/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		37: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "static/js/" + ({"0":"@atlaskit-internal_Card","1":"@atlaskit-internal_CardView","2":"@atlaskit-internal_emojiPickerComponent","3":"@atlaskit-internal_emojiTypeAheadComponent","4":"@atlaskit-internal_resourcedEmojiComponent","5":"@atlaskit-internal_editor-core_picker-facade","6":"@atlaskit-internal-renderer-node_Media","7":"@atlaskit-internal-renderer-node_MediaGroup","8":"@atlaskit-internal-editor-core-floating-toolbar","9":"@atlaskit-internal-smartcard-urlcardcontent","10":"@atlaskit-internal-smartcard-datacardcontent","11":"@atlaskit-internal-editor-datepicker","13":"@atlaskit-internal-editor-core-helpdialog","17":"@atlaskit-internal-renderer-node_Status","18":"@atlaskit-internal-renderer-node_Mention","19":"@atlaskit-internal-renderer-node_InlineCard","20":"@atlaskit-internal-renderer-node_Emoji","21":"@atlaskit-internal-renderer-node_DecisionItem","22":"@atlaskit-internal-renderer-node_Date","23":"@atlaskit-internal-renderer-node_BlockCard","29":"@atlaskit-internal_media-editor-view"}[chunkId]||chunkId) + "." + {"0":"adaa4353","1":"bb88daa2","2":"f03aefe2","3":"e7ae65e3","4":"daa545bd","5":"b5b98605","6":"0190136a","7":"1c81a84a","8":"a6cf5864","9":"301fadd7","10":"98ac8798","11":"2d2c7073","12":"057c3178","13":"6349253e","14":"0e2cd96c","15":"92ef973a","16":"34bb064f","17":"f0567497","18":"b73f1a66","19":"84331934","20":"33e855ab","21":"197ba147","22":"a20e3423","23":"a1dd3244","24":"3e6e0f33","25":"6d927baa","26":"6435ac43","27":"44b8f0d8","28":"2ff7318d","29":"fa00d1fe","30":"224a295e","31":"63dd743a","32":"9f9d2209","33":"daec7f20","34":"b89a442c","35":"432b8bfe","36":"51f8bac9"}[chunkId] + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1409);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1415);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process, module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectGlobal", function() { return injectGlobal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isStyledComponent", function() { return isStyledComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "consolidateStreamedStyles", function() { return consolidateStreamedStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeProvider", function() { return ThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withTheme", function() { return withTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServerStyleSheet", function() { return ServerStyleSheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StyleSheetManager", function() { return StyleSheetManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS", function() { return __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__ = __webpack_require__(1710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis__ = __webpack_require__(1712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__ = __webpack_require__(1713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_is__);








var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n* Are you trying to reuse it across renders?\n* Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n* Does this error occur on the client and is your target falsy?\n* Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n* Are you running in a client-like environment on the server?\n* Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n* Are you using a custom target that isn't mounted?\n* Does your document not have a valid head element?\n* Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  "11": "A plain React class (%s) has been interpolated into styles, probably as a component selector (https://www.styled-components.com/docs/advanced#referring-to-other-components). Only styled-component classes can be targeted in this fashion."
} : {};

/**
 * super basic version of sprintf
 */
function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c = void 0;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      interpolations[_key2 - 1] = arguments[_key2];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations))));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 

var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
    return __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default()(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
      return ruleSet;
    }

    /* Flatten ruleSet */
    if (Array.isArray(chunk)) {
      ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
      return ruleSet;
    }

    /* Handle other components */
    if (chunk.hasOwnProperty('styledComponentId')) {
      // $FlowFixMe not sure how to make this pass
      ruleSet.push('.' + chunk.styledComponentId);
      return ruleSet;
    }

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      if (executionContext) {
        var nextChunk = chunk(executionContext);
        /* Throw if a React Element was given styles */
        if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(nextChunk)) {
          var elementName = chunk.displayName || chunk.name;
          throw new StyledComponentsError(11, elementName);
        }
        ruleSet.push.apply(ruleSet, flatten([nextChunk], executionContext));
      } else ruleSet.push(chunk);

      return ruleSet;
    }

    /* Handle objects */
    ruleSet.push(
    // $FlowFixMe have to add %checks somehow to isPlainObject
    isPlainObject(chunk) ? objToCss(chunk) : chunk.toString());

    return ruleSet;
  }, []);
};

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];
// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

stylis.use([parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

// 

function isStyledComponent(target) /* : %checks */{
  return (
    // $FlowFixMe TODO: flow for styledComponentId
    typeof target === 'function' && typeof target.styledComponentId === 'string'
  );
}

// 

/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */
function consolidateStreamedStyles() {
  if (false) {
    // eslint-disable-next-line no-console
    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
  }
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
};

// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 

var css = (function (styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (typeof styles === 'function' || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
});

// 


var SC_ATTR = typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":""}).SC_ATTR || 'data-styled-components';
var SC_STREAM_ATTR = 'data-styled-streamed';
var CONTEXT_KEY = '__styled-components-stylesheet__';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = "production" !== 'production';

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker);
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(id) {
  return document.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }
    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTagInternal(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeServerTag = function makeServerTag() {
  return makeServerTagInternal();
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

/* wraps a given tag so that rehydration is performed once when necessary */
var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
  /* rehydration function that adds all rules to the new tag */
  var rehydrate = once(function () {
    /* add all extracted components to the new tag */
    for (var i = 0, len = extracted.length; i < len; i += 1) {
      var _extracted$i = extracted[i],
          componentId = _extracted$i.componentId,
          cssFromDOM = _extracted$i.cssFromDOM;

      var cssRules = splitByRules(cssFromDOM);
      tag.insertRules(componentId, cssRules);
    }

    /* remove old HTMLStyleElements, since they have been rehydrated */
    for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
      var el = els[_i];
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  });

  if (immediateRehydration) rehydrate();

  return _extends({}, tag, {
    /* add rehydration hook to insertion methods */
    insertMarker: function insertMarker(id) {
      rehydrate();
      return tag.insertMarker(id);
    },
    insertRules: function insertRules(id, cssRules, name) {
      rehydrate();
      return tag.insertRules(id, cssRules, name);
    }
  });
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {
  /* a map from ids to tags */
  /* deferred rules for a given id */
  /* this is used for not reinjecting rules via hasNameForId() */
  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
  /* a list of tags belonging to this StyleSheet */
  /* a tag for import rules */
  /* current capacity until a new tag must be created */
  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate() {
    if (!IS_BROWSER || this.forceServer) {
      return this;
    }

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (nodesSize === 0) {
      return this;
    }

    for (var i = 0; i < nodesSize; i += 1) {
      // $FlowFixMe: We can trust that all elements in this query are style elements
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0; j < elNamesSize; j += 1) {
        var name = elNames[j];
        /* add rehydrated name to sheet to avoid readding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (extractedSize === 0) {
      return this;
    }

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);
    var rehydrationTag = makeRehydrationTag(tag, els, extracted, isStreamed);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(rehydrationTag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = rehydrationTag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for injectGlobal to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);
    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;
    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
  };

  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
    if (this.props.sheet) {
      this.sheetInstance = this.props.sheet;
    } else if (this.props.target) {
      this.sheetInstance = new StyleSheet(this.props.target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.closed = false;
  }

  ServerStyleSheet.prototype.complete = function complete() {
    if (!this.closed) {
      /* Remove closed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.closed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.complete();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.complete();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        /* prepend style html to chunk */
        this.push(html + chunk);
        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.complete();
    });
    readableStream.on('error', function (err) {
      _this.complete();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

// 

function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

// 

function generateDisplayName(target) {
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

// 
/* eslint-disable max-len */
/**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */
/*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
*/
/* eslint-enable max-len */

var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var validAttr = (function (name) {
  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
});

// 

function hasInInheritanceChain(child, parent) {
  var target = child;

  while (target) {
    target = Object.getPrototypeOf(target);

    if (target && target === parent) {
      return true;
    }
  }

  return false;
}

// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

var _contextShape, _ThemeProvider$contex;

// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var contextShape = (_contextShape = {}, _contextShape[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _contextShape[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _contextShape);

var warnChannelDeprecated = void 0;
if (false) {
  warnChannelDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
  });
}

var isFunction = function isFunction(test) {
  return typeof test === 'function';
};

/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;

        if (_this2.broadcast !== undefined) {
          _this2.publish(_this2.props.theme);
        }
      });
    }

    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      if (false) {
        warnChannelDeprecated();
      }

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) {
      this.publish(nextProps.theme);
    }
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;

    if (isFunction(theme)) {
      var mergedTheme = theme(this.outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.publish = function publish(theme) {
    this.broadcast.publish(this.getTheme(theme));
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ThemeProvider.childContextTypes = contextShape;
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

var _babelHelpers$extends;

// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var STATIC_EXECUTION_CONTEXT = {};

var modifiedContextShape = _extends({}, contextShape, (_babelHelpers$extends = {}, _babelHelpers$extends[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]), _babelHelpers$extends));

var identifiers = {};

/* We depend on components having unique IDs */
var generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);

  return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
};

var warnExtendDeprecated = function warnExtendDeprecated() {};
if (false) {
  warnExtendDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: The "extend" API will be removed in the upcoming v4.0 release. Use styled(StyledComponent) instead. You can find more information here: https://github.com/styled-components/styled-components/issues/1546');
  });
}

// $FlowFixMe

var BaseStyledComponent = function (_Component) {
  inherits(BaseStyledComponent, _Component);

  function BaseStyledComponent() {
    var _temp, _this, _ret;

    classCallCheck(this, BaseStyledComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
      theme: null,
      generatedClassName: ''
    }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
  }

  BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
    if (this.unsubscribeId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
    }
  };

  BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
    var attrs = this.constructor.attrs;

    var context = _extends({}, props, { theme: theme });
    if (attrs === undefined) {
      return context;
    }

    this.attrs = Object.keys(attrs).reduce(function (acc, key) {
      var attr = attrs[key];

      // eslint-disable-next-line no-param-reassign
      acc[key] = typeof attr === 'function' && !hasInInheritanceChain(attr, __WEBPACK_IMPORTED_MODULE_1_react__["Component"]) ? attr(context) : attr;
      return acc;
    }, {});

    return _extends({}, context, this.attrs);
  };

  BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _constructor = this.constructor,
        attrs = _constructor.attrs,
        componentStyle = _constructor.componentStyle,
        warnTooManyClasses = _constructor.warnTooManyClasses;

    var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names
    if (componentStyle.isStatic && attrs === undefined) {
      return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
    } else {
      var executionContext = this.buildExecutionContext(theme, props);
      var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

      if (false) {
        warnTooManyClasses(className);
      }

      return className;
    }
  };

  BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var componentStyle = this.constructor.componentStyle;

    var styledContext = this.context[CHANNEL_NEXT];

    // If this is a statically-styled component, we don't need to the theme
    // to generate or build styles.
    if (componentStyle.isStatic) {
      var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
      this.setState({ generatedClassName: generatedClassName });
      // If there is a theme in the context, subscribe to the event emitter. This
      // is necessary due to pure components blocking context updates, this circumvents
      // that by updating when an event is emitted
    } else if (styledContext !== undefined) {
      var subscribe = styledContext.subscribe;

      this.unsubscribeId = subscribe(function (nextTheme) {
        // This will be called once immediately
        var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);

        var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);

        _this2.setState({ theme: theme, generatedClassName: generatedClassName });
      });
    } else {
      // eslint-disable-next-line react/prop-types
      var theme = this.props.theme || EMPTY_OBJECT;
      var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
      this.setState({ theme: theme, generatedClassName: _generatedClassName });
    }
  };

  BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    // If this is a statically-styled component, we don't need to listen to
    // props changes to update styles
    var componentStyle = this.constructor.componentStyle;

    if (componentStyle.isStatic) {
      return;
    }

    this.setState(function (prevState) {
      var theme = determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
      var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

      return { theme: theme, generatedClassName: generatedClassName };
    });
  };

  BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unsubscribeFromContext();
  };

  BaseStyledComponent.prototype.render = function render() {
    // eslint-disable-next-line react/prop-types
    var innerRef = this.props.innerRef;
    var generatedClassName = this.state.generatedClassName;
    var _constructor2 = this.constructor,
        styledComponentId = _constructor2.styledComponentId,
        target = _constructor2.target;


    var isTargetTag = isTag(target);

    var className = [
    // eslint-disable-next-line react/prop-types
    this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

    var baseProps = _extends({}, this.attrs, {
      className: className
    });

    if (isStyledComponent(target)) {
      baseProps.innerRef = innerRef;
    } else {
      baseProps.ref = innerRef;
    }

    var propsForElement = baseProps;
    var key = void 0;

    for (key in this.props) {
      // Don't pass through non HTML tags through to HTML elements
      // always omit innerRef
      if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || validAttr(key))) {
        propsForElement[key] = key === 'style' && key in this.attrs ? _extends({}, this.attrs[key], this.props[key]) : this.props[key];
      }
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(target, propsForElement);
  };

  return BaseStyledComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _options$isClass = options.isClass,
        isClass = _options$isClass === undefined ? !isTag(target) : _options$isClass,
        _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          warnExtendDeprecated();

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.contextTypes = modifiedContextShape;
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.target = target;


    if (false) {
      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    if (isClass) {
      __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(StyledComponent, target, {
        // all SC-specific things should not be hoisted
        attrs: true,
        componentStyle: true,
        displayName: true,
        extend: true,
        styledComponentId: true,
        target: true,
        warnTooManyClasses: true,
        withComponent: true
      });
    }

    return StyledComponent;
  };

  return createStyledComponent;
});

// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(str) {
  var l = str.length | 0,
      h = l | 0,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;

    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);

    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;

    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;

  return h >>> 0;
}

// 

var areStylesCacheable = IS_BROWSER;

var isStaticRules = function isStaticRules(rules, attrs) {
  for (var i = 0, len = rules.length; i < len; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      if (typeof attrs[key] === 'function') {
        return false;
      }
    }
  }

  return true;
};

var isHMREnabled = typeof module !== 'undefined' && module.hot && "production" !== 'production';

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  /* combines hashStr (murmurhash) and nameGenerator for convenience */
  var generateRuleHash = function generateRuleHash(str) {
    return nameGenerator(murmurhash(str));
  };

  var ComponentStyle = function () {
    function ComponentStyle(rules, attrs, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
      this.componentId = componentId;

      if (!StyleSheet.master.hasId(componentId)) {
        var placeholder =  false ? ['.' + componentId + ' {}'] : [];

        StyleSheet.master.deferredInject(componentId, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var isStatic = this.isStatic,
          componentId = this.componentId,
          lastClassName = this.lastClassName;

      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
        return lastClassName;
      }

      var flatCSS = flatten(this.rules, executionContext);
      var name = generateRuleHash(this.componentId + flatCSS.join(''));

      if (!styleSheet.hasNameForId(componentId, name)) {
        styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
      }

      this.lastClassName = name;
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return generateRuleHash(str);
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function () {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
    var id = 'sc-keyframes-' + name;

    if (!styleSheet.hasNameForId(id, name)) {
      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
    }

    return name;
  };
});

// 

var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal() {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var hash = murmurhash(JSON.stringify(rules));
    var id = 'sc-global-' + hash;

    if (!styleSheet.hasId(id)) {
      styleSheet.inject(id, stringifyRules(rules));
    }
  };

  return injectGlobal;
});

// 

var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

    if (!Object(__WEBPACK_IMPORTED_MODULE_6_react_is__["isValidElementType"])(tag)) {
      throw new StyledComponentsError(1, String(tag));
    }

    /* This is callable directly as a template function */
    // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
      return componentConstructor(tag, options, css.apply(undefined, arguments));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || EMPTY_OBJECT, attrs)
      }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

// 

var withTheme = (function (Component$$1) {
  var isStatelessFunctionalComponent = typeof Component$$1 === 'function' &&
  // $FlowFixMe TODO: flow for prototype
  !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);

  // NOTE: We can't pass a ref to a stateless functional component
  var shouldSetInnerRef = isStyledComponent(Component$$1) || isStatelessFunctionalComponent;

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var defaultProps = this.constructor.defaultProps;

      var styledContext = this.context[CHANNEL_NEXT];
      var themeProp = determineTheme(this.props, undefined, defaultProps);
      if (styledContext === undefined && themeProp === undefined && "production" !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
      } else if (styledContext === undefined && themeProp !== undefined) {
        this.setState({ theme: themeProp });
      } else {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
          _this2.setState({ theme: theme });
        });
      }
    };

    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var defaultProps = this.constructor.defaultProps;

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, defaultProps);

        return { theme: theme };
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      var props = _extends({
        theme: this.state.theme
      }, this.props);

      if (!shouldSetInnerRef) {
        props.ref = props.innerRef;
        delete props.innerRef;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component$$1, props);
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

  WithTheme.contextTypes = contextShape;
  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';
  WithTheme.styledComponentId = 'withTheme';


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component$$1);
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);

/* harmony default export */ __webpack_exports__["default"] = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(122), __webpack_require__(149)(module)))

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AtlasKitThemeProvider", function() { return AtlasKitThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderRadius", function() { return borderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridSize", function() { return gridSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fontSize", function() { return fontSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fontSizeSmall", function() { return fontSizeSmall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fontFamily", function() { return fontFamily; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "codeFontFamily", function() { return codeFontFamily; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "layers", function() { return layers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assistive", function() { return assistive; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colors__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elevation__ = __webpack_require__(1717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typography__ = __webpack_require__(1718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_math__ = __webpack_require__(1719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_getTheme__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_themed__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AtlaskitThemeProvider__ = __webpack_require__(1720);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "colors", function() { return __WEBPACK_IMPORTED_MODULE_1__colors__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "elevation", function() { return __WEBPACK_IMPORTED_MODULE_2__elevation__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "typography", function() { return __WEBPACK_IMPORTED_MODULE_3__typography__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "math", function() { return __WEBPACK_IMPORTED_MODULE_4__utils_math__; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getTheme", function() { return __WEBPACK_IMPORTED_MODULE_5__utils_getTheme__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "themed", function() { return __WEBPACK_IMPORTED_MODULE_6__utils_themed__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AtlaskitThemeProvider", function() { return __WEBPACK_IMPORTED_MODULE_7__components_AtlaskitThemeProvider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Appearance__ = __webpack_require__(1723);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Appearance", function() { return __WEBPACK_IMPORTED_MODULE_8__components_Appearance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Reset__ = __webpack_require__(1724);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ResetTheme", function() { return __WEBPACK_IMPORTED_MODULE_9__components_Reset__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Reset", function() { return __WEBPACK_IMPORTED_MODULE_9__components_Reset__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Theme__ = __webpack_require__(378);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_10__components_Theme__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hoc__ = __webpack_require__(1725);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "withTheme", function() { return __WEBPACK_IMPORTED_MODULE_11__hoc__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_createTheme__ = __webpack_require__(379);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "createTheme", function() { return __WEBPACK_IMPORTED_MODULE_12__utils_createTheme__["a"]; });









 // backwards-compatible export with old Atlaskit case

var AtlasKitThemeProvider = __WEBPACK_IMPORTED_MODULE_7__components_AtlaskitThemeProvider__["a" /* default */];
/*
  These theme values are expressed as functions so that if we decide to make
  them dependent on props in the future, it wouldn't require a significant
  refactor everywhere they are being used.
*/

var borderRadius = function borderRadius() {
  return 3;
};
var gridSize = function gridSize() {
  return 8;
};
var fontSize = function fontSize() {
  return 14;
};
var fontSizeSmall = function fontSizeSmall() {
  return 11;
};
var fontFamily = function fontFamily() {
  return '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';
};
var codeFontFamily = function codeFontFamily() {
  return '"SFMono-Medium", "SF Mono", "Segoe UI Mono", "Roboto Mono", "Ubuntu Mono", Menlo, Consolas, Courier, monospace';
};
var layers = {
  card: function card() {
    return 100;
  },
  dialog: function dialog() {
    return 200;
  },
  navigation: function navigation() {
    return 300;
  },
  layer: function layer() {
    return 400;
  },
  blanket: function blanket() {
    return 500;
  },
  modal: function modal() {
    return 510;
  },
  flag: function flag() {
    return 600;
  },
  spotlight: function spotlight() {
    return 700;
  },
  tooltip: function tooltip() {
    return 800;
  }
};
var assistive = function assistive() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  border: 0 !important;\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  height: 1px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  width: 1px !important;\n  white-space: nowrap !important;\n"]);
}; // New API






/***/ }),
/* 4 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(79);

var assertThisInitialized = __webpack_require__(16);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(1721);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1421)();
}


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorModel = __webpack_require__(23);
var prosemirrorTransform = __webpack_require__(46);

var classesById = Object.create(null);

// ::- Superclass for editor selections. Every selection type should
// extend this. Should not be instantiated directly.
var Selection = function Selection($anchor, $head, ranges) {
  // :: [SelectionRange]
  // The ranges covered by the selection.
  this.ranges = ranges || [new SelectionRange($anchor.min($head), $anchor.max($head))];
  // :: ResolvedPos
  // The resolved anchor of the selection (the side that stays in
  // place when the selection is modified).
  this.$anchor = $anchor;
  // :: ResolvedPos
  // The resolved head of the selection (the side that moves when
  // the selection is modified).
  this.$head = $head;
};

var prototypeAccessors = { anchor: {},head: {},from: {},to: {},$from: {},$to: {},empty: {} };

// :: number
// The selection's anchor, as an unresolved position.
prototypeAccessors.anchor.get = function () { return this.$anchor.pos };

// :: number
// The selection's head.
prototypeAccessors.head.get = function () { return this.$head.pos };

// :: number
// The lower bound of the selection's main range.
prototypeAccessors.from.get = function () { return this.$from.pos };

// :: number
// The upper bound of the selection's main range.
prototypeAccessors.to.get = function () { return this.$to.pos };

// :: ResolvedPos
// The resolved lowerbound of the selection's main range.
prototypeAccessors.$from.get = function () {
  return this.ranges[0].$from
};

// :: ResolvedPos
// The resolved upper bound of the selection's main range.
prototypeAccessors.$to.get = function () {
  return this.ranges[0].$to
};

// :: bool
// Indicates whether the selection contains any content.
prototypeAccessors.empty.get = function () {
  var ranges = this.ranges;
  for (var i = 0; i < ranges.length; i++)
    { if (ranges[i].$from.pos != ranges[i].$to.pos) { return false } }
  return true
};

// eq:: (Selection) → bool
// Test whether the selection is the same as another selection.

// map:: (doc: Node, mapping: Mappable) → Selection
// Map this selection through a [mappable](#transform.Mappable) thing. `doc`
// should be the new document to which we are mapping.

// :: () → Slice
// Get the content of this selection as a slice.
Selection.prototype.content = function content () {
  return this.$from.node(0).slice(this.from, this.to, true)
};

// :: (Transaction, ?Slice)
// Replace the selection with a slice or, if no slice is given,
// delete the selection. Will append to the given transaction.
Selection.prototype.replace = function replace (tr, content) {
    if ( content === void 0 ) content = prosemirrorModel.Slice.empty;

  // Put the new selection at the position after the inserted
  // content. When that ended in an inline node, search backwards,
  // to get the position after that node. If not, search forward.
  var lastNode = content.content.lastChild, lastParent = null;
  for (var i = 0; i < content.openEnd; i++) {
    lastParent = lastNode;
    lastNode = lastNode.lastChild;
  }

  var mapFrom = tr.steps.length, ranges = this.ranges;
  for (var i$1 = 0; i$1 < ranges.length; i$1++) {
    var ref = ranges[i$1];
      var $from = ref.$from;
      var $to = ref.$to;
      var mapping = tr.mapping.slice(mapFrom);
    tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i$1 ? prosemirrorModel.Slice.empty : content);
    if (i$1 == 0)
      { selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1); }
  }
};

// :: (Transaction, Node)
// Replace the selection with the given node, appending the changes
// to the given transaction.
Selection.prototype.replaceWith = function replaceWith (tr, node) {
  var mapFrom = tr.steps.length, ranges = this.ranges;
  for (var i = 0; i < ranges.length; i++) {
    var ref = ranges[i];
      var $from = ref.$from;
      var $to = ref.$to;
      var mapping = tr.mapping.slice(mapFrom);
    var from = mapping.map($from.pos), to = mapping.map($to.pos);
    if (i) {
      tr.deleteRange(from, to);
    } else {
      tr.replaceRangeWith(from, to, node);
      selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
    }
  }
};

// toJSON:: () → Object
// Convert the selection to a JSON representation. When implementing
// this for a custom selection class, make sure to give the object a
// `type` property whose value matches the ID under which you
// [registered](#state.Selection^jsonID) your class.

// :: (ResolvedPos, number, ?bool) → ?Selection
// Find a valid cursor or leaf node selection starting at the given
// position and searching back if `dir` is negative, and forward if
// positive. When `textOnly` is true, only consider cursor
// selections. Will return null when no valid selection position is
// found.
Selection.findFrom = function findFrom ($pos, dir, textOnly) {
  var inner = $pos.parent.inlineContent ? new TextSelection($pos)
      : findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
  if (inner) { return inner }

  for (var depth = $pos.depth - 1; depth >= 0; depth--) {
    var found = dir < 0
        ? findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly)
        : findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
    if (found) { return found }
  }
};

// :: (ResolvedPos, ?number) → Selection
// Find a valid cursor or leaf node selection near the given
// position. Searches forward first by default, but if `bias` is
// negative, it will search backwards first.
Selection.near = function near ($pos, bias) {
    if ( bias === void 0 ) bias = 1;

  return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new AllSelection($pos.node(0))
};

// :: (Node) → Selection
// Find the cursor or leaf node selection closest to the start of
// the given document. Will return an
// [`AllSelection`](#state.AllSelection) if no valid position
// exists.
Selection.atStart = function atStart (doc) {
  return findSelectionIn(doc, doc, 0, 0, 1) || new AllSelection(doc)
};

// :: (Node) → Selection
// Find the cursor or leaf node selection closest to the end of the
// given document.
Selection.atEnd = function atEnd (doc) {
  return findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new AllSelection(doc)
};

// :: (Node, Object) → Selection
// Deserialize the JSON representation of a selection. Must be
// implemented for custom classes (as a static class method).
Selection.fromJSON = function fromJSON (doc, json) {
  if (!json || !json.type) { throw new RangeError("Invalid input for Selection.fromJSON") }
  var cls = classesById[json.type];
  if (!cls) { throw new RangeError(("No selection type " + (json.type) + " defined")) }
  return cls.fromJSON(doc, json)
};

// :: (string, constructor<Selection>)
// To be able to deserialize selections from JSON, custom selection
// classes must register themselves with an ID string, so that they
// can be disambiguated. Try to pick something that's unlikely to
// clash with classes from other modules.
Selection.jsonID = function jsonID (id, selectionClass) {
  if (id in classesById) { throw new RangeError("Duplicate use of selection JSON ID " + id) }
  classesById[id] = selectionClass;
  selectionClass.prototype.jsonID = id;
  return selectionClass
};

// :: () → SelectionBookmark
// Get a [bookmark](#state.SelectionBookmark) for this selection,
// which is a value that can be mapped without having access to a
// current document, and later resolved to a real selection for a
// given document again. (This is used mostly by the history to
// track and restore old selections.) The default implementation of
// this method just converts the selection to a text selection and
// returns the bookmark for that.
Selection.prototype.getBookmark = function getBookmark () {
  return TextSelection.between(this.$anchor, this.$head).getBookmark()
};

Object.defineProperties( Selection.prototype, prototypeAccessors );

// :: bool
// Controls whether, when a selection of this type is active in the
// browser, the selected range should be visible to the user. Defaults
// to `true`.
Selection.prototype.visible = true;

// SelectionBookmark:: interface
// A lightweight, document-independent representation of a selection.
// You can define a custom bookmark type for a custom selection class
// to make the history handle it well.
//
//   map:: (mapping: Mapping) → SelectionBookmark
//   Map the bookmark through a set of changes.
//
//   resolve:: (doc: Node) → Selection
//   Resolve the bookmark to a real selection again. This may need to
//   do some error checking and may fall back to a default (usually
//   [`TextSelection.between`](#state.TextSelection^between)) if
//   mapping made the bookmark invalid.

// ::- Represents a selected range in a document.
var SelectionRange = function SelectionRange($from, $to) {
  // :: ResolvedPos
  // The lower bound of the range.
  this.$from = $from;
  // :: ResolvedPos
  // The upper bound of the range.
  this.$to = $to;
};

// ::- A text selection represents a classical editor selection, with
// a head (the moving side) and anchor (immobile side), both of which
// point into textblock nodes. It can be empty (a regular cursor
// position).
var TextSelection = (function (Selection) {
  function TextSelection($anchor, $head) {
    if ( $head === void 0 ) $head = $anchor;

    Selection.call(this, $anchor, $head);
  }

  if ( Selection ) TextSelection.__proto__ = Selection;
  TextSelection.prototype = Object.create( Selection && Selection.prototype );
  TextSelection.prototype.constructor = TextSelection;

  var prototypeAccessors$1 = { $cursor: {} };

  // :: ?ResolvedPos
  // Returns a resolved position if this is a cursor selection (an
  // empty text selection), and null otherwise.
  prototypeAccessors$1.$cursor.get = function () { return this.$anchor.pos == this.$head.pos ? this.$head : null };

  TextSelection.prototype.map = function map (doc, mapping) {
    var $head = doc.resolve(mapping.map(this.head));
    if (!$head.parent.inlineContent) { return Selection.near($head) }
    var $anchor = doc.resolve(mapping.map(this.anchor));
    return new TextSelection($anchor.parent.inlineContent ? $anchor : $head, $head)
  };

  TextSelection.prototype.replace = function replace (tr, content) {
    if ( content === void 0 ) content = prosemirrorModel.Slice.empty;

    Selection.prototype.replace.call(this, tr, content);
    if (content == prosemirrorModel.Slice.empty) {
      var marks = this.$from.marksAcross(this.$to);
      if (marks) { tr.ensureMarks(marks); }
    }
  };

  TextSelection.prototype.eq = function eq (other) {
    return other instanceof TextSelection && other.anchor == this.anchor && other.head == this.head
  };

  TextSelection.prototype.getBookmark = function getBookmark () {
    return new TextBookmark(this.anchor, this.head)
  };

  TextSelection.prototype.toJSON = function toJSON () {
    return {type: "text", anchor: this.anchor, head: this.head}
  };

  TextSelection.fromJSON = function fromJSON (doc, json) {
    if (typeof json.anchor != "number" || typeof json.head != "number")
      { throw new RangeError("Invalid input for TextSelection.fromJSON") }
    return new TextSelection(doc.resolve(json.anchor), doc.resolve(json.head))
  };

  // :: (Node, number, ?number) → TextSelection
  // Create a text selection from non-resolved positions.
  TextSelection.create = function create (doc, anchor, head) {
    if ( head === void 0 ) head = anchor;

    var $anchor = doc.resolve(anchor);
    return new this($anchor, head == anchor ? $anchor : doc.resolve(head))
  };

  // :: (ResolvedPos, ResolvedPos, ?number) → Selection
  // Return a text selection that spans the given positions or, if
  // they aren't text positions, find a text selection near them.
  // `bias` determines whether the method searches forward (default)
  // or backwards (negative number) first. Will fall back to calling
  // [`Selection.near`](#state.Selection^near) when the document
  // doesn't contain a valid text position.
  TextSelection.between = function between ($anchor, $head, bias) {
    var dPos = $anchor.pos - $head.pos;
    if (!bias || dPos) { bias = dPos >= 0 ? 1 : -1; }
    if (!$head.parent.inlineContent) {
      var found = Selection.findFrom($head, bias, true) || Selection.findFrom($head, -bias, true);
      if (found) { $head = found.$head; }
      else { return Selection.near($head, bias) }
    }
    if (!$anchor.parent.inlineContent) {
      if (dPos == 0) {
        $anchor = $head;
      } else {
        $anchor = (Selection.findFrom($anchor, -bias, true) || Selection.findFrom($anchor, bias, true)).$anchor;
        if (($anchor.pos < $head.pos) != (dPos < 0)) { $anchor = $head; }
      }
    }
    return new TextSelection($anchor, $head)
  };

  Object.defineProperties( TextSelection.prototype, prototypeAccessors$1 );

  return TextSelection;
}(Selection));

Selection.jsonID("text", TextSelection);

var TextBookmark = function TextBookmark(anchor, head) {
  this.anchor = anchor;
  this.head = head;
};
TextBookmark.prototype.map = function map (mapping) {
  return new TextBookmark(mapping.map(this.anchor), mapping.map(this.head))
};
TextBookmark.prototype.resolve = function resolve (doc) {
  return TextSelection.between(doc.resolve(this.anchor), doc.resolve(this.head))
};

// ::- A node selection is a selection that points at a single node.
// All nodes marked [selectable](#model.NodeSpec.selectable) can be
// the target of a node selection. In such a selection, `from` and
// `to` point directly before and after the selected node, `anchor`
// equals `from`, and `head` equals `to`..
var NodeSelection = (function (Selection) {
  function NodeSelection($pos) {
    var node = $pos.nodeAfter;
    var $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
    Selection.call(this, $pos, $end);
    // :: Node The selected node.
    this.node = node;
  }

  if ( Selection ) NodeSelection.__proto__ = Selection;
  NodeSelection.prototype = Object.create( Selection && Selection.prototype );
  NodeSelection.prototype.constructor = NodeSelection;

  NodeSelection.prototype.map = function map (doc, mapping) {
    var ref = mapping.mapResult(this.anchor);
    var deleted = ref.deleted;
    var pos = ref.pos;
    var $pos = doc.resolve(pos);
    if (deleted) { return Selection.near($pos) }
    return new NodeSelection($pos)
  };

  NodeSelection.prototype.content = function content () {
    return new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(this.node), 0, 0)
  };

  NodeSelection.prototype.eq = function eq (other) {
    return other instanceof NodeSelection && other.anchor == this.anchor
  };

  NodeSelection.prototype.toJSON = function toJSON () {
    return {type: "node", anchor: this.anchor}
  };

  NodeSelection.prototype.getBookmark = function getBookmark () { return new NodeBookmark(this.anchor) };

  NodeSelection.fromJSON = function fromJSON (doc, json) {
    if (typeof json.anchor != "number")
      { throw new RangeError("Invalid input for NodeSelection.fromJSON") }
    return new NodeSelection(doc.resolve(json.anchor))
  };

  // :: (Node, number) → NodeSelection
  // Create a node selection from non-resolved positions.
  NodeSelection.create = function create (doc, from) {
    return new this(doc.resolve(from))
  };

  // :: (Node) → bool
  // Determines whether the given node may be selected as a node
  // selection.
  NodeSelection.isSelectable = function isSelectable (node) {
    return !node.isText && node.type.spec.selectable !== false
  };

  return NodeSelection;
}(Selection));

NodeSelection.prototype.visible = false;

Selection.jsonID("node", NodeSelection);

var NodeBookmark = function NodeBookmark(anchor) {
  this.anchor = anchor;
};
NodeBookmark.prototype.map = function map (mapping) {
  var ref = mapping.mapResult(this.anchor);
    var deleted = ref.deleted;
    var pos = ref.pos;
  return deleted ? new TextBookmark(pos, pos) : new NodeBookmark(pos)
};
NodeBookmark.prototype.resolve = function resolve (doc) {
  var $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
  if (node && NodeSelection.isSelectable(node)) { return new NodeSelection($pos) }
  return Selection.near($pos)
};

// ::- A selection type that represents selecting the whole document
// (which can not necessarily be expressed with a text selection, when
// there are for example leaf block nodes at the start or end of the
// document).
var AllSelection = (function (Selection) {
  function AllSelection(doc) {
    Selection.call(this, doc.resolve(0), doc.resolve(doc.content.size));
  }

  if ( Selection ) AllSelection.__proto__ = Selection;
  AllSelection.prototype = Object.create( Selection && Selection.prototype );
  AllSelection.prototype.constructor = AllSelection;

  AllSelection.prototype.toJSON = function toJSON () { return {type: "all"} };

  AllSelection.fromJSON = function fromJSON (doc) { return new AllSelection(doc) };

  AllSelection.prototype.map = function map (doc) { return new AllSelection(doc) };

  AllSelection.prototype.eq = function eq (other) { return other instanceof AllSelection };

  AllSelection.prototype.getBookmark = function getBookmark () { return AllBookmark };

  return AllSelection;
}(Selection));

Selection.jsonID("all", AllSelection);

var AllBookmark = {
  map: function map() { return this },
  resolve: function resolve(doc) { return new AllSelection(doc) }
};

// FIXME we'll need some awareness of text direction when scanning for selections

// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function findSelectionIn(doc, node, pos, index, dir, text) {
  if (node.inlineContent) { return TextSelection.create(doc, pos) }
  for (var i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir) {
    var child = node.child(i);
    if (!child.isAtom) {
      var inner = findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
      if (inner) { return inner }
    } else if (!text && NodeSelection.isSelectable(child)) {
      return NodeSelection.create(doc, pos - (dir < 0 ? child.nodeSize : 0))
    }
    pos += child.nodeSize * dir;
  }
}

function selectionToInsertionEnd(tr, startLen, bias) {
  var last = tr.steps.length - 1;
  if (last < startLen) { return }
  var step = tr.steps[last];
  if (!(step instanceof prosemirrorTransform.ReplaceStep || step instanceof prosemirrorTransform.ReplaceAroundStep)) { return }
  var map = tr.mapping.maps[last], end;
  map.forEach(function (_from, _to, _newFrom, newTo) { if (end == null) { end = newTo; } });
  tr.setSelection(Selection.near(tr.doc.resolve(end), bias));
}

var UPDATED_SEL = 1;
var UPDATED_MARKS = 2;
var UPDATED_SCROLL = 4;

// ::- An editor state transaction, which can be applied to a state to
// create an updated state. Use
// [`EditorState.tr`](#state.EditorState.tr) to create an instance.
//
// Transactions track changes to the document (they are a subclass of
// [`Transform`](#transform.Transform)), but also other state changes,
// like selection updates and adjustments of the set of [stored
// marks](#state.EditorState.storedMarks). In addition, you can store
// metadata properties in a transaction, which are extra pieces of
// information that client code or plugins can use to describe what a
// transacion represents, so that they can update their [own
// state](#state.StateField) accordingly.
//
// The [editor view](#view.EditorView) uses a few metadata properties:
// it will attach a property `"pointer"` with the value `true` to
// selection transactions directly caused by mouse or touch input, and
// a `"uiEvent"` property of that may be `"paste"`, `"cut"`, or `"drop"`.
var Transaction = (function (Transform$$1) {
  function Transaction(state) {
    Transform$$1.call(this, state.doc);
    // :: number
    // The timestamp associated with this transaction, in the same
    // format as `Date.now()`.
    this.time = Date.now();
    this.curSelection = state.selection;
    // The step count for which the current selection is valid.
    this.curSelectionFor = 0;
    // :: ?[Mark]
    // The stored marks set by this transaction, if any.
    this.storedMarks = state.storedMarks;
    // Bitfield to track which aspects of the state were updated by
    // this transaction.
    this.updated = 0;
    // Object used to store metadata properties for the transaction.
    this.meta = Object.create(null);
  }

  if ( Transform$$1 ) Transaction.__proto__ = Transform$$1;
  Transaction.prototype = Object.create( Transform$$1 && Transform$$1.prototype );
  Transaction.prototype.constructor = Transaction;

  var prototypeAccessors = { selection: {},selectionSet: {},storedMarksSet: {},isGeneric: {},scrolledIntoView: {} };

  // :: Selection
  // The transaction's current selection. This defaults to the editor
  // selection [mapped](#state.Selection.map) through the steps in the
  // transaction, but can be overwritten with
  // [`setSelection`](#state.Transaction.setSelection).
  prototypeAccessors.selection.get = function () {
    if (this.curSelectionFor < this.steps.length) {
      this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
      this.curSelectionFor = this.steps.length;
    }
    return this.curSelection
  };

  // :: (Selection) → Transaction
  // Update the transaction's current selection. Will determine the
  // selection that the editor gets when the transaction is applied.
  Transaction.prototype.setSelection = function setSelection (selection) {
    this.curSelection = selection;
    this.curSelectionFor = this.steps.length;
    this.updated = (this.updated | UPDATED_SEL) & ~UPDATED_MARKS;
    this.storedMarks = null;
    return this
  };

  // :: bool
  // Whether the selection was explicitly updated by this transaction.
  prototypeAccessors.selectionSet.get = function () {
    return (this.updated & UPDATED_SEL) > 0
  };

  // :: (?[Mark]) → Transaction
  // Set the current stored marks.
  Transaction.prototype.setStoredMarks = function setStoredMarks (marks) {
    this.storedMarks = marks;
    this.updated |= UPDATED_MARKS;
    return this
  };

  // :: ([Mark]) → Transaction
  // Make sure the current stored marks or, if that is null, the marks
  // at the selection, match the given set of marks. Does nothing if
  // this is already the case.
  Transaction.prototype.ensureMarks = function ensureMarks (marks) {
    if (!prosemirrorModel.Mark.sameSet(this.storedMarks || this.selection.$from.marks(), marks))
      { this.setStoredMarks(marks); }
    return this
  };

  // :: (Mark) → Transaction
  // Add a mark to the set of stored marks.
  Transaction.prototype.addStoredMark = function addStoredMark (mark) {
    return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()))
  };

  // :: (union<Mark, MarkType>) → Transaction
  // Remove a mark or mark type from the set of stored marks.
  Transaction.prototype.removeStoredMark = function removeStoredMark (mark) {
    return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()))
  };

  // :: bool
  // Whether the stored marks were explicitly set for this transaction.
  prototypeAccessors.storedMarksSet.get = function () {
    return (this.updated & UPDATED_MARKS) > 0
  };

  Transaction.prototype.addStep = function addStep (step, doc) {
    Transform$$1.prototype.addStep.call(this, step, doc);
    this.updated = this.updated & ~UPDATED_MARKS;
    this.storedMarks = null;
  };

  // :: (number) → Transaction
  // Update the timestamp for the transaction.
  Transaction.prototype.setTime = function setTime (time) {
    this.time = time;
    return this
  };

  // :: (Slice) → Transaction
  // Replace the current selection with the given slice.
  Transaction.prototype.replaceSelection = function replaceSelection (slice) {
    this.selection.replace(this, slice);
    return this
  };

  // :: (Node, ?bool) → Transaction
  // Replace the selection with the given node. When `inheritMarks` is
  // true and the content is inline, it inherits the marks from the
  // place where it is inserted.
  Transaction.prototype.replaceSelectionWith = function replaceSelectionWith (node, inheritMarks) {
    var selection = this.selection;
    if (inheritMarks !== false)
      { node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : (selection.$from.marksAcross(selection.$to) || prosemirrorModel.Mark.none))); }
    selection.replaceWith(this, node);
    return this
  };

  // :: () → Transaction
  // Delete the selection.
  Transaction.prototype.deleteSelection = function deleteSelection () {
    this.selection.replace(this);
    return this
  };

  // :: (string, from: ?number, to: ?number) → Transaction
  // Replace the given range, or the selection if no range is given,
  // with a text node containing the given string.
  Transaction.prototype.insertText = function insertText (text, from, to) {
    if ( to === void 0 ) to = from;

    var schema = this.doc.type.schema;
    if (from == null) {
      if (!text) { return this.deleteSelection() }
      return this.replaceSelectionWith(schema.text(text), true)
    } else {
      if (!text) { return this.deleteRange(from, to) }
      var marks = this.storedMarks;
      if (!marks) {
        var $from = this.doc.resolve(from);
        marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
      }
      return this.replaceRangeWith(from, to, schema.text(text, marks))
    }
  };

  // :: (union<string, Plugin, PluginKey>, any) → Transaction
  // Store a metadata property in this transaction, keyed either by
  // name or by plugin.
  Transaction.prototype.setMeta = function setMeta (key, value) {
    this.meta[typeof key == "string" ? key : key.key] = value;
    return this
  };

  // :: (union<string, Plugin, PluginKey>) → any
  // Retrieve a metadata property for a given name or plugin.
  Transaction.prototype.getMeta = function getMeta (key) {
    return this.meta[typeof key == "string" ? key : key.key]
  };

  // :: bool
  // Returns true if this transaction doesn't contain any metadata,
  // and can thus safely be extended.
  prototypeAccessors.isGeneric.get = function () {
    var this$1 = this;

    for (var _ in this$1.meta) { return false }
    return true
  };

  // :: () → Transaction
  // Indicate that the editor should scroll the selection into view
  // when updated to the state produced by this transaction.
  Transaction.prototype.scrollIntoView = function scrollIntoView () {
    this.updated |= UPDATED_SCROLL;
    return this
  };

  prototypeAccessors.scrolledIntoView.get = function () {
    return (this.updated & UPDATED_SCROLL) > 0
  };

  Object.defineProperties( Transaction.prototype, prototypeAccessors );

  return Transaction;
}(prosemirrorTransform.Transform));

function bind(f, self) {
  return !self || !f ? f : f.bind(self)
}

var FieldDesc = function FieldDesc(name, desc, self) {
  this.name = name;
  this.init = bind(desc.init, self);
  this.apply = bind(desc.apply, self);
};

var baseFields = [
  new FieldDesc("doc", {
    init: function init(config) { return config.doc || config.schema.topNodeType.createAndFill() },
    apply: function apply(tr) { return tr.doc }
  }),

  new FieldDesc("selection", {
    init: function init(config, instance) { return config.selection || Selection.atStart(instance.doc) },
    apply: function apply(tr) { return tr.selection }
  }),

  new FieldDesc("storedMarks", {
    init: function init(config) { return config.storedMarks || null },
    apply: function apply(tr, _marks, _old, state) { return state.selection.$cursor ? tr.storedMarks : null }
  }),

  new FieldDesc("scrollToSelection", {
    init: function init() { return 0 },
    apply: function apply(tr, prev) { return tr.scrolledIntoView ? prev + 1 : prev }
  })
];

// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
var Configuration = function Configuration(schema, plugins) {
  var this$1 = this;

  this.schema = schema;
  this.fields = baseFields.concat();
  this.plugins = [];
  this.pluginsByKey = Object.create(null);
  if (plugins) { plugins.forEach(function (plugin) {
    if (this$1.pluginsByKey[plugin.key])
      { throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")") }
    this$1.plugins.push(plugin);
    this$1.pluginsByKey[plugin.key] = plugin;
    if (plugin.spec.state)
      { this$1.fields.push(new FieldDesc(plugin.key, plugin.spec.state, plugin)); }
  }); }
};

// ::- The state of a ProseMirror editor is represented by an object
// of this type. A state is a persistent data structure—it isn't
// updated, but rather a new state value is computed from an old one
// using the [`apply`](#state.EditorState.apply) method.
//
// A state holds a number of built-in fields, and plugins can
// [define](#state.PluginSpec.state) additional fields.
var EditorState = function EditorState(config) {
  this.config = config;
};

var prototypeAccessors$1 = { schema: {},plugins: {},tr: {} };

// doc:: Node
// The current document.

// selection:: Selection
// The selection.

// storedMarks:: ?[Mark]
// A set of marks to apply to the next input. Will be null when
// no explicit marks have been set.

// :: Schema
// The schema of the state's document.
prototypeAccessors$1.schema.get = function () {
  return this.config.schema
};

// :: [Plugin]
// The plugins that are active in this state.
prototypeAccessors$1.plugins.get = function () {
  return this.config.plugins
};

// :: (Transaction) → EditorState
// Apply the given transaction to produce a new state.
EditorState.prototype.apply = function apply (tr) {
  return this.applyTransaction(tr).state
};

// : (Transaction) → ?Transaction
EditorState.prototype.filterTransaction = function filterTransaction (tr, ignore) {
    var this$1 = this;
    if ( ignore === void 0 ) ignore = -1;

  for (var i = 0; i < this.config.plugins.length; i++) { if (i != ignore) {
    var plugin = this$1.config.plugins[i];
    if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this$1))
      { return false }
  } }
  return true
};

// :: (Transaction) → {state: EditorState, transactions: [Transaction]}
// Verbose variant of [`apply`](#state.EditorState.apply) that
// returns the precise transactions that were applied (which might
// be influenced by the [transaction
// hooks](#state.PluginSpec.filterTransaction) of
// plugins) along with the new state.
EditorState.prototype.applyTransaction = function applyTransaction (rootTr) {
    var this$1 = this;

  if (!this.filterTransaction(rootTr)) { return {state: this, transactions: []} }

  var trs = [rootTr], newState = this.applyInner(rootTr), seen = null;
  // This loop repeatedly gives plugins a chance to respond to
  // transactions as new transactions are added, making sure to only
  // pass the transactions the plugin did not see before.
  outer: for (;;) {
    var haveNew = false;
    for (var i = 0; i < this.config.plugins.length; i++) {
      var plugin = this$1.config.plugins[i];
      if (plugin.spec.appendTransaction) {
        var n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this$1;
        var tr = n < trs.length &&
            plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
        if (tr && newState.filterTransaction(tr, i)) {
          tr.setMeta("appendedTransaction", rootTr);
          if (!seen) {
            seen = [];
            for (var j = 0; j < this.config.plugins.length; j++)
              { seen.push(j < i ? {state: newState, n: trs.length} : {state: this$1, n: 0}); }
          }
          trs.push(tr);
          newState = newState.applyInner(tr);
          haveNew = true;
        }
        if (seen) { seen[i] = {state: newState, n: trs.length}; }
      }
    }
    if (!haveNew) { return {state: newState, transactions: trs} }
  }
};

// : (Transaction) → EditorState
EditorState.prototype.applyInner = function applyInner (tr) {
    var this$1 = this;

  if (!tr.before.eq(this.doc)) { throw new RangeError("Applying a mismatched transaction") }
  var newInstance = new EditorState(this.config), fields = this.config.fields;
  for (var i = 0; i < fields.length; i++) {
    var field = fields[i];
    newInstance[field.name] = field.apply(tr, this$1[field.name], this$1, newInstance);
  }
  for (var i$1 = 0; i$1 < applyListeners.length; i$1++) { applyListeners[i$1](this$1, tr, newInstance); }
  return newInstance
};

// :: Transaction
// Start a [transaction](#state.Transaction) from this state.
prototypeAccessors$1.tr.get = function () { return new Transaction(this) };

// :: (Object) → EditorState
// Create a new state.
//
// config::- Configuration options. Must contain `schema` or `doc` (or both).
//
//    schema:: ?Schema
//    The schema to use.
//
//    doc:: ?Node
//    The starting document.
//
//    selection:: ?Selection
//    A valid selection in the document.
//
//    storedMarks:: ?[Mark]
//    The initial set of [stored marks](#state.EditorState.storedMarks).
//
//    plugins:: ?[Plugin]
//    The plugins that should be active in this state.
EditorState.create = function create (config) {
  var $config = new Configuration(config.schema || config.doc.type.schema, config.plugins);
  var instance = new EditorState($config);
  for (var i = 0; i < $config.fields.length; i++)
    { instance[$config.fields[i].name] = $config.fields[i].init(config, instance); }
  return instance
};

// :: (Object) → EditorState
// Create a new state based on this one, but with an adjusted set of
// active plugins. State fields that exist in both sets of plugins
// are kept unchanged. Those that no longer exist are dropped, and
// those that are new are initialized using their
// [`init`](#state.StateField.init) method, passing in the new
// configuration object..
//
// config::- configuration options
//
//   schema:: ?Schema
//   New schema to use.
//
//   plugins:: ?[Plugin]
//   New set of active plugins.
EditorState.prototype.reconfigure = function reconfigure (config) {
    var this$1 = this;

  var $config = new Configuration(config.schema || this.schema, config.plugins);
  var fields = $config.fields, instance = new EditorState($config);
  for (var i = 0; i < fields.length; i++) {
    var name = fields[i].name;
    instance[name] = this$1.hasOwnProperty(name) ? this$1[name] : fields[i].init(config, instance);
  }
  return instance
};

// :: (?union<Object<Plugin>, string, number>) → Object
// Serialize this state to JSON. If you want to serialize the state
// of plugins, pass an object mapping property names to use in the
// resulting JSON object to plugin objects. The argument may also be
// a string or number, in which case it is ignored, to support the
// way `JSON.stringify` calls `toString` methods.
EditorState.prototype.toJSON = function toJSON (pluginFields) {
    var this$1 = this;

  var result = {doc: this.doc.toJSON(), selection: this.selection.toJSON()};
  if (this.storedMarks) { result.storedMarks = this.storedMarks.map(function (m) { return m.toJSON(); }); }
  if (pluginFields && typeof pluginFields == 'object') { for (var prop in pluginFields) {
    if (prop == "doc" || prop == "selection")
      { throw new RangeError("The JSON fields `doc` and `selection` are reserved") }
    var plugin = pluginFields[prop], state = plugin.spec.state;
    if (state && state.toJSON) { result[prop] = state.toJSON.call(plugin, this$1[plugin.key]); }
  } }
  return result
};

// :: (Object, Object, ?Object<Plugin>) → EditorState
// Deserialize a JSON representation of a state. `config` should
// have at least a `schema` field, and should contain array of
// plugins to initialize the state with. `pluginFields` can be used
// to deserialize the state of plugins, by associating plugin
// instances with the property names they use in the JSON object.
//
// config::- configuration options
//
//   schema:: Schema
//   The schema to use.
//
//   plugins:: ?[Plugin]
//   The set of active plugins.
EditorState.fromJSON = function fromJSON (config, json, pluginFields) {
  if (!json) { throw new RangeError("Invalid input for EditorState.fromJSON") }
  if (!config.schema) { throw new RangeError("Required config field 'schema' missing") }
  var $config = new Configuration(config.schema, config.plugins);
  var instance = new EditorState($config);
  $config.fields.forEach(function (field) {
    if (field.name == "doc") {
      instance.doc = prosemirrorModel.Node.fromJSON(config.schema, json.doc);
    } else if (field.name == "selection") {
      instance.selection = Selection.fromJSON(instance.doc, json.selection);
    } else if (field.name == "storedMarks") {
      if (json.storedMarks) { instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON); }
    } else {
      if (pluginFields) { for (var prop in pluginFields) {
        var plugin = pluginFields[prop], state = plugin.spec.state;
        if (plugin.key == field.name && state && state.fromJSON &&
            Object.prototype.hasOwnProperty.call(json, prop)) {
          // This field belongs to a plugin mapped to a JSON field, read it from there.
          instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
          return
        }
      } }
      instance[field.name] = field.init(config, instance);
    }
  });
  return instance
};

// Kludge to allow the view to track mappings between different
// instances of a state.
EditorState.addApplyListener = function addApplyListener (f) {
  applyListeners.push(f);
};
EditorState.removeApplyListener = function removeApplyListener (f) {
  var found = applyListeners.indexOf(f);
  if (found > -1) { applyListeners.splice(found, 1); }
};

Object.defineProperties( EditorState.prototype, prototypeAccessors$1 );

var applyListeners = [];

// PluginSpec:: interface
//
// This is the type passed to the [`Plugin`](#state.Plugin)
// constructor. It provides a definition for a plugin.
//
//   props:: ?EditorProps
//   The [view props](#view.EditorProps) added by this plugin. Props
//   that are functions will be bound to have the plugin instance as
//   their `this` binding.
//
//   state:: ?StateField<any>
//   Allows a plugin to define a [state field](#state.StateField), an
//   extra slot in the state object in which it can keep its own data.
//
//   key:: ?PluginKey
//   Can be used to make this a keyed plugin. You can have only one
//   plugin with a given key in a given state, but it is possible to
//   access the plugin's configuration and state through the key,
//   without having access to the plugin instance object.
//
//   view:: ?(EditorView) → Object
//   When the plugin needs to interact with the editor view, or
//   set something up in the DOM, use this field. The function
//   will be called when the plugin's state is associated with an
//   editor view.
//
//     return::-
//     Should return an object with the following optional
//     properties:
//
//       update:: ?(view: EditorView, prevState: EditorState)
//       Called whenever the view's state is updated.
//
//       destroy:: ?()
//       Called when the view is destroyed or receives a state
//       with different plugins.
//
//   filterTransaction:: ?(Transaction, EditorState) → bool
//   When present, this will be called before a transaction is
//   applied by the state, allowing the plugin to cancel it (by
//   returning false).
//
//   appendTransaction:: ?(transactions: [Transaction], oldState: EditorState, newState: EditorState) → ?Transaction
//   Allows the plugin to append another transaction to be applied
//   after the given array of transactions. When another plugin
//   appends a transaction after this was called, it is called again
//   with the new state and new transactions—but only the new
//   transactions, i.e. it won't be passed transactions that it
//   already saw.

function bindProps(obj, self, target) {
  for (var prop in obj) {
    var val = obj[prop];
    if (val instanceof Function) { val = val.bind(self); }
    else if (prop == "handleDOMEvents") { val = bindProps(val, self, {}); }
    target[prop] = val;
  }
  return target
}

// ::- Plugins bundle functionality that can be added to an editor.
// They are part of the [editor state](#state.EditorState) and
// may influence that state and the view that contains it.
var Plugin = function Plugin(spec) {
  // :: EditorProps
  // The [props](#view.EditorProps) exported by this plugin.
  this.props = {};
  if (spec.props) { bindProps(spec.props, this, this.props); }
  // :: Object
  // The plugin's [spec object](#state.PluginSpec).
  this.spec = spec;
  this.key = spec.key ? spec.key.key : createKey("plugin");
};

// :: (EditorState) → any
// Extract the plugin's state field from an editor state.
Plugin.prototype.getState = function getState (state) { return state[this.key] };

// StateField:: interface<T>
// A plugin spec may provide a state field (under its
// [`state`](#state.PluginSpec.state) property) of this type, which
// describes the state it wants to keep. Functions provided here are
// always called with the plugin instance as their `this` binding.
//
//   init:: (config: Object, instance: EditorState) → T
//   Initialize the value of the field. `config` will be the object
//   passed to [`EditorState.create`](#state.EditorState^create). Note
//   that `instance` is a half-initialized state instance, and will
//   not have values for plugin fields initialized after this one.
//
//   apply:: (tr: Transaction, value: T, oldState: EditorState, newState: EditorState) → T
//   Apply the given transaction to this state field, producing a new
//   field value. Note that the `newState` argument is again a partially
//   constructed state does not yet contain the state from plugins
//   coming after this one.
//
//   toJSON:: ?(value: T) → *
//   Convert this field to JSON. Optional, can be left off to disable
//   JSON serialization for the field.
//
//   fromJSON:: ?(config: Object, value: *, state: EditorState) → T
//   Deserialize the JSON representation of this field. Note that the
//   `state` argument is again a half-initialized state.

var keys = Object.create(null);

function createKey(name) {
  if (name in keys) { return name + "$" + ++keys[name] }
  keys[name] = 0;
  return name + "$"
}

// ::- A key is used to [tag](#state.PluginSpec.key)
// plugins in a way that makes it possible to find them, given an
// editor state. Assigning a key does mean only one plugin of that
// type can be active in a state.
var PluginKey = function PluginKey(name) {
if ( name === void 0 ) name = "key";
 this.key = createKey(name); };

// :: (EditorState) → ?Plugin
// Get the active plugin with this key, if any, from an editor
// state.
PluginKey.prototype.get = function get (state) { return state.config.pluginsByKey[this.key] };

// :: (EditorState) → ?any
// Get the plugin's state from an editor state.
PluginKey.prototype.getState = function getState (state) { return state[this.key] };

exports.Selection = Selection;
exports.SelectionRange = SelectionRange;
exports.TextSelection = TextSelection;
exports.NodeSelection = NodeSelection;
exports.AllSelection = AllSelection;
exports.Transaction = Transaction;
exports.EditorState = EditorState;
exports.Plugin = Plugin;
exports.PluginKey = PluginKey;
//# sourceMappingURL=index.js.map


/***/ }),
/* 12 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(373);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["n"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__providerFactory__ = __webpack_require__(399);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__providerFactory__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__providerFactory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(265);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["A"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["B"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["C"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["D"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["E"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["F"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["G"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["H"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["I"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["J"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui__ = __webpack_require__(643);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__ui__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__ui__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__ui__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__ui__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_3__ui__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__ui__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_3__ui__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_3__ui__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_3__ui__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_3__ui__["j"]; });




//# sourceMappingURL=index.js.map

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorState = __webpack_require__(11);
var prosemirrorModel = __webpack_require__(23);
var prosemirrorTables = __webpack_require__(60);

// :: (nodeType: union<NodeType, [NodeType]>) → (tr: Transaction) → Transaction
// Returns a new transaction that removes a node of a given `nodeType`. It will return an original transaction if parent node hasn't been found.
//
// ```javascript
// dispatch(
//   removeParentNodeOfType(schema.nodes.table)(tr)
// );
// ```
var removeParentNodeOfType = function removeParentNodeOfType(nodeType) {
  return function (tr) {
    var parent = findParentNodeOfType(nodeType)(tr.selection);
    if (parent) {
      return removeNodeAtPos(parent.pos)(tr);
    }
    return tr;
  };
};

// :: (nodeType: union<NodeType, [NodeType]>, content: union<ProseMirrorNode, Fragment>) → (tr: Transaction) → Transaction
// Returns a new transaction that replaces parent node of a given `nodeType` with the given `content`. It will return an original transaction if either parent node hasn't been found or replacing is not possible.
//
// ```javascript
// const node = schema.nodes.paragraph.createChecked({}, schema.text('new'));
//
// dispatch(
//  replaceParentNodeOfType(schema.nodes.table, node)(tr)
// );
// ```
var replaceParentNodeOfType = function replaceParentNodeOfType(nodeType, content) {
  return function (tr) {
    if (!Array.isArray(nodeType)) {
      nodeType = [nodeType];
    }
    for (var i = 0, count = nodeType.length; i < count; i++) {
      var parent = findParentNodeOfType(nodeType[i])(tr.selection);
      if (parent) {
        var newTr = replaceNodeAtPos(parent.pos, content)(tr);
        if (newTr !== tr) {
          return newTr;
        }
      }
    }
    return tr;
  };
};

// :: (tr: Transaction) → Transaction
// Returns a new transaction that removes selected node. It will return an original transaction if current selection is not a `NodeSelection`.
//
// ```javascript
// dispatch(
//   removeSelectedNode(tr)
// );
// ```
var removeSelectedNode = function removeSelectedNode(tr) {
  if (isNodeSelection(tr.selection)) {
    var from = tr.selection.$from.pos;
    var to = tr.selection.$to.pos;
    return cloneTr(tr.delete(from, to));
  }
  return tr;
};

// :: (node: ProseMirrorNode) → (tr: Transaction) → Transaction
// Returns a new transaction that replaces selected node with a given `node`.
// It will return the original transaction if either current selection is not a NodeSelection or replacing is not possible.
//
// ```javascript
// const node = schema.nodes.paragraph.createChecked({}, schema.text('new'));
// dispatch(
//   replaceSelectedNode(node)(tr)
// );
// ```
var replaceSelectedNode = function replaceSelectedNode(node) {
  return function (tr) {
    if (isNodeSelection(tr.selection)) {
      var _tr$selection = tr.selection,
          $from = _tr$selection.$from,
          $to = _tr$selection.$to;

      if ($from.parent.canReplaceWith($from.index(), $from.indexAfter(), node.type)) {
        return cloneTr(tr.replaceWith($from.pos, $to.pos, node));
      }
    }
    return tr;
  };
};

// :: (position: number, dir: ?number) → (tr: Transaction) → Transaction
// Returns a new transaction that tries to find a valid cursor selection starting at the given `position`
// and searching back if `dir` is negative, and forward if positive.
// If a valid cursor position hasn't been found, it will return the original transaction.
//
// ```javascript
// dispatch(
//   setTextSelection(5)(tr)
// );
// ```
var setTextSelection = function setTextSelection(position) {
  var dir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return function (tr) {
    var nextSelection = prosemirrorState.Selection.findFrom(tr.doc.resolve(position), dir, true);
    if (nextSelection) {
      return tr.setSelection(nextSelection);
    }
    return tr;
  };
};

// :: (content: union<ProseMirrorNode, Fragment>, position: ?number) → (tr: Transaction) → Transaction
// Returns a new transaction that inserts a given `content` at the current cursor position, or at a given `position`, if it is allowed by schema. If schema restricts such nesting, it will try to find an appropriate place for a given node in the document, looping through parent nodes up until the root document node.
// If cursor is inside of an empty paragraph, it will try to replace that paragraph with the given content. If insertion is successful and inserted node has content, it will set cursor inside of that content.
// It will return an original transaction if the place for insertion hasn't been found.
//
// ```javascript
// const node = schema.nodes.extension.createChecked({});
// dispatch(
//   safeInsert(node)(tr)
// );
// ```
var safeInsert = function safeInsert(content, position) {
  return function (tr) {
    var hasPosition = typeof position === 'number';
    var $from = tr.selection.$from;

    var $insertPos = hasPosition ? tr.doc.resolve(position) : isNodeSelection(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
    var parent = $insertPos.parent,
        depth = $insertPos.depth;

    // try to replace an empty paragraph

    if (isEmptyParagraph(parent)) {
      var oldTr = tr;
      tr = replaceParentNodeOfType(parent.type, content)(tr);
      if (oldTr !== tr) {
        return setTextSelection($insertPos.pos)(tr);
      }
    }

    // given node is allowed at the current cursor position
    if (canInsert($insertPos, content)) {
      tr.insert($insertPos.pos, content);
      return cloneTr(setTextSelection(hasPosition ? $insertPos.pos : tr.selection.$anchor.pos)(tr));
    }

    // looking for a place in the doc where the node is allowed
    for (var i = $insertPos.depth; i > 0; i--) {
      var pos = $insertPos.after(i);
      var $pos = tr.doc.resolve(pos);
      if (canInsert($pos, content)) {
        tr.insert(pos, content);
        return cloneTr(setTextSelection(pos)(tr));
      }
    }
    return tr;
  };
};

// :: (nodeType: union<NodeType, [NodeType]>, type: ?union<NodeType, null>, attrs: ?union<Object, null>, marks?: [Mark]) → (tr: Transaction) → Transaction
// Returns a transaction that changes the type, attributes, and/or marks of the parent node of a given `nodeType`.
//
// ```javascript
// const node = schema.nodes.extension.createChecked({});
// dispatch(
//   setParentNodeMarkup(schema.nodes.panel, null, { panelType })(tr);
// );
// ```
var setParentNodeMarkup = function setParentNodeMarkup(nodeType, type, attrs, marks) {
  return function (tr) {
    var parent = findParentNodeOfType(nodeType)(tr.selection);
    if (parent) {
      return cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
    }
    return tr;
  };
};

// :: (nodeType: union<NodeType, [NodeType]>) → (tr: Transaction) → Transaction
// Returns a new transaction that sets a `NodeSelection` on a parent node of a `given nodeType`.
//
// ```javascript
// dispatch(
//   selectParentNodeOfType([tableCell, tableHeader])(state.tr)
// );
// ```
var selectParentNodeOfType = function selectParentNodeOfType(nodeType) {
  return function (tr) {
    if (!isNodeSelection(tr.selection)) {
      var parent = findParentNodeOfType(nodeType)(tr.selection);
      if (parent) {
        return cloneTr(tr.setSelection(prosemirrorState.NodeSelection.create(tr.doc, parent.pos)));
      }
    }
    return tr;
  };
};

// :: (tr: Transaction) → Transaction
// Returns a new transaction that deletes previous node.
//
// ```javascript
// dispatch(
//   removeNodeBefore(state.tr)
// );
// ```
var removeNodeBefore = function removeNodeBefore(tr) {
  var position = findPositionOfNodeBefore(tr.selection);
  if (typeof position === 'number') {
    return removeNodeAtPos(position)(tr);
  }
  return tr;
};

// :: (selection: Selection) → boolean
// Checks if current selection is a `NodeSelection`.
//
// ```javascript
// if (isNodeSelection(tr.selection)) {
//   // ...
// }
// ```
var isNodeSelection = function isNodeSelection(selection) {
  return selection instanceof prosemirrorState.NodeSelection;
};

// (nodeType: union<NodeType, [NodeType]>) → boolean
// Checks if the type a given `node` equals to a given `nodeType`.
var equalNodeType = function equalNodeType(nodeType, node) {
  return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};

// (tr: Transaction) → Transaction
// Creates a new transaction object from a given transaction
var cloneTr = function cloneTr(tr) {
  return Object.assign(Object.create(tr), tr).setTime(Date.now());
};

// (position: number, content: union<ProseMirrorNode, Fragment>) → (tr: Transaction) → Transaction
// Returns a `replace` transaction that replaces a node at a given position with the given `content`.
// It will return the original transaction if replacing is not possible.
// `position` should point at the position immediately before the node.
var replaceNodeAtPos = function replaceNodeAtPos(position, content) {
  return function (tr) {
    var node = tr.doc.nodeAt(position);
    var $pos = tr.doc.resolve(position);
    if (canReplace($pos, content)) {
      tr = tr.replaceWith(position, position + node.nodeSize, content);
      var start = tr.selection.$from.pos - 1;
      // put cursor inside of the inserted node
      tr = setTextSelection(Math.max(start, 0), -1)(tr);
      // move cursor to the start of the node
      tr = setTextSelection(tr.selection.$from.start())(tr);
      return cloneTr(tr);
    }
    return tr;
  };
};

// ($pos: ResolvedPos, doc: ProseMirrorNode, content: union<ProseMirrorNode, Fragment>, ) → boolean
// Checks if replacing a node at a given `$pos` inside of the `doc` node with the given `content` is possible.
var canReplace = function canReplace($pos, content) {
  var node = $pos.node($pos.depth);
  return node && node.type.validContent(content instanceof prosemirrorModel.Fragment ? content : prosemirrorModel.Fragment.from(content));
};

// (position: number) → (tr: Transaction) → Transaction
// Returns a `delete` transaction that removes a node at a given position with the given `node`.
// `position` should point at the position immediately before the node.
var removeNodeAtPos = function removeNodeAtPos(position) {
  return function (tr) {
    var node = tr.doc.nodeAt(position);
    return cloneTr(tr.delete(position, position + node.nodeSize));
  };
};

// (schema: Schema) → {[key: string]: NodeType}
// Returns a map where keys are tableRoles and values are NodeTypes.
var tableNodeTypes = function tableNodeTypes(schema) {
  if (schema.cached.tableNodeTypes) {
    return schema.cached.tableNodeTypes;
  }
  var roles = {};
  Object.keys(schema.nodes).forEach(function (type) {
    var nodeType = schema.nodes[type];
    if (nodeType.spec.tableRole) {
      roles[nodeType.spec.tableRole] = nodeType;
    }
  });
  schema.cached.tableNodeTypes = roles;
  return roles;
};

// :: ($pos: ResolvedPos, content: union<ProseMirrorNode, Fragment>) → boolean
// Checks if a given `content` can be inserted at the given `$pos`
//
// ```javascript
// const { selection: { $from } } = state;
// const node = state.schema.nodes.atom.createChecked();
// if (canInsert($from, node)) {
//   // ...
// }
// ```
var canInsert = function canInsert($pos, content) {
  var index = $pos.index();

  if (content instanceof prosemirrorModel.Fragment) {
    return $pos.parent.canReplace(index, index, content);
  } else if (content instanceof prosemirrorModel.Node) {
    return $pos.parent.canReplaceWith(index, index, content.type);
  }
  return false;
};

// (node: ProseMirrorNode) → boolean
// Checks if a given `node` is an empty paragraph
var isEmptyParagraph = function isEmptyParagraph(node) {
  return !node || node.type.name === 'paragraph' && node.nodeSize === 2;
};

// ($pos: ResolvedPos) → ?{pos: number, start: number, node: ProseMirrorNode}
// Iterates over parent nodes, returning a table node closest to a given `$pos`.
//
// ```javascript
// const table = findTableClosestToPos(state.doc.resolve(10));
// ```
var findTableClosestToPos = function findTableClosestToPos($pos) {
  var predicate = function predicate(node) {
    return node.type.spec.tableRole && /table/i.test(node.type.spec.tableRole);
  };
  return findParentNodeClosestToPos($pos, predicate);
};

var createCell = function createCell(cellType) {
  var cellContent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (cellContent) {
    return cellType.createChecked(null, cellContent);
  }

  return cellType.createAndFill();
};

// :: (predicate: (node: ProseMirrorNode) → boolean) → (selection: Selection) → ?{pos: number, start: number, depth: number, node: ProseMirrorNode}
// Iterates over parent nodes, returning the closest node and its start position `predicate` returns truthy for. `start` points to the start position of the node, `pos` points directly before the node.
//
// ```javascript
// const predicate = node => node.type === schema.nodes.blockquote;
// const parent = findParentNode(predicate)(selection);
// ```
var findParentNode = function findParentNode(predicate) {
  return function (selection) {
    var $from = selection.$from;

    for (var i = $from.depth; i > 0; i--) {
      var node = $from.node(i);
      if (predicate(node)) {
        return {
          pos: i > 0 ? $from.before(i) : 0,
          start: $from.start(i),
          depth: i,
          node: node
        };
      }
    }
  };
};

// :: ($pos: ResolvedPos, predicate: (node: ProseMirrorNode) → boolean) → ?{pos: number, start: number, depth: number, node: ProseMirrorNode}
// Iterates over parent nodes starting from the given `$pos`, returning the closest node and its start position `predicate` returns truthy for. `start` points to the start position of the node, `pos` points directly before the node.
//
// ```javascript
// const predicate = node => node.type === schema.nodes.blockquote;
// const parent = findParentNodeClosestToPos(state.doc.resolve(5), predicate);
// ```
var findParentNodeClosestToPos = function findParentNodeClosestToPos($pos, predicate) {
  for (var i = $pos.depth; i > 0; i--) {
    var node = $pos.node(i);
    if (predicate(node)) {
      return {
        pos: i > 0 ? $pos.before(i) : 0,
        start: $pos.start(i),
        depth: i,
        node: node
      };
    }
  }
};

// :: (predicate: (node: ProseMirrorNode) → boolean, domAtPos: (pos: number) → {node: dom.Node, offset: number}) → (selection: Selection) → ?dom.Node
// Iterates over parent nodes, returning DOM reference of the closest node `predicate` returns truthy for.
//
// ```javascript
// const domAtPos = view.domAtPos.bind(view);
// const predicate = node => node.type === schema.nodes.table;
// const parent = findParentDomRef(predicate, domAtPos)(selection); // <table>
// ```
var findParentDomRef = function findParentDomRef(predicate, domAtPos) {
  return function (selection) {
    var parent = findParentNode(predicate)(selection);
    if (parent) {
      return findDomRefAtPos(parent.pos, domAtPos);
    }
  };
};

// :: (predicate: (node: ProseMirrorNode) → boolean) → (selection: Selection) → boolean
// Checks if there's a parent node `predicate` returns truthy for.
//
// ```javascript
// if (hasParentNode(node => node.type === schema.nodes.table)(selection)) {
//   // ....
// }
// ```
var hasParentNode = function hasParentNode(predicate) {
  return function (selection) {
    return !!findParentNode(predicate)(selection);
  };
};

// :: (nodeType: union<NodeType, [NodeType]>) → (selection: Selection) → ?{pos: number, start: number, depth: number, node: ProseMirrorNode}
// Iterates over parent nodes, returning closest node of a given `nodeType`. `start` points to the start position of the node, `pos` points directly before the node.
//
// ```javascript
// const parent = findParentNodeOfType(schema.nodes.paragraph)(selection);
// ```
var findParentNodeOfType = function findParentNodeOfType(nodeType) {
  return function (selection) {
    return findParentNode(function (node) {
      return equalNodeType(nodeType, node);
    })(selection);
  };
};

// :: ($pos: ResolvedPos, nodeType: union<NodeType, [NodeType]>) → ?{pos: number, start: number, depth: number, node: ProseMirrorNode}
// Iterates over parent nodes starting from the given `$pos`, returning closest node of a given `nodeType`. `start` points to the start position of the node, `pos` points directly before the node.
//
// ```javascript
// const parent = findParentNodeOfTypeClosestToPos(state.doc.resolve(10), schema.nodes.paragraph);
// ```
var findParentNodeOfTypeClosestToPos = function findParentNodeOfTypeClosestToPos($pos, nodeType) {
  return findParentNodeClosestToPos($pos, function (node) {
    return equalNodeType(nodeType, node);
  });
};

// :: (nodeType: union<NodeType, [NodeType]>) → (selection: Selection) → boolean
// Checks if there's a parent node of a given `nodeType`.
//
// ```javascript
// if (hasParentNodeOfType(schema.nodes.table)(selection)) {
//   // ....
// }
// ```
var hasParentNodeOfType = function hasParentNodeOfType(nodeType) {
  return function (selection) {
    return hasParentNode(function (node) {
      return equalNodeType(nodeType, node);
    })(selection);
  };
};

// :: (nodeType: union<NodeType, [NodeType]>, domAtPos: (pos: number) → {node: dom.Node, offset: number}) → (selection: Selection) → ?dom.Node
// Iterates over parent nodes, returning DOM reference of the closest node of a given `nodeType`.
//
// ```javascript
// const domAtPos = view.domAtPos.bind(view);
// const parent = findParentDomRefOfType(schema.nodes.codeBlock, domAtPos)(selection); // <pre>
// ```
var findParentDomRefOfType = function findParentDomRefOfType(nodeType, domAtPos) {
  return function (selection) {
    return findParentDomRef(function (node) {
      return equalNodeType(nodeType, node);
    }, domAtPos)(selection);
  };
};

// :: (nodeType: union<NodeType, [NodeType]>) → (selection: Selection) → ?{pos: number, start: number, depth: number, node: ProseMirrorNode}
// Returns a node of a given `nodeType` if it is selected. `start` points to the start position of the node, `pos` points directly before the node.
//
// ```javascript
// const { extension, inlineExtension, bodiedExtension } = schema.nodes;
// const selectedNode = findSelectedNodeOfType([
//   extension,
//   inlineExtension,
//   bodiedExtension,
// ])(selection);
// ```
var findSelectedNodeOfType = function findSelectedNodeOfType(nodeType) {
  return function (selection) {
    if (isNodeSelection(selection)) {
      var node = selection.node,
          $from = selection.$from;

      if (equalNodeType(nodeType, node)) {
        return { node: node, pos: $from.pos, depth: $from.depth };
      }
    }
  };
};

// :: (selection: Selection) → ?number
// Returns position of the previous node.
//
// ```javascript
// const pos = findPositionOfNodeBefore(tr.selection);
// ```
var findPositionOfNodeBefore = function findPositionOfNodeBefore(selection) {
  var nodeBefore = selection.$from.nodeBefore;

  var maybeSelection = prosemirrorState.Selection.findFrom(selection.$from, -1);
  if (maybeSelection && nodeBefore) {
    // leaf node
    var parent = findParentNodeOfType(nodeBefore.type)(maybeSelection);
    if (parent) {
      return parent.pos;
    }
    return maybeSelection.$from.pos;
  }
};

// :: (position: number, domAtPos: (pos: number) → {node: dom.Node, offset: number}) → dom.Node
// Returns DOM reference of a node at a given `position`. If the node type is of type `TEXT_NODE` it will return the reference of the parent node.
//
// ```javascript
// const domAtPos = view.domAtPos.bind(view);
// const ref = findDomRefAtPos($from.pos, domAtPos);
// ```
var findDomRefAtPos = function findDomRefAtPos(position, domAtPos) {
  var dom = domAtPos(position);
  var node = dom.node.childNodes[dom.offset];

  if (dom.node.nodeType === Node.TEXT_NODE) {
    return dom.node.parentNode;
  }

  if (!node || node.nodeType === Node.TEXT_NODE) {
    return dom.node;
  }

  return node;
};

// :: (node: ProseMirrorNode, descend: ?boolean) → [{ node: ProseMirrorNode, pos: number }]
// Flattens descendants of a given `node`. It doesn't descend into a node when descend argument is `false` (defaults to `true`).
//
// ```javascript
// const children = flatten(node);
// ```
var flatten = function flatten(node) {
  var descend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!node) {
    throw new Error('Invalid "node" parameter');
  }
  var result = [];
  node.descendants(function (child, pos) {
    result.push({ node: child, pos: pos });
    if (!descend) {
      return false;
    }
  });
  return result;
};

// :: (node: ProseMirrorNode, predicate: (node: ProseMirrorNode) → boolean, descend: ?boolean) → [{ node: ProseMirrorNode, pos: number }]
// Iterates over descendants of a given `node`, returning child nodes predicate returns truthy for. It doesn't descend into a node when descend argument is `false` (defaults to `true`).
//
// ```javascript
// const textNodes = findChildren(node, child => child.isText, false);
// ```
var findChildren = function findChildren(node, predicate, descend) {
  if (!node) {
    throw new Error('Invalid "node" parameter');
  } else if (!predicate) {
    throw new Error('Invalid "predicate" parameter');
  }
  return flatten(node, descend).filter(function (child) {
    return predicate(child.node);
  });
};

// :: (node: ProseMirrorNode, descend: ?boolean) → [{ node: ProseMirrorNode, pos: number }]
// Returns text nodes of a given `node`. It doesn't descend into a node when descend argument is `false` (defaults to `true`).
//
// ```javascript
// const textNodes = findTextNodes(node);
// ```
var findTextNodes = function findTextNodes(node, descend) {
  return findChildren(node, function (child) {
    return child.isText;
  }, descend);
};

// :: (node: ProseMirrorNode, descend: ?boolean) → [{ node: ProseMirrorNode, pos: number }]
// Returns inline nodes of a given `node`. It doesn't descend into a node when descend argument is `false` (defaults to `true`).
//
// ```javascript
// const inlineNodes = findInlineNodes(node);
// ```
var findInlineNodes = function findInlineNodes(node, descend) {
  return findChildren(node, function (child) {
    return child.isInline;
  }, descend);
};

// :: (node: ProseMirrorNode, descend: ?boolean) → [{ node: ProseMirrorNode, pos: number }]
// Returns block descendants of a given `node`. It doesn't descend into a node when descend argument is `false` (defaults to `true`).
//
// ```javascript
// const blockNodes = findBlockNodes(node);
// ```
var findBlockNodes = function findBlockNodes(node, descend) {
  return findChildren(node, function (child) {
    return child.isBlock;
  }, descend);
};

// :: (node: ProseMirrorNode, predicate: (attrs: ?Object) → boolean, descend: ?boolean) → [{ node: ProseMirrorNode, pos: number }]
// Iterates over descendants of a given `node`, returning child nodes predicate returns truthy for. It doesn't descend into a node when descend argument is `false` (defaults to `true`).
//
// ```javascript
// const mergedCells = findChildrenByAttr(table, attrs => attrs.colspan === 2);
// ```
var findChildrenByAttr = function findChildrenByAttr(node, predicate, descend) {
  return findChildren(node, function (child) {
    return !!predicate(child.attrs);
  }, descend);
};

// :: (node: ProseMirrorNode, nodeType: NodeType, descend: ?boolean) → [{ node: ProseMirrorNode, pos: number }]
// Iterates over descendants of a given `node`, returning child nodes of a given nodeType. It doesn't descend into a node when descend argument is `false` (defaults to `true`).
//
// ```javascript
// const cells = findChildrenByType(table, schema.nodes.tableCell);
// ```
var findChildrenByType = function findChildrenByType(node, nodeType, descend) {
  return findChildren(node, function (child) {
    return child.type === nodeType;
  }, descend);
};

// :: (node: ProseMirrorNode, markType: markType, descend: ?boolean) → [{ node: ProseMirrorNode, pos: number }]
// Iterates over descendants of a given `node`, returning child nodes that have a mark of a given markType. It doesn't descend into a `node` when descend argument is `false` (defaults to `true`).
//
// ```javascript
// const nodes = findChildrenByMark(state.doc, schema.marks.strong);
// ```
var findChildrenByMark = function findChildrenByMark(node, markType, descend) {
  return findChildren(node, function (child) {
    return markType.isInSet(child.marks);
  }, descend);
};

// :: (node: ProseMirrorNode, nodeType: NodeType) → boolean
// Returns `true` if a given node contains nodes of a given `nodeType`
//
// ```javascript
// if (contains(panel, schema.nodes.listItem)) {
//   // ...
// }
// ```
var contains = function contains(node, nodeType) {
  return !!findChildrenByType(node, nodeType).length;
};

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// :: (selection: Selection) → ?{pos: number, start: number, node: ProseMirrorNode}
// Iterates over parent nodes, returning the closest table node.
//
// ```javascript
// const table = findTable(selection);
// ```
var findTable = function findTable(selection) {
  return findParentNode(function (node) {
    return node.type.spec.tableRole && node.type.spec.tableRole === 'table';
  })(selection);
};

// :: (selection: Selection) → boolean
// Checks if current selection is a `CellSelection`.
//
// ```javascript
// if (isCellSelection(selection)) {
//   // ...
// }
// ```
var isCellSelection = function isCellSelection(selection) {
  return selection instanceof prosemirrorTables.CellSelection;
};

// :: (selection: Selection) → ?{left: number, right: number, top: number, bottom: number}
// Get the selection rectangle. Returns `undefined` if selection is not a CellSelection.
//
// ```javascript
// const rect = getSelectionRect(selection);
// ```
var getSelectionRect = function getSelectionRect(selection) {
  if (!isCellSelection(selection)) {
    return;
  }
  var start = selection.$anchorCell.start(-1);
  var map = prosemirrorTables.TableMap.get(selection.$anchorCell.node(-1));
  return map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start);
};

// :: (columnIndex: number) → (selection: Selection) → boolean
// Checks if entire column at index `columnIndex` is selected.
//
// ```javascript
// const className = isColumnSelected(i)(selection) ? 'selected' : '';
// ```
var isColumnSelected = function isColumnSelected(columnIndex) {
  return function (selection) {
    if (isCellSelection(selection)) {
      var rect = getSelectionRect(selection);
      if (!rect) {
        return false;
      }
      return selection.isColSelection() && columnIndex >= rect.left && columnIndex < rect.right;
    }

    return false;
  };
};

// :: (rowIndex: number) → (selection: Selection) → boolean
// Checks if entire row at index `rowIndex` is selected.
//
// ```javascript
// const className = isRowSelected(i)(selection) ? 'selected' : '';
// ```
var isRowSelected = function isRowSelected(rowIndex) {
  return function (selection) {
    if (isCellSelection(selection)) {
      var rect = getSelectionRect(selection);
      if (!rect) {
        return false;
      }
      return selection.isRowSelection() && rowIndex >= rect.top && rowIndex < rect.bottom;
    }

    return false;
  };
};

// :: (selection: Selection) → boolean
// Checks if entire table is selected
//
// ```javascript
// const className = isTableSelected(selection) ? 'selected' : '';
// ```
var isTableSelected = function isTableSelected(selection) {
  if (isCellSelection(selection)) {
    return selection.isColSelection() && selection.isRowSelection();
  }

  return false;
};

// :: (columnIndex: union<number, [number]>) → (selection: Selection) → ?[{pos: number, start: number, node: ProseMirrorNode}]
// Returns an array of cells in a column(s), where `columnIndex` could be a column index or an array of column indexes.
//
// ```javascript
// const cells = getCellsInColumn(i)(selection); // [{node, pos}, {node, pos}]
// ```
var getCellsInColumn = function getCellsInColumn(columnIndex) {
  return function (selection) {
    var table = findTable(selection);
    if (table) {
      var map = prosemirrorTables.TableMap.get(table.node);
      var indexes = Array.isArray(columnIndex) ? columnIndex : Array.from([columnIndex]);
      return indexes.reduce(function (acc, index) {
        if (index >= 0 && index <= map.width - 1) {
          var cells = map.cellsInRect({
            left: index,
            right: index + 1,
            top: 0,
            bottom: map.height
          });
          return acc.concat(cells.map(function (nodePos) {
            var node = table.node.nodeAt(nodePos);
            var pos = nodePos + table.start;
            return { pos: pos, start: pos + 1, node: node };
          }));
        }
      }, []);
    }
  };
};

// :: (rowIndex: union<number, [number]>) → (selection: Selection) → ?[{pos: number, start: number, node: ProseMirrorNode}]
// Returns an array of cells in a row(s), where `rowIndex` could be a row index or an array of row indexes.
//
// ```javascript
// const cells = getCellsInRow(i)(selection); // [{node, pos}, {node, pos}]
// ```
var getCellsInRow = function getCellsInRow(rowIndex) {
  return function (selection) {
    var table = findTable(selection);
    if (table) {
      var map = prosemirrorTables.TableMap.get(table.node);
      var indexes = Array.isArray(rowIndex) ? rowIndex : Array.from([rowIndex]);
      return indexes.reduce(function (acc, index) {
        if (index >= 0 && index <= map.height - 1) {
          var cells = map.cellsInRect({
            left: 0,
            right: map.width,
            top: index,
            bottom: index + 1
          });
          return acc.concat(cells.map(function (nodePos) {
            var node = table.node.nodeAt(nodePos);
            var pos = nodePos + table.start;
            return { pos: pos, start: pos + 1, node: node };
          }));
        }
      }, []);
    }
  };
};

// :: (selection: Selection) → ?[{pos: number, start: number, node: ProseMirrorNode}]
// Returns an array of all cells in a table.
//
// ```javascript
// const cells = getCellsInTable(selection); // [{node, pos}, {node, pos}]
// ```
var getCellsInTable = function getCellsInTable(selection) {
  var table = findTable(selection);
  if (table) {
    var map = prosemirrorTables.TableMap.get(table.node);
    var cells = map.cellsInRect({
      left: 0,
      right: map.width,
      top: 0,
      bottom: map.height
    });
    return cells.map(function (nodePos) {
      var node = table.node.nodeAt(nodePos);
      var pos = nodePos + table.start;
      return { pos: pos, start: pos + 1, node: node };
    });
  }
};

// :: (columnIndex: number) → (tr: Transaction) → Transaction
// Returns a new transaction that creates a `CellSelection` on a column at index `columnIndex`.
//
// ```javascript
// dispatch(
//   selectColumn(i)(state.tr)
// );
// ```
var selectColumn = function selectColumn(columnIndex) {
  return function (tr) {
    var cells = getCellsInColumn(columnIndex)(tr.selection);
    if (cells) {
      var $anchor = tr.doc.resolve(cells[0].pos);
      var $head = tr.doc.resolve(cells[cells.length - 1].pos);
      return cloneTr(tr.setSelection(new prosemirrorTables.CellSelection($anchor, $head)));
    }
    return tr;
  };
};

// :: (rowIndex: number) → (tr: Transaction) → Transaction
// Returns a new transaction that creates a `CellSelection` on a column at index `rowIndex`.
//
// ```javascript
// dispatch(
//   selectRow(i)(state.tr)
// );
// ```
var selectRow = function selectRow(rowIndex) {
  return function (tr) {
    var cells = getCellsInRow(rowIndex)(tr.selection);
    if (cells) {
      var $anchor = tr.doc.resolve(cells[0].pos);
      var $head = tr.doc.resolve(cells[cells.length - 1].pos);
      return cloneTr(tr.setSelection(new prosemirrorTables.CellSelection($anchor, $head)));
    }
    return tr;
  };
};

// :: (selection: Selection) → (tr: Transaction) → Transaction
// Returns a new transaction that creates a `CellSelection` on the entire table.
//
// ```javascript
// dispatch(
//   selectTable(i)(state.tr)
// );
// ```
var selectTable = function selectTable(tr) {
  var cells = getCellsInTable(tr.selection);
  if (cells) {
    var $anchor = tr.doc.resolve(cells[0].pos);
    var $head = tr.doc.resolve(cells[cells.length - 1].pos);
    return cloneTr(tr.setSelection(new prosemirrorTables.CellSelection($anchor, $head)));
  }
  return tr;
};

// :: (cell: {pos: number, node: ProseMirrorNode}, schema: Schema) → (tr: Transaction) → Transaction
// Returns a new transaction that clears the content of a given `cell`.
//
// ```javascript
// const $pos = state.doc.resolve(13);
// dispatch(
//   emptyCell(findCellClosestToPos($pos), state.schema)(state.tr)
// );
// ```
var emptyCell = function emptyCell(cell, schema) {
  return function (tr) {
    if (cell) {
      var content = tableNodeTypes(schema).cell.createAndFill().content;
      if (!cell.node.content.eq(content)) {
        tr.replaceWith(cell.pos, cell.pos + cell.node.nodeSize - 1, new prosemirrorModel.Slice(content, 0, 0));
        return cloneTr(tr);
      }
    }
    return tr;
  };
};

// :: (columnIndex: number) → (tr: Transaction) → Transaction
// Returns a new transaction that adds a new column at index `columnIndex`.
//
// ```javascript
// dispatch(
//   addColumnAt(i)(state.tr)
// );
// ```
var addColumnAt = function addColumnAt(columnIndex) {
  return function (tr) {
    var table = findTable(tr.selection);
    if (table) {
      var map = prosemirrorTables.TableMap.get(table.node);
      if (columnIndex >= 0 && columnIndex <= map.width) {
        return cloneTr(prosemirrorTables.addColumn(tr, {
          map: map,
          tableStart: table.start,
          table: table.node
        }, columnIndex));
      }
    }
    return tr;
  };
};

// :: (rowIndex: number, clonePreviousRow?: boolean) → (tr: Transaction) → Transaction
// Returns a new transaction that adds a new row at index `rowIndex`. Optionally clone the previous row.
//
// ```javascript
// dispatch(
//   addRowAt(i)(state.tr)
// );
// ```
//
// ```javascript
// dispatch(
//   addRowAt(i, true)(state.tr)
// );
// ```
var addRowAt = function addRowAt(rowIndex, clonePreviousRow) {
  return function (tr) {
    var table = findTable(tr.selection);
    if (table) {
      var map = prosemirrorTables.TableMap.get(table.node);
      var cloneRowIndex = rowIndex - 1;

      if (clonePreviousRow && cloneRowIndex >= 0) {
        return cloneTr(cloneRowAt(cloneRowIndex)(tr));
      }

      if (rowIndex >= 0 && rowIndex <= map.height) {
        return cloneTr(prosemirrorTables.addRow(tr, {
          map: map,
          tableStart: table.start,
          table: table.node
        }, rowIndex));
      }
    }
    return tr;
  };
};

// :: (cloneRowIndex: number) → (tr: Transaction) → Transaction
// Returns a new transaction that adds a new row after `cloneRowIndex`, cloning the row attributes at `cloneRowIndex`.
//
// ```javascript
// dispatch(
//   cloneRowAt(i)(state.tr)
// );
// ```
var cloneRowAt = function cloneRowAt(rowIndex) {
  return function (tr) {
    var table = findTable(tr.selection);
    if (table) {
      var map = prosemirrorTables.TableMap.get(table.node);

      if (rowIndex >= 0 && rowIndex <= map.height) {
        var tableNode = table.node;
        var tableNodes = tableNodeTypes(tableNode.type.schema);

        var rowPos = table.start;
        for (var i = 0; i < rowIndex + 1; i++) {
          rowPos += tableNode.child(i).nodeSize;
        }

        var cloneRow = tableNode.child(rowIndex);
        // Re-create the same nodes with same attrs, dropping the node content.
        var cells = [];
        var rowWidth = 0;
        cloneRow.forEach(function (cell) {
          // If we're copying a row with rowspan somewhere, we dont want to copy that cell
          // We'll increment its span below.
          if (cell.attrs.rowspan === 1) {
            rowWidth += cell.attrs.colspan;
            cells.push(tableNodes[cell.type.spec.tableRole].createAndFill(cell.attrs, cell.marks));
          }
        });

        // If a higher row spans past our clone row, bump the higher row to cover this new row too.
        if (rowWidth < map.width) {
          var rowSpanCells = [];

          var _loop = function _loop(_i) {
            var foundCells = filterCellsInRow(_i, function (cell, tr) {
              var rowspan = cell.node.attrs.rowspan;
              var spanRange = _i + rowspan;
              return rowspan > 1 && spanRange > rowIndex;
            })(tr);
            rowSpanCells.push.apply(rowSpanCells, _toConsumableArray(foundCells));
          };

          for (var _i = rowIndex; _i >= 0; _i--) {
            _loop(_i);
          }

          if (rowSpanCells.length) {
            rowSpanCells.forEach(function (cell) {
              tr = setCellAttrs(cell, {
                rowspan: cell.node.attrs.rowspan + 1
              })(tr);
            });
          }
        }

        return safeInsert(tableNodes.row.create(cloneRow.attrs, cells), rowPos)(tr);
      }
    }
    return tr;
  };
};

// :: (columnIndex: number) → (tr: Transaction) → Transaction
// Returns a new transaction that removes a column at index `columnIndex`. If there is only one column left, it will remove the entire table.
//
// ```javascript
// dispatch(
//   removeColumnAt(i)(state.tr)
// );
// ```
var removeColumnAt = function removeColumnAt(columnIndex) {
  return function (tr) {
    var table = findTable(tr.selection);
    if (table) {
      var map = prosemirrorTables.TableMap.get(table.node);
      if (columnIndex === 0 && map.width === 1) {
        return removeTable(tr);
      } else if (columnIndex >= 0 && columnIndex <= map.width) {
        prosemirrorTables.removeColumn(tr, {
          map: map,
          tableStart: table.start,
          table: table.node
        }, columnIndex);
        return cloneTr(tr);
      }
    }
    return tr;
  };
};

// :: (rowIndex: number) → (tr: Transaction) → Transaction
// Returns a new transaction that removes a row at index `rowIndex`. If there is only one row left, it will remove the entire table.
//
// ```javascript
// dispatch(
//   removeRowAt(i)(state.tr)
// );
// ```
var removeRowAt = function removeRowAt(rowIndex) {
  return function (tr) {
    var table = findTable(tr.selection);
    if (table) {
      var map = prosemirrorTables.TableMap.get(table.node);
      if (rowIndex === 0 && map.height === 1) {
        return removeTable(tr);
      } else if (rowIndex >= 0 && rowIndex <= map.height) {
        prosemirrorTables.removeRow(tr, {
          map: map,
          tableStart: table.start,
          table: table.node
        }, rowIndex);
        return cloneTr(tr);
      }
    }
    return tr;
  };
};

// :: (tr: Transaction) → Transaction
// Returns a new transaction that removes a table node if the cursor is inside of it.
//
// ```javascript
// dispatch(
//   removeTable(state.tr)
// );
// ```
var removeTable = function removeTable(tr) {
  var $from = tr.selection.$from;

  for (var depth = $from.depth; depth > 0; depth--) {
    var node = $from.node(depth);
    if (node.type.spec.tableRole === 'table') {
      return cloneTr(tr.delete($from.before(depth), $from.after(depth)));
    }
  }
  return tr;
};

// :: (tr: Transaction) → Transaction
// Returns a new transaction that removes selected columns.
//
// ```javascript
// dispatch(
//   removeSelectedColumns(state.tr)
// );
// ```
var removeSelectedColumns = function removeSelectedColumns(tr) {
  var _tr = tr,
      selection = _tr.selection;

  if (isTableSelected(selection)) {
    return removeTable(tr);
  }
  if (isCellSelection(selection)) {
    var table = findTable(selection);
    if (table) {
      var map = prosemirrorTables.TableMap.get(table.node);
      var rect = map.rectBetween(selection.$anchorCell.pos - table.start, selection.$headCell.pos - table.start);
      for (var i = rect.right - 1; i >= rect.left; i--) {
        tr = removeColumnAt(i)(tr);
      }
      return tr;
    }
  }
  return tr;
};

// :: (tr: Transaction) → Transaction
// Returns a new transaction that removes selected rows.
//
// ```javascript
// dispatch(
//   removeSelectedRows(state.tr)
// );
// ```
var removeSelectedRows = function removeSelectedRows(tr) {
  var _tr2 = tr,
      selection = _tr2.selection;

  if (isTableSelected(selection)) {
    return removeTable(tr);
  }
  if (isCellSelection(selection)) {
    var table = findTable(selection);
    if (table) {
      var map = prosemirrorTables.TableMap.get(table.node);
      var rect = map.rectBetween(selection.$anchorCell.pos - table.start, selection.$headCell.pos - table.start);
      for (var i = rect.bottom - 1; i >= rect.top; i--) {
        tr = removeRowAt(i)(tr);
      }
      return tr;
    }
  }
  return tr;
};

// :: ($pos: ResolvedPos) → (tr: Transaction) → Transaction
// Returns a new transaction that removes a column closest to a given `$pos`.
//
// ```javascript
// dispatch(
//   removeColumnClosestToPos(state.doc.resolve(3))(state.tr)
// );
// ```
var removeColumnClosestToPos = function removeColumnClosestToPos($pos) {
  return function (tr) {
    var rect = findCellRectClosestToPos($pos);
    if (rect) {
      return removeColumnAt(rect.left)(setTextSelection($pos.pos)(tr));
    }
    return tr;
  };
};

// :: ($pos: ResolvedPos) → (tr: Transaction) → Transaction
// Returns a new transaction that removes a row closest to a given `$pos`.
//
// ```javascript
// dispatch(
//   removeRowClosestToPos(state.doc.resolve(3))(state.tr)
// );
// ```
var removeRowClosestToPos = function removeRowClosestToPos($pos) {
  return function (tr) {
    var rect = findCellRectClosestToPos($pos);
    if (rect) {
      return removeRowAt(rect.top)(setTextSelection($pos.pos)(tr));
    }
    return tr;
  };
};

// :: (columnIndex: number, cellTransform: (cell: {pos: number, start: number, node: ProseMirrorNode}, tr: Transaction) → Transaction, setCursorToLastCell: ?boolean) → (tr: Transaction) → Transaction
// Returns a new transaction that maps a given `cellTransform` function to each cell in a column at a given `columnIndex`.
// It will set the selection into the last cell of the column if `setCursorToLastCell` param is set to `true`.
//
// ```javascript
// dispatch(
//   forEachCellInColumn(0, (cell, tr) => emptyCell(cell, state.schema)(tr))(state.tr)
// );
// ```
var forEachCellInColumn = function forEachCellInColumn(columnIndex, cellTransform, setCursorToLastCell) {
  return function (tr) {
    var cells = getCellsInColumn(columnIndex)(tr.selection);
    if (cells) {
      for (var i = cells.length - 1; i >= 0; i--) {
        tr = cellTransform(cells[i], tr);
      }
      if (setCursorToLastCell) {
        var $pos = tr.doc.resolve(tr.mapping.map(cells[cells.length - 1].pos));
        tr.setSelection(prosemirrorState.Selection.near($pos));
      }
      return cloneTr(tr);
    }
    return tr;
  };
};

// :: (rowIndex: number, cellTransform: (cell: {pos: number, start: number, node: ProseMirrorNode}, tr: Transaction) → Transaction, setCursorToLastCell: ?boolean) → (tr: Transaction) → Transaction
// Returns a new transaction that maps a given `cellTransform` function to each cell in a row at a given `rowIndex`.
// It will set the selection into the last cell of the row if `setCursorToLastCell` param is set to `true`.
//
// ```javascript
// dispatch(
//   forEachCellInRow(0, (cell, tr) => setCellAttrs(cell, { background: 'red' })(tr))(state.tr)
// );
// ```
var forEachCellInRow = function forEachCellInRow(rowIndex, cellTransform, setCursorToLastCell) {
  return function (tr) {
    var cells = getCellsInRow(rowIndex)(tr.selection);
    if (cells) {
      for (var i = cells.length - 1; i >= 0; i--) {
        tr = cellTransform(cells[i], tr);
      }
      if (setCursorToLastCell) {
        var $pos = tr.doc.resolve(tr.mapping.map(cells[cells.length - 1].pos));
        tr.setSelection(prosemirrorState.Selection.near($pos));
      }
    }
    return tr;
  };
};

// :: (cell: {pos: number, start: number, node: ProseMirrorNode}, attrs: Object) → (tr: Transaction) → Transaction
// Returns a new transaction that sets given `attrs` to a given `cell`.
//
// ```javascript
// dispatch(
//   setCellAttrs(findCellClosestToPos($pos), { background: 'blue' })(tr);
// );
// ```
var setCellAttrs = function setCellAttrs(cell, attrs) {
  return function (tr) {
    if (cell) {
      tr.setNodeMarkup(cell.pos, null, Object.assign({}, cell.node.attrs, attrs));
      return cloneTr(tr);
    }
    return tr;
  };
};

// :: (schema: Schema, rowsCount: ?number, colsCount: ?number, withHeaderRow: ?boolean, cellContent: ?Node) → Node
// Returns a table node of a given size.
// `withHeaderRow` defines whether the first row of the table will be a header row.
// `cellContent` defines the content of each cell.
//
// ```javascript
// const table = createTable(state.schema); // 3x3 table node
// dispatch(
//   tr.replaceSelectionWith(table).scrollIntoView()
// );
// ```
var createTable = function createTable(schema) {
  var rowsCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  var colsCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
  var withHeaderRow = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var cellContent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

  var _tableNodeTypes = tableNodeTypes(schema),
      tableCell = _tableNodeTypes.cell,
      tableHeader = _tableNodeTypes.header_cell,
      tableRow = _tableNodeTypes.row,
      table = _tableNodeTypes.table;

  var cells = [];
  var headerCells = [];
  for (var i = 0; i < colsCount; i++) {
    cells.push(createCell(tableCell, cellContent));

    if (withHeaderRow) {
      headerCells.push(createCell(tableHeader, cellContent));
    }
  }

  var rows = [];
  for (var _i2 = 0; _i2 < rowsCount; _i2++) {
    rows.push(tableRow.createChecked(null, withHeaderRow && _i2 === 0 ? headerCells : cells));
  }

  return table.createChecked(null, rows);
};

// :: ($pos: ResolvedPos) → ?{pos: number, start: number, node: ProseMirrorNode}
// Iterates over parent nodes, returning a table cell or a table header node closest to a given `$pos`.
//
// ```javascript
// const cell = findCellClosestToPos(state.selection.$from);
// ```
var findCellClosestToPos = function findCellClosestToPos($pos) {
  var predicate = function predicate(node) {
    return node.type.spec.tableRole && /cell/i.test(node.type.spec.tableRole);
  };
  return findParentNodeClosestToPos($pos, predicate);
};

// :: ($pos: ResolvedPos) → ?{left: number, top: number, right: number, bottom: number}
// Returns the rectangle spanning a cell closest to a given `$pos`.
//
// ```javascript
// dispatch(
//   findCellRectClosestToPos(state.selection.$from)
// );
// ```
var findCellRectClosestToPos = function findCellRectClosestToPos($pos) {
  var cell = findCellClosestToPos($pos);
  if (cell) {
    var table = findTableClosestToPos($pos);
    var map = prosemirrorTables.TableMap.get(table.node);
    var cellPos = cell.pos - table.start;
    return map.rectBetween(cellPos, cellPos);
  }
};

var filterCellsInRow = function filterCellsInRow(rowIndex, predicate) {
  return function (tr) {
    var foundCells = [];
    var cells = getCellsInRow(rowIndex)(tr.selection);
    if (cells) {
      for (var j = cells.length - 1; j >= 0; j--) {
        if (predicate(cells[j], tr)) {
          foundCells.push(cells[j]);
        }
      }
    }

    return foundCells;
  };
};

// :: (columnIndex: number) → (tr: Transaction) → {$anchor: ResolvedPos, $head: ResolvedPos, indexes: [number]}
// Returns a range of rectangular selection spanning all merged cells around a column at index `columnIndex`.
//
// ```javascript
// const range = getSelectionRangeInColumn(3)(state.tr);
// ```
var getSelectionRangeInColumn = function getSelectionRangeInColumn(columnIndex) {
  return function (tr) {
    var startIndex = columnIndex;
    var endIndex = columnIndex;

    // looking for selection start column (startIndex)

    var _loop2 = function _loop2(i) {
      var cells = getCellsInColumn(i)(tr.selection);
      cells.forEach(function (cell) {
        var maybeEndIndex = cell.node.attrs.colspan + i - 1;
        if (maybeEndIndex >= startIndex) {
          startIndex = i;
        }
        if (maybeEndIndex > endIndex) {
          endIndex = maybeEndIndex;
        }
      });
    };

    for (var i = columnIndex; i >= 0; i--) {
      _loop2(i);
    }
    // looking for selection end column (endIndex)

    var _loop3 = function _loop3(i) {
      var cells = getCellsInColumn(i)(tr.selection);
      cells.forEach(function (cell) {
        var maybeEndIndex = cell.node.attrs.colspan + i - 1;
        if (cell.node.attrs.colspan > 1 && maybeEndIndex > endIndex) {
          endIndex = maybeEndIndex;
        }
      });
    };

    for (var i = columnIndex; i <= endIndex; i++) {
      _loop3(i);
    }

    // filter out columns without cells (where all rows have colspan > 1 in the same column)
    var indexes = [];
    for (var i = startIndex; i <= endIndex; i++) {
      var maybeCells = getCellsInColumn(i)(tr.selection);
      if (maybeCells && maybeCells.length) {
        indexes.push(i);
      }
    }
    startIndex = indexes[0];
    endIndex = indexes[indexes.length - 1];

    var firstSelectedColumnCells = getCellsInColumn(startIndex)(tr.selection);
    var firstRowCells = getCellsInRow(0)(tr.selection);
    var $anchor = tr.doc.resolve(firstSelectedColumnCells[firstSelectedColumnCells.length - 1].pos);

    var headCell = void 0;
    for (var _i3 = endIndex; _i3 >= startIndex; _i3--) {
      var columnCells = getCellsInColumn(_i3)(tr.selection);
      if (columnCells && columnCells.length) {
        for (var j = firstRowCells.length - 1; j >= 0; j--) {
          if (firstRowCells[j].pos === columnCells[0].pos) {
            headCell = columnCells[0];
            break;
          }
        }
        if (headCell) {
          break;
        }
      }
    }

    var $head = tr.doc.resolve(headCell.pos);
    return { $anchor: $anchor, $head: $head, indexes: indexes };
  };
};

// :: (rowIndex: number) → (tr: Transaction) → {$anchor: ResolvedPos, $head: ResolvedPos, indexes: [number]}
// Returns a range of rectangular selection spanning all merged cells around a row at index `rowIndex`.
//
// ```javascript
// const range = getSelectionRangeInRow(3)(state.tr);
// ```
var getSelectionRangeInRow = function getSelectionRangeInRow(rowIndex) {
  return function (tr) {
    var startIndex = rowIndex;
    var endIndex = rowIndex;
    // looking for selection start row (startIndex)

    var _loop4 = function _loop4(i) {
      var cells = getCellsInRow(i)(tr.selection);
      cells.forEach(function (cell) {
        var maybeEndIndex = cell.node.attrs.rowspan + i - 1;
        if (maybeEndIndex >= startIndex) {
          startIndex = i;
        }
        if (maybeEndIndex > endIndex) {
          endIndex = maybeEndIndex;
        }
      });
    };

    for (var i = rowIndex; i >= 0; i--) {
      _loop4(i);
    }
    // looking for selection end row (endIndex)

    var _loop5 = function _loop5(i) {
      var cells = getCellsInRow(i)(tr.selection);
      cells.forEach(function (cell) {
        var maybeEndIndex = cell.node.attrs.rowspan + i - 1;
        if (cell.node.attrs.rowspan > 1 && maybeEndIndex > endIndex) {
          endIndex = maybeEndIndex;
        }
      });
    };

    for (var i = rowIndex; i <= endIndex; i++) {
      _loop5(i);
    }

    // filter out rows without cells (where all columns have rowspan > 1 in the same row)
    var indexes = [];
    for (var i = startIndex; i <= endIndex; i++) {
      var maybeCells = getCellsInRow(i)(tr.selection);
      if (maybeCells && maybeCells.length) {
        indexes.push(i);
      }
    }
    startIndex = indexes[0];
    endIndex = indexes[indexes.length - 1];

    var firstSelectedRowCells = getCellsInRow(startIndex)(tr.selection);
    var firstColumnCells = getCellsInColumn(0)(tr.selection);
    var $anchor = tr.doc.resolve(firstSelectedRowCells[firstSelectedRowCells.length - 1].pos);

    var headCell = void 0;
    for (var _i4 = endIndex; _i4 >= startIndex; _i4--) {
      var rowCells = getCellsInRow(_i4)(tr.selection);
      if (rowCells && rowCells.length) {
        for (var j = firstColumnCells.length - 1; j >= 0; j--) {
          if (firstColumnCells[j].pos === rowCells[0].pos) {
            headCell = rowCells[0];
            break;
          }
        }
        if (headCell) {
          break;
        }
      }
    }

    var $head = tr.doc.resolve(headCell.pos);
    return { $anchor: $anchor, $head: $head, indexes: indexes };
  };
};

exports.isNodeSelection = isNodeSelection;
exports.canInsert = canInsert;
exports.findParentNode = findParentNode;
exports.findParentNodeClosestToPos = findParentNodeClosestToPos;
exports.findParentDomRef = findParentDomRef;
exports.hasParentNode = hasParentNode;
exports.findParentNodeOfType = findParentNodeOfType;
exports.findParentNodeOfTypeClosestToPos = findParentNodeOfTypeClosestToPos;
exports.hasParentNodeOfType = hasParentNodeOfType;
exports.findParentDomRefOfType = findParentDomRefOfType;
exports.findSelectedNodeOfType = findSelectedNodeOfType;
exports.findPositionOfNodeBefore = findPositionOfNodeBefore;
exports.findDomRefAtPos = findDomRefAtPos;
exports.flatten = flatten;
exports.findChildren = findChildren;
exports.findTextNodes = findTextNodes;
exports.findInlineNodes = findInlineNodes;
exports.findBlockNodes = findBlockNodes;
exports.findChildrenByAttr = findChildrenByAttr;
exports.findChildrenByType = findChildrenByType;
exports.findChildrenByMark = findChildrenByMark;
exports.contains = contains;
exports.findTable = findTable;
exports.isCellSelection = isCellSelection;
exports.getSelectionRect = getSelectionRect;
exports.isColumnSelected = isColumnSelected;
exports.isRowSelected = isRowSelected;
exports.isTableSelected = isTableSelected;
exports.getCellsInColumn = getCellsInColumn;
exports.getCellsInRow = getCellsInRow;
exports.getCellsInTable = getCellsInTable;
exports.selectColumn = selectColumn;
exports.selectRow = selectRow;
exports.selectTable = selectTable;
exports.emptyCell = emptyCell;
exports.addColumnAt = addColumnAt;
exports.addRowAt = addRowAt;
exports.cloneRowAt = cloneRowAt;
exports.removeColumnAt = removeColumnAt;
exports.removeRowAt = removeRowAt;
exports.removeTable = removeTable;
exports.removeSelectedColumns = removeSelectedColumns;
exports.removeSelectedRows = removeSelectedRows;
exports.removeColumnClosestToPos = removeColumnClosestToPos;
exports.removeRowClosestToPos = removeRowClosestToPos;
exports.forEachCellInColumn = forEachCellInColumn;
exports.forEachCellInRow = forEachCellInRow;
exports.setCellAttrs = setCellAttrs;
exports.createTable = createTable;
exports.findCellClosestToPos = findCellClosestToPos;
exports.findCellRectClosestToPos = findCellRectClosestToPos;
exports.getSelectionRangeInColumn = getSelectionRangeInColumn;
exports.getSelectionRangeInRow = getSelectionRangeInRow;
exports.removeParentNodeOfType = removeParentNodeOfType;
exports.replaceParentNodeOfType = replaceParentNodeOfType;
exports.removeSelectedNode = removeSelectedNode;
exports.replaceSelectedNode = replaceSelectedNode;
exports.setTextSelection = setTextSelection;
exports.safeInsert = safeInsert;
exports.setParentNodeMarkup = setParentNodeMarkup;
exports.selectParentNodeOfType = selectParentNodeOfType;
exports.removeNodeBefore = removeNodeBefore;
//# sourceMappingURL=index.js.map


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(54);

var _interopRequireDefault = __webpack_require__(53);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.size = exports.default = exports.IconWrapper = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(4));

var _createClass2 = _interopRequireDefault(__webpack_require__(5));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(7));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(6));

var _inherits2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _styledComponents = _interopRequireDefault(__webpack_require__(2));

var _uuid = _interopRequireDefault(__webpack_require__(22));

var _theme = __webpack_require__(3);

var _constants = __webpack_require__(1770);

var getSize = function getSize(props) {
  if (props.size) {
    return "height: ".concat(_constants.sizes[props.size], "; width: ").concat(_constants.sizes[props.size], ";");
  }

  return null;
};

var IconWrapper = _styledComponents.default.span.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "dyhwwi-0"
})(["\n  ", " color: ", ";\n  display: inline-block;\n  fill: ", ";\n  flex-shrink: 0;\n  line-height: 1;\n\n  > svg {\n    ", " max-height: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    pointer-events: none;\n    vertical-align: bottom;\n  }\n  /* Stop-color doesn't properly apply in chrome when the inherited/current color changes.\n   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS\n   * rule) and then override it with currentColor for the color changes to be picked up.\n   */\n  stop {\n    stop-color: currentColor;\n  }\n"], getSize, function (p) {
  return p.primaryColor || 'currentColor';
}, function (p) {
  return p.secondaryColor || _theme.colors.background;
}, getSize);

exports.IconWrapper = IconWrapper;

var Icon =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Icon, _Component);

  function Icon() {
    (0, _classCallCheck2.default)(this, Icon);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Icon).apply(this, arguments));
  }

  (0, _createClass2.default)(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Glyph = _this$props.glyph,
          dangerouslySetGlyph = _this$props.dangerouslySetGlyph,
          onClick = _this$props.onClick,
          primaryColor = _this$props.primaryColor,
          secondaryColor = _this$props.secondaryColor,
          size = _this$props.size; // handling the glyphs as strings

      if (dangerouslySetGlyph) {
        return _react.default.createElement(IconWrapper, {
          onClick: onClick,
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          size: size,
          "aria-label": this.props.label,
          dangerouslySetInnerHTML: {
            __html: Icon.insertDynamicGradientID(dangerouslySetGlyph)
          }
        });
      } // handling the glyphs when passed through as functions


      return _react.default.createElement(IconWrapper, {
        onClick: onClick,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        "aria-label": this.props.label
      }, Glyph ? _react.default.createElement(Glyph, {
        role: "presentation"
      }) : null);
    }
  }], [{
    key: "insertDynamicGradientID",

    /* Icons need unique gradient IDs across instances for different gradient definitions to work
     * correctly.
     * A step in the icon build process replaces linear gradient IDs and their references in paths
     * to a placeholder string so we can replace them with a dynamic ID here.
     * Replacing the original IDs with placeholders in the build process is more robust than not
     * using placeholders as we do not have to rely on regular expressions to find specific element
     * to replace.
     */
    value: function insertDynamicGradientID(svgStr) {
      var id = (0, _uuid.default)();
      var replacedSvgStr = svgStr.replace(/id="([^"]+)-idPlaceholder"/g, "id=$1-".concat(id)).replace(/fill="url\(#([^"]+)-idPlaceholder\)"/g, "fill=\"url(#$1-".concat(id, ")\""));
      return replacedSvgStr;
    }
  }]);
  return Icon;
}(_react.Component);

exports.default = Icon;
(0, _defineProperty2.default)(Icon, "defaultProps", {
  onClick: function onClick() {}
});
var size = Object.keys(_constants.sizes).reduce(function (p, c) {
  return Object.assign(p, (0, _defineProperty2.default)({}, c, c));
}, {});
exports.size = size;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addLocaleData", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intlShape", function() { return intlShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectIntl", function() { return injectIntl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineMessages", function() { return defineMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntlProvider", function() { return IntlProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedDate", function() { return FormattedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedTime", function() { return FormattedTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedRelative", function() { return FormattedRelative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedNumber", function() { return FormattedNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedPlural", function() { return FormattedPlural; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedMessage", function() { return FormattedMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedHTMLMessage", function() { return FormattedHTMLMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(1616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(1625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intl_format_cache__ = __webpack_require__(1632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intl_format_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__);
/*
 * Copyright 2018, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */










// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
      __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;
var oneOfType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  timeZone: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object,

  onError: func
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year', 'second-short', 'minute-short', 'hour-short', 'day-short', 'month-short', 'year-short'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

function createError(message, exception) {
  var eMsg = exception ? '\n' + exception : '';
  return '[React Intl] ' + message + eMsg;
}

function defaultErrorHandler(error) {
  if (false) {
    console.error(error);
  }
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_6_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this._wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? /* istanbul ignore next */function (ref) {
            return _this2._wrappedInstance = ref;
          } : null
        }));
      }
    }]);
    return InjectIntl;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(InjectIntl, WrappedComponent);
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 };

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
  thresholds['second-short'] = newThresholds['second-short'];
  thresholds['minute-short'] = newThresholds['minute-short'];
  thresholds['hour-short'] = newThresholds['hour-short'];
  thresholds['day-short'] = newThresholds['day-short'];
  thresholds['month-short'] = newThresholds['month-short'];
}

function getNamedFormat(formats, type, name, onError) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  onError(createError('No ' + type + ' format named: ' + name));
}

function formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'date', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting date.', e));
  }

  return String(date);
}

function formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'time', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting time.', e));
  }

  return String(date);
}

function formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format, onError);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    onError(createError('Error formatting relative time.', e));
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var defaults$$1 = format && getNamedFormat(formats, 'number', format, onError);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting number.', e));
  }

  return String(value);
}

function formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
  var onError = config.onError || defaultErrorHandler;

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting plural.', e));
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // Produce a better error if the user calls `intl.formatMessage(element)`

  if (false) {
    invariant(!isValidElement(config), '[React Intl] Don\'t pass React elements to ' + 'formatMessage(), pass `.props`.');
  }

  // `id` is a required field of a Message Descriptor.
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;
  var onError = config.onError || defaultErrorHandler;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''), e));
    }
  } else {
    // This prevents warnings from littering the console in development
    // when no `messages` are passed into the <IntlProvider> for the
    // default locale, and a default message is in the source.
    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
      onError(createError('Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '')));
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting the default message for: "' + id + '"', e));
    }
  }

  if (!formattedMessage) {
    onError(createError('Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.')));
  }

  return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  timeZone: null,
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {},

  onError: defaultErrorHandler
};

var IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    __WEBPACK_IMPORTED_MODULE_6_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: __WEBPACK_IMPORTED_MODULE_7_intl_format_cache___default()(Intl.DateTimeFormat),
      getNumberFormat: __WEBPACK_IMPORTED_MODULE_7_intl_format_cache___default()(Intl.NumberFormat),
      getMessageFormat: __WEBPACK_IMPORTED_MODULE_7_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
      getRelativeFormat: __WEBPACK_IMPORTED_MODULE_7_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
      getPluralFormat: __WEBPACK_IMPORTED_MODULE_7_intl_format_cache___default()(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats,
            onError = _config.onError;


        onError(createError('Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.')));

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
  intl: intlShape
};
IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
  intl: intlShape
};
FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
  intl: intlShape
};
FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
  if (false) {
    console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
  }
  return formatMessage({}, { getMessageFormat: __WEBPACK_IMPORTED_MODULE_7_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a) }, descriptor, values);
};

var FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    if (!props.defaultMessage) {
      invariantIntlContext(context);
    }
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref = this.context.intl || {},
          _ref$formatMessage = _ref.formatMessage,
          formatMessage$$1 = _ref$formatMessage === undefined ? defaultFormatMessage : _ref$formatMessage,
          _ref$textComponent = _ref.textComponent,
          Text = _ref$textComponent === undefined ? 'span' : _ref$textComponent;

      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (Object(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage$$1(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
  intl: intlShape
};
FormattedMessage.defaultProps = {
  values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(1416);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schema__ = __webpack_require__(1638);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["A"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["B"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["C"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["D"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["E"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["F"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["G"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["H"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["I"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["J"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["K"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["L"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["M"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["N"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["O"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["P"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["Q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["R"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["S"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["T"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["U"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["V"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["W"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["X"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["Y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["Z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["_0"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["_1"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["_2"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["_3"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["_4"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["_5"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["_6"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["_7"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["_8"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["_9"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["_10"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["_11"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["_12"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["_13"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["_14"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["_15"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["_16"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["_17"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["_18"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["_19"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return __WEBPACK_IMPORTED_MODULE_0__schema__["_20"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1702);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__utils__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_1__utils__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_1__utils__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_1__utils__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_1__utils__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return __WEBPACK_IMPORTED_MODULE_1__utils__["f"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service__ = __webpack_require__(270);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__service__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handler__ = __webpack_require__(748);
/* unused harmony reexport detectHandler */
/* unused harmony reexport hermentHandler */
/* unused harmony reexport debugHandler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__withAnalytics__ = __webpack_require__(2110);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__withAnalytics__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__trackAndInvoke__ = __webpack_require__(2111);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__trackAndInvoke__["a"]; });




//# sourceMappingURL=index.js.map

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return isImage; });
/* harmony export (immutable) */ __webpack_exports__["h"] = canMoveUp;
/* harmony export (immutable) */ __webpack_exports__["g"] = canMoveDown;
/* harmony export (immutable) */ __webpack_exports__["f"] = atTheEndOfDoc;
/* harmony export (immutable) */ __webpack_exports__["d"] = atTheBeginningOfDoc;
/* harmony export (immutable) */ __webpack_exports__["e"] = atTheEndOfBlock;
/* harmony export (immutable) */ __webpack_exports__["c"] = atTheBeginningOfBlock;
/* harmony export (immutable) */ __webpack_exports__["I"] = startPositionOfParent;
/* harmony export (immutable) */ __webpack_exports__["l"] = endPositionOfParent;
/* harmony export (immutable) */ __webpack_exports__["n"] = getCursor;
/* harmony export (immutable) */ __webpack_exports__["y"] = isMarkTypeAllowedInCurrentSelection;
/* harmony export (immutable) */ __webpack_exports__["z"] = isRangeOfType;
/* unused harmony export createSliceWithContent */
/* unused harmony export canJoinDown */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return setNodeSelection; });
/* harmony export (immutable) */ __webpack_exports__["H"] = setTextSelection;
/* unused harmony export setGapCursorSelection */
/* unused harmony export canJoinUp */
/* unused harmony export getAncestorNodesBetween */
/* unused harmony export getGroupsInRange */
/* unused harmony export findAncestorPosition */
/* unused harmony export hasCommonAncestor */
/* unused harmony export liftSelection */
/* unused harmony export liftSiblingNodes */
/* unused harmony export liftAndSelectSiblingNodes */
/* unused harmony export wrapIn */
/* harmony export (immutable) */ __webpack_exports__["J"] = toJSON;
/* unused harmony export stringRepeat */
/* unused harmony export arrayFrom */
/* harmony export (immutable) */ __webpack_exports__["i"] = closestElement;
/* harmony export (immutable) */ __webpack_exports__["D"] = moveLeft;
/* harmony export (immutable) */ __webpack_exports__["b"] = areBlockTypesDisabled;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return isTemporary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return isChromeWithSelectionBug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return isEmptyNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return isTableCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return isElementInTableCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return isLastItemMediaGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return isInListItem; });
/* unused harmony export hasOpenEnd */
/* harmony export (immutable) */ __webpack_exports__["m"] = filterChildrenBetween;
/* harmony export (immutable) */ __webpack_exports__["k"] = dedupe;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return isTextSelection; });
/* harmony export (immutable) */ __webpack_exports__["j"] = compose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_commands__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_commands___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_commands__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_transform__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_transform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prosemirror_transform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keymaps__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_editor_json_transformer__ = __webpack_require__(2002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_fake_text_cursor_cursor__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_gap_cursor_selection__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__document__ = __webpack_require__(411);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_10__document__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_10__document__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_10__document__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__action__ = __webpack_require__(2112);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_11__action__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_11__action__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__step__ = __webpack_require__(2355);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_12__step__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mark__ = __webpack_require__(278);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_13__mark__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__filter__ = __webpack_require__(797);
/* unused harmony reexport filterContentByType */















function validateNode(node) {
    return false;
}
function isMarkTypeCompatibleWithMark(markType, mark) {
    return !mark.type.excludes(markType) && !markType.excludes(mark.type);
}
function isMarkTypeAllowedInNode(markType, state) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_commands__["toggleMark"])(markType)(state);
}
function closest(node, s) {
    var el = node;
    if (!el) {
        return null;
    }
    if (!document.documentElement || !document.documentElement.contains(el)) {
        return null;
    }
    var matches = el.matches ? 'matches' : 'msMatchesSelector';
    do {
        if (el[matches](s)) {
            return el;
        }
        el = (el.parentElement || el.parentNode);
    } while (el !== null && el.nodeType === 1);
    return null;
}
var isImage = function (fileType) {
    return !!fileType && fileType.indexOf('image/') > -1;
};
function canMoveUp(state) {
    var selection = state.selection, doc = state.doc;
    /**
     * If there's a media element on the selection,
     * add text blocks with arrow navigation.
     * Also, the selection could be media | mediaGroup.
     */
    if (selection instanceof __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["NodeSelection"]) {
        if (selection.node.type.name === 'media') {
            /** Weird way of checking if the previous element is a paragraph */
            var mediaAncestorNode = doc.nodeAt(selection.anchor - 3);
            return !!(mediaAncestorNode && mediaAncestorNode.type.name === 'paragraph');
        }
        else if (selection.node.type.name === 'mediaGroup') {
            var mediaGroupAncestorNode = selection.$anchor.nodeBefore;
            return !!(mediaGroupAncestorNode &&
                mediaGroupAncestorNode.type.name === 'paragraph');
        }
    }
    if (selection instanceof __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["TextSelection"]) {
        if (!selection.empty) {
            return true;
        }
    }
    return !atTheBeginningOfDoc(state);
}
function canMoveDown(state) {
    var selection = state.selection, doc = state.doc;
    /**
     * If there's a media element on the selection,
     * add text blocks with arrow navigation.
     * Also, the selection could be media | mediaGroup.
     */
    if (selection instanceof __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["NodeSelection"]) {
        if (selection.node.type.name === 'media') {
            var nodeAfter = doc.nodeAt(selection.$head.after());
            return !!(nodeAfter && nodeAfter.type.name === 'paragraph');
        }
        else if (selection.node.type.name === 'mediaGroup') {
            return !(selection.$head.parentOffset === selection.$anchor.parent.content.size);
        }
    }
    if (selection instanceof __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["TextSelection"]) {
        if (!selection.empty) {
            return true;
        }
    }
    return !atTheEndOfDoc(state);
}
function atTheEndOfDoc(state) {
    var selection = state.selection, doc = state.doc;
    return doc.nodeSize - selection.$to.pos - 2 === selection.$to.depth;
}
function atTheBeginningOfDoc(state) {
    var selection = state.selection;
    return selection.$from.pos === selection.$from.depth;
}
function atTheEndOfBlock(state) {
    var selection = state.selection;
    var $to = selection.$to;
    if (selection instanceof __WEBPACK_IMPORTED_MODULE_9__plugins_gap_cursor_selection__["a" /* GapCursorSelection */]) {
        return false;
    }
    if (selection instanceof __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["NodeSelection"] && selection.node.isBlock) {
        return true;
    }
    return endPositionOfParent($to) === $to.pos + 1;
}
function atTheBeginningOfBlock(state) {
    var selection = state.selection;
    var $from = selection.$from;
    if (selection instanceof __WEBPACK_IMPORTED_MODULE_9__plugins_gap_cursor_selection__["a" /* GapCursorSelection */]) {
        return false;
    }
    if (selection instanceof __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["NodeSelection"] && selection.node.isBlock) {
        return true;
    }
    return startPositionOfParent($from) === $from.pos;
}
function startPositionOfParent(resolvedPos) {
    return resolvedPos.start(resolvedPos.depth);
}
function endPositionOfParent(resolvedPos) {
    return resolvedPos.end(resolvedPos.depth) + 1;
}
function getCursor(selection) {
    return selection.$cursor || undefined;
}
/**
 * Check if a mark is allowed at the current selection / cursor based on a given state.
 * This method looks at both the currently active marks on the transaction, as well as
 * the node and marks at the current selection to determine if the given mark type is
 * allowed.
 */
function isMarkTypeAllowedInCurrentSelection(markType, state) {
    if (state.selection instanceof __WEBPACK_IMPORTED_MODULE_7__plugins_fake_text_cursor_cursor__["a" /* FakeTextCursorSelection */]) {
        return true;
    }
    if (!isMarkTypeAllowedInNode(markType, state)) {
        return false;
    }
    var _a = state.selection, empty = _a.empty, $cursor = _a.$cursor, ranges = _a.ranges;
    if (empty && !$cursor) {
        return false;
    }
    var isCompatibleMarkType = function (mark) {
        return isMarkTypeCompatibleWithMark(markType, mark);
    };
    // Handle any new marks in the current transaction
    if (state.tr.storedMarks &&
        !state.tr.storedMarks.every(isCompatibleMarkType)) {
        return false;
    }
    if ($cursor) {
        return $cursor.marks().every(isCompatibleMarkType);
    }
    // Check every node in a selection - ensuring that it is compatible with the current mark type
    return ranges.every(function (_a) {
        var $from = _a.$from, $to = _a.$to;
        var allowedInActiveMarks = $from.depth === 0 ? state.doc.marks.every(isCompatibleMarkType) : true;
        state.doc.nodesBetween($from.pos, $to.pos, function (node) {
            allowedInActiveMarks =
                allowedInActiveMarks && node.marks.every(isCompatibleMarkType);
        });
        return allowedInActiveMarks;
    });
}
/**
 * Step through block-nodes between $from and $to and returns false if a node is
 * found that isn't of the specified type
 */
function isRangeOfType(doc, $from, $to, nodeType) {
    return (getAncestorNodesBetween(doc, $from, $to).filter(function (node) { return node.type !== nodeType; }).length === 0);
}
function createSliceWithContent(content, state) {
    return new __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__["Slice"](__WEBPACK_IMPORTED_MODULE_2_prosemirror_model__["Fragment"].from(state.schema.text(content)), 0, 0);
}
/**
 * Determines if content inside a selection can be joined with the next block.
 * We need this check since the built-in method for "joinDown" will join a orderedList with bulletList.
 */
function canJoinDown(selection, doc, nodeType) {
    var res = doc.resolve(selection.$to.after(findAncestorPosition(doc, selection.$to).depth));
    return res.nodeAfter && res.nodeAfter.type === nodeType;
}
var setNodeSelection = function (view, pos) {
    var state = view.state, dispatch = view.dispatch;
    if (!isFinite(pos)) {
        return;
    }
    var tr = state.tr.setSelection(__WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["NodeSelection"].create(state.doc, pos));
    dispatch(tr);
};
function setTextSelection(view, anchor, head) {
    var state = view.state;
    var tr = state.tr.setSelection(__WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["TextSelection"].create(state.doc, anchor, head));
    view.dispatch(tr);
}
function setGapCursorSelection(view, pos, side) {
    var state = view.state;
    view.dispatch(state.tr.setSelection(new __WEBPACK_IMPORTED_MODULE_9__plugins_gap_cursor_selection__["a" /* GapCursorSelection */](state.doc.resolve(pos), side)));
}
/**
 * Determines if content inside a selection can be joined with the previous block.
 * We need this check since the built-in method for "joinUp" will join a orderedList with bulletList.
 */
function canJoinUp(selection, doc, nodeType) {
    var res = doc.resolve(selection.$from.before(findAncestorPosition(doc, selection.$from).depth));
    return res.nodeBefore && res.nodeBefore.type === nodeType;
}
/**
 * Returns all top-level ancestor-nodes between $from and $to
 */
function getAncestorNodesBetween(doc, $from, $to) {
    var nodes = Array();
    var maxDepth = findAncestorPosition(doc, $from).depth;
    var current = doc.resolve($from.start(maxDepth));
    while (current.pos <= $to.start($to.depth)) {
        var depth = Math.min(current.depth, maxDepth);
        var node = current.node(depth);
        if (node) {
            nodes.push(node);
        }
        if (depth === 0) {
            break;
        }
        var next = doc.resolve(current.after(depth));
        if (next.start(depth) >= doc.nodeSize - 2) {
            break;
        }
        if (next.depth !== current.depth) {
            next = doc.resolve(next.pos + 2);
        }
        if (next.depth) {
            current = doc.resolve(next.start(next.depth));
        }
        else {
            current = doc.resolve(next.end(next.depth));
        }
    }
    return nodes;
}
/**
 * Finds all "selection-groups" within a range. A selection group is based on ancestors.
 *
 * Example:
 * Given the following document and selection ({<} = start of selection and {>} = end)
 *  doc
 *    blockquote
 *      ul
 *        li
 *        li{<}
 *        li
 *     p
 *     p{>}
 *
 * The output will be two selection-groups. One within the ul and one with the two paragraphs.
 */
function getGroupsInRange(doc, $from, $to, isNodeValid) {
    if (isNodeValid === void 0) { isNodeValid = validateNode; }
    var groups = Array();
    var commonAncestor = hasCommonAncestor(doc, $from, $to);
    var fromAncestor = findAncestorPosition(doc, $from);
    if (commonAncestor ||
        (fromAncestor.depth === 1 && isNodeValid($from.node(1)))) {
        groups.push({ $from: $from, $to: $to });
    }
    else {
        var current = $from;
        while (current.pos < $to.pos) {
            var ancestorPos = findAncestorPosition(doc, current);
            while (ancestorPos.depth > 1) {
                ancestorPos = findAncestorPosition(doc, ancestorPos);
            }
            var endPos = doc.resolve(Math.min(
            // should not be smaller then start position in case of an empty paragraph for example.
            Math.max(ancestorPos.start(ancestorPos.depth), ancestorPos.end(ancestorPos.depth) - 3), $to.pos));
            groups.push({
                $from: current,
                $to: endPos,
            });
            current = doc.resolve(Math.min(endPos.after(1) + 1, doc.nodeSize - 2));
        }
    }
    return groups;
}
/**
 * Traverse the document until an "ancestor" is found. Any nestable block can be an ancestor.
 */
function findAncestorPosition(doc, pos) {
    var nestableBlocks = ['blockquote', 'bulletList', 'orderedList'];
    if (pos.depth === 1) {
        return pos;
    }
    var node = pos.node(pos.depth);
    var newPos = pos;
    while (pos.depth >= 1) {
        pos = doc.resolve(pos.before(pos.depth));
        node = pos.node(pos.depth);
        if (node && nestableBlocks.indexOf(node.type.name) !== -1) {
            newPos = pos;
        }
    }
    return newPos;
}
/**
 * Determine if two positions have a common ancestor.
 */
function hasCommonAncestor(doc, $from, $to) {
    var current;
    var target;
    if ($from.depth > $to.depth) {
        current = findAncestorPosition(doc, $from);
        target = findAncestorPosition(doc, $to);
    }
    else {
        current = findAncestorPosition(doc, $to);
        target = findAncestorPosition(doc, $from);
    }
    while (current.depth > target.depth && current.depth > 1) {
        current = findAncestorPosition(doc, current);
    }
    return current.node(current.depth) === target.node(target.depth);
}
/**
 * Takes a selection $from and $to and lift all text nodes from their parents to document-level
 */
function liftSelection(tr, doc, $from, $to) {
    var startPos = $from.start($from.depth);
    var endPos = $to.end($to.depth);
    var target = Math.max(0, findAncestorPosition(doc, $from).depth - 1);
    tr.doc.nodesBetween(startPos, endPos, function (node, pos) {
        if (node.isText || // Text node
            (node.isTextblock && !node.textContent) // Empty paragraph
        ) {
            var res = tr.doc.resolve(tr.mapping.map(pos));
            var sel = new __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["NodeSelection"](res);
            var range = sel.$from.blockRange(sel.$to);
            if (Object(__WEBPACK_IMPORTED_MODULE_4_prosemirror_transform__["liftTarget"])(range) !== undefined) {
                tr.lift(range, target);
            }
        }
    });
    startPos = tr.mapping.map(startPos);
    endPos = tr.mapping.map(endPos);
    endPos = tr.doc.resolve(endPos).end(tr.doc.resolve(endPos).depth); // We want to select the entire node
    tr.setSelection(new __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["TextSelection"](tr.doc.resolve(startPos), tr.doc.resolve(endPos)));
    return {
        tr: tr,
        $from: tr.doc.resolve(startPos),
        $to: tr.doc.resolve(endPos),
    };
}
/**
 * Lift nodes in block to one level above.
 */
function liftSiblingNodes(view) {
    var tr = view.state.tr;
    var _a = view.state.selection, $from = _a.$from, $to = _a.$to;
    var blockStart = tr.doc.resolve($from.start($from.depth - 1));
    var blockEnd = tr.doc.resolve($to.end($to.depth - 1));
    var range = blockStart.blockRange(blockEnd);
    view.dispatch(tr.lift(range, blockStart.depth - 1));
}
/**
 * Lift sibling nodes to document-level and select them.
 */
function liftAndSelectSiblingNodes(view) {
    var tr = view.state.tr;
    var _a = view.state.selection, $from = _a.$from, $to = _a.$to;
    var blockStart = tr.doc.resolve($from.start($from.depth - 1));
    var blockEnd = tr.doc.resolve($to.end($to.depth - 1));
    // TODO: [ts30] handle void and null properly
    var range = blockStart.blockRange(blockEnd);
    tr.setSelection(new __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["TextSelection"](blockStart, blockEnd));
    tr.lift(range, blockStart.depth - 1);
    return tr;
}
function wrapIn(nodeType, tr, $from, $to) {
    var range = $from.blockRange($to);
    var wrapping = range && Object(__WEBPACK_IMPORTED_MODULE_4_prosemirror_transform__["findWrapping"])(range, nodeType);
    if (wrapping) {
        tr = tr.wrap(range, wrapping).scrollIntoView();
    }
    return tr;
}
var transformer = new __WEBPACK_IMPORTED_MODULE_6__atlaskit_editor_json_transformer__["a" /* JSONTransformer */]();
function toJSON(node) {
    return transformer.encode(node);
}
/**
 * Repeating string for multiple times
 */
function stringRepeat(text, length) {
    var result = '';
    for (var x = 0; x < length; x++) {
        result += text;
    }
    return result;
}
/**
 * A replacement for `Array.from` until it becomes widely implemented.
 */
function arrayFrom(obj) {
    return Array.prototype.slice.call(obj);
}
/**
 * Replacement for Element.closest, until it becomes widely implemented
 * Returns the ancestor element of a particular type if exists or null
 */
function closestElement(node, s) {
    return closest(node, s);
}
function moveLeft(view) {
    var event = new CustomEvent('keydown', {
        bubbles: true,
        cancelable: true,
    });
    event.keyCode = __WEBPACK_IMPORTED_MODULE_5__keymaps__["a" /* LEFT */];
    view.dispatchEvent(event);
}
/**
 * Function will create a list of wrapper blocks present in a selection.
 */
function getSelectedWrapperNodes(state) {
    var nodes = [];
    if (state.selection) {
        var _a = state.selection, $from = _a.$from, $to = _a.$to;
        var _b = state.schema.nodes, blockquote_1 = _b.blockquote, panel_1 = _b.panel, orderedList_1 = _b.orderedList, bulletList_1 = _b.bulletList, listItem_1 = _b.listItem, codeBlock_1 = _b.codeBlock;
        state.doc.nodesBetween($from.pos, $to.pos, function (node, pos) {
            if ((node.isBlock &&
                [blockquote_1, panel_1, orderedList_1, bulletList_1, listItem_1].indexOf(node.type) >= 0) ||
                node.type === codeBlock_1) {
                nodes.push(node.type);
            }
        });
    }
    return nodes;
}
/**
 * Function will check if changing block types: Paragraph, Heading is enabled.
 */
function areBlockTypesDisabled(state) {
    var nodesTypes = getSelectedWrapperNodes(state);
    var panel = state.schema.nodes.panel;
    return nodesTypes.filter(function (type) { return type !== panel; }).length > 0;
}
var isTemporary = function (id) {
    return id.indexOf('temporary:') === 0;
};
// @see: https://github.com/ProseMirror/prosemirror/issues/710
// @see: https://bugs.chromium.org/p/chromium/issues/detail?id=740085
// Chrome >= 58
var isChromeWithSelectionBug = parseInt((navigator.userAgent.match(/Chrome\/(\d{2})/) || [])[1], 10) >= 58;
var isEmptyNode = function (schema) {
    var _a = schema.nodes, doc = _a.doc, paragraph = _a.paragraph, codeBlock = _a.codeBlock, blockquote = _a.blockquote, panel = _a.panel, heading = _a.heading, listItem = _a.listItem, bulletList = _a.bulletList, orderedList = _a.orderedList, taskList = _a.taskList, taskItem = _a.taskItem, decisionList = _a.decisionList, decisionItem = _a.decisionItem, media = _a.media, mediaGroup = _a.mediaGroup, mediaSingle = _a.mediaSingle;
    var innerIsEmptyNode = function (node) {
        switch (node.type) {
            case media:
            case mediaGroup:
            case mediaSingle:
                return false;
            case paragraph:
            case codeBlock:
            case heading:
            case taskItem:
            case decisionItem:
                return node.content.size === 0;
            case blockquote:
            case panel:
            case listItem:
                return (node.content.size === 2 && innerIsEmptyNode(node.content.firstChild));
            case bulletList:
            case orderedList:
                return (node.content.size === 4 && innerIsEmptyNode(node.content.firstChild));
            case taskList:
            case decisionList:
                return (node.content.size === 2 && innerIsEmptyNode(node.content.firstChild));
            case doc:
                var isEmpty_1 = true;
                node.content.forEach(function (child) {
                    isEmpty_1 = isEmpty_1 && innerIsEmptyNode(child);
                });
                return isEmpty_1;
            default:
                throw new Error(node.type.name + " node is not implemented");
        }
    };
    return innerIsEmptyNode;
};
var isTableCell = function (state) {
    var _a = state.schema.nodes, tableCell = _a.tableCell, tableHeader = _a.tableHeader;
    return Object(__WEBPACK_IMPORTED_MODULE_8_prosemirror_utils__["hasParentNodeOfType"])([tableCell, tableHeader])(state.selection);
};
var isElementInTableCell = function (element) {
    return closest(element, 'td') || closest(element, 'th');
};
var isLastItemMediaGroup = function (node) {
    var content = node.content;
    return !!content.lastChild && content.lastChild.type.name === 'mediaGroup';
};
var isInListItem = function (state) {
    return Object(__WEBPACK_IMPORTED_MODULE_8_prosemirror_utils__["hasParentNodeOfType"])(state.schema.nodes.listItem)(state.selection);
};
var hasOpenEnd = function (slice) {
    return slice.openStart > 0 || slice.openEnd > 0;
};
function filterChildrenBetween(doc, from, to, predicate) {
    var results = [];
    doc.nodesBetween(from, to, function (node, pos, parent) {
        if (predicate(node, pos, parent)) {
            results.push({ node: node, pos: pos });
        }
    });
    return results;
}
function dedupe(list, iteratee) {
    if (list === void 0) { list = []; }
    var transformed = iteratee ? list.map(iteratee) : list;
    return transformed
        .map(function (item, index, list) { return (list.indexOf(item) === index ? item : null); })
        .reduce(function (acc, item, index) { return (!!item ? acc.concat(list[index]) : acc); }, []);
}
var isTextSelection = function (selection) { return selection instanceof __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["TextSelection"]; };
/**
 * Compose 1 to n functions.
 * @param func first function
 * @param funcs additional functions
 */
function compose(func) {
    var funcs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        funcs[_i - 1] = arguments[_i];
    }
    var allFuncs = __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"]([func], funcs);
    return function composed(raw) {
        return allFuncs.reduceRight(function (memo, func) { return func(memo); }, raw);
    };
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(326);
var v4 = __webpack_require__(549);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var OrderedMap = _interopDefault(__webpack_require__(1646));

function findDiffStart(a, b, pos) {
  for (var i = 0;; i++) {
    if (i == a.childCount || i == b.childCount)
      { return a.childCount == b.childCount ? null : pos }

    var childA = a.child(i), childB = b.child(i);
    if (childA == childB) { pos += childA.nodeSize; continue }

    if (!childA.sameMarkup(childB)) { return pos }

    if (childA.isText && childA.text != childB.text) {
      for (var j = 0; childA.text[j] == childB.text[j]; j++)
        { pos++; }
      return pos
    }
    if (childA.content.size || childB.content.size) {
      var inner = findDiffStart(childA.content, childB.content, pos + 1);
      if (inner != null) { return inner }
    }
    pos += childA.nodeSize;
  }
}

function findDiffEnd(a, b, posA, posB) {
  for (var iA = a.childCount, iB = b.childCount;;) {
    if (iA == 0 || iB == 0)
      { return iA == iB ? null : {a: posA, b: posB} }

    var childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
    if (childA == childB) {
      posA -= size; posB -= size;
      continue
    }

    if (!childA.sameMarkup(childB)) { return {a: posA, b: posB} }

    if (childA.isText && childA.text != childB.text) {
      var same = 0, minSize = Math.min(childA.text.length, childB.text.length);
      while (same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]) {
        same++; posA--; posB--;
      }
      return {a: posA, b: posB}
    }
    if (childA.content.size || childB.content.size) {
      var inner = findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
      if (inner) { return inner }
    }
    posA -= size; posB -= size;
  }
}

// ::- A fragment represents a node's collection of child nodes.
//
// Like nodes, fragments are persistent data structures, and you
// should not mutate them or their content. Rather, you create new
// instances whenever needed. The API tries to make this easy.
var Fragment = function Fragment(content, size) {
  var this$1 = this;

  this.content = content;
  // :: number
  // The size of the fragment, which is the total of the size of its
  // content nodes.
  this.size = size || 0;
  if (size == null) { for (var i = 0; i < content.length; i++)
    { this$1.size += content[i].nodeSize; } }
};

var prototypeAccessors$1 = { firstChild: {},lastChild: {},childCount: {} };

// :: (number, number, (node: Node, start: number, parent: Node, index: number) → ?bool, ?number)
// Invoke a callback for all descendant nodes between the given two
// positions (relative to start of this fragment). Doesn't descend
// into a node when the callback returns `false`.
Fragment.prototype.nodesBetween = function nodesBetween (from, to, f, nodeStart, parent) {
    var this$1 = this;
    if ( nodeStart === void 0 ) nodeStart = 0;

  for (var i = 0, pos = 0; pos < to; i++) {
    var child = this$1.content[i], end = pos + child.nodeSize;
    if (end > from && f(child, nodeStart + pos, parent, i) !== false && child.content.size) {
      var start = pos + 1;
      child.nodesBetween(Math.max(0, from - start),
                         Math.min(child.content.size, to - start),
                         f, nodeStart + start);
    }
    pos = end;
  }
};

// :: ((node: Node, pos: number, parent: Node) → ?bool)
// Call the given callback for every descendant node. The callback
// may return `false` to prevent traversal of a given node's children.
Fragment.prototype.descendants = function descendants (f) {
  this.nodesBetween(0, this.size, f);
};

// : (number, number, ?string, ?string) → string
Fragment.prototype.textBetween = function textBetween (from, to, blockSeparator, leafText) {
  var text = "", separated = true;
  this.nodesBetween(from, to, function (node, pos) {
    if (node.isText) {
      text += node.text.slice(Math.max(from, pos) - pos, to - pos);
      separated = !blockSeparator;
    } else if (node.isLeaf && leafText) {
      text += leafText;
      separated = !blockSeparator;
    } else if (!separated && node.isBlock) {
      text += blockSeparator;
      separated = true;
    }
  }, 0);
  return text
};

// :: (Fragment) → Fragment
// Create a new fragment containing the combined content of this
// fragment and the other.
Fragment.prototype.append = function append (other) {
  if (!other.size) { return this }
  if (!this.size) { return other }
  var last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
  if (last.isText && last.sameMarkup(first)) {
    content[content.length - 1] = last.withText(last.text + first.text);
    i = 1;
  }
  for (; i < other.content.length; i++) { content.push(other.content[i]); }
  return new Fragment(content, this.size + other.size)
};

// :: (number, ?number) → Fragment
// Cut out the sub-fragment between the two given positions.
Fragment.prototype.cut = function cut (from, to) {
    var this$1 = this;

  if (to == null) { to = this.size; }
  if (from == 0 && to == this.size) { return this }
  var result = [], size = 0;
  if (to > from) { for (var i = 0, pos = 0; pos < to; i++) {
    var child = this$1.content[i], end = pos + child.nodeSize;
    if (end > from) {
      if (pos < from || end > to) {
        if (child.isText)
          { child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos)); }
        else
          { child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1)); }
      }
      result.push(child);
      size += child.nodeSize;
    }
    pos = end;
  } }
  return new Fragment(result, size)
};

Fragment.prototype.cutByIndex = function cutByIndex (from, to) {
  if (from == to) { return Fragment.empty }
  if (from == 0 && to == this.content.length) { return this }
  return new Fragment(this.content.slice(from, to))
};

// :: (number, Node) → Fragment
// Create a new fragment in which the node at the given index is
// replaced by the given node.
Fragment.prototype.replaceChild = function replaceChild (index, node) {
  var current = this.content[index];
  if (current == node) { return this }
  var copy = this.content.slice();
  var size = this.size + node.nodeSize - current.nodeSize;
  copy[index] = node;
  return new Fragment(copy, size)
};

// : (Node) → Fragment
// Create a new fragment by prepending the given node to this
// fragment.
Fragment.prototype.addToStart = function addToStart (node) {
  return new Fragment([node].concat(this.content), this.size + node.nodeSize)
};

// : (Node) → Fragment
// Create a new fragment by appending the given node to this
// fragment.
Fragment.prototype.addToEnd = function addToEnd (node) {
  return new Fragment(this.content.concat(node), this.size + node.nodeSize)
};

// :: (Fragment) → bool
// Compare this fragment to another one.
Fragment.prototype.eq = function eq (other) {
    var this$1 = this;

  if (this.content.length != other.content.length) { return false }
  for (var i = 0; i < this.content.length; i++)
    { if (!this$1.content[i].eq(other.content[i])) { return false } }
  return true
};

// :: ?Node
// The first child of the fragment, or `null` if it is empty.
prototypeAccessors$1.firstChild.get = function () { return this.content.length ? this.content[0] : null };

// :: ?Node
// The last child of the fragment, or `null` if it is empty.
prototypeAccessors$1.lastChild.get = function () { return this.content.length ? this.content[this.content.length - 1] : null };

// :: number
// The number of child nodes in this fragment.
prototypeAccessors$1.childCount.get = function () { return this.content.length };

// :: (number) → Node
// Get the child node at the given index. Raise an error when the
// index is out of range.
Fragment.prototype.child = function child (index) {
  var found = this.content[index];
  if (!found) { throw new RangeError("Index " + index + " out of range for " + this) }
  return found
};

// :: (number) → ?Node
// Get the child node at the given index, if it exists.
Fragment.prototype.maybeChild = function maybeChild (index) {
  return this.content[index]
};

// :: ((node: Node, offset: number, index: number))
// Call `f` for every child node, passing the node, its offset
// into this parent node, and its index.
Fragment.prototype.forEach = function forEach (f) {
    var this$1 = this;

  for (var i = 0, p = 0; i < this.content.length; i++) {
    var child = this$1.content[i];
    f(child, p, i);
    p += child.nodeSize;
  }
};

// :: (Fragment) → ?number
// Find the first position at which this fragment and another
// fragment differ, or `null` if they are the same.
Fragment.prototype.findDiffStart = function findDiffStart$1 (other, pos) {
    if ( pos === void 0 ) pos = 0;

  return findDiffStart(this, other, pos)
};

// :: (Fragment) → ?{a: number, b: number}
// Find the first position, searching from the end, at which this
// fragment and the given fragment differ, or `null` if they are the
// same. Since this position will not be the same in both nodes, an
// object with two separate positions is returned.
Fragment.prototype.findDiffEnd = function findDiffEnd$1 (other, pos, otherPos) {
    if ( pos === void 0 ) pos = this.size;
    if ( otherPos === void 0 ) otherPos = other.size;

  return findDiffEnd(this, other, pos, otherPos)
};

// : (number, ?number) → {index: number, offset: number}
// Find the index and inner offset corresponding to a given relative
// position in this fragment. The result object will be reused
// (overwritten) the next time the function is called. (Not public.)
Fragment.prototype.findIndex = function findIndex (pos, round) {
    var this$1 = this;
    if ( round === void 0 ) round = -1;

  if (pos == 0) { return retIndex(0, pos) }
  if (pos == this.size) { return retIndex(this.content.length, pos) }
  if (pos > this.size || pos < 0) { throw new RangeError(("Position " + pos + " outside of fragment (" + (this) + ")")) }
  for (var i = 0, curPos = 0;; i++) {
    var cur = this$1.child(i), end = curPos + cur.nodeSize;
    if (end >= pos) {
      if (end == pos || round > 0) { return retIndex(i + 1, end) }
      return retIndex(i, curPos)
    }
    curPos = end;
  }
};

// :: () → string
// Return a debugging string that describes this fragment.
Fragment.prototype.toString = function toString () { return "<" + this.toStringInner() + ">" };

Fragment.prototype.toStringInner = function toStringInner () { return this.content.join(", ") };

// :: () → ?Object
// Create a JSON-serializeable representation of this fragment.
Fragment.prototype.toJSON = function toJSON () {
  return this.content.length ? this.content.map(function (n) { return n.toJSON(); }) : null
};

// :: (Schema, ?Object) → Fragment
// Deserialize a fragment from its JSON representation.
Fragment.fromJSON = function fromJSON (schema, value) {
  if (!value) { return Fragment.empty }
  if (!Array.isArray(value)) { throw new RangeError("Invalid input for Fragment.fromJSON") }
  return new Fragment(value.map(schema.nodeFromJSON))
};

// :: ([Node]) → Fragment
// Build a fragment from an array of nodes. Ensures that adjacent
// text nodes with the same marks are joined together.
Fragment.fromArray = function fromArray (array) {
  if (!array.length) { return Fragment.empty }
  var joined, size = 0;
  for (var i = 0; i < array.length; i++) {
    var node = array[i];
    size += node.nodeSize;
    if (i && node.isText && array[i - 1].sameMarkup(node)) {
      if (!joined) { joined = array.slice(0, i); }
      joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
    } else if (joined) {
      joined.push(node);
    }
  }
  return new Fragment(joined || array, size)
};

// :: (?union<Fragment, Node, [Node]>) → Fragment
// Create a fragment from something that can be interpreted as a set
// of nodes. For `null`, it returns the empty fragment. For a
// fragment, the fragment itself. For a node or array of nodes, a
// fragment containing those nodes.
Fragment.from = function from (nodes) {
  if (!nodes) { return Fragment.empty }
  if (nodes instanceof Fragment) { return nodes }
  if (Array.isArray(nodes)) { return this.fromArray(nodes) }
  return new Fragment([nodes], nodes.nodeSize)
};

Object.defineProperties( Fragment.prototype, prototypeAccessors$1 );

var found = {index: 0, offset: 0};
function retIndex(index, offset) {
  found.index = index;
  found.offset = offset;
  return found
}

// :: Fragment
// An empty fragment. Intended to be reused whenever a node doesn't
// contain anything (rather than allocating a new empty fragment for
// each leaf node).
Fragment.empty = new Fragment([], 0);

function compareDeep(a, b) {
  if (a === b) { return true }
  if (!(a && typeof a == "object") ||
      !(b && typeof b == "object")) { return false }
  var array = Array.isArray(a);
  if (Array.isArray(b) != array) { return false }
  if (array) {
    if (a.length != b.length) { return false }
    for (var i = 0; i < a.length; i++) { if (!compareDeep(a[i], b[i])) { return false } }
  } else {
    for (var p in a) { if (!(p in b) || !compareDeep(a[p], b[p])) { return false } }
    for (var p$1 in b) { if (!(p$1 in a)) { return false } }
  }
  return true
}

// ::- A mark is a piece of information that can be attached to a node,
// such as it being emphasized, in code font, or a link. It has a type
// and optionally a set of attributes that provide further information
// (such as the target of the link). Marks are created through a
// `Schema`, which controls which types exist and which
// attributes they have.
var Mark = function Mark(type, attrs) {
  // :: MarkType
  // The type of this mark.
  this.type = type;
  // :: Object
  // The attributes associated with this mark.
  this.attrs = attrs;
};

// :: ([Mark]) → [Mark]
// Given a set of marks, create a new set which contains this one as
// well, in the right position. If this mark is already in the set,
// the set itself is returned. If any marks that are set to be
// [exclusive](#model.MarkSpec.excludes) with this mark are present,
// those are replaced by this one.
Mark.prototype.addToSet = function addToSet (set) {
    var this$1 = this;

  var copy, placed = false;
  for (var i = 0; i < set.length; i++) {
    var other = set[i];
    if (this$1.eq(other)) { return set }
    if (this$1.type.excludes(other.type)) {
      if (!copy) { copy = set.slice(0, i); }
    } else if (other.type.excludes(this$1.type)) {
      return set
    } else {
      if (!placed && other.type.rank > this$1.type.rank) {
        if (!copy) { copy = set.slice(0, i); }
        copy.push(this$1);
        placed = true;
      }
      if (copy) { copy.push(other); }
    }
  }
  if (!copy) { copy = set.slice(); }
  if (!placed) { copy.push(this); }
  return copy
};

// :: ([Mark]) → [Mark]
// Remove this mark from the given set, returning a new set. If this
// mark is not in the set, the set itself is returned.
Mark.prototype.removeFromSet = function removeFromSet (set) {
    var this$1 = this;

  for (var i = 0; i < set.length; i++)
    { if (this$1.eq(set[i]))
      { return set.slice(0, i).concat(set.slice(i + 1)) } }
  return set
};

// :: ([Mark]) → bool
// Test whether this mark is in the given set of marks.
Mark.prototype.isInSet = function isInSet (set) {
    var this$1 = this;

  for (var i = 0; i < set.length; i++)
    { if (this$1.eq(set[i])) { return true } }
  return false
};

// :: (Mark) → bool
// Test whether this mark has the same type and attributes as
// another mark.
Mark.prototype.eq = function eq (other) {
  return this == other ||
    (this.type == other.type && compareDeep(this.attrs, other.attrs))
};

// :: () → Object
// Convert this mark to a JSON-serializeable representation.
Mark.prototype.toJSON = function toJSON () {
    var this$1 = this;

  var obj = {type: this.type.name};
  for (var _ in this$1.attrs) {
    obj.attrs = this$1.attrs;
    break
  }
  return obj
};

// :: (Schema, Object) → Mark
Mark.fromJSON = function fromJSON (schema, json) {
  if (!json) { throw new RangeError("Invalid input for Mark.fromJSON") }
  var type = schema.marks[json.type];
  if (!type) { throw new RangeError(("There is no mark type " + (json.type) + " in this schema")) }
  return type.create(json.attrs)
};

// :: ([Mark], [Mark]) → bool
// Test whether two sets of marks are identical.
Mark.sameSet = function sameSet (a, b) {
  if (a == b) { return true }
  if (a.length != b.length) { return false }
  for (var i = 0; i < a.length; i++)
    { if (!a[i].eq(b[i])) { return false } }
  return true
};

// :: (?union<Mark, [Mark]>) → [Mark]
// Create a properly sorted mark set from null, a single mark, or an
// unsorted array of marks.
Mark.setFrom = function setFrom (marks) {
  if (!marks || marks.length == 0) { return Mark.none }
  if (marks instanceof Mark) { return [marks] }
  var copy = marks.slice();
  copy.sort(function (a, b) { return a.type.rank - b.type.rank; });
  return copy
};

// :: [Mark] The empty set of marks.
Mark.none = [];

// ReplaceError:: class extends Error
// Error type raised by [`Node.replace`](#model.Node.replace) when
// given an invalid replacement.

function ReplaceError(message) {
  var err = Error.call(this, message);
  err.__proto__ = ReplaceError.prototype;
  return err
}

ReplaceError.prototype = Object.create(Error.prototype);
ReplaceError.prototype.constructor = ReplaceError;
ReplaceError.prototype.name = "ReplaceError";

// ::- A slice represents a piece cut out of a larger document. It
// stores not only a fragment, but also the depth up to which nodes on
// both side are ‘open’ (cut through).
var Slice = function Slice(content, openStart, openEnd) {
  // :: Fragment The slice's content.
  this.content = content;
  // :: number The open depth at the start.
  this.openStart = openStart;
  // :: number The open depth at the end.
  this.openEnd = openEnd;
};

var prototypeAccessors$2 = { size: {} };

// :: number
// The size this slice would add when inserted into a document.
prototypeAccessors$2.size.get = function () {
  return this.content.size - this.openStart - this.openEnd
};

Slice.prototype.insertAt = function insertAt (pos, fragment) {
  var content = insertInto(this.content, pos + this.openStart, fragment, null);
  return content && new Slice(content, this.openStart, this.openEnd)
};

Slice.prototype.removeBetween = function removeBetween (from, to) {
  return new Slice(removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd)
};

// :: (Slice) → bool
// Tests whether this slice is equal to another slice.
Slice.prototype.eq = function eq (other) {
  return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd
};

Slice.prototype.toString = function toString () {
  return this.content + "(" + this.openStart + "," + this.openEnd + ")"
};

// :: () → ?Object
// Convert a slice to a JSON-serializable representation.
Slice.prototype.toJSON = function toJSON () {
  if (!this.content.size) { return null }
  var json = {content: this.content.toJSON()};
  if (this.openStart > 0) { json.openStart = this.openStart; }
  if (this.openEnd > 0) { json.openEnd = this.openEnd; }
  return json
};

// :: (Schema, ?Object) → Slice
// Deserialize a slice from its JSON representation.
Slice.fromJSON = function fromJSON (schema, json) {
  if (!json) { return Slice.empty }
  var openStart = json.openStart || 0, openEnd = json.openEnd || 0;
  if (typeof openStart != "number" || typeof openEnd != "number")
    { throw new RangeError("Invalid input for Slice.fromJSON") }
  return new Slice(Fragment.fromJSON(schema, json.content), json.openStart || 0, json.openEnd || 0)
};

// :: (Fragment, ?bool) → Slice
// Create a slice from a fragment by taking the maximum possible
// open value on both side of the fragment.
Slice.maxOpen = function maxOpen (fragment, openIsolating) {
    if ( openIsolating === void 0 ) openIsolating=true;

  var openStart = 0, openEnd = 0;
  for (var n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild) { openStart++; }
  for (var n$1 = fragment.lastChild; n$1 && !n$1.isLeaf && (openIsolating || !n$1.type.spec.isolating); n$1 = n$1.lastChild) { openEnd++; }
  return new Slice(fragment, openStart, openEnd)
};

Object.defineProperties( Slice.prototype, prototypeAccessors$2 );

function removeRange(content, from, to) {
  var ref = content.findIndex(from);
  var index = ref.index;
  var offset = ref.offset;
  var child = content.maybeChild(index);
  var ref$1 = content.findIndex(to);
  var indexTo = ref$1.index;
  var offsetTo = ref$1.offset;
  if (offset == from || child.isText) {
    if (offsetTo != to && !content.child(indexTo).isText) { throw new RangeError("Removing non-flat range") }
    return content.cut(0, from).append(content.cut(to))
  }
  if (index != indexTo) { throw new RangeError("Removing non-flat range") }
  return content.replaceChild(index, child.copy(removeRange(child.content, from - offset - 1, to - offset - 1)))
}

function insertInto(content, dist, insert, parent) {
  var ref = content.findIndex(dist);
  var index = ref.index;
  var offset = ref.offset;
  var child = content.maybeChild(index);
  if (offset == dist || child.isText) {
    if (parent && !parent.canReplace(index, index, insert)) { return null }
    return content.cut(0, dist).append(insert).append(content.cut(dist))
  }
  var inner = insertInto(child.content, dist - offset - 1, insert);
  return inner && content.replaceChild(index, child.copy(inner))
}

// :: Slice
// The empty slice.
Slice.empty = new Slice(Fragment.empty, 0, 0);

function replace($from, $to, slice) {
  if (slice.openStart > $from.depth)
    { throw new ReplaceError("Inserted content deeper than insertion position") }
  if ($from.depth - slice.openStart != $to.depth - slice.openEnd)
    { throw new ReplaceError("Inconsistent open depths") }
  return replaceOuter($from, $to, slice, 0)
}

function replaceOuter($from, $to, slice, depth) {
  var index = $from.index(depth), node = $from.node(depth);
  if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
    var inner = replaceOuter($from, $to, slice, depth + 1);
    return node.copy(node.content.replaceChild(index, inner))
  } else if (!slice.content.size) {
    return close(node, replaceTwoWay($from, $to, depth))
  } else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) { // Simple, flat case
    var parent = $from.parent, content = parent.content;
    return close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)))
  } else {
    var ref = prepareSliceForReplace(slice, $from);
    var start = ref.start;
    var end = ref.end;
    return close(node, replaceThreeWay($from, start, end, $to, depth))
  }
}

function checkJoin(main, sub) {
  if (!sub.type.compatibleContent(main.type))
    { throw new ReplaceError("Cannot join " + sub.type.name + " onto " + main.type.name) }
}

function joinable($before, $after, depth) {
  var node = $before.node(depth);
  checkJoin(node, $after.node(depth));
  return node
}

function addNode(child, target) {
  var last = target.length - 1;
  if (last >= 0 && child.isText && child.sameMarkup(target[last]))
    { target[last] = child.withText(target[last].text + child.text); }
  else
    { target.push(child); }
}

function addRange($start, $end, depth, target) {
  var node = ($end || $start).node(depth);
  var startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
  if ($start) {
    startIndex = $start.index(depth);
    if ($start.depth > depth) {
      startIndex++;
    } else if ($start.textOffset) {
      addNode($start.nodeAfter, target);
      startIndex++;
    }
  }
  for (var i = startIndex; i < endIndex; i++) { addNode(node.child(i), target); }
  if ($end && $end.depth == depth && $end.textOffset)
    { addNode($end.nodeBefore, target); }
}

function close(node, content) {
  if (!node.type.validContent(content))
    { throw new ReplaceError("Invalid content for node " + node.type.name) }
  return node.copy(content)
}

function replaceThreeWay($from, $start, $end, $to, depth) {
  var openStart = $from.depth > depth && joinable($from, $start, depth + 1);
  var openEnd = $to.depth > depth && joinable($end, $to, depth + 1);

  var content = [];
  addRange(null, $from, depth, content);
  if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
    checkJoin(openStart, openEnd);
    addNode(close(openStart, replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
  } else {
    if (openStart)
      { addNode(close(openStart, replaceTwoWay($from, $start, depth + 1)), content); }
    addRange($start, $end, depth, content);
    if (openEnd)
      { addNode(close(openEnd, replaceTwoWay($end, $to, depth + 1)), content); }
  }
  addRange($to, null, depth, content);
  return new Fragment(content)
}

function replaceTwoWay($from, $to, depth) {
  var content = [];
  addRange(null, $from, depth, content);
  if ($from.depth > depth) {
    var type = joinable($from, $to, depth + 1);
    addNode(close(type, replaceTwoWay($from, $to, depth + 1)), content);
  }
  addRange($to, null, depth, content);
  return new Fragment(content)
}

function prepareSliceForReplace(slice, $along) {
  var extra = $along.depth - slice.openStart, parent = $along.node(extra);
  var node = parent.copy(slice.content);
  for (var i = extra - 1; i >= 0; i--)
    { node = $along.node(i).copy(Fragment.from(node)); }
  return {start: node.resolveNoCache(slice.openStart + extra),
          end: node.resolveNoCache(node.content.size - slice.openEnd - extra)}
}

// ::- You can [_resolve_](#model.Node.resolve) a position to get more
// information about it. Objects of this class represent such a
// resolved position, providing various pieces of context information,
// and some helper methods.
//
// Throughout this interface, methods that take an optional `depth`
// parameter will interpret undefined as `this.depth` and negative
// numbers as `this.depth + value`.
var ResolvedPos = function ResolvedPos(pos, path, parentOffset) {
  // :: number The position that was resolved.
  this.pos = pos;
  this.path = path;
  // :: number
  // The number of levels the parent node is from the root. If this
  // position points directly into the root node, it is 0. If it
  // points into a top-level paragraph, 1, and so on.
  this.depth = path.length / 3 - 1;
  // :: number The offset this position has into its parent node.
  this.parentOffset = parentOffset;
};

var prototypeAccessors$3 = { parent: {},doc: {},textOffset: {},nodeAfter: {},nodeBefore: {} };

ResolvedPos.prototype.resolveDepth = function resolveDepth (val) {
  if (val == null) { return this.depth }
  if (val < 0) { return this.depth + val }
  return val
};

// :: Node
// The parent node that the position points into. Note that even if
// a position points into a text node, that node is not considered
// the parent—text nodes are ‘flat’ in this model, and have no content.
prototypeAccessors$3.parent.get = function () { return this.node(this.depth) };

// :: Node
// The root node in which the position was resolved.
prototypeAccessors$3.doc.get = function () { return this.node(0) };

// :: (?number) → Node
// The ancestor node at the given level. `p.node(p.depth)` is the
// same as `p.parent`.
ResolvedPos.prototype.node = function node (depth) { return this.path[this.resolveDepth(depth) * 3] };

// :: (?number) → number
// The index into the ancestor at the given level. If this points at
// the 3rd node in the 2nd paragraph on the top level, for example,
// `p.index(0)` is 2 and `p.index(1)` is 3.
ResolvedPos.prototype.index = function index (depth) { return this.path[this.resolveDepth(depth) * 3 + 1] };

// :: (?number) → number
// The index pointing after this position into the ancestor at the
// given level.
ResolvedPos.prototype.indexAfter = function indexAfter (depth) {
  depth = this.resolveDepth(depth);
  return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1)
};

// :: (?number) → number
// The (absolute) position at the start of the node at the given
// level.
ResolvedPos.prototype.start = function start (depth) {
  depth = this.resolveDepth(depth);
  return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1
};

// :: (?number) → number
// The (absolute) position at the end of the node at the given
// level.
ResolvedPos.prototype.end = function end (depth) {
  depth = this.resolveDepth(depth);
  return this.start(depth) + this.node(depth).content.size
};

// :: (?number) → number
// The (absolute) position directly before the wrapping node at the
// given level, or, when `level` is `this.depth + 1`, the original
// position.
ResolvedPos.prototype.before = function before (depth) {
  depth = this.resolveDepth(depth);
  if (!depth) { throw new RangeError("There is no position before the top-level node") }
  return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1]
};

// :: (?number) → number
// The (absolute) position directly after the wrapping node at the
// given level, or the original position when `level` is `this.depth + 1`.
ResolvedPos.prototype.after = function after (depth) {
  depth = this.resolveDepth(depth);
  if (!depth) { throw new RangeError("There is no position after the top-level node") }
  return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize
};

// :: number
// When this position points into a text node, this returns the
// distance between the position and the start of the text node.
// Will be zero for positions that point between nodes.
prototypeAccessors$3.textOffset.get = function () { return this.pos - this.path[this.path.length - 1] };

// :: ?Node
// Get the node directly after the position, if any. If the position
// points into a text node, only the part of that node after the
// position is returned.
prototypeAccessors$3.nodeAfter.get = function () {
  var parent = this.parent, index = this.index(this.depth);
  if (index == parent.childCount) { return null }
  var dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
  return dOff ? parent.child(index).cut(dOff) : child
};

// :: ?Node
// Get the node directly before the position, if any. If the
// position points into a text node, only the part of that node
// before the position is returned.
prototypeAccessors$3.nodeBefore.get = function () {
  var index = this.index(this.depth);
  var dOff = this.pos - this.path[this.path.length - 1];
  if (dOff) { return this.parent.child(index).cut(0, dOff) }
  return index == 0 ? null : this.parent.child(index - 1)
};

// :: () → [Mark]
// Get the marks at this position, factoring in the surrounding
// marks' [`inclusive`](#model.MarkSpec.inclusive) property. If the
// position is at the start of a non-empty node, the marks of the
// node after it (if any) are returned.
ResolvedPos.prototype.marks = function marks () {
  var parent = this.parent, index = this.index();

  // In an empty parent, return the empty array
  if (parent.content.size == 0) { return Mark.none }

  // When inside a text node, just return the text node's marks
  if (this.textOffset) { return parent.child(index).marks }

  var main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
  // If the `after` flag is true of there is no node before, make
  // the node after this position the main reference.
  if (!main) { var tmp = main; main = other; other = tmp; }

  // Use all marks in the main node, except those that have
  // `inclusive` set to false and are not present in the other node.
  var marks = main.marks;
  for (var i = 0; i < marks.length; i++)
    { if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks)))
      { marks = marks[i--].removeFromSet(marks); } }

  return marks
};

// :: (ResolvedPos) → ?[Mark]
// Get the marks after the current position, if any, except those
// that are non-inclusive and not present at position `$end`. This
// is mostly useful for getting the set of marks to preserve after a
// deletion. Will return `null` if this position is at the end of
// its parent node or its parent node isn't a textblock (in which
// case no marks should be preserved).
ResolvedPos.prototype.marksAcross = function marksAcross ($end) {
  var after = this.parent.maybeChild(this.index());
  if (!after || !after.isInline) { return null }

  var marks = after.marks, next = $end.parent.maybeChild($end.index());
  for (var i = 0; i < marks.length; i++)
    { if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks)))
      { marks = marks[i--].removeFromSet(marks); } }
  return marks
};

// :: (number) → number
// The depth up to which this position and the given (non-resolved)
// position share the same parent nodes.
ResolvedPos.prototype.sharedDepth = function sharedDepth (pos) {
    var this$1 = this;

  for (var depth = this.depth; depth > 0; depth--)
    { if (this$1.start(depth) <= pos && this$1.end(depth) >= pos) { return depth } }
  return 0
};

// :: (?ResolvedPos, ?(Node) → bool) → ?NodeRange
// Returns a range based on the place where this position and the
// given position diverge around block content. If both point into
// the same textblock, for example, a range around that textblock
// will be returned. If they point into different blocks, the range
// around those blocks in their shared ancestor is returned. You can
// pass in an optional predicate that will be called with a parent
// node to see if a range into that parent is acceptable.
ResolvedPos.prototype.blockRange = function blockRange (other, pred) {
    var this$1 = this;
    if ( other === void 0 ) other = this;

  if (other.pos < this.pos) { return other.blockRange(this) }
  for (var d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)
    { if (other.pos <= this$1.end(d) && (!pred || pred(this$1.node(d))))
      { return new NodeRange(this$1, other, d) } }
};

// :: (ResolvedPos) → bool
// Query whether the given position shares the same parent node.
ResolvedPos.prototype.sameParent = function sameParent (other) {
  return this.pos - this.parentOffset == other.pos - other.parentOffset
};

// :: (ResolvedPos) → ResolvedPos
// Return the greater of this and the given position.
ResolvedPos.prototype.max = function max (other) {
  return other.pos > this.pos ? other : this
};

// :: (ResolvedPos) → ResolvedPos
// Return the smaller of this and the given position.
ResolvedPos.prototype.min = function min (other) {
  return other.pos < this.pos ? other : this
};

ResolvedPos.prototype.toString = function toString () {
    var this$1 = this;

  var str = "";
  for (var i = 1; i <= this.depth; i++)
    { str += (str ? "/" : "") + this$1.node(i).type.name + "_" + this$1.index(i - 1); }
  return str + ":" + this.parentOffset
};

ResolvedPos.resolve = function resolve (doc, pos) {
  if (!(pos >= 0 && pos <= doc.content.size)) { throw new RangeError("Position " + pos + " out of range") }
  var path = [];
  var start = 0, parentOffset = pos;
  for (var node = doc;;) {
    var ref = node.content.findIndex(parentOffset);
      var index = ref.index;
      var offset = ref.offset;
    var rem = parentOffset - offset;
    path.push(node, index, start + offset);
    if (!rem) { break }
    node = node.child(index);
    if (node.isText) { break }
    parentOffset = rem - 1;
    start += offset + 1;
  }
  return new ResolvedPos(pos, path, parentOffset)
};

ResolvedPos.resolveCached = function resolveCached (doc, pos) {
  for (var i = 0; i < resolveCache.length; i++) {
    var cached = resolveCache[i];
    if (cached.pos == pos && cached.doc == doc) { return cached }
  }
  var result = resolveCache[resolveCachePos] = ResolvedPos.resolve(doc, pos);
  resolveCachePos = (resolveCachePos + 1) % resolveCacheSize;
  return result
};

Object.defineProperties( ResolvedPos.prototype, prototypeAccessors$3 );

var resolveCache = [];
var resolveCachePos = 0;
var resolveCacheSize = 12;

// ::- Represents a flat range of content, i.e. one that starts and
// ends in the same node.
var NodeRange = function NodeRange($from, $to, depth) {
  // :: ResolvedPos A resolved position along the start of the
  // content. May have a `depth` greater than this object's `depth`
  // property, since these are the positions that were used to
  // compute the range, not re-resolved positions directly at its
  // boundaries.
  this.$from = $from;
  // :: ResolvedPos A position along the end of the content. See
  // caveat for [`$from`](#model.NodeRange.$from).
  this.$to = $to;
  // :: number The depth of the node that this range points into.
  this.depth = depth;
};

var prototypeAccessors$1$1 = { start: {},end: {},parent: {},startIndex: {},endIndex: {} };

// :: number The position at the start of the range.
prototypeAccessors$1$1.start.get = function () { return this.$from.before(this.depth + 1) };
// :: number The position at the end of the range.
prototypeAccessors$1$1.end.get = function () { return this.$to.after(this.depth + 1) };

// :: Node The parent node that the range points into.
prototypeAccessors$1$1.parent.get = function () { return this.$from.node(this.depth) };
// :: number The start index of the range in the parent node.
prototypeAccessors$1$1.startIndex.get = function () { return this.$from.index(this.depth) };
// :: number The end index of the range in the parent node.
prototypeAccessors$1$1.endIndex.get = function () { return this.$to.indexAfter(this.depth) };

Object.defineProperties( NodeRange.prototype, prototypeAccessors$1$1 );

var emptyAttrs = Object.create(null);

// ::- This class represents a node in the tree that makes up a
// ProseMirror document. So a document is an instance of `Node`, with
// children that are also instances of `Node`.
//
// Nodes are persistent data structures. Instead of changing them, you
// create new ones with the content you want. Old ones keep pointing
// at the old document shape. This is made cheaper by sharing
// structure between the old and new data as much as possible, which a
// tree shape like this (without back pointers) makes easy.
//
// **Do not** directly mutate the properties of a `Node` object. See
// [the guide](/docs/guide/#doc) for more information.
var Node = function Node(type, attrs, content, marks) {
  // :: NodeType
  // The type of node that this is.
  this.type = type;

  // :: Object
  // An object mapping attribute names to values. The kind of
  // attributes allowed and required are
  // [determined](#model.NodeSpec.attrs) by the node type.
  this.attrs = attrs;

  // :: Fragment
  // A container holding the node's children.
  this.content = content || Fragment.empty;

  // :: [Mark]
  // The marks (things like whether it is emphasized or part of a
  // link) applied to this node.
  this.marks = marks || Mark.none;
};

var prototypeAccessors = { nodeSize: {},childCount: {},textContent: {},firstChild: {},lastChild: {},isBlock: {},isTextblock: {},inlineContent: {},isInline: {},isText: {},isLeaf: {},isAtom: {} };

// text:: ?string
// For text nodes, this contains the node's text content.

// :: number
// The size of this node, as defined by the integer-based [indexing
// scheme](/docs/guide/#doc.indexing). For text nodes, this is the
// amount of characters. For other leaf nodes, it is one. For
// non-leaf nodes, it is the size of the content plus two (the start
// and end token).
prototypeAccessors.nodeSize.get = function () { return this.isLeaf ? 1 : 2 + this.content.size };

// :: number
// The number of children that the node has.
prototypeAccessors.childCount.get = function () { return this.content.childCount };

// :: (number) → Node
// Get the child node at the given index. Raises an error when the
// index is out of range.
Node.prototype.child = function child (index) { return this.content.child(index) };

// :: (number) → ?Node
// Get the child node at the given index, if it exists.
Node.prototype.maybeChild = function maybeChild (index) { return this.content.maybeChild(index) };

// :: ((node: Node, offset: number, index: number))
// Call `f` for every child node, passing the node, its offset
// into this parent node, and its index.
Node.prototype.forEach = function forEach (f) { this.content.forEach(f); };

// :: (number, number, (node: Node, pos: number, parent: Node, index: number) → ?bool, ?number)
// Invoke a callback for all descendant nodes recursively between
// the given two positions that are relative to start of this node's
// content. The callback is invoked with the node, its
// parent-relative position, its parent node, and its child index.
// When the callback returns false for a given node, that node's
// children will not be recursed over. The last parameter can be
// used to specify a starting position to count from.
Node.prototype.nodesBetween = function nodesBetween (from, to, f, startPos) {
    if ( startPos === void 0 ) startPos = 0;

  this.content.nodesBetween(from, to, f, startPos, this);
};

// :: ((node: Node, pos: number, parent: Node) → ?bool)
// Call the given callback for every descendant node. Doesn't
// descend into a node when the callback returns `false`.
Node.prototype.descendants = function descendants (f) {
  this.nodesBetween(0, this.content.size, f);
};

// :: string
// Concatenates all the text nodes found in this fragment and its
// children.
prototypeAccessors.textContent.get = function () { return this.textBetween(0, this.content.size, "") };

// :: (number, number, ?string, ?string) → string
// Get all text between positions `from` and `to`. When
// `blockSeparator` is given, it will be inserted whenever a new
// block node is started. When `leafText` is given, it'll be
// inserted for every non-text leaf node encountered.
Node.prototype.textBetween = function textBetween (from, to, blockSeparator, leafText) {
  return this.content.textBetween(from, to, blockSeparator, leafText)
};

// :: ?Node
// Returns this node's first child, or `null` if there are no
// children.
prototypeAccessors.firstChild.get = function () { return this.content.firstChild };

// :: ?Node
// Returns this node's last child, or `null` if there are no
// children.
prototypeAccessors.lastChild.get = function () { return this.content.lastChild };

// :: (Node) → bool
// Test whether two nodes represent the same piece of document.
Node.prototype.eq = function eq (other) {
  return this == other || (this.sameMarkup(other) && this.content.eq(other.content))
};

// :: (Node) → bool
// Compare the markup (type, attributes, and marks) of this node to
// those of another. Returns `true` if both have the same markup.
Node.prototype.sameMarkup = function sameMarkup (other) {
  return this.hasMarkup(other.type, other.attrs, other.marks)
};

// :: (NodeType, ?Object, ?[Mark]) → bool
// Check whether this node's markup correspond to the given type,
// attributes, and marks.
Node.prototype.hasMarkup = function hasMarkup (type, attrs, marks) {
  return this.type == type &&
    compareDeep(this.attrs, attrs || type.defaultAttrs || emptyAttrs) &&
    Mark.sameSet(this.marks, marks || Mark.none)
};

// :: (?Fragment) → Node
// Create a new node with the same markup as this node, containing
// the given content (or empty, if no content is given).
Node.prototype.copy = function copy (content) {
    if ( content === void 0 ) content = null;

  if (content == this.content) { return this }
  return new this.constructor(this.type, this.attrs, content, this.marks)
};

// :: ([Mark]) → Node
// Create a copy of this node, with the given set of marks instead
// of the node's own marks.
Node.prototype.mark = function mark (marks) {
  return marks == this.marks ? this : new this.constructor(this.type, this.attrs, this.content, marks)
};

// :: (number, ?number) → Node
// Create a copy of this node with only the content between the
// given positions. If `to` is not given, it defaults to the end of
// the node.
Node.prototype.cut = function cut (from, to) {
  if (from == 0 && to == this.content.size) { return this }
  return this.copy(this.content.cut(from, to))
};

// :: (number, ?number) → Slice
// Cut out the part of the document between the given positions, and
// return it as a `Slice` object.
Node.prototype.slice = function slice (from, to, includeParents) {
    if ( to === void 0 ) to = this.content.size;
    if ( includeParents === void 0 ) includeParents = false;

  if (from == to) { return Slice.empty }

  var $from = this.resolve(from), $to = this.resolve(to);
  var depth = includeParents ? 0 : $from.sharedDepth(to);
  var start = $from.start(depth), node = $from.node(depth);
  var content = node.content.cut($from.pos - start, $to.pos - start);
  return new Slice(content, $from.depth - depth, $to.depth - depth)
};

// :: (number, number, Slice) → Node
// Replace the part of the document between the given positions with
// the given slice. The slice must 'fit', meaning its open sides
// must be able to connect to the surrounding content, and its
// content nodes must be valid children for the node they are placed
// into. If any of this is violated, an error of type
// [`ReplaceError`](#model.ReplaceError) is thrown.
Node.prototype.replace = function replace$1 (from, to, slice) {
  return replace(this.resolve(from), this.resolve(to), slice)
};

// :: (number) → ?Node
// Find the node directly after the given position.
Node.prototype.nodeAt = function nodeAt (pos) {
  for (var node = this;;) {
    var ref = node.content.findIndex(pos);
      var index = ref.index;
      var offset = ref.offset;
    node = node.maybeChild(index);
    if (!node) { return null }
    if (offset == pos || node.isText) { return node }
    pos -= offset + 1;
  }
};

// :: (number) → {node: ?Node, index: number, offset: number}
// Find the (direct) child node after the given offset, if any,
// and return it along with its index and offset relative to this
// node.
Node.prototype.childAfter = function childAfter (pos) {
  var ref = this.content.findIndex(pos);
    var index = ref.index;
    var offset = ref.offset;
  return {node: this.content.maybeChild(index), index: index, offset: offset}
};

// :: (number) → {node: ?Node, index: number, offset: number}
// Find the (direct) child node before the given offset, if any,
// and return it along with its index and offset relative to this
// node.
Node.prototype.childBefore = function childBefore (pos) {
  if (pos == 0) { return {node: null, index: 0, offset: 0} }
  var ref = this.content.findIndex(pos);
    var index = ref.index;
    var offset = ref.offset;
  if (offset < pos) { return {node: this.content.child(index), index: index, offset: offset} }
  var node = this.content.child(index - 1);
  return {node: node, index: index - 1, offset: offset - node.nodeSize}
};

// :: (number) → ResolvedPos
// Resolve the given position in the document, returning an
// [object](#model.ResolvedPos) with information about its context.
Node.prototype.resolve = function resolve (pos) { return ResolvedPos.resolveCached(this, pos) };

Node.prototype.resolveNoCache = function resolveNoCache (pos) { return ResolvedPos.resolve(this, pos) };

// :: (number, number, MarkType) → bool
// Test whether a mark of the given type occurs in this document
// between the two given positions.
Node.prototype.rangeHasMark = function rangeHasMark (from, to, type) {
  var found = false;
  if (to > from) { this.nodesBetween(from, to, function (node) {
    if (type.isInSet(node.marks)) { found = true; }
    return !found
  }); }
  return found
};

// :: bool
// True when this is a block (non-inline node)
prototypeAccessors.isBlock.get = function () { return this.type.isBlock };

// :: bool
// True when this is a textblock node, a block node with inline
// content.
prototypeAccessors.isTextblock.get = function () { return this.type.isTextblock };

// :: bool
// True when this node has inline content.
prototypeAccessors.inlineContent.get = function () { return this.type.inlineContent };

// :: bool
// True when this is an inline node (a text node or a node that can
// appear among text).
prototypeAccessors.isInline.get = function () { return this.type.isInline };

// :: bool
// True when this is a text node.
prototypeAccessors.isText.get = function () { return this.type.isText };

// :: bool
// True when this is a leaf node.
prototypeAccessors.isLeaf.get = function () { return this.type.isLeaf };

// :: bool
// True when this is an atom, i.e. when it does not have directly
// editable content. This is usually the same as `isLeaf`, but can
// be configured with the [`atom` property](#model.NodeSpec.atom) on
// a node's spec (typically used when the node is displayed as an
// uneditable [node view](#view.NodeView)).
prototypeAccessors.isAtom.get = function () { return this.type.isAtom };

// :: () → string
// Return a string representation of this node for debugging
// purposes.
Node.prototype.toString = function toString () {
  if (this.type.spec.toDebugString) { return this.type.spec.toDebugString(this) }
  var name = this.type.name;
  if (this.content.size)
    { name += "(" + this.content.toStringInner() + ")"; }
  return wrapMarks(this.marks, name)
};

// :: (number) → ContentMatch
// Get the content match in this node at the given index.
Node.prototype.contentMatchAt = function contentMatchAt (index) {
  var match = this.type.contentMatch.matchFragment(this.content, 0, index);
  if (!match) { throw new Error("Called contentMatchAt on a node with invalid content") }
  return match
};

// :: (number, number, ?Fragment, ?number, ?number) → bool
// Test whether replacing the range between `from` and `to` (by
// child index) with the given replacement fragment (which defaults
// to the empty fragment) would leave the node's content valid. You
// can optionally pass `start` and `end` indices into the
// replacement fragment.
Node.prototype.canReplace = function canReplace (from, to, replacement, start, end) {
    var this$1 = this;
    if ( replacement === void 0 ) replacement = Fragment.empty;
    if ( start === void 0 ) start = 0;
    if ( end === void 0 ) end = replacement.childCount;

  var one = this.contentMatchAt(from).matchFragment(replacement, start, end);
  var two = one && one.matchFragment(this.content, to);
  if (!two || !two.validEnd) { return false }
  for (var i = start; i < end; i++) { if (!this$1.type.allowsMarks(replacement.child(i).marks)) { return false } }
  return true
};

// :: (number, number, NodeType, ?[Mark]) → bool
// Test whether replacing the range `from` to `to` (by index) with a
// node of the given type would leave the node's content valid.
Node.prototype.canReplaceWith = function canReplaceWith (from, to, type, marks) {
  if (marks && !this.type.allowsMarks(marks)) { return false }
  var start = this.contentMatchAt(from).matchType(type);
  var end = start && start.matchFragment(this.content, to);
  return end ? end.validEnd : false
};

// :: (Node) → bool
// Test whether the given node's content could be appended to this
// node. If that node is empty, this will only return true if there
// is at least one node type that can appear in both nodes (to avoid
// merging completely incompatible nodes).
Node.prototype.canAppend = function canAppend (other) {
  if (other.content.size) { return this.canReplace(this.childCount, this.childCount, other.content) }
  else { return this.type.compatibleContent(other.type) }
};

// Unused. Left for backwards compatibility.
Node.prototype.defaultContentType = function defaultContentType (at) {
  return this.contentMatchAt(at).defaultType
};

// :: ()
// Check whether this node and its descendants conform to the
// schema, and raise error when they do not.
Node.prototype.check = function check () {
  if (!this.type.validContent(this.content))
    { throw new RangeError(("Invalid content for node " + (this.type.name) + ": " + (this.content.toString().slice(0, 50)))) }
  this.content.forEach(function (node) { return node.check(); });
};

// :: () → Object
// Return a JSON-serializeable representation of this node.
Node.prototype.toJSON = function toJSON () {
    var this$1 = this;

  var obj = {type: this.type.name};
  for (var _ in this$1.attrs) {
    obj.attrs = this$1.attrs;
    break
  }
  if (this.content.size)
    { obj.content = this.content.toJSON(); }
  if (this.marks.length)
    { obj.marks = this.marks.map(function (n) { return n.toJSON(); }); }
  return obj
};

// :: (Schema, Object) → Node
// Deserialize a node from its JSON representation.
Node.fromJSON = function fromJSON (schema, json) {
  if (!json) { throw new RangeError("Invalid input for Node.fromJSON") }
  var marks = null;
  if (json.marks) {
    if (!Array.isArray(json.marks)) { throw new RangeError("Invalid mark data for Node.fromJSON") }
    marks = json.marks.map(schema.markFromJSON);
  }
  if (json.type == "text") {
    if (typeof json.text != "string") { throw new RangeError("Invalid text node in JSON") }
    return schema.text(json.text, marks)
  }
  var content = Fragment.fromJSON(schema, json.content);
  return schema.nodeType(json.type).create(json.attrs, content, marks)
};

Object.defineProperties( Node.prototype, prototypeAccessors );

var TextNode = (function (Node) {
  function TextNode(type, attrs, content, marks) {
    Node.call(this, type, attrs, null, marks);

    if (!content) { throw new RangeError("Empty text nodes are not allowed") }

    this.text = content;
  }

  if ( Node ) TextNode.__proto__ = Node;
  TextNode.prototype = Object.create( Node && Node.prototype );
  TextNode.prototype.constructor = TextNode;

  var prototypeAccessors$1 = { textContent: {},nodeSize: {} };

  TextNode.prototype.toString = function toString () {
    if (this.type.spec.toDebugString) { return this.type.spec.toDebugString(this) }
    return wrapMarks(this.marks, JSON.stringify(this.text))
  };

  prototypeAccessors$1.textContent.get = function () { return this.text };

  TextNode.prototype.textBetween = function textBetween (from, to) { return this.text.slice(from, to) };

  prototypeAccessors$1.nodeSize.get = function () { return this.text.length };

  TextNode.prototype.mark = function mark (marks) {
    return marks == this.marks ? this : new TextNode(this.type, this.attrs, this.text, marks)
  };

  TextNode.prototype.withText = function withText (text) {
    if (text == this.text) { return this }
    return new TextNode(this.type, this.attrs, text, this.marks)
  };

  TextNode.prototype.cut = function cut (from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.text.length;

    if (from == 0 && to == this.text.length) { return this }
    return this.withText(this.text.slice(from, to))
  };

  TextNode.prototype.eq = function eq (other) {
    return this.sameMarkup(other) && this.text == other.text
  };

  TextNode.prototype.toJSON = function toJSON () {
    var base = Node.prototype.toJSON.call(this);
    base.text = this.text;
    return base
  };

  Object.defineProperties( TextNode.prototype, prototypeAccessors$1 );

  return TextNode;
}(Node));

function wrapMarks(marks, str) {
  for (var i = marks.length - 1; i >= 0; i--)
    { str = marks[i].type.name + "(" + str + ")"; }
  return str
}

// ::- Instances of this class represent a match state of a node
// type's [content expression](#model.NodeSpec.content), and can be
// used to find out whether further content matches here, and whether
// a given position is a valid end of the node.
var ContentMatch = function ContentMatch(validEnd) {
  // :: bool
  // True when this match state represents a valid end of the node.
  this.validEnd = validEnd;
  this.next = [];
  this.wrapCache = [];
};

var prototypeAccessors$5 = { inlineContent: {},defaultType: {},edgeCount: {} };

ContentMatch.parse = function parse (string, nodeTypes) {
  var stream = new TokenStream(string, nodeTypes);
  if (stream.next == null) { return ContentMatch.empty }
  var expr = parseExpr(stream);
  if (stream.next) { stream.err("Unexpected trailing text"); }
  var match = dfa(nfa(expr));
  checkForDeadEnds(match, stream);
  return match
};

// :: (NodeType) → ?ContentMatch
// Match a node type, returning a match after that node if
// successful.
ContentMatch.prototype.matchType = function matchType (type) {
    var this$1 = this;

  for (var i = 0; i < this.next.length; i += 2)
    { if (this$1.next[i] == type) { return this$1.next[i + 1] } }
  return null
};

// :: (Fragment, ?number, ?number) → ?ContentMatch
// Try to match a fragment. Returns the resulting match when
// successful.
ContentMatch.prototype.matchFragment = function matchFragment (frag, start, end) {
    if ( start === void 0 ) start = 0;
    if ( end === void 0 ) end = frag.childCount;

  var cur = this;
  for (var i = start; cur && i < end; i++)
    { cur = cur.matchType(frag.child(i).type); }
  return cur
};

prototypeAccessors$5.inlineContent.get = function () {
  var first = this.next[0];
  return first ? first.isInline : false
};

// :: ?NodeType
// Get the first matching node type at this match position that can
// be generated.
prototypeAccessors$5.defaultType.get = function () {
    var this$1 = this;

  for (var i = 0; i < this.next.length; i += 2) {
    var type = this$1.next[i];
    if (!(type.isText || type.hasRequiredAttrs())) { return type }
  }
};

ContentMatch.prototype.compatible = function compatible (other) {
    var this$1 = this;

  for (var i = 0; i < this.next.length; i += 2)
    { for (var j = 0; j < other.next.length; j += 2)
      { if (this$1.next[i] == other.next[j]) { return true } } }
  return false
};

// :: (Fragment, bool, ?number) → ?Fragment
// Try to match the given fragment, and if that fails, see if it can
// be made to match by inserting nodes in front of it. When
// successful, return a fragment of inserted nodes (which may be
// empty if nothing had to be inserted). When `toEnd` is true, only
// return a fragment if the resulting match goes to the end of the
// content expression.
ContentMatch.prototype.fillBefore = function fillBefore (after, toEnd, startIndex) {
    if ( toEnd === void 0 ) toEnd = false;
    if ( startIndex === void 0 ) startIndex = 0;

  var seen = [this];
  function search(match, types) {
    var finished = match.matchFragment(after, startIndex);
    if (finished && (!toEnd || finished.validEnd))
      { return Fragment.from(types.map(function (tp) { return tp.createAndFill(); })) }

    for (var i = 0; i < match.next.length; i += 2) {
      var type = match.next[i], next = match.next[i + 1];
      if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
        seen.push(next);
        var found = search(next, types.concat(type));
        if (found) { return found }
      }
    }
  }

  return search(this, [])
};

// :: (NodeType) → ?[NodeType]
// Find a set of wrapping node types that would allow a node of the
// given type to appear at this position. The result may be empty
// (when it fits directly) and will be null when no such wrapping
// exists.
ContentMatch.prototype.findWrapping = function findWrapping (target) {
    var this$1 = this;

  for (var i = 0; i < this.wrapCache.length; i += 2)
    { if (this$1.wrapCache[i] == target) { return this$1.wrapCache[i + 1] } }
  var computed = this.computeWrapping(target);
  this.wrapCache.push(target, computed);
  return computed
};

ContentMatch.prototype.computeWrapping = function computeWrapping (target) {
  var seen = Object.create(null), active = [{match: this, type: null, via: null}];
  while (active.length) {
    var current = active.shift(), match = current.match;
    if (match.matchType(target)) {
      var result = [];
      for (var obj = current; obj.type; obj = obj.via)
        { result.push(obj.type); }
      return result.reverse()
    }
    for (var i = 0; i < match.next.length; i += 2) {
      var type = match.next[i];
      if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || match.next[i + 1].validEnd)) {
        active.push({match: type.contentMatch, type: type, via: current});
        seen[type.name] = true;
      }
    }
  }
};

// :: number
// The number of outgoing edges this node has in the finite
// automaton that describes the content expression.
prototypeAccessors$5.edgeCount.get = function () {
  return this.next.length >> 1
};

// :: (number) → {type: NodeType, next: ContentMatch}
// Get the _n_th outgoing edge from this node in the finite
// automaton that describes the content expression.
ContentMatch.prototype.edge = function edge (n) {
  var i = n << 1;
  if (i > this.next.length) { throw new RangeError(("There's no " + n + "th edge in this content match")) }
  return {type: this.next[i], next: this.next[i + 1]}
};

ContentMatch.prototype.toString = function toString () {
  var seen = [];
  function scan(m) {
    seen.push(m);
    for (var i = 1; i < m.next.length; i += 2)
      { if (seen.indexOf(m.next[i]) == -1) { scan(m.next[i]); } }
  }
  scan(this);
  return seen.map(function (m, i) {
    var out = i + (m.validEnd ? "*" : " ") + " ";
    for (var i$1 = 0; i$1 < m.next.length; i$1 += 2)
      { out += (i$1 ? ", " : "") + m.next[i$1].name + "->" + seen.indexOf(m.next[i$1 + 1]); }
    return out
  }).join("\n")
};

Object.defineProperties( ContentMatch.prototype, prototypeAccessors$5 );

ContentMatch.empty = new ContentMatch(true);

var TokenStream = function TokenStream(string, nodeTypes) {
  this.string = string;
  this.nodeTypes = nodeTypes;
  this.inline = null;
  this.pos = 0;
  this.tokens = string.split(/\s*(?=\b|\W|$)/);
  if (this.tokens[this.tokens.length - 1] == "") { this.tokens.pop(); }
  if (this.tokens[0] == "") { this.tokens.unshift(); }
};

var prototypeAccessors$1$3 = { next: {} };

prototypeAccessors$1$3.next.get = function () { return this.tokens[this.pos] };

TokenStream.prototype.eat = function eat (tok) { return this.next == tok && (this.pos++ || true) };

TokenStream.prototype.err = function err (str) { throw new SyntaxError(str + " (in content expression '" + this.string + "')") };

Object.defineProperties( TokenStream.prototype, prototypeAccessors$1$3 );

function parseExpr(stream) {
  var exprs = [];
  do { exprs.push(parseExprSeq(stream)); }
  while (stream.eat("|"))
  return exprs.length == 1 ? exprs[0] : {type: "choice", exprs: exprs}
}

function parseExprSeq(stream) {
  var exprs = [];
  do { exprs.push(parseExprSubscript(stream)); }
  while (stream.next && stream.next != ")" && stream.next != "|")
  return exprs.length == 1 ? exprs[0] : {type: "seq", exprs: exprs}
}

function parseExprSubscript(stream) {
  var expr = parseExprAtom(stream);
  for (;;) {
    if (stream.eat("+"))
      { expr = {type: "plus", expr: expr}; }
    else if (stream.eat("*"))
      { expr = {type: "star", expr: expr}; }
    else if (stream.eat("?"))
      { expr = {type: "opt", expr: expr}; }
    else if (stream.eat("{"))
      { expr = parseExprRange(stream, expr); }
    else { break }
  }
  return expr
}

function parseNum(stream) {
  if (/\D/.test(stream.next)) { stream.err("Expected number, got '" + stream.next + "'"); }
  var result = Number(stream.next);
  stream.pos++;
  return result
}

function parseExprRange(stream, expr) {
  var min = parseNum(stream), max = min;
  if (stream.eat(",")) {
    if (stream.next != "}") { max = parseNum(stream); }
    else { max = -1; }
  }
  if (!stream.eat("}")) { stream.err("Unclosed braced range"); }
  return {type: "range", min: min, max: max, expr: expr}
}

function resolveName(stream, name) {
  var types = stream.nodeTypes, type = types[name];
  if (type) { return [type] }
  var result = [];
  for (var typeName in types) {
    var type$1 = types[typeName];
    if (type$1.groups.indexOf(name) > -1) { result.push(type$1); }
  }
  if (result.length == 0) { stream.err("No node type or group '" + name + "' found"); }
  return result
}

function parseExprAtom(stream) {
  if (stream.eat("(")) {
    var expr = parseExpr(stream);
    if (!stream.eat(")")) { stream.err("Missing closing paren"); }
    return expr
  } else if (!/\W/.test(stream.next)) {
    var exprs = resolveName(stream, stream.next).map(function (type) {
      if (stream.inline == null) { stream.inline = type.isInline; }
      else if (stream.inline != type.isInline) { stream.err("Mixing inline and block content"); }
      return {type: "name", value: type}
    });
    stream.pos++;
    return exprs.length == 1 ? exprs[0] : {type: "choice", exprs: exprs}
  } else {
    stream.err("Unexpected token '" + stream.next + "'");
  }
}

// The code below helps compile a regular-expression-like language
// into a deterministic finite automaton. For a good introduction to
// these concepts, see https://swtch.com/~rsc/regexp/regexp1.html

// : (Object) → [[{term: ?any, to: number}]]
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function nfa(expr) {
  var nfa = [[]];
  connect(compile(expr, 0), node());
  return nfa

  function node() { return nfa.push([]) - 1 }
  function edge(from, to, term) {
    var edge = {term: term, to: to};
    nfa[from].push(edge);
    return edge
  }
  function connect(edges, to) { edges.forEach(function (edge) { return edge.to = to; }); }

  function compile(expr, from) {
    if (expr.type == "choice") {
      return expr.exprs.reduce(function (out, expr) { return out.concat(compile(expr, from)); }, [])
    } else if (expr.type == "seq") {
      for (var i = 0;; i++) {
        var next = compile(expr.exprs[i], from);
        if (i == expr.exprs.length - 1) { return next }
        connect(next, from = node());
      }
    } else if (expr.type == "star") {
      var loop = node();
      edge(from, loop);
      connect(compile(expr.expr, loop), loop);
      return [edge(loop)]
    } else if (expr.type == "plus") {
      var loop$1 = node();
      connect(compile(expr.expr, from), loop$1);
      connect(compile(expr.expr, loop$1), loop$1);
      return [edge(loop$1)]
    } else if (expr.type == "opt") {
      return [edge(from)].concat(compile(expr.expr, from))
    } else if (expr.type == "range") {
      var cur = from;
      for (var i$1 = 0; i$1 < expr.min; i$1++) {
        var next$1 = node();
        connect(compile(expr.expr, cur), next$1);
        cur = next$1;
      }
      if (expr.max == -1) {
        connect(compile(expr.expr, cur), cur);
      } else {
        for (var i$2 = expr.min; i$2 < expr.max; i$2++) {
          var next$2 = node();
          edge(cur, next$2);
          connect(compile(expr.expr, cur), next$2);
          cur = next$2;
        }
      }
      return [edge(cur)]
    } else if (expr.type == "name") {
      return [edge(from, null, expr.value)]
    }
  }
}

function cmp(a, b) { return a - b }

// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function nullFrom(nfa, node) {
  var result = [];
  scan(node);
  return result.sort(cmp)

  function scan(node) {
    var edges = nfa[node];
    if (edges.length == 1 && !edges[0].term) { return scan(edges[0].to) }
    result.push(node);
    for (var i = 0; i < edges.length; i++) {
      var ref = edges[i];
      var term = ref.term;
      var to = ref.to;
      if (!term && result.indexOf(to) == -1) { scan(to); }
    }
  }
}

// : ([[{term: ?any, to: number}]]) → ContentMatch
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function dfa(nfa) {
  var labeled = Object.create(null);
  return explore(nullFrom(nfa, 0))

  function explore(states) {
    var out = [];
    states.forEach(function (node) {
      nfa[node].forEach(function (ref) {
        var term = ref.term;
        var to = ref.to;

        if (!term) { return }
        var known = out.indexOf(term), set = known > -1 && out[known + 1];
        nullFrom(nfa, to).forEach(function (node) {
          if (!set) { out.push(term, set = []); }
          if (set.indexOf(node) == -1) { set.push(node); }
        });
      });
    });
    var state = labeled[states.join(",")] = new ContentMatch(states.indexOf(nfa.length - 1) > -1);
    for (var i = 0; i < out.length; i += 2) {
      var states$1 = out[i + 1].sort(cmp);
      state.next.push(out[i], labeled[states$1.join(",")] || explore(states$1));
    }
    return state
  }
}

function checkForDeadEnds(match, stream) {
  for (var i = 0, work = [match]; i < work.length; i++) {
    var state = work[i], dead = !state.validEnd, nodes = [];
    for (var j = 0; j < state.next.length; j += 2) {
      var node = state.next[j], next = state.next[j + 1];
      nodes.push(node.name);
      if (dead && !(node.isText || node.hasRequiredAttrs())) { dead = false; }
      if (work.indexOf(next) == -1) { work.push(next); }
    }
    if (dead) { stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position"); }
  }
}

// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function defaultAttrs(attrs) {
  var defaults = Object.create(null);
  for (var attrName in attrs) {
    var attr = attrs[attrName];
    if (!attr.hasDefault) { return null }
    defaults[attrName] = attr.default;
  }
  return defaults
}

function computeAttrs(attrs, value) {
  var built = Object.create(null);
  for (var name in attrs) {
    var given = value && value[name];
    if (given === undefined) {
      var attr = attrs[name];
      if (attr.hasDefault) { given = attr.default; }
      else { throw new RangeError("No value supplied for attribute " + name) }
    }
    built[name] = given;
  }
  return built
}

function initAttrs(attrs) {
  var result = Object.create(null);
  if (attrs) { for (var name in attrs) { result[name] = new Attribute(attrs[name]); } }
  return result
}

// ::- Node types are objects allocated once per `Schema` and used to
// [tag](#model.Node.type) `Node` instances. They contain information
// about the node type, such as its name and what kind of node it
// represents.
var NodeType = function NodeType(name, schema, spec) {
  // :: string
  // The name the node type has in this schema.
  this.name = name;

  // :: Schema
  // A link back to the `Schema` the node type belongs to.
  this.schema = schema;

  // :: NodeSpec
  // The spec that this type is based on
  this.spec = spec;

  this.groups = spec.group ? spec.group.split(" ") : [];
  this.attrs = initAttrs(spec.attrs);

  this.defaultAttrs = defaultAttrs(this.attrs);

  // :: ContentMatch
  // The starting match of the node type's content expression.
  this.contentMatch = null;

  // : ?[MarkType]
  // The set of marks allowed in this node. `null` means all marks
  // are allowed.
  this.markSet = null;

  // :: bool
  // True if this node type has inline content.
  this.inlineContent = null;

  // :: bool
  // True if this is a block type
  this.isBlock = !(spec.inline || name == "text");

  // :: bool
  // True if this is the text node type.
  this.isText = name == "text";
};

var prototypeAccessors$4 = { isInline: {},isTextblock: {},isLeaf: {},isAtom: {} };

// :: bool
// True if this is an inline type.
prototypeAccessors$4.isInline.get = function () { return !this.isBlock };

// :: bool
// True if this is a textblock type, a block that contains inline
// content.
prototypeAccessors$4.isTextblock.get = function () { return this.isBlock && this.inlineContent };

// :: bool
// True for node types that allow no content.
prototypeAccessors$4.isLeaf.get = function () { return this.contentMatch == ContentMatch.empty };

// :: bool
// True when this node is an atom, i.e. when it does not have
// directly editable content.
prototypeAccessors$4.isAtom.get = function () { return this.isLeaf || this.spec.atom };

NodeType.prototype.hasRequiredAttrs = function hasRequiredAttrs (ignore) {
    var this$1 = this;

  for (var n in this$1.attrs)
    { if (this$1.attrs[n].isRequired && (!ignore || !(n in ignore))) { return true } }
  return false
};

NodeType.prototype.compatibleContent = function compatibleContent (other) {
  return this == other || this.contentMatch.compatible(other.contentMatch)
};

NodeType.prototype.computeAttrs = function computeAttrs$1 (attrs) {
  if (!attrs && this.defaultAttrs) { return this.defaultAttrs }
  else { return computeAttrs(this.attrs, attrs) }
};

// :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → Node
// Create a `Node` of this type. The given attributes are
// checked and defaulted (you can pass `null` to use the type's
// defaults entirely, if no required attributes exist). `content`
// may be a `Fragment`, a node, an array of nodes, or
// `null`. Similarly `marks` may be `null` to default to the empty
// set of marks.
NodeType.prototype.create = function create (attrs, content, marks) {
  if (this.isText) { throw new Error("NodeType.create can't construct text nodes") }
  return new Node(this, this.computeAttrs(attrs), Fragment.from(content), Mark.setFrom(marks))
};

// :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → Node
// Like [`create`](#model.NodeType.create), but check the given content
// against the node type's content restrictions, and throw an error
// if it doesn't match.
NodeType.prototype.createChecked = function createChecked (attrs, content, marks) {
  content = Fragment.from(content);
  if (!this.validContent(content))
    { throw new RangeError("Invalid content for node " + this.name) }
  return new Node(this, this.computeAttrs(attrs), content, Mark.setFrom(marks))
};

// :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → ?Node
// Like [`create`](#model.NodeType.create), but see if it is necessary to
// add nodes to the start or end of the given fragment to make it
// fit the node. If no fitting wrapping can be found, return null.
// Note that, due to the fact that required nodes can always be
// created, this will always succeed if you pass null or
// `Fragment.empty` as content.
NodeType.prototype.createAndFill = function createAndFill (attrs, content, marks) {
  attrs = this.computeAttrs(attrs);
  content = Fragment.from(content);
  if (content.size) {
    var before = this.contentMatch.fillBefore(content);
    if (!before) { return null }
    content = before.append(content);
  }
  var after = this.contentMatch.matchFragment(content).fillBefore(Fragment.empty, true);
  if (!after) { return null }
  return new Node(this, attrs, content.append(after), Mark.setFrom(marks))
};

// :: (Fragment) → bool
// Returns true if the given fragment is valid content for this node
// type with the given attributes.
NodeType.prototype.validContent = function validContent (content) {
    var this$1 = this;

  var result = this.contentMatch.matchFragment(content);
  if (!result || !result.validEnd) { return false }
  for (var i = 0; i < content.childCount; i++)
    { if (!this$1.allowsMarks(content.child(i).marks)) { return false } }
  return true
};

// :: (MarkType) → bool
// Check whether the given mark type is allowed in this node.
NodeType.prototype.allowsMarkType = function allowsMarkType (markType) {
  return this.markSet == null || this.markSet.indexOf(markType) > -1
};

// :: ([Mark]) → bool
// Test whether the given set of marks are allowed in this node.
NodeType.prototype.allowsMarks = function allowsMarks (marks) {
    var this$1 = this;

  if (this.markSet == null) { return true }
  for (var i = 0; i < marks.length; i++) { if (!this$1.allowsMarkType(marks[i].type)) { return false } }
  return true
};

// :: ([Mark]) → [Mark]
// Removes the marks that are not allowed in this node from the given set.
NodeType.prototype.allowedMarks = function allowedMarks (marks) {
    var this$1 = this;

  if (this.markSet == null) { return marks }
  var copy;
  for (var i = 0; i < marks.length; i++) {
    if (!this$1.allowsMarkType(marks[i].type)) {
      if (!copy) { copy = marks.slice(0, i); }
    } else if (copy) {
      copy.push(marks[i]);
    }
  }
  return !copy ? marks : copy.length ? copy : Mark.empty
};

NodeType.compile = function compile (nodes, schema) {
  var result = Object.create(null);
  nodes.forEach(function (name, spec) { return result[name] = new NodeType(name, schema, spec); });

  var topType = schema.spec.topNode || "doc";
  if (!result[topType]) { throw new RangeError("Schema is missing its top node type ('" + topType + "')") }
  if (!result.text) { throw new RangeError("Every schema needs a 'text' type") }
  for (var _ in result.text.attrs) { throw new RangeError("The text node type should not have attributes") }

  return result
};

Object.defineProperties( NodeType.prototype, prototypeAccessors$4 );

// Attribute descriptors

var Attribute = function Attribute(options) {
  this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
  this.default = options.default;
};

var prototypeAccessors$1$2 = { isRequired: {} };

prototypeAccessors$1$2.isRequired.get = function () {
  return !this.hasDefault
};

Object.defineProperties( Attribute.prototype, prototypeAccessors$1$2 );

// Marks

// ::- Like nodes, marks (which are associated with nodes to signify
// things like emphasis or being part of a link) are
// [tagged](#model.Mark.type) with type objects, which are
// instantiated once per `Schema`.
var MarkType = function MarkType(name, rank, schema, spec) {
  // :: string
  // The name of the mark type.
  this.name = name;

  // :: Schema
  // The schema that this mark type instance is part of.
  this.schema = schema;

  // :: MarkSpec
  // The spec on which the type is based.
  this.spec = spec;

  this.attrs = initAttrs(spec.attrs);

  this.rank = rank;
  this.excluded = null;
  var defaults = defaultAttrs(this.attrs);
  this.instance = defaults && new Mark(this, defaults);
};

// :: (?Object) → Mark
// Create a mark of this type. `attrs` may be `null` or an object
// containing only some of the mark's attributes. The others, if
// they have defaults, will be added.
MarkType.prototype.create = function create (attrs) {
  if (!attrs && this.instance) { return this.instance }
  return new Mark(this, computeAttrs(this.attrs, attrs))
};

MarkType.compile = function compile (marks, schema) {
  var result = Object.create(null), rank = 0;
  marks.forEach(function (name, spec) { return result[name] = new MarkType(name, rank++, schema, spec); });
  return result
};

// :: ([Mark]) → [Mark]
// When there is a mark of this type in the given set, a new set
// without it is returned. Otherwise, the input set is returned.
MarkType.prototype.removeFromSet = function removeFromSet (set) {
    var this$1 = this;

  for (var i = 0; i < set.length; i++)
    { if (set[i].type == this$1)
      { return set.slice(0, i).concat(set.slice(i + 1)) } }
  return set
};

// :: ([Mark]) → ?Mark
// Tests whether there is a mark of this type in the given set.
MarkType.prototype.isInSet = function isInSet (set) {
    var this$1 = this;

  for (var i = 0; i < set.length; i++)
    { if (set[i].type == this$1) { return set[i] } }
};

// :: (MarkType) → bool
// Queries whether a given mark type is
// [excluded](#model.MarkSpec.excludes) by this one.
MarkType.prototype.excludes = function excludes (other) {
  return this.excluded.indexOf(other) > -1
};

// SchemaSpec:: interface
// An object describing a schema, as passed to the [`Schema`](#model.Schema)
// constructor.
//
//   nodes:: union<Object<NodeSpec>, OrderedMap<NodeSpec>>
//   The node types in this schema. Maps names to
//   [`NodeSpec`](#model.NodeSpec) objects that describe the node type
//   associated with that name. Their order is significant—it
//   determines which [parse rules](#model.NodeSpec.parseDOM) take
//   precedence by default, and which nodes come first in a given
//   [group](#model.NodeSpec.group).
//
//   marks:: ?union<Object<MarkSpec>, OrderedMap<MarkSpec>>
//   The mark types that exist in this schema. The order in which they
//   are provided determines the order in which [mark
//   sets](#model.Mark.addToSet) are sorted and in which [parse
//   rules](#model.MarkSpec.parseDOM) are tried.
//
//   topNode:: ?string
//   The name of the default top-level node for the schema. Defaults
//   to `"doc"`.

// NodeSpec:: interface
//
//   content:: ?string
//   The content expression for this node, as described in the [schema
//   guide](/docs/guide/#schema.content_expressions). When not given,
//   the node does not allow any content.
//
//   marks:: ?string
//   The marks that are allowed inside of this node. May be a
//   space-separated string referring to mark names or groups, `"_"`
//   to explicitly allow all marks, or `""` to disallow marks. When
//   not given, nodes with inline content default to allowing all
//   marks, other nodes default to not allowing marks.
//
//   group:: ?string
//   The group or space-separated groups to which this node belongs,
//   which can be referred to in the content expressions for the
//   schema.
//
//   inline:: ?bool
//   Should be set to true for inline nodes. (Implied for text nodes.)
//
//   atom:: ?bool
//   Can be set to true to indicate that, though this isn't a [leaf
//   node](#model.NodeType.isLeaf), it doesn't have directly editable
//   content and should be treated as a single unit in the view.
//
//   attrs:: ?Object<AttributeSpec>
//   The attributes that nodes of this type get.
//
//   selectable:: ?bool
//   Controls whether nodes of this type can be selected as a [node
//   selection](#state.NodeSelection). Defaults to true for non-text
//   nodes.
//
//   draggable:: ?bool
//   Determines whether nodes of this type can be dragged without
//   being selected. Defaults to false.
//
//   code:: ?bool
//   Can be used to indicate that this node contains code, which
//   causes some commands to behave differently.
//
//   defining:: ?bool
//   Determines whether this node is considered an important parent
//   node during replace operations (such as paste). Non-defining (the
//   default) nodes get dropped when their entire content is replaced,
//   whereas defining nodes persist and wrap the inserted content.
//   Likewise, in _inserted_ content the defining parents of the
//   content are preserved when possible. Typically,
//   non-default-paragraph textblock types, and possibly list items,
//   are marked as defining.
//
//   isolating:: ?bool
//   When enabled (default is false), the sides of nodes of this type
//   count as boundaries that regular editing operations, like
//   backspacing or lifting, won't cross. An example of a node that
//   should probably have this enabled is a table cell.
//
//   toDOM:: ?(node: Node) → DOMOutputSpec
//   Defines the default way a node of this type should be serialized
//   to DOM/HTML (as used by
//   [`DOMSerializer.fromSchema`](#model.DOMSerializer^fromSchema)).
//   Should return a DOM node or an [array
//   structure](#model.DOMOutputSpec) that describes one, with an
//   optional number zero (“hole”) in it to indicate where the node's
//   content should be inserted.
//
//   For text nodes, the default is to create a text DOM node. Though
//   it is possible to create a serializer where text is rendered
//   differently, this is not supported inside the editor, so you
//   shouldn't override that in your text node spec.
//
//   parseDOM:: ?[ParseRule]
//   Associates DOM parser information with this node, which can be
//   used by [`DOMParser.fromSchema`](#model.DOMParser^fromSchema) to
//   automatically derive a parser. The `node` field in the rules is
//   implied (the name of this node will be filled in automatically).
//   If you supply your own parser, you do not need to also specify
//   parsing rules in your schema.
//
//   toDebugString:: ?(node: Node) -> string
//   Defines the default way a node of this type should be serialized
//   to a string representation for debugging (e.g. in error messages).

// MarkSpec:: interface
//
//   attrs:: ?Object<AttributeSpec>
//   The attributes that marks of this type get.
//
//   inclusive:: ?bool
//   Whether this mark should be active when the cursor is positioned
//   at its end (or at its start when that is also the start of the
//   parent node). Defaults to true.
//
//   excludes:: ?string
//   Determines which other marks this mark can coexist with. Should
//   be a space-separated strings naming other marks or groups of marks.
//   When a mark is [added](#model.Mark.addToSet) to a set, all marks
//   that it excludes are removed in the process. If the set contains
//   any mark that excludes the new mark but is not, itself, excluded
//   by the new mark, the mark can not be added an the set. You can
//   use the value `"_"` to indicate that the mark excludes all
//   marks in the schema.
//
//   Defaults to only being exclusive with marks of the same type. You
//   can set it to an empty string (or any string not containing the
//   mark's own name) to allow multiple marks of a given type to
//   coexist (as long as they have different attributes).
//
//   group:: ?string
//   The group or space-separated groups to which this mark belongs.
//
//   toDOM:: ?(mark: Mark, inline: bool) → DOMOutputSpec
//   Defines the default way marks of this type should be serialized
//   to DOM/HTML. When the resulting spec contains a hole, that is
//   where the marked content is placed. Otherwise, it is appended to
//   the top node.
//
//   parseDOM:: ?[ParseRule]
//   Associates DOM parser information with this mark (see the
//   corresponding [node spec field](#model.NodeSpec.parseDOM)). The
//   `mark` field in the rules is implied.

// AttributeSpec:: interface
//
// Used to [define](#model.NodeSpec.attrs) attributes on nodes or
// marks.
//
//   default:: ?any
//   The default value for this attribute, to use when no explicit
//   value is provided. Attributes that have no default must be
//   provided whenever a node or mark of a type that has them is
//   created.

// ::- A document schema. Holds [node](#model.NodeType) and [mark
// type](#model.MarkType) objects for the nodes and marks that may
// occur in conforming documents, and provides functionality for
// creating and deserializing such documents.
var Schema = function Schema(spec) {
  var this$1 = this;

  // :: SchemaSpec
  // The [spec](#model.SchemaSpec) on which the schema is based,
  // with the added guarantee that its `nodes` and `marks`
  // properties are
  // [`OrderedMap`](https://github.com/marijnh/orderedmap) instances
  // (not raw objects).
  this.spec = {};
  for (var prop in spec) { this$1.spec[prop] = spec[prop]; }
  this.spec.nodes = OrderedMap.from(spec.nodes);
  this.spec.marks = OrderedMap.from(spec.marks);

  // :: Object<NodeType>
  // An object mapping the schema's node names to node type objects.
  this.nodes = NodeType.compile(this.spec.nodes, this);

  // :: Object<MarkType>
  // A map from mark names to mark type objects.
  this.marks = MarkType.compile(this.spec.marks, this);

  var contentExprCache = Object.create(null);
  for (var prop$1 in this$1.nodes) {
    if (prop$1 in this$1.marks)
      { throw new RangeError(prop$1 + " can not be both a node and a mark") }
    var type = this$1.nodes[prop$1], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
    type.contentMatch = contentExprCache[contentExpr] ||
      (contentExprCache[contentExpr] = ContentMatch.parse(contentExpr, this$1.nodes));
    type.inlineContent = type.contentMatch.inlineContent;
    type.markSet = markExpr == "_" ? null :
      markExpr ? gatherMarks(this$1, markExpr.split(" ")) :
      markExpr == "" || !type.inlineContent ? [] : null;
  }
  for (var prop$2 in this$1.marks) {
    var type$1 = this$1.marks[prop$2], excl = type$1.spec.excludes;
    type$1.excluded = excl == null ? [type$1] : excl == "" ? [] : gatherMarks(this$1, excl.split(" "));
  }

  this.nodeFromJSON = this.nodeFromJSON.bind(this);
  this.markFromJSON = this.markFromJSON.bind(this);

  // :: NodeType
  // The type of the [default top node](#model.SchemaSpec.topNode)
  // for this schema.
  this.topNodeType = this.nodes[this.spec.topNode || "doc"];

  // :: Object
  // An object for storing whatever values modules may want to
  // compute and cache per schema. (If you want to store something
  // in it, try to use property names unlikely to clash.)
  this.cached = Object.create(null);
  this.cached.wrappings = Object.create(null);
};

// :: (union<string, NodeType>, ?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → Node
// Create a node in this schema. The `type` may be a string or a
// `NodeType` instance. Attributes will be extended
// with defaults, `content` may be a `Fragment`,
// `null`, a `Node`, or an array of nodes.
Schema.prototype.node = function node (type, attrs, content, marks) {
  if (typeof type == "string")
    { type = this.nodeType(type); }
  else if (!(type instanceof NodeType))
    { throw new RangeError("Invalid node type: " + type) }
  else if (type.schema != this)
    { throw new RangeError("Node type from different schema used (" + type.name + ")") }

  return type.createChecked(attrs, content, marks)
};

// :: (string, ?[Mark]) → Node
// Create a text node in the schema. Empty text nodes are not
// allowed.
Schema.prototype.text = function text (text$1, marks) {
  var type = this.nodes.text;
  return new TextNode(type, type.defaultAttrs, text$1, Mark.setFrom(marks))
};

// :: (union<string, MarkType>, ?Object) → Mark
// Create a mark with the given type and attributes.
Schema.prototype.mark = function mark (type, attrs) {
  if (typeof type == "string") { type = this.marks[type]; }
  return type.create(attrs)
};

// :: (Object) → Node
// Deserialize a node from its JSON representation. This method is
// bound.
Schema.prototype.nodeFromJSON = function nodeFromJSON (json) {
  return Node.fromJSON(this, json)
};

// :: (Object) → Mark
// Deserialize a mark from its JSON representation. This method is
// bound.
Schema.prototype.markFromJSON = function markFromJSON (json) {
  return Mark.fromJSON(this, json)
};

Schema.prototype.nodeType = function nodeType (name) {
  var found = this.nodes[name];
  if (!found) { throw new RangeError("Unknown node type: " + name) }
  return found
};

function gatherMarks(schema, marks) {
  var found = [];
  for (var i = 0; i < marks.length; i++) {
    var name = marks[i], mark = schema.marks[name], ok = mark;
    if (mark) {
      found.push(mark);
    } else {
      for (var prop in schema.marks) {
        var mark$1 = schema.marks[prop];
        if (name == "_" || (mark$1.spec.group && mark$1.spec.group.split(" ").indexOf(name) > -1))
          { found.push(ok = mark$1); }
      }
    }
    if (!ok) { throw new SyntaxError("Unknown mark type: '" + marks[i] + "'") }
  }
  return found
}

// ParseOptions:: interface
// These are the options recognized by the
// [`parse`](#model.DOMParser.parse) and
// [`parseSlice`](#model.DOMParser.parseSlice) methods.
//
//   preserveWhitespace:: ?union<bool, "full">
//   By default, whitespace is collapsed as per HTML's rules. Pass
//   `true` to preserve whitespace, but normalize newlines to
//   spaces, and `"full"` to preserve whitespace entirely.
//
//   findPositions:: ?[{node: dom.Node, offset: number}]
//   When given, the parser will, beside parsing the content,
//   record the document positions of the given DOM positions. It
//   will do so by writing to the objects, adding a `pos` property
//   that holds the document position. DOM positions that are not
//   in the parsed content will not be written to.
//
//   from:: ?number
//   The child node index to start parsing from.
//
//   to:: ?number
//   The child node index to stop parsing at.
//
//   topNode:: ?Node
//   By default, the content is parsed into the schema's default
//   [top node type](#model.Schema.topNodeType). You can pass this
//   option to use the type and attributes from a different node
//   as the top container.
//
//   topMatch:: ?ContentMatch
//   Provide the starting content match that content parsed into the
//   top node is matched against.
//
//   context:: ?ResolvedPos
//   A set of additional nodes to count as
//   [context](#model.ParseRule.context) when parsing, above the
//   given [top node](#model.ParseOptions.topNode).

// ParseRule:: interface
// A value that describes how to parse a given DOM node or inline
// style as a ProseMirror node or mark.
//
//   tag:: ?string
//   A CSS selector describing the kind of DOM elements to match. A
//   single rule should have _either_ a `tag` or a `style` property.
//
//   namespace:: ?string
//   The namespace to match. This should be used with `tag`.
//   Nodes are only matched when the namespace matches or this property
//   is null.
//
//   style:: ?string
//   A CSS property name to match. When given, this rule matches
//   inline styles that list that property. May also have the form
//   `"property=value"`, in which case the rule only matches if the
//   propery's value exactly matches the given value. (For more
//   complicated filters, use [`getAttrs`](#model.ParseRule.getAttrs)
//   and return undefined to indicate that the match failed.)
//
//   priority:: ?number
//   Can be used to change the order in which the parse rules in a
//   schema are tried. Those with higher priority come first. Rules
//   without a priority are counted as having priority 50. This
//   property is only meaningful in a schema—when directly
//   constructing a parser, the order of the rule array is used.
//
//   context:: ?string
//   When given, restricts this rule to only match when the current
//   context—the parent nodes into which the content is being
//   parsed—matches this expression. Should contain one or more node
//   names or node group names followed by single or double slashes.
//   For example `"paragraph/"` means the rule only matches when the
//   parent node is a paragraph, `"blockquote/paragraph/"` restricts
//   it to be in a paragraph that is inside a blockquote, and
//   `"section//"` matches any position inside a section—a double
//   slash matches any sequence of ancestor nodes. To allow multiple
//   different contexts, they can be separated by a pipe (`|`)
//   character, as in `"blockquote/|list_item/"`.
//
//   node:: ?string
//   The name of the node type to create when this rule matches. Only
//   valid for rules with a `tag` property, not for style rules. Each
//   rule should have one of a `node`, `mark`, or `ignore` property
//   (except when it appears in a [node](#model.NodeSpec.parseDOM) or
//   [mark spec](#model.MarkSpec.parseDOM), in which case the `node`
//   or `mark` property will be derived from its position).
//
//   mark:: ?string
//   The name of the mark type to wrap the matched content in.
//
//   ignore:: ?bool
//   When true, ignore content that matches this rule.
//
//   skip:: ?bool
//   When true, ignore the node that matches this rule, but do parse
//   its content.
//
//   attrs:: ?Object
//   Attributes for the node or mark created by this rule. When
//   `getAttrs` is provided, it takes precedence.
//
//   getAttrs:: ?(union<dom.Node, string>) → ?union<Object, false>
//   A function used to compute the attributes for the node or mark
//   created by this rule. Can also be used to describe further
//   conditions the DOM element or style must match. When it returns
//   `false`, the rule won't match. When it returns null or undefined,
//   that is interpreted as an empty/default set of attributes.
//
//   Called with a DOM Element for `tag` rules, and with a string (the
//   style's value) for `style` rules.
//
//   contentElement:: ?union<string, (dom.Node) → dom.Node>
//   For `tag` rules that produce non-leaf nodes or marks, by default
//   the content of the DOM element is parsed as content of the mark
//   or node. If the child nodes are in a descendent node, this may be
//   a CSS selector string that the parser must use to find the actual
//   content element, or a function that returns the actual content
//   element to the parser.
//
//   getContent:: ?(dom.Node, schema: Schema) → Fragment
//   Can be used to override the content of a matched node. When
//   present, instead of parsing the node's child nodes, the result of
//   this function is used.
//
//   preserveWhitespace:: ?union<bool, "full">
//   Controls whether whitespace should be preserved when parsing the
//   content inside the matched element. `false` means whitespace may
//   be collapsed, `true` means that whitespace should be preserved
//   but newlines normalized to spaces, and `"full"` means that
//   newlines should also be preserved.

// ::- A DOM parser represents a strategy for parsing DOM content into
// a ProseMirror document conforming to a given schema. Its behavior
// is defined by an array of [rules](#model.ParseRule).
var DOMParser = function DOMParser(schema, rules) {
  var this$1 = this;

  // :: Schema
  // The schema into which the parser parses.
  this.schema = schema;
  // :: [ParseRule]
  // The set of [parse rules](#model.ParseRule) that the parser
  // uses, in order of precedence.
  this.rules = rules;
  this.tags = [];
  this.styles = [];

  rules.forEach(function (rule) {
    if (rule.tag) { this$1.tags.push(rule); }
    else if (rule.style) { this$1.styles.push(rule); }
  });
};

// :: (dom.Node, ?ParseOptions) → Node
// Parse a document from the content of a DOM node.
DOMParser.prototype.parse = function parse (dom, options) {
    if ( options === void 0 ) options = {};

  var context = new ParseContext(this, options, false);
  context.addAll(dom, null, options.from, options.to);
  return context.finish()
};

// :: (dom.Node, ?ParseOptions) → Slice
// Parses the content of the given DOM node, like
// [`parse`](#model.DOMParser.parse), and takes the same set of
// options. But unlike that method, which produces a whole node,
// this one returns a slice that is open at the sides, meaning that
// the schema constraints aren't applied to the start of nodes to
// the left of the input and the end of nodes at the end.
DOMParser.prototype.parseSlice = function parseSlice (dom, options) {
    if ( options === void 0 ) options = {};

  var context = new ParseContext(this, options, true);
  context.addAll(dom, null, options.from, options.to);
  return Slice.maxOpen(context.finish())
};

DOMParser.prototype.matchTag = function matchTag (dom, context) {
    var this$1 = this;

  for (var i = 0; i < this.tags.length; i++) {
    var rule = this$1.tags[i];
    if (matches(dom, rule.tag) &&
        (rule.namespace === undefined || dom.namespaceURI == rule.namespace) &&
        (!rule.context || context.matchesContext(rule.context))) {
      if (rule.getAttrs) {
        var result = rule.getAttrs(dom);
        if (result === false) { continue }
        rule.attrs = result;
      }
      return rule
    }
  }
};

DOMParser.prototype.matchStyle = function matchStyle (prop, value, context) {
    var this$1 = this;

  for (var i = 0; i < this.styles.length; i++) {
    var rule = this$1.styles[i];
    if (rule.style.indexOf(prop) != 0 ||
        rule.context && !context.matchesContext(rule.context) ||
        // Test that the style string either precisely matches the prop,
        // or has an '=' sign after the prop, followed by the given
        // value.
        rule.style.length > prop.length &&
        (rule.style.charCodeAt(prop.length) != 61 || rule.style.slice(prop.length + 1) != value))
      { continue }
    if (rule.getAttrs) {
      var result = rule.getAttrs(value);
      if (result === false) { continue }
      rule.attrs = result;
    }
    return rule
  }
};

// : (Schema) → [ParseRule]
DOMParser.schemaRules = function schemaRules (schema) {
  var result = [];
  function insert(rule) {
    var priority = rule.priority == null ? 50 : rule.priority, i = 0;
    for (; i < result.length; i++) {
      var next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
      if (nextPriority < priority) { break }
    }
    result.splice(i, 0, rule);
  }

  var loop = function ( name ) {
    var rules = schema.marks[name].spec.parseDOM;
    if (rules) { rules.forEach(function (rule) {
      insert(rule = copy(rule));
      rule.mark = name;
    }); }
  };

    for (var name in schema.marks) loop( name );
  var loop$1 = function ( name ) {
    var rules$1 = schema.nodes[name$1].spec.parseDOM;
    if (rules$1) { rules$1.forEach(function (rule) {
      insert(rule = copy(rule));
      rule.node = name$1;
    }); }
  };

    for (var name$1 in schema.nodes) loop$1( name );
  return result
};

// :: (Schema) → DOMParser
// Construct a DOM parser using the parsing rules listed in a
// schema's [node specs](#model.NodeSpec.parseDOM), reordered by
// [priority](#model.ParseRule.priority).
DOMParser.fromSchema = function fromSchema (schema) {
  return schema.cached.domParser ||
    (schema.cached.domParser = new DOMParser(schema, DOMParser.schemaRules(schema)))
};

// : Object<bool> The block-level tags in HTML5
var blockTags = {
  address: true, article: true, aside: true, blockquote: true, canvas: true,
  dd: true, div: true, dl: true, fieldset: true, figcaption: true, figure: true,
  footer: true, form: true, h1: true, h2: true, h3: true, h4: true, h5: true,
  h6: true, header: true, hgroup: true, hr: true, li: true, noscript: true, ol: true,
  output: true, p: true, pre: true, section: true, table: true, tfoot: true, ul: true
};

// : Object<bool> The tags that we normally ignore.
var ignoreTags = {
  head: true, noscript: true, object: true, script: true, style: true, title: true
};

// : Object<bool> List tags.
var listTags = {ol: true, ul: true};

// Using a bitfield for node context options
var OPT_PRESERVE_WS = 1;
var OPT_PRESERVE_WS_FULL = 2;
var OPT_OPEN_LEFT = 4;

function wsOptionsFor(preserveWhitespace) {
  return (preserveWhitespace ? OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? OPT_PRESERVE_WS_FULL : 0)
}

var NodeContext = function NodeContext(type, attrs, marks, solid, match, options) {
  this.type = type;
  this.attrs = attrs;
  this.solid = solid;
  this.match = match || (options & OPT_OPEN_LEFT ? null : type.contentMatch);
  this.options = options;
  this.content = [];
  this.marks = marks;
  this.activeMarks = Mark.none;
};

NodeContext.prototype.findWrapping = function findWrapping (node) {
  if (!this.match) {
    if (!this.type) { return [] }
    var fill = this.type.contentMatch.fillBefore(Fragment.from(node));
    if (fill) {
      this.match = this.type.contentMatch.matchFragment(fill);
    } else {
      var start = this.type.contentMatch, wrap;
      if (wrap = start.findWrapping(node.type)) {
        this.match = start;
        return wrap
      } else {
        return null
      }
    }
  }
  return this.match.findWrapping(node.type)
};

NodeContext.prototype.finish = function finish (openEnd) {
  if (!(this.options & OPT_PRESERVE_WS)) { // Strip trailing whitespace
    var last = this.content[this.content.length - 1], m;
    if (last && last.isText && (m = /\s+$/.exec(last.text))) {
      if (last.text.length == m[0].length) { this.content.pop(); }
      else { this.content[this.content.length - 1] = last.withText(last.text.slice(0, last.text.length - m[0].length)); }
    }
  }
  var content = Fragment.from(this.content);
  if (!openEnd && this.match)
    { content = content.append(this.match.fillBefore(Fragment.empty, true)); }
  return this.type ? this.type.create(this.attrs, content, this.marks) : content
};

var ParseContext = function ParseContext(parser, options, open) {
  // : DOMParser The parser we are using.
  this.parser = parser;
  // : Object The options passed to this parse.
  this.options = options;
  this.isOpen = open;
  this.pendingMarks = [];
  var topNode = options.topNode, topContext;
  var topOptions = wsOptionsFor(options.preserveWhitespace) | (open ? OPT_OPEN_LEFT : 0);
  if (topNode)
    { topContext = new NodeContext(topNode.type, topNode.attrs, Mark.none, true,
                                 options.topMatch || topNode.type.contentMatch, topOptions); }
  else if (open)
    { topContext = new NodeContext(null, null, Mark.none, true, null, topOptions); }
  else
    { topContext = new NodeContext(parser.schema.topNodeType, null, Mark.none, true, null, topOptions); }
  this.nodes = [topContext];
  // : [Mark] The current set of marks
  this.open = 0;
  this.find = options.findPositions;
  this.needsBlock = false;
};

var prototypeAccessors$6 = { top: {},currentPos: {} };

prototypeAccessors$6.top.get = function () {
  return this.nodes[this.open]
};

// : (dom.Node)
// Add a DOM node to the content. Text is inserted as text node,
// otherwise, the node is passed to `addElement` or, if it has a
// `style` attribute, `addElementWithStyles`.
ParseContext.prototype.addDOM = function addDOM (dom) {
    var this$1 = this;

  if (dom.nodeType == 3) {
    this.addTextNode(dom);
  } else if (dom.nodeType == 1) {
    var style = dom.getAttribute("style");
    var marks = style ? this.readStyles(parseStyles(style)) : null;
    if (marks != null) { for (var i = 0; i < marks.length; i++) { this$1.addPendingMark(marks[i]); } }
    this.addElement(dom);
    if (marks != null) { for (var i$1 = 0; i$1 < marks.length; i$1++) { this$1.removePendingMark(marks[i$1]); } }
  }
};

ParseContext.prototype.addTextNode = function addTextNode (dom) {
  var value = dom.nodeValue;
  var top = this.top;
  if ((top.type ? top.type.inlineContent : top.content.length && top.content[0].isInline) || /\S/.test(value)) {
    if (!(top.options & OPT_PRESERVE_WS)) {
      value = value.replace(/\s+/g, " ");
      // If this starts with whitespace, and there is no node before it, or
      // a hard break, or a text node that ends with whitespace, strip the
      // leading space.
      if (/^\s/.test(value) && this.open == this.nodes.length - 1) {
        var nodeBefore = top.content[top.content.length - 1];
        var domNodeBefore = dom.previousSibling;
        if (!nodeBefore ||
            (domNodeBefore && domNodeBefore.nodeName == 'BR') ||
            (nodeBefore.isText && /\s$/.test(nodeBefore.text)))
          { value = value.slice(1); }
      }
    } else if (!(top.options & OPT_PRESERVE_WS_FULL)) {
      value = value.replace(/\r?\n|\r/g, " ");
    }
    if (value) { this.insertNode(this.parser.schema.text(value)); }
    this.findInText(dom);
  } else {
    this.findInside(dom);
  }
};

// : (dom.Element)
// Try to find a handler for the given tag and use that to parse. If
// none is found, the element's content nodes are added directly.
ParseContext.prototype.addElement = function addElement (dom) {
  var name = dom.nodeName.toLowerCase();
  if (listTags.hasOwnProperty(name)) { normalizeList(dom); }
  var rule = (this.options.ruleFromNode && this.options.ruleFromNode(dom)) || this.parser.matchTag(dom, this);
  if (rule ? rule.ignore : ignoreTags.hasOwnProperty(name)) {
    this.findInside(dom);
  } else if (!rule || rule.skip) {
    if (rule && rule.skip.nodeType) { dom = rule.skip; }
    var sync, top = this.top, oldNeedsBlock = this.needsBlock;
    if (blockTags.hasOwnProperty(name)) {
      sync = true;
      if (!top.type) { this.needsBlock = true; }
    }
    this.addAll(dom);
    if (sync) { this.sync(top); }
    this.needsBlock = oldNeedsBlock;
  } else {
    this.addElementByRule(dom, rule);
  }
};

// Run any style parser associated with the node's styles. Either
// return an array of marks, or null to indicate some of the styles
// had a rule with `ignore` set.
ParseContext.prototype.readStyles = function readStyles (styles) {
    var this$1 = this;

  var marks = Mark.none;
  for (var i = 0; i < styles.length; i += 2) {
    var rule = this$1.parser.matchStyle(styles[i], styles[i + 1], this$1);
    if (!rule) { continue }
    if (rule.ignore) { return null }
    marks = this$1.parser.schema.marks[rule.mark].create(rule.attrs).addToSet(marks);
  }
  return marks
};

// : (dom.Element, ParseRule) → bool
// Look up a handler for the given node. If none are found, return
// false. Otherwise, apply it, use its return value to drive the way
// the node's content is wrapped, and return true.
ParseContext.prototype.addElementByRule = function addElementByRule (dom, rule) {
    var this$1 = this;

  var sync, nodeType, markType, mark;
  if (rule.node) {
    nodeType = this.parser.schema.nodes[rule.node];
    if (nodeType.isLeaf) { this.insertNode(nodeType.create(rule.attrs)); }
    else { sync = this.enter(nodeType, rule.attrs, rule.preserveWhitespace); }
  } else {
    markType = this.parser.schema.marks[rule.mark];
    mark = markType.create(rule.attrs);
    this.addPendingMark(mark);
  }
  var startIn = this.top;

  if (nodeType && nodeType.isLeaf) {
    this.findInside(dom);
  } else if (rule.getContent) {
    this.findInside(dom);
    rule.getContent(dom, this.parser.schema).forEach(function (node) { return this$1.insertNode(node); });
  } else {
    var contentDOM = rule.contentElement;
    if (typeof contentDOM == "string") { contentDOM = dom.querySelector(contentDOM); }
    else if (typeof contentDOM == "function") { contentDOM = contentDOM(dom); }
    if (!contentDOM) { contentDOM = dom; }
    this.findAround(dom, contentDOM, true);
    this.addAll(contentDOM, sync);
  }
  if (sync) { this.sync(startIn); this.open--; }
  if (mark) { this.removePendingMark(mark); }
  return true
};

// : (dom.Node, ?NodeBuilder, ?number, ?number)
// Add all child nodes between `startIndex` and `endIndex` (or the
// whole node, if not given). If `sync` is passed, use it to
// synchronize after every block element.
ParseContext.prototype.addAll = function addAll (parent, sync, startIndex, endIndex) {
    var this$1 = this;

  var index = startIndex || 0;
  for (var dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild,
           end = endIndex == null ? null : parent.childNodes[endIndex];
       dom != end; dom = dom.nextSibling, ++index) {
    this$1.findAtPoint(parent, index);
    this$1.addDOM(dom);
    if (sync && blockTags.hasOwnProperty(dom.nodeName.toLowerCase()))
      { this$1.sync(sync); }
  }
  this.findAtPoint(parent, index);
};

// Try to find a way to fit the given node type into the current
// context. May add intermediate wrappers and/or leave non-solid
// nodes that we're in.
ParseContext.prototype.findPlace = function findPlace (node) {
    var this$1 = this;

  var route, sync;
  for (var depth = this.open; depth >= 0; depth--) {
    var cx = this$1.nodes[depth];
    var found = cx.findWrapping(node);
    if (found && (!route || route.length > found.length)) {
      route = found;
      sync = cx;
      if (!found.length) { break }
    }
    if (cx.solid) { break }
  }
  if (!route) { return false }
  this.sync(sync);
  for (var i = 0; i < route.length; i++)
    { this$1.enterInner(route[i], null, false); }
  return true
};

// : (Node) → ?Node
// Try to insert the given node, adjusting the context when needed.
ParseContext.prototype.insertNode = function insertNode (node) {
  if (node.isInline && this.needsBlock && !this.top.type) {
    var block = this.textblockFromContext();
    if (block) { this.enterInner(block); }
  }
  if (this.findPlace(node)) {
    this.closeExtra();
    var top = this.top;
    this.applyPendingMarks(top);
    if (top.match) { top.match = top.match.matchType(node.type); }
    var marks = top.activeMarks;
    for (var i = 0; i < node.marks.length; i++)
      { if (!top.type || top.type.allowsMarkType(node.marks[i].type))
        { marks = node.marks[i].addToSet(marks); } }
    top.content.push(node.mark(marks));
  }
};

ParseContext.prototype.applyPendingMarks = function applyPendingMarks (top) {
    var this$1 = this;

  for (var i = 0; i < this.pendingMarks.length; i++) {
    var mark = this$1.pendingMarks[i];
    if ((!top.type || top.type.allowsMarkType(mark.type)) && !mark.type.isInSet(top.activeMarks)) {
      top.activeMarks = mark.addToSet(top.activeMarks);
      this$1.pendingMarks.splice(i--, 1);
    }
  }
};

// : (NodeType, ?Object) → bool
// Try to start a node of the given type, adjusting the context when
// necessary.
ParseContext.prototype.enter = function enter (type, attrs, preserveWS) {
  var ok = this.findPlace(type.create(attrs));
  if (ok) {
    this.applyPendingMarks(this.top);
    this.enterInner(type, attrs, true, preserveWS);
  }
  return ok
};

// Open a node of the given type
ParseContext.prototype.enterInner = function enterInner (type, attrs, solid, preserveWS) {
  this.closeExtra();
  var top = this.top;
  top.match = top.match && top.match.matchType(type, attrs);
  var options = preserveWS == null ? top.options & ~OPT_OPEN_LEFT : wsOptionsFor(preserveWS);
  if ((top.options & OPT_OPEN_LEFT) && top.content.length == 0) { options |= OPT_OPEN_LEFT; }
  this.nodes.push(new NodeContext(type, attrs, top.activeMarks, solid, null, options));
  this.open++;
};

// Make sure all nodes above this.open are finished and added to
// their parents
ParseContext.prototype.closeExtra = function closeExtra (openEnd) {
    var this$1 = this;

  var i = this.nodes.length - 1;
  if (i > this.open) {
    for (; i > this.open; i--) { this$1.nodes[i - 1].content.push(this$1.nodes[i].finish(openEnd)); }
    this.nodes.length = this.open + 1;
  }
};

ParseContext.prototype.finish = function finish () {
  this.open = 0;
  this.closeExtra(this.isOpen);
  return this.nodes[0].finish(this.isOpen || this.options.topOpen)
};

ParseContext.prototype.sync = function sync (to) {
    var this$1 = this;

  for (var i = this.open; i >= 0; i--) { if (this$1.nodes[i] == to) {
    this$1.open = i;
    return
  } }
};

ParseContext.prototype.addPendingMark = function addPendingMark (mark) {
  this.pendingMarks.push(mark);
};

ParseContext.prototype.removePendingMark = function removePendingMark (mark) {
  var found = this.pendingMarks.lastIndexOf(mark);
  if (found > -1) {
    this.pendingMarks.splice(found, 1);
  } else {
    var top = this.top;
    top.activeMarks = mark.removeFromSet(top.activeMarks);
  }
};

prototypeAccessors$6.currentPos.get = function () {
    var this$1 = this;

  this.closeExtra();
  var pos = 0;
  for (var i = this.open; i >= 0; i--) {
    var content = this$1.nodes[i].content;
    for (var j = content.length - 1; j >= 0; j--)
      { pos += content[j].nodeSize; }
    if (i) { pos++; }
  }
  return pos
};

ParseContext.prototype.findAtPoint = function findAtPoint (parent, offset) {
    var this$1 = this;

  if (this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this$1.find[i].node == parent && this$1.find[i].offset == offset)
      { this$1.find[i].pos = this$1.currentPos; }
  } }
};

ParseContext.prototype.findInside = function findInside (parent) {
    var this$1 = this;

  if (this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this$1.find[i].pos == null && parent.nodeType == 1 && parent.contains(this$1.find[i].node))
      { this$1.find[i].pos = this$1.currentPos; }
  } }
};

ParseContext.prototype.findAround = function findAround (parent, content, before) {
    var this$1 = this;

  if (parent != content && this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this$1.find[i].pos == null && parent.nodeType == 1 && parent.contains(this$1.find[i].node)) {
      var pos = content.compareDocumentPosition(this$1.find[i].node);
      if (pos & (before ? 2 : 4))
        { this$1.find[i].pos = this$1.currentPos; }
    }
  } }
};

ParseContext.prototype.findInText = function findInText (textNode) {
    var this$1 = this;

  if (this.find) { for (var i = 0; i < this.find.length; i++) {
    if (this$1.find[i].node == textNode)
      { this$1.find[i].pos = this$1.currentPos - (textNode.nodeValue.length - this$1.find[i].offset); }
  } }
};

// : (string) → bool
// Determines whether the given [context
// string](#ParseRule.context) matches this context.
ParseContext.prototype.matchesContext = function matchesContext (context) {
    var this$1 = this;

  if (context.indexOf("|") > -1)
    { return context.split(/\s*\|\s*/).some(this.matchesContext, this) }

  var parts = context.split("/");
  var option = this.options.context;
  var useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
  var minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
  var match = function (i, depth) {
    for (; i >= 0; i--) {
      var part = parts[i];
      if (part == "") {
        if (i == parts.length - 1 || i == 0) { continue }
        for (; depth >= minDepth; depth--)
          { if (match(i - 1, depth)) { return true } }
        return false
      } else {
        var next = depth > 0 || (depth == 0 && useRoot) ? this$1.nodes[depth].type
            : option && depth >= minDepth ? option.node(depth - minDepth).type
            : null;
        if (!next || (next.name != part && next.groups.indexOf(part) == -1))
          { return false }
        depth--;
      }
    }
    return true
  };
  return match(parts.length - 1, this.open)
};

ParseContext.prototype.textblockFromContext = function textblockFromContext () {
    var this$1 = this;

  var $context = this.options.context;
  if ($context) { for (var d = $context.depth; d >= 0; d--) {
    var deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
    if (deflt && deflt.isTextblock && deflt.defaultAttrs) { return deflt }
  } }
  for (var name in this$1.parser.schema.nodes) {
    var type = this$1.parser.schema.nodes[name];
    if (type.isTextblock && type.defaultAttrs) { return type }
  }
};

Object.defineProperties( ParseContext.prototype, prototypeAccessors$6 );

// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function normalizeList(dom) {
  for (var child = dom.firstChild, prevItem = null; child; child = child.nextSibling) {
    var name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
    if (name && listTags.hasOwnProperty(name) && prevItem) {
      prevItem.appendChild(child);
      child = prevItem;
    } else if (name == "li") {
      prevItem = child;
    } else if (name) {
      prevItem = null;
    }
  }
}

// Apply a CSS selector.
function matches(dom, selector) {
  return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector)
}

// : (string) → [string]
// Tokenize a style attribute into property/value pairs.
function parseStyles(style) {
  var re = /\s*([\w-]+)\s*:\s*([^;]+)/g, m, result = [];
  while (m = re.exec(style)) { result.push(m[1], m[2].trim()); }
  return result
}

function copy(obj) {
  var copy = {};
  for (var prop in obj) { copy[prop] = obj[prop]; }
  return copy
}

// DOMOutputSpec:: interface
// A description of a DOM structure. Can be either a string, which is
// interpreted as a text node, a DOM node, which is interpreted as
// itself, or an array.
//
// An array describes a DOM element. The first value in the array
// should be a string—the name of the DOM element. If the second
// element is plain object, it is interpreted as a set of attributes
// for the element. Any elements after that (including the 2nd if it's
// not an attribute object) are interpreted as children of the DOM
// elements, and must either be valid `DOMOutputSpec` values, or the
// number zero.
//
// The number zero (pronounced “hole”) is used to indicate the place
// where a node's child nodes should be inserted. It it occurs in an
// output spec, it should be the only child element in its parent
// node.

// ::- A DOM serializer knows how to convert ProseMirror nodes and
// marks of various types to DOM nodes.
var DOMSerializer = function DOMSerializer(nodes, marks) {
  // :: Object<(node: Node) → DOMOutputSpec>
  // The node serialization functions.
  this.nodes = nodes || {};
  // :: Object<?(mark: Mark, inline: bool) → DOMOutputSpec>
  // The mark serialization functions.
  this.marks = marks || {};
};

// :: (Fragment, ?Object) → dom.DocumentFragment
// Serialize the content of this fragment to a DOM fragment. When
// not in the browser, the `document` option, containing a DOM
// document, should be passed so that the serializer can create
// nodes.
DOMSerializer.prototype.serializeFragment = function serializeFragment (fragment, options, target) {
    var this$1 = this;
    if ( options === void 0 ) options = {};

  if (!target) { target = doc(options).createDocumentFragment(); }

  var top = target, active = null;
  fragment.forEach(function (node) {
    if (active || node.marks.length) {
      if (!active) { active = []; }
      var keep = 0, rendered = 0;
      while (keep < active.length && rendered < node.marks.length) {
        var next = node.marks[rendered];
        if (!this$1.marks[next.type.name]) { rendered++; continue }
        if (!next.eq(active[keep])) { break }
        keep += 2; rendered++;
      }
      while (keep < active.length) {
        top = active.pop();
        active.pop();
      }
      while (rendered < node.marks.length) {
        var add = node.marks[rendered++];
        var markDOM = this$1.serializeMark(add, node.isInline, options);
        if (markDOM) {
          active.push(add, top);
          top.appendChild(markDOM.dom);
          top = markDOM.contentDOM || markDOM.dom;
        }
      }
    }
    top.appendChild(this$1.serializeNode(node, options));
  });

  return target
};

// :: (Node, ?Object) → dom.Node
// Serialize this node to a DOM node. This can be useful when you
// need to serialize a part of a document, as opposed to the whole
// document. To serialize a whole document, use
// [`serializeFragment`](#model.DOMSerializer.serializeFragment) on
// its [content](#model.Node.content).
DOMSerializer.prototype.serializeNode = function serializeNode (node, options) {
    if ( options === void 0 ) options = {};

  var ref =
      DOMSerializer.renderSpec(doc(options), this.nodes[node.type.name](node));
    var dom = ref.dom;
    var contentDOM = ref.contentDOM;
  if (contentDOM) {
    if (node.isLeaf)
      { throw new RangeError("Content hole not allowed in a leaf node spec") }
    if (options.onContent)
      { options.onContent(node, contentDOM, options); }
    else
      { this.serializeFragment(node.content, options, contentDOM); }
  }
  return dom
};

DOMSerializer.prototype.serializeNodeAndMarks = function serializeNodeAndMarks (node, options) {
    var this$1 = this;
    if ( options === void 0 ) options = {};

  var dom = this.serializeNode(node, options);
  for (var i = node.marks.length - 1; i >= 0; i--) {
    var wrap = this$1.serializeMark(node.marks[i], node.isInline, options);
    if (wrap) {
      (wrap.contentDOM || wrap.dom).appendChild(dom);
      dom = wrap.dom;
    }
  }
  return dom
};

DOMSerializer.prototype.serializeMark = function serializeMark (mark, inline, options) {
    if ( options === void 0 ) options = {};

  var toDOM = this.marks[mark.type.name];
  return toDOM && DOMSerializer.renderSpec(doc(options), toDOM(mark, inline))
};

// :: (dom.Document, DOMOutputSpec) → {dom: dom.Node, contentDOM: ?dom.Node}
// Render an [output spec](#model.DOMOutputSpec) to a DOM node. If
// the spec has a hole (zero) in it, `contentDOM` will point at the
// node with the hole.
DOMSerializer.renderSpec = function renderSpec (doc, structure) {
  if (typeof structure == "string")
    { return {dom: doc.createTextNode(structure)} }
  if (structure.nodeType != null)
    { return {dom: structure} }
  var dom = doc.createElement(structure[0]), contentDOM = null;
  var attrs = structure[1], start = 1;
  if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
    start = 2;
    for (var name in attrs) {
      if (name == "style") { dom.style.cssText = attrs[name]; }
      else if (attrs[name] != null) { dom.setAttribute(name, attrs[name]); }
    }
  }
  for (var i = start; i < structure.length; i++) {
    var child = structure[i];
    if (child === 0) {
      if (i < structure.length - 1 || i > start)
        { throw new RangeError("Content hole must be the only child of its parent node") }
      return {dom: dom, contentDOM: dom}
    } else {
      var ref = DOMSerializer.renderSpec(doc, child);
        var inner = ref.dom;
        var innerContent = ref.contentDOM;
      dom.appendChild(inner);
      if (innerContent) {
        if (contentDOM) { throw new RangeError("Multiple content holes") }
        contentDOM = innerContent;
      }
    }
  }
  return {dom: dom, contentDOM: contentDOM}
};

// :: (Schema) → DOMSerializer
// Build a serializer using the [`toDOM`](#model.NodeSpec.toDOM)
// properties in a schema's node and mark specs.
DOMSerializer.fromSchema = function fromSchema (schema) {
  return schema.cached.domSerializer ||
    (schema.cached.domSerializer = new DOMSerializer(this.nodesFromSchema(schema), this.marksFromSchema(schema)))
};

// : (Schema) → Object<(node: Node) → DOMOutputSpec>
// Gather the serializers in a schema's node specs into an object.
// This can be useful as a base to build a custom serializer from.
DOMSerializer.nodesFromSchema = function nodesFromSchema (schema) {
  var result = gatherToDOM(schema.nodes);
  if (!result.text) { result.text = function (node) { return node.text; }; }
  return result
};

// : (Schema) → Object<(mark: Mark) → DOMOutputSpec>
// Gather the serializers in a schema's mark specs into an object.
DOMSerializer.marksFromSchema = function marksFromSchema (schema) {
  return gatherToDOM(schema.marks)
};

function gatherToDOM(obj) {
  var result = {};
  for (var name in obj) {
    var toDOM = obj[name].spec.toDOM;
    if (toDOM) { result[name] = toDOM; }
  }
  return result
}

function doc(options) {
  // declare global: window
  return options.document || window.document
}

exports.Node = Node;
exports.ResolvedPos = ResolvedPos;
exports.NodeRange = NodeRange;
exports.Fragment = Fragment;
exports.Slice = Slice;
exports.ReplaceError = ReplaceError;
exports.Mark = Mark;
exports.Schema = Schema;
exports.NodeType = NodeType;
exports.MarkType = MarkType;
exports.ContentMatch = ContentMatch;
exports.DOMParser = DOMParser;
exports.DOMSerializer = DOMSerializer;
//# sourceMappingURL=index.js.map


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(9);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

module.exports = _objectSpread;

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ncss_Container__ = __webpack_require__(1496);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__ncss_Container__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ncss_Button__ = __webpack_require__(601);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__ncss_Button__["a"]; });
/* unused harmony reexport IconButton */
/* unused harmony reexport LinkButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ncss_Select__ = __webpack_require__(1497);
/* unused harmony reexport NcssSelect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ncss_InputContainer__ = __webpack_require__(602);
/* unused harmony reexport InputContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ncss_Checkbox__ = __webpack_require__(370);
/* unused harmony reexport Checkbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ncss_TextInput__ = __webpack_require__(626);
/* unused harmony reexport TextInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ncss_Toggle__ = __webpack_require__(627);
/* unused harmony reexport Toggle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ncss_Headers__ = __webpack_require__(1584);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__ncss_Headers__["a"]; });
/* unused harmony reexport H2 */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_7__ncss_Headers__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_7__ncss_Headers__["c"]; });
/* unused harmony reexport H5 */
/* unused harmony reexport H6 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ncss_Label__ = __webpack_require__(189);
/* unused harmony reexport Label */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__errors_Generic__ = __webpack_require__(1585);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_9__errors_Generic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__errors_NotAuthorized__ = __webpack_require__(1586);
/* unused harmony reexport NotAuthorized */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__errors_NotFound__ = __webpack_require__(1587);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_11__errors_NotFound__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Link__ = __webpack_require__(1588);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_12__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Badge__ = __webpack_require__(1589);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_13__Badge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PageHeader__ = __webpack_require__(1590);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_14__PageHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PageTitle__ = __webpack_require__(1591);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_15__PageTitle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PageSpinner__ = __webpack_require__(1594);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_16__PageSpinner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__RenderInBody__ = __webpack_require__(1595);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_17__RenderInBody__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Spinner__ = __webpack_require__(1596);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_18__Spinner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Markdown__ = __webpack_require__(621);
/* unused harmony reexport Markdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__MarkdownEditor__ = __webpack_require__(1597);
/* unused harmony reexport MarkdownEditor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Gravatar__ = __webpack_require__(1607);
/* unused harmony reexport Gravatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Select__ = __webpack_require__(629);
/* unused harmony reexport Select */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Collapsible__ = __webpack_require__(1610);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_23__Collapsible__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Tooltip__ = __webpack_require__(256);
/* unused harmony reexport Tooltip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__InfoTooltip__ = __webpack_require__(603);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_25__InfoTooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Card__ = __webpack_require__(1612);
/* unused harmony reexport Card */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__DescriptionList__ = __webpack_require__(1613);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_27__DescriptionList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__JiraWikiEditor__ = __webpack_require__(630);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_28__JiraWikiEditor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__AccessStatusIndicator__ = __webpack_require__(2830);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_29__AccessStatusIndicator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__AppStatusIndicator__ = __webpack_require__(2831);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_30__AppStatusIndicator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ModalDialog__ = __webpack_require__(2832);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_31__ModalDialog__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__MentionProvider__ = __webpack_require__(3167);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_32__MentionProvider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__AtlasWikiRenderer__ = __webpack_require__(3171);
/* unused harmony reexport WikiRenderer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__RoutedTabs__ = __webpack_require__(3172);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_34__RoutedTabs__["a"]; });


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__splice__ = __webpack_require__(3209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getIn__ = __webpack_require__(3210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setIn__ = __webpack_require__(3235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__deepEqual__ = __webpack_require__(3236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__deleteIn__ = __webpack_require__(3269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keys__ = __webpack_require__(3270);








var structure = {
  allowsArrayErrors: true,
  empty: {},
  emptyList: [],
  getIn: __WEBPACK_IMPORTED_MODULE_1__getIn__["a" /* default */],
  setIn: __WEBPACK_IMPORTED_MODULE_2__setIn__["a" /* default */],
  deepEqual: __WEBPACK_IMPORTED_MODULE_3__deepEqual__["a" /* default */],
  deleteIn: __WEBPACK_IMPORTED_MODULE_4__deleteIn__["a" /* default */],
  forEach: function forEach(items, callback) {
    return items.forEach(callback);
  },
  fromJS: function fromJS(value) {
    return value;
  },
  keys: __WEBPACK_IMPORTED_MODULE_5__keys__["a" /* default */],
  size: function size(array) {
    return array ? array.length : 0;
  },
  some: function some(items, callback) {
    return items.some(callback);
  },
  splice: __WEBPACK_IMPORTED_MODULE_0__splice__["a" /* default */],
  toJS: function toJS(value) {
    return value;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (structure);

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sizes; });
var DefaultProps = {
  iconColor: 'inherit',
  textColor: 'currentColor',
  iconGradientStart: 'inherit',
  iconGradientStop: 'inherit',
  size: 'medium',
  label: ''
};
var sizes = {
  xsmall: 16,
  small: 24,
  medium: 32,
  large: 40,
  xlarge: 48
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Utilities
//



function _class(obj) { return Object.prototype.toString.call(obj); }

function isString(obj) { return _class(obj) === '[object String]'; }

var _hasOwnProperty = Object.prototype.hasOwnProperty;

function has(object, key) {
  return _hasOwnProperty.call(object, key);
}

// Merge objects
//
function assign(obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);

  sources.forEach(function (source) {
    if (!source) { return; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be object');
    }

    Object.keys(source).forEach(function (key) {
      obj[key] = source[key];
    });
  });

  return obj;
}

// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function arrayReplaceAt(src, pos, newElements) {
  return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}

////////////////////////////////////////////////////////////////////////////////

function isValidEntityCode(c) {
  /*eslint no-bitwise:0*/
  // broken sequence
  if (c >= 0xD800 && c <= 0xDFFF) { return false; }
  // never used
  if (c >= 0xFDD0 && c <= 0xFDEF) { return false; }
  if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) { return false; }
  // control codes
  if (c >= 0x00 && c <= 0x08) { return false; }
  if (c === 0x0B) { return false; }
  if (c >= 0x0E && c <= 0x1F) { return false; }
  if (c >= 0x7F && c <= 0x9F) { return false; }
  // out of range
  if (c > 0x10FFFF) { return false; }
  return true;
}

function fromCodePoint(c) {
  /*eslint no-bitwise:0*/
  if (c > 0xffff) {
    c -= 0x10000;
    var surrogate1 = 0xd800 + (c >> 10),
        surrogate2 = 0xdc00 + (c & 0x3ff);

    return String.fromCharCode(surrogate1, surrogate2);
  }
  return String.fromCharCode(c);
}


var UNESCAPE_MD_RE  = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
var ENTITY_RE       = /&([a-z#][a-z0-9]{1,31});/gi;
var UNESCAPE_ALL_RE = new RegExp(UNESCAPE_MD_RE.source + '|' + ENTITY_RE.source, 'gi');

var DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i;

var entities = __webpack_require__(859);

function replaceEntityPattern(match, name) {
  var code = 0;

  if (has(entities, name)) {
    return entities[name];
  }

  if (name.charCodeAt(0) === 0x23/* # */ && DIGITAL_ENTITY_TEST_RE.test(name)) {
    code = name[1].toLowerCase() === 'x' ?
      parseInt(name.slice(2), 16)
    :
      parseInt(name.slice(1), 10);
    if (isValidEntityCode(code)) {
      return fromCodePoint(code);
    }
  }

  return match;
}

/*function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
}*/

function unescapeMd(str) {
  if (str.indexOf('\\') < 0) { return str; }
  return str.replace(UNESCAPE_MD_RE, '$1');
}

function unescapeAll(str) {
  if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) { return str; }

  return str.replace(UNESCAPE_ALL_RE, function (match, escaped, entity) {
    if (escaped) { return escaped; }
    return replaceEntityPattern(match, entity);
  });
}

////////////////////////////////////////////////////////////////////////////////

var HTML_ESCAPE_TEST_RE = /[&<>"]/;
var HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var HTML_REPLACEMENTS = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;'
};

function replaceUnsafeChar(ch) {
  return HTML_REPLACEMENTS[ch];
}

function escapeHtml(str) {
  if (HTML_ESCAPE_TEST_RE.test(str)) {
    return str.replace(HTML_ESCAPE_REPLACE_RE, replaceUnsafeChar);
  }
  return str;
}

////////////////////////////////////////////////////////////////////////////////

var REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;

function escapeRE(str) {
  return str.replace(REGEXP_ESCAPE_RE, '\\$&');
}

////////////////////////////////////////////////////////////////////////////////

function isSpace(code) {
  switch (code) {
    case 0x09:
    case 0x20:
      return true;
  }
  return false;
}

// Zs (unicode class) || [\t\f\v\r\n]
function isWhiteSpace(code) {
  if (code >= 0x2000 && code <= 0x200A) { return true; }
  switch (code) {
    case 0x09: // \t
    case 0x0A: // \n
    case 0x0B: // \v
    case 0x0C: // \f
    case 0x0D: // \r
    case 0x20:
    case 0xA0:
    case 0x1680:
    case 0x202F:
    case 0x205F:
    case 0x3000:
      return true;
  }
  return false;
}

////////////////////////////////////////////////////////////////////////////////

/*eslint-disable max-len*/
var UNICODE_PUNCT_RE = __webpack_require__(375);

// Currently without astral characters support.
function isPunctChar(ch) {
  return UNICODE_PUNCT_RE.test(ch);
}


// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function isMdAsciiPunct(ch) {
  switch (ch) {
    case 0x21/* ! */:
    case 0x22/* " */:
    case 0x23/* # */:
    case 0x24/* $ */:
    case 0x25/* % */:
    case 0x26/* & */:
    case 0x27/* ' */:
    case 0x28/* ( */:
    case 0x29/* ) */:
    case 0x2A/* * */:
    case 0x2B/* + */:
    case 0x2C/* , */:
    case 0x2D/* - */:
    case 0x2E/* . */:
    case 0x2F/* / */:
    case 0x3A/* : */:
    case 0x3B/* ; */:
    case 0x3C/* < */:
    case 0x3D/* = */:
    case 0x3E/* > */:
    case 0x3F/* ? */:
    case 0x40/* @ */:
    case 0x5B/* [ */:
    case 0x5C/* \ */:
    case 0x5D/* ] */:
    case 0x5E/* ^ */:
    case 0x5F/* _ */:
    case 0x60/* ` */:
    case 0x7B/* { */:
    case 0x7C/* | */:
    case 0x7D/* } */:
    case 0x7E/* ~ */:
      return true;
    default:
      return false;
  }
}

// Hepler to unify [reference labels].
//
function normalizeReference(str) {
  // use .toUpperCase() instead of .toLowerCase()
  // here to avoid a conflict with Object.prototype
  // members (most notably, `__proto__`)
  return str.trim().replace(/\s+/g, ' ').toUpperCase();
}

////////////////////////////////////////////////////////////////////////////////

// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
exports.lib                 = {};
exports.lib.mdurl           = __webpack_require__(860);
exports.lib.ucmicro         = __webpack_require__(2646);

exports.assign              = assign;
exports.isString            = isString;
exports.has                 = has;
exports.unescapeMd          = unescapeMd;
exports.unescapeAll         = unescapeAll;
exports.isValidEntityCode   = isValidEntityCode;
exports.fromCodePoint       = fromCodePoint;
// exports.replaceEntities     = replaceEntities;
exports.escapeHtml          = escapeHtml;
exports.arrayReplaceAt      = arrayReplaceAt;
exports.isSpace             = isSpace;
exports.isWhiteSpace        = isWhiteSpace;
exports.isMdAsciiPunct      = isMdAsciiPunct;
exports.isPunctChar         = isPunctChar;
exports.escapeRE            = escapeRE;
exports.normalizeReference  = normalizeReference;


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnalyticsEvent__ = __webpack_require__(651);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AnalyticsEvent", function() { return __WEBPACK_IMPORTED_MODULE_0__AnalyticsEvent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UIAnalyticsEvent__ = __webpack_require__(382);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UIAnalyticsEvent", function() { return __WEBPACK_IMPORTED_MODULE_1__UIAnalyticsEvent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnalyticsListener__ = __webpack_require__(1757);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AnalyticsListener", function() { return __WEBPACK_IMPORTED_MODULE_2__AnalyticsListener__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnalyticsContext__ = __webpack_require__(652);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AnalyticsContext", function() { return __WEBPACK_IMPORTED_MODULE_3__AnalyticsContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__withAnalyticsContext__ = __webpack_require__(1758);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withAnalyticsContext", function() { return __WEBPACK_IMPORTED_MODULE_4__withAnalyticsContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__withAnalyticsEvents__ = __webpack_require__(1759);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withAnalyticsEvents", function() { return __WEBPACK_IMPORTED_MODULE_5__withAnalyticsEvents__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createAndFireEvent__ = __webpack_require__(1760);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createAndFireEvent", function() { return __WEBPACK_IMPORTED_MODULE_6__createAndFireEvent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cleanProps__ = __webpack_require__(1761);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cleanProps", function() { return __WEBPACK_IMPORTED_MODULE_7__cleanProps__["a"]; });
// Analytics event classes


// AnalyticsListener component
 // AnalyticsContext component and HOC


 // createAnalyticsEvent HOC

 // Helper functions




/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(27);





var Span = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].span.withConfig({
  displayName: "Wrapper__Span",
  componentId: "qx583l-0"
})(["\n  color: ", ";\n  display: inline-block;\n  fill: ", ";\n  height: ", "px;\n  position: relative;\n  user-select: none;\n\n  > svg {\n    fill: inherit;\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%;\n  }\n  > canvas {\n    display: block;\n    height: 100%;\n    visibility: hidden;\n  }\n  ", ";\n"], function (p) {
  return p.iconColor;
}, function (p) {
  return p.textColor;
}, function (p) {
  return __WEBPACK_IMPORTED_MODULE_4__constants__["b" /* sizes */][p.size];
}, function (p) {
  return (
    /* Only apply this if our stop-colors are inherit, if they aren't we don't need to set stop-color via css */
    p.iconGradientStart === 'inherit' && p.iconGradientStop === 'inherit' && Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["css"])(["\n      /* Stop-color doesn't properly apply in chrome when the inherited/current color changes.\n      * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS\n      * rule) and then override it with currentColor for the color changes to be picked up.\n      */\n      stop {\n        stop-color: currentColor;\n      }\n    "])
  );
});

var Wrapper = function Wrapper(_ref) {
  var label = _ref.label,
      svg = _ref.svg,
      rest = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref, ["label", "svg"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Span // We want to not add the aria-label if it does not exist for consistency
  // eslint-disable-next-line
  , __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
    "aria-label": label ? label : undefined,
    dangerouslySetInnerHTML: {
      __html: typeof svg === 'function' ? svg(String(rest.iconGradientStart), String(rest.iconGradientStop)) : svg
    }
  }, rest));
};

/* harmony default export */ __webpack_exports__["a"] = (Wrapper);

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(1427);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);



/**
 * Wraps component in a high order component that watches state changes of given plugins
 * and passes those states to the wrapped component.
 *
 * Example:
 * <WithPluginState
 *   eventDispatcher={eventDispatcher}
 *   editorView={editorView}
 *   plugins={{
 *     hyperlink: hyperlinkPluginKey
 *   }}
 *   render={renderComponent}
 * />
 *
 * renderComponent: ({ hyperlink }) => React.Component;
 */
var WithPluginState = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WithPluginState, _super);
    function WithPluginState(props, context) {
        var _this = _super.call(this, props) || this;
        _this.listeners = {};
        _this.debounce = null;
        _this.notAppliedState = {};
        _this.isSubscribed = false;
        _this.hasBeenMounted = false;
        _this.state = {};
        _this.handlePluginStateChange = function (propName, skipEqualityCheck) { return function (pluginState) {
            var _a;
            // skipEqualityCheck is being used for old plugins since they are mutating plugin state instead of creating a new one
            if (_this.state[propName] !== pluginState || skipEqualityCheck) {
                _this.updateState((_a = {}, _a[propName] = pluginState, _a));
            }
        }; };
        _this.onContextUpdate = function () {
            _this.subscribe(_this.props);
        };
        _this.state = _this.getPluginsStates(props.plugins, _this.getEditorView(props, context));
        return _this;
    }
    WithPluginState.prototype.getEditorView = function (maybeProps, maybeContext) {
        var props = maybeProps || this.props;
        var context = maybeContext || this.context;
        return (props.editorView ||
            (context &&
                context.editorActions &&
                context.editorActions._privateGetEditorView()));
    };
    WithPluginState.prototype.getEventDispatcher = function (maybeProps) {
        var props = maybeProps || this.props;
        return (props.eventDispatcher ||
            (this.context &&
                this.context.editorActions &&
                this.context.editorActions._privateGetEventDispatcher()));
    };
    /**
     * Debounces setState calls in order to reduce number of re-renders caused by several plugin state changes.
     */
    WithPluginState.prototype.updateState = function (stateSubset) {
        var _this = this;
        this.notAppliedState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, this.notAppliedState, stateSubset);
        if (this.debounce) {
            clearTimeout(this.debounce);
        }
        this.debounce = window.setTimeout(function () {
            if (_this.hasBeenMounted) {
                _this.setState(_this.notAppliedState);
            }
            _this.debounce = null;
            _this.notAppliedState = {};
        }, 10);
    };
    WithPluginState.prototype.getPluginsStates = function (plugins, editorView) {
        if (!editorView || !plugins) {
            return {};
        }
        return Object.keys(plugins).reduce(function (acc, propName) {
            var pluginKey = plugins[propName];
            if (!pluginKey) {
                return acc;
            }
            acc[propName] = pluginKey.getState(editorView.state);
            return acc;
        }, {});
    };
    WithPluginState.prototype.subscribe = function (props) {
        var _this = this;
        var plugins = props.plugins;
        var eventDispatcher = this.getEventDispatcher(props);
        var editorView = this.getEditorView(props);
        if (!eventDispatcher || !editorView || this.isSubscribed) {
            return;
        }
        this.isSubscribed = true;
        var pluginsStates = this.getPluginsStates(plugins, editorView);
        this.setState(pluginsStates);
        Object.keys(plugins).forEach(function (propName) {
            var pluginKey = plugins[propName];
            if (!pluginKey) {
                return;
            }
            var pluginState = pluginsStates[propName];
            var isPluginWithSubscribe = pluginState && pluginState.subscribe;
            var handler = _this.handlePluginStateChange(propName, isPluginWithSubscribe);
            if (isPluginWithSubscribe) {
                pluginState.subscribe(handler);
            }
            else {
                eventDispatcher.on(pluginKey.key, handler);
            }
            _this.listeners[pluginKey.key] = { handler: handler, pluginKey: pluginKey };
        });
    };
    WithPluginState.prototype.unsubscribe = function () {
        var _this = this;
        var eventDispatcher = this.getEventDispatcher();
        var editorView = this.getEditorView();
        if (!eventDispatcher || !editorView || !this.isSubscribed) {
            return;
        }
        Object.keys(this.listeners).forEach(function (key) {
            var pluginState = _this.listeners[key].pluginKey.getState(editorView.state);
            if (pluginState && pluginState.unsubscribe) {
                pluginState.unsubscribe(_this.listeners[key].handler);
            }
            else {
                eventDispatcher.off(key, _this.listeners[key].handler);
            }
        });
        this.listeners = [];
    };
    WithPluginState.prototype.subscribeToContextUpdates = function (context) {
        if (context && context.editorActions) {
            context.editorActions._privateSubscribe(this.onContextUpdate);
        }
    };
    WithPluginState.prototype.unsubscribeFromContextUpdates = function (context) {
        if (context && context.editorActions) {
            context.editorActions._privateUnsubscribe(this.onContextUpdate);
        }
    };
    WithPluginState.prototype.componentDidMount = function () {
        this.hasBeenMounted = true;
        this.subscribe(this.props);
        this.subscribeToContextUpdates(this.context);
    };
    WithPluginState.prototype.componentWillReceiveProps = function (nextProps) {
        if (!this.isSubscribed) {
            this.subscribe(nextProps);
        }
    };
    WithPluginState.prototype.componentWillUnmount = function () {
        this.unsubscribeFromContextUpdates(this.context);
        this.unsubscribe();
        this.hasBeenMounted = false;
    };
    WithPluginState.prototype.render = function () {
        var render = this.props.render;
        return render(this.state);
    };
    WithPluginState.contextTypes = {
        editorActions: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    };
    return WithPluginState;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (WithPluginState);
//# sourceMappingURL=index.js.map

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return serializeStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyMarks; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__serializers__ = __webpack_require__(1276);


var createTag = function (tagName, attrs, content) {
    var attrsList = [];
    Object.keys(attrs || {}).forEach(function (key) {
        var value = attrs[key];
        if (value === undefined) {
            return;
        }
        attrsList.push(key + "=\"" + String(value).replace(/"/g, '"') + "\"");
    });
    var attrsSerialized = attrsList.length ? " " + attrsList.join(' ') : '';
    return content
        ? "<" + tagName + attrsSerialized + ">" + content + "</" + tagName + ">"
        : "<" + tagName + attrsSerialized + "/>";
};
var serializeStyle = function (style) {
    return Object.keys(style).reduce(function (memo, key) {
        if (style[key] === undefined) {
            return memo;
        }
        var value = String(style[key]).replace(/"/g, '"');
        return (memo += key + ": " + value + ";");
    }, '');
};
var applyMarks = function (marks, text) {
    var e_1, _a;
    var output = text;
    try {
        for (var marks_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](marks), marks_1_1 = marks_1.next(); !marks_1_1.done; marks_1_1 = marks_1.next()) {
            var mark = marks_1_1.value;
            // ignore marks with unknown type
            if (__WEBPACK_IMPORTED_MODULE_1__serializers__["a" /* markSerializers */][mark.type.name]) {
                output = __WEBPACK_IMPORTED_MODULE_1__serializers__["a" /* markSerializers */][mark.type.name]({ mark: mark, text: output });
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (marks_1_1 && !marks_1_1.done && (_a = marks_1.return)) _a.call(marks_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return output;
};
//# sourceMappingURL=util.js.map

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Button__ = __webpack_require__(1771);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Button__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultProps", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Button__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ButtonGroup__ = __webpack_require__(1788);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return __WEBPACK_IMPORTED_MODULE_1__components_ButtonGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme__ = __webpack_require__(661);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "themeNamespace", function() { return __WEBPACK_IMPORTED_MODULE_2__theme__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(64);
/* unused harmony reexport compose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(31);
/* unused harmony reexport connect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_actions_js__ = __webpack_require__(357);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__util_actions_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__util_actions_js__["a"]; });
/* unused harmony reexport createPollingAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_requireLogin_js__ = __webpack_require__(187);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__auth_requireLogin_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_history_js__ = __webpack_require__(186);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__util_history_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_requestReducer_js__ = __webpack_require__(600);
/* unused harmony reexport selectRequestError */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__util_requestReducer_js__["b"]; });
/* unused harmony reexport selectIsAnyRequestPending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_index_js__ = __webpack_require__(25);
/* unused harmony reexport waitForAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__strings_js__ = __webpack_require__(3178);
/* unused harmony reexport pluralize */
/* unused harmony reexport endsWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__errors_js__ = __webpack_require__(3179);
/* unused harmony reexport getHttpErrorMessage */
/* unused harmony reexport logError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__http__ = __webpack_require__(496);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_9__http__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__normalize_js__ = __webpack_require__(3180);
/* unused harmony reexport normalizeArray */
/* unused harmony reexport normalizeVersionName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__validation_js__ = __webpack_require__(3181);
/* unused harmony reexport syncValidate */
/* unused harmony reexport submitIfValid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__jsonParse_js__ = __webpack_require__(3183);
/* unused harmony reexport tryJsonParse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__stateHydration_js__ = __webpack_require__(3184);
/* unused harmony reexport hydrateState */


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var keyName = _interopDefault(__webpack_require__(2003));
var prosemirrorState = __webpack_require__(11);

// declare global: navigator

var mac = typeof navigator != "undefined" ? /Mac/.test(navigator.platform) : false;

function normalizeKeyName(name) {
  var parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
  if (result == "Space") { result = " "; }
  var alt, ctrl, shift, meta;
  for (var i = 0; i < parts.length - 1; i++) {
    var mod = parts[i];
    if (/^(cmd|meta|m)$/i.test(mod)) { meta = true; }
    else if (/^a(lt)?$/i.test(mod)) { alt = true; }
    else if (/^(c|ctrl|control)$/i.test(mod)) { ctrl = true; }
    else if (/^s(hift)?$/i.test(mod)) { shift = true; }
    else if (/^mod$/i.test(mod)) { if (mac) { meta = true; } else { ctrl = true; } }
    else { throw new Error("Unrecognized modifier name: " + mod) }
  }
  if (alt) { result = "Alt-" + result; }
  if (ctrl) { result = "Ctrl-" + result; }
  if (meta) { result = "Meta-" + result; }
  if (shift) { result = "Shift-" + result; }
  return result
}

function normalize(map) {
  var copy = Object.create(null);
  for (var prop in map) { copy[normalizeKeyName(prop)] = map[prop]; }
  return copy
}

function modifiers(name, event, shift) {
  if (event.altKey) { name = "Alt-" + name; }
  if (event.ctrlKey) { name = "Ctrl-" + name; }
  if (event.metaKey) { name = "Meta-" + name; }
  if (shift !== false && event.shiftKey) { name = "Shift-" + name; }
  return name
}

// :: (Object) → Plugin
// Create a keymap plugin for the given set of bindings.
//
// Bindings should map key names to [command](#commands)-style
// functions, which will be called with `(EditorState, dispatch,
// EditorView)` arguments, and should return true when they've handled
// the key. Note that the view argument isn't part of the command
// protocol, but can be used as an escape hatch if a binding needs to
// directly interact with the UI.
//
// Key names may be strings like `"Shift-Ctrl-Enter"`—a key
// identifier prefixed with zero or more modifiers. Key identifiers
// are based on the strings that can appear in
// [`KeyEvent.key`](https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key).
// Use lowercase letters to refer to letter keys (or uppercase letters
// if you want shift to be held). You may use `"Space"` as an alias
// for the `" "` name.
//
// Modifiers can be given in any order. `Shift-` (or `s-`), `Alt-` (or
// `a-`), `Ctrl-` (or `c-` or `Control-`) and `Cmd-` (or `m-` or
// `Meta-`) are recognized. For characters that are created by holding
// shift, the `Shift-` prefix is implied, and should not be added
// explicitly.
//
// You can use `Mod-` as a shorthand for `Cmd-` on Mac and `Ctrl-` on
// other platforms.
//
// You can add multiple keymap plugins to an editor. The order in
// which they appear determines their precedence (the ones early in
// the array get to dispatch first).
function keymap(bindings) {
  return new prosemirrorState.Plugin({props: {handleKeyDown: keydownHandler(bindings)}})
}

// :: (Object) → (view: EditorView, event: dom.Event) → bool
// Given a set of bindings (using the same format as
// [`keymap`](#keymap.keymap), return a [keydown
// handler](#view.EditorProps.handleKeyDown) handles them.
function keydownHandler(bindings) {
  var map = normalize(bindings);
  return function(view, event) {
    var name = keyName(event), isChar = name.length == 1 && name != " ", baseName;
    var direct = map[modifiers(name, event, !isChar)];
    if (direct && direct(view.state, view.dispatch, view)) { return true }
    if (isChar && (event.shiftKey || event.altKey || event.metaKey) &&
        (baseName = keyName.base[event.keyCode]) && baseName != name) {
      var fromCode = map[modifiers(baseName, event, true)];
      if (fromCode && fromCode(view.state, view.dispatch, view)) { return true }
    }
    return false
  }
}

exports.keymap = keymap;
exports.keydownHandler = keydownHandler;
//# sourceMappingURL=keymap.js.map


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return toggleBold; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return toggleItalic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return toggleUnderline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return toggleStrikethrough; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return toggleCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return pastePlainText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return clearFormatting; });
/* unused harmony export setNormalText */
/* unused harmony export toggleHeading1 */
/* unused harmony export toggleHeading2 */
/* unused harmony export toggleHeading3 */
/* unused harmony export toggleHeading4 */
/* unused harmony export toggleHeading5 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return toggleOrderedList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return toggleBulletList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return toggleBlockQuote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return insertNewLine; });
/* unused harmony export shiftBackspace */
/* unused harmony export splitCodeBlock */
/* unused harmony export splitListItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return insertRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return undo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return moveUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return moveDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return moveLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return moveRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return indentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return outdentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return redo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return redoBarred; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return openHelp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return submit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return enter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return tab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return indent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return outdent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return backspace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return deleteKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return space; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return escape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return nextCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return previousCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return toggleTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return addRowBefore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return addRowAfter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addColumnAfter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addColumnBefore; });
/* unused harmony export cut */
/* unused harmony export copy */
/* unused harmony export paste */
/* unused harmony export altPaste */
/* harmony export (immutable) */ __webpack_exports__["S"] = tooltip;
/* harmony export (immutable) */ __webpack_exports__["n"] = findKeymapByDescription;
/* harmony export (immutable) */ __webpack_exports__["o"] = findShortcutByDescription;
/* harmony export (immutable) */ __webpack_exports__["p"] = findShortcutByKeymap;
/* harmony export (immutable) */ __webpack_exports__["h"] = bindKeymapWithCommand;
/* harmony export (immutable) */ __webpack_exports__["m"] = findKeyMapForBrowser;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LEFT; });
/* unused harmony export RIGHT */
/* unused harmony export UP */
/* unused harmony export DOWN */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_editor_common__ = __webpack_require__(13);

var toggleBold = makeKeyMapWithCommon('Bold', 'Mod-b');
var toggleItalic = makeKeyMapWithCommon('Italic', 'Mod-i');
var toggleUnderline = makeKeyMapWithCommon('Underline', 'Mod-u');
var toggleStrikethrough = makeKeyMapWithCommon('Strikethrough', 'Mod-Shift-s');
var toggleCode = makeKeyMapWithCommon('Code', 'Mod-Shift-m');
var pastePlainText = makeKeyMapWithCommon('Paste Plain Text', 'Mod-Shift-v');
var clearFormatting = makeKeyMapWithCommon('Clear formatting', 'Mod-\\');
var setNormalText = makeKeymap('Normal text', '', 'Cmd-Alt-0');
var toggleHeading1 = makeKeymap('Heading 1', '', 'Cmd-Alt-1');
var toggleHeading2 = makeKeymap('Heading 2', '', 'Cmd-Alt-2');
var toggleHeading3 = makeKeymap('Heading 3', '', 'Cmd-Alt-3');
var toggleHeading4 = makeKeymap('Heading 4', '', 'Cmd-Alt-4');
var toggleHeading5 = makeKeymap('Heading 5', '', 'Cmd-Alt-5');
var toggleOrderedList = makeKeymap('Numbered list', '', 'Cmd-Shift-7');
var toggleBulletList = makeKeymap('Bullet list', '', 'Cmd-Shift-8');
var toggleBlockQuote = makeKeymap('Block quote', '', 'Cmd-Alt-9');
var insertNewLine = makeKeyMapWithCommon('Insert new line', 'Shift-Enter');
var shiftBackspace = makeKeyMapWithCommon('Shift Backspace', 'Shift-Backspace');
var splitCodeBlock = makeKeyMapWithCommon('Split code block', 'Enter');
var splitListItem = makeKeyMapWithCommon('Split list item', 'Enter');
var insertRule = makeKeyMapWithCommon('Insert horizontal rule', 'Mod-Shift--');
var undo = makeKeyMapWithCommon('Undo', 'Mod-z');
var moveUp = makeKeyMapWithCommon('Move up', 'ArrowUp');
var moveDown = makeKeyMapWithCommon('Move down', 'ArrowDown');
var moveLeft = makeKeyMapWithCommon('Move left', 'ArrowLeft');
var moveRight = makeKeyMapWithCommon('Move right', 'ArrowRight');
var indentList = makeKeyMapWithCommon('Indent List', 'Tab');
var outdentList = makeKeyMapWithCommon('Outdent List', 'Shift-Tab');
var redo = makeKeymap('Redo', 'Ctrl-y', 'Cmd-Shift-z');
var redoBarred = makeKeymap('Redo Barred', 'Ctrl-Shift-z', 'Cmd-y');
var openHelp = makeKeyMapWithCommon('Open Help', 'Mod-/');
var addLink = makeKeyMapWithCommon('Link', 'Mod-k');
var submit = makeKeyMapWithCommon('Submit Content', 'Mod-Enter');
var enter = makeKeyMapWithCommon('Enter', 'Enter');
var tab = makeKeyMapWithCommon('Tab', 'Tab');
var indent = makeKeyMapWithCommon('Indent', 'Tab');
var outdent = makeKeyMapWithCommon('Outdent', 'Shift-Tab');
var backspace = makeKeyMapWithCommon('Backspace', 'Backspace');
var deleteKey = makeKeyMapWithCommon('Delete', 'Delete');
var space = makeKeyMapWithCommon('Space', 'Space');
var escape = makeKeyMapWithCommon('Escape', 'Escape');
var nextCell = makeKeyMapWithCommon('Next cell', 'Tab');
var previousCell = makeKeyMapWithCommon('Previous cell', 'Shift-Tab');
var toggleTable = makeKeyMapWithCommon('Table', 'Shift-Alt-t');
var addRowBefore = makeKeyMapWithCommon('Add Row Above', 'Ctrl-Alt-ArrowUp');
var addRowAfter = makeKeyMapWithCommon('Add Row Below', 'Ctrl-Alt-ArrowDown');
var addColumnAfter = makeKeyMapWithCommon('Add Column After', 'Ctrl-Alt-ArrowRight');
var addColumnBefore = makeKeyMapWithCommon('Add Column Before', 'Ctrl-Alt-ArrowLeft');
var cut = makeKeyMapWithCommon('Cut', 'Mod-x');
var copy = makeKeyMapWithCommon('Copy', 'Mod-c');
var paste = makeKeyMapWithCommon('Paste', 'Mod-v');
var altPaste = makeKeyMapWithCommon('Paste', 'Mod-Shift-v');
function tooltip(keymap, description) {
    if (keymap) {
        var shortcut = void 0;
        if (__WEBPACK_IMPORTED_MODULE_0__atlaskit_editor_common__["E" /* browser */].mac) {
            shortcut = keymap.mac
                .replace(/Cmd/i, '⌘')
                .replace(/Shift/i, '⇧')
                .replace(/Ctrl/i, '^')
                .replace(/Alt/i, '⌥');
        }
        else {
            shortcut = keymap.windows;
        }
        var keys = shortcut.split('-');
        keys[keys.length - 1] = keys[keys.length - 1].toUpperCase();
        shortcut = keys.join(__WEBPACK_IMPORTED_MODULE_0__atlaskit_editor_common__["E" /* browser */].mac ? '' : '+');
        return description ? description + " " + shortcut : shortcut;
    }
}
function findKeymapByDescription(description) {
    var matches = ALL.filter(function (keymap) { return keymap.description.toUpperCase() === description.toUpperCase(); });
    return matches[0];
}
function findShortcutByDescription(description) {
    var keymap = findKeymapByDescription(description);
    if (keymap) {
        return findShortcutByKeymap(keymap);
    }
}
function findShortcutByKeymap(keymap) {
    if (__WEBPACK_IMPORTED_MODULE_0__atlaskit_editor_common__["E" /* browser */].mac) {
        return keymap.mac;
    }
    return keymap.windows;
}
var ALL = [
    toggleOrderedList,
    toggleBulletList,
    toggleBold,
    toggleItalic,
    toggleUnderline,
    toggleStrikethrough,
    toggleCode,
    setNormalText,
    toggleHeading1,
    toggleHeading2,
    toggleHeading3,
    toggleHeading4,
    toggleHeading5,
    toggleBlockQuote,
    insertNewLine,
    insertRule,
    splitCodeBlock,
    splitListItem,
    redo,
    undo,
];
function makeKeymap(description, windows, mac, common) {
    return {
        description: description,
        windows: windows,
        mac: mac,
        common: common,
    };
}
function makeKeyMapWithCommon(description, common) {
    var windows = common.replace(/Mod/i, 'Ctrl');
    var mac = common.replace(/Mod/i, 'Cmd');
    return makeKeymap(description, windows, mac, common);
}
function bindKeymapWithCommand(shortcut, cmd, keymap) {
    var oldCmd = keymap[shortcut];
    var newCmd = cmd;
    if (keymap[shortcut]) {
        newCmd = function (state, dispatch, editorView) {
            return oldCmd(state, dispatch) || cmd(state, dispatch, editorView);
        };
    }
    keymap[shortcut] = newCmd;
}
function findKeyMapForBrowser(kayMap) {
    if (kayMap) {
        if (__WEBPACK_IMPORTED_MODULE_0__atlaskit_editor_common__["E" /* browser */].mac) {
            return kayMap.mac;
        }
        return kayMap.windows;
    }
}
var LEFT = 37;
var RIGHT = 39;
var UP = 38;
var DOWN = 40;
//# sourceMappingURL=index.js.map

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(1722);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_tooltip__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(2367);





var ToolbarButton = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ToolbarButton, _super);
    function ToolbarButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (event) {
            var _a = _this.props, disabled = _a.disabled, onClick = _a.onClick;
            if (!disabled && onClick) {
                onClick(event);
            }
        };
        return _this;
    }
    ToolbarButton.prototype.render = function () {
        var button = (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* AkButton */], { appearance: "subtle", ariaHaspopup: true, className: this.props.className, href: this.props.href, ariaLabel: this.props.ariaLabel, iconAfter: this.props.iconAfter, iconBefore: this.props.iconBefore, isDisabled: this.props.disabled, isSelected: this.props.selected, onClick: this.handleClick, spacing: this.props.spacing || 'default', target: this.props.target, theme: this.props.theme, shouldFitContainer: true }, this.props.children));
        var position = this.props.titlePosition || 'top';
        var tooltipContent = !this.props.hideTooltip ? this.props.title : null;
        return this.props.title ? (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__atlaskit_tooltip__["a" /* default */], { content: tooltipContent, hideTooltipOnClick: true, position: position }, button)) : (button);
    };
    ToolbarButton.defaultProps = {
        className: '',
    };
    return ToolbarButton;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (ToolbarButton);
//# sourceMappingURL=index.js.map

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(644);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__serviceResources__ = __webpack_require__(1737);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__serviceResources__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__serviceUtils__ = __webpack_require__(1738);



var utils = __WEBPACK_IMPORTED_MODULE_2__serviceUtils__;
//# sourceMappingURL=index.js.map

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(112);
var toSubscriber_1 = __webpack_require__(1848);
var observable_1 = __webpack_require__(391);
var pipe_1 = __webpack_require__(1849);
/**
 * A representation of any set of values over any amount of time. This is the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */
var Observable = (function () {
    /**
     * @constructor
     * @param {Function} subscribe the function that is called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    /**
     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
     *
     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
     *
     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
     * thought.
     *
     * Apart from starting the execution of an Observable, this method allows you to listen for values
     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
     * following ways.
     *
     * The first way is creating an object that implements {@link Observer} interface. It should have methods
     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
     * be left uncaught.
     *
     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
     *
     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
     *
     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
     * It is an Observable itself that decides when these functions will be called. For example {@link of}
     * by default emits all its values synchronously. Always check documentation for how given Observable
     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
     *
     * @example <caption>Subscribe with an Observer</caption>
     * const sumObserver = {
     *   sum: 0,
     *   next(value) {
     *     console.log('Adding: ' + value);
     *     this.sum = this.sum + value;
     *   },
     *   error() { // We actually could just remove this method,
     *   },        // since we do not really care about errors right now.
     *   complete() {
     *     console.log('Sum equals: ' + this.sum);
     *   }
     * };
     *
     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
     * .subscribe(sumObserver);
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Subscribe with functions</caption>
     * let sum = 0;
     *
     * Rx.Observable.of(1, 2, 3)
     * .subscribe(
     *   function(value) {
     *     console.log('Adding: ' + value);
     *     sum = sum + value;
     *   },
     *   undefined,
     *   function() {
     *     console.log('Sum equals: ' + sum);
     *   }
     * );
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Cancel a subscription</caption>
     * const subscription = Rx.Observable.interval(1000).subscribe(
     *   num => console.log(num),
     *   undefined,
     *   () => console.log('completed!') // Will not be called, even
     * );                                // when cancelling subscription
     *
     *
     * setTimeout(() => {
     *   subscription.unsubscribe();
     *   console.log('unsubscribed!');
     * }, 2500);
     *
     * // Logs:
     * // 0 after 1s
     * // 1 after 2s
     * // "unsubscribed!" after 2.5s
     *
     *
     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
     *  Observable.
     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
     *  the error will be thrown as unhandled.
     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
     * @return {ISubscription} a subscription reference to the registered handlers
     * @method subscribe
     */
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = toSubscriber_1.toSubscriber(observerOrNext, error, complete);
        if (operator) {
            operator.call(sink, this.source);
        }
        else {
            sink.add(this.source || !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        }
        if (sink.syncErrorThrowable) {
            sink.syncErrorThrowable = false;
            if (sink.syncErrorThrown) {
                throw sink.syncErrorValue;
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            sink.syncErrorThrown = true;
            sink.syncErrorValue = err;
            sink.error(err);
        }
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */
    Observable.prototype.forEach = function (next, PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
                PromiseCtor = root_1.root.Rx.config.Promise;
            }
            else if (root_1.root.Promise) {
                PromiseCtor = root_1.root.Promise;
            }
        }
        if (!PromiseCtor) {
            throw new Error('no Promise impl found');
        }
        return new PromiseCtor(function (resolve, reject) {
            // Must be declared in a separate statement to avoid a RefernceError when
            // accessing subscription below in the closure due to Temporal Dead Zone.
            var subscription;
            subscription = _this.subscribe(function (value) {
                if (subscription) {
                    // if there is a subscription, then we can surmise
                    // the next handling is asynchronous. Any errors thrown
                    // need to be rejected explicitly and unsubscribe must be
                    // called manually
                    try {
                        next(value);
                    }
                    catch (err) {
                        reject(err);
                        subscription.unsubscribe();
                    }
                }
                else {
                    // if there is NO subscription, then we're getting a nexted
                    // value synchronously during subscription. We can just call it.
                    // If it errors, Observable's `subscribe` will ensure the
                    // unsubscription logic is called, then synchronously rethrow the error.
                    // After that, Promise will trap the error and send it
                    // down the rejection path.
                    next(value);
                }
            }, reject, resolve);
        });
    };
    /** @deprecated internal use only */ Observable.prototype._subscribe = function (subscriber) {
        return this.source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */
    Observable.prototype[observable_1.observable] = function () {
        return this;
    };
    /* tslint:enable:max-line-length */
    /**
     * Used to stitch together functional operators into a chain.
     * @method pipe
     * @return {Observable} the Observable result of all of the operators having
     * been called in the order they were passed in.
     *
     * @example
     *
     * import { map, filter, scan } from 'rxjs/operators';
     *
     * Rx.Observable.interval(1000)
     *   .pipe(
     *     filter(x => x % 2 === 0),
     *     map(x => x + x),
     *     scan((acc, x) => acc + x)
     *   )
     *   .subscribe(x => console.log(x))
     */
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i - 0] = arguments[_i];
        }
        if (operations.length === 0) {
            return this;
        }
        return pipe_1.pipeFromArray(operations)(this);
    };
    /* tslint:enable:max-line-length */
    Observable.prototype.toPromise = function (PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
                PromiseCtor = root_1.root.Rx.config.Promise;
            }
            else if (root_1.root.Promise) {
                PromiseCtor = root_1.root.Promise;
            }
        }
        if (!PromiseCtor) {
            throw new Error('no Promise impl found');
        }
        return new PromiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     */
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());
exports.Observable = Observable;
//# sourceMappingURL=Observable.js.map

/***/ }),
/* 43 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TableDecorations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TableCssClassName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_editor_common__ = __webpack_require__(13);


var TableDecorations = {
    CONTROLS_HOVER: 'CONTROLS_HOVER',
};
var clPrefix = 'pm-table-';
var TableCssClassName = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, __WEBPACK_IMPORTED_MODULE_1__atlaskit_editor_common__["g" /* TableSharedCssClassName */], { COLUMN_CONTROLS_WRAPPER: clPrefix + "column-controls-wrapper", COLUMN_CONTROLS: clPrefix + "column-controls", COLUMN_CONTROLS_INNER: clPrefix + "column-controls__inner", COLUMN_CONTROLS_BUTTON_WRAP: clPrefix + "column-controls__button-wrap", ROW_CONTROLS_WRAPPER: clPrefix + "row-controls-wrapper", ROW_CONTROLS: clPrefix + "row-controls", ROW_CONTROLS_INNER: clPrefix + "row-controls__inner", ROW_CONTROLS_BUTTON_WRAP: clPrefix + "row-controls__button-wrap", CONTROLS_BUTTON: clPrefix + "controls__button", CONTROLS_BUTTON_ICON: clPrefix + "controls__button-icon", CONTROLS_INSERT_BUTTON: clPrefix + "controls__insert-button", CONTROLS_INSERT_BUTTON_INNER: clPrefix + "controls__insert-button-inner", CONTROLS_INSERT_BUTTON_WRAP: clPrefix + "controls__insert-button-wrap", CONTROLS_INSERT_LINE: clPrefix + "controls__insert-line", CONTROLS_BUTTON_OVERLAY: clPrefix + "controls__button-overlay", LAYOUT_BUTTON: clPrefix + "layout-button", CONTROLS_INSERT_MARKER: clPrefix + "controls__insert-marker", CONTROLS_INSERT_COLUMN: clPrefix + "controls__insert-column", CONTROLS_INSERT_ROW: clPrefix + "controls__insert-row", CONTROLS_DELETE_BUTTON_WRAP: clPrefix + "controls__delete-button-wrap", CONTROLS_DELETE_BUTTON: clPrefix + "controls__delete-button", CORNER_CONTROLS: clPrefix + "corner-controls", CONTROLS_CORNER_BUTTON: clPrefix + "corner-button", NUMBERED_COLUMN: clPrefix + "numbered-column", NUMBERED_COLUMN_BUTTON: clPrefix + "numbered-column__button", HOVERED_CELL: clPrefix + "hovered-cell", WITH_CONTROLS: clPrefix + "with-controls", RESIZING_PLUGIN: clPrefix + "resizing-plugin", RESIZE_CURSOR: clPrefix + "resize-cursor", IS_RESIZING: clPrefix + "is-resizing", CONTEXTUAL_SUBMENU: clPrefix + "contextual-submenu", CONTEXTUAL_MENU_BUTTON: clPrefix + "contextual-menu-button", CONTEXTUAL_MENU_ICON: clPrefix + "contextual-submenu-icon", CELL_NODEVIEW_WRAPPER: clPrefix + "cell-nodeview-wrapper", 
    // come from prosemirror-table
    COLUMN_RESIZE_HANDLE: 'column-resize-handle', SELECTED_CELL: 'selectedCell', 
    // defined in ReactNodeView based on PM node name
    NODEVIEW_WRAPPER: 'tableView-content-wrap', TABLE_HEADER_NODE_WRAPPER: 'tableHeaderView-content-wrap', TABLE_CELL_NODE_WRAPPER: 'tableCellView-content-wrap', TOP_LEFT_CELL: 'table > tbody > tr:nth-child(2) > td:nth-child(1)' });
//# sourceMappingURL=types.js.map

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TokenType; });
/* harmony export (immutable) */ __webpack_exports__["b"] = parseToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blockquote__ = __webpack_require__(2866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__citation__ = __webpack_require__(2868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__deleted__ = __webpack_require__(2870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__double_dash_symbol__ = __webpack_require__(2871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emoji__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emphasis__ = __webpack_require__(2872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hardbreak__ = __webpack_require__(2873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__heading__ = __webpack_require__(2874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__inserted__ = __webpack_require__(2875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__links_link_format__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__link_text__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__list__ = __webpack_require__(2876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__monospace__ = __webpack_require__(2878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__quadruple_dash_symbol__ = __webpack_require__(2879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ruler__ = __webpack_require__(2880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__strong__ = __webpack_require__(2882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__subscript__ = __webpack_require__(2883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__superscript__ = __webpack_require__(2884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__table__ = __webpack_require__(2885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__triple_dash_symbol__ = __webpack_require__(2887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__panel_macro__ = __webpack_require__(2888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__adf_macro__ = __webpack_require__(2891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__anchor_macro__ = __webpack_require__(2892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__code_macro__ = __webpack_require__(2893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__quote_macro__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__color_macro__ = __webpack_require__(2894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__noformat_macro__ = __webpack_require__(2962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__force_line_break__ = __webpack_require__(2963);
var _a;





























var TokenType;
(function (TokenType) {
    TokenType["ADF_MACRO"] = "ADF_MACRO";
    TokenType["ANCHOR_MACRO"] = "ANCHOR_MACRO";
    TokenType["CODE_MACRO"] = "CODE_MACRO";
    TokenType["QUOTE_MACRO"] = "QUOTE_MACRO";
    TokenType["NOFORMAT_MACRO"] = "NOFORMAT_MACRO";
    TokenType["PANEL_MACRO"] = "PANEL_MACRO";
    TokenType["COLOR_MACRO"] = "COLOR_MACRO";
    TokenType["LOREM_MACRO"] = "LOREM_MACRO";
    TokenType["QUOTE"] = "QUOTE";
    TokenType["STRING"] = "STRING";
    TokenType["LINK_FORMAT"] = "LINK_FORMAT";
    TokenType["LINK_TEXT"] = "LINK_TEXT";
    TokenType["MEDIA"] = "MEDIA";
    TokenType["HEADING"] = "HEADING";
    TokenType["LIST"] = "LIST";
    TokenType["TABLE"] = "TABLE";
    TokenType["RULER"] = "RULER";
    TokenType["HARD_BREAK"] = "HARD_BREAK";
    TokenType["DOUBLE_DASH_SYMBOL"] = "DOUBLE_DASH_SYMBOL";
    TokenType["TRIPLE_DASH_SYMBOL"] = "TRIPLE_DASH_SYMBOL";
    TokenType["QUADRUPLE_DASH_SYMBOL"] = "QUADRUPLE_DASH_SYMBOL";
    TokenType["STRONG"] = "STRONG";
    TokenType["MONOSPACE"] = "MONOSPACE";
    TokenType["SUPERSCRIPT"] = "SUPERSCRIPT";
    TokenType["SUBSCRIPT"] = "SUBSCRIPT";
    TokenType["EMPHASIS"] = "EMPHASIS";
    TokenType["CITATION"] = "CITATION";
    TokenType["DELETED"] = "DELETED";
    TokenType["INSERTED"] = "INSERTED";
    TokenType["EMOJI"] = "EMOJI";
    TokenType["FORCE_LINE_BREAK"] = "FORCE_LINE_BREAK";
})(TokenType || (TokenType = {}));
var tokenToTokenParserMapping = (_a = {},
    _a[TokenType.DOUBLE_DASH_SYMBOL] = __WEBPACK_IMPORTED_MODULE_4__double_dash_symbol__["a" /* doubleDashSymbol */],
    _a[TokenType.TRIPLE_DASH_SYMBOL] = __WEBPACK_IMPORTED_MODULE_20__triple_dash_symbol__["a" /* tripleDashSymbol */],
    _a[TokenType.QUADRUPLE_DASH_SYMBOL] = __WEBPACK_IMPORTED_MODULE_14__quadruple_dash_symbol__["a" /* quadrupleDashSymbol */],
    _a[TokenType.RULER] = __WEBPACK_IMPORTED_MODULE_15__ruler__["a" /* ruler */],
    _a[TokenType.STRONG] = __WEBPACK_IMPORTED_MODULE_16__strong__["a" /* strong */],
    _a[TokenType.MONOSPACE] = __WEBPACK_IMPORTED_MODULE_13__monospace__["a" /* monospace */],
    _a[TokenType.SUPERSCRIPT] = __WEBPACK_IMPORTED_MODULE_18__superscript__["a" /* superscript */],
    _a[TokenType.SUBSCRIPT] = __WEBPACK_IMPORTED_MODULE_17__subscript__["a" /* subscript */],
    _a[TokenType.EMPHASIS] = __WEBPACK_IMPORTED_MODULE_6__emphasis__["a" /* emphasis */],
    _a[TokenType.CITATION] = __WEBPACK_IMPORTED_MODULE_2__citation__["a" /* citation */],
    _a[TokenType.DELETED] = __WEBPACK_IMPORTED_MODULE_3__deleted__["a" /* deleted */],
    _a[TokenType.INSERTED] = __WEBPACK_IMPORTED_MODULE_9__inserted__["a" /* inserted */],
    _a[TokenType.HARD_BREAK] = __WEBPACK_IMPORTED_MODULE_7__hardbreak__["a" /* hardbreak */],
    _a[TokenType.LINK_FORMAT] = __WEBPACK_IMPORTED_MODULE_10__links_link_format__["a" /* linkFormat */],
    _a[TokenType.LINK_TEXT] = __WEBPACK_IMPORTED_MODULE_11__link_text__["b" /* linkText */],
    _a[TokenType.HEADING] = __WEBPACK_IMPORTED_MODULE_8__heading__["a" /* heading */],
    _a[TokenType.MEDIA] = __WEBPACK_IMPORTED_MODULE_0__media__["a" /* media */],
    _a[TokenType.LIST] = __WEBPACK_IMPORTED_MODULE_12__list__["a" /* list */],
    _a[TokenType.QUOTE] = __WEBPACK_IMPORTED_MODULE_1__blockquote__["a" /* blockquote */],
    _a[TokenType.TABLE] = __WEBPACK_IMPORTED_MODULE_19__table__["a" /* table */],
    _a[TokenType.EMOJI] = __WEBPACK_IMPORTED_MODULE_5__emoji__["b" /* emoji */],
    _a[TokenType.ADF_MACRO] = __WEBPACK_IMPORTED_MODULE_22__adf_macro__["a" /* adfMacro */],
    _a[TokenType.ANCHOR_MACRO] = __WEBPACK_IMPORTED_MODULE_23__anchor_macro__["a" /* anchorMacro */],
    _a[TokenType.CODE_MACRO] = __WEBPACK_IMPORTED_MODULE_24__code_macro__["a" /* codeMacro */],
    _a[TokenType.QUOTE_MACRO] = __WEBPACK_IMPORTED_MODULE_25__quote_macro__["a" /* quoteMacro */],
    _a[TokenType.NOFORMAT_MACRO] = __WEBPACK_IMPORTED_MODULE_27__noformat_macro__["a" /* noformatMacro */],
    _a[TokenType.PANEL_MACRO] = __WEBPACK_IMPORTED_MODULE_21__panel_macro__["a" /* panelMacro */],
    _a[TokenType.COLOR_MACRO] = __WEBPACK_IMPORTED_MODULE_26__color_macro__["a" /* colorMacro */],
    _a[TokenType.FORCE_LINE_BREAK] = __WEBPACK_IMPORTED_MODULE_28__force_line_break__["a" /* forceLineBreak */],
    _a);
function parseToken(input, type, position, schema, errCallback) {
    var tokenParser = tokenToTokenParserMapping[type];
    if (tokenParser) {
        try {
            return tokenParser(input, position, schema, errCallback);
        }
        catch (err) {
            if (errCallback) {
                errCallback(err, type);
            }
            return fallback(input, position);
        }
    }
    return fallback(input, position);
}
function fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1,
    };
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorModel = __webpack_require__(23);

// Mappable:: interface
// There are several things that positions can be mapped through.
// Such objects conform to this interface.
//
//   map:: (pos: number, assoc: ?number) → number
//   Map a position through this object. When given, `assoc` (should
//   be -1 or 1, defaults to 1) determines with which side the
//   position is associated, which determines in which direction to
//   move when a chunk of content is inserted at the mapped position.
//
//   mapResult:: (pos: number, assoc: ?number) → MapResult
//   Map a position, and return an object containing additional
//   information about the mapping. The result's `deleted` field tells
//   you whether the position was deleted (completely enclosed in a
//   replaced range) during the mapping. When content on only one side
//   is deleted, the position itself is only considered deleted when
//   `assoc` points in the direction of the deleted content.

// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.

var lower16 = 0xffff;
var factor16 = Math.pow(2, 16);

function makeRecover(index, offset) { return index + offset * factor16 }
function recoverIndex(value) { return value & lower16 }
function recoverOffset(value) { return (value - (value & lower16)) / factor16 }

// ::- An object representing a mapped position with extra
// information.
var MapResult = function MapResult(pos, deleted, recover) {
  if ( deleted === void 0 ) deleted = false;
  if ( recover === void 0 ) recover = null;

  // :: number The mapped version of the position.
  this.pos = pos;
  // :: bool Tells you whether the position was deleted, that is,
  // whether the step removed its surroundings from the document.
  this.deleted = deleted;
  this.recover = recover;
};

// :: class extends Mappable
// A map describing the deletions and insertions made by a step, which
// can be used to find the correspondence between positions in the
// pre-step version of a document and the same position in the
// post-step version.
var StepMap = function StepMap(ranges, inverted) {
  if ( inverted === void 0 ) inverted = false;

  this.ranges = ranges;
  this.inverted = inverted;
};

StepMap.prototype.recover = function recover (value) {
    var this$1 = this;

  var diff = 0, index = recoverIndex(value);
  if (!this.inverted) { for (var i = 0; i < index; i++)
    { diff += this$1.ranges[i * 3 + 2] - this$1.ranges[i * 3 + 1]; } }
  return this.ranges[index * 3] + diff + recoverOffset(value)
};

// : (number, ?number) → MapResult
StepMap.prototype.mapResult = function mapResult (pos, assoc) {
  if ( assoc === void 0 ) assoc = 1;
 return this._map(pos, assoc, false) };

// : (number, ?number) → number
StepMap.prototype.map = function map (pos, assoc) {
  if ( assoc === void 0 ) assoc = 1;
 return this._map(pos, assoc, true) };

StepMap.prototype._map = function _map (pos, assoc, simple) {
    var this$1 = this;

  var diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i = 0; i < this.ranges.length; i += 3) {
    var start = this$1.ranges[i] - (this$1.inverted ? diff : 0);
    if (start > pos) { break }
    var oldSize = this$1.ranges[i + oldIndex], newSize = this$1.ranges[i + newIndex], end = start + oldSize;
    if (pos <= end) {
      var side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
      var result = start + diff + (side < 0 ? 0 : newSize);
      if (simple) { return result }
      var recover = makeRecover(i / 3, pos - start);
      return new MapResult(result, assoc < 0 ? pos != start : pos != end, recover)
    }
    diff += newSize - oldSize;
  }
  return simple ? pos + diff : new MapResult(pos + diff)
};

StepMap.prototype.touches = function touches (pos, recover) {
    var this$1 = this;

  var diff = 0, index = recoverIndex(recover);
  var oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i = 0; i < this.ranges.length; i += 3) {
    var start = this$1.ranges[i] - (this$1.inverted ? diff : 0);
    if (start > pos) { break }
    var oldSize = this$1.ranges[i + oldIndex], end = start + oldSize;
    if (pos <= end && i == index * 3) { return true }
    diff += this$1.ranges[i + newIndex] - oldSize;
  }
  return false
};

// :: ((oldStart: number, oldEnd: number, newStart: number, newEnd: number))
// Calls the given function on each of the changed ranges included in
// this map.
StepMap.prototype.forEach = function forEach (f) {
    var this$1 = this;

  var oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
  for (var i = 0, diff = 0; i < this.ranges.length; i += 3) {
    var start = this$1.ranges[i], oldStart = start - (this$1.inverted ? diff : 0), newStart = start + (this$1.inverted ? 0 : diff);
    var oldSize = this$1.ranges[i + oldIndex], newSize = this$1.ranges[i + newIndex];
    f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
    diff += newSize - oldSize;
  }
};

// :: () → StepMap
// Create an inverted version of this map. The result can be used to
// map positions in the post-step document to the pre-step document.
StepMap.prototype.invert = function invert () {
  return new StepMap(this.ranges, !this.inverted)
};

StepMap.prototype.toString = function toString () {
  return (this.inverted ? "-" : "") + JSON.stringify(this.ranges)
};

// :: (n: number) → StepMap
// Create a map that moves all positions by offset `n` (which may be
// negative). This can be useful when applying steps meant for a
// sub-document to a larger document, or vice-versa.
StepMap.offset = function offset (n) {
  return n == 0 ? StepMap.empty : new StepMap(n < 0 ? [0, -n, 0] : [0, 0, n])
};

StepMap.empty = new StepMap([]);

// :: class extends Mappable
// A mapping represents a pipeline of zero or more [step
// maps](#transform.StepMap). It has special provisions for losslessly
// handling mapping positions through a series of steps in which some
// steps are inverted versions of earlier steps. (This comes up when
// ‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
// collaboration or history management.)
var Mapping = function Mapping(maps, mirror, from, to) {
  // :: [StepMap]
  // The step maps in this mapping.
  this.maps = maps || [];
  // :: number
  // The starting position in the `maps` array, used when `map` or
  // `mapResult` is called.
  this.from = from || 0;
  // :: number
  // The end position in the `maps` array.
  this.to = to == null ? this.maps.length : to;
  this.mirror = mirror;
};

// :: (?number, ?number) → Mapping
// Create a mapping that maps only through a part of this one.
Mapping.prototype.slice = function slice (from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.maps.length;

  return new Mapping(this.maps, this.mirror, from, to)
};

Mapping.prototype.copy = function copy () {
  return new Mapping(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to)
};

// :: (StepMap, ?number)
// Add a step map to the end of this mapping. If `mirrors` is
// given, it should be the index of the step map that is the mirror
// image of this one.
Mapping.prototype.appendMap = function appendMap (map, mirrors) {
  this.to = this.maps.push(map);
  if (mirrors != null) { this.setMirror(this.maps.length - 1, mirrors); }
};

// :: (Mapping)
// Add all the step maps in a given mapping to this one (preserving
// mirroring information).
Mapping.prototype.appendMapping = function appendMapping (mapping) {
    var this$1 = this;

  for (var i = 0, startSize = this.maps.length; i < mapping.maps.length; i++) {
    var mirr = mapping.getMirror(i);
    this$1.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : null);
  }
};

// :: (number) → ?number
// Finds the offset of the step map that mirrors the map at the
// given offset, in this mapping (as per the second argument to
// `appendMap`).
Mapping.prototype.getMirror = function getMirror (n) {
    var this$1 = this;

  if (this.mirror) { for (var i = 0; i < this.mirror.length; i++)
    { if (this$1.mirror[i] == n) { return this$1.mirror[i + (i % 2 ? -1 : 1)] } } }
};

Mapping.prototype.setMirror = function setMirror (n, m) {
  if (!this.mirror) { this.mirror = []; }
  this.mirror.push(n, m);
};

// :: (Mapping)
// Append the inverse of the given mapping to this one.
Mapping.prototype.appendMappingInverted = function appendMappingInverted (mapping) {
    var this$1 = this;

  for (var i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--) {
    var mirr = mapping.getMirror(i);
    this$1.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : null);
  }
};

// () → Mapping
// Create an inverted version of this mapping.
Mapping.prototype.invert = function invert () {
  var inverse = new Mapping;
  inverse.appendMappingInverted(this);
  return inverse
};

// : (number, ?number) → number
// Map a position through this mapping.
Mapping.prototype.map = function map (pos, assoc) {
    var this$1 = this;
    if ( assoc === void 0 ) assoc = 1;

  if (this.mirror) { return this._map(pos, assoc, true) }
  for (var i = this.from; i < this.to; i++)
    { pos = this$1.maps[i].map(pos, assoc); }
  return pos
};

// : (number, ?number) → MapResult
// Map a position through this mapping, returning a mapping
// result.
Mapping.prototype.mapResult = function mapResult (pos, assoc) {
  if ( assoc === void 0 ) assoc = 1;
 return this._map(pos, assoc, false) };

Mapping.prototype._map = function _map (pos, assoc, simple) {
    var this$1 = this;

  var deleted = false, recoverables = null;

  for (var i = this.from; i < this.to; i++) {
    var map = this$1.maps[i], rec = recoverables && recoverables[i];
    if (rec != null && map.touches(pos, rec)) {
      pos = map.recover(rec);
      continue
    }

    var result = map.mapResult(pos, assoc);
    if (result.recover != null) {
      var corr = this$1.getMirror(i);
      if (corr != null && corr > i && corr < this$1.to) {
        if (result.deleted) {
          i = corr;
          pos = this$1.maps[corr].recover(result.recover);
          continue
        } else {
          (recoverables || (recoverables = Object.create(null)))[corr] = result.recover;
        }
      }
    }

    if (result.deleted) { deleted = true; }
    pos = result.pos;
  }

  return simple ? pos : new MapResult(pos, deleted)
};

function TransformError(message) {
  var err = Error.call(this, message);
  err.__proto__ = TransformError.prototype;
  return err
}

TransformError.prototype = Object.create(Error.prototype);
TransformError.prototype.constructor = TransformError;
TransformError.prototype.name = "TransformError";

// ::- Abstraction to build up and track an array of
// [steps](#transform.Step) representing a document transformation.
//
// Most transforming methods return the `Transform` object itself, so
// that they can be chained.
var Transform = function Transform(doc) {
  // :: Node
  // The current document (the result of applying the steps in the
  // transform).
  this.doc = doc;
  // :: [Step]
  // The steps in this transform.
  this.steps = [];
  // :: [Node]
  // The documents before each of the steps.
  this.docs = [];
  // :: Mapping
  // A mapping with the maps for each of the steps in this transform.
  this.mapping = new Mapping;
};

var prototypeAccessors = { before: {},docChanged: {} };

// :: Node The starting document.
prototypeAccessors.before.get = function () { return this.docs.length ? this.docs[0] : this.doc };

// :: (step: Step) → this
// Apply a new step in this transform, saving the result. Throws an
// error when the step fails.
Transform.prototype.step = function step (object) {
  var result = this.maybeStep(object);
  if (result.failed) { throw new TransformError(result.failed) }
  return this
};

// :: (Step) → StepResult
// Try to apply a step in this transformation, ignoring it if it
// fails. Returns the step result.
Transform.prototype.maybeStep = function maybeStep (step) {
  var result = step.apply(this.doc);
  if (!result.failed) { this.addStep(step, result.doc); }
  return result
};

// :: bool
// True when the document has been changed (when there are any
// steps).
prototypeAccessors.docChanged.get = function () {
  return this.steps.length > 0
};

Transform.prototype.addStep = function addStep (step, doc) {
  this.docs.push(this.doc);
  this.steps.push(step);
  this.mapping.appendMap(step.getMap());
  this.doc = doc;
};

Object.defineProperties( Transform.prototype, prototypeAccessors );

function mustOverride() { throw new Error("Override me") }

var stepsByID = Object.create(null);

// ::- A step object represents an atomic change. It generally applies
// only to the document it was created for, since the positions
// stored in it will only make sense for that document.
//
// New steps are defined by creating classes that extend `Step`,
// overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
// methods, and registering your class with a unique
// JSON-serialization identifier using
// [`Step.jsonID`](#transform.Step^jsonID).
var Step = function Step () {};

Step.prototype.apply = function apply (_doc) { return mustOverride() };

// :: () → StepMap
// Get the step map that represents the changes made by this step,
// and which can be used to transform between positions in the old
// and the new document.
Step.prototype.getMap = function getMap () { return StepMap.empty };

// :: (doc: Node) → Step
// Create an inverted version of this step. Needs the document as it
// was before the step as argument.
Step.prototype.invert = function invert (_doc) { return mustOverride() };

// :: (mapping: Mappable) → ?Step
// Map this step through a mappable thing, returning either a
// version of that step with its positions adjusted, or `null` if
// the step was entirely deleted by the mapping.
Step.prototype.map = function map (_mapping) { return mustOverride() };

// :: (other: Step) → ?Step
// Try to merge this step with another one, to be applied directly
// after it. Returns the merged step when possible, null if the
// steps can't be merged.
Step.prototype.merge = function merge (_other) { return null };

// :: () → Object
// Create a JSON-serializeable representation of this step. When
// defining this for a custom subclass, make sure the result object
// includes the step type's [JSON id](#transform.Step^jsonID) under
// the `stepType` property.
Step.prototype.toJSON = function toJSON () { return mustOverride() };

// :: (Schema, Object) → Step
// Deserialize a step from its JSON representation. Will call
// through to the step class' own implementation of this method.
Step.fromJSON = function fromJSON (schema, json) {
  if (!json || !json.stepType) { throw new RangeError("Invalid input for Step.fromJSON") }
  var type = stepsByID[json.stepType];
  if (!type) { throw new RangeError(("No step type " + (json.stepType) + " defined")) }
  return type.fromJSON(schema, json)
};

// :: (string, constructor<Step>)
// To be able to serialize steps to JSON, each step needs a string
// ID to attach to its JSON representation. Use this method to
// register an ID for your step classes. Try to pick something
// that's unlikely to clash with steps from other modules.
Step.jsonID = function jsonID (id, stepClass) {
  if (id in stepsByID) { throw new RangeError("Duplicate use of step JSON ID " + id) }
  stepsByID[id] = stepClass;
  stepClass.prototype.jsonID = id;
  return stepClass
};

// ::- The result of [applying](#transform.Step.apply) a step. Contains either a
// new document or a failure value.
var StepResult = function StepResult(doc, failed) {
  // :: ?Node The transformed document.
  this.doc = doc;
  // :: ?string Text providing information about a failed step.
  this.failed = failed;
};

// :: (Node) → StepResult
// Create a successful step result.
StepResult.ok = function ok (doc) { return new StepResult(doc, null) };

// :: (string) → StepResult
// Create a failed step result.
StepResult.fail = function fail (message) { return new StepResult(null, message) };

// :: (Node, number, number, Slice) → StepResult
// Call [`Node.replace`](#model.Node.replace) with the given
// arguments. Create a successful result if it succeeds, and a
// failed one if it throws a `ReplaceError`.
StepResult.fromReplace = function fromReplace (doc, from, to, slice) {
  try {
    return StepResult.ok(doc.replace(from, to, slice))
  } catch (e) {
    if (e instanceof prosemirrorModel.ReplaceError) { return StepResult.fail(e.message) }
    throw e
  }
};

// ::- Replace a part of the document with a slice of new content.
var ReplaceStep = (function (Step$$1) {
  function ReplaceStep(from, to, slice, structure) {
    Step$$1.call(this);
    this.from = from;
    this.to = to;
    this.slice = slice;
    this.structure = !!structure;
  }

  if ( Step$$1 ) ReplaceStep.__proto__ = Step$$1;
  ReplaceStep.prototype = Object.create( Step$$1 && Step$$1.prototype );
  ReplaceStep.prototype.constructor = ReplaceStep;

  ReplaceStep.prototype.apply = function apply (doc) {
    if (this.structure && contentBetween(doc, this.from, this.to))
      { return StepResult.fail("Structure replace would overwrite content") }
    return StepResult.fromReplace(doc, this.from, this.to, this.slice)
  };

  ReplaceStep.prototype.getMap = function getMap () {
    return new StepMap([this.from, this.to - this.from, this.slice.size])
  };

  ReplaceStep.prototype.invert = function invert (doc) {
    return new ReplaceStep(this.from, this.from + this.slice.size, doc.slice(this.from, this.to))
  };

  ReplaceStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from.deleted && to.deleted) { return null }
    return new ReplaceStep(from.pos, Math.max(from.pos, to.pos), this.slice)
  };

  ReplaceStep.prototype.merge = function merge (other) {
    if (!(other instanceof ReplaceStep) || other.structure != this.structure) { return null }

    if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
      var slice = this.slice.size + other.slice.size == 0 ? prosemirrorModel.Slice.empty
          : new prosemirrorModel.Slice(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
      return new ReplaceStep(this.from, this.to + (other.to - other.from), slice, this.structure)
    } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
      var slice$1 = this.slice.size + other.slice.size == 0 ? prosemirrorModel.Slice.empty
          : new prosemirrorModel.Slice(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
      return new ReplaceStep(other.from, this.to, slice$1, this.structure)
    } else {
      return null
    }
  };

  ReplaceStep.prototype.toJSON = function toJSON () {
    var json = {stepType: "replace", from: this.from, to: this.to};
    if (this.slice.size) { json.slice = this.slice.toJSON(); }
    if (this.structure) { json.structure = true; }
    return json
  };

  ReplaceStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      { throw new RangeError("Invalid input for ReplaceStep.fromJSON") }
    return new ReplaceStep(json.from, json.to, prosemirrorModel.Slice.fromJSON(schema, json.slice), !!json.structure)
  };

  return ReplaceStep;
}(Step));

Step.jsonID("replace", ReplaceStep);

// ::- Replace a part of the document with a slice of content, but
// preserve a range of the replaced content by moving it into the
// slice.
var ReplaceAroundStep = (function (Step$$1) {
  function ReplaceAroundStep(from, to, gapFrom, gapTo, slice, insert, structure) {
    Step$$1.call(this);
    this.from = from;
    this.to = to;
    this.gapFrom = gapFrom;
    this.gapTo = gapTo;
    this.slice = slice;
    this.insert = insert;
    this.structure = !!structure;
  }

  if ( Step$$1 ) ReplaceAroundStep.__proto__ = Step$$1;
  ReplaceAroundStep.prototype = Object.create( Step$$1 && Step$$1.prototype );
  ReplaceAroundStep.prototype.constructor = ReplaceAroundStep;

  ReplaceAroundStep.prototype.apply = function apply (doc) {
    if (this.structure && (contentBetween(doc, this.from, this.gapFrom) ||
                           contentBetween(doc, this.gapTo, this.to)))
      { return StepResult.fail("Structure gap-replace would overwrite content") }

    var gap = doc.slice(this.gapFrom, this.gapTo);
    if (gap.openStart || gap.openEnd)
      { return StepResult.fail("Gap is not a flat range") }
    var inserted = this.slice.insertAt(this.insert, gap.content);
    if (!inserted) { return StepResult.fail("Content does not fit in gap") }
    return StepResult.fromReplace(doc, this.from, this.to, inserted)
  };

  ReplaceAroundStep.prototype.getMap = function getMap () {
    return new StepMap([this.from, this.gapFrom - this.from, this.insert,
                        this.gapTo, this.to - this.gapTo, this.slice.size - this.insert])
  };

  ReplaceAroundStep.prototype.invert = function invert (doc) {
    var gap = this.gapTo - this.gapFrom;
    return new ReplaceAroundStep(this.from, this.from + this.slice.size + gap,
                                 this.from + this.insert, this.from + this.insert + gap,
                                 doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from),
                                 this.gapFrom - this.from, this.structure)
  };

  ReplaceAroundStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    var gapFrom = mapping.map(this.gapFrom, -1), gapTo = mapping.map(this.gapTo, 1);
    if ((from.deleted && to.deleted) || gapFrom < from.pos || gapTo > to.pos) { return null }
    return new ReplaceAroundStep(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure)
  };

  ReplaceAroundStep.prototype.toJSON = function toJSON () {
    var json = {stepType: "replaceAround", from: this.from, to: this.to,
                gapFrom: this.gapFrom, gapTo: this.gapTo, insert: this.insert};
    if (this.slice.size) { json.slice = this.slice.toJSON(); }
    if (this.structure) { json.structure = true; }
    return json
  };

  ReplaceAroundStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number" ||
        typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number")
      { throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON") }
    return new ReplaceAroundStep(json.from, json.to, json.gapFrom, json.gapTo,
                                 prosemirrorModel.Slice.fromJSON(schema, json.slice), json.insert, !!json.structure)
  };

  return ReplaceAroundStep;
}(Step));

Step.jsonID("replaceAround", ReplaceAroundStep);

function contentBetween(doc, from, to) {
  var $from = doc.resolve(from), dist = to - from, depth = $from.depth;
  while (dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount) {
    depth--;
    dist--;
  }
  if (dist > 0) {
    var next = $from.node(depth).maybeChild($from.indexAfter(depth));
    while (dist > 0) {
      if (!next || next.isLeaf) { return true }
      next = next.firstChild;
      dist--;
    }
  }
  return false
}

function canCut(node, start, end) {
  return (start == 0 || node.canReplace(start, node.childCount)) &&
    (end == node.childCount || node.canReplace(0, end))
}

// :: (NodeRange) → ?number
// Try to find a target depth to which the content in the given range
// can be lifted. Will not go across
// [isolating](#model.NodeSpec.isolating) parent nodes.
function liftTarget(range) {
  var parent = range.parent;
  var content = parent.content.cutByIndex(range.startIndex, range.endIndex);
  for (var depth = range.depth;; --depth) {
    var node = range.$from.node(depth);
    var index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
    if (depth < range.depth && node.canReplace(index, endIndex, content))
      { return depth }
    if (depth == 0 || node.type.spec.isolating || !canCut(node, index, endIndex)) { break }
  }
}

// :: (NodeRange, number) → this
// Split the content in the given range off from its parent, if there
// is sibling content before or after it, and move it up the tree to
// the depth specified by `target`. You'll probably want to use
// [`liftTarget`](#transform.liftTarget) to compute `target`, to make
// sure the lift is valid.
Transform.prototype.lift = function(range, target) {
  var $from = range.$from;
  var $to = range.$to;
  var depth = range.depth;

  var gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
  var start = gapStart, end = gapEnd;

  var before = prosemirrorModel.Fragment.empty, openStart = 0;
  for (var d = depth, splitting = false; d > target; d--)
    { if (splitting || $from.index(d) > 0) {
      splitting = true;
      before = prosemirrorModel.Fragment.from($from.node(d).copy(before));
      openStart++;
    } else {
      start--;
    } }
  var after = prosemirrorModel.Fragment.empty, openEnd = 0;
  for (var d$1 = depth, splitting$1 = false; d$1 > target; d$1--)
    { if (splitting$1 || $to.after(d$1 + 1) < $to.end(d$1)) {
      splitting$1 = true;
      after = prosemirrorModel.Fragment.from($to.node(d$1).copy(after));
      openEnd++;
    } else {
      end++;
    } }

  return this.step(new ReplaceAroundStep(start, end, gapStart, gapEnd,
                                         new prosemirrorModel.Slice(before.append(after), openStart, openEnd),
                                         before.size - openStart, true))
};

// :: (NodeRange, NodeType, ?Object, ?NodeRange) → ?[{type: NodeType, attrs: ?Object}]
// Try to find a valid way to wrap the content in the given range in a
// node of the given type. May introduce extra nodes around and inside
// the wrapper node, if necessary. Returns null if no valid wrapping
// could be found. When `innerRange` is given, that range's content is
// used as the content to fit into the wrapping, instead of the
// content of `range`.
function findWrapping(range, nodeType, attrs, innerRange) {
  if ( innerRange === void 0 ) innerRange = range;

  var around = findWrappingOutside(range, nodeType);
  var inner = around && findWrappingInside(innerRange, nodeType);
  if (!inner) { return null }
  return around.map(withAttrs).concat({type: nodeType, attrs: attrs}).concat(inner.map(withAttrs))
}

function withAttrs(type) { return {type: type, attrs: null} }

function findWrappingOutside(range, type) {
  var parent = range.parent;
  var startIndex = range.startIndex;
  var endIndex = range.endIndex;
  var around = parent.contentMatchAt(startIndex).findWrapping(type);
  if (!around) { return null }
  var outer = around.length ? around[0] : type;
  return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null
}

function findWrappingInside(range, type) {
  var parent = range.parent;
  var startIndex = range.startIndex;
  var endIndex = range.endIndex;
  var inner = parent.child(startIndex);
  var inside = type.contentMatch.findWrapping(inner.type);
  if (!inside) { return null }
  var lastType = inside.length ? inside[inside.length - 1] : type;
  var innerMatch = lastType.contentMatch;
  for (var i = startIndex; innerMatch && i < endIndex; i++)
    { innerMatch = innerMatch.matchType(parent.child(i).type); }
  if (!innerMatch || !innerMatch.validEnd) { return null }
  return inside
}

// :: (NodeRange, [{type: NodeType, attrs: ?Object}]) → this
// Wrap the given [range](#model.NodeRange) in the given set of wrappers.
// The wrappers are assumed to be valid in this position, and should
// probably be computed with [`findWrapping`](#transform.findWrapping).
Transform.prototype.wrap = function(range, wrappers) {
  var content = prosemirrorModel.Fragment.empty;
  for (var i = wrappers.length - 1; i >= 0; i--)
    { content = prosemirrorModel.Fragment.from(wrappers[i].type.create(wrappers[i].attrs, content)); }

  var start = range.start, end = range.end;
  return this.step(new ReplaceAroundStep(start, end, start, end, new prosemirrorModel.Slice(content, 0, 0), wrappers.length, true))
};

// :: (number, ?number, NodeType, ?Object) → this
// Set the type of all textblocks (partly) between `from` and `to` to
// the given node type with the given attributes.
Transform.prototype.setBlockType = function(from, to, type, attrs) {
  var this$1 = this;
  if ( to === void 0 ) to = from;

  if (!type.isTextblock) { throw new RangeError("Type given to setBlockType should be a textblock") }
  var mapFrom = this.steps.length;
  this.doc.nodesBetween(from, to, function (node, pos) {
    if (node.isTextblock && !node.hasMarkup(type, attrs) && canChangeType(this$1.doc, this$1.mapping.slice(mapFrom).map(pos), type)) {
      // Ensure all markup that isn't allowed in the new node type is cleared
      this$1.clearIncompatible(this$1.mapping.slice(mapFrom).map(pos, 1), type);
      var mapping = this$1.mapping.slice(mapFrom);
      var startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
      this$1.step(new ReplaceAroundStep(startM, endM, startM + 1, endM - 1,
                                      new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(type.create(attrs, null, node.marks)), 0, 0), 1, true));
      return false
    }
  });
  return this
};

function canChangeType(doc, pos, type) {
  var $pos = doc.resolve(pos), index = $pos.index();
  return $pos.parent.canReplaceWith(index, index + 1, type)
}

// :: (number, ?NodeType, ?Object, ?[Mark]) → this
// Change the type, attributes, and/or marks of the node at `pos`.
// When `type` isn't given, the existing node type is preserved,
Transform.prototype.setNodeMarkup = function(pos, type, attrs, marks) {
  var node = this.doc.nodeAt(pos);
  if (!node) { throw new RangeError("No node at given position") }
  if (!type) { type = node.type; }
  var newNode = type.create(attrs, null, marks || node.marks);
  if (node.isLeaf)
    { return this.replaceWith(pos, pos + node.nodeSize, newNode) }

  if (!type.validContent(node.content))
    { throw new RangeError("Invalid content for node type " + type.name) }

  return this.step(new ReplaceAroundStep(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1,
                                         new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(newNode), 0, 0), 1, true))
};

// :: (Node, number, number, ?[?{type: NodeType, attrs: ?Object}]) → bool
// Check whether splitting at the given position is allowed.
function canSplit(doc, pos, depth, typesAfter) {
  if ( depth === void 0 ) depth = 1;

  var $pos = doc.resolve(pos), base = $pos.depth - depth;
  var innerType = (typesAfter && typesAfter[typesAfter.length - 1]) || $pos.parent;
  if (base < 0 || $pos.parent.type.spec.isolating ||
      !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) ||
      !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount)))
    { return false }
  for (var d = $pos.depth - 1, i = depth - 2; d > base; d--, i--) {
    var node = $pos.node(d), index$1 = $pos.index(d);
    if (node.type.spec.isolating) { return false }
    var rest = node.content.cutByIndex(index$1, node.childCount);
    var after = (typesAfter && typesAfter[i]) || node;
    if (after != node) { rest = rest.replaceChild(0, after.type.create(after.attrs)); }
    if (!node.canReplace(index$1 + 1, node.childCount) || !after.type.validContent(rest))
      { return false }
  }
  var index = $pos.indexAfter(base);
  var baseType = typesAfter && typesAfter[0];
  return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type)
}

// :: (number, ?number, ?[?{type: NodeType, attrs: ?Object}]) → this
// Split the node at the given position, and optionally, if `depth` is
// greater than one, any number of nodes above that. By default, the
// parts split off will inherit the node type of the original node.
// This can be changed by passing an array of types and attributes to
// use after the split.
Transform.prototype.split = function(pos, depth, typesAfter) {
  if ( depth === void 0 ) depth = 1;

  var $pos = this.doc.resolve(pos), before = prosemirrorModel.Fragment.empty, after = prosemirrorModel.Fragment.empty;
  for (var d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--) {
    before = prosemirrorModel.Fragment.from($pos.node(d).copy(before));
    var typeAfter = typesAfter && typesAfter[i];
    after = prosemirrorModel.Fragment.from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
  }
  return this.step(new ReplaceStep(pos, pos, new prosemirrorModel.Slice(before.append(after), depth, depth, true)))
};

// :: (Node, number) → bool
// Test whether the blocks before and after a given position can be
// joined.
function canJoin(doc, pos) {
  var $pos = doc.resolve(pos), index = $pos.index();
  return joinable($pos.nodeBefore, $pos.nodeAfter) &&
    $pos.parent.canReplace(index, index + 1)
}

function joinable(a, b) {
  return a && b && !a.isLeaf && a.canAppend(b)
}

// :: (Node, number, ?number) → ?number
// Find an ancestor of the given position that can be joined to the
// block before (or after if `dir` is positive). Returns the joinable
// point, if any.
function joinPoint(doc, pos, dir) {
  if ( dir === void 0 ) dir = -1;

  var $pos = doc.resolve(pos);
  for (var d = $pos.depth;; d--) {
    var before = (void 0), after = (void 0);
    if (d == $pos.depth) {
      before = $pos.nodeBefore;
      after = $pos.nodeAfter;
    } else if (dir > 0) {
      before = $pos.node(d + 1);
      after = $pos.node(d).maybeChild($pos.index(d) + 1);
    } else {
      before = $pos.node(d).maybeChild($pos.index(d) - 1);
      after = $pos.node(d + 1);
    }
    if (before && !before.isTextblock && joinable(before, after)) { return pos }
    if (d == 0) { break }
    pos = dir < 0 ? $pos.before(d) : $pos.after(d);
  }
}

// :: (number, ?number) → this
// Join the blocks around the given position. If depth is 2, their
// last and first siblings are also joined, and so on.
Transform.prototype.join = function(pos, depth) {
  if ( depth === void 0 ) depth = 1;

  var step = new ReplaceStep(pos - depth, pos + depth, prosemirrorModel.Slice.empty, true);
  return this.step(step)
};

// :: (Node, number, NodeType) → ?number
// Try to find a point where a node of the given type can be inserted
// near `pos`, by searching up the node hierarchy when `pos` itself
// isn't a valid place but is at the start or end of a node. Return
// null if no position was found.
function insertPoint(doc, pos, nodeType) {
  var $pos = doc.resolve(pos);
  if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) { return pos }

  if ($pos.parentOffset == 0)
    { for (var d = $pos.depth - 1; d >= 0; d--) {
      var index = $pos.index(d);
      if ($pos.node(d).canReplaceWith(index, index, nodeType)) { return $pos.before(d + 1) }
      if (index > 0) { return null }
    } }
  if ($pos.parentOffset == $pos.parent.content.size)
    { for (var d$1 = $pos.depth - 1; d$1 >= 0; d$1--) {
      var index$1 = $pos.indexAfter(d$1);
      if ($pos.node(d$1).canReplaceWith(index$1, index$1, nodeType)) { return $pos.after(d$1 + 1) }
      if (index$1 < $pos.node(d$1).childCount) { return null }
    } }
}

// :: (Node, number, Slice) → ?number
// Finds a position at or around the given position where the given
// slice can be inserted. Will look at parent nodes' nearest boundary
// and try there, even if the original position wasn't directly at the
// start or end of that node. Returns null when no position was found.
function dropPoint(doc, pos, slice) {
  var $pos = doc.resolve(pos);
  if (!slice.content.size) { return pos }
  var content = slice.content;
  for (var i = 0; i < slice.openStart; i++) { content = content.firstChild.content; }
  for (var pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++) {
    for (var d = $pos.depth; d >= 0; d--) {
      var bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
      var insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
      if (pass == 1
          ? $pos.node(d).canReplace(insertPos, insertPos, content)
          : $pos.node(d).contentMatchAt(insertPos).findWrapping(content.firstChild.type))
        { return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1) }
    }
  }
  return null
}

function mapFragment(fragment, f, parent) {
  var mapped = [];
  for (var i = 0; i < fragment.childCount; i++) {
    var child = fragment.child(i);
    if (child.content.size) { child = child.copy(mapFragment(child.content, f, child)); }
    if (child.isInline) { child = f(child, parent, i); }
    mapped.push(child);
  }
  return prosemirrorModel.Fragment.fromArray(mapped)
}

// ::- Add a mark to all inline content between two positions.
var AddMarkStep = (function (Step$$1) {
  function AddMarkStep(from, to, mark) {
    Step$$1.call(this);
    this.from = from;
    this.to = to;
    this.mark = mark;
  }

  if ( Step$$1 ) AddMarkStep.__proto__ = Step$$1;
  AddMarkStep.prototype = Object.create( Step$$1 && Step$$1.prototype );
  AddMarkStep.prototype.constructor = AddMarkStep;

  AddMarkStep.prototype.apply = function apply (doc) {
    var this$1 = this;

    var oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
    var parent = $from.node($from.sharedDepth(this.to));
    var slice = new prosemirrorModel.Slice(mapFragment(oldSlice.content, function (node, parent) {
      if (!parent.type.allowsMarkType(this$1.mark.type)) { return node }
      return node.mark(this$1.mark.addToSet(node.marks))
    }, parent), oldSlice.openStart, oldSlice.openEnd);
    return StepResult.fromReplace(doc, this.from, this.to, slice)
  };

  AddMarkStep.prototype.invert = function invert () {
    return new RemoveMarkStep(this.from, this.to, this.mark)
  };

  AddMarkStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from.deleted && to.deleted || from.pos >= to.pos) { return null }
    return new AddMarkStep(from.pos, to.pos, this.mark)
  };

  AddMarkStep.prototype.merge = function merge (other) {
    if (other instanceof AddMarkStep &&
        other.mark.eq(this.mark) &&
        this.from <= other.to && this.to >= other.from)
      { return new AddMarkStep(Math.min(this.from, other.from),
                             Math.max(this.to, other.to), this.mark) }
  };

  AddMarkStep.prototype.toJSON = function toJSON () {
    return {stepType: "addMark", mark: this.mark.toJSON(),
            from: this.from, to: this.to}
  };

  AddMarkStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      { throw new RangeError("Invalid input for AddMarkStep.fromJSON") }
    return new AddMarkStep(json.from, json.to, schema.markFromJSON(json.mark))
  };

  return AddMarkStep;
}(Step));

Step.jsonID("addMark", AddMarkStep);

// ::- Remove a mark from all inline content between two positions.
var RemoveMarkStep = (function (Step$$1) {
  function RemoveMarkStep(from, to, mark) {
    Step$$1.call(this);
    this.from = from;
    this.to = to;
    this.mark = mark;
  }

  if ( Step$$1 ) RemoveMarkStep.__proto__ = Step$$1;
  RemoveMarkStep.prototype = Object.create( Step$$1 && Step$$1.prototype );
  RemoveMarkStep.prototype.constructor = RemoveMarkStep;

  RemoveMarkStep.prototype.apply = function apply (doc) {
    var this$1 = this;

    var oldSlice = doc.slice(this.from, this.to);
    var slice = new prosemirrorModel.Slice(mapFragment(oldSlice.content, function (node) {
      return node.mark(this$1.mark.removeFromSet(node.marks))
    }), oldSlice.openStart, oldSlice.openEnd);
    return StepResult.fromReplace(doc, this.from, this.to, slice)
  };

  RemoveMarkStep.prototype.invert = function invert () {
    return new AddMarkStep(this.from, this.to, this.mark)
  };

  RemoveMarkStep.prototype.map = function map (mapping) {
    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
    if (from.deleted && to.deleted || from.pos >= to.pos) { return null }
    return new RemoveMarkStep(from.pos, to.pos, this.mark)
  };

  RemoveMarkStep.prototype.merge = function merge (other) {
    if (other instanceof RemoveMarkStep &&
        other.mark.eq(this.mark) &&
        this.from <= other.to && this.to >= other.from)
      { return new RemoveMarkStep(Math.min(this.from, other.from),
                                Math.max(this.to, other.to), this.mark) }
  };

  RemoveMarkStep.prototype.toJSON = function toJSON () {
    return {stepType: "removeMark", mark: this.mark.toJSON(),
            from: this.from, to: this.to}
  };

  RemoveMarkStep.fromJSON = function fromJSON (schema, json) {
    if (typeof json.from != "number" || typeof json.to != "number")
      { throw new RangeError("Invalid input for RemoveMarkStep.fromJSON") }
    return new RemoveMarkStep(json.from, json.to, schema.markFromJSON(json.mark))
  };

  return RemoveMarkStep;
}(Step));

Step.jsonID("removeMark", RemoveMarkStep);

// :: (number, number, Mark) → this
// Add the given mark to the inline content between `from` and `to`.
Transform.prototype.addMark = function(from, to, mark) {
  var this$1 = this;

  var removed = [], added = [], removing = null, adding = null;
  this.doc.nodesBetween(from, to, function (node, pos, parent) {
    if (!node.isInline) { return }
    var marks = node.marks;
    if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
      var start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
      var newSet = mark.addToSet(marks);

      for (var i = 0; i < marks.length; i++) {
        if (!marks[i].isInSet(newSet)) {
          if (removing && removing.to == start && removing.mark.eq(marks[i]))
            { removing.to = end; }
          else
            { removed.push(removing = new RemoveMarkStep(start, end, marks[i])); }
        }
      }

      if (adding && adding.to == start)
        { adding.to = end; }
      else
        { added.push(adding = new AddMarkStep(start, end, mark)); }
    }
  });

  removed.forEach(function (s) { return this$1.step(s); });
  added.forEach(function (s) { return this$1.step(s); });
  return this
};

// :: (number, number, ?union<Mark, MarkType>) → this
// Remove marks from inline nodes between `from` and `to`. When `mark`
// is a single mark, remove precisely that mark. When it is a mark type,
// remove all marks of that type. When it is null, remove all marks of
// any type.
Transform.prototype.removeMark = function(from, to, mark) {
  var this$1 = this;
  if ( mark === void 0 ) mark = null;

  var matched = [], step = 0;
  this.doc.nodesBetween(from, to, function (node, pos) {
    if (!node.isInline) { return }
    step++;
    var toRemove = null;
    if (mark instanceof prosemirrorModel.MarkType) {
      var found = mark.isInSet(node.marks);
      if (found) { toRemove = [found]; }
    } else if (mark) {
      if (mark.isInSet(node.marks)) { toRemove = [mark]; }
    } else {
      toRemove = node.marks;
    }
    if (toRemove && toRemove.length) {
      var end = Math.min(pos + node.nodeSize, to);
      for (var i = 0; i < toRemove.length; i++) {
        var style = toRemove[i], found$1 = (void 0);
        for (var j = 0; j < matched.length; j++) {
          var m = matched[j];
          if (m.step == step - 1 && style.eq(matched[j].style)) { found$1 = m; }
        }
        if (found$1) {
          found$1.to = end;
          found$1.step = step;
        } else {
          matched.push({style: style, from: Math.max(pos, from), to: end, step: step});
        }
      }
    }
  });
  matched.forEach(function (m) { return this$1.step(new RemoveMarkStep(m.from, m.to, m.style)); });
  return this
};

// :: (number, NodeType, ?ContentMatch) → this
// Removes all marks and nodes from the content of the node at `pos`
// that don't match the given new parent node type. Accepts an
// optional starting [content match](#model.ContentMatch) as third
// argument.
Transform.prototype.clearIncompatible = function(pos, parentType, match) {
  var this$1 = this;
  if ( match === void 0 ) match = parentType.contentMatch;

  var node = this.doc.nodeAt(pos);
  var delSteps = [], cur = pos + 1;
  for (var i = 0; i < node.childCount; i++) {
    var child = node.child(i), end = cur + child.nodeSize;
    var allowed = match.matchType(child.type, child.attrs);
    if (!allowed) {
      delSteps.push(new ReplaceStep(cur, end, prosemirrorModel.Slice.empty));
    } else {
      match = allowed;
      for (var j = 0; j < child.marks.length; j++) { if (!parentType.allowsMarkType(child.marks[j].type))
        { this$1.step(new RemoveMarkStep(cur, end, child.marks[j])); } }
    }
    cur = end;
  }
  if (!match.validEnd) {
    var fill = match.fillBefore(prosemirrorModel.Fragment.empty, true);
    this.replace(cur, cur, new prosemirrorModel.Slice(fill, 0, 0));
  }
  for (var i$1 = delSteps.length - 1; i$1 >= 0; i$1--) { this$1.step(delSteps[i$1]); }
  return this
};

// :: (Node, number, ?number, ?Slice) → ?Step
// ‘Fit’ a slice into a given position in the document, producing a
// [step](#transform.Step) that inserts it. Will return null if
// there's no meaningful way to insert the slice here, or inserting it
// would be a no-op (an empty slice over an empty range).
function replaceStep(doc, from, to, slice) {
  if ( to === void 0 ) to = from;
  if ( slice === void 0 ) slice = prosemirrorModel.Slice.empty;

  if (from == to && !slice.size) { return null }

  var $from = doc.resolve(from), $to = doc.resolve(to);
  // Optimization -- avoid work if it's obvious that it's not needed.
  if (fitsTrivially($from, $to, slice)) { return new ReplaceStep(from, to, slice) }
  var placed = placeSlice($from, slice);

  var fittedLeft = fitLeft($from, placed);
  var fitted = fitRight($from, $to, fittedLeft);
  if (!fitted) { return null }
  if (fittedLeft.size != fitted.size && canMoveText($from, $to, fittedLeft)) {
    var d = $to.depth, after = $to.after(d);
    while (d > 1 && after == $to.end(--d)) { ++after; }
    var fittedAfter = fitRight($from, doc.resolve(after), fittedLeft);
    if (fittedAfter)
      { return new ReplaceAroundStep(from, after, to, $to.end(), fittedAfter, fittedLeft.size) }
  }
  return fitted.size || from != to ? new ReplaceStep(from, to, fitted) : null
}

// :: (number, ?number, ?Slice) → this
// Replace the part of the document between `from` and `to` with the
// given `slice`.
Transform.prototype.replace = function(from, to, slice) {
  if ( to === void 0 ) to = from;
  if ( slice === void 0 ) slice = prosemirrorModel.Slice.empty;

  var step = replaceStep(this.doc, from, to, slice);
  if (step) { this.step(step); }
  return this
};

// :: (number, number, union<Fragment, Node, [Node]>) → this
// Replace the given range with the given content, which may be a
// fragment, node, or array of nodes.
Transform.prototype.replaceWith = function(from, to, content) {
  return this.replace(from, to, new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(content), 0, 0))
};

// :: (number, number) → this
// Delete the content between the given positions.
Transform.prototype.delete = function(from, to) {
  return this.replace(from, to, prosemirrorModel.Slice.empty)
};

// :: (number, union<Fragment, Node, [Node]>) → this
// Insert the given content at the given position.
Transform.prototype.insert = function(pos, content) {
  return this.replaceWith(pos, pos, content)
};



function fitLeftInner($from, depth, placed, placedBelow) {
  var content = prosemirrorModel.Fragment.empty, openEnd = 0, placedHere = placed[depth];
  if ($from.depth > depth) {
    var inner = fitLeftInner($from, depth + 1, placed, placedBelow || placedHere);
    openEnd = inner.openEnd + 1;
    content = prosemirrorModel.Fragment.from($from.node(depth + 1).copy(inner.content));
  }

  if (placedHere) {
    content = content.append(placedHere.content);
    openEnd = placedHere.openEnd;
  }
  if (placedBelow) {
    content = content.append($from.node(depth).contentMatchAt($from.indexAfter(depth)).fillBefore(prosemirrorModel.Fragment.empty, true));
    openEnd = 0;
  }

  return {content: content, openEnd: openEnd}
}

function fitLeft($from, placed) {
  var ref = fitLeftInner($from, 0, placed, false);
  var content = ref.content;
  var openEnd = ref.openEnd;
  return new prosemirrorModel.Slice(content, $from.depth, openEnd || 0)
}

function fitRightJoin(content, parent, $from, $to, depth, openStart, openEnd) {
  var match, count = content.childCount, matchCount = count - (openEnd > 0 ? 1 : 0);
  var parentNode = openStart < 0 ? parent : $from.node(depth);
  if (openStart < 0)
    { match = parentNode.contentMatchAt(matchCount); }
  else if (count == 1 && openEnd > 0)
    { match = parentNode.contentMatchAt(openStart ? $from.index(depth) : $from.indexAfter(depth)); }
  else
    { match = parentNode.contentMatchAt($from.indexAfter(depth))
      .matchFragment(content, count > 0 && openStart ? 1 : 0, matchCount); }

  var toNode = $to.node(depth);
  if (openEnd > 0 && depth < $to.depth) {
    var after = toNode.content.cutByIndex($to.indexAfter(depth)).addToStart(content.lastChild);
    var joinable$1 = match.fillBefore(after, true);
    // Can't insert content if there's a single node stretched across this gap
    if (joinable$1 && joinable$1.size && openStart > 0 && count == 1) { joinable$1 = null; }

    if (joinable$1) {
      var inner = fitRightJoin(content.lastChild.content, content.lastChild, $from, $to,
                               depth + 1, count == 1 ? openStart - 1 : -1, openEnd - 1);
      if (inner) {
        var last = content.lastChild.copy(inner);
        if (joinable$1.size)
          { return content.cutByIndex(0, count - 1).append(joinable$1).addToEnd(last) }
        else
          { return content.replaceChild(count - 1, last) }
      }
    }
  }
  if (openEnd > 0)
    { match = match.matchType((count == 1 && openStart > 0 ? $from.node(depth + 1) : content.lastChild).type); }

  // If we're here, the next level can't be joined, so we see what
  // happens if we leave it open.
  var toIndex = $to.index(depth);
  if (toIndex == toNode.childCount && !toNode.type.compatibleContent(parent.type)) { return null }
  var joinable = match.fillBefore(toNode.content, true, toIndex);
  for (var i = toIndex; joinable && i < toNode.content.childCount; i++)
    { if (!parentNode.type.allowsMarks(toNode.content.child(i).marks)) { joinable = null; } }
  if (!joinable) { return null }

  if (openEnd > 0) {
    var closed = fitRightClosed(content.lastChild, openEnd - 1, $from, depth + 1,
                                count == 1 ? openStart - 1 : -1);
    content = content.replaceChild(count - 1, closed);
  }
  content = content.append(joinable);
  if ($to.depth > depth)
    { content = content.addToEnd(fitRightSeparate($to, depth + 1)); }
  return content
}

function fitRightClosed(node, openEnd, $from, depth, openStart) {
  var match, content = node.content, count = content.childCount;
  if (openStart >= 0)
    { match = $from.node(depth).contentMatchAt($from.indexAfter(depth))
      .matchFragment(content, openStart > 0 ? 1 : 0, count); }
  else
    { match = node.contentMatchAt(count); }

  if (openEnd > 0) {
    var closed = fitRightClosed(content.lastChild, openEnd - 1, $from, depth + 1,
                                count == 1 ? openStart - 1 : -1);
    content = content.replaceChild(count - 1, closed);
  }

  return node.copy(content.append(match.fillBefore(prosemirrorModel.Fragment.empty, true)))
}

function fitRightSeparate($to, depth) {
  var node = $to.node(depth);
  var fill = node.contentMatchAt(0).fillBefore(node.content, true, $to.index(depth));
  if ($to.depth > depth) { fill = fill.addToEnd(fitRightSeparate($to, depth + 1)); }
  return node.copy(fill)
}

function normalizeSlice(content, openStart, openEnd) {
  while (openStart > 0 && openEnd > 0 && content.childCount == 1) {
    content = content.firstChild.content;
    openStart--;
    openEnd--;
  }
  return new prosemirrorModel.Slice(content, openStart, openEnd)
}

// : (ResolvedPos, ResolvedPos, number, Slice) → Slice
function fitRight($from, $to, slice) {
  var fitted = fitRightJoin(slice.content, $from.node(0), $from, $to, 0, slice.openStart, slice.openEnd);
  if (!fitted) { return null }
  return normalizeSlice(fitted, slice.openStart, $to.depth)
}

function fitsTrivially($from, $to, slice) {
  return !slice.openStart && !slice.openEnd && $from.start() == $to.start() &&
    $from.parent.canReplace($from.index(), $to.index(), slice.content)
}

function canMoveText($from, $to, slice) {
  if (!$to.parent.isTextblock) { return false }

  var parent = slice.openEnd ? nodeRight(slice.content, slice.openEnd)
      : $from.node($from.depth - (slice.openStart - slice.openEnd));
  if (!parent.isTextblock) { return false }
  for (var i = $to.index(); i < $to.parent.childCount; i++)
    { if (!parent.type.allowsMarks($to.parent.child(i).marks)) { return false } }
  var match;
  if (slice.openEnd) {
    match = parent.contentMatchAt(parent.childCount);
  } else {
    match = parent.contentMatchAt(parent.childCount);
    if (slice.size) { match = match.matchFragment(slice.content, slice.openStart ? 1 : 0); }
  }
  match = match.matchFragment($to.parent.content, $to.index());
  return match && match.validEnd
}

function nodeRight(content, depth) {
  for (var i = 1; i < depth; i++) { content = content.lastChild.content; }
  return content.lastChild
}

// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// So placeSlice splits up a slice into a number of sub-slices,
// along with information on where they can be placed on the given
// left-side edge. It works by walking the open side of the slice,
// from the inside out, and trying to find a landing spot for each
// element, by simultaneously scanning over the gap side. When no
// place is found for an open node's content, it is left in that node.

// : (ResolvedPos, Slice) → [{content: Fragment, openEnd: number, depth: number}]
function placeSlice($from, slice) {
  var frontier = new Frontier($from);
  for (var pass = 1; slice.size && pass <= 3; pass++)
    { slice = frontier.placeSlice(slice.content, slice.openStart, slice.openEnd, pass); }
  while (frontier.open.length) { frontier.closeNode(); }
  return frontier.placed
}

// Helper class that models the open side of the insert position,
// keeping track of the content match and already inserted content
// at each depth.
var Frontier = function Frontier($pos) {
  var this$1 = this;

  // : [{parent: Node, match: ContentMatch, content: Fragment, wrapper: bool, openEnd: number, depth: number}]
  this.open = [];
  for (var d = 0; d <= $pos.depth; d++) {
    var parent = $pos.node(d), match = parent.contentMatchAt($pos.indexAfter(d));
    this$1.open.push({parent: parent, match: match, content: prosemirrorModel.Fragment.empty, wrapper: false, openEnd: 0, depth: d});
  }
  this.placed = [];
};

// : (Fragment, number, number, number, ?Node) → Slice
// Tries to place the content of the given slice, and returns a
// slice containing unplaced content.
//
// pass 1: try to fit directly
// pass 2: allow wrapper nodes to be introduced
// pass 3: allow unwrapping of nodes that aren't open
Frontier.prototype.placeSlice = function placeSlice (fragment, openStart, openEnd, pass, parent) {
    var this$1 = this;

  if (openStart > 0) {
    var first = fragment.firstChild;
    var inner = this.placeSlice(first.content, Math.max(0, openStart - 1),
                                openEnd && fragment.childCount == 1 ? openEnd - 1 : 0,
                                pass, first);
    if (inner.content != first.content) {
      if (inner.content.size) {
        fragment = fragment.replaceChild(0, first.copy(inner.content));
        openStart = inner.openStart + 1;
      } else {
        if (fragment.childCount == 1) { openEnd = 0; }
        fragment = fragment.cutByIndex(1);
        openStart = 0;
      }
    }
  }
  var result = this.placeContent(fragment, openStart, openEnd, pass, parent);
  if (pass > 2 && result.size && openStart == 0) {
    for (var i = 0; i < result.content.childCount; i++) {
      var child = result.content.child(i);
      this$1.placeContent(child.content, 0,
                        openEnd && i == result.content.childCount.length - 1 ? openEnd - 1 : 0,
                        pass, child);
    }
    result = prosemirrorModel.Fragment.empty;
  }
  return result
};

Frontier.prototype.placeContent = function placeContent (fragment, openStart, openEnd, pass, parent) {
    var this$1 = this;

  var i = 0;
  // Go over the fragment's children
  for (; i < fragment.childCount; i++) {
    var child = fragment.child(i), placed = false, last = i == fragment.childCount - 1;
    // Try each open node in turn, starting from the innermost
    for (var d = this.open.length - 1; d >= 0; d--) {
      var open = this$1.open[d], wrap = (void 0);

      // If pass > 1, it is allowed to wrap the node to help find a
      // fit, so if findWrappeing returns something, we add open
      // nodes to the frontier for that wrapping.
      if (pass > 1 && (wrap = open.match.findWrapping(child.type)) &&
          !(parent && wrap.length && wrap[wrap.length - 1] == parent.type)) {
        while (this.open.length - 1 > d) { this$1.closeNode(); }
        for (var w = 0; w < wrap.length; w++) {
          open.match = open.match.matchType(wrap[w]);
          d++;
          open = {parent: wrap[w].create(),
                  match: wrap[w].contentMatch,
                  content: prosemirrorModel.Fragment.empty, wrapper: true, openEnd: 0, depth: d + w};
          this$1.open.push(open);
        }
      }

      // See if the child fits here
      var match = open.match.matchType(child.type);
      if (!match) {
        var fill = open.match.fillBefore(prosemirrorModel.Fragment.from(child));
        if (fill) {
          for (var j = 0; j < fill.childCount; j++) {
            var ch = fill.child(j);
            this$1.addNode(open, ch, 0);
            match = open.match.matchFragment(ch);
          }
        } else if (parent && open.match.matchType(parent.type)) {
          // Don't continue looking further up if the parent node
          // would fit here.
          break
        } else {
          continue
        }
      }

      // Close open nodes above this one, since we're starting to
      // add to this.
      while (this.open.length - 1 > d) { this$1.closeNode(); }
      // Strip marks from the child or close its start when necessary
      child = child.mark(open.parent.type.allowedMarks(child.marks));
      if (openStart) {
        child = closeNodeStart(child, openStart, last ? openEnd : 0);
        openStart = 0;
      }
      // Add the child to this open node and adjust its metadata
      this$1.addNode(open, child, last ? openEnd : 0);
      open.match = match;
      if (last) { openEnd = 0; }
      placed = true;
      break
    }
    // As soon as we've failed to place a node we stop looking at
    // later nodes
    if (!placed) { break }
  }
  // Close the current open node if it's not the the root and we
  // either placed up to the end of the node or the the current
  // slice depth's node type matches the open node's type
  if (this.open.length > 1 &&
      (i > 0 && i == fragment.childCount ||
       parent && this.open[this.open.length - 1].parent.type == parent.type))
    { this.closeNode(); }

  return new prosemirrorModel.Slice(fragment.cutByIndex(i), openStart, openEnd)
};

Frontier.prototype.addNode = function addNode (open, node, openEnd) {
  open.content = closeFragmentEnd(open.content, open.openEnd).addToEnd(node);
  open.openEnd = openEnd;
};

Frontier.prototype.closeNode = function closeNode () {
  var open = this.open.pop();
  if (open.content.size == 0) {
    // Nothing here
  } else if (open.wrapper) {
    this.addNode(this.open[this.open.length - 1], open.parent.copy(open.content), open.openEnd + 1);
  } else {
    this.placed[open.depth] = {depth: open.depth, content: open.content, openEnd: open.openEnd};
  }
};

function closeNodeStart(node, openStart, openEnd) {
  var content = node.content;
  if (openStart > 1) {
    var first = closeNodeStart(node.firstChild, openStart - 1, node.childCount == 1 ? openEnd - 1 : 0);
    content = node.content.replaceChild(0, first);
  }
  var fill = node.type.contentMatch.fillBefore(content, openEnd == 0);
  return node.copy(fill.append(content))
}

function closeNodeEnd(node, depth) {
  var content = node.content;
  if (depth > 1) {
    var last = closeNodeEnd(node.lastChild, depth - 1);
    content = node.content.replaceChild(node.childCount - 1, last);
  }
  var fill = node.contentMatchAt(node.childCount).fillBefore(prosemirrorModel.Fragment.empty, true);
  return node.copy(content.append(fill))
}

function closeFragmentEnd(fragment, depth) {
  return depth ? fragment.replaceChild(fragment.childCount - 1, closeNodeEnd(fragment.lastChild, depth)) : fragment
}

// :: (number, number, Slice) → this
// Replace a range of the document with a given slice, using `from`,
// `to`, and the slice's [`openStart`](#model.Slice.openStart) property
// as hints, rather than fixed start and end points. This method may
// grow the replaced area or close open nodes in the slice in order to
// get a fit that is more in line with WYSIWYG expectations, by
// dropping fully covered parent nodes of the replaced region when
// they are marked [non-defining](#model.NodeSpec.defining), or
// including an open parent node from the slice that _is_ marked as
// [defining](#model.NodeSpec.defining).
//
// This is the method, for example, to handle paste. The similar
// [`replace`](#transform.Transform.replace) method is a more
// primitive tool which will _not_ move the start and end of its given
// range, and is useful in situations where you need more precise
// control over what happens.
Transform.prototype.replaceRange = function(from, to, slice) {
  var this$1 = this;

  if (!slice.size) { return this.deleteRange(from, to) }

  var $from = this.doc.resolve(from), $to = this.doc.resolve(to);
  if (fitsTrivially($from, $to, slice))
    { return this.step(new ReplaceStep(from, to, slice)) }

  var targetDepths = coveredDepths($from, this.doc.resolve(to));
  // Can't replace the whole document, so remove 0 if it's present
  if (targetDepths[targetDepths.length - 1] == 0) { targetDepths.pop(); }
  // Negative numbers represent not expansion over the whole node at
  // that depth, but replacing from $from.before(-D) to $to.pos.
  var preferredTarget = -($from.depth + 1);
  targetDepths.unshift(preferredTarget);
  // This loop picks a preferred target depth, if one of the covering
  // depths is not outside of a defining node, and adds negative
  // depths for any depth that has $from at its start and does not
  // cross a defining node.
  for (var d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--) {
    var spec = $from.node(d).type.spec;
    if (spec.defining || spec.isolating) { break }
    if (targetDepths.indexOf(d) > -1) { preferredTarget = d; }
    else if ($from.before(d) == pos) { targetDepths.splice(1, 0, -d); }
  }
  // Try to fit each possible depth of the slice into each possible
  // target depth, starting with the preferred depths.
  var preferredTargetIndex = targetDepths.indexOf(preferredTarget);

  var leftNodes = [], preferredDepth = slice.openStart;
  for (var content = slice.content, i = 0;; i++) {
    var node = content.firstChild;
    leftNodes.push(node);
    if (i == slice.openStart) { break }
    content = node.content;
  }
  // Back up if the node directly above openStart, or the node above
  // that separated only by a non-defining textblock node, is defining.
  if (preferredDepth > 0 && leftNodes[preferredDepth - 1].type.spec.defining &&
      $from.node(preferredTargetIndex).type != leftNodes[preferredDepth - 1].type)
    { preferredDepth -= 1; }
  else if (preferredDepth >= 2 && leftNodes[preferredDepth - 1].isTextblock && leftNodes[preferredDepth - 2].type.spec.defining &&
           $from.node(preferredTargetIndex).type != leftNodes[preferredDepth - 2].type)
    { preferredDepth -= 2; }

  for (var j = slice.openStart; j >= 0; j--) {
    var openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
    var insert = leftNodes[openDepth];
    if (!insert) { continue }
    for (var i$1 = 0; i$1 < targetDepths.length; i$1++) {
      // Loop over possible expansion levels, starting with the
      // preferred one
      var targetDepth = targetDepths[(i$1 + preferredTargetIndex) % targetDepths.length], expand = true;
      if (targetDepth < 0) { expand = false; targetDepth = -targetDepth; }
      var parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
      if (parent.canReplaceWith(index, index, insert.type, insert.marks))
        { return this$1.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to,
                            new prosemirrorModel.Slice(closeFragment(slice.content, 0, slice.openStart, openDepth),
                                      openDepth, slice.openEnd)) }
    }
  }

  return this.replace(from, to, slice)
};

function closeFragment(fragment, depth, oldOpen, newOpen, parent) {
  if (depth < oldOpen) {
    var first = fragment.firstChild;
    fragment = fragment.replaceChild(0, first.copy(closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
  }
  if (depth > newOpen)
    { fragment = parent.contentMatchAt(0).fillBefore(fragment, true).append(fragment); }
  return fragment
}

// :: (number, number, Node) → this
// Replace the given range with a node, but use `from` and `to` as
// hints, rather than precise positions. When from and to are the same
// and are at the start or end of a parent node in which the given
// node doesn't fit, this method may _move_ them out towards a parent
// that does allow the given node to be placed. When the given range
// completely covers a parent node, this method may completely replace
// that parent node.
Transform.prototype.replaceRangeWith = function(from, to, node) {
  if (!node.isInline && from == to && this.doc.resolve(from).parent.content.size) {
    var point = insertPoint(this.doc, from, node.type);
    if (point != null) { from = to = point; }
  }
  return this.replaceRange(from, to, new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(node), 0, 0))
};

// :: (number, number) → this
// Delete the given range, expanding it to cover fully covered
// parent nodes until a valid replace is found.
Transform.prototype.deleteRange = function(from, to) {
  var this$1 = this;

  var $from = this.doc.resolve(from), $to = this.doc.resolve(to);
  var covered = coveredDepths($from, $to);
  for (var i = 0; i < covered.length; i++) {
    var depth = covered[i], last = i == covered.length - 1;
    if ((last && depth == 0) || $from.node(depth).type.contentMatch.validEnd)
      { return this$1.delete($from.start(depth), $to.end(depth)) }
    if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1))))
      { return this$1.delete($from.before(depth), $to.after(depth)) }
  }
  for (var d = 1; d <= $from.depth; d++) {
    if (from - $from.start(d) == $from.depth - d && to > $from.end(d))
      { return this$1.delete($from.before(d), to) }
  }
  return this.delete(from, to)
};

// : (ResolvedPos, ResolvedPos) → [number]
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function coveredDepths($from, $to) {
  var result = [], minDepth = Math.min($from.depth, $to.depth);
  for (var d = minDepth; d >= 0; d--) {
    var start = $from.start(d);
    if (start < $from.pos - ($from.depth - d) ||
        $to.end(d) > $to.pos + ($to.depth - d) ||
        $from.node(d).type.spec.isolating ||
        $to.node(d).type.spec.isolating) { break }
    if (start == $to.start(d)) { result.push(d); }
  }
  return result
}

exports.Transform = Transform;
exports.TransformError = TransformError;
exports.Step = Step;
exports.StepResult = StepResult;
exports.joinPoint = joinPoint;
exports.canJoin = canJoin;
exports.canSplit = canSplit;
exports.insertPoint = insertPoint;
exports.dropPoint = dropPoint;
exports.liftTarget = liftTarget;
exports.findWrapping = findWrapping;
exports.StepMap = StepMap;
exports.MapResult = MapResult;
exports.Mapping = Mapping;
exports.AddMarkStep = AddMarkStep;
exports.RemoveMarkStep = RemoveMarkStep;
exports.ReplaceStep = ReplaceStep;
exports.ReplaceAroundStep = ReplaceAroundStep;
exports.replaceStep = replaceStep;
//# sourceMappingURL=index.js.map


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Avatar__ = __webpack_require__(1900);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Avatar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AvatarItem__ = __webpack_require__(1911);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__components_AvatarItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Presence__ = __webpack_require__(708);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__components_Presence__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Status__ = __webpack_require__(711);
/* unused harmony reexport Status */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Skeleton__ = __webpack_require__(1912);
/* unused harmony reexport Skeleton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__theme__ = __webpack_require__(266);
/* unused harmony reexport Theme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__theme_item__ = __webpack_require__(715);
/* unused harmony reexport ThemeItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled_constants__ = __webpack_require__(199);
/* unused harmony reexport AVATAR_SIZES */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__styled_constants__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hoc__ = __webpack_require__(402);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_8__hoc__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers__ = __webpack_require__(401);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_9__helpers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styled_utils__ = __webpack_require__(400);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__styled_utils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__styled_utils__["b"]; });




 // Theming is currently experimental.


 // The below are exposed for use by avatarGroup






/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AtlasKitThemeProvider", function() { return AtlasKitThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderRadius", function() { return borderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridSize", function() { return gridSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fontSize", function() { return fontSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fontSizeSmall", function() { return fontSizeSmall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fontFamily", function() { return fontFamily; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "codeFontFamily", function() { return codeFontFamily; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "layers", function() { return layers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assistive", function() { return assistive; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colors__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elevation__ = __webpack_require__(2150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typography__ = __webpack_require__(2151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_math__ = __webpack_require__(2152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_getTheme__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_themed__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AtlaskitThemeProvider__ = __webpack_require__(2153);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "colors", function() { return __WEBPACK_IMPORTED_MODULE_1__colors__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "elevation", function() { return __WEBPACK_IMPORTED_MODULE_2__elevation__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "typography", function() { return __WEBPACK_IMPORTED_MODULE_3__typography__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "math", function() { return __WEBPACK_IMPORTED_MODULE_4__utils_math__; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getTheme", function() { return __WEBPACK_IMPORTED_MODULE_5__utils_getTheme__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "themed", function() { return __WEBPACK_IMPORTED_MODULE_6__utils_themed__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AtlaskitThemeProvider", function() { return __WEBPACK_IMPORTED_MODULE_7__components_AtlaskitThemeProvider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Appearance__ = __webpack_require__(2154);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Appearance", function() { return __WEBPACK_IMPORTED_MODULE_8__components_Appearance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Reset__ = __webpack_require__(2155);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ResetTheme", function() { return __WEBPACK_IMPORTED_MODULE_9__components_Reset__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Reset", function() { return __WEBPACK_IMPORTED_MODULE_9__components_Reset__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Theme__ = __webpack_require__(414);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_10__components_Theme__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hoc__ = __webpack_require__(2156);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "withTheme", function() { return __WEBPACK_IMPORTED_MODULE_11__hoc__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_createTheme__ = __webpack_require__(415);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "createTheme", function() { return __WEBPACK_IMPORTED_MODULE_12__utils_createTheme__["a"]; });









 // backwards-compatible export with old Atlaskit case

var AtlasKitThemeProvider = __WEBPACK_IMPORTED_MODULE_7__components_AtlaskitThemeProvider__["a" /* default */];
/*
  These theme values are expressed as functions so that if we decide to make
  them dependent on props in the future, it wouldn't require a significant
  refactor everywhere they are being used.
*/

var borderRadius = function borderRadius() {
  return 3;
};
var gridSize = function gridSize() {
  return 8;
};
var fontSize = function fontSize() {
  return 14;
};
var fontSizeSmall = function fontSizeSmall() {
  return 11;
};
var fontFamily = function fontFamily() {
  return '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';
};
var codeFontFamily = function codeFontFamily() {
  return '"SFMono-Medium", "SF Mono", "Segoe UI Mono", "Roboto Mono", "Ubuntu Mono", Menlo, Consolas, Courier, monospace';
};
var layers = {
  card: function card() {
    return 100;
  },
  dialog: function dialog() {
    return 200;
  },
  navigation: function navigation() {
    return 300;
  },
  layer: function layer() {
    return 400;
  },
  blanket: function blanket() {
    return 500;
  },
  modal: function modal() {
    return 510;
  },
  flag: function flag() {
    return 600;
  },
  spotlight: function spotlight() {
    return 700;
  },
  tooltip: function tooltip() {
    return 800;
  }
};
var assistive = function assistive() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  border: 0 !important;\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  height: 1px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  width: 1px !important;\n  white-space: nowrap !important;\n"]);
}; // New API






/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nodes_text__ = __webpack_require__(2858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tokenize_keyword__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tokenize__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tokenize_whitespace__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_escape__ = __webpack_require__(889);






var processState = {
    NEWLINE: 0,
    BUFFER: 1,
    TOKEN: 2,
    ESCAPE: 3,
};
function parseString(input, schema, ignoreTokens, tokenErrCallback) {
    if (ignoreTokens === void 0) { ignoreTokens = []; }
    var index = 0;
    var state = processState.NEWLINE;
    var buffer = '';
    var tokenType = __WEBPACK_IMPORTED_MODULE_3__tokenize__["a" /* TokenType */].STRING;
    var output = [];
    while (index < input.length) {
        var char = input.charAt(index);
        switch (state) {
            case processState.NEWLINE: {
                /**
                 * During this state, the parser will trim leading
                 * spaces and looking for any leading keywords.
                 */
                var substring = input.substring(index);
                var length_1 = Object(__WEBPACK_IMPORTED_MODULE_4__tokenize_whitespace__["b" /* parseWhitespaceOnly */])(substring);
                if (length_1) {
                    index += length_1;
                    continue;
                }
                var match = Object(__WEBPACK_IMPORTED_MODULE_2__tokenize_keyword__["a" /* parseLeadingKeyword */])(substring) ||
                    Object(__WEBPACK_IMPORTED_MODULE_2__tokenize_keyword__["b" /* parseMacroKeyword */])(substring) ||
                    Object(__WEBPACK_IMPORTED_MODULE_2__tokenize_keyword__["c" /* parseOtherKeyword */])(substring);
                if (match && ignoreTokens.indexOf(match.type) === -1) {
                    tokenType = match.type;
                    state = processState.TOKEN;
                    continue;
                }
                else {
                    state = processState.BUFFER;
                    continue;
                }
            }
            case processState.BUFFER: {
                /**
                 * During this state, the parser will start
                 * saving plantext into the buffer until it hits
                 * a keyword
                 */
                var substring = input.substring(index);
                /**
                 * If the previous char is not a alphanumeric, we will parse
                 * format keywords.
                 * If the previous char is '{', we need to skip parse macro
                 * keyword
                 */
                var match = null;
                if (buffer.endsWith('{')) {
                    match = Object(__WEBPACK_IMPORTED_MODULE_2__tokenize_keyword__["c" /* parseOtherKeyword */])(substring);
                }
                else {
                    match = Object(__WEBPACK_IMPORTED_MODULE_2__tokenize_keyword__["b" /* parseMacroKeyword */])(substring) || Object(__WEBPACK_IMPORTED_MODULE_2__tokenize_keyword__["c" /* parseOtherKeyword */])(substring);
                }
                if (match && ignoreTokens.indexOf(match.type) === -1) {
                    tokenType = match.type;
                    state = processState.TOKEN;
                    continue;
                }
                if (char === '\\') {
                    state = processState.ESCAPE;
                    continue;
                }
                buffer += char;
                break;
            }
            case processState.TOKEN: {
                var token = Object(__WEBPACK_IMPORTED_MODULE_3__tokenize__["b" /* parseToken */])(input, tokenType, index, schema, tokenErrCallback);
                if (token.type === 'text') {
                    buffer += token.text;
                }
                else if (token.type === 'pmnode') {
                    output.push.apply(output, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](Object(__WEBPACK_IMPORTED_MODULE_1__nodes_text__["a" /* createTextNode */])(buffer, schema)));
                    buffer = ''; // clear the buffer
                    output.push.apply(// clear the buffer
                    output, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](token.nodes));
                }
                index += token.length;
                if (tokenType === __WEBPACK_IMPORTED_MODULE_3__tokenize__["a" /* TokenType */].HARD_BREAK) {
                    state = processState.NEWLINE;
                }
                else {
                    state = processState.BUFFER;
                }
                continue;
            }
            case processState.ESCAPE: {
                var token = Object(__WEBPACK_IMPORTED_MODULE_5__utils_escape__["a" /* escapeHandler */])(input, index);
                buffer += token.text;
                index += token.length;
                state = processState.BUFFER;
                continue;
            }
            default:
        }
        index++;
    }
    if (buffer.length > 0) {
        // Wrapping the rest of the buffer into a text node
        output.push.apply(output, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](Object(__WEBPACK_IMPORTED_MODULE_1__nodes_text__["a" /* createTextNode */])(buffer, schema)));
    }
    return output;
}
//# sourceMappingURL=text.js.map

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export locales */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n_index__ = __webpack_require__(2122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BlockCard__ = __webpack_require__(2147);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__BlockCard__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__BlockCard__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__BlockCard__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__BlockCard__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__BlockCard__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InlineCard__ = __webpack_require__(2229);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_2__InlineCard__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_2__InlineCard__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_2__InlineCard__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_2__InlineCard__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_2__InlineCard__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LinkView__ = __webpack_require__(2240);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__LinkView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ellipsify__ = __webpack_require__(765);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_4__ellipsify__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__humanReadableSize__ = __webpack_require__(2242);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_5__humanReadableSize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins__ = __webpack_require__(101);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_6__mixins__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_6__mixins__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_6__mixins__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_6__mixins__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_6__mixins__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_6__mixins__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__camera__ = __webpack_require__(2244);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__messages__ = __webpack_require__(771);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_8__messages__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_languages__ = __webpack_require__(2245);
/* unused harmony reexport languages */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__infiniteScroll__ = __webpack_require__(2246);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_10__infiniteScroll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__imageMetaData__ = __webpack_require__(2247);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_11__imageMetaData__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_11__imageMetaData__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_11__imageMetaData__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util__ = __webpack_require__(425);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_12__util__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__customMediaPlayer_index__ = __webpack_require__(2253);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_13__customMediaPlayer_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__customMediaPlayer_timeRange__ = __webpack_require__(774);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__classNames__ = __webpack_require__(776);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shortcut__ = __webpack_require__(777);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__formatDuration__ = __webpack_require__(426);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__theme__ = __webpack_require__(773);
/* unused harmony reexport theme */

var locales = __WEBPACK_IMPORTED_MODULE_0__i18n_index__;



















//# sourceMappingURL=index.js.map

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

!function(root, factory) {
     true ? module.exports = factory(__webpack_require__(543), __webpack_require__(1387), __webpack_require__(260)) : "function" == typeof define && define.amd ? define([ "babel-runtime/core-js/object/assign", "babel-runtime/core-js/object/keys", "babel-runtime/helpers/typeof" ], factory) : "object" == typeof exports ? exports["@atlaskit/utilSharedStyles"] = factory(require("babel-runtime/core-js/object/assign"), require("babel-runtime/core-js/object/keys"), require("babel-runtime/helpers/typeof")) : root["@atlaskit/utilSharedStyles"] = factory(root["babel-runtime/core-js/object/assign"], root["babel-runtime/core-js/object/keys"], root["babel-runtime/helpers/typeof"]);
}(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_6__) {
    /******/
    return function(modules) {
        /******/
        /******/
        // The require function
        /******/
        function __webpack_require__(moduleId) {
            /******/
            /******/
            // Check if module is in cache
            /******/
            if (installedModules[moduleId]) /******/
            return installedModules[moduleId].exports;
            /******/
            /******/
            // Create a new module (and put it into the cache)
            /******/
            var module = installedModules[moduleId] = {
                /******/
                exports: {},
                /******/
                id: moduleId,
                /******/
                loaded: !1
            };
            /******/
            /******/
            // Return the exports of the module
            /******/
            /******/
            /******/
            // Execute the module function
            /******/
            /******/
            /******/
            // Flag the module as loaded
            /******/
            return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
            module.loaded = !0, module.exports;
        }
        // webpackBootstrap
        /******/
        // The module cache
        /******/
        var installedModules = {};
        /******/
        /******/
        // Load entry module and return exports
        /******/
        /******/
        /******/
        /******/
        // expose the modules object (__webpack_modules__)
        /******/
        /******/
        /******/
        // expose the module cache
        /******/
        /******/
        /******/
        // __webpack_public_path__
        /******/
        return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
        __webpack_require__.p = "", __webpack_require__(0);
    }([ /* 0 */
    /***/
    function(module, exports, __webpack_require__) {
        module.exports = __webpack_require__(1);
    }, /* 1 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        var _assign = __webpack_require__(2), _assign2 = _interopRequireDefault(_assign), _keys = __webpack_require__(3), _keys2 = _interopRequireDefault(_keys), lessVarsAsJS = __webpack_require__(4), intVariableNames = [ "akGridSizeUnitless", "akZIndexNavigation", "akZIndexLayer", "akZIndexBlanket", "akZIndexFlag", "akZIndexCard", "akZIndexDialog", "akZIndexModal" ];
        (0, _keys2.default)(lessVarsAsJS).forEach(function(varName) {
            intVariableNames.indexOf(varName) > -1 ? module.exports[varName] = parseInt(lessVarsAsJS[varName], 10) : module.exports[varName] = lessVarsAsJS[varName];
        });
        // the order is very important here if these requires happen before the computation above
        // then the exported consts will interpolate undefined into their variables,
        // since the values won't exist on the exports of this module before the requires resolve.
        // this is a known issue encompased by AK-3182, and will be removed in that issue.
        var _require = __webpack_require__(5), akAnimationMixins = _require.default, _require2 = __webpack_require__(7), akElevationMixins = _require2.default, _require3 = __webpack_require__(8), akHelperMixins = _require3.default, _require4 = __webpack_require__(9), akTypographyMixins = _require4.default;
        module.exports = (0, _assign2.default)(module.exports, {
            // this default export only exists for backwards compat
            // and should be removed on the next breaking change.
            // See issue no: AK-3182
            default: lessVarsAsJS,
            akAnimationMixins: akAnimationMixins,
            akElevationMixins: akElevationMixins,
            akHelperMixins: akHelperMixins,
            akTypographyMixins: akTypographyMixins
        });
    }, /* 2 */
    /***/
    function(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
    }, /* 3 */
    /***/
    function(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
    }, /* 4 */
    /***/
    function(module, exports) {
        "use strict";
        /** ***************************************************************************
	 **  THIS FILE IS GENERATED - DO NOT MODIFY AND DO NOT CHECK INTO THE REPO   **
	 *************************************************************************** **/
        module.exports = {
            akBorderRadius: "3px",
            akColorPrimary1: "#172B4D",
            akColorPrimary2: "#0747A6",
            akColorPrimary3: "#FFFFFF",
            akColorSecondary1: "#FF5630",
            akColorSecondary2: "#FFAB00",
            akColorSecondary3: "#36B37E",
            akColorSecondary4: "#6554C0",
            akColorSecondary5: "#00B8D9",
            akColorR50: "#FFEBE6",
            akColorR75: "#FFBDAD",
            akColorR100: "#FF8F73",
            akColorR200: "#FF7452",
            akColorR300: "#FF5630",
            akColorR400: "#DE350B",
            akColorR500: "#BF2600",
            akColorY50: "#FFFAE6",
            akColorY75: "#FFF0B3",
            akColorY100: "#FFE380",
            akColorY200: "#FFC400",
            akColorY300: "#FFAB00",
            akColorY400: "#FF991F",
            akColorY500: "#FF8B00",
            akColorG50: "#E3FCEF",
            akColorG75: "#ABF5D1",
            akColorG100: "#79F2C0",
            akColorG200: "#57D9A3",
            akColorG300: "#36B37E",
            akColorG400: "#00875A",
            akColorG500: "#006644",
            akColorB50: "#DEEBFF",
            akColorB75: "#B3D4FF",
            akColorB100: "#4C9AFF",
            akColorB200: "#2684FF",
            akColorB300: "#0065FF",
            akColorB400: "#0052CC",
            akColorB500: "#0747A6",
            akColorP50: "#EAE6FF",
            akColorP75: "#C0B6F2",
            akColorP100: "#998DD9",
            akColorP200: "#8777D9",
            akColorP300: "#6554C0",
            akColorP400: "#5243AA",
            akColorP500: "#403294",
            akColorT50: "#E6FCFF",
            akColorT75: "#B3F5FF",
            akColorT100: "#79E2F2",
            akColorT200: "#00C7E6",
            akColorT300: "#00B8D9",
            akColorT400: "#00A3BF",
            akColorT500: "#008DA6",
            akColorN0: "#FFFFFF",
            akColorN10: "#FAFBFC",
            akColorN20: "#F4F5F7",
            akColorN30: "#EBECF0",
            akColorN40: "#DFE1E6",
            akColorN50: "#C1C7D0",
            akColorN60: "#B3BAC5",
            akColorN70: "#A5ADBA",
            akColorN80: "#97A0AF",
            akColorN90: "#8993A4",
            akColorN100: "#7A869A",
            akColorN200: "#6B778C",
            akColorN300: "#5E6C84",
            akColorN400: "#505F79",
            akColorN500: "#42526E",
            akColorN600: "#344563",
            akColorN700: "#253858",
            akColorN800: "#172B4D",
            akColorN900: "#091E42",
            akColorN10A: "rgba(9, 30, 66, 0.02)",
            akColorN20A: "rgba(9, 30, 66, 0.04)",
            akColorN30A: "rgba(9, 30, 66, 0.08)",
            akColorN40A: "rgba(9, 30, 66, 0.13)",
            akColorN50A: "rgba(9, 30, 66, 0.25)",
            akColorN60A: "rgba(9, 30, 66, 0.31)",
            akColorN70A: "rgba(9, 30, 66, 0.36)",
            akColorN80A: "rgba(9, 30, 66, 0.42)",
            akColorN90A: "rgba(9, 30, 66, 0.48)",
            akColorN100A: "rgba(9, 30, 66, 0.54)",
            akColorN200A: "rgba(9, 30, 66, 0.60)",
            akColorN300A: "rgba(9, 30, 66, 0.66)",
            akColorN400A: "rgba(9, 30, 66, 0.71)",
            akColorN500A: "rgba(9, 30, 66, 0.77)",
            akColorN600A: "rgba(9, 30, 66, 0.82)",
            akColorN700A: "rgba(9, 30, 66, 0.89)",
            akColorN800A: "rgba(9, 30, 66, 0.95)",
            akFontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
            akFontSizeDefault: "14px",
            akCodeFontFamily: "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Courier, monospace",
            akGridSizeUnitless: "8",
            akGridSize: "8px",
            akZIndexCard: "100",
            akZIndexDialog: "200",
            akZIndexNavigation: "300",
            akZIndexLayer: "400",
            akZIndexBlanket: "500",
            akZIndexModal: "510",
            akZIndexFlag: "600"
        };
    }, /* 5 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        // ==============================
        // PRIVATE
        // ==============================
        // Function for calculating one prop value into one prop of a keyframe. i.e
        // For arguments: ({
        //    property: 'transform',
        //    value: interpolate`translateY(${t => t}px) translateX(${t => t}px)`,
        //    deltas: [{ from: 0, to: -200 }, { from: 0, to: -50 }]
        // }, 0.5)
        //
        // Will output: transform: translateY(-100px) translateX(-25px);
        function calculateValue(_ref, mod) {
            var deltas = _ref.deltas, value = _ref.value, modifiedDeltas = deltas.map(function(_ref2) {
                var from = _ref2.from, to = _ref2.to;
                return from + (to - from) * mod;
            });
            return value ? value(modifiedDeltas) : modifiedDeltas[0];
        }
        // Function used to create the content inside each keyframe.
        function calculateKeyframe(options, mod) {
            if (!Array.isArray(options)) throw new Error("Animation mixin expects an array, but received `" + ("undefined" == typeof options ? "undefined" : (0, 
            _typeof3.default)(options)) + "`");
            return options.map(function(opt) {
                return opt.property + ": " + calculateValue(opt, mod) + ";";
            }).join("\n").trim();
        }
        // ==============================
        // PUBLIC
        // ==============================
        // Create an animation by defining an object with the following properties:
        //
        // const slideUpAndRight = {
        //   property: 'transform',
        //   value: interpolate`translateY(${y => y}px) translateX(${x => x}px)`,
        //   deltas: [{ from: 0, to: -200 }, { from: 0, to: 100 }],
        // };
        // const fadeOut = {
        //   property: 'opacity',
        //   deltas: [{ from: 1, to: 0 }],
        // };
        //
        // Animation options require:
        //   - @property [String] is the name of a CSS property (i.e 'transform')
        //   - @value [Function] use the `interpolate` function as a tagged template
        //     literal to evaluate the value for each keyframe.
        //     NOTE: The @value prop can be omitted when the value directly maps to
        //     a number, and doesn't need to be transformed. For instance with `opacity`.
        //   - @deltas [ArrayOfObjects]
        //     - @from [Number] the start value
        //     - @to [Number] the end value
        //
        // Pass the options as an array to one of the mixins below. i.e.
        // const keyframes = akAnimationMixins.createBold([slideUp, fadeOut]);
        function createBold(options) {
            return "\n    0% {\n      " + calculateKeyframe(options, 0) + ";\n      animation-timing-function: cubic-bezier(0.23830050393398, 0, 0.25586732616931, 0.79011192334632);\n    }\n    20% {\n      " + calculateKeyframe(options, .8) + ";\n      animation-timing-function: cubic-bezier(0.21787238302442, 0.98324004924648, 0.58694150667646, 1);\n    }\n    100% {\n      " + calculateKeyframe(options, 1) + ";\n    }\n  ";
        }
        function createOptimistic(options) {
            return "\n    0% {\n      " + calculateKeyframe(options, 0) + ";\n      animation-timing-function: cubic-bezier(0.33333333, 0, 0.4, 1);\n    }\n    20% {\n      " + calculateKeyframe(options, 1.05) + ";\n      animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n    }\n    76% {\n      " + calculateKeyframe(options, .975) + ";\n      animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n    }\n    100% {\n      " + calculateKeyframe(options, 1) + ";\n    }\n  ";
        }
        function createCombined(options) {
            return "\n    0% {\n      " + calculateKeyframe(options, 0) + ";\n      animation-timing-function: cubic-bezier(0.4, 0, 0.15, 1);\n    }\n    50% {\n      " + calculateKeyframe(options, 1.1) + ";\n      animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n    }\n    100% {\n      " + calculateKeyframe(options, 1) + ";\n    }\n  ";
        }
        // Function to be used as a tagged template literal that evaluates it's
        // value given the progress through an animation and concatenates
        function interpolate(strings) {
            for (var _len = arguments.length, expressions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) expressions[_key - 1] = arguments[_key];
            return function(mods) {
                if (0 === expressions.length) // eslint-disable-next-line no-console
                return console.warn("Interpolate is not required. Use a `String` or remove the value property for direct numeric mapping."), 
                strings.join("");
                var results = [];
                return expressions.forEach(function(e, i) {
                    results.push(strings[i]), results.push(e(mods[i]));
                }), results.push(strings[strings.length - 1]), results.join("");
            };
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _typeof2 = __webpack_require__(6), _typeof3 = _interopRequireDefault(_typeof2);
        exports.createBold = createBold, exports.createOptimistic = createOptimistic, exports.createCombined = createCombined, 
        exports.interpolate = interpolate, exports.default = {
            createBold: createBold,
            createCombined: createCombined,
            createOptimistic: createOptimistic,
            interpolate: interpolate
        };
    }, /* 6 */
    /***/
    function(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_6__;
    }, /* 7 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _index = __webpack_require__(1), e100 = "\n  box-shadow: 0 1px 1px " + _index.akColorN50A + ", 0 0 1px 0 " + _index.akColorN60A + ";\n  z-index: " + _index.akZIndexCard + ";\n", e200 = "\n  box-shadow: 0 4px 8px -2px " + _index.akColorN60A + ", 0 0 1px " + _index.akColorN60A + ";\n  z-index: " + _index.akZIndexDialog + ";\n", e500 = "\n  box-shadow: 0 8px 16px -4px " + _index.akColorN60A + ", 0 0 1px " + _index.akColorN60A + ";\n  z-index: " + _index.akZIndexModal + ";\n", e600 = "\n  box-shadow: 0 20px 32px -8px " + _index.akColorN50A + ", 0 0 1px " + _index.akColorN60A + ";\n  z-index: " + _index.akZIndexFlag + ";\n";
        exports.default = {
            e100: e100,
            e200: e200,
            e500: e500,
            e600: e600
        };
    }, /* 8 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _index = __webpack_require__(1), createFocusRing = function() {
            var color = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : _index.akColorB100, width = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "2px";
            return "\n  &:focus {\n    box-shadow: 0 0 0 " + width + " " + color + ";\n    outline: none;\n  }\n";
        }, withFocusRing = "\n  " + createFocusRing() + "\n", withoutFocusRing = "\n  box-shadow: none;\n", truncate = function(width) {
            return "\n  max-width: " + width + ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n";
        }, placeholder = function(styles) {
            return "\n    &::-webkit-input-placeholder {\n      " + styles + "\n    }\n    &:-moz-placeholder {\n      " + styles + "\n    }\n    &::-moz-placeholder {\n      " + styles + "\n    }\n    &:-ms-input-placeholder {\n      " + styles + "\n    }\n  ";
        };
        // prefer default export
        exports.default = {
            focusRing: {
                generate: createFocusRing,
                default: withFocusRing,
                none: withoutFocusRing
            },
            text: {
                truncate: truncate
            },
            placeholder: placeholder
        };
    }, /* 9 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _index = __webpack_require__(1), fontSizeDefault = parseInt(_index.akFontSizeDefault, 10), gridSize = parseInt(_index.akGridSizeUnitless, 10), baseHeading = function(fontSize, lineHeight) {
            return "\n  font-size: " + fontSize / fontSizeDefault + "em;\n  font-style: inherit;\n  line-height: " + lineHeight / fontSize + ";\n";
        }, h900 = "\n  " + baseHeading(35, 40) + "\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: " + 6.5 * gridSize + "px;\n", h800 = "\n  " + baseHeading(29, 32) + "\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: " + 5 * gridSize + "px;\n", h700 = "\n  " + baseHeading(24, 28) + "\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: " + 5 * gridSize + "px;\n", h600 = "\n  " + baseHeading(20, 24) + "\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: " + 3.5 * gridSize + "px;\n", h500 = "\n  " + baseHeading(16, 20) + "\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: " + 3 * gridSize + "px;\n", h400 = "\n  " + baseHeading(14, 16) + "\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: " + 2 * gridSize + "px;\n", h300 = "\n  " + baseHeading(12, 16) + "\n  color: " + _index.akColorN300 + ";\n  font-weight: 600;\n  margin-top: " + 2.5 * gridSize + "px;\n  text-transform: uppercase;\n", h200 = "\n  " + baseHeading(12, 16) + "\n  color: " + _index.akColorN300 + ";\n  font-weight: 600;\n  margin-top: " + 2 * gridSize + "px;\n", h100 = "\n  " + baseHeading(12, 16) + "\n  color: " + _index.akColorN300 + ";\n  font-weight: normal;\n  margin-top: " + 2 * gridSize + "px;\n";
        exports.default = {
            h100: h100,
            h200: h200,
            h300: h300,
            h400: h400,
            h500: h500,
            h600: h600,
            h700: h700,
            h800: h800,
            h900: h900
        };
    } ]);
});

/***/ }),
/* 53 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 54 */
/***/ (function(module, exports) {

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

module.exports = _interopRequireWildcard;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tooltip__ = __webpack_require__(1743);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Tooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styled__ = __webpack_require__(654);
/* unused harmony reexport TooltipPrimitive */



/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(260);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1522);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1526);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(260);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = auth;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isLoggedIn; });
/* unused harmony export selectUsername */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasAuthCheckStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasAuthCheckFinished; });
/* unused harmony export selectUserAccessToken */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return selectLoginError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectADUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectJiraUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isAdmin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_actions_js__ = __webpack_require__(188);
var defaultState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["c" /* fromJS */])({hasAuthCheckStarted:false,hasAuthCheckFinished:false,loginError:null,userToken:null,adUserInfo:null,oktaToken:null,jiraUser:null});function auth(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];state=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["c" /* fromJS */])(state);// Force immutable in case of rehydration
switch(action.type){case __WEBPACK_IMPORTED_MODULE_2__auth_actions_js__["i" /* startAuthCheck */].type:return state.set('hasAuthCheckStarted',true).set('hasAuthCheckFinished',false);case __WEBPACK_IMPORTED_MODULE_2__auth_actions_js__["g" /* setAuthCheckError */].type:return state.set('hasAuthCheckFinished',true).set('loginError',action.payload);case __WEBPACK_IMPORTED_MODULE_2__auth_actions_js__["a" /* finishAuthCheck */].type:return state.set('hasAuthCheckFinished',true);case __WEBPACK_IMPORTED_MODULE_2__auth_actions_js__["h" /* setUserLogin */].type:return state.set('userToken',action.payload?Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["c" /* fromJS */])(action.payload):null);case __WEBPACK_IMPORTED_MODULE_2__auth_actions_js__["f" /* setADandJiraUser */].type:case __WEBPACK_IMPORTED_MODULE_2__auth_actions_js__["b" /* getExtraUserInfo */].event.success:var userInfo={};userInfo.username=action.payload.sAMAccountName;userInfo.firstName=action.payload.givenName;userInfo.lastName=action.payload.sn;userInfo.displayName=action.payload.givenName+' '+action.payload.sn;userInfo.email=action.payload.mail;userInfo.groups=action.payload.groups;state=state.set('adUserInfo',userInfo);state=state.set('jiraUser',action.payload.jiraUser);state=state.set('isAdmin',action.payload&&action.payload.groups&&action.payload.groups.includes(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].adminGroup));return state;default:return state;}}var isLoggedIn=function isLoggedIn(state){return state.auth.get('userToken')!==null;};var selectUsername=function selectUsername(state){return state.auth.getIn(['userToken','username']);};var selectEmail=function selectEmail(state){return state.auth.getIn(['userToken','email']);};var hasAuthCheckStarted=function hasAuthCheckStarted(state){return state.auth.get('hasAuthCheckStarted');};var hasAuthCheckFinished=function hasAuthCheckFinished(state){return state.auth.get('hasAuthCheckFinished');};var selectUserAccessToken=function selectUserAccessToken(state){return state.auth.getIn(['userToken','accessToken']);};var selectLoginError=function selectLoginError(state){return state.auth.get('loginError');};var selectADUserInfo=function selectADUserInfo(state){return state.auth.get('adUserInfo');};var selectJiraUser=function selectJiraUser(state){return state.auth.get('jiraUser');};var isAdmin=function isAdmin(state){return state.auth.get('isAdmin');};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorState = __webpack_require__(11);
var prosemirrorView = __webpack_require__(67);
var prosemirrorModel = __webpack_require__(23);
var prosemirrorTransform = __webpack_require__(46);
var prosemirrorKeymap = __webpack_require__(37);

// Because working with row and column-spanning cells is not quite
// trivial, this code builds up a descriptive structure for a given
// table node. The structures are cached with the (persistent) table
// nodes as key, so that they only have to be recomputed when the
// content of the table changes.
//
// This does mean that they have to store table-relative, not
// document-relative positions. So code that uses them will typically
// compute the start position of the table and offset positions passed
// to or gotten from this structure by that amount.

var readFromCache, addToCache;
// Prefer using a weak map to cache table maps. Fall back on a
// fixed-size cache if that's not supported.
if (typeof WeakMap != "undefined") {
  var cache = new WeakMap;
  readFromCache = function (key) { return cache.get(key); };
  addToCache = function (key, value) {
    cache.set(key, value);
    return value
  };
} else {
  var cache$1 = [], cacheSize = 10, cachePos = 0;
  readFromCache = function (key) {
    for (var i = 0; i < cache$1.length; i += 2)
      { if (cache$1[i] == key) { return cache$1[i + 1] } }
  };
  addToCache = function (key, value) {
    if (cachePos == cacheSize) { cachePos = 0; }
    cache$1[cachePos++] = key;
    return cache$1[cachePos++] = value
  };
}

var Rect = function Rect(left, top, right, bottom) {
  this.left = left; this.top = top; this.right = right; this.bottom = bottom;
};

// ::- A table map describes the structore of a given table. To avoid
// recomputing them all the time, they are cached per table node. To
// be able to do that, positions saved in the map are relative to the
// start of the table, rather than the start of the document.
var TableMap = function TableMap(width, height, map, problems) {
  // :: number The width of the table
  this.width = width;
  // :: number The table's height
  this.height = height;
  // :: [number] A width * height array with the start position of
  // the cell covering that part of the table in each slot
  this.map = map;
  // An optional array of problems (cell overlap or non-rectangular
  // shape) for the table, used by the table normalizer.
  this.problems = problems;
};

// :: (number) → Rect
// Find the dimensions of the cell at the given position.
TableMap.prototype.findCell = function findCell (pos) {
  for (var i = 0; i < this.map.length; i++) {
    var curPos = this.map[i];
    if (curPos != pos) { continue }
    var left = i % this.width, top = (i / this.width) | 0;
    var right = left + 1, bottom = top + 1;
    for (var j = 1; right < this.width && this.map[i + j] == curPos; j++) { right++; }
    for (var j$1 = 1; bottom < this.height && this.map[i + (this.width * j$1)] == curPos; j$1++) { bottom++; }
    return new Rect(left, top, right, bottom)
  }
  throw new RangeError("No cell with offset " + pos + " found")
};

// :: (number) → number
// Find the left side of the cell at the given position.
TableMap.prototype.colCount = function colCount (pos) {
  for (var i = 0; i < this.map.length; i++)
    { if (this.map[i] == pos) { return i % this.width } }
  throw new RangeError("No cell with offset " + pos + " found")
};

// :: (number, string, number) → ?number
// Find the next cell in the given direction, starting from the cell
// at `pos`, if any.
TableMap.prototype.nextCell = function nextCell (pos, axis, dir) {
  var ref = this.findCell(pos);
    var left = ref.left;
    var right = ref.right;
    var top = ref.top;
    var bottom = ref.bottom;
  if (axis == "horiz") {
    if (dir < 0 ? left == 0 : right == this.width) { return null }
    return this.map[top * this.width + (dir < 0 ? left - 1 : right)]
  } else {
    if (dir < 0 ? top == 0 : bottom == this.height) { return null }
    return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)]
  }
};

// :: (number, number) → Rect
// Get the rectangle spanning the two given cells.
TableMap.prototype.rectBetween = function rectBetween (a, b) {
  var ref = this.findCell(a);
    var leftA = ref.left;
    var rightA = ref.right;
    var topA = ref.top;
    var bottomA = ref.bottom;
  var ref$1 = this.findCell(b);
    var leftB = ref$1.left;
    var rightB = ref$1.right;
    var topB = ref$1.top;
    var bottomB = ref$1.bottom;
  return new Rect(Math.min(leftA, leftB), Math.min(topA, topB),
                  Math.max(rightA, rightB), Math.max(bottomA, bottomB))
};

// :: (Rect) → [number]
// Return the position of all cells that have the top left corner in
// the given rectangle.
TableMap.prototype.cellsInRect = function cellsInRect (rect) {
  var result = [], seen = [];
  for (var row = rect.top; row < rect.bottom; row++) {
    for (var col = rect.left; col < rect.right; col++) {
      var index = row * this.width + col, pos = this.map[index];
      if (seen.indexOf(pos) > -1) { continue }
      seen.push(pos);
      if ((col != rect.left || !col || this.map[index - 1] != pos) &&
          (row != rect.top || !row || this.map[index - this.width] != pos))
        { result.push(pos); }
    }
  }
  return result
};

// :: (number, number, Node) → number
// Return the position at which the cell at the given row and column
// starts, or would start, if a cell started there.
TableMap.prototype.positionAt = function positionAt (row, col, table) {
  for (var i = 0, rowStart = 0;; i++) {
    var rowEnd = rowStart + table.child(i).nodeSize;
    if (i == row) {
      var index = col + row * this.width, rowEndIndex = (row + 1) * this.width;
      // Skip past cells from previous rows (via rowspan)
      while (index < rowEndIndex && this.map[index] < rowStart) { index++; }
      return index == rowEndIndex ? rowEnd - 1 : this.map[index]
    }
    rowStart = rowEnd;
  }
};

// :: (Node) → TableMap
// Find the table map for the given table node.
TableMap.get = function get (table) {
  return readFromCache(table) || addToCache(table, computeMap(table))
};

// Compute a table map.
function computeMap(table) {
  if (table.type.spec.tableRole != "table") { throw new RangeError("Not a table node: " + table.type.name) }
  var width = findWidth(table), height = table.childCount;
  var map = [], mapPos = 0, problems = null, colWidths = [];
  for (var i = 0, e = width * height; i < e; i++) { map[i] = 0; }

  for (var row = 0, pos = 0; row < height; row++) {
    var rowNode = table.child(row);
    pos++;
    for (var i$1 = 0;; i$1++) {
      while (mapPos < map.length && map[mapPos] != 0) { mapPos++; }
      if (i$1 == rowNode.childCount) { break }
      var cellNode = rowNode.child(i$1);
      var ref = cellNode.attrs;
      var colspan = ref.colspan;
      var rowspan = ref.rowspan;
      var colwidth = ref.colwidth;
      for (var h = 0; h < rowspan; h++) {
        if (h + row >= height) {
          (problems || (problems = [])).push({type: "overlong_rowspan", pos: pos, n: rowspan - h});
          break
        }
        var start = mapPos + (h * width);
        for (var w = 0; w < colspan; w++) {
          if (map[start + w] == 0)
            { map[start + w] = pos; }
          else
            { (problems || (problems = [])).push({type: "collision", row: row, pos: pos, n: colspan - w}); }
          var colW = colwidth && colwidth[w];
          if (colW) {
            var widthIndex = ((start + w) % width) * 2, prev = colWidths[widthIndex];
            if (prev == null || (prev != colW && colWidths[widthIndex + 1] == 1)) {
              colWidths[widthIndex] = colW;
              colWidths[widthIndex + 1] = 1;
            } else if (prev == colW) {
              colWidths[widthIndex + 1]++;
            }
          }
        }
      }
      mapPos += colspan;
      pos += cellNode.nodeSize;
    }
    var expectedPos = (row + 1) * width, missing = 0;
    while (mapPos < expectedPos) { if (map[mapPos++] == 0) { missing++; } }
    if (missing) { (problems || (problems = [])).push({type: "missing", row: row, n: missing}); }
    pos++;
  }

  var tableMap = new TableMap(width, height, map, problems), badWidths = false;

  // For columns that have defined widths, but whose widths disagree
  // between rows, fix up the cells whose width doesn't match the
  // computed one.
  for (var i$2 = 0; !badWidths && i$2 < colWidths.length; i$2 += 2)
    { if (colWidths[i$2] != null && colWidths[i$2 + 1] < height) { badWidths = true; } }
  if (badWidths) { findBadColWidths(tableMap, colWidths, table); }

  return tableMap
}

function findWidth(table) {
  var width = -1, hasRowSpan = false;
  for (var row = 0; row < table.childCount; row++) {
    var rowNode = table.child(row), rowWidth = 0;
    if (hasRowSpan) { for (var j = 0; j < row; j++) {
      var prevRow = table.child(j);
      for (var i = 0; i < prevRow.childCount; i++) {
        var cell = prevRow.child(i);
        if (j + cell.attrs.rowspan > row) { rowWidth += cell.attrs.colspan; }
      }
    } }
    for (var i$1 = 0; i$1 < rowNode.childCount; i$1++) {
      var cell$1 = rowNode.child(i$1);
      rowWidth += cell$1.attrs.colspan;
      if (cell$1.attrs.rowspan > 1) { hasRowSpan = true; }
    }
    if (width == -1)
      { width = rowWidth; }
    else if (width != rowWidth)
      { width = Math.max(width, rowWidth); }
  }
  return width
}

function findBadColWidths(map, colWidths, table) {
  if (!map.problems) { map.problems = []; }
  for (var i = 0, seen = []; i < map.map.length; i++) {
    var pos = map.map[i];
    if (seen.indexOf(pos) > -1) { continue }
    seen.push(pos);
    var node = table.nodeAt(pos), updated = null;
    for (var j = 0; j < node.attrs.colspan; j++) {
      var col = (i + j) % map.width, colWidth = colWidths[col * 2];
      if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] != colWidth))
        { (updated || (updated = freshColWidth(node.attrs)))[j] = colWidth; }
    }
    if (updated) { map.problems.unshift({type: "colwidth mismatch", pos: pos, colwidth: updated}); }
  }
}

function freshColWidth(attrs) {
  if (attrs.colwidth) { return attrs.colwidth.slice() }
  var result = [];
  for (var i = 0; i < attrs.colspan; i++) { result.push(0); }
  return result
}

// Various helper function for working with tables

var key = new prosemirrorState.PluginKey("selectingCells");

function cellAround($pos) {
  for (var d = $pos.depth - 1; d > 0; d--)
    { if ($pos.node(d).type.spec.tableRole == "row") { return $pos.node(0).resolve($pos.before(d + 1)) } }
  return null
}

function cellWrapping($pos) {
  for (var d = $pos.depth - 1; d > 0; d--) {
    var role = $pos.node(d).type.spec.tableRole;
    if (role === "cell" || role === 'header_cell') { return $pos.node(d) }
  }
  return null
}

function isInTable(state) {
  var $head = state.selection.$head;
  for (var d = $head.depth; d > 0; d--) { if ($head.node(d).type.spec.tableRole == "row") { return true } }
  return false
}

function selectionCell(state) {
  var sel = state.selection;
  if (sel.$anchorCell) {
    return sel.$anchorCell.pos > sel.$headCell.pos ? sel.$anchorCell : sel.$headCell;
  } else if (sel.node && sel.node.type.spec.tableRole == "cell") {
    return sel.$anchor
  }
  return cellAround(sel.$head) || cellNear(sel.$head)
}

function cellNear($pos) {
  for (var after = $pos.nodeAfter, pos = $pos.pos; after; after = after.firstChild, pos++) {
    var role = after.type.spec.tableRole;
    if (role == "cell" || role == "header_cell") { return $pos.doc.resolve(pos) }
  }
  for (var before = $pos.nodeBefore, pos$1 = $pos.pos; before; before = before.lastChild, pos$1--) {
    var role$1 = before.type.spec.tableRole;
    if (role$1 == "cell" || role$1 == "header_cell") { return $pos.doc.resolve(pos$1 - before.nodeSize) }
  }
}

function pointsAtCell($pos) {
  return $pos.parent.type.spec.tableRole == "row" && $pos.nodeAfter
}

function moveCellForward($pos) {
  return $pos.node(0).resolve($pos.pos + $pos.nodeAfter.nodeSize)
}

function inSameTable($a, $b) {
  return $a.depth == $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1)
}

function findCell($pos) {
  return TableMap.get($pos.node(-1)).findCell($pos.pos - $pos.start(-1))
}

function colCount($pos) {
  return TableMap.get($pos.node(-1)).colCount($pos.pos - $pos.start(-1))
}

function nextCell($pos, axis, dir) {
  var start = $pos.start(-1), map = TableMap.get($pos.node(-1));
  var moved = map.nextCell($pos.pos - start, axis, dir);
  return moved == null ? null : $pos.node(0).resolve(start + moved)
}

function setAttr(attrs, name, value) {
  var result = {};
  for (var prop in attrs) { result[prop] = attrs[prop]; }
  result[name] = value;
  return result
}

function rmColSpan(attrs, pos, n) {
  if ( n === void 0 ) n=1;

  var result = setAttr(attrs, "colspan", attrs.colspan - n);
  if (result.colwidth) {
    result.colwidth = result.colwidth.slice();
    result.colwidth.splice(pos, n);
    if (!result.colwidth.some(function (w) { return w > 0; })) { result.colwidth = null; }
  }
  return result
}

function addColSpan(attrs, pos, n) {
  if ( n === void 0 ) n=1;

  var result = setAttr(attrs, "colspan", attrs.colspan + n);
  if (result.colwidth) {
    result.colwidth = result.colwidth.slice();
    for (var i = 0; i < n; i++) { result.colwidth.splice(pos, 0, 0); }
  }
  return result
}

// This file defines a ProseMirror selection subclass that models

// ::- A [`Selection`](http://prosemirror.net/docs/ref/#state.Selection)
// subclass that represents a cell selection spanning part of a table.
// With the plugin enabled, these will be created when the user
// selects across cells, and will be drawn by giving selected cells a
// `selectedCell` CSS class.
var CellSelection = /*@__PURE__*/(function (Selection) {
  function CellSelection($anchorCell, $headCell) {
    if ( $headCell === void 0 ) $headCell = $anchorCell;

    var table = $anchorCell.node(-1), map = TableMap.get(table), start = $anchorCell.start(-1);
    var rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    var doc = $anchorCell.node(0);
    var cells = map.cellsInRect(rect).filter(function (p) { return p != $headCell.pos - start; });
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    var ranges = cells.map(function (pos) {
      var cell = table.nodeAt(pos), from = pos + start + 1;
      return new prosemirrorState.SelectionRange(doc.resolve(from), doc.resolve(from + cell.content.size))
    });
    Selection.call(this, ranges[0].$from, ranges[0].$to, ranges);
    // :: ResolvedPos
    // A resolved position pointing _in front of_ the anchor cell (the one
    // that doesn't move when extending the selection).
    this.$anchorCell = $anchorCell;
    // :: ResolvedPos
    // A resolved position pointing in front of the head cell (the one
    // moves when extending the selection).
    this.$headCell = $headCell;
  }

  if ( Selection ) CellSelection.__proto__ = Selection;
  CellSelection.prototype = Object.create( Selection && Selection.prototype );
  CellSelection.prototype.constructor = CellSelection;

  CellSelection.prototype.map = function map (doc, mapping) {
    var $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
    var $headCell = doc.resolve(mapping.map(this.$headCell.pos));
    if (pointsAtCell($anchorCell) && pointsAtCell($headCell) && inSameTable($anchorCell, $headCell)) {
      var tableChanged = this.$anchorCell.node(-1) != $anchorCell.node(-1);
      if (tableChanged && this.isRowSelection())
        { return CellSelection.rowSelection($anchorCell, $headCell) }
      else if (tableChanged && this.isColSelection())
        { return CellSelection.colSelection($anchorCell, $headCell) }
      else
        { return new CellSelection($anchorCell, $headCell) }
    }
    return prosemirrorState.TextSelection.between($anchorCell, $headCell)
  };

  // :: () → Slice
  // Returns a rectangular slice of table rows containing the selected
  // cells.
  CellSelection.prototype.content = function content () {
    var table = this.$anchorCell.node(-1), map = TableMap.get(table), start = this.$anchorCell.start(-1);
    var rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
    var seen = [], rows = [];
    for (var row = rect.top; row < rect.bottom; row++) {
      var rowContent = [];
      for (var index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++) {
        var pos = map.map[index];
        if (seen.indexOf(pos) == -1) {
          seen.push(pos);
          var cellRect = map.findCell(pos), cell = table.nodeAt(pos);
          var extraLeft = rect.left - cellRect.left, extraRight = cellRect.right - rect.right;
          if (extraLeft > 0 || extraRight > 0) {
            var attrs = cell.attrs;
            if (extraLeft > 0) { attrs = rmColSpan(attrs, 0, extraLeft); }
            if (extraRight > 0) { attrs = rmColSpan(attrs, attrs.colspan - extraRight, extraRight); }
            if (cellRect.left < rect.left) { cell = cell.type.createAndFill(attrs); }
            else { cell = cell.type.create(attrs, cell.content); }
          }
          if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
            var attrs$1 = setAttr(cell.attrs, "rowspan", Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top));
            if (cellRect.top < rect.top) { cell = cell.type.createAndFill(attrs$1); }
            else { cell = cell.type.create(attrs$1, cell.content); }
          }
          rowContent.push(cell);
        }
      }
      rows.push(table.child(row).copy(prosemirrorModel.Fragment.from(rowContent)));
    }

    var fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
    return new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(fragment), 1, 1)
  };

  CellSelection.prototype.replace = function replace (tr, content) {
    if ( content === void 0 ) content = prosemirrorModel.Slice.empty;

    var mapFrom = tr.steps.length, ranges = this.ranges;
    for (var i = 0; i < ranges.length; i++) {
      var ref = ranges[i];
      var $from = ref.$from;
      var $to = ref.$to;
      var mapping = tr.mapping.slice(mapFrom);
      tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? prosemirrorModel.Slice.empty : content);
    }
    var sel = Selection.findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
    if (sel) { tr.setSelection(sel); }
  };

  CellSelection.prototype.replaceWith = function replaceWith (tr, node) {
    this.replace(tr, new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(node), 0, 0));
  };

  CellSelection.prototype.forEachCell = function forEachCell (f) {
    var table = this.$anchorCell.node(-1), map = TableMap.get(table), start = this.$anchorCell.start(-1);
    var cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
    for (var i = 0; i < cells.length; i++)
      { f(table.nodeAt(cells[i]), start + cells[i]); }
  };

  // :: () → bool
  // True if this selection goes all the way from the top to the
  // bottom of the table.
  CellSelection.prototype.isColSelection = function isColSelection () {
    var anchorTop = this.$anchorCell.index(-1), headTop = this.$headCell.index(-1);
    if (Math.min(anchorTop, headTop) > 0) { return false }
    var anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan,
        headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
    return Math.max(anchorBot, headBot) == this.$headCell.node(-1).childCount
  };

  // :: (ResolvedPos, ?ResolvedPos) → CellSelection
  // Returns the smallest column selection that covers the given anchor
  // and head cell.
  CellSelection.colSelection = function colSelection ($anchorCell, $headCell) {
    if ( $headCell === void 0 ) $headCell = $anchorCell;

    var map = TableMap.get($anchorCell.node(-1)), start = $anchorCell.start(-1);
    var anchorRect = map.findCell($anchorCell.pos - start), headRect = map.findCell($headCell.pos - start);
    var doc = $anchorCell.node(0);
    if (anchorRect.top <= headRect.top) {
      if (anchorRect.top > 0)
        { $anchorCell = doc.resolve(start + map.map[anchorRect.left]); }
      if (headRect.bottom < map.height)
        { $headCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]); }
    } else {
      if (headRect.top > 0)
        { $headCell = doc.resolve(start + map.map[headRect.left]); }
      if (anchorRect.bottom < map.height)
        { $anchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]); }
    }
    return new CellSelection($anchorCell, $headCell)
  };

  // :: () → bool
  // True if this selection goes all the way from the left to the
  // right of the table.
  CellSelection.prototype.isRowSelection = function isRowSelection () {
    var map = TableMap.get(this.$anchorCell.node(-1)), start = this.$anchorCell.start(-1);
    var anchorLeft = map.colCount(this.$anchorCell.pos - start),
        headLeft = map.colCount(this.$headCell.pos - start);
    if (Math.min(anchorLeft, headLeft) > 0) { return false }
    var anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan,
        headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
    return Math.max(anchorRight, headRight) == map.width
  };

  CellSelection.prototype.eq = function eq (other) {
    return other instanceof CellSelection && other.$anchorCell.pos == this.$anchorCell.pos &&
      other.$headCell.pos == this.$headCell.pos
  };

  // :: (ResolvedPos, ?ResolvedPos) → CellSelection
  // Returns the smallest row selection that covers the given anchor
  // and head cell.
  CellSelection.rowSelection = function rowSelection ($anchorCell, $headCell) {
    if ( $headCell === void 0 ) $headCell = $anchorCell;

    var map = TableMap.get($anchorCell.node(-1)), start = $anchorCell.start(-1);
    var anchorRect = map.findCell($anchorCell.pos - start), headRect = map.findCell($headCell.pos - start);
    var doc = $anchorCell.node(0);
    if (anchorRect.left <= headRect.left) {
      if (anchorRect.left > 0)
        { $anchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]); }
      if (headRect.right < map.width)
        { $headCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]); }
    } else {
      if (headRect.left > 0)
        { $headCell = doc.resolve(start + map.map[headRect.top * map.width]); }
      if (anchorRect.right < map.width)
        { $anchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]); }
    }
    return new CellSelection($anchorCell, $headCell)
  };

  CellSelection.prototype.toJSON = function toJSON () {
    return {type: "cell", anchor: this.$anchorCell.pos, head: this.$headCell.pos}
  };

  CellSelection.fromJSON = function fromJSON (doc, json) {
    return new CellSelection(doc.resolve(json.anchor), doc.resolve(json.head))
  };

  // :: (Node, number, ?number) → CellSelection
  CellSelection.create = function create (doc, anchorCell, headCell) {
    if ( headCell === void 0 ) headCell = anchorCell;

    return new CellSelection(doc.resolve(anchorCell), doc.resolve(headCell))
  };

  CellSelection.prototype.getBookmark = function getBookmark () { return new CellBookmark(this.$anchorCell.pos, this.$headCell.pos) };

  return CellSelection;
}(prosemirrorState.Selection));

CellSelection.prototype.visible = false;

prosemirrorState.Selection.jsonID("cell", CellSelection);

var CellBookmark = function CellBookmark(anchor, head) {
  this.anchor = anchor;
  this.head = head;
};
CellBookmark.prototype.map = function map (mapping) {
  return new CellBookmark(mapping.map(this.anchor), mapping.map(this.head))
};
CellBookmark.prototype.resolve = function resolve (doc) {
  var $anchorCell = doc.resolve(this.anchor), $headCell = doc.resolve(this.head);
  if ($anchorCell.parent.type.spec.tableRole == "row" &&
      $headCell.parent.type.spec.tableRole == "row" &&
      $anchorCell.index() < $anchorCell.parent.childCount &&
      $headCell.index() < $headCell.parent.childCount &&
      inSameTable($anchorCell, $headCell))
    { return new CellSelection($anchorCell, $headCell) }
  else
    { return prosemirrorState.Selection.near($headCell, 1) }
};

function drawCellSelection(state) {
  if (!(state.selection instanceof CellSelection)) { return null }
  var cells = [];
  state.selection.forEachCell(function (node, pos) {
    cells.push(prosemirrorView.Decoration.node(pos, pos + node.nodeSize, {class: "selectedCell"}));
  });
  return prosemirrorView.DecorationSet.create(state.doc, cells)
}

function isCellBoundarySelection(ref) {
  var $from = ref.$from;
  var $to = ref.$to;

  if ($from.pos == $to.pos || $from.pos < $from.pos - 6) { return false } // Cheap elimination
  var afterFrom = $from.pos, beforeTo = $to.pos, depth = $from.depth;
  for (; depth >= 0; depth--, afterFrom++)
    { if ($from.after(depth + 1) < $from.end(depth)) { break } }
  for (var d = $to.depth; d >= 0; d--, beforeTo--)
    { if ($to.before(d + 1) > $to.start(d)) { break } }
  return afterFrom == beforeTo && /row|table/.test($from.node(depth).type.spec.tableRole)
}

function isTextSelectionAcrossCells(ref) {
  var $from = ref.$from;
  var $to = ref.$to;

  var fromCellBoundaryNode;
  var toCellBoundaryNode;

  for (var i = $from.depth; i > 0; i--) {
    var node = $from.node(i);
    if (node.type.spec.tableRole === 'cell' || node.type.spec.tableRole === 'header_cell') {
      fromCellBoundaryNode = node;
      break;
    }
  }

  for (var i$1 = $to.depth; i$1 > 0; i$1--) {
    var node$1 = $to.node(i$1);
    if (node$1.type.spec.tableRole === 'cell' || node$1.type.spec.tableRole === 'header_cell') {
      toCellBoundaryNode = node$1;
      break;
    }
  }

  return fromCellBoundaryNode !== toCellBoundaryNode && $to.parentOffset === 0
}

function normalizeSelection(state, tr) {
  var sel = (tr || state).selection, doc = (tr || state).doc, normalize, role;
  if (sel instanceof prosemirrorState.NodeSelection && (role = sel.node.type.spec.tableRole)) {
    if (role == "cell" || role == "header_cell") {
      normalize = CellSelection.create(doc, sel.from);
    } else if (role == "row") {
      var $cell = doc.resolve(sel.from + 1);
      normalize = CellSelection.rowSelection($cell, $cell);
    } else {
      var map = TableMap.get(sel.node), start = sel.from + 1;
      var lastCell = start + map.map[map.width * map.height - 1];
      normalize = CellSelection.create(doc, start + 1, lastCell);
    }
  } else if (sel instanceof prosemirrorState.TextSelection && isCellBoundarySelection(sel)) {
    normalize = prosemirrorState.TextSelection.create(doc, sel.from);
  } else if (sel instanceof prosemirrorState.TextSelection && isTextSelectionAcrossCells(sel)) {
    normalize = prosemirrorState.TextSelection.create(doc, sel.$from.start(), sel.$from.end());
  }
  if (normalize)
    { (tr || (tr = state.tr)).setSelection(normalize); }
  return tr
}

// Helper for creating a schema that supports tables.

function getCellAttrs(dom, extraAttrs) {
  var widthAttr = dom.getAttribute("data-colwidth");
  var widths = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(",").map(function (s) { return Number(s); }) : null;
  var colspan = Number(dom.getAttribute("colspan") || 1);
  var result = {
    colspan: colspan,
    rowspan: Number(dom.getAttribute("rowspan") || 1),
    colwidth: widths && widths.length == colspan ? widths : null
  };
  for (var prop in extraAttrs) {
    var getter = extraAttrs[prop].getFromDOM;
    var value = getter && getter(dom);
    if (value != null) { result[prop] = value; }
  }
  return result
}

function setCellAttrs(node, extraAttrs) {
  var attrs = {};
  if (node.attrs.colspan != 1) { attrs.colspan = node.attrs.colspan; }
  if (node.attrs.rowspan != 1) { attrs.rowspan = node.attrs.rowspan; }
  if (node.attrs.colwidth)
    { attrs["data-colwidth"] = node.attrs.colwidth.join(","); }
  for (var prop in extraAttrs) {
    var setter = extraAttrs[prop].setDOMAttr;
    if (setter) { setter(node.attrs[prop], attrs); }
  }
  return attrs
}

// :: (Object) → Object
//
// This function creates a set of [node
// specs](http://prosemirror.net/docs/ref/#model.SchemaSpec.nodes) for
// `table`, `table_row`, and `table_cell` nodes types as used by this
// module. The result can then be added to the set of nodes when
// creating a a schema.
//
//   options::- The following options are understood:
//
//     tableGroup:: ?string
//     A group name (something like `"block"`) to add to the table
//     node type.
//
//     cellContent:: string
//     The content expression for table cells.
//
//     cellAttributes:: ?Object
//     Additional attributes to add to cells. Maps attribute names to
//     objects with the following properties:
//
//       default:: any
//       The attribute's default value.
//
//       getFromDOM:: ?(dom.Node) → any
//       A function to read the attribute's value from a DOM node.
//
//       setDOMAttr:: ?(value: any, attrs: Object)
//       A function to add the attribute's value to an attribute
//       object that's used to render the cell's DOM.
function tableNodes(options) {
  var extraAttrs = options.cellAttributes || {};
  var cellAttrs = {
    colspan: {default: 1},
    rowspan: {default: 1},
    colwidth: {default: null}
  };
  for (var prop in extraAttrs)
    { cellAttrs[prop] = {default: extraAttrs[prop].default}; }

  return {
    table: {
      content: "table_row+",
      tableRole: "table",
      isolating: true,
      group: options.tableGroup,
      parseDOM: [{tag: "table"}],
      toDOM: function toDOM() { return ["table", ["tbody", 0]] }
    },
    table_row: {
      content: "(table_cell | table_header)*",
      tableRole: "row",
      parseDOM: [{tag: "tr"}],
      toDOM: function toDOM() { return ["tr", 0] }
    },
    table_cell: {
      content: options.cellContent,
      attrs: cellAttrs,
      tableRole: "cell",
      isolating: true,
      parseDOM: [{tag: "td", getAttrs: function (dom) { return getCellAttrs(dom, extraAttrs); }}],
      toDOM: function toDOM(node) { return ["td", setCellAttrs(node, extraAttrs), 0] }
    },
    table_header: {
      content: options.cellContent,
      attrs: cellAttrs,
      tableRole: "header_cell",
      isolating: true,
      parseDOM: [{tag: "th", getAttrs: function (dom) { return getCellAttrs(dom, extraAttrs); }}],
      toDOM: function toDOM(node) { return ["th", setCellAttrs(node, extraAttrs), 0] }
    }
  }
}

function tableNodeTypes(schema) {
  var result = schema.cached.tableNodeTypes;
  if (!result) {
    result = schema.cached.tableNodeTypes = {};
    for (var name in schema.nodes) {
      var type = schema.nodes[name], role = type.spec.tableRole;
      if (role) { result[role] = type; }
    }
  }
  return result
}

// Utilities used for copy/paste handling.

// Utilities to help with copying and pasting table cells

// : (Slice) → ?{width: number, height: number, rows: [Fragment]}
// Get a rectangular area of cells from a slice, or null if the outer
// nodes of the slice aren't table cells or rows.
function pastedCells(slice) {
  if (!slice.size) { return null }
  var content = slice.content;
  var openStart = slice.openStart;
  var openEnd = slice.openEnd;
  while (content.childCount == 1 && (openStart > 0 && openEnd > 0 || content.firstChild.type.spec.tableRole == "table")) {
    openStart--;
    openEnd--;
    content = content.firstChild.content;
  }
  var first = content.firstChild, role = first.type.spec.tableRole;
  var schema = first.type.schema, rows = [];
  if (role == "row") {
    for (var i = 0; i < content.childCount; i++) {
      var cells = content.child(i).content;
      var left = i ? 0 : Math.max(0, openStart - 1);
      var right = i < content.childCount - 1 ? 0 : Math.max(0, openEnd - 1);
      if (left || right) { cells = fitSlice(tableNodeTypes(schema).row, new prosemirrorModel.Slice(cells, left, right)).content; }
      rows.push(cells);
    }
  } else if (role == "cell" || role == "header_cell") {
    rows.push(openStart || openEnd ? fitSlice(tableNodeTypes(schema).row, new prosemirrorModel.Slice(content, openStart, openEnd)).content : content);
  } else {
    return null
  }
  return ensureRectangular(schema, rows)
}

// : (Schema, [Fragment]) → {width: number, height: number, rows: [Fragment]}
// Compute the width and height of a set of cells, and make sure each
// row has the same number of cells.
function ensureRectangular(schema, rows) {
  var widths = [];
  for (var i = 0; i < rows.length; i++) {
    var row = rows[i];
    for (var j = row.childCount - 1; j >= 0; j--) {
      var ref = row.child(j).attrs;
      var rowspan = ref.rowspan;
      var colspan = ref.colspan;
      for (var r = i; r < i + rowspan; r++)
        { widths[r] = (widths[r] || 0) + colspan; }
    }
  }
  var width = 0;
  for (var r$1 = 0; r$1 < widths.length; r$1++) { width = Math.max(width, widths[r$1]); }
  for (var r$2 = 0; r$2 < widths.length; r$2++) {
    if (r$2 >= rows.length) { rows.push(prosemirrorModel.Fragment.empty); }
    if (widths[r$2] < width) {
      var empty = tableNodeTypes(schema).cell.createAndFill(), cells = [];
      for (var i$1 = widths[r$2]; i$1 < width; i$1++) { cells.push(empty); }
      rows[r$2] = rows[r$2].append(prosemirrorModel.Fragment.from(cells));
    }
  }
  return {height: rows.length, width: width, rows: rows}
}

function fitSlice(nodeType, slice) {
  var node = nodeType.createAndFill();
  var tr = new prosemirrorTransform.Transform(node).replace(0, node.content.size, slice);
  return tr.doc
}

// : ({width: number, height: number, rows: [Fragment]}, number, number) → {width: number, height: number, rows: [Fragment]}
// Clip or extend (repeat) the given set of cells to cover the given
// width and height. Will clip rowspan/colspan cells at the edges when
// they stick out.
function clipCells(ref, newWidth, newHeight) {
  var width = ref.width;
  var height = ref.height;
  var rows = ref.rows;

  if (width != newWidth) {
    var added = [], newRows = [];
    for (var row = 0; row < rows.length; row++) {
      var frag = rows[row], cells = [];
      for (var col = added[row] || 0, i = 0; col < newWidth; i++) {
        var cell = frag.child(i % frag.childCount);
        if (col + cell.attrs.colspan > newWidth)
          { cell = cell.type.create(rmColSpan(cell.attrs, cell.attrs.colspan, col + cell.attrs.colspan - newWidth), cell.content); }
        cells.push(cell);
        col += cell.attrs.colspan;
        for (var j = 1; j < cell.attrs.rowspan; j++)
          { added[row + j] = (added[row + j] || 0) + cell.attrs.colspan; }
      }
      newRows.push(prosemirrorModel.Fragment.from(cells));
    }
    rows = newRows;
    width = newWidth;
  }

  if (height != newHeight) {
    var newRows$1 = [];
    for (var row$1 = 0, i$1 = 0; row$1 < newHeight; row$1++, i$1++) {
      var cells$1 = [], source = rows[i$1 % height];
      for (var j$1 = 0; j$1 < source.childCount; j$1++) {
        var cell$1 = source.child(j$1);
        if (row$1 + cell$1.attrs.rowspan > newHeight)
          { cell$1 = cell$1.type.create(setAttr(cell$1.attrs, "rowspan", newHeight - cell$1.attrs.rowspan), cell$1.content); }
        cells$1.push(cell$1);
      }
      newRows$1.push(prosemirrorModel.Fragment.from(cells$1));
    }
    rows = newRows$1;
    height = newHeight;
  }

  return {width: width, height: height, rows: rows}
}

// Make sure a table has at least the given width and height. Return
// true if something was changed.
function growTable(tr, map, table, start, width, height, mapFrom) {
  var schema = tr.doc.type.schema, types = tableNodeTypes(schema), empty, emptyHead;
  if (width > map.width) {
    for (var row = 0, rowEnd = 0; row < map.height; row++) {
      var rowNode = table.child(row);
      rowEnd += rowNode.nodeSize;
      var cells = [], add = (void 0);
      if (rowNode.lastChild == null || rowNode.lastChild.type == types.cell)
        { add = empty || (empty = types.cell.createAndFill()); }
      else
        { add = emptyHead || (emptyHead = types.header_cell.createAndFill()); }
      for (var i = map.width; i < width; i++) { cells.push(add); }
      tr.insert(tr.mapping.slice(mapFrom).map(rowEnd - 1 + start), cells);
    }
  }
  if (height > map.height) {
    var cells$1 = [];
    for (var i$1 = 0, start$1 = (map.height - 1) * map.width; i$1 < Math.max(map.width, width); i$1++) {
      var header = i$1 >= map.width ? false :
          table.nodeAt(map.map[start$1 + i$1]).type == types.header_cell;
      cells$1.push(header
                 ? (emptyHead || (emptyHead = types.header_cell.createAndFill()))
                 : (empty || (empty = types.cell.createAndFill())));
    }

    var emptyRow = types.row.create(null, prosemirrorModel.Fragment.from(cells$1)), rows = [];
    for (var i$2 = map.height; i$2 < height; i$2++) { rows.push(emptyRow); }
    tr.insert(tr.mapping.slice(mapFrom).map(start + table.nodeSize - 2), rows);
  }
  return !!(empty || emptyHead)
}

// Make sure the given line (left, top) to (right, top) doesn't cross
// any rowspan cells by splitting cells that cross it. Return true if
// something changed.
function isolateHorizontal(tr, map, table, start, left, right, top, mapFrom) {
  if (top == 0 || top == map.height) { return false }
  var found = false;
  for (var col = left; col < right; col++) {
    var index = top * map.width + col, pos = map.map[index];
    if (map.map[index - map.width] == pos) {
      found = true;
      var cell = table.nodeAt(pos);
      var ref = map.findCell(pos);
      var cellTop = ref.top;
      var cellLeft = ref.left;
      tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + start), null, setAttr(cell.attrs, "rowspan", top - cellTop));
      tr.insert(tr.mapping.slice(mapFrom).map(map.positionAt(top, cellLeft, table)),
                cell.type.createAndFill(setAttr(cell.attrs, "rowspan", (cellTop + cell.attrs.rowspan) - top)));
      col += cell.attrs.colspan - 1;
    }
  }
  return found
}

// Make sure the given line (left, top) to (left, bottom) doesn't
// cross any colspan cells by splitting cells that cross it. Return
// true if something changed.
function isolateVertical(tr, map, table, start, top, bottom, left, mapFrom) {
  if (left == 0 || left == map.width) { return false }
  var found = false;
  for (var row = top; row < bottom; row++) {
    var index = row * map.width + left, pos = map.map[index];
    if (map.map[index - 1] == pos) {
      found = true;
      var cell = table.nodeAt(pos), cellLeft = map.colCount(pos);
      var updatePos = tr.mapping.slice(mapFrom).map(pos + start);
      tr.setNodeMarkup(updatePos, null, rmColSpan(cell.attrs, left - cellLeft, cell.attrs.colspan - (left - cellLeft)));
      tr.insert(updatePos + cell.nodeSize, cell.type.createAndFill(rmColSpan(cell.attrs, 0, left - cellLeft)));
      row += cell.attrs.rowspan - 1;
    }
  }
  return found
}

// Insert the given set of cells (as returned by `pastedCells`) into a
// table, at the position pointed at by rect.
function insertCells(state, dispatch, tableStart, rect, cells) {
  var table = tableStart ? state.doc.nodeAt(tableStart - 1) : state.doc, map = TableMap.get(table);
  var top = rect.top;
  var left = rect.left;
  var right = left + cells.width, bottom = top + cells.height;
  var tr = state.tr, mapFrom = 0;
  function recomp() {
    table = tableStart ? tr.doc.nodeAt(tableStart - 1) : tr.doc;
    map = TableMap.get(table);
    mapFrom = tr.mapping.maps.length;
  }
  // Prepare the table to be large enough and not have any cells
  // crossing the boundaries of the rectangle that we want to
  // insert into. If anything about it changes, recompute the table
  // map so that subsequent operations can see the current shape.
  if (growTable(tr, map, table, tableStart, right, bottom, mapFrom)) { recomp(); }
  if (isolateHorizontal(tr, map, table, tableStart, left, right, top, mapFrom)) { recomp(); }
  if (isolateHorizontal(tr, map, table, tableStart, left, right, bottom, mapFrom)) { recomp(); }
  if (isolateVertical(tr, map, table, tableStart, top, bottom, left, mapFrom)) { recomp(); }
  if (isolateVertical(tr, map, table, tableStart, top, bottom, right, mapFrom)) { recomp(); }

  for (var row = top; row < bottom; row++) {
    var from = map.positionAt(row, left, table), to = map.positionAt(row, right, table);
    tr.replace(tr.mapping.slice(mapFrom).map(from + tableStart), tr.mapping.slice(mapFrom).map(to + tableStart),
               new prosemirrorModel.Slice(cells.rows[row - top], 0, 0));
  }
  recomp();
  tr.setSelection(new CellSelection(tr.doc.resolve(tableStart + map.positionAt(top, left, table)),
                                    tr.doc.resolve(tableStart + map.positionAt(bottom - 1, right - 1, table))));
  dispatch(tr);
}

// This file defines a number of helpers for wiring up user input to

var handleKeyDown = prosemirrorKeymap.keydownHandler({
  "ArrowLeft": arrow("horiz", -1),
  "ArrowRight": arrow("horiz", 1),
  "ArrowUp": arrow("vert", -1),
  "ArrowDown": arrow("vert", 1),

  "Shift-ArrowLeft": shiftArrow("horiz", -1),
  "Shift-ArrowRight": shiftArrow("horiz", 1),
  "Shift-ArrowUp": shiftArrow("vert", -1),
  "Shift-ArrowDown": shiftArrow("vert", 1),

  "Backspace": deleteCellSelection,
  "Mod-Backspace": deleteCellSelection,
  "Delete": deleteCellSelection,
  "Mod-Delete": deleteCellSelection
});

function maybeSetSelection(state, dispatch, selection) {
  if (selection.eq(state.selection)) { return false }
  if (dispatch) { dispatch(state.tr.setSelection(selection).scrollIntoView()); }
  return true
}

function arrow(axis, dir) {
  return function (state, dispatch, view) {
    var sel = state.selection;
    if (sel instanceof CellSelection) {
      return maybeSetSelection(state, dispatch, prosemirrorState.Selection.near(sel.$headCell, dir))
    }
    if (axis != "horiz" && !sel.empty) { return false }
    var end = atEndOfCell(view, axis, dir);
    if (end == null) { return false }
    if (axis == "horiz") {
      return maybeSetSelection(state, dispatch, prosemirrorState.Selection.near(state.doc.resolve(sel.head + dir), dir))
    } else {
      var $cell = state.doc.resolve(end), $next = nextCell($cell, axis, dir), newSel;
      if ($next) { newSel = prosemirrorState.Selection.near($next, 1); }
      else if (dir < 0) { newSel = prosemirrorState.Selection.near(state.doc.resolve($cell.before(-1)), -1); }
      else { newSel = prosemirrorState.Selection.near(state.doc.resolve($cell.after(-1)), 1); }
      return maybeSetSelection(state, dispatch, newSel)
    }
  }
}

function shiftArrow(axis, dir) {
  return function (state, dispatch, view) {
    var sel = state.selection;
    if (!(sel instanceof CellSelection)) {
      var end = atEndOfCell(view, axis, dir);
      if (end == null) { return false }
      sel = new CellSelection(state.doc.resolve(end));
    }
    var $head = nextCell(sel.$headCell, axis, dir);
    if (!$head) { return false }
    return maybeSetSelection(state, dispatch, new CellSelection(sel.$anchorCell, $head))
  }
}

function deleteCellSelection(state, dispatch) {
  var sel = state.selection;
  if (!(sel instanceof CellSelection)) { return false }
  if (dispatch) {
    var tr = state.tr, baseContent = tableNodeTypes(state.schema).cell.createAndFill().content;
    sel.forEachCell(function (cell, pos) {
      if (!cell.content.eq(baseContent))
        { tr.replace(tr.mapping.map(pos + 1), tr.mapping.map(pos + cell.nodeSize - 1),
                   new prosemirrorModel.Slice(baseContent, 0, 0)); }
    });
    if (tr.docChanged) { dispatch(tr); }
  }
  return true
}

function handleTripleClick(view, pos) {
  var doc = view.state.doc, $cell = cellAround(doc.resolve(pos));
  if (!$cell) { return false }
  view.dispatch(view.state.tr.setSelection(new CellSelection($cell)));
  return true
}

function handlePaste(view, _, slice) {
  if (!isInTable(view.state)) { return false }
  var cells = pastedCells(slice), sel = view.state.selection;
  if (sel instanceof CellSelection) {
    if (!cells) { cells = {width: 1, height: 1, rows: [prosemirrorModel.Fragment.from(fitSlice(tableNodeTypes(view.state.schema).cell, slice))]}; }
    var table = sel.$anchorCell.node(-1), start = sel.$anchorCell.start(-1);
    var rect = TableMap.get(table).rectBetween(sel.$anchorCell.pos - start, sel.$headCell.pos - start);
    cells = clipCells(cells, rect.right - rect.left, rect.bottom - rect.top);
    insertCells(view.state, view.dispatch, start, rect, cells);
    return true
  } else if (cells) {
    var $cell = selectionCell(view.state), start$1 = $cell.start(-1);
    insertCells(view.state, view.dispatch, start$1, TableMap.get($cell.node(-1)).findCell($cell.pos - start$1), cells);
    return true
  } else {
    return false
  }
}

function handleMouseDown(view, startEvent) {
  if (startEvent.ctrlKey || startEvent.metaKey) { return }

  var startDOMCell = domInCell(view, startEvent.target), $anchor;
  if (startEvent.shiftKey && (view.state.selection instanceof CellSelection)) {
    // Adding to an existing cell selection
    setCellSelection(view.state.selection.$anchorCell, startEvent);
    startEvent.preventDefault();
  } else if (startEvent.shiftKey && startDOMCell &&
             ($anchor = cellAround(view.state.selection.$anchor)) != null &&
             cellUnderMouse(view, startEvent).pos != $anchor.pos) {
    // Adding to a selection that starts in another cell (causing a
    // cell selection to be created).
    setCellSelection($anchor, startEvent);
    startEvent.preventDefault();
  } else if (!startDOMCell) {
    // Not in a cell, let the default behavior happen.
    return
  }

  // Create and dispatch a cell selection between the given anchor and
  // the position under the mouse.
  function setCellSelection($anchor, event) {
    var $head = cellUnderMouse(view, event);
    var starting = key.getState(view.state) == null;
    if (!$head || !inSameTable($anchor, $head)) {
      if (starting) { $head = $anchor; }
      else { return }
    }
    var selection = new CellSelection($anchor, $head);
    if (starting || !view.state.selection.eq(selection)) {
      var tr = view.state.tr.setSelection(selection);
      if (starting) { tr.setMeta(key, $anchor.pos); }
      view.dispatch(tr);
    }
  }

  // Stop listening to mouse motion events.
  function stop() {
    view.root.removeEventListener("mouseup", stop);
    view.root.removeEventListener("dragstart", stop);
    view.root.removeEventListener("mousemove", move);
    if (key.getState(view.state) != null) { view.dispatch(view.state.tr.setMeta(key, -1)); }
  }

  function move(event) {
    var anchor = key.getState(view.state), $anchor;
    if (anchor != null) {
      // Continuing an existing cross-cell selection
      $anchor = view.state.doc.resolve(anchor);
    } else if (domInCell(view, event.target) != startDOMCell) {
      // Moving out of the initial cell -- start a new cell selection
      $anchor = cellUnderMouse(view, startEvent);
      if (!$anchor) { return stop() }
    }
    if ($anchor) { setCellSelection($anchor, event); }
  }
  view.root.addEventListener("mouseup", stop);
  view.root.addEventListener("dragstart", stop);
  view.root.addEventListener("mousemove", move);
}

// Check whether the cursor is at the end of a cell (so that further
// motion would move out of the cell)
function atEndOfCell(view, axis, dir) {
  if (!(view.state.selection instanceof prosemirrorState.TextSelection)) { return null }
  var ref = view.state.selection;
  var $head = ref.$head;
  for (var d = $head.depth - 1; d >= 0; d--) {
    var parent = $head.node(d), index = dir < 0 ? $head.index(d) : $head.indexAfter(d);
    if (index != (dir < 0 ? 0 : parent.childCount)) { return null }
    if (parent.type.spec.tableRole == "cell" || parent.type.spec.tableRole == "header_cell") {
      var cellPos = $head.before(d);
      var dirStr = axis == "vert" ? (dir > 0 ? "down" : "up") : (dir > 0 ? "right" : "left");
      return view.endOfTextblock(dirStr) ? cellPos : null
    }
  }
  return null
}

function domInCell(view, dom) {
  for (; dom && dom != view.dom; dom = dom.parentNode)
    { if (dom.nodeName == "TD" || dom.nodeName == "TH") { return dom } }
}

function cellUnderMouse(view, event) {
  var mousePos = view.posAtCoords({left: event.clientX, top: event.clientY});
  if (!mousePos) { return null }
  return mousePos ? cellAround(view.state.doc.resolve(mousePos.pos)) : null
}

// This file defines helpers for normalizing tables, making sure no

// Helper for iterating through the nodes in a document that changed
// compared to the given previous document. Useful for avoiding
// duplicate work on each transaction.
function changedDescendants(old, cur, offset, f) {
  var oldSize = old.childCount, curSize = cur.childCount;
  outer: for (var i = 0, j = 0; i < curSize; i++) {
    var child = cur.child(i);
    for (var scan = j, e = Math.min(oldSize, i + 3); scan < e; scan++) {
      if (old.child(scan) == child) {
        j = scan + 1;
        offset += child.nodeSize;
        continue outer
      }
    }
    f(child, offset);
    if (j < oldSize && old.child(j).sameMarkup(child))
      { changedDescendants(old.child(j), child, offset + 1, f); }
    else
      { child.nodesBetween(0, child.content.size, f, offset + 1); }
    offset += child.nodeSize;
  }
}

// :: (EditorState, ?EditorState) → ?Transaction
// Inspect all tables in the given state's document and return a
// transaction that fixes them, if necessary. If `oldState` was
// provided, that is assumed to hold a previous, known-good state,
// which will be used to avoid re-scanning unchanged parts of the
// document.
function fixTables(state, oldState) {
  var tr, check = function (node, pos) {
    if (node.type.spec.tableRole == "table") { tr = fixTable(state, node, pos, tr); }
  };
  if (!oldState) { state.doc.descendants(check); }
  else if (oldState.doc != state.doc) { changedDescendants(oldState.doc, state.doc, 0, check); }
  return tr
}

// : (EditorState, Node, number, ?Transaction) → ?Transaction
// Fix the given table, if necessary. Will append to the transaction
// it was given, if non-null, or create a new one if necessary.
function fixTable(state, table, tablePos, tr) {
  var map = TableMap.get(table);
  if (!map.problems) { return tr }
  if (!tr) { tr = state.tr; }

  // Track which rows we must add cells to, so that we can adjust that
  // when fixing collisions.
  var mustAdd = [];
  for (var i = 0; i < map.height; i++) { mustAdd.push(0); }
  for (var i$1 = 0; i$1 < map.problems.length; i$1++) {
    var prob = map.problems[i$1];
    if (prob.type == "collision") {
      var cell = table.nodeAt(prob.pos);
      for (var j = 0; j < cell.attrs.rowspan; j++) { mustAdd[prob.row + j] += prob.n; }
      tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, rmColSpan(cell.attrs, cell.attrs.colspan - prob.n, prob.n));
    } else if (prob.type == "missing") {
      mustAdd[prob.row] += prob.n;
    } else if (prob.type == "overlong_rowspan") {
      var cell$1 = table.nodeAt(prob.pos);
      tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, setAttr(cell$1.attrs, "rowspan", cell$1.attrs.rowspan - prob.n));
    } else if (prob.type == "colwidth mismatch") {
      var cell$2 = table.nodeAt(prob.pos);
      tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, setAttr(cell$2.attrs, "colwidth", prob.colwidth));
    }
  }
  var first, last;
  for (var i$2 = 0; i$2 < mustAdd.length; i$2++) { if (mustAdd[i$2]) {
    if (first == null) { first = i$2; }
    last = i$2;
  } }
  // Add the necessary cells, using a heuristic for whether to add the
  // cells at the start or end of the rows (if it looks like a 'bite'
  // was taken out of the table, add cells at the start of the row
  // after the bite. Otherwise add them at the end).
  for (var i$3 = 0, pos = tablePos + 1; i$3 < map.height; i$3++) {
    var row = table.child(i$3);
    var end = pos + row.nodeSize;
    var add = mustAdd[i$3];
    if (add > 0) {
      var tableNodeType = 'cell';
      if (row.firstChild) {
        tableNodeType = row.firstChild.type.spec.tableRole;
      }
      var nodes = [];
      for (var j$1 = 0; j$1 < add; j$1++)
        { nodes.push(tableNodeTypes(state.schema)[tableNodeType].createAndFill()); }
      var side = (i$3 == 0 || first == i$3 - 1) && last == i$3 ? pos + 1 : end - 1;
      tr.insert(tr.mapping.map(side), nodes);
    }
    pos = end;
  }
  return tr
}

// This file defines a number of table-related commands.

// Helper to get the selected rectangle in a table, if any. Adds table
// map, table node, and table start offset to the object for
// convenience.
function selectedRect(state) {
  var sel = state.selection, $pos = selectionCell(state);
  var table = $pos.node(-1), tableStart = $pos.start(-1), map = TableMap.get(table);
  var rect;
  if (sel instanceof CellSelection)
    { rect = map.rectBetween(sel.$anchorCell.pos - tableStart, sel.$headCell.pos - tableStart); }
  else
    { rect = map.findCell($pos.pos - tableStart); }
  rect.tableStart = tableStart;
  rect.map = map;
  rect.table = table;
  return rect
}

function columnIsHeader(map, table, col) {
  var headerCell = tableNodeTypes(table.type.schema).header_cell;
  for (var row = 0; row < map.height; row++)
    { if (table.nodeAt(map.map[col + row * map.width]).type != headerCell)
      { return false } }
  return true
}

// Add a column at the given position in a table.
function addColumn(tr, ref, col) {
  var map = ref.map;
  var tableStart = ref.tableStart;
  var table = ref.table;

  var refColumn = col > 0 ? -1 : 0;
  if (columnIsHeader(map, table, col + refColumn))
    { refColumn = col == 0 || col == map.width ? null : 0; }

  for (var row = 0; row < map.height; row++) {
    var index = row * map.width + col;
    // If this position falls inside a col-spanning cell
    if (col > 0 && col < map.width && map.map[index - 1] == map.map[index]) {
      var pos = map.map[index], cell = table.nodeAt(pos);
      tr.setNodeMarkup(tr.mapping.map(tableStart + pos), null,
                       addColSpan(cell.attrs, col - map.colCount(pos)));
      // Skip ahead if rowspan > 1
      row += cell.attrs.rowspan - 1;
    } else {
      var type = refColumn == null ? tableNodeTypes(table.type.schema).cell
          : table.nodeAt(map.map[index + refColumn]).type;
      var pos$1 = map.positionAt(row, col, table);
      tr.insert(tr.mapping.map(tableStart + pos$1), type.createAndFill());
    }
  }
  return tr
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Command to add a column before the column with the selection.
function addColumnBefore(state, dispatch) {
  if (!isInTable(state)) { return false }
  if (dispatch) {
    var rect = selectedRect(state);
    dispatch(addColumn(state.tr, rect, rect.left));
  }
  return true
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Command to add a column after the column with the selection.
function addColumnAfter(state, dispatch) {
  if (!isInTable(state)) { return false }
  if (dispatch) {
    var rect = selectedRect(state);
    dispatch(addColumn(state.tr, rect, rect.right));
  }
  return true
}

function removeColumn(tr, ref, col) {
  var map = ref.map;
  var table = ref.table;
  var tableStart = ref.tableStart;

  var mapStart = tr.mapping.maps.length;
  for (var row = 0; row < map.height;) {
    var index = row * map.width + col, pos = map.map[index], cell = table.nodeAt(pos);
    // If this is part of a col-spanning cell
    if ((col > 0 && map.map[index - 1] == pos) || (col < map.width - 1 && map.map[index + 1] == pos)) {
      tr.setNodeMarkup(tr.mapping.slice(mapStart).map(tableStart + pos), null,
                       rmColSpan(cell.attrs, col - map.colCount(pos)));
    } else {
      var start = tr.mapping.slice(mapStart).map(tableStart + pos);
      tr.delete(start, start + cell.nodeSize);
    }
    row += cell.attrs.rowspan;
  }
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Command function that removes the selected columns from a table.
function deleteColumn(state, dispatch) {
  if (!isInTable(state)) { return false }
  if (dispatch) {
    var rect = selectedRect(state), tr = state.tr;
    if (rect.left == 0 && rect.right == rect.map.width) { return false }
    for (var i = rect.right - 1;; i--) {
      removeColumn(tr, rect, i);
      if (i == rect.left) { break }
      rect.table = rect.tableStart ? tr.doc.nodeAt(rect.tableStart - 1) : tr.doc;
      rect.map = TableMap.get(rect.table);
    }
    dispatch(tr);
  }
  return true
}

function rowIsHeader(map, table, row) {
  var headerCell = tableNodeTypes(table.type.schema).header_cell;
  for (var col = 0; col < map.width; col++)
    { if (table.nodeAt(map.map[col + row * map.width]).type != headerCell)
      { return false } }
  return true
}

function addRow(tr, ref, row) {
  var map = ref.map;
  var tableStart = ref.tableStart;
  var table = ref.table;

  var rowPos = tableStart;
  for (var i = 0; i < row; i++) { rowPos += table.child(i).nodeSize; }
  var cells = [], refRow = row > 0 ? -1 : 0;
  if (rowIsHeader(map, table, row + refRow))
    { refRow = row == 0 || row == map.height ? null : 0; }
  for (var col = 0, index = map.width * row; col < map.width; col++, index++) {
    // Covered by a rowspan cell
    if (row > 0 && row < map.height && map.map[index] == map.map[index - map.width]) {
      var pos = map.map[index], attrs = table.nodeAt(pos).attrs;
      tr.setNodeMarkup(tableStart + pos, null, setAttr(attrs, "rowspan", attrs.rowspan + 1));
      col += attrs.colspan - 1;
    } else {
      var type = refRow == null ? tableNodeTypes(table.type.schema).cell
          : table.nodeAt(map.map[index + refRow * map.width]).type;
      cells.push(type.createAndFill());
    }
  }
  tr.insert(rowPos, tableNodeTypes(table.type.schema).row.create(null, cells));
  return tr
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Add a table row before the selection.
function addRowBefore(state, dispatch) {
  if (!isInTable(state)) { return false }
  if (dispatch) {
    var rect = selectedRect(state);
    dispatch(addRow(state.tr, rect, rect.top));
  }
  return true
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Add a table row after the selection.
function addRowAfter(state, dispatch) {
  if (!isInTable(state)) { return false }
  if (dispatch) {
    var rect = selectedRect(state);
    dispatch(addRow(state.tr, rect, rect.bottom));
  }
  return true
}

function removeRow(tr, ref, row) {
  var map = ref.map;
  var table = ref.table;
  var tableStart = ref.tableStart;

  var rowPos = 0;
  for (var i = 0; i < row; i++) { rowPos += table.child(i).nodeSize; }
  var nextRow = rowPos + table.child(row).nodeSize;

  var mapFrom = tr.mapping.maps.length;
  tr.delete(rowPos + tableStart, nextRow + tableStart);

  for (var col = 0, index = row * map.width; col < map.width; col++, index++) {
    var pos = map.map[index];
    if (row > 0 && pos == map.map[index - map.width]) {
      // If this cell starts in the row above, simply reduce its rowspan
      var attrs = table.nodeAt(pos).attrs;
      tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + tableStart), null, setAttr(attrs, "rowspan", attrs.rowspan - 1));
      col += attrs.colspan - 1;
    } else if (row < map.width && pos == map.map[index + map.width]) {
      // Else, if it continues in the row below, it has to be moved down
      var cell = table.nodeAt(pos);
      var copy = cell.type.create(setAttr(cell.attrs, "rowspan", cell.attrs.rowspan - 1), cell.content);
      var newPos = map.positionAt(row + 1, col, table);
      tr.insert(tr.mapping.slice(mapFrom).map(tableStart + newPos), copy);
      col += cell.attrs.colspan - 1;
    }
  }
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Remove the selected rows from a table.
function deleteRow(state, dispatch) {
  if (!isInTable(state)) { return false }
  if (dispatch) {
    var rect = selectedRect(state), tr = state.tr;
    if (rect.top == 0 && rect.bottom == rect.map.height) { return false }
    for (var i = rect.bottom - 1;; i--) {
      removeRow(tr, rect, i);
      if (i == rect.top) { break }
      rect.table = rect.tableStart ? tr.doc.nodeAt(rect.tableStart - 1) : tr.doc;
      rect.map = TableMap.get(rect.table);
    }
    dispatch(tr);
  }
  return true
}

function isEmpty(cell) {
  var c = cell.content;
  return c.childCount == 1 && c.firstChild.isTextblock && c.firstChild.childCount == 0
}

function cellsOverlapRectangle(ref, rect) {
  var width = ref.width;
  var height = ref.height;
  var map = ref.map;

  var indexTop = rect.top * width + rect.left, indexLeft = indexTop;
  var indexBottom = (rect.bottom - 1) * width + rect.left, indexRight = indexTop + (rect.right - rect.left - 1);
  for (var i = rect.top; i < rect.bottom; i++) {
    if (rect.left > 0 && map[indexLeft] == map[indexLeft - 1] ||
        rect.right < width && map[indexRight] == map[indexRight + 1]) { return true }
    indexLeft += width; indexRight += width;
  }
  for (var i$1 = rect.left; i$1 < rect.right; i$1++) {
    if (rect.top > 0 && map[indexTop] == map[indexTop - width] ||
        rect.bottom < height && map[indexBottom] == map[indexBottom + width]) { return true }
    indexTop++; indexBottom++;
  }
  return false
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Merge the selected cells into a single cell. Only available when
// the selected cells' outline forms a rectangle.
function mergeCells(state, dispatch) {
  var sel = state.selection;
  if (!(sel instanceof CellSelection) || sel.$anchorCell.pos == sel.$headCell.pos) { return false }
  var rect = selectedRect(state);
  var map = rect.map;
  if (cellsOverlapRectangle(map, rect)) { return false }
  if (dispatch) {
    var tr = state.tr, seen = [], content = prosemirrorModel.Fragment.empty, mergedPos, mergedCell;
    for (var row = rect.top; row < rect.bottom; row++) {
      for (var col = rect.left; col < rect.right; col++) {
        var cellPos = map.map[row * map.width + col], cell = rect.table.nodeAt(cellPos);
        if (seen.indexOf(cellPos) > -1) { continue }
        seen.push(cellPos);
        if (mergedPos == null) {
          mergedPos = cellPos;
          mergedCell = cell;
        } else {
          if (!isEmpty(cell)) { content = content.append(cell.content); }
          var mapped = tr.mapping.map(cellPos + rect.tableStart);
          tr.delete(mapped, mapped + cell.nodeSize);
        }
      }
    }
    tr.setNodeMarkup(mergedPos + rect.tableStart, null,
                     setAttr(addColSpan(mergedCell.attrs, mergedCell.attrs.colspan, (rect.right - rect.left) - mergedCell.attrs.colspan),
                             "rowspan", rect.bottom - rect.top));
    if (content.size) {
      var end = mergedPos + 1 + mergedCell.content.size;
      var start = isEmpty(mergedCell) ? mergedPos + 1 : end;
      tr.replaceWith(start + rect.tableStart, end + rect.tableStart, content);
    }
    tr.setSelection(new CellSelection(tr.doc.resolve(mergedPos + rect.tableStart)));
    dispatch(tr);
  }
  return true
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Split a selected cell, whose rowpan or colspan is greater than one,
// into smaller cells.
function splitCell(state, dispatch) {
  var sel = state.selection;
  var cellNode, cellPos;
  if (!(sel instanceof CellSelection)) {
    cellNode = cellWrapping(sel.$from);
    if (!cellNode) { return false }
    cellPos = cellAround(sel.$from).pos;
  } else {
    if (sel.$anchorCell.pos != sel.$headCell.pos) { return false }
    cellNode = sel.$anchorCell.nodeAfter;
    cellPos = sel.$anchorCell.pos;
  }
  if (cellNode.attrs.colspan == 1 && cellNode.attrs.rowspan == 1) {return false}
  if (dispatch) {
    var baseAttrs = cellNode.attrs, attrs = [], colwidth = baseAttrs.colwidth;
    if (baseAttrs.rowspan > 1) { baseAttrs = setAttr(baseAttrs, "rowspan", 1); }
    if (baseAttrs.colspan > 1) { baseAttrs = setAttr(baseAttrs, "colspan", 1); }
    var rect = selectedRect(state), tr = state.tr;
    for (var i = 0; i < rect.right - rect.left; i++)
      { attrs.push(colwidth ? setAttr(baseAttrs, "colwidth", colwidth && colwidth[i] ? [colwidth[i]] : null) : baseAttrs); }
    var lastCell, cellType = tableNodeTypes(state.schema)[cellNode.type.spec.tableRole];
    for (var row = 0; row < rect.bottom; row++) {
      if (row >= rect.top) {
        var pos = rect.map.positionAt(row, rect.left, rect.table);
        if (row == rect.top) { pos += cellNode.nodeSize; }
        for (var col = rect.left, i$1 = 0; col < rect.right; col++, i$1++) {
          if (col == rect.left && row == rect.top) { continue }
          tr.insert(lastCell = tr.mapping.map(pos + rect.tableStart, 1), cellType.createAndFill(attrs[i$1]));
        }
      }
    }
    tr.setNodeMarkup(cellPos, null, attrs[0]);
    if (sel instanceof CellSelection)
      { tr.setSelection(new CellSelection(tr.doc.resolve(sel.$anchorCell.pos),
                                        lastCell && tr.doc.resolve(lastCell))); }
    dispatch(tr);
  }
  return true
}

// :: (string, any) → (EditorState, dispatch: ?(tr: Transaction)) → bool
// Returns a command that sets the given attribute to the given value,
// and is only available when the currently selected cell doesn't
// already have that attribute set to that value.
function setCellAttr(name, value) {
  return function(state, dispatch) {
    if (!isInTable(state)) { return false }
    var $cell = selectionCell(state);
    if ($cell.nodeAfter.attrs[name] === value) { return false }
    if (dispatch) {
      var tr = state.tr;
      if (state.selection instanceof CellSelection)
        { state.selection.forEachCell(function (node, pos) {
          if (node.attrs[name] !== value)
            { tr.setNodeMarkup(pos, null, setAttr(node.attrs, name, value)); }
        }); }
      else
        { tr.setNodeMarkup($cell.pos, null, setAttr($cell.nodeAfter.attrs, name, value)); }
      dispatch(tr);
    }
    return true
  }
}

function toggleHeader(type) {
  return function(state, dispatch) {
    if (!isInTable(state)) { return false }
    if (dispatch) {
      var types = tableNodeTypes(state.schema);
      var rect = selectedRect(state), tr = state.tr;
      var cells = rect.map.cellsInRect(type == "column" ? new Rect(rect.left, 0, rect.right, rect.map.height) :
                                       type == "row" ? new Rect(0, rect.top, rect.map.width, rect.bottom) : rect);
      var nodes = cells.map(function (pos) { return rect.table.nodeAt(pos); });
      for (var i = 0; i < cells.length; i++) // Remove headers, if any
        { if (nodes[i].type == types.header_cell)
          { tr.setNodeMarkup(rect.tableStart + cells[i], types.cell, nodes[i].attrs); } }
      if (tr.steps.length == 0) { for (var i$1 = 0; i$1 < cells.length; i$1++) // No headers removed, add instead
        { tr.setNodeMarkup(rect.tableStart + cells[i$1], types.header_cell, nodes[i$1].attrs); } }
      dispatch(tr);
    }
    return true
  }
}

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Toggles whether the selected row contains header cells.
var toggleHeaderRow = toggleHeader("row");

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Toggles whether the selected column contains header cells.
var toggleHeaderColumn = toggleHeader("column");

// :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Toggles whether the selected cells are header cells.
var toggleHeaderCell = toggleHeader("cell");

function findNextCell($cell, dir) {
  if (dir < 0) {
    var before = $cell.nodeBefore;
    if (before) { return $cell.pos - before.nodeSize }
    for (var row = $cell.index(-1) - 1, rowEnd = $cell.before(); row >= 0; row--) {
      var rowNode = $cell.node(-1).child(row);
      if (rowNode.childCount) { return rowEnd - 1 - rowNode.lastChild.nodeSize }
      rowEnd -= rowNode.nodeSize;
    }
  } else {
    if ($cell.index() < $cell.parent.childCount - 1) { return $cell.pos + $cell.nodeAfter.nodeSize }
    var table = $cell.node(-1);
    for (var row$1 = $cell.indexAfter(-1), rowStart = $cell.after(); row$1 < table.childCount; row$1++) {
      var rowNode$1 = table.child(row$1);
      if (rowNode$1.childCount) { return rowStart + 1 }
      rowStart += rowNode$1.nodeSize;
    }
  }
}

// :: (number) → (EditorState, dispatch: ?(tr: Transaction)) → bool
// Returns a command for selecting the next (direction=1) or previous
// (direction=-1) cell in a table.
function goToNextCell(direction) {
  return function(state, dispatch) {
    if (!isInTable(state)) { return false }
    var cell = findNextCell(selectionCell(state), direction);
    if (cell == null) { return }
    if (dispatch) {
      var $cell = state.doc.resolve(cell);
      dispatch(state.tr.setSelection(prosemirrorState.TextSelection.between($cell, moveCellForward($cell))).scrollIntoView());
    }
    return true
  }
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Deletes the table around the selection, if any.
function deleteTable(state, dispatch) {
  var $pos = state.selection.$anchor;
  for (var d = $pos.depth; d > 0; d--) {
    var node = $pos.node(d);
    if (node.type.spec.tableRole == "table") {
      if (dispatch) { dispatch(state.tr.delete($pos.before(d), $pos.after(d)).scrollIntoView()); }
      return true
    }
  }
  return false
}

var TableView = function TableView(node, cellMinWidth) {
  this.node = node;
  this.cellMinWidth = cellMinWidth;
  this.dom = document.createElement("div");
  this.dom.className = "tableWrapper";
  this.table = this.dom.appendChild(document.createElement("table"));
  this.colgroup = this.table.appendChild(document.createElement("colgroup"));
  updateColumns(node, this.colgroup, this.table, cellMinWidth);
  this.contentDOM = this.table.appendChild(document.createElement("tbody"));
};

TableView.prototype.update = function update (node) {
  if (node.type != this.node.type) { return false }
  this.node = node;
  updateColumns(node, this.colgroup, this.table, this.cellMinWidth);
  return true
};

TableView.prototype.ignoreMutation = function ignoreMutation (record) {
  return record.type == "attributes" && (record.target == this.table || this.colgroup.contains(record.target))
};

function updateColumns(node, colgroup, table, cellMinWidth, overrideCol, overrideValue) {
  var totalWidth = 0, fixedWidth = true;
  var nextDOM = colgroup.firstChild, row = node.firstChild;
  for (var i = 0, col = 0; i < row.childCount; i++) {
    var ref = row.child(i).attrs;
    var colspan = ref.colspan;
    var colwidth = ref.colwidth;
    for (var j = 0; j < colspan; j++, col++) {
      var hasWidth = overrideCol == col ? overrideValue : colwidth && colwidth[j];
      var cssWidth = hasWidth ? hasWidth + "px" : "";
      totalWidth += hasWidth || cellMinWidth;
      if (!hasWidth) { fixedWidth = false; }
      if (!nextDOM) {
        colgroup.appendChild(document.createElement("col")).style.width = cssWidth;
      } else {
        if (nextDOM.style.width != cssWidth) { nextDOM.style.width = cssWidth; }
        nextDOM = nextDOM.nextSibling;
      }
    }
  }

  while (nextDOM) {
    var after = nextDOM.nextSibling;
    nextDOM.parentNode.removeChild(nextDOM);
    nextDOM = after;
  }

  if (fixedWidth) {
    table.style.width = totalWidth + "px";
    table.style.minWidth = "";
  } else {
    table.style.width = "";
    table.style.minWidth = totalWidth + "px";
  }
}

var key$1 = new prosemirrorState.PluginKey("tableColumnResizing");

function columnResizing(ref) {
  if ( ref === void 0 ) ref = {};
  var handleWidth = ref.handleWidth; if ( handleWidth === void 0 ) handleWidth = 5;
  var cellMinWidth = ref.cellMinWidth; if ( cellMinWidth === void 0 ) cellMinWidth = 25;
  var View = ref.View; if ( View === void 0 ) View = TableView;
  var lastColumnResizable = ref.lastColumnResizable; if ( lastColumnResizable === void 0 ) lastColumnResizable = true;

  var plugin = new prosemirrorState.Plugin({
    key: key$1,
    state: {
      init: function init(_, state) {
        this.spec.props.nodeViews[tableNodeTypes(state.schema).table.name] =
          function (node, view) { return new View(node, cellMinWidth, view); };
        return new ResizeState(-1, false)
      },
      apply: function apply(tr, prev) {
        return prev.apply(tr)
      }
    },
    props: {
      attributes: function attributes(state) {
        var pluginState = key$1.getState(state);
        return pluginState.activeHandle > -1 ? {class: "resize-cursor"} : null
      },

      handleDOMEvents: {
        mousemove: function mousemove(view, event) { handleMouseMove(view, event, handleWidth, cellMinWidth, lastColumnResizable); },
        mouseleave: function mouseleave(view) { handleMouseLeave(view); },
        mousedown: function mousedown(view, event) { handleMouseDown$1(view, event, cellMinWidth); }
      },

      decorations: function decorations(state) {
        var pluginState = key$1.getState(state);
        if (pluginState.activeHandle > -1) { return handleDecorations(state, pluginState.activeHandle) }
      },

      nodeViews: {}
    }
  });
  return plugin
}

var ResizeState = function ResizeState(activeHandle, dragging) {
  this.activeHandle = activeHandle;
  this.dragging = dragging;
};

ResizeState.prototype.apply = function apply (tr) {
  var state = this, action = tr.getMeta(key$1);
  if (action && action.setHandle != null)
    { return new ResizeState(action.setHandle, null) }
  if (action && action.setDragging !== undefined)
    { return new ResizeState(state.activeHandle, action.setDragging) }
  if (state.activeHandle > -1 && tr.docChanged) {
    var handle = tr.mapping.map(state.activeHandle, -1);
    if (!pointsAtCell(tr.doc.resolve(handle))) { handle = null; }
    state = new ResizeState(handle, state.dragging);
  }
  return state
};

function handleMouseMove(view, event, handleWidth, cellMinWidth, lastColumnResizable) {
  var pluginState = key$1.getState(view.state);

  if (!pluginState.dragging) {
    var target = domCellAround(event.target), cell = -1;
    if (target) {
      var ref = target.getBoundingClientRect();
      var left = ref.left;
      var right = ref.right;
      if (event.clientX - left <= handleWidth)
        { cell = edgeCell(view, event, "left"); }
      else if (right - event.clientX <= handleWidth)
        { cell = edgeCell(view, event, "right"); }
    }

    if (cell != pluginState.activeHandle) {
      if (!lastColumnResizable && cell !== -1) {
        var $cell = view.state.doc.resolve(cell);
        var table = $cell.node(-1), map = TableMap.get(table), start = $cell.start(-1);
        var col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;

        if (col == map.width - 1) {
          return
        }
      }

      updateHandle(view, cell);
    }
  }
}

function handleMouseLeave(view) {
  var pluginState = key$1.getState(view.state);
  if (pluginState.activeHandle > -1 && !pluginState.dragging) { updateHandle(view, -1); }
}

function handleMouseDown$1(view, event, cellMinWidth) {
  var pluginState = key$1.getState(view.state);
  if (pluginState.activeHandle == -1 || pluginState.dragging) { return false }

  var cell = view.state.doc.nodeAt(pluginState.activeHandle);
  var width = currentColWidth(view, pluginState.activeHandle, cell.attrs);
  view.dispatch(view.state.tr.setMeta(key$1, {setDragging: {startX: event.clientX, startWidth: width}}));

  function finish(event) {
    window.removeEventListener("mouseup", finish);
    window.removeEventListener("mousemove", move);
    var pluginState = key$1.getState(view.state);
    if (pluginState.dragging) {
      updateColumnWidth(view, pluginState.activeHandle, draggedWidth(pluginState.dragging, event, cellMinWidth));
      view.dispatch(view.state.tr.setMeta(key$1, {setDragging: null}));
    }
  }
  function move(event) {
    if (!event.which) { return finish(event) }
    var pluginState = key$1.getState(view.state);
    var dragged = draggedWidth(pluginState.dragging, event, cellMinWidth);
    displayColumnWidth(view, pluginState.activeHandle, dragged, cellMinWidth);
  }

  window.addEventListener("mouseup", finish);
  window.addEventListener("mousemove", move);
  event.preventDefault();
  return true
}

function currentColWidth(view, cellPos, ref) {
  var colspan = ref.colspan;
  var colwidth = ref.colwidth;

  var width = colwidth && colwidth[colwidth.length - 1];
  if (width) { return width }
  var dom = view.domAtPos(cellPos);
  var node = dom.node.childNodes[dom.offset];
  var domWidth = node.offsetWidth, parts = colspan;
  if (colwidth) { for (var i = 0; i < colspan; i++) { if (colwidth[i]) {
    domWidth -= colwidth[i];
    parts--;
  } } }
  return domWidth / parts
}

function domCellAround(target) {
  while (target && target.nodeName != "TD" && target.nodeName != "TH")
    { target = target.classList.contains("ProseMirror") ? null : target.parentNode; }
  return target
}

function edgeCell(view, event, side) {
  var ref = view.posAtCoords({left: event.clientX, top: event.clientY});
  var pos = ref.pos;
  var $cell = cellAround(view.state.doc.resolve(pos));
  if (!$cell) { return -1 }
  if (side == "right") { return $cell.pos }
  var map = TableMap.get($cell.node(-1)), start = $cell.start(-1);
  var index = map.map.indexOf($cell.pos - start);
  return index % map.width == 0 ? -1 : start + map.map[index - 1]
}

function draggedWidth(dragging, event, cellMinWidth) {
  var offset = event.clientX - dragging.startX;
  return Math.max(cellMinWidth, dragging.startWidth + offset)
}

function updateHandle(view, value) {
  view.dispatch(view.state.tr.setMeta(key$1, {setHandle: value}));
}

function updateColumnWidth(view, cell, width) {
  var $cell = view.state.doc.resolve(cell);
  var table = $cell.node(-1), map = TableMap.get(table), start = $cell.start(-1);
  var col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
  var tr = view.state.tr;
  for (var row = 0; row < map.height; row++) {
    var mapIndex = row * map.width + col;
    // Rowspanning cell that has already been handled
    if (row && map.map[mapIndex] == map.map[mapIndex - map.width]) { continue }
    var pos = map.map[mapIndex];
    var ref = table.nodeAt(pos);
    var attrs = ref.attrs;
    var index = attrs.colspan == 1 ? 0 : col - map.colCount(pos);
    if (attrs.colwidth && attrs.colwidth[index] == width) { continue }
    var colwidth = attrs.colwidth ? attrs.colwidth.slice() : zeroes(attrs.colspan);
    colwidth[index] = width;
    tr.setNodeMarkup(start + pos, null, setAttr(attrs, "colwidth", colwidth));
  }
  if (tr.docChanged) { view.dispatch(tr); }
}

function displayColumnWidth(view, cell, width, cellMinWidth) {
  var $cell = view.state.doc.resolve(cell);
  var table = $cell.node(-1), start = $cell.start(-1);
  var col = TableMap.get(table).colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
  var dom = view.domAtPos($cell.start(-1)).node;
  while (dom.nodeName != "TABLE") { dom = dom.parentNode; }
  updateColumns(table, dom.firstChild, dom, cellMinWidth, col, width);
}

function zeroes(n) {
  var result = [];
  for (var i = 0; i < n; i++) { result.push(0); }
  return result
}

function handleDecorations(state, cell) {
  var decorations = [];
  var $cell = state.doc.resolve(cell);
  var table = $cell.node(-1), map = TableMap.get(table), start = $cell.start(-1);
  var col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan;
  for (var row = 0; row < map.height; row++) {
    var index = col + row * map.width - 1;
    // For positions that are have either a different cell or the end
    // of the table to their right, and either the top of the table or
    // a different cell above them, add a decoration
    if ((col == map.width || map.map[index] != map.map[index + 1]) &&
        (row == 0 || map.map[index - 1] != map.map[index - 1 - map.width])) {
      var cellPos = map.map[index];
      var pos = start + cellPos + table.nodeAt(cellPos).nodeSize - 1;
      var dom = document.createElement("div");
      dom.className = "column-resize-handle";
      decorations.push(prosemirrorView.Decoration.widget(pos, dom));
    }
  }
  return prosemirrorView.DecorationSet.create(state.doc, decorations)
}

// This file defines a plugin that handles the drawing of cell

// :: () → Plugin
//
// Creates a [plugin](http://prosemirror.net/docs/ref/#state.Plugin)
// that, when added to an editor, enables cell-selection, handles
// cell-based copy/paste, and makes sure tables stay well-formed (each
// row has the same width, and cells don't overlap).
//
// You should probably put this plugin near the end of your array of
// plugins, since it handles mouse and arrow key events in tables
// rather broadly, and other plugins, like the gap cursor or the
// column-width dragging plugin, might want to get a turn first to
// perform more specific behavior.
function tableEditing() {
  return new prosemirrorState.Plugin({
    key: key,

    // This piece of state is used to remember when a mouse-drag
    // cell-selection is happening, so that it can continue even as
    // transactions (which might move its anchor cell) come in.
    state: {
      init: function init() { return null },
      apply: function apply(tr, cur) {
        var set = tr.getMeta(key);
        if (set != null) { return set == -1 ? null : set }
        if (cur == null || !tr.docChanged) { return cur }
        var ref = tr.mapping.mapResult(cur);
        var deleted = ref.deleted;
        var pos = ref.pos;
        return deleted ? null : pos
      }
    },

    props: {
      decorations: drawCellSelection,

      handleDOMEvents: {
        mousedown: handleMouseDown
      },

      createSelectionBetween: function createSelectionBetween(view) {
        if (key.getState(view.state) != null) { return view.state.selection }
      },

      handleTripleClick: handleTripleClick,

      handleKeyDown: handleKeyDown,

      handlePaste: handlePaste
    },

    appendTransaction: function appendTransaction(_, oldState, state) {
      return normalizeSelection(state, fixTables(state, oldState))
    }
  })
}

exports.tableEditing = tableEditing;
exports.fixTables = fixTables;
exports.handlePaste = handlePaste;
exports.cellAround = cellAround;
exports.isInTable = isInTable;
exports.selectionCell = selectionCell;
exports.moveCellForward = moveCellForward;
exports.inSameTable = inSameTable;
exports.findCell = findCell;
exports.colCount = colCount;
exports.nextCell = nextCell;
exports.tableNodes = tableNodes;
exports.CellSelection = CellSelection;
exports.TableMap = TableMap;
exports.columnResizing = columnResizing;
exports.columnResizingPluginKey = key$1;
exports.updateColumnsOnResize = updateColumns;
exports.__pastedCells = pastedCells;
exports.__insertCells = insertCells;
exports.__clipCells = clipCells;
exports.addColumn = addColumn;
exports.addColumnBefore = addColumnBefore;
exports.addColumnAfter = addColumnAfter;
exports.removeColumn = removeColumn;
exports.deleteColumn = deleteColumn;
exports.addRow = addRow;
exports.addRowBefore = addRowBefore;
exports.addRowAfter = addRowAfter;
exports.removeRow = removeRow;
exports.deleteRow = deleteRow;
exports.mergeCells = mergeCells;
exports.splitCell = splitCell;
exports.setCellAttr = setCellAttr;
exports.toggleHeaderRow = toggleHeaderRow;
exports.toggleHeaderColumn = toggleHeaderColumn;
exports.toggleHeaderCell = toggleHeaderCell;
exports.goToNextCell = goToNextCell;
exports.deleteTable = deleteTable;
//# sourceMappingURL=index.js.map


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearHoverSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return hoverColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return hoverRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return hoverTable; });
/* unused harmony export clearSelection */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return toggleHeaderRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return toggleHeaderColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return toggleNumberColumn; });
/* unused harmony export setCellAttr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return insertColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return insertRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return triggerUnlessTableHeader; });
/* harmony export (immutable) */ __webpack_exports__["E"] = transformSliceToAddTableHeaders;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return deleteTable; });
/* unused harmony export convertFirstRowToHeader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deleteSelectedColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return deleteSelectedRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return toggleTableLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return goToNextCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return moveCursorBackward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return deleteColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deleteRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return emptyMultipleCells; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return setMultipleCellAttrs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return toggleContextualMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return setEditorFocus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return setTableRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return selectColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return selectRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return showInsertColumnButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return showInsertRowButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return hideInsertColumnOrRowButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return handleCut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return handleShiftSelection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lists_commands__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_slice__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(21);











var clearHoverSelection = function (state, dispatch) {
    if (dispatch) {
        dispatch(state.tr.setMeta(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["e" /* pluginKey */], { action: __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["a" /* ACTIONS */].CLEAR_HOVER_SELECTION }));
    }
    return true;
};
var hoverColumns = function (columns, isInDanger) { return function (state, dispatch) {
    var hoveredColumns = columns.reduce(function (acc, index) {
        var indexes = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["getSelectionRangeInColumn"])(index)(state.tr).indexes;
        return acc.concat(indexes.filter(function (index) { return acc.indexOf(index) === -1; }));
    }, []);
    var cells = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["getCellsInColumn"])(hoveredColumns)(state.selection);
    if (!cells) {
        return false;
    }
    if (dispatch) {
        dispatch(state.tr
            .setMeta(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["e" /* pluginKey */], {
            action: __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["a" /* ACTIONS */].HOVER_COLUMNS,
            data: {
                hoverDecoration: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["e" /* createControlsHoverDecoration */])(cells, isInDanger),
                hoveredColumns: hoveredColumns,
                isInDanger: isInDanger,
            },
        })
            .setMeta('addToHistory', false));
    }
    return true;
}; };
var hoverRows = function (rows, isInDanger) { return function (state, dispatch) {
    var hoveredRows = rows.reduce(function (acc, index) {
        var indexes = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["getSelectionRangeInRow"])(index)(state.tr).indexes;
        return acc.concat(indexes.filter(function (index) { return acc.indexOf(index) === -1; }));
    }, []);
    var cells = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["getCellsInRow"])(hoveredRows)(state.selection);
    if (!cells) {
        return false;
    }
    if (dispatch) {
        dispatch(state.tr
            .setMeta(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["e" /* pluginKey */], {
            action: __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["a" /* ACTIONS */].HOVER_ROWS,
            data: {
                hoverDecoration: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["e" /* createControlsHoverDecoration */])(cells, isInDanger),
                hoveredRows: hoveredRows,
                isInDanger: isInDanger,
            },
        })
            .setMeta('addToHistory', false));
    }
    return true;
}; };
var hoverTable = function (isInDanger) { return function (state, dispatch) {
    var table = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findTable"])(state.selection);
    if (!table) {
        return false;
    }
    var map = __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["TableMap"].get(table.node);
    var hoveredColumns = Array.from(Array(map.width).keys());
    var hoveredRows = Array.from(Array(map.height).keys());
    var cells = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["getCellsInRow"])(hoveredRows)(state.selection);
    if (!cells) {
        return false;
    }
    if (dispatch) {
        dispatch(state.tr
            .setMeta(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["e" /* pluginKey */], {
            action: __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["a" /* ACTIONS */].HOVER_TABLE,
            data: {
                hoverDecoration: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["e" /* createControlsHoverDecoration */])(cells, isInDanger),
                hoveredColumns: hoveredColumns,
                hoveredRows: hoveredRows,
                isInDanger: isInDanger,
            },
        })
            .setMeta('addToHistory', false));
    }
    return true;
}; };
var clearSelection = function (state, dispatch) {
    if (dispatch) {
        dispatch(state.tr
            .setSelection(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Selection"].near(state.selection.$from))
            .setMeta('addToHistory', false));
    }
    return true;
};
var toggleHeaderRow = function (state, dispatch) {
    var table = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findTable"])(state.selection);
    if (!table) {
        return false;
    }
    var tr = state.tr;
    var map = __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["TableMap"].get(table.node);
    var _a = state.schema.nodes, tableHeader = _a.tableHeader, tableCell = _a.tableCell;
    var isHeaderRowEnabled = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* checkIfHeaderRowEnabled */])(state);
    var isHeaderColumnEnabled = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* checkIfHeaderColumnEnabled */])(state);
    var type = isHeaderRowEnabled ? tableCell : tableHeader;
    for (var column = 0; column < table.node.child(0).childCount; column++) {
        // skip header column
        if (isHeaderColumnEnabled && column === 0) {
            continue;
        }
        var from = tr.mapping.map(table.start + map.map[column]);
        var cell = table.node.child(0).child(column);
        tr.setNodeMarkup(from, type, cell.attrs);
    }
    if (dispatch) {
        dispatch(tr);
    }
    return true;
};
var toggleHeaderColumn = function (state, dispatch) {
    var table = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findTable"])(state.selection);
    if (!table) {
        return false;
    }
    var tr = state.tr;
    var map = __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["TableMap"].get(table.node);
    var _a = state.schema.nodes, tableHeader = _a.tableHeader, tableCell = _a.tableCell;
    var type = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* checkIfHeaderColumnEnabled */])(state) ? tableCell : tableHeader;
    // skip header row
    var startIndex = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* checkIfHeaderRowEnabled */])(state) ? 1 : 0;
    for (var row = startIndex; row < table.node.childCount; row++) {
        var column = 0;
        var cell = table.node.child(row).child(column);
        tr.setNodeMarkup(table.start + map.map[column + row * map.width], type, cell.attrs);
    }
    if (dispatch) {
        dispatch(tr);
    }
    return true;
};
var toggleNumberColumn = function (state, dispatch) {
    var tr = state.tr;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findTable"])(state.selection), node = _a.node, pos = _a.pos;
    tr.setNodeMarkup(pos, state.schema.nodes.table, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, node.attrs, { isNumberColumnEnabled: !node.attrs.isNumberColumnEnabled }));
    if (dispatch) {
        dispatch(tr);
    }
    return true;
};
var setCellAttr = function (name, value) { return function (state, dispatch) {
    var _a;
    var tr = state.tr, selection = state.selection;
    if (selection instanceof __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["CellSelection"]) {
        var updated_1 = false;
        selection.forEachCell(function (cell, pos) {
            var _a;
            if (cell.attrs[name] !== value) {
                tr.setNodeMarkup(pos, cell.type, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, cell.attrs, (_a = {}, _a[name] = value, _a)));
                updated_1 = true;
            }
        });
        if (updated_1) {
            if (dispatch) {
                dispatch(tr);
            }
            return true;
        }
    }
    else {
        var cell = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["selectionCell"])(state);
        if (cell) {
            if (dispatch) {
                dispatch(tr.setNodeMarkup(cell.pos, cell.nodeAfter.type, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, cell.nodeAfter.attrs, (_a = {}, _a[name] = value, _a))));
            }
            return true;
        }
    }
    return false;
}; };
var insertColumn = function (column) { return function (state, dispatch) {
    var tr = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["addColumnAt"])(column)(state.tr);
    var table = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findTable"])(tr.selection);
    // move the cursor to the newly created column
    var pos = __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["TableMap"].get(table.node).positionAt(0, column, table.node);
    if (dispatch) {
        dispatch(tr.setSelection(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Selection"].near(tr.doc.resolve(table.start + pos))));
    }
    __WEBPACK_IMPORTED_MODULE_6__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.format.table.column.button');
    return true;
}; };
var insertRow = function (row) { return function (state, dispatch) {
    clearHoverSelection(state, dispatch);
    // Dont clone the header row
    var headerRowEnabled = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* checkIfHeaderRowEnabled */])(state);
    var clonePreviousRow = (headerRowEnabled && row > 1) || (!headerRowEnabled && row >= 0);
    var tr = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["addRowAt"])(row, clonePreviousRow)(state.tr);
    var table = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findTable"])(tr.selection);
    // move the cursor to the newly created row
    var pos = __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["TableMap"].get(table.node).positionAt(row, 0, table.node);
    if (dispatch) {
        dispatch(tr.setSelection(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Selection"].near(tr.doc.resolve(table.start + pos))));
    }
    __WEBPACK_IMPORTED_MODULE_6__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.format.table.row.button');
    return true;
}; };
var triggerUnlessTableHeader = function (command) { return function (state, dispatch) {
    var selection = state.selection, tableHeader = state.schema.nodes.tableHeader;
    if (selection instanceof __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["TextSelection"]) {
        var cell = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findCellClosestToPos"])(selection.$from);
        if (cell && cell.node.type !== tableHeader) {
            return command(state, dispatch);
        }
    }
    if (selection instanceof __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["CellSelection"]) {
        var rect = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["getSelectionRect"])(selection);
        if (!Object(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* checkIfHeaderRowEnabled */])(state) || (rect && rect.top > 0)) {
            return command(state, dispatch);
        }
    }
    return false;
}; };
function transformSliceToAddTableHeaders(slice, schema) {
    var _a = schema.nodes, table = _a.table, tableHeader = _a.tableHeader, tableRow = _a.tableRow;
    return Object(__WEBPACK_IMPORTED_MODULE_8__utils_slice__["e" /* mapSlice */])(slice, function (maybeTable) {
        if (maybeTable.type === table) {
            var firstRow = maybeTable.firstChild;
            if (firstRow) {
                var headerCols_1 = [];
                firstRow.forEach(function (oldCol) {
                    headerCols_1.push(tableHeader.createChecked(oldCol.attrs, oldCol.content, oldCol.marks));
                });
                var headerRow = tableRow.createChecked(firstRow.attrs, headerCols_1, firstRow.marks);
                return maybeTable.copy(maybeTable.content.replaceChild(0, headerRow));
            }
        }
        return maybeTable;
    });
}
var deleteTable = function (state, dispatch) {
    if (dispatch) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["removeTable"])(state.tr));
    }
    __WEBPACK_IMPORTED_MODULE_6__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.format.table.delete.button');
    return true;
};
var convertFirstRowToHeader = function (schema) { return function (tr) {
    var table = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findTable"])(tr.selection);
    var map = __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["TableMap"].get(table.node);
    for (var i = 0; i < map.width; i++) {
        var cell = table.node.child(0).child(i);
        tr.setNodeMarkup(table.start + map.map[i], schema.nodes.tableHeader, cell.attrs);
    }
    return tr;
}; };
var deleteSelectedColumns = function (state, dispatch) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["isCellSelection"])(state.selection)) {
        return false;
    }
    var tr = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["removeSelectedColumns"])(state.tr);
    // sometimes cursor jumps out of the table when deleting last few columns
    if (!Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["hasParentNodeOfType"])(state.schema.nodes.table)(tr.selection)) {
        // trying to put cursor back inside of the table
        var start = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findTable"])(state.tr.selection).start;
        tr = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["setTextSelection"])(start)(tr);
    }
    var table = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findTable"])(tr.selection);
    var map = __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["TableMap"].get(table.node);
    var rect = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["getSelectionRect"])(tr.selection);
    var columnIndex = rect
        ? Math.min(rect.left, rect.right) - 1
        : map.width - 1;
    var pos = map.positionAt(0, columnIndex < 0 ? 0 : columnIndex, table.node);
    // move cursor to the column to the left of the deleted column
    if (dispatch) {
        dispatch(tr.setSelection(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Selection"].near(tr.doc.resolve(table.start + pos))));
    }
    __WEBPACK_IMPORTED_MODULE_6__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.format.table.delete_column.button');
    return true;
};
var deleteSelectedRows = function (state, dispatch) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["isCellSelection"])(state.selection)) {
        return false;
    }
    var tableHeader = state.schema.nodes.tableHeader;
    var tr = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["removeSelectedRows"])(state.tr);
    // sometimes cursor jumps out of the table when deleting last few columns
    if (!Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["hasParentNodeOfType"])(state.schema.nodes.table)(tr.selection)) {
        // trying to put cursor back inside of the table
        var start = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findTable"])(state.tr.selection).start;
        tr = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["setTextSelection"])(start)(tr);
    }
    var table = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findTable"])(tr.selection);
    var map = __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["TableMap"].get(table.node);
    var rect = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["getSelectionRect"])(state.selection);
    var rowIndex = rect ? Math.min(rect.top, rect.bottom) : 0;
    var pos = map.positionAt(rowIndex === map.height ? rowIndex - 1 : rowIndex, 0, table.node);
    // move cursor to the beginning of the next row, or prev row if deleted row was the last row
    tr.setSelection(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Selection"].near(tr.doc.resolve(table.start + pos)));
    // make sure header row is always present (for Bitbucket markdown)
    var isHeaderRowRequired = Object(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["d" /* getPluginState */])(state).pluginConfig.isHeaderRowRequired;
    if (isHeaderRowRequired && Object(__WEBPACK_IMPORTED_MODULE_5__utils__["u" /* isHeaderRowSelected */])(state)) {
        tr = convertFirstRowToHeader(state.schema)(tr);
    }
    if (dispatch) {
        dispatch(tr);
    }
    var headerRow = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["hasParentNodeOfType"])(tableHeader)(tr.selection)
        ? 'header_'
        : '';
    __WEBPACK_IMPORTED_MODULE_6__analytics__["a" /* analyticsService */].trackEvent("atlassian.editor.format.table.delete_" + headerRow + "row.button");
    return true;
};
var toggleTableLayout = function (state, dispatch) {
    var table = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findTable"])(state.selection);
    if (!table) {
        return false;
    }
    var layout;
    switch (table.node.attrs.layout) {
        case 'default':
            layout = 'wide';
            break;
        case 'wide':
            layout = 'full-width';
            break;
        case 'full-width':
            layout = 'default';
            break;
    }
    if (dispatch) {
        dispatch(state.tr.setNodeMarkup(table.pos, state.schema.nodes.table, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, table.node.attrs, { layout: layout })));
    }
    return true;
};
var TAB_FORWARD_DIRECTION = 1;
var TAB_BACKWARD_DIRECTION = -1;
var createTable = function (state, dispatch) {
    if (!__WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["e" /* pluginKey */].get(state)) {
        return false;
    }
    var table = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["createTable"])(state.schema);
    if (dispatch) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["safeInsert"])(table)(state.tr).scrollIntoView());
    }
    return true;
};
var goToNextCell = function (direction) { return function (state, dispatch) {
    var table = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findTable"])(state.selection);
    if (!table) {
        return false;
    }
    var map = __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["TableMap"].get(table.node);
    var _a = state.schema.nodes, tableCell = _a.tableCell, tableHeader = _a.tableHeader;
    var cell = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findParentNodeOfType"])([tableCell, tableHeader])(state.selection);
    var firstCellPos = map.positionAt(0, 0, table.node) + table.start;
    var lastCellPos = map.positionAt(map.height - 1, map.width - 1, table.node) + table.start;
    var event = direction === TAB_FORWARD_DIRECTION ? 'next_cell' : 'previous_cell';
    __WEBPACK_IMPORTED_MODULE_6__analytics__["a" /* analyticsService */].trackEvent("atlassian.editor.format.table." + event + ".keyboard");
    if (firstCellPos === cell.pos && direction === TAB_BACKWARD_DIRECTION) {
        insertRow(0)(state, dispatch);
        return true;
    }
    if (lastCellPos === cell.pos && direction === TAB_FORWARD_DIRECTION) {
        insertRow(map.height)(state, dispatch);
        return true;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["goToNextCell"])(direction)(state, dispatch);
}; };
var moveCursorBackward = function (state, dispatch) {
    var pluginState = Object(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["d" /* getPluginState */])(state);
    var $cursor = state.selection.$cursor;
    // if cursor is in the middle of a text node, do nothing
    if (!$cursor ||
        (pluginState.view
            ? !pluginState.view.endOfTextblock('backward', state)
            : $cursor.parentOffset > 0)) {
        return false;
    }
    // find the node before the cursor
    var before;
    var cut;
    if (!Object(__WEBPACK_IMPORTED_MODULE_5__utils__["x" /* isIsolating */])($cursor.parent)) {
        for (var i = $cursor.depth - 1; !before && i >= 0; i--) {
            if ($cursor.index(i) > 0) {
                cut = $cursor.before(i + 1);
                before = $cursor.node(i).child($cursor.index(i) - 1);
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_5__utils__["x" /* isIsolating */])($cursor.node(i))) {
                break;
            }
        }
    }
    // if the node before is not a table node - do nothing
    if (!before || before.type !== state.schema.nodes.table) {
        return false;
    }
    /*
      ensure we're just at a top level paragraph
      otherwise, perform regular backspace behaviour
     */
    var grandparent = $cursor.node($cursor.depth - 1);
    var listItem = state.schema.nodes.listItem;
    if ($cursor.parent.type !== state.schema.nodes.paragraph ||
        (grandparent && grandparent.type !== state.schema.nodes.doc)) {
        if (grandparent && grandparent.type === listItem) {
            return Object(__WEBPACK_IMPORTED_MODULE_7__lists_commands__["d" /* outdentList */])()(state, dispatch);
        }
        else {
            return false;
        }
    }
    var tr = state.tr;
    var lastCellPos = cut - 4;
    // need to move cursor inside the table to be able to calculate table's offset
    tr.setSelection(new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["TextSelection"](state.doc.resolve(lastCellPos)));
    var $from = tr.selection.$from;
    var start = $from.start(-1);
    var pos = start + $from.parent.nodeSize - 1;
    // move cursor to the last cell
    // it doesn't join node before (last cell) with node after (content after the cursor)
    // due to ridiculous amount of PM code that would have been required to overwrite
    if (dispatch) {
        dispatch(tr.setSelection(new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["TextSelection"](state.doc.resolve(pos))));
    }
    return true;
};
var deleteColumns = function (indexes) { return function (state, dispatch) {
    var tr = state.tr;
    for (var i = indexes.length; i >= 0; i--) {
        tr = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["removeColumnAt"])(indexes[i])(tr);
    }
    if (tr.docChanged) {
        if (dispatch) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["setTextSelection"])(tr.selection.$from.pos)(tr));
        }
        return true;
    }
    return false;
}; };
var deleteRows = function (indexes) { return function (state, dispatch) {
    var tr = state.tr;
    for (var i = indexes.length; i >= 0; i--) {
        tr = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["removeRowAt"])(indexes[i])(tr);
    }
    if (tr.docChanged) {
        if (dispatch) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["setTextSelection"])(tr.selection.$from.pos)(tr));
        }
        return true;
    }
    return false;
}; };
var emptyMultipleCells = function (targetCellPosition) { return function (state, dispatch) {
    var cursorPos;
    var tr = state.tr;
    if (Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["isCellSelection"])(tr.selection)) {
        var selection = tr.selection;
        selection.forEachCell(function (node, pos) {
            var $pos = tr.doc.resolve(tr.mapping.map(pos + 1));
            tr = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["emptyCell"])(Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findCellClosestToPos"])($pos), state.schema)(tr);
        });
        cursorPos = selection.$headCell.pos;
    }
    else if (targetCellPosition) {
        var cell = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findCellClosestToPos"])(tr.doc.resolve(targetCellPosition + 1));
        tr = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["emptyCell"])(cell, state.schema)(tr);
        cursorPos = cell.pos;
    }
    if (tr.docChanged) {
        var $pos = tr.doc.resolve(tr.mapping.map(cursorPos));
        var textSelection = __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Selection"].findFrom($pos, 1, true);
        if (textSelection) {
            tr.setSelection(textSelection);
        }
        if (dispatch) {
            dispatch(tr);
        }
        return true;
    }
    return false;
}; };
var setMultipleCellAttrs = function (attrs, targetCellPosition) { return function (state, dispatch) {
    var cursorPos;
    var tr = state.tr;
    if (Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["isCellSelection"])(tr.selection)) {
        var selection = tr.selection;
        selection.forEachCell(function (cell, pos) {
            var $pos = tr.doc.resolve(tr.mapping.map(pos + 1));
            tr = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["setCellAttrs"])(Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findCellClosestToPos"])($pos), attrs)(tr);
        });
        cursorPos = selection.$headCell.pos;
    }
    else if (targetCellPosition) {
        var cell = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findCellClosestToPos"])(tr.doc.resolve(targetCellPosition + 1));
        tr = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["setCellAttrs"])(cell, attrs)(tr);
        cursorPos = cell.pos;
    }
    if (tr.docChanged) {
        var $pos = tr.doc.resolve(tr.mapping.map(cursorPos));
        if (dispatch) {
            dispatch(tr.setSelection(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Selection"].near($pos)));
        }
        return true;
    }
    return false;
}; };
var toggleContextualMenu = function (state, dispatch) {
    if (dispatch) {
        dispatch(state.tr
            .setMeta(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["e" /* pluginKey */], {
            action: __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["a" /* ACTIONS */].TOGGLE_CONTEXTUAL_MENU,
        })
            .setMeta('addToHistory', false));
    }
    return true;
};
var setEditorFocus = function (editorHasFocus) { return function (state, dispatch) {
    if (dispatch) {
        dispatch(state.tr.setMeta(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["e" /* pluginKey */], {
            action: __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["a" /* ACTIONS */].SET_EDITOR_FOCUS,
            data: { editorHasFocus: editorHasFocus },
        }));
    }
    return true;
}; };
var setTableRef = function (tableRef) { return function (state, dispatch) {
    if (dispatch) {
        dispatch(state.tr
            .setMeta(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["e" /* pluginKey */], {
            action: __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["a" /* ACTIONS */].SET_TABLE_REF,
            data: { tableRef: tableRef },
        })
            .setMeta('addToHistory', false));
    }
    return true;
}; };
var selectColumn = function (column) { return function (state, dispatch) {
    var tr = state.tr;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["getSelectionRangeInColumn"])(column)(tr), $anchor = _a.$anchor, $head = _a.$head, indexes = _a.indexes;
    tr.setSelection(new __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["CellSelection"]($anchor, $head));
    var targetCellPosition;
    var cells = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["getCellsInColumn"])(indexes[0])(tr.selection);
    if (cells && cells.length) {
        targetCellPosition = cells[0].pos;
    }
    // update contextual menu target cell position on column selection
    if (dispatch) {
        dispatch(tr
            .setMeta(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["e" /* pluginKey */], {
            action: __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["a" /* ACTIONS */].SET_TARGET_CELL_POSITION,
            data: { targetCellPosition: targetCellPosition },
        })
            .setMeta('addToHistory', false));
    }
    return true;
}; };
var selectRow = function (row) { return function (state, dispatch) {
    var tr = state.tr;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["getSelectionRangeInRow"])(row)(tr), $anchor = _a.$anchor, $head = _a.$head, indexes = _a.indexes;
    tr.setSelection(new __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["CellSelection"]($anchor, $head));
    var targetCellPosition;
    var cells = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["getCellsInRow"])(indexes[0])(tr.selection);
    if (cells && cells.length) {
        targetCellPosition = cells[0].pos;
    }
    // update contextual menu target cell position on row selection
    if (dispatch) {
        dispatch(tr
            .setMeta(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["e" /* pluginKey */], {
            action: __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["a" /* ACTIONS */].SET_TARGET_CELL_POSITION,
            data: { targetCellPosition: targetCellPosition },
        })
            .setMeta('addToHistory', false));
    }
    return true;
}; };
var showInsertColumnButton = function (columnIndex) { return function (state, dispatch) {
    var insertColumnButtonIndex = Object(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["d" /* getPluginState */])(state).insertColumnButtonIndex;
    if (columnIndex > -1 && insertColumnButtonIndex !== columnIndex) {
        if (dispatch) {
            dispatch(state.tr
                .setMeta(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["e" /* pluginKey */], {
                action: __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["a" /* ACTIONS */].SHOW_INSERT_COLUMN_BUTTON,
                data: {
                    insertColumnButtonIndex: columnIndex,
                },
            })
                .setMeta('addToHistory', false));
        }
        return true;
    }
    return false;
}; };
var showInsertRowButton = function (rowIndex) { return function (state, dispatch) {
    var insertRowButtonIndex = Object(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["d" /* getPluginState */])(state).insertRowButtonIndex;
    if (rowIndex > -1 && insertRowButtonIndex !== rowIndex) {
        if (dispatch) {
            dispatch(state.tr
                .setMeta(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["e" /* pluginKey */], {
                action: __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["a" /* ACTIONS */].SHOW_INSERT_ROW_BUTTON,
                data: {
                    insertRowButtonIndex: rowIndex,
                },
            })
                .setMeta('addToHistory', false));
        }
        return true;
    }
    return false;
}; };
var hideInsertColumnOrRowButton = function (state, dispatch) {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["d" /* getPluginState */])(state), insertColumnButtonIndex = _a.insertColumnButtonIndex, insertRowButtonIndex = _a.insertRowButtonIndex;
    if (typeof insertColumnButtonIndex === 'number' ||
        typeof insertRowButtonIndex === 'number') {
        if (dispatch) {
            dispatch(state.tr
                .setMeta(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["e" /* pluginKey */], {
                action: __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["a" /* ACTIONS */].HIDE_INSERT_COLUMN_OR_ROW_BUTTON,
            })
                .setMeta('addToHistory', false));
        }
        return true;
    }
    return false;
};
var handleCut = function (oldTr, oldState, newState) {
    var oldSelection = oldState.tr.selection;
    var tr = newState.tr;
    if (oldSelection instanceof __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["CellSelection"]) {
        var $anchorCell = oldTr.doc.resolve(oldTr.mapping.map(oldSelection.$anchorCell.pos));
        var $headCell = oldTr.doc.resolve(oldTr.mapping.map(oldSelection.$headCell.pos));
        tr.setSelection(new __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["CellSelection"]($anchorCell, $headCell));
        if (tr.selection instanceof __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["CellSelection"]) {
            if (tr.selection.isRowSelection()) {
                tr = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["removeSelectedRows"])(tr);
            }
            else if (tr.selection.isColSelection()) {
                tr = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["removeSelectedColumns"])(tr);
            }
        }
    }
    return tr;
};
var handleShiftSelection = function (event) { return function (state, dispatch) {
    if (!(state.selection instanceof __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["CellSelection"]) || !event.shiftKey) {
        return false;
    }
    var selection = state.selection;
    if (selection.isRowSelection() || selection.isColSelection()) {
        var selector = selection.isRowSelection()
            ? "." + __WEBPACK_IMPORTED_MODULE_9__types__["a" /* TableCssClassName */].ROW_CONTROLS_BUTTON_WRAP
            : "." + __WEBPACK_IMPORTED_MODULE_9__types__["a" /* TableCssClassName */].COLUMN_CONTROLS_BUTTON_WRAP;
        var button = Object(__WEBPACK_IMPORTED_MODULE_10__utils__["i" /* closestElement */])(event.target, selector);
        if (!button) {
            return false;
        }
        var buttons = document.querySelectorAll(selector);
        var index = Array.from(buttons).indexOf(button);
        var rect = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["getSelectionRect"])(selection);
        var startCells = selection.isRowSelection()
            ? Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["getCellsInRow"])(index >= rect.bottom ? rect.top : rect.bottom - 1)(selection)
            : Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["getCellsInColumn"])(index >= rect.right ? rect.left : rect.right - 1)(selection);
        var endCells = selection.isRowSelection()
            ? Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["getCellsInRow"])(index)(selection)
            : Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["getCellsInColumn"])(index)(selection);
        if (startCells && endCells) {
            event.stopPropagation();
            event.preventDefault();
            if (dispatch) {
                dispatch(state.tr.setSelection(new __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["CellSelection"](state.doc.resolve(startCells[startCells.length - 1].pos), state.doc.resolve(endCells[0].pos))));
            }
            return true;
        }
    }
    return false;
}; };
//# sourceMappingURL=actions.js.map

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Spinner__ = __webpack_require__(1780);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Spinner__["a"]; });


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(1714);

var iterableToArray = __webpack_require__(1715);

var nonIterableSpread = __webpack_require__(1716);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(569);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(1442);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(1448);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(576);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(1449);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(1450);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(1452);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(1453);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(578);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(350);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(1454);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(1455);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(1456);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(1457);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(1458);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FONT_STYLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SEARCH_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALIGNMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INDENTATION; });
// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
var FONT_STYLE = 'fontStyle';
// Marks group for search queries.
var SEARCH_QUERY = 'searchQuery';
// Marks group for links.
var LINK = 'link';
// Marks group for colors (text-color, background-color, etc).
var COLOR = 'color';
// They need to be on their own group so that they can exclude each other
// and also work when one of them is disabled.
// Marks group for alignment.
var ALIGNMENT = 'alignment';
// Marks group for indentation.
var INDENTATION = 'indentation';
//# sourceMappingURL=groups.js.map

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorModel = __webpack_require__(23);
var prosemirrorState = __webpack_require__(11);
var prosemirrorTransform = __webpack_require__(46);

var result = {};
if (typeof navigator != "undefined" && typeof document != "undefined") {
  var ie_edge = /Edge\/(\d+)/.exec(navigator.userAgent);
  var ie_upto10 = /MSIE \d/.test(navigator.userAgent);
  var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);

  result.mac = /Mac/.test(navigator.platform);
  var ie = result.ie = !!(ie_upto10 || ie_11up || ie_edge);
  result.ie_version = ie_upto10 ? document.documentMode || 6 : ie_11up ? +ie_11up[1] : ie_edge ? +ie_edge[1] : null;
  result.gecko = !ie && /gecko\/(\d+)/i.test(navigator.userAgent);
  result.gecko_version = result.gecko && +(/Firefox\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1];
  var chrome = !ie && /Chrome\/(\d+)/.exec(navigator.userAgent);
  result.chrome = !!chrome;
  result.chrome_version = chrome && +chrome[1];
  result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
  result.android = /Android \d/.test(navigator.userAgent);
  result.webkit = !ie && 'WebkitAppearance' in document.documentElement.style;
  result.safari = /Apple Computer/.test(navigator.vendor);
  result.webkit_version = result.webkit && +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1];
}

var domIndex = function(node) {
  for (var index = 0;; index++) {
    node = node.previousSibling;
    if (!node) { return index }
  }
};

var parentNode = function(node) {
  var parent = node.parentNode;
  return parent && parent.nodeType == 11 ? parent.host : parent
};

var textRange = function(node, from, to) {
  var range = document.createRange();
  range.setEnd(node, to == null ? node.nodeValue.length : to);
  range.setStart(node, from || 0);
  return range
};

// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
var isEquivalentPosition = function(node, off, targetNode, targetOff) {
  return targetNode && (scanFor(node, off, targetNode, targetOff, -1) ||
                        scanFor(node, off, targetNode, targetOff, 1))
};

var atomElements = /^(img|br|input|textarea|hr)$/i;

function scanFor(node, off, targetNode, targetOff, dir) {
  for (;;) {
    if (node == targetNode && off == targetOff) { return true }
    if (off == (dir < 0 ? 0 : nodeSize(node)) || node.nodeType == 3 && node.nodeValue == "\ufeff") {
      var parent = node.parentNode;
      if (parent.nodeType != 1 || hasBlockDesc(node) || atomElements.test(node.nodeName) || node.contentEditable == "false")
        { return false }
      off = domIndex(node) + (dir < 0 ? 0 : 1);
      node = parent;
    } else if (node.nodeType == 1) {
      node = node.childNodes[off + (dir < 0 ? -1 : 0)];
      off = dir < 0 ? nodeSize(node) : 0;
    } else {
      return false
    }
  }
}

function nodeSize(node) {
  return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length
}

function hasBlockDesc(dom) {
  var desc = dom.pmViewDesc;
  return desc && desc.node && desc.node.isBlock
}

// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
var selectionCollapsed = function(domSel) {
  var collapsed = domSel.isCollapsed;
  if (collapsed && result.chrome && domSel.rangeCount && !domSel.getRangeAt(0).collapsed)
    { collapsed = false; }
  return collapsed
};

function windowRect(win) {
  return {left: 0, right: win.innerWidth,
          top: 0, bottom: win.innerHeight}
}

function getSide(value, side) {
  return typeof value == "number" ? value : value[side]
}

function scrollRectIntoView(view, rect, startDOM) {
  var scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
  var doc = view.dom.ownerDocument, win = doc.defaultView;
  for (var parent = startDOM || view.dom;; parent = parentNode(parent)) {
    if (!parent) { break }
    if (parent.nodeType != 1) { continue }
    var atTop = parent == doc.body || parent.nodeType != 1;
    var bounding = atTop ? windowRect(win) : parent.getBoundingClientRect();
    var moveX = 0, moveY = 0;
    if (rect.top < bounding.top + getSide(scrollThreshold, "top"))
      { moveY = -(bounding.top - rect.top + getSide(scrollMargin, "top")); }
    else if (rect.bottom > bounding.bottom - getSide(scrollThreshold, "bottom"))
      { moveY = rect.bottom - bounding.bottom + getSide(scrollMargin, "bottom"); }
    if (rect.left < bounding.left + getSide(scrollThreshold, "left"))
      { moveX = -(bounding.left - rect.left + getSide(scrollMargin, "left")); }
    else if (rect.right > bounding.right - getSide(scrollThreshold, "right"))
      { moveX = rect.right - bounding.right + getSide(scrollMargin, "right"); }
    if (moveX || moveY) {
      if (atTop) {
        win.scrollBy(moveX, moveY);
      } else {
        if (moveY) { parent.scrollTop += moveY; }
        if (moveX) { parent.scrollLeft += moveX; }
      }
    }
    if (atTop) { break }
  }
}

// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function storeScrollPos(view) {
  var rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
  var doc = view.dom.ownerDocument;
  var refDOM, refTop;
  for (var x = (rect.left + rect.right) / 2, y = startY + 1;
       y < Math.min(innerHeight, rect.bottom); y += 5) {
    var dom = view.root.elementFromPoint(x, y);
    if (dom == view.dom || !view.dom.contains(dom)) { continue }
    var localRect = dom.getBoundingClientRect();
    if (localRect.top >= startY - 20) {
      refDOM = dom;
      refTop = localRect.top;
      break
    }
  }
  var stack = [];
  for (var dom$1 = view.dom; dom$1; dom$1 = parentNode(dom$1)) {
    stack.push({dom: dom$1, top: dom$1.scrollTop, left: dom$1.scrollLeft});
    if (dom$1 == doc.body) { break }
  }
  return {refDOM: refDOM, refTop: refTop, stack: stack}
}

// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function resetScrollPos(ref) {
  var refDOM = ref.refDOM;
  var refTop = ref.refTop;
  var stack = ref.stack;

  var newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
  var dTop = newRefTop == 0 ? 0 : newRefTop - refTop;
  for (var i = 0; i < stack.length; i++) {
    var ref$1 = stack[i];
    var dom = ref$1.dom;
    var top = ref$1.top;
    var left = ref$1.left;
    if (dom.scrollTop != top + dTop) { dom.scrollTop = top + dTop; }
    if (dom.scrollLeft != left) { dom.scrollLeft = left; }
  }
}

function findOffsetInNode(node, coords) {
  var closest, dxClosest = 2e8, coordsClosest, offset = 0;
  var rowBot = coords.top, rowTop = coords.top;
  for (var child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++) {
    var rects = (void 0);
    if (child.nodeType == 1) { rects = child.getClientRects(); }
    else if (child.nodeType == 3) { rects = textRange(child).getClientRects(); }
    else { continue }

    for (var i = 0; i < rects.length; i++) {
      var rect = rects[i];
      if (rect.top <= rowBot && rect.bottom >= rowTop) {
        rowBot = Math.max(rect.bottom, rowBot);
        rowTop = Math.min(rect.top, rowTop);
        var dx = rect.left > coords.left ? rect.left - coords.left
            : rect.right < coords.left ? coords.left - rect.right : 0;
        if (dx < dxClosest) {
          closest = child;
          dxClosest = dx;
          coordsClosest = dx && closest.nodeType == 3 ? {left: rect.right < coords.left ? rect.right : rect.left, top: coords.top} : coords;
          if (child.nodeType == 1 && dx)
            { offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0); }
          continue
        }
      }
      if (!closest && (coords.left >= rect.right && coords.top >= rect.top ||
                       coords.left >= rect.left && coords.top >= rect.bottom))
        { offset = childIndex + 1; }
    }
  }
  if (closest && closest.nodeType == 3) { return findOffsetInText(closest, coordsClosest) }
  if (!closest || (dxClosest && closest.nodeType == 1)) { return {node: node, offset: offset} }
  return findOffsetInNode(closest, coordsClosest)
}

function findOffsetInText(node, coords) {
  var len = node.nodeValue.length;
  var range = document.createRange();
  for (var i = 0; i < len; i++) {
    range.setEnd(node, i + 1);
    range.setStart(node, i);
    var rect = singleRect(range, 1);
    if (rect.top == rect.bottom) { continue }
    if (rect.left - 1 <= coords.left && rect.right + 1 >= coords.left &&
        rect.top - 1 <= coords.top && rect.bottom + 1 >= coords.top)
      { return {node: node, offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)} }
  }
  return {node: node, offset: 0}
}

function targetKludge(dom, coords) {
  var parent = dom.parentNode;
  if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left)
    { return parent }
  return dom
}

function posFromElement(view, elt, coords) {
  if (!view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) { return null }

  var ref = findOffsetInNode(elt, coords);
  var node = ref.node;
  var offset = ref.offset;
  var bias = -1;
  if (node.nodeType == 1 && !node.firstChild) {
    var rect = node.getBoundingClientRect();
    bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
  }
  return view.docView.posFromDOM(node, offset, bias)
}

function posFromCaret(view, node, offset, coords) {
  // Browser (in caretPosition/RangeFromPoint) will agressively
  // normalize towards nearby inline nodes. Since we are interested in
  // positions between block nodes too, we first walk up the hierarchy
  // of nodes to see if there are block nodes that the coordinates
  // fall outside of. If so, we take the position before/after that
  // block. If not, we call `posFromDOM` on the raw node/offset.
  var outside = -1;
  for (var cur = node;;) {
    if (cur == view.dom) { break }
    var desc = view.docView.nearestDesc(cur, true);
    if (!desc) { return null }
    if (desc.node.isBlock && desc.parent) {
      var rect = desc.dom.getBoundingClientRect();
      if (rect.left > coords.left || rect.top > coords.top) { outside = desc.posBefore; }
      else if (rect.right < coords.left || rect.bottom < coords.top) { outside = desc.posAfter; }
      else { break }
    }
    cur = desc.dom.parentNode;
  }
  return outside > -1 ? outside : view.docView.posFromDOM(node, offset)
}

// Given an x,y position on the editor, get the position in the document.
function posAtCoords(view, coords) {
  var root = view.root, node, offset;
  if (root.caretPositionFromPoint) {
    var pos$1 = root.caretPositionFromPoint(coords.left, coords.top);
    if (pos$1) { var assign;
      ((assign = pos$1, node = assign.offsetNode, offset = assign.offset)); }
  }
  if (!node && root.caretRangeFromPoint) {
    var range = root.caretRangeFromPoint(coords.left, coords.top);
    if (range) { var assign$1;
      ((assign$1 = range, node = assign$1.startContainer, offset = assign$1.startOffset)); }
  }

  var elt = root.elementFromPoint(coords.left, coords.top + 1), pos;
  if (!elt) { return null }
  elt = targetKludge(elt, coords);
  if (node) {
    // Suspiciously specific kludge to work around caret*FromPoint
    // never returning a position at the end of the document
    if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 &&
        coords.top > node.lastChild.getBoundingClientRect().bottom)
      { pos = view.state.doc.content.size; }
    // Ignore positions directly after a BR, since caret*FromPoint
    // 'round up' positions that would be more accurately places
    // before the BR node.
    else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR")
      { pos = posFromCaret(view, node, offset, coords); }
  }
  if (pos == null) {
    pos = posFromElement(view, elt, coords);
    if (pos == null) { return null }
  }

  var desc = view.docView.nearestDesc(elt, true);
  return {pos: pos, inside: desc ? desc.posAtStart - desc.border : -1}
}

function singleRect(object, bias) {
  var rects = object.getClientRects();
  return !rects.length ? object.getBoundingClientRect() : rects[bias < 0 ? 0 : rects.length - 1]
}

// : (EditorView, number) → {left: number, top: number, right: number, bottom: number}
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function coordsAtPos(view, pos) {
  var ref = view.docView.domFromPos(pos);
  var node = ref.node;
  var offset = ref.offset;
  var side, rect;
  if (node.nodeType == 3) {
    if (offset < node.nodeValue.length) {
      rect = singleRect(textRange(node, offset, offset + 1), -1);
      side = "left";
    }
    if ((!rect || rect.left == rect.right) && offset) {
      rect = singleRect(textRange(node, offset - 1, offset), 1);
      side = "right";
    }
  } else if (node.firstChild) {
    if (offset < node.childNodes.length) {
      var child = node.childNodes[offset];
      rect = singleRect(child.nodeType == 3 ? textRange(child) : child, -1);
      side = "left";
    }
    if ((!rect || rect.top == rect.bottom) && offset) {
      var child$1 = node.childNodes[offset - 1];
      rect = singleRect(child$1.nodeType == 3 ? textRange(child$1) : child$1, 1);
      side = "right";
    }
  } else {
    rect = node.getBoundingClientRect();
    side = "left";
  }
  var x = rect[side];
  return {top: rect.top, bottom: rect.bottom, left: x, right: x}
}

function withFlushedState(view, state, f) {
  var viewState = view.state, active = view.root.activeElement;
  if (viewState != state || !view.inDOMChange) { view.updateState(state); }
  if (active != view.dom) { view.focus(); }
  try {
    return f()
  } finally {
    if (viewState != state) { view.updateState(viewState); }
    if (active != view.dom) { active.focus(); }
  }
}

// : (EditorView, number, number)
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function endOfTextblockVertical(view, state, dir) {
  var sel = state.selection;
  var $pos = dir == "up" ? sel.$anchor.min(sel.$head) : sel.$anchor.max(sel.$head);
  if (!$pos.depth) { return false }
  return withFlushedState(view, state, function () {
    var ref = view.docView.domFromPos($pos.pos);
    var dom = ref.node;
    for (;;) {
      var nearest = view.docView.nearestDesc(dom, true);
      if (!nearest || nearest.node.isBlock) { break }
      dom = nearest.dom.parentNode;
    }
    var coords = coordsAtPos(view, $pos.pos);
    for (var child = dom.firstChild; child; child = child.nextSibling) {
      var boxes = (void 0);
      if (child.nodeType == 1) { boxes = child.getClientRects(); }
      else if (child.nodeType == 3) { boxes = textRange(child, 0, child.nodeValue.length).getClientRects(); }
      else { continue }
      for (var i = 0; i < boxes.length; i++) {
        var box = boxes[i];
        if (box.bottom > box.top && (dir == "up" ? box.bottom < coords.top + 1 : box.top > coords.bottom - 1))
          { return false }
      }
    }
    return true
  })
}

var maybeRTL = /[\u0590-\u08ac]/;

function endOfTextblockHorizontal(view, state, dir) {
  var ref = state.selection;
  var $head = ref.$head;
  if (!$head.parent.isTextblock || !$head.depth) { return false }
  var offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
  var sel = getSelection();
  // If the textblock is all LTR, or the browser doesn't support
  // Selection.modify (Edge), fall back to a primitive approach
  if (!maybeRTL.test($head.parent.textContent) || !sel.modify)
    { return dir == "left" || dir == "backward" ? atStart : atEnd }

  return withFlushedState(view, state, function () {
    // This is a huge hack, but appears to be the best we can
    // currently do: use `Selection.modify` to move the selection by
    // one character, and see if that moves the cursor out of the
    // textblock (or doesn't move it at all, when at the start/end of
    // the document).
    var oldRange = sel.getRangeAt(0), oldNode = sel.focusNode, oldOff = sel.focusOffset;
    sel.modify("move", dir, "character");
    var parentDOM = view.docView.domAfterPos($head.before());
    var result = !parentDOM.contains(sel.focusNode.nodeType == 1 ? sel.focusNode : sel.focusNode.parentNode) ||
        (oldNode == sel.focusNode && oldOff == sel.focusOffset);
    // Restore the previous selection
    sel.removeAllRanges();
    sel.addRange(oldRange);
    return result
  })
}

var cachedState = null;
var cachedDir = null;
var cachedResult = false;
function endOfTextblock(view, state, dir) {
  if (cachedState == state && cachedDir == dir) { return cachedResult }
  cachedState = state; cachedDir = dir;
  return cachedResult = dir == "up" || dir == "down"
    ? endOfTextblockVertical(view, state, dir)
    : endOfTextblockHorizontal(view, state, dir)
}

// NodeView:: interface
//
// By default, document nodes are rendered using the result of the
// [`toDOM`](#model.NodeSpec.toDOM) method of their spec, and managed
// entirely by the editor. For some use cases, such as embedded
// node-specific editing interfaces, you want more control over
// the behavior of a node's in-editor representation, and need to
// [define](#view.EditorProps.nodeViews) a custom node view.
//
// Objects returned as node views must conform to this interface.
//
//   dom:: ?dom.Node
//   The outer DOM node that represents the document node. When not
//   given, the default strategy is used to create a DOM node.
//
//   contentDOM:: ?dom.Node
//   The DOM node that should hold the node's content. Only meaningful
//   if the node view also defines a `dom` property and if its node
//   type is not a leaf node type. When this is present, ProseMirror
//   will take care of rendering the node's children into it. When it
//   is not present, the node view itself is responsible for rendering
//   (or deciding not to render) its child nodes.
//
//   update:: ?(node: Node, decorations: [Decoration]) → bool
//   When given, this will be called when the view is updating itself.
//   It will be given a node (possibly of a different type), and an
//   array of active decorations (which are automatically drawn, and
//   the node view may ignore if it isn't interested in them), and
//   should return true if it was able to update to that node, and
//   false otherwise. If the node view has a `contentDOM` property (or
//   no `dom` property), updating its child nodes will be handled by
//   ProseMirror.
//
//   selectNode:: ?()
//   Can be used to override the way the node's selected status (as a
//   node selection) is displayed.
//
//   deselectNode:: ?()
//   When defining a `selectNode` method, you should also provide a
//   `deselectNode` method to remove the effect again.
//
//   setSelection:: ?(anchor: number, head: number, root: dom.Document)
//   This will be called to handle setting the selection inside the
//   node. The `anchor` and `head` positions are relative to the start
//   of the node. By default, a DOM selection will be created between
//   the DOM positions corresponding to those positions, but if you
//   override it you can do something else.
//
//   stopEvent:: ?(event: dom.Event) → bool
//   Can be used to prevent the editor view from trying to handle some
//   or all DOM events that bubble up from the node view. Events for
//   which this returns true are not handled by the editor.
//
//   ignoreMutation:: ?(dom.MutationRecord) → bool
//   Called when a DOM
//   [mutation](https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver)
//   happens within the view. Return false if the editor should
//   re-parse the range around the mutation, true if it can safely be
//   ignored.
//
//   destroy:: ?()
//   Called when the node view is removed from the editor or the whole
//   editor is destroyed.

// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.

var NOT_DIRTY = 0;
var CHILD_DIRTY = 1;
var CONTENT_DIRTY = 2;
var NODE_DIRTY = 3;

// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
var ViewDesc = function ViewDesc(parent, children, dom, contentDOM) {
  this.parent = parent;
  this.children = children;
  this.dom = dom;
  // An expando property on the DOM node provides a link back to its
  // description.
  dom.pmViewDesc = this;
  // This is the node that holds the child views. It may be null for
  // descs that don't have children.
  this.contentDOM = contentDOM;
  this.dirty = NOT_DIRTY;
};

var prototypeAccessors$1 = { beforePosition: {},size: {},border: {},posBefore: {},posAtStart: {},posAfter: {},posAtEnd: {},contentLost: {} };

// Used to check whether a given description corresponds to a
// widget/mark/node.
ViewDesc.prototype.matchesWidget = function matchesWidget () { return false };
ViewDesc.prototype.matchesMark = function matchesMark () { return false };
ViewDesc.prototype.matchesNode = function matchesNode () { return false };
ViewDesc.prototype.matchesHack = function matchesHack () { return false };

prototypeAccessors$1.beforePosition.get = function () { return false };

// : () → ?ParseRule
// When parsing in-editor content (in domchange.js), we allow
// descriptions to determine the parse rules that should be used to
// parse them.
ViewDesc.prototype.parseRule = function parseRule () { return null };

// : (dom.Event) → bool
// Used by the editor's event handler to ignore events that come
// from certain descs.
ViewDesc.prototype.stopEvent = function stopEvent () { return false };

// The size of the content represented by this desc.
prototypeAccessors$1.size.get = function () {
    var this$1 = this;

  var size = 0;
  for (var i = 0; i < this.children.length; i++) { size += this$1.children[i].size; }
  return size
};

// For block nodes, this represents the space taken up by their
// start/end tokens.
prototypeAccessors$1.border.get = function () { return 0 };

ViewDesc.prototype.destroy = function destroy () {
    var this$1 = this;

  this.parent = null;
  if (this.dom.pmViewDesc == this) { this.dom.pmViewDesc = null; }
  for (var i = 0; i < this.children.length; i++)
    { this$1.children[i].destroy(); }
};

ViewDesc.prototype.posBeforeChild = function posBeforeChild (child) {
    var this$1 = this;

  for (var i = 0, pos = this.posAtStart; i < this.children.length; i++) {
    var cur = this$1.children[i];
    if (cur == child) { return pos }
    pos += cur.size;
  }
};

prototypeAccessors$1.posBefore.get = function () {
  return this.parent.posBeforeChild(this)
};

prototypeAccessors$1.posAtStart.get = function () {
  return this.parent ? this.parent.posBeforeChild(this) + this.border : 0
};

prototypeAccessors$1.posAfter.get = function () {
  return this.posBefore + this.size
};

prototypeAccessors$1.posAtEnd.get = function () {
  return this.posAtStart + this.size - 2 * this.border
};

// : (dom.Node, number, ?number) → number
ViewDesc.prototype.localPosFromDOM = function localPosFromDOM (dom, offset, bias) {
    var this$1 = this;

  // If the DOM position is in the content, use the child desc after
  // it to figure out a position.
  if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
    if (bias < 0) {
      var domBefore, desc;
      if (dom == this.contentDOM) {
        domBefore = dom.childNodes[offset - 1];
      } else {
        while (dom.parentNode != this.contentDOM) { dom = dom.parentNode; }
        domBefore = dom.previousSibling;
      }
      while (domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this)) { domBefore = domBefore.previousSibling; }
      return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart
    } else {
      var domAfter, desc$1;
      if (dom == this.contentDOM) {
        domAfter = dom.childNodes[offset];
      } else {
        while (dom.parentNode != this.contentDOM) { dom = dom.parentNode; }
        domAfter = dom.nextSibling;
      }
      while (domAfter && !((desc$1 = domAfter.pmViewDesc) && desc$1.parent == this)) { domAfter = domAfter.nextSibling; }
      return domAfter ? this.posBeforeChild(desc$1) : this.posAtEnd
    }
  }
  // Otherwise, use various heuristics, falling back on the bias
  // parameter, to determine whether to return the position at the
  // start or at the end of this view desc.
  var atEnd;
  if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) {
    atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
  } else if (this.dom.firstChild) {
    if (offset == 0) { for (var search = dom;; search = search.parentNode) {
      if (search == this$1.dom) { atEnd = false; break }
      if (search.parentNode.firstChild != search) { break }
    } }
    if (atEnd == null && offset == dom.childNodes.length) { for (var search$1 = dom;; search$1 = search$1.parentNode) {
      if (search$1 == this$1.dom) { atEnd = true; break }
      if (search$1.parentNode.lastChild != search$1) { break }
    } }
  }
  return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart
};

// Scan up the dom finding the first desc that is a descendant of
// this one.
ViewDesc.prototype.nearestDesc = function nearestDesc (dom, onlyNodes) {
    var this$1 = this;

  for (var first = true, cur = dom; cur; cur = cur.parentNode) {
    var desc = this$1.getDesc(cur);
    if (desc && (!onlyNodes || desc.node)) {
      // If dom is outside of this desc's nodeDOM, don't count it.
      if (first && desc.nodeDOM && !(desc.nodeDOM.nodeType == 1 ? desc.nodeDOM.contains(dom) : desc.nodeDOM == dom)) { first = false; }
      else { return desc }
    }
  }
};

ViewDesc.prototype.getDesc = function getDesc (dom) {
    var this$1 = this;

  var desc = dom.pmViewDesc;
  for (var cur = desc; cur; cur = cur.parent) { if (cur == this$1) { return desc } }
};

ViewDesc.prototype.posFromDOM = function posFromDOM (dom, offset, bias) {
    var this$1 = this;

  for (var scan = dom;; scan = scan.parentNode) {
    var desc = this$1.getDesc(scan);
    if (desc) { return desc.localPosFromDOM(dom, offset, bias) }
  }
};

// : (number) → ?NodeViewDesc
// Find the desc for the node after the given pos, if any. (When a
// parent node overrode rendering, there might not be one.)
ViewDesc.prototype.descAt = function descAt (pos) {
    var this$1 = this;

  for (var i = 0, offset = 0; i < this.children.length; i++) {
    var child = this$1.children[i], end = offset + child.size;
    if (offset == pos && end != offset) {
      while (!child.border && child.children.length) { child = child.children[0]; }
      return child
    }
    if (pos < end) { return child.descAt(pos - offset - child.border) }
    offset = end;
  }
};

// : (number) → {node: dom.Node, offset: number}
ViewDesc.prototype.domFromPos = function domFromPos (pos) {
    var this$1 = this;

  if (!this.contentDOM) { return {node: this.dom, offset: 0} }
  for (var offset = 0, i = 0;; i++) {
    if (offset == pos) {
      while (i < this.children.length && this.children[i].beforePosition) { i++; }
      return {node: this$1.contentDOM, offset: i}
    }
    if (i == this$1.children.length) { throw new Error("Invalid position " + pos) }
    var child = this$1.children[i], end = offset + child.size;
    if (pos < end) { return child.domFromPos(pos - offset - child.border) }
    offset = end;
  }
};

// Used to find a DOM range in a single parent for a given changed
// range.
ViewDesc.prototype.parseRange = function parseRange (from, to, base) {
    var this$1 = this;
    if ( base === void 0 ) base = 0;

  if (this.children.length == 0)
    { return {node: this.contentDOM, from: from, to: to, fromOffset: 0, toOffset: this.contentDOM.childNodes.length} }

  var fromOffset = -1, toOffset = -1;
  for (var offset = 0, i = 0;; i++) {
    var child = this$1.children[i], end = offset + child.size;
    if (fromOffset == -1 && from <= end) {
      var childBase = offset + child.border;
      // FIXME maybe descend mark views to parse a narrower range?
      if (from >= childBase && to <= end - child.border && child.node &&
          child.contentDOM && this$1.contentDOM.contains(child.contentDOM))
        { return child.parseRange(from - childBase, to - childBase, base + childBase) }

      from = base + offset;
      for (var j = i; j > 0; j--) {
        var prev = this$1.children[j - 1];
        if (prev.size && prev.dom.parentNode == this$1.contentDOM && !prev.emptyChildAt(1)) {
          fromOffset = domIndex(prev.dom) + 1;
          break
        }
        from -= prev.size;
      }
      if (fromOffset == -1) { fromOffset = 0; }
    }
    if (fromOffset > -1 && to <= end) {
      to = base + end;
      for (var j$1 = i + 1; j$1 < this.children.length; j$1++) {
        var next = this$1.children[j$1];
        if (next.size && next.dom.parentNode == this$1.contentDOM && !next.emptyChildAt(-1)) {
          toOffset = domIndex(next.dom);
          break
        }
        to += next.size;
      }
      if (toOffset == -1) { toOffset = this$1.contentDOM.childNodes.length; }
      break
    }
    offset = end;
  }
  return {node: this.contentDOM, from: from, to: to, fromOffset: fromOffset, toOffset: toOffset}
};

ViewDesc.prototype.emptyChildAt = function emptyChildAt (side) {
  if (this.border || !this.contentDOM || !this.children.length) { return false }
  var child = this.children[side < 0 ? 0 : this.children.length - 1];
  return child.size == 0 || child.emptyChildAt(side)
};

// : (number) → dom.Node
ViewDesc.prototype.domAfterPos = function domAfterPos (pos) {
  var ref = this.domFromPos(pos);
    var node = ref.node;
    var offset = ref.offset;
  if (node.nodeType != 1 || offset == node.childNodes.length)
    { throw new RangeError("No node after pos " + pos) }
  return node.childNodes[offset]
};

// : (number, number, dom.Document)
// View descs are responsible for setting any selection that falls
// entirely inside of them, so that custom implementations can do
// custom things with the selection. Note that this falls apart when
// a selection starts in such a node and ends in another, in which
// case we just use whatever domFromPos produces as a best effort.
ViewDesc.prototype.setSelection = function setSelection (anchor, head, root, force) {
    var this$1 = this;

  // If the selection falls entirely in a child, give it to that child
  var from = Math.min(anchor, head), to = Math.max(anchor, head);
  for (var i = 0, offset = 0; i < this.children.length; i++) {
    var child = this$1.children[i], end = offset + child.size;
    if (from > offset && to < end)
      { return child.setSelection(anchor - offset - child.border, head - offset - child.border, root, force) }
    offset = end;
  }

  var anchorDOM = this.domFromPos(anchor), headDOM = this.domFromPos(head);
  var domSel = root.getSelection(), range = document.createRange();
  if (!force &&
      isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset) &&
      isEquivalentPosition(headDOM.node, headDOM.offset, domSel.focusNode, domSel.focusOffset))
    { return }

  // Selection.extend can be used to create an 'inverted' selection
  // (one where the focus is before the anchor), but not all
  // browsers support it yet.
  if (domSel.extend) {
    range.setEnd(anchorDOM.node, anchorDOM.offset);
    range.collapse(false);
  } else {
    if (anchor > head) { var tmp = anchorDOM; anchorDOM = headDOM; headDOM = tmp; }
    range.setEnd(headDOM.node, headDOM.offset);
    range.setStart(anchorDOM.node, anchorDOM.offset);
  }
  domSel.removeAllRanges();
  domSel.addRange(range);
  if (domSel.extend)
    { domSel.extend(headDOM.node, headDOM.offset); }
};

// : (dom.MutationRecord) → bool
ViewDesc.prototype.ignoreMutation = function ignoreMutation (_mutation) {
  return !this.contentDOM
};

prototypeAccessors$1.contentLost.get = function () {
  return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM)
};

// Remove a subtree of the element tree that has been touched
// by a DOM change, so that the next update will redraw it.
ViewDesc.prototype.markDirty = function markDirty (from, to) {
    var this$1 = this;

  for (var offset = 0, i = 0; i < this.children.length; i++) {
    var child = this$1.children[i], end = offset + child.size;
    if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
      var startInside = offset + child.border, endInside = end - child.border;
      if (from >= startInside && to <= endInside) {
        this$1.dirty = from == offset || to == end ? CONTENT_DIRTY : CHILD_DIRTY;
        if (from == startInside && to == endInside && child.contentLost) { child.dirty = NODE_DIRTY; }
        else { child.markDirty(from - startInside, to - startInside); }
        return
      } else {
        child.dirty = NODE_DIRTY;
      }
    }
    offset = end;
  }
  this.dirty = CONTENT_DIRTY;
};

Object.defineProperties( ViewDesc.prototype, prototypeAccessors$1 );

// Reused array to avoid allocating fresh arrays for things that will
// stay empty anyway.
var nothing = [];

// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
var WidgetViewDesc = (function (ViewDesc) {
  function WidgetViewDesc(parent, widget, view, pos) {
    var self, dom = widget.type.toDOM;
    if (typeof dom == "function") { dom = dom(view, function () {
      if (!self) { return pos }
      if (self.parent) { return self.parent.posBeforeChild(self) }
    }); }
    if (!widget.type.spec.raw) {
      if (dom.nodeType != 1) {
        var wrap = document.createElement("span");
        wrap.appendChild(dom);
        dom = wrap;
      }
      dom.contentEditable = false;
      dom.classList.add("ProseMirror-widget");
    }
    ViewDesc.call(this, parent, nothing, dom, null);
    this.widget = widget;
    self = this;
  }

  if ( ViewDesc ) WidgetViewDesc.__proto__ = ViewDesc;
  WidgetViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
  WidgetViewDesc.prototype.constructor = WidgetViewDesc;

  var prototypeAccessors$1 = { beforePosition: {} };

  prototypeAccessors$1.beforePosition.get = function () {
    return this.widget.type.side < 0
  };

  WidgetViewDesc.prototype.matchesWidget = function matchesWidget (widget) {
    return this.dirty == NOT_DIRTY && widget.type.eq(this.widget.type)
  };

  WidgetViewDesc.prototype.parseRule = function parseRule () { return {ignore: true} };

  WidgetViewDesc.prototype.stopEvent = function stopEvent (event) {
    var stop = this.widget.spec.stopEvent;
    return stop ? stop(event) : false
  };

  Object.defineProperties( WidgetViewDesc.prototype, prototypeAccessors$1 );

  return WidgetViewDesc;
}(ViewDesc));

// A cursor wrapper is used to put the cursor in when newly typed text
// needs to be styled differently from its surrounding text (for
// example through storedMarks), so that the style of the text doesn't
// visually 'pop' between typing it and actually updating the view.
var CursorWrapperDesc = (function (WidgetViewDesc) {
  function CursorWrapperDesc () {
    WidgetViewDesc.apply(this, arguments);
  }

  if ( WidgetViewDesc ) CursorWrapperDesc.__proto__ = WidgetViewDesc;
  CursorWrapperDesc.prototype = Object.create( WidgetViewDesc && WidgetViewDesc.prototype );
  CursorWrapperDesc.prototype.constructor = CursorWrapperDesc;

  CursorWrapperDesc.prototype.parseRule = function parseRule () {
    var content;
    for (var child = this.dom.firstChild; child; child = child.nextSibling) {
      var add = (void 0);
      if (child.nodeType == 3) {
        var text = child.nodeValue.replace(/\ufeff/g, "");
        if (!text) { continue }
        add = document.createTextNode(text);
      } else if (child.textContent == "\ufeff") {
        continue
      } else {
        add = child.cloneNode(true);
      }
      if (!content) { content = document.createDocumentFragment(); }
      content.appendChild(add);
    }
    if (content) { return {skip: content} }
    else { return WidgetViewDesc.prototype.parseRule.call(this) }
  };

  CursorWrapperDesc.prototype.ignoreMutation = function ignoreMutation () { return false };

  return CursorWrapperDesc;
}(WidgetViewDesc));

// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
var MarkViewDesc = (function (ViewDesc) {
  function MarkViewDesc(parent, mark, dom, contentDOM) {
    ViewDesc.call(this, parent, [], dom, contentDOM);
    this.mark = mark;
  }

  if ( ViewDesc ) MarkViewDesc.__proto__ = ViewDesc;
  MarkViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
  MarkViewDesc.prototype.constructor = MarkViewDesc;

  MarkViewDesc.create = function create (parent, mark, inline, view) {
    var custom = view.nodeViews[mark.type.name];
    var spec = custom && custom(mark, view, inline);
    if (!spec || !spec.dom)
      { spec = prosemirrorModel.DOMSerializer.renderSpec(document, mark.type.spec.toDOM(mark, inline)); }
    return new MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom)
  };

  MarkViewDesc.prototype.parseRule = function parseRule () { return {mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM} };

  MarkViewDesc.prototype.matchesMark = function matchesMark (mark) { return this.dirty != NODE_DIRTY && this.mark.eq(mark) };

  MarkViewDesc.prototype.markDirty = function markDirty (from, to) {
    ViewDesc.prototype.markDirty.call(this, from, to);
    // Move dirty info to nearest node view
    if (this.dirty != NOT_DIRTY) {
      var parent = this.parent;
      while (!parent.node) { parent = parent.parent; }
      if (parent.dirty < this.dirty) { parent.dirty = this.dirty; }
      this.dirty = NOT_DIRTY;
    }
  };

  return MarkViewDesc;
}(ViewDesc));

// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
var NodeViewDesc = (function (ViewDesc) {
  function NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos) {
    ViewDesc.call(this, parent, node.isLeaf ? nothing : [], dom, contentDOM);
    this.nodeDOM = nodeDOM;
    this.node = node;
    this.outerDeco = outerDeco;
    this.innerDeco = innerDeco;
    if (contentDOM) { this.updateChildren(view, pos); }
  }

  if ( ViewDesc ) NodeViewDesc.__proto__ = ViewDesc;
  NodeViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
  NodeViewDesc.prototype.constructor = NodeViewDesc;

  var prototypeAccessors$2 = { size: {},border: {} };

  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finnicky
  // implementation details to the user code that they probably will
  // never need.)
  NodeViewDesc.create = function create (parent, node, outerDeco, innerDeco, view, pos) {
    var custom = view.nodeViews[node.type.name], descObj;
    var spec = custom && custom(node, view, function () {
      // (This is a function that allows the custom view to find its
      // own position)
      if (!descObj) { return pos }
      if (descObj.parent) { return descObj.parent.posBeforeChild(descObj) }
    }, outerDeco);

    var dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
    if (node.isText) {
      if (!dom) { dom = document.createTextNode(node.text); }
      else if (dom.nodeType != 3) { throw new RangeError("Text must be rendered as a DOM text node") }
    } else if (!dom) {
      var assign;
      ((assign = prosemirrorModel.DOMSerializer.renderSpec(document, node.type.spec.toDOM(node)), dom = assign.dom, contentDOM = assign.contentDOM));
    }
    if (!contentDOM && !node.isText && dom.nodeName != "BR") { // Chrome gets confused by <br contenteditable=false>
      dom.contentEditable = false;
      if (node.type.spec.draggable) { dom.draggable = true; }
    }

    var nodeDOM = dom;
    dom = applyOuterDeco(dom, outerDeco, node);

    if (spec)
      { return descObj = new CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM,
                                              spec, view, pos + 1) }
    else if (node.isText)
      { return new TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view) }
    else
      { return new NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos + 1) }
  };

  NodeViewDesc.prototype.parseRule = function parseRule () {
    var this$1 = this;

    // Experimental kludge to allow opt-in re-parsing of nodes
    if (this.node.type.spec.reparseInView) { return null }
    // FIXME the assumption that this can always return the current
    // attrs means that if the user somehow manages to change the
    // attrs in the dom, that won't be picked up. Not entirely sure
    // whether this is a problem
    var rule = {node: this.node.type.name, attrs: this.node.attrs};
    if (this.node.type.spec.code) { rule.preserveWhitespace = "full"; }
    if (this.contentDOM && !this.contentLost) { rule.contentElement = this.contentDOM; }
    else { rule.getContent = function () { return this$1.contentDOM ? prosemirrorModel.Fragment.empty : this$1.node.content; }; }
    return rule
  };

  NodeViewDesc.prototype.matchesNode = function matchesNode (node, outerDeco, innerDeco) {
    return this.dirty == NOT_DIRTY && node.eq(this.node) &&
      sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco)
  };

  prototypeAccessors$2.size.get = function () { return this.node.nodeSize };

  prototypeAccessors$2.border.get = function () { return this.node.isLeaf ? 0 : 1 };

  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  NodeViewDesc.prototype.updateChildren = function updateChildren (view, pos) {
    var this$1 = this;

    var updater = new ViewTreeUpdater(this), inline = this.node.inlineContent;
    iterDeco(this.node, this.innerDeco, function (widget, i) {
      if (widget.spec.marks)
        { updater.syncToMarks(widget.spec.marks, inline, view); }
      else if (widget.type.side >= 0)
        { updater.syncToMarks(i == this$1.node.childCount ? prosemirrorModel.Mark.none : this$1.node.child(i).marks, inline, view); }
      // If the next node is a desc matching this widget, reuse it,
      // otherwise insert the widget as a new view desc.
      updater.placeWidget(widget, view, pos);
    }, function (child, outerDeco, innerDeco, i) {
      // Make sure the wrapping mark descs match the node's marks.
      updater.syncToMarks(child.marks, inline, view);
      // Either find an existing desc that exactly matches this node,
      // and drop the descs before it.
      updater.findNodeMatch(child, outerDeco, innerDeco, i) ||
        // Or try updating the next desc to reflect this node.
        updater.updateNextNode(child, outerDeco, innerDeco, view, i) ||
        // Or just add it as a new desc.
        updater.addNode(child, outerDeco, innerDeco, view, pos);
      pos += child.nodeSize;
    });
    // Drop all remaining descs after the current position.
    updater.syncToMarks(nothing, inline, view);
    if (this.node.isTextblock) { updater.addTextblockHacks(); }
    updater.destroyRest();

    // Sync the DOM if anything changed
    if (updater.changed || this.dirty == CONTENT_DIRTY) { this.renderChildren(); }
  };

  NodeViewDesc.prototype.renderChildren = function renderChildren () {
    renderDescs(this.contentDOM, this.children, NodeViewDesc.is);
    if (result.ios) { iosHacks(this.dom); }
  };

  // : (Node, [Decoration], DecorationSet, EditorView) → bool
  // If this desc be updated to match the given node decoration,
  // do so and return true.
  NodeViewDesc.prototype.update = function update (node, outerDeco, innerDeco, view) {
    if (this.dirty == NODE_DIRTY ||
        !node.sameMarkup(this.node)) { return false }
    this.updateInner(node, outerDeco, innerDeco, view);
    return true
  };

  NodeViewDesc.prototype.updateInner = function updateInner (node, outerDeco, innerDeco, view) {
    this.updateOuterDeco(outerDeco);
    this.node = node;
    this.innerDeco = innerDeco;
    if (this.contentDOM) { this.updateChildren(view, this.posAtStart); }
    this.dirty = NOT_DIRTY;
  };

  NodeViewDesc.prototype.updateOuterDeco = function updateOuterDeco (outerDeco) {
    if (sameOuterDeco(outerDeco, this.outerDeco)) { return }
    var needsWrap = this.nodeDOM.nodeType != 1;
    var oldDOM = this.dom;
    this.dom = patchOuterDeco(this.dom, this.nodeDOM,
                              computeOuterDeco(this.outerDeco, this.node, needsWrap),
                              computeOuterDeco(outerDeco, this.node, needsWrap));
    if (this.dom != oldDOM) {
      oldDOM.pmViewDesc = null;
      this.dom.pmViewDesc = this;
    }
    this.outerDeco = outerDeco;
  };

  // Mark this node as being the selected node.
  NodeViewDesc.prototype.selectNode = function selectNode () {
    this.nodeDOM.classList.add("ProseMirror-selectednode");
  };

  // Remove selected node marking from this node.
  NodeViewDesc.prototype.deselectNode = function deselectNode () {
    this.nodeDOM.classList.remove("ProseMirror-selectednode");
  };

  Object.defineProperties( NodeViewDesc.prototype, prototypeAccessors$2 );

  return NodeViewDesc;
}(ViewDesc));

// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function docViewDesc(doc, outerDeco, innerDeco, dom, view) {
  applyOuterDeco(dom, outerDeco, doc);
  return new NodeViewDesc(null, doc, outerDeco, innerDeco, dom, dom, dom, view, 0)
}

var TextViewDesc = (function (NodeViewDesc) {
  function TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view) {
    NodeViewDesc.call(this, parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view);
  }

  if ( NodeViewDesc ) TextViewDesc.__proto__ = NodeViewDesc;
  TextViewDesc.prototype = Object.create( NodeViewDesc && NodeViewDesc.prototype );
  TextViewDesc.prototype.constructor = TextViewDesc;

  TextViewDesc.prototype.parseRule = function parseRule () {
    var parent = this.nodeDOM.parentNode;
    return parent ? {skip: parent} : {ignore: true}
  };

  TextViewDesc.prototype.update = function update (node, outerDeco) {
    if (this.dirty == NODE_DIRTY || (this.dirty != NOT_DIRTY && !this.inParent()) ||
        !node.sameMarkup(this.node)) { return false }
    this.updateOuterDeco(outerDeco);
    if ((this.dirty != NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue)
      { this.nodeDOM.nodeValue = node.text; }
    this.node = node;
    this.dirty = NOT_DIRTY;
    return true
  };

  TextViewDesc.prototype.inParent = function inParent () {
    var parentDOM = this.parent.contentDOM;
    for (var n = this.nodeDOM; n; n = n.parentNode) { if (n == parentDOM) { return true } }
    return false
  };

  TextViewDesc.prototype.domFromPos = function domFromPos (pos) {
    return {node: this.nodeDOM, offset: pos}
  };

  TextViewDesc.prototype.localPosFromDOM = function localPosFromDOM (dom, offset, bias) {
    if (dom == this.nodeDOM) { return this.posAtStart + Math.min(offset, this.node.text.length) }
    return NodeViewDesc.prototype.localPosFromDOM.call(this, dom, offset, bias)
  };

  TextViewDesc.prototype.ignoreMutation = function ignoreMutation (mutation) {
    return mutation.type != "characterData"
  };

  return TextViewDesc;
}(NodeViewDesc));

// A dummy desc used to tag trailing BR or span nodes created to work
// around contentEditable terribleness.
var BRHackViewDesc = (function (ViewDesc) {
  function BRHackViewDesc () {
    ViewDesc.apply(this, arguments);
  }

  if ( ViewDesc ) BRHackViewDesc.__proto__ = ViewDesc;
  BRHackViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
  BRHackViewDesc.prototype.constructor = BRHackViewDesc;

  BRHackViewDesc.prototype.parseRule = function parseRule () { return {ignore: true} };
  BRHackViewDesc.prototype.matchesHack = function matchesHack () { return this.dirty == NOT_DIRTY };

  return BRHackViewDesc;
}(ViewDesc));

// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
var CustomNodeViewDesc = (function (NodeViewDesc) {
  function CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos) {
    NodeViewDesc.call(this, parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
    this.spec = spec;
  }

  if ( NodeViewDesc ) CustomNodeViewDesc.__proto__ = NodeViewDesc;
  CustomNodeViewDesc.prototype = Object.create( NodeViewDesc && NodeViewDesc.prototype );
  CustomNodeViewDesc.prototype.constructor = CustomNodeViewDesc;

  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  CustomNodeViewDesc.prototype.update = function update (node, outerDeco, innerDeco, view) {
    if (this.dirty == NODE_DIRTY) { return false }
    if (this.spec.update) {
      var result$$1 = this.spec.update(node, outerDeco);
      if (result$$1) { this.updateInner(node, outerDeco, innerDeco, view); }
      return result$$1
    } else if (!this.contentDOM && !node.isLeaf) {
      return false
    } else {
      return NodeViewDesc.prototype.update.call(this, node, outerDeco, innerDeco, view)
    }
  };

  CustomNodeViewDesc.prototype.selectNode = function selectNode () {
    this.spec.selectNode ? this.spec.selectNode() : NodeViewDesc.prototype.selectNode.call(this);
  };

  CustomNodeViewDesc.prototype.deselectNode = function deselectNode () {
    this.spec.deselectNode ? this.spec.deselectNode() : NodeViewDesc.prototype.deselectNode.call(this);
  };

  CustomNodeViewDesc.prototype.setSelection = function setSelection (anchor, head, root, force) {
    this.spec.setSelection ? this.spec.setSelection(anchor, head, root)
      : NodeViewDesc.prototype.setSelection.call(this, anchor, head, root, force);
  };

  CustomNodeViewDesc.prototype.destroy = function destroy () {
    if (this.spec.destroy) { this.spec.destroy(); }
    NodeViewDesc.prototype.destroy.call(this);
  };

  CustomNodeViewDesc.prototype.stopEvent = function stopEvent (event) {
    return this.spec.stopEvent ? this.spec.stopEvent(event) : false
  };

  CustomNodeViewDesc.prototype.ignoreMutation = function ignoreMutation (mutation) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : NodeViewDesc.prototype.ignoreMutation.call(this, mutation)
  };

  return CustomNodeViewDesc;
}(NodeViewDesc));

// : (dom.Node, [ViewDesc])
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function renderDescs(parentDOM, descs) {
  var dom = parentDOM.firstChild;
  for (var i = 0; i < descs.length; i++) {
    var desc = descs[i], childDOM = desc.dom;
    if (childDOM.parentNode == parentDOM) {
      while (childDOM != dom) { dom = rm(dom); }
      dom = dom.nextSibling;
    } else {
      parentDOM.insertBefore(childDOM, dom);
    }
    if (desc instanceof MarkViewDesc) {
      var pos = dom ? dom.previousSibling : parentDOM.lastChild;
      renderDescs(desc.contentDOM, desc.children);
      dom = pos ? pos.nextSibling : parentDOM.firstChild;
    }
  }
  while (dom) { dom = rm(dom); }
}

function OuterDecoLevel(nodeName) {
  if (nodeName) { this.nodeName = nodeName; }
}
OuterDecoLevel.prototype = Object.create(null);

var noDeco = [new OuterDecoLevel];

function computeOuterDeco(outerDeco, node, needsWrap) {
  if (outerDeco.length == 0) { return noDeco }

  var top = needsWrap ? noDeco[0] : new OuterDecoLevel, result$$1 = [top];

  for (var i = 0; i < outerDeco.length; i++) {
    var attrs = outerDeco[i].type.attrs, cur = top;
    if (!attrs) { continue }
    if (attrs.nodeName)
      { result$$1.push(cur = new OuterDecoLevel(attrs.nodeName)); }

    for (var name in attrs) {
      var val = attrs[name];
      if (val == null) { continue }
      if (needsWrap && result$$1.length == 1)
        { result$$1.push(cur = top = new OuterDecoLevel(node.isInline ? "span" : "div")); }
      if (name == "class") { cur.class = (cur.class ? cur.class + " " : "") + val; }
      else if (name == "style") { cur.style = (cur.style ? cur.style + ";" : "") + val; }
      else if (name != "nodeName") { cur[name] = val; }
    }
  }

  return result$$1
}

function patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
  // Shortcut for trivial case
  if (prevComputed == noDeco && curComputed == noDeco) { return nodeDOM }

  var curDOM = nodeDOM;
  for (var i = 0; i < curComputed.length; i++) {
    var deco = curComputed[i], prev = prevComputed[i];
    if (i) {
      var parent = (void 0);
      if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM &&
          (parent = nodeDOM.parentNode) && parent.tagName.toLowerCase() == deco.nodeName) {
        curDOM = parent;
      } else {
        parent = document.createElement(deco.nodeName);
        parent.appendChild(curDOM);
        curDOM = parent;
      }
    }
    patchAttributes(curDOM, prev || noDeco[0], deco);
  }
  return curDOM
}

function patchAttributes(dom, prev, cur) {
  for (var name in prev)
    { if (name != "class" && name != "style" && name != "nodeName" && !(name in cur))
      { dom.removeAttribute(name); } }
  for (var name$1 in cur)
    { if (name$1 != "class" && name$1 != "style" && name$1 != "nodeName" && cur[name$1] != prev[name$1])
      { dom.setAttribute(name$1, cur[name$1]); } }
  if (prev.class != cur.class) {
    var prevList = prev.class ? prev.class.split(" ") : nothing;
    var curList = cur.class ? cur.class.split(" ") : nothing;
    for (var i = 0; i < prevList.length; i++) { if (curList.indexOf(prevList[i]) == -1)
      { dom.classList.remove(prevList[i]); } }
    for (var i$1 = 0; i$1 < curList.length; i$1++) { if (prevList.indexOf(curList[i$1]) == -1)
      { dom.classList.add(curList[i$1]); } }
  }
  if (prev.style != cur.style) {
    if (prev.style) {
      var prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
      while (m = prop.exec(prev.style))
        { dom.style[m[1].toLowerCase()] = ""; }
    }
    if (cur.style)
      { dom.style.cssText += cur.style; }
  }
}

function applyOuterDeco(dom, deco, node) {
  return patchOuterDeco(dom, dom, noDeco, computeOuterDeco(deco, node, dom.nodeType != 1))
}

// : ([Decoration], [Decoration]) → bool
function sameOuterDeco(a, b) {
  if (a.length != b.length) { return false }
  for (var i = 0; i < a.length; i++) { if (!a[i].type.eq(b[i].type)) { return false } }
  return true
}

// Remove a DOM node and return its next sibling.
function rm(dom) {
  var next = dom.nextSibling;
  dom.parentNode.removeChild(dom);
  return next
}

// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
var ViewTreeUpdater = function ViewTreeUpdater(top) {
  this.top = top;
  // Index into `this.top`'s child array, represents the current
  // update position.
  this.index = 0;
  // When entering a mark, the current top and index are pushed
  // onto this.
  this.stack = [];
  // Tracks whether anything was changed
  this.changed = false;

  this.preMatched = preMatch(top.node.content, top.children);
};

// Destroy and remove the children between the given indices in
// `this.top`.
ViewTreeUpdater.prototype.destroyBetween = function destroyBetween (start, end) {
    var this$1 = this;

  if (start == end) { return }
  for (var i = start; i < end; i++) { this$1.top.children[i].destroy(); }
  this.top.children.splice(start, end - start);
  this.changed = true;
};

// Destroy all remaining children in `this.top`.
ViewTreeUpdater.prototype.destroyRest = function destroyRest () {
  this.destroyBetween(this.index, this.top.children.length);
};

// : ([Mark], EditorView)
// Sync the current stack of mark descs with the given array of
// marks, reusing existing mark descs when possible.
ViewTreeUpdater.prototype.syncToMarks = function syncToMarks (marks, inline, view) {
    var this$1 = this;

  var keep = 0, depth = this.stack.length >> 1;
  var maxKeep = Math.min(depth, marks.length);
  while (keep < maxKeep &&
         (keep == depth - 1 ? this.top : this.stack[(keep + 1) << 1]).matchesMark(marks[keep]))
    { keep++; }

  while (keep < depth) {
    this$1.destroyRest();
    this$1.top.dirty = NOT_DIRTY;
    this$1.index = this$1.stack.pop();
    this$1.top = this$1.stack.pop();
    depth--;
  }
  while (depth < marks.length) {
    this$1.stack.push(this$1.top, this$1.index + 1);
    var found = -1;
    for (var i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++) {
      if (this$1.top.children[i].matchesMark(marks[depth])) { found = i; break }
    }
    if (found > -1) {
      if (found > this$1.index) {
        this$1.changed = true;
        this$1.top.children.splice(this$1.index, found - this$1.index);
      }
      this$1.top = this$1.top.children[this$1.index];
    } else {
      var markDesc = MarkViewDesc.create(this$1.top, marks[depth], inline, view);
      this$1.top.children.splice(this$1.index, 0, markDesc);
      this$1.top = markDesc;
      this$1.changed = true;
    }
    this$1.index = 0;
    depth++;
  }
};

// : (Node, [Decoration], DecorationSet) → bool
// Try to find a node desc matching the given data. Skip over it and
// return true when successful.
ViewTreeUpdater.prototype.findNodeMatch = function findNodeMatch (node, outerDeco, innerDeco, index) {
    var this$1 = this;

  var found = -1, preMatch = this.preMatched[index], children = this.top.children;
  if (preMatch && preMatch.matchesNode(node, outerDeco, innerDeco)) {
    found = children.indexOf(preMatch);
  } else {
    for (var i = this.index, e = Math.min(children.length, i + 5); i < e; i++) {
      var child = children[i];
      if (child.matchesNode(node, outerDeco, innerDeco) && this$1.preMatched.indexOf(child) < 0) {
        found = i;
        break
      }
    }
  }
  if (found < 0) { return false }
  this.destroyBetween(this.index, found);
  this.index++;
  return true
};

// : (Node, [Decoration], DecorationSet, EditorView, Fragment, number) → bool
// Try to update the next node, if any, to the given data. Checks
// pre-matches to avoid overwriting nodes that could still be used.
ViewTreeUpdater.prototype.updateNextNode = function updateNextNode (node, outerDeco, innerDeco, view, index) {
  if (this.index == this.top.children.length) { return false }
  var next = this.top.children[this.index];
  if (next instanceof NodeViewDesc) {
    var preMatch = this.preMatched.indexOf(next);
    if (preMatch > -1 && preMatch != index) { return false }
    var nextDOM = next.dom;
    if (next.update(node, outerDeco, innerDeco, view)) {
      if (next.dom != nextDOM) { this.changed = true; }
      this.index++;
      return true
    }
  }
  return false
};

// : (Node, [Decoration], DecorationSet, EditorView)
// Insert the node as a newly created node desc.
ViewTreeUpdater.prototype.addNode = function addNode (node, outerDeco, innerDeco, view, pos) {
  this.top.children.splice(this.index++, 0, NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos));
  this.changed = true;
};

ViewTreeUpdater.prototype.placeWidget = function placeWidget (widget, view, pos) {
  if (this.index < this.top.children.length && this.top.children[this.index].matchesWidget(widget)) {
    this.index++;
  } else {
    var desc = new (widget.spec.isCursorWrapper ? CursorWrapperDesc : WidgetViewDesc)(this.top, widget, view, pos);
    this.top.children.splice(this.index++, 0, desc);
    this.changed = true;
  }
};

// Make sure a textblock looks and behaves correctly in
// contentEditable.
ViewTreeUpdater.prototype.addTextblockHacks = function addTextblockHacks () {
  var lastChild = this.top.children[this.index - 1];
  while (lastChild instanceof MarkViewDesc) { lastChild = lastChild.children[lastChild.children.length - 1]; }

  if (!lastChild || // Empty textblock
      !(lastChild instanceof TextViewDesc) ||
      /\n$/.test(lastChild.node.text)) {
    if (this.index < this.top.children.length && this.top.children[this.index].matchesHack()) {
      this.index++;
    } else {
      var dom = document.createElement("br");
      this.top.children.splice(this.index++, 0, new BRHackViewDesc(this.top, nothing, dom, null));
      this.changed = true;
    }
  }
};

// : (Fragment, [ViewDesc]) → [ViewDesc]
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing
// those for other nodes. Returns an array whose positions correspond
// to node positions in the fragment, and whose elements are either
// descs matched to the child at that index, or empty.
function preMatch(frag, descs) {
  var result$$1 = [], end = frag.childCount;
  for (var i = descs.length - 1; end > 0 && i >= 0; i--) {
    var desc = descs[i], node = desc.node;
    if (!node) { continue }
    if (node != frag.child(end - 1)) { break }
    result$$1[--end] = desc;
  }
  return result$$1
}

function compareSide(a, b) { return a.type.side - b.type.side }

// : (ViewDesc, DecorationSet, (Decoration), (Node, [Decoration], DecorationSet, number))
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function iterDeco(parent, deco, onWidget, onNode) {
  var locals = deco.locals(parent), offset = 0;
  // Simple, cheap variant for when there are no local decorations
  if (locals.length == 0) {
    for (var i = 0; i < parent.childCount; i++) {
      var child = parent.child(i);
      onNode(child, locals, deco.forChild(offset, child), i);
      offset += child.nodeSize;
    }
    return
  }

  var decoIndex = 0, active = [], restNode = null;
  for (var parentIndex = 0;;) {
    if (decoIndex < locals.length && locals[decoIndex].to == offset) {
      var widget = locals[decoIndex++], widgets = (void 0);
      while (decoIndex < locals.length && locals[decoIndex].to == offset)
        { (widgets || (widgets = [widget])).push(locals[decoIndex++]); }
      if (widgets) {
        widgets.sort(compareSide);
        for (var i$1 = 0; i$1 < widgets.length; i$1++) { onWidget(widgets[i$1], parentIndex); }
      } else {
        onWidget(widget, parentIndex);
      }
    }

    var child$1 = (void 0);
    if (restNode) {
      child$1 = restNode;
      restNode = null;
    } else if (parentIndex < parent.childCount) {
      child$1 = parent.child(parentIndex++);
    } else {
      break
    }

    for (var i$2 = 0; i$2 < active.length; i$2++) { if (active[i$2].to <= offset) { active.splice(i$2--, 1); } }
    while (decoIndex < locals.length && locals[decoIndex].from == offset) { active.push(locals[decoIndex++]); }

    var end = offset + child$1.nodeSize;
    if (child$1.isText) {
      var cutAt = end;
      if (decoIndex < locals.length && locals[decoIndex].from < cutAt) { cutAt = locals[decoIndex].from; }
      for (var i$3 = 0; i$3 < active.length; i$3++) { if (active[i$3].to < cutAt) { cutAt = active[i$3].to; } }
      if (cutAt < end) {
        restNode = child$1.cut(cutAt - offset);
        child$1 = child$1.cut(0, cutAt - offset);
        end = cutAt;
      }
    }

    onNode(child$1, active.length ? active.slice() : nothing, deco.forChild(offset, child$1), parentIndex - 1);
    offset = end;
  }
}

// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function iosHacks(dom) {
  if (dom.nodeName == "UL" || dom.nodeName == "OL") {
    var oldCSS = dom.style.cssText;
    dom.style.cssText = oldCSS + "; list-style: square !important";
    window.getComputedStyle(dom).listStyle;
    dom.style.cssText = oldCSS;
  }
}

function moveSelectionBlock(state, dir) {
  var ref = state.selection;
  var $anchor = ref.$anchor;
  var $head = ref.$head;
  var $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
  var $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
  return $start && prosemirrorState.Selection.findFrom($start, dir)
}

function apply(view, sel) {
  view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
  return true
}

function selectHorizontally(view, dir) {
  var sel = view.state.selection;
  if (sel instanceof prosemirrorState.TextSelection) {
    if (!sel.empty) {
      return false
    } else if (view.endOfTextblock(dir > 0 ? "right" : "left")) {
      var next = moveSelectionBlock(view.state, dir);
      if (next && (next instanceof prosemirrorState.NodeSelection)) { return apply(view, next) }
      return false
    } else {
      var $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
      if (node && prosemirrorState.NodeSelection.isSelectable(node)) {
        var nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
        if (node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)
          { return apply(view, new prosemirrorState.NodeSelection(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head)) }
      }
      return false
    }
  } else if (sel instanceof prosemirrorState.NodeSelection && sel.node.isInline) {
    return apply(view, new prosemirrorState.TextSelection(dir > 0 ? sel.$to : sel.$from))
  } else {
    var next$1 = moveSelectionBlock(view.state, dir);
    if (next$1) { return apply(view, next$1) }
    return false
  }
}

function nodeLen(node) {
  return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length
}

function isIgnorable(dom) {
  var desc = dom.pmViewDesc;
  return desc && desc.size == 0 && (dom.nextSibling || dom.nodeName != "BR")
}

// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function skipIgnoredNodesLeft(view) {
  var sel = view.root.getSelection();
  var node = sel.focusNode, offset = sel.focusOffset;
  if (!node) { return }
  var moveNode, moveOffset, force = false;
  // Gecko will do odd things when the selection is directly in front
  // of a non-editable node, so in that case, move it into the next
  // node if possible. Issue prosemirror/prosemirror#832.
  if (result.gecko && node.nodeType == 1 && offset < nodeLen(node) && isIgnorable(node.childNodes[offset])) { force = true; }
  for (;;) {
    if (offset > 0) {
      if (node.nodeType != 1) {
        if (node.nodeType == 3 && node.nodeValue.charAt(offset - 1) == "\ufeff") {
          // IE11's cursor will still be stuck when placed at the
          // beginning of the cursor wrapper text node (#807)
          if (result.ie && result.ie_version <= 11) { force = true; }
          moveNode = node;
          moveOffset = --offset;
        } else { break }
      } else {
        var before = node.childNodes[offset - 1];
        if (isIgnorable(before)) {
          moveNode = node;
          moveOffset = --offset;
        } else if (before.nodeType == 3) {
          node = before;
          offset = node.nodeValue.length;
        } else { break }
      }
    } else if (isBlockNode(node)) {
      break
    } else {
      var prev = node.previousSibling;
      while (prev && isIgnorable(prev)) {
        moveNode = node.parentNode;
        moveOffset = domIndex(prev);
        prev = prev.previousSibling;
      }
      if (!prev) {
        node = node.parentNode;
        if (node == view.dom) { break }
        offset = 0;
      } else {
        node = prev;
        offset = nodeLen(node);
      }
    }
  }
  if (force) { setSelFocus(view, sel, node, offset); }
  else if (moveNode) { setSelFocus(view, sel, moveNode, moveOffset); }
}

// Make sure the cursor isn't directly before one or more ignored
// nodes.
function skipIgnoredNodesRight(view) {
  var sel = view.root.getSelection();
  var node = sel.focusNode, offset = sel.focusOffset;
  if (!node) { return }
  var len = nodeLen(node);
  var moveNode, moveOffset;
  for (;;) {
    if (offset < len) {
      if (node.nodeType != 1) { break }
      var after = node.childNodes[offset];
      if (isIgnorable(after)) {
        moveNode = node;
        moveOffset = ++offset;
      }
      else { break }
    } else if (isBlockNode(node)) {
      break
    } else {
      var next = node.nextSibling;
      while (next && isIgnorable(next)) {
        moveNode = next.parentNode;
        moveOffset = domIndex(next) + 1;
        next = next.nextSibling;
      }
      if (!next) {
        node = node.parentNode;
        if (node == view.dom) { break }
        offset = len = 0;
      } else {
        node = next;
        offset = 0;
        len = nodeLen(node);
      }
    }
  }
  if (moveNode) { setSelFocus(view, sel, moveNode, moveOffset); }
}

function isBlockNode(dom) {
  var desc = dom.pmViewDesc;
  return desc && desc.node && desc.node.isBlock
}

function setSelFocus(view, sel, node, offset) {
  if (selectionCollapsed(sel)) {
    var range = document.createRange();
    range.setEnd(node, offset);
    range.setStart(node, offset);
    sel.removeAllRanges();
    sel.addRange(range);
  } else if (sel.extend) {
    sel.extend(node, offset);
  }
  view.selectionReader.storeDOMState(view.selection);
}

// : (EditorState, number)
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function selectVertically(view, dir) {
  var sel = view.state.selection;
  if (sel instanceof prosemirrorState.TextSelection && !sel.empty) { return false }
  var $from = sel.$from;
  var $to = sel.$to;

  if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
    var next = moveSelectionBlock(view.state, dir);
    if (next && (next instanceof prosemirrorState.NodeSelection))
      { return apply(view, next) }
  }
  if (!$from.parent.inlineContent) {
    var beyond = prosemirrorState.Selection.findFrom(dir < 0 ? $from : $to, dir);
    return beyond ? apply(view, beyond) : true
  }
  return false
}

function stopNativeHorizontalDelete(view, dir) {
  if (!(view.state.selection instanceof prosemirrorState.TextSelection)) { return true }
  var ref = view.state.selection;
  var $head = ref.$head;
  var $anchor = ref.$anchor;
  var empty = ref.empty;
  if (!$head.sameParent($anchor)) { return true }
  if (!empty) { return false }
  if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) { return true }
  var nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
  if (nextNode && !nextNode.isText) {
    var tr = view.state.tr;
    if (dir < 0) { tr.delete($head.pos - nextNode.nodeSize, $head.pos); }
    else { tr.delete($head.pos, $head.pos + nextNode.nodeSize); }
    view.dispatch(tr);
    return true
  }
  return false
}

function switchEditable(view, node, state) {
  view.domObserver.stop();
  node.contentEditable = state;
  view.domObserver.start();
}

// Issue #867 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Chrome does really wrong things when the down arrow is
// pressed when the cursor is directly at the start of a textblock and
// has an uneditable node after it
function chromeDownArrowBug(view) {
  if (!result.chrome || view.state.selection.$head.parentOffset > 0) { return }
  var ref = view.root.getSelection();
  var focusNode = ref.focusNode;
  var focusOffset = ref.focusOffset;
  if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 &&
      focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
    var child = focusNode.firstChild;
    switchEditable(view, child, true);
    setTimeout(function () { return switchEditable(view, child, false); }, 20);
  }
}

// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.

function getMods(event) {
  var result$$1 = "";
  if (event.ctrlKey) { result$$1 += "c"; }
  if (event.metaKey) { result$$1 += "m"; }
  if (event.altKey) { result$$1 += "a"; }
  if (event.shiftKey) { result$$1 += "s"; }
  return result$$1
}

function captureKeyDown(view, event) {
  var code = event.keyCode, mods = getMods(event);
  if (code == 8 || (result.mac && code == 72 && mods == "c")) { // Backspace, Ctrl-h on Mac
    return stopNativeHorizontalDelete(view, -1) || skipIgnoredNodesLeft(view)
  } else if (code == 46 || (result.mac && code == 68 && mods == "c")) { // Delete, Ctrl-d on Mac
    return stopNativeHorizontalDelete(view, 1) || skipIgnoredNodesRight(view)
  } else if (code == 13 || code == 27) { // Enter, Esc
    return true
  } else if (code == 37) { // Left arrow
    return selectHorizontally(view, -1) || skipIgnoredNodesLeft(view)
  } else if (code == 39) { // Right arrow
    return selectHorizontally(view, 1) || skipIgnoredNodesRight(view)
  } else if (code == 38) { // Up arrow
    return selectVertically(view, -1) || skipIgnoredNodesLeft(view)
  } else if (code == 40) { // Down arrow
    return chromeDownArrowBug(view) || selectVertically(view, 1) || skipIgnoredNodesRight(view)
  } else if (mods == (result.mac ? "m" : "c") &&
             (code == 66 || code == 73 || code == 89 || code == 90)) { // Mod-[biyz]
    return true
  }
  return false
}

var TrackedRecord = function TrackedRecord(prev, mapping, state) {
  this.prev = prev;
  this.mapping = mapping;
  this.state = state;
};

var TrackMappings = function TrackMappings(state) {
  this.seen = [new TrackedRecord(null, null, state)];
  // Kludge to listen to state changes globally in order to be able
  // to find mappings from a given state to another.
  prosemirrorState.EditorState.addApplyListener(this.track = this.track.bind(this));
};

TrackMappings.prototype.destroy = function destroy () {
  prosemirrorState.EditorState.removeApplyListener(this.track);
};

TrackMappings.prototype.find = function find (state) {
    var this$1 = this;

  for (var i = this.seen.length - 1; i >= 0; i--) {
    var record = this$1.seen[i];
    if (record.state == state) { return record }
  }
};

TrackMappings.prototype.track = function track (old, tr, state) {
  var found = this.seen.length < 200 ? this.find(old) : null;
  if (found)
    { this.seen.push(new TrackedRecord(found, tr.docChanged ? tr.mapping : null, state)); }
};

TrackMappings.prototype.getMapping = function getMapping (state, appendTo) {
  var found = this.find(state);
  if (!found) { return null }
  var mappings = [];
  for (var rec = found; rec; rec = rec.prev)
    { if (rec.mapping) { mappings.push(rec.mapping); } }
  var result = appendTo || new prosemirrorTransform.Mapping;
  for (var i = mappings.length - 1; i >= 0; i--)
    { result.appendMapping(mappings[i]); }
  return result
};

// Track the state of the DOM selection, creating transactions to
// update the selection state when necessary.
var SelectionReader = function SelectionReader(view) {
  var this$1 = this;

  this.view = view;

  // Track the state of the DOM selection.
  this.lastAnchorNode = this.lastHeadNode = this.lastAnchorOffset = this.lastHeadOffset = null;
  this.lastSelection = view.state.selection;
  this.ignoreUpdates = false;
  this.suppressUpdates = false;
  this.poller = poller(this);

  this.focusFunc = (function () { return this$1.poller.start(hasFocusAndSelection(this$1.view)); }).bind(this);
  this.blurFunc = this.poller.stop;

  view.dom.addEventListener("focus", this.focusFunc);
  view.dom.addEventListener("blur", this.blurFunc);

  if (!view.editable) { this.poller.start(false); }
};

SelectionReader.prototype.destroy = function destroy () {
  this.view.dom.removeEventListener("focus", this.focusFunc);
  this.view.dom.removeEventListener("blur", this.blurFunc);
  this.poller.stop();
};

SelectionReader.prototype.poll = function poll (origin) { this.poller.poll(origin); };

SelectionReader.prototype.editableChanged = function editableChanged () {
  if (!this.view.editable) { this.poller.start(); }
  else if (!hasFocusAndSelection(this.view)) { this.poller.stop(); }
};

// : () → bool
// Whether the DOM selection has changed from the last known state.
SelectionReader.prototype.domChanged = function domChanged () {
  var sel = this.view.root.getSelection();
  return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset ||
    sel.focusNode != this.lastHeadNode || sel.focusOffset != this.lastHeadOffset
};

// Store the current state of the DOM selection.
SelectionReader.prototype.storeDOMState = function storeDOMState (selection) {
  var sel = this.view.root.getSelection();
  this.lastAnchorNode = sel.anchorNode; this.lastAnchorOffset = sel.anchorOffset;
  this.lastHeadNode = sel.focusNode; this.lastHeadOffset = sel.focusOffset;
  this.lastSelection = selection;
};

SelectionReader.prototype.clearDOMState = function clearDOMState () {
  this.lastAnchorNode = this.lastSelection = null;
};

// : (?string)
// When the DOM selection changes in a notable manner, modify the
// current selection state to match.
SelectionReader.prototype.readFromDOM = function readFromDOM (origin) {
  if (this.ignoreUpdates || !this.domChanged() || !hasFocusAndSelection(this.view)) { return }
  if (this.suppressUpdates) { return selectionToDOM(this.view) }
  if (!this.view.inDOMChange) { this.view.domObserver.flush(); }
  if (this.view.inDOMChange) { return }

  var domSel = this.view.root.getSelection(), doc = this.view.state.doc;
  var nearestDesc = this.view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
  var head = this.view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset);
  var $head = doc.resolve(head), $anchor, selection;
  if (selectionCollapsed(domSel)) {
    $anchor = $head;
    while (nearestDesc && !nearestDesc.node) { nearestDesc = nearestDesc.parent; }
    if (nearestDesc && nearestDesc.node.isAtom && prosemirrorState.NodeSelection.isSelectable(nearestDesc.node) && nearestDesc.parent) {
      var pos = nearestDesc.posBefore;
      selection = new prosemirrorState.NodeSelection(head == pos ? $head : doc.resolve(pos));
    }
  } else {
    $anchor = doc.resolve(this.view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset));
  }

  if (!selection) {
    var bias = origin == "pointer" || (this.view.state.selection.head < $head.pos && !inWidget) ? 1 : -1;
    selection = selectionBetween(this.view, $anchor, $head, bias);
  }
  if (!this.view.state.selection.eq(selection)) {
    var tr = this.view.state.tr.setSelection(selection);
    if (origin == "pointer") { tr.setMeta("pointer", true); }
    else if (origin == "key") { tr.scrollIntoView(); }
    this.view.dispatch(tr);
  } else {
    selectionToDOM(this.view);
  }
};

// There's two polling models. On browsers that support the
// selectionchange event (everything except Firefox < 52, basically), we
// register a listener for that whenever the editor is focused.
var SelectionChangePoller = function SelectionChangePoller(reader) {
  var this$1 = this;

  this.listening = false;
  this.curOrigin = null;
  this.originTime = 0;
  this.reader = reader;

  this.readFunc = function () { return reader.readFromDOM(this$1.originTime > Date.now() - 50 ? this$1.curOrigin : null); };
};

SelectionChangePoller.prototype.poll = function poll (origin) {
  this.curOrigin = origin;
  this.originTime = Date.now();
};

SelectionChangePoller.prototype.start = function start (andRead) {
  if (!this.listening) {
    var doc = this.reader.view.dom.ownerDocument;
    doc.addEventListener("selectionchange", this.readFunc);
    this.listening = true;
    if (andRead) { this.readFunc(); }
  }
};

SelectionChangePoller.prototype.stop = function stop () {
  if (this.listening) {
    var doc = this.reader.view.dom.ownerDocument;
    doc.removeEventListener("selectionchange", this.readFunc);
    this.listening = false;
  }
};

// On Browsers that don't support the selectionchange event,
// we use timeout-based polling.
var TimeoutPoller = function TimeoutPoller(reader) {
  // The timeout ID for the poller when active.
  this.polling = null;
  this.reader = reader;
  this.pollFunc = this.doPoll.bind(this, null);
};

TimeoutPoller.prototype.doPoll = function doPoll (origin) {
  var view = this.reader.view;
  if (view.focused || !view.editable) {
    this.reader.readFromDOM(origin);
    this.polling = setTimeout(this.pollFunc, 100);
  } else {
    this.polling = null;
  }
};

TimeoutPoller.prototype.poll = function poll (origin) {
  clearTimeout(this.polling);
  this.polling = setTimeout(origin ? this.doPoll.bind(this, origin) : this.pollFunc, 0);
};

TimeoutPoller.prototype.start = function start () {
  if (this.polling == null) { this.poll(); }
};

TimeoutPoller.prototype.stop = function stop () {
  clearTimeout(this.polling);
  this.polling = null;
};

function poller(reader) {
  return new ("onselectionchange" in document ? SelectionChangePoller : TimeoutPoller)(reader)
}

function selectionToDOM(view, takeFocus, force) {
  var sel = view.state.selection;
  syncNodeSelection(view, sel);

  if (view.editable && !view.hasFocus()) {
    if (!takeFocus) { return }
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444
    if (result.gecko && result.gecko_version <= 55) {
      view.selectionReader.ignoreUpdates = true;
      view.dom.focus();
      view.selectionReader.ignoreUpdates = false;
    }
  } else if (!view.editable && !hasSelection(view) && !takeFocus) {
    return
  }

  var reader = view.selectionReader;
  if (reader.lastSelection && reader.lastSelection.eq(sel) && !reader.domChanged()) { return }

  reader.ignoreUpdates = true;

  if (view.cursorWrapper) {
    selectCursorWrapper(view);
  } else {
    var anchor = sel.anchor;
    var head = sel.head;
    var resetEditableFrom, resetEditableTo;
    if (brokenSelectBetweenUneditable && !(sel instanceof prosemirrorState.TextSelection)) {
      if (!sel.$from.parent.inlineContent)
        { resetEditableFrom = temporarilyEditableNear(view, sel.from); }
      if (!sel.empty && !sel.$from.parent.inlineContent)
        { resetEditableTo = temporarilyEditableNear(view, sel.to); }
    }
    view.docView.setSelection(anchor, head, view.root, force);
    if (brokenSelectBetweenUneditable) {
      if (resetEditableFrom) { resetEditableFrom.contentEditable = "false"; }
      if (resetEditableTo) { resetEditableTo.contentEditable = "false"; }
    }
    if (sel.visible) {
      view.dom.classList.remove("ProseMirror-hideselection");
    } else if (anchor != head) {
      view.dom.classList.add("ProseMirror-hideselection");
      if ("onselectionchange" in document) { removeClassOnSelectionChange(view); }
    }
  }

  reader.storeDOMState(sel);
  reader.ignoreUpdates = false;
}

// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.

var brokenSelectBetweenUneditable = result.safari || result.chrome && result.chrome_version < 63;

function temporarilyEditableNear(view, pos) {
  var ref = view.docView.domFromPos(pos);
  var node = ref.node;
  var offset = ref.offset;
  var after = offset < node.childNodes.length ? node.childNodes[offset] : null;
  var before = offset ? node.childNodes[offset - 1] : null;
  if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
    if (after) {
      after.contentEditable = "true";
      return after
    } else if (before) {
      before.contentEditable = "true";
      return before
    }
  }
}

function removeClassOnSelectionChange(view) {
  var doc = view.dom.ownerDocument;
  doc.removeEventListener("selectionchange", view.hideSelectionGuard);
  var domSel = view.root.getSelection();
  var node = domSel.anchorNode, offset = domSel.anchorOffset;
  doc.addEventListener("selectionchange", view.hideSelectionGuard = function () {
    if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
      doc.removeEventListener("selectionchange", view.hideSelectionGuard);
      view.dom.classList.remove("ProseMirror-hideselection");
    }
  });
}

function selectCursorWrapper(view) {
  var domSel = view.root.getSelection(), range = document.createRange();
  var node = view.cursorWrapper.dom;
  range.setEnd(node, node.childNodes.length);
  range.collapse(false);
  domSel.removeAllRanges();
  domSel.addRange(range);
  // Kludge to kill 'control selection' in IE11 when selecting an
  // invisible cursor wrapper, since that would result in those weird
  // resize handles and a selection that considers the absolutely
  // positioned wrapper, rather than the root editable node, the
  // focused element.
  if (!view.state.selection.visible && result.ie && result.ie_version <= 11) {
    node.disabled = true;
    node.disabled = false;
  }
}

function syncNodeSelection(view, sel) {
  if (sel instanceof prosemirrorState.NodeSelection) {
    var desc = view.docView.descAt(sel.from);
    if (desc != view.lastSelectedViewDesc) {
      clearNodeSelection(view);
      if (desc) { desc.selectNode(); }
      view.lastSelectedViewDesc = desc;
    }
  } else {
    clearNodeSelection(view);
  }
}

// Clear all DOM statefulness of the last node selection.
function clearNodeSelection(view) {
  if (view.lastSelectedViewDesc) {
    view.lastSelectedViewDesc.deselectNode();
    view.lastSelectedViewDesc = null;
  }
}

function selectionBetween(view, $anchor, $head, bias) {
  return view.someProp("createSelectionBetween", function (f) { return f(view, $anchor, $head); })
    || prosemirrorState.TextSelection.between($anchor, $head, bias)
}

function hasFocusAndSelection(view) {
  if (view.editable && view.root.activeElement != view.dom) { return false }
  return hasSelection(view)
}

function hasSelection(view) {
  var sel = view.root.getSelection();
  if (!sel.anchorNode) { return false }
  try {
    // Firefox will raise 'permission denied' errors when accessing
    // properties of `sel.anchorNode` when it's in a generated CSS
    // element.
    return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) &&
      (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode))
  } catch(_) {
    return false
  }
}

function nonInclusiveMark(mark) {
  return mark.type.spec.inclusive === false
}

function needsCursorWrapper(state) {
  var ref = state.selection;
  var $head = ref.$head;
  var $anchor = ref.$anchor;
  var visible = ref.visible;
  var $pos = $head.pos == $anchor.pos && (!visible || $head.parent.inlineContent) ? $head : null;
  if ($pos && (!visible || state.storedMarks || $pos.parent.content.length == 0 ||
               $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.some(nonInclusiveMark)))
    { return $pos }
  else
    { return null }
}

var DOMChange = function DOMChange(view, composing) {
  var this$1 = this;

  this.view = view;
  this.state = view.state;
  this.composing = composing;
  this.from = this.to = null;
  this.typeOver = false;
  this.timeout = composing ? null : setTimeout(function () { return this$1.finish(); }, DOMChange.commitTimeout);
  this.trackMappings = new TrackMappings(view.state);

  // If there have been changes since this DOM update started, we must
  // map our start and end positions, as well as the new selection
  // positions, through them. This tracks that mapping.
  this.mapping = new prosemirrorTransform.Mapping;
  this.mappingTo = view.state;
};

DOMChange.prototype.addRange = function addRange (from, to) {
  if (this.from == null) {
    this.from = from;
    this.to = to;
  } else {
    this.from = Math.min(from, this.from);
    this.to = Math.max(to, this.to);
  }
};

DOMChange.prototype.changedRange = function changedRange () {
  if (this.from == null) { return rangeAroundSelection(this.state.selection) }
  var $from = this.state.doc.resolve(Math.min(this.from, this.state.selection.from)), $to = this.state.doc.resolve(this.to);
  var shared = $from.sharedDepth(this.to);
  return {from: $from.before(shared + 1), to: $to.after(shared + 1)}
};

DOMChange.prototype.markDirty = function markDirty (range) {
  if (this.from == null) { this.view.docView.markDirty((range = range || this.changedRange()).from, range.to); }
  else { this.view.docView.markDirty(this.from, this.to); }
};

DOMChange.prototype.stateUpdated = function stateUpdated (state) {
  if (this.trackMappings.getMapping(state, this.mapping)) {
    this.trackMappings.destroy();
    this.trackMappings = new TrackMappings(state);
    this.mappingTo = state;
    return true
  } else {
    this.markDirty();
    this.destroy();
    return false
  }
};

DOMChange.prototype.finish = function finish (force) {
  clearTimeout(this.timeout);
  if (this.composing && !force) { return }
  this.view.domObserver.flush();
  var range = this.changedRange();
  this.markDirty(range);

  this.destroy();
  var sel = this.state.selection, allowTypeOver = this.typeOver && sel instanceof prosemirrorState.TextSelection &&
      !sel.empty && sel.$head.sameParent(sel.$anchor);
  readDOMChange(this.view, this.mapping, this.state, range, allowTypeOver);

  // If the reading didn't result in a view update, force one by
  // resetting the view to its current state.
  if (this.view.docView.dirty) { this.view.updateState(this.view.state); }
};

DOMChange.prototype.destroy = function destroy () {
  clearTimeout(this.timeout);
  this.trackMappings.destroy();
  this.view.inDOMChange = null;
};

DOMChange.prototype.compositionEnd = function compositionEnd () {
    var this$1 = this;

  if (this.composing) {
    this.composing = false;
    this.timeout = setTimeout(function () { return this$1.finish(); }, 50);
  }
};

DOMChange.start = function start (view, composing) {
  if (view.inDOMChange) {
    if (composing) {
      clearTimeout(view.inDOMChange.timeout);
      view.inDOMChange.composing = true;
    }
  } else {
    view.inDOMChange = new DOMChange(view, composing);
  }
  return view.inDOMChange
};
DOMChange.commitTimeout = 20;

// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.

function parseBetween(view, oldState, range) {
  var ref = view.docView.parseRange(range.from, range.to);
  var parent = ref.node;
  var fromOffset = ref.fromOffset;
  var toOffset = ref.toOffset;
  var from = ref.from;
  var to = ref.to;

  var domSel = view.root.getSelection(), find = null, anchor = domSel.anchorNode;
  if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
    find = [{node: anchor, offset: domSel.anchorOffset}];
    if (!selectionCollapsed(domSel))
      { find.push({node: domSel.focusNode, offset: domSel.focusOffset}); }
  }
  // Work around issue in Chrome where backspacing sometimes replaces
  // the deleted content with a random BR node (issues #799, #831)
  if (result.chrome && view.lastKeyCode === 8) {
    for (var off = toOffset; off > fromOffset; off--) {
      var node = parent.childNodes[off - 1], desc = node.pmViewDesc;
      if (node.nodeType == "BR" && !desc) { toOffset = off; break }
      if (!desc || desc.size) { break }
    }
  }
  var startDoc = oldState.doc;
  var parser = view.someProp("domParser") || prosemirrorModel.DOMParser.fromSchema(view.state.schema);
  var $from = startDoc.resolve(from);
  var sel = null, doc = parser.parse(parent, {
    topNode: $from.parent,
    topMatch: $from.parent.contentMatchAt($from.index()),
    topOpen: true,
    from: fromOffset,
    to: toOffset,
    preserveWhitespace: $from.parent.type.spec.code ? "full" : true,
    editableContent: true,
    findPositions: find,
    ruleFromNode: ruleFromNode(parser, $from),
    context: $from
  });
  if (find && find[0].pos != null) {
    var anchor$1 = find[0].pos, head = find[1] && find[1].pos;
    if (head == null) { head = anchor$1; }
    sel = {anchor: anchor$1 + from, head: head + from};
  }
  return {doc: doc, sel: sel, from: from, to: to}
}

function ruleFromNode(parser, context) {
  return function (dom) {
    var desc = dom.pmViewDesc;
    if (desc) {
      return desc.parseRule()
    } else if (dom.nodeName == "BR" && dom.parentNode) {
      // Safari replaces the list item or table cell with a BR
      // directly in the list node (?!) if you delete the last
      // character in a list item or table cell (#708, #862)
      if (result.safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName))
        { return parser.matchTag(document.createElement("li"), context) }
      else if (dom.parentNode.lastChild == dom || result.safari && /^(tr|table)$/i.test(dom.parentNode.nodeName))
        { return {ignore: true} }
    }
  }
}

function isAtEnd($pos, depth) {
  for (var i = depth || 0; i < $pos.depth; i++)
    { if ($pos.index(i) + 1 < $pos.node(i).childCount) { return false } }
  return $pos.parentOffset == $pos.parent.content.size
}
function isAtStart($pos, depth) {
  for (var i = depth || 0; i < $pos.depth; i++)
    { if ($pos.index(0) > 0) { return false } }
  return $pos.parentOffset == 0
}

function rangeAroundSelection(selection) {
  // Intentionally uses $head/$anchor because those will correspond to the DOM selection
  var $from = selection.$anchor.min(selection.$head), $to = selection.$anchor.max(selection.$head);

  if ($from.sameParent($to) && $from.parent.inlineContent && $from.parentOffset && $to.parentOffset < $to.parent.content.size) {
    var startOff = Math.max(0, $from.parentOffset);
    var size = $from.parent.content.size;
    var endOff = Math.min(size, $to.parentOffset);

    if (startOff > 0)
      { startOff = $from.parent.childBefore(startOff).offset; }
    if (endOff < size) {
      var after = $from.parent.childAfter(endOff);
      endOff = after.offset + after.node.nodeSize;
    }
    var nodeStart = $from.start();
    return {from: nodeStart + startOff, to: nodeStart + endOff}
  } else {
    for (var depth = 0;; depth++) {
      var fromStart = isAtStart($from, depth + 1), toEnd = isAtEnd($to, depth + 1);
      if (fromStart || toEnd || $from.index(depth) != $to.index(depth) || $to.node(depth).isTextblock) {
        var from = $from.before(depth + 1), to = $to.after(depth + 1);
        if (fromStart && $from.index(depth) > 0)
          { from -= $from.node(depth).child($from.index(depth) - 1).nodeSize; }
        if (toEnd && $to.index(depth) + 1 < $to.node(depth).childCount)
          { to += $to.node(depth).child($to.index(depth) + 1).nodeSize; }
        return {from: from, to: to}
      }
    }
  }
}

function keyEvent(keyCode, key) {
  var event = document.createEvent("Event");
  event.initEvent("keydown", true, true);
  event.keyCode = keyCode;
  event.key = event.code = key;
  return event
}

function readDOMChange(view, mapping, oldState, range, allowTypeOver) {
  var parse = parseBetween(view, oldState, range);

  var doc = oldState.doc, compare = doc.slice(parse.from, parse.to);
  var preferredPos, preferredSide;
  // Prefer anchoring to end when Backspace is pressed
  if (view.lastKeyCode === 8 && Date.now() - 100 < view.lastKeyCodeTime) {
    preferredPos = oldState.selection.to;
    preferredSide = "end";
  } else {
    preferredPos = oldState.selection.from;
    preferredSide = "start";
  }
  view.lastKeyCode = null;

  var change = findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
  if (!change) {
    if (allowTypeOver) {
      var state = view.state, sel = state.selection;
      view.dispatch(state.tr.replaceSelectionWith(state.schema.text(state.doc.textBetween(sel.from, sel.to)), true).scrollIntoView());
    } else if (parse.sel) {
      var sel$1 = resolveSelection(view, view.state.doc, mapping, parse.sel);
      if (sel$1 && !sel$1.eq(view.state.selection)) { view.dispatch(view.state.tr.setSelection(sel$1)); }
    }
    return
  }
  // Handle the case where overwriting a selection by typing matches
  // the start or end of the selected content, creating a change
  // that's smaller than what was actually overwritten.
  if (oldState.selection.from < oldState.selection.to &&
      change.start == change.endB &&
      oldState.selection instanceof prosemirrorState.TextSelection) {
    if (change.start > oldState.selection.from && change.start <= oldState.selection.from + 2) {
      change.start = oldState.selection.from;
    } else if (change.endA < oldState.selection.to && change.endA >= oldState.selection.to - 2) {
      change.endB += (oldState.selection.to - change.endA);
      change.endA = oldState.selection.to;
    }
  }

  var $from = parse.doc.resolveNoCache(change.start - parse.from);
  var $to = parse.doc.resolveNoCache(change.endB - parse.from);
  var nextSel;
  // If this looks like the effect of pressing Enter, just dispatch an
  // Enter key instead.
  if (!$from.sameParent($to) && $from.pos < parse.doc.content.size &&
      (nextSel = prosemirrorState.Selection.findFrom(parse.doc.resolve($from.pos + 1), 1, true)) &&
      nextSel.head == $to.pos &&
      view.someProp("handleKeyDown", function (f) { return f(view, keyEvent(13, "Enter")); }))
    { return }
  // Same for backspace
  if (oldState.selection.anchor > change.start &&
      looksLikeJoin(doc, change.start, change.endA, $from, $to) &&
      view.someProp("handleKeyDown", function (f) { return f(view, keyEvent(8, "Backspace")); })) {
    if (result.android && result.chrome) { // #820
      view.selectionReader.suppressUpdates = true;
      setTimeout(function () { return view.selectionReader.suppressUpdates = false; }, 50);
    }
    return
  }

  var from = mapping.map(change.start), to = mapping.map(change.endA, -1);

  var tr, storedMarks, markChange, $from1;
  if ($from.sameParent($to) && $from.parent.inlineContent) {
    if ($from.pos == $to.pos) { // Deletion
      tr = view.state.tr.delete(from, to);
      storedMarks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
    } else if ( // Adding or removing a mark
      change.endA == change.endB && ($from1 = doc.resolve(change.start)) &&
      (markChange = isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset),
                                 $from1.parent.content.cut($from1.parentOffset, change.endA - $from1.start())))
    ) {
      tr = view.state.tr;
      if (markChange.type == "add") { tr.addMark(from, to, markChange.mark); }
      else { tr.removeMark(from, to, markChange.mark); }
    } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
      // Both positions in the same text node -- simply insert text
      var text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
      if (view.someProp("handleTextInput", function (f) { return f(view, from, to, text); })) { return }
      tr = view.state.tr.insertText(text, from, to);
    }
  }

  if (!tr)
    { tr = view.state.tr.replace(from, to, parse.doc.slice(change.start - parse.from, change.endB - parse.from)); }
  if (parse.sel) {
    var sel$2 = resolveSelection(view, tr.doc, mapping, parse.sel);
    if (sel$2) { tr.setSelection(sel$2); }
  }
  if (storedMarks) { tr.ensureMarks(storedMarks); }
  view.dispatch(tr.scrollIntoView());
}

function resolveSelection(view, doc, mapping, parsedSel) {
  if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) { return null }
  return selectionBetween(view, doc.resolve(mapping.map(parsedSel.anchor)),
                          doc.resolve(mapping.map(parsedSel.head)))
}

// : (Fragment, Fragment) → ?{mark: Mark, type: string}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function isMarkChange(cur, prev) {
  var curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
  var added = curMarks, removed = prevMarks, type, mark, update;
  for (var i = 0; i < prevMarks.length; i++) { added = prevMarks[i].removeFromSet(added); }
  for (var i$1 = 0; i$1 < curMarks.length; i$1++) { removed = curMarks[i$1].removeFromSet(removed); }
  if (added.length == 1 && removed.length == 0) {
    mark = added[0];
    type = "add";
    update = function (node) { return node.mark(mark.addToSet(node.marks)); };
  } else if (added.length == 0 && removed.length == 1) {
    mark = removed[0];
    type = "remove";
    update = function (node) { return node.mark(mark.removeFromSet(node.marks)); };
  } else {
    return null
  }
  var updated = [];
  for (var i$2 = 0; i$2 < prev.childCount; i$2++) { updated.push(update(prev.child(i$2))); }
  if (prosemirrorModel.Fragment.from(updated).eq(cur)) { return {mark: mark, type: type} }
}

function looksLikeJoin(old, start, end, $newStart, $newEnd) {
  if (!$newStart.parent.isTextblock ||
      // The content must have shrunk
      end - start <= $newEnd.pos - $newStart.pos ||
      // newEnd must point directly at or after the end of the block that newStart points into
      skipClosingAndOpening($newStart, true, false) < $newEnd.pos)
    { return false }

  var $start = old.resolve(start);
  // Start must be at the end of a block
  if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock)
    { return false }
  var $next = old.resolve(skipClosingAndOpening($start, true, true));
  // The next textblock must start before end and end near it
  if (!$next.parent.isTextblock || $next.pos > end ||
      skipClosingAndOpening($next, true, false) < end)
    { return false }

  // The fragments after the join point must match
  return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content)
}

function skipClosingAndOpening($pos, fromEnd, mayOpen) {
  var depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
  while (depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)) {
    depth--;
    end++;
    fromEnd = false;
  }
  if (mayOpen) {
    var next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
    while (next && !next.isLeaf) {
      next = next.firstChild;
      end++;
    }
  }
  return end
}

function findDiff(a, b, pos, preferredPos, preferredSide) {
  var start = a.findDiffStart(b, pos);
  if (start == null) { return null }
  var ref = a.findDiffEnd(b, pos + a.size, pos + b.size);
  var endA = ref.a;
  var endB = ref.b;
  if (preferredSide == "end") {
    var adjust = Math.max(0, start - Math.min(endA, endB));
    preferredPos -= endA + adjust - start;
  }
  if (endA < start && a.size < b.size) {
    var move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
    start -= move;
    endB = start + (endB - endA);
    endA = start;
  } else if (endB < start) {
    var move$1 = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
    start -= move$1;
    endA = start + (endA - endB);
    endB = start;
  }
  return {start: start, endA: endA, endB: endB}
}

function serializeForClipboard(view, slice) {
  var context = [];
  var content = slice.content;
  var openStart = slice.openStart;
  var openEnd = slice.openEnd;
  while (openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1) {
    openStart--;
    openEnd--;
    var node = content.firstChild;
    context.push(node.type.name, node.type.hasRequiredAttrs() ? node.attrs : null);
    content = node.content;
  }

  var serializer = view.someProp("clipboardSerializer") || prosemirrorModel.DOMSerializer.fromSchema(view.state.schema);
  var wrap = document.createElement("div");
  wrap.appendChild(serializer.serializeFragment(content));

  var firstChild = wrap.firstChild, needsWrap;
  while (firstChild && firstChild.nodeType == 1 && (needsWrap = wrapMap[firstChild.nodeName.toLowerCase()])) {
    for (var i = needsWrap.length - 1; i >= 0; i--) {
      var wrapper = document.createElement(needsWrap[i]);
      while (wrap.firstChild) { wrapper.appendChild(wrap.firstChild); }
      wrap.appendChild(wrapper);
    }
    firstChild = wrap.firstChild;
  }

  if (firstChild && firstChild.nodeType == 1)
    { firstChild.setAttribute("data-pm-slice", (openStart + " " + openEnd + " " + (JSON.stringify(context)))); }

  var text = view.someProp("clipboardTextSerializer", function (f) { return f(slice); }) ||
      slice.content.textBetween(0, slice.content.size, "\n\n");

  return {dom: wrap, text: text}
}

// : (EditorView, string, string, ?bool, ResolvedPos) → ?Slice
// Read a slice of content from the clipboard (or drop data).
function parseFromClipboard(view, text, html, plainText, $context) {
  var dom, inCode = $context.parent.type.spec.code, slice;
  if (!html && !text) { return null }
  var asText = text && (plainText || inCode || !html);
  if (asText) {
    view.someProp("transformPastedText", function (f) { text = f(text); });
    if (inCode) { return new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(view.state.schema.text(text)), 0, 0) }
    var parsed = view.someProp("clipboardTextParser", function (f) { return f(text, $context); });
    if (parsed) {
      slice = parsed;
    } else {
      dom = document.createElement("div");
      text.trim().split(/(?:\r\n?|\n)+/).forEach(function (block) {
        dom.appendChild(document.createElement("p")).textContent = block;
      });
    }
  } else {
    view.someProp("transformPastedHTML", function (f) { return html = f(html); });
    dom = readHTML(html);
  }

  var contextNode = dom && dom.querySelector("[data-pm-slice]");
  var sliceData = contextNode && /^(\d+) (\d+) (.*)/.exec(contextNode.getAttribute("data-pm-slice"));
  if (!slice) {
    var parser = view.someProp("clipboardParser") || view.someProp("domParser") || prosemirrorModel.DOMParser.fromSchema(view.state.schema);
    slice = parser.parseSlice(dom, {preserveWhitespace: !!(asText || sliceData), context: $context});
  }
  if (sliceData)
    { slice = addContext(new prosemirrorModel.Slice(slice.content, Math.min(slice.openStart, +sliceData[1]),
                                 Math.min(slice.openEnd, +sliceData[2])), sliceData[3]); }
  else // HTML wasn't created by ProseMirror. Make sure top-level siblings are coherent
    { slice = prosemirrorModel.Slice.maxOpen(normalizeSiblings(slice.content, $context), false); }
  view.someProp("transformPasted", function (f) { slice = f(slice); });
  return slice
}

// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function normalizeSiblings(fragment, $context) {
  if (fragment.childCount < 2) { return fragment }
  var loop = function ( d ) {
    var parent = $context.node(d);
    var match = parent.contentMatchAt($context.index(d));
    var lastWrap = (void 0), result = [];
    fragment.forEach(function (node) {
      if (!result) { return }
      var wrap = match.findWrapping(node.type), inLast;
      if (!wrap) { return result = null }
      if (inLast = result.length && lastWrap.length && addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) {
        result[result.length - 1] = inLast;
      } else {
        if (result.length) { result[result.length - 1] = closeRight(result[result.length - 1], lastWrap.length); }
        var wrapped = withWrappers(node, wrap);
        result.push(wrapped);
        match = match.matchType(wrapped.type, wrapped.attrs);
        lastWrap = wrap;
      }
    });
    if (result) { return { v: prosemirrorModel.Fragment.from(result) } }
  };

  for (var d = $context.depth; d >= 0; d--) {
    var returned = loop( d );

    if ( returned ) return returned.v;
  }
  return fragment
}

function withWrappers(node, wrap, from) {
  if ( from === void 0 ) from = 0;

  for (var i = wrap.length - 1; i >= from; i--)
    { node = wrap[i].create(null, prosemirrorModel.Fragment.from(node)); }
  return node
}

// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function addToSibling(wrap, lastWrap, node, sibling, depth) {
  if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
    var inner = addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
    if (inner) { return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner)) }
    var match = sibling.contentMatchAt(sibling.childCount);
    if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1]))
      { return sibling.copy(sibling.content.append(prosemirrorModel.Fragment.from(withWrappers(node, wrap, depth + 1)))) }
  }
}

function closeRight(node, depth) {
  if (depth == 0) { return node }
  var fragment = node.content.replaceChild(node.childCount - 1, closeRight(node.lastChild, depth - 1));
  var fill = node.contentMatchAt(node.childCount).fillBefore(prosemirrorModel.Fragment.empty, true);
  return node.copy(fragment.append(fill))
}

// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
var wrapMap = {thead: ["table"], colgroup: ["table"], col: ["table", "colgroup"],
                 tr: ["table", "tbody"], td: ["table", "tbody", "tr"], th: ["table", "tbody", "tr"]};
var detachedDoc = null;
function readHTML(html) {
  var metas = /(\s*<meta [^>]*>)*/.exec(html);
  if (metas) { html = html.slice(metas[0].length); }
  var doc = detachedDoc || (detachedDoc = document.implementation.createHTMLDocument("title"));
  var elt = doc.createElement("div");
  var firstTag = /(?:<meta [^>]*>)*<([a-z][^>\s]+)/i.exec(html), wrap, depth = 0;
  if (wrap = firstTag && wrapMap[firstTag[1].toLowerCase()]) {
    html = wrap.map(function (n) { return "<" + n + ">"; }).join("") + html + wrap.map(function (n) { return "</" + n + ">"; }).reverse().join("");
    depth = wrap.length;
  }
  elt.innerHTML = html;
  for (var i = 0; i < depth; i++) { elt = elt.firstChild; }
  return elt
}

function addContext(slice, context) {
  if (!slice.size) { return slice }
  var schema = slice.content.firstChild.type.schema, array;
  try { array = JSON.parse(context); }
  catch(e) { return slice }
  var content = slice.content;
  var openStart = slice.openStart;
  var openEnd = slice.openEnd;
  for (var i = array.length - 2; i >= 0; i -= 2) {
    var type = schema.nodes[array[i]];
    if (!type || type.hasRequiredAttrs()) { break }
    content = prosemirrorModel.Fragment.from(type.create(array[i + 1], content));
    openStart++; openEnd++;
  }
  return new prosemirrorModel.Slice(content, openStart, openEnd)
}

var observeOptions = {childList: true, characterData: true, attributes: true, subtree: true, characterDataOldValue: true};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
var useCharData = result.ie && result.ie_version <= 11;

var DOMObserver = function DOMObserver(view) {
  var this$1 = this;

  this.view = view;
  this.observer = window.MutationObserver &&
    new window.MutationObserver(function (mutations) { return this$1.registerMutations(mutations); });
  if (useCharData)
    { this.onCharData = function (e) { return this$1.registerMutation({target: e.target, type: "characterData", oldValue: e.prevValue}); }; }
};

DOMObserver.prototype.start = function start () {
  if (this.observer)
    { this.observer.observe(this.view.dom, observeOptions); }
  if (useCharData)
    { this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData); }
};

DOMObserver.prototype.stop = function stop () {
  if (this.observer) {
    this.flush();
    this.observer.disconnect();
  }
  if (useCharData)
    { this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData); }
};

DOMObserver.prototype.flush = function flush () {
  if (this.observer)
    { this.registerMutations(this.observer.takeRecords()); }
};

DOMObserver.prototype.registerMutations = function registerMutations (mutations) {
    var this$1 = this;

  for (var i = 0; i < mutations.length; i++)
    { this$1.registerMutation(mutations[i]); }
};

DOMObserver.prototype.registerMutation = function registerMutation (mut) {
  if (!this.view.editable) { return }
  var desc = this.view.docView.nearestDesc(mut.target);
  if (mut.type == "attributes" &&
      (desc == this.view.docView || mut.attributeName == "contenteditable")) { return }
  if (!desc || desc.ignoreMutation(mut)) { return }

  var from, to;
  if (mut.type == "childList") {
    var fromOffset = mut.previousSibling && mut.previousSibling.parentNode == mut.target
        ? domIndex(mut.previousSibling) + 1 : 0;
    if (fromOffset == -1) { return }
    from = desc.localPosFromDOM(mut.target, fromOffset, -1);
    var toOffset = mut.nextSibling && mut.nextSibling.parentNode == mut.target
        ? domIndex(mut.nextSibling) : mut.target.childNodes.length;
    if (toOffset == -1) { return }
    to = desc.localPosFromDOM(mut.target, toOffset, 1);
  } else if (mut.type == "attributes") {
    from = desc.posAtStart - desc.border;
    to = desc.posAtEnd + desc.border;
  } else { // "characterData"
    from = desc.posAtStart;
    to = desc.posAtEnd;
    // An event was generated for a text change that didn't change
    // any text. Mark the dom change to fall back to assuming the
    // selection was typed over with an identical value if it can't
    // find another change.
    if (mut.target.nodeValue == mut.oldValue) { DOMChange.start(this.view).typeOver = true; }
  }

  DOMChange.start(this.view).addRange(from, to);
};

// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
var handlers = {};
var editHandlers = {};

function initInput(view) {
  view.shiftKey = false;
  view.mouseDown = null;
  view.inDOMChange = null;
  view.lastKeyCode = null;
  view.lastKeyCodeTime = 0;
  view.domObserver = new DOMObserver(view);
  view.domObserver.start();

  view.eventHandlers = Object.create(null);
  var loop = function ( event ) {
    var handler = handlers[event];
    view.dom.addEventListener(event, view.eventHandlers[event] = function (event) {
      if (eventBelongsToView(view, event) && !runCustomHandler(view, event) &&
          (view.editable || !(event.type in editHandlers)))
        { handler(view, event); }
    });
  };

  for (var event in handlers) loop( event );
  ensureListeners(view);
}

function destroyInput(view) {
  view.domObserver.stop();
  if (view.inDOMChange) { view.inDOMChange.destroy(); }
  for (var type in view.eventHandlers)
    { view.dom.removeEventListener(type, view.eventHandlers[type]); }
}

function ensureListeners(view) {
  view.someProp("handleDOMEvents", function (currentHandlers) {
    for (var type in currentHandlers) { if (!view.eventHandlers[type])
      { view.dom.addEventListener(type, view.eventHandlers[type] = function (event) { return runCustomHandler(view, event); }); } }
  });
}

function runCustomHandler(view, event) {
  return view.someProp("handleDOMEvents", function (handlers) {
    var handler = handlers[event.type];
    return handler ? handler(view, event) || event.defaultPrevented : false
  })
}

function eventBelongsToView(view, event) {
  if (!event.bubbles) { return true }
  if (event.defaultPrevented) { return false }
  for (var node = event.target; node != view.dom; node = node.parentNode)
    { if (!node || node.nodeType == 11 ||
        (node.pmViewDesc && node.pmViewDesc.stopEvent(event)))
      { return false } }
  return true
}

function dispatchEvent(view, event) {
  if (!runCustomHandler(view, event) && handlers[event.type] &&
      (view.editable || !(event.type in editHandlers)))
    { handlers[event.type](view, event); }
}

editHandlers.keydown = function (view, event) {
  view.shiftKey = event.keyCode == 16 || event.shiftKey;
  if (view.inDOMChange) {
    if (view.inDOMChange.composing) { return }
    view.inDOMChange.finish();
  }
  view.lastKeyCode = event.keyCode;
  view.lastKeyCodeTime = Date.now();
  if (view.someProp("handleKeyDown", function (f) { return f(view, event); }) || captureKeyDown(view, event))
    { event.preventDefault(); }
  else
    { view.selectionReader.poll("key"); }
};

editHandlers.keyup = function (view, e) {
  if (e.keyCode == 16) { view.shiftKey = false; }
};

editHandlers.keypress = function (view, event) {
  if (view.inDOMChange || !event.charCode ||
      event.ctrlKey && !event.altKey || result.mac && event.metaKey) { return }

  if (view.someProp("handleKeyPress", function (f) { return f(view, event); })) {
    event.preventDefault();
    return
  }

  var sel = view.state.selection;
  if (!(sel instanceof prosemirrorState.TextSelection) || !sel.$from.sameParent(sel.$to)) {
    var text = String.fromCharCode(event.charCode);
    if (!view.someProp("handleTextInput", function (f) { return f(view, sel.$from.pos, sel.$to.pos, text); }))
      { view.dispatch(view.state.tr.insertText(text).scrollIntoView()); }
    event.preventDefault();
  }
};

function eventCoords(event) { return {left: event.clientX, top: event.clientY} }

var lastClick = {time: 0, x: 0, y: 0, type: ""};

function isNear(event, click) {
  var dx = click.x - event.clientX, dy = click.y - event.clientY;
  return dx * dx + dy * dy < 100
}

function runHandlerOnContext(view, propName, pos, inside, event) {
  if (inside == -1) { return false }
  var $pos = view.state.doc.resolve(inside);
  var loop = function ( i ) {
    if (view.someProp(propName, function (f) { return i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true)
                                                    : f(view, pos, $pos.node(i), $pos.before(i), event, false); }))
      { return { v: true } }
  };

  for (var i = $pos.depth + 1; i > 0; i--) {
    var returned = loop( i );

    if ( returned ) return returned.v;
  }
  return false
}

function updateSelection(view, selection, origin) {
  if (!view.focused) { view.focus(); }
  var tr = view.state.tr.setSelection(selection);
  if (origin == "pointer") { tr.setMeta("pointer", true); }
  view.dispatch(tr);
}

function selectClickedLeaf(view, inside) {
  if (inside == -1) { return false }
  var $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
  if (node && node.isAtom && prosemirrorState.NodeSelection.isSelectable(node)) {
    updateSelection(view, new prosemirrorState.NodeSelection($pos), "pointer");
    return true
  }
  return false
}

function selectClickedNode(view, inside) {
  if (inside == -1) { return false }
  var sel = view.state.selection, selectedNode, selectAt;
  if (sel instanceof prosemirrorState.NodeSelection) { selectedNode = sel.node; }

  var $pos = view.state.doc.resolve(inside);
  for (var i = $pos.depth + 1; i > 0; i--) {
    var node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
    if (prosemirrorState.NodeSelection.isSelectable(node)) {
      if (selectedNode && sel.$from.depth > 0 &&
          i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos)
        { selectAt = $pos.before(sel.$from.depth); }
      else
        { selectAt = $pos.before(i); }
      break
    }
  }

  if (selectAt != null) {
    updateSelection(view, prosemirrorState.NodeSelection.create(view.state.doc, selectAt), "pointer");
    return true
  } else {
    return false
  }
}

function handleSingleClick(view, pos, inside, event, selectNode) {
  return runHandlerOnContext(view, "handleClickOn", pos, inside, event) ||
    view.someProp("handleClick", function (f) { return f(view, pos, event); }) ||
    (selectNode ? selectClickedNode(view, inside) : selectClickedLeaf(view, inside))
}

function handleDoubleClick(view, pos, inside, event) {
  return runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) ||
    view.someProp("handleDoubleClick", function (f) { return f(view, pos, event); })
}

function handleTripleClick(view, pos, inside, event) {
  return runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) ||
    view.someProp("handleTripleClick", function (f) { return f(view, pos, event); }) ||
    defaultTripleClick(view, inside)
}

function defaultTripleClick(view, inside) {
  var doc = view.state.doc;
  if (inside == -1) {
    if (doc.inlineContent) {
      updateSelection(view, prosemirrorState.TextSelection.create(doc, 0, doc.content.size), "pointer");
      return true
    }
    return false
  }

  var $pos = doc.resolve(inside);
  for (var i = $pos.depth + 1; i > 0; i--) {
    var node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
    var nodePos = $pos.before(i);
    if (node.inlineContent)
      { updateSelection(view, prosemirrorState.TextSelection.create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer"); }
    else if (prosemirrorState.NodeSelection.isSelectable(node))
      { updateSelection(view, prosemirrorState.NodeSelection.create(doc, nodePos), "pointer"); }
    else
      { continue }
    return true
  }
}

function forceDOMFlush(view) {
  if (!view.inDOMChange) { return false }
  view.inDOMChange.finish(true);
  return true
}

var selectNodeModifier = result.mac ? "metaKey" : "ctrlKey";

handlers.mousedown = function (view, event) {
  view.shiftKey = event.shiftKey;
  var flushed = forceDOMFlush(view);
  var now = Date.now(), type = "singleClick";
  if (now - lastClick.time < 500 && isNear(event, lastClick) && !event[selectNodeModifier]) {
    if (lastClick.type == "singleClick") { type = "doubleClick"; }
    else if (lastClick.type == "doubleClick") { type = "tripleClick"; }
  }
  lastClick = {time: now, x: event.clientX, y: event.clientY, type: type};

  var pos = view.posAtCoords(eventCoords(event));
  if (!pos) { return }

  if (type == "singleClick")
    { view.mouseDown = new MouseDown(view, pos, event, flushed); }
  else if ((type == "doubleClick" ? handleDoubleClick : handleTripleClick)(view, pos.pos, pos.inside, event))
    { event.preventDefault(); }
  else
    { view.selectionReader.poll("pointer"); }
};

var MouseDown = function MouseDown(view, pos, event, flushed) {
  var this$1 = this;

  this.view = view;
  this.pos = pos;
  this.event = event;
  this.flushed = flushed;
  this.selectNode = event[selectNodeModifier];
  this.allowDefault = event.shiftKey;

  var targetNode, targetPos;
  if (pos.inside > -1) {
    targetNode = view.state.doc.nodeAt(pos.inside);
    targetPos = pos.inside;
  } else {
    var $pos = view.state.doc.resolve(pos.pos);
    targetNode = $pos.parent;
    targetPos = $pos.depth ? $pos.before() : 0;
  }

  this.mightDrag = null;

  var target = flushed ? null : event.target;
  var targetDesc = target ? view.docView.nearestDesc(target, true) : null;
  this.target = targetDesc ? targetDesc.dom : null;

  if (targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false ||
      view.state.selection instanceof prosemirrorState.NodeSelection && targetPos == view.state.selection.from)
    { this.mightDrag = {node: targetNode,
                      pos: targetPos,
                      addAttr: this.target && !this.target.draggable,
                      setUneditable: this.target && result.gecko && !this.target.hasAttribute("contentEditable")}; }

  if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
    this.view.domObserver.stop();
    if (this.mightDrag.addAttr) { this.target.draggable = true; }
    if (this.mightDrag.setUneditable)
      { setTimeout(function () { return this$1.target.setAttribute("contentEditable", "false"); }, 20); }
    this.view.domObserver.start();
  }

  view.root.addEventListener("mouseup", this.up = this.up.bind(this));
  view.root.addEventListener("mousemove", this.move = this.move.bind(this));
  view.selectionReader.poll("pointer");
};

MouseDown.prototype.done = function done () {
  this.view.root.removeEventListener("mouseup", this.up);
  this.view.root.removeEventListener("mousemove", this.move);
  if (this.mightDrag && this.target) {
    this.view.domObserver.stop();
    if (this.mightDrag.addAttr) { this.target.draggable = false; }
    if (this.mightDrag.setUneditable) { this.target.removeAttribute("contentEditable"); }
    this.view.domObserver.start();
  }
  this.view.mouseDown = null;
};

MouseDown.prototype.up = function up (event) {
  this.done();

  if (!this.view.dom.contains(event.target.nodeType == 3 ? event.target.parentNode : event.target))
    { return }

  if (this.allowDefault) {
    // Force a cursor wrapper redraw if this was suppressed (to avoid an issue with IE drag-selection)
    if (result.ie && needsCursorWrapper(this.view.state)) { this.view.updateState(this.view.state); }
    this.view.selectionReader.poll("pointer");
  } else if (handleSingleClick(this.view, this.pos.pos, this.pos.inside, event, this.selectNode)) {
    event.preventDefault();
  } else if (this.flushed ||
             // Chrome will sometimes treat a node selection as a
             // cursor, but still report that the node is selected
             // when asked through getSelection. You'll then get a
             // situation where clicking at the point where that
             // (hidden) cursor is doesn't change the selection, and
             // thus doesn't get a reaction from ProseMirror. This
             // works around that.
             (result.chrome && !(this.view.state.selection instanceof prosemirrorState.TextSelection))) {
    updateSelection(this.view, prosemirrorState.Selection.near(this.view.state.doc.resolve(this.pos.pos)), "pointer");
    event.preventDefault();
  } else {
    this.view.selectionReader.poll("pointer");
  }
};

MouseDown.prototype.move = function move (event) {
  if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 ||
                             Math.abs(this.event.y - event.clientY) > 4))
    { this.allowDefault = true; }
  this.view.selectionReader.poll("pointer");
};

handlers.touchdown = function (view) {
  forceDOMFlush(view);
  view.selectionReader.poll("pointer");
};

handlers.contextmenu = function (view) { return forceDOMFlush(view); };

// Input compositions are hard. Mostly because the events fired by
// browsers are A) very unpredictable and inconsistent, and B) not
// cancelable.
//
// ProseMirror has the problem that it must not update the DOM during
// a composition, or the browser will cancel it. What it does is keep
// long-running operations (delayed DOM updates) when a composition is
// active.
//
// We _do not_ trust the information in the composition events which,
// apart from being very uninformative to begin with, is often just
// plain wrong. Instead, when a composition ends, we parse the dom
// around the original selection, and derive an update from that.

editHandlers.compositionstart = editHandlers.compositionupdate = function (view) {
  DOMChange.start(view, true);
};

editHandlers.compositionend = function (view, e) {
  if (!view.inDOMChange) {
    // We received a compositionend without having seen any previous
    // events for the composition. If there's data in the event
    // object, we assume that it's a real change, and start a
    // composition. Otherwise, we just ignore it.
    if (e.data) { DOMChange.start(view, true); }
    else { return }
  }

  view.inDOMChange.compositionEnd();
};

editHandlers.input = function (view) {
  var change = DOMChange.start(view);
  if (!change.composing) { change.finish(); }
};

function captureCopy(view, dom) {
  // The extra wrapper is somehow necessary on IE/Edge to prevent the
  // content from being mangled when it is put onto the clipboard
  var doc = dom.ownerDocument;
  var wrap = doc.body.appendChild(doc.createElement("div"));
  wrap.appendChild(dom);
  wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
  var sel = getSelection(), range = doc.createRange();
  range.selectNodeContents(dom);
  // Done because IE will fire a selectionchange moving the selection
  // to its start when removeAllRanges is called and the editor still
  // has focus (which will mess up the editor's selection state).
  view.dom.blur();
  sel.removeAllRanges();
  sel.addRange(range);
  setTimeout(function () {
    doc.body.removeChild(wrap);
    view.focus();
  }, 50);
}

// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
var brokenClipboardAPI = (result.ie && result.ie_version < 15) ||
      (result.ios && result.webkit_version < 604);

handlers.copy = editHandlers.cut = function (view, e) {
  var sel = view.state.selection, cut = e.type == "cut";
  if (sel.empty) { return }

  // IE and Edge's clipboard interface is completely broken
  var data = brokenClipboardAPI ? null : e.clipboardData;
  var slice = sel.content();
  var ref = serializeForClipboard(view, slice);
  var dom = ref.dom;
  var text = ref.text;
  if (data) {
    e.preventDefault();
    data.clearData();
    data.setData("text/html", dom.innerHTML);
    data.setData("text/plain", text);
  } else {
    captureCopy(view, dom);
  }
  if (cut) { view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut")); }
};

function sliceSingleNode(slice) {
  return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null
}

function capturePaste(view, e) {
  var doc = view.dom.ownerDocument;
  var plainText = view.shiftKey || view.state.selection.$from.parent.type.spec.code;
  var target = doc.body.appendChild(doc.createElement(plainText ? "textarea" : "div"));
  if (!plainText) { target.contentEditable = "true"; }
  target.style.cssText = "position: fixed; left: -10000px; top: 10px";
  target.focus();
  setTimeout(function () {
    view.focus();
    doc.body.removeChild(target);
    if (plainText) { doPaste(view, target.value, null, e); }
    else { doPaste(view, target.textContent, target.innerHTML, e); }
  }, 50);
}

function doPaste(view, text, html, e) {
  var slice = parseFromClipboard(view, text, html, view.shiftKey, view.state.selection.$from);
  if (!slice) { return false }

  if (view.someProp("handlePaste", function (f) { return f(view, e, slice); })) { return true }

  var singleNode = sliceSingleNode(slice);
  var tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, view.shiftKey) : view.state.tr.replaceSelection(slice);
  view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
  return true
}

editHandlers.paste = function (view, e) {
  var data = brokenClipboardAPI ? null : e.clipboardData;
  if (data && (doPaste(view, data.getData("text/plain"), data.getData("text/html"), e) || data.files.length > 0))
    { e.preventDefault(); }
  else
    { capturePaste(view, e); }
};

var Dragging = function Dragging(slice, move) {
  this.slice = slice;
  this.move = move;
};

var dragCopyModifier = result.mac ? "altKey" : "ctrlKey";

handlers.dragstart = function (view, e) {
  var mouseDown = view.mouseDown;
  if (mouseDown) { mouseDown.done(); }
  if (!e.dataTransfer) { return }

  var sel = view.state.selection;
  var pos = sel.empty ? null : view.posAtCoords(eventCoords(e));
  if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof prosemirrorState.NodeSelection ? sel.to - 1: sel.to)) {
    // In selection
  } else if (mouseDown && mouseDown.mightDrag) {
    view.dispatch(view.state.tr.setSelection(prosemirrorState.NodeSelection.create(view.state.doc, mouseDown.mightDrag.pos)));
  } else if (e.target && e.target.nodeType == 1) {
    var desc = view.docView.nearestDesc(e.target, true);
    if (!desc || !desc.node.type.spec.draggable || desc == view.docView) { return }
    view.dispatch(view.state.tr.setSelection(prosemirrorState.NodeSelection.create(view.state.doc, desc.posBefore)));
  }
  var slice = view.state.selection.content();
  var ref = serializeForClipboard(view, slice);
  var dom = ref.dom;
  var text = ref.text;
  e.dataTransfer.clearData();
  e.dataTransfer.setData(brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
  if (!brokenClipboardAPI) { e.dataTransfer.setData("text/plain", text); }
  view.dragging = new Dragging(slice, !e[dragCopyModifier]);
};

handlers.dragend = function (view) {
  window.setTimeout(function () { return view.dragging = null; }, 50);
};

editHandlers.dragover = editHandlers.dragenter = function (_, e) { return e.preventDefault(); };

editHandlers.drop = function (view, e) {
  var dragging = view.dragging;
  view.dragging = null;

  if (!e.dataTransfer) { return }

  var eventPos = view.posAtCoords(eventCoords(e));
  if (!eventPos) { return }
  var $mouse = view.state.doc.resolve(eventPos.pos);
  if (!$mouse) { return }
  var slice = dragging && dragging.slice ||
      parseFromClipboard(view, e.dataTransfer.getData(brokenClipboardAPI ? "Text" : "text/plain"),
                         brokenClipboardAPI ? null : e.dataTransfer.getData("text/html"), false, $mouse);
  if (!slice) { return }

  e.preventDefault();
  if (view.someProp("handleDrop", function (f) { return f(view, e, slice, dragging && dragging.move); })) { return }
  var insertPos = slice ? prosemirrorTransform.dropPoint(view.state.doc, $mouse.pos, slice) : $mouse.pos;
  if (insertPos == null) { insertPos = $mouse.pos; }

  var tr = view.state.tr;
  if (dragging && dragging.move) { tr.deleteSelection(); }

  var pos = tr.mapping.map(insertPos);
  var isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
  var beforeInsert = tr.doc;
  if (isNode)
    { tr.replaceRangeWith(pos, pos, slice.content.firstChild); }
  else
    { tr.replaceRange(pos, pos, slice); }
  if (tr.doc.eq(beforeInsert)) { return }

  var $pos = tr.doc.resolve(pos);
  if (isNode && prosemirrorState.NodeSelection.isSelectable(slice.content.firstChild) &&
      $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild))
    { tr.setSelection(new prosemirrorState.NodeSelection($pos)); }
  else
    { tr.setSelection(selectionBetween(view, $pos, tr.doc.resolve(tr.mapping.map(insertPos)))); }
  view.focus();
  view.dispatch(tr.setMeta("uiEvent", "drop"));
};

handlers.focus = function (view) {
  if (!view.focused) {
    view.dom.classList.add("ProseMirror-focused");
    view.focused = true;
  }
};

handlers.blur = function (view) {
  if (view.focused) {
    view.dom.classList.remove("ProseMirror-focused");
    view.focused = false;
  }
};

// Make sure all handlers get registered
for (var prop in editHandlers) { handlers[prop] = editHandlers[prop]; }

function compareObjs(a, b) {
  if (a == b) { return true }
  for (var p in a) { if (a[p] !== b[p]) { return false } }
  for (var p$1 in b) { if (!(p$1 in a)) { return false } }
  return true
}

var WidgetType = function WidgetType(toDOM, spec) {
  this.spec = spec || noSpec;
  this.side = this.spec.side || 0;
  this.toDOM = toDOM;
};

WidgetType.prototype.map = function map (mapping, span, offset, oldOffset) {
  var ref = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
    var pos = ref.pos;
    var deleted = ref.deleted;
  return deleted ? null : new Decoration(pos - offset, pos - offset, this)
};

WidgetType.prototype.valid = function valid () { return true };

WidgetType.prototype.eq = function eq (other) {
  return this == other ||
    (other instanceof WidgetType &&
     (this.spec.key && this.spec.key == other.spec.key ||
      this.toDOM == other.toDOM && compareObjs(this.spec, other.spec)))
};

var InlineType = function InlineType(attrs, spec) {
  this.spec = spec || noSpec;
  this.attrs = attrs;
};

InlineType.prototype.map = function map (mapping, span, offset, oldOffset) {
  var from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
  var to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
  return from >= to ? null : new Decoration(from, to, this)
};

InlineType.prototype.valid = function valid (_, span) { return span.from < span.to };

InlineType.prototype.eq = function eq (other) {
  return this == other ||
    (other instanceof InlineType && compareObjs(this.attrs, other.attrs) &&
     compareObjs(this.spec, other.spec))
};

InlineType.is = function is (span) { return span.type instanceof InlineType };

var NodeType = function NodeType(attrs, spec) {
  this.spec = spec || noSpec;
  this.attrs = attrs;
};

NodeType.prototype.map = function map (mapping, span, offset, oldOffset) {
  var from = mapping.mapResult(span.from + oldOffset, 1);
  if (from.deleted) { return null }
  var to = mapping.mapResult(span.to + oldOffset, -1);
  if (to.deleted || to.pos <= from.pos) { return null }
  return new Decoration(from.pos - offset, to.pos - offset, this)
};

NodeType.prototype.valid = function valid (node, span) {
  var ref = node.content.findIndex(span.from);
    var index = ref.index;
    var offset = ref.offset;
  return offset == span.from && offset + node.child(index).nodeSize == span.to
};

NodeType.prototype.eq = function eq (other) {
  return this == other ||
    (other instanceof NodeType && compareObjs(this.attrs, other.attrs) &&
     compareObjs(this.spec, other.spec))
};

// ::- Decoration objects can be provided to the view through the
// [`decorations` prop](#view.EditorProps.decorations). They come in
// several variants—see the static members of this class for details.
var Decoration = function Decoration(from, to, type) {
  // :: number
  // The start position of the decoration.
  this.from = from;
  // :: number
  // The end position. Will be the same as `from` for [widget
  // decorations](#view.Decoration^widget).
  this.to = to;
  this.type = type;
};

var prototypeAccessors$2 = { spec: {} };

Decoration.prototype.copy = function copy (from, to) {
  return new Decoration(from, to, this.type)
};

Decoration.prototype.eq = function eq (other) {
  return this.type.eq(other.type) && this.from == other.from && this.to == other.to
};

Decoration.prototype.map = function map (mapping, offset, oldOffset) {
  return this.type.map(mapping, this, offset, oldOffset)
};

// :: (number, union<(view: EditorView, getPos: () → number) → dom.Node, dom.Node>, ?Object) → Decoration
// Creates a widget decoration, which is a DOM node that's shown in
// the document at the given position. It is recommended that you
// delay rendering the widget by passing a function that will be
// called when the widget is actually drawn in a view, but you can
// also directly pass a DOM node. `getPos` can be used to find the
// widget's current document position.
//
// spec::- These options are supported:
//
//   side:: ?number
//   Controls which side of the document position this widget is
//   associated with. When negative, it is drawn before a cursor
//   at its position, and content inserted at that position ends
//   up after the widget. When zero (the default) or positive, the
//   widget is drawn after the cursor and content inserted there
//   ends up before the widget.
//
//   When there are multiple widgets at a given position, their
//   `side` values determine the order in which they appear. Those
//   with lower values appear first. The ordering of widgets with
//   the same `side` value is unspecified.
//
//   When `marks` is null, `side` also determines the marks that
//   the widget is wrapped in—those of the node before when
//   negative, those of the node after when positive.
//
//   marks:: ?[Mark]
//   The precise set of marks to draw around the widget.
//
//   stopEvent:: ?(event: dom.Event) → bool
//   Can be used to control which DOM events, when they bubble out
//   of this widget, the editor view should ignore.
//
//   key:: ?string
//   When comparing decorations of this type (in order to decide
//   whether it needs to be redrawn), ProseMirror will by default
//   compare the widget DOM node by identity. If you pass a key,
//   that key will be compared instead, which can be useful when
//   you generate decorations on the fly and don't want to store
//   and reuse DOM nodes. Make sure that any widgets with the same
//   key are interchangeable—if widgets differ in, for example,
//   the behavior of some event handler, they should get
//   different keys.
Decoration.widget = function widget (pos, toDOM, spec) {
  return new Decoration(pos, pos, new WidgetType(toDOM, spec))
};

// :: (number, number, DecorationAttrs, ?Object) → Decoration
// Creates an inline decoration, which adds the given attributes to
// each inline node between `from` and `to`.
//
// spec::- These options are recognized:
//
//   inclusiveStart:: ?bool
//   Determines how the left side of the decoration is
//   [mapped](#transform.Position_Mapping) when content is
//   inserted directly at that position. By default, the decoration
//   won't include the new content, but you can set this to `true`
//   to make it inclusive.
//
//   inclusiveEnd:: ?bool
//   Determines how the right side of the decoration is mapped.
//   See
//   [`inclusiveStart`](#view.Decoration^inline^spec.inclusiveStart).
Decoration.inline = function inline (from, to, attrs, spec) {
  return new Decoration(from, to, new InlineType(attrs, spec))
};

// :: (number, number, DecorationAttrs, ?Object) → Decoration
// Creates a node decoration. `from` and `to` should point precisely
// before and after a node in the document. That node, and only that
// node, will receive the given attributes.
Decoration.node = function node (from, to, attrs, spec) {
  return new Decoration(from, to, new NodeType(attrs, spec))
};

// :: Object
// The spec provided when creating this decoration. Can be useful
// if you've stored extra information in that object.
prototypeAccessors$2.spec.get = function () { return this.type.spec };

Object.defineProperties( Decoration.prototype, prototypeAccessors$2 );

// DecorationAttrs:: interface
// A set of attributes to add to a decorated node. Most properties
// simply directly correspond to DOM attributes of the same name,
// which will be set to the property's value. These are exceptions:
//
//   class:: ?string
//   A CSS class name or a space-separated set of class names to be
//   _added_ to the classes that the node already had.
//
//   style:: ?string
//   A string of CSS to be _added_ to the node's existing `style` property.
//
//   nodeName:: ?string
//   When non-null, the target node is wrapped in a DOM element of
//   this type (and the other attributes are applied to this element).

var none = [];
var noSpec = {};

// ::- A collection of [decorations](#view.Decoration), organized in
// such a way that the drawing algorithm can efficiently use and
// compare them. This is a persistent data structure—it is not
// modified, updates create a new value.
var DecorationSet = function DecorationSet(local, children) {
  this.local = local && local.length ? local : none;
  this.children = children && children.length ? children : none;
};

// :: (Node, [Decoration]) → DecorationSet
// Create a set of decorations, using the structure of the given
// document.
DecorationSet.create = function create (doc, decorations) {
  return decorations.length ? buildTree(decorations, doc, 0, noSpec) : empty
};

// :: (?number, ?number, ?(spec: Object) → bool) → [Decoration]
// Find all decorations in this set which touch the given range
// (including decorations that start or end directly at the
// boundaries) and match the given predicate on their spec. When
// `start` and `end` are omitted, all decorations in the set are
// considered. When `predicate` isn't given, all decorations are
// asssumed to match.
DecorationSet.prototype.find = function find (start, end, predicate) {
  var result = [];
  this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
  return result
};

DecorationSet.prototype.findInner = function findInner (start, end, result, offset, predicate) {
    var this$1 = this;

  for (var i = 0; i < this.local.length; i++) {
    var span = this$1.local[i];
    if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec)))
      { result.push(span.copy(span.from + offset, span.to + offset)); }
  }
  for (var i$1 = 0; i$1 < this.children.length; i$1 += 3) {
    if (this$1.children[i$1] < end && this$1.children[i$1 + 1] > start) {
      var childOff = this$1.children[i$1] + 1;
      this$1.children[i$1 + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
    }
  }
};

// :: (Mapping, Node, ?Object) → DecorationSet
// Map the set of decorations in response to a change in the
// document.
//
// options::- An optional set of options.
//
//   onRemove:: ?(decorationSpec: Object)
//   When given, this function will be called for each decoration
//   that gets dropped as a result of the mapping, passing the
//   spec of that decoration.
DecorationSet.prototype.map = function map (mapping, doc, options) {
  if (this == empty || mapping.maps.length == 0) { return this }
  return this.mapInner(mapping, doc, 0, 0, options || noSpec)
};

DecorationSet.prototype.mapInner = function mapInner (mapping, node, offset, oldOffset, options) {
    var this$1 = this;

  var newLocal;
  for (var i = 0; i < this.local.length; i++) {
    var mapped = this$1.local[i].map(mapping, offset, oldOffset);
    if (mapped && mapped.type.valid(node, mapped)) { (newLocal || (newLocal = [])).push(mapped); }
    else if (options.onRemove) { options.onRemove(this$1.local[i].spec); }
  }

  if (this.children.length)
    { return mapChildren(this.children, newLocal, mapping, node, offset, oldOffset, options) }
  else
    { return newLocal ? new DecorationSet(newLocal.sort(byPos)) : empty }
};

// :: (Node, [Decoration]) → DecorationSet
// Add the given array of decorations to the ones in the set,
// producing a new set. Needs access to the current document to
// create the appropriate tree structure.
DecorationSet.prototype.add = function add (doc, decorations) {
  if (!decorations.length) { return this }
  if (this == empty) { return DecorationSet.create(doc, decorations) }
  return this.addInner(doc, decorations, 0)
};

DecorationSet.prototype.addInner = function addInner (doc, decorations, offset) {
    var this$1 = this;

  var children, childIndex = 0;
  doc.forEach(function (childNode, childOffset) {
    var baseOffset = childOffset + offset, found;
    if (!(found = takeSpansForNode(decorations, childNode, baseOffset))) { return }

    if (!children) { children = this$1.children.slice(); }
    while (childIndex < children.length && children[childIndex] < childOffset) { childIndex += 3; }
    if (children[childIndex] == childOffset)
      { children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1); }
    else
      { children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, buildTree(found, childNode, baseOffset + 1, noSpec)); }
    childIndex += 3;
  });

  var local = moveSpans(childIndex ? withoutNulls(decorations) : decorations, -offset);
  return new DecorationSet(local.length ? this.local.concat(local).sort(byPos) : this.local,
                           children || this.children)
};

// :: ([Decoration]) → DecorationSet
// Create a new set that contains the decorations in this set, minus
// the ones in the given array.
DecorationSet.prototype.remove = function remove (decorations) {
  if (decorations.length == 0 || this == empty) { return this }
  return this.removeInner(decorations, 0)
};

DecorationSet.prototype.removeInner = function removeInner (decorations, offset) {
    var this$1 = this;

  var children = this.children, local = this.local;
  for (var i = 0; i < children.length; i += 3) {
    var found = (void 0), from = children[i] + offset, to = children[i + 1] + offset;
    for (var j = 0, span = (void 0); j < decorations.length; j++) { if (span = decorations[j]) {
      if (span.from > from && span.to < to) {
        decorations[j] = null
        ;(found || (found = [])).push(span);
      }
    } }
    if (!found) { continue }
    if (children == this$1.children) { children = this$1.children.slice(); }
    var removed = children[i + 2].removeInner(found, from + 1);
    if (removed != empty) {
      children[i + 2] = removed;
    } else {
      children.splice(i, 3);
      i -= 3;
    }
  }
  if (local.length) { for (var i$1 = 0, span$1 = (void 0); i$1 < decorations.length; i$1++) { if (span$1 = decorations[i$1]) {
    for (var j$1 = 0; j$1 < local.length; j$1++) { if (local[j$1].type.eq(span$1.type)) {
      if (local == this$1.local) { local = this$1.local.slice(); }
      local.splice(j$1--, 1);
    } }
  } } }
  if (children == this.children && local == this.local) { return this }
  return local.length || children.length ? new DecorationSet(local, children) : empty
};

DecorationSet.prototype.forChild = function forChild (offset, node) {
    var this$1 = this;

  if (this == empty) { return this }
  if (node.isLeaf) { return DecorationSet.empty }

  var child, local;
  for (var i = 0; i < this.children.length; i += 3) { if (this$1.children[i] >= offset) {
    if (this$1.children[i] == offset) { child = this$1.children[i + 2]; }
    break
  } }
  var start = offset + 1, end = start + node.content.size;
  for (var i$1 = 0; i$1 < this.local.length; i$1++) {
    var dec = this$1.local[i$1];
    if (dec.from < end && dec.to > start && (dec.type instanceof InlineType)) {
      var from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
      if (from < to) { (local || (local = [])).push(dec.copy(from, to)); }
    }
  }
  if (local) {
    var localSet = new DecorationSet(local.sort(byPos));
    return child ? new DecorationGroup([localSet, child]) : localSet
  }
  return child || empty
};

DecorationSet.prototype.eq = function eq (other) {
    var this$1 = this;

  if (this == other) { return true }
  if (!(other instanceof DecorationSet) ||
      this.local.length != other.local.length ||
      this.children.length != other.children.length) { return false }
  for (var i = 0; i < this.local.length; i++)
    { if (!this$1.local[i].eq(other.local[i])) { return false } }
  for (var i$1 = 0; i$1 < this.children.length; i$1 += 3)
    { if (this$1.children[i$1] != other.children[i$1] ||
        this$1.children[i$1 + 1] != other.children[i$1 + 1] ||
        !this$1.children[i$1 + 2].eq(other.children[i$1 + 2])) { return false } }
  return false
};

DecorationSet.prototype.locals = function locals (node) {
  return removeOverlap(this.localsInner(node))
};

DecorationSet.prototype.localsInner = function localsInner (node) {
    var this$1 = this;

  if (this == empty) { return none }
  if (node.inlineContent || !this.local.some(InlineType.is)) { return this.local }
  var result = [];
  for (var i = 0; i < this.local.length; i++) {
    if (!(this$1.local[i].type instanceof InlineType))
      { result.push(this$1.local[i]); }
  }
  return result
};

var empty = new DecorationSet();

// :: DecorationSet
// The empty set of decorations.
DecorationSet.empty = empty;

DecorationSet.removeOverlap = removeOverlap;

// :- An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
var DecorationGroup = function DecorationGroup(members) {
  this.members = members;
};

DecorationGroup.prototype.forChild = function forChild (offset, child) {
    var this$1 = this;

  if (child.isLeaf) { return DecorationSet.empty }
  var found = [];
  for (var i = 0; i < this.members.length; i++) {
    var result = this$1.members[i].forChild(offset, child);
    if (result == empty) { continue }
    if (result instanceof DecorationGroup) { found = found.concat(result.members); }
    else { found.push(result); }
  }
  return DecorationGroup.from(found)
};

DecorationGroup.prototype.eq = function eq (other) {
    var this$1 = this;

  if (!(other instanceof DecorationGroup) ||
      other.members.length != this.members.length) { return false }
  for (var i = 0; i < this.members.length; i++)
    { if (!this$1.members[i].eq(other.members[i])) { return false } }
  return true
};

DecorationGroup.prototype.locals = function locals (node) {
    var this$1 = this;

  var result, sorted = true;
  for (var i = 0; i < this.members.length; i++) {
    var locals = this$1.members[i].localsInner(node);
    if (!locals.length) { continue }
    if (!result) {
      result = locals;
    } else {
      if (sorted) {
        result = result.slice();
        sorted = false;
      }
      for (var j = 0; j < locals.length; j++) { result.push(locals[j]); }
    }
  }
  return result ? removeOverlap(sorted ? result : result.sort(byPos)) : none
};

// : ([DecorationSet]) → union<DecorationSet, DecorationGroup>
// Create a group for the given array of decoration sets, or return
// a single set when possible.
DecorationGroup.from = function from (members) {
  switch (members.length) {
    case 0: return empty
    case 1: return members[0]
    default: return new DecorationGroup(members)
  }
};

function mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
  var children = oldChildren.slice();

  // Mark the children that are directly touched by changes, and
  // move those that are after the changes.
  var shift = function (oldStart, oldEnd, newStart, newEnd) {
    for (var i = 0; i < children.length; i += 3) {
      var end = children[i + 1], dSize = (void 0);
      if (end == -1 || oldStart > end + oldOffset) { continue }
      if (oldEnd >= children[i] + oldOffset) {
        children[i + 1] = -1;
      } else if (dSize = (newEnd - newStart) - (oldEnd - oldStart) + (oldOffset - offset)) {
        children[i] += dSize;
        children[i + 1] += dSize;
      }
    }
  };
  for (var i = 0; i < mapping.maps.length; i++) { mapping.maps[i].forEach(shift); }

  // Find the child nodes that still correspond to a single node,
  // recursively call mapInner on them and update their positions.
  var mustRebuild = false;
  for (var i$1 = 0; i$1 < children.length; i$1 += 3) { if (children[i$1 + 1] == -1) { // Touched nodes
    var from = mapping.map(children[i$1] + oldOffset), fromLocal = from - offset;
    if (fromLocal < 0 || fromLocal >= node.content.size) {
      mustRebuild = true;
      continue
    }
    // Must read oldChildren because children was tagged with -1
    var to = mapping.map(oldChildren[i$1 + 1] + oldOffset, -1), toLocal = to - offset;
    var ref = node.content.findIndex(fromLocal);
    var index = ref.index;
    var childOffset = ref.offset;
    var childNode = node.maybeChild(index);
    if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
      var mapped = children[i$1 + 2].mapInner(mapping, childNode, from + 1, children[i$1] + oldOffset + 1, options);
      if (mapped != empty) {
        children[i$1] = fromLocal;
        children[i$1 + 1] = toLocal;
        children[i$1 + 2] = mapped;
      } else {
        children[i$1 + 1] = -2;
        mustRebuild = true;
      }
    } else {
      mustRebuild = true;
    }
  } }

  // Remaining children must be collected and rebuilt into the appropriate structure
  if (mustRebuild) {
    var decorations = mapAndGatherRemainingDecorations(children, oldChildren, newLocal || [], mapping,
                                                       offset, oldOffset, options);
    var built = buildTree(decorations, node, 0, options);
    newLocal = built.local;
    for (var i$2 = 0; i$2 < children.length; i$2 += 3) { if (children[i$2 + 1] < 0) {
      children.splice(i$2, 3);
      i$2 -= 3;
    } }
    for (var i$3 = 0, j = 0; i$3 < built.children.length; i$3 += 3) {
      var from$1 = built.children[i$3];
      while (j < children.length && children[j] < from$1) { j += 3; }
      children.splice(j, 0, built.children[i$3], built.children[i$3 + 1], built.children[i$3 + 2]);
    }
  }

  return new DecorationSet(newLocal && newLocal.sort(byPos), children)
}

function moveSpans(spans, offset) {
  if (!offset || !spans.length) { return spans }
  var result = [];
  for (var i = 0; i < spans.length; i++) {
    var span = spans[i];
    result.push(new Decoration(span.from + offset, span.to + offset, span.type));
  }
  return result
}

function mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
  // Gather all decorations from the remaining marked children
  function gather(set, oldOffset) {
    for (var i = 0; i < set.local.length; i++) {
      var mapped = set.local[i].map(mapping, offset, oldOffset);
      if (mapped) { decorations.push(mapped); }
      else if (options.onRemove) { options.onRemove(set.local[i].spec); }
    }
    for (var i$1 = 0; i$1 < set.children.length; i$1 += 3)
      { gather(set.children[i$1 + 2], set.children[i$1] + oldOffset + 1); }
  }
  for (var i = 0; i < children.length; i += 3) { if (children[i + 1] == -1)
    { gather(children[i + 2], oldChildren[i] + oldOffset + 1); } }

  return decorations
}

function takeSpansForNode(spans, node, offset) {
  if (node.isLeaf) { return null }
  var end = offset + node.nodeSize, found = null;
  for (var i = 0, span = (void 0); i < spans.length; i++) {
    if ((span = spans[i]) && span.from > offset && span.to < end) {
      (found || (found = [])).push(span);
      spans[i] = null;
    }
  }
  return found
}

function withoutNulls(array) {
  var result = [];
  for (var i = 0; i < array.length; i++)
    { if (array[i] != null) { result.push(array[i]); } }
  return result
}

// : ([Decoration], Node, number) → DecorationSet
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtractet from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function buildTree(spans, node, offset, options) {
  var children = [], hasNulls = false;
  node.forEach(function (childNode, localStart) {
    var found = takeSpansForNode(spans, childNode, localStart + offset);
    if (found) {
      hasNulls = true;
      var subtree = buildTree(found, childNode, offset + localStart + 1, options);
      if (subtree != empty)
        { children.push(localStart, localStart + childNode.nodeSize, subtree); }
    }
  });
  var locals = moveSpans(hasNulls ? withoutNulls(spans) : spans, -offset).sort(byPos);
  for (var i = 0; i < locals.length; i++) { if (!locals[i].type.valid(node, locals[i])) {
    if (options.onRemove) { options.onRemove(locals[i].spec); }
    locals.splice(i--, 1);
  } }
  return locals.length || children.length ? new DecorationSet(locals, children) : empty
}

// : (Decoration, Decoration) → number
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function byPos(a, b) {
  return a.from - b.from || a.to - b.to
}

// : ([Decoration]) → [Decoration]
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function removeOverlap(spans) {
  var working = spans;
  for (var i = 0; i < working.length - 1; i++) {
    var span = working[i];
    if (span.from != span.to) { for (var j = i + 1; j < working.length; j++) {
      var next = working[j];
      if (next.from == span.from) {
        if (next.to != span.to) {
          if (working == spans) { working = spans.slice(); }
          // Followed by a partially overlapping larger span. Split that
          // span.
          working[j] = next.copy(next.from, span.to);
          insertAhead(working, j + 1, next.copy(span.to, next.to));
        }
        continue
      } else {
        if (next.from < span.to) {
          if (working == spans) { working = spans.slice(); }
          // The end of this one overlaps with a subsequent span. Split
          // this one.
          working[i] = span.copy(span.from, next.from);
          insertAhead(working, j, span.copy(next.from, span.to));
        }
        break
      }
    } }
  }
  return working
}

function insertAhead(array, i, deco) {
  while (i < array.length && byPos(deco, array[i]) > 0) { i++; }
  array.splice(i, 0, deco);
}

// : (EditorView) → union<DecorationSet, DecorationGroup>
// Get the decorations associated with the current props of a view.
function viewDecorations(view) {
  var found = [];
  view.someProp("decorations", function (f) {
    var result = f(view.state);
    if (result && result != empty) { found.push(result); }
  });
  if (view.cursorWrapper)
    { found.push(DecorationSet.create(view.state.doc, [view.cursorWrapper.deco])); }
  return DecorationGroup.from(found)
}

// ::- An editor view manages the DOM structure that represents an
// editable document. Its state and behavior are determined by its
// [props](#view.DirectEditorProps).
var EditorView = function EditorView(place, props) {
  this._props = props;
  // :: EditorState
  // The view's current [state](#state.EditorState).
  this.state = props.state;

  this.dispatch = this.dispatch.bind(this);

  this._root = null;
  this.focused = false;

  // :: dom.Element
  // An editable DOM node containing the document. (You probably
  // should not directly interfere with its content.)
  this.dom = (place && place.mount) || document.createElement("div");
  if (place) {
    if (place.appendChild) { place.appendChild(this.dom); }
    else if (place.apply) { place(this.dom); }
    else if (place.mount) { this.mounted = true; }
  }

  this.editable = getEditable(this);
  this.redraw = false;
  this.cursorWrapper = null;
  updateCursorWrapper(this);
  this.nodeViews = buildNodeViews(this);
  this.docView = docViewDesc(this.state.doc, computeDocDeco(this), viewDecorations(this), this.dom, this);

  this.lastSelectedViewDesc = null;
  // :: ?{slice: Slice, move: bool}
  // When editor content is being dragged, this object contains
  // information about the dragged slice and whether it is being
  // copied or moved. At any other time, it is null.
  this.dragging = null;
  initInput(this); // Must be done before creating a SelectionReader

  this.selectionReader = new SelectionReader(this);

  this.pluginViews = [];
  this.updatePluginViews();
};

var prototypeAccessors = { props: {},root: {} };

// :: DirectEditorProps
// The view's current [props](#view.EditorProps).
prototypeAccessors.props.get = function () {
    var this$1 = this;

  if (this._props.state != this.state) {
    var prev = this._props;
    this._props = {};
    for (var name in prev) { this$1._props[name] = prev[name]; }
    this._props.state = this.state;
  }
  return this._props
};

// :: (DirectEditorProps)
// Update the view's props. Will immediately cause an update to
// the DOM.
EditorView.prototype.update = function update (props) {
  if (props.handleDOMEvents != this._props.handleDOMEvents) { ensureListeners(this); }
  this._props = props;
  var nodeViews = buildNodeViews(this);
  if (changedNodeViews(nodeViews, this.nodeViews)) {
    this.nodeViews = nodeViews;
    this.redraw = true;
  }
  this.updateState(props.state);
};

// :: (DirectEditorProps)
// Update the view by updating existing props object with the object
// given as argument. Equivalent to `view.update(Object.assign({},
// view.props, props))`.
EditorView.prototype.setProps = function setProps (props) {
    var this$1 = this;

  var updated = {};
  for (var name in this$1._props) { updated[name] = this$1._props[name]; }
  updated.state = this.state;
  for (var name$1 in props) { updated[name$1] = props[name$1]; }
  this.update(updated);
};

// :: (EditorState)
// Update the editor's `state` prop, without touching any of the
// other props.
EditorView.prototype.updateState = function updateState (state) {
    var this$1 = this;

  var prev = this.state;
  this.state = state;
  if (prev.plugins != state.plugins) { ensureListeners(this); }

  this.domObserver.flush();
  if (this.inDOMChange && this.inDOMChange.stateUpdated(state)) { return }

  var prevEditable = this.editable;
  this.editable = getEditable(this);
  updateCursorWrapper(this);
  var innerDeco = viewDecorations(this), outerDeco = computeDocDeco(this);

  var scroll = prev.config != state.config ? "reset"
      : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
  var updateDoc = this.redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
  var updateSel = updateDoc || !state.selection.eq(prev.selection) || this.selectionReader.domChanged();
  var oldScrollPos = scroll == "preserve" && updateSel && storeScrollPos(this);

  if (updateSel) {
    this.domObserver.stop();
    var forceSelUpdate = false;
    if (updateDoc) {
      // Work around an issue in Chrome where changing the DOM
      // around the active selection puts it into a broken state
      // where the thing the user sees differs from the selection
      // reported by the Selection object (#710)
      var startSelContext = result.chrome && selectionContext(this.root);
      if (this.redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
        this.docView.destroy();
        this.docView = docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
        this.redraw = false;
      }
      this.selectionReader.clearDOMState();
      if (startSelContext)
        { forceSelUpdate = needChromeSelectionForce(startSelContext, this.root); }
    }
    selectionToDOM(this, false, forceSelUpdate);
    this.domObserver.start();
  }

  if (prevEditable != this.editable) { this.selectionReader.editableChanged(); }
  this.updatePluginViews(prev);

  if (scroll == "reset") {
    this.dom.scrollTop = 0;
  } else if (scroll == "to selection") {
    var startDOM = this.root.getSelection().focusNode;
    if (this.someProp("handleScrollToSelection", function (f) { return f(this$1); }))
      {} // Handled
    else if (state.selection instanceof prosemirrorState.NodeSelection)
      { scrollRectIntoView(this, this.docView.domAfterPos(state.selection.from).getBoundingClientRect(), startDOM); }
    else
      { scrollRectIntoView(this, this.coordsAtPos(state.selection.head), startDOM); }
  } else if (oldScrollPos) {
    resetScrollPos(oldScrollPos);
  }
};

EditorView.prototype.destroyPluginViews = function destroyPluginViews () {
  var view;
  while (view = this.pluginViews.pop()) { if (view.destroy) { view.destroy(); } }
};

EditorView.prototype.updatePluginViews = function updatePluginViews (prevState) {
    var this$1 = this;

  var plugins = this.state.plugins;
  if (!prevState || prevState.plugins != plugins) {
    this.destroyPluginViews();
    for (var i = 0; i < plugins.length; i++) {
      var plugin = plugins[i];
      if (plugin.spec.view) { this$1.pluginViews.push(plugin.spec.view(this$1)); }
    }
  } else {
    for (var i$1 = 0; i$1 < this.pluginViews.length; i$1++) {
      var pluginView = this$1.pluginViews[i$1];
      if (pluginView.update) { pluginView.update(this$1, prevState); }
    }
  }
};

// :: (string, ?(prop: *) → *) → *
// Goes over the values of a prop, first those provided directly,
// then those from plugins (in order), and calls `f` every time a
// non-undefined value is found. When `f` returns a truthy value,
// that is immediately returned. When `f` isn't provided, it is
// treated as the identity function (the prop value is returned
// directly).
EditorView.prototype.someProp = function someProp (propName, f) {
  var prop = this._props && this._props[propName], value;
  if (prop != null && (value = f ? f(prop) : prop)) { return value }
  var plugins = this.state.plugins;
  if (plugins) { for (var i = 0; i < plugins.length; i++) {
    var prop$1 = plugins[i].props[propName];
    if (prop$1 != null && (value = f ? f(prop$1) : prop$1)) { return value }
  } }
};

// :: () → bool
// Query whether the view has focus.
EditorView.prototype.hasFocus = function hasFocus () {
  return this.root.activeElement == this.dom
};

// :: ()
// Focus the editor.
EditorView.prototype.focus = function focus () {
  this.domObserver.stop();
  selectionToDOM(this, true);
  this.domObserver.start();
  if (this.editable) { this.dom.focus(); }
};

// :: union<dom.Document, dom.DocumentFragment>
// Get the document root in which the editor exists. This will
// usually be the top-level `document`, but might be a [shadow
// DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
// root if the editor is inside one.
prototypeAccessors.root.get = function () {
    var this$1 = this;

  var cached = this._root;
  if (cached == null) { for (var search = this.dom.parentNode; search; search = search.parentNode) {
    if (search.nodeType == 9 || (search.nodeType == 11 && search.host))
      { return this$1._root = search }
  } }
  return cached || document
};

// :: ({left: number, top: number}) → ?{pos: number, inside: number}
// Given a pair of viewport coordinates, return the document
// position that corresponds to them. May return null if the given
// coordinates aren't inside of the visible editor. When an object
// is returned, its `pos` property is the position nearest to the
// coordinates, and its `inside` property holds the position of the
// inner node that the position falls inside of, or -1 if it is at
// the top level, not in any node.
EditorView.prototype.posAtCoords = function posAtCoords$1 (coords) {
  var pos = posAtCoords(this, coords);
  if (this.inDOMChange && pos) {
    pos.pos = this.inDOMChange.mapping.map(pos.pos);
    if (pos.inside != -1) { pos.inside = this.inDOMChange.mapping.map(pos.inside); }
  }
  return pos
};

// :: (number) → {left: number, right: number, top: number, bottom: number}
// Returns the viewport rectangle at a given document position. `left`
// and `right` will be the same number, as this returns a flat
// cursor-ish rectangle.
EditorView.prototype.coordsAtPos = function coordsAtPos$1 (pos) {
  if (this.inDOMChange)
    { pos = this.inDOMChange.mapping.invert().map(pos); }
  return coordsAtPos(this, pos)
};

// :: (number) → {node: dom.Node, offset: number}
// Find the DOM position that corresponds to the given document
// position. Note that you should **not** mutate the editor's
// internal DOM, only inspect it (and even that is usually not
// necessary).
EditorView.prototype.domAtPos = function domAtPos (pos) {
  if (this.inDOMChange)
    { pos = this.inDOMChange.mapping.invert().map(pos); }
  return this.docView.domFromPos(pos)
};

// :: (number) → ?dom.Node
// Find the DOM node that represents the document node after the
// given position. May return `null` when the position doesn't point
// in front of a node or if the node is inside an opaque node view.
//
// This is intended to be able to call things like
// `getBoundingClientRect` on that DOM node. Do **not** mutate the
// editor DOM directly, or add styling this way, since that will be
// immediately overriden by the editor as it redraws the node.
EditorView.prototype.nodeDOM = function nodeDOM (pos) {
  if (this.inDOMChange)
    { pos = this.inDOMChange.mapping.invert().map(pos); }
  var desc = this.docView.descAt(pos);
  return desc ? desc.nodeDOM : null
};

// :: (dom.Node, number, ?number) → number
// Find the document position that corresponds to a given DOM
// position. (Whenever possible, it is preferable to inspect the
// document structure directly, rather than poking around in the
// DOM, but sometimes—for example when interpreting an event
// target—you don't have a choice.)
//
// The `bias` parameter can be used to influence which side of a DOM
// node to use when the position is inside a leaf node.
EditorView.prototype.posAtDOM = function posAtDOM (node, offset, bias) {
    if ( bias === void 0 ) bias = -1;

  var pos = this.docView.posFromDOM(node, offset, bias);
  if (pos == null) { throw new RangeError("DOM position not inside the editor") }
  if (this.inDOMChange)
    { pos = this.inDOMChange.mapping.map(pos); }
  return pos
};

// :: (union<"up", "down", "left", "right", "forward", "backward">, ?EditorState) → bool
// Find out whether the selection is at the end of a textblock when
// moving in a given direction. When, for example, given `"left"`,
// it will return true if moving left from the current cursor
// position would leave that position's parent textblock. Will apply
// to the view's current state by default, but it is possible to
// pass a different state.
EditorView.prototype.endOfTextblock = function endOfTextblock$1 (dir, state) {
  return endOfTextblock(this, state || this.state, dir)
};

// :: ()
// Removes the editor from the DOM and destroys all [node
// views](#view.NodeView).
EditorView.prototype.destroy = function destroy () {
  if (!this.docView) { return }
  destroyInput(this);
  this.destroyPluginViews();
  this.selectionReader.destroy();
  if (this.mounted) {
    this.docView.update(this.state.doc, [], viewDecorations(this), this);
    this.dom.textContent = "";
  } else if (this.dom.parentNode) {
    this.dom.parentNode.removeChild(this.dom);
  }
  this.docView.destroy();
  this.docView = null;
};

// Used for testing.
EditorView.prototype.dispatchEvent = function dispatchEvent$1 (event) {
  return dispatchEvent(this, event)
};

// :: (Transaction)
// Dispatch a transaction. Will call
// [`dispatchTransaction`](#view.DirectEditorProps.dispatchTransaction)
// when given, and otherwise defaults to applying the transaction to
// the current state and calling
// [`updateState`](#view.EditorView.updateState) with the result.
// This method is bound to the view instance, so that it can be
// easily passed around.
EditorView.prototype.dispatch = function dispatch (tr) {
  var dispatchTransaction = this._props.dispatchTransaction;
  if (dispatchTransaction) { dispatchTransaction.call(this, tr); }
  else { this.updateState(this.state.apply(tr)); }
};

Object.defineProperties( EditorView.prototype, prototypeAccessors );

function computeDocDeco(view) {
  var attrs = Object.create(null);
  attrs.class = "ProseMirror" + (view.focused ? " ProseMirror-focused" : "");
  attrs.contenteditable = String(view.editable);

  view.someProp("attributes", function (value) {
    if (typeof value == "function") { value = value(view.state); }
    if (value) { for (var attr in value) {
      if (attr == "class")
        { attrs.class += " " + value[attr]; }
      else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName")
        { attrs[attr] = String(value[attr]); }
    } }
  });

  return [Decoration.node(0, view.state.doc.content.size, attrs)]
}

function cursorWrapperDOM(visible) {
  var span = document.createElement("span");
  span.textContent = "\ufeff"; // zero-width non-breaking space
  if (!visible) {
    span.style.position = "absolute";
    span.style.left = "-100000px";
  }
  return span
}

function updateCursorWrapper(view) {
  var $pos = needsCursorWrapper(view.state);
  // On IE/Edge, moving the DOM selection will abort a mouse drag, so
  // there we delay the creation of the wrapper when the mouse is down.
  if ($pos && !(result.ie && view.mouseDown)) {
    var visible = view.state.selection.visible;
    // Needs a cursor wrapper
    var marks = view.state.storedMarks || $pos.marks(), dom;
    if (!view.cursorWrapper || !prosemirrorModel.Mark.sameSet(view.cursorWrapper.deco.spec.marks, marks) ||
        view.cursorWrapper.dom.textContent != "\ufeff" ||
        view.cursorWrapper.deco.spec.visible != visible)
      { dom = cursorWrapperDOM(visible); }
    else if (view.cursorWrapper.deco.pos != $pos.pos)
      { dom = view.cursorWrapper.dom; }
    if (dom)
      { view.cursorWrapper = {dom: dom, deco: Decoration.widget($pos.pos, dom, {isCursorWrapper: true, marks: marks, raw: true, visible: visible})}; }
  } else {
    view.cursorWrapper = null;
  }
}

function getEditable(view) {
  return !view.someProp("editable", function (value) { return value(view.state) === false; })
}

function selectionContext(root) {
  var ref = root.getSelection();
  var offset = ref.focusOffset;
  var node = ref.focusNode;
  if (!node || node.nodeType == 3) { return null }
  return [node, offset,
          node.nodeType == 1 ? node.childNodes[offset - 1] : null,
          node.nodeType == 1 ? node.childNodes[offset] : null]
}

function needChromeSelectionForce(context, root) {
  var newContext = selectionContext(root);
  if (!newContext || newContext[0].nodeType == 3) { return false }
  for (var i = 0; i < context.length; i++) { if (newContext[i] != context[i]) { return true } }
  return false
}

function buildNodeViews(view) {
  var result$$1 = {};
  view.someProp("nodeViews", function (obj) {
    for (var prop in obj) { if (!Object.prototype.hasOwnProperty.call(result$$1, prop))
      { result$$1[prop] = obj[prop]; } }
  });
  return result$$1
}

function changedNodeViews(a, b) {
  var nA = 0, nB = 0;
  for (var prop in a) {
    if (a[prop] != b[prop]) { return true }
    nA++;
  }
  for (var _ in b) { nB++; }
  return nA != nB
}

// EditorProps:: interface
//
// Props are configuration values that can be passed to an editor view
// or included in a plugin. This interface lists the supported props.
//
// The various event-handling functions may all return `true` to
// indicate that they handled the given event. The view will then take
// care to call `preventDefault` on the event, except with
// `handleDOMEvents`, where the handler itself is responsible for that.
//
// How a prop is resolved depends on the prop. Handler functions are
// called one at a time, starting with the base props and then
// searching through the plugins (in order of appearance) until one of
// them returns true. For some props, the first plugin that yields a
// value gets precedence.
//
//   handleDOMEvents:: ?Object<(view: EditorView, event: dom.Event) → bool>
//   Can be an object mapping DOM event type names to functions that
//   handle them. Such functions will be called before any handling
//   ProseMirror does of events fired on the editable DOM element.
//   Contrary to the other event handling props, when returning true
//   from such a function, you are responsible for calling
//   `preventDefault` yourself (or not, if you want to allow the
//   default behavior).
//
//   handleKeyDown:: ?(view: EditorView, event: dom.KeyboardEvent) → bool
//   Called when the editor receives a `keydown` event.
//
//   handleKeyPress:: ?(view: EditorView, event: dom.KeyboardEvent) → bool
//   Handler for `keypress` events.
//
//   handleTextInput:: ?(view: EditorView, from: number, to: number, text: string) → bool
//   Whenever the user directly input text, this handler is called
//   before the input is applied. If it returns `true`, the default
//   behavior of actually inserting the text is suppressed.
//
//   handleClickOn:: ?(view: EditorView, pos: number, node: Node, nodePos: number, event: dom.MouseEvent, direct: bool) → bool
//   Called for each node around a click, from the inside out. The
//   `direct` flag will be true for the inner node.
//
//   handleClick:: ?(view: EditorView, pos: number, event: dom.MouseEvent) → bool
//   Called when the editor is clicked, after `handleClickOn` handlers
//   have been called.
//
//   handleDoubleClickOn:: ?(view: EditorView, pos: number, node: Node, nodePos: number, event: dom.MouseEvent, direct: bool) → bool
//   Called for each node around a double click.
//
//   handleDoubleClick:: ?(view: EditorView, pos: number, event: dom.MouseEvent) → bool
//   Called when the editor is double-clicked, after `handleDoubleClickOn`.
//
//   handleTripleClickOn:: ?(view: EditorView, pos: number, node: Node, nodePos: number, event: dom.MouseEvent, direct: bool) → bool
//   Called for each node around a triple click.
//
//   handleTripleClick:: ?(view: EditorView, pos: number, event: dom.MouseEvent) → bool
//   Called when the editor is triple-clicked, after `handleTripleClickOn`.
//
//   handlePaste:: ?(view: EditorView, event: dom.Event, slice: Slice) → bool
//   Can be used to override the behavior of pasting. `slice` is the
//   pasted content parsed by the editor, but you can directly access
//   the event to get at the raw content.
//
//   handleDrop:: ?(view: EditorView, event: dom.Event, slice: Slice, moved: bool) → bool
//   Called when something is dropped on the editor. `moved` will be
//   true if this drop moves from the current selection (which should
//   thus be deleted).
//
//   handleScrollToSelection:: ?(view: EditorView) → bool
//   Called when the view, after updating its state, tries to scroll
//   the selection into view. A handler function may return false to
//   indicate that it did not handle the scrolling and further
//   handlers or the default behavior should be tried.
//
//   createSelectionBetween:: ?(view: EditorView, anchor: ResolvedPos, head: ResolvedPos) → ?Selection
//   Can be used to override the way a selection is created when
//   reading a DOM selection between the given anchor and head.
//
//   domParser:: ?DOMParser
//   The [parser](#model.DOMParser) to use when reading editor changes
//   from the DOM. Defaults to calling
//   [`DOMParser.fromSchema`](#model.DOMParser^fromSchema) on the
//   editor's schema.
//
//   transformPastedHTML:: ?(html: string) → string
//   Can be used to transform pasted HTML text, _before_ it is parsed,
//   for example to clean it up.
//
//   clipboardParser:: ?DOMParser
//   The [parser](#model.DOMParser) to use when reading content from
//   the clipboard. When not given, the value of the
//   [`domParser`](#view.EditorProps.domParser) prop is used.
//
//   transformPastedText:: ?(text: string) → string
//   Transform pasted plain text.
//
//   clipboardTextParser:: ?(text: string, $context: ResolvedPos) → Slice
//   A function to parse text from the clipboard into a document
//   slice. Called after
//   [`transformPastedText`](#view.EditorProps.transformPastedText).
//   The default behavior is to split the text into lines, wrap them
//   in `<p>` tags, and call
//   [`clipboardParser`](#view.EditorProps.clipboardParser) on it.
//
//   transformPasted:: ?(Slice) → Slice
//   Can be used to transform pasted content before it is applied to
//   the document.
//
//   nodeViews:: ?Object<(node: Node, view: EditorView, getPos: () → number, decorations: [Decoration]) → NodeView>
//   Allows you to pass custom rendering and behavior logic for nodes
//   and marks. Should map node and mark names to constructor
//   functions that produce a [`NodeView`](#view.NodeView) object
//   implementing the node's display behavior. For nodes, the third
//   argument `getPos` is a function that can be called to get the
//   node's current position, which can be useful when creating
//   transactions to update it. For marks, the third argument is a
//   boolean that indicates whether the mark's content is inline.
//
//   `decorations` is an array of node or inline decorations that are
//   active around the node. They are automatically drawn in the
//   normal way, and you will usually just want to ignore this, but
//   they can also be used as a way to provide context information to
//   the node view without adding it to the document itself.
//
//   clipboardSerializer:: ?DOMSerializer
//   The DOM serializer to use when putting content onto the
//   clipboard. If not given, the result of
//   [`DOMSerializer.fromSchema`](#model.DOMSerializer^fromSchema)
//   will be used.
//
//   clipboardTextSerializer:: ?(Slice) → string
//   A function that will be called to get the text for the current
//   selection when copying text to the clipboard. By default, the
//   editor will use [`textBetween`](#model.Node.textBetween) on the
//   selected range.
//
//   decorations:: ?(state: EditorState) → ?DecorationSet
//   A set of [document decorations](#view.Decoration) to show in the
//   view.
//
//   editable:: ?(state: EditorState) → bool
//   When this returns false, the content of the view is not directly
//   editable.
//
//   attributes:: ?union<Object<string>, (EditorState) → ?Object<string>>
//   Control the DOM attributes of the editable element. May be either
//   an object or a function going from an editor state to an object.
//   By default, the element will get a class `"ProseMirror"`, and
//   will have its `contentEditable` attribute determined by the
//   [`editable` prop](#view.EditorProps.editable). Additional classes
//   provided here will be added to the class. For other attributes,
//   the value provided first (as in
//   [`someProp`](#view.EditorView.someProp)) will be used.
//
//   scrollThreshold:: ?number | {top: number, right: number, bottom: number, left: number}
//   Determines the distance (in pixels) between the cursor and the
//   end of the visible viewport at which point, when scrolling the
//   cursor into view, scrolling takes place. Defaults to 0.
//
//   scrollMargin:: ?number | {top: number, right: number, bottom: number, left: number}
//   Determines the extra space (in pixels) that is left above or
//   below the cursor when it is scrolled into view. Defaults to 5.

// DirectEditorProps:: interface extends EditorProps
//
// The props object given directly to the editor view supports two
// fields that can't be used in plugins:
//
//   state:: EditorState
//   The current state of the editor.
//
//   dispatchTransaction:: ?(tr: Transaction)
//   The callback over which to send transactions (state updates)
//   produced by the view. If you specify this, you probably want to
//   make sure this ends up calling the view's
//   [`updateState`](#view.EditorView.updateState) method with a new
//   state that has the transaction
//   [applied](#state.EditorState.apply). The callback will be bound to have
//   the view instance as its `this` binding.

exports.EditorView = EditorView;
exports.Decoration = Decoration;
exports.DecorationSet = DecorationSet;
exports.__serializeForClipboard = serializeForClipboard;
exports.__parseFromClipboard = parseFromClipboard;
//# sourceMappingURL=index.js.map


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selection__ = __webpack_require__(2397);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_0__selection__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_0__selection__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_0__selection__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__decoration__ = __webpack_require__(2398);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__decoration__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__decoration__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodes__ = __webpack_require__(2399);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__nodes__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__nodes__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__nodes__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__nodes__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_2__nodes__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_2__nodes__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__colwidth__ = __webpack_require__(2400);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_3__colwidth__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__paste__ = __webpack_require__(2401);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_4__paste__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_4__paste__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dom__ = __webpack_require__(2402);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_5__dom__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_5__dom__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_5__dom__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__column_controls__ = __webpack_require__(2403);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__column_controls__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__column_controls__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_6__column_controls__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_6__column_controls__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_6__column_controls__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_6__column_controls__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__row_controls__ = __webpack_require__(2404);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_7__row_controls__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_7__row_controls__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_7__row_controls__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_7__row_controls__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_7__row_controls__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_7__row_controls__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fix_tables__ = __webpack_require__(2405);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_8__fix_tables__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__colgroup__ = __webpack_require__(2406);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_9__colgroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_9__colgroup__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_9__colgroup__["b"]; });
/* unused harmony reexport insertColgroupFromNode */










//# sourceMappingURL=index.js.map

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return customCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return frequentCategory; });
/* unused harmony export customType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return customTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return userCustomTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return dataURLPrefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return deleteEmojiLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAX_ORDINAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return defaultEmojiHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return emojiPickerWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return emojiPickerHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return localStoragePrefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return selectedToneStorageKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return defaultCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return defaultListLimit; });
/* unused harmony export migrationUserId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return analyticsEmojiPrefix; });
var customCategory = 'CUSTOM';
var frequentCategory = 'FREQUENT';
var customType = 'SITE';
var customTitle = 'allUploadsCustomCategory';
var userCustomTitle = 'userUploadsCustomCategory';
var dataURLPrefix = 'data:';
var deleteEmojiLabel = 'delete-emoji';
/**
 * A constant used in sorting/ordering to represent a number 'obviously much bigger than any item in the set being handled'.
 * This is used instead of Number.MAX_VALUE since subtraction of MAX_VALUE from itself occassionaly doesn't equal zero exactly :-(
 */
var MAX_ORDINAL = 100000;
var defaultEmojiHeight = 20;
var emojiPickerWidth = 350;
var emojiPickerHeight = 295;
var localStoragePrefix = 'fabric.emoji';
var selectedToneStorageKey = localStoragePrefix + ".selectedTone";
var defaultCategories = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS',
];
var defaultListLimit = 50;
var migrationUserId = 'hipchat_migration_emoticons';
var analyticsEmojiPrefix = 'atlassian.fabric.emoji.picker';
//# sourceMappingURL=constants.js.map

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return customCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return frequentCategory; });
/* unused harmony export customType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return customTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return userCustomTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return dataURLPrefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return deleteEmojiLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAX_ORDINAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return defaultEmojiHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return emojiPickerWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return emojiPickerHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return localStoragePrefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return selectedToneStorageKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return defaultCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return defaultListLimit; });
/* unused harmony export migrationUserId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return analyticsEmojiPrefix; });
var customCategory = 'CUSTOM';
var frequentCategory = 'FREQUENT';
var customType = 'SITE';
var customTitle = 'allUploadsCustomCategory';
var userCustomTitle = 'userUploadsCustomCategory';
var dataURLPrefix = 'data:';
var deleteEmojiLabel = 'delete-emoji';
/**
 * A constant used in sorting/ordering to represent a number 'obviously much bigger than any item in the set being handled'.
 * This is used instead of Number.MAX_VALUE since subtraction of MAX_VALUE from itself occassionaly doesn't equal zero exactly :-(
 */
var MAX_ORDINAL = 100000;
var defaultEmojiHeight = 20;
var emojiPickerWidth = 350;
var emojiPickerHeight = 295;
var localStoragePrefix = 'fabric.emoji';
var selectedToneStorageKey = localStoragePrefix + ".selectedTone";
var defaultCategories = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS',
];
var defaultListLimit = 50;
var migrationUserId = 'hipchat_migration_emoticons';
var analyticsEmojiPrefix = 'atlassian.fabric.emoji.picker';
//# sourceMappingURL=constants.js.map

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return customCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return frequentCategory; });
/* unused harmony export customType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return customTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return userCustomTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return dataURLPrefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return deleteEmojiLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAX_ORDINAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return defaultEmojiHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return emojiPickerWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return emojiPickerHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return localStoragePrefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return selectedToneStorageKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return defaultCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return defaultListLimit; });
/* unused harmony export migrationUserId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return analyticsEmojiPrefix; });
var customCategory = 'CUSTOM';
var frequentCategory = 'FREQUENT';
var customType = 'SITE';
var customTitle = 'allUploadsCustomCategory';
var userCustomTitle = 'userUploadsCustomCategory';
var dataURLPrefix = 'data:';
var deleteEmojiLabel = 'delete-emoji';
/**
 * A constant used in sorting/ordering to represent a number 'obviously much bigger than any item in the set being handled'.
 * This is used instead of Number.MAX_VALUE since subtraction of MAX_VALUE from itself occassionaly doesn't equal zero exactly :-(
 */
var MAX_ORDINAL = 100000;
var defaultEmojiHeight = 20;
var emojiPickerWidth = 350;
var emojiPickerHeight = 295;
var localStoragePrefix = 'fabric.emoji';
var selectedToneStorageKey = localStoragePrefix + ".selectedTone";
var defaultCategories = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS',
];
var defaultListLimit = 50;
var migrationUserId = 'hipchat_migration_emoticons';
var analyticsEmojiPrefix = 'atlassian.fabric.emoji.picker';
//# sourceMappingURL=constants.js.map

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_deep_extend__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_deep_extend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_deep_extend__);
// collection of global config values that are merged into each set of environment specific configs
var base={appName:'BAAT Portal',appFullName:'Build And Agile Tools Self-Service Portal',slack:{channelId:'C0JSX3QSZ'},mentionsIssue:'BAAT-3625',adminGroup:'Lst-digitaltech.baat',oAuth:{client_id:'nike.baat.selfservice',response_type:'id_token token',scope:'profile openid email legacy_username '}};var local=__WEBPACK_IMPORTED_MODULE_0_deep_extend___default()({env:'local',apiUrl:'http://localhost:8001/',oAuth:{redirect_uri:window.location.origin,authorization:'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/authorize'}},base);var lab=__WEBPACK_IMPORTED_MODULE_0_deep_extend___default()({env:'lab',apiUrl:'https://toolbox-lab.preprod.baat-atlassian-test.nikecloud.com/',oAuth:{redirect_uri:'https://ssp-lab.preprod.baat-atlassian-test.nikecloud.com',authorization:'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/authorize'}},base);var dev=__WEBPACK_IMPORTED_MODULE_0_deep_extend___default()({env:'dev',apiUrl:'https://toolbox.preprod.baat-atlassian-test.nikecloud.com/',oAuth:{redirect_uri:'https://ssp.preprod.baat-atlassian-test.nikecloud.com',authorization:'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/authorize'}},base);var niketech=__WEBPACK_IMPORTED_MODULE_0_deep_extend___default()({env:'prod',apiUrl:'https://toolbox.baat-atlassian-prod.nikecloud.com/',oAuth:{redirect_uri:'https://baat.niketech.com',authorization:'https://nike.okta.com/oauth2/aus27z7p76as9Dz0H1t7/v1/authorize'}},base);var prod=__WEBPACK_IMPORTED_MODULE_0_deep_extend___default()({env:'prod',apiUrl:'https://toolbox.baat-atlassian-prod.nikecloud.com/',oAuth:{redirect_uri:'https://ssp.baat-atlassian-prod.nikecloud.com',authorization:'https://nike.okta.com/oauth2/aus27z7p76as9Dz0H1t7/v1/authorize'}},base);// Determine which set of environment configs to use based on the url the site is being accessed via.
var config=void 0;if(window.location.origin.includes('//ssp.baat-atlassian-prod.nikecloud.com')){config=prod;}else if(window.location.origin.includes('//baat.niketech.com')){config=niketech;}else if(window.location.origin.includes('//localhost')){config=local;}else if(window.location.origin.includes('//ssp-lab')){config=lab;}else{config=dev;}/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var getTimezoneOffsetInMilliseconds = __webpack_require__(1707)
var isDate = __webpack_require__(639)

var MILLISECONDS_IN_HOUR = 3600000
var MILLISECONDS_IN_MINUTE = 60000
var DEFAULT_ADDITIONAL_DIGITS = 2

var parseTokenDateTimeDelimeter = /[T ]/
var parseTokenPlainTime = /:/

// year tokens
var parseTokenYY = /^(\d{2})$/
var parseTokensYYY = [
  /^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
]

var parseTokenYYYY = /^(\d{4})/
var parseTokensYYYYY = [
  /^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
]

// date tokens
var parseTokenMM = /^-(\d{2})$/
var parseTokenDDD = /^-?(\d{3})$/
var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/
var parseTokenWww = /^-?W(\d{2})$/
var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/

// time tokens
var parseTokenHH = /^(\d{2}([.,]\d*)?)$/
var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/
var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/

// timezone tokens
var parseTokenTimezone = /([Z+-].*)$/
var parseTokenTimezoneZ = /^(Z)$/
var parseTokenTimezoneHH = /^([+-])(\d{2})$/
var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/

/**
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If all above fails, the function passes the given argument to Date constructor.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {Object} [options] - the object with options
 * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parse('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Parse string '+02014101',
 * // if the additional number of digits in the extended year format is 1:
 * var result = parse('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function parse (argument, dirtyOptions) {
  if (isDate(argument)) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (typeof argument !== 'string') {
    return new Date(argument)
  }

  var options = dirtyOptions || {}
  var additionalDigits = options.additionalDigits
  if (additionalDigits == null) {
    additionalDigits = DEFAULT_ADDITIONAL_DIGITS
  } else {
    additionalDigits = Number(additionalDigits)
  }

  var dateStrings = splitDateString(argument)

  var parseYearResult = parseYear(dateStrings.date, additionalDigits)
  var year = parseYearResult.year
  var restDateString = parseYearResult.restDateString

  var date = parseDate(restDateString, year)

  if (date) {
    var timestamp = date.getTime()
    var time = 0
    var offset

    if (dateStrings.time) {
      time = parseTime(dateStrings.time)
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone) * MILLISECONDS_IN_MINUTE
    } else {
      var fullTime = timestamp + time
      var fullTimeDate = new Date(fullTime)

      offset = getTimezoneOffsetInMilliseconds(fullTimeDate)

      // Adjust time when it's coming from DST
      var fullTimeDateNextDay = new Date(fullTime)
      fullTimeDateNextDay.setDate(fullTimeDate.getDate() + 1)
      var offsetDiff =
        getTimezoneOffsetInMilliseconds(fullTimeDateNextDay) -
        getTimezoneOffsetInMilliseconds(fullTimeDate)
      if (offsetDiff > 0) {
        offset += offsetDiff
      }
    }

    return new Date(timestamp + time + offset)
  } else {
    return new Date(argument)
  }
}

function splitDateString (dateString) {
  var dateStrings = {}
  var array = dateString.split(parseTokenDateTimeDelimeter)
  var timeString

  if (parseTokenPlainTime.test(array[0])) {
    dateStrings.date = null
    timeString = array[0]
  } else {
    dateStrings.date = array[0]
    timeString = array[1]
  }

  if (timeString) {
    var token = parseTokenTimezone.exec(timeString)
    if (token) {
      dateStrings.time = timeString.replace(token[1], '')
      dateStrings.timezone = token[1]
    } else {
      dateStrings.time = timeString
    }
  }

  return dateStrings
}

function parseYear (dateString, additionalDigits) {
  var parseTokenYYY = parseTokensYYY[additionalDigits]
  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits]

  var token

  // YYYY or ±YYYYY
  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString)
  if (token) {
    var yearString = token[1]
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    }
  }

  // YY or ±YYY
  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString)
  if (token) {
    var centuryString = token[1]
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null
  }
}

function parseDate (dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token
  var date
  var month
  var week

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0)
    date.setUTCFullYear(year)
    return date
  }

  // YYYY-MM
  token = parseTokenMM.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    date.setUTCFullYear(year, month)
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = parseTokenDDD.exec(dateString)
  if (token) {
    date = new Date(0)
    var dayOfYear = parseInt(token[1], 10)
    date.setUTCFullYear(year, 0, dayOfYear)
    return date
  }

  // YYYY-MM-DD or YYYYMMDD
  token = parseTokenMMDD.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    var day = parseInt(token[2], 10)
    date.setUTCFullYear(year, month, day)
    return date
  }

  // YYYY-Www or YYYYWww
  token = parseTokenWww.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    return dayOfISOYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = parseTokenWwwD.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    var dayOfWeek = parseInt(token[2], 10) - 1
    return dayOfISOYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime (timeString) {
  var token
  var hours
  var minutes

  // hh
  token = parseTokenHH.exec(timeString)
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = parseTokenHHMM.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseFloat(token[2].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE
  }

  // hh:mm:ss or hhmmss
  token = parseTokenHHMMSS.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseInt(token[2], 10)
    var seconds = parseFloat(token[3].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE +
      seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function parseTimezone (timezoneString) {
  var token
  var absoluteOffset

  // Z
  token = parseTokenTimezoneZ.exec(timezoneString)
  if (token) {
    return 0
  }

  // ±hh
  token = parseTokenTimezoneHH.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = parseTokenTimezoneHHMM.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10)
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  return 0
}

function dayOfISOYear (isoYear, week, day) {
  week = week || 0
  day = day || 0
  var date = new Date(0)
  date.setUTCFullYear(isoYear, 0, 4)
  var fourthOfJanuaryDay = date.getUTCDay() || 7
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay
  date.setUTCDate(date.getUTCDate() + diff)
  return date
}

module.exports = parse


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = (function (fn) {
  var lastArgs = [];
  var frameId = null;

  var wrapperFn = function wrapperFn() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args;

    if (frameId) {
      return frameId;
    }

    frameId = requestAnimationFrame(function () {
      frameId = null;
      fn.apply(undefined, lastArgs);
    });

    return frameId;
  };

  wrapperFn.cancel = function () {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
  };

  var resultFn = wrapperFn;

  return resultFn;
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Separator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ExpandIconWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TriggerWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MenuWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return dropShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return scrollbarStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Shortcut; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



var akGridSize = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() + 'px';
var ButtonGroup = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: inline-flex;\n  align-items: center;\n\n  & > div {\n    display: flex;\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n\n  & > div {\n    display: flex;\n  }\n"])));
var Separator = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  background: ", ";\n  width: 1px;\n  height: 24px;\n  display: inline-block;\n  margin: 0 8px;\n"], ["\n  background: ", ";\n  width: 1px;\n  height: 24px;\n  display: inline-block;\n  margin: 0 8px;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30);
var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  align-items: center;\n\n  > div,\n  > span {\n    display: flex;\n  }\n\n  > div > div {\n    display: flex;\n  }\n  margin-left: ", "px;\n  min-width: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n\n  > div,\n  > span {\n    display: flex;\n  }\n\n  > div > div {\n    display: flex;\n  }\n  margin-left: ", "px;\n  min-width: ",
    ";\n"])), function (_a) {
    var isSmall = _a.isSmall;
    return (isSmall ? 4 : 0);
}, function (_a) {
    var isSmall = _a.isSmall;
    return isSmall ? '40px' : 'auto';
});
var ExpandIconWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin-left: -8px;\n"], ["\n  margin-left: -8px;\n"])));
var TriggerWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_5 || (templateObject_5 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var MenuWrapper = Wrapper;
var ButtonContent = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_6 || (templateObject_6 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  min-width: 80px;\n  height: 24px;\n  line-height: 24px;\n  align-items: center;\n  padding: ", ";\n  flex-direction: column;\n"], ["\n  display: flex;\n  min-width: 80px;\n  height: 24px;\n  line-height: 24px;\n  align-items: center;\n  padding: ", ";\n  flex-direction: column;\n"])), function (props) { return (props.width ? 0 : '0 8px'); });
// Taken from the style of inline dialog components
var dropShadow = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_7 || (templateObject_7 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  box-shadow: 0 0 1px rgba(9, 30, 66, 0.31),\n    0 4px 8px -2px rgba(9, 30, 66, 0.25);\n"], ["\n  box-shadow: 0 0 1px rgba(9, 30, 66, 0.31),\n    0 4px 8px -2px rgba(9, 30, 66, 0.25);\n"])));
var scrollbarStyles = "\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n\n  &::-webkit-scrollbar {\n    height: " + akGridSize + ";\n    width: " + akGridSize + ";\n  }\n\n  &::-webkit-scrollbar-corner {\n    display: none;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: rgba(0, 0, 0, 0);\n  }\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgba(0, 0, 0, 0.2);\n    border-radius: " + akGridSize + ";\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(0, 0, 0, 0.4);\n  }\n";
var Shortcut = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].small(templateObject_8 || (templateObject_8 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  color: ", ";\n  margin-top: 0;\n"], ["\n  color: ", ";\n  margin-top: 0;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N50);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorState = __webpack_require__(11);
var prosemirrorTransform = __webpack_require__(46);

// ::- Input rules are regular expressions describing a piece of text
// that, when typed, causes something to happen. This might be
// changing two dashes into an emdash, wrapping a paragraph starting
// with `"> "` into a blockquote, or something entirely different.
var InputRule = function InputRule(match, handler) {
  this.match = match;
  this.handler = typeof handler == "string" ? stringHandler(handler) : handler;
};

function stringHandler(string) {
  return function(state, match, start, end) {
    var insert = string;
    if (match[1]) {
      var offset = match[0].lastIndexOf(match[1]);
      insert += match[0].slice(offset + match[1].length);
      start += offset;
      var cutOff = start - end;
      if (cutOff > 0) {
        insert = match[0].slice(offset - cutOff, offset) + insert;
        start = end;
      }
    }
    var marks = state.doc.resolve(start).marks();
    return state.tr.replaceWith(start, end, state.schema.text(insert, marks))
  }
}

var MAX_MATCH = 500;

// :: (config: {rules: [InputRule]}) → Plugin
// Create an input rules plugin. When enabled, it will cause text
// input that matches any of the given rules to trigger the rule's
// action.
function inputRules(ref) {
  var rules = ref.rules;

  return new prosemirrorState.Plugin({
    state: {
      init: function init() { return null },
      apply: function apply(tr, prev) {
        var stored = tr.getMeta(this);
        if (stored) { return stored }
        return tr.selectionSet || tr.docChanged ? null : prev
      }
    },

    props: {
      handleTextInput: function handleTextInput(view, from, to, text) {
        var this$1 = this;

        var state = view.state, $from = state.doc.resolve(from);
        if ($from.parent.type.spec.code) { return false }
        var textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - MAX_MATCH), $from.parentOffset,
                                                  null, "\ufffc") + text;
        for (var i = 0; i < rules.length; i++) {
          var match = rules[i].match.exec(textBefore);
          var tr = match && rules[i].handler(state, match, from - (match[0].length - text.length), to);
          if (!tr) { continue }
          view.dispatch(tr.setMeta(this$1, {transform: tr, from: from, to: to, text: text}));
          return true
        }
        return false
      }
    },

    isInputRules: true
  })
}

// :: (EditorState, ?(Transaction)) → bool
// This is a command that will undo an input rule, if applying such a
// rule was the last thing that the user did.
function undoInputRule(state, dispatch) {
  var plugins = state.plugins;
  for (var i = 0; i < plugins.length; i++) {
    var plugin = plugins[i], undoable = (void 0);
    if (plugin.spec.isInputRules && (undoable = plugin.getState(state))) {
      if (dispatch) {
        var tr = state.tr, toUndo = undoable.transform;
        for (var j = toUndo.steps.length - 1; j >= 0; j--)
          { tr.step(toUndo.steps[j].invert(toUndo.docs[j])); }
        var marks = tr.doc.resolve(undoable.from).marks();
        dispatch(tr.replaceWith(undoable.from, undoable.to, state.schema.text(undoable.text, marks)));
      }
      return true
    }
  }
  return false
}

// :: InputRule Converts double dashes to an emdash.
var emDash = new InputRule(/--$/, "—");
// :: InputRule Converts three dots to an ellipsis character.
var ellipsis = new InputRule(/\.\.\.$/, "…");
// :: InputRule “Smart” opening double quotes.
var openDoubleQuote = new InputRule(/(?:^|[\s\{\[\(\<'"\u2018\u201C])(")$/, "“");
// :: InputRule “Smart” closing double quotes.
var closeDoubleQuote = new InputRule(/"$/, "”");
// :: InputRule “Smart” opening single quotes.
var openSingleQuote = new InputRule(/(?:^|[\s\{\[\(\<'"\u2018\u201C])(')$/, "‘");
// :: InputRule “Smart” closing single quotes.
var closeSingleQuote = new InputRule(/'$/, "’");

// :: [InputRule] Smart-quote related input rules.
var smartQuotes = [openDoubleQuote, closeDoubleQuote, openSingleQuote, closeSingleQuote];

// :: (RegExp, NodeType, ?union<Object, ([string]) → ?Object>, ?([string], Node) → bool) → InputRule
// Build an input rule for automatically wrapping a textblock when a
// given string is typed. The `regexp` argument is
// directly passed through to the `InputRule` constructor. You'll
// probably want the regexp to start with `^`, so that the pattern can
// only occur at the start of a textblock.
//
// `nodeType` is the type of node to wrap in. If it needs attributes,
// you can either pass them directly, or pass a function that will
// compute them from the regular expression match.
//
// By default, if there's a node with the same type above the newly
// wrapped node, the rule will try to [join](#transform.Transform.join) those
// two nodes. You can pass a join predicate, which takes a regular
// expression match and the node before the wrapped node, and can
// return a boolean to indicate whether a join should happen.
function wrappingInputRule(regexp, nodeType, getAttrs, joinPredicate) {
  return new InputRule(regexp, function (state, match, start, end) {
    var attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
    var tr = state.tr.delete(start, end);
    var $start = tr.doc.resolve(start), range = $start.blockRange(), wrapping = range && prosemirrorTransform.findWrapping(range, nodeType, attrs);
    if (!wrapping) { return null }
    tr.wrap(range, wrapping);
    var before = tr.doc.resolve(start - 1).nodeBefore;
    if (before && before.type == nodeType && prosemirrorTransform.canJoin(tr.doc, start - 1) &&
        (!joinPredicate || joinPredicate(match, before)))
      { tr.join(start - 1); }
    return tr
  })
}

// :: (RegExp, NodeType, ?union<Object, ([string]) → ?Object>) → InputRule
// Build an input rule that changes the type of a textblock when the
// matched text is typed into it. You'll usually want to start your
// regexp with `^` to that it is only matched at the start of a
// textblock. The optional `getAttrs` parameter can be used to compute
// the new node's attributes, and works the same as in the
// `wrappingInputRule` function.
function textblockTypeInputRule(regexp, nodeType, getAttrs) {
  return new InputRule(regexp, function (state, match, start, end) {
    var $start = state.doc.resolve(start);
    var attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
    if (!$start.node(-1).canReplaceWith($start.index(-1), $start.indexAfter(-1), nodeType)) { return null }
    return state.tr
      .delete(start, end)
      .setBlockType(start, start, nodeType, attrs)
  })
}

exports.InputRule = InputRule;
exports.inputRules = inputRules;
exports.undoInputRule = undoInputRule;
exports.emDash = emDash;
exports.ellipsis = ellipsis;
exports.openDoubleQuote = openDoubleQuote;
exports.closeDoubleQuote = closeDoubleQuote;
exports.openSingleQuote = openSingleQuote;
exports.closeSingleQuote = closeSingleQuote;
exports.smartQuotes = smartQuotes;
exports.wrappingInputRule = wrappingInputRule;
exports.textblockTypeInputRule = textblockTypeInputRule;
//# sourceMappingURL=index.js.map


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 79 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(479);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["l"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__providerFactory__ = __webpack_require__(481);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__providerFactory__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__providerFactory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(305);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_2__styles__["A"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui__ = __webpack_require__(919);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__ui__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__ui__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__ui__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__ui__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__ui__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_3__ui__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__ui__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_3__ui__["i"]; });




//# sourceMappingURL=index.js.map

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return messages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_add__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_chevron_down__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_chevron_down___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_chevron_down__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_table__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_image__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_code__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_code___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_code__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_editor_info__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_editor_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_editor_info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_editor_mention__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_editor_mention___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_editor_mention__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_icon_glyph_editor_task__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_icon_glyph_editor_task___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__atlaskit_icon_glyph_editor_task__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__atlaskit_icon_glyph_editor_decision__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__atlaskit_icon_glyph_editor_decision___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__atlaskit_icon_glyph_editor_decision__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__atlaskit_icon_glyph_quote__ = __webpack_require__(2392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__atlaskit_icon_glyph_quote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__atlaskit_icon_glyph_quote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__atlaskit_icon_glyph_editor_more__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__atlaskit_icon_glyph_editor_more___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__atlaskit_icon_glyph_editor_more__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__atlaskit_icon_glyph_editor_link__ = __webpack_require__(2393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__atlaskit_icon_glyph_editor_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__atlaskit_icon_glyph_editor_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__atlaskit_icon_glyph_editor_emoji__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__atlaskit_icon_glyph_editor_emoji___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__atlaskit_icon_glyph_editor_emoji__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__atlaskit_icon_glyph_editor_date__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__atlaskit_icon_glyph_editor_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__atlaskit_icon_glyph_editor_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__atlaskit_icon_glyph_label__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__atlaskit_icon_glyph_label___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__atlaskit_icon_glyph_label__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__atlaskit_icon_glyph_media_services_text__ = __webpack_require__(2394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__atlaskit_icon_glyph_media_services_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__atlaskit_icon_glyph_media_services_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__atlaskit_icon_glyph_editor_layout_two_equal__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__atlaskit_icon_glyph_editor_layout_two_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__atlaskit_icon_glyph_editor_layout_two_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__atlaskit_icon_glyph_editor_horizontal_rule__ = __webpack_require__(2395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__atlaskit_icon_glyph_editor_horizontal_rule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__atlaskit_icon_glyph_editor_horizontal_rule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__atlaskit_emoji__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__keymaps__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ui_DropdownMenu__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ui_ToolbarButton__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ui_styles__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__table_actions__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__date_actions__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__placeholder_text_actions__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__rule_pm_plugins_input_rule__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__styles__ = __webpack_require__(2448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__layout_actions__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__tasks_and_decisions_commands__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__hyperlink_commands__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__mentions_commands_insert_mention_query__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__status_actions__ = __webpack_require__(217);







































var messages = Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["defineMessages"])({
    action: {
        id: 'fabric.editor.action',
        defaultMessage: 'Action item',
        description: 'Also known as a “task”, “to do item”, or a checklist',
    },
    bulletList: {
        id: 'fabric.editor.bulletList',
        defaultMessage: 'Bullet list',
        description: 'Also known as a “unordered list”',
    },
    orderedList: {
        id: 'fabric.editor.orderedList',
        defaultMessage: 'Ordered list',
        description: 'Also known as a “numbered list”',
    },
    link: {
        id: 'fabric.editor.link',
        defaultMessage: 'Link',
        description: 'Insert a hyperlink',
    },
    filesAndImages: {
        id: 'fabric.editor.filesAndImages',
        defaultMessage: 'Files & images',
        description: 'Insert one or more files or images',
    },
    image: {
        id: 'fabric.editor.image',
        defaultMessage: 'Image',
        description: 'Insert an image.',
    },
    mention: {
        id: 'fabric.editor.mention',
        defaultMessage: 'Mention',
        description: 'Reference another person in your document',
    },
    emoji: {
        id: 'fabric.editor.emoji',
        defaultMessage: 'Emoji',
        description: 'Insert an emoticon or smiley :-)',
    },
    table: {
        id: 'fabric.editor.table',
        defaultMessage: 'Table',
        description: 'Inserts a table in the document',
    },
    decision: {
        id: 'fabric.editor.decision',
        defaultMessage: 'Decision',
        description: 'Capture a decision you’ve made',
    },
    horizontalRule: {
        id: 'fabric.editor.horizontalRule',
        defaultMessage: 'Divider',
        description: 'A horizontal rule or divider',
    },
    date: {
        id: 'fabric.editor.date',
        defaultMessage: 'Date',
        description: 'Opens a date picker that lets you select a date',
    },
    placeholderText: {
        id: 'fabric.editor.placeholderText',
        defaultMessage: 'Placeholder text',
        description: '',
    },
    columns: {
        id: 'fabric.editor.columns',
        defaultMessage: 'Columns',
        description: 'Create a multi column section or layout',
    },
    status: {
        id: 'fabric.editor.status',
        defaultMessage: 'Status',
        description: 'Inserts an item representing the status of an activity to task.',
    },
    viewMore: {
        id: 'fabric.editor.viewMore',
        defaultMessage: 'View more',
        description: '',
    },
    insertMenu: {
        id: 'fabric.editor.insertMenu',
        defaultMessage: 'Insert',
        description: 'Opens a menu of additional items that can be inserted into your document.',
    },
});
var blockTypeIcons = {
    codeblock: __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_code___default.a,
    panel: __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_editor_info___default.a,
    blockquote: __WEBPACK_IMPORTED_MODULE_13__atlaskit_icon_glyph_quote___default.a,
};
/**
 * Checks if an element is detached (i.e. not in the current document)
 */
var isDetachedElement = function (el) { return !document.body.contains(el); };
var noop = function () { };
var ToolbarInsertBlock = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ToolbarInsertBlock, _super);
    function ToolbarInsertBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false,
            emojiPickerOpen: false,
        };
        _this.onOpenChange = function (attrs) {
            var state = {
                isOpen: attrs.isOpen,
                emojiPickerOpen: _this.state.emojiPickerOpen,
            };
            if (_this.state.emojiPickerOpen && !attrs.open) {
                state.emojiPickerOpen = false;
            }
            _this.setState(state);
        };
        _this.handleTriggerClick = function () {
            var isOpen = _this.state.isOpen;
            _this.onOpenChange({ isOpen: !isOpen });
        };
        _this.toggleEmojiPicker = function () {
            var emojiPickerOpen = !_this.state.emojiPickerOpen;
            _this.setState({ emojiPickerOpen: emojiPickerOpen });
        };
        _this.handleButtonRef = function (ref) {
            var buttonRef = ref || null;
            if (buttonRef) {
                _this.button = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](buttonRef);
            }
        };
        _this.handleDropDownButtonRef = function (ref, items) {
            items.forEach(function (item) { return item.handleRef && item.handleRef(ref); });
        };
        _this.onPickerRef = function (ref) {
            if (ref) {
                document.addEventListener('click', _this.handleClickOutside);
            }
            else {
                document.removeEventListener('click', _this.handleClickOutside);
            }
            _this.pickerRef = ref;
        };
        _this.handleClickOutside = function (e) {
            var picker = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](_this.pickerRef);
            // Ignore click events for detached elements.
            // Workaround for FS-1322 - where two onClicks fire - one when the upload button is
            // still in the document, and one once it's detached. Does not always occur, and
            // may be a side effect of a react render optimisation
            if (!picker ||
                (!isDetachedElement(e.target) && !picker.contains(e.target))) {
                _this.toggleEmojiPicker();
            }
        };
        _this.createItems = function () {
            var _a = _this.props, isTypeAheadAllowed = _a.isTypeAheadAllowed, tableSupported = _a.tableSupported, mediaUploadsEnabled = _a.mediaUploadsEnabled, mediaSupported = _a.mediaSupported, imageUploadSupported = _a.imageUploadSupported, imageUploadEnabled = _a.imageUploadEnabled, mentionsSupported = _a.mentionsSupported, availableWrapperBlockTypes = _a.availableWrapperBlockTypes, actionSupported = _a.actionSupported, decisionSupported = _a.decisionSupported, macroProvider = _a.macroProvider, linkSupported = _a.linkSupported, linkDisabled = _a.linkDisabled, emojiDisabled = _a.emojiDisabled, emojiProvider = _a.emojiProvider, nativeStatusSupported = _a.nativeStatusSupported, insertMenuItems = _a.insertMenuItems, dateEnabled = _a.dateEnabled, placeholderTextEnabled = _a.placeholderTextEnabled, horizontalRuleEnabled = _a.horizontalRuleEnabled, layoutSectionEnabled = _a.layoutSectionEnabled, formatMessage = _a.intl.formatMessage;
            var items = [];
            if (actionSupported) {
                var labelAction = formatMessage(messages.action);
                items.push({
                    content: labelAction,
                    value: { name: 'action' },
                    elemBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__atlaskit_icon_glyph_editor_task___default.a, { label: labelAction }),
                    elemAfter: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_28__ui_styles__["f" /* Shortcut */], null, '[]'),
                    shortcut: '[]',
                });
            }
            if (linkSupported) {
                var labelLink = formatMessage(messages.link);
                var shortcutLink = Object(__WEBPACK_IMPORTED_MODULE_25__keymaps__["S" /* tooltip */])(__WEBPACK_IMPORTED_MODULE_25__keymaps__["d" /* addLink */]);
                items.push({
                    content: labelLink,
                    value: { name: 'link' },
                    isDisabled: linkDisabled,
                    elemBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__atlaskit_icon_glyph_editor_link___default.a, { label: labelLink }),
                    elemAfter: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_28__ui_styles__["f" /* Shortcut */], null, shortcutLink),
                    shortcut: shortcutLink,
                });
            }
            if (mediaSupported && mediaUploadsEnabled) {
                var labelFilesAndImages = formatMessage(messages.filesAndImages);
                items.push({
                    content: labelFilesAndImages,
                    value: { name: 'media' },
                    elemBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_image___default.a, { label: labelFilesAndImages }),
                });
            }
            if (imageUploadSupported) {
                var labelImage = formatMessage(messages.image);
                items.push({
                    content: labelImage,
                    value: { name: 'image upload' },
                    isDisabled: !imageUploadEnabled,
                    elemBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_image___default.a, { label: labelImage }),
                });
            }
            if (mentionsSupported) {
                var labelMention = formatMessage(messages.mention);
                items.push({
                    content: labelMention,
                    value: { name: 'mention' },
                    isDisabled: !isTypeAheadAllowed,
                    elemBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_editor_mention___default.a, { label: labelMention }),
                    elemAfter: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_28__ui_styles__["f" /* Shortcut */], null, "@"),
                    shortcut: '@',
                });
            }
            if (emojiProvider) {
                var labelEmoji = formatMessage(messages.emoji);
                items.push({
                    content: labelEmoji,
                    value: { name: 'emoji' },
                    isDisabled: emojiDisabled,
                    elemBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__atlaskit_icon_glyph_editor_emoji___default.a, { label: labelEmoji }),
                    handleRef: _this.handleButtonRef,
                    elemAfter: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_28__ui_styles__["f" /* Shortcut */], null, ":"),
                    shortcut: ':',
                });
            }
            if (tableSupported) {
                var labelTable = formatMessage(messages.table);
                var shortcutTable = Object(__WEBPACK_IMPORTED_MODULE_25__keymaps__["S" /* tooltip */])(__WEBPACK_IMPORTED_MODULE_25__keymaps__["Q" /* toggleTable */]);
                items.push({
                    content: labelTable,
                    value: { name: 'table' },
                    elemBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_table___default.a, { label: labelTable }),
                    elemAfter: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_28__ui_styles__["f" /* Shortcut */], null, shortcutTable),
                    shortcut: shortcutTable,
                });
            }
            if (availableWrapperBlockTypes) {
                availableWrapperBlockTypes.forEach(function (blockType) {
                    var BlockTypeIcon = blockTypeIcons[blockType.name];
                    var labelBlock = formatMessage(blockType.title);
                    var shortcutBlock = Object(__WEBPACK_IMPORTED_MODULE_25__keymaps__["S" /* tooltip */])(Object(__WEBPACK_IMPORTED_MODULE_25__keymaps__["n" /* findKeymapByDescription */])(blockType.title.defaultMessage));
                    items.push({
                        content: labelBlock,
                        value: blockType,
                        elemBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](BlockTypeIcon, { label: labelBlock }),
                        elemAfter: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_28__ui_styles__["f" /* Shortcut */], null, shortcutBlock),
                        shortcut: shortcutBlock,
                    });
                });
            }
            if (decisionSupported) {
                var labelDecision = formatMessage(messages.decision);
                items.push({
                    content: labelDecision,
                    value: { name: 'decision' },
                    elemBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__atlaskit_icon_glyph_editor_decision___default.a, { label: labelDecision }),
                    elemAfter: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_28__ui_styles__["f" /* Shortcut */], null, '<>'),
                    shortcut: '<>',
                });
            }
            if (horizontalRuleEnabled &&
                _this.props.editorView.state.schema.nodes.rule) {
                var labelHorizontalRule = formatMessage(messages.horizontalRule);
                items.push({
                    content: labelHorizontalRule,
                    value: { name: 'horizontalrule' },
                    elemBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21__atlaskit_icon_glyph_editor_horizontal_rule___default.a, { label: labelHorizontalRule }),
                    elemAfter: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_28__ui_styles__["f" /* Shortcut */], null, "---"),
                    shortcut: '---',
                });
            }
            if (dateEnabled) {
                var labelDate = formatMessage(messages.date);
                items.push({
                    content: labelDate,
                    value: { name: 'date' },
                    elemBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__atlaskit_icon_glyph_editor_date___default.a, { label: labelDate }),
                });
            }
            if (placeholderTextEnabled) {
                var labelPlaceholderText = formatMessage(messages.placeholderText);
                items.push({
                    content: labelPlaceholderText,
                    value: { name: 'placeholder text' },
                    elemBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19__atlaskit_icon_glyph_media_services_text___default.a, { label: labelPlaceholderText }),
                });
            }
            if (layoutSectionEnabled) {
                var labelColumns = formatMessage(messages.columns);
                items.push({
                    content: labelColumns,
                    value: { name: 'layout' },
                    elemBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20__atlaskit_icon_glyph_editor_layout_two_equal___default.a, { label: labelColumns }),
                });
            }
            if (nativeStatusSupported) {
                var labelStatus = formatMessage(messages.status);
                items.push({
                    content: labelStatus,
                    value: { name: 'status' },
                    elemBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__atlaskit_icon_glyph_label___default.a, { label: labelStatus }),
                });
            }
            if (insertMenuItems) {
                items = items.concat(insertMenuItems);
                // keeping this here for backwards compatibility so confluence
                // has time to implement this button before it disappears.
                // Should be safe to delete soon. If in doubt ask Leandro Lemos (llemos)
            }
            else if (typeof macroProvider !== 'undefined' && macroProvider) {
                var labelViewMore = formatMessage(messages.viewMore);
                items.push({
                    content: labelViewMore,
                    value: { name: 'macro' },
                    elemBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__atlaskit_icon_glyph_editor_more___default.a, { label: labelViewMore }),
                });
            }
            return items;
        };
        _this.toggleLinkPanel = Object(__WEBPACK_IMPORTED_MODULE_24__analytics__["c" /* withAnalytics */])('atlassian.editor.format.hyperlink.button', function () {
            var editorView = _this.props.editorView;
            Object(__WEBPACK_IMPORTED_MODULE_36__hyperlink_commands__["f" /* showLinkToolbar */])()(editorView.state, editorView.dispatch);
            return true;
        });
        _this.insertMention = Object(__WEBPACK_IMPORTED_MODULE_24__analytics__["c" /* withAnalytics */])('atlassian.fabric.mention.picker.trigger.button', function () {
            var editorView = _this.props.editorView;
            Object(__WEBPACK_IMPORTED_MODULE_37__mentions_commands_insert_mention_query__["a" /* insertMentionQuery */])()(editorView.state, editorView.dispatch);
            return true;
        });
        _this.createTable = Object(__WEBPACK_IMPORTED_MODULE_24__analytics__["c" /* withAnalytics */])('atlassian.editor.format.table.button', function () {
            var editorView = _this.props.editorView;
            Object(__WEBPACK_IMPORTED_MODULE_29__table_actions__["b" /* createTable */])(editorView.state, editorView.dispatch);
            return true;
        });
        _this.createDate = Object(__WEBPACK_IMPORTED_MODULE_24__analytics__["c" /* withAnalytics */])('atlassian.editor.format.date.button', function () {
            var editorView = _this.props.editorView;
            Object(__WEBPACK_IMPORTED_MODULE_30__date_actions__["b" /* insertDate */])()(editorView.state, editorView.dispatch);
            Object(__WEBPACK_IMPORTED_MODULE_30__date_actions__["c" /* openDatePicker */])(editorView.domAtPos.bind(editorView))(editorView.state, editorView.dispatch);
            return true;
        });
        _this.createPlaceholderText = Object(__WEBPACK_IMPORTED_MODULE_24__analytics__["c" /* withAnalytics */])('atlassian.editor.format.placeholder.button', function () {
            var editorView = _this.props.editorView;
            Object(__WEBPACK_IMPORTED_MODULE_31__placeholder_text_actions__["c" /* showPlaceholderFloatingToolbar */])(editorView.state, editorView.dispatch);
            return true;
        });
        _this.insertLayoutColumns = Object(__WEBPACK_IMPORTED_MODULE_24__analytics__["c" /* withAnalytics */])('atlassian.editor.format.layout.button', function () {
            var editorView = _this.props.editorView;
            Object(__WEBPACK_IMPORTED_MODULE_34__layout_actions__["e" /* insertLayoutColumns */])(editorView.state, editorView.dispatch);
            return true;
        });
        _this.createStatus = Object(__WEBPACK_IMPORTED_MODULE_24__analytics__["c" /* withAnalytics */])('atlassian.editor.format.status.button', function () {
            var editorView = _this.props.editorView;
            Object(__WEBPACK_IMPORTED_MODULE_38__status_actions__["e" /* updateStatus */])(undefined, true)(editorView);
            return true;
        });
        _this.openMediaPicker = Object(__WEBPACK_IMPORTED_MODULE_24__analytics__["c" /* withAnalytics */])('atlassian.editor.format.media.button', function () {
            var onShowMediaPicker = _this.props.onShowMediaPicker;
            onShowMediaPicker();
            return true;
        });
        _this.insertDecision = Object(__WEBPACK_IMPORTED_MODULE_24__analytics__["c" /* withAnalytics */])('atlassian.fabric.decision.trigger.button', function () {
            var editorView = _this.props.editorView;
            if (!editorView) {
                return false;
            }
            Object(__WEBPACK_IMPORTED_MODULE_35__tasks_and_decisions_commands__["b" /* insertTaskDecision */])(editorView, 'decisionList');
            return true;
        });
        _this.insertAction = Object(__WEBPACK_IMPORTED_MODULE_24__analytics__["c" /* withAnalytics */])('atlassian.fabric.action.trigger.button', function () {
            var editorView = _this.props.editorView;
            if (!editorView) {
                return false;
            }
            Object(__WEBPACK_IMPORTED_MODULE_35__tasks_and_decisions_commands__["b" /* insertTaskDecision */])(editorView, 'taskList');
            return true;
        });
        _this.insertHorizontalRule = Object(__WEBPACK_IMPORTED_MODULE_24__analytics__["c" /* withAnalytics */])('atlassian.editor.format.horizontalrule.button', function () {
            var editorView = _this.props.editorView;
            var tr = Object(__WEBPACK_IMPORTED_MODULE_32__rule_pm_plugins_input_rule__["a" /* createHorizontalRule */])(editorView.state, editorView.state.selection.from, editorView.state.selection.to);
            if (tr) {
                editorView.dispatch(tr);
                return true;
            }
            return false;
        });
        _this.handleSelectedEmoji = Object(__WEBPACK_IMPORTED_MODULE_24__analytics__["c" /* withAnalytics */])('atlassian.editor.emoji.button', function (emojiId) {
            _this.props.insertEmoji(emojiId);
            _this.toggleEmojiPicker();
            return true;
        });
        _this.onItemActivated = function (_a) {
            var item = _a.item;
            var _b = _this.props, editorView = _b.editorView, editorActions = _b.editorActions, onInsertBlockType = _b.onInsertBlockType, onInsertMacroFromMacroBrowser = _b.onInsertMacroFromMacroBrowser, macroProvider = _b.macroProvider, handleImageUpload = _b.handleImageUpload;
            switch (item.value.name) {
                case 'link':
                    _this.toggleLinkPanel();
                    break;
                case 'table':
                    _this.createTable();
                    break;
                case 'image upload':
                    if (handleImageUpload) {
                        var state_1 = editorView.state, dispatch_1 = editorView.dispatch;
                        handleImageUpload()(state_1, dispatch_1);
                    }
                    break;
                case 'media':
                    _this.openMediaPicker();
                    break;
                case 'mention':
                    _this.insertMention();
                    break;
                case 'emoji':
                    _this.toggleEmojiPicker();
                    break;
                case 'codeblock':
                case 'blockquote':
                case 'panel':
                    __WEBPACK_IMPORTED_MODULE_24__analytics__["a" /* analyticsService */].trackEvent("atlassian.editor.format." + item.value.name + ".button");
                    var state = editorView.state, dispatch = editorView.dispatch;
                    onInsertBlockType(item.value.name)(state, dispatch);
                    break;
                case 'action':
                    _this.insertAction();
                    break;
                case 'decision':
                    _this.insertDecision();
                    break;
                case 'horizontalrule':
                    _this.insertHorizontalRule();
                    break;
                case 'macro':
                    __WEBPACK_IMPORTED_MODULE_24__analytics__["a" /* analyticsService */].trackEvent("atlassian.editor.format." + item.value.name + ".button");
                    onInsertMacroFromMacroBrowser(macroProvider)(editorView.state, editorView.dispatch);
                    break;
                case 'date':
                    _this.createDate();
                    break;
                case 'placeholder text':
                    _this.createPlaceholderText();
                    break;
                case 'layout':
                    _this.insertLayoutColumns();
                    break;
                case 'status':
                    _this.createStatus();
                    break;
                default:
                    if (item && item.onClick) {
                        item.onClick(editorActions);
                        break;
                    }
            }
            _this.setState({ isOpen: false });
            if (!editorView.hasFocus()) {
                editorView.focus();
            }
        };
        return _this;
    }
    ToolbarInsertBlock.prototype.componentWillReceiveProps = function (nextProps) {
        // If number of visible buttons changed, close emoji picker
        if (nextProps.buttons !== this.props.buttons) {
            this.setState({ emojiPickerOpen: false });
        }
    };
    ToolbarInsertBlock.prototype.renderPopup = function () {
        var emojiPickerOpen = this.state.emojiPickerOpen;
        var _a = this.props, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, popupsScrollableElement = _a.popupsScrollableElement, emojiProvider = _a.emojiProvider;
        if (!emojiPickerOpen || !this.button || !emojiProvider) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23__atlaskit_editor_common__["e" /* Popup */], { target: this.button, fitHeight: 350, fitWidth: 350, offset: [0, 3], mountTo: popupsMountPoint, boundariesElement: popupsBoundariesElement, scrollableElement: popupsScrollableElement },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22__atlaskit_emoji__["a" /* EmojiPicker */], { emojiProvider: emojiProvider, onSelection: this.handleSelectedEmoji, onPickerRef: this.onPickerRef })));
    };
    ToolbarInsertBlock.prototype.render = function () {
        var _this = this;
        var isOpen = this.state.isOpen;
        var _a = this.props, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, popupsScrollableElement = _a.popupsScrollableElement, isDisabled = _a.isDisabled, numberOfButtons = _a.buttons, isReducedSpacing = _a.isReducedSpacing, formatMessage = _a.intl.formatMessage;
        var items = this.createItems();
        var buttons = items.slice(0, numberOfButtons);
        var dropdownItems = items.slice(numberOfButtons);
        if (items.length === 0) {
            return null;
        }
        var labelInsertMenu = formatMessage(messages.insertMenu);
        var toolbarButtonFactory = function (disabled, items) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_27__ui_ToolbarButton__["a" /* default */], { ref: function (el) { return _this.handleDropDownButtonRef(el, items); }, selected: isOpen, disabled: disabled, onClick: _this.handleTriggerClick, spacing: isReducedSpacing ? 'none' : 'default', title: labelInsertMenu + " /", iconBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_33__styles__["a" /* TriggerWrapper */], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_add___default.a, { label: labelInsertMenu }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_28__ui_styles__["c" /* ExpandIconWrapper */], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_chevron_down___default.a, { label: labelInsertMenu }))) })); };
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_28__ui_styles__["b" /* ButtonGroup */], { width: isReducedSpacing ? 'small' : 'large' },
            buttons.map(function (btn) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_27__ui_ToolbarButton__["a" /* default */], { ref: btn.handleRef || noop, key: btn.content, spacing: isReducedSpacing ? 'none' : 'default', disabled: isDisabled || btn.isDisabled, iconBefore: btn.elemBefore, selected: btn.isActive, title: btn.content + (btn.shortcut ? ' ' + btn.shortcut : ''), onClick: function () { return _this.onItemActivated({ item: btn }); } })); }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_28__ui_styles__["h" /* Wrapper */], null,
                this.renderPopup(),
                dropdownItems.length > 0 &&
                    (!isDisabled ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_26__ui_DropdownMenu__["a" /* default */], { items: [{ items: dropdownItems }], onItemActivated: this.onItemActivated, onOpenChange: this.onOpenChange, mountTo: popupsMountPoint, boundariesElement: popupsBoundariesElement, scrollableElement: popupsScrollableElement, isOpen: isOpen, fitHeight: 188, fitWidth: 175, zIndex: __WEBPACK_IMPORTED_MODULE_23__atlaskit_editor_common__["r" /* akEditorMenuZIndex */] }, toolbarButtonFactory(false, dropdownItems))) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, toolbarButtonFactory(true, dropdownItems)))))));
    };
    return ToolbarInsertBlock;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["injectIntl"])(ToolbarInsertBlock));
//# sourceMappingURL=index.js.map

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMark;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_duplicate_mark__ = __webpack_require__(2006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nodes_text__ = __webpack_require__(412);


function applyMark(mark, maybeNode) {
    var node = typeof maybeNode === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_1__nodes_text__["a" /* text */])(maybeNode) : maybeNode;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is_duplicate_mark__["b" /* isDuplicateMark */])(node, mark.type)) {
        // tslint:disable-next-line
        console.error(Object(__WEBPACK_IMPORTED_MODULE_0__is_duplicate_mark__["a" /* duplicateMarkError */])(node, mark.type));
        return node;
    }
    node.marks = node.marks || [];
    node.marks.push(mark);
    return node;
}
//# sourceMappingURL=apply-mark.js.map

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return pluginKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defaultTableSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPluginState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_view__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nodeviews_table__ = __webpack_require__(2396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nodeviews_cell__ = __webpack_require__(2426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_handlers__ = __webpack_require__(2427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__event_handlers__ = __webpack_require__(2428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(68);










var pluginKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('tablePlugin');
var defaultTableSelection = {
    hoveredColumns: [],
    hoveredRows: [],
    isInDanger: false,
};
var ACTIONS;
(function (ACTIONS) {
    ACTIONS[ACTIONS["SET_EDITOR_FOCUS"] = 0] = "SET_EDITOR_FOCUS";
    ACTIONS[ACTIONS["SET_TABLE_REF"] = 1] = "SET_TABLE_REF";
    ACTIONS[ACTIONS["SET_TARGET_CELL_POSITION"] = 2] = "SET_TARGET_CELL_POSITION";
    ACTIONS[ACTIONS["CLEAR_HOVER_SELECTION"] = 3] = "CLEAR_HOVER_SELECTION";
    ACTIONS[ACTIONS["HOVER_COLUMNS"] = 4] = "HOVER_COLUMNS";
    ACTIONS[ACTIONS["HOVER_ROWS"] = 5] = "HOVER_ROWS";
    ACTIONS[ACTIONS["HOVER_TABLE"] = 6] = "HOVER_TABLE";
    ACTIONS[ACTIONS["TOGGLE_CONTEXTUAL_MENU"] = 7] = "TOGGLE_CONTEXTUAL_MENU";
    ACTIONS[ACTIONS["SHOW_INSERT_COLUMN_BUTTON"] = 8] = "SHOW_INSERT_COLUMN_BUTTON";
    ACTIONS[ACTIONS["SHOW_INSERT_ROW_BUTTON"] = 9] = "SHOW_INSERT_ROW_BUTTON";
    ACTIONS[ACTIONS["HIDE_INSERT_COLUMN_OR_ROW_BUTTON"] = 10] = "HIDE_INSERT_COLUMN_OR_ROW_BUTTON";
})(ACTIONS || (ACTIONS = {}));
var createPlugin = function (dispatch, portalProviderAPI, eventDispatcher, pluginConfig, appearance) {
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        state: {
            init: function () {
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ pluginConfig: pluginConfig, insertColumnButtonIndex: undefined, insertRowButtonIndex: undefined, decorationSet: __WEBPACK_IMPORTED_MODULE_3_prosemirror_view__["DecorationSet"].empty }, defaultTableSelection);
            },
            apply: function (tr, _pluginState, _, state) {
                var meta = tr.getMeta(pluginKey) || {};
                var data = meta.data || {};
                var editorHasFocus = data.editorHasFocus, tableRef = data.tableRef, targetCellPosition = data.targetCellPosition, hoverDecoration = data.hoverDecoration, hoveredColumns = data.hoveredColumns, hoveredRows = data.hoveredRows, isInDanger = data.isInDanger, insertColumnButtonIndex = data.insertColumnButtonIndex, insertRowButtonIndex = data.insertRowButtonIndex;
                var pluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, _pluginState);
                if (tr.docChanged && pluginState.targetCellPosition) {
                    var _a = tr.mapping.mapResult(pluginState.targetCellPosition), pos = _a.pos, deleted = _a.deleted;
                    pluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { targetCellPosition: deleted ? undefined : pos });
                }
                switch (meta.action) {
                    case ACTIONS.SET_EDITOR_FOCUS:
                        return Object(__WEBPACK_IMPORTED_MODULE_7__action_handlers__["g" /* handleSetFocus */])(editorHasFocus)(pluginState, dispatch);
                    case ACTIONS.SET_TABLE_REF:
                        return Object(__WEBPACK_IMPORTED_MODULE_7__action_handlers__["h" /* handleSetTableRef */])(state, tableRef)(pluginState, dispatch);
                    case ACTIONS.SET_TARGET_CELL_POSITION:
                        return Object(__WEBPACK_IMPORTED_MODULE_7__action_handlers__["i" /* handleSetTargetCellPosition */])(targetCellPosition)(pluginState, dispatch);
                    case ACTIONS.CLEAR_HOVER_SELECTION:
                        return Object(__WEBPACK_IMPORTED_MODULE_7__action_handlers__["a" /* handleClearSelection */])(pluginState, dispatch);
                    case ACTIONS.HOVER_COLUMNS:
                        return Object(__WEBPACK_IMPORTED_MODULE_7__action_handlers__["d" /* handleHoverColumns */])(state, hoverDecoration, hoveredColumns, isInDanger)(pluginState, dispatch);
                    case ACTIONS.HOVER_ROWS:
                        return Object(__WEBPACK_IMPORTED_MODULE_7__action_handlers__["e" /* handleHoverRows */])(state, hoverDecoration, hoveredRows, isInDanger)(pluginState, dispatch);
                    case ACTIONS.HOVER_TABLE:
                        return Object(__WEBPACK_IMPORTED_MODULE_7__action_handlers__["f" /* handleHoverTable */])(state, hoverDecoration, hoveredColumns, hoveredRows, isInDanger)(pluginState, dispatch);
                    case ACTIONS.TOGGLE_CONTEXTUAL_MENU:
                        return Object(__WEBPACK_IMPORTED_MODULE_7__action_handlers__["l" /* handleToggleContextualMenu */])(pluginState, dispatch);
                    case ACTIONS.SHOW_INSERT_COLUMN_BUTTON:
                        return Object(__WEBPACK_IMPORTED_MODULE_7__action_handlers__["j" /* handleShowInsertColumnButton */])(insertColumnButtonIndex)(pluginState, dispatch);
                    case ACTIONS.SHOW_INSERT_ROW_BUTTON:
                        return Object(__WEBPACK_IMPORTED_MODULE_7__action_handlers__["k" /* handleShowInsertRowButton */])(insertRowButtonIndex)(pluginState, dispatch);
                    case ACTIONS.HIDE_INSERT_COLUMN_OR_ROW_BUTTON:
                        return Object(__WEBPACK_IMPORTED_MODULE_7__action_handlers__["c" /* handleHideInsertColumnOrRowButton */])(pluginState, dispatch);
                    default:
                        break;
                }
                if (tr.docChanged || tr.selectionSet) {
                    return Object(__WEBPACK_IMPORTED_MODULE_7__action_handlers__["b" /* handleDocOrSelectionChanged */])(tr)(pluginState, dispatch);
                }
                return pluginState;
            },
        },
        key: pluginKey,
        appendTransaction: function (transactions, oldState, newState) {
            var tr = transactions.find(function (tr) { return tr.getMeta('uiEvent') === 'cut'; });
            if (tr) {
                // "fixTables" removes empty rows as we don't allow that in schema
                return Object(__WEBPACK_IMPORTED_MODULE_9__utils__["g" /* fixTables */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["j" /* handleCut */])(tr, oldState, newState));
            }
            if (transactions.find(function (tr) { return tr.docChanged; })) {
                return Object(__WEBPACK_IMPORTED_MODULE_9__utils__["g" /* fixTables */])(newState.tr);
            }
            if (transactions.find(function (tr) { return tr.selectionSet; })) {
                return Object(__WEBPACK_IMPORTED_MODULE_9__utils__["C" /* normalizeSelection */])(newState.tr);
            }
        },
        view: function (editorView) {
            var domAtPos = editorView.domAtPos.bind(editorView);
            return {
                update: function (view) {
                    var state = view.state, dispatch = view.dispatch;
                    var selection = state.selection;
                    var pluginState = getPluginState(state);
                    var tableRef;
                    if (pluginState.editorHasFocus) {
                        var parent_1 = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["findParentDomRefOfType"])(state.schema.nodes.table, domAtPos)(selection);
                        if (parent_1) {
                            tableRef = parent_1.querySelector('table');
                        }
                    }
                    if (pluginState.tableRef !== tableRef) {
                        Object(__WEBPACK_IMPORTED_MODULE_6__actions__["w" /* setTableRef */])(tableRef)(state, dispatch);
                    }
                },
            };
        },
        props: {
            decorations: function (state) { return getPluginState(state).decorationSet; },
            handleClick: function (_a) {
                var state = _a.state, dispatch = _a.dispatch;
                var decorationSet = getPluginState(state).decorationSet;
                if (Object(__WEBPACK_IMPORTED_MODULE_9__utils__["f" /* findControlsHoverDecoration */])(decorationSet).length) {
                    Object(__WEBPACK_IMPORTED_MODULE_6__actions__["a" /* clearHoverSelection */])(state, dispatch);
                }
                return false;
            },
            nodeViews: {
                table: Object(__WEBPACK_IMPORTED_MODULE_4__nodeviews_table__["a" /* createTableView */])(portalProviderAPI),
                tableCell: Object(__WEBPACK_IMPORTED_MODULE_5__nodeviews_cell__["a" /* createCellView */])(portalProviderAPI, appearance),
                tableHeader: Object(__WEBPACK_IMPORTED_MODULE_5__nodeviews_cell__["a" /* createCellView */])(portalProviderAPI, appearance),
            },
            handleDOMEvents: {
                blur: __WEBPACK_IMPORTED_MODULE_8__event_handlers__["a" /* handleBlur */],
                focus: __WEBPACK_IMPORTED_MODULE_8__event_handlers__["c" /* handleFocus */],
                mousedown: __WEBPACK_IMPORTED_MODULE_8__event_handlers__["d" /* handleMouseDown */],
                mouseover: __WEBPACK_IMPORTED_MODULE_8__event_handlers__["f" /* handleMouseOver */],
                mouseleave: __WEBPACK_IMPORTED_MODULE_8__event_handlers__["e" /* handleMouseLeave */],
                click: __WEBPACK_IMPORTED_MODULE_8__event_handlers__["b" /* handleClick */],
            },
            handleTripleClick: __WEBPACK_IMPORTED_MODULE_8__event_handlers__["g" /* handleTripleClick */],
        },
    });
};
var getPluginState = function (state) {
    return pluginKey.getState(state);
};
//# sourceMappingURL=main.js.map

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReactNodeView__ = __webpack_require__(162);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ReactNodeView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_adapter__ = __webpack_require__(2442);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__context_adapter__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reduce; });
/* unused harmony export nodeToReducerMapping */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__blockquote__ = __webpack_require__(3123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bulletList__ = __webpack_require__(3124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__decisionItem__ = __webpack_require__(3125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hardBreak__ = __webpack_require__(3126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__heading__ = __webpack_require__(3127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__listItem__ = __webpack_require__(3128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mediaGroup__ = __webpack_require__(3129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__orderedList__ = __webpack_require__(3130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__panel__ = __webpack_require__(3131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__paragraph__ = __webpack_require__(3132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rule__ = __webpack_require__(3133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__table__ = __webpack_require__(3134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__taskItem__ = __webpack_require__(3135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__unknown__ = __webpack_require__(3136);














var reduce = function (node, schema) {
    var reducer = nodeToReducerMapping[node.type.name] || nodeToReducerMapping.unknown;
    return reducer(node, schema);
};
var nodeToReducerMapping = {
    blockquote: __WEBPACK_IMPORTED_MODULE_0__blockquote__["a" /* default */],
    bulletList: __WEBPACK_IMPORTED_MODULE_1__bulletList__["a" /* default */],
    decisionItem: __WEBPACK_IMPORTED_MODULE_2__decisionItem__["a" /* default */],
    hardBreak: __WEBPACK_IMPORTED_MODULE_3__hardBreak__["a" /* default */],
    heading: __WEBPACK_IMPORTED_MODULE_4__heading__["a" /* default */],
    listItem: __WEBPACK_IMPORTED_MODULE_5__listItem__["a" /* default */],
    mediaGroup: __WEBPACK_IMPORTED_MODULE_6__mediaGroup__["a" /* default */],
    orderedList: __WEBPACK_IMPORTED_MODULE_7__orderedList__["a" /* default */],
    panel: __WEBPACK_IMPORTED_MODULE_8__panel__["a" /* default */],
    paragraph: __WEBPACK_IMPORTED_MODULE_9__paragraph__["a" /* default */],
    rule: __WEBPACK_IMPORTED_MODULE_10__rule__["a" /* default */],
    table: __WEBPACK_IMPORTED_MODULE_11__table__["a" /* default */],
    taskItem: __WEBPACK_IMPORTED_MODULE_12__taskItem__["a" /* default */],
    unknown: __WEBPACK_IMPORTED_MODULE_13__unknown__["a" /* default */],
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isSpriteServiceRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isSpriteRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isImageRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isMediaRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isMediaEmoji; });
/* unused harmony export hasDataURLImage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isLoadedMediaEmoji; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isEmojiDescriptionWithVariations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isEmojiVariationDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return toEmojiId; });
/* unused harmony export toOptionalEmojiId */
/* unused harmony export isEmojiIdEqual */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return containsEmojiId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return convertImageToMediaRepresentation; });
/* unused harmony export convertMediaToImageRepresentation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return convertMediaToImageEmoji; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildEmojiDescriptionWithAltRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCategoryId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(69);


var isSpriteServiceRepresentation = function (rep) {
    return !!(rep && rep.spriteRef);
};
var isSpriteRepresentation = function (rep) {
    return !!(rep && rep.sprite);
};
var isImageRepresentation = function (rep) {
    return !!(rep && rep.imagePath);
};
var isMediaRepresentation = function (rep) {
    return !!(rep && rep.mediaPath);
};
var isPromise = function (p) {
    return !!(p && p.then);
};
var isMediaEmoji = function (emoji) {
    return isMediaRepresentation(emoji.representation);
};
var hasDataURLImage = function (rep) {
    return isImageRepresentation(rep) && rep.imagePath.indexOf(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* dataURLPrefix */]) === 0;
};
var isLoadedMediaEmoji = function (emoji) {
    return emoji.category === __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* customCategory */] && hasDataURLImage(emoji.representation);
};
var isEmojiDescriptionWithVariations = function (emoji) {
    return !!(emoji && emoji.skinVariations);
};
var isEmojiVariationDescription = function (object) {
    return 'baseId' in object;
};
var toEmojiId = function (emoji) { return ({
    shortName: emoji.shortName,
    id: emoji.id,
    fallback: emoji.fallback,
}); };
var toOptionalEmojiId = function (emoji) {
    if (!emoji) {
        return undefined;
    }
    return toEmojiId(emoji);
};
var isEmojiIdEqual = function (l, r) {
    return l === r || (l && r && l.id === r.id && l.shortName === r.shortName);
};
var containsEmojiId = function (emojis, emojiId) {
    if (!emojiId) {
        return false;
    }
    for (var i = 0; i < emojis.length; i++) {
        if (isEmojiIdEqual(emojis[i], emojiId)) {
            return true;
        }
    }
    return false;
};
var convertImageToMediaRepresentation = function (rep) { return ({
    mediaPath: rep.imagePath,
    height: rep.height,
    width: rep.width,
}); };
var convertMediaToImageRepresentation = function (rep, newImagePath) { return ({
    imagePath: newImagePath || rep.mediaPath,
    height: rep.height,
    width: rep.width,
}); };
var convertMediaToImageEmoji = function (emoji, newImagePath, useAlt) {
    var mediaRepresentation = emoji.representation;
    var mediaAltRepresentation = emoji.altRepresentation;
    var imgPath = !useAlt ? newImagePath : undefined;
    var altImgPath = useAlt ? newImagePath : undefined;
    if (!isMediaRepresentation(mediaRepresentation) &&
        !isMediaRepresentation(mediaAltRepresentation)) {
        return emoji;
    }
    var representation = isMediaRepresentation(mediaRepresentation)
        ? convertMediaToImageRepresentation(mediaRepresentation, imgPath)
        : mediaRepresentation;
    var altRepresentation = isMediaRepresentation(mediaAltRepresentation)
        ? convertMediaToImageRepresentation(mediaAltRepresentation, altImgPath)
        : mediaAltRepresentation;
    var baseEmoji = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, emoji, { representation: representation });
    return buildEmojiDescriptionWithAltRepresentation(baseEmoji, altRepresentation);
};
// Prevent altRepresentation: undefined from being returned in EmojiDescription
var buildEmojiDescriptionWithAltRepresentation = function (emoji, altRepresentation) {
    if (!altRepresentation) {
        return emoji;
    }
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, emoji, { altRepresentation: altRepresentation });
};
var getCategoryId = function (emoji) {
    return emoji.category;
};
//# sourceMappingURL=type-helpers.js.map

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(54);

var _interopRequireDefault = __webpack_require__(53);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.size = exports.default = exports.IconWrapper = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(4));

var _createClass2 = _interopRequireDefault(__webpack_require__(5));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(7));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(6));

var _inherits2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _styledComponents = _interopRequireDefault(__webpack_require__(2));

var _uuid = _interopRequireDefault(__webpack_require__(22));

var _theme = __webpack_require__(330);

var _constants = __webpack_require__(2600);

var getSize = function getSize(props) {
  if (props.size) {
    return "height: ".concat(_constants.sizes[props.size], "; width: ").concat(_constants.sizes[props.size], ";");
  }

  return null;
};

var IconWrapper = _styledComponents.default.span.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "dyhwwi-0"
})(["\n  ", " color: ", ";\n  display: inline-block;\n  fill: ", ";\n  flex-shrink: 0;\n  line-height: 1;\n\n  > svg {\n    ", " max-height: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    pointer-events: none;\n    vertical-align: bottom;\n  }\n  /* Stop-color doesn't properly apply in chrome when the inherited/current color changes.\n   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS\n   * rule) and then override it with currentColor for the color changes to be picked up.\n   */\n  stop {\n    stop-color: currentColor;\n  }\n"], getSize, function (p) {
  return p.primaryColor || 'currentColor';
}, function (p) {
  return p.secondaryColor || _theme.colors.background;
}, getSize);

exports.IconWrapper = IconWrapper;

var Icon =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Icon, _Component);

  function Icon() {
    (0, _classCallCheck2.default)(this, Icon);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Icon).apply(this, arguments));
  }

  (0, _createClass2.default)(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Glyph = _this$props.glyph,
          dangerouslySetGlyph = _this$props.dangerouslySetGlyph,
          onClick = _this$props.onClick,
          primaryColor = _this$props.primaryColor,
          secondaryColor = _this$props.secondaryColor,
          size = _this$props.size; // handling the glyphs as strings

      if (dangerouslySetGlyph) {
        return _react.default.createElement(IconWrapper, {
          onClick: onClick,
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          size: size,
          "aria-label": this.props.label,
          dangerouslySetInnerHTML: {
            __html: Icon.insertDynamicGradientID(dangerouslySetGlyph)
          }
        });
      } // handling the glyphs when passed through as functions


      return _react.default.createElement(IconWrapper, {
        onClick: onClick,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        "aria-label": this.props.label
      }, Glyph ? _react.default.createElement(Glyph, {
        role: "presentation"
      }) : null);
    }
  }], [{
    key: "insertDynamicGradientID",

    /* Icons need unique gradient IDs across instances for different gradient definitions to work
     * correctly.
     * A step in the icon build process replaces linear gradient IDs and their references in paths
     * to a placeholder string so we can replace them with a dynamic ID here.
     * Replacing the original IDs with placeholders in the build process is more robust than not
     * using placeholders as we do not have to rely on regular expressions to find specific element
     * to replace.
     */
    value: function insertDynamicGradientID(svgStr) {
      var id = (0, _uuid.default)();
      var replacedSvgStr = svgStr.replace(/id="([^"]+)-idPlaceholder"/g, "id=$1-".concat(id)).replace(/fill="url\(#([^"]+)-idPlaceholder\)"/g, "fill=\"url(#$1-".concat(id, ")\""));
      return replacedSvgStr;
    }
  }]);
  return Icon;
}(_react.Component);

exports.default = Icon;
(0, _defineProperty2.default)(Icon, "defaultProps", {
  onClick: function onClick() {}
});
var size = Object.keys(_constants.sizes).reduce(function (p, c) {
  return Object.assign(p, (0, _defineProperty2.default)({}, c, c));
}, {});
exports.size = size;

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isSpriteServiceRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isSpriteRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isImageRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isMediaRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isMediaEmoji; });
/* unused harmony export hasDataURLImage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isLoadedMediaEmoji; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isEmojiDescriptionWithVariations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isEmojiVariationDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return toEmojiId; });
/* unused harmony export toOptionalEmojiId */
/* unused harmony export isEmojiIdEqual */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return containsEmojiId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return convertImageToMediaRepresentation; });
/* unused harmony export convertMediaToImageRepresentation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return convertMediaToImageEmoji; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildEmojiDescriptionWithAltRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCategoryId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(70);


var isSpriteServiceRepresentation = function (rep) {
    return !!(rep && rep.spriteRef);
};
var isSpriteRepresentation = function (rep) {
    return !!(rep && rep.sprite);
};
var isImageRepresentation = function (rep) {
    return !!(rep && rep.imagePath);
};
var isMediaRepresentation = function (rep) {
    return !!(rep && rep.mediaPath);
};
var isPromise = function (p) {
    return !!(p && p.then);
};
var isMediaEmoji = function (emoji) {
    return isMediaRepresentation(emoji.representation);
};
var hasDataURLImage = function (rep) {
    return isImageRepresentation(rep) && rep.imagePath.indexOf(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* dataURLPrefix */]) === 0;
};
var isLoadedMediaEmoji = function (emoji) {
    return emoji.category === __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* customCategory */] && hasDataURLImage(emoji.representation);
};
var isEmojiDescriptionWithVariations = function (emoji) {
    return !!(emoji && emoji.skinVariations);
};
var isEmojiVariationDescription = function (object) {
    return 'baseId' in object;
};
var toEmojiId = function (emoji) { return ({
    shortName: emoji.shortName,
    id: emoji.id,
    fallback: emoji.fallback,
}); };
var toOptionalEmojiId = function (emoji) {
    if (!emoji) {
        return undefined;
    }
    return toEmojiId(emoji);
};
var isEmojiIdEqual = function (l, r) {
    return l === r || (l && r && l.id === r.id && l.shortName === r.shortName);
};
var containsEmojiId = function (emojis, emojiId) {
    if (!emojiId) {
        return false;
    }
    for (var i = 0; i < emojis.length; i++) {
        if (isEmojiIdEqual(emojis[i], emojiId)) {
            return true;
        }
    }
    return false;
};
var convertImageToMediaRepresentation = function (rep) { return ({
    mediaPath: rep.imagePath,
    height: rep.height,
    width: rep.width,
}); };
var convertMediaToImageRepresentation = function (rep, newImagePath) { return ({
    imagePath: newImagePath || rep.mediaPath,
    height: rep.height,
    width: rep.width,
}); };
var convertMediaToImageEmoji = function (emoji, newImagePath, useAlt) {
    var mediaRepresentation = emoji.representation;
    var mediaAltRepresentation = emoji.altRepresentation;
    var imgPath = !useAlt ? newImagePath : undefined;
    var altImgPath = useAlt ? newImagePath : undefined;
    if (!isMediaRepresentation(mediaRepresentation) &&
        !isMediaRepresentation(mediaAltRepresentation)) {
        return emoji;
    }
    var representation = isMediaRepresentation(mediaRepresentation)
        ? convertMediaToImageRepresentation(mediaRepresentation, imgPath)
        : mediaRepresentation;
    var altRepresentation = isMediaRepresentation(mediaAltRepresentation)
        ? convertMediaToImageRepresentation(mediaAltRepresentation, altImgPath)
        : mediaAltRepresentation;
    var baseEmoji = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, emoji, { representation: representation });
    return buildEmojiDescriptionWithAltRepresentation(baseEmoji, altRepresentation);
};
// Prevent altRepresentation: undefined from being returned in EmojiDescription
var buildEmojiDescriptionWithAltRepresentation = function (emoji, altRepresentation) {
    if (!altRepresentation) {
        return emoji;
    }
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, emoji, { altRepresentation: altRepresentation });
};
var getCategoryId = function (emoji) {
    return emoji.category;
};
//# sourceMappingURL=type-helpers.js.map

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isSpriteServiceRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isSpriteRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isImageRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isMediaRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isMediaEmoji; });
/* unused harmony export hasDataURLImage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isLoadedMediaEmoji; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isEmojiDescriptionWithVariations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isEmojiVariationDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return toEmojiId; });
/* unused harmony export toOptionalEmojiId */
/* unused harmony export isEmojiIdEqual */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return containsEmojiId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return convertImageToMediaRepresentation; });
/* unused harmony export convertMediaToImageRepresentation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return convertMediaToImageEmoji; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildEmojiDescriptionWithAltRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCategoryId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(71);


var isSpriteServiceRepresentation = function (rep) {
    return !!(rep && rep.spriteRef);
};
var isSpriteRepresentation = function (rep) {
    return !!(rep && rep.sprite);
};
var isImageRepresentation = function (rep) {
    return !!(rep && rep.imagePath);
};
var isMediaRepresentation = function (rep) {
    return !!(rep && rep.mediaPath);
};
var isPromise = function (p) {
    return !!(p && p.then);
};
var isMediaEmoji = function (emoji) {
    return isMediaRepresentation(emoji.representation);
};
var hasDataURLImage = function (rep) {
    return isImageRepresentation(rep) && rep.imagePath.indexOf(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* dataURLPrefix */]) === 0;
};
var isLoadedMediaEmoji = function (emoji) {
    return emoji.category === __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* customCategory */] && hasDataURLImage(emoji.representation);
};
var isEmojiDescriptionWithVariations = function (emoji) {
    return !!(emoji && emoji.skinVariations);
};
var isEmojiVariationDescription = function (object) {
    return 'baseId' in object;
};
var toEmojiId = function (emoji) { return ({
    shortName: emoji.shortName,
    id: emoji.id,
    fallback: emoji.fallback,
}); };
var toOptionalEmojiId = function (emoji) {
    if (!emoji) {
        return undefined;
    }
    return toEmojiId(emoji);
};
var isEmojiIdEqual = function (l, r) {
    return l === r || (l && r && l.id === r.id && l.shortName === r.shortName);
};
var containsEmojiId = function (emojis, emojiId) {
    if (!emojiId) {
        return false;
    }
    for (var i = 0; i < emojis.length; i++) {
        if (isEmojiIdEqual(emojis[i], emojiId)) {
            return true;
        }
    }
    return false;
};
var convertImageToMediaRepresentation = function (rep) { return ({
    mediaPath: rep.imagePath,
    height: rep.height,
    width: rep.width,
}); };
var convertMediaToImageRepresentation = function (rep, newImagePath) { return ({
    imagePath: newImagePath || rep.mediaPath,
    height: rep.height,
    width: rep.width,
}); };
var convertMediaToImageEmoji = function (emoji, newImagePath, useAlt) {
    var mediaRepresentation = emoji.representation;
    var mediaAltRepresentation = emoji.altRepresentation;
    var imgPath = !useAlt ? newImagePath : undefined;
    var altImgPath = useAlt ? newImagePath : undefined;
    if (!isMediaRepresentation(mediaRepresentation) &&
        !isMediaRepresentation(mediaAltRepresentation)) {
        return emoji;
    }
    var representation = isMediaRepresentation(mediaRepresentation)
        ? convertMediaToImageRepresentation(mediaRepresentation, imgPath)
        : mediaRepresentation;
    var altRepresentation = isMediaRepresentation(mediaAltRepresentation)
        ? convertMediaToImageRepresentation(mediaAltRepresentation, altImgPath)
        : mediaAltRepresentation;
    var baseEmoji = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, emoji, { representation: representation });
    return buildEmojiDescriptionWithAltRepresentation(baseEmoji, altRepresentation);
};
// Prevent altRepresentation: undefined from being returned in EmojiDescription
var buildEmojiDescriptionWithAltRepresentation = function (emoji, altRepresentation) {
    if (!altRepresentation) {
        return emoji;
    }
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, emoji, { altRepresentation: altRepresentation });
};
var getCategoryId = function (emoji) {
    return emoji.category;
};
//# sourceMappingURL=type-helpers.js.map

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isFunction_1 = __webpack_require__(681);
var Subscription_1 = __webpack_require__(158);
var Observer_1 = __webpack_require__(685);
var rxSubscriber_1 = __webpack_require__(387);
/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */
var Subscriber = (function (_super) {
    __extends(Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */
    function Subscriber(destinationOrNext, error, complete) {
        _super.call(this);
        this.syncErrorValue = null;
        this.syncErrorThrown = false;
        this.syncErrorThrowable = false;
        this.isStopped = false;
        switch (arguments.length) {
            case 0:
                this.destination = Observer_1.empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    this.destination = Observer_1.empty;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    // HACK(benlesh): To resolve an issue where Node users may have multiple
                    // copies of rxjs in their node_modules directory.
                    if (isTrustedSubscriber(destinationOrNext)) {
                        var trustedSubscriber = destinationOrNext[rxSubscriber_1.rxSubscriber]();
                        this.syncErrorThrowable = trustedSubscriber.syncErrorThrowable;
                        this.destination = trustedSubscriber;
                        trustedSubscriber.add(this);
                    }
                    else {
                        this.syncErrorThrowable = true;
                        this.destination = new SafeSubscriber(this, destinationOrNext);
                    }
                    break;
                }
            default:
                this.syncErrorThrowable = true;
                this.destination = new SafeSubscriber(this, destinationOrNext, error, complete);
                break;
        }
    }
    Subscriber.prototype[rxSubscriber_1.rxSubscriber] = function () { return this; };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     */
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    /** @deprecated internal use only */ Subscriber.prototype._unsubscribeAndRecycle = function () {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        return this;
    };
    return Subscriber;
}(Subscription_1.Subscription));
exports.Subscriber = Subscriber;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SafeSubscriber = (function (_super) {
    __extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        _super.call(this);
        this._parentSubscriber = _parentSubscriber;
        var next;
        var context = this;
        if (isFunction_1.isFunction(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== Observer_1.empty) {
                context = Object.create(observerOrNext);
                if (isFunction_1.isFunction(context.unsubscribe)) {
                    this.add(context.unsubscribe.bind(context));
                }
                context.unsubscribe = this.unsubscribe.bind(this);
            }
        }
        this._context = context;
        this._next = next;
        this._error = error;
        this._complete = complete;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_parentSubscriber.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
            }
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._error) {
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            }
            else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                throw err;
            }
            else {
                _parentSubscriber.syncErrorValue = err;
                _parentSubscriber.syncErrorThrown = true;
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function () {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function () { return _this._complete.call(_this._context); };
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            }
            else {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            this.unsubscribe();
            throw err;
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            parent.syncErrorValue = err;
            parent.syncErrorThrown = true;
            return true;
        }
        return false;
    };
    /** @deprecated internal use only */ SafeSubscriber.prototype._unsubscribe = function () {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber));
function isTrustedSubscriber(obj) {
    return obj instanceof Subscriber || ('syncErrorThrowable' in obj && obj[rxSubscriber_1.rxSubscriber]);
}
//# sourceMappingURL=Subscriber.js.map

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(54);

var _interopRequireDefault = __webpack_require__(53);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.size = exports.default = exports.IconWrapper = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(4));

var _createClass2 = _interopRequireDefault(__webpack_require__(5));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(7));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(6));

var _inherits2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _styledComponents = _interopRequireDefault(__webpack_require__(2));

var _uuid = _interopRequireDefault(__webpack_require__(22));

var _theme = __webpack_require__(49);

var _constants = __webpack_require__(2204);

var getSize = function getSize(props) {
  if (props.size) {
    return "height: ".concat(_constants.sizes[props.size], "; width: ").concat(_constants.sizes[props.size], ";");
  }

  return null;
};

var IconWrapper = _styledComponents.default.span.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "dyhwwi-0"
})(["\n  ", " color: ", ";\n  display: inline-block;\n  fill: ", ";\n  flex-shrink: 0;\n  line-height: 1;\n\n  > svg {\n    ", " max-height: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    pointer-events: none;\n    vertical-align: bottom;\n  }\n  /* Stop-color doesn't properly apply in chrome when the inherited/current color changes.\n   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS\n   * rule) and then override it with currentColor for the color changes to be picked up.\n   */\n  stop {\n    stop-color: currentColor;\n  }\n"], getSize, function (p) {
  return p.primaryColor || 'currentColor';
}, function (p) {
  return p.secondaryColor || _theme.colors.background;
}, getSize);

exports.IconWrapper = IconWrapper;

var Icon =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Icon, _Component);

  function Icon() {
    (0, _classCallCheck2.default)(this, Icon);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Icon).apply(this, arguments));
  }

  (0, _createClass2.default)(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Glyph = _this$props.glyph,
          dangerouslySetGlyph = _this$props.dangerouslySetGlyph,
          onClick = _this$props.onClick,
          primaryColor = _this$props.primaryColor,
          secondaryColor = _this$props.secondaryColor,
          size = _this$props.size; // handling the glyphs as strings

      if (dangerouslySetGlyph) {
        return _react.default.createElement(IconWrapper, {
          onClick: onClick,
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          size: size,
          "aria-label": this.props.label,
          dangerouslySetInnerHTML: {
            __html: Icon.insertDynamicGradientID(dangerouslySetGlyph)
          }
        });
      } // handling the glyphs when passed through as functions


      return _react.default.createElement(IconWrapper, {
        onClick: onClick,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        "aria-label": this.props.label
      }, Glyph ? _react.default.createElement(Glyph, {
        role: "presentation"
      }) : null);
    }
  }], [{
    key: "insertDynamicGradientID",

    /* Icons need unique gradient IDs across instances for different gradient definitions to work
     * correctly.
     * A step in the icon build process replaces linear gradient IDs and their references in paths
     * to a placeholder string so we can replace them with a dynamic ID here.
     * Replacing the original IDs with placeholders in the build process is more robust than not
     * using placeholders as we do not have to rely on regular expressions to find specific element
     * to replace.
     */
    value: function insertDynamicGradientID(svgStr) {
      var id = (0, _uuid.default)();
      var replacedSvgStr = svgStr.replace(/id="([^"]+)-idPlaceholder"/g, "id=$1-".concat(id)).replace(/fill="url\(#([^"]+)-idPlaceholder\)"/g, "fill=\"url(#$1-".concat(id, ")\""));
      return replacedSvgStr;
    }
  }]);
  return Icon;
}(_react.Component);

exports.default = Icon;
(0, _defineProperty2.default)(Icon, "defaultProps", {
  onClick: function onClick() {}
});
var size = Object.keys(_constants.sizes).reduce(function (p, c) {
  return Object.assign(p, (0, _defineProperty2.default)({}, c, c));
}, {});
exports.size = size;

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = defaultInputRuleHandler;
/* harmony export (immutable) */ __webpack_exports__["a"] = createInputRule;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return leafNodeReplacementCharacter; });
/* unused harmony export uuid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__);

function defaultInputRuleHandler(inputRule, isBlockNodeRule) {
    if (isBlockNodeRule === void 0) { isBlockNodeRule = false; }
    var originalHandler = inputRule.handler;
    inputRule.handler = function (state, match, start, end) {
        // Skip any input rule inside code
        // https://product-fabric.atlassian.net/wiki/spaces/E/pages/37945345/Editor+content+feature+rules#Editorcontent/featurerules-Rawtextblocks
        var unsupportedMarks = isBlockNodeRule
            ? hasUnsupportedMarkForBlockInputRule(state, start, end)
            : hasUnsupportedMarkForInputRule(state, start, end);
        if (state.selection.$from.parent.type.spec.code || unsupportedMarks) {
            return;
        }
        return originalHandler(state, match, start, end);
    };
    return inputRule;
}
function createInputRule(match, handler, isBlockNodeRule) {
    if (isBlockNodeRule === void 0) { isBlockNodeRule = false; }
    return defaultInputRuleHandler(new __WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["InputRule"](match, handler), isBlockNodeRule);
}
// ProseMirror uses the Unicode Character 'OBJECT REPLACEMENT CHARACTER' (U+FFFC) as text representation for
// leaf nodes, i.e. nodes that don't have any content or text property (e.g. hardBreak, emoji, mention, rule)
// It was introduced because of https://github.com/ProseMirror/prosemirror/issues/262
// This can be used in an input rule regex to be able to include or exclude such nodes.
var leafNodeReplacementCharacter = '\ufffc';
// tslint:disable:no-bitwise
var uuid = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0;
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
};
var hasUnsupportedMarkForBlockInputRule = function (state, start, end) {
    var doc = state.doc, marks = state.schema.marks;
    var unsupportedMarksPresent = false;
    var isUnsupportedMark = function (node) {
        return node.type === marks.code ||
            node.type === marks.link ||
            node.type === marks.typeAheadQuery;
    };
    doc.nodesBetween(start, end, function (node) {
        unsupportedMarksPresent =
            unsupportedMarksPresent ||
                node.marks.filter(isUnsupportedMark).length > 0;
    });
    return unsupportedMarksPresent;
};
var hasUnsupportedMarkForInputRule = function (state, start, end) {
    var doc = state.doc, marks = state.schema.marks;
    var unsupportedMarksPresent = false;
    var isCodemark = function (node) {
        return node.type === marks.code || node.type === marks.typeAheadQuery;
    };
    doc.nodesBetween(start, end, function (node) {
        unsupportedMarksPresent =
            unsupportedMarksPresent || node.marks.filter(isCodemark).length > 0;
    });
    return unsupportedMarksPresent;
};
//# sourceMappingURL=input-rules.js.map

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = hasAnyOfMarks;
/* harmony export (immutable) */ __webpack_exports__["d"] = isDigit;
/* harmony export (immutable) */ __webpack_exports__["c"] = isBlank;
/* harmony export (immutable) */ __webpack_exports__["e"] = isNotBlank;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StringBuffer; });
/**
 * Check if the node has certain marks
 */
function hasAnyOfMarks(node, types) {
    return (node.marks.findIndex(function (m) { return types.findIndex(function (t) { return m.type.name === t; }) !== -1; }) !== -1);
}
function isDigit(value) {
    return !!value.match(/^\d$/);
}
function isBlank(value) {
    return value === null || value.trim() === '';
}
function isNotBlank(value) {
    return !isBlank(value);
}
var StringBuffer = /** @class */ (function () {
    function StringBuffer(buffer) {
        if (buffer === void 0) { buffer = ''; }
        this.buffer = buffer;
    }
    StringBuffer.prototype.indexOf = function (value) {
        return this.buffer.indexOf(value);
    };
    StringBuffer.prototype.lastIndexOf = function (value) {
        return this.buffer.lastIndexOf(value);
    };
    StringBuffer.prototype.charAt = function (index) {
        return this.buffer.charAt(index);
    };
    StringBuffer.prototype.length = function () {
        return this.buffer.length;
    };
    StringBuffer.prototype.delete = function (start, end) {
        this.buffer = this.buffer.substring(0, start) + this.buffer.substring(end);
    };
    StringBuffer.prototype.append = function (value) {
        this.buffer += value;
    };
    StringBuffer.prototype.substring = function (start, end) {
        return this.buffer.substring(start, end);
    };
    StringBuffer.prototype.deleteCharAt = function (index) {
        this.delete(index, index + 1);
    };
    StringBuffer.prototype.toString = function () {
        return this.buffer;
    };
    return StringBuffer;
}());

//# sourceMappingURL=text.js.map

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["a"] = (isArray);


/***/ }),
/* 95 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(566);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Collection */
/* unused harmony export Iterable */
/* unused harmony export List */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OrderedMap; });
/* unused harmony export OrderedSet */
/* unused harmony export PairSorting */
/* unused harmony export Range */
/* unused harmony export Record */
/* unused harmony export Repeat */
/* unused harmony export Seq */
/* unused harmony export Set */
/* unused harmony export Stack */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fromJS; });
/* unused harmony export get */
/* unused harmony export getIn */
/* unused harmony export has */
/* unused harmony export hasIn */
/* unused harmony export hash */
/* unused harmony export is */
/* unused harmony export isAssociative */
/* unused harmony export isCollection */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isImmutable; });
/* unused harmony export isIndexed */
/* unused harmony export isKeyed */
/* unused harmony export isList */
/* unused harmony export isMap */
/* unused harmony export isOrdered */
/* unused harmony export isOrderedMap */
/* unused harmony export isOrderedSet */
/* unused harmony export isPlainObject */
/* unused harmony export isRecord */
/* unused harmony export isSeq */
/* unused harmony export isSet */
/* unused harmony export isStack */
/* unused harmony export isValueObject */
/* unused harmony export merge */
/* unused harmony export mergeDeep */
/* unused harmony export mergeDeepWith */
/* unused harmony export mergeWith */
/* unused harmony export remove */
/* unused harmony export removeIn */
/* unused harmony export set */
/* unused harmony export setIn */
/* unused harmony export update */
/* unused harmony export updateIn */
/* unused harmony export version */
/**
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var DELETE = 'delete';

// Constants describing the size of trie nodes.
var SHIFT = 5; // Resulted in best performance after ______?
var SIZE = 1 << SHIFT;
var MASK = SIZE - 1;

// A consistent shared value representing "not set" which equals nothing other
// than itself, and nothing that could be provided externally.
var NOT_SET = {};

// Boolean references, Rough equivalent of `bool &`.
function MakeRef() {
  return { value: false };
}

function SetRef(ref) {
  if (ref) {
    ref.value = true;
  }
}

// A function which returns a value representing an "owner" for transient writes
// to tries. The return value will only ever equal itself, and will not equal
// the return of any subsequent call of this function.
function OwnerID() {}

function ensureSize(iter) {
  if (iter.size === undefined) {
    iter.size = iter.__iterate(returnTrue);
  }
  return iter.size;
}

function wrapIndex(iter, index) {
  // This implements "is array index" which the ECMAString spec defines as:
  //
  //     A String property name P is an array index if and only if
  //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
  //     to 2^32−1.
  //
  // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
  if (typeof index !== 'number') {
    var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
    if ('' + uint32Index !== index || uint32Index === 4294967295) {
      return NaN;
    }
    index = uint32Index;
  }
  return index < 0 ? ensureSize(iter) + index : index;
}

function returnTrue() {
  return true;
}

function wholeSlice(begin, end, size) {
  return (
    ((begin === 0 && !isNeg(begin)) ||
      (size !== undefined && begin <= -size)) &&
    (end === undefined || (size !== undefined && end >= size))
  );
}

function resolveBegin(begin, size) {
  return resolveIndex(begin, size, 0);
}

function resolveEnd(end, size) {
  return resolveIndex(end, size, size);
}

function resolveIndex(index, size, defaultIndex) {
  // Sanitize indices using this shorthand for ToInt32(argument)
  // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
  return index === undefined
    ? defaultIndex
    : isNeg(index)
    ? size === Infinity
      ? size
      : Math.max(0, size + index) | 0
    : size === undefined || size === index
    ? index
    : Math.min(size, index) | 0;
}

function isNeg(value) {
  // Account for -0 which is negative, but not less than 0.
  return value < 0 || (value === 0 && 1 / value === -Infinity);
}

var IS_COLLECTION_SYMBOL = '@@__IMMUTABLE_ITERABLE__@@';

function isCollection(maybeCollection) {
  return Boolean(maybeCollection && maybeCollection[IS_COLLECTION_SYMBOL]);
}

var IS_KEYED_SYMBOL = '@@__IMMUTABLE_KEYED__@@';

function isKeyed(maybeKeyed) {
  return Boolean(maybeKeyed && maybeKeyed[IS_KEYED_SYMBOL]);
}

var IS_INDEXED_SYMBOL = '@@__IMMUTABLE_INDEXED__@@';

function isIndexed(maybeIndexed) {
  return Boolean(maybeIndexed && maybeIndexed[IS_INDEXED_SYMBOL]);
}

function isAssociative(maybeAssociative) {
  return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
}

var Collection = function Collection(value) {
  // eslint-disable-next-line no-constructor-return
  return isCollection(value) ? value : Seq(value);
};

var KeyedCollection = /*@__PURE__*/(function (Collection) {
  function KeyedCollection(value) {
    // eslint-disable-next-line no-constructor-return
    return isKeyed(value) ? value : KeyedSeq(value);
  }

  if ( Collection ) KeyedCollection.__proto__ = Collection;
  KeyedCollection.prototype = Object.create( Collection && Collection.prototype );
  KeyedCollection.prototype.constructor = KeyedCollection;

  return KeyedCollection;
}(Collection));

var IndexedCollection = /*@__PURE__*/(function (Collection) {
  function IndexedCollection(value) {
    // eslint-disable-next-line no-constructor-return
    return isIndexed(value) ? value : IndexedSeq(value);
  }

  if ( Collection ) IndexedCollection.__proto__ = Collection;
  IndexedCollection.prototype = Object.create( Collection && Collection.prototype );
  IndexedCollection.prototype.constructor = IndexedCollection;

  return IndexedCollection;
}(Collection));

var SetCollection = /*@__PURE__*/(function (Collection) {
  function SetCollection(value) {
    // eslint-disable-next-line no-constructor-return
    return isCollection(value) && !isAssociative(value) ? value : SetSeq(value);
  }

  if ( Collection ) SetCollection.__proto__ = Collection;
  SetCollection.prototype = Object.create( Collection && Collection.prototype );
  SetCollection.prototype.constructor = SetCollection;

  return SetCollection;
}(Collection));

Collection.Keyed = KeyedCollection;
Collection.Indexed = IndexedCollection;
Collection.Set = SetCollection;

var IS_SEQ_SYMBOL = '@@__IMMUTABLE_SEQ__@@';

function isSeq(maybeSeq) {
  return Boolean(maybeSeq && maybeSeq[IS_SEQ_SYMBOL]);
}

var IS_RECORD_SYMBOL = '@@__IMMUTABLE_RECORD__@@';

function isRecord(maybeRecord) {
  return Boolean(maybeRecord && maybeRecord[IS_RECORD_SYMBOL]);
}

function isImmutable(maybeImmutable) {
  return isCollection(maybeImmutable) || isRecord(maybeImmutable);
}

var IS_ORDERED_SYMBOL = '@@__IMMUTABLE_ORDERED__@@';

function isOrdered(maybeOrdered) {
  return Boolean(maybeOrdered && maybeOrdered[IS_ORDERED_SYMBOL]);
}

var ITERATE_KEYS = 0;
var ITERATE_VALUES = 1;
var ITERATE_ENTRIES = 2;

var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';

var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;

var Iterator = function Iterator(next) {
  this.next = next;
};

Iterator.prototype.toString = function toString () {
  return '[Iterator]';
};

Iterator.KEYS = ITERATE_KEYS;
Iterator.VALUES = ITERATE_VALUES;
Iterator.ENTRIES = ITERATE_ENTRIES;

Iterator.prototype.inspect = Iterator.prototype.toSource = function () {
  return this.toString();
};
Iterator.prototype[ITERATOR_SYMBOL] = function () {
  return this;
};

function iteratorValue(type, k, v, iteratorResult) {
  var value = type === 0 ? k : type === 1 ? v : [k, v];
  iteratorResult
    ? (iteratorResult.value = value)
    : (iteratorResult = {
        value: value,
        done: false,
      });
  return iteratorResult;
}

function iteratorDone() {
  return { value: undefined, done: true };
}

function hasIterator(maybeIterable) {
  if (Array.isArray(maybeIterable)) {
    // IE11 trick as it does not support `Symbol.iterator`
    return true;
  }

  return !!getIteratorFn(maybeIterable);
}

function isIterator(maybeIterator) {
  return maybeIterator && typeof maybeIterator.next === 'function';
}

function getIterator(iterable) {
  var iteratorFn = getIteratorFn(iterable);
  return iteratorFn && iteratorFn.call(iterable);
}

function getIteratorFn(iterable) {
  var iteratorFn =
    iterable &&
    ((REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

function isEntriesIterable(maybeIterable) {
  var iteratorFn = getIteratorFn(maybeIterable);
  return iteratorFn && iteratorFn === maybeIterable.entries;
}

function isKeysIterable(maybeIterable) {
  var iteratorFn = getIteratorFn(maybeIterable);
  return iteratorFn && iteratorFn === maybeIterable.keys;
}

var hasOwnProperty = Object.prototype.hasOwnProperty;

function isArrayLike(value) {
  if (Array.isArray(value) || typeof value === 'string') {
    return true;
  }

  return (
    value &&
    typeof value === 'object' &&
    Number.isInteger(value.length) &&
    value.length >= 0 &&
    (value.length === 0
      ? // Only {length: 0} is considered Array-like.
        Object.keys(value).length === 1
      : // An object is only Array-like if it has a property where the last value
        // in the array-like may be found (which could be undefined).
        value.hasOwnProperty(value.length - 1))
  );
}

var Seq = /*@__PURE__*/(function (Collection) {
  function Seq(value) {
    // eslint-disable-next-line no-constructor-return
    return value === undefined || value === null
      ? emptySequence()
      : isImmutable(value)
      ? value.toSeq()
      : seqFromValue(value);
  }

  if ( Collection ) Seq.__proto__ = Collection;
  Seq.prototype = Object.create( Collection && Collection.prototype );
  Seq.prototype.constructor = Seq;

  Seq.prototype.toSeq = function toSeq () {
    return this;
  };

  Seq.prototype.toString = function toString () {
    return this.__toString('Seq {', '}');
  };

  Seq.prototype.cacheResult = function cacheResult () {
    if (!this._cache && this.__iterateUncached) {
      this._cache = this.entrySeq().toArray();
      this.size = this._cache.length;
    }
    return this;
  };

  // abstract __iterateUncached(fn, reverse)

  Seq.prototype.__iterate = function __iterate (fn, reverse) {
    var cache = this._cache;
    if (cache) {
      var size = cache.length;
      var i = 0;
      while (i !== size) {
        var entry = cache[reverse ? size - ++i : i++];
        if (fn(entry[1], entry[0], this) === false) {
          break;
        }
      }
      return i;
    }
    return this.__iterateUncached(fn, reverse);
  };

  // abstract __iteratorUncached(type, reverse)

  Seq.prototype.__iterator = function __iterator (type, reverse) {
    var cache = this._cache;
    if (cache) {
      var size = cache.length;
      var i = 0;
      return new Iterator(function () {
        if (i === size) {
          return iteratorDone();
        }
        var entry = cache[reverse ? size - ++i : i++];
        return iteratorValue(type, entry[0], entry[1]);
      });
    }
    return this.__iteratorUncached(type, reverse);
  };

  return Seq;
}(Collection));

var KeyedSeq = /*@__PURE__*/(function (Seq) {
  function KeyedSeq(value) {
    // eslint-disable-next-line no-constructor-return
    return value === undefined || value === null
      ? emptySequence().toKeyedSeq()
      : isCollection(value)
      ? isKeyed(value)
        ? value.toSeq()
        : value.fromEntrySeq()
      : isRecord(value)
      ? value.toSeq()
      : keyedSeqFromValue(value);
  }

  if ( Seq ) KeyedSeq.__proto__ = Seq;
  KeyedSeq.prototype = Object.create( Seq && Seq.prototype );
  KeyedSeq.prototype.constructor = KeyedSeq;

  KeyedSeq.prototype.toKeyedSeq = function toKeyedSeq () {
    return this;
  };

  return KeyedSeq;
}(Seq));

var IndexedSeq = /*@__PURE__*/(function (Seq) {
  function IndexedSeq(value) {
    // eslint-disable-next-line no-constructor-return
    return value === undefined || value === null
      ? emptySequence()
      : isCollection(value)
      ? isKeyed(value)
        ? value.entrySeq()
        : value.toIndexedSeq()
      : isRecord(value)
      ? value.toSeq().entrySeq()
      : indexedSeqFromValue(value);
  }

  if ( Seq ) IndexedSeq.__proto__ = Seq;
  IndexedSeq.prototype = Object.create( Seq && Seq.prototype );
  IndexedSeq.prototype.constructor = IndexedSeq;

  IndexedSeq.of = function of (/*...values*/) {
    return IndexedSeq(arguments);
  };

  IndexedSeq.prototype.toIndexedSeq = function toIndexedSeq () {
    return this;
  };

  IndexedSeq.prototype.toString = function toString () {
    return this.__toString('Seq [', ']');
  };

  return IndexedSeq;
}(Seq));

var SetSeq = /*@__PURE__*/(function (Seq) {
  function SetSeq(value) {
    // eslint-disable-next-line no-constructor-return
    return (
      isCollection(value) && !isAssociative(value) ? value : IndexedSeq(value)
    ).toSetSeq();
  }

  if ( Seq ) SetSeq.__proto__ = Seq;
  SetSeq.prototype = Object.create( Seq && Seq.prototype );
  SetSeq.prototype.constructor = SetSeq;

  SetSeq.of = function of (/*...values*/) {
    return SetSeq(arguments);
  };

  SetSeq.prototype.toSetSeq = function toSetSeq () {
    return this;
  };

  return SetSeq;
}(Seq));

Seq.isSeq = isSeq;
Seq.Keyed = KeyedSeq;
Seq.Set = SetSeq;
Seq.Indexed = IndexedSeq;

Seq.prototype[IS_SEQ_SYMBOL] = true;

// #pragma Root Sequences

var ArraySeq = /*@__PURE__*/(function (IndexedSeq) {
  function ArraySeq(array) {
    this._array = array;
    this.size = array.length;
  }

  if ( IndexedSeq ) ArraySeq.__proto__ = IndexedSeq;
  ArraySeq.prototype = Object.create( IndexedSeq && IndexedSeq.prototype );
  ArraySeq.prototype.constructor = ArraySeq;

  ArraySeq.prototype.get = function get (index, notSetValue) {
    return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
  };

  ArraySeq.prototype.__iterate = function __iterate (fn, reverse) {
    var array = this._array;
    var size = array.length;
    var i = 0;
    while (i !== size) {
      var ii = reverse ? size - ++i : i++;
      if (fn(array[ii], ii, this) === false) {
        break;
      }
    }
    return i;
  };

  ArraySeq.prototype.__iterator = function __iterator (type, reverse) {
    var array = this._array;
    var size = array.length;
    var i = 0;
    return new Iterator(function () {
      if (i === size) {
        return iteratorDone();
      }
      var ii = reverse ? size - ++i : i++;
      return iteratorValue(type, ii, array[ii]);
    });
  };

  return ArraySeq;
}(IndexedSeq));

var ObjectSeq = /*@__PURE__*/(function (KeyedSeq) {
  function ObjectSeq(object) {
    var keys = Object.keys(object).concat(
      Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(object) : []
    );
    this._object = object;
    this._keys = keys;
    this.size = keys.length;
  }

  if ( KeyedSeq ) ObjectSeq.__proto__ = KeyedSeq;
  ObjectSeq.prototype = Object.create( KeyedSeq && KeyedSeq.prototype );
  ObjectSeq.prototype.constructor = ObjectSeq;

  ObjectSeq.prototype.get = function get (key, notSetValue) {
    if (notSetValue !== undefined && !this.has(key)) {
      return notSetValue;
    }
    return this._object[key];
  };

  ObjectSeq.prototype.has = function has (key) {
    return hasOwnProperty.call(this._object, key);
  };

  ObjectSeq.prototype.__iterate = function __iterate (fn, reverse) {
    var object = this._object;
    var keys = this._keys;
    var size = keys.length;
    var i = 0;
    while (i !== size) {
      var key = keys[reverse ? size - ++i : i++];
      if (fn(object[key], key, this) === false) {
        break;
      }
    }
    return i;
  };

  ObjectSeq.prototype.__iterator = function __iterator (type, reverse) {
    var object = this._object;
    var keys = this._keys;
    var size = keys.length;
    var i = 0;
    return new Iterator(function () {
      if (i === size) {
        return iteratorDone();
      }
      var key = keys[reverse ? size - ++i : i++];
      return iteratorValue(type, key, object[key]);
    });
  };

  return ObjectSeq;
}(KeyedSeq));
ObjectSeq.prototype[IS_ORDERED_SYMBOL] = true;

var CollectionSeq = /*@__PURE__*/(function (IndexedSeq) {
  function CollectionSeq(collection) {
    this._collection = collection;
    this.size = collection.length || collection.size;
  }

  if ( IndexedSeq ) CollectionSeq.__proto__ = IndexedSeq;
  CollectionSeq.prototype = Object.create( IndexedSeq && IndexedSeq.prototype );
  CollectionSeq.prototype.constructor = CollectionSeq;

  CollectionSeq.prototype.__iterateUncached = function __iterateUncached (fn, reverse) {
    if (reverse) {
      return this.cacheResult().__iterate(fn, reverse);
    }
    var collection = this._collection;
    var iterator = getIterator(collection);
    var iterations = 0;
    if (isIterator(iterator)) {
      var step;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
    }
    return iterations;
  };

  CollectionSeq.prototype.__iteratorUncached = function __iteratorUncached (type, reverse) {
    if (reverse) {
      return this.cacheResult().__iterator(type, reverse);
    }
    var collection = this._collection;
    var iterator = getIterator(collection);
    if (!isIterator(iterator)) {
      return new Iterator(iteratorDone);
    }
    var iterations = 0;
    return new Iterator(function () {
      var step = iterator.next();
      return step.done ? step : iteratorValue(type, iterations++, step.value);
    });
  };

  return CollectionSeq;
}(IndexedSeq));

// # pragma Helper functions

var EMPTY_SEQ;

function emptySequence() {
  return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
}

function keyedSeqFromValue(value) {
  var seq = maybeIndexedSeqFromValue(value);
  if (seq) {
    return seq.fromEntrySeq();
  }
  if (typeof value === 'object') {
    return new ObjectSeq(value);
  }
  throw new TypeError(
    'Expected Array or collection object of [k, v] entries, or keyed object: ' +
      value
  );
}

function indexedSeqFromValue(value) {
  var seq = maybeIndexedSeqFromValue(value);
  if (seq) {
    return seq;
  }
  throw new TypeError(
    'Expected Array or collection object of values: ' + value
  );
}

function seqFromValue(value) {
  var seq = maybeIndexedSeqFromValue(value);
  if (seq) {
    return isEntriesIterable(value)
      ? seq.fromEntrySeq()
      : isKeysIterable(value)
      ? seq.toSetSeq()
      : seq;
  }
  if (typeof value === 'object') {
    return new ObjectSeq(value);
  }
  throw new TypeError(
    'Expected Array or collection object of values, or keyed object: ' + value
  );
}

function maybeIndexedSeqFromValue(value) {
  return isArrayLike(value)
    ? new ArraySeq(value)
    : hasIterator(value)
    ? new CollectionSeq(value)
    : undefined;
}

var IS_MAP_SYMBOL = '@@__IMMUTABLE_MAP__@@';

function isMap(maybeMap) {
  return Boolean(maybeMap && maybeMap[IS_MAP_SYMBOL]);
}

function isOrderedMap(maybeOrderedMap) {
  return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
}

function isValueObject(maybeValue) {
  return Boolean(
    maybeValue &&
      typeof maybeValue.equals === 'function' &&
      typeof maybeValue.hashCode === 'function'
  );
}

/**
 * An extension of the "same-value" algorithm as [described for use by ES6 Map
 * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
 *
 * NaN is considered the same as NaN, however -0 and 0 are considered the same
 * value, which is different from the algorithm described by
 * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
 *
 * This is extended further to allow Objects to describe the values they
 * represent, by way of `valueOf` or `equals` (and `hashCode`).
 *
 * Note: because of this extension, the key equality of Immutable.Map and the
 * value equality of Immutable.Set will differ from ES6 Map and Set.
 *
 * ### Defining custom values
 *
 * The easiest way to describe the value an object represents is by implementing
 * `valueOf`. For example, `Date` represents a value by returning a unix
 * timestamp for `valueOf`:
 *
 *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
 *     var date2 = new Date(1234567890000);
 *     date1.valueOf(); // 1234567890000
 *     assert( date1 !== date2 );
 *     assert( Immutable.is( date1, date2 ) );
 *
 * Note: overriding `valueOf` may have other implications if you use this object
 * where JavaScript expects a primitive, such as implicit string coercion.
 *
 * For more complex types, especially collections, implementing `valueOf` may
 * not be performant. An alternative is to implement `equals` and `hashCode`.
 *
 * `equals` takes another object, presumably of similar type, and returns true
 * if it is equal. Equality is symmetrical, so the same result should be
 * returned if this and the argument are flipped.
 *
 *     assert( a.equals(b) === b.equals(a) );
 *
 * `hashCode` returns a 32bit integer number representing the object which will
 * be used to determine how to store the value object in a Map or Set. You must
 * provide both or neither methods, one must not exist without the other.
 *
 * Also, an important relationship between these methods must be upheld: if two
 * values are equal, they *must* return the same hashCode. If the values are not
 * equal, they might have the same hashCode; this is called a hash collision,
 * and while undesirable for performance reasons, it is acceptable.
 *
 *     if (a.equals(b)) {
 *       assert( a.hashCode() === b.hashCode() );
 *     }
 *
 * All Immutable collections are Value Objects: they implement `equals()`
 * and `hashCode()`.
 */
function is(valueA, valueB) {
  if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
    return true;
  }
  if (!valueA || !valueB) {
    return false;
  }
  if (
    typeof valueA.valueOf === 'function' &&
    typeof valueB.valueOf === 'function'
  ) {
    valueA = valueA.valueOf();
    valueB = valueB.valueOf();
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
  }
  return !!(
    isValueObject(valueA) &&
    isValueObject(valueB) &&
    valueA.equals(valueB)
  );
}

var imul =
  typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2
    ? Math.imul
    : function imul(a, b) {
        a |= 0; // int
        b |= 0; // int
        var c = a & 0xffff;
        var d = b & 0xffff;
        // Shift by 0 fixes the sign on the high part.
        return (c * d + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0)) | 0; // int
      };

// v8 has an optimization for storing 31-bit signed numbers.
// Values which have either 00 or 11 as the high order bits qualify.
// This function drops the highest order bit in a signed number, maintaining
// the sign bit.
function smi(i32) {
  return ((i32 >>> 1) & 0x40000000) | (i32 & 0xbfffffff);
}

var defaultValueOf = Object.prototype.valueOf;

function hash(o) {
  if (o == null) {
    return hashNullish(o);
  }

  if (typeof o.hashCode === 'function') {
    // Drop any high bits from accidentally long hash codes.
    return smi(o.hashCode(o));
  }

  var v = valueOf(o);

  if (v == null) {
    return hashNullish(v);
  }

  switch (typeof v) {
    case 'boolean':
      // The hash values for built-in constants are a 1 value for each 5-byte
      // shift region expect for the first, which encodes the value. This
      // reduces the odds of a hash collision for these common values.
      return v ? 0x42108421 : 0x42108420;
    case 'number':
      return hashNumber(v);
    case 'string':
      return v.length > STRING_HASH_CACHE_MIN_STRLEN
        ? cachedHashString(v)
        : hashString(v);
    case 'object':
    case 'function':
      return hashJSObj(v);
    case 'symbol':
      return hashSymbol(v);
    default:
      if (typeof v.toString === 'function') {
        return hashString(v.toString());
      }
      throw new Error('Value type ' + typeof v + ' cannot be hashed.');
  }
}

function hashNullish(nullish) {
  return nullish === null ? 0x42108422 : /* undefined */ 0x42108423;
}

// Compress arbitrarily large numbers into smi hashes.
function hashNumber(n) {
  if (n !== n || n === Infinity) {
    return 0;
  }
  var hash = n | 0;
  if (hash !== n) {
    hash ^= n * 0xffffffff;
  }
  while (n > 0xffffffff) {
    n /= 0xffffffff;
    hash ^= n;
  }
  return smi(hash);
}

function cachedHashString(string) {
  var hashed = stringHashCache[string];
  if (hashed === undefined) {
    hashed = hashString(string);
    if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
      STRING_HASH_CACHE_SIZE = 0;
      stringHashCache = {};
    }
    STRING_HASH_CACHE_SIZE++;
    stringHashCache[string] = hashed;
  }
  return hashed;
}

// http://jsperf.com/hashing-strings
function hashString(string) {
  // This is the hash from JVM
  // The hash code for a string is computed as
  // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
  // where s[i] is the ith character of the string and n is the length of
  // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
  // (exclusive) by dropping high bits.
  var hashed = 0;
  for (var ii = 0; ii < string.length; ii++) {
    hashed = (31 * hashed + string.charCodeAt(ii)) | 0;
  }
  return smi(hashed);
}

function hashSymbol(sym) {
  var hashed = symbolMap[sym];
  if (hashed !== undefined) {
    return hashed;
  }

  hashed = nextHash();

  symbolMap[sym] = hashed;

  return hashed;
}

function hashJSObj(obj) {
  var hashed;
  if (usingWeakMap) {
    hashed = weakMap.get(obj);
    if (hashed !== undefined) {
      return hashed;
    }
  }

  hashed = obj[UID_HASH_KEY];
  if (hashed !== undefined) {
    return hashed;
  }

  if (!canDefineProperty) {
    hashed = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
    if (hashed !== undefined) {
      return hashed;
    }

    hashed = getIENodeHash(obj);
    if (hashed !== undefined) {
      return hashed;
    }
  }

  hashed = nextHash();

  if (usingWeakMap) {
    weakMap.set(obj, hashed);
  } else if (isExtensible !== undefined && isExtensible(obj) === false) {
    throw new Error('Non-extensible objects are not allowed as keys.');
  } else if (canDefineProperty) {
    Object.defineProperty(obj, UID_HASH_KEY, {
      enumerable: false,
      configurable: false,
      writable: false,
      value: hashed,
    });
  } else if (
    obj.propertyIsEnumerable !== undefined &&
    obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable
  ) {
    // Since we can't define a non-enumerable property on the object
    // we'll hijack one of the less-used non-enumerable properties to
    // save our hash on it. Since this is a function it will not show up in
    // `JSON.stringify` which is what we want.
    obj.propertyIsEnumerable = function () {
      return this.constructor.prototype.propertyIsEnumerable.apply(
        this,
        arguments
      );
    };
    obj.propertyIsEnumerable[UID_HASH_KEY] = hashed;
  } else if (obj.nodeType !== undefined) {
    // At this point we couldn't get the IE `uniqueID` to use as a hash
    // and we couldn't use a non-enumerable property to exploit the
    // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
    // itself.
    obj[UID_HASH_KEY] = hashed;
  } else {
    throw new Error('Unable to set a non-enumerable property on object.');
  }

  return hashed;
}

// Get references to ES5 object methods.
var isExtensible = Object.isExtensible;

// True if Object.defineProperty works as expected. IE8 fails this test.
var canDefineProperty = (function () {
  try {
    Object.defineProperty({}, '@', {});
    return true;
  } catch (e) {
    return false;
  }
})();

// IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
// and avoid memory leaks from the IE cloneNode bug.
function getIENodeHash(node) {
  if (node && node.nodeType > 0) {
    switch (node.nodeType) {
      case 1: // Element
        return node.uniqueID;
      case 9: // Document
        return node.documentElement && node.documentElement.uniqueID;
    }
  }
}

function valueOf(obj) {
  return obj.valueOf !== defaultValueOf && typeof obj.valueOf === 'function'
    ? obj.valueOf(obj)
    : obj;
}

function nextHash() {
  var nextHash = ++_objHashUID;
  if (_objHashUID & 0x40000000) {
    _objHashUID = 0;
  }
  return nextHash;
}

// If possible, use a WeakMap.
var usingWeakMap = typeof WeakMap === 'function';
var weakMap;
if (usingWeakMap) {
  weakMap = new WeakMap();
}

var symbolMap = Object.create(null);

var _objHashUID = 0;

var UID_HASH_KEY = '__immutablehash__';
if (typeof Symbol === 'function') {
  UID_HASH_KEY = Symbol(UID_HASH_KEY);
}

var STRING_HASH_CACHE_MIN_STRLEN = 16;
var STRING_HASH_CACHE_MAX_SIZE = 255;
var STRING_HASH_CACHE_SIZE = 0;
var stringHashCache = {};

var ToKeyedSequence = /*@__PURE__*/(function (KeyedSeq) {
  function ToKeyedSequence(indexed, useKeys) {
    this._iter = indexed;
    this._useKeys = useKeys;
    this.size = indexed.size;
  }

  if ( KeyedSeq ) ToKeyedSequence.__proto__ = KeyedSeq;
  ToKeyedSequence.prototype = Object.create( KeyedSeq && KeyedSeq.prototype );
  ToKeyedSequence.prototype.constructor = ToKeyedSequence;

  ToKeyedSequence.prototype.get = function get (key, notSetValue) {
    return this._iter.get(key, notSetValue);
  };

  ToKeyedSequence.prototype.has = function has (key) {
    return this._iter.has(key);
  };

  ToKeyedSequence.prototype.valueSeq = function valueSeq () {
    return this._iter.valueSeq();
  };

  ToKeyedSequence.prototype.reverse = function reverse () {
    var this$1$1 = this;

    var reversedSequence = reverseFactory(this, true);
    if (!this._useKeys) {
      reversedSequence.valueSeq = function () { return this$1$1._iter.toSeq().reverse(); };
    }
    return reversedSequence;
  };

  ToKeyedSequence.prototype.map = function map (mapper, context) {
    var this$1$1 = this;

    var mappedSequence = mapFactory(this, mapper, context);
    if (!this._useKeys) {
      mappedSequence.valueSeq = function () { return this$1$1._iter.toSeq().map(mapper, context); };
    }
    return mappedSequence;
  };

  ToKeyedSequence.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1$1 = this;

    return this._iter.__iterate(function (v, k) { return fn(v, k, this$1$1); }, reverse);
  };

  ToKeyedSequence.prototype.__iterator = function __iterator (type, reverse) {
    return this._iter.__iterator(type, reverse);
  };

  return ToKeyedSequence;
}(KeyedSeq));
ToKeyedSequence.prototype[IS_ORDERED_SYMBOL] = true;

var ToIndexedSequence = /*@__PURE__*/(function (IndexedSeq) {
  function ToIndexedSequence(iter) {
    this._iter = iter;
    this.size = iter.size;
  }

  if ( IndexedSeq ) ToIndexedSequence.__proto__ = IndexedSeq;
  ToIndexedSequence.prototype = Object.create( IndexedSeq && IndexedSeq.prototype );
  ToIndexedSequence.prototype.constructor = ToIndexedSequence;

  ToIndexedSequence.prototype.includes = function includes (value) {
    return this._iter.includes(value);
  };

  ToIndexedSequence.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1$1 = this;

    var i = 0;
    reverse && ensureSize(this);
    return this._iter.__iterate(
      function (v) { return fn(v, reverse ? this$1$1.size - ++i : i++, this$1$1); },
      reverse
    );
  };

  ToIndexedSequence.prototype.__iterator = function __iterator (type, reverse) {
    var this$1$1 = this;

    var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
    var i = 0;
    reverse && ensureSize(this);
    return new Iterator(function () {
      var step = iterator.next();
      return step.done
        ? step
        : iteratorValue(
            type,
            reverse ? this$1$1.size - ++i : i++,
            step.value,
            step
          );
    });
  };

  return ToIndexedSequence;
}(IndexedSeq));

var ToSetSequence = /*@__PURE__*/(function (SetSeq) {
  function ToSetSequence(iter) {
    this._iter = iter;
    this.size = iter.size;
  }

  if ( SetSeq ) ToSetSequence.__proto__ = SetSeq;
  ToSetSequence.prototype = Object.create( SetSeq && SetSeq.prototype );
  ToSetSequence.prototype.constructor = ToSetSequence;

  ToSetSequence.prototype.has = function has (key) {
    return this._iter.includes(key);
  };

  ToSetSequence.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1$1 = this;

    return this._iter.__iterate(function (v) { return fn(v, v, this$1$1); }, reverse);
  };

  ToSetSequence.prototype.__iterator = function __iterator (type, reverse) {
    var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
    return new Iterator(function () {
      var step = iterator.next();
      return step.done
        ? step
        : iteratorValue(type, step.value, step.value, step);
    });
  };

  return ToSetSequence;
}(SetSeq));

var FromEntriesSequence = /*@__PURE__*/(function (KeyedSeq) {
  function FromEntriesSequence(entries) {
    this._iter = entries;
    this.size = entries.size;
  }

  if ( KeyedSeq ) FromEntriesSequence.__proto__ = KeyedSeq;
  FromEntriesSequence.prototype = Object.create( KeyedSeq && KeyedSeq.prototype );
  FromEntriesSequence.prototype.constructor = FromEntriesSequence;

  FromEntriesSequence.prototype.entrySeq = function entrySeq () {
    return this._iter.toSeq();
  };

  FromEntriesSequence.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1$1 = this;

    return this._iter.__iterate(function (entry) {
      // Check if entry exists first so array access doesn't throw for holes
      // in the parent iteration.
      if (entry) {
        validateEntry(entry);
        var indexedCollection = isCollection(entry);
        return fn(
          indexedCollection ? entry.get(1) : entry[1],
          indexedCollection ? entry.get(0) : entry[0],
          this$1$1
        );
      }
    }, reverse);
  };

  FromEntriesSequence.prototype.__iterator = function __iterator (type, reverse) {
    var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
    return new Iterator(function () {
      while (true) {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedCollection = isCollection(entry);
          return iteratorValue(
            type,
            indexedCollection ? entry.get(0) : entry[0],
            indexedCollection ? entry.get(1) : entry[1],
            step
          );
        }
      }
    });
  };

  return FromEntriesSequence;
}(KeyedSeq));

ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;

function flipFactory(collection) {
  var flipSequence = makeSequence(collection);
  flipSequence._iter = collection;
  flipSequence.size = collection.size;
  flipSequence.flip = function () { return collection; };
  flipSequence.reverse = function () {
    var reversedSequence = collection.reverse.apply(this); // super.reverse()
    reversedSequence.flip = function () { return collection.reverse(); };
    return reversedSequence;
  };
  flipSequence.has = function (key) { return collection.includes(key); };
  flipSequence.includes = function (key) { return collection.has(key); };
  flipSequence.cacheResult = cacheResultThrough;
  flipSequence.__iterateUncached = function (fn, reverse) {
    var this$1$1 = this;

    return collection.__iterate(function (v, k) { return fn(k, v, this$1$1) !== false; }, reverse);
  };
  flipSequence.__iteratorUncached = function (type, reverse) {
    if (type === ITERATE_ENTRIES) {
      var iterator = collection.__iterator(type, reverse);
      return new Iterator(function () {
        var step = iterator.next();
        if (!step.done) {
          var k = step.value[0];
          step.value[0] = step.value[1];
          step.value[1] = k;
        }
        return step;
      });
    }
    return collection.__iterator(
      type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
      reverse
    );
  };
  return flipSequence;
}

function mapFactory(collection, mapper, context) {
  var mappedSequence = makeSequence(collection);
  mappedSequence.size = collection.size;
  mappedSequence.has = function (key) { return collection.has(key); };
  mappedSequence.get = function (key, notSetValue) {
    var v = collection.get(key, NOT_SET);
    return v === NOT_SET
      ? notSetValue
      : mapper.call(context, v, key, collection);
  };
  mappedSequence.__iterateUncached = function (fn, reverse) {
    var this$1$1 = this;

    return collection.__iterate(
      function (v, k, c) { return fn(mapper.call(context, v, k, c), k, this$1$1) !== false; },
      reverse
    );
  };
  mappedSequence.__iteratorUncached = function (type, reverse) {
    var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
    return new Iterator(function () {
      var step = iterator.next();
      if (step.done) {
        return step;
      }
      var entry = step.value;
      var key = entry[0];
      return iteratorValue(
        type,
        key,
        mapper.call(context, entry[1], key, collection),
        step
      );
    });
  };
  return mappedSequence;
}

function reverseFactory(collection, useKeys) {
  var this$1$1 = this;

  var reversedSequence = makeSequence(collection);
  reversedSequence._iter = collection;
  reversedSequence.size = collection.size;
  reversedSequence.reverse = function () { return collection; };
  if (collection.flip) {
    reversedSequence.flip = function () {
      var flipSequence = flipFactory(collection);
      flipSequence.reverse = function () { return collection.flip(); };
      return flipSequence;
    };
  }
  reversedSequence.get = function (key, notSetValue) { return collection.get(useKeys ? key : -1 - key, notSetValue); };
  reversedSequence.has = function (key) { return collection.has(useKeys ? key : -1 - key); };
  reversedSequence.includes = function (value) { return collection.includes(value); };
  reversedSequence.cacheResult = cacheResultThrough;
  reversedSequence.__iterate = function (fn, reverse) {
    var this$1$1 = this;

    var i = 0;
    reverse && ensureSize(collection);
    return collection.__iterate(
      function (v, k) { return fn(v, useKeys ? k : reverse ? this$1$1.size - ++i : i++, this$1$1); },
      !reverse
    );
  };
  reversedSequence.__iterator = function (type, reverse) {
    var i = 0;
    reverse && ensureSize(collection);
    var iterator = collection.__iterator(ITERATE_ENTRIES, !reverse);
    return new Iterator(function () {
      var step = iterator.next();
      if (step.done) {
        return step;
      }
      var entry = step.value;
      return iteratorValue(
        type,
        useKeys ? entry[0] : reverse ? this$1$1.size - ++i : i++,
        entry[1],
        step
      );
    });
  };
  return reversedSequence;
}

function filterFactory(collection, predicate, context, useKeys) {
  var filterSequence = makeSequence(collection);
  if (useKeys) {
    filterSequence.has = function (key) {
      var v = collection.get(key, NOT_SET);
      return v !== NOT_SET && !!predicate.call(context, v, key, collection);
    };
    filterSequence.get = function (key, notSetValue) {
      var v = collection.get(key, NOT_SET);
      return v !== NOT_SET && predicate.call(context, v, key, collection)
        ? v
        : notSetValue;
    };
  }
  filterSequence.__iterateUncached = function (fn, reverse) {
    var this$1$1 = this;

    var iterations = 0;
    collection.__iterate(function (v, k, c) {
      if (predicate.call(context, v, k, c)) {
        iterations++;
        return fn(v, useKeys ? k : iterations - 1, this$1$1);
      }
    }, reverse);
    return iterations;
  };
  filterSequence.__iteratorUncached = function (type, reverse) {
    var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
    var iterations = 0;
    return new Iterator(function () {
      while (true) {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        var value = entry[1];
        if (predicate.call(context, value, key, collection)) {
          return iteratorValue(type, useKeys ? key : iterations++, value, step);
        }
      }
    });
  };
  return filterSequence;
}

function countByFactory(collection, grouper, context) {
  var groups = Map().asMutable();
  collection.__iterate(function (v, k) {
    groups.update(grouper.call(context, v, k, collection), 0, function (a) { return a + 1; });
  });
  return groups.asImmutable();
}

function groupByFactory(collection, grouper, context) {
  var isKeyedIter = isKeyed(collection);
  var groups = (isOrdered(collection) ? OrderedMap() : Map()).asMutable();
  collection.__iterate(function (v, k) {
    groups.update(
      grouper.call(context, v, k, collection),
      function (a) { return ((a = a || []), a.push(isKeyedIter ? [k, v] : v), a); }
    );
  });
  var coerce = collectionClass(collection);
  return groups.map(function (arr) { return reify(collection, coerce(arr)); }).asImmutable();
}

function partitionFactory(collection, predicate, context) {
  var isKeyedIter = isKeyed(collection);
  var groups = [[], []];
  collection.__iterate(function (v, k) {
    groups[predicate.call(context, v, k, collection) ? 1 : 0].push(
      isKeyedIter ? [k, v] : v
    );
  });
  var coerce = collectionClass(collection);
  return groups.map(function (arr) { return reify(collection, coerce(arr)); });
}

function sliceFactory(collection, begin, end, useKeys) {
  var originalSize = collection.size;

  if (wholeSlice(begin, end, originalSize)) {
    return collection;
  }

  // begin or end can not be resolved if they were provided as negative numbers and
  // this collection's size is unknown. In that case, cache first so there is
  // a known size and these do not resolve to NaN.
  if (typeof originalSize === 'undefined' && (begin < 0 || end < 0)) {
    return sliceFactory(collection.toSeq().cacheResult(), begin, end, useKeys);
  }

  var resolvedBegin = resolveBegin(begin, originalSize);
  var resolvedEnd = resolveEnd(end, originalSize);

  // Note: resolvedEnd is undefined when the original sequence's length is
  // unknown and this slice did not supply an end and should contain all
  // elements after resolvedBegin.
  // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
  var resolvedSize = resolvedEnd - resolvedBegin;
  var sliceSize;
  if (resolvedSize === resolvedSize) {
    sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
  }

  var sliceSeq = makeSequence(collection);

  // If collection.size is undefined, the size of the realized sliceSeq is
  // unknown at this point unless the number of items to slice is 0
  sliceSeq.size =
    sliceSize === 0 ? sliceSize : (collection.size && sliceSize) || undefined;

  if (!useKeys && isSeq(collection) && sliceSize >= 0) {
    sliceSeq.get = function (index, notSetValue) {
      index = wrapIndex(this, index);
      return index >= 0 && index < sliceSize
        ? collection.get(index + resolvedBegin, notSetValue)
        : notSetValue;
    };
  }

  sliceSeq.__iterateUncached = function (fn, reverse) {
    var this$1$1 = this;

    if (sliceSize === 0) {
      return 0;
    }
    if (reverse) {
      return this.cacheResult().__iterate(fn, reverse);
    }
    var skipped = 0;
    var isSkipping = true;
    var iterations = 0;
    collection.__iterate(function (v, k) {
      if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
        iterations++;
        return (
          fn(v, useKeys ? k : iterations - 1, this$1$1) !== false &&
          iterations !== sliceSize
        );
      }
    });
    return iterations;
  };

  sliceSeq.__iteratorUncached = function (type, reverse) {
    if (sliceSize !== 0 && reverse) {
      return this.cacheResult().__iterator(type, reverse);
    }
    // Don't bother instantiating parent iterator if taking 0.
    if (sliceSize === 0) {
      return new Iterator(iteratorDone);
    }
    var iterator = collection.__iterator(type, reverse);
    var skipped = 0;
    var iterations = 0;
    return new Iterator(function () {
      while (skipped++ < resolvedBegin) {
        iterator.next();
      }
      if (++iterations > sliceSize) {
        return iteratorDone();
      }
      var step = iterator.next();
      if (useKeys || type === ITERATE_VALUES || step.done) {
        return step;
      }
      if (type === ITERATE_KEYS) {
        return iteratorValue(type, iterations - 1, undefined, step);
      }
      return iteratorValue(type, iterations - 1, step.value[1], step);
    });
  };

  return sliceSeq;
}

function takeWhileFactory(collection, predicate, context) {
  var takeSequence = makeSequence(collection);
  takeSequence.__iterateUncached = function (fn, reverse) {
    var this$1$1 = this;

    if (reverse) {
      return this.cacheResult().__iterate(fn, reverse);
    }
    var iterations = 0;
    collection.__iterate(
      function (v, k, c) { return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$1$1); }
    );
    return iterations;
  };
  takeSequence.__iteratorUncached = function (type, reverse) {
    var this$1$1 = this;

    if (reverse) {
      return this.cacheResult().__iterator(type, reverse);
    }
    var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
    var iterating = true;
    return new Iterator(function () {
      if (!iterating) {
        return iteratorDone();
      }
      var step = iterator.next();
      if (step.done) {
        return step;
      }
      var entry = step.value;
      var k = entry[0];
      var v = entry[1];
      if (!predicate.call(context, v, k, this$1$1)) {
        iterating = false;
        return iteratorDone();
      }
      return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
    });
  };
  return takeSequence;
}

function skipWhileFactory(collection, predicate, context, useKeys) {
  var skipSequence = makeSequence(collection);
  skipSequence.__iterateUncached = function (fn, reverse) {
    var this$1$1 = this;

    if (reverse) {
      return this.cacheResult().__iterate(fn, reverse);
    }
    var isSkipping = true;
    var iterations = 0;
    collection.__iterate(function (v, k, c) {
      if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
        iterations++;
        return fn(v, useKeys ? k : iterations - 1, this$1$1);
      }
    });
    return iterations;
  };
  skipSequence.__iteratorUncached = function (type, reverse) {
    var this$1$1 = this;

    if (reverse) {
      return this.cacheResult().__iterator(type, reverse);
    }
    var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
    var skipping = true;
    var iterations = 0;
    return new Iterator(function () {
      var step;
      var k;
      var v;
      do {
        step = iterator.next();
        if (step.done) {
          if (useKeys || type === ITERATE_VALUES) {
            return step;
          }
          if (type === ITERATE_KEYS) {
            return iteratorValue(type, iterations++, undefined, step);
          }
          return iteratorValue(type, iterations++, step.value[1], step);
        }
        var entry = step.value;
        k = entry[0];
        v = entry[1];
        skipping && (skipping = predicate.call(context, v, k, this$1$1));
      } while (skipping);
      return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
    });
  };
  return skipSequence;
}

function concatFactory(collection, values) {
  var isKeyedCollection = isKeyed(collection);
  var iters = [collection]
    .concat(values)
    .map(function (v) {
      if (!isCollection(v)) {
        v = isKeyedCollection
          ? keyedSeqFromValue(v)
          : indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedCollection) {
        v = KeyedCollection(v);
      }
      return v;
    })
    .filter(function (v) { return v.size !== 0; });

  if (iters.length === 0) {
    return collection;
  }

  if (iters.length === 1) {
    var singleton = iters[0];
    if (
      singleton === collection ||
      (isKeyedCollection && isKeyed(singleton)) ||
      (isIndexed(collection) && isIndexed(singleton))
    ) {
      return singleton;
    }
  }

  var concatSeq = new ArraySeq(iters);
  if (isKeyedCollection) {
    concatSeq = concatSeq.toKeyedSeq();
  } else if (!isIndexed(collection)) {
    concatSeq = concatSeq.toSetSeq();
  }
  concatSeq = concatSeq.flatten(true);
  concatSeq.size = iters.reduce(function (sum, seq) {
    if (sum !== undefined) {
      var size = seq.size;
      if (size !== undefined) {
        return sum + size;
      }
    }
  }, 0);
  return concatSeq;
}

function flattenFactory(collection, depth, useKeys) {
  var flatSequence = makeSequence(collection);
  flatSequence.__iterateUncached = function (fn, reverse) {
    if (reverse) {
      return this.cacheResult().__iterate(fn, reverse);
    }
    var iterations = 0;
    var stopped = false;
    function flatDeep(iter, currentDepth) {
      iter.__iterate(function (v, k) {
        if ((!depth || currentDepth < depth) && isCollection(v)) {
          flatDeep(v, currentDepth + 1);
        } else {
          iterations++;
          if (fn(v, useKeys ? k : iterations - 1, flatSequence) === false) {
            stopped = true;
          }
        }
        return !stopped;
      }, reverse);
    }
    flatDeep(collection, 0);
    return iterations;
  };
  flatSequence.__iteratorUncached = function (type, reverse) {
    if (reverse) {
      return this.cacheResult().__iterator(type, reverse);
    }
    var iterator = collection.__iterator(type, reverse);
    var stack = [];
    var iterations = 0;
    return new Iterator(function () {
      while (iterator) {
        var step = iterator.next();
        if (step.done !== false) {
          iterator = stack.pop();
          continue;
        }
        var v = step.value;
        if (type === ITERATE_ENTRIES) {
          v = v[1];
        }
        if ((!depth || stack.length < depth) && isCollection(v)) {
          stack.push(iterator);
          iterator = v.__iterator(type, reverse);
        } else {
          return useKeys ? step : iteratorValue(type, iterations++, v, step);
        }
      }
      return iteratorDone();
    });
  };
  return flatSequence;
}

function flatMapFactory(collection, mapper, context) {
  var coerce = collectionClass(collection);
  return collection
    .toSeq()
    .map(function (v, k) { return coerce(mapper.call(context, v, k, collection)); })
    .flatten(true);
}

function interposeFactory(collection, separator) {
  var interposedSequence = makeSequence(collection);
  interposedSequence.size = collection.size && collection.size * 2 - 1;
  interposedSequence.__iterateUncached = function (fn, reverse) {
    var this$1$1 = this;

    var iterations = 0;
    collection.__iterate(
      function (v) { return (!iterations || fn(separator, iterations++, this$1$1) !== false) &&
        fn(v, iterations++, this$1$1) !== false; },
      reverse
    );
    return iterations;
  };
  interposedSequence.__iteratorUncached = function (type, reverse) {
    var iterator = collection.__iterator(ITERATE_VALUES, reverse);
    var iterations = 0;
    var step;
    return new Iterator(function () {
      if (!step || iterations % 2) {
        step = iterator.next();
        if (step.done) {
          return step;
        }
      }
      return iterations % 2
        ? iteratorValue(type, iterations++, separator)
        : iteratorValue(type, iterations++, step.value, step);
    });
  };
  return interposedSequence;
}

function sortFactory(collection, comparator, mapper) {
  if (!comparator) {
    comparator = defaultComparator;
  }
  var isKeyedCollection = isKeyed(collection);
  var index = 0;
  var entries = collection
    .toSeq()
    .map(function (v, k) { return [k, v, index++, mapper ? mapper(v, k, collection) : v]; })
    .valueSeq()
    .toArray();
  entries
    .sort(function (a, b) { return comparator(a[3], b[3]) || a[2] - b[2]; })
    .forEach(
      isKeyedCollection
        ? function (v, i) {
            entries[i].length = 2;
          }
        : function (v, i) {
            entries[i] = v[1];
          }
    );
  return isKeyedCollection
    ? KeyedSeq(entries)
    : isIndexed(collection)
    ? IndexedSeq(entries)
    : SetSeq(entries);
}

function maxFactory(collection, comparator, mapper) {
  if (!comparator) {
    comparator = defaultComparator;
  }
  if (mapper) {
    var entry = collection
      .toSeq()
      .map(function (v, k) { return [v, mapper(v, k, collection)]; })
      .reduce(function (a, b) { return (maxCompare(comparator, a[1], b[1]) ? b : a); });
    return entry && entry[0];
  }
  return collection.reduce(function (a, b) { return (maxCompare(comparator, a, b) ? b : a); });
}

function maxCompare(comparator, a, b) {
  var comp = comparator(b, a);
  // b is considered the new max if the comparator declares them equal, but
  // they are not equal and b is in fact a nullish value.
  return (
    (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) ||
    comp > 0
  );
}

function zipWithFactory(keyIter, zipper, iters, zipAll) {
  var zipSequence = makeSequence(keyIter);
  var sizes = new ArraySeq(iters).map(function (i) { return i.size; });
  zipSequence.size = zipAll ? sizes.max() : sizes.min();
  // Note: this a generic base implementation of __iterate in terms of
  // __iterator which may be more generically useful in the future.
  zipSequence.__iterate = function (fn, reverse) {
    /* generic:
    var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
    var step;
    var iterations = 0;
    while (!(step = iterator.next()).done) {
      iterations++;
      if (fn(step.value[1], step.value[0], this) === false) {
        break;
      }
    }
    return iterations;
    */
    // indexed:
    var iterator = this.__iterator(ITERATE_VALUES, reverse);
    var step;
    var iterations = 0;
    while (!(step = iterator.next()).done) {
      if (fn(step.value, iterations++, this) === false) {
        break;
      }
    }
    return iterations;
  };
  zipSequence.__iteratorUncached = function (type, reverse) {
    var iterators = iters.map(
      function (i) { return ((i = Collection(i)), getIterator(reverse ? i.reverse() : i)); }
    );
    var iterations = 0;
    var isDone = false;
    return new Iterator(function () {
      var steps;
      if (!isDone) {
        steps = iterators.map(function (i) { return i.next(); });
        isDone = zipAll ? steps.every(function (s) { return s.done; }) : steps.some(function (s) { return s.done; });
      }
      if (isDone) {
        return iteratorDone();
      }
      return iteratorValue(
        type,
        iterations++,
        zipper.apply(
          null,
          steps.map(function (s) { return s.value; })
        )
      );
    });
  };
  return zipSequence;
}

// #pragma Helper Functions

function reify(iter, seq) {
  return iter === seq ? iter : isSeq(iter) ? seq : iter.constructor(seq);
}

function validateEntry(entry) {
  if (entry !== Object(entry)) {
    throw new TypeError('Expected [K, V] tuple: ' + entry);
  }
}

function collectionClass(collection) {
  return isKeyed(collection)
    ? KeyedCollection
    : isIndexed(collection)
    ? IndexedCollection
    : SetCollection;
}

function makeSequence(collection) {
  return Object.create(
    (isKeyed(collection)
      ? KeyedSeq
      : isIndexed(collection)
      ? IndexedSeq
      : SetSeq
    ).prototype
  );
}

function cacheResultThrough() {
  if (this._iter.cacheResult) {
    this._iter.cacheResult();
    this.size = this._iter.size;
    return this;
  }
  return Seq.prototype.cacheResult.call(this);
}

function defaultComparator(a, b) {
  if (a === undefined && b === undefined) {
    return 0;
  }

  if (a === undefined) {
    return 1;
  }

  if (b === undefined) {
    return -1;
  }

  return a > b ? 1 : a < b ? -1 : 0;
}

function arrCopy(arr, offset) {
  offset = offset || 0;
  var len = Math.max(0, arr.length - offset);
  var newArr = new Array(len);
  for (var ii = 0; ii < len; ii++) {
    newArr[ii] = arr[ii + offset];
  }
  return newArr;
}

function invariant(condition, error) {
  if (!condition) { throw new Error(error); }
}

function assertNotInfinite(size) {
  invariant(
    size !== Infinity,
    'Cannot perform this action with an infinite size.'
  );
}

function coerceKeyPath(keyPath) {
  if (isArrayLike(keyPath) && typeof keyPath !== 'string') {
    return keyPath;
  }
  if (isOrdered(keyPath)) {
    return keyPath.toArray();
  }
  throw new TypeError(
    'Invalid keyPath: expected Ordered Collection or Array: ' + keyPath
  );
}

var toString = Object.prototype.toString;

function isPlainObject(value) {
  // The base prototype's toString deals with Argument objects and native namespaces like Math
  if (
    !value ||
    typeof value !== 'object' ||
    toString.call(value) !== '[object Object]'
  ) {
    return false;
  }

  var proto = Object.getPrototypeOf(value);
  if (proto === null) {
    return true;
  }

  // Iteratively going up the prototype chain is needed for cross-realm environments (differing contexts, iframes, etc)
  var parentProto = proto;
  var nextProto = Object.getPrototypeOf(proto);
  while (nextProto !== null) {
    parentProto = nextProto;
    nextProto = Object.getPrototypeOf(parentProto);
  }
  return parentProto === proto;
}

/**
 * Returns true if the value is a potentially-persistent data structure, either
 * provided by Immutable.js or a plain Array or Object.
 */
function isDataStructure(value) {
  return (
    typeof value === 'object' &&
    (isImmutable(value) || Array.isArray(value) || isPlainObject(value))
  );
}

function quoteString(value) {
  try {
    return typeof value === 'string' ? JSON.stringify(value) : String(value);
  } catch (_ignoreError) {
    return JSON.stringify(value);
  }
}

function has(collection, key) {
  return isImmutable(collection)
    ? collection.has(key)
    : isDataStructure(collection) && hasOwnProperty.call(collection, key);
}

function get(collection, key, notSetValue) {
  return isImmutable(collection)
    ? collection.get(key, notSetValue)
    : !has(collection, key)
    ? notSetValue
    : typeof collection.get === 'function'
    ? collection.get(key)
    : collection[key];
}

function isProtoKey(key) {
  return (
    typeof key === 'string' && (key === '__proto__' || key === 'constructor')
  );
}

function shallowCopy(from) {
  if (Array.isArray(from)) {
    return arrCopy(from);
  }
  var to = {};
  for (var key in from) {
    if (isProtoKey(key)) {
      continue;
    }

    if (hasOwnProperty.call(from, key)) {
      to[key] = from[key];
    }
  }
  return to;
}

function remove(collection, key) {
  if (!isDataStructure(collection)) {
    throw new TypeError(
      'Cannot update non-data-structure value: ' + collection
    );
  }
  if (isImmutable(collection)) {
    if (!collection.remove) {
      throw new TypeError(
        'Cannot update immutable value without .remove() method: ' + collection
      );
    }
    return collection.remove(key);
  }
  if (!hasOwnProperty.call(collection, key)) {
    return collection;
  }
  var collectionCopy = shallowCopy(collection);
  if (Array.isArray(collectionCopy)) {
    collectionCopy.splice(key, 1);
  } else {
    delete collectionCopy[key];
  }
  return collectionCopy;
}

function set(collection, key, value) {
  if (isProtoKey(key)) {
    return collection;
  }

  if (!isDataStructure(collection)) {
    throw new TypeError(
      'Cannot update non-data-structure value: ' + collection
    );
  }
  if (isImmutable(collection)) {
    if (!collection.set) {
      throw new TypeError(
        'Cannot update immutable value without .set() method: ' + collection
      );
    }
    return collection.set(key, value);
  }
  if (hasOwnProperty.call(collection, key) && value === collection[key]) {
    return collection;
  }
  var collectionCopy = shallowCopy(collection);
  collectionCopy[key] = value;
  return collectionCopy;
}

function updateIn$1(collection, keyPath, notSetValue, updater) {
  if (!updater) {
    updater = notSetValue;
    notSetValue = undefined;
  }
  var updatedValue = updateInDeeply(
    isImmutable(collection),
    collection,
    coerceKeyPath(keyPath),
    0,
    notSetValue,
    updater
  );
  return updatedValue === NOT_SET ? notSetValue : updatedValue;
}

function updateInDeeply(
  inImmutable,
  existing,
  keyPath,
  i,
  notSetValue,
  updater
) {
  var wasNotSet = existing === NOT_SET;
  if (i === keyPath.length) {
    var existingValue = wasNotSet ? notSetValue : existing;
    var newValue = updater(existingValue);
    return newValue === existingValue ? existing : newValue;
  }
  if (!wasNotSet && !isDataStructure(existing)) {
    throw new TypeError(
      'Cannot update within non-data-structure value in path [' +
        keyPath.slice(0, i).map(quoteString) +
        ']: ' +
        existing
    );
  }
  var key = keyPath[i];
  var nextExisting = wasNotSet ? NOT_SET : get(existing, key, NOT_SET);
  var nextUpdated = updateInDeeply(
    nextExisting === NOT_SET ? inImmutable : isImmutable(nextExisting),
    nextExisting,
    keyPath,
    i + 1,
    notSetValue,
    updater
  );
  return nextUpdated === nextExisting
    ? existing
    : nextUpdated === NOT_SET
    ? remove(existing, key)
    : set(
        wasNotSet ? (inImmutable ? emptyMap() : {}) : existing,
        key,
        nextUpdated
      );
}

function setIn$1(collection, keyPath, value) {
  return updateIn$1(collection, keyPath, NOT_SET, function () { return value; });
}

function setIn(keyPath, v) {
  return setIn$1(this, keyPath, v);
}

function removeIn(collection, keyPath) {
  return updateIn$1(collection, keyPath, function () { return NOT_SET; });
}

function deleteIn(keyPath) {
  return removeIn(this, keyPath);
}

function update$1(collection, key, notSetValue, updater) {
  return updateIn$1(collection, [key], notSetValue, updater);
}

function update(key, notSetValue, updater) {
  return arguments.length === 1
    ? key(this)
    : update$1(this, key, notSetValue, updater);
}

function updateIn(keyPath, notSetValue, updater) {
  return updateIn$1(this, keyPath, notSetValue, updater);
}

function merge$1() {
  var iters = [], len = arguments.length;
  while ( len-- ) iters[ len ] = arguments[ len ];

  return mergeIntoKeyedWith(this, iters);
}

function mergeWith$1(merger) {
  var iters = [], len = arguments.length - 1;
  while ( len-- > 0 ) iters[ len ] = arguments[ len + 1 ];

  if (typeof merger !== 'function') {
    throw new TypeError('Invalid merger function: ' + merger);
  }
  return mergeIntoKeyedWith(this, iters, merger);
}

function mergeIntoKeyedWith(collection, collections, merger) {
  var iters = [];
  for (var ii = 0; ii < collections.length; ii++) {
    var collection$1 = KeyedCollection(collections[ii]);
    if (collection$1.size !== 0) {
      iters.push(collection$1);
    }
  }
  if (iters.length === 0) {
    return collection;
  }
  if (
    collection.toSeq().size === 0 &&
    !collection.__ownerID &&
    iters.length === 1
  ) {
    return collection.constructor(iters[0]);
  }
  return collection.withMutations(function (collection) {
    var mergeIntoCollection = merger
      ? function (value, key) {
          update$1(collection, key, NOT_SET, function (oldVal) { return oldVal === NOT_SET ? value : merger(oldVal, value, key); }
          );
        }
      : function (value, key) {
          collection.set(key, value);
        };
    for (var ii = 0; ii < iters.length; ii++) {
      iters[ii].forEach(mergeIntoCollection);
    }
  });
}

function merge(collection) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];

  return mergeWithSources(collection, sources);
}

function mergeWith(merger, collection) {
  var sources = [], len = arguments.length - 2;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 2 ];

  return mergeWithSources(collection, sources, merger);
}

function mergeDeep$1(collection) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];

  return mergeDeepWithSources(collection, sources);
}

function mergeDeepWith$1(merger, collection) {
  var sources = [], len = arguments.length - 2;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 2 ];

  return mergeDeepWithSources(collection, sources, merger);
}

function mergeDeepWithSources(collection, sources, merger) {
  return mergeWithSources(collection, sources, deepMergerWith(merger));
}

function mergeWithSources(collection, sources, merger) {
  if (!isDataStructure(collection)) {
    throw new TypeError(
      'Cannot merge into non-data-structure value: ' + collection
    );
  }
  if (isImmutable(collection)) {
    return typeof merger === 'function' && collection.mergeWith
      ? collection.mergeWith.apply(collection, [ merger ].concat( sources ))
      : collection.merge
      ? collection.merge.apply(collection, sources)
      : collection.concat.apply(collection, sources);
  }
  var isArray = Array.isArray(collection);
  var merged = collection;
  var Collection = isArray ? IndexedCollection : KeyedCollection;
  var mergeItem = isArray
    ? function (value) {
        // Copy on write
        if (merged === collection) {
          merged = shallowCopy(merged);
        }
        merged.push(value);
      }
    : function (value, key) {
        if (isProtoKey(key)) {
          return;
        }

        var hasVal = hasOwnProperty.call(merged, key);
        var nextVal =
          hasVal && merger ? merger(merged[key], value, key) : value;
        if (!hasVal || nextVal !== merged[key]) {
          // Copy on write
          if (merged === collection) {
            merged = shallowCopy(merged);
          }
          merged[key] = nextVal;
        }
      };
  for (var i = 0; i < sources.length; i++) {
    Collection(sources[i]).forEach(mergeItem);
  }
  return merged;
}

function deepMergerWith(merger) {
  function deepMerger(oldValue, newValue, key) {
    return isDataStructure(oldValue) &&
      isDataStructure(newValue) &&
      areMergeable(oldValue, newValue)
      ? mergeWithSources(oldValue, [newValue], deepMerger)
      : merger
      ? merger(oldValue, newValue, key)
      : newValue;
  }
  return deepMerger;
}

/**
 * It's unclear what the desired behavior is for merging two collections that
 * fall into separate categories between keyed, indexed, or set-like, so we only
 * consider them mergeable if they fall into the same category.
 */
function areMergeable(oldDataStructure, newDataStructure) {
  var oldSeq = Seq(oldDataStructure);
  var newSeq = Seq(newDataStructure);
  // This logic assumes that a sequence can only fall into one of the three
  // categories mentioned above (since there's no `isSetLike()` method).
  return (
    isIndexed(oldSeq) === isIndexed(newSeq) &&
    isKeyed(oldSeq) === isKeyed(newSeq)
  );
}

function mergeDeep() {
  var iters = [], len = arguments.length;
  while ( len-- ) iters[ len ] = arguments[ len ];

  return mergeDeepWithSources(this, iters);
}

function mergeDeepWith(merger) {
  var iters = [], len = arguments.length - 1;
  while ( len-- > 0 ) iters[ len ] = arguments[ len + 1 ];

  return mergeDeepWithSources(this, iters, merger);
}

function mergeIn(keyPath) {
  var iters = [], len = arguments.length - 1;
  while ( len-- > 0 ) iters[ len ] = arguments[ len + 1 ];

  return updateIn$1(this, keyPath, emptyMap(), function (m) { return mergeWithSources(m, iters); });
}

function mergeDeepIn(keyPath) {
  var iters = [], len = arguments.length - 1;
  while ( len-- > 0 ) iters[ len ] = arguments[ len + 1 ];

  return updateIn$1(this, keyPath, emptyMap(), function (m) { return mergeDeepWithSources(m, iters); }
  );
}

function withMutations(fn) {
  var mutable = this.asMutable();
  fn(mutable);
  return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
}

function asMutable() {
  return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
}

function asImmutable() {
  return this.__ensureOwner();
}

function wasAltered() {
  return this.__altered;
}

var Map = /*@__PURE__*/(function (KeyedCollection) {
  function Map(value) {
    // eslint-disable-next-line no-constructor-return
    return value === undefined || value === null
      ? emptyMap()
      : isMap(value) && !isOrdered(value)
      ? value
      : emptyMap().withMutations(function (map) {
          var iter = KeyedCollection(value);
          assertNotInfinite(iter.size);
          iter.forEach(function (v, k) { return map.set(k, v); });
        });
  }

  if ( KeyedCollection ) Map.__proto__ = KeyedCollection;
  Map.prototype = Object.create( KeyedCollection && KeyedCollection.prototype );
  Map.prototype.constructor = Map;

  Map.of = function of () {
    var keyValues = [], len = arguments.length;
    while ( len-- ) keyValues[ len ] = arguments[ len ];

    return emptyMap().withMutations(function (map) {
      for (var i = 0; i < keyValues.length; i += 2) {
        if (i + 1 >= keyValues.length) {
          throw new Error('Missing value for key: ' + keyValues[i]);
        }
        map.set(keyValues[i], keyValues[i + 1]);
      }
    });
  };

  Map.prototype.toString = function toString () {
    return this.__toString('Map {', '}');
  };

  // @pragma Access

  Map.prototype.get = function get (k, notSetValue) {
    return this._root
      ? this._root.get(0, undefined, k, notSetValue)
      : notSetValue;
  };

  // @pragma Modification

  Map.prototype.set = function set (k, v) {
    return updateMap(this, k, v);
  };

  Map.prototype.remove = function remove (k) {
    return updateMap(this, k, NOT_SET);
  };

  Map.prototype.deleteAll = function deleteAll (keys) {
    var collection = Collection(keys);

    if (collection.size === 0) {
      return this;
    }

    return this.withMutations(function (map) {
      collection.forEach(function (key) { return map.remove(key); });
    });
  };

  Map.prototype.clear = function clear () {
    if (this.size === 0) {
      return this;
    }
    if (this.__ownerID) {
      this.size = 0;
      this._root = null;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return emptyMap();
  };

  // @pragma Composition

  Map.prototype.sort = function sort (comparator) {
    // Late binding
    return OrderedMap(sortFactory(this, comparator));
  };

  Map.prototype.sortBy = function sortBy (mapper, comparator) {
    // Late binding
    return OrderedMap(sortFactory(this, comparator, mapper));
  };

  Map.prototype.map = function map (mapper, context) {
    var this$1$1 = this;

    return this.withMutations(function (map) {
      map.forEach(function (value, key) {
        map.set(key, mapper.call(context, value, key, this$1$1));
      });
    });
  };

  // @pragma Mutability

  Map.prototype.__iterator = function __iterator (type, reverse) {
    return new MapIterator(this, type, reverse);
  };

  Map.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1$1 = this;

    var iterations = 0;
    this._root &&
      this._root.iterate(function (entry) {
        iterations++;
        return fn(entry[1], entry[0], this$1$1);
      }, reverse);
    return iterations;
  };

  Map.prototype.__ensureOwner = function __ensureOwner (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    if (!ownerID) {
      if (this.size === 0) {
        return emptyMap();
      }
      this.__ownerID = ownerID;
      this.__altered = false;
      return this;
    }
    return makeMap(this.size, this._root, ownerID, this.__hash);
  };

  return Map;
}(KeyedCollection));

Map.isMap = isMap;

var MapPrototype = Map.prototype;
MapPrototype[IS_MAP_SYMBOL] = true;
MapPrototype[DELETE] = MapPrototype.remove;
MapPrototype.removeAll = MapPrototype.deleteAll;
MapPrototype.setIn = setIn;
MapPrototype.removeIn = MapPrototype.deleteIn = deleteIn;
MapPrototype.update = update;
MapPrototype.updateIn = updateIn;
MapPrototype.merge = MapPrototype.concat = merge$1;
MapPrototype.mergeWith = mergeWith$1;
MapPrototype.mergeDeep = mergeDeep;
MapPrototype.mergeDeepWith = mergeDeepWith;
MapPrototype.mergeIn = mergeIn;
MapPrototype.mergeDeepIn = mergeDeepIn;
MapPrototype.withMutations = withMutations;
MapPrototype.wasAltered = wasAltered;
MapPrototype.asImmutable = asImmutable;
MapPrototype['@@transducer/init'] = MapPrototype.asMutable = asMutable;
MapPrototype['@@transducer/step'] = function (result, arr) {
  return result.set(arr[0], arr[1]);
};
MapPrototype['@@transducer/result'] = function (obj) {
  return obj.asImmutable();
};

// #pragma Trie Nodes

var ArrayMapNode = function ArrayMapNode(ownerID, entries) {
  this.ownerID = ownerID;
  this.entries = entries;
};

ArrayMapNode.prototype.get = function get (shift, keyHash, key, notSetValue) {
  var entries = this.entries;
  for (var ii = 0, len = entries.length; ii < len; ii++) {
    if (is(key, entries[ii][0])) {
      return entries[ii][1];
    }
  }
  return notSetValue;
};

ArrayMapNode.prototype.update = function update (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
  var removed = value === NOT_SET;

  var entries = this.entries;
  var idx = 0;
  var len = entries.length;
  for (; idx < len; idx++) {
    if (is(key, entries[idx][0])) {
      break;
    }
  }
  var exists = idx < len;

  if (exists ? entries[idx][1] === value : removed) {
    return this;
  }

  SetRef(didAlter);
  (removed || !exists) && SetRef(didChangeSize);

  if (removed && entries.length === 1) {
    return; // undefined
  }

  if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
    return createNodes(ownerID, entries, key, value);
  }

  var isEditable = ownerID && ownerID === this.ownerID;
  var newEntries = isEditable ? entries : arrCopy(entries);

  if (exists) {
    if (removed) {
      idx === len - 1
        ? newEntries.pop()
        : (newEntries[idx] = newEntries.pop());
    } else {
      newEntries[idx] = [key, value];
    }
  } else {
    newEntries.push([key, value]);
  }

  if (isEditable) {
    this.entries = newEntries;
    return this;
  }

  return new ArrayMapNode(ownerID, newEntries);
};

var BitmapIndexedNode = function BitmapIndexedNode(ownerID, bitmap, nodes) {
  this.ownerID = ownerID;
  this.bitmap = bitmap;
  this.nodes = nodes;
};

BitmapIndexedNode.prototype.get = function get (shift, keyHash, key, notSetValue) {
  if (keyHash === undefined) {
    keyHash = hash(key);
  }
  var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
  var bitmap = this.bitmap;
  return (bitmap & bit) === 0
    ? notSetValue
    : this.nodes[popCount(bitmap & (bit - 1))].get(
        shift + SHIFT,
        keyHash,
        key,
        notSetValue
      );
};

BitmapIndexedNode.prototype.update = function update (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
  if (keyHash === undefined) {
    keyHash = hash(key);
  }
  var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
  var bit = 1 << keyHashFrag;
  var bitmap = this.bitmap;
  var exists = (bitmap & bit) !== 0;

  if (!exists && value === NOT_SET) {
    return this;
  }

  var idx = popCount(bitmap & (bit - 1));
  var nodes = this.nodes;
  var node = exists ? nodes[idx] : undefined;
  var newNode = updateNode(
    node,
    ownerID,
    shift + SHIFT,
    keyHash,
    key,
    value,
    didChangeSize,
    didAlter
  );

  if (newNode === node) {
    return this;
  }

  if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
    return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
  }

  if (
    exists &&
    !newNode &&
    nodes.length === 2 &&
    isLeafNode(nodes[idx ^ 1])
  ) {
    return nodes[idx ^ 1];
  }

  if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
    return newNode;
  }

  var isEditable = ownerID && ownerID === this.ownerID;
  var newBitmap = exists ? (newNode ? bitmap : bitmap ^ bit) : bitmap | bit;
  var newNodes = exists
    ? newNode
      ? setAt(nodes, idx, newNode, isEditable)
      : spliceOut(nodes, idx, isEditable)
    : spliceIn(nodes, idx, newNode, isEditable);

  if (isEditable) {
    this.bitmap = newBitmap;
    this.nodes = newNodes;
    return this;
  }

  return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
};

var HashArrayMapNode = function HashArrayMapNode(ownerID, count, nodes) {
  this.ownerID = ownerID;
  this.count = count;
  this.nodes = nodes;
};

HashArrayMapNode.prototype.get = function get (shift, keyHash, key, notSetValue) {
  if (keyHash === undefined) {
    keyHash = hash(key);
  }
  var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
  var node = this.nodes[idx];
  return node
    ? node.get(shift + SHIFT, keyHash, key, notSetValue)
    : notSetValue;
};

HashArrayMapNode.prototype.update = function update (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
  if (keyHash === undefined) {
    keyHash = hash(key);
  }
  var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
  var removed = value === NOT_SET;
  var nodes = this.nodes;
  var node = nodes[idx];

  if (removed && !node) {
    return this;
  }

  var newNode = updateNode(
    node,
    ownerID,
    shift + SHIFT,
    keyHash,
    key,
    value,
    didChangeSize,
    didAlter
  );
  if (newNode === node) {
    return this;
  }

  var newCount = this.count;
  if (!node) {
    newCount++;
  } else if (!newNode) {
    newCount--;
    if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
      return packNodes(ownerID, nodes, newCount, idx);
    }
  }

  var isEditable = ownerID && ownerID === this.ownerID;
  var newNodes = setAt(nodes, idx, newNode, isEditable);

  if (isEditable) {
    this.count = newCount;
    this.nodes = newNodes;
    return this;
  }

  return new HashArrayMapNode(ownerID, newCount, newNodes);
};

var HashCollisionNode = function HashCollisionNode(ownerID, keyHash, entries) {
  this.ownerID = ownerID;
  this.keyHash = keyHash;
  this.entries = entries;
};

HashCollisionNode.prototype.get = function get (shift, keyHash, key, notSetValue) {
  var entries = this.entries;
  for (var ii = 0, len = entries.length; ii < len; ii++) {
    if (is(key, entries[ii][0])) {
      return entries[ii][1];
    }
  }
  return notSetValue;
};

HashCollisionNode.prototype.update = function update (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
  if (keyHash === undefined) {
    keyHash = hash(key);
  }

  var removed = value === NOT_SET;

  if (keyHash !== this.keyHash) {
    if (removed) {
      return this;
    }
    SetRef(didAlter);
    SetRef(didChangeSize);
    return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
  }

  var entries = this.entries;
  var idx = 0;
  var len = entries.length;
  for (; idx < len; idx++) {
    if (is(key, entries[idx][0])) {
      break;
    }
  }
  var exists = idx < len;

  if (exists ? entries[idx][1] === value : removed) {
    return this;
  }

  SetRef(didAlter);
  (removed || !exists) && SetRef(didChangeSize);

  if (removed && len === 2) {
    return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
  }

  var isEditable = ownerID && ownerID === this.ownerID;
  var newEntries = isEditable ? entries : arrCopy(entries);

  if (exists) {
    if (removed) {
      idx === len - 1
        ? newEntries.pop()
        : (newEntries[idx] = newEntries.pop());
    } else {
      newEntries[idx] = [key, value];
    }
  } else {
    newEntries.push([key, value]);
  }

  if (isEditable) {
    this.entries = newEntries;
    return this;
  }

  return new HashCollisionNode(ownerID, this.keyHash, newEntries);
};

var ValueNode = function ValueNode(ownerID, keyHash, entry) {
  this.ownerID = ownerID;
  this.keyHash = keyHash;
  this.entry = entry;
};

ValueNode.prototype.get = function get (shift, keyHash, key, notSetValue) {
  return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
};

ValueNode.prototype.update = function update (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
  var removed = value === NOT_SET;
  var keyMatch = is(key, this.entry[0]);
  if (keyMatch ? value === this.entry[1] : removed) {
    return this;
  }

  SetRef(didAlter);

  if (removed) {
    SetRef(didChangeSize);
    return; // undefined
  }

  if (keyMatch) {
    if (ownerID && ownerID === this.ownerID) {
      this.entry[1] = value;
      return this;
    }
    return new ValueNode(ownerID, this.keyHash, [key, value]);
  }

  SetRef(didChangeSize);
  return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
};

// #pragma Iterators

ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate =
  function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  };

BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate =
  function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  };

// eslint-disable-next-line no-unused-vars
ValueNode.prototype.iterate = function (fn, reverse) {
  return fn(this.entry);
};

var MapIterator = /*@__PURE__*/(function (Iterator) {
  function MapIterator(map, type, reverse) {
    this._type = type;
    this._reverse = reverse;
    this._stack = map._root && mapIteratorFrame(map._root);
  }

  if ( Iterator ) MapIterator.__proto__ = Iterator;
  MapIterator.prototype = Object.create( Iterator && Iterator.prototype );
  MapIterator.prototype.constructor = MapIterator;

  MapIterator.prototype.next = function next () {
    var type = this._type;
    var stack = this._stack;
    while (stack) {
      var node = stack.node;
      var index = stack.index++;
      var maxIndex = (void 0);
      if (node.entry) {
        if (index === 0) {
          return mapIteratorValue(type, node.entry);
        }
      } else if (node.entries) {
        maxIndex = node.entries.length - 1;
        if (index <= maxIndex) {
          return mapIteratorValue(
            type,
            node.entries[this._reverse ? maxIndex - index : index]
          );
        }
      } else {
        maxIndex = node.nodes.length - 1;
        if (index <= maxIndex) {
          var subNode = node.nodes[this._reverse ? maxIndex - index : index];
          if (subNode) {
            if (subNode.entry) {
              return mapIteratorValue(type, subNode.entry);
            }
            stack = this._stack = mapIteratorFrame(subNode, stack);
          }
          continue;
        }
      }
      stack = this._stack = this._stack.__prev;
    }
    return iteratorDone();
  };

  return MapIterator;
}(Iterator));

function mapIteratorValue(type, entry) {
  return iteratorValue(type, entry[0], entry[1]);
}

function mapIteratorFrame(node, prev) {
  return {
    node: node,
    index: 0,
    __prev: prev,
  };
}

function makeMap(size, root, ownerID, hash) {
  var map = Object.create(MapPrototype);
  map.size = size;
  map._root = root;
  map.__ownerID = ownerID;
  map.__hash = hash;
  map.__altered = false;
  return map;
}

var EMPTY_MAP;
function emptyMap() {
  return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
}

function updateMap(map, k, v) {
  var newRoot;
  var newSize;
  if (!map._root) {
    if (v === NOT_SET) {
      return map;
    }
    newSize = 1;
    newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
  } else {
    var didChangeSize = MakeRef();
    var didAlter = MakeRef();
    newRoot = updateNode(
      map._root,
      map.__ownerID,
      0,
      undefined,
      k,
      v,
      didChangeSize,
      didAlter
    );
    if (!didAlter.value) {
      return map;
    }
    newSize = map.size + (didChangeSize.value ? (v === NOT_SET ? -1 : 1) : 0);
  }
  if (map.__ownerID) {
    map.size = newSize;
    map._root = newRoot;
    map.__hash = undefined;
    map.__altered = true;
    return map;
  }
  return newRoot ? makeMap(newSize, newRoot) : emptyMap();
}

function updateNode(
  node,
  ownerID,
  shift,
  keyHash,
  key,
  value,
  didChangeSize,
  didAlter
) {
  if (!node) {
    if (value === NOT_SET) {
      return node;
    }
    SetRef(didAlter);
    SetRef(didChangeSize);
    return new ValueNode(ownerID, keyHash, [key, value]);
  }
  return node.update(
    ownerID,
    shift,
    keyHash,
    key,
    value,
    didChangeSize,
    didAlter
  );
}

function isLeafNode(node) {
  return (
    node.constructor === ValueNode || node.constructor === HashCollisionNode
  );
}

function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
  if (node.keyHash === keyHash) {
    return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
  }

  var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
  var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

  var newNode;
  var nodes =
    idx1 === idx2
      ? [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)]
      : ((newNode = new ValueNode(ownerID, keyHash, entry)),
        idx1 < idx2 ? [node, newNode] : [newNode, node]);

  return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
}

function createNodes(ownerID, entries, key, value) {
  if (!ownerID) {
    ownerID = new OwnerID();
  }
  var node = new ValueNode(ownerID, hash(key), [key, value]);
  for (var ii = 0; ii < entries.length; ii++) {
    var entry = entries[ii];
    node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
  }
  return node;
}

function packNodes(ownerID, nodes, count, excluding) {
  var bitmap = 0;
  var packedII = 0;
  var packedNodes = new Array(count);
  for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
    var node = nodes[ii];
    if (node !== undefined && ii !== excluding) {
      bitmap |= bit;
      packedNodes[packedII++] = node;
    }
  }
  return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
}

function expandNodes(ownerID, nodes, bitmap, including, node) {
  var count = 0;
  var expandedNodes = new Array(SIZE);
  for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
    expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
  }
  expandedNodes[including] = node;
  return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
}

function popCount(x) {
  x -= (x >> 1) & 0x55555555;
  x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
  x = (x + (x >> 4)) & 0x0f0f0f0f;
  x += x >> 8;
  x += x >> 16;
  return x & 0x7f;
}

function setAt(array, idx, val, canEdit) {
  var newArray = canEdit ? array : arrCopy(array);
  newArray[idx] = val;
  return newArray;
}

function spliceIn(array, idx, val, canEdit) {
  var newLen = array.length + 1;
  if (canEdit && idx + 1 === newLen) {
    array[idx] = val;
    return array;
  }
  var newArray = new Array(newLen);
  var after = 0;
  for (var ii = 0; ii < newLen; ii++) {
    if (ii === idx) {
      newArray[ii] = val;
      after = -1;
    } else {
      newArray[ii] = array[ii + after];
    }
  }
  return newArray;
}

function spliceOut(array, idx, canEdit) {
  var newLen = array.length - 1;
  if (canEdit && idx === newLen) {
    array.pop();
    return array;
  }
  var newArray = new Array(newLen);
  var after = 0;
  for (var ii = 0; ii < newLen; ii++) {
    if (ii === idx) {
      after = 1;
    }
    newArray[ii] = array[ii + after];
  }
  return newArray;
}

var MAX_ARRAY_MAP_SIZE = SIZE / 4;
var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

var IS_LIST_SYMBOL = '@@__IMMUTABLE_LIST__@@';

function isList(maybeList) {
  return Boolean(maybeList && maybeList[IS_LIST_SYMBOL]);
}

var List = /*@__PURE__*/(function (IndexedCollection) {
  function List(value) {
    var empty = emptyList();
    if (value === undefined || value === null) {
      // eslint-disable-next-line no-constructor-return
      return empty;
    }
    if (isList(value)) {
      // eslint-disable-next-line no-constructor-return
      return value;
    }
    var iter = IndexedCollection(value);
    var size = iter.size;
    if (size === 0) {
      // eslint-disable-next-line no-constructor-return
      return empty;
    }
    assertNotInfinite(size);
    if (size > 0 && size < SIZE) {
      // eslint-disable-next-line no-constructor-return
      return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
    }
    // eslint-disable-next-line no-constructor-return
    return empty.withMutations(function (list) {
      list.setSize(size);
      iter.forEach(function (v, i) { return list.set(i, v); });
    });
  }

  if ( IndexedCollection ) List.__proto__ = IndexedCollection;
  List.prototype = Object.create( IndexedCollection && IndexedCollection.prototype );
  List.prototype.constructor = List;

  List.of = function of (/*...values*/) {
    return this(arguments);
  };

  List.prototype.toString = function toString () {
    return this.__toString('List [', ']');
  };

  // @pragma Access

  List.prototype.get = function get (index, notSetValue) {
    index = wrapIndex(this, index);
    if (index >= 0 && index < this.size) {
      index += this._origin;
      var node = listNodeFor(this, index);
      return node && node.array[index & MASK];
    }
    return notSetValue;
  };

  // @pragma Modification

  List.prototype.set = function set (index, value) {
    return updateList(this, index, value);
  };

  List.prototype.remove = function remove (index) {
    return !this.has(index)
      ? this
      : index === 0
      ? this.shift()
      : index === this.size - 1
      ? this.pop()
      : this.splice(index, 1);
  };

  List.prototype.insert = function insert (index, value) {
    return this.splice(index, 0, value);
  };

  List.prototype.clear = function clear () {
    if (this.size === 0) {
      return this;
    }
    if (this.__ownerID) {
      this.size = this._origin = this._capacity = 0;
      this._level = SHIFT;
      this._root = this._tail = this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return emptyList();
  };

  List.prototype.push = function push (/*...values*/) {
    var values = arguments;
    var oldSize = this.size;
    return this.withMutations(function (list) {
      setListBounds(list, 0, oldSize + values.length);
      for (var ii = 0; ii < values.length; ii++) {
        list.set(oldSize + ii, values[ii]);
      }
    });
  };

  List.prototype.pop = function pop () {
    return setListBounds(this, 0, -1);
  };

  List.prototype.unshift = function unshift (/*...values*/) {
    var values = arguments;
    return this.withMutations(function (list) {
      setListBounds(list, -values.length);
      for (var ii = 0; ii < values.length; ii++) {
        list.set(ii, values[ii]);
      }
    });
  };

  List.prototype.shift = function shift () {
    return setListBounds(this, 1);
  };

  // @pragma Composition

  List.prototype.concat = function concat (/*...collections*/) {
    var arguments$1 = arguments;

    var seqs = [];
    for (var i = 0; i < arguments.length; i++) {
      var argument = arguments$1[i];
      var seq = IndexedCollection(
        typeof argument !== 'string' && hasIterator(argument)
          ? argument
          : [argument]
      );
      if (seq.size !== 0) {
        seqs.push(seq);
      }
    }
    if (seqs.length === 0) {
      return this;
    }
    if (this.size === 0 && !this.__ownerID && seqs.length === 1) {
      return this.constructor(seqs[0]);
    }
    return this.withMutations(function (list) {
      seqs.forEach(function (seq) { return seq.forEach(function (value) { return list.push(value); }); });
    });
  };

  List.prototype.setSize = function setSize (size) {
    return setListBounds(this, 0, size);
  };

  List.prototype.map = function map (mapper, context) {
    var this$1$1 = this;

    return this.withMutations(function (list) {
      for (var i = 0; i < this$1$1.size; i++) {
        list.set(i, mapper.call(context, list.get(i), i, this$1$1));
      }
    });
  };

  // @pragma Iteration

  List.prototype.slice = function slice (begin, end) {
    var size = this.size;
    if (wholeSlice(begin, end, size)) {
      return this;
    }
    return setListBounds(
      this,
      resolveBegin(begin, size),
      resolveEnd(end, size)
    );
  };

  List.prototype.__iterator = function __iterator (type, reverse) {
    var index = reverse ? this.size : 0;
    var values = iterateList(this, reverse);
    return new Iterator(function () {
      var value = values();
      return value === DONE
        ? iteratorDone()
        : iteratorValue(type, reverse ? --index : index++, value);
    });
  };

  List.prototype.__iterate = function __iterate (fn, reverse) {
    var index = reverse ? this.size : 0;
    var values = iterateList(this, reverse);
    var value;
    while ((value = values()) !== DONE) {
      if (fn(value, reverse ? --index : index++, this) === false) {
        break;
      }
    }
    return index;
  };

  List.prototype.__ensureOwner = function __ensureOwner (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    if (!ownerID) {
      if (this.size === 0) {
        return emptyList();
      }
      this.__ownerID = ownerID;
      this.__altered = false;
      return this;
    }
    return makeList(
      this._origin,
      this._capacity,
      this._level,
      this._root,
      this._tail,
      ownerID,
      this.__hash
    );
  };

  return List;
}(IndexedCollection));

List.isList = isList;

var ListPrototype = List.prototype;
ListPrototype[IS_LIST_SYMBOL] = true;
ListPrototype[DELETE] = ListPrototype.remove;
ListPrototype.merge = ListPrototype.concat;
ListPrototype.setIn = setIn;
ListPrototype.deleteIn = ListPrototype.removeIn = deleteIn;
ListPrototype.update = update;
ListPrototype.updateIn = updateIn;
ListPrototype.mergeIn = mergeIn;
ListPrototype.mergeDeepIn = mergeDeepIn;
ListPrototype.withMutations = withMutations;
ListPrototype.wasAltered = wasAltered;
ListPrototype.asImmutable = asImmutable;
ListPrototype['@@transducer/init'] = ListPrototype.asMutable = asMutable;
ListPrototype['@@transducer/step'] = function (result, arr) {
  return result.push(arr);
};
ListPrototype['@@transducer/result'] = function (obj) {
  return obj.asImmutable();
};

var VNode = function VNode(array, ownerID) {
  this.array = array;
  this.ownerID = ownerID;
};

// TODO: seems like these methods are very similar

VNode.prototype.removeBefore = function removeBefore (ownerID, level, index) {
  if (index === level ? 1 << level : this.array.length === 0) {
    return this;
  }
  var originIndex = (index >>> level) & MASK;
  if (originIndex >= this.array.length) {
    return new VNode([], ownerID);
  }
  var removingFirst = originIndex === 0;
  var newChild;
  if (level > 0) {
    var oldChild = this.array[originIndex];
    newChild =
      oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
    if (newChild === oldChild && removingFirst) {
      return this;
    }
  }
  if (removingFirst && !newChild) {
    return this;
  }
  var editable = editableVNode(this, ownerID);
  if (!removingFirst) {
    for (var ii = 0; ii < originIndex; ii++) {
      editable.array[ii] = undefined;
    }
  }
  if (newChild) {
    editable.array[originIndex] = newChild;
  }
  return editable;
};

VNode.prototype.removeAfter = function removeAfter (ownerID, level, index) {
  if (index === (level ? 1 << level : 0) || this.array.length === 0) {
    return this;
  }
  var sizeIndex = ((index - 1) >>> level) & MASK;
  if (sizeIndex >= this.array.length) {
    return this;
  }

  var newChild;
  if (level > 0) {
    var oldChild = this.array[sizeIndex];
    newChild =
      oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
    if (newChild === oldChild && sizeIndex === this.array.length - 1) {
      return this;
    }
  }

  var editable = editableVNode(this, ownerID);
  editable.array.splice(sizeIndex + 1);
  if (newChild) {
    editable.array[sizeIndex] = newChild;
  }
  return editable;
};

var DONE = {};

function iterateList(list, reverse) {
  var left = list._origin;
  var right = list._capacity;
  var tailPos = getTailOffset(right);
  var tail = list._tail;

  return iterateNodeOrLeaf(list._root, list._level, 0);

  function iterateNodeOrLeaf(node, level, offset) {
    return level === 0
      ? iterateLeaf(node, offset)
      : iterateNode(node, level, offset);
  }

  function iterateLeaf(node, offset) {
    var array = offset === tailPos ? tail && tail.array : node && node.array;
    var from = offset > left ? 0 : left - offset;
    var to = right - offset;
    if (to > SIZE) {
      to = SIZE;
    }
    return function () {
      if (from === to) {
        return DONE;
      }
      var idx = reverse ? --to : from++;
      return array && array[idx];
    };
  }

  function iterateNode(node, level, offset) {
    var values;
    var array = node && node.array;
    var from = offset > left ? 0 : (left - offset) >> level;
    var to = ((right - offset) >> level) + 1;
    if (to > SIZE) {
      to = SIZE;
    }
    return function () {
      while (true) {
        if (values) {
          var value = values();
          if (value !== DONE) {
            return value;
          }
          values = null;
        }
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        values = iterateNodeOrLeaf(
          array && array[idx],
          level - SHIFT,
          offset + (idx << level)
        );
      }
    };
  }
}

function makeList(origin, capacity, level, root, tail, ownerID, hash) {
  var list = Object.create(ListPrototype);
  list.size = capacity - origin;
  list._origin = origin;
  list._capacity = capacity;
  list._level = level;
  list._root = root;
  list._tail = tail;
  list.__ownerID = ownerID;
  list.__hash = hash;
  list.__altered = false;
  return list;
}

var EMPTY_LIST;
function emptyList() {
  return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
}

function updateList(list, index, value) {
  index = wrapIndex(list, index);

  if (index !== index) {
    return list;
  }

  if (index >= list.size || index < 0) {
    return list.withMutations(function (list) {
      index < 0
        ? setListBounds(list, index).set(0, value)
        : setListBounds(list, 0, index + 1).set(index, value);
    });
  }

  index += list._origin;

  var newTail = list._tail;
  var newRoot = list._root;
  var didAlter = MakeRef();
  if (index >= getTailOffset(list._capacity)) {
    newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
  } else {
    newRoot = updateVNode(
      newRoot,
      list.__ownerID,
      list._level,
      index,
      value,
      didAlter
    );
  }

  if (!didAlter.value) {
    return list;
  }

  if (list.__ownerID) {
    list._root = newRoot;
    list._tail = newTail;
    list.__hash = undefined;
    list.__altered = true;
    return list;
  }
  return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
}

function updateVNode(node, ownerID, level, index, value, didAlter) {
  var idx = (index >>> level) & MASK;
  var nodeHas = node && idx < node.array.length;
  if (!nodeHas && value === undefined) {
    return node;
  }

  var newNode;

  if (level > 0) {
    var lowerNode = node && node.array[idx];
    var newLowerNode = updateVNode(
      lowerNode,
      ownerID,
      level - SHIFT,
      index,
      value,
      didAlter
    );
    if (newLowerNode === lowerNode) {
      return node;
    }
    newNode = editableVNode(node, ownerID);
    newNode.array[idx] = newLowerNode;
    return newNode;
  }

  if (nodeHas && node.array[idx] === value) {
    return node;
  }

  if (didAlter) {
    SetRef(didAlter);
  }

  newNode = editableVNode(node, ownerID);
  if (value === undefined && idx === newNode.array.length - 1) {
    newNode.array.pop();
  } else {
    newNode.array[idx] = value;
  }
  return newNode;
}

function editableVNode(node, ownerID) {
  if (ownerID && node && ownerID === node.ownerID) {
    return node;
  }
  return new VNode(node ? node.array.slice() : [], ownerID);
}

function listNodeFor(list, rawIndex) {
  if (rawIndex >= getTailOffset(list._capacity)) {
    return list._tail;
  }
  if (rawIndex < 1 << (list._level + SHIFT)) {
    var node = list._root;
    var level = list._level;
    while (node && level > 0) {
      node = node.array[(rawIndex >>> level) & MASK];
      level -= SHIFT;
    }
    return node;
  }
}

function setListBounds(list, begin, end) {
  // Sanitize begin & end using this shorthand for ToInt32(argument)
  // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
  if (begin !== undefined) {
    begin |= 0;
  }
  if (end !== undefined) {
    end |= 0;
  }
  var owner = list.__ownerID || new OwnerID();
  var oldOrigin = list._origin;
  var oldCapacity = list._capacity;
  var newOrigin = oldOrigin + begin;
  var newCapacity =
    end === undefined
      ? oldCapacity
      : end < 0
      ? oldCapacity + end
      : oldOrigin + end;
  if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
    return list;
  }

  // If it's going to end after it starts, it's empty.
  if (newOrigin >= newCapacity) {
    return list.clear();
  }

  var newLevel = list._level;
  var newRoot = list._root;

  // New origin might need creating a higher root.
  var offsetShift = 0;
  while (newOrigin + offsetShift < 0) {
    newRoot = new VNode(
      newRoot && newRoot.array.length ? [undefined, newRoot] : [],
      owner
    );
    newLevel += SHIFT;
    offsetShift += 1 << newLevel;
  }
  if (offsetShift) {
    newOrigin += offsetShift;
    oldOrigin += offsetShift;
    newCapacity += offsetShift;
    oldCapacity += offsetShift;
  }

  var oldTailOffset = getTailOffset(oldCapacity);
  var newTailOffset = getTailOffset(newCapacity);

  // New size might need creating a higher root.
  while (newTailOffset >= 1 << (newLevel + SHIFT)) {
    newRoot = new VNode(
      newRoot && newRoot.array.length ? [newRoot] : [],
      owner
    );
    newLevel += SHIFT;
  }

  // Locate or create the new tail.
  var oldTail = list._tail;
  var newTail =
    newTailOffset < oldTailOffset
      ? listNodeFor(list, newCapacity - 1)
      : newTailOffset > oldTailOffset
      ? new VNode([], owner)
      : oldTail;

  // Merge Tail into tree.
  if (
    oldTail &&
    newTailOffset > oldTailOffset &&
    newOrigin < oldCapacity &&
    oldTail.array.length
  ) {
    newRoot = editableVNode(newRoot, owner);
    var node = newRoot;
    for (var level = newLevel; level > SHIFT; level -= SHIFT) {
      var idx = (oldTailOffset >>> level) & MASK;
      node = node.array[idx] = editableVNode(node.array[idx], owner);
    }
    node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
  }

  // If the size has been reduced, there's a chance the tail needs to be trimmed.
  if (newCapacity < oldCapacity) {
    newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
  }

  // If the new origin is within the tail, then we do not need a root.
  if (newOrigin >= newTailOffset) {
    newOrigin -= newTailOffset;
    newCapacity -= newTailOffset;
    newLevel = SHIFT;
    newRoot = null;
    newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
  } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
    offsetShift = 0;

    // Identify the new top root node of the subtree of the old root.
    while (newRoot) {
      var beginIndex = (newOrigin >>> newLevel) & MASK;
      if ((beginIndex !== newTailOffset >>> newLevel) & MASK) {
        break;
      }
      if (beginIndex) {
        offsetShift += (1 << newLevel) * beginIndex;
      }
      newLevel -= SHIFT;
      newRoot = newRoot.array[beginIndex];
    }

    // Trim the new sides of the new root.
    if (newRoot && newOrigin > oldOrigin) {
      newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
    }
    if (newRoot && newTailOffset < oldTailOffset) {
      newRoot = newRoot.removeAfter(
        owner,
        newLevel,
        newTailOffset - offsetShift
      );
    }
    if (offsetShift) {
      newOrigin -= offsetShift;
      newCapacity -= offsetShift;
    }
  }

  if (list.__ownerID) {
    list.size = newCapacity - newOrigin;
    list._origin = newOrigin;
    list._capacity = newCapacity;
    list._level = newLevel;
    list._root = newRoot;
    list._tail = newTail;
    list.__hash = undefined;
    list.__altered = true;
    return list;
  }
  return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
}

function getTailOffset(size) {
  return size < SIZE ? 0 : ((size - 1) >>> SHIFT) << SHIFT;
}

var OrderedMap = /*@__PURE__*/(function (Map) {
  function OrderedMap(value) {
    // eslint-disable-next-line no-constructor-return
    return value === undefined || value === null
      ? emptyOrderedMap()
      : isOrderedMap(value)
      ? value
      : emptyOrderedMap().withMutations(function (map) {
          var iter = KeyedCollection(value);
          assertNotInfinite(iter.size);
          iter.forEach(function (v, k) { return map.set(k, v); });
        });
  }

  if ( Map ) OrderedMap.__proto__ = Map;
  OrderedMap.prototype = Object.create( Map && Map.prototype );
  OrderedMap.prototype.constructor = OrderedMap;

  OrderedMap.of = function of (/*...values*/) {
    return this(arguments);
  };

  OrderedMap.prototype.toString = function toString () {
    return this.__toString('OrderedMap {', '}');
  };

  // @pragma Access

  OrderedMap.prototype.get = function get (k, notSetValue) {
    var index = this._map.get(k);
    return index !== undefined ? this._list.get(index)[1] : notSetValue;
  };

  // @pragma Modification

  OrderedMap.prototype.clear = function clear () {
    if (this.size === 0) {
      return this;
    }
    if (this.__ownerID) {
      this.size = 0;
      this._map.clear();
      this._list.clear();
      this.__altered = true;
      return this;
    }
    return emptyOrderedMap();
  };

  OrderedMap.prototype.set = function set (k, v) {
    return updateOrderedMap(this, k, v);
  };

  OrderedMap.prototype.remove = function remove (k) {
    return updateOrderedMap(this, k, NOT_SET);
  };

  OrderedMap.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1$1 = this;

    return this._list.__iterate(
      function (entry) { return entry && fn(entry[1], entry[0], this$1$1); },
      reverse
    );
  };

  OrderedMap.prototype.__iterator = function __iterator (type, reverse) {
    return this._list.fromEntrySeq().__iterator(type, reverse);
  };

  OrderedMap.prototype.__ensureOwner = function __ensureOwner (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    var newMap = this._map.__ensureOwner(ownerID);
    var newList = this._list.__ensureOwner(ownerID);
    if (!ownerID) {
      if (this.size === 0) {
        return emptyOrderedMap();
      }
      this.__ownerID = ownerID;
      this.__altered = false;
      this._map = newMap;
      this._list = newList;
      return this;
    }
    return makeOrderedMap(newMap, newList, ownerID, this.__hash);
  };

  return OrderedMap;
}(Map));

OrderedMap.isOrderedMap = isOrderedMap;

OrderedMap.prototype[IS_ORDERED_SYMBOL] = true;
OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;

function makeOrderedMap(map, list, ownerID, hash) {
  var omap = Object.create(OrderedMap.prototype);
  omap.size = map ? map.size : 0;
  omap._map = map;
  omap._list = list;
  omap.__ownerID = ownerID;
  omap.__hash = hash;
  omap.__altered = false;
  return omap;
}

var EMPTY_ORDERED_MAP;
function emptyOrderedMap() {
  return (
    EMPTY_ORDERED_MAP ||
    (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()))
  );
}

function updateOrderedMap(omap, k, v) {
  var map = omap._map;
  var list = omap._list;
  var i = map.get(k);
  var has = i !== undefined;
  var newMap;
  var newList;
  if (v === NOT_SET) {
    // removed
    if (!has) {
      return omap;
    }
    if (list.size >= SIZE && list.size >= map.size * 2) {
      newList = list.filter(function (entry, idx) { return entry !== undefined && i !== idx; });
      newMap = newList
        .toKeyedSeq()
        .map(function (entry) { return entry[0]; })
        .flip()
        .toMap();
      if (omap.__ownerID) {
        newMap.__ownerID = newList.__ownerID = omap.__ownerID;
      }
    } else {
      newMap = map.remove(k);
      newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
    }
  } else if (has) {
    if (v === list.get(i)[1]) {
      return omap;
    }
    newMap = map;
    newList = list.set(i, [k, v]);
  } else {
    newMap = map.set(k, list.size);
    newList = list.set(list.size, [k, v]);
  }
  if (omap.__ownerID) {
    omap.size = newMap.size;
    omap._map = newMap;
    omap._list = newList;
    omap.__hash = undefined;
    omap.__altered = true;
    return omap;
  }
  return makeOrderedMap(newMap, newList);
}

var IS_STACK_SYMBOL = '@@__IMMUTABLE_STACK__@@';

function isStack(maybeStack) {
  return Boolean(maybeStack && maybeStack[IS_STACK_SYMBOL]);
}

var Stack = /*@__PURE__*/(function (IndexedCollection) {
  function Stack(value) {
    // eslint-disable-next-line no-constructor-return
    return value === undefined || value === null
      ? emptyStack()
      : isStack(value)
      ? value
      : emptyStack().pushAll(value);
  }

  if ( IndexedCollection ) Stack.__proto__ = IndexedCollection;
  Stack.prototype = Object.create( IndexedCollection && IndexedCollection.prototype );
  Stack.prototype.constructor = Stack;

  Stack.of = function of (/*...values*/) {
    return this(arguments);
  };

  Stack.prototype.toString = function toString () {
    return this.__toString('Stack [', ']');
  };

  // @pragma Access

  Stack.prototype.get = function get (index, notSetValue) {
    var head = this._head;
    index = wrapIndex(this, index);
    while (head && index--) {
      head = head.next;
    }
    return head ? head.value : notSetValue;
  };

  Stack.prototype.peek = function peek () {
    return this._head && this._head.value;
  };

  // @pragma Modification

  Stack.prototype.push = function push (/*...values*/) {
    var arguments$1 = arguments;

    if (arguments.length === 0) {
      return this;
    }
    var newSize = this.size + arguments.length;
    var head = this._head;
    for (var ii = arguments.length - 1; ii >= 0; ii--) {
      head = {
        value: arguments$1[ii],
        next: head,
      };
    }
    if (this.__ownerID) {
      this.size = newSize;
      this._head = head;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return makeStack(newSize, head);
  };

  Stack.prototype.pushAll = function pushAll (iter) {
    iter = IndexedCollection(iter);
    if (iter.size === 0) {
      return this;
    }
    if (this.size === 0 && isStack(iter)) {
      return iter;
    }
    assertNotInfinite(iter.size);
    var newSize = this.size;
    var head = this._head;
    iter.__iterate(function (value) {
      newSize++;
      head = {
        value: value,
        next: head,
      };
    }, /* reverse */ true);
    if (this.__ownerID) {
      this.size = newSize;
      this._head = head;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return makeStack(newSize, head);
  };

  Stack.prototype.pop = function pop () {
    return this.slice(1);
  };

  Stack.prototype.clear = function clear () {
    if (this.size === 0) {
      return this;
    }
    if (this.__ownerID) {
      this.size = 0;
      this._head = undefined;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return emptyStack();
  };

  Stack.prototype.slice = function slice (begin, end) {
    if (wholeSlice(begin, end, this.size)) {
      return this;
    }
    var resolvedBegin = resolveBegin(begin, this.size);
    var resolvedEnd = resolveEnd(end, this.size);
    if (resolvedEnd !== this.size) {
      // super.slice(begin, end);
      return IndexedCollection.prototype.slice.call(this, begin, end);
    }
    var newSize = this.size - resolvedBegin;
    var head = this._head;
    while (resolvedBegin--) {
      head = head.next;
    }
    if (this.__ownerID) {
      this.size = newSize;
      this._head = head;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return makeStack(newSize, head);
  };

  // @pragma Mutability

  Stack.prototype.__ensureOwner = function __ensureOwner (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    if (!ownerID) {
      if (this.size === 0) {
        return emptyStack();
      }
      this.__ownerID = ownerID;
      this.__altered = false;
      return this;
    }
    return makeStack(this.size, this._head, ownerID, this.__hash);
  };

  // @pragma Iteration

  Stack.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1$1 = this;

    if (reverse) {
      return new ArraySeq(this.toArray()).__iterate(
        function (v, k) { return fn(v, k, this$1$1); },
        reverse
      );
    }
    var iterations = 0;
    var node = this._head;
    while (node) {
      if (fn(node.value, iterations++, this) === false) {
        break;
      }
      node = node.next;
    }
    return iterations;
  };

  Stack.prototype.__iterator = function __iterator (type, reverse) {
    if (reverse) {
      return new ArraySeq(this.toArray()).__iterator(type, reverse);
    }
    var iterations = 0;
    var node = this._head;
    return new Iterator(function () {
      if (node) {
        var value = node.value;
        node = node.next;
        return iteratorValue(type, iterations++, value);
      }
      return iteratorDone();
    });
  };

  return Stack;
}(IndexedCollection));

Stack.isStack = isStack;

var StackPrototype = Stack.prototype;
StackPrototype[IS_STACK_SYMBOL] = true;
StackPrototype.shift = StackPrototype.pop;
StackPrototype.unshift = StackPrototype.push;
StackPrototype.unshiftAll = StackPrototype.pushAll;
StackPrototype.withMutations = withMutations;
StackPrototype.wasAltered = wasAltered;
StackPrototype.asImmutable = asImmutable;
StackPrototype['@@transducer/init'] = StackPrototype.asMutable = asMutable;
StackPrototype['@@transducer/step'] = function (result, arr) {
  return result.unshift(arr);
};
StackPrototype['@@transducer/result'] = function (obj) {
  return obj.asImmutable();
};

function makeStack(size, head, ownerID, hash) {
  var map = Object.create(StackPrototype);
  map.size = size;
  map._head = head;
  map.__ownerID = ownerID;
  map.__hash = hash;
  map.__altered = false;
  return map;
}

var EMPTY_STACK;
function emptyStack() {
  return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
}

var IS_SET_SYMBOL = '@@__IMMUTABLE_SET__@@';

function isSet(maybeSet) {
  return Boolean(maybeSet && maybeSet[IS_SET_SYMBOL]);
}

function isOrderedSet(maybeOrderedSet) {
  return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
}

function deepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (
    !isCollection(b) ||
    (a.size !== undefined && b.size !== undefined && a.size !== b.size) ||
    (a.__hash !== undefined &&
      b.__hash !== undefined &&
      a.__hash !== b.__hash) ||
    isKeyed(a) !== isKeyed(b) ||
    isIndexed(a) !== isIndexed(b) ||
    isOrdered(a) !== isOrdered(b)
  ) {
    return false;
  }

  if (a.size === 0 && b.size === 0) {
    return true;
  }

  var notAssociative = !isAssociative(a);

  if (isOrdered(a)) {
    var entries = a.entries();
    return (
      b.every(function (v, k) {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done
    );
  }

  var flipped = false;

  if (a.size === undefined) {
    if (b.size === undefined) {
      if (typeof a.cacheResult === 'function') {
        a.cacheResult();
      }
    } else {
      flipped = true;
      var _ = a;
      a = b;
      b = _;
    }
  }

  var allEqual = true;
  var bSize = b.__iterate(function (v, k) {
    if (
      notAssociative
        ? !a.has(v)
        : flipped
        ? !is(v, a.get(k, NOT_SET))
        : !is(a.get(k, NOT_SET), v)
    ) {
      allEqual = false;
      return false;
    }
  });

  return allEqual && a.size === bSize;
}

function mixin(ctor, methods) {
  var keyCopier = function (key) {
    ctor.prototype[key] = methods[key];
  };
  Object.keys(methods).forEach(keyCopier);
  Object.getOwnPropertySymbols &&
    Object.getOwnPropertySymbols(methods).forEach(keyCopier);
  return ctor;
}

function toJS(value) {
  if (!value || typeof value !== 'object') {
    return value;
  }
  if (!isCollection(value)) {
    if (!isDataStructure(value)) {
      return value;
    }
    value = Seq(value);
  }
  if (isKeyed(value)) {
    var result$1 = {};
    value.__iterate(function (v, k) {
      if (isProtoKey(k)) {
        return;
      }

      result$1[k] = toJS(v);
    });
    return result$1;
  }
  var result = [];
  value.__iterate(function (v) {
    result.push(toJS(v));
  });
  return result;
}

var Set = /*@__PURE__*/(function (SetCollection) {
  function Set(value) {
    // eslint-disable-next-line no-constructor-return
    return value === undefined || value === null
      ? emptySet()
      : isSet(value) && !isOrdered(value)
      ? value
      : emptySet().withMutations(function (set) {
          var iter = SetCollection(value);
          assertNotInfinite(iter.size);
          iter.forEach(function (v) { return set.add(v); });
        });
  }

  if ( SetCollection ) Set.__proto__ = SetCollection;
  Set.prototype = Object.create( SetCollection && SetCollection.prototype );
  Set.prototype.constructor = Set;

  Set.of = function of (/*...values*/) {
    return this(arguments);
  };

  Set.fromKeys = function fromKeys (value) {
    return this(KeyedCollection(value).keySeq());
  };

  Set.intersect = function intersect (sets) {
    sets = Collection(sets).toArray();
    return sets.length
      ? SetPrototype.intersect.apply(Set(sets.pop()), sets)
      : emptySet();
  };

  Set.union = function union (sets) {
    sets = Collection(sets).toArray();
    return sets.length
      ? SetPrototype.union.apply(Set(sets.pop()), sets)
      : emptySet();
  };

  Set.prototype.toString = function toString () {
    return this.__toString('Set {', '}');
  };

  // @pragma Access

  Set.prototype.has = function has (value) {
    return this._map.has(value);
  };

  // @pragma Modification

  Set.prototype.add = function add (value) {
    return updateSet(this, this._map.set(value, value));
  };

  Set.prototype.remove = function remove (value) {
    return updateSet(this, this._map.remove(value));
  };

  Set.prototype.clear = function clear () {
    return updateSet(this, this._map.clear());
  };

  // @pragma Composition

  Set.prototype.map = function map (mapper, context) {
    var this$1$1 = this;

    // keep track if the set is altered by the map function
    var didChanges = false;

    var newMap = updateSet(
      this,
      this._map.mapEntries(function (ref) {
        var v = ref[1];

        var mapped = mapper.call(context, v, v, this$1$1);

        if (mapped !== v) {
          didChanges = true;
        }

        return [mapped, mapped];
      }, context)
    );

    return didChanges ? newMap : this;
  };

  Set.prototype.union = function union () {
    var iters = [], len = arguments.length;
    while ( len-- ) iters[ len ] = arguments[ len ];

    iters = iters.filter(function (x) { return x.size !== 0; });
    if (iters.length === 0) {
      return this;
    }
    if (this.size === 0 && !this.__ownerID && iters.length === 1) {
      return this.constructor(iters[0]);
    }
    return this.withMutations(function (set) {
      for (var ii = 0; ii < iters.length; ii++) {
        if (typeof iters[ii] === 'string') {
          set.add(iters[ii]);
        } else {
          SetCollection(iters[ii]).forEach(function (value) { return set.add(value); });
        }
      }
    });
  };

  Set.prototype.intersect = function intersect () {
    var iters = [], len = arguments.length;
    while ( len-- ) iters[ len ] = arguments[ len ];

    if (iters.length === 0) {
      return this;
    }
    iters = iters.map(function (iter) { return SetCollection(iter); });
    var toRemove = [];
    this.forEach(function (value) {
      if (!iters.every(function (iter) { return iter.includes(value); })) {
        toRemove.push(value);
      }
    });
    return this.withMutations(function (set) {
      toRemove.forEach(function (value) {
        set.remove(value);
      });
    });
  };

  Set.prototype.subtract = function subtract () {
    var iters = [], len = arguments.length;
    while ( len-- ) iters[ len ] = arguments[ len ];

    if (iters.length === 0) {
      return this;
    }
    iters = iters.map(function (iter) { return SetCollection(iter); });
    var toRemove = [];
    this.forEach(function (value) {
      if (iters.some(function (iter) { return iter.includes(value); })) {
        toRemove.push(value);
      }
    });
    return this.withMutations(function (set) {
      toRemove.forEach(function (value) {
        set.remove(value);
      });
    });
  };

  Set.prototype.sort = function sort (comparator) {
    // Late binding
    return OrderedSet(sortFactory(this, comparator));
  };

  Set.prototype.sortBy = function sortBy (mapper, comparator) {
    // Late binding
    return OrderedSet(sortFactory(this, comparator, mapper));
  };

  Set.prototype.wasAltered = function wasAltered () {
    return this._map.wasAltered();
  };

  Set.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1$1 = this;

    return this._map.__iterate(function (k) { return fn(k, k, this$1$1); }, reverse);
  };

  Set.prototype.__iterator = function __iterator (type, reverse) {
    return this._map.__iterator(type, reverse);
  };

  Set.prototype.__ensureOwner = function __ensureOwner (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    var newMap = this._map.__ensureOwner(ownerID);
    if (!ownerID) {
      if (this.size === 0) {
        return this.__empty();
      }
      this.__ownerID = ownerID;
      this._map = newMap;
      return this;
    }
    return this.__make(newMap, ownerID);
  };

  return Set;
}(SetCollection));

Set.isSet = isSet;

var SetPrototype = Set.prototype;
SetPrototype[IS_SET_SYMBOL] = true;
SetPrototype[DELETE] = SetPrototype.remove;
SetPrototype.merge = SetPrototype.concat = SetPrototype.union;
SetPrototype.withMutations = withMutations;
SetPrototype.asImmutable = asImmutable;
SetPrototype['@@transducer/init'] = SetPrototype.asMutable = asMutable;
SetPrototype['@@transducer/step'] = function (result, arr) {
  return result.add(arr);
};
SetPrototype['@@transducer/result'] = function (obj) {
  return obj.asImmutable();
};

SetPrototype.__empty = emptySet;
SetPrototype.__make = makeSet;

function updateSet(set, newMap) {
  if (set.__ownerID) {
    set.size = newMap.size;
    set._map = newMap;
    return set;
  }
  return newMap === set._map
    ? set
    : newMap.size === 0
    ? set.__empty()
    : set.__make(newMap);
}

function makeSet(map, ownerID) {
  var set = Object.create(SetPrototype);
  set.size = map ? map.size : 0;
  set._map = map;
  set.__ownerID = ownerID;
  return set;
}

var EMPTY_SET;
function emptySet() {
  return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
}

/**
 * Returns a lazy seq of nums from start (inclusive) to end
 * (exclusive), by step, where start defaults to 0, step to 1, and end to
 * infinity. When start is equal to end, returns empty list.
 */
var Range = /*@__PURE__*/(function (IndexedSeq) {
  function Range(start, end, step) {
    if (!(this instanceof Range)) {
      // eslint-disable-next-line no-constructor-return
      return new Range(start, end, step);
    }
    invariant(step !== 0, 'Cannot step a Range by 0');
    start = start || 0;
    if (end === undefined) {
      end = Infinity;
    }
    step = step === undefined ? 1 : Math.abs(step);
    if (end < start) {
      step = -step;
    }
    this._start = start;
    this._end = end;
    this._step = step;
    this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
    if (this.size === 0) {
      if (EMPTY_RANGE) {
        // eslint-disable-next-line no-constructor-return
        return EMPTY_RANGE;
      }
      EMPTY_RANGE = this;
    }
  }

  if ( IndexedSeq ) Range.__proto__ = IndexedSeq;
  Range.prototype = Object.create( IndexedSeq && IndexedSeq.prototype );
  Range.prototype.constructor = Range;

  Range.prototype.toString = function toString () {
    if (this.size === 0) {
      return 'Range []';
    }
    return (
      'Range [ ' +
      this._start +
      '...' +
      this._end +
      (this._step !== 1 ? ' by ' + this._step : '') +
      ' ]'
    );
  };

  Range.prototype.get = function get (index, notSetValue) {
    return this.has(index)
      ? this._start + wrapIndex(this, index) * this._step
      : notSetValue;
  };

  Range.prototype.includes = function includes (searchValue) {
    var possibleIndex = (searchValue - this._start) / this._step;
    return (
      possibleIndex >= 0 &&
      possibleIndex < this.size &&
      possibleIndex === Math.floor(possibleIndex)
    );
  };

  Range.prototype.slice = function slice (begin, end) {
    if (wholeSlice(begin, end, this.size)) {
      return this;
    }
    begin = resolveBegin(begin, this.size);
    end = resolveEnd(end, this.size);
    if (end <= begin) {
      return new Range(0, 0);
    }
    return new Range(
      this.get(begin, this._end),
      this.get(end, this._end),
      this._step
    );
  };

  Range.prototype.indexOf = function indexOf (searchValue) {
    var offsetValue = searchValue - this._start;
    if (offsetValue % this._step === 0) {
      var index = offsetValue / this._step;
      if (index >= 0 && index < this.size) {
        return index;
      }
    }
    return -1;
  };

  Range.prototype.lastIndexOf = function lastIndexOf (searchValue) {
    return this.indexOf(searchValue);
  };

  Range.prototype.__iterate = function __iterate (fn, reverse) {
    var size = this.size;
    var step = this._step;
    var value = reverse ? this._start + (size - 1) * step : this._start;
    var i = 0;
    while (i !== size) {
      if (fn(value, reverse ? size - ++i : i++, this) === false) {
        break;
      }
      value += reverse ? -step : step;
    }
    return i;
  };

  Range.prototype.__iterator = function __iterator (type, reverse) {
    var size = this.size;
    var step = this._step;
    var value = reverse ? this._start + (size - 1) * step : this._start;
    var i = 0;
    return new Iterator(function () {
      if (i === size) {
        return iteratorDone();
      }
      var v = value;
      value += reverse ? -step : step;
      return iteratorValue(type, reverse ? size - ++i : i++, v);
    });
  };

  Range.prototype.equals = function equals (other) {
    return other instanceof Range
      ? this._start === other._start &&
          this._end === other._end &&
          this._step === other._step
      : deepEqual(this, other);
  };

  return Range;
}(IndexedSeq));

var EMPTY_RANGE;

function getIn$1(collection, searchKeyPath, notSetValue) {
  var keyPath = coerceKeyPath(searchKeyPath);
  var i = 0;
  while (i !== keyPath.length) {
    collection = get(collection, keyPath[i++], NOT_SET);
    if (collection === NOT_SET) {
      return notSetValue;
    }
  }
  return collection;
}

function getIn(searchKeyPath, notSetValue) {
  return getIn$1(this, searchKeyPath, notSetValue);
}

function hasIn$1(collection, keyPath) {
  return getIn$1(collection, keyPath, NOT_SET) !== NOT_SET;
}

function hasIn(searchKeyPath) {
  return hasIn$1(this, searchKeyPath);
}

function toObject() {
  assertNotInfinite(this.size);
  var object = {};
  this.__iterate(function (v, k) {
    if (isProtoKey(k)) {
      return;
    }

    object[k] = v;
  });
  return object;
}

// Note: all of these methods are deprecated.
Collection.isIterable = isCollection;
Collection.isKeyed = isKeyed;
Collection.isIndexed = isIndexed;
Collection.isAssociative = isAssociative;
Collection.isOrdered = isOrdered;

Collection.Iterator = Iterator;

mixin(Collection, {
  // ### Conversion to other types

  toArray: function toArray() {
    assertNotInfinite(this.size);
    var array = new Array(this.size || 0);
    var useTuples = isKeyed(this);
    var i = 0;
    this.__iterate(function (v, k) {
      // Keyed collections produce an array of tuples.
      array[i++] = useTuples ? [k, v] : v;
    });
    return array;
  },

  toIndexedSeq: function toIndexedSeq() {
    return new ToIndexedSequence(this);
  },

  toJS: function toJS$1() {
    return toJS(this);
  },

  toKeyedSeq: function toKeyedSeq() {
    return new ToKeyedSequence(this, true);
  },

  toMap: function toMap() {
    // Use Late Binding here to solve the circular dependency.
    return Map(this.toKeyedSeq());
  },

  toObject: toObject,

  toOrderedMap: function toOrderedMap() {
    // Use Late Binding here to solve the circular dependency.
    return OrderedMap(this.toKeyedSeq());
  },

  toOrderedSet: function toOrderedSet() {
    // Use Late Binding here to solve the circular dependency.
    return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
  },

  toSet: function toSet() {
    // Use Late Binding here to solve the circular dependency.
    return Set(isKeyed(this) ? this.valueSeq() : this);
  },

  toSetSeq: function toSetSeq() {
    return new ToSetSequence(this);
  },

  toSeq: function toSeq() {
    return isIndexed(this)
      ? this.toIndexedSeq()
      : isKeyed(this)
      ? this.toKeyedSeq()
      : this.toSetSeq();
  },

  toStack: function toStack() {
    // Use Late Binding here to solve the circular dependency.
    return Stack(isKeyed(this) ? this.valueSeq() : this);
  },

  toList: function toList() {
    // Use Late Binding here to solve the circular dependency.
    return List(isKeyed(this) ? this.valueSeq() : this);
  },

  // ### Common JavaScript methods and properties

  toString: function toString() {
    return '[Collection]';
  },

  __toString: function __toString(head, tail) {
    if (this.size === 0) {
      return head + tail;
    }
    return (
      head +
      ' ' +
      this.toSeq().map(this.__toStringMapper).join(', ') +
      ' ' +
      tail
    );
  },

  // ### ES6 Collection methods (ES6 Array and Map)

  concat: function concat() {
    var values = [], len = arguments.length;
    while ( len-- ) values[ len ] = arguments[ len ];

    return reify(this, concatFactory(this, values));
  },

  includes: function includes(searchValue) {
    return this.some(function (value) { return is(value, searchValue); });
  },

  entries: function entries() {
    return this.__iterator(ITERATE_ENTRIES);
  },

  every: function every(predicate, context) {
    assertNotInfinite(this.size);
    var returnValue = true;
    this.__iterate(function (v, k, c) {
      if (!predicate.call(context, v, k, c)) {
        returnValue = false;
        return false;
      }
    });
    return returnValue;
  },

  filter: function filter(predicate, context) {
    return reify(this, filterFactory(this, predicate, context, true));
  },

  partition: function partition(predicate, context) {
    return partitionFactory(this, predicate, context);
  },

  find: function find(predicate, context, notSetValue) {
    var entry = this.findEntry(predicate, context);
    return entry ? entry[1] : notSetValue;
  },

  forEach: function forEach(sideEffect, context) {
    assertNotInfinite(this.size);
    return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
  },

  join: function join(separator) {
    assertNotInfinite(this.size);
    separator = separator !== undefined ? '' + separator : ',';
    var joined = '';
    var isFirst = true;
    this.__iterate(function (v) {
      isFirst ? (isFirst = false) : (joined += separator);
      joined += v !== null && v !== undefined ? v.toString() : '';
    });
    return joined;
  },

  keys: function keys() {
    return this.__iterator(ITERATE_KEYS);
  },

  map: function map(mapper, context) {
    return reify(this, mapFactory(this, mapper, context));
  },

  reduce: function reduce$1(reducer, initialReduction, context) {
    return reduce(
      this,
      reducer,
      initialReduction,
      context,
      arguments.length < 2,
      false
    );
  },

  reduceRight: function reduceRight(reducer, initialReduction, context) {
    return reduce(
      this,
      reducer,
      initialReduction,
      context,
      arguments.length < 2,
      true
    );
  },

  reverse: function reverse() {
    return reify(this, reverseFactory(this, true));
  },

  slice: function slice(begin, end) {
    return reify(this, sliceFactory(this, begin, end, true));
  },

  some: function some(predicate, context) {
    assertNotInfinite(this.size);
    var returnValue = false;
    this.__iterate(function (v, k, c) {
      if (predicate.call(context, v, k, c)) {
        returnValue = true;
        return false;
      }
    });
    return returnValue;
  },

  sort: function sort(comparator) {
    return reify(this, sortFactory(this, comparator));
  },

  values: function values() {
    return this.__iterator(ITERATE_VALUES);
  },

  // ### More sequential methods

  butLast: function butLast() {
    return this.slice(0, -1);
  },

  isEmpty: function isEmpty() {
    return this.size !== undefined ? this.size === 0 : !this.some(function () { return true; });
  },

  count: function count(predicate, context) {
    return ensureSize(
      predicate ? this.toSeq().filter(predicate, context) : this
    );
  },

  countBy: function countBy(grouper, context) {
    return countByFactory(this, grouper, context);
  },

  equals: function equals(other) {
    return deepEqual(this, other);
  },

  entrySeq: function entrySeq() {
    var collection = this;
    if (collection._cache) {
      // We cache as an entries array, so we can just return the cache!
      return new ArraySeq(collection._cache);
    }
    var entriesSequence = collection.toSeq().map(entryMapper).toIndexedSeq();
    entriesSequence.fromEntrySeq = function () { return collection.toSeq(); };
    return entriesSequence;
  },

  filterNot: function filterNot(predicate, context) {
    return this.filter(not(predicate), context);
  },

  findEntry: function findEntry(predicate, context, notSetValue) {
    var found = notSetValue;
    this.__iterate(function (v, k, c) {
      if (predicate.call(context, v, k, c)) {
        found = [k, v];
        return false;
      }
    });
    return found;
  },

  findKey: function findKey(predicate, context) {
    var entry = this.findEntry(predicate, context);
    return entry && entry[0];
  },

  findLast: function findLast(predicate, context, notSetValue) {
    return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
  },

  findLastEntry: function findLastEntry(predicate, context, notSetValue) {
    return this.toKeyedSeq()
      .reverse()
      .findEntry(predicate, context, notSetValue);
  },

  findLastKey: function findLastKey(predicate, context) {
    return this.toKeyedSeq().reverse().findKey(predicate, context);
  },

  first: function first(notSetValue) {
    return this.find(returnTrue, null, notSetValue);
  },

  flatMap: function flatMap(mapper, context) {
    return reify(this, flatMapFactory(this, mapper, context));
  },

  flatten: function flatten(depth) {
    return reify(this, flattenFactory(this, depth, true));
  },

  fromEntrySeq: function fromEntrySeq() {
    return new FromEntriesSequence(this);
  },

  get: function get(searchKey, notSetValue) {
    return this.find(function (_, key) { return is(key, searchKey); }, undefined, notSetValue);
  },

  getIn: getIn,

  groupBy: function groupBy(grouper, context) {
    return groupByFactory(this, grouper, context);
  },

  has: function has(searchKey) {
    return this.get(searchKey, NOT_SET) !== NOT_SET;
  },

  hasIn: hasIn,

  isSubset: function isSubset(iter) {
    iter = typeof iter.includes === 'function' ? iter : Collection(iter);
    return this.every(function (value) { return iter.includes(value); });
  },

  isSuperset: function isSuperset(iter) {
    iter = typeof iter.isSubset === 'function' ? iter : Collection(iter);
    return iter.isSubset(this);
  },

  keyOf: function keyOf(searchValue) {
    return this.findKey(function (value) { return is(value, searchValue); });
  },

  keySeq: function keySeq() {
    return this.toSeq().map(keyMapper).toIndexedSeq();
  },

  last: function last(notSetValue) {
    return this.toSeq().reverse().first(notSetValue);
  },

  lastKeyOf: function lastKeyOf(searchValue) {
    return this.toKeyedSeq().reverse().keyOf(searchValue);
  },

  max: function max(comparator) {
    return maxFactory(this, comparator);
  },

  maxBy: function maxBy(mapper, comparator) {
    return maxFactory(this, comparator, mapper);
  },

  min: function min(comparator) {
    return maxFactory(
      this,
      comparator ? neg(comparator) : defaultNegComparator
    );
  },

  minBy: function minBy(mapper, comparator) {
    return maxFactory(
      this,
      comparator ? neg(comparator) : defaultNegComparator,
      mapper
    );
  },

  rest: function rest() {
    return this.slice(1);
  },

  skip: function skip(amount) {
    return amount === 0 ? this : this.slice(Math.max(0, amount));
  },

  skipLast: function skipLast(amount) {
    return amount === 0 ? this : this.slice(0, -Math.max(0, amount));
  },

  skipWhile: function skipWhile(predicate, context) {
    return reify(this, skipWhileFactory(this, predicate, context, true));
  },

  skipUntil: function skipUntil(predicate, context) {
    return this.skipWhile(not(predicate), context);
  },

  sortBy: function sortBy(mapper, comparator) {
    return reify(this, sortFactory(this, comparator, mapper));
  },

  take: function take(amount) {
    return this.slice(0, Math.max(0, amount));
  },

  takeLast: function takeLast(amount) {
    return this.slice(-Math.max(0, amount));
  },

  takeWhile: function takeWhile(predicate, context) {
    return reify(this, takeWhileFactory(this, predicate, context));
  },

  takeUntil: function takeUntil(predicate, context) {
    return this.takeWhile(not(predicate), context);
  },

  update: function update(fn) {
    return fn(this);
  },

  valueSeq: function valueSeq() {
    return this.toIndexedSeq();
  },

  // ### Hashable Object

  hashCode: function hashCode() {
    return this.__hash || (this.__hash = hashCollection(this));
  },

  // ### Internal

  // abstract __iterate(fn, reverse)

  // abstract __iterator(type, reverse)
});

var CollectionPrototype = Collection.prototype;
CollectionPrototype[IS_COLLECTION_SYMBOL] = true;
CollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.values;
CollectionPrototype.toJSON = CollectionPrototype.toArray;
CollectionPrototype.__toStringMapper = quoteString;
CollectionPrototype.inspect = CollectionPrototype.toSource = function () {
  return this.toString();
};
CollectionPrototype.chain = CollectionPrototype.flatMap;
CollectionPrototype.contains = CollectionPrototype.includes;

mixin(KeyedCollection, {
  // ### More sequential methods

  flip: function flip() {
    return reify(this, flipFactory(this));
  },

  mapEntries: function mapEntries(mapper, context) {
    var this$1$1 = this;

    var iterations = 0;
    return reify(
      this,
      this.toSeq()
        .map(function (v, k) { return mapper.call(context, [k, v], iterations++, this$1$1); })
        .fromEntrySeq()
    );
  },

  mapKeys: function mapKeys(mapper, context) {
    var this$1$1 = this;

    return reify(
      this,
      this.toSeq()
        .flip()
        .map(function (k, v) { return mapper.call(context, k, v, this$1$1); })
        .flip()
    );
  },
});

var KeyedCollectionPrototype = KeyedCollection.prototype;
KeyedCollectionPrototype[IS_KEYED_SYMBOL] = true;
KeyedCollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.entries;
KeyedCollectionPrototype.toJSON = toObject;
KeyedCollectionPrototype.__toStringMapper = function (v, k) { return quoteString(k) + ': ' + quoteString(v); };

mixin(IndexedCollection, {
  // ### Conversion to other types

  toKeyedSeq: function toKeyedSeq() {
    return new ToKeyedSequence(this, false);
  },

  // ### ES6 Collection methods (ES6 Array and Map)

  filter: function filter(predicate, context) {
    return reify(this, filterFactory(this, predicate, context, false));
  },

  findIndex: function findIndex(predicate, context) {
    var entry = this.findEntry(predicate, context);
    return entry ? entry[0] : -1;
  },

  indexOf: function indexOf(searchValue) {
    var key = this.keyOf(searchValue);
    return key === undefined ? -1 : key;
  },

  lastIndexOf: function lastIndexOf(searchValue) {
    var key = this.lastKeyOf(searchValue);
    return key === undefined ? -1 : key;
  },

  reverse: function reverse() {
    return reify(this, reverseFactory(this, false));
  },

  slice: function slice(begin, end) {
    return reify(this, sliceFactory(this, begin, end, false));
  },

  splice: function splice(index, removeNum /*, ...values*/) {
    var numArgs = arguments.length;
    removeNum = Math.max(removeNum || 0, 0);
    if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
      return this;
    }
    // If index is negative, it should resolve relative to the size of the
    // collection. However size may be expensive to compute if not cached, so
    // only call count() if the number is in fact negative.
    index = resolveBegin(index, index < 0 ? this.count() : this.size);
    var spliced = this.slice(0, index);
    return reify(
      this,
      numArgs === 1
        ? spliced
        : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
    );
  },

  // ### More collection methods

  findLastIndex: function findLastIndex(predicate, context) {
    var entry = this.findLastEntry(predicate, context);
    return entry ? entry[0] : -1;
  },

  first: function first(notSetValue) {
    return this.get(0, notSetValue);
  },

  flatten: function flatten(depth) {
    return reify(this, flattenFactory(this, depth, false));
  },

  get: function get(index, notSetValue) {
    index = wrapIndex(this, index);
    return index < 0 ||
      this.size === Infinity ||
      (this.size !== undefined && index > this.size)
      ? notSetValue
      : this.find(function (_, key) { return key === index; }, undefined, notSetValue);
  },

  has: function has(index) {
    index = wrapIndex(this, index);
    return (
      index >= 0 &&
      (this.size !== undefined
        ? this.size === Infinity || index < this.size
        : this.indexOf(index) !== -1)
    );
  },

  interpose: function interpose(separator) {
    return reify(this, interposeFactory(this, separator));
  },

  interleave: function interleave(/*...collections*/) {
    var collections = [this].concat(arrCopy(arguments));
    var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, collections);
    var interleaved = zipped.flatten(true);
    if (zipped.size) {
      interleaved.size = zipped.size * collections.length;
    }
    return reify(this, interleaved);
  },

  keySeq: function keySeq() {
    return Range(0, this.size);
  },

  last: function last(notSetValue) {
    return this.get(-1, notSetValue);
  },

  skipWhile: function skipWhile(predicate, context) {
    return reify(this, skipWhileFactory(this, predicate, context, false));
  },

  zip: function zip(/*, ...collections */) {
    var collections = [this].concat(arrCopy(arguments));
    return reify(this, zipWithFactory(this, defaultZipper, collections));
  },

  zipAll: function zipAll(/*, ...collections */) {
    var collections = [this].concat(arrCopy(arguments));
    return reify(this, zipWithFactory(this, defaultZipper, collections, true));
  },

  zipWith: function zipWith(zipper /*, ...collections */) {
    var collections = arrCopy(arguments);
    collections[0] = this;
    return reify(this, zipWithFactory(this, zipper, collections));
  },
});

var IndexedCollectionPrototype = IndexedCollection.prototype;
IndexedCollectionPrototype[IS_INDEXED_SYMBOL] = true;
IndexedCollectionPrototype[IS_ORDERED_SYMBOL] = true;

mixin(SetCollection, {
  // ### ES6 Collection methods (ES6 Array and Map)

  get: function get(value, notSetValue) {
    return this.has(value) ? value : notSetValue;
  },

  includes: function includes(value) {
    return this.has(value);
  },

  // ### More sequential methods

  keySeq: function keySeq() {
    return this.valueSeq();
  },
});

var SetCollectionPrototype = SetCollection.prototype;
SetCollectionPrototype.has = CollectionPrototype.includes;
SetCollectionPrototype.contains = SetCollectionPrototype.includes;
SetCollectionPrototype.keys = SetCollectionPrototype.values;

// Mixin subclasses

mixin(KeyedSeq, KeyedCollectionPrototype);
mixin(IndexedSeq, IndexedCollectionPrototype);
mixin(SetSeq, SetCollectionPrototype);

// #pragma Helper functions

function reduce(collection, reducer, reduction, context, useFirst, reverse) {
  assertNotInfinite(collection.size);
  collection.__iterate(function (v, k, c) {
    if (useFirst) {
      useFirst = false;
      reduction = v;
    } else {
      reduction = reducer.call(context, reduction, v, k, c);
    }
  }, reverse);
  return reduction;
}

function keyMapper(v, k) {
  return k;
}

function entryMapper(v, k) {
  return [k, v];
}

function not(predicate) {
  return function () {
    return !predicate.apply(this, arguments);
  };
}

function neg(predicate) {
  return function () {
    return -predicate.apply(this, arguments);
  };
}

function defaultZipper() {
  return arrCopy(arguments);
}

function defaultNegComparator(a, b) {
  return a < b ? 1 : a > b ? -1 : 0;
}

function hashCollection(collection) {
  if (collection.size === Infinity) {
    return 0;
  }
  var ordered = isOrdered(collection);
  var keyed = isKeyed(collection);
  var h = ordered ? 1 : 0;
  var size = collection.__iterate(
    keyed
      ? ordered
        ? function (v, k) {
            h = (31 * h + hashMerge(hash(v), hash(k))) | 0;
          }
        : function (v, k) {
            h = (h + hashMerge(hash(v), hash(k))) | 0;
          }
      : ordered
      ? function (v) {
          h = (31 * h + hash(v)) | 0;
        }
      : function (v) {
          h = (h + hash(v)) | 0;
        }
  );
  return murmurHashOfSize(size, h);
}

function murmurHashOfSize(size, h) {
  h = imul(h, 0xcc9e2d51);
  h = imul((h << 15) | (h >>> -15), 0x1b873593);
  h = imul((h << 13) | (h >>> -13), 5);
  h = ((h + 0xe6546b64) | 0) ^ size;
  h = imul(h ^ (h >>> 16), 0x85ebca6b);
  h = imul(h ^ (h >>> 13), 0xc2b2ae35);
  h = smi(h ^ (h >>> 16));
  return h;
}

function hashMerge(a, b) {
  return (a ^ (b + 0x9e3779b9 + (a << 6) + (a >> 2))) | 0; // int
}

var OrderedSet = /*@__PURE__*/(function (Set) {
  function OrderedSet(value) {
    // eslint-disable-next-line no-constructor-return
    return value === undefined || value === null
      ? emptyOrderedSet()
      : isOrderedSet(value)
      ? value
      : emptyOrderedSet().withMutations(function (set) {
          var iter = SetCollection(value);
          assertNotInfinite(iter.size);
          iter.forEach(function (v) { return set.add(v); });
        });
  }

  if ( Set ) OrderedSet.__proto__ = Set;
  OrderedSet.prototype = Object.create( Set && Set.prototype );
  OrderedSet.prototype.constructor = OrderedSet;

  OrderedSet.of = function of (/*...values*/) {
    return this(arguments);
  };

  OrderedSet.fromKeys = function fromKeys (value) {
    return this(KeyedCollection(value).keySeq());
  };

  OrderedSet.prototype.toString = function toString () {
    return this.__toString('OrderedSet {', '}');
  };

  return OrderedSet;
}(Set));

OrderedSet.isOrderedSet = isOrderedSet;

var OrderedSetPrototype = OrderedSet.prototype;
OrderedSetPrototype[IS_ORDERED_SYMBOL] = true;
OrderedSetPrototype.zip = IndexedCollectionPrototype.zip;
OrderedSetPrototype.zipWith = IndexedCollectionPrototype.zipWith;
OrderedSetPrototype.zipAll = IndexedCollectionPrototype.zipAll;

OrderedSetPrototype.__empty = emptyOrderedSet;
OrderedSetPrototype.__make = makeOrderedSet;

function makeOrderedSet(map, ownerID) {
  var set = Object.create(OrderedSetPrototype);
  set.size = map ? map.size : 0;
  set._map = map;
  set.__ownerID = ownerID;
  return set;
}

var EMPTY_ORDERED_SET;
function emptyOrderedSet() {
  return (
    EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()))
  );
}

var PairSorting = {
  LeftThenRight: -1,
  RightThenLeft: +1,
};

function throwOnInvalidDefaultValues(defaultValues) {
  if (isRecord(defaultValues)) {
    throw new Error(
      'Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead.'
    );
  }

  if (isImmutable(defaultValues)) {
    throw new Error(
      'Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead.'
    );
  }

  if (defaultValues === null || typeof defaultValues !== 'object') {
    throw new Error(
      'Can not call `Record` with a non-object as default values. Use a plain javascript object instead.'
    );
  }
}

var Record = function Record(defaultValues, name) {
  var hasInitialized;

  throwOnInvalidDefaultValues(defaultValues);

  var RecordType = function Record(values) {
    var this$1$1 = this;

    if (values instanceof RecordType) {
      return values;
    }
    if (!(this instanceof RecordType)) {
      return new RecordType(values);
    }
    if (!hasInitialized) {
      hasInitialized = true;
      var keys = Object.keys(defaultValues);
      var indices = (RecordTypePrototype._indices = {});
      // Deprecated: left to attempt not to break any external code which
      // relies on a ._name property existing on record instances.
      // Use Record.getDescriptiveName() instead
      RecordTypePrototype._name = name;
      RecordTypePrototype._keys = keys;
      RecordTypePrototype._defaultValues = defaultValues;
      for (var i = 0; i < keys.length; i++) {
        var propName = keys[i];
        indices[propName] = i;
        if (RecordTypePrototype[propName]) {
          /* eslint-disable no-console */
          typeof console === 'object' &&
            console.warn &&
            console.warn(
              'Cannot define ' +
                recordName(this) +
                ' with property "' +
                propName +
                '" since that property name is part of the Record API.'
            );
          /* eslint-enable no-console */
        } else {
          setProp(RecordTypePrototype, propName);
        }
      }
    }
    this.__ownerID = undefined;
    this._values = List().withMutations(function (l) {
      l.setSize(this$1$1._keys.length);
      KeyedCollection(values).forEach(function (v, k) {
        l.set(this$1$1._indices[k], v === this$1$1._defaultValues[k] ? undefined : v);
      });
    });
    return this;
  };

  var RecordTypePrototype = (RecordType.prototype =
    Object.create(RecordPrototype));
  RecordTypePrototype.constructor = RecordType;

  if (name) {
    RecordType.displayName = name;
  }

  // eslint-disable-next-line no-constructor-return
  return RecordType;
};

Record.prototype.toString = function toString () {
  var str = recordName(this) + ' { ';
  var keys = this._keys;
  var k;
  for (var i = 0, l = keys.length; i !== l; i++) {
    k = keys[i];
    str += (i ? ', ' : '') + k + ': ' + quoteString(this.get(k));
  }
  return str + ' }';
};

Record.prototype.equals = function equals (other) {
  return (
    this === other ||
    (isRecord(other) && recordSeq(this).equals(recordSeq(other)))
  );
};

Record.prototype.hashCode = function hashCode () {
  return recordSeq(this).hashCode();
};

// @pragma Access

Record.prototype.has = function has (k) {
  return this._indices.hasOwnProperty(k);
};

Record.prototype.get = function get (k, notSetValue) {
  if (!this.has(k)) {
    return notSetValue;
  }
  var index = this._indices[k];
  var value = this._values.get(index);
  return value === undefined ? this._defaultValues[k] : value;
};

// @pragma Modification

Record.prototype.set = function set (k, v) {
  if (this.has(k)) {
    var newValues = this._values.set(
      this._indices[k],
      v === this._defaultValues[k] ? undefined : v
    );
    if (newValues !== this._values && !this.__ownerID) {
      return makeRecord(this, newValues);
    }
  }
  return this;
};

Record.prototype.remove = function remove (k) {
  return this.set(k);
};

Record.prototype.clear = function clear () {
  var newValues = this._values.clear().setSize(this._keys.length);

  return this.__ownerID ? this : makeRecord(this, newValues);
};

Record.prototype.wasAltered = function wasAltered () {
  return this._values.wasAltered();
};

Record.prototype.toSeq = function toSeq () {
  return recordSeq(this);
};

Record.prototype.toJS = function toJS$1 () {
  return toJS(this);
};

Record.prototype.entries = function entries () {
  return this.__iterator(ITERATE_ENTRIES);
};

Record.prototype.__iterator = function __iterator (type, reverse) {
  return recordSeq(this).__iterator(type, reverse);
};

Record.prototype.__iterate = function __iterate (fn, reverse) {
  return recordSeq(this).__iterate(fn, reverse);
};

Record.prototype.__ensureOwner = function __ensureOwner (ownerID) {
  if (ownerID === this.__ownerID) {
    return this;
  }
  var newValues = this._values.__ensureOwner(ownerID);
  if (!ownerID) {
    this.__ownerID = ownerID;
    this._values = newValues;
    return this;
  }
  return makeRecord(this, newValues, ownerID);
};

Record.isRecord = isRecord;
Record.getDescriptiveName = recordName;
var RecordPrototype = Record.prototype;
RecordPrototype[IS_RECORD_SYMBOL] = true;
RecordPrototype[DELETE] = RecordPrototype.remove;
RecordPrototype.deleteIn = RecordPrototype.removeIn = deleteIn;
RecordPrototype.getIn = getIn;
RecordPrototype.hasIn = CollectionPrototype.hasIn;
RecordPrototype.merge = merge$1;
RecordPrototype.mergeWith = mergeWith$1;
RecordPrototype.mergeIn = mergeIn;
RecordPrototype.mergeDeep = mergeDeep;
RecordPrototype.mergeDeepWith = mergeDeepWith;
RecordPrototype.mergeDeepIn = mergeDeepIn;
RecordPrototype.setIn = setIn;
RecordPrototype.update = update;
RecordPrototype.updateIn = updateIn;
RecordPrototype.withMutations = withMutations;
RecordPrototype.asMutable = asMutable;
RecordPrototype.asImmutable = asImmutable;
RecordPrototype[ITERATOR_SYMBOL] = RecordPrototype.entries;
RecordPrototype.toJSON = RecordPrototype.toObject =
  CollectionPrototype.toObject;
RecordPrototype.inspect = RecordPrototype.toSource = function () {
  return this.toString();
};

function makeRecord(likeRecord, values, ownerID) {
  var record = Object.create(Object.getPrototypeOf(likeRecord));
  record._values = values;
  record.__ownerID = ownerID;
  return record;
}

function recordName(record) {
  return record.constructor.displayName || record.constructor.name || 'Record';
}

function recordSeq(record) {
  return keyedSeqFromValue(record._keys.map(function (k) { return [k, record.get(k)]; }));
}

function setProp(prototype, name) {
  try {
    Object.defineProperty(prototype, name, {
      get: function () {
        return this.get(name);
      },
      set: function (value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      },
    });
  } catch (error) {
    // Object.defineProperty failed. Probably IE8.
  }
}

/**
 * Returns a lazy Seq of `value` repeated `times` times. When `times` is
 * undefined, returns an infinite sequence of `value`.
 */
var Repeat = /*@__PURE__*/(function (IndexedSeq) {
  function Repeat(value, times) {
    if (!(this instanceof Repeat)) {
      // eslint-disable-next-line no-constructor-return
      return new Repeat(value, times);
    }
    this._value = value;
    this.size = times === undefined ? Infinity : Math.max(0, times);
    if (this.size === 0) {
      if (EMPTY_REPEAT) {
        // eslint-disable-next-line no-constructor-return
        return EMPTY_REPEAT;
      }
      EMPTY_REPEAT = this;
    }
  }

  if ( IndexedSeq ) Repeat.__proto__ = IndexedSeq;
  Repeat.prototype = Object.create( IndexedSeq && IndexedSeq.prototype );
  Repeat.prototype.constructor = Repeat;

  Repeat.prototype.toString = function toString () {
    if (this.size === 0) {
      return 'Repeat []';
    }
    return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
  };

  Repeat.prototype.get = function get (index, notSetValue) {
    return this.has(index) ? this._value : notSetValue;
  };

  Repeat.prototype.includes = function includes (searchValue) {
    return is(this._value, searchValue);
  };

  Repeat.prototype.slice = function slice (begin, end) {
    var size = this.size;
    return wholeSlice(begin, end, size)
      ? this
      : new Repeat(
          this._value,
          resolveEnd(end, size) - resolveBegin(begin, size)
        );
  };

  Repeat.prototype.reverse = function reverse () {
    return this;
  };

  Repeat.prototype.indexOf = function indexOf (searchValue) {
    if (is(this._value, searchValue)) {
      return 0;
    }
    return -1;
  };

  Repeat.prototype.lastIndexOf = function lastIndexOf (searchValue) {
    if (is(this._value, searchValue)) {
      return this.size;
    }
    return -1;
  };

  Repeat.prototype.__iterate = function __iterate (fn, reverse) {
    var size = this.size;
    var i = 0;
    while (i !== size) {
      if (fn(this._value, reverse ? size - ++i : i++, this) === false) {
        break;
      }
    }
    return i;
  };

  Repeat.prototype.__iterator = function __iterator (type, reverse) {
    var this$1$1 = this;

    var size = this.size;
    var i = 0;
    return new Iterator(function () { return i === size
        ? iteratorDone()
        : iteratorValue(type, reverse ? size - ++i : i++, this$1$1._value); }
    );
  };

  Repeat.prototype.equals = function equals (other) {
    return other instanceof Repeat
      ? is(this._value, other._value)
      : deepEqual(this, other);
  };

  return Repeat;
}(IndexedSeq));

var EMPTY_REPEAT;

function fromJS(value, converter) {
  return fromJSWith(
    [],
    converter || defaultConverter,
    value,
    '',
    converter && converter.length > 2 ? [] : undefined,
    { '': value }
  );
}

function fromJSWith(stack, converter, value, key, keyPath, parentValue) {
  if (
    typeof value !== 'string' &&
    !isImmutable(value) &&
    (isArrayLike(value) || hasIterator(value) || isPlainObject(value))
  ) {
    if (~stack.indexOf(value)) {
      throw new TypeError('Cannot convert circular structure to Immutable');
    }
    stack.push(value);
    keyPath && key !== '' && keyPath.push(key);
    var converted = converter.call(
      parentValue,
      key,
      Seq(value).map(function (v, k) { return fromJSWith(stack, converter, v, k, keyPath, value); }
      ),
      keyPath && keyPath.slice()
    );
    stack.pop();
    keyPath && keyPath.pop();
    return converted;
  }
  return value;
}

function defaultConverter(k, v) {
  // Effectively the opposite of "Collection.toSeq()"
  return isIndexed(v) ? v.toList() : isKeyed(v) ? v.toMap() : v.toSet();
}

var version = "4.3.8";

var Immutable = {
  version: version,

  Collection: Collection,
  // Note: Iterable is deprecated
  Iterable: Collection,

  Seq: Seq,
  Map: Map,
  OrderedMap: OrderedMap,
  List: List,
  Stack: Stack,
  Set: Set,
  OrderedSet: OrderedSet,
  PairSorting: PairSorting,

  Record: Record,
  Range: Range,
  Repeat: Repeat,

  is: is,
  fromJS: fromJS,
  hash: hash,

  isImmutable: isImmutable,
  isCollection: isCollection,
  isKeyed: isKeyed,
  isIndexed: isIndexed,
  isAssociative: isAssociative,
  isOrdered: isOrdered,
  isValueObject: isValueObject,
  isPlainObject: isPlainObject,
  isSeq: isSeq,
  isList: isList,
  isMap: isMap,
  isOrderedMap: isOrderedMap,
  isStack: isStack,
  isSet: isSet,
  isOrderedSet: isOrderedSet,
  isRecord: isRecord,

  get: get,
  getIn: getIn$1,
  has: has,
  hasIn: hasIn$1,
  merge: merge,
  mergeDeep: mergeDeep$1,
  mergeWith: mergeWith,
  mergeDeepWith: mergeDeepWith$1,
  remove: remove,
  removeIn: removeIn,
  set: set,
  setIn: setIn$1,
  update: update$1,
  updateIn: updateIn$1,
};

// Note: Iterable is deprecated
var Iterable = Collection;

/* unused harmony default export */ var _unused_webpack_default_export = (Immutable);



/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Lozenge__ = __webpack_require__(1914);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__Lozenge__["a"]; });


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export tableToolbarColor */
/* unused harmony export tableBorderColor */
/* unused harmony export tableFloatingControlsColor */
/* unused harmony export tableCellSelectedColor */
/* unused harmony export tableToolbarSelectedColor */
/* unused harmony export tableBorderSelectedColor */
/* unused harmony export tableCellDeleteColor */
/* unused harmony export tableBorderDeleteColor */
/* unused harmony export tableToolbarDeleteColor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return tableToolbarSize; });
/* unused harmony export tableBorderRadiusSize */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return tableInsertColumnButtonSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return tableDeleteButtonSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return contextualMenuTriggerSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return contextualMenuDropdownWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return layoutButtonSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return tableStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return tableFullPageEditorStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return tableCommentEditorStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return tablePopupStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_styles__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(44);

// @ts-ignore: unused variable





var N40A = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N40A, B100 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B100, B300 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B300, N300 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N300, B75 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B75, N20 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N20, N50 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N50, R50 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R50, R300 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R300, R75 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R75, N20A = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N20A, N60A = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N60A, N30 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30, N90 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N90, N200 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N200, N0 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N0, R500 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R500;
var tableToolbarColor = N20;
var tableBorderColor = N50;
var tableFloatingControlsColor = N20;
var tableCellSelectedColor = B75;
var tableToolbarSelectedColor = B100;
var tableBorderSelectedColor = B300;
var tableCellDeleteColor = R50;
var tableBorderDeleteColor = R300;
var tableToolbarDeleteColor = R75;
var tableToolbarSize = __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["x" /* akEditorTableToolbarSize */];
var tableBorderRadiusSize = 3;
var tableInsertColumnButtonSize = 20;
var tableDeleteButtonSize = 16;
var contextualMenuTriggerSize = 16;
var contextualMenuDropdownWidth = 180;
var layoutButtonSize = 32;
var isIE11 = __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["E" /* browser */].ie_version === 11;
var InsertLine = function (css) { return "\n  ." + __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_INSERT_LINE + " {\n    background: " + tableBorderSelectedColor + ";\n    display: none;\n    position: absolute;\n    z-index: " + __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["y" /* akEditorUnitZIndex */] + ";\n    " + css + "\n  }\n"; };
var InsertMarker = function (css) { return "\n  ." + __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_INSERT_MARKER + " {\n    background-color: " + tableBorderColor + ";\n    position: absolute;\n    height: 4px;\n    width: 4px;\n    border-radius: 50%;\n    pointer-events: none;\n    " + css + "\n  }\n"; };
var Button = function (css) { return "\n  border-radius: " + Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])() + "px;\n  border-width: 0px;\n  display: inline-flex;\n  max-width: 100%;\n  text-align: center;\n  margin: 0px;\n  padding: 0px;\n  text-decoration: none;\n  transition: background 0.1s ease-out 0s, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;\n  outline: none !important;\n  cursor: none;\n\n  > ." + __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_BUTTON_ICON + " {\n    display: inline-flex;\n    max-height: 100%;\n    max-width: 100%;\n  }\n  " + css + "\n"; };
var HeaderButton = function (css) { return "\n  ." + __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_BUTTON + " {\n    background: " + tableToolbarColor + ";\n    border-top: 1px solid " + tableBorderColor + ";\n    border-left: 1px solid " + tableBorderColor + ";\n    display: block;\n    box-sizing: border-box;\n    padding: 0;\n\n    :focus {\n      outline: none;\n    }\n    " + css + "\n  }\n  .active ." + __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_BUTTON + " {\n    color: " + N0 + ";\n    background-color: " + tableToolbarSelectedColor + ";\n    border-color: " + tableBorderSelectedColor + ";\n  }\n"; };
var HeaderButtonHover = function () { return "\n  ." + __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_BUTTON + ":hover {\n    color: " + N0 + ";\n    background-color: " + tableToolbarSelectedColor + ";\n    border-color: " + tableBorderSelectedColor + ";\n    cursor: pointer;\n  }\n"; };
var HeaderButtonDanger = function () { return "\n  .danger ." + __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_BUTTON + " {\n    background-color: " + tableToolbarDeleteColor + ";\n    border-color: " + tableBorderDeleteColor + ";\n    position: relative;\n    z-index: " + __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["y" /* akEditorUnitZIndex */] + ";\n  }\n"; };
var InsertButton = function () { return "\n  ." + __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_INSERT_BUTTON_INNER + " {\n    position: absolute;\n    z-index: " + __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["y" /* akEditorUnitZIndex */] + ";\n  }\n  ." + __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_INSERT_BUTTON_INNER + ",\n  ." + __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_INSERT_BUTTON + " {\n    height: " + tableInsertColumnButtonSize + "px;\n    width: " + tableInsertColumnButtonSize + "px;\n  }\n  ." + __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_INSERT_BUTTON + " {\n    " + Button("\n      background: white;\n      box-shadow: 0 4px 8px -2px " + N60A + ", 0 0 1px " + N60A + ";\n      color: " + N300 + ";\n    ") + "\n  }\n  ." + __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_INSERT_LINE + " {\n    display: none;\n  }\n"; };
var InsertButtonHover = function () { return "\n  ." + __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_INSERT_BUTTON + ":hover {\n    background: " + B300 + ";\n    color: white;\n    cursor: pointer;\n  }\n"; };
var DeleteButton = function (css) { return "\n  ." + __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_DELETE_BUTTON_WRAP + ",\n  ." + __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_DELETE_BUTTON + " {\n    height: " + tableDeleteButtonSize + "px;\n    width: " + tableDeleteButtonSize + "px;\n  }\n  ." + __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_DELETE_BUTTON_WRAP + " {\n    position: absolute;\n    " + css + "\n\n    ." + __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_DELETE_BUTTON + " {\n      " + Button("\n        background: " + N20A + ";\n        color: " + N300 + ";\n      ") + "\n    }\n  }\n"; };
var DeleteButtonHover = function () { return "\n  ." + __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_DELETE_BUTTON + ":hover {\n    background: " + R300 + ";\n    color: white;\n    cursor: pointer;\n  }\n"; };
var tableStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .", " button {\n    background: ", ";\n    color: ", ";\n    cursor: none;\n  }\n\n  .", ":not(.", ") button:hover {\n    background: ", ";\n    color: white !important;\n    cursor: pointer;\n  }\n\n  .ProseMirror {\n    ", "\n\n    .less-padding {\n      padding: 0 8px;\n\n      .", " {\n         padding: 0 8px;\n      }\n    }\n\n    /* Breakout only works on top level */\n    > .", " .", "[data-layout='full-width'],\n    > .", " .", "[data-layout='wide'] {\n      margin-left: 50%;\n      transform: translateX(-50%);\n    }\n    > * .", " .", " {\n      width: 100% !important;\n    }\n\n    /* Column controls */\n    .", " {\n      height: ", "px;\n      box-sizing: border-box;\n      display: none;\n\n      .", " {\n        display: flex;\n      }\n      .", " {\n        position: relative;\n        margin-right: -1px;\n      }\n      .", ":last-child > button {\n        border-top-right-radius: ", "px;\n      }\n      .", ".active .", ",\n      .", ":hover {\n        z-index: ", ";\n        position: relative;\n      }\n      ", "\n    }\n    :not(.", ") .", " {\n      ", "\n      ", "\n    }\n    .", ",\n    .", " {\n      ", "\n      .", " {\n        position: absolute;\n        height: ", "px;\n        width: ", "px;\n        z-index: ", ";\n        &:hover .", " {\n          display: flex;\n        }\n      }\n      .", " {\n        top: -", "px;\n        right: -", "px;\n      }\n      .", " {\n        top: 2px;\n        left: -", "px;\n      }\n    }\n    :not(.", ") .", ", \n    :not(.", ") .", " {\n      ", "\n    }\n    .", ",\n    .", " {\n      ", "\n      ", "\n    }\n    :not(.", ") .", " {\n      ", "\n      ", "\n    }\n    .", ",\n    .", " {\n      ", "\n      ", "\n    }\n    :not(.", ") .", " {\n      ", "\n      ", "\n    }\n\n    /* Corner controls */\n    .", " {\n      width: ", "px;\n      height: ", "px;\n      display: none;\n    }\n    .", " {\n      position: absolute;\n      top: 0;\n      width: ", "px;\n      height: ", "px;\n      border: 1px solid ", ";\n      border-radius: 0;\n      border-top-left-radius: ", "px;\n      background: ", ";\n      box-sizing: border-box;\n      padding: 0;\n      :focus {\n        outline: none;\n      }\n    }\n    .active .", " {\n      border-color: ", ";\n      background: ", ";\n    }\n    .", "[data-number-column='true'] {\n      .", ",\n      .", " {\n        width: ", "px;\n      }\n      .", " .", " {\n        border-right-width: 0;\n      }\n    }\n    :not(.", ") .", ":hover {\n      border-color: ", ";\n      background: ", ";\n      cursor: pointer;\n    }\n    :not(.", ") .", ".danger {\n      border-color: ", ";\n      background: ", ";\n    }\n\n    /* Row controls */\n    .", " {\n      width: ", "px;\n      box-sizing: border-box;\n      display: none;\n      position: relative;\n\n      .", " {\n        display: flex;\n        flex-direction: column;\n      }\n      .", ":last-child > button {\n        border-bottom-left-radius: ", "px;\n      }\n      .", " {\n        position: relative;\n        margin-top: -1px;\n      }\n      .", ".active .", ",\n      .", ":hover {\n        z-index: ", ";\n        position: relative;\n      }\n      .", " {\n        position: absolute;\n        bottom: -", "px;\n        left: -", "px;\n        height: ", "px;\n        width: ", "px;\n        z-index: ", ";\n        &:hover .", " {\n          display: flex;\n        }\n      }\n      ", "\n      ", "\n    }\n    :not(.", ") .", " {\n      ", "\n      ", "\n      ", "\n    }\n\n    /* Numbered column */\n    .", " {\n      position: relative;\n      float: right;\n      margin-left: ", "px;\n      top: ", "px;\n      width: ", "px;\n      box-sizing: border-box;\n      border-left: 1px solid ", ";\n    }\n    .", " {\n      border-top: 1px solid ", ";\n      border-right: 1px solid ", ";\n      box-sizing: border-box;\n      margin-top: -1px;\n      padding: 10px 2px;\n      text-align: center;\n      font-size: ", "px;\n      background-color: ", ";\n      color: ", ";\n      border-color: ", ";\n\n      :first-child {\n        margin-top: 0;\n      }\n      :last-child {\n        border-bottom: 1px solid ", ";\n      }\n    }\n    .", " {\n      .", ",\n      .", ",\n      .", " {\n        display: block;\n      }\n      .", " {\n        border-left: 0 none;\n        padding-left: 1px;\n\n        .", ".active {\n          border-bottom: 1px solid ", ";\n          border-color: ", ";\n          background-color: ", ";\n          position: relative;\n          z-index: ", ";\n          color: ", ";\n        }\n      }\n  \n      /* scroll shadows */\n      .", ",\n      .", "::after {\n        display: block;\n        position: absolute;\n        pointer-events: none;\n        z-index: ", ";\n        width: 8px;\n      }\n      .", "::after {\n        background: linear-gradient(\n          to left,\n          rgba(99, 114, 130, 0) 0,\n          ", " 100%\n        );\n        content: '';\n        height: 100%;\n        right: -8px;\n        bottom: 0;\n      }\n      .", " {\n        background: linear-gradient(\n          to right,\n          rgba(99, 114, 130, 0) 0,\n          ", " 100%\n        );\n        height: calc(100% - ", "px);\n        left: calc(100% + 2px);\n        top: ", "px;\n      }\n    }\n    :not(.", ") .", " {\n      .", " {\n        cursor: pointer;\n      }\n      .", ":hover {\n        border-bottom: 1px solid ", ";\n        border-color: ", ";\n        background-color: ", ";\n        position: relative;\n        z-index: ", ";\n        color: ", ";\n      }\n      .", ".danger {\n        background-color: ", ";\n        border: 1px solid ", ";\n        color: ", ";\n        position: relative;\n        z-index: ", ";\n      }\n    }\n\n    /* Table */\n    .", " > table {\n      table-layout: fixed;\n\n      td,\n      th {\n        position: relative;\n      }\n\n      .", " {\n        position: relative;\n        border: 1px solid ", ";\n      }\n      /* Give selected cells a blue overlay */\n      .", "::after {\n        z-index: ", ";\n        position: absolute;\n        content: '';\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        background: ", ";\n        opacity: 0.3;\n        pointer-events: none;\n      }\n    }\n    :not(.", ") .", " > table { \n      .", " {\n        position: relative;\n        border: 1px solid ", ";\n      }\n      .", ".danger,\n      .", ".danger {\n        border: 1px solid ", ";\n      }\n      .", ".danger::after {\n        background: ", ";\n      }\n    }\n    .", ",\n    .", " {\n      position: absolute;\n      top: ", "px;\n    }\n    .", ".", " {\n      z-index: ", ";\n    }\n    .", " {\n      left: 0;\n    }\n    .", " {\n      left: -", "px;\n    }\n    .", " {\n      padding-right: ", "px;\n      margin-right: -", "px;\n      padding-top: ", "px;\n      margin-top: -", "px;\n      z-index: ", ";\n      /* fixes gap cursor height */\n      overflow: ", ";\n      position: relative;\n    }\n    .", " {\n      bottom: 0;\n      top: -1px;\n      right: -2px;\n      width: 2px;\n      height: calc(100% + 2px);\n    }\n  }\n\n  /* =============== TABLE COLUMN RESIZING ================== */\n  .ProseMirror.", " {\n    .", " {\n      overflow-x: ", ";\n      ", ";\n    }\n    .", " {\n      background-color: ", ";\n      position: absolute;\n      bottom: 0;\n      top: -1px;\n      right: -2px;\n      width: 2px;\n      height: calc(100% + 2px);\n      pointer-events: none;\n      z-index: ", ";\n    }\n    .", " .", " {\n      top: -", "px;\n      height: calc(100% + ", "px);\n    }\n  }\n\n  .ProseMirror.", " {\n    cursor: col-resize;\n  }\n\n  /* =============== TABLE CONTEXTUAL MENU ================== */\n  .", " {\n    position: absolute;\n    right: 2px;\n    top: 2px;\n\n    > div {\n      background: ", ";\n      border-radius: ", "px;\n      border: 2px solid ", ";\n      display: flex;\n      height: ", "px;\n      flex-direction: column;\n    }\n    button {\n      flex-direction: column;\n      padding: 0;\n    }\n  }\n"], ["\n  .", " button {\n    background: ", ";\n    color: ", ";\n    cursor: none;\n  }\n\n  .", ":not(.", ") button:hover {\n    background: ", ";\n    color: white !important;\n    cursor: pointer;\n  }\n\n  .ProseMirror {\n    ", "\n\n    .less-padding {\n      padding: 0 8px;\n\n      .", " {\n         padding: 0 8px;\n      }\n    }\n\n    /* Breakout only works on top level */\n    > .", " .", "[data-layout='full-width'],\n    > .", " .", "[data-layout='wide'] {\n      margin-left: 50%;\n      transform: translateX(-50%);\n    }\n    > * .", " .", " {\n      width: 100% !important;\n    }\n\n    /* Column controls */\n    .", " {\n      height: ", "px;\n      box-sizing: border-box;\n      display: none;\n\n      .", " {\n        display: flex;\n      }\n      .", " {\n        position: relative;\n        margin-right: -1px;\n      }\n      .", ":last-child > button {\n        border-top-right-radius: ", "px;\n      }\n      .", ".active .", ",\n      .", ":hover {\n        z-index: ", ";\n        position: relative;\n      }\n      ",
    "\n    }\n    :not(.", ") .", " {\n      ", "\n      ", "\n    }\n    .", ",\n    .", " {\n      ",
    "\n      .", " {\n        position: absolute;\n        height: ", "px;\n        width: ", "px;\n        z-index: ", ";\n        &:hover .", " {\n          display: flex;\n        }\n      }\n      .", " {\n        top: -", "px;\n        right: -", "px;\n      }\n      .", " {\n        top: 2px;\n        left: -", "px;\n      }\n    }\n    :not(.", ") .", ", \n    :not(.", ") .", " {\n      ", "\n    }\n    .", ",\n    .", " {\n      ", "\n      ",
    "\n    }\n    :not(.", ") .", " {\n      ", "\n      ",
    "\n    }\n    .", ",\n    .", " {\n      ", "\n      ",
    "\n    }\n    :not(.", ") .", " {\n      ", "\n      ",
    "\n    }\n\n    /* Corner controls */\n    .", " {\n      width: ", "px;\n      height: ", "px;\n      display: none;\n    }\n    .", " {\n      position: absolute;\n      top: 0;\n      width: ", "px;\n      height: ", "px;\n      border: 1px solid ", ";\n      border-radius: 0;\n      border-top-left-radius: ", "px;\n      background: ", ";\n      box-sizing: border-box;\n      padding: 0;\n      :focus {\n        outline: none;\n      }\n    }\n    .active .", " {\n      border-color: ", ";\n      background: ", ";\n    }\n    .", "[data-number-column='true'] {\n      .", ",\n      .", " {\n        width: ", "px;\n      }\n      .", " .", " {\n        border-right-width: 0;\n      }\n    }\n    :not(.", ") .", ":hover {\n      border-color: ", ";\n      background: ", ";\n      cursor: pointer;\n    }\n    :not(.", ") .", ".danger {\n      border-color: ", ";\n      background: ", ";\n    }\n\n    /* Row controls */\n    .", " {\n      width: ", "px;\n      box-sizing: border-box;\n      display: none;\n      position: relative;\n\n      .", " {\n        display: flex;\n        flex-direction: column;\n      }\n      .", ":last-child > button {\n        border-bottom-left-radius: ", "px;\n      }\n      .", " {\n        position: relative;\n        margin-top: -1px;\n      }\n      .", ".active .", ",\n      .", ":hover {\n        z-index: ", ";\n        position: relative;\n      }\n      .", " {\n        position: absolute;\n        bottom: -", "px;\n        left: -", "px;\n        height: ", "px;\n        width: ", "px;\n        z-index: ", ";\n        &:hover .", " {\n          display: flex;\n        }\n      }\n      ",
    "\n      ",
    "\n    }\n    :not(.", ") .", " {\n      ", "\n      ", "\n      ", "\n    }\n\n    /* Numbered column */\n    .", " {\n      position: relative;\n      float: right;\n      margin-left: ", "px;\n      top: ", "px;\n      width: ", "px;\n      box-sizing: border-box;\n      border-left: 1px solid ", ";\n    }\n    .", " {\n      border-top: 1px solid ", ";\n      border-right: 1px solid ", ";\n      box-sizing: border-box;\n      margin-top: -1px;\n      padding: 10px 2px;\n      text-align: center;\n      font-size: ", "px;\n      background-color: ", ";\n      color: ", ";\n      border-color: ", ";\n\n      :first-child {\n        margin-top: 0;\n      }\n      :last-child {\n        border-bottom: 1px solid ", ";\n      }\n    }\n    .", " {\n      .", ",\n      .", ",\n      .", " {\n        display: block;\n      }\n      .", " {\n        border-left: 0 none;\n        padding-left: 1px;\n\n        .", ".active {\n          border-bottom: 1px solid ", ";\n          border-color: ", ";\n          background-color: ", ";\n          position: relative;\n          z-index: ", ";\n          color: ", ";\n        }\n      }\n  \n      /* scroll shadows */\n      .", ",\n      .", "::after {\n        display: block;\n        position: absolute;\n        pointer-events: none;\n        z-index: ", ";\n        width: 8px;\n      }\n      .", "::after {\n        background: linear-gradient(\n          to left,\n          rgba(99, 114, 130, 0) 0,\n          ", " 100%\n        );\n        content: '';\n        height: 100%;\n        right: -8px;\n        bottom: 0;\n      }\n      .", " {\n        background: linear-gradient(\n          to right,\n          rgba(99, 114, 130, 0) 0,\n          ", " 100%\n        );\n        height: calc(100% - ", "px);\n        left: calc(100% + 2px);\n        top: ", "px;\n      }\n    }\n    :not(.", ") .", " {\n      .", " {\n        cursor: pointer;\n      }\n      .", ":hover {\n        border-bottom: 1px solid ", ";\n        border-color: ", ";\n        background-color: ", ";\n        position: relative;\n        z-index: ", ";\n        color: ", ";\n      }\n      .", ".danger {\n        background-color: ", ";\n        border: 1px solid ", ";\n        color: ", ";\n        position: relative;\n        z-index: ", ";\n      }\n    }\n\n    /* Table */\n    .", " > table {\n      table-layout: fixed;\n\n      td,\n      th {\n        position: relative;\n      }\n\n      .", " {\n        position: relative;\n        border: 1px solid ", ";\n      }\n      /* Give selected cells a blue overlay */\n      .", "::after {\n        z-index: ", ";\n        position: absolute;\n        content: '';\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        background: ", ";\n        opacity: 0.3;\n        pointer-events: none;\n      }\n    }\n    :not(.", ") .", " > table { \n      .", " {\n        position: relative;\n        border: 1px solid ", ";\n      }\n      .", ".danger,\n      .", ".danger {\n        border: 1px solid ", ";\n      }\n      .", ".danger::after {\n        background: ", ";\n      }\n    }\n    .", ",\n    .", " {\n      position: absolute;\n      top: ", "px;\n    }\n    .", ".", " {\n      z-index: ", ";\n    }\n    .", " {\n      left: 0;\n    }\n    .", " {\n      left: -", "px;\n    }\n    .", " {\n      padding-right: ", "px;\n      margin-right: -", "px;\n      padding-top: ", "px;\n      margin-top: -", "px;\n      z-index: ", ";\n      /* fixes gap cursor height */\n      overflow: ", ";\n      position: relative;\n    }\n    .", " {\n      bottom: 0;\n      top: -1px;\n      right: -2px;\n      width: 2px;\n      height: calc(100% + 2px);\n    }\n  }\n\n  /* =============== TABLE COLUMN RESIZING ================== */\n  .ProseMirror.", " {\n    .", " {\n      overflow-x: ", ";\n      ", ";\n    }\n    .", " {\n      background-color: ", ";\n      position: absolute;\n      bottom: 0;\n      top: -1px;\n      right: -2px;\n      width: 2px;\n      height: calc(100% + 2px);\n      pointer-events: none;\n      z-index: ", ";\n    }\n    .", " .", " {\n      top: -", "px;\n      height: calc(100% + ", "px);\n    }\n  }\n\n  .ProseMirror.", " {\n    cursor: col-resize;\n  }\n\n  /* =============== TABLE CONTEXTUAL MENU ================== */\n  .", " {\n    position: absolute;\n    right: 2px;\n    top: 2px;\n\n    > div {\n      background: ", ";\n      border-radius: ", "px;\n      border: 2px solid ", ";\n      display: flex;\n      height: ", "px;\n      flex-direction: column;\n    }\n    button {\n      flex-direction: column;\n      padding: 0;\n    }\n  }\n"])), __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].LAYOUT_BUTTON, N20A, N300, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].LAYOUT_BUTTON, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].IS_RESIZING, B300, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["_2" /* tableSharedStyle */], __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].ROW_CONTROLS_WRAPPER, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].NODEVIEW_WRAPPER, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].TABLE_CONTAINER, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].NODEVIEW_WRAPPER, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].TABLE_CONTAINER, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].NODEVIEW_WRAPPER, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].TABLE_CONTAINER, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].COLUMN_CONTROLS, tableToolbarSize, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].COLUMN_CONTROLS_INNER, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].COLUMN_CONTROLS_BUTTON_WRAP, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].COLUMN_CONTROLS_BUTTON_WRAP, tableBorderRadiusSize, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].COLUMN_CONTROLS_BUTTON_WRAP, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_BUTTON, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_BUTTON, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["y" /* akEditorUnitZIndex */], HeaderButton("\n        border-right: 1px solid " + tableBorderColor + ";\n        border-bottom: none;\n        height: " + tableToolbarSize + "px;\n        width: 100%;\n\n        ." + __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_BUTTON_OVERLAY + " {\n          position: absolute;\n          width: 50%;\n          height: 30px;\n          bottom: 0;\n          right: 0;\n        }\n        ." + __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_BUTTON_OVERLAY + ":first-child {\n          left: 0;\n        }\n      "), __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].IS_RESIZING, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].COLUMN_CONTROLS, HeaderButtonHover(), HeaderButtonDanger(), __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].COLUMN_CONTROLS, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CORNER_CONTROLS, DeleteButton("\n        top: -" + (tableDeleteButtonSize + 4) + "px;\n      "), __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_INSERT_BUTTON_WRAP, tableInsertColumnButtonSize, tableInsertColumnButtonSize, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["t" /* akEditorSmallZIndex */], __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_INSERT_LINE, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_INSERT_COLUMN, tableInsertColumnButtonSize - 2, tableInsertColumnButtonSize / 2, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_INSERT_ROW, tableDeleteButtonSize + 2, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].IS_RESIZING, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].COLUMN_CONTROLS, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].IS_RESIZING, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CORNER_CONTROLS, DeleteButtonHover(), __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].COLUMN_CONTROLS, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_INSERT_COLUMN, InsertButton(), InsertMarker("\n        bottom: 5px;\n        left: 7px;\n      "), __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].IS_RESIZING, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_INSERT_COLUMN, InsertButtonHover(), InsertLine("\n        width: 2px;\n        left: 8px;\n        top: " + (tableInsertColumnButtonSize - 2) + "px;\n      "), __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].ROW_CONTROLS, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_INSERT_ROW, InsertButton(), InsertMarker("\n        top: 7px;\n        right: 5px;\n      "), __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].IS_RESIZING, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_INSERT_ROW, InsertButtonHover(), InsertLine("\n        height: 2px;\n        top: 8px;\n        left: " + (tableInsertColumnButtonSize - 2) + "px;\n      "), __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CORNER_CONTROLS, tableToolbarSize + 1, tableToolbarSize + 1, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_CORNER_BUTTON, tableToolbarSize + 1, tableToolbarSize + 1, tableBorderColor, tableBorderRadiusSize, tableToolbarColor, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_CORNER_BUTTON, tableBorderSelectedColor, tableToolbarSelectedColor, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].TABLE_CONTAINER, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CORNER_CONTROLS, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_CORNER_BUTTON, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["x" /* akEditorTableToolbarSize */] + __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["w" /* akEditorTableNumberColumnWidth */], __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].ROW_CONTROLS, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_BUTTON, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].IS_RESIZING, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_CORNER_BUTTON, tableBorderSelectedColor, tableToolbarSelectedColor, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].IS_RESIZING, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_CORNER_BUTTON, tableBorderDeleteColor, tableToolbarDeleteColor, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].ROW_CONTROLS, tableToolbarSize, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].ROW_CONTROLS_INNER, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].ROW_CONTROLS_BUTTON_WRAP, tableBorderRadiusSize, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].ROW_CONTROLS_BUTTON_WRAP, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].ROW_CONTROLS_BUTTON_WRAP, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_BUTTON, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_BUTTON, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["y" /* akEditorUnitZIndex */], __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_INSERT_BUTTON_WRAP, tableInsertColumnButtonSize / 2, tableInsertColumnButtonSize - 2, tableInsertColumnButtonSize, tableInsertColumnButtonSize, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["t" /* akEditorSmallZIndex */], __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_INSERT_LINE, DeleteButton("\n        bottom: -" + tableInsertColumnButtonSize / 2 + "px;\n        left: -" + (tableDeleteButtonSize + 6) + "px;\n      "), HeaderButton("\n        border-bottom: 1px solid " + tableBorderColor + ";\n        border-right: 1px solid " + tableBorderColor + ";\n        border-radius: 0;\n        height: 100%;\n        width: " + (tableToolbarSize + 1) + "px;\n\n        ." + __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_BUTTON_OVERLAY + " {\n          position: absolute;\n          width: 30px;\n          height: 50%;\n          right: 0;\n          bottom: 0;\n        }\n        ." + __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTROLS_BUTTON_OVERLAY + ":first-child {\n          top: 0;\n        }\n      "), __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].IS_RESIZING, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].ROW_CONTROLS, HeaderButtonHover(), HeaderButtonDanger(), DeleteButtonHover(), __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].NUMBERED_COLUMN, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["x" /* akEditorTableToolbarSize */] - 1, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["x" /* akEditorTableToolbarSize */], __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["w" /* akEditorTableNumberColumnWidth */] + 1, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["u" /* akEditorTableBorder */], __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].NUMBERED_COLUMN_BUTTON, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["u" /* akEditorTableBorder */], __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["u" /* akEditorTableBorder */], Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["fontSize"])(), tableToolbarColor, N200, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["u" /* akEditorTableBorder */], __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["u" /* akEditorTableBorder */], __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].WITH_CONTROLS, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].COLUMN_CONTROLS, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CORNER_CONTROLS, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].ROW_CONTROLS, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].NUMBERED_COLUMN, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].NUMBERED_COLUMN_BUTTON, tableBorderSelectedColor, tableBorderSelectedColor, tableToolbarSelectedColor, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["y" /* akEditorUnitZIndex */], N0, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].TABLE_RIGHT_SHADOW, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].TABLE_LEFT_SHADOW, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["t" /* akEditorSmallZIndex */], __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].TABLE_LEFT_SHADOW, N40A, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].TABLE_RIGHT_SHADOW, N40A, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["_1" /* tableMarginTop */] + 8, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["_1" /* tableMarginTop */] - 1, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].IS_RESIZING, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].WITH_CONTROLS, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].NUMBERED_COLUMN_BUTTON, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].NUMBERED_COLUMN_BUTTON, tableBorderSelectedColor, tableBorderSelectedColor, tableToolbarSelectedColor, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["y" /* akEditorUnitZIndex */], N0, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].NUMBERED_COLUMN_BUTTON, tableToolbarDeleteColor, tableBorderDeleteColor, R500, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["y" /* akEditorUnitZIndex */], __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].TABLE_NODE_WRAPPER, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].SELECTED_CELL, tableBorderSelectedColor, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].SELECTED_CELL, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["t" /* akEditorSmallZIndex */], tableCellSelectedColor, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].IS_RESIZING, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].TABLE_NODE_WRAPPER, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].HOVERED_CELL, tableBorderSelectedColor, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].SELECTED_CELL, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].HOVERED_CELL, tableBorderDeleteColor, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].SELECTED_CELL, tableCellDeleteColor, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].COLUMN_CONTROLS_WRAPPER, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].ROW_CONTROLS_WRAPPER, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["_1" /* tableMarginTop */] - 1, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].ROW_CONTROLS_WRAPPER, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].TABLE_LEFT_SHADOW, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["y" /* akEditorUnitZIndex */], __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].COLUMN_CONTROLS_WRAPPER, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].ROW_CONTROLS_WRAPPER, tableToolbarSize, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].TABLE_NODE_WRAPPER, tableInsertColumnButtonSize / 2, tableInsertColumnButtonSize / 2, tableInsertColumnButtonSize / 2, tableInsertColumnButtonSize / 2, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["y" /* akEditorUnitZIndex */] - 1, isIE11 ? 'none' : 'auto', __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].COLUMN_RESIZE_HANDLE, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].IS_RESIZING, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].TABLE_NODE_WRAPPER, isIE11 ? 'none' : 'auto', !isIE11 ? __WEBPACK_IMPORTED_MODULE_4__ui_styles__["j" /* scrollbarStyles */] : '', __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].COLUMN_RESIZE_HANDLE, tableBorderSelectedColor, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["y" /* akEditorUnitZIndex */], __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].WITH_CONTROLS, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].COLUMN_RESIZE_HANDLE, tableToolbarSize, tableToolbarSize, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].RESIZE_CURSOR, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTEXTUAL_MENU_BUTTON, N20, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])(), N0, contextualMenuTriggerSize + 2);
var tableFullPageEditorStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .ProseMirror .", " > table {\n    margin-left: 0;\n    margin-right: 0;\n    width: 100%;\n  }\n  .ProseMirror:not(.", ") .", " {\n    .", ".danger, .", ".danger {\n      border: 1px solid ", ";\n      background: ", ";\n    }\n    .", ".danger:after {\n      background: ", ";\n    }\n  }\n"], ["\n  .ProseMirror .", " > table {\n    margin-left: 0;\n    margin-right: 0;\n    width: 100%;\n  }\n  .ProseMirror:not(.", ") .", " {\n    .", ".danger, .", ".danger {\n      border: 1px solid ", ";\n      background: ", ";\n    }\n    .", ".danger:after {\n      background: ", ";\n    }\n  }\n"])), __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].TABLE_NODE_WRAPPER, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].IS_RESIZING, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].TABLE_NODE_WRAPPER, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].SELECTED_CELL, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].HOVERED_CELL, tableBorderDeleteColor, tableCellDeleteColor, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].SELECTED_CELL, tableCellDeleteColor);
var tableCommentEditorStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .ProseMirror .", " > table {\n    margin-left: 0;\n    margin-right: 0;\n\n    ", ";\n  }\n"], ["\n  .ProseMirror .", " > table {\n    margin-left: 0;\n    margin-right: 0;\n\n    ", ";\n  }\n"])), __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].TABLE_NODE_WRAPPER, __WEBPACK_IMPORTED_MODULE_4__ui_styles__["j" /* scrollbarStyles */]);
var tablePopupStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .", " {\n    border-radius: ", "px;\n    background: white;\n    box-shadow: 0 4px 8px -2px ", ", 0 0 1px ", ";\n    display: block;\n    position: absolute;\n    width: 130px;\n    height: 64px;\n    top: 0;\n    left: ", "px;\n    padding: 5px;\n\n    > div {\n      padding: 0;\n    }\n  }\n\n  .", " {\n    border: 1px solid ", ";\n    border-radius: ", "px;\n    display: block;\n    width: 20px;\n    height: 20px;\n    position: relative;\n    left: -10px;\n\n    &::after {\n      content: '\u203A';\n      display: inline-block;\n      width: 1px;\n      position: relative;\n      left: 25px;\n      top: 9px;\n      color: ", ";\n    }\n  }\n"], ["\n  .", " {\n    border-radius: ", "px;\n    background: white;\n    box-shadow: 0 4px 8px -2px ", ", 0 0 1px ", ";\n    display: block;\n    position: absolute;\n    width: 130px;\n    height: 64px;\n    top: 0;\n    left: ", "px;\n    padding: 5px;\n\n    > div {\n      padding: 0;\n    }\n  }\n\n  .", " {\n    border: 1px solid ", ";\n    border-radius: ", "px;\n    display: block;\n    width: 20px;\n    height: 20px;\n    position: relative;\n    left: -10px;\n\n    &::after {\n      content: '\u203A';\n      display: inline-block;\n      width: 1px;\n      position: relative;\n      left: 25px;\n      top: 9px;\n      color: ", ";\n    }\n  }\n"])), __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTEXTUAL_SUBMENU, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])(), N60A, N60A, contextualMenuDropdownWidth, __WEBPACK_IMPORTED_MODULE_5__types__["a" /* TableCssClassName */].CONTEXTUAL_MENU_ICON, N30, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])(), N90);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MediaPluginState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return stateKey; });
/* unused harmony export getMediaPluginState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_transform__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_transform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prosemirror_transform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prosemirror_view__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prosemirror_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prosemirror_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__analytics_service__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_Media_DropPlaceholder__ = __webpack_require__(2116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_media_files__ = __webpack_require__(2296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_media_common__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__picker_facade_loader__ = __webpack_require__(2297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__default_state_manager__ = __webpack_require__(2354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_media_single__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_prosemirror_utils__);
/* unused harmony reexport DefaultMediaStateManager */


















var MEDIA_RESOLVED_STATES = ['ready', 'error', 'cancelled'];
var MediaPluginState = /** @class */ (function () {
    function MediaPluginState(state, options, reactContext, editorAppearance) {
        var _this = this;
        this.allowsMedia = false;
        this.allowsUploads = false;
        this.ignoreLinks = false;
        this.waitForMediaUpload = true;
        this.allUploadsFinished = true;
        this.showDropzone = false;
        this.layout = 'center';
        this.mediaNodes = [];
        this.mediaGroupNodes = {};
        this.pendingTask = Promise.resolve(null);
        this.pluginStateChangeSubscribers = [];
        this.useDefaultStateManager = true;
        this.destroyed = false;
        this.pickers = [];
        this.removeOnCloseListener = function () { };
        this.setMediaProvider = function (mediaProvider) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](_this, void 0, void 0, function () {
            var Picker, resolvedMediaProvider, _a, err_1, wrappedError, _b, stateManager, _c, view, allowsUploads, uploadContext;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!mediaProvider) {
                            this.destroyPickers();
                            this.allowsUploads = false;
                            this.allowsMedia = false;
                            this.notifyPluginStateSubscribers();
                            return [2 /*return*/];
                        }
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 4, , 5]);
                        _a = this;
                        return [4 /*yield*/, mediaProvider];
                    case 2:
                        resolvedMediaProvider = (_a.mediaProvider = _d.sent());
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_13__picker_facade_loader__["a" /* default */])()];
                    case 3:
                        Picker = _d.sent();
                        __WEBPACK_IMPORTED_MODULE_1_assert__(resolvedMediaProvider && resolvedMediaProvider.viewContext, "MediaProvider promise did not resolve to a valid instance of MediaProvider - " + resolvedMediaProvider);
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _d.sent();
                        wrappedError = new Error("Media functionality disabled due to rejected provider: " + err_1.message);
                        this.errorReporter.captureException(wrappedError);
                        this.destroyPickers();
                        this.allowsUploads = false;
                        this.allowsMedia = false;
                        this.notifyPluginStateSubscribers();
                        return [2 /*return*/];
                    case 5:
                        this.allowsMedia = true;
                        _b = this;
                        return [4 /*yield*/, this.mediaProvider.viewContext];
                    case 6:
                        _b.mediaContext = _d.sent();
                        stateManager = this.mediaProvider.stateManager;
                        if (stateManager && this.useDefaultStateManager) {
                            stateManager.destroy();
                            this.useDefaultStateManager = false;
                        }
                        if (stateManager) {
                            this.stateManager = stateManager;
                        }
                        this.allowsUploads = !!this.mediaProvider.uploadContext;
                        _c = this, view = _c.view, allowsUploads = _c.allowsUploads;
                        // make sure editable DOM node is mounted
                        if (view.dom.parentNode) {
                            // make PM plugin aware of the state change to update UI during 'apply' hook
                            view.dispatch(view.state.tr.setMeta(stateKey, { allowsUploads: allowsUploads }));
                        }
                        if (!this.allowsUploads) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.mediaProvider.uploadContext];
                    case 7:
                        uploadContext = _d.sent();
                        if (this.mediaProvider.uploadParams && uploadContext) {
                            this.initPickers(this.mediaProvider.uploadParams, uploadContext, Picker, this.reactContext);
                        }
                        else {
                            this.destroyPickers();
                        }
                        return [3 /*break*/, 9];
                    case 8:
                        this.destroyPickers();
                        _d.label = 9;
                    case 9:
                        this.notifyPluginStateSubscribers();
                        return [2 /*return*/];
                }
            });
        }); };
        this.getMediaOptions = function () { return _this.options; };
        this.updateUploadStateDebounce = null;
        this.insertFiles = function (mediaStates) {
            var stateManager = _this.stateManager;
            var mediaSingle = _this.view.state.schema.nodes.mediaSingle;
            var collection = _this.collectionFromProvider();
            if (collection === undefined) {
                return;
            }
            var imageAttachments = mediaStates.filter(function (media) {
                return Object(__WEBPACK_IMPORTED_MODULE_9__utils__["v" /* isImage */])(media.fileMimeType);
            });
            var nonImageAttachments = mediaStates.filter(function (media) { return !Object(__WEBPACK_IMPORTED_MODULE_9__utils__["v" /* isImage */])(media.fileMimeType); });
            var grandParentNode = _this.view.state.selection.$from.node(-1);
            // in case of gap cursor, selection might be at depth=0
            if (grandParentNode && Object(__WEBPACK_IMPORTED_MODULE_11__utils_media_files__["b" /* isNonImagesBanned */])(grandParentNode)) {
                nonImageAttachments = [];
            }
            mediaStates.forEach(function (mediaState) {
                _this.stateManager.on(mediaState.id, _this.handleMediaState);
            });
            if (_this.editorAppearance !== 'message' && mediaSingle) {
                Object(__WEBPACK_IMPORTED_MODULE_11__utils_media_files__["a" /* insertMediaGroupNode */])(_this.view, nonImageAttachments, collection);
                imageAttachments.forEach(function (mediaState) {
                    Object(__WEBPACK_IMPORTED_MODULE_15__utils_media_single__["b" /* insertMediaSingleNode */])(_this.view, mediaState, collection);
                });
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_11__utils_media_files__["a" /* insertMediaGroupNode */])(_this.view, mediaStates, collection);
            }
            var isEndState = function (state) {
                return state.status && MEDIA_RESOLVED_STATES.indexOf(state.status) !== -1;
            };
            _this.pendingTask = mediaStates
                .filter(function (state) { return !isEndState(state); })
                .reduce(function (promise, state) {
                // Chain the previous promise with a new one for this media item
                return new Promise(function (resolve, reject) {
                    var onStateChange = function (newState) {
                        // When media item reaches its final state, remove listener and resolve
                        if (isEndState(newState)) {
                            stateManager.off(state.id, onStateChange);
                            resolve(newState);
                        }
                    };
                    stateManager.on(state.id, onStateChange);
                }).then(function () { return promise; });
            }, _this.pendingTask);
            var view = _this.view;
            if (!view.hasFocus()) {
                view.focus();
            }
        };
        this.splitMediaGroup = function () { return Object(__WEBPACK_IMPORTED_MODULE_12__utils_media_common__["h" /* splitMediaGroup */])(_this.view); };
        this.insertFileFromDataUrl = function (url, fileName) {
            var binaryPicker = _this.binaryPicker;
            __WEBPACK_IMPORTED_MODULE_1_assert__(binaryPicker, 'Unable to insert file because media pickers have not been initialized yet');
            binaryPicker.upload(url, fileName);
        };
        // TODO [MSW-454]: remove this logic from Editor
        this.onPopupPickerClose = function () {
            if (_this.dropzonePicker &&
                _this.popupPicker &&
                _this.popupPicker.type === 'popup') {
                _this.dropzonePicker.activate();
            }
        };
        this.showMediaPicker = function () {
            if (!_this.popupPicker) {
                return;
            }
            if (_this.dropzonePicker && _this.popupPicker.type === 'popup') {
                _this.dropzonePicker.deactivate();
            }
            _this.popupPicker.show();
        };
        /**
         * Returns a promise that is resolved after all pending operations have been finished.
         * An optional timeout will cause the promise to reject if the operation takes too long
         *
         * NOTE: The promise will resolve even if some of the media have failed to process.
         */
        this.waitForPendingTasks = function (timeout, lastTask) {
            if (lastTask && _this.pendingTask === lastTask) {
                return lastTask;
            }
            var chainedPromise = _this.pendingTask.then(function () {
                // Call ourselves to make sure that no new pending tasks have been
                // added before the current promise has resolved.
                return _this.waitForPendingTasks(undefined, _this.pendingTask);
            });
            if (!timeout) {
                return chainedPromise;
            }
            var rejectTimeout;
            var timeoutPromise = new Promise(function (resolve, reject) {
                rejectTimeout = window.setTimeout(function () {
                    return reject(new Error("Media operations did not finish in " + timeout + " ms"));
                }, timeout);
            });
            return Promise.race([
                timeoutPromise,
                chainedPromise.then(function () {
                    clearTimeout(rejectTimeout);
                }),
            ]);
        };
        /**
         * Called from React UI Component when user clicks on "Delete" icon
         * inside of it
         */
        this.handleMediaNodeRemoval = function (node, getPos) {
            var getNode = node;
            if (!getNode) {
                getNode = _this.view.state.doc.nodeAt(getPos());
            }
            Object(__WEBPACK_IMPORTED_MODULE_12__utils_media_common__["g" /* removeMediaNode */])(_this.view, getNode, getPos);
        };
        /**
         * Called from React UI Component on componentDidMount
         */
        this.handleMediaNodeMount = function (node, getPos) {
            _this.mediaNodes.unshift({ node: node, getPos: getPos });
        };
        /**
         * Called from React UI Component on componentWillUnmount and componentWillReceiveProps
         * when React component's underlying node property is replaced with a new node
         */
        this.handleMediaNodeUnmount = function (oldNode) {
            _this.mediaNodes = _this.mediaNodes.filter(function (_a) {
                var node = _a.node;
                return oldNode !== node;
            });
        };
        this.align = function (layout, gridSize) {
            if (gridSize === void 0) { gridSize = 12; }
            if (!_this.selectedMediaNode()) {
                return false;
            }
            var _a = _this.view.state, from = _a.selection.from, tr = _a.tr, schema = _a.schema;
            var mediaSingleNode = _this.view.state.doc.nodeAt(from - 1);
            if (!mediaSingleNode) {
                return false;
            }
            var width = mediaSingleNode.attrs.width;
            var oldLayout = mediaSingleNode.attrs.layout;
            var wrappedLayouts = ['wrap-left', 'wrap-right'];
            if (width) {
                var cols = Math.round((width / 100) * gridSize);
                var targetCols = cols;
                var nonWrappedLayouts = [
                    'center',
                    'wide',
                    'full-width',
                ];
                if (wrappedLayouts.indexOf(oldLayout) > -1 &&
                    nonWrappedLayouts.indexOf(layout) > -1) {
                    // wrap -> center needs to align to even grid
                    targetCols = Math.floor(targetCols / 2) * 2;
                }
                else if (nonWrappedLayouts.indexOf(oldLayout) > -1 &&
                    wrappedLayouts.indexOf(layout) > -1) {
                    // cannot resize to full column width, and cannot resize to 1 column
                    if (cols <= 1) {
                        targetCols = 2;
                    }
                    else if (cols >= gridSize) {
                        targetCols = 10;
                    }
                }
                if (targetCols !== cols) {
                    width = (targetCols / gridSize) * 100;
                }
            }
            _this.view.dispatch(tr.setNodeMarkup(from - 1, schema.nodes.mediaSingle, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, mediaSingleNode.attrs, { layout: layout,
                width: width })));
            return true;
        };
        this.findMediaNode = function (id) {
            var mediaNodes = _this.mediaNodes;
            // Array#find... no IE support
            return mediaNodes.reduce(function (memo, nodeWithPos) {
                if (memo) {
                    return memo;
                }
                var node = nodeWithPos.node;
                if (node.attrs.__key === id) {
                    return nodeWithPos;
                }
                return memo;
            }, null);
        };
        this.destroyPickers = function () {
            var pickers = _this.pickers;
            pickers.forEach(function (picker) { return picker.destroy(); });
            pickers.splice(0, pickers.length);
            _this.popupPicker = undefined;
            _this.binaryPicker = undefined;
            _this.clipboardPicker = undefined;
            _this.dropzonePicker = undefined;
            _this.customPicker = undefined;
        };
        this.updateMediaNodeAttrs = function (id, attrs, isMediaSingle) {
            var view = _this.view;
            if (!view) {
                return;
            }
            var mediaNodeWithPos = isMediaSingle
                ? _this.findMediaNode(id)
                : _this.mediaGroupNodes[id];
            if (!mediaNodeWithPos) {
                return;
            }
            view.dispatch(view.state.tr
                .step(new __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* SetAttrsStep */](mediaNodeWithPos.getPos(), attrs))
                .setMeta('addToHistory', false));
        };
        this.handleMediaState = function (state) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](_this, void 0, void 0, function () {
            var isMediaSingle, uploadErrorHandler, attrs;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
                isMediaSingle = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["v" /* isImage */])(state.fileMimeType) && !!this.view.state.schema.nodes.mediaSingle;
                switch (state.status) {
                    case 'error':
                        this.removeNodeById(state);
                        uploadErrorHandler = this.options.uploadErrorHandler;
                        if (uploadErrorHandler) {
                            uploadErrorHandler(state);
                        }
                        break;
                    case 'preview':
                        attrs = {
                            id: state.publicId || state.id,
                        };
                        if (typeof state.collection === 'string') {
                            attrs.collection = state.collection;
                        }
                        this.updateMediaNodeAttrs(state.id, attrs, isMediaSingle);
                        delete this.mediaGroupNodes[state.id];
                        break;
                    case 'ready':
                        this.stateManager.off(state.id, this.handleMediaState);
                        break;
                }
                return [2 /*return*/];
            });
        }); };
        this.notifyPluginStateSubscribers = function () {
            _this.pluginStateChangeSubscribers.forEach(function (cb) { return cb.call(cb, _this); });
        };
        this.removeNodeById = function (state) {
            var id = state.id;
            var mediaNodeWithPos = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["v" /* isImage */])(state.fileMimeType)
                ? _this.findMediaNode(id)
                : _this.mediaGroupNodes[id];
            if (mediaNodeWithPos) {
                Object(__WEBPACK_IMPORTED_MODULE_12__utils_media_common__["g" /* removeMediaNode */])(_this.view, mediaNodeWithPos.node, mediaNodeWithPos.getPos);
            }
        };
        this.removeSelectedMediaNode = function () {
            var view = _this.view;
            if (_this.selectedMediaNode()) {
                var _a = view.state.selection, from_1 = _a.from, node = _a.node;
                Object(__WEBPACK_IMPORTED_MODULE_12__utils_media_common__["g" /* removeMediaNode */])(view, node, function () { return from_1; });
                return true;
            }
            return false;
        };
        /**
         * Since we replace nodes with public id when node is finalized
         * stateManager contains no information for public ids
         */
        this.getMediaNodeStateStatus = function (id) {
            var state = _this.getMediaNodeState(id);
            return (state && state.status) || 'ready';
        };
        this.getMediaNodeState = function (id) {
            return _this.stateManager.getState(id);
        };
        this.handleDrag = function (dragState) {
            var isActive = dragState === 'enter';
            if (_this.showDropzone === isActive) {
                return;
            }
            _this.showDropzone = isActive;
            var _a = _this.view, dispatch = _a.dispatch, state = _a.state;
            // Trigger state change to be able to pick it up in the decorations handler
            dispatch(state.tr);
        };
        this.reactContext = reactContext;
        this.options = options;
        this.editorAppearance = editorAppearance;
        this.waitForMediaUpload =
            options.waitForMediaUpload === undefined
                ? true
                : options.waitForMediaUpload;
        var nodes = state.schema.nodes;
        __WEBPACK_IMPORTED_MODULE_1_assert__(nodes.media && (nodes.mediaGroup || nodes.mediaSingle), 'Editor: unable to init media plugin - media or mediaGroup/mediaSingle node absent in schema');
        this.stateManager = new __WEBPACK_IMPORTED_MODULE_14__default_state_manager__["a" /* default */]();
        options.providerFactory.subscribe('mediaProvider', function (name, provider) {
            return _this.setMediaProvider(provider);
        });
        this.errorReporter = options.errorReporter || new __WEBPACK_IMPORTED_MODULE_7__atlaskit_editor_common__["b" /* ErrorReporter */]();
    }
    MediaPluginState.prototype.subscribe = function (cb) {
        this.pluginStateChangeSubscribers.push(cb);
        cb(this);
    };
    MediaPluginState.prototype.unsubscribe = function (cb) {
        var pluginStateChangeSubscribers = this.pluginStateChangeSubscribers;
        var pos = pluginStateChangeSubscribers.indexOf(cb);
        if (pos > -1) {
            pluginStateChangeSubscribers.splice(pos, 1);
        }
    };
    MediaPluginState.prototype.updateElement = function () {
        var newElement;
        if (this.selectedMediaNode() && this.isMediaSingle()) {
            newElement = this.getDomElement(this.view.domAtPos.bind(this.view));
        }
        if (this.element !== newElement) {
            this.element = newElement;
            this.notifyPluginStateSubscribers();
        }
    };
    MediaPluginState.prototype.updateUploadState = function () {
        var _this = this;
        if (!this.waitForMediaUpload) {
            return;
        }
        if (this.updateUploadStateDebounce) {
            clearTimeout(this.updateUploadStateDebounce);
        }
        this.updateUploadStateDebounce = window.setTimeout(function () {
            _this.updateUploadStateDebounce = null;
            _this.allUploadsFinished = false;
            _this.notifyPluginStateSubscribers();
            _this.waitForPendingTasks().then(function () {
                _this.allUploadsFinished = true;
                _this.notifyPluginStateSubscribers();
            });
        }, 0);
    };
    MediaPluginState.prototype.updateLayout = function (layout) {
        this.layout = layout;
        this.notifyPluginStateSubscribers();
    };
    MediaPluginState.prototype.isMediaSingle = function () {
        var _a = this.view.state, selection = _a.selection, schema = _a.schema;
        return selection.$from.parent.type === schema.nodes.mediaSingle;
    };
    MediaPluginState.prototype.getDomElement = function (domAtPos) {
        var from = this.view.state.selection.from;
        if (this.selectedMediaNode()) {
            var node = domAtPos(from).node;
            if (!node.childNodes.length) {
                return node.parentNode;
            }
            return node.querySelector('.wrapper') || node;
        }
    };
    MediaPluginState.prototype.setView = function (view) {
        this.view = view;
    };
    MediaPluginState.prototype.destroy = function () {
        if (this.destroyed) {
            return;
        }
        this.destroyed = true;
        var mediaNodes = this.mediaNodes;
        mediaNodes.splice(0, mediaNodes.length);
        this.removeOnCloseListener();
        this.destroyPickers();
    };
    MediaPluginState.prototype.initPickers = function (uploadParams, context, Picker, reactContext) {
        var _this = this;
        if (this.destroyed) {
            return;
        }
        var _a = this, errorReporter = _a.errorReporter, pickers = _a.pickers, stateManager = _a.stateManager;
        // create pickers if they don't exist, re-use otherwise
        if (!pickers.length) {
            var pickerFacadeConfig = {
                context: context,
                stateManager: stateManager,
                errorReporter: errorReporter,
            };
            var defaultPickerConfig = {
                uploadParams: uploadParams,
                proxyReactContext: reactContext(),
            };
            if (this.options.customMediaPicker) {
                pickers.push((this.customPicker = new Picker('customMediaPicker', pickerFacadeConfig, this.options.customMediaPicker)));
            }
            else {
                pickers.push((this.popupPicker = new Picker(
                // Fallback to browser picker for unauthenticated users
                context.config.userAuthProvider ? 'popup' : 'browser', pickerFacadeConfig, defaultPickerConfig)));
                pickers.push((this.binaryPicker = new Picker('binary', pickerFacadeConfig, defaultPickerConfig)));
                pickers.push((this.clipboardPicker = new Picker('clipboard', pickerFacadeConfig, defaultPickerConfig)));
                pickers.push((this.dropzonePicker = new Picker('dropzone', pickerFacadeConfig, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ container: this.options.customDropzoneContainer, headless: true }, defaultPickerConfig))));
                this.dropzonePicker.onDrag(this.handleDrag);
                this.removeOnCloseListener = this.popupPicker.onClose(this.onPopupPickerClose);
            }
            pickers.forEach(function (picker) {
                picker.onNewMedia(_this.insertFiles);
                picker.onNewMedia(_this.trackNewMediaEvent(picker.type));
            });
        }
        // set new upload params for the pickers
        pickers.forEach(function (picker) { return picker.setUploadParams(uploadParams); });
    };
    MediaPluginState.prototype.trackNewMediaEvent = function (pickerType) {
        return function (mediaStates) {
            mediaStates.forEach(function (mediaState) {
                __WEBPACK_IMPORTED_MODULE_8__analytics_service__["a" /* default */].trackEvent("atlassian.editor.media.file." + pickerType, mediaState.fileMimeType
                    ? { fileMimeType: mediaState.fileMimeType }
                    : {});
            });
        };
    };
    MediaPluginState.prototype.collectionFromProvider = function () {
        return (this.mediaProvider &&
            this.mediaProvider.uploadParams &&
            this.mediaProvider.uploadParams.collection);
    };
    MediaPluginState.prototype.selectedMediaNode = function () {
        var _a = this.view.state, selection = _a.selection, schema = _a.schema;
        if (selection instanceof __WEBPACK_IMPORTED_MODULE_6_prosemirror_state__["NodeSelection"] &&
            selection.node.type === schema.nodes.media) {
            var node = selection.node;
            return node;
        }
    };
    MediaPluginState.prototype.isLayoutSupported = function () {
        var _a = this.view.state, selection = _a.selection, schema = _a.schema;
        if (selection instanceof __WEBPACK_IMPORTED_MODULE_6_prosemirror_state__["NodeSelection"] &&
            selection.node.type === schema.nodes.media) {
            return (!Object(__WEBPACK_IMPORTED_MODULE_16_prosemirror_utils__["hasParentNodeOfType"])(schema.nodes.bodiedExtension)(selection) &&
                !Object(__WEBPACK_IMPORTED_MODULE_16_prosemirror_utils__["hasParentNodeOfType"])(schema.nodes.layoutSection)(selection));
        }
        return false;
    };
    return MediaPluginState;
}());

var createDropPlaceholder = function (editorAppearance) {
    var dropPlaceholder = document.createElement('div');
    if (editorAppearance === 'full-page') {
        __WEBPACK_IMPORTED_MODULE_3_react_dom__["render"](__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ui_Media_DropPlaceholder__["a" /* default */], { type: 'single' }), dropPlaceholder);
    }
    else {
        __WEBPACK_IMPORTED_MODULE_3_react_dom__["render"](__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ui_Media_DropPlaceholder__["a" /* default */]), dropPlaceholder);
    }
    return dropPlaceholder;
};
var stateKey = new __WEBPACK_IMPORTED_MODULE_6_prosemirror_state__["PluginKey"]('mediaPlugin');
var getMediaPluginState = function (state) {
    return stateKey.getState(state);
};
var createPlugin = function (schema, options, reactContext, dispatch, editorAppearance) {
    var dropPlaceholder = createDropPlaceholder(editorAppearance);
    return new __WEBPACK_IMPORTED_MODULE_6_prosemirror_state__["Plugin"]({
        state: {
            init: function (config, state) {
                return new MediaPluginState(state, options, reactContext, editorAppearance);
            },
            apply: function (tr, pluginState, oldState, newState) {
                var parent = newState.selection.$from.parent;
                // Update Layout
                var mediaSingle = oldState.schema.nodes.mediaSingle;
                if (parent.type === mediaSingle) {
                    pluginState.layout = parent.attrs.layout;
                }
                var meta = tr.getMeta(stateKey);
                if (meta && dispatch) {
                    var showMediaPicker = pluginState.showMediaPicker;
                    var allowsUploads = meta.allowsUploads;
                    dispatch(stateKey, { allowsUploads: allowsUploads, showMediaPicker: showMediaPicker });
                }
                // NOTE: We're not calling passing new state to the Editor, because we depend on the view.state reference
                //       throughout the lifetime of view. We injected the view into the plugin state, because we dispatch()
                //       transformations from within the plugin state (i.e. when adding a new file).
                return pluginState;
            },
        },
        key: stateKey,
        view: function (view) {
            var pluginState = getMediaPluginState(view.state);
            pluginState.setView(view);
            pluginState.updateElement();
            return {
                update: function () {
                    pluginState.updateUploadState();
                    pluginState.updateElement();
                },
            };
        },
        props: {
            decorations: function (state) {
                var pluginState = getMediaPluginState(state);
                if (!pluginState.showDropzone) {
                    return;
                }
                var schema = state.schema, $anchor = state.selection.$anchor;
                // When a media is already selected
                if (state.selection instanceof __WEBPACK_IMPORTED_MODULE_6_prosemirror_state__["NodeSelection"]) {
                    var node = state.selection.node;
                    if (node.type === schema.nodes.mediaSingle) {
                        var deco = __WEBPACK_IMPORTED_MODULE_5_prosemirror_view__["Decoration"].node(state.selection.from, state.selection.to, {
                            class: 'mediaSingle-selected',
                        });
                        return __WEBPACK_IMPORTED_MODULE_5_prosemirror_view__["DecorationSet"].create(state.doc, [deco]);
                    }
                    return;
                }
                var pos = $anchor.pos;
                if ($anchor.parent.type !== schema.nodes.paragraph &&
                    $anchor.parent.type !== schema.nodes.codeBlock) {
                    pos = Object(__WEBPACK_IMPORTED_MODULE_4_prosemirror_transform__["insertPoint"])(state.doc, pos, schema.nodes.mediaGroup);
                }
                if (pos === null || pos === undefined) {
                    return;
                }
                var dropPlaceholders = [
                    __WEBPACK_IMPORTED_MODULE_5_prosemirror_view__["Decoration"].widget(pos, dropPlaceholder, { key: 'drop-placeholder' }),
                ];
                return __WEBPACK_IMPORTED_MODULE_5_prosemirror_view__["DecorationSet"].create(state.doc, dropPlaceholders);
            },
            nodeViews: options.nodeViews,
            handleTextInput: function (view) {
                getMediaPluginState(view.state).splitMediaGroup();
                return false;
            },
        },
    });
};
//# sourceMappingURL=main.js.map

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ellipsis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return size; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return center; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return absolute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return borderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return borderRadiusBottom; });
/* unused harmony export easeInOutCubic */
/* unused harmony export fadeInKeyframe */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fadeIn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(49);



var ellipsis = function (maxWidth) {
    if (maxWidth === void 0) { maxWidth = '100%'; }
    var unit = typeof maxWidth === 'number' ? 'px' : '';
    return "\n    max-width: " + maxWidth + unit + ";\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  ";
};
var size = function (value) {
    if (value === void 0) { value = '100%'; }
    var unit = typeof value === 'number' ? 'px' : '';
    return "\n    width: " + value + unit + ";\n    height: " + value + unit + ";\n  ";
};
var center = "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n";
var absolute = function (top, left) {
    if (top === void 0) { top = 0; }
    if (left === void 0) { left = 0; }
    return "\n  position: absolute;\n  top: " + top + "px;\n  left: " + left + "px;\n";
};
var borderRadius = "\n  border-radius: " + Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])() + "px;\n";
var borderRadiusBottom = "\n  border-bottom-left-radius: " + Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])() + "px;\n  border-bottom-right-radius: " + Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])() + "px;\n";
var easeInOutCubic = 'cubic-bezier(0.645, 0.045, 0.355, 1)';
var fadeInKeyframe = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  0%{\n    opacity: 0;\n  }\n\n  100%{\n    opacity: 1;\n  }\n"], ["\n  0%{\n    opacity: 0;\n  }\n\n  100%{\n    opacity: 1;\n  }\n"])));
var fadeIn = "\n  animation: " + fadeInKeyframe + " .3s " + easeInOutCubic + ";\n";
var templateObject_1;
//# sourceMappingURL=mixins.js.map

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(54);

var _interopRequireDefault = __webpack_require__(53);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.size = exports.default = exports.IconWrapper = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(4));

var _createClass2 = _interopRequireDefault(__webpack_require__(5));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(7));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(6));

var _inherits2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _styledComponents = _interopRequireDefault(__webpack_require__(2));

var _uuid = _interopRequireDefault(__webpack_require__(22));

var _theme = __webpack_require__(3);

var _constants = __webpack_require__(2990);

var getSize = function getSize(props) {
  if (props.size) {
    return "height: ".concat(_constants.sizes[props.size], "; width: ").concat(_constants.sizes[props.size], ";");
  }

  return null;
};

var IconWrapper = _styledComponents.default.span.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "dyhwwi-0"
})(["\n  ", " color: ", ";\n  display: inline-block;\n  fill: ", ";\n  flex-shrink: 0;\n  line-height: 1;\n\n  > svg {\n    ", " max-height: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    pointer-events: none;\n    vertical-align: bottom;\n  }\n  /* Stop-color doesn't properly apply in chrome when the inherited/current color changes.\n   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS\n   * rule) and then override it with currentColor for the color changes to be picked up.\n   */\n  stop {\n    stop-color: currentColor;\n  }\n"], getSize, function (p) {
  return p.primaryColor || 'currentColor';
}, function (p) {
  return p.secondaryColor || _theme.colors.background;
}, getSize);

exports.IconWrapper = IconWrapper;

var Icon =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Icon, _Component);

  function Icon() {
    (0, _classCallCheck2.default)(this, Icon);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Icon).apply(this, arguments));
  }

  (0, _createClass2.default)(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Glyph = _this$props.glyph,
          dangerouslySetGlyph = _this$props.dangerouslySetGlyph,
          onClick = _this$props.onClick,
          primaryColor = _this$props.primaryColor,
          secondaryColor = _this$props.secondaryColor,
          size = _this$props.size; // handling the glyphs as strings

      if (dangerouslySetGlyph) {
        return _react.default.createElement(IconWrapper, {
          onClick: onClick,
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          size: size,
          "aria-label": this.props.label,
          dangerouslySetInnerHTML: {
            __html: Icon.insertDynamicGradientID(dangerouslySetGlyph)
          }
        });
      } // handling the glyphs when passed through as functions


      return _react.default.createElement(IconWrapper, {
        onClick: onClick,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        "aria-label": this.props.label
      }, Glyph ? _react.default.createElement(Glyph, {
        role: "presentation"
      }) : null);
    }
  }], [{
    key: "insertDynamicGradientID",

    /* Icons need unique gradient IDs across instances for different gradient definitions to work
     * correctly.
     * A step in the icon build process replaces linear gradient IDs and their references in paths
     * to a placeholder string so we can replace them with a dynamic ID here.
     * Replacing the original IDs with placeholders in the build process is more robust than not
     * using placeholders as we do not have to rely on regular expressions to find specific element
     * to replace.
     */
    value: function insertDynamicGradientID(svgStr) {
      var id = (0, _uuid.default)();
      var replacedSvgStr = svgStr.replace(/id="([^"]+)-idPlaceholder"/g, "id=$1-".concat(id)).replace(/fill="url\(#([^"]+)-idPlaceholder\)"/g, "fill=\"url(#$1-".concat(id, ")\""));
      return replacedSvgStr;
    }
  }]);
  return Icon;
}(_react.Component);

exports.default = Icon;
(0, _defineProperty2.default)(Icon, "defaultProps", {
  onClick: function onClick() {}
});
var size = Object.keys(_constants.sizes).reduce(function (p, c) {
  return Object.assign(p, (0, _defineProperty2.default)({}, c, c));
}, {});
exports.size = size;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(543);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getFragmentBackingArray;
/* harmony export (immutable) */ __webpack_exports__["d"] = mapFragment;
/* harmony export (immutable) */ __webpack_exports__["e"] = mapSlice;
/* harmony export (immutable) */ __webpack_exports__["a"] = flatmap;
/* harmony export (immutable) */ __webpack_exports__["c"] = mapChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__);


/**
 * A helper to get the underlying array of a fragment.
 */
function getFragmentBackingArray(fragment) {
    return fragment.content;
}
function mapFragment(content, callback, parent) {
    if (parent === void 0) { parent = null; }
    var children = [];
    for (var i = 0, size = content.childCount; i < size; i++) {
        var node = content.child(i);
        var transformed = node.isLeaf
            ? callback(node, parent, i)
            : callback(node.copy(mapFragment(node.content, callback, node)), parent, i);
        if (transformed) {
            if (transformed instanceof __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"]) {
                children.push.apply(children, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](getFragmentBackingArray(transformed)));
            }
            else if (Array.isArray(transformed)) {
                children.push.apply(children, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](transformed));
            }
            else {
                children.push(transformed);
            }
        }
    }
    return __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].fromArray(children);
}
function mapSlice(slice, callback) {
    var fragment = mapFragment(slice.content, callback);
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"](fragment, slice.openStart, slice.openEnd);
}
function flatmap(fragment, callback) {
    var fragmentContent = [];
    for (var i = 0; i < fragment.childCount; i++) {
        var child = callback(fragment.child(i), i, fragment);
        if (Array.isArray(child)) {
            fragmentContent.push.apply(fragmentContent, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](child));
        }
        else {
            fragmentContent.push(child);
        }
    }
    return __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].fromArray(fragmentContent);
}
function mapChildren(node, callback) {
    var array = [];
    for (var i = 0; i < node.childCount; i++) {
        array.push(callback(node.child(i), i, node.content));
    }
    return array;
}
//# sourceMappingURL=slice.js.map

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(17);
// Common Translations will live here

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["defineMessages"])({
    layoutFixedWidth: {
        id: 'fabric.editor.layoutFixedWidth',
        defaultMessage: 'Center',
        description: 'Display your element (image, table, extension, etc) as standard width',
    },
    layoutWide: {
        id: 'fabric.editor.layoutWide',
        defaultMessage: 'Wide',
        description: 'Display your element (image, table, extension, etc) wider than normal',
    },
    layoutFullWidth: {
        id: 'fabric.editor.layoutFullWidth',
        defaultMessage: 'Full width',
        description: 'Display your element (image, table, extension, etc) as full width',
    },
    alignImageRight: {
        id: 'fabric.editor.alignImageRight',
        defaultMessage: 'Align right',
        description: 'Aligns image to the right',
    },
    alignImageCenter: {
        id: 'fabric.editor.alignImageCenter',
        defaultMessage: 'Align center',
        description: 'Aligns image to the center',
    },
    alignImageLeft: {
        id: 'fabric.editor.alignImageLeft',
        defaultMessage: 'Align left',
        description: 'Aligns image to the left',
    },
    remove: {
        id: 'fabric.editor.remove',
        defaultMessage: 'Remove',
        description: 'Delete the element (image, panel, table, etc.) from your document',
    },
    visit: {
        id: 'fabric.editor.visit',
        defaultMessage: 'Open link in a new window',
        description: '',
    },
}));
//# sourceMappingURL=messages.js.map

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluginKey; });
/* unused harmony export createPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);

var pluginKey = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["PluginKey"]('editorDisabledPlugin');
/*
Stores the state of the editor enabled/disabled for panel and floating
toolbar to subscribe to through <WithPluginState>. Otherwise the NodeViews
won't re-render when it changes.
*/
function createPlugin(dispatch) {
    return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
        key: pluginKey,
        state: {
            init: function () {
                return ({
                    editorDisabled: false,
                });
            },
            apply: function (tr, oldPluginState) {
                var newPluginState = tr.getMeta(pluginKey);
                if (newPluginState &&
                    oldPluginState.editorDisabled !== newPluginState.editorDisabled) {
                    dispatch(pluginKey, newPluginState);
                    return newPluginState;
                }
                return oldPluginState;
            },
        },
    });
}
var editorDisabledPlugin = {
    pmPlugins: function () { return [
        {
            name: 'editorDisabled',
            plugin: function (_a) {
                var dispatch = _a.dispatch;
                return createPlugin(dispatch);
            },
        },
    ]; },
};
/* harmony default export */ __webpack_exports__["a"] = (editorDisabledPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return pluginKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIONS; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createInitialPluginState;
/* harmony export (immutable) */ __webpack_exports__["c"] = createPlugin;
/* unused harmony export createItemsLoader */
/* unused harmony export defaultActionHandler */
/* unused harmony export setCurrentItemIndex */
/* unused harmony export selectPrevActionHandler */
/* unused harmony export selectNextActionHandler */
/* unused harmony export itemsListUpdatedActionHandler */
/* unused harmony export selectCurrentActionHandler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands_dismiss__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commands_items_list_updated__ = __webpack_require__(2526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_is_query_active__ = __webpack_require__(2527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_find_query_mark__ = __webpack_require__(457);







var pluginKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('typeAheadPlugin');
var ACTIONS = {
    SELECT_PREV: 'SELECT_PREV',
    SELECT_NEXT: 'SELECT_NEXT',
    SELECT_CURRENT: 'SELECT_CURRENT',
    SET_CURRENT_INDEX: 'SET_CURRENT_INDEX',
    ITEMS_LIST_UPDATED: 'ITEMS_LIST_UPDATED',
};
function createInitialPluginState(prevActiveState, isAllowed) {
    if (prevActiveState === void 0) { prevActiveState = false; }
    if (isAllowed === void 0) { isAllowed = true; }
    return {
        isAllowed: isAllowed,
        active: false,
        prevActiveState: prevActiveState,
        query: null,
        trigger: null,
        typeAheadHandler: null,
        currentIndex: 0,
        items: [],
        itemsLoader: null,
        queryMarkPos: null,
        queryStarted: 0,
        upKeyCount: 0,
        downKeyCount: 0,
    };
}
function createPlugin(dispatch, reactContext, typeAhead) {
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        key: pluginKey,
        state: {
            init: function () {
                return createInitialPluginState();
            },
            apply: function (tr, pluginState, oldState, state) {
                var meta = tr.getMeta(pluginKey) || {};
                var action = meta.action, params = meta.params;
                switch (action) {
                    case ACTIONS.SET_CURRENT_INDEX:
                        return setCurrentItemIndex({
                            dispatch: dispatch,
                            pluginState: pluginState,
                            tr: tr,
                            params: params,
                        });
                    case ACTIONS.SELECT_PREV:
                        return selectPrevActionHandler({ dispatch: dispatch, pluginState: pluginState, tr: tr });
                    case ACTIONS.SELECT_NEXT:
                        return selectNextActionHandler({ dispatch: dispatch, pluginState: pluginState, tr: tr });
                    case ACTIONS.ITEMS_LIST_UPDATED:
                        return itemsListUpdatedActionHandler({ dispatch: dispatch, pluginState: pluginState, tr: tr });
                    case ACTIONS.SELECT_CURRENT:
                        var _a = tr.selection, from = _a.from, to = _a.to;
                        var typeAheadQuery = state.schema.marks.typeAheadQuery;
                        // If inserted content has typeAheadQuery mark should fallback to default action handler
                        return tr.doc.rangeHasMark(from - 1, to, typeAheadQuery)
                            ? defaultActionHandler({
                                dispatch: dispatch,
                                reactContext: reactContext,
                                typeAhead: typeAhead,
                                state: state,
                                pluginState: pluginState,
                            })
                            : selectCurrentActionHandler({ dispatch: dispatch, pluginState: pluginState, tr: tr });
                    default:
                        return defaultActionHandler({
                            dispatch: dispatch,
                            reactContext: reactContext,
                            typeAhead: typeAhead,
                            state: state,
                            pluginState: pluginState,
                        });
                }
            },
        },
        view: function () {
            return {
                update: function (editorView) {
                    var pluginState = pluginKey.getState(editorView.state);
                    if (!pluginState) {
                        return;
                    }
                    var state = editorView.state, dispatch = editorView.dispatch;
                    var doc = state.doc, selection = state.selection;
                    var from = selection.from, to = selection.to;
                    var typeAheadQuery = state.schema.marks.typeAheadQuery;
                    // Disable type ahead query when removing trigger.
                    if (pluginState.active &&
                        !pluginState.query &&
                        !pluginState.trigger) {
                        Object(__WEBPACK_IMPORTED_MODULE_3__commands_dismiss__["a" /* dismissCommand */])()(state, dispatch);
                        return;
                    }
                    // Disable type ahead query when the first character is a space.
                    if (pluginState.active &&
                        (pluginState.query || '').indexOf(' ') === 0) {
                        Object(__WEBPACK_IMPORTED_MODULE_3__commands_dismiss__["a" /* dismissCommand */])()(state, dispatch);
                        return;
                    }
                    // Optimization to not call dismissCommand if plugin is in an inactive state.
                    if (!pluginState.active &&
                        pluginState.prevActiveState &&
                        !doc.rangeHasMark(from - 1, to, typeAheadQuery)) {
                        Object(__WEBPACK_IMPORTED_MODULE_3__commands_dismiss__["a" /* dismissCommand */])()(state, dispatch);
                        return;
                    }
                    // Fetch type ahead items if handler returned a promise.
                    if (pluginState.active && pluginState.itemsLoader) {
                        pluginState.itemsLoader.promise.then(function (items) {
                            return Object(__WEBPACK_IMPORTED_MODULE_4__commands_items_list_updated__["a" /* itemsListUpdated */])(items)(editorView.state, dispatch);
                        });
                    }
                },
            };
        },
    });
}
function createItemsLoader(promiseOfItems) {
    var canceled = false;
    return {
        promise: new Promise(function (resolve, reject) {
            promiseOfItems
                .then(function (result) { return !canceled && resolve(result); })
                .catch(function (error) { return !canceled && reject(error); });
        }),
        cancel: function () {
            canceled = true;
        },
    };
}
function defaultActionHandler(_a) {
    var dispatch = _a.dispatch, reactContext = _a.reactContext, typeAhead = _a.typeAhead, pluginState = _a.pluginState, state = _a.state;
    var typeAheadQuery = state.schema.marks.typeAheadQuery;
    var doc = state.doc, selection = state.selection;
    var from = selection.from, to = selection.to;
    var isActive = Object(__WEBPACK_IMPORTED_MODULE_5__utils_is_query_active__["a" /* isQueryActive */])(typeAheadQuery, doc, from - 1, to);
    var isAllowed = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["y" /* isMarkTypeAllowedInCurrentSelection */])(typeAheadQuery, state);
    if (!isAllowed && !isActive) {
        var newPluginState_1 = createInitialPluginState(pluginState.active, isAllowed);
        dispatch(pluginKey, newPluginState_1);
        return newPluginState_1;
    }
    var nodeBefore = selection.$from.nodeBefore;
    if (!isActive || !nodeBefore || !pluginState) {
        var newPluginState_2 = createInitialPluginState(pluginState ? pluginState.active : false);
        if (!pluginState || pluginState.active || !pluginState.isAllowed) {
            dispatch(pluginKey, newPluginState_2);
        }
        return newPluginState_2;
    }
    var typeAheadMark = typeAheadQuery.isInSet(nodeBefore.marks || []);
    if (!typeAheadMark || !typeAheadMark.attrs.trigger) {
        return pluginState;
    }
    var textContent = nodeBefore.textContent || '';
    var trigger = typeAheadMark.attrs.trigger.replace(/([^\x00-\xFF]|[\s\n])+/g, '');
    // If trigger has been removed, reset plugin state
    if (!textContent.includes(trigger)) {
        var newPluginState_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, createInitialPluginState(true), { active: true });
        dispatch(pluginKey, newPluginState_3);
        return newPluginState_3;
    }
    var query = textContent
        .replace(/^([^\x00-\xFF]|[\s\n])+/g, '')
        .replace(trigger, '');
    var typeAheadHandler = typeAhead.find(function (t) { return t.trigger === trigger; });
    var typeAheadItems = [];
    var itemsLoader = null;
    try {
        var intl = reactContext().intl;
        typeAheadItems = typeAheadHandler.getItems(query, state, intl, {
            prevActive: pluginState.prevActiveState,
            queryChanged: query !== pluginState.query,
        });
        if (pluginState.itemsLoader) {
            pluginState.itemsLoader.cancel();
        }
        if (typeAheadItems.then) {
            itemsLoader = createItemsLoader(typeAheadItems);
            typeAheadItems = pluginState.items;
        }
    }
    catch (e) { }
    var queryMark = Object(__WEBPACK_IMPORTED_MODULE_6__utils_find_query_mark__["a" /* findTypeAheadQuery */])(state);
    var newPluginState = {
        isAllowed: isAllowed,
        query: query,
        trigger: trigger,
        typeAheadHandler: typeAheadHandler,
        active: true,
        prevActiveState: pluginState.active,
        items: typeAheadItems,
        itemsLoader: itemsLoader,
        currentIndex: pluginState.currentIndex,
        queryMarkPos: queryMark !== null ? queryMark.start : null,
        queryStarted: Date.now(),
        upKeyCount: 0,
        downKeyCount: 0,
    };
    dispatch(pluginKey, newPluginState);
    return newPluginState;
}
function setCurrentItemIndex(_a) {
    var dispatch = _a.dispatch, pluginState = _a.pluginState, params = _a.params;
    if (!params) {
        return pluginState;
    }
    var newPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { currentIndex: params.currentIndex || params.currentIndex === 0
            ? params.currentIndex
            : pluginState.currentIndex });
    dispatch(pluginKey, newPluginState);
    return newPluginState;
}
function selectPrevActionHandler(_a) {
    var dispatch = _a.dispatch, pluginState = _a.pluginState;
    var newIndex = pluginState.currentIndex - 1;
    var newPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { currentIndex: newIndex < 0 ? pluginState.items.length - 1 : newIndex, upKeyCount: ++pluginState.upKeyCount });
    dispatch(pluginKey, newPluginState);
    return newPluginState;
}
function selectNextActionHandler(_a) {
    var dispatch = _a.dispatch, pluginState = _a.pluginState;
    var newIndex = pluginState.currentIndex + 1;
    var newPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { currentIndex: newIndex > pluginState.items.length - 1 ? 0 : newIndex, downKeyCount: ++pluginState.downKeyCount });
    dispatch(pluginKey, newPluginState);
    return newPluginState;
}
function itemsListUpdatedActionHandler(_a) {
    var dispatch = _a.dispatch, pluginState = _a.pluginState, tr = _a.tr;
    var items = tr.getMeta(pluginKey).items;
    var newPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { items: items, itemsLoader: null, currentIndex: pluginState.currentIndex > items.length ? 0 : pluginState.currentIndex });
    dispatch(pluginKey, newPluginState);
    return newPluginState;
}
function selectCurrentActionHandler(_a) {
    var dispatch = _a.dispatch, pluginState = _a.pluginState;
    var newPluginState = createInitialPluginState(false);
    dispatch(pluginKey, newPluginState);
    return newPluginState;
}
//# sourceMappingURL=main.js.map

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = commonFormatter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__links_link_format__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__whitespace__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keyword__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_escape__ = __webpack_require__(889);






var processState = {
    START: 0,
    BUFFER: 1,
    END: 2,
    INLINE_MACRO: 3,
    LINK_FORMAT: 4,
    ESCAPE: 5,
};
function commonFormatter(input, position, schema, opt) {
    var index = position;
    var state = processState.START;
    var buffer = '';
    var openingSymbolLength = opt.opening.length;
    var closingSymbolLength = opt.closing.length;
    while (index < input.length) {
        var char = input.charAt(index);
        var twoChar = input.substr(index, 2);
        var charsMatchClosingSymbol = input.substr(index, closingSymbolLength);
        switch (state) {
            case processState.START: {
                if (position > 0) {
                    /**
                     * If the previous char is a alphanumeric, then it's not a valid
                     * formatter
                     */
                    var charBeforeOpening = input.charAt(position - 1);
                    if (/[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charBeforeOpening)) {
                        return fallback(input, index, openingSymbolLength);
                    }
                }
                var charAfterOpening = input.charAt(index + openingSymbolLength);
                if (!input.substring(position).startsWith(opt.opening) ||
                    charAfterOpening === ' ') {
                    // this is not a valid formatter mark
                    return fallback(input, position, openingSymbolLength);
                }
                state = processState.BUFFER;
                index += openingSymbolLength;
                continue;
            }
            case processState.BUFFER: {
                // the linebreak would break the strong marks
                var length_1 = Object(__WEBPACK_IMPORTED_MODULE_2__whitespace__["a" /* parseNewlineOnly */])(input.substring(index));
                if (length_1) {
                    return fallback(input, position, openingSymbolLength);
                }
                if (charsMatchClosingSymbol === opt.closing) {
                    state = processState.END;
                    continue;
                }
                else if (twoChar === '{{') {
                    // this is a monospace
                    buffer += twoChar;
                    index += 2;
                    continue;
                }
                else if (char === '{') {
                    state = processState.INLINE_MACRO;
                    continue;
                }
                else if (char === '[') {
                    state = processState.LINK_FORMAT;
                    continue;
                }
                else if (char === '\\') {
                    state = processState.ESCAPE;
                    continue;
                }
                else {
                    buffer += char;
                }
                break;
            }
            case processState.END: {
                index += closingSymbolLength;
                // empty formatter mark is treated as normal text
                if (buffer.length === 0) {
                    return fallback(input, position, openingSymbolLength);
                }
                /**
                 * If the closing symbol is followed by a alphanumeric, it's
                 * not a valid formatter, and we keep looking for
                 * next valid closing formatter
                 */
                if (index < input.length) {
                    var charAfterEnd = input.charAt(index);
                    if (/[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charAfterEnd)) {
                        buffer += charsMatchClosingSymbol;
                        state = processState.BUFFER;
                        continue;
                    }
                }
                /**
                 * If the closing symbol has an empty space before it,
                 * it's not a valid formatter
                 */
                if (buffer.endsWith(' ')) {
                    return fallback(input, position, openingSymbolLength);
                }
                return opt.rawContentProcessor(buffer, index - position);
            }
            case processState.INLINE_MACRO: {
                var match = Object(__WEBPACK_IMPORTED_MODULE_3__keyword__["b" /* parseMacroKeyword */])(input.substring(index));
                if (!match) {
                    buffer += char;
                    state = processState.BUFFER;
                    break;
                }
                var token = Object(__WEBPACK_IMPORTED_MODULE_4____["b" /* parseToken */])(input, match.type, index, schema);
                if (token.type === 'text') {
                    buffer += token.text;
                    index += token.length;
                    state = processState.BUFFER;
                    continue;
                }
                else if (match.type === __WEBPACK_IMPORTED_MODULE_0____["a" /* TokenType */].COLOR_MACRO) {
                    /**
                     * {color} is valid in formatter, we simply jump over the length
                     */
                    buffer += input.substr(index, token.length);
                    index += token.length;
                    state = processState.BUFFER;
                    continue;
                }
                else {
                    // No macro are accepted in formater
                    return fallback(input, position, openingSymbolLength);
                }
            }
            case processState.LINK_FORMAT: {
                /**
                 * We should "fly over" the link format and we dont want
                 * -awesome [link|https://www.atlass-ian.com] nice
                 * to be a strike through because of the '-' in link
                 */
                var token = Object(__WEBPACK_IMPORTED_MODULE_1__links_link_format__["a" /* linkFormat */])(input, index, schema);
                if (token.type === 'text') {
                    buffer += token.text;
                    index += token.length;
                    state = processState.BUFFER;
                    continue;
                }
                else if (token.type === 'pmnode') {
                    buffer += input.substr(index, token.length);
                    index += token.length;
                    state = processState.BUFFER;
                    continue;
                }
                return fallback(input, position, openingSymbolLength);
            }
            case processState.ESCAPE: {
                var token = Object(__WEBPACK_IMPORTED_MODULE_5__utils_escape__["a" /* escapeHandler */])(input, index);
                buffer += token.text;
                index += token.length;
                state = processState.BUFFER;
                continue;
            }
            default:
        }
        index++;
    }
    return fallback(input, position, openingSymbolLength);
}
function fallback(input, position, length) {
    return {
        type: 'text',
        text: input.substr(position, length),
        length: length,
    };
}
//# sourceMappingURL=common-formatter.js.map

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__react__ = __webpack_require__(2964);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__react__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__text__ = __webpack_require__(3122);
/* unused harmony reexport TextSerializer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__email__ = __webpack_require__(3137);
/* unused harmony reexport EmailSerializer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Renderer__ = __webpack_require__(3164);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__ui_Renderer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(144);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__utils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__render_document__ = __webpack_require__(3166);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__render_document__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__render_document__["b"]; });






//# sourceMappingURL=index.js.map

/***/ }),
/* 110 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Item__ = __webpack_require__(2165);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Item__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ItemGroup__ = __webpack_require__(2168);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__components_ItemGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_hoc_withItemClick__ = __webpack_require__(2171);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__components_hoc_withItemClick__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_hoc_withItemFocus__ = __webpack_require__(2172);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__components_hoc_withItemFocus__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_theme__ = __webpack_require__(272);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__util_theme__["e"]; });






/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
// CommonJS / Node have global context exposed as "global" variable.
// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
// the global "global" var for now.
var __window = typeof window !== 'undefined' && window;
var __self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' &&
    self instanceof WorkerGlobalScope && self;
var __global = typeof global !== 'undefined' && global;
var _root = __window || __global || __self;
exports.root = _root;
// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
// This is needed when used with angular/tsickle which inserts a goog.module statement.
// Wrap in IIFE
(function () {
    if (!_root) {
        throw new Error('RxJS could not find any global context (window, self, global)');
    }
})();
//# sourceMappingURL=root.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["i"] = preventDefault;
/* harmony export (immutable) */ __webpack_exports__["f"] = insertNewLine;
/* harmony export (immutable) */ __webpack_exports__["h"] = insertRule;
/* harmony export (immutable) */ __webpack_exports__["j"] = shouldAppendParagraphAfterBlockNode;
/* harmony export (immutable) */ __webpack_exports__["g"] = insertNodesEndWithNewParagraph;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createNewParagraphAbove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createNewParagraphBelow; });
/* harmony export (immutable) */ __webpack_exports__["e"] = createParagraphNear;
/* harmony export (immutable) */ __webpack_exports__["d"] = createParagraphAtEnd;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeImageAlignment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return toggleBlockMark; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(21);




function preventDefault() {
    return function (state, dispatch) {
        return true;
    };
}
function insertNewLine() {
    return function (state, dispatch) {
        var $from = state.selection.$from;
        var parent = $from.parent;
        var hardBreak = state.schema.nodes.hardBreak;
        if (hardBreak) {
            var hardBreakNode = hardBreak.create();
            if (parent && parent.type.validContent(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(hardBreakNode))) {
                if (dispatch) {
                    dispatch(state.tr.replaceSelectionWith(hardBreakNode));
                }
                return true;
            }
        }
        if (state.selection instanceof __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["TextSelection"]) {
            if (dispatch) {
                dispatch(state.tr.insertText('\n'));
            }
            return true;
        }
        return false;
    };
}
function insertRule() {
    return function (state, dispatch) {
        var to = state.selection.to;
        var rule = state.schema.nodes.rule;
        if (rule) {
            var ruleNode = rule.create();
            if (dispatch) {
                dispatch(state.tr.insert(to + 1, ruleNode));
            }
            return true;
        }
        return false;
    };
}
function shouldAppendParagraphAfterBlockNode(state) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* atTheEndOfDoc */])(state) && Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* atTheBeginningOfBlock */])(state);
}
function insertNodesEndWithNewParagraph(nodes) {
    return function (state, dispatch) {
        var tr = state.tr, schema = state.schema;
        var paragraph = schema.nodes.paragraph;
        var head = state.selection.head;
        if (shouldAppendParagraphAfterBlockNode(state)) {
            nodes.push(paragraph.create());
        }
        /** If table cell, the default is to move to the next cell, override to select paragraph */
        tr.replaceSelection(new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"](__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(nodes), 0, 0));
        if (Object(__WEBPACK_IMPORTED_MODULE_3__utils__["A" /* isTableCell */])(state)) {
            tr.setSelection(__WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["TextSelection"].create(state.doc, head, head));
        }
        if (dispatch) {
            dispatch(tr);
        }
        return true;
    };
}
var createNewParagraphAbove = function (state, dispatch) {
    var append = false;
    if (!Object(__WEBPACK_IMPORTED_MODULE_3__utils__["h" /* canMoveUp */])(state) && canCreateParagraphNear(state)) {
        createParagraphNear(append)(state, dispatch);
        return true;
    }
    return false;
};
var createNewParagraphBelow = function (state, dispatch) {
    var append = true;
    if (!Object(__WEBPACK_IMPORTED_MODULE_3__utils__["g" /* canMoveDown */])(state) && canCreateParagraphNear(state)) {
        createParagraphNear(append)(state, dispatch);
        return true;
    }
    return false;
};
function canCreateParagraphNear(state) {
    var $from = state.selection.$from;
    var node = $from.node($from.depth);
    var insideCodeBlock = !!node && node.type === state.schema.nodes.codeBlock;
    var isNodeSelection = state.selection instanceof __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["NodeSelection"];
    return $from.depth > 1 || isNodeSelection || insideCodeBlock;
}
function createParagraphNear(append) {
    if (append === void 0) { append = true; }
    return function (state, dispatch) {
        var paragraph = state.schema.nodes.paragraph;
        if (!paragraph) {
            return false;
        }
        var insertPos;
        if (state.selection instanceof __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["TextSelection"]) {
            if (topLevelNodeIsEmptyTextBlock(state)) {
                return false;
            }
            insertPos = getInsertPosFromTextBlock(state, append);
        }
        else {
            insertPos = getInsertPosFromNonTextBlock(state, append);
        }
        var tr = state.tr.insert(insertPos, paragraph.createAndFill());
        tr.setSelection(__WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["TextSelection"].create(tr.doc, insertPos + 1));
        if (dispatch) {
            dispatch(tr);
        }
        return true;
    };
}
function getInsertPosFromTextBlock(state, append) {
    var _a = state.selection, $from = _a.$from, $to = _a.$to;
    var pos;
    if (!append) {
        pos = $from.start(0);
    }
    else {
        pos = $to.end(0);
    }
    return pos;
}
function getInsertPosFromNonTextBlock(state, append) {
    var _a = state.selection, $from = _a.$from, $to = _a.$to;
    var nodeAtSelection = state.selection instanceof __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["NodeSelection"] &&
        state.doc.nodeAt(state.selection.$anchor.pos);
    var isMediaSelection = nodeAtSelection && nodeAtSelection.type.name === 'mediaGroup';
    var pos;
    if (!append) {
        // The start position is different with text block because it starts from 0
        pos = $from.start($from.depth);
        // The depth is different with text block because it starts from 0
        pos = $from.depth > 0 && !isMediaSelection ? pos - 1 : pos;
    }
    else {
        pos = $to.end($to.depth);
        pos = $to.depth > 0 && !isMediaSelection ? pos + 1 : pos;
    }
    return pos;
}
function topLevelNodeIsEmptyTextBlock(state) {
    var topLevelNode = state.selection.$from.node(1);
    return (topLevelNode.isTextblock &&
        topLevelNode.type !== state.schema.nodes.codeBlock &&
        topLevelNode.nodeSize === 2);
}
function createParagraphAtEnd() {
    return function (state, dispatch) {
        var doc = state.doc, tr = state.tr, nodes = state.schema.nodes;
        if (doc.lastChild &&
            !(doc.lastChild.type === nodes.paragraph &&
                doc.lastChild.content.size === 0)) {
            tr.insert(doc.content.size, nodes.paragraph.createAndFill());
        }
        tr.setSelection(__WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["TextSelection"].create(tr.doc, tr.doc.content.size - 1));
        tr.scrollIntoView();
        if (dispatch) {
            dispatch(tr);
        }
        return true;
    };
}
var changeImageAlignment = function (align) { return function (state, dispatch) {
    var _a = state.selection, from = _a.from, to = _a.to;
    var tr = state.tr;
    state.doc.nodesBetween(from, to, function (node, pos, parent) {
        if (node.type === state.schema.nodes.mediaSingle) {
            tr.setNodeMarkup(pos, undefined, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, node.attrs, { layout: align === 'center' ? 'center' : "align-" + align }));
        }
    });
    if (tr.docChanged && dispatch) {
        dispatch(tr.scrollIntoView());
        return true;
    }
    return false;
}; };
/**
 * Toggles block mark based on the return type of `getAttrs`.
 * This is similar to ProseMirror's `getAttrs` from `AttributeSpec`
 * return `false` to remove the mark.
 * return `undefined for no-op.
 * return an `object` to update the mark.
 */
var toggleBlockMark = function (markType, getAttrs, allowedBlocks) { return function (state, dispatch) {
    var _a = state.selection, from = _a.from, to = _a.to;
    var markApplied = false;
    var tr = state.tr;
    state.doc.nodesBetween(from, to, function (node, pos, parent) {
        if (!node.type.isBlock) {
            return false;
        }
        if ((!allowedBlocks ||
            (Array.isArray(allowedBlocks)
                ? allowedBlocks.indexOf(node.type) > -1
                : allowedBlocks(state.schema, node, parent))) &&
            parent.type.allowsMarkType(markType)) {
            var oldMarks = node.marks.filter(function (mark) { return mark.type === markType; });
            var newAttrs = getAttrs(oldMarks.length ? oldMarks[0].attrs : undefined);
            if (newAttrs !== undefined) {
                tr.setNodeMarkup(pos, node.type, node.attrs, node.marks
                    .filter(function (mark) { return !markType.excludes(mark.type); })
                    .concat(newAttrs === false ? [] : markType.create(newAttrs)));
                markApplied = true;
            }
        }
    });
    if (markApplied && tr.docChanged) {
        if (dispatch) {
            dispatch(tr.scrollIntoView());
        }
        return true;
    }
    return false;
}; };
//# sourceMappingURL=index.js.map

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluginKey; });
/* unused harmony export createPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);


var pluginKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('widthPlugin');
function createPlugin(dispatch) {
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        key: pluginKey,
        state: {
            init: function () { return ({
                width: document.body.offsetWidth,
            }); },
            apply: function (tr, pluginState) {
                var meta = tr.getMeta(pluginKey);
                if (!meta) {
                    return pluginState;
                }
                var newPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, meta);
                if (newPluginState &&
                    (pluginState.width !== newPluginState.width ||
                        pluginState.lineLength !== newPluginState.lineLength)) {
                    dispatch(pluginKey, newPluginState);
                    return newPluginState;
                }
                return pluginState;
            },
        },
    });
}
var widthPlugin = {
    pmPlugins: function () { return [
        {
            name: 'width',
            plugin: function (_a) {
                var dispatch = _a.dispatch;
                return createPlugin(dispatch);
            },
        },
    ]; },
    // do this early here, otherwise we have to wait for WidthEmitter to debounce
    // which causes anything dependent on lineLength to jump around
    contentComponent: function (_a) {
        var editorView = _a.editorView, containerElement = _a.containerElement;
        var pmDom = containerElement
            ? containerElement.querySelector('.ProseMirror')
            : undefined;
        var tr = editorView.state.tr.setMeta(pluginKey, {
            lineLength: pmDom ? pmDom.clientWidth : undefined,
        });
        editorView.dispatch(tr);
        return null;
    },
};
/* harmony default export */ __webpack_exports__["a"] = (widthPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LINK_REGEXP */
/* harmony export (immutable) */ __webpack_exports__["b"] = getLinkMatch;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkMatcher; });
/* harmony export (immutable) */ __webpack_exports__["e"] = normalizeUrl;
/* harmony export (immutable) */ __webpack_exports__["c"] = linkifyContent;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return linkifyMatch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_linkify_it__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_linkify_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_linkify_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_slice__ = __webpack_require__(104);


var LINK_REGEXP = /(https?|ftp):\/\/[^\s]+/;
var linkify = __WEBPACK_IMPORTED_MODULE_0_linkify_it__();
linkify.add('sourcetree:', 'http:');
var tlds = 'biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф'.split('|');
var tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
tlds.push(tlds2Char);
linkify.tlds(tlds, false);
function getLinkMatch(str) {
    if (!str) {
        return null;
    }
    var match = linkifyMatch(str);
    if (!match.length) {
        match = linkify.match(str);
    }
    return match && match[0];
}
/**
 * Instance of class LinkMatcher are used in autoformatting in place of Regex.
 * Hence it has been made similar to regex with an exec method.
 * Extending it directly from class Regex was introducing some issues, thus that has been avoided.
 */
var LinkMatcher = /** @class */ (function () {
    function LinkMatcher() {
    }
    LinkMatcher.prototype.exec = function (str) {
        if (str.endsWith(' ')) {
            var chunks = str.slice(0, str.length - 1).split(' ');
            var lastChunk = chunks[chunks.length - 1];
            var links = linkify.match(lastChunk);
            if (links && links.length > 0) {
                var lastLink = links[links.length - 1];
                lastLink.input = lastChunk;
                lastLink.length = lastLink.lastIndex - lastLink.index + 1;
                return [lastLink];
            }
        }
        return null;
    };
    return LinkMatcher;
}());

/**
 * Adds protocol to url if needed.
 */
function normalizeUrl(url) {
    if (LINK_REGEXP.test(url)) {
        return url;
    }
    var match = getLinkMatch(url);
    return (match && match.url) || url;
}
function linkifyContent(schema, slice) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__utils_slice__["e" /* mapSlice */])(slice, function (node, parent) {
        var isAllowedInParent = !parent || parent.type !== schema.nodes.codeBlock;
        if (isAllowedInParent && node.isText) {
            var linkified_1 = [];
            var link_1 = node.type.schema.marks['link'];
            var text = node.text;
            var matches = findLinkMatches(text);
            var pos_1 = 0;
            matches.forEach(function (match) {
                if (match.start > 0) {
                    linkified_1.push(node.cut(pos_1, match.start));
                }
                linkified_1.push(node
                    .cut(match.start, match.end)
                    .mark(link_1
                    .create({ href: normalizeUrl(match.href) })
                    .addToSet(node.marks)));
                pos_1 = match.end;
            });
            if (pos_1 < text.length) {
                linkified_1.push(node.cut(pos_1));
            }
            return linkified_1;
        }
        return node;
    });
}
function findLinkMatches(text) {
    var matches = [];
    var linkMatches = text && linkify.match(text);
    if (linkMatches && linkMatches.length > 0) {
        linkMatches.forEach(function (match) {
            matches.push({
                start: match.index,
                end: match.lastIndex,
                title: match.raw,
                href: match.url,
            });
        });
    }
    return matches;
}
var linkifyMatch = function (text) {
    var matches = [];
    if (!LINK_REGEXP.test(text)) {
        return matches;
    }
    var startpos = 0;
    var substr;
    while ((substr = text.substr(startpos))) {
        var link = (substr.match(LINK_REGEXP) || [''])[0];
        if (link) {
            var index = substr.search(LINK_REGEXP);
            var start = index >= 0 ? index + startpos : index;
            var end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: '',
            });
            startpos += end;
        }
        else {
            break;
        }
    }
    return matches;
};
//# sourceMappingURL=utils.js.map

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearUserCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setUserCheckResults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearAccessBotResults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clearUserStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getUserAccessStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return triggerAccessBot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkUserExists; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url_join__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_url_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_index_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(73);
var clearUserCheck=Object(__WEBPACK_IMPORTED_MODULE_1__util_index_js__["b" /* createAction */])('CLEAR_USER_CHECK',{noPayload:true});var setUserCheckResults=Object(__WEBPACK_IMPORTED_MODULE_1__util_index_js__["b" /* createAction */])('SET_USER_CHECK_RESUTS');var clearAccessBotResults=Object(__WEBPACK_IMPORTED_MODULE_1__util_index_js__["b" /* createAction */])('CLEAR_ACCESS_BOT_RESULTS');var clearUserStatus=Object(__WEBPACK_IMPORTED_MODULE_1__util_index_js__["b" /* createAction */])('CLEAR_USER_STATUS');var api=__WEBPACK_IMPORTED_MODULE_0_url_join___default.a.bind(null,__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].apiUrl);var getUserAccessStatus=Object(__WEBPACK_IMPORTED_MODULE_1__util_index_js__["a" /* asyncAction */])({baseName:'getUserAccessStatus',action:function action(_action){return function(username){return function(dispatch){dispatch(_action.start());return __WEBPACK_IMPORTED_MODULE_1__util_index_js__["d" /* http */].get(api('/ssp/access/status?user='+username)).then(function(appStatus){dispatch(_action.success(appStatus));}).catch(function(err){console.error('error getting api response',err);dispatch(_action.error(err));});};};}});var triggerAccessBot=Object(__WEBPACK_IMPORTED_MODULE_1__util_index_js__["a" /* asyncAction */])({baseName:'triggerAccessBot',action:function action(_action2){return function(username,app){return function(dispatch){dispatch(_action2.start());return __WEBPACK_IMPORTED_MODULE_1__util_index_js__["d" /* http */].get(api('/ssp/access/?user='+username+'&app='+app)).then(function(botResults){dispatch(_action2.success(botResults));dispatch(getUserAccessStatus(username));}).catch(function(err){console.error('error getting api response',err);dispatch(_action2.error(err));});};};}});var checkUserExists=Object(__WEBPACK_IMPORTED_MODULE_1__util_index_js__["a" /* asyncAction */])({baseName:'checkUserExists',action:function action(_action3){return function(user){return function(dispatch){dispatch(_action3.start());return __WEBPACK_IMPORTED_MODULE_1__util_index_js__["d" /* http */].get(api('/ssp/user/check?user='+user)).then(function(checkResults){dispatch(_action3.success(checkResults));}).catch(function(err){console.error('error getting api response',err);dispatch(_action3.error(err));});};};}});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(110);
var core = __webpack_require__(95);
var ctx = __webpack_require__(530);
var hide = __webpack_require__(145);
var has = __webpack_require__(129);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export enableLogger */
/* unused harmony export enableStacktraces */
/* unused harmony export logStacktrace */
/* harmony export (immutable) */ __webpack_exports__["a"] = debug;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

var debugEnabled = false;
var stacktracesEnabled = false;
function enableLogger(enable) {
    debugEnabled = enable;
}
function enableStacktraces(enable) {
    stacktracesEnabled = enable;
}
function logStacktrace() {
    if (stacktracesEnabled) {
        // tslint:disable-next-line:no-console
        console.log(new Error().stack);
    }
}
function debug(msg) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (debugEnabled) {
        // tslint:disable-next-line:no-console
        console.log.apply(console, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"]([msg], args));
    }
}
//# sourceMappingURL=logger.js.map

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export enableLogger */
/* unused harmony export enableStacktraces */
/* unused harmony export logStacktrace */
/* harmony export (immutable) */ __webpack_exports__["a"] = debug;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

var debugEnabled = false;
var stacktracesEnabled = false;
function enableLogger(enable) {
    debugEnabled = enable;
}
function enableStacktraces(enable) {
    stacktracesEnabled = enable;
}
function logStacktrace() {
    if (stacktracesEnabled) {
        // tslint:disable-next-line:no-console
        console.log(new Error().stack);
    }
}
function debug(msg) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (debugEnabled) {
        // tslint:disable-next-line:no-console
        console.log.apply(console, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"]([msg], args));
    }
}
//# sourceMappingURL=logger.js.map

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export enableLogger */
/* unused harmony export enableStacktraces */
/* unused harmony export logStacktrace */
/* harmony export (immutable) */ __webpack_exports__["a"] = debug;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

var debugEnabled = false;
var stacktracesEnabled = false;
function enableLogger(enable) {
    debugEnabled = enable;
}
function enableStacktraces(enable) {
    stacktracesEnabled = enable;
}
function logStacktrace() {
    if (stacktracesEnabled) {
        // tslint:disable-next-line:no-console
        console.log(new Error().stack);
    }
}
function debug(msg) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (debugEnabled) {
        // tslint:disable-next-line:no-console
        console.log.apply(console, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"]([msg], args));
    }
}
//# sourceMappingURL=logger.js.map

/***/ }),
/* 122 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(177);
var IE8_DOM_DEFINE = __webpack_require__(604);
var toPrimitive = __webpack_require__(358);
var dP = Object.defineProperty;

exports.f = __webpack_require__(124) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(153)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return messages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return NORMAL_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HEADING_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return HEADING_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return HEADING_3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return HEADING_4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return HEADING_5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return HEADING_6; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BLOCK_QUOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CODE_BLOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PANEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return OTHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return TEXT_BLOCK_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return WRAPPER_BLOCK_TYPES; });
/* unused harmony export ALL_BLOCK_TYPES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HEADINGS_BY_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HEADINGS_BY_NAME; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(17);
// The names of the blocks don't map precisely to schema nodes, because
// of concepts like "paragraph" <-> "Normal text" and "Unknown".
//
// (there are also different blocks for different types of panel, when
// they're really all just a panel node)
//
// Rather than half-match half-not, this plugin introduces its own
// nomenclature for what 'block type' is active.

var messages = Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["defineMessages"])({
    normal: {
        id: 'fabric.editor.normal',
        defaultMessage: 'Normal text',
        description: 'This is the default text style',
    },
    heading1: {
        id: 'fabric.editor.heading1',
        defaultMessage: 'Heading 1',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)',
    },
    heading2: {
        id: 'fabric.editor.heading2',
        defaultMessage: 'Heading 2',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)',
    },
    heading3: {
        id: 'fabric.editor.heading3',
        defaultMessage: 'Heading 3',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)',
    },
    heading4: {
        id: 'fabric.editor.heading4',
        defaultMessage: 'Heading 4',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)',
    },
    heading5: {
        id: 'fabric.editor.heading5',
        defaultMessage: 'Heading 5',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)',
    },
    heading6: {
        id: 'fabric.editor.heading6',
        defaultMessage: 'Heading 6',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)',
    },
    blockquote: {
        id: 'fabric.editor.blockquote',
        defaultMessage: 'Block quote',
        description: 'Quote some text',
    },
    codeblock: {
        id: 'fabric.editor.codeblock',
        defaultMessage: 'Code block',
        description: 'Insert a block of code (code snippet)',
    },
    panel: {
        id: 'fabric.editor.panel',
        defaultMessage: 'Panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)',
    },
    notePanel: {
        id: 'fabric.editor.notePanel',
        defaultMessage: 'Note panel',
        description: 'Visually distinguishes your text by adding a note panel',
    },
    successPanel: {
        id: 'fabric.editor.successPanel',
        defaultMessage: 'Success panel',
        description: 'Visually distinguishes your text by adding a success panel',
    },
    warningPanel: {
        id: 'fabric.editor.warningPanel',
        defaultMessage: 'Warning panel',
        description: 'Visually distinguishes your text by adding a warning panel',
    },
    errorPanel: {
        id: 'fabric.editor.errorPanel',
        defaultMessage: 'Error panel',
        description: 'Visually distinguishes your text by adding a error panel',
    },
    other: {
        id: 'fabric.editor.other',
        defaultMessage: 'Others...',
        description: 'Other text formatting',
    },
});
var NORMAL_TEXT = {
    name: 'normal',
    title: messages.normal,
    nodeName: 'paragraph',
    tagName: 'p',
};
var HEADING_1 = {
    name: 'heading1',
    title: messages.heading1,
    nodeName: 'heading',
    tagName: 'h1',
    level: 1,
};
var HEADING_2 = {
    name: 'heading2',
    title: messages.heading2,
    nodeName: 'heading',
    tagName: 'h2',
    level: 2,
};
var HEADING_3 = {
    name: 'heading3',
    title: messages.heading3,
    nodeName: 'heading',
    tagName: 'h3',
    level: 3,
};
var HEADING_4 = {
    name: 'heading4',
    title: messages.heading4,
    nodeName: 'heading',
    tagName: 'h4',
    level: 4,
};
var HEADING_5 = {
    name: 'heading5',
    title: messages.heading5,
    nodeName: 'heading',
    tagName: 'h5',
    level: 5,
};
var HEADING_6 = {
    name: 'heading6',
    title: messages.heading6,
    nodeName: 'heading',
    tagName: 'h6',
    level: 6,
};
var BLOCK_QUOTE = {
    name: 'blockquote',
    title: messages.blockquote,
    nodeName: 'blockquote',
};
var CODE_BLOCK = {
    name: 'codeblock',
    title: messages.codeblock,
    nodeName: 'codeBlock',
};
var PANEL = {
    name: 'panel',
    title: messages.panel,
    nodeName: 'panel',
};
var OTHER = {
    name: 'other',
    title: messages.other,
    nodeName: '',
};
var TEXT_BLOCK_TYPES = [
    NORMAL_TEXT,
    HEADING_1,
    HEADING_2,
    HEADING_3,
    HEADING_4,
    HEADING_5,
    HEADING_6,
];
var WRAPPER_BLOCK_TYPES = [BLOCK_QUOTE, CODE_BLOCK, PANEL];
var ALL_BLOCK_TYPES = TEXT_BLOCK_TYPES.concat(WRAPPER_BLOCK_TYPES);
var HEADINGS_BY_LEVEL = TEXT_BLOCK_TYPES.reduce(function (acc, blockType) {
    if (blockType.level && blockType.nodeName === 'heading') {
        acc[blockType.level] = blockType;
    }
    return acc;
}, {});
var HEADINGS_BY_NAME = TEXT_BLOCK_TYPES.reduce(function (acc, blockType) {
    if (blockType.level && blockType.nodeName === 'heading') {
        acc[blockType.name] = blockType;
    }
    return acc;
}, {});
//# sourceMappingURL=types.js.map

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(1443);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(1446);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__createHashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(1447);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(250);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(185);
/* unused harmony reexport parsePath */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__PathUtils__["b"]; });










/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (name, context, definition) {
  if (typeof module !== 'undefined' && module.exports) module.exports = definition();
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  else context[name] = definition();
})('urljoin', this, function () {

  function startsWith(str, searchString) {
    return str.substr(0, searchString.length) === searchString;
  }

  function normalize (str, options) {

    if (startsWith(str, 'file://')) {

      // make sure file protocol has max three slashes
      str = str.replace(/(\/{0,3})\/*/g, '$1');
    } else {

      // make sure protocol is followed by two slashes
      str = str.replace(/:\//g, '://');

      // remove consecutive slashes
      str = str.replace(/([^:\s\%\3\A])\/+/g, '$1/');
    }

    // remove trailing slash before parameters or hash
    str = str.replace(/\/(\?|&|#[^!])/g, '$1');

    // replace ? in parameters with &
    str = str.replace(/(\?.+)\?/g, '$1&');

    return str;
  }

  return function () {
    var input = arguments;
    var options = {};

    if (typeof arguments[0] === 'object') {
      // new syntax with array and options
      input = arguments[0];
      options = arguments[1] || {};
    }

    var joined = [].slice.call(input, 0).join('/');
    return normalize(joined, options);
  };

});


/***/ }),
/* 129 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__propertyUtils__ = __webpack_require__(1543);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;

var getComputedStyleX = void 0;

// https://stackoverflow.com/a/3485654/3040605
function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line
  elem.style.display = originalStyle;
}

function css(el, name, v) {
  var value = v;
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = value + 'px';
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}

function getClientPosition(elem) {
  var box = void 0;
  var x = void 0;
  var y = void 0;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top;

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;

  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}

function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }
  if (node.nodeType === 9) {
    return node;
  }
  return node.ownerDocument;
}

function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;

    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}

if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }
  return option.useCssBottom ? 'bottom' : dir;
}

function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
}

// 设置 elem 相对 elem.ownerDocument 的坐标
function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }
  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);

  if (horizontalProperty !== 'left') {
    presetH = 999;
  }

  if (verticalProperty !== 'top') {
    presetV = 999;
  }
  var originalTransition = '';
  var originalOffset = getOffset(elem);
  if ('left' in offset || 'top' in offset) {
    originalTransition = Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["c" /* getTransitionProperty */])(elem) || '';
    Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["e" /* setTransitionProperty */])(elem, 'none');
  }
  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = presetH + 'px';
  }
  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = presetV + 'px';
  }
  // force relayout
  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};
  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];
      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }
  css(elem, originalStyle);
  // force relayout
  forceRelayout(elem);
  if ('left' in offset || 'top' in offset) {
    Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["e" /* setTransitionProperty */])(elem, originalTransition);
  }
  var ret = {};
  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);
      var _off = offset[_key] - originalOffset[_key];
      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }
  css(elem, ret);
}

function setTransform(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["b" /* getTransformXY */])(elem);
  var resultXY = { x: originalXY.x, y: originalXY.y };
  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }
  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["d" /* setTransformXY */])(elem, resultXY);
}

function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);

    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);

    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }

  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["a" /* getTransformName */])() in document.body.style) {
    setTransform(elem, offset, option);
  } else {
    setLeftTop(elem, offset, option);
  }
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name = void 0;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop = void 0;
  var j = void 0;
  var i = void 0;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;
        if (prop === 'border') {
          cssProp = '' + prop + which[i] + 'Width';
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}

var domUtils = {};

each(['Width', 'Height'], function (name) {
  domUtils['doc' + name] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement['scroll' + name],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body['scroll' + name], domUtils['viewport' + name](d));
  };

  domUtils['viewport' + name] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = 'client' + name;
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, ex) {
  var extra = ex;
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem, computedStyle);
  var cssBoxValue = 0;
  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
    }
    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }
    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle));
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var val = void 0;
  var elem = args[0];
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils['outer' + first] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, v) {
    var val = v;
    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }
  return to;
}

var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },

  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },

  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i = void 0;
    var ret = {};
    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },

  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};

    for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
      args[_key3] = arguments[_key3];
    }

    for (var i = 0; i < args.length; i++) {
      utils.mix(ret, args[i]);
    }
    return ret;
  },

  viewportWidth: 0,
  viewportHeight: 0
};

mix(utils, domUtils);

/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

// This is CodeMirror (https://codemirror.net), a code editor
// implemented in JavaScript on top of the browser's DOM.
//
// You can find some technical background for some of the code below
// at http://marijnhaverbeke.nl/blog/#cm-internals .

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.CodeMirror = factory());
}(this, (function () { 'use strict';

  // Kludges for bugs and behavior differences that can't be feature
  // detected are enabled based on userAgent etc sniffing.
  var userAgent = navigator.userAgent;
  var platform = navigator.platform;

  var gecko = /gecko\/\d/i.test(userAgent);
  var ie_upto10 = /MSIE \d/.test(userAgent);
  var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent);
  var edge = /Edge\/(\d+)/.exec(userAgent);
  var ie = ie_upto10 || ie_11up || edge;
  var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : +(edge || ie_11up)[1]);
  var webkit = !edge && /WebKit\//.test(userAgent);
  var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent);
  var chrome = !edge && /Chrome\//.test(userAgent);
  var presto = /Opera\//.test(userAgent);
  var safari = /Apple Computer/.test(navigator.vendor);
  var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent);
  var phantom = /PhantomJS/.test(userAgent);

  var ios = !edge && /AppleWebKit/.test(userAgent) && /Mobile\/\w+/.test(userAgent);
  var android = /Android/.test(userAgent);
  // This is woefully incomplete. Suggestions for alternative methods welcome.
  var mobile = ios || android || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent);
  var mac = ios || /Mac/.test(platform);
  var chromeOS = /\bCrOS\b/.test(userAgent);
  var windows = /win/i.test(platform);

  var presto_version = presto && userAgent.match(/Version\/(\d*\.\d*)/);
  if (presto_version) { presto_version = Number(presto_version[1]); }
  if (presto_version && presto_version >= 15) { presto = false; webkit = true; }
  // Some browsers use the wrong event properties to signal cmd/ctrl on OS X
  var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11));
  var captureRightClick = gecko || (ie && ie_version >= 9);

  function classTest(cls) { return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*") }

  var rmClass = function(node, cls) {
    var current = node.className;
    var match = classTest(cls).exec(current);
    if (match) {
      var after = current.slice(match.index + match[0].length);
      node.className = current.slice(0, match.index) + (after ? match[1] + after : "");
    }
  };

  function removeChildren(e) {
    for (var count = e.childNodes.length; count > 0; --count)
      { e.removeChild(e.firstChild); }
    return e
  }

  function removeChildrenAndAdd(parent, e) {
    return removeChildren(parent).appendChild(e)
  }

  function elt(tag, content, className, style) {
    var e = document.createElement(tag);
    if (className) { e.className = className; }
    if (style) { e.style.cssText = style; }
    if (typeof content == "string") { e.appendChild(document.createTextNode(content)); }
    else if (content) { for (var i = 0; i < content.length; ++i) { e.appendChild(content[i]); } }
    return e
  }
  // wrapper for elt, which removes the elt from the accessibility tree
  function eltP(tag, content, className, style) {
    var e = elt(tag, content, className, style);
    e.setAttribute("role", "presentation");
    return e
  }

  var range;
  if (document.createRange) { range = function(node, start, end, endNode) {
    var r = document.createRange();
    r.setEnd(endNode || node, end);
    r.setStart(node, start);
    return r
  }; }
  else { range = function(node, start, end) {
    var r = document.body.createTextRange();
    try { r.moveToElementText(node.parentNode); }
    catch(e) { return r }
    r.collapse(true);
    r.moveEnd("character", end);
    r.moveStart("character", start);
    return r
  }; }

  function contains(parent, child) {
    if (child.nodeType == 3) // Android browser always returns false when child is a textnode
      { child = child.parentNode; }
    if (parent.contains)
      { return parent.contains(child) }
    do {
      if (child.nodeType == 11) { child = child.host; }
      if (child == parent) { return true }
    } while (child = child.parentNode)
  }

  function activeElt() {
    // IE and Edge may throw an "Unspecified Error" when accessing document.activeElement.
    // IE < 10 will throw when accessed while the page is loading or in an iframe.
    // IE > 9 and Edge will throw when accessed in an iframe if document.body is unavailable.
    var activeElement;
    try {
      activeElement = document.activeElement;
    } catch(e) {
      activeElement = document.body || null;
    }
    while (activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement)
      { activeElement = activeElement.shadowRoot.activeElement; }
    return activeElement
  }

  function addClass(node, cls) {
    var current = node.className;
    if (!classTest(cls).test(current)) { node.className += (current ? " " : "") + cls; }
  }
  function joinClasses(a, b) {
    var as = a.split(" ");
    for (var i = 0; i < as.length; i++)
      { if (as[i] && !classTest(as[i]).test(b)) { b += " " + as[i]; } }
    return b
  }

  var selectInput = function(node) { node.select(); };
  if (ios) // Mobile Safari apparently has a bug where select() is broken.
    { selectInput = function(node) { node.selectionStart = 0; node.selectionEnd = node.value.length; }; }
  else if (ie) // Suppress mysterious IE10 errors
    { selectInput = function(node) { try { node.select(); } catch(_e) {} }; }

  function bind(f) {
    var args = Array.prototype.slice.call(arguments, 1);
    return function(){return f.apply(null, args)}
  }

  function copyObj(obj, target, overwrite) {
    if (!target) { target = {}; }
    for (var prop in obj)
      { if (obj.hasOwnProperty(prop) && (overwrite !== false || !target.hasOwnProperty(prop)))
        { target[prop] = obj[prop]; } }
    return target
  }

  // Counts the column offset in a string, taking tabs into account.
  // Used mostly to find indentation.
  function countColumn(string, end, tabSize, startIndex, startValue) {
    if (end == null) {
      end = string.search(/[^\s\u00a0]/);
      if (end == -1) { end = string.length; }
    }
    for (var i = startIndex || 0, n = startValue || 0;;) {
      var nextTab = string.indexOf("\t", i);
      if (nextTab < 0 || nextTab >= end)
        { return n + (end - i) }
      n += nextTab - i;
      n += tabSize - (n % tabSize);
      i = nextTab + 1;
    }
  }

  var Delayed = function() {this.id = null;};
  Delayed.prototype.set = function (ms, f) {
    clearTimeout(this.id);
    this.id = setTimeout(f, ms);
  };

  function indexOf(array, elt) {
    for (var i = 0; i < array.length; ++i)
      { if (array[i] == elt) { return i } }
    return -1
  }

  // Number of pixels added to scroller and sizer to hide scrollbar
  var scrollerGap = 30;

  // Returned or thrown by various protocols to signal 'I'm not
  // handling this'.
  var Pass = {toString: function(){return "CodeMirror.Pass"}};

  // Reused option objects for setSelection & friends
  var sel_dontScroll = {scroll: false}, sel_mouse = {origin: "*mouse"}, sel_move = {origin: "+move"};

  // The inverse of countColumn -- find the offset that corresponds to
  // a particular column.
  function findColumn(string, goal, tabSize) {
    for (var pos = 0, col = 0;;) {
      var nextTab = string.indexOf("\t", pos);
      if (nextTab == -1) { nextTab = string.length; }
      var skipped = nextTab - pos;
      if (nextTab == string.length || col + skipped >= goal)
        { return pos + Math.min(skipped, goal - col) }
      col += nextTab - pos;
      col += tabSize - (col % tabSize);
      pos = nextTab + 1;
      if (col >= goal) { return pos }
    }
  }

  var spaceStrs = [""];
  function spaceStr(n) {
    while (spaceStrs.length <= n)
      { spaceStrs.push(lst(spaceStrs) + " "); }
    return spaceStrs[n]
  }

  function lst(arr) { return arr[arr.length-1] }

  function map(array, f) {
    var out = [];
    for (var i = 0; i < array.length; i++) { out[i] = f(array[i], i); }
    return out
  }

  function insertSorted(array, value, score) {
    var pos = 0, priority = score(value);
    while (pos < array.length && score(array[pos]) <= priority) { pos++; }
    array.splice(pos, 0, value);
  }

  function nothing() {}

  function createObj(base, props) {
    var inst;
    if (Object.create) {
      inst = Object.create(base);
    } else {
      nothing.prototype = base;
      inst = new nothing();
    }
    if (props) { copyObj(props, inst); }
    return inst
  }

  var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
  function isWordCharBasic(ch) {
    return /\w/.test(ch) || ch > "\x80" &&
      (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch))
  }
  function isWordChar(ch, helper) {
    if (!helper) { return isWordCharBasic(ch) }
    if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) { return true }
    return helper.test(ch)
  }

  function isEmpty(obj) {
    for (var n in obj) { if (obj.hasOwnProperty(n) && obj[n]) { return false } }
    return true
  }

  // Extending unicode characters. A series of a non-extending char +
  // any number of extending chars is treated as a single unit as far
  // as editing and measuring is concerned. This is not fully correct,
  // since some scripts/fonts/browsers also treat other configurations
  // of code points as a group.
  var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
  function isExtendingChar(ch) { return ch.charCodeAt(0) >= 768 && extendingChars.test(ch) }

  // Returns a number from the range [`0`; `str.length`] unless `pos` is outside that range.
  function skipExtendingChars(str, pos, dir) {
    while ((dir < 0 ? pos > 0 : pos < str.length) && isExtendingChar(str.charAt(pos))) { pos += dir; }
    return pos
  }

  // Returns the value from the range [`from`; `to`] that satisfies
  // `pred` and is closest to `from`. Assumes that at least `to`
  // satisfies `pred`. Supports `from` being greater than `to`.
  function findFirst(pred, from, to) {
    // At any point we are certain `to` satisfies `pred`, don't know
    // whether `from` does.
    var dir = from > to ? -1 : 1;
    for (;;) {
      if (from == to) { return from }
      var midF = (from + to) / 2, mid = dir < 0 ? Math.ceil(midF) : Math.floor(midF);
      if (mid == from) { return pred(mid) ? from : to }
      if (pred(mid)) { to = mid; }
      else { from = mid + dir; }
    }
  }

  // The display handles the DOM integration, both for input reading
  // and content drawing. It holds references to DOM nodes and
  // display-related state.

  function Display(place, doc, input) {
    var d = this;
    this.input = input;

    // Covers bottom-right square when both scrollbars are present.
    d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler");
    d.scrollbarFiller.setAttribute("cm-not-content", "true");
    // Covers bottom of gutter when coverGutterNextToScrollbar is on
    // and h scrollbar is present.
    d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler");
    d.gutterFiller.setAttribute("cm-not-content", "true");
    // Will contain the actual code, positioned to cover the viewport.
    d.lineDiv = eltP("div", null, "CodeMirror-code");
    // Elements are added to these to represent selection and cursors.
    d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1");
    d.cursorDiv = elt("div", null, "CodeMirror-cursors");
    // A visibility: hidden element used to find the size of things.
    d.measure = elt("div", null, "CodeMirror-measure");
    // When lines outside of the viewport are measured, they are drawn in this.
    d.lineMeasure = elt("div", null, "CodeMirror-measure");
    // Wraps everything that needs to exist inside the vertically-padded coordinate system
    d.lineSpace = eltP("div", [d.measure, d.lineMeasure, d.selectionDiv, d.cursorDiv, d.lineDiv],
                      null, "position: relative; outline: none");
    var lines = eltP("div", [d.lineSpace], "CodeMirror-lines");
    // Moved around its parent to cover visible view.
    d.mover = elt("div", [lines], null, "position: relative");
    // Set to the height of the document, allowing scrolling.
    d.sizer = elt("div", [d.mover], "CodeMirror-sizer");
    d.sizerWidth = null;
    // Behavior of elts with overflow: auto and padding is
    // inconsistent across browsers. This is used to ensure the
    // scrollable area is big enough.
    d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;");
    // Will contain the gutters, if any.
    d.gutters = elt("div", null, "CodeMirror-gutters");
    d.lineGutter = null;
    // Actual scrollable element.
    d.scroller = elt("div", [d.sizer, d.heightForcer, d.gutters], "CodeMirror-scroll");
    d.scroller.setAttribute("tabIndex", "-1");
    // The element in which the editor lives.
    d.wrapper = elt("div", [d.scrollbarFiller, d.gutterFiller, d.scroller], "CodeMirror");

    // Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
    if (ie && ie_version < 8) { d.gutters.style.zIndex = -1; d.scroller.style.paddingRight = 0; }
    if (!webkit && !(gecko && mobile)) { d.scroller.draggable = true; }

    if (place) {
      if (place.appendChild) { place.appendChild(d.wrapper); }
      else { place(d.wrapper); }
    }

    // Current rendered range (may be bigger than the view window).
    d.viewFrom = d.viewTo = doc.first;
    d.reportedViewFrom = d.reportedViewTo = doc.first;
    // Information about the rendered lines.
    d.view = [];
    d.renderedView = null;
    // Holds info about a single rendered line when it was rendered
    // for measurement, while not in view.
    d.externalMeasured = null;
    // Empty space (in pixels) above the view
    d.viewOffset = 0;
    d.lastWrapHeight = d.lastWrapWidth = 0;
    d.updateLineNumbers = null;

    d.nativeBarWidth = d.barHeight = d.barWidth = 0;
    d.scrollbarsClipped = false;

    // Used to only resize the line number gutter when necessary (when
    // the amount of lines crosses a boundary that makes its width change)
    d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null;
    // Set to true when a non-horizontal-scrolling line widget is
    // added. As an optimization, line widget aligning is skipped when
    // this is false.
    d.alignWidgets = false;

    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;

    // Tracks the maximum line length so that the horizontal scrollbar
    // can be kept static when scrolling.
    d.maxLine = null;
    d.maxLineLength = 0;
    d.maxLineChanged = false;

    // Used for measuring wheel scrolling granularity
    d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null;

    // True when shift is held down.
    d.shift = false;

    // Used to track whether anything happened since the context menu
    // was opened.
    d.selForContextMenu = null;

    d.activeTouch = null;

    input.init(d);
  }

  // Find the line object corresponding to the given line number.
  function getLine(doc, n) {
    n -= doc.first;
    if (n < 0 || n >= doc.size) { throw new Error("There is no line " + (n + doc.first) + " in the document.") }
    var chunk = doc;
    while (!chunk.lines) {
      for (var i = 0;; ++i) {
        var child = chunk.children[i], sz = child.chunkSize();
        if (n < sz) { chunk = child; break }
        n -= sz;
      }
    }
    return chunk.lines[n]
  }

  // Get the part of a document between two positions, as an array of
  // strings.
  function getBetween(doc, start, end) {
    var out = [], n = start.line;
    doc.iter(start.line, end.line + 1, function (line) {
      var text = line.text;
      if (n == end.line) { text = text.slice(0, end.ch); }
      if (n == start.line) { text = text.slice(start.ch); }
      out.push(text);
      ++n;
    });
    return out
  }
  // Get the lines between from and to, as array of strings.
  function getLines(doc, from, to) {
    var out = [];
    doc.iter(from, to, function (line) { out.push(line.text); }); // iter aborts when callback returns truthy value
    return out
  }

  // Update the height of a line, propagating the height change
  // upwards to parent nodes.
  function updateLineHeight(line, height) {
    var diff = height - line.height;
    if (diff) { for (var n = line; n; n = n.parent) { n.height += diff; } }
  }

  // Given a line object, find its line number by walking up through
  // its parent links.
  function lineNo(line) {
    if (line.parent == null) { return null }
    var cur = line.parent, no = indexOf(cur.lines, line);
    for (var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent) {
      for (var i = 0;; ++i) {
        if (chunk.children[i] == cur) { break }
        no += chunk.children[i].chunkSize();
      }
    }
    return no + cur.first
  }

  // Find the line at the given vertical position, using the height
  // information in the document tree.
  function lineAtHeight(chunk, h) {
    var n = chunk.first;
    outer: do {
      for (var i$1 = 0; i$1 < chunk.children.length; ++i$1) {
        var child = chunk.children[i$1], ch = child.height;
        if (h < ch) { chunk = child; continue outer }
        h -= ch;
        n += child.chunkSize();
      }
      return n
    } while (!chunk.lines)
    var i = 0;
    for (; i < chunk.lines.length; ++i) {
      var line = chunk.lines[i], lh = line.height;
      if (h < lh) { break }
      h -= lh;
    }
    return n + i
  }

  function isLine(doc, l) {return l >= doc.first && l < doc.first + doc.size}

  function lineNumberFor(options, i) {
    return String(options.lineNumberFormatter(i + options.firstLineNumber))
  }

  // A Pos instance represents a position within the text.
  function Pos(line, ch, sticky) {
    if ( sticky === void 0 ) sticky = null;

    if (!(this instanceof Pos)) { return new Pos(line, ch, sticky) }
    this.line = line;
    this.ch = ch;
    this.sticky = sticky;
  }

  // Compare two positions, return 0 if they are the same, a negative
  // number when a is less, and a positive number otherwise.
  function cmp(a, b) { return a.line - b.line || a.ch - b.ch }

  function equalCursorPos(a, b) { return a.sticky == b.sticky && cmp(a, b) == 0 }

  function copyPos(x) {return Pos(x.line, x.ch)}
  function maxPos(a, b) { return cmp(a, b) < 0 ? b : a }
  function minPos(a, b) { return cmp(a, b) < 0 ? a : b }

  // Most of the external API clips given positions to make sure they
  // actually exist within the document.
  function clipLine(doc, n) {return Math.max(doc.first, Math.min(n, doc.first + doc.size - 1))}
  function clipPos(doc, pos) {
    if (pos.line < doc.first) { return Pos(doc.first, 0) }
    var last = doc.first + doc.size - 1;
    if (pos.line > last) { return Pos(last, getLine(doc, last).text.length) }
    return clipToLen(pos, getLine(doc, pos.line).text.length)
  }
  function clipToLen(pos, linelen) {
    var ch = pos.ch;
    if (ch == null || ch > linelen) { return Pos(pos.line, linelen) }
    else if (ch < 0) { return Pos(pos.line, 0) }
    else { return pos }
  }
  function clipPosArray(doc, array) {
    var out = [];
    for (var i = 0; i < array.length; i++) { out[i] = clipPos(doc, array[i]); }
    return out
  }

  // Optimize some code when these features are not used.
  var sawReadOnlySpans = false, sawCollapsedSpans = false;

  function seeReadOnlySpans() {
    sawReadOnlySpans = true;
  }

  function seeCollapsedSpans() {
    sawCollapsedSpans = true;
  }

  // TEXTMARKER SPANS

  function MarkedSpan(marker, from, to) {
    this.marker = marker;
    this.from = from; this.to = to;
  }

  // Search an array of spans for a span matching the given marker.
  function getMarkedSpanFor(spans, marker) {
    if (spans) { for (var i = 0; i < spans.length; ++i) {
      var span = spans[i];
      if (span.marker == marker) { return span }
    } }
  }
  // Remove a span from an array, returning undefined if no spans are
  // left (we don't store arrays for lines without spans).
  function removeMarkedSpan(spans, span) {
    var r;
    for (var i = 0; i < spans.length; ++i)
      { if (spans[i] != span) { (r || (r = [])).push(spans[i]); } }
    return r
  }
  // Add a span to a line.
  function addMarkedSpan(line, span) {
    line.markedSpans = line.markedSpans ? line.markedSpans.concat([span]) : [span];
    span.marker.attachLine(line);
  }

  // Used for the algorithm that adjusts markers for a change in the
  // document. These functions cut an array of spans at a given
  // character position, returning an array of remaining chunks (or
  // undefined if nothing remains).
  function markedSpansBefore(old, startCh, isInsert) {
    var nw;
    if (old) { for (var i = 0; i < old.length; ++i) {
      var span = old[i], marker = span.marker;
      var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh);
      if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
        var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh)
        ;(nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to));
      }
    } }
    return nw
  }
  function markedSpansAfter(old, endCh, isInsert) {
    var nw;
    if (old) { for (var i = 0; i < old.length; ++i) {
      var span = old[i], marker = span.marker;
      var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh);
      if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
        var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh)
        ;(nw || (nw = [])).push(new MarkedSpan(marker, startsBefore ? null : span.from - endCh,
                                              span.to == null ? null : span.to - endCh));
      }
    } }
    return nw
  }

  // Given a change object, compute the new set of marker spans that
  // cover the line in which the change took place. Removes spans
  // entirely within the change, reconnects spans belonging to the
  // same marker that appear on both sides of the change, and cuts off
  // spans partially within the change. Returns an array of span
  // arrays with one element for each line in (after) the change.
  function stretchSpansOverChange(doc, change) {
    if (change.full) { return null }
    var oldFirst = isLine(doc, change.from.line) && getLine(doc, change.from.line).markedSpans;
    var oldLast = isLine(doc, change.to.line) && getLine(doc, change.to.line).markedSpans;
    if (!oldFirst && !oldLast) { return null }

    var startCh = change.from.ch, endCh = change.to.ch, isInsert = cmp(change.from, change.to) == 0;
    // Get the spans that 'stick out' on both sides
    var first = markedSpansBefore(oldFirst, startCh, isInsert);
    var last = markedSpansAfter(oldLast, endCh, isInsert);

    // Next, merge those two ends
    var sameLine = change.text.length == 1, offset = lst(change.text).length + (sameLine ? startCh : 0);
    if (first) {
      // Fix up .to properties of first
      for (var i = 0; i < first.length; ++i) {
        var span = first[i];
        if (span.to == null) {
          var found = getMarkedSpanFor(last, span.marker);
          if (!found) { span.to = startCh; }
          else if (sameLine) { span.to = found.to == null ? null : found.to + offset; }
        }
      }
    }
    if (last) {
      // Fix up .from in last (or move them into first in case of sameLine)
      for (var i$1 = 0; i$1 < last.length; ++i$1) {
        var span$1 = last[i$1];
        if (span$1.to != null) { span$1.to += offset; }
        if (span$1.from == null) {
          var found$1 = getMarkedSpanFor(first, span$1.marker);
          if (!found$1) {
            span$1.from = offset;
            if (sameLine) { (first || (first = [])).push(span$1); }
          }
        } else {
          span$1.from += offset;
          if (sameLine) { (first || (first = [])).push(span$1); }
        }
      }
    }
    // Make sure we didn't create any zero-length spans
    if (first) { first = clearEmptySpans(first); }
    if (last && last != first) { last = clearEmptySpans(last); }

    var newMarkers = [first];
    if (!sameLine) {
      // Fill gap with whole-line-spans
      var gap = change.text.length - 2, gapMarkers;
      if (gap > 0 && first)
        { for (var i$2 = 0; i$2 < first.length; ++i$2)
          { if (first[i$2].to == null)
            { (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i$2].marker, null, null)); } } }
      for (var i$3 = 0; i$3 < gap; ++i$3)
        { newMarkers.push(gapMarkers); }
      newMarkers.push(last);
    }
    return newMarkers
  }

  // Remove spans that are empty and don't have a clearWhenEmpty
  // option of false.
  function clearEmptySpans(spans) {
    for (var i = 0; i < spans.length; ++i) {
      var span = spans[i];
      if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false)
        { spans.splice(i--, 1); }
    }
    if (!spans.length) { return null }
    return spans
  }

  // Used to 'clip' out readOnly ranges when making a change.
  function removeReadOnlyRanges(doc, from, to) {
    var markers = null;
    doc.iter(from.line, to.line + 1, function (line) {
      if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
        var mark = line.markedSpans[i].marker;
        if (mark.readOnly && (!markers || indexOf(markers, mark) == -1))
          { (markers || (markers = [])).push(mark); }
      } }
    });
    if (!markers) { return null }
    var parts = [{from: from, to: to}];
    for (var i = 0; i < markers.length; ++i) {
      var mk = markers[i], m = mk.find(0);
      for (var j = 0; j < parts.length; ++j) {
        var p = parts[j];
        if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) { continue }
        var newParts = [j, 1], dfrom = cmp(p.from, m.from), dto = cmp(p.to, m.to);
        if (dfrom < 0 || !mk.inclusiveLeft && !dfrom)
          { newParts.push({from: p.from, to: m.from}); }
        if (dto > 0 || !mk.inclusiveRight && !dto)
          { newParts.push({from: m.to, to: p.to}); }
        parts.splice.apply(parts, newParts);
        j += newParts.length - 3;
      }
    }
    return parts
  }

  // Connect or disconnect spans from a line.
  function detachMarkedSpans(line) {
    var spans = line.markedSpans;
    if (!spans) { return }
    for (var i = 0; i < spans.length; ++i)
      { spans[i].marker.detachLine(line); }
    line.markedSpans = null;
  }
  function attachMarkedSpans(line, spans) {
    if (!spans) { return }
    for (var i = 0; i < spans.length; ++i)
      { spans[i].marker.attachLine(line); }
    line.markedSpans = spans;
  }

  // Helpers used when computing which overlapping collapsed span
  // counts as the larger one.
  function extraLeft(marker) { return marker.inclusiveLeft ? -1 : 0 }
  function extraRight(marker) { return marker.inclusiveRight ? 1 : 0 }

  // Returns a number indicating which of two overlapping collapsed
  // spans is larger (and thus includes the other). Falls back to
  // comparing ids when the spans cover exactly the same range.
  function compareCollapsedMarkers(a, b) {
    var lenDiff = a.lines.length - b.lines.length;
    if (lenDiff != 0) { return lenDiff }
    var aPos = a.find(), bPos = b.find();
    var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b);
    if (fromCmp) { return -fromCmp }
    var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b);
    if (toCmp) { return toCmp }
    return b.id - a.id
  }

  // Find out whether a line ends or starts in a collapsed span. If
  // so, return the marker for that span.
  function collapsedSpanAtSide(line, start) {
    var sps = sawCollapsedSpans && line.markedSpans, found;
    if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
      sp = sps[i];
      if (sp.marker.collapsed && (start ? sp.from : sp.to) == null &&
          (!found || compareCollapsedMarkers(found, sp.marker) < 0))
        { found = sp.marker; }
    } }
    return found
  }
  function collapsedSpanAtStart(line) { return collapsedSpanAtSide(line, true) }
  function collapsedSpanAtEnd(line) { return collapsedSpanAtSide(line, false) }

  function collapsedSpanAround(line, ch) {
    var sps = sawCollapsedSpans && line.markedSpans, found;
    if (sps) { for (var i = 0; i < sps.length; ++i) {
      var sp = sps[i];
      if (sp.marker.collapsed && (sp.from == null || sp.from < ch) && (sp.to == null || sp.to > ch) &&
          (!found || compareCollapsedMarkers(found, sp.marker) < 0)) { found = sp.marker; }
    } }
    return found
  }

  // Test whether there exists a collapsed span that partially
  // overlaps (covers the start or end, but not both) of a new span.
  // Such overlap is not allowed.
  function conflictingCollapsedRange(doc, lineNo$$1, from, to, marker) {
    var line = getLine(doc, lineNo$$1);
    var sps = sawCollapsedSpans && line.markedSpans;
    if (sps) { for (var i = 0; i < sps.length; ++i) {
      var sp = sps[i];
      if (!sp.marker.collapsed) { continue }
      var found = sp.marker.find(0);
      var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker);
      var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker);
      if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) { continue }
      if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) ||
          fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0))
        { return true }
    } }
  }

  // A visual line is a line as drawn on the screen. Folding, for
  // example, can cause multiple logical lines to appear on the same
  // visual line. This finds the start of the visual line that the
  // given line is part of (usually that is the line itself).
  function visualLine(line) {
    var merged;
    while (merged = collapsedSpanAtStart(line))
      { line = merged.find(-1, true).line; }
    return line
  }

  function visualLineEnd(line) {
    var merged;
    while (merged = collapsedSpanAtEnd(line))
      { line = merged.find(1, true).line; }
    return line
  }

  // Returns an array of logical lines that continue the visual line
  // started by the argument, or undefined if there are no such lines.
  function visualLineContinued(line) {
    var merged, lines;
    while (merged = collapsedSpanAtEnd(line)) {
      line = merged.find(1, true).line
      ;(lines || (lines = [])).push(line);
    }
    return lines
  }

  // Get the line number of the start of the visual line that the
  // given line number is part of.
  function visualLineNo(doc, lineN) {
    var line = getLine(doc, lineN), vis = visualLine(line);
    if (line == vis) { return lineN }
    return lineNo(vis)
  }

  // Get the line number of the start of the next visual line after
  // the given line.
  function visualLineEndNo(doc, lineN) {
    if (lineN > doc.lastLine()) { return lineN }
    var line = getLine(doc, lineN), merged;
    if (!lineIsHidden(doc, line)) { return lineN }
    while (merged = collapsedSpanAtEnd(line))
      { line = merged.find(1, true).line; }
    return lineNo(line) + 1
  }

  // Compute whether a line is hidden. Lines count as hidden when they
  // are part of a visual line that starts with another line, or when
  // they are entirely covered by collapsed, non-widget span.
  function lineIsHidden(doc, line) {
    var sps = sawCollapsedSpans && line.markedSpans;
    if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
      sp = sps[i];
      if (!sp.marker.collapsed) { continue }
      if (sp.from == null) { return true }
      if (sp.marker.widgetNode) { continue }
      if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc, line, sp))
        { return true }
    } }
  }
  function lineIsHiddenInner(doc, line, span) {
    if (span.to == null) {
      var end = span.marker.find(1, true);
      return lineIsHiddenInner(doc, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker))
    }
    if (span.marker.inclusiveRight && span.to == line.text.length)
      { return true }
    for (var sp = (void 0), i = 0; i < line.markedSpans.length; ++i) {
      sp = line.markedSpans[i];
      if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to &&
          (sp.to == null || sp.to != span.from) &&
          (sp.marker.inclusiveLeft || span.marker.inclusiveRight) &&
          lineIsHiddenInner(doc, line, sp)) { return true }
    }
  }

  // Find the height above the given line.
  function heightAtLine(lineObj) {
    lineObj = visualLine(lineObj);

    var h = 0, chunk = lineObj.parent;
    for (var i = 0; i < chunk.lines.length; ++i) {
      var line = chunk.lines[i];
      if (line == lineObj) { break }
      else { h += line.height; }
    }
    for (var p = chunk.parent; p; chunk = p, p = chunk.parent) {
      for (var i$1 = 0; i$1 < p.children.length; ++i$1) {
        var cur = p.children[i$1];
        if (cur == chunk) { break }
        else { h += cur.height; }
      }
    }
    return h
  }

  // Compute the character length of a line, taking into account
  // collapsed ranges (see markText) that might hide parts, and join
  // other lines onto it.
  function lineLength(line) {
    if (line.height == 0) { return 0 }
    var len = line.text.length, merged, cur = line;
    while (merged = collapsedSpanAtStart(cur)) {
      var found = merged.find(0, true);
      cur = found.from.line;
      len += found.from.ch - found.to.ch;
    }
    cur = line;
    while (merged = collapsedSpanAtEnd(cur)) {
      var found$1 = merged.find(0, true);
      len -= cur.text.length - found$1.from.ch;
      cur = found$1.to.line;
      len += cur.text.length - found$1.to.ch;
    }
    return len
  }

  // Find the longest line in the document.
  function findMaxLine(cm) {
    var d = cm.display, doc = cm.doc;
    d.maxLine = getLine(doc, doc.first);
    d.maxLineLength = lineLength(d.maxLine);
    d.maxLineChanged = true;
    doc.iter(function (line) {
      var len = lineLength(line);
      if (len > d.maxLineLength) {
        d.maxLineLength = len;
        d.maxLine = line;
      }
    });
  }

  // BIDI HELPERS

  function iterateBidiSections(order, from, to, f) {
    if (!order) { return f(from, to, "ltr", 0) }
    var found = false;
    for (var i = 0; i < order.length; ++i) {
      var part = order[i];
      if (part.from < to && part.to > from || from == to && part.to == from) {
        f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr", i);
        found = true;
      }
    }
    if (!found) { f(from, to, "ltr"); }
  }

  var bidiOther = null;
  function getBidiPartAt(order, ch, sticky) {
    var found;
    bidiOther = null;
    for (var i = 0; i < order.length; ++i) {
      var cur = order[i];
      if (cur.from < ch && cur.to > ch) { return i }
      if (cur.to == ch) {
        if (cur.from != cur.to && sticky == "before") { found = i; }
        else { bidiOther = i; }
      }
      if (cur.from == ch) {
        if (cur.from != cur.to && sticky != "before") { found = i; }
        else { bidiOther = i; }
      }
    }
    return found != null ? found : bidiOther
  }

  // Bidirectional ordering algorithm
  // See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
  // that this (partially) implements.

  // One-char codes used for character types:
  // L (L):   Left-to-Right
  // R (R):   Right-to-Left
  // r (AL):  Right-to-Left Arabic
  // 1 (EN):  European Number
  // + (ES):  European Number Separator
  // % (ET):  European Number Terminator
  // n (AN):  Arabic Number
  // , (CS):  Common Number Separator
  // m (NSM): Non-Spacing Mark
  // b (BN):  Boundary Neutral
  // s (B):   Paragraph Separator
  // t (S):   Segment Separator
  // w (WS):  Whitespace
  // N (ON):  Other Neutrals

  // Returns null if characters are ordered as they appear
  // (left-to-right), or an array of sections ({from, to, level}
  // objects) in the order in which they occur visually.
  var bidiOrdering = (function() {
    // Character types for codepoints 0 to 0xff
    var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN";
    // Character types for codepoints 0x600 to 0x6f9
    var arabicTypes = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";
    function charType(code) {
      if (code <= 0xf7) { return lowTypes.charAt(code) }
      else if (0x590 <= code && code <= 0x5f4) { return "R" }
      else if (0x600 <= code && code <= 0x6f9) { return arabicTypes.charAt(code - 0x600) }
      else if (0x6ee <= code && code <= 0x8ac) { return "r" }
      else if (0x2000 <= code && code <= 0x200b) { return "w" }
      else if (code == 0x200c) { return "b" }
      else { return "L" }
    }

    var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
    var isNeutral = /[stwN]/, isStrong = /[LRr]/, countsAsLeft = /[Lb1n]/, countsAsNum = /[1n]/;

    function BidiSpan(level, from, to) {
      this.level = level;
      this.from = from; this.to = to;
    }

    return function(str, direction) {
      var outerType = direction == "ltr" ? "L" : "R";

      if (str.length == 0 || direction == "ltr" && !bidiRE.test(str)) { return false }
      var len = str.length, types = [];
      for (var i = 0; i < len; ++i)
        { types.push(charType(str.charCodeAt(i))); }

      // W1. Examine each non-spacing mark (NSM) in the level run, and
      // change the type of the NSM to the type of the previous
      // character. If the NSM is at the start of the level run, it will
      // get the type of sor.
      for (var i$1 = 0, prev = outerType; i$1 < len; ++i$1) {
        var type = types[i$1];
        if (type == "m") { types[i$1] = prev; }
        else { prev = type; }
      }

      // W2. Search backwards from each instance of a European number
      // until the first strong type (R, L, AL, or sor) is found. If an
      // AL is found, change the type of the European number to Arabic
      // number.
      // W3. Change all ALs to R.
      for (var i$2 = 0, cur = outerType; i$2 < len; ++i$2) {
        var type$1 = types[i$2];
        if (type$1 == "1" && cur == "r") { types[i$2] = "n"; }
        else if (isStrong.test(type$1)) { cur = type$1; if (type$1 == "r") { types[i$2] = "R"; } }
      }

      // W4. A single European separator between two European numbers
      // changes to a European number. A single common separator between
      // two numbers of the same type changes to that type.
      for (var i$3 = 1, prev$1 = types[0]; i$3 < len - 1; ++i$3) {
        var type$2 = types[i$3];
        if (type$2 == "+" && prev$1 == "1" && types[i$3+1] == "1") { types[i$3] = "1"; }
        else if (type$2 == "," && prev$1 == types[i$3+1] &&
                 (prev$1 == "1" || prev$1 == "n")) { types[i$3] = prev$1; }
        prev$1 = type$2;
      }

      // W5. A sequence of European terminators adjacent to European
      // numbers changes to all European numbers.
      // W6. Otherwise, separators and terminators change to Other
      // Neutral.
      for (var i$4 = 0; i$4 < len; ++i$4) {
        var type$3 = types[i$4];
        if (type$3 == ",") { types[i$4] = "N"; }
        else if (type$3 == "%") {
          var end = (void 0);
          for (end = i$4 + 1; end < len && types[end] == "%"; ++end) {}
          var replace = (i$4 && types[i$4-1] == "!") || (end < len && types[end] == "1") ? "1" : "N";
          for (var j = i$4; j < end; ++j) { types[j] = replace; }
          i$4 = end - 1;
        }
      }

      // W7. Search backwards from each instance of a European number
      // until the first strong type (R, L, or sor) is found. If an L is
      // found, then change the type of the European number to L.
      for (var i$5 = 0, cur$1 = outerType; i$5 < len; ++i$5) {
        var type$4 = types[i$5];
        if (cur$1 == "L" && type$4 == "1") { types[i$5] = "L"; }
        else if (isStrong.test(type$4)) { cur$1 = type$4; }
      }

      // N1. A sequence of neutrals takes the direction of the
      // surrounding strong text if the text on both sides has the same
      // direction. European and Arabic numbers act as if they were R in
      // terms of their influence on neutrals. Start-of-level-run (sor)
      // and end-of-level-run (eor) are used at level run boundaries.
      // N2. Any remaining neutrals take the embedding direction.
      for (var i$6 = 0; i$6 < len; ++i$6) {
        if (isNeutral.test(types[i$6])) {
          var end$1 = (void 0);
          for (end$1 = i$6 + 1; end$1 < len && isNeutral.test(types[end$1]); ++end$1) {}
          var before = (i$6 ? types[i$6-1] : outerType) == "L";
          var after = (end$1 < len ? types[end$1] : outerType) == "L";
          var replace$1 = before == after ? (before ? "L" : "R") : outerType;
          for (var j$1 = i$6; j$1 < end$1; ++j$1) { types[j$1] = replace$1; }
          i$6 = end$1 - 1;
        }
      }

      // Here we depart from the documented algorithm, in order to avoid
      // building up an actual levels array. Since there are only three
      // levels (0, 1, 2) in an implementation that doesn't take
      // explicit embedding into account, we can build up the order on
      // the fly, without following the level-based algorithm.
      var order = [], m;
      for (var i$7 = 0; i$7 < len;) {
        if (countsAsLeft.test(types[i$7])) {
          var start = i$7;
          for (++i$7; i$7 < len && countsAsLeft.test(types[i$7]); ++i$7) {}
          order.push(new BidiSpan(0, start, i$7));
        } else {
          var pos = i$7, at = order.length;
          for (++i$7; i$7 < len && types[i$7] != "L"; ++i$7) {}
          for (var j$2 = pos; j$2 < i$7;) {
            if (countsAsNum.test(types[j$2])) {
              if (pos < j$2) { order.splice(at, 0, new BidiSpan(1, pos, j$2)); }
              var nstart = j$2;
              for (++j$2; j$2 < i$7 && countsAsNum.test(types[j$2]); ++j$2) {}
              order.splice(at, 0, new BidiSpan(2, nstart, j$2));
              pos = j$2;
            } else { ++j$2; }
          }
          if (pos < i$7) { order.splice(at, 0, new BidiSpan(1, pos, i$7)); }
        }
      }
      if (direction == "ltr") {
        if (order[0].level == 1 && (m = str.match(/^\s+/))) {
          order[0].from = m[0].length;
          order.unshift(new BidiSpan(0, 0, m[0].length));
        }
        if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
          lst(order).to -= m[0].length;
          order.push(new BidiSpan(0, len - m[0].length, len));
        }
      }

      return direction == "rtl" ? order.reverse() : order
    }
  })();

  // Get the bidi ordering for the given line (and cache it). Returns
  // false for lines that are fully left-to-right, and an array of
  // BidiSpan objects otherwise.
  function getOrder(line, direction) {
    var order = line.order;
    if (order == null) { order = line.order = bidiOrdering(line.text, direction); }
    return order
  }

  // EVENT HANDLING

  // Lightweight event framework. on/off also work on DOM nodes,
  // registering native DOM handlers.

  var noHandlers = [];

  var on = function(emitter, type, f) {
    if (emitter.addEventListener) {
      emitter.addEventListener(type, f, false);
    } else if (emitter.attachEvent) {
      emitter.attachEvent("on" + type, f);
    } else {
      var map$$1 = emitter._handlers || (emitter._handlers = {});
      map$$1[type] = (map$$1[type] || noHandlers).concat(f);
    }
  };

  function getHandlers(emitter, type) {
    return emitter._handlers && emitter._handlers[type] || noHandlers
  }

  function off(emitter, type, f) {
    if (emitter.removeEventListener) {
      emitter.removeEventListener(type, f, false);
    } else if (emitter.detachEvent) {
      emitter.detachEvent("on" + type, f);
    } else {
      var map$$1 = emitter._handlers, arr = map$$1 && map$$1[type];
      if (arr) {
        var index = indexOf(arr, f);
        if (index > -1)
          { map$$1[type] = arr.slice(0, index).concat(arr.slice(index + 1)); }
      }
    }
  }

  function signal(emitter, type /*, values...*/) {
    var handlers = getHandlers(emitter, type);
    if (!handlers.length) { return }
    var args = Array.prototype.slice.call(arguments, 2);
    for (var i = 0; i < handlers.length; ++i) { handlers[i].apply(null, args); }
  }

  // The DOM events that CodeMirror handles can be overridden by
  // registering a (non-DOM) handler on the editor for the event name,
  // and preventDefault-ing the event in that handler.
  function signalDOMEvent(cm, e, override) {
    if (typeof e == "string")
      { e = {type: e, preventDefault: function() { this.defaultPrevented = true; }}; }
    signal(cm, override || e.type, cm, e);
    return e_defaultPrevented(e) || e.codemirrorIgnore
  }

  function signalCursorActivity(cm) {
    var arr = cm._handlers && cm._handlers.cursorActivity;
    if (!arr) { return }
    var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = []);
    for (var i = 0; i < arr.length; ++i) { if (indexOf(set, arr[i]) == -1)
      { set.push(arr[i]); } }
  }

  function hasHandler(emitter, type) {
    return getHandlers(emitter, type).length > 0
  }

  // Add on and off methods to a constructor's prototype, to make
  // registering events on such objects more convenient.
  function eventMixin(ctor) {
    ctor.prototype.on = function(type, f) {on(this, type, f);};
    ctor.prototype.off = function(type, f) {off(this, type, f);};
  }

  // Due to the fact that we still support jurassic IE versions, some
  // compatibility wrappers are needed.

  function e_preventDefault(e) {
    if (e.preventDefault) { e.preventDefault(); }
    else { e.returnValue = false; }
  }
  function e_stopPropagation(e) {
    if (e.stopPropagation) { e.stopPropagation(); }
    else { e.cancelBubble = true; }
  }
  function e_defaultPrevented(e) {
    return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false
  }
  function e_stop(e) {e_preventDefault(e); e_stopPropagation(e);}

  function e_target(e) {return e.target || e.srcElement}
  function e_button(e) {
    var b = e.which;
    if (b == null) {
      if (e.button & 1) { b = 1; }
      else if (e.button & 2) { b = 3; }
      else if (e.button & 4) { b = 2; }
    }
    if (mac && e.ctrlKey && b == 1) { b = 3; }
    return b
  }

  // Detect drag-and-drop
  var dragAndDrop = function() {
    // There is *some* kind of drag-and-drop support in IE6-8, but I
    // couldn't get it to work yet.
    if (ie && ie_version < 9) { return false }
    var div = elt('div');
    return "draggable" in div || "dragDrop" in div
  }();

  var zwspSupported;
  function zeroWidthElement(measure) {
    if (zwspSupported == null) {
      var test = elt("span", "\u200b");
      removeChildrenAndAdd(measure, elt("span", [test, document.createTextNode("x")]));
      if (measure.firstChild.offsetHeight != 0)
        { zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8); }
    }
    var node = zwspSupported ? elt("span", "\u200b") :
      elt("span", "\u00a0", null, "display: inline-block; width: 1px; margin-right: -1px");
    node.setAttribute("cm-text", "");
    return node
  }

  // Feature-detect IE's crummy client rect reporting for bidi text
  var badBidiRects;
  function hasBadBidiRects(measure) {
    if (badBidiRects != null) { return badBidiRects }
    var txt = removeChildrenAndAdd(measure, document.createTextNode("A\u062eA"));
    var r0 = range(txt, 0, 1).getBoundingClientRect();
    var r1 = range(txt, 1, 2).getBoundingClientRect();
    removeChildren(measure);
    if (!r0 || r0.left == r0.right) { return false } // Safari returns null in some cases (#2780)
    return badBidiRects = (r1.right - r0.right < 3)
  }

  // See if "".split is the broken IE version, if so, provide an
  // alternative way to split lines.
  var splitLinesAuto = "\n\nb".split(/\n/).length != 3 ? function (string) {
    var pos = 0, result = [], l = string.length;
    while (pos <= l) {
      var nl = string.indexOf("\n", pos);
      if (nl == -1) { nl = string.length; }
      var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl);
      var rt = line.indexOf("\r");
      if (rt != -1) {
        result.push(line.slice(0, rt));
        pos += rt + 1;
      } else {
        result.push(line);
        pos = nl + 1;
      }
    }
    return result
  } : function (string) { return string.split(/\r\n?|\n/); };

  var hasSelection = window.getSelection ? function (te) {
    try { return te.selectionStart != te.selectionEnd }
    catch(e) { return false }
  } : function (te) {
    var range$$1;
    try {range$$1 = te.ownerDocument.selection.createRange();}
    catch(e) {}
    if (!range$$1 || range$$1.parentElement() != te) { return false }
    return range$$1.compareEndPoints("StartToEnd", range$$1) != 0
  };

  var hasCopyEvent = (function () {
    var e = elt("div");
    if ("oncopy" in e) { return true }
    e.setAttribute("oncopy", "return;");
    return typeof e.oncopy == "function"
  })();

  var badZoomedRects = null;
  function hasBadZoomedRects(measure) {
    if (badZoomedRects != null) { return badZoomedRects }
    var node = removeChildrenAndAdd(measure, elt("span", "x"));
    var normal = node.getBoundingClientRect();
    var fromRange = range(node, 0, 1).getBoundingClientRect();
    return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1
  }

  // Known modes, by name and by MIME
  var modes = {}, mimeModes = {};

  // Extra arguments are stored as the mode's dependencies, which is
  // used by (legacy) mechanisms like loadmode.js to automatically
  // load a mode. (Preferred mechanism is the require/define calls.)
  function defineMode(name, mode) {
    if (arguments.length > 2)
      { mode.dependencies = Array.prototype.slice.call(arguments, 2); }
    modes[name] = mode;
  }

  function defineMIME(mime, spec) {
    mimeModes[mime] = spec;
  }

  // Given a MIME type, a {name, ...options} config object, or a name
  // string, return a mode config object.
  function resolveMode(spec) {
    if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) {
      spec = mimeModes[spec];
    } else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
      var found = mimeModes[spec.name];
      if (typeof found == "string") { found = {name: found}; }
      spec = createObj(found, spec);
      spec.name = found.name;
    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) {
      return resolveMode("application/xml")
    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) {
      return resolveMode("application/json")
    }
    if (typeof spec == "string") { return {name: spec} }
    else { return spec || {name: "null"} }
  }

  // Given a mode spec (anything that resolveMode accepts), find and
  // initialize an actual mode object.
  function getMode(options, spec) {
    spec = resolveMode(spec);
    var mfactory = modes[spec.name];
    if (!mfactory) { return getMode(options, "text/plain") }
    var modeObj = mfactory(options, spec);
    if (modeExtensions.hasOwnProperty(spec.name)) {
      var exts = modeExtensions[spec.name];
      for (var prop in exts) {
        if (!exts.hasOwnProperty(prop)) { continue }
        if (modeObj.hasOwnProperty(prop)) { modeObj["_" + prop] = modeObj[prop]; }
        modeObj[prop] = exts[prop];
      }
    }
    modeObj.name = spec.name;
    if (spec.helperType) { modeObj.helperType = spec.helperType; }
    if (spec.modeProps) { for (var prop$1 in spec.modeProps)
      { modeObj[prop$1] = spec.modeProps[prop$1]; } }

    return modeObj
  }

  // This can be used to attach properties to mode objects from
  // outside the actual mode definition.
  var modeExtensions = {};
  function extendMode(mode, properties) {
    var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : (modeExtensions[mode] = {});
    copyObj(properties, exts);
  }

  function copyState(mode, state) {
    if (state === true) { return state }
    if (mode.copyState) { return mode.copyState(state) }
    var nstate = {};
    for (var n in state) {
      var val = state[n];
      if (val instanceof Array) { val = val.concat([]); }
      nstate[n] = val;
    }
    return nstate
  }

  // Given a mode and a state (for that mode), find the inner mode and
  // state at the position that the state refers to.
  function innerMode(mode, state) {
    var info;
    while (mode.innerMode) {
      info = mode.innerMode(state);
      if (!info || info.mode == mode) { break }
      state = info.state;
      mode = info.mode;
    }
    return info || {mode: mode, state: state}
  }

  function startState(mode, a1, a2) {
    return mode.startState ? mode.startState(a1, a2) : true
  }

  // STRING STREAM

  // Fed to the mode parsers, provides helper functions to make
  // parsers more succinct.

  var StringStream = function(string, tabSize, lineOracle) {
    this.pos = this.start = 0;
    this.string = string;
    this.tabSize = tabSize || 8;
    this.lastColumnPos = this.lastColumnValue = 0;
    this.lineStart = 0;
    this.lineOracle = lineOracle;
  };

  StringStream.prototype.eol = function () {return this.pos >= this.string.length};
  StringStream.prototype.sol = function () {return this.pos == this.lineStart};
  StringStream.prototype.peek = function () {return this.string.charAt(this.pos) || undefined};
  StringStream.prototype.next = function () {
    if (this.pos < this.string.length)
      { return this.string.charAt(this.pos++) }
  };
  StringStream.prototype.eat = function (match) {
    var ch = this.string.charAt(this.pos);
    var ok;
    if (typeof match == "string") { ok = ch == match; }
    else { ok = ch && (match.test ? match.test(ch) : match(ch)); }
    if (ok) {++this.pos; return ch}
  };
  StringStream.prototype.eatWhile = function (match) {
    var start = this.pos;
    while (this.eat(match)){}
    return this.pos > start
  };
  StringStream.prototype.eatSpace = function () {
      var this$1 = this;

    var start = this.pos;
    while (/[\s\u00a0]/.test(this.string.charAt(this.pos))) { ++this$1.pos; }
    return this.pos > start
  };
  StringStream.prototype.skipToEnd = function () {this.pos = this.string.length;};
  StringStream.prototype.skipTo = function (ch) {
    var found = this.string.indexOf(ch, this.pos);
    if (found > -1) {this.pos = found; return true}
  };
  StringStream.prototype.backUp = function (n) {this.pos -= n;};
  StringStream.prototype.column = function () {
    if (this.lastColumnPos < this.start) {
      this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
      this.lastColumnPos = this.start;
    }
    return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
  };
  StringStream.prototype.indentation = function () {
    return countColumn(this.string, null, this.tabSize) -
      (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
  };
  StringStream.prototype.match = function (pattern, consume, caseInsensitive) {
    if (typeof pattern == "string") {
      var cased = function (str) { return caseInsensitive ? str.toLowerCase() : str; };
      var substr = this.string.substr(this.pos, pattern.length);
      if (cased(substr) == cased(pattern)) {
        if (consume !== false) { this.pos += pattern.length; }
        return true
      }
    } else {
      var match = this.string.slice(this.pos).match(pattern);
      if (match && match.index > 0) { return null }
      if (match && consume !== false) { this.pos += match[0].length; }
      return match
    }
  };
  StringStream.prototype.current = function (){return this.string.slice(this.start, this.pos)};
  StringStream.prototype.hideFirstChars = function (n, inner) {
    this.lineStart += n;
    try { return inner() }
    finally { this.lineStart -= n; }
  };
  StringStream.prototype.lookAhead = function (n) {
    var oracle = this.lineOracle;
    return oracle && oracle.lookAhead(n)
  };
  StringStream.prototype.baseToken = function () {
    var oracle = this.lineOracle;
    return oracle && oracle.baseToken(this.pos)
  };

  var SavedContext = function(state, lookAhead) {
    this.state = state;
    this.lookAhead = lookAhead;
  };

  var Context = function(doc, state, line, lookAhead) {
    this.state = state;
    this.doc = doc;
    this.line = line;
    this.maxLookAhead = lookAhead || 0;
    this.baseTokens = null;
    this.baseTokenPos = 1;
  };

  Context.prototype.lookAhead = function (n) {
    var line = this.doc.getLine(this.line + n);
    if (line != null && n > this.maxLookAhead) { this.maxLookAhead = n; }
    return line
  };

  Context.prototype.baseToken = function (n) {
      var this$1 = this;

    if (!this.baseTokens) { return null }
    while (this.baseTokens[this.baseTokenPos] <= n)
      { this$1.baseTokenPos += 2; }
    var type = this.baseTokens[this.baseTokenPos + 1];
    return {type: type && type.replace(/( |^)overlay .*/, ""),
            size: this.baseTokens[this.baseTokenPos] - n}
  };

  Context.prototype.nextLine = function () {
    this.line++;
    if (this.maxLookAhead > 0) { this.maxLookAhead--; }
  };

  Context.fromSaved = function (doc, saved, line) {
    if (saved instanceof SavedContext)
      { return new Context(doc, copyState(doc.mode, saved.state), line, saved.lookAhead) }
    else
      { return new Context(doc, copyState(doc.mode, saved), line) }
  };

  Context.prototype.save = function (copy) {
    var state = copy !== false ? copyState(this.doc.mode, this.state) : this.state;
    return this.maxLookAhead > 0 ? new SavedContext(state, this.maxLookAhead) : state
  };


  // Compute a style array (an array starting with a mode generation
  // -- for invalidation -- followed by pairs of end positions and
  // style strings), which is used to highlight the tokens on the
  // line.
  function highlightLine(cm, line, context, forceToEnd) {
    // A styles array always starts with a number identifying the
    // mode/overlays that it is based on (for easy invalidation).
    var st = [cm.state.modeGen], lineClasses = {};
    // Compute the base array of styles
    runMode(cm, line.text, cm.doc.mode, context, function (end, style) { return st.push(end, style); },
            lineClasses, forceToEnd);
    var state = context.state;

    // Run overlays, adjust style array.
    var loop = function ( o ) {
      context.baseTokens = st;
      var overlay = cm.state.overlays[o], i = 1, at = 0;
      context.state = true;
      runMode(cm, line.text, overlay.mode, context, function (end, style) {
        var start = i;
        // Ensure there's a token end at the current position, and that i points at it
        while (at < end) {
          var i_end = st[i];
          if (i_end > end)
            { st.splice(i, 1, end, st[i+1], i_end); }
          i += 2;
          at = Math.min(end, i_end);
        }
        if (!style) { return }
        if (overlay.opaque) {
          st.splice(start, i - start, end, "overlay " + style);
          i = start + 2;
        } else {
          for (; start < i; start += 2) {
            var cur = st[start+1];
            st[start+1] = (cur ? cur + " " : "") + "overlay " + style;
          }
        }
      }, lineClasses);
      context.state = state;
      context.baseTokens = null;
      context.baseTokenPos = 1;
    };

    for (var o = 0; o < cm.state.overlays.length; ++o) loop( o );

    return {styles: st, classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null}
  }

  function getLineStyles(cm, line, updateFrontier) {
    if (!line.styles || line.styles[0] != cm.state.modeGen) {
      var context = getContextBefore(cm, lineNo(line));
      var resetState = line.text.length > cm.options.maxHighlightLength && copyState(cm.doc.mode, context.state);
      var result = highlightLine(cm, line, context);
      if (resetState) { context.state = resetState; }
      line.stateAfter = context.save(!resetState);
      line.styles = result.styles;
      if (result.classes) { line.styleClasses = result.classes; }
      else if (line.styleClasses) { line.styleClasses = null; }
      if (updateFrontier === cm.doc.highlightFrontier)
        { cm.doc.modeFrontier = Math.max(cm.doc.modeFrontier, ++cm.doc.highlightFrontier); }
    }
    return line.styles
  }

  function getContextBefore(cm, n, precise) {
    var doc = cm.doc, display = cm.display;
    if (!doc.mode.startState) { return new Context(doc, true, n) }
    var start = findStartLine(cm, n, precise);
    var saved = start > doc.first && getLine(doc, start - 1).stateAfter;
    var context = saved ? Context.fromSaved(doc, saved, start) : new Context(doc, startState(doc.mode), start);

    doc.iter(start, n, function (line) {
      processLine(cm, line.text, context);
      var pos = context.line;
      line.stateAfter = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo ? context.save() : null;
      context.nextLine();
    });
    if (precise) { doc.modeFrontier = context.line; }
    return context
  }

  // Lightweight form of highlight -- proceed over this line and
  // update state, but don't save a style array. Used for lines that
  // aren't currently visible.
  function processLine(cm, text, context, startAt) {
    var mode = cm.doc.mode;
    var stream = new StringStream(text, cm.options.tabSize, context);
    stream.start = stream.pos = startAt || 0;
    if (text == "") { callBlankLine(mode, context.state); }
    while (!stream.eol()) {
      readToken(mode, stream, context.state);
      stream.start = stream.pos;
    }
  }

  function callBlankLine(mode, state) {
    if (mode.blankLine) { return mode.blankLine(state) }
    if (!mode.innerMode) { return }
    var inner = innerMode(mode, state);
    if (inner.mode.blankLine) { return inner.mode.blankLine(inner.state) }
  }

  function readToken(mode, stream, state, inner) {
    for (var i = 0; i < 10; i++) {
      if (inner) { inner[0] = innerMode(mode, state).mode; }
      var style = mode.token(stream, state);
      if (stream.pos > stream.start) { return style }
    }
    throw new Error("Mode " + mode.name + " failed to advance stream.")
  }

  var Token = function(stream, type, state) {
    this.start = stream.start; this.end = stream.pos;
    this.string = stream.current();
    this.type = type || null;
    this.state = state;
  };

  // Utility for getTokenAt and getLineTokens
  function takeToken(cm, pos, precise, asArray) {
    var doc = cm.doc, mode = doc.mode, style;
    pos = clipPos(doc, pos);
    var line = getLine(doc, pos.line), context = getContextBefore(cm, pos.line, precise);
    var stream = new StringStream(line.text, cm.options.tabSize, context), tokens;
    if (asArray) { tokens = []; }
    while ((asArray || stream.pos < pos.ch) && !stream.eol()) {
      stream.start = stream.pos;
      style = readToken(mode, stream, context.state);
      if (asArray) { tokens.push(new Token(stream, style, copyState(doc.mode, context.state))); }
    }
    return asArray ? tokens : new Token(stream, style, context.state)
  }

  function extractLineClasses(type, output) {
    if (type) { for (;;) {
      var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/);
      if (!lineClass) { break }
      type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length);
      var prop = lineClass[1] ? "bgClass" : "textClass";
      if (output[prop] == null)
        { output[prop] = lineClass[2]; }
      else if (!(new RegExp("(?:^|\s)" + lineClass[2] + "(?:$|\s)")).test(output[prop]))
        { output[prop] += " " + lineClass[2]; }
    } }
    return type
  }

  // Run the given mode's parser over a line, calling f for each token.
  function runMode(cm, text, mode, context, f, lineClasses, forceToEnd) {
    var flattenSpans = mode.flattenSpans;
    if (flattenSpans == null) { flattenSpans = cm.options.flattenSpans; }
    var curStart = 0, curStyle = null;
    var stream = new StringStream(text, cm.options.tabSize, context), style;
    var inner = cm.options.addModeClass && [null];
    if (text == "") { extractLineClasses(callBlankLine(mode, context.state), lineClasses); }
    while (!stream.eol()) {
      if (stream.pos > cm.options.maxHighlightLength) {
        flattenSpans = false;
        if (forceToEnd) { processLine(cm, text, context, stream.pos); }
        stream.pos = text.length;
        style = null;
      } else {
        style = extractLineClasses(readToken(mode, stream, context.state, inner), lineClasses);
      }
      if (inner) {
        var mName = inner[0].name;
        if (mName) { style = "m-" + (style ? mName + " " + style : mName); }
      }
      if (!flattenSpans || curStyle != style) {
        while (curStart < stream.start) {
          curStart = Math.min(stream.start, curStart + 5000);
          f(curStart, curStyle);
        }
        curStyle = style;
      }
      stream.start = stream.pos;
    }
    while (curStart < stream.pos) {
      // Webkit seems to refuse to render text nodes longer than 57444
      // characters, and returns inaccurate measurements in nodes
      // starting around 5000 chars.
      var pos = Math.min(stream.pos, curStart + 5000);
      f(pos, curStyle);
      curStart = pos;
    }
  }

  // Finds the line to start with when starting a parse. Tries to
  // find a line with a stateAfter, so that it can start with a
  // valid state. If that fails, it returns the line with the
  // smallest indentation, which tends to need the least context to
  // parse correctly.
  function findStartLine(cm, n, precise) {
    var minindent, minline, doc = cm.doc;
    var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1000 : 100);
    for (var search = n; search > lim; --search) {
      if (search <= doc.first) { return doc.first }
      var line = getLine(doc, search - 1), after = line.stateAfter;
      if (after && (!precise || search + (after instanceof SavedContext ? after.lookAhead : 0) <= doc.modeFrontier))
        { return search }
      var indented = countColumn(line.text, null, cm.options.tabSize);
      if (minline == null || minindent > indented) {
        minline = search - 1;
        minindent = indented;
      }
    }
    return minline
  }

  function retreatFrontier(doc, n) {
    doc.modeFrontier = Math.min(doc.modeFrontier, n);
    if (doc.highlightFrontier < n - 10) { return }
    var start = doc.first;
    for (var line = n - 1; line > start; line--) {
      var saved = getLine(doc, line).stateAfter;
      // change is on 3
      // state on line 1 looked ahead 2 -- so saw 3
      // test 1 + 2 < 3 should cover this
      if (saved && (!(saved instanceof SavedContext) || line + saved.lookAhead < n)) {
        start = line + 1;
        break
      }
    }
    doc.highlightFrontier = Math.min(doc.highlightFrontier, start);
  }

  // LINE DATA STRUCTURE

  // Line objects. These hold state related to a line, including
  // highlighting info (the styles array).
  var Line = function(text, markedSpans, estimateHeight) {
    this.text = text;
    attachMarkedSpans(this, markedSpans);
    this.height = estimateHeight ? estimateHeight(this) : 1;
  };

  Line.prototype.lineNo = function () { return lineNo(this) };
  eventMixin(Line);

  // Change the content (text, markers) of a line. Automatically
  // invalidates cached information and tries to re-estimate the
  // line's height.
  function updateLine(line, text, markedSpans, estimateHeight) {
    line.text = text;
    if (line.stateAfter) { line.stateAfter = null; }
    if (line.styles) { line.styles = null; }
    if (line.order != null) { line.order = null; }
    detachMarkedSpans(line);
    attachMarkedSpans(line, markedSpans);
    var estHeight = estimateHeight ? estimateHeight(line) : 1;
    if (estHeight != line.height) { updateLineHeight(line, estHeight); }
  }

  // Detach a line from the document tree and its markers.
  function cleanUpLine(line) {
    line.parent = null;
    detachMarkedSpans(line);
  }

  // Convert a style as returned by a mode (either null, or a string
  // containing one or more styles) to a CSS style. This is cached,
  // and also looks for line-wide styles.
  var styleToClassCache = {}, styleToClassCacheWithMode = {};
  function interpretTokenStyle(style, options) {
    if (!style || /^\s*$/.test(style)) { return null }
    var cache = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache;
    return cache[style] ||
      (cache[style] = style.replace(/\S+/g, "cm-$&"))
  }

  // Render the DOM representation of the text of a line. Also builds
  // up a 'line map', which points at the DOM nodes that represent
  // specific stretches of text, and is used by the measuring code.
  // The returned object contains the DOM node, this map, and
  // information about line-wide styles that were set by the mode.
  function buildLineContent(cm, lineView) {
    // The padding-right forces the element to have a 'border', which
    // is needed on Webkit to be able to get line-level bounding
    // rectangles for it (in measureChar).
    var content = eltP("span", null, null, webkit ? "padding-right: .1px" : null);
    var builder = {pre: eltP("pre", [content], "CodeMirror-line"), content: content,
                   col: 0, pos: 0, cm: cm,
                   trailingSpace: false,
                   splitSpaces: cm.getOption("lineWrapping")};
    lineView.measure = {};

    // Iterate over the logical lines that make up this visual line.
    for (var i = 0; i <= (lineView.rest ? lineView.rest.length : 0); i++) {
      var line = i ? lineView.rest[i - 1] : lineView.line, order = (void 0);
      builder.pos = 0;
      builder.addToken = buildToken;
      // Optionally wire in some hacks into the token-rendering
      // algorithm, to deal with browser quirks.
      if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line, cm.doc.direction)))
        { builder.addToken = buildTokenBadBidi(builder.addToken, order); }
      builder.map = [];
      var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line);
      insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate));
      if (line.styleClasses) {
        if (line.styleClasses.bgClass)
          { builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || ""); }
        if (line.styleClasses.textClass)
          { builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || ""); }
      }

      // Ensure at least a single node is present, for measuring.
      if (builder.map.length == 0)
        { builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure))); }

      // Store the map and a cache object for the current logical line
      if (i == 0) {
        lineView.measure.map = builder.map;
        lineView.measure.cache = {};
      } else {
  (lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map)
        ;(lineView.measure.caches || (lineView.measure.caches = [])).push({});
      }
    }

    // See issue #2901
    if (webkit) {
      var last = builder.content.lastChild;
      if (/\bcm-tab\b/.test(last.className) || (last.querySelector && last.querySelector(".cm-tab")))
        { builder.content.className = "cm-tab-wrap-hack"; }
    }

    signal(cm, "renderLine", cm, lineView.line, builder.pre);
    if (builder.pre.className)
      { builder.textClass = joinClasses(builder.pre.className, builder.textClass || ""); }

    return builder
  }

  function defaultSpecialCharPlaceholder(ch) {
    var token = elt("span", "\u2022", "cm-invalidchar");
    token.title = "\\u" + ch.charCodeAt(0).toString(16);
    token.setAttribute("aria-label", token.title);
    return token
  }

  // Build up the DOM representation for a single token, and add it to
  // the line map. Takes care to render special characters separately.
  function buildToken(builder, text, style, startStyle, endStyle, css, attributes) {
    if (!text) { return }
    var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text;
    var special = builder.cm.state.specialChars, mustWrap = false;
    var content;
    if (!special.test(text)) {
      builder.col += text.length;
      content = document.createTextNode(displayText);
      builder.map.push(builder.pos, builder.pos + text.length, content);
      if (ie && ie_version < 9) { mustWrap = true; }
      builder.pos += text.length;
    } else {
      content = document.createDocumentFragment();
      var pos = 0;
      while (true) {
        special.lastIndex = pos;
        var m = special.exec(text);
        var skipped = m ? m.index - pos : text.length - pos;
        if (skipped) {
          var txt = document.createTextNode(displayText.slice(pos, pos + skipped));
          if (ie && ie_version < 9) { content.appendChild(elt("span", [txt])); }
          else { content.appendChild(txt); }
          builder.map.push(builder.pos, builder.pos + skipped, txt);
          builder.col += skipped;
          builder.pos += skipped;
        }
        if (!m) { break }
        pos += skipped + 1;
        var txt$1 = (void 0);
        if (m[0] == "\t") {
          var tabSize = builder.cm.options.tabSize, tabWidth = tabSize - builder.col % tabSize;
          txt$1 = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"));
          txt$1.setAttribute("role", "presentation");
          txt$1.setAttribute("cm-text", "\t");
          builder.col += tabWidth;
        } else if (m[0] == "\r" || m[0] == "\n") {
          txt$1 = content.appendChild(elt("span", m[0] == "\r" ? "\u240d" : "\u2424", "cm-invalidchar"));
          txt$1.setAttribute("cm-text", m[0]);
          builder.col += 1;
        } else {
          txt$1 = builder.cm.options.specialCharPlaceholder(m[0]);
          txt$1.setAttribute("cm-text", m[0]);
          if (ie && ie_version < 9) { content.appendChild(elt("span", [txt$1])); }
          else { content.appendChild(txt$1); }
          builder.col += 1;
        }
        builder.map.push(builder.pos, builder.pos + 1, txt$1);
        builder.pos++;
      }
    }
    builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32;
    if (style || startStyle || endStyle || mustWrap || css) {
      var fullStyle = style || "";
      if (startStyle) { fullStyle += startStyle; }
      if (endStyle) { fullStyle += endStyle; }
      var token = elt("span", [content], fullStyle, css);
      if (attributes) {
        for (var attr in attributes) { if (attributes.hasOwnProperty(attr) && attr != "style" && attr != "class")
          { token.setAttribute(attr, attributes[attr]); } }
      }
      return builder.content.appendChild(token)
    }
    builder.content.appendChild(content);
  }

  // Change some spaces to NBSP to prevent the browser from collapsing
  // trailing spaces at the end of a line when rendering text (issue #1362).
  function splitSpaces(text, trailingBefore) {
    if (text.length > 1 && !/  /.test(text)) { return text }
    var spaceBefore = trailingBefore, result = "";
    for (var i = 0; i < text.length; i++) {
      var ch = text.charAt(i);
      if (ch == " " && spaceBefore && (i == text.length - 1 || text.charCodeAt(i + 1) == 32))
        { ch = "\u00a0"; }
      result += ch;
      spaceBefore = ch == " ";
    }
    return result
  }

  // Work around nonsense dimensions being reported for stretches of
  // right-to-left text.
  function buildTokenBadBidi(inner, order) {
    return function (builder, text, style, startStyle, endStyle, css, attributes) {
      style = style ? style + " cm-force-border" : "cm-force-border";
      var start = builder.pos, end = start + text.length;
      for (;;) {
        // Find the part that overlaps with the start of this text
        var part = (void 0);
        for (var i = 0; i < order.length; i++) {
          part = order[i];
          if (part.to > start && part.from <= start) { break }
        }
        if (part.to >= end) { return inner(builder, text, style, startStyle, endStyle, css, attributes) }
        inner(builder, text.slice(0, part.to - start), style, startStyle, null, css, attributes);
        startStyle = null;
        text = text.slice(part.to - start);
        start = part.to;
      }
    }
  }

  function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
    var widget = !ignoreWidget && marker.widgetNode;
    if (widget) { builder.map.push(builder.pos, builder.pos + size, widget); }
    if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
      if (!widget)
        { widget = builder.content.appendChild(document.createElement("span")); }
      widget.setAttribute("cm-marker", marker.id);
    }
    if (widget) {
      builder.cm.display.input.setUneditable(widget);
      builder.content.appendChild(widget);
    }
    builder.pos += size;
    builder.trailingSpace = false;
  }

  // Outputs a number of spans to make up a line, taking highlighting
  // and marked text into account.
  function insertLineContent(line, builder, styles) {
    var spans = line.markedSpans, allText = line.text, at = 0;
    if (!spans) {
      for (var i$1 = 1; i$1 < styles.length; i$1+=2)
        { builder.addToken(builder, allText.slice(at, at = styles[i$1]), interpretTokenStyle(styles[i$1+1], builder.cm.options)); }
      return
    }

    var len = allText.length, pos = 0, i = 1, text = "", style, css;
    var nextChange = 0, spanStyle, spanEndStyle, spanStartStyle, collapsed, attributes;
    for (;;) {
      if (nextChange == pos) { // Update current marker set
        spanStyle = spanEndStyle = spanStartStyle = css = "";
        attributes = null;
        collapsed = null; nextChange = Infinity;
        var foundBookmarks = [], endStyles = (void 0);
        for (var j = 0; j < spans.length; ++j) {
          var sp = spans[j], m = sp.marker;
          if (m.type == "bookmark" && sp.from == pos && m.widgetNode) {
            foundBookmarks.push(m);
          } else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
            if (sp.to != null && sp.to != pos && nextChange > sp.to) {
              nextChange = sp.to;
              spanEndStyle = "";
            }
            if (m.className) { spanStyle += " " + m.className; }
            if (m.css) { css = (css ? css + ";" : "") + m.css; }
            if (m.startStyle && sp.from == pos) { spanStartStyle += " " + m.startStyle; }
            if (m.endStyle && sp.to == nextChange) { (endStyles || (endStyles = [])).push(m.endStyle, sp.to); }
            // support for the old title property
            // https://github.com/codemirror/CodeMirror/pull/5673
            if (m.title) { (attributes || (attributes = {})).title = m.title; }
            if (m.attributes) {
              for (var attr in m.attributes)
                { (attributes || (attributes = {}))[attr] = m.attributes[attr]; }
            }
            if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0))
              { collapsed = sp; }
          } else if (sp.from > pos && nextChange > sp.from) {
            nextChange = sp.from;
          }
        }
        if (endStyles) { for (var j$1 = 0; j$1 < endStyles.length; j$1 += 2)
          { if (endStyles[j$1 + 1] == nextChange) { spanEndStyle += " " + endStyles[j$1]; } } }

        if (!collapsed || collapsed.from == pos) { for (var j$2 = 0; j$2 < foundBookmarks.length; ++j$2)
          { buildCollapsedSpan(builder, 0, foundBookmarks[j$2]); } }
        if (collapsed && (collapsed.from || 0) == pos) {
          buildCollapsedSpan(builder, (collapsed.to == null ? len + 1 : collapsed.to) - pos,
                             collapsed.marker, collapsed.from == null);
          if (collapsed.to == null) { return }
          if (collapsed.to == pos) { collapsed = false; }
        }
      }
      if (pos >= len) { break }

      var upto = Math.min(len, nextChange);
      while (true) {
        if (text) {
          var end = pos + text.length;
          if (!collapsed) {
            var tokenText = end > upto ? text.slice(0, upto - pos) : text;
            builder.addToken(builder, tokenText, style ? style + spanStyle : spanStyle,
                             spanStartStyle, pos + tokenText.length == nextChange ? spanEndStyle : "", css, attributes);
          }
          if (end >= upto) {text = text.slice(upto - pos); pos = upto; break}
          pos = end;
          spanStartStyle = "";
        }
        text = allText.slice(at, at = styles[i++]);
        style = interpretTokenStyle(styles[i++], builder.cm.options);
      }
    }
  }


  // These objects are used to represent the visible (currently drawn)
  // part of the document. A LineView may correspond to multiple
  // logical lines, if those are connected by collapsed ranges.
  function LineView(doc, line, lineN) {
    // The starting line
    this.line = line;
    // Continuing lines, if any
    this.rest = visualLineContinued(line);
    // Number of logical lines in this visual line
    this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1;
    this.node = this.text = null;
    this.hidden = lineIsHidden(doc, line);
  }

  // Create a range of LineView objects for the given lines.
  function buildViewArray(cm, from, to) {
    var array = [], nextPos;
    for (var pos = from; pos < to; pos = nextPos) {
      var view = new LineView(cm.doc, getLine(cm.doc, pos), pos);
      nextPos = pos + view.size;
      array.push(view);
    }
    return array
  }

  var operationGroup = null;

  function pushOperation(op) {
    if (operationGroup) {
      operationGroup.ops.push(op);
    } else {
      op.ownsGroup = operationGroup = {
        ops: [op],
        delayedCallbacks: []
      };
    }
  }

  function fireCallbacksForOps(group) {
    // Calls delayed callbacks and cursorActivity handlers until no
    // new ones appear
    var callbacks = group.delayedCallbacks, i = 0;
    do {
      for (; i < callbacks.length; i++)
        { callbacks[i].call(null); }
      for (var j = 0; j < group.ops.length; j++) {
        var op = group.ops[j];
        if (op.cursorActivityHandlers)
          { while (op.cursorActivityCalled < op.cursorActivityHandlers.length)
            { op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm); } }
      }
    } while (i < callbacks.length)
  }

  function finishOperation(op, endCb) {
    var group = op.ownsGroup;
    if (!group) { return }

    try { fireCallbacksForOps(group); }
    finally {
      operationGroup = null;
      endCb(group);
    }
  }

  var orphanDelayedCallbacks = null;

  // Often, we want to signal events at a point where we are in the
  // middle of some work, but don't want the handler to start calling
  // other methods on the editor, which might be in an inconsistent
  // state or simply not expect any other events to happen.
  // signalLater looks whether there are any handlers, and schedules
  // them to be executed when the last operation ends, or, if no
  // operation is active, when a timeout fires.
  function signalLater(emitter, type /*, values...*/) {
    var arr = getHandlers(emitter, type);
    if (!arr.length) { return }
    var args = Array.prototype.slice.call(arguments, 2), list;
    if (operationGroup) {
      list = operationGroup.delayedCallbacks;
    } else if (orphanDelayedCallbacks) {
      list = orphanDelayedCallbacks;
    } else {
      list = orphanDelayedCallbacks = [];
      setTimeout(fireOrphanDelayed, 0);
    }
    var loop = function ( i ) {
      list.push(function () { return arr[i].apply(null, args); });
    };

    for (var i = 0; i < arr.length; ++i)
      loop( i );
  }

  function fireOrphanDelayed() {
    var delayed = orphanDelayedCallbacks;
    orphanDelayedCallbacks = null;
    for (var i = 0; i < delayed.length; ++i) { delayed[i](); }
  }

  // When an aspect of a line changes, a string is added to
  // lineView.changes. This updates the relevant part of the line's
  // DOM structure.
  function updateLineForChanges(cm, lineView, lineN, dims) {
    for (var j = 0; j < lineView.changes.length; j++) {
      var type = lineView.changes[j];
      if (type == "text") { updateLineText(cm, lineView); }
      else if (type == "gutter") { updateLineGutter(cm, lineView, lineN, dims); }
      else if (type == "class") { updateLineClasses(cm, lineView); }
      else if (type == "widget") { updateLineWidgets(cm, lineView, dims); }
    }
    lineView.changes = null;
  }

  // Lines with gutter elements, widgets or a background class need to
  // be wrapped, and have the extra elements added to the wrapper div
  function ensureLineWrapped(lineView) {
    if (lineView.node == lineView.text) {
      lineView.node = elt("div", null, null, "position: relative");
      if (lineView.text.parentNode)
        { lineView.text.parentNode.replaceChild(lineView.node, lineView.text); }
      lineView.node.appendChild(lineView.text);
      if (ie && ie_version < 8) { lineView.node.style.zIndex = 2; }
    }
    return lineView.node
  }

  function updateLineBackground(cm, lineView) {
    var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass;
    if (cls) { cls += " CodeMirror-linebackground"; }
    if (lineView.background) {
      if (cls) { lineView.background.className = cls; }
      else { lineView.background.parentNode.removeChild(lineView.background); lineView.background = null; }
    } else if (cls) {
      var wrap = ensureLineWrapped(lineView);
      lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild);
      cm.display.input.setUneditable(lineView.background);
    }
  }

  // Wrapper around buildLineContent which will reuse the structure
  // in display.externalMeasured when possible.
  function getLineContent(cm, lineView) {
    var ext = cm.display.externalMeasured;
    if (ext && ext.line == lineView.line) {
      cm.display.externalMeasured = null;
      lineView.measure = ext.measure;
      return ext.built
    }
    return buildLineContent(cm, lineView)
  }

  // Redraw the line's text. Interacts with the background and text
  // classes because the mode may output tokens that influence these
  // classes.
  function updateLineText(cm, lineView) {
    var cls = lineView.text.className;
    var built = getLineContent(cm, lineView);
    if (lineView.text == lineView.node) { lineView.node = built.pre; }
    lineView.text.parentNode.replaceChild(built.pre, lineView.text);
    lineView.text = built.pre;
    if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
      lineView.bgClass = built.bgClass;
      lineView.textClass = built.textClass;
      updateLineClasses(cm, lineView);
    } else if (cls) {
      lineView.text.className = cls;
    }
  }

  function updateLineClasses(cm, lineView) {
    updateLineBackground(cm, lineView);
    if (lineView.line.wrapClass)
      { ensureLineWrapped(lineView).className = lineView.line.wrapClass; }
    else if (lineView.node != lineView.text)
      { lineView.node.className = ""; }
    var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass;
    lineView.text.className = textClass || "";
  }

  function updateLineGutter(cm, lineView, lineN, dims) {
    if (lineView.gutter) {
      lineView.node.removeChild(lineView.gutter);
      lineView.gutter = null;
    }
    if (lineView.gutterBackground) {
      lineView.node.removeChild(lineView.gutterBackground);
      lineView.gutterBackground = null;
    }
    if (lineView.line.gutterClass) {
      var wrap = ensureLineWrapped(lineView);
      lineView.gutterBackground = elt("div", null, "CodeMirror-gutter-background " + lineView.line.gutterClass,
                                      ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px; width: " + (dims.gutterTotalWidth) + "px"));
      cm.display.input.setUneditable(lineView.gutterBackground);
      wrap.insertBefore(lineView.gutterBackground, lineView.text);
    }
    var markers = lineView.line.gutterMarkers;
    if (cm.options.lineNumbers || markers) {
      var wrap$1 = ensureLineWrapped(lineView);
      var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px"));
      cm.display.input.setUneditable(gutterWrap);
      wrap$1.insertBefore(gutterWrap, lineView.text);
      if (lineView.line.gutterClass)
        { gutterWrap.className += " " + lineView.line.gutterClass; }
      if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"]))
        { lineView.lineNumber = gutterWrap.appendChild(
          elt("div", lineNumberFor(cm.options, lineN),
              "CodeMirror-linenumber CodeMirror-gutter-elt",
              ("left: " + (dims.gutterLeft["CodeMirror-linenumbers"]) + "px; width: " + (cm.display.lineNumInnerWidth) + "px"))); }
      if (markers) { for (var k = 0; k < cm.options.gutters.length; ++k) {
        var id = cm.options.gutters[k], found = markers.hasOwnProperty(id) && markers[id];
        if (found)
          { gutterWrap.appendChild(elt("div", [found], "CodeMirror-gutter-elt",
                                     ("left: " + (dims.gutterLeft[id]) + "px; width: " + (dims.gutterWidth[id]) + "px"))); }
      } }
    }
  }

  function updateLineWidgets(cm, lineView, dims) {
    if (lineView.alignable) { lineView.alignable = null; }
    for (var node = lineView.node.firstChild, next = (void 0); node; node = next) {
      next = node.nextSibling;
      if (node.className == "CodeMirror-linewidget")
        { lineView.node.removeChild(node); }
    }
    insertLineWidgets(cm, lineView, dims);
  }

  // Build a line's DOM representation from scratch
  function buildLineElement(cm, lineView, lineN, dims) {
    var built = getLineContent(cm, lineView);
    lineView.text = lineView.node = built.pre;
    if (built.bgClass) { lineView.bgClass = built.bgClass; }
    if (built.textClass) { lineView.textClass = built.textClass; }

    updateLineClasses(cm, lineView);
    updateLineGutter(cm, lineView, lineN, dims);
    insertLineWidgets(cm, lineView, dims);
    return lineView.node
  }

  // A lineView may contain multiple logical lines (when merged by
  // collapsed spans). The widgets for all of them need to be drawn.
  function insertLineWidgets(cm, lineView, dims) {
    insertLineWidgetsFor(cm, lineView.line, lineView, dims, true);
    if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
      { insertLineWidgetsFor(cm, lineView.rest[i], lineView, dims, false); } }
  }

  function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
    if (!line.widgets) { return }
    var wrap = ensureLineWrapped(lineView);
    for (var i = 0, ws = line.widgets; i < ws.length; ++i) {
      var widget = ws[i], node = elt("div", [widget.node], "CodeMirror-linewidget");
      if (!widget.handleMouseEvents) { node.setAttribute("cm-ignore-events", "true"); }
      positionLineWidget(widget, node, lineView, dims);
      cm.display.input.setUneditable(node);
      if (allowAbove && widget.above)
        { wrap.insertBefore(node, lineView.gutter || lineView.text); }
      else
        { wrap.appendChild(node); }
      signalLater(widget, "redraw");
    }
  }

  function positionLineWidget(widget, node, lineView, dims) {
    if (widget.noHScroll) {
  (lineView.alignable || (lineView.alignable = [])).push(node);
      var width = dims.wrapperWidth;
      node.style.left = dims.fixedPos + "px";
      if (!widget.coverGutter) {
        width -= dims.gutterTotalWidth;
        node.style.paddingLeft = dims.gutterTotalWidth + "px";
      }
      node.style.width = width + "px";
    }
    if (widget.coverGutter) {
      node.style.zIndex = 5;
      node.style.position = "relative";
      if (!widget.noHScroll) { node.style.marginLeft = -dims.gutterTotalWidth + "px"; }
    }
  }

  function widgetHeight(widget) {
    if (widget.height != null) { return widget.height }
    var cm = widget.doc.cm;
    if (!cm) { return 0 }
    if (!contains(document.body, widget.node)) {
      var parentStyle = "position: relative;";
      if (widget.coverGutter)
        { parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;"; }
      if (widget.noHScroll)
        { parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;"; }
      removeChildrenAndAdd(cm.display.measure, elt("div", [widget.node], null, parentStyle));
    }
    return widget.height = widget.node.parentNode.offsetHeight
  }

  // Return true when the given mouse event happened in a widget
  function eventInWidget(display, e) {
    for (var n = e_target(e); n != display.wrapper; n = n.parentNode) {
      if (!n || (n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true") ||
          (n.parentNode == display.sizer && n != display.mover))
        { return true }
    }
  }

  // POSITION MEASUREMENT

  function paddingTop(display) {return display.lineSpace.offsetTop}
  function paddingVert(display) {return display.mover.offsetHeight - display.lineSpace.offsetHeight}
  function paddingH(display) {
    if (display.cachedPaddingH) { return display.cachedPaddingH }
    var e = removeChildrenAndAdd(display.measure, elt("pre", "x"));
    var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle;
    var data = {left: parseInt(style.paddingLeft), right: parseInt(style.paddingRight)};
    if (!isNaN(data.left) && !isNaN(data.right)) { display.cachedPaddingH = data; }
    return data
  }

  function scrollGap(cm) { return scrollerGap - cm.display.nativeBarWidth }
  function displayWidth(cm) {
    return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth
  }
  function displayHeight(cm) {
    return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight
  }

  // Ensure the lineView.wrapping.heights array is populated. This is
  // an array of bottom offsets for the lines that make up a drawn
  // line. When lineWrapping is on, there might be more than one
  // height.
  function ensureLineHeights(cm, lineView, rect) {
    var wrapping = cm.options.lineWrapping;
    var curWidth = wrapping && displayWidth(cm);
    if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
      var heights = lineView.measure.heights = [];
      if (wrapping) {
        lineView.measure.width = curWidth;
        var rects = lineView.text.firstChild.getClientRects();
        for (var i = 0; i < rects.length - 1; i++) {
          var cur = rects[i], next = rects[i + 1];
          if (Math.abs(cur.bottom - next.bottom) > 2)
            { heights.push((cur.bottom + next.top) / 2 - rect.top); }
        }
      }
      heights.push(rect.bottom - rect.top);
    }
  }

  // Find a line map (mapping character offsets to text nodes) and a
  // measurement cache for the given line number. (A line view might
  // contain multiple lines when collapsed ranges are present.)
  function mapFromLineView(lineView, line, lineN) {
    if (lineView.line == line)
      { return {map: lineView.measure.map, cache: lineView.measure.cache} }
    for (var i = 0; i < lineView.rest.length; i++)
      { if (lineView.rest[i] == line)
        { return {map: lineView.measure.maps[i], cache: lineView.measure.caches[i]} } }
    for (var i$1 = 0; i$1 < lineView.rest.length; i$1++)
      { if (lineNo(lineView.rest[i$1]) > lineN)
        { return {map: lineView.measure.maps[i$1], cache: lineView.measure.caches[i$1], before: true} } }
  }

  // Render a line into the hidden node display.externalMeasured. Used
  // when measurement is needed for a line that's not in the viewport.
  function updateExternalMeasurement(cm, line) {
    line = visualLine(line);
    var lineN = lineNo(line);
    var view = cm.display.externalMeasured = new LineView(cm.doc, line, lineN);
    view.lineN = lineN;
    var built = view.built = buildLineContent(cm, view);
    view.text = built.pre;
    removeChildrenAndAdd(cm.display.lineMeasure, built.pre);
    return view
  }

  // Get a {top, bottom, left, right} box (in line-local coordinates)
  // for a given character.
  function measureChar(cm, line, ch, bias) {
    return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias)
  }

  // Find a line view that corresponds to the given line number.
  function findViewForLine(cm, lineN) {
    if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo)
      { return cm.display.view[findViewIndex(cm, lineN)] }
    var ext = cm.display.externalMeasured;
    if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size)
      { return ext }
  }

  // Measurement can be split in two steps, the set-up work that
  // applies to the whole line, and the measurement of the actual
  // character. Functions like coordsChar, that need to do a lot of
  // measurements in a row, can thus ensure that the set-up work is
  // only done once.
  function prepareMeasureForLine(cm, line) {
    var lineN = lineNo(line);
    var view = findViewForLine(cm, lineN);
    if (view && !view.text) {
      view = null;
    } else if (view && view.changes) {
      updateLineForChanges(cm, view, lineN, getDimensions(cm));
      cm.curOp.forceUpdate = true;
    }
    if (!view)
      { view = updateExternalMeasurement(cm, line); }

    var info = mapFromLineView(view, line, lineN);
    return {
      line: line, view: view, rect: null,
      map: info.map, cache: info.cache, before: info.before,
      hasHeights: false
    }
  }

  // Given a prepared measurement object, measures the position of an
  // actual character (or fetches it from the cache).
  function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
    if (prepared.before) { ch = -1; }
    var key = ch + (bias || ""), found;
    if (prepared.cache.hasOwnProperty(key)) {
      found = prepared.cache[key];
    } else {
      if (!prepared.rect)
        { prepared.rect = prepared.view.text.getBoundingClientRect(); }
      if (!prepared.hasHeights) {
        ensureLineHeights(cm, prepared.view, prepared.rect);
        prepared.hasHeights = true;
      }
      found = measureCharInner(cm, prepared, ch, bias);
      if (!found.bogus) { prepared.cache[key] = found; }
    }
    return {left: found.left, right: found.right,
            top: varHeight ? found.rtop : found.top,
            bottom: varHeight ? found.rbottom : found.bottom}
  }

  var nullRect = {left: 0, right: 0, top: 0, bottom: 0};

  function nodeAndOffsetInLineMap(map$$1, ch, bias) {
    var node, start, end, collapse, mStart, mEnd;
    // First, search the line map for the text node corresponding to,
    // or closest to, the target character.
    for (var i = 0; i < map$$1.length; i += 3) {
      mStart = map$$1[i];
      mEnd = map$$1[i + 1];
      if (ch < mStart) {
        start = 0; end = 1;
        collapse = "left";
      } else if (ch < mEnd) {
        start = ch - mStart;
        end = start + 1;
      } else if (i == map$$1.length - 3 || ch == mEnd && map$$1[i + 3] > ch) {
        end = mEnd - mStart;
        start = end - 1;
        if (ch >= mEnd) { collapse = "right"; }
      }
      if (start != null) {
        node = map$$1[i + 2];
        if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right"))
          { collapse = bias; }
        if (bias == "left" && start == 0)
          { while (i && map$$1[i - 2] == map$$1[i - 3] && map$$1[i - 1].insertLeft) {
            node = map$$1[(i -= 3) + 2];
            collapse = "left";
          } }
        if (bias == "right" && start == mEnd - mStart)
          { while (i < map$$1.length - 3 && map$$1[i + 3] == map$$1[i + 4] && !map$$1[i + 5].insertLeft) {
            node = map$$1[(i += 3) + 2];
            collapse = "right";
          } }
        break
      }
    }
    return {node: node, start: start, end: end, collapse: collapse, coverStart: mStart, coverEnd: mEnd}
  }

  function getUsefulRect(rects, bias) {
    var rect = nullRect;
    if (bias == "left") { for (var i = 0; i < rects.length; i++) {
      if ((rect = rects[i]).left != rect.right) { break }
    } } else { for (var i$1 = rects.length - 1; i$1 >= 0; i$1--) {
      if ((rect = rects[i$1]).left != rect.right) { break }
    } }
    return rect
  }

  function measureCharInner(cm, prepared, ch, bias) {
    var place = nodeAndOffsetInLineMap(prepared.map, ch, bias);
    var node = place.node, start = place.start, end = place.end, collapse = place.collapse;

    var rect;
    if (node.nodeType == 3) { // If it is a text node, use a range to retrieve the coordinates.
      for (var i$1 = 0; i$1 < 4; i$1++) { // Retry a maximum of 4 times when nonsense rectangles are returned
        while (start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start))) { --start; }
        while (place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end))) { ++end; }
        if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart)
          { rect = node.parentNode.getBoundingClientRect(); }
        else
          { rect = getUsefulRect(range(node, start, end).getClientRects(), bias); }
        if (rect.left || rect.right || start == 0) { break }
        end = start;
        start = start - 1;
        collapse = "right";
      }
      if (ie && ie_version < 11) { rect = maybeUpdateRectForZooming(cm.display.measure, rect); }
    } else { // If it is a widget, simply get the box for the whole widget.
      if (start > 0) { collapse = bias = "right"; }
      var rects;
      if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1)
        { rect = rects[bias == "right" ? rects.length - 1 : 0]; }
      else
        { rect = node.getBoundingClientRect(); }
    }
    if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
      var rSpan = node.parentNode.getClientRects()[0];
      if (rSpan)
        { rect = {left: rSpan.left, right: rSpan.left + charWidth(cm.display), top: rSpan.top, bottom: rSpan.bottom}; }
      else
        { rect = nullRect; }
    }

    var rtop = rect.top - prepared.rect.top, rbot = rect.bottom - prepared.rect.top;
    var mid = (rtop + rbot) / 2;
    var heights = prepared.view.measure.heights;
    var i = 0;
    for (; i < heights.length - 1; i++)
      { if (mid < heights[i]) { break } }
    var top = i ? heights[i - 1] : 0, bot = heights[i];
    var result = {left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
                  right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
                  top: top, bottom: bot};
    if (!rect.left && !rect.right) { result.bogus = true; }
    if (!cm.options.singleCursorHeightPerLine) { result.rtop = rtop; result.rbottom = rbot; }

    return result
  }

  // Work around problem with bounding client rects on ranges being
  // returned incorrectly when zoomed on IE10 and below.
  function maybeUpdateRectForZooming(measure, rect) {
    if (!window.screen || screen.logicalXDPI == null ||
        screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure))
      { return rect }
    var scaleX = screen.logicalXDPI / screen.deviceXDPI;
    var scaleY = screen.logicalYDPI / screen.deviceYDPI;
    return {left: rect.left * scaleX, right: rect.right * scaleX,
            top: rect.top * scaleY, bottom: rect.bottom * scaleY}
  }

  function clearLineMeasurementCacheFor(lineView) {
    if (lineView.measure) {
      lineView.measure.cache = {};
      lineView.measure.heights = null;
      if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
        { lineView.measure.caches[i] = {}; } }
    }
  }

  function clearLineMeasurementCache(cm) {
    cm.display.externalMeasure = null;
    removeChildren(cm.display.lineMeasure);
    for (var i = 0; i < cm.display.view.length; i++)
      { clearLineMeasurementCacheFor(cm.display.view[i]); }
  }

  function clearCaches(cm) {
    clearLineMeasurementCache(cm);
    cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null;
    if (!cm.options.lineWrapping) { cm.display.maxLineChanged = true; }
    cm.display.lineNumChars = null;
  }

  function pageScrollX() {
    // Work around https://bugs.chromium.org/p/chromium/issues/detail?id=489206
    // which causes page_Offset and bounding client rects to use
    // different reference viewports and invalidate our calculations.
    if (chrome && android) { return -(document.body.getBoundingClientRect().left - parseInt(getComputedStyle(document.body).marginLeft)) }
    return window.pageXOffset || (document.documentElement || document.body).scrollLeft
  }
  function pageScrollY() {
    if (chrome && android) { return -(document.body.getBoundingClientRect().top - parseInt(getComputedStyle(document.body).marginTop)) }
    return window.pageYOffset || (document.documentElement || document.body).scrollTop
  }

  function widgetTopHeight(lineObj) {
    var height = 0;
    if (lineObj.widgets) { for (var i = 0; i < lineObj.widgets.length; ++i) { if (lineObj.widgets[i].above)
      { height += widgetHeight(lineObj.widgets[i]); } } }
    return height
  }

  // Converts a {top, bottom, left, right} box from line-local
  // coordinates into another coordinate system. Context may be one of
  // "line", "div" (display.lineDiv), "local"./null (editor), "window",
  // or "page".
  function intoCoordSystem(cm, lineObj, rect, context, includeWidgets) {
    if (!includeWidgets) {
      var height = widgetTopHeight(lineObj);
      rect.top += height; rect.bottom += height;
    }
    if (context == "line") { return rect }
    if (!context) { context = "local"; }
    var yOff = heightAtLine(lineObj);
    if (context == "local") { yOff += paddingTop(cm.display); }
    else { yOff -= cm.display.viewOffset; }
    if (context == "page" || context == "window") {
      var lOff = cm.display.lineSpace.getBoundingClientRect();
      yOff += lOff.top + (context == "window" ? 0 : pageScrollY());
      var xOff = lOff.left + (context == "window" ? 0 : pageScrollX());
      rect.left += xOff; rect.right += xOff;
    }
    rect.top += yOff; rect.bottom += yOff;
    return rect
  }

  // Coverts a box from "div" coords to another coordinate system.
  // Context may be "window", "page", "div", or "local"./null.
  function fromCoordSystem(cm, coords, context) {
    if (context == "div") { return coords }
    var left = coords.left, top = coords.top;
    // First move into "page" coordinate system
    if (context == "page") {
      left -= pageScrollX();
      top -= pageScrollY();
    } else if (context == "local" || !context) {
      var localBox = cm.display.sizer.getBoundingClientRect();
      left += localBox.left;
      top += localBox.top;
    }

    var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect();
    return {left: left - lineSpaceBox.left, top: top - lineSpaceBox.top}
  }

  function charCoords(cm, pos, context, lineObj, bias) {
    if (!lineObj) { lineObj = getLine(cm.doc, pos.line); }
    return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context)
  }

  // Returns a box for a given cursor position, which may have an
  // 'other' property containing the position of the secondary cursor
  // on a bidi boundary.
  // A cursor Pos(line, char, "before") is on the same visual line as `char - 1`
  // and after `char - 1` in writing order of `char - 1`
  // A cursor Pos(line, char, "after") is on the same visual line as `char`
  // and before `char` in writing order of `char`
  // Examples (upper-case letters are RTL, lower-case are LTR):
  //     Pos(0, 1, ...)
  //     before   after
  // ab     a|b     a|b
  // aB     a|B     aB|
  // Ab     |Ab     A|b
  // AB     B|A     B|A
  // Every position after the last character on a line is considered to stick
  // to the last character on the line.
  function cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
    lineObj = lineObj || getLine(cm.doc, pos.line);
    if (!preparedMeasure) { preparedMeasure = prepareMeasureForLine(cm, lineObj); }
    function get(ch, right) {
      var m = measureCharPrepared(cm, preparedMeasure, ch, right ? "right" : "left", varHeight);
      if (right) { m.left = m.right; } else { m.right = m.left; }
      return intoCoordSystem(cm, lineObj, m, context)
    }
    var order = getOrder(lineObj, cm.doc.direction), ch = pos.ch, sticky = pos.sticky;
    if (ch >= lineObj.text.length) {
      ch = lineObj.text.length;
      sticky = "before";
    } else if (ch <= 0) {
      ch = 0;
      sticky = "after";
    }
    if (!order) { return get(sticky == "before" ? ch - 1 : ch, sticky == "before") }

    function getBidi(ch, partPos, invert) {
      var part = order[partPos], right = part.level == 1;
      return get(invert ? ch - 1 : ch, right != invert)
    }
    var partPos = getBidiPartAt(order, ch, sticky);
    var other = bidiOther;
    var val = getBidi(ch, partPos, sticky == "before");
    if (other != null) { val.other = getBidi(ch, other, sticky != "before"); }
    return val
  }

  // Used to cheaply estimate the coordinates for a position. Used for
  // intermediate scroll updates.
  function estimateCoords(cm, pos) {
    var left = 0;
    pos = clipPos(cm.doc, pos);
    if (!cm.options.lineWrapping) { left = charWidth(cm.display) * pos.ch; }
    var lineObj = getLine(cm.doc, pos.line);
    var top = heightAtLine(lineObj) + paddingTop(cm.display);
    return {left: left, right: left, top: top, bottom: top + lineObj.height}
  }

  // Positions returned by coordsChar contain some extra information.
  // xRel is the relative x position of the input coordinates compared
  // to the found position (so xRel > 0 means the coordinates are to
  // the right of the character position, for example). When outside
  // is true, that means the coordinates lie outside the line's
  // vertical range.
  function PosWithInfo(line, ch, sticky, outside, xRel) {
    var pos = Pos(line, ch, sticky);
    pos.xRel = xRel;
    if (outside) { pos.outside = true; }
    return pos
  }

  // Compute the character position closest to the given coordinates.
  // Input must be lineSpace-local ("div" coordinate system).
  function coordsChar(cm, x, y) {
    var doc = cm.doc;
    y += cm.display.viewOffset;
    if (y < 0) { return PosWithInfo(doc.first, 0, null, true, -1) }
    var lineN = lineAtHeight(doc, y), last = doc.first + doc.size - 1;
    if (lineN > last)
      { return PosWithInfo(doc.first + doc.size - 1, getLine(doc, last).text.length, null, true, 1) }
    if (x < 0) { x = 0; }

    var lineObj = getLine(doc, lineN);
    for (;;) {
      var found = coordsCharInner(cm, lineObj, lineN, x, y);
      var collapsed = collapsedSpanAround(lineObj, found.ch + (found.xRel > 0 ? 1 : 0));
      if (!collapsed) { return found }
      var rangeEnd = collapsed.find(1);
      if (rangeEnd.line == lineN) { return rangeEnd }
      lineObj = getLine(doc, lineN = rangeEnd.line);
    }
  }

  function wrappedLineExtent(cm, lineObj, preparedMeasure, y) {
    y -= widgetTopHeight(lineObj);
    var end = lineObj.text.length;
    var begin = findFirst(function (ch) { return measureCharPrepared(cm, preparedMeasure, ch - 1).bottom <= y; }, end, 0);
    end = findFirst(function (ch) { return measureCharPrepared(cm, preparedMeasure, ch).top > y; }, begin, end);
    return {begin: begin, end: end}
  }

  function wrappedLineExtentChar(cm, lineObj, preparedMeasure, target) {
    if (!preparedMeasure) { preparedMeasure = prepareMeasureForLine(cm, lineObj); }
    var targetTop = intoCoordSystem(cm, lineObj, measureCharPrepared(cm, preparedMeasure, target), "line").top;
    return wrappedLineExtent(cm, lineObj, preparedMeasure, targetTop)
  }

  // Returns true if the given side of a box is after the given
  // coordinates, in top-to-bottom, left-to-right order.
  function boxIsAfter(box, x, y, left) {
    return box.bottom <= y ? false : box.top > y ? true : (left ? box.left : box.right) > x
  }

  function coordsCharInner(cm, lineObj, lineNo$$1, x, y) {
    // Move y into line-local coordinate space
    y -= heightAtLine(lineObj);
    var preparedMeasure = prepareMeasureForLine(cm, lineObj);
    // When directly calling `measureCharPrepared`, we have to adjust
    // for the widgets at this line.
    var widgetHeight$$1 = widgetTopHeight(lineObj);
    var begin = 0, end = lineObj.text.length, ltr = true;

    var order = getOrder(lineObj, cm.doc.direction);
    // If the line isn't plain left-to-right text, first figure out
    // which bidi section the coordinates fall into.
    if (order) {
      var part = (cm.options.lineWrapping ? coordsBidiPartWrapped : coordsBidiPart)
                   (cm, lineObj, lineNo$$1, preparedMeasure, order, x, y);
      ltr = part.level != 1;
      // The awkward -1 offsets are needed because findFirst (called
      // on these below) will treat its first bound as inclusive,
      // second as exclusive, but we want to actually address the
      // characters in the part's range
      begin = ltr ? part.from : part.to - 1;
      end = ltr ? part.to : part.from - 1;
    }

    // A binary search to find the first character whose bounding box
    // starts after the coordinates. If we run across any whose box wrap
    // the coordinates, store that.
    var chAround = null, boxAround = null;
    var ch = findFirst(function (ch) {
      var box = measureCharPrepared(cm, preparedMeasure, ch);
      box.top += widgetHeight$$1; box.bottom += widgetHeight$$1;
      if (!boxIsAfter(box, x, y, false)) { return false }
      if (box.top <= y && box.left <= x) {
        chAround = ch;
        boxAround = box;
      }
      return true
    }, begin, end);

    var baseX, sticky, outside = false;
    // If a box around the coordinates was found, use that
    if (boxAround) {
      // Distinguish coordinates nearer to the left or right side of the box
      var atLeft = x - boxAround.left < boxAround.right - x, atStart = atLeft == ltr;
      ch = chAround + (atStart ? 0 : 1);
      sticky = atStart ? "after" : "before";
      baseX = atLeft ? boxAround.left : boxAround.right;
    } else {
      // (Adjust for extended bound, if necessary.)
      if (!ltr && (ch == end || ch == begin)) { ch++; }
      // To determine which side to associate with, get the box to the
      // left of the character and compare it's vertical position to the
      // coordinates
      sticky = ch == 0 ? "after" : ch == lineObj.text.length ? "before" :
        (measureCharPrepared(cm, preparedMeasure, ch - (ltr ? 1 : 0)).bottom + widgetHeight$$1 <= y) == ltr ?
        "after" : "before";
      // Now get accurate coordinates for this place, in order to get a
      // base X position
      var coords = cursorCoords(cm, Pos(lineNo$$1, ch, sticky), "line", lineObj, preparedMeasure);
      baseX = coords.left;
      outside = y < coords.top || y >= coords.bottom;
    }

    ch = skipExtendingChars(lineObj.text, ch, 1);
    return PosWithInfo(lineNo$$1, ch, sticky, outside, x - baseX)
  }

  function coordsBidiPart(cm, lineObj, lineNo$$1, preparedMeasure, order, x, y) {
    // Bidi parts are sorted left-to-right, and in a non-line-wrapping
    // situation, we can take this ordering to correspond to the visual
    // ordering. This finds the first part whose end is after the given
    // coordinates.
    var index = findFirst(function (i) {
      var part = order[i], ltr = part.level != 1;
      return boxIsAfter(cursorCoords(cm, Pos(lineNo$$1, ltr ? part.to : part.from, ltr ? "before" : "after"),
                                     "line", lineObj, preparedMeasure), x, y, true)
    }, 0, order.length - 1);
    var part = order[index];
    // If this isn't the first part, the part's start is also after
    // the coordinates, and the coordinates aren't on the same line as
    // that start, move one part back.
    if (index > 0) {
      var ltr = part.level != 1;
      var start = cursorCoords(cm, Pos(lineNo$$1, ltr ? part.from : part.to, ltr ? "after" : "before"),
                               "line", lineObj, preparedMeasure);
      if (boxIsAfter(start, x, y, true) && start.top > y)
        { part = order[index - 1]; }
    }
    return part
  }

  function coordsBidiPartWrapped(cm, lineObj, _lineNo, preparedMeasure, order, x, y) {
    // In a wrapped line, rtl text on wrapping boundaries can do things
    // that don't correspond to the ordering in our `order` array at
    // all, so a binary search doesn't work, and we want to return a
    // part that only spans one line so that the binary search in
    // coordsCharInner is safe. As such, we first find the extent of the
    // wrapped line, and then do a flat search in which we discard any
    // spans that aren't on the line.
    var ref = wrappedLineExtent(cm, lineObj, preparedMeasure, y);
    var begin = ref.begin;
    var end = ref.end;
    if (/\s/.test(lineObj.text.charAt(end - 1))) { end--; }
    var part = null, closestDist = null;
    for (var i = 0; i < order.length; i++) {
      var p = order[i];
      if (p.from >= end || p.to <= begin) { continue }
      var ltr = p.level != 1;
      var endX = measureCharPrepared(cm, preparedMeasure, ltr ? Math.min(end, p.to) - 1 : Math.max(begin, p.from)).right;
      // Weigh against spans ending before this, so that they are only
      // picked if nothing ends after
      var dist = endX < x ? x - endX + 1e9 : endX - x;
      if (!part || closestDist > dist) {
        part = p;
        closestDist = dist;
      }
    }
    if (!part) { part = order[order.length - 1]; }
    // Clip the part to the wrapped line.
    if (part.from < begin) { part = {from: begin, to: part.to, level: part.level}; }
    if (part.to > end) { part = {from: part.from, to: end, level: part.level}; }
    return part
  }

  var measureText;
  // Compute the default text height.
  function textHeight(display) {
    if (display.cachedTextHeight != null) { return display.cachedTextHeight }
    if (measureText == null) {
      measureText = elt("pre");
      // Measure a bunch of lines, for browsers that compute
      // fractional heights.
      for (var i = 0; i < 49; ++i) {
        measureText.appendChild(document.createTextNode("x"));
        measureText.appendChild(elt("br"));
      }
      measureText.appendChild(document.createTextNode("x"));
    }
    removeChildrenAndAdd(display.measure, measureText);
    var height = measureText.offsetHeight / 50;
    if (height > 3) { display.cachedTextHeight = height; }
    removeChildren(display.measure);
    return height || 1
  }

  // Compute the default character width.
  function charWidth(display) {
    if (display.cachedCharWidth != null) { return display.cachedCharWidth }
    var anchor = elt("span", "xxxxxxxxxx");
    var pre = elt("pre", [anchor]);
    removeChildrenAndAdd(display.measure, pre);
    var rect = anchor.getBoundingClientRect(), width = (rect.right - rect.left) / 10;
    if (width > 2) { display.cachedCharWidth = width; }
    return width || 10
  }

  // Do a bulk-read of the DOM positions and sizes needed to draw the
  // view, so that we don't interleave reading and writing to the DOM.
  function getDimensions(cm) {
    var d = cm.display, left = {}, width = {};
    var gutterLeft = d.gutters.clientLeft;
    for (var n = d.gutters.firstChild, i = 0; n; n = n.nextSibling, ++i) {
      left[cm.options.gutters[i]] = n.offsetLeft + n.clientLeft + gutterLeft;
      width[cm.options.gutters[i]] = n.clientWidth;
    }
    return {fixedPos: compensateForHScroll(d),
            gutterTotalWidth: d.gutters.offsetWidth,
            gutterLeft: left,
            gutterWidth: width,
            wrapperWidth: d.wrapper.clientWidth}
  }

  // Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
  // but using getBoundingClientRect to get a sub-pixel-accurate
  // result.
  function compensateForHScroll(display) {
    return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left
  }

  // Returns a function that estimates the height of a line, to use as
  // first approximation until the line becomes visible (and is thus
  // properly measurable).
  function estimateHeight(cm) {
    var th = textHeight(cm.display), wrapping = cm.options.lineWrapping;
    var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3);
    return function (line) {
      if (lineIsHidden(cm.doc, line)) { return 0 }

      var widgetsHeight = 0;
      if (line.widgets) { for (var i = 0; i < line.widgets.length; i++) {
        if (line.widgets[i].height) { widgetsHeight += line.widgets[i].height; }
      } }

      if (wrapping)
        { return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th }
      else
        { return widgetsHeight + th }
    }
  }

  function estimateLineHeights(cm) {
    var doc = cm.doc, est = estimateHeight(cm);
    doc.iter(function (line) {
      var estHeight = est(line);
      if (estHeight != line.height) { updateLineHeight(line, estHeight); }
    });
  }

  // Given a mouse event, find the corresponding position. If liberal
  // is false, it checks whether a gutter or scrollbar was clicked,
  // and returns null if it was. forRect is used by rectangular
  // selections, and tries to estimate a character position even for
  // coordinates beyond the right of the text.
  function posFromMouse(cm, e, liberal, forRect) {
    var display = cm.display;
    if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") { return null }

    var x, y, space = display.lineSpace.getBoundingClientRect();
    // Fails unpredictably on IE[67] when mouse is dragged around quickly.
    try { x = e.clientX - space.left; y = e.clientY - space.top; }
    catch (e) { return null }
    var coords = coordsChar(cm, x, y), line;
    if (forRect && coords.xRel == 1 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
      var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length;
      coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff));
    }
    return coords
  }

  // Find the view element corresponding to a given line. Return null
  // when the line isn't visible.
  function findViewIndex(cm, n) {
    if (n >= cm.display.viewTo) { return null }
    n -= cm.display.viewFrom;
    if (n < 0) { return null }
    var view = cm.display.view;
    for (var i = 0; i < view.length; i++) {
      n -= view[i].size;
      if (n < 0) { return i }
    }
  }

  function updateSelection(cm) {
    cm.display.input.showSelection(cm.display.input.prepareSelection());
  }

  function prepareSelection(cm, primary) {
    if ( primary === void 0 ) primary = true;

    var doc = cm.doc, result = {};
    var curFragment = result.cursors = document.createDocumentFragment();
    var selFragment = result.selection = document.createDocumentFragment();

    for (var i = 0; i < doc.sel.ranges.length; i++) {
      if (!primary && i == doc.sel.primIndex) { continue }
      var range$$1 = doc.sel.ranges[i];
      if (range$$1.from().line >= cm.display.viewTo || range$$1.to().line < cm.display.viewFrom) { continue }
      var collapsed = range$$1.empty();
      if (collapsed || cm.options.showCursorWhenSelecting)
        { drawSelectionCursor(cm, range$$1.head, curFragment); }
      if (!collapsed)
        { drawSelectionRange(cm, range$$1, selFragment); }
    }
    return result
  }

  // Draws a cursor for the given range
  function drawSelectionCursor(cm, head, output) {
    var pos = cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine);

    var cursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor"));
    cursor.style.left = pos.left + "px";
    cursor.style.top = pos.top + "px";
    cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px";

    if (pos.other) {
      // Secondary cursor, shown when on a 'jump' in bi-directional text
      var otherCursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor CodeMirror-secondarycursor"));
      otherCursor.style.display = "";
      otherCursor.style.left = pos.other.left + "px";
      otherCursor.style.top = pos.other.top + "px";
      otherCursor.style.height = (pos.other.bottom - pos.other.top) * .85 + "px";
    }
  }

  function cmpCoords(a, b) { return a.top - b.top || a.left - b.left }

  // Draws the given range as a highlighted selection
  function drawSelectionRange(cm, range$$1, output) {
    var display = cm.display, doc = cm.doc;
    var fragment = document.createDocumentFragment();
    var padding = paddingH(cm.display), leftSide = padding.left;
    var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right;
    var docLTR = doc.direction == "ltr";

    function add(left, top, width, bottom) {
      if (top < 0) { top = 0; }
      top = Math.round(top);
      bottom = Math.round(bottom);
      fragment.appendChild(elt("div", null, "CodeMirror-selected", ("position: absolute; left: " + left + "px;\n                             top: " + top + "px; width: " + (width == null ? rightSide - left : width) + "px;\n                             height: " + (bottom - top) + "px")));
    }

    function drawForLine(line, fromArg, toArg) {
      var lineObj = getLine(doc, line);
      var lineLen = lineObj.text.length;
      var start, end;
      function coords(ch, bias) {
        return charCoords(cm, Pos(line, ch), "div", lineObj, bias)
      }

      function wrapX(pos, dir, side) {
        var extent = wrappedLineExtentChar(cm, lineObj, null, pos);
        var prop = (dir == "ltr") == (side == "after") ? "left" : "right";
        var ch = side == "after" ? extent.begin : extent.end - (/\s/.test(lineObj.text.charAt(extent.end - 1)) ? 2 : 1);
        return coords(ch, prop)[prop]
      }

      var order = getOrder(lineObj, doc.direction);
      iterateBidiSections(order, fromArg || 0, toArg == null ? lineLen : toArg, function (from, to, dir, i) {
        var ltr = dir == "ltr";
        var fromPos = coords(from, ltr ? "left" : "right");
        var toPos = coords(to - 1, ltr ? "right" : "left");

        var openStart = fromArg == null && from == 0, openEnd = toArg == null && to == lineLen;
        var first = i == 0, last = !order || i == order.length - 1;
        if (toPos.top - fromPos.top <= 3) { // Single line
          var openLeft = (docLTR ? openStart : openEnd) && first;
          var openRight = (docLTR ? openEnd : openStart) && last;
          var left = openLeft ? leftSide : (ltr ? fromPos : toPos).left;
          var right = openRight ? rightSide : (ltr ? toPos : fromPos).right;
          add(left, fromPos.top, right - left, fromPos.bottom);
        } else { // Multiple lines
          var topLeft, topRight, botLeft, botRight;
          if (ltr) {
            topLeft = docLTR && openStart && first ? leftSide : fromPos.left;
            topRight = docLTR ? rightSide : wrapX(from, dir, "before");
            botLeft = docLTR ? leftSide : wrapX(to, dir, "after");
            botRight = docLTR && openEnd && last ? rightSide : toPos.right;
          } else {
            topLeft = !docLTR ? leftSide : wrapX(from, dir, "before");
            topRight = !docLTR && openStart && first ? rightSide : fromPos.right;
            botLeft = !docLTR && openEnd && last ? leftSide : toPos.left;
            botRight = !docLTR ? rightSide : wrapX(to, dir, "after");
          }
          add(topLeft, fromPos.top, topRight - topLeft, fromPos.bottom);
          if (fromPos.bottom < toPos.top) { add(leftSide, fromPos.bottom, null, toPos.top); }
          add(botLeft, toPos.top, botRight - botLeft, toPos.bottom);
        }

        if (!start || cmpCoords(fromPos, start) < 0) { start = fromPos; }
        if (cmpCoords(toPos, start) < 0) { start = toPos; }
        if (!end || cmpCoords(fromPos, end) < 0) { end = fromPos; }
        if (cmpCoords(toPos, end) < 0) { end = toPos; }
      });
      return {start: start, end: end}
    }

    var sFrom = range$$1.from(), sTo = range$$1.to();
    if (sFrom.line == sTo.line) {
      drawForLine(sFrom.line, sFrom.ch, sTo.ch);
    } else {
      var fromLine = getLine(doc, sFrom.line), toLine = getLine(doc, sTo.line);
      var singleVLine = visualLine(fromLine) == visualLine(toLine);
      var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end;
      var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start;
      if (singleVLine) {
        if (leftEnd.top < rightStart.top - 2) {
          add(leftEnd.right, leftEnd.top, null, leftEnd.bottom);
          add(leftSide, rightStart.top, rightStart.left, rightStart.bottom);
        } else {
          add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom);
        }
      }
      if (leftEnd.bottom < rightStart.top)
        { add(leftSide, leftEnd.bottom, null, rightStart.top); }
    }

    output.appendChild(fragment);
  }

  // Cursor-blinking
  function restartBlink(cm) {
    if (!cm.state.focused) { return }
    var display = cm.display;
    clearInterval(display.blinker);
    var on = true;
    display.cursorDiv.style.visibility = "";
    if (cm.options.cursorBlinkRate > 0)
      { display.blinker = setInterval(function () { return display.cursorDiv.style.visibility = (on = !on) ? "" : "hidden"; },
        cm.options.cursorBlinkRate); }
    else if (cm.options.cursorBlinkRate < 0)
      { display.cursorDiv.style.visibility = "hidden"; }
  }

  function ensureFocus(cm) {
    if (!cm.state.focused) { cm.display.input.focus(); onFocus(cm); }
  }

  function delayBlurEvent(cm) {
    cm.state.delayingBlurEvent = true;
    setTimeout(function () { if (cm.state.delayingBlurEvent) {
      cm.state.delayingBlurEvent = false;
      onBlur(cm);
    } }, 100);
  }

  function onFocus(cm, e) {
    if (cm.state.delayingBlurEvent) { cm.state.delayingBlurEvent = false; }

    if (cm.options.readOnly == "nocursor") { return }
    if (!cm.state.focused) {
      signal(cm, "focus", cm, e);
      cm.state.focused = true;
      addClass(cm.display.wrapper, "CodeMirror-focused");
      // This test prevents this from firing when a context
      // menu is closed (since the input reset would kill the
      // select-all detection hack)
      if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
        cm.display.input.reset();
        if (webkit) { setTimeout(function () { return cm.display.input.reset(true); }, 20); } // Issue #1730
      }
      cm.display.input.receivedFocus();
    }
    restartBlink(cm);
  }
  function onBlur(cm, e) {
    if (cm.state.delayingBlurEvent) { return }

    if (cm.state.focused) {
      signal(cm, "blur", cm, e);
      cm.state.focused = false;
      rmClass(cm.display.wrapper, "CodeMirror-focused");
    }
    clearInterval(cm.display.blinker);
    setTimeout(function () { if (!cm.state.focused) { cm.display.shift = false; } }, 150);
  }

  // Read the actual heights of the rendered lines, and update their
  // stored heights to match.
  function updateHeightsInViewport(cm) {
    var display = cm.display;
    var prevBottom = display.lineDiv.offsetTop;
    for (var i = 0; i < display.view.length; i++) {
      var cur = display.view[i], wrapping = cm.options.lineWrapping;
      var height = (void 0), width = 0;
      if (cur.hidden) { continue }
      if (ie && ie_version < 8) {
        var bot = cur.node.offsetTop + cur.node.offsetHeight;
        height = bot - prevBottom;
        prevBottom = bot;
      } else {
        var box = cur.node.getBoundingClientRect();
        height = box.bottom - box.top;
        // Check that lines don't extend past the right of the current
        // editor width
        if (!wrapping && cur.text.firstChild)
          { width = cur.text.firstChild.getBoundingClientRect().right - box.left - 1; }
      }
      var diff = cur.line.height - height;
      if (height < 2) { height = textHeight(display); }
      if (diff > .005 || diff < -.005) {
        updateLineHeight(cur.line, height);
        updateWidgetHeight(cur.line);
        if (cur.rest) { for (var j = 0; j < cur.rest.length; j++)
          { updateWidgetHeight(cur.rest[j]); } }
      }
      if (width > cm.display.sizerWidth) {
        var chWidth = Math.ceil(width / charWidth(cm.display));
        if (chWidth > cm.display.maxLineLength) {
          cm.display.maxLineLength = chWidth;
          cm.display.maxLine = cur.line;
          cm.display.maxLineChanged = true;
        }
      }
    }
  }

  // Read and store the height of line widgets associated with the
  // given line.
  function updateWidgetHeight(line) {
    if (line.widgets) { for (var i = 0; i < line.widgets.length; ++i) {
      var w = line.widgets[i], parent = w.node.parentNode;
      if (parent) { w.height = parent.offsetHeight; }
    } }
  }

  // Compute the lines that are visible in a given viewport (defaults
  // the the current scroll position). viewport may contain top,
  // height, and ensure (see op.scrollToPos) properties.
  function visibleLines(display, doc, viewport) {
    var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop;
    top = Math.floor(top - paddingTop(display));
    var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight;

    var from = lineAtHeight(doc, top), to = lineAtHeight(doc, bottom);
    // Ensure is a {from: {line, ch}, to: {line, ch}} object, and
    // forces those lines into the viewport (if possible).
    if (viewport && viewport.ensure) {
      var ensureFrom = viewport.ensure.from.line, ensureTo = viewport.ensure.to.line;
      if (ensureFrom < from) {
        from = ensureFrom;
        to = lineAtHeight(doc, heightAtLine(getLine(doc, ensureFrom)) + display.wrapper.clientHeight);
      } else if (Math.min(ensureTo, doc.lastLine()) >= to) {
        from = lineAtHeight(doc, heightAtLine(getLine(doc, ensureTo)) - display.wrapper.clientHeight);
        to = ensureTo;
      }
    }
    return {from: from, to: Math.max(to, from + 1)}
  }

  // Re-align line numbers and gutter marks to compensate for
  // horizontal scrolling.
  function alignHorizontally(cm) {
    var display = cm.display, view = display.view;
    if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) { return }
    var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft;
    var gutterW = display.gutters.offsetWidth, left = comp + "px";
    for (var i = 0; i < view.length; i++) { if (!view[i].hidden) {
      if (cm.options.fixedGutter) {
        if (view[i].gutter)
          { view[i].gutter.style.left = left; }
        if (view[i].gutterBackground)
          { view[i].gutterBackground.style.left = left; }
      }
      var align = view[i].alignable;
      if (align) { for (var j = 0; j < align.length; j++)
        { align[j].style.left = left; } }
    } }
    if (cm.options.fixedGutter)
      { display.gutters.style.left = (comp + gutterW) + "px"; }
  }

  // Used to ensure that the line number gutter is still the right
  // size for the current document size. Returns true when an update
  // is needed.
  function maybeUpdateLineNumberWidth(cm) {
    if (!cm.options.lineNumbers) { return false }
    var doc = cm.doc, last = lineNumberFor(cm.options, doc.first + doc.size - 1), display = cm.display;
    if (last.length != display.lineNumChars) {
      var test = display.measure.appendChild(elt("div", [elt("div", last)],
                                                 "CodeMirror-linenumber CodeMirror-gutter-elt"));
      var innerW = test.firstChild.offsetWidth, padding = test.offsetWidth - innerW;
      display.lineGutter.style.width = "";
      display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1;
      display.lineNumWidth = display.lineNumInnerWidth + padding;
      display.lineNumChars = display.lineNumInnerWidth ? last.length : -1;
      display.lineGutter.style.width = display.lineNumWidth + "px";
      updateGutterSpace(cm);
      return true
    }
    return false
  }

  // SCROLLING THINGS INTO VIEW

  // If an editor sits on the top or bottom of the window, partially
  // scrolled out of view, this ensures that the cursor is visible.
  function maybeScrollWindow(cm, rect) {
    if (signalDOMEvent(cm, "scrollCursorIntoView")) { return }

    var display = cm.display, box = display.sizer.getBoundingClientRect(), doScroll = null;
    if (rect.top + box.top < 0) { doScroll = true; }
    else if (rect.bottom + box.top > (window.innerHeight || document.documentElement.clientHeight)) { doScroll = false; }
    if (doScroll != null && !phantom) {
      var scrollNode = elt("div", "\u200b", null, ("position: absolute;\n                         top: " + (rect.top - display.viewOffset - paddingTop(cm.display)) + "px;\n                         height: " + (rect.bottom - rect.top + scrollGap(cm) + display.barHeight) + "px;\n                         left: " + (rect.left) + "px; width: " + (Math.max(2, rect.right - rect.left)) + "px;"));
      cm.display.lineSpace.appendChild(scrollNode);
      scrollNode.scrollIntoView(doScroll);
      cm.display.lineSpace.removeChild(scrollNode);
    }
  }

  // Scroll a given position into view (immediately), verifying that
  // it actually became visible (as line heights are accurately
  // measured, the position of something may 'drift' during drawing).
  function scrollPosIntoView(cm, pos, end, margin) {
    if (margin == null) { margin = 0; }
    var rect;
    if (!cm.options.lineWrapping && pos == end) {
      // Set pos and end to the cursor positions around the character pos sticks to
      // If pos.sticky == "before", that is around pos.ch - 1, otherwise around pos.ch
      // If pos == Pos(_, 0, "before"), pos and end are unchanged
      pos = pos.ch ? Pos(pos.line, pos.sticky == "before" ? pos.ch - 1 : pos.ch, "after") : pos;
      end = pos.sticky == "before" ? Pos(pos.line, pos.ch + 1, "before") : pos;
    }
    for (var limit = 0; limit < 5; limit++) {
      var changed = false;
      var coords = cursorCoords(cm, pos);
      var endCoords = !end || end == pos ? coords : cursorCoords(cm, end);
      rect = {left: Math.min(coords.left, endCoords.left),
              top: Math.min(coords.top, endCoords.top) - margin,
              right: Math.max(coords.left, endCoords.left),
              bottom: Math.max(coords.bottom, endCoords.bottom) + margin};
      var scrollPos = calculateScrollPos(cm, rect);
      var startTop = cm.doc.scrollTop, startLeft = cm.doc.scrollLeft;
      if (scrollPos.scrollTop != null) {
        updateScrollTop(cm, scrollPos.scrollTop);
        if (Math.abs(cm.doc.scrollTop - startTop) > 1) { changed = true; }
      }
      if (scrollPos.scrollLeft != null) {
        setScrollLeft(cm, scrollPos.scrollLeft);
        if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) { changed = true; }
      }
      if (!changed) { break }
    }
    return rect
  }

  // Scroll a given set of coordinates into view (immediately).
  function scrollIntoView(cm, rect) {
    var scrollPos = calculateScrollPos(cm, rect);
    if (scrollPos.scrollTop != null) { updateScrollTop(cm, scrollPos.scrollTop); }
    if (scrollPos.scrollLeft != null) { setScrollLeft(cm, scrollPos.scrollLeft); }
  }

  // Calculate a new scroll position needed to scroll the given
  // rectangle into view. Returns an object with scrollTop and
  // scrollLeft properties. When these are undefined, the
  // vertical/horizontal position does not need to be adjusted.
  function calculateScrollPos(cm, rect) {
    var display = cm.display, snapMargin = textHeight(cm.display);
    if (rect.top < 0) { rect.top = 0; }
    var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop;
    var screen = displayHeight(cm), result = {};
    if (rect.bottom - rect.top > screen) { rect.bottom = rect.top + screen; }
    var docBottom = cm.doc.height + paddingVert(display);
    var atTop = rect.top < snapMargin, atBottom = rect.bottom > docBottom - snapMargin;
    if (rect.top < screentop) {
      result.scrollTop = atTop ? 0 : rect.top;
    } else if (rect.bottom > screentop + screen) {
      var newTop = Math.min(rect.top, (atBottom ? docBottom : rect.bottom) - screen);
      if (newTop != screentop) { result.scrollTop = newTop; }
    }

    var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft;
    var screenw = displayWidth(cm) - (cm.options.fixedGutter ? display.gutters.offsetWidth : 0);
    var tooWide = rect.right - rect.left > screenw;
    if (tooWide) { rect.right = rect.left + screenw; }
    if (rect.left < 10)
      { result.scrollLeft = 0; }
    else if (rect.left < screenleft)
      { result.scrollLeft = Math.max(0, rect.left - (tooWide ? 0 : 10)); }
    else if (rect.right > screenw + screenleft - 3)
      { result.scrollLeft = rect.right + (tooWide ? 0 : 10) - screenw; }
    return result
  }

  // Store a relative adjustment to the scroll position in the current
  // operation (to be applied when the operation finishes).
  function addToScrollTop(cm, top) {
    if (top == null) { return }
    resolveScrollToPos(cm);
    cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top;
  }

  // Make sure that at the end of the operation the current cursor is
  // shown.
  function ensureCursorVisible(cm) {
    resolveScrollToPos(cm);
    var cur = cm.getCursor();
    cm.curOp.scrollToPos = {from: cur, to: cur, margin: cm.options.cursorScrollMargin};
  }

  function scrollToCoords(cm, x, y) {
    if (x != null || y != null) { resolveScrollToPos(cm); }
    if (x != null) { cm.curOp.scrollLeft = x; }
    if (y != null) { cm.curOp.scrollTop = y; }
  }

  function scrollToRange(cm, range$$1) {
    resolveScrollToPos(cm);
    cm.curOp.scrollToPos = range$$1;
  }

  // When an operation has its scrollToPos property set, and another
  // scroll action is applied before the end of the operation, this
  // 'simulates' scrolling that position into view in a cheap way, so
  // that the effect of intermediate scroll commands is not ignored.
  function resolveScrollToPos(cm) {
    var range$$1 = cm.curOp.scrollToPos;
    if (range$$1) {
      cm.curOp.scrollToPos = null;
      var from = estimateCoords(cm, range$$1.from), to = estimateCoords(cm, range$$1.to);
      scrollToCoordsRange(cm, from, to, range$$1.margin);
    }
  }

  function scrollToCoordsRange(cm, from, to, margin) {
    var sPos = calculateScrollPos(cm, {
      left: Math.min(from.left, to.left),
      top: Math.min(from.top, to.top) - margin,
      right: Math.max(from.right, to.right),
      bottom: Math.max(from.bottom, to.bottom) + margin
    });
    scrollToCoords(cm, sPos.scrollLeft, sPos.scrollTop);
  }

  // Sync the scrollable area and scrollbars, ensure the viewport
  // covers the visible area.
  function updateScrollTop(cm, val) {
    if (Math.abs(cm.doc.scrollTop - val) < 2) { return }
    if (!gecko) { updateDisplaySimple(cm, {top: val}); }
    setScrollTop(cm, val, true);
    if (gecko) { updateDisplaySimple(cm); }
    startWorker(cm, 100);
  }

  function setScrollTop(cm, val, forceScroll) {
    val = Math.min(cm.display.scroller.scrollHeight - cm.display.scroller.clientHeight, val);
    if (cm.display.scroller.scrollTop == val && !forceScroll) { return }
    cm.doc.scrollTop = val;
    cm.display.scrollbars.setScrollTop(val);
    if (cm.display.scroller.scrollTop != val) { cm.display.scroller.scrollTop = val; }
  }

  // Sync scroller and scrollbar, ensure the gutter elements are
  // aligned.
  function setScrollLeft(cm, val, isScroller, forceScroll) {
    val = Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth);
    if ((isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) && !forceScroll) { return }
    cm.doc.scrollLeft = val;
    alignHorizontally(cm);
    if (cm.display.scroller.scrollLeft != val) { cm.display.scroller.scrollLeft = val; }
    cm.display.scrollbars.setScrollLeft(val);
  }

  // SCROLLBARS

  // Prepare DOM reads needed to update the scrollbars. Done in one
  // shot to minimize update/measure roundtrips.
  function measureForScrollbars(cm) {
    var d = cm.display, gutterW = d.gutters.offsetWidth;
    var docH = Math.round(cm.doc.height + paddingVert(cm.display));
    return {
      clientHeight: d.scroller.clientHeight,
      viewHeight: d.wrapper.clientHeight,
      scrollWidth: d.scroller.scrollWidth, clientWidth: d.scroller.clientWidth,
      viewWidth: d.wrapper.clientWidth,
      barLeft: cm.options.fixedGutter ? gutterW : 0,
      docHeight: docH,
      scrollHeight: docH + scrollGap(cm) + d.barHeight,
      nativeBarWidth: d.nativeBarWidth,
      gutterWidth: gutterW
    }
  }

  var NativeScrollbars = function(place, scroll, cm) {
    this.cm = cm;
    var vert = this.vert = elt("div", [elt("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar");
    var horiz = this.horiz = elt("div", [elt("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar");
    vert.tabIndex = horiz.tabIndex = -1;
    place(vert); place(horiz);

    on(vert, "scroll", function () {
      if (vert.clientHeight) { scroll(vert.scrollTop, "vertical"); }
    });
    on(horiz, "scroll", function () {
      if (horiz.clientWidth) { scroll(horiz.scrollLeft, "horizontal"); }
    });

    this.checkedZeroWidth = false;
    // Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
    if (ie && ie_version < 8) { this.horiz.style.minHeight = this.vert.style.minWidth = "18px"; }
  };

  NativeScrollbars.prototype.update = function (measure) {
    var needsH = measure.scrollWidth > measure.clientWidth + 1;
    var needsV = measure.scrollHeight > measure.clientHeight + 1;
    var sWidth = measure.nativeBarWidth;

    if (needsV) {
      this.vert.style.display = "block";
      this.vert.style.bottom = needsH ? sWidth + "px" : "0";
      var totalHeight = measure.viewHeight - (needsH ? sWidth : 0);
      // A bug in IE8 can cause this value to be negative, so guard it.
      this.vert.firstChild.style.height =
        Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px";
    } else {
      this.vert.style.display = "";
      this.vert.firstChild.style.height = "0";
    }

    if (needsH) {
      this.horiz.style.display = "block";
      this.horiz.style.right = needsV ? sWidth + "px" : "0";
      this.horiz.style.left = measure.barLeft + "px";
      var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0);
      this.horiz.firstChild.style.width =
        Math.max(0, measure.scrollWidth - measure.clientWidth + totalWidth) + "px";
    } else {
      this.horiz.style.display = "";
      this.horiz.firstChild.style.width = "0";
    }

    if (!this.checkedZeroWidth && measure.clientHeight > 0) {
      if (sWidth == 0) { this.zeroWidthHack(); }
      this.checkedZeroWidth = true;
    }

    return {right: needsV ? sWidth : 0, bottom: needsH ? sWidth : 0}
  };

  NativeScrollbars.prototype.setScrollLeft = function (pos) {
    if (this.horiz.scrollLeft != pos) { this.horiz.scrollLeft = pos; }
    if (this.disableHoriz) { this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz"); }
  };

  NativeScrollbars.prototype.setScrollTop = function (pos) {
    if (this.vert.scrollTop != pos) { this.vert.scrollTop = pos; }
    if (this.disableVert) { this.enableZeroWidthBar(this.vert, this.disableVert, "vert"); }
  };

  NativeScrollbars.prototype.zeroWidthHack = function () {
    var w = mac && !mac_geMountainLion ? "12px" : "18px";
    this.horiz.style.height = this.vert.style.width = w;
    this.horiz.style.pointerEvents = this.vert.style.pointerEvents = "none";
    this.disableHoriz = new Delayed;
    this.disableVert = new Delayed;
  };

  NativeScrollbars.prototype.enableZeroWidthBar = function (bar, delay, type) {
    bar.style.pointerEvents = "auto";
    function maybeDisable() {
      // To find out whether the scrollbar is still visible, we
      // check whether the element under the pixel in the bottom
      // right corner of the scrollbar box is the scrollbar box
      // itself (when the bar is still visible) or its filler child
      // (when the bar is hidden). If it is still visible, we keep
      // it enabled, if it's hidden, we disable pointer events.
      var box = bar.getBoundingClientRect();
      var elt$$1 = type == "vert" ? document.elementFromPoint(box.right - 1, (box.top + box.bottom) / 2)
          : document.elementFromPoint((box.right + box.left) / 2, box.bottom - 1);
      if (elt$$1 != bar) { bar.style.pointerEvents = "none"; }
      else { delay.set(1000, maybeDisable); }
    }
    delay.set(1000, maybeDisable);
  };

  NativeScrollbars.prototype.clear = function () {
    var parent = this.horiz.parentNode;
    parent.removeChild(this.horiz);
    parent.removeChild(this.vert);
  };

  var NullScrollbars = function () {};

  NullScrollbars.prototype.update = function () { return {bottom: 0, right: 0} };
  NullScrollbars.prototype.setScrollLeft = function () {};
  NullScrollbars.prototype.setScrollTop = function () {};
  NullScrollbars.prototype.clear = function () {};

  function updateScrollbars(cm, measure) {
    if (!measure) { measure = measureForScrollbars(cm); }
    var startWidth = cm.display.barWidth, startHeight = cm.display.barHeight;
    updateScrollbarsInner(cm, measure);
    for (var i = 0; i < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i++) {
      if (startWidth != cm.display.barWidth && cm.options.lineWrapping)
        { updateHeightsInViewport(cm); }
      updateScrollbarsInner(cm, measureForScrollbars(cm));
      startWidth = cm.display.barWidth; startHeight = cm.display.barHeight;
    }
  }

  // Re-synchronize the fake scrollbars with the actual size of the
  // content.
  function updateScrollbarsInner(cm, measure) {
    var d = cm.display;
    var sizes = d.scrollbars.update(measure);

    d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px";
    d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px";
    d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent";

    if (sizes.right && sizes.bottom) {
      d.scrollbarFiller.style.display = "block";
      d.scrollbarFiller.style.height = sizes.bottom + "px";
      d.scrollbarFiller.style.width = sizes.right + "px";
    } else { d.scrollbarFiller.style.display = ""; }
    if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
      d.gutterFiller.style.display = "block";
      d.gutterFiller.style.height = sizes.bottom + "px";
      d.gutterFiller.style.width = measure.gutterWidth + "px";
    } else { d.gutterFiller.style.display = ""; }
  }

  var scrollbarModel = {"native": NativeScrollbars, "null": NullScrollbars};

  function initScrollbars(cm) {
    if (cm.display.scrollbars) {
      cm.display.scrollbars.clear();
      if (cm.display.scrollbars.addClass)
        { rmClass(cm.display.wrapper, cm.display.scrollbars.addClass); }
    }

    cm.display.scrollbars = new scrollbarModel[cm.options.scrollbarStyle](function (node) {
      cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller);
      // Prevent clicks in the scrollbars from killing focus
      on(node, "mousedown", function () {
        if (cm.state.focused) { setTimeout(function () { return cm.display.input.focus(); }, 0); }
      });
      node.setAttribute("cm-not-content", "true");
    }, function (pos, axis) {
      if (axis == "horizontal") { setScrollLeft(cm, pos); }
      else { updateScrollTop(cm, pos); }
    }, cm);
    if (cm.display.scrollbars.addClass)
      { addClass(cm.display.wrapper, cm.display.scrollbars.addClass); }
  }

  // Operations are used to wrap a series of changes to the editor
  // state in such a way that each change won't have to update the
  // cursor and display (which would be awkward, slow, and
  // error-prone). Instead, display updates are batched and then all
  // combined and executed at once.

  var nextOpId = 0;
  // Start a new operation.
  function startOperation(cm) {
    cm.curOp = {
      cm: cm,
      viewChanged: false,      // Flag that indicates that lines might need to be redrawn
      startHeight: cm.doc.height, // Used to detect need to update scrollbar
      forceUpdate: false,      // Used to force a redraw
      updateInput: 0,       // Whether to reset the input textarea
      typing: false,           // Whether this reset should be careful to leave existing text (for compositing)
      changeObjs: null,        // Accumulated changes, for firing change events
      cursorActivityHandlers: null, // Set of handlers to fire cursorActivity on
      cursorActivityCalled: 0, // Tracks which cursorActivity handlers have been called already
      selectionChanged: false, // Whether the selection needs to be redrawn
      updateMaxLine: false,    // Set when the widest line needs to be determined anew
      scrollLeft: null, scrollTop: null, // Intermediate scroll position, not pushed to DOM yet
      scrollToPos: null,       // Used to scroll to a specific position
      focus: false,
      id: ++nextOpId           // Unique ID
    };
    pushOperation(cm.curOp);
  }

  // Finish an operation, updating the display and signalling delayed events
  function endOperation(cm) {
    var op = cm.curOp;
    if (op) { finishOperation(op, function (group) {
      for (var i = 0; i < group.ops.length; i++)
        { group.ops[i].cm.curOp = null; }
      endOperations(group);
    }); }
  }

  // The DOM updates done when an operation finishes are batched so
  // that the minimum number of relayouts are required.
  function endOperations(group) {
    var ops = group.ops;
    for (var i = 0; i < ops.length; i++) // Read DOM
      { endOperation_R1(ops[i]); }
    for (var i$1 = 0; i$1 < ops.length; i$1++) // Write DOM (maybe)
      { endOperation_W1(ops[i$1]); }
    for (var i$2 = 0; i$2 < ops.length; i$2++) // Read DOM
      { endOperation_R2(ops[i$2]); }
    for (var i$3 = 0; i$3 < ops.length; i$3++) // Write DOM (maybe)
      { endOperation_W2(ops[i$3]); }
    for (var i$4 = 0; i$4 < ops.length; i$4++) // Read DOM
      { endOperation_finish(ops[i$4]); }
  }

  function endOperation_R1(op) {
    var cm = op.cm, display = cm.display;
    maybeClipScrollbars(cm);
    if (op.updateMaxLine) { findMaxLine(cm); }

    op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null ||
      op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom ||
                         op.scrollToPos.to.line >= display.viewTo) ||
      display.maxLineChanged && cm.options.lineWrapping;
    op.update = op.mustUpdate &&
      new DisplayUpdate(cm, op.mustUpdate && {top: op.scrollTop, ensure: op.scrollToPos}, op.forceUpdate);
  }

  function endOperation_W1(op) {
    op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update);
  }

  function endOperation_R2(op) {
    var cm = op.cm, display = cm.display;
    if (op.updatedDisplay) { updateHeightsInViewport(cm); }

    op.barMeasure = measureForScrollbars(cm);

    // If the max line changed since it was last measured, measure it,
    // and ensure the document's width matches it.
    // updateDisplay_W2 will use these properties to do the actual resizing
    if (display.maxLineChanged && !cm.options.lineWrapping) {
      op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3;
      cm.display.sizerWidth = op.adjustWidthTo;
      op.barMeasure.scrollWidth =
        Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth);
      op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm));
    }

    if (op.updatedDisplay || op.selectionChanged)
      { op.preparedSelection = display.input.prepareSelection(); }
  }

  function endOperation_W2(op) {
    var cm = op.cm;

    if (op.adjustWidthTo != null) {
      cm.display.sizer.style.minWidth = op.adjustWidthTo + "px";
      if (op.maxScrollLeft < cm.doc.scrollLeft)
        { setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true); }
      cm.display.maxLineChanged = false;
    }

    var takeFocus = op.focus && op.focus == activeElt();
    if (op.preparedSelection)
      { cm.display.input.showSelection(op.preparedSelection, takeFocus); }
    if (op.updatedDisplay || op.startHeight != cm.doc.height)
      { updateScrollbars(cm, op.barMeasure); }
    if (op.updatedDisplay)
      { setDocumentHeight(cm, op.barMeasure); }

    if (op.selectionChanged) { restartBlink(cm); }

    if (cm.state.focused && op.updateInput)
      { cm.display.input.reset(op.typing); }
    if (takeFocus) { ensureFocus(op.cm); }
  }

  function endOperation_finish(op) {
    var cm = op.cm, display = cm.display, doc = cm.doc;

    if (op.updatedDisplay) { postUpdateDisplay(cm, op.update); }

    // Abort mouse wheel delta measurement, when scrolling explicitly
    if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos))
      { display.wheelStartX = display.wheelStartY = null; }

    // Propagate the scroll position to the actual DOM scroller
    if (op.scrollTop != null) { setScrollTop(cm, op.scrollTop, op.forceScroll); }

    if (op.scrollLeft != null) { setScrollLeft(cm, op.scrollLeft, true, true); }
    // If we need to scroll a specific position into view, do so.
    if (op.scrollToPos) {
      var rect = scrollPosIntoView(cm, clipPos(doc, op.scrollToPos.from),
                                   clipPos(doc, op.scrollToPos.to), op.scrollToPos.margin);
      maybeScrollWindow(cm, rect);
    }

    // Fire events for markers that are hidden/unidden by editing or
    // undoing
    var hidden = op.maybeHiddenMarkers, unhidden = op.maybeUnhiddenMarkers;
    if (hidden) { for (var i = 0; i < hidden.length; ++i)
      { if (!hidden[i].lines.length) { signal(hidden[i], "hide"); } } }
    if (unhidden) { for (var i$1 = 0; i$1 < unhidden.length; ++i$1)
      { if (unhidden[i$1].lines.length) { signal(unhidden[i$1], "unhide"); } } }

    if (display.wrapper.offsetHeight)
      { doc.scrollTop = cm.display.scroller.scrollTop; }

    // Fire change events, and delayed event handlers
    if (op.changeObjs)
      { signal(cm, "changes", cm, op.changeObjs); }
    if (op.update)
      { op.update.finish(); }
  }

  // Run the given function in an operation
  function runInOp(cm, f) {
    if (cm.curOp) { return f() }
    startOperation(cm);
    try { return f() }
    finally { endOperation(cm); }
  }
  // Wraps a function in an operation. Returns the wrapped function.
  function operation(cm, f) {
    return function() {
      if (cm.curOp) { return f.apply(cm, arguments) }
      startOperation(cm);
      try { return f.apply(cm, arguments) }
      finally { endOperation(cm); }
    }
  }
  // Used to add methods to editor and doc instances, wrapping them in
  // operations.
  function methodOp(f) {
    return function() {
      if (this.curOp) { return f.apply(this, arguments) }
      startOperation(this);
      try { return f.apply(this, arguments) }
      finally { endOperation(this); }
    }
  }
  function docMethodOp(f) {
    return function() {
      var cm = this.cm;
      if (!cm || cm.curOp) { return f.apply(this, arguments) }
      startOperation(cm);
      try { return f.apply(this, arguments) }
      finally { endOperation(cm); }
    }
  }

  // Updates the display.view data structure for a given change to the
  // document. From and to are in pre-change coordinates. Lendiff is
  // the amount of lines added or subtracted by the change. This is
  // used for changes that span multiple lines, or change the way
  // lines are divided into visual lines. regLineChange (below)
  // registers single-line changes.
  function regChange(cm, from, to, lendiff) {
    if (from == null) { from = cm.doc.first; }
    if (to == null) { to = cm.doc.first + cm.doc.size; }
    if (!lendiff) { lendiff = 0; }

    var display = cm.display;
    if (lendiff && to < display.viewTo &&
        (display.updateLineNumbers == null || display.updateLineNumbers > from))
      { display.updateLineNumbers = from; }

    cm.curOp.viewChanged = true;

    if (from >= display.viewTo) { // Change after
      if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo)
        { resetView(cm); }
    } else if (to <= display.viewFrom) { // Change before
      if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) {
        resetView(cm);
      } else {
        display.viewFrom += lendiff;
        display.viewTo += lendiff;
      }
    } else if (from <= display.viewFrom && to >= display.viewTo) { // Full overlap
      resetView(cm);
    } else if (from <= display.viewFrom) { // Top overlap
      var cut = viewCuttingPoint(cm, to, to + lendiff, 1);
      if (cut) {
        display.view = display.view.slice(cut.index);
        display.viewFrom = cut.lineN;
        display.viewTo += lendiff;
      } else {
        resetView(cm);
      }
    } else if (to >= display.viewTo) { // Bottom overlap
      var cut$1 = viewCuttingPoint(cm, from, from, -1);
      if (cut$1) {
        display.view = display.view.slice(0, cut$1.index);
        display.viewTo = cut$1.lineN;
      } else {
        resetView(cm);
      }
    } else { // Gap in the middle
      var cutTop = viewCuttingPoint(cm, from, from, -1);
      var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1);
      if (cutTop && cutBot) {
        display.view = display.view.slice(0, cutTop.index)
          .concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN))
          .concat(display.view.slice(cutBot.index));
        display.viewTo += lendiff;
      } else {
        resetView(cm);
      }
    }

    var ext = display.externalMeasured;
    if (ext) {
      if (to < ext.lineN)
        { ext.lineN += lendiff; }
      else if (from < ext.lineN + ext.size)
        { display.externalMeasured = null; }
    }
  }

  // Register a change to a single line. Type must be one of "text",
  // "gutter", "class", "widget"
  function regLineChange(cm, line, type) {
    cm.curOp.viewChanged = true;
    var display = cm.display, ext = cm.display.externalMeasured;
    if (ext && line >= ext.lineN && line < ext.lineN + ext.size)
      { display.externalMeasured = null; }

    if (line < display.viewFrom || line >= display.viewTo) { return }
    var lineView = display.view[findViewIndex(cm, line)];
    if (lineView.node == null) { return }
    var arr = lineView.changes || (lineView.changes = []);
    if (indexOf(arr, type) == -1) { arr.push(type); }
  }

  // Clear the view.
  function resetView(cm) {
    cm.display.viewFrom = cm.display.viewTo = cm.doc.first;
    cm.display.view = [];
    cm.display.viewOffset = 0;
  }

  function viewCuttingPoint(cm, oldN, newN, dir) {
    var index = findViewIndex(cm, oldN), diff, view = cm.display.view;
    if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size)
      { return {index: index, lineN: newN} }
    var n = cm.display.viewFrom;
    for (var i = 0; i < index; i++)
      { n += view[i].size; }
    if (n != oldN) {
      if (dir > 0) {
        if (index == view.length - 1) { return null }
        diff = (n + view[index].size) - oldN;
        index++;
      } else {
        diff = n - oldN;
      }
      oldN += diff; newN += diff;
    }
    while (visualLineNo(cm.doc, newN) != newN) {
      if (index == (dir < 0 ? 0 : view.length - 1)) { return null }
      newN += dir * view[index - (dir < 0 ? 1 : 0)].size;
      index += dir;
    }
    return {index: index, lineN: newN}
  }

  // Force the view to cover a given range, adding empty view element
  // or clipping off existing ones as needed.
  function adjustView(cm, from, to) {
    var display = cm.display, view = display.view;
    if (view.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
      display.view = buildViewArray(cm, from, to);
      display.viewFrom = from;
    } else {
      if (display.viewFrom > from)
        { display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view); }
      else if (display.viewFrom < from)
        { display.view = display.view.slice(findViewIndex(cm, from)); }
      display.viewFrom = from;
      if (display.viewTo < to)
        { display.view = display.view.concat(buildViewArray(cm, display.viewTo, to)); }
      else if (display.viewTo > to)
        { display.view = display.view.slice(0, findViewIndex(cm, to)); }
    }
    display.viewTo = to;
  }

  // Count the number of lines in the view whose DOM representation is
  // out of date (or nonexistent).
  function countDirtyView(cm) {
    var view = cm.display.view, dirty = 0;
    for (var i = 0; i < view.length; i++) {
      var lineView = view[i];
      if (!lineView.hidden && (!lineView.node || lineView.changes)) { ++dirty; }
    }
    return dirty
  }

  // HIGHLIGHT WORKER

  function startWorker(cm, time) {
    if (cm.doc.highlightFrontier < cm.display.viewTo)
      { cm.state.highlight.set(time, bind(highlightWorker, cm)); }
  }

  function highlightWorker(cm) {
    var doc = cm.doc;
    if (doc.highlightFrontier >= cm.display.viewTo) { return }
    var end = +new Date + cm.options.workTime;
    var context = getContextBefore(cm, doc.highlightFrontier);
    var changedLines = [];

    doc.iter(context.line, Math.min(doc.first + doc.size, cm.display.viewTo + 500), function (line) {
      if (context.line >= cm.display.viewFrom) { // Visible
        var oldStyles = line.styles;
        var resetState = line.text.length > cm.options.maxHighlightLength ? copyState(doc.mode, context.state) : null;
        var highlighted = highlightLine(cm, line, context, true);
        if (resetState) { context.state = resetState; }
        line.styles = highlighted.styles;
        var oldCls = line.styleClasses, newCls = highlighted.classes;
        if (newCls) { line.styleClasses = newCls; }
        else if (oldCls) { line.styleClasses = null; }
        var ischange = !oldStyles || oldStyles.length != line.styles.length ||
          oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass);
        for (var i = 0; !ischange && i < oldStyles.length; ++i) { ischange = oldStyles[i] != line.styles[i]; }
        if (ischange) { changedLines.push(context.line); }
        line.stateAfter = context.save();
        context.nextLine();
      } else {
        if (line.text.length <= cm.options.maxHighlightLength)
          { processLine(cm, line.text, context); }
        line.stateAfter = context.line % 5 == 0 ? context.save() : null;
        context.nextLine();
      }
      if (+new Date > end) {
        startWorker(cm, cm.options.workDelay);
        return true
      }
    });
    doc.highlightFrontier = context.line;
    doc.modeFrontier = Math.max(doc.modeFrontier, context.line);
    if (changedLines.length) { runInOp(cm, function () {
      for (var i = 0; i < changedLines.length; i++)
        { regLineChange(cm, changedLines[i], "text"); }
    }); }
  }

  // DISPLAY DRAWING

  var DisplayUpdate = function(cm, viewport, force) {
    var display = cm.display;

    this.viewport = viewport;
    // Store some values that we'll need later (but don't want to force a relayout for)
    this.visible = visibleLines(display, cm.doc, viewport);
    this.editorIsHidden = !display.wrapper.offsetWidth;
    this.wrapperHeight = display.wrapper.clientHeight;
    this.wrapperWidth = display.wrapper.clientWidth;
    this.oldDisplayWidth = displayWidth(cm);
    this.force = force;
    this.dims = getDimensions(cm);
    this.events = [];
  };

  DisplayUpdate.prototype.signal = function (emitter, type) {
    if (hasHandler(emitter, type))
      { this.events.push(arguments); }
  };
  DisplayUpdate.prototype.finish = function () {
      var this$1 = this;

    for (var i = 0; i < this.events.length; i++)
      { signal.apply(null, this$1.events[i]); }
  };

  function maybeClipScrollbars(cm) {
    var display = cm.display;
    if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
      display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth;
      display.heightForcer.style.height = scrollGap(cm) + "px";
      display.sizer.style.marginBottom = -display.nativeBarWidth + "px";
      display.sizer.style.borderRightWidth = scrollGap(cm) + "px";
      display.scrollbarsClipped = true;
    }
  }

  function selectionSnapshot(cm) {
    if (cm.hasFocus()) { return null }
    var active = activeElt();
    if (!active || !contains(cm.display.lineDiv, active)) { return null }
    var result = {activeElt: active};
    if (window.getSelection) {
      var sel = window.getSelection();
      if (sel.anchorNode && sel.extend && contains(cm.display.lineDiv, sel.anchorNode)) {
        result.anchorNode = sel.anchorNode;
        result.anchorOffset = sel.anchorOffset;
        result.focusNode = sel.focusNode;
        result.focusOffset = sel.focusOffset;
      }
    }
    return result
  }

  function restoreSelection(snapshot) {
    if (!snapshot || !snapshot.activeElt || snapshot.activeElt == activeElt()) { return }
    snapshot.activeElt.focus();
    if (snapshot.anchorNode && contains(document.body, snapshot.anchorNode) && contains(document.body, snapshot.focusNode)) {
      var sel = window.getSelection(), range$$1 = document.createRange();
      range$$1.setEnd(snapshot.anchorNode, snapshot.anchorOffset);
      range$$1.collapse(false);
      sel.removeAllRanges();
      sel.addRange(range$$1);
      sel.extend(snapshot.focusNode, snapshot.focusOffset);
    }
  }

  // Does the actual updating of the line display. Bails out
  // (returning false) when there is nothing to be done and forced is
  // false.
  function updateDisplayIfNeeded(cm, update) {
    var display = cm.display, doc = cm.doc;

    if (update.editorIsHidden) {
      resetView(cm);
      return false
    }

    // Bail out if the visible area is already rendered and nothing changed.
    if (!update.force &&
        update.visible.from >= display.viewFrom && update.visible.to <= display.viewTo &&
        (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) &&
        display.renderedView == display.view && countDirtyView(cm) == 0)
      { return false }

    if (maybeUpdateLineNumberWidth(cm)) {
      resetView(cm);
      update.dims = getDimensions(cm);
    }

    // Compute a suitable new viewport (from & to)
    var end = doc.first + doc.size;
    var from = Math.max(update.visible.from - cm.options.viewportMargin, doc.first);
    var to = Math.min(end, update.visible.to + cm.options.viewportMargin);
    if (display.viewFrom < from && from - display.viewFrom < 20) { from = Math.max(doc.first, display.viewFrom); }
    if (display.viewTo > to && display.viewTo - to < 20) { to = Math.min(end, display.viewTo); }
    if (sawCollapsedSpans) {
      from = visualLineNo(cm.doc, from);
      to = visualLineEndNo(cm.doc, to);
    }

    var different = from != display.viewFrom || to != display.viewTo ||
      display.lastWrapHeight != update.wrapperHeight || display.lastWrapWidth != update.wrapperWidth;
    adjustView(cm, from, to);

    display.viewOffset = heightAtLine(getLine(cm.doc, display.viewFrom));
    // Position the mover div to align with the current scroll position
    cm.display.mover.style.top = display.viewOffset + "px";

    var toUpdate = countDirtyView(cm);
    if (!different && toUpdate == 0 && !update.force && display.renderedView == display.view &&
        (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo))
      { return false }

    // For big changes, we hide the enclosing element during the
    // update, since that speeds up the operations on most browsers.
    var selSnapshot = selectionSnapshot(cm);
    if (toUpdate > 4) { display.lineDiv.style.display = "none"; }
    patchDisplay(cm, display.updateLineNumbers, update.dims);
    if (toUpdate > 4) { display.lineDiv.style.display = ""; }
    display.renderedView = display.view;
    // There might have been a widget with a focused element that got
    // hidden or updated, if so re-focus it.
    restoreSelection(selSnapshot);

    // Prevent selection and cursors from interfering with the scroll
    // width and height.
    removeChildren(display.cursorDiv);
    removeChildren(display.selectionDiv);
    display.gutters.style.height = display.sizer.style.minHeight = 0;

    if (different) {
      display.lastWrapHeight = update.wrapperHeight;
      display.lastWrapWidth = update.wrapperWidth;
      startWorker(cm, 400);
    }

    display.updateLineNumbers = null;

    return true
  }

  function postUpdateDisplay(cm, update) {
    var viewport = update.viewport;

    for (var first = true;; first = false) {
      if (!first || !cm.options.lineWrapping || update.oldDisplayWidth == displayWidth(cm)) {
        // Clip forced viewport to actual scrollable area.
        if (viewport && viewport.top != null)
          { viewport = {top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top)}; }
        // Updated line heights might result in the drawn area not
        // actually covering the viewport. Keep looping until it does.
        update.visible = visibleLines(cm.display, cm.doc, viewport);
        if (update.visible.from >= cm.display.viewFrom && update.visible.to <= cm.display.viewTo)
          { break }
      }
      if (!updateDisplayIfNeeded(cm, update)) { break }
      updateHeightsInViewport(cm);
      var barMeasure = measureForScrollbars(cm);
      updateSelection(cm);
      updateScrollbars(cm, barMeasure);
      setDocumentHeight(cm, barMeasure);
      update.force = false;
    }

    update.signal(cm, "update", cm);
    if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
      update.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo);
      cm.display.reportedViewFrom = cm.display.viewFrom; cm.display.reportedViewTo = cm.display.viewTo;
    }
  }

  function updateDisplaySimple(cm, viewport) {
    var update = new DisplayUpdate(cm, viewport);
    if (updateDisplayIfNeeded(cm, update)) {
      updateHeightsInViewport(cm);
      postUpdateDisplay(cm, update);
      var barMeasure = measureForScrollbars(cm);
      updateSelection(cm);
      updateScrollbars(cm, barMeasure);
      setDocumentHeight(cm, barMeasure);
      update.finish();
    }
  }

  // Sync the actual display DOM structure with display.view, removing
  // nodes for lines that are no longer in view, and creating the ones
  // that are not there yet, and updating the ones that are out of
  // date.
  function patchDisplay(cm, updateNumbersFrom, dims) {
    var display = cm.display, lineNumbers = cm.options.lineNumbers;
    var container = display.lineDiv, cur = container.firstChild;

    function rm(node) {
      var next = node.nextSibling;
      // Works around a throw-scroll bug in OS X Webkit
      if (webkit && mac && cm.display.currentWheelTarget == node)
        { node.style.display = "none"; }
      else
        { node.parentNode.removeChild(node); }
      return next
    }

    var view = display.view, lineN = display.viewFrom;
    // Loop over the elements in the view, syncing cur (the DOM nodes
    // in display.lineDiv) with the view as we go.
    for (var i = 0; i < view.length; i++) {
      var lineView = view[i];
      if (lineView.hidden) ; else if (!lineView.node || lineView.node.parentNode != container) { // Not drawn yet
        var node = buildLineElement(cm, lineView, lineN, dims);
        container.insertBefore(node, cur);
      } else { // Already drawn
        while (cur != lineView.node) { cur = rm(cur); }
        var updateNumber = lineNumbers && updateNumbersFrom != null &&
          updateNumbersFrom <= lineN && lineView.lineNumber;
        if (lineView.changes) {
          if (indexOf(lineView.changes, "gutter") > -1) { updateNumber = false; }
          updateLineForChanges(cm, lineView, lineN, dims);
        }
        if (updateNumber) {
          removeChildren(lineView.lineNumber);
          lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)));
        }
        cur = lineView.node.nextSibling;
      }
      lineN += lineView.size;
    }
    while (cur) { cur = rm(cur); }
  }

  function updateGutterSpace(cm) {
    var width = cm.display.gutters.offsetWidth;
    cm.display.sizer.style.marginLeft = width + "px";
  }

  function setDocumentHeight(cm, measure) {
    cm.display.sizer.style.minHeight = measure.docHeight + "px";
    cm.display.heightForcer.style.top = measure.docHeight + "px";
    cm.display.gutters.style.height = (measure.docHeight + cm.display.barHeight + scrollGap(cm)) + "px";
  }

  // Rebuild the gutter elements, ensure the margin to the left of the
  // code matches their width.
  function updateGutters(cm) {
    var gutters = cm.display.gutters, specs = cm.options.gutters;
    removeChildren(gutters);
    var i = 0;
    for (; i < specs.length; ++i) {
      var gutterClass = specs[i];
      var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + gutterClass));
      if (gutterClass == "CodeMirror-linenumbers") {
        cm.display.lineGutter = gElt;
        gElt.style.width = (cm.display.lineNumWidth || 1) + "px";
      }
    }
    gutters.style.display = i ? "" : "none";
    updateGutterSpace(cm);
  }

  // Make sure the gutters options contains the element
  // "CodeMirror-linenumbers" when the lineNumbers option is true.
  function setGuttersForLineNumbers(options) {
    var found = indexOf(options.gutters, "CodeMirror-linenumbers");
    if (found == -1 && options.lineNumbers) {
      options.gutters = options.gutters.concat(["CodeMirror-linenumbers"]);
    } else if (found > -1 && !options.lineNumbers) {
      options.gutters = options.gutters.slice(0);
      options.gutters.splice(found, 1);
    }
  }

  // Since the delta values reported on mouse wheel events are
  // unstandardized between browsers and even browser versions, and
  // generally horribly unpredictable, this code starts by measuring
  // the scroll effect that the first few mouse wheel events have,
  // and, from that, detects the way it can convert deltas to pixel
  // offsets afterwards.
  //
  // The reason we want to know the amount a wheel event will scroll
  // is that it gives us a chance to update the display before the
  // actual scrolling happens, reducing flickering.

  var wheelSamples = 0, wheelPixelsPerUnit = null;
  // Fill in a browser-detected starting value on browsers where we
  // know one. These don't have to be accurate -- the result of them
  // being wrong would just be a slight flicker on the first wheel
  // scroll (if it is large enough).
  if (ie) { wheelPixelsPerUnit = -.53; }
  else if (gecko) { wheelPixelsPerUnit = 15; }
  else if (chrome) { wheelPixelsPerUnit = -.7; }
  else if (safari) { wheelPixelsPerUnit = -1/3; }

  function wheelEventDelta(e) {
    var dx = e.wheelDeltaX, dy = e.wheelDeltaY;
    if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) { dx = e.detail; }
    if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) { dy = e.detail; }
    else if (dy == null) { dy = e.wheelDelta; }
    return {x: dx, y: dy}
  }
  function wheelEventPixels(e) {
    var delta = wheelEventDelta(e);
    delta.x *= wheelPixelsPerUnit;
    delta.y *= wheelPixelsPerUnit;
    return delta
  }

  function onScrollWheel(cm, e) {
    var delta = wheelEventDelta(e), dx = delta.x, dy = delta.y;

    var display = cm.display, scroll = display.scroller;
    // Quit if there's nothing to scroll here
    var canScrollX = scroll.scrollWidth > scroll.clientWidth;
    var canScrollY = scroll.scrollHeight > scroll.clientHeight;
    if (!(dx && canScrollX || dy && canScrollY)) { return }

    // Webkit browsers on OS X abort momentum scrolls when the target
    // of the scroll event is removed from the scrollable element.
    // This hack (see related code in patchDisplay) makes sure the
    // element is kept around.
    if (dy && mac && webkit) {
      outer: for (var cur = e.target, view = display.view; cur != scroll; cur = cur.parentNode) {
        for (var i = 0; i < view.length; i++) {
          if (view[i].node == cur) {
            cm.display.currentWheelTarget = cur;
            break outer
          }
        }
      }
    }

    // On some browsers, horizontal scrolling will cause redraws to
    // happen before the gutter has been realigned, causing it to
    // wriggle around in a most unseemly way. When we have an
    // estimated pixels/delta value, we just handle horizontal
    // scrolling entirely here. It'll be slightly off from native, but
    // better than glitching out.
    if (dx && !gecko && !presto && wheelPixelsPerUnit != null) {
      if (dy && canScrollY)
        { updateScrollTop(cm, Math.max(0, scroll.scrollTop + dy * wheelPixelsPerUnit)); }
      setScrollLeft(cm, Math.max(0, scroll.scrollLeft + dx * wheelPixelsPerUnit));
      // Only prevent default scrolling if vertical scrolling is
      // actually possible. Otherwise, it causes vertical scroll
      // jitter on OSX trackpads when deltaX is small and deltaY
      // is large (issue #3579)
      if (!dy || (dy && canScrollY))
        { e_preventDefault(e); }
      display.wheelStartX = null; // Abort measurement, if in progress
      return
    }

    // 'Project' the visible viewport to cover the area that is being
    // scrolled into view (if we know enough to estimate it).
    if (dy && wheelPixelsPerUnit != null) {
      var pixels = dy * wheelPixelsPerUnit;
      var top = cm.doc.scrollTop, bot = top + display.wrapper.clientHeight;
      if (pixels < 0) { top = Math.max(0, top + pixels - 50); }
      else { bot = Math.min(cm.doc.height, bot + pixels + 50); }
      updateDisplaySimple(cm, {top: top, bottom: bot});
    }

    if (wheelSamples < 20) {
      if (display.wheelStartX == null) {
        display.wheelStartX = scroll.scrollLeft; display.wheelStartY = scroll.scrollTop;
        display.wheelDX = dx; display.wheelDY = dy;
        setTimeout(function () {
          if (display.wheelStartX == null) { return }
          var movedX = scroll.scrollLeft - display.wheelStartX;
          var movedY = scroll.scrollTop - display.wheelStartY;
          var sample = (movedY && display.wheelDY && movedY / display.wheelDY) ||
            (movedX && display.wheelDX && movedX / display.wheelDX);
          display.wheelStartX = display.wheelStartY = null;
          if (!sample) { return }
          wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1);
          ++wheelSamples;
        }, 200);
      } else {
        display.wheelDX += dx; display.wheelDY += dy;
      }
    }
  }

  // Selection objects are immutable. A new one is created every time
  // the selection changes. A selection is one or more non-overlapping
  // (and non-touching) ranges, sorted, and an integer that indicates
  // which one is the primary selection (the one that's scrolled into
  // view, that getCursor returns, etc).
  var Selection = function(ranges, primIndex) {
    this.ranges = ranges;
    this.primIndex = primIndex;
  };

  Selection.prototype.primary = function () { return this.ranges[this.primIndex] };

  Selection.prototype.equals = function (other) {
      var this$1 = this;

    if (other == this) { return true }
    if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) { return false }
    for (var i = 0; i < this.ranges.length; i++) {
      var here = this$1.ranges[i], there = other.ranges[i];
      if (!equalCursorPos(here.anchor, there.anchor) || !equalCursorPos(here.head, there.head)) { return false }
    }
    return true
  };

  Selection.prototype.deepCopy = function () {
      var this$1 = this;

    var out = [];
    for (var i = 0; i < this.ranges.length; i++)
      { out[i] = new Range(copyPos(this$1.ranges[i].anchor), copyPos(this$1.ranges[i].head)); }
    return new Selection(out, this.primIndex)
  };

  Selection.prototype.somethingSelected = function () {
      var this$1 = this;

    for (var i = 0; i < this.ranges.length; i++)
      { if (!this$1.ranges[i].empty()) { return true } }
    return false
  };

  Selection.prototype.contains = function (pos, end) {
      var this$1 = this;

    if (!end) { end = pos; }
    for (var i = 0; i < this.ranges.length; i++) {
      var range = this$1.ranges[i];
      if (cmp(end, range.from()) >= 0 && cmp(pos, range.to()) <= 0)
        { return i }
    }
    return -1
  };

  var Range = function(anchor, head) {
    this.anchor = anchor; this.head = head;
  };

  Range.prototype.from = function () { return minPos(this.anchor, this.head) };
  Range.prototype.to = function () { return maxPos(this.anchor, this.head) };
  Range.prototype.empty = function () { return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch };

  // Take an unsorted, potentially overlapping set of ranges, and
  // build a selection out of it. 'Consumes' ranges array (modifying
  // it).
  function normalizeSelection(cm, ranges, primIndex) {
    var mayTouch = cm && cm.options.selectionsMayTouch;
    var prim = ranges[primIndex];
    ranges.sort(function (a, b) { return cmp(a.from(), b.from()); });
    primIndex = indexOf(ranges, prim);
    for (var i = 1; i < ranges.length; i++) {
      var cur = ranges[i], prev = ranges[i - 1];
      var diff = cmp(prev.to(), cur.from());
      if (mayTouch && !cur.empty() ? diff > 0 : diff >= 0) {
        var from = minPos(prev.from(), cur.from()), to = maxPos(prev.to(), cur.to());
        var inv = prev.empty() ? cur.from() == cur.head : prev.from() == prev.head;
        if (i <= primIndex) { --primIndex; }
        ranges.splice(--i, 2, new Range(inv ? to : from, inv ? from : to));
      }
    }
    return new Selection(ranges, primIndex)
  }

  function simpleSelection(anchor, head) {
    return new Selection([new Range(anchor, head || anchor)], 0)
  }

  // Compute the position of the end of a change (its 'to' property
  // refers to the pre-change end).
  function changeEnd(change) {
    if (!change.text) { return change.to }
    return Pos(change.from.line + change.text.length - 1,
               lst(change.text).length + (change.text.length == 1 ? change.from.ch : 0))
  }

  // Adjust a position to refer to the post-change position of the
  // same text, or the end of the change if the change covers it.
  function adjustForChange(pos, change) {
    if (cmp(pos, change.from) < 0) { return pos }
    if (cmp(pos, change.to) <= 0) { return changeEnd(change) }

    var line = pos.line + change.text.length - (change.to.line - change.from.line) - 1, ch = pos.ch;
    if (pos.line == change.to.line) { ch += changeEnd(change).ch - change.to.ch; }
    return Pos(line, ch)
  }

  function computeSelAfterChange(doc, change) {
    var out = [];
    for (var i = 0; i < doc.sel.ranges.length; i++) {
      var range = doc.sel.ranges[i];
      out.push(new Range(adjustForChange(range.anchor, change),
                         adjustForChange(range.head, change)));
    }
    return normalizeSelection(doc.cm, out, doc.sel.primIndex)
  }

  function offsetPos(pos, old, nw) {
    if (pos.line == old.line)
      { return Pos(nw.line, pos.ch - old.ch + nw.ch) }
    else
      { return Pos(nw.line + (pos.line - old.line), pos.ch) }
  }

  // Used by replaceSelections to allow moving the selection to the
  // start or around the replaced test. Hint may be "start" or "around".
  function computeReplacedSel(doc, changes, hint) {
    var out = [];
    var oldPrev = Pos(doc.first, 0), newPrev = oldPrev;
    for (var i = 0; i < changes.length; i++) {
      var change = changes[i];
      var from = offsetPos(change.from, oldPrev, newPrev);
      var to = offsetPos(changeEnd(change), oldPrev, newPrev);
      oldPrev = change.to;
      newPrev = to;
      if (hint == "around") {
        var range = doc.sel.ranges[i], inv = cmp(range.head, range.anchor) < 0;
        out[i] = new Range(inv ? to : from, inv ? from : to);
      } else {
        out[i] = new Range(from, from);
      }
    }
    return new Selection(out, doc.sel.primIndex)
  }

  // Used to get the editor into a consistent state again when options change.

  function loadMode(cm) {
    cm.doc.mode = getMode(cm.options, cm.doc.modeOption);
    resetModeState(cm);
  }

  function resetModeState(cm) {
    cm.doc.iter(function (line) {
      if (line.stateAfter) { line.stateAfter = null; }
      if (line.styles) { line.styles = null; }
    });
    cm.doc.modeFrontier = cm.doc.highlightFrontier = cm.doc.first;
    startWorker(cm, 100);
    cm.state.modeGen++;
    if (cm.curOp) { regChange(cm); }
  }

  // DOCUMENT DATA STRUCTURE

  // By default, updates that start and end at the beginning of a line
  // are treated specially, in order to make the association of line
  // widgets and marker elements with the text behave more intuitive.
  function isWholeLineUpdate(doc, change) {
    return change.from.ch == 0 && change.to.ch == 0 && lst(change.text) == "" &&
      (!doc.cm || doc.cm.options.wholeLineUpdateBefore)
  }

  // Perform a change on the document data structure.
  function updateDoc(doc, change, markedSpans, estimateHeight$$1) {
    function spansFor(n) {return markedSpans ? markedSpans[n] : null}
    function update(line, text, spans) {
      updateLine(line, text, spans, estimateHeight$$1);
      signalLater(line, "change", line, change);
    }
    function linesFor(start, end) {
      var result = [];
      for (var i = start; i < end; ++i)
        { result.push(new Line(text[i], spansFor(i), estimateHeight$$1)); }
      return result
    }

    var from = change.from, to = change.to, text = change.text;
    var firstLine = getLine(doc, from.line), lastLine = getLine(doc, to.line);
    var lastText = lst(text), lastSpans = spansFor(text.length - 1), nlines = to.line - from.line;

    // Adjust the line structure
    if (change.full) {
      doc.insert(0, linesFor(0, text.length));
      doc.remove(text.length, doc.size - text.length);
    } else if (isWholeLineUpdate(doc, change)) {
      // This is a whole-line replace. Treated specially to make
      // sure line objects move the way they are supposed to.
      var added = linesFor(0, text.length - 1);
      update(lastLine, lastLine.text, lastSpans);
      if (nlines) { doc.remove(from.line, nlines); }
      if (added.length) { doc.insert(from.line, added); }
    } else if (firstLine == lastLine) {
      if (text.length == 1) {
        update(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans);
      } else {
        var added$1 = linesFor(1, text.length - 1);
        added$1.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight$$1));
        update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
        doc.insert(from.line + 1, added$1);
      }
    } else if (text.length == 1) {
      update(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0));
      doc.remove(from.line + 1, nlines);
    } else {
      update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
      update(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans);
      var added$2 = linesFor(1, text.length - 1);
      if (nlines > 1) { doc.remove(from.line + 1, nlines - 1); }
      doc.insert(from.line + 1, added$2);
    }

    signalLater(doc, "change", doc, change);
  }

  // Call f for all linked documents.
  function linkedDocs(doc, f, sharedHistOnly) {
    function propagate(doc, skip, sharedHist) {
      if (doc.linked) { for (var i = 0; i < doc.linked.length; ++i) {
        var rel = doc.linked[i];
        if (rel.doc == skip) { continue }
        var shared = sharedHist && rel.sharedHist;
        if (sharedHistOnly && !shared) { continue }
        f(rel.doc, shared);
        propagate(rel.doc, doc, shared);
      } }
    }
    propagate(doc, null, true);
  }

  // Attach a document to an editor.
  function attachDoc(cm, doc) {
    if (doc.cm) { throw new Error("This document is already in use.") }
    cm.doc = doc;
    doc.cm = cm;
    estimateLineHeights(cm);
    loadMode(cm);
    setDirectionClass(cm);
    if (!cm.options.lineWrapping) { findMaxLine(cm); }
    cm.options.mode = doc.modeOption;
    regChange(cm);
  }

  function setDirectionClass(cm) {
  (cm.doc.direction == "rtl" ? addClass : rmClass)(cm.display.lineDiv, "CodeMirror-rtl");
  }

  function directionChanged(cm) {
    runInOp(cm, function () {
      setDirectionClass(cm);
      regChange(cm);
    });
  }

  function History(startGen) {
    // Arrays of change events and selections. Doing something adds an
    // event to done and clears undo. Undoing moves events from done
    // to undone, redoing moves them in the other direction.
    this.done = []; this.undone = [];
    this.undoDepth = Infinity;
    // Used to track when changes can be merged into a single undo
    // event
    this.lastModTime = this.lastSelTime = 0;
    this.lastOp = this.lastSelOp = null;
    this.lastOrigin = this.lastSelOrigin = null;
    // Used by the isClean() method
    this.generation = this.maxGeneration = startGen || 1;
  }

  // Create a history change event from an updateDoc-style change
  // object.
  function historyChangeFromChange(doc, change) {
    var histChange = {from: copyPos(change.from), to: changeEnd(change), text: getBetween(doc, change.from, change.to)};
    attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
    linkedDocs(doc, function (doc) { return attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1); }, true);
    return histChange
  }

  // Pop all selection events off the end of a history array. Stop at
  // a change event.
  function clearSelectionEvents(array) {
    while (array.length) {
      var last = lst(array);
      if (last.ranges) { array.pop(); }
      else { break }
    }
  }

  // Find the top change event in the history. Pop off selection
  // events that are in the way.
  function lastChangeEvent(hist, force) {
    if (force) {
      clearSelectionEvents(hist.done);
      return lst(hist.done)
    } else if (hist.done.length && !lst(hist.done).ranges) {
      return lst(hist.done)
    } else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
      hist.done.pop();
      return lst(hist.done)
    }
  }

  // Register a change in the history. Merges changes that are within
  // a single operation, or are close together with an origin that
  // allows merging (starting with "+") into a single event.
  function addChangeToHistory(doc, change, selAfter, opId) {
    var hist = doc.history;
    hist.undone.length = 0;
    var time = +new Date, cur;
    var last;

    if ((hist.lastOp == opId ||
         hist.lastOrigin == change.origin && change.origin &&
         ((change.origin.charAt(0) == "+" && hist.lastModTime > time - (doc.cm ? doc.cm.options.historyEventDelay : 500)) ||
          change.origin.charAt(0) == "*")) &&
        (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
      // Merge this change into the last event
      last = lst(cur.changes);
      if (cmp(change.from, change.to) == 0 && cmp(change.from, last.to) == 0) {
        // Optimized case for simple insertion -- don't want to add
        // new changesets for every character typed
        last.to = changeEnd(change);
      } else {
        // Add new sub-event
        cur.changes.push(historyChangeFromChange(doc, change));
      }
    } else {
      // Can not be merged, start a new event.
      var before = lst(hist.done);
      if (!before || !before.ranges)
        { pushSelectionToHistory(doc.sel, hist.done); }
      cur = {changes: [historyChangeFromChange(doc, change)],
             generation: hist.generation};
      hist.done.push(cur);
      while (hist.done.length > hist.undoDepth) {
        hist.done.shift();
        if (!hist.done[0].ranges) { hist.done.shift(); }
      }
    }
    hist.done.push(selAfter);
    hist.generation = ++hist.maxGeneration;
    hist.lastModTime = hist.lastSelTime = time;
    hist.lastOp = hist.lastSelOp = opId;
    hist.lastOrigin = hist.lastSelOrigin = change.origin;

    if (!last) { signal(doc, "historyAdded"); }
  }

  function selectionEventCanBeMerged(doc, origin, prev, sel) {
    var ch = origin.charAt(0);
    return ch == "*" ||
      ch == "+" &&
      prev.ranges.length == sel.ranges.length &&
      prev.somethingSelected() == sel.somethingSelected() &&
      new Date - doc.history.lastSelTime <= (doc.cm ? doc.cm.options.historyEventDelay : 500)
  }

  // Called whenever the selection changes, sets the new selection as
  // the pending selection in the history, and pushes the old pending
  // selection into the 'done' array when it was significantly
  // different (in number of selected ranges, emptiness, or time).
  function addSelectionToHistory(doc, sel, opId, options) {
    var hist = doc.history, origin = options && options.origin;

    // A new event is started when the previous origin does not match
    // the current, or the origins don't allow matching. Origins
    // starting with * are always merged, those starting with + are
    // merged when similar and close together in time.
    if (opId == hist.lastSelOp ||
        (origin && hist.lastSelOrigin == origin &&
         (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin ||
          selectionEventCanBeMerged(doc, origin, lst(hist.done), sel))))
      { hist.done[hist.done.length - 1] = sel; }
    else
      { pushSelectionToHistory(sel, hist.done); }

    hist.lastSelTime = +new Date;
    hist.lastSelOrigin = origin;
    hist.lastSelOp = opId;
    if (options && options.clearRedo !== false)
      { clearSelectionEvents(hist.undone); }
  }

  function pushSelectionToHistory(sel, dest) {
    var top = lst(dest);
    if (!(top && top.ranges && top.equals(sel)))
      { dest.push(sel); }
  }

  // Used to store marked span information in the history.
  function attachLocalSpans(doc, change, from, to) {
    var existing = change["spans_" + doc.id], n = 0;
    doc.iter(Math.max(doc.first, from), Math.min(doc.first + doc.size, to), function (line) {
      if (line.markedSpans)
        { (existing || (existing = change["spans_" + doc.id] = {}))[n] = line.markedSpans; }
      ++n;
    });
  }

  // When un/re-doing restores text containing marked spans, those
  // that have been explicitly cleared should not be restored.
  function removeClearedSpans(spans) {
    if (!spans) { return null }
    var out;
    for (var i = 0; i < spans.length; ++i) {
      if (spans[i].marker.explicitlyCleared) { if (!out) { out = spans.slice(0, i); } }
      else if (out) { out.push(spans[i]); }
    }
    return !out ? spans : out.length ? out : null
  }

  // Retrieve and filter the old marked spans stored in a change event.
  function getOldSpans(doc, change) {
    var found = change["spans_" + doc.id];
    if (!found) { return null }
    var nw = [];
    for (var i = 0; i < change.text.length; ++i)
      { nw.push(removeClearedSpans(found[i])); }
    return nw
  }

  // Used for un/re-doing changes from the history. Combines the
  // result of computing the existing spans with the set of spans that
  // existed in the history (so that deleting around a span and then
  // undoing brings back the span).
  function mergeOldSpans(doc, change) {
    var old = getOldSpans(doc, change);
    var stretched = stretchSpansOverChange(doc, change);
    if (!old) { return stretched }
    if (!stretched) { return old }

    for (var i = 0; i < old.length; ++i) {
      var oldCur = old[i], stretchCur = stretched[i];
      if (oldCur && stretchCur) {
        spans: for (var j = 0; j < stretchCur.length; ++j) {
          var span = stretchCur[j];
          for (var k = 0; k < oldCur.length; ++k)
            { if (oldCur[k].marker == span.marker) { continue spans } }
          oldCur.push(span);
        }
      } else if (stretchCur) {
        old[i] = stretchCur;
      }
    }
    return old
  }

  // Used both to provide a JSON-safe object in .getHistory, and, when
  // detaching a document, to split the history in two
  function copyHistoryArray(events, newGroup, instantiateSel) {
    var copy = [];
    for (var i = 0; i < events.length; ++i) {
      var event = events[i];
      if (event.ranges) {
        copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event);
        continue
      }
      var changes = event.changes, newChanges = [];
      copy.push({changes: newChanges});
      for (var j = 0; j < changes.length; ++j) {
        var change = changes[j], m = (void 0);
        newChanges.push({from: change.from, to: change.to, text: change.text});
        if (newGroup) { for (var prop in change) { if (m = prop.match(/^spans_(\d+)$/)) {
          if (indexOf(newGroup, Number(m[1])) > -1) {
            lst(newChanges)[prop] = change[prop];
            delete change[prop];
          }
        } } }
      }
    }
    return copy
  }

  // The 'scroll' parameter given to many of these indicated whether
  // the new cursor position should be scrolled into view after
  // modifying the selection.

  // If shift is held or the extend flag is set, extends a range to
  // include a given position (and optionally a second position).
  // Otherwise, simply returns the range between the given positions.
  // Used for cursor motion and such.
  function extendRange(range, head, other, extend) {
    if (extend) {
      var anchor = range.anchor;
      if (other) {
        var posBefore = cmp(head, anchor) < 0;
        if (posBefore != (cmp(other, anchor) < 0)) {
          anchor = head;
          head = other;
        } else if (posBefore != (cmp(head, other) < 0)) {
          head = other;
        }
      }
      return new Range(anchor, head)
    } else {
      return new Range(other || head, head)
    }
  }

  // Extend the primary selection range, discard the rest.
  function extendSelection(doc, head, other, options, extend) {
    if (extend == null) { extend = doc.cm && (doc.cm.display.shift || doc.extend); }
    setSelection(doc, new Selection([extendRange(doc.sel.primary(), head, other, extend)], 0), options);
  }

  // Extend all selections (pos is an array of selections with length
  // equal the number of selections)
  function extendSelections(doc, heads, options) {
    var out = [];
    var extend = doc.cm && (doc.cm.display.shift || doc.extend);
    for (var i = 0; i < doc.sel.ranges.length; i++)
      { out[i] = extendRange(doc.sel.ranges[i], heads[i], null, extend); }
    var newSel = normalizeSelection(doc.cm, out, doc.sel.primIndex);
    setSelection(doc, newSel, options);
  }

  // Updates a single range in the selection.
  function replaceOneSelection(doc, i, range, options) {
    var ranges = doc.sel.ranges.slice(0);
    ranges[i] = range;
    setSelection(doc, normalizeSelection(doc.cm, ranges, doc.sel.primIndex), options);
  }

  // Reset the selection to a single range.
  function setSimpleSelection(doc, anchor, head, options) {
    setSelection(doc, simpleSelection(anchor, head), options);
  }

  // Give beforeSelectionChange handlers a change to influence a
  // selection update.
  function filterSelectionChange(doc, sel, options) {
    var obj = {
      ranges: sel.ranges,
      update: function(ranges) {
        var this$1 = this;

        this.ranges = [];
        for (var i = 0; i < ranges.length; i++)
          { this$1.ranges[i] = new Range(clipPos(doc, ranges[i].anchor),
                                     clipPos(doc, ranges[i].head)); }
      },
      origin: options && options.origin
    };
    signal(doc, "beforeSelectionChange", doc, obj);
    if (doc.cm) { signal(doc.cm, "beforeSelectionChange", doc.cm, obj); }
    if (obj.ranges != sel.ranges) { return normalizeSelection(doc.cm, obj.ranges, obj.ranges.length - 1) }
    else { return sel }
  }

  function setSelectionReplaceHistory(doc, sel, options) {
    var done = doc.history.done, last = lst(done);
    if (last && last.ranges) {
      done[done.length - 1] = sel;
      setSelectionNoUndo(doc, sel, options);
    } else {
      setSelection(doc, sel, options);
    }
  }

  // Set a new selection.
  function setSelection(doc, sel, options) {
    setSelectionNoUndo(doc, sel, options);
    addSelectionToHistory(doc, doc.sel, doc.cm ? doc.cm.curOp.id : NaN, options);
  }

  function setSelectionNoUndo(doc, sel, options) {
    if (hasHandler(doc, "beforeSelectionChange") || doc.cm && hasHandler(doc.cm, "beforeSelectionChange"))
      { sel = filterSelectionChange(doc, sel, options); }

    var bias = options && options.bias ||
      (cmp(sel.primary().head, doc.sel.primary().head) < 0 ? -1 : 1);
    setSelectionInner(doc, skipAtomicInSelection(doc, sel, bias, true));

    if (!(options && options.scroll === false) && doc.cm)
      { ensureCursorVisible(doc.cm); }
  }

  function setSelectionInner(doc, sel) {
    if (sel.equals(doc.sel)) { return }

    doc.sel = sel;

    if (doc.cm) {
      doc.cm.curOp.updateInput = 1;
      doc.cm.curOp.selectionChanged = true;
      signalCursorActivity(doc.cm);
    }
    signalLater(doc, "cursorActivity", doc);
  }

  // Verify that the selection does not partially select any atomic
  // marked ranges.
  function reCheckSelection(doc) {
    setSelectionInner(doc, skipAtomicInSelection(doc, doc.sel, null, false));
  }

  // Return a selection that does not partially select any atomic
  // ranges.
  function skipAtomicInSelection(doc, sel, bias, mayClear) {
    var out;
    for (var i = 0; i < sel.ranges.length; i++) {
      var range = sel.ranges[i];
      var old = sel.ranges.length == doc.sel.ranges.length && doc.sel.ranges[i];
      var newAnchor = skipAtomic(doc, range.anchor, old && old.anchor, bias, mayClear);
      var newHead = skipAtomic(doc, range.head, old && old.head, bias, mayClear);
      if (out || newAnchor != range.anchor || newHead != range.head) {
        if (!out) { out = sel.ranges.slice(0, i); }
        out[i] = new Range(newAnchor, newHead);
      }
    }
    return out ? normalizeSelection(doc.cm, out, sel.primIndex) : sel
  }

  function skipAtomicInner(doc, pos, oldPos, dir, mayClear) {
    var line = getLine(doc, pos.line);
    if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
      var sp = line.markedSpans[i], m = sp.marker;
      if ((sp.from == null || (m.inclusiveLeft ? sp.from <= pos.ch : sp.from < pos.ch)) &&
          (sp.to == null || (m.inclusiveRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
        if (mayClear) {
          signal(m, "beforeCursorEnter");
          if (m.explicitlyCleared) {
            if (!line.markedSpans) { break }
            else {--i; continue}
          }
        }
        if (!m.atomic) { continue }

        if (oldPos) {
          var near = m.find(dir < 0 ? 1 : -1), diff = (void 0);
          if (dir < 0 ? m.inclusiveRight : m.inclusiveLeft)
            { near = movePos(doc, near, -dir, near && near.line == pos.line ? line : null); }
          if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0))
            { return skipAtomicInner(doc, near, pos, dir, mayClear) }
        }

        var far = m.find(dir < 0 ? -1 : 1);
        if (dir < 0 ? m.inclusiveLeft : m.inclusiveRight)
          { far = movePos(doc, far, dir, far.line == pos.line ? line : null); }
        return far ? skipAtomicInner(doc, far, pos, dir, mayClear) : null
      }
    } }
    return pos
  }

  // Ensure a given position is not inside an atomic range.
  function skipAtomic(doc, pos, oldPos, bias, mayClear) {
    var dir = bias || 1;
    var found = skipAtomicInner(doc, pos, oldPos, dir, mayClear) ||
        (!mayClear && skipAtomicInner(doc, pos, oldPos, dir, true)) ||
        skipAtomicInner(doc, pos, oldPos, -dir, mayClear) ||
        (!mayClear && skipAtomicInner(doc, pos, oldPos, -dir, true));
    if (!found) {
      doc.cantEdit = true;
      return Pos(doc.first, 0)
    }
    return found
  }

  function movePos(doc, pos, dir, line) {
    if (dir < 0 && pos.ch == 0) {
      if (pos.line > doc.first) { return clipPos(doc, Pos(pos.line - 1)) }
      else { return null }
    } else if (dir > 0 && pos.ch == (line || getLine(doc, pos.line)).text.length) {
      if (pos.line < doc.first + doc.size - 1) { return Pos(pos.line + 1, 0) }
      else { return null }
    } else {
      return new Pos(pos.line, pos.ch + dir)
    }
  }

  function selectAll(cm) {
    cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll);
  }

  // UPDATING

  // Allow "beforeChange" event handlers to influence a change
  function filterChange(doc, change, update) {
    var obj = {
      canceled: false,
      from: change.from,
      to: change.to,
      text: change.text,
      origin: change.origin,
      cancel: function () { return obj.canceled = true; }
    };
    if (update) { obj.update = function (from, to, text, origin) {
      if (from) { obj.from = clipPos(doc, from); }
      if (to) { obj.to = clipPos(doc, to); }
      if (text) { obj.text = text; }
      if (origin !== undefined) { obj.origin = origin; }
    }; }
    signal(doc, "beforeChange", doc, obj);
    if (doc.cm) { signal(doc.cm, "beforeChange", doc.cm, obj); }

    if (obj.canceled) {
      if (doc.cm) { doc.cm.curOp.updateInput = 2; }
      return null
    }
    return {from: obj.from, to: obj.to, text: obj.text, origin: obj.origin}
  }

  // Apply a change to a document, and add it to the document's
  // history, and propagating it to all linked documents.
  function makeChange(doc, change, ignoreReadOnly) {
    if (doc.cm) {
      if (!doc.cm.curOp) { return operation(doc.cm, makeChange)(doc, change, ignoreReadOnly) }
      if (doc.cm.state.suppressEdits) { return }
    }

    if (hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")) {
      change = filterChange(doc, change, true);
      if (!change) { return }
    }

    // Possibly split or suppress the update based on the presence
    // of read-only spans in its range.
    var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc, change.from, change.to);
    if (split) {
      for (var i = split.length - 1; i >= 0; --i)
        { makeChangeInner(doc, {from: split[i].from, to: split[i].to, text: i ? [""] : change.text, origin: change.origin}); }
    } else {
      makeChangeInner(doc, change);
    }
  }

  function makeChangeInner(doc, change) {
    if (change.text.length == 1 && change.text[0] == "" && cmp(change.from, change.to) == 0) { return }
    var selAfter = computeSelAfterChange(doc, change);
    addChangeToHistory(doc, change, selAfter, doc.cm ? doc.cm.curOp.id : NaN);

    makeChangeSingleDoc(doc, change, selAfter, stretchSpansOverChange(doc, change));
    var rebased = [];

    linkedDocs(doc, function (doc, sharedHist) {
      if (!sharedHist && indexOf(rebased, doc.history) == -1) {
        rebaseHist(doc.history, change);
        rebased.push(doc.history);
      }
      makeChangeSingleDoc(doc, change, null, stretchSpansOverChange(doc, change));
    });
  }

  // Revert a change stored in a document's history.
  function makeChangeFromHistory(doc, type, allowSelectionOnly) {
    var suppress = doc.cm && doc.cm.state.suppressEdits;
    if (suppress && !allowSelectionOnly) { return }

    var hist = doc.history, event, selAfter = doc.sel;
    var source = type == "undo" ? hist.done : hist.undone, dest = type == "undo" ? hist.undone : hist.done;

    // Verify that there is a useable event (so that ctrl-z won't
    // needlessly clear selection events)
    var i = 0;
    for (; i < source.length; i++) {
      event = source[i];
      if (allowSelectionOnly ? event.ranges && !event.equals(doc.sel) : !event.ranges)
        { break }
    }
    if (i == source.length) { return }
    hist.lastOrigin = hist.lastSelOrigin = null;

    for (;;) {
      event = source.pop();
      if (event.ranges) {
        pushSelectionToHistory(event, dest);
        if (allowSelectionOnly && !event.equals(doc.sel)) {
          setSelection(doc, event, {clearRedo: false});
          return
        }
        selAfter = event;
      } else if (suppress) {
        source.push(event);
        return
      } else { break }
    }

    // Build up a reverse change object to add to the opposite history
    // stack (redo when undoing, and vice versa).
    var antiChanges = [];
    pushSelectionToHistory(selAfter, dest);
    dest.push({changes: antiChanges, generation: hist.generation});
    hist.generation = event.generation || ++hist.maxGeneration;

    var filter = hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange");

    var loop = function ( i ) {
      var change = event.changes[i];
      change.origin = type;
      if (filter && !filterChange(doc, change, false)) {
        source.length = 0;
        return {}
      }

      antiChanges.push(historyChangeFromChange(doc, change));

      var after = i ? computeSelAfterChange(doc, change) : lst(source);
      makeChangeSingleDoc(doc, change, after, mergeOldSpans(doc, change));
      if (!i && doc.cm) { doc.cm.scrollIntoView({from: change.from, to: changeEnd(change)}); }
      var rebased = [];

      // Propagate to the linked documents
      linkedDocs(doc, function (doc, sharedHist) {
        if (!sharedHist && indexOf(rebased, doc.history) == -1) {
          rebaseHist(doc.history, change);
          rebased.push(doc.history);
        }
        makeChangeSingleDoc(doc, change, null, mergeOldSpans(doc, change));
      });
    };

    for (var i$1 = event.changes.length - 1; i$1 >= 0; --i$1) {
      var returned = loop( i$1 );

      if ( returned ) return returned.v;
    }
  }

  // Sub-views need their line numbers shifted when text is added
  // above or below them in the parent document.
  function shiftDoc(doc, distance) {
    if (distance == 0) { return }
    doc.first += distance;
    doc.sel = new Selection(map(doc.sel.ranges, function (range) { return new Range(
      Pos(range.anchor.line + distance, range.anchor.ch),
      Pos(range.head.line + distance, range.head.ch)
    ); }), doc.sel.primIndex);
    if (doc.cm) {
      regChange(doc.cm, doc.first, doc.first - distance, distance);
      for (var d = doc.cm.display, l = d.viewFrom; l < d.viewTo; l++)
        { regLineChange(doc.cm, l, "gutter"); }
    }
  }

  // More lower-level change function, handling only a single document
  // (not linked ones).
  function makeChangeSingleDoc(doc, change, selAfter, spans) {
    if (doc.cm && !doc.cm.curOp)
      { return operation(doc.cm, makeChangeSingleDoc)(doc, change, selAfter, spans) }

    if (change.to.line < doc.first) {
      shiftDoc(doc, change.text.length - 1 - (change.to.line - change.from.line));
      return
    }
    if (change.from.line > doc.lastLine()) { return }

    // Clip the change to the size of this doc
    if (change.from.line < doc.first) {
      var shift = change.text.length - 1 - (doc.first - change.from.line);
      shiftDoc(doc, shift);
      change = {from: Pos(doc.first, 0), to: Pos(change.to.line + shift, change.to.ch),
                text: [lst(change.text)], origin: change.origin};
    }
    var last = doc.lastLine();
    if (change.to.line > last) {
      change = {from: change.from, to: Pos(last, getLine(doc, last).text.length),
                text: [change.text[0]], origin: change.origin};
    }

    change.removed = getBetween(doc, change.from, change.to);

    if (!selAfter) { selAfter = computeSelAfterChange(doc, change); }
    if (doc.cm) { makeChangeSingleDocInEditor(doc.cm, change, spans); }
    else { updateDoc(doc, change, spans); }
    setSelectionNoUndo(doc, selAfter, sel_dontScroll);
  }

  // Handle the interaction of a change to a document with the editor
  // that this document is part of.
  function makeChangeSingleDocInEditor(cm, change, spans) {
    var doc = cm.doc, display = cm.display, from = change.from, to = change.to;

    var recomputeMaxLength = false, checkWidthStart = from.line;
    if (!cm.options.lineWrapping) {
      checkWidthStart = lineNo(visualLine(getLine(doc, from.line)));
      doc.iter(checkWidthStart, to.line + 1, function (line) {
        if (line == display.maxLine) {
          recomputeMaxLength = true;
          return true
        }
      });
    }

    if (doc.sel.contains(change.from, change.to) > -1)
      { signalCursorActivity(cm); }

    updateDoc(doc, change, spans, estimateHeight(cm));

    if (!cm.options.lineWrapping) {
      doc.iter(checkWidthStart, from.line + change.text.length, function (line) {
        var len = lineLength(line);
        if (len > display.maxLineLength) {
          display.maxLine = line;
          display.maxLineLength = len;
          display.maxLineChanged = true;
          recomputeMaxLength = false;
        }
      });
      if (recomputeMaxLength) { cm.curOp.updateMaxLine = true; }
    }

    retreatFrontier(doc, from.line);
    startWorker(cm, 400);

    var lendiff = change.text.length - (to.line - from.line) - 1;
    // Remember that these lines changed, for updating the display
    if (change.full)
      { regChange(cm); }
    else if (from.line == to.line && change.text.length == 1 && !isWholeLineUpdate(cm.doc, change))
      { regLineChange(cm, from.line, "text"); }
    else
      { regChange(cm, from.line, to.line + 1, lendiff); }

    var changesHandler = hasHandler(cm, "changes"), changeHandler = hasHandler(cm, "change");
    if (changeHandler || changesHandler) {
      var obj = {
        from: from, to: to,
        text: change.text,
        removed: change.removed,
        origin: change.origin
      };
      if (changeHandler) { signalLater(cm, "change", cm, obj); }
      if (changesHandler) { (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj); }
    }
    cm.display.selForContextMenu = null;
  }

  function replaceRange(doc, code, from, to, origin) {
    var assign;

    if (!to) { to = from; }
    if (cmp(to, from) < 0) { (assign = [to, from], from = assign[0], to = assign[1]); }
    if (typeof code == "string") { code = doc.splitLines(code); }
    makeChange(doc, {from: from, to: to, text: code, origin: origin});
  }

  // Rebasing/resetting history to deal with externally-sourced changes

  function rebaseHistSelSingle(pos, from, to, diff) {
    if (to < pos.line) {
      pos.line += diff;
    } else if (from < pos.line) {
      pos.line = from;
      pos.ch = 0;
    }
  }

  // Tries to rebase an array of history events given a change in the
  // document. If the change touches the same lines as the event, the
  // event, and everything 'behind' it, is discarded. If the change is
  // before the event, the event's positions are updated. Uses a
  // copy-on-write scheme for the positions, to avoid having to
  // reallocate them all on every rebase, but also avoid problems with
  // shared position objects being unsafely updated.
  function rebaseHistArray(array, from, to, diff) {
    for (var i = 0; i < array.length; ++i) {
      var sub = array[i], ok = true;
      if (sub.ranges) {
        if (!sub.copied) { sub = array[i] = sub.deepCopy(); sub.copied = true; }
        for (var j = 0; j < sub.ranges.length; j++) {
          rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff);
          rebaseHistSelSingle(sub.ranges[j].head, from, to, diff);
        }
        continue
      }
      for (var j$1 = 0; j$1 < sub.changes.length; ++j$1) {
        var cur = sub.changes[j$1];
        if (to < cur.from.line) {
          cur.from = Pos(cur.from.line + diff, cur.from.ch);
          cur.to = Pos(cur.to.line + diff, cur.to.ch);
        } else if (from <= cur.to.line) {
          ok = false;
          break
        }
      }
      if (!ok) {
        array.splice(0, i + 1);
        i = 0;
      }
    }
  }

  function rebaseHist(hist, change) {
    var from = change.from.line, to = change.to.line, diff = change.text.length - (to - from) - 1;
    rebaseHistArray(hist.done, from, to, diff);
    rebaseHistArray(hist.undone, from, to, diff);
  }

  // Utility for applying a change to a line by handle or number,
  // returning the number and optionally registering the line as
  // changed.
  function changeLine(doc, handle, changeType, op) {
    var no = handle, line = handle;
    if (typeof handle == "number") { line = getLine(doc, clipLine(doc, handle)); }
    else { no = lineNo(handle); }
    if (no == null) { return null }
    if (op(line, no) && doc.cm) { regLineChange(doc.cm, no, changeType); }
    return line
  }

  // The document is represented as a BTree consisting of leaves, with
  // chunk of lines in them, and branches, with up to ten leaves or
  // other branch nodes below them. The top node is always a branch
  // node, and is the document object itself (meaning it has
  // additional methods and properties).
  //
  // All nodes have parent links. The tree is used both to go from
  // line numbers to line objects, and to go from objects to numbers.
  // It also indexes by height, and is used to convert between height
  // and line object, and to find the total height of the document.
  //
  // See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html

  function LeafChunk(lines) {
    var this$1 = this;

    this.lines = lines;
    this.parent = null;
    var height = 0;
    for (var i = 0; i < lines.length; ++i) {
      lines[i].parent = this$1;
      height += lines[i].height;
    }
    this.height = height;
  }

  LeafChunk.prototype = {
    chunkSize: function() { return this.lines.length },

    // Remove the n lines at offset 'at'.
    removeInner: function(at, n) {
      var this$1 = this;

      for (var i = at, e = at + n; i < e; ++i) {
        var line = this$1.lines[i];
        this$1.height -= line.height;
        cleanUpLine(line);
        signalLater(line, "delete");
      }
      this.lines.splice(at, n);
    },

    // Helper used to collapse a small branch into a single leaf.
    collapse: function(lines) {
      lines.push.apply(lines, this.lines);
    },

    // Insert the given array of lines at offset 'at', count them as
    // having the given height.
    insertInner: function(at, lines, height) {
      var this$1 = this;

      this.height += height;
      this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at));
      for (var i = 0; i < lines.length; ++i) { lines[i].parent = this$1; }
    },

    // Used to iterate over a part of the tree.
    iterN: function(at, n, op) {
      var this$1 = this;

      for (var e = at + n; at < e; ++at)
        { if (op(this$1.lines[at])) { return true } }
    }
  };

  function BranchChunk(children) {
    var this$1 = this;

    this.children = children;
    var size = 0, height = 0;
    for (var i = 0; i < children.length; ++i) {
      var ch = children[i];
      size += ch.chunkSize(); height += ch.height;
      ch.parent = this$1;
    }
    this.size = size;
    this.height = height;
    this.parent = null;
  }

  BranchChunk.prototype = {
    chunkSize: function() { return this.size },

    removeInner: function(at, n) {
      var this$1 = this;

      this.size -= n;
      for (var i = 0; i < this.children.length; ++i) {
        var child = this$1.children[i], sz = child.chunkSize();
        if (at < sz) {
          var rm = Math.min(n, sz - at), oldHeight = child.height;
          child.removeInner(at, rm);
          this$1.height -= oldHeight - child.height;
          if (sz == rm) { this$1.children.splice(i--, 1); child.parent = null; }
          if ((n -= rm) == 0) { break }
          at = 0;
        } else { at -= sz; }
      }
      // If the result is smaller than 25 lines, ensure that it is a
      // single leaf node.
      if (this.size - n < 25 &&
          (this.children.length > 1 || !(this.children[0] instanceof LeafChunk))) {
        var lines = [];
        this.collapse(lines);
        this.children = [new LeafChunk(lines)];
        this.children[0].parent = this;
      }
    },

    collapse: function(lines) {
      var this$1 = this;

      for (var i = 0; i < this.children.length; ++i) { this$1.children[i].collapse(lines); }
    },

    insertInner: function(at, lines, height) {
      var this$1 = this;

      this.size += lines.length;
      this.height += height;
      for (var i = 0; i < this.children.length; ++i) {
        var child = this$1.children[i], sz = child.chunkSize();
        if (at <= sz) {
          child.insertInner(at, lines, height);
          if (child.lines && child.lines.length > 50) {
            // To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
            // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
            var remaining = child.lines.length % 25 + 25;
            for (var pos = remaining; pos < child.lines.length;) {
              var leaf = new LeafChunk(child.lines.slice(pos, pos += 25));
              child.height -= leaf.height;
              this$1.children.splice(++i, 0, leaf);
              leaf.parent = this$1;
            }
            child.lines = child.lines.slice(0, remaining);
            this$1.maybeSpill();
          }
          break
        }
        at -= sz;
      }
    },

    // When a node has grown, check whether it should be split.
    maybeSpill: function() {
      if (this.children.length <= 10) { return }
      var me = this;
      do {
        var spilled = me.children.splice(me.children.length - 5, 5);
        var sibling = new BranchChunk(spilled);
        if (!me.parent) { // Become the parent node
          var copy = new BranchChunk(me.children);
          copy.parent = me;
          me.children = [copy, sibling];
          me = copy;
       } else {
          me.size -= sibling.size;
          me.height -= sibling.height;
          var myIndex = indexOf(me.parent.children, me);
          me.parent.children.splice(myIndex + 1, 0, sibling);
        }
        sibling.parent = me.parent;
      } while (me.children.length > 10)
      me.parent.maybeSpill();
    },

    iterN: function(at, n, op) {
      var this$1 = this;

      for (var i = 0; i < this.children.length; ++i) {
        var child = this$1.children[i], sz = child.chunkSize();
        if (at < sz) {
          var used = Math.min(n, sz - at);
          if (child.iterN(at, used, op)) { return true }
          if ((n -= used) == 0) { break }
          at = 0;
        } else { at -= sz; }
      }
    }
  };

  // Line widgets are block elements displayed above or below a line.

  var LineWidget = function(doc, node, options) {
    var this$1 = this;

    if (options) { for (var opt in options) { if (options.hasOwnProperty(opt))
      { this$1[opt] = options[opt]; } } }
    this.doc = doc;
    this.node = node;
  };

  LineWidget.prototype.clear = function () {
      var this$1 = this;

    var cm = this.doc.cm, ws = this.line.widgets, line = this.line, no = lineNo(line);
    if (no == null || !ws) { return }
    for (var i = 0; i < ws.length; ++i) { if (ws[i] == this$1) { ws.splice(i--, 1); } }
    if (!ws.length) { line.widgets = null; }
    var height = widgetHeight(this);
    updateLineHeight(line, Math.max(0, line.height - height));
    if (cm) {
      runInOp(cm, function () {
        adjustScrollWhenAboveVisible(cm, line, -height);
        regLineChange(cm, no, "widget");
      });
      signalLater(cm, "lineWidgetCleared", cm, this, no);
    }
  };

  LineWidget.prototype.changed = function () {
      var this$1 = this;

    var oldH = this.height, cm = this.doc.cm, line = this.line;
    this.height = null;
    var diff = widgetHeight(this) - oldH;
    if (!diff) { return }
    if (!lineIsHidden(this.doc, line)) { updateLineHeight(line, line.height + diff); }
    if (cm) {
      runInOp(cm, function () {
        cm.curOp.forceUpdate = true;
        adjustScrollWhenAboveVisible(cm, line, diff);
        signalLater(cm, "lineWidgetChanged", cm, this$1, lineNo(line));
      });
    }
  };
  eventMixin(LineWidget);

  function adjustScrollWhenAboveVisible(cm, line, diff) {
    if (heightAtLine(line) < ((cm.curOp && cm.curOp.scrollTop) || cm.doc.scrollTop))
      { addToScrollTop(cm, diff); }
  }

  function addLineWidget(doc, handle, node, options) {
    var widget = new LineWidget(doc, node, options);
    var cm = doc.cm;
    if (cm && widget.noHScroll) { cm.display.alignWidgets = true; }
    changeLine(doc, handle, "widget", function (line) {
      var widgets = line.widgets || (line.widgets = []);
      if (widget.insertAt == null) { widgets.push(widget); }
      else { widgets.splice(Math.min(widgets.length - 1, Math.max(0, widget.insertAt)), 0, widget); }
      widget.line = line;
      if (cm && !lineIsHidden(doc, line)) {
        var aboveVisible = heightAtLine(line) < doc.scrollTop;
        updateLineHeight(line, line.height + widgetHeight(widget));
        if (aboveVisible) { addToScrollTop(cm, widget.height); }
        cm.curOp.forceUpdate = true;
      }
      return true
    });
    if (cm) { signalLater(cm, "lineWidgetAdded", cm, widget, typeof handle == "number" ? handle : lineNo(handle)); }
    return widget
  }

  // TEXTMARKERS

  // Created with markText and setBookmark methods. A TextMarker is a
  // handle that can be used to clear or find a marked position in the
  // document. Line objects hold arrays (markedSpans) containing
  // {from, to, marker} object pointing to such marker objects, and
  // indicating that such a marker is present on that line. Multiple
  // lines may point to the same marker when it spans across lines.
  // The spans will have null for their from/to properties when the
  // marker continues beyond the start/end of the line. Markers have
  // links back to the lines they currently touch.

  // Collapsed markers have unique ids, in order to be able to order
  // them, which is needed for uniquely determining an outer marker
  // when they overlap (they may nest, but not partially overlap).
  var nextMarkerId = 0;

  var TextMarker = function(doc, type) {
    this.lines = [];
    this.type = type;
    this.doc = doc;
    this.id = ++nextMarkerId;
  };

  // Clear the marker.
  TextMarker.prototype.clear = function () {
      var this$1 = this;

    if (this.explicitlyCleared) { return }
    var cm = this.doc.cm, withOp = cm && !cm.curOp;
    if (withOp) { startOperation(cm); }
    if (hasHandler(this, "clear")) {
      var found = this.find();
      if (found) { signalLater(this, "clear", found.from, found.to); }
    }
    var min = null, max = null;
    for (var i = 0; i < this.lines.length; ++i) {
      var line = this$1.lines[i];
      var span = getMarkedSpanFor(line.markedSpans, this$1);
      if (cm && !this$1.collapsed) { regLineChange(cm, lineNo(line), "text"); }
      else if (cm) {
        if (span.to != null) { max = lineNo(line); }
        if (span.from != null) { min = lineNo(line); }
      }
      line.markedSpans = removeMarkedSpan(line.markedSpans, span);
      if (span.from == null && this$1.collapsed && !lineIsHidden(this$1.doc, line) && cm)
        { updateLineHeight(line, textHeight(cm.display)); }
    }
    if (cm && this.collapsed && !cm.options.lineWrapping) { for (var i$1 = 0; i$1 < this.lines.length; ++i$1) {
      var visual = visualLine(this$1.lines[i$1]), len = lineLength(visual);
      if (len > cm.display.maxLineLength) {
        cm.display.maxLine = visual;
        cm.display.maxLineLength = len;
        cm.display.maxLineChanged = true;
      }
    } }

    if (min != null && cm && this.collapsed) { regChange(cm, min, max + 1); }
    this.lines.length = 0;
    this.explicitlyCleared = true;
    if (this.atomic && this.doc.cantEdit) {
      this.doc.cantEdit = false;
      if (cm) { reCheckSelection(cm.doc); }
    }
    if (cm) { signalLater(cm, "markerCleared", cm, this, min, max); }
    if (withOp) { endOperation(cm); }
    if (this.parent) { this.parent.clear(); }
  };

  // Find the position of the marker in the document. Returns a {from,
  // to} object by default. Side can be passed to get a specific side
  // -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
  // Pos objects returned contain a line object, rather than a line
  // number (used to prevent looking up the same line twice).
  TextMarker.prototype.find = function (side, lineObj) {
      var this$1 = this;

    if (side == null && this.type == "bookmark") { side = 1; }
    var from, to;
    for (var i = 0; i < this.lines.length; ++i) {
      var line = this$1.lines[i];
      var span = getMarkedSpanFor(line.markedSpans, this$1);
      if (span.from != null) {
        from = Pos(lineObj ? line : lineNo(line), span.from);
        if (side == -1) { return from }
      }
      if (span.to != null) {
        to = Pos(lineObj ? line : lineNo(line), span.to);
        if (side == 1) { return to }
      }
    }
    return from && {from: from, to: to}
  };

  // Signals that the marker's widget changed, and surrounding layout
  // should be recomputed.
  TextMarker.prototype.changed = function () {
      var this$1 = this;

    var pos = this.find(-1, true), widget = this, cm = this.doc.cm;
    if (!pos || !cm) { return }
    runInOp(cm, function () {
      var line = pos.line, lineN = lineNo(pos.line);
      var view = findViewForLine(cm, lineN);
      if (view) {
        clearLineMeasurementCacheFor(view);
        cm.curOp.selectionChanged = cm.curOp.forceUpdate = true;
      }
      cm.curOp.updateMaxLine = true;
      if (!lineIsHidden(widget.doc, line) && widget.height != null) {
        var oldHeight = widget.height;
        widget.height = null;
        var dHeight = widgetHeight(widget) - oldHeight;
        if (dHeight)
          { updateLineHeight(line, line.height + dHeight); }
      }
      signalLater(cm, "markerChanged", cm, this$1);
    });
  };

  TextMarker.prototype.attachLine = function (line) {
    if (!this.lines.length && this.doc.cm) {
      var op = this.doc.cm.curOp;
      if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1)
        { (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this); }
    }
    this.lines.push(line);
  };

  TextMarker.prototype.detachLine = function (line) {
    this.lines.splice(indexOf(this.lines, line), 1);
    if (!this.lines.length && this.doc.cm) {
      var op = this.doc.cm.curOp
      ;(op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this);
    }
  };
  eventMixin(TextMarker);

  // Create a marker, wire it up to the right lines, and
  function markText(doc, from, to, options, type) {
    // Shared markers (across linked documents) are handled separately
    // (markTextShared will call out to this again, once per
    // document).
    if (options && options.shared) { return markTextShared(doc, from, to, options, type) }
    // Ensure we are in an operation.
    if (doc.cm && !doc.cm.curOp) { return operation(doc.cm, markText)(doc, from, to, options, type) }

    var marker = new TextMarker(doc, type), diff = cmp(from, to);
    if (options) { copyObj(options, marker, false); }
    // Don't connect empty markers unless clearWhenEmpty is false
    if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false)
      { return marker }
    if (marker.replacedWith) {
      // Showing up as a widget implies collapsed (widget replaces text)
      marker.collapsed = true;
      marker.widgetNode = eltP("span", [marker.replacedWith], "CodeMirror-widget");
      if (!options.handleMouseEvents) { marker.widgetNode.setAttribute("cm-ignore-events", "true"); }
      if (options.insertLeft) { marker.widgetNode.insertLeft = true; }
    }
    if (marker.collapsed) {
      if (conflictingCollapsedRange(doc, from.line, from, to, marker) ||
          from.line != to.line && conflictingCollapsedRange(doc, to.line, from, to, marker))
        { throw new Error("Inserting collapsed marker partially overlapping an existing one") }
      seeCollapsedSpans();
    }

    if (marker.addToHistory)
      { addChangeToHistory(doc, {from: from, to: to, origin: "markText"}, doc.sel, NaN); }

    var curLine = from.line, cm = doc.cm, updateMaxLine;
    doc.iter(curLine, to.line + 1, function (line) {
      if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine)
        { updateMaxLine = true; }
      if (marker.collapsed && curLine != from.line) { updateLineHeight(line, 0); }
      addMarkedSpan(line, new MarkedSpan(marker,
                                         curLine == from.line ? from.ch : null,
                                         curLine == to.line ? to.ch : null));
      ++curLine;
    });
    // lineIsHidden depends on the presence of the spans, so needs a second pass
    if (marker.collapsed) { doc.iter(from.line, to.line + 1, function (line) {
      if (lineIsHidden(doc, line)) { updateLineHeight(line, 0); }
    }); }

    if (marker.clearOnEnter) { on(marker, "beforeCursorEnter", function () { return marker.clear(); }); }

    if (marker.readOnly) {
      seeReadOnlySpans();
      if (doc.history.done.length || doc.history.undone.length)
        { doc.clearHistory(); }
    }
    if (marker.collapsed) {
      marker.id = ++nextMarkerId;
      marker.atomic = true;
    }
    if (cm) {
      // Sync editor state
      if (updateMaxLine) { cm.curOp.updateMaxLine = true; }
      if (marker.collapsed)
        { regChange(cm, from.line, to.line + 1); }
      else if (marker.className || marker.startStyle || marker.endStyle || marker.css ||
               marker.attributes || marker.title)
        { for (var i = from.line; i <= to.line; i++) { regLineChange(cm, i, "text"); } }
      if (marker.atomic) { reCheckSelection(cm.doc); }
      signalLater(cm, "markerAdded", cm, marker);
    }
    return marker
  }

  // SHARED TEXTMARKERS

  // A shared marker spans multiple linked documents. It is
  // implemented as a meta-marker-object controlling multiple normal
  // markers.
  var SharedTextMarker = function(markers, primary) {
    var this$1 = this;

    this.markers = markers;
    this.primary = primary;
    for (var i = 0; i < markers.length; ++i)
      { markers[i].parent = this$1; }
  };

  SharedTextMarker.prototype.clear = function () {
      var this$1 = this;

    if (this.explicitlyCleared) { return }
    this.explicitlyCleared = true;
    for (var i = 0; i < this.markers.length; ++i)
      { this$1.markers[i].clear(); }
    signalLater(this, "clear");
  };

  SharedTextMarker.prototype.find = function (side, lineObj) {
    return this.primary.find(side, lineObj)
  };
  eventMixin(SharedTextMarker);

  function markTextShared(doc, from, to, options, type) {
    options = copyObj(options);
    options.shared = false;
    var markers = [markText(doc, from, to, options, type)], primary = markers[0];
    var widget = options.widgetNode;
    linkedDocs(doc, function (doc) {
      if (widget) { options.widgetNode = widget.cloneNode(true); }
      markers.push(markText(doc, clipPos(doc, from), clipPos(doc, to), options, type));
      for (var i = 0; i < doc.linked.length; ++i)
        { if (doc.linked[i].isParent) { return } }
      primary = lst(markers);
    });
    return new SharedTextMarker(markers, primary)
  }

  function findSharedMarkers(doc) {
    return doc.findMarks(Pos(doc.first, 0), doc.clipPos(Pos(doc.lastLine())), function (m) { return m.parent; })
  }

  function copySharedMarkers(doc, markers) {
    for (var i = 0; i < markers.length; i++) {
      var marker = markers[i], pos = marker.find();
      var mFrom = doc.clipPos(pos.from), mTo = doc.clipPos(pos.to);
      if (cmp(mFrom, mTo)) {
        var subMark = markText(doc, mFrom, mTo, marker.primary, marker.primary.type);
        marker.markers.push(subMark);
        subMark.parent = marker;
      }
    }
  }

  function detachSharedMarkers(markers) {
    var loop = function ( i ) {
      var marker = markers[i], linked = [marker.primary.doc];
      linkedDocs(marker.primary.doc, function (d) { return linked.push(d); });
      for (var j = 0; j < marker.markers.length; j++) {
        var subMarker = marker.markers[j];
        if (indexOf(linked, subMarker.doc) == -1) {
          subMarker.parent = null;
          marker.markers.splice(j--, 1);
        }
      }
    };

    for (var i = 0; i < markers.length; i++) loop( i );
  }

  var nextDocId = 0;
  var Doc = function(text, mode, firstLine, lineSep, direction) {
    if (!(this instanceof Doc)) { return new Doc(text, mode, firstLine, lineSep, direction) }
    if (firstLine == null) { firstLine = 0; }

    BranchChunk.call(this, [new LeafChunk([new Line("", null)])]);
    this.first = firstLine;
    this.scrollTop = this.scrollLeft = 0;
    this.cantEdit = false;
    this.cleanGeneration = 1;
    this.modeFrontier = this.highlightFrontier = firstLine;
    var start = Pos(firstLine, 0);
    this.sel = simpleSelection(start);
    this.history = new History(null);
    this.id = ++nextDocId;
    this.modeOption = mode;
    this.lineSep = lineSep;
    this.direction = (direction == "rtl") ? "rtl" : "ltr";
    this.extend = false;

    if (typeof text == "string") { text = this.splitLines(text); }
    updateDoc(this, {from: start, to: start, text: text});
    setSelection(this, simpleSelection(start), sel_dontScroll);
  };

  Doc.prototype = createObj(BranchChunk.prototype, {
    constructor: Doc,
    // Iterate over the document. Supports two forms -- with only one
    // argument, it calls that for each line in the document. With
    // three, it iterates over the range given by the first two (with
    // the second being non-inclusive).
    iter: function(from, to, op) {
      if (op) { this.iterN(from - this.first, to - from, op); }
      else { this.iterN(this.first, this.first + this.size, from); }
    },

    // Non-public interface for adding and removing lines.
    insert: function(at, lines) {
      var height = 0;
      for (var i = 0; i < lines.length; ++i) { height += lines[i].height; }
      this.insertInner(at - this.first, lines, height);
    },
    remove: function(at, n) { this.removeInner(at - this.first, n); },

    // From here, the methods are part of the public interface. Most
    // are also available from CodeMirror (editor) instances.

    getValue: function(lineSep) {
      var lines = getLines(this, this.first, this.first + this.size);
      if (lineSep === false) { return lines }
      return lines.join(lineSep || this.lineSeparator())
    },
    setValue: docMethodOp(function(code) {
      var top = Pos(this.first, 0), last = this.first + this.size - 1;
      makeChange(this, {from: top, to: Pos(last, getLine(this, last).text.length),
                        text: this.splitLines(code), origin: "setValue", full: true}, true);
      if (this.cm) { scrollToCoords(this.cm, 0, 0); }
      setSelection(this, simpleSelection(top), sel_dontScroll);
    }),
    replaceRange: function(code, from, to, origin) {
      from = clipPos(this, from);
      to = to ? clipPos(this, to) : from;
      replaceRange(this, code, from, to, origin);
    },
    getRange: function(from, to, lineSep) {
      var lines = getBetween(this, clipPos(this, from), clipPos(this, to));
      if (lineSep === false) { return lines }
      return lines.join(lineSep || this.lineSeparator())
    },

    getLine: function(line) {var l = this.getLineHandle(line); return l && l.text},

    getLineHandle: function(line) {if (isLine(this, line)) { return getLine(this, line) }},
    getLineNumber: function(line) {return lineNo(line)},

    getLineHandleVisualStart: function(line) {
      if (typeof line == "number") { line = getLine(this, line); }
      return visualLine(line)
    },

    lineCount: function() {return this.size},
    firstLine: function() {return this.first},
    lastLine: function() {return this.first + this.size - 1},

    clipPos: function(pos) {return clipPos(this, pos)},

    getCursor: function(start) {
      var range$$1 = this.sel.primary(), pos;
      if (start == null || start == "head") { pos = range$$1.head; }
      else if (start == "anchor") { pos = range$$1.anchor; }
      else if (start == "end" || start == "to" || start === false) { pos = range$$1.to(); }
      else { pos = range$$1.from(); }
      return pos
    },
    listSelections: function() { return this.sel.ranges },
    somethingSelected: function() {return this.sel.somethingSelected()},

    setCursor: docMethodOp(function(line, ch, options) {
      setSimpleSelection(this, clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options);
    }),
    setSelection: docMethodOp(function(anchor, head, options) {
      setSimpleSelection(this, clipPos(this, anchor), clipPos(this, head || anchor), options);
    }),
    extendSelection: docMethodOp(function(head, other, options) {
      extendSelection(this, clipPos(this, head), other && clipPos(this, other), options);
    }),
    extendSelections: docMethodOp(function(heads, options) {
      extendSelections(this, clipPosArray(this, heads), options);
    }),
    extendSelectionsBy: docMethodOp(function(f, options) {
      var heads = map(this.sel.ranges, f);
      extendSelections(this, clipPosArray(this, heads), options);
    }),
    setSelections: docMethodOp(function(ranges, primary, options) {
      var this$1 = this;

      if (!ranges.length) { return }
      var out = [];
      for (var i = 0; i < ranges.length; i++)
        { out[i] = new Range(clipPos(this$1, ranges[i].anchor),
                           clipPos(this$1, ranges[i].head)); }
      if (primary == null) { primary = Math.min(ranges.length - 1, this.sel.primIndex); }
      setSelection(this, normalizeSelection(this.cm, out, primary), options);
    }),
    addSelection: docMethodOp(function(anchor, head, options) {
      var ranges = this.sel.ranges.slice(0);
      ranges.push(new Range(clipPos(this, anchor), clipPos(this, head || anchor)));
      setSelection(this, normalizeSelection(this.cm, ranges, ranges.length - 1), options);
    }),

    getSelection: function(lineSep) {
      var this$1 = this;

      var ranges = this.sel.ranges, lines;
      for (var i = 0; i < ranges.length; i++) {
        var sel = getBetween(this$1, ranges[i].from(), ranges[i].to());
        lines = lines ? lines.concat(sel) : sel;
      }
      if (lineSep === false) { return lines }
      else { return lines.join(lineSep || this.lineSeparator()) }
    },
    getSelections: function(lineSep) {
      var this$1 = this;

      var parts = [], ranges = this.sel.ranges;
      for (var i = 0; i < ranges.length; i++) {
        var sel = getBetween(this$1, ranges[i].from(), ranges[i].to());
        if (lineSep !== false) { sel = sel.join(lineSep || this$1.lineSeparator()); }
        parts[i] = sel;
      }
      return parts
    },
    replaceSelection: function(code, collapse, origin) {
      var dup = [];
      for (var i = 0; i < this.sel.ranges.length; i++)
        { dup[i] = code; }
      this.replaceSelections(dup, collapse, origin || "+input");
    },
    replaceSelections: docMethodOp(function(code, collapse, origin) {
      var this$1 = this;

      var changes = [], sel = this.sel;
      for (var i = 0; i < sel.ranges.length; i++) {
        var range$$1 = sel.ranges[i];
        changes[i] = {from: range$$1.from(), to: range$$1.to(), text: this$1.splitLines(code[i]), origin: origin};
      }
      var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse);
      for (var i$1 = changes.length - 1; i$1 >= 0; i$1--)
        { makeChange(this$1, changes[i$1]); }
      if (newSel) { setSelectionReplaceHistory(this, newSel); }
      else if (this.cm) { ensureCursorVisible(this.cm); }
    }),
    undo: docMethodOp(function() {makeChangeFromHistory(this, "undo");}),
    redo: docMethodOp(function() {makeChangeFromHistory(this, "redo");}),
    undoSelection: docMethodOp(function() {makeChangeFromHistory(this, "undo", true);}),
    redoSelection: docMethodOp(function() {makeChangeFromHistory(this, "redo", true);}),

    setExtending: function(val) {this.extend = val;},
    getExtending: function() {return this.extend},

    historySize: function() {
      var hist = this.history, done = 0, undone = 0;
      for (var i = 0; i < hist.done.length; i++) { if (!hist.done[i].ranges) { ++done; } }
      for (var i$1 = 0; i$1 < hist.undone.length; i$1++) { if (!hist.undone[i$1].ranges) { ++undone; } }
      return {undo: done, redo: undone}
    },
    clearHistory: function() {this.history = new History(this.history.maxGeneration);},

    markClean: function() {
      this.cleanGeneration = this.changeGeneration(true);
    },
    changeGeneration: function(forceSplit) {
      if (forceSplit)
        { this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null; }
      return this.history.generation
    },
    isClean: function (gen) {
      return this.history.generation == (gen || this.cleanGeneration)
    },

    getHistory: function() {
      return {done: copyHistoryArray(this.history.done),
              undone: copyHistoryArray(this.history.undone)}
    },
    setHistory: function(histData) {
      var hist = this.history = new History(this.history.maxGeneration);
      hist.done = copyHistoryArray(histData.done.slice(0), null, true);
      hist.undone = copyHistoryArray(histData.undone.slice(0), null, true);
    },

    setGutterMarker: docMethodOp(function(line, gutterID, value) {
      return changeLine(this, line, "gutter", function (line) {
        var markers = line.gutterMarkers || (line.gutterMarkers = {});
        markers[gutterID] = value;
        if (!value && isEmpty(markers)) { line.gutterMarkers = null; }
        return true
      })
    }),

    clearGutter: docMethodOp(function(gutterID) {
      var this$1 = this;

      this.iter(function (line) {
        if (line.gutterMarkers && line.gutterMarkers[gutterID]) {
          changeLine(this$1, line, "gutter", function () {
            line.gutterMarkers[gutterID] = null;
            if (isEmpty(line.gutterMarkers)) { line.gutterMarkers = null; }
            return true
          });
        }
      });
    }),

    lineInfo: function(line) {
      var n;
      if (typeof line == "number") {
        if (!isLine(this, line)) { return null }
        n = line;
        line = getLine(this, line);
        if (!line) { return null }
      } else {
        n = lineNo(line);
        if (n == null) { return null }
      }
      return {line: n, handle: line, text: line.text, gutterMarkers: line.gutterMarkers,
              textClass: line.textClass, bgClass: line.bgClass, wrapClass: line.wrapClass,
              widgets: line.widgets}
    },

    addLineClass: docMethodOp(function(handle, where, cls) {
      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
        var prop = where == "text" ? "textClass"
                 : where == "background" ? "bgClass"
                 : where == "gutter" ? "gutterClass" : "wrapClass";
        if (!line[prop]) { line[prop] = cls; }
        else if (classTest(cls).test(line[prop])) { return false }
        else { line[prop] += " " + cls; }
        return true
      })
    }),
    removeLineClass: docMethodOp(function(handle, where, cls) {
      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
        var prop = where == "text" ? "textClass"
                 : where == "background" ? "bgClass"
                 : where == "gutter" ? "gutterClass" : "wrapClass";
        var cur = line[prop];
        if (!cur) { return false }
        else if (cls == null) { line[prop] = null; }
        else {
          var found = cur.match(classTest(cls));
          if (!found) { return false }
          var end = found.index + found[0].length;
          line[prop] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null;
        }
        return true
      })
    }),

    addLineWidget: docMethodOp(function(handle, node, options) {
      return addLineWidget(this, handle, node, options)
    }),
    removeLineWidget: function(widget) { widget.clear(); },

    markText: function(from, to, options) {
      return markText(this, clipPos(this, from), clipPos(this, to), options, options && options.type || "range")
    },
    setBookmark: function(pos, options) {
      var realOpts = {replacedWith: options && (options.nodeType == null ? options.widget : options),
                      insertLeft: options && options.insertLeft,
                      clearWhenEmpty: false, shared: options && options.shared,
                      handleMouseEvents: options && options.handleMouseEvents};
      pos = clipPos(this, pos);
      return markText(this, pos, pos, realOpts, "bookmark")
    },
    findMarksAt: function(pos) {
      pos = clipPos(this, pos);
      var markers = [], spans = getLine(this, pos.line).markedSpans;
      if (spans) { for (var i = 0; i < spans.length; ++i) {
        var span = spans[i];
        if ((span.from == null || span.from <= pos.ch) &&
            (span.to == null || span.to >= pos.ch))
          { markers.push(span.marker.parent || span.marker); }
      } }
      return markers
    },
    findMarks: function(from, to, filter) {
      from = clipPos(this, from); to = clipPos(this, to);
      var found = [], lineNo$$1 = from.line;
      this.iter(from.line, to.line + 1, function (line) {
        var spans = line.markedSpans;
        if (spans) { for (var i = 0; i < spans.length; i++) {
          var span = spans[i];
          if (!(span.to != null && lineNo$$1 == from.line && from.ch >= span.to ||
                span.from == null && lineNo$$1 != from.line ||
                span.from != null && lineNo$$1 == to.line && span.from >= to.ch) &&
              (!filter || filter(span.marker)))
            { found.push(span.marker.parent || span.marker); }
        } }
        ++lineNo$$1;
      });
      return found
    },
    getAllMarks: function() {
      var markers = [];
      this.iter(function (line) {
        var sps = line.markedSpans;
        if (sps) { for (var i = 0; i < sps.length; ++i)
          { if (sps[i].from != null) { markers.push(sps[i].marker); } } }
      });
      return markers
    },

    posFromIndex: function(off) {
      var ch, lineNo$$1 = this.first, sepSize = this.lineSeparator().length;
      this.iter(function (line) {
        var sz = line.text.length + sepSize;
        if (sz > off) { ch = off; return true }
        off -= sz;
        ++lineNo$$1;
      });
      return clipPos(this, Pos(lineNo$$1, ch))
    },
    indexFromPos: function (coords) {
      coords = clipPos(this, coords);
      var index = coords.ch;
      if (coords.line < this.first || coords.ch < 0) { return 0 }
      var sepSize = this.lineSeparator().length;
      this.iter(this.first, coords.line, function (line) { // iter aborts when callback returns a truthy value
        index += line.text.length + sepSize;
      });
      return index
    },

    copy: function(copyHistory) {
      var doc = new Doc(getLines(this, this.first, this.first + this.size),
                        this.modeOption, this.first, this.lineSep, this.direction);
      doc.scrollTop = this.scrollTop; doc.scrollLeft = this.scrollLeft;
      doc.sel = this.sel;
      doc.extend = false;
      if (copyHistory) {
        doc.history.undoDepth = this.history.undoDepth;
        doc.setHistory(this.getHistory());
      }
      return doc
    },

    linkedDoc: function(options) {
      if (!options) { options = {}; }
      var from = this.first, to = this.first + this.size;
      if (options.from != null && options.from > from) { from = options.from; }
      if (options.to != null && options.to < to) { to = options.to; }
      var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep, this.direction);
      if (options.sharedHist) { copy.history = this.history
      ; }(this.linked || (this.linked = [])).push({doc: copy, sharedHist: options.sharedHist});
      copy.linked = [{doc: this, isParent: true, sharedHist: options.sharedHist}];
      copySharedMarkers(copy, findSharedMarkers(this));
      return copy
    },
    unlinkDoc: function(other) {
      var this$1 = this;

      if (other instanceof CodeMirror) { other = other.doc; }
      if (this.linked) { for (var i = 0; i < this.linked.length; ++i) {
        var link = this$1.linked[i];
        if (link.doc != other) { continue }
        this$1.linked.splice(i, 1);
        other.unlinkDoc(this$1);
        detachSharedMarkers(findSharedMarkers(this$1));
        break
      } }
      // If the histories were shared, split them again
      if (other.history == this.history) {
        var splitIds = [other.id];
        linkedDocs(other, function (doc) { return splitIds.push(doc.id); }, true);
        other.history = new History(null);
        other.history.done = copyHistoryArray(this.history.done, splitIds);
        other.history.undone = copyHistoryArray(this.history.undone, splitIds);
      }
    },
    iterLinkedDocs: function(f) {linkedDocs(this, f);},

    getMode: function() {return this.mode},
    getEditor: function() {return this.cm},

    splitLines: function(str) {
      if (this.lineSep) { return str.split(this.lineSep) }
      return splitLinesAuto(str)
    },
    lineSeparator: function() { return this.lineSep || "\n" },

    setDirection: docMethodOp(function (dir) {
      if (dir != "rtl") { dir = "ltr"; }
      if (dir == this.direction) { return }
      this.direction = dir;
      this.iter(function (line) { return line.order = null; });
      if (this.cm) { directionChanged(this.cm); }
    })
  });

  // Public alias.
  Doc.prototype.eachLine = Doc.prototype.iter;

  // Kludge to work around strange IE behavior where it'll sometimes
  // re-fire a series of drag-related events right after the drop (#1551)
  var lastDrop = 0;

  function onDrop(e) {
    var cm = this;
    clearDragCursor(cm);
    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e))
      { return }
    e_preventDefault(e);
    if (ie) { lastDrop = +new Date; }
    var pos = posFromMouse(cm, e, true), files = e.dataTransfer.files;
    if (!pos || cm.isReadOnly()) { return }
    // Might be a file drop, in which case we simply extract the text
    // and insert it.
    if (files && files.length && window.FileReader && window.File) {
      var n = files.length, text = Array(n), read = 0;
      var loadFile = function (file, i) {
        if (cm.options.allowDropFileTypes &&
            indexOf(cm.options.allowDropFileTypes, file.type) == -1)
          { return }

        var reader = new FileReader;
        reader.onload = operation(cm, function () {
          var content = reader.result;
          if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) { content = ""; }
          text[i] = content;
          if (++read == n) {
            pos = clipPos(cm.doc, pos);
            var change = {from: pos, to: pos,
                          text: cm.doc.splitLines(text.join(cm.doc.lineSeparator())),
                          origin: "paste"};
            makeChange(cm.doc, change);
            setSelectionReplaceHistory(cm.doc, simpleSelection(pos, changeEnd(change)));
          }
        });
        reader.readAsText(file);
      };
      for (var i = 0; i < n; ++i) { loadFile(files[i], i); }
    } else { // Normal drop
      // Don't do a replace if the drop happened inside of the selected text.
      if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
        cm.state.draggingText(e);
        // Ensure the editor is re-focused
        setTimeout(function () { return cm.display.input.focus(); }, 20);
        return
      }
      try {
        var text$1 = e.dataTransfer.getData("Text");
        if (text$1) {
          var selected;
          if (cm.state.draggingText && !cm.state.draggingText.copy)
            { selected = cm.listSelections(); }
          setSelectionNoUndo(cm.doc, simpleSelection(pos, pos));
          if (selected) { for (var i$1 = 0; i$1 < selected.length; ++i$1)
            { replaceRange(cm.doc, "", selected[i$1].anchor, selected[i$1].head, "drag"); } }
          cm.replaceSelection(text$1, "around", "paste");
          cm.display.input.focus();
        }
      }
      catch(e){}
    }
  }

  function onDragStart(cm, e) {
    if (ie && (!cm.state.draggingText || +new Date - lastDrop < 100)) { e_stop(e); return }
    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) { return }

    e.dataTransfer.setData("Text", cm.getSelection());
    e.dataTransfer.effectAllowed = "copyMove";

    // Use dummy image instead of default browsers image.
    // Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
    if (e.dataTransfer.setDragImage && !safari) {
      var img = elt("img", null, null, "position: fixed; left: 0; top: 0;");
      img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
      if (presto) {
        img.width = img.height = 1;
        cm.display.wrapper.appendChild(img);
        // Force a relayout, or Opera won't use our image for some obscure reason
        img._top = img.offsetTop;
      }
      e.dataTransfer.setDragImage(img, 0, 0);
      if (presto) { img.parentNode.removeChild(img); }
    }
  }

  function onDragOver(cm, e) {
    var pos = posFromMouse(cm, e);
    if (!pos) { return }
    var frag = document.createDocumentFragment();
    drawSelectionCursor(cm, pos, frag);
    if (!cm.display.dragCursor) {
      cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors");
      cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv);
    }
    removeChildrenAndAdd(cm.display.dragCursor, frag);
  }

  function clearDragCursor(cm) {
    if (cm.display.dragCursor) {
      cm.display.lineSpace.removeChild(cm.display.dragCursor);
      cm.display.dragCursor = null;
    }
  }

  // These must be handled carefully, because naively registering a
  // handler for each editor will cause the editors to never be
  // garbage collected.

  function forEachCodeMirror(f) {
    if (!document.getElementsByClassName) { return }
    var byClass = document.getElementsByClassName("CodeMirror"), editors = [];
    for (var i = 0; i < byClass.length; i++) {
      var cm = byClass[i].CodeMirror;
      if (cm) { editors.push(cm); }
    }
    if (editors.length) { editors[0].operation(function () {
      for (var i = 0; i < editors.length; i++) { f(editors[i]); }
    }); }
  }

  var globalsRegistered = false;
  function ensureGlobalHandlers() {
    if (globalsRegistered) { return }
    registerGlobalHandlers();
    globalsRegistered = true;
  }
  function registerGlobalHandlers() {
    // When the window resizes, we need to refresh active editors.
    var resizeTimer;
    on(window, "resize", function () {
      if (resizeTimer == null) { resizeTimer = setTimeout(function () {
        resizeTimer = null;
        forEachCodeMirror(onResize);
      }, 100); }
    });
    // When the window loses focus, we want to show the editor as blurred
    on(window, "blur", function () { return forEachCodeMirror(onBlur); });
  }
  // Called when the window resizes
  function onResize(cm) {
    var d = cm.display;
    // Might be a text scaling operation, clear size caches.
    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
    d.scrollbarsClipped = false;
    cm.setSize();
  }

  var keyNames = {
    3: "Pause", 8: "Backspace", 9: "Tab", 13: "Enter", 16: "Shift", 17: "Ctrl", 18: "Alt",
    19: "Pause", 20: "CapsLock", 27: "Esc", 32: "Space", 33: "PageUp", 34: "PageDown", 35: "End",
    36: "Home", 37: "Left", 38: "Up", 39: "Right", 40: "Down", 44: "PrintScrn", 45: "Insert",
    46: "Delete", 59: ";", 61: "=", 91: "Mod", 92: "Mod", 93: "Mod",
    106: "*", 107: "=", 109: "-", 110: ".", 111: "/", 127: "Delete", 145: "ScrollLock",
    173: "-", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\",
    221: "]", 222: "'", 63232: "Up", 63233: "Down", 63234: "Left", 63235: "Right", 63272: "Delete",
    63273: "Home", 63275: "End", 63276: "PageUp", 63277: "PageDown", 63302: "Insert"
  };

  // Number keys
  for (var i = 0; i < 10; i++) { keyNames[i + 48] = keyNames[i + 96] = String(i); }
  // Alphabetic keys
  for (var i$1 = 65; i$1 <= 90; i$1++) { keyNames[i$1] = String.fromCharCode(i$1); }
  // Function keys
  for (var i$2 = 1; i$2 <= 12; i$2++) { keyNames[i$2 + 111] = keyNames[i$2 + 63235] = "F" + i$2; }

  var keyMap = {};

  keyMap.basic = {
    "Left": "goCharLeft", "Right": "goCharRight", "Up": "goLineUp", "Down": "goLineDown",
    "End": "goLineEnd", "Home": "goLineStartSmart", "PageUp": "goPageUp", "PageDown": "goPageDown",
    "Delete": "delCharAfter", "Backspace": "delCharBefore", "Shift-Backspace": "delCharBefore",
    "Tab": "defaultTab", "Shift-Tab": "indentAuto",
    "Enter": "newlineAndIndent", "Insert": "toggleOverwrite",
    "Esc": "singleSelection"
  };
  // Note that the save and find-related commands aren't defined by
  // default. User code or addons can define them. Unknown commands
  // are simply ignored.
  keyMap.pcDefault = {
    "Ctrl-A": "selectAll", "Ctrl-D": "deleteLine", "Ctrl-Z": "undo", "Shift-Ctrl-Z": "redo", "Ctrl-Y": "redo",
    "Ctrl-Home": "goDocStart", "Ctrl-End": "goDocEnd", "Ctrl-Up": "goLineUp", "Ctrl-Down": "goLineDown",
    "Ctrl-Left": "goGroupLeft", "Ctrl-Right": "goGroupRight", "Alt-Left": "goLineStart", "Alt-Right": "goLineEnd",
    "Ctrl-Backspace": "delGroupBefore", "Ctrl-Delete": "delGroupAfter", "Ctrl-S": "save", "Ctrl-F": "find",
    "Ctrl-G": "findNext", "Shift-Ctrl-G": "findPrev", "Shift-Ctrl-F": "replace", "Shift-Ctrl-R": "replaceAll",
    "Ctrl-[": "indentLess", "Ctrl-]": "indentMore",
    "Ctrl-U": "undoSelection", "Shift-Ctrl-U": "redoSelection", "Alt-U": "redoSelection",
    "fallthrough": "basic"
  };
  // Very basic readline/emacs-style bindings, which are standard on Mac.
  keyMap.emacsy = {
    "Ctrl-F": "goCharRight", "Ctrl-B": "goCharLeft", "Ctrl-P": "goLineUp", "Ctrl-N": "goLineDown",
    "Alt-F": "goWordRight", "Alt-B": "goWordLeft", "Ctrl-A": "goLineStart", "Ctrl-E": "goLineEnd",
    "Ctrl-V": "goPageDown", "Shift-Ctrl-V": "goPageUp", "Ctrl-D": "delCharAfter", "Ctrl-H": "delCharBefore",
    "Alt-D": "delWordAfter", "Alt-Backspace": "delWordBefore", "Ctrl-K": "killLine", "Ctrl-T": "transposeChars",
    "Ctrl-O": "openLine"
  };
  keyMap.macDefault = {
    "Cmd-A": "selectAll", "Cmd-D": "deleteLine", "Cmd-Z": "undo", "Shift-Cmd-Z": "redo", "Cmd-Y": "redo",
    "Cmd-Home": "goDocStart", "Cmd-Up": "goDocStart", "Cmd-End": "goDocEnd", "Cmd-Down": "goDocEnd", "Alt-Left": "goGroupLeft",
    "Alt-Right": "goGroupRight", "Cmd-Left": "goLineLeft", "Cmd-Right": "goLineRight", "Alt-Backspace": "delGroupBefore",
    "Ctrl-Alt-Backspace": "delGroupAfter", "Alt-Delete": "delGroupAfter", "Cmd-S": "save", "Cmd-F": "find",
    "Cmd-G": "findNext", "Shift-Cmd-G": "findPrev", "Cmd-Alt-F": "replace", "Shift-Cmd-Alt-F": "replaceAll",
    "Cmd-[": "indentLess", "Cmd-]": "indentMore", "Cmd-Backspace": "delWrappedLineLeft", "Cmd-Delete": "delWrappedLineRight",
    "Cmd-U": "undoSelection", "Shift-Cmd-U": "redoSelection", "Ctrl-Up": "goDocStart", "Ctrl-Down": "goDocEnd",
    "fallthrough": ["basic", "emacsy"]
  };
  keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault;

  // KEYMAP DISPATCH

  function normalizeKeyName(name) {
    var parts = name.split(/-(?!$)/);
    name = parts[parts.length - 1];
    var alt, ctrl, shift, cmd;
    for (var i = 0; i < parts.length - 1; i++) {
      var mod = parts[i];
      if (/^(cmd|meta|m)$/i.test(mod)) { cmd = true; }
      else if (/^a(lt)?$/i.test(mod)) { alt = true; }
      else if (/^(c|ctrl|control)$/i.test(mod)) { ctrl = true; }
      else if (/^s(hift)?$/i.test(mod)) { shift = true; }
      else { throw new Error("Unrecognized modifier name: " + mod) }
    }
    if (alt) { name = "Alt-" + name; }
    if (ctrl) { name = "Ctrl-" + name; }
    if (cmd) { name = "Cmd-" + name; }
    if (shift) { name = "Shift-" + name; }
    return name
  }

  // This is a kludge to keep keymaps mostly working as raw objects
  // (backwards compatibility) while at the same time support features
  // like normalization and multi-stroke key bindings. It compiles a
  // new normalized keymap, and then updates the old object to reflect
  // this.
  function normalizeKeyMap(keymap) {
    var copy = {};
    for (var keyname in keymap) { if (keymap.hasOwnProperty(keyname)) {
      var value = keymap[keyname];
      if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) { continue }
      if (value == "...") { delete keymap[keyname]; continue }

      var keys = map(keyname.split(" "), normalizeKeyName);
      for (var i = 0; i < keys.length; i++) {
        var val = (void 0), name = (void 0);
        if (i == keys.length - 1) {
          name = keys.join(" ");
          val = value;
        } else {
          name = keys.slice(0, i + 1).join(" ");
          val = "...";
        }
        var prev = copy[name];
        if (!prev) { copy[name] = val; }
        else if (prev != val) { throw new Error("Inconsistent bindings for " + name) }
      }
      delete keymap[keyname];
    } }
    for (var prop in copy) { keymap[prop] = copy[prop]; }
    return keymap
  }

  function lookupKey(key, map$$1, handle, context) {
    map$$1 = getKeyMap(map$$1);
    var found = map$$1.call ? map$$1.call(key, context) : map$$1[key];
    if (found === false) { return "nothing" }
    if (found === "...") { return "multi" }
    if (found != null && handle(found)) { return "handled" }

    if (map$$1.fallthrough) {
      if (Object.prototype.toString.call(map$$1.fallthrough) != "[object Array]")
        { return lookupKey(key, map$$1.fallthrough, handle, context) }
      for (var i = 0; i < map$$1.fallthrough.length; i++) {
        var result = lookupKey(key, map$$1.fallthrough[i], handle, context);
        if (result) { return result }
      }
    }
  }

  // Modifier key presses don't count as 'real' key presses for the
  // purpose of keymap fallthrough.
  function isModifierKey(value) {
    var name = typeof value == "string" ? value : keyNames[value.keyCode];
    return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod"
  }

  function addModifierNames(name, event, noShift) {
    var base = name;
    if (event.altKey && base != "Alt") { name = "Alt-" + name; }
    if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") { name = "Ctrl-" + name; }
    if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Cmd") { name = "Cmd-" + name; }
    if (!noShift && event.shiftKey && base != "Shift") { name = "Shift-" + name; }
    return name
  }

  // Look up the name of a key as indicated by an event object.
  function keyName(event, noShift) {
    if (presto && event.keyCode == 34 && event["char"]) { return false }
    var name = keyNames[event.keyCode];
    if (name == null || event.altGraphKey) { return false }
    // Ctrl-ScrollLock has keyCode 3, same as Ctrl-Pause,
    // so we'll use event.code when available (Chrome 48+, FF 38+, Safari 10.1+)
    if (event.keyCode == 3 && event.code) { name = event.code; }
    return addModifierNames(name, event, noShift)
  }

  function getKeyMap(val) {
    return typeof val == "string" ? keyMap[val] : val
  }

  // Helper for deleting text near the selection(s), used to implement
  // backspace, delete, and similar functionality.
  function deleteNearSelection(cm, compute) {
    var ranges = cm.doc.sel.ranges, kill = [];
    // Build up a set of ranges to kill first, merging overlapping
    // ranges.
    for (var i = 0; i < ranges.length; i++) {
      var toKill = compute(ranges[i]);
      while (kill.length && cmp(toKill.from, lst(kill).to) <= 0) {
        var replaced = kill.pop();
        if (cmp(replaced.from, toKill.from) < 0) {
          toKill.from = replaced.from;
          break
        }
      }
      kill.push(toKill);
    }
    // Next, remove those actual ranges.
    runInOp(cm, function () {
      for (var i = kill.length - 1; i >= 0; i--)
        { replaceRange(cm.doc, "", kill[i].from, kill[i].to, "+delete"); }
      ensureCursorVisible(cm);
    });
  }

  function moveCharLogically(line, ch, dir) {
    var target = skipExtendingChars(line.text, ch + dir, dir);
    return target < 0 || target > line.text.length ? null : target
  }

  function moveLogically(line, start, dir) {
    var ch = moveCharLogically(line, start.ch, dir);
    return ch == null ? null : new Pos(start.line, ch, dir < 0 ? "after" : "before")
  }

  function endOfLine(visually, cm, lineObj, lineNo, dir) {
    if (visually) {
      var order = getOrder(lineObj, cm.doc.direction);
      if (order) {
        var part = dir < 0 ? lst(order) : order[0];
        var moveInStorageOrder = (dir < 0) == (part.level == 1);
        var sticky = moveInStorageOrder ? "after" : "before";
        var ch;
        // With a wrapped rtl chunk (possibly spanning multiple bidi parts),
        // it could be that the last bidi part is not on the last visual line,
        // since visual lines contain content order-consecutive chunks.
        // Thus, in rtl, we are looking for the first (content-order) character
        // in the rtl chunk that is on the last line (that is, the same line
        // as the last (content-order) character).
        if (part.level > 0 || cm.doc.direction == "rtl") {
          var prep = prepareMeasureForLine(cm, lineObj);
          ch = dir < 0 ? lineObj.text.length - 1 : 0;
          var targetTop = measureCharPrepared(cm, prep, ch).top;
          ch = findFirst(function (ch) { return measureCharPrepared(cm, prep, ch).top == targetTop; }, (dir < 0) == (part.level == 1) ? part.from : part.to - 1, ch);
          if (sticky == "before") { ch = moveCharLogically(lineObj, ch, 1); }
        } else { ch = dir < 0 ? part.to : part.from; }
        return new Pos(lineNo, ch, sticky)
      }
    }
    return new Pos(lineNo, dir < 0 ? lineObj.text.length : 0, dir < 0 ? "before" : "after")
  }

  function moveVisually(cm, line, start, dir) {
    var bidi = getOrder(line, cm.doc.direction);
    if (!bidi) { return moveLogically(line, start, dir) }
    if (start.ch >= line.text.length) {
      start.ch = line.text.length;
      start.sticky = "before";
    } else if (start.ch <= 0) {
      start.ch = 0;
      start.sticky = "after";
    }
    var partPos = getBidiPartAt(bidi, start.ch, start.sticky), part = bidi[partPos];
    if (cm.doc.direction == "ltr" && part.level % 2 == 0 && (dir > 0 ? part.to > start.ch : part.from < start.ch)) {
      // Case 1: We move within an ltr part in an ltr editor. Even with wrapped lines,
      // nothing interesting happens.
      return moveLogically(line, start, dir)
    }

    var mv = function (pos, dir) { return moveCharLogically(line, pos instanceof Pos ? pos.ch : pos, dir); };
    var prep;
    var getWrappedLineExtent = function (ch) {
      if (!cm.options.lineWrapping) { return {begin: 0, end: line.text.length} }
      prep = prep || prepareMeasureForLine(cm, line);
      return wrappedLineExtentChar(cm, line, prep, ch)
    };
    var wrappedLineExtent = getWrappedLineExtent(start.sticky == "before" ? mv(start, -1) : start.ch);

    if (cm.doc.direction == "rtl" || part.level == 1) {
      var moveInStorageOrder = (part.level == 1) == (dir < 0);
      var ch = mv(start, moveInStorageOrder ? 1 : -1);
      if (ch != null && (!moveInStorageOrder ? ch >= part.from && ch >= wrappedLineExtent.begin : ch <= part.to && ch <= wrappedLineExtent.end)) {
        // Case 2: We move within an rtl part or in an rtl editor on the same visual line
        var sticky = moveInStorageOrder ? "before" : "after";
        return new Pos(start.line, ch, sticky)
      }
    }

    // Case 3: Could not move within this bidi part in this visual line, so leave
    // the current bidi part

    var searchInVisualLine = function (partPos, dir, wrappedLineExtent) {
      var getRes = function (ch, moveInStorageOrder) { return moveInStorageOrder
        ? new Pos(start.line, mv(ch, 1), "before")
        : new Pos(start.line, ch, "after"); };

      for (; partPos >= 0 && partPos < bidi.length; partPos += dir) {
        var part = bidi[partPos];
        var moveInStorageOrder = (dir > 0) == (part.level != 1);
        var ch = moveInStorageOrder ? wrappedLineExtent.begin : mv(wrappedLineExtent.end, -1);
        if (part.from <= ch && ch < part.to) { return getRes(ch, moveInStorageOrder) }
        ch = moveInStorageOrder ? part.from : mv(part.to, -1);
        if (wrappedLineExtent.begin <= ch && ch < wrappedLineExtent.end) { return getRes(ch, moveInStorageOrder) }
      }
    };

    // Case 3a: Look for other bidi parts on the same visual line
    var res = searchInVisualLine(partPos + dir, dir, wrappedLineExtent);
    if (res) { return res }

    // Case 3b: Look for other bidi parts on the next visual line
    var nextCh = dir > 0 ? wrappedLineExtent.end : mv(wrappedLineExtent.begin, -1);
    if (nextCh != null && !(dir > 0 && nextCh == line.text.length)) {
      res = searchInVisualLine(dir > 0 ? 0 : bidi.length - 1, dir, getWrappedLineExtent(nextCh));
      if (res) { return res }
    }

    // Case 4: Nowhere to move
    return null
  }

  // Commands are parameter-less actions that can be performed on an
  // editor, mostly used for keybindings.
  var commands = {
    selectAll: selectAll,
    singleSelection: function (cm) { return cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll); },
    killLine: function (cm) { return deleteNearSelection(cm, function (range) {
      if (range.empty()) {
        var len = getLine(cm.doc, range.head.line).text.length;
        if (range.head.ch == len && range.head.line < cm.lastLine())
          { return {from: range.head, to: Pos(range.head.line + 1, 0)} }
        else
          { return {from: range.head, to: Pos(range.head.line, len)} }
      } else {
        return {from: range.from(), to: range.to()}
      }
    }); },
    deleteLine: function (cm) { return deleteNearSelection(cm, function (range) { return ({
      from: Pos(range.from().line, 0),
      to: clipPos(cm.doc, Pos(range.to().line + 1, 0))
    }); }); },
    delLineLeft: function (cm) { return deleteNearSelection(cm, function (range) { return ({
      from: Pos(range.from().line, 0), to: range.from()
    }); }); },
    delWrappedLineLeft: function (cm) { return deleteNearSelection(cm, function (range) {
      var top = cm.charCoords(range.head, "div").top + 5;
      var leftPos = cm.coordsChar({left: 0, top: top}, "div");
      return {from: leftPos, to: range.from()}
    }); },
    delWrappedLineRight: function (cm) { return deleteNearSelection(cm, function (range) {
      var top = cm.charCoords(range.head, "div").top + 5;
      var rightPos = cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div");
      return {from: range.from(), to: rightPos }
    }); },
    undo: function (cm) { return cm.undo(); },
    redo: function (cm) { return cm.redo(); },
    undoSelection: function (cm) { return cm.undoSelection(); },
    redoSelection: function (cm) { return cm.redoSelection(); },
    goDocStart: function (cm) { return cm.extendSelection(Pos(cm.firstLine(), 0)); },
    goDocEnd: function (cm) { return cm.extendSelection(Pos(cm.lastLine())); },
    goLineStart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStart(cm, range.head.line); },
      {origin: "+move", bias: 1}
    ); },
    goLineStartSmart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStartSmart(cm, range.head); },
      {origin: "+move", bias: 1}
    ); },
    goLineEnd: function (cm) { return cm.extendSelectionsBy(function (range) { return lineEnd(cm, range.head.line); },
      {origin: "+move", bias: -1}
    ); },
    goLineRight: function (cm) { return cm.extendSelectionsBy(function (range) {
      var top = cm.cursorCoords(range.head, "div").top + 5;
      return cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div")
    }, sel_move); },
    goLineLeft: function (cm) { return cm.extendSelectionsBy(function (range) {
      var top = cm.cursorCoords(range.head, "div").top + 5;
      return cm.coordsChar({left: 0, top: top}, "div")
    }, sel_move); },
    goLineLeftSmart: function (cm) { return cm.extendSelectionsBy(function (range) {
      var top = cm.cursorCoords(range.head, "div").top + 5;
      var pos = cm.coordsChar({left: 0, top: top}, "div");
      if (pos.ch < cm.getLine(pos.line).search(/\S/)) { return lineStartSmart(cm, range.head) }
      return pos
    }, sel_move); },
    goLineUp: function (cm) { return cm.moveV(-1, "line"); },
    goLineDown: function (cm) { return cm.moveV(1, "line"); },
    goPageUp: function (cm) { return cm.moveV(-1, "page"); },
    goPageDown: function (cm) { return cm.moveV(1, "page"); },
    goCharLeft: function (cm) { return cm.moveH(-1, "char"); },
    goCharRight: function (cm) { return cm.moveH(1, "char"); },
    goColumnLeft: function (cm) { return cm.moveH(-1, "column"); },
    goColumnRight: function (cm) { return cm.moveH(1, "column"); },
    goWordLeft: function (cm) { return cm.moveH(-1, "word"); },
    goGroupRight: function (cm) { return cm.moveH(1, "group"); },
    goGroupLeft: function (cm) { return cm.moveH(-1, "group"); },
    goWordRight: function (cm) { return cm.moveH(1, "word"); },
    delCharBefore: function (cm) { return cm.deleteH(-1, "char"); },
    delCharAfter: function (cm) { return cm.deleteH(1, "char"); },
    delWordBefore: function (cm) { return cm.deleteH(-1, "word"); },
    delWordAfter: function (cm) { return cm.deleteH(1, "word"); },
    delGroupBefore: function (cm) { return cm.deleteH(-1, "group"); },
    delGroupAfter: function (cm) { return cm.deleteH(1, "group"); },
    indentAuto: function (cm) { return cm.indentSelection("smart"); },
    indentMore: function (cm) { return cm.indentSelection("add"); },
    indentLess: function (cm) { return cm.indentSelection("subtract"); },
    insertTab: function (cm) { return cm.replaceSelection("\t"); },
    insertSoftTab: function (cm) {
      var spaces = [], ranges = cm.listSelections(), tabSize = cm.options.tabSize;
      for (var i = 0; i < ranges.length; i++) {
        var pos = ranges[i].from();
        var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize);
        spaces.push(spaceStr(tabSize - col % tabSize));
      }
      cm.replaceSelections(spaces);
    },
    defaultTab: function (cm) {
      if (cm.somethingSelected()) { cm.indentSelection("add"); }
      else { cm.execCommand("insertTab"); }
    },
    // Swap the two chars left and right of each selection's head.
    // Move cursor behind the two swapped characters afterwards.
    //
    // Doesn't consider line feeds a character.
    // Doesn't scan more than one line above to find a character.
    // Doesn't do anything on an empty line.
    // Doesn't do anything with non-empty selections.
    transposeChars: function (cm) { return runInOp(cm, function () {
      var ranges = cm.listSelections(), newSel = [];
      for (var i = 0; i < ranges.length; i++) {
        if (!ranges[i].empty()) { continue }
        var cur = ranges[i].head, line = getLine(cm.doc, cur.line).text;
        if (line) {
          if (cur.ch == line.length) { cur = new Pos(cur.line, cur.ch - 1); }
          if (cur.ch > 0) {
            cur = new Pos(cur.line, cur.ch + 1);
            cm.replaceRange(line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2),
                            Pos(cur.line, cur.ch - 2), cur, "+transpose");
          } else if (cur.line > cm.doc.first) {
            var prev = getLine(cm.doc, cur.line - 1).text;
            if (prev) {
              cur = new Pos(cur.line, 1);
              cm.replaceRange(line.charAt(0) + cm.doc.lineSeparator() +
                              prev.charAt(prev.length - 1),
                              Pos(cur.line - 1, prev.length - 1), cur, "+transpose");
            }
          }
        }
        newSel.push(new Range(cur, cur));
      }
      cm.setSelections(newSel);
    }); },
    newlineAndIndent: function (cm) { return runInOp(cm, function () {
      var sels = cm.listSelections();
      for (var i = sels.length - 1; i >= 0; i--)
        { cm.replaceRange(cm.doc.lineSeparator(), sels[i].anchor, sels[i].head, "+input"); }
      sels = cm.listSelections();
      for (var i$1 = 0; i$1 < sels.length; i$1++)
        { cm.indentLine(sels[i$1].from().line, null, true); }
      ensureCursorVisible(cm);
    }); },
    openLine: function (cm) { return cm.replaceSelection("\n", "start"); },
    toggleOverwrite: function (cm) { return cm.toggleOverwrite(); }
  };


  function lineStart(cm, lineN) {
    var line = getLine(cm.doc, lineN);
    var visual = visualLine(line);
    if (visual != line) { lineN = lineNo(visual); }
    return endOfLine(true, cm, visual, lineN, 1)
  }
  function lineEnd(cm, lineN) {
    var line = getLine(cm.doc, lineN);
    var visual = visualLineEnd(line);
    if (visual != line) { lineN = lineNo(visual); }
    return endOfLine(true, cm, line, lineN, -1)
  }
  function lineStartSmart(cm, pos) {
    var start = lineStart(cm, pos.line);
    var line = getLine(cm.doc, start.line);
    var order = getOrder(line, cm.doc.direction);
    if (!order || order[0].level == 0) {
      var firstNonWS = Math.max(0, line.text.search(/\S/));
      var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch;
      return Pos(start.line, inWS ? 0 : firstNonWS, start.sticky)
    }
    return start
  }

  // Run a handler that was bound to a key.
  function doHandleBinding(cm, bound, dropShift) {
    if (typeof bound == "string") {
      bound = commands[bound];
      if (!bound) { return false }
    }
    // Ensure previous input has been read, so that the handler sees a
    // consistent view of the document
    cm.display.input.ensurePolled();
    var prevShift = cm.display.shift, done = false;
    try {
      if (cm.isReadOnly()) { cm.state.suppressEdits = true; }
      if (dropShift) { cm.display.shift = false; }
      done = bound(cm) != Pass;
    } finally {
      cm.display.shift = prevShift;
      cm.state.suppressEdits = false;
    }
    return done
  }

  function lookupKeyForEditor(cm, name, handle) {
    for (var i = 0; i < cm.state.keyMaps.length; i++) {
      var result = lookupKey(name, cm.state.keyMaps[i], handle, cm);
      if (result) { return result }
    }
    return (cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm))
      || lookupKey(name, cm.options.keyMap, handle, cm)
  }

  // Note that, despite the name, this function is also used to check
  // for bound mouse clicks.

  var stopSeq = new Delayed;

  function dispatchKey(cm, name, e, handle) {
    var seq = cm.state.keySeq;
    if (seq) {
      if (isModifierKey(name)) { return "handled" }
      if (/\'$/.test(name))
        { cm.state.keySeq = null; }
      else
        { stopSeq.set(50, function () {
          if (cm.state.keySeq == seq) {
            cm.state.keySeq = null;
            cm.display.input.reset();
          }
        }); }
      if (dispatchKeyInner(cm, seq + " " + name, e, handle)) { return true }
    }
    return dispatchKeyInner(cm, name, e, handle)
  }

  function dispatchKeyInner(cm, name, e, handle) {
    var result = lookupKeyForEditor(cm, name, handle);

    if (result == "multi")
      { cm.state.keySeq = name; }
    if (result == "handled")
      { signalLater(cm, "keyHandled", cm, name, e); }

    if (result == "handled" || result == "multi") {
      e_preventDefault(e);
      restartBlink(cm);
    }

    return !!result
  }

  // Handle a key from the keydown event.
  function handleKeyBinding(cm, e) {
    var name = keyName(e, true);
    if (!name) { return false }

    if (e.shiftKey && !cm.state.keySeq) {
      // First try to resolve full name (including 'Shift-'). Failing
      // that, see if there is a cursor-motion command (starting with
      // 'go') bound to the keyname without 'Shift-'.
      return dispatchKey(cm, "Shift-" + name, e, function (b) { return doHandleBinding(cm, b, true); })
          || dispatchKey(cm, name, e, function (b) {
               if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion)
                 { return doHandleBinding(cm, b) }
             })
    } else {
      return dispatchKey(cm, name, e, function (b) { return doHandleBinding(cm, b); })
    }
  }

  // Handle a key from the keypress event
  function handleCharBinding(cm, e, ch) {
    return dispatchKey(cm, "'" + ch + "'", e, function (b) { return doHandleBinding(cm, b, true); })
  }

  var lastStoppedKey = null;
  function onKeyDown(e) {
    var cm = this;
    cm.curOp.focus = activeElt();
    if (signalDOMEvent(cm, e)) { return }
    // IE does strange things with escape.
    if (ie && ie_version < 11 && e.keyCode == 27) { e.returnValue = false; }
    var code = e.keyCode;
    cm.display.shift = code == 16 || e.shiftKey;
    var handled = handleKeyBinding(cm, e);
    if (presto) {
      lastStoppedKey = handled ? code : null;
      // Opera has no cut event... we try to at least catch the key combo
      if (!handled && code == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey))
        { cm.replaceSelection("", null, "cut"); }
    }

    // Turn mouse into crosshair when Alt is held on Mac.
    if (code == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className))
      { showCrossHair(cm); }
  }

  function showCrossHair(cm) {
    var lineDiv = cm.display.lineDiv;
    addClass(lineDiv, "CodeMirror-crosshair");

    function up(e) {
      if (e.keyCode == 18 || !e.altKey) {
        rmClass(lineDiv, "CodeMirror-crosshair");
        off(document, "keyup", up);
        off(document, "mouseover", up);
      }
    }
    on(document, "keyup", up);
    on(document, "mouseover", up);
  }

  function onKeyUp(e) {
    if (e.keyCode == 16) { this.doc.sel.shift = false; }
    signalDOMEvent(this, e);
  }

  function onKeyPress(e) {
    var cm = this;
    if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) { return }
    var keyCode = e.keyCode, charCode = e.charCode;
    if (presto && keyCode == lastStoppedKey) {lastStoppedKey = null; e_preventDefault(e); return}
    if ((presto && (!e.which || e.which < 10)) && handleKeyBinding(cm, e)) { return }
    var ch = String.fromCharCode(charCode == null ? keyCode : charCode);
    // Some browsers fire keypress events for backspace
    if (ch == "\x08") { return }
    if (handleCharBinding(cm, e, ch)) { return }
    cm.display.input.onKeyPress(e);
  }

  var DOUBLECLICK_DELAY = 400;

  var PastClick = function(time, pos, button) {
    this.time = time;
    this.pos = pos;
    this.button = button;
  };

  PastClick.prototype.compare = function (time, pos, button) {
    return this.time + DOUBLECLICK_DELAY > time &&
      cmp(pos, this.pos) == 0 && button == this.button
  };

  var lastClick, lastDoubleClick;
  function clickRepeat(pos, button) {
    var now = +new Date;
    if (lastDoubleClick && lastDoubleClick.compare(now, pos, button)) {
      lastClick = lastDoubleClick = null;
      return "triple"
    } else if (lastClick && lastClick.compare(now, pos, button)) {
      lastDoubleClick = new PastClick(now, pos, button);
      lastClick = null;
      return "double"
    } else {
      lastClick = new PastClick(now, pos, button);
      lastDoubleClick = null;
      return "single"
    }
  }

  // A mouse down can be a single click, double click, triple click,
  // start of selection drag, start of text drag, new cursor
  // (ctrl-click), rectangle drag (alt-drag), or xwin
  // middle-click-paste. Or it might be a click on something we should
  // not interfere with, such as a scrollbar or widget.
  function onMouseDown(e) {
    var cm = this, display = cm.display;
    if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) { return }
    display.input.ensurePolled();
    display.shift = e.shiftKey;

    if (eventInWidget(display, e)) {
      if (!webkit) {
        // Briefly turn off draggability, to allow widgets to do
        // normal dragging things.
        display.scroller.draggable = false;
        setTimeout(function () { return display.scroller.draggable = true; }, 100);
      }
      return
    }
    if (clickInGutter(cm, e)) { return }
    var pos = posFromMouse(cm, e), button = e_button(e), repeat = pos ? clickRepeat(pos, button) : "single";
    window.focus();

    // #3261: make sure, that we're not starting a second selection
    if (button == 1 && cm.state.selectingText)
      { cm.state.selectingText(e); }

    if (pos && handleMappedButton(cm, button, pos, repeat, e)) { return }

    if (button == 1) {
      if (pos) { leftButtonDown(cm, pos, repeat, e); }
      else if (e_target(e) == display.scroller) { e_preventDefault(e); }
    } else if (button == 2) {
      if (pos) { extendSelection(cm.doc, pos); }
      setTimeout(function () { return display.input.focus(); }, 20);
    } else if (button == 3) {
      if (captureRightClick) { cm.display.input.onContextMenu(e); }
      else { delayBlurEvent(cm); }
    }
  }

  function handleMappedButton(cm, button, pos, repeat, event) {
    var name = "Click";
    if (repeat == "double") { name = "Double" + name; }
    else if (repeat == "triple") { name = "Triple" + name; }
    name = (button == 1 ? "Left" : button == 2 ? "Middle" : "Right") + name;

    return dispatchKey(cm,  addModifierNames(name, event), event, function (bound) {
      if (typeof bound == "string") { bound = commands[bound]; }
      if (!bound) { return false }
      var done = false;
      try {
        if (cm.isReadOnly()) { cm.state.suppressEdits = true; }
        done = bound(cm, pos) != Pass;
      } finally {
        cm.state.suppressEdits = false;
      }
      return done
    })
  }

  function configureMouse(cm, repeat, event) {
    var option = cm.getOption("configureMouse");
    var value = option ? option(cm, repeat, event) : {};
    if (value.unit == null) {
      var rect = chromeOS ? event.shiftKey && event.metaKey : event.altKey;
      value.unit = rect ? "rectangle" : repeat == "single" ? "char" : repeat == "double" ? "word" : "line";
    }
    if (value.extend == null || cm.doc.extend) { value.extend = cm.doc.extend || event.shiftKey; }
    if (value.addNew == null) { value.addNew = mac ? event.metaKey : event.ctrlKey; }
    if (value.moveOnDrag == null) { value.moveOnDrag = !(mac ? event.altKey : event.ctrlKey); }
    return value
  }

  function leftButtonDown(cm, pos, repeat, event) {
    if (ie) { setTimeout(bind(ensureFocus, cm), 0); }
    else { cm.curOp.focus = activeElt(); }

    var behavior = configureMouse(cm, repeat, event);

    var sel = cm.doc.sel, contained;
    if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() &&
        repeat == "single" && (contained = sel.contains(pos)) > -1 &&
        (cmp((contained = sel.ranges[contained]).from(), pos) < 0 || pos.xRel > 0) &&
        (cmp(contained.to(), pos) > 0 || pos.xRel < 0))
      { leftButtonStartDrag(cm, event, pos, behavior); }
    else
      { leftButtonSelect(cm, event, pos, behavior); }
  }

  // Start a text drag. When it ends, see if any dragging actually
  // happen, and treat as a click if it didn't.
  function leftButtonStartDrag(cm, event, pos, behavior) {
    var display = cm.display, moved = false;
    var dragEnd = operation(cm, function (e) {
      if (webkit) { display.scroller.draggable = false; }
      cm.state.draggingText = false;
      off(display.wrapper.ownerDocument, "mouseup", dragEnd);
      off(display.wrapper.ownerDocument, "mousemove", mouseMove);
      off(display.scroller, "dragstart", dragStart);
      off(display.scroller, "drop", dragEnd);
      if (!moved) {
        e_preventDefault(e);
        if (!behavior.addNew)
          { extendSelection(cm.doc, pos, null, null, behavior.extend); }
        // Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
        if (webkit || ie && ie_version == 9)
          { setTimeout(function () {display.wrapper.ownerDocument.body.focus(); display.input.focus();}, 20); }
        else
          { display.input.focus(); }
      }
    });
    var mouseMove = function(e2) {
      moved = moved || Math.abs(event.clientX - e2.clientX) + Math.abs(event.clientY - e2.clientY) >= 10;
    };
    var dragStart = function () { return moved = true; };
    // Let the drag handler handle this.
    if (webkit) { display.scroller.draggable = true; }
    cm.state.draggingText = dragEnd;
    dragEnd.copy = !behavior.moveOnDrag;
    // IE's approach to draggable
    if (display.scroller.dragDrop) { display.scroller.dragDrop(); }
    on(display.wrapper.ownerDocument, "mouseup", dragEnd);
    on(display.wrapper.ownerDocument, "mousemove", mouseMove);
    on(display.scroller, "dragstart", dragStart);
    on(display.scroller, "drop", dragEnd);

    delayBlurEvent(cm);
    setTimeout(function () { return display.input.focus(); }, 20);
  }

  function rangeForUnit(cm, pos, unit) {
    if (unit == "char") { return new Range(pos, pos) }
    if (unit == "word") { return cm.findWordAt(pos) }
    if (unit == "line") { return new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))) }
    var result = unit(cm, pos);
    return new Range(result.from, result.to)
  }

  // Normal selection, as opposed to text dragging.
  function leftButtonSelect(cm, event, start, behavior) {
    var display = cm.display, doc = cm.doc;
    e_preventDefault(event);

    var ourRange, ourIndex, startSel = doc.sel, ranges = startSel.ranges;
    if (behavior.addNew && !behavior.extend) {
      ourIndex = doc.sel.contains(start);
      if (ourIndex > -1)
        { ourRange = ranges[ourIndex]; }
      else
        { ourRange = new Range(start, start); }
    } else {
      ourRange = doc.sel.primary();
      ourIndex = doc.sel.primIndex;
    }

    if (behavior.unit == "rectangle") {
      if (!behavior.addNew) { ourRange = new Range(start, start); }
      start = posFromMouse(cm, event, true, true);
      ourIndex = -1;
    } else {
      var range$$1 = rangeForUnit(cm, start, behavior.unit);
      if (behavior.extend)
        { ourRange = extendRange(ourRange, range$$1.anchor, range$$1.head, behavior.extend); }
      else
        { ourRange = range$$1; }
    }

    if (!behavior.addNew) {
      ourIndex = 0;
      setSelection(doc, new Selection([ourRange], 0), sel_mouse);
      startSel = doc.sel;
    } else if (ourIndex == -1) {
      ourIndex = ranges.length;
      setSelection(doc, normalizeSelection(cm, ranges.concat([ourRange]), ourIndex),
                   {scroll: false, origin: "*mouse"});
    } else if (ranges.length > 1 && ranges[ourIndex].empty() && behavior.unit == "char" && !behavior.extend) {
      setSelection(doc, normalizeSelection(cm, ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0),
                   {scroll: false, origin: "*mouse"});
      startSel = doc.sel;
    } else {
      replaceOneSelection(doc, ourIndex, ourRange, sel_mouse);
    }

    var lastPos = start;
    function extendTo(pos) {
      if (cmp(lastPos, pos) == 0) { return }
      lastPos = pos;

      if (behavior.unit == "rectangle") {
        var ranges = [], tabSize = cm.options.tabSize;
        var startCol = countColumn(getLine(doc, start.line).text, start.ch, tabSize);
        var posCol = countColumn(getLine(doc, pos.line).text, pos.ch, tabSize);
        var left = Math.min(startCol, posCol), right = Math.max(startCol, posCol);
        for (var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line));
             line <= end; line++) {
          var text = getLine(doc, line).text, leftPos = findColumn(text, left, tabSize);
          if (left == right)
            { ranges.push(new Range(Pos(line, leftPos), Pos(line, leftPos))); }
          else if (text.length > leftPos)
            { ranges.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize)))); }
        }
        if (!ranges.length) { ranges.push(new Range(start, start)); }
        setSelection(doc, normalizeSelection(cm, startSel.ranges.slice(0, ourIndex).concat(ranges), ourIndex),
                     {origin: "*mouse", scroll: false});
        cm.scrollIntoView(pos);
      } else {
        var oldRange = ourRange;
        var range$$1 = rangeForUnit(cm, pos, behavior.unit);
        var anchor = oldRange.anchor, head;
        if (cmp(range$$1.anchor, anchor) > 0) {
          head = range$$1.head;
          anchor = minPos(oldRange.from(), range$$1.anchor);
        } else {
          head = range$$1.anchor;
          anchor = maxPos(oldRange.to(), range$$1.head);
        }
        var ranges$1 = startSel.ranges.slice(0);
        ranges$1[ourIndex] = bidiSimplify(cm, new Range(clipPos(doc, anchor), head));
        setSelection(doc, normalizeSelection(cm, ranges$1, ourIndex), sel_mouse);
      }
    }

    var editorSize = display.wrapper.getBoundingClientRect();
    // Used to ensure timeout re-tries don't fire when another extend
    // happened in the meantime (clearTimeout isn't reliable -- at
    // least on Chrome, the timeouts still happen even when cleared,
    // if the clear happens after their scheduled firing time).
    var counter = 0;

    function extend(e) {
      var curCount = ++counter;
      var cur = posFromMouse(cm, e, true, behavior.unit == "rectangle");
      if (!cur) { return }
      if (cmp(cur, lastPos) != 0) {
        cm.curOp.focus = activeElt();
        extendTo(cur);
        var visible = visibleLines(display, doc);
        if (cur.line >= visible.to || cur.line < visible.from)
          { setTimeout(operation(cm, function () {if (counter == curCount) { extend(e); }}), 150); }
      } else {
        var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0;
        if (outside) { setTimeout(operation(cm, function () {
          if (counter != curCount) { return }
          display.scroller.scrollTop += outside;
          extend(e);
        }), 50); }
      }
    }

    function done(e) {
      cm.state.selectingText = false;
      counter = Infinity;
      e_preventDefault(e);
      display.input.focus();
      off(display.wrapper.ownerDocument, "mousemove", move);
      off(display.wrapper.ownerDocument, "mouseup", up);
      doc.history.lastSelOrigin = null;
    }

    var move = operation(cm, function (e) {
      if (e.buttons === 0 || !e_button(e)) { done(e); }
      else { extend(e); }
    });
    var up = operation(cm, done);
    cm.state.selectingText = up;
    on(display.wrapper.ownerDocument, "mousemove", move);
    on(display.wrapper.ownerDocument, "mouseup", up);
  }

  // Used when mouse-selecting to adjust the anchor to the proper side
  // of a bidi jump depending on the visual position of the head.
  function bidiSimplify(cm, range$$1) {
    var anchor = range$$1.anchor;
    var head = range$$1.head;
    var anchorLine = getLine(cm.doc, anchor.line);
    if (cmp(anchor, head) == 0 && anchor.sticky == head.sticky) { return range$$1 }
    var order = getOrder(anchorLine);
    if (!order) { return range$$1 }
    var index = getBidiPartAt(order, anchor.ch, anchor.sticky), part = order[index];
    if (part.from != anchor.ch && part.to != anchor.ch) { return range$$1 }
    var boundary = index + ((part.from == anchor.ch) == (part.level != 1) ? 0 : 1);
    if (boundary == 0 || boundary == order.length) { return range$$1 }

    // Compute the relative visual position of the head compared to the
    // anchor (<0 is to the left, >0 to the right)
    var leftSide;
    if (head.line != anchor.line) {
      leftSide = (head.line - anchor.line) * (cm.doc.direction == "ltr" ? 1 : -1) > 0;
    } else {
      var headIndex = getBidiPartAt(order, head.ch, head.sticky);
      var dir = headIndex - index || (head.ch - anchor.ch) * (part.level == 1 ? -1 : 1);
      if (headIndex == boundary - 1 || headIndex == boundary)
        { leftSide = dir < 0; }
      else
        { leftSide = dir > 0; }
    }

    var usePart = order[boundary + (leftSide ? -1 : 0)];
    var from = leftSide == (usePart.level == 1);
    var ch = from ? usePart.from : usePart.to, sticky = from ? "after" : "before";
    return anchor.ch == ch && anchor.sticky == sticky ? range$$1 : new Range(new Pos(anchor.line, ch, sticky), head)
  }


  // Determines whether an event happened in the gutter, and fires the
  // handlers for the corresponding event.
  function gutterEvent(cm, e, type, prevent) {
    var mX, mY;
    if (e.touches) {
      mX = e.touches[0].clientX;
      mY = e.touches[0].clientY;
    } else {
      try { mX = e.clientX; mY = e.clientY; }
      catch(e) { return false }
    }
    if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) { return false }
    if (prevent) { e_preventDefault(e); }

    var display = cm.display;
    var lineBox = display.lineDiv.getBoundingClientRect();

    if (mY > lineBox.bottom || !hasHandler(cm, type)) { return e_defaultPrevented(e) }
    mY -= lineBox.top - display.viewOffset;

    for (var i = 0; i < cm.options.gutters.length; ++i) {
      var g = display.gutters.childNodes[i];
      if (g && g.getBoundingClientRect().right >= mX) {
        var line = lineAtHeight(cm.doc, mY);
        var gutter = cm.options.gutters[i];
        signal(cm, type, cm, line, gutter, e);
        return e_defaultPrevented(e)
      }
    }
  }

  function clickInGutter(cm, e) {
    return gutterEvent(cm, e, "gutterClick", true)
  }

  // CONTEXT MENU HANDLING

  // To make the context menu work, we need to briefly unhide the
  // textarea (making it as unobtrusive as possible) to let the
  // right-click take effect on it.
  function onContextMenu(cm, e) {
    if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) { return }
    if (signalDOMEvent(cm, e, "contextmenu")) { return }
    if (!captureRightClick) { cm.display.input.onContextMenu(e); }
  }

  function contextMenuInGutter(cm, e) {
    if (!hasHandler(cm, "gutterContextMenu")) { return false }
    return gutterEvent(cm, e, "gutterContextMenu", false)
  }

  function themeChanged(cm) {
    cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") +
      cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-");
    clearCaches(cm);
  }

  var Init = {toString: function(){return "CodeMirror.Init"}};

  var defaults = {};
  var optionHandlers = {};

  function defineOptions(CodeMirror) {
    var optionHandlers = CodeMirror.optionHandlers;

    function option(name, deflt, handle, notOnInit) {
      CodeMirror.defaults[name] = deflt;
      if (handle) { optionHandlers[name] =
        notOnInit ? function (cm, val, old) {if (old != Init) { handle(cm, val, old); }} : handle; }
    }

    CodeMirror.defineOption = option;

    // Passed to option handlers when there is no old value.
    CodeMirror.Init = Init;

    // These two are, on init, called from the constructor because they
    // have to be initialized before the editor can start at all.
    option("value", "", function (cm, val) { return cm.setValue(val); }, true);
    option("mode", null, function (cm, val) {
      cm.doc.modeOption = val;
      loadMode(cm);
    }, true);

    option("indentUnit", 2, loadMode, true);
    option("indentWithTabs", false);
    option("smartIndent", true);
    option("tabSize", 4, function (cm) {
      resetModeState(cm);
      clearCaches(cm);
      regChange(cm);
    }, true);

    option("lineSeparator", null, function (cm, val) {
      cm.doc.lineSep = val;
      if (!val) { return }
      var newBreaks = [], lineNo = cm.doc.first;
      cm.doc.iter(function (line) {
        for (var pos = 0;;) {
          var found = line.text.indexOf(val, pos);
          if (found == -1) { break }
          pos = found + val.length;
          newBreaks.push(Pos(lineNo, found));
        }
        lineNo++;
      });
      for (var i = newBreaks.length - 1; i >= 0; i--)
        { replaceRange(cm.doc, val, newBreaks[i], Pos(newBreaks[i].line, newBreaks[i].ch + val.length)); }
    });
    option("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b-\u200f\u2028\u2029\ufeff]/g, function (cm, val, old) {
      cm.state.specialChars = new RegExp(val.source + (val.test("\t") ? "" : "|\t"), "g");
      if (old != Init) { cm.refresh(); }
    });
    option("specialCharPlaceholder", defaultSpecialCharPlaceholder, function (cm) { return cm.refresh(); }, true);
    option("electricChars", true);
    option("inputStyle", mobile ? "contenteditable" : "textarea", function () {
      throw new Error("inputStyle can not (yet) be changed in a running editor") // FIXME
    }, true);
    option("spellcheck", false, function (cm, val) { return cm.getInputField().spellcheck = val; }, true);
    option("rtlMoveVisually", !windows);
    option("wholeLineUpdateBefore", true);

    option("theme", "default", function (cm) {
      themeChanged(cm);
      guttersChanged(cm);
    }, true);
    option("keyMap", "default", function (cm, val, old) {
      var next = getKeyMap(val);
      var prev = old != Init && getKeyMap(old);
      if (prev && prev.detach) { prev.detach(cm, next); }
      if (next.attach) { next.attach(cm, prev || null); }
    });
    option("extraKeys", null);
    option("configureMouse", null);

    option("lineWrapping", false, wrappingChanged, true);
    option("gutters", [], function (cm) {
      setGuttersForLineNumbers(cm.options);
      guttersChanged(cm);
    }, true);
    option("fixedGutter", true, function (cm, val) {
      cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0";
      cm.refresh();
    }, true);
    option("coverGutterNextToScrollbar", false, function (cm) { return updateScrollbars(cm); }, true);
    option("scrollbarStyle", "native", function (cm) {
      initScrollbars(cm);
      updateScrollbars(cm);
      cm.display.scrollbars.setScrollTop(cm.doc.scrollTop);
      cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft);
    }, true);
    option("lineNumbers", false, function (cm) {
      setGuttersForLineNumbers(cm.options);
      guttersChanged(cm);
    }, true);
    option("firstLineNumber", 1, guttersChanged, true);
    option("lineNumberFormatter", function (integer) { return integer; }, guttersChanged, true);
    option("showCursorWhenSelecting", false, updateSelection, true);

    option("resetSelectionOnContextMenu", true);
    option("lineWiseCopyCut", true);
    option("pasteLinesPerSelection", true);
    option("selectionsMayTouch", false);

    option("readOnly", false, function (cm, val) {
      if (val == "nocursor") {
        onBlur(cm);
        cm.display.input.blur();
      }
      cm.display.input.readOnlyChanged(val);
    });
    option("disableInput", false, function (cm, val) {if (!val) { cm.display.input.reset(); }}, true);
    option("dragDrop", true, dragDropChanged);
    option("allowDropFileTypes", null);

    option("cursorBlinkRate", 530);
    option("cursorScrollMargin", 0);
    option("cursorHeight", 1, updateSelection, true);
    option("singleCursorHeightPerLine", true, updateSelection, true);
    option("workTime", 100);
    option("workDelay", 100);
    option("flattenSpans", true, resetModeState, true);
    option("addModeClass", false, resetModeState, true);
    option("pollInterval", 100);
    option("undoDepth", 200, function (cm, val) { return cm.doc.history.undoDepth = val; });
    option("historyEventDelay", 1250);
    option("viewportMargin", 10, function (cm) { return cm.refresh(); }, true);
    option("maxHighlightLength", 10000, resetModeState, true);
    option("moveInputWithCursor", true, function (cm, val) {
      if (!val) { cm.display.input.resetPosition(); }
    });

    option("tabindex", null, function (cm, val) { return cm.display.input.getField().tabIndex = val || ""; });
    option("autofocus", null);
    option("direction", "ltr", function (cm, val) { return cm.doc.setDirection(val); }, true);
    option("phrases", null);
  }

  function guttersChanged(cm) {
    updateGutters(cm);
    regChange(cm);
    alignHorizontally(cm);
  }

  function dragDropChanged(cm, value, old) {
    var wasOn = old && old != Init;
    if (!value != !wasOn) {
      var funcs = cm.display.dragFunctions;
      var toggle = value ? on : off;
      toggle(cm.display.scroller, "dragstart", funcs.start);
      toggle(cm.display.scroller, "dragenter", funcs.enter);
      toggle(cm.display.scroller, "dragover", funcs.over);
      toggle(cm.display.scroller, "dragleave", funcs.leave);
      toggle(cm.display.scroller, "drop", funcs.drop);
    }
  }

  function wrappingChanged(cm) {
    if (cm.options.lineWrapping) {
      addClass(cm.display.wrapper, "CodeMirror-wrap");
      cm.display.sizer.style.minWidth = "";
      cm.display.sizerWidth = null;
    } else {
      rmClass(cm.display.wrapper, "CodeMirror-wrap");
      findMaxLine(cm);
    }
    estimateLineHeights(cm);
    regChange(cm);
    clearCaches(cm);
    setTimeout(function () { return updateScrollbars(cm); }, 100);
  }

  // A CodeMirror instance represents an editor. This is the object
  // that user code is usually dealing with.

  function CodeMirror(place, options) {
    var this$1 = this;

    if (!(this instanceof CodeMirror)) { return new CodeMirror(place, options) }

    this.options = options = options ? copyObj(options) : {};
    // Determine effective options based on given values and defaults.
    copyObj(defaults, options, false);
    setGuttersForLineNumbers(options);

    var doc = options.value;
    if (typeof doc == "string") { doc = new Doc(doc, options.mode, null, options.lineSeparator, options.direction); }
    else if (options.mode) { doc.modeOption = options.mode; }
    this.doc = doc;

    var input = new CodeMirror.inputStyles[options.inputStyle](this);
    var display = this.display = new Display(place, doc, input);
    display.wrapper.CodeMirror = this;
    updateGutters(this);
    themeChanged(this);
    if (options.lineWrapping)
      { this.display.wrapper.className += " CodeMirror-wrap"; }
    initScrollbars(this);

    this.state = {
      keyMaps: [],  // stores maps added by addKeyMap
      overlays: [], // highlighting overlays, as added by addOverlay
      modeGen: 0,   // bumped when mode/overlay changes, used to invalidate highlighting info
      overwrite: false,
      delayingBlurEvent: false,
      focused: false,
      suppressEdits: false, // used to disable editing during key handlers when in readOnly mode
      pasteIncoming: false, cutIncoming: false, // help recognize paste/cut edits in input.poll
      selectingText: false,
      draggingText: false,
      highlight: new Delayed(), // stores highlight worker timeout
      keySeq: null,  // Unfinished key sequence
      specialChars: null
    };

    if (options.autofocus && !mobile) { display.input.focus(); }

    // Override magic textarea content restore that IE sometimes does
    // on our hidden textarea on reload
    if (ie && ie_version < 11) { setTimeout(function () { return this$1.display.input.reset(true); }, 20); }

    registerEventHandlers(this);
    ensureGlobalHandlers();

    startOperation(this);
    this.curOp.forceUpdate = true;
    attachDoc(this, doc);

    if ((options.autofocus && !mobile) || this.hasFocus())
      { setTimeout(bind(onFocus, this), 20); }
    else
      { onBlur(this); }

    for (var opt in optionHandlers) { if (optionHandlers.hasOwnProperty(opt))
      { optionHandlers[opt](this$1, options[opt], Init); } }
    maybeUpdateLineNumberWidth(this);
    if (options.finishInit) { options.finishInit(this); }
    for (var i = 0; i < initHooks.length; ++i) { initHooks[i](this$1); }
    endOperation(this);
    // Suppress optimizelegibility in Webkit, since it breaks text
    // measuring on line wrapping boundaries.
    if (webkit && options.lineWrapping &&
        getComputedStyle(display.lineDiv).textRendering == "optimizelegibility")
      { display.lineDiv.style.textRendering = "auto"; }
  }

  // The default configuration options.
  CodeMirror.defaults = defaults;
  // Functions to run when options are changed.
  CodeMirror.optionHandlers = optionHandlers;

  // Attach the necessary event handlers when initializing the editor
  function registerEventHandlers(cm) {
    var d = cm.display;
    on(d.scroller, "mousedown", operation(cm, onMouseDown));
    // Older IE's will not fire a second mousedown for a double click
    if (ie && ie_version < 11)
      { on(d.scroller, "dblclick", operation(cm, function (e) {
        if (signalDOMEvent(cm, e)) { return }
        var pos = posFromMouse(cm, e);
        if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) { return }
        e_preventDefault(e);
        var word = cm.findWordAt(pos);
        extendSelection(cm.doc, word.anchor, word.head);
      })); }
    else
      { on(d.scroller, "dblclick", function (e) { return signalDOMEvent(cm, e) || e_preventDefault(e); }); }
    // Some browsers fire contextmenu *after* opening the menu, at
    // which point we can't mess with it anymore. Context menu is
    // handled in onMouseDown for these browsers.
    on(d.scroller, "contextmenu", function (e) { return onContextMenu(cm, e); });

    // Used to suppress mouse event handling when a touch happens
    var touchFinished, prevTouch = {end: 0};
    function finishTouch() {
      if (d.activeTouch) {
        touchFinished = setTimeout(function () { return d.activeTouch = null; }, 1000);
        prevTouch = d.activeTouch;
        prevTouch.end = +new Date;
      }
    }
    function isMouseLikeTouchEvent(e) {
      if (e.touches.length != 1) { return false }
      var touch = e.touches[0];
      return touch.radiusX <= 1 && touch.radiusY <= 1
    }
    function farAway(touch, other) {
      if (other.left == null) { return true }
      var dx = other.left - touch.left, dy = other.top - touch.top;
      return dx * dx + dy * dy > 20 * 20
    }
    on(d.scroller, "touchstart", function (e) {
      if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e) && !clickInGutter(cm, e)) {
        d.input.ensurePolled();
        clearTimeout(touchFinished);
        var now = +new Date;
        d.activeTouch = {start: now, moved: false,
                         prev: now - prevTouch.end <= 300 ? prevTouch : null};
        if (e.touches.length == 1) {
          d.activeTouch.left = e.touches[0].pageX;
          d.activeTouch.top = e.touches[0].pageY;
        }
      }
    });
    on(d.scroller, "touchmove", function () {
      if (d.activeTouch) { d.activeTouch.moved = true; }
    });
    on(d.scroller, "touchend", function (e) {
      var touch = d.activeTouch;
      if (touch && !eventInWidget(d, e) && touch.left != null &&
          !touch.moved && new Date - touch.start < 300) {
        var pos = cm.coordsChar(d.activeTouch, "page"), range;
        if (!touch.prev || farAway(touch, touch.prev)) // Single tap
          { range = new Range(pos, pos); }
        else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) // Double tap
          { range = cm.findWordAt(pos); }
        else // Triple tap
          { range = new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))); }
        cm.setSelection(range.anchor, range.head);
        cm.focus();
        e_preventDefault(e);
      }
      finishTouch();
    });
    on(d.scroller, "touchcancel", finishTouch);

    // Sync scrolling between fake scrollbars and real scrollable
    // area, ensure viewport is updated when scrolling.
    on(d.scroller, "scroll", function () {
      if (d.scroller.clientHeight) {
        updateScrollTop(cm, d.scroller.scrollTop);
        setScrollLeft(cm, d.scroller.scrollLeft, true);
        signal(cm, "scroll", cm);
      }
    });

    // Listen to wheel events in order to try and update the viewport on time.
    on(d.scroller, "mousewheel", function (e) { return onScrollWheel(cm, e); });
    on(d.scroller, "DOMMouseScroll", function (e) { return onScrollWheel(cm, e); });

    // Prevent wrapper from ever scrolling
    on(d.wrapper, "scroll", function () { return d.wrapper.scrollTop = d.wrapper.scrollLeft = 0; });

    d.dragFunctions = {
      enter: function (e) {if (!signalDOMEvent(cm, e)) { e_stop(e); }},
      over: function (e) {if (!signalDOMEvent(cm, e)) { onDragOver(cm, e); e_stop(e); }},
      start: function (e) { return onDragStart(cm, e); },
      drop: operation(cm, onDrop),
      leave: function (e) {if (!signalDOMEvent(cm, e)) { clearDragCursor(cm); }}
    };

    var inp = d.input.getField();
    on(inp, "keyup", function (e) { return onKeyUp.call(cm, e); });
    on(inp, "keydown", operation(cm, onKeyDown));
    on(inp, "keypress", operation(cm, onKeyPress));
    on(inp, "focus", function (e) { return onFocus(cm, e); });
    on(inp, "blur", function (e) { return onBlur(cm, e); });
  }

  var initHooks = [];
  CodeMirror.defineInitHook = function (f) { return initHooks.push(f); };

  // Indent the given line. The how parameter can be "smart",
  // "add"/null, "subtract", or "prev". When aggressive is false
  // (typically set to true for forced single-line indents), empty
  // lines are not indented, and places where the mode returns Pass
  // are left alone.
  function indentLine(cm, n, how, aggressive) {
    var doc = cm.doc, state;
    if (how == null) { how = "add"; }
    if (how == "smart") {
      // Fall back to "prev" when the mode doesn't have an indentation
      // method.
      if (!doc.mode.indent) { how = "prev"; }
      else { state = getContextBefore(cm, n).state; }
    }

    var tabSize = cm.options.tabSize;
    var line = getLine(doc, n), curSpace = countColumn(line.text, null, tabSize);
    if (line.stateAfter) { line.stateAfter = null; }
    var curSpaceString = line.text.match(/^\s*/)[0], indentation;
    if (!aggressive && !/\S/.test(line.text)) {
      indentation = 0;
      how = "not";
    } else if (how == "smart") {
      indentation = doc.mode.indent(state, line.text.slice(curSpaceString.length), line.text);
      if (indentation == Pass || indentation > 150) {
        if (!aggressive) { return }
        how = "prev";
      }
    }
    if (how == "prev") {
      if (n > doc.first) { indentation = countColumn(getLine(doc, n-1).text, null, tabSize); }
      else { indentation = 0; }
    } else if (how == "add") {
      indentation = curSpace + cm.options.indentUnit;
    } else if (how == "subtract") {
      indentation = curSpace - cm.options.indentUnit;
    } else if (typeof how == "number") {
      indentation = curSpace + how;
    }
    indentation = Math.max(0, indentation);

    var indentString = "", pos = 0;
    if (cm.options.indentWithTabs)
      { for (var i = Math.floor(indentation / tabSize); i; --i) {pos += tabSize; indentString += "\t";} }
    if (pos < indentation) { indentString += spaceStr(indentation - pos); }

    if (indentString != curSpaceString) {
      replaceRange(doc, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input");
      line.stateAfter = null;
      return true
    } else {
      // Ensure that, if the cursor was in the whitespace at the start
      // of the line, it is moved to the end of that space.
      for (var i$1 = 0; i$1 < doc.sel.ranges.length; i$1++) {
        var range = doc.sel.ranges[i$1];
        if (range.head.line == n && range.head.ch < curSpaceString.length) {
          var pos$1 = Pos(n, curSpaceString.length);
          replaceOneSelection(doc, i$1, new Range(pos$1, pos$1));
          break
        }
      }
    }
  }

  // This will be set to a {lineWise: bool, text: [string]} object, so
  // that, when pasting, we know what kind of selections the copied
  // text was made out of.
  var lastCopied = null;

  function setLastCopied(newLastCopied) {
    lastCopied = newLastCopied;
  }

  function applyTextInput(cm, inserted, deleted, sel, origin) {
    var doc = cm.doc;
    cm.display.shift = false;
    if (!sel) { sel = doc.sel; }

    var paste = cm.state.pasteIncoming || origin == "paste";
    var textLines = splitLinesAuto(inserted), multiPaste = null;
    // When pasting N lines into N selections, insert one line per selection
    if (paste && sel.ranges.length > 1) {
      if (lastCopied && lastCopied.text.join("\n") == inserted) {
        if (sel.ranges.length % lastCopied.text.length == 0) {
          multiPaste = [];
          for (var i = 0; i < lastCopied.text.length; i++)
            { multiPaste.push(doc.splitLines(lastCopied.text[i])); }
        }
      } else if (textLines.length == sel.ranges.length && cm.options.pasteLinesPerSelection) {
        multiPaste = map(textLines, function (l) { return [l]; });
      }
    }

    var updateInput = cm.curOp.updateInput;
    // Normal behavior is to insert the new text into every selection
    for (var i$1 = sel.ranges.length - 1; i$1 >= 0; i$1--) {
      var range$$1 = sel.ranges[i$1];
      var from = range$$1.from(), to = range$$1.to();
      if (range$$1.empty()) {
        if (deleted && deleted > 0) // Handle deletion
          { from = Pos(from.line, from.ch - deleted); }
        else if (cm.state.overwrite && !paste) // Handle overwrite
          { to = Pos(to.line, Math.min(getLine(doc, to.line).text.length, to.ch + lst(textLines).length)); }
        else if (paste && lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == inserted)
          { from = to = Pos(from.line, 0); }
      }
      var changeEvent = {from: from, to: to, text: multiPaste ? multiPaste[i$1 % multiPaste.length] : textLines,
                         origin: origin || (paste ? "paste" : cm.state.cutIncoming ? "cut" : "+input")};
      makeChange(cm.doc, changeEvent);
      signalLater(cm, "inputRead", cm, changeEvent);
    }
    if (inserted && !paste)
      { triggerElectric(cm, inserted); }

    ensureCursorVisible(cm);
    if (cm.curOp.updateInput < 2) { cm.curOp.updateInput = updateInput; }
    cm.curOp.typing = true;
    cm.state.pasteIncoming = cm.state.cutIncoming = false;
  }

  function handlePaste(e, cm) {
    var pasted = e.clipboardData && e.clipboardData.getData("Text");
    if (pasted) {
      e.preventDefault();
      if (!cm.isReadOnly() && !cm.options.disableInput)
        { runInOp(cm, function () { return applyTextInput(cm, pasted, 0, null, "paste"); }); }
      return true
    }
  }

  function triggerElectric(cm, inserted) {
    // When an 'electric' character is inserted, immediately trigger a reindent
    if (!cm.options.electricChars || !cm.options.smartIndent) { return }
    var sel = cm.doc.sel;

    for (var i = sel.ranges.length - 1; i >= 0; i--) {
      var range$$1 = sel.ranges[i];
      if (range$$1.head.ch > 100 || (i && sel.ranges[i - 1].head.line == range$$1.head.line)) { continue }
      var mode = cm.getModeAt(range$$1.head);
      var indented = false;
      if (mode.electricChars) {
        for (var j = 0; j < mode.electricChars.length; j++)
          { if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
            indented = indentLine(cm, range$$1.head.line, "smart");
            break
          } }
      } else if (mode.electricInput) {
        if (mode.electricInput.test(getLine(cm.doc, range$$1.head.line).text.slice(0, range$$1.head.ch)))
          { indented = indentLine(cm, range$$1.head.line, "smart"); }
      }
      if (indented) { signalLater(cm, "electricInput", cm, range$$1.head.line); }
    }
  }

  function copyableRanges(cm) {
    var text = [], ranges = [];
    for (var i = 0; i < cm.doc.sel.ranges.length; i++) {
      var line = cm.doc.sel.ranges[i].head.line;
      var lineRange = {anchor: Pos(line, 0), head: Pos(line + 1, 0)};
      ranges.push(lineRange);
      text.push(cm.getRange(lineRange.anchor, lineRange.head));
    }
    return {text: text, ranges: ranges}
  }

  function disableBrowserMagic(field, spellcheck) {
    field.setAttribute("autocorrect", "off");
    field.setAttribute("autocapitalize", "off");
    field.setAttribute("spellcheck", !!spellcheck);
  }

  function hiddenTextarea() {
    var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; outline: none");
    var div = elt("div", [te], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
    // The textarea is kept positioned near the cursor to prevent the
    // fact that it'll be scrolled into view on input from scrolling
    // our fake cursor out of view. On webkit, when wrap=off, paste is
    // very slow. So make the area wide instead.
    if (webkit) { te.style.width = "1000px"; }
    else { te.setAttribute("wrap", "off"); }
    // If border: 0; -- iOS fails to open keyboard (issue #1287)
    if (ios) { te.style.border = "1px solid black"; }
    disableBrowserMagic(te);
    return div
  }

  // The publicly visible API. Note that methodOp(f) means
  // 'wrap f in an operation, performed on its `this` parameter'.

  // This is not the complete set of editor methods. Most of the
  // methods defined on the Doc type are also injected into
  // CodeMirror.prototype, for backwards compatibility and
  // convenience.

  function addEditorMethods(CodeMirror) {
    var optionHandlers = CodeMirror.optionHandlers;

    var helpers = CodeMirror.helpers = {};

    CodeMirror.prototype = {
      constructor: CodeMirror,
      focus: function(){window.focus(); this.display.input.focus();},

      setOption: function(option, value) {
        var options = this.options, old = options[option];
        if (options[option] == value && option != "mode") { return }
        options[option] = value;
        if (optionHandlers.hasOwnProperty(option))
          { operation(this, optionHandlers[option])(this, value, old); }
        signal(this, "optionChange", this, option);
      },

      getOption: function(option) {return this.options[option]},
      getDoc: function() {return this.doc},

      addKeyMap: function(map$$1, bottom) {
        this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map$$1));
      },
      removeKeyMap: function(map$$1) {
        var maps = this.state.keyMaps;
        for (var i = 0; i < maps.length; ++i)
          { if (maps[i] == map$$1 || maps[i].name == map$$1) {
            maps.splice(i, 1);
            return true
          } }
      },

      addOverlay: methodOp(function(spec, options) {
        var mode = spec.token ? spec : CodeMirror.getMode(this.options, spec);
        if (mode.startState) { throw new Error("Overlays may not be stateful.") }
        insertSorted(this.state.overlays,
                     {mode: mode, modeSpec: spec, opaque: options && options.opaque,
                      priority: (options && options.priority) || 0},
                     function (overlay) { return overlay.priority; });
        this.state.modeGen++;
        regChange(this);
      }),
      removeOverlay: methodOp(function(spec) {
        var this$1 = this;

        var overlays = this.state.overlays;
        for (var i = 0; i < overlays.length; ++i) {
          var cur = overlays[i].modeSpec;
          if (cur == spec || typeof spec == "string" && cur.name == spec) {
            overlays.splice(i, 1);
            this$1.state.modeGen++;
            regChange(this$1);
            return
          }
        }
      }),

      indentLine: methodOp(function(n, dir, aggressive) {
        if (typeof dir != "string" && typeof dir != "number") {
          if (dir == null) { dir = this.options.smartIndent ? "smart" : "prev"; }
          else { dir = dir ? "add" : "subtract"; }
        }
        if (isLine(this.doc, n)) { indentLine(this, n, dir, aggressive); }
      }),
      indentSelection: methodOp(function(how) {
        var this$1 = this;

        var ranges = this.doc.sel.ranges, end = -1;
        for (var i = 0; i < ranges.length; i++) {
          var range$$1 = ranges[i];
          if (!range$$1.empty()) {
            var from = range$$1.from(), to = range$$1.to();
            var start = Math.max(end, from.line);
            end = Math.min(this$1.lastLine(), to.line - (to.ch ? 0 : 1)) + 1;
            for (var j = start; j < end; ++j)
              { indentLine(this$1, j, how); }
            var newRanges = this$1.doc.sel.ranges;
            if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i].from().ch > 0)
              { replaceOneSelection(this$1.doc, i, new Range(from, newRanges[i].to()), sel_dontScroll); }
          } else if (range$$1.head.line > end) {
            indentLine(this$1, range$$1.head.line, how, true);
            end = range$$1.head.line;
            if (i == this$1.doc.sel.primIndex) { ensureCursorVisible(this$1); }
          }
        }
      }),

      // Fetch the parser token for a given character. Useful for hacks
      // that want to inspect the mode state (say, for completion).
      getTokenAt: function(pos, precise) {
        return takeToken(this, pos, precise)
      },

      getLineTokens: function(line, precise) {
        return takeToken(this, Pos(line), precise, true)
      },

      getTokenTypeAt: function(pos) {
        pos = clipPos(this.doc, pos);
        var styles = getLineStyles(this, getLine(this.doc, pos.line));
        var before = 0, after = (styles.length - 1) / 2, ch = pos.ch;
        var type;
        if (ch == 0) { type = styles[2]; }
        else { for (;;) {
          var mid = (before + after) >> 1;
          if ((mid ? styles[mid * 2 - 1] : 0) >= ch) { after = mid; }
          else if (styles[mid * 2 + 1] < ch) { before = mid + 1; }
          else { type = styles[mid * 2 + 2]; break }
        } }
        var cut = type ? type.indexOf("overlay ") : -1;
        return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1)
      },

      getModeAt: function(pos) {
        var mode = this.doc.mode;
        if (!mode.innerMode) { return mode }
        return CodeMirror.innerMode(mode, this.getTokenAt(pos).state).mode
      },

      getHelper: function(pos, type) {
        return this.getHelpers(pos, type)[0]
      },

      getHelpers: function(pos, type) {
        var this$1 = this;

        var found = [];
        if (!helpers.hasOwnProperty(type)) { return found }
        var help = helpers[type], mode = this.getModeAt(pos);
        if (typeof mode[type] == "string") {
          if (help[mode[type]]) { found.push(help[mode[type]]); }
        } else if (mode[type]) {
          for (var i = 0; i < mode[type].length; i++) {
            var val = help[mode[type][i]];
            if (val) { found.push(val); }
          }
        } else if (mode.helperType && help[mode.helperType]) {
          found.push(help[mode.helperType]);
        } else if (help[mode.name]) {
          found.push(help[mode.name]);
        }
        for (var i$1 = 0; i$1 < help._global.length; i$1++) {
          var cur = help._global[i$1];
          if (cur.pred(mode, this$1) && indexOf(found, cur.val) == -1)
            { found.push(cur.val); }
        }
        return found
      },

      getStateAfter: function(line, precise) {
        var doc = this.doc;
        line = clipLine(doc, line == null ? doc.first + doc.size - 1: line);
        return getContextBefore(this, line + 1, precise).state
      },

      cursorCoords: function(start, mode) {
        var pos, range$$1 = this.doc.sel.primary();
        if (start == null) { pos = range$$1.head; }
        else if (typeof start == "object") { pos = clipPos(this.doc, start); }
        else { pos = start ? range$$1.from() : range$$1.to(); }
        return cursorCoords(this, pos, mode || "page")
      },

      charCoords: function(pos, mode) {
        return charCoords(this, clipPos(this.doc, pos), mode || "page")
      },

      coordsChar: function(coords, mode) {
        coords = fromCoordSystem(this, coords, mode || "page");
        return coordsChar(this, coords.left, coords.top)
      },

      lineAtHeight: function(height, mode) {
        height = fromCoordSystem(this, {top: height, left: 0}, mode || "page").top;
        return lineAtHeight(this.doc, height + this.display.viewOffset)
      },
      heightAtLine: function(line, mode, includeWidgets) {
        var end = false, lineObj;
        if (typeof line == "number") {
          var last = this.doc.first + this.doc.size - 1;
          if (line < this.doc.first) { line = this.doc.first; }
          else if (line > last) { line = last; end = true; }
          lineObj = getLine(this.doc, line);
        } else {
          lineObj = line;
        }
        return intoCoordSystem(this, lineObj, {top: 0, left: 0}, mode || "page", includeWidgets || end).top +
          (end ? this.doc.height - heightAtLine(lineObj) : 0)
      },

      defaultTextHeight: function() { return textHeight(this.display) },
      defaultCharWidth: function() { return charWidth(this.display) },

      getViewport: function() { return {from: this.display.viewFrom, to: this.display.viewTo}},

      addWidget: function(pos, node, scroll, vert, horiz) {
        var display = this.display;
        pos = cursorCoords(this, clipPos(this.doc, pos));
        var top = pos.bottom, left = pos.left;
        node.style.position = "absolute";
        node.setAttribute("cm-ignore-events", "true");
        this.display.input.setUneditable(node);
        display.sizer.appendChild(node);
        if (vert == "over") {
          top = pos.top;
        } else if (vert == "above" || vert == "near") {
          var vspace = Math.max(display.wrapper.clientHeight, this.doc.height),
          hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth);
          // Default to positioning above (if specified and possible); otherwise default to positioning below
          if ((vert == 'above' || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight)
            { top = pos.top - node.offsetHeight; }
          else if (pos.bottom + node.offsetHeight <= vspace)
            { top = pos.bottom; }
          if (left + node.offsetWidth > hspace)
            { left = hspace - node.offsetWidth; }
        }
        node.style.top = top + "px";
        node.style.left = node.style.right = "";
        if (horiz == "right") {
          left = display.sizer.clientWidth - node.offsetWidth;
          node.style.right = "0px";
        } else {
          if (horiz == "left") { left = 0; }
          else if (horiz == "middle") { left = (display.sizer.clientWidth - node.offsetWidth) / 2; }
          node.style.left = left + "px";
        }
        if (scroll)
          { scrollIntoView(this, {left: left, top: top, right: left + node.offsetWidth, bottom: top + node.offsetHeight}); }
      },

      triggerOnKeyDown: methodOp(onKeyDown),
      triggerOnKeyPress: methodOp(onKeyPress),
      triggerOnKeyUp: onKeyUp,
      triggerOnMouseDown: methodOp(onMouseDown),

      execCommand: function(cmd) {
        if (commands.hasOwnProperty(cmd))
          { return commands[cmd].call(null, this) }
      },

      triggerElectric: methodOp(function(text) { triggerElectric(this, text); }),

      findPosH: function(from, amount, unit, visually) {
        var this$1 = this;

        var dir = 1;
        if (amount < 0) { dir = -1; amount = -amount; }
        var cur = clipPos(this.doc, from);
        for (var i = 0; i < amount; ++i) {
          cur = findPosH(this$1.doc, cur, dir, unit, visually);
          if (cur.hitSide) { break }
        }
        return cur
      },

      moveH: methodOp(function(dir, unit) {
        var this$1 = this;

        this.extendSelectionsBy(function (range$$1) {
          if (this$1.display.shift || this$1.doc.extend || range$$1.empty())
            { return findPosH(this$1.doc, range$$1.head, dir, unit, this$1.options.rtlMoveVisually) }
          else
            { return dir < 0 ? range$$1.from() : range$$1.to() }
        }, sel_move);
      }),

      deleteH: methodOp(function(dir, unit) {
        var sel = this.doc.sel, doc = this.doc;
        if (sel.somethingSelected())
          { doc.replaceSelection("", null, "+delete"); }
        else
          { deleteNearSelection(this, function (range$$1) {
            var other = findPosH(doc, range$$1.head, dir, unit, false);
            return dir < 0 ? {from: other, to: range$$1.head} : {from: range$$1.head, to: other}
          }); }
      }),

      findPosV: function(from, amount, unit, goalColumn) {
        var this$1 = this;

        var dir = 1, x = goalColumn;
        if (amount < 0) { dir = -1; amount = -amount; }
        var cur = clipPos(this.doc, from);
        for (var i = 0; i < amount; ++i) {
          var coords = cursorCoords(this$1, cur, "div");
          if (x == null) { x = coords.left; }
          else { coords.left = x; }
          cur = findPosV(this$1, coords, dir, unit);
          if (cur.hitSide) { break }
        }
        return cur
      },

      moveV: methodOp(function(dir, unit) {
        var this$1 = this;

        var doc = this.doc, goals = [];
        var collapse = !this.display.shift && !doc.extend && doc.sel.somethingSelected();
        doc.extendSelectionsBy(function (range$$1) {
          if (collapse)
            { return dir < 0 ? range$$1.from() : range$$1.to() }
          var headPos = cursorCoords(this$1, range$$1.head, "div");
          if (range$$1.goalColumn != null) { headPos.left = range$$1.goalColumn; }
          goals.push(headPos.left);
          var pos = findPosV(this$1, headPos, dir, unit);
          if (unit == "page" && range$$1 == doc.sel.primary())
            { addToScrollTop(this$1, charCoords(this$1, pos, "div").top - headPos.top); }
          return pos
        }, sel_move);
        if (goals.length) { for (var i = 0; i < doc.sel.ranges.length; i++)
          { doc.sel.ranges[i].goalColumn = goals[i]; } }
      }),

      // Find the word at the given position (as returned by coordsChar).
      findWordAt: function(pos) {
        var doc = this.doc, line = getLine(doc, pos.line).text;
        var start = pos.ch, end = pos.ch;
        if (line) {
          var helper = this.getHelper(pos, "wordChars");
          if ((pos.sticky == "before" || end == line.length) && start) { --start; } else { ++end; }
          var startChar = line.charAt(start);
          var check = isWordChar(startChar, helper)
            ? function (ch) { return isWordChar(ch, helper); }
            : /\s/.test(startChar) ? function (ch) { return /\s/.test(ch); }
            : function (ch) { return (!/\s/.test(ch) && !isWordChar(ch)); };
          while (start > 0 && check(line.charAt(start - 1))) { --start; }
          while (end < line.length && check(line.charAt(end))) { ++end; }
        }
        return new Range(Pos(pos.line, start), Pos(pos.line, end))
      },

      toggleOverwrite: function(value) {
        if (value != null && value == this.state.overwrite) { return }
        if (this.state.overwrite = !this.state.overwrite)
          { addClass(this.display.cursorDiv, "CodeMirror-overwrite"); }
        else
          { rmClass(this.display.cursorDiv, "CodeMirror-overwrite"); }

        signal(this, "overwriteToggle", this, this.state.overwrite);
      },
      hasFocus: function() { return this.display.input.getField() == activeElt() },
      isReadOnly: function() { return !!(this.options.readOnly || this.doc.cantEdit) },

      scrollTo: methodOp(function (x, y) { scrollToCoords(this, x, y); }),
      getScrollInfo: function() {
        var scroller = this.display.scroller;
        return {left: scroller.scrollLeft, top: scroller.scrollTop,
                height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
                width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
                clientHeight: displayHeight(this), clientWidth: displayWidth(this)}
      },

      scrollIntoView: methodOp(function(range$$1, margin) {
        if (range$$1 == null) {
          range$$1 = {from: this.doc.sel.primary().head, to: null};
          if (margin == null) { margin = this.options.cursorScrollMargin; }
        } else if (typeof range$$1 == "number") {
          range$$1 = {from: Pos(range$$1, 0), to: null};
        } else if (range$$1.from == null) {
          range$$1 = {from: range$$1, to: null};
        }
        if (!range$$1.to) { range$$1.to = range$$1.from; }
        range$$1.margin = margin || 0;

        if (range$$1.from.line != null) {
          scrollToRange(this, range$$1);
        } else {
          scrollToCoordsRange(this, range$$1.from, range$$1.to, range$$1.margin);
        }
      }),

      setSize: methodOp(function(width, height) {
        var this$1 = this;

        var interpret = function (val) { return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val; };
        if (width != null) { this.display.wrapper.style.width = interpret(width); }
        if (height != null) { this.display.wrapper.style.height = interpret(height); }
        if (this.options.lineWrapping) { clearLineMeasurementCache(this); }
        var lineNo$$1 = this.display.viewFrom;
        this.doc.iter(lineNo$$1, this.display.viewTo, function (line) {
          if (line.widgets) { for (var i = 0; i < line.widgets.length; i++)
            { if (line.widgets[i].noHScroll) { regLineChange(this$1, lineNo$$1, "widget"); break } } }
          ++lineNo$$1;
        });
        this.curOp.forceUpdate = true;
        signal(this, "refresh", this);
      }),

      operation: function(f){return runInOp(this, f)},
      startOperation: function(){return startOperation(this)},
      endOperation: function(){return endOperation(this)},

      refresh: methodOp(function() {
        var oldHeight = this.display.cachedTextHeight;
        regChange(this);
        this.curOp.forceUpdate = true;
        clearCaches(this);
        scrollToCoords(this, this.doc.scrollLeft, this.doc.scrollTop);
        updateGutterSpace(this);
        if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > .5)
          { estimateLineHeights(this); }
        signal(this, "refresh", this);
      }),

      swapDoc: methodOp(function(doc) {
        var old = this.doc;
        old.cm = null;
        attachDoc(this, doc);
        clearCaches(this);
        this.display.input.reset();
        scrollToCoords(this, doc.scrollLeft, doc.scrollTop);
        this.curOp.forceScroll = true;
        signalLater(this, "swapDoc", this, old);
        return old
      }),

      phrase: function(phraseText) {
        var phrases = this.options.phrases;
        return phrases && Object.prototype.hasOwnProperty.call(phrases, phraseText) ? phrases[phraseText] : phraseText
      },

      getInputField: function(){return this.display.input.getField()},
      getWrapperElement: function(){return this.display.wrapper},
      getScrollerElement: function(){return this.display.scroller},
      getGutterElement: function(){return this.display.gutters}
    };
    eventMixin(CodeMirror);

    CodeMirror.registerHelper = function(type, name, value) {
      if (!helpers.hasOwnProperty(type)) { helpers[type] = CodeMirror[type] = {_global: []}; }
      helpers[type][name] = value;
    };
    CodeMirror.registerGlobalHelper = function(type, name, predicate, value) {
      CodeMirror.registerHelper(type, name, value);
      helpers[type]._global.push({pred: predicate, val: value});
    };
  }

  // Used for horizontal relative motion. Dir is -1 or 1 (left or
  // right), unit can be "char", "column" (like char, but doesn't
  // cross line boundaries), "word" (across next word), or "group" (to
  // the start of next group of word or non-word-non-whitespace
  // chars). The visually param controls whether, in right-to-left
  // text, direction 1 means to move towards the next index in the
  // string, or towards the character to the right of the current
  // position. The resulting position will have a hitSide=true
  // property if it reached the end of the document.
  function findPosH(doc, pos, dir, unit, visually) {
    var oldPos = pos;
    var origDir = dir;
    var lineObj = getLine(doc, pos.line);
    function findNextLine() {
      var l = pos.line + dir;
      if (l < doc.first || l >= doc.first + doc.size) { return false }
      pos = new Pos(l, pos.ch, pos.sticky);
      return lineObj = getLine(doc, l)
    }
    function moveOnce(boundToLine) {
      var next;
      if (visually) {
        next = moveVisually(doc.cm, lineObj, pos, dir);
      } else {
        next = moveLogically(lineObj, pos, dir);
      }
      if (next == null) {
        if (!boundToLine && findNextLine())
          { pos = endOfLine(visually, doc.cm, lineObj, pos.line, dir); }
        else
          { return false }
      } else {
        pos = next;
      }
      return true
    }

    if (unit == "char") {
      moveOnce();
    } else if (unit == "column") {
      moveOnce(true);
    } else if (unit == "word" || unit == "group") {
      var sawType = null, group = unit == "group";
      var helper = doc.cm && doc.cm.getHelper(pos, "wordChars");
      for (var first = true;; first = false) {
        if (dir < 0 && !moveOnce(!first)) { break }
        var cur = lineObj.text.charAt(pos.ch) || "\n";
        var type = isWordChar(cur, helper) ? "w"
          : group && cur == "\n" ? "n"
          : !group || /\s/.test(cur) ? null
          : "p";
        if (group && !first && !type) { type = "s"; }
        if (sawType && sawType != type) {
          if (dir < 0) {dir = 1; moveOnce(); pos.sticky = "after";}
          break
        }

        if (type) { sawType = type; }
        if (dir > 0 && !moveOnce(!first)) { break }
      }
    }
    var result = skipAtomic(doc, pos, oldPos, origDir, true);
    if (equalCursorPos(oldPos, result)) { result.hitSide = true; }
    return result
  }

  // For relative vertical movement. Dir may be -1 or 1. Unit can be
  // "page" or "line". The resulting position will have a hitSide=true
  // property if it reached the end of the document.
  function findPosV(cm, pos, dir, unit) {
    var doc = cm.doc, x = pos.left, y;
    if (unit == "page") {
      var pageSize = Math.min(cm.display.wrapper.clientHeight, window.innerHeight || document.documentElement.clientHeight);
      var moveAmount = Math.max(pageSize - .5 * textHeight(cm.display), 3);
      y = (dir > 0 ? pos.bottom : pos.top) + dir * moveAmount;

    } else if (unit == "line") {
      y = dir > 0 ? pos.bottom + 3 : pos.top - 3;
    }
    var target;
    for (;;) {
      target = coordsChar(cm, x, y);
      if (!target.outside) { break }
      if (dir < 0 ? y <= 0 : y >= doc.height) { target.hitSide = true; break }
      y += dir * 5;
    }
    return target
  }

  // CONTENTEDITABLE INPUT STYLE

  var ContentEditableInput = function(cm) {
    this.cm = cm;
    this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null;
    this.polling = new Delayed();
    this.composing = null;
    this.gracePeriod = false;
    this.readDOMTimeout = null;
  };

  ContentEditableInput.prototype.init = function (display) {
      var this$1 = this;

    var input = this, cm = input.cm;
    var div = input.div = display.lineDiv;
    disableBrowserMagic(div, cm.options.spellcheck);

    on(div, "paste", function (e) {
      if (signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }
      // IE doesn't fire input events, so we schedule a read for the pasted content in this way
      if (ie_version <= 11) { setTimeout(operation(cm, function () { return this$1.updateFromDOM(); }), 20); }
    });

    on(div, "compositionstart", function (e) {
      this$1.composing = {data: e.data, done: false};
    });
    on(div, "compositionupdate", function (e) {
      if (!this$1.composing) { this$1.composing = {data: e.data, done: false}; }
    });
    on(div, "compositionend", function (e) {
      if (this$1.composing) {
        if (e.data != this$1.composing.data) { this$1.readFromDOMSoon(); }
        this$1.composing.done = true;
      }
    });

    on(div, "touchstart", function () { return input.forceCompositionEnd(); });

    on(div, "input", function () {
      if (!this$1.composing) { this$1.readFromDOMSoon(); }
    });

    function onCopyCut(e) {
      if (signalDOMEvent(cm, e)) { return }
      if (cm.somethingSelected()) {
        setLastCopied({lineWise: false, text: cm.getSelections()});
        if (e.type == "cut") { cm.replaceSelection("", null, "cut"); }
      } else if (!cm.options.lineWiseCopyCut) {
        return
      } else {
        var ranges = copyableRanges(cm);
        setLastCopied({lineWise: true, text: ranges.text});
        if (e.type == "cut") {
          cm.operation(function () {
            cm.setSelections(ranges.ranges, 0, sel_dontScroll);
            cm.replaceSelection("", null, "cut");
          });
        }
      }
      if (e.clipboardData) {
        e.clipboardData.clearData();
        var content = lastCopied.text.join("\n");
        // iOS exposes the clipboard API, but seems to discard content inserted into it
        e.clipboardData.setData("Text", content);
        if (e.clipboardData.getData("Text") == content) {
          e.preventDefault();
          return
        }
      }
      // Old-fashioned briefly-focus-a-textarea hack
      var kludge = hiddenTextarea(), te = kludge.firstChild;
      cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild);
      te.value = lastCopied.text.join("\n");
      var hadFocus = document.activeElement;
      selectInput(te);
      setTimeout(function () {
        cm.display.lineSpace.removeChild(kludge);
        hadFocus.focus();
        if (hadFocus == div) { input.showPrimarySelection(); }
      }, 50);
    }
    on(div, "copy", onCopyCut);
    on(div, "cut", onCopyCut);
  };

  ContentEditableInput.prototype.prepareSelection = function () {
    var result = prepareSelection(this.cm, false);
    result.focus = this.cm.state.focused;
    return result
  };

  ContentEditableInput.prototype.showSelection = function (info, takeFocus) {
    if (!info || !this.cm.display.view.length) { return }
    if (info.focus || takeFocus) { this.showPrimarySelection(); }
    this.showMultipleSelections(info);
  };

  ContentEditableInput.prototype.getSelection = function () {
    return this.cm.display.wrapper.ownerDocument.getSelection()
  };

  ContentEditableInput.prototype.showPrimarySelection = function () {
    var sel = this.getSelection(), cm = this.cm, prim = cm.doc.sel.primary();
    var from = prim.from(), to = prim.to();

    if (cm.display.viewTo == cm.display.viewFrom || from.line >= cm.display.viewTo || to.line < cm.display.viewFrom) {
      sel.removeAllRanges();
      return
    }

    var curAnchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
    var curFocus = domToPos(cm, sel.focusNode, sel.focusOffset);
    if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad &&
        cmp(minPos(curAnchor, curFocus), from) == 0 &&
        cmp(maxPos(curAnchor, curFocus), to) == 0)
      { return }

    var view = cm.display.view;
    var start = (from.line >= cm.display.viewFrom && posToDOM(cm, from)) ||
        {node: view[0].measure.map[2], offset: 0};
    var end = to.line < cm.display.viewTo && posToDOM(cm, to);
    if (!end) {
      var measure = view[view.length - 1].measure;
      var map$$1 = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map;
      end = {node: map$$1[map$$1.length - 1], offset: map$$1[map$$1.length - 2] - map$$1[map$$1.length - 3]};
    }

    if (!start || !end) {
      sel.removeAllRanges();
      return
    }

    var old = sel.rangeCount && sel.getRangeAt(0), rng;
    try { rng = range(start.node, start.offset, end.offset, end.node); }
    catch(e) {} // Our model of the DOM might be outdated, in which case the range we try to set can be impossible
    if (rng) {
      if (!gecko && cm.state.focused) {
        sel.collapse(start.node, start.offset);
        if (!rng.collapsed) {
          sel.removeAllRanges();
          sel.addRange(rng);
        }
      } else {
        sel.removeAllRanges();
        sel.addRange(rng);
      }
      if (old && sel.anchorNode == null) { sel.addRange(old); }
      else if (gecko) { this.startGracePeriod(); }
    }
    this.rememberSelection();
  };

  ContentEditableInput.prototype.startGracePeriod = function () {
      var this$1 = this;

    clearTimeout(this.gracePeriod);
    this.gracePeriod = setTimeout(function () {
      this$1.gracePeriod = false;
      if (this$1.selectionChanged())
        { this$1.cm.operation(function () { return this$1.cm.curOp.selectionChanged = true; }); }
    }, 20);
  };

  ContentEditableInput.prototype.showMultipleSelections = function (info) {
    removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors);
    removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection);
  };

  ContentEditableInput.prototype.rememberSelection = function () {
    var sel = this.getSelection();
    this.lastAnchorNode = sel.anchorNode; this.lastAnchorOffset = sel.anchorOffset;
    this.lastFocusNode = sel.focusNode; this.lastFocusOffset = sel.focusOffset;
  };

  ContentEditableInput.prototype.selectionInEditor = function () {
    var sel = this.getSelection();
    if (!sel.rangeCount) { return false }
    var node = sel.getRangeAt(0).commonAncestorContainer;
    return contains(this.div, node)
  };

  ContentEditableInput.prototype.focus = function () {
    if (this.cm.options.readOnly != "nocursor") {
      if (!this.selectionInEditor())
        { this.showSelection(this.prepareSelection(), true); }
      this.div.focus();
    }
  };
  ContentEditableInput.prototype.blur = function () { this.div.blur(); };
  ContentEditableInput.prototype.getField = function () { return this.div };

  ContentEditableInput.prototype.supportsTouch = function () { return true };

  ContentEditableInput.prototype.receivedFocus = function () {
    var input = this;
    if (this.selectionInEditor())
      { this.pollSelection(); }
    else
      { runInOp(this.cm, function () { return input.cm.curOp.selectionChanged = true; }); }

    function poll() {
      if (input.cm.state.focused) {
        input.pollSelection();
        input.polling.set(input.cm.options.pollInterval, poll);
      }
    }
    this.polling.set(this.cm.options.pollInterval, poll);
  };

  ContentEditableInput.prototype.selectionChanged = function () {
    var sel = this.getSelection();
    return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset ||
      sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset
  };

  ContentEditableInput.prototype.pollSelection = function () {
    if (this.readDOMTimeout != null || this.gracePeriod || !this.selectionChanged()) { return }
    var sel = this.getSelection(), cm = this.cm;
    // On Android Chrome (version 56, at least), backspacing into an
    // uneditable block element will put the cursor in that element,
    // and then, because it's not editable, hide the virtual keyboard.
    // Because Android doesn't allow us to actually detect backspace
    // presses in a sane way, this code checks for when that happens
    // and simulates a backspace press in this case.
    if (android && chrome && this.cm.options.gutters.length && isInGutter(sel.anchorNode)) {
      this.cm.triggerOnKeyDown({type: "keydown", keyCode: 8, preventDefault: Math.abs});
      this.blur();
      this.focus();
      return
    }
    if (this.composing) { return }
    this.rememberSelection();
    var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
    var head = domToPos(cm, sel.focusNode, sel.focusOffset);
    if (anchor && head) { runInOp(cm, function () {
      setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll);
      if (anchor.bad || head.bad) { cm.curOp.selectionChanged = true; }
    }); }
  };

  ContentEditableInput.prototype.pollContent = function () {
    if (this.readDOMTimeout != null) {
      clearTimeout(this.readDOMTimeout);
      this.readDOMTimeout = null;
    }

    var cm = this.cm, display = cm.display, sel = cm.doc.sel.primary();
    var from = sel.from(), to = sel.to();
    if (from.ch == 0 && from.line > cm.firstLine())
      { from = Pos(from.line - 1, getLine(cm.doc, from.line - 1).length); }
    if (to.ch == getLine(cm.doc, to.line).text.length && to.line < cm.lastLine())
      { to = Pos(to.line + 1, 0); }
    if (from.line < display.viewFrom || to.line > display.viewTo - 1) { return false }

    var fromIndex, fromLine, fromNode;
    if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
      fromLine = lineNo(display.view[0].line);
      fromNode = display.view[0].node;
    } else {
      fromLine = lineNo(display.view[fromIndex].line);
      fromNode = display.view[fromIndex - 1].node.nextSibling;
    }
    var toIndex = findViewIndex(cm, to.line);
    var toLine, toNode;
    if (toIndex == display.view.length - 1) {
      toLine = display.viewTo - 1;
      toNode = display.lineDiv.lastChild;
    } else {
      toLine = lineNo(display.view[toIndex + 1].line) - 1;
      toNode = display.view[toIndex + 1].node.previousSibling;
    }

    if (!fromNode) { return false }
    var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine));
    var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length));
    while (newText.length > 1 && oldText.length > 1) {
      if (lst(newText) == lst(oldText)) { newText.pop(); oldText.pop(); toLine--; }
      else if (newText[0] == oldText[0]) { newText.shift(); oldText.shift(); fromLine++; }
      else { break }
    }

    var cutFront = 0, cutEnd = 0;
    var newTop = newText[0], oldTop = oldText[0], maxCutFront = Math.min(newTop.length, oldTop.length);
    while (cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront))
      { ++cutFront; }
    var newBot = lst(newText), oldBot = lst(oldText);
    var maxCutEnd = Math.min(newBot.length - (newText.length == 1 ? cutFront : 0),
                             oldBot.length - (oldText.length == 1 ? cutFront : 0));
    while (cutEnd < maxCutEnd &&
           newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1))
      { ++cutEnd; }
    // Try to move start of change to start of selection if ambiguous
    if (newText.length == 1 && oldText.length == 1 && fromLine == from.line) {
      while (cutFront && cutFront > from.ch &&
             newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)) {
        cutFront--;
        cutEnd++;
      }
    }

    newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd).replace(/^\u200b+/, "");
    newText[0] = newText[0].slice(cutFront).replace(/\u200b+$/, "");

    var chFrom = Pos(fromLine, cutFront);
    var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0);
    if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
      replaceRange(cm.doc, newText, chFrom, chTo, "+input");
      return true
    }
  };

  ContentEditableInput.prototype.ensurePolled = function () {
    this.forceCompositionEnd();
  };
  ContentEditableInput.prototype.reset = function () {
    this.forceCompositionEnd();
  };
  ContentEditableInput.prototype.forceCompositionEnd = function () {
    if (!this.composing) { return }
    clearTimeout(this.readDOMTimeout);
    this.composing = null;
    this.updateFromDOM();
    this.div.blur();
    this.div.focus();
  };
  ContentEditableInput.prototype.readFromDOMSoon = function () {
      var this$1 = this;

    if (this.readDOMTimeout != null) { return }
    this.readDOMTimeout = setTimeout(function () {
      this$1.readDOMTimeout = null;
      if (this$1.composing) {
        if (this$1.composing.done) { this$1.composing = null; }
        else { return }
      }
      this$1.updateFromDOM();
    }, 80);
  };

  ContentEditableInput.prototype.updateFromDOM = function () {
      var this$1 = this;

    if (this.cm.isReadOnly() || !this.pollContent())
      { runInOp(this.cm, function () { return regChange(this$1.cm); }); }
  };

  ContentEditableInput.prototype.setUneditable = function (node) {
    node.contentEditable = "false";
  };

  ContentEditableInput.prototype.onKeyPress = function (e) {
    if (e.charCode == 0 || this.composing) { return }
    e.preventDefault();
    if (!this.cm.isReadOnly())
      { operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0); }
  };

  ContentEditableInput.prototype.readOnlyChanged = function (val) {
    this.div.contentEditable = String(val != "nocursor");
  };

  ContentEditableInput.prototype.onContextMenu = function () {};
  ContentEditableInput.prototype.resetPosition = function () {};

  ContentEditableInput.prototype.needsContentAttribute = true;

  function posToDOM(cm, pos) {
    var view = findViewForLine(cm, pos.line);
    if (!view || view.hidden) { return null }
    var line = getLine(cm.doc, pos.line);
    var info = mapFromLineView(view, line, pos.line);

    var order = getOrder(line, cm.doc.direction), side = "left";
    if (order) {
      var partPos = getBidiPartAt(order, pos.ch);
      side = partPos % 2 ? "right" : "left";
    }
    var result = nodeAndOffsetInLineMap(info.map, pos.ch, side);
    result.offset = result.collapse == "right" ? result.end : result.start;
    return result
  }

  function isInGutter(node) {
    for (var scan = node; scan; scan = scan.parentNode)
      { if (/CodeMirror-gutter-wrapper/.test(scan.className)) { return true } }
    return false
  }

  function badPos(pos, bad) { if (bad) { pos.bad = true; } return pos }

  function domTextBetween(cm, from, to, fromLine, toLine) {
    var text = "", closing = false, lineSep = cm.doc.lineSeparator(), extraLinebreak = false;
    function recognizeMarker(id) { return function (marker) { return marker.id == id; } }
    function close() {
      if (closing) {
        text += lineSep;
        if (extraLinebreak) { text += lineSep; }
        closing = extraLinebreak = false;
      }
    }
    function addText(str) {
      if (str) {
        close();
        text += str;
      }
    }
    function walk(node) {
      if (node.nodeType == 1) {
        var cmText = node.getAttribute("cm-text");
        if (cmText) {
          addText(cmText);
          return
        }
        var markerID = node.getAttribute("cm-marker"), range$$1;
        if (markerID) {
          var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID));
          if (found.length && (range$$1 = found[0].find(0)))
            { addText(getBetween(cm.doc, range$$1.from, range$$1.to).join(lineSep)); }
          return
        }
        if (node.getAttribute("contenteditable") == "false") { return }
        var isBlock = /^(pre|div|p|li|table|br)$/i.test(node.nodeName);
        if (!/^br$/i.test(node.nodeName) && node.textContent.length == 0) { return }

        if (isBlock) { close(); }
        for (var i = 0; i < node.childNodes.length; i++)
          { walk(node.childNodes[i]); }

        if (/^(pre|p)$/i.test(node.nodeName)) { extraLinebreak = true; }
        if (isBlock) { closing = true; }
      } else if (node.nodeType == 3) {
        addText(node.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
      }
    }
    for (;;) {
      walk(from);
      if (from == to) { break }
      from = from.nextSibling;
      extraLinebreak = false;
    }
    return text
  }

  function domToPos(cm, node, offset) {
    var lineNode;
    if (node == cm.display.lineDiv) {
      lineNode = cm.display.lineDiv.childNodes[offset];
      if (!lineNode) { return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true) }
      node = null; offset = 0;
    } else {
      for (lineNode = node;; lineNode = lineNode.parentNode) {
        if (!lineNode || lineNode == cm.display.lineDiv) { return null }
        if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) { break }
      }
    }
    for (var i = 0; i < cm.display.view.length; i++) {
      var lineView = cm.display.view[i];
      if (lineView.node == lineNode)
        { return locateNodeInLineView(lineView, node, offset) }
    }
  }

  function locateNodeInLineView(lineView, node, offset) {
    var wrapper = lineView.text.firstChild, bad = false;
    if (!node || !contains(wrapper, node)) { return badPos(Pos(lineNo(lineView.line), 0), true) }
    if (node == wrapper) {
      bad = true;
      node = wrapper.childNodes[offset];
      offset = 0;
      if (!node) {
        var line = lineView.rest ? lst(lineView.rest) : lineView.line;
        return badPos(Pos(lineNo(line), line.text.length), bad)
      }
    }

    var textNode = node.nodeType == 3 ? node : null, topNode = node;
    if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
      textNode = node.firstChild;
      if (offset) { offset = textNode.nodeValue.length; }
    }
    while (topNode.parentNode != wrapper) { topNode = topNode.parentNode; }
    var measure = lineView.measure, maps = measure.maps;

    function find(textNode, topNode, offset) {
      for (var i = -1; i < (maps ? maps.length : 0); i++) {
        var map$$1 = i < 0 ? measure.map : maps[i];
        for (var j = 0; j < map$$1.length; j += 3) {
          var curNode = map$$1[j + 2];
          if (curNode == textNode || curNode == topNode) {
            var line = lineNo(i < 0 ? lineView.line : lineView.rest[i]);
            var ch = map$$1[j] + offset;
            if (offset < 0 || curNode != textNode) { ch = map$$1[j + (offset ? 1 : 0)]; }
            return Pos(line, ch)
          }
        }
      }
    }
    var found = find(textNode, topNode, offset);
    if (found) { return badPos(found, bad) }

    // FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
    for (var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling) {
      found = find(after, after.firstChild, 0);
      if (found)
        { return badPos(Pos(found.line, found.ch - dist), bad) }
      else
        { dist += after.textContent.length; }
    }
    for (var before = topNode.previousSibling, dist$1 = offset; before; before = before.previousSibling) {
      found = find(before, before.firstChild, -1);
      if (found)
        { return badPos(Pos(found.line, found.ch + dist$1), bad) }
      else
        { dist$1 += before.textContent.length; }
    }
  }

  // TEXTAREA INPUT STYLE

  var TextareaInput = function(cm) {
    this.cm = cm;
    // See input.poll and input.reset
    this.prevInput = "";

    // Flag that indicates whether we expect input to appear real soon
    // now (after some event like 'keypress' or 'input') and are
    // polling intensively.
    this.pollingFast = false;
    // Self-resetting timeout for the poller
    this.polling = new Delayed();
    // Used to work around IE issue with selection being forgotten when focus moves away from textarea
    this.hasSelection = false;
    this.composing = null;
  };

  TextareaInput.prototype.init = function (display) {
      var this$1 = this;

    var input = this, cm = this.cm;
    this.createField(display);
    var te = this.textarea;

    display.wrapper.insertBefore(this.wrapper, display.wrapper.firstChild);

    // Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
    if (ios) { te.style.width = "0px"; }

    on(te, "input", function () {
      if (ie && ie_version >= 9 && this$1.hasSelection) { this$1.hasSelection = null; }
      input.poll();
    });

    on(te, "paste", function (e) {
      if (signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }

      cm.state.pasteIncoming = true;
      input.fastPoll();
    });

    function prepareCopyCut(e) {
      if (signalDOMEvent(cm, e)) { return }
      if (cm.somethingSelected()) {
        setLastCopied({lineWise: false, text: cm.getSelections()});
      } else if (!cm.options.lineWiseCopyCut) {
        return
      } else {
        var ranges = copyableRanges(cm);
        setLastCopied({lineWise: true, text: ranges.text});
        if (e.type == "cut") {
          cm.setSelections(ranges.ranges, null, sel_dontScroll);
        } else {
          input.prevInput = "";
          te.value = ranges.text.join("\n");
          selectInput(te);
        }
      }
      if (e.type == "cut") { cm.state.cutIncoming = true; }
    }
    on(te, "cut", prepareCopyCut);
    on(te, "copy", prepareCopyCut);

    on(display.scroller, "paste", function (e) {
      if (eventInWidget(display, e) || signalDOMEvent(cm, e)) { return }
      cm.state.pasteIncoming = true;
      input.focus();
    });

    // Prevent normal selection in the editor (we handle our own)
    on(display.lineSpace, "selectstart", function (e) {
      if (!eventInWidget(display, e)) { e_preventDefault(e); }
    });

    on(te, "compositionstart", function () {
      var start = cm.getCursor("from");
      if (input.composing) { input.composing.range.clear(); }
      input.composing = {
        start: start,
        range: cm.markText(start, cm.getCursor("to"), {className: "CodeMirror-composing"})
      };
    });
    on(te, "compositionend", function () {
      if (input.composing) {
        input.poll();
        input.composing.range.clear();
        input.composing = null;
      }
    });
  };

  TextareaInput.prototype.createField = function (_display) {
    // Wraps and hides input textarea
    this.wrapper = hiddenTextarea();
    // The semihidden textarea that is focused when the editor is
    // focused, and receives input.
    this.textarea = this.wrapper.firstChild;
  };

  TextareaInput.prototype.prepareSelection = function () {
    // Redraw the selection and/or cursor
    var cm = this.cm, display = cm.display, doc = cm.doc;
    var result = prepareSelection(cm);

    // Move the hidden textarea near the cursor to prevent scrolling artifacts
    if (cm.options.moveInputWithCursor) {
      var headPos = cursorCoords(cm, doc.sel.primary().head, "div");
      var wrapOff = display.wrapper.getBoundingClientRect(), lineOff = display.lineDiv.getBoundingClientRect();
      result.teTop = Math.max(0, Math.min(display.wrapper.clientHeight - 10,
                                          headPos.top + lineOff.top - wrapOff.top));
      result.teLeft = Math.max(0, Math.min(display.wrapper.clientWidth - 10,
                                           headPos.left + lineOff.left - wrapOff.left));
    }

    return result
  };

  TextareaInput.prototype.showSelection = function (drawn) {
    var cm = this.cm, display = cm.display;
    removeChildrenAndAdd(display.cursorDiv, drawn.cursors);
    removeChildrenAndAdd(display.selectionDiv, drawn.selection);
    if (drawn.teTop != null) {
      this.wrapper.style.top = drawn.teTop + "px";
      this.wrapper.style.left = drawn.teLeft + "px";
    }
  };

  // Reset the input to correspond to the selection (or to be empty,
  // when not typing and nothing is selected)
  TextareaInput.prototype.reset = function (typing) {
    if (this.contextMenuPending || this.composing) { return }
    var cm = this.cm;
    if (cm.somethingSelected()) {
      this.prevInput = "";
      var content = cm.getSelection();
      this.textarea.value = content;
      if (cm.state.focused) { selectInput(this.textarea); }
      if (ie && ie_version >= 9) { this.hasSelection = content; }
    } else if (!typing) {
      this.prevInput = this.textarea.value = "";
      if (ie && ie_version >= 9) { this.hasSelection = null; }
    }
  };

  TextareaInput.prototype.getField = function () { return this.textarea };

  TextareaInput.prototype.supportsTouch = function () { return false };

  TextareaInput.prototype.focus = function () {
    if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt() != this.textarea)) {
      try { this.textarea.focus(); }
      catch (e) {} // IE8 will throw if the textarea is display: none or not in DOM
    }
  };

  TextareaInput.prototype.blur = function () { this.textarea.blur(); };

  TextareaInput.prototype.resetPosition = function () {
    this.wrapper.style.top = this.wrapper.style.left = 0;
  };

  TextareaInput.prototype.receivedFocus = function () { this.slowPoll(); };

  // Poll for input changes, using the normal rate of polling. This
  // runs as long as the editor is focused.
  TextareaInput.prototype.slowPoll = function () {
      var this$1 = this;

    if (this.pollingFast) { return }
    this.polling.set(this.cm.options.pollInterval, function () {
      this$1.poll();
      if (this$1.cm.state.focused) { this$1.slowPoll(); }
    });
  };

  // When an event has just come in that is likely to add or change
  // something in the input textarea, we poll faster, to ensure that
  // the change appears on the screen quickly.
  TextareaInput.prototype.fastPoll = function () {
    var missed = false, input = this;
    input.pollingFast = true;
    function p() {
      var changed = input.poll();
      if (!changed && !missed) {missed = true; input.polling.set(60, p);}
      else {input.pollingFast = false; input.slowPoll();}
    }
    input.polling.set(20, p);
  };

  // Read input from the textarea, and update the document to match.
  // When something is selected, it is present in the textarea, and
  // selected (unless it is huge, in which case a placeholder is
  // used). When nothing is selected, the cursor sits after previously
  // seen text (can be empty), which is stored in prevInput (we must
  // not reset the textarea when typing, because that breaks IME).
  TextareaInput.prototype.poll = function () {
      var this$1 = this;

    var cm = this.cm, input = this.textarea, prevInput = this.prevInput;
    // Since this is called a *lot*, try to bail out as cheaply as
    // possible when it is clear that nothing happened. hasSelection
    // will be the case when there is a lot of text in the textarea,
    // in which case reading its value would be expensive.
    if (this.contextMenuPending || !cm.state.focused ||
        (hasSelection(input) && !prevInput && !this.composing) ||
        cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq)
      { return false }

    var text = input.value;
    // If nothing changed, bail.
    if (text == prevInput && !cm.somethingSelected()) { return false }
    // Work around nonsensical selection resetting in IE9/10, and
    // inexplicable appearance of private area unicode characters on
    // some key combos in Mac (#2689).
    if (ie && ie_version >= 9 && this.hasSelection === text ||
        mac && /[\uf700-\uf7ff]/.test(text)) {
      cm.display.input.reset();
      return false
    }

    if (cm.doc.sel == cm.display.selForContextMenu) {
      var first = text.charCodeAt(0);
      if (first == 0x200b && !prevInput) { prevInput = "\u200b"; }
      if (first == 0x21da) { this.reset(); return this.cm.execCommand("undo") }
    }
    // Find the part of the input that is actually new
    var same = 0, l = Math.min(prevInput.length, text.length);
    while (same < l && prevInput.charCodeAt(same) == text.charCodeAt(same)) { ++same; }

    runInOp(cm, function () {
      applyTextInput(cm, text.slice(same), prevInput.length - same,
                     null, this$1.composing ? "*compose" : null);

      // Don't leave long text in the textarea, since it makes further polling slow
      if (text.length > 1000 || text.indexOf("\n") > -1) { input.value = this$1.prevInput = ""; }
      else { this$1.prevInput = text; }

      if (this$1.composing) {
        this$1.composing.range.clear();
        this$1.composing.range = cm.markText(this$1.composing.start, cm.getCursor("to"),
                                           {className: "CodeMirror-composing"});
      }
    });
    return true
  };

  TextareaInput.prototype.ensurePolled = function () {
    if (this.pollingFast && this.poll()) { this.pollingFast = false; }
  };

  TextareaInput.prototype.onKeyPress = function () {
    if (ie && ie_version >= 9) { this.hasSelection = null; }
    this.fastPoll();
  };

  TextareaInput.prototype.onContextMenu = function (e) {
    var input = this, cm = input.cm, display = cm.display, te = input.textarea;
    if (input.contextMenuPending) { input.contextMenuPending(); }
    var pos = posFromMouse(cm, e), scrollPos = display.scroller.scrollTop;
    if (!pos || presto) { return } // Opera is difficult.

    // Reset the current text selection only if the click is done outside of the selection
    // and 'resetSelectionOnContextMenu' option is true.
    var reset = cm.options.resetSelectionOnContextMenu;
    if (reset && cm.doc.sel.contains(pos) == -1)
      { operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll); }

    var oldCSS = te.style.cssText, oldWrapperCSS = input.wrapper.style.cssText;
    var wrapperBox = input.wrapper.offsetParent.getBoundingClientRect();
    input.wrapper.style.cssText = "position: static";
    te.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - wrapperBox.top - 5) + "px; left: " + (e.clientX - wrapperBox.left - 5) + "px;\n      z-index: 1000; background: " + (ie ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);";
    var oldScrollY;
    if (webkit) { oldScrollY = window.scrollY; } // Work around Chrome issue (#2712)
    display.input.focus();
    if (webkit) { window.scrollTo(null, oldScrollY); }
    display.input.reset();
    // Adds "Select all" to context menu in FF
    if (!cm.somethingSelected()) { te.value = input.prevInput = " "; }
    input.contextMenuPending = rehide;
    display.selForContextMenu = cm.doc.sel;
    clearTimeout(display.detectingSelectAll);

    // Select-all will be greyed out if there's nothing to select, so
    // this adds a zero-width space so that we can later check whether
    // it got selected.
    function prepareSelectAllHack() {
      if (te.selectionStart != null) {
        var selected = cm.somethingSelected();
        var extval = "\u200b" + (selected ? te.value : "");
        te.value = "\u21da"; // Used to catch context-menu undo
        te.value = extval;
        input.prevInput = selected ? "" : "\u200b";
        te.selectionStart = 1; te.selectionEnd = extval.length;
        // Re-set this, in case some other handler touched the
        // selection in the meantime.
        display.selForContextMenu = cm.doc.sel;
      }
    }
    function rehide() {
      if (input.contextMenuPending != rehide) { return }
      input.contextMenuPending = false;
      input.wrapper.style.cssText = oldWrapperCSS;
      te.style.cssText = oldCSS;
      if (ie && ie_version < 9) { display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos); }

      // Try to detect the user choosing select-all
      if (te.selectionStart != null) {
        if (!ie || (ie && ie_version < 9)) { prepareSelectAllHack(); }
        var i = 0, poll = function () {
          if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 &&
              te.selectionEnd > 0 && input.prevInput == "\u200b") {
            operation(cm, selectAll)(cm);
          } else if (i++ < 10) {
            display.detectingSelectAll = setTimeout(poll, 500);
          } else {
            display.selForContextMenu = null;
            display.input.reset();
          }
        };
        display.detectingSelectAll = setTimeout(poll, 200);
      }
    }

    if (ie && ie_version >= 9) { prepareSelectAllHack(); }
    if (captureRightClick) {
      e_stop(e);
      var mouseup = function () {
        off(window, "mouseup", mouseup);
        setTimeout(rehide, 20);
      };
      on(window, "mouseup", mouseup);
    } else {
      setTimeout(rehide, 50);
    }
  };

  TextareaInput.prototype.readOnlyChanged = function (val) {
    if (!val) { this.reset(); }
    this.textarea.disabled = val == "nocursor";
  };

  TextareaInput.prototype.setUneditable = function () {};

  TextareaInput.prototype.needsContentAttribute = false;

  function fromTextArea(textarea, options) {
    options = options ? copyObj(options) : {};
    options.value = textarea.value;
    if (!options.tabindex && textarea.tabIndex)
      { options.tabindex = textarea.tabIndex; }
    if (!options.placeholder && textarea.placeholder)
      { options.placeholder = textarea.placeholder; }
    // Set autofocus to true if this textarea is focused, or if it has
    // autofocus and no other element is focused.
    if (options.autofocus == null) {
      var hasFocus = activeElt();
      options.autofocus = hasFocus == textarea ||
        textarea.getAttribute("autofocus") != null && hasFocus == document.body;
    }

    function save() {textarea.value = cm.getValue();}

    var realSubmit;
    if (textarea.form) {
      on(textarea.form, "submit", save);
      // Deplorable hack to make the submit method do the right thing.
      if (!options.leaveSubmitMethodAlone) {
        var form = textarea.form;
        realSubmit = form.submit;
        try {
          var wrappedSubmit = form.submit = function () {
            save();
            form.submit = realSubmit;
            form.submit();
            form.submit = wrappedSubmit;
          };
        } catch(e) {}
      }
    }

    options.finishInit = function (cm) {
      cm.save = save;
      cm.getTextArea = function () { return textarea; };
      cm.toTextArea = function () {
        cm.toTextArea = isNaN; // Prevent this from being ran twice
        save();
        textarea.parentNode.removeChild(cm.getWrapperElement());
        textarea.style.display = "";
        if (textarea.form) {
          off(textarea.form, "submit", save);
          if (typeof textarea.form.submit == "function")
            { textarea.form.submit = realSubmit; }
        }
      };
    };

    textarea.style.display = "none";
    var cm = CodeMirror(function (node) { return textarea.parentNode.insertBefore(node, textarea.nextSibling); },
      options);
    return cm
  }

  function addLegacyProps(CodeMirror) {
    CodeMirror.off = off;
    CodeMirror.on = on;
    CodeMirror.wheelEventPixels = wheelEventPixels;
    CodeMirror.Doc = Doc;
    CodeMirror.splitLines = splitLinesAuto;
    CodeMirror.countColumn = countColumn;
    CodeMirror.findColumn = findColumn;
    CodeMirror.isWordChar = isWordCharBasic;
    CodeMirror.Pass = Pass;
    CodeMirror.signal = signal;
    CodeMirror.Line = Line;
    CodeMirror.changeEnd = changeEnd;
    CodeMirror.scrollbarModel = scrollbarModel;
    CodeMirror.Pos = Pos;
    CodeMirror.cmpPos = cmp;
    CodeMirror.modes = modes;
    CodeMirror.mimeModes = mimeModes;
    CodeMirror.resolveMode = resolveMode;
    CodeMirror.getMode = getMode;
    CodeMirror.modeExtensions = modeExtensions;
    CodeMirror.extendMode = extendMode;
    CodeMirror.copyState = copyState;
    CodeMirror.startState = startState;
    CodeMirror.innerMode = innerMode;
    CodeMirror.commands = commands;
    CodeMirror.keyMap = keyMap;
    CodeMirror.keyName = keyName;
    CodeMirror.isModifierKey = isModifierKey;
    CodeMirror.lookupKey = lookupKey;
    CodeMirror.normalizeKeyMap = normalizeKeyMap;
    CodeMirror.StringStream = StringStream;
    CodeMirror.SharedTextMarker = SharedTextMarker;
    CodeMirror.TextMarker = TextMarker;
    CodeMirror.LineWidget = LineWidget;
    CodeMirror.e_preventDefault = e_preventDefault;
    CodeMirror.e_stopPropagation = e_stopPropagation;
    CodeMirror.e_stop = e_stop;
    CodeMirror.addClass = addClass;
    CodeMirror.contains = contains;
    CodeMirror.rmClass = rmClass;
    CodeMirror.keyNames = keyNames;
  }

  // EDITOR CONSTRUCTOR

  defineOptions(CodeMirror);

  addEditorMethods(CodeMirror);

  // Set up methods on CodeMirror's prototype to redirect to the editor's document.
  var dontDelegate = "iter insert remove copy getEditor constructor".split(" ");
  for (var prop in Doc.prototype) { if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0)
    { CodeMirror.prototype[prop] = (function(method) {
      return function() {return method.apply(this.doc, arguments)}
    })(Doc.prototype[prop]); } }

  eventMixin(Doc);
  CodeMirror.inputStyles = {"textarea": TextareaInput, "contenteditable": ContentEditableInput};

  // Extra arguments are stored as the mode's dependencies, which is
  // used by (legacy) mechanisms like loadmode.js to automatically
  // load a mode. (Preferred mechanism is the require/define calls.)
  CodeMirror.defineMode = function(name/*, mode, …*/) {
    if (!CodeMirror.defaults.mode && name != "null") { CodeMirror.defaults.mode = name; }
    defineMode.apply(this, arguments);
  };

  CodeMirror.defineMIME = defineMIME;

  // Minimal default mode.
  CodeMirror.defineMode("null", function () { return ({token: function (stream) { return stream.skipToEnd(); }}); });
  CodeMirror.defineMIME("text/plain", "null");

  // EXTENSIONS

  CodeMirror.defineExtension = function (name, func) {
    CodeMirror.prototype[name] = func;
  };
  CodeMirror.defineDocExtension = function (name, func) {
    Doc.prototype[name] = func;
  };

  CodeMirror.fromTextArea = fromTextArea;

  addLegacyProps(CodeMirror);

  CodeMirror.version = "5.42.2";

  return CodeMirror;

})));


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MentionType; });
/* harmony export (immutable) */ __webpack_exports__["c"] = isRestricted;
/* harmony export (immutable) */ __webpack_exports__["d"] = isSpecialMention;
/* harmony export (immutable) */ __webpack_exports__["b"] = isAppMention;
/* harmony export (immutable) */ __webpack_exports__["f"] = isTeamMention;
/* harmony export (immutable) */ __webpack_exports__["e"] = isSpecialMentionText;
var MentionType;
(function (MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
})(MentionType || (MentionType = {}));
var UserAccessLevel;
(function (UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
})(UserAccessLevel || (UserAccessLevel = {}));
var UserType;
(function (UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
})(UserType || (UserType = {}));
function isRestricted(accessLevel) {
    return (accessLevel && accessLevel !== UserAccessLevel[UserAccessLevel.CONTAINER]);
}
function isSpecialMention(mention) {
    return !!mention.userType && mention.userType === UserType[UserType.SPECIAL];
}
function isAppMention(mention) {
    return mention.userType && mention.userType === UserType[UserType.APP];
}
function isTeamMention(mention) {
    return mention.userType && mention.userType === UserType[UserType.TEAM];
}
function isSpecialMentionText(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
//# sourceMappingURL=types.js.map

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorTransform = __webpack_require__(46);
var prosemirrorModel = __webpack_require__(23);
var prosemirrorState = __webpack_require__(11);

// :: (EditorState, ?(tr: Transaction)) → bool
// Delete the selection, if there is one.
function deleteSelection(state, dispatch) {
  if (state.selection.empty) { return false }
  if (dispatch) { dispatch(state.tr.deleteSelection().scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
// If the selection is empty and at the start of a textblock, try to
// reduce the distance between that block and the one before it—if
// there's a block directly before it that can be joined, join them.
// If not, try to move the selected block closer to the next one in
// the document structure by lifting it out of its parent or moving it
// into a parent of the previous block. Will use the view for accurate
// (bidi-aware) start-of-textblock detection if given.
function joinBackward(state, dispatch, view) {
  var ref = state.selection;
  var $cursor = ref.$cursor;
  if (!$cursor || (view ? !view.endOfTextblock("backward", state)
                        : $cursor.parentOffset > 0))
    { return false }

  var $cut = findCutBefore($cursor);

  // If there is no node before this, try to lift
  if (!$cut) {
    var range = $cursor.blockRange(), target = range && prosemirrorTransform.liftTarget(range);
    if (target == null) { return false }
    if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
    return true
  }

  var before = $cut.nodeBefore;
  // Apply the joining algorithm
  if (!before.type.spec.isolating && deleteBarrier(state, $cut, dispatch))
    { return true }

  // If the node below has no content and the node above is
  // selectable, delete the node below and select the one above.
  if ($cursor.parent.content.size == 0 &&
      (textblockAt(before, "end") || prosemirrorState.NodeSelection.isSelectable(before))) {
    if (dispatch) {
      var tr = state.tr.deleteRange($cursor.before(), $cursor.after());
      tr.setSelection(textblockAt(before, "end") ? prosemirrorState.Selection.findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1)
                      : prosemirrorState.NodeSelection.create(tr.doc, $cut.pos - before.nodeSize));
      dispatch(tr.scrollIntoView());
    }
    return true
  }

  // If the node before is an atom, delete it
  if (before.isAtom && $cut.depth == $cursor.depth - 1) {
    if (dispatch) { dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView()); }
    return true
  }

  return false
}

function textblockAt(node, side) {
  for (; node; node = (side == "start" ? node.firstChild : node.lastChild))
    { if (node.isTextblock) { return true } }
  return false
}

// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
// When the selection is empty and at the start of a textblock, select
// the node before that textblock, if possible. This is intended to be
// bound to keys like backspace, after
// [`joinBackward`](#commands.joinBackward) or other deleting
// commands, as a fall-back behavior when the schema doesn't allow
// deletion at the selected point.
function selectNodeBackward(state, dispatch, view) {
  var ref = state.selection;
  var $cursor = ref.$cursor;
  if (!$cursor || (view ? !view.endOfTextblock("backward", state)
                        : $cursor.parentOffset > 0))
    { return false }

  var $cut = findCutBefore($cursor), node = $cut && $cut.nodeBefore;
  if (!node || !prosemirrorState.NodeSelection.isSelectable(node)) { return false }
  if (dispatch)
    { dispatch(state.tr.setSelection(prosemirrorState.NodeSelection.create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView()); }
  return true
}

function findCutBefore($pos) {
  if (!$pos.parent.type.spec.isolating) { for (var i = $pos.depth - 1; i >= 0; i--) {
    if ($pos.index(i) > 0) { return $pos.doc.resolve($pos.before(i + 1)) }
    if ($pos.node(i).type.spec.isolating) { break }
  } }
  return null
}

// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
// If the selection is empty and the cursor is at the end of a
// textblock, try to reduce or remove the boundary between that block
// and the one after it, either by joining them or by moving the other
// block closer to this one in the tree structure. Will use the view
// for accurate start-of-textblock detection if given.
function joinForward(state, dispatch, view) {
  var ref = state.selection;
  var $cursor = ref.$cursor;
  if (!$cursor || (view ? !view.endOfTextblock("forward", state)
                        : $cursor.parentOffset < $cursor.parent.content.size))
    { return false }

  var $cut = findCutAfter($cursor);

  // If there is no node after this, there's nothing to do
  if (!$cut) { return false }

  var after = $cut.nodeAfter;
  // Try the joining algorithm
  if (deleteBarrier(state, $cut, dispatch)) { return true }

  // If the node above has no content and the node below is
  // selectable, delete the node above and select the one below.
  if ($cursor.parent.content.size == 0 &&
      (textblockAt(after, "start") || prosemirrorState.NodeSelection.isSelectable(after))) {
    if (dispatch) {
      var tr = state.tr.deleteRange($cursor.before(), $cursor.after());
      tr.setSelection(textblockAt(after, "start") ? prosemirrorState.Selection.findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1)
                      : prosemirrorState.NodeSelection.create(tr.doc, tr.mapping.map($cut.pos)));
      dispatch(tr.scrollIntoView());
    }
    return true
  }

  // If the next node is an atom, delete it
  if (after.isAtom && $cut.depth == $cursor.depth - 1) {
    if (dispatch) { dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView()); }
    return true
  }

  return false
}

// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
// When the selection is empty and at the end of a textblock, select
// the node coming after that textblock, if possible. This is intended
// to be bound to keys like delete, after
// [`joinForward`](#commands.joinForward) and similar deleting
// commands, to provide a fall-back behavior when the schema doesn't
// allow deletion at the selected point.
function selectNodeForward(state, dispatch, view) {
  var ref = state.selection;
  var $cursor = ref.$cursor;
  if (!$cursor || (view ? !view.endOfTextblock("forward", state)
                        : $cursor.parentOffset < $cursor.parent.content.size))
    { return false }

  var $cut = findCutAfter($cursor), node = $cut && $cut.nodeAfter;
  if (!node || !prosemirrorState.NodeSelection.isSelectable(node)) { return false }
  if (dispatch)
    { dispatch(state.tr.setSelection(prosemirrorState.NodeSelection.create(state.doc, $cut.pos)).scrollIntoView()); }
  return true
}

function findCutAfter($pos) {
  if (!$pos.parent.type.spec.isolating) { for (var i = $pos.depth - 1; i >= 0; i--) {
    var parent = $pos.node(i);
    if ($pos.index(i) + 1 < parent.childCount) { return $pos.doc.resolve($pos.after(i + 1)) }
    if (parent.type.spec.isolating) { break }
  } }
  return null
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Join the selected block or, if there is a text selection, the
// closest ancestor block of the selection that can be joined, with
// the sibling above it.
function joinUp(state, dispatch) {
  var sel = state.selection, nodeSel = sel instanceof prosemirrorState.NodeSelection, point;
  if (nodeSel) {
    if (sel.node.isTextblock || !prosemirrorTransform.canJoin(state.doc, sel.from)) { return false }
    point = sel.from;
  } else {
    point = prosemirrorTransform.joinPoint(state.doc, sel.from, -1);
    if (point == null) { return false }
  }
  if (dispatch) {
    var tr = state.tr.join(point);
    if (nodeSel) { tr.setSelection(prosemirrorState.NodeSelection.create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize)); }
    dispatch(tr.scrollIntoView());
  }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Join the selected block, or the closest ancestor of the selection
// that can be joined, with the sibling after it.
function joinDown(state, dispatch) {
  var sel = state.selection, point;
  if (sel instanceof prosemirrorState.NodeSelection) {
    if (sel.node.isTextblock || !prosemirrorTransform.canJoin(state.doc, sel.to)) { return false }
    point = sel.to;
  } else {
    point = prosemirrorTransform.joinPoint(state.doc, sel.to, 1);
    if (point == null) { return false }
  }
  if (dispatch)
    { dispatch(state.tr.join(point).scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Lift the selected block, or the closest ancestor block of the
// selection that can be lifted, out of its parent node.
function lift(state, dispatch) {
  var ref = state.selection;
  var $from = ref.$from;
  var $to = ref.$to;
  var range = $from.blockRange($to), target = range && prosemirrorTransform.liftTarget(range);
  if (target == null) { return false }
  if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// If the selection is in a node whose type has a truthy
// [`code`](#model.NodeSpec.code) property in its spec, replace the
// selection with a newline character.
function newlineInCode(state, dispatch) {
  var ref = state.selection;
  var $head = ref.$head;
  var $anchor = ref.$anchor;
  if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) { return false }
  if (dispatch) { dispatch(state.tr.insertText("\n").scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// When the selection is in a node with a truthy
// [`code`](#model.NodeSpec.code) property in its spec, create a
// default block after the code block, and move the cursor there.
function exitCode(state, dispatch) {
  var ref = state.selection;
  var $head = ref.$head;
  var $anchor = ref.$anchor;
  if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) { return false }
  var above = $head.node(-1), after = $head.indexAfter(-1), type = above.contentMatchAt(after).defaultType;
  if (!above.canReplaceWith(after, after, type)) { return false }
  if (dispatch) {
    var pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
    tr.setSelection(prosemirrorState.Selection.near(tr.doc.resolve(pos), 1));
    dispatch(tr.scrollIntoView());
  }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// If a block node is selected, create an empty paragraph before (if
// it is its parent's first child) or after it.
function createParagraphNear(state, dispatch) {
  var ref = state.selection;
  var $from = ref.$from;
  var $to = ref.$to;
  if ($from.parent.inlineContent || $to.parent.inlineContent) { return false }
  var type = $from.parent.contentMatchAt($to.indexAfter()).defaultType;
  if (!type || !type.isTextblock) { return false }
  if (dispatch) {
    var side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
    var tr = state.tr.insert(side, type.createAndFill());
    tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, side + 1));
    dispatch(tr.scrollIntoView());
  }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// If the cursor is in an empty textblock that can be lifted, lift the
// block.
function liftEmptyBlock(state, dispatch) {
  var ref = state.selection;
  var $cursor = ref.$cursor;
  if (!$cursor || $cursor.parent.content.size) { return false }
  if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
    var before = $cursor.before();
    if (prosemirrorTransform.canSplit(state.doc, before)) {
      if (dispatch) { dispatch(state.tr.split(before).scrollIntoView()); }
      return true
    }
  }
  var range = $cursor.blockRange(), target = range && prosemirrorTransform.liftTarget(range);
  if (target == null) { return false }
  if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Split the parent block of the selection. If the selection is a text
// selection, also delete its content.
function splitBlock(state, dispatch) {
  var ref = state.selection;
  var $from = ref.$from;
  var $to = ref.$to;
  if (state.selection instanceof prosemirrorState.NodeSelection && state.selection.node.isBlock) {
    if (!$from.parentOffset || !prosemirrorTransform.canSplit(state.doc, $from.pos)) { return false }
    if (dispatch) { dispatch(state.tr.split($from.pos).scrollIntoView()); }
    return true
  }

  if (!$from.parent.isBlock) { return false }

  if (dispatch) {
    var atEnd = $to.parentOffset == $to.parent.content.size;
    var tr = state.tr;
    if (state.selection instanceof prosemirrorState.TextSelection) { tr.deleteSelection(); }
    var deflt = $from.depth == 0 ? null : $from.node(-1).contentMatchAt($from.indexAfter(-1)).defaultType;
    var types = atEnd && deflt ? [{type: deflt}] : null;
    var can = prosemirrorTransform.canSplit(tr.doc, $from.pos, 1, types);
    if (!types && !can && prosemirrorTransform.canSplit(tr.doc, tr.mapping.map($from.pos), 1, deflt && [{type: deflt}])) {
      types = [{type: deflt}];
      can = true;
    }
    if (can) {
      tr.split(tr.mapping.map($from.pos), 1, types);
      if (!atEnd && !$from.parentOffset && $from.parent.type != deflt &&
          $from.node(-1).canReplace($from.index(-1), $from.indexAfter(-1), prosemirrorModel.Fragment.from(deflt.create(), $from.parent)))
        { tr.setNodeMarkup(tr.mapping.map($from.before()), deflt); }
    }
    dispatch(tr.scrollIntoView());
  }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Acts like [`splitBlock`](#commands.splitBlock), but without
// resetting the set of active marks at the cursor.
function splitBlockKeepMarks(state, dispatch) {
  return splitBlock(state, dispatch && (function (tr) {
    var marks = state.storedMarks || (state.selection.$to.parentOffset && state.selection.$from.marks());
    if (marks) { tr.ensureMarks(marks); }
    dispatch(tr);
  }))
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Move the selection to the node wrapping the current selection, if
// any. (Will not select the document node.)
function selectParentNode(state, dispatch) {
  var ref = state.selection;
  var $from = ref.$from;
  var to = ref.to;
  var pos;
  var same = $from.sharedDepth(to);
  if (same == 0) { return false }
  pos = $from.before(same);
  if (dispatch) { dispatch(state.tr.setSelection(prosemirrorState.NodeSelection.create(state.doc, pos))); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// Select the whole document.
function selectAll(state, dispatch) {
  if (dispatch) { dispatch(state.tr.setSelection(new prosemirrorState.AllSelection(state.doc))); }
  return true
}

function joinMaybeClear(state, $pos, dispatch) {
  var before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
  if (!before || !after || !before.type.compatibleContent(after.type)) { return false }
  if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
    if (dispatch) { dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView()); }
    return true
  }
  if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || prosemirrorTransform.canJoin(state.doc, $pos.pos)))
    { return false }
  if (dispatch)
    { dispatch(state.tr
             .clearIncompatible($pos.pos, before.type, before.contentMatchAt(before.childCount))
             .join($pos.pos)
             .scrollIntoView()); }
  return true
}

function deleteBarrier(state, $cut, dispatch) {
  var before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
  if (before.type.spec.isolating || after.type.spec.isolating) { return false }
  if (joinMaybeClear(state, $cut, dispatch)) { return true }

  if ($cut.parent.canReplace($cut.index(), $cut.index() + 1) &&
      (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) &&
      match.matchType(conn[0] || after.type).validEnd) {
    if (dispatch) {
      var end = $cut.pos + after.nodeSize, wrap = prosemirrorModel.Fragment.empty;
      for (var i = conn.length - 1; i >= 0; i--)
        { wrap = prosemirrorModel.Fragment.from(conn[i].create(null, wrap)); }
      wrap = prosemirrorModel.Fragment.from(before.copy(wrap));
      var tr = state.tr.step(new prosemirrorTransform.ReplaceAroundStep($cut.pos - 1, end, $cut.pos, end, new prosemirrorModel.Slice(wrap, 1, 0), conn.length, true));
      var joinAt = end + 2 * conn.length;
      if (prosemirrorTransform.canJoin(tr.doc, joinAt)) { tr.join(joinAt); }
      dispatch(tr.scrollIntoView());
    }
    return true
  }

  var selAfter = prosemirrorState.Selection.findFrom($cut, 1);
  var range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && prosemirrorTransform.liftTarget(range);
  if (target != null && target >= $cut.depth) {
    if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
    return true
  }

  return false
}

// Parameterized commands

// :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Wrap the selection in a node of the given type with the given
// attributes.
function wrapIn(nodeType, attrs) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var range = $from.blockRange($to), wrapping = range && prosemirrorTransform.findWrapping(range, nodeType, attrs);
    if (!wrapping) { return false }
    if (dispatch) { dispatch(state.tr.wrap(range, wrapping).scrollIntoView()); }
    return true
  }
}

// :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Returns a command that tries to set the selected textblocks to the
// given node type with the given attributes.
function setBlockType(nodeType, attrs) {
  return function(state, dispatch) {
    var ref = state.selection;
    var from = ref.from;
    var to = ref.to;
    var applicable = false;
    state.doc.nodesBetween(from, to, function (node, pos) {
      if (applicable) { return false }
      if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) { return }
      if (node.type == nodeType) {
        applicable = true;
      } else {
        var $pos = state.doc.resolve(pos), index = $pos.index();
        applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
      }
    });
    if (!applicable) { return false }
    if (dispatch) { dispatch(state.tr.setBlockType(from, to, nodeType, attrs).scrollIntoView()); }
    return true
  }
}

function markApplies(doc, ranges, type) {
  var loop = function ( i ) {
    var ref = ranges[i];
    var $from = ref.$from;
    var $to = ref.$to;
    var can = $from.depth == 0 ? doc.type.allowsMarkType(type) : false;
    doc.nodesBetween($from.pos, $to.pos, function (node) {
      if (can) { return false }
      can = node.inlineContent && node.type.allowsMarkType(type);
    });
    if (can) { return { v: true } }
  };

  for (var i = 0; i < ranges.length; i++) {
    var returned = loop( i );

    if ( returned ) return returned.v;
  }
  return false
}

// :: (MarkType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Create a command function that toggles the given mark with the
// given attributes. Will return `false` when the current selection
// doesn't support that mark. This will remove the mark if any marks
// of that type exist in the selection, or add it otherwise. If the
// selection is empty, this applies to the [stored
// marks](#state.EditorState.storedMarks) instead of a range of the
// document.
function toggleMark(markType, attrs) {
  return function(state, dispatch) {
    var ref = state.selection;
    var empty = ref.empty;
    var $cursor = ref.$cursor;
    var ranges = ref.ranges;
    if ((empty && !$cursor) || !markApplies(state.doc, ranges, markType)) { return false }
    if (dispatch) {
      if ($cursor) {
        if (markType.isInSet(state.storedMarks || $cursor.marks()))
          { dispatch(state.tr.removeStoredMark(markType)); }
        else
          { dispatch(state.tr.addStoredMark(markType.create(attrs))); }
      } else {
        var has = false, tr = state.tr;
        for (var i = 0; !has && i < ranges.length; i++) {
          var ref$1 = ranges[i];
          var $from = ref$1.$from;
          var $to = ref$1.$to;
          has = state.doc.rangeHasMark($from.pos, $to.pos, markType);
        }
        for (var i$1 = 0; i$1 < ranges.length; i$1++) {
          var ref$2 = ranges[i$1];
          var $from$1 = ref$2.$from;
          var $to$1 = ref$2.$to;
          if (has) { tr.removeMark($from$1.pos, $to$1.pos, markType); }
          else { tr.addMark($from$1.pos, $to$1.pos, markType.create(attrs)); }
        }
        dispatch(tr.scrollIntoView());
      }
    }
    return true
  }
}

function wrapDispatchForJoin(dispatch, isJoinable) {
  return function (tr) {
    if (!tr.isGeneric) { return dispatch(tr) }

    var ranges = [];
    for (var i = 0; i < tr.mapping.maps.length; i++) {
      var map = tr.mapping.maps[i];
      for (var j = 0; j < ranges.length; j++)
        { ranges[j] = map.map(ranges[j]); }
      map.forEach(function (_s, _e, from, to) { return ranges.push(from, to); });
    }

    // Figure out which joinable points exist inside those ranges,
    // by checking all node boundaries in their parent nodes.
    var joinable = [];
    for (var i$1 = 0; i$1 < ranges.length; i$1 += 2) {
      var from = ranges[i$1], to = ranges[i$1 + 1];
      var $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
      for (var index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index) {
        var after = parent.maybeChild(index);
        if (!after) { break }
        if (index && joinable.indexOf(pos) == -1) {
          var before = parent.child(index - 1);
          if (before.type == after.type && isJoinable(before, after))
            { joinable.push(pos); }
        }
        pos += after.nodeSize;
      }
    }
    // Join the joinable points
    joinable.sort(function (a, b) { return a - b; });
    for (var i$2 = joinable.length - 1; i$2 >= 0; i$2--) {
      if (prosemirrorTransform.canJoin(tr.doc, joinable[i$2])) { tr.join(joinable[i$2]); }
    }
    dispatch(tr);
  }
}

// :: ((state: EditorState, ?(tr: Transaction)) → bool, union<(before: Node, after: Node) → bool, [string]>) → (state: EditorState, ?(tr: Transaction)) → bool
// Wrap a command so that, when it produces a transform that causes
// two joinable nodes to end up next to each other, those are joined.
// Nodes are considered joinable when they are of the same type and
// when the `isJoinable` predicate returns true for them or, if an
// array of strings was passed, if their node type name is in that
// array.
function autoJoin(command, isJoinable) {
  if (Array.isArray(isJoinable)) {
    var types = isJoinable;
    isJoinable = function (node) { return types.indexOf(node.type.name) > -1; };
  }
  return function (state, dispatch) { return command(state, dispatch && wrapDispatchForJoin(dispatch, isJoinable)); }
}

// :: (...[(EditorState, ?(tr: Transaction), ?EditorView) → bool]) → (EditorState, ?(tr: Transaction), ?EditorView) → bool
// Combine a number of command functions into a single function (which
// calls them one by one until one returns true).
function chainCommands() {
  var commands = [], len = arguments.length;
  while ( len-- ) commands[ len ] = arguments[ len ];

  return function(state, dispatch, view) {
    for (var i = 0; i < commands.length; i++)
      { if (commands[i](state, dispatch, view)) { return true } }
    return false
  }
}

var backspace = chainCommands(deleteSelection, joinBackward, selectNodeBackward);
var del = chainCommands(deleteSelection, joinForward, selectNodeForward);

// :: Object
// A basic keymap containing bindings not specific to any schema.
// Binds the following keys (when multiple commands are listed, they
// are chained with [`chainCommands`](#commands.chainCommands)):
//
// * **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
// * **Mod-Enter** to `exitCode`
// * **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
// * **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
// * **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
// * **Mod-a** to `selectAll`
var pcBaseKeymap = {
  "Enter": chainCommands(newlineInCode, createParagraphNear, liftEmptyBlock, splitBlock),
  "Mod-Enter": exitCode,
  "Backspace": backspace,
  "Mod-Backspace": backspace,
  "Delete": del,
  "Mod-Delete": del,
  "Mod-a": selectAll
};

// :: Object
// A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
// **Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
// **Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
// Ctrl-Delete.
var macBaseKeymap = {
  "Ctrl-h": pcBaseKeymap["Backspace"],
  "Alt-Backspace": pcBaseKeymap["Mod-Backspace"],
  "Ctrl-d": pcBaseKeymap["Delete"],
  "Ctrl-Alt-Backspace": pcBaseKeymap["Mod-Delete"],
  "Alt-Delete": pcBaseKeymap["Mod-Delete"],
  "Alt-d": pcBaseKeymap["Mod-Delete"]
};
for (var key in pcBaseKeymap) { macBaseKeymap[key] = pcBaseKeymap[key]; }

// declare global: os, navigator
var mac = typeof navigator != "undefined" ? /Mac/.test(navigator.platform)
          : typeof os != "undefined" ? os.platform() == "darwin" : false;

// :: Object
// Depending on the detected platform, this will hold
// [`pcBasekeymap`](#commands.pcBaseKeymap) or
// [`macBaseKeymap`](#commands.macBaseKeymap).
var baseKeymap = mac ? macBaseKeymap : pcBaseKeymap;

exports.deleteSelection = deleteSelection;
exports.joinBackward = joinBackward;
exports.selectNodeBackward = selectNodeBackward;
exports.joinForward = joinForward;
exports.selectNodeForward = selectNodeForward;
exports.joinUp = joinUp;
exports.joinDown = joinDown;
exports.lift = lift;
exports.newlineInCode = newlineInCode;
exports.exitCode = exitCode;
exports.createParagraphNear = createParagraphNear;
exports.liftEmptyBlock = liftEmptyBlock;
exports.splitBlock = splitBlock;
exports.splitBlockKeepMarks = splitBlockKeepMarks;
exports.selectParentNode = selectParentNode;
exports.selectAll = selectAll;
exports.wrapIn = wrapIn;
exports.setBlockType = setBlockType;
exports.toggleMark = toggleMark;
exports.autoJoin = autoJoin;
exports.chainCommands = chainCommands;
exports.pcBaseKeymap = pcBaseKeymap;
exports.macBaseKeymap = macBaseKeymap;
exports.baseKeymap = baseKeymap;
//# sourceMappingURL=commands.js.map


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorRemoveIcon = function EditorRemoveIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M7 7h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2zm2.78 11a1 1 0 0 1-.97-.757L7.156 10.62A.5.5 0 0 1 7.64 10h8.72a.5.5 0 0 1 .485.621l-1.656 6.622a1 1 0 0 1-.97.757H9.781zM11 6h2a1 1 0 0 1 1 1h-4a1 1 0 0 1 1-1z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorRemoveIcon.displayName = 'EditorRemoveIcon';
var _default = EditorRemoveIcon;
exports.default = _default;

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = commonMacro;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

function commonMacro(input, schema, opt) {
    /**
     * Forging the opening regex, the result would look something like
     * /^\{(quote)(?::([^\{\n\}]*))?\}/i
     */
    var opening = new RegExp("^{(" + opt.keyword + ")(?::([^{\n}]*))?}", 'i');
    var matchOpening = input.match(opening);
    if (!matchOpening) {
        return fallback(input);
    }
    var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](matchOpening, 3), name = _a[1], rawAttrs = _a[2];
    var openingLength = matchOpening[0].length;
    if (!opt.paired) {
        /**
         * Some macros do not have a closing symbol, for example
         * {anchor:here} {loremipsum}
         */
        return opt.rawContentProcessor(rawAttrs, '', openingLength, schema, opt.tokenErrCallback);
    }
    /**
     * Forging the closing regex, the result would look something like
     * /\{quote\}/
     */
    var closing = new RegExp("{" + name + "}");
    var matchClosing = closing.exec(input.substring(openingLength));
    var rawContent = '';
    if (matchClosing) {
        rawContent = input.substring(openingLength, openingLength + matchClosing.index);
    }
    var length = matchClosing
        ? openingLength + matchClosing.index + matchClosing[0].length
        : openingLength;
    return opt.rawContentProcessor(rawAttrs, rawContent, length, schema, opt.tokenErrCallback);
}
function fallback(input) {
    return {
        type: 'text',
        text: input.substr(0, 1),
        length: 1,
    };
}
//# sourceMappingURL=common-macro.js.map

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MentionType; });
/* harmony export (immutable) */ __webpack_exports__["c"] = isRestricted;
/* harmony export (immutable) */ __webpack_exports__["d"] = isSpecialMention;
/* harmony export (immutable) */ __webpack_exports__["b"] = isAppMention;
/* harmony export (immutable) */ __webpack_exports__["f"] = isTeamMention;
/* harmony export (immutable) */ __webpack_exports__["e"] = isSpecialMentionText;
var MentionType;
(function (MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
})(MentionType || (MentionType = {}));
var UserAccessLevel;
(function (UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
})(UserAccessLevel || (UserAccessLevel = {}));
var UserType;
(function (UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
})(UserType || (UserType = {}));
function isRestricted(accessLevel) {
    return (accessLevel && accessLevel !== UserAccessLevel[UserAccessLevel.CONTAINER]);
}
function isSpecialMention(mention) {
    return !!mention.userType && mention.userType === UserType[UserType.SPECIAL];
}
function isAppMention(mention) {
    return mention.userType && mention.userType === UserType[UserType.APP];
}
function isTeamMention(mention) {
    return mention.userType && mention.userType === UserType[UserType.TEAM];
}
function isSpecialMentionText(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
//# sourceMappingURL=types.js.map

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = c
c.displayName = 'c'
c.aliases = []
function c(Prism) {
  Prism.languages.c = Prism.languages.extend('clike', {
    keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|asm|typeof|inline|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|union|unsigned|void|volatile|while)\b/,
    operator: /-[>-]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/]/,
    number: /(?:\b0x[\da-f]+|(?:\b\d+\.?\d*|\B\.\d+)(?:e[+-]?\d+)?)[ful]*/i
  })
  Prism.languages.insertBefore('c', 'string', {
    macro: {
      // allow for multiline macro definitions
      // spaces after the # character compile fine with gcc
      pattern: /(^\s*)#\s*[a-z]+(?:[^\r\n\\]|\\(?:\r\n|[\s\S]))*/im,
      lookbehind: true,
      alias: 'property',
      inside: {
        // highlight the path of the include statement as a string
        string: {
          pattern: /(#\s*include\s*)(?:<.+?>|("|')(?:\\?.)+?\2)/,
          lookbehind: true
        },
        // highlight macro directives as keywords
        directive: {
          pattern: /(#\s*)\b(?:define|defined|elif|else|endif|error|ifdef|ifndef|if|import|include|line|pragma|undef|using)\b/,
          lookbehind: true,
          alias: 'keyword'
        }
      }
    },
    // highlight predefined macros as constants
    constant: /\b(?:__FILE__|__LINE__|__DATE__|__TIME__|__TIMESTAMP__|__func__|EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|stdin|stdout|stderr)\b/
  })
  delete Prism.languages.c['class-name']
  delete Prism.languages.c['boolean']
}


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setRequestType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setIssue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setIssueError; });
/* unused harmony export setEditComment */
/* unused harmony export setEditingComment */
/* unused harmony export setComment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return updateIssueData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearNewIssueKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearIssues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAllRequestTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getRequestType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAllUserIssues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getIssue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createIssue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return updateIssue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getIssueComments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return updateIssueComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addIssueComment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url_join__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_url_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_reducer__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_wikimarkup_transformer__ = __webpack_require__(302);
var setRequestType=Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* createAction */])('SET_REQUEST_TYPE');var setIssue=Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* createAction */])('SET_ISSUE');var setIssueError=Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* createAction */])('SET_ISSUE_ERROR');var setEditComment=Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* createAction */])('SET_EDIT_COMMENT');var setEditingComment=Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* createAction */])('SET_EDITING_COMMENT');var setComment=Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* createAction */])('SET_COMMENT');var updateIssueData=Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* createAction */])('UPDATE_ISSUE_DATA');var clearNewIssueKey=Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* createAction */])('CLEAR_NEW_ISSUE_KEY',{noPayload:true});var clearIssues=Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* createAction */])('CLEAR_ISSUES',{noPayload:true});var api=__WEBPACK_IMPORTED_MODULE_0_url_join___default.a.bind(null,__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].apiUrl);var transformer=new __WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_wikimarkup_transformer__["a" /* WikiMarkupTransformer */]();var getAllRequestTypes=Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* asyncAction */])({baseName:'REQUEST_TYPES_GET_ALL',action:function action(_action){return function(){return function(dispatch,getState){// Use cached version if already loaded
var requestTypes=getState().serviceDesk.get('requestTypes');if(requestTypes.size===0){dispatch(_action.start());return __WEBPACK_IMPORTED_MODULE_1__util__["d" /* http */].get(api('/ssp/requests')).then(function(searchResults){dispatch(_action.success(searchResults));}).catch(function(err){console.error('error getting Request Types api response',err);dispatch(_action.error(err));});}else{return Promise.resolve();}};};}});var getRequestType=Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* asyncAction */])({baseName:'REQUEST_TYPE_GET',action:function action(_action2){return function(requestTypeName){return function(dispatch){dispatch(_action2.start());return __WEBPACK_IMPORTED_MODULE_1__util__["d" /* http */].get(api('/ssp/requests/'+requestTypeName)).then(function(searchResults){dispatch(_action2.success(searchResults));}).catch(function(err){console.error('error getting Request Type api response',err);dispatch(_action2.error(err));});};};}});var getAllUserIssues=Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* asyncAction */])({baseName:'USER_ISSUES_GET_ALL',action:function action(_action3){return function(refresh,startAt){return function(dispatch,getState){var state=getState();var userIssues=state.serviceDesk.get('issues');if(userIssues.size===0||refresh||startAt>userIssues.length){var userInfo=Object(__WEBPACK_IMPORTED_MODULE_3__auth_reducer__["f" /* selectADUserInfo */])(state);var quarry='(assignee='+userInfo.username+' or reporter='+userInfo.username+' or "Requestor Email Address" ~ \''+userInfo.email+'\') and project=baat and type=request and "Request Type" is not Empty ORDER BY created DESC';dispatch(_action3.start());return __WEBPACK_IMPORTED_MODULE_1__util__["d" /* http */].get(api('/ssp/issues?query='+quarry+'&maxResults=10&startAt='+(startAt-1))).then(function(searchResults){dispatch(_action3.success({userIssues:userIssues,searchResults:searchResults,refresh:refresh}));}).catch(function(err){console.error('error getting User Issues api response',err);dispatch(_action3.error(err));});}else{return Promise.resolve();}};};}});var getIssue=Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* asyncAction */])({baseName:'ISSUE_GET',action:function action(_action4){return function(issueKey){return function(dispatch){dispatch(_action4.start());return __WEBPACK_IMPORTED_MODULE_1__util__["d" /* http */].get(api('/ssp/issues?key='+issueKey)).then(function(searchResults){dispatch(_action4.success(searchResults));}).catch(function(error){var message=error.message;if(message){dispatch(setIssueError(message));}console.error('error getting Issue api response',error);dispatch(_action4.error(error));});};};}});var createIssue=Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* asyncAction */])({baseName:'ISSUE_CREATE',action:function action(_action5){return function(formData,requestType){return function(dispatch,getState){formData=processWikiFields(formData,requestType);var issueCount=getState().serviceDesk.get('totalIssues');var issues=getState().serviceDesk.get('issues');dispatch(_action5.start(formData));return __WEBPACK_IMPORTED_MODULE_1__util__["d" /* http */].post(api('/ssp/issues'),formData).then(function(newIssue){dispatch(_action5.success({newIssue:newIssue,issues:issues,issueCount:issueCount}));}).then(function(){return dispatch(getAllUserIssues());}).catch(function(err){console.error('error with create issue api',err);dispatch(_action5.error(err));});};};}});var updateIssue=Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* asyncAction */])({baseName:'ISSUE_UPDATE',action:function action(_action6){return function(formData,issueKey){return function(dispatch,getState){formData=processWikiFields(formData,formData.requestType);var issues_list=getState().serviceDesk.get('issues');dispatch(_action6.start(formData));return __WEBPACK_IMPORTED_MODULE_1__util__["d" /* http */].put(api('/ssp/issues?key='+issueKey),formData).then(function(response){dispatch(_action6.success({response:response,issues_list:issues_list}));//dispatch(setIssue(formData))
}).catch(function(err){console.error('error with update issue api',err);dispatch(_action6.error(err));});};};}});var getIssueComments=Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* asyncAction */])({baseName:'COMMENTS_GET',action:function action(_action7){return function(issueKey){return function(dispatch,getState){var user=Object(__WEBPACK_IMPORTED_MODULE_3__auth_reducer__["f" /* selectADUserInfo */])(getState());var jiraUser=Object(__WEBPACK_IMPORTED_MODULE_3__auth_reducer__["h" /* selectJiraUser */])(getState());dispatch(_action7.start(issueKey));return __WEBPACK_IMPORTED_MODULE_1__util__["d" /* http */].get(api('/ssp/comments?key='+issueKey)).then(function(issueComments){dispatch(_action7.success({issueComments:issueComments,user:user,jiraUser:jiraUser}));}).catch(function(err){console.error('error with update issue api',err);dispatch(_action7.error(err));});};};}});var updateIssueComment=Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* asyncAction */])({baseName:'COMMENTS_UPDATE',action:function action(_action8){return function(issueKey,comment){return function(dispatch,getState){comment.body=encodeWikiFieldData(comment.body);var commentsList=getState().serviceDesk.get('issueComments');var requestor=Object(__WEBPACK_IMPORTED_MODULE_3__auth_reducer__["f" /* selectADUserInfo */])(getState());var jUser=Object(__WEBPACK_IMPORTED_MODULE_3__auth_reducer__["h" /* selectJiraUser */])(getState());dispatch(_action8.start(issueKey));return __WEBPACK_IMPORTED_MODULE_1__util__["d" /* http */].put(api('/ssp/comments?key='+issueKey+'&requestor='+requestor.displayName),comment).then(function(updatedComment){dispatch(_action8.success({updatedComment:updatedComment,commentsList:commentsList,requestor:requestor,jUser:jUser}));}).catch(function(err){console.error('error with update issue api',err);dispatch(_action8.error(err));});};};}});var addIssueComment=Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* asyncAction */])({baseName:'COMMENTS_ADD',action:function action(_action9){return function(issueKey,commentBody){return function(dispatch,getState){commentBody=encodeWikiFieldData(commentBody);var comments=getState().serviceDesk.get('issueComments');var commentAuthor=Object(__WEBPACK_IMPORTED_MODULE_3__auth_reducer__["f" /* selectADUserInfo */])(getState());var JiraUser=Object(__WEBPACK_IMPORTED_MODULE_3__auth_reducer__["h" /* selectJiraUser */])(getState());dispatch(_action9.start(issueKey));return __WEBPACK_IMPORTED_MODULE_1__util__["d" /* http */].post(api('/ssp/comments?key='+issueKey+'&requestor='+commentAuthor.displayName),commentBody).then(function(newComment){dispatch(_action9.success({newComment:newComment,comments:comments,commentAuthor:commentAuthor,JiraUser:JiraUser}));}).catch(function(err){console.error('error with update issue api',err);dispatch(_action9.error(err));});};};}});function processWikiFields(formData,requestType){requestType.inputs.properties.map(function(field){if(field.type=='wiki'||field.jiraFieldName=='description'){formData[field.id]=encodeWikiFieldData(formData[field.id]);}});return formData;}function encodeWikiFieldData(wikiData){return transformer.encode(wikiData);}

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__ = __webpack_require__(3216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getValue_js__ = __webpack_require__(3219);



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = Object(__WEBPACK_IMPORTED_MODULE_1__getValue_js__["a" /* default */])(object, key);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__["a" /* default */])(value) ? value : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (getNative);


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(362)('wks');
var uid = __webpack_require__(258);
var Symbol = __webpack_require__(110).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnalyticsDecorator__ = __webpack_require__(1795);
/* unused harmony reexport AnalyticsDecorator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnalyticsDelegate__ = __webpack_require__(1796);
/* unused harmony reexport AnalyticsDelegate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnalyticsListener__ = __webpack_require__(1797);
/* unused harmony reexport AnalyticsListener */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cleanProps__ = __webpack_require__(1798);
/* unused harmony reexport cleanProps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__withAnalytics__ = __webpack_require__(1799);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__withAnalytics__["a"]; });






/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setStylesTarget */
/* unused harmony export cssRaw */
/* unused harmony export cssRule */
/* unused harmony export forceRenderStyles */
/* unused harmony export fontFace */
/* unused harmony export getStyles */
/* unused harmony export keyframes */
/* unused harmony export reinit */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return style; });
/* unused harmony export stylesheet */
/* unused harmony export createTypeStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_typestyle__ = __webpack_require__(1790);
/* unused harmony reexport TypeStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(1792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);
/* unused harmony reexport types */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_utilities__ = __webpack_require__(669);
/* unused harmony reexport extend */
/* unused harmony reexport classes */
/* unused harmony reexport media */


/**
 * All the CSS types in the 'types' namespace
 */


/**
 * Export certain utilities
 */

/** Zero configuration, default instance of TypeStyle */
var ts = new __WEBPACK_IMPORTED_MODULE_0__internal_typestyle__["a" /* TypeStyle */]({ autoGenerateTag: true });
/** Sets the target tag where we write the css on style updates */
var setStylesTarget = ts.setStylesTarget;
/**
 * Insert `raw` CSS as a string. This is useful for e.g.
 * - third party CSS that you are customizing with template strings
 * - generating raw CSS in JavaScript
 * - reset libraries like normalize.css that you can use without loaders
 */
var cssRaw = ts.cssRaw;
/**
 * Takes CSSProperties and registers it to a global selector (body, html, etc.)
 */
var cssRule = ts.cssRule;
/**
 * Renders styles to the singleton tag imediately
 * NOTE: You should only call it on initial render to prevent any non CSS flash.
 * After that it is kept sync using `requestAnimationFrame` and we haven't noticed any bad flashes.
 **/
var forceRenderStyles = ts.forceRenderStyles;
/**
 * Utility function to register an @font-face
 */
var fontFace = ts.fontFace;
/**
 * Allows use to use the stylesheet in a node.js environment
 */
var getStyles = ts.getStyles;
/**
 * Takes keyframes and returns a generated animationName
 */
var keyframes = ts.keyframes;
/**
 * Helps with testing. Reinitializes FreeStyle + raw
 */
var reinit = ts.reinit;
/**
 * Takes CSSProperties and return a generated className you can use on your component
 */
var style = ts.style;
/**
 * Takes an object where property names are ideal class names and property values are CSSProperties, and
 * returns an object where property names are the same ideal class names and the property values are
 * the actual generated class names using the ideal class name as the $debugName
 */
var stylesheet = ts.stylesheet;
/**
 * Creates a new instance of TypeStyle separate from the default instance.
 *
 * - Use this for creating a different typestyle instance for a shadow dom component.
 * - Use this if you don't want an auto tag generated and you just want to collect the CSS.
 *
 * NOTE: styles aren't shared between different instances.
 */
function createTypeStyle(target) {
    var instance = new __WEBPACK_IMPORTED_MODULE_0__internal_typestyle__["a" /* TypeStyle */]({ autoGenerateTag: false });
    if (target) {
        instance.setStylesTarget(target);
    }
    return instance;
}


/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bigEmojiHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADFEncoder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getEventHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_editor_json_transformer__ = __webpack_require__(2965);


var bigEmojiHeight = 40;
function createEncoder(parser, encoder) {
    return function (value) { return encoder.encode(parser.parse(value)); };
}
var ADFEncoder = /** @class */ (function () {
    function ADFEncoder(createTransformerWithSchema) {
        var transformer = createTransformerWithSchema(__WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["x" /* defaultSchema */]);
        this.encode = createEncoder(transformer, new __WEBPACK_IMPORTED_MODULE_1__atlaskit_editor_json_transformer__["a" /* JSONTransformer */]());
    }
    return ADFEncoder;
}());

var getText = function (node) {
    return (node.text ||
        (node.attrs && (node.attrs.text || node.attrs.shortName)) ||
        "[" + (typeof node.type === 'string' ? node.type : node.type.name) + "]");
};
var getEventHandler = function (eventHandlers, type, eventName) {
    if (eventName === void 0) { eventName = 'onClick'; }
    return (eventHandlers &&
        type &&
        eventHandlers[type] &&
        eventHandlers[type][eventName]);
};
//# sourceMappingURL=utils.js.map

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(123);
var createDesc = __webpack_require__(257);
module.exports = __webpack_require__(124) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(606);
var defined = __webpack_require__(359);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ChevronDownIcon = function ChevronDownIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

ChevronDownIcon.displayName = 'ChevronDownIcon';
var _default = ChevronDownIcon;
exports.default = _default;

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(1431);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var encode = __webpack_require__(622);
var decode = __webpack_require__(623);

var C_BACKSLASH = 92;

var decodeHTML = __webpack_require__(624).decodeHTML;

var ENTITY = "&(?:#x[a-f0-9]{1,8}|#[0-9]{1,8}|[a-z][a-z0-9]{1,31});";

var TAGNAME = '[A-Za-z][A-Za-z0-9-]*';
var ATTRIBUTENAME = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
var UNQUOTEDVALUE = "[^\"'=<>`\\x00-\\x20]+";
var SINGLEQUOTEDVALUE = "'[^']*'";
var DOUBLEQUOTEDVALUE = '"[^"]*"';
var ATTRIBUTEVALUE = "(?:" + UNQUOTEDVALUE + "|" + SINGLEQUOTEDVALUE + "|" + DOUBLEQUOTEDVALUE + ")";
var ATTRIBUTEVALUESPEC = "(?:" + "\\s*=" + "\\s*" + ATTRIBUTEVALUE + ")";
var ATTRIBUTE = "(?:" + "\\s+" + ATTRIBUTENAME + ATTRIBUTEVALUESPEC + "?)";
var OPENTAG = "<" + TAGNAME + ATTRIBUTE + "*" + "\\s*/?>";
var CLOSETAG = "</" + TAGNAME + "\\s*[>]";
var HTMLCOMMENT = "<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->";
var PROCESSINGINSTRUCTION = "[<][?].*?[?][>]";
var DECLARATION = "<![A-Z]+" + "\\s+[^>]*>";
var CDATA = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>";
var HTMLTAG = "(?:" + OPENTAG + "|" + CLOSETAG + "|" + HTMLCOMMENT + "|" +
        PROCESSINGINSTRUCTION + "|" + DECLARATION + "|" + CDATA + ")";
var reHtmlTag = new RegExp('^' + HTMLTAG, 'i');

var reBackslashOrAmp = /[\\&]/;

var ESCAPABLE = '[!"#$%&\'()*+,./:;<=>?@[\\\\\\]^_`{|}~-]';

var reEntityOrEscapedChar = new RegExp('\\\\' + ESCAPABLE + '|' + ENTITY, 'gi');

var XMLSPECIAL = '[&<>"]';

var reXmlSpecial = new RegExp(XMLSPECIAL, 'g');

var reXmlSpecialOrEntity = new RegExp(ENTITY + '|' + XMLSPECIAL, 'gi');

var unescapeChar = function(s) {
    if (s.charCodeAt(0) === C_BACKSLASH) {
        return s.charAt(1);
    } else {
        return decodeHTML(s);
    }
};

// Replace entities and backslash escapes with literal characters.
var unescapeString = function(s) {
    if (reBackslashOrAmp.test(s)) {
        return s.replace(reEntityOrEscapedChar, unescapeChar);
    } else {
        return s;
    }
};

var normalizeURI = function(uri) {
    try {
        return encode(decode(uri));
    }
    catch(err) {
        return uri;
    }
};

var replaceUnsafeChar = function(s) {
    switch (s) {
    case '&':
        return '&amp;';
    case '<':
        return '&lt;';
    case '>':
        return '&gt;';
    case '"':
        return '&quot;';
    default:
        return s;
    }
};

var escapeXml = function(s, preserve_entities) {
    if (reXmlSpecial.test(s)) {
        if (preserve_entities) {
            return s.replace(reXmlSpecialOrEntity, replaceUnsafeChar);
        } else {
            return s.replace(reXmlSpecial, replaceUnsafeChar);
        }
    } else {
        return s;
    }
};

module.exports = { unescapeString: unescapeString,
                   normalizeURI: normalizeURI,
                   escapeXml: escapeXml,
                   reHtmlTag: reHtmlTag,
                   OPENTAG: OPENTAG,
                   CLOSETAG: CLOSETAG,
                   ENTITY: ENTITY,
                   ESCAPABLE: ESCAPABLE
                 };


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return R50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return R75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return R300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return R500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return Y50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return Y75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return Y400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return Y500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return G50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return G75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return G300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return G500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return B50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return B75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return B400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return N0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return N20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return N30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return N40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return N80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return N90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return P50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return P75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return P300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return P500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return T50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return T75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return T300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return T500; });
/* unused harmony export normalizeHexColor */
/* unused harmony export hexToRgb */
/* harmony export (immutable) */ __webpack_exports__["D"] = hexToRgba;
/* harmony export (immutable) */ __webpack_exports__["F"] = rgbToHex;
/* unused harmony export isRgb */
/* harmony export (immutable) */ __webpack_exports__["E"] = isHex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_css_color_names__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_css_color_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_css_color_names__);


/**
 * We're avoding importing these colors from @atlaskit/theme since we
 * do not want to have react as a dependency of this package.
 */
var R50 = '#FFEBE6';
var R75 = '#FFBDAD';
var R300 = '#FF5630';
var R500 = '#BF2600';
var Y50 = '#FFFAE6';
var Y75 = '#FFF0B3';
var Y400 = '#FF991F';
var Y500 = '#FF8B00';
var G50 = '#E3FCEF';
var G75 = '#ABF5D1';
var G300 = '#36B37E';
var G500 = '#006644';
var B50 = '#DEEBFF';
var B75 = '#B3D4FF';
var B400 = '#0052CC';
var N0 = '#FFFFFF';
var N20 = '#F4F5F7';
var N30 = '#EBECF0';
var N40 = '#DFE1E6';
var N80 = '#97A0AF';
var N90 = '#8993A4';
var P50 = '#EAE6FF';
var P75 = '#C0B6F2';
var P300 = '#6554C0';
var P500 = '#403294';
var T50 = '#E6FCFF';
var T75 = '#B3F5FF';
var T300 = '#00B8D9';
var T500 = '#008DA6';
/**
 * @return String with HEX-coded color
 */
function normalizeHexColor(color, defaultColor) {
    if (!color) {
        return null;
    }
    // Normalize to hex
    color = color.trim().toLowerCase();
    if (isHex(color)) {
        // Normalize 3-hex to 6-hex colours
        if (color.length === 4) {
            color = color
                .split('')
                .map(function (c) { return (c === '#' ? '#' : "" + c + c); })
                .join('');
        }
    }
    else if (isRgb(color)) {
        return rgbToHex(color);
    }
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (__WEBPACK_IMPORTED_MODULE_1_css_color_names__["default"] && __WEBPACK_IMPORTED_MODULE_1_css_color_names__["default"][color]) {
            color = __WEBPACK_IMPORTED_MODULE_1_css_color_names__["default"][color];
        }
        else if (__WEBPACK_IMPORTED_MODULE_1_css_color_names__ && __WEBPACK_IMPORTED_MODULE_1_css_color_names__[color]) {
            color = __WEBPACK_IMPORTED_MODULE_1_css_color_names__[color];
        }
        else {
            return null;
        }
    }
    if (color === defaultColor) {
        return null;
    }
    return color;
}
/**
 * Converts hex color format to rgb.
 * Works well with full hex color format and shortcut as well.
 *
 * @param hex - hex color string (#xxx, or #xxxxxx)
 */
function hexToRgb(color) {
    if (!isHex(color)) {
        return null;
    }
    var colorBits = color.substring(1).split('');
    if (colorBits.length === 3) {
        colorBits = [
            colorBits[0],
            colorBits[0],
            colorBits[1],
            colorBits[1],
            colorBits[2],
            colorBits[2],
        ];
    }
    var rgb = Number("0x" + colorBits.join(''));
    // tslint:disable-next-line:no-bitwise
    return "rgb(" + ((rgb >> 16) & 255) + "," + ((rgb >> 8) & 255) + "," + (rgb & 255) + ")";
}
/**
 * Converts hex color format to rgba.
 *
 * @param hex - hex color string (#xxx, or #xxxxxx)
 */
function hexToRgba(rawColor, alpha) {
    var color = normalizeHexColor(rawColor);
    if (!color) {
        return null;
    }
    var hex2rgb = function (color) {
        return color.match(/[a-z0-9]{2}/gi).map(function (hex) { return parseInt(hex, 16); });
    };
    return "rgba(" + hex2rgb(color)
        .concat(alpha)
        .join(',') + ")";
}
function rgbToHex(value) {
    var matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](matches.map(Number), 3), red = _a[0], green = _a[1], blue = _a[2];
        return ('#' +
            (blue | (green << 8) | (red << 16) | (1 << 24)).toString(16).slice(1) // tslint:disable-line:no-bitwise
        );
    }
    return null;
}
function isRgb(color) {
    return /rgba?\(/.test(color);
}
function isHex(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}
//# sourceMappingURL=colors.js.map

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export akEditorCodeFontFamily */
/* unused harmony export akEditorInactiveForeground */
/* unused harmony export akEditorFocus */
/* unused harmony export akEditorSubtleAccent */
/* unused harmony export akEditorActiveBackground */
/* unused harmony export akEditorActiveForeground */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return akEditorBlockquoteBorderColor; });
/* unused harmony export akEditorDropdownActiveBackground */
/* unused harmony export akEditorPopupBackground */
/* unused harmony export akEditorPopupText */
/* unused harmony export akEditorPrimaryButton */
/* unused harmony export akEditorCodeBackground */
/* unused harmony export akEditorCodeBlockPadding */
/* unused harmony export akEditorCodeInlinePadding */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return akEditorUnitZIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return akEditorSmallZIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return akEditorGridLineZIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return akEditorMenuZIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return akEditorFloatingPanelZIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return akEditorFloatingDialogZIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return akEditorFloatingOverlapPanelZIndex; });
/* unused harmony export akEditorMentionSelected */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return akEditorTableToolbarSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return akEditorTableBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return akEditorTableToolbar; });
/* unused harmony export akEditorTableFloatingControls */
/* unused harmony export akEditorTableCellSelected */
/* unused harmony export akEditorTableToolbarSelected */
/* unused harmony export akEditorTableBorderSelected */
/* unused harmony export akEditorTableCellDelete */
/* unused harmony export akEditorTableBorderDelete */
/* unused harmony export akEditorTableToolbarDelete */
/* unused harmony export akEditorTableBorderRadius */
/* unused harmony export akEditorTableCellBackgroundOpacity */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return akEditorFullPageMaxWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return akEditorDefaultLayoutWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return akEditorWideLayoutWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return akEditorTableNumberColumnWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return akEditorBreakoutPadding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return akEditorMobileBreakoutPoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return akEditorTableCellMinWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return gridMediumMaxWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return breakoutWideScaleRatio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return editorFontSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return relativeSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return blockNodesVerticalMargin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);

var B100 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100, B300 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B300, B400 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400, B50 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B50, B75 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75, N0 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0, N20 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, N40 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N40, N50 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N50, N100 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N100, N500 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N500, N700 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, N900 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N900, R300 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R300, R50 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R50, R75 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R75;
var akEditorCodeFontFamily = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["codeFontFamily"])();
var akEditorInactiveForeground = N500;
var akEditorFocus = B100;
var akEditorSubtleAccent = N40;
var akEditorActiveBackground = N500;
var akEditorActiveForeground = N0;
var akEditorBlockquoteBorderColor = N40;
var akEditorDropdownActiveBackground = N900;
var akEditorPopupBackground = N700;
var akEditorPopupText = B50;
var akEditorPrimaryButton = B400;
var akEditorCodeBackground = N20;
var akEditorCodeBlockPadding = '12px';
var akEditorCodeInlinePadding = '2px 4px';
var akEditorUnitZIndex = 1;
var akEditorSmallZIndex = 2;
var akEditorGridLineZIndex = 9999;
// z-index for main menu bar -
// this is highest as it should be above anything else in editor below.
var akEditorMenuZIndex = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["layers"].blanket();
// z-index used for floating toolbars like code block, table etc
var akEditorFloatingPanelZIndex = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["layers"].layer();
// z-index used for pickers (date, emoji, mentions) and type-aheads, hyperlinks
var akEditorFloatingDialogZIndex = akEditorFloatingPanelZIndex + 10;
// z-index used for floating toolbars table cell menu which are above block toolbars
var akEditorFloatingOverlapPanelZIndex = akEditorFloatingPanelZIndex + 5;
var akEditorMentionSelected = N100;
var akEditorTableToolbarSize = 11;
var akEditorTableBorder = N50;
var akEditorTableToolbar = N20;
var akEditorTableFloatingControls = N20;
var akEditorTableCellSelected = B75;
var akEditorTableToolbarSelected = B100;
var akEditorTableBorderSelected = B300;
var akEditorTableCellDelete = R50;
var akEditorTableBorderDelete = R300;
var akEditorTableToolbarDelete = R75;
var akEditorTableBorderRadius = '3px';
var akEditorTableCellBackgroundOpacity = 0.5;
var akEditorFullPageMaxWidth = 680;
var akEditorDefaultLayoutWidth = 680;
var akEditorWideLayoutWidth = 960;
var akEditorTableNumberColumnWidth = 42;
var akEditorBreakoutPadding = 96;
var akEditorMobileBreakoutPoint = 720;
var akEditorTableCellMinWidth = 48;
var gridMediumMaxWidth = 1024;
var breakoutWideScaleRatio = 1.33;
var editorFontSize = function (_a) {
    var theme = _a.theme;
    return theme && theme.baseFontSize ? theme.baseFontSize : Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["fontSize"])();
};
var relativeSize = function (multiplier) { return function (_a) {
    var theme = _a.theme;
    return editorFontSize({ theme: theme }) * multiplier;
}; };
// @see typography spreadsheet: https://docs.google.com/spreadsheets/d/1iYusRGCT4PoPfvxbJ8NrgjtfFgXLm5lpDWXzjua1W2E/edit#gid=93913128
var blockNodesVerticalMargin = '1.142em';
//# sourceMappingURL=consts.js.map

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_util_service_support__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Emoji__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_EmojiPlaceholder__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_ResourcedEmoji__ = __webpack_require__(1793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_picker_EmojiPicker__ = __webpack_require__(1794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_typeahead_EmojiTypeAhead__ = __webpack_require__(1892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_EmojiResource__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_EmojiRepository__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_EmojiLoader__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_EmojiUtils__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__type_helpers__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_internal_UsageFrequencyTracker__ = __webpack_require__(676);
/* unused harmony reexport AbstractResource */
/* unused harmony reexport Emoji */
/* unused harmony reexport EmojiPlaceholder */
/* unused harmony reexport EmojiLoader */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__components_picker_EmojiPicker__["a"]; });
/* unused harmony reexport EmojiResource */
/* unused harmony reexport EmojiRepository */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__components_typeahead_EmojiTypeAhead__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__components_common_ResourcedEmoji__["a"]; });
/* unused harmony reexport denormaliseEmojiServiceResponse */
/* unused harmony reexport toEmojiId */
/* unused harmony reexport toOptionalEmojiId */
/* unused harmony reexport emojiPickerWidth */
/* unused harmony reexport emojiPickerHeight */
/* unused harmony reexport defaultEmojiHeight */
/* unused harmony reexport customCategory */
/* unused harmony reexport UsageFrequencyTracker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types__ = __webpack_require__(538);
/* unused harmony namespace reexport */















/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_4__components_picker_EmojiPicker__["a" /* default */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray_1 = __webpack_require__(682);
var isObject_1 = __webpack_require__(683);
var isFunction_1 = __webpack_require__(681);
var tryCatch_1 = __webpack_require__(1846);
var errorObject_1 = __webpack_require__(684);
var UnsubscriptionError_1 = __webpack_require__(1847);
/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */
var Subscription = (function () {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */
    function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */
        this.closed = false;
        this._parent = null;
        this._parents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._unsubscribe = unsubscribe;
        }
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */
    Subscription.prototype.unsubscribe = function () {
        var hasErrors = false;
        var errors;
        if (this.closed) {
            return;
        }
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        // null out _subscriptions first so any child subscriptions that attempt
        // to remove themselves from this subscription will noop
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        // if this._parent is null, then so is this._parents, and we
        // don't have to remove ourselves from any parent subscriptions.
        while (_parent) {
            _parent.remove(this);
            // if this._parents is null or index >= len,
            // then _parent is set to null, and the loop exits
            _parent = ++index < len && _parents[index] || null;
        }
        if (isFunction_1.isFunction(_unsubscribe)) {
            var trial = tryCatch_1.tryCatch(_unsubscribe).call(this);
            if (trial === errorObject_1.errorObject) {
                hasErrors = true;
                errors = errors || (errorObject_1.errorObject.e instanceof UnsubscriptionError_1.UnsubscriptionError ?
                    flattenUnsubscriptionErrors(errorObject_1.errorObject.e.errors) : [errorObject_1.errorObject.e]);
            }
        }
        if (isArray_1.isArray(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while (++index < len) {
                var sub = _subscriptions[index];
                if (isObject_1.isObject(sub)) {
                    var trial = tryCatch_1.tryCatch(sub.unsubscribe).call(sub);
                    if (trial === errorObject_1.errorObject) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = errorObject_1.errorObject.e;
                        if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
                            errors = errors.concat(flattenUnsubscriptionErrors(err.errors));
                        }
                        else {
                            errors.push(err);
                        }
                    }
                }
            }
        }
        if (hasErrors) {
            throw new UnsubscriptionError_1.UnsubscriptionError(errors);
        }
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */
    Subscription.prototype.add = function (teardown) {
        if (!teardown || (teardown === Subscription.EMPTY)) {
            return Subscription.EMPTY;
        }
        if (teardown === this) {
            return this;
        }
        var subscription = teardown;
        switch (typeof teardown) {
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription.closed || typeof subscription.unsubscribe !== 'function') {
                    return subscription;
                }
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                }
                else if (typeof subscription._addParent !== 'function' /* quack quack */) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [tmp];
                }
                break;
            default:
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */
    Subscription.prototype.remove = function (subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
            }
        }
    };
    Subscription.prototype._addParent = function (parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) {
            // If we don't have a parent, or the new parent is the same as the
            // current parent, then set this._parent to the new parent.
            this._parent = parent;
        }
        else if (!_parents) {
            // If there's already one parent, but not multiple, allocate an Array to
            // store the rest of the parent Subscriptions.
            this._parents = [parent];
        }
        else if (_parents.indexOf(parent) === -1) {
            // Only add the new parent to the _parents list if it's not already there.
            _parents.push(parent);
        }
    };
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    }(new Subscription()));
    return Subscription;
}());
exports.Subscription = Subscription;
function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError_1.UnsubscriptionError) ? err.errors : err); }, []);
}
//# sourceMappingURL=Subscription.js.map

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_MentionResource__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_PresenceResource__ = __webpack_require__(1899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MentionItem__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MentionList__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ResourcedMentionList__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MentionPicker__ = __webpack_require__(1926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Mention__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Mention_ResourcedMention__ = __webpack_require__(1931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_searchIndex__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_ContextMentionResource__ = __webpack_require__(1932);
/* unused harmony reexport ContextMentionResource */
/* unused harmony reexport MentionResource */
/* unused harmony reexport PresenceResource */
/* unused harmony reexport AbstractMentionResource */
/* unused harmony reexport AbstractPresenceResource */
/* unused harmony reexport SearchIndex */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__components_MentionItem__["a"]; });
/* unused harmony reexport MentionList */
/* unused harmony reexport ResourcedMentionList */
/* unused harmony reexport MentionPicker */
/* unused harmony reexport Mention */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__components_Mention_ResourcedMention__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_8__types__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_10__constants__["a"]; });













/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_5__components_MentionPicker__["a" /* MentionPickerWithAnalytics */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(54);

var _interopRequireDefault = __webpack_require__(53);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.size = exports.default = exports.IconWrapper = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(4));

var _createClass2 = _interopRequireDefault(__webpack_require__(5));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(7));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(6));

var _inherits2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _styledComponents = _interopRequireDefault(__webpack_require__(2));

var _uuid = _interopRequireDefault(__webpack_require__(22));

var _theme = __webpack_require__(3);

var _constants = __webpack_require__(1937);

var getSize = function getSize(props) {
  if (props.size) {
    return "height: ".concat(_constants.sizes[props.size], "; width: ").concat(_constants.sizes[props.size], ";");
  }

  return null;
};

var IconWrapper = _styledComponents.default.span.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "dyhwwi-0"
})(["\n  ", " color: ", ";\n  display: inline-block;\n  fill: ", ";\n  flex-shrink: 0;\n  line-height: 1;\n\n  > svg {\n    ", " max-height: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    pointer-events: none;\n    vertical-align: bottom;\n  }\n  /* Stop-color doesn't properly apply in chrome when the inherited/current color changes.\n   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS\n   * rule) and then override it with currentColor for the color changes to be picked up.\n   */\n  stop {\n    stop-color: currentColor;\n  }\n"], getSize, function (p) {
  return p.primaryColor || 'currentColor';
}, function (p) {
  return p.secondaryColor || _theme.colors.background;
}, getSize);

exports.IconWrapper = IconWrapper;

var Icon =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Icon, _Component);

  function Icon() {
    (0, _classCallCheck2.default)(this, Icon);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Icon).apply(this, arguments));
  }

  (0, _createClass2.default)(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Glyph = _this$props.glyph,
          dangerouslySetGlyph = _this$props.dangerouslySetGlyph,
          onClick = _this$props.onClick,
          primaryColor = _this$props.primaryColor,
          secondaryColor = _this$props.secondaryColor,
          size = _this$props.size; // handling the glyphs as strings

      if (dangerouslySetGlyph) {
        return _react.default.createElement(IconWrapper, {
          onClick: onClick,
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          size: size,
          "aria-label": this.props.label,
          dangerouslySetInnerHTML: {
            __html: Icon.insertDynamicGradientID(dangerouslySetGlyph)
          }
        });
      } // handling the glyphs when passed through as functions


      return _react.default.createElement(IconWrapper, {
        onClick: onClick,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        "aria-label": this.props.label
      }, Glyph ? _react.default.createElement(Glyph, {
        role: "presentation"
      }) : null);
    }
  }], [{
    key: "insertDynamicGradientID",

    /* Icons need unique gradient IDs across instances for different gradient definitions to work
     * correctly.
     * A step in the icon build process replaces linear gradient IDs and their references in paths
     * to a placeholder string so we can replace them with a dynamic ID here.
     * Replacing the original IDs with placeholders in the build process is more robust than not
     * using placeholders as we do not have to rely on regular expressions to find specific element
     * to replace.
     */
    value: function insertDynamicGradientID(svgStr) {
      var id = (0, _uuid.default)();
      var replacedSvgStr = svgStr.replace(/id="([^"]+)-idPlaceholder"/g, "id=$1-".concat(id)).replace(/fill="url\(#([^"]+)-idPlaceholder\)"/g, "fill=\"url(#$1-".concat(id, ")\""));
      return replacedSvgStr;
    }
  }]);
  return Icon;
}(_react.Component);

exports.default = Icon;
(0, _defineProperty2.default)(Icon, "defaultProps", {
  onClick: function onClick() {}
});
var size = Object.keys(_constants.sizes).reduce(function (p, c) {
  return Object.assign(p, (0, _defineProperty2.default)({}, c, c));
}, {});
exports.size = size;

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return arrayFind; });
var toArray = function toArray(a) {
  var ret = Array(a.length);
  for (var i = 0; i < a.length; ++i) {
    ret[i] = a[i];
  }
  return ret;
};

var arrayFind = function arrayFind(array, search) {
  return array.filter(function (a) {
    return a === search;
  })[0];
};

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var ReactNodeView = /** @class */ (function () {
    function ReactNodeView(node, view, getPos, portalProviderAPI, reactComponentProps, reactComponent, hasContext) {
        if (reactComponentProps === void 0) { reactComponentProps = {}; }
        if (hasContext === void 0) { hasContext = false; }
        var _this = this;
        this.reactComponentProps = {};
        this.handleRef = function (node) { return _this._handleRef(node); };
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.portalProviderAPI = portalProviderAPI;
        this.reactComponentProps = reactComponentProps;
        this.reactComponent = reactComponent;
        this.hasContext = hasContext;
    }
    /**
     * This method exists to move initialization logic out of the constructor,
     * so object can be initialized properly before calling render first time.
     *
     * Example:
     * Instance properties get added to an object only after super call in
     * constructor, which leads to some methods being undefined during the
     * first render.
     */
    ReactNodeView.prototype.init = function () {
        var _this = this;
        this.domRef = this.createDomRef();
        this.setDomAttrs(this.node, this.domRef);
        var _a = this.getContentDOM() || {
            dom: undefined,
            contentDOM: undefined,
        }, contentDOMWrapper = _a.dom, contentDOM = _a.contentDOM;
        if (this.domRef && contentDOMWrapper) {
            this.domRef.appendChild(contentDOMWrapper);
            this.contentDOM = contentDOM ? contentDOM : contentDOMWrapper;
            this.contentDOMWrapper = contentDOMWrapper || contentDOM;
        }
        // @see ED-3790
        // something gets messed up during mutation processing inside of a
        // nodeView if DOM structure has nested plain "div"s, it doesn't see the
        // difference between them and it kills the nodeView
        this.domRef.className = this.node.type.name + "View-content-wrap";
        this.renderReactComponent(function () {
            return _this.render(_this.reactComponentProps, _this.handleRef);
        });
        return this;
    };
    ReactNodeView.prototype.renderReactComponent = function (component) {
        if (!this.domRef || !component) {
            return;
        }
        this.portalProviderAPI.render(component, this.domRef, this.hasContext);
    };
    ReactNodeView.prototype.createDomRef = function () {
        return this.node.isInline
            ? document.createElement('span')
            : document.createElement('div');
    };
    ReactNodeView.prototype.getContentDOM = function () {
        return undefined;
    };
    ReactNodeView.prototype._handleRef = function (node) {
        var contentDOM = this.contentDOMWrapper || this.contentDOM;
        // move the contentDOM node inside the inner reference after rendering
        if (node && contentDOM && !node.contains(contentDOM)) {
            node.appendChild(contentDOM);
        }
    };
    ReactNodeView.prototype.render = function (props, forwardRef) {
        return this.reactComponent ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](this.reactComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ view: this.view, getPos: this.getPos, node: this.node, forwardRef: forwardRef }, props))) : null;
    };
    ReactNodeView.prototype.update = function (node, decorations, validUpdate) {
        var _this = this;
        if (validUpdate === void 0) { validUpdate = function () { return true; }; }
        // @see https://github.com/ProseMirror/prosemirror/issues/648
        var isValidUpdate = this.node.type === node.type && validUpdate(this.node, node);
        if (!isValidUpdate) {
            return false;
        }
        if (this.domRef && !this.node.sameMarkup(node)) {
            this.setDomAttrs(node, this.domRef);
        }
        this.node = node;
        this.renderReactComponent(function () {
            return _this.render(_this.reactComponentProps, _this.handleRef);
        });
        return true;
    };
    /**
     * Copies the attributes from a ProseMirror Node to a DOM node.
     * @param node The Prosemirror Node from which to source the attributes
     */
    ReactNodeView.prototype.setDomAttrs = function (node, element) {
        Object.keys(node.attrs || {}).forEach(function (attr) {
            element.setAttribute(attr, node.attrs[attr]);
        });
    };
    Object.defineProperty(ReactNodeView.prototype, "dom", {
        get: function () {
            return this.domRef;
        },
        enumerable: true,
        configurable: true
    });
    ReactNodeView.prototype.destroy = function () {
        if (!this.domRef) {
            return;
        }
        this.portalProviderAPI.remove(this.domRef);
        this.domRef = undefined;
        this.contentDOM = undefined;
    };
    ReactNodeView.fromComponent = function (component, portalProviderAPI, props) {
        return function (node, view, getPos) {
            return new ReactNodeView(node, view, getPos, portalProviderAPI, props, component).init();
        };
    };
    return ReactNodeView;
}());
/* harmony default export */ __webpack_exports__["a"] = (ReactNodeView);
//# sourceMappingURL=ReactNodeView.js.map

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return insertTaskDecision; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isSupportedSourceNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeInDepth; });
/* unused harmony export createListAtSelection */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return splitListAtSelection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gap_cursor__ = __webpack_require__(213);




var getListTypes = function (listType, schema) {
    var _a = schema.nodes, decisionList = _a.decisionList, decisionItem = _a.decisionItem, taskList = _a.taskList, taskItem = _a.taskItem;
    if (listType === 'taskList') {
        return {
            list: taskList,
            item: taskItem,
        };
    }
    return {
        list: decisionList,
        item: decisionItem,
    };
};
var insertTaskDecision = function (view, listType) {
    var state = view.state;
    var schema = state.schema;
    var _a = getListTypes(listType, schema), list = _a.list, item = _a.item;
    var tr = state.tr;
    var $to = state.selection.$to;
    if (!Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["findParentNodeOfType"])(list)(state.selection)) {
        // Not a list - convert to one.
        var created = createListAtSelection(tr, list, item, schema, state);
        view.dispatch(tr);
        return created;
    }
    else if ($to.node().textContent.length > 0) {
        var pos = $to.end($to.depth);
        tr.split(pos, 1, [{ type: item, attrs: { localId: __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["_26" /* uuid */].generate() } }]);
        tr.setSelection(new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["TextSelection"](tr.doc.resolve(pos + $to.depth)));
        view.dispatch(tr);
        return true;
    }
    return false;
};
var isSupportedSourceNode = function (schema, selection) {
    var _a = schema.nodes, paragraph = _a.paragraph, blockquote = _a.blockquote, decisionList = _a.decisionList, taskList = _a.taskList;
    return Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["hasParentNodeOfType"])([blockquote, paragraph, decisionList, taskList])(selection);
};
var changeInDepth = function (before, after) {
    return after.depth - before.depth;
};
var createListAtSelection = function (tr, list, item, schema, state) {
    var selection = state.selection;
    var $from = selection.$from, $to = selection.$to;
    if ($from.parent !== $to.parent) {
        // ignore selections across multiple nodes
        return false;
    }
    var _a = schema.nodes, paragraph = _a.paragraph, blockquote = _a.blockquote, decisionList = _a.decisionList, taskList = _a.taskList, mediaGroup = _a.mediaGroup;
    if ($from.parent.type === mediaGroup) {
        return false;
    }
    var emptyList = list.create({ localId: __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["_26" /* uuid */].generate() }, [
        item.create({ localId: __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["_26" /* uuid */].generate() }),
    ]);
    // we don't take the content of a block node next to the gap cursor and always create an empty task
    if (selection instanceof __WEBPACK_IMPORTED_MODULE_3__gap_cursor__["a" /* GapCursorSelection */]) {
        Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["safeInsert"])(emptyList)(tr);
        return true;
    }
    // try to replace any of the given nodeTypes
    if (isSupportedSourceNode(schema, selection)) {
        var newTr = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["replaceParentNodeOfType"])([blockquote, paragraph, decisionList, taskList], list.create({ localId: __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["_26" /* uuid */].generate() }, [
            item.create({ localId: __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["_26" /* uuid */].generate() }, $from.node($from.depth).content),
        ]))(tr);
        // Adjust depth for new selection, if it has changed (e.g. paragraph to list (ol > li))
        var depthAdjustment = changeInDepth($to, newTr.selection.$to);
        tr = tr.setSelection(new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["TextSelection"](tr.doc.resolve($to.pos + depthAdjustment)));
        // replacing successful
        if (newTr !== tr) {
            return true;
        }
    }
    Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["safeInsert"])(emptyList)(tr);
    return true;
};
var splitListAtSelection = function (tr, schema) {
    var selection = tr.selection;
    var $from = selection.$from, $to = selection.$to;
    if ($from.parent !== $to.parent) {
        // ignore selections across multiple nodes
        return tr;
    }
    var _a = schema.nodes, decisionItem = _a.decisionItem, decisionList = _a.decisionList, paragraph = _a.paragraph, taskItem = _a.taskItem, taskList = _a.taskList;
    var parentList = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["findParentNodeOfType"])([decisionList, taskList])(selection);
    if (!parentList) {
        return tr;
    }
    var item = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["findParentNodeOfType"])([decisionItem, taskItem])(selection);
    if (!item) {
        return tr;
    }
    var resolvedItemPos = tr.doc.resolve(item.pos);
    var newListIds = [
        parentList.node.attrs['localId'] || __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["_26" /* uuid */].generate(),
        __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["_26" /* uuid */].generate(),
    ];
    var beforeItems = [];
    var afterItems = [];
    parentList.node.content.forEach(function (item, offset, index) {
        if (offset < resolvedItemPos.parentOffset) {
            beforeItems.push(item);
        }
        else if (offset > resolvedItemPos.parentOffset) {
            afterItems.push(item);
        }
    });
    var content = [];
    if (beforeItems.length) {
        content.push(parentList.node.type.createChecked({
            localId: newListIds.shift(),
        }, beforeItems));
    }
    content.push(paragraph.createChecked({}, item.node.content));
    if (afterItems.length) {
        content.push(parentList.node.type.createChecked({
            localId: newListIds.shift(),
        }, afterItems));
    }
    // If no list remains at start, then the new selection is different relative to the original selection.
    var posAdjust = beforeItems.length === 0 ? -1 : 1;
    tr = tr.replaceWith(resolvedItemPos.start() - 1, resolvedItemPos.end() + 1, content);
    tr = tr.setSelection(new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["TextSelection"](tr.doc.resolve($from.pos + posAdjust)));
    return tr;
};
//# sourceMappingURL=commands.js.map

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LinkAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InsertStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return canLinkBeCreatedInRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stateKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return plugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(21);



var LinkAction;
(function (LinkAction) {
    LinkAction["SHOW_INSERT_TOOLBAR"] = "SHOW_INSERT_TOOLBAR";
    LinkAction["HIDE_TOOLBAR"] = "HIDE_TOOLBAR";
    LinkAction["SELECTION_CHANGE"] = "SELECTION_CHANGE";
})(LinkAction || (LinkAction = {}));
var InsertStatus;
(function (InsertStatus) {
    InsertStatus["EDIT_LINK_TOOLBAR"] = "EDIT";
    InsertStatus["INSERT_LINK_TOOLBAR"] = "INSERT";
})(InsertStatus || (InsertStatus = {}));
var canLinkBeCreatedInRange = function (from, to) { return function (state) {
    if (!state.doc.rangeHasMark(from, to, state.schema.marks.link)) {
        var $from = state.doc.resolve(from);
        var $to = state.doc.resolve(to);
        var link_1 = state.schema.marks.link;
        if ($from.parent === $to.parent && $from.parent.isTextblock) {
            if ($from.parent.type.allowsMarkType(link_1)) {
                var allowed_1 = true;
                state.doc.nodesBetween(from, to, function (node) {
                    allowed_1 = allowed_1 && !node.marks.some(function (m) { return m.type.excludes(link_1); });
                    return allowed_1;
                });
                return allowed_1;
            }
        }
    }
    return false;
}; };
var isSelectionInsideLink = function (state) {
    var $cursor = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["n" /* getCursor */])(state.selection);
    return $cursor
        ? !!state.doc.type.schema.marks.link.isInSet($cursor.marks())
        : false;
};
var isSelectionAroundLink = function (state) {
    var _a = state.selection, $from = _a.$from, $to = _a.$to;
    var node = $from.nodeAfter;
    if (node && $from.textOffset === 0 && $to.pos - $from.pos === node.nodeSize) {
        if (state.doc.type.schema.marks.link.isInSet(node.marks)) {
            return true;
        }
    }
    return false;
};
var mapTransactionToState = function (state, tr) {
    if (!state) {
        return undefined;
    }
    else if (state.type === InsertStatus.EDIT_LINK_TOOLBAR) {
        var _a = tr.mapping.mapResult(state.pos, 1), pos = _a.pos, deleted = _a.deleted;
        var node = tr.doc.nodeAt(pos);
        // If the position was not deleted & it is still a link
        if (!deleted && !!node.type.schema.marks.link.isInSet(node.marks)) {
            if (node === state.node && pos === state.pos) {
                return state;
            }
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, state, { pos: pos, node: node });
        }
        // If the position has been deleted, then require a navigation to show the toolbar again
        return undefined;
    }
    else if (state.type === InsertStatus.INSERT_LINK_TOOLBAR) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, state, { from: tr.mapping.map(state.from), to: tr.mapping.map(state.to) });
    }
};
var toState = function (state, action, editorState) {
    // Show insert or edit toolbar
    if (!state) {
        switch (action) {
            case LinkAction.SHOW_INSERT_TOOLBAR:
                var _a = editorState.selection, from = _a.from, to = _a.to;
                if (canLinkBeCreatedInRange(from, to)(editorState)) {
                    return { type: InsertStatus.INSERT_LINK_TOOLBAR, from: from, to: to };
                }
                return undefined;
            case LinkAction.SELECTION_CHANGE:
                // If the user has moved their cursor, see if they're in a link
                var link = getActiveLinkMark(editorState);
                if (link) {
                    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, link, { type: InsertStatus.EDIT_LINK_TOOLBAR });
                }
                return undefined;
            default:
                return undefined;
        }
    }
    // Update toolbar state if selection changes, or if toolbar is hidden
    if (state.type === InsertStatus.EDIT_LINK_TOOLBAR) {
        switch (action) {
            case LinkAction.SELECTION_CHANGE:
                var link = getActiveLinkMark(editorState);
                if (link) {
                    if (link.pos === state.pos && link.node === state.node) {
                        // Make sure we return the same object, if it's the same link
                        return state;
                    }
                    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, link, { type: InsertStatus.EDIT_LINK_TOOLBAR });
                }
                return undefined;
            case LinkAction.HIDE_TOOLBAR:
                return undefined;
            default:
                return state;
        }
    }
    // Remove toolbar if user changes selection or toolbar is hidden
    if (state.type === InsertStatus.INSERT_LINK_TOOLBAR) {
        switch (action) {
            case LinkAction.SELECTION_CHANGE:
            case LinkAction.HIDE_TOOLBAR:
                return undefined;
            default:
                return state;
        }
    }
};
var getActiveLinkMark = function (state) {
    if (isSelectionInsideLink(state)) {
        var $cursor = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["n" /* getCursor */])(state.selection);
        var pos = $cursor.pos - $cursor.textOffset;
        var node = state.doc.nodeAt(pos);
        return node && node.isText ? { node: node, pos: pos } : undefined;
    }
    if (isSelectionAroundLink(state)) {
        var $from = state.selection.$from;
        var pos = $from.pos - $from.textOffset;
        var node = state.doc.nodeAt(pos);
        return node && node.isText ? { node: node, pos: pos } : undefined;
    }
    return undefined;
};
var stateKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('hyperlinkPlugin');
var plugin = function (dispatch) {
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        state: {
            init: function (_, state) {
                var canInsertLink = canLinkBeCreatedInRange(state.selection.from, state.selection.to)(state);
                return {
                    canInsertLink: canInsertLink,
                    activeLinkMark: toState(undefined, LinkAction.SELECTION_CHANGE, state),
                };
            },
            apply: function (tr, pluginState, oldState, newState) {
                var state = pluginState;
                var action = tr.getMeta(stateKey);
                if (tr.docChanged) {
                    state = {
                        canInsertLink: canLinkBeCreatedInRange(newState.selection.from, newState.selection.to)(newState),
                        activeLinkMark: mapTransactionToState(state.activeLinkMark, tr),
                    };
                }
                if (action) {
                    state = {
                        canInsertLink: state.canInsertLink,
                        activeLinkMark: toState(state.activeLinkMark, action, newState),
                    };
                }
                if (tr.selectionSet) {
                    state = {
                        canInsertLink: canLinkBeCreatedInRange(newState.selection.from, newState.selection.to)(newState),
                        activeLinkMark: toState(state.activeLinkMark, LinkAction.SELECTION_CHANGE, newState),
                    };
                }
                if (state !== pluginState) {
                    dispatch(stateKey, state);
                }
                return state;
            },
        },
        key: stateKey,
    });
};
//# sourceMappingURL=main.js.map

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return pluginKey; });
/* unused harmony export createPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(835);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__actions__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__actions__["b"]; });




var pluginKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('macroPlugin');
var createPlugin = function (dispatch, providerFactory) {
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        state: {
            init: function () { return ({ macroProvider: null }); },
            apply: function (tr, state) {
                var meta = tr.getMeta(pluginKey);
                if (meta) {
                    var newState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, state, meta);
                    dispatch(pluginKey, newState);
                    return newState;
                }
                return state;
            },
        },
        key: pluginKey,
        view: function (view) {
            // make sure editable DOM node is mounted
            if (view.dom.parentNode) {
                providerFactory.subscribe('macroProvider', function (name, provider) {
                    return provider && Object(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* setMacroProvider */])(provider)(view);
                });
            }
            return {};
        },
    });
};
/* harmony default export */ __webpack_exports__["a"] = ({
    pmPlugins: function () {
        return [
            {
                name: 'macro',
                plugin: function (_a) {
                    var dispatch = _a.dispatch, providerFactory = _a.providerFactory;
                    return createPlugin(dispatch, providerFactory);
                },
            },
        ];
    },
});
//# sourceMappingURL=index.js.map

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return moveRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return moveLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeIgnoredNodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return toggleEm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return toggleStrike; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return toggleStrong; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return toggleUnderline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return toggleSuperscript; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return toggleSubscript; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return toggleCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createInlineCodeFromTextInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_commands__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_commands___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_commands__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__transform_to_code__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__analytics__ = __webpack_require__(20);






var moveRight = function () {
    return function (state, dispatch) {
        var code = state.schema.marks.code;
        var _a = state.selection, empty = _a.empty, $cursor = _a.$cursor;
        if (!empty || !$cursor) {
            return false;
        }
        var storedMarks = state.tr.storedMarks;
        if (code) {
            var insideCode = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* markActive */])(state, code.create());
            var currentPosHasCode = state.doc.rangeHasMark($cursor.pos, $cursor.pos, code);
            var nextPosHasCode = state.doc.rangeHasMark($cursor.pos, $cursor.pos + 1, code);
            var exitingCode = !currentPosHasCode &&
                !nextPosHasCode &&
                (!storedMarks || !!storedMarks.length);
            var enteringCode = !currentPosHasCode &&
                nextPosHasCode &&
                (!storedMarks || !storedMarks.length);
            // entering code mark (from the left edge): don't move the cursor, just add the mark
            if (!insideCode && enteringCode) {
                if (dispatch) {
                    dispatch(state.tr.addStoredMark(code.create()));
                }
                return true;
            }
            // exiting code mark: don't move the cursor, just remove the mark
            if (insideCode && exitingCode) {
                if (dispatch) {
                    dispatch(state.tr.removeStoredMark(code));
                }
                return true;
            }
        }
        return false;
    };
};
var moveLeft = function (view) {
    return function (state, dispatch) {
        var code = state.schema.marks.code;
        var _a = state.selection, empty = _a.empty, $cursor = _a.$cursor;
        if (!empty || !$cursor) {
            return false;
        }
        var storedMarks = state.tr.storedMarks;
        if (code) {
            var insideCode = code && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* markActive */])(state, code.create());
            var currentPosHasCode = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* hasCode */])(state, $cursor.pos);
            var nextPosHasCode = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* hasCode */])(state, $cursor.pos - 1);
            var nextNextPosHasCode = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* hasCode */])(state, $cursor.pos - 2);
            var exitingCode = currentPosHasCode && !nextPosHasCode && Array.isArray(storedMarks);
            var atLeftEdge = nextPosHasCode &&
                !nextNextPosHasCode &&
                (storedMarks === null ||
                    (Array.isArray(storedMarks) && !!storedMarks.length));
            var atRightEdge = ((exitingCode && Array.isArray(storedMarks) && !storedMarks.length) ||
                (!exitingCode && storedMarks === null)) &&
                !nextPosHasCode &&
                nextNextPosHasCode;
            var enteringCode = !currentPosHasCode &&
                nextPosHasCode &&
                Array.isArray(storedMarks) &&
                !storedMarks.length;
            // removing ignored nodes (cursor wrapper) to make sure cursor isn't stuck
            if (view.cursorWrapper && !atLeftEdge && !atRightEdge) {
                Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* removeIgnoredNodesLeft */])(view);
            }
            // at the right edge: remove code mark and move the cursor to the left
            if (!insideCode && atRightEdge) {
                var tr = state.tr.setSelection(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Selection"].near(state.doc.resolve($cursor.pos - 1)));
                if (dispatch) {
                    dispatch(tr.removeStoredMark(code));
                }
                return true;
            }
            // entering code mark (from right edge): don't move the cursor, just add the mark
            if (!insideCode && enteringCode) {
                if (dispatch) {
                    dispatch(state.tr.addStoredMark(code.create()));
                }
                return true;
            }
            // at the left edge: add code mark and move the cursor to the left
            if (insideCode && atLeftEdge) {
                var tr = state.tr.setSelection(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Selection"].near(state.doc.resolve($cursor.pos - 1)));
                if (dispatch) {
                    dispatch(tr.addStoredMark(code.create()));
                }
                return true;
            }
            // exiting code mark (or at the beginning of the line): don't move the cursor, just remove the mark
            var isFirstChild = $cursor.index($cursor.depth - 1) === 0;
            if (insideCode &&
                (exitingCode || (!$cursor.nodeBefore && isFirstChild))) {
                if (dispatch) {
                    dispatch(state.tr.removeStoredMark(code));
                }
                return true;
            }
        }
        return false;
    };
};
// removing ignored nodes (cursor wrapper) when pressing Backspace to make sure cursor isn't stuck
var removeIgnoredNodes = function (view) {
    return function (state) {
        var _a = state.selection, empty = _a.empty, $cursor = _a.$cursor;
        if (empty && $cursor && $cursor.nodeBefore) {
            Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* removeIgnoredNodesLeft */])(view);
        }
        return false;
    };
};
var toggleEm = function () {
    return function (state, dispatch) {
        var em = state.schema.marks.em;
        if (em) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_commands__["toggleMark"])(em)(state, dispatch);
        }
        return false;
    };
};
var toggleStrike = function () {
    return function (state, dispatch) {
        var strike = state.schema.marks.strike;
        if (strike) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_commands__["toggleMark"])(strike)(state, dispatch);
        }
        return false;
    };
};
var toggleStrong = function () {
    return function (state, dispatch) {
        var strong = state.schema.marks.strong;
        if (strong) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_commands__["toggleMark"])(strong)(state, dispatch);
        }
        return false;
    };
};
var toggleUnderline = function () {
    return function (state, dispatch) {
        var underline = state.schema.marks.underline;
        if (underline) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_commands__["toggleMark"])(underline)(state, dispatch);
        }
        return false;
    };
};
var toggleSuperscript = function () {
    return function (state, dispatch) {
        var subsup = state.schema.marks.subsup;
        if (subsup) {
            if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* markActive */])(state, subsup.create({ type: 'sub' }))) {
                // If subscript is enabled, turn it off first.
                return Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_commands__["toggleMark"])(subsup)(state, dispatch);
            }
            return Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_commands__["toggleMark"])(subsup, { type: 'sup' })(state, dispatch);
        }
        return false;
    };
};
var toggleSubscript = function () {
    return function (state, dispatch) {
        var subsup = state.schema.marks.subsup;
        if (subsup) {
            if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* markActive */])(state, subsup.create({ type: 'sup' }))) {
                return Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_commands__["toggleMark"])(subsup)(state, dispatch);
            }
            return Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_commands__["toggleMark"])(subsup, { type: 'sub' })(state, dispatch);
        }
        return false;
    };
};
var toggleCode = function () {
    return function (state, dispatch) {
        var code = state.schema.marks.code;
        var _a = state.selection, from = _a.from, to = _a.to;
        if (code) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* markActive */])(state, code.create())) {
                if (dispatch) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__transform_to_code__["a" /* transformToCodeAction */])(from, to, state.tr));
                }
                return true;
            }
            return Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_commands__["toggleMark"])(code)(state, dispatch);
        }
        return false;
    };
};
var createInlineCodeFromTextInput = function (from, to, text) {
    return function (state, dispatch) {
        if (state.selection.empty) {
            var before = state.doc.resolve(from).nodeBefore;
            var after = state.doc.resolve(to).nodeAfter;
            var hasTickBefore = before && before.text && before.text.endsWith('`');
            var hasTickAfter = after && after.text && after.text.startsWith('`');
            if (hasTickBefore && hasTickAfter) {
                __WEBPACK_IMPORTED_MODULE_4__analytics__["a" /* analyticsService */].trackEvent("atlassian.editor.format.code.autoformatting");
                var tr = state.tr.replaceRangeWith(from - 1, to + 1, state.schema.text(text));
                if (dispatch) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__transform_to_code__["a" /* transformToCodeAction */])(tr.mapping.map(from - 1), tr.mapping.map(to + 1), tr));
                }
                return true;
            }
        }
        return false;
    };
};
//# sourceMappingURL=text-formatting.js.map

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = encode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nodes_blockquote__ = __webpack_require__(2833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nodes_bullet_list__ = __webpack_require__(2834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodes_code_block__ = __webpack_require__(2848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nodes_doc__ = __webpack_require__(2849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nodes_heading__ = __webpack_require__(2850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nodes_media_group__ = __webpack_require__(2851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nodes_ordered_list__ = __webpack_require__(2853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__nodes_panel__ = __webpack_require__(2854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__nodes_paragraph__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__nodes_rule__ = __webpack_require__(2855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__nodes_table__ = __webpack_require__(2856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__nodes_unknown__ = __webpack_require__(886);












var nodeEncoderMapping = {
    blockquote: __WEBPACK_IMPORTED_MODULE_0__nodes_blockquote__["a" /* blockquote */],
    bulletList: __WEBPACK_IMPORTED_MODULE_1__nodes_bullet_list__["a" /* bulletList */],
    codeBlock: __WEBPACK_IMPORTED_MODULE_2__nodes_code_block__["a" /* codeBlock */],
    doc: __WEBPACK_IMPORTED_MODULE_3__nodes_doc__["a" /* doc */],
    heading: __WEBPACK_IMPORTED_MODULE_4__nodes_heading__["a" /* heading */],
    mediaGroup: __WEBPACK_IMPORTED_MODULE_5__nodes_media_group__["a" /* mediaGroup */],
    mediaSingle: __WEBPACK_IMPORTED_MODULE_5__nodes_media_group__["a" /* mediaGroup */],
    orderedList: __WEBPACK_IMPORTED_MODULE_6__nodes_ordered_list__["a" /* orderedList */],
    panel: __WEBPACK_IMPORTED_MODULE_7__nodes_panel__["a" /* panel */],
    paragraph: __WEBPACK_IMPORTED_MODULE_8__nodes_paragraph__["a" /* paragraph */],
    rule: __WEBPACK_IMPORTED_MODULE_9__nodes_rule__["a" /* rule */],
    table: __WEBPACK_IMPORTED_MODULE_10__nodes_table__["a" /* table */],
};
function encode(node) {
    var encoder = nodeEncoderMapping[node.type.name];
    if (encoder) {
        return encoder(node);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_11__nodes_unknown__["a" /* unknown */])(node);
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export akEditorCodeFontFamily */
/* unused harmony export akEditorInactiveForeground */
/* unused harmony export akEditorFocus */
/* unused harmony export akEditorSubtleAccent */
/* unused harmony export akEditorActiveBackground */
/* unused harmony export akEditorActiveForeground */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return akEditorBlockquoteBorderColor; });
/* unused harmony export akEditorDropdownActiveBackground */
/* unused harmony export akEditorPopupBackground */
/* unused harmony export akEditorPopupText */
/* unused harmony export akEditorPrimaryButton */
/* unused harmony export akEditorCodeBackground */
/* unused harmony export akEditorCodeBlockPadding */
/* unused harmony export akEditorCodeInlinePadding */
/* unused harmony export akEditorUnitZIndex */
/* unused harmony export akEditorSmallZIndex */
/* unused harmony export akEditorGridLineZIndex */
/* unused harmony export akEditorMenuZIndex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return akEditorFloatingPanelZIndex; });
/* unused harmony export akEditorFloatingDialogZIndex */
/* unused harmony export akEditorFloatingOverlapPanelZIndex */
/* unused harmony export akEditorMentionSelected */
/* unused harmony export akEditorTableToolbarSize */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return akEditorTableBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return akEditorTableToolbar; });
/* unused harmony export akEditorTableFloatingControls */
/* unused harmony export akEditorTableCellSelected */
/* unused harmony export akEditorTableToolbarSelected */
/* unused harmony export akEditorTableBorderSelected */
/* unused harmony export akEditorTableCellDelete */
/* unused harmony export akEditorTableBorderDelete */
/* unused harmony export akEditorTableToolbarDelete */
/* unused harmony export akEditorTableBorderRadius */
/* unused harmony export akEditorTableCellBackgroundOpacity */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return akEditorFullPageMaxWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return akEditorDefaultLayoutWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return akEditorWideLayoutWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return akEditorTableNumberColumnWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return akEditorBreakoutPadding; });
/* unused harmony export akEditorMobileBreakoutPoint */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return akEditorTableCellMinWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return gridMediumMaxWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return breakoutWideScaleRatio; });
/* unused harmony export editorFontSize */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return relativeSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return blockNodesVerticalMargin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);

var B100 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100, B300 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B300, B400 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400, B50 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B50, B75 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75, N0 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0, N20 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, N40 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N40, N50 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N50, N100 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N100, N500 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N500, N700 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, N900 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N900, R300 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R300, R50 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R50, R75 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R75;
var akEditorCodeFontFamily = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["codeFontFamily"])();
var akEditorInactiveForeground = N500;
var akEditorFocus = B100;
var akEditorSubtleAccent = N40;
var akEditorActiveBackground = N500;
var akEditorActiveForeground = N0;
var akEditorBlockquoteBorderColor = N40;
var akEditorDropdownActiveBackground = N900;
var akEditorPopupBackground = N700;
var akEditorPopupText = B50;
var akEditorPrimaryButton = B400;
var akEditorCodeBackground = N20;
var akEditorCodeBlockPadding = '12px';
var akEditorCodeInlinePadding = '2px 4px';
var akEditorUnitZIndex = 1;
var akEditorSmallZIndex = 2;
var akEditorGridLineZIndex = 9999;
// z-index for main menu bar -
// this is highest as it should be above anything else in editor below.
var akEditorMenuZIndex = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["layers"].blanket();
// z-index used for floating toolbars like code block, table etc
var akEditorFloatingPanelZIndex = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["layers"].layer();
// z-index used for pickers (date, emoji, mentions) and type-aheads, hyperlinks
var akEditorFloatingDialogZIndex = akEditorFloatingPanelZIndex + 10;
// z-index used for floating toolbars table cell menu which are above block toolbars
var akEditorFloatingOverlapPanelZIndex = akEditorFloatingPanelZIndex + 5;
var akEditorMentionSelected = N100;
var akEditorTableToolbarSize = 11;
var akEditorTableBorder = N50;
var akEditorTableToolbar = N20;
var akEditorTableFloatingControls = N20;
var akEditorTableCellSelected = B75;
var akEditorTableToolbarSelected = B100;
var akEditorTableBorderSelected = B300;
var akEditorTableCellDelete = R50;
var akEditorTableBorderDelete = R300;
var akEditorTableToolbarDelete = R75;
var akEditorTableBorderRadius = '3px';
var akEditorTableCellBackgroundOpacity = 0.5;
var akEditorFullPageMaxWidth = 680;
var akEditorDefaultLayoutWidth = 680;
var akEditorWideLayoutWidth = 960;
var akEditorTableNumberColumnWidth = 42;
var akEditorBreakoutPadding = 96;
var akEditorMobileBreakoutPoint = 720;
var akEditorTableCellMinWidth = 48;
var gridMediumMaxWidth = 1024;
var breakoutWideScaleRatio = 1.33;
var editorFontSize = function (_a) {
    var theme = _a.theme;
    return theme && theme.baseFontSize ? theme.baseFontSize : Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["fontSize"])();
};
var relativeSize = function (multiplier) { return function (_a) {
    var theme = _a.theme;
    return editorFontSize({ theme: theme }) * multiplier;
}; };
// @see typography spreadsheet: https://docs.google.com/spreadsheets/d/1iYusRGCT4PoPfvxbJ8NrgjtfFgXLm5lpDWXzjua1W2E/edit#gid=93913128
var blockNodesVerticalMargin = '1.142em';
//# sourceMappingURL=consts.js.map

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export akEditorCodeFontFamily */
/* unused harmony export akEditorInactiveForeground */
/* unused harmony export akEditorFocus */
/* unused harmony export akEditorSubtleAccent */
/* unused harmony export akEditorActiveBackground */
/* unused harmony export akEditorActiveForeground */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return akEditorBlockquoteBorderColor; });
/* unused harmony export akEditorDropdownActiveBackground */
/* unused harmony export akEditorPopupBackground */
/* unused harmony export akEditorPopupText */
/* unused harmony export akEditorPrimaryButton */
/* unused harmony export akEditorCodeBackground */
/* unused harmony export akEditorCodeBlockPadding */
/* unused harmony export akEditorCodeInlinePadding */
/* unused harmony export akEditorUnitZIndex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return akEditorSmallZIndex; });
/* unused harmony export akEditorGridLineZIndex */
/* unused harmony export akEditorMenuZIndex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return akEditorFloatingPanelZIndex; });
/* unused harmony export akEditorFloatingDialogZIndex */
/* unused harmony export akEditorFloatingOverlapPanelZIndex */
/* unused harmony export akEditorMentionSelected */
/* unused harmony export akEditorTableToolbarSize */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return akEditorTableBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return akEditorTableToolbar; });
/* unused harmony export akEditorTableFloatingControls */
/* unused harmony export akEditorTableCellSelected */
/* unused harmony export akEditorTableToolbarSelected */
/* unused harmony export akEditorTableBorderSelected */
/* unused harmony export akEditorTableCellDelete */
/* unused harmony export akEditorTableBorderDelete */
/* unused harmony export akEditorTableToolbarDelete */
/* unused harmony export akEditorTableBorderRadius */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return akEditorTableCellBackgroundOpacity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return akEditorFullPageMaxWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return akEditorDefaultLayoutWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return akEditorWideLayoutWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return akEditorTableNumberColumnWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return akEditorBreakoutPadding; });
/* unused harmony export akEditorMobileBreakoutPoint */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return akEditorTableCellMinWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return gridMediumMaxWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return breakoutWideScaleRatio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return editorFontSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return relativeSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return blockNodesVerticalMargin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);

var B100 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100, B300 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B300, B400 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400, B50 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B50, B75 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75, N0 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0, N20 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, N40 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N40, N50 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N50, N100 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N100, N500 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N500, N700 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, N900 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N900, R300 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R300, R50 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R50, R75 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R75;
var akEditorCodeFontFamily = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["codeFontFamily"])();
var akEditorInactiveForeground = N500;
var akEditorFocus = B100;
var akEditorSubtleAccent = N40;
var akEditorActiveBackground = N500;
var akEditorActiveForeground = N0;
var akEditorBlockquoteBorderColor = N40;
var akEditorDropdownActiveBackground = N900;
var akEditorPopupBackground = N700;
var akEditorPopupText = B50;
var akEditorPrimaryButton = B400;
var akEditorCodeBackground = N20;
var akEditorCodeBlockPadding = '12px';
var akEditorCodeInlinePadding = '2px 4px';
var akEditorUnitZIndex = 1;
var akEditorSmallZIndex = 2;
var akEditorGridLineZIndex = 9999;
// z-index for main menu bar -
// this is highest as it should be above anything else in editor below.
var akEditorMenuZIndex = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["layers"].blanket();
// z-index used for floating toolbars like code block, table etc
var akEditorFloatingPanelZIndex = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["layers"].layer();
// z-index used for pickers (date, emoji, mentions) and type-aheads, hyperlinks
var akEditorFloatingDialogZIndex = akEditorFloatingPanelZIndex + 10;
// z-index used for floating toolbars table cell menu which are above block toolbars
var akEditorFloatingOverlapPanelZIndex = akEditorFloatingPanelZIndex + 5;
var akEditorMentionSelected = N100;
var akEditorTableToolbarSize = 11;
var akEditorTableBorder = N50;
var akEditorTableToolbar = N20;
var akEditorTableFloatingControls = N20;
var akEditorTableCellSelected = B75;
var akEditorTableToolbarSelected = B100;
var akEditorTableBorderSelected = B300;
var akEditorTableCellDelete = R50;
var akEditorTableBorderDelete = R300;
var akEditorTableToolbarDelete = R75;
var akEditorTableBorderRadius = '3px';
var akEditorTableCellBackgroundOpacity = 0.5;
var akEditorFullPageMaxWidth = 680;
var akEditorDefaultLayoutWidth = 680;
var akEditorWideLayoutWidth = 960;
var akEditorTableNumberColumnWidth = 42;
var akEditorBreakoutPadding = 96;
var akEditorMobileBreakoutPoint = 720;
var akEditorTableCellMinWidth = 48;
var gridMediumMaxWidth = 1024;
var breakoutWideScaleRatio = 1.33;
var editorFontSize = function (_a) {
    var theme = _a.theme;
    return theme && theme.baseFontSize ? theme.baseFontSize : Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["fontSize"])();
};
var relativeSize = function (multiplier) { return function (_a) {
    var theme = _a.theme;
    return editorFontSize({ theme: theme }) * multiplier;
}; };
// @see typography spreadsheet: https://docs.google.com/spreadsheets/d/1iYusRGCT4PoPfvxbJ8NrgjtfFgXLm5lpDWXzjua1W2E/edit#gid=93913128
var blockNodesVerticalMargin = 1.143;
//# sourceMappingURL=consts.js.map

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MentionType; });
/* harmony export (immutable) */ __webpack_exports__["c"] = isRestricted;
/* unused harmony export isSpecialMention */
/* harmony export (immutable) */ __webpack_exports__["b"] = isAppMention;
/* harmony export (immutable) */ __webpack_exports__["e"] = isTeamMention;
/* harmony export (immutable) */ __webpack_exports__["d"] = isSpecialMentionText;
var MentionType;
(function (MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
})(MentionType || (MentionType = {}));
var UserAccessLevel;
(function (UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
})(UserAccessLevel || (UserAccessLevel = {}));
var UserType;
(function (UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
})(UserType || (UserType = {}));
function isRestricted(accessLevel) {
    return (accessLevel && accessLevel !== UserAccessLevel[UserAccessLevel.CONTAINER]);
}
function isSpecialMention(mention) {
    return !!mention.userType && mention.userType === UserType[UserType.SPECIAL];
}
function isAppMention(mention) {
    return mention.userType && mention.userType === UserType[UserType.APP];
}
function isTeamMention(mention) {
    return mention.userType && mention.userType === UserType[UserType.TEAM];
}
function isSpecialMentionText(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
//# sourceMappingURL=types.js.map

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AccessStatus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducer__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_index__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_refresh__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_refresh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_refresh__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AccessStatus=function(_Component){_inherits(AccessStatus,_Component);function AccessStatus(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AccessStatus);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AccessStatus.__proto__||Object.getPrototypeOf(AccessStatus)).call.apply(_ref,[this].concat(args))),_this),_this.handleClick=function(app){var _this$props=_this.props,username=_this$props.username,triggerAccessBot=_this$props.triggerAccessBot;triggerAccessBot(username,app);},_this.handleRefresh=function(){var _this$props2=_this.props,getUserAccessStatus=_this$props2.getUserAccessStatus,username=_this$props2.username;getUserAccessStatus(username);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AccessStatus,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,username=_props.username,getUserAccessStatus=_props.getUserAccessStatus,clearUserStatus=_props.clearUserStatus;clearUserStatus();if(username){getUserAccessStatus(username).catch(function(err){return console.error(err);});}}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,getAccessPending=_props2.getAccessPending,updateAccessPending=_props2.updateAccessPending,botResults=_props2.botResults,clearAccessBotResults=_props2.clearAccessBotResults,accessStatus=_props2.accessStatus,title=_props2.title,header=_props2.header;var appList=null;if(accessStatus&&!getAccessPending){appList=accessStatus.map(function(app){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:app.name},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'access-status-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_index_js__["m" /* Link */],{external:true,to:app.url,className:'access-status-app link'},app.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["a" /* AccessStatusIndicator */],{className:'access-status-indicator',status:app.status.toLowerCase()},app.status=='ACTIVE'?'Access verified':app.status=='UNAVAILABLE'?'Tool is currently unavailable':app.status=='INPROGRESS'?'Request Processing, pending app sync to complete':'Click "Grant Access" to get access to the application.'),app.status=='INACTIVE'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__atlaskit_button__["default"],{className:'access-status-button',type:'button',appearance:'primary'//isLoading={getAccessPending || updateAccessPending}
,spacing:'compact',onClick:function onClick(){return _this2.handleClick(app.app);}},'Grant Access'):null));});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,header?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_index_js__["j" /* H3 */],{className:'pb5-sm'},header,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_index_js__["l" /* InfoTooltip */],{key:'tooltip',className:'ml2-sm'},'Status of your application level access to the listed tools'),!getAccessPending?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn icon-solo',title:'refresh',onClick:this.handleRefresh},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_refresh___default.a,{size:'medium'})):null):title?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-header'},title,!getAccessPending?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn icon-solo',title:'refresh',onClick:this.handleRefresh},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_refresh___default.a,{size:'small'})):null):null,appList&&!updateAccessPending?appList:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_index_js__["v" /* Spinner */],{medium:true}),botResults?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["o" /* ModalDialog */],{display:true,handleClose:clearAccessBotResults},botResults):null);}}]);return AccessStatus;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{updateAccessPending:Object(__WEBPACK_IMPORTED_MODULE_7__util_index__["f" /* selectIsRequestPending */])(state,__WEBPACK_IMPORTED_MODULE_5__actions__["g" /* triggerAccessBot */]),getAccessPending:Object(__WEBPACK_IMPORTED_MODULE_7__util_index__["f" /* selectIsRequestPending */])(state,__WEBPACK_IMPORTED_MODULE_5__actions__["e" /* getUserAccessStatus */]),accessStatus:Object(__WEBPACK_IMPORTED_MODULE_6__reducer__["c" /* selectAccessStatus */])(state),botResults:Object(__WEBPACK_IMPORTED_MODULE_6__reducer__["b" /* selectAccessBotResults */])(state)};},{getUserAccessStatus:__WEBPACK_IMPORTED_MODULE_5__actions__["e" /* getUserAccessStatus */],triggerAccessBot:__WEBPACK_IMPORTED_MODULE_5__actions__["g" /* triggerAccessBot */],clearAccessBotResults:__WEBPACK_IMPORTED_MODULE_5__actions__["b" /* clearAccessBotResults */],clearUserStatus:__WEBPACK_IMPORTED_MODULE_5__actions__["d" /* clearUserStatus */]})(AccessStatus)));

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R50", function() { return R50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R75", function() { return R75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R100", function() { return R100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R200", function() { return R200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R300", function() { return R300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R400", function() { return R400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R500", function() { return R500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y50", function() { return Y50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y75", function() { return Y75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y100", function() { return Y100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y200", function() { return Y200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y300", function() { return Y300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y400", function() { return Y400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y500", function() { return Y500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G50", function() { return G50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G75", function() { return G75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G100", function() { return G100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G200", function() { return G200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G300", function() { return G300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G400", function() { return G400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G500", function() { return G500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B50", function() { return B50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B75", function() { return B75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B100", function() { return B100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B200", function() { return B200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B300", function() { return B300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B400", function() { return B400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B500", function() { return B500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P50", function() { return P50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P75", function() { return P75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P100", function() { return P100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P200", function() { return P200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P300", function() { return P300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P400", function() { return P400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P500", function() { return P500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T50", function() { return T50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T75", function() { return T75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T100", function() { return T100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T200", function() { return T200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T300", function() { return T300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T400", function() { return T400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T500", function() { return T500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N0", function() { return N0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10", function() { return N10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20", function() { return N20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30", function() { return N30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40", function() { return N40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50", function() { return N50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60", function() { return N60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70", function() { return N70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80", function() { return N80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90", function() { return N90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100", function() { return N100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200", function() { return N200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300", function() { return N300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400", function() { return N400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500", function() { return N500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600", function() { return N600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700", function() { return N700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800", function() { return N800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N900", function() { return N900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10A", function() { return N10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20A", function() { return N20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30A", function() { return N30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40A", function() { return N40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50A", function() { return N50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60A", function() { return N60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70A", function() { return N70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80A", function() { return N80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90A", function() { return N90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100A", function() { return N100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200A", function() { return N200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300A", function() { return N300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400A", function() { return N400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500A", function() { return N500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600A", function() { return N600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700A", function() { return N700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800A", function() { return N800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN900", function() { return DN900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800", function() { return DN800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700", function() { return DN700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600", function() { return DN600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500", function() { return DN500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400", function() { return DN400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300", function() { return DN300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200", function() { return DN200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100", function() { return DN100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90", function() { return DN90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80", function() { return DN80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70", function() { return DN70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60", function() { return DN60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50", function() { return DN50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40", function() { return DN40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30", function() { return DN30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20", function() { return DN20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10", function() { return DN10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN0", function() { return DN0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800A", function() { return DN800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700A", function() { return DN700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600A", function() { return DN600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500A", function() { return DN500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400A", function() { return DN400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300A", function() { return DN300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200A", function() { return DN200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100A", function() { return DN100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90A", function() { return DN90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80A", function() { return DN80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70A", function() { return DN70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60A", function() { return DN60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50A", function() { return DN50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40A", function() { return DN40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30A", function() { return DN30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20A", function() { return DN20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10A", function() { return DN10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "background", function() { return background; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundActive", function() { return backgroundActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundHover", function() { return backgroundHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundOnLayer", function() { return backgroundOnLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "text", function() { return text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textHover", function() { return textHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textActive", function() { return textActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleText", function() { return subtleText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "placeholderText", function() { return placeholderText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "heading", function() { return heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleHeading", function() { return subtleHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "codeBlock", function() { return codeBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "link", function() { return link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkHover", function() { return linkHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkActive", function() { return linkActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkOutline", function() { return linkOutline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "primary", function() { return primary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blue", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "teal", function() { return teal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purple", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yellow", function() { return yellow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "green", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette8", function() { return colorPalette8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette16", function() { return colorPalette16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette24", function() { return colorPalette24; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette", function() { return colorPalette; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(501);


// Reds
var R50 = '#FFEBE6';
var R75 = '#FFBDAD';
var R100 = '#FF8F73';
var R200 = '#FF7452';
var R300 = '#FF5630';
var R400 = '#DE350B';
var R500 = '#BF2600'; // Yellows

var Y50 = '#FFFAE6';
var Y75 = '#FFF0B3';
var Y100 = '#FFE380';
var Y200 = '#FFC400';
var Y300 = '#FFAB00';
var Y400 = '#FF991F';
var Y500 = '#FF8B00'; // Greens

var G50 = '#E3FCEF';
var G75 = '#ABF5D1';
var G100 = '#79F2C0';
var G200 = '#57D9A3';
var G300 = '#36B37E';
var G400 = '#00875A';
var G500 = '#006644'; // Blues

var B50 = '#DEEBFF';
var B75 = '#B3D4FF';
var B100 = '#4C9AFF';
var B200 = '#2684FF';
var B300 = '#0065FF';
var B400 = '#0052CC';
var B500 = '#0747A6'; // Purples

var P50 = '#EAE6FF';
var P75 = '#C0B6F2';
var P100 = '#998DD9';
var P200 = '#8777D9';
var P300 = '#6554C0';
var P400 = '#5243AA';
var P500 = '#403294'; // Teals

var T50 = '#E6FCFF';
var T75 = '#B3F5FF';
var T100 = '#79E2F2';
var T200 = '#00C7E6';
var T300 = '#00B8D9';
var T400 = '#00A3BF';
var T500 = '#008DA6'; // Neutrals

var N0 = '#FFFFFF';
var N10 = '#FAFBFC';
var N20 = '#F4F5F7';
var N30 = '#EBECF0';
var N40 = '#DFE1E6';
var N50 = '#C1C7D0';
var N60 = '#B3BAC5';
var N70 = '#A5ADBA';
var N80 = '#97A0AF';
var N90 = '#8993A4';
var N100 = '#7A869A';
var N200 = '#6B778C';
var N300 = '#5E6C84';
var N400 = '#505F79';
var N500 = '#42526E';
var N600 = '#344563';
var N700 = '#253858';
var N800 = '#172B4D'; // ATTENTION: update the tints if you update this

var N900 = '#091E42'; // Each tint is made of N900 and an alpha channel

var N10A = 'rgba(9, 30, 66, 0.02)';
var N20A = 'rgba(9, 30, 66, 0.04)';
var N30A = 'rgba(9, 30, 66, 0.08)';
var N40A = 'rgba(9, 30, 66, 0.13)';
var N50A = 'rgba(9, 30, 66, 0.25)';
var N60A = 'rgba(9, 30, 66, 0.31)';
var N70A = 'rgba(9, 30, 66, 0.36)';
var N80A = 'rgba(9, 30, 66, 0.42)';
var N90A = 'rgba(9, 30, 66, 0.48)';
var N100A = 'rgba(9, 30, 66, 0.54)';
var N200A = 'rgba(9, 30, 66, 0.60)';
var N300A = 'rgba(9, 30, 66, 0.66)';
var N400A = 'rgba(9, 30, 66, 0.71)';
var N500A = 'rgba(9, 30, 66, 0.77)';
var N600A = 'rgba(9, 30, 66, 0.82)';
var N700A = 'rgba(9, 30, 66, 0.89)';
var N800A = 'rgba(9, 30, 66, 0.95)'; // Dark Mode Neutrals

var DN900 = '#E6EDFA';
var DN800 = '#DCE5F5';
var DN700 = '#CED9EB';
var DN600 = '#B8C7E0';
var DN500 = '#ABBBD6';
var DN400 = '#9FB0CC';
var DN300 = '#8C9CB8';
var DN200 = '#7988A3';
var DN100 = '#67758F';
var DN90 = '#56637A';
var DN80 = '#455166';
var DN70 = '#3B475C';
var DN60 = '#313D52';
var DN50 = '#283447';
var DN40 = '#202B3D';
var DN30 = '#1B2638';
var DN20 = '#121A29';
var DN10 = '#0E1624'; // ATTENTION: update the tints if you update this

var DN0 = '#0D1424'; // Each dark tint is made of DN0 and an alpha channel

var DN800A = 'rgba(13, 20, 36, 0.06)';
var DN700A = 'rgba(13, 20, 36, 0.14)';
var DN600A = 'rgba(13, 20, 36, 0.18)';
var DN500A = 'rgba(13, 20, 36, 0.29)';
var DN400A = 'rgba(13, 20, 36, 0.36)';
var DN300A = 'rgba(13, 20, 36, 0.40)';
var DN200A = 'rgba(13, 20, 36, 0.47)';
var DN100A = 'rgba(13, 20, 36, 0.53)';
var DN90A = 'rgba(13, 20, 36, 0.63)';
var DN80A = 'rgba(13, 20, 36, 0.73)';
var DN70A = 'rgba(13, 20, 36, 0.78)';
var DN60A = 'rgba(13, 20, 36, 0.81)';
var DN50A = 'rgba(13, 20, 36, 0.85)';
var DN40A = 'rgba(13, 20, 36, 0.89)';
var DN30A = 'rgba(13, 20, 36, 0.92)';
var DN20A = 'rgba(13, 20, 36, 0.95)';
var DN10A = 'rgba(13, 20, 36, 0.97)'; // Themed colors

var background = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N0,
  dark: DN30
});
var backgroundActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B50,
  dark: B75
});
var backgroundHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N30,
  dark: DN70
});
var backgroundOnLayer = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N0,
  dark: DN50
});
var text = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N900,
  dark: DN600
});
var textHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N800,
  dark: DN600
});
var textActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B400,
  dark: B400
});
var subtleText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N200,
  dark: DN300
});
var placeholderText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N100,
  dark: DN200
});
var heading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N800,
  dark: DN600
});
var subtleHeading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N200,
  dark: DN300
});
var codeBlock = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N20,
  dark: DN50
});
var link = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B400,
  dark: B100
});
var linkHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B300,
  dark: B200
});
var linkActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B500,
  dark: B100
});
var linkOutline = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B100,
  dark: B200
});
var primary = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B400,
  dark: B100
});
var blue = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B400,
  dark: B100
});
var teal = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: T300,
  dark: T200
});
var purple = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: P300,
  dark: P100
});
var red = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: R300,
  dark: R300
});
var yellow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: Y300,
  dark: Y300
});
var green = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: G300,
  dark: G300
}); // Jira Portfolio

var colorPalette8 = [{
  background: N800,
  text: N0
}, {
  background: R400,
  text: N0
}, {
  background: P400,
  text: P50
}, {
  background: B400,
  text: B75
}, {
  background: T300,
  text: N800
}, {
  background: G400,
  text: N0
}, {
  background: Y400,
  text: N800
}, {
  background: N70,
  text: N800
}];
var colorPalette16 = [].concat(colorPalette8, [{
  background: N500,
  text: N0
}, {
  background: R100,
  text: N800
}, {
  background: P75,
  text: N800
}, {
  background: B100,
  text: N800
}, {
  background: T100,
  text: N800
}, {
  background: G100,
  text: G500
}, {
  background: Y200,
  text: N800
}, {
  background: N0,
  text: N800
}]);
var colorPalette24 = [].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(colorPalette16), [{
  background: N100,
  text: N0
}, {
  background: N40,
  text: N800
}, {
  background: N50,
  text: R500
}, {
  background: P50,
  text: P500
}, {
  background: B50,
  text: B500
}, {
  background: T75,
  text: N800
}, {
  background: G50,
  text: G500
}, {
  background: Y75,
  text: N800
}]);
var colorPalette = function colorPalette() {
  var palette = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '8';

  switch (palette) {
    case '8':
      return colorPalette8;

    case '16':
      return colorPalette16;

    case '24':
      return colorPalette24;

    default:
      throw new Error('The only available color palette is 8, 16, 24');
  }
};

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = serviceDesk;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return selectRequestTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectRequestType; });
/* unused harmony export selectRequestTypeName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectIssues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectIssue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectIssueComments; });
/* unused harmony export selectIssueFields */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectNewIssueKey; });
/* unused harmony export selectUpdateIssueStatus */
/* unused harmony export selectEditComment */
/* unused harmony export selectComment */
/* unused harmony export selectEditingComment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectIssueError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectIssuesTotal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_immutableUtils__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_wikimarkup_transformer__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_renderer__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(138);
var adfEncoder=new __WEBPACK_IMPORTED_MODULE_3__atlaskit_renderer__["a" /* ADFEncoder */](function(){return new __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_wikimarkup_transformer__["a" /* WikiMarkupTransformer */]();});var defaultState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["c" /* fromJS */])({requestTypes:[],requestType:null,requestTypeName:null,issues:[],issue:null,issueComments:[],issueUpdated:false,editable:false});function serviceDesk(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];state=Object(__WEBPACK_IMPORTED_MODULE_1__util_immutableUtils__["a" /* forceImmutable */])(state);// Force immutable in case of rehydration
switch(action.type){case __WEBPACK_IMPORTED_MODULE_4__actions__["c" /* clearNewIssueKey */].type:state=state.set('newIssueKey',null);return state;case __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* clearIssues */].type:return state.set('issues',[]);case __WEBPACK_IMPORTED_MODULE_4__actions__["l" /* setRequestType */].type:return state.set('requestType',action.payload);case __WEBPACK_IMPORTED_MODULE_4__actions__["j" /* setIssue */].type:return state.set('issue',action.payload);case __WEBPACK_IMPORTED_MODULE_4__actions__["o" /* updateIssueData */].type:var _action$payload=action.payload,issue=_action$payload.issue,values=_action$payload.values;return state.set('issue',Object.assign({},issue,values));/*case setEditable.type:
            return state.set('editable', action.payload)*/case __WEBPACK_IMPORTED_MODULE_4__actions__["e" /* getAllRequestTypes */].event.success:state=state.set('requestTypes',action.payload);return state;case __WEBPACK_IMPORTED_MODULE_4__actions__["i" /* getRequestType */].event.success:state=state.set('requestType',action.payload);return state;case __WEBPACK_IMPORTED_MODULE_4__actions__["f" /* getAllUserIssues */].event.success:var _action$payload2=action.payload,userIssues=_action$payload2.userIssues,searchResults=_action$payload2.searchResults,refresh=_action$payload2.refresh;var issueList=searchResults.issues;state=state.set('totalIssues',searchResults.total);var processedIssueList=issueList.map(function(issue){return process_issue(issue);});userIssues=userIssues.length&&!refresh?userIssues.concat(processedIssueList):processedIssueList;state=state.set('issues',userIssues);return state;case __WEBPACK_IMPORTED_MODULE_4__actions__["g" /* getIssue */].event.success:state=state.set('issue',process_issue(action.payload.issues[0]));return state;case __WEBPACK_IMPORTED_MODULE_4__actions__["k" /* setIssueError */].type:state=state.set('issueError',action.payload);return state;case __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* createIssue */].event.success:var _action$payload3=action.payload,newIssue=_action$payload3.newIssue,issues=_action$payload3.issues,issueCount=_action$payload3.issueCount;state=state.set('issue',process_issue(newIssue));state=state.set('newIssueKey',newIssue.key);issues.unshift(newIssue);state=state.set('totalIssues',issueCount+1);state=state.set('issues',issues);return state;case __WEBPACK_IMPORTED_MODULE_4__actions__["m" /* updateIssue */].event.success:var _action$payload4=action.payload,response=_action$payload4.response,issues_list=_action$payload4.issues_list;state=state.set('issueUpdated',true);var updatedIssue=process_issue(response);state=state.set('issue',updatedIssue);state=state.set('issues',issues_list.map(function(issue){if(issue.key===updatedIssue.key){issue=updatedIssue;}return issue;}));return state;case __WEBPACK_IMPORTED_MODULE_4__actions__["h" /* getIssueComments */].event.success:var _action$payload5=action.payload,issueComments=_action$payload5.issueComments,user=_action$payload5.user,jiraUser=_action$payload5.jiraUser;return state.set('issueComments',issueComments.map(function(comment){return portalfy_comments(user,jiraUser,comment);}));case __WEBPACK_IMPORTED_MODULE_4__actions__["n" /* updateIssueComment */].event.success:var _action$payload6=action.payload,updatedComment=_action$payload6.updatedComment,commentsList=_action$payload6.commentsList,requestor=_action$payload6.requestor,jUser=_action$payload6.jUser;return state.set('issueComments',commentsList.map(function(comment){return comment.id===updatedComment.id?portalfy_comments(requestor,jUser,updatedComment):comment;}));case __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* addIssueComment */].event.success:var _action$payload7=action.payload,newComment=_action$payload7.newComment,comments=_action$payload7.comments,commentAuthor=_action$payload7.commentAuthor,JiraUser=_action$payload7.JiraUser;comments.push(portalfy_comments(commentAuthor,JiraUser,newComment));return state.set('issueComments',comments);default:return state;}}function portalfy_comments(adUser,jiraUser,comment){var checkString='Portal Comment made by: ';var stripString=checkString+adUser.displayName;if(comment.body.includes(checkString)){var commentWritter=comment.body.split(checkString).pop();var extraText=commentWritter.split(adUser.displayName);extraText?commentWritter=commentWritter.replace(extraText,''):null;if(commentWritter==adUser.displayName){if(jiraUser){jiraUser.avatarUrls?comment.author.avatarUrls['48x48']=jiraUser.avatarUrls['48x48']:comment.author.avatarUrls=null;comment.author.displayName=jiraUser.displayName;comment.author.emailAddress=jiraUser.emailAddress;}else{comment.author.avatarUrls=null;comment.author.displayName=aduser.displayName;comment.author.emailAddress=aduser.email;}}}comment.body=comment.body.replace(stripString,'');comment.body=encode_wikiMarkup(comment.body,comment.mentions);return comment;}function process_issue(issue){issue.requestType.inputs.properties.map(function(field){if(field.type=='wiki'||field.jiraFieldName=='description'){issue[field.id]=encode_wikiMarkup(issue[field.id],issue['mentions']);}});return issue;}function encode_wikiMarkup(value,mentions){var doc=value?adfEncoder.encode(value):null;doc.content=parseDocForMentions(doc.content,mentions);return doc;}function parseDocForMentions(contents,mentions){for(var i=0;i<contents.length;i++){var object=contents[i];var array=object.content;if(object.type==='mention'){if(object.attrs.text===''){for(var n=0;n<mentions.length;n++){var mention=mentions[n];if(object.attrs.id===mention.id&&object.attrs.text===''){object.attrs.text=mention.text;break;}}}}else if('content'in object){object.content=parseDocForMentions(array,mentions);}contents[i]=object;}return contents;}var selectRequestTypes=function selectRequestTypes(state){return state.serviceDesk.get('requestTypes');};var selectRequestType=function selectRequestType(state){return state.serviceDesk.get('requestType');};var selectRequestTypeName=function selectRequestTypeName(state){return state.serviceDesk.get('requestTypeName');};var selectIssues=function selectIssues(state){return state.serviceDesk.get('issues');};var selectIssue=function selectIssue(state){return state.serviceDesk.get('issue');};var selectIssueComments=function selectIssueComments(state){return state.serviceDesk.get('issueComments');};var selectIssueFields=function selectIssueFields(state){return state.serviceDesk.get('fields');};var selectNewIssueKey=function selectNewIssueKey(state){return state.serviceDesk.get('newIssueKey');};var selectUpdateIssueStatus=function selectUpdateIssueStatus(state){return state.serviceDesk.get('issueUpdated');};//export const selectEditable = state => state.serviceDesk.get('editable')
var selectEditComment=function selectEditComment(state){return state.serviceDesk.get('editComment');};var selectComment=function selectComment(state){return state.serviceDesk.get('comment');};var selectEditingComment=function selectEditingComment(state){return state.serviceDesk.get('editingComment');};var selectIssueError=function selectIssueError(state){return state.serviceDesk.get('issueError');};var selectIssuesTotal=function selectIssuesTotal(state){return state.serviceDesk.get('totalIssues');};

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export actionTypes */
/* unused harmony export arrayInsert */
/* unused harmony export arrayMove */
/* unused harmony export arrayPop */
/* unused harmony export arrayPush */
/* unused harmony export arrayRemove */
/* unused harmony export arrayRemoveAll */
/* unused harmony export arrayShift */
/* unused harmony export arraySplice */
/* unused harmony export arraySwap */
/* unused harmony export arrayUnshift */
/* unused harmony export autofill */
/* unused harmony export blur */
/* unused harmony export change */
/* unused harmony export clearAsyncError */
/* unused harmony export clearFields */
/* unused harmony export clearSubmitErrors */
/* unused harmony export destroy */
/* unused harmony export focus */
/* unused harmony export initialize */
/* unused harmony export registerField */
/* unused harmony export reset */
/* unused harmony export resetSection */
/* unused harmony export setSubmitFailed */
/* unused harmony export setSubmitSucceeded */
/* unused harmony export startAsyncValidation */
/* unused harmony export startSubmit */
/* unused harmony export stopAsyncValidation */
/* unused harmony export stopSubmit */
/* unused harmony export submit */
/* unused harmony export touch */
/* unused harmony export unregisterField */
/* unused harmony export untouch */
/* unused harmony export updateSyncWarnings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultShouldAsyncValidate__ = __webpack_require__(1288);
/* unused harmony reexport defaultShouldAsyncValidate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultShouldValidate__ = __webpack_require__(1289);
/* unused harmony reexport defaultShouldValidate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultShouldError__ = __webpack_require__(1290);
/* unused harmony reexport defaultShouldError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultShouldWarn__ = __webpack_require__(1291);
/* unused harmony reexport defaultShouldWarn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(3199);
/* unused harmony reexport Form */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormName__ = __webpack_require__(3200);
/* unused harmony reexport FormName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormSection__ = __webpack_require__(3201);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__FormSection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SubmissionError__ = __webpack_require__(1292);
/* unused harmony reexport SubmissionError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__propTypes__ = __webpack_require__(3203);
/* unused harmony reexport propTypes */
/* unused harmony reexport fieldInputPropTypes */
/* unused harmony reexport fieldMetaPropTypes */
/* unused harmony reexport fieldPropTypes */
/* unused harmony reexport fieldArrayFieldsPropTypes */
/* unused harmony reexport fieldArrayMetaPropTypes */
/* unused harmony reexport fieldArrayPropTypes */
/* unused harmony reexport formPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Field__ = __webpack_require__(3204);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_11__Field__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Fields__ = __webpack_require__(3271);
/* unused harmony reexport Fields */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FieldArray__ = __webpack_require__(3274);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_13__FieldArray__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__formValueSelector__ = __webpack_require__(3292);
/* unused harmony reexport formValueSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__formValues__ = __webpack_require__(3294);
/* unused harmony reexport formValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__getFormError__ = __webpack_require__(3298);
/* unused harmony reexport getFormError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__getFormNames__ = __webpack_require__(3300);
/* unused harmony reexport getFormNames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__getFormValues__ = __webpack_require__(3302);
/* unused harmony reexport getFormValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__getFormInitialValues__ = __webpack_require__(3304);
/* unused harmony reexport getFormInitialValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__getFormSyncErrors__ = __webpack_require__(3306);
/* unused harmony reexport getFormSyncErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__getFormMeta__ = __webpack_require__(3308);
/* unused harmony reexport getFormMeta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__getFormAsyncErrors__ = __webpack_require__(3310);
/* unused harmony reexport getFormAsyncErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__getFormSyncWarnings__ = __webpack_require__(3312);
/* unused harmony reexport getFormSyncWarnings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__getFormSubmitErrors__ = __webpack_require__(3314);
/* unused harmony reexport getFormSubmitErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__isAsyncValidating__ = __webpack_require__(3316);
/* unused harmony reexport isAsyncValidating */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__isDirty__ = __webpack_require__(3318);
/* unused harmony reexport isDirty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__isInvalid__ = __webpack_require__(3320);
/* unused harmony reexport isInvalid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__isPristine__ = __webpack_require__(3323);
/* unused harmony reexport isPristine */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__isValid__ = __webpack_require__(3324);
/* unused harmony reexport isValid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__isSubmitting__ = __webpack_require__(3325);
/* unused harmony reexport isSubmitting */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__hasSubmitSucceeded__ = __webpack_require__(3327);
/* unused harmony reexport hasSubmitSucceeded */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__hasSubmitFailed__ = __webpack_require__(3329);
/* unused harmony reexport hasSubmitFailed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__reduxForm__ = __webpack_require__(3331);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_33__reduxForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__reducer__ = __webpack_require__(3362);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_34__reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__values__ = __webpack_require__(3365);
/* unused harmony reexport values */










// alias for propTypes


























var actionTypes = __WEBPACK_IMPORTED_MODULE_1__actionTypes__;
var arrayInsert = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayInsert;
var arrayMove = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayMove;
var arrayPop = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayPop;
var arrayPush = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayPush;
var arrayRemove = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayRemove;
var arrayRemoveAll = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayRemoveAll;
var arrayShift = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayShift;
var arraySplice = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arraySplice;
var arraySwap = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arraySwap;
var arrayUnshift = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayUnshift;
var autofill = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].autofill;
var blur = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].blur;
var change = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].change;
var clearAsyncError = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearAsyncError;
var clearFields = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearFields;
var clearSubmitErrors = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearSubmitErrors;
var destroy = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].destroy;
var focus = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].focus;
var initialize = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].initialize;
var registerField = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].registerField;
var reset = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].reset;
var resetSection = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].resetSection;
var setSubmitFailed = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].setSubmitFailed;
var setSubmitSucceeded = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].setSubmitSucceeded;
var startAsyncValidation = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].startAsyncValidation;
var startSubmit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].startSubmit;
var stopAsyncValidation = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].stopAsyncValidation;
var stopSubmit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].stopSubmit;
var submit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].submit;
var touch = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].touch;
var unregisterField = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].unregisterField;
var untouch = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].untouch;
var updateSyncWarnings = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].updateSyncWarnings;

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ncss_InputContainer_js__ = __webpack_require__(602);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var meta=_ref.meta,children=_ref.children,props=_objectWithoutProperties(_ref,['meta','children']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ncss_InputContainer_js__["a" /* default */],Object.assign({},props,{error:meta.touched&&meta.error}),children);});

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



module.exports = {
  copy: copy,
  checkDataType: checkDataType,
  checkDataTypes: checkDataTypes,
  coerceToTypes: coerceToTypes,
  toHash: toHash,
  getProperty: getProperty,
  escapeQuotes: escapeQuotes,
  equal: __webpack_require__(521),
  ucs2length: __webpack_require__(3379),
  varOccurences: varOccurences,
  varReplace: varReplace,
  schemaHasRules: schemaHasRules,
  schemaHasRulesExcept: schemaHasRulesExcept,
  schemaUnknownRules: schemaUnknownRules,
  toQuotedString: toQuotedString,
  getPathExpr: getPathExpr,
  getPath: getPath,
  getData: getData,
  unescapeFragment: unescapeFragment,
  unescapeJsonPointer: unescapeJsonPointer,
  escapeFragment: escapeFragment,
  escapeJsonPointer: escapeJsonPointer
};


function copy(o, to) {
  to = to || {};
  for (var key in o) to[key] = o[key];
  return to;
}


function checkDataType(dataType, data, strictNumbers, negate) {
  var EQUAL = negate ? ' !== ' : ' === '
    , AND = negate ? ' || ' : ' && '
    , OK = negate ? '!' : ''
    , NOT = negate ? '' : '!';
  switch (dataType) {
    case 'null': return data + EQUAL + 'null';
    case 'array': return OK + 'Array.isArray(' + data + ')';
    case 'object': return '(' + OK + data + AND +
                          'typeof ' + data + EQUAL + '"object"' + AND +
                          NOT + 'Array.isArray(' + data + '))';
    case 'integer': return '(typeof ' + data + EQUAL + '"number"' + AND +
                           NOT + '(' + data + ' % 1)' +
                           AND + data + EQUAL + data +
                           (strictNumbers ? (AND + OK + 'isFinite(' + data + ')') : '') + ')';
    case 'number': return '(typeof ' + data + EQUAL + '"' + dataType + '"' +
                          (strictNumbers ? (AND + OK + 'isFinite(' + data + ')') : '') + ')';
    default: return 'typeof ' + data + EQUAL + '"' + dataType + '"';
  }
}


function checkDataTypes(dataTypes, data, strictNumbers) {
  switch (dataTypes.length) {
    case 1: return checkDataType(dataTypes[0], data, strictNumbers, true);
    default:
      var code = '';
      var types = toHash(dataTypes);
      if (types.array && types.object) {
        code = types.null ? '(': '(!' + data + ' || ';
        code += 'typeof ' + data + ' !== "object")';
        delete types.null;
        delete types.array;
        delete types.object;
      }
      if (types.number) delete types.integer;
      for (var t in types)
        code += (code ? ' && ' : '' ) + checkDataType(t, data, strictNumbers, true);

      return code;
  }
}


var COERCE_TO_TYPES = toHash([ 'string', 'number', 'integer', 'boolean', 'null' ]);
function coerceToTypes(optionCoerceTypes, dataTypes) {
  if (Array.isArray(dataTypes)) {
    var types = [];
    for (var i=0; i<dataTypes.length; i++) {
      var t = dataTypes[i];
      if (COERCE_TO_TYPES[t]) types[types.length] = t;
      else if (optionCoerceTypes === 'array' && t === 'array') types[types.length] = t;
    }
    if (types.length) return types;
  } else if (COERCE_TO_TYPES[dataTypes]) {
    return [dataTypes];
  } else if (optionCoerceTypes === 'array' && dataTypes === 'array') {
    return ['array'];
  }
}


function toHash(arr) {
  var hash = {};
  for (var i=0; i<arr.length; i++) hash[arr[i]] = true;
  return hash;
}


var IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
var SINGLE_QUOTE = /'|\\/g;
function getProperty(key) {
  return typeof key == 'number'
          ? '[' + key + ']'
          : IDENTIFIER.test(key)
            ? '.' + key
            : "['" + escapeQuotes(key) + "']";
}


function escapeQuotes(str) {
  return str.replace(SINGLE_QUOTE, '\\$&')
            .replace(/\n/g, '\\n')
            .replace(/\r/g, '\\r')
            .replace(/\f/g, '\\f')
            .replace(/\t/g, '\\t');
}


function varOccurences(str, dataVar) {
  dataVar += '[^0-9]';
  var matches = str.match(new RegExp(dataVar, 'g'));
  return matches ? matches.length : 0;
}


function varReplace(str, dataVar, expr) {
  dataVar += '([^0-9])';
  expr = expr.replace(/\$/g, '$$$$');
  return str.replace(new RegExp(dataVar, 'g'), expr + '$1');
}


function schemaHasRules(schema, rules) {
  if (typeof schema == 'boolean') return !schema;
  for (var key in schema) if (rules[key]) return true;
}


function schemaHasRulesExcept(schema, rules, exceptKeyword) {
  if (typeof schema == 'boolean') return !schema && exceptKeyword != 'not';
  for (var key in schema) if (key != exceptKeyword && rules[key]) return true;
}


function schemaUnknownRules(schema, rules) {
  if (typeof schema == 'boolean') return;
  for (var key in schema) if (!rules[key]) return key;
}


function toQuotedString(str) {
  return '\'' + escapeQuotes(str) + '\'';
}


function getPathExpr(currentPath, expr, jsonPointers, isNumber) {
  var path = jsonPointers // false by default
              ? '\'/\' + ' + expr + (isNumber ? '' : '.replace(/~/g, \'~0\').replace(/\\//g, \'~1\')')
              : (isNumber ? '\'[\' + ' + expr + ' + \']\'' : '\'[\\\'\' + ' + expr + ' + \'\\\']\'');
  return joinPaths(currentPath, path);
}


function getPath(currentPath, prop, jsonPointers) {
  var path = jsonPointers // false by default
              ? toQuotedString('/' + escapeJsonPointer(prop))
              : toQuotedString(getProperty(prop));
  return joinPaths(currentPath, path);
}


var JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
var RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function getData($data, lvl, paths) {
  var up, jsonPointer, data, matches;
  if ($data === '') return 'rootData';
  if ($data[0] == '/') {
    if (!JSON_POINTER.test($data)) throw new Error('Invalid JSON-pointer: ' + $data);
    jsonPointer = $data;
    data = 'rootData';
  } else {
    matches = $data.match(RELATIVE_JSON_POINTER);
    if (!matches) throw new Error('Invalid JSON-pointer: ' + $data);
    up = +matches[1];
    jsonPointer = matches[2];
    if (jsonPointer == '#') {
      if (up >= lvl) throw new Error('Cannot access property/index ' + up + ' levels up, current level is ' + lvl);
      return paths[lvl - up];
    }

    if (up > lvl) throw new Error('Cannot access data ' + up + ' levels up, current level is ' + lvl);
    data = 'data' + ((lvl - up) || '');
    if (!jsonPointer) return data;
  }

  var expr = data;
  var segments = jsonPointer.split('/');
  for (var i=0; i<segments.length; i++) {
    var segment = segments[i];
    if (segment) {
      data += getProperty(unescapeJsonPointer(segment));
      expr += ' && ' + data;
    }
  }
  return expr;
}


function joinPaths (a, b) {
  if (a == '""') return b;
  return (a + ' + ' + b).replace(/([^\\])' \+ '/g, '$1');
}


function unescapeFragment(str) {
  return unescapeJsonPointer(decodeURIComponent(str));
}


function escapeFragment(str) {
  return encodeURIComponent(escapeJsonPointer(str));
}


function escapeJsonPointer(str) {
  return str.replace(/~/g, '~0').replace(/\//g, '~1');
}


function unescapeJsonPointer(str) {
  return str.replace(/~1/g, '/').replace(/~0/g, '~');
}


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(143);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(611);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return active; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return disable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return emojiPicker; });
/* unused harmony export addButton */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return categorySelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return category; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return emojiPickerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return virtualList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return searchIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return input; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return pickerSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return emojiPickerSpinner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return emojiPickerRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return emojiCategoryTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return emojiItem; });
/* unused harmony export addEmoji */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return emojiPickerFooter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return emojiPickerFooterWithTopShadow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_typestyle__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_styles__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_styles__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(69);
var _a, _b, _c, _d, _e, _f, _g, _h;





var active = 'emoji-picker-active';
var disable = 'emoji-picker-disable';
// Level 1 - picker
var emojiPicker = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    background: 'white',
    border: __WEBPACK_IMPORTED_MODULE_2__shared_styles__["c" /* emojiPickerBorderColor */] + " 1px solid",
    borderRadius: Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["borderRadius"])() + "px",
    boxShadow: __WEBPACK_IMPORTED_MODULE_2__shared_styles__["d" /* emojiPickerBoxShadow */],
    height: __WEBPACK_IMPORTED_MODULE_4__constants__["j" /* emojiPickerHeight */] + "px",
    width: __WEBPACK_IMPORTED_MODULE_4__constants__["k" /* emojiPickerWidth */] + "px",
    marginBottom: '8px',
    minWidth: __WEBPACK_IMPORTED_MODULE_4__constants__["k" /* emojiPickerWidth */] + "px",
});
// Level 2
/// Category Selector
var addButton = 'emoji-picker-add-button';
var categorySelector = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    flex: '0 0 auto',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N30,
    $nest: (_a = {
            ul: {
                listStyle: 'none',
                margin: '0 4px',
                padding: '3px 0',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around',
            },
            li: {
                display: 'inline-block',
                margin: 0,
                padding: 0,
                $nest: {
                    button: {
                        verticalAlign: 'middle',
                    },
                },
            }
        },
        _a["." + addButton] = {
            color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N200,
            margin: '0 0 0 5px',
            verticalAlign: 'middle',
        },
        _a),
});
var category = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    backgroundColor: 'transparent',
    border: 0,
    color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N100A,
    cursor: 'pointer',
    margin: '2px 0',
    padding: 0,
    transition: 'color 0.2s ease',
    $nest: (_b = {},
        /* Firefox */
        _b['&::-moz-focus-inner'] = {
            border: '0 none',
            padding: 0,
        },
        _b["&." + active] = {
            color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].B300,
            $nest: (_c = {},
                _c['&:hover'] = {
                    color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].B300,
                },
                _c),
        },
        _b['&:hover'] = {
            color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].B100,
        },
        _b["&." + disable] = {
            color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N50,
            cursor: 'default',
            $nest: (_d = {},
                _d['&:hover'] = {
                    color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N50,
                },
                _d),
        },
        _b['&:focus'] = {
            outline: '0',
        },
        _b),
});
/// EmojiPickerList
var emojiPickerList = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    // To force Firefox/IE/Edge to shrink the list, if necessary (e.g. when upload panel in place)
    height: '0',
});
// react-virtualized enables focus style by default - turn it off
var virtualList = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    $nest: {
        '&:focus': {
            outline: 'none',
        },
    },
});
//// Search
var searchIcon = 'search-icon';
var input = 'input';
var pickerSearch = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    boxSizing: 'border-box',
    padding: '10px',
    flex: '0 0 auto',
    $nest: (_e = {},
        _e["." + searchIcon] = {
            opacity: 0.5,
        },
        _e["." + input] = {
            background: 'transparent',
            border: 0,
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'inherit',
            fontSize: '14px',
            outline: 'none',
            padding: '1px 0 2px 10px',
            width: '100%',
            $nest: (_f = {},
                _f['&:invalid'] = {
                    boxShadow: 'none',
                },
                _f['&::-ms-clear'] = {
                    display: 'none',
                },
                _f),
        },
        _e),
});
//// Loading/Spinner
var emojiPickerSpinner = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    display: 'flex',
    width: '100%',
    height: '150px',
    justifyContent: 'center',
    alignItems: 'center',
    $nest: {
        '>div': {
            flex: '0 0 auto',
        },
    },
});
//// Category/Result
var emojiPickerRow = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    marginLeft: '8px',
});
var emojiCategoryTitle = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    boxSizing: 'border-box',
    color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N900,
    fontSize: '14px',
    padding: '5px 8px',
    textTransform: 'lowercase',
    $nest: {
        '&:first-letter': {
            textTransform: 'uppercase',
        },
    },
});
var emojiItem = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    display: 'inline-block',
    textAlign: 'center',
    width: '40px',
    $nest: (_g = {},
        _g["&>." + __WEBPACK_IMPORTED_MODULE_3__common_styles__["p" /* emojiNode */]] = {
            cursor: 'pointer',
            padding: '8px',
            borderRadius: '5px',
            width: '24px',
            height: '24px',
            $nest: (_h = {
                    // Fit non-square emoji to square
                    '&>img': {
                        position: 'relative',
                        left: '50%',
                        top: '50%',
                        transform: 'translateX(-50%) translateY(-50%)',
                        maxHeight: '24px',
                        maxWidth: '24px',
                        display: 'block',
                    }
                },
                // Scale sprite to fit regardless of default emoji size
                _h["&>." + __WEBPACK_IMPORTED_MODULE_3__common_styles__["u" /* emojiSprite */]] = {
                    height: '24px',
                    width: '24px',
                },
                _h),
        },
        _g["&>." + __WEBPACK_IMPORTED_MODULE_3__common_styles__["y" /* placeholder */]] = {
            padding: '0',
            margin: '7px',
            minWidth: '24px',
            maxWidth: '24px',
        },
        _g),
});
var addEmoji = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    border: '2px dashed #ccc',
    borderRadius: Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["borderRadius"])() + "px",
    backgroundColor: 'transparent',
    width: '32px',
    height: '32px',
    padding: 0,
    margin: '4px',
    verticalAlign: 'middle',
    $nest: {
        '&:hover': {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_2__shared_styles__["a" /* akEmojiSelectedBackgroundColor */],
        },
        '&:focus': {
            outline: '0',
        },
        span: {
            backgroundColor: 'inherit',
        },
    },
});
/// Footer
var emojiPickerFooter = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    flex: '0 0 auto',
});
var emojiPickerFooterWithTopShadow = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    borderTop: "2px solid " + __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N30A,
    boxShadow: __WEBPACK_IMPORTED_MODULE_2__shared_styles__["b" /* emojiFooterBoxShadow */],
});
//# sourceMappingURL=styles.js.map

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return active; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return disable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return emojiPicker; });
/* unused harmony export addButton */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return categorySelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return category; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return emojiPickerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return virtualList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return searchIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return input; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return pickerSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return emojiPickerSpinner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return emojiPickerRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return emojiCategoryTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return emojiItem; });
/* unused harmony export addEmoji */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return emojiPickerFooter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return emojiPickerFooterWithTopShadow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_typestyle__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_styles__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_styles__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(70);
var _a, _b, _c, _d, _e, _f, _g, _h;





var active = 'emoji-picker-active';
var disable = 'emoji-picker-disable';
// Level 1 - picker
var emojiPicker = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    background: 'white',
    border: __WEBPACK_IMPORTED_MODULE_2__shared_styles__["c" /* emojiPickerBorderColor */] + " 1px solid",
    borderRadius: Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["borderRadius"])() + "px",
    boxShadow: __WEBPACK_IMPORTED_MODULE_2__shared_styles__["d" /* emojiPickerBoxShadow */],
    height: __WEBPACK_IMPORTED_MODULE_4__constants__["j" /* emojiPickerHeight */] + "px",
    width: __WEBPACK_IMPORTED_MODULE_4__constants__["k" /* emojiPickerWidth */] + "px",
    marginBottom: '8px',
    minWidth: __WEBPACK_IMPORTED_MODULE_4__constants__["k" /* emojiPickerWidth */] + "px",
});
// Level 2
/// Category Selector
var addButton = 'emoji-picker-add-button';
var categorySelector = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    flex: '0 0 auto',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N30,
    $nest: (_a = {
            ul: {
                listStyle: 'none',
                margin: '0 4px',
                padding: '3px 0',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around',
            },
            li: {
                display: 'inline-block',
                margin: 0,
                padding: 0,
                $nest: {
                    button: {
                        verticalAlign: 'middle',
                    },
                },
            }
        },
        _a["." + addButton] = {
            color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N200,
            margin: '0 0 0 5px',
            verticalAlign: 'middle',
        },
        _a),
});
var category = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    backgroundColor: 'transparent',
    border: 0,
    color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N100A,
    cursor: 'pointer',
    margin: '2px 0',
    padding: 0,
    transition: 'color 0.2s ease',
    $nest: (_b = {},
        /* Firefox */
        _b['&::-moz-focus-inner'] = {
            border: '0 none',
            padding: 0,
        },
        _b["&." + active] = {
            color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].B300,
            $nest: (_c = {},
                _c['&:hover'] = {
                    color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].B300,
                },
                _c),
        },
        _b['&:hover'] = {
            color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].B100,
        },
        _b["&." + disable] = {
            color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N50,
            cursor: 'default',
            $nest: (_d = {},
                _d['&:hover'] = {
                    color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N50,
                },
                _d),
        },
        _b['&:focus'] = {
            outline: '0',
        },
        _b),
});
/// EmojiPickerList
var emojiPickerList = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    // To force Firefox/IE/Edge to shrink the list, if necessary (e.g. when upload panel in place)
    height: '0',
});
// react-virtualized enables focus style by default - turn it off
var virtualList = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    $nest: {
        '&:focus': {
            outline: 'none',
        },
    },
});
//// Search
var searchIcon = 'search-icon';
var input = 'input';
var pickerSearch = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    boxSizing: 'border-box',
    padding: '10px',
    flex: '0 0 auto',
    $nest: (_e = {},
        _e["." + searchIcon] = {
            opacity: 0.5,
        },
        _e["." + input] = {
            background: 'transparent',
            border: 0,
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'inherit',
            fontSize: '14px',
            outline: 'none',
            padding: '1px 0 2px 10px',
            width: '100%',
            $nest: (_f = {},
                _f['&:invalid'] = {
                    boxShadow: 'none',
                },
                _f['&::-ms-clear'] = {
                    display: 'none',
                },
                _f),
        },
        _e),
});
//// Loading/Spinner
var emojiPickerSpinner = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    display: 'flex',
    width: '100%',
    height: '150px',
    justifyContent: 'center',
    alignItems: 'center',
    $nest: {
        '>div': {
            flex: '0 0 auto',
        },
    },
});
//// Category/Result
var emojiPickerRow = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    marginLeft: '8px',
});
var emojiCategoryTitle = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    boxSizing: 'border-box',
    color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N900,
    fontSize: '14px',
    padding: '5px 8px',
    textTransform: 'lowercase',
    $nest: {
        '&:first-letter': {
            textTransform: 'uppercase',
        },
    },
});
var emojiItem = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    display: 'inline-block',
    textAlign: 'center',
    width: '40px',
    $nest: (_g = {},
        _g["&>." + __WEBPACK_IMPORTED_MODULE_3__common_styles__["p" /* emojiNode */]] = {
            cursor: 'pointer',
            padding: '8px',
            borderRadius: '5px',
            width: '24px',
            height: '24px',
            $nest: (_h = {
                    // Fit non-square emoji to square
                    '&>img': {
                        position: 'relative',
                        left: '50%',
                        top: '50%',
                        transform: 'translateX(-50%) translateY(-50%)',
                        maxHeight: '24px',
                        maxWidth: '24px',
                        display: 'block',
                    }
                },
                // Scale sprite to fit regardless of default emoji size
                _h["&>." + __WEBPACK_IMPORTED_MODULE_3__common_styles__["u" /* emojiSprite */]] = {
                    height: '24px',
                    width: '24px',
                },
                _h),
        },
        _g["&>." + __WEBPACK_IMPORTED_MODULE_3__common_styles__["y" /* placeholder */]] = {
            padding: '0',
            margin: '7px',
            minWidth: '24px',
            maxWidth: '24px',
        },
        _g),
});
var addEmoji = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    border: '2px dashed #ccc',
    borderRadius: Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["borderRadius"])() + "px",
    backgroundColor: 'transparent',
    width: '32px',
    height: '32px',
    padding: 0,
    margin: '4px',
    verticalAlign: 'middle',
    $nest: {
        '&:hover': {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_2__shared_styles__["a" /* akEmojiSelectedBackgroundColor */],
        },
        '&:focus': {
            outline: '0',
        },
        span: {
            backgroundColor: 'inherit',
        },
    },
});
/// Footer
var emojiPickerFooter = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    flex: '0 0 auto',
});
var emojiPickerFooterWithTopShadow = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    borderTop: "2px solid " + __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N30A,
    boxShadow: __WEBPACK_IMPORTED_MODULE_2__shared_styles__["b" /* emojiFooterBoxShadow */],
});
//# sourceMappingURL=styles.js.map

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return active; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return disable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return emojiPicker; });
/* unused harmony export addButton */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return categorySelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return category; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return emojiPickerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return virtualList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return searchIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return input; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return pickerSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return emojiPickerSpinner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return emojiPickerRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return emojiCategoryTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return emojiItem; });
/* unused harmony export addEmoji */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return emojiPickerFooter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return emojiPickerFooterWithTopShadow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_typestyle__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_styles__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_styles__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(71);
var _a, _b, _c, _d, _e, _f, _g, _h;





var active = 'emoji-picker-active';
var disable = 'emoji-picker-disable';
// Level 1 - picker
var emojiPicker = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    background: 'white',
    border: __WEBPACK_IMPORTED_MODULE_2__shared_styles__["c" /* emojiPickerBorderColor */] + " 1px solid",
    borderRadius: Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["borderRadius"])() + "px",
    boxShadow: __WEBPACK_IMPORTED_MODULE_2__shared_styles__["d" /* emojiPickerBoxShadow */],
    height: __WEBPACK_IMPORTED_MODULE_4__constants__["j" /* emojiPickerHeight */] + "px",
    width: __WEBPACK_IMPORTED_MODULE_4__constants__["k" /* emojiPickerWidth */] + "px",
    marginBottom: '8px',
    minWidth: __WEBPACK_IMPORTED_MODULE_4__constants__["k" /* emojiPickerWidth */] + "px",
});
// Level 2
/// Category Selector
var addButton = 'emoji-picker-add-button';
var categorySelector = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    flex: '0 0 auto',
    backgroundColor: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N30,
    $nest: (_a = {
            ul: {
                listStyle: 'none',
                margin: '0 4px',
                padding: '3px 0',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around',
            },
            li: {
                display: 'inline-block',
                margin: 0,
                padding: 0,
                $nest: {
                    button: {
                        verticalAlign: 'middle',
                    },
                },
            }
        },
        _a["." + addButton] = {
            color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N200,
            margin: '0 0 0 5px',
            verticalAlign: 'middle',
        },
        _a),
});
var category = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    backgroundColor: 'transparent',
    border: 0,
    color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N100A,
    cursor: 'pointer',
    margin: '2px 0',
    padding: 0,
    transition: 'color 0.2s ease',
    $nest: (_b = {},
        /* Firefox */
        _b['&::-moz-focus-inner'] = {
            border: '0 none',
            padding: 0,
        },
        _b["&." + active] = {
            color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].B300,
            $nest: (_c = {},
                _c['&:hover'] = {
                    color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].B300,
                },
                _c),
        },
        _b['&:hover'] = {
            color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].B100,
        },
        _b["&." + disable] = {
            color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N50,
            cursor: 'default',
            $nest: (_d = {},
                _d['&:hover'] = {
                    color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N50,
                },
                _d),
        },
        _b['&:focus'] = {
            outline: '0',
        },
        _b),
});
/// EmojiPickerList
var emojiPickerList = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    // To force Firefox/IE/Edge to shrink the list, if necessary (e.g. when upload panel in place)
    height: '0',
});
// react-virtualized enables focus style by default - turn it off
var virtualList = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    $nest: {
        '&:focus': {
            outline: 'none',
        },
    },
});
//// Search
var searchIcon = 'search-icon';
var input = 'input';
var pickerSearch = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    boxSizing: 'border-box',
    padding: '10px',
    flex: '0 0 auto',
    $nest: (_e = {},
        _e["." + searchIcon] = {
            opacity: 0.5,
        },
        _e["." + input] = {
            background: 'transparent',
            border: 0,
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'inherit',
            fontSize: '14px',
            outline: 'none',
            padding: '1px 0 2px 10px',
            width: '100%',
            $nest: (_f = {},
                _f['&:invalid'] = {
                    boxShadow: 'none',
                },
                _f['&::-ms-clear'] = {
                    display: 'none',
                },
                _f),
        },
        _e),
});
//// Loading/Spinner
var emojiPickerSpinner = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    display: 'flex',
    width: '100%',
    height: '150px',
    justifyContent: 'center',
    alignItems: 'center',
    $nest: {
        '>div': {
            flex: '0 0 auto',
        },
    },
});
//// Category/Result
var emojiPickerRow = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    marginLeft: '8px',
});
var emojiCategoryTitle = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    boxSizing: 'border-box',
    color: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N900,
    fontSize: '14px',
    padding: '5px 8px',
    textTransform: 'lowercase',
    $nest: {
        '&:first-letter': {
            textTransform: 'uppercase',
        },
    },
});
var emojiItem = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    display: 'inline-block',
    textAlign: 'center',
    width: '40px',
    $nest: (_g = {},
        _g["&>." + __WEBPACK_IMPORTED_MODULE_3__common_styles__["p" /* emojiNode */]] = {
            cursor: 'pointer',
            padding: '8px',
            borderRadius: '5px',
            width: '24px',
            height: '24px',
            $nest: (_h = {
                    // Fit non-square emoji to square
                    '&>img': {
                        position: 'relative',
                        left: '50%',
                        top: '50%',
                        transform: 'translateX(-50%) translateY(-50%)',
                        maxHeight: '24px',
                        maxWidth: '24px',
                        display: 'block',
                    }
                },
                // Scale sprite to fit regardless of default emoji size
                _h["&>." + __WEBPACK_IMPORTED_MODULE_3__common_styles__["u" /* emojiSprite */]] = {
                    height: '24px',
                    width: '24px',
                },
                _h),
        },
        _g["&>." + __WEBPACK_IMPORTED_MODULE_3__common_styles__["y" /* placeholder */]] = {
            padding: '0',
            margin: '7px',
            minWidth: '24px',
            maxWidth: '24px',
        },
        _g),
});
var addEmoji = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    border: '2px dashed #ccc',
    borderRadius: Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["borderRadius"])() + "px",
    backgroundColor: 'transparent',
    width: '32px',
    height: '32px',
    padding: 0,
    margin: '4px',
    verticalAlign: 'middle',
    $nest: {
        '&:hover': {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_2__shared_styles__["a" /* akEmojiSelectedBackgroundColor */],
        },
        '&:focus': {
            outline: '0',
        },
        span: {
            backgroundColor: 'inherit',
        },
    },
});
/// Footer
var emojiPickerFooter = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    flex: '0 0 auto',
});
var emojiPickerFooterWithTopShadow = Object(__WEBPACK_IMPORTED_MODULE_0_typestyle__["a" /* style */])({
    borderTop: "2px solid " + __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N30A,
    boxShadow: __WEBPACK_IMPORTED_MODULE_2__shared_styles__["b" /* emojiFooterBoxShadow */],
});
//# sourceMappingURL=styles.js.map

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = __webpack_require__(10);

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];

function isWebpackReady(getModuleIds) {
  if (( false ? "undefined" : _typeof(__webpack_require__.m)) !== "object") {
    return false;
  }

  return getModuleIds().every(function (moduleId) {
    return typeof moduleId !== "undefined" && typeof __webpack_require__.m[moduleId] !== "undefined";
  });
}

function load(loader) {
  var promise = loader();

  var state = {
    loading: true,
    loaded: null,
    error: null
  };

  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  }).catch(function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });

  return state;
}

function loadMap(obj) {
  var state = {
    loading: false,
    loaded: {},
    error: null
  };

  var promises = [];

  try {
    Object.keys(obj).forEach(function (key) {
      var result = load(obj[key]);

      if (!result.loading) {
        state.loaded[key] = result.loaded;
        state.error = result.error;
      } else {
        state.loading = true;
      }

      promises.push(result.promise);

      result.promise.then(function (res) {
        state.loaded[key] = res;
      }).catch(function (err) {
        state.error = err;
      });
    });
  } catch (err) {
    state.error = err;
  }

  state.promise = Promise.all(promises).then(function (res) {
    state.loading = false;
    return res;
  }).catch(function (err) {
    state.loading = false;
    throw err;
  });

  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj.default : obj;
}

function render(loaded, props) {
  return React.createElement(resolve(loaded), props);
}

function createLoadableComponent(loadFn, options) {
  var _class, _temp;

  if (!options.loading) {
    throw new Error("react-loadable requires a `loading` component");
  }

  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    render: render,
    webpack: null,
    modules: null
  }, options);

  var res = null;

  function init() {
    if (!res) {
      res = loadFn(opts.loader);
    }
    return res.promise;
  }

  ALL_INITIALIZERS.push(init);

  if (typeof opts.webpack === "function") {
    READY_INITIALIZERS.push(function () {
      if (isWebpackReady(opts.webpack)) {
        return init();
      }
    });
  }

  return _temp = _class = function (_React$Component) {
    _inherits(LoadableComponent, _React$Component);

    function LoadableComponent(props) {
      _classCallCheck(this, LoadableComponent);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

      _this.retry = function () {
        _this.setState({ error: null, loading: true, timedOut: false });
        res = loadFn(opts.loader);
        _this._loadModule();
      };

      init();

      _this.state = {
        error: res.error,
        pastDelay: false,
        timedOut: false,
        loading: res.loading,
        loaded: res.loaded
      };
      return _this;
    }

    LoadableComponent.preload = function preload() {
      return init();
    };

    LoadableComponent.prototype.componentWillMount = function componentWillMount() {
      this._mounted = true;
      this._loadModule();
    };

    LoadableComponent.prototype._loadModule = function _loadModule() {
      var _this2 = this;

      if (this.context.loadable && Array.isArray(opts.modules)) {
        opts.modules.forEach(function (moduleName) {
          _this2.context.loadable.report(moduleName);
        });
      }

      if (!res.loading) {
        return;
      }

      if (typeof opts.delay === "number") {
        if (opts.delay === 0) {
          this.setState({ pastDelay: true });
        } else {
          this._delay = setTimeout(function () {
            _this2.setState({ pastDelay: true });
          }, opts.delay);
        }
      }

      if (typeof opts.timeout === "number") {
        this._timeout = setTimeout(function () {
          _this2.setState({ timedOut: true });
        }, opts.timeout);
      }

      var update = function update() {
        if (!_this2._mounted) {
          return;
        }

        _this2.setState({
          error: res.error,
          loaded: res.loaded,
          loading: res.loading
        });

        _this2._clearTimeouts();
      };

      res.promise.then(function () {
        update();
      }).catch(function (err) {
        update();
      });
    };

    LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      this._mounted = false;
      this._clearTimeouts();
    };

    LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    };

    LoadableComponent.prototype.render = function render() {
      if (this.state.loading || this.state.error) {
        return React.createElement(opts.loading, {
          isLoading: this.state.loading,
          pastDelay: this.state.pastDelay,
          timedOut: this.state.timedOut,
          error: this.state.error,
          retry: this.retry
        });
      } else if (this.state.loaded) {
        return opts.render(this.state.loaded, this.props);
      } else {
        return null;
      }
    };

    return LoadableComponent;
  }(React.Component), _class.contextTypes = {
    loadable: PropTypes.shape({
      report: PropTypes.func.isRequired
    })
  }, _temp;
}

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function LoadableMap(opts) {
  if (typeof opts.render !== "function") {
    throw new Error("LoadableMap requires a `render(loaded, props)` function");
  }

  return createLoadableComponent(loadMap, opts);
}

Loadable.Map = LoadableMap;

var Capture = function (_React$Component2) {
  _inherits(Capture, _React$Component2);

  function Capture() {
    _classCallCheck(this, Capture);

    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
  }

  Capture.prototype.getChildContext = function getChildContext() {
    return {
      loadable: {
        report: this.props.report
      }
    };
  };

  Capture.prototype.render = function render() {
    return React.Children.only(this.props.children);
  };

  return Capture;
}(React.Component);

Capture.propTypes = {
  report: PropTypes.func.isRequired
};
Capture.childContextTypes = {
  loadable: PropTypes.shape({
    report: PropTypes.func.isRequired
  }).isRequired
};


Loadable.Capture = Capture;

function flushInitializers(initializers) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init());
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolve, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolve, reject);
  });
};

Loadable.preloadReady = function () {
  return new Promise(function (resolve, reject) {
    // We always will resolve, errors should be handled within loading UIs.
    flushInitializers(READY_INITIALIZERS).then(resolve, resolve);
  });
};

module.exports = Loadable;

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DecisionItem__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DecisionList__ = __webpack_require__(2717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ResourcedItemList__ = __webpack_require__(2718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ResourcedTaskItem__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_TaskDecisionResource__ = __webpack_require__(2734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TaskItem__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_TaskList__ = __webpack_require__(2735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types__ = __webpack_require__(871);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_TaskDecisionUtils__ = __webpack_require__(872);
/* unused harmony reexport convertServiceItemResponseToItemResponse */
/* unused harmony reexport convertServiceDecisionResponseToDecisionResponse */
/* unused harmony reexport convertServiceTaskResponseToTaskResponse */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_DecisionItem__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__components_DecisionList__["a"]; });
/* unused harmony reexport ResourcedItemList */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__components_ResourcedTaskItem__["a"]; });
/* unused harmony reexport TaskDecisionResource */
/* unused harmony reexport TaskItem */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__components_TaskList__["a"]; });










//# sourceMappingURL=index.js.map

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
var _history=Object(__WEBPACK_IMPORTED_MODULE_0_history__["a" /* createBrowserHistory */])();function addLocationQuery(history){if(!history.location.search)return;history.location=Object.assign(history.location,{query:__WEBPACK_IMPORTED_MODULE_1_qs___default.a.parse(history.location.search.substring(1))});}addLocationQuery(_history);_history.listen(function(){addLocationQuery(_history);});_history.mergeQueryString=function(obj){var search=__WEBPACK_IMPORTED_MODULE_1_qs___default.a.parse(_history.location.search,{ignoreQueryPrefix:true});var nextSearch=Object.assign({},search,obj);_history.push({search:__WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(nextSearch)});};/* harmony default export */ __webpack_exports__["a"] = (_history);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoginRequired; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_reducer_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth_actions_js__ = __webpack_require__(188);
var mapProps=function mapProps(state){return{isLoggedIn:Object(__WEBPACK_IMPORTED_MODULE_3__auth_reducer_js__["e" /* isLoggedIn */])(state),loginFinished:Object(__WEBPACK_IMPORTED_MODULE_3__auth_reducer_js__["b" /* hasAuthCheckFinished */])(state)};};var LoginRequired=Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapProps,{loginUser:__WEBPACK_IMPORTED_MODULE_5__auth_actions_js__["d" /* loginUser */]})(function(_ref){var isLoggedIn=_ref.isLoggedIn,loginFinished=_ref.loginFinished,title=_ref.title,loginUser=_ref.loginUser,children=_ref.children;if(!loginFinished)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index_js__["r" /* PageSpinner */],{title:title,noHeader:true});if(!isLoggedIn){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index_js__["f" /* Container */],{fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index_js__["i" /* H1 */],{className:'u-sm-ib u-va-m'},'You must be logged in to view this page'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index_js__["d" /* Button */],{extraClassName:'m2-sm u-sm-ib u-va-m',onClick:loginUser},'Login'));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(children);}));var requireLogin=function requireLogin(title){return function(WrappedComponent){return function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoginRequired,{title:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent,props));};};};/* harmony default export */ __webpack_exports__["b"] = (requireLogin);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return startAuthCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return finishAuthCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setAuthCheckError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setADandJiraUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setUserLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getExtraUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loginUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return logoutUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return initializeUserAuth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_localforage__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url_join__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_url_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_index_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_http__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducer_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__appStatus_actions__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__offline_reducer_js__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth_oAuth_js__ = __webpack_require__(3185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(73);
var locationKey='location';var routeStore=__WEBPACK_IMPORTED_MODULE_0_localforage___default.a.createInstance({name:'route-store '});var startAuthCheck=Object(__WEBPACK_IMPORTED_MODULE_2__util_index_js__["b" /* createAction */])('AUTH_CHECK_START',{noPayload:true});var finishAuthCheck=Object(__WEBPACK_IMPORTED_MODULE_2__util_index_js__["b" /* createAction */])('AUTH_CHECK_COMPLETE',{noPayload:true});var setAuthCheckError=Object(__WEBPACK_IMPORTED_MODULE_2__util_index_js__["b" /* createAction */])('AUTH_CHECK_ERROR');var setADandJiraUser=Object(__WEBPACK_IMPORTED_MODULE_2__util_index_js__["b" /* createAction */])('SET_AD_AND_JIRA_USER');var setUserLogin=Object(__WEBPACK_IMPORTED_MODULE_2__util_index_js__["b" /* createAction */])('LOGIN_SET_USER');var api=__WEBPACK_IMPORTED_MODULE_1_url_join___default.a.bind(null,__WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */].apiUrl);var getExtraUserInfo=Object(__WEBPACK_IMPORTED_MODULE_2__util_index_js__["a" /* asyncAction */])({baseName:'EXTRA_USER_INFO_GET',action:function action(_action){return function(userEmail){return function(dispatch,getState){var adUserInfo=getState().auth.get('adUserInfo');if(adUserInfo===undefined||adUserInfo==null){dispatch(_action.start());return __WEBPACK_IMPORTED_MODULE_8__util__["d" /* http */].get(api('/ssp/user?id='+userEmail)).then(function(userInfo){dispatch(_action.success(userInfo));}).catch(function(err){console.error('error getting AD and JIRA user info api response',err);dispatch(_action.error(err));});}else{return Promise.resolve();}};};}});var loginUser=function loginUser(){return function(dispatch,getState){var route=getState().routing.location.pathname;return routeStore.setItem(locationKey,route).then(function(){return __WEBPACK_IMPORTED_MODULE_7__auth_oAuth_js__["b" /* login */]();});};};var logoutUser=function logoutUser(skipRedirect){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_7__auth_oAuth_js__["c" /* logout */]().then(function(){return routeStore.removeItem(locationKey);}).then(function(){dispatch(setUserLogin(null));if(!skipRedirect)__WEBPACK_IMPORTED_MODULE_2__util_index_js__["c" /* history */].push('/');}).catch(function(error){// TODO: NOTIFY THE USER: this is an app decision. Use a toast, error page, etc
console.error(error);});};};var initializeUserAuth=function initializeUserAuth(){return function(dispatch,getState){var state=getState();if(Object(__WEBPACK_IMPORTED_MODULE_4__reducer_js__["c" /* hasAuthCheckStarted */])(state))return Promise.resolve();dispatch(startAuthCheck());return __WEBPACK_IMPORTED_MODULE_7__auth_oAuth_js__["a" /* checkForToken */]().then(function(loginToken){if(!loginToken){if(Object(__WEBPACK_IMPORTED_MODULE_6__offline_reducer_js__["b" /* isOffline */])(state)){dispatch(finishAuthCheck());return;}loginUser()(dispatch,getState);// Don't finish auth check if we are logging user in
return;}Object(__WEBPACK_IMPORTED_MODULE_3__util_http__["c" /* setGlobalHeader */])('Authorization','Bearer '+loginToken.accessToken);watchForTokenExpiration(dispatch,loginToken);// TODO: Configure your HTTP client to use the token here      
dispatch(setUserLogin(loginToken));return routeStore.getItem(locationKey).then(function(previousRoute){if(previousRoute){__WEBPACK_IMPORTED_MODULE_2__util_index_js__["c" /* history */].replace(previousRoute);return routeStore.removeItem(locationKey);}}).then(dispatch(getExtraUserInfo(loginToken.email))).then(dispatch(finishAuthCheck())).then(dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__appStatus_actions__["a" /* getAppStatus */])()));}).catch(function(err){dispatch(setAuthCheckError(err));});};};var tokenExpirationWatcher=null;function watchForTokenExpiration(dispatch,token){if(tokenExpirationWatcher){clearInterval(tokenExpirationWatcher);}tokenExpirationWatcher=setInterval(function(){if(token.isExpired){clearInterval(tokenExpirationWatcher);tokenExpirationWatcher=null;logoutUser(true)(dispatch);}},1000);}

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InfoTooltip__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Markdown_js__ = __webpack_require__(621);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var defaultClass='ncss-label';/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var children=_ref.children,title=_ref.title,className=_ref.className,useBareClass=_ref.useBareClass,props=_objectWithoutProperties(_ref,['children','title','className','useBareClass']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',Object.assign({},props,{className:(useBareClass||defaultClass)+' '+(className||''),key:'label'}),children,title?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__InfoTooltip__["a" /* default */],{key:'tooltip',className:'ml2-sm '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tooltip-markdown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Markdown_js__["a" /* default */],{source:title}))):null);});

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(605);
var enumBugKeys = __webpack_require__(363);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateUuid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return uuid; });
// tslint:disable:no-bitwise
var generateUuid = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0;
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
};
var staticValue = false;
var uuid = {
    setStatic: function (value) {
        staticValue = value;
    },
    generate: function () {
        return staticValue || generateUuid();
    },
};
//# sourceMappingURL=uuid.js.map

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSchema;
/* harmony export (immutable) */ __webpack_exports__["b"] = sanitizeNodes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__groups__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__marks__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nodes__ = __webpack_require__(374);





function addItems(builtInItems, config, customSpecs) {
    if (customSpecs === void 0) { customSpecs = {}; }
    if (!config) {
        return {};
    }
    /**
     * Add built-in Node / Mark specs
     */
    var items = builtInItems.reduce(function (items, _a) {
        var name = _a.name, spec = _a.spec;
        if (config.indexOf(name) !== -1) {
            items[name] = customSpecs[name] || spec;
        }
        return items;
    }, {});
    /**
     * Add Custom Node / Mark specs
     */
    return Object.keys(customSpecs).reduce(function (items, name) {
        if (items[name]) {
            return items;
        }
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function groupDeclaration(name) {
    return {
        name: "__" + name + "GroupDeclaration",
        spec: {
            group: name,
        },
    };
}
var markGroupDeclarations = [
    groupDeclaration(__WEBPACK_IMPORTED_MODULE_2__groups__["b" /* COLOR */]),
    groupDeclaration(__WEBPACK_IMPORTED_MODULE_2__groups__["c" /* FONT_STYLE */]),
    groupDeclaration(__WEBPACK_IMPORTED_MODULE_2__groups__["f" /* SEARCH_QUERY */]),
    groupDeclaration(__WEBPACK_IMPORTED_MODULE_2__groups__["e" /* LINK */]),
];
var markGroupDeclarationsNames = markGroupDeclarations.map(function (groupMark) { return groupMark.name; });
var nodesInOrder = [
    { name: 'doc', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["doc"] },
    { name: 'paragraph', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["paragraph"] },
    { name: 'text', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["text"] },
    { name: 'bulletList', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["bulletList"] },
    { name: 'orderedList', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["orderedList"] },
    { name: 'listItem', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["listItem"] },
    { name: 'heading', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["heading"] },
    { name: 'blockquote', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["blockquote"] },
    { name: 'codeBlock', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["codeBlock"] },
    { name: 'panel', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["panel"] },
    { name: 'rule', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["rule"] },
    { name: 'image', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["image"] },
    { name: 'mention', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["mention"] },
    { name: 'media', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["media"] },
    { name: 'mediaGroup', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["mediaGroup"] },
    { name: 'mediaSingle', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["mediaSingle"] },
    { name: 'placeholder', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["placeholder"] },
    { name: 'layoutSection', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["layoutSection"] },
    { name: 'layoutColumn', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["layoutColumn"] },
    { name: 'hardBreak', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["hardBreak"] },
    { name: 'emoji', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["emoji"] },
    { name: 'table', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["table"] },
    { name: 'tableCell', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["tableCell"] },
    { name: 'tableRow', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["tableRow"] },
    { name: 'tableHeader', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["tableHeader"] },
    { name: 'confluenceJiraIssue', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["confluenceJiraIssue"] },
    { name: 'confluenceUnsupportedInline', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["confluenceUnsupportedInline"] },
    { name: 'confluenceUnsupportedBlock', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["confluenceUnsupportedBlock"] },
    { name: 'applicationCard', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["applicationCard"] },
    { name: 'decisionList', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["decisionList"] },
    { name: 'decisionItem', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["decisionItem"] },
    { name: 'taskList', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["taskList"] },
    { name: 'taskItem', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["taskItem"] },
    { name: 'date', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["date"] },
    { name: 'status', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["status"] },
    { name: 'extension', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["extension"] },
    { name: 'inlineExtension', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["inlineExtension"] },
    { name: 'bodiedExtension', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["bodiedExtension"] },
    { name: 'inlineCard', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["inlineCard"] },
    { name: 'blockCard', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["blockCard"] },
    { name: 'unknownBlock', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["unknownBlock"] },
    { name: 'unsupportedBlock', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["unsupportedBlock"] },
    { name: 'unsupportedInline', spec: __WEBPACK_IMPORTED_MODULE_4__nodes__["unsupportedInline"] },
];
var marksInOrder = __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"]([
    { name: 'link', spec: __WEBPACK_IMPORTED_MODULE_3__marks__["l" /* link */] },
    { name: 'em', spec: __WEBPACK_IMPORTED_MODULE_3__marks__["i" /* em */] },
    { name: 'strong', spec: __WEBPACK_IMPORTED_MODULE_3__marks__["o" /* strong */] },
    { name: 'strike', spec: __WEBPACK_IMPORTED_MODULE_3__marks__["n" /* strike */] },
    { name: 'subsup', spec: __WEBPACK_IMPORTED_MODULE_3__marks__["p" /* subsup */] },
    { name: 'underline', spec: __WEBPACK_IMPORTED_MODULE_3__marks__["s" /* underline */] },
    { name: 'code', spec: __WEBPACK_IMPORTED_MODULE_3__marks__["f" /* code */] },
    { name: 'emojiQuery', spec: __WEBPACK_IMPORTED_MODULE_3__marks__["j" /* emojiQuery */] },
    { name: 'typeAheadQuery', spec: __WEBPACK_IMPORTED_MODULE_3__marks__["r" /* typeAheadQuery */] },
    { name: 'textColor', spec: __WEBPACK_IMPORTED_MODULE_3__marks__["q" /* textColor */] },
    { name: 'action', spec: __WEBPACK_IMPORTED_MODULE_3__marks__["a" /* action */] },
    { name: 'alignment', spec: __WEBPACK_IMPORTED_MODULE_3__marks__["b" /* alignment */] },
    { name: 'confluenceInlineComment', spec: __WEBPACK_IMPORTED_MODULE_3__marks__["h" /* confluenceInlineComment */] }
], markGroupDeclarations, [
    { name: 'breakout', spec: __WEBPACK_IMPORTED_MODULE_3__marks__["e" /* breakout */] },
    { name: 'indentation', spec: __WEBPACK_IMPORTED_MODULE_3__marks__["k" /* indentation */] },
]);
/**
 * Creates a schema preserving order of marks and nodes.
 */
function createSchema(config) {
    var customNodeSpecs = config.customNodeSpecs, customMarkSpecs = config.customMarkSpecs;
    var nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    var marksConfig = Object.keys(customMarkSpecs || {})
        .concat(config.marks || [])
        .concat(markGroupDeclarationsNames);
    var nodes = addItems(nodesInOrder, nodesConfig, customNodeSpecs);
    var marks = addItems(marksInOrder, marksConfig, customMarkSpecs);
    nodes = sanitizeNodes(nodes, marks);
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Schema"]({
        nodes: nodes,
        marks: marks,
    });
}
function sanitizeNodes(nodes, supportedMarks) {
    var nodeNames = Object.keys(nodes);
    nodeNames.forEach(function (nodeKey) {
        var nodeSpec = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, nodes[nodeKey]);
        if (nodeSpec.marks && nodeSpec.marks !== '_') {
            nodeSpec.marks = nodeSpec.marks
                .split(' ')
                .filter(function (mark) { return !!supportedMarks[mark]; })
                .join(' ');
        }
        if (nodeSpec.content) {
            var content = nodeSpec.content.replace(/\W/g, ' ');
            var contentKeys = content.split(' ');
            var unsupportedContentKeys = contentKeys.filter(function (contentKey) { return !isContentSupported(nodes, contentKey); });
            nodeSpec.content = unsupportedContentKeys.reduce(function (newContent, nodeName) { return sanitizedContent(newContent, nodeName); }, nodeSpec.content);
        }
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) {
        return content || '';
    }
    if (!content || !content.match(/\w/)) {
        return '';
    }
    var newContent = content
        .replace(new RegExp("(" + invalidContent + "((\\s)*\\|)+)|((\\|(\\s)*)+" + invalidContent + ")|(" + invalidContent + "$)", 'g'), '')
        .replace('  ', ' ')
        .trim();
    return newContent;
}
function isContentSupported(nodes, contentKey) {
    var nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) {
        return true;
    }
    // content is with valid group
    for (var supportedKey in nodes) {
        var nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=create-schema.js.map

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(74)

/**
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfDay


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R50", function() { return R50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R75", function() { return R75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R100", function() { return R100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R200", function() { return R200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R300", function() { return R300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R400", function() { return R400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R500", function() { return R500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y50", function() { return Y50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y75", function() { return Y75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y100", function() { return Y100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y200", function() { return Y200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y300", function() { return Y300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y400", function() { return Y400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y500", function() { return Y500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G50", function() { return G50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G75", function() { return G75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G100", function() { return G100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G200", function() { return G200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G300", function() { return G300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G400", function() { return G400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G500", function() { return G500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B50", function() { return B50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B75", function() { return B75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B100", function() { return B100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B200", function() { return B200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B300", function() { return B300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B400", function() { return B400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B500", function() { return B500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P50", function() { return P50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P75", function() { return P75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P100", function() { return P100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P200", function() { return P200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P300", function() { return P300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P400", function() { return P400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P500", function() { return P500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T50", function() { return T50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T75", function() { return T75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T100", function() { return T100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T200", function() { return T200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T300", function() { return T300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T400", function() { return T400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T500", function() { return T500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N0", function() { return N0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10", function() { return N10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20", function() { return N20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30", function() { return N30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40", function() { return N40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50", function() { return N50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60", function() { return N60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70", function() { return N70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80", function() { return N80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90", function() { return N90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100", function() { return N100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200", function() { return N200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300", function() { return N300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400", function() { return N400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500", function() { return N500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600", function() { return N600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700", function() { return N700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800", function() { return N800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N900", function() { return N900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10A", function() { return N10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20A", function() { return N20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30A", function() { return N30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40A", function() { return N40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50A", function() { return N50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60A", function() { return N60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70A", function() { return N70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80A", function() { return N80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90A", function() { return N90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100A", function() { return N100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200A", function() { return N200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300A", function() { return N300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400A", function() { return N400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500A", function() { return N500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600A", function() { return N600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700A", function() { return N700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800A", function() { return N800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN900", function() { return DN900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800", function() { return DN800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700", function() { return DN700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600", function() { return DN600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500", function() { return DN500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400", function() { return DN400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300", function() { return DN300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200", function() { return DN200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100", function() { return DN100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90", function() { return DN90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80", function() { return DN80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70", function() { return DN70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60", function() { return DN60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50", function() { return DN50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40", function() { return DN40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30", function() { return DN30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20", function() { return DN20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10", function() { return DN10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN0", function() { return DN0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800A", function() { return DN800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700A", function() { return DN700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600A", function() { return DN600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500A", function() { return DN500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400A", function() { return DN400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300A", function() { return DN300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200A", function() { return DN200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100A", function() { return DN100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90A", function() { return DN90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80A", function() { return DN80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70A", function() { return DN70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60A", function() { return DN60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50A", function() { return DN50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40A", function() { return DN40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30A", function() { return DN30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20A", function() { return DN20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10A", function() { return DN10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "background", function() { return background; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundActive", function() { return backgroundActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundHover", function() { return backgroundHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundOnLayer", function() { return backgroundOnLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "text", function() { return text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textHover", function() { return textHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textActive", function() { return textActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleText", function() { return subtleText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "placeholderText", function() { return placeholderText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "heading", function() { return heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleHeading", function() { return subtleHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "codeBlock", function() { return codeBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "link", function() { return link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkHover", function() { return linkHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkActive", function() { return linkActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkOutline", function() { return linkOutline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "primary", function() { return primary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blue", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "teal", function() { return teal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purple", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yellow", function() { return yellow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "green", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette8", function() { return colorPalette8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette16", function() { return colorPalette16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette24", function() { return colorPalette24; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette", function() { return colorPalette; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(377);


// Reds
var R50 = '#FFEBE6';
var R75 = '#FFBDAD';
var R100 = '#FF8F73';
var R200 = '#FF7452';
var R300 = '#FF5630';
var R400 = '#DE350B';
var R500 = '#BF2600'; // Yellows

var Y50 = '#FFFAE6';
var Y75 = '#FFF0B3';
var Y100 = '#FFE380';
var Y200 = '#FFC400';
var Y300 = '#FFAB00';
var Y400 = '#FF991F';
var Y500 = '#FF8B00'; // Greens

var G50 = '#E3FCEF';
var G75 = '#ABF5D1';
var G100 = '#79F2C0';
var G200 = '#57D9A3';
var G300 = '#36B37E';
var G400 = '#00875A';
var G500 = '#006644'; // Blues

var B50 = '#DEEBFF';
var B75 = '#B3D4FF';
var B100 = '#4C9AFF';
var B200 = '#2684FF';
var B300 = '#0065FF';
var B400 = '#0052CC';
var B500 = '#0747A6'; // Purples

var P50 = '#EAE6FF';
var P75 = '#C0B6F2';
var P100 = '#998DD9';
var P200 = '#8777D9';
var P300 = '#6554C0';
var P400 = '#5243AA';
var P500 = '#403294'; // Teals

var T50 = '#E6FCFF';
var T75 = '#B3F5FF';
var T100 = '#79E2F2';
var T200 = '#00C7E6';
var T300 = '#00B8D9';
var T400 = '#00A3BF';
var T500 = '#008DA6'; // Neutrals

var N0 = '#FFFFFF';
var N10 = '#FAFBFC';
var N20 = '#F4F5F7';
var N30 = '#EBECF0';
var N40 = '#DFE1E6';
var N50 = '#C1C7D0';
var N60 = '#B3BAC5';
var N70 = '#A5ADBA';
var N80 = '#97A0AF';
var N90 = '#8993A4';
var N100 = '#7A869A';
var N200 = '#6B778C';
var N300 = '#5E6C84';
var N400 = '#505F79';
var N500 = '#42526E';
var N600 = '#344563';
var N700 = '#253858';
var N800 = '#172B4D'; // ATTENTION: update the tints if you update this

var N900 = '#091E42'; // Each tint is made of N900 and an alpha channel

var N10A = 'rgba(9, 30, 66, 0.02)';
var N20A = 'rgba(9, 30, 66, 0.04)';
var N30A = 'rgba(9, 30, 66, 0.08)';
var N40A = 'rgba(9, 30, 66, 0.13)';
var N50A = 'rgba(9, 30, 66, 0.25)';
var N60A = 'rgba(9, 30, 66, 0.31)';
var N70A = 'rgba(9, 30, 66, 0.36)';
var N80A = 'rgba(9, 30, 66, 0.42)';
var N90A = 'rgba(9, 30, 66, 0.48)';
var N100A = 'rgba(9, 30, 66, 0.54)';
var N200A = 'rgba(9, 30, 66, 0.60)';
var N300A = 'rgba(9, 30, 66, 0.66)';
var N400A = 'rgba(9, 30, 66, 0.71)';
var N500A = 'rgba(9, 30, 66, 0.77)';
var N600A = 'rgba(9, 30, 66, 0.82)';
var N700A = 'rgba(9, 30, 66, 0.89)';
var N800A = 'rgba(9, 30, 66, 0.95)'; // Dark Mode Neutrals

var DN900 = '#E6EDFA';
var DN800 = '#DCE5F5';
var DN700 = '#CED9EB';
var DN600 = '#B8C7E0';
var DN500 = '#ABBBD6';
var DN400 = '#9FB0CC';
var DN300 = '#8C9CB8';
var DN200 = '#7988A3';
var DN100 = '#67758F';
var DN90 = '#56637A';
var DN80 = '#455166';
var DN70 = '#3B475C';
var DN60 = '#313D52';
var DN50 = '#283447';
var DN40 = '#202B3D';
var DN30 = '#1B2638';
var DN20 = '#121A29';
var DN10 = '#0E1624'; // ATTENTION: update the tints if you update this

var DN0 = '#0D1424'; // Each dark tint is made of DN0 and an alpha channel

var DN800A = 'rgba(13, 20, 36, 0.06)';
var DN700A = 'rgba(13, 20, 36, 0.14)';
var DN600A = 'rgba(13, 20, 36, 0.18)';
var DN500A = 'rgba(13, 20, 36, 0.29)';
var DN400A = 'rgba(13, 20, 36, 0.36)';
var DN300A = 'rgba(13, 20, 36, 0.40)';
var DN200A = 'rgba(13, 20, 36, 0.47)';
var DN100A = 'rgba(13, 20, 36, 0.53)';
var DN90A = 'rgba(13, 20, 36, 0.63)';
var DN80A = 'rgba(13, 20, 36, 0.73)';
var DN70A = 'rgba(13, 20, 36, 0.78)';
var DN60A = 'rgba(13, 20, 36, 0.81)';
var DN50A = 'rgba(13, 20, 36, 0.85)';
var DN40A = 'rgba(13, 20, 36, 0.89)';
var DN30A = 'rgba(13, 20, 36, 0.92)';
var DN20A = 'rgba(13, 20, 36, 0.95)';
var DN10A = 'rgba(13, 20, 36, 0.97)'; // Themed colors

var background = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N0,
  dark: DN30
});
var backgroundActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B50,
  dark: B75
});
var backgroundHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N30,
  dark: DN70
});
var backgroundOnLayer = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N0,
  dark: DN50
});
var text = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N900,
  dark: DN600
});
var textHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N800,
  dark: DN600
});
var textActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B400,
  dark: B400
});
var subtleText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N200,
  dark: DN300
});
var placeholderText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N100,
  dark: DN200
});
var heading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N800,
  dark: DN600
});
var subtleHeading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N200,
  dark: DN300
});
var codeBlock = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N20,
  dark: DN50
});
var link = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B400,
  dark: B100
});
var linkHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B300,
  dark: B200
});
var linkActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B500,
  dark: B100
});
var linkOutline = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B100,
  dark: B200
});
var primary = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B400,
  dark: B100
});
var blue = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B400,
  dark: B100
});
var teal = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: T300,
  dark: T200
});
var purple = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: P300,
  dark: P100
});
var red = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: R300,
  dark: R300
});
var yellow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: Y300,
  dark: Y300
});
var green = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: G300,
  dark: G300
}); // Jira Portfolio

var colorPalette8 = [{
  background: N800,
  text: N0
}, {
  background: R400,
  text: N0
}, {
  background: P400,
  text: P50
}, {
  background: B400,
  text: B75
}, {
  background: T300,
  text: N800
}, {
  background: G400,
  text: N0
}, {
  background: Y400,
  text: N800
}, {
  background: N70,
  text: N800
}];
var colorPalette16 = colorPalette8.concat([{
  background: N500,
  text: N0
}, {
  background: R100,
  text: N800
}, {
  background: P75,
  text: N800
}, {
  background: B100,
  text: N800
}, {
  background: T100,
  text: N800
}, {
  background: G100,
  text: G500
}, {
  background: Y200,
  text: N800
}, {
  background: N0,
  text: N800
}]);
var colorPalette24 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(colorPalette16).concat([{
  background: N100,
  text: N0
}, {
  background: N40,
  text: N800
}, {
  background: N50,
  text: R500
}, {
  background: P50,
  text: P500
}, {
  background: B50,
  text: B500
}, {
  background: T75,
  text: N800
}, {
  background: G50,
  text: G500
}, {
  background: Y75,
  text: N800
}]);
var colorPalette = function colorPalette() {
  var palette = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '8';

  switch (palette) {
    case '8':
      return colorPalette8;

    case '16':
      return colorPalette16;

    case '24':
      return colorPalette24;

    default:
      throw new Error('The only available color palette is 8, 16, 24');
  }
};

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return emojiRequest; });
/* unused harmony export getPixelRatio */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAltRepresentation; });
/* unused harmony export isMediaApiUrl */
/* unused harmony export denormaliseServiceRepresentation */
/* unused harmony export denormaliseServiceAltRepresentation */
/* unused harmony export denormaliseSkinEmoji */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return denormaliseEmojiServiceResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return shouldUseAltRepresentation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type_helpers__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_logger__ = __webpack_require__(119);




var emojiRequest = function (provider, options) {
    var _a = provider.getRatio, getRatio = _a === void 0 ? getPixelRatio : _a, serviceConfig = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](provider, ["getRatio"]);
    var scaleQueryParams = calculateScale(getRatio);
    var _b = options || {}, _c = _b.queryParams, queryParams = _c === void 0 ? {} : _c, otherOptions = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_b, ["queryParams"]);
    var requestOptions = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, otherOptions, { queryParams: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, scaleQueryParams, queryParams) });
    return __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */].requestService(serviceConfig, requestOptions);
};
var calculateScale = function (getRatio) {
    // Retina display
    if (getRatio() > 1) {
        return { scale: 'XHDPI', altScale: 'XXXHDPI' };
    }
    // Default set used for desktop
    return { altScale: 'XHDPI' };
};
var getPixelRatio = function () {
    return window.devicePixelRatio;
};
var getAltRepresentation = function (reps) {
    // Invalid reps handled outside function - logic may change depending what the service returns
    return reps[calculateScale(getPixelRatio).altScale];
};
var isMediaApiUrl = function (url, meta) {
    return !!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);
};
var denormaliseServiceRepresentation = function (representation, meta) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["n" /* isSpriteServiceRepresentation */])(representation) &&
        meta &&
        meta.spriteSheets) {
        var _a = representation, height = _a.height, width = _a.width, x = _a.x, y = _a.y, xIndex = _a.xIndex, yIndex = _a.yIndex, spriteRef = _a.spriteRef;
        var spriteSheet = meta.spriteSheets[spriteRef];
        if (spriteSheet) {
            return {
                sprite: spriteSheet,
                height: height,
                width: width,
                x: x,
                y: y,
                xIndex: xIndex,
                yIndex: yIndex,
            };
        }
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["h" /* isImageRepresentation */])(representation)) {
        var height = representation.height, width = representation.width, imagePath = representation.imagePath;
        if (isMediaApiUrl(imagePath, meta)) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["c" /* convertImageToMediaRepresentation */])(representation);
        }
        return {
            height: height,
            width: width,
            imagePath: imagePath,
        };
    }
    Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])('failed conversion for representation', representation, meta);
    return undefined;
};
var denormaliseServiceAltRepresentation = function (altReps, meta) {
    return !altReps || altReps === {}
        ? undefined
        : denormaliseServiceRepresentation(getAltRepresentation(altReps), meta);
};
var denormaliseSkinEmoji = function (emoji, meta) {
    if (!emoji.skinVariations) {
        return [];
    }
    var skinEmoji = emoji.skinVariations;
    var baseId = emoji.id;
    return skinEmoji.map(function (skin) {
        var representation = skin.representation, altRepresentations = skin.altRepresentations, other = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](skin, ["representation", "altRepresentations"]);
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ baseId: baseId, representation: denormaliseServiceRepresentation(representation, meta), altRepresentation: denormaliseServiceAltRepresentation(altRepresentations, meta) }, other);
    });
};
/**
 * Denormalised an emoji response (emojis + sprite references) into an array of
 * emoji with local sprite definitions.
 */
var denormaliseEmojiServiceResponse = function (emojiData) {
    var emojis = emojiData.emojis.map(function (emoji) {
        var newRepresentation = denormaliseServiceRepresentation(emoji.representation, emojiData.meta);
        var altRepresentation = denormaliseServiceAltRepresentation(emoji.altRepresentations, emojiData.meta);
        var newSkinVariations = denormaliseSkinEmoji(emoji, emojiData.meta);
        // create trimmedServiceDesc which is emoji with no representations or skinVariations
        var representation = emoji.representation, skinVariations = emoji.skinVariations, altRepresentations = emoji.altRepresentations, trimmedServiceDesc = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](emoji, ["representation", "skinVariations", "altRepresentations"]);
        var response = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, trimmedServiceDesc, { representation: newRepresentation, skinVariations: newSkinVariations });
        return Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["a" /* buildEmojiDescriptionWithAltRepresentation */])(response, altRepresentation);
    });
    var mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
    return {
        emojis: emojis,
        mediaApiToken: mediaApiToken,
    };
};
var getHeight = function (fitToHeight) {
    return getPixelRatio() > 1 ? fitToHeight * 2 : fitToHeight;
};
var shouldUseAltRepresentation = function (emoji, fitToHeight) {
    return !!(fitToHeight &&
        emoji.altRepresentation &&
        getHeight(fitToHeight) > emoji.representation.height);
};
//# sourceMappingURL=EmojiUtils.js.map

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(384);

Object.defineProperty(exports, 'AllSubstringsIndexStrategy', {
  enumerable: true,
  get: function get() {
    return _index.AllSubstringsIndexStrategy;
  }
});
Object.defineProperty(exports, 'ExactWordIndexStrategy', {
  enumerable: true,
  get: function get() {
    return _index.ExactWordIndexStrategy;
  }
});
Object.defineProperty(exports, 'PrefixIndexStrategy', {
  enumerable: true,
  get: function get() {
    return _index.PrefixIndexStrategy;
  }
});

var _index2 = __webpack_require__(385);

Object.defineProperty(exports, 'CaseSensitiveSanitizer', {
  enumerable: true,
  get: function get() {
    return _index2.CaseSensitiveSanitizer;
  }
});
Object.defineProperty(exports, 'LowerCaseSanitizer', {
  enumerable: true,
  get: function get() {
    return _index2.LowerCaseSanitizer;
  }
});

var _index3 = __webpack_require__(672);

Object.defineProperty(exports, 'TfIdfSearchIndex', {
  enumerable: true,
  get: function get() {
    return _index3.TfIdfSearchIndex;
  }
});
Object.defineProperty(exports, 'UnorderedSearchIndex', {
  enumerable: true,
  get: function get() {
    return _index3.UnorderedSearchIndex;
  }
});

var _index4 = __webpack_require__(674);

Object.defineProperty(exports, 'SimpleTokenizer', {
  enumerable: true,
  get: function get() {
    return _index4.SimpleTokenizer;
  }
});
Object.defineProperty(exports, 'StemmingTokenizer', {
  enumerable: true,
  get: function get() {
    return _index4.StemmingTokenizer;
  }
});
Object.defineProperty(exports, 'StopWordsTokenizer', {
  enumerable: true,
  get: function get() {
    return _index4.StopWordsTokenizer;
  }
});

var _Search = __webpack_require__(1827);

Object.defineProperty(exports, 'Search', {
  enumerable: true,
  get: function get() {
    return _Search.Search;
  }
});

var _StopWordsMap = __webpack_require__(675);

Object.defineProperty(exports, 'StopWordsMap', {
  enumerable: true,
  get: function get() {
    return _StopWordsMap.StopWordsMap;
  }
});

var _TokenHighlighter = __webpack_require__(1828);

Object.defineProperty(exports, 'TokenHighlighter', {
  enumerable: true,
  get: function get() {
    return _TokenHighlighter.TokenHighlighter;
  }
});
//# sourceMappingURL=index.js.map

/***/ }),
/* 197 */
/***/ (function(module, exports) {

/**
 * A doubly linked list-based Least Recently Used (LRU) cache. Will keep most
 * recently used items while discarding least recently used items when its limit
 * is reached.
 *
 * Licensed under MIT. Copyright (c) 2010 Rasmus Andersson <http://hunch.se/>
 * See README.md for details.
 *
 * Illustration of the design:
 *
 *       entry             entry             entry             entry
 *       ______            ______            ______            ______
 *      | head |.newer => |      |.newer => |      |.newer => | tail |
 *      |  A   |          |  B   |          |  C   |          |  D   |
 *      |______| <= older.|______| <= older.|______| <= older.|______|
 *
 *  removed  <--  <--  <--  <--  <--  <--  <--  <--  <--  <--  <--  added
 */
function LRUCache (limit) {
  // Current size of the cache. (Read-only).
  this.size = 0;
  // Maximum number of items this cache can hold.
  this.limit = limit;
  this.oldest = this.newest = undefined;
  this._keymap = {};
}


LRUCache.prototype._markEntryAsUsed = function(entry) {
  if (entry === this.newest) {
    // Already the most recenlty used entry, so no need to update the list
    return;
  }
  // HEAD--------------TAIL
  //   <.older   .newer>
  //  <--- add direction --
  //   A  B  C  <D>  E
  if (entry.newer) {
    if (entry === this.oldest) {
      this.oldest = entry.newer;
    }
    entry.newer.older = entry.older; // C <-- E.
  }
  if (entry.older) {
    entry.older.newer = entry.newer; // C. --> E
  }
  entry.newer = undefined; // D --x
  entry.older = this.newest; // D. --> E
  if (this.newest) {
    this.newest.newer = entry; // E. <-- D
  }
  this.newest = entry;
};

/**
 * Put <value> into the cache associated with <key>. Returns the entry which was
 * removed to make room for the new entry. Otherwise undefined is returned
 * (i.e. if there was enough room already).
 */
LRUCache.prototype.put = function(key, value) {
  var entry = this._keymap[key];

  if (entry) {
    // update existing
    entry.value = value;
    this._markEntryAsUsed(entry);
    return;
  }

  // new entry
  this._keymap[key] = entry = {key:key, value:value, older:undefined, newer:undefined};

  if (this.newest) {
    // link previous tail to the new tail (entry)
    this.newest.newer = entry;
    entry.older = this.newest;
  } else {
    // we're first in -- yay
    this.oldest = entry;
  }

  // add new entry to the end of the linked list -- it's now the freshest entry.
  this.newest = entry;
  this.size++;
  if (this.size > this.limit) {
    // we hit the limit -- remove the head
    return this.shift();
  }
};

/**
 * Purge the least recently used (oldest) entry from the cache. Returns the
 * removed entry or undefined if the cache was empty.
 *
 * If you need to perform any form of finalization of purged items, this is a
 * good place to do it. Simply override/replace this function:
 *
 *   var c = new LRUCache(123);
 *   c.shift = function() {
 *     var entry = LRUCache.prototype.shift.call(this);
 *     doSomethingWith(entry);
 *     return entry;
 *   }
 */
LRUCache.prototype.shift = function() {
  // todo: handle special case when limit == 1
  var entry = this.oldest;
  if (entry) {
    if (this.oldest.newer) {
      // advance the list
      this.oldest = this.oldest.newer;
      this.oldest.older = undefined;
    } else {
      // the cache is exhausted
      this.oldest = undefined;
      this.newest = undefined;
    }
    // Remove last strong reference to <entry> and remove links from the purged
    // entry being returned:
    entry.newer = entry.older = undefined;
    // delete is slow, but we need to do this to avoid uncontrollable growth:
    delete this._keymap[entry.key];
    this.size--;
  }
  return entry;
};

/**
 * Get and register recent use of <key>. Returns the value associated with <key>
 * or undefined if not in cache.
 */
LRUCache.prototype.get = function(key, returnEntry) {
  // First, find our cache entry
  var entry = this._keymap[key];
  if (entry === undefined) return; // Not cached. Sorry.
  // As <key> was found in the cache, register it as being requested recently
  this._markEntryAsUsed(entry);
  return returnEntry ? entry : entry.value;
};

// ----------------------------------------------------------------------------
// Following code is optional and can be removed without breaking the core
// functionality.

/**
 * Check if <key> is in the cache without registering recent use. Feasible if
 * you do not want to chage the state of the cache, but only "peek" at it.
 * Returns the entry associated with <key> if found, or undefined if not found.
 */
LRUCache.prototype.find = function(key) {
  return this._keymap[key];
};

/**
 * Update the value of entry with <key>. Returns the old value, or undefined if
 * entry was not in the cache.
 */
LRUCache.prototype.set = function(key, value) {
  var oldvalue, entry = this.get(key, true);
  if (entry) {
    oldvalue = entry.value;
    entry.value = value;
  } else {
    oldvalue = this.put(key, value);
    if (oldvalue) oldvalue = oldvalue.value;
  }
  return oldvalue;
};

/**
 * Remove entry <key> from cache and return its value. Returns undefined if not
 * found.
 */
LRUCache.prototype.remove = function(key) {
  var entry = this._keymap[key];
  if (!entry) return;
  delete this._keymap[entry.key]; // need to do delete unfortunately
  if (entry.newer && entry.older) {
    // relink the older entry with the newer entry
    entry.older.newer = entry.newer;
    entry.newer.older = entry.older;
  } else if (entry.newer) {
    // remove the link to us
    entry.newer.older = undefined;
    // link the newer entry to head
    this.oldest = entry.newer;
  } else if (entry.older) {
    // remove the link to us
    entry.older.newer = undefined;
    // link the newer entry to head
    this.newest = entry.older;
  } else {// if(entry.older === undefined && entry.newer === undefined) {
    this.oldest = this.newest = undefined;
  }

  this.size--;
  return entry.value;
};

/** Removes all entries */
LRUCache.prototype.removeAll = function() {
  // This should be safe, as we never expose strong refrences to the outside
  this.oldest = this.newest = undefined;
  this.size = 0;
  this._keymap = {};
};

/**
 * Return an array containing all keys of entries stored in the cache object, in
 * arbitrary order.
 */
if (typeof Object.keys === 'function') {
  LRUCache.prototype.keys = function() {
    return Object.keys(this._keymap);
  };
} else {
  LRUCache.prototype.keys = function() {
    var keys = [];
    for (var k in this._keymap) {
      keys.push(k);
    }
    return keys;
  };
}

/**
 * Call `fun` for each entry. Starting with the newest entry if `desc` is a true
 * value, otherwise starts with the oldest (head) enrty and moves towards the
 * tail.
 *
 * `fun` is called with 3 arguments in the context `context`:
 *   `fun.call(context, Object key, Object value, LRUCache self)`
 */
LRUCache.prototype.forEach = function(fun, context, desc) {
  var entry;
  if (context === true) {
    desc = true;
    context = undefined;
  } else if (typeof context !== 'object') {
    context = this;
  }
  if (desc) {
    entry = this.newest;
    while (entry) {
      fun.call(context, entry.key, entry.value, this);
      entry = entry.older;
    }
  } else {
    entry = this.oldest;
    while (entry) {
      fun.call(context, entry.key, entry.value, this);
      entry = entry.newer;
    }
  }
};

/** Returns a JSON (array) representation */
LRUCache.prototype.toJSON = function() {
  var s = new Array(this.size), i = 0, entry = this.oldest;
  while (entry) {
    s[i++] = { key: entry.key, value: entry.value };
    entry = entry.newer;
  }
  return s;
};

/** Returns a String representation */
LRUCache.prototype.toString = function() {
  var s = '', entry = this.oldest;
  while (entry) {
    s += String(entry.key)+':'+entry.value;
    entry = entry.newer;
    if (entry) {
      s += ' < ';
    }
  }
  return s;
};

// Export ourselves
if (typeof this === 'object') this.LRUCache = LRUCache;


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export enableLogger */
/* unused harmony export enableStacktraces */
/* unused harmony export logStacktrace */
/* harmony export (immutable) */ __webpack_exports__["a"] = debug;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

var debugEnabled = false;
var stacktracesEnabled = false;
function enableLogger(enable) {
    debugEnabled = enable;
}
function enableStacktraces(enable) {
    stacktracesEnabled = enable;
}
function logStacktrace() {
    if (stacktracesEnabled) {
        // tslint:disable-next-line:no-console
        console.log(new Error().stack);
    }
}
function debug(msg) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (debugEnabled) {
        // tslint:disable-next-line:no-console
        console.log.apply(console, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"]([msg], args));
    }
}
//# sourceMappingURL=logger.js.map

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRANSITION_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AVATAR_SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AVATAR_RADIUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BORDER_WIDTH; });
/* unused harmony export EXCESS_INDICATOR_FONT_SIZE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ICON_SIZES; });
/* unused harmony export ICON_OFFSET */
/* unused harmony export SQUARE_ICON_OFFSET */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);

var TRANSITION_DURATION = '200ms';
var gridSizeValue = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["gridSize"])();
var AVATAR_SIZES = {
  xsmall: gridSizeValue * 2,
  small: gridSizeValue * 3,
  medium: gridSizeValue * 4,
  large: gridSizeValue * 5,
  xlarge: gridSizeValue * 12,
  xxlarge: gridSizeValue * 16
}; // border radius only applies to "square" avatars

var AVATAR_RADIUS = {
  xsmall: 2,
  small: 2,
  medium: 3,
  large: 3,
  xlarge: 6,
  xxlarge: 12
};
var BORDER_WIDTH = {
  xsmall: 2,
  small: 2,
  medium: 2,
  large: 2,
  xlarge: 2,
  xxlarge: 2
}; // NOTE: sizes xsmall & xxlarge DO NOT support
// - groups
// - presence
// - status

var EXCESS_INDICATOR_FONT_SIZE = {
  small: 10,
  medium: 11,
  large: 12,
  xlarge: 16
};
var ICON_SIZES = {
  small: 12,
  medium: 14,
  large: 15,
  xlarge: 18
};
var ICON_OFFSET = {
  small: 0,
  medium: 0,
  large: 1,
  xlarge: 7
};
var SQUARE_ICON_OFFSET = {
  small: 0,
  medium: 0,
  large: 0,
  xlarge: 1
};

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventDispatcher; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createDispatch;
var EventDispatcher = /** @class */ (function () {
    function EventDispatcher() {
        this.listeners = {};
    }
    EventDispatcher.prototype.on = function (event, cb) {
        if (!this.listeners[event]) {
            this.listeners[event] = [];
        }
        this.listeners[event].push(cb);
    };
    EventDispatcher.prototype.off = function (event, cb) {
        if (!this.listeners[event]) {
            return;
        }
        this.listeners[event] = this.listeners[event].filter(function (callback) { return callback !== cb; });
    };
    EventDispatcher.prototype.emit = function (event, data) {
        if (!this.listeners[event]) {
            return;
        }
        this.listeners[event].forEach(function (cb) { return cb(data); });
    };
    EventDispatcher.prototype.destroy = function () {
        this.listeners = {};
    };
    return EventDispatcher;
}());

/**
 * Creates a dispatch function that can be called inside ProseMirror Plugin
 * to notify listeners about that plugin's state change.
 */
function createDispatch(eventDispatcher) {
    return function (eventName, data) {
        if (!eventName) {
            throw new Error('event name is required!');
        }
        var event = typeof eventName === 'string'
            ? eventName
            : eventName.key;
        eventDispatcher.emit(event, data);
    };
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Side; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return JSON_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GapCursorSelection; });
/* unused harmony export GapBookmark */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(410);




var Side;
(function (Side) {
    Side["LEFT"] = "left";
    Side["RIGHT"] = "right";
})(Side || (Side = {}));
var JSON_ID = 'gapcursor';
var GapCursorSelection = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](GapCursorSelection, _super);
    /**
     * Construct a GapCursorSelection
     * @param {ResolvedPos} $pos resolved position
     * @param {Side} side side where the gap cursor is drawn
     */
    function GapCursorSelection($pos, side) {
        if (side === void 0) { side = Side.LEFT; }
        var _this = _super.call(this, $pos, $pos) || this;
        _this.side = side;
        _this.visible = false;
        return _this;
    }
    GapCursorSelection.valid = function ($pos) {
        var parent = $pos.parent, nodeBefore = $pos.nodeBefore, nodeAfter = $pos.nodeAfter;
        var targetNode = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* isValidTargetNode */])(nodeBefore)
            ? nodeBefore
            : Object(__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* isValidTargetNode */])(nodeAfter)
                ? nodeAfter
                : null;
        if (!targetNode || parent.isTextblock) {
            return false;
        }
        var deflt = parent.contentMatchAt($pos.index()).defaultType;
        return deflt && deflt.isTextblock;
    };
    GapCursorSelection.findFrom = function ($pos, dir, mustMove) {
        if (mustMove === void 0) { mustMove = false; }
        var side = dir === 1 ? Side.RIGHT : Side.LEFT;
        if (!mustMove && GapCursorSelection.valid($pos)) {
            return new GapCursorSelection($pos, side);
        }
        var pos = $pos.pos;
        // TODO: Fix any, potential issue. ED-5048
        var next = null;
        // Scan up from this position
        for (var d = $pos.depth;; d--) {
            var parent_1 = $pos.node(d);
            if (side === Side.RIGHT
                ? $pos.indexAfter(d) < parent_1.childCount
                : $pos.index(d) > 0) {
                next = parent_1.maybeChild(side === Side.RIGHT ? $pos.indexAfter(d) : $pos.index(d) - 1);
                break;
            }
            else if (d === 0) {
                return null;
            }
            pos += dir;
            var $cur = $pos.doc.resolve(pos);
            if (GapCursorSelection.valid($cur)) {
                return new GapCursorSelection($cur, side);
            }
        }
        // And then down into the next node
        for (;;) {
            next = side === Side.RIGHT ? next.firstChild : next.lastChild;
            if (next === null) {
                break;
            }
            pos += dir;
            var $cur = $pos.doc.resolve(pos);
            if (GapCursorSelection.valid($cur)) {
                return new GapCursorSelection($cur, side);
            }
        }
        return null;
    };
    GapCursorSelection.fromJSON = function (doc, json) {
        return new GapCursorSelection(doc.resolve(json.pos));
    };
    GapCursorSelection.prototype.map = function (doc, mapping) {
        var $pos = doc.resolve(mapping.map(this.head));
        return GapCursorSelection.valid($pos)
            ? new GapCursorSelection($pos, this.side)
            : __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Selection"].near($pos);
    };
    GapCursorSelection.prototype.eq = function (other) {
        return other instanceof GapCursorSelection && other.head === this.head;
    };
    GapCursorSelection.prototype.content = function () {
        return __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__["Slice"].empty;
    };
    GapCursorSelection.prototype.getBookmark = function () {
        return new GapBookmark(this.anchor);
    };
    GapCursorSelection.prototype.toJSON = function () {
        return { pos: this.head, type: JSON_ID };
    };
    return GapCursorSelection;
}(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Selection"]));

__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Selection"].jsonID(JSON_ID, GapCursorSelection);
var GapBookmark = /** @class */ (function () {
    function GapBookmark(pos) {
        this.pos = pos;
    }
    GapBookmark.prototype.map = function (mapping) {
        return new GapBookmark(mapping.map(this.pos));
    };
    GapBookmark.prototype.resolve = function (doc) {
        var $pos = doc.resolve(this.pos);
        return GapCursorSelection.valid($pos)
            ? new GapCursorSelection($pos)
            : __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Selection"].near($pos);
    };
    return GapBookmark;
}());

//# sourceMappingURL=selection.js.map

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R50", function() { return R50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R75", function() { return R75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R100", function() { return R100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R200", function() { return R200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R300", function() { return R300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R400", function() { return R400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R500", function() { return R500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y50", function() { return Y50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y75", function() { return Y75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y100", function() { return Y100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y200", function() { return Y200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y300", function() { return Y300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y400", function() { return Y400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y500", function() { return Y500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G50", function() { return G50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G75", function() { return G75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G100", function() { return G100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G200", function() { return G200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G300", function() { return G300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G400", function() { return G400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G500", function() { return G500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B50", function() { return B50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B75", function() { return B75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B100", function() { return B100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B200", function() { return B200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B300", function() { return B300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B400", function() { return B400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B500", function() { return B500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P50", function() { return P50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P75", function() { return P75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P100", function() { return P100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P200", function() { return P200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P300", function() { return P300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P400", function() { return P400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P500", function() { return P500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T50", function() { return T50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T75", function() { return T75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T100", function() { return T100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T200", function() { return T200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T300", function() { return T300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T400", function() { return T400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T500", function() { return T500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N0", function() { return N0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10", function() { return N10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20", function() { return N20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30", function() { return N30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40", function() { return N40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50", function() { return N50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60", function() { return N60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70", function() { return N70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80", function() { return N80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90", function() { return N90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100", function() { return N100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200", function() { return N200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300", function() { return N300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400", function() { return N400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500", function() { return N500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600", function() { return N600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700", function() { return N700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800", function() { return N800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N900", function() { return N900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10A", function() { return N10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20A", function() { return N20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30A", function() { return N30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40A", function() { return N40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50A", function() { return N50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60A", function() { return N60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70A", function() { return N70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80A", function() { return N80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90A", function() { return N90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100A", function() { return N100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200A", function() { return N200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300A", function() { return N300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400A", function() { return N400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500A", function() { return N500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600A", function() { return N600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700A", function() { return N700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800A", function() { return N800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN900", function() { return DN900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800", function() { return DN800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700", function() { return DN700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600", function() { return DN600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500", function() { return DN500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400", function() { return DN400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300", function() { return DN300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200", function() { return DN200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100", function() { return DN100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90", function() { return DN90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80", function() { return DN80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70", function() { return DN70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60", function() { return DN60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50", function() { return DN50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40", function() { return DN40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30", function() { return DN30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20", function() { return DN20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10", function() { return DN10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN0", function() { return DN0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800A", function() { return DN800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700A", function() { return DN700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600A", function() { return DN600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500A", function() { return DN500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400A", function() { return DN400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300A", function() { return DN300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200A", function() { return DN200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100A", function() { return DN100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90A", function() { return DN90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80A", function() { return DN80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70A", function() { return DN70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60A", function() { return DN60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50A", function() { return DN50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40A", function() { return DN40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30A", function() { return DN30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20A", function() { return DN20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10A", function() { return DN10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "background", function() { return background; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundActive", function() { return backgroundActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundHover", function() { return backgroundHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundOnLayer", function() { return backgroundOnLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "text", function() { return text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textHover", function() { return textHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textActive", function() { return textActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleText", function() { return subtleText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "placeholderText", function() { return placeholderText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "heading", function() { return heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleHeading", function() { return subtleHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "codeBlock", function() { return codeBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "link", function() { return link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkHover", function() { return linkHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkActive", function() { return linkActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkOutline", function() { return linkOutline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "primary", function() { return primary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blue", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "teal", function() { return teal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purple", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yellow", function() { return yellow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "green", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette8", function() { return colorPalette8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette16", function() { return colorPalette16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette24", function() { return colorPalette24; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette", function() { return colorPalette; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(413);


// Reds
var R50 = '#FFEBE6';
var R75 = '#FFBDAD';
var R100 = '#FF8F73';
var R200 = '#FF7452';
var R300 = '#FF5630';
var R400 = '#DE350B';
var R500 = '#BF2600'; // Yellows

var Y50 = '#FFFAE6';
var Y75 = '#FFF0B3';
var Y100 = '#FFE380';
var Y200 = '#FFC400';
var Y300 = '#FFAB00';
var Y400 = '#FF991F';
var Y500 = '#FF8B00'; // Greens

var G50 = '#E3FCEF';
var G75 = '#ABF5D1';
var G100 = '#79F2C0';
var G200 = '#57D9A3';
var G300 = '#36B37E';
var G400 = '#00875A';
var G500 = '#006644'; // Blues

var B50 = '#DEEBFF';
var B75 = '#B3D4FF';
var B100 = '#4C9AFF';
var B200 = '#2684FF';
var B300 = '#0065FF';
var B400 = '#0052CC';
var B500 = '#0747A6'; // Purples

var P50 = '#EAE6FF';
var P75 = '#C0B6F2';
var P100 = '#998DD9';
var P200 = '#8777D9';
var P300 = '#6554C0';
var P400 = '#5243AA';
var P500 = '#403294'; // Teals

var T50 = '#E6FCFF';
var T75 = '#B3F5FF';
var T100 = '#79E2F2';
var T200 = '#00C7E6';
var T300 = '#00B8D9';
var T400 = '#00A3BF';
var T500 = '#008DA6'; // Neutrals

var N0 = '#FFFFFF';
var N10 = '#FAFBFC';
var N20 = '#F4F5F7';
var N30 = '#EBECF0';
var N40 = '#DFE1E6';
var N50 = '#C1C7D0';
var N60 = '#B3BAC5';
var N70 = '#A5ADBA';
var N80 = '#97A0AF';
var N90 = '#8993A4';
var N100 = '#7A869A';
var N200 = '#6B778C';
var N300 = '#5E6C84';
var N400 = '#505F79';
var N500 = '#42526E';
var N600 = '#344563';
var N700 = '#253858';
var N800 = '#172B4D'; // ATTENTION: update the tints if you update this

var N900 = '#091E42'; // Each tint is made of N900 and an alpha channel

var N10A = 'rgba(9, 30, 66, 0.02)';
var N20A = 'rgba(9, 30, 66, 0.04)';
var N30A = 'rgba(9, 30, 66, 0.08)';
var N40A = 'rgba(9, 30, 66, 0.13)';
var N50A = 'rgba(9, 30, 66, 0.25)';
var N60A = 'rgba(9, 30, 66, 0.31)';
var N70A = 'rgba(9, 30, 66, 0.36)';
var N80A = 'rgba(9, 30, 66, 0.42)';
var N90A = 'rgba(9, 30, 66, 0.48)';
var N100A = 'rgba(9, 30, 66, 0.54)';
var N200A = 'rgba(9, 30, 66, 0.60)';
var N300A = 'rgba(9, 30, 66, 0.66)';
var N400A = 'rgba(9, 30, 66, 0.71)';
var N500A = 'rgba(9, 30, 66, 0.77)';
var N600A = 'rgba(9, 30, 66, 0.82)';
var N700A = 'rgba(9, 30, 66, 0.89)';
var N800A = 'rgba(9, 30, 66, 0.95)'; // Dark Mode Neutrals

var DN900 = '#E6EDFA';
var DN800 = '#DCE5F5';
var DN700 = '#CED9EB';
var DN600 = '#B8C7E0';
var DN500 = '#ABBBD6';
var DN400 = '#9FB0CC';
var DN300 = '#8C9CB8';
var DN200 = '#7988A3';
var DN100 = '#67758F';
var DN90 = '#56637A';
var DN80 = '#455166';
var DN70 = '#3B475C';
var DN60 = '#313D52';
var DN50 = '#283447';
var DN40 = '#202B3D';
var DN30 = '#1B2638';
var DN20 = '#121A29';
var DN10 = '#0E1624'; // ATTENTION: update the tints if you update this

var DN0 = '#0D1424'; // Each dark tint is made of DN0 and an alpha channel

var DN800A = 'rgba(13, 20, 36, 0.06)';
var DN700A = 'rgba(13, 20, 36, 0.14)';
var DN600A = 'rgba(13, 20, 36, 0.18)';
var DN500A = 'rgba(13, 20, 36, 0.29)';
var DN400A = 'rgba(13, 20, 36, 0.36)';
var DN300A = 'rgba(13, 20, 36, 0.40)';
var DN200A = 'rgba(13, 20, 36, 0.47)';
var DN100A = 'rgba(13, 20, 36, 0.53)';
var DN90A = 'rgba(13, 20, 36, 0.63)';
var DN80A = 'rgba(13, 20, 36, 0.73)';
var DN70A = 'rgba(13, 20, 36, 0.78)';
var DN60A = 'rgba(13, 20, 36, 0.81)';
var DN50A = 'rgba(13, 20, 36, 0.85)';
var DN40A = 'rgba(13, 20, 36, 0.89)';
var DN30A = 'rgba(13, 20, 36, 0.92)';
var DN20A = 'rgba(13, 20, 36, 0.95)';
var DN10A = 'rgba(13, 20, 36, 0.97)'; // Themed colors

var background = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N0,
  dark: DN30
});
var backgroundActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B50,
  dark: B75
});
var backgroundHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N30,
  dark: DN70
});
var backgroundOnLayer = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N0,
  dark: DN50
});
var text = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N900,
  dark: DN600
});
var textHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N800,
  dark: DN600
});
var textActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B400,
  dark: B400
});
var subtleText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N200,
  dark: DN300
});
var placeholderText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N100,
  dark: DN200
});
var heading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N800,
  dark: DN600
});
var subtleHeading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N200,
  dark: DN300
});
var codeBlock = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N20,
  dark: DN50
});
var link = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B400,
  dark: B100
});
var linkHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B300,
  dark: B200
});
var linkActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B500,
  dark: B100
});
var linkOutline = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B100,
  dark: B200
});
var primary = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B400,
  dark: B100
});
var blue = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B400,
  dark: B100
});
var teal = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: T300,
  dark: T200
});
var purple = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: P300,
  dark: P100
});
var red = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: R300,
  dark: R300
});
var yellow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: Y300,
  dark: Y300
});
var green = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: G300,
  dark: G300
}); // Jira Portfolio

var colorPalette8 = [{
  background: N800,
  text: N0
}, {
  background: R400,
  text: N0
}, {
  background: P400,
  text: P50
}, {
  background: B400,
  text: B75
}, {
  background: T300,
  text: N800
}, {
  background: G400,
  text: N0
}, {
  background: Y400,
  text: N800
}, {
  background: N70,
  text: N800
}];
var colorPalette16 = colorPalette8.concat([{
  background: N500,
  text: N0
}, {
  background: R100,
  text: N800
}, {
  background: P75,
  text: N800
}, {
  background: B100,
  text: N800
}, {
  background: T100,
  text: N800
}, {
  background: G100,
  text: G500
}, {
  background: Y200,
  text: N800
}, {
  background: N0,
  text: N800
}]);
var colorPalette24 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(colorPalette16).concat([{
  background: N100,
  text: N0
}, {
  background: N40,
  text: N800
}, {
  background: N50,
  text: R500
}, {
  background: P50,
  text: P500
}, {
  background: B50,
  text: B500
}, {
  background: T75,
  text: N800
}, {
  background: G50,
  text: G500
}, {
  background: Y75,
  text: N800
}]);
var colorPalette = function colorPalette() {
  var palette = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '8';

  switch (palette) {
    case '8':
      return colorPalette8;

    case '16':
      return colorPalette16;

    case '24':
      return colorPalette24;

    default:
      throw new Error('The only available color palette is 8, 16, 24');
  }
};

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return minWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return maxWidth; });
var minWidth = 200;
var maxWidth = 400;
//# sourceMappingURL=dimensions.js.map

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return focusManagerContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectionCacheContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectionManagerContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clickManagerContext; });
var prefix = function prefix(key) {
  return "@atlaskit-private-do-not-use/dropdown-menu:".concat(key);
};

var focusManagerContext = prefix('focus-manager');
var selectionCacheContext = prefix('selection-cache');
var selectionManagerContext = prefix('selection-manager');
var clickManagerContext = prefix('click-manager');

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Frame; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled__ = __webpack_require__(2231);



var Frame = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Frame, _super);
    function Frame() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (event) {
            var onClick = _this.props.onClick;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick();
            }
        };
        _this.handleKeyPress = function (event) {
            if (event.key !== ' ' && event.key !== 'Enter') {
                return;
            }
            var onClick = _this.props.onClick;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick();
            }
        };
        return _this;
    }
    Frame.prototype.render = function () {
        var _a = this.props, isSelected = _a.isSelected, children = _a.children, onClick = _a.onClick, link = _a.link;
        var isInteractive = Boolean(onClick);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["a" /* Wrapper */], { target: "_blank", href: link, isSelected: isSelected, isInteractive: isInteractive, tabIndex: isInteractive ? 0 : undefined, role: isInteractive ? 'button' : undefined, onClick: this.handleClick, onKeyPress: this.handleKeyPress }, children));
    };
    return Frame;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconAndTitleLayout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled__ = __webpack_require__(2232);



var IconAndTitleLayout = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](IconAndTitleLayout, _super);
    function IconAndTitleLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconAndTitleLayout.prototype.render = function () {
        var _a = this.props, icon = _a.icon, title = _a.title, children = _a.children;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            icon && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["a" /* IconWrapper */], null, icon),
            title,
            children && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["b" /* OtherWrapper */], null, children)));
    };
    return IconAndTitleLayout;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R50", function() { return R50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R75", function() { return R75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R100", function() { return R100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R200", function() { return R200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R300", function() { return R300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R400", function() { return R400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R500", function() { return R500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y50", function() { return Y50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y75", function() { return Y75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y100", function() { return Y100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y200", function() { return Y200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y300", function() { return Y300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y400", function() { return Y400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y500", function() { return Y500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G50", function() { return G50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G75", function() { return G75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G100", function() { return G100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G200", function() { return G200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G300", function() { return G300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G400", function() { return G400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G500", function() { return G500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B50", function() { return B50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B75", function() { return B75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B100", function() { return B100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B200", function() { return B200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B300", function() { return B300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B400", function() { return B400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B500", function() { return B500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P50", function() { return P50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P75", function() { return P75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P100", function() { return P100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P200", function() { return P200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P300", function() { return P300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P400", function() { return P400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P500", function() { return P500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T50", function() { return T50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T75", function() { return T75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T100", function() { return T100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T200", function() { return T200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T300", function() { return T300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T400", function() { return T400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T500", function() { return T500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N0", function() { return N0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10", function() { return N10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20", function() { return N20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30", function() { return N30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40", function() { return N40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50", function() { return N50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60", function() { return N60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70", function() { return N70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80", function() { return N80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90", function() { return N90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100", function() { return N100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200", function() { return N200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300", function() { return N300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400", function() { return N400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500", function() { return N500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600", function() { return N600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700", function() { return N700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800", function() { return N800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N900", function() { return N900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10A", function() { return N10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20A", function() { return N20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30A", function() { return N30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40A", function() { return N40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50A", function() { return N50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60A", function() { return N60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70A", function() { return N70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80A", function() { return N80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90A", function() { return N90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100A", function() { return N100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200A", function() { return N200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300A", function() { return N300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400A", function() { return N400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500A", function() { return N500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600A", function() { return N600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700A", function() { return N700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800A", function() { return N800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN900", function() { return DN900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800", function() { return DN800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700", function() { return DN700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600", function() { return DN600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500", function() { return DN500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400", function() { return DN400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300", function() { return DN300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200", function() { return DN200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100", function() { return DN100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90", function() { return DN90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80", function() { return DN80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70", function() { return DN70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60", function() { return DN60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50", function() { return DN50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40", function() { return DN40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30", function() { return DN30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20", function() { return DN20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10", function() { return DN10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN0", function() { return DN0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800A", function() { return DN800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700A", function() { return DN700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600A", function() { return DN600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500A", function() { return DN500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400A", function() { return DN400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300A", function() { return DN300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200A", function() { return DN200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100A", function() { return DN100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90A", function() { return DN90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80A", function() { return DN80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70A", function() { return DN70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60A", function() { return DN60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50A", function() { return DN50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40A", function() { return DN40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30A", function() { return DN30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20A", function() { return DN20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10A", function() { return DN10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "background", function() { return background; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundActive", function() { return backgroundActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundHover", function() { return backgroundHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundOnLayer", function() { return backgroundOnLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "text", function() { return text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textHover", function() { return textHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textActive", function() { return textActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleText", function() { return subtleText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "placeholderText", function() { return placeholderText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "heading", function() { return heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleHeading", function() { return subtleHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "codeBlock", function() { return codeBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "link", function() { return link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkHover", function() { return linkHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkActive", function() { return linkActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkOutline", function() { return linkOutline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "primary", function() { return primary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blue", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "teal", function() { return teal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purple", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yellow", function() { return yellow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "green", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette8", function() { return colorPalette8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette16", function() { return colorPalette16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette24", function() { return colorPalette24; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette", function() { return colorPalette; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(427);


// Reds
var R50 = '#FFEBE6';
var R75 = '#FFBDAD';
var R100 = '#FF8F73';
var R200 = '#FF7452';
var R300 = '#FF5630';
var R400 = '#DE350B';
var R500 = '#BF2600'; // Yellows

var Y50 = '#FFFAE6';
var Y75 = '#FFF0B3';
var Y100 = '#FFE380';
var Y200 = '#FFC400';
var Y300 = '#FFAB00';
var Y400 = '#FF991F';
var Y500 = '#FF8B00'; // Greens

var G50 = '#E3FCEF';
var G75 = '#ABF5D1';
var G100 = '#79F2C0';
var G200 = '#57D9A3';
var G300 = '#36B37E';
var G400 = '#00875A';
var G500 = '#006644'; // Blues

var B50 = '#DEEBFF';
var B75 = '#B3D4FF';
var B100 = '#4C9AFF';
var B200 = '#2684FF';
var B300 = '#0065FF';
var B400 = '#0052CC';
var B500 = '#0747A6'; // Purples

var P50 = '#EAE6FF';
var P75 = '#C0B6F2';
var P100 = '#998DD9';
var P200 = '#8777D9';
var P300 = '#6554C0';
var P400 = '#5243AA';
var P500 = '#403294'; // Teals

var T50 = '#E6FCFF';
var T75 = '#B3F5FF';
var T100 = '#79E2F2';
var T200 = '#00C7E6';
var T300 = '#00B8D9';
var T400 = '#00A3BF';
var T500 = '#008DA6'; // Neutrals

var N0 = '#FFFFFF';
var N10 = '#FAFBFC';
var N20 = '#F4F5F7';
var N30 = '#EBECF0';
var N40 = '#DFE1E6';
var N50 = '#C1C7D0';
var N60 = '#B3BAC5';
var N70 = '#A5ADBA';
var N80 = '#97A0AF';
var N90 = '#8993A4';
var N100 = '#7A869A';
var N200 = '#6B778C';
var N300 = '#5E6C84';
var N400 = '#505F79';
var N500 = '#42526E';
var N600 = '#344563';
var N700 = '#253858';
var N800 = '#172B4D'; // ATTENTION: update the tints if you update this

var N900 = '#091E42'; // Each tint is made of N900 and an alpha channel

var N10A = 'rgba(9, 30, 66, 0.02)';
var N20A = 'rgba(9, 30, 66, 0.04)';
var N30A = 'rgba(9, 30, 66, 0.08)';
var N40A = 'rgba(9, 30, 66, 0.13)';
var N50A = 'rgba(9, 30, 66, 0.25)';
var N60A = 'rgba(9, 30, 66, 0.31)';
var N70A = 'rgba(9, 30, 66, 0.36)';
var N80A = 'rgba(9, 30, 66, 0.42)';
var N90A = 'rgba(9, 30, 66, 0.48)';
var N100A = 'rgba(9, 30, 66, 0.54)';
var N200A = 'rgba(9, 30, 66, 0.60)';
var N300A = 'rgba(9, 30, 66, 0.66)';
var N400A = 'rgba(9, 30, 66, 0.71)';
var N500A = 'rgba(9, 30, 66, 0.77)';
var N600A = 'rgba(9, 30, 66, 0.82)';
var N700A = 'rgba(9, 30, 66, 0.89)';
var N800A = 'rgba(9, 30, 66, 0.95)'; // Dark Mode Neutrals

var DN900 = '#E6EDFA';
var DN800 = '#DCE5F5';
var DN700 = '#CED9EB';
var DN600 = '#B8C7E0';
var DN500 = '#ABBBD6';
var DN400 = '#9FB0CC';
var DN300 = '#8C9CB8';
var DN200 = '#7988A3';
var DN100 = '#67758F';
var DN90 = '#56637A';
var DN80 = '#455166';
var DN70 = '#3B475C';
var DN60 = '#313D52';
var DN50 = '#283447';
var DN40 = '#202B3D';
var DN30 = '#1B2638';
var DN20 = '#121A29';
var DN10 = '#0E1624'; // ATTENTION: update the tints if you update this

var DN0 = '#0D1424'; // Each dark tint is made of DN0 and an alpha channel

var DN800A = 'rgba(13, 20, 36, 0.06)';
var DN700A = 'rgba(13, 20, 36, 0.14)';
var DN600A = 'rgba(13, 20, 36, 0.18)';
var DN500A = 'rgba(13, 20, 36, 0.29)';
var DN400A = 'rgba(13, 20, 36, 0.36)';
var DN300A = 'rgba(13, 20, 36, 0.40)';
var DN200A = 'rgba(13, 20, 36, 0.47)';
var DN100A = 'rgba(13, 20, 36, 0.53)';
var DN90A = 'rgba(13, 20, 36, 0.63)';
var DN80A = 'rgba(13, 20, 36, 0.73)';
var DN70A = 'rgba(13, 20, 36, 0.78)';
var DN60A = 'rgba(13, 20, 36, 0.81)';
var DN50A = 'rgba(13, 20, 36, 0.85)';
var DN40A = 'rgba(13, 20, 36, 0.89)';
var DN30A = 'rgba(13, 20, 36, 0.92)';
var DN20A = 'rgba(13, 20, 36, 0.95)';
var DN10A = 'rgba(13, 20, 36, 0.97)'; // Themed colors

var background = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N0,
  dark: DN30
});
var backgroundActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B50,
  dark: B75
});
var backgroundHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N30,
  dark: DN70
});
var backgroundOnLayer = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N0,
  dark: DN50
});
var text = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N900,
  dark: DN600
});
var textHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N800,
  dark: DN600
});
var textActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B400,
  dark: B400
});
var subtleText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N200,
  dark: DN300
});
var placeholderText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N100,
  dark: DN200
});
var heading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N800,
  dark: DN600
});
var subtleHeading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N200,
  dark: DN300
});
var codeBlock = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N20,
  dark: DN50
});
var link = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B400,
  dark: B100
});
var linkHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B300,
  dark: B200
});
var linkActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B500,
  dark: B100
});
var linkOutline = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B100,
  dark: B200
});
var primary = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B400,
  dark: B100
});
var blue = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B400,
  dark: B100
});
var teal = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: T300,
  dark: T200
});
var purple = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: P300,
  dark: P100
});
var red = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: R300,
  dark: R300
});
var yellow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: Y300,
  dark: Y300
});
var green = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: G300,
  dark: G300
}); // Jira Portfolio

var colorPalette8 = [{
  background: N800,
  text: N0
}, {
  background: R400,
  text: N0
}, {
  background: P400,
  text: P50
}, {
  background: B400,
  text: B75
}, {
  background: T300,
  text: N800
}, {
  background: G400,
  text: N0
}, {
  background: Y400,
  text: N800
}, {
  background: N70,
  text: N800
}];
var colorPalette16 = colorPalette8.concat([{
  background: N500,
  text: N0
}, {
  background: R100,
  text: N800
}, {
  background: P75,
  text: N800
}, {
  background: B100,
  text: N800
}, {
  background: T100,
  text: N800
}, {
  background: G100,
  text: G500
}, {
  background: Y200,
  text: N800
}, {
  background: N0,
  text: N800
}]);
var colorPalette24 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(colorPalette16).concat([{
  background: N100,
  text: N0
}, {
  background: N40,
  text: N800
}, {
  background: N50,
  text: R500
}, {
  background: P50,
  text: P500
}, {
  background: B50,
  text: B500
}, {
  background: T75,
  text: N800
}, {
  background: G50,
  text: G500
}, {
  background: Y75,
  text: N800
}]);
var colorPalette = function colorPalette() {
  var palette = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '8';

  switch (palette) {
    case '8':
      return colorPalette8;

    case '16':
      return colorPalette16;

    case '24':
      return colorPalette24;

    default:
      throw new Error('The only available color palette is 8, 16, 24');
  }
};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabHook__ = __webpack_require__(2336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__focusMerge__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__focusInside__ = __webpack_require__(2342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__focusIsHidden__ = __webpack_require__(2343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__setFocus__ = __webpack_require__(2344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_all_affected__ = __webpack_require__(433);
/* unused harmony reexport tabHook */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__focusInside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__focusIsHidden__["a"]; });
/* unused harmony reexport focusMerge */
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__constants__; });
/* unused harmony reexport getAllAffectedNodes */










/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_4__setFocus__["a" /* default */]);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ReactNodeViewState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return stateKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return plugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);

var ReactNodeViewState = /** @class */ (function () {
    function ReactNodeViewState() {
        this.changeHandlers = [];
        this.changeHandlers = [];
    }
    ReactNodeViewState.prototype.subscribe = function (cb) {
        this.changeHandlers.push(cb);
    };
    ReactNodeViewState.prototype.unsubscribe = function (cb) {
        this.changeHandlers = this.changeHandlers.filter(function (ch) { return ch !== cb; });
    };
    ReactNodeViewState.prototype.notifyNewSelection = function (anchorPos, headPos) {
        this.changeHandlers.forEach(function (cb) { return cb(anchorPos, headPos); });
    };
    return ReactNodeViewState;
}());

var stateKey = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["PluginKey"]('reactNodeView');
var plugin = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
    state: {
        init: function (config, state) {
            return new ReactNodeViewState();
        },
        apply: function (tr, pluginState, oldState, newState) {
            return pluginState;
        },
    },
    key: stateKey,
    view: function (view) {
        var pluginState = stateKey.getState(view.state);
        return {
            update: function (view, prevState) {
                var _a = view.state.selection, $anchor = _a.$anchor, $head = _a.$head;
                pluginState.notifyNewSelection($anchor.pos, $head.pos);
            },
        };
    },
});
var plugins = function (schema) {
    return [plugin];
};
/* unused harmony default export */ var _unused_webpack_default_export = (plugins);
//# sourceMappingURL=react-nodeview.js.map

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToolbarSize; });
/* unused harmony export ToolbarInner */
/* unused harmony export Toolbar */
/* harmony export (immutable) */ __webpack_exports__["b"] = ToolbarWithSizeDetector;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_size_detector__ = __webpack_require__(268);




var ToolbarComponentsWrapper = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var ToolbarSize;
(function (ToolbarSize) {
    ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
    ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
    ToolbarSize[ToolbarSize["L"] = 4] = "L";
    ToolbarSize[ToolbarSize["M"] = 3] = "M";
    ToolbarSize[ToolbarSize["S"] = 2] = "S";
    ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
})(ToolbarSize || (ToolbarSize = {}));
// Toolbar sizes for full page editor a little bit different, because it has more buttons e.g. actions button...
var toolbarSizesFullPage = [
    { width: 650, size: ToolbarSize.XXL },
    { width: 580, size: ToolbarSize.XL },
    { width: 500, size: ToolbarSize.L },
    { width: 450, size: ToolbarSize.M },
    { width: 370, size: ToolbarSize.S },
];
var toolbarSizes = [
    { width: 610, size: ToolbarSize.XXL },
    { width: 540, size: ToolbarSize.XL },
    { width: 460, size: ToolbarSize.L },
    { width: 450, size: ToolbarSize.M },
    { width: 370, size: ToolbarSize.S },
];
var ToolbarInner = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ToolbarInner, _super);
    function ToolbarInner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToolbarInner.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return (nextProps.toolbarSize !== this.props.toolbarSize ||
            nextProps.disabled !== this.props.disabled ||
            nextProps.popupsMountPoint === this.props.popupsMountPoint ||
            nextProps.popupsBoundariesElement ===
                this.props.popupsBoundariesElement ||
            nextProps.popupsScrollableElement ===
                this.props.popupsScrollableElement ||
            nextProps.isReducedSpacing !== this.props.isToolbarReducedSpacing);
    };
    ToolbarInner.prototype.render = function () {
        var _a = this.props, appearance = _a.appearance, editorView = _a.editorView, editorActions = _a.editorActions, eventDispatcher = _a.eventDispatcher, providerFactory = _a.providerFactory, items = _a.items, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, popupsScrollableElement = _a.popupsScrollableElement, toolbarSize = _a.toolbarSize, disabled = _a.disabled, isToolbarReducedSpacing = _a.isToolbarReducedSpacing;
        if (!items || !items.length) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ToolbarComponentsWrapper, null, items.map(function (component, key) {
            var props = { key: key };
            var element = component({
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                providerFactory: providerFactory,
                appearance: appearance,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                disabled: disabled,
                toolbarSize: toolbarSize,
                isToolbarReducedSpacing: isToolbarReducedSpacing,
                containerElement: undefined,
            });
            return element && __WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"](element, props);
        })));
    };
    return ToolbarInner;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

var toolbarSizesForAppearance = function (appearance) {
    return appearance === 'full-page' ? toolbarSizesFullPage : toolbarSizes;
};
var widthToToolbarSize = function (toolbarWidth, appearance) {
    return (toolbarSizesForAppearance(appearance).find(function (_a) {
        var width = _a.width;
        return toolbarWidth > width;
    }) || {
        size: ToolbarSize.XXXS,
    }).size;
};
function Toolbar(props) {
    var toolbarSize = widthToToolbarSize(props.width || 0, props.appearance);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ToolbarInner, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, props, { toolbarSize: toolbarSize, isToolbarReducedSpacing: toolbarSize < ToolbarSize.XXL })));
}
function ToolbarWithSizeDetector(props) {
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: { width: '100%', minWidth: '254px' } },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_size_detector__["a" /* default */], null, function (_a) {
            var width = _a.width;
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Toolbar, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, props, { width: width }));
        })));
}
var templateObject_1;
//# sourceMappingURL=index.js.map

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_droplist__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_item__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_tooltip__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__with_outer_listeners__ = __webpack_require__(246);









var Wrapper = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  line-height: 0;\n"], ["\n  line-height: 0;\n"])));
var DropListWithOutsideListeners = Object(__WEBPACK_IMPORTED_MODULE_7__with_outer_listeners__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__atlaskit_droplist__["c" /* default */]);
/**
 * Hack for item to imitate old dropdown-menu selected styles
 */
var ItemWrapper = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    return props.isSelected
        ? '&& > span, && > span:hover { background: #6c798f; color: #fff; }'
        : '';
});
var ItemContentWrapper = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", ";\n"], ["\n  ", ";\n"])), function (props) { return (props.hasElemBefore ? 'margin-left: 8px;' : ''); });
/**
 * Wrapper around @atlaskit/droplist which uses Popup and Portal to render
 * dropdown-menu outside of "overflow: hidden" containers when needed.
 *
 * Also it controls popper's placement.
 */
var DropdownMenuWrapper = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](DropdownMenuWrapper, _super);
    function DropdownMenuWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            popupPlacement: ['bottom', 'left'],
        };
        _this.handleRef = function (target) {
            _this.setState({ target: target });
        };
        _this.updatePopupPlacement = function (placement) {
            _this.setState({ popupPlacement: placement });
        };
        _this.handleClose = function () {
            if (_this.props.onOpenChange) {
                _this.props.onOpenChange({ isOpen: false });
            }
        };
        return _this;
    }
    DropdownMenuWrapper.prototype.renderItem = function (item) {
        var _a = this.props, onItemActivated = _a.onItemActivated, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
        // onClick and value.name are the action indicators in the handlers
        // If neither are present, don't wrap in an Item.
        if (!item.onClick && !item.value && !item.value.name) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { key: item.content }, item.content);
        }
        var dropListItem = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ItemWrapper, { key: item.key || item.content, isSelected: item.isActive },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_item__["b" /* default */], { elemBefore: item.elemBefore, elemAfter: item.elemAfter, isDisabled: item.isDisabled, onClick: function () { return onItemActivated && onItemActivated({ item: item }); }, onMouseEnter: function () { return onMouseEnter && onMouseEnter({ item: item }); }, onMouseLeave: function () { return onMouseLeave && onMouseLeave({ item: item }); }, className: item.className },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ItemContentWrapper, { hasElemBefore: !!item.elemBefore }, item.content))));
        if (item.tooltipDescription) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__atlaskit_tooltip__["a" /* default */], { key: item.content, content: item.tooltipDescription, position: item.tooltipPosition }, dropListItem));
        }
        return dropListItem;
    };
    DropdownMenuWrapper.prototype.renderDropdownMenu = function () {
        var _this = this;
        var _a = this.state, target = _a.target, popupPlacement = _a.popupPlacement;
        var _b = this.props, items = _b.items, mountTo = _b.mountTo, boundariesElement = _b.boundariesElement, scrollableElement = _b.scrollableElement, offset = _b.offset, fitHeight = _b.fitHeight, fitWidth = _b.fitWidth, isOpen = _b.isOpen, zIndex = _b.zIndex;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__atlaskit_editor_common__["e" /* Popup */], { target: isOpen ? target : undefined, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, onPlacementChanged: this.updatePopupPlacement, fitHeight: fitHeight, fitWidth: fitWidth, zIndex: zIndex || __WEBPACK_IMPORTED_MODULE_6__atlaskit_editor_common__["o" /* akEditorFloatingPanelZIndex */], offset: offset },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](DropListWithOutsideListeners, { isOpen: true, appearance: "tall", position: popupPlacement.join(' '), shouldFlip: false, shouldFitContainer: true, isTriggerNotTabbable: true, handleClickOutside: this.handleClose, handleEscapeKeydown: this.handleClose },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: { height: 0, minWidth: fitWidth || 0 } }),
                items.map(function (group, index) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_item__["a" /* ItemGroup */], { key: index }, group.items.map(function (item) { return _this.renderItem(item); }))); }))));
    };
    DropdownMenuWrapper.prototype.render = function () {
        var _a = this.props, children = _a.children, isOpen = _a.isOpen;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Wrapper, null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this.handleRef }, children),
            isOpen ? this.renderDropdownMenu() : null));
    };
    return DropdownMenuWrapper;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (DropdownMenuWrapper);
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pm_plugins_keymap__ = __webpack_require__(2380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selection__ = __webpack_require__(201);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__selection__["a"]; });
/* unused harmony reexport Side */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(438);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__actions__["c"]; });




/* harmony default export */ __webpack_exports__["b"] = ({
    pmPlugins: function () {
        return [
            {
                name: 'gapCursorKeymap',
                plugin: function (_a) {
                    var schema = _a.schema, props = _a.props;
                    return Object(__WEBPACK_IMPORTED_MODULE_1__pm_plugins_keymap__["a" /* default */])();
                },
            },
            {
                name: 'gapCursor',
                plugin: function (_a) {
                    var schema = _a.schema, props = _a.props;
                    return __WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__["a" /* default */];
                },
            },
        ];
    },
});
//# sourceMappingURL=index.js.map

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(17);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["defineMessages"])({
    insertColumn: {
        id: 'fabric.editor.insertColumn',
        defaultMessage: 'Insert column',
        description: 'Add a new column to your table.',
    },
    removeColumns: {
        id: 'fabric.editor.removeColumns',
        defaultMessage: 'Remove {0, plural, one {column} other {columns}}',
        description: 'Deletes a table column.',
    },
    insertRow: {
        id: 'fabric.editor.insertRow',
        defaultMessage: 'Insert row',
        description: 'Add a new row to your table.',
    },
    removeRows: {
        id: 'fabric.editor.removeRows',
        defaultMessage: 'Remove {0, plural, one {row} other {rows}}',
        description: 'Deletes a table row.',
    },
    cellOptions: {
        id: 'fabric.editor.cellOptions',
        defaultMessage: 'Cell options',
        description: 'Opens a menu with options for the current table cell.',
    },
}));
//# sourceMappingURL=messages.js.map

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugin__ = __webpack_require__(2412);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__plugin__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__plugin__["b"]; });
/* unused harmony reexport ResizeState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(818);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["d"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(2446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(2447);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__utils__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__utils__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__utils__["a"]; });






var FloatingToolbar = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](FloatingToolbar, _super);
    function FloatingToolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FloatingToolbar.prototype.render = function () {
        var _a = this.props, containerRef = _a.containerRef, children = _a.children, target = _a.target, offset = _a.offset, fitWidth = _a.fitWidth, _b = _a.fitHeight, fitHeight = _b === void 0 ? 40 : _b, onPositionCalculated = _a.onPositionCalculated, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, className = _a.className, alignX = _a.alignX, alignY = _a.alignY, zIndex = _a.zIndex;
        if (!target) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["e" /* Popup */], { alignX: alignX, alignY: alignY, target: target, zIndex: zIndex, mountTo: popupsMountPoint, boundariesElement: popupsBoundariesElement, offset: offset, fitWidth: fitWidth, fitHeight: fitHeight, onPositionCalculated: onPositionCalculated },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Container */], { height: fitHeight, className: className, innerRef: containerRef }, children)));
    };
    return FloatingToolbar;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (FloatingToolbar);
//# sourceMappingURL=index.js.map

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setStatusPickerAt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return commitStatusPicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugin__ = __webpack_require__(291);





var DEFAULT_STATUS = {
    text: '',
    color: 'neutral',
};
var createStatus = function (showStatusPickerAtOffset) {
    if (showStatusPickerAtOffset === void 0) { showStatusPickerAtOffset = -2; }
    return function (insert, state) {
        var statusNode = state.schema.nodes.status.createChecked(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, DEFAULT_STATUS, { localId: __WEBPACK_IMPORTED_MODULE_3__atlaskit_adf_schema__["_26" /* uuid */].generate() }));
        var selectedStatus = statusNode.attrs;
        var tr = insert(statusNode);
        var showStatusPickerAt = tr.selection.from + showStatusPickerAtOffset;
        return tr
            .setSelection(__WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["NodeSelection"].create(tr.doc, showStatusPickerAt))
            .setMeta(__WEBPACK_IMPORTED_MODULE_4__plugin__["b" /* pluginKey */], {
            showStatusPickerAt: showStatusPickerAt,
            autoFocus: true,
            selectedStatus: selectedStatus,
        });
    };
};
var updateStatus = function (status, autoFocus) { return function (editorView) {
    var state = editorView.state, dispatch = editorView.dispatch;
    var schema = state.schema;
    var selectedStatus = null;
    var statusProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, DEFAULT_STATUS, { localId: __WEBPACK_IMPORTED_MODULE_3__atlaskit_adf_schema__["_26" /* uuid */].generate() }, status);
    var tr = state.tr;
    var showStatusPickerAt = __WEBPACK_IMPORTED_MODULE_4__plugin__["b" /* pluginKey */].getState(state).showStatusPickerAt;
    if (!showStatusPickerAt) {
        // Same behaviour as quick insert (used in createStatus)
        var statusNode = schema.nodes.status.createChecked(statusProps);
        var fragment = __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].fromArray([statusNode, state.schema.text(' ')]);
        var newShowStatusPickerAt = tr.selection.from;
        tr = tr.replaceWith(newShowStatusPickerAt, newShowStatusPickerAt, fragment);
        tr = tr.setSelection(__WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["NodeSelection"].create(tr.doc, newShowStatusPickerAt));
        tr = tr
            .setMeta(__WEBPACK_IMPORTED_MODULE_4__plugin__["b" /* pluginKey */], {
            showStatusPickerAt: newShowStatusPickerAt,
            selectedStatus: selectedStatus,
            autoFocus: autoFocus,
        })
            .scrollIntoView();
        dispatch(tr);
        return true;
    }
    if (state.doc.nodeAt(showStatusPickerAt)) {
        tr = tr.setNodeMarkup(showStatusPickerAt, schema.nodes.status, statusProps);
        tr = tr.setSelection(__WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["NodeSelection"].create(tr.doc, showStatusPickerAt));
        tr = tr
            .setMeta(__WEBPACK_IMPORTED_MODULE_4__plugin__["b" /* pluginKey */], { showStatusPickerAt: showStatusPickerAt, selectedStatus: selectedStatus })
            .scrollIntoView();
        dispatch(tr);
        return true;
    }
    return false;
}; };
var setStatusPickerAt = function (showStatusPickerAt) { return function (state, dispatch) {
    dispatch(state.tr.setMeta(__WEBPACK_IMPORTED_MODULE_4__plugin__["b" /* pluginKey */], {
        showStatusPickerAt: showStatusPickerAt,
        autoFocus: false,
        selectedStatus: null,
    }));
    return true;
}; };
var commitStatusPicker = function () { return function (editorView) {
    var state = editorView.state, dispatch = editorView.dispatch;
    var showStatusPickerAt = __WEBPACK_IMPORTED_MODULE_4__plugin__["b" /* pluginKey */].getState(state).showStatusPickerAt;
    if (!showStatusPickerAt) {
        return;
    }
    var statusNode = state.tr.doc.nodeAt(showStatusPickerAt);
    if (!statusNode) {
        return;
    }
    var tr = state.tr;
    tr = tr.setMeta(__WEBPACK_IMPORTED_MODULE_4__plugin__["b" /* pluginKey */], {
        showStatusPickerAt: null,
        autoFocus: false,
        selectedStatus: null,
    });
    if (statusNode.attrs.text) {
        // still has content - keep content, move selection after status
        tr = tr.setSelection(__WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["Selection"].near(state.tr.doc.resolve(showStatusPickerAt + 2)));
    }
    else {
        // no content - remove node
        tr = tr
            .delete(showStatusPickerAt, showStatusPickerAt + 1)
            .setSelection(__WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["Selection"].near(state.tr.doc.resolve(showStatusPickerAt)));
    }
    dispatch(tr);
    editorView.focus();
}; };
//# sourceMappingURL=actions.js.map

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return padding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Overlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PlaceholderFallback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PlaceholderFallbackParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);




var padding = 8;
var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  background: ", ";\n  border-radius: ", "px;\n  position: relative;\n  vertical-align: middle;\n  font-size: ", "px;\n\n  .ProseMirror-selectednode > & > .extension-overlay {\n    border: 2px solid ", ";\n    top: -2px;\n    left: -2px;\n    opacity: 1;\n  }\n\n  &.with-overlay {\n    .extension-overlay {\n      background: ", ";\n      color: transparent;\n    }\n\n    &:hover .extension-overlay {\n      opacity: 1;\n    }\n  }\n"], ["\n  background: ", ";\n  border-radius: ", "px;\n  position: relative;\n  vertical-align: middle;\n  font-size: ", "px;\n\n  .ProseMirror-selectednode > & > .extension-overlay {\n    border: 2px solid ", ";\n    top: -2px;\n    left: -2px;\n    opacity: 1;\n  }\n\n  &.with-overlay {\n    .extension-overlay {\n      background: ", ";\n      color: transparent;\n    }\n\n    &:hover .extension-overlay {\n      opacity: 1;\n    }\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N20, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])(), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["fontSize"])(), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B200, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N20A);
var Overlay = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  border-radius: ", "px;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s;\n"], ["\n  border-radius: ", "px;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s;\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])());
var PlaceholderFallback = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: inline-flex;\n  align-items: center;\n\n  & > img {\n    margin: 0 4px;\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n\n  & > img {\n    margin: 0 4px;\n  }\n"])));
var PlaceholderFallbackParams = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: inline-block;\n  max-width: 200px;\n  margin-left: 5px;\n  color: ", ";\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"], ["\n  display: inline-block;\n  max-width: 200px;\n  margin-left: 5px;\n  color: ", ";\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N70);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluginKey; });
/* unused harmony export createPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);

var pluginKey = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["PluginKey"]('maxContentSizePlugin');
function createPlugin(dispatch, maxContentSize, onMaxContentSize) {
    if (!maxContentSize) {
        return;
    }
    var maxContentSizeReached = false;
    return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
        filterTransaction: function (tr) {
            var result = tr.doc && tr.doc.nodeSize > maxContentSize;
            if (result || result !== maxContentSizeReached) {
                dispatch(pluginKey, { maxContentSizeReached: result });
            }
            maxContentSizeReached = result;
            return !result;
        },
    });
}
var maxContentSizePlugin = {
    pmPlugins: function () {
        return [
            {
                name: 'maxContentSize',
                plugin: function (_a) {
                    var dispatch = _a.dispatch, props = _a.props;
                    return createPlugin(dispatch, props.maxContentSize);
                },
            },
        ];
    },
};
/* harmony default export */ __webpack_exports__["a"] = (maxContentSizePlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R50", function() { return R50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R75", function() { return R75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R100", function() { return R100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R200", function() { return R200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R300", function() { return R300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R400", function() { return R400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R500", function() { return R500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y50", function() { return Y50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y75", function() { return Y75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y100", function() { return Y100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y200", function() { return Y200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y300", function() { return Y300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y400", function() { return Y400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y500", function() { return Y500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G50", function() { return G50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G75", function() { return G75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G100", function() { return G100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G200", function() { return G200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G300", function() { return G300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G400", function() { return G400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G500", function() { return G500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B50", function() { return B50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B75", function() { return B75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B100", function() { return B100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B200", function() { return B200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B300", function() { return B300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B400", function() { return B400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B500", function() { return B500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P50", function() { return P50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P75", function() { return P75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P100", function() { return P100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P200", function() { return P200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P300", function() { return P300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P400", function() { return P400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P500", function() { return P500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T50", function() { return T50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T75", function() { return T75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T100", function() { return T100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T200", function() { return T200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T300", function() { return T300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T400", function() { return T400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T500", function() { return T500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N0", function() { return N0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10", function() { return N10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20", function() { return N20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30", function() { return N30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40", function() { return N40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50", function() { return N50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60", function() { return N60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70", function() { return N70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80", function() { return N80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90", function() { return N90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100", function() { return N100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200", function() { return N200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300", function() { return N300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400", function() { return N400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500", function() { return N500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600", function() { return N600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700", function() { return N700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800", function() { return N800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N900", function() { return N900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10A", function() { return N10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20A", function() { return N20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30A", function() { return N30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40A", function() { return N40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50A", function() { return N50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60A", function() { return N60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70A", function() { return N70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80A", function() { return N80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90A", function() { return N90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100A", function() { return N100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200A", function() { return N200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300A", function() { return N300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400A", function() { return N400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500A", function() { return N500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600A", function() { return N600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700A", function() { return N700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800A", function() { return N800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN900", function() { return DN900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800", function() { return DN800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700", function() { return DN700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600", function() { return DN600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500", function() { return DN500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400", function() { return DN400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300", function() { return DN300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200", function() { return DN200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100", function() { return DN100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90", function() { return DN90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80", function() { return DN80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70", function() { return DN70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60", function() { return DN60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50", function() { return DN50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40", function() { return DN40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30", function() { return DN30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20", function() { return DN20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10", function() { return DN10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN0", function() { return DN0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800A", function() { return DN800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700A", function() { return DN700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600A", function() { return DN600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500A", function() { return DN500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400A", function() { return DN400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300A", function() { return DN300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200A", function() { return DN200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100A", function() { return DN100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90A", function() { return DN90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80A", function() { return DN80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70A", function() { return DN70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60A", function() { return DN60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50A", function() { return DN50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40A", function() { return DN40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30A", function() { return DN30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20A", function() { return DN20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10A", function() { return DN10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "background", function() { return background; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundActive", function() { return backgroundActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundHover", function() { return backgroundHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundOnLayer", function() { return backgroundOnLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "text", function() { return text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textHover", function() { return textHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textActive", function() { return textActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleText", function() { return subtleText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "placeholderText", function() { return placeholderText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "heading", function() { return heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleHeading", function() { return subtleHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "codeBlock", function() { return codeBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "link", function() { return link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkHover", function() { return linkHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkActive", function() { return linkActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkOutline", function() { return linkOutline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "primary", function() { return primary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blue", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "teal", function() { return teal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purple", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yellow", function() { return yellow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "green", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette8", function() { return colorPalette8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette16", function() { return colorPalette16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette24", function() { return colorPalette24; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette", function() { return colorPalette; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(458);


// Reds
var R50 = '#FFEBE6';
var R75 = '#FFBDAD';
var R100 = '#FF8F73';
var R200 = '#FF7452';
var R300 = '#FF5630';
var R400 = '#DE350B';
var R500 = '#BF2600'; // Yellows

var Y50 = '#FFFAE6';
var Y75 = '#FFF0B3';
var Y100 = '#FFE380';
var Y200 = '#FFC400';
var Y300 = '#FFAB00';
var Y400 = '#FF991F';
var Y500 = '#FF8B00'; // Greens

var G50 = '#E3FCEF';
var G75 = '#ABF5D1';
var G100 = '#79F2C0';
var G200 = '#57D9A3';
var G300 = '#36B37E';
var G400 = '#00875A';
var G500 = '#006644'; // Blues

var B50 = '#DEEBFF';
var B75 = '#B3D4FF';
var B100 = '#4C9AFF';
var B200 = '#2684FF';
var B300 = '#0065FF';
var B400 = '#0052CC';
var B500 = '#0747A6'; // Purples

var P50 = '#EAE6FF';
var P75 = '#C0B6F2';
var P100 = '#998DD9';
var P200 = '#8777D9';
var P300 = '#6554C0';
var P400 = '#5243AA';
var P500 = '#403294'; // Teals

var T50 = '#E6FCFF';
var T75 = '#B3F5FF';
var T100 = '#79E2F2';
var T200 = '#00C7E6';
var T300 = '#00B8D9';
var T400 = '#00A3BF';
var T500 = '#008DA6'; // Neutrals

var N0 = '#FFFFFF';
var N10 = '#FAFBFC';
var N20 = '#F4F5F7';
var N30 = '#EBECF0';
var N40 = '#DFE1E6';
var N50 = '#C1C7D0';
var N60 = '#B3BAC5';
var N70 = '#A5ADBA';
var N80 = '#97A0AF';
var N90 = '#8993A4';
var N100 = '#7A869A';
var N200 = '#6B778C';
var N300 = '#5E6C84';
var N400 = '#505F79';
var N500 = '#42526E';
var N600 = '#344563';
var N700 = '#253858';
var N800 = '#172B4D'; // ATTENTION: update the tints if you update this

var N900 = '#091E42'; // Each tint is made of N900 and an alpha channel

var N10A = 'rgba(9, 30, 66, 0.02)';
var N20A = 'rgba(9, 30, 66, 0.04)';
var N30A = 'rgba(9, 30, 66, 0.08)';
var N40A = 'rgba(9, 30, 66, 0.13)';
var N50A = 'rgba(9, 30, 66, 0.25)';
var N60A = 'rgba(9, 30, 66, 0.31)';
var N70A = 'rgba(9, 30, 66, 0.36)';
var N80A = 'rgba(9, 30, 66, 0.42)';
var N90A = 'rgba(9, 30, 66, 0.48)';
var N100A = 'rgba(9, 30, 66, 0.54)';
var N200A = 'rgba(9, 30, 66, 0.60)';
var N300A = 'rgba(9, 30, 66, 0.66)';
var N400A = 'rgba(9, 30, 66, 0.71)';
var N500A = 'rgba(9, 30, 66, 0.77)';
var N600A = 'rgba(9, 30, 66, 0.82)';
var N700A = 'rgba(9, 30, 66, 0.89)';
var N800A = 'rgba(9, 30, 66, 0.95)'; // Dark Mode Neutrals

var DN900 = '#E6EDFA';
var DN800 = '#DCE5F5';
var DN700 = '#CED9EB';
var DN600 = '#B8C7E0';
var DN500 = '#ABBBD6';
var DN400 = '#9FB0CC';
var DN300 = '#8C9CB8';
var DN200 = '#7988A3';
var DN100 = '#67758F';
var DN90 = '#56637A';
var DN80 = '#455166';
var DN70 = '#3B475C';
var DN60 = '#313D52';
var DN50 = '#283447';
var DN40 = '#202B3D';
var DN30 = '#1B2638';
var DN20 = '#121A29';
var DN10 = '#0E1624'; // ATTENTION: update the tints if you update this

var DN0 = '#0D1424'; // Each dark tint is made of DN0 and an alpha channel

var DN800A = 'rgba(13, 20, 36, 0.06)';
var DN700A = 'rgba(13, 20, 36, 0.14)';
var DN600A = 'rgba(13, 20, 36, 0.18)';
var DN500A = 'rgba(13, 20, 36, 0.29)';
var DN400A = 'rgba(13, 20, 36, 0.36)';
var DN300A = 'rgba(13, 20, 36, 0.40)';
var DN200A = 'rgba(13, 20, 36, 0.47)';
var DN100A = 'rgba(13, 20, 36, 0.53)';
var DN90A = 'rgba(13, 20, 36, 0.63)';
var DN80A = 'rgba(13, 20, 36, 0.73)';
var DN70A = 'rgba(13, 20, 36, 0.78)';
var DN60A = 'rgba(13, 20, 36, 0.81)';
var DN50A = 'rgba(13, 20, 36, 0.85)';
var DN40A = 'rgba(13, 20, 36, 0.89)';
var DN30A = 'rgba(13, 20, 36, 0.92)';
var DN20A = 'rgba(13, 20, 36, 0.95)';
var DN10A = 'rgba(13, 20, 36, 0.97)'; // Themed colors

var background = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N0,
  dark: DN30
});
var backgroundActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B50,
  dark: B75
});
var backgroundHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N30,
  dark: DN70
});
var backgroundOnLayer = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N0,
  dark: DN50
});
var text = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N900,
  dark: DN600
});
var textHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N800,
  dark: DN600
});
var textActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B400,
  dark: B400
});
var subtleText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N200,
  dark: DN300
});
var placeholderText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N100,
  dark: DN200
});
var heading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N800,
  dark: DN600
});
var subtleHeading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N200,
  dark: DN300
});
var codeBlock = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: N20,
  dark: DN50
});
var link = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B400,
  dark: B100
});
var linkHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B300,
  dark: B200
});
var linkActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B500,
  dark: B100
});
var linkOutline = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B100,
  dark: B200
});
var primary = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B400,
  dark: B100
});
var blue = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: B400,
  dark: B100
});
var teal = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: T300,
  dark: T200
});
var purple = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: P300,
  dark: P100
});
var red = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: R300,
  dark: R300
});
var yellow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: Y300,
  dark: Y300
});
var green = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: G300,
  dark: G300
}); // Jira Portfolio

var colorPalette8 = [{
  background: N800,
  text: N0
}, {
  background: R400,
  text: N0
}, {
  background: P400,
  text: P50
}, {
  background: B400,
  text: B75
}, {
  background: T300,
  text: N800
}, {
  background: G400,
  text: N0
}, {
  background: Y400,
  text: N800
}, {
  background: N70,
  text: N800
}];
var colorPalette16 = colorPalette8.concat([{
  background: N500,
  text: N0
}, {
  background: R100,
  text: N800
}, {
  background: P75,
  text: N800
}, {
  background: B100,
  text: N800
}, {
  background: T100,
  text: N800
}, {
  background: G100,
  text: G500
}, {
  background: Y200,
  text: N800
}, {
  background: N0,
  text: N800
}]);
var colorPalette24 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(colorPalette16).concat([{
  background: N100,
  text: N0
}, {
  background: N40,
  text: N800
}, {
  background: N50,
  text: R500
}, {
  background: P50,
  text: P500
}, {
  background: B50,
  text: B500
}, {
  background: T75,
  text: N800
}, {
  background: G50,
  text: G500
}, {
  background: Y75,
  text: N800
}]);
var colorPalette = function colorPalette() {
  var palette = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '8';

  switch (palette) {
    case '8':
      return colorPalette8;

    case '16':
      return colorPalette16;

    case '24':
      return colorPalette24;

    default:
      throw new Error('The only available color palette is 8, 16, 24');
  }
};

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_COLOR; });
/* unused harmony export createInitialPluginState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return pluginKey; });
/* harmony export (immutable) */ __webpack_exports__["c"] = createPlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_color__ = __webpack_require__(2743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_disabled__ = __webpack_require__(874);






var DEFAULT_COLOR = {
    color: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N800.toLowerCase(),
    label: 'Dark gray',
};
function createInitialPluginState(editorState, pluginConfig) {
    var defaultColor = (pluginConfig && pluginConfig.defaultColor) || DEFAULT_COLOR;
    var palette = new Map([
        [defaultColor.color, defaultColor.label],
    ]);
    // Typescript can't spread Map as of 11 May, 2017
    __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__["o" /* colorPalette */].forEach(function (label, color) { return palette.set(color, label); });
    return {
        color: Object(__WEBPACK_IMPORTED_MODULE_4__utils_color__["a" /* getActiveColor */])(editorState),
        disabled: Object(__WEBPACK_IMPORTED_MODULE_5__utils_disabled__["a" /* getDisabledState */])(editorState),
        palette: palette,
        borderColorPalette: __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__["h" /* borderColorPalette */],
        defaultColor: palette.keys().next().value,
    };
}
var ACTIONS;
(function (ACTIONS) {
    ACTIONS[ACTIONS["RESET_COLOR"] = 0] = "RESET_COLOR";
    ACTIONS[ACTIONS["SET_COLOR"] = 1] = "SET_COLOR";
    ACTIONS[ACTIONS["DISABLE"] = 2] = "DISABLE";
})(ACTIONS || (ACTIONS = {}));
var pluginKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('textColorPlugin');
function createPlugin(dispatch, pluginConfig) {
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        key: pluginKey,
        state: {
            init: function (config, editorState) {
                return createInitialPluginState(editorState, pluginConfig);
            },
            apply: function (tr, pluginState, _, newState) {
                var meta = tr.getMeta(pluginKey) || {};
                var nextState;
                switch (meta.action) {
                    case ACTIONS.RESET_COLOR:
                        nextState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { color: pluginState.defaultColor });
                        break;
                    case ACTIONS.SET_COLOR:
                        nextState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { color: meta.color, disabled: false });
                        break;
                    case ACTIONS.DISABLE:
                        nextState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { disabled: true });
                        break;
                    default:
                        nextState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { color: Object(__WEBPACK_IMPORTED_MODULE_4__utils_color__["a" /* getActiveColor */])(newState), disabled: Object(__WEBPACK_IMPORTED_MODULE_5__utils_disabled__["a" /* getDisabledState */])(newState) });
                }
                if ((pluginState && pluginState.color !== nextState.color) ||
                    (pluginState && pluginState.disabled !== nextState.disabled)) {
                    dispatch(pluginKey, nextState);
                    return nextState;
                }
                return pluginState;
            },
        },
    });
}
//# sourceMappingURL=main.js.map

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);



var PluginsComponentsWrapper = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var PluginSlot = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](PluginSlot, _super);
    function PluginSlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PluginSlot.prototype.shouldComponentUpdate = function (nextProps) {
        var _a = this.props, editorView = _a.editorView, editorActions = _a.editorActions, items = _a.items, providerFactory = _a.providerFactory, eventDispatcher = _a.eventDispatcher, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, popupsScrollableElement = _a.popupsScrollableElement, containerElement = _a.containerElement, disabled = _a.disabled;
        return !(nextProps.editorView === editorView &&
            nextProps.editorActions === editorActions &&
            nextProps.items === items &&
            nextProps.providerFactory === providerFactory &&
            nextProps.eventDispatcher === eventDispatcher &&
            nextProps.popupsMountPoint === popupsMountPoint &&
            nextProps.popupsBoundariesElement === popupsBoundariesElement &&
            nextProps.popupsScrollableElement === popupsScrollableElement &&
            nextProps.containerElement === containerElement &&
            nextProps.disabled === disabled);
    };
    PluginSlot.prototype.render = function () {
        var _a = this.props, items = _a.items, editorView = _a.editorView, editorActions = _a.editorActions, eventDispatcher = _a.eventDispatcher, providerFactory = _a.providerFactory, appearance = _a.appearance, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, popupsScrollableElement = _a.popupsScrollableElement, containerElement = _a.containerElement, disabled = _a.disabled;
        if (!items || !editorView) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](PluginsComponentsWrapper, null, items.map(function (component, key) {
            var props = { key: key };
            var element = component({
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                providerFactory: providerFactory,
                appearance: appearance,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                containerElement: containerElement,
                disabled: disabled,
            });
            return element && __WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"](element, props);
        })));
    };
    return PluginSlot;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (PluginSlot);
var templateObject_1;
//# sourceMappingURL=index.js.map

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_collab_edit_styles__ = __webpack_require__(2793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_gap_cursor_styles__ = __webpack_require__(2794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_table_ui_styles__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_placeholder_styles__ = __webpack_require__(2795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_block_type_styles__ = __webpack_require__(2796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_code_block_styles__ = __webpack_require__(2797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_lists_styles__ = __webpack_require__(2798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plugins_rule_styles__ = __webpack_require__(2799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__plugins_media_styles__ = __webpack_require__(2800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__plugins_layout_styles__ = __webpack_require__(2801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__plugins_panel_styles__ = __webpack_require__(2802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__plugins_fake_text_cursor_styles__ = __webpack_require__(2803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__plugins_mentions_styles__ = __webpack_require__(2804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__plugins_text_formatting_styles__ = __webpack_require__(2805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__plugins_placeholder_text_styles__ = __webpack_require__(2806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__plugins_tasks_and_decisions_ui_styles__ = __webpack_require__(2807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__plugins_grid_styles__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__plugins_hyperlink_styles__ = __webpack_require__(2808);





















var ContentStyles = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  /* Hack for ie11 that is being used in code block.\n   * https://bitbucket.org/atlassian/atlaskit/src/ad09f6361109ece1aab316c8cbd8116ffb7963ef/packages/editor-core/src/schema/nodes/code-block.ts?fileviewer=file-view-default#code-block.ts-110\n   */\n  & .ie11 {\n    overflow: visible;\n    word-wrap: break-word;\n  }\n\n  .ProseMirror {\n    word-wrap: break-word;\n    white-space: pre-wrap;\n    outline: none;\n    font-size: ", "px;\n\n    ", ";\n    ", "\n  }\n\n  .ProseMirror-hideselection *::selection {\n    background: transparent;\n  }\n\n  .ProseMirror-hideselection *::-moz-selection {\n    background: transparent;\n  }\n\n  .ProseMirror-selectednode {\n    outline: none;\n  }\n\n  .ProseMirror-selectednode:empty {\n    outline: 2px solid #8cf;\n  }\n\n  .inlineCardView-content-wrap,\n  .blockCardView-content-wrap {\n    display: inline-block;\n  }\n\n  /* fix cursor alignment */\n  .ProseMirror .emoji-common-node {\n    display: inline;\n    vertical-align: baseline;\n\n    img {\n      display: inline-block;\n      vertical-align: middle;\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", ";\n  ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  .panelView-content-wrap {\n    box-sizing: border-box;\n  }\n\n  .mediaGroupView-content-wrap ul {\n    padding: 0;\n  }\n\n  /** Needed to override any cleared floats, e.g. image wrapping */\n  div.fabric-editor-block-mark[class^='fabric-editor-align'] {\n    clear: none !important;\n  }\n\n  .fabric-editor-align-end {\n    text-align: right;\n  }\n\n  .fabric-editor-align-start {\n    text-align: left;\n  }\n\n  .fabric-editor-align-center {\n    text-align: center;\n  }\n\n"], ["\n  /* Hack for ie11 that is being used in code block.\n   * https://bitbucket.org/atlassian/atlaskit/src/ad09f6361109ece1aab316c8cbd8116ffb7963ef/packages/editor-core/src/schema/nodes/code-block.ts?fileviewer=file-view-default#code-block.ts-110\n   */\n  & .ie11 {\n    overflow: visible;\n    word-wrap: break-word;\n  }\n\n  .ProseMirror {\n    word-wrap: break-word;\n    white-space: pre-wrap;\n    outline: none;\n    font-size: ", "px;\n\n    ", ";\n    ", "\n  }\n\n  .ProseMirror-hideselection *::selection {\n    background: transparent;\n  }\n\n  .ProseMirror-hideselection *::-moz-selection {\n    background: transparent;\n  }\n\n  .ProseMirror-selectednode {\n    outline: none;\n  }\n\n  .ProseMirror-selectednode:empty {\n    outline: 2px solid #8cf;\n  }\n\n  .inlineCardView-content-wrap,\n  .blockCardView-content-wrap {\n    display: inline-block;\n  }\n\n  /* fix cursor alignment */\n  .ProseMirror .emoji-common-node {\n    display: inline;\n    vertical-align: baseline;\n\n    img {\n      display: inline-block;\n      vertical-align: middle;\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", ";\n  ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  .panelView-content-wrap {\n    box-sizing: border-box;\n  }\n\n  .mediaGroupView-content-wrap ul {\n    padding: 0;\n  }\n\n  /** Needed to override any cleared floats, e.g. image wrapping */\n  div.fabric-editor-block-mark[class^='fabric-editor-align'] {\n    clear: none !important;\n  }\n\n  .fabric-editor-align-end {\n    text-align: right;\n  }\n\n  .fabric-editor-align-start {\n    text-align: left;\n  }\n\n  .fabric-editor-align-center {\n    text-align: center;\n  }\n\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["M" /* editorFontSize */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["X" /* paragraphSharedStyles */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["S" /* indentationSharedStyles */], __WEBPACK_IMPORTED_MODULE_7__plugins_block_type_styles__["a" /* blocktypeStyles */], __WEBPACK_IMPORTED_MODULE_16__plugins_text_formatting_styles__["a" /* textFormattingStyles */], __WEBPACK_IMPORTED_MODULE_17__plugins_placeholder_text_styles__["a" /* placeholderTextStyles */], __WEBPACK_IMPORTED_MODULE_6__plugins_placeholder_styles__["a" /* placeholderStyles */], __WEBPACK_IMPORTED_MODULE_8__plugins_code_block_styles__["a" /* codeBlockStyles */], __WEBPACK_IMPORTED_MODULE_9__plugins_lists_styles__["a" /* listsStyles */], __WEBPACK_IMPORTED_MODULE_10__plugins_rule_styles__["a" /* ruleStyles */], __WEBPACK_IMPORTED_MODULE_11__plugins_media_styles__["a" /* mediaStyles */], __WEBPACK_IMPORTED_MODULE_12__plugins_layout_styles__["a" /* layoutStyles */], __WEBPACK_IMPORTED_MODULE_3__plugins_collab_edit_styles__["a" /* telepointerStyle */], __WEBPACK_IMPORTED_MODULE_4__plugins_gap_cursor_styles__["a" /* gapCursorStyles */], __WEBPACK_IMPORTED_MODULE_5__plugins_table_ui_styles__["i" /* tableStyles */], __WEBPACK_IMPORTED_MODULE_13__plugins_panel_styles__["a" /* panelStyles */], __WEBPACK_IMPORTED_MODULE_14__plugins_fake_text_cursor_styles__["a" /* fakeCursorStyles */], __WEBPACK_IMPORTED_MODULE_15__plugins_mentions_styles__["a" /* mentionsStyles */], __WEBPACK_IMPORTED_MODULE_18__plugins_tasks_and_decisions_ui_styles__["a" /* tasksAndDecisionsStyles */], __WEBPACK_IMPORTED_MODULE_19__plugins_grid_styles__["b" /* gridStyles */], __WEBPACK_IMPORTED_MODULE_20__plugins_hyperlink_styles__["a" /* linkStyles */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["A" /* blockMarksSharedStyles */]);
/* harmony default export */ __webpack_exports__["a"] = (ContentStyles);
var templateObject_1;
//# sourceMappingURL=index.js.map

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return akEditorCodeFontFamily; });
/* unused harmony export akEditorInactiveForeground */
/* unused harmony export akEditorFocus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return akEditorSubtleAccent; });
/* unused harmony export akEditorActiveBackground */
/* unused harmony export akEditorActiveForeground */
/* unused harmony export akEditorBlockquoteBorderColor */
/* unused harmony export akEditorDropdownActiveBackground */
/* unused harmony export akEditorPopupBackground */
/* unused harmony export akEditorPopupText */
/* unused harmony export akEditorPrimaryButton */
/* unused harmony export akEditorCodeBackground */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return akEditorCodeBlockPadding; });
/* unused harmony export akEditorCodeInlinePadding */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return akEditorMentionSelected; });
/* unused harmony export akEditorRuleBackground */
/* unused harmony export akEditorRuleBorderRadius */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return akEditorToolbarKeylineHeight; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);

var B100 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100, B400 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400, B50 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B50, N0 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0, N20 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, N30 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N30, N40 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N40, N100 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N100, N500 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N500, N700 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, N900 = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N900;
var akEditorCodeFontFamily = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["codeFontFamily"])();
var akEditorInactiveForeground = N500;
var akEditorFocus = B100;
var akEditorSubtleAccent = N40;
var akEditorActiveBackground = N500;
var akEditorActiveForeground = N0;
var akEditorBlockquoteBorderColor = N40;
var akEditorDropdownActiveBackground = N900;
var akEditorPopupBackground = N700;
var akEditorPopupText = B50;
var akEditorPrimaryButton = B400;
var akEditorCodeBackground = N20;
var akEditorCodeBlockPadding = '12px';
var akEditorCodeInlinePadding = '2px 4px';
var akEditorMentionSelected = N100;
var akEditorRuleBackground = N30;
var akEditorRuleBorderRadius = '1px';
var akEditorToolbarKeylineHeight = 2;
//# sourceMappingURL=index.js.map

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return baseMarkPattern; });
/**
 * For text that has leading and ending space. We don't want to
 * convert it to `* strong *. Instead, we need it to be ` *strong* `
 */
var baseMarkPattern = function (text, token) {
    if (/^\s*$/.test(text)) {
        /**
         * If it's a string with only whitespaces, wiki renderer
         * will behave incorrect if we apply format on it
         */
        return text;
    }
    return text.replace(/^\s*/, "$&" + token).replace(/\s*$/, token + "$&");
};
//# sourceMappingURL=__base.js.map

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseAttrs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_querystring__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_querystring__);

function parseAttrs(str, sep) {
    if (sep === void 0) { sep = '|'; }
    var output = Object(__WEBPACK_IMPORTED_MODULE_0_querystring__["parse"])(str, sep);
    // take only first value of the same keys
    Object.keys(output).forEach(function (key) {
        if (Array.isArray(output[key])) {
            output[key] = output[key][0];
        }
    });
    return output;
}
//# sourceMappingURL=attrs.js.map

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export parseWhitespaceAndNewLine */
/* harmony export (immutable) */ __webpack_exports__["b"] = parseWhitespaceOnly;
/* harmony export (immutable) */ __webpack_exports__["a"] = parseNewlineOnly;
function parseWhitespaceAndNewLine(input) {
    var newlineLength = parseNewlineOnly(input);
    if (newlineLength) {
        return newlineLength;
    }
    var whitespaceLength = parseWhitespaceOnly(input);
    if (whitespaceLength) {
        return whitespaceLength;
    }
    // There is nether whitespace nor newline
    return 0;
}
function parseWhitespaceOnly(input) {
    var index = 0;
    var char = input.charAt(index);
    if (char === '\t' || char === ' ') {
        index++;
    }
    return index;
}
function parseNewlineOnly(input) {
    var index = 0;
    var char = input.charAt(index);
    if (char === '\r') {
        // CR (Unix)
        index++;
        if (input.charAt(index) === '\n') {
            // CRLF (Windows)
            index++;
        }
    }
    else if (char === '\n') {
        // LF (MacOS)
        index++;
    }
    return index;
}
//# sourceMappingURL=whitespace.js.map

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizePMNodes;
/* unused harmony export isNextLineEmpty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nodes_paragraph__ = __webpack_require__(2867);


function normalizePMNodes(nodes, schema) {
    var e_1, _a;
    var output = [];
    var inlineNodeBuffer = [];
    try {
        for (var nodes_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
            var node = nodes_1_1.value;
            if (!node.isBlock) {
                inlineNodeBuffer.push(node);
                continue;
            }
            var trimedInlineNodes_1 = trimInlineNodes(inlineNodeBuffer);
            if (trimedInlineNodes_1.length > 0) {
                output.push.apply(output, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](Object(__WEBPACK_IMPORTED_MODULE_1__nodes_paragraph__["b" /* createParagraphNodeFromInlineNodes */])(trimedInlineNodes_1, schema)));
            }
            inlineNodeBuffer = []; // clear buffer
            output.push(node);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var trimedInlineNodes = trimInlineNodes(inlineNodeBuffer);
    if (trimedInlineNodes.length > 0) {
        output.push.apply(output, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](Object(__WEBPACK_IMPORTED_MODULE_1__nodes_paragraph__["b" /* createParagraphNodeFromInlineNodes */])(trimedInlineNodes, schema)));
    }
    if (output.length === 0) {
        return [Object(__WEBPACK_IMPORTED_MODULE_1__nodes_paragraph__["a" /* createEmptyParagraphNode */])(schema)];
    }
    return output;
}
/**
 * Remove leading and trailing hardBreak
 */
function trimInlineNodes(nodes) {
    var leadingNode = nodes.shift();
    while (leadingNode) {
        if (leadingNode.type.name !== 'hardBreak') {
            nodes.unshift(leadingNode);
            break;
        }
        leadingNode = nodes.shift();
    }
    var trailingNode = nodes.pop();
    while (trailingNode) {
        if (trailingNode.type.name !== 'hardBreak') {
            nodes.push(trailingNode);
            break;
        }
        trailingNode = nodes.pop();
    }
    return nodes;
}
function isNextLineEmpty(input) {
    // Line with only spaces is considered an empty line
    return input.trim().length === 0;
}
//# sourceMappingURL=normalize.js.map

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return emojiRequest; });
/* unused harmony export getPixelRatio */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAltRepresentation; });
/* unused harmony export isMediaApiUrl */
/* unused harmony export denormaliseServiceRepresentation */
/* unused harmony export denormaliseServiceAltRepresentation */
/* unused harmony export denormaliseSkinEmoji */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return denormaliseEmojiServiceResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return shouldUseAltRepresentation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type_helpers__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_logger__ = __webpack_require__(120);




var emojiRequest = function (provider, options) {
    var _a = provider.getRatio, getRatio = _a === void 0 ? getPixelRatio : _a, serviceConfig = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](provider, ["getRatio"]);
    var scaleQueryParams = calculateScale(getRatio);
    var _b = options || {}, _c = _b.queryParams, queryParams = _c === void 0 ? {} : _c, otherOptions = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_b, ["queryParams"]);
    var requestOptions = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, otherOptions, { queryParams: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, scaleQueryParams, queryParams) });
    return __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */].requestService(serviceConfig, requestOptions);
};
var calculateScale = function (getRatio) {
    // Retina display
    if (getRatio() > 1) {
        return { scale: 'XHDPI', altScale: 'XXXHDPI' };
    }
    // Default set used for desktop
    return { altScale: 'XHDPI' };
};
var getPixelRatio = function () {
    return window.devicePixelRatio;
};
var getAltRepresentation = function (reps) {
    // Invalid reps handled outside function - logic may change depending what the service returns
    return reps[calculateScale(getPixelRatio).altScale];
};
var isMediaApiUrl = function (url, meta) {
    return !!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);
};
var denormaliseServiceRepresentation = function (representation, meta) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["n" /* isSpriteServiceRepresentation */])(representation) &&
        meta &&
        meta.spriteSheets) {
        var _a = representation, height = _a.height, width = _a.width, x = _a.x, y = _a.y, xIndex = _a.xIndex, yIndex = _a.yIndex, spriteRef = _a.spriteRef;
        var spriteSheet = meta.spriteSheets[spriteRef];
        if (spriteSheet) {
            return {
                sprite: spriteSheet,
                height: height,
                width: width,
                x: x,
                y: y,
                xIndex: xIndex,
                yIndex: yIndex,
            };
        }
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["h" /* isImageRepresentation */])(representation)) {
        var height = representation.height, width = representation.width, imagePath = representation.imagePath;
        if (isMediaApiUrl(imagePath, meta)) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["c" /* convertImageToMediaRepresentation */])(representation);
        }
        return {
            height: height,
            width: width,
            imagePath: imagePath,
        };
    }
    Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])('failed conversion for representation', representation, meta);
    return undefined;
};
var denormaliseServiceAltRepresentation = function (altReps, meta) {
    return !altReps || altReps === {}
        ? undefined
        : denormaliseServiceRepresentation(getAltRepresentation(altReps), meta);
};
var denormaliseSkinEmoji = function (emoji, meta) {
    if (!emoji.skinVariations) {
        return [];
    }
    var skinEmoji = emoji.skinVariations;
    var baseId = emoji.id;
    return skinEmoji.map(function (skin) {
        var representation = skin.representation, altRepresentations = skin.altRepresentations, other = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](skin, ["representation", "altRepresentations"]);
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ baseId: baseId, representation: denormaliseServiceRepresentation(representation, meta), altRepresentation: denormaliseServiceAltRepresentation(altRepresentations, meta) }, other);
    });
};
/**
 * Denormalised an emoji response (emojis + sprite references) into an array of
 * emoji with local sprite definitions.
 */
var denormaliseEmojiServiceResponse = function (emojiData) {
    var emojis = emojiData.emojis.map(function (emoji) {
        var newRepresentation = denormaliseServiceRepresentation(emoji.representation, emojiData.meta);
        var altRepresentation = denormaliseServiceAltRepresentation(emoji.altRepresentations, emojiData.meta);
        var newSkinVariations = denormaliseSkinEmoji(emoji, emojiData.meta);
        // create trimmedServiceDesc which is emoji with no representations or skinVariations
        var representation = emoji.representation, skinVariations = emoji.skinVariations, altRepresentations = emoji.altRepresentations, trimmedServiceDesc = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](emoji, ["representation", "skinVariations", "altRepresentations"]);
        var response = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, trimmedServiceDesc, { representation: newRepresentation, skinVariations: newSkinVariations });
        return Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["a" /* buildEmojiDescriptionWithAltRepresentation */])(response, altRepresentation);
    });
    var mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
    return {
        emojis: emojis,
        mediaApiToken: mediaApiToken,
    };
};
var getHeight = function (fitToHeight) {
    return getPixelRatio() > 1 ? fitToHeight * 2 : fitToHeight;
};
var shouldUseAltRepresentation = function (emoji, fitToHeight) {
    return !!(fitToHeight &&
        emoji.altRepresentation &&
        getHeight(fitToHeight) > emoji.representation.height);
};
//# sourceMappingURL=EmojiUtils.js.map

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export enableLogger */
/* unused harmony export enableStacktraces */
/* unused harmony export logStacktrace */
/* harmony export (immutable) */ __webpack_exports__["a"] = debug;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

var debugEnabled = false;
var stacktracesEnabled = false;
function enableLogger(enable) {
    debugEnabled = enable;
}
function enableStacktraces(enable) {
    stacktracesEnabled = enable;
}
function logStacktrace() {
    if (stacktracesEnabled) {
        // tslint:disable-next-line:no-console
        console.log(new Error().stack);
    }
}
function debug(msg) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (debugEnabled) {
        // tslint:disable-next-line:no-console
        console.log.apply(console, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"]([msg], args));
    }
}
//# sourceMappingURL=logger.js.map

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return emojiRequest; });
/* unused harmony export getPixelRatio */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAltRepresentation; });
/* unused harmony export isMediaApiUrl */
/* unused harmony export denormaliseServiceRepresentation */
/* unused harmony export denormaliseServiceAltRepresentation */
/* unused harmony export denormaliseSkinEmoji */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return denormaliseEmojiServiceResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return shouldUseAltRepresentation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type_helpers__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_logger__ = __webpack_require__(121);




var emojiRequest = function (provider, options) {
    var _a = provider.getRatio, getRatio = _a === void 0 ? getPixelRatio : _a, serviceConfig = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](provider, ["getRatio"]);
    var scaleQueryParams = calculateScale(getRatio);
    var _b = options || {}, _c = _b.queryParams, queryParams = _c === void 0 ? {} : _c, otherOptions = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_b, ["queryParams"]);
    var requestOptions = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, otherOptions, { queryParams: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, scaleQueryParams, queryParams) });
    return __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */].requestService(serviceConfig, requestOptions);
};
var calculateScale = function (getRatio) {
    // Retina display
    if (getRatio() > 1) {
        return { scale: 'XHDPI', altScale: 'XXXHDPI' };
    }
    // Default set used for desktop
    return { altScale: 'XHDPI' };
};
var getPixelRatio = function () {
    return window.devicePixelRatio;
};
var getAltRepresentation = function (reps) {
    // Invalid reps handled outside function - logic may change depending what the service returns
    return reps[calculateScale(getPixelRatio).altScale];
};
var isMediaApiUrl = function (url, meta) {
    return !!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);
};
var denormaliseServiceRepresentation = function (representation, meta) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["n" /* isSpriteServiceRepresentation */])(representation) &&
        meta &&
        meta.spriteSheets) {
        var _a = representation, height = _a.height, width = _a.width, x = _a.x, y = _a.y, xIndex = _a.xIndex, yIndex = _a.yIndex, spriteRef = _a.spriteRef;
        var spriteSheet = meta.spriteSheets[spriteRef];
        if (spriteSheet) {
            return {
                sprite: spriteSheet,
                height: height,
                width: width,
                x: x,
                y: y,
                xIndex: xIndex,
                yIndex: yIndex,
            };
        }
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["h" /* isImageRepresentation */])(representation)) {
        var height = representation.height, width = representation.width, imagePath = representation.imagePath;
        if (isMediaApiUrl(imagePath, meta)) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["c" /* convertImageToMediaRepresentation */])(representation);
        }
        return {
            height: height,
            width: width,
            imagePath: imagePath,
        };
    }
    Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])('failed conversion for representation', representation, meta);
    return undefined;
};
var denormaliseServiceAltRepresentation = function (altReps, meta) {
    return !altReps || altReps === {}
        ? undefined
        : denormaliseServiceRepresentation(getAltRepresentation(altReps), meta);
};
var denormaliseSkinEmoji = function (emoji, meta) {
    if (!emoji.skinVariations) {
        return [];
    }
    var skinEmoji = emoji.skinVariations;
    var baseId = emoji.id;
    return skinEmoji.map(function (skin) {
        var representation = skin.representation, altRepresentations = skin.altRepresentations, other = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](skin, ["representation", "altRepresentations"]);
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ baseId: baseId, representation: denormaliseServiceRepresentation(representation, meta), altRepresentation: denormaliseServiceAltRepresentation(altRepresentations, meta) }, other);
    });
};
/**
 * Denormalised an emoji response (emojis + sprite references) into an array of
 * emoji with local sprite definitions.
 */
var denormaliseEmojiServiceResponse = function (emojiData) {
    var emojis = emojiData.emojis.map(function (emoji) {
        var newRepresentation = denormaliseServiceRepresentation(emoji.representation, emojiData.meta);
        var altRepresentation = denormaliseServiceAltRepresentation(emoji.altRepresentations, emojiData.meta);
        var newSkinVariations = denormaliseSkinEmoji(emoji, emojiData.meta);
        // create trimmedServiceDesc which is emoji with no representations or skinVariations
        var representation = emoji.representation, skinVariations = emoji.skinVariations, altRepresentations = emoji.altRepresentations, trimmedServiceDesc = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](emoji, ["representation", "skinVariations", "altRepresentations"]);
        var response = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, trimmedServiceDesc, { representation: newRepresentation, skinVariations: newSkinVariations });
        return Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["a" /* buildEmojiDescriptionWithAltRepresentation */])(response, altRepresentation);
    });
    var mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
    return {
        emojis: emojis,
        mediaApiToken: mediaApiToken,
    };
};
var getHeight = function (fitToHeight) {
    return getPixelRatio() > 1 ? fitToHeight * 2 : fitToHeight;
};
var shouldUseAltRepresentation = function (emoji, fitToHeight) {
    return !!(fitToHeight &&
        emoji.altRepresentation &&
        getHeight(fitToHeight) > emoji.representation.height);
};
//# sourceMappingURL=EmojiUtils.js.map

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export enableLogger */
/* unused harmony export enableStacktraces */
/* unused harmony export logStacktrace */
/* harmony export (immutable) */ __webpack_exports__["a"] = debug;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

var debugEnabled = false;
var stacktracesEnabled = false;
function enableLogger(enable) {
    debugEnabled = enable;
}
function enableStacktraces(enable) {
    stacktracesEnabled = enable;
}
function logStacktrace() {
    if (stacktracesEnabled) {
        // tslint:disable-next-line:no-console
        console.log(new Error().stack);
    }
}
function debug(msg) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (debugEnabled) {
        // tslint:disable-next-line:no-console
        console.log.apply(console, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"]([msg], args));
    }
}
//# sourceMappingURL=logger.js.map

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_element__ = __webpack_require__(3036);



var newLineRegex = /\n/g;

function getNewLines(str) {
  return str.match(newLineRegex);
}

function getLineNumbers(_ref) {
  var lines = _ref.lines,
      startingLineNumber = _ref.startingLineNumber,
      style = _ref.style;
  return lines.map(function (_, i) {
    var number = i + startingLineNumber;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", {
      key: "line-".concat(i),
      className: "react-syntax-highlighter-line-number",
      style: typeof style === 'function' ? style(number) : style
    }, "".concat(number, "\n"));
  });
}

function LineNumbers(_ref2) {
  var codeString = _ref2.codeString,
      codeStyle = _ref2.codeStyle,
      _ref2$containerStyle = _ref2.containerStyle,
      containerStyle = _ref2$containerStyle === void 0 ? {
    float: 'left',
    paddingRight: '10px'
  } : _ref2$containerStyle,
      _ref2$numberStyle = _ref2.numberStyle,
      numberStyle = _ref2$numberStyle === void 0 ? {} : _ref2$numberStyle,
      startingLineNumber = _ref2.startingLineNumber;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("code", {
    style: Object.assign({}, codeStyle, containerStyle)
  }, getLineNumbers({
    lines: codeString.replace(/\n$/, '').split('\n'),
    style: numberStyle,
    startingLineNumber: startingLineNumber
  }));
}

function createLineElement(_ref3) {
  var children = _ref3.children,
      lineNumber = _ref3.lineNumber,
      lineProps = _ref3.lineProps,
      _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? [] : _ref3$className;
  var properties = (typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps) || {};
  properties.className = properties.className ? className.concat(properties.className) : className;
  return {
    type: 'element',
    tagName: 'span',
    properties: properties,
    children: children
  };
}

function flattenCodeTree(tree) {
  var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var newTree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  for (var i = 0; i < tree.length; i++) {
    var node = tree[i];

    if (node.type === 'text') {
      newTree.push(createLineElement({
        children: [node],
        className: className
      }));
    } else if (node.children) {
      var classNames = className.concat(node.properties.className);
      newTree = newTree.concat(flattenCodeTree(node.children, classNames));
    }
  }

  return newTree;
}

function wrapLinesInSpan(codeTree, lineProps) {
  var tree = flattenCodeTree(codeTree.value);
  var newTree = [];
  var lastLineBreakIndex = -1;
  var index = 0;

  var _loop = function _loop() {
    var node = tree[index];
    var value = node.children[0].value;
    var newLines = getNewLines(value);

    if (newLines) {
      var splitValue = value.split('\n');
      splitValue.forEach(function (text, i) {
        var lineNumber = newTree.length + 1;
        var newChild = {
          type: 'text',
          value: "".concat(text, "\n")
        };

        if (i === 0) {
          var _children = tree.slice(lastLineBreakIndex + 1, index).concat(createLineElement({
            children: [newChild],
            className: node.properties.className
          }));

          newTree.push(createLineElement({
            children: _children,
            lineNumber: lineNumber,
            lineProps: lineProps
          }));
        } else if (i === splitValue.length - 1) {
          var stringChild = tree[index + 1] && tree[index + 1].children && tree[index + 1].children[0];

          if (stringChild) {
            var lastLineInPreviousSpan = {
              type: 'text',
              value: "".concat(text)
            };
            var newElem = createLineElement({
              children: [lastLineInPreviousSpan],
              className: node.properties.className
            });
            tree.splice(index + 1, 0, newElem);
          } else {
            newTree.push(createLineElement({
              children: [newChild],
              lineNumber: lineNumber,
              lineProps: lineProps,
              className: node.properties.className
            }));
          }
        } else {
          newTree.push(createLineElement({
            children: [newChild],
            lineNumber: lineNumber,
            lineProps: lineProps,
            className: node.properties.className
          }));
        }
      });
      lastLineBreakIndex = index;
    }

    index++;
  };

  while (index < tree.length) {
    _loop();
  }

  if (lastLineBreakIndex !== tree.length - 1) {
    var children = tree.slice(lastLineBreakIndex + 1, tree.length);

    if (children && children.length) {
      newTree.push(createLineElement({
        children: children,
        lineNumber: newTree.length + 1,
        lineProps: lineProps
      }));
    }
  }

  return newTree;
}

function defaultRenderer(_ref4) {
  var rows = _ref4.rows,
      stylesheet = _ref4.stylesheet,
      useInlineStyles = _ref4.useInlineStyles;
  return rows.map(function (node, i) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__create_element__["a" /* default */])({
      node: node,
      stylesheet: stylesheet,
      useInlineStyles: useInlineStyles,
      key: "code-segement".concat(i)
    });
  });
}

function getCodeTree(_ref5) {
  var astGenerator = _ref5.astGenerator,
      language = _ref5.language,
      code = _ref5.code,
      defaultCodeValue = _ref5.defaultCodeValue;

  if (astGenerator.getLanguage) {
    var hasLanguage = language && astGenerator.getLanguage(language);

    if (language === 'text') {
      return {
        value: defaultCodeValue,
        language: 'text'
      };
    } else if (hasLanguage) {
      return astGenerator.highlight(language, code);
    } else {
      return astGenerator.highlightAuto(code);
    }
  }

  try {
    return language && language !== 'text' ? {
      value: astGenerator.highlight(code, language)
    } : {
      value: defaultCodeValue
    };
  } catch (e) {
    return {
      value: defaultCodeValue
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (function (defaultAstGenerator, defaultStyle) {
  return function SyntaxHighlighter(_ref6) {
    var language = _ref6.language,
        children = _ref6.children,
        _ref6$style = _ref6.style,
        style = _ref6$style === void 0 ? defaultStyle : _ref6$style,
        _ref6$customStyle = _ref6.customStyle,
        customStyle = _ref6$customStyle === void 0 ? {} : _ref6$customStyle,
        _ref6$codeTagProps = _ref6.codeTagProps,
        codeTagProps = _ref6$codeTagProps === void 0 ? {
      style: style['code[class*="language-"]']
    } : _ref6$codeTagProps,
        _ref6$useInlineStyles = _ref6.useInlineStyles,
        useInlineStyles = _ref6$useInlineStyles === void 0 ? true : _ref6$useInlineStyles,
        _ref6$showLineNumbers = _ref6.showLineNumbers,
        showLineNumbers = _ref6$showLineNumbers === void 0 ? false : _ref6$showLineNumbers,
        _ref6$startingLineNum = _ref6.startingLineNumber,
        startingLineNumber = _ref6$startingLineNum === void 0 ? 1 : _ref6$startingLineNum,
        lineNumberContainerStyle = _ref6.lineNumberContainerStyle,
        lineNumberStyle = _ref6.lineNumberStyle,
        wrapLines = _ref6.wrapLines,
        _ref6$lineProps = _ref6.lineProps,
        lineProps = _ref6$lineProps === void 0 ? {} : _ref6$lineProps,
        renderer = _ref6.renderer,
        _ref6$PreTag = _ref6.PreTag,
        PreTag = _ref6$PreTag === void 0 ? 'pre' : _ref6$PreTag,
        _ref6$CodeTag = _ref6.CodeTag,
        CodeTag = _ref6$CodeTag === void 0 ? 'code' : _ref6$CodeTag,
        _ref6$code = _ref6.code,
        code = _ref6$code === void 0 ? Array.isArray(children) ? children[0] : children : _ref6$code,
        astGenerator = _ref6.astGenerator,
        rest = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(_ref6, ["language", "children", "style", "customStyle", "codeTagProps", "useInlineStyles", "showLineNumbers", "startingLineNumber", "lineNumberContainerStyle", "lineNumberStyle", "wrapLines", "lineProps", "renderer", "PreTag", "CodeTag", "code", "astGenerator"]);

    astGenerator = astGenerator || defaultAstGenerator;
    var lineNumbers = showLineNumbers ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LineNumbers, {
      containerStyle: lineNumberContainerStyle,
      codeStyle: codeTagProps.style || {},
      numberStyle: lineNumberStyle,
      startingLineNumber: startingLineNumber,
      codeString: code
    }) : null;
    var defaultPreStyle = style.hljs || style['pre[class*="language-"]'] || {
      backgroundColor: '#fff'
    };
    var preProps = useInlineStyles ? Object.assign({}, rest, {
      style: Object.assign({}, defaultPreStyle, customStyle)
    }) : Object.assign({}, rest, {
      className: 'hljs'
    });

    if (!astGenerator) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PreTag, preProps, lineNumbers, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CodeTag, codeTagProps, code));
    }
    /*
     * some custom renderers rely on individual row elements so we need to turn wrapLines on
     * if renderer is provided and wrapLines is undefined
     */


    wrapLines = renderer && wrapLines === undefined ? true : wrapLines;
    renderer = renderer || defaultRenderer;
    var defaultCodeValue = [{
      type: 'text',
      value: code
    }];
    var codeTree = getCodeTree({
      astGenerator: astGenerator,
      language: language,
      code: code,
      defaultCodeValue: defaultCodeValue
    });

    if (codeTree.language === null) {
      codeTree.value = defaultCodeValue;
    }

    var tree = wrapLines ? wrapLinesInSpan(codeTree, lineProps) : codeTree.value;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PreTag, preProps, lineNumbers, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CodeTag, codeTagProps, renderer({
      rows: tree,
      stylesheet: style,
      useInlineStyles: useInlineStyles
    })));
  };
});

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var normalize = __webpack_require__(493)
var Schema = __webpack_require__(1263)
var DefinedInfo = __webpack_require__(1264)

module.exports = create

function create(definition) {
  var space = definition.space
  var mustUseProperty = definition.mustUseProperty || []
  var attributes = definition.attributes || {}
  var props = definition.properties
  var transform = definition.transform
  var property = {}
  var normal = {}
  var prop
  var info

  for (prop in props) {
    info = new DefinedInfo(
      prop,
      transform(attributes, prop),
      props[prop],
      space
    )

    if (mustUseProperty.indexOf(prop) !== -1) {
      info.mustUseProperty = true
    }

    property[prop] = info

    normal[normalize(prop)] = prop
    normal[normalize(info.attribute)] = prop
  }

  return new Schema(property, normal, space)
}


/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AccessSelfService;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectAccessStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectAccessBotResults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectUserCheckResults; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(116);
var defaultState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["c" /* fromJS */])({});function AccessSelfService(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];state=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["c" /* fromJS */])(state);// Force immutable in case of rehydration
switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* getUserAccessStatus */].event.success:return state.set('accessStatus',action.payload);case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* triggerAccessBot */].event.success:return state.set('accessBotResults',action.payload);case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* checkUserExists */].event.success:return state.set('userCheckResults',action.payload);case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* clearUserCheck */].type:return state.set('userCheckResults',null);case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* setUserCheckResults */].type:return state.set('userCheckResults',action.payload);case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* clearAccessBotResults */].type:return state.set('accessBotResults',null);case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* clearUserStatus */].type:return state.set('accessStatus',null);default:return state;}}var selectAccessStatus=function selectAccessStatus(state){return state.AccessSelfService.get('accessStatus');};var selectAccessBotResults=function selectAccessBotResults(state){return state.AccessSelfService.get('accessBotResults');};var selectUserCheckResults=function selectUserCheckResults(state){return state.AccessSelfService.get('userCheckResults');};

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(3186));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var RefreshIcon = function RefreshIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003h3z\" fill-rule=\"nonzero\"/><path d=\"M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.979.979 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388z\" fill-rule=\"nonzero\"/><path d=\"M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0z\"/><path d=\"M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.957.957 0 0 0 15.002 4a1 1 0 0 0-.905.596z\"/></g></svg>"
  }, props));
};

RefreshIcon.displayName = 'RefreshIcon';
var _default = RefreshIcon;
exports.default = _default;

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = appStatus;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectAppList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_immutableUtils__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(498);
var defaultState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["c" /* fromJS */])({appList:null});function appStatus(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];state=Object(__WEBPACK_IMPORTED_MODULE_1__util_immutableUtils__["a" /* forceImmutable */])(state);// Force immutable in case of rehydration
switch(action.type){case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* getAppStatus */].event.success:return state.set('appList',action.payload);default:return state;}}var selectAppList=function selectAppList(state){return state.appStatus.get("appList");};

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var formatName = function formatName(_ref, name) {
  var sectionPrefix = _ref._reduxForm.sectionPrefix;
  return sectionPrefix ? sectionPrefix + '.' + name : name;
};


/* harmony default export */ __webpack_exports__["a"] = (formatName);

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ __webpack_exports__["a"] = (eq);


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSymbol_js__ = __webpack_require__(312);


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || Object(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (toKey);


/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(514);



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLike);


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DropdownMenu__ = __webpack_require__(2161);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__components_DropdownMenu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DropdownMenuStateless__ = __webpack_require__(753);
/* unused harmony reexport DropdownMenuStateless */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_item_DropdownItem__ = __webpack_require__(2189);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__components_item_DropdownItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_item_DropdownItemRadio__ = __webpack_require__(2190);
/* unused harmony reexport DropdownItemRadio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_item_DropdownItemCheckbox__ = __webpack_require__(2193);
/* unused harmony reexport DropdownItemCheckbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_group_DropdownItemGroup__ = __webpack_require__(421);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__components_group_DropdownItemGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_group_DropdownItemGroupRadio__ = __webpack_require__(2195);
/* unused harmony reexport DropdownItemGroupRadio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_group_DropdownItemGroupCheckbox__ = __webpack_require__(2197);
/* unused harmony reexport DropdownItemGroupCheckbox */
// menu exports

 // Item exports



 // ItemGroup exports





/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FieldBase__ = __webpack_require__(1801);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_FieldBase__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FieldBaseStateless__ = __webpack_require__(671);
/* unused harmony reexport FieldBaseStateless */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Label__ = __webpack_require__(1812);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__components_Label__["a"]; });




/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(1765);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}
module.exports = exports['default'];

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withOuterListeners;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);




// tslint:disable:next-line variable-name
function withOuterListeners(Component) {
    return /** @class */ (function (_super) {
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WithOutsideClick, _super);
        function WithOutsideClick() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.handleClick = function (evt) {
                var domNode = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](_this); // eslint-disable-line react/no-find-dom-node
                if (!domNode ||
                    (evt.target instanceof Node && !domNode.contains(evt.target))) {
                    _this.props.handleClickOutside();
                }
            };
            _this.handleKeydown = function (evt) {
                if (evt.code === 'Escape' && _this.props.handleEscapeKeydown) {
                    _this.props.handleEscapeKeydown();
                }
                else if (evt.code === 'Enter' && _this.props.handleEnterKeydown) {
                    _this.props.handleEnterKeydown();
                }
            };
            return _this;
        }
        WithOutsideClick.prototype.componentDidMount = function () {
            if (this.props.handleClickOutside) {
                document.addEventListener('click', this.handleClick, false);
            }
            if (this.props.handleEscapeKeydown) {
                document.addEventListener('keydown', this.handleKeydown, false);
            }
        };
        WithOutsideClick.prototype.componentWillUnmount = function () {
            if (this.props.handleClickOutside) {
                document.removeEventListener('click', this.handleClick, false);
            }
            if (this.props.handleEscapeKeydown) {
                document.removeEventListener('keydown', this.handleKeydown, false);
            }
        };
        WithOutsideClick.prototype.render = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Component, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, this.props));
        };
        return WithOutsideClick;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
}
//# sourceMappingURL=with-outer-listeners.js.map

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FabricElementsAnalyticsContext__ = __webpack_require__(2732);
/* unused harmony reexport ELEMENTS_CONTEXT */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FabricElementsAnalyticsContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavigationAnalyticsContext__ = __webpack_require__(2733);
/* unused harmony reexport NAVIGATION_CONTEXT */
/* unused harmony reexport NavigationAnalyticsContext */


//# sourceMappingURL=index.js.map

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(96);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(185);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["a" /* default */])(a.state, b.state);
};

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(1463);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

var quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (
        (typeof globalThis !== 'undefined' && obj === globalThis)
        || (typeof global !== 'undefined' && obj === global)
    ) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style];
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function canTrustToString(obj) {
    return !toStringTag || !(typeof obj === 'object' && (toStringTag in obj || typeof obj[toStringTag] !== 'undefined'));
}
function isArray(obj) { return toStr(obj) === '[object Array]' && canTrustToString(obj); }
function isDate(obj) { return toStr(obj) === '[object Date]' && canTrustToString(obj); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && canTrustToString(obj); }
function isError(obj) { return toStr(obj) === '[object Error]' && canTrustToString(obj); }
function isString(obj) { return toStr(obj) === '[object String]' && canTrustToString(obj); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && canTrustToString(obj); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && canTrustToString(obj); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(1485);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rc_tooltip__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_tooltip_assets_bootstrap_css__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_tooltip_assets_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rc_tooltip_assets_bootstrap_css__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var hover=_ref.hover,click=_ref.click,focus=_ref.focus,trigger=_ref.trigger,_ref$placement=_ref.placement,placement=_ref$placement===undefined?'right':_ref$placement,content=_ref.content,children=_ref.children;if((hover||click||focus)&&trigger)throw new Error('trigger cannot be used with click, hover, and focus. trigger is the long-form of those options');if(!trigger){trigger=[];if(click)trigger.push('click');if(hover)trigger.push('hover');if(focus)trigger.push('focus');if(!trigger.length)trigger.push('hover');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_rc_tooltip__["a" /* default */],{placement:placement,trigger:trigger,overlay:content},children);});

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 258 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 259 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1505);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1513);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/editor-core","version":"94.0.0","sideEffects":false}

/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports = {"aliceblue":"#f0f8ff","antiquewhite":"#faebd7","aqua":"#00ffff","aquamarine":"#7fffd4","azure":"#f0ffff","beige":"#f5f5dc","bisque":"#ffe4c4","black":"#000000","blanchedalmond":"#ffebcd","blue":"#0000ff","blueviolet":"#8a2be2","brown":"#a52a2a","burlywood":"#deb887","cadetblue":"#5f9ea0","chartreuse":"#7fff00","chocolate":"#d2691e","coral":"#ff7f50","cornflowerblue":"#6495ed","cornsilk":"#fff8dc","crimson":"#dc143c","cyan":"#00ffff","darkblue":"#00008b","darkcyan":"#008b8b","darkgoldenrod":"#b8860b","darkgray":"#a9a9a9","darkgreen":"#006400","darkgrey":"#a9a9a9","darkkhaki":"#bdb76b","darkmagenta":"#8b008b","darkolivegreen":"#556b2f","darkorange":"#ff8c00","darkorchid":"#9932cc","darkred":"#8b0000","darksalmon":"#e9967a","darkseagreen":"#8fbc8f","darkslateblue":"#483d8b","darkslategray":"#2f4f4f","darkslategrey":"#2f4f4f","darkturquoise":"#00ced1","darkviolet":"#9400d3","deeppink":"#ff1493","deepskyblue":"#00bfff","dimgray":"#696969","dimgrey":"#696969","dodgerblue":"#1e90ff","firebrick":"#b22222","floralwhite":"#fffaf0","forestgreen":"#228b22","fuchsia":"#ff00ff","gainsboro":"#dcdcdc","ghostwhite":"#f8f8ff","gold":"#ffd700","goldenrod":"#daa520","gray":"#808080","green":"#008000","greenyellow":"#adff2f","grey":"#808080","honeydew":"#f0fff0","hotpink":"#ff69b4","indianred":"#cd5c5c","indigo":"#4b0082","ivory":"#fffff0","khaki":"#f0e68c","lavender":"#e6e6fa","lavenderblush":"#fff0f5","lawngreen":"#7cfc00","lemonchiffon":"#fffacd","lightblue":"#add8e6","lightcoral":"#f08080","lightcyan":"#e0ffff","lightgoldenrodyellow":"#fafad2","lightgray":"#d3d3d3","lightgreen":"#90ee90","lightgrey":"#d3d3d3","lightpink":"#ffb6c1","lightsalmon":"#ffa07a","lightseagreen":"#20b2aa","lightskyblue":"#87cefa","lightslategray":"#778899","lightslategrey":"#778899","lightsteelblue":"#b0c4de","lightyellow":"#ffffe0","lime":"#00ff00","limegreen":"#32cd32","linen":"#faf0e6","magenta":"#ff00ff","maroon":"#800000","mediumaquamarine":"#66cdaa","mediumblue":"#0000cd","mediumorchid":"#ba55d3","mediumpurple":"#9370db","mediumseagreen":"#3cb371","mediumslateblue":"#7b68ee","mediumspringgreen":"#00fa9a","mediumturquoise":"#48d1cc","mediumvioletred":"#c71585","midnightblue":"#191970","mintcream":"#f5fffa","mistyrose":"#ffe4e1","moccasin":"#ffe4b5","navajowhite":"#ffdead","navy":"#000080","oldlace":"#fdf5e6","olive":"#808000","olivedrab":"#6b8e23","orange":"#ffa500","orangered":"#ff4500","orchid":"#da70d6","palegoldenrod":"#eee8aa","palegreen":"#98fb98","paleturquoise":"#afeeee","palevioletred":"#db7093","papayawhip":"#ffefd5","peachpuff":"#ffdab9","peru":"#cd853f","pink":"#ffc0cb","plum":"#dda0dd","powderblue":"#b0e0e6","purple":"#800080","rebeccapurple":"#663399","red":"#ff0000","rosybrown":"#bc8f8f","royalblue":"#4169e1","saddlebrown":"#8b4513","salmon":"#fa8072","sandybrown":"#f4a460","seagreen":"#2e8b57","seashell":"#fff5ee","sienna":"#a0522d","silver":"#c0c0c0","skyblue":"#87ceeb","slateblue":"#6a5acd","slategray":"#708090","slategrey":"#708090","snow":"#fffafa","springgreen":"#00ff7f","steelblue":"#4682b4","tan":"#d2b48c","teal":"#008080","thistle":"#d8bfd8","tomato":"#ff6347","turquoise":"#40e0d0","violet":"#ee82ee","wheat":"#f5deb3","white":"#ffffff","whitesmoke":"#f5f5f5","yellow":"#ffff00","yellowgreen":"#9acd32"}

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



////////////////////////////////////////////////////////////////////////////////
// Helpers

// Merge objects
//
function assign(obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);

  sources.forEach(function (source) {
    if (!source) { return; }

    Object.keys(source).forEach(function (key) {
      obj[key] = source[key];
    });
  });

  return obj;
}

function _class(obj) { return Object.prototype.toString.call(obj); }
function isString(obj) { return _class(obj) === '[object String]'; }
function isObject(obj) { return _class(obj) === '[object Object]'; }
function isRegExp(obj) { return _class(obj) === '[object RegExp]'; }
function isFunction(obj) { return _class(obj) === '[object Function]'; }


function escapeRE(str) { return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&'); }

////////////////////////////////////////////////////////////////////////////////


var defaultOptions = {
  fuzzyLink: true,
  fuzzyEmail: true,
  fuzzyIP: false
};


function isOptionsObj(obj) {
  return Object.keys(obj || {}).reduce(function (acc, k) {
    return acc || defaultOptions.hasOwnProperty(k);
  }, false);
}


var defaultSchemas = {
  'http:': {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.http) {
        // compile lazily, because "host"-containing variables can change on tlds update.
        self.re.http =  new RegExp(
          '^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i'
        );
      }
      if (self.re.http.test(tail)) {
        return tail.match(self.re.http)[0].length;
      }
      return 0;
    }
  },
  'https:':  'http:',
  'ftp:':    'http:',
  '//':      {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.no_http) {
      // compile lazily, because "host"-containing variables can change on tlds update.
        self.re.no_http =  new RegExp(
          '^' +
          self.re.src_auth +
          // Don't allow single-level domains, because of false positives like '//test'
          // with code comments
          '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' +
          self.re.src_port +
          self.re.src_host_terminator +
          self.re.src_path,

          'i'
        );
      }

      if (self.re.no_http.test(tail)) {
        // should not be `://` & `///`, that protects from errors in protocol name
        if (pos >= 3 && text[pos - 3] === ':') { return 0; }
        if (pos >= 3 && text[pos - 3] === '/') { return 0; }
        return tail.match(self.re.no_http)[0].length;
      }
      return 0;
    }
  },
  'mailto:': {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.mailto) {
        self.re.mailto =  new RegExp(
          '^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i'
        );
      }
      if (self.re.mailto.test(tail)) {
        return tail.match(self.re.mailto)[0].length;
      }
      return 0;
    }
  }
};

/*eslint-disable max-len*/

// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';

// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var tlds_default = 'biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф'.split('|');

/*eslint-enable max-len*/

////////////////////////////////////////////////////////////////////////////////

function resetScanCache(self) {
  self.__index__ = -1;
  self.__text_cache__   = '';
}

function createValidator(re) {
  return function (text, pos) {
    var tail = text.slice(pos);

    if (re.test(tail)) {
      return tail.match(re)[0].length;
    }
    return 0;
  };
}

function createNormalizer() {
  return function (match, self) {
    self.normalize(match);
  };
}

// Schemas compiler. Build regexps.
//
function compile(self) {

  // Load & clone RE patterns.
  var re = self.re = __webpack_require__(1686)(self.__opts__);

  // Define dynamic patterns
  var tlds = self.__tlds__.slice();

  self.onCompile();

  if (!self.__tlds_replaced__) {
    tlds.push(tlds_2ch_src_re);
  }
  tlds.push(re.src_xn);

  re.src_tlds = tlds.join('|');

  function untpl(tpl) { return tpl.replace('%TLDS%', re.src_tlds); }

  re.email_fuzzy      = RegExp(untpl(re.tpl_email_fuzzy), 'i');
  re.link_fuzzy       = RegExp(untpl(re.tpl_link_fuzzy), 'i');
  re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
  re.host_fuzzy_test  = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');

  //
  // Compile each schema
  //

  var aliases = [];

  self.__compiled__ = {}; // Reset compiled data

  function schemaError(name, val) {
    throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
  }

  Object.keys(self.__schemas__).forEach(function (name) {
    var val = self.__schemas__[name];

    // skip disabled methods
    if (val === null) { return; }

    var compiled = { validate: null, link: null };

    self.__compiled__[name] = compiled;

    if (isObject(val)) {
      if (isRegExp(val.validate)) {
        compiled.validate = createValidator(val.validate);
      } else if (isFunction(val.validate)) {
        compiled.validate = val.validate;
      } else {
        schemaError(name, val);
      }

      if (isFunction(val.normalize)) {
        compiled.normalize = val.normalize;
      } else if (!val.normalize) {
        compiled.normalize = createNormalizer();
      } else {
        schemaError(name, val);
      }

      return;
    }

    if (isString(val)) {
      aliases.push(name);
      return;
    }

    schemaError(name, val);
  });

  //
  // Compile postponed aliases
  //

  aliases.forEach(function (alias) {
    if (!self.__compiled__[self.__schemas__[alias]]) {
      // Silently fail on missed schemas to avoid errons on disable.
      // schemaError(alias, self.__schemas__[alias]);
      return;
    }

    self.__compiled__[alias].validate =
      self.__compiled__[self.__schemas__[alias]].validate;
    self.__compiled__[alias].normalize =
      self.__compiled__[self.__schemas__[alias]].normalize;
  });

  //
  // Fake record for guessed links
  //
  self.__compiled__[''] = { validate: null, normalize: createNormalizer() };

  //
  // Build schema condition
  //
  var slist = Object.keys(self.__compiled__)
                      .filter(function (name) {
                        // Filter disabled & fake schemas
                        return name.length > 0 && self.__compiled__[name];
                      })
                      .map(escapeRE)
                      .join('|');
  // (?!_) cause 1.5x slowdown
  self.re.schema_test   = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
  self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');

  self.re.pretest = RegExp(
    '(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@',
    'i'
  );

  //
  // Cleanup
  //

  resetScanCache(self);
}

/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/
function Match(self, shift) {
  var start = self.__index__,
      end   = self.__last_index__,
      text  = self.__text_cache__.slice(start, end);

  /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/
  this.schema    = self.__schema__.toLowerCase();
  /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/
  this.index     = start + shift;
  /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/
  this.lastIndex = end + shift;
  /**
   * Match#raw -> String
   *
   * Matched string.
   **/
  this.raw       = text;
  /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/
  this.text      = text;
  /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/
  this.url       = text;
}

function createMatch(self, shift) {
  var match = new Match(self, shift);

  self.__compiled__[match.schema].normalize(match, self);

  return match;
}


/**
 * class LinkifyIt
 **/

/**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/
function LinkifyIt(schemas, options) {
  if (!(this instanceof LinkifyIt)) {
    return new LinkifyIt(schemas, options);
  }

  if (!options) {
    if (isOptionsObj(schemas)) {
      options = schemas;
      schemas = {};
    }
  }

  this.__opts__           = assign({}, defaultOptions, options);

  // Cache last tested result. Used to skip repeating steps on next `match` call.
  this.__index__          = -1;
  this.__last_index__     = -1; // Next scan position
  this.__schema__         = '';
  this.__text_cache__     = '';

  this.__schemas__        = assign({}, defaultSchemas, schemas);
  this.__compiled__       = {};

  this.__tlds__           = tlds_default;
  this.__tlds_replaced__  = false;

  this.re = {};

  compile(this);
}


/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/
LinkifyIt.prototype.add = function add(schema, definition) {
  this.__schemas__[schema] = definition;
  compile(this);
  return this;
};


/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/
LinkifyIt.prototype.set = function set(options) {
  this.__opts__ = assign(this.__opts__, options);
  return this;
};


/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/
LinkifyIt.prototype.test = function test(text) {
  // Reset scan cache
  this.__text_cache__ = text;
  this.__index__      = -1;

  if (!text.length) { return false; }

  var m, ml, me, len, shift, next, re, tld_pos, at_pos;

  // try to scan for link with schema - that's the most simple rule
  if (this.re.schema_test.test(text)) {
    re = this.re.schema_search;
    re.lastIndex = 0;
    while ((m = re.exec(text)) !== null) {
      len = this.testSchemaAt(text, m[2], re.lastIndex);
      if (len) {
        this.__schema__     = m[2];
        this.__index__      = m.index + m[1].length;
        this.__last_index__ = m.index + m[0].length + len;
        break;
      }
    }
  }

  if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
    // guess schemaless links
    tld_pos = text.search(this.re.host_fuzzy_test);
    if (tld_pos >= 0) {
      // if tld is located after found link - no need to check fuzzy pattern
      if (this.__index__ < 0 || tld_pos < this.__index__) {
        if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {

          shift = ml.index + ml[1].length;

          if (this.__index__ < 0 || shift < this.__index__) {
            this.__schema__     = '';
            this.__index__      = shift;
            this.__last_index__ = ml.index + ml[0].length;
          }
        }
      }
    }
  }

  if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
    // guess schemaless emails
    at_pos = text.indexOf('@');
    if (at_pos >= 0) {
      // We can't skip this check, because this cases are possible:
      // 192.168.1.1@gmail.com, my.in@example.com
      if ((me = text.match(this.re.email_fuzzy)) !== null) {

        shift = me.index + me[1].length;
        next  = me.index + me[0].length;

        if (this.__index__ < 0 || shift < this.__index__ ||
            (shift === this.__index__ && next > this.__last_index__)) {
          this.__schema__     = 'mailto:';
          this.__index__      = shift;
          this.__last_index__ = next;
        }
      }
    }
  }

  return this.__index__ >= 0;
};


/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/
LinkifyIt.prototype.pretest = function pretest(text) {
  return this.re.pretest.test(text);
};


/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/
LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
  // If not supported schema check requested - terminate
  if (!this.__compiled__[schema.toLowerCase()]) {
    return 0;
  }
  return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};


/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/
LinkifyIt.prototype.match = function match(text) {
  var shift = 0, result = [];

  // Try to take previous element from cache, if .test() called before
  if (this.__index__ >= 0 && this.__text_cache__ === text) {
    result.push(createMatch(this, shift));
    shift = this.__last_index__;
  }

  // Cut head if cache was used
  var tail = shift ? text.slice(shift) : text;

  // Scan string until end reached
  while (this.test(tail)) {
    result.push(createMatch(this, shift));

    tail = tail.slice(this.__last_index__);
    shift += this.__last_index__;
  }

  if (result.length) {
    return result;
  }

  return null;
};


/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/
LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
  list = Array.isArray(list) ? list : [ list ];

  if (!keepOld) {
    this.__tlds__ = list.slice();
    this.__tlds_replaced__ = true;
    compile(this);
    return this;
  }

  this.__tlds__ = this.__tlds__.concat(list)
                                  .sort()
                                  .filter(function (el, idx, arr) {
                                    return el !== arr[idx - 1];
                                  })
                                  .reverse();

  compile(this);
  return this;
};

/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/
LinkifyIt.prototype.normalize = function normalize(match) {

  // Do minimal possible changes by default. Need to collect feedback prior
  // to move forward https://github.com/markdown-it/linkify-it/issues/1

  if (!match.schema) { match.url = 'http://' + match.url; }

  if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) {
    match.url = 'mailto:' + match.url;
  }
};


/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/
LinkifyIt.prototype.onCompile = function onCompile() {
};


module.exports = LinkifyIt;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(193)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_DAY = 86400000

/**
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 */
function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {
  var startOfDayLeft = startOfDay(dirtyDateLeft)
  var startOfDayRight = startOfDay(dirtyDateRight)

  var timestampLeft = startOfDayLeft.getTime() -
    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfDayRight.getTime() -
    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
}

module.exports = differenceInCalendarDays


/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(156);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["w"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_table__ = __webpack_require__(1726);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_1__shared_table__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_1__shared_table__["d"]; });
/* unused harmony reexport tableMarginBottom */
/* unused harmony reexport tableMarginSides */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_1__shared_table__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_1__shared_table__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__shared_table__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_column_layout__ = __webpack_require__(1727);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_2__shared_column_layout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_media_single__ = __webpack_require__(1728);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_3__shared_media_single__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_blockquote__ = __webpack_require__(1729);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_4__shared_blockquote__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_headings__ = __webpack_require__(1730);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_5__shared_headings__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_panel__ = __webpack_require__(642);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_6__shared_panel__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_rule__ = __webpack_require__(1731);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_7__shared_rule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_paragraph__ = __webpack_require__(1732);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_8__shared_paragraph__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_link__ = __webpack_require__(1733);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_9__shared_link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_indentation__ = __webpack_require__(1734);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_10__shared_indentation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_block_marks__ = __webpack_require__(1735);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_11__shared_block_marks__["a"]; });












//# sourceMappingURL=index.js.map

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Theme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);


var gridSizeValue = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])();
var AVATAR_SIZES = {
  xsmall: gridSizeValue * 2,
  small: gridSizeValue * 3,
  medium: gridSizeValue * 4,
  large: gridSizeValue * 5,
  xlarge: gridSizeValue * 12,
  xxlarge: gridSizeValue * 16
}; // border radius only applies to "square" avatars

var AVATAR_RADIUS = {
  xsmall: 2,
  small: 2,
  medium: 3,
  large: 3,
  xlarge: 6,
  xxlarge: 12
};
var BORDER_WIDTH = {
  xsmall: 2,
  small: 2,
  medium: 2,
  large: 2,
  xlarge: 2,
  xxlarge: 2
};
var ICON_SIZES = {
  xsmall: 0,
  small: 12,
  medium: 14,
  large: 15,
  xlarge: 18,
  xxlarge: 0
};
var ICON_OFFSET = {
  xsmall: 0,
  small: 0,
  medium: 0,
  large: 1,
  xlarge: 7,
  xxlarge: 0
};
var SQUARE_ICON_OFFSET = {
  xsmall: 0,
  small: 0,
  medium: 0,
  large: 0,
  xlarge: 1,
  xxlarge: 0
};

function getBackgroundColor(props) {
  var backgroundColors = {
    light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N40,
    dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN50
  };
  return props.isLoading ? backgroundColors[props.mode] : 'transparent';
}

function getBorderRadius(props) {
  var borderWidth = props.includeBorderWidth ? BORDER_WIDTH[props.size] : 0;
  var borderRadius = props.appearance === 'circle' ? '50%' : "".concat(AVATAR_RADIUS[props.size] + borderWidth, "px");
  return borderRadius;
}

function getDimensions(props) {
  var borderWidth = props.includeBorderWidth ? BORDER_WIDTH[props.size] * 2 : 0;
  var size = AVATAR_SIZES[props.size] + borderWidth;
  var width = "".concat(size, "px");
  var height = width;
  return {
    height: height,
    width: width
  };
}

var getPresenceLayout = function getPresenceLayout(props) {
  var presencePosition = props.appearance === 'square' ? -(BORDER_WIDTH[props.size] * 2) : ICON_OFFSET[props.size];
  var presenceSize = ICON_SIZES[props.size];
  return {
    bottom: "".concat(presencePosition, "px"),
    height: "".concat(presenceSize, "px"),
    right: "".concat(presencePosition, "px"),
    width: "".concat(presenceSize, "px")
  };
};

var getStatusLayout = function getStatusLayout(props) {
  var statusPosition = props.appearance === 'square' ? SQUARE_ICON_OFFSET[props.size] : ICON_OFFSET[props.size];
  var statusSize = ICON_SIZES[props.size];
  return {
    height: "".concat(statusSize, "px"),
    right: "".concat(statusPosition, "px"),
    top: "".concat(statusPosition, "px"),
    width: "".concat(statusSize, "px")
  };
};

var propsDefaults = {
  appearance: 'circle',
  includeBorderWidth: false,
  isLoading: false,
  mode: 'light',
  presence: 'offline',
  size: 'xsmall'
};
var Theme = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["createTheme"])(function (props) {
  var propsWithDefaults = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, propsDefaults, props);

  return {
    backgroundColor: getBackgroundColor(propsWithDefaults),
    borderRadius: getBorderRadius(propsWithDefaults),
    dimensions: getDimensions(propsWithDefaults),
    presence: getPresenceLayout(propsWithDefaults),
    status: getStatusLayout(propsWithDefaults)
  };
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = omit;
/* harmony export (immutable) */ __webpack_exports__["a"] = getDisplayName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);

function omit(obj) {
  var newObj = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, obj);

  for (var _len = arguments.length, keysToOmit = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keysToOmit[_key - 1] = arguments[_key];
  }

  for (var _i = 0; _i < keysToOmit.length; _i++) {
    var key = keysToOmit[_i];
    delete newObj[key];
  }

  return newObj;
}
function getDisplayName(prefix, Component) {
  var componentName = Component.displayName || Component.name;
  return componentName ? "".concat(prefix, "(").concat(componentName, ")") : prefix;
}

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SizeDetector__ = __webpack_require__(1999);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SizeDetector__["a"]; });


/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export validateVisitors */
/* harmony export (immutable) */ __webpack_exports__["a"] = traverse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

function validateVisitors(visitors) {
    return true;
}
function traverse(adf, visitors) {
    if (!validateVisitors(visitors)) {
        throw new Error("Visitors are not valid: \"" + Object.keys(visitors).join(', ') + "\"");
    }
    return traverseNode(adf, { node: undefined }, visitors);
}
function traverseNode(adfNode, parent, visitors) {
    var visitor = visitors[adfNode.type] || visitors['any'];
    var newNode = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, adfNode);
    if (visitor) {
        var processedNode = visitor(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, newNode), parent);
        if (processedNode === false) {
            return false;
        }
        newNode = processedNode || adfNode;
    }
    if (newNode.content) {
        newNode.content = newNode.content.reduce(function (acc, node) {
            var processedNode = traverseNode(node, { node: newNode, parent: parent }, visitors);
            if (processedNode !== false) {
                acc.push(processedNode);
            }
            return acc;
        }, []);
    }
    return newNode;
}
//# sourceMappingURL=traverse.js.map

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AnalyticsService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__handler__ = __webpack_require__(748);

/**
 * The service allows @analytics annotations to access the analytics Handler
 * from an arbitrary scope. This coupling assumes that there is only one analytics
 * Handler that should be used on the page across all components.
 */
var AnalyticsService = /** @class */ (function () {
    function AnalyticsService() {
        // trackEvent: analyticsHandler = (name: string, properties?: analyticsProperties) => {};
        this.trackEvent = Object(__WEBPACK_IMPORTED_MODULE_0__handler__["a" /* detectHandler */])();
    }
    Object.defineProperty(AnalyticsService.prototype, "handler", {
        set: function (handler) {
            this.trackEvent = handler ? handler : function () { };
        },
        enumerable: true,
        configurable: true
    });
    return AnalyticsService;
}());

/* harmony default export */ __webpack_exports__["a"] = (new AnalyticsService());
//# sourceMappingURL=service.js.map

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CollapsedFrame; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled__ = __webpack_require__(2149);



var CollapsedFrame = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CollapsedFrame, _super);
    function CollapsedFrame() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (event) {
            var onClick = _this.props.onClick;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick();
            }
        };
        // imitate a button for accessibility reasons
        _this.handleKeyPress = function (event) {
            if (event.key !== ' ' && event.key !== 'Enter') {
                return;
            }
            var onClick = _this.props.onClick;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick();
            }
        };
        return _this;
    }
    CollapsedFrame.prototype.render = function () {
        var _a = this.props, isSelected = _a.isSelected, minWidth = _a.minWidth, maxWidth = _a.maxWidth, children = _a.children, onClick = _a.onClick;
        var isInteractive = Boolean(onClick);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["a" /* Wrappper */], { minWidth: minWidth, maxWidth: maxWidth, isInteractive: isInteractive, isSelected: isSelected, tabIndex: isInteractive ? 0 : undefined, role: isInteractive ? 'button' : undefined, onClick: this.handleClick, onKeyPress: this.handleKeyPress }, children));
    };
    return CollapsedFrame;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return themeNamespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return compactSmallFontSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return compactLineHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return gridSize; });
/* unused harmony export defaultTheme */
/* unused harmony export themeWithKeys */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getThemeStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);

var themeNamespace = '@atlaskit-shared-theme/item'; // Used for Group titles and Item descriptions

var compactSmallFontSize = 10;
var compactLineHeight = 1.2;
var gridSize = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["gridSize"])();
var defaultTheme = {
  afterItemSpacing: {
    compact: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["gridSize"])(),
    default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["gridSize"])()
  },
  beforeItemSpacing: {
    compact: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["gridSize"])(),
    default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["gridSize"])()
  },
  borderRadius: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["borderRadius"])(),
  focus: {
    outline: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100
  },
  height: {
    compact: 0,
    default: 0
  },
  padding: {
    default: {
      bottom: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["gridSize"])() / 2,
      left: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["gridSize"])() / 2,
      right: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["gridSize"])() / 2,
      top: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["gridSize"])() / 2
    },
    compact: {
      bottom: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["gridSize"])(),
      left: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["gridSize"])(),
      right: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["gridSize"])(),
      top: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["gridSize"])()
    }
  },
  default: {
    background: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].background,
    text: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].text,
    secondaryText: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N200
  },
  selected: {
    background: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].backgroundActive,
    text: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N500,
    secondaryText: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N200
  },
  active: {
    background: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].backgroundActive,
    text: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].textActive,
    secondaryText: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N200
  },
  hover: {
    background: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].backgroundHover,
    text: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].textHover,
    secondaryText: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N200
  },
  disabled: {
    background: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0,
    text: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N200,
    secondaryText: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N200
  },
  // same as hover in this case
  dragging: {
    background: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20,
    text: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N800,
    secondaryText: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N200
  }
};

var isValidCssValue = function isValidCssValue(value) {
  return value !== undefined && value !== null && value !== '';
}; // Returns the theme that contains the requested theme key(s), preferring the user-supplied
// theme if it is provided.


var themeWithKeys = function themeWithKeys(maybeTheme, key, parentKey) {
  if (parentKey) {
    return maybeTheme && maybeTheme[parentKey] && isValidCssValue(maybeTheme[parentKey][key]) ? maybeTheme : defaultTheme;
  }

  return maybeTheme && isValidCssValue(maybeTheme[key]) ? maybeTheme : defaultTheme;
}; // Returns the theme value for the requested key(s), falling back to the default theme if the
// user-supplied theme doesn't exist or doesn't contain the requested key(s)

var getThemeStyle = function getThemeStyle(maybeTheme, key, parentKey) {
  var theme = themeWithKeys(maybeTheme, key, parentKey);
  return parentKey ? theme[parentKey][key] : theme[key];
};

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ImageType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SupportedImageMetaTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExifOrientation; });
var ImageType;
(function (ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
})(ImageType || (ImageType = {}));
var SupportedImageMetaTag;
(function (SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
})(SupportedImageMetaTag || (SupportedImageMetaTag = {}));
// http://sylvana.net/jpegcrop/exif_orientation.html
var ExifOrientation = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8,
};
//# sourceMappingURL=types.js.map

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorWarningIcon = function EditorWarningIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M13.31 5.343l7.359 13.17A1 1 0 0 1 19.796 20H4.204a1 1 0 0 1-.873-1.488l7.36-13.169a1.5 1.5 0 0 1 2.618 0zM12 8.5a1.091 1.091 0 0 0-1.081 1.239l.513 3.766a.573.573 0 0 0 1.136 0l.513-3.766A1.091 1.091 0 0 0 12 8.5zm0 8.63a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorWarningIcon.displayName = 'EditorWarningIcon';
var _default = EditorWarningIcon;
exports.default = _default;

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return keylineHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TitleText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TitleIconWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Body; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return styledBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Footer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Actions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_flex_max_height_ie_fix__ = __webpack_require__(786);



 // Constants
// ==============================

var innerGutter = 16;
var outerGutter = 20;
var keylineColor = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30,
  dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN30
});
var keylineHeight = 2; // Wrapper
// ==============================

var DefaultWrapperComponent = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div.withConfig({
  displayName: "Content__DefaultWrapperComponent",
  componentId: "sc-1npw367-0"
})(["\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  ", ";\n"], __WEBPACK_IMPORTED_MODULE_3__utils_flex_max_height_ie_fix__["b" /* flexMaxHeightIEFix */]);
var Wrapper = function Wrapper(_ref) {
  var component = _ref.component,
      children = _ref.children;
  var StyledComponent = DefaultWrapperComponent;

  if (component !== 'div') {
    // $FlowFixMe
    StyledComponent = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(component).withConfig({
      displayName: "Content__StyledComponent",
      componentId: "sc-1npw367-1"
    })(["\n      display: flex;\n      flex-direction: column;\n      flex: 1 1 auto;\n      ", ";\n    "], __WEBPACK_IMPORTED_MODULE_3__utils_flex_max_height_ie_fix__["b" /* flexMaxHeightIEFix */]);
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledComponent, null, children);
};
Wrapper.defaultProps = {
  component: 'div'
}; // Header
// ==============================

var HeaderOrFooter = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div.withConfig({
  displayName: "Content__HeaderOrFooter",
  componentId: "sc-1npw367-2"
})(["\n  align-items: center;\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: space-between;\n  transition: box-shadow 200ms;\n  z-index: 1;\n"]);
var Header = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(HeaderOrFooter).withConfig({
  displayName: "Content__Header",
  componentId: "sc-1npw367-3"
})(["\n  padding: ", "px ", "px ", "px;\n  box-shadow: ", ";\n"], outerGutter, outerGutter, innerGutter - keylineHeight, function (p) {
  return p.showKeyline ? " 0 ".concat(keylineHeight, "px 0 0 ").concat(keylineColor(p)) : 'none';
}); // Title

var oneLineTitleText = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"]);
var Title = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].h4.withConfig({
  displayName: "Content__Title",
  componentId: "sc-1npw367-4"
})(["\n  align-items: center;\n  display: flex;\n  font-size: 20px;\n  font-style: inherit;\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  line-height: 1;\n  margin: 0;\n  min-width: 0;\n"]);
var TitleText = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span.withConfig({
  displayName: "Content__TitleText",
  componentId: "sc-1npw367-5"
})(["\n  flex: 1 1 auto;\n  min-width: 0;\n  word-wrap: break-word;\n  width: 100%;\n  ", ";\n"], function (_ref2) {
  var isHeadingMultiline = _ref2.isHeadingMultiline;
  return !isHeadingMultiline && oneLineTitleText;
});
var iconColor = {
  danger: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R400,
  warning: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].Y400
};
var TitleIconWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span.withConfig({
  displayName: "Content__TitleIconWrapper",
  componentId: "sc-1npw367-6"
})(["\n  color: ", ";\n  margin-right: ", "px;\n  flex: 0 0 auto;\n"], function (p) {
  return iconColor[p.appearance];
}, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"]); // Body
// ==============================

/**
  Adding the padding here avoids cropping box shadow on first/last
  children. The combined vertical spacing is maintained by subtracting the
  keyline height from header and footer.
*/

var Body = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div.withConfig({
  displayName: "Content__Body",
  componentId: "sc-1npw367-7"
})(["\n  flex: 1 1 auto;\n  ", ";\n"], function (p) {
  return p.shouldScroll ? "\n          overflow-y: auto;\n          overflow-x: hidden;\n          padding: ".concat(keylineHeight, "px ").concat(outerGutter, "px;\n        ") : "\n          padding: 0 ".concat(outerGutter, "px;\n        ");
});
var styledBody = function styledBody(component) {
  return component ? // $FlowFixMe
  Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(component).withConfig({
    displayName: "Content",
    componentId: "sc-1npw367-8"
  })(["\n        flex: 1 1 auto;\n        ", ";\n      "], function (p) {
    return p.shouldScroll ? "\n            overflow-y: auto;\n            overflow-x: hidden;\n            padding: ".concat(keylineHeight, "px ").concat(outerGutter, "px;\n          ") : "\n            border-radius: 0px;\n            padding: 0 ".concat(outerGutter, "px;\n    ");
  }) : undefined;
}; // Footer
// ==============================

var Footer = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(HeaderOrFooter).withConfig({
  displayName: "Content__Footer",
  componentId: "sc-1npw367-9"
})(["\n  padding: ", "px ", "px ", "px;\n  box-shadow: ", ";\n"], innerGutter - keylineHeight, outerGutter, outerGutter, function (p) {
  return p.showKeyline ? "0 -".concat(keylineHeight, "px 0 0 ").concat(keylineColor(p)) : 'none';
});
var Actions = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div.withConfig({
  displayName: "Content__Actions",
  componentId: "sc-1npw367-10"
})(["\n  display: inline-flex;\n  margin: 0 -", "px;\n"], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 2));
var ActionItem = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div.withConfig({
  displayName: "Content__ActionItem",
  componentId: "sc-1npw367-11"
})(["\n  flex: 1 0 auto;\n  margin: 0 ", "px;\n"], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 2));

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS_GROUP", function() { return FOCUS_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS_DISABLED", function() { return FOCUS_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS_ALLOW", function() { return FOCUS_ALLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS_AUTO", function() { return FOCUS_AUTO; });
var FOCUS_GROUP = 'data-focus-lock';
var FOCUS_DISABLED = 'data-focus-lock-disabled';
var FOCUS_ALLOW = 'data-no-focus-lock';
var FOCUS_AUTO = 'data-autofocus-inside';

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = deferAction;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return inlineProp; });
function deferAction(action) {
  // Hidding setImmediate from Webpack to avoid inserting polyfill
  var setImmediate = window.setImmediate;

  if (typeof setImmediate !== 'undefined') {
    setImmediate(action);
  } else {
    setTimeout(action, 1);
  }
}
var inlineProp = function inlineProp(name, value) {
  var obj = {};
  obj[name] = value;
  return obj;
};

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isMarkAllowedInRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isMarkExcluded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeBlockMarks; });
/* harmony export (immutable) */ __webpack_exports__["d"] = removeQueryMarksFromJSON;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_utils__ = __webpack_require__(735);


var isMarkAllowedInRange = function (doc, ranges, type) {
    var _loop_1 = function (i) {
        var _a = ranges[i], $from = _a.$from, $to = _a.$to;
        var can = $from.depth === 0 ? doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, function (node) {
            if (can) {
                return false;
            }
            can = node.inlineContent && node.type.allowsMarkType(type);
        });
        if (can) {
            return { value: can };
        }
    };
    for (var i = 0; i < ranges.length; i++) {
        var state_1 = _loop_1(i);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return false;
};
var isMarkExcluded = function (type, marks) {
    if (marks) {
        return marks.some(function (mark) { return mark.type !== type && mark.type.excludes(type); });
    }
    return false;
};
var not = function (fn) { return function (arg) { return !fn(arg); }; };
var removeBlockMarks = function (state, marks) {
    var selection = state.selection, schema = state.schema;
    var tr = state.tr;
    // Marks might not exist in Schema
    var marksToRemove = marks.filter(Boolean);
    if (marksToRemove.length === 0) {
        return undefined;
    }
    /** Saves an extra dispatch */
    var blockMarksExists = false;
    var hasMark = function (mark) { return marksToRemove.indexOf(mark.type) > -1; };
    /**
     * When you need to toggle the selection
     * when another type which does not allow alignment is applied
     */
    state.doc.nodesBetween(selection.from, selection.to, function (node, pos) {
        if (node.type === schema.nodes.paragraph && node.marks.some(hasMark)) {
            blockMarksExists = true;
            var resolvedPos = state.doc.resolve(pos);
            var withoutBlockMarks = node.marks.filter(not(hasMark));
            tr = tr.setNodeMarkup(resolvedPos.pos, undefined, node.attrs, withoutBlockMarks);
        }
    });
    return blockMarksExists ? tr : undefined;
};
function removeQueryMarksFromJSON(json) {
    var sanitizedJSON = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_utils__["a" /* traverse */])(json, {
        text: function (node) {
            if (!node || !Array.isArray(node.marks)) {
                return node;
            }
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, node, { marks: node.marks.filter(function (mark) { return ['emojiQuery', 'typeAheadQuery'].indexOf(mark.type) === -1; }) });
        },
    });
    return sanitizedJSON;
}
//# sourceMappingURL=mark.js.map

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var RopeSequence = _interopDefault(__webpack_require__(2358));
var prosemirrorTransform = __webpack_require__(46);
var prosemirrorState = __webpack_require__(11);

// ProseMirror's history isn't simply a way to roll back to a previous
// state, because ProseMirror supports applying changes without adding
// them to the history (for example during collaboration).
//
// To this end, each 'Branch' (one for the undo history and one for
// the redo history) keeps an array of 'Items', which can optionally
// hold a step (an actual undoable change), and always hold a position
// map (which is needed to move changes below them to apply to the
// current document).
//
// An item that has both a step and a selection bookmark is the start
// of an 'event' — a group of changes that will be undone or redone at
// once. (It stores only the bookmark, since that way we don't have to
// provide a document until the selection is actually applied, which
// is useful when compressing.)

// Used to schedule history compression
var max_empty_items = 500;

var Branch = function Branch(items, eventCount) {
  this.items = items;
  this.eventCount = eventCount;
};

// : (EditorState, bool) → ?{transform: Transform, selection: ?SelectionBookmark, remaining: Branch}
// Pop the latest event off the branch's history and apply it
// to a document transform.
Branch.prototype.popEvent = function popEvent (state, preserveItems) {
    var this$1 = this;

  if (this.eventCount == 0) { return null }

  var end = this.items.length;
  for (;; end--) {
    var next = this$1.items.get(end - 1);
    if (next.selection) { --end; break }
  }

  var remap, mapFrom;
  if (preserveItems) {
    remap = this.remapping(end, this.items.length);
    mapFrom = remap.maps.length;
  }
  var transform = state.tr;
  var selection, remaining;
  var addAfter = [], addBefore = [];

  this.items.forEach(function (item, i) {
    if (!item.step) {
      if (!remap) {
        remap = this$1.remapping(end, i + 1);
        mapFrom = remap.maps.length;
      }
      mapFrom--;
      addBefore.push(item);
      return
    }

    if (remap) {
      addBefore.push(new Item(item.map));
      var step = item.step.map(remap.slice(mapFrom)), map;

      if (step && transform.maybeStep(step).doc) {
        map = transform.mapping.maps[transform.mapping.maps.length - 1];
        addAfter.push(new Item(map, null, null, addAfter.length + addBefore.length));
      }
      mapFrom--;
      if (map) { remap.appendMap(map, mapFrom); }
    } else {
      transform.maybeStep(item.step);
    }

    if (item.selection) {
      selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
      remaining = new Branch(this$1.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this$1.eventCount - 1);
      return false
    }
  }, this.items.length, 0);

  return {remaining: remaining, transform: transform, selection: selection}
};

// : (Transform, ?SelectionBookmark, Object) → Branch
// Create a new branch with the given transform added.
Branch.prototype.addTransform = function addTransform (transform, selection, histOptions, preserveItems) {
  var newItems = [], eventCount = this.eventCount;
  var oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;

  for (var i = 0; i < transform.steps.length; i++) {
    var step = transform.steps[i].invert(transform.docs[i]);
    var item = new Item(transform.mapping.maps[i], step, selection), merged = (void 0);
    if (merged = lastItem && lastItem.merge(item)) {
      item = merged;
      if (i) { newItems.pop(); }
      else { oldItems = oldItems.slice(0, oldItems.length - 1); }
    }
    newItems.push(item);
    if (selection) {
      eventCount++;
      selection = null;
    }
    if (!preserveItems) { lastItem = item; }
  }
  var overflow = eventCount - histOptions.depth;
  if (overflow > DEPTH_OVERFLOW) {
    oldItems = cutOffEvents(oldItems, overflow);
    eventCount -= overflow;
  }
  return new Branch(oldItems.append(newItems), eventCount)
};

Branch.prototype.remapping = function remapping (from, to) {
  var maps = new prosemirrorTransform.Mapping;
  this.items.forEach(function (item, i) {
    var mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from
        ? mirrorPos = maps.maps.length - item.mirrorOffset : null;
    maps.appendMap(item.map, mirrorPos);
  }, from, to);
  return maps
};

Branch.prototype.addMaps = function addMaps (array) {
  if (this.eventCount == 0) { return this }
  return new Branch(this.items.append(array.map(function (map) { return new Item(map); })), this.eventCount)
};

// : (Transform, number)
// When the collab module receives remote changes, the history has
// to know about those, so that it can adjust the steps that were
// rebased on top of the remote changes, and include the position
// maps for the remote changes in its array of items.
Branch.prototype.rebased = function rebased (rebasedTransform, rebasedCount) {
  if (!this.eventCount) { return this }

  var rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);

  var mapping = rebasedTransform.mapping;
  var newUntil = rebasedTransform.steps.length;
  var eventCount = this.eventCount;
  this.items.forEach(function (item) { if (item.selection) { eventCount--; } }, start);

  var iRebased = rebasedCount;
  this.items.forEach(function (item) {
    var pos = mapping.getMirror(--iRebased);
    if (pos == null) { return }
    newUntil = Math.min(newUntil, pos);
    var map = mapping.maps[pos];
    if (item.step) {
      var step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
      var selection = item.selection && item.selection.map(mapping.slice(iRebased, pos));
      if (selection) { eventCount++; }
      rebasedItems.push(new Item(map, step, selection));
    } else {
      rebasedItems.push(new Item(map));
    }
  }, start);

  var newMaps = [];
  for (var i = rebasedCount; i < newUntil; i++)
    { newMaps.push(new Item(mapping.maps[i])); }
  var items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
  var branch = new Branch(items, eventCount);

  if (branch.emptyItemCount() > max_empty_items)
    { branch = branch.compress(this.items.length - rebasedItems.length); }
  return branch
};

Branch.prototype.emptyItemCount = function emptyItemCount () {
  var count = 0;
  this.items.forEach(function (item) { if (!item.step) { count++; } });
  return count
};

// Compressing a branch means rewriting it to push the air (map-only
// items) out. During collaboration, these naturally accumulate
// because each remote change adds one. The `upto` argument is used
// to ensure that only the items below a given level are compressed,
// because `rebased` relies on a clean, untouched set of items in
// order to associate old items with rebased steps.
Branch.prototype.compress = function compress (upto) {
    if ( upto === void 0 ) upto = this.items.length;

  var remap = this.remapping(0, upto), mapFrom = remap.maps.length;
  var items = [], events = 0;
  this.items.forEach(function (item, i) {
    if (i >= upto) {
      items.push(item);
      if (item.selection) { events++; }
    } else if (item.step) {
      var step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
      mapFrom--;
      if (map) { remap.appendMap(map, mapFrom); }
      if (step) {
        var selection = item.selection && item.selection.map(remap.slice(mapFrom));
        if (selection) { events++; }
        var newItem = new Item(map.invert(), step, selection), merged, last = items.length - 1;
        if (merged = items.length && items[last].merge(newItem))
          { items[last] = merged; }
        else
          { items.push(newItem); }
      }
    } else if (item.map) {
      mapFrom--;
    }
  }, this.items.length, 0);
  return new Branch(RopeSequence.from(items.reverse()), events)
};

Branch.empty = new Branch(RopeSequence.empty, 0);

function cutOffEvents(items, n) {
  var cutPoint;
  items.forEach(function (item, i) {
    if (item.selection && (n-- == 0)) {
      cutPoint = i;
      return false
    }
  });
  return items.slice(cutPoint)
}

var Item = function Item(map, step, selection, mirrorOffset) {
  this.map = map;
  this.step = step;
  this.selection = selection;
  this.mirrorOffset = mirrorOffset;
};

Item.prototype.merge = function merge (other) {
  if (this.step && other.step && !other.selection) {
    var step = other.step.merge(this.step);
    if (step) { return new Item(step.getMap().invert(), step, this.selection) }
  }
};

// The value of the state field that tracks undo/redo history for that
// state. Will be stored in the plugin state when the history plugin
// is active.
var HistoryState = function HistoryState(done, undone, prevRanges, prevTime) {
  this.done = done;
  this.undone = undone;
  this.prevRanges = prevRanges;
  this.prevTime = prevTime;
};

var DEPTH_OVERFLOW = 20;

// : (HistoryState, EditorState, Transaction, Object)
// Record a transformation in undo history.
function applyTransaction(history, state, tr, options) {
  var historyTr = tr.getMeta(historyKey), rebased;
  if (historyTr) { return historyTr.historyState }

  if (tr.getMeta(closeHistoryKey)) { history = new HistoryState(history.done, history.undone, null, 0); }

  var appended = tr.getMeta("appendedTransaction");

  if (tr.steps.length == 0) {
    return history
  } else if (appended && appended.getMeta(historyKey)) {
    if (appended.getMeta(historyKey).redo)
      { return new HistoryState(history.done.addTransform(tr, null, options, mustPreserveItems(state)),
                              history.undone, rangesFor(tr.mapping.maps[tr.steps.length - 1]), history.prevTime) }
    else
      { return new HistoryState(history.done, history.undone.addTransform(tr, null, options, mustPreserveItems(state)),
                              null, history.prevTime) }
  } else if (tr.getMeta("addToHistory") !== false && !(appended && appended.getMeta("addToHistory") === false)) {
    // Group transforms that occur in quick succession into one event.
    var newGroup = history.prevTime < (tr.time || 0) - options.newGroupDelay ||
        !appended && !isAdjacentTo(tr, history.prevRanges);
    var prevRanges = appended ? mapRanges(history.prevRanges, tr.mapping) : rangesFor(tr.mapping.maps[tr.steps.length - 1]);
    return new HistoryState(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : null,
                                                      options, mustPreserveItems(state)),
                            Branch.empty, prevRanges, tr.time)
  } else if (rebased = tr.getMeta("rebased")) {
    // Used by the collab module to tell the history that some of its
    // content has been rebased.
    return new HistoryState(history.done.rebased(tr, rebased),
                            history.undone.rebased(tr, rebased),
                            mapRanges(history.prevRanges, tr.mapping), history.prevTime)
  } else {
    return new HistoryState(history.done.addMaps(tr.mapping.maps),
                            history.undone.addMaps(tr.mapping.maps),
                            mapRanges(history.prevRanges, tr.mapping), history.prevTime)
  }
}

function isAdjacentTo(transform, prevRanges) {
  if (!prevRanges) { return false }
  if (!transform.docChanged) { return true }
  var adjacent = false;
  transform.mapping.maps[0].forEach(function (start, end) {
    for (var i = 0; i < prevRanges.length; i += 2)
      { if (start <= prevRanges[i + 1] && end >= prevRanges[i])
        { adjacent = true; } }
  });
  return adjacent
}

function rangesFor(map) {
  var result = [];
  map.forEach(function (_from, _to, from, to) { return result.push(from, to); });
  return result
}

function mapRanges(ranges, mapping) {
  if (!ranges) { return null }
  var result = [];
  for (var i = 0; i < ranges.length; i += 2) {
    var from = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
    if (from <= to) { result.push(from, to); }
  }
  return result
}

// : (HistoryState, EditorState, (tr: Transaction), bool)
// Apply the latest event from one branch to the document and shift the event
// onto the other branch.
function histTransaction(history, state, dispatch, redo) {
  var preserveItems = mustPreserveItems(state), histOptions = historyKey.get(state).spec.config;
  var pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
  if (!pop) { return }

  var selection = pop.selection.resolve(pop.transform.doc);
  var added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(),
                                                                  histOptions, preserveItems);

  var newHist = new HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0);
  dispatch(pop.transform.setSelection(selection).setMeta(historyKey, {redo: redo, historyState: newHist}).scrollIntoView());
}

var cachedPreserveItems = false;
var cachedPreserveItemsPlugins = null;
// Check whether any plugin in the given state has a
// `historyPreserveItems` property in its spec, in which case we must
// preserve steps exactly as they came in, so that they can be
// rebased.
function mustPreserveItems(state) {
  var plugins = state.plugins;
  if (cachedPreserveItemsPlugins != plugins) {
    cachedPreserveItems = false;
    cachedPreserveItemsPlugins = plugins;
    for (var i = 0; i < plugins.length; i++) { if (plugins[i].spec.historyPreserveItems) {
      cachedPreserveItems = true;
      break
    } }
  }
  return cachedPreserveItems
}

// :: (Transaction) → Transaction
// Set a flag on the given transaction that will prevent further steps
// from being appended to an existing history event (so that they
// require a separate undo command to undo).
function closeHistory(tr) {
  return tr.setMeta(closeHistoryKey, true)
}

var historyKey = new prosemirrorState.PluginKey("history");
var closeHistoryKey = new prosemirrorState.PluginKey("closeHistory");

// :: (?Object) → Plugin
// Returns a plugin that enables the undo history for an editor. The
// plugin will track undo and redo stacks, which can be used with the
// [`undo`](#history.undo) and [`redo`](#history.redo) commands.
//
// You can set an `"addToHistory"` [metadata
// property](#state.Transaction.setMeta) of `false` on a transaction
// to prevent it from being rolled back by undo.
//
//   config::-
//   Supports the following configuration options:
//
//     depth:: ?number
//     The amount of history events that are collected before the
//     oldest events are discarded. Defaults to 100.
//
//     newGroupDelay:: ?number
//     The delay between changes after which a new group should be
//     started. Defaults to 500 (milliseconds). Note that when changes
//     aren't adjacent, a new group is always started.
function history(config) {
  config = {depth: config && config.depth || 100,
            newGroupDelay: config && config.newGroupDelay || 500};
  return new prosemirrorState.Plugin({
    key: historyKey,

    state: {
      init: function init() {
        return new HistoryState(Branch.empty, Branch.empty, null, 0)
      },
      apply: function apply(tr, hist, state) {
        return applyTransaction(hist, state, tr, config)
      }
    },

    config: config
  })
}

// :: (EditorState, ?(tr: Transaction)) → bool
// A command function that undoes the last change, if any.
function undo(state, dispatch) {
  var hist = historyKey.getState(state);
  if (!hist || hist.done.eventCount == 0) { return false }
  if (dispatch) { histTransaction(hist, state, dispatch, false); }
  return true
}

// :: (EditorState, ?(tr: Transaction)) → bool
// A command function that redoes the last undone change, if any.
function redo(state, dispatch) {
  var hist = historyKey.getState(state);
  if (!hist || hist.undone.eventCount == 0) { return false }
  if (dispatch) { histTransaction(hist, state, dispatch, true); }
  return true
}

// :: (EditorState) → number
// The amount of undoable events available in a given state.
function undoDepth(state) {
  var hist = historyKey.getState(state);
  return hist ? hist.done.eventCount : 0
}

// :: (EditorState) → number
// The amount of redoable events available in a given editor state.
function redoDepth(state) {
  var hist = historyKey.getState(state);
  return hist ? hist.undone.eventCount : 0
}

exports.HistoryState = HistoryState;
exports.closeHistory = closeHistory;
exports.history = history;
exports.undo = undo;
exports.redo = redo;
exports.undoDepth = undoDepth;
exports.redoDepth = redoDepth;
//# sourceMappingURL=history.js.map


/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__block_type__ = __webpack_require__(2363);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__block_type__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__block_type__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__block_type__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__insert_block__ = __webpack_require__(801);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transform_to_code_block__ = __webpack_require__(802);
/* unused harmony namespace reexport */



//# sourceMappingURL=index.js.map

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSupportedNodeForBreakout;
var supportedNodesForBreakout = ['codeBlock', 'layoutSection'];
function isSupportedNodeForBreakout(node) {
    return supportedNodesForBreakout.indexOf(node.type.name) !== -1;
}
//# sourceMappingURL=is-supported-node.js.map

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isEmptySelectionAtStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isFirstChildOfParent; });
/* unused harmony export isNthParentOfType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return findCutBefore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_gap_cursor__ = __webpack_require__(213);

var filter = function (predicates, cmd) {
    return function (state, dispatch, view) {
        if (!Array.isArray(predicates)) {
            predicates = [predicates];
        }
        if (predicates.some(function (pred) { return !pred(state, view); })) {
            return false;
        }
        return cmd(state, dispatch, view) || false;
    };
};
var isEmptySelectionAtStart = function (state, view) {
    var _a = state.selection, empty = _a.empty, $from = _a.$from;
    return (empty &&
        ($from.parentOffset === 0 || state.selection instanceof __WEBPACK_IMPORTED_MODULE_0__plugins_gap_cursor__["a" /* GapCursorSelection */]));
};
var isFirstChildOfParent = function (state, view) {
    var $from = state.selection.$from;
    return $from.depth > 1
        ? (state.selection instanceof __WEBPACK_IMPORTED_MODULE_0__plugins_gap_cursor__["a" /* GapCursorSelection */] &&
            $from.parentOffset === 0) ||
            $from.index($from.depth - 1) === 0
        : true;
};
/**
 * Creates a filter that checks if the node at a given number of parents above the current
 * selection is of the correct node type.
 * @param nodeType The node type to compare the nth parent against
 * @param depthAway How many levels above the current node to check against. 0 refers to
 * the current selection's parent, which will be the containing node when the selection
 * is usually inside the text content.
 */
var isNthParentOfType = function (nodeType, depthAway) {
    return function (state) {
        var $from = state.selection.$from;
        var parent = $from.node($from.depth - depthAway);
        return !!parent && parent.type === state.schema.nodes[nodeType];
    };
};
// https://github.com/ProseMirror/prosemirror-commands/blob/master/src/commands.js#L90
// Keep going left up the tree, without going across isolating boundaries, until we
// can go along the tree at that same level
//
// You can think of this as, if you could construct each document like we do in the tests,
// return the position of the first ) backwards from the current selection.
function findCutBefore($pos) {
    // parent is non-isolating, so we can look across this boundary
    if (!$pos.parent.type.spec.isolating) {
        // search up the tree from the pos's *parent*
        for (var i = $pos.depth - 1; i >= 0; i--) {
            // starting from the inner most node's parent, find out
            // if we're not its first child
            if ($pos.index(i) > 0) {
                return $pos.doc.resolve($pos.before(i + 1));
            }
            if ($pos.node(i).type.spec.isolating) {
                break;
            }
        }
    }
    return null;
}

//# sourceMappingURL=commands.js.map

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorState = __webpack_require__(11);

var Rebaseable = function Rebaseable(step, inverted, origin) {
  this.step = step;
  this.inverted = inverted;
  this.origin = origin;
};

// : ([Rebaseable], [Step], Transform) → [Rebaseable]
// Undo a given set of steps, apply a set of other steps, and then
// redo them.
function rebaseSteps(steps, over, transform) {
  for (var i = steps.length - 1; i >= 0; i--) { transform.step(steps[i].inverted); }
  for (var i$1 = 0; i$1 < over.length; i$1++) { transform.step(over[i$1]); }
  var result = [];
  for (var i$2 = 0, mapFrom = steps.length; i$2 < steps.length; i$2++) {
    var mapped = steps[i$2].step.map(transform.mapping.slice(mapFrom));
    mapFrom--;
    if (mapped && !transform.maybeStep(mapped).failed) {
      transform.mapping.setMirror(mapFrom, transform.steps.length - 1);
      result.push(new Rebaseable(mapped, mapped.invert(transform.docs[transform.docs.length - 1]), steps[i$2].origin));
    }
  }
  return result
}

// This state field accumulates changes that have to be sent to the
// central authority in the collaborating group and makes it possible
// to integrate changes made by peers into our local document. It is
// defined by the plugin, and will be available as the `collab` field
// in the resulting editor state.
var CollabState = function CollabState(version, unconfirmed) {
  // : number
  // The version number of the last update received from the central
  // authority. Starts at 0 or the value of the `version` property
  // in the option object, for the editor's value when the option
  // was enabled.
  this.version = version;

  // : [Rebaseable]
  // The local steps that havent been successfully sent to the
  // server yet.
  this.unconfirmed = unconfirmed;
};

function unconfirmedFrom(transform) {
  var result = [];
  for (var i = 0; i < transform.steps.length; i++)
    { result.push(new Rebaseable(transform.steps[i],
                               transform.steps[i].invert(transform.docs[i]),
                               transform)); }
  return result
}

var collabKey = new prosemirrorState.PluginKey("collab");

// :: (?Object) → Plugin
//
// Creates a plugin that enables the collaborative editing framework
// for the editor.
//
//   config::- An optional set of options
//
//     version:: ?number
//     The starting version number of the collaborative editing.
//     Defaults to 0.
//
//     clientID:: ?union<number, string>
//     This client's ID, used to distinguish its changes from those of
//     other clients. Defaults to a random 32-bit number.
function collab(config) {
  if ( config === void 0 ) config = {};

  config = {version: config.version || 0,
            clientID: config.clientID == null ? Math.floor(Math.random() * 0xFFFFFFFF) : config.clientID};

  return new prosemirrorState.Plugin({
    key: collabKey,

    state: {
      init: function () { return new CollabState(config.version, []); },
      apply: function apply(tr, collab) {
        var newState = tr.getMeta(collabKey);
        if (newState)
          { return newState }
        if (tr.docChanged)
          { return new CollabState(collab.version, collab.unconfirmed.concat(unconfirmedFrom(tr))) }
        return collab
      }
    },

    config: config,
    // This is used to notify the history plugin to not merge steps,
    // so that the history can be rebased.
    historyPreserveItems: true
  })
}

// :: (state: EditorState, steps: [Step], clientIDs: [union<number, string>], options: ?Object) → Transaction
// Create a transaction that represents a set of new steps received from
// the authority. Applying this transaction moves the state forward to
// adjust to the authority's view of the document.
//
//   options::- Additional options.
//
//     mapSelectionBackward:: ?boolean
//     When enabled (the default is `false`), if the current selection
//     is a [text selection](#state.TextSelection), its sides are
//     mapped with a negative bias for this transaction, so that
//     content inserted at the cursor ends up after the cursor. Users
//     usually prefer this, but it isn't done by default for reasons
//     of backwards compatibility.
function receiveTransaction(state, steps, clientIDs, options) {
  // Pushes a set of steps (received from the central authority) into
  // the editor state (which should have the collab plugin enabled).
  // Will recognize its own changes, and confirm unconfirmed steps as
  // appropriate. Remaining unconfirmed steps will be rebased over
  // remote steps.
  var collabState = collabKey.getState(state);
  var version = collabState.version + steps.length;
  var ourID = collabKey.get(state).spec.config.clientID;

  // Find out which prefix of the steps originated with us
  var ours = 0;
  while (ours < clientIDs.length && clientIDs[ours] == ourID) { ++ours; }
  var unconfirmed = collabState.unconfirmed.slice(ours);
  steps = ours ? steps.slice(ours) : steps;

  // If all steps originated with us, we're done.
  if (!steps.length)
    { return state.tr.setMeta(collabKey, new CollabState(version, unconfirmed)) }

  var nUnconfirmed = unconfirmed.length;
  var tr = state.tr;
  if (nUnconfirmed) {
    unconfirmed = rebaseSteps(unconfirmed, steps, tr);
  } else {
    for (var i = 0; i < steps.length; i++) { tr.step(steps[i]); }
    unconfirmed = [];
  }

  var newCollabState = new CollabState(version, unconfirmed);
  if (options && options.mapSelectionBackward && state.selection instanceof prosemirrorState.TextSelection) {
    tr.setSelection(prosemirrorState.TextSelection.between(tr.doc.resolve(tr.mapping.map(state.selection.head, -1)),
                                          tr.doc.resolve(tr.mapping.map(state.selection.anchor, -1)), -1));
    tr.updated &= ~1;
  }
  return tr.setMeta("rebased", nUnconfirmed).setMeta("addToHistory", false).setMeta(collabKey, newCollabState)
}

// :: (state: EditorState) → ?{version: number, steps: [Step], clientID: union<number, string>, origins: [Transaction]}
// Provides data describing the editor's unconfirmed steps, which need
// to be sent to the central authority. Returns null when there is
// nothing to send.
//
// `origins` holds the _original_ transactions that produced each
// steps. This can be useful for looking up time stamps and other
// metadata for the steps, but note that the steps may have been
// rebased, whereas the origin transactions are still the old,
// unchanged objects.
function sendableSteps(state) {
  var collabState = collabKey.getState(state);
  if (collabState.unconfirmed.length == 0) { return null }
  return {
    version: collabState.version,
    steps: collabState.unconfirmed.map(function (s) { return s.step; }),
    clientID: collabKey.get(state).spec.config.clientID,
    get origins() { return this._origins || (this._origins = collabState.unconfirmed.map(function (s) { return s.origin; })) }
  }
}

// :: (EditorState) → number
// Get the version up to which the collab plugin has synced with the
// central authority.
function getVersion(state) {
  return collabKey.getState(state).version
}

exports.rebaseSteps = rebaseSteps;
exports.collab = collab;
exports.receiveTransaction = receiveTransaction;
exports.sendableSteps = sendableSteps;
exports.getVersion = getVersion;
//# sourceMappingURL=collab.js.map


/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return colors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAvatarColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return findPointers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createTelepointers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return replaceDocument; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_view__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);




var R400 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R400, Y400 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].Y400, G400 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].G400, B400 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B400, T400 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].T400, P400 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].P400, N800 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N800;
var colors = [R400, Y400, G400, T400, B400, P400, N800].map(function (solid) { return ({
    solid: solid,
    selection: Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["R" /* hexToRgba */])(solid, 0.2),
}); });
// tslint:disable:no-bitwise
var getAvatarColor = function (str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
        hash = (hash << 5) - hash + str.charCodeAt(i);
        hash = hash & hash;
    }
    var index = Math.abs(hash) % colors.length;
    return { index: index, color: colors[index] };
};
// tslint:enable:no-bitwise
var findPointers = function (id, decorations) {
    return decorations
        .find()
        .reduce(function (arr, deco) {
        return deco.spec.pointer.sessionId === id ? arr.concat(deco) : arr;
    }, []);
};
function style(options) {
    var color = (options && options.color) || 'black';
    return "border-left: 1px solid " + color + "; border-right: 1px solid " + color + "; margin-right: -2px;";
}
var createTelepointers = function (from, to, sessionId, isSelection, initial) {
    var decorations = [];
    var avatarColor = getAvatarColor(sessionId);
    var color = avatarColor.index.toString();
    if (isSelection) {
        var className = "telepointer color-" + color + " telepointer-selection";
        decorations.push(__WEBPACK_IMPORTED_MODULE_1_prosemirror_view__["Decoration"].inline(from, to, { class: className, 'data-initial': initial }, { pointer: { sessionId: sessionId } }));
    }
    var cursor = document.createElement('span');
    cursor.textContent = '\u200b';
    cursor.className = "telepointer color-" + color + " telepointer-selection-badge";
    cursor.style.cssText = style({ color: avatarColor.color.solid }) + ";";
    cursor.setAttribute('data-initial', initial);
    return decorations.concat(__WEBPACK_IMPORTED_MODULE_1_prosemirror_view__["Decoration"].widget(to, cursor, { pointer: { sessionId: sessionId } }));
};
var replaceDocument = function (doc, state, version, options) {
    var schema = state.schema, tr = state.tr;
    var content = (doc.content || []).map(function (child) { return schema.nodeFromJSON(child); });
    if (content.length) {
        tr.setMeta('addToHistory', false);
        tr.replaceWith(0, state.doc.nodeSize - 2, content);
        tr.setSelection(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Selection"].atStart(tr.doc));
        if (typeof version !== undefined && (options && options.useNativePlugin)) {
            var collabState = { version: version, unconfirmed: [] };
            tr.setMeta('collab$', collabState);
        }
    }
    return tr;
};
//# sourceMappingURL=utils.js.map

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorInfoIcon = function EditorInfoIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-8.5a1 1 0 0 0-1 1V15a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1zm0-1.125a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorInfoIcon.displayName = 'EditorInfoIcon';
var _default = EditorInfoIcon;
exports.default = _default;

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return makeColIdxPair; });
/* unused harmony export findFreeCol */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return findNextFreeCol; });
/* unused harmony export getRowChildren */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calculateColWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return unitToNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addContainerLeftRightPadding; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

var makeColIdxPair = function (cols) {
    return cols.map(function (col, idx) {
        return { col: col, idx: idx };
    });
};
var findFreeCol = function (colIdxObj, direction) {
    if (colIdxObj.length === 0) {
        return null;
    }
    var freeAmount = colIdxObj[0].col.freeSpace;
    var freeIdx = 0;
    colIdxObj.slice(1).forEach(function (_a, idx) {
        var col = _a.col;
        var isGreatest = col.freeSpace > freeAmount;
        if (isGreatest) {
            freeAmount = col.freeSpace;
            freeIdx = idx + 1;
        }
    });
    return freeIdx;
};
var findNextFreeCol = function (colIdxObj, direction) {
    if (colIdxObj.length === 0) {
        return -1;
    }
    if (direction < 0) {
        colIdxObj = colIdxObj.slice().reverse();
    }
    var freeIdx = -1;
    colIdxObj.forEach(function (_a, idx) {
        var col = _a.col;
        if (col.freeSpace && freeIdx === -1) {
            freeIdx = idx;
        }
    });
    if (freeIdx === -1) {
        return -1;
    }
    return direction < 0 ? colIdxObj.length - 1 - freeIdx : freeIdx;
};
var getRowChildren = function (row) {
    var children = [];
    var _loop_1 = function (i) {
        var currentCol = row.children[i];
        var colspan = Number(currentCol.getAttribute('colspan'));
        if (colspan > 1) {
            children.push.apply(children, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](Array.from({ length: colspan }, function (_) { return currentCol; })));
        }
        else {
            children.push(currentCol);
        }
    };
    for (var i = 0; i < row.childElementCount; i++) {
        _loop_1(i);
    }
    return children;
};
var defaultCalculateColWidthCb = function (col, colComputedStyle) { return unitToNumber(colComputedStyle.width); };
var calculateColWidth = function (table, colIdx, calculateColWidthCb) {
    if (calculateColWidthCb === void 0) { calculateColWidthCb = defaultCalculateColWidthCb; }
    var tbody = table.querySelector('tbody');
    if (tbody) {
        table = tbody;
    }
    var maxColWidth = 0;
    var colSpanWidth = 0;
    for (var i = 0; i < table.childElementCount; i++) {
        var row = table.children[i];
        if (row.tagName.toUpperCase() !== 'TR') {
            continue;
        }
        var rowChildren = getRowChildren(row);
        var col = rowChildren[colIdx];
        // We may encounter a rowspan'd cell.
        if (!col) {
            continue;
        }
        var colComputedStyle = getComputedStyle(col);
        var colspan = Number(col.getAttribute('colspan'));
        if (colspan > 1) {
            colSpanWidth = unitToNumber(colComputedStyle.width);
            continue;
        }
        if (colComputedStyle) {
            var colWidth = calculateColWidthCb(col, colComputedStyle);
            maxColWidth = Math.max(colWidth, maxColWidth);
        }
    }
    return maxColWidth || colSpanWidth;
};
var unitToNumber = function (unit) {
    if (unit) {
        return Number(unit.slice(0, unit.length - 2));
    }
    return 0;
};
var addContainerLeftRightPadding = function (amount, computedStyle) {
    return (amount +
        unitToNumber(computedStyle.paddingLeft) +
        unitToNumber(computedStyle.paddingRight));
};
//# sourceMappingURL=utils.js.map

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return enterKeyCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return backspaceKeyCommand; });
/* harmony export (immutable) */ __webpack_exports__["d"] = outdentList;
/* harmony export (immutable) */ __webpack_exports__["c"] = indentList;
/* unused harmony export liftListItems */
/* unused harmony export adjustSelectionInList */
/* unused harmony export rootListDepth */
/* unused harmony export numberNestedLists */
/* unused harmony export toggleList */
/* harmony export (immutable) */ __webpack_exports__["f"] = toggleListCommand;
/* harmony export (immutable) */ __webpack_exports__["e"] = toggleBulletList;
/* harmony export (immutable) */ __webpack_exports__["g"] = toggleOrderedList;
/* unused harmony export wrapInList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_transform__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_transform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_transform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_commands__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_commands___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_commands__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_schema_list__ = __webpack_require__(2429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_schema_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prosemirror_schema_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_document__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_commands__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__transforms__ = __webpack_require__(2430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__gap_cursor__ = __webpack_require__(213);











var maxIndentation = 5;
var deletePreviousEmptyListItem = function (state, dispatch) {
    var $from = state.selection.$from;
    var listItem = state.schema.nodes.listItem;
    var $cut = Object(__WEBPACK_IMPORTED_MODULE_7__utils_commands__["b" /* findCutBefore */])($from);
    if (!$cut || !$cut.nodeBefore || !($cut.nodeBefore.type === listItem)) {
        return false;
    }
    var previousListItemEmpty = $cut.nodeBefore.childCount === 1 &&
        $cut.nodeBefore.firstChild.nodeSize <= 2;
    if (previousListItemEmpty) {
        var tr = state.tr;
        if (dispatch) {
            dispatch(tr
                .delete($cut.pos - $cut.nodeBefore.nodeSize, $from.pos)
                .scrollIntoView());
        }
        return true;
    }
    return false;
};
var joinToPreviousListItem = function (state, dispatch) {
    var $from = state.selection.$from;
    var _a = state.schema.nodes, paragraph = _a.paragraph, listItem = _a.listItem, codeBlock = _a.codeBlock, bulletList = _a.bulletList, orderedList = _a.orderedList;
    var isGapCursorShown = state.selection instanceof __WEBPACK_IMPORTED_MODULE_10__gap_cursor__["a" /* GapCursorSelection */];
    var $cutPos = isGapCursorShown ? state.doc.resolve($from.pos + 1) : $from;
    var $cut = Object(__WEBPACK_IMPORTED_MODULE_7__utils_commands__["b" /* findCutBefore */])($cutPos);
    if (!$cut) {
        return false;
    }
    // see if the containing node is a list
    if ($cut.nodeBefore &&
        [bulletList, orderedList].indexOf($cut.nodeBefore.type) > -1) {
        // and the node after this is a paragraph or a codeBlock
        if ($cut.nodeAfter &&
            ($cut.nodeAfter.type === paragraph || $cut.nodeAfter.type === codeBlock)) {
            // find the nearest paragraph that precedes this node
            var $lastNode = $cut.doc.resolve($cut.pos - 1);
            while ($lastNode.parent.type !== paragraph) {
                $lastNode = state.doc.resolve($lastNode.pos - 1);
            }
            var tr = state.tr;
            if (isGapCursorShown) {
                var nodeBeforePos = Object(__WEBPACK_IMPORTED_MODULE_5_prosemirror_utils__["findPositionOfNodeBefore"])(tr.selection);
                if (typeof nodeBeforePos !== 'number') {
                    return false;
                }
                // append the codeblock to the list node
                var list = $cut.nodeBefore.copy($cut.nodeBefore.content.append(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(listItem.createChecked({}, $cut.nodeAfter))));
                tr.replaceWith(nodeBeforePos, $from.pos + $cut.nodeAfter.nodeSize, list);
            }
            else {
                // take the text content of the paragraph and insert after the paragraph up until before the the cut
                tr = state.tr.step(new __WEBPACK_IMPORTED_MODULE_2_prosemirror_transform__["ReplaceAroundStep"]($lastNode.pos, $cut.pos + $cut.nodeAfter.nodeSize, $cut.pos + 1, $cut.pos + $cut.nodeAfter.nodeSize - 1, state.tr.doc.slice($lastNode.pos, $cut.pos), 0, true));
            }
            // find out if there's now another list following and join them
            // as in, [list, p, list] => [list with p, list], and we want [joined list]
            var $postCut = tr.doc.resolve(tr.mapping.map($cut.pos + $cut.nodeAfter.nodeSize));
            if ($postCut.nodeBefore &&
                $postCut.nodeAfter &&
                $postCut.nodeBefore.type === $postCut.nodeAfter.type &&
                [bulletList, orderedList].indexOf($postCut.nodeBefore.type) > -1) {
                tr = tr.join($postCut.pos);
            }
            if (dispatch) {
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
};
var isInsideListItem = function (state) {
    var $from = state.selection.$from;
    var _a = state.schema.nodes, listItem = _a.listItem, paragraph = _a.paragraph;
    if (state.selection instanceof __WEBPACK_IMPORTED_MODULE_10__gap_cursor__["a" /* GapCursorSelection */]) {
        return $from.parent.type === listItem;
    }
    return (Object(__WEBPACK_IMPORTED_MODULE_5_prosemirror_utils__["hasParentNodeOfType"])(listItem)(state.selection) &&
        $from.parent.type === paragraph);
};
var canToJoinToPreviousListItem = function (state) {
    var $from = state.selection.$from;
    var _a = state.schema.nodes, bulletList = _a.bulletList, orderedList = _a.orderedList;
    var $before = state.doc.resolve($from.pos - 1);
    var nodeBefore = $before ? $before.nodeBefore : null;
    if (state.selection instanceof __WEBPACK_IMPORTED_MODULE_10__gap_cursor__["a" /* GapCursorSelection */]) {
        nodeBefore = $from.nodeBefore;
    }
    return (!!nodeBefore && [bulletList, orderedList].indexOf(nodeBefore.type) > -1);
};
var canOutdent = function (state) {
    var parent = state.selection.$from.parent;
    var _a = state.schema.nodes, listItem = _a.listItem, paragraph = _a.paragraph;
    if (state.selection instanceof __WEBPACK_IMPORTED_MODULE_10__gap_cursor__["a" /* GapCursorSelection */]) {
        return parent.type === listItem;
    }
    return (parent.type === paragraph && Object(__WEBPACK_IMPORTED_MODULE_5_prosemirror_utils__["hasParentNodeOfType"])(listItem)(state.selection));
};
var enterKeyCommand = function (state, dispatch) {
    var selection = state.selection;
    if (selection.empty) {
        var $from = selection.$from;
        var listItem = state.schema.nodes.listItem;
        var node = $from.node($from.depth);
        var wrapper = $from.node($from.depth - 1);
        if (wrapper && wrapper.type === listItem) {
            /** Check if the wrapper has any visible content */
            var wrapperHasContent = Object(__WEBPACK_IMPORTED_MODULE_6__utils_document__["b" /* hasVisibleContent */])(wrapper);
            if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_document__["d" /* isEmptyNode */])(node) && !wrapperHasContent) {
                return outdentList()(state, dispatch);
            }
            else {
                return splitListItem(listItem)(state, dispatch);
            }
        }
    }
    return false;
};
var backspaceKeyCommand = __WEBPACK_IMPORTED_MODULE_3_prosemirror_commands__["chainCommands"](
// if we're at the start of a list item, we need to either backspace
// directly to an empty list item above, or outdent this node
Object(__WEBPACK_IMPORTED_MODULE_7__utils_commands__["a" /* filter */])([
    __WEBPACK_IMPORTED_MODULE_7__utils_commands__["c" /* isEmptySelectionAtStart */],
    // list items might have multiple paragraphs; only do this at the first one
    __WEBPACK_IMPORTED_MODULE_7__utils_commands__["d" /* isFirstChildOfParent */],
    canOutdent,
], __WEBPACK_IMPORTED_MODULE_3_prosemirror_commands__["chainCommands"](deletePreviousEmptyListItem, outdentList())), 
// if we're just inside a paragraph node (or gapcursor is shown) and backspace, then try to join
// the text to the previous list item, if one exists
Object(__WEBPACK_IMPORTED_MODULE_7__utils_commands__["a" /* filter */])([__WEBPACK_IMPORTED_MODULE_7__utils_commands__["c" /* isEmptySelectionAtStart */], canToJoinToPreviousListItem], joinToPreviousListItem));
/**
 * Implemetation taken and modified for our needs from PM
 * @param itemType Node
 * Splits the list items, specific implementation take from PM
 */
function splitListItem(itemType) {
    return function (state, dispatch) {
        var ref = state.selection;
        var $from = ref.$from;
        var $to = ref.$to;
        var node = ref.node;
        if ((node && node.isBlock) || $from.depth < 2 || !$from.sameParent($to)) {
            return false;
        }
        var grandParent = $from.node(-1);
        if (grandParent.type !== itemType) {
            return false;
        }
        /** --> The following line changed from the original PM implementation to allow list additions with multiple paragraphs */
        if (grandParent.content.content.length <= 1 &&
            $from.parent.content.size === 0 &&
            !(grandParent.content.size === 0)) {
            // In an empty block. If this is a nested list, the wrapping
            // list item should be split. Otherwise, bail out and let next
            // command handle lifting.
            if ($from.depth === 2 ||
                $from.node(-3).type !== itemType ||
                $from.index(-2) !== $from.node(-2).childCount - 1) {
                return false;
            }
            if (dispatch) {
                var wrap = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty;
                var keepItem = $from.index(-1) > 0;
                // Build a fragment containing empty versions of the structure
                // from the outer list item to the parent node of the cursor
                for (var d = $from.depth - (keepItem ? 1 : 2); d >= $from.depth - 3; d--) {
                    wrap = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from($from.node(d).copy(wrap));
                }
                // Add a second list item with an empty default start node
                wrap = wrap.append(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(itemType.createAndFill()));
                var tr$1 = state.tr.replace($from.before(keepItem ? null : -1), $from.after(-3), new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](wrap, keepItem ? 3 : 2, 2));
                tr$1.setSelection(state.selection.constructor.near(tr$1.doc.resolve($from.pos + (keepItem ? 3 : 2))));
                dispatch(tr$1.scrollIntoView());
            }
            return true;
        }
        var nextType = $to.pos === $from.end() ? grandParent.defaultContentType(0) : null;
        var tr = state.tr.delete($from.pos, $to.pos);
        var types = nextType && [null, { type: nextType }];
        if (dispatch) {
            dispatch(tr.split($from.pos, 2, types).scrollIntoView());
        }
        return true;
    };
}
function outdentList() {
    return function (state, dispatch) {
        var listItem = state.schema.nodes.listItem;
        var _a = state.selection, $from = _a.$from, $to = _a.$to;
        if (isInsideListItem(state)) {
            // if we're backspacing at the start of a list item, unindent it
            // take the the range of nodes we might be lifting
            // the predicate is for when you're backspacing a top level list item:
            // we don't want to go up past the doc node, otherwise the range
            // to clear will include everything
            var range = $from.blockRange($to, function (node) { return node.childCount > 0 && node.firstChild.type === listItem; });
            if (!range) {
                return false;
            }
            var tr_1;
            if (__WEBPACK_IMPORTED_MODULE_4_prosemirror_schema_list__["liftListItem"](listItem)(state, function (liftTr) { return (tr_1 = liftTr); })) {
                /* we now need to handle the case that we lifted a sublist out,
                 * and any listItems at the current level get shifted out to
                 * their own new list; e.g.:
                 *
                 * unorderedList
                 *  listItem(A)
                 *  listItem
                 *    unorderedList
                 *      listItem(B)
                 *  listItem(C)
                 *
                 * becomes, after unindenting the first, top level listItem, A:
                 *
                 * content of A
                 * unorderedList
                 *  listItem(B)
                 * unorderedList
                 *  listItem(C)
                 *
                 * so, we try to merge these two lists if they're of the same type, to give:
                 *
                 * content of A
                 * unorderedList
                 *  listItem(B)
                 *  listItem(C)
                 */
                var $start = state.doc.resolve(range.start);
                var $end = state.doc.resolve(range.end);
                var $join = tr_1.doc.resolve(tr_1.mapping.map(range.end - 1));
                if ($join.nodeBefore &&
                    $join.nodeAfter &&
                    $join.nodeBefore.type === $join.nodeAfter.type) {
                    if ($end.nodeAfter &&
                        $end.nodeAfter.type === listItem &&
                        $end.parent.type === $start.parent.type) {
                        tr_1.join($join.pos);
                    }
                }
                if (dispatch) {
                    dispatch(tr_1.scrollIntoView());
                }
                return true;
            }
        }
        return false;
    };
}
function indentList() {
    return function (state, dispatch) {
        var listItem = state.schema.nodes.listItem;
        if (isInsideListItem(state)) {
            var initialIndentationLevel = numberNestedLists(state.selection.$from, state.schema.nodes);
            /*
            - Record initial list indentation
            - Keep going forward in document until indentation of the node is < than the initial
            - If indentation is EVER > max indentation, return true and don't sink the list
            */
            var currentIndentationLevel = void 0;
            var currentPos = state.tr.selection.$to.pos;
            do {
                var resolvedPos = state.doc.resolve(currentPos);
                currentIndentationLevel = numberNestedLists(resolvedPos, state.schema.nodes);
                if (currentIndentationLevel > maxIndentation) {
                    // Cancel sink list.
                    // If current indentation less than the initial, it won't be
                    // larger than the max, and the loop will terminate at end of this iteration
                    return true;
                }
                currentPos++;
            } while (currentIndentationLevel >= initialIndentationLevel);
            __WEBPACK_IMPORTED_MODULE_4_prosemirror_schema_list__["sinkListItem"](listItem)(state, dispatch);
            return true;
        }
        return false;
    };
}
function liftListItems() {
    return function (state, dispatch) {
        var tr = state.tr;
        var _a = state.selection, $from = _a.$from, $to = _a.$to;
        tr.doc.nodesBetween($from.pos, $to.pos, function (node, pos) {
            // Following condition will ensure that block types paragraph, heading, codeBlock, blockquote, panel are lifted.
            // isTextblock is true for paragraph, heading, codeBlock.
            if (node.isTextblock ||
                node.type.name === 'blockquote' ||
                node.type.name === 'panel') {
                var sel = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["NodeSelection"](tr.doc.resolve(tr.mapping.map(pos)));
                var range = sel.$from.blockRange(sel.$to);
                if (!range || sel.$from.parent.type !== state.schema.nodes.listItem) {
                    return false;
                }
                var target = range && Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_transform__["liftTarget"])(range);
                if (target === undefined || target === null) {
                    return false;
                }
                tr.lift(range, target);
            }
        });
        if (dispatch) {
            dispatch(tr);
        }
        return true;
    };
}
/**
 * Sometimes a selection in the editor can be slightly offset, for example:
 * it's possible for a selection to start or end at an empty node at the very end of
 * a line. This isn't obvious by looking at the editor and it's likely not what the
 * user intended - so we need to adjust the selection a bit in scenarios like that.
 */
function adjustSelectionInList(doc, selection) {
    var $from = selection.$from, $to = selection.$to;
    var isSameLine = $from.pos === $to.pos;
    var startPos = $from.pos;
    var endPos = $to.pos;
    if (isSameLine && startPos === doc.nodeSize - 3) {
        // Line is empty, don't do anything
        return selection;
    }
    // Selection started at the very beginning of a line and therefor points to the previous line.
    if ($from.nodeBefore && !isSameLine) {
        startPos++;
        var node = doc.nodeAt(startPos);
        while (!node || (node && !node.isText)) {
            startPos++;
            node = doc.nodeAt(startPos);
        }
    }
    if (endPos === startPos) {
        return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["TextSelection"](doc.resolve(startPos));
    }
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["TextSelection"](doc.resolve(startPos), doc.resolve(endPos));
}
// Get the depth of the nearest ancestor list
var rootListDepth = function (pos, nodes) {
    var bulletList = nodes.bulletList, orderedList = nodes.orderedList, listItem = nodes.listItem;
    var depth;
    for (var i = pos.depth - 1; i > 0; i--) {
        var node = pos.node(i);
        if (node.type === bulletList || node.type === orderedList) {
            depth = i;
        }
        if (node.type !== bulletList &&
            node.type !== orderedList &&
            node.type !== listItem) {
            break;
        }
    }
    return depth;
};
// Returns the number of nested lists that are ancestors of the given selection
var numberNestedLists = function (resolvedPos, nodes) {
    var bulletList = nodes.bulletList, orderedList = nodes.orderedList;
    var count = 0;
    for (var i = resolvedPos.depth - 1; i > 0; i--) {
        var node = resolvedPos.node(i);
        if (node.type === bulletList || node.type === orderedList) {
            count += 1;
        }
    }
    return count;
};
var toggleList = function (state, dispatch, view, listType) {
    var selection = state.selection;
    var fromNode = selection.$from.node(selection.$from.depth - 2);
    var endNode = selection.$to.node(selection.$to.depth - 2);
    if (!fromNode ||
        fromNode.type.name !== listType ||
        (!endNode || endNode.type.name !== listType)) {
        return toggleListCommand(listType)(state, dispatch, view);
    }
    else {
        var depth = rootListDepth(selection.$to, state.schema.nodes);
        var tr = Object(__WEBPACK_IMPORTED_MODULE_9__transforms__["a" /* liftFollowingList */])(state, selection.$to.pos, selection.$to.end(depth), depth, state.tr);
        tr = Object(__WEBPACK_IMPORTED_MODULE_9__transforms__["b" /* liftSelectionList */])(state, tr);
        dispatch(tr);
        return true;
    }
};
function toggleListCommand(listType) {
    return function (state, dispatch, view) {
        if (dispatch) {
            dispatch(state.tr.setSelection(adjustSelectionInList(state.doc, state.selection)));
        }
        if (!view) {
            return false;
        }
        state = view.state;
        var _a = state.selection, $from = _a.$from, $to = _a.$to;
        var parent = $from.node(-2);
        var grandgrandParent = $from.node(-3);
        var isRangeOfSingleType = Object(__WEBPACK_IMPORTED_MODULE_8__utils__["z" /* isRangeOfType */])(state.doc, $from, $to, state.schema.nodes[listType]);
        if (((parent && parent.type === state.schema.nodes[listType]) ||
            (grandgrandParent &&
                grandgrandParent.type === state.schema.nodes[listType])) &&
            isRangeOfSingleType) {
            // Untoggles list
            return liftListItems()(state, dispatch);
        }
        else {
            // Wraps selection in list and converts list type e.g. bullet_list -> ordered_list if needed
            if (!isRangeOfSingleType) {
                liftListItems()(state, dispatch);
                state = view.state;
            }
            return wrapInList(state.schema.nodes[listType])(state, dispatch);
        }
    };
}
function toggleBulletList(view) {
    return toggleList(view.state, view.dispatch, view, 'bulletList');
}
function toggleOrderedList(view) {
    return toggleList(view.state, view.dispatch, view, 'orderedList');
}
function wrapInList(nodeType) {
    return __WEBPACK_IMPORTED_MODULE_3_prosemirror_commands__["autoJoin"](__WEBPACK_IMPORTED_MODULE_4_prosemirror_schema_list__["wrapInList"](nodeType), function (before, after) { return before.type === after.type && before.type === nodeType; });
}
//# sourceMappingURL=commands.js.map

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return insertDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setDatePickerAt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return closeDatePicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return openDatePicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugin__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__ = __webpack_require__(13);



var insertDate = function (date) { return function (state, dispatch) {
    var schema = state.schema;
    var timestamp;
    if (date) {
        timestamp = Date.UTC(date.year, date.month - 1, date.day).toString();
    }
    else {
        timestamp = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["_7" /* todayTimestampInUTC */])();
    }
    var tr = state.tr;
    var showDatePickerAt = __WEBPACK_IMPORTED_MODULE_1__plugin__["b" /* pluginKey */].getState(state).showDatePickerAt;
    if (!showDatePickerAt) {
        var dateNode = schema.nodes.date.createChecked({ timestamp: timestamp });
        dispatch(tr.replaceSelectionWith(dateNode).scrollIntoView());
        return true;
    }
    if (state.doc.nodeAt(showDatePickerAt)) {
        dispatch(tr
            .setNodeMarkup(showDatePickerAt, schema.nodes.date, {
            timestamp: timestamp,
        })
            .setSelection(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Selection"].near(tr.doc.resolve(showDatePickerAt + 2)))
            .setMeta(__WEBPACK_IMPORTED_MODULE_1__plugin__["b" /* pluginKey */], { showDatePickerAt: null })
            .scrollIntoView());
        return true;
    }
    return false;
}; };
var setDatePickerAt = function (showDatePickerAt) { return function (state, dispatch) {
    dispatch(state.tr.setMeta(__WEBPACK_IMPORTED_MODULE_1__plugin__["b" /* pluginKey */], { showDatePickerAt: showDatePickerAt }));
    return true;
}; };
var closeDatePicker = function () { return function (state, dispatch) {
    var showDatePickerAt = __WEBPACK_IMPORTED_MODULE_1__plugin__["b" /* pluginKey */].getState(state).showDatePickerAt;
    if (!showDatePickerAt) {
        return false;
    }
    dispatch(state.tr
        .setMeta(__WEBPACK_IMPORTED_MODULE_1__plugin__["b" /* pluginKey */], { showDatePickerAt: null })
        .setSelection(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Selection"].near(state.tr.doc.resolve(showDatePickerAt + 2))));
}; };
var openDatePicker = function (domAtPos) { return function (state, dispatch) {
    var $from = state.selection.$from;
    var start = $from.parent.childAfter($from.parentOffset).offset +
        $from.start($from.depth);
    var parent = domAtPos(start).node;
    if (parent && parent.childNodes.length) {
        var index = $from.index($from.depth);
        var element = parent.childNodes[index - 1];
        if (element) {
            var showDatePickerAt = $from.pos - 1;
            dispatch(state.tr
                .setMeta(__WEBPACK_IMPORTED_MODULE_1__plugin__["b" /* pluginKey */], { showDatePickerAt: showDatePickerAt })
                .setSelection(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"].create(state.doc, showDatePickerAt)));
        }
    }
    return false;
}; };
//# sourceMappingURL=actions.js.map

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluginKey; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeviews_date__ = __webpack_require__(2431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nodeviews__ = __webpack_require__(84);




var pluginKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('datePlugin');
var createPlugin = function (_a) {
    var dispatch = _a.dispatch, portalProviderAPI = _a.portalProviderAPI;
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        state: {
            init: function () { return ({ showDatePickerAt: null }); },
            apply: function (tr, state) {
                var meta = tr.getMeta(pluginKey);
                if (meta) {
                    // ED-5033, calendar control open for element in plugin state, when node-view is clicked.
                    // Following chanek ensures that if same node-view is clicked twice calendar should close,
                    // but if a different node-view is clicked, calendar should open next the that node-view.
                    var newState = void 0;
                    if (meta.showDatePickerAt === state.showDatePickerAt) {
                        newState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, state, { showDatePickerAt: null });
                    }
                    else {
                        newState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, state, meta);
                    }
                    dispatch(pluginKey, newState);
                    return newState;
                }
                if (tr.docChanged && state.showDatePickerAt) {
                    var _a = tr.mapping.mapResult(state.showDatePickerAt), pos = _a.pos, deleted = _a.deleted;
                    var newState = {
                        showDatePickerAt: deleted ? null : pos,
                    };
                    if (newState.showDatePickerAt !== state.showDatePickerAt) {
                        dispatch(pluginKey, newState);
                        return newState;
                    }
                }
                return state;
            },
        },
        key: pluginKey,
        props: {
            nodeViews: {
                date: __WEBPACK_IMPORTED_MODULE_3__nodeviews__["a" /* ReactNodeView */].fromComponent(__WEBPACK_IMPORTED_MODULE_2__nodeviews_date__["a" /* default */], portalProviderAPI),
            },
        },
    });
};
/* harmony default export */ __webpack_exports__["a"] = (createPlugin);
//# sourceMappingURL=plugin.js.map

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPresetLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createDefaultLayoutSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return insertLayoutColumns; });
/* unused harmony export forceSectionToPresetLayout */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setPresetLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fixColumnSizes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteActiveLayoutNode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pm_plugins_main__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_slice__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(21);






var getPresetLayout = function (section) {
    var widths = Object(__WEBPACK_IMPORTED_MODULE_4__utils_slice__["c" /* mapChildren */])(section, function (column) { return column.attrs.width; });
    if (widths.length === 2 && widths.every(function (width) { return width === 50; })) {
        return 'two_equal';
    }
    else if (widths.every(function (width) { return Number(width.toFixed(2)) === 33.33; })) {
        return 'three_equal';
    }
};
var createDefaultLayoutSection = function (state) {
    var _a = state.schema.nodes, layoutSection = _a.layoutSection, layoutColumn = _a.layoutColumn;
    // create a 50-50 layout by default
    var columns = __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__["Fragment"].fromArray([
        layoutColumn.createAndFill({ width: 50 }),
        layoutColumn.createAndFill({ width: 50 }),
    ]);
    return layoutSection.createAndFill(undefined, columns);
};
var insertLayoutColumns = function (state, dispatch) {
    if (dispatch) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["safeInsert"])(createDefaultLayoutSection(state))(state.tr));
    }
    return true;
};
function forceColumnStructure(state, node, pos, presetLayout) {
    var tr = state.tr;
    var insideRightEdgeOfLayoutSection = pos + node.nodeSize - 1;
    if (presetLayout === 'two_equal' && node.childCount === 3) {
        var thirdColumn = node.content.child(2);
        var thirdColumnPos = insideRightEdgeOfLayoutSection - thirdColumn.nodeSize;
        if (Object(__WEBPACK_IMPORTED_MODULE_5__utils__["t" /* isEmptyDocument */])(thirdColumn)) {
            tr.replaceRange(
            // end pos of second column
            tr.mapping.map(thirdColumnPos - 1), tr.mapping.map(insideRightEdgeOfLayoutSection), __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__["Slice"].empty);
        }
        else {
            tr.replaceRange(
            // end pos of second column
            tr.mapping.map(thirdColumnPos - 1), 
            // start pos of third column
            tr.mapping.map(thirdColumnPos + 1), __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__["Slice"].empty);
        }
    }
    else if (presetLayout === 'three_equal' && node.childCount === 2) {
        tr.replaceWith(tr.mapping.map(insideRightEdgeOfLayoutSection), tr.mapping.map(insideRightEdgeOfLayoutSection), state.schema.nodes.layoutColumn.createAndFill());
    }
    return tr;
}
function equalColumnWidth(node, schema, width) {
    var layoutColumn = schema.nodes.layoutColumn;
    var truncatedWidth = Number(width.toFixed(2));
    return Object(__WEBPACK_IMPORTED_MODULE_4__utils_slice__["a" /* flatmap */])(node.content, function (column) {
        return layoutColumn.create(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, column.attrs, { width: truncatedWidth }), column.content, column.marks);
    });
}
function forceColumnWidths(state, tr, pos, presetLayout) {
    var width = presetLayout === 'two_equal' ? 50 : 33.33;
    var node = tr.doc.nodeAt(pos);
    if (!node) {
        return tr;
    }
    if (getPresetLayout(node) === presetLayout) {
        return tr;
    }
    return tr.replaceWith(pos + 1, pos + node.nodeSize - 1, equalColumnWidth(node, state.schema, width));
}
function forceSectionToPresetLayout(state, node, pos, presetLayout) {
    var tr = forceColumnStructure(state, node, pos, presetLayout);
    // save the selection here, since forcing column widths causes a change over the
    // entire layoutSection, which remaps selection to the end. not remapping here
    // is safe because the structure is no longer changing.
    var selection = tr.selection;
    return forceColumnWidths(state, tr, pos, presetLayout).setSelection(selection);
}
var setPresetLayout = function (layout) { return function (state, dispatch) {
    var pos = __WEBPACK_IMPORTED_MODULE_3__pm_plugins_main__["b" /* pluginKey */].getState(state).pos;
    if (pos === null) {
        return false;
    }
    var node = state.doc.nodeAt(pos);
    if (!node) {
        return false;
    }
    var tr = forceSectionToPresetLayout(state, node, pos, layout);
    if (tr) {
        if (dispatch) {
            dispatch(tr.scrollIntoView());
        }
        return true;
    }
    return false;
}; };
var fixColumnSizes = function (changedTr, state) {
    var layoutSection = state.schema.nodes.layoutSection;
    var change;
    var range = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["p" /* getStepRange */])(changedTr);
    if (!range) {
        return undefined;
    }
    changedTr.doc.nodesBetween(range.from, range.to, function (node, pos) {
        if (node.type === layoutSection) {
            var widths = Object(__WEBPACK_IMPORTED_MODULE_4__utils_slice__["c" /* mapChildren */])(node, function (column) { return column.attrs.width; });
            var totalWidth = Math.round(widths.reduce(function (acc, width) { return acc + width; }, 0));
            if (totalWidth !== 100) {
                var fixedColumns = equalColumnWidth(node, state.schema, 100 / node.childCount);
                change = {
                    from: pos + 1,
                    to: pos + node.nodeSize - 1,
                    slice: new __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__["Slice"](fixedColumns, 0, 0),
                };
                return false;
            }
        }
        else {
            return true;
        }
    });
    return change;
};
var deleteActiveLayoutNode = function (state, dispatch) {
    var pos = __WEBPACK_IMPORTED_MODULE_3__pm_plugins_main__["b" /* pluginKey */].getState(state).pos;
    if (pos !== null) {
        var node = state.doc.nodeAt(pos);
        if (dispatch) {
            dispatch(state.tr.delete(pos, pos + node.nodeSize));
        }
        return true;
    }
    return false;
};
//# sourceMappingURL=actions.js.map

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluginKey; });
/* unused harmony export SelectionChange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeviews_status__ = __webpack_require__(2450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nodeviews__ = __webpack_require__(84);




var pluginKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('statusPlugin');
var SelectionChange = /** @class */ (function () {
    function SelectionChange() {
        this.changeHandlers = [];
        this.changeHandlers = [];
    }
    SelectionChange.prototype.subscribe = function (cb) {
        this.changeHandlers.push(cb);
    };
    SelectionChange.prototype.unsubscribe = function (cb) {
        this.changeHandlers = this.changeHandlers.filter(function (ch) { return ch !== cb; });
    };
    SelectionChange.prototype.notifyNewSelection = function (newSelection, prevSelection) {
        this.changeHandlers.forEach(function (cb) { return cb(newSelection, prevSelection); });
    };
    return SelectionChange;
}());

var createPlugin = function (_a) {
    var dispatch = _a.dispatch, portalProviderAPI = _a.portalProviderAPI;
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        state: {
            init: function () { return ({
                autoFocus: false,
                selectionChanges: new SelectionChange(),
                showStatusPickerAt: null,
                selectedStatus: null,
            }); },
            apply: function (tr, state, editorState) {
                var meta = tr.getMeta(pluginKey);
                var nodeAtSelection = tr.doc.nodeAt(tr.selection.from);
                if (state.showStatusPickerAt &&
                    (!nodeAtSelection ||
                        nodeAtSelection.type !== editorState.schema.nodes.status)) {
                    var newState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, state, { showStatusPickerAt: null, selectedStatus: null });
                    dispatch(pluginKey, newState);
                    return newState;
                }
                if (meta) {
                    var selectedStatus = null;
                    if (meta.showStatusPickerAt &&
                        meta.showStatusPickerAt !== state.showStatusPickerAt) {
                        var statusNode = tr.doc.nodeAt(meta.showStatusPickerAt);
                        if (statusNode) {
                            selectedStatus = statusNode.attrs;
                        }
                    }
                    var newState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, state, meta, { selectedStatus: selectedStatus });
                    dispatch(pluginKey, newState);
                    return newState;
                }
                if (tr.docChanged && state.showStatusPickerAt) {
                    var _a = tr.mapping.mapResult(state.showStatusPickerAt), pos = _a.pos, deleted = _a.deleted;
                    var newState = {
                        showStatusPickerAt: deleted ? null : pos,
                        selectedStatus: null,
                    };
                    if (newState.showStatusPickerAt !== state.showStatusPickerAt) {
                        dispatch(pluginKey, newState);
                        return newState;
                    }
                }
                return state;
            },
        },
        key: pluginKey,
        props: {
            nodeViews: {
                status: __WEBPACK_IMPORTED_MODULE_3__nodeviews__["a" /* ReactNodeView */].fromComponent(__WEBPACK_IMPORTED_MODULE_2__nodeviews_status__["a" /* default */], portalProviderAPI),
            },
        },
        view: function (view) {
            return {
                update: function (view, prevState) {
                    var newSelection = view.state.selection;
                    var prevSelection = prevState.selection;
                    if (!prevSelection.eq(newSelection)) {
                        // selection changed
                        var pluginState = pluginKey.getState(view.state);
                        var selectionChanges = pluginState.selectionChanges;
                        if (selectionChanges) {
                            selectionChanges.notifyNewSelection(newSelection, prevSelection);
                        }
                    }
                },
            };
        },
    });
};
/* harmony default export */ __webpack_exports__["a"] = (createPlugin);
//# sourceMappingURL=plugin.js.map

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return emojiPluginKey; });
/* unused harmony export EmojiState */
/* harmony export (immutable) */ __webpack_exports__["a"] = createPlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nodeviews__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nodeviews_emoji__ = __webpack_require__(2463);





var emojiPluginKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('emojiPlugin');
var EmojiState = /** @class */ (function () {
    function EmojiState(state, providerFactory) {
        var _this = this;
        this.enabled = true;
        this.focused = false;
        this.queryActive = false;
        this.onSelectPrevious = function () { return false; };
        this.onSelectNext = function () { return false; };
        this.onSelectCurrent = function (key) { return false; };
        this.onSpaceSelectCurrent = function (emoji, key, query) { };
        this.onSpaceTyped = function () { };
        this.onDismiss = function () { };
        this.changeHandlers = [];
        this.queryResult = [];
        this.insertEmoji = function (emojiId) {
            var _a = _this, state = _a.state, view = _a.view;
            var emoji = state.schema.nodes.emoji;
            if (emoji && emojiId) {
                var _b = _this.findEmojiQueryMark(), start = _b.start, end = _b.end;
                var node = emoji.create(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, emojiId, { text: emojiId.fallback || emojiId.shortName }));
                var textNode = state.schema.text(' ');
                // This problem affects Chrome v58-62. See: https://github.com/ProseMirror/prosemirror/issues/710
                if (__WEBPACK_IMPORTED_MODULE_2__utils__["r" /* isChromeWithSelectionBug */]) {
                    var selection = document.getSelection();
                    if (selection) {
                        selection.empty();
                    }
                }
                view.dispatch(state.tr.replaceWith(start, end, [node, textNode]));
                view.focus();
                _this.queryActive = false;
                _this.query = undefined;
            }
            else {
                _this.dismiss();
            }
        };
        this.handleProvider = function (name, provider) {
            if (!provider) {
                return;
            }
            switch (name) {
                case 'emojiProvider':
                    provider
                        .then(function (emojiProvider) {
                        _this.emojiProvider = emojiProvider;
                        if (_this.emojiProvider) {
                            _this.emojiProvider.subscribe(_this.onProviderChange);
                        }
                    })
                        .catch(function () {
                        if (_this.emojiProvider) {
                            _this.emojiProvider.unsubscribe(_this.onProviderChange);
                        }
                        _this.emojiProvider = undefined;
                    });
                    break;
            }
        };
        this.trySelectCurrentWithSpace = function (key) {
            var emojisCount = _this.getEmojisCount();
            if (emojisCount === 1) {
                var lastQuery = _this.query;
                _this.insertEmoji(_this.queryResult[0]);
                _this.onSpaceSelectCurrent(_this.queryResult[0], key, lastQuery);
                return true;
            }
            else if (emojisCount === 0 || _this.isEmptyQuery()) {
                _this.dismiss();
            }
            _this.onSpaceTyped();
            return false;
        };
        this.getEmojisCount = function () {
            return (_this.queryResult && _this.queryResult.length) || 0;
        };
        this.isEmptyQuery = function () {
            return !_this.query || _this.query === ':';
        };
        this.onSearchResult = function (searchResults) {
            _this.queryResult = searchResults.emojis;
        };
        this.onProviderChange = {
            result: this.onSearchResult,
        };
        this.changeHandlers = [];
        this.state = state;
        providerFactory.subscribe('emojiProvider', this.handleProvider);
    }
    EmojiState.prototype.subscribe = function (cb) {
        this.changeHandlers.push(cb);
        cb(this);
    };
    EmojiState.prototype.unsubscribe = function (cb) {
        this.changeHandlers = this.changeHandlers.filter(function (ch) { return ch !== cb; });
    };
    EmojiState.prototype.notifySubscribers = function () {
        var _this = this;
        this.changeHandlers.forEach(function (cb) { return cb(_this); });
    };
    EmojiState.prototype.update = function (state) {
        this.state = state;
        if (!this.emojiProvider) {
            return;
        }
        var emojiQuery = state.schema.marks.emojiQuery;
        var doc = state.doc, selection = state.selection;
        var from = selection.from, to = selection.to;
        var dirty = false;
        var newEnabled = this.isEnabled();
        if (newEnabled !== this.enabled) {
            this.enabled = newEnabled;
            dirty = true;
        }
        if (doc.rangeHasMark(from - 1, to, emojiQuery)) {
            if (!this.queryActive) {
                dirty = true;
                this.queryActive = true;
            }
            var nodeBefore = selection.$from.nodeBefore /*nodeAfter*/;
            var newQuery = (nodeBefore && nodeBefore.textContent) || '';
            if (this.query !== newQuery) {
                dirty = true;
                this.query = newQuery;
            }
        }
        else if (this.queryActive) {
            dirty = true;
            this.dismiss();
            return;
        }
        var newAnchorElement = this.view.dom.querySelector('[data-emoji-query]');
        if (newAnchorElement !== this.anchorElement) {
            dirty = true;
            this.anchorElement = newAnchorElement;
        }
        if (dirty) {
            this.notifySubscribers();
        }
    };
    EmojiState.prototype.dismiss = function () {
        this.queryActive = false;
        this.query = undefined;
        var _a = this, state = _a.state, view = _a.view;
        if (state) {
            var schema = state.schema;
            var tr = state.tr;
            var markType = schema.mark('emojiQuery');
            view.dispatch(tr
                .removeMark(0, state.doc.nodeSize - 2, markType)
                .removeStoredMark(markType));
        }
        this.onDismiss();
        return true;
    };
    EmojiState.prototype.isEnabled = function () {
        var schema = this.state.schema;
        var emojiQuery = schema.marks.emojiQuery;
        return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["y" /* isMarkTypeAllowedInCurrentSelection */])(emojiQuery, this.state);
    };
    EmojiState.prototype.findEmojiQueryMark = function () {
        var state = this.state;
        var doc = state.doc, schema = state.schema, selection = state.selection;
        var to = selection.to, from = selection.from;
        var emojiQuery = schema.marks.emojiQuery;
        var start = from;
        var node = doc.nodeAt(start);
        while (start > 0 && (!node || !emojiQuery.isInSet(node.marks))) {
            start--;
            node = doc.nodeAt(start);
        }
        var end = start;
        if (node && emojiQuery.isInSet(node.marks)) {
            var resolvedPos = doc.resolve(start);
            // -1 is to include : in replacement
            // resolvedPos.depth + 1 to make emoji work inside other blocks e.g. "list item" or "blockquote"
            start = resolvedPos.start(resolvedPos.depth + 1) - 1;
            end = start + node.nodeSize;
        }
        // Emoji inserted via picker
        if (start === 0 && end === 0) {
            start = from;
            end = to;
        }
        return { start: start, end: end };
    };
    EmojiState.prototype.updateEditorFocused = function (focused) {
        this.focused = focused;
        this.notifySubscribers();
    };
    EmojiState.prototype.setView = function (view) {
        this.view = view;
    };
    return EmojiState;
}());

function createPlugin(portalProviderAPI, providerFactory) {
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        state: {
            init: function (config, state) {
                return new EmojiState(state, providerFactory);
            },
            apply: function (tr, pluginState, oldState, newState) {
                // NOTE: Don't call pluginState.update here.
                return pluginState;
            },
        },
        props: {
            nodeViews: {
                emoji: __WEBPACK_IMPORTED_MODULE_3__nodeviews__["a" /* ReactNodeView */].fromComponent(__WEBPACK_IMPORTED_MODULE_4__nodeviews_emoji__["a" /* default */], portalProviderAPI, {
                    providerFactory: providerFactory,
                }),
            },
            handleDOMEvents: {
                focus: function (view, event) {
                    emojiPluginKey.getState(view.state).updateEditorFocused(true);
                    return false;
                },
                blur: function (view, event) {
                    emojiPluginKey.getState(view.state).updateEditorFocused(false);
                    return false;
                },
            },
        },
        key: emojiPluginKey,
        view: function (view) {
            var pluginState = emojiPluginKey.getState(view.state);
            pluginState.setView(view);
            return {
                update: function (view, prevState) {
                    pluginState.update(view.state);
                },
                destroy: function () {
                    providerFactory.unsubscribe('emojiProvider', pluginState.handleProvider);
                },
            };
        },
    });
}
//# sourceMappingURL=main.js.map

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export nodeLen */
/* unused harmony export isIgnorable */
/* unused harmony export isBlockNode */
/* unused harmony export domIndex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return deepEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return removeIgnoredNodesLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return markActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return anyMarkActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return checkFormattingIsPresent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commands_clear_formatting__ = __webpack_require__(452);

var nodeLen = function (node) {
    return node.nodeType === 3 && node.nodeValue
        ? node.nodeValue.length
        : node.childNodes.length;
};
var isIgnorable = function (dom) {
    return dom.pmViewDesc && dom.pmViewDesc.size === 0;
};
var isBlockNode = function (dom) {
    var desc = dom.pmViewDesc;
    return desc && desc.node && desc.node.isBlock;
};
var domIndex = function (node) {
    if (node) {
        for (var index = 0;; index++) {
            node = node.previousSibling;
            if (!node) {
                return index;
            }
        }
    }
};
var deepEqual = function (obj1, obj2) {
    for (var key in obj1) {
        if (obj1[key] !== obj2[key]) {
            return false;
        }
    }
    return true;
};
// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
var removeIgnoredNodesLeft = function (view) {
    var sel = view.root.getSelection();
    var node = sel.anchorNode;
    var offset = sel.anchorOffset;
    var removeNode;
    // TODO: un-ignore it
    // @ts-ignore
    var removeOffset;
    if (!node) {
        return;
    }
    for (;;) {
        if (offset > 0) {
            if (node.nodeType !== 1) {
                // zero-width non-breaking space
                if (node.nodeType === 3 &&
                    node.nodeValue.charAt(offset - 1) === '\ufeff') {
                    removeNode = node;
                    removeOffset = --offset;
                }
                else {
                    break;
                }
            }
            else {
                var before = node.childNodes[offset - 1];
                if (isIgnorable(before)) {
                    removeNode = before;
                    removeOffset = --offset;
                }
                else if (before.nodeType === 3) {
                    node = before;
                    offset = node.nodeValue.length;
                }
                else {
                    break;
                }
            }
        }
        else if (isBlockNode(node)) {
            break;
        }
        else {
            var prev = node.previousSibling;
            while (prev && isIgnorable(prev)) {
                removeNode = node.parentNode;
                removeOffset = domIndex(prev);
                prev = prev.previousSibling;
            }
            if (!prev) {
                node = node.parentNode;
                if (node === view.dom) {
                    break;
                }
                offset = 0;
            }
            else {
                node = prev;
                offset = nodeLen(node);
            }
        }
    }
    if (removeNode) {
        removeNode.parentNode.removeChild(removeNode);
    }
};
var hasCode = function (state, pos) {
    var code = state.schema.marks.code;
    var node = pos >= 0 && state.doc.nodeAt(pos);
    if (node) {
        return !!node.marks.filter(function (mark) { return mark.type === code; }).length;
    }
    return false;
};
/**
 * Determine if a mark (with specific attribute values) exists anywhere in the selection.
 */
var markActive = function (state, mark) {
    var _a = state.selection, from = _a.from, to = _a.to, empty = _a.empty;
    // When the selection is empty, only the active marks apply.
    if (empty) {
        return !!mark.isInSet(state.tr.storedMarks || state.selection.$from.marks());
    }
    // For a non-collapsed selection, the marks on the nodes matter.
    var found = false;
    state.doc.nodesBetween(from, to, function (node) {
        found = found || mark.isInSet(node.marks);
    });
    return found;
};
/**
 * Determine if a mark of a specific type exists anywhere in the selection.
 */
var anyMarkActive = function (state, markType) {
    var _a = state.selection, $from = _a.$from, from = _a.from, to = _a.to, empty = _a.empty;
    if (empty) {
        return !!markType.isInSet(state.storedMarks || $from.marks());
    }
    return state.doc.rangeHasMark(from, to, markType);
};
var blockStylingIsPresent = function (state) {
    var _a = state.selection, from = _a.from, to = _a.to;
    var isBlockStyling = false;
    state.doc.nodesBetween(from, to, function (node, pos) {
        if (__WEBPACK_IMPORTED_MODULE_0__commands_clear_formatting__["b" /* FORMATTING_NODE_TYPES */].indexOf(node.type.name) !== -1) {
            isBlockStyling = true;
            return false;
        }
        return true;
    });
    return isBlockStyling;
};
var marksArePresent = function (state) {
    var activeMarkTypes = __WEBPACK_IMPORTED_MODULE_0__commands_clear_formatting__["a" /* FORMATTING_MARK_TYPES */].filter(function (mark) {
        if (!!state.schema.marks[mark]) {
            var _a = state.selection, $from = _a.$from, empty = _a.empty;
            var marks = state.schema.marks;
            if (empty) {
                return !!marks[mark].isInSet(state.storedMarks || $from.marks());
            }
            if (marks.code && mark === marks.code.name) {
                return markActive(state, marks.code.create());
            }
            return anyMarkActive(state, marks[mark]);
        }
        return false;
    });
    return activeMarkTypes.length > 0;
};
var checkFormattingIsPresent = function (state) {
    return marksArePresent(state) || blockStylingIsPresent(state);
};
//# sourceMappingURL=utils.js.map

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export cardAction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resolveCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return queueCards; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(453);

var cardAction = function (tr, action) {
    return tr.setMeta(__WEBPACK_IMPORTED_MODULE_0__main__["b" /* pluginKey */], action);
};
var resolveCard = function (url) { return function (tr) {
    return cardAction(tr, {
        type: 'RESOLVE',
        url: url,
    });
}; };
var queueCards = function (requests) { return function (tr) {
    return cardAction(tr, {
        type: 'QUEUE',
        requests: requests,
    });
}; };
var setProvider = function (cardProvider) { return function (tr) {
    return cardAction(tr, {
        type: 'SET_PROVIDER',
        provider: cardProvider,
    });
}; };
//# sourceMappingURL=actions.js.map

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorSuccessIcon = function EditorSuccessIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm1.364-10.964l-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var _default = EditorSuccessIcon;
exports.default = _default;

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return stateKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_clipboard__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_drag_drop__ = __webpack_require__(2522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commands__ = __webpack_require__(844);
var _this = this;







var createDOMHandler = function (pred, eventName) { return function (view, event) {
    if (!pred(event)) {
        return false;
    }
    event.preventDefault();
    event.stopPropagation();
    if (Object(__WEBPACK_IMPORTED_MODULE_6__commands__["b" /* startImageUpload */])(event)(view.state, view.dispatch)) {
        __WEBPACK_IMPORTED_MODULE_4__analytics__["a" /* analyticsService */].trackEvent(eventName);
    }
    return true;
}; };
var stateKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('imageUploadPlugin');
var getNewActiveUpload = function (tr, pluginState) {
    var meta = tr.getMeta(stateKey);
    if (meta && meta.name === 'START_UPLOAD') {
        return {
            event: meta.event,
        };
    }
    return pluginState.activeUpload;
};
var createPlugin = function (_a) {
    var dispatch = _a.dispatch, providerFactory = _a.providerFactory;
    var uploadHandler;
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        state: {
            init: function (config, state) {
                return {
                    active: false,
                    enabled: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* canInsertMedia */])(state),
                    hidden: !state.schema.nodes.media || !state.schema.nodes.mediaSingle,
                };
            },
            apply: function (tr, pluginState, oldState, newState) {
                var newActive = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["c" /* isMediaSelected */])(newState);
                var newEnabled = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* canInsertMedia */])(newState);
                var newActiveUpload = getNewActiveUpload(tr, pluginState);
                if (newActive !== pluginState.active ||
                    newEnabled !== pluginState.enabled ||
                    newActiveUpload !== pluginState.activeUpload) {
                    var newPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { active: newActive, enabled: newEnabled, activeUpload: newActiveUpload });
                    dispatch(newPluginState);
                    return newPluginState;
                }
                return pluginState;
            },
        },
        key: stateKey,
        view: function () {
            var handleProvider = function (name, provider) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](_this, void 0, void 0, function () {
                var e_1;
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (name !== 'imageUploadProvider' || !provider) {
                                return [2 /*return*/];
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, provider];
                        case 2:
                            uploadHandler = _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            e_1 = _a.sent();
                            uploadHandler = undefined;
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); };
            providerFactory.subscribe('imageUploadProvider', handleProvider);
            return {
                update: function (view, prevState) {
                    var editorState = view.state;
                    var currentState = stateKey.getState(editorState);
                    // if we've add a new upload to the state, execute the uploadHandler
                    var oldState = stateKey.getState(prevState);
                    if (currentState.activeUpload !== oldState.activeUpload &&
                        currentState.activeUpload &&
                        uploadHandler) {
                        uploadHandler(currentState.activeUpload.event, function (options) {
                            return Object(__WEBPACK_IMPORTED_MODULE_6__commands__["a" /* insertExternalImage */])(options)(view.state, view.dispatch);
                        });
                    }
                },
                destroy: function () {
                    providerFactory.unsubscribe('imageUploadProvider', handleProvider);
                },
            };
        },
        props: {
            handleDOMEvents: {
                drop: createDOMHandler(__WEBPACK_IMPORTED_MODULE_3__utils_drag_drop__["a" /* isDroppedFile */], 'atlassian.editor.image.drop'),
                paste: createDOMHandler(__WEBPACK_IMPORTED_MODULE_2__utils_clipboard__["a" /* isPastedFile */], 'atlassian.editor.image.paste'),
            },
        },
    });
};
//# sourceMappingURL=main.js.map

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ACTIONS */
/* unused harmony export setProvider */
/* unused harmony export setResults */
/* unused harmony export setContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mentionPluginKey; });
/* unused harmony export getMentionPluginState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_mention__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_mention___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_mention__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_mention__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__type_ahead_pm_plugins_main__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__insert_block_ui_ToolbarInsertBlock__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__nodeviews__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_ToolbarMention__ = __webpack_require__(2528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__nodeviews_mention__ = __webpack_require__(2529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__analytics__ = __webpack_require__(2531);















var mentionsPlugin = function (createAnalyticsEvent) {
    var sessionId = __WEBPACK_IMPORTED_MODULE_2_uuid__();
    var fireEvent = function (payload) {
        if (createAnalyticsEvent) {
            if (payload.attributes && !payload.attributes.sessionId) {
                payload.attributes.sessionId = sessionId;
            }
            createAnalyticsEvent(payload).fire(__WEBPACK_IMPORTED_MODULE_5__atlaskit_mention__["a" /* ELEMENTS_CHANNEL */]);
        }
    };
    return {
        nodes: function () {
            return [{ name: 'mention', node: __WEBPACK_IMPORTED_MODULE_6__atlaskit_adf_schema__["W" /* mention */] }];
        },
        pmPlugins: function () {
            return [
                {
                    name: 'mention',
                    plugin: function (_a) {
                        var providerFactory = _a.providerFactory, dispatch = _a.dispatch, portalProviderAPI = _a.portalProviderAPI;
                        return mentionPluginFactory(dispatch, providerFactory, portalProviderAPI, fireEvent);
                    },
                },
            ];
        },
        secondaryToolbarComponent: function (_a) {
            var editorView = _a.editorView, disabled = _a.disabled;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ui_WithPluginState__["a" /* default */], { editorView: editorView, plugins: {
                    typeAheadState: __WEBPACK_IMPORTED_MODULE_9__type_ahead_pm_plugins_main__["d" /* pluginKey */],
                    mentionState: mentionPluginKey,
                }, render: function (_a) {
                    var _b = _a.typeAheadState, typeAheadState = _b === void 0 ? Object(__WEBPACK_IMPORTED_MODULE_9__type_ahead_pm_plugins_main__["b" /* createInitialPluginState */])() : _b, _c = _a.mentionState, mentionState = _c === void 0 ? {} : _c;
                    return !mentionState.provider ? null : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__ui_ToolbarMention__["a" /* default */], { editorView: editorView, isDisabled: disabled || !typeAheadState.isAllowed }));
                } }));
        },
        pluginsOptions: {
            quickInsert: function (_a) {
                var formatMessage = _a.formatMessage;
                return [
                    {
                        title: formatMessage(__WEBPACK_IMPORTED_MODULE_10__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].mention),
                        priority: 400,
                        icon: function () { return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_mention___default.a, { label: formatMessage(__WEBPACK_IMPORTED_MODULE_10__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].mention) }); },
                        action: function (insert, state) {
                            var mark = state.schema.mark('typeAheadQuery', {
                                trigger: '@',
                            });
                            var mentionText = state.schema.text('@', [mark]);
                            return insert(mentionText);
                        },
                    },
                ];
            },
            typeAhead: {
                trigger: '@',
                // Custom regex must have a capture group around trigger
                // so it's possible to use it without needing to scan through all triggers again
                customRegex: '\\(?(@)',
                getItems: function (query, state, intl, _a) {
                    var prevActive = _a.prevActive, queryChanged = _a.queryChanged;
                    if (!prevActive && queryChanged) {
                        __WEBPACK_IMPORTED_MODULE_7__analytics__["a" /* analyticsService */].trackEvent('atlassian.fabric.mention.picker.trigger.shortcut');
                    }
                    var pluginState = getMentionPluginState(state);
                    var mentions = !prevActive && queryChanged ? [] : pluginState.mentions || [];
                    if (queryChanged && pluginState.provider) {
                        pluginState.provider.filter(query || '');
                    }
                    return mentions.map(function (mention) { return ({
                        title: mention.id,
                        render: function (_a) {
                            var isSelected = _a.isSelected, onClick = _a.onClick, onMouseMove = _a.onMouseMove;
                            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__atlaskit_mention__["b" /* MentionItem */], { mention: mention, selected: isSelected, onMouseMove: onMouseMove, onSelection: onClick }));
                        },
                        mention: mention,
                    }); });
                },
                selectItem: function (state, item, insert, _a) {
                    var mode = _a.mode;
                    var pluginState = getMentionPluginState(state);
                    var _b = item.mention, id = _b.id, name = _b.name, nickname = _b.nickname, accessLevel = _b.accessLevel, userType = _b.userType;
                    var renderName = nickname ? nickname : name;
                    var typeAheadPluginState = __WEBPACK_IMPORTED_MODULE_9__type_ahead_pm_plugins_main__["d" /* pluginKey */].getState(state);
                    var pickerElapsedTime = typeAheadPluginState.queryStarted
                        ? Date.now() - typeAheadPluginState.queryStarted
                        : 0;
                    __WEBPACK_IMPORTED_MODULE_7__analytics__["a" /* analyticsService */].trackEvent('atlassian.fabric.mention.picker.insert', __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ mode: mode, isSpecial: Object(__WEBPACK_IMPORTED_MODULE_5__atlaskit_mention__["d" /* isSpecialMention */])(item.mention) || false, accessLevel: accessLevel || '', mentionee: id, duration: pickerElapsedTime, queryLength: (typeAheadPluginState.query || '').length }, pluginState.contextIdentifier));
                    fireEvent(Object(__WEBPACK_IMPORTED_MODULE_14__analytics__["b" /* buildTypeAheadInsertedPayload */])(pickerElapsedTime, typeAheadPluginState.upKeyCount, typeAheadPluginState.downKeyCount, sessionId, mode, item.mention, pluginState.mentions, typeAheadPluginState.query || ''));
                    sessionId = __WEBPACK_IMPORTED_MODULE_2_uuid__();
                    return insert(state.schema.nodes.mention.createChecked({
                        text: "@" + renderName,
                        id: id,
                        accessLevel: accessLevel,
                        userType: userType === 'DEFAULT' ? null : userType,
                    }));
                },
                dismiss: function (state) {
                    var typeAheadPluginState = __WEBPACK_IMPORTED_MODULE_9__type_ahead_pm_plugins_main__["d" /* pluginKey */].getState(state);
                    var pickerElapsedTime = typeAheadPluginState.queryStarted
                        ? Date.now() - typeAheadPluginState.queryStarted
                        : 0;
                    fireEvent(Object(__WEBPACK_IMPORTED_MODULE_14__analytics__["a" /* buildTypeAheadCancelPayload */])(pickerElapsedTime, typeAheadPluginState.upKeyCount, typeAheadPluginState.downKeyCount, sessionId, typeAheadPluginState.query || ''));
                    sessionId = __WEBPACK_IMPORTED_MODULE_2_uuid__();
                },
            },
        },
    };
};
/* harmony default export */ __webpack_exports__["a"] = (mentionsPlugin);
/**
 * Actions
 */
var ACTIONS = {
    SET_PROVIDER: 'SET_PROVIDER',
    SET_RESULTS: 'SET_RESULTS',
    SET_CONTEXT: 'SET_CONTEXT',
};
var setProvider = function (provider) { return function (state, dispatch) {
    if (dispatch) {
        dispatch(state.tr.setMeta(mentionPluginKey, {
            action: ACTIONS.SET_PROVIDER,
            params: { provider: provider },
        }));
    }
    return true;
}; };
var setResults = function (results) { return function (state, dispatch) {
    if (dispatch) {
        dispatch(state.tr.setMeta(mentionPluginKey, {
            action: ACTIONS.SET_RESULTS,
            params: { results: results },
        }));
    }
    return true;
}; };
var setContext = function (context) { return function (state, dispatch) {
    if (dispatch) {
        dispatch(state.tr.setMeta(mentionPluginKey, {
            action: ACTIONS.SET_CONTEXT,
            params: { context: context },
        }));
    }
    return true;
}; };
/**
 *
 * ProseMirror Plugin
 *
 */
var mentionPluginKey = new __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["PluginKey"]('mentionPlugin');
function getMentionPluginState(state) {
    return mentionPluginKey.getState(state);
}
function mentionPluginFactory(dispatch, providerFactory, portalProviderAPI, fireEvent) {
    var mentionProvider;
    return new __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["Plugin"]({
        key: mentionPluginKey,
        state: {
            init: function () {
                return {};
            },
            apply: function (tr, pluginState) {
                var _a = tr.getMeta(mentionPluginKey) || {
                    action: null,
                    params: null,
                }, action = _a.action, params = _a.params;
                var newPluginState = pluginState;
                switch (action) {
                    case ACTIONS.SET_PROVIDER:
                        newPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { provider: params.provider });
                        dispatch(mentionPluginKey, newPluginState);
                        return newPluginState;
                    case ACTIONS.SET_RESULTS:
                        newPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { mentions: params.results });
                        dispatch(mentionPluginKey, newPluginState);
                        return newPluginState;
                    case ACTIONS.SET_CONTEXT:
                        newPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { contextIdentifier: params.context });
                        dispatch(mentionPluginKey, newPluginState);
                        return newPluginState;
                }
                return newPluginState;
            },
        },
        props: {
            nodeViews: {
                mention: __WEBPACK_IMPORTED_MODULE_11__nodeviews__["a" /* ReactNodeView */].fromComponent(__WEBPACK_IMPORTED_MODULE_13__nodeviews_mention__["a" /* default */], portalProviderAPI, { providerFactory: providerFactory }),
            },
        },
        view: function (editorView) {
            var providerHandler = function (name, providerPromise) {
                switch (name) {
                    case 'mentionProvider':
                        if (!providerPromise) {
                            return setProvider(undefined)(editorView.state, editorView.dispatch);
                        }
                        providerPromise
                            .then(function (provider) {
                            if (mentionProvider) {
                                mentionProvider.unsubscribe('mentionPlugin');
                            }
                            // Preload mentions, and populate cache
                            if (provider) {
                                provider.filter('');
                            }
                            mentionProvider = provider;
                            setProvider(provider)(editorView.state, editorView.dispatch);
                            provider.subscribe('mentionPlugin', function (mentions, query, stats) {
                                setResults(mentions)(editorView.state, editorView.dispatch);
                                if (stats && stats.remoteSearch) {
                                    fireEvent(Object(__WEBPACK_IMPORTED_MODULE_14__analytics__["c" /* buildTypeAheadRenderedPayload */])(stats.duration, mentions.map(function (mention) { return mention.id; }), query || ''));
                                }
                            });
                        })
                            .catch(function () {
                            return setProvider(undefined)(editorView.state, editorView.dispatch);
                        });
                        break;
                    case 'contextIdentifierProvider':
                        if (!providerPromise) {
                            return setContext(undefined)(editorView.state, editorView.dispatch);
                        }
                        providerPromise.then(function (provider) {
                            setContext(provider)(editorView.state, editorView.dispatch);
                        });
                        break;
                }
            };
            providerFactory.subscribe('mentionProvider', providerHandler);
            providerFactory.subscribe('contextIdentifierProvider', providerHandler);
            return {
                destroy: function () {
                    if (providerFactory) {
                        providerFactory.unsubscribe('mentionProvider', providerHandler);
                        providerFactory.unsubscribe('contextIdentifierProvider', providerHandler);
                    }
                    if (mentionProvider) {
                        mentionProvider.unsubscribe('mentionPlugin');
                    }
                },
            };
        },
    });
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stateKey */
/* unused harmony export GRID_SIZE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createDisplayGrid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return gridTypeForLayout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__width_index__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__event_dispatcher__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles__ = __webpack_require__(857);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_9__styles__["a"]; });









var stateKey = new __WEBPACK_IMPORTED_MODULE_4_prosemirror_state__["PluginKey"]('gridPlugin');
var GRID_SIZE = 12;
var createDisplayGrid = function (eventDispatcher) {
    var dispatch = Object(__WEBPACK_IMPORTED_MODULE_8__event_dispatcher__["b" /* createDispatch */])(eventDispatcher);
    return function (show, type, highlight) {
        if (highlight === void 0) { highlight = []; }
        return dispatch(stateKey, {
            visible: show,
            gridType: type,
            highlight: highlight,
        });
    };
};
var gridTypeForLayout = function (layout) {
    return layout === 'wrap-left' || layout === 'wrap-right' ? 'wrapped' : 'full';
};
var sides = ['left', 'right'];
var overflowHighlight = function (highlights, side, start, size) {
    if (!highlights.length) {
        return false;
    }
    var minHighlight = highlights.reduce(function (prev, cur) { return Math.min(prev, cur); });
    var maxHighlight = highlights.reduce(function (prev, cur) { return Math.max(prev, cur); });
    if (side === 'left') {
        return (minHighlight < 0 &&
            minHighlight <= -start &&
            (typeof size === 'number' ? minHighlight >= -(start + size) : true));
    }
    else {
        return (maxHighlight > GRID_SIZE &&
            maxHighlight >= GRID_SIZE + start &&
            (typeof size === 'number' ? maxHighlight <= GRID_SIZE + size : true));
    }
};
var gutterGridLines = function (appearance, editorMaxWidth, editorWidth, highlights) {
    var gridLines = [];
    if (appearance !== 'full-page') {
        return gridLines;
    }
    var wideSpacing = (editorMaxWidth * __WEBPACK_IMPORTED_MODULE_5__atlaskit_editor_common__["D" /* breakoutWideScaleRatio */] - editorMaxWidth) / 2;
    sides.forEach(function (side) {
        var _a, _b;
        gridLines.push(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: side, className: __WEBPACK_IMPORTED_MODULE_2_classnames__('gridLine', overflowHighlight(highlights, side, 0, 4) ? 'highlight' : ''), style: (_a = { position: 'absolute' }, _a[side] = "-" + wideSpacing + "px", _a) }));
        gridLines.push(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: side + '-bk', className: __WEBPACK_IMPORTED_MODULE_2_classnames__('gridLine', highlights.indexOf('full-width') > -1 ? 'highlight' : ''), style: (_b = {
                    position: 'absolute'
                },
                _b[side] = "-" + (editorWidth - editorMaxWidth - __WEBPACK_IMPORTED_MODULE_5__atlaskit_editor_common__["k" /* akEditorBreakoutPadding */]) /
                    2 + "px",
                _b) }));
    });
    return gridLines;
};
var lineLengthGridLines = function (highlights) {
    var gridLines = [];
    var gridSpacing = 100 / GRID_SIZE;
    for (var i = 0; i <= GRID_SIZE; i++) {
        var style = {
            paddingLeft: gridSpacing + "%",
        };
        gridLines.push(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: i, className: __WEBPACK_IMPORTED_MODULE_2_classnames__('gridLine', highlights.indexOf(i) > -1 ? 'highlight' : ''), style: i < GRID_SIZE ? style : undefined }));
    }
    return gridLines;
};
var Grid = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Grid, _super);
    function Grid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Grid.prototype.render = function () {
        var _a = this.props, highlight = _a.highlight, appearance = _a.appearance, theme = _a.theme, containerElement = _a.containerElement, editorWidth = _a.editorWidth, gridType = _a.gridType, visible = _a.visible;
        var editorMaxWidth = theme.layoutMaxWidth;
        var gridLines = __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](lineLengthGridLines(highlight), gutterGridLines(appearance, editorMaxWidth, editorWidth, highlight));
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "gridParent" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__('gridContainer', gridType, !visible ? 'hidden' : ''), style: {
                    height: containerElement.scrollHeight + "px",
                } }, gridLines)));
    };
    return Grid;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
var ThemedGrid = Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["withTheme"])(Grid);
var gridPlugin = {
    contentComponent: function (_a) {
        var editorView = _a.editorView, appearance = _a.appearance;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ui_WithPluginState__["a" /* default */], { plugins: {
                grid: stateKey,
                widthState: __WEBPACK_IMPORTED_MODULE_6__width_index__["b" /* pluginKey */],
            }, render: function (_a) {
                var grid = _a.grid, _b = _a.widthState, widthState = _b === void 0 ? { width: __WEBPACK_IMPORTED_MODULE_5__atlaskit_editor_common__["p" /* akEditorFullPageMaxWidth */] } : _b;
                if (!grid) {
                    return null;
                }
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ThemedGrid, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ appearance: appearance, editorWidth: widthState.width, containerElement: editorView.dom }, grid)));
            } }));
    },
};
/* harmony default export */ __webpack_exports__["c"] = (gridPlugin);

//# sourceMappingURL=index.js.map

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isDecision; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isServiceDecision; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isServiceTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isDateSortCriteria; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return toObjectKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return toRendererContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return objectKeyToString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return toggleTaskState; });
var isDecision = function (item) {
    return !!(item && item.type === 'DECISION');
};
var isTask = function (item) {
    return !!(item && item.type === 'TASK');
};
var isServiceDecision = function (item) {
    return !!(item && item.type === 'DECISION');
};
var isServiceTask = function (item) {
    return !!(item && item.type === 'TASK');
};
var isDateSortCriteria = function (sortCriteria) {
    return !sortCriteria ||
        sortCriteria === 'creationDate' ||
        sortCriteria === 'lastUpdateDate';
};
var toObjectKey = function (item) {
    var containerAri = item.containerAri, localId = item.localId, objectAri = item.objectAri;
    return {
        containerAri: containerAri,
        localId: localId,
        objectAri: objectAri,
    };
};
var toRendererContext = function (item) {
    var containerAri = item.containerAri, objectAri = item.objectAri;
    return {
        containerAri: containerAri,
        objectAri: objectAri,
    };
};
var objectKeyToString = function (objectKey) {
    var containerAri = objectKey.containerAri, objectAri = objectKey.objectAri, localId = objectKey.localId;
    return containerAri + ":" + objectAri + ":" + localId;
};
var toggleTaskState = function (state) {
    return state === 'DONE' ? 'TODO' : 'DONE';
};
//# sourceMappingURL=type-helpers.js.map

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DropdownItem__ = __webpack_require__(2809);
/* unused harmony reexport Addon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dropdown__ = __webpack_require__(2811);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__Dropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClickAreaInline__ = __webpack_require__(2813);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__ClickAreaInline__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ClickAreaBlock__ = __webpack_require__(2814);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__ClickAreaBlock__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddonToolbar__ = __webpack_require__(2815);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__AddonToolbar__["a"]; });





//# sourceMappingURL=index.js.map

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__ = __webpack_require__(3);




var pulseBackground = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["keyframes"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  50% {\n    background-color: ", ";\n  }\n"], ["\n  50% {\n    background-color: ", ";\n  }\n"])), __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].R100);
var pulseBackgroundReverse = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["keyframes"])(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  0% {\n    background-color: ", ";\n  }\n  50% {\n    background-color: auto;\n  }\n  100% {\n    background-color: ", ";\n  }\n"], ["\n  0% {\n    background-color: ", ";\n  }\n  50% {\n    background-color: auto;\n  }\n  100% {\n    background-color: ", ";\n  }\n"])), __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].R100, __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].R100);
var Wrapper = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  &.-flash > div {\n    animation: 0.25s ease-in-out ", ";\n  }\n\n  & > div {\n    animation: ", ";\n  }\n"], ["\n  &.-flash > div {\n    animation: 0.25s ease-in-out ", ";\n  }\n\n  & > div {\n    animation: ",
    ";\n  }\n"])), pulseBackgroundReverse, function (props) {
    return props.animate ? ".25s ease-in-out " + pulseBackground : 'none';
});
var WithFlash = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WithFlash, _super);
    function WithFlash() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toggle = false;
        return _this;
    }
    WithFlash.prototype.render = function () {
        var _a = this.props, animate = _a.animate, children = _a.children;
        this.toggle = animate && !this.toggle;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Wrapper, { className: this.toggle ? '-flash' : '', animate: animate }, children));
    };
    return WithFlash;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (WithFlash);
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WikiMarkupTransformer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__encoder__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parser_abstract_tree__ = __webpack_require__(2857);



var WikiMarkupTransformer = /** @class */ (function () {
    function WikiMarkupTransformer(schema) {
        if (schema === void 0) { schema = __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["x" /* defaultSchema */]; }
        this.schema = schema;
    }
    WikiMarkupTransformer.prototype.encode = function (node) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__encoder__["a" /* encode */])(node);
    };
    WikiMarkupTransformer.prototype.parse = function (wikiMarkup, tokenErrCallback) {
        var tree = new __WEBPACK_IMPORTED_MODULE_2__parser_abstract_tree__["a" /* default */](this.schema, wikiMarkup);
        return tree.getProseMirrorModel(tokenErrCallback);
    };
    return WikiMarkupTransformer;
}());

/* unused harmony default export */ var _unused_webpack_default_export = (WikiMarkupTransformer);
//# sourceMappingURL=index.js.map

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = parseMacroKeyword;
/* harmony export (immutable) */ __webpack_exports__["c"] = parseOtherKeyword;
/* harmony export (immutable) */ __webpack_exports__["a"] = parseLeadingKeyword;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emoji__ = __webpack_require__(892);



var macroKeywordTokenMap = [
    {
        type: __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].ADF_MACRO,
        regex: /^{adf/i,
    },
    {
        type: __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].ANCHOR_MACRO,
        regex: /^{anchor/i,
    },
    {
        type: __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].CODE_MACRO,
        regex: /^{code/i,
    },
    {
        type: __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].QUOTE_MACRO,
        regex: /^{quote/i,
    },
    {
        type: __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].NOFORMAT_MACRO,
        regex: /^{noformat/i,
    },
    {
        type: __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].PANEL_MACRO,
        regex: /^{panel/i,
    },
    {
        type: __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].COLOR_MACRO,
        regex: /^{color/,
    },
    {
        type: __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].LOREM_MACRO,
        regex: /^{loremipsum/i,
    },
];
/**
 * The order of this mapping determind which keyword
 * will be checked first, so it matters.
 */
var keywordTokenMap = {
    '[': __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].LINK_FORMAT,
    http: __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].LINK_TEXT,
    irc: __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].LINK_TEXT,
    mailto: __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].LINK_TEXT,
    '\\\\': __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].FORCE_LINE_BREAK,
    '\r': __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].HARD_BREAK,
    '\n': __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].HARD_BREAK,
    '\r\n': __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].HARD_BREAK,
    '!': __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].MEDIA,
    '----': __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].QUADRUPLE_DASH_SYMBOL,
    '---': __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].TRIPLE_DASH_SYMBOL,
    '--': __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].DOUBLE_DASH_SYMBOL,
    '-': __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].DELETED,
    '+': __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].INSERTED,
    '*': __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].STRONG,
    '^': __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].SUPERSCRIPT,
    '~': __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].SUBSCRIPT,
    _: __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].EMPHASIS,
    '{{': __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].MONOSPACE,
    '??': __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].CITATION,
};
function parseMacroKeyword(input) {
    var e_1, _a;
    try {
        for (var macroKeywordTokenMap_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](macroKeywordTokenMap), macroKeywordTokenMap_1_1 = macroKeywordTokenMap_1.next(); !macroKeywordTokenMap_1_1.done; macroKeywordTokenMap_1_1 = macroKeywordTokenMap_1.next()) {
            var keyword = macroKeywordTokenMap_1_1.value;
            if (keyword.regex.test(input)) {
                return {
                    type: keyword.type,
                };
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (macroKeywordTokenMap_1_1 && !macroKeywordTokenMap_1_1.done && (_a = macroKeywordTokenMap_1.return)) _a.call(macroKeywordTokenMap_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return null;
}
function parseOtherKeyword(input) {
    var e_2, _a, e_3, _b;
    for (var name_1 in keywordTokenMap) {
        if (keywordTokenMap.hasOwnProperty(name_1) && input.startsWith(name_1)) {
            return {
                type: keywordTokenMap[name_1],
            };
        }
    }
    // Look for a emoji
    var char = input.charAt(0);
    if ([':', '(', ';'].indexOf(char) !== -1) {
        try {
            for (var EMOJIS_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](__WEBPACK_IMPORTED_MODULE_2__emoji__["a" /* EMOJIS */]), EMOJIS_1_1 = EMOJIS_1.next(); !EMOJIS_1_1.done; EMOJIS_1_1 = EMOJIS_1.next()) {
                var emoji = EMOJIS_1_1.value;
                try {
                    for (var _c = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](emoji.markup), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var text = _d.value;
                        if (input.startsWith(text)) {
                            return {
                                type: __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].EMOJI,
                            };
                        }
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (EMOJIS_1_1 && !EMOJIS_1_1.done && (_a = EMOJIS_1.return)) _a.call(EMOJIS_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
    return null;
}
/**
 * These keywords only take effect when it's at the
 * beginning of the line
 * The order of the mapping matters. We should not put
 * LIST in front of RULER for example.
 */
var leadingKeywordTokenMap = [
    {
        type: __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].QUOTE,
        regex: /^bq\./,
    },
    {
        type: __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].HEADING,
        regex: /^h[1-6]\./,
    },
    {
        type: __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].RULER,
        regex: /^-{4,5}(\s|$)/,
    },
    {
        type: __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].TRIPLE_DASH_SYMBOL,
        regex: /^-{3}\s/,
    },
    {
        type: __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].DOUBLE_DASH_SYMBOL,
        regex: /^-{2}\s/,
    },
    {
        type: __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].LIST,
        regex: /^([*#]+|-) /,
    },
    {
        type: __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].TABLE,
        regex: /^\|{1,2}/,
    },
];
function parseLeadingKeyword(input) {
    var e_4, _a;
    try {
        for (var leadingKeywordTokenMap_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](leadingKeywordTokenMap), leadingKeywordTokenMap_1_1 = leadingKeywordTokenMap_1.next(); !leadingKeywordTokenMap_1_1.done; leadingKeywordTokenMap_1_1 = leadingKeywordTokenMap_1.next()) {
            var keyword = leadingKeywordTokenMap_1_1.value;
            if (keyword.regex.test(input)) {
                return {
                    type: keyword.type,
                };
            }
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (leadingKeywordTokenMap_1_1 && !leadingKeywordTokenMap_1_1.done && (_a = leadingKeywordTokenMap_1.return)) _a.call(leadingKeywordTokenMap_1);
        }
        finally { if (e_4) throw e_4.error; }
    }
    return null;
}
//# sourceMappingURL=keyword.js.map

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(168);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["l"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_table__ = __webpack_require__(2904);
/* unused harmony reexport tableSharedStyle */
/* unused harmony reexport tableMarginTop */
/* unused harmony reexport tableMarginBottom */
/* unused harmony reexport tableMarginSides */
/* unused harmony reexport tableCellMinWidth */
/* unused harmony reexport calcTableWidth */
/* unused harmony reexport TableSharedCssClassName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_column_layout__ = __webpack_require__(2905);
/* unused harmony reexport columnLayoutSharedStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_media_single__ = __webpack_require__(2906);
/* unused harmony reexport mediaSingleSharedStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_blockquote__ = __webpack_require__(2907);
/* unused harmony reexport blockquoteSharedStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_headings__ = __webpack_require__(2908);
/* unused harmony reexport headingsSharedStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_panel__ = __webpack_require__(894);
/* unused harmony reexport panelSharedStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_rule__ = __webpack_require__(2909);
/* unused harmony reexport ruleSharedStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_paragraph__ = __webpack_require__(2910);
/* unused harmony reexport paragraphSharedStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_link__ = __webpack_require__(2911);
/* unused harmony reexport linkSharedStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_indentation__ = __webpack_require__(2912);
/* unused harmony reexport indentationSharedStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_block_marks__ = __webpack_require__(2913);
/* unused harmony reexport blockMarksSharedStyles */












//# sourceMappingURL=index.js.map

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(169);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_0__consts__["p"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_table__ = __webpack_require__(2977);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_1__shared_table__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_1__shared_table__["d"]; });
/* unused harmony reexport tableMarginBottom */
/* unused harmony reexport tableMarginSides */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_1__shared_table__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_1__shared_table__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__shared_table__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_column_layout__ = __webpack_require__(2978);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_2__shared_column_layout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_media_single__ = __webpack_require__(2979);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_3__shared_media_single__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_blockquote__ = __webpack_require__(2980);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_4__shared_blockquote__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_headings__ = __webpack_require__(2981);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_5__shared_headings__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_panel__ = __webpack_require__(918);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_6__shared_panel__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_rule__ = __webpack_require__(2982);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_7__shared_rule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_paragraph__ = __webpack_require__(2983);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_8__shared_paragraph__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_link__ = __webpack_require__(2984);
/* unused harmony reexport linkSharedStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_indentation__ = __webpack_require__(2985);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_10__shared_indentation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_block_marks__ = __webpack_require__(2986);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_11__shared_block_marks__["a"]; });












//# sourceMappingURL=index.js.map

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RendererCssClassName; });
var clPrefix = 'ak-renderer-';
var RendererCssClassName = {
    DOCUMENT: clPrefix + "document",
    EXTENSION: clPrefix + "extension",
    NUMBER_COLUMN: clPrefix + "table-number-column",
};
//# sourceMappingURL=consts.js.map

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var refractorC = __webpack_require__(137)
module.exports = cpp
cpp.displayName = 'cpp'
cpp.aliases = []
function cpp(Prism) {
  Prism.register(refractorC)
  Prism.languages.cpp = Prism.languages.extend('c', {
    keyword: /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|class|compl|const|constexpr|const_cast|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|float|for|friend|goto|if|inline|int|int8_t|int16_t|int32_t|int64_t|uint8_t|uint16_t|uint32_t|uint64_t|long|mutable|namespace|new|noexcept|nullptr|operator|private|protected|public|register|reinterpret_cast|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/,
    boolean: /\b(?:true|false)\b/,
    operator: /--?|\+\+?|!=?|<{1,2}=?|>{1,2}=?|->|:{1,2}|={1,2}|\^|~|%|&{1,2}|\|\|?|\?|\*|\/|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/
  })
  Prism.languages.insertBefore('cpp', 'keyword', {
    'class-name': {
      pattern: /(class\s+)\w+/i,
      lookbehind: true
    }
  })
  Prism.languages.insertBefore('cpp', 'string', {
    'raw-string': {
      pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
      alias: 'string',
      greedy: true
    }
  })
}


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = ruby
ruby.displayName = 'ruby'
ruby.aliases = []
function ruby(Prism) {
  /**
   * Original by Samuel Flores
   *
   * Adds the following new token classes:
   *      constant, builtin, variable, symbol, regex
   */
  ;(function(Prism) {
    Prism.languages.ruby = Prism.languages.extend('clike', {
      comment: [
        /#.*/,
        {
          pattern: /^=begin(?:\r?\n|\r)(?:.*(?:\r?\n|\r))*?=end/m,
          greedy: true
        }
      ],
      keyword: /\b(?:alias|and|BEGIN|begin|break|case|class|def|define_method|defined|do|each|else|elsif|END|end|ensure|false|for|if|in|module|new|next|nil|not|or|protected|private|public|raise|redo|require|rescue|retry|return|self|super|then|throw|true|undef|unless|until|when|while|yield)\b/
    })
    var interpolation = {
      pattern: /#\{[^}]+\}/,
      inside: {
        delimiter: {
          pattern: /^#\{|\}$/,
          alias: 'tag'
        },
        rest: Prism.languages.ruby
      }
    }
    Prism.languages.insertBefore('ruby', 'keyword', {
      regex: [
        {
          pattern: /%r([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1[gim]{0,3}/,
          greedy: true,
          inside: {
            interpolation: interpolation
          }
        },
        {
          pattern: /%r\((?:[^()\\]|\\[\s\S])*\)[gim]{0,3}/,
          greedy: true,
          inside: {
            interpolation: interpolation
          }
        },
        {
          // Here we need to specifically allow interpolation
          pattern: /%r\{(?:[^#{}\\]|#(?:\{[^}]+\})?|\\[\s\S])*\}[gim]{0,3}/,
          greedy: true,
          inside: {
            interpolation: interpolation
          }
        },
        {
          pattern: /%r\[(?:[^\[\]\\]|\\[\s\S])*\][gim]{0,3}/,
          greedy: true,
          inside: {
            interpolation: interpolation
          }
        },
        {
          pattern: /%r<(?:[^<>\\]|\\[\s\S])*>[gim]{0,3}/,
          greedy: true,
          inside: {
            interpolation: interpolation
          }
        },
        {
          pattern: /(^|[^/])\/(?!\/)(\[.+?]|\\.|[^/\\\r\n])+\/[gim]{0,3}(?=\s*($|[\r\n,.;})]))/,
          lookbehind: true,
          greedy: true
        }
      ],
      variable: /[@$]+[a-zA-Z_]\w*(?:[?!]|\b)/,
      symbol: {
        pattern: /(^|[^:]):[a-zA-Z_]\w*(?:[?!]|\b)/,
        lookbehind: true
      }
    })
    Prism.languages.insertBefore('ruby', 'number', {
      builtin: /\b(?:Array|Bignum|Binding|Class|Continuation|Dir|Exception|FalseClass|File|Stat|Fixnum|Float|Hash|Integer|IO|MatchData|Method|Module|NilClass|Numeric|Object|Proc|Range|Regexp|String|Struct|TMS|Symbol|ThreadGroup|Thread|Time|TrueClass)\b/,
      constant: /\b[A-Z]\w*(?:[?!]|\b)/
    })
    Prism.languages.ruby.string = [
      {
        pattern: /%[qQiIwWxs]?([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/,
        greedy: true,
        inside: {
          interpolation: interpolation
        }
      },
      {
        pattern: /%[qQiIwWxs]?\((?:[^()\\]|\\[\s\S])*\)/,
        greedy: true,
        inside: {
          interpolation: interpolation
        }
      },
      {
        // Here we need to specifically allow interpolation
        pattern: /%[qQiIwWxs]?\{(?:[^#{}\\]|#(?:\{[^}]+\})?|\\[\s\S])*\}/,
        greedy: true,
        inside: {
          interpolation: interpolation
        }
      },
      {
        pattern: /%[qQiIwWxs]?\[(?:[^\[\]\\]|\\[\s\S])*\]/,
        greedy: true,
        inside: {
          interpolation: interpolation
        }
      },
      {
        pattern: /%[qQiIwWxs]?<(?:[^<>\\]|\\[\s\S])*>/,
        greedy: true,
        inside: {
          interpolation: interpolation
        }
      },
      {
        pattern: /("|')(?:#\{[^}]+\}|\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true,
        inside: {
          interpolation: interpolation
        }
      }
    ]
  })(Prism)
}


/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isTab;
/* harmony export (immutable) */ __webpack_exports__["c"] = isTabPanel;
/* harmony export (immutable) */ __webpack_exports__["b"] = isTabList;
function isTab(el) {
  return el.type && el.type.tabsRole === 'Tab';
}
function isTabPanel(el) {
  return el.type && el.type.tabsRole === 'TabPanel';
}
function isTabList(el) {
  return el.type && el.type.tabsRole === 'TabList';
}

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FLATTENED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_THEME_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return THEME_MODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return borderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return gridSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return fontSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return fontSizeSmall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fontFamily; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return codeFontFamily; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return focusRing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return noFocusRing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return layers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return assistive; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colors__ = __webpack_require__(172);


var FLATTENED = '__FLATTENED__';
var CHANNEL = '__ATLASKIT_THEME__';
var DEFAULT_THEME_MODE = 'light';
var THEME_MODES = ['light', 'dark'];
/*
  These theme values are expressed as functions so that if we decide to make
  them dependent on props in the future, it wouldn't require a significant
  refactor everywhere they are being used.
*/

var borderRadius = function borderRadius() {
  return 3;
};
var gridSize = function gridSize() {
  return 8;
};
var fontSize = function fontSize() {
  return 14;
};
var fontSizeSmall = function fontSizeSmall() {
  return 11;
};
var fontFamily = function fontFamily() {
  return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var codeFontFamily = function codeFontFamily() {
  return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var focusRing = function focusRing() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__colors__["B100"];
  var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : gridSize() / 4;
  return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var noFocusRing = function noFocusRing() {
  return "\n  box-shadow: none;\n";
};
var layers = {
  card: function card() {
    return 100;
  },
  dialog: function dialog() {
    return 300;
  },
  navigation: function navigation() {
    return 200;
  },
  layer: function layer() {
    return 400;
  },
  blanket: function blanket() {
    return 500;
  },
  modal: function modal() {
    return 510;
  },
  flag: function flag() {
    return 600;
  },
  spotlight: function spotlight() {
    return 700;
  },
  tooltip: function tooltip() {
    return 800;
  }
};
var assistive = function assistive() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  border: 0 !important;\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  height: 1px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  width: 1px !important;\n  white-space: nowrap !important;\n"]);
};

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__copyArray_js__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stringToPath_js__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toString_js__ = __webpack_require__(1301);








/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(value, __WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */]);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_1__copyArray_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toString_js__["a" /* default */])(value)));
}

/* harmony default export */ __webpack_exports__["a"] = (toPath);


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(126);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(139);


/* Built-in method references that are verified to be native. */
var nativeCreate = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'create');

/* harmony default export */ __webpack_exports__["a"] = (nativeCreate);


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__ = __webpack_require__(3224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__ = __webpack_require__(3225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__ = __webpack_require__(3226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__ = __webpack_require__(3227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__ = __webpack_require__(3228);






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__["a" /* default */];
ListCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__["a" /* default */];
ListCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__["a" /* default */];
ListCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__["a" /* default */];
ListCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (ListCache);


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(239);


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (assocIndexOf);


/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isKeyable_js__ = __webpack_require__(3230);


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return Object(__WEBPACK_IMPORTED_MODULE_0__isKeyable_js__["a" /* default */])(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ __webpack_exports__["a"] = (getMapData);


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__ = __webpack_require__(3237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(126);



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && !Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(other))) {
    return value !== value && other !== other;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__["a" /* default */])(value, other, bitmask, customizer, baseIsEqual, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqual);


/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__ = __webpack_require__(3259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(126);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = Object(__WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */])(function() { return arguments; }()) ? __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */] : function(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__(3260);



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(149)(module)))

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__ = __webpack_require__(3261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(3262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(3263);




/* Node.js helper references. */
var nodeIsTypedArray = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsTypedArray) : __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isTypedArray);


/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/* harmony default export */ __webpack_exports__["a"] = (isPrototype);


/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(1309);


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */]) {
    Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssignValue);


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TextInput__ = __webpack_require__(3367);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__TextInput__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NumericInput__ = __webpack_require__(3368);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__NumericInput__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Checkbox__ = __webpack_require__(3369);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Checkbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Select__ = __webpack_require__(3370);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__Select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SaveButton__ = __webpack_require__(3371);
/* unused harmony reexport SaveButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Label__ = __webpack_require__(3372);
/* unused harmony reexport Label */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WikiInput__ = __webpack_require__(3373);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__WikiInput__["a"]; });


/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/comment","version":"6.0.30","sideEffects":false}

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_media_store__ = __webpack_require__(335);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__atlaskit_media_store__["c"]; });
/* unused harmony reexport isAsapBasedAuth */
/* unused harmony reexport UploadController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_context__ = __webpack_require__(1870);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__context_context__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1887);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__utils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fileState__ = __webpack_require__(397);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getMediaTypeFromMimeType__ = __webpack_require__(701);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__utils_getMediaTypeFromMimeType__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context_fileStreamCache__ = __webpack_require__(398);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__context_fileStreamCache__["a"]; });






//# sourceMappingURL=index.js.map

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(658);
var bytesToUuid = __webpack_require__(659);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return selected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return selectOnHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return emojiSprite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return emojiNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return deleteButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return emoji; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return emojiContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return placeholder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return placeholderContainer; });
/* unused harmony export placeholderEmoji */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return emojiButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return buttons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return preview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return previewImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return previewText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return name; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return shortName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return previewSingleLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return toneSelectorContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return withToneSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return emojiPreviewSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return emojiPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return emojiScrollable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return emojiUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return uploadChooseFileMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return emojiUploadBottom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return uploadChooseFileRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return uploadChooseFileEmojiName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return uploadChooseFileBrowse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return uploadPreviewFooter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return uploadPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return uploadPreviewText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bigEmojiPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return uploadAddRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddCustomEmoji; });
/* unused harmony export submitDelete */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return previewButtonGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return deletePreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return deleteText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return deleteFooter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return emojiDeleteErrorMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return emojiChooseFileErrorMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return emojiPreviewErrorMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addCustomEmojiButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return uploadRetryButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return uploadEmojiButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return cancelButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return buttonSpinner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_styles__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_typestyle__ = __webpack_require__(142);
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;




var selected = 'emoji-common-selected';
var selectOnHover = 'emoji-common-select-on-hover';
var emojiSprite = 'emoji-common-emoji-sprite';
var emojiNode = 'emoji-common-node';
var deleteButton = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    // hide by default
    visibility: 'hidden',
    display: 'flex',
    height: '0px',
    // 40px emoji width with 2px left offset
    width: '38px',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    // vertically align button and prevent emoji offset
    paddingTop: '4px',
    marginBottom: '-4px',
});
var emoji = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    borderRadius: '5px',
    backgroundColor: 'transparent',
    display: 'inline-block',
    verticalAlign: 'middle',
    // Ensure along with vertical align middle, we don't increase the line height for p and some
    // headings. Smaller headings get a slight increase in height, cannot add more negative margin
    // as a "selected" emoji (e.g. in the editor) will not look good.
    margin: '-1px 0',
    $nest: (_a = {},
        _a["&." + selected + ",&." + selectOnHover + ":hover"] = {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_2__shared_styles__["a" /* akEmojiSelectedBackgroundColor */],
        },
        _a["&." + selected + ",&." + selectOnHover + ":hover ." + deleteButton] = {
            // show delete button on hover
            visibility: 'visible',
        },
        _a.img = {
            display: 'block',
        },
        _a),
});
var emojiContainer = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'inline-block',
    // Ensure along with vertical align middle, we don't increase the line height for h1..h6, and p
    margin: '-1px 0',
    $nest: (_b = {},
        _b["&." + selected + ",&." + selectOnHover + ":hover"] = {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_2__shared_styles__["a" /* akEmojiSelectedBackgroundColor */],
        },
        _b["." + emojiSprite] = {
            background: 'transparent no-repeat',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* defaultEmojiHeight */] + "px",
            width: __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* defaultEmojiHeight */] + "px",
        },
        _b),
});
var placeholder = 'emoji-common-placeholder';
var placeholderContainer = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    // Ensure no vertical reflow
    margin: '-1px 0',
    display: 'inline-block',
    background: '#f7f7f7',
    borderRadius: '20%',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
});
var placeholderEmoji = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'inline-block',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
});
var emojiButton = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    backgroundColor: 'transparent',
    border: '0',
    cursor: 'pointer',
    padding: 0,
    $nest: (_c = {},
        /* Firefox */
        _c['&::-moz-focus-inner'] = {
            border: '0 none',
            padding: 0,
        },
        _c['&>span'] = {
            borderRadius: '5px',
            padding: '8px',
            $nest: (_d = {},
                // Scale sprite to fit regardless of default emoji size
                _d["&>." + emojiSprite] = {
                    height: '24px',
                    width: '24px',
                },
                _d),
        },
        _c),
});
// Emoji Preview
var buttons = 'emoji-common-buttons';
var preview = 'emoji-common-preview';
var previewImg = 'emoji-common-preview-image';
var previewText = 'emoji-common-preview-text';
var name = 'emoji-common-name';
var shortName = 'emoji-common-shortname';
var previewSingleLine = 'emoji-common-preview-single-line';
var toneSelectorContainer = 'emoji-common-tone-selector-container';
var withToneSelector = 'emoji-common-with-tone-selector';
var emojiPreviewSection = 'emoji-preview-section';
var emojiPreview = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    height: '50px',
    boxSizing: 'border-box',
    $nest: (_e = {},
        _e["." + preview] = {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            padding: '10px',
            $nest: (_f = {},
                _f["." + emojiSprite] = {
                    height: '32px',
                    margin: '0',
                    width: '32px',
                },
                _f["." + previewImg] = {
                    display: 'inline-block',
                    flex: 'initial',
                    width: '32px',
                    $nest: {
                        '&>span': {
                            width: '32px',
                            height: '32px',
                            padding: 0,
                            maxHeight: 'inherit',
                            $nest: {
                                '&>img': {
                                    position: 'relative',
                                    left: '50%',
                                    top: '50%',
                                    transform: 'translateX(-50%) translateY(-50%)',
                                    maxHeight: '32px',
                                    maxWidth: '32px',
                                    padding: 0,
                                    display: 'block',
                                },
                            },
                        },
                    },
                },
                _f["." + previewText] = {
                    display: 'flex',
                    flexDirection: 'column',
                    marginLeft: '10px',
                    marginTop: '-2px',
                    maxWidth: '285px',
                    width: '285px' /* IE */,
                    flexGrow: 1,
                    flexShrink: 1,
                    $nest: (_g = {},
                        _g["." + name] = {
                            display: 'block',
                            color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N900,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            $nest: (_h = {},
                                _h['&:first-letter'] = {
                                    textTransform: 'uppercase',
                                },
                                _h),
                        },
                        _g["." + shortName] = {
                            display: 'block',
                            color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N200,
                            fontSize: '12px',
                            lineHeight: 1,
                            marginBottom: '-2px',
                            overflow: 'hidden',
                            paddingBottom: '2px',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        },
                        _g),
                },
                _f["." + previewSingleLine] = {
                    paddingTop: '10px',
                    $nest: (_j = {},
                        _j["." + name] = {
                            display: 'none',
                        },
                        _j["." + shortName] = {
                            color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N900,
                            fontSize: '14px',
                        },
                        _j),
                },
                _f),
        },
        _e["." + buttons] = {
            flex: 1,
            textAlign: 'right',
            margin: '6px',
        },
        _e["." + toneSelectorContainer] = {
            flex: 1,
            textAlign: 'right',
            margin: '6px',
        },
        _e["." + withToneSelector + " ." + previewText] = {
            maxWidth: '235px',
            width: '235px' /* IE */,
        },
        _e),
});
// Scrollable
var emojiScrollable = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    border: '1px solid #fff',
    borderRadius: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["borderRadius"])() + "px",
    display: 'block',
    margin: '0',
    overflowX: 'hidden',
    overflowY: 'auto',
    padding: '0',
});
// EmojiUpload
var emojiUpload = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    height: '78px',
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
});
var uploadChooseFileMessage = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N300,
    fontSize: '12px',
    paddingBottom: '7px',
});
var emojiUploadBottom = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    fontSize: '11px',
});
var uploadChooseFileRow = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    justifyContent: 'space-between',
});
var uploadChooseFileEmojiName = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    flex: '1 1 auto',
    marginRight: '5px',
    $nest: {
        input: {
            background: 'transparent',
            border: 0,
            fontSize: '12px',
            outline: 'none',
            width: '100%',
            height: '22px',
            $nest: (_k = {},
                _k['&:invalid'] = {
                    boxShadow: 'none',
                },
                _k['&::-ms-clear'] = {
                    display: 'none',
                },
                _k),
        },
    },
});
var uploadChooseFileBrowse = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    flex: '0 0 auto',
});
var uploadPreviewFooter = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    flexDirection: 'column',
    height: '100px',
    padding: '10px',
});
var uploadPreview = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20,
    borderRadius: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["borderRadius"])() + "px",
    padding: '10px',
});
var uploadPreviewText = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    $nest: {
        h5: {
            color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N300,
            paddingBottom: '4px',
            fontSize: '12px',
        },
        img: {
            maxHeight: '20px',
            maxWidth: '50px',
        },
    },
});
var bigEmojiPreview = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    paddingLeft: '4px',
    $nest: {
        img: {
            maxHeight: '40px',
            maxWidth: '100px',
        },
    },
});
var uploadAddRow = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingTop: '10px',
});
var AddCustomEmoji = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    alignSelf: 'center',
    marginLeft: '10px',
});
// Emoji Delete preview
var submitDelete = 'emoji-submit-delete';
var previewButtonGroup = 'emoji-preview-button-group';
var deletePreview = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    height: '100px',
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    fontSize: '12px',
});
var deleteText = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    height: '64px',
    $nest: {
        ':first-child': {
            color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N300,
            lineHeight: '16px',
        },
    },
});
var deleteFooter = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    height: '40px',
    alignItems: 'center',
    justifyContent: 'space-between',
    $nest: (_l = {
            img: {
                maxHeight: '32px',
                maxWidth: '72px',
            }
        },
        _l["." + previewButtonGroup] = {
            display: 'flex',
        },
        _l["." + submitDelete] = {
            width: '84px',
            fontWeight: 'bold',
            marginRight: '4px',
        },
        _l.button = {
            display: 'flex',
            justifyContent: 'center',
            fontSize: '14px',
            $nest: {
                div: {
                    display: 'flex',
                },
            },
        },
        _l),
});
var emojiDeleteErrorMessage = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R400,
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingRight: '4px',
});
var emojiChooseFileErrorMessage = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R300,
    paddingRight: '10px',
    justifyContent: 'flex-start',
});
var emojiPreviewErrorMessage = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'inline-flex',
    color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R400,
    paddingRight: '10px',
    justifyContent: 'flex-end',
    alignItems: 'center',
});
var addCustomEmojiButton = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    maxWidth: '285px',
});
var uploadRetryButton = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    maxWidth: '172px',
    justifyContent: 'center',
    fontWeight: 'bold',
    marginRight: '4px',
    $nest: {
        div: {
            display: 'flex',
        },
    },
});
var uploadEmojiButton = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    maxWidth: '187px',
    justifyContent: 'center',
    marginRight: '4px',
    $nest: {
        div: {
            display: 'flex',
        },
    },
});
var cancelButton = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    maxWidth: '100px',
});
var buttonSpinner = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    marginRight: '10px',
    marginLeft: '10px',
});
//# sourceMappingURL=styles.js.map

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return selected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return selectOnHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return emojiSprite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return emojiNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return deleteButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return emoji; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return emojiContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return placeholder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return placeholderContainer; });
/* unused harmony export placeholderEmoji */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return emojiButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return buttons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return preview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return previewImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return previewText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return name; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return shortName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return previewSingleLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return toneSelectorContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return withToneSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return emojiPreviewSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return emojiPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return emojiScrollable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return emojiUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return uploadChooseFileMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return emojiUploadBottom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return uploadChooseFileRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return uploadChooseFileEmojiName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return uploadChooseFileBrowse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return uploadPreviewFooter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return uploadPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return uploadPreviewText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bigEmojiPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return uploadAddRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddCustomEmoji; });
/* unused harmony export submitDelete */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return previewButtonGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return deletePreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return deleteText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return deleteFooter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return emojiDeleteErrorMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return emojiChooseFileErrorMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return emojiPreviewErrorMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addCustomEmojiButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return uploadRetryButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return uploadEmojiButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return cancelButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return buttonSpinner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_styles__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_typestyle__ = __webpack_require__(142);
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;




var selected = 'emoji-common-selected';
var selectOnHover = 'emoji-common-select-on-hover';
var emojiSprite = 'emoji-common-emoji-sprite';
var emojiNode = 'emoji-common-node';
var deleteButton = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    // hide by default
    visibility: 'hidden',
    display: 'flex',
    height: '0px',
    // 40px emoji width with 2px left offset
    width: '38px',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    // vertically align button and prevent emoji offset
    paddingTop: '4px',
    marginBottom: '-4px',
});
var emoji = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    borderRadius: '5px',
    backgroundColor: 'transparent',
    display: 'inline-block',
    verticalAlign: 'middle',
    // Ensure along with vertical align middle, we don't increase the line height for p and some
    // headings. Smaller headings get a slight increase in height, cannot add more negative margin
    // as a "selected" emoji (e.g. in the editor) will not look good.
    margin: '-1px 0',
    $nest: (_a = {},
        _a["&." + selected + ",&." + selectOnHover + ":hover"] = {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_2__shared_styles__["a" /* akEmojiSelectedBackgroundColor */],
        },
        _a["&." + selected + ",&." + selectOnHover + ":hover ." + deleteButton] = {
            // show delete button on hover
            visibility: 'visible',
        },
        _a.img = {
            display: 'block',
        },
        _a),
});
var emojiContainer = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'inline-block',
    // Ensure along with vertical align middle, we don't increase the line height for h1..h6, and p
    margin: '-1px 0',
    $nest: (_b = {},
        _b["&." + selected + ",&." + selectOnHover + ":hover"] = {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_2__shared_styles__["a" /* akEmojiSelectedBackgroundColor */],
        },
        _b["." + emojiSprite] = {
            background: 'transparent no-repeat',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* defaultEmojiHeight */] + "px",
            width: __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* defaultEmojiHeight */] + "px",
        },
        _b),
});
var placeholder = 'emoji-common-placeholder';
var placeholderContainer = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    // Ensure no vertical reflow
    margin: '-1px 0',
    display: 'inline-block',
    background: '#f7f7f7',
    borderRadius: '20%',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
});
var placeholderEmoji = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'inline-block',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
});
var emojiButton = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    backgroundColor: 'transparent',
    border: '0',
    cursor: 'pointer',
    padding: 0,
    $nest: (_c = {},
        /* Firefox */
        _c['&::-moz-focus-inner'] = {
            border: '0 none',
            padding: 0,
        },
        _c['&>span'] = {
            borderRadius: '5px',
            padding: '8px',
            $nest: (_d = {},
                // Scale sprite to fit regardless of default emoji size
                _d["&>." + emojiSprite] = {
                    height: '24px',
                    width: '24px',
                },
                _d),
        },
        _c),
});
// Emoji Preview
var buttons = 'emoji-common-buttons';
var preview = 'emoji-common-preview';
var previewImg = 'emoji-common-preview-image';
var previewText = 'emoji-common-preview-text';
var name = 'emoji-common-name';
var shortName = 'emoji-common-shortname';
var previewSingleLine = 'emoji-common-preview-single-line';
var toneSelectorContainer = 'emoji-common-tone-selector-container';
var withToneSelector = 'emoji-common-with-tone-selector';
var emojiPreviewSection = 'emoji-preview-section';
var emojiPreview = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    height: '50px',
    boxSizing: 'border-box',
    $nest: (_e = {},
        _e["." + preview] = {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            padding: '10px',
            $nest: (_f = {},
                _f["." + emojiSprite] = {
                    height: '32px',
                    margin: '0',
                    width: '32px',
                },
                _f["." + previewImg] = {
                    display: 'inline-block',
                    flex: 'initial',
                    width: '32px',
                    $nest: {
                        '&>span': {
                            width: '32px',
                            height: '32px',
                            padding: 0,
                            maxHeight: 'inherit',
                            $nest: {
                                '&>img': {
                                    position: 'relative',
                                    left: '50%',
                                    top: '50%',
                                    transform: 'translateX(-50%) translateY(-50%)',
                                    maxHeight: '32px',
                                    maxWidth: '32px',
                                    padding: 0,
                                    display: 'block',
                                },
                            },
                        },
                    },
                },
                _f["." + previewText] = {
                    display: 'flex',
                    flexDirection: 'column',
                    marginLeft: '10px',
                    marginTop: '-2px',
                    maxWidth: '285px',
                    width: '285px' /* IE */,
                    flexGrow: 1,
                    flexShrink: 1,
                    $nest: (_g = {},
                        _g["." + name] = {
                            display: 'block',
                            color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N900,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            $nest: (_h = {},
                                _h['&:first-letter'] = {
                                    textTransform: 'uppercase',
                                },
                                _h),
                        },
                        _g["." + shortName] = {
                            display: 'block',
                            color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N200,
                            fontSize: '12px',
                            lineHeight: 1,
                            marginBottom: '-2px',
                            overflow: 'hidden',
                            paddingBottom: '2px',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        },
                        _g),
                },
                _f["." + previewSingleLine] = {
                    paddingTop: '10px',
                    $nest: (_j = {},
                        _j["." + name] = {
                            display: 'none',
                        },
                        _j["." + shortName] = {
                            color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N900,
                            fontSize: '14px',
                        },
                        _j),
                },
                _f),
        },
        _e["." + buttons] = {
            flex: 1,
            textAlign: 'right',
            margin: '6px',
        },
        _e["." + toneSelectorContainer] = {
            flex: 1,
            textAlign: 'right',
            margin: '6px',
        },
        _e["." + withToneSelector + " ." + previewText] = {
            maxWidth: '235px',
            width: '235px' /* IE */,
        },
        _e),
});
// Scrollable
var emojiScrollable = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    border: '1px solid #fff',
    borderRadius: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["borderRadius"])() + "px",
    display: 'block',
    margin: '0',
    overflowX: 'hidden',
    overflowY: 'auto',
    padding: '0',
});
// EmojiUpload
var emojiUpload = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    height: '78px',
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
});
var uploadChooseFileMessage = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N300,
    fontSize: '12px',
    paddingBottom: '7px',
});
var emojiUploadBottom = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    fontSize: '11px',
});
var uploadChooseFileRow = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    justifyContent: 'space-between',
});
var uploadChooseFileEmojiName = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    flex: '1 1 auto',
    marginRight: '5px',
    $nest: {
        input: {
            background: 'transparent',
            border: 0,
            fontSize: '12px',
            outline: 'none',
            width: '100%',
            height: '22px',
            $nest: (_k = {},
                _k['&:invalid'] = {
                    boxShadow: 'none',
                },
                _k['&::-ms-clear'] = {
                    display: 'none',
                },
                _k),
        },
    },
});
var uploadChooseFileBrowse = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    flex: '0 0 auto',
});
var uploadPreviewFooter = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    flexDirection: 'column',
    height: '100px',
    padding: '10px',
});
var uploadPreview = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20,
    borderRadius: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["borderRadius"])() + "px",
    padding: '10px',
});
var uploadPreviewText = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    $nest: {
        h5: {
            color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N300,
            paddingBottom: '4px',
            fontSize: '12px',
        },
        img: {
            maxHeight: '20px',
            maxWidth: '50px',
        },
    },
});
var bigEmojiPreview = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    paddingLeft: '4px',
    $nest: {
        img: {
            maxHeight: '40px',
            maxWidth: '100px',
        },
    },
});
var uploadAddRow = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingTop: '10px',
});
var AddCustomEmoji = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    alignSelf: 'center',
    marginLeft: '10px',
});
// Emoji Delete preview
var submitDelete = 'emoji-submit-delete';
var previewButtonGroup = 'emoji-preview-button-group';
var deletePreview = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    height: '100px',
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    fontSize: '12px',
});
var deleteText = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    height: '64px',
    $nest: {
        ':first-child': {
            color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N300,
            lineHeight: '16px',
        },
    },
});
var deleteFooter = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    height: '40px',
    alignItems: 'center',
    justifyContent: 'space-between',
    $nest: (_l = {
            img: {
                maxHeight: '32px',
                maxWidth: '72px',
            }
        },
        _l["." + previewButtonGroup] = {
            display: 'flex',
        },
        _l["." + submitDelete] = {
            width: '84px',
            fontWeight: 'bold',
            marginRight: '4px',
        },
        _l.button = {
            display: 'flex',
            justifyContent: 'center',
            fontSize: '14px',
            $nest: {
                div: {
                    display: 'flex',
                },
            },
        },
        _l),
});
var emojiDeleteErrorMessage = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R400,
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingRight: '4px',
});
var emojiChooseFileErrorMessage = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R300,
    paddingRight: '10px',
    justifyContent: 'flex-start',
});
var emojiPreviewErrorMessage = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'inline-flex',
    color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R400,
    paddingRight: '10px',
    justifyContent: 'flex-end',
    alignItems: 'center',
});
var addCustomEmojiButton = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    maxWidth: '285px',
});
var uploadRetryButton = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    maxWidth: '172px',
    justifyContent: 'center',
    fontWeight: 'bold',
    marginRight: '4px',
    $nest: {
        div: {
            display: 'flex',
        },
    },
});
var uploadEmojiButton = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    maxWidth: '187px',
    justifyContent: 'center',
    marginRight: '4px',
    $nest: {
        div: {
            display: 'flex',
        },
    },
});
var cancelButton = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    maxWidth: '100px',
});
var buttonSpinner = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    marginRight: '10px',
    marginLeft: '10px',
});
//# sourceMappingURL=styles.js.map

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return selected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return selectOnHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return emojiSprite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return emojiNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return deleteButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return emoji; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return emojiContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return placeholder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return placeholderContainer; });
/* unused harmony export placeholderEmoji */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return emojiButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return buttons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return preview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return previewImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return previewText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return name; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return shortName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return previewSingleLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return toneSelectorContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return withToneSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return emojiPreviewSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return emojiPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return emojiScrollable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return emojiUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return uploadChooseFileMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return emojiUploadBottom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return uploadChooseFileRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return uploadChooseFileEmojiName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return uploadChooseFileBrowse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return uploadPreviewFooter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return uploadPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return uploadPreviewText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bigEmojiPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return uploadAddRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddCustomEmoji; });
/* unused harmony export submitDelete */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return previewButtonGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return deletePreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return deleteText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return deleteFooter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return emojiDeleteErrorMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return emojiChooseFileErrorMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return emojiPreviewErrorMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addCustomEmojiButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return uploadRetryButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return uploadEmojiButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return cancelButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return buttonSpinner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_styles__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_typestyle__ = __webpack_require__(142);
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;




var selected = 'emoji-common-selected';
var selectOnHover = 'emoji-common-select-on-hover';
var emojiSprite = 'emoji-common-emoji-sprite';
var emojiNode = 'emoji-common-node';
var deleteButton = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    // hide by default
    visibility: 'hidden',
    display: 'flex',
    height: '0px',
    // 40px emoji width with 2px left offset
    width: '38px',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    // vertically align button and prevent emoji offset
    paddingTop: '4px',
    marginBottom: '-4px',
});
var emoji = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    borderRadius: '5px',
    backgroundColor: 'transparent',
    display: 'inline-block',
    verticalAlign: 'middle',
    // Ensure along with vertical align middle, we don't increase the line height for p and some
    // headings. Smaller headings get a slight increase in height, cannot add more negative margin
    // as a "selected" emoji (e.g. in the editor) will not look good.
    margin: '-1px 0',
    $nest: (_a = {},
        _a["&." + selected + ",&." + selectOnHover + ":hover"] = {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_2__shared_styles__["a" /* akEmojiSelectedBackgroundColor */],
        },
        _a["&." + selected + ",&." + selectOnHover + ":hover ." + deleteButton] = {
            // show delete button on hover
            visibility: 'visible',
        },
        _a.img = {
            display: 'block',
        },
        _a),
});
var emojiContainer = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'inline-block',
    // Ensure along with vertical align middle, we don't increase the line height for h1..h6, and p
    margin: '-1px 0',
    $nest: (_b = {},
        _b["&." + selected + ",&." + selectOnHover + ":hover"] = {
            backgroundColor: __WEBPACK_IMPORTED_MODULE_2__shared_styles__["a" /* akEmojiSelectedBackgroundColor */],
        },
        _b["." + emojiSprite] = {
            background: 'transparent no-repeat',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* defaultEmojiHeight */] + "px",
            width: __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* defaultEmojiHeight */] + "px",
        },
        _b),
});
var placeholder = 'emoji-common-placeholder';
var placeholderContainer = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    // Ensure no vertical reflow
    margin: '-1px 0',
    display: 'inline-block',
    background: '#f7f7f7',
    borderRadius: '20%',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
});
var placeholderEmoji = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'inline-block',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
});
var emojiButton = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    backgroundColor: 'transparent',
    border: '0',
    cursor: 'pointer',
    padding: 0,
    $nest: (_c = {},
        /* Firefox */
        _c['&::-moz-focus-inner'] = {
            border: '0 none',
            padding: 0,
        },
        _c['&>span'] = {
            borderRadius: '5px',
            padding: '8px',
            $nest: (_d = {},
                // Scale sprite to fit regardless of default emoji size
                _d["&>." + emojiSprite] = {
                    height: '24px',
                    width: '24px',
                },
                _d),
        },
        _c),
});
// Emoji Preview
var buttons = 'emoji-common-buttons';
var preview = 'emoji-common-preview';
var previewImg = 'emoji-common-preview-image';
var previewText = 'emoji-common-preview-text';
var name = 'emoji-common-name';
var shortName = 'emoji-common-shortname';
var previewSingleLine = 'emoji-common-preview-single-line';
var toneSelectorContainer = 'emoji-common-tone-selector-container';
var withToneSelector = 'emoji-common-with-tone-selector';
var emojiPreviewSection = 'emoji-preview-section';
var emojiPreview = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    height: '50px',
    boxSizing: 'border-box',
    $nest: (_e = {},
        _e["." + preview] = {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            padding: '10px',
            $nest: (_f = {},
                _f["." + emojiSprite] = {
                    height: '32px',
                    margin: '0',
                    width: '32px',
                },
                _f["." + previewImg] = {
                    display: 'inline-block',
                    flex: 'initial',
                    width: '32px',
                    $nest: {
                        '&>span': {
                            width: '32px',
                            height: '32px',
                            padding: 0,
                            maxHeight: 'inherit',
                            $nest: {
                                '&>img': {
                                    position: 'relative',
                                    left: '50%',
                                    top: '50%',
                                    transform: 'translateX(-50%) translateY(-50%)',
                                    maxHeight: '32px',
                                    maxWidth: '32px',
                                    padding: 0,
                                    display: 'block',
                                },
                            },
                        },
                    },
                },
                _f["." + previewText] = {
                    display: 'flex',
                    flexDirection: 'column',
                    marginLeft: '10px',
                    marginTop: '-2px',
                    maxWidth: '285px',
                    width: '285px' /* IE */,
                    flexGrow: 1,
                    flexShrink: 1,
                    $nest: (_g = {},
                        _g["." + name] = {
                            display: 'block',
                            color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N900,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            $nest: (_h = {},
                                _h['&:first-letter'] = {
                                    textTransform: 'uppercase',
                                },
                                _h),
                        },
                        _g["." + shortName] = {
                            display: 'block',
                            color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N200,
                            fontSize: '12px',
                            lineHeight: 1,
                            marginBottom: '-2px',
                            overflow: 'hidden',
                            paddingBottom: '2px',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        },
                        _g),
                },
                _f["." + previewSingleLine] = {
                    paddingTop: '10px',
                    $nest: (_j = {},
                        _j["." + name] = {
                            display: 'none',
                        },
                        _j["." + shortName] = {
                            color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N900,
                            fontSize: '14px',
                        },
                        _j),
                },
                _f),
        },
        _e["." + buttons] = {
            flex: 1,
            textAlign: 'right',
            margin: '6px',
        },
        _e["." + toneSelectorContainer] = {
            flex: 1,
            textAlign: 'right',
            margin: '6px',
        },
        _e["." + withToneSelector + " ." + previewText] = {
            maxWidth: '235px',
            width: '235px' /* IE */,
        },
        _e),
});
// Scrollable
var emojiScrollable = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    border: '1px solid #fff',
    borderRadius: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["borderRadius"])() + "px",
    display: 'block',
    margin: '0',
    overflowX: 'hidden',
    overflowY: 'auto',
    padding: '0',
});
// EmojiUpload
var emojiUpload = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    height: '78px',
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
});
var uploadChooseFileMessage = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N300,
    fontSize: '12px',
    paddingBottom: '7px',
});
var emojiUploadBottom = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    fontSize: '11px',
});
var uploadChooseFileRow = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    justifyContent: 'space-between',
});
var uploadChooseFileEmojiName = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    flex: '1 1 auto',
    marginRight: '5px',
    $nest: {
        input: {
            background: 'transparent',
            border: 0,
            fontSize: '12px',
            outline: 'none',
            width: '100%',
            height: '22px',
            $nest: (_k = {},
                _k['&:invalid'] = {
                    boxShadow: 'none',
                },
                _k['&::-ms-clear'] = {
                    display: 'none',
                },
                _k),
        },
    },
});
var uploadChooseFileBrowse = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    flex: '0 0 auto',
});
var uploadPreviewFooter = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    flexDirection: 'column',
    height: '100px',
    padding: '10px',
});
var uploadPreview = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20,
    borderRadius: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["borderRadius"])() + "px",
    padding: '10px',
});
var uploadPreviewText = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    $nest: {
        h5: {
            color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N300,
            paddingBottom: '4px',
            fontSize: '12px',
        },
        img: {
            maxHeight: '20px',
            maxWidth: '50px',
        },
    },
});
var bigEmojiPreview = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    paddingLeft: '4px',
    $nest: {
        img: {
            maxHeight: '40px',
            maxWidth: '100px',
        },
    },
});
var uploadAddRow = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingTop: '10px',
});
var AddCustomEmoji = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    alignSelf: 'center',
    marginLeft: '10px',
});
// Emoji Delete preview
var submitDelete = 'emoji-submit-delete';
var previewButtonGroup = 'emoji-preview-button-group';
var deletePreview = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    height: '100px',
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    fontSize: '12px',
});
var deleteText = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    height: '64px',
    $nest: {
        ':first-child': {
            color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N300,
            lineHeight: '16px',
        },
    },
});
var deleteFooter = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    height: '40px',
    alignItems: 'center',
    justifyContent: 'space-between',
    $nest: (_l = {
            img: {
                maxHeight: '32px',
                maxWidth: '72px',
            }
        },
        _l["." + previewButtonGroup] = {
            display: 'flex',
        },
        _l["." + submitDelete] = {
            width: '84px',
            fontWeight: 'bold',
            marginRight: '4px',
        },
        _l.button = {
            display: 'flex',
            justifyContent: 'center',
            fontSize: '14px',
            $nest: {
                div: {
                    display: 'flex',
                },
            },
        },
        _l),
});
var emojiDeleteErrorMessage = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R400,
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingRight: '4px',
});
var emojiChooseFileErrorMessage = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'flex',
    color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R300,
    paddingRight: '10px',
    justifyContent: 'flex-start',
});
var emojiPreviewErrorMessage = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    display: 'inline-flex',
    color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R400,
    paddingRight: '10px',
    justifyContent: 'flex-end',
    alignItems: 'center',
});
var addCustomEmojiButton = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    maxWidth: '285px',
});
var uploadRetryButton = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    maxWidth: '172px',
    justifyContent: 'center',
    fontWeight: 'bold',
    marginRight: '4px',
    $nest: {
        div: {
            display: 'flex',
        },
    },
});
var uploadEmojiButton = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    maxWidth: '187px',
    justifyContent: 'center',
    marginRight: '4px',
    $nest: {
        div: {
            display: 'flex',
        },
    },
});
var cancelButton = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    maxWidth: '100px',
});
var buttonSpinner = Object(__WEBPACK_IMPORTED_MODULE_3_typestyle__["a" /* style */])({
    marginRight: '10px',
    marginLeft: '10px',
});
//# sourceMappingURL=styles.js.map

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AtlasKitThemeProvider", function() { return AtlasKitThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderRadius", function() { return borderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridSize", function() { return gridSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fontSize", function() { return fontSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fontSizeSmall", function() { return fontSizeSmall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fontFamily", function() { return fontFamily; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "codeFontFamily", function() { return codeFontFamily; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "focusRing", function() { return focusRing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "noFocusRing", function() { return noFocusRing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "layers", function() { return layers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assistive", function() { return assistive; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colors__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elevation__ = __webpack_require__(2593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typography__ = __webpack_require__(2594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_math__ = __webpack_require__(2595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_getTheme__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_themed__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AtlaskitThemeProvider__ = __webpack_require__(2596);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "colors", function() { return __WEBPACK_IMPORTED_MODULE_1__colors__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "elevation", function() { return __WEBPACK_IMPORTED_MODULE_2__elevation__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "typography", function() { return __WEBPACK_IMPORTED_MODULE_3__typography__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "math", function() { return __WEBPACK_IMPORTED_MODULE_4__utils_math__; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getTheme", function() { return __WEBPACK_IMPORTED_MODULE_5__utils_getTheme__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "themed", function() { return __WEBPACK_IMPORTED_MODULE_6__utils_themed__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AtlaskitThemeProvider", function() { return __WEBPACK_IMPORTED_MODULE_7__components_AtlaskitThemeProvider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Appearance__ = __webpack_require__(2597);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Appearance", function() { return __WEBPACK_IMPORTED_MODULE_8__components_Appearance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Reset__ = __webpack_require__(2598);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ResetTheme", function() { return __WEBPACK_IMPORTED_MODULE_9__components_Reset__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Reset", function() { return __WEBPACK_IMPORTED_MODULE_9__components_Reset__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Theme__ = __webpack_require__(459);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_10__components_Theme__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hoc__ = __webpack_require__(2599);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "withTheme", function() { return __WEBPACK_IMPORTED_MODULE_11__hoc__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_createTheme__ = __webpack_require__(460);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "createTheme", function() { return __WEBPACK_IMPORTED_MODULE_12__utils_createTheme__["a"]; });









 // backwards-compatible export with old Atlaskit case

var AtlasKitThemeProvider = __WEBPACK_IMPORTED_MODULE_7__components_AtlaskitThemeProvider__["a" /* default */];
/*
  These theme values are expressed as functions so that if we decide to make
  them dependent on props in the future, it wouldn't require a significant
  refactor everywhere they are being used.
*/

var borderRadius = function borderRadius() {
  return 3;
};
var gridSize = function gridSize() {
  return 8;
};
var fontSize = function fontSize() {
  return 14;
};
var fontSizeSmall = function fontSizeSmall() {
  return 11;
};
var fontFamily = function fontFamily() {
  return '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';
};
var codeFontFamily = function codeFontFamily() {
  return '"SFMono-Medium", "SF Mono", "Segoe UI Mono", "Roboto Mono", "Ubuntu Mono", Menlo, Consolas, Courier, monospace';
};
var focusRing = function focusRing() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__colors__["B100"];
  var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : gridSize() / 4;
  return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, " ").concat(color, ";\n  }\n");
};
var noFocusRing = function noFocusRing() {
  return "\n  box-shadow: none;\n";
};
var layers = {
  card: function card() {
    return 100;
  },
  dialog: function dialog() {
    return 200;
  },
  navigation: function navigation() {
    return 300;
  },
  layer: function layer() {
    return 400;
  },
  blanket: function blanket() {
    return 500;
  },
  modal: function modal() {
    return 510;
  },
  flag: function flag() {
    return 600;
  },
  spotlight: function spotlight() {
    return 700;
  },
  tooltip: function tooltip() {
    return 800;
  }
};
var assistive = function assistive() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  border: 0 !important;\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  height: 1px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  width: 1px !important;\n  white-space: nowrap !important;\n"]);
}; // New API






/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1493)
var ieee754 = __webpack_require__(1494)
var isArray = __webpack_require__(1495)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getDimensionsWithDefault */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardLoading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_file__ = __webpack_require__(2119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_file___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_file__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_link__ = __webpack_require__(2120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styled__ = __webpack_require__(2121);






var getDimensionsWithDefault = function (dimensions) {
    if (dimensions === void 0) { dimensions = { width: '100%', height: '100%' }; }
    return {
        height: typeof dimensions.height === 'number'
            ? dimensions.height + "px"
            : dimensions.height,
        width: typeof dimensions.width === 'number'
            ? dimensions.width + "px"
            : dimensions.width,
    };
};
var CardLoading = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CardLoading, _super);
    function CardLoading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardLoading.prototype.render = function () {
        var dimensions = getDimensionsWithDefault(this.props.dimensions);
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styled__["a" /* Wrapper */], { dimensions: dimensions }, this.icon);
    };
    Object.defineProperty(CardLoading.prototype, "iconSize", {
        get: function () {
            return this.props.iconSize || 'medium';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardLoading.prototype, "icon", {
        get: function () {
            var iconSize = this.iconSize;
            var mediaItemType = this.props.mediaItemType;
            return mediaItemType === 'link' ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_link___default.a, { label: "loading", size: iconSize })) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_file___default.a, { label: "loading", size: iconSize }));
        },
        enumerable: true,
        configurable: true
    });
    return CardLoading;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getDimensionsWithDefault */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardLoading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_file__ = __webpack_require__(2606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_file___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_file__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_link__ = __webpack_require__(2607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styled__ = __webpack_require__(2608);






var getDimensionsWithDefault = function (dimensions) {
    if (dimensions === void 0) { dimensions = { width: '100%', height: '100%' }; }
    return {
        height: typeof dimensions.height === 'number'
            ? dimensions.height + "px"
            : dimensions.height,
        width: typeof dimensions.width === 'number'
            ? dimensions.width + "px"
            : dimensions.width,
    };
};
var CardLoading = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CardLoading, _super);
    function CardLoading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardLoading.prototype.render = function () {
        var dimensions = getDimensionsWithDefault(this.props.dimensions);
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styled__["a" /* Wrapper */], { dimensions: dimensions }, this.icon);
    };
    Object.defineProperty(CardLoading.prototype, "iconSize", {
        get: function () {
            return this.props.iconSize || 'medium';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardLoading.prototype, "icon", {
        get: function () {
            var iconSize = this.iconSize;
            var mediaItemType = this.props.mediaItemType;
            return mediaItemType === 'link' ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_link___default.a, { label: "loading", size: iconSize })) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_file___default.a, { label: "loading", size: iconSize }));
        },
        enumerable: true,
        configurable: true
    });
    return CardLoading;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media_store__ = __webpack_require__(1836);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__media_store__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_media__ = __webpack_require__(1840);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_auth__ = __webpack_require__(386);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__models_auth__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__upload_controller__ = __webpack_require__(1841);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__upload_controller__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_artifacts__ = __webpack_require__(680);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__uploader__ = __webpack_require__(1842);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__uploader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_request__ = __webpack_require__(679);
/* unused harmony namespace reexport */







//# sourceMappingURL=index.js.map

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Provider__ = __webpack_require__(2492);
/* unused harmony reexport Provider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Client__ = __webpack_require__(839);
/* unused harmony reexport Client */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card__ = __webpack_require__(2505);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Card__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Editor_card_provider__ = __webpack_require__(2507);
/* unused harmony reexport EditorCardProvider */
/* unused harmony reexport editorCardProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Context__ = __webpack_require__(555);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__Context__["a"]; });





//# sourceMappingURL=index.js.map

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(359);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(123).f;
var has = __webpack_require__(129);
var TAG = __webpack_require__(140)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var simpleIsEqual = function simpleIsEqual(a, b) {
  return a === b;
};

/* harmony default export */ __webpack_exports__["a"] = (function (resultFn) {
  var isEqual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : simpleIsEqual;

  var lastThis = void 0;
  var lastArgs = [];
  var lastResult = void 0;
  var calledOnce = false;

  var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
    return isEqual(newArg, lastArgs[index]);
  };

  var result = function result() {
    for (var _len = arguments.length, newArgs = Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }

    if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
      return lastResult;
    }

    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    lastResult = resultFn.apply(this, newArgs);
    return lastResult;
  };

  return result;
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_tooltip__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__type_helpers__ = __webpack_require__(86);






// tslint:disable-next-line:variable-name
var EmojiPlaceholder = function (props) {
    var _a;
    var shortName = props.shortName, _b = props.size, size = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_4__constants__["g" /* defaultEmojiHeight */] : _b, showTooltip = props.showTooltip, representation = props.representation;
    var scaledWidth;
    var scaledHeight;
    if (representation &&
        size &&
        (Object(__WEBPACK_IMPORTED_MODULE_5__type_helpers__["h" /* isImageRepresentation */])(representation) ||
            Object(__WEBPACK_IMPORTED_MODULE_5__type_helpers__["k" /* isMediaRepresentation */])(representation))) {
        var width_1 = representation.width;
        var height_1 = representation.height;
        if (width_1 && height_1) {
            scaledWidth = (size / height_1) * width_1;
            scaledHeight = size;
        }
    }
    var width = scaledWidth || size;
    var height = scaledHeight || size;
    var style = {
        fill: 'f7f7f7',
        width: width + "px",
        height: height + "px",
    };
    var classes = (_a = {},
        _a[__WEBPACK_IMPORTED_MODULE_3__styles__["y" /* placeholder */]] = true,
        _a[__WEBPACK_IMPORTED_MODULE_3__styles__["z" /* placeholderContainer */]] = true,
        _a);
    var placeholderNode = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { "aria-label": shortName, className: __WEBPACK_IMPORTED_MODULE_1_classnames__(classes), style: style }));
    return showTooltip ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_tooltip__["a" /* default */], { tag: "span", content: shortName }, placeholderNode)) : (placeholderNode);
};
/* harmony default export */ __webpack_exports__["a"] = (EmojiPlaceholder);
//# sourceMappingURL=EmojiPlaceholder.js.map

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_tooltip__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__type_helpers__ = __webpack_require__(88);






// tslint:disable-next-line:variable-name
var EmojiPlaceholder = function (props) {
    var _a;
    var shortName = props.shortName, _b = props.size, size = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_4__constants__["g" /* defaultEmojiHeight */] : _b, showTooltip = props.showTooltip, representation = props.representation;
    var scaledWidth;
    var scaledHeight;
    if (representation &&
        size &&
        (Object(__WEBPACK_IMPORTED_MODULE_5__type_helpers__["h" /* isImageRepresentation */])(representation) ||
            Object(__WEBPACK_IMPORTED_MODULE_5__type_helpers__["k" /* isMediaRepresentation */])(representation))) {
        var width_1 = representation.width;
        var height_1 = representation.height;
        if (width_1 && height_1) {
            scaledWidth = (size / height_1) * width_1;
            scaledHeight = size;
        }
    }
    var width = scaledWidth || size;
    var height = scaledHeight || size;
    var style = {
        fill: 'f7f7f7',
        width: width + "px",
        height: height + "px",
    };
    var classes = (_a = {},
        _a[__WEBPACK_IMPORTED_MODULE_3__styles__["y" /* placeholder */]] = true,
        _a[__WEBPACK_IMPORTED_MODULE_3__styles__["z" /* placeholderContainer */]] = true,
        _a);
    var placeholderNode = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { "aria-label": shortName, className: __WEBPACK_IMPORTED_MODULE_1_classnames__(classes), style: style }));
    return showTooltip ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_tooltip__["a" /* default */], { tag: "span", content: shortName }, placeholderNode)) : (placeholderNode);
};
/* harmony default export */ __webpack_exports__["a"] = (EmojiPlaceholder);
//# sourceMappingURL=EmojiPlaceholder.js.map

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_tooltip__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__type_helpers__ = __webpack_require__(89);






// tslint:disable-next-line:variable-name
var EmojiPlaceholder = function (props) {
    var _a;
    var shortName = props.shortName, _b = props.size, size = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_4__constants__["g" /* defaultEmojiHeight */] : _b, showTooltip = props.showTooltip, representation = props.representation;
    var scaledWidth;
    var scaledHeight;
    if (representation &&
        size &&
        (Object(__WEBPACK_IMPORTED_MODULE_5__type_helpers__["h" /* isImageRepresentation */])(representation) ||
            Object(__WEBPACK_IMPORTED_MODULE_5__type_helpers__["k" /* isMediaRepresentation */])(representation))) {
        var width_1 = representation.width;
        var height_1 = representation.height;
        if (width_1 && height_1) {
            scaledWidth = (size / height_1) * width_1;
            scaledHeight = size;
        }
    }
    var width = scaledWidth || size;
    var height = scaledHeight || size;
    var style = {
        fill: 'f7f7f7',
        width: width + "px",
        height: height + "px",
    };
    var classes = (_a = {},
        _a[__WEBPACK_IMPORTED_MODULE_3__styles__["y" /* placeholder */]] = true,
        _a[__WEBPACK_IMPORTED_MODULE_3__styles__["z" /* placeholderContainer */]] = true,
        _a);
    var placeholderNode = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { "aria-label": shortName, className: __WEBPACK_IMPORTED_MODULE_1_classnames__(classes), style: style }));
    return showTooltip ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_tooltip__["a" /* default */], { tag: "span", content: shortName }, placeholderNode)) : (placeholderNode);
};
/* harmony default export */ __webpack_exports__["a"] = (EmojiPlaceholder);
//# sourceMappingURL=EmojiPlaceholder.js.map

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1425);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(126);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(251);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(252);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(1462);
var parse = __webpack_require__(1490);
var formats = __webpack_require__(356);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $Object = __webpack_require__(591);

var $Error = __webpack_require__(1465);
var $EvalError = __webpack_require__(1466);
var $RangeError = __webpack_require__(1467);
var $ReferenceError = __webpack_require__(1468);
var $SyntaxError = __webpack_require__(1469);
var $TypeError = __webpack_require__(152);
var $URIError = __webpack_require__(1470);

var abs = __webpack_require__(1471);
var floor = __webpack_require__(1472);
var max = __webpack_require__(1473);
var min = __webpack_require__(1474);
var pow = __webpack_require__(1475);
var round = __webpack_require__(1476);
var sign = __webpack_require__(1477);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = __webpack_require__(592);
var $defineProperty = __webpack_require__(1480);

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(1481)();

var getProto = __webpack_require__(1483);
var $ObjectGPO = __webpack_require__(594);
var $ReflectGPO = __webpack_require__(593);

var $apply = __webpack_require__(596);
var $call = __webpack_require__(355);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(255);
var hasOwn = __webpack_require__(1488);
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createAction;
/* unused harmony export action */
/* harmony export (immutable) */ __webpack_exports__["a"] = asyncAction;
/* unused harmony export createPollingAction */
var identity=function identity(t){return t;};function createAction(type,payloadCreator,metaCreator){var finalPayloadCreator=typeof payloadCreator==='function'?payloadCreator:payloadCreator&&payloadCreator.noPayload?null:identity;var actionCreator=function actionCreator(){var hasError=(arguments.length<=0?undefined:arguments[0])instanceof Error;var action={type:type};var payload=null;if(finalPayloadCreator!==null){payload=hasError?arguments.length<=0?undefined:arguments[0]:finalPayloadCreator.apply(undefined,arguments);}if(!(payload===null||payload===undefined)){action.payload=payload;}if(hasError||payload instanceof Error){// Handle FSA errors where the payload is an Error object. Set error.
action.error=true;}if(typeof metaCreator==='function'){action.meta=metaCreator.apply(undefined,arguments);}return action;};actionCreator.toString=function(){return type.toString();};actionCreator.type=type.toString();return actionCreator;}function action(type,payload){return{type:type,payload:payload};}function asyncAction(config){var event={name:config.baseName,start:config.baseName+'_START',success:config.baseName+'_SUCCESS',error:config.baseName+'_ERROR'};var request=function request(type,isPending,error){return function(payload){return{type:type,payload:payload,request:{id:config.baseName,isPending:isPending,error:error?payload:null}};};};var dispatchers={start:request(event.start,true),success:request(event.success,false),error:request(event.error,false,true)};var action=config.action(dispatchers);action.event=event;return action;}var createPollingAction=function createPollingAction(action,frequency){var actionInterval=null;var stop=function stop(){if(actionInterval)clearInterval(actionInterval);};var start=function start(dispatch,getState){stop();action(dispatch,getState);// actionInterval = setInterval(() => action(dispatch, getState), frequency)
};return{start:start,stop:stop};};

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(143);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 359 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 360 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(362)('keys');
var uid = __webpack_require__(258);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(95);
var global = __webpack_require__(110);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(247) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 363 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 364 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(177);
var dPs = __webpack_require__(1509);
var enumBugKeys = __webpack_require__(363);
var IE_PROTO = __webpack_require__(361)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(544)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(1376).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(140);


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(110);
var core = __webpack_require__(95);
var LIBRARY = __webpack_require__(247);
var wksExt = __webpack_require__(366);
var defineProperty = __webpack_require__(123).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function isContainer(node) {
    switch (node._type) {
    case 'Document':
    case 'BlockQuote':
    case 'List':
    case 'Item':
    case 'Paragraph':
    case 'Heading':
    case 'Emph':
    case 'Strong':
    case 'Link':
    case 'Image':
    case 'CustomInline':
    case 'CustomBlock':
        return true;
    default:
        return false;
    }
}

var resumeAt = function(node, entering) {
    this.current = node;
    this.entering = (entering === true);
};

var next = function(){
    var cur = this.current;
    var entering = this.entering;

    if (cur === null) {
        return null;
    }

    var container = isContainer(cur);

    if (entering && container) {
        if (cur._firstChild) {
            this.current = cur._firstChild;
            this.entering = true;
        } else {
            // stay on node but exit
            this.entering = false;
        }

    } else if (cur === this.root) {
        this.current = null;

    } else if (cur._next === null) {
        this.current = cur._parent;
        this.entering = false;

    } else {
        this.current = cur._next;
        this.entering = true;
    }

    return {entering: entering, node: cur};
};

var NodeWalker = function(root) {
    return { current: root,
             root: root,
             entering: true,
             next: next,
             resumeAt: resumeAt };
};

var Node = function(nodeType, sourcepos) {
    this._type = nodeType;
    this._parent = null;
    this._firstChild = null;
    this._lastChild = null;
    this._prev = null;
    this._next = null;
    this._sourcepos = sourcepos;
    this._lastLineBlank = false;
    this._open = true;
    this._string_content = null;
    this._literal = null;
    this._listData = {};
    this._info = null;
    this._destination = null;
    this._title = null;
    this._isFenced = false;
    this._fenceChar = null;
    this._fenceLength = 0;
    this._fenceOffset = null;
    this._level = null;
    this._onEnter = null;
    this._onExit = null;
};

var proto = Node.prototype;

Object.defineProperty(proto, 'isContainer', {
    get: function () { return isContainer(this); }
});

Object.defineProperty(proto, 'type', {
    get: function() { return this._type; }
});

Object.defineProperty(proto, 'firstChild', {
    get: function() { return this._firstChild; }
});

Object.defineProperty(proto, 'lastChild', {
    get: function() { return this._lastChild; }
});

Object.defineProperty(proto, 'next', {
    get: function() { return this._next; }
});

Object.defineProperty(proto, 'prev', {
    get: function() { return this._prev; }
});

Object.defineProperty(proto, 'parent', {
    get: function() { return this._parent; }
});

Object.defineProperty(proto, 'sourcepos', {
    get: function() { return this._sourcepos; }
});

Object.defineProperty(proto, 'literal', {
    get: function() { return this._literal; },
    set: function(s) { this._literal = s; }
});

Object.defineProperty(proto, 'destination', {
    get: function() { return this._destination; },
    set: function(s) { this._destination = s; }
});

Object.defineProperty(proto, 'title', {
    get: function() { return this._title; },
    set: function(s) { this._title = s; }
});

Object.defineProperty(proto, 'info', {
    get: function() { return this._info; },
    set: function(s) { this._info = s; }
});

Object.defineProperty(proto, 'level', {
    get: function() { return this._level; },
    set: function(s) { this._level = s; }
});

Object.defineProperty(proto, 'listType', {
    get: function() { return this._listData.type; },
    set: function(t) { this._listData.type = t; }
});

Object.defineProperty(proto, 'listTight', {
    get: function() { return this._listData.tight; },
    set: function(t) { this._listData.tight = t; }
});

Object.defineProperty(proto, 'listStart', {
    get: function() { return this._listData.start; },
    set: function(n) { this._listData.start = n; }
});

Object.defineProperty(proto, 'listDelimiter', {
    get: function() { return this._listData.delimiter; },
    set: function(delim) { this._listData.delimiter = delim; }
});

Object.defineProperty(proto, 'onEnter', {
    get: function() { return this._onEnter; },
    set: function(s) { this._onEnter = s; }
});

Object.defineProperty(proto, 'onExit', {
    get: function() { return this._onExit; },
    set: function(s) { this._onExit = s; }
});

Node.prototype.appendChild = function(child) {
    child.unlink();
    child._parent = this;
    if (this._lastChild) {
        this._lastChild._next = child;
        child._prev = this._lastChild;
        this._lastChild = child;
    } else {
        this._firstChild = child;
        this._lastChild = child;
    }
};

Node.prototype.prependChild = function(child) {
    child.unlink();
    child._parent = this;
    if (this._firstChild) {
        this._firstChild._prev = child;
        child._next = this._firstChild;
        this._firstChild = child;
    } else {
        this._firstChild = child;
        this._lastChild = child;
    }
};

Node.prototype.unlink = function() {
    if (this._prev) {
        this._prev._next = this._next;
    } else if (this._parent) {
        this._parent._firstChild = this._next;
    }
    if (this._next) {
        this._next._prev = this._prev;
    } else if (this._parent) {
        this._parent._lastChild = this._prev;
    }
    this._parent = null;
    this._next = null;
    this._prev = null;
};

Node.prototype.insertAfter = function(sibling) {
    sibling.unlink();
    sibling._next = this._next;
    if (sibling._next) {
        sibling._next._prev = sibling;
    }
    sibling._prev = this;
    this._next = sibling;
    sibling._parent = this._parent;
    if (!sibling._next) {
        sibling._parent._lastChild = sibling;
    }
};

Node.prototype.insertBefore = function(sibling) {
    sibling.unlink();
    sibling._prev = this._prev;
    if (sibling._prev) {
        sibling._prev._next = sibling;
    }
    sibling._next = this;
    this._prev = sibling;
    sibling._parent = this._parent;
    if (!sibling._prev) {
        sibling._parent._firstChild = sibling;
    }
};

Node.prototype.walker = function() {
    var walker = new NodeWalker(this);
    return walker;
};

module.exports = Node;


/* Example of use of walker:

 var walker = w.walker();
 var event;

 while (event = walker.next()) {
 console.log(event.entering, event.node.type);
 }

 */


/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Label__ = __webpack_require__(189);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var id=0;var Checkbox=function(_Component){_inherits(Checkbox,_Component);function Checkbox(){var _ref;_classCallCheck(this,Checkbox);for(var _len=arguments.length,props=Array(_len),_key=0;_key<_len;_key++){props[_key]=arguments[_key];}var _this=_possibleConstructorReturn(this,(_ref=Checkbox.__proto__||Object.getPrototypeOf(Checkbox)).call.apply(_ref,[this].concat(props)));_this.id=id++;return _this;}_createClass(Checkbox,[{key:'render',value:function render(){var _props=this.props,checked=_props.checked,label=_props.label,_onChange=_props.onChange,title=_props.title;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',className:'ncss-checkbox',id:'ncss-checkbox-'+this.id,checked:checked,onChange:function onChange(e){return _onChange(e.target.checked);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Label__["a" /* default */],{className:'pl6-sm',htmlFor:'ncss-checkbox-'+this.id,title:title},label));}}]);return Checkbox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Checkbox);

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return nextMajorVersion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__package_json__, "name")) __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__package_json__["name"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__package_json__, "version")) __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__package_json__["version"]; });

var nextMajorVersion = function () {
    return [Number(__WEBPACK_IMPORTED_MODULE_0__package_json__["version"].split('.')[0]) + 1, 0, 0].join('.');
};

//# sourceMappingURL=version.js.map

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__create_editor__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_EditorContext__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_WithCreateAnalyticsEvent__ = __webpack_require__(2821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_PortalProvider__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__version__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_smart_card__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__nodeviews__ = __webpack_require__(84);














// allows connecting external React.Context through to nodeviews
var ContextAdapter = Object(__WEBPACK_IMPORTED_MODULE_12__nodeviews__["b" /* createContextAdapter */])({
    card: __WEBPACK_IMPORTED_MODULE_11__atlaskit_smart_card__["b" /* Context */],
});
var Editor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Editor, _super);
    function Editor(props, context) {
        var _this = _super.call(this, props) || this;
        _this.handleSave = function (view) {
            if (!_this.props.onSave) {
                return;
            }
            // ED-4021: if you type a short amount of content
            // inside a content-editable on Android, Chrome only sends a
            // compositionend when it feels like it.
            //
            // to work around the PM editable being out of sync with
            // the document, force a DOM sync before calling onSave
            // if we've already started typing
            // @ts-ignore
            if (view['inDOMChange']) {
                // @ts-ignore
                view['inDOMChange'].finish(true);
            }
            return _this.props.onSave(view);
        };
        _this.providerFactory = new __WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__["f" /* ProviderFactory */]();
        _this.deprecationWarnings(props);
        _this.onEditorCreated = _this.onEditorCreated.bind(_this);
        _this.onEditorDestroyed = _this.onEditorDestroyed.bind(_this);
        _this.editorActions = (context || {}).editorActions || new __WEBPACK_IMPORTED_MODULE_6__actions__["a" /* default */]();
        return _this;
    }
    Editor.prototype.componentDidMount = function () {
        this.handleProviders(this.props);
    };
    Editor.prototype.componentWillReceiveProps = function (nextProps) {
        this.handleProviders(nextProps);
    };
    Editor.prototype.componentWillUnmount = function () {
        this.unregisterEditorFromActions();
        this.providerFactory.destroy();
    };
    Editor.prototype.onEditorCreated = function (instance) {
        this.registerEditorForActions(instance.view, instance.eventDispatcher, instance.transformer);
        if (this.props.shouldFocus) {
            if (!instance.view.hasFocus()) {
                window.setTimeout(function () {
                    instance.view.focus();
                }, 0);
            }
        }
    };
    Editor.prototype.deprecationWarnings = function (props) {
        var nextVersion = Object(__WEBPACK_IMPORTED_MODULE_10__version__["b" /* nextMajorVersion */])();
        var deprecatedProperties = {
            mediaProvider: {
                message: 'To pass media provider use media property – <Editor media={{ provider }} />',
                type: 'removed',
            },
            allowTasksAndDecisions: {
                message: 'To allow tasks and decisions use taskDecisionProvider – <Editor taskDecisionProvider={{ provider }} />',
                type: 'removed',
            },
            allowPlaceholderCursor: {
                type: 'removed',
            },
            allowInlineAction: {
                type: 'removed',
            },
            allowConfluenceInlineComment: {
                type: 'removed',
            },
            addonToolbarComponents: {
                type: 'removed',
            },
            cardProvider: {
                type: 'removed',
            },
            allowCodeBlocks: {
                message: 'To disable codeBlocks use - <Editor allowBlockTypes={{ exclude: ["codeBlocks"] }} />',
            },
            allowLists: {},
            allowHelpDialog: {},
            allowGapCursor: {
                type: 'removed',
            },
            allowUnsupportedContent: {
                message: 'Deprecated. Defaults to true.',
                type: 'removed',
            },
        };
        Object.keys(deprecatedProperties).forEach(function (property) {
            if (props.hasOwnProperty(property)) {
                var meta = deprecatedProperties[property];
                var type = meta.type || 'enabled by default';
                // tslint:disable-next-line:no-console
                console.warn(property + " property is deprecated. " + (meta.message ||
                    '') + " [Will be " + type + " in editor-core@" + nextVersion + "]");
            }
        });
        if (!props.hasOwnProperty('appearance')) {
            // tslint:disable-next-line:no-console
            console.warn("The default appearance is changing from \"message\" to \"comment\", to main current behaviour use <Editor appearance=\"message\" />. [Will be changed in editor-core@" + nextVersion + "]");
        }
        if (props.hasOwnProperty('quickInsert') &&
            typeof props.quickInsert === 'boolean') {
            // tslint:disable-next-line:no-console
            console.warn("quickInsert property is deprecated. [Will be enabled by default in editor-core@" + nextVersion + "]");
        }
        if (props.hasOwnProperty('allowTables') &&
            typeof props.allowTables !== 'boolean' &&
            !props.allowTables.advanced) {
            // tslint:disable-next-line:no-console
            console.warn("Advanced table options are deprecated (except isHeaderRowRequired) to continue using advanced table features use - <Editor allowTables={{ advanced: true }} /> [Will be changed in editor-core@" + nextVersion + "]");
        }
    };
    Editor.prototype.onEditorDestroyed = function (instance) {
        this.unregisterEditorFromActions();
    };
    Editor.prototype.registerEditorForActions = function (editorView, eventDispatcher, contentTransformer) {
        this.editorActions._privateRegisterEditor(editorView, eventDispatcher, contentTransformer);
    };
    Editor.prototype.unregisterEditorFromActions = function () {
        if (this.editorActions) {
            this.editorActions._privateUnregisterEditor();
        }
    };
    Editor.prototype.handleProviders = function (props) {
        var emojiProvider = props.emojiProvider, mentionProvider = props.mentionProvider, mediaProvider = props.mediaProvider, taskDecisionProvider = props.taskDecisionProvider, contextIdentifierProvider = props.contextIdentifierProvider, collabEditProvider = props.collabEditProvider, activityProvider = props.activityProvider, presenceProvider = props.presenceProvider, macroProvider = props.macroProvider, legacyImageUploadProvider = props.legacyImageUploadProvider, media = props.media, collabEdit = props.collabEdit, quickInsert = props.quickInsert, UNSAFE_cards = props.UNSAFE_cards;
        this.providerFactory.setProvider('emojiProvider', emojiProvider);
        this.providerFactory.setProvider('mentionProvider', mentionProvider);
        this.providerFactory.setProvider('taskDecisionProvider', taskDecisionProvider);
        this.providerFactory.setProvider('contextIdentifierProvider', contextIdentifierProvider);
        this.providerFactory.setProvider('mediaProvider', media && media.provider ? media.provider : mediaProvider);
        this.providerFactory.setProvider('imageUploadProvider', legacyImageUploadProvider);
        this.providerFactory.setProvider('collabEditProvider', collabEdit && collabEdit.provider
            ? collabEdit.provider
            : collabEditProvider);
        this.providerFactory.setProvider('activityProvider', activityProvider);
        this.providerFactory.setProvider('presenceProvider', presenceProvider);
        this.providerFactory.setProvider('macroProvider', macroProvider);
        if (UNSAFE_cards && UNSAFE_cards.provider) {
            this.providerFactory.setProvider('cardProvider', UNSAFE_cards.provider);
        }
        if (quickInsert && typeof quickInsert !== 'boolean') {
            this.providerFactory.setProvider('quickInsertProvider', quickInsert.provider);
        }
    };
    Editor.prototype.render = function () {
        var _this = this;
        var Component = Object(__WEBPACK_IMPORTED_MODULE_5__create_editor__["b" /* getUiComponent */])(this.props.appearance);
        var overriddenEditorProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, this.props, { onSave: this.props.onSave ? this.handleSave : undefined });
        var editor = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__["i" /* WidthProvider */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ui_EditorContext__["a" /* default */], { editorActions: this.editorActions },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ui_WithCreateAnalyticsEvent__["a" /* WithCreateAnalyticsEvent */], { render: function (createAnalyticsEvent) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ContextAdapter, null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ui_PortalProvider__["a" /* PortalProvider */], { render: function (portalProviderAPI) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__create_editor__["a" /* ReactEditorView */], { editorProps: overriddenEditorProps, createAnalyticsEvent: createAnalyticsEvent, portalProviderAPI: portalProviderAPI, providerFactory: _this.providerFactory, onEditorCreated: _this.onEditorCreated, onEditorDestroyed: _this.onEditorDestroyed, disabled: _this.props.disabled, render: function (_a) {
                                        var editor = _a.editor, view = _a.view, eventDispatcher = _a.eventDispatcher, config = _a.config;
                                        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__["a" /* BaseTheme */], { dynamicTextSizing: _this.props.allowDynamicTextSizing },
                                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Component, { disabled: _this.props.disabled, editorActions: _this.editorActions, editorDOMElement: editor, editorView: view, providerFactory: _this.providerFactory, eventDispatcher: eventDispatcher, maxHeight: _this.props.maxHeight, onSave: _this.props.onSave ? _this.handleSave : undefined, onCancel: _this.props.onCancel, popupsMountPoint: _this.props.popupsMountPoint, popupsBoundariesElement: _this.props.popupsBoundariesElement, contentComponents: config.contentComponents, primaryToolbarComponents: config.primaryToolbarComponents, secondaryToolbarComponents: config.secondaryToolbarComponents, insertMenuItems: _this.props.insertMenuItems, customContentComponents: _this.props.contentComponents, customPrimaryToolbarComponents: _this.props.primaryToolbarComponents, customSecondaryToolbarComponents: _this.props.secondaryToolbarComponents, addonToolbarComponents: _this.props.addonToolbarComponents, collabEdit: _this.props.collabEdit })));
                                    } }),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ui_PortalProvider__["b" /* PortalRenderer */], { portalProviderAPI: portalProviderAPI }))); } }))); } }))));
        return this.context.intl ? (editor) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["IntlProvider"], { locale: "en" }, editor));
    };
    Editor.defaultProps = {
        appearance: 'message',
        disabled: false,
        extensionHandlers: {},
    };
    Editor.contextTypes = {
        editorActions: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
        intl: __WEBPACK_IMPORTED_MODULE_3_react_intl__["intlShape"],
    };
    return Editor;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Editor);
//# sourceMappingURL=editor.js.map

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__(1635);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__color__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__macro__ = __webpack_require__(1636);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__macro__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validator__ = __webpack_require__(1637);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__validator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__browser__ = __webpack_require__(1704);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__browser__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_reporter__ = __webpack_require__(1705);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__error_reporter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__date__ = __webpack_require__(1706);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__date__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__date__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_5__date__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_5__date__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_5__date__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_5__date__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imageLoader__ = __webpack_require__(1708);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_6__imageLoader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__calc_breakout_width__ = __webpack_require__(1709);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__calc_breakout_width__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__calc_breakout_width__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__traversor__ = __webpack_require__(2000);
/* unused harmony reexport ADFTraversor */









//# sourceMappingURL=index.js.map

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__confluence_jira_issue__ = __webpack_require__(1639);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "confluenceJiraIssue", function() { return __WEBPACK_IMPORTED_MODULE_0__confluence_jira_issue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__confluence_unsupported_block__ = __webpack_require__(1640);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "confluenceUnsupportedBlock", function() { return __WEBPACK_IMPORTED_MODULE_1__confluence_unsupported_block__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__confluence_unsupported_inline__ = __webpack_require__(1641);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "confluenceUnsupportedInline", function() { return __WEBPACK_IMPORTED_MODULE_2__confluence_unsupported_inline__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__doc__ = __webpack_require__(1642);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "doc", function() { return __WEBPACK_IMPORTED_MODULE_3__doc__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blockquote__ = __webpack_require__(1643);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "blockquote", function() { return __WEBPACK_IMPORTED_MODULE_4__blockquote__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bullet_list__ = __webpack_require__(1644);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bulletList", function() { return __WEBPACK_IMPORTED_MODULE_5__bullet_list__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__code_block__ = __webpack_require__(1645);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "codeBlock", function() { return __WEBPACK_IMPORTED_MODULE_6__code_block__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "codeBlockToJSON", function() { return __WEBPACK_IMPORTED_MODULE_6__code_block__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hard_break__ = __webpack_require__(1647);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hardBreak", function() { return __WEBPACK_IMPORTED_MODULE_7__hard_break__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__heading__ = __webpack_require__(1648);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "heading", function() { return __WEBPACK_IMPORTED_MODULE_8__heading__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rule__ = __webpack_require__(1649);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "rule", function() { return __WEBPACK_IMPORTED_MODULE_9__rule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ordered_list__ = __webpack_require__(1650);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "orderedList", function() { return __WEBPACK_IMPORTED_MODULE_10__ordered_list__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__paragraph__ = __webpack_require__(1651);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "paragraph", function() { return __WEBPACK_IMPORTED_MODULE_11__paragraph__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__emoji__ = __webpack_require__(1652);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "emoji", function() { return __WEBPACK_IMPORTED_MODULE_12__emoji__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__image__ = __webpack_require__(1653);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "image", function() { return __WEBPACK_IMPORTED_MODULE_13__image__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mention__ = __webpack_require__(1654);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mention", function() { return __WEBPACK_IMPORTED_MODULE_14__mention__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mentionToJSON", function() { return __WEBPACK_IMPORTED_MODULE_14__mention__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__list_item__ = __webpack_require__(1655);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "listItem", function() { return __WEBPACK_IMPORTED_MODULE_15__list_item__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__panel__ = __webpack_require__(1656);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "panel", function() { return __WEBPACK_IMPORTED_MODULE_16__panel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__text__ = __webpack_require__(1657);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "text", function() { return __WEBPACK_IMPORTED_MODULE_17__text__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__unknown_block__ = __webpack_require__(1658);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "unknownBlock", function() { return __WEBPACK_IMPORTED_MODULE_18__unknown_block__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__media__ = __webpack_require__(1659);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "media", function() { return __WEBPACK_IMPORTED_MODULE_19__media__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "copyPrivateMediaAttributes", function() { return __WEBPACK_IMPORTED_MODULE_19__media__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mediaToJSON", function() { return __WEBPACK_IMPORTED_MODULE_19__media__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__media_group__ = __webpack_require__(1660);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mediaGroup", function() { return __WEBPACK_IMPORTED_MODULE_20__media_group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__media_single__ = __webpack_require__(1661);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mediaSingle", function() { return __WEBPACK_IMPORTED_MODULE_21__media_single__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mediaSingleToJSON", function() { return __WEBPACK_IMPORTED_MODULE_21__media_single__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__tableNodes__ = __webpack_require__(1662);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "table", function() { return __WEBPACK_IMPORTED_MODULE_22__tableNodes__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tableToJSON", function() { return __WEBPACK_IMPORTED_MODULE_22__tableNodes__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tableCell", function() { return __WEBPACK_IMPORTED_MODULE_22__tableNodes__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "toJSONTableCell", function() { return __WEBPACK_IMPORTED_MODULE_22__tableNodes__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tableHeader", function() { return __WEBPACK_IMPORTED_MODULE_22__tableNodes__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "toJSONTableHeader", function() { return __WEBPACK_IMPORTED_MODULE_22__tableNodes__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tableRow", function() { return __WEBPACK_IMPORTED_MODULE_22__tableNodes__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tableBackgroundColorPalette", function() { return __WEBPACK_IMPORTED_MODULE_22__tableNodes__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tableBackgroundBorderColors", function() { return __WEBPACK_IMPORTED_MODULE_22__tableNodes__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tableBackgroundColorNames", function() { return __WEBPACK_IMPORTED_MODULE_22__tableNodes__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "calcTableColumnWidths", function() { return __WEBPACK_IMPORTED_MODULE_22__tableNodes__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setCellAttrs", function() { return __WEBPACK_IMPORTED_MODULE_22__tableNodes__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__applicationCard__ = __webpack_require__(1663);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applicationCard", function() { return __WEBPACK_IMPORTED_MODULE_23__applicationCard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__decision_list__ = __webpack_require__(1664);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "decisionList", function() { return __WEBPACK_IMPORTED_MODULE_24__decision_list__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__decision_item__ = __webpack_require__(1665);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "decisionItem", function() { return __WEBPACK_IMPORTED_MODULE_25__decision_item__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__task_list__ = __webpack_require__(1666);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "taskList", function() { return __WEBPACK_IMPORTED_MODULE_26__task_list__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__task_item__ = __webpack_require__(1667);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "taskItem", function() { return __WEBPACK_IMPORTED_MODULE_27__task_item__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__extension__ = __webpack_require__(1668);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "extension", function() { return __WEBPACK_IMPORTED_MODULE_28__extension__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__inline_extension__ = __webpack_require__(1669);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "inlineExtension", function() { return __WEBPACK_IMPORTED_MODULE_29__inline_extension__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__bodied_extension__ = __webpack_require__(1670);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bodiedExtension", function() { return __WEBPACK_IMPORTED_MODULE_30__bodied_extension__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__date__ = __webpack_require__(1671);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "date", function() { return __WEBPACK_IMPORTED_MODULE_31__date__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__placeholder__ = __webpack_require__(1672);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "placeholder", function() { return __WEBPACK_IMPORTED_MODULE_32__placeholder__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__layout_section__ = __webpack_require__(1673);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "layoutSection", function() { return __WEBPACK_IMPORTED_MODULE_33__layout_section__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__layout_column__ = __webpack_require__(1674);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "layoutColumn", function() { return __WEBPACK_IMPORTED_MODULE_34__layout_column__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__inline_card__ = __webpack_require__(1675);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "inlineCard", function() { return __WEBPACK_IMPORTED_MODULE_35__inline_card__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__block_card__ = __webpack_require__(1676);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "blockCard", function() { return __WEBPACK_IMPORTED_MODULE_36__block_card__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__unsupported_block__ = __webpack_require__(1677);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "unsupportedBlock", function() { return __WEBPACK_IMPORTED_MODULE_37__unsupported_block__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__unsupported_inline__ = __webpack_require__(1678);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "unsupportedInline", function() { return __WEBPACK_IMPORTED_MODULE_38__unsupported_inline__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__status__ = __webpack_require__(1679);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "status", function() { return __WEBPACK_IMPORTED_MODULE_39__status__["a"]; });








































//# sourceMappingURL=index.js.map

/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports=/[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(74)

/**
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|String|Number} date - the date that should be before the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore (dirtyDate, dirtyDateToCompare) {
  var date = parse(dirtyDate)
  var dateToCompare = parse(dirtyDateToCompare)
  return date.getTime() < dateToCompare.getTime()
}

module.exports = isBefore


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = themed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTheme__ = __webpack_require__(640);
/* eslint-disable prefer-rest-params */


function themedVariants(variantProp, variants) {
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);

    if (props && props[variantProp] && variants) {
      var modes = variants[props[variantProp]];

      if (modes) {
        return modes[theme.mode];
      }
    }

    return '';
  };
}

function themed(modesOrVariant, variantModes) {
  if (typeof modesOrVariant === 'string') {
    return themedVariants(modesOrVariant, variantModes);
  }

  var modes = modesOrVariant;
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    return modes[theme.mode];
  };
}

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createTheme__ = __webpack_require__(379);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils_createTheme__["a" /* createTheme */])(function () {
  return {
    mode: 'light'
  };
}));

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


function createTheme(defaultThemeFn) {
  var emptyThemeFn = function emptyThemeFn(tokens, props) {
    return tokens(props);
  };

  var ThemeContext = Object(__WEBPACK_IMPORTED_MODULE_1_react__["createContext"])(defaultThemeFn);

  function Consumer(props) {
    var children = props.children,
        themeProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(props, ["children"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ThemeContext.Consumer, null, function (theme) {
      var themeFn = theme || emptyThemeFn;
      return props.children(themeFn(themeProps));
    });
  }

  function Provider(props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ThemeContext.Consumer, null, function (themeFn) {
      var valueFn = props.value || emptyThemeFn;

      var mixedFn = function mixedFn(themeProps) {
        return valueFn(themeFn, themeProps);
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ThemeContext.Provider, {
        value: mixedFn
      }, props.children);
    });
  }

  return {
    Consumer: Consumer,
    Provider: Provider
  };
}

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManagerContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_create_react_context__ = __webpack_require__(1748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_create_react_context__);







var ManagerContext = __WEBPACK_IMPORTED_MODULE_5_create_react_context___default()({ getReferenceRef: undefined, referenceNode: undefined });

var Manager = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Manager, _React$Component);

  function Manager() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Manager);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this));

    _this.getReferenceRef = function (referenceNode) {
      return _this.setState(function (_ref) {
        var context = _ref.context;
        return {
          context: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, context, { referenceNode: referenceNode })
        };
      });
    };

    _this.state = {
      context: {
        getReferenceRef: _this.getReferenceRef,
        referenceNode: undefined
      }
    };
    return _this;
  }

  Manager.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](
      ManagerContext.Provider,
      { value: this.state.context },
      this.props.children
    );
  };

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["b"] = (Manager);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';

var index = (function (condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  }

  throw new Error(prefix + ': ' + (message || ''));
});

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UIAnalyticsEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get__ = __webpack_require__(1755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AnalyticsEvent__ = __webpack_require__(651);










var _console = console,
    warn = _console.warn;

var UIAnalyticsEvent =
/*#__PURE__*/
function (_AnalyticsEvent) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(UIAnalyticsEvent, _AnalyticsEvent);

  function UIAnalyticsEvent(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, UIAnalyticsEvent);

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(UIAnalyticsEvent).call(this, props));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "context", void 0);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handlers", void 0);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "hasFired", void 0);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "clone", function () {
      if (_this.hasFired) {
        warn("Cannot clone an event after it's been fired.");
        return null;
      }

      var context = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(_this.context);

      var handlers = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(_this.handlers); // We stringify and parse here to get a hacky "deep clone" of the object.
      // This has some limitations in that it wont support functions, regexs, Maps, Sets, etc,
      // but none of those need to be represented in our payload, so we consider this fine


      var payload = JSON.parse(JSON.stringify(_this.payload));
      return new UIAnalyticsEvent({
        context: context,
        handlers: handlers,
        payload: payload
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "fire", function (channel) {
      if (_this.hasFired) {
        warn('Cannot fire an event twice.');
        return;
      }

      _this.handlers.forEach(function (handler) {
        handler(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), channel);
      });

      _this.hasFired = true;
    });

    _this.context = props.context || [];
    _this.handlers = props.handlers || [];
    _this.hasFired = false;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(UIAnalyticsEvent, [{
    key: "update",
    value: function update(updater) {
      if (this.hasFired) {
        warn("Cannot update an event after it's been fired.");
        return this;
      }

      return __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
    }
  }]);

  return UIAnalyticsEvent;
}(__WEBPACK_IMPORTED_MODULE_9__AnalyticsEvent__["a" /* default */]);



/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


/**
 * A base class for components that don't want to start rendering
 * until the EmojiProvider is resolved.
 * Notes: super.componentDidMount and super.componentWillUnmount will need to be
 * called explicitly if they are overridden on the child class.
 */
var LoadingEmojiComponent = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](LoadingEmojiComponent, _super);
    function LoadingEmojiComponent(props, state) {
        var _this = _super.call(this, props) || this;
        _this.loaded = function (state) { return !!state.asyncLoadedComponent && !!state.loadedEmojiProvider; };
        _this.state = state;
        return _this;
    }
    LoadingEmojiComponent.prototype.componentWillMount = function () {
        // using componentWillMount instead of componentDidMount to avoid needless
        // rerendering if emojiProvider resolves immediately.
        this.loadEmojiProvider(this.props.emojiProvider);
    };
    LoadingEmojiComponent.prototype.componentDidMount = function () {
        // check for the module has not yet been loaded
        // state.asyncLoadedComponent should be initialised
        // with static field to prevent unnecessary rerender
        if (!this.state.asyncLoadedComponent) {
            this.asyncLoadComponent();
        }
    };
    LoadingEmojiComponent.prototype.componentWillReceiveProps = function (nextProps) {
        this.loadEmojiProvider(nextProps.emojiProvider);
    };
    LoadingEmojiComponent.prototype.componentWillUnmount = function () {
        this.isUnmounted = true;
    };
    LoadingEmojiComponent.prototype.loadEmojiProvider = function (futureEmojiProvider) {
        var _this = this;
        futureEmojiProvider
            .then(function (loadedEmojiProvider) {
            if (!_this.isUnmounted) {
                _this.setState({
                    loadedEmojiProvider: loadedEmojiProvider,
                });
            }
        })
            .catch(function (err) {
            if (!_this.isUnmounted) {
                _this.setState({
                    loadedEmojiProvider: undefined,
                });
            }
        });
    };
    LoadingEmojiComponent.prototype.setAsyncState = function (asyncLoadedComponent) {
        if (!this.isUnmounted) {
            this.setState({ asyncLoadedComponent: asyncLoadedComponent });
        }
    };
    LoadingEmojiComponent.prototype.renderLoading = function () {
        return null;
    };
    LoadingEmojiComponent.prototype.render = function () {
        if (this.loaded(this.state)) {
            var _a = this.state, loadedEmojiProvider = _a.loadedEmojiProvider, asyncLoadedComponent = _a.asyncLoadedComponent;
            return this.renderLoaded(loadedEmojiProvider, asyncLoadedComponent);
        }
        return this.renderLoading();
    };
    return LoadingEmojiComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (LoadingEmojiComponent);
//# sourceMappingURL=LoadingEmojiComponent.js.map

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AllSubstringsIndexStrategy = __webpack_require__(1817);

Object.defineProperty(exports, 'AllSubstringsIndexStrategy', {
  enumerable: true,
  get: function get() {
    return _AllSubstringsIndexStrategy.AllSubstringsIndexStrategy;
  }
});

var _ExactWordIndexStrategy = __webpack_require__(1818);

Object.defineProperty(exports, 'ExactWordIndexStrategy', {
  enumerable: true,
  get: function get() {
    return _ExactWordIndexStrategy.ExactWordIndexStrategy;
  }
});

var _PrefixIndexStrategy = __webpack_require__(1819);

Object.defineProperty(exports, 'PrefixIndexStrategy', {
  enumerable: true,
  get: function get() {
    return _PrefixIndexStrategy.PrefixIndexStrategy;
  }
});
//# sourceMappingURL=index.js.map

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CaseSensitiveSanitizer = __webpack_require__(1820);

Object.defineProperty(exports, 'CaseSensitiveSanitizer', {
  enumerable: true,
  get: function get() {
    return _CaseSensitiveSanitizer.CaseSensitiveSanitizer;
  }
});

var _LowerCaseSanitizer = __webpack_require__(1821);

Object.defineProperty(exports, 'LowerCaseSanitizer', {
  enumerable: true,
  get: function get() {
    return _LowerCaseSanitizer.LowerCaseSanitizer;
  }
});
//# sourceMappingURL=index.js.map

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isClientBasedAuth;
/* unused harmony export isAsapBasedAuth */
function isClientBasedAuth(auth) {
    return !!auth.clientId;
}
function isAsapBasedAuth(auth) {
    return !!auth.asapIssuer;
}
//# sourceMappingURL=auth.js.map

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(112);
var Symbol = root_1.root.Symbol;
exports.rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function') ?
    Symbol.for('rxSubscriber') : '@@rxSubscriber';
/**
 * @deprecated use rxSubscriber instead
 */
exports.$$rxSubscriber = exports.rxSubscriber;
//# sourceMappingURL=rxSubscriber.js.map

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeMap_1 = __webpack_require__(389);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */
function concatMap(project, resultSelector) {
    return mergeMap_1.mergeMap(project, resultSelector, 1);
}
exports.concatMap = concatMap;
//# sourceMappingURL=concatMap.js.map

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var subscribeToResult_1 = __webpack_require__(390);
var OuterSubscriber_1 = __webpack_require__(393);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return function mergeMapOperatorFunction(source) {
        if (typeof resultSelector === 'number') {
            concurrent = resultSelector;
            resultSelector = null;
        }
        return source.lift(new MergeMapOperator(project, resultSelector, concurrent));
    };
}
exports.mergeMap = mergeMap;
var MergeMapOperator = (function () {
    function MergeMapOperator(project, resultSelector, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
    };
    return MergeMapOperator;
}());
exports.MergeMapOperator = MergeMapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MergeMapSubscriber = (function (_super) {
    __extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            this._tryNext(value);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeMapSubscriber.prototype._tryNext = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result, value, index);
    };
    MergeMapSubscriber.prototype._innerSub = function (ish, value, index) {
        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
    };
    MergeMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
    };
    MergeMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) {
            this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            this.destination.next(innerValue);
        }
    };
    MergeMapSubscriber.prototype._notifyResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    MergeMapSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeMapSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.MergeMapSubscriber = MergeMapSubscriber;
//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(112);
var isArrayLike_1 = __webpack_require__(686);
var isPromise_1 = __webpack_require__(687);
var isObject_1 = __webpack_require__(683);
var Observable_1 = __webpack_require__(42);
var iterator_1 = __webpack_require__(392);
var InnerSubscriber_1 = __webpack_require__(1851);
var observable_1 = __webpack_require__(391);
function subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
    var destination = new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
    if (destination.closed) {
        return null;
    }
    if (result instanceof Observable_1.Observable) {
        if (result._isScalar) {
            destination.next(result.value);
            destination.complete();
            return null;
        }
        else {
            destination.syncErrorThrowable = true;
            return result.subscribe(destination);
        }
    }
    else if (isArrayLike_1.isArrayLike(result)) {
        for (var i = 0, len = result.length; i < len && !destination.closed; i++) {
            destination.next(result[i]);
        }
        if (!destination.closed) {
            destination.complete();
        }
    }
    else if (isPromise_1.isPromise(result)) {
        result.then(function (value) {
            if (!destination.closed) {
                destination.next(value);
                destination.complete();
            }
        }, function (err) { return destination.error(err); })
            .then(null, function (err) {
            // Escaping the Promise trap: globally throw unhandled errors
            root_1.root.setTimeout(function () { throw err; });
        });
        return destination;
    }
    else if (result && typeof result[iterator_1.iterator] === 'function') {
        var iterator = result[iterator_1.iterator]();
        do {
            var item = iterator.next();
            if (item.done) {
                destination.complete();
                break;
            }
            destination.next(item.value);
            if (destination.closed) {
                break;
            }
        } while (true);
    }
    else if (result && typeof result[observable_1.observable] === 'function') {
        var obs = result[observable_1.observable]();
        if (typeof obs.subscribe !== 'function') {
            destination.error(new TypeError('Provided object does not correctly implement Symbol.observable'));
        }
        else {
            return obs.subscribe(new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
        }
    }
    else {
        var value = isObject_1.isObject(result) ? 'an invalid object' : "'" + result + "'";
        var msg = ("You provided " + value + " where a stream was expected.")
            + ' You can provide an Observable, Promise, Array, or Iterable.';
        destination.error(new TypeError(msg));
    }
    return null;
}
exports.subscribeToResult = subscribeToResult;
//# sourceMappingURL=subscribeToResult.js.map

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(112);
function getSymbolObservable(context) {
    var $$observable;
    var Symbol = context.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) {
            $$observable = Symbol.observable;
        }
        else {
            $$observable = Symbol('observable');
            Symbol.observable = $$observable;
        }
    }
    else {
        $$observable = '@@observable';
    }
    return $$observable;
}
exports.getSymbolObservable = getSymbolObservable;
exports.observable = getSymbolObservable(root_1.root);
/**
 * @deprecated use observable instead
 */
exports.$$observable = exports.observable;
//# sourceMappingURL=observable.js.map

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(112);
function symbolIteratorPonyfill(root) {
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (!Symbol.iterator) {
            Symbol.iterator = Symbol('iterator polyfill');
        }
        return Symbol.iterator;
    }
    else {
        // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
        var Set_1 = root.Set;
        if (Set_1 && typeof new Set_1()['@@iterator'] === 'function') {
            return '@@iterator';
        }
        var Map_1 = root.Map;
        // required for compatability with es6-shim
        if (Map_1) {
            var keys = Object.getOwnPropertyNames(Map_1.prototype);
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
                if (key !== 'entries' && key !== 'size' && Map_1.prototype[key] === Map_1.prototype['entries']) {
                    return key;
                }
            }
        }
        return '@@iterator';
    }
}
exports.symbolIteratorPonyfill = symbolIteratorPonyfill;
exports.iterator = symbolIteratorPonyfill(root_1.root);
/**
 * @deprecated use iterator instead
 */
exports.$$iterator = exports.iterator;
//# sourceMappingURL=iterator.js.map

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(90);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var OuterSubscriber = (function (_super) {
    __extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        _super.apply(this, arguments);
    }
    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}(Subscriber_1.Subscriber));
exports.OuterSubscriber = OuterSubscriber;
//# sourceMappingURL=OuterSubscriber.js.map

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(42);
var Subscriber_1 = __webpack_require__(90);
var Subscription_1 = __webpack_require__(158);
var ObjectUnsubscribedError_1 = __webpack_require__(690);
var SubjectSubscription_1 = __webpack_require__(691);
var rxSubscriber_1 = __webpack_require__(387);
/**
 * @class SubjectSubscriber<T>
 */
var SubjectSubscriber = (function (_super) {
    __extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        _super.call(this, destination);
        this.destination = destination;
    }
    return SubjectSubscriber;
}(Subscriber_1.Subscriber));
exports.SubjectSubscriber = SubjectSubscriber;
/**
 * @class Subject<T>
 */
var Subject = (function (_super) {
    __extends(Subject, _super);
    function Subject() {
        _super.call(this);
        this.observers = [];
        this.closed = false;
        this.isStopped = false;
        this.hasError = false;
        this.thrownError = null;
    }
    Subject.prototype[rxSubscriber_1.rxSubscriber] = function () {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function (operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function (value) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].next(value);
            }
        }
    };
    Subject.prototype.error = function (err) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].error(err);
        }
        this.observers.length = 0;
    };
    Subject.prototype.complete = function () {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].complete();
        }
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function () {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function (subscriber) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else {
            return _super.prototype._trySubscribe.call(this, subscriber);
        }
    };
    /** @deprecated internal use only */ Subject.prototype._subscribe = function (subscriber) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return Subscription_1.Subscription.EMPTY;
        }
        else if (this.isStopped) {
            subscriber.complete();
            return Subscription_1.Subscription.EMPTY;
        }
        else {
            this.observers.push(subscriber);
            return new SubjectSubscription_1.SubjectSubscription(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function () {
        var observable = new Observable_1.Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function (destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}(Observable_1.Observable));
exports.Subject = Subject;
/**
 * @class AnonymousSubject<T>
 */
var AnonymousSubject = (function (_super) {
    __extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        _super.call(this);
        this.destination = destination;
        this.source = source;
    }
    AnonymousSubject.prototype.next = function (value) {
        var destination = this.destination;
        if (destination && destination.next) {
            destination.next(value);
        }
    };
    AnonymousSubject.prototype.error = function (err) {
        var destination = this.destination;
        if (destination && destination.error) {
            this.destination.error(err);
        }
    };
    AnonymousSubject.prototype.complete = function () {
        var destination = this.destination;
        if (destination && destination.complete) {
            this.destination.complete();
        }
    };
    /** @deprecated internal use only */ AnonymousSubject.prototype._subscribe = function (subscriber) {
        var source = this.source;
        if (source) {
            return this.source.subscribe(subscriber);
        }
        else {
            return Subscription_1.Subscription.EMPTY;
        }
    };
    return AnonymousSubject;
}(Subject));
exports.AnonymousSubject = AnonymousSubject;
//# sourceMappingURL=Subject.js.map

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(42);
var ScalarObservable_1 = __webpack_require__(694);
var EmptyObservable_1 = __webpack_require__(695);
var isScheduler_1 = __webpack_require__(696);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ArrayObservable = (function (_super) {
    __extends(ArrayObservable, _super);
    function ArrayObservable(array, scheduler) {
        _super.call(this);
        this.array = array;
        this.scheduler = scheduler;
        if (!scheduler && array.length === 1) {
            this._isScalar = true;
            this.value = array[0];
        }
    }
    ArrayObservable.create = function (array, scheduler) {
        return new ArrayObservable(array, scheduler);
    };
    /**
     * Creates an Observable that emits some values you specify as arguments,
     * immediately one after the other, and then emits a complete notification.
     *
     * <span class="informal">Emits the arguments you provide, then completes.
     * </span>
     *
     * <img src="./img/of.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the arguments given, and the complete notification thereafter. It can
     * be used for composing with other Observables, such as with {@link concat}.
     * By default, it uses a `null` IScheduler, which means the `next`
     * notifications are sent synchronously, although with a different IScheduler
     * it is possible to determine when those notifications will be delivered.
     *
     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
     * var numbers = Rx.Observable.of(10, 20, 30);
     * var letters = Rx.Observable.of('a', 'b', 'c');
     * var interval = Rx.Observable.interval(1000);
     * var result = numbers.concat(letters).concat(interval);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link throw}
     *
     * @param {...T} values Arguments that represent `next` values to be emitted.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the `next` notifications.
     * @return {Observable<T>} An Observable that emits each given input value.
     * @static true
     * @name of
     * @owner Observable
     */
    ArrayObservable.of = function () {
        var array = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            array[_i - 0] = arguments[_i];
        }
        var scheduler = array[array.length - 1];
        if (isScheduler_1.isScheduler(scheduler)) {
            array.pop();
        }
        else {
            scheduler = null;
        }
        var len = array.length;
        if (len > 1) {
            return new ArrayObservable(array, scheduler);
        }
        else if (len === 1) {
            return new ScalarObservable_1.ScalarObservable(array[0], scheduler);
        }
        else {
            return new EmptyObservable_1.EmptyObservable(scheduler);
        }
    };
    ArrayObservable.dispatch = function (state) {
        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(array[index]);
        if (subscriber.closed) {
            return;
        }
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var array = this.array;
        var count = array.length;
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(ArrayObservable.dispatch, 0, {
                array: array, index: index, count: count, subscriber: subscriber
            });
        }
        else {
            for (var i = 0; i < count && !subscriber.closed; i++) {
                subscriber.next(array[i]);
            }
            subscriber.complete();
        }
    };
    return ArrayObservable;
}(Observable_1.Observable));
exports.ArrayObservable = ArrayObservable;
//# sourceMappingURL=ArrayObservable.js.map

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(394);
var queue_1 = __webpack_require__(1872);
var Subscription_1 = __webpack_require__(158);
var observeOn_1 = __webpack_require__(697);
var ObjectUnsubscribedError_1 = __webpack_require__(690);
var SubjectSubscription_1 = __webpack_require__(691);
/**
 * @class ReplaySubject<T>
 */
var ReplaySubject = (function (_super) {
    __extends(ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) { bufferSize = Number.POSITIVE_INFINITY; }
        if (windowTime === void 0) { windowTime = Number.POSITIVE_INFINITY; }
        _super.call(this);
        this.scheduler = scheduler;
        this._events = [];
        this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        this._windowTime = windowTime < 1 ? 1 : windowTime;
    }
    ReplaySubject.prototype.next = function (value) {
        var now = this._getNow();
        this._events.push(new ReplayEvent(now, value));
        this._trimBufferThenGetEvents();
        _super.prototype.next.call(this, value);
    };
    /** @deprecated internal use only */ ReplaySubject.prototype._subscribe = function (subscriber) {
        var _events = this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var subscription;
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else if (this.hasError) {
            subscription = Subscription_1.Subscription.EMPTY;
        }
        else if (this.isStopped) {
            subscription = Subscription_1.Subscription.EMPTY;
        }
        else {
            this.observers.push(subscriber);
            subscription = new SubjectSubscription_1.SubjectSubscription(this, subscriber);
        }
        if (scheduler) {
            subscriber.add(subscriber = new observeOn_1.ObserveOnSubscriber(subscriber, scheduler));
        }
        var len = _events.length;
        for (var i = 0; i < len && !subscriber.closed; i++) {
            subscriber.next(_events[i].value);
        }
        if (this.hasError) {
            subscriber.error(this.thrownError);
        }
        else if (this.isStopped) {
            subscriber.complete();
        }
        return subscription;
    };
    ReplaySubject.prototype._getNow = function () {
        return (this.scheduler || queue_1.queue).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function () {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        // Trim events that fall out of the time window.
        // Start at the front of the list. Break early once
        // we encounter an event that falls within the window.
        while (spliceCount < eventsCount) {
            if ((now - _events[spliceCount].time) < _windowTime) {
                break;
            }
            spliceCount++;
        }
        if (eventsCount > _bufferSize) {
            spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        }
        if (spliceCount > 0) {
            _events.splice(0, spliceCount);
        }
        return _events;
    };
    return ReplaySubject;
}(Subject_1.Subject));
exports.ReplaySubject = ReplaySubject;
var ReplayEvent = (function () {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}());
//# sourceMappingURL=ReplaySubject.js.map

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isErrorFileState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mapMediaFileToFileState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapMediaItemToFileState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

var isErrorFileState = function (fileState) {
    return fileState.status === 'error';
};
var apiProcessingStatusToFileStatus = function (fileStatus) {
    switch (fileStatus) {
        case 'pending':
            return 'processing';
        case 'succeeded':
            return 'processed';
        case 'failed':
            return 'failed-processing';
        case undefined:
            return 'processing';
    }
};
var mapMediaFileToFileState = function (mediaFile) {
    var _a = mediaFile.data, id = _a.id, name = _a.name, size = _a.size, processingStatus = _a.processingStatus, artifacts = _a.artifacts, mediaType = _a.mediaType, mimeType = _a.mimeType;
    var status = apiProcessingStatusToFileStatus(processingStatus);
    switch (processingStatus) {
        case 'pending':
        case undefined:
            return {
                id: id,
                status: status,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
            };
        case 'succeeded':
            return {
                id: id,
                status: status,
                name: name,
                size: size,
                artifacts: artifacts,
                mediaType: mediaType,
                mimeType: mimeType,
            };
        case 'failed':
            return {
                id: id,
                status: status,
                name: name,
                size: size,
                artifacts: artifacts,
                mediaType: mediaType,
                mimeType: mimeType,
            };
    }
};
var mapMediaItemToFileState = function (id, item) {
    return mapMediaFileToFileState({
        data: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ id: id }, item),
    });
};
//# sourceMappingURL=fileState.js.map

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FileStreamCache */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fileStreamsCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lru_fast__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lru_fast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lru_fast__);

var FileStreamCache = /** @class */ (function () {
    function FileStreamCache() {
        this.fileStreams = new __WEBPACK_IMPORTED_MODULE_0_lru_fast__["LRUCache"](1000);
    }
    FileStreamCache.prototype.has = function (id) {
        return !!this.fileStreams.find(id);
    };
    FileStreamCache.prototype.set = function (id, fileStream) {
        this.fileStreams.set(id, fileStream);
    };
    FileStreamCache.prototype.get = function (id) {
        return this.fileStreams.get(id);
    };
    FileStreamCache.prototype.getOrInsert = function (id, callback) {
        if (!this.has(id)) {
            this.set(id, callback());
        }
        return this.get(id);
    };
    FileStreamCache.prototype.removeAll = function () {
        this.fileStreams.removeAll();
    };
    FileStreamCache.prototype.remove = function (id) {
        this.fileStreams.remove(id);
    };
    Object.defineProperty(FileStreamCache.prototype, "size", {
        get: function () {
            return this.fileStreams.size;
        },
        enumerable: true,
        configurable: true
    });
    return FileStreamCache;
}());

var fileStreamsCache = new FileStreamCache();
/* unused harmony default export */ var _unused_webpack_default_export = (FileStreamCache);
//# sourceMappingURL=fileStreamCache.js.map

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withProviders__ = __webpack_require__(1894);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__withProviders__["a"]; });

var ProviderFactory = /** @class */ (function () {
    function ProviderFactory() {
        this.providers = new Map();
        this.subscribers = new Map();
    }
    ProviderFactory.create = function (providers) {
        var providerFactory = new ProviderFactory();
        Object.keys(providers).forEach(function (name) {
            providerFactory.setProvider(name, providers[name]);
        });
        return providerFactory;
    };
    ProviderFactory.prototype.destroy = function () {
        this.providers.clear();
        this.subscribers.clear();
    };
    ProviderFactory.prototype.isEmpty = function () {
        return !this.providers.size && !this.subscribers.size;
    };
    ProviderFactory.prototype.setProvider = function (name, provider) {
        // Do not trigger notifyUpdate if provider is the same.
        if (provider && this.providers.get(name) === provider) {
            return;
        }
        if (provider) {
            this.providers.set(name, provider);
        }
        else {
            this.providers.delete(name);
        }
        this.notifyUpdated(name, provider);
    };
    ProviderFactory.prototype.removeProvider = function (name) {
        this.providers.delete(name);
        this.notifyUpdated(name);
    };
    ProviderFactory.prototype.subscribe = function (name, handler) {
        var handlers = this.subscribers.get(name) || [];
        handlers.push(handler);
        this.subscribers.set(name, handlers);
        var provider = this.providers.get(name);
        if (provider) {
            handler(name, provider);
        }
    };
    ProviderFactory.prototype.unsubscribe = function (name, handler) {
        var handlers = this.subscribers.get(name);
        if (!handlers) {
            return;
        }
        var index = handlers.indexOf(handler);
        if (index !== -1) {
            handlers.splice(index, 1);
        }
        if (handlers.length === 0) {
            this.subscribers.delete(name);
        }
        else {
            this.subscribers.set(name, handlers);
        }
    };
    ProviderFactory.prototype.unsubscribeAll = function (name) {
        var handlers = this.subscribers.get(name);
        if (!handlers) {
            return;
        }
        this.subscribers.delete(name);
    };
    ProviderFactory.prototype.hasProvider = function (name) {
        return this.providers.has(name);
    };
    ProviderFactory.prototype.notifyUpdated = function (name, provider) {
        var handlers = this.subscribers.get(name);
        if (!handlers) {
            return;
        }
        handlers.forEach(function (handler) {
            handler(name, provider);
        });
    };
    return ProviderFactory;
}());
/* harmony default export */ __webpack_exports__["b"] = (ProviderFactory);
//# sourceMappingURL=index.js.map

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBorderRadius;
/* unused harmony export getSize */
/* unused harmony export getAvatarDimensions */
/* harmony export (immutable) */ __webpack_exports__["b"] = getInnerStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(199);



var backgroundColorFocus = __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].B200;
var overlayColorDefault = 'transparent';
var overlayColorHover = __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N70A;
var overlayColorSelected = __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N200A;
var overlayColorDisabled = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: 'rgba(255, 255, 255, 0.7)',
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN80A
}); // "square" avatars are explicit

function getBorderRadius(props) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    includeBorderWidth: false
  };
  var borderWidth = config.includeBorderWidth ? __WEBPACK_IMPORTED_MODULE_2__constants__["c" /* BORDER_WIDTH */][props.size] : 0;
  return props.appearance === 'circle' ? '50%' : "".concat(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* AVATAR_RADIUS */][props.size] + borderWidth, "px");
}
var getSize = function getSize(props) {
  return __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* AVATAR_SIZES */][props.size];
}; // for testing

function getAvatarDimensions(props) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    includeBorderWidth: false,
    sizeOnly: false
  };
  var borderWidth = config.includeBorderWidth ? __WEBPACK_IMPORTED_MODULE_2__constants__["c" /* BORDER_WIDTH */][props.size] * 2 : 0;
  var size = __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* AVATAR_SIZES */][props.size] + borderWidth;
  return config.sizeOnly ? size : "\n    height: ".concat(size, "px;\n    width: ").concat(size, "px;\n  ");
} // expose here for use with multiple element types

function getInnerStyles(props) {
  var boxSizing = 'content-box';
  var borderWidth = "".concat(__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* BORDER_WIDTH */][props.size], "px");
  var isInteractive = Boolean(props.isInteractive || props.href || props.onClick); // We make the distinction between isInteractive and isClickable as supplying a tooltip
  // makes the avatar interactive but not clickable

  var isClickable = Boolean(props.href || props.onClick);
  var backgroundColor = props.borderColor || __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].background; // Inherit cursor styles so we don't cancel out pointer cursors in places like avatar group more dropdown

  var cursor = 'inherit';
  var outline = 'none';
  var overlayShade = overlayColorDefault;
  var overlayOpacity = 0;
  var pointerEvents = 'auto';
  var position = 'static';
  var transform = 'translateZ(0)';
  var transitionDuration = '0s'; // Interaction: Hover

  if (isInteractive && (props.isActive || props.isHover)) {
    overlayShade = overlayColorHover;
    overlayOpacity = 1;
  } // Interaction: Active


  if (isClickable && props.isActive) {
    transform = 'scale(0.9)';
  } // Interaction: Focus


  if (isInteractive && props.isFocus && !props.isActive) {
    outline = 'none';
    backgroundColor = backgroundColorFocus;
    transitionDuration = __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* TRANSITION_DURATION */];
  } // Disabled


  if (props.isDisabled) {
    cursor = 'not-allowed';
    overlayShade = overlayColorDisabled;
    overlayOpacity = 1;
    pointerEvents = 'none';
  } // Clickable


  if (isClickable) {
    cursor = 'pointer';
  } // Loading


  if (props.isSelected) {
    overlayShade = overlayColorSelected;
    overlayOpacity = 1;
  } // Stack


  if (props.stackIndex) {
    position = 'relative';
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n    ", ";\n    align-items: stretch;\n    background-color: ", ";\n    border: 0;\n    border-radius: ", ";\n    padding: ", ";\n    box-sizing: ", ";\n    cursor: ", ";\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    outline: ", ";\n    overflow: hidden;\n    pointer-events: ", ";\n    position: ", ";\n    transform: ", ";\n    transition: background-color ", " ease-out;\n\n    a &,\n    button & {\n      cursor: pointer;\n    }\n\n    &::after {\n      background-color: ", ";\n      border-radius: ", ";\n      bottom: ", ";\n      content: ' ';\n      left: ", ";\n      opacity: ", ";\n      pointer-events: none;\n      position: absolute;\n      right: ", ";\n      top: ", ";\n      transition: opacity ", ";\n    }\n\n    &::-moz-focus-inner {\n      border: 0;\n      margin: 0;\n      padding: 0;\n    }\n  "], getAvatarDimensions, backgroundColor, function (p) {
    return getBorderRadius(p, {
      includeBorderWidth: true
    });
  }, borderWidth, boxSizing, cursor, outline, pointerEvents, position, transform, transitionDuration, overlayShade, getBorderRadius, borderWidth, borderWidth, overlayOpacity, borderWidth, borderWidth, __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* TRANSITION_DURATION */]);
}

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPresenceSVG__ = __webpack_require__(710);
/* unused harmony reexport getPresenceSVG */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getProps__ = __webpack_require__(1905);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__getProps__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getStatusSVG__ = __webpack_require__(712);
/* unused harmony reexport getStatusSVG */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getStyledAvatar__ = __webpack_require__(1906);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__getStyledAvatar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getStyledAvatarItem__ = __webpack_require__(1908);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__getStyledAvatarItem__["a"]; });






/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapProps__ = __webpack_require__(1909);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__mapProps__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__withPseudoState__ = __webpack_require__(1910);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__withPseudoState__["a"]; });



/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export noPropFormatter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NoAccessWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NoAccessLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DefaultHeadline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultAdvisedAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LoginAgain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DifferentText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_i18n__ = __webpack_require__(1920);




var noPropFormatter = function (messageDescriptor) { return function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["FormattedMessage"], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, props, messageDescriptor))); }; };
var NoAccessWarning = function (_a) {
    var name = _a.name, props = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["name"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["FormattedMessage"], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, props, { values: { name: name } }, __WEBPACK_IMPORTED_MODULE_3__components_i18n__["a" /* messages */].noAccessWarning)));
};
var NoAccessLabel = noPropFormatter(__WEBPACK_IMPORTED_MODULE_3__components_i18n__["a" /* messages */].noAccessLabel);
var DefaultHeadline = noPropFormatter(__WEBPACK_IMPORTED_MODULE_3__components_i18n__["a" /* messages */].defaultHeadline);
var DefaultAdvisedAction = noPropFormatter(__WEBPACK_IMPORTED_MODULE_3__components_i18n__["a" /* messages */].defaultAdvisedAction);
var LoginAgain = noPropFormatter(__WEBPACK_IMPORTED_MODULE_3__components_i18n__["a" /* messages */].loginAgain);
var DifferentText = noPropFormatter(__WEBPACK_IMPORTED_MODULE_3__components_i18n__["a" /* messages */].differentText);
//# sourceMappingURL=i18n.js.map

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return noDialogContainerBorderColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return noDialogContainerBorderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return noDialogContainerBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return scrollableMaxHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mentionListWidth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);

var noDialogContainerBorderColor = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N40; // This has not been confirmed by the ADG yet
var noDialogContainerBorderRadius = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["borderRadius"])() + "px";
var noDialogContainerBoxShadow = '0 4px 8px -2px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)'; // Copied from droplist style
var scrollableMaxHeight = '264px';
var mentionListWidth = '340px';
//# sourceMappingURL=shared-styles.js.map

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__profilecard__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_profile_client__ = __webpack_require__(1983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__profilecard_resourced__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__profilecard_trigger__ = __webpack_require__(1984);
/* unused harmony reexport AkProfilecard */
/* unused harmony reexport AkProfilecardTrigger */
/* unused harmony reexport AkProfileClient */
/* unused harmony reexport modifyResponse */







/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__profilecard_resourced__["a" /* default */]);

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bgColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return headerBgColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return headerBgColorDisabledUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return headerTextColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return headerTextColorInactive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return appLabelBgColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return appLabelTextColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return labelTextColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return labelIconColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return errorIconColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return errorTitleColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return errorTextColor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);

var bgColor = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0,
  dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN50
});
var headerBgColor = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B500,
  dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100
});
var headerBgColorDisabledUser = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N30,
  dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100
});
var headerTextColor = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0,
  dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0
});
var headerTextColorInactive = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N800,
  dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0
});
var appLabelBgColor = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20,
  dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20
});
var appLabelTextColor = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N500,
  dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N500
});
var labelTextColor = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N800,
  dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN900
});
var labelIconColor = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N60,
  dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN100
});
var errorIconColor = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N90,
  dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN90
});
var errorTitleColor = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N800,
  dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN800
});
var errorTextColor = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N90,
  dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN90
});

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preventTouchMove = preventTouchMove;
exports.allowTouchMove = allowTouchMove;
exports.preventInertiaScroll = preventInertiaScroll;
exports.isTouchDevice = isTouchDevice;
exports.getPadding = getPadding;
exports.camelToKebab = camelToKebab;
exports.getWindowHeight = getWindowHeight;
exports.getDocumentHeight = getDocumentHeight;
exports.parse = parse;
exports.makeStyleTag = makeStyleTag;
exports.injectStyles = injectStyles;
exports.insertStyleTag = insertStyleTag;
function preventTouchMove(e) {
  e.preventDefault();
}

function allowTouchMove(e) {
  e.stopPropagation();
}

function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}

// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
  if (typeof window === 'undefined' || !window) return false;
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

function getPadding() {
  if (typeof window === 'undefined' || !window || !document) return 0;

  var currentPadding = parseInt(document.body.paddingRight, 10) || 0;
  var clientWidth = document.body ? document.body.clientWidth : 0;
  var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;

  return adjustedPadding;
}

function camelToKebab(str) {
  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

function getWindowHeight() {
  var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  if (typeof window !== 'undefined' && window && window.innerHeight) {
    return window.innerHeight * multiplier;
  }
}

function getDocumentHeight() {
  if (typeof window !== 'undefined' && document && document.body) {
    return document.body.clientHeight;
  }
}

function parse(val) {
  return isNaN(val) ? val : val + 'px';
}

// ==============================
// Style Sheets
// ==============================

function makeStyleTag(id) {
  var tag = document.createElement('style');
  tag.type = 'text/css';
  tag.setAttribute('data-react-scrolllock', '');

  return tag;
}
function injectStyles(tag, css) {
  if (tag.styleSheet) {
    tag.styleSheet.cssText = css;
  } else {
    tag.appendChild(document.createTextNode(css));
  }
}
function insertStyleTag(tag) {
  var head = document.head || document.getElementsByTagName('head')[0];
  head.appendChild(tag);
}

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReactEditorView__ = __webpack_require__(2001);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ReactEditorView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_ui_component__ = __webpack_require__(2791);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__get_ui_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_plugins_list__ = __webpack_require__(434);
/* unused harmony reexport createPluginsList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__get_props_preset__ = __webpack_require__(881);
/* unused harmony reexport getPropsPreset */




//# sourceMappingURL=index.js.map

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FakeTextCursorBookmark */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FakeTextCursorSelection; });
/* unused harmony export addFakeTextCursor */
/* unused harmony export removeFakeTextCursor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return drawFakeTextCursor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_view__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_model__);




var FakeTextCursorBookmark = /** @class */ (function () {
    function FakeTextCursorBookmark(pos) {
        this.pos = undefined;
        this.visible = false;
        this.pos = pos;
    }
    FakeTextCursorBookmark.prototype.map = function (mapping) {
        return new FakeTextCursorBookmark(mapping.map(this.pos));
    };
    FakeTextCursorBookmark.prototype.resolve = function (doc) {
        var $pos = doc.resolve(this.pos);
        return __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Selection"].near($pos);
    };
    return FakeTextCursorBookmark;
}());

var FakeTextCursorSelection = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](FakeTextCursorSelection, _super);
    function FakeTextCursorSelection($pos) {
        return _super.call(this, $pos, $pos) || this;
    }
    FakeTextCursorSelection.prototype.map = function (doc, mapping) {
        var $pos = doc.resolve(mapping.map(this.$head.pos));
        return new FakeTextCursorSelection($pos);
    };
    FakeTextCursorSelection.content = function () {
        return __WEBPACK_IMPORTED_MODULE_3_prosemirror_model__["Slice"].empty;
    };
    FakeTextCursorSelection.prototype.eq = function (other) {
        return other instanceof FakeTextCursorSelection && other.head === this.head;
    };
    FakeTextCursorSelection.prototype.toJSON = function () {
        return { type: 'Cursor', pos: this.head };
    };
    FakeTextCursorSelection.fromJSON = function (doc, json) {
        return new FakeTextCursorSelection(doc.resolve(json.pos));
    };
    FakeTextCursorSelection.prototype.getBookmark = function () {
        return new FakeTextCursorBookmark(this.anchor);
    };
    return FakeTextCursorSelection;
}(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Selection"]));

__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Selection"].jsonID('fake-text-cursor', FakeTextCursorSelection);
var addFakeTextCursor = function (state, dispatch) {
    var selection = state.selection;
    if (selection.empty) {
        var $from = state.selection.$from;
        dispatch(state.tr.setSelection(new FakeTextCursorSelection($from)));
    }
};
var removeFakeTextCursor = function (state, dispatch) {
    if (state.selection instanceof FakeTextCursorSelection) {
        var $from = state.selection.$from;
        dispatch(state.tr.setSelection(new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["TextSelection"]($from)));
    }
};
var drawFakeTextCursor = function (state) {
    if (!(state.selection instanceof FakeTextCursorSelection)) {
        return null;
    }
    var node = document.createElement('div');
    node.className = 'ProseMirror-fake-text-cursor';
    return __WEBPACK_IMPORTED_MODULE_2_prosemirror_view__["DecorationSet"].create(state.doc, [
        __WEBPACK_IMPORTED_MODULE_2_prosemirror_view__["Decoration"].widget(state.selection.head, node, { key: 'Cursor' }),
    ]);
};
//# sourceMappingURL=cursor.js.map

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isIgnored */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isValidTargetNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isTextBlockNearPos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fixCursorAlignment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isIgnoredClick; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selection__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__table_types__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__table_ui_styles__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(21);






// we don't show gap cursor for those nodes
var IGNORED_NODES = [
    'paragraph',
    'bulletList',
    'orderedList',
    'listItem',
    'taskItem',
    'decisionItem',
    'heading',
    'blockquote',
];
// Returns DOM node's vertical margin. It descents into the node and reads margins of nested DOM nodes
var getDomNodeVerticalMargin = function (ref, side) {
    var margin = 0;
    while (ref && ref.nodeType === 1) {
        var css = window.getComputedStyle(ref);
        var curMargin = parseInt(css["margin-" + side], 10);
        if (curMargin > margin) {
            margin = curMargin;
        }
        ref = ref[side === 'top' ? 'firstChild' : 'lastChild'];
    }
    return margin;
};
var isIgnored = function (node) {
    return !!node && IGNORED_NODES.indexOf(node.type.name) !== -1;
};
var isValidTargetNode = function (node) {
    return !!node && !isIgnored(node);
};
var isTextBlockNearPos = function (doc, schema, $pos, dir) {
    var $currentPos = $pos;
    var currentNode = null;
    while ($currentPos.depth > 0) {
        $currentPos = doc.resolve(dir === -1 ? $currentPos.before() : $currentPos.after());
        if (!$currentPos) {
            return false;
        }
        currentNode =
            (dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter) ||
                $currentPos.parent;
        if (!currentNode || currentNode.type === schema.nodes.doc) {
            return false;
        }
        if (currentNode.isTextblock) {
            return true;
        }
    }
    var childNode = currentNode;
    while (childNode && childNode.firstChild) {
        childNode = childNode.firstChild;
        if (childNode && childNode.isTextblock) {
            return true;
        }
    }
    return false;
};
var isMediaSingle = function (node) {
    if (!node) {
        return false;
    }
    var firstChild = node.firstChild;
    return (!!firstChild &&
        firstChild.nodeType === Node.ELEMENT_NODE &&
        firstChild.classList.contains('media-single'));
};
var isNodeViewWrapper = function (node) {
    if (!node) {
        return false;
    }
    return (!!node &&
        node.nodeType === Node.ELEMENT_NODE &&
        node.className.indexOf('-content-wrap') !== -1);
};
function getBreakoutModeFromTargetNode(node) {
    if (node.attrs.layout) {
        return node.attrs.layout;
    }
    if (node.marks && node.marks.length) {
        return (node.marks.find(function (mark) { return mark.type.name === 'breakout'; }) || {
            attrs: { mode: '' },
        }).attrs.mode;
    }
    return '';
}
// incapsulated this hack into a separate util function
var fixCursorAlignment = function (view) {
    var _a = view.state, selection = _a.selection, schema = _a.schema, domAtPos = view.domAtPos;
    var _b = selection, side = _b.side, $from = _b.$from;
    // gap cursor is positioned relative to that node
    var targetNode = side === __WEBPACK_IMPORTED_MODULE_2__selection__["c" /* Side */].LEFT ? $from.nodeAfter : $from.nodeBefore;
    if (!targetNode) {
        return;
    }
    var targetNodePos = side === __WEBPACK_IMPORTED_MODULE_2__selection__["c" /* Side */].LEFT ? $from.pos + 1 : Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["findPositionOfNodeBefore"])(selection);
    var targetNodeRef = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["findDomRefAtPos"])(targetNodePos, domAtPos.bind(view));
    var gapCursorRef = view.dom.querySelector('.ProseMirror-gapcursor span');
    var gapCursorParentNodeRef = gapCursorRef.parentNode;
    var previousSibling = gapCursorParentNodeRef.previousSibling;
    var isTargetNodeMediaSingle = isMediaSingle(targetNodeRef);
    var isMediaWithWrapping = isTargetNodeMediaSingle &&
        /wrap-[right|left]/i.test(targetNode.attrs.layout);
    var prevNodeMarginBottom = getDomNodeVerticalMargin(previousSibling, 'bottom');
    var minHeight = 20;
    var height = 0;
    var width = 0;
    var marginTop = 0;
    var breakoutWidth = 0;
    var paddingLeft = 0;
    // gets width and height of the prevNode DOM element, or its nodeView wrapper DOM element
    do {
        var isTargetNodeNodeViewWrapper = isNodeViewWrapper(targetNodeRef);
        var firstChild = targetNodeRef.firstChild;
        var css = window.getComputedStyle(isTargetNodeMediaSingle || isTargetNodeNodeViewWrapper
            ? firstChild
            : targetNodeRef);
        var isInTableCell = /td|th/i.test(targetNodeRef.parentNode.nodeName);
        height = parseInt(css.height, 10);
        width = parseInt(css.width, 10);
        width += parseInt(css.paddingLeft, 10);
        width += parseInt(css.paddingRight, 10);
        height += parseInt(css.paddingTop, 10);
        height += parseInt(css.paddingBottom, 10);
        // padding is cumulative
        paddingLeft += parseInt(css.paddingLeft, 10);
        if (previousSibling || isMediaWithWrapping || isInTableCell) {
            var curNodeMarginTop = getDomNodeVerticalMargin(targetNodeRef, 'top');
            if (curNodeMarginTop > prevNodeMarginBottom) {
                marginTop = curNodeMarginTop - prevNodeMarginBottom;
            }
            if (isMediaWithWrapping) {
                marginTop = curNodeMarginTop;
            }
        }
        if (isTargetNodeNodeViewWrapper || isTargetNodeMediaSingle) {
            breakoutWidth = width;
        }
        targetNodeRef = targetNodeRef.parentNode;
    } while (targetNodeRef && !targetNodeRef.contains(gapCursorRef));
    // height of the rule (<hr>) is 0, that's why we set minHeight
    if (height < minHeight) {
        height = minHeight;
        marginTop -= Math.round(minHeight / 2) - 1;
    }
    // table nodeView margin fix
    if (targetNode.type === schema.nodes.table) {
        var tableFullMarginTop = __WEBPACK_IMPORTED_MODULE_1__atlaskit_editor_common__["_1" /* tableMarginTop */] + __WEBPACK_IMPORTED_MODULE_4__table_ui_styles__["g" /* tableInsertColumnButtonSize */] / 2;
        height -= tableFullMarginTop;
        marginTop = tableFullMarginTop;
        gapCursorRef.style.paddingLeft = paddingLeft + "px";
    }
    // breakout mode
    var breakoutMode = getBreakoutModeFromTargetNode(targetNode);
    if (/full-width|wide/i.test(breakoutMode)) {
        gapCursorRef.setAttribute('layout', breakoutMode);
    }
    // mediaSingle with layout="wrap-left" or "wrap-right"
    if (isMediaWithWrapping) {
        gapCursorParentNodeRef.setAttribute('layout', targetNode.attrs.layout);
        if (targetNode.attrs.layout === 'wrap-right') {
            gapCursorRef.style.marginLeft = "-" + width + "px";
        }
    }
    gapCursorRef.style.height = height + "px";
    gapCursorRef.style.marginTop = marginTop + "px";
    gapCursorRef.style.width = (breakoutWidth || width) + "px";
};
var isIgnoredClick = function (elem) {
    if (elem.nodeName === 'BUTTON' || Object(__WEBPACK_IMPORTED_MODULE_5__utils__["i" /* closestElement */])(elem, 'button')) {
        return true;
    }
    // check if target node has a parent table node
    var tableWrap;
    var node = elem;
    while (node) {
        if (node.className &&
            (node.getAttribute('class') || '').indexOf(__WEBPACK_IMPORTED_MODULE_3__table_types__["a" /* TableCssClassName */].TABLE_CONTAINER) > -1) {
            tableWrap = node;
            break;
        }
        node = node.parentNode;
    }
    if (tableWrap) {
        var rowControls = tableWrap.querySelector("." + __WEBPACK_IMPORTED_MODULE_3__table_types__["a" /* TableCssClassName */].ROW_CONTROLS_WRAPPER);
        var columnControls = tableWrap.querySelector("." + __WEBPACK_IMPORTED_MODULE_3__table_types__["a" /* TableCssClassName */].COLUMN_CONTROLS_WRAPPER);
        return ((rowControls && rowControls.contains(elem)) ||
            (columnControls && columnControls.contains(elem)));
    }
    return false;
};
//# sourceMappingURL=utils.js.map

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isEmptyParagraph */
/* harmony export (immutable) */ __webpack_exports__["b"] = hasVisibleContent;
/* harmony export (immutable) */ __webpack_exports__["d"] = isEmptyNode;
/* harmony export (immutable) */ __webpack_exports__["c"] = isEmptyDocument;
/* harmony export (immutable) */ __webpack_exports__["e"] = processRawValue;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStepRange; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_utils__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__analytics__ = __webpack_require__(20);



var FALSE_POSITIVE_MARKS = ['code', 'alignment', 'indentation'];
/**
 * Checks if node is an empty paragraph.
 */
function isEmptyParagraph(node) {
    return (!node ||
        (node.type.name === 'paragraph' && !node.textContent && !node.childCount));
}
/**
 * Returns false if node contains only empty inline nodes and hardBreaks.
 */
function hasVisibleContent(node) {
    var isInlineNodeHasVisibleContent = function (inlineNode) {
        return inlineNode.isText
            ? !!inlineNode.textContent.trim()
            : inlineNode.type.name !== 'hardBreak';
    };
    if (node.isInline) {
        return isInlineNodeHasVisibleContent(node);
    }
    else if (node.isBlock && (node.isLeaf || node.isAtom)) {
        return true;
    }
    else if (!node.childCount) {
        return false;
    }
    for (var index = 0; index < node.childCount; index++) {
        var child = node.child(index);
        if (hasVisibleContent(child)) {
            return true;
        }
    }
    return false;
}
/**
 * Checks if a node has any content. Ignores node that only contain empty block nodes.
 */
function isEmptyNode(node) {
    if (node && node.textContent) {
        return false;
    }
    if (!node ||
        !node.childCount ||
        (node.childCount === 1 && isEmptyParagraph(node.firstChild))) {
        return true;
    }
    var block = [];
    var nonBlock = [];
    node.forEach(function (child) {
        child.isInline ? nonBlock.push(child) : block.push(child);
    });
    return (!nonBlock.length &&
        !block.filter(function (childNode) {
            return (!!childNode.childCount &&
                !(childNode.childCount === 1 && isEmptyParagraph(childNode.firstChild))) ||
                childNode.isAtom;
        }).length);
}
/**
 * Checks if a node looks like an empty document
 */
function isEmptyDocument(node) {
    var nodeChild = node.content.firstChild;
    if (node.childCount !== 1 || !nodeChild) {
        return false;
    }
    return (nodeChild.type.name === 'paragraph' &&
        !nodeChild.childCount &&
        nodeChild.nodeSize === 2 &&
        (!nodeChild.marks || nodeChild.marks.length === 0));
}
function wrapWithUnsupported(originalValue, type) {
    if (type === void 0) { type = 'block'; }
    return {
        type: "unsupported" + (type === 'block' ? 'Block' : 'Inline'),
        attrs: { originalValue: originalValue },
    };
}
function fireAnalyticsEvent(entity, error, type) {
    if (type === void 0) { type = 'block'; }
    var code = error.code;
    __WEBPACK_IMPORTED_MODULE_2__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.unsupported', {
        name: entity.type || 'unknown',
        type: type,
        errorCode: code,
    });
}
function processRawValue(schema, value) {
    if (!value) {
        return;
    }
    var node;
    if (typeof value === 'string') {
        try {
            node = JSON.parse(value);
        }
        catch (e) {
            // tslint:disable-next-line:no-console
            console.error("Error processing value: " + value + " isn't a valid JSON");
            return;
        }
    }
    else {
        node = value;
    }
    if (Array.isArray(node)) {
        // tslint:disable-next-line:no-console
        console.error("Error processing value: " + node + " is an array, but it must be an object.");
        return;
    }
    try {
        var nodes = Object.keys(schema.nodes);
        var marks_1 = Object.keys(schema.marks);
        var validate = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_utils__["b" /* validator */])(nodes, marks_1, { allowPrivateAttributes: true });
        var emptyDoc = { type: 'doc', content: [] };
        // ProseMirror always require a child under doc
        if (node.type === 'doc') {
            if (Array.isArray(node.content) && node.content.length === 0) {
                node.content.push({
                    type: 'paragraph',
                    content: [],
                });
            }
            // Just making sure doc is always valid
            if (!node.version) {
                node.version = 1;
            }
        }
        var _a = validate(node, function (entity, error, options) {
            // Remove any invalid marks
            if (marks_1.indexOf(entity.type) > -1) {
                if (!(error.code === "INVALID_TYPE" /* INVALID_TYPE */ &&
                    FALSE_POSITIVE_MARKS.indexOf(entity.type) > -1)) {
                    fireAnalyticsEvent(entity, error, 'mark');
                }
                return;
            }
            /**
             * There's a inconsistency between ProseMirror and ADF.
             * `content` is actually optional in ProseMirror.
             * And, also empty `text` node is not valid.
             */
            if (error.code === "MISSING_PROPERTY" /* MISSING_PROPERTY */ &&
                entity.type === 'paragraph') {
                return { type: 'paragraph', content: [] };
            }
            // Can't fix it by wrapping
            // TODO: We can repair missing content like `panel` without a `paragraph`.
            if (error.code === "INVALID_CONTENT_LENGTH" /* INVALID_CONTENT_LENGTH */) {
                return entity;
            }
            if (options.allowUnsupportedBlock) {
                fireAnalyticsEvent(entity, error);
                return wrapWithUnsupported(entity);
            }
            else if (options.allowUnsupportedInline) {
                fireAnalyticsEvent(entity, error, 'inline');
                return wrapWithUnsupported(entity, 'inline');
            }
            return entity;
        }).entity, entity = _a === void 0 ? emptyDoc : _a;
        var parsedDoc = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Node"].fromJSON(schema, entity);
        // throws an error if the document is invalid
        parsedDoc.check();
        return parsedDoc;
    }
    catch (e) {
        // tslint:disable-next-line:no-console
        console.error("Error processing value: \"" + JSON.stringify(node) + "\" \u2013 " + e.message);
        return;
    }
}
var getStepRange = function (transaction) {
    var from = -1;
    var to = -1;
    transaction.steps.forEach(function (step) {
        step.getMap().forEach(function (_oldStart, _oldEnd, newStart, newEnd) {
            from = newStart < from || from === -1 ? newStart : from;
            to = newEnd < to || to === -1 ? newEnd : to;
        });
    });
    if (from !== -1) {
        return { from: from, to: to };
    }
    return null;
};
//# sourceMappingURL=document.js.map

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return text; });
var text = function (text) { return ({
    type: 'text',
    text: text,
}); };
//# sourceMappingURL=text.js.map

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = themed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTheme__ = __webpack_require__(751);
/* eslint-disable prefer-rest-params */


function themedVariants(variantProp, variants) {
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);

    if (props && props[variantProp] && variants) {
      var modes = variants[props[variantProp]];

      if (modes) {
        return modes[theme.mode];
      }
    }

    return '';
  };
}

function themed(modesOrVariant, variantModes) {
  if (typeof modesOrVariant === 'string') {
    return themedVariants(modesOrVariant, variantModes);
  }

  var modes = modesOrVariant;
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    return modes[theme.mode];
  };
}

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createTheme__ = __webpack_require__(415);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils_createTheme__["a" /* createTheme */])(function () {
  return {
    mode: 'light'
  };
}));

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


function createTheme(defaultThemeFn) {
  var emptyThemeFn = function emptyThemeFn(tokens, props) {
    return tokens(props);
  };

  var ThemeContext = Object(__WEBPACK_IMPORTED_MODULE_1_react__["createContext"])(defaultThemeFn);

  function Consumer(props) {
    var children = props.children,
        themeProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(props, ["children"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ThemeContext.Consumer, null, function (theme) {
      var themeFn = theme || emptyThemeFn;
      return props.children(themeFn(themeProps));
    });
  }

  function Provider(props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ThemeContext.Consumer, null, function (themeFn) {
      var valueFn = props.value || emptyThemeFn;

      var mixedFn = function mixedFn(themeProps) {
        return valueFn(themeFn, themeProps);
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ThemeContext.Provider, {
        value: mixedFn
      }, props.children);
    });
  }

  return {
    Consumer: Consumer,
    Provider: Provider
  };
}

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AvatarGroup__ = __webpack_require__(2160);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__components_AvatarGroup__["a"]; });


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Droplist__ = __webpack_require__(2162);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Droplist__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Item__ = __webpack_require__(2173);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__components_Item__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Group__ = __webpack_require__(2179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__components_Group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled_Item__ = __webpack_require__(418);
/* unused harmony reexport SecondaryText */





/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Anchor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Span; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return InputWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Before; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return After; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ContentWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Description; });
/* unused harmony export SecondaryText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);


var activeBackgroundColor = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].B75,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN30
});
var hoverBackgroundColor = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N20,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN60
});
var selectedBackgroundColor = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N0,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN30
});
var activePrimaryTextColor = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N800,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN300
});
var defaultPrimaryTextColor = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N800,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN600
});
var disabledPrimaryTextColor = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N70,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN70
});
var primaryPrimaryTextColor = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].B400,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].B400
});
var selectedPrimaryTextColor = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N800,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N800
});
var focusedStyles = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  box-shadow: 0 0 0 2px ", "\n    inset;\n  outline: none;\n  outline-offset: 0;\n  position: relative; /* prevents bgcolor of a hovered element from obfuscating focus ring of a focused sibling element */\n"], Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].B100,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].B75
}));
var activeStyles = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  &,\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n"], selectedBackgroundColor, selectedPrimaryTextColor);
var primaryStyles = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  color: ", ";\n"], primaryPrimaryTextColor);

var sharedStyles = function sharedStyles(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  align-items: center;\n  box-sizing: border-box;\n  color: ", ";\n  cursor: ", ";\n  display: ", ";\n  flex-wrap: nowrap;\n  font-size: ", "px;\n  font-weight: normal;\n  padding: 0 ", "px;\n  text-decoration: none;\n\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n    text-decoration: none;\n\n    ", ";\n  }\n  &:active {\n    background-color: ", ";\n    color: ", ";\n\n    ", ";\n  }\n  &:focus {\n    ", ";\n  }\n\n  ", " ", " ", ";\n"], props.isDisabled ? disabledPrimaryTextColor : defaultPrimaryTextColor, props.isDisabled ? 'not-allowed' : 'pointer', props.isHidden ? 'none' : 'flex', __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["fontSize"], __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"], 1.5), !props.isDisabled && hoverBackgroundColor, props.isDisabled ? disabledPrimaryTextColor : defaultPrimaryTextColor, props.isPrimary && primaryStyles, !props.isDisabled && activeBackgroundColor, !props.isDisabled && activePrimaryTextColor, props.isPrimary && primaryStyles, focusedStyles, props.isFocused && focusedStyles, props.isActive && activeStyles, props.isPrimary && primaryStyles);
};

var Anchor = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].a.withConfig({
  displayName: "Item__Anchor",
  componentId: "aiqnor-0"
})(["\n  ", ";\n"], function (props) {
  return sharedStyles(props);
});
var Span = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "Item__Span",
  componentId: "aiqnor-1"
})(["\n  ", ";\n"], function (props) {
  return sharedStyles(props);
}); // Checkbox/Radio wrapper -- sits left of the children

var InputWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "Item__InputWrapper",
  componentId: "aiqnor-2"
})(["\n  display: flex;\n  margin: 0 2px;\n"]); // Elements injected before/after the children

var Before = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "Item__Before",
  componentId: "aiqnor-3"
})(["\n  display: flex;\n"]);
var After = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "Item__After",
  componentId: "aiqnor-4"
})(["\n  align-items: center;\n  display: flex;\n"]); // Alignment and layout for the children

var ContentWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "Item__ContentWrapper",
  componentId: "aiqnor-5"
})(["\n  display: flex;\n  flex-direction: column;\n  margin: 0 ", "px;\n  padding: ", "px 0;\n  overflow: hidden;\n\n  &:first-child {\n    margin: 0;\n  }\n"], __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"], __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"]);
var Content = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "Item__Content",
  componentId: "aiqnor-6"
})(["\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  ", ";\n"], function (props) {
  return props.allowMultiline && Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n      white-space: normal;\n    "]);
}); // Description is a block element below the children, like a subtitle

var Description = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "Item__Description",
  componentId: "aiqnor-7"
})(["\n  color: ", ";\n  flex: 1 1 auto;\n  font-size: 12px;\n  line-height: 16 / 12;\n  margin-top: ", "px;\n"], __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].subtleText, __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["math"].divide(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"], 2)); // NOTE: Exposed as a named export for this package

var SecondaryText = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "Item__SecondaryText",
  componentId: "aiqnor-8"
})(["\n  color: ", ";\n"], __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].subtleText);

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(54);

var _interopRequireDefault = __webpack_require__(53);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.size = exports.default = exports.IconWrapper = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(4));

var _createClass2 = _interopRequireDefault(__webpack_require__(5));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(7));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(6));

var _inherits2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _styledComponents = _interopRequireDefault(__webpack_require__(2));

var _uuid = _interopRequireDefault(__webpack_require__(22));

var _theme = __webpack_require__(3);

var _constants = __webpack_require__(2182);

var getSize = function getSize(props) {
  if (props.size) {
    return "height: ".concat(_constants.sizes[props.size], "; width: ").concat(_constants.sizes[props.size], ";");
  }

  return null;
};

var IconWrapper = _styledComponents.default.span.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "dyhwwi-0"
})(["\n  ", " color: ", ";\n  display: inline-block;\n  fill: ", ";\n  flex-shrink: 0;\n  line-height: 1;\n\n  > svg {\n    ", " max-height: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    pointer-events: none;\n    vertical-align: bottom;\n  }\n  /* Stop-color doesn't properly apply in chrome when the inherited/current color changes.\n   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS\n   * rule) and then override it with currentColor for the color changes to be picked up.\n   */\n  stop {\n    stop-color: currentColor;\n  }\n"], getSize, function (p) {
  return p.primaryColor || 'currentColor';
}, function (p) {
  return p.secondaryColor || _theme.colors.background;
}, getSize);

exports.IconWrapper = IconWrapper;

var Icon =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Icon, _Component);

  function Icon() {
    (0, _classCallCheck2.default)(this, Icon);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Icon).apply(this, arguments));
  }

  (0, _createClass2.default)(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Glyph = _this$props.glyph,
          dangerouslySetGlyph = _this$props.dangerouslySetGlyph,
          onClick = _this$props.onClick,
          primaryColor = _this$props.primaryColor,
          secondaryColor = _this$props.secondaryColor,
          size = _this$props.size; // handling the glyphs as strings

      if (dangerouslySetGlyph) {
        return _react.default.createElement(IconWrapper, {
          onClick: onClick,
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          size: size,
          "aria-label": this.props.label,
          dangerouslySetInnerHTML: {
            __html: Icon.insertDynamicGradientID(dangerouslySetGlyph)
          }
        });
      } // handling the glyphs when passed through as functions


      return _react.default.createElement(IconWrapper, {
        onClick: onClick,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        "aria-label": this.props.label
      }, Glyph ? _react.default.createElement(Glyph, {
        role: "presentation"
      }) : null);
    }
  }], [{
    key: "insertDynamicGradientID",

    /* Icons need unique gradient IDs across instances for different gradient definitions to work
     * correctly.
     * A step in the icon build process replaces linear gradient IDs and their references in paths
     * to a placeholder string so we can replace them with a dynamic ID here.
     * Replacing the original IDs with placeholders in the build process is more robust than not
     * using placeholders as we do not have to rely on regular expressions to find specific element
     * to replace.
     */
    value: function insertDynamicGradientID(svgStr) {
      var id = (0, _uuid.default)();
      var replacedSvgStr = svgStr.replace(/id="([^"]+)-idPlaceholder"/g, "id=$1-".concat(id)).replace(/fill="url\(#([^"]+)-idPlaceholder\)"/g, "fill=\"url(#$1-".concat(id, ")\""));
      return replacedSvgStr;
    }
  }]);
  return Icon;
}(_react.Component);

exports.default = Icon;
(0, _defineProperty2.default)(Icon, "defaultProps", {
  onClick: function onClick() {}
});
var size = Object.keys(_constants.sizes).reduce(function (p, c) {
  return Object.assign(p, (0, _defineProperty2.default)({}, c, c));
}, {});
exports.size = size;

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return KEY_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KEY_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return KEY_SPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return KEY_ENTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return KEY_TAB; });
/* unused harmony export KEY_ESC */
var KEY_UP = 'ArrowUp';
var KEY_DOWN = 'ArrowDown';
var KEY_SPACE = ' ';
var KEY_ENTER = 'Enter';
var KEY_TAB = 'Tab';
var KEY_ESC = 'Escape';

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropdownItemGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_item__ = __webpack_require__(111);








var DropdownItemGroup =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(DropdownItemGroup, _Component);

  function DropdownItemGroup() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, DropdownItemGroup);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DropdownItemGroup).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(DropdownItemGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          elemAfter = _this$props.elemAfter,
          title = _this$props.title;
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__atlaskit_item__["a" /* ItemGroup */], {
        elemAfter: elemAfter,
        title: title,
        role: "menu"
      }, children);
    }
  }]);

  return DropdownItemGroup;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);



/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_render_image__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_render_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_render_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__(2202);




var ImageIcon = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ImageIcon, _super);
    function ImageIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImageIcon.prototype.render = function () {
        var _a = this.props, _b = _a.alt, alt = _b === void 0 ? '' : _b, src = _a.src, _c = _a.size, size = _c === void 0 ? 16 : _c, title = _a.title;
        if (!src) {
            return this.props.default || null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_render_image___default.a, { src: src, loading: this.props.default, loaded: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* Image */], { src: src, alt: alt, size: size, title: title }), errored: this.props.default }));
    };
    return ImageIcon;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CollapsedIconTitleDescriptionLayout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MultiLineLayout__ = __webpack_require__(2223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__(2225);




var CollapsedIconTitleDescriptionLayout = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CollapsedIconTitleDescriptionLayout, _super);
    function CollapsedIconTitleDescriptionLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollapsedIconTitleDescriptionLayout.prototype.render = function () {
        var _a = this.props, icon = _a.icon, title = _a.title, description = _a.description, other = _a.other;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__MultiLineLayout__["a" /* MultiLineLayout */], { left: icon, middle: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled__["b" /* Title */], null, title.replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, '')),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* Description */], null, description)), right: other }));
    };
    return CollapsedIconTitleDescriptionLayout;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return truncateUrlForErrorView; });
var truncateUrlForErrorView = function (str, len) {
    if (len === void 0) { len = 40; }
    var clean = str.replace(/https?:\/\//gi, '');
    return clean.length > len - 3 ? clean.substr(0, len) + '...' : clean;
};
//# sourceMappingURL=utils.js.map

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dataURItoFile */
/* unused harmony export fileToDataURI */
/* harmony export (immutable) */ __webpack_exports__["b"] = getFileInfo;
/* unused harmony export getFileInfoFromSrc */
/* harmony export (immutable) */ __webpack_exports__["a"] = fileToArrayBuffer;
/* harmony export (immutable) */ __webpack_exports__["c"] = loadImage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

function dataURItoFile(dataURI, filename) {
    if (filename === void 0) { filename = 'untitled'; }
    if (dataURI.length === 0) {
        throw new Error('dataURI not found');
    }
    // convert base64/URLEncoded data component to raw binary data held in a string
    var dataURIParts = dataURI.split(',');
    var byteString = dataURIParts[0].indexOf('base64') >= 0
        ? atob(dataURIParts[1])
        : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    var mimeString;
    try {
        mimeString = dataURI
            .split(',')[0]
            .split(':')[1]
            .split(';')[0];
    }
    catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    var intArray = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        intArray[i] = byteString.charCodeAt(i);
    }
    var blob = new Blob([intArray], { type: mimeString });
    try {
        return new File([blob], filename, { type: mimeString });
    }
    catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        var ie11File = blob;
        var date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function fileToDataURI(blob) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.addEventListener('load', function () {
            var result = reader.result;
            if (typeof result === 'string') {
                resolve(result);
            }
            else if (result === null) {
                reject();
            }
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
function getFileInfo(file, src) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
        var _a, _b;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = {
                        file: file
                    };
                    _b = src;
                    if (_b) return [3 /*break*/, 2];
                    return [4 /*yield*/, fileToDataURI(file)];
                case 1:
                    _b = (_c.sent());
                    _c.label = 2;
                case 2: return [2 /*return*/, (_a.src = _b,
                        _a)];
            }
        });
    });
}
function getFileInfoFromSrc(src, file) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
        var _a, _b;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = {};
                    _b = file;
                    if (_b) return [3 /*break*/, 2];
                    return [4 /*yield*/, dataURItoFile(src)];
                case 1:
                    _b = (_c.sent());
                    _c.label = 2;
                case 2: return [2 /*return*/, (_a.file = _b,
                        _a.src = src,
                        _a)];
            }
        });
    });
}
function fileToArrayBuffer(file) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.addEventListener('load', function () {
            var array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function loadImage(src) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.src = src;
        img.onload = function () {
            resolve(img);
        };
        img.onerror = reject;
    });
}
//# sourceMappingURL=util.js.map

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatDuration; });
var pad = function (n) {
    return n < 10 ? "0" + n : n;
};
var isInvalidInput = function (seconds) {
    return isNaN(seconds) || seconds === Infinity || seconds < 0;
};
var formatDuration = function (seconds) {
    if (isInvalidInput(seconds)) {
        return '0:00';
    }
    var totalSeconds = parseInt("" + seconds, 10);
    var hours = Math.floor(totalSeconds / 3600);
    var remainingSeconds = totalSeconds % 3600;
    var minutes = Math.floor(remainingSeconds / 60);
    remainingSeconds %= 60;
    var prettyHoursWithSeparator = hours > 0 ? hours + ':' : '';
    var prettyMinutes = prettyHoursWithSeparator ? pad(minutes) : minutes;
    return "" + prettyHoursWithSeparator + prettyMinutes + ":" + pad(remainingSeconds);
};
//# sourceMappingURL=formatDuration.js.map

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = themed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTheme__ = __webpack_require__(778);
/* eslint-disable prefer-rest-params */


function themedVariants(variantProp, variants) {
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);

    if (props && props[variantProp] && variants) {
      var modes = variants[props[variantProp]];

      if (modes) {
        return modes[theme.mode];
      }
    }

    return '';
  };
}

function themed(modesOrVariant, variantModes) {
  if (typeof modesOrVariant === 'string') {
    return themedVariants(modesOrVariant, variantModes);
  }

  var modes = modesOrVariant;
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    return modes[theme.mode];
  };
}

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createTheme__ = __webpack_require__(429);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils_createTheme__["a" /* createTheme */])(function () {
  return {
    mode: 'light'
  };
}));

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


function createTheme(defaultThemeFn) {
  var emptyThemeFn = function emptyThemeFn(tokens, props) {
    return tokens(props);
  };

  var ThemeContext = Object(__WEBPACK_IMPORTED_MODULE_1_react__["createContext"])(defaultThemeFn);

  function Consumer(props) {
    var children = props.children,
        themeProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(props, ["children"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ThemeContext.Consumer, null, function (theme) {
      var themeFn = theme || emptyThemeFn;
      return props.children(themeFn(themeProps));
    });
  }

  function Provider(props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ThemeContext.Consumer, null, function (themeFn) {
      var valueFn = props.value || emptyThemeFn;

      var mixedFn = function mixedFn(themeProps) {
        return valueFn(themeFn, themeProps);
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ThemeContext.Provider, {
        value: mixedFn
      }, props.children);
    });
  }

  return {
    Consumer: Consumer,
    Provider: Provider
  };
}

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardActionButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_media_ui__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1348);
/* tslint:disable:variable-name */





var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* Root */])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  position: relative;\n  line-height: 0;\n"], ["\n  display: flex;\n  position: relative;\n  line-height: 0;\n"])));
var CardActionButton = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", " ", " ", " color: ", ";\n\n  &:hover {\n    cursor: pointer;\n    background-color: rgba(9, 30, 66, 0.06);\n  }\n"], ["\n  ", " ", " ", " color: ", ";\n\n  &:hover {\n    cursor: pointer;\n    background-color: rgba(9, 30, 66, 0.06);\n  }\n"])), __WEBPACK_IMPORTED_MODULE_3__atlaskit_media_ui__["q" /* center */], __WEBPACK_IMPORTED_MODULE_3__atlaskit_media_ui__["p" /* borderRadius */], Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_media_ui__["y" /* size */])(26), __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorN500"]);
var templateObject_1, templateObject_2;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return posOfMediaGroupNearby; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isSelectionNonMediaBlockNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return posOfPrecedingMediaGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isInsidePotentialEmptyParagraph; });
/* unused harmony export posOfMediaGroupBelow */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return posOfParentMediaGroup; });
/* unused harmony export endPositionForMedia */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return removeMediaNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return splitMediaGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return copyOptionalAttrsFromMediaState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_commands___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(21);





var posOfMediaGroupNearby = function (state) {
    return (posOfParentMediaGroup(state) ||
        posOfFollowingMediaGroup(state) ||
        posOfPrecedingMediaGroup(state));
};
var isSelectionNonMediaBlockNode = function (state) {
    var node = state.selection.node;
    return node && node.type !== state.schema.nodes.media && node.isBlock;
};
var posOfPrecedingMediaGroup = function (state) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* atTheBeginningOfBlock */])(state)) {
        return;
    }
    return posOfMediaGroupAbove(state, state.selection.$from);
};
var posOfFollowingMediaGroup = function (state) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* atTheEndOfBlock */])(state)) {
        return;
    }
    return posOfMediaGroupBelow(state, state.selection.$to);
};
var posOfMediaGroupAbove = function (state, $pos) {
    var adjacentPos;
    var adjacentNode;
    if (isSelectionNonMediaBlockNode(state)) {
        adjacentPos = $pos.pos;
        adjacentNode = $pos.nodeBefore;
    }
    else {
        adjacentPos = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["I" /* startPositionOfParent */])($pos) - 1;
        adjacentNode = state.doc.resolve(adjacentPos).nodeBefore;
    }
    if (adjacentNode && adjacentNode.type === state.schema.nodes.mediaGroup) {
        return adjacentPos - adjacentNode.nodeSize + 1;
    }
};
/**
 * Determine whether the cursor is inside empty paragraph
 * or the selection is the entire paragraph
 */
var isInsidePotentialEmptyParagraph = function (state) {
    var $from = state.selection.$from;
    return ($from.parent.type === state.schema.nodes.paragraph &&
        Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* atTheBeginningOfBlock */])(state) &&
        Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* atTheEndOfBlock */])(state));
};
var posOfMediaGroupBelow = function (state, $pos, prepend) {
    if (prepend === void 0) { prepend = true; }
    var adjacentPos;
    var adjacentNode;
    if (isSelectionNonMediaBlockNode(state)) {
        adjacentPos = $pos.pos;
        adjacentNode = $pos.nodeAfter;
    }
    else {
        adjacentPos = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["l" /* endPositionOfParent */])($pos);
        adjacentNode = state.doc.nodeAt(adjacentPos);
    }
    if (adjacentNode && adjacentNode.type === state.schema.nodes.mediaGroup) {
        return prepend ? adjacentPos + 1 : adjacentPos + adjacentNode.nodeSize - 1;
    }
};
var posOfParentMediaGroup = function (state, $pos, prepend) {
    if (prepend === void 0) { prepend = false; }
    var $from = state.selection.$from;
    $pos = $pos || $from;
    if ($pos.parent.type === state.schema.nodes.mediaGroup) {
        return prepend
            ? Object(__WEBPACK_IMPORTED_MODULE_4__utils__["I" /* startPositionOfParent */])($pos)
            : Object(__WEBPACK_IMPORTED_MODULE_4__utils__["l" /* endPositionOfParent */])($pos) - 1;
    }
};
/**
 * The function will return the position after current selection where mediaGroup can be inserted.
 */
function endPositionForMedia(state, resolvedPos) {
    var mediaGroup = state.schema.nodes.mediaGroup;
    var i = resolvedPos.depth;
    for (; i > 1; i--) {
        var nodeType = resolvedPos.node(i).type;
        if (nodeType.validContent(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(mediaGroup.create()))) {
            break;
        }
    }
    return resolvedPos.end(i) + 1;
}
var removeMediaNode = function (view, node, getPos) {
    var id = node.attrs.id;
    var state = view.state;
    var tr = state.tr, selection = state.selection, doc = state.doc;
    var currentMediaNodePos = getPos();
    tr.deleteRange(currentMediaNodePos, currentMediaNodePos + node.nodeSize);
    if (Object(__WEBPACK_IMPORTED_MODULE_4__utils__["B" /* isTemporary */])(id)) {
        tr.setMeta('addToHistory', false);
    }
    view.dispatch(tr);
    var $currentMediaNodePos = doc.resolve(currentMediaNodePos);
    var isLastMediaNode = $currentMediaNodePos.index() === $currentMediaNodePos.parent.childCount - 1;
    // If deleting a selected media node, we need to tell where the cursor to go next.
    // Prosemirror didn't gave us the behaviour of moving left if the media node is not the last one.
    // So we handle it ourselves.
    if (selection.from === currentMediaNodePos &&
        !isLastMediaNode &&
        !Object(__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* atTheBeginningOfDoc */])(state)) {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils__["D" /* moveLeft */])(view);
    }
};
var splitMediaGroup = function (view) {
    var selection = view.state.selection;
    // if selection is not a media node, do nothing.
    if (!(selection instanceof __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["NodeSelection"]) ||
        selection.node.type !== view.state.schema.nodes.media) {
        return false;
    }
    Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["deleteSelection"])(view.state, view.dispatch);
    if (selection.$to.nodeAfter) {
        Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["splitBlock"])(view.state, view.dispatch);
        Object(__WEBPACK_IMPORTED_MODULE_3__commands__["e" /* createParagraphNear */])(false)(view.state, view.dispatch);
    }
    else {
        Object(__WEBPACK_IMPORTED_MODULE_3__commands__["c" /* createNewParagraphBelow */])(view.state, view.dispatch);
    }
    return true;
};
var isOptionalAttr = function (attr) {
    return attr.length > 1 && attr[0] === '_' && attr[1] === '_';
};
var copyOptionalAttrsFromMediaState = function (mediaState, node) {
    Object.keys(node.attrs)
        .filter(isOptionalAttr)
        .forEach(function (key) {
        var mediaStateKey = key.substring(2);
        var attrValue = mediaState[mediaStateKey];
        if (attrValue !== undefined) {
            node.attrs[key] = attrValue;
        }
    });
};
//# sourceMappingURL=media-common.js.map

/***/ }),
/* 432 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(161);



var filterNested = function filterNested(nodes) {
  var l = nodes.length;
  var i = void 0;
  var j = void 0;
  for (i = 0; i < l; i += 1) {
    for (j = 0; j < l; j += 1) {
      if (i !== j) {
        if (nodes[i].contains(nodes[j])) {
          return filterNested(nodes.filter(function (x) {
            return x !== nodes[j];
          }));
        }
      }
    }
  }
  return nodes;
};

var getTopParent = function getTopParent(node) {
  return node.parentNode ? getTopParent(node.parentNode) : node;
};

var getAllAffectedNodes = function getAllAffectedNodes(node) {
  var group = node.getAttribute(__WEBPACK_IMPORTED_MODULE_0__constants__["FOCUS_GROUP"]);
  if (group) {
    return filterNested(Object(__WEBPACK_IMPORTED_MODULE_1__array__["b" /* toArray */])(getTopParent(node).querySelectorAll('[' + __WEBPACK_IMPORTED_MODULE_0__constants__["FOCUS_GROUP"] + '="' + group + '"]:not([' + __WEBPACK_IMPORTED_MODULE_0__constants__["FOCUS_DISABLED"] + '="disabled"])')));
  }
  return [node];
};

/* harmony default export */ __webpack_exports__["a"] = (getAllAffectedNodes);

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getDefaultPluginsList */
/* harmony export (immutable) */ __webpack_exports__["a"] = createPluginsList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins__ = __webpack_require__(799);

/**
 * Returns list of plugins that are absolutely necessary for editor to work
 */
function getDefaultPluginsList(props) {
    return [
        __WEBPACK_IMPORTED_MODULE_0__plugins__["G" /* pastePlugin */],
        __WEBPACK_IMPORTED_MODULE_0__plugins__["b" /* basePlugin */],
        __WEBPACK_IMPORTED_MODULE_0__plugins__["c" /* blockTypePlugin */],
        __WEBPACK_IMPORTED_MODULE_0__plugins__["H" /* placeholderPlugin */],
        __WEBPACK_IMPORTED_MODULE_0__plugins__["f" /* clearMarksOnChangeToEmptyDocumentPlugin */],
        __WEBPACK_IMPORTED_MODULE_0__plugins__["s" /* hyperlinkPlugin */],
        Object(__WEBPACK_IMPORTED_MODULE_0__plugins__["R" /* textFormattingPlugin */])(props.textFormatting || {}),
        __WEBPACK_IMPORTED_MODULE_0__plugins__["U" /* widthPlugin */],
        __WEBPACK_IMPORTED_MODULE_0__plugins__["S" /* typeAheadPlugin */],
        __WEBPACK_IMPORTED_MODULE_0__plugins__["T" /* unsupportedContentPlugin */],
        __WEBPACK_IMPORTED_MODULE_0__plugins__["k" /* editorDisabledPlugin */],
    ];
}
/**
 * Maps EditorProps to EditorPlugins
 */
function createPluginsList(props, createAnalyticsEvent) {
    var plugins = getDefaultPluginsList(props);
    if (props.allowBreakout && props.appearance === 'full-page') {
        plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["d" /* breakoutPlugin */]);
    }
    if (props.allowTextAlignment) {
        plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["a" /* alignment */]);
    }
    if (props.allowInlineAction) {
        plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["v" /* inlineActionPlugin */]);
    }
    if (props.allowTextColor) {
        plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["Q" /* textColorPlugin */]);
    }
    if (props.allowLists) {
        plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["A" /* listsPlugin */]);
    }
    if (props.allowRule) {
        plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["K" /* rulePlugin */]);
    }
    if (props.media || props.mediaProvider) {
        plugins.push(Object(__WEBPACK_IMPORTED_MODULE_0__plugins__["D" /* mediaPlugin */])(props.media));
    }
    if (props.allowCodeBlocks) {
        var options = props.allowCodeBlocks !== true ? props.allowCodeBlocks : {};
        plugins.push(Object(__WEBPACK_IMPORTED_MODULE_0__plugins__["g" /* codeBlockPlugin */])(options));
    }
    if (props.mentionProvider) {
        plugins.push(Object(__WEBPACK_IMPORTED_MODULE_0__plugins__["E" /* mentionsPlugin */])(createAnalyticsEvent));
    }
    if (props.emojiProvider) {
        plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["l" /* emojiPlugin */]);
    }
    if (props.allowTables) {
        plugins.push(Object(__WEBPACK_IMPORTED_MODULE_0__plugins__["O" /* tablesPlugin */])(props.allowTables));
    }
    if (props.allowTasksAndDecisions || props.taskDecisionProvider) {
        plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["P" /* tasksAndDecisionsPlugin */]);
    }
    if (props.allowHelpDialog) {
        plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["r" /* helpDialogPlugin */]);
    }
    if (props.saveOnEnter) {
        plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["L" /* saveOnEnterPlugin */]);
    }
    if (props.legacyImageUploadProvider) {
        plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["t" /* imageUploadPlugin */]);
        if (!props.media && !props.mediaProvider) {
            plugins.push(Object(__WEBPACK_IMPORTED_MODULE_0__plugins__["D" /* mediaPlugin */])({
                allowMediaSingle: { disableLayout: true },
                allowMediaGroup: false,
            }));
        }
    }
    if (props.collabEdit || props.collabEditProvider) {
        plugins.push(Object(__WEBPACK_IMPORTED_MODULE_0__plugins__["h" /* collabEditPlugin */])(props.collabEdit));
    }
    if (props.maxContentSize) {
        plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["C" /* maxContentSizePlugin */]);
    }
    if (props.allowJiraIssue) {
        plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["y" /* jiraIssuePlugin */]);
    }
    if (props.allowPanel) {
        plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["F" /* panelPlugin */]);
    }
    if (props.allowExtension) {
        plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["m" /* extensionPlugin */]);
    }
    if (props.macroProvider) {
        plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["B" /* macroPlugin */]);
    }
    if (props.allowConfluenceInlineComment) {
        plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["i" /* confluenceInlineComment */]);
    }
    if (props.allowDate) {
        plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["j" /* datePlugin */]);
    }
    if (props.allowTemplatePlaceholders) {
        var options = props.allowTemplatePlaceholders !== true
            ? props.allowTemplatePlaceholders
            : {};
        plugins.push(Object(__WEBPACK_IMPORTED_MODULE_0__plugins__["I" /* placeholderTextPlugin */])(options));
    }
    if (props.allowLayouts) {
        plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["z" /* layoutPlugin */]);
    }
    if (props.UNSAFE_cards) {
        plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["e" /* cardPlugin */]);
    }
    var statusMenuDisabled = true;
    if (props.allowStatus) {
        statusMenuDisabled =
            typeof props.allowStatus === 'object'
                ? props.allowStatus.menuDisabled
                : false;
        plugins.push(Object(__WEBPACK_IMPORTED_MODULE_0__plugins__["M" /* statusPlugin */])({ menuDisabled: statusMenuDisabled }));
    }
    if (props.allowIndentation) {
        plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["u" /* indentationPlugin */]);
    }
    // UI only plugins
    plugins.push(Object(__WEBPACK_IMPORTED_MODULE_0__plugins__["w" /* insertBlockPlugin */])({
        insertMenuItems: props.insertMenuItems,
        horizontalRuleEnabled: props.allowRule,
        nativeStatusSupported: !statusMenuDisabled,
    }));
    plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["p" /* gapCursorPlugin */]);
    plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["q" /* gridPlugin */]);
    plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["N" /* submitEditorPlugin */]);
    plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["n" /* fakeTextCursorPlugin */]);
    plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["o" /* floatingToolbarPlugin */]);
    if (props.appearance !== 'mobile') {
        plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["J" /* quickInsertPlugin */]);
    }
    if (props.appearance === 'message') {
        plugins.push(__WEBPACK_IMPORTED_MODULE_0__plugins__["x" /* isMultilineContentPlugin */]);
    }
    return plugins;
}
//# sourceMappingURL=create-plugins-list.js.map

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluginKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(21);




var blockTypeForNode = function (node, schema) {
    if (node.type === schema.nodes.heading) {
        var maybeNode = __WEBPACK_IMPORTED_MODULE_2__types__["c" /* HEADINGS_BY_LEVEL */][node.attrs['level']];
        if (maybeNode) {
            return maybeNode;
        }
    }
    else if (node.type === schema.nodes.paragraph) {
        return __WEBPACK_IMPORTED_MODULE_2__types__["k" /* NORMAL_TEXT */];
    }
    return __WEBPACK_IMPORTED_MODULE_2__types__["l" /* OTHER */];
};
var isBlockTypeSchemaSupported = function (blockType, state) {
    switch (blockType) {
        case __WEBPACK_IMPORTED_MODULE_2__types__["k" /* NORMAL_TEXT */]:
            return !!state.schema.nodes.paragraph;
        case __WEBPACK_IMPORTED_MODULE_2__types__["e" /* HEADING_1 */]:
        case __WEBPACK_IMPORTED_MODULE_2__types__["f" /* HEADING_2 */]:
        case __WEBPACK_IMPORTED_MODULE_2__types__["g" /* HEADING_3 */]:
        case __WEBPACK_IMPORTED_MODULE_2__types__["h" /* HEADING_4 */]:
        case __WEBPACK_IMPORTED_MODULE_2__types__["i" /* HEADING_5 */]:
        case __WEBPACK_IMPORTED_MODULE_2__types__["j" /* HEADING_6 */]:
            return !!state.schema.nodes.heading;
        case __WEBPACK_IMPORTED_MODULE_2__types__["a" /* BLOCK_QUOTE */]:
            return !!state.schema.nodes.blockquote;
        case __WEBPACK_IMPORTED_MODULE_2__types__["b" /* CODE_BLOCK */]:
            return !!state.schema.nodes.codeBlock;
        case __WEBPACK_IMPORTED_MODULE_2__types__["m" /* PANEL */]:
            return !!state.schema.nodes.panel;
    }
};
var detectBlockType = function (availableBlockTypes, state) {
    // Before a document is loaded, there is no selection.
    if (!state.selection) {
        return __WEBPACK_IMPORTED_MODULE_2__types__["k" /* NORMAL_TEXT */];
    }
    var blockType;
    var _a = state.selection, $from = _a.$from, $to = _a.$to;
    state.doc.nodesBetween($from.pos, $to.pos, function (node, pos) {
        var nodeBlockType = availableBlockTypes.filter(function (blockType) { return blockType === blockTypeForNode(node, state.schema); });
        if (nodeBlockType.length > 0) {
            if (!blockType) {
                blockType = nodeBlockType[0];
            }
            else if (blockType !== __WEBPACK_IMPORTED_MODULE_2__types__["l" /* OTHER */] && blockType !== nodeBlockType[0]) {
                blockType = __WEBPACK_IMPORTED_MODULE_2__types__["l" /* OTHER */];
            }
        }
    });
    return blockType || __WEBPACK_IMPORTED_MODULE_2__types__["l" /* OTHER */];
};
var pluginKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('blockTypePlugin');
var createPlugin = function (dispatch, appearance) {
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        appendTransaction: function (transactions, oldState, newState) {
            if (appearance === 'comment') {
                var pos = newState.doc.resolve(newState.doc.content.size - 1);
                var lastNode = pos.node(1);
                var paragraph = newState.schema.nodes.paragraph;
                if (lastNode && lastNode.isBlock && lastNode.type !== paragraph) {
                    return newState.tr.insert(newState.doc.content.size, newState.schema.nodes.paragraph.create());
                }
            }
        },
        state: {
            init: function (config, state) {
                var availableBlockTypes = __WEBPACK_IMPORTED_MODULE_2__types__["n" /* TEXT_BLOCK_TYPES */].filter(function (blockType) {
                    return isBlockTypeSchemaSupported(blockType, state);
                });
                var availableWrapperBlockTypes = __WEBPACK_IMPORTED_MODULE_2__types__["o" /* WRAPPER_BLOCK_TYPES */].filter(function (blockType) { return isBlockTypeSchemaSupported(blockType, state); });
                return {
                    currentBlockType: detectBlockType(availableBlockTypes, state),
                    blockTypesDisabled: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* areBlockTypesDisabled */])(state),
                    availableBlockTypes: availableBlockTypes,
                    availableWrapperBlockTypes: availableWrapperBlockTypes,
                };
            },
            apply: function (tr, oldPluginState, oldState, newState) {
                var newPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, oldPluginState, { currentBlockType: detectBlockType(oldPluginState.availableBlockTypes, newState), blockTypesDisabled: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* areBlockTypesDisabled */])(newState) });
                if (newPluginState.currentBlockType !== oldPluginState.currentBlockType ||
                    newPluginState.blockTypesDisabled !==
                        oldPluginState.blockTypesDisabled) {
                    dispatch(pluginKey, newPluginState);
                }
                return newPluginState;
            },
        },
        key: pluginKey,
    });
};
//# sourceMappingURL=main.js.map

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorMediaFullWidthIcon = function EditorMediaFullWidthIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M7 17h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zM4 5h16a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorMediaFullWidthIcon.displayName = 'EditorMediaFullWidthIcon';
var _default = EditorMediaFullWidthIcon;
exports.default = _default;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorMediaWideIcon = function EditorMediaWideIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M7 5h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2zm0 12h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zM4 9h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorMediaWideIcon.displayName = 'EditorMediaWideIcon';
var _default = EditorMediaWideIcon;
exports.default = _default;

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return arrow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setGapCursorAtPos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setCursorForTopLevelBlocks; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__direction__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selection__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pm_plugins_main__ = __webpack_require__(807);







var arrow = function (dir, endOfTextblock) { return function (state, dispatch) {
    var doc = state.doc, schema = state.schema, selection = state.selection, tr = state.tr;
    var $pos = Object(__WEBPACK_IMPORTED_MODULE_2__direction__["b" /* isBackward */])(dir) ? selection.$from : selection.$to;
    var mustMove = selection.empty;
    // start from text selection
    if (selection instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"]) {
        // if cursor is in the middle of a text node, do nothing
        if (!endOfTextblock(dir.toString())) {
            return false;
        }
        // UP/DOWN jumps to the nearest texblock skipping gapcursor whenever possible
        if ((dir === __WEBPACK_IMPORTED_MODULE_2__direction__["a" /* Direction */].UP &&
            !Object(__WEBPACK_IMPORTED_MODULE_5__utils__["d" /* atTheBeginningOfDoc */])(state) &&
            Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* isTextBlockNearPos */])(doc, schema, $pos, -1)) ||
            (dir === __WEBPACK_IMPORTED_MODULE_2__direction__["a" /* Direction */].DOWN &&
                (Object(__WEBPACK_IMPORTED_MODULE_5__utils__["f" /* atTheEndOfDoc */])(state) || Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* isTextBlockNearPos */])(doc, schema, $pos, 1)))) {
            return false;
        }
        // otherwise resolve previous/next position
        $pos = doc.resolve(Object(__WEBPACK_IMPORTED_MODULE_2__direction__["b" /* isBackward */])(dir) ? $pos.before() : $pos.after());
        mustMove = false;
    }
    // when jumping between block nodes at the same depth, we need to reverse cursor without changing ProseMirror position
    if (selection instanceof __WEBPACK_IMPORTED_MODULE_3__selection__["a" /* GapCursorSelection */] &&
        // next node allow gap cursor position
        Object(__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* isValidTargetNode */])(Object(__WEBPACK_IMPORTED_MODULE_2__direction__["b" /* isBackward */])(dir) ? $pos.nodeBefore : $pos.nodeAfter) &&
        // gap cursor changes block node
        ((Object(__WEBPACK_IMPORTED_MODULE_2__direction__["b" /* isBackward */])(dir) && selection.side === __WEBPACK_IMPORTED_MODULE_3__selection__["c" /* Side */].LEFT) ||
            (Object(__WEBPACK_IMPORTED_MODULE_2__direction__["c" /* isForward */])(dir) && selection.side === __WEBPACK_IMPORTED_MODULE_3__selection__["c" /* Side */].RIGHT))) {
        // reverse cursor position
        if (dispatch) {
            dispatch(tr
                .setSelection(new __WEBPACK_IMPORTED_MODULE_3__selection__["a" /* GapCursorSelection */]($pos, selection.side === __WEBPACK_IMPORTED_MODULE_3__selection__["c" /* Side */].RIGHT ? __WEBPACK_IMPORTED_MODULE_3__selection__["c" /* Side */].LEFT : __WEBPACK_IMPORTED_MODULE_3__selection__["c" /* Side */].RIGHT))
                .scrollIntoView());
        }
        return true;
    }
    var nextSelection = __WEBPACK_IMPORTED_MODULE_3__selection__["a" /* GapCursorSelection */].findFrom($pos, Object(__WEBPACK_IMPORTED_MODULE_2__direction__["b" /* isBackward */])(dir) ? -1 : 1, mustMove);
    if (!nextSelection) {
        return false;
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* isValidTargetNode */])(Object(__WEBPACK_IMPORTED_MODULE_2__direction__["c" /* isForward */])(dir)
        ? nextSelection.$from.nodeBefore
        : nextSelection.$from.nodeAfter)) {
        // reverse cursor position
        if (dispatch) {
            dispatch(tr
                .setSelection(new __WEBPACK_IMPORTED_MODULE_3__selection__["a" /* GapCursorSelection */](nextSelection.$from, Object(__WEBPACK_IMPORTED_MODULE_2__direction__["c" /* isForward */])(dir) ? __WEBPACK_IMPORTED_MODULE_3__selection__["c" /* Side */].LEFT : __WEBPACK_IMPORTED_MODULE_3__selection__["c" /* Side */].RIGHT))
                .scrollIntoView());
        }
        return true;
    }
    if (dispatch) {
        dispatch(tr.setSelection(nextSelection).scrollIntoView());
    }
    return true;
}; };
var deleteNode = function (dir) { return function (state, dispatch) {
    if (state.selection instanceof __WEBPACK_IMPORTED_MODULE_3__selection__["a" /* GapCursorSelection */]) {
        var _a = state.selection, $from = _a.$from, $anchor = _a.$anchor;
        var tr = state.tr;
        if (Object(__WEBPACK_IMPORTED_MODULE_2__direction__["b" /* isBackward */])(dir)) {
            if (state.selection.side === 'left') {
                tr.setSelection(new __WEBPACK_IMPORTED_MODULE_3__selection__["a" /* GapCursorSelection */]($anchor, __WEBPACK_IMPORTED_MODULE_3__selection__["c" /* Side */].RIGHT));
                if (dispatch) {
                    dispatch(tr);
                }
                return true;
            }
            tr = Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["removeNodeBefore"])(state.tr);
        }
        else if ($from.nodeAfter) {
            tr = tr.delete($from.pos, $from.pos + $from.nodeAfter.nodeSize);
        }
        if (dispatch) {
            dispatch(tr
                .setSelection(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Selection"].near(tr.doc.resolve(tr.mapping.map(state.selection.$from.pos))))
                .scrollIntoView());
        }
        return true;
    }
    return false;
}; };
var setGapCursorAtPos = function (position, side) {
    if (side === void 0) { side = __WEBPACK_IMPORTED_MODULE_3__selection__["c" /* Side */].LEFT; }
    return function (state, dispatch) {
        var $pos = state.doc.resolve(position);
        if (__WEBPACK_IMPORTED_MODULE_3__selection__["a" /* GapCursorSelection */].valid($pos)) {
            if (dispatch) {
                dispatch(state.tr.setSelection(new __WEBPACK_IMPORTED_MODULE_3__selection__["a" /* GapCursorSelection */]($pos, side)));
            }
            return true;
        }
        return false;
    };
};
// This function captures clicks outside of the ProseMirror contentEditable area
// see also description of "handleClick" in gap-cursor pm-plugin
var captureCursorCoords = function (event, editorRef, posAtCoords, state) {
    var rect = editorRef.getBoundingClientRect();
    // capture clicks before the first block element
    if (event.clientY < rect.top) {
        return { position: 0, side: __WEBPACK_IMPORTED_MODULE_3__selection__["c" /* Side */].LEFT };
    }
    if (rect.left > 0) {
        // calculate start position of a node that is vertically at the same level
        var coords = posAtCoords({
            left: rect.left,
            top: event.clientY,
        });
        if (coords && coords.inside > -1) {
            var $from = state.doc.resolve(coords.inside);
            var start = $from.before(1);
            var side = event.clientX < rect.left ? __WEBPACK_IMPORTED_MODULE_3__selection__["c" /* Side */].LEFT : __WEBPACK_IMPORTED_MODULE_3__selection__["c" /* Side */].RIGHT;
            var position = void 0;
            if (side === __WEBPACK_IMPORTED_MODULE_3__selection__["c" /* Side */].LEFT) {
                position = start;
            }
            else {
                var node = state.doc.nodeAt(start);
                if (node) {
                    position = start + node.nodeSize;
                }
            }
            return { position: position, side: side };
        }
    }
    return null;
};
var setCursorForTopLevelBlocks = function (event, editorRef, posAtCoords) { return function (state, dispatch) {
    // plugin is disabled
    if (!__WEBPACK_IMPORTED_MODULE_6__pm_plugins_main__["b" /* pluginKey */].get(state)) {
        return false;
    }
    var cursorCoords = captureCursorCoords(event, editorRef, posAtCoords, state);
    if (!cursorCoords) {
        return false;
    }
    var $pos = state.doc.resolve(cursorCoords.position);
    var isGapCursorAllowed = cursorCoords.side === __WEBPACK_IMPORTED_MODULE_3__selection__["c" /* Side */].LEFT
        ? Object(__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* isValidTargetNode */])($pos.nodeAfter)
        : Object(__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* isValidTargetNode */])($pos.nodeBefore);
    if (isGapCursorAllowed && __WEBPACK_IMPORTED_MODULE_3__selection__["a" /* GapCursorSelection */].valid($pos)) {
        // this forces PM to re-render the decoration node if we change the side of the gap cursor, it doesn't do it by default
        if (state.selection instanceof __WEBPACK_IMPORTED_MODULE_3__selection__["a" /* GapCursorSelection */]) {
            if (dispatch) {
                dispatch(state.tr.setSelection(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Selection"].near($pos)));
            }
        }
        if (dispatch) {
            dispatch(state.tr.setSelection(new __WEBPACK_IMPORTED_MODULE_3__selection__["a" /* GapCursorSelection */]($pos, cursorCoords.side)));
        }
        return true;
    }
    // try to set text selection
    else {
        var selection = __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Selection"].findFrom($pos, cursorCoords.side === __WEBPACK_IMPORTED_MODULE_3__selection__["c" /* Side */].LEFT ? 1 : -1, true);
        if (selection) {
            if (dispatch) {
                dispatch(state.tr.setSelection(selection));
            }
            return true;
        }
    }
    return false;
}; };
//# sourceMappingURL=actions.js.map

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return logger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(2386);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__collab_provider__ = __webpack_require__(2387);
/* unused harmony reexport CollabProvider */


var logger = function (msg, data, style) {
    if (data === void 0) { data = null; }
    if (style === void 0) { style = 'color:blue;font-weight:bold;'; }
    // tslint:disable-next-line:no-console
    console.log("%cCollab-Edit: " + msg, style);
    if (data) {
        // tslint:disable-next-line:no-console
        console.log(data);
    }
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorMentionIcon = function EditorMentionIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M12.062 13.93c-.904 0-1.451-.734-1.451-1.945 0-1.226.538-1.952 1.466-1.952.928 0 1.422.764 1.422 1.967 0 1.195-.502 1.93-1.438 1.93M12 5c-3.925 0-7 3.075-7 7 0 4.596 3.522 7 7 7 .874 0 1.614-.09 2.26-.279a.751.751 0 0 0-.42-1.44c-.508.147-1.11.22-1.84.22-2.648 0-5.5-1.722-5.5-5.5 0-3.085 2.417-5.5 5.5-5.5 3.24 0 5.5 1.952 5.5 4.75 0 2.045-1.043 3-1.748 3-.008 0-.752-.11-.752-.75v-4a.75.75 0 1 0-1.5 0v.187c-.346-.585-1.016-.952-1.795-.952C10.102 8.736 9 10.04 9 11.938c0 1.984 1.103 3.312 2.753 3.312.865 0 1.51-.387 1.865-1.076.334 1.016 1.37 1.576 2.132 1.576 1.598 0 3.25-1.683 3.25-4.5C19 7.628 16.058 5 12 5\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorMentionIcon.displayName = 'EditorMentionIcon';
var _default = EditorMentionIcon;
exports.default = _default;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorTaskIcon = function EditorTaskIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M7.5 6h9A1.5 1.5 0 0 1 18 7.5v9a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 16.5v-9A1.5 1.5 0 0 1 7.5 6zm3.072 8.838l.143.154a.5.5 0 0 0 .769-.042l.13-.175 3.733-5.045a.8.8 0 0 0-.11-1.064.665.665 0 0 0-.984.118l-3.243 4.387-1.315-1.422a.663.663 0 0 0-.99 0 .801.801 0 0 0 0 1.07l1.867 2.019z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorTaskIcon.displayName = 'EditorTaskIcon';
var _default = EditorTaskIcon;
exports.default = _default;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorDecisionIcon = function EditorDecisionIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M9.414 8l3.293 3.293c.187.187.293.442.293.707v5a1 1 0 0 1-2 0v-4.586l-3-3V10.5a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2H9.414zm8.293-1.707a.999.999 0 0 1 0 1.414l-2.5 2.5a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414l2.5-2.5a.999.999 0 0 1 1.414 0z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorDecisionIcon.displayName = 'EditorDecisionIcon';
var _default = EditorDecisionIcon;
exports.default = _default;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorMoreIcon = function EditorMoreIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M12 14a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm-4.5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorMoreIcon.displayName = 'EditorMoreIcon';
var _default = EditorMoreIcon;
exports.default = _default;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorEmojiIcon = function EditorEmojiIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M12 5a7 7 0 1 1 0 14 7 7 0 0 1 0-14zm0 12.5c3.033 0 5.5-2.467 5.5-5.5S15.033 6.5 12 6.5A5.506 5.506 0 0 0 6.5 12c0 3.033 2.467 5.5 5.5 5.5zm-1.5-6a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm.27 1.583a.626.626 0 0 1 .932.834A3.63 3.63 0 0 1 12 15.125a3.63 3.63 0 0 1-2.698-1.204.625.625 0 0 1 .93-.835c.901 1.003 2.639 1.003 3.538-.003z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorEmojiIcon.displayName = 'EditorEmojiIcon';
var _default = EditorEmojiIcon;
exports.default = _default;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorLayoutTwoEqualIcon = function EditorLayoutTwoEqualIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M5 5h5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm9 0h5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorLayoutTwoEqualIcon.displayName = 'EditorLayoutTwoEqualIcon';
var _default = EditorLayoutTwoEqualIcon;
exports.default = _default;

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__messages__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils___ = __webpack_require__(21);







var getInsertLineHeight = function (tableRef) {
    return tableRef.offsetHeight + __WEBPACK_IMPORTED_MODULE_4__styles__["j" /* tableToolbarSize */];
};
var getToolbarSize = function (tableRef) {
    var parent = Object(__WEBPACK_IMPORTED_MODULE_6__utils___["i" /* closestElement */])(tableRef, "." + __WEBPACK_IMPORTED_MODULE_3__types__["a" /* TableCssClassName */].TABLE_CONTAINER);
    if (parent) {
        return parent.querySelector("." + __WEBPACK_IMPORTED_MODULE_3__types__["a" /* TableCssClassName */].NUMBERED_COLUMN)
            ? __WEBPACK_IMPORTED_MODULE_4__styles__["j" /* tableToolbarSize */] + __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["w" /* akEditorTableNumberColumnWidth */] - 1
            : __WEBPACK_IMPORTED_MODULE_4__styles__["j" /* tableToolbarSize */];
    }
    return __WEBPACK_IMPORTED_MODULE_4__styles__["j" /* tableToolbarSize */];
};
var getInsertLineWidth = function (tableRef) {
    var parentElement = tableRef.parentElement, offsetWidth = tableRef.offsetWidth;
    var parentOffsetWidth = parentElement.offsetWidth;
    var scrollLeft = parentElement.scrollLeft;
    var diff = offsetWidth - parentOffsetWidth;
    var toolbarSize = getToolbarSize(tableRef);
    return Math.min(offsetWidth + toolbarSize, parentOffsetWidth + toolbarSize - Math.max(scrollLeft - diff, 0));
};
var InsertButton = function (_a) {
    var onMouseDown = _a.onMouseDown, index = _a.index, tableRef = _a.tableRef, showInsertButton = _a.showInsertButton, type = _a.type, formatMessage = _a.intl.formatMessage;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { "data-index": index, className: __WEBPACK_IMPORTED_MODULE_3__types__["a" /* TableCssClassName */].CONTROLS_INSERT_BUTTON_WRAP + " " + (type === 'row'
            ? __WEBPACK_IMPORTED_MODULE_3__types__["a" /* TableCssClassName */].CONTROLS_INSERT_ROW
            : __WEBPACK_IMPORTED_MODULE_3__types__["a" /* TableCssClassName */].CONTROLS_INSERT_COLUMN) },
        showInsertButton && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3__types__["a" /* TableCssClassName */].CONTROLS_INSERT_BUTTON_INNER },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { type: "button", title: formatMessage(type === 'row'
                        ? __WEBPACK_IMPORTED_MODULE_5__messages__["a" /* default */].insertRow
                        : __WEBPACK_IMPORTED_MODULE_5__messages__["a" /* default */].insertColumn), className: __WEBPACK_IMPORTED_MODULE_3__types__["a" /* TableCssClassName */].CONTROLS_INSERT_BUTTON, onMouseDown: onMouseDown },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg", { className: __WEBPACK_IMPORTED_MODULE_3__types__["a" /* TableCssClassName */].CONTROLS_BUTTON_ICON },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M10 4a1 1 0 0 1 1 1v4h4a1 1 0 0 1 0 2h-4v4a1 1 0 0 1-2 0v-4H5a1 1 0 1 1 0-2h4V5a1 1 0 0 1 1-1z", fill: "currentColor", fillRule: "evenodd" })))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3__types__["a" /* TableCssClassName */].CONTROLS_INSERT_LINE, style: type === 'row'
                    ? { width: getInsertLineWidth(tableRef) }
                    : { height: getInsertLineHeight(tableRef) } }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3__types__["a" /* TableCssClassName */].CONTROLS_INSERT_MARKER })));
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["injectIntl"])(InsertButton));
//# sourceMappingURL=InsertButton.js.map

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(727)

/**
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek (dirtyDate) {
  return startOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = startOfISOWeek


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluginKey; });
/* unused harmony export createPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_document__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fake_text_cursor_cursor__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nodeviews_placeholder_text__ = __webpack_require__(2443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_PlaceholderFloatingToolbar__ = __webpack_require__(2444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(828);










var pluginKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('placeholderTextPlugin');
function createPlugin(dispatch, options) {
    var allowInserting = !!options.allowInserting;
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        key: pluginKey,
        state: {
            init: function () {
                return ({
                    showInsertPanelAt: null,
                    allowInserting: allowInserting,
                });
            },
            apply: function (tr, state) {
                var meta = tr.getMeta(pluginKey);
                if (meta && meta.showInsertPanelAt !== undefined) {
                    var newState = {
                        showInsertPanelAt: meta.showInsertPanelAt,
                        allowInserting: allowInserting,
                    };
                    dispatch(pluginKey, newState);
                    return newState;
                }
                else if (state.showInsertPanelAt) {
                    var newState = {
                        showInsertPanelAt: tr.mapping.map(state.showInsertPanelAt),
                        allowInserting: allowInserting,
                    };
                    dispatch(pluginKey, newState);
                    return newState;
                }
                return state;
            },
        },
        props: {
            nodeViews: {
                placeholder: function (node, view, getPos) {
                    return new __WEBPACK_IMPORTED_MODULE_6__nodeviews_placeholder_text__["a" /* default */](node, view, getPos);
                },
            },
        },
        appendTransaction: function (transactions, oldState, newState) {
            if (transactions.some(function (txn) { return txn.docChanged; })) {
                var didPlaceholderExistBeforeTxn = oldState.selection.$head.nodeAfter ===
                    newState.selection.$head.nodeAfter;
                var adjacentNode = newState.selection.$head.nodeAfter;
                var adjacentNodePos = newState.selection.$head.pos;
                var placeholderNodeType = newState.schema.nodes.placeholder;
                if (adjacentNode &&
                    adjacentNode.type === placeholderNodeType &&
                    didPlaceholderExistBeforeTxn) {
                    // Check that cursor has moved forward in the document **and** that there is content before the cursor
                    var wasContentAdded = oldState.selection.$head.pos < newState.selection.$head.pos &&
                        !Object(__WEBPACK_IMPORTED_MODULE_4__utils_document__["d" /* isEmptyNode */])(newState.selection.$head.nodeBefore);
                    if (wasContentAdded) {
                        var _a = __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["NodeSelection"].create(newState.doc, adjacentNodePos), $from = _a.$from, $to = _a.$to;
                        return newState.tr.deleteRange($from.pos, $to.pos);
                    }
                }
            }
            // Handle Fake Text Cursor for Floating Toolbar
            if (!pluginKey.getState(oldState).showInsertPanelAt &&
                pluginKey.getState(newState).showInsertPanelAt) {
                return newState.tr.setSelection(new __WEBPACK_IMPORTED_MODULE_5__fake_text_cursor_cursor__["a" /* FakeTextCursorSelection */](newState.selection.$from));
            }
            if (pluginKey.getState(oldState).showInsertPanelAt &&
                !pluginKey.getState(newState).showInsertPanelAt) {
                if (newState.selection instanceof __WEBPACK_IMPORTED_MODULE_5__fake_text_cursor_cursor__["a" /* FakeTextCursorSelection */]) {
                    return newState.tr.setSelection(new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["TextSelection"](newState.selection.$from));
                }
            }
        },
    });
}
var placeholderTextPlugin = function (options) { return ({
    nodes: function () {
        return [{ name: 'placeholder', node: __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__["_1" /* placeholder */] }];
    },
    pmPlugins: function () {
        return [
            {
                name: 'placeholderText',
                plugin: function (_a) {
                    var schema = _a.schema, props = _a.props, dispatch = _a.dispatch;
                    return createPlugin(dispatch, options);
                },
            },
        ];
    },
    contentComponent: function (_a) {
        var editorView = _a.editorView, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement;
        var insertPlaceholderText = function (value) {
            return Object(__WEBPACK_IMPORTED_MODULE_8__actions__["b" /* insertPlaceholderTextAtSelection */])(value)(editorView.state, editorView.dispatch);
        };
        var hidePlaceholderToolbar = function () {
            return Object(__WEBPACK_IMPORTED_MODULE_8__actions__["a" /* hidePlaceholderFloatingToolbar */])(editorView.state, editorView.dispatch);
        };
        var getNodeFromPos = function (pos) { return editorView.domAtPos(pos).node; };
        var getFixedCoordinatesFromPos = function (pos) {
            return editorView.coordsAtPos(pos);
        };
        var setFocusInEditor = function () { return editorView.focus(); };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ui_WithPluginState__["a" /* default */], { plugins: { placeholderTextState: pluginKey }, render: function (_a) {
                var _b = _a.placeholderTextState, placeholderTextState = _b === void 0 ? {} : _b;
                if (placeholderTextState.showInsertPanelAt) {
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ui_PlaceholderFloatingToolbar__["a" /* default */], { editorViewDOM: editorView.dom, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, getFixedCoordinatesFromPos: getFixedCoordinatesFromPos, getNodeFromPos: getNodeFromPos, hidePlaceholderFloatingToolbar: hidePlaceholderToolbar, showInsertPanelAt: placeholderTextState.showInsertPanelAt, insertPlaceholder: insertPlaceholderText, setFocusInEditor: setFocusInEditor }));
                }
                return null;
            } }));
    },
}); };
/* harmony default export */ __webpack_exports__["a"] = (placeholderTextPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2445);




var PanelTextInput = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](PanelTextInput, _super);
    function PanelTextInput(props) {
        var _this = _super.call(this, props) || this;
        _this.onMouseDown = function () {
            var onMouseDown = _this.props.onMouseDown;
            if (onMouseDown) {
                onMouseDown();
            }
        };
        _this.onBlur = function () {
            var onBlur = _this.props.onBlur;
            if (onBlur) {
                onBlur();
            }
        };
        _this.handleChange = function () {
            var onChange = _this.props.onChange;
            if (_this.input) {
                _this.setState({
                    value: _this.input.value,
                });
            }
            if (onChange && _this.input) {
                onChange(_this.input.value);
            }
        };
        _this.handleKeydown = function (e) {
            if (e.keyCode === 13 && _this.props.onSubmit) {
                e.preventDefault(); // Prevent from submitting if an editor is inside a form.
                _this.props.onSubmit(_this.input.value);
            }
            else if (e.keyCode === 27 && _this.props.onCancel) {
                _this.props.onCancel();
            }
            if (_this.props.onKeyDown) {
                _this.props.onKeyDown(e);
            }
        };
        _this.handleRef = function (input) {
            if (input instanceof HTMLInputElement) {
                _this.input = input;
                if (_this.props.autoFocus) {
                    // Need this to prevent jumping when we render TextInput inside Portal @see ED-2992
                    window.setTimeout(function () { return input.focus(); });
                }
            }
            else {
                _this.input = undefined;
            }
        };
        _this.state = {
            value: props.defaultValue || '',
        };
        return _this;
    }
    PanelTextInput.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.defaultValue !== this.props.defaultValue) {
            this.setState({
                value: nextProps.defaultValue,
            });
        }
    };
    PanelTextInput.prototype.render = function () {
        var _a = this.props, placeholder = _a.placeholder, width = _a.width;
        var value = this.state.value;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Input */], { type: "text", placeholder: placeholder, value: value, onChange: this.handleChange, onKeyDown: this.handleKeydown, onMouseDown: this.onMouseDown, onBlur: this.onBlur, innerRef: this.handleRef, width: width }));
    };
    PanelTextInput.prototype.focus = function () {
        var input = this.input;
        if (input) {
            input.focus();
        }
    };
    return PanelTextInput;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (PanelTextInput);
//# sourceMappingURL=index.js.map

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = setLinkHref;
/* harmony export (immutable) */ __webpack_exports__["e"] = setLinkText;
/* harmony export (immutable) */ __webpack_exports__["b"] = insertLink;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeLink;
/* harmony export (immutable) */ __webpack_exports__["f"] = showLinkToolbar;
/* harmony export (immutable) */ __webpack_exports__["a"] = hideLinkToolbar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_commands__ = __webpack_require__(282);





var isLinkAtPos = function (pos) { return function (state) {
    var text = state.doc.nodeAt(pos);
    if (text) {
        var link = state.schema.marks.link;
        return !!link.isInSet(text.marks);
    }
    return false;
}; };
function setLinkHref(pos, href) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__utils_commands__["a" /* filter */])(isLinkAtPos(pos), function (state, dispatch) {
        var node = state.doc.nodeAt(pos);
        var link = state.schema.marks.link;
        var mark = link.isInSet(node.marks);
        var url = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* normalizeUrl */])(href);
        var tr = state.tr.removeMark(pos, pos + node.nodeSize, mark);
        if (href.trim()) {
            tr.addMark(pos, pos + node.nodeSize, link.create(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, mark.attrs, { href: url })));
        }
        if (dispatch) {
            dispatch(tr);
        }
        return true;
    });
}
function setLinkText(pos, text) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__utils_commands__["a" /* filter */])(isLinkAtPos(pos), function (state, dispatch) {
        var node = state.doc.nodeAt(pos);
        var link = state.schema.marks.link;
        var mark = link.isInSet(node.marks);
        if (node && text && text !== node.text) {
            var tr = state.tr;
            tr.insertText(text, pos, pos + node.nodeSize);
            tr.addMark(pos, pos + text.length, mark);
            if (dispatch) {
                dispatch(tr);
            }
            return true;
        }
        return false;
    });
}
function insertLink(from, to, href, text) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__utils_commands__["a" /* filter */])(Object(__WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["c" /* canLinkBeCreatedInRange */])(from, to), function (state, dispatch) {
        var link = state.schema.marks.link;
        if (href.trim()) {
            var tr = state.tr;
            if (from === to) {
                var textContent = text || href;
                tr.insertText(textContent, from, to);
                tr.addMark(from, from + textContent.length, link.create({ href: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* normalizeUrl */])(href) }));
            }
            else {
                tr.addMark(from, to, link.create({ href: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* normalizeUrl */])(href) }));
                tr.setSelection(__WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["Selection"].near(tr.doc.resolve(to)));
            }
            if (dispatch) {
                dispatch(tr);
            }
            return true;
        }
        return false;
    });
}
function removeLink(pos) {
    return setLinkHref(pos, '');
}
function showLinkToolbar() {
    return function (state, dispatch) {
        if (dispatch) {
            dispatch(state.tr.setMeta(__WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["e" /* stateKey */], __WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["b" /* LinkAction */].SHOW_INSERT_TOOLBAR));
        }
        return true;
    };
}
function hideLinkToolbar() {
    return function (state, dispatch) {
        if (dispatch) {
            dispatch(state.tr.setMeta(__WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["e" /* stateKey */], __WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["b" /* LinkAction */].HIDE_TOOLBAR));
        }
        return true;
    };
}
//# sourceMappingURL=commands.js.map

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluginKey; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeviews_extension__ = __webpack_require__(2473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(834);






var pluginKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('extensionPlugin');
/* harmony default export */ __webpack_exports__["a"] = (function (dispatch, providerFactory, extensionHandlers, portalProviderAPI, allowExtension) {
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        state: {
            init: function () {
                var stickToolbarToBottom = true;
                var allowBreakout = false;
                if (typeof allowExtension === 'object') {
                    stickToolbarToBottom = !!allowExtension.stickToolbarToBottom;
                    allowBreakout = !!allowExtension.allowBreakout;
                }
                return {
                    element: null,
                    layout: 'default',
                    showLayoutOptions: true,
                    stickToolbarToBottom: stickToolbarToBottom,
                    node: null,
                    allowBreakout: allowBreakout,
                };
            },
            apply: function (tr, state, prevState, nextState) {
                var nextPluginState = tr.getMeta(pluginKey);
                if (nextPluginState) {
                    dispatch(pluginKey, nextPluginState);
                    return nextPluginState;
                }
                return state;
            },
        },
        view: function (editorView) {
            var domAtPos = editorView.domAtPos.bind(editorView);
            return {
                update: function (view) {
                    var editorDispatch = view.dispatch, state = view.state, schema = view.state.schema;
                    /** this fetches the selected extn node, either by keyboard selection or click for all types of extns */
                    var selectedExtNode = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* getExtensionNode */])(state);
                    var selectedExtDomNode = selectedExtNode &&
                        Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findDomRefAtPos"])(selectedExtNode.pos, domAtPos);
                    var pluginState = pluginKey.getState(state);
                    if (!selectedExtNode && !pluginState.element) {
                        return;
                    }
                    var _a = schema.nodes, extension = _a.extension, inlineExtension = _a.inlineExtension;
                    var isNonContentExt = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findSelectedNodeOfType"])([
                        inlineExtension,
                        extension,
                    ])(state.selection);
                    /** Non-content extension can be nested in bodied-extension, the following check is necessary for that case */
                    var newElement = selectedExtNode && selectedExtDomNode.querySelector
                        ? isNonContentExt
                            ? selectedExtDomNode.querySelector('.extension-container') ||
                                selectedExtDomNode
                            : Object(__WEBPACK_IMPORTED_MODULE_4__utils__["i" /* closestElement */])(selectedExtDomNode, '.extension-container') ||
                                selectedExtDomNode.querySelector('.extension-container') ||
                                selectedExtDomNode
                        : undefined;
                    if (pluginState.element !== newElement) {
                        editorDispatch(state.tr.setMeta(pluginKey, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { element: newElement, layout: selectedExtNode && selectedExtNode.node.attrs.layout, node: selectedExtNode })));
                        return true;
                    }
                    /** Required toolbar re-positioning */
                    dispatch(pluginKey, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState));
                    return true;
                },
            };
        },
        key: pluginKey,
        props: {
            nodeViews: {
                extension: Object(__WEBPACK_IMPORTED_MODULE_2__nodeviews_extension__["a" /* default */])(portalProviderAPI, providerFactory, extensionHandlers),
                bodiedExtension: Object(__WEBPACK_IMPORTED_MODULE_2__nodeviews_extension__["a" /* default */])(portalProviderAPI, providerFactory, extensionHandlers),
                inlineExtension: Object(__WEBPACK_IMPORTED_MODULE_2__nodeviews_extension__["a" /* default */])(portalProviderAPI, providerFactory, extensionHandlers),
            },
        },
    });
});
//# sourceMappingURL=plugin.js.map

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FORMATTING_NODE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FORMATTING_MARK_TYPES; });
/* harmony export (immutable) */ __webpack_exports__["c"] = clearFormatting;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_transform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__);

var FORMATTING_NODE_TYPES = [
    'heading',
    'codeBlock',
    'blockquote',
    'panel',
];
var FORMATTING_MARK_TYPES = [
    'em',
    'code',
    'strike',
    'strong',
    'underline',
    'textColor',
    'subsup',
];
function clearFormatting() {
    return function (state, dispatch) {
        var tr = state.tr;
        FORMATTING_MARK_TYPES.forEach(function (mark) {
            var _a = tr.selection, from = _a.from, to = _a.to;
            if (state.schema.marks[mark]) {
                tr.removeMark(from, to, state.schema.marks[mark]);
            }
        });
        FORMATTING_NODE_TYPES.forEach(function (nodeName) {
            var formattedNodeType = state.schema.nodes[nodeName];
            var _a = tr.selection, $from = _a.$from, $to = _a.$to;
            tr.doc.nodesBetween($from.pos, $to.pos, function (node, pos) {
                if (node.hasMarkup(formattedNodeType)) {
                    if (formattedNodeType.isTextblock) {
                        tr.setNodeMarkup(pos, state.schema.nodes.paragraph);
                        return false;
                    }
                    else {
                        var fromPos = tr.doc.resolve(pos + 1);
                        var toPos = tr.doc.resolve(pos + node.nodeSize - 1);
                        var nodeRange = fromPos.blockRange(toPos);
                        if (nodeRange) {
                            var targetLiftDepth = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["liftTarget"])(nodeRange);
                            if (targetLiftDepth || targetLiftDepth === 0) {
                                tr.lift(nodeRange, targetLiftDepth);
                            }
                        }
                    }
                }
                return true;
            });
        });
        tr.setStoredMarks([]);
        if (dispatch) {
            dispatch(tr);
        }
        return true;
    };
}
//# sourceMappingURL=clear-formatting.js.map

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluginKey; });
/* unused harmony export getPluginState */
/* unused harmony export resolveWithProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers__ = __webpack_require__(2490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nodeviews_inlineCard__ = __webpack_require__(2491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nodeviews_blockCard__ = __webpack_require__(2508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__doc__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__nodeviews__ = __webpack_require__(2510);








var pluginKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('cardPlugin');
var getPluginState = function (editorState) {
    return pluginKey.getState(editorState);
};
var handleResolved = function (view, request) { return function (resolvedCard) {
    Object(__WEBPACK_IMPORTED_MODULE_6__doc__["b" /* replaceQueuedUrlWithCard */])(request.url, resolvedCard)(view.state, view.dispatch);
    return resolvedCard;
}; };
var handleRejected = function (view, request) { return function (rejected) {
    view.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* resolveCard */])(request.url)(view.state.tr));
}; };
var resolveWithProvider = function (view, outstandingRequests, provider, request) {
    var $pos = view.state.doc.resolve(request.pos);
    var parent = $pos.parent;
    var isBlock = parent.type.name === 'paragraph' &&
        parent.childCount === 1 &&
        parent.firstChild.type.isText &&
        parent.firstChild.text === request.url &&
        $pos.node($pos.depth - 1).type.name === 'doc';
    outstandingRequests[request.url] = provider
        .resolve(request.url, isBlock ? 'block' : 'inline')
        .then(function (resolvedCard) {
        delete outstandingRequests[request.url];
        return resolvedCard;
    })
        .then(handleResolved(view, request), handleRejected(view, request));
};
var createPlugin = function (_a) {
    var portalProviderAPI = _a.portalProviderAPI, dispatch = _a.dispatch, providerFactory = _a.providerFactory;
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        state: {
            init: function () {
                return {
                    requests: [],
                    provider: null,
                };
            },
            apply: function (tr, pluginState) {
                // update all the positions
                var remappedState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { requests: pluginState.requests.map(function (request) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, request, { pos: tr.mapping.map(request.pos) })); }) });
                // apply any actions
                var meta = tr.getMeta(pluginKey);
                if (meta) {
                    var nextPluginState = Object(__WEBPACK_IMPORTED_MODULE_2__reducers__["a" /* default */])(remappedState, meta);
                    return nextPluginState;
                }
                return remappedState;
            },
        },
        view: function (view) {
            // listen for card provider changes
            var handleProvider = function (name, provider) {
                if (name !== 'cardProvider') {
                    return;
                }
                provider.then(function (cardProvider) {
                    var state = view.state, dispatch = view.dispatch;
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* setProvider */])(cardProvider)(state.tr));
                });
            };
            providerFactory.subscribe('cardProvider', handleProvider);
            var outstandingRequests = {};
            return {
                update: function (view, prevState) {
                    var currentState = getPluginState(view.state);
                    var oldState = getPluginState(prevState);
                    if (currentState && currentState.provider) {
                        // find requests in this state that weren't in the old one
                        var newRequests = oldState
                            ? currentState.requests.filter(function (req) {
                                return !oldState.requests.find(function (oldReq) {
                                    return oldReq.url === req.url && oldReq.pos === req.pos;
                                });
                            })
                            : currentState.requests;
                        // ask the CardProvider to resolve all new requests
                        var provider_1 = currentState.provider;
                        newRequests.forEach(function (request) {
                            resolveWithProvider(view, outstandingRequests, provider_1, request);
                        });
                    }
                },
                destroy: function () {
                    // cancel all outstanding requests
                    Object.keys(outstandingRequests).forEach(function (url) {
                        return Promise.reject(outstandingRequests[url]);
                    });
                    providerFactory.unsubscribe('cardProvider', handleProvider);
                },
            };
        },
        props: {
            nodeViews: {
                inlineCard: __WEBPACK_IMPORTED_MODULE_7__nodeviews__["a" /* CardNodeView */].fromComponent(__WEBPACK_IMPORTED_MODULE_4__nodeviews_inlineCard__["a" /* default */], portalProviderAPI, {
                    providerFactory: providerFactory,
                }),
                blockCard: __WEBPACK_IMPORTED_MODULE_7__nodeviews__["a" /* CardNodeView */].fromComponent(__WEBPACK_IMPORTED_MODULE_5__nodeviews_blockCard__["a" /* default */], portalProviderAPI, {
                    providerFactory: providerFactory,
                }),
            },
        },
        key: pluginKey,
    });
};
//# sourceMappingURL=main.js.map

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return replaceQueuedUrlWithCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return queueCardsFromChangedTr; });
/* unused harmony export changeSelectedCardToLink */
/* unused harmony export setSelectedCardAppearance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(2509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(21);





var replaceQueuedUrlWithCard = function (url, cardData) { return function (editorState, dispatch) {
    var state = __WEBPACK_IMPORTED_MODULE_1__main__["b" /* pluginKey */].getState(editorState);
    if (!state) {
        return false;
    }
    // find the requests for this URL
    var requests = state.requests.filter(function (req) { return req.url === url; });
    // try to transform response to ADF
    var schema = editorState.schema;
    var cardAdf = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["E" /* processRawValue */])(schema, cardData);
    var tr = editorState.tr;
    if (cardAdf) {
        requests.forEach(function (request) {
            // replace all the outstanding links with their cards
            var pos = tr.mapping.map(request.pos);
            var node = tr.doc.nodeAt(pos);
            if (!node || !node.type.isText) {
                return;
            }
            // not a link anymore
            var linkMark = node.marks.find(function (mark) { return mark.type.name === 'link'; });
            if (!linkMark) {
                return;
            }
            var textSlice = node.text;
            if (linkMark.attrs.href !== url || textSlice !== url) {
                return;
            }
            tr = tr.replaceWith(pos, pos + url.length, cardAdf);
        });
    }
    if (dispatch) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* resolveCard */])(url)(tr));
    }
    return true;
}; };
var queueCardsFromChangedTr = function (state, tr) {
    var schema = state.schema;
    var link = schema.marks.link;
    var stepRange = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["p" /* getStepRange */])(tr);
    if (!stepRange) {
        // no steps mutate this document, do nothing
        return tr;
    }
    var requests = [];
    tr.doc.nodesBetween(stepRange.from, stepRange.to, function (node, pos) {
        if (!node.isText) {
            return true;
        }
        var linkMark = node.marks.find(function (mark) { return mark.type === link; });
        if (linkMark) {
            // don't bother queueing nodes that have user-defined text for a link
            if (node.text !== linkMark.attrs.href) {
                return false;
            }
            requests.push({
                url: linkMark.attrs.href,
                pos: pos,
                appearance: 'inline',
            });
        }
        return false;
    });
    return Object(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* queueCards */])(requests)(tr);
};
var changeSelectedCardToLink = function (state, dispatch) {
    var selectedNode = state.selection instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"] && state.selection.node;
    if (!selectedNode) {
        return false;
    }
    var link = state.schema.marks.link;
    var tr = state.tr.replaceSelectionWith(state.schema.text(selectedNode.attrs.url, [
        link.create({ href: selectedNode.attrs.url }),
    ]), false);
    if (dispatch) {
        dispatch(tr.scrollIntoView());
    }
    return true;
};
var setSelectedCardAppearance = function (appearance) { return function (state, dispatch) {
    var selectedNode = state.selection instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"] && state.selection.node;
    if (!selectedNode) {
        return false;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* appearanceForNodeType */])(selectedNode.type) === appearance) {
        return false;
    }
    var _a = state.schema.nodes, inlineCard = _a.inlineCard, blockCard = _a.blockCard;
    var pos = state.selection.from;
    if (appearance === 'block' && state.selection.$from.parent.childCount === 1) {
        var tr_1 = state.tr.replaceRangeWith(pos - 1, pos + selectedNode.nodeSize + 1, blockCard.createChecked(selectedNode.attrs, undefined, selectedNode.marks));
        if (dispatch) {
            dispatch(tr_1.scrollIntoView());
        }
        return true;
    }
    var tr = state.tr.setNodeMarkup(pos, appearance === 'inline' ? inlineCard : blockCard, selectedNode.attrs, selectedNode.marks);
    if (dispatch) {
        dispatch(tr.scrollIntoView());
    }
    return true;
}; };
//# sourceMappingURL=doc.js.map

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isMediaSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canInsertMedia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createExternalMediaNode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);

var isMediaSelected = function (state) {
    var media = state.schema.nodes.media;
    return (state.selection instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"] &&
        state.selection.node.type === media);
};
var canInsertMedia = function (state) {
    var mediaSingle = state.schema.nodes.mediaSingle;
    var $to = state.selection.$to;
    if (mediaSingle) {
        for (var d = $to.depth; d >= 0; d--) {
            var index = $to.index(d);
            if ($to.node(d).canReplaceWith(index, index, mediaSingle)) {
                return true;
            }
        }
    }
    return false;
};
var createExternalMediaNode = function (url, schema) {
    var _a = schema.nodes, media = _a.media, mediaSingle = _a.mediaSingle;
    if (!media || !mediaSingle) {
        return null;
    }
    var mediaNode = media.createChecked({
        type: 'external',
        url: url,
    });
    return mediaSingle.createChecked({}, mediaNode);
};
//# sourceMappingURL=utils.js.map

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dismissCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_find_query_mark__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__ = __webpack_require__(107);



var dismissCommand = function () { return function (state, dispatch) {
    var queryMark = Object(__WEBPACK_IMPORTED_MODULE_0__utils_find_query_mark__["a" /* findTypeAheadQuery */])(state);
    if (queryMark === null) {
        return false;
    }
    var start = queryMark.start, end = queryMark.end;
    var schema = state.schema;
    var markType = schema.marks.typeAheadQuery;
    if (start === -1) {
        return false;
    }
    __WEBPACK_IMPORTED_MODULE_1__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.typeahead.dismiss');
    var typeAheadHandler = __WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["d" /* pluginKey */].getState(state).typeAheadHandler;
    if (typeAheadHandler && typeAheadHandler.dismiss) {
        typeAheadHandler.dismiss(state);
    }
    if (dispatch) {
        dispatch(state.tr.removeMark(start, end, markType).removeStoredMark(markType));
    }
    return true;
}; };
//# sourceMappingURL=dismiss.js.map

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findQueryMark */
/* harmony export (immutable) */ __webpack_exports__["a"] = findTypeAheadQuery;
function findQueryMark(mark, doc, from, to) {
    var queryMark = { start: -1, end: -1 };
    doc.nodesBetween(from, to, function (node, pos) {
        if (queryMark.start === -1 && mark.isInSet(node.marks)) {
            queryMark = {
                start: pos,
                end: pos + node.textContent.length,
            };
        }
    });
    return queryMark;
}
function findTypeAheadQuery(state) {
    var doc = state.doc, schema = state.schema;
    var typeAheadQuery = schema.marks.typeAheadQuery;
    var _a = state.selection, from = _a.from, to = _a.to;
    return findQueryMark(typeAheadQuery, doc, from - 1, to);
}
//# sourceMappingURL=find-query-mark.js.map

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = themed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTheme__ = __webpack_require__(852);
/* eslint-disable prefer-rest-params */


function themedVariants(variantProp, variants) {
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);

    if (props && props[variantProp] && variants) {
      var modes = variants[props[variantProp]];

      if (modes) {
        return modes[theme.mode];
      }
    }

    return '';
  };
}

function themed(modesOrVariant, variantModes) {
  if (typeof modesOrVariant === 'string') {
    return themedVariants(modesOrVariant, variantModes);
  }

  var modes = modesOrVariant;
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    return modes[theme.mode];
  };
}

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createTheme__ = __webpack_require__(460);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils_createTheme__["a" /* createTheme */])(function () {
  return {
    mode: 'light'
  };
}));

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


function createTheme(defaultThemeFn) {
  var emptyThemeFn = function emptyThemeFn(tokens, props) {
    return tokens(props);
  };

  var ThemeContext = Object(__WEBPACK_IMPORTED_MODULE_1_react__["createContext"])(defaultThemeFn);

  function Consumer(props) {
    var children = props.children,
        themeProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(props, ["children"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ThemeContext.Consumer, null, function (theme) {
      var themeFn = theme || emptyThemeFn;
      return props.children(themeFn(themeProps));
    });
  }

  function Provider(props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ThemeContext.Consumer, null, function (themeFn) {
      var valueFn = props.value || emptyThemeFn;

      var mixedFn = function mixedFn(themeProps) {
        return valueFn(themeFn, themeProps);
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ThemeContext.Provider, {
        value: mixedFn
      }, props.children);
    });
  }

  return {
    Consumer: Consumer,
    Provider: Provider
  };
}

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardActionButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_media_ui__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(1354);
/* tslint:disable:variable-name */





var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* Root */])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  position: relative;\n  line-height: 0;\n"], ["\n  display: flex;\n  position: relative;\n  line-height: 0;\n"])));
var CardActionButton = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", " ", " ", " color: ", ";\n\n  &:hover {\n    cursor: pointer;\n    background-color: rgba(9, 30, 66, 0.06);\n  }\n"], ["\n  ", " ", " ", " color: ", ";\n\n  &:hover {\n    cursor: pointer;\n    background-color: rgba(9, 30, 66, 0.06);\n  }\n"])), __WEBPACK_IMPORTED_MODULE_3__atlaskit_media_ui__["q" /* center */], __WEBPACK_IMPORTED_MODULE_3__atlaskit_media_ui__["p" /* borderRadius */], Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_media_ui__["y" /* size */])(26), __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorN500"]);
var templateObject_1, templateObject_2;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorErrorIcon = function EditorErrorIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M13.485 11.929l2.122-2.121a1 1 0 0 0-1.415-1.415l-2.12 2.122L9.95 8.393a1 1 0 0 0-1.414 1.415l2.12 2.12-2.12 2.122a1 1 0 0 0 1.414 1.414l2.121-2.12 2.121 2.12a1 1 0 1 0 1.415-1.414l-2.122-2.121zM12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorErrorIcon.displayName = 'EditorErrorIcon';
var _default = EditorErrorIcon;
exports.default = _default;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorNoteIcon = function EditorNoteIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M8 4h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm1.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-5zm0 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-3z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorNoteIcon.displayName = 'EditorNoteIcon';
var _default = EditorNoteIcon;
exports.default = _default;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



module.exports = __webpack_require__(2643);


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/



/**
 * new Ruler()
 **/
function Ruler() {
  // List of added rules. Each element is:
  //
  // {
  //   name: XXX,
  //   enabled: Boolean,
  //   fn: Function(),
  //   alt: [ name2, name3 ]
  // }
  //
  this.__rules__ = [];

  // Cached rule chains.
  //
  // First level - chain name, '' for default.
  // Second level - diginal anchor for fast filtering by charcodes.
  //
  this.__cache__ = null;
}

////////////////////////////////////////////////////////////////////////////////
// Helper methods, should not be used directly


// Find rule index by name
//
Ruler.prototype.__find__ = function (name) {
  for (var i = 0; i < this.__rules__.length; i++) {
    if (this.__rules__[i].name === name) {
      return i;
    }
  }
  return -1;
};


// Build rules lookup cache
//
Ruler.prototype.__compile__ = function () {
  var self = this;
  var chains = [ '' ];

  // collect unique names
  self.__rules__.forEach(function (rule) {
    if (!rule.enabled) { return; }

    rule.alt.forEach(function (altName) {
      if (chains.indexOf(altName) < 0) {
        chains.push(altName);
      }
    });
  });

  self.__cache__ = {};

  chains.forEach(function (chain) {
    self.__cache__[chain] = [];
    self.__rules__.forEach(function (rule) {
      if (!rule.enabled) { return; }

      if (chain && rule.alt.indexOf(chain) < 0) { return; }

      self.__cache__[chain].push(rule.fn);
    });
  });
};


/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler.prototype.at = function (name, fn, options) {
  var index = this.__find__(name);
  var opt = options || {};

  if (index === -1) { throw new Error('Parser rule not found: ' + name); }

  this.__rules__[index].fn = fn;
  this.__rules__[index].alt = opt.alt || [];
  this.__cache__ = null;
};


/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler.prototype.before = function (beforeName, ruleName, fn, options) {
  var index = this.__find__(beforeName);
  var opt = options || {};

  if (index === -1) { throw new Error('Parser rule not found: ' + beforeName); }

  this.__rules__.splice(index, 0, {
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};


/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler.prototype.after = function (afterName, ruleName, fn, options) {
  var index = this.__find__(afterName);
  var opt = options || {};

  if (index === -1) { throw new Error('Parser rule not found: ' + afterName); }

  this.__rules__.splice(index + 1, 0, {
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};

/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler.prototype.push = function (ruleName, fn, options) {
  var opt = options || {};

  this.__rules__.push({
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};


/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/
Ruler.prototype.enable = function (list, ignoreInvalid) {
  if (!Array.isArray(list)) { list = [ list ]; }

  var result = [];

  // Search by name and enable
  list.forEach(function (name) {
    var idx = this.__find__(name);

    if (idx < 0) {
      if (ignoreInvalid) { return; }
      throw new Error('Rules manager: invalid rule name ' + name);
    }
    this.__rules__[idx].enabled = true;
    result.push(name);
  }, this);

  this.__cache__ = null;
  return result;
};


/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/
Ruler.prototype.enableOnly = function (list, ignoreInvalid) {
  if (!Array.isArray(list)) { list = [ list ]; }

  this.__rules__.forEach(function (rule) { rule.enabled = false; });

  this.enable(list, ignoreInvalid);
};


/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/
Ruler.prototype.disable = function (list, ignoreInvalid) {
  if (!Array.isArray(list)) { list = [ list ]; }

  var result = [];

  // Search by name and disable
  list.forEach(function (name) {
    var idx = this.__find__(name);

    if (idx < 0) {
      if (ignoreInvalid) { return; }
      throw new Error('Rules manager: invalid rule name ' + name);
    }
    this.__rules__[idx].enabled = false;
    result.push(name);
  }, this);

  this.__cache__ = null;
  return result;
};


/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/
Ruler.prototype.getRules = function (chainName) {
  if (this.__cache__ === null) {
    this.__compile__();
  }

  // Chain can be empty, if rules disabled. But we still have to return Array.
  return this.__cache__[chainName] || [];
};

module.exports = Ruler;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Token class




/**
 * class Token
 **/

/**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/
function Token(type, tag, nesting) {
  /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/
  this.type     = type;

  /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/
  this.tag      = tag;

  /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/
  this.attrs    = null;

  /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/
  this.map      = null;

  /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/
  this.nesting  = nesting;

  /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/
  this.level    = 0;

  /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/
  this.children = null;

  /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/
  this.content  = '';

  /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/
  this.markup   = '';

  /**
   * Token#info -> String
   *
   * fence infostring
   **/
  this.info     = '';

  /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/
  this.meta     = null;

  /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/
  this.block    = false;

  /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/
  this.hidden   = false;
}


/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/
Token.prototype.attrIndex = function attrIndex(name) {
  var attrs, i, len;

  if (!this.attrs) { return -1; }

  attrs = this.attrs;

  for (i = 0, len = attrs.length; i < len; i++) {
    if (attrs[i][0] === name) { return i; }
  }
  return -1;
};


/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/
Token.prototype.attrPush = function attrPush(attrData) {
  if (this.attrs) {
    this.attrs.push(attrData);
  } else {
    this.attrs = [ attrData ];
  }
};


/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/
Token.prototype.attrSet = function attrSet(name, value) {
  var idx = this.attrIndex(name),
      attrData = [ name, value ];

  if (idx < 0) {
    this.attrPush(attrData);
  } else {
    this.attrs[idx] = attrData;
  }
};


/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/
Token.prototype.attrGet = function attrGet(name) {
  var idx = this.attrIndex(name), value = null;
  if (idx >= 0) {
    value = this.attrs[idx][1];
  }
  return value;
};


/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/
Token.prototype.attrJoin = function attrJoin(name, value) {
  var idx = this.attrIndex(name);

  if (idx < 0) {
    this.attrPush([ name, value ]);
  } else {
    this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
  }
};


module.exports = Token;


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var ListWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].ol(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  list-style-type: none;\n  padding-left: 0;\n"], ["\n  list-style-type: none;\n  padding-left: 0;\n"])));
/* harmony default export */ __webpack_exports__["a"] = (ListWrapper);
var templateObject_1;
//# sourceMappingURL=ListWrapper.js.map

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);



var WithEditorActions = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WithEditorActions, _super);
    function WithEditorActions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onContextUpdate = function () {
            // Re-render actions when editorActions changes...
            _this.forceUpdate();
        };
        return _this;
    }
    WithEditorActions.prototype.componentDidMount = function () {
        this.context.editorActions._privateSubscribe(this.onContextUpdate);
    };
    WithEditorActions.prototype.componentWillUnmount = function () {
        this.context.editorActions._privateUnsubscribe(this.onContextUpdate);
    };
    WithEditorActions.prototype.render = function () {
        return this.props.render(this.context.editorActions);
    };
    WithEditorActions.contextTypes = {
        editorActions: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"].isRequired,
    };
    return WithEditorActions;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (WithEditorActions);
//# sourceMappingURL=index.js.map

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__);




var EditorActions = /** @class */ (function () {
    function EditorActions() {
        this.listeners = [];
    }
    EditorActions.from = function (view, eventDispatcher, transformer) {
        var editorActions = new EditorActions();
        editorActions._privateRegisterEditor(view, eventDispatcher, transformer);
        return editorActions;
    };
    // This method needs to be public for context based helper components.
    EditorActions.prototype._privateGetEditorView = function () {
        return this.editorView;
    };
    EditorActions.prototype._privateGetEventDispatcher = function () {
        return this.eventDispatcher;
    };
    // This method needs to be public for EditorContext component.
    EditorActions.prototype._privateRegisterEditor = function (editorView, eventDispatcher, contentTransformer) {
        this.contentTransformer = contentTransformer;
        this.eventDispatcher = eventDispatcher;
        if (!this.editorView && editorView) {
            this.editorView = editorView;
            this.listeners.forEach(function (cb) { return cb(editorView, eventDispatcher); });
        }
        else if (this.editorView !== editorView) {
            throw new Error("Editor has already been registered! It's not allowed to re-register editor with the new Editor instance.");
        }
    };
    // This method needs to be public for EditorContext component.
    EditorActions.prototype._privateUnregisterEditor = function () {
        this.editorView = undefined;
        this.contentTransformer = undefined;
        this.eventDispatcher = undefined;
    };
    EditorActions.prototype._privateSubscribe = function (cb) {
        // If editor is registered and somebody is trying to add a listener,
        // just call it first.
        if (this.editorView && this.eventDispatcher) {
            cb(this.editorView, this.eventDispatcher);
        }
        this.listeners.push(cb);
    };
    EditorActions.prototype._privateUnsubscribe = function (cb) {
        this.listeners = this.listeners.filter(function (c) { return c !== cb; });
    };
    EditorActions.prototype.focus = function () {
        if (!this.editorView || this.editorView.hasFocus()) {
            return false;
        }
        this.editorView.focus();
        this.editorView.dispatch(this.editorView.state.tr.scrollIntoView());
        return true;
    };
    EditorActions.prototype.blur = function () {
        if (!this.editorView || !this.editorView.hasFocus()) {
            return false;
        }
        this.editorView.dom.blur();
        return true;
    };
    EditorActions.prototype.clear = function () {
        if (!this.editorView) {
            return false;
        }
        var editorView = this.editorView;
        var state = editorView.state;
        var tr = editorView.state.tr
            .setSelection(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["TextSelection"].create(state.doc, 0, state.doc.nodeSize - 2))
            .deleteSelection();
        editorView.dispatch(tr);
        return true;
    };
    EditorActions.prototype.getValue = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
            var doc;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["o" /* getEditorValueWithMedia */])(this.editorView)];
                    case 1:
                        doc = _a.sent();
                        if (!doc) {
                            return [2 /*return*/];
                        }
                        if (this.contentTransformer) {
                            return [2 /*return*/, this.contentTransformer.encode(doc)];
                        }
                        return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["j" /* compose */])(__WEBPACK_IMPORTED_MODULE_2__utils__["F" /* removeQueryMarksFromJSON */], __WEBPACK_IMPORTED_MODULE_2__utils__["J" /* toJSON */])(doc)];
                }
            });
        });
    };
    EditorActions.prototype.replaceDocument = function (rawValue, shouldScrollToBottom) {
        if (shouldScrollToBottom === void 0) { shouldScrollToBottom = true; }
        if (!this.editorView || rawValue === undefined || rawValue === null) {
            return false;
        }
        var state = this.editorView.state;
        var schema = state.schema;
        var transformedDoc = this.contentTransformer
            ? this.contentTransformer.parse(rawValue).toJSON()
            : rawValue;
        var content = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["E" /* processRawValue */])(schema, transformedDoc);
        if (!content) {
            return false;
        }
        // In case of replacing a whole document, we only need a content of a top level node e.g. document.
        var tr = state.tr.replaceWith(0, state.doc.nodeSize - 2, content.content);
        if (shouldScrollToBottom) {
            tr = tr.scrollIntoView();
        }
        this.editorView.dispatch(tr);
        return true;
    };
    EditorActions.prototype.replaceSelection = function (rawValue) {
        if (!this.editorView) {
            return false;
        }
        var state = this.editorView.state;
        if (!rawValue) {
            var tr = state.tr.deleteSelection().scrollIntoView();
            this.editorView.dispatch(tr);
            return true;
        }
        var schema = state.schema;
        var content = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["E" /* processRawValue */])(schema, rawValue);
        if (!content) {
            return false;
        }
        // try to find a place in the document where to insert a node if its not allowed at the cursor position by schema
        this.editorView.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["safeInsert"])(content)(state.tr).scrollIntoView());
        return true;
    };
    EditorActions.prototype.appendText = function (text) {
        if (!this.editorView || !text) {
            return false;
        }
        var state = this.editorView.state;
        var lastChild = state.doc.lastChild;
        if (lastChild && lastChild.type !== state.schema.nodes.paragraph) {
            return false;
        }
        var tr = state.tr.insertText(text).scrollIntoView();
        this.editorView.dispatch(tr);
        return true;
    };
    EditorActions.prototype.insertFileFromDataUrl = function (url, filename) {
        if (!this.editorView) {
            return false;
        }
        Object(__WEBPACK_IMPORTED_MODULE_2__utils__["q" /* insertFileFromDataUrl */])(this.editorView.state, url, filename);
        return true;
    };
    return EditorActions;
}());
/* harmony default export */ __webpack_exports__["a"] = (EditorActions);
//# sourceMappingURL=index.js.map

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(469);




var EditorContext = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EditorContext, _super);
    function EditorContext(props) {
        var _this = _super.call(this, props) || this;
        _this.editorActions = props.editorActions || new __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]();
        return _this;
    }
    EditorContext.prototype.getChildContext = function () {
        return {
            editorActions: this.editorActions,
        };
    };
    EditorContext.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };
    EditorContext.childContextTypes = {
        editorActions: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    };
    return EditorContext;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (EditorContext);
//# sourceMappingURL=index.js.map

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return inlines; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emoji__ = __webpack_require__(2835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hard_break__ = __webpack_require__(2837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mention__ = __webpack_require__(2838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__text__ = __webpack_require__(2839);




var inlinesEncoderMapping = {
    emoji: __WEBPACK_IMPORTED_MODULE_0__emoji__["a" /* emoji */],
    hardBreak: __WEBPACK_IMPORTED_MODULE_1__hard_break__["a" /* hardBreak */],
    mention: __WEBPACK_IMPORTED_MODULE_2__mention__["a" /* mention */],
    text: __WEBPACK_IMPORTED_MODULE_3__text__["a" /* text */],
};
var inlines = function (node, parent) {
    return inlinesEncoderMapping[node.type.name](node, parent);
};
//# sourceMappingURL=inlines.js.map

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = linkFormat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__link_resolver__ = __webpack_require__(2860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__link_parser__ = __webpack_require__(2865);


// [http://www.example.com] and [Example|http://www.example.com]
var LINK_FORMAT_REGEXP = /^\[([^\[\]\n]+)]/;
function linkFormat(input, position, schema, tokenErrCallback) {
    var match = input.substring(position).match(LINK_FORMAT_REGEXP);
    if (!match) {
        return fallback();
    }
    var content = Object(__WEBPACK_IMPORTED_MODULE_1__link_parser__["a" /* parseContentLink */])(match[1]);
    return Object(__WEBPACK_IMPORTED_MODULE_0__link_resolver__["a" /* resolveLink */])(content, schema, tokenErrCallback);
}
function fallback() {
    return {
        type: 'text',
        text: '[',
        length: 1,
    };
}
//# sourceMappingURL=link-format.js.map

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = title;
/**
 * This will return ADF to replace the titles in some macro
 * For example
 * {panel:title}aaa{panel}
 */
function title(text, schema) {
    var mark = schema.marks.strong.create();
    var title = schema.text(text, [mark]);
    return schema.nodes.paragraph.createChecked({}, [title]);
}
//# sourceMappingURL=title.js.map

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__(2896);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__color__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__macro__ = __webpack_require__(2897);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validator__ = __webpack_require__(2898);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__browser__ = __webpack_require__(2899);
/* unused harmony reexport browser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_reporter__ = __webpack_require__(2900);
/* unused harmony reexport ErrorReporter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__date__ = __webpack_require__(2901);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imageLoader__ = __webpack_require__(2902);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__calc_breakout_width__ = __webpack_require__(2903);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__calc_breakout_width__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__calc_breakout_width__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__traversor__ = __webpack_require__(2961);
/* unused harmony reexport ADFTraversor */









//# sourceMappingURL=index.js.map

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


/**
 * A base class for components that don't want to start rendering
 * until the EmojiProvider is resolved.
 * Notes: super.componentDidMount and super.componentWillUnmount will need to be
 * called explicitly if they are overridden on the child class.
 */
var LoadingEmojiComponent = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](LoadingEmojiComponent, _super);
    function LoadingEmojiComponent(props, state) {
        var _this = _super.call(this, props) || this;
        _this.loaded = function (state) { return !!state.asyncLoadedComponent && !!state.loadedEmojiProvider; };
        _this.state = state;
        return _this;
    }
    LoadingEmojiComponent.prototype.componentWillMount = function () {
        // using componentWillMount instead of componentDidMount to avoid needless
        // rerendering if emojiProvider resolves immediately.
        this.loadEmojiProvider(this.props.emojiProvider);
    };
    LoadingEmojiComponent.prototype.componentDidMount = function () {
        // check for the module has not yet been loaded
        // state.asyncLoadedComponent should be initialised
        // with static field to prevent unnecessary rerender
        if (!this.state.asyncLoadedComponent) {
            this.asyncLoadComponent();
        }
    };
    LoadingEmojiComponent.prototype.componentWillReceiveProps = function (nextProps) {
        this.loadEmojiProvider(nextProps.emojiProvider);
    };
    LoadingEmojiComponent.prototype.componentWillUnmount = function () {
        this.isUnmounted = true;
    };
    LoadingEmojiComponent.prototype.loadEmojiProvider = function (futureEmojiProvider) {
        var _this = this;
        futureEmojiProvider
            .then(function (loadedEmojiProvider) {
            if (!_this.isUnmounted) {
                _this.setState({
                    loadedEmojiProvider: loadedEmojiProvider,
                });
            }
        })
            .catch(function (err) {
            if (!_this.isUnmounted) {
                _this.setState({
                    loadedEmojiProvider: undefined,
                });
            }
        });
    };
    LoadingEmojiComponent.prototype.setAsyncState = function (asyncLoadedComponent) {
        if (!this.isUnmounted) {
            this.setState({ asyncLoadedComponent: asyncLoadedComponent });
        }
    };
    LoadingEmojiComponent.prototype.renderLoading = function () {
        return null;
    };
    LoadingEmojiComponent.prototype.render = function () {
        if (this.loaded(this.state)) {
            var _a = this.state, loadedEmojiProvider = _a.loadedEmojiProvider, asyncLoadedComponent = _a.asyncLoadedComponent;
            return this.renderLoaded(loadedEmojiProvider, asyncLoadedComponent);
        }
        return this.renderLoading();
    };
    return LoadingEmojiComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (LoadingEmojiComponent);
//# sourceMappingURL=LoadingEmojiComponent.js.map

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withProviders__ = __webpack_require__(2933);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__withProviders__["a"]; });

var ProviderFactory = /** @class */ (function () {
    function ProviderFactory() {
        this.providers = new Map();
        this.subscribers = new Map();
    }
    ProviderFactory.create = function (providers) {
        var providerFactory = new ProviderFactory();
        Object.keys(providers).forEach(function (name) {
            providerFactory.setProvider(name, providers[name]);
        });
        return providerFactory;
    };
    ProviderFactory.prototype.destroy = function () {
        this.providers.clear();
        this.subscribers.clear();
    };
    ProviderFactory.prototype.isEmpty = function () {
        return !this.providers.size && !this.subscribers.size;
    };
    ProviderFactory.prototype.setProvider = function (name, provider) {
        // Do not trigger notifyUpdate if provider is the same.
        if (provider && this.providers.get(name) === provider) {
            return;
        }
        if (provider) {
            this.providers.set(name, provider);
        }
        else {
            this.providers.delete(name);
        }
        this.notifyUpdated(name, provider);
    };
    ProviderFactory.prototype.removeProvider = function (name) {
        this.providers.delete(name);
        this.notifyUpdated(name);
    };
    ProviderFactory.prototype.subscribe = function (name, handler) {
        var handlers = this.subscribers.get(name) || [];
        handlers.push(handler);
        this.subscribers.set(name, handlers);
        var provider = this.providers.get(name);
        if (provider) {
            handler(name, provider);
        }
    };
    ProviderFactory.prototype.unsubscribe = function (name, handler) {
        var handlers = this.subscribers.get(name);
        if (!handlers) {
            return;
        }
        var index = handlers.indexOf(handler);
        if (index !== -1) {
            handlers.splice(index, 1);
        }
        if (handlers.length === 0) {
            this.subscribers.delete(name);
        }
        else {
            this.subscribers.set(name, handlers);
        }
    };
    ProviderFactory.prototype.unsubscribeAll = function (name) {
        var handlers = this.subscribers.get(name);
        if (!handlers) {
            return;
        }
        this.subscribers.delete(name);
    };
    ProviderFactory.prototype.hasProvider = function (name) {
        return this.providers.has(name);
    };
    ProviderFactory.prototype.notifyUpdated = function (name, provider) {
        var handlers = this.subscribers.get(name);
        if (!handlers) {
            return;
        }
        handlers.forEach(function (handler) {
            handler(name, provider);
        });
    };
    return ProviderFactory;
}());
/* harmony default export */ __webpack_exports__["b"] = (ProviderFactory);
//# sourceMappingURL=index.js.map

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export noPropFormatter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NoAccessWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NoAccessLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DefaultHeadline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultAdvisedAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LoginAgain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DifferentText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_i18n__ = __webpack_require__(2943);




var noPropFormatter = function (messageDescriptor) { return function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["FormattedMessage"], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, props, messageDescriptor))); }; };
var NoAccessWarning = function (_a) {
    var name = _a.name, props = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["name"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["FormattedMessage"], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, props, { values: { name: name } }, __WEBPACK_IMPORTED_MODULE_3__components_i18n__["a" /* messages */].noAccessWarning)));
};
var NoAccessLabel = noPropFormatter(__WEBPACK_IMPORTED_MODULE_3__components_i18n__["a" /* messages */].noAccessLabel);
var DefaultHeadline = noPropFormatter(__WEBPACK_IMPORTED_MODULE_3__components_i18n__["a" /* messages */].defaultHeadline);
var DefaultAdvisedAction = noPropFormatter(__WEBPACK_IMPORTED_MODULE_3__components_i18n__["a" /* messages */].defaultAdvisedAction);
var LoginAgain = noPropFormatter(__WEBPACK_IMPORTED_MODULE_3__components_i18n__["a" /* messages */].loginAgain);
var DifferentText = noPropFormatter(__WEBPACK_IMPORTED_MODULE_3__components_i18n__["a" /* messages */].differentText);
//# sourceMappingURL=i18n.js.map

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return noDialogContainerBorderColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return noDialogContainerBorderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return noDialogContainerBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return scrollableMaxHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mentionListWidth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);

var noDialogContainerBorderColor = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N40; // This has not been confirmed by the ADG yet
var noDialogContainerBorderRadius = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["borderRadius"])() + "px";
var noDialogContainerBoxShadow = '0 4px 8px -2px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)'; // Copied from droplist style
var scrollableMaxHeight = '264px';
var mentionListWidth = '340px';
//# sourceMappingURL=shared-styles.js.map

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__(2969);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__color__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__macro__ = __webpack_require__(2970);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validator__ = __webpack_require__(2971);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__validator__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__validator__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__validator__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_2__validator__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__browser__ = __webpack_require__(2972);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__browser__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_reporter__ = __webpack_require__(2973);
/* unused harmony reexport ErrorReporter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__date__ = __webpack_require__(2974);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__date__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_5__date__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_5__date__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imageLoader__ = __webpack_require__(2975);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_6__imageLoader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__calc_breakout_width__ = __webpack_require__(2976);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__calc_breakout_width__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__calc_breakout_width__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__traversor__ = __webpack_require__(3031);
/* unused harmony reexport ADFTraversor */









//# sourceMappingURL=index.js.map

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


/**
 * A base class for components that don't want to start rendering
 * until the EmojiProvider is resolved.
 * Notes: super.componentDidMount and super.componentWillUnmount will need to be
 * called explicitly if they are overridden on the child class.
 */
var LoadingEmojiComponent = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](LoadingEmojiComponent, _super);
    function LoadingEmojiComponent(props, state) {
        var _this = _super.call(this, props) || this;
        _this.loaded = function (state) { return !!state.asyncLoadedComponent && !!state.loadedEmojiProvider; };
        _this.state = state;
        return _this;
    }
    LoadingEmojiComponent.prototype.componentWillMount = function () {
        // using componentWillMount instead of componentDidMount to avoid needless
        // rerendering if emojiProvider resolves immediately.
        this.loadEmojiProvider(this.props.emojiProvider);
    };
    LoadingEmojiComponent.prototype.componentDidMount = function () {
        // check for the module has not yet been loaded
        // state.asyncLoadedComponent should be initialised
        // with static field to prevent unnecessary rerender
        if (!this.state.asyncLoadedComponent) {
            this.asyncLoadComponent();
        }
    };
    LoadingEmojiComponent.prototype.componentWillReceiveProps = function (nextProps) {
        this.loadEmojiProvider(nextProps.emojiProvider);
    };
    LoadingEmojiComponent.prototype.componentWillUnmount = function () {
        this.isUnmounted = true;
    };
    LoadingEmojiComponent.prototype.loadEmojiProvider = function (futureEmojiProvider) {
        var _this = this;
        futureEmojiProvider
            .then(function (loadedEmojiProvider) {
            if (!_this.isUnmounted) {
                _this.setState({
                    loadedEmojiProvider: loadedEmojiProvider,
                });
            }
        })
            .catch(function (err) {
            if (!_this.isUnmounted) {
                _this.setState({
                    loadedEmojiProvider: undefined,
                });
            }
        });
    };
    LoadingEmojiComponent.prototype.setAsyncState = function (asyncLoadedComponent) {
        if (!this.isUnmounted) {
            this.setState({ asyncLoadedComponent: asyncLoadedComponent });
        }
    };
    LoadingEmojiComponent.prototype.renderLoading = function () {
        return null;
    };
    LoadingEmojiComponent.prototype.render = function () {
        if (this.loaded(this.state)) {
            var _a = this.state, loadedEmojiProvider = _a.loadedEmojiProvider, asyncLoadedComponent = _a.asyncLoadedComponent;
            return this.renderLoaded(loadedEmojiProvider, asyncLoadedComponent);
        }
        return this.renderLoading();
    };
    return LoadingEmojiComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (LoadingEmojiComponent);
//# sourceMappingURL=LoadingEmojiComponent.js.map

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withProviders__ = __webpack_require__(3006);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__withProviders__["a"]; });

var ProviderFactory = /** @class */ (function () {
    function ProviderFactory() {
        this.providers = new Map();
        this.subscribers = new Map();
    }
    ProviderFactory.create = function (providers) {
        var providerFactory = new ProviderFactory();
        Object.keys(providers).forEach(function (name) {
            providerFactory.setProvider(name, providers[name]);
        });
        return providerFactory;
    };
    ProviderFactory.prototype.destroy = function () {
        this.providers.clear();
        this.subscribers.clear();
    };
    ProviderFactory.prototype.isEmpty = function () {
        return !this.providers.size && !this.subscribers.size;
    };
    ProviderFactory.prototype.setProvider = function (name, provider) {
        // Do not trigger notifyUpdate if provider is the same.
        if (this.providers.get(name) === provider) {
            return;
        }
        if (provider) {
            this.providers.set(name, provider);
        }
        else {
            this.providers.delete(name);
        }
        this.notifyUpdated(name, provider);
    };
    ProviderFactory.prototype.removeProvider = function (name) {
        this.providers.delete(name);
        this.notifyUpdated(name);
    };
    ProviderFactory.prototype.subscribe = function (name, handler) {
        var handlers = this.subscribers.get(name) || [];
        handlers.push(handler);
        this.subscribers.set(name, handlers);
        var provider = this.providers.get(name);
        if (provider) {
            handler(name, provider);
        }
    };
    ProviderFactory.prototype.unsubscribe = function (name, handler) {
        var handlers = this.subscribers.get(name);
        if (!handlers) {
            return;
        }
        var index = handlers.indexOf(handler);
        if (index !== -1) {
            handlers.splice(index, 1);
        }
        if (handlers.length === 0) {
            this.subscribers.delete(name);
        }
        else {
            this.subscribers.set(name, handlers);
        }
    };
    ProviderFactory.prototype.unsubscribeAll = function (name) {
        var handlers = this.subscribers.get(name);
        if (!handlers) {
            return;
        }
        this.subscribers.delete(name);
    };
    ProviderFactory.prototype.hasProvider = function (name) {
        return this.providers.has(name);
    };
    ProviderFactory.prototype.notifyUpdated = function (name, provider) {
        var handlers = this.subscribers.get(name);
        if (!handlers) {
            return;
        }
        handlers.forEach(function (handler) {
            handler(name, provider);
        });
    };
    return ProviderFactory;
}());
/* harmony default export */ __webpack_exports__["b"] = (ProviderFactory);
//# sourceMappingURL=index.js.map

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export noPropFormatter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NoAccessWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NoAccessLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DefaultHeadline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultAdvisedAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LoginAgain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DifferentText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_i18n__ = __webpack_require__(3013);




var noPropFormatter = function (messageDescriptor) { return function (props) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["FormattedMessage"], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, props, messageDescriptor))); }; };
var NoAccessWarning = function (_a) {
    var name = _a.name, props = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["name"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["FormattedMessage"], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, props, { values: { name: name } }, __WEBPACK_IMPORTED_MODULE_3__components_i18n__["a" /* messages */].noAccessWarning)));
};
var NoAccessLabel = noPropFormatter(__WEBPACK_IMPORTED_MODULE_3__components_i18n__["a" /* messages */].noAccessLabel);
var DefaultHeadline = noPropFormatter(__WEBPACK_IMPORTED_MODULE_3__components_i18n__["a" /* messages */].defaultHeadline);
var DefaultAdvisedAction = noPropFormatter(__WEBPACK_IMPORTED_MODULE_3__components_i18n__["a" /* messages */].defaultAdvisedAction);
var LoginAgain = noPropFormatter(__WEBPACK_IMPORTED_MODULE_3__components_i18n__["a" /* messages */].loginAgain);
var DifferentText = noPropFormatter(__WEBPACK_IMPORTED_MODULE_3__components_i18n__["a" /* messages */].differentText);
//# sourceMappingURL=i18n.js.map

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return noDialogContainerBorderColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return noDialogContainerBorderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return noDialogContainerBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return scrollableMaxHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mentionListWidth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);

var noDialogContainerBorderColor = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N40; // This has not been confirmed by the ADG yet
var noDialogContainerBorderRadius = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["borderRadius"])() + "px";
var noDialogContainerBoxShadow = '0 4px 8px -2px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)'; // Copied from droplist style
var scrollableMaxHeight = '264px';
var mentionListWidth = '340px';
//# sourceMappingURL=shared-styles.js.map

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var high = __webpack_require__(3039)
var fault = __webpack_require__(3040)

/* The lowlight interface, which has to be compatible
 * with highlight.js, as this object is passed to
 * highlight.js syntaxes. */

function High() {}

High.prototype = high

/* Expose. */
var low = new High() // Ha!

module.exports = low

low.highlight = highlight
low.highlightAuto = autoHighlight
low.registerLanguage = registerLanguage
low.getLanguage = getLanguage

var inherit = high.inherit
var own = {}.hasOwnProperty
var concat = [].concat

var defaultPrefix = 'hljs-'
var keyInsensitive = 'case_insensitive'
var keyCachedVariants = 'cached_variants'
var space = ' '
var pipe = '|'

var T_ELEMENT = 'element'
var T_TEXT = 'text'
var T_SPAN = 'span'

/* Maps of syntaxes. */
var languageNames = []
var languages = {}
var aliases = {}

/* Highlighting with language detection.  Accepts a string
 * with the code to highlight.  Returns an object with the
 * following properties:
 *
 * - language (detected language)
 * - relevance (int)
 * - value (a HAST tree with highlighting markup)
 * - secondBest (object with the same structure for
 *   second-best heuristically detected language, may
 *   be absent) */
function autoHighlight(value, options) {
  var settings = options || {}
  var subset = settings.subset || languageNames
  var prefix = settings.prefix
  var length = subset.length
  var index = -1
  var result
  var secondBest
  var current
  var name

  if (prefix === null || prefix === undefined) {
    prefix = defaultPrefix
  }

  if (typeof value !== 'string') {
    throw fault('Expected `string` for value, got `%s`', value)
  }

  secondBest = normalize({})
  result = normalize({})

  while (++index < length) {
    name = subset[index]

    if (!getLanguage(name)) {
      continue
    }

    current = normalize(coreHighlight(name, value, false, prefix))

    current.language = name

    if (current.relevance > secondBest.relevance) {
      secondBest = current
    }

    if (current.relevance > result.relevance) {
      secondBest = result
      result = current
    }
  }

  if (secondBest.language) {
    result.secondBest = secondBest
  }

  return result
}

/* Highlighting `value` in the language `language`. */
function highlight(language, value, options) {
  var settings = options || {}
  var prefix = settings.prefix

  if (prefix === null || prefix === undefined) {
    prefix = defaultPrefix
  }

  return normalize(coreHighlight(language, value, true, prefix))
}

/* Register a language. */
function registerLanguage(name, syntax) {
  var lang = syntax(low)
  var values = lang.aliases
  var length = values && values.length
  var index = -1

  languages[name] = lang

  languageNames.push(name)

  while (++index < length) {
    aliases[values[index]] = name
  }
}

/* Core highlighting function.  Accepts a language name, or
 * an alias, and a string with the code to highlight.
 * Returns an object with the following properties: */
function coreHighlight(name, value, ignore, prefix, continuation) {
  var continuations = {}
  var stack = []
  var modeBuffer = ''
  var relevance = 0
  var language
  var top
  var current
  var currentChildren
  var offset
  var count
  var match
  var children

  if (typeof name !== 'string') {
    throw fault('Expected `string` for name, got `%s`', name)
  }

  if (typeof value !== 'string') {
    throw fault('Expected `string` for value, got `%s`', value)
  }

  language = getLanguage(name)
  top = continuation || language
  children = []

  current = top
  currentChildren = children

  if (!language) {
    throw fault('Unknown language: `%s` is not registered', name)
  }

  compileLanguage(language)

  try {
    top.terminators.lastIndex = 0
    offset = 0
    match = top.terminators.exec(value)

    while (match) {
      count = processLexeme(value.substring(offset, match.index), match[0])
      offset = match.index + count
      top.terminators.lastIndex = offset
      match = top.terminators.exec(value)
    }

    processLexeme(value.substr(offset))
    current = top

    while (current.parent) {
      if (current.className) {
        pop()
      }

      current = current.parent
    }

    return {
      relevance: relevance,
      value: currentChildren,
      language: name,
      top: top
    }
  } catch (err) {
    /* istanbul ignore if - Catch-all  */
    if (err.message.indexOf('Illegal') === -1) {
      throw err
    }

    return {relevance: 0, value: addText(value, [])}
  }

  /* Process a lexeme.  Returns next position. */
  function processLexeme(buffer, lexeme) {
    var newMode
    var endMode
    var origin

    modeBuffer += buffer

    if (lexeme === undefined) {
      addSiblings(processBuffer(), currentChildren)

      return 0
    }

    newMode = subMode(lexeme, top)

    if (newMode) {
      addSiblings(processBuffer(), currentChildren)

      startNewMode(newMode, lexeme)

      return newMode.returnBegin ? 0 : lexeme.length
    }

    endMode = endOfMode(top, lexeme)

    if (endMode) {
      origin = top

      if (!(origin.returnEnd || origin.excludeEnd)) {
        modeBuffer += lexeme
      }

      addSiblings(processBuffer(), currentChildren)

      /* Close open modes. */
      do {
        if (top.className) {
          pop()
        }

        relevance += top.relevance
        top = top.parent
      } while (top !== endMode.parent)

      if (origin.excludeEnd) {
        addText(lexeme, currentChildren)
      }

      modeBuffer = ''

      if (endMode.starts) {
        startNewMode(endMode.starts, '')
      }

      return origin.returnEnd ? 0 : lexeme.length
    }

    if (isIllegal(lexeme, top)) {
      throw fault(
        'Illegal lexeme "%s" for mode "%s"',
        lexeme,
        top.className || '<unnamed>'
      )
    }

    /* Parser should not reach this point as all
     * types of lexemes should be caught earlier,
     * but if it does due to some bug make sure it
     * advances at least one character forward to
     * prevent infinite looping. */
    modeBuffer += lexeme

    return lexeme.length || /* istanbul ignore next */ 1
  }

  /* Start a new mode with a `lexeme` to process. */
  function startNewMode(mode, lexeme) {
    var node

    if (mode.className) {
      node = build(mode.className, [])
    }

    if (mode.returnBegin) {
      modeBuffer = ''
    } else if (mode.excludeBegin) {
      addText(lexeme, currentChildren)

      modeBuffer = ''
    } else {
      modeBuffer = lexeme
    }

    /* Enter a new mode. */
    if (node) {
      currentChildren.push(node)
      stack.push(currentChildren)
      currentChildren = node.children
    }

    top = Object.create(mode, {parent: {value: top}})
  }

  /* Process the buffer. */
  function processBuffer() {
    var result = top.subLanguage ? processSubLanguage() : processKeywords()
    modeBuffer = ''
    return result
  }

  /* Process a sublanguage (returns a list of nodes). */
  function processSubLanguage() {
    var explicit = typeof top.subLanguage === 'string'
    var subvalue

    /* istanbul ignore if - support non-loaded sublanguages */
    if (explicit && !languages[top.subLanguage]) {
      return addText(modeBuffer, [])
    }

    if (explicit) {
      subvalue = coreHighlight(
        top.subLanguage,
        modeBuffer,
        true,
        prefix,
        continuations[top.subLanguage]
      )
    } else {
      subvalue = autoHighlight(modeBuffer, {
        subset: top.subLanguage.length ? top.subLanguage : undefined,
        prefix: prefix
      })
    }

    /* Counting embedded language score towards the
     * host language may be disabled with zeroing the
     * containing mode relevance.  Usecase in point is
     * Markdown that allows XML everywhere and makes
     * every XML snippet to have a much larger Markdown
     * score. */
    if (top.relevance > 0) {
      relevance += subvalue.relevance
    }

    if (explicit) {
      continuations[top.subLanguage] = subvalue.top
    }

    return [build(subvalue.language, subvalue.value, true)]
  }

  /* Process keywords. Returns nodes. */
  function processKeywords() {
    var nodes = []
    var lastIndex
    var keyword
    var node
    var submatch

    if (!top.keywords) {
      return addText(modeBuffer, nodes)
    }

    lastIndex = 0

    top.lexemesRe.lastIndex = 0

    keyword = top.lexemesRe.exec(modeBuffer)

    while (keyword) {
      addText(modeBuffer.substring(lastIndex, keyword.index), nodes)

      submatch = keywordMatch(top, keyword)

      if (submatch) {
        relevance += submatch[1]

        node = build(submatch[0], [])

        nodes.push(node)

        addText(keyword[0], node.children)
      } else {
        addText(keyword[0], nodes)
      }

      lastIndex = top.lexemesRe.lastIndex
      keyword = top.lexemesRe.exec(modeBuffer)
    }

    addText(modeBuffer.substr(lastIndex), nodes)

    return nodes
  }

  /* Add siblings. */
  function addSiblings(siblings, nodes) {
    var length = siblings.length
    var index = -1
    var sibling

    while (++index < length) {
      sibling = siblings[index]

      if (sibling.type === T_TEXT) {
        addText(sibling.value, nodes)
      } else {
        nodes.push(sibling)
      }
    }
  }

  /* Add a text. */
  function addText(value, nodes) {
    var tail

    if (value) {
      tail = nodes[nodes.length - 1]

      if (tail && tail.type === T_TEXT) {
        tail.value += value
      } else {
        nodes.push(buildText(value))
      }
    }

    return nodes
  }

  /* Build a text. */
  function buildText(value) {
    return {type: T_TEXT, value: value}
  }

  /* Build a span. */
  function build(name, contents, noPrefix) {
    return {
      type: T_ELEMENT,
      tagName: T_SPAN,
      properties: {
        className: [(noPrefix ? '' : prefix) + name]
      },
      children: contents
    }
  }

  /* Check if the first word in `keywords` is a keyword. */
  function keywordMatch(mode, keywords) {
    var keyword = keywords[0]

    if (language[keyInsensitive]) {
      keyword = keyword.toLowerCase()
    }

    return own.call(mode.keywords, keyword) && mode.keywords[keyword]
  }

  /* Check if `lexeme` is illegal according to `mode`. */
  function isIllegal(lexeme, mode) {
    return !ignore && test(mode.illegalRe, lexeme)
  }

  /* Check if `lexeme` ends `mode`. */
  function endOfMode(mode, lexeme) {
    if (test(mode.endRe, lexeme)) {
      while (mode.endsParent && mode.parent) {
        mode = mode.parent
      }

      return mode
    }

    if (mode.endsWithParent) {
      return endOfMode(mode.parent, lexeme)
    }
  }

  /* Check a sub-mode. */
  function subMode(lexeme, mode) {
    var values = mode.contains
    var length = values.length
    var index = -1

    while (++index < length) {
      if (test(values[index].beginRe, lexeme)) {
        return values[index]
      }
    }
  }

  /* Exit the current context. */
  function pop() {
    /* istanbul ignore next - removed in hljs 9.3 */
    currentChildren = stack.pop() || children
  }
}

function expandMode(mode) {
  var length
  var index
  var variants
  var result

  if (mode.variants && !mode[keyCachedVariants]) {
    variants = mode.variants
    length = variants.length
    index = -1
    result = []

    while (++index < length) {
      result[index] = inherit(mode, {variants: null}, variants[index])
    }

    mode[keyCachedVariants] = result
  }

  return (
    mode[keyCachedVariants] || (mode.endsWithParent ? [inherit(mode)] : [mode])
  )
}

/* Compile a language. */
function compileLanguage(language) {
  compileMode(language)

  /* Compile a language mode, optionally with a parent. */
  function compileMode(mode, parent) {
    var compiledKeywords = {}
    var terminators

    if (mode.compiled) {
      return
    }

    mode.compiled = true

    mode.keywords = mode.keywords || mode.beginKeywords

    if (mode.keywords) {
      if (typeof mode.keywords === 'string') {
        flatten('keyword', mode.keywords)
      } else {
        Object.keys(mode.keywords).forEach(function(className) {
          flatten(className, mode.keywords[className])
        })
      }

      mode.keywords = compiledKeywords
    }

    mode.lexemesRe = langRe(mode.lexemes || /\w+/, true)

    if (parent) {
      if (mode.beginKeywords) {
        mode.begin =
          '\\b(' + mode.beginKeywords.split(space).join(pipe) + ')\\b'
      }

      if (!mode.begin) {
        mode.begin = /\B|\b/
      }

      mode.beginRe = langRe(mode.begin)

      if (!mode.end && !mode.endsWithParent) {
        mode.end = /\B|\b/
      }

      if (mode.end) {
        mode.endRe = langRe(mode.end)
      }

      mode.terminatorEnd = source(mode.end) || ''

      if (mode.endsWithParent && parent.terminatorEnd) {
        mode.terminatorEnd += (mode.end ? pipe : '') + parent.terminatorEnd
      }
    }

    if (mode.illegal) {
      mode.illegalRe = langRe(mode.illegal)
    }

    if (mode.relevance === undefined) {
      mode.relevance = 1
    }

    if (!mode.contains) {
      mode.contains = []
    }

    mode.contains = concat.apply(
      [],
      mode.contains.map(function(c) {
        return expandMode(c === 'self' ? mode : c)
      })
    )

    mode.contains.forEach(function(c) {
      compileMode(c, mode)
    })

    if (mode.starts) {
      compileMode(mode.starts, parent)
    }

    terminators = mode.contains
      .map(map)
      .concat([mode.terminatorEnd, mode.illegal])
      .map(source)
      .filter(Boolean)

    mode.terminators = terminators.length
      ? langRe(terminators.join(pipe), true)
      : {exec: execNoop}

    function map(c) {
      return c.beginKeywords ? '\\.?(' + c.begin + ')\\.?' : c.begin
    }

    /* Flatten a classname. */
    function flatten(className, value) {
      var pairs
      var pair
      var index
      var length

      if (language[keyInsensitive]) {
        value = value.toLowerCase()
      }

      pairs = value.split(space)
      length = pairs.length
      index = -1

      while (++index < length) {
        pair = pairs[index].split(pipe)

        compiledKeywords[pair[0]] = [className, pair[1] ? Number(pair[1]) : 1]
      }
    }
  }

  /* Create a regex for `value`. */
  function langRe(value, global) {
    return new RegExp(
      source(value),
      'm' + (language[keyInsensitive] ? 'i' : '') + (global ? 'g' : '')
    )
  }

  /* Get the source of an expression or string. */
  function source(re) {
    return (re && re.source) || re
  }
}

/* Normalize a syntax result. */
function normalize(result) {
  return {
    relevance: result.relevance || 0,
    language: result.language || null,
    value: result.value || []
  }
}

/* Check if `expression` matches `lexeme`. */
function test(expression, lexeme) {
  var match = expression && expression.exec(lexeme)
  return match && match.index === 0
}

/* No-op exec. */
function execNoop() {
  return null
}

/* Get a language by `name`. */
function getLanguage(name) {
  name = name.toLowerCase()

  return languages[name] || languages[aliases[name]]
}


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__highlight__ = __webpack_require__(233);











/* harmony default export */ __webpack_exports__["a"] = (function (options) {
  var loader = options.loader,
      isLanguageRegistered = options.isLanguageRegistered,
      registerLanguage = options.registerLanguage,
      languageLoaders = options.languageLoaders,
      noAsyncLoadingLanguages = options.noAsyncLoadingLanguages;

  var ReactAsyncHighlighter =
  /*#__PURE__*/
  function (_React$PureComponent) {
    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(ReactAsyncHighlighter, _React$PureComponent);

    function ReactAsyncHighlighter() {
      __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, ReactAsyncHighlighter);

      return __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(ReactAsyncHighlighter).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(ReactAsyncHighlighter, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        if (!ReactAsyncHighlighter.isRegistered(this.props.language) && languageLoaders) {
          this.loadLanguage();
        }
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this = this;

        if (!ReactAsyncHighlighter.astGeneratorPromise) {
          ReactAsyncHighlighter.loadAstGenerator();
        }

        if (!ReactAsyncHighlighter.astGenerator) {
          ReactAsyncHighlighter.astGeneratorPromise.then(function () {
            _this.forceUpdate();
          });
        }

        if (!ReactAsyncHighlighter.isRegistered(this.props.language) && languageLoaders) {
          this.loadLanguage();
        }
      }
    }, {
      key: "loadLanguage",
      value: function loadLanguage() {
        var _this2 = this;

        var language = this.props.language;

        if (language === 'text') {
          return;
        }

        ReactAsyncHighlighter.loadLanguage(language).then(function () {
          _this2.forceUpdate();
        });
      }
    }, {
      key: "normalizeLanguage",
      value: function normalizeLanguage(language) {
        return ReactAsyncHighlighter.isSupportedLanguage(language) ? language : 'text';
      }
    }, {
      key: "render",
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(ReactAsyncHighlighter.highlightInstance, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({}, this.props, {
          language: this.normalizeLanguage(this.props.language),
          astGenerator: ReactAsyncHighlighter.astGenerator
        }));
      }
    }], [{
      key: "preload",
      value: function preload() {
        return ReactAsyncHighlighter.loadAstGenerator();
      }
    }, {
      key: "loadLanguage",
      value: function () {
        var _loadLanguage = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(
        /*#__PURE__*/
        __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.mark(function _callee(language) {
          var languageLoader;
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  languageLoader = languageLoaders[language];

                  if (!(typeof languageLoader === 'function')) {
                    _context.next = 5;
                    break;
                  }

                  return _context.abrupt("return", languageLoader(ReactAsyncHighlighter.registerLanguage));

                case 5:
                  throw new Error("Language ".concat(language, " not supported"));

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        return function loadLanguage(_x) {
          return _loadLanguage.apply(this, arguments);
        };
      }()
    }, {
      key: "isSupportedLanguage",
      value: function isSupportedLanguage(language) {
        return ReactAsyncHighlighter.isRegistered(language) || typeof languageLoaders[language] === 'function';
      }
    }, {
      key: "loadAstGenerator",
      value: function loadAstGenerator() {
        ReactAsyncHighlighter.astGeneratorPromise = loader().then(function (astGenerator) {
          ReactAsyncHighlighter.astGenerator = astGenerator;

          if (registerLanguage) {
            ReactAsyncHighlighter.languages.forEach(function (language, name) {
              return registerLanguage(astGenerator, name, language);
            });
          }
        });
        return ReactAsyncHighlighter.astGeneratorPromise;
      }
    }]);

    return ReactAsyncHighlighter;
  }(__WEBPACK_IMPORTED_MODULE_9_react___default.a.PureComponent);

  __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(ReactAsyncHighlighter, "astGenerator", null);

  __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(ReactAsyncHighlighter, "highlightInstance", Object(__WEBPACK_IMPORTED_MODULE_10__highlight__["a" /* default */])(null, {}));

  __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(ReactAsyncHighlighter, "astGeneratorPromise", null);

  __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(ReactAsyncHighlighter, "languages", new Map());

  __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(ReactAsyncHighlighter, "supportedLanguages", options.supportedLanguages || Object.keys(languageLoaders || {}));

  __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(ReactAsyncHighlighter, "isRegistered", function (language) {
    if (noAsyncLoadingLanguages) {
      return true;
    }

    if (!registerLanguage) {
      throw new Error("Current syntax highlighter doesn't support registration of languages");
    }

    if (!ReactAsyncHighlighter.astGenerator) {
      // Ast generator not available yet, but language will be registered once it is.
      return ReactAsyncHighlighter.languages.has(language);
    }

    return isLanguageRegistered(ReactAsyncHighlighter.astGenerator, language);
  });

  __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(ReactAsyncHighlighter, "registerLanguage", function (name, language) {
    if (!registerLanguage) {
      throw new Error("Current syntax highlighter doesn't support registration of languages");
    }

    if (ReactAsyncHighlighter.astGenerator) {
      return registerLanguage(ReactAsyncHighlighter.astGenerator, name, language);
    } else {
      ReactAsyncHighlighter.languages.set(name, language);
    }
  });

  return ReactAsyncHighlighter;
});

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = basic
basic.displayName = 'basic'
basic.aliases = []
function basic(Prism) {
  Prism.languages.basic = {
    comment: {
      pattern: /(?:!|REM\b).+/i,
      inside: {
        keyword: /^REM/i
      }
    },
    string: {
      pattern: /"(?:""|[!#$%&'()*,\/:;<=>?^_ +\-.A-Z\d])*"/i,
      greedy: true
    },
    number: /(?:\b\d+\.?\d*|\B\.\d+)(?:E[+-]?\d+)?/i,
    keyword: /\b(?:AS|BEEP|BLOAD|BSAVE|CALL(?: ABSOLUTE)?|CASE|CHAIN|CHDIR|CLEAR|CLOSE|CLS|COM|COMMON|CONST|DATA|DECLARE|DEF(?: FN| SEG|DBL|INT|LNG|SNG|STR)|DIM|DO|DOUBLE|ELSE|ELSEIF|END|ENVIRON|ERASE|ERROR|EXIT|FIELD|FILES|FOR|FUNCTION|GET|GOSUB|GOTO|IF|INPUT|INTEGER|IOCTL|KEY|KILL|LINE INPUT|LOCATE|LOCK|LONG|LOOP|LSET|MKDIR|NAME|NEXT|OFF|ON(?: COM| ERROR| KEY| TIMER)?|OPEN|OPTION BASE|OUT|POKE|PUT|READ|REDIM|REM|RESTORE|RESUME|RETURN|RMDIR|RSET|RUN|SHARED|SINGLE|SELECT CASE|SHELL|SLEEP|STATIC|STEP|STOP|STRING|SUB|SWAP|SYSTEM|THEN|TIMER|TO|TROFF|TRON|TYPE|UNLOCK|UNTIL|USING|VIEW PRINT|WAIT|WEND|WHILE|WRITE)(?:\$|\b)/i,
    function: /\b(?:ABS|ACCESS|ACOS|ANGLE|AREA|ARITHMETIC|ARRAY|ASIN|ASK|AT|ATN|BASE|BEGIN|BREAK|CAUSE|CEIL|CHR|CLIP|COLLATE|COLOR|CON|COS|COSH|COT|CSC|DATE|DATUM|DEBUG|DECIMAL|DEF|DEG|DEGREES|DELETE|DET|DEVICE|DISPLAY|DOT|ELAPSED|EPS|ERASABLE|EXLINE|EXP|EXTERNAL|EXTYPE|FILETYPE|FIXED|FP|GO|GRAPH|HANDLER|IDN|IMAGE|IN|INT|INTERNAL|IP|IS|KEYED|LBOUND|LCASE|LEFT|LEN|LENGTH|LET|LINE|LINES|LOG|LOG10|LOG2|LTRIM|MARGIN|MAT|MAX|MAXNUM|MID|MIN|MISSING|MOD|NATIVE|NUL|NUMERIC|OF|OPTION|ORD|ORGANIZATION|OUTIN|OUTPUT|PI|POINT|POINTER|POINTS|POS|PRINT|PROGRAM|PROMPT|RAD|RADIANS|RANDOMIZE|RECORD|RECSIZE|RECTYPE|RELATIVE|REMAINDER|REPEAT|REST|RETRY|REWRITE|RIGHT|RND|ROUND|RTRIM|SAME|SEC|SELECT|SEQUENTIAL|SET|SETTER|SGN|SIN|SINH|SIZE|SKIP|SQR|STANDARD|STATUS|STR|STREAM|STYLE|TAB|TAN|TANH|TEMPLATE|TEXT|THERE|TIME|TIMEOUT|TRACE|TRANSFORM|TRUNCATE|UBOUND|UCASE|USE|VAL|VARIABLE|VIEWPORT|WHEN|WINDOW|WITH|ZER|ZONEWIDTH)(?:\$|\b)/i,
    operator: /<[=>]?|>=?|[+\-*\/^=&]|\b(?:AND|EQV|IMP|NOT|OR|XOR)\b/i,
    punctuation: /[,;:()]/
  }
}


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = java
java.displayName = 'java'
java.aliases = []
function java(Prism) {
  Prism.languages.java = Prism.languages.extend('clike', {
    keyword: /\b(?:abstract|continue|for|new|switch|assert|default|goto|package|synchronized|boolean|do|if|private|this|break|double|implements|protected|throw|byte|else|import|public|throws|case|enum|instanceof|return|transient|catch|extends|int|short|try|char|final|interface|static|void|class|finally|long|strictfp|volatile|const|float|native|super|while)\b/,
    number: /\b0b[01]+\b|\b0x[\da-f]*\.?[\da-fp-]+\b|(?:\b\d+\.?\d*|\B\.\d+)(?:e[+-]?\d+)?[df]?/i,
    operator: {
      pattern: /(^|[^.])(?:\+[+=]?|-[-=]?|!=?|<<?=?|>>?>?=?|==?|&[&=]?|\|[|=]?|\*=?|\/=?|%=?|\^=?|[?:~])/m,
      lookbehind: true
    }
  })
  Prism.languages.insertBefore('java', 'function', {
    annotation: {
      alias: 'punctuation',
      pattern: /(^|[^.])@\w+/,
      lookbehind: true
    }
  })
  Prism.languages.insertBefore('java', 'class-name', {
    generics: {
      pattern: /<\s*\w+(?:\.\w+)?(?:\s*,\s*\w+(?:\.\w+)?)*>/i,
      alias: 'function',
      inside: {
        keyword: Prism.languages.java.keyword,
        punctuation: /[<>(),.:]/
      }
    }
  })
}


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = jsx
jsx.displayName = 'jsx'
jsx.aliases = []
function jsx(Prism) {
  ;(function(Prism) {
    var javascript = Prism.util.clone(Prism.languages.javascript)
    Prism.languages.jsx = Prism.languages.extend('markup', javascript)
    Prism.languages.jsx.tag.pattern = /<\/?(?:[\w.:-]+\s*(?:\s+(?:[\w.:-]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s{'">=]+|\{(?:\{(?:\{[^}]*\}|[^{}])*\}|[^{}])+\}))?|\{\.{3}[a-z_$][\w$]*(?:\.[a-z_$][\w$]*)*\}))*\s*\/?)?>/i
    Prism.languages.jsx.tag.inside['tag'].pattern = /^<\/?[^\s>\/]*/i
    Prism.languages.jsx.tag.inside[
      'attr-value'
    ].pattern = /=(?!\{)(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">]+)/i
    Prism.languages.insertBefore(
      'inside',
      'attr-name',
      {
        spread: {
          pattern: /\{\.{3}[a-z_$][\w$]*(?:\.[a-z_$][\w$]*)*\}/,
          inside: {
            punctuation: /\.{3}|[{}.]/,
            'attr-value': /\w+/
          }
        }
      },
      Prism.languages.jsx.tag
    )
    Prism.languages.insertBefore(
      'inside',
      'attr-value',
      {
        script: {
          // Allow for two levels of nesting
          pattern: /=(\{(?:\{(?:\{[^}]*\}|[^}])*\}|[^}])+\})/i,
          inside: {
            'script-punctuation': {
              pattern: /^=(?={)/,
              alias: 'punctuation'
            },
            rest: Prism.languages.jsx
          },
          alias: 'language-javascript'
        }
      },
      Prism.languages.jsx.tag
    )
    // The following will handle plain text inside tags
    var stringifyToken = function(token) {
      if (!token) {
        return ''
      }
      if (typeof token === 'string') {
        return token
      }
      if (typeof token.content === 'string') {
        return token.content
      }
      return token.content.map(stringifyToken).join('')
    }
    var walkTokens = function(tokens) {
      var openedTags = []
      for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i]
        var notTagNorBrace = false
        if (typeof token !== 'string') {
          if (
            token.type === 'tag' &&
            token.content[0] &&
            token.content[0].type === 'tag'
          ) {
            // We found a tag, now find its kind
            if (token.content[0].content[0].content === '</') {
              // Closing tag
              if (
                openedTags.length > 0 &&
                openedTags[openedTags.length - 1].tagName ===
                  stringifyToken(token.content[0].content[1])
              ) {
                // Pop matching opening tag
                openedTags.pop()
              }
            } else {
              if (token.content[token.content.length - 1].content === '/>') {
                // Autoclosed tag, ignore
              } else {
                // Opening tag
                openedTags.push({
                  tagName: stringifyToken(token.content[0].content[1]),
                  openedBraces: 0
                })
              }
            }
          } else if (
            openedTags.length > 0 &&
            token.type === 'punctuation' &&
            token.content === '{'
          ) {
            // Here we might have entered a JSX context inside a tag
            openedTags[openedTags.length - 1].openedBraces++
          } else if (
            openedTags.length > 0 &&
            openedTags[openedTags.length - 1].openedBraces > 0 &&
            token.type === 'punctuation' &&
            token.content === '}'
          ) {
            // Here we might have left a JSX context inside a tag
            openedTags[openedTags.length - 1].openedBraces--
          } else {
            notTagNorBrace = true
          }
        }
        if (notTagNorBrace || typeof token === 'string') {
          if (
            openedTags.length > 0 &&
            openedTags[openedTags.length - 1].openedBraces === 0
          ) {
            // Here we are inside a tag, and not inside a JSX context.
            // That's plain text: drop any tokens matched.
            var plainText = stringifyToken(token)
            // And merge text with adjacent text
            if (
              i < tokens.length - 1 &&
              (typeof tokens[i + 1] === 'string' ||
                tokens[i + 1].type === 'plain-text')
            ) {
              plainText += stringifyToken(tokens[i + 1])
              tokens.splice(i + 1, 1)
            }
            if (
              i > 0 &&
              (typeof tokens[i - 1] === 'string' ||
                tokens[i - 1].type === 'plain-text')
            ) {
              plainText = stringifyToken(tokens[i - 1]) + plainText
              tokens.splice(i - 1, 1)
              i--
            }
            tokens[i] = new Prism.Token(
              'plain-text',
              plainText,
              null,
              plainText
            )
          }
        }
        if (token.content && typeof token.content !== 'string') {
          walkTokens(token.content)
        }
      }
    }
    Prism.hooks.add('after-tokenize', function(env) {
      if (env.language !== 'jsx' && env.language !== 'tsx') {
        return
      }
      walkTokens(env.tokens)
    })
  })(Prism)
}


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = php
php.displayName = 'php'
php.aliases = []
function php(Prism) {
  /**
   * Original by Aaron Harun: http://aahacreative.com/2012/07/31/php-syntax-highlighting-prism/
   * Modified by Miles Johnson: http://milesj.me
   *
   * Supports the following:
   *      - Extends clike syntax
   *      - Support for PHP 5.3+ (namespaces, traits, generators, etc)
   *      - Smarter constant and function matching
   *
   * Adds the following new token classes:
   *      constant, delimiter, variable, function, package
   */
  ;(function(Prism) {
    Prism.languages.php = Prism.languages.extend('clike', {
      keyword: /\b(?:and|or|xor|array|as|break|case|cfunction|class|const|continue|declare|default|die|do|else|elseif|enddeclare|endfor|endforeach|endif|endswitch|endwhile|extends|for|foreach|function|include|include_once|global|if|new|return|static|switch|use|require|require_once|var|while|abstract|interface|public|implements|private|protected|parent|throw|null|echo|print|trait|namespace|final|yield|goto|instanceof|finally|try|catch)\b/i,
      constant: /\b[A-Z0-9_]{2,}\b/,
      comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
        lookbehind: true
      }
    })
    Prism.languages.insertBefore('php', 'string', {
      'shell-comment': {
        pattern: /(^|[^\\])#.*/,
        lookbehind: true,
        alias: 'comment'
      }
    })
    Prism.languages.insertBefore('php', 'keyword', {
      delimiter: {
        pattern: /\?>|<\?(?:php|=)?/i,
        alias: 'important'
      },
      variable: /\$+(?:\w+\b|(?={))/i,
      package: {
        pattern: /(\\|namespace\s+|use\s+)[\w\\]+/,
        lookbehind: true,
        inside: {
          punctuation: /\\/
        }
      }
    })
    // Must be defined after the function pattern
    Prism.languages.insertBefore('php', 'operator', {
      property: {
        pattern: /(->)[\w]+/,
        lookbehind: true
      }
    })
    Prism.languages.insertBefore('php', 'string', {
      'nowdoc-string': {
        pattern: /<<<'([^']+)'(?:\r\n?|\n)(?:.*(?:\r\n?|\n))*?\1;/,
        greedy: true,
        alias: 'string',
        inside: {
          delimiter: {
            pattern: /^<<<'[^']+'|[a-z_]\w*;$/i,
            alias: 'symbol',
            inside: {
              punctuation: /^<<<'?|[';]$/
            }
          }
        }
      },
      'heredoc-string': {
        pattern: /<<<(?:"([^"]+)"(?:\r\n?|\n)(?:.*(?:\r\n?|\n))*?\1;|([a-z_]\w*)(?:\r\n?|\n)(?:.*(?:\r\n?|\n))*?\2;)/i,
        greedy: true,
        alias: 'string',
        inside: {
          delimiter: {
            pattern: /^<<<(?:"[^"]+"|[a-z_]\w*)|[a-z_]\w*;$/i,
            alias: 'symbol',
            inside: {
              punctuation: /^<<<"?|[";]$/
            }
          },
          interpolation: null // See below
        }
      },
      'single-quoted-string': {
        pattern: /'(?:\\[\s\S]|[^\\'])*'/,
        greedy: true,
        alias: 'string'
      },
      'double-quoted-string': {
        pattern: /"(?:\\[\s\S]|[^\\"])*"/,
        greedy: true,
        alias: 'string',
        inside: {
          interpolation: null // See below
        }
      }
    })
    // The different types of PHP strings "replace" the C-like standard string
    delete Prism.languages.php['string']
    var string_interpolation = {
      pattern: /{\$(?:{(?:{[^{}]+}|[^{}]+)}|[^{}])+}|(^|[^\\{])\$+(?:\w+(?:\[.+?]|->\w+)*)/,
      lookbehind: true,
      inside: {
        rest: Prism.languages.php
      }
    }
    Prism.languages.php['heredoc-string'].inside[
      'interpolation'
    ] = string_interpolation
    Prism.languages.php['double-quoted-string'].inside[
      'interpolation'
    ] = string_interpolation
    Prism.hooks.add('before-tokenize', function(env) {
      if (!/(?:<\?php|<\?)/gi.test(env.code)) {
        return
      }
      var phpPattern = /(?:<\?php|<\?)[\s\S]*?(?:\?>|$)/gi
      Prism.languages['markup-templating'].buildPlaceholders(
        env,
        'php',
        phpPattern
      )
    })
    Prism.hooks.add('after-tokenize', function(env) {
      Prism.languages['markup-templating'].tokenizePlaceholders(env, 'php')
    })
  })(Prism)
}


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = sql
sql.displayName = 'sql'
sql.aliases = []
function sql(Prism) {
  Prism.languages.sql = {
    comment: {
      pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
      lookbehind: true
    },
    string: {
      pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\])*\2/,
      greedy: true,
      lookbehind: true
    },
    variable: /@[\w.$]+|@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
    function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i, // Should we highlight user defined functions too?
    keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:_INSERT|COL)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURNS?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
    boolean: /\b(?:TRUE|FALSE|NULL)\b/i,
    number: /\b0x[\da-f]+\b|\b\d+\.?\d*|\B\.\d+\b/i,
    operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|IN|LIKE|NOT|OR|IS|DIV|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
    punctuation: /[;[\]()`,.]/
  }
}


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = typescript
typescript.displayName = 'typescript'
typescript.aliases = ['ts']
function typescript(Prism) {
  Prism.languages.typescript = Prism.languages.extend('javascript', {
    // From JavaScript Prism keyword list and TypeScript language spec: https://github.com/Microsoft/TypeScript/blob/master/doc/spec.md#221-reserved-words
    keyword: /\b(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|var|void|while|with|yield|module|declare|constructor|namespace|abstract|require|type)\b/,
    builtin: /\b(?:string|Function|any|number|boolean|Array|symbol|console)\b/
  })
  Prism.languages.ts = Prism.languages.typescript
}


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

/* global window, self */

var restore = capture()

// istanbul ignore next - Don't allow Prism to run on page load in browser or
// to start messaging from workers.
var ctx =
  typeof window === 'undefined'
    ? typeof self === 'undefined'
      ? {}
      : self
    : window

ctx.Prism = {manual: true, disableWorkerMessageHandler: true}

/* Load all stuff in `prism.js` itself, except for
 * `prism-file-highlight.js`.
 * The wrapped non-leaky grammars are loaded instead of
 * Prism’s originals. */
var h = __webpack_require__(3050)
var decode = __webpack_require__(3066)
var Prism = __webpack_require__(3073)
var markup = __webpack_require__(1196)
var css = __webpack_require__(1146)
var clike = __webpack_require__(1139)
var js = __webpack_require__(1180)

restore()

var own = {}.hasOwnProperty

/* Inherit. */
function Refractor() {}

Refractor.prototype = Prism

/* Construct. */
var refract = new Refractor()

/* Expose. */
module.exports = refract

/* Create. */
refract.highlight = highlight
refract.register = register
refract.registered = registered

/* Register bundled grammars. */
register(markup)
register(css)
register(clike)
register(js)

refract.util.encode = encode
refract.Token.stringify = stringify

function register(grammar) {
  if (typeof grammar !== 'function' || !grammar.displayName) {
    throw new Error('Expected `function` for `grammar`, got `' + grammar + '`')
  }

  /* Do not duplicate registrations. */
  if (refract.languages[grammar.displayName] === undefined) {
    grammar(refract)
  }
}

function highlight(value, name) {
  var sup = Prism.highlight
  var grammar

  if (typeof value !== 'string') {
    throw new Error('Expected `string` for `value`, got `' + value + '`')
  }

  /* `name` is a grammar object */
  if (refract.util.type(name) === 'Object') {
    grammar = name
    name = null
  } else {
    if (typeof name !== 'string') {
      throw new Error('Expected `string` for `name`, got `' + name + '`')
    }

    if (own.call(refract.languages, name)) {
      grammar = refract.languages[name]
    } else {
      throw new Error('Unknown language: `' + name + '` is not registered')
    }
  }

  return sup.call(this, value, grammar, name)
}

function registered(language) {
  if (typeof language !== 'string') {
    throw new Error('Expected `string` for `language`, got `' + language + '`')
  }

  return own.call(refract.languages, language)
}

function stringify(value, language, parent) {
  var env

  if (typeof value === 'string') {
    return {type: 'text', value: value}
  }

  if (refract.util.type(value) === 'Array') {
    return stringifyAll(value, language)
  }

  env = {
    type: value.type,
    content: refract.Token.stringify(value.content, language, parent),
    tag: 'span',
    classes: ['token', value.type],
    attributes: {},
    language: language,
    parent: parent
  }

  if (value.alias) {
    env.classes = env.classes.concat(value.alias)
  }

  refract.hooks.run('wrap', env)

  return h(
    env.tag + '.' + env.classes.join('.'),
    attributes(env.attributes),
    env.content
  )
}

function stringifyAll(values, language) {
  var result = []
  var length = values.length
  var index = -1
  var value

  while (++index < length) {
    value = values[index]

    if (value !== '' && value !== null && value !== undefined) {
      result.push(value)
    }
  }

  index = -1
  length = result.length

  while (++index < length) {
    value = result[index]
    result[index] = refract.Token.stringify(value, language, result)
  }

  return result
}

function encode(tokens) {
  return tokens
}

function attributes(attrs) {
  var key

  for (key in attrs) {
    attrs[key] = decode(attrs[key])
  }

  return attrs
}

function capture() {
  var defined = 'Prism' in global
  /* istanbul ignore next */
  var current = defined ? global.Prism : undefined

  return restore

  function restore() {
    /* istanbul ignore else - Clean leaks after Prism. */
    if (defined) {
      global.Prism = current
    } else {
      delete global.Prism
    }

    defined = undefined
    current = undefined
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = normalize

function normalize(value) {
  return value.toLowerCase()
}


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var powers = 0

exports.boolean = increment()
exports.booleanish = increment()
exports.overloadedBoolean = increment()
exports.number = increment()
exports.spaceSeparated = increment()
exports.commaSeparated = increment()
exports.commaOrSpaceSeparated = increment()

function increment() {
  return Math.pow(2, ++powers)
}


/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FullPagePadding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return shadowClassNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Wrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__consts__ = __webpack_require__(306);





var FullPagePadding = 32;
var shadowWidth = 8;
var shadowClassNames = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow',
};
var getLineHeight = function (_a) {
    var appearance = _a.appearance;
    return "line-height: " + (appearance === 'message' ? 20 : 24) + "px";
};
var tableStyles = function (_a) {
    var appearance = _a.appearance;
    if (appearance === 'mobile') {
        return 'table-layout: auto';
    }
    return '';
};
var fullPageStyles = function (_a) {
    var theme = _a.theme, appearance = _a.appearance;
    if (appearance !== 'full-page' && appearance !== 'mobile') {
        return '';
    }
    return "\n    max-width: " + (theme && theme.layoutMaxWidth ? theme.layoutMaxWidth + "px" : 'none') + ";\n    margin: 0 auto;\n    padding: 0 " + (appearance === 'full-page' ? FullPagePadding : 0) + "px;\n  ";
};
// prettier-ignore
var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", "\n\n  font-size: ", "px;\n  ", ";\n  color: ", ";\n  word-wrap: break-word;\n\n  & span.akActionMark {\n    color: ", ";\n    text-decoration: none;\n\n    &:hover {\n      color: ", ";\n      text-decoration: underline;\n    }\n  }\n\n  & span.akActionMark {\n    cursor: pointer;\n  }\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", "\n\n  & .UnknownBlock {\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: 400;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n  }\n\n  & span.date-node {\n    background: ", ";\n    border-radius: ", "px;\n    color: ", ";\n    padding: 2px 4px;\n    margin: 0 1px;\n    transition: background 0.3s;\n    white-space: nowrap;\n  }\n\n  & span.date-node-highlighted {\n    background: ", ";\n    color: ", ";\n  }\n\n  & ul {\n    list-style-type: disc;\n\n    & ul {\n      list-style-type: circle;\n    }\n\n    & ul ul {\n      list-style-type: square;\n    }\n\n    & ul ul ul {\n      list-style-type: disc;\n    }\n\n    & ul ul ul ul {\n      list-style-type: circle;\n    }\n\n    & ul ul ul ul ul {\n      list-style-type: square;\n    }\n  }\n\n  & ol {\n    list-style-type: decimal;\n\n    & ol {\n      list-style-type: lower-alpha;\n    }\n\n    & ol ol {\n      list-style-type: lower-roman;\n    }\n\n    & ol ol ol {\n      list-style-type: decimal;\n    }\n\n    & ol ol ol ol {\n      list-style-type: lower-alpha;\n    }\n\n    & ol ol ol ol ol {\n      list-style-type: lower-roman;\n    }\n\n    & ol ol ol ol ol ol {\n      list-style-type: decimal;\n    }\n\n    & ol ol ol ol ol ol ol {\n      list-style-type: lower-alpha;\n    }\n\n    & ol ol ol ol ol ol ol ol {\n      list-style-type: lower-roman;\n    }\n  }\n\n  & .akTaskList > ol,\n  & .akDecisionList > ol {\n    list-style-type: none;\n    font-size: ", "px;\n  }\n\n  & .renderer-image {\n    max-width: 100%;\n    display: block;\n    margin: ", "px 0;\n  }\n\n  .media-single.media-wrapped + .media-single:not(.media-wrapped) {\n    clear: both;\n  }\n\n  & .CodeBlock,\n  & blockquote,\n  & hr,\n  & > div > div:not(.media-wrapped),\n  .media-single.media-wrapped + .media-wrapped + *:not(.media-wrapped),\n  .media-single.media-wrapped + div:not(.media-wrapped) {\n    clear: both;\n  }\n\n  & .media-wrapped {\n    & + h1,\n    & + h2,\n    & + h3,\n    & + h4,\n    & + h5,\n    & + h6 {\n      margin-top: 8px;\n    }\n  }\n\n  ", " &\n  div[class^='image-wrap-'] + div[class^='image-wrap-'] {\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  /* Breakout for tables and extensions */\n  .", " > {\n    .", "[data-layout='full-width'],\n    .", "[data-layout='wide'],\n    .", "[data-layout='wide'],\n    .", "[data-layout='full-width']   {\n      margin-left: 50%;\n      transform: translateX(-50%);\n    }\n    * .", ",\n    * .", " {\n      width: 100% !important;\n    }\n  }\n\n    .", " {\n      overflow-x: auto;\n    }\n\n  ", "\n\n  .", " {\n    transition: all 0.1s linear;\n\n    /** Shadow overrides */\n    &.", "::after, &.", "::before {\n      top: ", "px;\n      height: calc(100% - ", "px);\n    }\n\n    table {\n      ", ";\n      margin-left: 0;\n      margin-right: 0;\n    }\n\n    table[data-number-column='true'] {\n      .", " {\n        background-color: ", ";\n        border-right: 1px solid ", ";\n        width: ", "px;\n        text-align: center;\n        color: ", ";\n        font-size: ", "px;\n      }\n    }\n  }\n\n  /*\n   * We wrap CodeBlock in a grid to prevent it from overflowing the container of the renderer.\n   * See ED-4159.\n   */\n  & .CodeBlock {\n    max-width: 100%;\n    /* -ms- properties are necessary until MS supports the latest version of the grid spec */\n    /* stylelint-disable value-no-vendor-prefix, declaration-block-no-duplicate-properties */\n    display: -ms-grid;\n    display: grid;\n    -ms-grid-columns: auto 1fr;\n    /* stylelint-enable */\n\n    grid-template-columns: minmax(0, 1fr);\n    position: relative;\n\n    /*\n     * The overall renderer has word-wrap: break; which causes issues with\n     * code block line numbers in Safari / iOS.\n     */\n    word-wrap: normal;\n\n    & > span {\n      /* stylelint-disable value-no-vendor-prefix */\n      -ms-grid-row: 1;\n      -ms-grid-column: 2;\n      /* stylelint-enable */\n      grid-column: 1;\n    }\n  }\n\n  & .MediaGroup,\n  & .CodeBlock {\n    margin-top: ", ";\n\n    &:first-child {\n      margin-top: 0;\n    }\n  }\n\n  ", ";\n  & [data-layout-section] {\n    margin-top: ", "px;\n    & > div + div {\n      margin-left: ", "px;\n    }\n\n    @media screen and (max-width: ", "px) {\n      & > div + div {\n        margin-left: 0;\n      }\n    }\n  }\n\n  & .", "::before, .", "::after,\n    .", "::before, .", "::after {\n      display: none;\n      position: absolute;\n      pointer-events: none;\n      z-index: ", ";\n      width: ", "px;\n      content: '';\n      /* Scrollbar is outside the content in IE, inset in other browsers. */\n      height: calc(100%);\n  }\n\n  & .", "::before {\n    background: linear-gradient(\n      to left,\n      rgba(99, 114, 130, 0) 0,\n      ", " 100%\n    );\n    top: 0px;\n    left: 0;\n    display: block;\n  }\n\n  & .", "::after {\n    background: linear-gradient(\n      to right,\n      rgba(99, 114, 130, 0) 0,\n      ", " 100%\n    );\n    left: calc(100% - ", "px);\n    top: 0px;\n    display: block;\n  }\n"], ["\n  ", "\n\n  font-size: ", "px;\n  ", ";\n  color: ", ";\n  word-wrap: break-word;\n\n  & span.akActionMark {\n    color: ", ";\n    text-decoration: none;\n\n    &:hover {\n      color: ", ";\n      text-decoration: underline;\n    }\n  }\n\n  & span.akActionMark {\n    cursor: pointer;\n  }\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", "\n\n  & .UnknownBlock {\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: 400;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n  }\n\n  & span.date-node {\n    background: ", ";\n    border-radius: ", "px;\n    color: ", ";\n    padding: 2px 4px;\n    margin: 0 1px;\n    transition: background 0.3s;\n    white-space: nowrap;\n  }\n\n  & span.date-node-highlighted {\n    background: ", ";\n    color: ", ";\n  }\n\n  & ul {\n    list-style-type: disc;\n\n    & ul {\n      list-style-type: circle;\n    }\n\n    & ul ul {\n      list-style-type: square;\n    }\n\n    & ul ul ul {\n      list-style-type: disc;\n    }\n\n    & ul ul ul ul {\n      list-style-type: circle;\n    }\n\n    & ul ul ul ul ul {\n      list-style-type: square;\n    }\n  }\n\n  & ol {\n    list-style-type: decimal;\n\n    & ol {\n      list-style-type: lower-alpha;\n    }\n\n    & ol ol {\n      list-style-type: lower-roman;\n    }\n\n    & ol ol ol {\n      list-style-type: decimal;\n    }\n\n    & ol ol ol ol {\n      list-style-type: lower-alpha;\n    }\n\n    & ol ol ol ol ol {\n      list-style-type: lower-roman;\n    }\n\n    & ol ol ol ol ol ol {\n      list-style-type: decimal;\n    }\n\n    & ol ol ol ol ol ol ol {\n      list-style-type: lower-alpha;\n    }\n\n    & ol ol ol ol ol ol ol ol {\n      list-style-type: lower-roman;\n    }\n  }\n\n  & .akTaskList > ol,\n  & .akDecisionList > ol {\n    list-style-type: none;\n    font-size: ", "px;\n  }\n\n  & .renderer-image {\n    max-width: 100%;\n    display: block;\n    margin: ", "px 0;\n  }\n\n  .media-single.media-wrapped + .media-single:not(.media-wrapped) {\n    clear: both;\n  }\n\n  & .CodeBlock,\n  & blockquote,\n  & hr,\n  & > div > div:not(.media-wrapped),\n  .media-single.media-wrapped + .media-wrapped + *:not(.media-wrapped),\n  .media-single.media-wrapped + div:not(.media-wrapped) {\n    clear: both;\n  }\n\n  & .media-wrapped {\n    & + h1,\n    & + h2,\n    & + h3,\n    & + h4,\n    & + h5,\n    & + h6 {\n      margin-top: 8px;\n    }\n  }\n\n  ", " &\n  div[class^='image-wrap-'] + div[class^='image-wrap-'] {\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  /* Breakout for tables and extensions */\n  .", " > {\n    .", "[data-layout='full-width'],\n    .", "[data-layout='wide'],\n    .", "[data-layout='wide'],\n    .", "[data-layout='full-width']   {\n      margin-left: 50%;\n      transform: translateX(-50%);\n    }\n    * .", ",\n    * .", " {\n      width: 100% !important;\n    }\n  }\n\n    .", " {\n      overflow-x: auto;\n    }\n\n  ", "\n\n  .", " {\n    transition: all 0.1s linear;\n\n    /** Shadow overrides */\n    &.", "::after, &.", "::before {\n      top: ", "px;\n      height: calc(100% - ", "px);\n    }\n\n    table {\n      ", ";\n      margin-left: 0;\n      margin-right: 0;\n    }\n\n    table[data-number-column='true'] {\n      .", " {\n        background-color: ", ";\n        border-right: 1px solid ", ";\n        width: ", "px;\n        text-align: center;\n        color: ", ";\n        font-size: ", "px;\n      }\n    }\n  }\n\n  /*\n   * We wrap CodeBlock in a grid to prevent it from overflowing the container of the renderer.\n   * See ED-4159.\n   */\n  & .CodeBlock {\n    max-width: 100%;\n    /* -ms- properties are necessary until MS supports the latest version of the grid spec */\n    /* stylelint-disable value-no-vendor-prefix, declaration-block-no-duplicate-properties */\n    display: -ms-grid;\n    display: grid;\n    -ms-grid-columns: auto 1fr;\n    /* stylelint-enable */\n\n    grid-template-columns: minmax(0, 1fr);\n    position: relative;\n\n    /*\n     * The overall renderer has word-wrap: break; which causes issues with\n     * code block line numbers in Safari / iOS.\n     */\n    word-wrap: normal;\n\n    & > span {\n      /* stylelint-disable value-no-vendor-prefix */\n      -ms-grid-row: 1;\n      -ms-grid-column: 2;\n      /* stylelint-enable */\n      grid-column: 1;\n    }\n  }\n\n  & .MediaGroup,\n  & .CodeBlock {\n    margin-top: ", ";\n\n    &:first-child {\n      margin-top: 0;\n    }\n  }\n\n  ", ";\n  & [data-layout-section] {\n    margin-top: ", "px;\n    & > div + div {\n      margin-left: ", "px;\n    }\n\n    @media screen and (max-width: ", "px) {\n      & > div + div {\n        margin-left: 0;\n      }\n    }\n  }\n\n  & .", "::before, .", "::after,\n    .", "::before, .", "::after {\n      display: none;\n      position: absolute;\n      pointer-events: none;\n      z-index: ", ";\n      width: ", "px;\n      content: '';\n      /* Scrollbar is outside the content in IE, inset in other browsers. */\n      height: calc(100%);\n  }\n\n  & .", "::before {\n    background: linear-gradient(\n      to left,\n      rgba(99, 114, 130, 0) 0,\n      ", " 100%\n    );\n    top: 0px;\n    left: 0;\n    display: block;\n  }\n\n  & .", "::after {\n    background: linear-gradient(\n      to right,\n      rgba(99, 114, 130, 0) 0,\n      ", " 100%\n    );\n    left: calc(100% - ", "px);\n    top: 0px;\n    display: block;\n  }\n"])), fullPageStyles, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["x" /* editorFontSize */], getLineHeight, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N800, dark: '#B8C7E0' }), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B400, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B300, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["s" /* blockquoteSharedStyles */], __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["C" /* headingsSharedStyles */], __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["J" /* panelSharedStyles */], __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["L" /* ruleSharedStyles */], __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["K" /* paragraphSharedStyles */], __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["E" /* indentationSharedStyles */], __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["q" /* blockMarksSharedStyles */], Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["fontFamily"])(), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["fontSize"])(), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30A, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])(), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N800, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R50, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R500, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["fontSize"])(), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() * 3, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["I" /* mediaSingleSharedStyle */], __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* RendererCssClassName */].DOCUMENT, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["f" /* TableSharedCssClassName */].TABLE_CONTAINER, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["f" /* TableSharedCssClassName */].TABLE_CONTAINER, __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* RendererCssClassName */].EXTENSION, __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* RendererCssClassName */].EXTENSION, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["f" /* TableSharedCssClassName */].TABLE_CONTAINER, __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* RendererCssClassName */].EXTENSION, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["f" /* TableSharedCssClassName */].TABLE_NODE_WRAPPER, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["O" /* tableSharedStyle */], __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["f" /* TableSharedCssClassName */].TABLE_CONTAINER, shadowClassNames.RIGHT_SHADOW, shadowClassNames.LEFT_SHADOW, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["N" /* tableMarginTop */] - 1, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["N" /* tableMarginTop */], tableStyles, __WEBPACK_IMPORTED_MODULE_4__consts__["a" /* RendererCssClassName */].NUMBER_COLUMN, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["p" /* akEditorTableToolbar */], __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["m" /* akEditorTableBorder */], __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["o" /* akEditorTableNumberColumnWidth */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N200, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["fontSize"])(), __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["r" /* blockNodesVerticalMargin */], __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["w" /* columnLayoutSharedStyle */], Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() * 2.5, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() * 4, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["B" /* gridMediumMaxWidth */], shadowClassNames.RIGHT_SHADOW, shadowClassNames.RIGHT_SHADOW, shadowClassNames.LEFT_SHADOW, shadowClassNames.LEFT_SHADOW, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["l" /* akEditorSmallZIndex */], shadowWidth, shadowClassNames.LEFT_SHADOW, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N40A, shadowClassNames.RIGHT_SHADOW, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N40A, shadowWidth);
var templateObject_1;
//# sourceMappingURL=style.js.map

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = setGlobalHeader;
/* harmony export (immutable) */ __webpack_exports__["b"] = getGlobalHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fetch__ = __webpack_require__(3170);
var URL=__webpack_require__(536);var USP=__webpack_require__(3169);// IE, Safari, Mobile Chrome, Mobile Safari
//import URL from 'url'
//import USP from 'url-search-params'
var URLSearchParams=USP.default||USP;var globalHeaders={};function setGlobalHeader(name,value){globalHeaders[name]=value;}function getGlobalHeader(){return globalHeaders;}function processError(r,contentType){if(contentType==='application/json'){return r.json().then(function(res){throw new Error(res?res.description:r.status);});}throw new Error();}function processResponse(r){var contentType=r.headers.get('content-type');if(!r.ok){return processError(r,contentType);}if(contentType==='application/json'){return r.json();}else if(contentType==='application/octet-stream'){return r.blob();}return r;}var buildUrl=function buildUrl(baseUrl,path,queryParams){if(path===void 0){path='';}var searchParam=new URLSearchParams(URL.parse(baseUrl).search||undefined);baseUrl=baseUrl.split('?')[0];if(queryParams){for(var key in queryParams){if({}.hasOwnProperty.call(queryParams,key)){searchParam.append(key,queryParams[key]);}}}var seperator='';if(path&&baseUrl.substr(-1)!=='/'){seperator='/';}var params=searchParam.toString();if(params){params='?'+params;}return""+baseUrl+seperator+path+params;};/* harmony default export */ __webpack_exports__["a"] = ({post:function post(url,payload,headers){return Object(__WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */])(url,{method:'POST',headers:Object.assign({'Content-Type':'application/json'},globalHeaders,headers),body:JSON.stringify(payload)}).then(processResponse);},get:function get(url){return Object(__WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */])(url,{headers:globalHeaders}).then(processResponse);},delete:function _delete(url){return Object(__WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */])(url,{method:'DELETE',headers:globalHeaders}).then(processResponse);},put:function put(url,payload,headers){return Object(__WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */])(url,{method:'PUT',headers:Object.assign({'Content-Type':'application/json'},globalHeaders,headers),body:JSON.stringify(payload)}).then(processResponse);},requestService:function requestService(serviceConfig,options){var url=serviceConfig.url,requestOptions;var _a=options,path=_a.path,queryParams=_a.queryParams,headers=_a.headers;var requestUrl=buildUrl(url,path,queryParams);var requestOptions={headers:headers};return Object(__WEBPACK_IMPORTED_MODULE_0__fetch__["a" /* default */])(requestUrl,requestOptions).then(processResponse);}});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = deepMap;
/* harmony export (immutable) */ __webpack_exports__["a"] = deepForEach;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elementTypes__ = __webpack_require__(309);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




function isTabChild(child) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["a" /* isTab */])(child) || Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["b" /* isTabList */])(child) || Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child);
}

function deepMap(children, callback) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (child) {
    // null happens when conditionally rendering TabPanel/Tab
    // see https://github.com/reactjs/react-tabs/issues/37
    if (child === null) return null;

    if (isTabChild(child)) {
      return callback(child);
    }

    if (child.props && child.props.children && typeof child.props.children === 'object') {
      // Clone the child that has children and map them too
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, _objectSpread({}, child.props, {
        children: deepMap(child.props.children, callback)
      }));
    }

    return child;
  });
}
function deepForEach(children, callback) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(children, function (child) {
    // null happens when conditionally rendering TabPanel/Tab
    // see https://github.com/reactjs/react-tabs/issues/37
    if (child === null) return;

    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["a" /* isTab */])(child) || Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child)) {
      callback(child);
    } else if (child.props && child.props.children && typeof child.props.children === 'object') {
      if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["b" /* isTabList */])(child)) callback(child);
      deepForEach(child.props.children, callback);
    }
  });
}

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAppStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url_join__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_url_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(73);
var api=__WEBPACK_IMPORTED_MODULE_0_url_join___default.a.bind(null,__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].apiUrl);var getAppStatus=Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* asyncAction */])({basename:'APP_STATUS_GET',action:function action(_action){return function(){return function(dispatch){dispatch(_action.start());return __WEBPACK_IMPORTED_MODULE_1__util__["d" /* http */].get(api('/ssp/status')).then(function(response){dispatch(_action.success(response));}).catch(function(err){console.error('error getting app status api response',err);alert("You MUST be connected to the Nike VPN to use this tool."+'\n'+" Please properly connect and reload this page");dispatch(_action.error(err));});};};}});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = notifications;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isOffline; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_js__ = __webpack_require__(500);
var defaultState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["c" /* fromJS */])({offline:false});function notifications(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];state=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["c" /* fromJS */])(state);// Force immutable in case of rehydration
switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions_js__["a" /* notifyOffline */].type:return state.set('offline',action.payload.offline);default:return state;}}var isOffline=function isOffline(state){return state.offline.get('offline');};

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return notifyOffline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return watchOnlineState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_index_js__ = __webpack_require__(36);
var notifyOffline=Object(__WEBPACK_IMPORTED_MODULE_0__util_index_js__["b" /* createAction */])('OFFLINE_MODE_CHANGE',function(offline){return{offline:offline};});var watchOnlineState=function watchOnlineState(store){var notify=function notify(){return store.dispatch(notifyOffline(!navigator.onLine));};// Initialize the state
notify();// There is a problem with registering these events
// If you try attach them before 'load' fires they just no-op (Edge/Firefox)
// If 'load' has already fired it will not fire again
// To ensure they work in all cases you must do both (yay browser inconsistencies!)
// To ensure you are not double notified 'load' must also clean up the original listeners
window.addEventListener('online',notify);window.addEventListener('offline',notify);window.addEventListener('load',function(){window.removeEventListener('online',notify);window.removeEventListener('offline',notify);window.addEventListener('online',notify);window.addEventListener('offline',notify);});};

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = themed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTheme__ = __webpack_require__(1283);
/* eslint-disable prefer-rest-params */


function themedVariants(variantProp, variants) {
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);

    if (props && props[variantProp] && variants) {
      var modes = variants[props[variantProp]];

      if (modes) {
        return modes[theme.mode];
      }
    }

    return '';
  };
}

function themed(modesOrVariant, variantModes) {
  if (typeof modesOrVariant === 'string') {
    return themedVariants(modesOrVariant, variantModes);
  }

  var modes = modesOrVariant;
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    return modes[theme.mode];
  };
}

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createTheme__ = __webpack_require__(503);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils_createTheme__["a" /* createTheme */])(function () {
  return {
    mode: 'light'
  };
}));

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


function createTheme(defaultThemeFn) {
  var emptyThemeFn = function emptyThemeFn(tokens, props) {
    return tokens(props);
  };

  var ThemeContext = Object(__WEBPACK_IMPORTED_MODULE_1_react__["createContext"])(defaultThemeFn);

  function Consumer(props) {
    var children = props.children,
        themeProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(props, ["children"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ThemeContext.Consumer, null, function (theme) {
      var themeFn = theme || emptyThemeFn;
      return props.children(themeFn(themeProps));
    });
  }

  function Provider(props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ThemeContext.Consumer, null, function (themeFn) {
      var valueFn = props.value || emptyThemeFn;

      var mixedFn = function mixedFn(themeProps) {
        return valueFn(themeFn, themeProps);
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ThemeContext.Provider, {
        value: mixedFn
      }, props.children);
    });
  }

  return {
    Consumer: Consumer,
    Provider: Provider
  };
}

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IssueList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_history__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_lozenge__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_index__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_refresh__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_refresh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_refresh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducer__ = __webpack_require__(173);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var dateOptions={year:'numeric',month:'long',day:'numeric','hour':'2-digit','minute':'2-digit','hour12':false};var IssueList=function(_Component){_inherits(IssueList,_Component);function IssueList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,IssueList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=IssueList.__proto__||Object.getPrototypeOf(IssueList)).call.apply(_ref,[this].concat(args))),_this),_this.handleRefresh=function(){var getAllUserIssues=_this.props.getAllUserIssues;getAllUserIssues(true,0);},_this.handleLoadMore=function(){var _this$props=_this.props,getAllUserIssues=_this$props.getAllUserIssues,userIssues=_this$props.userIssues;getAllUserIssues(false,userIssues.length+1);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(IssueList,[{key:'componentWillMount',value:function componentWillMount(){var getAllUserIssues=this.props.getAllUserIssues;getAllUserIssues(false,0);}},{key:'render',value:function render(){var _props=this.props,setIssue=_props.setIssue,isSelectIssuesPending=_props.isSelectIssuesPending,userIssues=_props.userIssues,totalIssues=_props.totalIssues;var rows=null;if(userIssues.length>0&&!isSelectIssuesPending){rows=userIssues.map(function(issue){var created=new Date(issue.created);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'u-cursor-pointer',key:issue.key,onClick:function onClick(){setIssue(issue);__WEBPACK_IMPORTED_MODULE_3__util_history__["a" /* default */].push('/requests/'+issue.key);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,issue.key),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__atlaskit_lozenge__["default"],{appearance:issue.status.appearance},issue.status.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,issue.customfield_15740),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,issue.summary),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,created.toLocaleDateString('en-US',dateOptions)));});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,isSelectIssuesPending?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["j" /* H3 */],{className:'pb5-sm pr5-sm'},'My Requests'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["v" /* Spinner */],{medium:true})):userIssues.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["j" /* H3 */],{className:'pb5-sm pr5-sm'},'My Requests',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn icon-solo',title:'refresh',onClick:this.handleRefresh},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_refresh___default.a,{size:'medium'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'showing ',userIssues.length,' of ',totalIssues,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'page-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',{className:'u-uppercase u-bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Issue Key'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Request Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Summary'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Created'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,rows)),userIssues.length<totalIssues?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__atlaskit_button__["default"],{type:'button',onClick:this.handleLoadMore,appearance:'primary'},'Load More ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa '+(isSelectIssuesPending?'fa-circle-o-notch fa-spin':null)})):null)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index__["k" /* H4 */],{className:'border-top-black pt4-sm'},'You have not created any Requests')));}}]);return IssueList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{isSelectIssuesPending:Object(__WEBPACK_IMPORTED_MODULE_4__util__["f" /* selectIsRequestPending */])(state,__WEBPACK_IMPORTED_MODULE_9__actions__["f" /* getAllUserIssues */]),userIssues:Object(__WEBPACK_IMPORTED_MODULE_10__reducer__["e" /* selectIssues */])(state),totalIssues:Object(__WEBPACK_IMPORTED_MODULE_10__reducer__["f" /* selectIssuesTotal */])(state)};},{setIssue:__WEBPACK_IMPORTED_MODULE_9__actions__["j" /* setIssue */],getAllUserIssues:__WEBPACK_IMPORTED_MODULE_9__actions__["f" /* getAllUserIssues */]})(IssueList)));// improvements: get status color from API and make Status value a colored Pill matching the status color
// allow for the number of results to be limited. Home page should limit to 5 results
// If number of results are limited and there are more results then the limit
// there should be a configurable link to take the user to all issues

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RequestTypeList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_history__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_index__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducer__ = __webpack_require__(173);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//.unshift can be used to add an element to the begining of an array. rows is an array
var RequestTypeList=function(_Component){_inherits(RequestTypeList,_Component);function RequestTypeList(){_classCallCheck(this,RequestTypeList);return _possibleConstructorReturn(this,(RequestTypeList.__proto__||Object.getPrototypeOf(RequestTypeList)).apply(this,arguments));}_createClass(RequestTypeList,[{key:'componentWillMount',value:function componentWillMount(){var getAllRequestTypes=this.props.getAllRequestTypes;getAllRequestTypes();}},{key:'render',value:function render(){var _props=this.props,requestTypes=_props.requestTypes,setRequestType=_props.setRequestType,clearNewIssueKey=_props.clearNewIssueKey,isSelectRequestTypesPending=_props.isSelectRequestTypesPending;var rows=null;if(requestTypes.length>0&&!isSelectRequestTypesPending){rows=requestTypes.map(function(requestType){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'u-cursor-pointer',key:requestType.name,onClick:function onClick(){setRequestType(requestType);clearNewIssueKey();__WEBPACK_IMPORTED_MODULE_3__util_history__["a" /* default */].push('/createReq');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,requestType.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,requestType.description));});}var accessRequest=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'u-cursor-pointer',key:'Access Request',onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_3__util_history__["a" /* default */].push('/');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Access Request'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Select for help gaining access to Jira, Portfolio for Jira Sidebar, Confluence, Bitbucket, or Github'));if(rows){rows.unshift(accessRequest);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,requestTypes.length>0&&!isSelectRequestTypesPending?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["j" /* H3 */],{className:'pb5-sm'},'Create Request'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'page-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',{className:'u-uppercase u-bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Description'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,rows)))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["j" /* H3 */],{className:'pb5-sm'},'Create Request'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["v" /* Spinner */],{medium:true})));}}]);return RequestTypeList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{isSelectRequestTypesPending:Object(__WEBPACK_IMPORTED_MODULE_4__util__["f" /* selectIsRequestPending */])(state,__WEBPACK_IMPORTED_MODULE_6__actions__["e" /* getAllRequestTypes */]),requestTypes:Object(__WEBPACK_IMPORTED_MODULE_7__reducer__["i" /* selectRequestTypes */])(state)};},{setRequestType:__WEBPACK_IMPORTED_MODULE_6__actions__["l" /* setRequestType */],clearNewIssueKey:__WEBPACK_IMPORTED_MODULE_6__actions__["c" /* clearNewIssueKey */],getAllRequestTypes:__WEBPACK_IMPORTED_MODULE_6__actions__["e" /* getAllRequestTypes */]})(RequestTypeList)));

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppStatus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducer__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_index_js__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AppStatus=function(_Component){_inherits(AppStatus,_Component);function AppStatus(){_classCallCheck(this,AppStatus);return _possibleConstructorReturn(this,(AppStatus.__proto__||Object.getPrototypeOf(AppStatus)).apply(this,arguments));}_createClass(AppStatus,[{key:'render',value:function render(){var appList=this.props.appList;var appStatusList=null;if(appList!=null){appStatusList=appList.map(function(app){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:app.name},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'access-status-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index_js__["m" /* Link */],{external:true,to:app.url,className:'access-status-app link'},app.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["b" /* AppStatusIndicator */],{className:'access-status-indicator',status:app.available},!app.available?app.error_message:'App is online and available')));});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,appStatusList?appStatusList:null);}}]);return AppStatus;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{appList:Object(__WEBPACK_IMPORTED_MODULE_4__reducer__["b" /* selectAppList */])(state)};},{})(AppStatus)));

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prefix", function() { return prefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_INSERT", function() { return ARRAY_INSERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_MOVE", function() { return ARRAY_MOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_POP", function() { return ARRAY_POP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_PUSH", function() { return ARRAY_PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_REMOVE", function() { return ARRAY_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_REMOVE_ALL", function() { return ARRAY_REMOVE_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SHIFT", function() { return ARRAY_SHIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SPLICE", function() { return ARRAY_SPLICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_UNSHIFT", function() { return ARRAY_UNSHIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SWAP", function() { return ARRAY_SWAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTOFILL", function() { return AUTOFILL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLUR", function() { return BLUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE", function() { return CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_FIELDS", function() { return CLEAR_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_SUBMIT", function() { return CLEAR_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_SUBMIT_ERRORS", function() { return CLEAR_SUBMIT_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_ASYNC_ERROR", function() { return CLEAR_ASYNC_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DESTROY", function() { return DESTROY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS", function() { return FOCUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INITIALIZE", function() { return INITIALIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REGISTER_FIELD", function() { return REGISTER_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET", function() { return RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_SECTION", function() { return RESET_SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SUBMIT_FAILED", function() { return SET_SUBMIT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SUBMIT_SUCCEEDED", function() { return SET_SUBMIT_SUCCEEDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_ASYNC_VALIDATION", function() { return START_ASYNC_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_SUBMIT", function() { return START_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STOP_ASYNC_VALIDATION", function() { return STOP_ASYNC_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STOP_SUBMIT", function() { return STOP_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUBMIT", function() { return SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOUCH", function() { return TOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNREGISTER_FIELD", function() { return UNREGISTER_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNTOUCH", function() { return UNTOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SYNC_ERRORS", function() { return UPDATE_SYNC_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SYNC_WARNINGS", function() { return UPDATE_SYNC_WARNINGS; });
var prefix = '@@redux-form/';

var ARRAY_INSERT = prefix + 'ARRAY_INSERT';
var ARRAY_MOVE = prefix + 'ARRAY_MOVE';
var ARRAY_POP = prefix + 'ARRAY_POP';
var ARRAY_PUSH = prefix + 'ARRAY_PUSH';
var ARRAY_REMOVE = prefix + 'ARRAY_REMOVE';
var ARRAY_REMOVE_ALL = prefix + 'ARRAY_REMOVE_ALL';
var ARRAY_SHIFT = prefix + 'ARRAY_SHIFT';
var ARRAY_SPLICE = prefix + 'ARRAY_SPLICE';
var ARRAY_UNSHIFT = prefix + 'ARRAY_UNSHIFT';
var ARRAY_SWAP = prefix + 'ARRAY_SWAP';
var AUTOFILL = prefix + 'AUTOFILL';
var BLUR = prefix + 'BLUR';
var CHANGE = prefix + 'CHANGE';
var CLEAR_FIELDS = prefix + 'CLEAR_FIELDS';
var CLEAR_SUBMIT = prefix + 'CLEAR_SUBMIT';
var CLEAR_SUBMIT_ERRORS = prefix + 'CLEAR_SUBMIT_ERRORS';
var CLEAR_ASYNC_ERROR = prefix + 'CLEAR_ASYNC_ERROR';
var DESTROY = prefix + 'DESTROY';
var FOCUS = prefix + 'FOCUS';
var INITIALIZE = prefix + 'INITIALIZE';
var REGISTER_FIELD = prefix + 'REGISTER_FIELD';
var RESET = prefix + 'RESET';
var RESET_SECTION = prefix + 'RESET_SECTION';
var SET_SUBMIT_FAILED = prefix + 'SET_SUBMIT_FAILED';
var SET_SUBMIT_SUCCEEDED = prefix + 'SET_SUBMIT_SUCCEEDED';
var START_ASYNC_VALIDATION = prefix + 'START_ASYNC_VALIDATION';
var START_SUBMIT = prefix + 'START_SUBMIT';
var STOP_ASYNC_VALIDATION = prefix + 'STOP_ASYNC_VALIDATION';
var STOP_SUBMIT = prefix + 'STOP_SUBMIT';
var SUBMIT = prefix + 'SUBMIT';
var TOUCH = prefix + 'TOUCH';
var UNREGISTER_FIELD = prefix + 'UNREGISTER_FIELD';
var UNTOUCH = prefix + 'UNTOUCH';
var UPDATE_SYNC_ERRORS = prefix + 'UPDATE_SYNC_ERRORS';
var UPDATE_SYNC_WARNINGS = prefix + 'UPDATE_SYNC_WARNINGS';

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__ = __webpack_require__(3213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__ = __webpack_require__(3229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__ = __webpack_require__(3231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__ = __webpack_require__(3232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__ = __webpack_require__(3233);






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__["a" /* default */];
MapCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__["a" /* default */];
MapCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__["a" /* default */];
MapCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__["a" /* default */];
MapCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (MapCache);


/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(117);



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(96);



/* Built-in method references that are verified to be native. */
var Map = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Map');

/* harmony default export */ __webpack_exports__["a"] = (Map);


/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stackClear_js__ = __webpack_require__(3238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__ = __webpack_require__(3239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stackGet_js__ = __webpack_require__(3240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stackHas_js__ = __webpack_require__(3241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stackSet_js__ = __webpack_require__(3242);







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */](entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = __WEBPACK_IMPORTED_MODULE_1__stackClear_js__["a" /* default */];
Stack.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__["a" /* default */];
Stack.prototype.get = __WEBPACK_IMPORTED_MODULE_3__stackGet_js__["a" /* default */];
Stack.prototype.has = __WEBPACK_IMPORTED_MODULE_4__stackHas_js__["a" /* default */];
Stack.prototype.set = __WEBPACK_IMPORTED_MODULE_5__stackSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Stack);


/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeys_js__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(241);




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeys_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keys);


/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ __webpack_exports__["a"] = (isIndex);


/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["a"] = (isLength);


/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__ = __webpack_require__(3277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(3279);




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 3);

  Object(__WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__["a" /* default */])(object, function(value, key, object) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(result, key, iteratee(value, key, object));
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapValues);


/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(312);



/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* harmony default export */ __webpack_exports__["a"] = (isKey);


/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = (identity);


/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hasError__ = __webpack_require__(3322);



var createIsValid = function createIsValid(structure) {
  var getIn = structure.getIn,
      keys = structure.keys;

  var hasError = Object(__WEBPACK_IMPORTED_MODULE_0__hasError__["a" /* default */])(structure);
  return function (form, getFormState) {
    var ignoreSubmitErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      var formState = nonNullGetFormState(state);
      var syncError = getIn(formState, form + '.syncError');
      if (syncError) {
        return false;
      }
      if (!ignoreSubmitErrors) {
        var error = getIn(formState, form + '.error');
        if (error) {
          return false;
        }
      }
      var syncErrors = getIn(formState, form + '.syncErrors');
      var asyncErrors = getIn(formState, form + '.asyncErrors');
      var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + '.submitErrors');
      if (!syncErrors && !asyncErrors && !submitErrors) {
        return true;
      }

      var registeredFields = getIn(formState, form + '.registeredFields');
      if (!registeredFields) {
        return true;
      }

      return !keys(registeredFields).filter(function (name) {
        return getIn(registeredFields, '[\'' + name + '\'].count') > 0;
      }).some(function (name) {
        return hasError(getIn(registeredFields, '[\'' + name + '\']'), syncErrors, asyncErrors, submitErrors);
      });
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsValid);

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var URI = __webpack_require__(3378)
  , equal = __webpack_require__(521)
  , util = __webpack_require__(176)
  , SchemaObject = __webpack_require__(1322)
  , traverse = __webpack_require__(3380);

module.exports = resolve;

resolve.normalizeId = normalizeId;
resolve.fullPath = getFullPath;
resolve.url = resolveUrl;
resolve.ids = resolveIds;
resolve.inlineRef = inlineRef;
resolve.schema = resolveSchema;

/**
 * [resolve and compile the references ($ref)]
 * @this   Ajv
 * @param  {Function} compile reference to schema compilation funciton (localCompile)
 * @param  {Object} root object with information about the root schema for the current schema
 * @param  {String} ref reference to resolve
 * @return {Object|Function} schema object (if the schema can be inlined) or validation function
 */
function resolve(compile, root, ref) {
  /* jshint validthis: true */
  var refVal = this._refs[ref];
  if (typeof refVal == 'string') {
    if (this._refs[refVal]) refVal = this._refs[refVal];
    else return resolve.call(this, compile, root, refVal);
  }

  refVal = refVal || this._schemas[ref];
  if (refVal instanceof SchemaObject) {
    return inlineRef(refVal.schema, this._opts.inlineRefs)
            ? refVal.schema
            : refVal.validate || this._compile(refVal);
  }

  var res = resolveSchema.call(this, root, ref);
  var schema, v, baseId;
  if (res) {
    schema = res.schema;
    root = res.root;
    baseId = res.baseId;
  }

  if (schema instanceof SchemaObject) {
    v = schema.validate || compile.call(this, schema.schema, root, undefined, baseId);
  } else if (schema !== undefined) {
    v = inlineRef(schema, this._opts.inlineRefs)
        ? schema
        : compile.call(this, schema, root, undefined, baseId);
  }

  return v;
}


/**
 * Resolve schema, its root and baseId
 * @this Ajv
 * @param  {Object} root root object with properties schema, refVal, refs
 * @param  {String} ref  reference to resolve
 * @return {Object} object with properties schema, root, baseId
 */
function resolveSchema(root, ref) {
  /* jshint validthis: true */
  var p = URI.parse(ref)
    , refPath = _getFullPath(p)
    , baseId = getFullPath(this._getId(root.schema));
  if (Object.keys(root.schema).length === 0 || refPath !== baseId) {
    var id = normalizeId(refPath);
    var refVal = this._refs[id];
    if (typeof refVal == 'string') {
      return resolveRecursive.call(this, root, refVal, p);
    } else if (refVal instanceof SchemaObject) {
      if (!refVal.validate) this._compile(refVal);
      root = refVal;
    } else {
      refVal = this._schemas[id];
      if (refVal instanceof SchemaObject) {
        if (!refVal.validate) this._compile(refVal);
        if (id == normalizeId(ref))
          return { schema: refVal, root: root, baseId: baseId };
        root = refVal;
      } else {
        return;
      }
    }
    if (!root.schema) return;
    baseId = getFullPath(this._getId(root.schema));
  }
  return getJsonPointer.call(this, p, baseId, root.schema, root);
}


/* @this Ajv */
function resolveRecursive(root, ref, parsedRef) {
  /* jshint validthis: true */
  var res = resolveSchema.call(this, root, ref);
  if (res) {
    var schema = res.schema;
    var baseId = res.baseId;
    root = res.root;
    var id = this._getId(schema);
    if (id) baseId = resolveUrl(baseId, id);
    return getJsonPointer.call(this, parsedRef, baseId, schema, root);
  }
}


var PREVENT_SCOPE_CHANGE = util.toHash(['properties', 'patternProperties', 'enum', 'dependencies', 'definitions']);
/* @this Ajv */
function getJsonPointer(parsedRef, baseId, schema, root) {
  /* jshint validthis: true */
  parsedRef.fragment = parsedRef.fragment || '';
  if (parsedRef.fragment.slice(0,1) != '/') return;
  var parts = parsedRef.fragment.split('/');

  for (var i = 1; i < parts.length; i++) {
    var part = parts[i];
    if (part) {
      part = util.unescapeFragment(part);
      schema = schema[part];
      if (schema === undefined) break;
      var id;
      if (!PREVENT_SCOPE_CHANGE[part]) {
        id = this._getId(schema);
        if (id) baseId = resolveUrl(baseId, id);
        if (schema.$ref) {
          var $ref = resolveUrl(baseId, schema.$ref);
          var res = resolveSchema.call(this, root, $ref);
          if (res) {
            schema = res.schema;
            root = res.root;
            baseId = res.baseId;
          }
        }
      }
    }
  }
  if (schema !== undefined && schema !== root.schema)
    return { schema: schema, root: root, baseId: baseId };
}


var SIMPLE_INLINED = util.toHash([
  'type', 'format', 'pattern',
  'maxLength', 'minLength',
  'maxProperties', 'minProperties',
  'maxItems', 'minItems',
  'maximum', 'minimum',
  'uniqueItems', 'multipleOf',
  'required', 'enum'
]);
function inlineRef(schema, limit) {
  if (limit === false) return false;
  if (limit === undefined || limit === true) return checkNoRef(schema);
  else if (limit) return countKeys(schema) <= limit;
}


function checkNoRef(schema) {
  var item;
  if (Array.isArray(schema)) {
    for (var i=0; i<schema.length; i++) {
      item = schema[i];
      if (typeof item == 'object' && !checkNoRef(item)) return false;
    }
  } else {
    for (var key in schema) {
      if (key == '$ref') return false;
      item = schema[key];
      if (typeof item == 'object' && !checkNoRef(item)) return false;
    }
  }
  return true;
}


function countKeys(schema) {
  var count = 0, item;
  if (Array.isArray(schema)) {
    for (var i=0; i<schema.length; i++) {
      item = schema[i];
      if (typeof item == 'object') count += countKeys(item);
      if (count == Infinity) return Infinity;
    }
  } else {
    for (var key in schema) {
      if (key == '$ref') return Infinity;
      if (SIMPLE_INLINED[key]) {
        count++;
      } else {
        item = schema[key];
        if (typeof item == 'object') count += countKeys(item) + 1;
        if (count == Infinity) return Infinity;
      }
    }
  }
  return count;
}


function getFullPath(id, normalize) {
  if (normalize !== false) id = normalizeId(id);
  var p = URI.parse(id);
  return _getFullPath(p);
}


function _getFullPath(p) {
  return URI.serialize(p).split('#')[0] + '#';
}


var TRAILING_SLASH_HASH = /#\/?$/;
function normalizeId(id) {
  return id ? id.replace(TRAILING_SLASH_HASH, '') : '';
}


function resolveUrl(baseId, id) {
  id = normalizeId(id);
  return URI.resolve(baseId, id);
}


/* @this Ajv */
function resolveIds(schema) {
  var schemaId = normalizeId(this._getId(schema));
  var baseIds = {'': schemaId};
  var fullPaths = {'': getFullPath(schemaId, false)};
  var localRefs = {};
  var self = this;

  traverse(schema, {allKeys: true}, function(sch, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
    if (jsonPtr === '') return;
    var id = self._getId(sch);
    var baseId = baseIds[parentJsonPtr];
    var fullPath = fullPaths[parentJsonPtr] + '/' + parentKeyword;
    if (keyIndex !== undefined)
      fullPath += '/' + (typeof keyIndex == 'number' ? keyIndex : util.escapeFragment(keyIndex));

    if (typeof id == 'string') {
      id = baseId = normalizeId(baseId ? URI.resolve(baseId, id) : id);

      var refVal = self._refs[id];
      if (typeof refVal == 'string') refVal = self._refs[refVal];
      if (refVal && refVal.schema) {
        if (!equal(sch, refVal.schema))
          throw new Error('id "' + id + '" resolves to more than one schema');
      } else if (id != normalizeId(fullPath)) {
        if (id[0] == '#') {
          if (localRefs[id] && !equal(sch, localRefs[id]))
            throw new Error('id "' + id + '" resolves to more than one schema');
          localRefs[id] = sch;
        } else {
          self._refs[id] = fullPath;
        }
      }
    }
    baseIds[jsonPtr] = baseId;
    fullPaths[jsonPtr] = fullPath;
  });

  return localRefs;
}


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// do not edit .js files directly - edit src/index.jst



module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var resolve = __webpack_require__(520);

module.exports = {
  Validation: errorSubclass(ValidationError),
  MissingRef: errorSubclass(MissingRefError)
};


function ValidationError(errors) {
  this.message = 'validation failed';
  this.errors = errors;
  this.ajv = this.validation = true;
}


MissingRefError.message = function (baseId, ref) {
  return 'can\'t resolve reference ' + ref + ' from id ' + baseId;
};


function MissingRefError(baseId, ref, message) {
  this.message = message || MissingRefError.message(baseId, ref);
  this.missingRef = resolve.url(baseId, ref);
  this.missingSchema = resolve.normalizeId(resolve.fullPath(this.missingRef));
}


function errorSubclass(Subclass) {
  Subclass.prototype = Object.create(Error.prototype);
  Subclass.prototype.constructor = Subclass;
  return Subclass;
}


/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return toggleNavMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return closeNavMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return openNavMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_index_js__ = __webpack_require__(36);
var toggleNavMenu=Object(__WEBPACK_IMPORTED_MODULE_0__util_index_js__["b" /* createAction */])('NAVIGATION_MENU_TOGGLE',{noPayload:true});var closeNavMenu=Object(__WEBPACK_IMPORTED_MODULE_0__util_index_js__["b" /* createAction */])('NAVIGATION_MENU_CLOSE',{noPayload:true});var openNavMenu=Object(__WEBPACK_IMPORTED_MODULE_0__util_index_js__["b" /* createAction */])('NAVIGATION_MENU_OPEN',{noPayload:true});

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(54);

var _interopRequireDefault = __webpack_require__(53);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.size = exports.default = exports.IconWrapper = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(4));

var _createClass2 = _interopRequireDefault(__webpack_require__(5));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(7));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(6));

var _inherits2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _styledComponents = _interopRequireDefault(__webpack_require__(2));

var _uuid = _interopRequireDefault(__webpack_require__(22));

var _theme = __webpack_require__(3);

var _constants = __webpack_require__(2917);

var getSize = function getSize(props) {
  if (props.size) {
    return "height: ".concat(_constants.sizes[props.size], "; width: ").concat(_constants.sizes[props.size], ";");
  }

  return null;
};

var IconWrapper = _styledComponents.default.span.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "dyhwwi-0"
})(["\n  ", " color: ", ";\n  display: inline-block;\n  fill: ", ";\n  flex-shrink: 0;\n  line-height: 1;\n\n  > svg {\n    ", " max-height: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    pointer-events: none;\n    vertical-align: bottom;\n  }\n  /* Stop-color doesn't properly apply in chrome when the inherited/current color changes.\n   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS\n   * rule) and then override it with currentColor for the color changes to be picked up.\n   */\n  stop {\n    stop-color: currentColor;\n  }\n"], getSize, function (p) {
  return p.primaryColor || 'currentColor';
}, function (p) {
  return p.secondaryColor || _theme.colors.background;
}, getSize);

exports.IconWrapper = IconWrapper;

var Icon =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Icon, _Component);

  function Icon() {
    (0, _classCallCheck2.default)(this, Icon);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Icon).apply(this, arguments));
  }

  (0, _createClass2.default)(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Glyph = _this$props.glyph,
          dangerouslySetGlyph = _this$props.dangerouslySetGlyph,
          onClick = _this$props.onClick,
          primaryColor = _this$props.primaryColor,
          secondaryColor = _this$props.secondaryColor,
          size = _this$props.size; // handling the glyphs as strings

      if (dangerouslySetGlyph) {
        return _react.default.createElement(IconWrapper, {
          onClick: onClick,
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          size: size,
          "aria-label": this.props.label,
          dangerouslySetInnerHTML: {
            __html: Icon.insertDynamicGradientID(dangerouslySetGlyph)
          }
        });
      } // handling the glyphs when passed through as functions


      return _react.default.createElement(IconWrapper, {
        onClick: onClick,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        "aria-label": this.props.label
      }, Glyph ? _react.default.createElement(Glyph, {
        role: "presentation"
      }) : null);
    }
  }], [{
    key: "insertDynamicGradientID",

    /* Icons need unique gradient IDs across instances for different gradient definitions to work
     * correctly.
     * A step in the icon build process replaces linear gradient IDs and their references in paths
     * to a placeholder string so we can replace them with a dynamic ID here.
     * Replacing the original IDs with placeholders in the build process is more robust than not
     * using placeholders as we do not have to rely on regular expressions to find specific element
     * to replace.
     */
    value: function insertDynamicGradientID(svgStr) {
      var id = (0, _uuid.default)();
      var replacedSvgStr = svgStr.replace(/id="([^"]+)-idPlaceholder"/g, "id=$1-".concat(id)).replace(/fill="url\(#([^"]+)-idPlaceholder\)"/g, "fill=\"url(#$1-".concat(id, ")\""));
      return replacedSvgStr;
    }
  }]);
  return Icon;
}(_react.Component);

exports.default = Icon;
(0, _defineProperty2.default)(Icon, "defaultProps", {
  onClick: function onClick() {}
});
var size = Object.keys(_constants.sizes).reduce(function (p, c) {
  return Object.assign(p, (0, _defineProperty2.default)({}, c, c));
}, {});
exports.size = size;

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return messages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(17);

var messages = Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["defineMessages"])({
    deleteEmojiTitle: {
        id: 'fabric.emoji.delete.title',
        defaultMessage: 'Remove emoji',
        description: 'Title for emoji removal dialog',
    },
    deleteEmojiDescription: {
        id: 'fabric.emoji.delete.description',
        defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
        description: 'Description for emoji removal dialog',
    },
    deleteEmojiLabel: {
        id: 'fabric.emoji.delete.label',
        defaultMessage: 'Remove',
        description: 'Button label to remove emoji',
    },
    addCustomEmojiLabel: {
        id: 'fabric.emoji.add.custom.emoji.label',
        defaultMessage: 'Add your own emoji',
        description: 'Button label to add custom emoji',
    },
    emojiPlaceholder: {
        id: 'fabric.emoji.placeholder',
        defaultMessage: 'Emoji name',
        description: 'Placeholder for emoji',
    },
    emojiChooseFileTitle: {
        id: 'fabric.emoji.choose.file.title',
        defaultMessage: 'Choose file',
        description: 'Choose custom emoji file',
    },
    emojiImageRequirements: {
        id: 'fabric.emoji.image.requirements',
        defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
        description: 'Message for emoji image requirements and maximum file size',
    },
    emojiPreviewTitle: {
        id: 'fabric.emoji.preview.title',
        defaultMessage: 'Preview',
        description: 'Emoji preview title',
    },
    emojiPreview: {
        id: 'fabric.emoji.preview',
        defaultMessage: 'Your new emoji {emoji} looks great',
        description: 'Emoji preview',
    },
    addEmojiLabel: {
        id: 'fabric.emoji.add.label',
        defaultMessage: 'Add emoji',
        description: 'verb - Button label to add emoji',
    },
    retryLabel: {
        id: 'fabric.emoji.retry.label',
        defaultMessage: 'Retry',
        description: 'verb - Button label to retry upload',
    },
    cancelLabel: {
        id: 'fabric.emoji.cancel.label',
        defaultMessage: 'Cancel',
        description: 'verb - button label to cancel operation',
    },
    searchLabel: {
        id: 'fabric.emoji.search.label',
        defaultMessage: 'Search',
        description: 'verb - button label to search',
    },
    categoriesSearchResults: {
        id: 'fabric.emoji.categories.search.results',
        defaultMessage: 'Search results',
        description: 'Emoji categories search results',
    },
    frequentCategory: {
        id: 'fabric.emoji.category.frequent',
        defaultMessage: 'Frequent',
        description: 'Emoji frequent category',
    },
    peopleCategory: {
        id: 'fabric.emoji.category.people',
        defaultMessage: 'People',
        description: 'Emoji frequent category',
    },
    natureCategory: {
        id: 'fabric.emoji.category.nature',
        defaultMessage: 'Nature',
        description: 'Emoji nature category',
    },
    foodsCategory: {
        id: 'fabric.emoji.category.foods',
        defaultMessage: 'Food & Drink',
        description: 'Emoji Foods category',
    },
    activityCategory: {
        id: 'fabric.emoji.category.activity',
        defaultMessage: 'Activity',
        description: 'Emoji activity category',
    },
    placesCategory: {
        id: 'fabric.emoji.category.places',
        defaultMessage: 'Travel & Places',
        description: 'Emoji Places category',
    },
    objectsCategory: {
        id: 'fabric.emoji.category.objects',
        defaultMessage: 'Objects',
        description: 'Emoji objects category',
    },
    symbolsCategory: {
        id: 'fabric.emoji.category.symbols',
        defaultMessage: 'Symbols',
        description: 'Emoji symbols category',
    },
    flagsCategory: {
        id: 'fabric.emoji.category.flags',
        defaultMessage: 'Flags',
        description: 'Emoji flags category',
    },
    productivityCategory: {
        id: 'fabric.emoji.category.productivity',
        defaultMessage: 'Productivity',
        description: 'Emoji productivity category',
    },
    userUploadsCustomCategory: {
        id: 'fabric.emoji.category.user.uploads',
        defaultMessage: 'Your uploads',
        description: 'User uploads in the custom category',
    },
    allUploadsCustomCategory: {
        id: 'fabric.emoji.category.all.uploads',
        defaultMessage: 'All uploads',
        description: 'All uploads in the custom category',
    },
    deleteEmojiFailed: {
        id: 'fabric.emoji.error.delete.failed',
        defaultMessage: 'Remove failed',
        description: 'Error message when custom emoji failed to be removed',
    },
    emojiInvalidImage: {
        id: 'fabric.emoji.error.invalid.image',
        defaultMessage: 'Selected image is invalid',
        description: 'Error message for invalid selected image',
    },
    emojiUploadFailed: {
        id: 'fabric.emoji.error.upload.failed',
        defaultMessage: 'Upload failed',
        description: 'Failed to upload emoji image',
    },
    emojiImageTooBig: {
        id: 'fabric.emoji.error.image.too.big',
        defaultMessage: 'Selected image is more than 1 MB',
        description: 'Error message for image too big, beyond the size limit',
    },
});
//# sourceMappingURL=i18n.js.map

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return messages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(17);

var messages = Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["defineMessages"])({
    deleteEmojiTitle: {
        id: 'fabric.emoji.delete.title',
        defaultMessage: 'Remove emoji',
        description: 'Title for emoji removal dialog',
    },
    deleteEmojiDescription: {
        id: 'fabric.emoji.delete.description',
        defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
        description: 'Description for emoji removal dialog',
    },
    deleteEmojiLabel: {
        id: 'fabric.emoji.delete.label',
        defaultMessage: 'Remove',
        description: 'Button label to remove emoji',
    },
    addCustomEmojiLabel: {
        id: 'fabric.emoji.add.custom.emoji.label',
        defaultMessage: 'Add your own emoji',
        description: 'Button label to add custom emoji',
    },
    emojiPlaceholder: {
        id: 'fabric.emoji.placeholder',
        defaultMessage: 'Emoji name',
        description: 'Placeholder for emoji',
    },
    emojiChooseFileTitle: {
        id: 'fabric.emoji.choose.file.title',
        defaultMessage: 'Choose file',
        description: 'Choose custom emoji file',
    },
    emojiImageRequirements: {
        id: 'fabric.emoji.image.requirements',
        defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
        description: 'Message for emoji image requirements and maximum file size',
    },
    emojiPreviewTitle: {
        id: 'fabric.emoji.preview.title',
        defaultMessage: 'Preview',
        description: 'Emoji preview title',
    },
    emojiPreview: {
        id: 'fabric.emoji.preview',
        defaultMessage: 'Your new emoji {emoji} looks great',
        description: 'Emoji preview',
    },
    addEmojiLabel: {
        id: 'fabric.emoji.add.label',
        defaultMessage: 'Add emoji',
        description: 'verb - Button label to add emoji',
    },
    retryLabel: {
        id: 'fabric.emoji.retry.label',
        defaultMessage: 'Retry',
        description: 'verb - Button label to retry upload',
    },
    cancelLabel: {
        id: 'fabric.emoji.cancel.label',
        defaultMessage: 'Cancel',
        description: 'verb - button label to cancel operation',
    },
    searchLabel: {
        id: 'fabric.emoji.search.label',
        defaultMessage: 'Search',
        description: 'verb - button label to search',
    },
    categoriesSearchResults: {
        id: 'fabric.emoji.categories.search.results',
        defaultMessage: 'Search results',
        description: 'Emoji categories search results',
    },
    frequentCategory: {
        id: 'fabric.emoji.category.frequent',
        defaultMessage: 'Frequent',
        description: 'Emoji frequent category',
    },
    peopleCategory: {
        id: 'fabric.emoji.category.people',
        defaultMessage: 'People',
        description: 'Emoji frequent category',
    },
    natureCategory: {
        id: 'fabric.emoji.category.nature',
        defaultMessage: 'Nature',
        description: 'Emoji nature category',
    },
    foodsCategory: {
        id: 'fabric.emoji.category.foods',
        defaultMessage: 'Food & Drink',
        description: 'Emoji Foods category',
    },
    activityCategory: {
        id: 'fabric.emoji.category.activity',
        defaultMessage: 'Activity',
        description: 'Emoji activity category',
    },
    placesCategory: {
        id: 'fabric.emoji.category.places',
        defaultMessage: 'Travel & Places',
        description: 'Emoji Places category',
    },
    objectsCategory: {
        id: 'fabric.emoji.category.objects',
        defaultMessage: 'Objects',
        description: 'Emoji objects category',
    },
    symbolsCategory: {
        id: 'fabric.emoji.category.symbols',
        defaultMessage: 'Symbols',
        description: 'Emoji symbols category',
    },
    flagsCategory: {
        id: 'fabric.emoji.category.flags',
        defaultMessage: 'Flags',
        description: 'Emoji flags category',
    },
    productivityCategory: {
        id: 'fabric.emoji.category.productivity',
        defaultMessage: 'Productivity',
        description: 'Emoji productivity category',
    },
    userUploadsCustomCategory: {
        id: 'fabric.emoji.category.user.uploads',
        defaultMessage: 'Your uploads',
        description: 'User uploads in the custom category',
    },
    allUploadsCustomCategory: {
        id: 'fabric.emoji.category.all.uploads',
        defaultMessage: 'All uploads',
        description: 'All uploads in the custom category',
    },
    deleteEmojiFailed: {
        id: 'fabric.emoji.error.delete.failed',
        defaultMessage: 'Remove failed',
        description: 'Error message when custom emoji failed to be removed',
    },
    emojiInvalidImage: {
        id: 'fabric.emoji.error.invalid.image',
        defaultMessage: 'Selected image is invalid',
        description: 'Error message for invalid selected image',
    },
    emojiUploadFailed: {
        id: 'fabric.emoji.error.upload.failed',
        defaultMessage: 'Upload failed',
        description: 'Failed to upload emoji image',
    },
    emojiImageTooBig: {
        id: 'fabric.emoji.error.image.too.big',
        defaultMessage: 'Selected image is more than 1 MB',
        description: 'Error message for image too big, beyond the size limit',
    },
});
//# sourceMappingURL=i18n.js.map

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return messages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(17);

var messages = Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["defineMessages"])({
    deleteEmojiTitle: {
        id: 'fabric.emoji.delete.title',
        defaultMessage: 'Remove emoji',
        description: 'Title for emoji removal dialog',
    },
    deleteEmojiDescription: {
        id: 'fabric.emoji.delete.description',
        defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
        description: 'Description for emoji removal dialog',
    },
    deleteEmojiLabel: {
        id: 'fabric.emoji.delete.label',
        defaultMessage: 'Remove',
        description: 'Button label to remove emoji',
    },
    addCustomEmojiLabel: {
        id: 'fabric.emoji.add.custom.emoji.label',
        defaultMessage: 'Add your own emoji',
        description: 'Button label to add custom emoji',
    },
    emojiPlaceholder: {
        id: 'fabric.emoji.placeholder',
        defaultMessage: 'Emoji name',
        description: 'Placeholder for emoji',
    },
    emojiChooseFileTitle: {
        id: 'fabric.emoji.choose.file.title',
        defaultMessage: 'Choose file',
        description: 'Choose custom emoji file',
    },
    emojiImageRequirements: {
        id: 'fabric.emoji.image.requirements',
        defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
        description: 'Message for emoji image requirements and maximum file size',
    },
    emojiPreviewTitle: {
        id: 'fabric.emoji.preview.title',
        defaultMessage: 'Preview',
        description: 'Emoji preview title',
    },
    emojiPreview: {
        id: 'fabric.emoji.preview',
        defaultMessage: 'Your new emoji {emoji} looks great',
        description: 'Emoji preview',
    },
    addEmojiLabel: {
        id: 'fabric.emoji.add.label',
        defaultMessage: 'Add emoji',
        description: 'verb - Button label to add emoji',
    },
    retryLabel: {
        id: 'fabric.emoji.retry.label',
        defaultMessage: 'Retry',
        description: 'verb - Button label to retry upload',
    },
    cancelLabel: {
        id: 'fabric.emoji.cancel.label',
        defaultMessage: 'Cancel',
        description: 'verb - button label to cancel operation',
    },
    searchLabel: {
        id: 'fabric.emoji.search.label',
        defaultMessage: 'Search',
        description: 'verb - button label to search',
    },
    categoriesSearchResults: {
        id: 'fabric.emoji.categories.search.results',
        defaultMessage: 'Search results',
        description: 'Emoji categories search results',
    },
    frequentCategory: {
        id: 'fabric.emoji.category.frequent',
        defaultMessage: 'Frequent',
        description: 'Emoji frequent category',
    },
    peopleCategory: {
        id: 'fabric.emoji.category.people',
        defaultMessage: 'People',
        description: 'Emoji frequent category',
    },
    natureCategory: {
        id: 'fabric.emoji.category.nature',
        defaultMessage: 'Nature',
        description: 'Emoji nature category',
    },
    foodsCategory: {
        id: 'fabric.emoji.category.foods',
        defaultMessage: 'Food & Drink',
        description: 'Emoji Foods category',
    },
    activityCategory: {
        id: 'fabric.emoji.category.activity',
        defaultMessage: 'Activity',
        description: 'Emoji activity category',
    },
    placesCategory: {
        id: 'fabric.emoji.category.places',
        defaultMessage: 'Travel & Places',
        description: 'Emoji Places category',
    },
    objectsCategory: {
        id: 'fabric.emoji.category.objects',
        defaultMessage: 'Objects',
        description: 'Emoji objects category',
    },
    symbolsCategory: {
        id: 'fabric.emoji.category.symbols',
        defaultMessage: 'Symbols',
        description: 'Emoji symbols category',
    },
    flagsCategory: {
        id: 'fabric.emoji.category.flags',
        defaultMessage: 'Flags',
        description: 'Emoji flags category',
    },
    productivityCategory: {
        id: 'fabric.emoji.category.productivity',
        defaultMessage: 'Productivity',
        description: 'Emoji productivity category',
    },
    userUploadsCustomCategory: {
        id: 'fabric.emoji.category.user.uploads',
        defaultMessage: 'Your uploads',
        description: 'User uploads in the custom category',
    },
    allUploadsCustomCategory: {
        id: 'fabric.emoji.category.all.uploads',
        defaultMessage: 'All uploads',
        description: 'All uploads in the custom category',
    },
    deleteEmojiFailed: {
        id: 'fabric.emoji.error.delete.failed',
        defaultMessage: 'Remove failed',
        description: 'Error message when custom emoji failed to be removed',
    },
    emojiInvalidImage: {
        id: 'fabric.emoji.error.invalid.image',
        defaultMessage: 'Selected image is invalid',
        description: 'Error message for invalid selected image',
    },
    emojiUploadFailed: {
        id: 'fabric.emoji.error.upload.failed',
        defaultMessage: 'Upload failed',
        description: 'Failed to upload emoji image',
    },
    emojiImageTooBig: {
        id: 'fabric.emoji.error.image.too.big',
        defaultMessage: 'Selected image is more than 1 MB',
        description: 'Error message for image too big, beyond the size limit',
    },
});
//# sourceMappingURL=i18n.js.map

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(2293);
var isArguments = __webpack_require__(2294);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AtlasKitThemeProvider */
/* unused harmony export borderRadius */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return gridSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fontSize; });
/* unused harmony export fontSizeSmall */
/* unused harmony export fontFamily */
/* unused harmony export codeFontFamily */
/* unused harmony export focusRing */
/* unused harmony export noFocusRing */
/* unused harmony export layers */
/* unused harmony export assistive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colors__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elevation__ = __webpack_require__(2263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typography__ = __webpack_require__(2264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_math__ = __webpack_require__(2265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_getTheme__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_themed__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AtlaskitThemeProvider__ = __webpack_require__(2266);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__colors__; });
/* unused harmony reexport elevation */
/* unused harmony reexport typography */
/* unused harmony reexport math */
/* unused harmony reexport getTheme */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__utils_themed__["a"]; });
/* unused harmony reexport AtlaskitThemeProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Appearance__ = __webpack_require__(2267);
/* unused harmony reexport Appearance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Reset__ = __webpack_require__(2268);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Theme__ = __webpack_require__(428);
/* unused harmony reexport default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hoc__ = __webpack_require__(2269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_createTheme__ = __webpack_require__(429);
/* unused harmony namespace reexport */









 // backwards-compatible export with old Atlaskit case

var AtlasKitThemeProvider = __WEBPACK_IMPORTED_MODULE_7__components_AtlaskitThemeProvider__["a" /* default */];
/*
  These theme values are expressed as functions so that if we decide to make
  them dependent on props in the future, it wouldn't require a significant
  refactor everywhere they are being used.
*/

var borderRadius = function borderRadius() {
  return 3;
};
var gridSize = function gridSize() {
  return 8;
};
var fontSize = function fontSize() {
  return 14;
};
var fontSizeSmall = function fontSizeSmall() {
  return 11;
};
var fontFamily = function fontFamily() {
  return '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';
};
var codeFontFamily = function codeFontFamily() {
  return '"SFMono-Medium", "SF Mono", "Segoe UI Mono", "Roboto Mono", "Ubuntu Mono", Menlo, Consolas, Courier, monospace';
};
var focusRing = function focusRing() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__colors__["B100"];
  var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : gridSize() / 4;
  return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, " ").concat(color, ";\n  }\n");
};
var noFocusRing = function noFocusRing() {
  return "\n  box-shadow: none;\n";
};
var layers = {
  card: function card() {
    return 100;
  },
  dialog: function dialog() {
    return 200;
  },
  navigation: function navigation() {
    return 300;
  },
  layer: function layer() {
    return 400;
  },
  blanket: function blanket() {
    return 500;
  },
  modal: function modal() {
    return 510;
  },
  flag: function flag() {
    return 600;
  },
  spotlight: function spotlight() {
    return 700;
  },
  tooltip: function tooltip() {
    return 800;
  }
};
var assistive = function assistive() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  border: 0 !important;\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  height: 1px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  width: 1px !important;\n  white-space: nowrap !important;\n"]);
}; // New API






/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(1361);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 531 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Emoji */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_tooltip__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_cross_circle__ = __webpack_require__(1769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_cross_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_cross_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__type_helpers__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_mouse__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_EmojiUtils__ = __webpack_require__(195);












var handleMouseDown = function (props, event) {
    // Clicked emoji delete button
    if (event.target instanceof Element &&
        event.target.getAttribute('aria-label') === __WEBPACK_IMPORTED_MODULE_9__constants__["i" /* deleteEmojiLabel */]) {
        return;
    }
    var emoji = props.emoji, onSelected = props.onSelected;
    event.preventDefault();
    if (onSelected && Object(__WEBPACK_IMPORTED_MODULE_10__util_mouse__["b" /* leftClick */])(event)) {
        onSelected(Object(__WEBPACK_IMPORTED_MODULE_8__type_helpers__["o" /* toEmojiId */])(emoji), emoji, event);
    }
};
var handleMouseMove = function (props, event) {
    var emoji = props.emoji, onMouseMove = props.onMouseMove;
    if (onMouseMove) {
        onMouseMove(Object(__WEBPACK_IMPORTED_MODULE_8__type_helpers__["o" /* toEmojiId */])(emoji), emoji, event);
    }
};
var handleDelete = function (props, event) {
    var emoji = props.emoji, onDelete = props.onDelete;
    if (onDelete) {
        onDelete(Object(__WEBPACK_IMPORTED_MODULE_8__type_helpers__["o" /* toEmojiId */])(emoji), emoji, event);
    }
};
var handleImageError = function (props, event) {
    var emoji = props.emoji, onLoadError = props.onLoadError;
    // Hide error state (but keep space for it)
    if (event.target) {
        var target = event.target;
        target.style.visibility = 'hidden';
    }
    if (onLoadError) {
        onLoadError(Object(__WEBPACK_IMPORTED_MODULE_8__type_helpers__["o" /* toEmojiId */])(emoji), emoji, event);
    }
};
// Pure functional components are used in favour of class based components, due to the performance!
// When rendering 1500+ emoji using class based components had a significant impact.
var renderAsSprite = function (props) {
    var _a;
    var emoji = props.emoji, fitToHeight = props.fitToHeight, selected = props.selected, selectOnHover = props.selectOnHover, className = props.className, showTooltip = props.showTooltip;
    var representation = emoji.representation;
    var sprite = representation.sprite;
    var classes = (_a = {},
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["n" /* emojiContainer */]] = true,
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["p" /* emojiNode */]] = true,
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["G" /* selected */]] = selected,
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["F" /* selectOnHover */]] = selectOnHover,
        _a);
    if (className) {
        classes[className] = true;
    }
    var sizing = {};
    if (fitToHeight) {
        sizing = {
            width: fitToHeight + "px",
            height: fitToHeight + "px",
        };
    }
    var xPositionInPercent = (100 / (sprite.column - 1)) * (representation.xIndex - 0);
    var yPositionInPercent = (100 / (sprite.row - 1)) * (representation.yIndex - 0);
    var style = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ backgroundImage: "url(" + sprite.url + ")", backgroundPosition: xPositionInPercent + "% " + yPositionInPercent + "%", backgroundSize: sprite.column * 100 + "% " + sprite.row * 100 + "%" }, sizing);
    var emojiNode = (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_7__styles__["u" /* emojiSprite */], style: style }, "\u00A0"));
    return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(classes), 
        // tslint:disable-next-line:jsx-no-lambda
        onMouseDown: function (event) {
            handleMouseDown(props, event);
        }, 
        // tslint:disable-next-line:jsx-no-lambda
        onMouseMove: function (event) {
            handleMouseMove(props, event);
        }, "aria-label": emoji.shortName }, showTooltip ? (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_tooltip__["a" /* default */], { tag: "span", content: emoji.shortName }, emojiNode)) : (emojiNode)));
};
// Keep as pure functional component, see renderAsSprite.
var renderAsImage = function (props) {
    var _a;
    var emoji = props.emoji, fitToHeight = props.fitToHeight, selected = props.selected, selectOnHover = props.selectOnHover, className = props.className, showTooltip = props.showTooltip, showDelete = props.showDelete;
    var classes = (_a = {},
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["k" /* emoji */]] = true,
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["p" /* emojiNode */]] = true,
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["G" /* selected */]] = selected,
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["F" /* selectOnHover */]] = selectOnHover,
        _a);
    if (className) {
        classes[className] = true;
    }
    var width;
    var height;
    var src;
    var representation = Object(__WEBPACK_IMPORTED_MODULE_11__api_EmojiUtils__["d" /* shouldUseAltRepresentation */])(emoji, fitToHeight)
        ? emoji.altRepresentation
        : emoji.representation;
    if (Object(__WEBPACK_IMPORTED_MODULE_8__type_helpers__["h" /* isImageRepresentation */])(representation)) {
        src = representation.imagePath;
        width = representation.width;
        height = representation.height;
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_8__type_helpers__["k" /* isMediaRepresentation */])(representation)) {
        src = representation.mediaPath;
        width = representation.width;
        height = representation.height;
    }
    var deleteButton;
    if (showDelete) {
        deleteButton = (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_7__styles__["g" /* deleteButton */] },
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__atlaskit_button__["default"], { iconBefore: __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_cross_circle___default.a, { label: __WEBPACK_IMPORTED_MODULE_9__constants__["i" /* deleteEmojiLabel */], primaryColor: __WEBPACK_IMPORTED_MODULE_6__atlaskit_theme__["colors"].N500, size: "small" }), onClick: function (event) { return handleDelete(props, event); }, appearance: "subtle-link", spacing: "none" })));
    }
    var sizing = {};
    if (fitToHeight && width && height) {
        // Presize image, to prevent reflow due to size changes after loading
        sizing = {
            width: (fitToHeight / height) * width,
            height: fitToHeight,
        };
    }
    var onError = function (event) {
        handleImageError(props, event);
    };
    // Pass src attribute as key to force React to rerender img node since browser does not
    // change preview image until loaded
    var emojiNode = (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("img", __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ src: src, key: src, alt: emoji.shortName, style: { visibility: 'visible' }, onError: onError }, sizing)));
    return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(classes), 
        // tslint:disable-next-line:jsx-no-lambda
        onMouseDown: function (event) {
            handleMouseDown(props, event);
        }, 
        // tslint:disable-next-line:jsx-no-lambda
        onMouseMove: function (event) {
            handleMouseMove(props, event);
        }, "aria-label": emoji.shortName },
        deleteButton,
        showTooltip ? (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_tooltip__["a" /* default */], { tag: "span", content: emoji.shortName }, emojiNode)) : (emojiNode)));
};
// tslint:disable-next-line:variable-name
var Emoji = function (props) {
    var emoji = props.emoji;
    if (Object(__WEBPACK_IMPORTED_MODULE_8__type_helpers__["m" /* isSpriteRepresentation */])(emoji.representation)) {
        return renderAsSprite(props);
    }
    return renderAsImage(props);
};
/* harmony default export */ __webpack_exports__["a"] = (Emoji);
//# sourceMappingURL=Emoji.js.map

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * EventEmitter2
 * https://github.com/hij1nx/EventEmitter2
 *
 * Copyright (c) 2013 hij1nx
 * Licensed under the MIT license.
 */
;!function(undefined) {

  var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
    return Object.prototype.toString.call(obj) === "[object Array]";
  };
  var defaultMaxListeners = 10;

  function init() {
    this._events = {};
    if (this._conf) {
      configure.call(this, this._conf);
    }
  }

  function configure(conf) {
    if (conf) {
      this._conf = conf;

      conf.delimiter && (this.delimiter = conf.delimiter);
      this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;

      conf.wildcard && (this.wildcard = conf.wildcard);
      conf.newListener && (this.newListener = conf.newListener);
      conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);

      if (this.wildcard) {
        this.listenerTree = {};
      }
    } else {
      this._maxListeners = defaultMaxListeners;
    }
  }

  function logPossibleMemoryLeak(count, eventName) {
    var errorMsg = '(node) warning: possible EventEmitter memory ' +
        'leak detected. ' + count + ' listeners added. ' +
        'Use emitter.setMaxListeners() to increase limit.';

    if(this.verboseMemoryLeak){
      errorMsg += ' Event name: ' + eventName + '.';
    }

    if(typeof process !== 'undefined' && process.emitWarning){
      var e = new Error(errorMsg);
      e.name = 'MaxListenersExceededWarning';
      e.emitter = this;
      e.count = count;
      process.emitWarning(e);
    } else {
      console.error(errorMsg);

      if (console.trace){
        console.trace();
      }
    }
  }

  function EventEmitter(conf) {
    this._events = {};
    this.newListener = false;
    this.verboseMemoryLeak = false;
    configure.call(this, conf);
  }
  EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property

  //
  // Attention, function return type now is array, always !
  // It has zero elements if no any matches found and one or more
  // elements (leafs) if there are matches
  //
  function searchListenerTree(handlers, type, tree, i) {
    if (!tree) {
      return [];
    }
    var listeners=[], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached,
        typeLength = type.length, currentType = type[i], nextType = type[i+1];
    if (i === typeLength && tree._listeners) {
      //
      // If at the end of the event(s) list and the tree has listeners
      // invoke those listeners.
      //
      if (typeof tree._listeners === 'function') {
        handlers && handlers.push(tree._listeners);
        return [tree];
      } else {
        for (leaf = 0, len = tree._listeners.length; leaf < len; leaf++) {
          handlers && handlers.push(tree._listeners[leaf]);
        }
        return [tree];
      }
    }

    if ((currentType === '*' || currentType === '**') || tree[currentType]) {
      //
      // If the event emitted is '*' at this part
      // or there is a concrete match at this patch
      //
      if (currentType === '*') {
        for (branch in tree) {
          if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i+1));
          }
        }
        return listeners;
      } else if(currentType === '**') {
        endReached = (i+1 === typeLength || (i+2 === typeLength && nextType === '*'));
        if(endReached && tree._listeners) {
          // The next element has a _listeners, add it to the handlers.
          listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
        }

        for (branch in tree) {
          if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
            if(branch === '*' || branch === '**') {
              if(tree[branch]._listeners && !endReached) {
                listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
              }
              listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
            } else if(branch === nextType) {
              listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i+2));
            } else {
              // No match on this one, shift into the tree but not in the type array.
              listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
            }
          }
        }
        return listeners;
      }

      listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i+1));
    }

    xTree = tree['*'];
    if (xTree) {
      //
      // If the listener tree will allow any match for this part,
      // then recursively explore all branches of the tree
      //
      searchListenerTree(handlers, type, xTree, i+1);
    }

    xxTree = tree['**'];
    if(xxTree) {
      if(i < typeLength) {
        if(xxTree._listeners) {
          // If we have a listener on a '**', it will catch all, so add its handler.
          searchListenerTree(handlers, type, xxTree, typeLength);
        }

        // Build arrays of matching next branches and others.
        for(branch in xxTree) {
          if(branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
            if(branch === nextType) {
              // We know the next element will match, so jump twice.
              searchListenerTree(handlers, type, xxTree[branch], i+2);
            } else if(branch === currentType) {
              // Current node matches, move into the tree.
              searchListenerTree(handlers, type, xxTree[branch], i+1);
            } else {
              isolatedBranch = {};
              isolatedBranch[branch] = xxTree[branch];
              searchListenerTree(handlers, type, { '**': isolatedBranch }, i+1);
            }
          }
        }
      } else if(xxTree._listeners) {
        // We have reached the end and still on a '**'
        searchListenerTree(handlers, type, xxTree, typeLength);
      } else if(xxTree['*'] && xxTree['*']._listeners) {
        searchListenerTree(handlers, type, xxTree['*'], typeLength);
      }
    }

    return listeners;
  }

  function growListenerTree(type, listener) {

    type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();

    //
    // Looks for two consecutive '**', if so, don't add the event at all.
    //
    for(var i = 0, len = type.length; i+1 < len; i++) {
      if(type[i] === '**' && type[i+1] === '**') {
        return;
      }
    }

    var tree = this.listenerTree;
    var name = type.shift();

    while (name !== undefined) {

      if (!tree[name]) {
        tree[name] = {};
      }

      tree = tree[name];

      if (type.length === 0) {

        if (!tree._listeners) {
          tree._listeners = listener;
        }
        else {
          if (typeof tree._listeners === 'function') {
            tree._listeners = [tree._listeners];
          }

          tree._listeners.push(listener);

          if (
            !tree._listeners.warned &&
            this._maxListeners > 0 &&
            tree._listeners.length > this._maxListeners
          ) {
            tree._listeners.warned = true;
            logPossibleMemoryLeak.call(this, tree._listeners.length, name);
          }
        }
        return true;
      }
      name = type.shift();
    }
    return true;
  }

  // By default EventEmitters will print a warning if more than
  // 10 listeners are added to it. This is a useful default which
  // helps finding memory leaks.
  //
  // Obviously not all Emitters should be limited to 10. This function allows
  // that to be increased. Set to zero for unlimited.

  EventEmitter.prototype.delimiter = '.';

  EventEmitter.prototype.setMaxListeners = function(n) {
    if (n !== undefined) {
      this._maxListeners = n;
      if (!this._conf) this._conf = {};
      this._conf.maxListeners = n;
    }
  };

  EventEmitter.prototype.event = '';


  EventEmitter.prototype.once = function(event, fn) {
    return this._once(event, fn, false);
  };

  EventEmitter.prototype.prependOnceListener = function(event, fn) {
    return this._once(event, fn, true);
  };

  EventEmitter.prototype._once = function(event, fn, prepend) {
    this._many(event, 1, fn, prepend);
    return this;
  };

  EventEmitter.prototype.many = function(event, ttl, fn) {
    return this._many(event, ttl, fn, false);
  }

  EventEmitter.prototype.prependMany = function(event, ttl, fn) {
    return this._many(event, ttl, fn, true);
  }

  EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
    var self = this;

    if (typeof fn !== 'function') {
      throw new Error('many only accepts instances of Function');
    }

    function listener() {
      if (--ttl === 0) {
        self.off(event, listener);
      }
      return fn.apply(this, arguments);
    }

    listener._origin = fn;

    this._on(event, listener, prepend);

    return self;
  };

  EventEmitter.prototype.emit = function() {

    this._events || init.call(this);

    var type = arguments[0];

    if (type === 'newListener' && !this.newListener) {
      if (!this._events.newListener) {
        return false;
      }
    }

    var al = arguments.length;
    var args,l,i,j;
    var handler;

    if (this._all && this._all.length) {
      handler = this._all.slice();
      if (al > 3) {
        args = new Array(al);
        for (j = 0; j < al; j++) args[j] = arguments[j];
      }

      for (i = 0, l = handler.length; i < l; i++) {
        this.event = type;
        switch (al) {
        case 1:
          handler[i].call(this, type);
          break;
        case 2:
          handler[i].call(this, type, arguments[1]);
          break;
        case 3:
          handler[i].call(this, type, arguments[1], arguments[2]);
          break;
        default:
          handler[i].apply(this, args);
        }
      }
    }

    if (this.wildcard) {
      handler = [];
      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
      searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
    } else {
      handler = this._events[type];
      if (typeof handler === 'function') {
        this.event = type;
        switch (al) {
        case 1:
          handler.call(this);
          break;
        case 2:
          handler.call(this, arguments[1]);
          break;
        case 3:
          handler.call(this, arguments[1], arguments[2]);
          break;
        default:
          args = new Array(al - 1);
          for (j = 1; j < al; j++) args[j - 1] = arguments[j];
          handler.apply(this, args);
        }
        return true;
      } else if (handler) {
        // need to make copy of handlers because list can change in the middle
        // of emit call
        handler = handler.slice();
      }
    }

    if (handler && handler.length) {
      if (al > 3) {
        args = new Array(al - 1);
        for (j = 1; j < al; j++) args[j - 1] = arguments[j];
      }
      for (i = 0, l = handler.length; i < l; i++) {
        this.event = type;
        switch (al) {
        case 1:
          handler[i].call(this);
          break;
        case 2:
          handler[i].call(this, arguments[1]);
          break;
        case 3:
          handler[i].call(this, arguments[1], arguments[2]);
          break;
        default:
          handler[i].apply(this, args);
        }
      }
      return true;
    } else if (!this._all && type === 'error') {
      if (arguments[1] instanceof Error) {
        throw arguments[1]; // Unhandled 'error' event
      } else {
        throw new Error("Uncaught, unspecified 'error' event.");
      }
      return false;
    }

    return !!this._all;
  };

  EventEmitter.prototype.emitAsync = function() {

    this._events || init.call(this);

    var type = arguments[0];

    if (type === 'newListener' && !this.newListener) {
        if (!this._events.newListener) { return Promise.resolve([false]); }
    }

    var promises= [];

    var al = arguments.length;
    var args,l,i,j;
    var handler;

    if (this._all) {
      if (al > 3) {
        args = new Array(al);
        for (j = 1; j < al; j++) args[j] = arguments[j];
      }
      for (i = 0, l = this._all.length; i < l; i++) {
        this.event = type;
        switch (al) {
        case 1:
          promises.push(this._all[i].call(this, type));
          break;
        case 2:
          promises.push(this._all[i].call(this, type, arguments[1]));
          break;
        case 3:
          promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
          break;
        default:
          promises.push(this._all[i].apply(this, args));
        }
      }
    }

    if (this.wildcard) {
      handler = [];
      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
      searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
    } else {
      handler = this._events[type];
    }

    if (typeof handler === 'function') {
      this.event = type;
      switch (al) {
      case 1:
        promises.push(handler.call(this));
        break;
      case 2:
        promises.push(handler.call(this, arguments[1]));
        break;
      case 3:
        promises.push(handler.call(this, arguments[1], arguments[2]));
        break;
      default:
        args = new Array(al - 1);
        for (j = 1; j < al; j++) args[j - 1] = arguments[j];
        promises.push(handler.apply(this, args));
      }
    } else if (handler && handler.length) {
      handler = handler.slice();
      if (al > 3) {
        args = new Array(al - 1);
        for (j = 1; j < al; j++) args[j - 1] = arguments[j];
      }
      for (i = 0, l = handler.length; i < l; i++) {
        this.event = type;
        switch (al) {
        case 1:
          promises.push(handler[i].call(this));
          break;
        case 2:
          promises.push(handler[i].call(this, arguments[1]));
          break;
        case 3:
          promises.push(handler[i].call(this, arguments[1], arguments[2]));
          break;
        default:
          promises.push(handler[i].apply(this, args));
        }
      }
    } else if (!this._all && type === 'error') {
      if (arguments[1] instanceof Error) {
        return Promise.reject(arguments[1]); // Unhandled 'error' event
      } else {
        return Promise.reject("Uncaught, unspecified 'error' event.");
      }
    }

    return Promise.all(promises);
  };

  EventEmitter.prototype.on = function(type, listener) {
    return this._on(type, listener, false);
  };

  EventEmitter.prototype.prependListener = function(type, listener) {
    return this._on(type, listener, true);
  };

  EventEmitter.prototype.onAny = function(fn) {
    return this._onAny(fn, false);
  };

  EventEmitter.prototype.prependAny = function(fn) {
    return this._onAny(fn, true);
  };

  EventEmitter.prototype.addListener = EventEmitter.prototype.on;

  EventEmitter.prototype._onAny = function(fn, prepend){
    if (typeof fn !== 'function') {
      throw new Error('onAny only accepts instances of Function');
    }

    if (!this._all) {
      this._all = [];
    }

    // Add the function to the event listener collection.
    if(prepend){
      this._all.unshift(fn);
    }else{
      this._all.push(fn);
    }

    return this;
  }

  EventEmitter.prototype._on = function(type, listener, prepend) {
    if (typeof type === 'function') {
      this._onAny(type, listener);
      return this;
    }

    if (typeof listener !== 'function') {
      throw new Error('on only accepts instances of Function');
    }
    this._events || init.call(this);

    // To avoid recursion in the case that type == "newListeners"! Before
    // adding it to the listeners, first emit "newListeners".
    this.emit('newListener', type, listener);

    if (this.wildcard) {
      growListenerTree.call(this, type, listener);
      return this;
    }

    if (!this._events[type]) {
      // Optimize the case of one listener. Don't need the extra array object.
      this._events[type] = listener;
    }
    else {
      if (typeof this._events[type] === 'function') {
        // Change to array.
        this._events[type] = [this._events[type]];
      }

      // If we've already got an array, just add
      if(prepend){
        this._events[type].unshift(listener);
      }else{
        this._events[type].push(listener);
      }

      // Check for listener leak
      if (
        !this._events[type].warned &&
        this._maxListeners > 0 &&
        this._events[type].length > this._maxListeners
      ) {
        this._events[type].warned = true;
        logPossibleMemoryLeak.call(this, this._events[type].length, type);
      }
    }

    return this;
  }

  EventEmitter.prototype.off = function(type, listener) {
    if (typeof listener !== 'function') {
      throw new Error('removeListener only takes instances of Function');
    }

    var handlers,leafs=[];

    if(this.wildcard) {
      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
      leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
    }
    else {
      // does not use listeners(), so no side effect of creating _events[type]
      if (!this._events[type]) return this;
      handlers = this._events[type];
      leafs.push({_listeners:handlers});
    }

    for (var iLeaf=0; iLeaf<leafs.length; iLeaf++) {
      var leaf = leafs[iLeaf];
      handlers = leaf._listeners;
      if (isArray(handlers)) {

        var position = -1;

        for (var i = 0, length = handlers.length; i < length; i++) {
          if (handlers[i] === listener ||
            (handlers[i].listener && handlers[i].listener === listener) ||
            (handlers[i]._origin && handlers[i]._origin === listener)) {
            position = i;
            break;
          }
        }

        if (position < 0) {
          continue;
        }

        if(this.wildcard) {
          leaf._listeners.splice(position, 1);
        }
        else {
          this._events[type].splice(position, 1);
        }

        if (handlers.length === 0) {
          if(this.wildcard) {
            delete leaf._listeners;
          }
          else {
            delete this._events[type];
          }
        }

        this.emit("removeListener", type, listener);

        return this;
      }
      else if (handlers === listener ||
        (handlers.listener && handlers.listener === listener) ||
        (handlers._origin && handlers._origin === listener)) {
        if(this.wildcard) {
          delete leaf._listeners;
        }
        else {
          delete this._events[type];
        }

        this.emit("removeListener", type, listener);
      }
    }

    function recursivelyGarbageCollect(root) {
      if (root === undefined) {
        return;
      }
      var keys = Object.keys(root);
      for (var i in keys) {
        var key = keys[i];
        var obj = root[key];
        if ((obj instanceof Function) || (typeof obj !== "object") || (obj === null))
          continue;
        if (Object.keys(obj).length > 0) {
          recursivelyGarbageCollect(root[key]);
        }
        if (Object.keys(obj).length === 0) {
          delete root[key];
        }
      }
    }
    recursivelyGarbageCollect(this.listenerTree);

    return this;
  };

  EventEmitter.prototype.offAny = function(fn) {
    var i = 0, l = 0, fns;
    if (fn && this._all && this._all.length > 0) {
      fns = this._all;
      for(i = 0, l = fns.length; i < l; i++) {
        if(fn === fns[i]) {
          fns.splice(i, 1);
          this.emit("removeListenerAny", fn);
          return this;
        }
      }
    } else {
      fns = this._all;
      for(i = 0, l = fns.length; i < l; i++)
        this.emit("removeListenerAny", fns[i]);
      this._all = [];
    }
    return this;
  };

  EventEmitter.prototype.removeListener = EventEmitter.prototype.off;

  EventEmitter.prototype.removeAllListeners = function(type) {
    if (arguments.length === 0) {
      !this._events || init.call(this);
      return this;
    }

    if (this.wildcard) {
      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
      var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);

      for (var iLeaf=0; iLeaf<leafs.length; iLeaf++) {
        var leaf = leafs[iLeaf];
        leaf._listeners = null;
      }
    }
    else if (this._events) {
      this._events[type] = null;
    }
    return this;
  };

  EventEmitter.prototype.listeners = function(type) {
    if (this.wildcard) {
      var handlers = [];
      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
      searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
      return handlers;
    }

    this._events || init.call(this);

    if (!this._events[type]) this._events[type] = [];
    if (!isArray(this._events[type])) {
      this._events[type] = [this._events[type]];
    }
    return this._events[type];
  };

  EventEmitter.prototype.eventNames = function(){
    return Object.keys(this._events);
  }

  EventEmitter.prototype.listenerCount = function(type) {
    return this.listeners(type).length;
  };

  EventEmitter.prototype.listenersAny = function() {

    if(this._all) {
      return this._all;
    }
    else {
      return [];
    }

  };

  if (true) {
     // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return EventEmitter;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // CommonJS
    module.exports = EventEmitter;
  }
  else {
    // Browser global.
    window.EventEmitter2 = EventEmitter;
  }
}();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(122)))

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Emoji */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_tooltip__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_cross_circle__ = __webpack_require__(2916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_cross_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_cross_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__type_helpers__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_mouse__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_EmojiUtils__ = __webpack_require__(229);












var handleMouseDown = function (props, event) {
    // Clicked emoji delete button
    if (event.target instanceof Element &&
        event.target.getAttribute('aria-label') === __WEBPACK_IMPORTED_MODULE_9__constants__["i" /* deleteEmojiLabel */]) {
        return;
    }
    var emoji = props.emoji, onSelected = props.onSelected;
    event.preventDefault();
    if (onSelected && Object(__WEBPACK_IMPORTED_MODULE_10__util_mouse__["b" /* leftClick */])(event)) {
        onSelected(Object(__WEBPACK_IMPORTED_MODULE_8__type_helpers__["o" /* toEmojiId */])(emoji), emoji, event);
    }
};
var handleMouseMove = function (props, event) {
    var emoji = props.emoji, onMouseMove = props.onMouseMove;
    if (onMouseMove) {
        onMouseMove(Object(__WEBPACK_IMPORTED_MODULE_8__type_helpers__["o" /* toEmojiId */])(emoji), emoji, event);
    }
};
var handleDelete = function (props, event) {
    var emoji = props.emoji, onDelete = props.onDelete;
    if (onDelete) {
        onDelete(Object(__WEBPACK_IMPORTED_MODULE_8__type_helpers__["o" /* toEmojiId */])(emoji), emoji, event);
    }
};
var handleImageError = function (props, event) {
    var emoji = props.emoji, onLoadError = props.onLoadError;
    // Hide error state (but keep space for it)
    if (event.target) {
        var target = event.target;
        target.style.visibility = 'hidden';
    }
    if (onLoadError) {
        onLoadError(Object(__WEBPACK_IMPORTED_MODULE_8__type_helpers__["o" /* toEmojiId */])(emoji), emoji, event);
    }
};
// Pure functional components are used in favour of class based components, due to the performance!
// When rendering 1500+ emoji using class based components had a significant impact.
var renderAsSprite = function (props) {
    var _a;
    var emoji = props.emoji, fitToHeight = props.fitToHeight, selected = props.selected, selectOnHover = props.selectOnHover, className = props.className, showTooltip = props.showTooltip;
    var representation = emoji.representation;
    var sprite = representation.sprite;
    var classes = (_a = {},
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["n" /* emojiContainer */]] = true,
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["p" /* emojiNode */]] = true,
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["G" /* selected */]] = selected,
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["F" /* selectOnHover */]] = selectOnHover,
        _a);
    if (className) {
        classes[className] = true;
    }
    var sizing = {};
    if (fitToHeight) {
        sizing = {
            width: fitToHeight + "px",
            height: fitToHeight + "px",
        };
    }
    var xPositionInPercent = (100 / (sprite.column - 1)) * (representation.xIndex - 0);
    var yPositionInPercent = (100 / (sprite.row - 1)) * (representation.yIndex - 0);
    var style = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ backgroundImage: "url(" + sprite.url + ")", backgroundPosition: xPositionInPercent + "% " + yPositionInPercent + "%", backgroundSize: sprite.column * 100 + "% " + sprite.row * 100 + "%" }, sizing);
    var emojiNode = (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_7__styles__["u" /* emojiSprite */], style: style }, "\u00A0"));
    return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(classes), 
        // tslint:disable-next-line:jsx-no-lambda
        onMouseDown: function (event) {
            handleMouseDown(props, event);
        }, 
        // tslint:disable-next-line:jsx-no-lambda
        onMouseMove: function (event) {
            handleMouseMove(props, event);
        }, "aria-label": emoji.shortName }, showTooltip ? (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_tooltip__["a" /* default */], { tag: "span", content: emoji.shortName }, emojiNode)) : (emojiNode)));
};
// Keep as pure functional component, see renderAsSprite.
var renderAsImage = function (props) {
    var _a;
    var emoji = props.emoji, fitToHeight = props.fitToHeight, selected = props.selected, selectOnHover = props.selectOnHover, className = props.className, showTooltip = props.showTooltip, showDelete = props.showDelete;
    var classes = (_a = {},
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["k" /* emoji */]] = true,
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["p" /* emojiNode */]] = true,
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["G" /* selected */]] = selected,
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["F" /* selectOnHover */]] = selectOnHover,
        _a);
    if (className) {
        classes[className] = true;
    }
    var width;
    var height;
    var src;
    var representation = Object(__WEBPACK_IMPORTED_MODULE_11__api_EmojiUtils__["d" /* shouldUseAltRepresentation */])(emoji, fitToHeight)
        ? emoji.altRepresentation
        : emoji.representation;
    if (Object(__WEBPACK_IMPORTED_MODULE_8__type_helpers__["h" /* isImageRepresentation */])(representation)) {
        src = representation.imagePath;
        width = representation.width;
        height = representation.height;
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_8__type_helpers__["k" /* isMediaRepresentation */])(representation)) {
        src = representation.mediaPath;
        width = representation.width;
        height = representation.height;
    }
    var deleteButton;
    if (showDelete) {
        deleteButton = (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_7__styles__["g" /* deleteButton */] },
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__atlaskit_button__["default"], { iconBefore: __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_cross_circle___default.a, { label: __WEBPACK_IMPORTED_MODULE_9__constants__["i" /* deleteEmojiLabel */], primaryColor: __WEBPACK_IMPORTED_MODULE_6__atlaskit_theme__["colors"].N500, size: "small" }), onClick: function (event) { return handleDelete(props, event); }, appearance: "subtle-link", spacing: "none" })));
    }
    var sizing = {};
    if (fitToHeight && width && height) {
        // Presize image, to prevent reflow due to size changes after loading
        sizing = {
            width: (fitToHeight / height) * width,
            height: fitToHeight,
        };
    }
    var onError = function (event) {
        handleImageError(props, event);
    };
    // Pass src attribute as key to force React to rerender img node since browser does not
    // change preview image until loaded
    var emojiNode = (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("img", __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ src: src, key: src, alt: emoji.shortName, style: { visibility: 'visible' }, onError: onError }, sizing)));
    return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(classes), 
        // tslint:disable-next-line:jsx-no-lambda
        onMouseDown: function (event) {
            handleMouseDown(props, event);
        }, 
        // tslint:disable-next-line:jsx-no-lambda
        onMouseMove: function (event) {
            handleMouseMove(props, event);
        }, "aria-label": emoji.shortName },
        deleteButton,
        showTooltip ? (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_tooltip__["a" /* default */], { tag: "span", content: emoji.shortName }, emojiNode)) : (emojiNode)));
};
// tslint:disable-next-line:variable-name
var Emoji = function (props) {
    var emoji = props.emoji;
    if (Object(__WEBPACK_IMPORTED_MODULE_8__type_helpers__["m" /* isSpriteRepresentation */])(emoji.representation)) {
        return renderAsSprite(props);
    }
    return renderAsImage(props);
};
/* harmony default export */ __webpack_exports__["a"] = (Emoji);
//# sourceMappingURL=Emoji.js.map

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Emoji */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_tooltip__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_cross_circle__ = __webpack_require__(2989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_cross_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_cross_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__type_helpers__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_mouse__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_EmojiUtils__ = __webpack_require__(231);












var handleMouseDown = function (props, event) {
    // Clicked emoji delete button
    if (event.target instanceof Element &&
        event.target.getAttribute('aria-label') === __WEBPACK_IMPORTED_MODULE_9__constants__["i" /* deleteEmojiLabel */]) {
        return;
    }
    var emoji = props.emoji, onSelected = props.onSelected;
    event.preventDefault();
    if (onSelected && Object(__WEBPACK_IMPORTED_MODULE_10__util_mouse__["b" /* leftClick */])(event)) {
        onSelected(Object(__WEBPACK_IMPORTED_MODULE_8__type_helpers__["o" /* toEmojiId */])(emoji), emoji, event);
    }
};
var handleMouseMove = function (props, event) {
    var emoji = props.emoji, onMouseMove = props.onMouseMove;
    if (onMouseMove) {
        onMouseMove(Object(__WEBPACK_IMPORTED_MODULE_8__type_helpers__["o" /* toEmojiId */])(emoji), emoji, event);
    }
};
var handleDelete = function (props, event) {
    var emoji = props.emoji, onDelete = props.onDelete;
    if (onDelete) {
        onDelete(Object(__WEBPACK_IMPORTED_MODULE_8__type_helpers__["o" /* toEmojiId */])(emoji), emoji, event);
    }
};
var handleImageError = function (props, event) {
    var emoji = props.emoji, onLoadError = props.onLoadError;
    // Hide error state (but keep space for it)
    if (event.target) {
        var target = event.target;
        target.style.visibility = 'hidden';
    }
    if (onLoadError) {
        onLoadError(Object(__WEBPACK_IMPORTED_MODULE_8__type_helpers__["o" /* toEmojiId */])(emoji), emoji, event);
    }
};
// Pure functional components are used in favour of class based components, due to the performance!
// When rendering 1500+ emoji using class based components had a significant impact.
var renderAsSprite = function (props) {
    var _a;
    var emoji = props.emoji, fitToHeight = props.fitToHeight, selected = props.selected, selectOnHover = props.selectOnHover, className = props.className, showTooltip = props.showTooltip;
    var representation = emoji.representation;
    var sprite = representation.sprite;
    var classes = (_a = {},
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["n" /* emojiContainer */]] = true,
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["p" /* emojiNode */]] = true,
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["G" /* selected */]] = selected,
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["F" /* selectOnHover */]] = selectOnHover,
        _a);
    if (className) {
        classes[className] = true;
    }
    var sizing = {};
    if (fitToHeight) {
        sizing = {
            width: fitToHeight + "px",
            height: fitToHeight + "px",
        };
    }
    var xPositionInPercent = (100 / (sprite.column - 1)) * (representation.xIndex - 0);
    var yPositionInPercent = (100 / (sprite.row - 1)) * (representation.yIndex - 0);
    var style = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ backgroundImage: "url(" + sprite.url + ")", backgroundPosition: xPositionInPercent + "% " + yPositionInPercent + "%", backgroundSize: sprite.column * 100 + "% " + sprite.row * 100 + "%" }, sizing);
    var emojiNode = (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_7__styles__["u" /* emojiSprite */], style: style }, "\u00A0"));
    return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(classes), 
        // tslint:disable-next-line:jsx-no-lambda
        onMouseDown: function (event) {
            handleMouseDown(props, event);
        }, 
        // tslint:disable-next-line:jsx-no-lambda
        onMouseMove: function (event) {
            handleMouseMove(props, event);
        }, "aria-label": emoji.shortName }, showTooltip ? (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_tooltip__["a" /* default */], { tag: "span", content: emoji.shortName }, emojiNode)) : (emojiNode)));
};
// Keep as pure functional component, see renderAsSprite.
var renderAsImage = function (props) {
    var _a;
    var emoji = props.emoji, fitToHeight = props.fitToHeight, selected = props.selected, selectOnHover = props.selectOnHover, className = props.className, showTooltip = props.showTooltip, showDelete = props.showDelete;
    var classes = (_a = {},
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["k" /* emoji */]] = true,
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["p" /* emojiNode */]] = true,
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["G" /* selected */]] = selected,
        _a[__WEBPACK_IMPORTED_MODULE_7__styles__["F" /* selectOnHover */]] = selectOnHover,
        _a);
    if (className) {
        classes[className] = true;
    }
    var width;
    var height;
    var src;
    var representation = Object(__WEBPACK_IMPORTED_MODULE_11__api_EmojiUtils__["d" /* shouldUseAltRepresentation */])(emoji, fitToHeight)
        ? emoji.altRepresentation
        : emoji.representation;
    if (Object(__WEBPACK_IMPORTED_MODULE_8__type_helpers__["h" /* isImageRepresentation */])(representation)) {
        src = representation.imagePath;
        width = representation.width;
        height = representation.height;
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_8__type_helpers__["k" /* isMediaRepresentation */])(representation)) {
        src = representation.mediaPath;
        width = representation.width;
        height = representation.height;
    }
    var deleteButton;
    if (showDelete) {
        deleteButton = (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_7__styles__["g" /* deleteButton */] },
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__atlaskit_button__["default"], { iconBefore: __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_cross_circle___default.a, { label: __WEBPACK_IMPORTED_MODULE_9__constants__["i" /* deleteEmojiLabel */], primaryColor: __WEBPACK_IMPORTED_MODULE_6__atlaskit_theme__["colors"].N500, size: "small" }), onClick: function (event) { return handleDelete(props, event); }, appearance: "subtle-link", spacing: "none" })));
    }
    var sizing = {};
    if (fitToHeight && width && height) {
        // Presize image, to prevent reflow due to size changes after loading
        sizing = {
            width: (fitToHeight / height) * width,
            height: fitToHeight,
        };
    }
    var onError = function (event) {
        handleImageError(props, event);
    };
    // Pass src attribute as key to force React to rerender img node since browser does not
    // change preview image until loaded
    var emojiNode = (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("img", __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ src: src, key: src, alt: emoji.shortName, style: { visibility: 'visible' }, onError: onError }, sizing)));
    return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_1_classnames__(classes), 
        // tslint:disable-next-line:jsx-no-lambda
        onMouseDown: function (event) {
            handleMouseDown(props, event);
        }, 
        // tslint:disable-next-line:jsx-no-lambda
        onMouseMove: function (event) {
            handleMouseMove(props, event);
        }, "aria-label": emoji.shortName },
        deleteButton,
        showTooltip ? (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_tooltip__["a" /* default */], { tag: "span", content: emoji.shortName }, emojiNode)) : (emojiNode)));
};
// tslint:disable-next-line:variable-name
var Emoji = function (props) {
    var emoji = props.emoji;
    if (Object(__WEBPACK_IMPORTED_MODULE_8__type_helpers__["m" /* isSpriteRepresentation */])(emoji.representation)) {
        return renderAsSprite(props);
    }
    return renderAsImage(props);
};
/* harmony default export */ __webpack_exports__["a"] = (Emoji);
//# sourceMappingURL=Emoji.js.map

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(645);
var util = __webpack_require__(1739);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(647);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export emojiPickerListWidth */
/* unused harmony export emojiPickerListHeight */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return emojiPickerBorderColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return emojiPickerBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return emojiFooterBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return noDialogContainerBorderColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return noDialogContainerBorderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return noDialogContainerBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return akEmojiSelectedBackgroundColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return emojiPreviewSelectedColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return emojiTypeAheadMaxHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return emojiTypeAheadWidth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(69);


var emojiPickerListWidth = __WEBPACK_IMPORTED_MODULE_1__constants__["k" /* emojiPickerWidth */];
var emojiPickerListHeight = 205;
var emojiPickerBorderColor = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N40; // This has not been confirmed by the ADG yet
var emojiPickerBoxShadow = '0 3px 6px rgba(0, 0, 0, 0.2)';
var emojiFooterBoxShadow = '0px -1px 1px 0px rgba(0, 0, 0, 0.1)';
var noDialogContainerBorderColor = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N40; // This has not been confirmed by the ADG yet
var noDialogContainerBorderRadius = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["borderRadius"])() + "px";
var noDialogContainerBoxShadow = '0 3px 6px rgba(0, 0, 0, 0.2)';
var akEmojiSelectedBackgroundColor = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N30;
var emojiPreviewSelectedColor = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N30;
var emojiTypeAheadMaxHeight = 350;
var emojiTypeAheadWidth = 350;
//# sourceMappingURL=shared-styles.js.map

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchSort; });
var SearchSort;
(function (SearchSort) {
    // no sort - just the default ordering of emoji
    SearchSort[SearchSort["None"] = 0] = "None";
    // a sort taking into account a number of factors including, usage, closeness of match to the query, etc
    SearchSort[SearchSort["Default"] = 1] = "Default";
    // sort such that the most frequently used emoji come first, and then standard, service defined ordering is preserved.
    SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
})(SearchSort || (SearchSort = {}));
//# sourceMappingURL=types.js.map

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export emojiPickerListWidth */
/* unused harmony export emojiPickerListHeight */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return emojiPickerBorderColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return emojiPickerBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return emojiFooterBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return noDialogContainerBorderColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return noDialogContainerBorderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return noDialogContainerBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return akEmojiSelectedBackgroundColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return emojiPreviewSelectedColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return emojiTypeAheadMaxHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return emojiTypeAheadWidth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(70);


var emojiPickerListWidth = __WEBPACK_IMPORTED_MODULE_1__constants__["k" /* emojiPickerWidth */];
var emojiPickerListHeight = 205;
var emojiPickerBorderColor = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N40; // This has not been confirmed by the ADG yet
var emojiPickerBoxShadow = '0 3px 6px rgba(0, 0, 0, 0.2)';
var emojiFooterBoxShadow = '0px -1px 1px 0px rgba(0, 0, 0, 0.1)';
var noDialogContainerBorderColor = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N40; // This has not been confirmed by the ADG yet
var noDialogContainerBorderRadius = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["borderRadius"])() + "px";
var noDialogContainerBoxShadow = '0 3px 6px rgba(0, 0, 0, 0.2)';
var akEmojiSelectedBackgroundColor = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N30;
var emojiPreviewSelectedColor = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N30;
var emojiTypeAheadMaxHeight = 350;
var emojiTypeAheadWidth = 350;
//# sourceMappingURL=shared-styles.js.map

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchSort; });
var SearchSort;
(function (SearchSort) {
    // no sort - just the default ordering of emoji
    SearchSort[SearchSort["None"] = 0] = "None";
    // a sort taking into account a number of factors including, usage, closeness of match to the query, etc
    SearchSort[SearchSort["Default"] = 1] = "Default";
    // sort such that the most frequently used emoji come first, and then standard, service defined ordering is preserved.
    SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
})(SearchSort || (SearchSort = {}));
//# sourceMappingURL=types.js.map

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export emojiPickerListWidth */
/* unused harmony export emojiPickerListHeight */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return emojiPickerBorderColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return emojiPickerBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return emojiFooterBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return noDialogContainerBorderColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return noDialogContainerBorderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return noDialogContainerBoxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return akEmojiSelectedBackgroundColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return emojiPreviewSelectedColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return emojiTypeAheadMaxHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return emojiTypeAheadWidth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(71);


var emojiPickerListWidth = __WEBPACK_IMPORTED_MODULE_1__constants__["k" /* emojiPickerWidth */];
var emojiPickerListHeight = 205;
var emojiPickerBorderColor = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N40; // This has not been confirmed by the ADG yet
var emojiPickerBoxShadow = '0 3px 6px rgba(0, 0, 0, 0.2)';
var emojiFooterBoxShadow = '0px -1px 1px 0px rgba(0, 0, 0, 0.1)';
var noDialogContainerBorderColor = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N40; // This has not been confirmed by the ADG yet
var noDialogContainerBorderRadius = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["borderRadius"])() + "px";
var noDialogContainerBoxShadow = '0 3px 6px rgba(0, 0, 0, 0.2)';
var akEmojiSelectedBackgroundColor = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N30;
var emojiPreviewSelectedColor = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N30;
var emojiTypeAheadMaxHeight = 350;
var emojiTypeAheadWidth = 350;
//# sourceMappingURL=shared-styles.js.map

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchSort; });
var SearchSort;
(function (SearchSort) {
    // no sort - just the default ordering of emoji
    SearchSort[SearchSort["None"] = 0] = "None";
    // a sort taking into account a number of factors including, usage, closeness of match to the query, etc
    SearchSort[SearchSort["Default"] = 1] = "Default";
    // sort such that the most frequently used emoji come first, and then standard, service defined ordering is preserved.
    SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
})(SearchSort || (SearchSort = {}));
//# sourceMappingURL=types.js.map

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1500), __esModule: true };

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(143);
var document = __webpack_require__(110).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(259);
var createDesc = __webpack_require__(257);
var toIObject = __webpack_require__(146);
var toPrimitive = __webpack_require__(358);
var has = __webpack_require__(129);
var IE8_DOM_DEFINE = __webpack_require__(604);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(124) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NodeResolver = __webpack_require__(1744);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_NodeResolver).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popper__ = __webpack_require__(1747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Manager__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reference__ = __webpack_require__(1753);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["a"]; });
/* unused harmony reexport placements */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Manager__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Reference__["a"]; });


// Public components





// Public types

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(658);
var bytesToUuid = __webpack_require__(659);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getEmojiVariation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_search__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__type_helpers__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_Comparators__ = __webpack_require__(1829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_UsageFrequencyTracker__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EmojiRepositoryRegex__ = __webpack_require__(1831);








// FS-1097 - duplicated in mentions - extract at some point into a shared library
var Tokenizer = /** @class */ (function () {
    function Tokenizer() {
    }
    Tokenizer.tokenize = function (text) {
        return this.tokenizeAsTokens(text).map(function (token) { return token.token; });
    };
    Tokenizer.tokenizeAsTokens = function (text) {
        var match;
        var tokens = [];
        __WEBPACK_IMPORTED_MODULE_7__EmojiRepositoryRegex__["a" /* tokenizerRegex */].lastIndex = 0;
        while ((match = __WEBPACK_IMPORTED_MODULE_7__EmojiRepositoryRegex__["a" /* tokenizerRegex */].exec(text)) !== null) {
            if (match[0]) {
                tokens.push({
                    token: match[0],
                    start: match.index,
                });
            }
        }
        return tokens;
    };
    return Tokenizer;
}());
var addAllVariants = function (emoji, fnKey, map) {
    var key = fnKey(emoji);
    if (!map.has(key)) {
        map.set(key, []);
    }
    var emojisForKey = map.get(key);
    // Unnecessary, but typescript thinks it is. :/
    if (emojisForKey) {
        emojisForKey.push(emoji);
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_4__type_helpers__["f" /* isEmojiDescriptionWithVariations */])(emoji)) {
        // map variations too
        var variations = emoji.skinVariations;
        if (variations) {
            variations.forEach(function (variation) { return addAllVariants(variation, fnKey, map); });
        }
    }
};
var findByKey = function (map, key) {
    var emojis = map.get(key);
    if (emojis && emojis.length) {
        // Priority is always to source from the last emoji set (last overrides first)
        return emojis[emojis.length - 1];
    }
    return undefined;
};
var splitQuery = function (query) {
    if (query === void 0) { query = ''; }
    var isColonQuery = query.indexOf(':') === 0;
    if (isColonQuery) {
        return {
            nameQuery: query.slice(1),
            asciiQuery: query,
        };
    }
    return {
        nameQuery: query,
        asciiQuery: '',
    };
};
var getEmojiVariation = function (emoji, options) {
    if (Object(__WEBPACK_IMPORTED_MODULE_4__type_helpers__["f" /* isEmojiDescriptionWithVariations */])(emoji) && options) {
        var skinTone = options.skinTone;
        if (skinTone && emoji.skinVariations && emoji.skinVariations.length) {
            var skinToneEmoji = emoji.skinVariations[skinTone - 1]; // skinTone start at 1
            if (skinToneEmoji) {
                return skinToneEmoji;
            }
        }
    }
    return emoji;
};
var findEmojiIndex = function (emojis, toFind) {
    var findId = toFind.id;
    var match = -1;
    emojis.forEach(function (emoji, index) {
        // Match if ID is defined and are equal
        // Or both have no id and shortnames match
        if ((emoji.id && emoji.id === findId) ||
            (!emoji.id && !findId && emoji.shortName === toFind.shortName)) {
            match = index;
            return;
        }
    });
    return match;
};
var EmojiRepository = /** @class */ (function () {
    function EmojiRepository(emojis, usageTracker) {
        this.emojis = emojis;
        this.initMembers(usageTracker);
    }
    /**
     * Returns all available (and searchable) emoji in some default order.
     */
    EmojiRepository.prototype.all = function () {
        var options = {
            sort: __WEBPACK_IMPORTED_MODULE_3__types__["a" /* SearchSort */].None,
        };
        return this.search('', options);
    };
    /**
     * Text search of emoji shortName and name field for suitable matches.
     *
     * Returns an array of all (searchable) emoji if query is empty or null, otherwise returns matching emoji.
     *
     * You can change how the results are sorted by specifying a custom EmojiComparator in the SearchOptions. If
     * you don't want any sorting you can also disable via the SearchOptions (this might be a useful optimisation).
     * If no sort is specified in SearchOptions then a default sorting it applied based on the query.
     */
    EmojiRepository.prototype.search = function (query, options) {
        var filteredEmoji = [];
        var _a = splitQuery(query), nameQuery = _a.nameQuery, asciiQuery = _a.asciiQuery;
        if (nameQuery) {
            filteredEmoji = this.fullSearch.search(nameQuery);
            if (asciiQuery) {
                filteredEmoji = this.withAsciiMatch(asciiQuery, filteredEmoji);
            }
        }
        else {
            filteredEmoji = this.getAllSearchableEmojis();
        }
        filteredEmoji = this.applySearchOptions(filteredEmoji, query, options);
        return {
            emojis: filteredEmoji,
            query: query,
        };
    };
    /**
     * Returns all emoji with matching shortName
     */
    EmojiRepository.prototype.findAllMatchingShortName = function (shortName) {
        return this.shortNameMap.get(shortName) || [];
    };
    /**
     * Returns the first matching emoji matching the shortName, or null if none found.
     */
    EmojiRepository.prototype.findByShortName = function (shortName) {
        return findByKey(this.shortNameMap, shortName);
    };
    /**
     * Returns the first matching emoji matching the id, or null if none found.
     */
    EmojiRepository.prototype.findById = function (id) {
        return findByKey(this.idMap, id);
    };
    EmojiRepository.prototype.findByAsciiRepresentation = function (asciiEmoji) {
        return this.asciiMap.get(asciiEmoji);
    };
    EmojiRepository.prototype.findInCategory = function (categoryId) {
        if (categoryId === __WEBPACK_IMPORTED_MODULE_2__constants__["l" /* frequentCategory */]) {
            return this.getFrequentlyUsed();
        }
        else {
            return this.all().emojis.filter(function (emoji) { return emoji.category === categoryId; });
        }
    };
    EmojiRepository.prototype.addUnknownEmoji = function (emoji) {
        this.emojis = __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](this.emojis, [emoji]);
        this.fullSearch.addDocuments([emoji]);
        this.addToMaps(emoji);
        this.addToDynamicCategories(emoji);
    };
    EmojiRepository.prototype.getAsciiMap = function () {
        return this.asciiMap;
    };
    /**
     * Return the most frequently used emoji, ordered from most frequent to least frequent. Return an empty array if
     * there are none.
     *
     * @param options optional settings to be applied to the set of frequently used emoji
     */
    EmojiRepository.prototype.getFrequentlyUsed = function (options) {
        var _this = this;
        var emojiIds = this.usageTracker.getOrder();
        var emojiResult = emojiIds
            .map(function (id) { return _this.findById(id); })
            .filter(function (e) { return e !== undefined; });
        if (options) {
            emojiResult = this.applySearchOptions(emojiResult, '', options);
        }
        return emojiResult;
    };
    EmojiRepository.prototype.getDynamicCategoryList = function () {
        return this.dynamicCategoryList.slice();
    };
    /**
     * Call this on emoji usage to allow the EmojiRepository to track the usage of emoji (which could be useful
     * in sorting, etc).
     *
     * @param emoji the emoji that was just used
     */
    EmojiRepository.prototype.used = function (emoji) {
        var _this = this;
        this.usageTracker.recordUsage(emoji);
        // If this is the first usage ensure that we update the dynamic categories.
        // This is done in a 'timeout' since the usageTracker call previously also happens in a timeout. This ensures that
        // the frequent category will not appear until the usage has been tracked (avoiding the possibility of an empty
        // frequent category being shown in the picker).
        if (this.dynamicCategoryList.indexOf(__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* frequentCategory */]) === -1) {
            window.setTimeout(function () {
                _this.dynamicCategoryList.push(__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* frequentCategory */]);
            });
        }
    };
    EmojiRepository.prototype.delete = function (emoji) {
        var deletedIndex = findEmojiIndex(this.emojis, emoji);
        if (deletedIndex !== -1) {
            // Remove the deleted emojis from the internal list
            this.emojis.splice(deletedIndex, 1);
            // Reconstruct repository member variables
            this.initMembers(this.usageTracker);
        }
    };
    EmojiRepository.prototype.withAsciiMatch = function (ascii, emojis) {
        var result = emojis;
        var asciiEmoji = this.findByAsciiRepresentation(ascii);
        if (asciiEmoji) {
            // Ensures that the same emoji isn't already in the list
            // If it is, we give precedence to the ascii match
            result = emojis.filter(function (e) { return e.id !== asciiEmoji.id; });
            result = __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"]([asciiEmoji], result);
        }
        return result;
    };
    EmojiRepository.prototype.applySearchOptions = function (emojis, query, options) {
        if (!options) {
            options = {};
        }
        if (options.sort === undefined) {
            options.sort = __WEBPACK_IMPORTED_MODULE_3__types__["a" /* SearchSort */].Default;
        }
        var comparator;
        if (options.sort === __WEBPACK_IMPORTED_MODULE_3__types__["a" /* SearchSort */].Default) {
            comparator = Object(__WEBPACK_IMPORTED_MODULE_5__internal_Comparators__["a" /* createSearchEmojiComparator */])(query, this.usageTracker.getOrder());
        }
        else if (options.sort === __WEBPACK_IMPORTED_MODULE_3__types__["a" /* SearchSort */].UsageFrequency) {
            comparator = Object(__WEBPACK_IMPORTED_MODULE_5__internal_Comparators__["b" /* createUsageOnlyEmojiComparator */])(this.usageTracker.getOrder());
        }
        if (comparator) {
            comparator.compare = comparator.compare.bind(comparator); // TODO bind at a better place
            emojis = emojis.sort(comparator.compare);
        }
        if (options.limit && options.limit > 0) {
            emojis = emojis.slice(0, options.limit);
        }
        if (options.skinTone) {
            return emojis.map(function (emoji) {
                return getEmojiVariation(emoji, options);
            });
        }
        return emojis;
    };
    EmojiRepository.prototype.initMembers = function (usageTracker) {
        this.usageTracker = usageTracker || new __WEBPACK_IMPORTED_MODULE_6__internal_UsageFrequencyTracker__["a" /* UsageFrequencyTracker */]();
        this.initRepositoryMetadata();
        this.initSearchIndex();
    };
    /**
     * Optimisation to initialise all map member variables in single loop over emojis
     */
    EmojiRepository.prototype.initRepositoryMetadata = function () {
        var _this = this;
        this.shortNameMap = new Map();
        this.idMap = new Map();
        this.asciiMap = new Map();
        var categorySet = new Set();
        this.emojis.forEach(function (emoji) {
            categorySet.add(emoji.category);
            _this.addToMaps(emoji);
        });
        if (this.usageTracker.getOrder().length) {
            categorySet.add(__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* frequentCategory */]);
        }
        this.dynamicCategoryList = Array.from(categorySet).filter(function (category) { return __WEBPACK_IMPORTED_MODULE_2__constants__["f" /* defaultCategories */].indexOf(category) === -1; });
    };
    EmojiRepository.prototype.initSearchIndex = function () {
        this.fullSearch = new __WEBPACK_IMPORTED_MODULE_1_js_search__["Search"]('id');
        this.fullSearch.tokenizer = Tokenizer;
        this.fullSearch.searchIndex = new __WEBPACK_IMPORTED_MODULE_1_js_search__["UnorderedSearchIndex"]();
        this.fullSearch.addIndex('name');
        this.fullSearch.addIndex('shortName');
        this.fullSearch.addDocuments(this.getAllSearchableEmojis());
    };
    EmojiRepository.prototype.getAllSearchableEmojis = function () {
        return this.emojis.filter(function (emojiDescription) { return emojiDescription.searchable; });
    };
    EmojiRepository.prototype.addToMaps = function (emoji) {
        var _this = this;
        // Give default value and assign higher weight to Atlassian emojis for logical order when sorting
        if (typeof emoji.order === 'undefined' || emoji.order === -1) {
            emoji.order = EmojiRepository.defaultEmojiWeight;
        }
        if (typeof emoji.id === 'undefined') {
            emoji.id = EmojiRepository.defaultEmojiWeight.toString();
        }
        addAllVariants(emoji, function (e) { return e.shortName; }, this.shortNameMap);
        addAllVariants(emoji, function (e) { return e.id; }, this.idMap);
        if (emoji.ascii) {
            emoji.ascii.forEach(function (a) { return _this.asciiMap.set(a, emoji); });
        }
    };
    EmojiRepository.prototype.addToDynamicCategories = function (emoji) {
        var category = Object(__WEBPACK_IMPORTED_MODULE_4__type_helpers__["e" /* getCategoryId */])(emoji);
        if (__WEBPACK_IMPORTED_MODULE_2__constants__["f" /* defaultCategories */].indexOf(category) === -1 &&
            this.dynamicCategoryList.indexOf(category) === -1) {
            this.dynamicCategoryList.push(category);
        }
    };
    EmojiRepository.defaultEmojiWeight = 1000000;
    return EmojiRepository;
}());
/* harmony default export */ __webpack_exports__["a"] = (EmojiRepository);
//# sourceMappingURL=EmojiRepository.js.map

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(90);
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */
function map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== 'function') {
            throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
        }
        return source.lift(new MapOperator(project, thisArg));
    };
}
exports.map = map;
var MapOperator = (function () {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}());
exports.MapOperator = MapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MapSubscriber = (function (_super) {
    __extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        _super.call(this, destination);
        this.project = project;
        this.count = 0;
        this.thisArg = thisArg || this;
    }
    // NOTE: This looks unoptimized, but it's actually purposefully NOT
    // using try/catch optimizations.
    MapSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=map.js.map

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Status_1 = __webpack_require__(2451);
exports.Status = Status_1.Status;
var StatusPicker_1 = __webpack_require__(2454);
exports.StatusPicker = StatusPicker_1.StatusPicker;
//# sourceMappingURL=index.js.map

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pluginKey */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return openHelpCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return closeHelpCommand; });
/* unused harmony export stopPropagationCommand */
/* unused harmony export createPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_keymap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keymaps__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_HelpDialogLoader__ = __webpack_require__(2484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__quick_insert__ = __webpack_require__(838);









var pluginKey = new __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["PluginKey"]('helpDialogPlugin');
var openHelpCommand = function (tr, dispatch) {
    tr = tr.setMeta(pluginKey, true);
    if (dispatch) {
        dispatch(tr);
    }
};
var closeHelpCommand = function (tr, dispatch) {
    tr = tr.setMeta(pluginKey, false);
    dispatch(tr);
};
var stopPropagationCommand = function (e) { return e.stopPropagation(); };
function createPlugin(dispatch, imageEnabled) {
    return new __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["Plugin"]({
        key: pluginKey,
        state: {
            init: function () {
                return { isVisible: false, imageEnabled: imageEnabled };
            },
            apply: function (tr, value, state) {
                var isVisible = tr.getMeta(pluginKey);
                var currentState = pluginKey.getState(state);
                if (isVisible !== undefined && isVisible !== currentState.isVisible) {
                    var newState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, currentState, { isVisible: isVisible });
                    dispatch(pluginKey, newState);
                    return newState;
                }
                return currentState;
            },
        },
    });
}
var helpDialog = {
    pmPlugins: function () {
        return [
            {
                name: 'helpDialog',
                plugin: function (_a) {
                    var dispatch = _a.dispatch, legacyImageUploadProvider = _a.props.legacyImageUploadProvider;
                    return createPlugin(dispatch, !!legacyImageUploadProvider);
                },
            },
            {
                name: 'helpDialogKeymap',
                plugin: function (_a) {
                    var schema = _a.schema;
                    return keymapPlugin(schema);
                },
            },
        ];
    },
    contentComponent: function (_a) {
        var editorView = _a.editorView, appearance = _a.appearance;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ui_WithPluginState__["a" /* default */], { plugins: {
                helpDialog: pluginKey,
                quickInsert: __WEBPACK_IMPORTED_MODULE_8__quick_insert__["b" /* pluginKey */],
            }, render: function (_a) {
                var _b = _a.helpDialog, helpDialog = _b === void 0 ? {} : _b, quickInsert = _a.quickInsert;
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ui_HelpDialogLoader__["a" /* HelpDialogLoader */], { appearance: appearance, editorView: editorView, isVisible: helpDialog.isVisible, quickInsertEnabled: !!quickInsert, imageEnabled: helpDialog.imageEnabled }));
            } }));
    },
};
var keymapPlugin = function (schema) {
    var list = {};
    __WEBPACK_IMPORTED_MODULE_4__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_4__keymaps__["z" /* openHelp */].common, function (state, dispatch) {
        var tr = state.tr;
        var isVisible = tr.getMeta(pluginKey);
        if (!isVisible) {
            __WEBPACK_IMPORTED_MODULE_5__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.help.keyboard');
            openHelpCommand(tr, dispatch);
        }
        return true;
    }, list);
    return Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_keymap__["keymap"])(list);
};
/* harmony default export */ __webpack_exports__["b"] = (helpDialog);
//# sourceMappingURL=index.js.map

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react__["createContext"](undefined));
//# sourceMappingURL=Context.js.map

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_card_cardLoader__ = __webpack_require__(2605);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__root_card_cardLoader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_cardViewLoader__ = __webpack_require__(2627);
/* unused harmony reexport CardView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__root_domain__ = __webpack_require__(1398);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_identifier__ = __webpack_require__(1400);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__utils_identifier__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1372);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__utils__["a"]; });
// the only components we expose to consumers is Card and CardView





//# sourceMappingURL=index.js.map

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_droplist__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);





/**
 * Wrapper around @atlaskit/droplist which uses Popup and Portal to render
 * droplist outside of "overflow: hidden" containers when needed.
 *
 * Also it controls popper's placement.
 */
var Dropdown = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Dropdown, _super);
    function Dropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.handleRef = function (target) {
            _this.setState({ target: target });
        };
        _this.updatePopupPlacement = function (placement) {
            _this.setState({ popupPlacement: placement });
        };
        _this.state = {
            popupPlacement: ['bottom', 'left'],
        };
        return _this;
    }
    Dropdown.prototype.renderDropdown = function () {
        var _a = this.state, target = _a.target, popupPlacement = _a.popupPlacement;
        var _b = this.props, children = _b.children, mountTo = _b.mountTo, boundariesElement = _b.boundariesElement, scrollableElement = _b.scrollableElement, onOpenChange = _b.onOpenChange, fitHeight = _b.fitHeight, fitWidth = _b.fitWidth, zIndex = _b.zIndex;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["e" /* Popup */], { target: target, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, onPlacementChanged: this.updatePopupPlacement, fitHeight: fitHeight, fitWidth: fitWidth, zIndex: zIndex },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: { height: 0, minWidth: fitWidth || 0 } },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_droplist__["c" /* default */], { isOpen: true, onOpenChange: onOpenChange, appearance: "tall", position: popupPlacement.join(' '), shouldFlip: false, shouldFitContainer: true }, children))));
    };
    Dropdown.prototype.render = function () {
        var _a = this.props, trigger = _a.trigger, isOpen = _a.isOpen;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this.handleRef }, trigger),
            isOpen ? this.renderDropdown() : null));
    };
    return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Dropdown);
//# sourceMappingURL=index.js.map

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getEmojiVariation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_search__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__type_helpers__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_Comparators__ = __webpack_require__(2924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_UsageFrequencyTracker__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EmojiRepositoryRegex__ = __webpack_require__(2926);








// FS-1097 - duplicated in mentions - extract at some point into a shared library
var Tokenizer = /** @class */ (function () {
    function Tokenizer() {
    }
    Tokenizer.tokenize = function (text) {
        return this.tokenizeAsTokens(text).map(function (token) { return token.token; });
    };
    Tokenizer.tokenizeAsTokens = function (text) {
        var match;
        var tokens = [];
        __WEBPACK_IMPORTED_MODULE_7__EmojiRepositoryRegex__["a" /* tokenizerRegex */].lastIndex = 0;
        while ((match = __WEBPACK_IMPORTED_MODULE_7__EmojiRepositoryRegex__["a" /* tokenizerRegex */].exec(text)) !== null) {
            if (match[0]) {
                tokens.push({
                    token: match[0],
                    start: match.index,
                });
            }
        }
        return tokens;
    };
    return Tokenizer;
}());
var addAllVariants = function (emoji, fnKey, map) {
    var key = fnKey(emoji);
    if (!map.has(key)) {
        map.set(key, []);
    }
    var emojisForKey = map.get(key);
    // Unnecessary, but typescript thinks it is. :/
    if (emojisForKey) {
        emojisForKey.push(emoji);
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_4__type_helpers__["f" /* isEmojiDescriptionWithVariations */])(emoji)) {
        // map variations too
        var variations = emoji.skinVariations;
        if (variations) {
            variations.forEach(function (variation) { return addAllVariants(variation, fnKey, map); });
        }
    }
};
var findByKey = function (map, key) {
    var emojis = map.get(key);
    if (emojis && emojis.length) {
        // Priority is always to source from the last emoji set (last overrides first)
        return emojis[emojis.length - 1];
    }
    return undefined;
};
var splitQuery = function (query) {
    if (query === void 0) { query = ''; }
    var isColonQuery = query.indexOf(':') === 0;
    if (isColonQuery) {
        return {
            nameQuery: query.slice(1),
            asciiQuery: query,
        };
    }
    return {
        nameQuery: query,
        asciiQuery: '',
    };
};
var getEmojiVariation = function (emoji, options) {
    if (Object(__WEBPACK_IMPORTED_MODULE_4__type_helpers__["f" /* isEmojiDescriptionWithVariations */])(emoji) && options) {
        var skinTone = options.skinTone;
        if (skinTone && emoji.skinVariations && emoji.skinVariations.length) {
            var skinToneEmoji = emoji.skinVariations[skinTone - 1]; // skinTone start at 1
            if (skinToneEmoji) {
                return skinToneEmoji;
            }
        }
    }
    return emoji;
};
var findEmojiIndex = function (emojis, toFind) {
    var findId = toFind.id;
    var match = -1;
    emojis.forEach(function (emoji, index) {
        // Match if ID is defined and are equal
        // Or both have no id and shortnames match
        if ((emoji.id && emoji.id === findId) ||
            (!emoji.id && !findId && emoji.shortName === toFind.shortName)) {
            match = index;
            return;
        }
    });
    return match;
};
var EmojiRepository = /** @class */ (function () {
    function EmojiRepository(emojis, usageTracker) {
        this.emojis = emojis;
        this.initMembers(usageTracker);
    }
    /**
     * Returns all available (and searchable) emoji in some default order.
     */
    EmojiRepository.prototype.all = function () {
        var options = {
            sort: __WEBPACK_IMPORTED_MODULE_3__types__["a" /* SearchSort */].None,
        };
        return this.search('', options);
    };
    /**
     * Text search of emoji shortName and name field for suitable matches.
     *
     * Returns an array of all (searchable) emoji if query is empty or null, otherwise returns matching emoji.
     *
     * You can change how the results are sorted by specifying a custom EmojiComparator in the SearchOptions. If
     * you don't want any sorting you can also disable via the SearchOptions (this might be a useful optimisation).
     * If no sort is specified in SearchOptions then a default sorting it applied based on the query.
     */
    EmojiRepository.prototype.search = function (query, options) {
        var filteredEmoji = [];
        var _a = splitQuery(query), nameQuery = _a.nameQuery, asciiQuery = _a.asciiQuery;
        if (nameQuery) {
            filteredEmoji = this.fullSearch.search(nameQuery);
            if (asciiQuery) {
                filteredEmoji = this.withAsciiMatch(asciiQuery, filteredEmoji);
            }
        }
        else {
            filteredEmoji = this.getAllSearchableEmojis();
        }
        filteredEmoji = this.applySearchOptions(filteredEmoji, query, options);
        return {
            emojis: filteredEmoji,
            query: query,
        };
    };
    /**
     * Returns all emoji with matching shortName
     */
    EmojiRepository.prototype.findAllMatchingShortName = function (shortName) {
        return this.shortNameMap.get(shortName) || [];
    };
    /**
     * Returns the first matching emoji matching the shortName, or null if none found.
     */
    EmojiRepository.prototype.findByShortName = function (shortName) {
        return findByKey(this.shortNameMap, shortName);
    };
    /**
     * Returns the first matching emoji matching the id, or null if none found.
     */
    EmojiRepository.prototype.findById = function (id) {
        return findByKey(this.idMap, id);
    };
    EmojiRepository.prototype.findByAsciiRepresentation = function (asciiEmoji) {
        return this.asciiMap.get(asciiEmoji);
    };
    EmojiRepository.prototype.findInCategory = function (categoryId) {
        if (categoryId === __WEBPACK_IMPORTED_MODULE_2__constants__["l" /* frequentCategory */]) {
            return this.getFrequentlyUsed();
        }
        else {
            return this.all().emojis.filter(function (emoji) { return emoji.category === categoryId; });
        }
    };
    EmojiRepository.prototype.addUnknownEmoji = function (emoji) {
        this.emojis = __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](this.emojis, [emoji]);
        this.fullSearch.addDocuments([emoji]);
        this.addToMaps(emoji);
        this.addToDynamicCategories(emoji);
    };
    EmojiRepository.prototype.getAsciiMap = function () {
        return this.asciiMap;
    };
    /**
     * Return the most frequently used emoji, ordered from most frequent to least frequent. Return an empty array if
     * there are none.
     *
     * @param options optional settings to be applied to the set of frequently used emoji
     */
    EmojiRepository.prototype.getFrequentlyUsed = function (options) {
        var _this = this;
        var emojiIds = this.usageTracker.getOrder();
        var emojiResult = emojiIds
            .map(function (id) { return _this.findById(id); })
            .filter(function (e) { return e !== undefined; });
        if (options) {
            emojiResult = this.applySearchOptions(emojiResult, '', options);
        }
        return emojiResult;
    };
    EmojiRepository.prototype.getDynamicCategoryList = function () {
        return this.dynamicCategoryList.slice();
    };
    /**
     * Call this on emoji usage to allow the EmojiRepository to track the usage of emoji (which could be useful
     * in sorting, etc).
     *
     * @param emoji the emoji that was just used
     */
    EmojiRepository.prototype.used = function (emoji) {
        var _this = this;
        this.usageTracker.recordUsage(emoji);
        // If this is the first usage ensure that we update the dynamic categories.
        // This is done in a 'timeout' since the usageTracker call previously also happens in a timeout. This ensures that
        // the frequent category will not appear until the usage has been tracked (avoiding the possibility of an empty
        // frequent category being shown in the picker).
        if (this.dynamicCategoryList.indexOf(__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* frequentCategory */]) === -1) {
            window.setTimeout(function () {
                _this.dynamicCategoryList.push(__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* frequentCategory */]);
            });
        }
    };
    EmojiRepository.prototype.delete = function (emoji) {
        var deletedIndex = findEmojiIndex(this.emojis, emoji);
        if (deletedIndex !== -1) {
            // Remove the deleted emojis from the internal list
            this.emojis.splice(deletedIndex, 1);
            // Reconstruct repository member variables
            this.initMembers(this.usageTracker);
        }
    };
    EmojiRepository.prototype.withAsciiMatch = function (ascii, emojis) {
        var result = emojis;
        var asciiEmoji = this.findByAsciiRepresentation(ascii);
        if (asciiEmoji) {
            // Ensures that the same emoji isn't already in the list
            // If it is, we give precedence to the ascii match
            result = emojis.filter(function (e) { return e.id !== asciiEmoji.id; });
            result = __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"]([asciiEmoji], result);
        }
        return result;
    };
    EmojiRepository.prototype.applySearchOptions = function (emojis, query, options) {
        if (!options) {
            options = {};
        }
        if (options.sort === undefined) {
            options.sort = __WEBPACK_IMPORTED_MODULE_3__types__["a" /* SearchSort */].Default;
        }
        var comparator;
        if (options.sort === __WEBPACK_IMPORTED_MODULE_3__types__["a" /* SearchSort */].Default) {
            comparator = Object(__WEBPACK_IMPORTED_MODULE_5__internal_Comparators__["a" /* createSearchEmojiComparator */])(query, this.usageTracker.getOrder());
        }
        else if (options.sort === __WEBPACK_IMPORTED_MODULE_3__types__["a" /* SearchSort */].UsageFrequency) {
            comparator = Object(__WEBPACK_IMPORTED_MODULE_5__internal_Comparators__["b" /* createUsageOnlyEmojiComparator */])(this.usageTracker.getOrder());
        }
        if (comparator) {
            comparator.compare = comparator.compare.bind(comparator); // TODO bind at a better place
            emojis = emojis.sort(comparator.compare);
        }
        if (options.limit && options.limit > 0) {
            emojis = emojis.slice(0, options.limit);
        }
        if (options.skinTone) {
            return emojis.map(function (emoji) {
                return getEmojiVariation(emoji, options);
            });
        }
        return emojis;
    };
    EmojiRepository.prototype.initMembers = function (usageTracker) {
        this.usageTracker = usageTracker || new __WEBPACK_IMPORTED_MODULE_6__internal_UsageFrequencyTracker__["a" /* UsageFrequencyTracker */]();
        this.initRepositoryMetadata();
        this.initSearchIndex();
    };
    /**
     * Optimisation to initialise all map member variables in single loop over emojis
     */
    EmojiRepository.prototype.initRepositoryMetadata = function () {
        var _this = this;
        this.shortNameMap = new Map();
        this.idMap = new Map();
        this.asciiMap = new Map();
        var categorySet = new Set();
        this.emojis.forEach(function (emoji) {
            categorySet.add(emoji.category);
            _this.addToMaps(emoji);
        });
        if (this.usageTracker.getOrder().length) {
            categorySet.add(__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* frequentCategory */]);
        }
        this.dynamicCategoryList = Array.from(categorySet).filter(function (category) { return __WEBPACK_IMPORTED_MODULE_2__constants__["f" /* defaultCategories */].indexOf(category) === -1; });
    };
    EmojiRepository.prototype.initSearchIndex = function () {
        this.fullSearch = new __WEBPACK_IMPORTED_MODULE_1_js_search__["Search"]('id');
        this.fullSearch.tokenizer = Tokenizer;
        this.fullSearch.searchIndex = new __WEBPACK_IMPORTED_MODULE_1_js_search__["UnorderedSearchIndex"]();
        this.fullSearch.addIndex('name');
        this.fullSearch.addIndex('shortName');
        this.fullSearch.addDocuments(this.getAllSearchableEmojis());
    };
    EmojiRepository.prototype.getAllSearchableEmojis = function () {
        return this.emojis.filter(function (emojiDescription) { return emojiDescription.searchable; });
    };
    EmojiRepository.prototype.addToMaps = function (emoji) {
        var _this = this;
        // Give default value and assign higher weight to Atlassian emojis for logical order when sorting
        if (typeof emoji.order === 'undefined' || emoji.order === -1) {
            emoji.order = EmojiRepository.defaultEmojiWeight;
        }
        if (typeof emoji.id === 'undefined') {
            emoji.id = EmojiRepository.defaultEmojiWeight.toString();
        }
        addAllVariants(emoji, function (e) { return e.shortName; }, this.shortNameMap);
        addAllVariants(emoji, function (e) { return e.id; }, this.idMap);
        if (emoji.ascii) {
            emoji.ascii.forEach(function (a) { return _this.asciiMap.set(a, emoji); });
        }
    };
    EmojiRepository.prototype.addToDynamicCategories = function (emoji) {
        var category = Object(__WEBPACK_IMPORTED_MODULE_4__type_helpers__["e" /* getCategoryId */])(emoji);
        if (__WEBPACK_IMPORTED_MODULE_2__constants__["f" /* defaultCategories */].indexOf(category) === -1 &&
            this.dynamicCategoryList.indexOf(category) === -1) {
            this.dynamicCategoryList.push(category);
        }
    };
    EmojiRepository.defaultEmojiWeight = 1000000;
    return EmojiRepository;
}());
/* harmony default export */ __webpack_exports__["a"] = (EmojiRepository);
//# sourceMappingURL=EmojiRepository.js.map

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getEmojiVariation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_search__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__type_helpers__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_Comparators__ = __webpack_require__(2997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_UsageFrequencyTracker__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EmojiRepositoryRegex__ = __webpack_require__(2999);








// FS-1097 - duplicated in mentions - extract at some point into a shared library
var Tokenizer = /** @class */ (function () {
    function Tokenizer() {
    }
    Tokenizer.tokenize = function (text) {
        return this.tokenizeAsTokens(text).map(function (token) { return token.token; });
    };
    Tokenizer.tokenizeAsTokens = function (text) {
        var match;
        var tokens = [];
        __WEBPACK_IMPORTED_MODULE_7__EmojiRepositoryRegex__["a" /* tokenizerRegex */].lastIndex = 0;
        while ((match = __WEBPACK_IMPORTED_MODULE_7__EmojiRepositoryRegex__["a" /* tokenizerRegex */].exec(text)) !== null) {
            if (match[0]) {
                tokens.push({
                    token: match[0],
                    start: match.index,
                });
            }
        }
        return tokens;
    };
    return Tokenizer;
}());
var addAllVariants = function (emoji, fnKey, map) {
    var key = fnKey(emoji);
    if (!map.has(key)) {
        map.set(key, []);
    }
    var emojisForKey = map.get(key);
    // Unnecessary, but typescript thinks it is. :/
    if (emojisForKey) {
        emojisForKey.push(emoji);
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_4__type_helpers__["f" /* isEmojiDescriptionWithVariations */])(emoji)) {
        // map variations too
        var variations = emoji.skinVariations;
        if (variations) {
            variations.forEach(function (variation) { return addAllVariants(variation, fnKey, map); });
        }
    }
};
var findByKey = function (map, key) {
    var emojis = map.get(key);
    if (emojis && emojis.length) {
        // Priority is always to source from the last emoji set (last overrides first)
        return emojis[emojis.length - 1];
    }
    return undefined;
};
var splitQuery = function (query) {
    if (query === void 0) { query = ''; }
    var isColonQuery = query.indexOf(':') === 0;
    if (isColonQuery) {
        return {
            nameQuery: query.slice(1),
            asciiQuery: query,
        };
    }
    return {
        nameQuery: query,
        asciiQuery: '',
    };
};
var getEmojiVariation = function (emoji, options) {
    if (Object(__WEBPACK_IMPORTED_MODULE_4__type_helpers__["f" /* isEmojiDescriptionWithVariations */])(emoji) && options) {
        var skinTone = options.skinTone;
        if (skinTone && emoji.skinVariations && emoji.skinVariations.length) {
            var skinToneEmoji = emoji.skinVariations[skinTone - 1]; // skinTone start at 1
            if (skinToneEmoji) {
                return skinToneEmoji;
            }
        }
    }
    return emoji;
};
var findEmojiIndex = function (emojis, toFind) {
    var findId = toFind.id;
    var match = -1;
    emojis.forEach(function (emoji, index) {
        // Match if ID is defined and are equal
        // Or both have no id and shortnames match
        if ((emoji.id && emoji.id === findId) ||
            (!emoji.id && !findId && emoji.shortName === toFind.shortName)) {
            match = index;
            return;
        }
    });
    return match;
};
var EmojiRepository = /** @class */ (function () {
    function EmojiRepository(emojis, usageTracker) {
        this.emojis = emojis;
        this.initMembers(usageTracker);
    }
    /**
     * Returns all available (and searchable) emoji in some default order.
     */
    EmojiRepository.prototype.all = function () {
        var options = {
            sort: __WEBPACK_IMPORTED_MODULE_3__types__["a" /* SearchSort */].None,
        };
        return this.search('', options);
    };
    /**
     * Text search of emoji shortName and name field for suitable matches.
     *
     * Returns an array of all (searchable) emoji if query is empty or null, otherwise returns matching emoji.
     *
     * You can change how the results are sorted by specifying a custom EmojiComparator in the SearchOptions. If
     * you don't want any sorting you can also disable via the SearchOptions (this might be a useful optimisation).
     * If no sort is specified in SearchOptions then a default sorting it applied based on the query.
     */
    EmojiRepository.prototype.search = function (query, options) {
        var filteredEmoji = [];
        var _a = splitQuery(query), nameQuery = _a.nameQuery, asciiQuery = _a.asciiQuery;
        if (nameQuery) {
            filteredEmoji = this.fullSearch.search(nameQuery);
            if (asciiQuery) {
                filteredEmoji = this.withAsciiMatch(asciiQuery, filteredEmoji);
            }
        }
        else {
            filteredEmoji = this.getAllSearchableEmojis();
        }
        filteredEmoji = this.applySearchOptions(filteredEmoji, query, options);
        return {
            emojis: filteredEmoji,
            query: query,
        };
    };
    /**
     * Returns all emoji with matching shortName
     */
    EmojiRepository.prototype.findAllMatchingShortName = function (shortName) {
        return this.shortNameMap.get(shortName) || [];
    };
    /**
     * Returns the first matching emoji matching the shortName, or null if none found.
     */
    EmojiRepository.prototype.findByShortName = function (shortName) {
        return findByKey(this.shortNameMap, shortName);
    };
    /**
     * Returns the first matching emoji matching the id, or null if none found.
     */
    EmojiRepository.prototype.findById = function (id) {
        return findByKey(this.idMap, id);
    };
    EmojiRepository.prototype.findByAsciiRepresentation = function (asciiEmoji) {
        return this.asciiMap.get(asciiEmoji);
    };
    EmojiRepository.prototype.findInCategory = function (categoryId) {
        if (categoryId === __WEBPACK_IMPORTED_MODULE_2__constants__["l" /* frequentCategory */]) {
            return this.getFrequentlyUsed();
        }
        else {
            return this.all().emojis.filter(function (emoji) { return emoji.category === categoryId; });
        }
    };
    EmojiRepository.prototype.addUnknownEmoji = function (emoji) {
        this.emojis = __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](this.emojis, [emoji]);
        this.fullSearch.addDocuments([emoji]);
        this.addToMaps(emoji);
        this.addToDynamicCategories(emoji);
    };
    EmojiRepository.prototype.getAsciiMap = function () {
        return this.asciiMap;
    };
    /**
     * Return the most frequently used emoji, ordered from most frequent to least frequent. Return an empty array if
     * there are none.
     *
     * @param options optional settings to be applied to the set of frequently used emoji
     */
    EmojiRepository.prototype.getFrequentlyUsed = function (options) {
        var _this = this;
        var emojiIds = this.usageTracker.getOrder();
        var emojiResult = emojiIds
            .map(function (id) { return _this.findById(id); })
            .filter(function (e) { return e !== undefined; });
        if (options) {
            emojiResult = this.applySearchOptions(emojiResult, '', options);
        }
        return emojiResult;
    };
    EmojiRepository.prototype.getDynamicCategoryList = function () {
        return this.dynamicCategoryList.slice();
    };
    /**
     * Call this on emoji usage to allow the EmojiRepository to track the usage of emoji (which could be useful
     * in sorting, etc).
     *
     * @param emoji the emoji that was just used
     */
    EmojiRepository.prototype.used = function (emoji) {
        var _this = this;
        this.usageTracker.recordUsage(emoji);
        // If this is the first usage ensure that we update the dynamic categories.
        // This is done in a 'timeout' since the usageTracker call previously also happens in a timeout. This ensures that
        // the frequent category will not appear until the usage has been tracked (avoiding the possibility of an empty
        // frequent category being shown in the picker).
        if (this.dynamicCategoryList.indexOf(__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* frequentCategory */]) === -1) {
            window.setTimeout(function () {
                _this.dynamicCategoryList.push(__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* frequentCategory */]);
            });
        }
    };
    EmojiRepository.prototype.delete = function (emoji) {
        var deletedIndex = findEmojiIndex(this.emojis, emoji);
        if (deletedIndex !== -1) {
            // Remove the deleted emojis from the internal list
            this.emojis.splice(deletedIndex, 1);
            // Reconstruct repository member variables
            this.initMembers(this.usageTracker);
        }
    };
    EmojiRepository.prototype.withAsciiMatch = function (ascii, emojis) {
        var result = emojis;
        var asciiEmoji = this.findByAsciiRepresentation(ascii);
        if (asciiEmoji) {
            // Ensures that the same emoji isn't already in the list
            // If it is, we give precedence to the ascii match
            result = emojis.filter(function (e) { return e.id !== asciiEmoji.id; });
            result = __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"]([asciiEmoji], result);
        }
        return result;
    };
    EmojiRepository.prototype.applySearchOptions = function (emojis, query, options) {
        if (!options) {
            options = {};
        }
        if (options.sort === undefined) {
            options.sort = __WEBPACK_IMPORTED_MODULE_3__types__["a" /* SearchSort */].Default;
        }
        var comparator;
        if (options.sort === __WEBPACK_IMPORTED_MODULE_3__types__["a" /* SearchSort */].Default) {
            comparator = Object(__WEBPACK_IMPORTED_MODULE_5__internal_Comparators__["a" /* createSearchEmojiComparator */])(query, this.usageTracker.getOrder());
        }
        else if (options.sort === __WEBPACK_IMPORTED_MODULE_3__types__["a" /* SearchSort */].UsageFrequency) {
            comparator = Object(__WEBPACK_IMPORTED_MODULE_5__internal_Comparators__["b" /* createUsageOnlyEmojiComparator */])(this.usageTracker.getOrder());
        }
        if (comparator) {
            comparator.compare = comparator.compare.bind(comparator); // TODO bind at a better place
            emojis = emojis.sort(comparator.compare);
        }
        if (options.limit && options.limit > 0) {
            emojis = emojis.slice(0, options.limit);
        }
        if (options.skinTone) {
            return emojis.map(function (emoji) {
                return getEmojiVariation(emoji, options);
            });
        }
        return emojis;
    };
    EmojiRepository.prototype.initMembers = function (usageTracker) {
        this.usageTracker = usageTracker || new __WEBPACK_IMPORTED_MODULE_6__internal_UsageFrequencyTracker__["a" /* UsageFrequencyTracker */]();
        this.initRepositoryMetadata();
        this.initSearchIndex();
    };
    /**
     * Optimisation to initialise all map member variables in single loop over emojis
     */
    EmojiRepository.prototype.initRepositoryMetadata = function () {
        var _this = this;
        this.shortNameMap = new Map();
        this.idMap = new Map();
        this.asciiMap = new Map();
        var categorySet = new Set();
        this.emojis.forEach(function (emoji) {
            categorySet.add(emoji.category);
            _this.addToMaps(emoji);
        });
        if (this.usageTracker.getOrder().length) {
            categorySet.add(__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* frequentCategory */]);
        }
        this.dynamicCategoryList = Array.from(categorySet).filter(function (category) { return __WEBPACK_IMPORTED_MODULE_2__constants__["f" /* defaultCategories */].indexOf(category) === -1; });
    };
    EmojiRepository.prototype.initSearchIndex = function () {
        this.fullSearch = new __WEBPACK_IMPORTED_MODULE_1_js_search__["Search"]('id');
        this.fullSearch.tokenizer = Tokenizer;
        this.fullSearch.searchIndex = new __WEBPACK_IMPORTED_MODULE_1_js_search__["UnorderedSearchIndex"]();
        this.fullSearch.addIndex('name');
        this.fullSearch.addIndex('shortName');
        this.fullSearch.addDocuments(this.getAllSearchableEmojis());
    };
    EmojiRepository.prototype.getAllSearchableEmojis = function () {
        return this.emojis.filter(function (emojiDescription) { return emojiDescription.searchable; });
    };
    EmojiRepository.prototype.addToMaps = function (emoji) {
        var _this = this;
        // Give default value and assign higher weight to Atlassian emojis for logical order when sorting
        if (typeof emoji.order === 'undefined' || emoji.order === -1) {
            emoji.order = EmojiRepository.defaultEmojiWeight;
        }
        if (typeof emoji.id === 'undefined') {
            emoji.id = EmojiRepository.defaultEmojiWeight.toString();
        }
        addAllVariants(emoji, function (e) { return e.shortName; }, this.shortNameMap);
        addAllVariants(emoji, function (e) { return e.id; }, this.idMap);
        if (emoji.ascii) {
            emoji.ascii.forEach(function (a) { return _this.asciiMap.set(a, emoji); });
        }
    };
    EmojiRepository.prototype.addToDynamicCategories = function (emoji) {
        var category = Object(__WEBPACK_IMPORTED_MODULE_4__type_helpers__["e" /* getCategoryId */])(emoji);
        if (__WEBPACK_IMPORTED_MODULE_2__constants__["f" /* defaultCategories */].indexOf(category) === -1 &&
            this.dynamicCategoryList.indexOf(category) === -1) {
            this.dynamicCategoryList.push(category);
        }
    };
    EmojiRepository.defaultEmojiWeight = 1000000;
    return EmojiRepository;
}());
/* harmony default export */ __webpack_exports__["a"] = (EmojiRepository);
//# sourceMappingURL=EmojiRepository.js.map

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(1412);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 561 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(563);










var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(1432);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(43)))

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(568);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(572);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(344);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export routes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return navRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_history__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_UserPage__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__home_RequestsFocus__ = __webpack_require__(3196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__home_HomePage__ = __webpack_require__(3197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__serviceDesk_CreateRequest__ = __webpack_require__(3374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__home_CreateRequestPage__ = __webpack_require__(3411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__serviceDesk_ViewEditRequest__ = __webpack_require__(3412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__accessSelfService_CheckAccessStatus__ = __webpack_require__(3433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__admin_admin__ = __webpack_require__(3434);
var routes=[{path:'/',title:'Home',component:__WEBPACK_IMPORTED_MODULE_6__home_HomePage__["a" /* default */],nav:true},{path:'/user',title:'User',component:__WEBPACK_IMPORTED_MODULE_4__user_UserPage__["a" /* default */],nav:false},{path:'/requests/:issueKey',component:__WEBPACK_IMPORTED_MODULE_9__serviceDesk_ViewEditRequest__["a" /* default */],nav:false},{path:'/requests',title:'My Requests',component:__WEBPACK_IMPORTED_MODULE_5__home_RequestsFocus__["a" /* default */],nav:true},{path:'/access',title:'How User Access Works',component:__WEBPACK_IMPORTED_MODULE_10__accessSelfService_CheckAccessStatus__["a" /* default */],nav:false},{path:'/createReq',component:__WEBPACK_IMPORTED_MODULE_7__serviceDesk_CreateRequest__["a" /* default */],nav:false},{path:'/create',title:'Create a Request',component:__WEBPACK_IMPORTED_MODULE_8__home_CreateRequestPage__["a" /* default */],nav:true},{path:'/admin',title:'Admin Tools',component:__WEBPACK_IMPORTED_MODULE_11__admin_admin__["a" /* default */],nav:false}];var navRoutes=routes.filter(function(r){return r.nav;});var Routes=function Routes(_ref){var component=_ref.component,_ref$history=_ref.history,history=_ref$history===undefined?__WEBPACK_IMPORTED_MODULE_3__util_history__["a" /* default */]:_ref$history;var Component=component;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["a" /* ConnectedRouter */],{history:history},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Switch */],null,routes.map(function(route){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{key:route.path,path:route.path,exact:true,component:route.component});}))));};/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(127);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(251);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(351);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(1451)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(352);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(251);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(252);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(351);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__ = __webpack_require__(1459);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__(1460);
/* unused harmony reexport getLocation */
/* unused harmony reexport createMatchSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducer__ = __webpack_require__(587);
/* unused harmony reexport LOCATION_CHANGE */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__reducer__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(588);
/* unused harmony reexport CALL_HISTORY_METHOD */
/* unused harmony reexport push */
/* unused harmony reexport replace */
/* unused harmony reexport go */
/* unused harmony reexport goBack */
/* unused harmony reexport goForward */
/* unused harmony reexport routerActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middleware__ = __webpack_require__(1461);
/* unused harmony reexport routerMiddleware */









/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(577);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(580);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(581);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(351);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(251);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(582);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(583);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generatePath__ = __webpack_require__(352);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__matchPath__ = __webpack_require__(252);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withRouter__ = __webpack_require__(584);
/* unused harmony reexport withRouter */





















/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOCATION_CHANGE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = routerReducer;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  location: null

  /**
   * This reducer will update the state with the most recent location history
   * has transitioned to. This may not be in sync with the router, particularly
   * if you have asynchronously-loaded routes, so reading from and relying on
   * this state is discouraged.
   */
};function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { location: payload });
  }

  return state;
}

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALL_HISTORY_METHOD; });
/* unused harmony export push */
/* unused harmony export replace */
/* unused harmony export go */
/* unused harmony export goBack */
/* unused harmony export goForward */
/* unused harmony export routerActions */

/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = updateLocation('push');
var replace = updateLocation('replace');
var go = updateLocation('go');
var goBack = updateLocation('goBack');
var goForward = updateLocation('goForward');

var routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(152);
var inspect = __webpack_require__(254);
var getSideChannelList = __webpack_require__(1464);
var getSideChannelMap = __webpack_require__(590);
var getSideChannelWeakMap = __webpack_require__(1489);

var makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList;

/** @type {import('.')} */
module.exports = function getSideChannel() {
	/** @typedef {ReturnType<typeof getSideChannel>} Channel */

	/** @type {Channel | undefined} */ var $channelData;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			return !!$channelData && $channelData['delete'](key);
		},
		get: function (key) {
			return $channelData && $channelData.get(key);
		},
		has: function (key) {
			return !!$channelData && $channelData.has(key);
		},
		set: function (key, value) {
			if (!$channelData) {
				$channelData = makeChannel();
			}

			$channelData.set(key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(354);
var callBound = __webpack_require__(597);
var inspect = __webpack_require__(254);

var $TypeError = __webpack_require__(152);
var $Map = GetIntrinsic('%Map%', true);

/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */
var $mapGet = callBound('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */
var $mapSet = callBound('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapHas = callBound('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapDelete = callBound('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */
var $mapSize = callBound('Map.prototype.size', true);

/** @type {import('.')} */
module.exports = !!$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
	/** @typedef {ReturnType<typeof getSideChannelMap>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {Map<K, V> | undefined} */ var $m;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			if ($m) {
				var result = $mapDelete($m, key);
				if ($mapSize($m) === 0) {
					$m = void undefined;
				}
				return result;
			}
			return false;
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($m) {
				return $mapGet($m, key);
			}
		},
		has: function (key) {
			if ($m) {
				return $mapHas($m, key);
			}
			return false;
		},
		set: function (key, value) {
			if (!$m) {
				// @ts-expect-error TS can't handle narrowing a variable inside a closure
				$m = new $Map();
			}
			$mapSet($m, key, value);
		}
	};

	// @ts-expect-error TODO: figure out why TS is erroring here
	return channel;
};


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
module.exports = Object;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
var $gOPD = __webpack_require__(1479);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $Object = __webpack_require__(591);

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(255);
var $TypeError = __webpack_require__(152);

var $call = __webpack_require__(355);
var $actualApply = __webpack_require__(1486);

/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(354);

var callBindBasic = __webpack_require__(595);

/** @type {(thisArg: string, searchString: string, position?: number) => number} */
var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);

/** @type {import('.')} */
module.exports = function callBoundIntrinsic(name, allowMissing) {
	/* eslint no-extra-parens: 0 */

	var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBindBasic(/** @type {const} */ ([intrinsic]));
	}
	return intrinsic;
};


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(356);
var getSideChannel = __webpack_require__(589);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var overflowChannel = getSideChannel();

var markOverflow = function markOverflow(obj, maxIndex) {
    overflowChannel.set(obj, maxIndex);
    return obj;
};

var isOverflow = function isOverflow(obj) {
    return overflowChannel.has(obj);
};

var getMaxIndex = function getMaxIndex(obj) {
    return overflowChannel.get(obj);
};

var setMaxIndex = function setMaxIndex(obj, maxIndex) {
    overflowChannel.set(obj, maxIndex);
};

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array[array.length] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted[compacted.length] = obj[j];
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? { __proto__: null } : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object' && typeof source !== 'function') {
        if (isArray(target)) {
            var nextIndex = target.length;
            if (options && typeof options.arrayLimit === 'number' && nextIndex > options.arrayLimit) {
                return markOverflow(arrayToObject(target.concat(source), options), nextIndex);
            }
            target[nextIndex] = source;
        } else if (target && typeof target === 'object') {
            if (isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = getMaxIndex(target) + 1;
                target[newIndex] = source;
                setMaxIndex(target, newIndex);
            } else if (options && options.strictMerge) {
                return [target, source];
            } else if (
                (options && (options.plainObjects || options.allowPrototypes))
                || !has.call(Object.prototype, source)
            ) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        if (isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects
                ? { __proto__: null, 0: target }
                : { 0: target };
            for (var m = 0; m < sourceKeys.length; m++) {
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return markOverflow(result, getMaxIndex(source) + 1);
        }
        var combined = [target].concat(source);
        if (options && typeof options.arrayLimit === 'number' && combined.length > options.arrayLimit) {
            return markOverflow(arrayToObject(combined, options), combined.length - 1);
        }
        return combined;
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target[target.length] = item;
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }

        if (isOverflow(source) && !isOverflow(acc)) {
            markOverflow(acc, getMaxIndex(source));
        }
        if (isOverflow(acc)) {
            var keyNum = parseInt(key, 10);
            if (String(keyNum) === key && keyNum >= 0 && keyNum > getMaxIndex(acc)) {
                setMaxIndex(acc, keyNum);
            }
        }

        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];

        for (var i = 0; i < segment.length; ++i) {
            var c = segment.charCodeAt(i);
            if (
                c === 0x2D // -
                || c === 0x2E // .
                || c === 0x5F // _
                || c === 0x7E // ~
                || (c >= 0x30 && c <= 0x39) // 0-9
                || (c >= 0x41 && c <= 0x5A) // a-z
                || (c >= 0x61 && c <= 0x7A) // A-Z
                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }

            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }

            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            i += 1;
            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));

            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
                + hexTable[0x80 | ((c >> 12) & 0x3F)]
                + hexTable[0x80 | ((c >> 6) & 0x3F)]
                + hexTable[0x80 | (c & 0x3F)];
        }

        out += arr.join('');
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue[queue.length] = { obj: obj, prop: key };
                refs[refs.length] = val;
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b, arrayLimit, plainObjects) {
    // If 'a' is already an overflow object, add to it
    if (isOverflow(a)) {
        var newIndex = getMaxIndex(a) + 1;
        a[newIndex] = b;
        setMaxIndex(a, newIndex);
        return a;
    }

    var result = [].concat(a, b);
    if (result.length > arrayLimit) {
        return markOverflow(arrayToObject(result, { plainObjects: plainObjects }), result.length - 1);
    }
    return result;
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped[mapped.length] = fn(val[i]);
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isOverflow: isOverflow,
    isRegExp: isRegExp,
    markOverflow: markOverflow,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var require;var require;/*!
    localForage -- Offline Storage, Improved
    Version 1.7.3
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/
(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.localforage = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw (f.code="MODULE_NOT_FOUND", f)}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
(function (global){
'use strict';
var Mutation = global.MutationObserver || global.WebKitMutationObserver;

var scheduleDrain;

{
  if (Mutation) {
    var called = 0;
    var observer = new Mutation(nextTick);
    var element = global.document.createTextNode('');
    observer.observe(element, {
      characterData: true
    });
    scheduleDrain = function () {
      element.data = (called = ++called % 2);
    };
  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
    var channel = new global.MessageChannel();
    channel.port1.onmessage = nextTick;
    scheduleDrain = function () {
      channel.port2.postMessage(0);
    };
  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
    scheduleDrain = function () {

      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var scriptEl = global.document.createElement('script');
      scriptEl.onreadystatechange = function () {
        nextTick();

        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
      };
      global.document.documentElement.appendChild(scriptEl);
    };
  } else {
    scheduleDrain = function () {
      setTimeout(nextTick, 0);
    };
  }
}

var draining;
var queue = [];
//named nextTick for less confusing stack traces
function nextTick() {
  draining = true;
  var i, oldQueue;
  var len = queue.length;
  while (len) {
    oldQueue = queue;
    queue = [];
    i = -1;
    while (++i < len) {
      oldQueue[i]();
    }
    len = queue.length;
  }
  draining = false;
}

module.exports = immediate;
function immediate(task) {
  if (queue.push(task) === 1 && !draining) {
    scheduleDrain();
  }
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],2:[function(_dereq_,module,exports){
'use strict';
var immediate = _dereq_(1);

/* istanbul ignore next */
function INTERNAL() {}

var handlers = {};

var REJECTED = ['REJECTED'];
var FULFILLED = ['FULFILLED'];
var PENDING = ['PENDING'];

module.exports = Promise;

function Promise(resolver) {
  if (typeof resolver !== 'function') {
    throw new TypeError('resolver must be a function');
  }
  this.state = PENDING;
  this.queue = [];
  this.outcome = void 0;
  if (resolver !== INTERNAL) {
    safelyResolveThenable(this, resolver);
  }
}

Promise.prototype["catch"] = function (onRejected) {
  return this.then(null, onRejected);
};
Promise.prototype.then = function (onFulfilled, onRejected) {
  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
    typeof onRejected !== 'function' && this.state === REJECTED) {
    return this;
  }
  var promise = new this.constructor(INTERNAL);
  if (this.state !== PENDING) {
    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
    unwrap(promise, resolver, this.outcome);
  } else {
    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
  }

  return promise;
};
function QueueItem(promise, onFulfilled, onRejected) {
  this.promise = promise;
  if (typeof onFulfilled === 'function') {
    this.onFulfilled = onFulfilled;
    this.callFulfilled = this.otherCallFulfilled;
  }
  if (typeof onRejected === 'function') {
    this.onRejected = onRejected;
    this.callRejected = this.otherCallRejected;
  }
}
QueueItem.prototype.callFulfilled = function (value) {
  handlers.resolve(this.promise, value);
};
QueueItem.prototype.otherCallFulfilled = function (value) {
  unwrap(this.promise, this.onFulfilled, value);
};
QueueItem.prototype.callRejected = function (value) {
  handlers.reject(this.promise, value);
};
QueueItem.prototype.otherCallRejected = function (value) {
  unwrap(this.promise, this.onRejected, value);
};

function unwrap(promise, func, value) {
  immediate(function () {
    var returnValue;
    try {
      returnValue = func(value);
    } catch (e) {
      return handlers.reject(promise, e);
    }
    if (returnValue === promise) {
      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
    } else {
      handlers.resolve(promise, returnValue);
    }
  });
}

handlers.resolve = function (self, value) {
  var result = tryCatch(getThen, value);
  if (result.status === 'error') {
    return handlers.reject(self, result.value);
  }
  var thenable = result.value;

  if (thenable) {
    safelyResolveThenable(self, thenable);
  } else {
    self.state = FULFILLED;
    self.outcome = value;
    var i = -1;
    var len = self.queue.length;
    while (++i < len) {
      self.queue[i].callFulfilled(value);
    }
  }
  return self;
};
handlers.reject = function (self, error) {
  self.state = REJECTED;
  self.outcome = error;
  var i = -1;
  var len = self.queue.length;
  while (++i < len) {
    self.queue[i].callRejected(error);
  }
  return self;
};

function getThen(obj) {
  // Make sure we only access the accessor once as required by the spec
  var then = obj && obj.then;
  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
    return function appyThen() {
      then.apply(obj, arguments);
    };
  }
}

function safelyResolveThenable(self, thenable) {
  // Either fulfill, reject or reject with error
  var called = false;
  function onError(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.reject(self, value);
  }

  function onSuccess(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.resolve(self, value);
  }

  function tryToUnwrap() {
    thenable(onSuccess, onError);
  }

  var result = tryCatch(tryToUnwrap);
  if (result.status === 'error') {
    onError(result.value);
  }
}

function tryCatch(func, value) {
  var out = {};
  try {
    out.value = func(value);
    out.status = 'success';
  } catch (e) {
    out.status = 'error';
    out.value = e;
  }
  return out;
}

Promise.resolve = resolve;
function resolve(value) {
  if (value instanceof this) {
    return value;
  }
  return handlers.resolve(new this(INTERNAL), value);
}

Promise.reject = reject;
function reject(reason) {
  var promise = new this(INTERNAL);
  return handlers.reject(promise, reason);
}

Promise.all = all;
function all(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var values = new Array(len);
  var resolved = 0;
  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    allResolver(iterable[i], i);
  }
  return promise;
  function allResolver(value, i) {
    self.resolve(value).then(resolveFromAll, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
    function resolveFromAll(outValue) {
      values[i] = outValue;
      if (++resolved === len && !called) {
        called = true;
        handlers.resolve(promise, values);
      }
    }
  }
}

Promise.race = race;
function race(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    resolver(iterable[i]);
  }
  return promise;
  function resolver(value) {
    self.resolve(value).then(function (response) {
      if (!called) {
        called = true;
        handlers.resolve(promise, response);
      }
    }, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
  }
}

},{"1":1}],3:[function(_dereq_,module,exports){
(function (global){
'use strict';
if (typeof global.Promise !== 'function') {
  global.Promise = _dereq_(2);
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"2":2}],4:[function(_dereq_,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getIDB() {
    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */
    try {
        if (typeof indexedDB !== 'undefined') {
            return indexedDB;
        }
        if (typeof webkitIndexedDB !== 'undefined') {
            return webkitIndexedDB;
        }
        if (typeof mozIndexedDB !== 'undefined') {
            return mozIndexedDB;
        }
        if (typeof OIndexedDB !== 'undefined') {
            return OIndexedDB;
        }
        if (typeof msIndexedDB !== 'undefined') {
            return msIndexedDB;
        }
    } catch (e) {
        return;
    }
}

var idb = getIDB();

function isIndexedDBValid() {
    try {
        // Initialize IndexedDB; fall back to vendor-prefixed versions
        // if needed.
        if (!idb) {
            return false;
        }
        // We mimic PouchDB here;
        //
        // We test for openDatabase because IE Mobile identifies itself
        // as Safari. Oh the lulz...
        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);

        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;

        // Safari <10.1 does not meet our requirements for IDB support (#5572)
        // since Safari 10.1 shipped with fetch, we can use that to detect it
        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' &&
        // some outdated implementations of IDB that appear on Samsung
        // and HTC Android devices <4.4 are missing IDBKeyRange
        // See: https://github.com/mozilla/localForage/issues/128
        // See: https://github.com/mozilla/localForage/issues/272
        typeof IDBKeyRange !== 'undefined';
    } catch (e) {
        return false;
    }
}

// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
function createBlob(parts, properties) {
    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
    parts = parts || [];
    properties = properties || {};
    try {
        return new Blob(parts, properties);
    } catch (e) {
        if (e.name !== 'TypeError') {
            throw e;
        }
        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
        var builder = new Builder();
        for (var i = 0; i < parts.length; i += 1) {
            builder.append(parts[i]);
        }
        return builder.getBlob(properties.type);
    }
}

// This is CommonJS because lie is an external dependency, so Rollup
// can just ignore it.
if (typeof Promise === 'undefined') {
    // In the "nopromises" build this will just throw if you don't have
    // a global promise object, but it would throw anyway later.
    _dereq_(3);
}
var Promise$1 = Promise;

function executeCallback(promise, callback) {
    if (callback) {
        promise.then(function (result) {
            callback(null, result);
        }, function (error) {
            callback(error);
        });
    }
}

function executeTwoCallbacks(promise, callback, errorCallback) {
    if (typeof callback === 'function') {
        promise.then(callback);
    }

    if (typeof errorCallback === 'function') {
        promise["catch"](errorCallback);
    }
}

function normalizeKey(key) {
    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    return key;
}

function getCallback() {
    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') {
        return arguments[arguments.length - 1];
    }
}

// Some code originally from async_storage.js in
// [Gaia](https://github.com/mozilla-b2g/gaia).

var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
var supportsBlobs = void 0;
var dbContexts = {};
var toString = Object.prototype.toString;

// Transaction Modes
var READ_ONLY = 'readonly';
var READ_WRITE = 'readwrite';

// Transform a binary string to an array buffer, because otherwise
// weird stuff happens when you try to work with the binary string directly.
// It is known.
// From http://stackoverflow.com/questions/14967647/ (continues on next line)
// encode-decode-image-with-base64-breaks-image (2013-04-21)
function _binStringToArrayBuffer(bin) {
    var length = bin.length;
    var buf = new ArrayBuffer(length);
    var arr = new Uint8Array(buf);
    for (var i = 0; i < length; i++) {
        arr[i] = bin.charCodeAt(i);
    }
    return buf;
}

//
// Blobs are not supported in all versions of IndexedDB, notably
// Chrome <37 and Android <5. In those versions, storing a blob will throw.
//
// Various other blob bugs exist in Chrome v37-42 (inclusive).
// Detecting them is expensive and confusing to users, and Chrome 37-42
// is at very low usage worldwide, so we do a hacky userAgent check instead.
//
// content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
// 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
// FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
//
// Code borrowed from PouchDB. See:
// https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
//
function _checkBlobSupportWithoutCaching(idb) {
    return new Promise$1(function (resolve) {
        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
        var blob = createBlob(['']);
        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');

        txn.onabort = function (e) {
            // If the transaction aborts now its due to not being able to
            // write to the database, likely due to the disk being full
            e.preventDefault();
            e.stopPropagation();
            resolve(false);
        };

        txn.oncomplete = function () {
            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
            var matchedEdge = navigator.userAgent.match(/Edge\//);
            // MS Edge pretends to be Chrome 42:
            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
        };
    })["catch"](function () {
        return false; // error, so assume unsupported
    });
}

function _checkBlobSupport(idb) {
    if (typeof supportsBlobs === 'boolean') {
        return Promise$1.resolve(supportsBlobs);
    }
    return _checkBlobSupportWithoutCaching(idb).then(function (value) {
        supportsBlobs = value;
        return supportsBlobs;
    });
}

function _deferReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Create a deferred object representing the current database operation.
    var deferredOperation = {};

    deferredOperation.promise = new Promise$1(function (resolve, reject) {
        deferredOperation.resolve = resolve;
        deferredOperation.reject = reject;
    });

    // Enqueue the deferred operation.
    dbContext.deferredOperations.push(deferredOperation);

    // Chain its promise to the database readiness.
    if (!dbContext.dbReady) {
        dbContext.dbReady = deferredOperation.promise;
    } else {
        dbContext.dbReady = dbContext.dbReady.then(function () {
            return deferredOperation.promise;
        });
    }
}

function _advanceReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Resolve its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.resolve();
        return deferredOperation.promise;
    }
}

function _rejectReadiness(dbInfo, err) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Reject its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.reject(err);
        return deferredOperation.promise;
    }
}

function _getConnection(dbInfo, upgradeNeeded) {
    return new Promise$1(function (resolve, reject) {
        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();

        if (dbInfo.db) {
            if (upgradeNeeded) {
                _deferReadiness(dbInfo);
                dbInfo.db.close();
            } else {
                return resolve(dbInfo.db);
            }
        }

        var dbArgs = [dbInfo.name];

        if (upgradeNeeded) {
            dbArgs.push(dbInfo.version);
        }

        var openreq = idb.open.apply(idb, dbArgs);

        if (upgradeNeeded) {
            openreq.onupgradeneeded = function (e) {
                var db = openreq.result;
                try {
                    db.createObjectStore(dbInfo.storeName);
                    if (e.oldVersion <= 1) {
                        // Added when support for blob shims was added
                        db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                    }
                } catch (ex) {
                    if (ex.name === 'ConstraintError') {
                        console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                    } else {
                        throw ex;
                    }
                }
            };
        }

        openreq.onerror = function (e) {
            e.preventDefault();
            reject(openreq.error);
        };

        openreq.onsuccess = function () {
            resolve(openreq.result);
            _advanceReadiness(dbInfo);
        };
    });
}

function _getOriginalConnection(dbInfo) {
    return _getConnection(dbInfo, false);
}

function _getUpgradedConnection(dbInfo) {
    return _getConnection(dbInfo, true);
}

function _isUpgradeNeeded(dbInfo, defaultVersion) {
    if (!dbInfo.db) {
        return true;
    }

    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
    var isDowngrade = dbInfo.version < dbInfo.db.version;
    var isUpgrade = dbInfo.version > dbInfo.db.version;

    if (isDowngrade) {
        // If the version is not the default one
        // then warn for impossible downgrade.
        if (dbInfo.version !== defaultVersion) {
            console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
        }
        // Align the versions to prevent errors.
        dbInfo.version = dbInfo.db.version;
    }

    if (isUpgrade || isNewStore) {
        // If the store is new then increment the version (if needed).
        // This will trigger an "upgradeneeded" event which is required
        // for creating a store.
        if (isNewStore) {
            var incVersion = dbInfo.db.version + 1;
            if (incVersion > dbInfo.version) {
                dbInfo.version = incVersion;
            }
        }

        return true;
    }

    return false;
}

// encode a blob for indexeddb engines that don't support blobs
function _encodeBlob(blob) {
    return new Promise$1(function (resolve, reject) {
        var reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = function (e) {
            var base64 = btoa(e.target.result || '');
            resolve({
                __local_forage_encoded_blob: true,
                data: base64,
                type: blob.type
            });
        };
        reader.readAsBinaryString(blob);
    });
}

// decode an encoded blob
function _decodeBlob(encodedBlob) {
    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
    return createBlob([arrayBuff], { type: encodedBlob.type });
}

// is this one of our fancy encoded blobs?
function _isEncodedBlob(value) {
    return value && value.__local_forage_encoded_blob;
}

// Specialize the default `ready()` function by making it dependent
// on the current database operations. Thus, the driver will be actually
// ready when it's been initialized (default) *and* there are no pending
// operations on the database (initiated by some other instances).
function _fullyReady(callback) {
    var self = this;

    var promise = self._initReady().then(function () {
        var dbContext = dbContexts[self._dbInfo.name];

        if (dbContext && dbContext.dbReady) {
            return dbContext.dbReady;
        }
    });

    executeTwoCallbacks(promise, callback, callback);
    return promise;
}

// Try to establish a new db connection to replace the
// current one which is broken (i.e. experiencing
// InvalidStateError while creating a transaction).
function _tryReconnect(dbInfo) {
    _deferReadiness(dbInfo);

    var dbContext = dbContexts[dbInfo.name];
    var forages = dbContext.forages;

    for (var i = 0; i < forages.length; i++) {
        var forage = forages[i];
        if (forage._dbInfo.db) {
            forage._dbInfo.db.close();
            forage._dbInfo.db = null;
        }
    }
    dbInfo.db = null;

    return _getOriginalConnection(dbInfo).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        // store the latest db reference
        // in case the db was upgraded
        dbInfo.db = dbContext.db = db;
        for (var i = 0; i < forages.length; i++) {
            forages[i]._dbInfo.db = db;
        }
    })["catch"](function (err) {
        _rejectReadiness(dbInfo, err);
        throw err;
    });
}

// FF doesn't like Promises (micro-tasks) and IDDB store operations,
// so we have to do it with callbacks
function createTransaction(dbInfo, mode, callback, retries) {
    if (retries === undefined) {
        retries = 1;
    }

    try {
        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
        callback(null, tx);
    } catch (err) {
        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) {
            return Promise$1.resolve().then(function () {
                if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                    // increase the db version, to create the new ObjectStore
                    if (dbInfo.db) {
                        dbInfo.version = dbInfo.db.version + 1;
                    }
                    // Reopen the database for upgrading.
                    return _getUpgradedConnection(dbInfo);
                }
            }).then(function () {
                return _tryReconnect(dbInfo).then(function () {
                    createTransaction(dbInfo, mode, callback, retries - 1);
                });
            })["catch"](callback);
        }

        callback(err);
    }
}

function createDbContext() {
    return {
        // Running localForages sharing a database.
        forages: [],
        // Shared database.
        db: null,
        // Database readiness (promise).
        dbReady: null,
        // Deferred operations on the database.
        deferredOperations: []
    };
}

// Open the IndexedDB database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    // Get the current context of the database;
    var dbContext = dbContexts[dbInfo.name];

    // ...or create a new context.
    if (!dbContext) {
        dbContext = createDbContext();
        // Register the new context in the global container.
        dbContexts[dbInfo.name] = dbContext;
    }

    // Register itself as a running localForage in the current context.
    dbContext.forages.push(self);

    // Replace the default `ready()` function with the specialized one.
    if (!self._initReady) {
        self._initReady = self.ready;
        self.ready = _fullyReady;
    }

    // Create an array of initialization states of the related localForages.
    var initPromises = [];

    function ignoreErrors() {
        // Don't handle errors here,
        // just makes sure related localForages aren't pending.
        return Promise$1.resolve();
    }

    for (var j = 0; j < dbContext.forages.length; j++) {
        var forage = dbContext.forages[j];
        if (forage !== self) {
            // Don't wait for itself...
            initPromises.push(forage._initReady()["catch"](ignoreErrors));
        }
    }

    // Take a snapshot of the related localForages.
    var forages = dbContext.forages.slice(0);

    // Initialize the connection process only when
    // all the related localForages aren't pending.
    return Promise$1.all(initPromises).then(function () {
        dbInfo.db = dbContext.db;
        // Get the connection or open a new one without upgrade.
        return _getOriginalConnection(dbInfo);
    }).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo, self._defaultConfig.version)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        dbInfo.db = dbContext.db = db;
        self._dbInfo = dbInfo;
        // Share the final connection amongst related localForages.
        for (var k = 0; k < forages.length; k++) {
            var forage = forages[k];
            if (forage !== self) {
                // Self is already up-to-date.
                forage._dbInfo.db = dbInfo.db;
                forage._dbInfo.version = dbInfo.version;
            }
        }
    });
}

function getItem(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.get(key);

                    req.onsuccess = function () {
                        var value = req.result;
                        if (value === undefined) {
                            value = null;
                        }
                        if (_isEncodedBlob(value)) {
                            value = _decodeBlob(value);
                        }
                        resolve(value);
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items stored in database.
function iterate(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.openCursor();
                    var iterationNumber = 1;

                    req.onsuccess = function () {
                        var cursor = req.result;

                        if (cursor) {
                            var value = cursor.value;
                            if (_isEncodedBlob(value)) {
                                value = _decodeBlob(value);
                            }
                            var result = iterator(value, cursor.key, iterationNumber++);

                            // when the iterator callback retuns any
                            // (non-`undefined`) value, then we stop
                            // the iteration immediately
                            if (result !== void 0) {
                                resolve(result);
                            } else {
                                cursor["continue"]();
                            }
                        } else {
                            resolve();
                        }
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);

    return promise;
}

function setItem(key, value, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        var dbInfo;
        self.ready().then(function () {
            dbInfo = self._dbInfo;
            if (toString.call(value) === '[object Blob]') {
                return _checkBlobSupport(dbInfo.db).then(function (blobSupport) {
                    if (blobSupport) {
                        return value;
                    }
                    return _encodeBlob(value);
                });
            }
            return value;
        }).then(function (value) {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);

                    // The reason we don't _save_ null is because IE 10 does
                    // not support saving the `null` type in IndexedDB. How
                    // ironic, given the bug below!
                    // See: https://github.com/mozilla/localForage/issues/161
                    if (value === null) {
                        value = undefined;
                    }

                    var req = store.put(value, key);

                    transaction.oncomplete = function () {
                        // Cast to undefined so the value passed to
                        // callback/promise is the same as what one would get out
                        // of `getItem()` later. This leads to some weirdness
                        // (setItem('foo', undefined) will return `null`), but
                        // it's not my fault localStorage is our baseline and that
                        // it's weird.
                        if (value === undefined) {
                            value = null;
                        }

                        resolve(value);
                    };
                    transaction.onabort = transaction.onerror = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function removeItem(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    // We use a Grunt task to make this safe for IE and some
                    // versions of Android (including those used by Cordova).
                    // Normally IE won't like `.delete()` and will insist on
                    // using `['delete']()`, but we have a build step that
                    // fixes this for us now.
                    var req = store["delete"](key);
                    transaction.oncomplete = function () {
                        resolve();
                    };

                    transaction.onerror = function () {
                        reject(req.error);
                    };

                    // The request will be also be aborted if we've exceeded our storage
                    // space.
                    transaction.onabort = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function clear(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.clear();

                    transaction.oncomplete = function () {
                        resolve();
                    };

                    transaction.onabort = transaction.onerror = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function length(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.count();

                    req.onsuccess = function () {
                        resolve(req.result);
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function key(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        if (n < 0) {
            resolve(null);

            return;
        }

        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var advanced = false;
                    var req = store.openCursor();

                    req.onsuccess = function () {
                        var cursor = req.result;
                        if (!cursor) {
                            // this means there weren't enough keys
                            resolve(null);

                            return;
                        }

                        if (n === 0) {
                            // We have the first key, return it if that's what they
                            // wanted.
                            resolve(cursor.key);
                        } else {
                            if (!advanced) {
                                // Otherwise, ask the cursor to skip ahead n
                                // records.
                                advanced = true;
                                cursor.advance(n);
                            } else {
                                // When we get here, we've got the nth key.
                                resolve(cursor.key);
                            }
                        }
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.openCursor();
                    var keys = [];

                    req.onsuccess = function () {
                        var cursor = req.result;

                        if (!cursor) {
                            resolve(keys);
                            return;
                        }

                        keys.push(cursor.key);
                        cursor["continue"]();
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function dropInstance(options, callback) {
    callback = getCallback.apply(this, arguments);

    var currentConfig = this.config();
    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        var isCurrentDb = options.name === currentConfig.name && self._dbInfo.db;

        var dbPromise = isCurrentDb ? Promise$1.resolve(self._dbInfo.db) : _getOriginalConnection(options).then(function (db) {
            var dbContext = dbContexts[options.name];
            var forages = dbContext.forages;
            dbContext.db = db;
            for (var i = 0; i < forages.length; i++) {
                forages[i]._dbInfo.db = db;
            }
            return db;
        });

        if (!options.storeName) {
            promise = dbPromise.then(function (db) {
                _deferReadiness(options);

                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;

                db.close();
                for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                }

                var dropDBPromise = new Promise$1(function (resolve, reject) {
                    var req = idb.deleteDatabase(options.name);

                    req.onerror = req.onblocked = function (err) {
                        var db = req.result;
                        if (db) {
                            db.close();
                        }
                        reject(err);
                    };

                    req.onsuccess = function () {
                        var db = req.result;
                        if (db) {
                            db.close();
                        }
                        resolve(db);
                    };
                });

                return dropDBPromise.then(function (db) {
                    dbContext.db = db;
                    for (var i = 0; i < forages.length; i++) {
                        var _forage = forages[i];
                        _advanceReadiness(_forage._dbInfo);
                    }
                })["catch"](function (err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
                    throw err;
                });
            });
        } else {
            promise = dbPromise.then(function (db) {
                if (!db.objectStoreNames.contains(options.storeName)) {
                    return;
                }

                var newVersion = db.version + 1;

                _deferReadiness(options);

                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;

                db.close();
                for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                    forage._dbInfo.version = newVersion;
                }

                var dropObjectPromise = new Promise$1(function (resolve, reject) {
                    var req = idb.open(options.name, newVersion);

                    req.onerror = function (err) {
                        var db = req.result;
                        db.close();
                        reject(err);
                    };

                    req.onupgradeneeded = function () {
                        var db = req.result;
                        db.deleteObjectStore(options.storeName);
                    };

                    req.onsuccess = function () {
                        var db = req.result;
                        db.close();
                        resolve(db);
                    };
                });

                return dropObjectPromise.then(function (db) {
                    dbContext.db = db;
                    for (var j = 0; j < forages.length; j++) {
                        var _forage2 = forages[j];
                        _forage2._dbInfo.db = db;
                        _advanceReadiness(_forage2._dbInfo);
                    }
                })["catch"](function (err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
                    throw err;
                });
            });
        }
    }

    executeCallback(promise, callback);
    return promise;
}

var asyncStorage = {
    _driver: 'asyncStorage',
    _initStorage: _initStorage,
    _support: isIndexedDBValid(),
    iterate: iterate,
    getItem: getItem,
    setItem: setItem,
    removeItem: removeItem,
    clear: clear,
    length: length,
    key: key,
    keys: keys,
    dropInstance: dropInstance
};

function isWebSQLValid() {
    return typeof openDatabase === 'function';
}

// Sadly, the best way to save binary data in WebSQL/localStorage is serializing
// it to Base64, so this is how we store it to prevent very strange errors with less
// verbose ways of binary <-> string data storage.
var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

var BLOB_TYPE_PREFIX = '~~local_forage_type~';
var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;

var SERIALIZED_MARKER = '__lfsc__:';
var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;

// OMG the serializations!
var TYPE_ARRAYBUFFER = 'arbf';
var TYPE_BLOB = 'blob';
var TYPE_INT8ARRAY = 'si08';
var TYPE_UINT8ARRAY = 'ui08';
var TYPE_UINT8CLAMPEDARRAY = 'uic8';
var TYPE_INT16ARRAY = 'si16';
var TYPE_INT32ARRAY = 'si32';
var TYPE_UINT16ARRAY = 'ur16';
var TYPE_UINT32ARRAY = 'ui32';
var TYPE_FLOAT32ARRAY = 'fl32';
var TYPE_FLOAT64ARRAY = 'fl64';
var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;

var toString$1 = Object.prototype.toString;

function stringToBuffer(serializedString) {
    // Fill the string into a ArrayBuffer.
    var bufferLength = serializedString.length * 0.75;
    var len = serializedString.length;
    var i;
    var p = 0;
    var encoded1, encoded2, encoded3, encoded4;

    if (serializedString[serializedString.length - 1] === '=') {
        bufferLength--;
        if (serializedString[serializedString.length - 2] === '=') {
            bufferLength--;
        }
    }

    var buffer = new ArrayBuffer(bufferLength);
    var bytes = new Uint8Array(buffer);

    for (i = 0; i < len; i += 4) {
        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);

        /*jslint bitwise: true */
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return buffer;
}

// Converts a buffer to a string to store, serialized, in the backend
// storage library.
function bufferToString(buffer) {
    // base64-arraybuffer
    var bytes = new Uint8Array(buffer);
    var base64String = '';
    var i;

    for (i = 0; i < bytes.length; i += 3) {
        /*jslint bitwise: true */
        base64String += BASE_CHARS[bytes[i] >> 2];
        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64String += BASE_CHARS[bytes[i + 2] & 63];
    }

    if (bytes.length % 3 === 2) {
        base64String = base64String.substring(0, base64String.length - 1) + '=';
    } else if (bytes.length % 3 === 1) {
        base64String = base64String.substring(0, base64String.length - 2) + '==';
    }

    return base64String;
}

// Serialize a value, afterwards executing a callback (which usually
// instructs the `setItem()` callback/promise to be executed). This is how
// we store binary data with localStorage.
function serialize(value, callback) {
    var valueType = '';
    if (value) {
        valueType = toString$1.call(value);
    }

    // Cannot use `value instanceof ArrayBuffer` or such here, as these
    // checks fail when running the tests using casper.js...
    //
    // TODO: See why those tests fail and use a better solution.
    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
        // Convert binary arrays to a string and prefix the string with
        // a special marker.
        var buffer;
        var marker = SERIALIZED_MARKER;

        if (value instanceof ArrayBuffer) {
            buffer = value;
            marker += TYPE_ARRAYBUFFER;
        } else {
            buffer = value.buffer;

            if (valueType === '[object Int8Array]') {
                marker += TYPE_INT8ARRAY;
            } else if (valueType === '[object Uint8Array]') {
                marker += TYPE_UINT8ARRAY;
            } else if (valueType === '[object Uint8ClampedArray]') {
                marker += TYPE_UINT8CLAMPEDARRAY;
            } else if (valueType === '[object Int16Array]') {
                marker += TYPE_INT16ARRAY;
            } else if (valueType === '[object Uint16Array]') {
                marker += TYPE_UINT16ARRAY;
            } else if (valueType === '[object Int32Array]') {
                marker += TYPE_INT32ARRAY;
            } else if (valueType === '[object Uint32Array]') {
                marker += TYPE_UINT32ARRAY;
            } else if (valueType === '[object Float32Array]') {
                marker += TYPE_FLOAT32ARRAY;
            } else if (valueType === '[object Float64Array]') {
                marker += TYPE_FLOAT64ARRAY;
            } else {
                callback(new Error('Failed to get type for BinaryArray'));
            }
        }

        callback(marker + bufferToString(buffer));
    } else if (valueType === '[object Blob]') {
        // Conver the blob to a binaryArray and then to a string.
        var fileReader = new FileReader();

        fileReader.onload = function () {
            // Backwards-compatible prefix for the blob type.
            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);

            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
        };

        fileReader.readAsArrayBuffer(value);
    } else {
        try {
            callback(JSON.stringify(value));
        } catch (e) {
            console.error("Couldn't convert value into a JSON string: ", value);

            callback(null, e);
        }
    }
}

// Deserialize data we've inserted into a value column/field. We place
// special markers into our strings to mark them as encoded; this isn't
// as nice as a meta field, but it's the only sane thing we can do whilst
// keeping localStorage support intact.
//
// Oftentimes this will just deserialize JSON content, but if we have a
// special marker (SERIALIZED_MARKER, defined above), we will extract
// some kind of arraybuffer/binary data/typed array out of the string.
function deserialize(value) {
    // If we haven't marked this string as being specially serialized (i.e.
    // something other than serialized JSON), we can just return it and be
    // done with it.
    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
        return JSON.parse(value);
    }

    // The following code deals with deserializing some kind of Blob or
    // TypedArray. First we separate out the type of data we're dealing
    // with from the data itself.
    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);

    var blobType;
    // Backwards-compatible blob type serialization strategy.
    // DBs created with older versions of localForage will simply not have the blob type.
    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
        blobType = matcher[1];
        serializedString = serializedString.substring(matcher[0].length);
    }
    var buffer = stringToBuffer(serializedString);

    // Return the right type based on the code/type set during
    // serialization.
    switch (type) {
        case TYPE_ARRAYBUFFER:
            return buffer;
        case TYPE_BLOB:
            return createBlob([buffer], { type: blobType });
        case TYPE_INT8ARRAY:
            return new Int8Array(buffer);
        case TYPE_UINT8ARRAY:
            return new Uint8Array(buffer);
        case TYPE_UINT8CLAMPEDARRAY:
            return new Uint8ClampedArray(buffer);
        case TYPE_INT16ARRAY:
            return new Int16Array(buffer);
        case TYPE_UINT16ARRAY:
            return new Uint16Array(buffer);
        case TYPE_INT32ARRAY:
            return new Int32Array(buffer);
        case TYPE_UINT32ARRAY:
            return new Uint32Array(buffer);
        case TYPE_FLOAT32ARRAY:
            return new Float32Array(buffer);
        case TYPE_FLOAT64ARRAY:
            return new Float64Array(buffer);
        default:
            throw new Error('Unkown type: ' + type);
    }
}

var localforageSerializer = {
    serialize: serialize,
    deserialize: deserialize,
    stringToBuffer: stringToBuffer,
    bufferToString: bufferToString
};

/*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */

function createDbTable(t, dbInfo, callback, errorCallback) {
    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
}

// Open the WebSQL database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage$1(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
        }
    }

    var dbInfoPromise = new Promise$1(function (resolve, reject) {
        // Open the database; the openDatabase API will automatically
        // create it for us if it doesn't exist.
        try {
            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
        } catch (e) {
            return reject(e);
        }

        // Create our key/value table if it doesn't exist.
        dbInfo.db.transaction(function (t) {
            createDbTable(t, dbInfo, function () {
                self._dbInfo = dbInfo;
                resolve();
            }, function (t, error) {
                reject(error);
            });
        }, reject);
    });

    dbInfo.serializer = localforageSerializer;
    return dbInfoPromise;
}

function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
    t.executeSql(sqlStatement, args, callback, function (t, error) {
        if (error.code === error.SYNTAX_ERR) {
            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name = ?", [dbInfo.storeName], function (t, results) {
                if (!results.rows.length) {
                    // if the table is missing (was deleted)
                    // re-create it table and retry
                    createDbTable(t, dbInfo, function () {
                        t.executeSql(sqlStatement, args, callback, errorCallback);
                    }, errorCallback);
                } else {
                    errorCallback(t, error);
                }
            }, errorCallback);
        } else {
            errorCallback(t, error);
        }
    }, errorCallback);
}

function getItem$1(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [key], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).value : null;

                    // Check to see if this is serialized content we need to
                    // unpack.
                    if (result) {
                        result = dbInfo.serializer.deserialize(result);
                    }

                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function iterate$1(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;

            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function (t, results) {
                    var rows = results.rows;
                    var length = rows.length;

                    for (var i = 0; i < length; i++) {
                        var item = rows.item(i);
                        var result = item.value;

                        // Check to see if this is serialized content
                        // we need to unpack.
                        if (result) {
                            result = dbInfo.serializer.deserialize(result);
                        }

                        result = iterator(result, item.key, i + 1);

                        // void(0) prevents problems with redefinition
                        // of `undefined`.
                        if (result !== void 0) {
                            resolve(result);
                            return;
                        }
                    }

                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function _setItem(key, value, callback, retriesLeft) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            // The localStorage API doesn't return undefined values in an
            // "expected" way, so undefined is always cast to null in all
            // drivers. See: https://github.com/mozilla/localForage/pull/42
            if (value === undefined) {
                value = null;
            }

            // Save the original value to pass to the callback.
            var originalValue = value;

            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    dbInfo.db.transaction(function (t) {
                        tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [key, value], function () {
                            resolve(originalValue);
                        }, function (t, error) {
                            reject(error);
                        });
                    }, function (sqlError) {
                        // The transaction failed; check
                        // to see if it's a quota error.
                        if (sqlError.code === sqlError.QUOTA_ERR) {
                            // We reject the callback outright for now, but
                            // it's worth trying to re-run the transaction.
                            // Even if the user accepts the prompt to use
                            // more storage on Safari, this error will
                            // be called.
                            //
                            // Try to re-run the transaction.
                            if (retriesLeft > 0) {
                                resolve(_setItem.apply(self, [key, originalValue, callback, retriesLeft - 1]));
                                return;
                            }
                            reject(sqlError);
                        }
                    });
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function setItem$1(key, value, callback) {
    return _setItem.apply(this, [key, value, callback, 1]);
}

function removeItem$1(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [key], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Deletes every item in the table.
// TODO: Find out if this resets the AUTO_INCREMENT number.
function clear$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Does a simple `COUNT(key)` to get the number of items stored in
// localForage.
function length$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                // Ahhh, SQL makes this one soooooo easy.
                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function (t, results) {
                    var result = results.rows.item(0).c;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Return the key located at key index X; essentially gets the key from a
// `WHERE id = ?`. This is the most efficient way I can think to implement
// this rarely-used (in my experience) part of the API, but it can seem
// inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
// the ID of each key will change every time it's updated. Perhaps a stored
// procedure for the `setItem()` SQL would solve this problem?
// TODO: Don't change ID on `setItem()`.
function key$1(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [n + 1], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).key : null;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function (t, results) {
                    var keys = [];

                    for (var i = 0; i < results.rows.length; i++) {
                        keys.push(results.rows.item(i).key);
                    }

                    resolve(keys);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// https://www.w3.org/TR/webdatabase/#databases
// > There is no way to enumerate or delete the databases available for an origin from this API.
function getAllStoreNames(db) {
    return new Promise$1(function (resolve, reject) {
        db.transaction(function (t) {
            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (t, results) {
                var storeNames = [];

                for (var i = 0; i < results.rows.length; i++) {
                    storeNames.push(results.rows.item(i).name);
                }

                resolve({
                    db: db,
                    storeNames: storeNames
                });
            }, function (t, error) {
                reject(error);
            });
        }, function (sqlError) {
            reject(sqlError);
        });
    });
}

function dropInstance$1(options, callback) {
    callback = getCallback.apply(this, arguments);

    var currentConfig = this.config();
    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        promise = new Promise$1(function (resolve) {
            var db;
            if (options.name === currentConfig.name) {
                // use the db reference of the current instance
                db = self._dbInfo.db;
            } else {
                db = openDatabase(options.name, '', '', 0);
            }

            if (!options.storeName) {
                // drop all database tables
                resolve(getAllStoreNames(db));
            } else {
                resolve({
                    db: db,
                    storeNames: [options.storeName]
                });
            }
        }).then(function (operationInfo) {
            return new Promise$1(function (resolve, reject) {
                operationInfo.db.transaction(function (t) {
                    function dropTable(storeName) {
                        return new Promise$1(function (resolve, reject) {
                            t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function () {
                                resolve();
                            }, function (t, error) {
                                reject(error);
                            });
                        });
                    }

                    var operations = [];
                    for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
                        operations.push(dropTable(operationInfo.storeNames[i]));
                    }

                    Promise$1.all(operations).then(function () {
                        resolve();
                    })["catch"](function (e) {
                        reject(e);
                    });
                }, function (sqlError) {
                    reject(sqlError);
                });
            });
        });
    }

    executeCallback(promise, callback);
    return promise;
}

var webSQLStorage = {
    _driver: 'webSQLStorage',
    _initStorage: _initStorage$1,
    _support: isWebSQLValid(),
    iterate: iterate$1,
    getItem: getItem$1,
    setItem: setItem$1,
    removeItem: removeItem$1,
    clear: clear$1,
    length: length$1,
    key: key$1,
    keys: keys$1,
    dropInstance: dropInstance$1
};

function isLocalStorageValid() {
    try {
        return typeof localStorage !== 'undefined' && 'setItem' in localStorage &&
        // in IE8 typeof localStorage.setItem === 'object'
        !!localStorage.setItem;
    } catch (e) {
        return false;
    }
}

function _getKeyPrefix(options, defaultConfig) {
    var keyPrefix = options.name + '/';

    if (options.storeName !== defaultConfig.storeName) {
        keyPrefix += options.storeName + '/';
    }
    return keyPrefix;
}

// Check if localStorage throws when saving an item
function checkIfLocalStorageThrows() {
    var localStorageTestKey = '_localforage_support_test';

    try {
        localStorage.setItem(localStorageTestKey, true);
        localStorage.removeItem(localStorageTestKey);

        return false;
    } catch (e) {
        return true;
    }
}

// Check if localStorage is usable and allows to save an item
// This method checks if localStorage is usable in Safari Private Browsing
// mode, or in any other case where the available quota for localStorage
// is 0 and there wasn't any saved items yet.
function _isLocalStorageUsable() {
    return !checkIfLocalStorageThrows() || localStorage.length > 0;
}

// Config the localStorage backend, using options set in the config.
function _initStorage$2(options) {
    var self = this;
    var dbInfo = {};
    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    dbInfo.keyPrefix = _getKeyPrefix(options, self._defaultConfig);

    if (!_isLocalStorageUsable()) {
        return Promise$1.reject();
    }

    self._dbInfo = dbInfo;
    dbInfo.serializer = localforageSerializer;

    return Promise$1.resolve();
}

// Remove all keys from the datastore, effectively destroying all data in
// the app's key/value store!
function clear$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var keyPrefix = self._dbInfo.keyPrefix;

        for (var i = localStorage.length - 1; i >= 0; i--) {
            var key = localStorage.key(i);

            if (key.indexOf(keyPrefix) === 0) {
                localStorage.removeItem(key);
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Retrieve an item from the store. Unlike the original async_storage
// library in Gaia, we don't modify return values at all. If a key's value
// is `undefined`, we pass that value to the callback function.
function getItem$2(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result = localStorage.getItem(dbInfo.keyPrefix + key);

        // If a result was found, parse it from the serialized
        // string into a JS object. If result isn't truthy, the key
        // is likely undefined and we'll pass it straight to the
        // callback.
        if (result) {
            result = dbInfo.serializer.deserialize(result);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items in the store.
function iterate$2(iterator, callback) {
    var self = this;

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var keyPrefix = dbInfo.keyPrefix;
        var keyPrefixLength = keyPrefix.length;
        var length = localStorage.length;

        // We use a dedicated iterator instead of the `i` variable below
        // so other keys we fetch in localStorage aren't counted in
        // the `iterationNumber` argument passed to the `iterate()`
        // callback.
        //
        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
        var iterationNumber = 1;

        for (var i = 0; i < length; i++) {
            var key = localStorage.key(i);
            if (key.indexOf(keyPrefix) !== 0) {
                continue;
            }
            var value = localStorage.getItem(key);

            // If a result was found, parse it from the serialized
            // string into a JS object. If result isn't truthy, the
            // key is likely undefined and we'll pass it straight
            // to the iterator.
            if (value) {
                value = dbInfo.serializer.deserialize(value);
            }

            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);

            if (value !== void 0) {
                return value;
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Same as localStorage's key() method, except takes a callback.
function key$2(n, callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result;
        try {
            result = localStorage.key(n);
        } catch (error) {
            result = null;
        }

        // Remove the prefix from the key, if a key is found.
        if (result) {
            result = result.substring(dbInfo.keyPrefix.length);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var length = localStorage.length;
        var keys = [];

        for (var i = 0; i < length; i++) {
            var itemKey = localStorage.key(i);
            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
                keys.push(itemKey.substring(dbInfo.keyPrefix.length));
            }
        }

        return keys;
    });

    executeCallback(promise, callback);
    return promise;
}

// Supply the number of keys in the datastore to the callback function.
function length$2(callback) {
    var self = this;
    var promise = self.keys().then(function (keys) {
        return keys.length;
    });

    executeCallback(promise, callback);
    return promise;
}

// Remove an item from the store, nice and simple.
function removeItem$2(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        localStorage.removeItem(dbInfo.keyPrefix + key);
    });

    executeCallback(promise, callback);
    return promise;
}

// Set a key's value and run an optional callback once the value is set.
// Unlike Gaia's implementation, the callback function is passed the value,
// in case you want to operate on that value only after you're sure it
// saved, or something like that.
function setItem$2(key, value, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        // Convert undefined values to null.
        // https://github.com/mozilla/localForage/pull/42
        if (value === undefined) {
            value = null;
        }

        // Save the original value to pass to the callback.
        var originalValue = value;

        return new Promise$1(function (resolve, reject) {
            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    try {
                        localStorage.setItem(dbInfo.keyPrefix + key, value);
                        resolve(originalValue);
                    } catch (e) {
                        // localStorage capacity exceeded.
                        // TODO: Make this a specific error/event.
                        if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                            reject(e);
                        }
                        reject(e);
                    }
                }
            });
        });
    });

    executeCallback(promise, callback);
    return promise;
}

function dropInstance$2(options, callback) {
    callback = getCallback.apply(this, arguments);

    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        var currentConfig = this.config();
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        promise = new Promise$1(function (resolve) {
            if (!options.storeName) {
                resolve(options.name + '/');
            } else {
                resolve(_getKeyPrefix(options, self._defaultConfig));
            }
        }).then(function (keyPrefix) {
            for (var i = localStorage.length - 1; i >= 0; i--) {
                var key = localStorage.key(i);

                if (key.indexOf(keyPrefix) === 0) {
                    localStorage.removeItem(key);
                }
            }
        });
    }

    executeCallback(promise, callback);
    return promise;
}

var localStorageWrapper = {
    _driver: 'localStorageWrapper',
    _initStorage: _initStorage$2,
    _support: isLocalStorageValid(),
    iterate: iterate$2,
    getItem: getItem$2,
    setItem: setItem$2,
    removeItem: removeItem$2,
    clear: clear$2,
    length: length$2,
    key: key$2,
    keys: keys$2,
    dropInstance: dropInstance$2
};

var sameValue = function sameValue(x, y) {
    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
};

var includes = function includes(array, searchElement) {
    var len = array.length;
    var i = 0;
    while (i < len) {
        if (sameValue(array[i], searchElement)) {
            return true;
        }
        i++;
    }

    return false;
};

var isArray = Array.isArray || function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
};

// Drivers are stored here when `defineDriver()` is called.
// They are shared across all instances of localForage.
var DefinedDrivers = {};

var DriverSupport = {};

var DefaultDrivers = {
    INDEXEDDB: asyncStorage,
    WEBSQL: webSQLStorage,
    LOCALSTORAGE: localStorageWrapper
};

var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];

var OptionalDriverMethods = ['dropInstance'];

var LibraryMethods = ['clear', 'getItem', 'iterate', 'key', 'keys', 'length', 'removeItem', 'setItem'].concat(OptionalDriverMethods);

var DefaultConfig = {
    description: '',
    driver: DefaultDriverOrder.slice(),
    name: 'localforage',
    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
    // we can use without a prompt.
    size: 4980736,
    storeName: 'keyvaluepairs',
    version: 1.0
};

function callWhenReady(localForageInstance, libraryMethod) {
    localForageInstance[libraryMethod] = function () {
        var _args = arguments;
        return localForageInstance.ready().then(function () {
            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
        });
    };
}

function extend() {
    for (var i = 1; i < arguments.length; i++) {
        var arg = arguments[i];

        if (arg) {
            for (var _key in arg) {
                if (arg.hasOwnProperty(_key)) {
                    if (isArray(arg[_key])) {
                        arguments[0][_key] = arg[_key].slice();
                    } else {
                        arguments[0][_key] = arg[_key];
                    }
                }
            }
        }
    }

    return arguments[0];
}

var LocalForage = function () {
    function LocalForage(options) {
        _classCallCheck(this, LocalForage);

        for (var driverTypeKey in DefaultDrivers) {
            if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                var driver = DefaultDrivers[driverTypeKey];
                var driverName = driver._driver;
                this[driverTypeKey] = driverName;

                if (!DefinedDrivers[driverName]) {
                    // we don't need to wait for the promise,
                    // since the default drivers can be defined
                    // in a blocking manner
                    this.defineDriver(driver);
                }
            }
        }

        this._defaultConfig = extend({}, DefaultConfig);
        this._config = extend({}, this._defaultConfig, options);
        this._driverSet = null;
        this._initDriver = null;
        this._ready = false;
        this._dbInfo = null;

        this._wrapLibraryMethodsWithReady();
        this.setDriver(this._config.driver)["catch"](function () {});
    }

    // Set any config values for localForage; can be called anytime before
    // the first API call (e.g. `getItem`, `setItem`).
    // We loop through options so we don't overwrite existing config
    // values.


    LocalForage.prototype.config = function config(options) {
        // If the options argument is an object, we use it to set values.
        // Otherwise, we return either a specified config value or all
        // config values.
        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
            // If localforage is ready and fully initialized, we can't set
            // any new configuration values. Instead, we return an error.
            if (this._ready) {
                return new Error("Can't call config() after localforage " + 'has been used.');
            }

            for (var i in options) {
                if (i === 'storeName') {
                    options[i] = options[i].replace(/\W/g, '_');
                }

                if (i === 'version' && typeof options[i] !== 'number') {
                    return new Error('Database version must be a number.');
                }

                this._config[i] = options[i];
            }

            // after all config options are set and
            // the driver option is used, try setting it
            if ('driver' in options && options.driver) {
                return this.setDriver(this._config.driver);
            }

            return true;
        } else if (typeof options === 'string') {
            return this._config[options];
        } else {
            return this._config;
        }
    };

    // Used to define a custom driver, shared across all instances of
    // localForage.


    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
        var promise = new Promise$1(function (resolve, reject) {
            try {
                var driverName = driverObject._driver;
                var complianceError = new Error('Custom driver not compliant; see ' + 'https://mozilla.github.io/localForage/#definedriver');

                // A driver name should be defined and not overlap with the
                // library-defined, default drivers.
                if (!driverObject._driver) {
                    reject(complianceError);
                    return;
                }

                var driverMethods = LibraryMethods.concat('_initStorage');
                for (var i = 0, len = driverMethods.length; i < len; i++) {
                    var driverMethodName = driverMethods[i];

                    // when the property is there,
                    // it should be a method even when optional
                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
                        reject(complianceError);
                        return;
                    }
                }

                var configureMissingMethods = function configureMissingMethods() {
                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                        return function () {
                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
                            var promise = Promise$1.reject(error);
                            executeCallback(promise, arguments[arguments.length - 1]);
                            return promise;
                        };
                    };

                    for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
                        var optionalDriverMethod = OptionalDriverMethods[_i];
                        if (!driverObject[optionalDriverMethod]) {
                            driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                        }
                    }
                };

                configureMissingMethods();

                var setDriverSupport = function setDriverSupport(support) {
                    if (DefinedDrivers[driverName]) {
                        console.info('Redefining LocalForage driver: ' + driverName);
                    }
                    DefinedDrivers[driverName] = driverObject;
                    DriverSupport[driverName] = support;
                    // don't use a then, so that we can define
                    // drivers that have simple _support methods
                    // in a blocking manner
                    resolve();
                };

                if ('_support' in driverObject) {
                    if (driverObject._support && typeof driverObject._support === 'function') {
                        driverObject._support().then(setDriverSupport, reject);
                    } else {
                        setDriverSupport(!!driverObject._support);
                    }
                } else {
                    setDriverSupport(true);
                }
            } catch (e) {
                reject(e);
            }
        });

        executeTwoCallbacks(promise, callback, errorCallback);
        return promise;
    };

    LocalForage.prototype.driver = function driver() {
        return this._driver || null;
    };

    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));

        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
        return getDriverPromise;
    };

    LocalForage.prototype.getSerializer = function getSerializer(callback) {
        var serializerPromise = Promise$1.resolve(localforageSerializer);
        executeTwoCallbacks(serializerPromise, callback);
        return serializerPromise;
    };

    LocalForage.prototype.ready = function ready(callback) {
        var self = this;

        var promise = self._driverSet.then(function () {
            if (self._ready === null) {
                self._ready = self._initDriver();
            }

            return self._ready;
        });

        executeTwoCallbacks(promise, callback, callback);
        return promise;
    };

    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
        var self = this;

        if (!isArray(drivers)) {
            drivers = [drivers];
        }

        var supportedDrivers = this._getSupportedDrivers(drivers);

        function setDriverToConfig() {
            self._config.driver = self.driver();
        }

        function extendSelfWithDriver(driver) {
            self._extend(driver);
            setDriverToConfig();

            self._ready = self._initStorage(self._config);
            return self._ready;
        }

        function initDriver(supportedDrivers) {
            return function () {
                var currentDriverIndex = 0;

                function driverPromiseLoop() {
                    while (currentDriverIndex < supportedDrivers.length) {
                        var driverName = supportedDrivers[currentDriverIndex];
                        currentDriverIndex++;

                        self._dbInfo = null;
                        self._ready = null;

                        return self.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                    }

                    setDriverToConfig();
                    var error = new Error('No available storage method found.');
                    self._driverSet = Promise$1.reject(error);
                    return self._driverSet;
                }

                return driverPromiseLoop();
            };
        }

        // There might be a driver initialization in progress
        // so wait for it to finish in order to avoid a possible
        // race condition to set _dbInfo
        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function () {
            return Promise$1.resolve();
        }) : Promise$1.resolve();

        this._driverSet = oldDriverSetDone.then(function () {
            var driverName = supportedDrivers[0];
            self._dbInfo = null;
            self._ready = null;

            return self.getDriver(driverName).then(function (driver) {
                self._driver = driver._driver;
                setDriverToConfig();
                self._wrapLibraryMethodsWithReady();
                self._initDriver = initDriver(supportedDrivers);
            });
        })["catch"](function () {
            setDriverToConfig();
            var error = new Error('No available storage method found.');
            self._driverSet = Promise$1.reject(error);
            return self._driverSet;
        });

        executeTwoCallbacks(this._driverSet, callback, errorCallback);
        return this._driverSet;
    };

    LocalForage.prototype.supports = function supports(driverName) {
        return !!DriverSupport[driverName];
    };

    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
        extend(this, libraryMethodsAndProperties);
    };

    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
        var supportedDrivers = [];
        for (var i = 0, len = drivers.length; i < len; i++) {
            var driverName = drivers[i];
            if (this.supports(driverName)) {
                supportedDrivers.push(driverName);
            }
        }
        return supportedDrivers;
    };

    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
        // Add a stub for each driver API method that delays the call to the
        // corresponding driver method until localForage is ready. These stubs
        // will be replaced by the driver methods as soon as the driver is
        // loaded, so there is no performance impact.
        for (var i = 0, len = LibraryMethods.length; i < len; i++) {
            callWhenReady(this, LibraryMethods[i]);
        }
    };

    LocalForage.prototype.createInstance = function createInstance(options) {
        return new LocalForage(options);
    };

    return LocalForage;
}();

// The actual localForage object that we expose as a module or via a
// global. It's extended by pulling in one of our other libraries.


var localforage_js = new LocalForage();

module.exports = localforage_js;

},{"3":3}]},{},[4])(4)
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = request;
/* unused harmony export selectIsAnyRequestPending */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectIsRequestPending; });
/* unused harmony export selectRequestError */
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function request(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];if(action.request){return Object.assign({},state,_defineProperty({},action.request.id,{isPending:action.request.isPending,error:action.request.error}));}return state;}var selectIsAnyRequestPending=function selectIsAnyRequestPending(state){return Object.keys(state.request).some(function(key){var action=state.request[key]||{};return action.isPending;});};var selectIsRequestPending=function selectIsRequestPending(state,action){return(state.request[action.event.name]||{}).isPending===true;};var selectRequestError=function selectRequestError(state,action){return(state.request[action.event.name]||{}).error;};

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IconButton */
/* unused harmony export LinkButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_js__ = __webpack_require__(25);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var textAlignStyle={verticalAlign:'baseline'};var Button=function Button(_ref){var submit=_ref.submit,className=_ref.className,small=_ref.small,children=_ref.children,color=_ref.color,matchCase=_ref.matchCase,thin=_ref.thin,large=_ref.large,textInline=_ref.textInline,extraClassName=_ref.extraClassName,props=_objectWithoutProperties(_ref,['submit','className','small','children','color','matchCase','thin','large','textInline','extraClassName']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',Object.assign({type:props.submit?'submit':'button'},props,{className:props.className||getButtonClass({color:color,matchCase:matchCase,thin:thin,large:large,small:small,extraClassName:extraClassName}),style:textInline?textAlignStyle:undefined}),children);};var getButtonClass=function getButtonClass(props){var style=['ncss-btn-primary-'+(props.color||'dark')];if(!props.matchCase)style.push('u-uppercase');if(props.small)style.push('pt1-sm pb1-sm prl2-sm');else if(props.thin)style.push('');// Not yet determined
else if(props.large)style.push('');// Not yet determined
else style.push('pt3-sm pr5-sm pb3-sm pl5-sm pt2-lg pb2-lg');if(props.extraClassName)style.push(props.extraClassName);return style.join(' ');};/* harmony default export */ __webpack_exports__["a"] = (Button);var getIcon=function getIcon(icon){return icon&&icon.indexOf('g72')===0?icon:'fa fa-'+icon;};var IconButton=function IconButton(_ref2){var icon=_ref2.icon,color=_ref2.color,props=_objectWithoutProperties(_ref2,['icon','color']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',Object.assign({type:'button',className:'btn icon-solo'},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:getIcon(icon)+' text-color-'+(color||'primary-dark')}));};var LinkButton=function LinkButton(_ref3){var to=_ref3.to,color=_ref3.color,icon=_ref3.icon,label=_ref3.label,title=_ref3.title,iconOnly=_ref3.iconOnly,props=_objectWithoutProperties(_ref3,['to','color','icon','label','title','iconOnly']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__index_js__["m" /* Link */],{to:to,title:title},iconOnly?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconButton,{color:color,icon:icon}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,Object.assign({},props,{color:color}),label,' ',icon?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:getIcon(icon)}):null));};

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Label__ = __webpack_require__(189);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var types={input:'ncss-input-container',textarea:'ncss-textarea-container',radio:'ncss-radio-container',select:'ncss-select-container',checkbox:'ncss-checkbox-container',wiki:'ncss-wiki-container'};var labelBeforeTypes=['input','select','textarea','text','wiki'];var labelAfterTypes=['radio','checkbox'];var InputContainer=function(_Component){_inherits(InputContainer,_Component);function InputContainer(){_classCallCheck(this,InputContainer);return _possibleConstructorReturn(this,(InputContainer.__proto__||Object.getPrototypeOf(InputContainer)).apply(this,arguments));}_createClass(InputContainer,[{key:'render',value:function render(){var type=this.props.type||'input';var inputType=types[type];var _props=this.props,label=_props.label,title=_props.title,error=_props.error,labelBefore=_props.labelBefore,labelAfter=_props.labelAfter;var children=__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(this.props.children);if(label){var inputLabel=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Label__["a" /* default */],{key:'label',title:title},label);if(labelBefore||!labelAfter&&labelBeforeTypes.includes(type)){children.unshift(inputLabel);}else if(labelAfter||labelAfterTypes.includes(type)){children.push(inputLabel);}}if(error){children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ncss-error-msg',key:'error'},error));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ncss-form-group '+(this.props.extraClassName||'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:inputType+' '+(error?'error':'')},children));}}]);return InputContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (InputContainer);

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tooltip__ = __webpack_require__(256);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var children=_ref.children,className=_ref.className,useBareClass=_ref.useBareClass,props=_objectWithoutProperties(_ref,['children','className','useBareClass']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:(useBareClass||'fs18-sm d-sm-ib')+' '+(className||'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Tooltip__["a" /* default */],Object.assign({},props,{content:children,placement:'right'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-info-circle text-color-accent fs18-sm'})));});

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(124) && !__webpack_require__(153)(function () {
  return Object.defineProperty(__webpack_require__(544)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(129);
var toIObject = __webpack_require__(146);
var arrayIndexOf = __webpack_require__(1503)(false);
var IE_PROTO = __webpack_require__(361)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(531);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(247);
var $export = __webpack_require__(118);
var redefine = __webpack_require__(608);
var hide = __webpack_require__(145);
var Iterators = __webpack_require__(334);
var $iterCreate = __webpack_require__(1508);
var setToStringTag = __webpack_require__(338);
var getPrototypeOf = __webpack_require__(1377);
var ITERATOR = __webpack_require__(140)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(145);


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(605);
var hiddenKeys = __webpack_require__(363).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function addEventListenerWrap(target, eventType, cb) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback);
}

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1535), __esModule: true };

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAlignPopupClassName;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, baseAlign, align);
}

function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getVisibleRectForElement__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__adjustForViewport__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getRegion__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getElFuturePos__ = __webpack_require__(1546);
/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */







// http://yiminghe.iteye.com/blog/1124720

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}

function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}

function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}

function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}

function flip(points, reg, map) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}

function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}

function convertOffset(str, offsetLen) {
  var n = void 0;
  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }
  return n || 0;
}

function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}

/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */
function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  // 当前节点可以被放置的显示区域
  var visibleRect = Object(__WEBPACK_IMPORTED_MODULE_1__getVisibleRectForElement__["a" /* default */])(source);
  // 当前节点所占的区域, left/top/width/height
  var elRegion = Object(__WEBPACK_IMPORTED_MODULE_3__getRegion__["a" /* default */])(source);
  // 将 offset 转换成数值，支持百分比
  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion);
  // 当前节点将要被放置的位置
  var elFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, points, offset, targetOffset);
  // 当前节点将要所处的区域
  var newElRegion = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].merge(elRegion, elFuturePos);

  // 如果可视区域不能完全放置当前节点时允许调整
  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/ig, {
          l: 'r',
          r: 'l'
        });
        // 偏移量也反下
        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);

        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }

    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/ig, {
          t: 'b',
          b: 't'
        });
        // 偏移量也反下
        var _newOffset = flipOffset(offset, 1);
        var _newTargetOffset = flipOffset(targetOffset, 1);
        var _newElFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);

        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    }

    // 如果失败，重新计算当前节点将要被放置的位置
    if (fail) {
      elFuturePos = Object(__WEBPACK_IMPORTED_MODULE_4__getElFuturePos__["a" /* default */])(elRegion, tgtRegion, points, offset, targetOffset);
      __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].mix(newElRegion, elFuturePos);
    }
    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
    // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数
    if (isStillFailX || isStillFailY) {
      points = align.points;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    }
    // 2. 只有指定了可以调整当前方向才调整
    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;

    // 确实要调整，甚至可能会调整高度宽度
    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = Object(__WEBPACK_IMPORTED_MODULE_2__adjustForViewport__["a" /* default */])(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  }

  // need judge to in case set fixed with in css on height auto element
  if (newElRegion.width !== elRegion.width) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(source, 'width', __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].width(source) + newElRegion.width - elRegion.width);
  }

  if (newElRegion.height !== elRegion.height) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(source, 'height', __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].height(source) + newElRegion.height - elRegion.height);
  }

  // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>
  __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });

  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}

/* harmony default export */ __webpack_exports__["a"] = (doAlign);
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isAncestorFixed__ = __webpack_require__(1544);




/**
 * 获得元素的显示部分的区域
 */
function getVisibleRectForElement(element) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = Object(__WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */])(element);
  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement;

  // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.
  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
    // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(el, 'overflow') !== 'visible') {
      var pos = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(el);
      // add border
      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right,
      // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }
    el = Object(__WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */])(el);
  }

  // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601
  var originalPosition = null;
  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(element, 'position');
    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }

  var scrollX = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollLeft(win);
  var scrollY = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollTop(win);
  var viewportWidth = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportWidth(win);
  var viewportHeight = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight;

  // Reset element position after calculate the visible area
  if (element.style) {
    element.style.position = originalPosition;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_2__isAncestorFixed__["a" /* default */])(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);

    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }

  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

/* harmony default export */ __webpack_exports__["a"] = (getVisibleRectForElement);

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(130);


/**
 * 得到会导致元素显示不全的祖先元素
 */

function getOffsetParent(element) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) || element.nodeType === 9) {
    return null;
  }
  // ie 这个也不是完全可行
  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法
  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var body = doc.body;
  var parent = void 0;
  var positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';

  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : element.parentNode;
  }

  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
    positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(parent, 'position');
    if (positionStyle !== 'static') {
      return parent;
    }
  }
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (getOffsetParent);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(130);


function getRegion(node) {
  var offset = void 0;
  var w = void 0;
  var h = void 0;
  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(node) && node.nodeType !== 9) {
    offset = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(node);
    w = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].outerWidth(node);
    h = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].outerHeight(node);
  } else {
    var win = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindow(node);
    offset = {
      left: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollLeft(win),
      top: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollTop(win)
    };
    w = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportWidth(win);
    h = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportHeight(win);
  }
  offset.width = w;
  offset.height = h;
  return offset;
}

/* harmony default export */ __webpack_exports__["a"] = (getRegion);

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(611);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var LazyRenderBox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.hiddenClassName || nextProps.visible;
  };

  LazyRenderBox.prototype.render = function render() {
    var _props = this.props,
        hiddenClassName = _props.hiddenClassName,
        visible = _props.visible,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible']);

    if (hiddenClassName || __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(props.children) > 1) {
      if (!visible && hiddenClassName) {
        props.className += ' ' + hiddenClassName;
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', props);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(props.children);
  };

  return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

LazyRenderBox.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shallow_compare__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_markdown__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_highlight_js__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_highlight_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_highlight_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index_js__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InlineCodeBlock=function InlineCodeBlock(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code',null,props.value);};var CodeBlock=function(_Component){_inherits(CodeBlock,_Component);function CodeBlock(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CodeBlock);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CodeBlock.__proto__||Object.getPrototypeOf(CodeBlock)).call.apply(_ref,[this].concat(args))),_this),_this.shouldComponentUpdate=function(nextProps,nextState){return Object(__WEBPACK_IMPORTED_MODULE_1_shallow_compare__["a" /* default */])(_this,nextProps,nextState);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CodeBlock,[{key:'componentDidMount',value:function componentDidMount(){this.highlightCode();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.highlightCode();}},{key:'highlightCode',value:function highlightCode(){__WEBPACK_IMPORTED_MODULE_3__util_highlight_js___default.a.highlightBlock(this.code);}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code',{ref:function ref(el){_this2.code=el;},className:this.props.language},this.props.value));}}]);return CodeBlock;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Link=function(_Component2){_inherits(Link,_Component2);function Link(){var _ref2;var _temp2,_this3,_ret2;_classCallCheck(this,Link);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this3=_possibleConstructorReturn(this,(_ref2=Link.__proto__||Object.getPrototypeOf(Link)).call.apply(_ref2,[this].concat(args))),_this3),_this3.shouldComponentUpdate=function(nextProps,nextState){return Object(__WEBPACK_IMPORTED_MODULE_1_shallow_compare__["a" /* default */])(_this3,nextProps,nextState);},_temp2),_possibleConstructorReturn(_this3,_ret2);}_createClass(Link,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index_js__["m" /* Link */],{to:this.props.href,external:!isHrefInternal(this.props.href),title:this.props.title},this.props.children);}}]);return Link;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var isHrefInternal=function isHrefInternal(href){return href.indexOf('/')===0||window&&window.location&&window.location.origin&&href.indexOf(window.location.origin)===0;};var Markdown=function(_Component3){_inherits(Markdown,_Component3);function Markdown(){_classCallCheck(this,Markdown);return _possibleConstructorReturn(this,(Markdown.__proto__||Object.getPrototypeOf(Markdown)).apply(this,arguments));}_createClass(Markdown,[{key:'render',value:function render(){var allowHtml=this.props.allowHtml;var renderers=this.props.renderers||{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'markdown-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_markdown___default.a,{source:this.props.source||'',escapeHtml:!allowHtml,renderers:Object.assign({code:CodeBlock,inlineCode:InlineCodeBlock,link:Link},renderers)}));}}]);return Markdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Markdown.defaultProps={allowHtml:false};/* harmony default export */ __webpack_exports__["a"] = (Markdown);

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";




var encodeCache = {};


// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function getEncodeCache(exclude) {
  var i, ch, cache = encodeCache[exclude];
  if (cache) { return cache; }

  cache = encodeCache[exclude] = [];

  for (i = 0; i < 128; i++) {
    ch = String.fromCharCode(i);

    if (/^[0-9a-z]$/i.test(ch)) {
      // always allow unencoded alphanumeric characters
      cache.push(ch);
    } else {
      cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
  }

  for (i = 0; i < exclude.length; i++) {
    cache[exclude.charCodeAt(i)] = exclude[i];
  }

  return cache;
}


// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function encode(string, exclude, keepEscaped) {
  var i, l, code, nextCode, cache,
      result = '';

  if (typeof exclude !== 'string') {
    // encode(string, keepEscaped)
    keepEscaped  = exclude;
    exclude = encode.defaultChars;
  }

  if (typeof keepEscaped === 'undefined') {
    keepEscaped = true;
  }

  cache = getEncodeCache(exclude);

  for (i = 0, l = string.length; i < l; i++) {
    code = string.charCodeAt(i);

    if (keepEscaped && code === 0x25 /* % */ && i + 2 < l) {
      if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
        result += string.slice(i, i + 3);
        i += 2;
        continue;
      }
    }

    if (code < 128) {
      result += cache[code];
      continue;
    }

    if (code >= 0xD800 && code <= 0xDFFF) {
      if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
        nextCode = string.charCodeAt(i + 1);
        if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
          result += encodeURIComponent(string[i] + string[i + 1]);
          i++;
          continue;
        }
      }
      result += '%EF%BF%BD';
      continue;
    }

    result += encodeURIComponent(string[i]);
  }

  return result;
}

encode.defaultChars   = ";/?:@&=+$,-_.!~*'()#";
encode.componentChars = "-_.!~*'()";


module.exports = encode;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";




/* eslint-disable no-bitwise */

var decodeCache = {};

function getDecodeCache(exclude) {
  var i, ch, cache = decodeCache[exclude];
  if (cache) { return cache; }

  cache = decodeCache[exclude] = [];

  for (i = 0; i < 128; i++) {
    ch = String.fromCharCode(i);
    cache.push(ch);
  }

  for (i = 0; i < exclude.length; i++) {
    ch = exclude.charCodeAt(i);
    cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
  }

  return cache;
}


// Decode percent-encoded string.
//
function decode(string, exclude) {
  var cache;

  if (typeof exclude !== 'string') {
    exclude = decode.defaultChars;
  }

  cache = getDecodeCache(exclude);

  return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
    var i, l, b1, b2, b3, b4, chr,
        result = '';

    for (i = 0, l = seq.length; i < l; i += 3) {
      b1 = parseInt(seq.slice(i + 1, i + 3), 16);

      if (b1 < 0x80) {
        result += cache[b1];
        continue;
      }

      if ((b1 & 0xE0) === 0xC0 && (i + 3 < l)) {
        // 110xxxxx 10xxxxxx
        b2 = parseInt(seq.slice(i + 4, i + 6), 16);

        if ((b2 & 0xC0) === 0x80) {
          chr = ((b1 << 6) & 0x7C0) | (b2 & 0x3F);

          if (chr < 0x80) {
            result += '\ufffd\ufffd';
          } else {
            result += String.fromCharCode(chr);
          }

          i += 3;
          continue;
        }
      }

      if ((b1 & 0xF0) === 0xE0 && (i + 6 < l)) {
        // 1110xxxx 10xxxxxx 10xxxxxx
        b2 = parseInt(seq.slice(i + 4, i + 6), 16);
        b3 = parseInt(seq.slice(i + 7, i + 9), 16);

        if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
          chr = ((b1 << 12) & 0xF000) | ((b2 << 6) & 0xFC0) | (b3 & 0x3F);

          if (chr < 0x800 || (chr >= 0xD800 && chr <= 0xDFFF)) {
            result += '\ufffd\ufffd\ufffd';
          } else {
            result += String.fromCharCode(chr);
          }

          i += 6;
          continue;
        }
      }

      if ((b1 & 0xF8) === 0xF0 && (i + 9 < l)) {
        // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
        b2 = parseInt(seq.slice(i + 4, i + 6), 16);
        b3 = parseInt(seq.slice(i + 7, i + 9), 16);
        b4 = parseInt(seq.slice(i + 10, i + 12), 16);

        if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
          chr = ((b1 << 18) & 0x1C0000) | ((b2 << 12) & 0x3F000) | ((b3 << 6) & 0xFC0) | (b4 & 0x3F);

          if (chr < 0x10000 || chr > 0x10FFFF) {
            result += '\ufffd\ufffd\ufffd\ufffd';
          } else {
            chr -= 0x10000;
            result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
          }

          i += 9;
          continue;
        }
      }

      result += '\ufffd';
    }

    return result;
  });
}


decode.defaultChars   = ';/?:@&=+$,#';
decode.componentChars = '';


module.exports = decode;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var encode = __webpack_require__(1567),
    decode = __webpack_require__(1568);

exports.decode = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
};

exports.decodeStrict = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
};

exports.encode = function(data, level){
	return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
};

exports.encodeXML = encode.XML;

exports.encodeHTML4 =
exports.encodeHTML5 =
exports.encodeHTML  = encode.HTML;

exports.decodeXML =
exports.decodeXMLStrict = decode.XML;

exports.decodeHTML4 =
exports.decodeHTML5 =
exports.decodeHTML = decode.HTML;

exports.decodeHTML4Strict =
exports.decodeHTML5Strict =
exports.decodeHTMLStrict = decode.HTMLStrict;

exports.escape = encode.escape;


/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var defaultInputClass='ncss-input pt2-sm pr4-sm pb2-sm pl4-sm';var defaultTextAreaClass='ncss-textarea p4-sm';var Input=function Input(_ref){var textArea=_ref.textArea,props=_objectWithoutProperties(_ref,['textArea']);var onChange=void 0;if(props.onChange){onChange=function onChange(e){return props.onChange(e.target.value);};}if(props.type==='textarea'||textArea){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',Object.assign({className:props.className||defaultTextAreaClass},props,{onChange:onChange}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',Object.assign({className:props.className||defaultInputClass},props,{onChange:onChange}));};/* harmony default export */ __webpack_exports__["a"] = (Input);

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Label__ = __webpack_require__(189);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var name=_ref.name,options=_ref.options,label=_ref.label,line=_ref.line,_onChange=_ref.onChange,title=_ref.title,value=_ref.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ncss-form-group'},label?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Label__["a" /* default */],{title:title,className:'mb2-sm d-sm-b'},label):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:line?'ncss-toggle-line':'ncss-toggle-btn border-light-grey'},options.map(function(option){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:option.value,className:line?'ncss-toggle-line-item':'ncss-toggle-btn-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'ncss-radio',type:'radio',name:name,id:option.value,onChange:function onChange(){return _onChange(option.value);},checked:option.value===value}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'ncss-label ncss-brand pt2-sm pr5-sm pb2-sm pl5-sm u-uppercase',onClick:function onClick(){return _onChange(option.value);},htmlFor:option.value},option.label));})));});

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
    PropTypes = __webpack_require__(10),
    withSideEffect = __webpack_require__(1592);

function reducePropsToState(propsList) {
  var innermostProps = propsList[propsList.length - 1];
  if (innermostProps) {
    return innermostProps.title;
  }
}

function handleStateChangeOnClient(title) {
  var nextTitle = title || '';
  if (nextTitle !== document.title) {
    document.title = nextTitle;
  }
}

function DocumentTitle() {}
DocumentTitle.prototype = Object.create(React.Component.prototype);

DocumentTitle.displayName = 'DocumentTitle';
DocumentTitle.propTypes = {
  title: PropTypes.string.isRequired
};

DocumentTitle.prototype.render = function() {
  if (this.props.children) {
    return React.Children.only(this.props.children);
  } else {
    return null;
  }
};

module.exports = withSideEffect(
  reducePropsToState,
  handleStateChangeOnClient
)(DocumentTitle);


/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(1609);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var props=_objectWithoutProperties(_ref,[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */],props);});

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_core__ = __webpack_require__(1615);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var wikiEditor=function(_Component){_inherits(wikiEditor,_Component);function wikiEditor(){var _ref;var _temp,_this,_ret;_classCallCheck(this,wikiEditor);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=wikiEditor.__proto__||Object.getPrototypeOf(wikiEditor)).call.apply(_ref,[this].concat(args))),_this),_this.onChange=function(editorView){var props=_this.props;var contents=editorView.state.doc;if(props.onChange){props.onChange(contents);}},_this.handleSave=function(editorView){var onSave=_this.props.onSave;var contents=editorView.state.doc;onSave(contents);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(wikiEditor,[{key:'render',value:function render(){var _props=this.props,onCancel=_props.onCancel,value=_props.value,onSave=_props.onSave,mentionProvider=_props.mentionProvider,disabled=_props.disabled;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__index__["f" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_core__["b" /* EditorContext */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_core__["a" /* Editor */],{appearance:'comment',isExpandedByDefault:true,allowRule:true,allowTextFormatting:true,allowCodeBlocks:true,allowTextColor:true,allowLists:true,allowTables:true,mentionProvider:mentionProvider,onSave:onSave?this.handleSave:null,onCancel:onCancel?onCancel:null,onChange:this.onChange,defaultValue:value?value:null,disabled:disabled?disabled:false}))));}}]);return wikiEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (wikiEditor);

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(1617)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(1624);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = acNameToEmoji;
/* unused harmony export emojiIdToAcName */
/* harmony export (immutable) */ __webpack_exports__["b"] = acShortcutToEmoji;
/* unused harmony export getEmojiAcName */
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
var DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
var DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
var HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */
var acNameToEmojiMap = {
    smile: ['1f642', ':slight_smile:', '\uD83D\uDE42'],
    sad: ['1f641', ':slight_frown:', '\uD83D\uDE41'],
    cheeky: ['1f61b', ':stuck_out_tongue:', '\uD83D\uDE1B'],
    laugh: ['1f600', ':grinning:', '\uD83D\uDE00'],
    wink: ['1f609', ':wink:', '\uD83D\uDE09'],
    information: ['2139', ':information_source:', '\u2139'],
    tick: ['2705', ':white_check_mark:', '\u2705'],
    cross: ['274c', ':x:', '\u274C'],
    warning: ['26a0', ':warning:', '\u26A0'],
    plus: ['2795', ':heavy_plus_sign:', '\u2795'],
    minus: ['2796', ':heavy_minus_sign:', '\u2796'],
    question: ['2753', ':question:', '\u003F'],
    'thumbs-up': ['1f44d', ':thumbsup:', '\uD83D\uDC4D'],
    'thumbs-down': ['1f44e', ':thumbsdown:', '\uD83D\uDC4E'],
    'light-on': ['1f4a1', ':bulb:', '\uD83D\uDCA1'],
    'yellow-star': ['2b50', ':star:', '\uD83D\uDC9B'],
    'light-off': ['1f6ab', ':no_entry_sign:', '\uD83D\uDEAB'],
    'red-star': ['2764', ':heart:', '\u2764\uFE0F'],
    'green-star': ['1f49a', ':green_heart:', '\uD83D\uDC9A'],
    'blue-star': ['1f499', ':blue_heart:', '\uD83D\uDC99'],
    heart: ['2764', ':heart:', '\u2764\uFE0F'],
    'broken-heart': ['1f494', ':broken_heart:', '\uD83D\uDC94'],
};
function acNameToEmoji(acName) {
    var emojiData = acNameToEmojiMap[acName];
    return emojiData
        ? {
            id: emojiData[0],
            shortName: emojiData[1],
            text: emojiData[2],
        }
        : {
            id: DEFAULT_EMOJI_ID,
            shortName: ":" + acName + ":",
            text: '',
        };
}
function emojiIdToAcName(emojiId) {
    var filterEmojis = function (acName) {
        return acNameToEmojiMap[acName] ? acNameToEmojiMap[acName][0] === emojiId : false;
    };
    return Object.keys(acNameToEmojiMap).filter(filterEmojis)[0];
}
function acShortcutToEmoji(hipchatEmoticonShortName) {
    return {
        id: "" + HC_EMOTICON_PREFIX + hipchatEmoticonShortName,
        shortName: ":" + hipchatEmoticonShortName + ":",
        text: '',
    };
}
function getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function getEmojiAcName(_a) {
    var id = _a.id, shortName = _a.shortName;
    if (DEFAULT_EMOJI_ID === id) {
        var possibleName = getAcNameFromShortName(shortName);
        if (possibleName in acNameToEmojiMap) {
            return possibleName;
        }
    }
    return emojiIdToAcName(id) || DEFAULT_EMOJI_ACNAME;
}
//# sourceMappingURL=emoji.js.map

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__em__ = __webpack_require__(1680);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__em__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__code__ = __webpack_require__(1681);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__code__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__strike__ = __webpack_require__(1682);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_2__strike__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__strong__ = __webpack_require__(1683);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_3__strong__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__underline__ = __webpack_require__(1684);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_4__underline__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__link__ = __webpack_require__(1685);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_5__link__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_5__link__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emoji_query__ = __webpack_require__(1687);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__emoji_query__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__type_ahead_query__ = __webpack_require__(1688);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_7__type_ahead_query__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__subsup__ = __webpack_require__(1689);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_8__subsup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__text_color__ = __webpack_require__(1690);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_9__text_color__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_9__text_color__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_9__text_color__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__confluence_inline_comment__ = __webpack_require__(1691);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_10__confluence_inline_comment__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__action__ = __webpack_require__(1692);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_11__action__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__breakout__ = __webpack_require__(1693);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_12__breakout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__alignment__ = __webpack_require__(1694);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_13__alignment__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_13__alignment__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__indentation__ = __webpack_require__(1695);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_14__indentation__["a"]; });















//# sourceMappingURL=index.js.map

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isSafeUrl; });
/* unused harmony export getLinkMatch */
/* harmony export (immutable) */ __webpack_exports__["b"] = normalizeUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_linkify_it__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_linkify_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_linkify_it__);

var whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    /^notes:/im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
];
var isSafeUrl = function (url) {
    return whitelistedURLPatterns.some(function (p) { return p.test(url.trim()) === true; });
};
var linkify = __WEBPACK_IMPORTED_MODULE_0_linkify_it__();
linkify.add('sourcetree:', 'http:');
function getLinkMatch(str) {
    var match = str && linkify.match(str);
    return match && match[0];
}
/**
 * Adds protocol to url if needed.
 */
function normalizeUrl(url) {
    var match = getLinkMatch(url);
    return (match && match.url) || url;
}
//# sourceMappingURL=url.js.map

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports=/[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports=/[\0-\x1F\x7F-\x9F]/

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports=/[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/

/***/ }),
/* 639 */
/***/ (function(module, exports) {

/**
 * @category Common Helpers
 * @summary Is the given argument an instance of Date?
 *
 * @description
 * Is the given argument an instance of Date?
 *
 * @param {*} argument - the argument to check
 * @returns {Boolean} the given argument is an instance of Date
 *
 * @example
 * // Is 'mayonnaise' a Date?
 * var result = isDate('mayonnaise')
 * //=> false
 */
function isDate (argument) {
  return argument instanceof Date
}

module.exports = isDate


/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(641);

var defaultTheme = {
  mode: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_THEME_MODE */]
};
function getTheme(props) {
  if (props && props.theme && props.theme.__ATLASKIT_THEME__) {
    // $FlowFixMe - cannot narrow type between input types
    return props.theme.__ATLASKIT_THEME__;
  } else if (props && props.theme && props.theme.mode) {
    // $FlowFixMe - cannot narrow type between input types
    return props.theme;
  }

  return defaultTheme;
}

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FLATTENED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_THEME_MODE; });
/* unused harmony export THEME_MODES */
var FLATTENED = '__FLATTENED__';
var CHANNEL = '__ATLASKIT_THEME__';
var DEFAULT_THEME_MODE = 'light';
var THEME_MODES = ['light', 'dark'];

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PanelSharedCssClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return panelSharedStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(156);

// @ts-ignore: unused variable
// prettier-ignore



var PanelSharedCssClassName = {
    PANEL_CONTAINER: 'ak-editor-panel',
};
var panelSharedStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  & .", " {\n    border-radius: ", "px;\n    margin: ", "px 0;\n    padding: ", "px;\n    min-width: ", "px;\n    display: flex;\n    align-items: baseline;\n    word-break: break-word;\n\n    .ak-editor-panel__icon {\n      display: block;\n      flex-shrink: 0;\n      height: ", "px;\n      width: ", "px;\n      box-sizing: content-box;\n      padding-right: ", "px;\n\n      > span {\n        vertical-align: middle;\n        display: inline;\n      }\n    }\n\n    .ak-editor-panel__content {\n      margin: 1px 0 1px;\n      flex: 1 0 0;\n    }\n  }\n"], ["\n  & .", " {\n    border-radius: ", "px;\n    margin: ", "px 0;\n    padding: ", "px;\n    min-width: ", "px;\n    display: flex;\n    align-items: baseline;\n    word-break: break-word;\n\n    .ak-editor-panel__icon {\n      display: block;\n      flex-shrink: 0;\n      height: ", "px;\n      width: ", "px;\n      box-sizing: content-box;\n      padding-right: ", "px;\n\n      > span {\n        vertical-align: middle;\n        display: inline;\n      }\n    }\n\n    .ak-editor-panel__content {\n      margin: 1px 0 1px;\n      flex: 1 0 0;\n    }\n  }\n"])), PanelSharedCssClassName.PANEL_CONTAINER, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])(), Object(__WEBPACK_IMPORTED_MODULE_3__consts__["w" /* relativeSize */])(1.142), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])(), __WEBPACK_IMPORTED_MODULE_3__consts__["m" /* akEditorTableCellMinWidth */], Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() * 3, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() * 3, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])());
var templateObject_1;
//# sourceMappingURL=panel.js.map

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Emoji__ = __webpack_require__(1736);
/* unused harmony reexport Emoji */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MediaSingle__ = __webpack_require__(1895);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__MediaSingle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MediaSingle_styled__ = __webpack_require__(702);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__MediaSingle_styled__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MediaSingle_grid__ = __webpack_require__(703);
/* unused harmony reexport layoutSupportsWidth */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__MediaSingle_grid__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_3__MediaSingle_grid__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_3__MediaSingle_grid__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__MediaSingle_grid__["a"]; });
/* unused harmony reexport snapToGrid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Mention__ = __webpack_require__(1896);
/* unused harmony reexport Mention */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Popup__ = __webpack_require__(732);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__Popup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UnsupportedBlock__ = __webpack_require__(1997);
/* unused harmony reexport UnsupportedBlock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BaseTheme__ = __webpack_require__(1998);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__BaseTheme__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_7__BaseTheme__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__with_outer_listeners__ = __webpack_require__(733);
/* unused harmony reexport withOuterListeners */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WidthProvider__ = __webpack_require__(734);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_9__WidthProvider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_9__WidthProvider__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_9__WidthProvider__["d"]; });










//# sourceMappingURL=index.js.map

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildCredentials; });
var buildCredentials = function (secOptions) {
    return secOptions && secOptions.omitCredentials
        ? 'omit'
        : 'include';
};
//# sourceMappingURL=types.js.map

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(646)(module), __webpack_require__(43)))

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(1740);
exports.encode = exports.stringify = __webpack_require__(1741);


/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popper__ = __webpack_require__(1746);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["b"]; });


/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.6
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;


  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthOddness = reference.width % 2 === popper.width % 2;
  var bothOddWidth = reference.width % 2 === 1 && popper.width % 2 === 1;
  var noRound = function noRound(v) {
    return v;
  };

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthOddness ? Math.round : Math.floor;
  var verticalToInteger = !shouldRound ? noRound : Math.round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(43)))

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return unwrapArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return safeInvoke; });


/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};

/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */
var safeInvoke = function safeInvoke(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (typeof fn === "function") {
    return fn.apply(undefined, args);
  }
};

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnalyticsEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__);






var AnalyticsEvent =
/*#__PURE__*/
function () {
  function AnalyticsEvent(props) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, AnalyticsEvent);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(this, "payload", void 0);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(this, "clone", function () {
      // We stringify and parse here to get a hacky "deep clone" of the object.
      // This has some limitations in that it wont support functions, regexs, Maps, Sets, etc,
      // but none of those need to be represented in our payload, so we consider this fine
      var payload = JSON.parse(JSON.stringify(_this.payload));
      return new AnalyticsEvent({
        payload: payload
      });
    });

    this.payload = props.payload;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(AnalyticsEvent, [{
    key: "update",
    value: function update(updater) {
      if (typeof updater === 'function') {
        this.payload = updater(this.payload);
      } else if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(updater) === 'object') {
        this.payload = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, this.payload, updater);
      }

      return this;
    }
  }]);

  return AnalyticsEvent;
}();



/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnalyticsContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);










var ContextTypes = {
  getAtlaskitAnalyticsContext: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
};

var AnalyticsContext =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(AnalyticsContext, _Component);

  function AnalyticsContext() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, AnalyticsContext);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(AnalyticsContext)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getChildContext", function () {
      return {
        getAtlaskitAnalyticsContext: _this.getAnalyticsContext
      };
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getAnalyticsContext", function () {
      var data = _this.props.data;
      var getAtlaskitAnalyticsContext = _this.context.getAtlaskitAnalyticsContext;
      var ancestorData = typeof getAtlaskitAnalyticsContext === 'function' && getAtlaskitAnalyticsContext() || [];
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(ancestorData).concat([data]);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(AnalyticsContext, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_8_react__["Children"].only(this.props.children);
    }
  }]);

  return AnalyticsContext;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(AnalyticsContext, "contextTypes", ContextTypes);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(AnalyticsContext, "childContextTypes", ContextTypes);



/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/tooltip","version":"12.1.14","sideEffects":false}

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TooltipPrimitive */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tooltip; });
/* unused harmony export Target */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);


var backgroundColor = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N800,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN0
});
var textColor = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N0,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN600
});

var truncate = function truncate(p) {
  return p.truncate ? Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n        max-width: 420px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      "]) : '';
};

var TooltipPrimitive = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "styled__TooltipPrimitive",
  componentId: "fadon5-0"
})(["\n  z-index: ", ";\n  pointer-events: none;\n  position: fixed;\n"], __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["layers"].tooltip);
var Tooltip = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(TooltipPrimitive).withConfig({
  displayName: "styled__Tooltip",
  componentId: "fadon5-1"
})(["\n  background-color: ", ";\n  border-radius: ", "px;\n  box-sizing: border-box;\n  color: ", ";\n  font-size: 12px;\n  left: 0;\n  line-height: 1.3;\n  max-width: 240px;\n  padding: 2px 6px;\n  top: 0;\n  /* Edge does not support overflow-wrap */\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  ", ";\n"], backgroundColor, __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["borderRadius"], textColor, truncate); // The inline-block here is needed to keep the tooltip appearing in the correct position
// when nested inside a wider parent (see position: relative example).

var Target = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "styled__Target",
  componentId: "fadon5-2"
})(["\n  display: inline-block;\n"]);

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(18));

var _reactLifecyclesCompat = __webpack_require__(72);

var _PropTypes = __webpack_require__(656);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts(); // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing); // FIXME: appear timeout?


      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }

      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    var pt = process.env.NODE_ENV !== "production" ? _PropTypes.timeoutsShape : {};;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.transitionTimeout = transitionTimeout;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(10));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;
  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.'); // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number
}).isRequired]);

exports.timeoutsShape = timeoutsShape;

var classNamesShape = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]);

exports.classNamesShape = classNamesShape;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(72);

var _ChildMapping = __webpack_require__(1767);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};;
var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 658 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 659 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var getComponentName = function (target) {
    if (target.displayName && typeof target.displayName === 'string') {
        return target.displayName;
    }
    return target.name || 'Component';
};
var warnIfDeprecatedAppearance = function (appearance) {
    var deprecatedAppearances = ['help'];
    if (appearance && deprecatedAppearances.indexOf(appearance) !== -1) {
        // tslint:disable-next-line:no-console
        console.warn("Atlaskit: The Button appearance \"" + appearance + "\" is deprecated. Please use styled-components' ThemeProvider to provide a custom theme for Button instead.");
    }
};
var withDeprecationWarnings = function (Component) {
    var _a;
    return _a = /** @class */ (function (_super) {
            __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WithDeprecationWarnings, _super);
            function WithDeprecationWarnings() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            WithDeprecationWarnings.prototype.componentWillMount = function () {
                warnIfDeprecatedAppearance(this.props.appearance);
            };
            WithDeprecationWarnings.prototype.componentWillReceiveProps = function (newProps) {
                if (newProps.appearance !== this.props.appearance) {
                    warnIfDeprecatedAppearance(newProps.appearance);
                }
            };
            WithDeprecationWarnings.prototype.render = function () {
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Component, this.props);
            };
            return WithDeprecationWarnings;
        }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"])),
        _a.displayName = "WithDeprecationWarnings(" + getComponentName(Component) + ")",
        _a;
};
/* harmony default export */ __webpack_exports__["a"] = (withDeprecationWarnings);
//# sourceMappingURL=withDeprecationWarnings.js.map

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themeNamespace; });
var themeNamespace = '@atlaskit-shared-theme/button';
//# sourceMappingURL=theme.js.map

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isLoadingStyle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLoadingStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var isLoadingStyle = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  transition: opacity 0.3s;\n  opacity: ", ";\n"], ["\n  transition: opacity 0.3s;\n  opacity: ", ";\n"])), function (_a) {
    var isLoading = _a.isLoading;
    return (isLoading ? 0 : 1);
});
var getLoadingStyle = function (_a) {
    var isLoading = _a.isLoading;
    return ({
        transition: 'opacity 0.3s',
        opacity: isLoading ? 0 : 1,
    });
};

var templateObject_1;
//# sourceMappingURL=utils.js.map

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(18));

var _reactLifecyclesCompat = __webpack_require__(72);

var _PropTypes = __webpack_require__(664);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts(); // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing); // FIXME: appear timeout?


      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }

      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    var pt = process.env.NODE_ENV !== "production" ? _PropTypes.timeoutsShape : {};;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.transitionTimeout = transitionTimeout;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(10));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;
  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.'); // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number
}).isRequired]);

exports.timeoutsShape = timeoutsShape;

var classNamesShape = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]);

exports.classNamesShape = classNamesShape;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(72);

var _ChildMapping = __webpack_require__(1784);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};;
var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SIZES_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_SIZE; });
var SIZES_MAP = {
  xsmall: 8,
  small: 16,
  medium: 24,
  large: 48,
  xlarge: 96
};
var DEFAULT_SIZE = SIZES_MAP.small;

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withDefaultProps; });
var withDefaultProps = function (defaultProps, Component) {
    Component.defaultProps = defaultProps;
    return Component;
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The unique id is used for unique hashes.
 */
var uniqueId = 0;
/**
 * Tag styles with this string to get unique hashes.
 */
exports.IS_UNIQUE = '__DO_NOT_DEDUPE_STYLE__';
var upperCasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var interpolatePattern = /&/g;
var escapePattern = /[ !#$%&()*+,./;<=>?@[\]^`{|}~"'\\]/g;
var propLower = function (m) { return "-" + m.toLowerCase(); };
/**
 * CSS properties that are valid unit-less numbers.
 */
var cssNumberProperties = [
    'animation-iteration-count',
    'box-flex',
    'box-flex-group',
    'column-count',
    'counter-increment',
    'counter-reset',
    'flex',
    'flex-grow',
    'flex-positive',
    'flex-shrink',
    'flex-negative',
    'font-weight',
    'line-clamp',
    'line-height',
    'opacity',
    'order',
    'orphans',
    'tab-size',
    'widows',
    'z-index',
    'zoom',
    // SVG properties.
    'fill-opacity',
    'stroke-dashoffset',
    'stroke-opacity',
    'stroke-width'
];
/**
 * Map of css number properties.
 */
var CSS_NUMBER = Object.create(null);
// Add vendor prefixes to all unit-less properties.
for (var _i = 0, _a = ['-webkit-', '-ms-', '-moz-', '-o-', '']; _i < _a.length; _i++) {
    var prefix = _a[_i];
    for (var _b = 0, cssNumberProperties_1 = cssNumberProperties; _b < cssNumberProperties_1.length; _b++) {
        var property = cssNumberProperties_1[_b];
        CSS_NUMBER[prefix + property] = true;
    }
}
/**
 * Escape a CSS class name.
 */
exports.escape = function (str) { return str.replace(escapePattern, '\\$&'); };
/**
 * Transform a JavaScript property into a CSS property.
 */
function hyphenate(propertyName) {
    return propertyName
        .replace(upperCasePattern, propLower)
        .replace(msPattern, '-ms-'); // Internet Explorer vendor prefix.
}
exports.hyphenate = hyphenate;
/**
 * Generate a hash value from a string.
 */
function stringHash(str) {
    var value = 5381;
    var len = str.length;
    while (len--)
        value = (value * 33) ^ str.charCodeAt(len);
    return (value >>> 0).toString(36);
}
exports.stringHash = stringHash;
/**
 * Transform a style string to a CSS string.
 */
function styleToString(key, value) {
    if (typeof value === 'number' && value !== 0 && !CSS_NUMBER[key]) {
        return key + ":" + value + "px";
    }
    return key + ":" + value;
}
/**
 * Sort an array of tuples by first value.
 */
function sortTuples(value) {
    return value.sort(function (a, b) { return a[0] > b[0] ? 1 : -1; });
}
/**
 * Categorize user styles.
 */
function parseStyles(styles, hasNestedStyles) {
    var properties = [];
    var nestedStyles = [];
    var isUnique = false;
    // Sort keys before adding to styles.
    for (var _i = 0, _a = Object.keys(styles); _i < _a.length; _i++) {
        var key = _a[_i];
        var value = styles[key];
        if (value !== null && value !== undefined) {
            if (key === exports.IS_UNIQUE) {
                isUnique = true;
            }
            else if (typeof value === 'object' && !Array.isArray(value)) {
                nestedStyles.push([key.trim(), value]);
            }
            else {
                properties.push([hyphenate(key.trim()), value]);
            }
        }
    }
    return {
        styleString: stringifyProperties(sortTuples(properties)),
        nestedStyles: hasNestedStyles ? nestedStyles : sortTuples(nestedStyles),
        isUnique: isUnique
    };
}
/**
 * Stringify an array of property tuples.
 */
function stringifyProperties(properties) {
    return properties.map(function (_a) {
        var name = _a[0], value = _a[1];
        if (!Array.isArray(value))
            return styleToString(name, value);
        return value.map(function (x) { return styleToString(name, x); }).join(';');
    }).join(';');
}
/**
 * Interpolate CSS selectors.
 */
function interpolate(selector, parent) {
    if (selector.indexOf('&') > -1) {
        return selector.replace(interpolatePattern, parent);
    }
    return parent + " " + selector;
}
/**
 * Recursive loop building styles with deferred selectors.
 */
function stylize(cache, selector, styles, list, parent) {
    var _a = parseStyles(styles, !!selector), styleString = _a.styleString, nestedStyles = _a.nestedStyles, isUnique = _a.isUnique;
    var pid = styleString;
    if (selector.charCodeAt(0) === 64 /* @ */) {
        var rule = cache.add(new Rule(selector, parent ? undefined : styleString, cache.hash));
        // Nested styles support (e.g. `.foo > @media > .bar`).
        if (styleString && parent) {
            var style = rule.add(new Style(styleString, rule.hash, isUnique ? "u" + (++uniqueId).toString(36) : undefined));
            list.push([parent, style]);
        }
        for (var _i = 0, nestedStyles_1 = nestedStyles; _i < nestedStyles_1.length; _i++) {
            var _b = nestedStyles_1[_i], name = _b[0], value = _b[1];
            pid += name + stylize(rule, name, value, list, parent);
        }
    }
    else {
        var key = parent ? interpolate(selector, parent) : selector;
        if (styleString) {
            var style = cache.add(new Style(styleString, cache.hash, isUnique ? "u" + (++uniqueId).toString(36) : undefined));
            list.push([key, style]);
        }
        for (var _c = 0, nestedStyles_2 = nestedStyles; _c < nestedStyles_2.length; _c++) {
            var _d = nestedStyles_2[_c], name = _d[0], value = _d[1];
            pid += name + stylize(cache, name, value, list, key);
        }
    }
    return pid;
}
/**
 * Register all styles, but collect for selector interpolation using the hash.
 */
function composeStyles(container, selector, styles, isStyle, displayName) {
    var cache = new Cache(container.hash);
    var list = [];
    var pid = stylize(cache, selector, styles, list);
    var hash = "f" + cache.hash(pid);
    var id = displayName ? displayName + "_" + hash : hash;
    for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
        var _a = list_1[_i], selector_1 = _a[0], style = _a[1];
        var key = isStyle ? interpolate(selector_1, "." + exports.escape(id)) : selector_1;
        style.add(new Selector(key, style.hash, undefined, pid));
    }
    return { cache: cache, pid: pid, id: id };
}
/**
 * Cache to list to styles.
 */
function join(arr) {
    var res = '';
    for (var i = 0; i < arr.length; i++)
        res += arr[i];
    return res;
}
/**
 * Noop changes.
 */
var noopChanges = {
    add: function () { return undefined; },
    change: function () { return undefined; },
    remove: function () { return undefined; }
};
/**
 * Implement a cache/event emitter.
 */
var Cache = /** @class */ (function () {
    function Cache(hash, changes) {
        if (hash === void 0) { hash = stringHash; }
        if (changes === void 0) { changes = noopChanges; }
        this.hash = hash;
        this.changes = changes;
        this.sheet = [];
        this.changeId = 0;
        this._keys = [];
        this._children = Object.create(null);
        this._counters = Object.create(null);
    }
    Cache.prototype.add = function (style) {
        var count = this._counters[style.id] || 0;
        var item = this._children[style.id] || style.clone();
        this._counters[style.id] = count + 1;
        if (count === 0) {
            this._children[item.id] = item;
            this._keys.push(item.id);
            this.sheet.push(item.getStyles());
            this.changeId++;
            this.changes.add(item, this._keys.length - 1);
        }
        else {
            // Check if contents are different.
            if (item.getIdentifier() !== style.getIdentifier()) {
                throw new TypeError("Hash collision: " + style.getStyles() + " === " + item.getStyles());
            }
            var oldIndex = this._keys.indexOf(style.id);
            var newIndex = this._keys.length - 1;
            var prevChangeId = this.changeId;
            if (oldIndex !== newIndex) {
                this._keys.splice(oldIndex, 1);
                this._keys.push(style.id);
                this.changeId++;
            }
            if (item instanceof Cache && style instanceof Cache) {
                var prevChangeId_1 = item.changeId;
                item.merge(style);
                if (item.changeId !== prevChangeId_1) {
                    this.changeId++;
                }
            }
            if (this.changeId !== prevChangeId) {
                if (oldIndex === newIndex) {
                    this.sheet.splice(oldIndex, 1, item.getStyles());
                }
                else {
                    this.sheet.splice(oldIndex, 1);
                    this.sheet.splice(newIndex, 0, item.getStyles());
                }
                this.changes.change(item, oldIndex, newIndex);
            }
        }
        return item;
    };
    Cache.prototype.remove = function (style) {
        var count = this._counters[style.id];
        if (count > 0) {
            this._counters[style.id] = count - 1;
            var item = this._children[style.id];
            var index = this._keys.indexOf(item.id);
            if (count === 1) {
                delete this._counters[style.id];
                delete this._children[style.id];
                this._keys.splice(index, 1);
                this.sheet.splice(index, 1);
                this.changeId++;
                this.changes.remove(item, index);
            }
            else if (item instanceof Cache && style instanceof Cache) {
                var prevChangeId = item.changeId;
                item.unmerge(style);
                if (item.changeId !== prevChangeId) {
                    this.sheet.splice(index, 1, item.getStyles());
                    this.changeId++;
                    this.changes.change(item, index, index);
                }
            }
        }
    };
    Cache.prototype.merge = function (cache) {
        for (var _i = 0, _a = cache._keys; _i < _a.length; _i++) {
            var id = _a[_i];
            this.add(cache._children[id]);
        }
        return this;
    };
    Cache.prototype.unmerge = function (cache) {
        for (var _i = 0, _a = cache._keys; _i < _a.length; _i++) {
            var id = _a[_i];
            this.remove(cache._children[id]);
        }
        return this;
    };
    Cache.prototype.clone = function () {
        return new Cache(this.hash).merge(this);
    };
    return Cache;
}());
exports.Cache = Cache;
/**
 * Selector is a dumb class made to represent nested CSS selectors.
 */
var Selector = /** @class */ (function () {
    function Selector(selector, hash, id, pid) {
        if (id === void 0) { id = "s" + hash(selector); }
        if (pid === void 0) { pid = ''; }
        this.selector = selector;
        this.hash = hash;
        this.id = id;
        this.pid = pid;
    }
    Selector.prototype.getStyles = function () {
        return this.selector;
    };
    Selector.prototype.getIdentifier = function () {
        return this.pid + "." + this.selector;
    };
    Selector.prototype.clone = function () {
        return new Selector(this.selector, this.hash, this.id, this.pid);
    };
    return Selector;
}());
exports.Selector = Selector;
/**
 * The style container registers a style string with selectors.
 */
var Style = /** @class */ (function (_super) {
    __extends(Style, _super);
    function Style(style, hash, id) {
        if (id === void 0) { id = "c" + hash(style); }
        var _this = _super.call(this, hash) || this;
        _this.style = style;
        _this.hash = hash;
        _this.id = id;
        return _this;
    }
    Style.prototype.getStyles = function () {
        return this.sheet.join(',') + "{" + this.style + "}";
    };
    Style.prototype.getIdentifier = function () {
        return this.style;
    };
    Style.prototype.clone = function () {
        return new Style(this.style, this.hash, this.id).merge(this);
    };
    return Style;
}(Cache));
exports.Style = Style;
/**
 * Implement rule logic for style output.
 */
var Rule = /** @class */ (function (_super) {
    __extends(Rule, _super);
    function Rule(rule, style, hash, id, pid) {
        if (style === void 0) { style = ''; }
        if (id === void 0) { id = "a" + hash(rule + "." + style); }
        if (pid === void 0) { pid = ''; }
        var _this = _super.call(this, hash) || this;
        _this.rule = rule;
        _this.style = style;
        _this.hash = hash;
        _this.id = id;
        _this.pid = pid;
        return _this;
    }
    Rule.prototype.getStyles = function () {
        return this.rule + "{" + this.style + join(this.sheet) + "}";
    };
    Rule.prototype.getIdentifier = function () {
        return this.pid + "." + this.rule + "." + this.style;
    };
    Rule.prototype.clone = function () {
        return new Rule(this.rule, this.style, this.hash, this.id, this.pid).merge(this);
    };
    return Rule;
}(Cache));
exports.Rule = Rule;
/**
 * The FreeStyle class implements the API for everything else.
 */
var FreeStyle = /** @class */ (function (_super) {
    __extends(FreeStyle, _super);
    function FreeStyle(hash, debug, id, changes) {
        if (hash === void 0) { hash = stringHash; }
        if (debug === void 0) { debug = typeof process !== 'undefined' && "production" !== 'production'; }
        if (id === void 0) { id = "f" + (++uniqueId).toString(36); }
        var _this = _super.call(this, hash, changes) || this;
        _this.hash = hash;
        _this.debug = debug;
        _this.id = id;
        return _this;
    }
    FreeStyle.prototype.registerStyle = function (styles, displayName) {
        var debugName = this.debug ? displayName : undefined;
        var _a = composeStyles(this, '&', styles, true, debugName), cache = _a.cache, id = _a.id;
        this.merge(cache);
        return id;
    };
    FreeStyle.prototype.registerKeyframes = function (keyframes, displayName) {
        return this.registerHashRule('@keyframes', keyframes, displayName);
    };
    FreeStyle.prototype.registerHashRule = function (prefix, styles, displayName) {
        var debugName = this.debug ? displayName : undefined;
        var _a = composeStyles(this, '', styles, false, debugName), cache = _a.cache, pid = _a.pid, id = _a.id;
        var rule = new Rule(prefix + " " + exports.escape(id), undefined, this.hash, undefined, pid);
        this.add(rule.merge(cache));
        return id;
    };
    FreeStyle.prototype.registerRule = function (rule, styles) {
        this.merge(composeStyles(this, rule, styles, false).cache);
    };
    FreeStyle.prototype.registerCss = function (styles) {
        this.merge(composeStyles(this, '', styles, false).cache);
    };
    FreeStyle.prototype.getStyles = function () {
        return join(this.sheet);
    };
    FreeStyle.prototype.getIdentifier = function () {
        return this.id;
    };
    FreeStyle.prototype.clone = function () {
        return new FreeStyle(this.hash, this.debug, this.id, this.changes).merge(this);
    };
    return FreeStyle;
}(Cache));
exports.FreeStyle = FreeStyle;
/**
 * Exports a simple function to create a new instance.
 */
function create(hash, debug, changes) {
    return new FreeStyle(hash, debug, undefined, changes);
}
exports.create = create;
//# sourceMappingURL=free-style.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(122)))

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return raf; });
/* unused harmony export classes */
/* harmony export (immutable) */ __webpack_exports__["a"] = extend;
/* unused harmony export media */
/** Raf for node + browser */
var raf = typeof requestAnimationFrame === 'undefined'
    ? function (cb) { return setTimeout(cb); }
    : typeof window === 'undefined'
        ? requestAnimationFrame
        : requestAnimationFrame.bind(window);
/**
 * Utility to join classes conditionally
 */
function classes() {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.filter(function (c) { return !!c; }).join(' ');
}
/**
 * Merges various styles into a single style object.
 * Note: if two objects have the same property the last one wins
 */
function extend() {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    /** The final result we will return */
    var result = {};
    for (var _a = 0, objects_1 = objects; _a < objects_1.length; _a++) {
        var object = objects_1[_a];
        if (object == null || object === false) {
            continue;
        }
        for (var key in object) {
            /** Falsy values except a explicit 0 is ignored */
            var val = object[key];
            if (!val && val !== 0) {
                continue;
            }
            /** if nested media or pseudo selector */
            if (key === '$nest' && val) {
                result[key] = result['$nest'] ? extend(result['$nest'], val) : val;
            }
            else if ((key.indexOf('&') !== -1 || key.indexOf('@media') === 0)) {
                result[key] = result[key] ? extend(result[key], val) : val;
            }
            else {
                result[key] = val;
            }
        }
    }
    return result;
}
/**
 * Utility to help customize styles with media queries. e.g.
 * ```
 * style(
 *  media({maxWidth:500}, {color:'red'})
 * )
 * ```
 */
var media = function (mediaQuery) {
    var objects = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        objects[_i - 1] = arguments[_i];
    }
    var mediaQuerySections = [];
    if (mediaQuery.type)
        mediaQuerySections.push(mediaQuery.type);
    if (mediaQuery.orientation)
        mediaQuerySections.push("(orientation: " + mediaQuery.orientation + ")");
    if (mediaQuery.minWidth)
        mediaQuerySections.push("(min-width: " + mediaLength(mediaQuery.minWidth) + ")");
    if (mediaQuery.maxWidth)
        mediaQuerySections.push("(max-width: " + mediaLength(mediaQuery.maxWidth) + ")");
    if (mediaQuery.minHeight)
        mediaQuerySections.push("(min-height: " + mediaLength(mediaQuery.minHeight) + ")");
    if (mediaQuery.maxHeight)
        mediaQuerySections.push("(max-height: " + mediaLength(mediaQuery.maxHeight) + ")");
    var stringMediaQuery = "@media " + mediaQuerySections.join(' and ');
    var object = {
        $nest: (_a = {},
            _a[stringMediaQuery] = extend.apply(void 0, objects),
            _a)
    };
    return object;
    var _a;
};
var mediaLength = function (value) {
    return typeof value === 'string' ? value : value + "px";
};


/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
The matchEvent method is responsible for deciding whether a Decorator or
Listener should take action based on the event name and the `match` prop.
*/
var ENDS_WITH_DOT = /\.$/;

function matchEvent(matcher, name) {
  if (matcher === '*' || name === undefined) {
    return true;
  }

  if (typeof matcher === 'string') {
    if (ENDS_WITH_DOT.test(matcher)) {
      return name.substr(0, matcher.length) === matcher;
    }

    return name === matcher;
  }

  if (typeof matcher === 'function') {
    return matcher(name);
  }

  if (matcher instanceof RegExp) {
    return matcher.test(name);
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (matchEvent);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FieldBaseStateless; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_inline_dialog__ = __webpack_require__(1802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled_Content__ = __webpack_require__(1806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ValidationElement__ = __webpack_require__(1808);











var FieldBaseStateless =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(FieldBaseStateless, _Component);

  function FieldBaseStateless() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, FieldBaseStateless);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(FieldBaseStateless).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(FieldBaseStateless, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.shouldReset) {
        this.props.onBlur();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          appearance = _this$props.appearance,
          children = _this$props.children,
          invalidMessage = _this$props.invalidMessage,
          isCompact = _this$props.isCompact,
          isDialogOpen = _this$props.isDialogOpen,
          isDisabled = _this$props.isDisabled,
          isFitContainerWidthEnabled = _this$props.isFitContainerWidthEnabled,
          isFocused = _this$props.isFocused,
          isInvalid = _this$props.isInvalid,
          isLoading = _this$props.isLoading,
          isPaddingDisabled = _this$props.isPaddingDisabled,
          isReadOnly = _this$props.isReadOnly,
          maxWidth = _this$props.maxWidth,
          onBlur = _this$props.onBlur,
          onDialogBlur = _this$props.onDialogBlur,
          onDialogClick = _this$props.onDialogClick,
          onDialogFocus = _this$props.onDialogFocus,
          onFocus = _this$props.onFocus,
          isValidationHidden = _this$props.isValidationHidden;

      function getAppearance(a) {
        if (isDisabled) return 'disabled';
        if (isInvalid) return 'invalid';
        return a;
      }

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styled_Content__["c" /* ContentWrapper */], {
        disabled: isDisabled,
        maxWidth: maxWidth,
        grow: isFitContainerWidthEnabled
      }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__atlaskit_inline_dialog__["a" /* default */], {
        content: invalidMessage,
        isOpen: isDialogOpen && !!invalidMessage && !isValidationHidden,
        onContentBlur: onDialogBlur,
        onContentClick: onDialogClick,
        onContentFocus: onDialogFocus,
        placement: "right"
      }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styled_Content__["a" /* ChildWrapper */], {
        compact: isCompact
      }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styled_Content__["b" /* Content */], {
        appearance: getAppearance(appearance),
        compact: isCompact,
        disabled: isDisabled,
        isFocused: isFocused,
        invalid: isInvalid && !isFocused,
        none: appearance === 'none',
        onBlurCapture: onBlur,
        onFocusCapture: onFocus,
        paddingDisabled: isPaddingDisabled,
        readOnly: isReadOnly,
        subtle: appearance === 'subtle'
      }, children, !isValidationHidden ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ValidationElement__["a" /* default */], {
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        isLoading: isLoading
      }) : null))));
    }
  }]);

  return FieldBaseStateless;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(FieldBaseStateless, "defaultProps", {
  appearance: 'standard',
  invalidMessage: '',
  isCompact: false,
  isDialogOpen: false,
  isDisabled: false,
  isFitContainerWidthEnabled: false,
  isFocused: false,
  isInvalid: false,
  isLoading: false,
  isPaddingDisabled: false,
  isReadOnly: false,
  onDialogBlur: function onDialogBlur() {},
  onDialogClick: function onDialogClick() {},
  onDialogFocus: function onDialogFocus() {},
  shouldReset: false,
  isValidationHidden: false
});



/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TfIdfSearchIndex = __webpack_require__(1822);

Object.defineProperty(exports, 'TfIdfSearchIndex', {
  enumerable: true,
  get: function get() {
    return _TfIdfSearchIndex.TfIdfSearchIndex;
  }
});

var _UnorderedSearchIndex = __webpack_require__(1823);

Object.defineProperty(exports, 'UnorderedSearchIndex', {
  enumerable: true,
  get: function get() {
    return _UnorderedSearchIndex.UnorderedSearchIndex;
  }
});
//# sourceMappingURL=index.js.map

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getNestedFieldValue;
/**
 * Find and return a nested object value.
 *
 * @param object to crawl
 * @param path Property path
 * @returns {any}
 */
function getNestedFieldValue(object, path) {
  path = path || [];
  object = object || {};

  var value = object;

  // walk down the property path
  for (var i = 0; i < path.length; i++) {
    value = value[path[i]];

    if (value == null) {
      return null;
    }
  }

  return value;
}
//# sourceMappingURL=getNestedFieldValue.js.map

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleTokenizer = __webpack_require__(1824);

Object.defineProperty(exports, 'SimpleTokenizer', {
  enumerable: true,
  get: function get() {
    return _SimpleTokenizer.SimpleTokenizer;
  }
});

var _StemmingTokenizer = __webpack_require__(1825);

Object.defineProperty(exports, 'StemmingTokenizer', {
  enumerable: true,
  get: function get() {
    return _StemmingTokenizer.StemmingTokenizer;
  }
});

var _StopWordsTokenizer = __webpack_require__(1826);

Object.defineProperty(exports, 'StopWordsTokenizer', {
  enumerable: true,
  get: function get() {
    return _StopWordsTokenizer.StopWordsTokenizer;
  }
});
//# sourceMappingURL=index.js.map

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var StopWordsMap = exports.StopWordsMap = {
  a: true,
  able: true,
  about: true,
  across: true,
  after: true,
  all: true,
  almost: true,
  also: true,
  am: true,
  among: true,
  an: true,
  and: true,
  any: true,
  are: true,
  as: true,
  at: true,
  be: true,
  because: true,
  been: true,
  but: true,
  by: true,
  can: true,
  cannot: true,
  could: true,
  dear: true,
  did: true,
  'do': true,
  does: true,
  either: true,
  'else': true,
  ever: true,
  every: true,
  'for': true,
  from: true,
  'get': true,
  got: true,
  had: true,
  has: true,
  have: true,
  he: true,
  her: true,
  hers: true,
  him: true,
  his: true,
  how: true,
  however: true,
  i: true,
  'if': true,
  'in': true,
  into: true,
  is: true,
  it: true,
  its: true,
  just: true,
  least: true,
  let: true,
  like: true,
  likely: true,
  may: true,
  me: true,
  might: true,
  most: true,
  must: true,
  my: true,
  neither: true,
  no: true,
  nor: true,
  not: true,
  of: true,
  off: true,
  often: true,
  on: true,
  only: true,
  or: true,
  other: true,
  our: true,
  own: true,
  rather: true,
  said: true,
  say: true,
  says: true,
  she: true,
  should: true,
  since: true,
  so: true,
  some: true,
  than: true,
  that: true,
  the: true,
  their: true,
  them: true,
  then: true,
  there: true,
  these: true,
  they: true,
  'this': true,
  tis: true,
  to: true,
  too: true,
  twas: true,
  us: true,
  wants: true,
  was: true,
  we: true,
  were: true,
  what: true,
  when: true,
  where: true,
  which: true,
  'while': true,
  who: true,
  whom: true,
  why: true,
  will: true,
  'with': true,
  would: true,
  yet: true,
  you: true,
  your: true
};

// Prevent false positives for inherited properties
StopWordsMap.constructor = false;
StopWordsMap.hasOwnProperty = false;
StopWordsMap.isPrototypeOf = false;
StopWordsMap.propertyIsEnumerable = false;
StopWordsMap.toLocaleString = false;
StopWordsMap.toString = false;
StopWordsMap.valueOf = false;
//# sourceMappingURL=StopWordsMap.js.map

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UsageFrequencyTracker; });
/* unused harmony export Gateway */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type_helpers__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DuplicateLimitedQueue__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StoredDuplicateLimitedQueue__ = __webpack_require__(1830);





/**
 * Keeps track of the last 150 emoji usages, although limiting the maximum count for a single emoji to 25 to
 * ensure we don't end up with only a single emoji being recorded. Usage is persisted to local storage for
 * consistency between 'sessions'.
 *
 * Skin tone variations for an emoji will be 'collapsed' so they are tracked as their base emoji. Gender
 * variations are not collapsed in this way and will be tracked per gender. This decision reflects the UI of
 * the EmojiPicker component.
 */
var UsageFrequencyTracker = /** @class */ (function () {
    function UsageFrequencyTracker(useStorageIfPossible) {
        if (useStorageIfPossible === void 0) { useStorageIfPossible = true; }
        var options = UsageFrequencyTracker.queueOptions;
        if (useStorageIfPossible && options.storage) {
            var queueOptions = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, options, { storage: options.storage });
            this.queue = new __WEBPACK_IMPORTED_MODULE_4__StoredDuplicateLimitedQueue__["a" /* default */](queueOptions);
        }
        else {
            this.queue = new __WEBPACK_IMPORTED_MODULE_3__DuplicateLimitedQueue__["a" /* default */](options);
        }
        this.gateway = new Gateway(10);
    }
    /**
     * Record the fact that the supplied emoji was used. You should note that usage is updated asynchronously so you can not
     * count on getOrder() reflecting this usage immediately.
     *
     * @param emoji the emoji who's usage is to be recorded. If the emoji has no id then no usage will be recorded
     */
    UsageFrequencyTracker.prototype.recordUsage = function (emoji) {
        var _this = this;
        var emojiId = emoji.id;
        if (emojiId) {
            if (Object(__WEBPACK_IMPORTED_MODULE_1__type_helpers__["g" /* isEmojiVariationDescription */])(emoji)) {
                emojiId = emoji.baseId;
            }
            this.gateway.submit(function () {
                if (emojiId) {
                    _this.queue.enqueue(emojiId);
                }
            });
        }
    };
    /**
     * Returns an array of emoji id (without skin tone variations) sorted by most used to least used. If there
     * are no usages then an empty array will be returned.
     */
    UsageFrequencyTracker.prototype.getOrder = function () {
        return this.queue.getItemsOrderedByDuplicateCount();
    };
    /**
     * Exposed for testing only. Clear any recorded usage.
     */
    UsageFrequencyTracker.prototype.clear = function () {
        this.queue.clear();
    };
    UsageFrequencyTracker.queueOptions = {
        storage: typeof window !== 'undefined' && window.localStorage,
        storagePrefix: __WEBPACK_IMPORTED_MODULE_2__constants__["m" /* localStoragePrefix */],
        maxDuplicates: 25,
        minUniqueItems: 5,
    };
    return UsageFrequencyTracker;
}());

var Gateway = /** @class */ (function () {
    function Gateway(maximumPermitted) {
        if (maximumPermitted < 1) {
            throw new RangeError('The maximumPermitted parameter must be 1 or more.');
        }
        this.maximumPermitted = maximumPermitted;
        this.count = 0;
    }
    /**
     * Run the supplied function if the count of already submitted work allows it. Drop the work
     * if it's not allowed to run.
     *
     * Will return true if the function has been submitted or false if it was not submitted.
     */
    Gateway.prototype.submit = function (f) {
        var _this = this;
        if (this.count >= this.maximumPermitted) {
            return false;
        }
        this.count++;
        var wrappedFunc = function () {
            try {
                f();
            }
            finally {
                _this.completed();
            }
        };
        window.setTimeout(wrappedFunc);
        return true;
    };
    Gateway.prototype.completed = function () {
        this.count--;
    };
    return Gateway;
}());

//# sourceMappingURL=UsageFrequencyTracker.js.map

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A queue which will limit the number of duplicates of type T that it holds. When the duplicate limit is
 * reached the earliest inserted duplicate (the "original") is removed to make room for the new insertion.
 */
var DuplicateLimitedQueue = /** @class */ (function () {
    /**
     * Construct a new DuplicateLimitedQueue.
     *
     * @param options the options for this queue.
     */
    function DuplicateLimitedQueue(options) {
        if (options.maxDuplicates < 1) {
            throw new RangeError('The maxDuplicates option must be at least 1');
        }
        if (options.minUniqueItems < 1) {
            throw new RangeError('The minUniqueItems option must be at least 1');
        }
        this.maximumSize = options.maxDuplicates * options.minUniqueItems;
        this.perItemSize = options.maxDuplicates;
        this.createEmptyState();
    }
    /**
     * @param item the item to add to the queue.
     */
    DuplicateLimitedQueue.prototype.enqueue = function (item) {
        this.enqueueWithoutOrdering(item);
        // enqueues are less time sensitive (and may happen less frequently) than queries against the queue
        // so do the ordering work on each enqueue.
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    };
    /**
     * Return the items in the queue, ordered by how often they are duplicated. The items with the
     * most duplicates come first in the returned Array.
     *
     * If there are no items in the queue then an empty Array will be returned.
     */
    DuplicateLimitedQueue.prototype.getItemsOrderedByDuplicateCount = function () {
        return this.itemsOrderedByFrequency;
    };
    /**
     * Exposed for storybook/testing purposes only. Clear the contents of the queue.
     */
    DuplicateLimitedQueue.prototype.clear = function () {
        this.createEmptyState();
    };
    /**
     * A more efficient mechanism for adding multiple items. Ordering is only performed once all
     * the items have been added.
     *
     * @param items the items to be enqueued, which happens in their presented order.
     */
    DuplicateLimitedQueue.prototype.bulkEnqueue = function (items) {
        var _this = this;
        items.map(function (item) { return _this.enqueueWithoutOrdering(item); });
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    };
    /**
     * Return the items currently stored in the queue.
     */
    DuplicateLimitedQueue.prototype.getItems = function () {
        return this.items;
    };
    DuplicateLimitedQueue.prototype.createEmptyState = function () {
        this.items = new Array();
        this.itemCountMap = new Map();
        this.itemsOrderedByFrequency = new Array();
    };
    /**
     * Enqueue the supplied item, keeping consistency with the limits configured. However no ordering is
     * performed by this enqueuing. You must trigger that manually if required.
     *
     * @param item the item to be queued
     */
    DuplicateLimitedQueue.prototype.enqueueWithoutOrdering = function (item) {
        var count = this.itemCountMap.get(item);
        if (count && count >= this.perItemSize) {
            // find the first item with that key in the array and remove it
            this.removeFirstOccurrence(item);
        }
        else {
            if (this.items.length >= this.maximumSize) {
                this.remove();
            }
        }
        this.add(item);
    };
    /**
     * Get an array of items from the queue ordered by how often they are duplicated in the queue.
     */
    DuplicateLimitedQueue.prototype.orderItemsByFrequency = function () {
        var orderedEntries = Array.from(this.itemCountMap.entries()).sort(function (a, b) {
            return b[1] - a[1];
        });
        return orderedEntries.map(function (value) { return value[0]; });
    };
    DuplicateLimitedQueue.prototype.decrementCount = function (item) {
        var count = this.itemCountMap.get(item);
        if (count) {
            count--;
            if (count > 0) {
                this.itemCountMap.set(item, count);
            }
            else {
                this.itemCountMap.delete(item);
            }
        }
    };
    /**
     * Walk the list of items and remove the first occurrence of the matching item.
     *
     * @param item the item to be removed.
     */
    DuplicateLimitedQueue.prototype.removeFirstOccurrence = function (item) {
        var index = this.items.indexOf(item);
        if (index !== -1) {
            this.items.splice(index, 1);
            this.decrementCount(item);
        }
    };
    /**
     * Remove the first item from the queue and update the itemCountMap accordingly.
     * @return the item add the front of the queue or undefined if the queue is empty
     */
    DuplicateLimitedQueue.prototype.remove = function () {
        var removed = this.items.shift();
        if (removed !== undefined) {
            this.decrementCount(removed);
        }
        return removed;
    };
    /**
     * Add the supplied item to the end of the queue and update the itemCountMap accordingly.
     * @param item the item to be added to the queue
     */
    DuplicateLimitedQueue.prototype.add = function (item) {
        this.items.push(item);
        var count = this.itemCountMap.get(item);
        if (count) {
            this.itemCountMap.set(item, count + 1);
        }
        else {
            this.itemCountMap.set(item, 1);
        }
    };
    return DuplicateLimitedQueue;
}());
/* harmony default export */ __webpack_exports__["a"] = (DuplicateLimitedQueue);
//# sourceMappingURL=DuplicateLimitedQueue.js.map

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EmojiUtils__ = __webpack_require__(195);

/**
 * Emoji providers should return JSON in the format defined by EmojiServiceResponse.
 */
var EmojiLoader = /** @class */ (function () {
    function EmojiLoader(config) {
        this.config = config;
    }
    /**
     * Returns a promise with an array of Emoji from all providers.
     */
    EmojiLoader.prototype.loadEmoji = function () {
        var emojisPromise = Object(__WEBPACK_IMPORTED_MODULE_0__EmojiUtils__["b" /* emojiRequest */])(this.config);
        return emojisPromise.then(function (emojiServiceResponse) {
            return Object(__WEBPACK_IMPORTED_MODULE_0__EmojiUtils__["a" /* denormaliseEmojiServiceResponse */])(emojiServiceResponse);
        });
    };
    return EmojiLoader;
}());
/* harmony default export */ __webpack_exports__["a"] = (EmojiLoader);
//# sourceMappingURL=EmojiLoader.js.map

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = request;
/* harmony export (immutable) */ __webpack_exports__["c"] = mapResponseToJson;
/* harmony export (immutable) */ __webpack_exports__["b"] = mapResponseToBlob;
/* harmony export (immutable) */ __webpack_exports__["d"] = mapResponseToVoid;
/* harmony export (immutable) */ __webpack_exports__["a"] = createUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__(1837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_auth__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_auth_query_parameters__ = __webpack_require__(1839);




function request(url, options, controller) {
    if (options === void 0) { options = {}; }
    var _a = options.method, method = _a === void 0 ? 'GET' : _a, auth = options.auth, params = options.params, headers = options.headers, body = options.body;
    var processFetchResponse = function (response) {
        if (response.ok || response.redirected) {
            return response;
        }
        else {
            throw response;
        }
    };
    if (method === 'GET') {
        return fetch(createUrl(url, { params: params, auth: auth }), {
            method: method,
            body: body,
            headers: headers,
            signal: controller && controller.signal,
        }).then(processFetchResponse);
    }
    else {
        return fetch(createUrl(url, { params: params }), {
            method: method,
            body: body,
            headers: withAuth(auth)(headers),
        }).then(processFetchResponse);
    }
}
function mapResponseToJson(response) {
    return response.json();
}
function mapResponseToBlob(response) {
    return response.blob();
}
function mapResponseToVoid(_response) {
    return Promise.resolve();
}
function createUrl(url, _a) {
    var params = _a.params, auth = _a.auth;
    var _b = extract(url), baseUrl = _b.baseUrl, queryParams = _b.queryParams;
    var authParams = auth && Object(__WEBPACK_IMPORTED_MODULE_3__models_auth_query_parameters__["a" /* mapAuthToQueryParameters */])(auth);
    var queryString = Object(__WEBPACK_IMPORTED_MODULE_1_query_string__["stringify"])(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, queryParams, params, authParams));
    var shouldAppendQueryString = queryString.length > 0;
    return "" + baseUrl + (shouldAppendQueryString ? "?" + queryString : '');
}
function withAuth(auth) {
    return function (headers) {
        if (auth) {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, (headers || {}), mapAuthToRequestHeaders(auth));
        }
        else {
            return headers;
        }
    };
}
function extract(url) {
    var index = url.indexOf('?');
    if (index > 0) {
        return {
            baseUrl: url.substring(0, index),
            queryParams: Object(__WEBPACK_IMPORTED_MODULE_1_query_string__["parse"])(url.substring(index + 1, url.length)),
        };
    }
    else {
        return {
            baseUrl: url,
        };
    }
}
function mapAuthToRequestHeaders(auth) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__models_auth__["a" /* isClientBasedAuth */])(auth)) {
        return {
            'X-Client-Id': auth.clientId,
            Authorization: "Bearer " + auth.token,
        };
    }
    else {
        return {
            'X-Issuer': auth.asapIssuer,
            Authorization: "Bearer " + auth.token,
        };
    }
}
/* unused harmony default export */ var _unused_webpack_default_export = (request);
//# sourceMappingURL=request.js.map

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getArtifactUrl; });
var getArtifactUrl = function (artifacts, prop) {
    var artifact = artifacts[prop];
    if (!artifact || !artifact.url) {
        return undefined;
    }
    return artifact.url;
};
//# sourceMappingURL=artifacts.js.map

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isFunction(x) {
    return typeof x === 'function';
}
exports.isFunction = isFunction;
//# sourceMappingURL=isFunction.js.map

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArray.js.map

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isObject(x) {
    return x != null && typeof x === 'object';
}
exports.isObject = isObject;
//# sourceMappingURL=isObject.js.map

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// typeof any so that it we don't have to cast when comparing a result to the error object
exports.errorObject = { e: {} };
//# sourceMappingURL=errorObject.js.map

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.empty = {
    closed: true,
    next: function (value) { },
    error: function (err) { throw err; },
    complete: function () { }
};
//# sourceMappingURL=Observer.js.map

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArrayLike.js.map

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
exports.isPromise = isPromise;
//# sourceMappingURL=isPromise.js.map

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var PromiseObservable_1 = __webpack_require__(689);
exports.fromPromise = PromiseObservable_1.PromiseObservable.create;
//# sourceMappingURL=fromPromise.js.map

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__(112);
var Observable_1 = __webpack_require__(42);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var PromiseObservable = (function (_super) {
    __extends(PromiseObservable, _super);
    function PromiseObservable(promise, scheduler) {
        _super.call(this);
        this.promise = promise;
        this.scheduler = scheduler;
    }
    /**
     * Converts a Promise to an Observable.
     *
     * <span class="informal">Returns an Observable that just emits the Promise's
     * resolved value, then completes.</span>
     *
     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
     * Observable. If the Promise resolves with a value, the output Observable
     * emits that resolved value as a `next`, and then completes. If the Promise
     * is rejected, then the output Observable emits the corresponding Error.
     *
     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link bindCallback}
     * @see {@link from}
     *
     * @param {PromiseLike<T>} promise The promise to be converted.
     * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
     * the delivery of the resolved value (or the rejection).
     * @return {Observable<T>} An Observable which wraps the Promise.
     * @static true
     * @name fromPromise
     * @owner Observable
     */
    PromiseObservable.create = function (promise, scheduler) {
        return new PromiseObservable(promise, scheduler);
    };
    /** @deprecated internal use only */ PromiseObservable.prototype._subscribe = function (subscriber) {
        var _this = this;
        var promise = this.promise;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    subscriber.next(this.value);
                    subscriber.complete();
                }
            }
            else {
                promise.then(function (value) {
                    _this.value = value;
                    _this._isScalar = true;
                    if (!subscriber.closed) {
                        subscriber.next(value);
                        subscriber.complete();
                    }
                }, function (err) {
                    if (!subscriber.closed) {
                        subscriber.error(err);
                    }
                })
                    .then(null, function (err) {
                    // escape the promise trap, throw unhandled errors
                    root_1.root.setTimeout(function () { throw err; });
                });
            }
        }
        else {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    return scheduler.schedule(dispatchNext, 0, { value: this.value, subscriber: subscriber });
                }
            }
            else {
                promise.then(function (value) {
                    _this.value = value;
                    _this._isScalar = true;
                    if (!subscriber.closed) {
                        subscriber.add(scheduler.schedule(dispatchNext, 0, { value: value, subscriber: subscriber }));
                    }
                }, function (err) {
                    if (!subscriber.closed) {
                        subscriber.add(scheduler.schedule(dispatchError, 0, { err: err, subscriber: subscriber }));
                    }
                })
                    .then(null, function (err) {
                    // escape the promise trap, throw unhandled errors
                    root_1.root.setTimeout(function () { throw err; });
                });
            }
        }
    };
    return PromiseObservable;
}(Observable_1.Observable));
exports.PromiseObservable = PromiseObservable;
function dispatchNext(arg) {
    var value = arg.value, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
    }
}
function dispatchError(arg) {
    var err = arg.err, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.error(err);
    }
}
//# sourceMappingURL=PromiseObservable.js.map

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an action is invalid because the object has been
 * unsubscribed.
 *
 * @see {@link Subject}
 * @see {@link BehaviorSubject}
 *
 * @class ObjectUnsubscribedError
 */
var ObjectUnsubscribedError = (function (_super) {
    __extends(ObjectUnsubscribedError, _super);
    function ObjectUnsubscribedError() {
        var err = _super.call(this, 'object unsubscribed');
        this.name = err.name = 'ObjectUnsubscribedError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ObjectUnsubscribedError;
}(Error));
exports.ObjectUnsubscribedError = ObjectUnsubscribedError;
//# sourceMappingURL=ObjectUnsubscribedError.js.map

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscription_1 = __webpack_require__(158);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SubjectSubscription = (function (_super) {
    __extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        _super.call(this);
        this.subject = subject;
        this.subscriber = subscriber;
        this.closed = false;
    }
    SubjectSubscription.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
            return;
        }
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) {
            observers.splice(subscriberIndex, 1);
        }
    };
    return SubjectSubscription;
}(Subscription_1.Subscription));
exports.SubjectSubscription = SubjectSubscription;
//# sourceMappingURL=SubjectSubscription.js.map

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = __webpack_require__(42);
exports.Observable = Observable_1.Observable;
var mergeMap_1 = __webpack_require__(389);
var notify_1 = __webpack_require__(1859);
var mapper = function (project) {
    var notifiers = new Array();
    var onReady = function () {
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        var notReadyIdx = notifiers.findIndex(function (notifier) { return !notifier.notifyIfReady(); });
        if (notReadyIdx > 0) {
            // remove all the notifiers we invoked
            notifiers.splice(0, notReadyIdx);
        }
    };
    return function (value) { return new Observable_1.Observable(function (sub) {
        notifiers.push(notify_1.notify(project(value), sub, onReady));
    }); };
};
exports.asyncMap = function (project, concurrent) {
    return mergeMap_1.mergeMap(mapper(project), concurrent);
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(90);
/**
 * Buffers the source Observable values until the size hits the maximum
 * `bufferSize` given.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when its size reaches `bufferSize`.</span>
 *
 * <img src="./img/bufferCount.png" width="100%">
 *
 * Buffers a number of values from the source Observable by `bufferSize` then
 * emits the buffer and clears it, and starts a new buffer each
 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
 * `null`, then new buffers are started immediately at the start of the source
 * and when each buffer closes and is emitted.
 *
 * @example <caption>Emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>On every click, emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2, 1);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link pairwise}
 * @see {@link windowCount}
 *
 * @param {number} bufferSize The maximum size of the buffer emitted.
 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
 * For example if `startBufferEvery` is `2`, then a new buffer will be started
 * on every other value from the source. A new buffer is started at the
 * beginning of the source by default.
 * @return {Observable<T[]>} An Observable of arrays of buffered values.
 * @method bufferCount
 * @owner Observable
 */
function bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) { startBufferEvery = null; }
    return function bufferCountOperatorFunction(source) {
        return source.lift(new BufferCountOperator(bufferSize, startBufferEvery));
    };
}
exports.bufferCount = bufferCount;
var BufferCountOperator = (function () {
    function BufferCountOperator(bufferSize, startBufferEvery) {
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        if (!startBufferEvery || bufferSize === startBufferEvery) {
            this.subscriberClass = BufferCountSubscriber;
        }
        else {
            this.subscriberClass = BufferSkipCountSubscriber;
        }
    }
    BufferCountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
    };
    return BufferCountOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferCountSubscriber = (function (_super) {
    __extends(BufferCountSubscriber, _super);
    function BufferCountSubscriber(destination, bufferSize) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.buffer = [];
    }
    BufferCountSubscriber.prototype._next = function (value) {
        var buffer = this.buffer;
        buffer.push(value);
        if (buffer.length == this.bufferSize) {
            this.destination.next(buffer);
            this.buffer = [];
        }
    };
    BufferCountSubscriber.prototype._complete = function () {
        var buffer = this.buffer;
        if (buffer.length > 0) {
            this.destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    return BufferCountSubscriber;
}(Subscriber_1.Subscriber));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferSkipCountSubscriber = (function (_super) {
    __extends(BufferSkipCountSubscriber, _super);
    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        this.buffers = [];
        this.count = 0;
    }
    BufferSkipCountSubscriber.prototype._next = function (value) {
        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
        this.count++;
        if (count % startBufferEvery === 0) {
            buffers.push([]);
        }
        for (var i = buffers.length; i--;) {
            var buffer = buffers[i];
            buffer.push(value);
            if (buffer.length === bufferSize) {
                buffers.splice(i, 1);
                this.destination.next(buffer);
            }
        }
    };
    BufferSkipCountSubscriber.prototype._complete = function () {
        var _a = this, buffers = _a.buffers, destination = _a.destination;
        while (buffers.length > 0) {
            var buffer = buffers.shift();
            if (buffer.length > 0) {
                destination.next(buffer);
            }
        }
        _super.prototype._complete.call(this);
    };
    return BufferSkipCountSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=bufferCount.js.map

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(42);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ScalarObservable = (function (_super) {
    __extends(ScalarObservable, _super);
    function ScalarObservable(value, scheduler) {
        _super.call(this);
        this.value = value;
        this.scheduler = scheduler;
        this._isScalar = true;
        if (scheduler) {
            this._isScalar = false;
        }
    }
    ScalarObservable.create = function (value, scheduler) {
        return new ScalarObservable(value, scheduler);
    };
    ScalarObservable.dispatch = function (state) {
        var done = state.done, value = state.value, subscriber = state.subscriber;
        if (done) {
            subscriber.complete();
            return;
        }
        subscriber.next(value);
        if (subscriber.closed) {
            return;
        }
        state.done = true;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ScalarObservable.prototype._subscribe = function (subscriber) {
        var value = this.value;
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(ScalarObservable.dispatch, 0, {
                done: false, value: value, subscriber: subscriber
            });
        }
        else {
            subscriber.next(value);
            if (!subscriber.closed) {
                subscriber.complete();
            }
        }
    };
    return ScalarObservable;
}(Observable_1.Observable));
exports.ScalarObservable = ScalarObservable;
//# sourceMappingURL=ScalarObservable.js.map

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(42);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var EmptyObservable = (function (_super) {
    __extends(EmptyObservable, _super);
    function EmptyObservable(scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits a complete notification.
     *
     * <span class="informal">Just emits 'complete', and nothing else.
     * </span>
     *
     * <img src="./img/empty.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the complete notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then complete.</caption>
     * var result = Rx.Observable.empty().startWith(7);
     * result.subscribe(x => console.log(x));
     *
     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
     * );
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following to the console:
     * // x is equal to the count on the interval eg(0,1,2,3,...)
     * // x will occur every 1000ms
     * // if x % 2 is equal to 1 print abc
     * // if x % 2 is not equal to 1 nothing will be output
     *
     * @see {@link create}
     * @see {@link never}
     * @see {@link of}
     * @see {@link throw}
     *
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the complete notification.
     * @return {Observable} An "empty" Observable: emits only the complete
     * notification.
     * @static true
     * @name empty
     * @owner Observable
     */
    EmptyObservable.create = function (scheduler) {
        return new EmptyObservable(scheduler);
    };
    EmptyObservable.dispatch = function (arg) {
        var subscriber = arg.subscriber;
        subscriber.complete();
    };
    /** @deprecated internal use only */ EmptyObservable.prototype._subscribe = function (subscriber) {
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(EmptyObservable.dispatch, 0, { subscriber: subscriber });
        }
        else {
            subscriber.complete();
        }
    };
    return EmptyObservable;
}(Observable_1.Observable));
exports.EmptyObservable = EmptyObservable;
//# sourceMappingURL=EmptyObservable.js.map

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
exports.isScheduler = isScheduler;
//# sourceMappingURL=isScheduler.js.map

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(90);
var Notification_1 = __webpack_require__(698);
/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */
function observeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return function observeOnOperatorFunction(source) {
        return source.lift(new ObserveOnOperator(scheduler, delay));
    };
}
exports.observeOn = observeOn;
var ObserveOnOperator = (function () {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) { delay = 0; }
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}());
exports.ObserveOnOperator = ObserveOnOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ObserveOnSubscriber = (function (_super) {
    __extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) { delay = 0; }
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnSubscriber.dispatch = function (arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function (value) {
        this.scheduleMessage(Notification_1.Notification.createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function (err) {
        this.scheduleMessage(Notification_1.Notification.createError(err));
    };
    ObserveOnSubscriber.prototype._complete = function () {
        this.scheduleMessage(Notification_1.Notification.createComplete());
    };
    return ObserveOnSubscriber;
}(Subscriber_1.Subscriber));
exports.ObserveOnSubscriber = ObserveOnSubscriber;
var ObserveOnMessage = (function () {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}());
exports.ObserveOnMessage = ObserveOnMessage;
//# sourceMappingURL=observeOn.js.map

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(42);
/**
 * Represents a push-based event or value that an {@link Observable} can emit.
 * This class is particularly useful for operators that manage notifications,
 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
 * others. Besides wrapping the actual delivered value, it also annotates it
 * with metadata of, for instance, what type of push message it is (`next`,
 * `error`, or `complete`).
 *
 * @see {@link materialize}
 * @see {@link dematerialize}
 * @see {@link observeOn}
 *
 * @class Notification<T>
 */
var Notification = (function () {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    /**
     * Delivers to the given `observer` the value wrapped by this Notification.
     * @param {Observer} observer
     * @return
     */
    Notification.prototype.observe = function (observer) {
        switch (this.kind) {
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    /**
     * Given some {@link Observer} callbacks, deliver the value represented by the
     * current Notification to the correctly corresponding callback.
     * @param {function(value: T): void} next An Observer `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */
    Notification.prototype.do = function (next, error, complete) {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    /**
     * Takes an Observer or its individual callback functions, and calls `observe`
     * or `do` methods accordingly.
     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
     * the `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */
    Notification.prototype.accept = function (nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
            return this.observe(nextOrObserver);
        }
        else {
            return this.do(nextOrObserver, error, complete);
        }
    };
    /**
     * Returns a simple Observable that just delivers the notification represented
     * by this Notification instance.
     * @return {any}
     */
    Notification.prototype.toObservable = function () {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return Observable_1.Observable.of(this.value);
            case 'E':
                return Observable_1.Observable.throw(this.error);
            case 'C':
                return Observable_1.Observable.empty();
        }
        throw new Error('unexpected notification kind value');
    };
    /**
     * A shortcut to create a Notification instance of the type `next` from a
     * given value.
     * @param {T} value The `next` value.
     * @return {Notification<T>} The "next" Notification representing the
     * argument.
     */
    Notification.createNext = function (value) {
        if (typeof value !== 'undefined') {
            return new Notification('N', value);
        }
        return Notification.undefinedValueNotification;
    };
    /**
     * A shortcut to create a Notification instance of the type `error` from a
     * given error.
     * @param {any} [err] The `error` error.
     * @return {Notification<T>} The "error" Notification representing the
     * argument.
     */
    Notification.createError = function (err) {
        return new Notification('E', undefined, err);
    };
    /**
     * A shortcut to create a Notification instance of the type `complete`.
     * @return {Notification<any>} The valueless "complete" Notification.
     */
    Notification.createComplete = function () {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}());
exports.Notification = Notification;
//# sourceMappingURL=Notification.js.map

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__(112);
var Action_1 = __webpack_require__(1874);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AsyncAction = (function (_super) {
    __extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.pending = false;
        this.work = work;
    }
    AsyncAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (this.closed) {
            return this;
        }
        // Always replace the current state with the new state.
        this.state = state;
        // Set the pending flag indicating that this action has been scheduled, or
        // has recursively rescheduled itself.
        this.pending = true;
        var id = this.id;
        var scheduler = this.scheduler;
        //
        // Important implementation note:
        //
        // Actions only execute once by default, unless rescheduled from within the
        // scheduled callback. This allows us to implement single and repeat
        // actions via the same code path, without adding API surface area, as well
        // as mimic traditional recursion but across asynchronous boundaries.
        //
        // However, JS runtimes and timers distinguish between intervals achieved by
        // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
        // serial `setTimeout` calls can be individually delayed, which delays
        // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
        // guarantee the interval callback will be invoked more precisely to the
        // interval period, regardless of load.
        //
        // Therefore, we use `setInterval` to schedule single and repeat actions.
        // If the action reschedules itself with the same delay, the interval is not
        // canceled. If the action doesn't reschedule, or reschedules with a
        // different delay, the interval will be canceled after scheduled callback
        // execution.
        //
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, delay);
        }
        this.delay = delay;
        // If this action has already an async Id, don't request a new one.
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        return root_1.root.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If this action is rescheduled with the same delay time, don't clear the interval id.
        if (delay !== null && this.delay === delay && this.pending === false) {
            return id;
        }
        // Otherwise, if the action's delay time is different from the current delay,
        // or the action has been rescheduled before it's executed, clear the interval id
        return root_1.root.clearInterval(id) && undefined || undefined;
    };
    /**
     * Immediately executes this action and the `work` it contains.
     * @return {any}
     */
    AsyncAction.prototype.execute = function (state, delay) {
        if (this.closed) {
            return new Error('executing a cancelled action');
        }
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) {
            return error;
        }
        else if (this.pending === false && this.id != null) {
            // Dequeue if the action didn't reschedule itself. Don't call
            // unsubscribe(), because the action could reschedule later.
            // For example:
            // ```
            // scheduler.schedule(function doWork(counter) {
            //   /* ... I'm a busy worker bee ... */
            //   var originalAction = this;
            //   /* wait 100ms before rescheduling the action */
            //   setTimeout(function () {
            //     originalAction.schedule(counter + 1);
            //   }, 100);
            // }, 1000);
            // ```
            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
    };
    AsyncAction.prototype._execute = function (state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        }
        catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    /** @deprecated internal use only */ AsyncAction.prototype._unsubscribe = function () {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) {
            actions.splice(index, 1);
        }
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, null);
        }
        this.delay = null;
    };
    return AsyncAction;
}(Action_1.Action));
exports.AsyncAction = AsyncAction;
//# sourceMappingURL=AsyncAction.js.map

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Scheduler_1 = __webpack_require__(1876);
var AsyncScheduler = (function (_super) {
    __extends(AsyncScheduler, _super);
    function AsyncScheduler() {
        _super.apply(this, arguments);
        this.actions = [];
        /**
         * A flag to indicate whether the Scheduler is currently executing a batch of
         * queued actions.
         * @type {boolean}
         */
        this.active = false;
        /**
         * An internal ID used to track the latest asynchronous task such as those
         * coming from `setTimeout`, `setInterval`, `requestAnimationFrame`, and
         * others.
         * @type {any}
         */
        this.scheduled = undefined;
    }
    AsyncScheduler.prototype.flush = function (action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (action = actions.shift()); // exhaust the scheduler queue
        this.active = false;
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsyncScheduler;
}(Scheduler_1.Scheduler));
exports.AsyncScheduler = AsyncScheduler;
//# sourceMappingURL=AsyncScheduler.js.map

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMediaTypeFromMimeType; });
var getMediaTypeFromMimeType = function (type) {
    if (type.indexOf('image/') === 0) {
        return 'image';
    }
    else if (type.indexOf('video/') === 0) {
        return 'video';
    }
    else if (type.indexOf('audio/') === 0) {
        return 'audio';
    }
    else if (type.indexOf('application/pdf') === 0) {
        return 'doc';
    }
    else {
        return 'unknown';
    }
};
//# sourceMappingURL=getMediaTypeFromMimeType.js.map

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export calcLegacyWidth */
/* unused harmony export calcResizedWidth */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MediaSingleDimensionHelper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(373);




function float(layout) {
    switch (layout) {
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
/**
 * Calculates the image width for non-resized images.
 *
 * If an image has not been resized using the pctWidth attribute,
 * then an image in wide or full-width can not be wider than the image's
 * original width.
 */
function calcLegacyWidth(layout, width, containerWidth) {
    if (containerWidth === void 0) { containerWidth = 0; }
    switch (layout) {
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > __WEBPACK_IMPORTED_MODULE_2__styles__["g" /* akEditorFullPageMaxWidth */] / 2
                ? 'calc(50% - 12px)'
                : width + "px";
        case 'wide':
            return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* calcWideWidth */])(containerWidth);
        case 'full-width':
            return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* calcBreakoutWidth */])(layout, containerWidth);
        default:
            return width > __WEBPACK_IMPORTED_MODULE_2__styles__["g" /* akEditorFullPageMaxWidth */] ? '100%' : width + "px";
    }
}
/**
 * Calculates the image width for previously resized images.
 *
 * Wide and full-width images are always that size (960px and 100%); there is
 * no distinction between max-width and width.
 */
function calcResizedWidth(layout, width, containerWidth) {
    if (containerWidth === void 0) { containerWidth = 0; }
    switch (layout) {
        case 'wide':
            return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* calcWideWidth */])(containerWidth);
        case 'full-width':
            return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* calcBreakoutWidth */])(layout, containerWidth);
        default:
            return width + "px";
    }
}
function calcMaxWidth(layout, width, containerWidth) {
    switch (layout) {
        case 'wide':
            return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* calcWideWidth */])(containerWidth);
        case 'full-width':
            return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* calcBreakoutWidth */])(layout, containerWidth);
        default:
            return '100%';
    }
}
function calcMargin(layout) {
    switch (layout) {
        case 'wrap-right':
            return '12px auto 12px 24px';
        case 'wrap-left':
            return '12px 24px 12px auto';
        default:
            return '24px auto';
    }
}
function isImageAligned(layout) {
    switch (layout) {
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 */
var MediaSingleDimensionHelper = function (_a) {
    var width = _a.width, height = _a.height, layout = _a.layout, _b = _a.containerWidth, containerWidth = _b === void 0 ? 0 : _b, pctWidth = _a.pctWidth;
    return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  tr & {\n    max-width: 100%;\n  }\n  width: ", ";\n  max-width: ", ";\n  float: ", ";\n  margin: ", ";\n  ", ";\n"], ["\n  tr & {\n    max-width: 100%;\n  }\n  width: ",
        ";\n  max-width: ", ";\n  float: ", ";\n  margin: ", ";\n  ", ";\n"])), pctWidth
        ? calcResizedWidth(layout, width, containerWidth)
        : calcLegacyWidth(layout, width, containerWidth), calcMaxWidth(layout, width, containerWidth), float(layout), calcMargin(layout), isImageAligned(layout));
};
var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", ";\n  position: relative;\n\n  &::after {\n    content: '';\n    display: block;\n    padding-bottom: ", "%;\n  }\n\n  & > div {\n    position: absolute;\n    height: 100%;\n  }\n"], ["\n  ", ";\n  position: relative;\n\n  &::after {\n    content: '';\n    display: block;\n    padding-bottom: ", "%;\n  }\n\n  & > div {\n    position: absolute;\n    height: 100%;\n  }\n"])), MediaSingleDimensionHelper, function (p) { return (p.height / p.width) * 100; });
Wrapper.displayName = 'WrapperMediaSingle';
/* harmony default export */ __webpack_exports__["b"] = (Wrapper);
var templateObject_1, templateObject_2;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return layoutSupportsWidth; });
/* harmony export (immutable) */ __webpack_exports__["c"] = calcPxFromColumns;
/* harmony export (immutable) */ __webpack_exports__["a"] = calcColumnsFromPx;
/* harmony export (immutable) */ __webpack_exports__["d"] = calcPxFromPct;
/* harmony export (immutable) */ __webpack_exports__["b"] = calcPctFromPx;
/* unused harmony export snapToGrid */
var handleMargin = 12;
var gutterSize = handleMargin * 2;
var validWidthModes = [
    'center',
    'wrap-left',
    'wrap-right',
    'align-start',
    'align-end',
];
var layoutSupportsWidth = function (layout) {
    return validWidthModes.indexOf(layout) > -1;
};
function calcPxFromColumns(columns, lineLength, gridSize) {
    var maxWidth = lineLength + gutterSize;
    return (maxWidth / gridSize) * columns - gutterSize;
}
function calcColumnsFromPx(width, lineLength, gridSize) {
    var maxWidth = lineLength + gutterSize;
    return ((width + gutterSize) * gridSize) / maxWidth;
}
function calcPxFromPct(pct, lineLength) {
    var maxWidth = lineLength + gutterSize;
    return maxWidth * pct - gutterSize;
}
function calcPctFromPx(width, lineLength) {
    var maxWidth = lineLength + gutterSize;
    return (width + gutterSize) / maxWidth;
}
var snapToGrid = function (gridWidth, width, height, lineLength, gridSize) {
    var pxWidth = calcPxFromPct(gridWidth / 100, lineLength);
    var columnSpan = Math.round(calcColumnsFromPx(pxWidth, lineLength, gridSize));
    var alignedWidth = calcPxFromColumns(columnSpan, lineLength, gridSize);
    return {
        height: (height / width) * alignedWidth,
        width: alignedWidth,
    };
};
//# sourceMappingURL=grid.js.map

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HttpError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AbstractResource; });
/* unused harmony export AbstractMentionResource */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_logger__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_searchIndex__ = __webpack_require__(705);





var MAX_QUERY_ITEMS = 100;
var MAX_NOTIFIED_ITEMS = 20;
var emptySecurityProvider = function () {
    return {
        params: {},
        headers: {},
    };
};
var AbstractResource = /** @class */ (function () {
    function AbstractResource() {
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
    }
    AbstractResource.prototype.subscribe = function (key, callback, errCallback, infoCallback, allResultsCallback) {
        if (callback) {
            this.changeListeners.set(key, callback);
        }
        if (errCallback) {
            this.errListeners.set(key, errCallback);
        }
        if (infoCallback) {
            this.infoListeners.set(key, infoCallback);
        }
        if (allResultsCallback) {
            this.allResultsListeners.set(key, allResultsCallback);
        }
    };
    AbstractResource.prototype.unsubscribe = function (key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
    };
    return AbstractResource;
}());
var AbstractMentionResource = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AbstractMentionResource, _super);
    function AbstractMentionResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AbstractMentionResource.prototype.shouldHighlightMention = function (mention) {
        return false;
    };
    // eslint-disable-next-line class-methods-use-this
    AbstractMentionResource.prototype.filter = function (query) {
        throw new Error("not yet implemented.\nParams: query=" + query);
    };
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    AbstractMentionResource.prototype.recordMentionSelection = function (mention) {
        // Do nothing
    };
    AbstractMentionResource.prototype.isFiltering = function (query) {
        return false;
    };
    AbstractMentionResource.prototype._notifyListeners = function (mentionsResult, stats) {
        Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])('ak-mention-resource._notifyListeners', mentionsResult &&
            mentionsResult.mentions &&
            mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach(function (listener, key) {
            try {
                listener(mentionsResult.mentions.slice(0, MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            }
            catch (e) {
                // ignore error from listener
                Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])("error from listener '" + key + "', ignoring", e);
            }
        });
    };
    AbstractMentionResource.prototype._notifyAllResultsListeners = function (mentionsResult) {
        Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])('ak-mention-resource._notifyAllResultsListeners', mentionsResult &&
            mentionsResult.mentions &&
            mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach(function (listener, key) {
            try {
                listener(mentionsResult.mentions.slice(0, MAX_NOTIFIED_ITEMS), mentionsResult.query);
            }
            catch (e) {
                // ignore error from listener
                Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])("error from listener '" + key + "', ignoring", e);
            }
        });
    };
    AbstractMentionResource.prototype._notifyErrorListeners = function (error, query) {
        this.errListeners.forEach(function (listener, key) {
            try {
                listener(error, query);
            }
            catch (e) {
                // ignore error from listener
                Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])("error from listener '" + key + "', ignoring", e);
            }
        });
    };
    AbstractMentionResource.prototype._notifyInfoListeners = function (info) {
        this.infoListeners.forEach(function (listener, key) {
            try {
                listener(info);
            }
            catch (e) {
                // ignore error fromr listener
                Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])("error from listener '" + key + "', ignoring", e);
            }
        });
    };
    return AbstractMentionResource;
}(AbstractResource));
/**
 * Provides a Javascript API
 */
var MentionResource = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionResource, _super);
    function MentionResource(config) {
        var _this = _super.call(this) || this;
        if (!config.url) {
            throw new Error('config.url is a required parameter');
        }
        if (!config.securityProvider) {
            config.securityProvider = emptySecurityProvider;
        }
        _this.config = config;
        _this.lastReturnedSearch = 0;
        _this.searchIndex = new __WEBPACK_IMPORTED_MODULE_4__util_searchIndex__["a" /* SearchIndex */]();
        _this.activeSearches = new Set();
        return _this;
    }
    MentionResource.prototype.shouldHighlightMention = function (mention) {
        if (this.config.shouldHighlightMention) {
            return this.config.shouldHighlightMention(mention);
        }
        return false;
    };
    MentionResource.prototype.notify = function (searchTime, mentionResult, query, remoteSearch) {
        var _this = this;
        this.sortMentionsResult(mentionResult).then(function (sortedMentionsResult) {
            if (searchTime > _this.lastReturnedSearch) {
                _this.lastReturnedSearch = searchTime;
                _this._notifyListeners(sortedMentionsResult, {
                    duration: Date.now() - searchTime,
                    remoteSearch: remoteSearch,
                });
            }
            else {
                var date = new Date(searchTime).toISOString().substr(17, 6);
                Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
            }
            _this._notifyAllResultsListeners(sortedMentionsResult);
        });
    };
    MentionResource.prototype.notifyError = function (error, query) {
        this._notifyErrorListeners(error, query);
        if (query) {
            this.activeSearches.delete(query);
        }
    };
    MentionResource.prototype.filter = function (query, contextIdentifier) {
        var _this = this;
        var searchTime = Date.now();
        if (!query) {
            this.initialState(contextIdentifier).then(function (results) { return _this.notify(searchTime, results, query, true); }, function (error) { return _this.notifyError(error, query); });
        }
        else {
            this.activeSearches.add(query);
            var searchResponse_1 = this.search(query, contextIdentifier);
            searchResponse_1.mentions.then(function (results) {
                _this.notify(searchTime, results, query, searchResponse_1.remoteSearch);
            }, function (error) { return _this.notifyError(error, query); });
        }
    };
    MentionResource.prototype.recordMentionSelection = function (mention, contextIdentifier) {
        return this.recordSelection(mention, contextIdentifier).then(function () { }, function (error) { return Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])("error recording mention selection: " + error, error); });
    };
    MentionResource.prototype.isFiltering = function (query) {
        return this.activeSearches.has(query);
    };
    MentionResource.prototype.initialState = function (contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    };
    MentionResource.prototype.getUserIdsInContext = function () {
        if (this.config.getUsersInContext) {
            return this.config
                .getUsersInContext()
                .then(function (users) {
                return users.reduce(function (acc, value) { return acc.add(value.id); }, new Set());
            });
        }
        return Promise.resolve(new Set());
    };
    MentionResource.prototype.getQueryParams = function (contextIdentifier) {
        var configParams = {};
        if (this.config.containerId) {
            configParams['containerId'] = this.config.containerId;
        }
        if (this.config.productId) {
            configParams['productIdentifier'] = this.config.productId;
        }
        // if contextParams exist then it will override configParams for containerId
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, configParams, contextIdentifier);
    };
    /**
     * Returns the initial mention display list before a search is performed for the specified
     * container.
     *
     * @param contextIdentifier
     * @returns Promise
     */
    MentionResource.prototype.remoteInitialState = function (contextIdentifier) {
        var _this = this;
        var queryParams = this.getQueryParams(contextIdentifier);
        var options = {
            path: 'bootstrap',
            queryParams: queryParams,
        };
        return __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */]
            .requestService(this.config, options)
            .then(function (result) { return _this.transformServiceResponse(result, ''); })
            .then(function (result) {
            _this.searchIndex.indexResults(result.mentions);
            return result;
        });
    };
    MentionResource.prototype.searchAsync = function (query, contextIdentifier) {
        var _this = this;
        var searchTime = Date.now() + 1; // Ensure that search time is different than the local search time
        this.remoteSearch(query, contextIdentifier).then(function (result) {
            _this.activeSearches.delete(query);
            _this.notify(searchTime, result, query, true);
            _this.searchIndex.indexResults(result.mentions);
        }, function (err) {
            _this._notifyErrorListeners(err);
        });
    };
    MentionResource.prototype.search = function (query, contextIdentifier) {
        var _this = this;
        if (this.searchIndex.hasDocuments()) {
            return {
                mentions: this.searchIndex.search(query).then(function (result) {
                    _this.searchAsync(query, contextIdentifier);
                    // return local search result quickly while the back-end search runs async
                    return result;
                }),
                remoteSearch: false,
            };
        }
        return {
            mentions: this.remoteSearch(query, contextIdentifier).then(function (result) {
                _this.searchIndex.indexResults(result.mentions);
                return result;
            }),
            remoteSearch: true,
        };
    };
    MentionResource.prototype.sortMentionsResult = function (mentionsResult) {
        return this.getUserIdsInContext().then(function (userIdsInContext) {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, mentionsResult, { mentions: mentionsResult.mentions.sort(Object(__WEBPACK_IMPORTED_MODULE_4__util_searchIndex__["b" /* mentionDescriptionComparator */])(userIdsInContext)) });
        });
    };
    MentionResource.prototype.remoteSearch = function (query, contextIdentifier) {
        var _this = this;
        var options = {
            path: 'search',
            queryParams: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ query: query, limit: MAX_QUERY_ITEMS }, this.getQueryParams(contextIdentifier)),
        };
        return __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */]
            .requestService(this.config, options)
            .then(function (result) { return _this.transformServiceResponse(result, query); });
    };
    MentionResource.prototype.transformServiceResponse = function (result, query) {
        var mentions = result.mentions.map(function (mention, index) {
            var lozenge;
            var weight = mention.weight !== undefined ? mention.weight : index;
            if (Object(__WEBPACK_IMPORTED_MODULE_2__types__["b" /* isAppMention */])(mention)) {
                lozenge = mention.userType;
            }
            else if (Object(__WEBPACK_IMPORTED_MODULE_2__types__["f" /* isTeamMention */])(mention)) {
                lozenge = mention.userType;
            }
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, mention, { lozenge: lozenge, weight: weight, query: query });
        });
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, result, { mentions: mentions, query: result.query || query });
    };
    MentionResource.prototype.recordSelection = function (mention, contextIdentifier) {
        var options = {
            path: 'record',
            queryParams: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ selectedUserId: mention.id }, this.getQueryParams(contextIdentifier)),
            requestInit: {
                method: 'POST',
            },
        };
        return __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */].requestService(this.config, options);
    };
    return MentionResource;
}(AbstractMentionResource));
var HttpError = /** @class */ (function () {
    function HttpError(statusCode, statusMessage) {
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
    return HttpError;
}());


/* unused harmony default export */ var _unused_webpack_default_export = (MentionResource);
//# sourceMappingURL=MentionResource.js.map

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Tokenizer */
/* harmony export (immutable) */ __webpack_exports__["b"] = mentionDescriptionComparator;
/* unused harmony export Highlighter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_search__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__searchIndexRegex__ = __webpack_require__(1898);




// Order by increasing weight, using a big enough number to put item without an explicit weight
// at the end
var DEFAULT_WEIGHT = 100000;
var Tokenizer = /** @class */ (function () {
    function Tokenizer() {
    }
    Tokenizer.tokenize = function (text) {
        return this.tokenizeAsTokens(text).map(function (token) { return token.token; });
    };
    Tokenizer.tokenizeAsTokens = function (text) {
        var match;
        var tokens = [];
        __WEBPACK_IMPORTED_MODULE_3__searchIndexRegex__["b" /* tokenizerRegex */].lastIndex = 0;
        while ((match = __WEBPACK_IMPORTED_MODULE_3__searchIndexRegex__["b" /* tokenizerRegex */].exec(text)) !== null) {
            if (match[0]) {
                tokens.push({
                    token: match[0],
                    start: match.index,
                });
            }
        }
        return tokens;
    };
    return Tokenizer;
}());

/**
 * Returns a comparator function for MentionDescription object.
 *
 * @param {Set<string>} inContextUsers
 * @returns {(a: MentionDescription, b: MentionDescription) => number}
 */
function mentionDescriptionComparator(inContextUsers) {
    return function (a, b) {
        var aIsSpecialMention = Object(__WEBPACK_IMPORTED_MODULE_2__types__["d" /* isSpecialMention */])(a);
        var bIsSpecialMention = Object(__WEBPACK_IMPORTED_MODULE_2__types__["d" /* isSpecialMention */])(b);
        if (aIsSpecialMention && !bIsSpecialMention) {
            return -1;
        }
        if (bIsSpecialMention && !aIsSpecialMention) {
            return 1;
        }
        var aInContext = inContextUsers.has(a.id);
        var bInContext = inContextUsers.has(b.id);
        if (aInContext && !bInContext) {
            return -1;
        }
        if (bInContext && !aInContext) {
            return 1;
        }
        var aWeight = a.weight !== undefined ? a.weight : DEFAULT_WEIGHT;
        var bWeight = b.weight !== undefined ? b.weight : DEFAULT_WEIGHT;
        if (aWeight !== bWeight) {
            return aWeight - bWeight;
        }
        if (a.name && b.name) {
            return a.name.localeCompare(b.name);
        }
        return a.id.localeCompare(b.id);
    };
}
var Highlighter = /** @class */ (function () {
    function Highlighter() {
    }
    Highlighter.find = function (field, query) {
        var e_1, _a, e_2, _b;
        var highlights = [];
        if (field) {
            var queryTokens = Tokenizer.tokenizeAsTokens(query.toLowerCase());
            queryTokens.sort(function (a, b) { return -1 * a.token.localeCompare(b.token); });
            var lowercaseField = field.toLowerCase();
            var fieldTokens = Tokenizer.tokenizeAsTokens(lowercaseField);
            try {
                for (var fieldTokens_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](fieldTokens), fieldTokens_1_1 = fieldTokens_1.next(); !fieldTokens_1_1.done; fieldTokens_1_1 = fieldTokens_1.next()) {
                    var fieldToken = fieldTokens_1_1.value;
                    try {
                        for (var queryTokens_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](queryTokens), queryTokens_1_1 = queryTokens_1.next(); !queryTokens_1_1.done; queryTokens_1_1 = queryTokens_1.next()) {
                            var queryToken = queryTokens_1_1.value;
                            if (fieldToken.token.indexOf(queryToken.token) === 0) {
                                var start = fieldToken.start;
                                var end = start + queryToken.token.length - 1;
                                var i = end + 1;
                                var combiningCharacters = 0;
                                // Includes non spacing mark in highlights (e.g. ញុំ  when searching ញ)
                                while (i < fieldToken.token.length &&
                                    __WEBPACK_IMPORTED_MODULE_3__searchIndexRegex__["a" /* nonSpacingMarkRegex */].test(fieldToken.token[i])) {
                                    ++combiningCharacters;
                                    ++i;
                                    __WEBPACK_IMPORTED_MODULE_3__searchIndexRegex__["a" /* nonSpacingMarkRegex */].lastIndex = 0;
                                }
                                highlights.push({
                                    start: start,
                                    end: end + combiningCharacters,
                                });
                                break;
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (queryTokens_1_1 && !queryTokens_1_1.done && (_b = queryTokens_1.return)) _b.call(queryTokens_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (fieldTokens_1_1 && !fieldTokens_1_1.done && (_a = fieldTokens_1.return)) _a.call(fieldTokens_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            if (highlights.length < queryTokens.length) {
                return [];
            }
        }
        return highlights;
    };
    return Highlighter;
}());

var SearchIndex = /** @class */ (function () {
    function SearchIndex() {
        this.reset();
    }
    SearchIndex.prototype.search = function (query) {
        var _this = this;
        if (query === void 0) { query = ''; }
        return new Promise(function (resolve) {
            var localResults = _this.index
                .search(query)
                .map(function (mention) {
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, mention, { highlight: {
                        name: Highlighter.find(mention.name, query),
                        mentionName: Highlighter.find(mention.mentionName, query),
                        nickname: Highlighter.find(mention.nickname, query),
                    } });
            })
                .filter(function (mention) {
                if (Object(__WEBPACK_IMPORTED_MODULE_2__types__["d" /* isSpecialMention */])(mention) &&
                    mention.highlight.nickname.length === 0) {
                    return false;
                }
                return true;
            });
            resolve({
                mentions: localResults,
                query: query,
            });
        });
    };
    SearchIndex.prototype.hasDocuments = function () {
        return this.indexedCount > 0;
    };
    SearchIndex.prototype.reset = function () {
        this.index = SearchIndex.createIndex();
        this.indexedCount = 0;
    };
    SearchIndex.prototype.indexResults = function (mentions) {
        this.index.addDocuments(mentions);
        this.indexedCount += mentions.length;
    };
    SearchIndex.createIndex = function () {
        var index = new __WEBPACK_IMPORTED_MODULE_1_js_search__["Search"]('id');
        index.searchIndex = new __WEBPACK_IMPORTED_MODULE_1_js_search__["UnorderedSearchIndex"]();
        index.tokenizer = Tokenizer;
        index.addIndex('name');
        index.addIndex('mentionName');
        index.addIndex('nickname');
        return index;
    };
    return SearchIndex;
}());

//# sourceMappingURL=searchIndex.js.map

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_avatar__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_lozenge__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_lock_circle__ = __webpack_require__(1918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_lock_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_lock_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_mouse__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(1919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_i18n__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NoAccessTooltip__ = __webpack_require__(717);











function renderHighlight(ReactComponent, value, highlights, prefix) {
    if (!value) {
        return null;
    }
    var parts = [];
    var prefixText = prefix || '';
    var lastIndex = 0;
    if (highlights) {
        for (var i = 0; i < highlights.length; i++) {
            var h = highlights[i];
            var start = h.start;
            var end = h.end;
            if (start > lastIndex) {
                parts.push({
                    value: value.substring(lastIndex, start),
                    matches: false,
                });
            }
            parts.push({
                value: value.substring(start, end + 1),
                matches: true,
            });
            lastIndex = end + 1;
        }
        if (lastIndex < value.length) {
            parts.push({
                value: value.substring(lastIndex, value.length),
                matches: false,
            });
        }
    }
    else {
        parts.push({
            value: value,
            matches: false,
        });
    }
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ReactComponent, null,
        prefixText,
        parts.map(function (part, index) {
            if (part.matches) {
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("b", { key: index }, part.value);
            }
            return part.value;
        })));
}
function renderLozenge(lozenge) {
    if (lozenge) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_lozenge__["default"], null, lozenge);
    }
    return null;
}
function renderTime(time) {
    if (time) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["i" /* TimeStyle */], null, time);
    }
    return null;
}
var MentionItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionItem, _super);
    function MentionItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // internal, used for callbacks
        _this.onMentionSelected = function (event) {
            if (Object(__WEBPACK_IMPORTED_MODULE_7__util_mouse__["b" /* leftClick */])(event) && _this.props.onSelection) {
                event.preventDefault();
                _this.props.onSelection(_this.props.mention, event);
            }
        };
        _this.onMentionMenuItemMouseMove = function (event) {
            if (_this.props.onMouseMove) {
                _this.props.onMouseMove(_this.props.mention, event);
            }
        };
        return _this;
    }
    MentionItem.prototype.render = function () {
        var _a = this.props, mention = _a.mention, selected = _a.selected;
        var id = mention.id, highlight = mention.highlight, avatarUrl = mention.avatarUrl, presence = mention.presence, name = mention.name, mentionName = mention.mentionName, nickname = mention.nickname, lozenge = mention.lozenge, accessLevel = mention.accessLevel;
        var _b = presence || {}, status = _b.status, time = _b.time;
        var restricted = Object(__WEBPACK_IMPORTED_MODULE_6__types__["c" /* isRestricted */])(accessLevel);
        var nameHighlights = highlight && highlight.name;
        var nicknameHighlights = highlight && highlight.nickname;
        var borderColor = selected ? __WEBPACK_IMPORTED_MODULE_5__atlaskit_theme__["colors"].N30 : undefined;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["e" /* MentionItemStyle */], { selected: selected, onMouseDown: this.onMentionSelected, onMouseMove: this.onMentionMenuItemMouseMove, "data-mention-id": id, "data-mention-name": mentionName },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["h" /* RowStyle */], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["b" /* AvatarStyle */], { restricted: restricted },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_avatar__["d" /* default */], { src: avatarUrl, size: "medium", presence: status, borderColor: borderColor })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["f" /* NameSectionStyle */], { restricted: restricted },
                    renderHighlight(__WEBPACK_IMPORTED_MODULE_8__styles__["c" /* FullNameStyle */], name, nameHighlights),
                    renderHighlight(__WEBPACK_IMPORTED_MODULE_8__styles__["g" /* NicknameStyle */], nickname, nicknameHighlights, '@')),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["d" /* InfoSectionStyle */], { restricted: restricted },
                    renderLozenge(lozenge),
                    renderTime(time)),
                restricted ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__NoAccessTooltip__["a" /* NoAccessTooltip */], { name: name },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* AccessSectionStyle */], null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__util_i18n__["e" /* NoAccessLabel */], null, function (text) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_lock_circle___default.a, { label: text })); } /* safe to cast to string given there is no value binding */)))) : null)));
    };
    return MentionItem;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (MentionItem);
//# sourceMappingURL=index.js.map

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return validIconSizes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return propsOmittedFromClickData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styled_constants__ = __webpack_require__(199);

var validIconSizes = Object.keys(__WEBPACK_IMPORTED_MODULE_0__styled_constants__["d" /* ICON_SIZES */]);
var propsOmittedFromClickData = ['onBlur', 'onClick', 'onFocus', 'onKeyDown', 'onKeyUp', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseUp'];

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Presence; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styled_Icon__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_getPresenceSVG__ = __webpack_require__(710);









var Presence =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Presence, _Component);

  function Presence() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Presence);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Presence).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Presence, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          borderColor = _this$props.borderColor,
          children = _this$props.children,
          presence = _this$props.presence,
          size = _this$props.size;
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styled_Icon__["b" /* Outer */], {
        size: size,
        bgColor: borderColor
      }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styled_Icon__["a" /* Inner */], null, children || presence && Object(__WEBPACK_IMPORTED_MODULE_7__helpers_getPresenceSVG__["a" /* default */])(presence)));
    }
  }]);

  return Presence;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);



/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Outer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Inner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(199);


 // set fallbacks for border color/width to protect consumers from invalid values

var Outer = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["withTheme"])(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "Icon__Outer",
  componentId: "sc-1i6jzcz-0"
})(["\n  align-content: center;\n  align-items: center;\n  background-color: ", ";\n  border-radius: 50%;\n  box-sizing: border-box;\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n  padding: ", "px;\n  width: 100%;\n"], function (props) {
  return props.bgColor || __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].background;
}, function (_ref) {
  var size = _ref.size;
  return __WEBPACK_IMPORTED_MODULE_2__constants__["c" /* BORDER_WIDTH */][size] || __WEBPACK_IMPORTED_MODULE_2__constants__["c" /* BORDER_WIDTH */].medium;
}));
var Inner = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "Icon__Inner",
  componentId: "sc-1i6jzcz-1"
})(["\n  align-items: center;\n  border-radius: 50%;\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n  width: 100%;\n"]);

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPresenceSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);





var Svg = function Svg(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("svg", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
    height: "100%",
    version: "1.1",
    viewBox: "0 0 8 8",
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg"
  }, props));
};

var BusyCircle = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["withTheme"])(__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].circle.withConfig({
  displayName: "getPresenceSVG__BusyCircle",
  componentId: "sc-1k153k9-0"
})(["\n  fill: ", ";\n"], Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].R300,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].R200
})));
var BusyPath = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["withTheme"])(__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].path.withConfig({
  displayName: "getPresenceSVG__BusyPath",
  componentId: "sc-1k153k9-1"
})(["\n  fill: ", ";\n"], __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].background));
var FocusPath = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["withTheme"])(__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].path.withConfig({
  displayName: "getPresenceSVG__FocusPath",
  componentId: "sc-1k153k9-2"
})(["\n  fill: ", ";\n"], __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].purple));
var OfflineOuter = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["withTheme"])(__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].path.withConfig({
  displayName: "getPresenceSVG__OfflineOuter",
  componentId: "sc-1k153k9-3"
})(["\n  fill: ", ";\n"], Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N200,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN100
})));
var OfflineInner = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["withTheme"])(__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].path.withConfig({
  displayName: "getPresenceSVG__OfflineInner",
  componentId: "sc-1k153k9-4"
})(["\n  fill: ", ";\n"], Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N40,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN500
})));
var OnlineCircle = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["withTheme"])(__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].circle.withConfig({
  displayName: "getPresenceSVG__OnlineCircle",
  componentId: "sc-1k153k9-5"
})(["\n  fill: ", ";\n"], Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].G300,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].G200
})));
function getPresenceSvg(presence) {
  switch (presence) {
    case 'busy':
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Svg, null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(BusyCircle, {
        cx: "4",
        cy: "4",
        r: "4"
      }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(BusyPath, {
        d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
      }));

    case 'focus':
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Svg, null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(FocusPath, {
        d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
      }));

    case 'offline':
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Svg, null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(OfflineOuter, {
        d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
      }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(OfflineInner, {
        d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
      }));

    case 'online':
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Svg, null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(OnlineCircle, {
        cx: "4",
        cy: "4",
        r: "4"
      }));

    default:
      return null;
  }
}

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Status; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styled_Icon__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_getStatusSVG__ = __webpack_require__(712);









var Status =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Status, _Component);

  function Status() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Status);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Status).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Status, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          borderColor = _this$props.borderColor,
          children = _this$props.children,
          status = _this$props.status,
          size = _this$props.size;
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styled_Icon__["b" /* Outer */], {
        size: size,
        bgColor: borderColor
      }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styled_Icon__["a" /* Inner */], null, children || status && Object(__WEBPACK_IMPORTED_MODULE_7__helpers_getStatusSVG__["a" /* default */])(status)));
    }
  }]);

  return Status;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);



/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStatusSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__ = __webpack_require__(3);





var Svg = function Svg(props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
    height: "100%",
    version: "1.1",
    viewBox: "0 0 8 8",
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg"
  }, props));
};

var ApprovedCircle = Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["withTheme"])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].circle.withConfig({
  displayName: "getStatusSVG__ApprovedCircle",
  componentId: "kqelaq-0"
})(["\n  fill: ", ";\n"], Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].G400,
  dark: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].G300
})));
var ApprovedPath = Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["withTheme"])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].path.withConfig({
  displayName: "getStatusSVG__ApprovedPath",
  componentId: "kqelaq-1"
})(["\n  fill: ", ";\n"], __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].background));
var DeclinedCircle = Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["withTheme"])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].circle.withConfig({
  displayName: "getStatusSVG__DeclinedCircle",
  componentId: "kqelaq-2"
})(["\n  fill: ", ";\n"], Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].R400,
  dark: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].R300
})));
var DeclinedPath = Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["withTheme"])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].path.withConfig({
  displayName: "getStatusSVG__DeclinedPath",
  componentId: "kqelaq-3"
})(["\n  fill: ", ";\n"], __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].background));
var LockedCircle = Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["withTheme"])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].circle.withConfig({
  displayName: "getStatusSVG__LockedCircle",
  componentId: "kqelaq-4"
})(["\n  fill: ", ";\n"], Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N40,
  dark: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].DN800
})));
var LockedPath = Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["withTheme"])(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].path.withConfig({
  displayName: "getStatusSVG__LockedPath",
  componentId: "kqelaq-5"
})(["\n  fill: ", ";\n"], Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N500,
  dark: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].DN30
})));
function getStatusSvg(status) {
  switch (status) {
    case 'approved':
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Svg, null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ApprovedCircle, {
        cx: "4",
        cy: "4",
        r: "4"
      }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ApprovedPath, {
        d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
      }));

    case 'declined':
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Svg, null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DeclinedCircle, {
        cx: "4",
        cy: "4",
        r: "4"
      }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DeclinedPath, {
        d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
      }));

    case 'locked':
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Svg, null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LockedCircle, {
        cx: "4",
        cy: "4",
        r: "4"
      }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LockedPath, {
        d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
      }));

    default:
      return null;
  }
}

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CustomComponentProxy__ = __webpack_require__(1907);


 // This is necessary because we don't know what DOM element the custom component will render.

/* harmony default export */ __webpack_exports__["a"] = (function (styles) {
  var StyledCustomComponent = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["withTheme"])(Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2__components_CustomComponentProxy__["a" /* default */]).withConfig({
    displayName: "styledCache__StyledCustomComponent",
    componentId: "zohhd2-0"
  })(["\n      &,\n      &:hover,\n      &:active,\n      &:focus {\n        ", "\n      }\n    "], styles));
  var StyledButton = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["withTheme"])(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button.withConfig({
    displayName: "styledCache__StyledButton",
    componentId: "zohhd2-1"
  })(["\n    ", ";\n  "], styles));
  var StyledLink = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["withTheme"])(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].a.withConfig({
    displayName: "styledCache__StyledLink",
    componentId: "zohhd2-2"
  })(["\n    a& {\n      ", ";\n    }\n  "], styles));
  var StyledSpan = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["withTheme"])(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span.withConfig({
    displayName: "styledCache__StyledSpan",
    componentId: "zohhd2-3"
  })(["\n    ", ";\n  "], styles));
  return function getStyled(_ref) {
    var component = _ref.component,
        href = _ref.href,
        onClick = _ref.onClick;
    var Ret = StyledSpan;

    if (component) {
      Ret = StyledCustomComponent;
    } else if (href) {
      Ret = StyledLink;
    } else if (onClick) {
      Ret = StyledButton;
    }

    return Ret;
  };
});

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getBackgroundColor;
/* harmony export (immutable) */ __webpack_exports__["e"] = getStyles;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PrimaryText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SecondaryText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);


var focusBorderColor = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].B200,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].B75
});
var textColors = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N900,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN600
});
var subtleTextColors = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N200,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN300
});
function getBackgroundColor(_ref) {
  var backgroundColor = _ref.backgroundColor,
      href = _ref.href,
      isActive = _ref.isActive,
      isHover = _ref.isHover,
      isSelected = _ref.isSelected,
      onClick = _ref.onClick;
  var isInteractive = href || onClick;
  var themedBackgroundColor = backgroundColor || __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].background; // Interaction: Hover

  if (isInteractive && (isHover || isSelected)) {
    themedBackgroundColor = __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].backgroundHover;
  } // Interaction: Active


  if (isInteractive && isActive) {
    themedBackgroundColor = __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].backgroundActive;
  }

  return themedBackgroundColor;
}
function getStyles(_ref2) {
  var href = _ref2.href,
      isActive = _ref2.isActive,
      isDisabled = _ref2.isDisabled,
      isFocus = _ref2.isFocus,
      onClick = _ref2.onClick;
  var isInteractive = href || onClick;
  var borderColor = 'transparent';
  var cursor = 'auto';
  var opacity = 1;
  var outline = 'none';
  var pointerEvents = 'auto'; // Interaction: Focus

  if (isInteractive && isFocus && !isActive) {
    outline = 'none';
    borderColor = focusBorderColor;
  } // Disabled


  if (isDisabled) {
    cursor = 'not-allowed';
    opacity = 0.75;
    pointerEvents = 'none';
  } // Interactive


  if (isInteractive) {
    cursor = 'pointer';
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n    align-items: center;\n    background-color: ", ";\n    border-radius: ", "px;\n    border: 2px solid ", ";\n    box-sizing: content-box;\n    color: inherit;\n    cursor: ", ";\n    display: flex;\n    font-size: inherit;\n    font-style: normal;\n    font-weight: normal;\n    line-height: 1;\n    opacity: ", ";\n    outline: ", ";\n    margin: 0;\n    padding: ", "px;\n    pointer-events: ", ";\n    text-align: left;\n    text-decoration: none;\n    width: 100%;\n  "], getBackgroundColor, __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["borderRadius"], borderColor, cursor, opacity, outline, __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["math"].divide(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"], 2), pointerEvents);
}

var truncateText = function truncateText(p) {
  return p.truncate && Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  "]);
};

var truncateTextFlexParent = function truncateTextFlexParent(p) {
  return p.truncate && Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n    max-width: 100%;\n    min-width: 0;\n  "]);
};

var Content = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "AvatarItem__Content",
  componentId: "sc-189r3pd-0"
})(["\n  ", " flex: 1 1 100%;\n  line-height: 1.4;\n  padding-left: ", "px;\n"], truncateTextFlexParent, __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"]);
var PrimaryText = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["withTheme"])(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "AvatarItem__PrimaryText",
  componentId: "sc-189r3pd-1"
})(["\n  ", " color: ", ";\n"], truncateText, textColors));
var SecondaryText = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["withTheme"])(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "AvatarItem__SecondaryText",
  componentId: "sc-189r3pd-2"
})(["\n  ", " color: ", ";\n  font-size: 0.85em;\n"], truncateText, subtleTextColors));

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThemeItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);

var ThemeItem = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["createTheme"])(function () {
  return {
    backgroundColor: ''
  };
});

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = mouseLocation;
/* harmony export (immutable) */ __webpack_exports__["a"] = actualMouseMove;
/* harmony export (immutable) */ __webpack_exports__["b"] = leftClick;
function mouseLocation(event) {
    return {
        x: event.clientX,
        y: event.clientY,
    };
}
// Used to prevent invalid mouse move detection on scroll
// lastPosition is object (x, y)
function actualMouseMove(oldPosition, newPosition) {
    if (!oldPosition ||
        oldPosition.x !== newPosition.x ||
        oldPosition.y !== newPosition.y) {
        return true;
    }
    return false;
}
function leftClick(event) {
    return (event.button === 0 &&
        !event.altKey &&
        !event.ctrlKey &&
        !event.metaKey &&
        !event.shiftKey);
}
//# sourceMappingURL=mouse.js.map

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoAccessTooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_tooltip__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_i18n__ = __webpack_require__(403);



var NoAccessTooltip = function (_a) {
    var name = _a.name, children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__util_i18n__["f" /* NoAccessWarning */], { name: name }, function (text) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__atlaskit_tooltip__["a" /* default */], { content: text, position: "right" }, children)); }));
};
//# sourceMappingURL=NoAccessTooltip.js.map

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MentionListError__ = __webpack_require__(1922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MentionItem__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Scrollable__ = __webpack_require__(1924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_logger__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_mouse__ = __webpack_require__(716);








function wrapIndex(mentions, index) {
    var len = mentions.length;
    var newIndex = index;
    while (newIndex < 0 && len > 0) {
        newIndex += len;
    }
    return newIndex % len;
}
function getKey(index, mentions) {
    return mentions && mentions[index] && mentions[index].id;
}
function getIndex(key, mentions) {
    var index;
    if (mentions) {
        index = 0;
        while (index < mentions.length && mentions[index].id !== key) {
            index++;
        }
        if (index === mentions.length) {
            index = undefined;
        }
    }
    return index;
}
var MentionList = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionList, _super);
    function MentionList(props) {
        var _this = _super.call(this, props) || this;
        // API
        _this.selectNext = function () {
            var newIndex = wrapIndex(_this.props.mentions, _this.state.selectedIndex + 1);
            _this.selectIndex(newIndex);
        };
        _this.selectPrevious = function () {
            var newIndex = wrapIndex(_this.props.mentions, _this.state.selectedIndex - 1);
            _this.selectIndex(newIndex);
        };
        _this.selectIndex = function (index, callback) {
            var mentions = _this.props.mentions;
            _this.setState({
                selectedIndex: index,
                selectedKey: getKey(index, mentions),
            }, callback);
        };
        _this.selectId = function (id, callback) {
            var mentions = _this.props.mentions;
            var index = getIndex(id, mentions);
            if (index !== undefined) {
                _this.setState({
                    selectedIndex: index,
                    selectedKey: id,
                }, callback);
            }
        };
        _this.chooseCurrentSelection = function () {
            var _a = _this.props, mentions = _a.mentions, onSelection = _a.onSelection;
            var selectedIndex = _this.state.selectedIndex;
            var selectedMention = mentions && mentions[selectedIndex || 0];
            Object(__WEBPACK_IMPORTED_MODULE_6__util_logger__["a" /* default */])('ak-mention-list.chooseCurrentSelection', selectedMention);
            if (onSelection && selectedMention) {
                onSelection(selectedMention);
            }
        };
        _this.mentionsCount = function () {
            var mentions = _this.props.mentions;
            return (mentions && mentions.length) || 0;
        };
        _this.selectIndexOnHover = function (mention, event) {
            if (!event) {
                return;
            }
            var mousePosition = Object(__WEBPACK_IMPORTED_MODULE_7__util_mouse__["c" /* mouseLocation */])(event);
            if (Object(__WEBPACK_IMPORTED_MODULE_7__util_mouse__["a" /* actualMouseMove */])(_this.lastMousePosition, mousePosition)) {
                _this.selectId(mention.id);
            }
            _this.lastMousePosition = mousePosition;
        };
        _this.itemSelected = function (mention) {
            _this.selectId(mention.id, function () {
                _this.chooseCurrentSelection();
            });
        };
        _this.handleScrollableRef = function (ref) {
            _this.scrollable = ref;
        };
        _this.setDefaultSelectionState();
        return _this;
    }
    MentionList.prototype.componentWillReceiveProps = function (nextProps) {
        // adjust selection
        var mentions = nextProps.mentions;
        var selectedKey = this.state.selectedKey;
        if (mentions) {
            if (!selectedKey) {
                // don't explicitly set any selected index and go with default behaviour
                return;
            }
            for (var i = 0; i < mentions.length; i++) {
                if (selectedKey === mentions[i].id) {
                    this.setState({
                        selectedIndex: i,
                    });
                    return;
                }
            }
            // existing selection not in results so clear any current selection state and go with default behaviour
            this.setDefaultSelectionState();
        }
    };
    MentionList.prototype.componentDidUpdate = function () {
        var mentions = this.props.mentions;
        var selectedIndex = this.state.selectedIndex;
        if (mentions && mentions[selectedIndex]) {
            this.revealItem(mentions[selectedIndex].id);
        }
        // FIXME - a React version of this _may_ be required for Confluence
        // integration tests. Will remove / fix once known
        // emit(elem, mentionListRenderedEvent);
    };
    // Internal
    MentionList.prototype.revealItem = function (key) {
        var item = this.items[key];
        if (item && this.scrollable) {
            this.scrollable.reveal(item);
        }
    };
    /**
     * The default selection state is to chose index 0 and not have any particular key selected
     */
    MentionList.prototype.setDefaultSelectionState = function () {
        this.state = {
            selectedIndex: 0,
            selectedKey: undefined,
        };
    };
    MentionList.prototype.renderItems = function () {
        var _this = this;
        var mentions = this.props.mentions;
        if (mentions && mentions.length) {
            this.items = {};
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, mentions.map(function (mention, idx) {
                var key = mention.id;
                var item = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__MentionItem__["a" /* default */], { mention: mention, selected: _this.isSelectedMention(mention, idx), key: key, onMouseMove: _this.selectIndexOnHover, 
                    /* Cannot use onclick, as onblur will close the element, and prevent
                     * onClick from firing.
                     */
                    onSelection: _this.itemSelected, 
                    // tslint:disable-next-line:jsx-no-lambda
                    ref: function (ref) {
                        if (ref) {
                            _this.items[key] = ref;
                        }
                        else {
                            delete _this.items[key];
                        }
                    } }));
                return item;
            })));
        }
        return null;
    };
    MentionList.prototype.isSelectedMention = function (mention, index) {
        var selectedKey = this.state.selectedKey;
        return selectedKey ? selectedKey === mention.id : index === 0;
    };
    MentionList.prototype.render = function () {
        var _a = this.props, mentions = _a.mentions, resourceError = _a.resourceError;
        var hasMentions = mentions && mentions.length;
        // If we get an error, but existing mentions are displayed, lets
        // just continue to show the existing mentions we have
        var mustShowError = resourceError && !hasMentions;
        var errorSection;
        var resultSection;
        if (mustShowError) {
            errorSection = __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__MentionListError__["a" /* default */], { error: resourceError });
        }
        else if (hasMentions) {
            resultSection = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Scrollable__["a" /* default */], { ref: this.handleScrollableRef }, this.renderItems()));
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* MentionListStyle */], { empty: !hasMentions && !resourceError },
            errorSection,
            resultSection));
    };
    return MentionList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (MentionList);
//# sourceMappingURL=index.js.map

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MentionListErrorStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GenericErrorVisualStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MentionListErrorHeadlineStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MentionListAdviceStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



// tslint:disable:next-line variable-name
var MentionListErrorStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  background-color: white;\n  color: ", ";\n  border: 1px solid #fff;\n  border-radius: ", "px;\n"], ["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  background-color: white;\n  color: ", ";\n  border: 1px solid #fff;\n  border-radius: ", "px;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N500, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])());
var GenericErrorVisualStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  height: 108px;\n  margin-bottom: 8px;\n  margin-top: 36px;\n  width: 83px;\n"], ["\n  height: 108px;\n  margin-bottom: 8px;\n  margin-top: 36px;\n  width: 83px;\n"])));
// TODO: Figure out why the themed css function is causing type errors when passed prop children
var MentionListErrorHeadlineStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", ";\n  margin-bottom: 8px;\n"], ["\n  ", ";\n  margin-bottom: 8px;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["typography"].h400());
var MentionListAdviceStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin-bottom: 48px;\n"], ["\n  margin-bottom: 48px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MentionList__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_logger__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_id__ = __webpack_require__(721);





function applyPresence(mentions, presences) {
    var updatedMentions = [];
    for (var i = 0; i < mentions.length; i++) {
        // Shallow copy
        var mention = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, mentions[i]);
        var presence = presences[mention.id];
        if (presence) {
            mention.presence = presence;
        }
        updatedMentions.push(mention);
    }
    return updatedMentions;
}
function extractPresences(mentions) {
    var presences = {};
    for (var i = 0; i < mentions.length; i++) {
        var mention = mentions[i];
        if (mention.presence) {
            presences[mention.id] = mention.presence;
        }
    }
    return presences;
}
var ResourcedMentionList = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ResourcedMentionList, _super);
    function ResourcedMentionList(props) {
        var _this = _super.call(this, props) || this;
        // API
        _this.selectNext = function () {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectNext();
            }
        };
        _this.selectPrevious = function () {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectPrevious();
            }
        };
        _this.selectIndex = function (index, callback) {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectIndex(index, callback);
            }
        };
        _this.selectId = function (id, callback) {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectId(id, callback);
            }
        };
        _this.chooseCurrentSelection = function () {
            if (_this.mentionListRef) {
                _this.mentionListRef.chooseCurrentSelection();
            }
        };
        _this.mentionsCount = function () {
            if (_this.mentionListRef) {
                return _this.mentionListRef.mentionsCount();
            }
            return 0;
        };
        // internal, used for callbacks
        _this.filterChange = function (mentions) {
            // Retain known presence
            var currentPresences = extractPresences(_this.state.mentions);
            _this.setState({
                resourceError: undefined,
                mentions: applyPresence(mentions, currentPresences),
            });
            _this.refreshPresences(mentions);
        };
        _this.filterError = function (error) {
            Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])('ak-resourced-mentions-list._filterError', error);
            _this.setState({
                resourceError: error,
            });
        };
        _this.presenceUpdate = function (presences) {
            _this.setState({
                mentions: applyPresence(_this.state.mentions, presences),
            });
        };
        _this.notifySelection = function (mention) {
            _this.props.resourceProvider.recordMentionSelection(mention);
            if (_this.props.onSelection) {
                _this.props.onSelection(mention);
            }
        };
        _this.handleMentionListRef = function (ref) {
            _this.mentionListRef = ref;
        };
        _this.subscriberKey = Object(__WEBPACK_IMPORTED_MODULE_4__util_id__["a" /* default */])('ak-resourced-mention-list');
        _this.state = {
            resourceError: undefined,
            mentions: [],
        };
        _this.applyPropChanges({}, props);
        return _this;
    }
    ResourcedMentionList.prototype.componentDidMount = function () {
        this.subscribeMentionProvider(this.props.resourceProvider);
        this.subscribePresenceProvider(this.props.presenceProvider);
    };
    ResourcedMentionList.prototype.componentWillReceiveProps = function (nextProps) {
        this.applyPropChanges(this.props, nextProps);
    };
    ResourcedMentionList.prototype.componentWillUnmount = function () {
        this.unsubscribeMentionProvider(this.props.resourceProvider);
        this.unsubscribePresenceProvider(this.props.presenceProvider);
    };
    // internal
    ResourcedMentionList.prototype.subscribeMentionProvider = function (mentionProvider) {
        if (mentionProvider) {
            mentionProvider.subscribe(this.subscriberKey, this.filterChange, this.filterError);
        }
    };
    ResourcedMentionList.prototype.subscribePresenceProvider = function (presenceProvider) {
        if (presenceProvider) {
            presenceProvider.subscribe(this.subscriberKey, this.presenceUpdate);
        }
    };
    ResourcedMentionList.prototype.unsubscribeMentionProvider = function (mentionProvider) {
        if (mentionProvider) {
            mentionProvider.unsubscribe(this.subscriberKey);
        }
    };
    ResourcedMentionList.prototype.unsubscribePresenceProvider = function (presenceProvider) {
        if (presenceProvider) {
            presenceProvider.unsubscribe(this.subscriberKey);
        }
    };
    ResourcedMentionList.prototype.applyPropChanges = function (prevProps, nextProps) {
        var oldResourceProvider = prevProps.resourceProvider;
        var oldPresenceProvider = prevProps.presenceProvider;
        var oldQuery = prevProps.query;
        var newResourceProvider = nextProps.resourceProvider;
        var newPresenceProvider = nextProps.presenceProvider;
        var newQuery = nextProps.query;
        var resourceProviderChanged = oldResourceProvider !== newResourceProvider;
        var queryChanged = oldQuery !== newQuery;
        var canFilter = !!(typeof newQuery === 'string' && newResourceProvider);
        var shouldFilter = canFilter && (queryChanged || resourceProviderChanged);
        // resource provider
        if (resourceProviderChanged) {
            this.unsubscribeMentionProvider(oldResourceProvider);
            this.subscribeMentionProvider(newResourceProvider);
        }
        // presence provider
        if (oldPresenceProvider !== newPresenceProvider) {
            this.unsubscribePresenceProvider(oldPresenceProvider);
            this.subscribePresenceProvider(newPresenceProvider);
        }
        if (shouldFilter) {
            newResourceProvider.filter(newQuery);
        }
    };
    ResourcedMentionList.prototype.refreshPresences = function (mentions) {
        if (this.props.presenceProvider) {
            var ids = mentions.map(function (mention) { return mention.id; });
            this.props.presenceProvider.refreshPresence(ids);
        }
    };
    ResourcedMentionList.prototype.render = function () {
        var _a = this.state, mentions = _a.mentions, resourceError = _a.resourceError;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__MentionList__["a" /* default */], { mentions: mentions, resourceError: resourceError, onSelection: this.notifySelection, ref: this.handleMentionListRef }));
    };
    return ResourcedMentionList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (ResourcedMentionList);
//# sourceMappingURL=index.js.map

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid__);

/* harmony default export */ __webpack_exports__["a"] = (function (prefix) {
    if (prefix === void 0) { prefix = ''; }
    return prefix + "_" + __WEBPACK_IMPORTED_MODULE_0_uuid__();
});
//# sourceMappingURL=id.js.map

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fireAnalyticsMentionTypeaheadEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fireAnalyticsMentionEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fireAnalytics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__package_json__ = __webpack_require__(1929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(132);



var fireAnalyticsMentionTypeaheadEvent = function (props) { return function (action, duration, userIds, query) {
    if (userIds === void 0) { userIds = []; }
    if (props.createAnalyticsEvent) {
        var eventPayload = {
            action: action,
            actionSubject: 'mentionTypeahead',
            attributes: {
                packageName: __WEBPACK_IMPORTED_MODULE_1__package_json__["name"],
                packageVersion: __WEBPACK_IMPORTED_MODULE_1__package_json__["version"],
                componentName: 'mention',
                duration: Math.round(duration),
                userIds: userIds,
                queryLength: query ? query.length : 0,
            },
            eventType: 'operational',
        };
        var analyticsEvent = props.createAnalyticsEvent(eventPayload);
        analyticsEvent.fire(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ELEMENTS_CHANNEL */]);
    }
}; };
var fireAnalyticsMentionEvent = function (createEvent) { return function (actionSubject, action, text, id, accessLevel) {
    var payload = {
        action: action,
        actionSubject: actionSubject,
        eventType: 'ui',
        attributes: {
            packageName: __WEBPACK_IMPORTED_MODULE_1__package_json__["name"],
            packageVersion: __WEBPACK_IMPORTED_MODULE_1__package_json__["version"],
            componentName: 'mention',
            accessLevel: accessLevel,
            isSpecial: Object(__WEBPACK_IMPORTED_MODULE_2__types__["e" /* isSpecialMentionText */])(text),
            userId: id,
        },
    };
    var event = createEvent(payload);
    event.fire(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ELEMENTS_CHANNEL */]);
    return event;
}; };
// OLD Analytics
var MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
var fireAnalytics = function (firePrivateAnalyticsEvent) { return function (eventName, text, accessLevel) {
    if (firePrivateAnalyticsEvent) {
        firePrivateAnalyticsEvent(MENTION_ANALYTICS_PREFIX + "." + eventName, {
            accessLevel: accessLevel,
            isSpecial: Object(__WEBPACK_IMPORTED_MODULE_2__types__["e" /* isSpecialMentionText */])(text),
        });
    }
}; };
//# sourceMappingURL=analytics.js.map

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ELEMENTS_CHANNEL; });
var ELEMENTS_CHANNEL = 'fabric-elements';
//# sourceMappingURL=constants.js.map

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ANALYTICS_HOVER_DELAY */
/* unused harmony export MentionInternal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NoAccessTooltip__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_analytics__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__ = __webpack_require__(29);








var ANALYTICS_HOVER_DELAY = 1000;
var MentionInternal = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionInternal, _super);
    function MentionInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnClick = function (e) {
            var _a = _this.props, id = _a.id, text = _a.text, onClick = _a.onClick;
            if (onClick) {
                onClick(id, text, e);
            }
        };
        _this.handleOnMouseEnter = function (e) {
            var _a = _this.props, id = _a.id, text = _a.text, onMouseEnter = _a.onMouseEnter, onHover = _a.onHover;
            if (onMouseEnter) {
                onMouseEnter(id, text, e);
            }
            _this.hoverTimeout = window.setTimeout(function () {
                if (onHover) {
                    onHover();
                }
                _this.hoverTimeout = undefined;
            }, ANALYTICS_HOVER_DELAY);
        };
        _this.handleOnMouseLeave = function (e) {
            var _a = _this.props, id = _a.id, text = _a.text, onMouseLeave = _a.onMouseLeave;
            if (onMouseLeave) {
                onMouseLeave(id, text, e);
            }
            if (_this.hoverTimeout) {
                clearTimeout(_this.hoverTimeout);
            }
        };
        _this.getMentionType = function () {
            var _a = _this.props, accessLevel = _a.accessLevel, isHighlighted = _a.isHighlighted;
            if (isHighlighted) {
                return __WEBPACK_IMPORTED_MODULE_4__types__["a" /* MentionType */].SELF;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_4__types__["c" /* isRestricted */])(accessLevel)) {
                return __WEBPACK_IMPORTED_MODULE_4__types__["a" /* MentionType */].RESTRICTED;
            }
            return __WEBPACK_IMPORTED_MODULE_4__types__["a" /* MentionType */].DEFAULT;
        };
        return _this;
    }
    MentionInternal.prototype.componentWillUnmount = function () {
        if (this.hoverTimeout) {
            clearTimeout(this.hoverTimeout);
        }
    };
    MentionInternal.prototype.render = function () {
        var _a = this, handleOnClick = _a.handleOnClick, handleOnMouseEnter = _a.handleOnMouseEnter, handleOnMouseLeave = _a.handleOnMouseLeave, props = _a.props;
        var text = props.text, id = props.id, accessLevel = props.accessLevel;
        var mentionType = this.getMentionType();
        var mentionComponent = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* MentionStyle */], { mentionType: mentionType, onClick: handleOnClick, onMouseEnter: handleOnMouseEnter, onMouseLeave: handleOnMouseLeave }, text));
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { "data-mention-id": id, "data-access-level": accessLevel, spellCheck: false }, mentionType === __WEBPACK_IMPORTED_MODULE_4__types__["a" /* MentionType */].RESTRICTED ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__NoAccessTooltip__["a" /* NoAccessTooltip */], { name: text }, mentionComponent)) : (mentionComponent)));
    };
    return MentionInternal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

// tslint:disable-next-line:variable-name
var MentionWithAnalytics = Object(__WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__["withAnalyticsEvents"])({
    onClick: function (createEvent, props) {
        var id = props.id, text = props.text, accessLevel = props.accessLevel, firePrivateAnalyticsEvent = props.firePrivateAnalyticsEvent;
        var event = Object(__WEBPACK_IMPORTED_MODULE_5__util_analytics__["b" /* fireAnalyticsMentionEvent */])(createEvent)('mention', 'selected', text, id, accessLevel);
        // old analytics
        Object(__WEBPACK_IMPORTED_MODULE_5__util_analytics__["a" /* fireAnalytics */])(firePrivateAnalyticsEvent)('lozenge.select', text, accessLevel);
        return event;
    },
    onHover: function (createEvent, props) {
        var id = props.id, text = props.text, accessLevel = props.accessLevel, firePrivateAnalyticsEvent = props.firePrivateAnalyticsEvent;
        var event = Object(__WEBPACK_IMPORTED_MODULE_5__util_analytics__["b" /* fireAnalyticsMentionEvent */])(createEvent)('mention', 'hovered', text, id, accessLevel);
        // old analytics
        Object(__WEBPACK_IMPORTED_MODULE_5__util_analytics__["a" /* fireAnalytics */])(firePrivateAnalyticsEvent)('lozenge.hover', text, accessLevel);
        return event;
    },
})(MentionInternal);
var Mention = Object(__WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics__["a" /* withAnalytics */])(MentionWithAnalytics, {}, {});
/* harmony default export */ __webpack_exports__["a"] = (Mention);
//# sourceMappingURL=index.js.map

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Profilecard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_spinner__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_avatar__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__atlaskit_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__atlaskit_lozenge__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ErrorMessage__ = __webpack_require__(1935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_HeightTransitionWrapper__ = __webpack_require__(1939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_IconLabel__ = __webpack_require__(1940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_MessagesIntlProvider__ = __webpack_require__(1946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__relative_date__ = __webpack_require__(1973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__internal_presences__ = __webpack_require__(1981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__messages__ = __webpack_require__(1982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styled_Card__ = __webpack_require__(726);























var Profilecard =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Profilecard, _PureComponent);

  function Profilecard(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Profilecard);

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Profilecard).call(this, props));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "_timeOpen", void 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "clientFetchProfile", void 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "callClientFetchProfile", function () {
      if (_this.props.clientFetchProfile) {
        var _this$props;

        (_this$props = _this.props).clientFetchProfile.apply(_this$props, arguments);
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "callAnalytics", function (id, options) {
      if (_this.props.analytics) {
        _this.props.analytics(id, options);
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "_durationSince", function (from) {
      var fromParsed = parseInt(from, 10) || 0;
      return fromParsed > 0 ? Date.now() - fromParsed : null;
    });

    _this._timeOpen = null;

    _this.clientFetchProfile = function () {
      var _this2;

      _this.callAnalytics('profile-card.reload', {});

      (_this2 = _this).callClientFetchProfile.apply(_this2, arguments);
    };

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Profilecard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._timeOpen = Date.now();
      this.callAnalytics('profile-card.view', {});
    }
  }, {
    key: "renderActionsButtons",
    value: function renderActionsButtons() {
      var _this3 = this;

      if (this.props.actions && this.props.actions.length === 0) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styled_Card__["a" /* ActionButtonGroup */], null, this.props.actions && this.props.actions.map(function (action, idx) {
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__atlaskit_button__["default"], {
          appearance: idx === 0 ? 'default' : 'subtle',
          compact: true,
          key: action.label,
          onClick: function onClick() {
            _this3.callAnalytics('profile-card.click', {
              id: action.id || null,
              duration: _this3._durationSince(_this3._timeOpen)
            });

            if (action.callback) {
              action.callback.apply(action, arguments);
            }
          }
        }, action.label);
      }));
    }
  }, {
    key: "renderErrorMessage",
    value: function renderErrorMessage() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_ErrorMessage__["a" /* default */], {
        reload: this.props.clientFetchProfile && this.clientFetchProfile,
        errorType: this.props.errorType
      });
    }
  }, {
    key: "renderCardDetailsDefault",
    value: function renderCardDetailsDefault() {
      var _this$props2 = this.props,
          meta = _this$props2.meta,
          presence = _this$props2.presence,
          presenceMessage = _this$props2.presenceMessage,
          nickname = _this$props2.nickname,
          fullName = _this$props2.fullName,
          location = _this$props2.location,
          email = _this$props2.email,
          timestring = _this$props2.timestring,
          companyName = _this$props2.companyName;
      var validPresence = __WEBPACK_IMPORTED_MODULE_19__internal_presences__["a" /* default */][presence || 'none'];
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styled_Card__["f" /* DetailsGroup */], null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styled_Card__["k" /* FullNameLabel */], {
        noMeta: !meta
      }, fullName), meta && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styled_Card__["l" /* JobTitleLabel */], null, meta), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_IconLabel__["a" /* default */], {
        icon: presence
      }, !!validPresence && presenceMessage || validPresence), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_IconLabel__["a" /* default */], {
        icon: "email"
      }, email), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_IconLabel__["a" /* default */], {
        icon: "mention"
      }, nickname && "@".concat(nickname)), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_IconLabel__["a" /* default */], {
        icon: "time"
      }, timestring), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_IconLabel__["a" /* default */], {
        icon: "companyName"
      }, companyName), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_IconLabel__["a" /* default */], {
        icon: "location"
      }, location));
    }
  }, {
    key: "renderCardDetailsForDisabledAccount",
    value: function renderCardDetailsForDisabledAccount() {
      var _this$props3 = this.props,
          nickname = _this$props3.nickname,
          status = _this$props3.status,
          companyName = _this$props3.companyName;
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styled_Card__["f" /* DetailsGroup */], null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styled_Card__["k" /* FullNameLabel */], {
        noMeta: true,
        isDisabledAccount: true
      }, this.getDisabledAccountName()), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styled_Card__["m" /* LozengeWrapper */], null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__atlaskit_lozenge__["default"], {
        appearance: "default",
        isBold: true
      }, status === 'inactive' && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], __WEBPACK_IMPORTED_MODULE_20__messages__["a" /* default */].inactiveAccountMsg), status === 'closed' && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], __WEBPACK_IMPORTED_MODULE_20__messages__["a" /* default */].closedAccountMsg))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styled_Card__["j" /* DisabledInfo */], null, this.getDisabledAccountDesc()), status === 'inactive' && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_IconLabel__["a" /* default */], {
        icon: "mention"
      }, nickname && "@".concat(nickname)), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_IconLabel__["a" /* default */], {
        icon: "companyName"
      }, companyName)));
    }
  }, {
    key: "getDisabledAccountName",
    value: function getDisabledAccountName() {
      var _this$props4 = this.props,
          nickname = _this$props4.nickname,
          fullName = _this$props4.fullName,
          status = _this$props4.status;

      if (status === 'inactive') {
        return fullName || nickname;
      } else if (status === 'closed') {
        return nickname || __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], __WEBPACK_IMPORTED_MODULE_20__messages__["a" /* default */].disabledAccountDefaultName);
      }

      return null;
    }
  }, {
    key: "getDisabledAccountDesc",
    value: function getDisabledAccountDesc() {
      var _this$props5 = this.props,
          _this$props5$status = _this$props5.status,
          status = _this$props5$status === void 0 ? 'closed' : _this$props5$status,
          statusModifiedDate = _this$props5.statusModifiedDate;
      var date = statusModifiedDate ? new Date(statusModifiedDate * 1000) : null;
      var relativeDateKey = Object(__WEBPACK_IMPORTED_MODULE_18__relative_date__["a" /* default */])(date);
      var secondSentence = null;

      if (relativeDateKey) {
        secondSentence = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], __WEBPACK_IMPORTED_MODULE_20__messages__["a" /* default */]["".concat(status, "AccountDescMsgHasDate").concat(relativeDateKey)]);
      } else {
        secondSentence = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], __WEBPACK_IMPORTED_MODULE_20__messages__["a" /* default */]["".concat(status, "AccountDescMsgNoDate")]);
      }

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("p", null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"], __WEBPACK_IMPORTED_MODULE_20__messages__["a" /* default */].generalDescMsgForDisabledUser), ' ', secondSentence);
    }
  }, {
    key: "renderCardDetailsApp",
    value: function renderCardDetailsApp() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styled_Card__["f" /* DetailsGroup */], null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styled_Card__["k" /* FullNameLabel */], null, this.props.fullName), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styled_Card__["c" /* AppTitleLabel */], null, "App"), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_IconLabel__["a" /* default */], {
        icon: "mention"
      }, this.props.nickname && "@".concat(this.props.nickname)));
    }
  }, {
    key: "renderCardDetails",
    value: function renderCardDetails() {
      var _this$props6 = this.props,
          isBot = _this$props6.isBot,
          status = _this$props6.status;

      if (isBot) {
        return this.renderCardDetailsApp();
      }

      if (status === 'inactive' || status === 'closed') {
        return this.renderCardDetailsForDisabledAccount();
      }

      return this.renderCardDetailsDefault();
    }
  }, {
    key: "renderProfilecard",
    value: function renderProfilecard() {
      var status = this.props.status;
      this.callAnalytics('profile-card.loaded', {
        duration: this._durationSince(this._timeOpen)
      });
      var isDisabledUser = status === 'inactive' || status === 'closed';
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styled_Card__["d" /* CardContainer */], {
        isDisabledUser: isDisabledUser
      }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styled_Card__["n" /* ProfileImage */], null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__atlaskit_avatar__["d" /* default */], {
        size: "xlarge",
        src: this.props.status !== 'closed' ? this.props.avatarUrl : null,
        borderColor: __WEBPACK_IMPORTED_MODULE_9__atlaskit_theme__["colors"].N0
      })), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styled_Card__["e" /* CardContent */], null, this.renderCardDetails(), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styled_Card__["b" /* ActionsFlexSpacer */], null), this.renderActionsButtons()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          fullName = _this$props7.fullName,
          status = _this$props7.status;
      var customElevation = this.props.customElevation;
      var cardContent = null; // closed users have empty fullName field

      var isFetched = fullName || status === 'closed';

      if (this.props.hasError) {
        this.callAnalytics('profile-card.error', {});
        cardContent = this.renderErrorMessage();
      } else if (this.props.isLoading) {
        cardContent = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__styled_Card__["o" /* SpinnerContainer */], null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__atlaskit_spinner__["a" /* default */], null));
      } else if (isFetched) {
        cardContent = this.renderProfilecard();
      }

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_MessagesIntlProvider__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_HeightTransitionWrapper__["a" /* default */], {
        customElevation: customElevation
      }, cardContent));
    }
  }]);

  return Profilecard;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Profilecard, "defaultProps", {
  status: 'active',
  isBot: false,
  isNotMentionable: false,
  presence: 'none',
  actions: [],
  isLoading: false,
  hasError: false,
  analytics: function analytics() {},
  clientFetchProfile: function clientFetchProfile() {},
  presenceMessage: ''
});



/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ProfileImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionsFlexSpacer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionButtonGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CardContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DetailsGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DisabledInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FullNameLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return LozengeWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return JobTitleLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AppTitleLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SpinnerContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CardContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DetailsLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DetailsLabelIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DetailsLabelText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_shared_styles__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_shared_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__atlaskit_util_shared_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled_constants__ = __webpack_require__(406);





var getFullNameMargin = function getFullNameMargin(props) {
  return props.noMeta ? "".concat(Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() * 4.5, "px 0 ").concat(Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() * 1.5, "px 0") : "".concat(Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() * 1.5, "px 0 0 0");
};

var ProfileImage = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Card__ProfileImage",
  componentId: "gwoajk-0"
})(["\n  position: absolute;\n  top: ", "px;\n  left: ", "px;\n"], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 3), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 3));
var ActionsFlexSpacer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Card__ActionsFlexSpacer",
  componentId: "gwoajk-1"
})(["\n  flex: 1 0 auto;\n"]);
var ActionButtonGroup = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Card__ActionButtonGroup",
  componentId: "gwoajk-2"
})(["\n  user-select: none;\n  margin: ", "px 0 0 0;\n  text-align: right;\n\n  button {\n    margin-left: ", "px;\n\n    &:first-child {\n      margin-left: 0;\n    }\n  }\n"], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 2), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"]);
var CardContent = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Card__CardContent",
  componentId: "gwoajk-3"
})(["\n  display: flex;\n  flex-direction: column;\n  min-height: ", "px;\n"], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 17));
var DetailsGroup = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Card__DetailsGroup",
  componentId: "gwoajk-4"
})(["\n  display: flex;\n  flex-direction: column;\n  margin-left: ", "px;\n  width: ", "px;\n"], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 14.5), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 24.5));
var DisabledInfo = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Card__DisabledInfo",
  componentId: "gwoajk-5"
})(["\n  font-size: ", "px;\n  color: ", ";\n  margin: ", "px 0 0 0;\n  line-height: ", "px;\n"], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["fontSizeSmall"], __WEBPACK_IMPORTED_MODULE_3__styled_constants__["l" /* labelTextColor */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 1.5), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 2));
var FullNameLabel = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "Card__FullNameLabel",
  componentId: "gwoajk-6"
})(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  font-size: 18px;\n  color: ", ";\n  margin: ", ";\n  line-height: ", "em;\n"], function (props) {
  return props.isDisabledAccount ? __WEBPACK_IMPORTED_MODULE_3__styled_constants__["j" /* headerTextColorInactive */] : __WEBPACK_IMPORTED_MODULE_3__styled_constants__["i" /* headerTextColor */];
}, function (props) {
  return getFullNameMargin(props);
}, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].divide(function () {
  return 24;
}, 18));
var LozengeWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Card__LozengeWrapper",
  componentId: "gwoajk-7"
})(["\n  margin-top: ", "px;\n  text-transform: uppercase;\n  display: block;\n"], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 2));
var JobTitleLabel = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "Card__JobTitleLabel",
  componentId: "gwoajk-8"
})(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  font-size: 14px;\n  color: ", ";\n  margin: 0 0 ", "px 0;\n  line-height: ", "em;\n"], __WEBPACK_IMPORTED_MODULE_3__styled_constants__["i" /* headerTextColor */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 1.5), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].divide(function () {
  return 24;
}, 14));
var AppTitleLabel = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "Card__AppTitleLabel",
  componentId: "gwoajk-9"
})(["\n  background: ", ";\n  color: ", ";\n  border-radius: ", ";\n  padding: 0 6px;\n  width: fit-content;\n  font-weight: bold;\n  text-transform: uppercase;\n\n  font-size: 12px;\n  margin: 4px 0 ", "px 0;\n  line-height: ", "em;\n"], __WEBPACK_IMPORTED_MODULE_3__styled_constants__["a" /* appLabelBgColor */], __WEBPACK_IMPORTED_MODULE_3__styled_constants__["b" /* appLabelTextColor */], __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_shared_styles__["akBorderRadius"], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 1.5), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].divide(function () {
  return 24;
}, 14));
var SpinnerContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Card__SpinnerContainer",
  componentId: "gwoajk-10"
})(["\n  align-items: center;\n  display: flex;\n  height: ", "px;\n  justify-content: center;\n  position: relative;\n"], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 12));
var CardContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Card__CardContainer",
  componentId: "gwoajk-11"
})(["\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-image: linear-gradient(\n    to bottom,\n    ", "\n      0%,\n    ", "\n      100%\n  );\n  background-repeat: no-repeat;\n  background-size: 100% ", "px;\n  box-sizing: content-box;\n  padding: ", "px;\n"], function (props) {
  return props.isDisabledUser ? __WEBPACK_IMPORTED_MODULE_3__styled_constants__["h" /* headerBgColorDisabledUser */] : __WEBPACK_IMPORTED_MODULE_3__styled_constants__["g" /* headerBgColor */];
}, function (props) {
  return props.isDisabledUser ? __WEBPACK_IMPORTED_MODULE_3__styled_constants__["h" /* headerBgColorDisabledUser */] : __WEBPACK_IMPORTED_MODULE_3__styled_constants__["g" /* headerBgColor */];
}, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 12), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 3));
var DetailsLabel = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Card__DetailsLabel",
  componentId: "gwoajk-12"
})(["\n  display: flex;\n  align-items: center;\n  line-height: ", "px;\n  font-size: ", "px;\n  margin: ", "px 0 0 0;\n  white-space: nowrap;\n\n  & + & {\n    margin-top: ", "px;\n  }\n"], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 3), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 1.5), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 2), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 0.25));
var DetailsLabelIcon = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Card__DetailsLabelIcon",
  componentId: "gwoajk-13"
})(["\n  display: flex;\n  flex-shrink: 0;\n  color: ", ";\n  width: ", "px;\n  height: ", "px;\n  padding: ", "px;\n  vertical-align: top;\n\n  svg {\n    width: 100%;\n    height: 100%;\n  }\n"], __WEBPACK_IMPORTED_MODULE_3__styled_constants__["k" /* labelIconColor */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 2), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 2), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 0.5));
var DetailsLabelText = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "Card__DetailsLabelText",
  componentId: "gwoajk-14"
})(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: ", ";\n  padding-left: ", "px;\n"], __WEBPACK_IMPORTED_MODULE_3__styled_constants__["l" /* labelTextColor */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 0.5));

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(74)

/**
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn

  date.setDate(date.getDate() - diff)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfWeek


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var isDate = __webpack_require__(639)

/**
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {Date} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} argument must be an instance of Date
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate) {
  if (isDate(dirtyDate)) {
    return !isNaN(dirtyDate)
  } else {
    throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date')
  }
}

module.exports = isValid


/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProfilecardResourced; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__profilecard__ = __webpack_require__(725);












var ProfilecardResourced =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(ProfilecardResourced, _PureComponent);

  function ProfilecardResourced(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, ProfilecardResourced);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(ProfilecardResourced).call(this, props));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "_isMounted", void 0);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      isLoading: false,
      hasError: false,
      error: null,
      data: {}
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "clientFetchProfile", function () {
      var _this$props = _this.props,
          cloudId = _this$props.cloudId,
          userId = _this$props.userId;

      _this.setState({
        isLoading: true,
        hasError: false,
        data: {}
      });

      _this.props.resourceClient.getProfile(cloudId, userId).then(function (res) {
        return _this.handleClientSuccess(res);
      }, function (err) {
        return _this.handleClientError(err);
      }).catch(function (err) {
        return _this.handleClientError(err);
      });
    });

    _this._isMounted = false;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(ProfilecardResourced, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
      this.clientFetchProfile();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.userId !== prevProps.userId || this.props.cloudId !== prevProps.cloudId) {
        this.clientFetchProfile();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "handleClientSuccess",
    value: function handleClientSuccess(res) {
      if (!this._isMounted) {
        return;
      }

      this.setState({
        isLoading: false,
        hasError: false,
        data: res
      });
    }
  }, {
    key: "handleClientError",
    value: function handleClientError(err) {
      if (!this._isMounted) {
        return;
      }

      this.setState({
        isLoading: false,
        hasError: true,
        error: err
      });
    }
  }, {
    key: "filterActions",
    value: function filterActions() {
      var _this2 = this;

      var actions = this.props.actions || [];
      return actions.filter(function (action) {
        if (!action.shouldRender) {
          return true;
        } else if (typeof action.shouldRender !== 'function') {
          return Boolean(action.shouldRender);
        }

        return action.shouldRender(_this2.state.data);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var newProps = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({
        isLoading: this.state.isLoading,
        hasError: this.state.hasError,
        errorType: this.state.error,
        clientFetchProfile: this.clientFetchProfile,
        analytics: this.props.analytics
      }, this.state.data);

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__profilecard__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, newProps, {
        actions: this.filterActions()
      }));
    }
  }]);

  return ProfilecardResourced;
}(__WEBPACK_IMPORTED_MODULE_9_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(ProfilecardResourced, "defaultProps", {
  actions: []
});



/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Layer__ = __webpack_require__(1985);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Layer__["a"]; });


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScrollLock = __webpack_require__(1987);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ScrollLock).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raf_schd__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1996);






var Popup = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Popup, _super);
    function Popup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            overflowScrollParent: false,
        };
        _this.placement = ['', ''];
        _this.handleRef = function (popup) {
            if (!popup) {
                return;
            }
            _this.initPopup(popup);
        };
        _this.scheduledUpdatePosition = Object(__WEBPACK_IMPORTED_MODULE_3_raf_schd__["a" /* default */])(function (props) {
            return _this.updatePosition(props);
        });
        _this.onResize = function () { return _this.scheduledUpdatePosition(); };
        return _this;
    }
    /**
     * Calculates new popup position
     */
    Popup.prototype.updatePosition = function (props, state) {
        if (props === void 0) { props = this.props; }
        if (state === void 0) { state = this.state; }
        var target = props.target, fitHeight = props.fitHeight, fitWidth = props.fitWidth, boundariesElement = props.boundariesElement, offset = props.offset, onPositionCalculated = props.onPositionCalculated, onPlacementChanged = props.onPlacementChanged, alignX = props.alignX, alignY = props.alignY, stick = props.stick;
        var popup = state.popup;
        if (!target || !popup) {
            return;
        }
        var placement = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* calculatePlacement */])(target, boundariesElement || document.body, fitWidth, fitHeight, alignX, alignY);
        if (onPlacementChanged && this.placement.join('') !== placement.join('')) {
            onPlacementChanged(placement);
            this.placement = placement;
        }
        var position = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* calculatePosition */])({
            placement: placement,
            popup: popup,
            target: target,
            stick: stick,
            offset: offset,
        });
        position = onPositionCalculated ? onPositionCalculated(position) : position;
        this.setState({ position: position });
    };
    Popup.prototype.cannotSetPopup = function (popup, target, overflowScrollParent) {
        /**
         * Check whether:
         * 1. Popup's offset targets which means whether or not its possible to correctly position popup along with given target.
         * 2. Popup is inside "overflow: scroll" container, but its offset parent isn't.
         *
         * Currently Popup isn't capable of position itself correctly in case 2,
         * Add "position: relative" to "overflow: scroll" container or to some other FloatingPanel wrapper inside it.
         */
        return ((document.body.contains(target) &&
            (popup.offsetParent && !popup.offsetParent.contains(target))) ||
            (overflowScrollParent &&
                !overflowScrollParent.contains(popup.offsetParent)));
    };
    /**
     * Popup initialization.
     * Checks whether it's possible to position popup along given target, and if it's not throws an error.
     */
    Popup.prototype.initPopup = function (popup) {
        var target = this.props.target;
        var overflowScrollParent = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["c" /* findOverflowScrollParent */])(popup);
        if (this.cannotSetPopup(popup, target, overflowScrollParent)) {
            return;
        }
        this.setState({ popup: popup, overflowScrollParent: overflowScrollParent }, this.scheduledUpdatePosition);
    };
    Popup.prototype.componentWillReceiveProps = function (newProps) {
        // We are delaying `updatePosition` otherwise it happens before the children
        // get rendered and we end up with a wrong position
        this.scheduledUpdatePosition(newProps);
    };
    Popup.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.onResize);
        var stick = this.props.stick;
        if (stick) {
            this.scrollElement = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["c" /* findOverflowScrollParent */])(this.props.target);
        }
        else {
            this.scrollElement = this.props.scrollableElement;
        }
        if (this.scrollElement) {
            this.scrollElement.addEventListener('scroll', this.onResize);
        }
    };
    Popup.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onResize);
        if (this.scrollElement) {
            this.scrollElement.removeEventListener('scroll', this.onResize);
        }
        this.scheduledUpdatePosition.cancel();
    };
    Popup.prototype.renderPopup = function () {
        var position = this.state.position;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this.handleRef, style: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ position: 'absolute', zIndex: this.props.zIndex || __WEBPACK_IMPORTED_MODULE_4__styles__["f" /* akEditorFloatingPanelZIndex */] }, position), "aria-label": this.props.ariaLabel || 'Popup', "data-editor-popup": true }, this.props.children));
    };
    Popup.prototype.render = function () {
        if (!this.props.target) {
            return null;
        }
        if (this.props.mountTo) {
            return Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["createPortal"])(this.renderPopup(), this.props.mountTo);
        }
        // Without mountTo property renders popup as is,
        // which means it will be cropped by "overflow: hidden" container.
        return this.renderPopup();
    };
    Popup.defaultProps = {
        offset: [0, 0],
    };
    return Popup;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Popup);
//# sourceMappingURL=index.js.map

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withOuterListeners;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);




// tslint:disable:next-line variable-name
function withOuterListeners(Component) {
    return /** @class */ (function (_super) {
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WithOutsideClick, _super);
        function WithOutsideClick() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.handleClick = function (evt) {
                var domNode = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](_this); // eslint-disable-line react/no-find-dom-node
                if (!domNode ||
                    (evt.target instanceof Node && !domNode.contains(evt.target))) {
                    _this.props.handleClickOutside();
                }
            };
            _this.handleKeydown = function (evt) {
                if (evt.code === 'Escape') {
                    _this.props.handleEscapeKeydown();
                }
            };
            return _this;
        }
        WithOutsideClick.prototype.componentDidMount = function () {
            if (this.props.handleClickOutside) {
                document.addEventListener('click', this.handleClick, false);
            }
            if (this.props.handleEscapeKeydown) {
                document.addEventListener('keydown', this.handleKeydown, false);
            }
        };
        WithOutsideClick.prototype.componentWillUnmount = function () {
            if (this.props.handleClickOutside) {
                document.removeEventListener('click', this.handleClick, false);
            }
            if (this.props.handleEscapeKeydown) {
                document.removeEventListener('keydown', this.handleKeydown, false);
            }
        };
        WithOutsideClick.prototype.render = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Component, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, this.props));
        };
        return WithOutsideClick;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
}
//# sourceMappingURL=with-outer-listeners.js.map

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Breakpoints; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getBreakpoint;
/* unused harmony export createWidthContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WidthProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Consumer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf_schd__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_size_detector__ = __webpack_require__(268);




var Breakpoints = {
    S: 'S',
    M: 'M',
    L: 'L',
};
var MAX_S = 1266;
var MAX_M = 2146;
function getBreakpoint(width) {
    if (width === void 0) { width = 0; }
    if (width >= MAX_S && width < MAX_M) {
        return Breakpoints.M;
    }
    else if (width >= MAX_M) {
        return Breakpoints.L;
    }
    return Breakpoints.S;
}
function createWidthContext(width) {
    if (width === void 0) { width = 0; }
    return { width: width, breakpoint: getBreakpoint(width) };
}
var _a = __WEBPACK_IMPORTED_MODULE_1_react__["createContext"](createWidthContext()), Provider = _a.Provider, Consumer = _a.Consumer;
var WidthProvider = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WidthProvider, _super);
    function WidthProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { width: 0 };
        _this.setWidth = Object(__WEBPACK_IMPORTED_MODULE_2_raf_schd__["a" /* default */])(function (width) {
            if (_this.state.width === width) {
                return;
            }
            _this.setState({ width: width });
        });
        _this.state.width = document.body.offsetWidth;
        return _this;
    }
    WidthProvider.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_size_detector__["a" /* default */], { containerStyle: {
                    height: '0',
                    borderStyle: 'none',
                } }, function (_a) {
                var width = _a.width;
                _this.setWidth(width);
                return null;
            }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Provider, { value: createWidthContext(this.state.width) }, this.props.children)));
    };
    return WidthProvider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));


//# sourceMappingURL=index.js.map

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__builders__ = __webpack_require__(2004);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__traverse__ = __webpack_require__(2039);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__traverse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validator__ = __webpack_require__(2043);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__validator__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__ = __webpack_require__(82);

var link = function (attrs) { return function (maybeNode) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__["a" /* applyMark */])({ type: 'link', attrs: attrs }, maybeNode);
}; };
//# sourceMappingURL=link.js.map

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export strong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__ = __webpack_require__(82);

var strong = function (maybeNode) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__["a" /* applyMark */])({ type: 'strong' }, maybeNode);
};
//# sourceMappingURL=strong.js.map

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export underline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__ = __webpack_require__(82);

var underline = function (maybeNode) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__["a" /* applyMark */])({ type: 'underline' }, maybeNode);
};
//# sourceMappingURL=underline.js.map

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bulletList */
var bulletList = function () {
    var content = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        content[_i] = arguments[_i];
    }
    return ({
        type: 'bulletList',
        content: content,
    });
};
//# sourceMappingURL=bullet-list.js.map

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hardBreak */
var hardBreak = function (attrs) { return ({
    type: 'hardBreak',
    attrs: attrs,
}); };
//# sourceMappingURL=hard-break.js.map

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export listItem */
var listItem = function (content) { return ({
    type: 'listItem',
    content: content,
}); };
//# sourceMappingURL=list-item.js.map

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export orderedList */
var orderedList = function (attrs) { return function () {
    var content = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        content[_i] = arguments[_i];
    }
    return ({
        type: 'orderedList',
        attrs: attrs,
        content: content,
    });
}; };
//# sourceMappingURL=ordered-list.js.map

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export paragraph */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_create_text_nodes__ = __webpack_require__(2034);

var paragraph = function () {
    var content = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        content[_i] = arguments[_i];
    }
    return ({
        type: 'paragraph',
        content: Object(__WEBPACK_IMPORTED_MODULE_0__utils_create_text_nodes__["a" /* createTextNodes */])(content),
    });
};
//# sourceMappingURL=paragraph.js.map

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rule */
var rule = function () { return ({ type: 'rule' }); };
//# sourceMappingURL=rule.js.map

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export tableCell */
var tableCell = function (attrs) { return function () {
    var content = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        content[_i] = arguments[_i];
    }
    return ({
        type: 'tableCell',
        attrs: attrs,
        content: content,
    });
}; };
//# sourceMappingURL=table-cell.js.map

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export tableHeader */
var tableHeader = function (attrs) { return function () {
    var content = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        content[_i] = arguments[_i];
    }
    return ({
        type: 'tableHeader',
        attrs: attrs,
        content: content,
    });
}; };
//# sourceMappingURL=table-header.js.map

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export tableRow */
var tableRow = function (content) { return ({
    type: 'tableRow',
    content: content,
}); };
//# sourceMappingURL=table-row.js.map

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hermentHandler */
/* unused harmony export debugHandler */
/* harmony export (immutable) */ __webpack_exports__["a"] = detectHandler;
/**
 * Provider using globally available, configured Herment instance.
 *
 * @link https://bitbucket.org/atlassian/herment/overview
 */
function hermentHandler(name, properties) {
    try {
        window.AJS.EventQueue.push({ name: name, properties: properties });
    }
    catch (e) {
        // tslint:disable-next-line:no-console
        console.warn('Unable to send analytics event via Herment - has it been initialized?', e);
    }
}
function debugHandler(name, properties) {
    // tslint:disable-next-line:no-console
    console.info('analytics event: ', name, properties ? properties : '[no properties]');
}
/**
 * Attempt to detect analytics provider.
 */
function detectHandler() {
    // Check Herment is globally available
    if (typeof window !== 'undefined' &&
        window.AJS &&
        window.AJS.EventQueue &&
        typeof window.AJS.EventQueue.push === 'function') {
        return hermentHandler;
    }
    // Unable to detect a suitable handler
    return function () { return null; };
}
//# sourceMappingURL=handler.js.map

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = __webpack_require__(2113);
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MEDIA_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILE_WIDTH; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_media_card__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__ = __webpack_require__(13);






// This is being used by DropPlaceholder now
var MEDIA_HEIGHT = 125;
var FILE_WIDTH = 156;
var MediaNode = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MediaNode, _super);
    function MediaNode(props) {
        var _this = _super.call(this, props) || this;
        _this.hasBeenMounted = false;
        _this.state = {
            viewContext: undefined,
        };
        _this.updateMediaContext = function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](_this, void 0, void 0, function () {
            var mediaProvider, viewContext;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mediaProvider];
                    case 1:
                        mediaProvider = _a.sent();
                        if (!mediaProvider) return [3 /*break*/, 3];
                        return [4 /*yield*/, mediaProvider.viewContext];
                    case 2:
                        viewContext = _a.sent();
                        if (viewContext && this.hasBeenMounted) {
                            this.setState({ viewContext: viewContext });
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.handleNewNode = function (props) {
            var node = props.node;
            // +1 indicates the media node inside the mediaSingle nodeview
            _this.pluginState.handleMediaNodeMount(node, function () { return _this.props.getPos() + 1; });
        };
        var view = _this.props.view;
        _this.pluginState = __WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["b" /* stateKey */].getState(view.state);
        _this.mediaProvider = props.mediaProvider;
        return _this;
    }
    MediaNode.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (this.props.selected !== nextProps.selected ||
            this.state.viewContext !== nextState.viewContext ||
            this.props.node.attrs.id !== nextProps.node.attrs.id ||
            this.props.node.attrs.collection !== nextProps.node.attrs.collection ||
            this.props.cardDimensions !== nextProps.cardDimensions) {
            return true;
        }
        return false;
    };
    MediaNode.prototype.componentDidMount = function () {
        this.hasBeenMounted = true;
        this.handleNewNode(this.props);
        this.updateMediaContext();
    };
    MediaNode.prototype.componentWillUnmount = function () {
        var node = this.props.node;
        this.pluginState.handleMediaNodeUnmount(node);
        this.hasBeenMounted = false;
    };
    MediaNode.prototype.componentDidUpdate = function () {
        this.pluginState.updateElement();
    };
    MediaNode.prototype.render = function () {
        var _a = this.props, node = _a.node, selected = _a.selected, cardDimensions = _a.cardDimensions, onClick = _a.onClick, editorAppearance = _a.editorAppearance;
        var _b = node.attrs, id = _b.id, type = _b.type, collection = _b.collection, url = _b.url, __key = _b.__key;
        if (!this.state.viewContext) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_media_card__["b" /* CardView */], { status: "loading", dimensions: cardDimensions });
        }
        /** For new images, the media state will be loaded inside the plugin state */
        var getState = this.pluginState.getMediaNodeState(__key);
        var fileId = getState && getState.fileId ? getState.fileId : id;
        var identifier = type === 'external'
            ? {
                dataURI: url,
                name: url,
                mediaItemType: 'external-image',
            }
            : {
                id: fileId,
                mediaItemType: 'file',
                collectionName: collection,
            };
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_media_card__["a" /* Card */], { context: this.state.viewContext, resizeMode: "stretchy-fit", dimensions: cardDimensions, identifier: identifier, selectable: true, selected: selected, disableOverlay: true, onClick: onClick, useInlinePlayer: false, isLazy: editorAppearance !== 'mobile' }));
    };
    return MediaNode;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["c"] = (Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__["_8" /* withImageLoader */])(MediaNode));
//# sourceMappingURL=media.js.map

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(752);

var defaultTheme = {
  mode: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_THEME_MODE */]
};
function getTheme(props) {
  if (props && props.theme && props.theme.__ATLASKIT_THEME__) {
    // $FlowFixMe - cannot narrow type between input types
    return props.theme.__ATLASKIT_THEME__;
  } else if (props && props.theme && props.theme.mode) {
    // $FlowFixMe - cannot narrow type between input types
    return props.theme;
  }

  return defaultTheme;
}

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FLATTENED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_THEME_MODE; });
/* unused harmony export THEME_MODES */
var FLATTENED = '__FLATTENED__';
var CHANNEL = '__ATLASKIT_THEME__';
var DEFAULT_THEME_MODE = 'light';
var THEME_MODES = ['light', 'dark'];

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DropdownMenuStatelessWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_uuid_v1__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_uuid_v1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_uuid_v1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__atlaskit_analytics_next__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__atlaskit_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__atlaskit_droplist__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__atlaskit_icon_glyph_chevron_down__ = __webpack_require__(2181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__atlaskit_icon_glyph_chevron_down___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__atlaskit_icon_glyph_chevron_down__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__package_json__ = __webpack_require__(2183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__context_DropdownItemFocusManager__ = __webpack_require__(2184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__context_DropdownItemClickManager__ = __webpack_require__(2185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__context_DropdownItemSelectionCache__ = __webpack_require__(2186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styled_WidthConstrainer__ = __webpack_require__(2188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__util_keys__ = __webpack_require__(420);










/* eslint-disable react/no-array-index-key */














var DropdownMenuStateless =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(DropdownMenuStateless, _Component);

  function DropdownMenuStateless() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, DropdownMenuStateless);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(DropdownMenuStateless)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "domItemsList", void 0);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "focusedItem", void 0);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "triggerContainer", void 0);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "sourceOfIsOpen", void 0);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "dropdownListPositioned", false);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      id: __WEBPACK_IMPORTED_MODULE_11_uuid_v1___default()(),
      autoFocusDropdownItems: false
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "componentDidMount", function () {
      if (_this.isUsingDeprecatedAPI()) {
        if (false) {
          // eslint-disable-next-line no-console
          console.log('DropdownMenu.items is deprecated. Please switch to the declarative API.');
        }

        if (_this.domItemsList) {
          _this.focusFirstItem();
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "componentDidUpdate", function (prevProp) {
      if (_this.isUsingDeprecatedAPI() && _this.props.isOpen && !prevProp.isOpen) {
        _this.focusFirstItem();
      }
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getNextFocusable", function (indexItem, available) {
      if (!_this.domItemsList) {
        return null;
      }

      var currentItem = typeof indexItem !== 'number' ? -1 : indexItem;
      var latestAvailable = typeof available !== 'number' ? currentItem : available;

      if (currentItem < _this.domItemsList.length - 1) {
        currentItem++;

        if (_this.domItemsList[currentItem].getAttribute('aria-hidden') !== 'true') {
          return currentItem;
        }

        return _this.getNextFocusable(currentItem, latestAvailable);
      }

      return latestAvailable;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getPrevFocusable", function (indexItem, available) {
      if (!_this.domItemsList) {
        return null;
      }

      var currentItem = typeof indexItem !== 'number' ? -1 : indexItem;
      var latestAvailable = typeof available !== 'number' ? currentItem : available;

      if (currentItem && currentItem > 0) {
        currentItem--;

        if (_this.domItemsList[currentItem].getAttribute('aria-hidden') !== 'true') {
          return currentItem;
        }

        return _this.getPrevFocusable(currentItem, latestAvailable);
      }

      return latestAvailable || currentItem;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "focusFirstItem", function () {
      if (_this.sourceOfIsOpen === 'keydown') {
        _this.focusItem(_this.getNextFocusable());
      }
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "focusNextItem", function () {
      _this.focusItem(_this.getNextFocusable(_this.focusedItem));
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "focusPreviousItem", function () {
      _this.focusItem(_this.getPrevFocusable(_this.focusedItem));
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "focusItem", function (index) {
      if (!_this.domItemsList || !index) {
        return;
      }

      _this.focusedItem = index;

      _this.domItemsList[_this.focusedItem].focus();
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "isTargetChildItem", function (target) {
      if (!target) return false;
      var isDroplistItem = target.getAttribute('data-role') === 'droplistItem'; // eslint-disable-next-line react/no-find-dom-node

      var thisDom = Object(__WEBPACK_IMPORTED_MODULE_10_react_dom__["findDOMNode"])(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
      return isDroplistItem && thisDom ? thisDom.contains(target) : false;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleKeyboardInteractionForClosed", function (event) {
      if (_this.props.isOpen) {
        return;
      }

      switch (event.key) {
        case __WEBPACK_IMPORTED_MODULE_21__util_keys__["a" /* KEY_DOWN */]:
        case __WEBPACK_IMPORTED_MODULE_21__util_keys__["c" /* KEY_SPACE */]:
        case __WEBPACK_IMPORTED_MODULE_21__util_keys__["b" /* KEY_ENTER */]:
          event.preventDefault();

          _this.open({
            event: event,
            source: 'keydown'
          });

          break;

        default:
          break;
      }
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleKeyboardInteractionsDeprecated", function (event) {
      // KeyboardEvent.target is typed as an EventTarget but we need to access methods on it which
      // are specific to Element. Due limitations of the HTML spec flow doesn't know that an
      // EventTarget can have these methods, so we cast it to Element through Object. This is the
      // safest thing we can do in this situation.
      var target = event.target;

      if (_this.props.isOpen) {
        if (_this.isTargetChildItem(target)) {
          switch (event.key) {
            case 'ArrowUp':
              event.preventDefault();

              _this.focusPreviousItem();

              break;

            case 'ArrowDown':
              event.preventDefault();

              _this.focusNextItem();

              break;

            case 'Tab':
              event.preventDefault();

              _this.close({
                event: event
              });

              break;

            default:
              break;
          }
        } else if (event.key === 'ArrowDown') {
          _this.sourceOfIsOpen = 'keydown';

          _this.focusFirstItem();
        } else if (event.key === 'Tab') {
          _this.close({
            event: event
          });
        }
      } else {
        switch (event.key) {
          case __WEBPACK_IMPORTED_MODULE_21__util_keys__["a" /* KEY_DOWN */]:
          case __WEBPACK_IMPORTED_MODULE_21__util_keys__["c" /* KEY_SPACE */]:
          case __WEBPACK_IMPORTED_MODULE_21__util_keys__["b" /* KEY_ENTER */]:
            event.preventDefault();

            _this.open({
              event: event,
              source: 'keydown'
            });

            break;

          default:
            break;
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "domMenuContainer", void 0);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleClickDeprecated", function (event) {
      var menuContainer = _this.domMenuContainer; // Casting target to Element. See comment in `handleKeyboardInteractionsDeprecated`.

      var target = event.target;

      if (!menuContainer || menuContainer && !menuContainer.contains(target)) {
        _this.toggle({
          source: 'click',
          event: event
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "isUsingDeprecatedAPI", function () {
      return Boolean(_this.props.items.length);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleClick", function (event) {
      // For any clicks we don't want autofocus
      _this.setState({
        autoFocusDropdownItems: false
      });

      if (_this.isUsingDeprecatedAPI()) {
        _this.handleClickDeprecated(event);

        return;
      }

      var _assertThisInitialize = __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)),
          triggerContainer = _assertThisInitialize.triggerContainer; // Casting target to Element. See comment in `handleKeyboardInteractionsDeprecated`.


      var target = event.target;

      if (triggerContainer && triggerContainer.contains(target) && // $FlowFixMe - disabled is not in Element
      target.disabled !== true) {
        var isOpen = _this.props.isOpen;
        _this.sourceOfIsOpen = 'mouse';

        _this.props.onOpenChange({
          isOpen: !isOpen,
          event: event
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "triggerContent", function () {
      var _this$props = _this.props,
          children = _this$props.children,
          trigger = _this$props.trigger,
          isOpen = _this$props.isOpen,
          triggerButtonProps = _this$props.triggerButtonProps,
          triggerType = _this$props.triggerType;
      var insideTriggerContent = _this.isUsingDeprecatedAPI() ? children : trigger;

      if (triggerType !== 'button') {
        return insideTriggerContent;
      }

      var triggerProps = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, triggerButtonProps);

      var defaultButtonProps = {
        ariaControls: _this.state.id,
        ariaExpanded: isOpen,
        ariaHaspopup: true,
        isSelected: isOpen
      };

      if (!triggerProps.iconAfter && !triggerProps.iconBefore) {
        triggerProps.iconAfter = __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__atlaskit_icon_glyph_chevron_down___default.a, {
          size: "medium",
          label: ""
        });
      }

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__atlaskit_button__["default"], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, defaultButtonProps, triggerProps), insideTriggerContent);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "open", function (attrs) {
      _this.sourceOfIsOpen = attrs.source;

      _this.props.onOpenChange({
        isOpen: true,
        event: attrs.event
      }); // Dropdown opened via keyboard gets auto focussed


      _this.setState({
        autoFocusDropdownItems: _this.sourceOfIsOpen === 'keydown'
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "close", function (attrs) {
      _this.sourceOfIsOpen = null;

      _this.props.onOpenChange({
        isOpen: false,
        event: attrs.event
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "toggle", function (attrs) {
      if (attrs.source === 'keydown') return;

      if (_this.props.isOpen) {
        _this.close(attrs);
      } else {
        _this.open(attrs);
      }
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleItemClicked", function (event) {
      _this.props.onOpenChange({
        isOpen: false,
        event: event
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "renderTrigger", function () {
      var triggerContent = _this.triggerContent();

      return _this.isUsingDeprecatedAPI() ? triggerContent : __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", {
        ref: function ref(_ref) {
          _this.triggerContainer = _ref;
        }
      }, triggerContent);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "renderItems", function (items) {
      return items.map(function (item, itemIndex) {
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__atlaskit_droplist__["b" /* Item */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, item, {
          key: itemIndex,
          onActivate: function onActivate(_ref2) {
            var event = _ref2.event;

            _this.props.onItemActivated({
              item: item,
              event: event
            });
          }
        }), item.content);
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "renderGroups", function (groups) {
      return groups.map(function (group, groupIndex) {
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__atlaskit_droplist__["a" /* Group */], {
          heading: group.heading,
          elemAfter: group.elemAfter,
          key: groupIndex
        }, _this.renderItems(group.items));
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "renderDeprecated", function () {
      var _this$props2 = _this.props,
          items = _this$props2.items,
          shouldFitContainer = _this$props2.shouldFitContainer;
      var id = _this.state.id;
      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", {
        id: id,
        ref: function ref(_ref3) {
          _this.domMenuContainer = _ref3;
          _this.domItemsList = _ref3 ? _ref3.querySelectorAll('[data-role="droplistItem"]') : null;
        },
        role: "menu",
        style: shouldFitContainer ? null : {
          maxWidth: 300
        }
      }, _this.renderGroups(items));
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onDroplistPositioned", function () {
      _this.dropdownListPositioned = true; // Trigger render so item focus manager can auto focus for keyboard trigger

      _this.setState({
        autoFocusDropdownItems: _this.sourceOfIsOpen === 'keydown'
      });

      if (_this.props.onPositioned) _this.props.onPositioned();
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "renderDropdownItems", function () {
      if (_this.sourceOfIsOpen === 'keydown' && _this.dropdownListPositioned) {
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__context_DropdownItemFocusManager__["a" /* default */], {
          autoFocus: _this.state.autoFocusDropdownItems,
          close: _this.close
        }, _this.props.children);
      }

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react__["Fragment"], null, _this.props.children);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(DropdownMenuStateless, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          appearance = _this$props3.appearance,
          boundariesElement = _this$props3.boundariesElement,
          isLoading = _this$props3.isLoading,
          isOpen = _this$props3.isOpen,
          onOpenChange = _this$props3.onOpenChange,
          position = _this$props3.position,
          isMenuFixed = _this$props3.isMenuFixed,
          shouldAllowMultilineItems = _this$props3.shouldAllowMultilineItems,
          shouldFitContainer = _this$props3.shouldFitContainer,
          shouldFlip = _this$props3.shouldFlip;
      var id = this.state.id;
      var isDeprecated = this.isUsingDeprecatedAPI();
      var deprecatedProps = isDeprecated ? {
        onKeyDown: this.handleKeyboardInteractionsDeprecated,
        shouldAllowMultilineItems: shouldAllowMultilineItems
      } : {
        onKeyDown: this.handleKeyboardInteractionForClosed
      };
      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__context_DropdownItemSelectionCache__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__atlaskit_droplist__["c" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        appearance: appearance,
        boundariesElement: boundariesElement,
        isLoading: isLoading,
        isOpen: isOpen,
        onClick: this.handleClick,
        onOpenChange: onOpenChange,
        position: position,
        isMenuFixed: isMenuFixed,
        shouldFitContainer: shouldFitContainer,
        shouldFlip: shouldFlip,
        trigger: this.renderTrigger(),
        onPositioned: this.onDroplistPositioned
      }, deprecatedProps, {
        analyticsContext: {
          componentName: 'dropdownMenu',
          packageName: __WEBPACK_IMPORTED_MODULE_16__package_json__["name"],
          packageVersion: __WEBPACK_IMPORTED_MODULE_16__package_json__["version"]
        }
      }), isDeprecated ? this.renderDeprecated() : __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styled_WidthConstrainer__["a" /* default */], {
        id: id,
        role: "menu",
        shouldFitContainer: shouldFitContainer
      }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__context_DropdownItemClickManager__["a" /* default */], {
        onItemClicked: this.handleItemClicked
      }, this.renderDropdownItems()))));
    }
  }]);

  return DropdownMenuStateless;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(DropdownMenuStateless, "defaultProps", {
  appearance: 'default',
  boundariesElement: 'viewport',
  isLoading: false,
  isOpen: false,
  items: [],
  onItemActivated: function onItemActivated() {},
  onOpenChange: function onOpenChange() {},
  position: 'bottom left',
  isMenuFixed: false,
  shouldAllowMultilineItems: false,
  shouldFitContainer: false,
  shouldFlip: true,
  triggerType: 'default',
  onPositioned: function onPositioned() {}
});


var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_12__atlaskit_analytics_next__["createAndFireEvent"])('atlaskit');
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__atlaskit_analytics_next__["withAnalyticsEvents"])({
  onOpenChange: createAndFireEventOnAtlaskit({
    action: 'toggled',
    actionSubject: 'dropdownMenu',
    attributes: {
      componentName: 'dropdownMenu',
      packageName: __WEBPACK_IMPORTED_MODULE_16__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_16__package_json__["version"]
    }
  })
})(DropdownMenuStateless));

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/droplist","version":"7.0.17","sideEffects":false}

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// from https://facebook.github.io/react/docs/higher-order-components.html
var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

/* harmony default export */ __webpack_exports__["a"] = (getDisplayName);

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// There are cases where the context is not available, such as when a dropdown item is used
// inside @atlaskit/navigation. For this reason we have this helper function which safely calls
// the context functions if they are available.
/* harmony default export */ __webpack_exports__["a"] = (function (instance, contextKey) {
  return function (fnToCall) {
    var _instance$context$con;

    if (!instance.context[contextKey]) {
      return null;
    }

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return (_instance$context$con = instance.context[contextKey])[fnToCall].apply(_instance$context$con, args);
  };
});

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return focusManagerContext; });
/* unused harmony export selectionCacheContext */
/* unused harmony export selectionManagerContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clickManagerContext; });
var prefix = function prefix(key) {
  return "@atlaskit-private-do-not-use/dropdown-menu:".concat(key);
};

var focusManagerContext = prefix('focus-manager');
var selectionCacheContext = prefix('selection-cache');
var selectionManagerContext = prefix('selection-manager');
var clickManagerContext = prefix('click-manager');

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(54);

var _interopRequireDefault = __webpack_require__(53);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.size = exports.default = exports.IconWrapper = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(4));

var _createClass2 = _interopRequireDefault(__webpack_require__(5));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(7));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(6));

var _inherits2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _styledComponents = _interopRequireDefault(__webpack_require__(2));

var _uuid = _interopRequireDefault(__webpack_require__(22));

var _theme = __webpack_require__(3);

var _constants = __webpack_require__(2175);

var getSize = function getSize(props) {
  if (props.size) {
    return "height: ".concat(_constants.sizes[props.size], "; width: ").concat(_constants.sizes[props.size], ";");
  }

  return null;
};

var IconWrapper = _styledComponents.default.span.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "dyhwwi-0"
})(["\n  ", " color: ", ";\n  display: inline-block;\n  fill: ", ";\n  flex-shrink: 0;\n  line-height: 1;\n\n  > svg {\n    ", " max-height: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    pointer-events: none;\n    vertical-align: bottom;\n  }\n  /* Stop-color doesn't properly apply in chrome when the inherited/current color changes.\n   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS\n   * rule) and then override it with currentColor for the color changes to be picked up.\n   */\n  stop {\n    stop-color: currentColor;\n  }\n"], getSize, function (p) {
  return p.primaryColor || 'currentColor';
}, function (p) {
  return p.secondaryColor || _theme.colors.background;
}, getSize);

exports.IconWrapper = IconWrapper;

var Icon =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Icon, _Component);

  function Icon() {
    (0, _classCallCheck2.default)(this, Icon);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Icon).apply(this, arguments));
  }

  (0, _createClass2.default)(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Glyph = _this$props.glyph,
          dangerouslySetGlyph = _this$props.dangerouslySetGlyph,
          onClick = _this$props.onClick,
          primaryColor = _this$props.primaryColor,
          secondaryColor = _this$props.secondaryColor,
          size = _this$props.size; // handling the glyphs as strings

      if (dangerouslySetGlyph) {
        return _react.default.createElement(IconWrapper, {
          onClick: onClick,
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          size: size,
          "aria-label": this.props.label,
          dangerouslySetInnerHTML: {
            __html: Icon.insertDynamicGradientID(dangerouslySetGlyph)
          }
        });
      } // handling the glyphs when passed through as functions


      return _react.default.createElement(IconWrapper, {
        onClick: onClick,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        "aria-label": this.props.label
      }, Glyph ? _react.default.createElement(Glyph, {
        role: "presentation"
      }) : null);
    }
  }], [{
    key: "insertDynamicGradientID",

    /* Icons need unique gradient IDs across instances for different gradient definitions to work
     * correctly.
     * A step in the icon build process replaces linear gradient IDs and their references in paths
     * to a placeholder string so we can replace them with a dynamic ID here.
     * Replacing the original IDs with placeholders in the build process is more robust than not
     * using placeholders as we do not have to rely on regular expressions to find specific element
     * to replace.
     */
    value: function insertDynamicGradientID(svgStr) {
      var id = (0, _uuid.default)();
      var replacedSvgStr = svgStr.replace(/id="([^"]+)-idPlaceholder"/g, "id=$1-".concat(id)).replace(/fill="url\(#([^"]+)-idPlaceholder\)"/g, "fill=\"url(#$1-".concat(id, ")\""));
      return replacedSvgStr;
    }
  }]);
  return Icon;
}(_react.Component);

exports.default = Icon;
(0, _defineProperty2.default)(Icon, "defaultProps", {
  onClick: function onClick() {}
});
var size = Object.keys(_constants.sizes).reduce(function (p, c) {
  return Object.assign(p, (0, _defineProperty2.default)({}, c, c));
}, {});
exports.size = size;

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_getDisplayName__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_safeContextCall__ = __webpack_require__(2192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_contextNamespace__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_keys__ = __webpack_require__(420);

















// HOC that typically wraps @atlaskit/item
var withToggleInteraction = function withToggleInteraction(WrappedComponent, SelectionIcon, getAriaRole) {
  var WithToggleInteraction =
  /*#__PURE__*/
  function (_Component) {
    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(WithToggleInteraction, _Component);

    function WithToggleInteraction() {
      var _getPrototypeOf2;

      var _this;

      __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, WithToggleInteraction);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(WithToggleInteraction)).call.apply(_getPrototypeOf2, [this].concat(args)));

      __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getIconColors", function () {
        var isSelected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (isSelected) {
          return {
            primary: __WEBPACK_IMPORTED_MODULE_10__atlaskit_theme__["colors"].B400,
            secondary: __WEBPACK_IMPORTED_MODULE_10__atlaskit_theme__["colors"].N40
          };
        }

        return {
          primary: __WEBPACK_IMPORTED_MODULE_10__atlaskit_theme__["colors"].N40,
          secondary: __WEBPACK_IMPORTED_MODULE_10__atlaskit_theme__["colors"].N40
        };
      });

      __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "warnIfUseControlledAndUncontrolledState", function () {
        if (false) {
          if (_this.props.defaultSelected && _this.props.isSelected) {
            // eslint-disable-next-line no-console
            console.warn('DropdownItem defaultSelected and isSelected props should not be used at the same time.');
          }
        }
      });

      __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "callContextFn", Object(__WEBPACK_IMPORTED_MODULE_13__util_safeContextCall__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), __WEBPACK_IMPORTED_MODULE_14__util_contextNamespace__["d" /* selectionManagerContext */]));

      __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleKeyboard", function (event) {
        var key = event.key;

        if (key === __WEBPACK_IMPORTED_MODULE_15__util_keys__["b" /* KEY_ENTER */] || key === __WEBPACK_IMPORTED_MODULE_15__util_keys__["c" /* KEY_SPACE */]) {
          // We prevent default here to avoid page scroll
          event.preventDefault();

          _this.handleItemActivated(event);
        }
      });

      __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleItemActivated", function (event) {
        if (_this.props.onClick) {
          _this.props.onClick(event);
        }

        _this.callContextFn('itemClicked', _this.props.id);
      });

      __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "isSelectedInDropdown", function () {
        return _this.callContextFn('isItemSelected', _this.props.id);
      });

      return _this;
    }

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(WithToggleInteraction, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this$props = this.props,
            defaultSelected = _this$props.defaultSelected,
            isSelected = _this$props.isSelected,
            id = _this$props.id;
        this.warnIfUseControlledAndUncontrolledState();
        this.callContextFn('setItemSelected', id, isSelected, defaultSelected);
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        var id = nextProps.id,
            defaultSelected = nextProps.defaultSelected,
            isSelected = nextProps.isSelected;

        if (this.props.isSelected !== isSelected) {
          this.callContextFn('setItemSelected', id, isSelected, defaultSelected);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            children = _this$props2.children,
            otherProps = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_this$props2, ["children"]);

        var isSelected = this.isSelectedInDropdown();
        var iconColors = this.getIconColors(isSelected);
        var ariaRole = getAriaRole();
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(WrappedComponent, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, otherProps, {
          role: ariaRole,
          "aria-checked": isSelected,
          isSelected: isSelected,
          onClick: this.handleItemActivated,
          onKeyDown: this.handleKeyboard,
          elemBefore: __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(SelectionIcon, {
            primaryColor: iconColors.primary,
            secondaryColor: iconColors.secondary,
            size: "medium",
            label: ""
          })
        }), children);
      }
    }]);

    return WithToggleInteraction;
  }(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

  __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(WithToggleInteraction, "defaultProps", {
    onClick: function onClick() {}
  });

  __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(WithToggleInteraction, "contextTypes", __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_14__util_contextNamespace__["d" /* selectionManagerContext */], __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.object.isRequired));

  WithToggleInteraction.displayName = "WithToggleInteraction(".concat(Object(__WEBPACK_IMPORTED_MODULE_12__util_getDisplayName__["a" /* default */])(WrappedComponent), ")");
  return WithToggleInteraction;
};

/* harmony default export */ __webpack_exports__["a"] = (withToggleInteraction);

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// from https://facebook.github.io/react/docs/higher-order-components.html
var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

/* harmony default export */ __webpack_exports__["a"] = (getDisplayName);

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var canUseDOM = function canUseDOM() {
  return Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
};

var supportsVoiceOver = function supportsVoiceOver() {
  return /Mac OS X/.test(canUseDOM() ? navigator.userAgent : '');
};

/* harmony default export */ __webpack_exports__["a"] = (supportsVoiceOver);

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_getDisplayName__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__context_DropdownItemSelectionManager__ = __webpack_require__(2196);











// HOC that typically wraps @atlaskit/item/ItemGroup
var withDropdownItemSelectionManager = function withDropdownItemSelectionManager(WrappedComponent, selectionBehavior) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(WithDropdownItemSelectionManager, _Component);

    function WithDropdownItemSelectionManager() {
      __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, WithDropdownItemSelectionManager);

      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(WithDropdownItemSelectionManager).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(WithDropdownItemSelectionManager, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            children = _this$props.children,
            id = _this$props.id,
            otherProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(_this$props, ["children", "id"]);

        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(WrappedComponent, otherProps, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__context_DropdownItemSelectionManager__["a" /* default */], {
          groupId: id,
          behavior: selectionBehavior
        }, children));
      }
    }]);

    return WithDropdownItemSelectionManager;
  }(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]), __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_class, "displayName", "WithDropdownItemSelectionManager(".concat(Object(__WEBPACK_IMPORTED_MODULE_8__util_getDisplayName__["a" /* default */])(WrappedComponent), ")")), _temp;
};

/* harmony default export */ __webpack_exports__["a"] = (withDropdownItemSelectionManager);

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Grid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Stack; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getBackgroundColor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_avatar__ = __webpack_require__(48);


 // TODO: use math utilities within styled component

var gutterUnitless = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])() / 2;
var gutter = "".concat(gutterUnitless, "px");
var Grid = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "AvatarGroup__Grid",
  componentId: "sc-19dfd4t-0"
})(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  line-height: 1;\n  margin-left: -", ";\n  margin-right: -", ";\n\n  > * {\n    margin-bottom: ", ";\n    padding-left: ", ";\n    padding-right: ", ";\n  }\n"], gutter, gutter, __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"], gutter, gutter);
var Stack = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "AvatarGroup__Stack",
  componentId: "sc-19dfd4t-1"
})(["\n  display: flex;\n  line-height: 1;\n  /* Balance the negative margin of the children */\n  margin-right: ", "px;\n\n  > * {\n    margin-right: -", "px;\n  }\n"], function (props) {
  return __WEBPACK_IMPORTED_MODULE_2__atlaskit_avatar__["b" /* BORDER_WIDTH */][props.size] * 2 + gutterUnitless;
}, function (props) {
  return __WEBPACK_IMPORTED_MODULE_2__atlaskit_avatar__["b" /* BORDER_WIDTH */][props.size] * 2 + gutterUnitless;
});
function getBackgroundColor(_ref) {
  var isActive = _ref.isActive,
      isHover = _ref.isHover;
  var themedBackgroundColor = __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].backgroundOnLayer;

  if (isHover) {
    themedBackgroundColor = __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].backgroundHover;
  }

  if (isActive) {
    themedBackgroundColor = __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].backgroundActive;
  }

  return themedBackgroundColor;
}

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function loading(image) {
  return {
    image: image,
    isLoaded: false,
    isErrored: false
  };
}

function loaded() {
  return {
    isLoaded: true
  };
}

function errored() {
  return {
    isErrored: true
  };
}

function hasPropsChanged(prevProps, nextProps) {
  var prevSrc = prevProps.src;
  var nextSrc = nextProps.src;

  return prevSrc !== nextSrc;
}

var ImageRenderer = function (_React$Component) {
  _inherits(ImageRenderer, _React$Component);

  function ImageRenderer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ImageRenderer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isLoaded: false,
      isErrored: false
    }, _this.handleLoad = function () {
      var onLoad = _this.props.onLoad;

      _this.unload();
      _this.setState(loaded(), function () {
        if (onLoad) {
          onLoad();
        }
      });
    }, _this.handleError = function () {
      var onError = _this.props.onError;

      _this.unload();
      _this.setState(errored(), function () {
        if (onError) {
          onError();
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ImageRenderer, [{
    key: 'load',
    value: function load() {
      var src = this.props.src;
      var image = this.state.image;


      if (image) {
        image.onload = this.handleLoad;
        image.onerror = this.handleError;
        image.src = src;
      }
    }
  }, {
    key: 'unload',
    value: function unload() {
      var image = this.state.image;

      if (image) {
        image.onload = undefined;
        image.onerror = undefined;
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window === 'undefined') {
        return;
      }
      this.setState(loading(new Image()));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.load();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (hasPropsChanged(this.props, nextProps)) {
        this.setState(loading(new Image()));
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (hasPropsChanged(prevProps, this.props)) {
        this.unload();
        this.load();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unload();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          loading = _props.loading,
          loaded = _props.loaded,
          errored = _props.errored,
          children = _props.children;
      var _state = this.state,
          image = _state.image,
          isLoaded = _state.isLoaded,
          isErrored = _state.isErrored;


      if (isLoaded && loaded) {
        return loaded;
      }

      if (isErrored && errored) {
        return errored;
      }

      if (!isLoaded && !isErrored && loading) {
        return loading;
      }

      if (children) {
        return children({
          image: isLoaded ? image : undefined,
          loaded: isLoaded,
          errored: isErrored
        });
      }

      return null;
    }
  }]);

  return ImageRenderer;
}(React.Component);

exports.default = ImageRenderer;

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ellipsify; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_exenv__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_exenv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_exenv__);

/* tslint:disable:variable-name */



var Wrapper = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
    var inline = _a.inline;
    return (inline && 'display: inline;') || '';
});
Wrapper.displayName = 'Ellipsify';
var Ellipsify = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Wrapper, { className: "ellipsed-text", innerRef: setEllipsis(props), "aria-label": props.text, inline: props.inline }, props.text));
};
var setEllipsis = function (props) { return function (element) {
    if (!element) {
        return;
    }
    var maximumLines = props.lines;
    var height = element.getBoundingClientRect().height;
    var text = element.textContent;
    element.textContent = 'a';
    var lineHeight = element.getBoundingClientRect().height;
    var lineCount = height / lineHeight;
    var maximumHeight = lineHeight * maximumLines;
    if (lineCount <= maximumLines) {
        element.textContent = text;
        return;
    }
    var textContent = text;
    var endLength = typeof props.endLength === 'number' && props.endLength >= 0
        ? props.endLength
        : 8;
    var beginningText = text.substr(0, (text.length * maximumLines) / lineCount - endLength);
    var endText = text.substr(text.length - endLength, endLength);
    element.textContent = textContent = beginningText + "..." + endText;
    var finalHeight = element.getBoundingClientRect().height;
    if (finalHeight > maximumHeight) {
        var adjustedBeginningText = beginningText.substr(0, beginningText.length - (beginningText.length / maximumLines) * 0.25);
        textContent = adjustedBeginningText + "..." + endText;
    }
    delayRun(function () { return (element.textContent = textContent); });
}; };
var timeout = function (fn) { return setTimeout(fn, 1); };
var delayRun = __WEBPACK_IMPORTED_MODULE_3_exenv__["canUseDOM"] && window.requestAnimationFrame
    ? window.requestAnimationFrame
    : timeout;
/* unused harmony default export */ var _unused_webpack_default_export = (Ellipsify);
var templateObject_1;
//# sourceMappingURL=ellipsify.js.map

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Container; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);

var Container = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "Container",
  componentId: "d38mat-0"
})(["\n  ", ";\n  border-radius: 2em;\n  display: inline-block;\n  font-size: 12px;\n  font-weight: normal;\n  line-height: 1;\n  min-width: 1px;\n  padding: 0.16666666666667em 0.5em;\n  text-align: center;\n"], function (props) {
  return "\n    background-color: ".concat(props.backgroundColor, ";\n    color: ").concat(props.textColor, ";\n  ");
});
Container.displayName = 'Ak.Badge.Container';

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Format; });
var Format = function Format(props) {
  var formatted = '';
  var _props$children = props.children,
      children = _props$children === void 0 ? 0 : _props$children,
      _props$max = props.max,
      max = _props$max === void 0 ? 0 : _props$max;

  if (children < 0) {
    children = 0;
  }

  if (max < 0) {
    max = 0;
  }

  if (max && max < children) {
    formatted = "".concat(max, "+");
  } else if (children === Infinity) {
    formatted = '∞';
  } else {
    formatted = children;
  }

  return "".concat(formatted);
};
Format.displayName = 'Ak.Badge.Format';

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export backgroundColors */
/* unused harmony export textColors */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Theme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



var backgroundColors = {
  added: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].G50,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].G50
  },
  default: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N40,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN70
  },
  important: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R400,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R400
  },
  primary: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B400,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B100
  },

  /* Note that primary inverted is a temporary implementation. Once navigation has
  context of the nav location to pass down, this will be moved to the primary when
  viewed in a global context. */
  primaryInverted: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N0,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN400
  },
  removed: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R50,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R50
  }
};
var textColors = {
  added: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].G500,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].G500
  },
  default: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N800,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN900
  },
  important: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N0,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N0
  },
  primary: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N0,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN0
  },
  primaryInverted: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B500,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN0
  },
  removed: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R500,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R500
  }
};
var Theme = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["createTheme"])(function (_ref) {
  var appearance = _ref.appearance,
      mode = _ref.mode;

  if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(appearance) === 'object') {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({
      backgroundColor: backgroundColors.default.light,
      textColor: textColors.default.light
    }, appearance);
  }

  return {
    backgroundColor: backgroundColors[appearance][mode],
    textColor: textColors[appearance][mode]
  };
});

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(91));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var LockFilledIcon = function LockFilledIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2zm2 0h4V8.002A2.001 2.001 0 0 0 12 6c-1.102 0-2 .898-2 2.002V10zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4z\"/></svg>"
  }, props));
};

LockFilledIcon.displayName = 'LockFilledIcon';
var _default = LockFilledIcon;
exports.default = _default;

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var Icon = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].img(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: inline-block;\n  overflow: hidden;\n  width: 16px;\n  height: 16px;\n  vertical-align: text-bottom;\n  margin-right: 2px;\n"], ["\n  display: inline-block;\n  overflow: hidden;\n  width: 16px;\n  height: 16px;\n  vertical-align: text-bottom;\n  margin-right: 2px;\n"])));
var templateObject_1;
//# sourceMappingURL=Icon.js.map

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return messages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(17);

var messages = Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["defineMessages"])({
    retry: {
        id: 'fabric.media.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again',
    },
    failed_to_load: {
        id: 'fabric.media.failed_to_load',
        defaultMessage: 'Failed to load',
        description: 'We show this message when we have an error loading a file',
    },
    recent_uploads: {
        id: 'fabric.media.recent_uploads',
        defaultMessage: 'Recent uploads',
        description: 'Title of a section where we show the user recent uploaded files',
    },
    upload_file: {
        id: 'fabric.media.upload_file',
        defaultMessage: 'Upload a file',
        description: 'Call to action that initiates the upload of a file',
    },
    drag_and_drop_your_files: {
        id: 'fabric.media.drag_and_drop_your_files',
        defaultMessage: 'Drag and drop your files anywhere or',
        description: 'Used to describe the area where the user can drag and drop files to upload',
    },
    drop_your_files: {
        id: 'fabric.media.drop_your_files',
        defaultMessage: 'Drop your files to upload',
        description: 'Indicates that the files will be uploaded when the user drops them in the drag and drop area',
    },
    upload: {
        id: 'fabric.media.upload',
        defaultMessage: 'Upload',
        description: 'upload',
    },
    cancel: {
        id: 'fabric.media.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel',
    },
    search_all_gifs: {
        id: 'fabric.media.search_all_gifs',
        defaultMessage: 'Search all the GIFs!',
        description: 'Used as input placeholder to let the user know that he can search for GIF image files',
    },
    cant_retrieve_gifs: {
        id: 'fabric.media.cant_retrieve_gifs',
        defaultMessage: 'Ouch! We could not retrieve any GIFs',
        description: 'Error message when we can not find any GIF images for that text',
    },
    check_your_network: {
        id: 'fabric.media.check_your_network',
        defaultMessage: 'Check your network connection',
        description: 'Error message when network does not work',
    },
    try_again: {
        id: 'fabric.media.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again',
    },
    no_gifs_found: {
        id: 'fabric.media.no_gifs_found',
        defaultMessage: "Hello? Was it me you're looking for?",
        description: 'Not expected error that happens when searching for GIF images',
    },
    no_gifs_found_suggestion: {
        id: 'fabric.media.no_gifs_found_suggestion',
        defaultMessage: 'We couldn\'t find anything for "{query}"',
        description: 'There are no results for GIFs matching that query',
    },
    load_more_gifs: {
        id: 'fabric.media.load_more_gifs',
        defaultMessage: 'Load more GIFs',
        description: 'Used to load next page of GIF images',
    },
    add_account: {
        id: 'fabric.media.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account',
    },
    unlink_account: {
        id: 'fabric.media.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user',
    },
    upload_file_from: {
        id: 'fabric.media.upload_file_from',
        defaultMessage: 'Upload a file from {name}',
        description: 'Allows to upload a file from different sources',
    },
    connect_to: {
        id: 'fabric.media.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services',
    },
    connect_account_description: {
        id: 'fabric.media.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account',
    },
    upload_an_avatar: {
        id: 'fabric.media.upload_an_avatar',
        defaultMessage: 'Upload an avatar',
        description: 'Indicates that the user can upload a new avatar',
    },
    save: {
        id: 'fabric.media.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word',
    },
    or: {
        id: 'fabric.media.or',
        defaultMessage: 'or',
        description: 'Just the "or" word',
    },
    upload_photo: {
        id: 'fabric.media.upload_photo',
        defaultMessage: 'Upload a photo',
        description: 'Call to action for the user to upload a new photo',
    },
    default_avatars: {
        id: 'fabric.media.default_avatars',
        defaultMessage: 'Default avatars',
        description: 'Showed above the default avatar list',
    },
    drag_and_drop_images_here: {
        id: 'fabric.media.drag_and_drop_images_here',
        defaultMessage: 'Drag and drop your images here',
        description: 'Indicates that the user can drag and drop images in that area',
    },
    upload_image: {
        id: 'fabric.media.upload_image',
        defaultMessage: 'Upload image',
        description: 'Call to action for the user to upload a new image',
    },
    image_url_invalid_error: {
        id: 'fabric.media.image_url_invalid_error',
        defaultMessage: 'Could not load image, the url is invalid.',
        description: 'There was an error parsing the image url',
    },
    image_format_invalid_error: {
        id: 'fabric.media.image_format_invalid_error',
        defaultMessage: 'Could not load image, the format is invalid.',
        description: 'The provided image format is not valid',
    },
    image_size_too_large_error: {
        id: 'fabric.media.image_size_too_large_error',
        defaultMessage: 'Image is too large, must be no larger than {MAX_SIZE_MB}Mb',
        description: 'The provided image size is too big',
    },
    something_went_wrong: {
        id: 'fabric.media.something_went_wrong',
        defaultMessage: 'Something went wrong.',
        description: 'Showed when an error happen but we dont have more info about it',
    },
    might_be_a_hiccup: {
        id: 'fabric.media.might_be_a_hiccup',
        defaultMessage: 'It might just be a hiccup.',
        description: 'Used when an unknow error happens, just in a funny way of saying that we dont have more info about it',
    },
    couldnt_generate_preview: {
        id: 'fabric.media.couldnt_generate_preview',
        defaultMessage: "We couldn't generate a preview for this file.",
        description: 'Error case for when the backend cant generate a preview for that file',
    },
    cant_preview_file_type: {
        id: 'fabric.media.cant_preview_file_type',
        defaultMessage: "We can't preview this file type.",
        description: 'Error case for when we have no available preview for that file',
    },
    item_not_found_in_list: {
        id: 'fabric.media.item_not_found_in_list',
        defaultMessage: 'The selected item was not found on the list.',
        description: 'Error case for when a provided item is not found within the list of items',
    },
    no_pdf_artifacts: {
        id: 'fabric.media.no_pdf_artifacts',
        defaultMessage: 'No PDF artifacts found for this file.',
        description: 'Error case for when we cant preview a PDF file',
    },
    give_feedback: {
        id: 'fabric.media.give_feedback',
        defaultMessage: 'Give feedback',
        description: 'Call to action that opens a popup to get feedback from the users',
    },
    try_downloading_file: {
        id: 'fabric.media.try_downloading_file',
        defaultMessage: 'Try downloading the file to view it.',
        description: 'We show this message to allow users to download a file',
    },
    webgl_warning_description: {
        id: 'fabric.media.webgl_warning_description',
        defaultMessage: 'Your browser does not support WebGL. Use a WebGL enabled browser to annotate images.',
        description: 'We show this error message when the browser doesnt support this feature',
    },
    unable_to_annotate_image: {
        id: 'fabric.media.unable_to_annotate_image',
        defaultMessage: "You're unable to annotate this image",
        description: 'If there is an error trying to annotate an image we show this',
    },
    learn_more: {
        id: 'fabric.media.learn_more',
        defaultMessage: 'Learn More',
        description: '',
    },
    accounts: {
        id: 'fabric.media.accounts',
        defaultMessage: 'Accounts',
        description: '',
    },
    actions: {
        id: 'fabric.media.actions',
        defaultMessage: 'Actions',
        description: '',
    },
    error_hint_retry: {
        id: 'fabric.media.error_hint_retry',
        defaultMessage: "Try again and we'll give it another shot.",
        description: 'Generic message that we show if an action failed',
    },
    error_hint_critical: {
        id: 'fabric.media.error_hint_critical',
        defaultMessage: 'If the problem keeps happening contact support.',
        description: 'We show this error message if we cant recover from the action',
    },
    close: {
        id: 'fabric.media.close',
        defaultMessage: 'Close',
        description: '',
    },
    could_not_load_editor: {
        id: 'fabric.media.could_not_load_editor',
        defaultMessage: 'Ouch! We could not load the editor',
        description: 'Error message to communicate that we cant load the editor',
    },
    could_not_save_image: {
        id: 'fabric.media.could_not_save_image',
        defaultMessage: 'Ouch! We could not save the image',
        description: 'Error message to communicate that we cant save an image',
    },
    annotate: {
        id: 'fabric.media.annotate',
        defaultMessage: 'Annotate',
        description: '',
    },
    drop_your_files_here: {
        id: 'fabric.media.drop_your_files_here',
        defaultMessage: 'Drop your files here',
        description: 'Info message that we show to indicate that the user can drag and drop files',
    },
    share_files_instantly: {
        id: 'fabric.media.share_files_instantly',
        defaultMessage: "We'll share them instantly",
        description: 'It means that we will upload the files you drag and drop automatically',
    },
    insert_files: {
        id: 'fabric.media.insert_files',
        defaultMessage: 'Insert {0, plural, one {a file} other {{0} files}}',
        description: 'Showed when the user selects 1 or more files to insert',
    },
    zoom_out: {
        id: 'fabric.media.zoom_out',
        defaultMessage: 'zoom out',
        description: 'Indicates the user can zoom out a file',
    },
    zoom_in: {
        id: 'fabric.media.zoom_in',
        defaultMessage: 'zoom in',
        description: 'Indicates the user can zoom in a file',
    },
    remove_image: {
        id: 'fabric.media.remove_image',
        defaultMessage: 'Remove image',
        description: 'Allows the user to remove a file',
    },
    play: {
        id: 'fabric.media.play',
        defaultMessage: 'play',
        description: '',
    },
    pause: {
        id: 'fabric.media.pause',
        defaultMessage: 'pause',
        description: '',
    },
    disable_fullscreen: {
        id: 'fabric.media.disable_fullscreen',
        defaultMessage: 'disable fullscreen',
        description: 'Hint to let the user know he can disable the fullscreen mode',
    },
    enable_fullscreen: {
        id: 'fabric.media.enable_fullscreen',
        defaultMessage: 'enable fullscreen',
        description: 'Hint to let the user know he can enable the fullscreen mode',
    },
    error_loading_file: {
        id: 'fabric.media.error_loading_file',
        defaultMessage: 'Error loading file',
        description: 'Message showed when we had an error trying to load the file',
    },
    error_generating_preview: {
        id: 'fabric.media.error_generating_preview',
        defaultMessage: 'Error generating preview',
        description: 'Message showed when we had an error trying generate a preview for a file',
    },
    download: {
        id: 'fabric.media.download',
        defaultMessage: 'Download',
        description: '',
    },
    unknown: {
        id: 'fabric.media.unknown',
        defaultMessage: 'unknown',
        description: '',
    },
    document: {
        id: 'fabric.media.document',
        defaultMessage: 'document',
        description: '',
    },
    audio: {
        id: 'fabric.media.audio',
        defaultMessage: 'audio',
        description: '',
    },
    video: {
        id: 'fabric.media.video',
        defaultMessage: 'video',
        description: '',
    },
    image: {
        id: 'fabric.media.image',
        defaultMessage: 'image',
        description: '',
    },
});
//# sourceMappingURL=messages.js.map

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Video; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2261);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var getVolumeFromVideo = function (video) {
    var volume = video.volume;
    var isMuted = volume === 0;
    return {
        volume: volume,
        isMuted: isMuted
    };
};
var isSafari = typeof navigator !== 'undefined' ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : false;
var Video = (function (_super) {
    __extends(Video, _super);
    function Video() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.previousVolume = 1;
        _this.mediaRef = __WEBPACK_IMPORTED_MODULE_0_react__["createRef"]();
        _this.state = {
            isLoading: true,
            buffered: 0,
            currentTime: 0,
            volume: 1,
            status: 'paused',
            duration: 0,
            isMuted: false
        };
        _this.onVolumeChange = function (event) {
            var video = event.target;
            var _a = getVolumeFromVideo(video), volume = _a.volume, isMuted = _a.isMuted;
            _this.setState({
                volume: volume,
                isMuted: isMuted
            });
        };
        _this.onTimeUpdate = function (event) {
            var video = event.target;
            _this.setState({
                currentTime: video.currentTime
            });
            if (video.buffered.length) {
                var buffered = video.buffered.end(video.buffered.length - 1);
                _this.setState({ buffered: buffered });
            }
        };
        _this.onCanPlay = function (event) {
            var video = event.target;
            var _a = getVolumeFromVideo(video), volume = _a.volume, isMuted = _a.isMuted;
            _this.setState({
                volume: volume,
                isMuted: isMuted,
                isLoading: false,
                currentTime: video.currentTime,
                duration: video.duration
            });
        };
        _this.onPlay = function () {
            _this.setState({
                status: 'playing'
            });
        };
        _this.onPause = function () {
            _this.setState({
                status: 'paused'
            });
        };
        _this.play = function () {
            _this.mediaRef.current && _this.mediaRef.current.play();
        };
        _this.pause = function () {
            _this.mediaRef.current && _this.mediaRef.current.pause();
        };
        _this.navigate = function (time) {
            _this.setState({ currentTime: time });
            _this.mediaRef.current && (_this.mediaRef.current.currentTime = time);
        };
        _this.setVolume = function (volume) {
            _this.setState({ volume: volume });
            _this.mediaRef.current && (_this.mediaRef.current.volume = volume);
        };
        _this.requestFullscreen = function () {
            var sourceType = _this.props.sourceType;
            if (sourceType === 'video') {
                Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* requestFullScreen */])(_this.mediaRef.current);
            }
        };
        _this.mute = function () {
            var volume = _this.state.volume;
            _this.previousVolume = volume;
            _this.setVolume(0);
        };
        _this.unmute = function () {
            _this.setVolume(_this.previousVolume);
        };
        _this.toggleMute = function () {
            var volume = _this.videoState.volume;
            if (volume > 0) {
                _this.mute();
            }
            else {
                _this.unmute();
            }
        };
        _this.onDurationChange = function (event) {
            var video = event.target;
            _this.setState({
                duration: video.duration
            });
        };
        _this.onError = function (event) {
            var video = event.target;
            _this.setState({
                isLoading: false,
                status: 'errored',
                error: video.error
            });
        };
        _this.onWaiting = function () {
            _this.setState({ isLoading: true });
        };
        return _this;
    }
    Video.prototype.componentDidUpdate = function (prevProps) {
        var src = this.props.src;
        var _a = this.state, currentTime = _a.currentTime, status = _a.status;
        var hasSrcChanged = prevProps.src !== src;
        if (hasSrcChanged) {
            if (status === 'playing') {
                this.play();
            }
            this.navigate(currentTime);
        }
    };
    Object.defineProperty(Video.prototype, "videoState", {
        get: function () {
            var _a = this.state, currentTime = _a.currentTime, volume = _a.volume, status = _a.status, duration = _a.duration, buffered = _a.buffered, isMuted = _a.isMuted, isLoading = _a.isLoading, error = _a.error;
            return {
                currentTime: currentTime,
                volume: volume,
                status: status,
                duration: duration,
                buffered: buffered,
                isMuted: isMuted,
                isLoading: isLoading,
                error: error
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Video.prototype, "actions", {
        get: function () {
            var _a = this, play = _a.play, pause = _a.pause, navigate = _a.navigate, setVolume = _a.setVolume, requestFullscreen = _a.requestFullscreen, mute = _a.mute, unmute = _a.unmute, toggleMute = _a.toggleMute;
            return {
                play: play,
                pause: pause,
                navigate: navigate,
                setVolume: setVolume,
                requestFullscreen: requestFullscreen,
                mute: mute,
                unmute: unmute,
                toggleMute: toggleMute
            };
        },
        enumerable: true,
        configurable: true
    });
    Video.prototype.render = function () {
        var _a = this, videoState = _a.videoState, actions = _a.actions;
        var _b = this.props, sourceType = _b.sourceType, src = _b.src, children = _b.children, autoPlay = _b.autoPlay, controls = _b.controls, preload = _b.preload, crossOrigin = _b.crossOrigin;
        var TagName = sourceType || 'video';
        return children(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TagName, { ref: this.mediaRef, src: src, preload: preload, controls: controls, autoPlay: autoPlay, onPlay: this.onPlay, onPause: this.onPause, onVolumeChange: this.onVolumeChange, onTimeUpdate: this.onTimeUpdate, onCanPlay: this.onCanPlay, onDurationChange: this.onDurationChange, onError: this.onError, onWaiting: this.onWaiting, crossOrigin: crossOrigin }), videoState, actions, this.mediaRef);
    };
    Video.defaultProps = {
        sourceType: 'video',
        autoPlay: false,
        controls: false,
        preload: isSafari ? 'auto' : 'metadata'
    };
    return Video;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));



/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(49);

var buttonTheme = {
    toolbar: {
        background: {
            hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN60 }),
            active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75 }),
        },
        boxShadowColor: {
            focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75 }),
        },
        color: {
            default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
            active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400 }),
            disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN100 }),
        },
    },
    primary: {
        background: {
            default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100 }),
            hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75 }),
            active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200 }),
            disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN70 }),
        },
        boxShadowColor: {
            focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75 }),
        },
        color: {
            default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN30 }),
        },
    },
};
/* harmony default export */ __webpack_exports__["a"] = ({ '@atlaskit-shared-theme/button': buttonTheme });
//# sourceMappingURL=theme.js.map

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimeRange; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatDuration__ = __webpack_require__(426);





var TimeRange = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](TimeRange, _super);
    function TimeRange() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wrapperElementWidth = 0;
        _this.state = {
            isDragging: false,
            dragStartClientX: 0,
        };
        _this.setWrapperWidth = function () {
            if (!_this.wrapperElement) {
                return;
            }
            _this.wrapperElementWidth = _this.wrapperElement.getBoundingClientRect().width;
        };
        _this.onMouseMove = function (e) {
            var _a = _this.state, isDragging = _a.isDragging, dragStartClientX = _a.dragStartClientX;
            if (!isDragging) {
                return;
            }
            e.stopPropagation();
            var _b = _this.props, onChange = _b.onChange, duration = _b.duration, currentTime = _b.currentTime;
            var clientX = e.clientX;
            var absolutePosition = clientX - dragStartClientX;
            var isOutsideToRight = absolutePosition > _this.wrapperElementWidth;
            var isOutsideToLeft = absolutePosition < 0;
            // Next to conditions take care of situation where user moves mouse very quickly out to the side
            // left or right. It's very easy to leave thumb not at the end/beginning of a timeline.
            // This will guarantee that in this case thumb will move to appropriate extreme.
            if (isOutsideToRight) {
                absolutePosition = _this.wrapperElementWidth;
            }
            if (isOutsideToLeft) {
                absolutePosition = 0;
            }
            var newTimeWithBoundaries = (absolutePosition * duration) / _this.wrapperElementWidth;
            if (currentTime !== newTimeWithBoundaries) {
                // If value hasn't changed we don't want to call "change"
                onChange(newTimeWithBoundaries);
            }
        };
        _this.onMouseUp = function () {
            // As soon as user finished dragging, we should clean up events.
            document.removeEventListener('mouseup', _this.onMouseUp);
            document.removeEventListener('mousemove', _this.onMouseMove);
            _this.setState({
                isDragging: false,
            });
        };
        _this.onThumbMouseDown = function (e) {
            // We need to recalculate every time, because width can change (thanks, editor ;-)
            _this.setWrapperWidth();
            // We are implementing drag and drop here. There is no reason to start listening for mouseUp or move
            // before that. Also if we start listening for mouseup before that we could pick up someone else's event
            // For example editors resizing of a inline video player.
            document.addEventListener('mouseup', _this.onMouseUp);
            document.addEventListener('mousemove', _this.onMouseMove);
            var _a = _this.props, duration = _a.duration, onChange = _a.onChange;
            var event = e.nativeEvent;
            var x = event.offsetX;
            var currentTime = (x * duration) / _this.wrapperElementWidth;
            _this.setState({
                isDragging: true,
                dragStartClientX: event.clientX - x,
            });
            // As soon as user clicks timeline we want to move thumb over to that place.
            onChange(currentTime);
        };
        _this.saveWrapperElement = function (el) {
            if (el) {
                _this.wrapperElement = el;
                _this.setWrapperWidth();
            }
        };
        _this.saveThumbElement = function (el) {
            if (el) {
                _this.thumbElement = el;
            }
        };
        return _this;
    }
    TimeRange.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.setWrapperWidth);
    };
    TimeRange.prototype.componentWillUnmount = function () {
        document.removeEventListener('mousemove', this.onMouseMove);
        document.removeEventListener('mouseup', this.onMouseUp);
        window.removeEventListener('resize', this.setWrapperWidth);
    };
    TimeRange.prototype.render = function () {
        var isDragging = this.state.isDragging;
        var _a = this.props, currentTime = _a.currentTime, duration = _a.duration, bufferedTime = _a.bufferedTime, disableThumbTooltip = _a.disableThumbTooltip, isAlwaysActive = _a.isAlwaysActive;
        var currentPosition = (currentTime * 100) / duration;
        var bufferedTimePercentage = (bufferedTime * 100) / duration;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["m" /* TimeRangeWrapper */], { showAsActive: isAlwaysActive, onMouseDown: this.onThumbMouseDown },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["l" /* TimeLine */], { innerRef: this.saveWrapperElement },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["a" /* BufferedTime */], { style: { width: bufferedTimePercentage + "%" } }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["d" /* CurrentTimeLine */], { style: { width: currentPosition + "%" } },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["k" /* Thumb */], { innerRef: this.saveThumbElement }, disableThumbTooltip ? null : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["e" /* CurrentTimeTooltip */], { draggable: false, isDragging: isDragging, className: "current-time-tooltip" }, Object(__WEBPACK_IMPORTED_MODULE_3__formatDuration__["a" /* formatDuration */])(currentTime))))))));
    };
    TimeRange.defaultProps = {
        disableThumbTooltip: false,
        isAlwaysActive: false,
    };
    return TimeRange;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=timeRange.js.map

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CustomVideoWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return VideoWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return TimebarWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return VolumeWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return TimeWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CurrentTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return TimeLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CurrentTimeLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return Thumb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BufferedTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LeftControls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RightControls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ControlsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return VolumeToggleWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return VolumeTimeRangeWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MutedIndicator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CurrentTimeTooltip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return TimeRangeWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SpinnerWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(49);



var CustomVideoWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  width: 100%;\n  height: 100%;\n  user-select: none;\n"], ["\n  width: 100%;\n  height: 100%;\n  user-select: none;\n"])));
var VideoWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"], ["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"])));
var TimebarWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: white;\n  position: absolute;\n  width: 100%;\n  bottom: 10px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: white;\n  position: absolute;\n  width: 100%;\n  bottom: 10px;\n"])));
var VolumeWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  width: 35px;\n  overflow: hidden;\n  transition: width 0.3s;\n  align-items: center;\n\n  &:hover,\n  &:active {\n    width: 159px;\n    transition: width 0.3s ease-out;\n  }\n"], ["\n  display: flex;\n  width: 35px;\n  overflow: hidden;\n  transition: width 0.3s;\n  align-items: center;\n\n  &:hover,\n  &:active {\n    width: 159px;\n    transition: width 0.3s ease-out;\n  }\n"])));
var TimeWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_5 || (templateObject_5 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin: 0 20px 10px 20px;\n  margin-bottom: 44px;\n"], ["\n  margin: 0 20px 10px 20px;\n  margin-bottom: 44px;\n"])));
var CurrentTime = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_6 || (templateObject_6 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  color: #a4b4cb;\n  user-select: none;\n  margin-right: 10px;\n"], ["\n  color: #a4b4cb;\n  user-select: none;\n  margin-right: 10px;\n"])));
var TimeLine = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_7 || (templateObject_7 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  width: 100%;\n  height: 2px;\n  transition-delay: 1s;\n  transition: all 0.1s;\n  background-color: #5d646f;\n  border-radius: 5px;\n  position: relative;\n"], ["\n  width: 100%;\n  height: 2px;\n  transition-delay: 1s;\n  transition: all 0.1s;\n  background-color: #5d646f;\n  border-radius: 5px;\n  position: relative;\n"])));
var CurrentTimeLine = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_8 || (templateObject_8 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  background-color: #3383ff;\n  border-radius: inherit;\n  height: inherit;\n  position: absolute;\n  top: 0;\n  max-width: 100%;\n"], ["\n  background-color: #3383ff;\n  border-radius: inherit;\n  height: inherit;\n  position: absolute;\n  top: 0;\n  max-width: 100%;\n"])));
var Thumb = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_9 || (templateObject_9 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  pointer-events: none;\n  width: 14px;\n  height: 14px;\n  border-radius: 100%;\n  background-color: white;\n  border: 1px solid #666;\n  position: absolute;\n  right: 0;\n  top: 50%;\n\n  transform: translate(7px, -50%) scale(0);\n  transition: all 0.1s;\n  transition-delay: 1s;\n\n  &:hover .current-time-tooltip {\n    opacity: 1;\n  }\n"], ["\n  pointer-events: none;\n  width: 14px;\n  height: 14px;\n  border-radius: 100%;\n  background-color: white;\n  border: 1px solid #666;\n  position: absolute;\n  right: 0;\n  top: 50%;\n\n  transform: translate(7px, -50%) scale(0);\n  transition: all 0.1s;\n  transition-delay: 1s;\n\n  &:hover .current-time-tooltip {\n    opacity: 1;\n  }\n"])));
var BufferedTime = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_10 || (templateObject_10 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  background-color: #aeb1b7;\n  height: inherit;\n  border-radius: inherit;\n  width: 0;\n"], ["\n  background-color: #aeb1b7;\n  height: inherit;\n  border-radius: inherit;\n  width: 0;\n"])));
var LeftControls = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_11 || (templateObject_11 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  margin-left: 10px;\n"], ["\n  display: flex;\n  margin-left: 10px;\n"])));
var RightControls = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_12 || (templateObject_12 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  align-items: center;\n  margin-right: 10px;\n"], ["\n  display: flex;\n  align-items: center;\n  margin-right: 10px;\n"])));
var ControlsWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_13 || (templateObject_13 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: auto;\n  background: linear-gradient(to top, #0e1624, rgba(14, 22, 36, 0));\n  position: absolute;\n"], ["\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: auto;\n  background: linear-gradient(to top, #0e1624, rgba(14, 22, 36, 0));\n  position: absolute;\n"])));
var VolumeToggleWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_14 || (templateObject_14 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  position: relative;\n  margin-right: 13px;\n\n  button {\n    width: 36px;\n    color: ", ";\n  }\n"], ["\n  position: relative;\n  margin-right: 13px;\n\n  button {\n    width: 36px;\n    color: ",
    ";\n  }\n"])), function (_a) {
    var isMuted = _a.isMuted;
    return isMuted ? __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R300 + " !important;" : '';
});
var VolumeTimeRangeWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_15 || (templateObject_15 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  width: 100%;\n  margin-right: 20px;\n"], ["\n  width: 100%;\n  margin-right: 20px;\n"])));
var MutedIndicator = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_16 || (templateObject_16 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  width: 29px;\n  height: 2px;\n  position: absolute;\n  top: 5px;\n  left: 9px;\n  background: ", ";\n  transform: rotate(32deg) translateY(10px);\n  opacity: 0;\n  pointer-events: none;\n\n  ", ";\n"], ["\n  width: 29px;\n  height: 2px;\n  position: absolute;\n  top: 5px;\n  left: 9px;\n  background: ", ";\n  transform: rotate(32deg) translateY(10px);\n  opacity: 0;\n  pointer-events: none;\n\n  ",
    ";\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R300, function (props) {
    return props.isMuted
        ? "\n    opacity: 1;\n  "
        : '';
});
var CurrentTimeTooltip = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_17 || (templateObject_17 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  position: absolute;\n  user-select: none;\n  top: -28px;\n  background-color: #182c4c;\n  color: #eff1f3;\n  font-size: 12px;\n  padding: 3px 7px;\n  border-radius: 3px;\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: ", ";\n  transition: opacity 0.3s;\n"], ["\n  position: absolute;\n  user-select: none;\n  top: -28px;\n  background-color: #182c4c;\n  color: #eff1f3;\n  font-size: 12px;\n  padding: 3px 7px;\n  border-radius: 3px;\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: ",
    ";\n  transition: opacity 0.3s;\n"])), function (props) {
    return props.isDragging ? '1' : '0';
});
var TimeRangeWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_18 || (templateObject_18 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  align-items: center;\n  height: 22px;\n\n  cursor: pointer;\n  width: 100%;\n\n  &:hover ", " {\n    height: 4px;\n    transition: all 0.1s;\n  }\n\n  &:hover ", " {\n    transition: all 0.1s;\n    transform: translate(7px, -50%) scale(1);\n  }\n\n  ", " {\n    transition-delay: 1s;\n    ", "\n  }\n  ", " {\n    ", "\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  height: 22px;\n\n  cursor: pointer;\n  width: 100%;\n\n  &:hover ", " {\n    height: 4px;\n    transition: all 0.1s;\n  }\n\n  &:hover ", " {\n    transition: all 0.1s;\n    transform: translate(7px, -50%) scale(1);\n  }\n\n  ", " {\n    transition-delay: 1s;\n    ",
    "\n  }\n  ", " {\n    ",
    "\n  }\n"])), TimeLine, Thumb, TimeLine, function (_a) {
    var showAsActive = _a.showAsActive;
    return showAsActive ? 'height: 4px;' : '';
}, Thumb, function (_a) {
    var showAsActive = _a.showAsActive;
    return showAsActive ? 'transform: translate(7px, -50%) scale(1);' : '';
});
var SpinnerWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_19 || (templateObject_19 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hideControlsClassName; });
var hideControlsClassName = 'mvng-hide-controls';
//# sourceMappingURL=classNames.js.map

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return keyCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Shortcut; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var keyCodes = {
    space: 32,
    m: 77,
};
var Shortcut = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Shortcut, _super);
    function Shortcut() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.keyHandler = function (e) {
            var _a = _this.props, keyCode = _a.keyCode, handler = _a.handler;
            if (e.keyCode === keyCode) {
                handler();
            }
        };
        _this.init = function () {
            document.addEventListener('keydown', _this.keyHandler);
        };
        _this.release = function () {
            document.removeEventListener('keydown', _this.keyHandler);
        };
        return _this;
    }
    Shortcut.prototype.componentDidMount = function () {
        this.init();
    };
    Shortcut.prototype.componentWillUnmount = function () {
        this.release();
    };
    Shortcut.prototype.render = function () {
        return null;
    };
    return Shortcut;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=shortcut.js.map

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(779);

var defaultTheme = {
  mode: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_THEME_MODE */]
};
function getTheme(props) {
  if (props && props.theme && props.theme.__ATLASKIT_THEME__) {
    // $FlowFixMe - cannot narrow type between input types
    return props.theme.__ATLASKIT_THEME__;
  } else if (props && props.theme && props.theme.mode) {
    // $FlowFixMe - cannot narrow type between input types
    return props.theme;
  }

  return defaultTheme;
}

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FLATTENED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_THEME_MODE; });
/* unused harmony export THEME_MODES */
var FLATTENED = '__FLATTENED__';
var CHANNEL = '__ATLASKIT_THEME__';
var DEFAULT_THEME_MODE = 'light';
var THEME_MODES = ['light', 'dark'];

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultTransitionDuration; });
var defaultTransitionDuration = '.3s';
//# sourceMappingURL=config.js.map

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardActionIconButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled__ = __webpack_require__(430);




var CardActionIconButton = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CardActionIconButton, _super);
    function CardActionIconButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardActionIconButton.prototype.render = function () {
        var _a = this.props, icon = _a.icon, triggerColor = _a.triggerColor, onClick = _a.onClick;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["a" /* CardActionButton */], { onClick: onClick, style: { color: triggerColor } }, icon));
    };
    return CardActionIconButton;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=cardActionIconButton.js.map

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardActionsDropdownMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_more__ = __webpack_require__(2275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_more___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_more__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_dropdown_menu__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styled__ = __webpack_require__(430);






var CardActionsDropdownMenu = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CardActionsDropdownMenu, _super);
    function CardActionsDropdownMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardActionsDropdownMenu.prototype.render = function () {
        var _a = this.props, actions = _a.actions, triggerColor = _a.triggerColor, onOpenChange = _a.onOpenChange;
        if (actions.length > 0) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_dropdown_menu__["c" /* default */], { onOpenChange: onOpenChange, trigger: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styled__["a" /* CardActionButton */], { style: { color: triggerColor } },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_more___default.a, { label: "more" })) },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_dropdown_menu__["b" /* DropdownItemGroup */], null, actions.map(function (_a, index) {
                    var label = _a.label, handler = _a.handler;
                    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_dropdown_menu__["a" /* DropdownItem */], { key: index, onClick: handler }, label));
                }))));
        }
        else {
            return null;
        }
    };
    return CardActionsDropdownMenu;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=cardActionsDropdownMenu.js.map

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getElementBounds;

__webpack_require__(208);

function getElementBounds(element) {
  if (!element) {
    return undefined;
  }
  var rect = element.getBoundingClientRect();
  return {
    left: window.pageXOffset + rect.left,
    right: window.pageXOffset + rect.left + rect.width,
    top: window.pageYOffset + rect.top,
    bottom: window.pageYOffset + rect.top + rect.height
  };
}

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalTransitionConsumer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);









var _createContext = Object(__WEBPACK_IMPORTED_MODULE_7_react__["createContext"])({
  isOpen: true,
  onExited: undefined
}),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider; // checks if children exist and are truthy


var hasChildren = function hasChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.count(children) > 0 && __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.map(children, function (child) {
    return !!child;
  }).filter(Boolean).length > 0;
};

var Transition =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Transition, _React$Component);

  function Transition() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Transition);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Transition)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      currentChildren: undefined
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onExited", function () {
      _this.setState({
        currentChildren: _this.props.children
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Transition, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Provider, {
        value: {
          onExited: this.onExited,
          isOpen: hasChildren(this.props.children)
        }
      }, this.state.currentChildren);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var previousChildren = state.currentChildren;
      var exiting = hasChildren(previousChildren) && !hasChildren(props.children);
      return {
        currentChildren: exiting ? previousChildren : props.children
      };
    }
  }]);

  return Transition;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

var ModalTransitionConsumer = Consumer;
/* harmony default export */ __webpack_exports__["b"] = (Transition);

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WIDTH_ENUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gutter; });
// eslint-disable-next-line import/prefer-default-export
var WIDTH_ENUM = {
  values: ['small', 'medium', 'large', 'x-large'],
  widths: {
    small: 400,
    medium: 600,
    large: 800,
    'x-large': 968
  },
  defaultValue: 'medium'
};
var gutter = 60;

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IEMaxHeightCalcPx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return flexMaxHeightIEFix; });
/* Used to adjust flex parent height to account for the subtraction in children below */
var IEMaxHeightCalcPx = 1;
/* A bug exists in IE where flex column children overflow the height of their parents.
 * The workaround is to set a pixel max-height on the flex children.
 * For more information see https://github.com/philipwalton/flexbugs/issues/216
 */

var flexMaxHeightIEFix = "\n  max-height: calc(100% - ".concat(IEMaxHeightCalcPx, "px);\n");

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(18));

var _reactLifecyclesCompat = __webpack_require__(72);

var _PropTypes = __webpack_require__(788);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }

      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   *  appear: 500,
   * }}
   * ```
   *
   * If the value of appear is not set, then the value from enter is taken.
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    var pt = process.env.NODE_ENV !== "production" ? _PropTypes.timeoutsShape : {};;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(10));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(72);

var _ChildMapping = __webpack_require__(2313);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var getComponentName = function (target) {
    if (target.displayName && typeof target.displayName === 'string') {
        return target.displayName;
    }
    return target.name || 'Component';
};
var warnIfDeprecatedAppearance = function (appearance) {
    var deprecatedAppearances = ['help'];
    if (appearance && deprecatedAppearances.indexOf(appearance) !== -1) {
        // tslint:disable-next-line:no-console
        console.warn("Atlaskit: The Button appearance \"" + appearance + "\" is deprecated. Please use styled-components' ThemeProvider to provide a custom theme for Button instead.");
    }
};
var withDeprecationWarnings = function (Component) {
    var _a;
    return _a = /** @class */ (function (_super) {
            __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WithDeprecationWarnings, _super);
            function WithDeprecationWarnings() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            WithDeprecationWarnings.prototype.componentWillMount = function () {
                warnIfDeprecatedAppearance(this.props.appearance);
            };
            WithDeprecationWarnings.prototype.componentWillReceiveProps = function (newProps) {
                if (newProps.appearance !== this.props.appearance) {
                    warnIfDeprecatedAppearance(newProps.appearance);
                }
            };
            WithDeprecationWarnings.prototype.render = function () {
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Component, this.props);
            };
            return WithDeprecationWarnings;
        }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"])),
        _a.displayName = "WithDeprecationWarnings(" + getComponentName(Component) + ")",
        _a;
};
/* harmony default export */ __webpack_exports__["a"] = (withDeprecationWarnings);
//# sourceMappingURL=withDeprecationWarnings.js.map

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themeNamespace; });
var themeNamespace = '@atlaskit-shared-theme/button';
//# sourceMappingURL=theme.js.map

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isLoadingStyle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLoadingStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var isLoadingStyle = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  transition: opacity 0.3s;\n  opacity: ", ";\n"], ["\n  transition: opacity 0.3s;\n  opacity: ", ";\n"])), function (_a) {
    var isLoading = _a.isLoading;
    return (isLoading ? 0 : 1);
});
var getLoadingStyle = function (_a) {
    var isLoading = _a.isLoading;
    return ({
        transition: 'opacity 0.3s',
        opacity: isLoading ? 0 : 1,
    });
};

var templateObject_1;
//# sourceMappingURL=utils.js.map

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(54);

var _interopRequireDefault = __webpack_require__(53);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.size = exports.default = exports.IconWrapper = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(4));

var _createClass2 = _interopRequireDefault(__webpack_require__(5));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(7));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(6));

var _inherits2 = _interopRequireDefault(__webpack_require__(8));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _styledComponents = _interopRequireDefault(__webpack_require__(2));

var _uuid = _interopRequireDefault(__webpack_require__(22));

var _theme = __webpack_require__(3);

var _constants = __webpack_require__(2331);

var getSize = function getSize(props) {
  if (props.size) {
    return "height: ".concat(_constants.sizes[props.size], "; width: ").concat(_constants.sizes[props.size], ";");
  }

  return null;
};

var IconWrapper = _styledComponents.default.span.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "dyhwwi-0"
})(["\n  ", " color: ", ";\n  display: inline-block;\n  fill: ", ";\n  flex-shrink: 0;\n  line-height: 1;\n\n  > svg {\n    ", " max-height: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    pointer-events: none;\n    vertical-align: bottom;\n  }\n  /* Stop-color doesn't properly apply in chrome when the inherited/current color changes.\n   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS\n   * rule) and then override it with currentColor for the color changes to be picked up.\n   */\n  stop {\n    stop-color: currentColor;\n  }\n"], getSize, function (p) {
  return p.primaryColor || 'currentColor';
}, function (p) {
  return p.secondaryColor || _theme.colors.background;
}, getSize);

exports.IconWrapper = IconWrapper;

var Icon =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Icon, _Component);

  function Icon() {
    (0, _classCallCheck2.default)(this, Icon);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Icon).apply(this, arguments));
  }

  (0, _createClass2.default)(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Glyph = _this$props.glyph,
          dangerouslySetGlyph = _this$props.dangerouslySetGlyph,
          primaryColor = _this$props.primaryColor,
          secondaryColor = _this$props.secondaryColor,
          size = _this$props.size; // handling the glyphs as strings

      if (dangerouslySetGlyph) {
        return _react.default.createElement(IconWrapper, {
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          size: size,
          "aria-label": this.props.label,
          dangerouslySetInnerHTML: {
            __html: Icon.insertDynamicGradientID(dangerouslySetGlyph)
          }
        });
      } // handling the glyphs when passed through as functions


      return _react.default.createElement(IconWrapper, {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        "aria-label": this.props.label
      }, Glyph ? _react.default.createElement(Glyph, {
        role: "presentation"
      }) : null);
    }
  }], [{
    key: "insertDynamicGradientID",

    /* Icons need unique gradient IDs across instances for different gradient definitions to work
     * correctly.
     * A step in the icon build process replaces linear gradient IDs and their references in paths
     * to a placeholder string so we can replace them with a dynamic ID here.
     * Replacing the original IDs with placeholders in the build process is more robust than not
     * using placeholders as we do not have to rely on regular expressions to find specific element
     * to replace.
     */
    value: function insertDynamicGradientID(svgStr) {
      var id = (0, _uuid.default)();
      var replacedSvgStr = svgStr.replace(/id="([^"]+)-idPlaceholder"/g, "id=$1-".concat(id)).replace(/fill="url\(#([^"]+)-idPlaceholder\)"/g, "fill=\"url(#$1-".concat(id, ")\""));
      return replacedSvgStr;
    }
  }]);
  return Icon;
}(_react.Component);

exports.default = Icon;
var size = Object.keys(_constants.sizes).reduce(function (p, c) {
  return Object.assign(p, (0, _defineProperty2.default)({}, c, c));
}, {});
exports.size = size;

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export newFocus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__ = __webpack_require__(2337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_firstFocus__ = __webpack_require__(2341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_all_affected__ = __webpack_require__(433);




var findAutoFocused = function findAutoFocused(autoFocusables) {
  return function (node) {
    return !!node.autofocus || node.dataset && !!node.dataset.autofocus || autoFocusables.indexOf(node) >= 0;
  };
};

var newFocus = function newFocus(innerNodes, outerNodes, activeElement, lastNode, autoFocused) {
  var cnt = innerNodes.length;
  var firstFocus = innerNodes[0];
  var lastFocus = innerNodes[cnt - 1];

  // focus is inside
  if (innerNodes.indexOf(activeElement) >= 0) {
    return undefined;
  }

  var activeIndex = outerNodes.indexOf(activeElement);
  var lastIndex = outerNodes.indexOf(lastNode || activeIndex);
  var lastNodeInside = innerNodes.indexOf(lastNode);
  var indexDiff = activeIndex - lastIndex;
  var firstNodeIndex = outerNodes.indexOf(firstFocus);
  var lastNodeIndex = outerNodes.indexOf(lastFocus);

  // new focus
  if (activeIndex === -1 || lastNodeInside === -1) {
    return innerNodes.indexOf(autoFocused.length ? Object(__WEBPACK_IMPORTED_MODULE_1__utils_firstFocus__["a" /* default */])(autoFocused) : Object(__WEBPACK_IMPORTED_MODULE_1__utils_firstFocus__["a" /* default */])(innerNodes));
  }
  // old focus
  if (!indexDiff && lastNodeInside >= 0) {
    return lastNodeInside;
  }
  // jump out
  if (indexDiff && Math.abs(indexDiff) > 1) {
    return lastNodeInside;
  }
  // focus above lock
  if (activeIndex <= firstNodeIndex) {
    return cnt - 1;
  }
  // focus below lock
  if (activeIndex > lastNodeIndex) {
    return 0;
  }
  // index is inside tab order, but outside Lock
  if (indexDiff) {
    if (Math.abs(indexDiff) > 1) {
      return lastNodeInside;
    }
    return (cnt + lastNodeInside + indexDiff) % cnt;
  }
  // do nothing
  return undefined;
};

var getTopCommonParent = function getTopCommonParent(activeElement, entry, entries) {
  var topCommon = entry;
  entries.forEach(function (subEntry) {
    var common = Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["b" /* getCommonParent */])(activeElement, subEntry);
    if (common) {
      if (common.contains(topCommon)) {
        topCommon = common;
      } else {
        topCommon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["b" /* getCommonParent */])(common, topCommon);
      }
    }
  });
  return topCommon;
};

var allParentAutofocusables = function allParentAutofocusables(entries) {
  return entries.reduce(function (acc, node) {
    return acc.concat(Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["d" /* parentAutofocusables */])(node));
  }, []);
};

var notAGuard = function notAGuard(node) {
  return !(node.dataset && node.dataset.focusGuard);
};

var getFocusMerge = function getFocusMerge(topNode, lastNode) {
  var activeElement = document && document.activeElement;
  var entries = Object(__WEBPACK_IMPORTED_MODULE_2__utils_all_affected__["a" /* default */])(topNode).filter(notAGuard);

  var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);

  var innerElements = Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["c" /* getTabbableNodes */])(entries).filter(function (_ref) {
    var node = _ref.node;
    return notAGuard(node);
  });

  if (!innerElements[0]) {
    innerElements = Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["a" /* getAllTabbableNodes */])(entries).filter(function (_ref2) {
      var node = _ref2.node;
      return notAGuard(node);
    });
    if (!innerElements[0]) {
      return undefined;
    }
  }

  var innerNodes = innerElements.map(function (_ref3) {
    var node = _ref3.node;
    return node;
  });

  var outerNodes = Object(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["c" /* getTabbableNodes */])([commonParent]).map(function (_ref4) {
    var node = _ref4.node;
    return node;
  });

  var newId = newFocus(innerNodes, outerNodes, activeElement, lastNode, innerNodes.filter(findAutoFocused(allParentAutofocusables(entries))));

  if (newId === undefined) {
    return newId;
  }
  return innerElements[newId];
};

/* harmony default export */ __webpack_exports__["a"] = (getFocusMerge);

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FieldTextStatelessWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_analytics_next__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_field_base__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__package_json__ = __webpack_require__(2352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styled_Input__ = __webpack_require__(2353);













var Wrapper = __WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div.withConfig({
  displayName: "FieldTextStateless__Wrapper",
  componentId: "ynbdsh-0"
})(["\n  flex: 1 1 100%;\n"]);

var FieldTextStateless =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(FieldTextStateless, _Component);

  function FieldTextStateless() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, FieldTextStateless);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(FieldTextStateless)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "input", void 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "setInputRef", function (input) {
      _this.input = input; // $FlowFixMe - Cannot call `this.props.innerRef` because undefined [1] is not a function

      _this.props.innerRef(input);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(FieldTextStateless, [{
    key: "focus",
    value: function focus() {
      if (this.input) {
        this.input.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Wrapper, null, !this.props.isLabelHidden && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__atlaskit_field_base__["a" /* Label */], {
        htmlFor: this.props.id,
        isDisabled: this.props.disabled,
        isLabelHidden: this.props.isLabelHidden,
        isRequired: this.props.required,
        label: this.props.label || ''
      }), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__atlaskit_field_base__["b" /* default */], {
        invalidMessage: this.props.invalidMessage,
        isCompact: this.props.compact,
        isDisabled: this.props.disabled,
        isFitContainerWidthEnabled: this.props.shouldFitContainer,
        isInvalid: this.props.isInvalid,
        isReadOnly: this.props.isReadOnly,
        isRequired: this.props.required,
        isValidationHidden: this.props.isValidationHidden
      }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__styled_Input__["a" /* default */], {
        autoComplete: this.props.autoComplete,
        autoFocus: this.props.autoFocus,
        disabled: this.props.disabled,
        form: this.props.form,
        id: this.props.id,
        innerRef: this.setInputRef,
        isMonospaced: this.props.isMonospaced,
        maxLength: this.props.maxLength,
        min: this.props.min,
        max: this.props.max,
        name: this.props.name,
        onBlur: this.props.onBlur,
        onChange: this.props.onChange,
        onFocus: this.props.onFocus,
        onKeyDown: this.props.onKeyDown,
        onKeyPress: this.props.onKeyPress,
        onKeyUp: this.props.onKeyUp,
        pattern: this.props.pattern,
        placeholder: this.props.placeholder,
        readOnly: this.props.isReadOnly,
        required: this.props.required,
        spellCheck: this.props.isSpellCheckEnabled,
        type: this.props.type,
        value: this.props.value
      })));
    }
  }]);

  return FieldTextStateless;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(FieldTextStateless, "defaultProps", {
  compact: false,
  disabled: false,
  isInvalid: false,
  isReadOnly: false,
  isSpellCheckEnabled: true,
  onChange: function onChange() {},
  required: false,
  type: 'text',
  isValidationHidden: false,
  innerRef: function innerRef() {}
});


var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_9__atlaskit_analytics_next__["createAndFireEvent"])('atlaskit');
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__atlaskit_analytics_next__["withAnalyticsContext"])({
  componentName: 'fieldText',
  packageName: __WEBPACK_IMPORTED_MODULE_11__package_json__["name"],
  packageVersion: __WEBPACK_IMPORTED_MODULE_11__package_json__["version"]
})(Object(__WEBPACK_IMPORTED_MODULE_9__atlaskit_analytics_next__["withAnalyticsEvents"])({
  onBlur: createAndFireEventOnAtlaskit({
    action: 'blurred',
    actionSubject: 'textField',
    attributes: {
      componentName: 'fieldText',
      packageName: __WEBPACK_IMPORTED_MODULE_11__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_11__package_json__["version"]
    }
  }),
  onFocus: createAndFireEventOnAtlaskit({
    action: 'focused',
    actionSubject: 'textField',
    attributes: {
      componentName: 'fieldText',
      packageName: __WEBPACK_IMPORTED_MODULE_11__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_11__package_json__["version"]
    }
  })
})(FieldTextStateless)));

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return insertMediaAsMediaSingle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return insertMediaSingleNode; });
/* unused harmony export createMediaSingleNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commands__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_media_common__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prosemirror_utils__);





var insertMediaAsMediaSingle = function (view, node) {
    var state = view.state, dispatch = view.dispatch;
    var _a = state.schema.nodes, mediaSingle = _a.mediaSingle, media = _a.media;
    if (!mediaSingle) {
        return false;
    }
    // if not an image type media node
    if (node.type !== media ||
        (!Object(__WEBPACK_IMPORTED_MODULE_1__utils__["v" /* isImage */])(node.attrs.__fileMimeType) && node.attrs.type !== 'external')) {
        return false;
    }
    var mediaSingleNode = mediaSingle.create({}, node);
    var nodes = [mediaSingleNode];
    return Object(__WEBPACK_IMPORTED_MODULE_2__commands__["g" /* insertNodesEndWithNewParagraph */])(nodes)(state, dispatch);
};
var insertMediaSingleNode = function (view, mediaState, collection) {
    if (collection === undefined) {
        return false;
    }
    var state = view.state, dispatch = view.dispatch;
    var grandParent = state.selection.$from.node(-1);
    var node = createMediaSingleNode(state.schema, collection)(mediaState);
    var shouldSplit = grandParent && grandParent.type.validContent(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(node));
    if (shouldSplit) {
        Object(__WEBPACK_IMPORTED_MODULE_2__commands__["g" /* insertNodesEndWithNewParagraph */])([node])(state, dispatch);
    }
    else {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_prosemirror_utils__["safeInsert"])(Object(__WEBPACK_IMPORTED_MODULE_2__commands__["j" /* shouldAppendParagraphAfterBlockNode */])(view.state)
            ? __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].fromArray([node, state.schema.nodes.paragraph.create()])
            : node)(state.tr));
    }
    return true;
};
var createMediaSingleNode = function (schema, collection) { return function (mediaState) {
    var id = mediaState.id, dimensions = mediaState.dimensions, _a = mediaState.scaleFactor, scaleFactor = _a === void 0 ? 1 : _a;
    var _b = dimensions || {
        height: undefined,
        width: undefined,
    }, width = _b.width, height = _b.height;
    var _c = schema.nodes, media = _c.media, mediaSingle = _c.mediaSingle;
    var mediaNode = media.create({
        id: id,
        type: 'file',
        collection: collection,
        width: width / scaleFactor,
        height: height / scaleFactor,
        __key: id,
    });
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_media_common__["a" /* copyOptionalAttrsFromMediaState */])(mediaState, mediaNode);
    return mediaSingle.create({}, mediaNode);
}; };
//# sourceMappingURL=media-single.js.map

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter__ = __webpack_require__(798);
/* unused harmony reexport filterContentByType */
/* unused harmony reexport filterSliceByType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__task_decision_filter__ = __webpack_require__(2356);
/* unused harmony reexport taskDecisionDocFilter */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__task_decision_filter__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterContentByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filterSliceByType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__);


var isBlockNode = function (node, schema) {
    if (!schema) {
        return false;
    }
    var nodeType = schema.nodes[node.type];
    if (!nodeType) {
        return false;
    }
    return nodeType.isBlock;
};
/**
 * Filters text (e.g. from code blocks) that include new lines - convert to hardBreaks
 */
var filterText = function (acc, node) {
    var text = node.text;
    if (!text || node.type !== 'text') {
        return;
    }
    var lines = text.split('\n');
    return lines.reduce(function (acc, line, index) {
        if (index > 0) {
            acc.push({
                type: 'hardBreak',
            });
        }
        acc.push(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, node, { text: line }));
        return acc;
    }, acc);
};
var filterContent = function (content, types, schema, breakBetweenBlocks) {
    return content.reduce(function (acc, node, index) {
        if (types.has(node.type)) {
            if (node.content) {
                acc.push(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, node, { content: filterContent(node.content, types) }));
            }
            else if (node.type === 'text') {
                filterText(acc, node);
            }
            else {
                acc.push(node);
            }
        }
        else if (node.content) {
            if (breakBetweenBlocks && acc.length > 0 && isBlockNode(node, schema)) {
                // Seperate blocks with hard breaks
                acc.push({
                    type: 'hardBreak',
                });
            }
            filterContent(node.content, types).forEach(function (child) { return acc.push(child); });
        }
        return acc;
    }, []);
};
var filterContentByType = function (doc, types, schema, breakBetweenBlocks) {
    var content = doc.content;
    if (!content) {
        return [];
    }
    return filterContent(content, types, schema, breakBetweenBlocks);
};
var filterSliceByType = function (slice, types, schema, breakBetweenBlocks) {
    var jsonSlice = slice.toJSON();
    if (!jsonSlice) {
        return slice;
    }
    var content = jsonSlice.content;
    var filteredContent = filterContent(content, types, schema, breakBetweenBlocks);
    return __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"].fromJSON(schema, { content: filteredContent });
};
//# sourceMappingURL=filter.js.map

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(2357);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__base__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__block_type__ = __webpack_require__(800);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__block_type__["a"]; });
/* unused harmony reexport blockPluginStateKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clear_marks_on_change_to_empty_document__ = __webpack_require__(2369);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__clear_marks_on_change_to_empty_document__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__code_block__ = __webpack_require__(2370);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__code_block__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__collab_edit__ = __webpack_require__(2383);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_4__collab_edit__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__confluence_inline_comment__ = __webpack_require__(2390);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__confluence_inline_comment__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__date__ = __webpack_require__(2391);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__date__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__emoji__ = __webpack_require__(2462);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_7__emoji__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__extension__ = __webpack_require__(2472);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_8__extension__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fake_text_cursor__ = __webpack_require__(2483);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_9__fake_text_cursor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__help_dialog__ = __webpack_require__(554);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_10__help_dialog__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hyperlink__ = __webpack_require__(2488);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_11__hyperlink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__image_upload__ = __webpack_require__(2521);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_12__image_upload__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__insert_block__ = __webpack_require__(2525);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_13__insert_block__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__is_multiline_content__ = __webpack_require__(846);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_14__is_multiline_content__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__jira_issue__ = __webpack_require__(2534);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_15__jira_issue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__layout__ = __webpack_require__(845);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_16__layout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lists__ = __webpack_require__(2577);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_17__lists__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__macro__ = __webpack_require__(165);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_18__macro__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__max_content_size__ = __webpack_require__(219);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_19__max_content_size__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__media__ = __webpack_require__(850);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_20__media__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mentions__ = __webpack_require__(297);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_21__mentions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__panel__ = __webpack_require__(2635);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_22__panel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__paste__ = __webpack_require__(2641);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_23__paste__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__placeholder__ = __webpack_require__(2700);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_24__placeholder__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__placeholder_text__ = __webpack_require__(448);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_25__placeholder_text__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__rule__ = __webpack_require__(2701);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_26__rule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__quick_insert__ = __webpack_require__(838);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_27__quick_insert__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__save_on_enter__ = __webpack_require__(2704);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_28__save_on_enter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__submit_editor__ = __webpack_require__(2705);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_29__submit_editor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__table__ = __webpack_require__(822);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_30__table__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__tasks_and_decisions__ = __webpack_require__(2706);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_31__tasks_and_decisions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__text_color__ = __webpack_require__(873);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_32__text_color__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__text_formatting__ = __webpack_require__(2749);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_33__text_formatting__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__type_ahead__ = __webpack_require__(2756);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_34__type_ahead__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__unsupported_content__ = __webpack_require__(2762);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_35__unsupported_content__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__width__ = __webpack_require__(114);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_36__width__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__gap_cursor__ = __webpack_require__(213);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_37__gap_cursor__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__inline_action__ = __webpack_require__(2766);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_38__inline_action__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__card__ = __webpack_require__(2767);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_39__card__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__floating_toolbar__ = __webpack_require__(2770);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_40__floating_toolbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__status__ = __webpack_require__(2772);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_41__status__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__grid__ = __webpack_require__(298);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_42__grid__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__breakout__ = __webpack_require__(2775);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_43__breakout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__alignment__ = __webpack_require__(2776);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_44__alignment__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__editor_disabled__ = __webpack_require__(106);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_45__editor_disabled__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__indentation__ = __webpack_require__(2786);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_46__indentation__["a"]; });
















































//# sourceMappingURL=index.js.map

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_quote__ = __webpack_require__(2361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_quote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_quote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Toolbar__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pm_plugins_keymap__ = __webpack_require__(2362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pm_plugins_input_rule__ = __webpack_require__(2364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_ToolbarBlockType__ = __webpack_require__(2365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commands__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types__ = __webpack_require__(125);
/* unused harmony reexport pluginKey */











var blockType = {
    nodes: function (_a) {
        var allowBlockType = _a.allowBlockType;
        var nodes = [
            { name: 'heading', node: __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__["G" /* heading */] },
            { name: 'blockquote', node: __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__["f" /* blockquote */] },
            { name: 'hardBreak', node: __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__["F" /* hardBreak */] },
        ];
        if (allowBlockType) {
            var exclude_1 = allowBlockType.exclude ? allowBlockType.exclude : [];
            return nodes.filter(function (node) { return exclude_1.indexOf(node.name) === -1; });
        }
        return nodes;
    },
    pmPlugins: function () {
        return [
            {
                name: 'blockType',
                plugin: function (_a) {
                    var props = _a.props, dispatch = _a.dispatch;
                    return Object(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["a" /* createPlugin */])(dispatch, props.appearance);
                },
            },
            {
                name: 'blockTypeInputRule',
                plugin: function (_a) {
                    var schema = _a.schema;
                    return Object(__WEBPACK_IMPORTED_MODULE_6__pm_plugins_input_rule__["a" /* default */])(schema);
                },
            },
            // Needs to be lower priority than prosemirror-tables.tableEditing
            // plugin as it is currently swallowing right/down arrow events inside tables
            {
                name: 'blockTypeKeyMap',
                plugin: function (_a) {
                    var schema = _a.schema;
                    return Object(__WEBPACK_IMPORTED_MODULE_5__pm_plugins_keymap__["a" /* default */])(schema);
                },
            },
        ];
    },
    primaryToolbarComponent: function (_a) {
        var editorView = _a.editorView, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, popupsScrollableElement = _a.popupsScrollableElement, toolbarSize = _a.toolbarSize, disabled = _a.disabled, isToolbarReducedSpacing = _a.isToolbarReducedSpacing, eventDispatcher = _a.eventDispatcher;
        var isSmall = toolbarSize < __WEBPACK_IMPORTED_MODULE_3__ui_Toolbar__["a" /* ToolbarSize */].XL;
        var boundSetBlockType = function (name) {
            return Object(__WEBPACK_IMPORTED_MODULE_9__commands__["c" /* setBlockType */])(name)(editorView.state, editorView.dispatch);
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ui_WithPluginState__["a" /* default */], { editorView: editorView, eventDispatcher: eventDispatcher, plugins: {
                pluginState: __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["b" /* pluginKey */],
            }, render: function (_a) {
                var pluginState = _a.pluginState;
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ui_ToolbarBlockType__["a" /* default */], { isSmall: isSmall, isDisabled: disabled, isReducedSpacing: isToolbarReducedSpacing, setBlockType: boundSetBlockType, pluginState: pluginState, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }));
            } }));
    },
    pluginsOptions: {
        quickInsert: function (_a) {
            var formatMessage = _a.formatMessage;
            return [
                {
                    title: formatMessage(__WEBPACK_IMPORTED_MODULE_10__types__["p" /* messages */].blockquote),
                    priority: 1300,
                    icon: function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_quote___default.a, { label: formatMessage(__WEBPACK_IMPORTED_MODULE_10__types__["p" /* messages */].blockquote) })); },
                    action: function (insert, state) {
                        return insert(state.schema.nodes.blockquote.createChecked({}, state.schema.nodes.paragraph.createChecked()));
                    },
                },
            ];
        },
    },
};
/* harmony default export */ __webpack_exports__["a"] = (blockType);

//# sourceMappingURL=index.js.map

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return insertBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__analytics__ = __webpack_require__(20);



var insertBlock = function (state, nodeType, nodeName, start, end, attrs) {
    // To ensure that match is done after HardBreak.
    var _a = state.schema.nodes, hardBreak = _a.hardBreak, codeBlock = _a.codeBlock, listItem = _a.listItem;
    var $pos = state.doc.resolve(start);
    if ($pos.nodeAfter.type !== hardBreak) {
        return null;
    }
    // To ensure no nesting is done. (unless we're inserting a codeBlock inside lists)
    if ($pos.depth > 1 &&
        !(nodeType === codeBlock && Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["hasParentNodeOfType"])(listItem)(state.selection))) {
        return null;
    }
    // Track event
    __WEBPACK_IMPORTED_MODULE_2__analytics__["a" /* analyticsService */].trackEvent("atlassian.editor.format." + nodeName + ".autoformatting");
    // Split at the start of autoformatting and delete formatting characters.
    var tr = state.tr.delete(start, end).split(start);
    var currentNode = tr.doc.nodeAt(start + 1);
    // If node has more content split at the end of autoformatting.
    var nodeHasMoreContent = false;
    tr.doc.nodesBetween(start, start + currentNode.nodeSize, function (node, pos) {
        if (!nodeHasMoreContent && node.type === hardBreak) {
            nodeHasMoreContent = true;
            tr = tr.split(pos + 1).delete(pos, pos + 1);
        }
    });
    if (nodeHasMoreContent) {
        currentNode = tr.doc.nodeAt(start + 1);
    }
    // Create new node and fill with content of current node.
    var _b = state.schema.nodes, blockquote = _b.blockquote, paragraph = _b.paragraph;
    var content;
    var depth;
    if (nodeType === blockquote) {
        depth = 3;
        content = [paragraph.create({}, currentNode.content)];
    }
    else {
        depth = 2;
        content = currentNode.content;
    }
    var newNode = nodeType.create(attrs, content);
    // Add new node.
    tr = tr
        .setSelection(new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["NodeSelection"](tr.doc.resolve(start + 1)))
        .replaceSelectionWith(newNode)
        .setSelection(new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["TextSelection"](tr.doc.resolve(start + depth)));
    return tr;
};
//# sourceMappingURL=insert-block.js.map

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = transformToCodeBlockAction;
/* harmony export (immutable) */ __webpack_exports__["a"] = isConvertableToCodeBlock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_slice__ = __webpack_require__(104);

function transformToCodeBlockAction(state, attrs) {
    var codeBlock = state.schema.nodes.codeBlock;
    if (state.selection.empty) {
        var startOfCodeBlockText = state.selection.$from;
        var parentPos = startOfCodeBlockText.before();
        var end = startOfCodeBlockText.end();
        var slice = Object(__WEBPACK_IMPORTED_MODULE_0__utils_slice__["e" /* mapSlice */])(state.doc.slice(startOfCodeBlockText.pos, end), function (node) {
            if (node.type === state.schema.nodes.hardBreak) {
                return state.schema.text('\n');
            }
            if (node.isText) {
                return node.mark([]);
            }
            else if (node.isInline) {
                return node.attrs.text ? state.schema.text(node.attrs.text) : null;
            }
            else {
                return node.content.childCount ? node.content : null;
            }
        });
        var tr = state.tr.replaceRange(startOfCodeBlockText.pos, end, slice);
        // If our offset isnt at 3 (backticks) at the start of line, cater for content.
        if (startOfCodeBlockText.parentOffset >= 3) {
            return tr.split(startOfCodeBlockText.pos, undefined, [
                { type: codeBlock, attrs: attrs },
            ]);
        }
        return tr.setNodeMarkup(parentPos, codeBlock, attrs);
    }
    return state.tr;
}
function isConvertableToCodeBlock(state) {
    // Before a document is loaded, there is no selection.
    if (!state.selection) {
        return false;
    }
    var $from = state.selection.$from;
    var node = $from.parent;
    if (!node.isTextblock || node.type === state.schema.nodes.codeBlock) {
        return false;
    }
    var parentDepth = $from.depth - 1;
    var parentNode = $from.node(parentDepth);
    var index = $from.index(parentDepth);
    return parentNode.canReplaceWith(index, index + 1, state.schema.nodes.codeBlock);
}
//# sourceMappingURL=transform-to-code-block.js.map

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorCodeIcon = function EditorCodeIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M10.208 7.308a1.09 1.09 0 0 1 0 1.483l-3.515 3.71 3.515 3.708a1.09 1.09 0 0 1 0 1.483.957.957 0 0 1-1.405 0l-3.866-4.08a1.635 1.635 0 0 1 0-2.225l3.866-4.08a.957.957 0 0 1 1.405 0zm3.584 0a.957.957 0 0 1 1.405 0l3.866 4.08c.583.614.583 1.61 0 2.225l-3.866 4.08a.957.957 0 0 1-1.405 0 1.09 1.09 0 0 1 0-1.484l3.515-3.708-3.515-3.71a1.09 1.09 0 0 1 0-1.483z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorCodeIcon.displayName = 'EditorCodeIcon';
var _default = EditorCodeIcon;
exports.default = _default;

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPluginState */
/* unused harmony export setPluginState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluginKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nodeviews_code_block__ = __webpack_require__(2371);




var getPluginState = function (state) {
    return pluginKey.getState(state);
};
var setPluginState = function (stateProps) { return function (state, dispatch) {
    var pluginState = getPluginState(state);
    dispatch(state.tr.setMeta(pluginKey, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, stateProps)));
    return true;
}; };
var pluginKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('codeBlockPlugin');
var createPlugin = function (_a) {
    var portalProviderAPI = _a.portalProviderAPI, dispatch = _a.dispatch, providerFactory = _a.providerFactory;
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        state: {
            init: function (config, state) {
                return {
                    toolbarVisible: false,
                };
            },
            apply: function (tr, pluginState, oldState, newState) {
                var nextPluginState = tr.getMeta(pluginKey);
                if (nextPluginState) {
                    dispatch(pluginKey, nextPluginState);
                    return nextPluginState;
                }
                return pluginState;
            },
        },
        key: pluginKey,
        view: function (view) {
            return {
                update: function (view, prevState) {
                    var _a = view.state, selection = _a.selection, codeBlock = _a.schema.nodes.codeBlock;
                    var pluginState = getPluginState(view.state);
                    var parentDOM = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["findParentDomRefOfType"])(codeBlock, view.domAtPos.bind(view))(selection);
                    if (parentDOM !== pluginState.element) {
                        var parent_1 = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["findParentNodeOfType"])(codeBlock)(selection);
                        var newState = {
                            element: parentDOM,
                            toolbarVisible: !!parent_1,
                        };
                        setPluginState(newState)(view.state, view.dispatch);
                        return true;
                    }
                    /** Plugin dispatch needed to reposition the toolbar */
                    dispatch(pluginKey, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState));
                },
            };
        },
        props: {
            nodeViews: {
                codeBlock: __WEBPACK_IMPORTED_MODULE_3__nodeviews_code_block__["a" /* default */],
            },
            handleDOMEvents: {
                blur: function (view, event) {
                    var pluginState = getPluginState(view.state);
                    if (pluginState.toolbarVisible) {
                        setPluginState({
                            toolbarVisible: false,
                            element: null,
                        })(view.state, view.dispatch);
                        return true;
                    }
                    return false;
                },
            },
        },
    });
};
//# sourceMappingURL=main.js.map

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createBreakoutToolbarItems;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_icon_glyph_editor_media_full_width__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_icon_glyph_editor_media_full_width___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__atlaskit_icon_glyph_editor_media_full_width__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_media_wide__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_media_wide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_media_wide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_media_center__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_media_center___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_media_center__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__messages__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commands_remove_breakout__ = __webpack_require__(2374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commands_set_breakout_mode__ = __webpack_require__(2375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__get_breakout_mode__ = __webpack_require__(2376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__is_breakout_mark_allowed__ = __webpack_require__(2377);








function createBreakoutToolbarItems(state, _a) {
    var formatMessage = _a.formatMessage;
    if (!Object(__WEBPACK_IMPORTED_MODULE_7__is_breakout_mark_allowed__["a" /* isBreakoutMarkAllowed */])(state)) {
        return false;
    }
    var breakoutMode = Object(__WEBPACK_IMPORTED_MODULE_6__get_breakout_mode__["a" /* getBreakoutMode */])(state);
    var centerButton = {
        type: 'button',
        icon: __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_media_center___default.a,
        onClick: Object(__WEBPACK_IMPORTED_MODULE_4__commands_remove_breakout__["a" /* removeBreakout */])(),
        title: formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].layoutFixedWidth),
        selected: !breakoutMode,
    };
    var wideButton = {
        type: 'button',
        icon: __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_media_wide___default.a,
        onClick: Object(__WEBPACK_IMPORTED_MODULE_5__commands_set_breakout_mode__["a" /* setBreakoutMode */])('wide'),
        title: formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].layoutWide),
        selected: breakoutMode === 'wide',
    };
    var fullWidthButton = {
        type: 'button',
        icon: __WEBPACK_IMPORTED_MODULE_0__atlaskit_icon_glyph_editor_media_full_width___default.a,
        onClick: Object(__WEBPACK_IMPORTED_MODULE_5__commands_set_breakout_mode__["a" /* setBreakoutMode */])('full-width'),
        title: formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].layoutFullWidth),
        selected: breakoutMode === 'full-width',
    };
    return [centerButton, wideButton, fullWidthButton];
}
//# sourceMappingURL=create-breakout-toolbar-items.js.map

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorMediaCenterIcon = function EditorMediaCenterIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2zm0 12h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2zm0-8h12a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorMediaCenterIcon.displayName = 'EditorMediaCenterIcon';
var _default = EditorMediaCenterIcon;
exports.default = _default;

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluginKey; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_view__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selection__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(438);






var pluginKey = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["PluginKey"]('gapCursorPlugin');
var plugin = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
    key: pluginKey,
    // this hack fixes gap cursor alignment on each cursor movement after its been rendered to DOM
    view: function () {
        return {
            update: function (view) {
                if (view.state.selection instanceof __WEBPACK_IMPORTED_MODULE_3__selection__["a" /* GapCursorSelection */]) {
                    Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* fixCursorAlignment */])(view);
                }
            },
        };
    },
    props: {
        decorations: function (_a) {
            var doc = _a.doc, selection = _a.selection;
            if (selection instanceof __WEBPACK_IMPORTED_MODULE_3__selection__["a" /* GapCursorSelection */]) {
                var $from = selection.$from, side = selection.side;
                var node = document.createElement('span');
                node.className = "ProseMirror-gapcursor " + (side === __WEBPACK_IMPORTED_MODULE_3__selection__["c" /* Side */].LEFT ? '-left' : '-right');
                node.appendChild(document.createElement('span'));
                // render decoration DOM node always to the left of the target node even if selection points to the right
                // otherwise positioning of the right gap cursor is a nightmare when the target node has a nodeView with vertical margins
                var position = selection.head;
                if (side === __WEBPACK_IMPORTED_MODULE_3__selection__["c" /* Side */].RIGHT && $from.nodeBefore) {
                    var nodeBeforeStart = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["findPositionOfNodeBefore"])(selection);
                    if (typeof nodeBeforeStart === 'number') {
                        position = nodeBeforeStart;
                    }
                }
                return __WEBPACK_IMPORTED_MODULE_1_prosemirror_view__["DecorationSet"].create(doc, [
                    __WEBPACK_IMPORTED_MODULE_1_prosemirror_view__["Decoration"].widget(position, node, { key: "" + __WEBPACK_IMPORTED_MODULE_3__selection__["b" /* JSON_ID */], side: -1 }),
                ]);
            }
            return null;
        },
        // render gap cursor only when its valid
        createSelectionBetween: function (view, $anchor, $head) {
            if ($anchor.pos === $head.pos && __WEBPACK_IMPORTED_MODULE_3__selection__["a" /* GapCursorSelection */].valid($head)) {
                return new __WEBPACK_IMPORTED_MODULE_3__selection__["a" /* GapCursorSelection */]($head);
            }
            return;
        },
        // there's no space between top level nodes and the wrapping ProseMirror contenteditable area and handleClick won't capture clicks, there's nothing to click on
        // it handles only attempts to set gap cursor for nested nodes, where we have space between parent and child nodes
        // top level nodes are handled by <ClickAreaBlock>
        handleClick: function (view, position, event) {
            var posAtCoords = view.posAtCoords({
                left: event.clientX,
                top: event.clientY,
            });
            // this helps to ignore all of the clicks outside of the parent (e.g. nodeView controls)
            if (posAtCoords &&
                posAtCoords.inside !== position &&
                !Object(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* isIgnoredClick */])(event.target)) {
                // max available space between parent and child from the left side in px
                // this ensures the correct side of the gap cursor in case of clicking in between two block nodes
                var leftSideOffsetX = 20;
                var side = event.offsetX > leftSideOffsetX ? __WEBPACK_IMPORTED_MODULE_3__selection__["c" /* Side */].RIGHT : __WEBPACK_IMPORTED_MODULE_3__selection__["c" /* Side */].LEFT;
                return Object(__WEBPACK_IMPORTED_MODULE_5__actions__["d" /* setGapCursorAtPos */])(position, side)(view.state, view.dispatch);
            }
            return false;
        },
    },
});
/* harmony default export */ __webpack_exports__["a"] = (plugin);
//# sourceMappingURL=main.js.map

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Direction; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isBackward;
/* harmony export (immutable) */ __webpack_exports__["c"] = isForward;
/* unused harmony export toString */
var Direction;
(function (Direction) {
    Direction["UP"] = "up";
    Direction["RIGHT"] = "right";
    Direction["DOWN"] = "down";
    Direction["LEFT"] = "left";
    Direction["BACKWARD"] = "backward";
    Direction["FORWARD"] = "forward";
})(Direction || (Direction = {}));
function isBackward(dir) {
    return [Direction.UP, Direction.LEFT, Direction.BACKWARD].indexOf(dir) !== -1;
}
function isForward(dir) {
    return ([Direction.RIGHT, Direction.DOWN, Direction.FORWARD].indexOf(dir) !== -1);
}
function toString(dir) {
    return Direction[dir];
}
//# sourceMappingURL=direction.js.map

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isSelectionEntirelyInsideCodeBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isCursorInsideCodeBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getStartOfCurrentLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getEndOfCurrentLine; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getLinesFromSelection;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return forEachLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getLineInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(21);

var isSelectionEntirelyInsideCodeBlock = function (state) {
    return state.selection.$from.sameParent(state.selection.$to) &&
        state.selection.$from.parent.type === state.schema.nodes.codeBlock;
};
var isCursorInsideCodeBlock = function (state) {
    return !!Object(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* getCursor */])(state.selection) && isSelectionEntirelyInsideCodeBlock(state);
};
var getStartOfCurrentLine = function (state) {
    var $from = state.selection.$from;
    if ($from.nodeBefore && $from.nodeBefore.isText) {
        var prevNewLineIndex = $from.nodeBefore.text.lastIndexOf('\n');
        return {
            text: $from.nodeBefore.text.substring(prevNewLineIndex + 1),
            pos: $from.start() + prevNewLineIndex + 1,
        };
    }
    return { text: '', pos: $from.pos };
};
var getEndOfCurrentLine = function (state) {
    var $to = state.selection.$to;
    if ($to.nodeAfter && $to.nodeAfter.isText) {
        var nextNewLineIndex = $to.nodeAfter.text.indexOf('\n');
        return {
            text: $to.nodeAfter.text.substring(0, nextNewLineIndex >= 0 ? nextNewLineIndex : undefined),
            pos: nextNewLineIndex >= 0 ? $to.pos + nextNewLineIndex : $to.end(),
        };
    }
    return { text: '', pos: $to.pos };
};
function getLinesFromSelection(state) {
    var start = getStartOfCurrentLine(state).pos;
    var end = getEndOfCurrentLine(state).pos;
    var text = state.doc.textBetween(start, end);
    return { text: text, start: start, end: end };
}
var forEachLine = function (text, callback) {
    var offset = 0;
    text.split('\n').forEach(function (line) {
        callback(line, offset);
        offset += line.length + 1;
    });
};
var SPACE = { token: ' ', size: 2, regex: /[^ ]/ };
var TAB = { token: '\t', size: 1, regex: /[^\t]/ };
var getLineInfo = function (line) {
    var indentToken = line.startsWith('\t') ? TAB : SPACE;
    var indentLength = line.search(indentToken.regex);
    var indentText = line.substring(0, indentLength >= 0 ? indentLength : line.length);
    return { indentToken: indentToken, indentText: indentText };
};
//# sourceMappingURL=line-handling.js.map

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluginKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPlugin; });
/* unused harmony export PluginState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_view__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_transform__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_transform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_transform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(2384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__participants__ = __webpack_require__(2385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(284);







var pluginKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('collabEditPlugin');
var createPlugin = function (dispatch, providerFactory, options) {
    var collabEditProvider;
    var isReady = false;
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        key: pluginKey,
        state: {
            init: PluginState.init,
            apply: function (tr, prevPluginState, oldState, newState) {
                var pluginState = prevPluginState.apply(tr);
                if (tr.getMeta('isRemote') !== true) {
                    if (collabEditProvider) {
                        collabEditProvider.send(tr, oldState, newState);
                    }
                }
                var prevActiveParticipants = prevPluginState.activeParticipants;
                var activeParticipants = pluginState.activeParticipants, sessionId = pluginState.sessionId;
                if (collabEditProvider) {
                    var selectionChanged = !oldState.selection.eq(newState.selection);
                    var participantsChanged = !prevActiveParticipants.eq(activeParticipants);
                    if ((sessionId && selectionChanged && !tr.docChanged) ||
                        (sessionId && participantsChanged)) {
                        var selection = Object(__WEBPACK_IMPORTED_MODULE_4__actions__["b" /* getSendableSelection */])(newState.selection);
                        // Delay sending selection till next tick so that participants info
                        // can go before it
                        window.setTimeout(collabEditProvider.sendMessage.bind(collabEditProvider), 0, {
                            type: 'telepointer',
                            selection: selection,
                            sessionId: sessionId,
                        });
                    }
                }
                dispatch(pluginKey, { activeParticipants: activeParticipants, sessionId: sessionId });
                return pluginState;
            },
        },
        props: {
            decorations: function (state) {
                return this.getState(state).decorations;
            },
        },
        filterTransaction: function (tr, state) {
            // Don't allow transactions that modifies the document before
            // collab-plugin is ready.
            if (!isReady && tr.docChanged) {
                return false;
            }
            return true;
        },
        view: function (view) {
            var _this = this;
            providerFactory.subscribe('collabEditProvider', function (name, providerPromise) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](_this, void 0, void 0, function () {
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!providerPromise) return [3 /*break*/, 2];
                            return [4 /*yield*/, providerPromise];
                        case 1:
                            collabEditProvider = _a.sent();
                            // Initialize provider
                            collabEditProvider
                                .on('init', function (data) {
                                isReady = true;
                                Object(__WEBPACK_IMPORTED_MODULE_4__actions__["d" /* handleInit */])(data, view, options);
                            })
                                .on('connected', function (data) { return Object(__WEBPACK_IMPORTED_MODULE_4__actions__["c" /* handleConnection */])(data, view); })
                                .on('data', function (data) { return Object(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* applyRemoteData */])(data, view, options); })
                                .on('presence', function (data) { return Object(__WEBPACK_IMPORTED_MODULE_4__actions__["e" /* handlePresence */])(data, view); })
                                .on('telepointer', function (data) { return Object(__WEBPACK_IMPORTED_MODULE_4__actions__["f" /* handleTelePointer */])(data, view); })
                                .on('local-steps', function (data) {
                                var steps = data.steps;
                                var state = view.state;
                                var tr = state.tr;
                                steps.forEach(function (step) { return tr.step(step); });
                                var newState = state.apply(tr);
                                view.updateState(newState);
                            })
                                .on('error', function (err) {
                                // TODO: Handle errors property (ED-2580)
                            })
                                .initialize(function () { return view.state; }, function (json) { return __WEBPACK_IMPORTED_MODULE_3_prosemirror_transform__["Step"].fromJSON(view.state.schema, json); });
                            return [3 /*break*/, 3];
                        case 2:
                            collabEditProvider = null;
                            isReady = false;
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            }); });
            return {
                destroy: function () {
                    providerFactory.unsubscribeAll('collabEditProvider');
                    collabEditProvider = null;
                },
            };
        },
    });
};
var isReplaceStep = function (step) { return step instanceof __WEBPACK_IMPORTED_MODULE_3_prosemirror_transform__["ReplaceStep"]; };
/**
 * Returns position where it's possible to place a decoration.
 */
var getValidPos = function (tr, pos) {
    var resolvedPos = tr.doc.resolve(pos);
    var backwardSelection = __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Selection"].findFrom(resolvedPos, -1, true);
    // if there's no correct cursor position before the `pos`, we try to find it after the `pos`
    var forwardSelection = __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Selection"].findFrom(resolvedPos, 1, true);
    return backwardSelection
        ? backwardSelection.from
        : forwardSelection
            ? forwardSelection.from
            : pos;
};
var PluginState = /** @class */ (function () {
    function PluginState(decorations, participants, sessionId) {
        this.decorationSet = decorations;
        this.participants = participants;
        this.sid = sessionId;
    }
    Object.defineProperty(PluginState.prototype, "decorations", {
        get: function () {
            return this.decorationSet;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PluginState.prototype, "activeParticipants", {
        get: function () {
            return this.participants;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PluginState.prototype, "sessionId", {
        get: function () {
            return this.sid;
        },
        enumerable: true,
        configurable: true
    });
    PluginState.prototype.getInitial = function (sessionId) {
        var participant = this.participants.get(sessionId);
        return participant ? participant.name.substring(0, 1).toUpperCase() : 'X';
    };
    PluginState.prototype.apply = function (tr) {
        var _this = this;
        var _a = this, decorationSet = _a.decorationSet, participants = _a.participants, sid = _a.sid;
        var presenceData = tr.getMeta('presence');
        var telepointerData = tr.getMeta('telepointer');
        var sessionIdData = tr.getMeta('sessionId');
        if (sessionIdData) {
            sid = sessionIdData.sid;
        }
        var add = [];
        var remove = [];
        if (presenceData) {
            var _b = presenceData.joined, joined = _b === void 0 ? [] : _b, _c = presenceData.left, left = _c === void 0 ? [] : _c;
            participants = participants.remove(left.map(function (i) { return i.sessionId; }));
            participants = participants.add(joined);
            // Remove telepointers for users that left
            left.forEach(function (i) {
                var pointers = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* findPointers */])(i.sessionId, decorationSet);
                if (pointers) {
                    remove = remove.concat(pointers);
                }
            });
        }
        if (telepointerData) {
            var sessionId = telepointerData.sessionId;
            if (participants.get(sessionId) && sessionId !== sid) {
                var oldPointers = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* findPointers */])(telepointerData.sessionId, decorationSet);
                if (oldPointers) {
                    remove = remove.concat(oldPointers);
                }
                var _d = telepointerData.selection, anchor = _d.anchor, head = _d.head;
                var rawFrom = anchor < head ? anchor : head;
                var rawTo = anchor >= head ? anchor : head;
                var isSelection = rawTo - rawFrom > 0;
                var from = 1;
                var to = 1;
                try {
                    from = getValidPos(tr, isSelection ? Math.max(rawFrom - 1, 0) : rawFrom);
                    to = isSelection ? getValidPos(tr, rawTo) : from;
                }
                catch (err) { }
                add = add.concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* createTelepointers */])(from, to, sessionId, isSelection, this.getInitial(sessionId)));
            }
        }
        if (tr.docChanged) {
            // Adjust decoration positions to changes made by the transaction
            try {
                decorationSet = decorationSet.map(tr.mapping, tr.doc, {
                    // Reapplies decorators those got removed by the state change
                    onRemove: function (spec) {
                        if (spec.pointer && spec.pointer.sessionId) {
                            var step = tr.steps.filter(isReplaceStep)[0];
                            if (step) {
                                var sessionId = spec.pointer.sessionId;
                                var _a = step, size = _a.slice.content.size, from = _a.from;
                                var pos = getValidPos(tr, size
                                    ? Math.min(from + size, tr.doc.nodeSize - 3)
                                    : Math.max(from, 1));
                                add = add.concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* createTelepointers */])(pos, pos, sessionId, false, _this.getInitial(sessionId)));
                            }
                        }
                    },
                });
            }
            catch (err) { }
            // Remove any selection decoration within the change range,
            // takes care of the issue when after pasting we end up with a dead selection
            tr.steps.filter(isReplaceStep).forEach(function (s) {
                var _a = s, from = _a.from, to = _a.to;
                decorationSet.find(from, to).forEach(function (deco) {
                    // `type` is private, `from` and `to` are public in latest version
                    // `from` != `to` means it's a selection
                    if (deco.from !== deco.to) {
                        remove.push(deco);
                    }
                });
            });
        }
        if (remove.length) {
            decorationSet = decorationSet.remove(remove);
        }
        if (add.length) {
            decorationSet = decorationSet.add(tr.doc, add);
        }
        return new PluginState(decorationSet, participants, sid);
    };
    PluginState.init = function (config) {
        var doc = config.doc;
        return new PluginState(__WEBPACK_IMPORTED_MODULE_2_prosemirror_view__["DecorationSet"].create(doc, []), new __WEBPACK_IMPORTED_MODULE_5__participants__["a" /* Participants */]());
    };
    return PluginState;
}());

//# sourceMappingURL=plugin.js.map

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorDateIcon = function EditorDateIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M6 8.51c0-.282.229-.51.5-.51h11c.276 0 .5.228.5.51v8.98c0 .282-.229.51-.5.51h-11a.505.505 0 0 1-.5-.51V8.51zm2 2.995v.99c0 .291.226.505.505.505h.99a.497.497 0 0 0 .505-.505v-.99A.497.497 0 0 0 9.495 11h-.99a.497.497 0 0 0-.505.505zm3 0v.99c0 .291.226.505.505.505h.99a.497.497 0 0 0 .505-.505v-.99a.497.497 0 0 0-.505-.505h-.99a.497.497 0 0 0-.505.505zm-3 3v.99c0 .291.226.505.505.505h.99a.497.497 0 0 0 .505-.505v-.99A.497.497 0 0 0 9.495 14h-.99a.497.497 0 0 0-.505.505zM7.5 8v1h3V8h-3zm6 0v1h3V8h-3zm.5-1.495c0-.279.214-.505.505-.505h.99c.279 0 .505.214.505.505V8h-2V6.505zm-6 0C8 6.226 8.214 6 8.505 6h.99c.279 0 .505.214.505.505V8H8V6.505z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorDateIcon.displayName = 'EditorDateIcon';
var _default = EditorDateIcon;
exports.default = _default;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorAddIcon = function EditorAddIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M13 11V7a1 1 0 0 0-2 0v4H7a1 1 0 0 0 0 2h4v4a1 1 0 0 0 2 0v-4h4a1 1 0 0 0 0-2h-4z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorAddIcon.displayName = 'EditorAddIcon';
var _default = EditorAddIcon;
exports.default = _default;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorTableIcon = function EditorTableIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M8 6h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm0 2v3h3V8H8zm5 0v3h3V8h-3zm-5 5v3h3v-3H8zm5 0v3h3v-3h-3z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorTableIcon.displayName = 'EditorTableIcon';
var _default = EditorTableIcon;
exports.default = _default;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorImageIcon = function EditorImageIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M11 15l-1-1-2 2h8v-1.8L14 12l-3 3zM6 6.5c0-.276.229-.5.5-.5h11c.276 0 .5.229.5.5v11c0 .276-.229.5-.5.5h-11a.504.504 0 0 1-.5-.5v-11zM9.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorImageIcon.displayName = 'EditorImageIcon';
var _default = EditorImageIcon;
exports.default = _default;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var LabelIcon = function LabelIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M11.433 5.428l-4.207.6A2 2 0 0 0 5.53 7.727l-.6 4.207a1 1 0 0 0 .281.849l6.895 6.894a.999.999 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0 0-1.414L12.282 5.71a.998.998 0 0 0-.849-.283m-.647 5.858A1.666 1.666 0 1 1 8.43 8.929a1.666 1.666 0 0 1 2.357 2.357\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

LabelIcon.displayName = 'LabelIcon';
var _default = LabelIcon;
exports.default = _default;

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateRightShadow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf_schd__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_TableFloatingControls__ = __webpack_require__(2407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_TableFloatingControls_ColumnControls__ = __webpack_require__(2411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pm_plugins_main__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pm_plugins_table_resizing__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(68);










var isIE11 = __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["E" /* browser */].ie_version === 11;

var TableComponent = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](TableComponent, _super);
    function TableComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            scroll: 0,
            tableContainerWidth: 'inherit',
        };
        _this.handleScroll = function (event) {
            if (!_this.wrapper || event.target !== _this.wrapper) {
                return;
            }
            _this.setState({ scroll: _this.wrapper.scrollLeft });
        };
        _this.handleScrollDebounced = Object(__WEBPACK_IMPORTED_MODULE_2_raf_schd__["a" /* default */])(_this.handleScroll);
        // Disable inline table editing and resizing controls in Firefox
        // https://github.com/ProseMirror/prosemirror/issues/432
        if ('execCommand' in document) {
            ['enableObjectResizing', 'enableInlineTableEditing'].forEach(function (cmd) {
                if (document.queryCommandSupported(cmd)) {
                    document.execCommand(cmd, false, 'false');
                }
            });
        }
        return _this;
    }
    TableComponent.prototype.componentDidMount = function () {
        var _a = this.props, onComponentMount = _a.onComponentMount, allowColumnResizing = _a.allowColumnResizing;
        onComponentMount();
        if (allowColumnResizing && this.wrapper && !isIE11) {
            this.wrapper.addEventListener('scroll', this.handleScrollDebounced);
        }
        if (allowColumnResizing) {
            var _b = this.props, node_1 = _b.node, containerWidth_1 = _b.containerWidth;
            Object(__WEBPACK_IMPORTED_MODULE_7__pm_plugins_table_resizing__["d" /* setColumnWidths */])(this.table, node_1, containerWidth_1.width, node_1.attrs.layout);
            this.setState(function () { return ({
                tableContainerWidth: Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["K" /* calcTableWidth */])(node_1.attrs.layout, containerWidth_1.width),
            }); });
        }
    };
    TableComponent.prototype.componentWillUnmount = function () {
        if (this.wrapper && !isIE11) {
            this.wrapper.removeEventListener('scroll', this.handleScrollDebounced);
        }
        this.handleScrollDebounced.cancel();
    };
    TableComponent.prototype.componentDidUpdate = function (prevProps) {
        updateRightShadow(this.wrapper, this.table, this.rightShadow);
        if (this.props.allowColumnResizing && this.table) {
            this.handleTableResizing(prevProps);
        }
    };
    TableComponent.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, view = _b.view, node = _b.node, pluginState = _b.pluginState, tableResizingPluginState = _b.tableResizingPluginState, width = _b.width;
        var _c = pluginState.pluginConfig.allowControls, allowControls = _c === void 0 ? true : _c;
        // doesn't work well with WithPluginState
        var _d = Object(__WEBPACK_IMPORTED_MODULE_6__pm_plugins_main__["d" /* getPluginState */])(view.state), isInDanger = _d.isInDanger, hoveredColumns = _d.hoveredColumns, hoveredRows = _d.hoveredRows, insertColumnButtonIndex = _d.insertColumnButtonIndex, insertRowButtonIndex = _d.insertRowButtonIndex;
        var tableRef = this.table || undefined;
        var tableActive = this.table === pluginState.tableRef;
        var isResizing = !!tableResizingPluginState && !!tableResizingPluginState.dragging;
        var scroll = this.state.scroll;
        var rowControls = [
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: 0, className: __WEBPACK_IMPORTED_MODULE_8__types__["a" /* TableCssClassName */].ROW_CONTROLS_WRAPPER + " " + (scroll > 0 ? __WEBPACK_IMPORTED_MODULE_8__types__["a" /* TableCssClassName */].TABLE_LEFT_SHADOW : '') },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ui_TableFloatingControls__["a" /* default */], { editorView: view, tableRef: tableRef, tableActive: tableActive, hoveredRows: hoveredRows, isInDanger: isInDanger, isResizing: isResizing, isNumberColumnEnabled: node.attrs.isNumberColumnEnabled, isHeaderColumnEnabled: Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* checkIfHeaderColumnEnabled */])(view.state), isHeaderRowEnabled: Object(__WEBPACK_IMPORTED_MODULE_10__utils__["b" /* checkIfHeaderRowEnabled */])(view.state), hasHeaderRow: Object(__WEBPACK_IMPORTED_MODULE_10__utils__["d" /* containsHeaderRow */])(view.state, node), 
                    // pass `selection` and `tableHeight` to control re-render
                    selection: view.state.selection, tableHeight: tableRef ? tableRef.offsetHeight : undefined, insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex })),
        ];
        var columnControls = [
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: 0, className: __WEBPACK_IMPORTED_MODULE_8__types__["a" /* TableCssClassName */].COLUMN_CONTROLS_WRAPPER },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ui_TableFloatingControls_ColumnControls__["a" /* default */], { editorView: view, tableRef: tableRef, ref: function (elem) { return (_this.columnControls = elem); }, hoveredColumns: hoveredColumns, isInDanger: isInDanger, isResizing: isResizing, 
                    // pass `selection` and `numberOfColumns` to control re-render
                    selection: view.state.selection, numberOfColumns: node.firstChild.childCount, insertColumnButtonIndex: insertColumnButtonIndex })),
        ];
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: {
                width: this.state.tableContainerWidth,
            }, className: __WEBPACK_IMPORTED_MODULE_9_classnames__(__WEBPACK_IMPORTED_MODULE_8__types__["a" /* TableCssClassName */].TABLE_CONTAINER, (_a = {},
                _a[__WEBPACK_IMPORTED_MODULE_8__types__["a" /* TableCssClassName */].WITH_CONTROLS] = tableActive,
                _a['less-padding'] = width < __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["s" /* akEditorMobileBreakoutPoint */],
                _a)), "data-number-column": node.attrs.isNumberColumnEnabled, "data-layout": node.attrs.layout },
            allowControls && rowControls,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_9_classnames__(__WEBPACK_IMPORTED_MODULE_8__types__["a" /* TableCssClassName */].TABLE_NODE_WRAPPER), ref: function (elem) {
                    _this.wrapper = elem;
                    _this.props.contentDOM(elem ? elem : undefined);
                    if (elem) {
                        _this.table = elem.querySelector('table');
                    }
                } }, allowControls && columnControls),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: function (elem) {
                    _this.rightShadow = elem;
                }, className: __WEBPACK_IMPORTED_MODULE_8__types__["a" /* TableCssClassName */].TABLE_RIGHT_SHADOW })));
    };
    TableComponent.prototype.handleTableResizing = function (prevProps) {
        var _a = this.props, view = _a.view, node = _a.node, getPos = _a.getPos, containerWidth = _a.containerWidth;
        var prevAttrs = prevProps.node.attrs;
        var currentAttrs = node.attrs;
        var prevColCount = prevProps.node.firstChild.childCount;
        var currentColCount = node.firstChild.childCount;
        if (prevColCount !== currentColCount ||
            prevAttrs.layout !== currentAttrs.layout ||
            prevAttrs.isNumberColumnEnabled !== currentAttrs.isNumberColumnEnabled ||
            prevProps.containerWidth !== containerWidth) {
            Object(__WEBPACK_IMPORTED_MODULE_7__pm_plugins_table_resizing__["c" /* scaleTable */])(view, this.table, node, getPos(), containerWidth.width, currentAttrs.layout);
            if (this.columnControls) {
                this.columnControls.forceUpdate();
            }
            this.setState(function () { return ({
                tableContainerWidth: Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["K" /* calcTableWidth */])(currentAttrs.layout, containerWidth.width),
            }); });
        }
    };
    return TableComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
var updateRightShadow = function (wrapper, table, rightShadow) {
    if (table && wrapper && rightShadow) {
        var diff = table.offsetWidth - wrapper.offsetWidth;
        rightShadow.style.display =
            diff > 0 && diff > wrapper.scrollLeft ? 'block' : 'none';
    }
    return;
};
/* harmony default export */ __webpack_exports__["a"] = (TableComponent);
//# sourceMappingURL=TableComponent.js.map

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(44);



var DeleteButton = function (_a) {
    var style = _a.style, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, removeLabel = _a.removeLabel, formatMessage = _a.intl.formatMessage;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2__types__["a" /* TableCssClassName */].CONTROLS_DELETE_BUTTON_WRAP, style: style, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { type: "button", title: formatMessage(removeLabel, { 0: 1 }), className: __WEBPACK_IMPORTED_MODULE_2__types__["a" /* TableCssClassName */].CONTROLS_DELETE_BUTTON, onMouseDown: onClick, onMouseMove: function (e) { return e.preventDefault(); } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg", { className: __WEBPACK_IMPORTED_MODULE_2__types__["a" /* TableCssClassName */].CONTROLS_BUTTON_ICON },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M12.242 10.828L9.414 8l2.828-2.829a.999.999 0 1 0-1.414-1.414L8 6.587l-2.829-2.83a1 1 0 0 0-1.414 1.414l2.83 2.83-2.83 2.827a1 1 0 0 0 1.414 1.414l2.83-2.828 2.827 2.828a.999.999 0 1 0 1.414-1.414", fill: "currentColor", fillRule: "evenodd" })))));
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["injectIntl"])(DeleteButton));
//# sourceMappingURL=DeleteButton.js.map

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = updateColumnWidth;
/* unused harmony export applyColumnWidths */
/* harmony export (immutable) */ __webpack_exports__["a"] = handleBreakoutContent;
/* harmony export (immutable) */ __webpack_exports__["b"] = resizeColumn;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateControls; });
/* harmony export (immutable) */ __webpack_exports__["c"] = scaleTable;
/* harmony export (immutable) */ __webpack_exports__["d"] = setColumnWidths;
/* unused harmony export resizeColumnTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_tables__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__resizer_utils__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resizer_resizer__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__nodeviews_TableComponent__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(821);










function updateColumnWidth(view, cell, movedWidth, resizer) {
    var $cell = view.state.doc.resolve(cell);
    var table = $cell.node(-1);
    var map = __WEBPACK_IMPORTED_MODULE_1_prosemirror_tables__["TableMap"].get(table);
    var start = $cell.start(-1);
    var col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
    var newState = resizer.resize(col, movedWidth);
    var tr = applyColumnWidths(view, newState, table, start);
    if (tr.docChanged) {
        view.dispatch(tr);
    }
}
function applyColumnWidths(view, state, table, start) {
    var tr = view.state.tr;
    var map = __WEBPACK_IMPORTED_MODULE_1_prosemirror_tables__["TableMap"].get(table);
    for (var i = 0; i < state.cols.length; i++) {
        var width = state.cols[i].width;
        for (var row = 0; row < map.height; row++) {
            var mapIndex = row * map.width + i;
            // Rowspanning cell that has already been handled
            if (row && map.map[mapIndex] === map.map[mapIndex - map.width]) {
                continue;
            }
            var pos = map.map[mapIndex];
            var attrs = table.nodeAt(pos).attrs;
            var index = attrs.colspan === 1 ? 0 : i - map.colCount(pos);
            if (attrs.colwidth && attrs.colwidth[index] === width) {
                continue;
            }
            var colwidth = attrs.colwidth
                ? attrs.colwidth.slice()
                : Array.from({ length: attrs.colspan }, function (_) { return 0; });
            colwidth[index] = width;
            tr = tr.setNodeMarkup(start + pos, null, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, attrs, { colwidth: colwidth }));
        }
    }
    return tr;
}
function handleBreakoutContent(view, elem, start, minWidth, node) {
    var colIdx = Array.from(elem.parentNode.children).indexOf(elem);
    var cellStyle = getComputedStyle(elem);
    var amount = Object(__WEBPACK_IMPORTED_MODULE_4__resizer_utils__["a" /* addContainerLeftRightPadding */])(minWidth - elem.offsetWidth, cellStyle);
    var state = resizeColumnTo(elem, colIdx, amount, node);
    updateControls(view.state);
    var tr = applyColumnWidths(view, state, node, start);
    if (tr.docChanged) {
        view.dispatch(tr);
    }
}
function resizeColumn(view, cell, width, resizer) {
    var $cell = view.state.doc.resolve(cell);
    var table = $cell.node(-1);
    var start = $cell.start(-1);
    var col = __WEBPACK_IMPORTED_MODULE_1_prosemirror_tables__["TableMap"].get(table).colCount($cell.pos - start) +
        $cell.nodeAfter.attrs.colspan -
        1;
    var newState = resizer.resize(col, width);
    resizer.apply(newState);
    return newState;
}
/**
 * Updates the column controls on resize
 */
var updateControls = function (state) {
    var tableRef = Object(__WEBPACK_IMPORTED_MODULE_6__main__["d" /* getPluginState */])(state).tableRef;
    if (!tableRef) {
        return;
    }
    var tr = tableRef.querySelector('tr');
    if (!tr) {
        return;
    }
    var cols = tr.children;
    var wrapper = tableRef.parentElement;
    var columnControls = wrapper.querySelectorAll("." + __WEBPACK_IMPORTED_MODULE_3__types__["a" /* TableCssClassName */].COLUMN_CONTROLS_BUTTON_WRAP);
    var rows = tableRef.querySelectorAll('tr');
    var rowControls = wrapper.parentElement.querySelectorAll("." + __WEBPACK_IMPORTED_MODULE_3__types__["a" /* TableCssClassName */].ROW_CONTROLS_BUTTON_WRAP);
    var numberedRows = wrapper.parentElement.querySelectorAll(__WEBPACK_IMPORTED_MODULE_3__types__["a" /* TableCssClassName */].NUMBERED_COLUMN_BUTTON);
    // update column controls width on resize
    for (var i = 0, count = columnControls.length; i < count; i++) {
        if (cols[i]) {
            columnControls[i].style.width = cols[i].offsetWidth + 1 + "px";
        }
    }
    // update rows controls height on resize
    for (var i = 0, count = rowControls.length; i < count; i++) {
        if (rows[i]) {
            rowControls[i].style.height = rows[i].offsetHeight + 1 + "px";
            if (numberedRows.length) {
                numberedRows[i].style.height = rows[i].offsetHeight + 1 + "px";
            }
        }
    }
    Object(__WEBPACK_IMPORTED_MODULE_7__nodeviews_TableComponent__["b" /* updateRightShadow */])(wrapper, tableRef, wrapper.parentElement.querySelector("." + __WEBPACK_IMPORTED_MODULE_3__types__["a" /* TableCssClassName */].TABLE_RIGHT_SHADOW));
};
/**
 * Scale the table to meet new requirements (col, layout change etc)
 * @param view
 * @param tableElem
 * @param node
 * @param pos
 * @param containerWidth
 * @param currentLayout
 */
function scaleTable(view, tableElem, node, pos, containerWidth, currentLayout) {
    var state = setColumnWidths(tableElem, node, containerWidth, currentLayout);
    if (state) {
        var tr = applyColumnWidths(view, state, node, pos + 1);
        if (tr.docChanged) {
            view.dispatch(tr);
        }
    }
}
/**
 * Hydate a table with column widths.
 * @param tableElem
 * @param node
 * @param containerWidth
 * @param currentLayout
 */
function setColumnWidths(tableElem, node, containerWidth, currentLayout) {
    if (!tableElem) {
        return;
    }
    var maxSize = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["d" /* getLayoutSize */])(currentLayout, containerWidth);
    return scale(tableElem, node, maxSize);
}
/**
 * Light wrapper over Resizer.resize
 * Mainly used to re-set a columns width.
 * @param elem
 * @param colIdx
 * @param amount
 * @param node
 */
function resizeColumnTo(elem, colIdx, amount, node) {
    while (elem.nodeName !== 'TABLE') {
        elem = elem.parentNode;
    }
    var resizer = __WEBPACK_IMPORTED_MODULE_5__resizer_resizer__["a" /* default */].fromDOM(elem, {
        minWidth: __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["_0" /* tableCellMinWidth */],
        maxSize: elem.offsetWidth,
        node: node,
    });
    var newState = resizer.resize(colIdx, amount);
    resizer.apply(newState);
    return newState;
}
/**
 * Base function to trigger the actual scale on a table node.
 * Will only resize/scale if a table has been previously resized.
 * @param tableElem
 * @param node
 * @param maxSize
 */
function scale(tableElem, node, maxSize) {
    if (node.attrs.isNumberColumnEnabled) {
        maxSize -= __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["w" /* akEditorTableNumberColumnWidth */];
    }
    // If a table has not been resized yet, columns should be auto.
    if (Object(__WEBPACK_IMPORTED_MODULE_8__utils__["r" /* hasTableBeenResized */])(node)) {
        var resizer = __WEBPACK_IMPORTED_MODULE_5__resizer_resizer__["a" /* default */].fromDOM(tableElem, {
            minWidth: __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["_0" /* tableCellMinWidth */],
            maxSize: tableElem.offsetWidth,
            node: node,
        });
        return resizer.scale(maxSize);
    }
}
//# sourceMappingURL=actions.js.map

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resizeState__ = __webpack_require__(2413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__columnState__ = __webpack_require__(2414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(68);



function recreateResizeColsByNode(tableElem, node) {
    var colgroup = tableElem.querySelector('colgroup');
    if (colgroup) {
        tableElem.removeChild(colgroup);
    }
    colgroup = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["E" /* renderColgroupFromNode */])(node);
    tableElem.insertBefore(colgroup, tableElem.firstChild);
    return colgroup.children;
}
var Resizer = /** @class */ (function () {
    function Resizer(tableElem, colgroupChildren, config, initialState) {
        this.tableElem = tableElem;
        this.colgroupChildren = colgroupChildren;
        this.minWidth = config.minWidth;
        this.node = config.node;
        this.currentState = initialState;
    }
    /**
     * Create resizer from given DOM element
     */
    Resizer.fromDOM = function (tableElem, config) {
        var maxSize = config.maxSize, minWidth = config.minWidth, node = config.node;
        var colgroupChildren = recreateResizeColsByNode(tableElem, node);
        return new Resizer(tableElem, colgroupChildren, config, 
        // update state from DOM
        new __WEBPACK_IMPORTED_MODULE_0__resizeState__["a" /* default */](Array.from(colgroupChildren).map(function (col, i) {
            return __WEBPACK_IMPORTED_MODULE_1__columnState__["a" /* default */].fromDOM(tableElem, i, minWidth);
        }), maxSize));
    };
    /**
     * Applies a resize state to the DOM. Does NOT update state.
     */
    Resizer.prototype.apply = function (state) {
        var _this = this;
        state.cols
            .filter(function (col) { return !!col.width; }) // if width is 0, we dont want to apply that.
            .forEach(function (col, i) {
            _this.colgroupChildren[i].style.width = col.width + "px";
        });
    };
    /**
     * Applies the column resize state to the DOM, and sets it for future use.
     */
    Resizer.prototype.update = function (state) {
        this.apply(state);
        this.currentState = state;
    };
    /**
     * Resize a given column by an amount from the current state and return the new state.
     *
     * You can then either:
     * - #apply() this new state to the DOM while dragging resize handles,
     * - or #update() the resizer state when resizing is finished (typically when the user releases the resize handle)
     * @param {number} col The column index to resize
     * @param {number} amount Delta of pixels to resize by. Can be positive or negative.
     */
    Resizer.prototype.resize = function (col, amount) {
        return this.currentState.resize(col, amount);
    };
    /**
     * Scale the table to a given size, update state and DOM and return the new state.
     * @param {number} newSize the table new size
     */
    Resizer.prototype.scale = function (newSize) {
        var newState = this.currentState.scale(newSize);
        this.update(newState);
        return newState;
    };
    Resizer.prototype.getCol = function (colIdx) {
        return this.currentState.cols[colIdx];
    };
    return Resizer;
}());
/* harmony default export */ __webpack_exports__["a"] = (Resizer);
//# sourceMappingURL=resizer.js.map

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return contentWidth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(286);

/**
 * Measure text via Canvas context API.
 * @param {HTMLCanvasElement} canvas
 * @param {string} text
 * @param {string} font
 */
function measureText(canvas, text, font) {
    var ctx = canvas.getContext('2d');
    if (font) {
        ctx.font = font;
    }
    return Math.round(ctx.measureText(text || '').width);
}
function handlePreText(canvas, node, textContent, font) {
    var parent = node;
    if (node.nodeName === 'CODE') {
        parent = node.parentNode;
    }
    var computedStyle = getComputedStyle(parent);
    if (textContent && computedStyle.whiteSpace === 'pre') {
        // If white space is pre grab the longest line in the block.
        return textContent
            .split('\n')
            .reduce(function (acc, current) { return Math.max(measureText(canvas, current, font), acc); }, 0);
    }
    return measureText(canvas, textContent, font);
}
function calcContentWidth(elem, container, canvas, colWidths) {
    var flowWidths = [];
    var curWidth = 0;
    for (var i = 0; i < elem.childNodes.length; i++) {
        var child = elem.childNodes[i];
        if (child.nodeType === Node.COMMENT_NODE) {
            continue;
        }
        if (child.nodeType === Node.TEXT_NODE) {
            var parent_1 = child.parentNode;
            var parentStyle = getComputedStyle(parent_1);
            var contentLength = 0;
            if (parent_1.nodeName === 'CODE' || parent_1.nodeName === 'PRE') {
                contentLength = handlePreText(canvas, parent_1, child.textContent, parentStyle.font);
            }
            else {
                contentLength = measureText(canvas, child.textContent, parentStyle.font);
            }
            var left = parent_1.offsetLeft - container.offsetLeft;
            flowWidths.push(curWidth);
            curWidth += contentLength + left;
            // If the text isn't meant to wrap, we should set that as a hard limit.
            if (parentStyle.whiteSpace === 'nowrap') {
                // + 3 is for date offset plus cursor
                // TODO There should be a programmatic way to get this.
                colWidths.push(parent_1.offsetWidth + 3);
            }
        }
        else {
            // FIXME: doesn't quite work right with spacing
            var style = getComputedStyle(child);
            if (style.minWidth &&
                style.minWidth.endsWith('px') &&
                style.minWidth !== '0px') {
                colWidths.push(Object(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* unitToNumber */])(style.minWidth));
            }
            var width = contentWidth(child, container, colWidths, canvas).width;
            if (style.display && style.display.indexOf('inline') > -1) {
                // is inline element, add to curWidth
                curWidth += width;
            }
            else {
                // block element, reset curWidth
                flowWidths.push(curWidth);
                curWidth = width;
            }
        }
    }
    flowWidths.push(curWidth);
    return {
        minWidth: colWidths.reduce(function (oldMax, width) { return Math.max(width, oldMax); }, 0),
        width: flowWidths.reduce(function (oldMax, width) { return Math.max(width, oldMax); }, 0),
    };
}
function contentWidth(elem, container, colWidths, canvas) {
    if (colWidths === void 0) { colWidths = []; }
    if (canvas === void 0) { canvas = document.createElement('canvas'); }
    return calcContentWidth(elem, container || elem, canvas, colWidths);
}

//# sourceMappingURL=contentWidth.js.map

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getLayoutSize;
/* harmony export (immutable) */ __webpack_exports__["e"] = pointsAtCell;
/* harmony export (immutable) */ __webpack_exports__["c"] = edgeCell;
/* harmony export (immutable) */ __webpack_exports__["a"] = currentColWidth;
/* harmony export (immutable) */ __webpack_exports__["b"] = domCellAround;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_tables__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_editor_common__ = __webpack_require__(13);


var tableLayoutToSize = {
    default: __WEBPACK_IMPORTED_MODULE_1__atlaskit_editor_common__["l" /* akEditorDefaultLayoutWidth */],
    wide: __WEBPACK_IMPORTED_MODULE_1__atlaskit_editor_common__["z" /* akEditorWideLayoutWidth */],
    'full-width': undefined,
};
/**
 * Translates named layouts in number values.
 * @param tableLayout
 * @param containerWidth
 */
function getLayoutSize(tableLayout, containerWidth) {
    if (containerWidth === void 0) { containerWidth = 0; }
    var calculatedTableWidth = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_editor_common__["K" /* calcTableWidth */])(tableLayout, containerWidth);
    return calculatedTableWidth.endsWith('px')
        ? Number(calculatedTableWidth.slice(0, calculatedTableWidth.length - 2))
        : tableLayoutToSize[tableLayout] || containerWidth;
}
/**
 * Does the current position point at a cell.
 * @param $pos
 */
function pointsAtCell($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
/**
 * Returns the pos of the cell on the side requested.
 * @param view
 * @param event
 * @param side
 */
function edgeCell(view, event, side) {
    var buffer = side === 'right' ? -5 : 5; // Fixes finicky bug where posAtCoords could return wrong pos.
    var pos = view.posAtCoords({
        left: event.clientX + buffer,
        top: event.clientY,
    }).pos;
    var $cell = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_tables__["cellAround"])(view.state.doc.resolve(pos));
    if (!$cell) {
        return -1;
    }
    if (side === 'right') {
        return $cell.pos;
    }
    var map = __WEBPACK_IMPORTED_MODULE_0_prosemirror_tables__["TableMap"].get($cell.node(-1));
    var start = $cell.start(-1);
    var index = map.map.indexOf($cell.pos - start);
    return index % map.width === 0 ? -1 : start + map.map[index - 1];
}
/**
 * Get the current col width, handles colspan.
 * @param view
 * @param cellPos
 * @param param2
 */
function currentColWidth(view, cellPos, _a) {
    var colspan = _a.colspan, colwidth = _a.colwidth;
    var width = colwidth && colwidth[colwidth.length - 1];
    if (width) {
        return width;
    }
    // Not fixed, read current width from DOM
    var domWidth = view.domAtPos(cellPos + 1).node.offsetWidth;
    var parts = colspan;
    if (colwidth) {
        for (var i = 0; i < colspan; i++) {
            if (colwidth[i]) {
                domWidth -= colwidth[i];
                parts--;
            }
        }
    }
    return domWidth / parts;
}
/**
 * Attempts to find a parent TD/TH depending on target element.
 * @param target
 */
function domCellAround(target) {
    while (target && target.nodeName !== 'TD' && target.nodeName !== 'TH') {
        target = target.classList.contains('ProseMirror')
            ? null
            : target.parentNode;
    }
    return target;
}
//# sourceMappingURL=utils.js.map

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HANDLE_WIDTH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluginConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_table__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_LayoutButton__ = __webpack_require__(2415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__insert_block_ui_ToolbarInsertBlock__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pm_plugins_main__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pm_plugins_keymap__ = __webpack_require__(2418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pm_plugins_table_resizing__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__toolbar__ = __webpack_require__(2419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ui_FloatingContextualMenu__ = __webpack_require__(2421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils__ = __webpack_require__(68);
















var HANDLE_WIDTH = 6;
var pluginConfig = function (tablesConfig) {
    var config = !tablesConfig || typeof tablesConfig === 'boolean' ? {} : tablesConfig;
    return config.advanced
        ? __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ allowBackgroundColor: true, allowColumnResizing: true, allowHeaderColumn: true, allowHeaderRow: true, allowMergeCells: true, allowNumberColumn: true, stickToolbarToBottom: true, permittedLayouts: 'all', allowControls: true }, config) : config;
};
var tablesPlugin = function (options) { return ({
    nodes: function () {
        return [
            { name: 'table', node: __WEBPACK_IMPORTED_MODULE_6__atlaskit_adf_schema__["_9" /* table */] },
            { name: 'tableHeader', node: __WEBPACK_IMPORTED_MODULE_6__atlaskit_adf_schema__["_13" /* tableHeader */] },
            { name: 'tableRow', node: __WEBPACK_IMPORTED_MODULE_6__atlaskit_adf_schema__["_14" /* tableRow */] },
            { name: 'tableCell', node: __WEBPACK_IMPORTED_MODULE_6__atlaskit_adf_schema__["_12" /* tableCell */] },
        ];
    },
    pmPlugins: function () {
        return [
            {
                name: 'table',
                plugin: function (_a) {
                    var _b = _a.props, allowTables = _b.allowTables, appearance = _b.appearance, eventDispatcher = _a.eventDispatcher, dispatch = _a.dispatch, portalProviderAPI = _a.portalProviderAPI;
                    return Object(__WEBPACK_IMPORTED_MODULE_10__pm_plugins_main__["b" /* createPlugin */])(dispatch, portalProviderAPI, eventDispatcher, pluginConfig(allowTables), appearance);
                },
            },
            {
                name: 'tablePMColResizing',
                plugin: function (_a) {
                    var dispatch = _a.dispatch, allowTables = _a.props.allowTables;
                    var allowColumnResizing = pluginConfig(allowTables).allowColumnResizing;
                    return allowColumnResizing
                        ? Object(__WEBPACK_IMPORTED_MODULE_12__pm_plugins_table_resizing__["a" /* createPlugin */])(dispatch, {
                            handleWidth: HANDLE_WIDTH,
                            cellMinWidth: __WEBPACK_IMPORTED_MODULE_5__atlaskit_editor_common__["_0" /* tableCellMinWidth */],
                        })
                        : undefined;
                },
            },
            // Needs to be lower priority than prosemirror-tables.tableEditing
            // plugin as it is currently swallowing backspace events inside tables
            { name: 'tableKeymap', plugin: function () { return Object(__WEBPACK_IMPORTED_MODULE_11__pm_plugins_keymap__["a" /* keymapPlugin */])(); } },
            { name: 'tableEditing', plugin: function () { return Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["tableEditing"])(); } },
        ];
    },
    contentComponent: function (_a) {
        var editorView = _a.editorView, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, popupsScrollableElement = _a.popupsScrollableElement, appearance = _a.appearance;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ui_WithPluginState__["a" /* default */], { plugins: {
                pluginState: __WEBPACK_IMPORTED_MODULE_10__pm_plugins_main__["e" /* pluginKey */],
                tableResizingPluginState: __WEBPACK_IMPORTED_MODULE_12__pm_plugins_table_resizing__["b" /* pluginKey */],
            }, render: function (_a) {
                var pluginState = _a.pluginState, tableResizingPluginState = _a.tableResizingPluginState;
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__ui_FloatingContextualMenu__["a" /* default */], { editorView: editorView, mountPoint: popupsMountPoint, boundariesElement: popupsBoundariesElement, targetCellPosition: pluginState.targetCellPosition, isOpen: pluginState.isContextualMenuOpen, pluginConfig: pluginState.pluginConfig }),
                    appearance === 'full-page' &&
                        Object(__WEBPACK_IMPORTED_MODULE_15__utils__["y" /* isLayoutSupported */])(editorView.state) && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ui_LayoutButton__["a" /* default */], { editorView: editorView, mountPoint: popupsMountPoint, boundariesElement: popupsBoundariesElement, scrollableElement: popupsScrollableElement, targetRef: pluginState.tableFloatingToolbarTarget, isResizing: !!tableResizingPluginState &&
                            !!tableResizingPluginState.dragging }))));
            } }));
    },
    pluginsOptions: {
        quickInsert: function (_a) {
            var formatMessage = _a.formatMessage;
            return [
                {
                    title: formatMessage(__WEBPACK_IMPORTED_MODULE_9__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].table),
                    priority: 600,
                    icon: function () { return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_table___default.a, { label: formatMessage(__WEBPACK_IMPORTED_MODULE_9__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].table) }); },
                    action: function (insert, state) {
                        return insert(Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["createTable"])(state.schema));
                    },
                },
            ];
        },
        floatingToolbar: __WEBPACK_IMPORTED_MODULE_13__toolbar__["a" /* getToolbarConfig */],
    },
}); };
/* harmony default export */ __webpack_exports__["a"] = (tablesPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Color__ = __webpack_require__(2423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(2425);





var ColorPalette = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ColorPalette, _super);
    function ColorPalette() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColorPalette.prototype.render = function () {
        var _a = this.props, palette = _a.palette, _b = _a.cols, cols = _b === void 0 ? 7 : _b, onClick = _a.onClick, selectedColor = _a.selectedColor, borderColors = _a.borderColors, className = _a.className, checkMarkColor = _a.checkMarkColor;
        var colors = [];
        palette.forEach(function (value, key) { return colors.push([key, value]); });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* ColorPaletteWrapper */], { className: className, style: { maxWidth: cols * 32 } }, colors.map(function (_a) {
            var _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](_a, 2), color = _b[0], label = _b[1];
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Color__["a" /* default */], { key: color, value: color, borderColor: borderColors[label.toLowerCase() || 'transparent'], label: label, onClick: onClick, isSelected: color === selectedColor, checkMarkColor: checkMarkColor }));
        })));
    };
    return ColorPalette;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (ColorPalette);
//# sourceMappingURL=index.js.map

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isWrappingPossible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getListLiftTarget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_transform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__);

var isWrappingPossible = function (nodeType, state) {
    var _a = state.selection, $from = _a.$from, $to = _a.$to;
    var range = $from.blockRange($to);
    if (!range) {
        return false;
    }
    var wrap = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_transform__["findWrapping"])(range, nodeType);
    if (!wrap) {
        return false;
    }
    return true;
};
// This will return (depth - 1) for root list parent of a list.
var getListLiftTarget = function (schema, resPos) {
    var target = resPos.depth;
    var _a = schema.nodes, bulletList = _a.bulletList, orderedList = _a.orderedList, listItem = _a.listItem;
    for (var i = resPos.depth; i > 0; i--) {
        var node = resPos.node(i);
        if (node.type === bulletList || node.type === orderedList) {
            target = i;
        }
        if (node.type !== bulletList &&
            node.type !== orderedList &&
            node.type !== listItem) {
            break;
        }
    }
    return target - 1;
};
//# sourceMappingURL=utils.js.map

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var theme_1 = __webpack_require__(3);
var styled_components_1 = __webpack_require__(2);
exports.resolveColors = function (color) {
    if (!color || color === 'grey') {
        return {
            light: [theme_1.colors.N30A, theme_1.colors.N800, theme_1.colors.N40],
            dark: [theme_1.colors.DN70, theme_1.colors.DN800, theme_1.colors.DN60],
        };
    }
    var letter = color.toUpperCase().charAt(0);
    var resolvedColors = [
        theme_1.colors[letter + "50"],
        theme_1.colors[letter + "500"],
        theme_1.colors[letter + "75"],
    ];
    return {
        light: resolvedColors,
        dark: resolvedColors,
    };
};
/**
 * TODO when update typescript to 2.9+
 * add custom props as Generic Parameter to span instead of casting
 */
exports.DateLozenge = styled_components_1.default.span(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  border-radius: ", "px;\n  padding: 2px 4px;\n  margin: 0 1px;\n  position: relative;\n  transition: background 0.3s;\n  white-space: nowrap;\n  cursor: ", ";\n\n  ", ";\n"], ["\n  border-radius: ", "px;\n  padding: 2px 4px;\n  margin: 0 1px;\n  position: relative;\n  transition: background 0.3s;\n  white-space: nowrap;\n  cursor: ", ";\n\n  ",
    ";\n"])), theme_1.borderRadius(), function (props) { return (props.onClick ? 'pointer' : 'unset'); }, function (props) {
    var _a = tslib_1.__read(theme_1.themed(exports.resolveColors(props.color))(props), 3), background = _a[0], color = _a[1], hoverBackground = _a[2];
    return "\n      background: " + background + ";\n      color: " + color + ";\n      &:hover {\n        background: " + hoverBackground + ";\n      }\n    ";
});
var templateObject_1;
//# sourceMappingURL=DateLozenge.js.map

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

var getDayOfYear = __webpack_require__(2434)
var getISOWeek = __webpack_require__(2436)
var getISOYear = __webpack_require__(827)
var parse = __webpack_require__(74)
var isValid = __webpack_require__(728)
var enLocale = __webpack_require__(2438)

/**
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format.
 *
 * Accepted tokens:
 * | Unit                    | Token | Result examples                  |
 * |-------------------------|-------|----------------------------------|
 * | Month                   | M     | 1, 2, ..., 12                    |
 * |                         | Mo    | 1st, 2nd, ..., 12th              |
 * |                         | MM    | 01, 02, ..., 12                  |
 * |                         | MMM   | Jan, Feb, ..., Dec               |
 * |                         | MMMM  | January, February, ..., December |
 * | Quarter                 | Q     | 1, 2, 3, 4                       |
 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Day of month            | D     | 1, 2, ..., 31                    |
 * |                         | Do    | 1st, 2nd, ..., 31st              |
 * |                         | DD    | 01, 02, ..., 31                  |
 * | Day of year             | DDD   | 1, 2, ..., 366                   |
 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         | DDDD  | 001, 002, ..., 366               |
 * | Day of week             | d     | 0, 1, ..., 6                     |
 * |                         | do    | 0th, 1st, ..., 6th               |
 * |                         | dd    | Su, Mo, ..., Sa                  |
 * |                         | ddd   | Sun, Mon, ..., Sat               |
 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
 * | ISO week                | W     | 1, 2, ..., 53                    |
 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         | WW    | 01, 02, ..., 53                  |
 * | Year                    | YY    | 00, 01, ..., 99                  |
 * |                         | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
 * |                         | GGGG  | 1900, 1901, ..., 2099            |
 * | AM/PM                   | A     | AM, PM                           |
 * |                         | a     | am, pm                           |
 * |                         | aa    | a.m., p.m.                       |
 * | Hour                    | H     | 0, 1, ... 23                     |
 * |                         | HH    | 00, 01, ... 23                   |
 * |                         | h     | 1, 2, ..., 12                    |
 * |                         | hh    | 01, 02, ..., 12                  |
 * | Minute                  | m     | 0, 1, ..., 59                    |
 * |                         | mm    | 00, 01, ..., 59                  |
 * | Second                  | s     | 0, 1, ..., 59                    |
 * |                         | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | SSS   | 000, 001, ..., 999               |
 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
 * |                         | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | X     | 512969520                        |
 * | Milliseconds timestamp  | x     | 512969520900                     |
 *
 * The characters wrapped in square brackets are escaped.
 *
 * The result may vary by locale.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
 * @param {Object} [options] - the object with options
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the formatted date string
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/DD/YYYY'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * var eoLocale = require('date-fns/locale/eo')
 * var result = format(
 *   new Date(2014, 6, 2),
 *   'Do [de] MMMM YYYY',
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 */
function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ'
  var options = dirtyOptions || {}

  var locale = options.locale
  var localeFormatters = enLocale.format.formatters
  var formattingTokensRegExp = enLocale.format.formattingTokensRegExp
  if (locale && locale.format && locale.format.formatters) {
    localeFormatters = locale.format.formatters

    if (locale.format.formattingTokensRegExp) {
      formattingTokensRegExp = locale.format.formattingTokensRegExp
    }
  }

  var date = parse(dirtyDate)

  if (!isValid(date)) {
    return 'Invalid Date'
  }

  var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp)

  return formatFn(date)
}

var formatters = {
  // Month: 1, 2, ..., 12
  'M': function (date) {
    return date.getMonth() + 1
  },

  // Month: 01, 02, ..., 12
  'MM': function (date) {
    return addLeadingZeros(date.getMonth() + 1, 2)
  },

  // Quarter: 1, 2, 3, 4
  'Q': function (date) {
    return Math.ceil((date.getMonth() + 1) / 3)
  },

  // Day of month: 1, 2, ..., 31
  'D': function (date) {
    return date.getDate()
  },

  // Day of month: 01, 02, ..., 31
  'DD': function (date) {
    return addLeadingZeros(date.getDate(), 2)
  },

  // Day of year: 1, 2, ..., 366
  'DDD': function (date) {
    return getDayOfYear(date)
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': function (date) {
    return addLeadingZeros(getDayOfYear(date), 3)
  },

  // Day of week: 0, 1, ..., 6
  'd': function (date) {
    return date.getDay()
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': function (date) {
    return date.getDay() || 7
  },

  // ISO week: 1, 2, ..., 53
  'W': function (date) {
    return getISOWeek(date)
  },

  // ISO week: 01, 02, ..., 53
  'WW': function (date) {
    return addLeadingZeros(getISOWeek(date), 2)
  },

  // Year: 00, 01, ..., 99
  'YY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4).substr(2)
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4)
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': function (date) {
    return String(getISOYear(date)).substr(2)
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': function (date) {
    return getISOYear(date)
  },

  // Hour: 0, 1, ... 23
  'H': function (date) {
    return date.getHours()
  },

  // Hour: 00, 01, ..., 23
  'HH': function (date) {
    return addLeadingZeros(date.getHours(), 2)
  },

  // Hour: 1, 2, ..., 12
  'h': function (date) {
    var hours = date.getHours()
    if (hours === 0) {
      return 12
    } else if (hours > 12) {
      return hours % 12
    } else {
      return hours
    }
  },

  // Hour: 01, 02, ..., 12
  'hh': function (date) {
    return addLeadingZeros(formatters['h'](date), 2)
  },

  // Minute: 0, 1, ..., 59
  'm': function (date) {
    return date.getMinutes()
  },

  // Minute: 00, 01, ..., 59
  'mm': function (date) {
    return addLeadingZeros(date.getMinutes(), 2)
  },

  // Second: 0, 1, ..., 59
  's': function (date) {
    return date.getSeconds()
  },

  // Second: 00, 01, ..., 59
  'ss': function (date) {
    return addLeadingZeros(date.getSeconds(), 2)
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': function (date) {
    return Math.floor(date.getMilliseconds() / 100)
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': function (date) {
    return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2)
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': function (date) {
    return addLeadingZeros(date.getMilliseconds(), 3)
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': function (date) {
    return formatTimezone(date.getTimezoneOffset(), ':')
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': function (date) {
    return formatTimezone(date.getTimezoneOffset())
  },

  // Seconds timestamp: 512969520
  'X': function (date) {
    return Math.floor(date.getTime() / 1000)
  },

  // Milliseconds timestamp: 512969520900
  'x': function (date) {
    return date.getTime()
  }
}

function buildFormatFn (formatStr, localeFormatters, formattingTokensRegExp) {
  var array = formatStr.match(formattingTokensRegExp)
  var length = array.length

  var i
  var formatter
  for (i = 0; i < length; i++) {
    formatter = localeFormatters[array[i]] || formatters[array[i]]
    if (formatter) {
      array[i] = formatter
    } else {
      array[i] = removeFormattingTokens(array[i])
    }
  }

  return function (date) {
    var output = ''
    for (var i = 0; i < length; i++) {
      if (array[i] instanceof Function) {
        output += array[i](date, formatters)
      } else {
        output += array[i]
      }
    }
    return output
  }
}

function removeFormattingTokens (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}

function formatTimezone (offset, delimeter) {
  delimeter = delimeter || ''
  var sign = offset > 0 ? '-' : '+'
  var absOffset = Math.abs(offset)
  var hours = Math.floor(absOffset / 60)
  var minutes = absOffset % 60
  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
}

function addLeadingZeros (number, targetLength) {
  var output = Math.abs(number).toString()
  while (output.length < targetLength) {
    output = '0' + output
  }
  return output
}

module.exports = format


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(74)
var startOfISOWeek = __webpack_require__(447)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * var result = getISOYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()

  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear)

  var fourthOfJanuaryOfThisYear = new Date(0)
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4)
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0)
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear)

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

module.exports = getISOYear


/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return showPlaceholderFloatingToolbar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return insertPlaceholderTextAtSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hidePlaceholderFloatingToolbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(448);

var showPlaceholderFloatingToolbar = function (state, dispatch) {
    var tr = state.tr;
    if (!state.selection.empty) {
        tr.deleteSelection();
    }
    tr.setMeta(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* pluginKey */], { showInsertPanelAt: tr.selection.anchor });
    tr.scrollIntoView();
    dispatch(tr);
    return true;
};
var insertPlaceholderTextAtSelection = function (value) { return function (state, dispatch) {
    dispatch(state.tr
        .replaceSelectionWith(state.schema.nodes.placeholder.createChecked({ text: value }))
        .setMeta(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* pluginKey */], { showInsertPanelAt: null })
        .scrollIntoView());
    return true;
}; };
var hidePlaceholderFloatingToolbar = function (state, dispatch) {
    dispatch(state.tr.setMeta(__WEBPACK_IMPORTED_MODULE_0__index__["b" /* pluginKey */], { showInsertPanelAt: null }));
    return true;
};
//# sourceMappingURL=actions.js.map

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createHorizontalRule; });
/* unused harmony export inputRulePlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_input_rules__ = __webpack_require__(92);




var createHorizontalRule = function (state, start, end) {
    if (!state.selection.empty) {
        return null;
    }
    var $from = state.selection.$from;
    var $afterRule = state.doc.resolve($from.after());
    var paragraph = state.schema.nodes.paragraph;
    if ($afterRule.nodeAfter && $afterRule.nodeAfter.type === paragraph) {
        // if there's already a paragraph after, just insert the rule into
        // the current paragraph
        end = end + 1;
    }
    return state.tr.replaceWith(start, end, __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(state.schema.nodes.rule.createChecked()));
};
var createHorizontalRuleAutoformat = function (state, start, end) {
    __WEBPACK_IMPORTED_MODULE_2__analytics__["a" /* analyticsService */].trackEvent("atlassian.editor.format.horizontalrule.autoformatting");
    return createHorizontalRule(state, start, end);
};
function inputRulePlugin(schema) {
    var rules = [];
    if (schema.nodes.rule) {
        // '---' and '***' for hr
        rules.push(
        // -1, so that it also replaces the container paragraph
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_input_rules__["a" /* createInputRule */])(/^(\-\-\-|\*\*\*)$/, function (state, match, start, end) {
            return createHorizontalRuleAutoformat(state, start - 1, end);
        }, true));
        // '---' and '***' after shift+enter for hr
        rules.push(Object(__WEBPACK_IMPORTED_MODULE_3__utils_input_rules__["a" /* createInputRule */])(new RegExp(__WEBPACK_IMPORTED_MODULE_3__utils_input_rules__["c" /* leafNodeReplacementCharacter */] + "(\\-\\-\\-|\\*\\*\\*)"), function (state, match, start, end) {
            var hardBreak = state.schema.nodes.hardBreak;
            if (state.doc.resolve(start).nodeAfter.type !== hardBreak) {
                return null;
            }
            return createHorizontalRuleAutoformat(state, start, end);
        }, true));
    }
    if (rules.length !== 0) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["inputRules"])({ rules: rules });
    }
}
/* harmony default export */ __webpack_exports__["b"] = (inputRulePlugin);
//# sourceMappingURL=input-rule.js.map

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluginKey; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_view__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_keymap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_commands__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(290);







var isWholeSelectionInsideLayoutColumn = function (state) {
    // Since findParentNodeOfType doesn't check if selection.to shares the parent, we do this check ourselves
    var fromParent = Object(__WEBPACK_IMPORTED_MODULE_4_prosemirror_utils__["findParentNodeOfType"])(state.schema.nodes.layoutColumn)(state.selection);
    if (fromParent) {
        var isToPosInsideSameLayoutColumn = state.selection.from < fromParent.pos + fromParent.node.nodeSize;
        return isToPosInsideSameLayoutColumn;
    }
    return false;
};
var moveCursorToNextColumn = function (state, dispatch) {
    var selection = state.selection;
    var _a = state.schema.nodes, layoutColumn = _a.layoutColumn, layoutSection = _a.layoutSection;
    var section = Object(__WEBPACK_IMPORTED_MODULE_4_prosemirror_utils__["findParentNodeOfType"])(layoutSection)(selection);
    var column = Object(__WEBPACK_IMPORTED_MODULE_4_prosemirror_utils__["findParentNodeOfType"])(layoutColumn)(selection);
    if (column.node !== section.node.lastChild) {
        var $nextColumn = state.doc.resolve(column.pos + column.node.nodeSize);
        var shiftedSelection = __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["TextSelection"].findFrom($nextColumn, 1);
        if (dispatch) {
            dispatch(state.tr.setSelection(shiftedSelection));
        }
    }
    return true;
};
// TODO: Look at memoize-one-ing this fn
var getNodeDecoration = function (pos, node) { return [
    __WEBPACK_IMPORTED_MODULE_2_prosemirror_view__["Decoration"].node(pos, pos + node.nodeSize, { class: 'selected' }),
]; };
var getInitialPluginState = function (pluginConfig, state) {
    var maybeLayoutSection = Object(__WEBPACK_IMPORTED_MODULE_4_prosemirror_utils__["findParentNodeOfType"])(state.schema.nodes.layoutSection)(state.selection);
    var allowBreakout = typeof pluginConfig === 'object' ? !!pluginConfig.allowBreakout : false;
    var pos = maybeLayoutSection ? maybeLayoutSection.pos : null;
    return { pos: pos, allowBreakout: allowBreakout };
};
var pluginKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('layout');
/* harmony default export */ __webpack_exports__["a"] = (function (pluginConfig) {
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        key: pluginKey,
        state: {
            init: function (_, state) {
                return getInitialPluginState(pluginConfig, state);
            },
            apply: function (tr, pluginState, oldState, newState) {
                if (tr.docChanged || tr.selectionSet) {
                    var maybeLayoutSection = Object(__WEBPACK_IMPORTED_MODULE_4_prosemirror_utils__["findParentNodeOfType"])(newState.schema.nodes.layoutSection)(newState.selection);
                    var newPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { pos: maybeLayoutSection ? maybeLayoutSection.pos : null });
                    return newPluginState;
                }
                return pluginState;
            },
        },
        props: {
            decorations: function (state) {
                var layoutState = pluginKey.getState(state);
                if (layoutState.pos !== null) {
                    return __WEBPACK_IMPORTED_MODULE_2_prosemirror_view__["DecorationSet"].create(state.doc, getNodeDecoration(layoutState.pos, state.doc.nodeAt(layoutState.pos)));
                }
                return undefined;
            },
            handleKeyDown: Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_keymap__["keydownHandler"])({
                Tab: Object(__WEBPACK_IMPORTED_MODULE_5__utils_commands__["a" /* filter */])(isWholeSelectionInsideLayoutColumn, moveCursorToNextColumn),
            }),
        },
        appendTransaction: function (transactions, oldState, newState) {
            var changes = [];
            transactions.forEach(function (prevTr) {
                // remap change segments across the transaction set
                changes.map(function (change) {
                    return {
                        from: prevTr.mapping.map(change.from),
                        to: prevTr.mapping.map(change.to),
                        slice: change.slice,
                    };
                });
                // don't consider transactions that don't mutate
                if (!prevTr.docChanged) {
                    return;
                }
                var change = Object(__WEBPACK_IMPORTED_MODULE_6__actions__["c" /* fixColumnSizes */])(prevTr, newState);
                if (change) {
                    changes.push(change);
                }
            });
            if (changes.length) {
                var tr_1 = newState.tr;
                var selection = newState.selection;
                changes.forEach(function (change) {
                    tr_1.replaceRange(change.from, change.to, change.slice);
                });
                if (tr_1.docChanged) {
                    tr_1.setSelection(selection);
                    tr_1.setMeta('addToHistory', false);
                    return tr_1;
                }
            }
        },
    });
});
//# sourceMappingURL=main.js.map

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = insertMentionQuery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type_ahead_commands_insert_query__ = __webpack_require__(2449);

function insertMentionQuery() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__type_ahead_commands_insert_query__["a" /* insertTypeAheadQuery */])('@');
}
//# sourceMappingURL=insert-mention-query.js.map

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ANALYTICS_HOVER_DELAY = 1000;
//# sourceMappingURL=constants.js.map

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export capitalizeFirstLetter */
/* unused harmony export ICON_SIZE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_file__ = __webpack_require__(2477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_file___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_file__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(218);






var capitalizeFirstLetter = function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var ICON_SIZE = 24;
var ExtensionLozenge = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ExtensionLozenge, _super);
    function ExtensionLozenge() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExtensionLozenge.prototype.render = function () {
        var node = this.props.node;
        var imageData = Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["N" /* getExtensionLozengeData */])({ node: node, type: 'image' });
        if (imageData) {
            return this.renderImage(imageData);
        }
        var iconData = Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["N" /* getExtensionLozengeData */])({ node: node, type: 'icon' });
        return this.renderFallback(iconData);
    };
    ExtensionLozenge.prototype.renderImage = function (lozengeData) {
        var extensionKey = this.props.node.attrs.extensionKey;
        var url = lozengeData.url, rest = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](lozengeData, ["url"]);
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ src: url }, rest, { alt: extensionKey }));
    };
    ExtensionLozenge.prototype.renderFallback = function (lozengeData) {
        var _a = this.props.node.attrs, parameters = _a.parameters, extensionKey = _a.extensionKey;
        var params = parameters && parameters.macroParams;
        var title = (parameters && parameters.extensionTitle) || extensionKey;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* PlaceholderFallback */], null,
            lozengeData ? (this.renderImage(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ height: ICON_SIZE, width: ICON_SIZE }, lozengeData))) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_file___default.a, { label: title })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "extension-title" }, capitalizeFirstLetter(title)),
            params && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* PlaceholderFallbackParams */], null, Object.keys(params).map(function (key) { return key && " | " + key + " = " + params[key].value; })))));
    };
    return ExtensionLozenge;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ExtensionLozenge);
//# sourceMappingURL=Lozenge.js.map

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getExtensionNode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__);

var getExtensionNode = function (state) {
    var selection = state.selection;
    var _a = state.schema.nodes, extension = _a.extension, inlineExtension = _a.inlineExtension, bodiedExtension = _a.bodiedExtension;
    if (Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["isNodeSelection"])(selection) &&
        Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["findSelectedNodeOfType"])([extension, bodiedExtension, inlineExtension])(selection)) {
        return {
            node: selection.node,
            pos: selection.$from.pos,
        };
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["findParentNodeOfType"])([extension, inlineExtension, bodiedExtension])(selection);
};
//# sourceMappingURL=utils.js.map

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return insertMacroFromMacroBrowser; });
/* unused harmony export resolveMacro */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return runMacroAutoConvert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setMacroProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assert__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prosemirror_utils__);
var _this = this;






var insertMacroFromMacroBrowser = function (macroProvider, macroNode, isEditing) { return function (state, dispatch) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](_this, void 0, void 0, function () {
    var newMacro, currentLayout, node, bodiedExtension, tr, nonSelectedBodiedExtension;
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!macroProvider) {
                    return [2 /*return*/, false];
                }
                return [4 /*yield*/, macroProvider.openMacroBrowser(macroNode)];
            case 1:
                newMacro = _a.sent();
                if (newMacro) {
                    currentLayout = (macroNode && macroNode.attrs.layout) || 'default';
                    node = resolveMacro(newMacro, state, { layout: currentLayout });
                    if (!node) {
                        return [2 /*return*/, false];
                    }
                    bodiedExtension = state.schema.nodes.bodiedExtension;
                    tr = state.tr;
                    nonSelectedBodiedExtension = macroNode.type === bodiedExtension &&
                        !(tr.selection instanceof __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["NodeSelection"]);
                    if (nonSelectedBodiedExtension && !isEditing) {
                        tr = Object(__WEBPACK_IMPORTED_MODULE_5_prosemirror_utils__["safeInsert"])(node)(tr);
                    }
                    else if (nonSelectedBodiedExtension) {
                        tr = Object(__WEBPACK_IMPORTED_MODULE_5_prosemirror_utils__["replaceParentNodeOfType"])(bodiedExtension, node)(tr);
                    }
                    else if (tr.selection instanceof __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["NodeSelection"]) {
                        tr = Object(__WEBPACK_IMPORTED_MODULE_5_prosemirror_utils__["replaceSelectedNode"])(node)(tr);
                    }
                    dispatch(tr.scrollIntoView());
                    return [2 /*return*/, true];
                }
                return [2 /*return*/, false];
        }
    });
}); }; };
var resolveMacro = function (macro, state, optionalAttrs) {
    if (!macro || !state) {
        return null;
    }
    var schema = state.schema;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__["O" /* getValidNode */])(macro, schema), type = _a.type, attrs = _a.attrs;
    var node;
    if (type === 'extension') {
        node = schema.nodes.extension.create(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, attrs, optionalAttrs));
    }
    else if (type === 'bodiedExtension') {
        node = schema.nodes.bodiedExtension.create(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, attrs, optionalAttrs), schema.nodeFromJSON(macro).content);
    }
    else if (type === 'inlineExtension') {
        node = schema.nodes.inlineExtension.create(attrs);
    }
    return node;
};
// gets the macroProvider from the state and tries to autoConvert a given text
var runMacroAutoConvert = function (state, text) {
    var macroPluginState = __WEBPACK_IMPORTED_MODULE_2____["c" /* pluginKey */].getState(state);
    var macroProvider = macroPluginState && macroPluginState.macroProvider;
    if (!macroProvider || !macroProvider.autoConvert) {
        return null;
    }
    var macroAttributes = macroProvider.autoConvert(text);
    if (!macroAttributes) {
        return null;
    }
    // decides which kind of macro to render (inline|bodied|bodyless) - will be just inline atm.
    return resolveMacro(macroAttributes, state);
};
var setMacroProvider = function (provider) { return function (view) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](_this, void 0, void 0, function () {
    var resolvedProvider, err_1;
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, provider];
            case 1:
                resolvedProvider = _a.sent();
                __WEBPACK_IMPORTED_MODULE_3_assert__(resolvedProvider && resolvedProvider.openMacroBrowser, "MacroProvider promise did not resolve to a valid instance of MacroProvider - " + resolvedProvider);
                return [3 /*break*/, 3];
            case 2:
                err_1 = _a.sent();
                resolvedProvider = null;
                return [3 /*break*/, 3];
            case 3:
                view.dispatch(view.state.tr.setMeta(__WEBPACK_IMPORTED_MODULE_2____["c" /* pluginKey */], { macroProvider: resolvedProvider }));
                return [2 /*return*/, true];
        }
    });
}); }; };
//# sourceMappingURL=actions.js.map

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateExtensionLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return editExtension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return removeExtension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return transformSliceToRemoveOpenBodiedExtension; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugin__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__macro__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_slice__ = __webpack_require__(104);









var updateExtensionLayout = function (layout) { return function (state, dispatch) {
    var selection = state.selection, schema = state.schema, tr = state.tr;
    var _a = schema.nodes, bodiedExtension = _a.bodiedExtension, extension = _a.extension, inlineExtension = _a.inlineExtension;
    var parentExtNode = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["findParentNodeOfType"])([bodiedExtension])(selection);
    var extPosition;
    var extNode;
    var selectedNode = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["findSelectedNodeOfType"])([
        bodiedExtension,
        inlineExtension,
        extension,
    ])(selection);
    if (!parentExtNode && !selectedNode) {
        return false;
    }
    if (selectedNode) {
        extPosition = selectedNode.pos;
        extNode = selectedNode.node;
    }
    else {
        extPosition = parentExtNode.pos;
        extNode = parentExtNode.node;
    }
    var pluginState = __WEBPACK_IMPORTED_MODULE_4__plugin__["b" /* pluginKey */].getState(state);
    tr.setNodeMarkup(extPosition, undefined, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, extNode.attrs, { layout: layout })).setMeta(__WEBPACK_IMPORTED_MODULE_4__plugin__["b" /* pluginKey */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { layout: layout }));
    if (dispatch) {
        dispatch(tr);
    }
    return true;
}; };
var editExtension = function (macroProvider) { return function (state, dispatch) {
    var node = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* getExtensionNode */])(state);
    if (!node || !macroProvider) {
        return false;
    }
    Object(__WEBPACK_IMPORTED_MODULE_5__macro__["b" /* insertMacroFromMacroBrowser */])(macroProvider, node.node, true)(state, dispatch);
    return true;
}; };
var removeExtension = function () { return function (state, dispatch) {
    var schema = state.schema, selection = state.selection;
    var pluginState = __WEBPACK_IMPORTED_MODULE_4__plugin__["b" /* pluginKey */].getState(state);
    var tr = state.tr.setMeta(__WEBPACK_IMPORTED_MODULE_4__plugin__["b" /* pluginKey */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { element: null }));
    if (selection instanceof __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["NodeSelection"] &&
        selection.node.type === schema.nodes.inlineExtension) {
        tr = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["removeSelectedNode"])(tr);
    }
    else {
        tr = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["removeParentNodeOfType"])(schema.nodes.bodiedExtension)(tr);
    }
    if (dispatch) {
        dispatch(tr);
    }
    return true;
}; };
/**
 * Lift content out of "open" top-level bodiedExtensions.
 * Will not work if bodiedExtensions are nested, or when bodiedExtensions are not in the top level
 */
var transformSliceToRemoveOpenBodiedExtension = function (slice, schema) {
    var bodiedExtension = schema.nodes.bodiedExtension;
    var fragment = Object(__WEBPACK_IMPORTED_MODULE_7__utils_slice__["d" /* mapFragment */])(slice.content, function (node, parent, index) {
        if (node.type === bodiedExtension && !parent) {
            var currentNodeIsAtStartAndIsOpen = slice.openStart && index === 0;
            var currentNodeIsAtEndAndIsOpen = slice.openEnd && index + 1 === slice.content.childCount;
            if (currentNodeIsAtStartAndIsOpen || currentNodeIsAtEndAndIsOpen) {
                return node.content;
            }
        }
        return node;
    });
    // If the first/last child has changed - then we know we've removed a bodied extension & to decrement the open depth
    return new __WEBPACK_IMPORTED_MODULE_3_prosemirror_model__["Slice"](fragment, fragment.firstChild &&
        fragment.firstChild.type !== slice.content.firstChild.type
        ? slice.openStart - 1
        : slice.openStart, fragment.lastChild &&
        fragment.lastChild.type !== slice.content.lastChild.type
        ? slice.openEnd - 1
        : slice.openEnd);
};
//# sourceMappingURL=actions.js.map

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transformToCodeAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(21);

var SMART_TO_ASCII = {
    '…': '...',
    '→': '->',
    '←': '<-',
    '–': '--',
    '“': '"',
    '”': '"',
    '‘': "'",
    '’': "'",
};
var FIND_SMART_CHAR = new RegExp("[" + Object.keys(SMART_TO_ASCII).join('') + "]", 'g');
var replaceMentionOrEmojiForTextContent = function (position, nodeSize, textContent, tr) {
    var currentPos = tr.mapping.map(position);
    var schema = tr.doc.type.schema;
    tr.replaceWith(currentPos, currentPos + nodeSize, schema.text(textContent));
};
var replaceSmartCharsToAscii = function (position, textContent, tr) {
    var textExtracted = textContent.substr(position - 1);
    var schema = tr.doc.type.schema;
    var match;
    while ((match = FIND_SMART_CHAR.exec(textExtracted))) {
        var smartChar = match[0], offset = match.index;
        var replacePos = tr.mapping.map(position + offset);
        var replacementText = schema.text(SMART_TO_ASCII[smartChar]);
        tr.replaceWith(replacePos, replacePos + smartChar.length, replacementText);
    }
};
var transformSmartCharsMentionsAndEmojis = function (from, to, tr) {
    var schema = tr.doc.type.schema;
    var _a = schema.nodes, mention = _a.mention, text = _a.text, emoji = _a.emoji;
    var isNodeTextBlock = function (node, _, parent) {
        if (node.type === mention || node.type === emoji || node.type === text) {
            return parent.isTextblock;
        }
    };
    // Traverse through all the nodes within the range and replace them with their plaintext counterpart
    var children = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* filterChildrenBetween */])(tr.doc, from, to, isNodeTextBlock);
    children.forEach(function (_a) {
        var node = _a.node, pos = _a.pos;
        if (node.type === mention || node.type === emoji) {
            replaceMentionOrEmojiForTextContent(pos, node.nodeSize, node.attrs.text, tr);
        }
        else if (node.type === text && node.text) {
            var replacePosition = pos > from ? pos : from;
            replaceSmartCharsToAscii(replacePosition, node.text, tr);
        }
    });
};
var applyCodeBlock = function (from, to, tr) {
    var schema = tr.doc.type.schema;
    if (schema.marks.code) {
        var codeMark = schema.marks.code.create();
        tr.addMark(tr.mapping.map(from), tr.mapping.map(to), codeMark).setStoredMarks([codeMark]);
    }
};
function transformToCodeAction(from, to, tr) {
    transformSmartCharsMentionsAndEmojis(from, to, tr);
    applyCodeBlock(from, to, tr);
    return tr;
}
//# sourceMappingURL=transform-to-code.js.map

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluginKey; });
/* unused harmony export setProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__search__ = __webpack_require__(2487);





var quickInsertPlugin = {
    name: 'quickInsert',
    pmPlugins: function (quickInsert) {
        return [
            {
                name: 'quickInsert',
                plugin: function (_a) {
                    var providerFactory = _a.providerFactory;
                    return quickInsertPluginFactory(quickInsert, providerFactory);
                },
            },
        ];
    },
    pluginsOptions: {
        typeAhead: {
            trigger: '/',
            getItems: function (query, state, intl) {
                __WEBPACK_IMPORTED_MODULE_2__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.quickinsert.query');
                var quickInsertState = pluginKey.getState(state);
                var defaultItems = processItems(quickInsertState.items, intl);
                var defaultSearch = function () { return Object(__WEBPACK_IMPORTED_MODULE_4__search__["a" /* find */])(query, defaultItems); };
                if (quickInsertState.provider) {
                    return quickInsertState.provider
                        .then(function (items) {
                        return Object(__WEBPACK_IMPORTED_MODULE_4__search__["a" /* find */])(query, Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* dedupe */])(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](defaultItems, items), function (item) { return item.title; }));
                    })
                        .catch(function (err) {
                        // tslint:disable-next-line:no-console
                        console.error(err);
                        return defaultSearch();
                    });
                }
                return defaultSearch();
            },
            selectItem: function (state, item, insert) {
                __WEBPACK_IMPORTED_MODULE_2__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.quickinsert.select', {
                    item: item.title,
                });
                return item.action(insert, state);
            },
        },
    },
};
/* harmony default export */ __webpack_exports__["a"] = (quickInsertPlugin);
var itemsCache = {};
var processItems = function (items, intl) {
    if (!itemsCache[intl.locale]) {
        itemsCache[intl.locale] = items.reduce(function (acc, item) {
            if (typeof item === 'function') {
                return acc.concat(item(intl));
            }
            return acc.concat(item);
        }, []);
    }
    return itemsCache[intl.locale];
};
/**
 *
 * ProseMirror Plugin
 *
 */
var pluginKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('quickInsertPluginKey');
var setProvider = function (provider) { return function (state, dispatch) {
    if (dispatch) {
        dispatch(state.tr.setMeta(pluginKey, provider));
    }
    return true;
}; };
function quickInsertPluginFactory(quickInsertItems, providerFactory) {
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        key: pluginKey,
        state: {
            init: function () {
                return {
                    items: quickInsertItems || [],
                };
            },
            apply: function (tr, pluginState) {
                var provider = tr.getMeta(pluginKey);
                if (provider) {
                    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { provider: provider });
                }
                return pluginState;
            },
        },
        view: function (editorView) {
            var providerHandler = function (name, providerPromise) {
                if (providerPromise) {
                    setProvider(providerPromise.then(function (provider) {
                        return provider.getItems();
                    }))(editorView.state, editorView.dispatch);
                }
            };
            providerFactory.subscribe('quickInsertProvider', providerHandler);
            return {
                destroy: function () {
                    providerFactory.unsubscribe('quickInsertProvider', providerHandler);
                },
            };
        },
    });
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Client; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_observable_of__ = __webpack_require__(2493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_merge__ = __webpack_require__(2494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_fromPromise__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fetch__ = __webpack_require__(2497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operators_map__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operators_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_operators_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operators_delay__ = __webpack_require__(2498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operators_delay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_operators_delay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operators_takeUntil__ = __webpack_require__(2501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operators_takeUntil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators_takeUntil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operators_catchError__ = __webpack_require__(2502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operators_catchError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_operators_catchError__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(2503);









// TODO: add some form of caching so that urls not currently loaded will still be fast
var SERVICE_URL = 'https://api-private.stg.atlassian.com/object-resolver';
var DEFAULT_CACHE_LIFESPAN = 15 * 1000;
var DEFAULT_LOADING_STATE_DELAY = 1200;
var convertAuthToService = function (auth) { return ({
    id: auth.key,
    name: auth.displayName,
    startAuthUrl: auth.url,
}); };
var statusByAccess = function (status, json) { return ({
    status: status,
    definitionId: json.meta.definitionId,
    services: json.meta.auth.map(convertAuthToService),
    data: json.data,
}); };
var responseToStateMapper = function (json) {
    if (json.meta.visibility === 'not_found') {
        return { status: 'not-found' };
    }
    switch (json.meta.access) {
        case 'forbidden':
            return statusByAccess('forbidden', json);
        case 'unauthorized':
            return statusByAccess('unauthorized', json);
        default:
            return statusByAccess('resolved', json);
    }
};
var filterUrlsByDefId = function (store, defId, urls) {
    return urls.filter(function (url) {
        var entry = store.get(url);
        var entryDefId = entry && entry.getProp('definitionId');
        return entryDefId === defId;
    });
};
var unresolvedUrls = function (store, urls) {
    return urls.filter(function (url) {
        var entry = store.get(url);
        var entryStatus = entry && entry.getProp('status');
        return entryStatus !== 'resolved';
    });
};
var urlsWithoutDefinitionId = function (store, urls) {
    return urls.filter(function (url) {
        var entry = store.get(url);
        var defId = entry && entry.getProp('definitionId');
        return defId === undefined;
    });
};
var getUrlsToReload = function (store, definitionIdFromCard) {
    if (definitionIdFromCard) {
        return unresolvedUrls(store, filterUrlsByDefId(store, definitionIdFromCard, store.getAllUrls()));
    }
    else {
        return urlsWithoutDefinitionId(store, store.getAllUrls());
    }
};
var Client = /** @class */ (function () {
    function Client(config) {
        this.cacheLifespan =
            (config && config.cacheLifespan) || DEFAULT_CACHE_LIFESPAN;
        this.store = new __WEBPACK_IMPORTED_MODULE_8__store__["a" /* Store */]((config && config.getNowTimeFn) || Date.now);
        this.loadingStateDelay =
            (config && config.loadingStateDelay) || DEFAULT_LOADING_STATE_DELAY;
    }
    Client.prototype.fetchData = function (objectUrl) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__fetch__["a" /* default */])('post', SERVICE_URL + "/resolve", {
            resourceUrl: encodeURI(objectUrl),
        }).toPromise();
    };
    Client.prototype.startStreaming = function (objectUrl) {
        return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_fromPromise__["fromPromise"])(this.fetchData(objectUrl)).pipe(Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_operators_map__["map"])(responseToStateMapper), Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_operators_catchError__["catchError"])(function () { return Object(__WEBPACK_IMPORTED_MODULE_0_rxjs_observable_of__["of"])({ status: 'errored' }); }));
    };
    /**
     * A card should register itself using this method.
     *
     * We're trying to match a DefinitionId to a bunch of URLs and each URL to a callback.
     *
     * As such, when a card gives us the URL we can fetch data+DefinitionId from the ORS,
     * then use that definitionId to find cards that has to be updated.
     *
     * @param url the url that card holds
     * @param fn the callback that can be called after the data has been resolved for that card.
     */
    Client.prototype.register = function (url) {
        if (!this.store.exists(url)) {
            return this.store.init(url);
        }
        return this.store.get(url);
    };
    // let's say when a card gets unmounted, we need to "clean-up"
    Client.prototype.deregister = function (url, uuid) {
        var storeEntry = this.store.get(url);
        if (storeEntry) {
            storeEntry.unsubscribe(uuid);
        }
        return this;
    };
    Client.prototype.resolve = function (url, cb) {
        var _this = this;
        if (!this.store.exists(url)) {
            throw new Error('Please, register a smart card before calling get()');
        }
        var entry = this.store.get(url);
        // Only load the data from network after it's expired in the cache
        if (entry && entry.hasExpired()) {
            var data$ = this.startStreaming(url);
            var resolving$ = Object(__WEBPACK_IMPORTED_MODULE_0_rxjs_observable_of__["of"])({ status: 'resolving' }).pipe(Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_operators_delay__["delay"])(this.loadingStateDelay), Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators_takeUntil__["takeUntil"])(data$));
            Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_merge__["merge"])(resolving$, data$).subscribe(function (state) {
                _this.store.set(url, state, _this.cacheLifespan);
                if (cb) {
                    cb();
                }
            });
        }
    };
    Client.prototype.reload = function (urlToReload, definitionIdFromCard) {
        var _this = this;
        this.store.get(urlToReload).invalidate();
        this.resolve(urlToReload, function () {
            getUrlsToReload(_this.store, definitionIdFromCard)
                .filter(function (otherUrl) { return otherUrl !== urlToReload; })
                .forEach(function (otherUrl) {
                _this.store.get(otherUrl).invalidate();
                _this.resolve(otherUrl);
            });
        });
    };
    return Client;
}());

//# sourceMappingURL=index.js.map

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapComponentWithClickArea;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(21);





var BlockWrapper = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
BlockWrapper.displayName = 'BlockWrapperClickArea';
var InlineWrapper = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"]([""], [""])));
InlineWrapper.displayName = 'InlineWrapperClickArea';
// tslint:disable-next-line:variable-name
function wrapComponentWithClickArea(ReactComponent, inline) {
    return /** @class */ (function (_super) {
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WrapperClickArea, _super);
        function WrapperClickArea() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = { selected: false };
            _this.handleDocumentSelectionChange = function (anchorPos, headPos) {
                var _a = _this.props, getPos = _a.getPos, onSelection = _a.onSelection;
                var nodePos = getPos();
                var selected = nodePos >= anchorPos && nodePos < headPos;
                var oldSelected = _this.state.selected;
                _this.setState({ selected: selected }, function () {
                    if (onSelection && selected !== oldSelected) {
                        onSelection(selected);
                    }
                });
            };
            _this.onClick = function () {
                var _a = _this.props, getPos = _a.getPos, view = _a.view;
                Object(__WEBPACK_IMPORTED_MODULE_3__utils__["G" /* setNodeSelection */])(view, getPos());
            };
            return _this;
        }
        WrapperClickArea.prototype.componentDidMount = function () {
            var pluginState = this.props.pluginState;
            pluginState.subscribe(this.handleDocumentSelectionChange);
        };
        WrapperClickArea.prototype.componentWillUnmount = function () {
            var pluginState = this.props.pluginState;
            pluginState.unsubscribe(this.handleDocumentSelectionChange);
        };
        WrapperClickArea.prototype.render = function () {
            var Wrapper = inline ? InlineWrapper : BlockWrapper;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Wrapper, { onClick: this.onClick },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ReactComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, this.props, { selected: this.state.selected }))));
        };
        return WrapperClickArea;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=wrapper-click-area.js.map

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FloatingToolbar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ToolbarButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Separator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_ToolbarButton__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_FloatingToolbar__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Separator__ = __webpack_require__(842);





// `line-height: 1` to fix extra 1px height from toolbar wrapper
var FloatingToolbar = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3__ui_FloatingToolbar__["a" /* default */])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  max-height: 350px;\n  min-height: 32px;\n  height: initial;\n  & > div {\n    line-height: 1;\n  }\n  & > div > button:last-child {\n    margin-right: 0;\n  }\n  .normal& input {\n    min-width: 244px;\n    margin-right: 2px;\n  }\n  .recent-search& {\n    padding: 8px 0 0;\n    input {\n      padding: 0 8px 8px;\n    }\n  }\n"], ["\n  max-height: 350px;\n  min-height: 32px;\n  height: initial;\n  & > div {\n    line-height: 1;\n  }\n  & > div > button:last-child {\n    margin-right: 0;\n  }\n  .normal& input {\n    min-width: 244px;\n    margin-right: 2px;\n  }\n  .recent-search& {\n    padding: 8px 0 0;\n    input {\n      padding: 0 8px 8px;\n    }\n  }\n"])));
// `a&` because `Button` uses it and it produces a more specific selector `a.xyz`
var ToolbarButton = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2__ui_ToolbarButton__["a" /* default */])(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  width: 24px;\n  padding: 0;\n  margin: 0 2px;\n  a& {\n    width: 24px;\n    margin: 0 2px;\n  }\n"], ["\n  width: 24px;\n  padding: 0;\n  margin: 0 2px;\n  a& {\n    width: 24px;\n    margin: 0 2px;\n  }\n"])));
// Need fixed height because parent has height inherit and `height: 100%` doesn't work because of that
var Separator = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_4__ui_Separator__["a" /* default */])(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin: 2px 6px;\n  height: 20px;\n"], ["\n  margin: 2px 6px;\n  height: 20px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



var Separator = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  background: ", ";\n  height: 100%;\n  padding-left: 1px;\n  margin: 2px 8px;\n"], ["\n  background: ", ";\n  height: 100%;\n  padding-left: 1px;\n  margin: 2px 8px;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30);
/* harmony default export */ __webpack_exports__["a"] = (Separator);
var templateObject_1;
//# sourceMappingURL=index.js.map

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export checkClipboardTypes */
/* harmony export (immutable) */ __webpack_exports__["a"] = isPastedFile;
function checkClipboardTypes(type, item) {
    var isDOMStringList = function (t) { return !t.indexOf && !!t.contains; };
    return isDOMStringList(type) ? type.contains(item) : type.indexOf(item) > -1;
}
function isPastedFile(rawEvent) {
    var clipboardData = rawEvent.clipboardData;
    if (!clipboardData) {
        return false;
    }
    return checkClipboardTypes(clipboardData.types, 'Files');
}
//# sourceMappingURL=clipboard.js.map

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return insertExternalImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return startImageUpload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(2523);




var insertExternalImage = function (options) { return function (state, dispatch) {
    var pluginState = __WEBPACK_IMPORTED_MODULE_2__main__["b" /* stateKey */].getState(state);
    if (!pluginState.enabled || !options.src) {
        return false;
    }
    var mediaNode = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* createExternalMediaNode */])(options.src, state.schema);
    if (!mediaNode) {
        return false;
    }
    if (dispatch) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["safeInsert"])(mediaNode, state.selection.$to.pos)(state.tr).scrollIntoView());
    }
    return true;
}; };
var startImageUpload = function (event) { return function (state, dispatch) {
    var pluginState = __WEBPACK_IMPORTED_MODULE_2__main__["b" /* stateKey */].getState(state);
    if (!pluginState.enabled) {
        return false;
    }
    if (dispatch) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* startUpload */])(event)(state.tr));
    }
    return true;
}; };
//# sourceMappingURL=commands.js.map

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_layout_two_equal__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_layout_two_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_layout_two_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__insert_block_ui_ToolbarInsertBlock__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toolbar__ = __webpack_require__(2532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(290);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["b"]; });








/* harmony default export */ __webpack_exports__["a"] = ({
    nodes: function () {
        return [
            { name: 'layoutSection', node: __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__["N" /* layoutSection */] },
            { name: 'layoutColumn', node: __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__["M" /* layoutColumn */] },
        ];
    },
    pmPlugins: function () {
        return [
            {
                name: 'layout',
                plugin: function (_a) {
                    var props = _a.props;
                    return Object(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["a" /* default */])(props.allowLayouts);
                },
            },
        ];
    },
    pluginsOptions: {
        floatingToolbar: function (state, intl) {
            var _a = __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["b" /* pluginKey */].getState(state), pos = _a.pos, allowBreakout = _a.allowBreakout;
            if (pos !== null) {
                return Object(__WEBPACK_IMPORTED_MODULE_5__toolbar__["a" /* buildToolbar */])(state, intl, pos, allowBreakout);
            }
            return undefined;
        },
        quickInsert: function (_a) {
            var formatMessage = _a.formatMessage;
            return [
                {
                    title: formatMessage(__WEBPACK_IMPORTED_MODULE_3__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].columns),
                    keywords: ['layout', 'section'],
                    priority: 1100,
                    icon: function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_layout_two_equal___default.a, { label: formatMessage(__WEBPACK_IMPORTED_MODULE_3__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].columns) })); },
                    action: function (insert, state) {
                        return insert(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["a" /* createDefaultLayoutSection */])(state));
                    },
                },
            ];
        },
    },
});
//# sourceMappingURL=index.js.map

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluginKey; });
/* unused harmony export isMultiline */
/* unused harmony export createPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);

var pluginKey = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["PluginKey"]('isMultilineContentPlugin');
var isMultiline = function (doc) {
    if (doc.childCount > 1) {
        return true;
    }
    if (doc.firstChild.type.name !== 'paragraph') {
        return true;
    }
    var paragraph = doc.firstChild;
    if (paragraph.firstChild && paragraph.firstChild.type.name === 'hardBreak') {
        return true;
    }
    if (paragraph.childCount === 1) {
        return false;
    }
    for (var child = 0; child < paragraph.childCount; child++) {
        if (paragraph.child(child).type.name === 'hardBreak') {
            return true;
        }
    }
    return false;
};
function createPlugin(dispatch) {
    return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
        state: {
            init: function (config, editorState) {
                return false;
            },
            apply: function (tr, isMultilineContent, oldState, newState) {
                var state = isMultiline(newState.doc);
                if (state !== isMultilineContent) {
                    dispatch(pluginKey, state);
                }
                return state;
            },
        },
    });
}
var isMultilineContentPlugin = {
    pmPlugins: function () {
        return [
            {
                name: 'multilineContent',
                plugin: function (_a) {
                    var dispatch = _a.dispatch;
                    return createPlugin(dispatch);
                },
            },
        ];
    },
};
/* harmony default export */ __webpack_exports__["a"] = (isMultilineContentPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorBulletListIcon = function EditorBulletListIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M6 8c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1zm5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2zm-5 5c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1zm5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2zm-5 5c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1zm5-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorBulletListIcon.displayName = 'EditorBulletListIcon';
var _default = EditorBulletListIcon;
exports.default = _default;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorNumberListIcon = function EditorNumberListIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M11 7h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2zm0 4h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2zm0 4h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2zm-5 0h3v1H6v-1zm0 2h3v1H6v-1zm1-9H6V7h2v3H7V8zm-1 3h3v1.333h-.6V13H7.2v-.667H6V11zm0 2h3v1H6v-1zm2 3h2v1H8v-1z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorNumberListIcon.displayName = 'EditorNumberListIcon';
var _default = EditorNumberListIcon;
exports.default = _default;

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluginKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mark__ = __webpack_require__(278);





var pluginKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('listsPlugin');
var createPlugin = function (dispatch) {
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        state: {
            init: function () { return ({
                bulletListActive: false,
                bulletListDisabled: false,
                orderedListActive: false,
                orderedListDisabled: false,
            }); },
            apply: function (tr, pluginState, _, state) {
                var _a = state.schema.nodes, bulletList = _a.bulletList, orderedList = _a.orderedList;
                var listParent = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["findParentNodeOfType"])([bulletList, orderedList])(tr.selection);
                var bulletListActive = !!listParent && listParent.node.type === bulletList;
                var orderedListActive = !!listParent && listParent.node.type === orderedList;
                var bulletListDisabled = !(bulletListActive ||
                    orderedListActive ||
                    Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* isWrappingPossible */])(bulletList, state));
                var orderedListDisabled = !(bulletListActive ||
                    orderedListActive ||
                    Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* isWrappingPossible */])(orderedList, state));
                if (bulletListActive !== pluginState.bulletListActive ||
                    orderedListActive !== pluginState.orderedListActive ||
                    bulletListDisabled !== pluginState.bulletListDisabled ||
                    orderedListDisabled !== pluginState.orderedListDisabled) {
                    var nextPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { bulletListActive: bulletListActive,
                        orderedListActive: orderedListActive,
                        bulletListDisabled: bulletListDisabled,
                        orderedListDisabled: orderedListDisabled });
                    dispatch(pluginKey, nextPluginState);
                    return nextPluginState;
                }
                return pluginState;
            },
        },
        view: function (editorView) {
            return {
                update: function (_a) {
                    var state = _a.state, dispatch = _a.dispatch;
                    var _b = state.schema.nodes, bulletList = _b.bulletList, orderedList = _b.orderedList;
                    var _c = state.schema.marks, alignment = _c.alignment, indentation = _c.indentation;
                    var listParent = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["findParentNodeOfType"])([bulletList, orderedList])(state.tr.selection);
                    if (!listParent) {
                        return;
                    }
                    /** Block mark if exists should be removed when toggled to list items */
                    var removeMarks = Object(__WEBPACK_IMPORTED_MODULE_4__utils_mark__["c" /* removeBlockMarks */])(state, [alignment, indentation]);
                    if (removeMarks) {
                        dispatch(removeMarks);
                    }
                },
            };
        },
        key: pluginKey,
    });
};
//# sourceMappingURL=main.js.map

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_image__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pm_plugins_main__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pm_plugins_keymap_media_single__ = __webpack_require__(2581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pm_plugins_keymap__ = __webpack_require__(2582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_ToolbarMedia__ = __webpack_require__(2583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_MediaSingleEdit__ = __webpack_require__(2585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__nodeviews_mediaGroup__ = __webpack_require__(2591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__nodeviews_mediaSingle__ = __webpack_require__(2630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__insert_block_ui_ToolbarInsertBlock__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__editor_disabled__ = __webpack_require__(106);
/* unused harmony reexport DefaultMediaStateManager */















var mediaPlugin = function (options) { return ({
    nodes: function () {
        return [
            { name: 'mediaGroup', node: __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__["S" /* mediaGroup */] },
            { name: 'mediaSingle', node: __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__["T" /* mediaSingle */] },
            { name: 'media', node: __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__["R" /* media */] },
        ].filter(function (node) {
            var _a = options || {}, _b = _a.allowMediaGroup, allowMediaGroup = _b === void 0 ? true : _b, _c = _a.allowMediaSingle, allowMediaSingle = _c === void 0 ? false : _c;
            if (node.name === 'mediaGroup') {
                return allowMediaGroup;
            }
            if (node.name === 'mediaSingle') {
                return allowMediaSingle;
            }
            return true;
        });
    },
    pmPlugins: function () {
        return [
            {
                name: 'media',
                plugin: function (_a) {
                    var schema = _a.schema, props = _a.props, dispatch = _a.dispatch, eventDispatcher = _a.eventDispatcher, providerFactory = _a.providerFactory, errorReporter = _a.errorReporter, portalProviderAPI = _a.portalProviderAPI, reactContext = _a.reactContext;
                    return Object(__WEBPACK_IMPORTED_MODULE_3__pm_plugins_main__["a" /* createPlugin */])(schema, {
                        providerFactory: providerFactory,
                        nodeViews: {
                            mediaGroup: Object(__WEBPACK_IMPORTED_MODULE_8__nodeviews_mediaGroup__["a" /* ReactMediaGroupNode */])(portalProviderAPI, props.appearance),
                            mediaSingle: Object(__WEBPACK_IMPORTED_MODULE_9__nodeviews_mediaSingle__["a" /* ReactMediaSingleNode */])(portalProviderAPI, eventDispatcher, props.appearance),
                        },
                        errorReporter: errorReporter,
                        uploadErrorHandler: props.uploadErrorHandler,
                        waitForMediaUpload: props.waitForMediaUpload,
                        customDropzoneContainer: options && options.customDropzoneContainer,
                        customMediaPicker: options && options.customMediaPicker,
                        appearance: props.appearance,
                        allowResizing: !!(options && options.allowResizing),
                    }, reactContext, dispatch, props.appearance);
                },
            },
            { name: 'mediaKeymap', plugin: function (_a) {
                    var schema = _a.schema;
                    return Object(__WEBPACK_IMPORTED_MODULE_5__pm_plugins_keymap__["a" /* default */])();
                } },
        ].concat(options && options.allowMediaSingle
            ? {
                name: 'mediaSingleKeymap',
                plugin: function (_a) {
                    var schema = _a.schema;
                    return Object(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_keymap_media_single__["a" /* default */])(schema);
                },
            }
            : []);
    },
    contentComponent: function (_a) {
        var editorView = _a.editorView, appearance = _a.appearance;
        if (!options) {
            return null;
        }
        var allowMediaSingle = options.allowMediaSingle;
        var disableLayout;
        if (typeof allowMediaSingle === 'object') {
            disableLayout = allowMediaSingle.disableLayout;
        }
        if ((typeof allowMediaSingle === 'boolean' && allowMediaSingle === false) ||
            (typeof disableLayout === 'boolean' && disableLayout === true)) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ui_WithPluginState__["a" /* default */], { editorView: editorView, plugins: {
                mediaState: __WEBPACK_IMPORTED_MODULE_3__pm_plugins_main__["b" /* stateKey */],
                disabled: __WEBPACK_IMPORTED_MODULE_13__editor_disabled__["b" /* pluginKey */],
            }, render: function (_a) {
                var mediaState = _a.mediaState, disabled = _a.disabled;
                var _b = mediaState, target = _b.element, layout = _b.layout;
                var node = mediaState.selectedMediaNode();
                var isFullPage = appearance === 'full-page';
                var allowBreakout = !!(node &&
                    node.attrs &&
                    node.attrs.width > __WEBPACK_IMPORTED_MODULE_11__atlaskit_editor_common__["p" /* akEditorFullPageMaxWidth */] &&
                    isFullPage);
                var allowLayout = isFullPage && !!mediaState.isLayoutSupported();
                var allowResizing = mediaState.getMediaOptions().allowResizing;
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ui_MediaSingleEdit__["a" /* default */], { pluginState: mediaState, allowBreakout: allowBreakout, allowLayout: allowLayout, layout: layout, target: target, allowResizing: allowResizing, editorDisabled: disabled.editorDisabled }));
            } }));
    },
    secondaryToolbarComponent: function (_a) {
        var editorView = _a.editorView, disabled = _a.disabled;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ui_ToolbarMedia__["a" /* default */], { editorView: editorView, pluginKey: __WEBPACK_IMPORTED_MODULE_3__pm_plugins_main__["b" /* stateKey */], isDisabled: disabled, isReducedSpacing: true }));
    },
    pluginsOptions: {
        quickInsert: function (_a) {
            var formatMessage = _a.formatMessage;
            return [
                {
                    title: formatMessage(__WEBPACK_IMPORTED_MODULE_12__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].filesAndImages),
                    priority: 400,
                    keywords: ['media'],
                    icon: function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_image___default.a, { label: formatMessage(__WEBPACK_IMPORTED_MODULE_12__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].filesAndImages) })); },
                    action: function (insert, state) {
                        var pluginState = __WEBPACK_IMPORTED_MODULE_3__pm_plugins_main__["b" /* stateKey */].getState(state);
                        pluginState.showMediaPicker();
                        return insert('');
                    },
                },
            ];
        },
    },
}); };
/* harmony default export */ __webpack_exports__["a"] = (mediaPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MUTATION_CONFIG */
/* unused harmony export LeftArrow */
/* unused harmony export RightArrow */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilmstripView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_arrow_left__ = __webpack_require__(2592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_arrow_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_arrow_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_arrow_right__ = __webpack_require__(2601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_arrow_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_arrow_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debounce__ = __webpack_require__(2602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styled__ = __webpack_require__(2603);

/* tslint:disable variable-name */





var DURATION_MIN = 0.5;
var DURATION_MAX = 1.0;
var EXTRA_PADDING = 4;
var MUTATION_CONFIG = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true,
};
var LeftArrow = function (_a) {
    var onClick = _a.onClick;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styled__["g" /* ShadowLeft */], null,
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styled__["a" /* ArrowLeftWrapper */], { className: "arrow", onClick: onClick },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_arrow_left___default.a, { label: "left" }))));
};
var RightArrow = function (_a) {
    var onClick = _a.onClick;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styled__["h" /* ShadowRight */], null,
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styled__["b" /* ArrowRightWrapper */], { className: "arrow", onClick: onClick },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_arrow_right___default.a, { label: "right" }))));
};
var FilmstripView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](FilmstripView, _super);
    function FilmstripView(props) {
        var _this = _super.call(this, props) || this;
        _this.previousOffset = 0;
        _this.state = {
            bufferWidth: 0,
            windowWidth: 0,
        };
        _this.handleSizeChange = function () {
            // get the new widths
            var _a = _this, windowElement = _a.windowElement, bufferElement = _a.bufferElement;
            var bufferWidth = 0;
            var windowWidth = 0;
            var childOffsets = [];
            if (windowElement && bufferElement) {
                bufferWidth = bufferElement.getBoundingClientRect().width;
                windowWidth = windowElement.getBoundingClientRect().width;
                // we're calculating `left` based on `width` because `rect.left` can be a negative value after resizing the window (considered scrolled??)
                var children = Array.prototype.slice.call(bufferElement.children, 0);
                var left_1 = 0;
                childOffsets = children.map(function (child, index) {
                    var width = child.getBoundingClientRect().width;
                    var offset = {
                        left: left_1,
                        right: left_1 + width - 1,
                    };
                    left_1 += width;
                    return offset;
                });
            }
            // make sure the state has changed before we update state and notify the integrator
            // (otherwise, since this method() is called in componentDidUpdate() we'll recurse until the stack size is exceeded)
            var _b = _this.state, prevBufferWidth = _b.bufferWidth, prevWindowWidth = _b.windowWidth;
            if (bufferWidth === prevBufferWidth && windowWidth === prevWindowWidth) {
                // NOTE: we're not checking here if childOffsets has changed... if the children change size but
                // result in the exact same size buffer, we're not going to update, resulting in incorrect navigations
                return;
            }
            // store the widths
            _this.setState({
                bufferWidth: bufferWidth,
                windowWidth: windowWidth,
            }, function () {
                _this.childOffsets = childOffsets;
                // notify the integrator
                var onSize = _this.props.onSize;
                if (onSize) {
                    onSize({
                        offset: Math.min(_this.maxOffset, _this.offset),
                        offsets: childOffsets,
                        width: windowWidth,
                        minOffset: _this.minOffset,
                        maxOffset: _this.maxOffset,
                    });
                }
            });
        };
        _this.handleWindowElementChange = function (windowElement) {
            _this.windowElement = windowElement;
            _this.handleSizeChange();
        };
        _this.handleBufferElementChange = function (bufferElement) {
            if (!bufferElement) {
                return;
            }
            _this.bufferElement = bufferElement;
            _this.handleSizeChange();
            _this.initMutationObserver();
        };
        _this.handleMutation = function (mutationList) {
            // there are edge cases where the DOM may change outside of the normal React life-cycle
            // https://product-fabric.atlassian.net/browse/MSW-425
            _this.handleSizeChange();
        };
        _this.handleLeftClick = function (event) {
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            var onScroll = _this.props.onScroll;
            if (onScroll) {
                var windowWidth = _this.state.windowWidth;
                var newOffset = _this.getClosestForLeft(_this.offset - windowWidth);
                onScroll({
                    direction: 'left',
                    offset: newOffset,
                    animate: true,
                });
            }
        };
        _this.handleRightClick = function (event) {
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            var onScroll = _this.props.onScroll;
            if (onScroll) {
                var windowWidth = _this.state.windowWidth;
                var newOffset = _this.getClosestForRight(_this.offset + windowWidth);
                onScroll({
                    direction: 'right',
                    offset: newOffset,
                    animate: true,
                });
            }
        };
        _this.handleScroll = function (event) {
            var isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);
            if (!isHorizontalScroll) {
                return;
            }
            // don't actually let the element scroll because we'll fake scrolling with `transform: translateX()`
            event.preventDefault();
            // notify the integrator of the offset change
            var onScroll = _this.props.onScroll;
            if (onScroll && isHorizontalScroll) {
                var newOffset = Math.max(_this.minOffset, Math.min(_this.maxOffset, _this.offset + event.deltaX));
                onScroll({
                    direction: event.deltaX < 0 ? 'left' : 'right',
                    offset: newOffset,
                    animate: false,
                });
            }
        };
        try {
            _this.mutationObserver = new MutationObserver(__WEBPACK_IMPORTED_MODULE_4_debounce__(_this.handleMutation, 30, true));
        }
        catch (e) {
            // in the case where we are running on an unsupported browser,
            // or where tests include the FilmstripView but do not mock the MutationObserver - we catch it and handle safely here.
            // NOTE: this won't effect the component, it just means mutations won't be observerd
        }
        return _this;
    }
    Object.defineProperty(FilmstripView.prototype, "offset", {
        get: function () {
            var offset = this.props.offset;
            if (!offset) {
                return 0;
            }
            return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilmstripView.prototype, "minOffset", {
        get: function () {
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilmstripView.prototype, "maxOffset", {
        /**
         * The furthest we can scroll, where the end of the buffer is just in view
         */
        get: function () {
            var _a = this.state, bufferWidth = _a.bufferWidth, windowWidth = _a.windowWidth;
            return Math.max(this.minOffset, bufferWidth - windowWidth - 1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilmstripView.prototype, "canGoLeft", {
        get: function () {
            return this.offset > this.minOffset;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilmstripView.prototype, "canGoRight", {
        get: function () {
            return this.offset < this.maxOffset;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilmstripView.prototype, "transitionDuration", {
        get: function () {
            var animate = this.props.animate;
            var windowWidth = this.state.windowWidth;
            if (!animate) {
                return 0;
            }
            if (Math.abs(this.offset - this.previousOffset) < 1e-6) {
                return DURATION_MIN;
            }
            else {
                var diff = Math.abs(this.offset - this.previousOffset);
                var relativeOffset = diff / windowWidth;
                var duration = DURATION_MAX - DURATION_MIN * relativeOffset;
                return Math.max(Math.min(duration, DURATION_MAX), DURATION_MIN);
            }
        },
        enumerable: true,
        configurable: true
    });
    FilmstripView.prototype.initMutationObserver = function () {
        var mutationObserver = this.mutationObserver;
        if (mutationObserver) {
            mutationObserver.disconnect();
            mutationObserver.observe(this.bufferElement, MUTATION_CONFIG);
        }
    };
    FilmstripView.prototype.triggerScrollEvent = function () {
        if (!this.windowElement) {
            return;
        }
        var event = document.createEvent('MouseEvents');
        event.initEvent('scroll', true, true);
        this.windowElement.dispatchEvent(event);
    };
    // find the child that is cut off on the left edge of the window and change the window offset to
    // start to the left of that child
    FilmstripView.prototype.getClosestForLeft = function (offset) {
        var leftWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset));
        for (var i = 0; i < this.childOffsets.length; ++i) {
            var childBounds = this.childOffsets[i];
            if (leftWindowEdge >= childBounds.left &&
                leftWindowEdge <= childBounds.right) {
                var newOffset = childBounds.left;
                if (newOffset >= EXTRA_PADDING) {
                    return newOffset - EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                }
                else {
                    return newOffset;
                }
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    };
    // find the child that is cut off on the right edge of the window and change the window offset
    // to finish at start of the next child
    FilmstripView.prototype.getClosestForRight = function (offset) {
        var windowWidth = this.state.windowWidth;
        var rightWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset)) + windowWidth;
        for (var i = 0; i < this.childOffsets.length; ++i) {
            var childBounds = this.childOffsets[i];
            if (rightWindowEdge >= childBounds.left &&
                rightWindowEdge <= childBounds.right) {
                var newOffset = childBounds.right - windowWidth;
                if (newOffset + EXTRA_PADDING <= this.maxOffset) {
                    return newOffset + EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                }
                else {
                    return newOffset;
                }
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    };
    FilmstripView.prototype.renderLeftArrow = function () {
        var canGoLeft = this.canGoLeft;
        if (!canGoLeft) {
            return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](LeftArrow, { onClick: this.handleLeftClick });
    };
    FilmstripView.prototype.renderRightArrow = function () {
        var canGoRight = this.canGoRight;
        if (!canGoRight) {
            return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](RightArrow, { onClick: this.handleRightClick });
    };
    FilmstripView.prototype.componentDidMount = function () {
        this.previousOffset = this.offset;
        window.addEventListener('resize', this.handleSizeChange);
    };
    FilmstripView.prototype.componentWillUnmount = function () {
        var mutationObserver = this.mutationObserver;
        window.removeEventListener('resize', this.handleSizeChange);
        if (mutationObserver) {
            mutationObserver.disconnect();
        }
    };
    FilmstripView.prototype.componentDidUpdate = function () {
        var _this = this;
        this.previousOffset = this.offset;
        // trigger a "real" scroll event so lazily loaded cards realize they've been shown
        // note: we have to wait for the transition to end, otherwise the cards not visible when the scroll
        // event is triggered will be forever stuck in the loading screen (due to the lazy load)
        window.setTimeout(function () { return _this.triggerScrollEvent(); }, this.transitionDuration * 1000);
    };
    FilmstripView.prototype.render = function () {
        var _a = this.props, animate = _a.animate, children = _a.children;
        var transform = "translateX(" + -this.offset + "px)";
        var transitionProperty = animate ? 'transform' : 'none';
        var transitionDuration = this.transitionDuration + "s";
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styled__["f" /* FilmStripViewWrapper */], null,
            this.renderLeftArrow(),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styled__["e" /* FilmStripListWrapper */], { innerRef: this.handleWindowElementChange, onWheel: this.handleScroll },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styled__["c" /* FilmStripList */], { innerRef: this.handleBufferElementChange, style: { transform: transform, transitionProperty: transitionProperty, transitionDuration: transitionDuration } }, __WEBPACK_IMPORTED_MODULE_1_react__["Children"].map(children, mapReactChildToReactNode))),
            this.renderRightArrow()));
    };
    FilmstripView.defaultProps = {
        animate: false,
        offset: 0,
    };
    return FilmstripView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

function mapReactChildToReactNode(child, index) {
    var key = (isReactElement(child) && child.key) || index;
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styled__["d" /* FilmStripListItem */], { key: key }, child);
}
function isReactElement(child) {
    return !!child.type;
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(853);

var defaultTheme = {
  mode: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_THEME_MODE */]
};
function getTheme(props) {
  if (props && props.theme && props.theme.__ATLASKIT_THEME__) {
    // $FlowFixMe - cannot narrow type between input types
    return props.theme.__ATLASKIT_THEME__;
  } else if (props && props.theme && props.theme.mode) {
    // $FlowFixMe - cannot narrow type between input types
    return props.theme;
  }

  return defaultTheme;
}

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FLATTENED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_THEME_MODE; });
/* unused harmony export THEME_MODES */
var FLATTENED = '__FLATTENED__';
var CHANNEL = '__ATLASKIT_THEME__';
var DEFAULT_THEME_MODE = 'light';
var THEME_MODES = ['light', 'dark'];

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultTransitionDuration; });
var defaultTransitionDuration = '.3s';
//# sourceMappingURL=config.js.map

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardActionIconButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled__ = __webpack_require__(461);




var CardActionIconButton = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CardActionIconButton, _super);
    function CardActionIconButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardActionIconButton.prototype.render = function () {
        var _a = this.props, icon = _a.icon, triggerColor = _a.triggerColor, onClick = _a.onClick;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["a" /* CardActionButton */], { onClick: onClick, style: { color: triggerColor } }, icon));
    };
    return CardActionIconButton;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=cardActionIconButton.js.map

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardActionsDropdownMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_more__ = __webpack_require__(2614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_more___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_more__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_dropdown_menu__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styled__ = __webpack_require__(461);






var CardActionsDropdownMenu = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CardActionsDropdownMenu, _super);
    function CardActionsDropdownMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardActionsDropdownMenu.prototype.render = function () {
        var _a = this.props, actions = _a.actions, triggerColor = _a.triggerColor, onOpenChange = _a.onOpenChange;
        if (actions.length > 0) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_dropdown_menu__["c" /* default */], { onOpenChange: onOpenChange, trigger: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styled__["a" /* CardActionButton */], { style: { color: triggerColor } },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_more___default.a, { label: "more" })) },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_dropdown_menu__["b" /* DropdownItemGroup */], null, actions.map(function (_a, index) {
                    var label = _a.label, handler = _a.handler;
                    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_dropdown_menu__["a" /* DropdownItem */], { key: index, onClick: handler }, label));
                }))));
        }
        else {
            return null;
        }
    };
    return CardActionsDropdownMenu;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=cardActionsDropdownMenu.js.map

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GRID_GUTTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gridStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);

// @ts-ignore: unused variable



var GRID_GUTTER = 12;
var gridStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .gridParent {\n    width: calc(100% + ", "px);\n    margin-left: -", "px;\n    margin-right: -", "px;\n    transform: scale(1);\n    z-index: ", ";\n  }\n\n  .gridContainer {\n    position: fixed;\n    height: 100vh;\n    width: 100%;\n    pointer-events: none;\n  }\n\n  .gridLine {\n    border-left: 1px solid ", ";\n    display: inline-block;\n    box-sizing: border-box;\n    height: 100%;\n    margin-left: -1px;\n\n    transition: border-color 0.15s linear;\n    z-index: 0;\n  }\n\n  .gridContainer.hidden .gridLine {\n    border-left: 1px solid transparent;\n  }\n\n  .highlight {\n    border-left: 1px solid ", ";\n  }\n"], ["\n  .gridParent {\n    width: calc(100% + ", "px);\n    margin-left: -", "px;\n    margin-right: -", "px;\n    transform: scale(1);\n    z-index: ", ";\n  }\n\n  .gridContainer {\n    position: fixed;\n    height: 100vh;\n    width: 100%;\n    pointer-events: none;\n  }\n\n  .gridLine {\n    border-left: 1px solid ", ";\n    display: inline-block;\n    box-sizing: border-box;\n    height: 100%;\n    margin-left: -1px;\n\n    transition: border-color 0.15s linear;\n    z-index: 0;\n  }\n\n  .gridContainer.hidden .gridLine {\n    border-left: 1px solid transparent;\n  }\n\n  .highlight {\n    border-left: 1px solid ", ";\n  }\n"])), GRID_GUTTER * 2, GRID_GUTTER, GRID_GUTTER, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["q" /* akEditorGridLineZIndex */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30A, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B200);
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export availablePanelType */
/* unused harmony export getPluginState */
/* unused harmony export setPluginState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluginKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nodeviews_panel__ = __webpack_require__(2636);




var availablePanelType = [
    'info',
    'note',
    'success',
    'warning',
    'error',
];
var getPluginState = function (state) {
    return pluginKey.getState(state);
};
var setPluginState = function (stateProps) { return function (state, dispatch) {
    var pluginState = getPluginState(state);
    dispatch(state.tr.setMeta(pluginKey, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, stateProps)));
    return true;
}; };
var pluginKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('panelPlugin');
var createPlugin = function (_a) {
    var portalProviderAPI = _a.portalProviderAPI, dispatch = _a.dispatch, providerFactory = _a.providerFactory;
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        state: {
            init: function (config, state) {
                return {
                    element: null,
                    activePanelType: undefined,
                    toolbarVisible: false,
                };
            },
            apply: function (tr, pluginState, oldState, newState) {
                var nextPluginState = tr.getMeta(pluginKey);
                if (nextPluginState) {
                    dispatch(pluginKey, nextPluginState);
                    return nextPluginState;
                }
                return pluginState;
            },
        },
        key: pluginKey,
        view: function (view) {
            return {
                update: function (view, prevState) {
                    var _a = view.state, selection = _a.selection, panel = _a.schema.nodes.panel;
                    var pluginState = getPluginState(view.state);
                    var parent = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["findParentNodeOfType"])(panel)(selection);
                    var parentDOM = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["findParentDomRefOfType"])(panel, view.domAtPos.bind(view))(selection);
                    if (parentDOM !== pluginState.element) {
                        setPluginState({
                            element: parentDOM,
                            activePanelType: parent && parent.node.attrs['panelType'],
                            toolbarVisible: !!parent,
                        })(view.state, view.dispatch);
                        return true;
                    }
                    /** Plugin dispatch needed to reposition the toolbar */
                    dispatch(pluginKey, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState));
                },
            };
        },
        props: {
            nodeViews: {
                panel: Object(__WEBPACK_IMPORTED_MODULE_3__nodeviews_panel__["a" /* panelNodeView */])(portalProviderAPI),
            },
            handleDOMEvents: {
                blur: function (view, event) {
                    var pluginState = getPluginState(view.state);
                    if (pluginState.toolbarVisible) {
                        setPluginState({
                            toolbarVisible: false,
                            element: null,
                            activePanelType: undefined,
                        })(view.state, view.dispatch);
                        return true;
                    }
                    return false;
                },
            },
        },
    });
};
//# sourceMappingURL=main.js.map

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// HTML5 entities map: { name -> utf16string }
//


/*eslint quotes:0*/
module.exports = __webpack_require__(369);


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



module.exports.encode = __webpack_require__(622);
module.exports.decode = __webpack_require__(623);
module.exports.format = __webpack_require__(2644);
module.exports.parse  = __webpack_require__(2645);


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Regexps to match html elements



var attr_name     = '[a-zA-Z_:][a-zA-Z0-9:._-]*';

var unquoted      = '[^"\'=<>`\\x00-\\x20]+';
var single_quoted = "'[^']*'";
var double_quoted = '"[^"]*"';

var attr_value  = '(?:' + unquoted + '|' + single_quoted + '|' + double_quoted + ')';

var attribute   = '(?:\\s+' + attr_name + '(?:\\s*=\\s*' + attr_value + ')?)';

var open_tag    = '<[A-Za-z][A-Za-z0-9\\-]*' + attribute + '*\\s*\\/?>';

var close_tag   = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
var comment     = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
var processing  = '<[?].*?[?]>';
var declaration = '<![A-Z]+\\s+[^>]*>';
var cdata       = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';

var HTML_TAG_RE = new RegExp('^(?:' + open_tag + '|' + close_tag + '|' + comment +
                        '|' + processing + '|' + declaration + '|' + cdata + ')');
var HTML_OPEN_CLOSE_TAG_RE = new RegExp('^(?:' + open_tag + '|' + close_tag + ')');

module.exports.HTML_TAG_RE = HTML_TAG_RE;
module.exports.HTML_OPEN_CLOSE_TAG_RE = HTML_OPEN_CLOSE_TAG_RE;


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ~~strike through~~
//



// Insert each marker as a separate text token, and add it to delimiter list
//
module.exports.tokenize = function strikethrough(state, silent) {
  var i, scanned, token, len, ch,
      start = state.pos,
      marker = state.src.charCodeAt(start);

  if (silent) { return false; }

  if (marker !== 0x7E/* ~ */) { return false; }

  scanned = state.scanDelims(state.pos, true);
  len = scanned.length;
  ch = String.fromCharCode(marker);

  if (len < 2) { return false; }

  if (len % 2) {
    token         = state.push('text', '', 0);
    token.content = ch;
    len--;
  }

  for (i = 0; i < len; i += 2) {
    token         = state.push('text', '', 0);
    token.content = ch + ch;

    state.delimiters.push({
      marker: marker,
      jump:   i,
      token:  state.tokens.length - 1,
      level:  state.level,
      end:    -1,
      open:   scanned.can_open,
      close:  scanned.can_close
    });
  }

  state.pos += scanned.length;

  return true;
};


// Walk through delimiter list and replace text tokens with tags
//
module.exports.postProcess = function strikethrough(state) {
  var i, j,
      startDelim,
      endDelim,
      token,
      loneMarkers = [],
      delimiters = state.delimiters,
      max = state.delimiters.length;

  for (i = 0; i < max; i++) {
    startDelim = delimiters[i];

    if (startDelim.marker !== 0x7E/* ~ */) {
      continue;
    }

    if (startDelim.end === -1) {
      continue;
    }

    endDelim = delimiters[startDelim.end];

    token         = state.tokens[startDelim.token];
    token.type    = 's_open';
    token.tag     = 's';
    token.nesting = 1;
    token.markup  = '~~';
    token.content = '';

    token         = state.tokens[endDelim.token];
    token.type    = 's_close';
    token.tag     = 's';
    token.nesting = -1;
    token.markup  = '~~';
    token.content = '';

    if (state.tokens[endDelim.token - 1].type === 'text' &&
        state.tokens[endDelim.token - 1].content === '~') {

      loneMarkers.push(endDelim.token - 1);
    }
  }

  // If a marker sequence has an odd number of characters, it's splitted
  // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
  // start of the sequence.
  //
  // So, we have to move all those markers after subsequent s_close tags.
  //
  while (loneMarkers.length) {
    i = loneMarkers.pop();
    j = i + 1;

    while (j < state.tokens.length && state.tokens[j].type === 's_close') {
      j++;
    }

    j--;

    if (i !== j) {
      token = state.tokens[j];
      state.tokens[j] = state.tokens[i];
      state.tokens[i] = token;
    }
  }
};


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process *this* and _that_
//



// Insert each marker as a separate text token, and add it to delimiter list
//
module.exports.tokenize = function emphasis(state, silent) {
  var i, scanned, token,
      start = state.pos,
      marker = state.src.charCodeAt(start);

  if (silent) { return false; }

  if (marker !== 0x5F /* _ */ && marker !== 0x2A /* * */) { return false; }

  scanned = state.scanDelims(state.pos, marker === 0x2A);

  for (i = 0; i < scanned.length; i++) {
    token         = state.push('text', '', 0);
    token.content = String.fromCharCode(marker);

    state.delimiters.push({
      // Char code of the starting marker (number).
      //
      marker: marker,

      // Total length of these series of delimiters.
      //
      length: scanned.length,

      // An amount of characters before this one that's equivalent to
      // current one. In plain English: if this delimiter does not open
      // an emphasis, neither do previous `jump` characters.
      //
      // Used to skip sequences like "*****" in one step, for 1st asterisk
      // value will be 0, for 2nd it's 1 and so on.
      //
      jump:   i,

      // A position of the token this delimiter corresponds to.
      //
      token:  state.tokens.length - 1,

      // Token level.
      //
      level:  state.level,

      // If this delimiter is matched as a valid opener, `end` will be
      // equal to its position, otherwise it's `-1`.
      //
      end:    -1,

      // Boolean flags that determine if this delimiter could open or close
      // an emphasis.
      //
      open:   scanned.can_open,
      close:  scanned.can_close
    });
  }

  state.pos += scanned.length;

  return true;
};


// Walk through delimiter list and replace text tokens with tags
//
module.exports.postProcess = function emphasis(state) {
  var i,
      startDelim,
      endDelim,
      token,
      ch,
      isStrong,
      delimiters = state.delimiters,
      max = state.delimiters.length;

  for (i = max - 1; i >= 0; i--) {
    startDelim = delimiters[i];

    if (startDelim.marker !== 0x5F/* _ */ && startDelim.marker !== 0x2A/* * */) {
      continue;
    }

    // Process only opening markers
    if (startDelim.end === -1) {
      continue;
    }

    endDelim = delimiters[startDelim.end];

    // If the previous delimiter has the same marker and is adjacent to this one,
    // merge those into one strong delimiter.
    //
    // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
    //
    isStrong = i > 0 &&
               delimiters[i - 1].end === startDelim.end + 1 &&
               delimiters[i - 1].token === startDelim.token - 1 &&
               delimiters[startDelim.end + 1].token === endDelim.token + 1 &&
               delimiters[i - 1].marker === startDelim.marker;

    ch = String.fromCharCode(startDelim.marker);

    token         = state.tokens[startDelim.token];
    token.type    = isStrong ? 'strong_open' : 'em_open';
    token.tag     = isStrong ? 'strong' : 'em';
    token.nesting = 1;
    token.markup  = isStrong ? ch + ch : ch;
    token.content = '';

    token         = state.tokens[endDelim.token];
    token.type    = isStrong ? 'strong_close' : 'em_close';
    token.tag     = isStrong ? 'strong' : 'em';
    token.nesting = -1;
    token.markup  = isStrong ? ch + ch : ch;
    token.content = '';

    if (isStrong) {
      state.tokens[delimiters[i - 1].token].content = '';
      state.tokens[delimiters[startDelim.end + 1].token].content = '';
      i--;
    }
  }
};


/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isPastedFromWord */
/* unused harmony export isPastedFromExcel */
/* unused harmony export isPastedFromDropboxPaper */
/* unused harmony export isPastedFromGoogleDocs */
/* unused harmony export isPastedFromGoogleSpreadSheets */
/* unused harmony export isPastedFromPages */
/* unused harmony export isPastedFromFabricEditor */
/* unused harmony export isSingleLine */
/* harmony export (immutable) */ __webpack_exports__["b"] = getPasteSource;
/* unused harmony export isCode */
/* harmony export (immutable) */ __webpack_exports__["a"] = escapeLinks;
function isPastedFromWord(html) {
    return !!html && html.indexOf('urn:schemas-microsoft-com:office:word') >= 0;
}
function isPastedFromExcel(html) {
    return !!html && html.indexOf('urn:schemas-microsoft-com:office:excel') >= 0;
}
function isPastedFromDropboxPaper(html) {
    return !!html && !!html.match(/class=\"\s?author-d-.+"/gim);
}
function isPastedFromGoogleDocs(html) {
    return !!html && !!html.match(/id=\"docs-internal-guid-.+"/gim);
}
function isPastedFromGoogleSpreadSheets(html) {
    return !!html && !!html.match(/data-sheets-.+=/gim);
}
function isPastedFromPages(html) {
    return !!html && html.indexOf('content="Cocoa HTML Writer"') >= 0;
}
function isPastedFromFabricEditor(html) {
    return !!html && html.indexOf('data-pm-slice="') >= 0;
}
var isSingleLine = function (text) {
    return !!text && text.trim().split('\n').length === 1;
};
function getPasteSource(event) {
    var html = event.clipboardData.getData('text/html');
    if (isPastedFromDropboxPaper(html)) {
        return 'dropbox-paper';
    }
    else if (isPastedFromWord(html)) {
        return 'microsoft-word';
    }
    else if (isPastedFromExcel(html)) {
        return 'microsoft-excel';
    }
    else if (isPastedFromGoogleDocs(html)) {
        return 'google-docs';
    }
    else if (isPastedFromGoogleSpreadSheets(html)) {
        return 'google-spreadsheets';
    }
    else if (isPastedFromPages(html)) {
        return 'apple-pages';
    }
    else if (isPastedFromFabricEditor(html)) {
        return 'fabric-editor';
    }
    return 'other';
}
// TODO: Write JEST tests for this part
function isCode(str) {
    var lines = str.split(/\r?\n|\r/);
    if (3 > lines.length) {
        return false;
    }
    var weight = 0;
    lines.forEach(function (line) {
        // Ends with : or ;
        if (/[:;]$/.test(line)) {
            weight++;
        }
        // Contains second and third braces
        if (/[{}\[\]]/.test(line)) {
            weight++;
        }
        // Contains <tag> or </
        if (/<\w+>/.test(line) || /<\//.test(line)) {
            weight++;
        }
        // Contains () <- function calls
        if (/\(\)/.test(line)) {
            weight++;
        }
        // Contains a link
        if (/(^|[^!])\[(.*?)\]\((\S+)\)$/.test(line)) {
            weight--;
        }
        // New line starts with less than two chars. e.g- if, {, <, etc
        var token = /^(\s+)[a-zA-Z<{]{2,}/.exec(line);
        if (token && 2 <= token[1].length) {
            weight++;
        }
        if (/&&/.test(line)) {
            weight++;
        }
    });
    return 4 <= weight && weight >= 0.5 * lines.length;
}
// @see https://product-fabric.atlassian.net/browse/ED-3159
// @see https://github.com/markdown-it/markdown-it/issues/38
function escapeLinks(text) {
    return text.replace(/(\[([^\]]+)\]\()?((https?|ftp):\/\/[^\s]+)/g, function (str) {
        return str.match(/^(https?|ftp):\/\/[^\s]+$/) ? "<" + str + ">" : str;
    });
}
//# sourceMappingURL=util.js.map

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_decision__ = __webpack_require__(2710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_decision___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_decision__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled_DecisionItem__ = __webpack_require__(2713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Item__ = __webpack_require__(866);






var DecisionItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](DecisionItem, _super);
    function DecisionItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DecisionItem.prototype.getAttributionText = function () {
        var _a = this.props, creator = _a.creator, lastUpdater = _a.lastUpdater;
        var user = lastUpdater || creator;
        if (!user || !user.displayName) {
            return undefined;
        }
        return "Captured by " + user.displayName;
    };
    DecisionItem.prototype.render = function () {
        var _a = this.props, appearance = _a.appearance, children = _a.children, contentRef = _a.contentRef, participants = _a.participants, placeholder = _a.placeholder, showPlaceholder = _a.showPlaceholder;
        var icon = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled_DecisionItem__["a" /* EditorIconWrapper */], { showPlaceholder: showPlaceholder },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_decision___default.a, { label: "Decision", size: "large" })));
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Item__["a" /* default */], { appearance: appearance, contentRef: contentRef, icon: icon, participants: participants, placeholder: placeholder, showPlaceholder: showPlaceholder, attribution: this.getAttributionText() }, children));
    };
    DecisionItem.defaultProps = {
        appearance: 'inline',
    };
    return DecisionItem;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (DecisionItem);
//# sourceMappingURL=DecisionItem.js.map

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Participants__ = __webpack_require__(2714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled_Item__ = __webpack_require__(2715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styled_Placeholder__ = __webpack_require__(2716);






var Item = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Item, _super);
    function Item() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Item.prototype.renderPlaceholder = function () {
        var _a = this.props, children = _a.children, placeholder = _a.placeholder, showPlaceholder = _a.showPlaceholder;
        if (!showPlaceholder || !placeholder || children) {
            return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styled_Placeholder__["a" /* Placeholder */], { contentEditable: false }, placeholder);
    };
    Item.prototype.renderParticipants = function () {
        var _a = this.props, appearance = _a.appearance, _b = _a.participants, participants = _b === void 0 ? [] : _b;
        if (appearance === 'inline' || !participants.length) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled_Item__["d" /* ParticipantWrapper */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Participants__["a" /* default */], { participants: participants })));
    };
    Item.prototype.renderAttribution = function () {
        var attribution = this.props.attribution;
        if (!attribution) {
            return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled_Item__["a" /* AttributionWrapper */], null, attribution);
    };
    Item.prototype.renderCardAppearance = function () {
        var _a = this.props, appearance = _a.appearance, contentRef = _a.contentRef, children = _a.children, icon = _a.icon;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled_Item__["e" /* Wrapper */], { appearance: appearance },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled_Item__["b" /* CardHeadingWrapper */], null,
                icon,
                this.renderParticipants(),
                this.renderPlaceholder()),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled_Item__["c" /* ContentWrapper */], { innerRef: contentRef }, children),
            this.renderAttribution()));
    };
    Item.prototype.renderMessageAppearance = function () {
        var _a = this.props, appearance = _a.appearance, contentRef = _a.contentRef, children = _a.children, icon = _a.icon;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled_Item__["e" /* Wrapper */], { appearance: appearance },
            icon,
            this.renderPlaceholder(),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled_Item__["c" /* ContentWrapper */], { innerRef: contentRef }, children)));
    };
    Item.prototype.render = function () {
        var appearance = this.props.appearance;
        if (appearance === 'card') {
            return this.renderCardAppearance();
        }
        return this.renderMessageAppearance();
    };
    Item.defaultProps = {
        appearance: 'inline',
    };
    return Item;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Item);
//# sourceMappingURL=Item.js.map

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultLimit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultSortCriteria; });
var defaultLimit = 100;
var defaultSortCriteria = 'creationDate';
//# sourceMappingURL=constants.js.map

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TaskItem__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_analytics_namespaced_context__ = __webpack_require__(248);





var ResourcedTaskItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ResourcedTaskItem, _super);
    function ResourcedTaskItem(props) {
        var _this = _super.call(this, props) || this;
        _this.onUpdate = function (state) {
            _this.setState({ isDone: state === 'DONE' });
        };
        _this.handleOnChange = function (taskId, isDone) {
            var _a = _this.props, taskDecisionProvider = _a.taskDecisionProvider, objectAri = _a.objectAri, containerAri = _a.containerAri, onChange = _a.onChange;
            // Optimistically update the task
            _this.setState({ isDone: isDone });
            if (taskDecisionProvider && containerAri && objectAri) {
                // Call provider to update task
                taskDecisionProvider.then(function (provider) {
                    if (!_this.mounted) {
                        return;
                    }
                    provider.toggleTask({ localId: taskId, objectAri: objectAri, containerAri: containerAri }, isDone ? 'DONE' : 'TODO');
                    // onChange could trigger a rerender, in order to get the correct state
                    // we should only call onChange once the internal state have been modified
                    if (onChange) {
                        onChange(taskId, isDone);
                    }
                    if (isDone) {
                        // Undefined provider.getCurrentUser or currentUser shows 'Created By'
                        // ie. does not update to prevent incorrect 'Completed By' message
                        _this.setState({
                            lastUpdater: provider.getCurrentUser
                                ? provider.getCurrentUser()
                                : undefined,
                        });
                    }
                });
            }
            else {
                // No provider - state managed by consumer
                if (onChange) {
                    onChange(taskId, isDone);
                }
            }
        };
        _this.state = {
            isDone: props.isDone,
            lastUpdater: props.lastUpdater,
        };
        return _this;
    }
    ResourcedTaskItem.prototype.componentDidMount = function () {
        this.mounted = true;
        this.subscribe(this.props.taskDecisionProvider, this.props.containerAri, this.props.objectAri);
    };
    ResourcedTaskItem.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.taskDecisionProvider !== this.props.taskDecisionProvider ||
            nextProps.containerAri !== this.props.containerAri ||
            nextProps.objectAri !== this.props.objectAri) {
            this.unsubscribe();
            this.subscribe(nextProps.taskDecisionProvider, nextProps.containerAri, nextProps.objectAri);
        }
    };
    ResourcedTaskItem.prototype.componentWillUnmount = function () {
        this.unsubscribe();
        this.mounted = false;
    };
    ResourcedTaskItem.prototype.subscribe = function (taskDecisionProvider, containerAri, objectAri) {
        var _this = this;
        if (taskDecisionProvider && containerAri && objectAri) {
            taskDecisionProvider.then(function (provider) {
                if (!_this.mounted) {
                    return;
                }
                var taskId = _this.props.taskId;
                provider.subscribe({ localId: taskId, objectAri: objectAri, containerAri: containerAri }, _this.onUpdate);
            });
        }
    };
    ResourcedTaskItem.prototype.unsubscribe = function () {
        var _this = this;
        var _a = this.props, taskDecisionProvider = _a.taskDecisionProvider, taskId = _a.taskId, objectAri = _a.objectAri, containerAri = _a.containerAri;
        if (taskDecisionProvider && containerAri && objectAri) {
            taskDecisionProvider.then(function (provider) {
                provider.unsubscribe({ localId: taskId, objectAri: objectAri, containerAri: containerAri }, _this.onUpdate);
            });
        }
    };
    ResourcedTaskItem.prototype.render = function () {
        var _a = this.state, isDone = _a.isDone, lastUpdater = _a.lastUpdater;
        var _b = this.props, appearance = _b.appearance, children = _b.children, containerAri = _b.containerAri, contentRef = _b.contentRef, creator = _b.creator, objectAri = _b.objectAri, participants = _b.participants, showParticipants = _b.showParticipants, showPlaceholder = _b.showPlaceholder, placeholder = _b.placeholder, taskId = _b.taskId, disabled = _b.disabled;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_analytics_namespaced_context__["a" /* FabricElementsAnalyticsContext */], { data: {
                containerAri: containerAri,
                objectAri: objectAri,
            } },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__TaskItem__["a" /* default */], { isDone: isDone, taskId: taskId, onChange: this.handleOnChange, appearance: appearance, contentRef: contentRef, participants: participants, showParticipants: showParticipants, showPlaceholder: showPlaceholder, placeholder: placeholder, creator: creator, lastUpdater: lastUpdater, disabled: disabled }, children)));
    };
    ResourcedTaskItem.defaultProps = {
        appearance: 'inline',
    };
    return ResourcedTaskItem;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (ResourcedTaskItem);
//# sourceMappingURL=ResourcedTaskItem.js.map

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TaskItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled_TaskItem__ = __webpack_require__(2730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Item__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_analytics_next__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__analytics__ = __webpack_require__(2731);







var taskCount = 0;
var getCheckBoxId = function (localId) { return localId + "-" + taskCount++; };
var TaskItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](TaskItem, _super);
    function TaskItem(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnChange = function (evt) {
            var _a = _this.props, onChange = _a.onChange, taskId = _a.taskId, isDone = _a.isDone, createAnalyticsEvent = _a.createAnalyticsEvent;
            var newIsDone = !isDone;
            if (onChange) {
                onChange(taskId, newIsDone);
            }
            var action = newIsDone ? 'checked' : 'unchecked';
            if (createAnalyticsEvent) {
                Object(__WEBPACK_IMPORTED_MODULE_5__analytics__["a" /* createAndFireEventInElementsChannel */])({
                    action: action,
                    actionSubject: 'action',
                    eventType: 'ui',
                    attributes: {
                        localId: taskId,
                    },
                })(createAnalyticsEvent);
            }
        };
        _this.checkBoxId = getCheckBoxId(props.taskId);
        return _this;
    }
    TaskItem.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.taskId !== this.props.taskId) {
            this.checkBoxId = getCheckBoxId(nextProps.taskId);
        }
    };
    TaskItem.prototype.getAttributionText = function () {
        var _a = this.props, creator = _a.creator, lastUpdater = _a.lastUpdater, isDone = _a.isDone;
        if (isDone && lastUpdater) {
            return "Completed by " + lastUpdater.displayName;
        }
        if (!creator || !creator.displayName) {
            return undefined;
        }
        return "Added by " + creator.displayName;
    };
    TaskItem.prototype.render = function () {
        var _a = this.props, appearance = _a.appearance, isDone = _a.isDone, contentRef = _a.contentRef, children = _a.children, participants = _a.participants, placeholder = _a.placeholder, showPlaceholder = _a.showPlaceholder, disabled = _a.disabled;
        var icon = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled_TaskItem__["a" /* CheckBoxWrapper */], { contentEditable: false },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input", { id: this.checkBoxId, name: this.checkBoxId, type: "checkbox", onChange: this.handleOnChange, checked: !!isDone, disabled: !!disabled }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("label", { htmlFor: this.checkBoxId })));
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Item__["a" /* default */], { appearance: appearance, contentRef: contentRef, icon: icon, participants: participants, placeholder: placeholder, showPlaceholder: showPlaceholder, attribution: this.getAttributionText() }, children));
    };
    TaskItem.defaultProps = {
        appearance: 'inline',
    };
    return TaskItem;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

// This is to ensure that the "type" is exported, as it gets lost and not exported along with TaskItem after
// going through the high order component.
// tslint:disable-next-line:variable-name
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_analytics_next__["withAnalyticsEvents"])()(TaskItem));
//# sourceMappingURL=TaskItem.js.map

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_analytics_next__ = __webpack_require__(29);


var createNamespaceContext = function (namespace, displayName) {
    if (displayName === void 0) { displayName = 'NamespacedContext'; }
    var Component = function (props) {
        var _a;
        var newData = (_a = {},
            _a[namespace] = props.data,
            _a);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__atlaskit_analytics_next__["AnalyticsContext"], { data: newData }, __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(props.children)));
    };
    Component.displayName = displayName;
    return Component;
};
/* harmony default export */ __webpack_exports__["a"] = (createNamespaceContext);
//# sourceMappingURL=createNamespaceContext.js.map

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PubSubSpecialEventType; });
var PubSubSpecialEventType;
(function (PubSubSpecialEventType) {
    PubSubSpecialEventType["ERROR"] = "ERROR";
    PubSubSpecialEventType["CONNECTED"] = "CONNECTED";
    PubSubSpecialEventType["RECONNECT"] = "RECONNECT";
})(PubSubSpecialEventType || (PubSubSpecialEventType = {}));
//# sourceMappingURL=types.js.map

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export convertServiceDecisionToDecision */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertServiceDecisionResponseToDecisionResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return convertServiceTaskToTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return convertServiceTaskStateToBaseItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return convertServiceTaskResponseToTaskResponse; });
/* unused harmony export convertServiceItemToItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return convertServiceItemResponseToItemResponse; });
/* unused harmony export decisionsToDocument */
/* unused harmony export tasksToDocument */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return findIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type_helpers__ = __webpack_require__(299);


var convertServiceDecisionToDecision = function (serviceDecision) {
    var creationDate = serviceDecision.creationDate, lastUpdateDate = serviceDecision.lastUpdateDate, rawContent = serviceDecision.rawContent, contentAsFabricDocument = serviceDecision.contentAsFabricDocument, other = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](serviceDecision, ["creationDate", "lastUpdateDate", "rawContent", "contentAsFabricDocument"]);
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ creationDate: new Date(creationDate), lastUpdateDate: new Date(lastUpdateDate), content: JSON.parse(contentAsFabricDocument) }, other);
};
var convertServiceDecisionResponseToDecisionResponse = function (serviceDecisionResponse, query) {
    var decisions = serviceDecisionResponse.decisions.map(convertServiceDecisionToDecision);
    var nextQuery;
    if (query &&
        serviceDecisionResponse.meta &&
        serviceDecisionResponse.meta.cursor) {
        nextQuery = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, query, { cursor: serviceDecisionResponse.meta.cursor });
    }
    return {
        decisions: decisions,
        nextQuery: nextQuery,
    };
};
var convertServiceTaskToTask = function (serviceTask) {
    var creationDate = serviceTask.creationDate, lastUpdateDate = serviceTask.lastUpdateDate, rawContent = serviceTask.rawContent, contentAsFabricDocument = serviceTask.contentAsFabricDocument, other = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](serviceTask, ["creationDate", "lastUpdateDate", "rawContent", "contentAsFabricDocument"]);
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ creationDate: new Date(creationDate), lastUpdateDate: new Date(lastUpdateDate), content: JSON.parse(contentAsFabricDocument) }, other);
};
var convertServiceTaskStateToBaseItem = function (serviceTaskInfo) {
    var lastUpdateDate = serviceTaskInfo.lastUpdateDate, other = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](serviceTaskInfo, ["lastUpdateDate"]);
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ type: 'TASK', lastUpdateDate: new Date(lastUpdateDate) }, other);
};
var convertServiceTaskResponseToTaskResponse = function (serviceResponse, query) {
    var tasks = serviceResponse.tasks.map(convertServiceTaskToTask);
    var nextQuery;
    if (query && serviceResponse.meta && serviceResponse.meta.cursor) {
        nextQuery = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, query, { cursor: serviceResponse.meta.cursor });
    }
    return {
        tasks: tasks,
        nextQuery: nextQuery,
    };
};
var convertServiceItemToItem = function (items, serviceItem) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__type_helpers__["c" /* isServiceDecision */])(serviceItem)) {
        items.push(convertServiceDecisionToDecision(serviceItem));
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_1__type_helpers__["d" /* isServiceTask */])(serviceItem)) {
        items.push(convertServiceTaskToTask(serviceItem));
    }
    return items;
};
var convertServiceItemResponseToItemResponse = function (serviceResponse, query) {
    var items = serviceResponse.elements.reduce(convertServiceItemToItem, []);
    var nextQuery;
    if (query && serviceResponse.meta && serviceResponse.meta.cursor) {
        nextQuery = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, query, { cursor: serviceResponse.meta.cursor });
    }
    return {
        items: items,
        nextQuery: nextQuery,
    };
};
var decisionsToDocument = function (decisions) { return ({
    type: 'doc',
    version: 1,
    content: [
        {
            type: 'decisionList',
            content: decisions.map(function (decision) {
                var content = decision.content, localId = decision.localId, state = decision.state;
                return {
                    type: 'decisionItem',
                    attrs: {
                        localId: localId,
                        state: state,
                    },
                    content: content,
                };
            }),
        },
    ],
}); };
var tasksToDocument = function (tasks) { return ({
    type: 'doc',
    version: 1,
    content: [
        {
            type: 'taskList',
            content: tasks.map(function (task) {
                var content = task.content, localId = task.localId, state = task.state;
                return {
                    type: 'taskItem',
                    attrs: {
                        localId: localId,
                        state: state,
                    },
                    content: content,
                };
            }),
        },
    ],
}); };
var findIndex = function (array, predicate) {
    var index = -1;
    array.some(function (item, i) {
        if (predicate(item)) {
            index = i;
            return true;
        }
        return false;
    });
    return index;
};
//# sourceMappingURL=TaskDecisionUtils.js.map

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pm_plugins_main__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_ToolbarTextColor__ = __webpack_require__(2744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commands_change_color__ = __webpack_require__(875);
/* unused harmony reexport textColorPluginKey */






var pluginConfig = function (textColorConfig) {
    if (!textColorConfig || typeof textColorConfig === 'boolean') {
        return undefined;
    }
    return textColorConfig;
};
var textColorPlugin = {
    name: 'textColor',
    marks: function () {
        return [{ name: 'textColor', mark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["_19" /* textColor */] }];
    },
    pmPlugins: function () {
        return [
            {
                name: 'textColor',
                plugin: function (_a) {
                    var props = _a.props, dispatch = _a.dispatch;
                    return Object(__WEBPACK_IMPORTED_MODULE_3__pm_plugins_main__["c" /* createPlugin */])(dispatch, pluginConfig(props.allowTextColor));
                },
            },
        ];
    },
    primaryToolbarComponent: function (_a) {
        var editorView = _a.editorView, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, popupsScrollableElement = _a.popupsScrollableElement, disabled = _a.disabled, isToolbarReducedSpacing = _a.isToolbarReducedSpacing;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__ui_WithPluginState__["a" /* default */], { plugins: {
                textColor: __WEBPACK_IMPORTED_MODULE_3__pm_plugins_main__["d" /* pluginKey */],
            }, render: function (_a) {
                var textColor = _a.textColor;
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ui_ToolbarTextColor__["a" /* default */], { pluginState: textColor, isReducedSpacing: isToolbarReducedSpacing, changeColor: function (color) {
                        return Object(__WEBPACK_IMPORTED_MODULE_5__commands_change_color__["a" /* changeColor */])(color)(editorView.state, editorView.dispatch);
                    }, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }));
            } }));
    },
};

/* harmony default export */ __webpack_exports__["a"] = (textColorPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDisabledState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_mark__ = __webpack_require__(278);

var getDisabledState = function (state) {
    var textColor = state.schema.marks.textColor;
    if (textColor) {
        var _a = state.selection, empty = _a.empty, ranges = _a.ranges, $cursor = _a.$cursor;
        if ((empty && !$cursor) ||
            Object(__WEBPACK_IMPORTED_MODULE_0__utils_mark__["a" /* isMarkAllowedInRange */])(state.doc, ranges, textColor) === false) {
            return true;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_mark__["b" /* isMarkExcluded */])(textColor, state.storedMarks || ($cursor && $cursor.marks()))) {
            return true;
        }
        return false;
    }
    return true;
};
//# sourceMappingURL=disabled.js.map

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeColor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toggle_color__ = __webpack_require__(2747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__remove_color__ = __webpack_require__(2748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__ = __webpack_require__(221);



var changeColor = function (color) { return function (state, dispatch) {
    var textColor = state.schema.marks.textColor;
    if (textColor) {
        var pluginState = __WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["d" /* pluginKey */].getState(state);
        if (pluginState.disabled) {
            return false;
        }
        if (color === pluginState.defaultColor) {
            Object(__WEBPACK_IMPORTED_MODULE_1__remove_color__["a" /* removeColor */])()(state, dispatch);
            return true;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__toggle_color__["a" /* toggleColor */])(color)(state, dispatch);
        return true;
    }
    return false;
}; };
//# sourceMappingURL=change-color.js.map

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluginKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return plugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_commands___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands_text_formatting__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keymaps__ = __webpack_require__(38);






var pluginKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('textFormatting');
var getTextFormattingState = function (editorState) {
    var _a = editorState.schema.marks, em = _a.em, code = _a.code, strike = _a.strike, strong = _a.strong, subsup = _a.subsup, underline = _a.underline;
    var state = {};
    if (code) {
        state.codeActive = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* markActive */])(editorState, code.create());
        state.codeDisabled = !Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["toggleMark"])(code)(editorState);
    }
    if (em) {
        state.emActive = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* anyMarkActive */])(editorState, em);
        state.emDisabled = state.codeActive ? true : !Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["toggleMark"])(em)(editorState);
    }
    if (strike) {
        state.strikeActive = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* anyMarkActive */])(editorState, strike);
        state.strikeDisabled = state.codeActive
            ? true
            : !Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["toggleMark"])(strike)(editorState);
    }
    if (strong) {
        state.strongActive = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* anyMarkActive */])(editorState, strong);
        state.strongDisabled = state.codeActive
            ? true
            : !Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["toggleMark"])(strong)(editorState);
    }
    if (subsup) {
        var subMark = subsup.create({ type: 'sub' });
        var supMark = subsup.create({ type: 'sup' });
        state.subscriptActive = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* markActive */])(editorState, subMark);
        state.subscriptDisabled = state.codeActive
            ? true
            : !Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["toggleMark"])(subsup, { type: 'sub' })(editorState);
        state.superscriptActive = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* markActive */])(editorState, supMark);
        state.superscriptDisabled = state.codeActive
            ? true
            : !Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["toggleMark"])(subsup, { type: 'sup' })(editorState);
    }
    if (underline) {
        state.underlineActive = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* anyMarkActive */])(editorState, underline);
        state.underlineDisabled = state.codeActive
            ? true
            : !Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["toggleMark"])(underline)(editorState);
    }
    return state;
};
var plugin = function (dispatch) {
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        state: {
            init: function (config, state) {
                return getTextFormattingState(state);
            },
            apply: function (tr, pluginState, oldState, newState) {
                var state = getTextFormattingState(newState);
                if (!Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* deepEqual */])(pluginState, state)) {
                    dispatch(pluginKey, state);
                    return state;
                }
                return pluginState;
            },
        },
        key: pluginKey,
        props: {
            handleKeyDown: function (view, event) {
                var state = view.state, dispatch = view.dispatch;
                if (event.key === __WEBPACK_IMPORTED_MODULE_4__keymaps__["w" /* moveRight */].common) {
                    return __WEBPACK_IMPORTED_MODULE_3__commands_text_formatting__["c" /* moveRight */]()(state, dispatch);
                }
                else if (event.key === __WEBPACK_IMPORTED_MODULE_4__keymaps__["v" /* moveLeft */].common) {
                    return __WEBPACK_IMPORTED_MODULE_3__commands_text_formatting__["b" /* moveLeft */](view)(state, dispatch);
                }
                else if (event.key === __WEBPACK_IMPORTED_MODULE_4__keymaps__["g" /* backspace */].common) {
                    return __WEBPACK_IMPORTED_MODULE_3__commands_text_formatting__["d" /* removeIgnoredNodes */](view)(state, dispatch);
                }
                return false;
            },
            handleTextInput: function (view, from, to, text) {
                var state = view.state, dispatch = view.dispatch;
                return Object(__WEBPACK_IMPORTED_MODULE_3__commands_text_formatting__["a" /* createInlineCodeFromTextInput */])(from, to, text)(state, dispatch);
            },
        },
    });
};
//# sourceMappingURL=main.js.map

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectCurrentItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectSingleItemOrDismiss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectByIndex; });
/* unused harmony export selectItem */
/* unused harmony export insertFallbackCommand */
/* unused harmony export withTypeAheadQueryMarkPosition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pm_plugins_main__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_find_query_mark__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dismiss__ = __webpack_require__(456);








var selectCurrentItem = function (mode) {
    if (mode === void 0) { mode = 'selected'; }
    return function (state, dispatch) {
        var _a = __WEBPACK_IMPORTED_MODULE_5__pm_plugins_main__["d" /* pluginKey */].getState(state), active = _a.active, currentIndex = _a.currentIndex, items = _a.items, typeAheadHandler = _a.typeAheadHandler;
        if (!active || !typeAheadHandler) {
            return false;
        }
        if (!typeAheadHandler.selectItem || !items[currentIndex]) {
            return withTypeAheadQueryMarkPosition(state, function (start, end) {
                return insertFallbackCommand(start, end)(state, dispatch);
            });
        }
        return selectItem(typeAheadHandler, items[currentIndex], mode)(state, dispatch);
    };
};
var selectSingleItemOrDismiss = function (mode) {
    if (mode === void 0) { mode = 'selected'; }
    return function (state, dispatch) {
        var _a = __WEBPACK_IMPORTED_MODULE_5__pm_plugins_main__["d" /* pluginKey */].getState(state), active = _a.active, items = _a.items, typeAheadHandler = _a.typeAheadHandler;
        if (!active || !typeAheadHandler || !typeAheadHandler.selectItem) {
            return false;
        }
        if (items.length === 1) {
            return selectItem(typeAheadHandler, items[0], mode)(state, dispatch);
        }
        if (!items || items.length === 0) {
            Object(__WEBPACK_IMPORTED_MODULE_7__dismiss__["a" /* dismissCommand */])()(state, dispatch);
            return false;
        }
        return false;
    };
};
var selectByIndex = function (index) { return function (state, dispatch) {
    var _a = __WEBPACK_IMPORTED_MODULE_5__pm_plugins_main__["d" /* pluginKey */].getState(state), active = _a.active, items = _a.items, typeAheadHandler = _a.typeAheadHandler;
    if (!active ||
        !typeAheadHandler ||
        !typeAheadHandler.selectItem ||
        !items[index]) {
        return false;
    }
    return selectItem(typeAheadHandler, items[index])(state, dispatch);
}; };
var selectItem = function (handler, item, mode) {
    if (mode === void 0) { mode = 'selected'; }
    return function (state, dispatch) {
        return withTypeAheadQueryMarkPosition(state, function (start, end) {
            var insert = function (maybeNode, opts) {
                if (opts === void 0) { opts = {}; }
                var tr = state.tr;
                tr = tr
                    .setMeta(__WEBPACK_IMPORTED_MODULE_5__pm_plugins_main__["d" /* pluginKey */], { action: __WEBPACK_IMPORTED_MODULE_5__pm_plugins_main__["a" /* ACTIONS */].SELECT_CURRENT })
                    .replaceWith(start, end, __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].empty);
                if (!maybeNode) {
                    return tr;
                }
                var node;
                try {
                    node =
                        maybeNode instanceof __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Node"]
                            ? maybeNode
                            : typeof maybeNode === 'string'
                                ? state.schema.text(maybeNode)
                                : __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Node"].fromJSON(state.schema, maybeNode);
                }
                catch (e) {
                    // tslint:disable-next-line:no-console
                    console.error(e);
                    return tr;
                }
                if (node.isText) {
                    tr = tr.replaceWith(start, start, node);
                    /**
                     *
                     * Replacing a type ahead query mark with a block node.
                     *
                     */
                }
                else if (node.isBlock) {
                    tr = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["safeInsert"])(node)(tr);
                    /**
                     *
                     * Replacing a type ahead query mark with an inline node.
                     *
                     */
                }
                else if (node.isInline) {
                    var fragment = __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].fromArray([node, state.schema.text(' ')]);
                    tr = tr.replaceWith(start, start, fragment);
                    // This problem affects Chrome v58-62. See: https://github.com/ProseMirror/prosemirror/issues/710
                    if (__WEBPACK_IMPORTED_MODULE_4__utils__["r" /* isChromeWithSelectionBug */]) {
                        var selection = document.getSelection();
                        if (selection) {
                            selection.empty();
                        }
                    }
                    if (opts.selectInlineNode) {
                        // Select inserted node
                        tr = tr.setSelection(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"].create(tr.doc, start));
                    }
                    else {
                        // Placing cursor after node + space.
                        tr = tr.setSelection(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Selection"].near(tr.doc.resolve(start + fragment.size)));
                    }
                }
                return tr;
            };
            __WEBPACK_IMPORTED_MODULE_3__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.typeahead.select', { mode: mode });
            var tr = handler.selectItem(state, item, insert, { mode: mode });
            if (tr === false) {
                return insertFallbackCommand(start, end)(state, dispatch);
            }
            if (dispatch) {
                dispatch(tr);
            }
            return true;
        });
    };
};
var insertFallbackCommand = function (start, end) { return function (state, dispatch) {
    var _a = __WEBPACK_IMPORTED_MODULE_5__pm_plugins_main__["d" /* pluginKey */].getState(state), query = _a.query, trigger = _a.trigger;
    var node = state.schema.text(trigger + query);
    if (dispatch) {
        dispatch(state.tr.replaceWith(start, end, node));
    }
    return true;
}; };
var withTypeAheadQueryMarkPosition = function (state, cb) {
    var queryMark = Object(__WEBPACK_IMPORTED_MODULE_6__utils_find_query_mark__["a" /* findTypeAheadQuery */])(state);
    if (!queryMark || queryMark.start === -1) {
        return false;
    }
    return cb(queryMark.start, queryMark.end);
};
//# sourceMappingURL=select-item.js.map

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export cascadeCommands */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isAlignable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeAlignment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commands__ = __webpack_require__(113);

/**
 * Iterates over the commands one after the other,
 * passes the tr through and dispatches the cumulated transaction
 */
var cascadeCommands = function (cmds) { return function (state, dispatch) {
    var baseTr = state.tr;
    var shouldDispatch = false;
    var onDispatchAction = function (tr) {
        tr.steps.forEach(function (st) {
            baseTr.step(st);
        });
        shouldDispatch = true;
    };
    cmds.forEach(function (cmd) {
        cmd(state, onDispatchAction);
    });
    if (dispatch && shouldDispatch) {
        dispatch(baseTr);
        return true;
    }
    return false;
}; };
var isAlignable = function (align) { return function (state, dispatch) {
    var _a = state.schema, _b = _a.nodes, paragraph = _b.paragraph, heading = _b.heading, alignment = _a.marks.alignment;
    return Object(__WEBPACK_IMPORTED_MODULE_0__commands__["k" /* toggleBlockMark */])(alignment, function () { return (!align ? undefined : align === 'start' ? false : { align: align }); }, [paragraph, heading])(state, dispatch);
}; };
var changeAlignment = function (align) { return function (state, dispatch) {
    var _a = state.schema, _b = _a.nodes, paragraph = _b.paragraph, heading = _b.heading, alignment = _a.marks.alignment;
    return cascadeCommands([
        Object(__WEBPACK_IMPORTED_MODULE_0__commands__["a" /* changeImageAlignment */])(align),
        Object(__WEBPACK_IMPORTED_MODULE_0__commands__["k" /* toggleBlockMark */])(alignment, function () { return (!align ? undefined : align === 'start' ? false : { align: align }); }, [paragraph, heading]),
    ])(state, dispatch);
}; };
//# sourceMappingURL=index.js.map

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return iconMap; });
/* unused harmony export messages */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_chevron_down__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_chevron_down___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_chevron_down__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_ToolbarButton__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_Dropdown__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_align_left__ = __webpack_require__(2779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_align_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_align_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_align_center__ = __webpack_require__(2780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_align_center___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_align_center__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_align_right__ = __webpack_require__(2781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_align_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_align_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles__ = __webpack_require__(2782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_Alignment__ = __webpack_require__(2783);









var iconMap = {
    start: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_align_left___default.a, { label: "Align left" }),
    end: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_align_right___default.a, { label: "Align right" }),
    center: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_align_center___default.a, { label: "Align center" }),
};


var messages = Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["defineMessages"])({
    alignment: {
        id: 'fabric.editor.alignment',
        defaultMessage: 'Alignment',
        description: 'Aligns text',
    },
});
var AlignmentToolbar = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AlignmentToolbar, _super);
    function AlignmentToolbar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false,
        };
        _this.changeAlignment = function (align) {
            _this.toggleOpen();
            return _this.props.changeAlignment(align);
        };
        _this.toggleOpen = function () {
            _this.handleOpenChange({ isOpen: !_this.state.isOpen });
        };
        _this.handleOpenChange = function (_a) {
            var isOpen = _a.isOpen;
            _this.setState({ isOpen: isOpen });
        };
        return _this;
    }
    AlignmentToolbar.prototype.render = function () {
        var _this = this;
        var isOpen = this.state.isOpen;
        var _a = this.props, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, popupsScrollableElement = _a.popupsScrollableElement, isReducedSpacing = _a.isReducedSpacing, pluginState = _a.pluginState, disabled = _a.disabled;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__styles__["d" /* Wrapper */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ui_Dropdown__["a" /* default */], { mountTo: popupsMountPoint, boundariesElement: popupsBoundariesElement, scrollableElement: popupsScrollableElement, isOpen: this.state.isOpen, onOpenChange: this.handleOpenChange, fitWidth: 242, fitHeight: 80, trigger: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ui_ToolbarButton__["a" /* default */], { spacing: isReducedSpacing ? 'none' : 'default', disabled: disabled, selected: isOpen, title: "Text alignment", ariaLabel: "Text alignment", className: "align-btn", onClick: this.toggleOpen, iconBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__styles__["c" /* TriggerWrapper */], null,
                        iconMap[pluginState.align],
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__styles__["a" /* ExpandIconWrapper */], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_chevron_down___default.a, { label: 'Alignment' }))) }) },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ui_Alignment__["a" /* default */], { onClick: function (align) { return _this.changeAlignment(align); }, selectedAlignment: pluginState.align })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__styles__["b" /* Separator */], null)));
    };
    return AlignmentToolbar;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (AlignmentToolbar);
//# sourceMappingURL=index.js.map

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_width__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);





var WidthEmitter = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WidthEmitter, _super);
    function WidthEmitter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.debounce = null;
        _this.broadcastWidth = function (width) {
            var editorView = _this.props.editorView;
            if (editorView && _this.width !== width) {
                if (_this.debounce) {
                    clearTimeout(_this.debounce);
                }
                // NodeViews will trigger multiple state change error without this debounce
                _this.debounce = window.setTimeout(function () {
                    var pmDom = _this.props.contentArea
                        ? _this.props.contentArea.querySelector('.ProseMirror')
                        : undefined;
                    var tr = editorView.state.tr.setMeta(__WEBPACK_IMPORTED_MODULE_2__plugins_width__["b" /* pluginKey */], {
                        width: width,
                        lineLength: pmDom ? pmDom.clientWidth : undefined,
                    });
                    editorView.dispatch(tr);
                    _this.width = width;
                    _this.debounce = null;
                }, 10);
            }
            return null;
        };
        return _this;
    }
    WidthEmitter.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["h" /* WidthConsumer */], null, function (_a) {
            var width = _a.width;
            return _this.broadcastWidth(width);
        }));
    };
    return WidthEmitter;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (WidthEmitter);
//# sourceMappingURL=index.js.map

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

var messageEditorPropsPreset = {
    appearance: 'message',
    saveOnEnter: true,
    allowLists: true,
    allowTextColor: true,
    allowInlineAction: true,
    allowCodeBlocks: true,
    allowTasksAndDecisions: true,
    allowHelpDialog: true,
};
function getPropsPreset(appearance) {
    switch (appearance) {
        case 'message':
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, messageEditorPropsPreset);
        default:
            return {};
    }
}
//# sourceMappingURL=get-props-preset.js.map

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PortalProviderAPI */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PortalProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PortalRenderer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_dispatcher__ = __webpack_require__(200);




var PortalProviderAPI = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](PortalProviderAPI, _super);
    function PortalProviderAPI() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.portals = new Map();
        _this.setContext = function (context) {
            _this.context = context;
        };
        return _this;
    }
    PortalProviderAPI.prototype.render = function (children, container, hasReactContext) {
        if (hasReactContext === void 0) { hasReactContext = false; }
        this.portals.set(container, { children: children, hasReactContext: hasReactContext });
        Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_renderSubtreeIntoContainer"])(this.context, children(), container);
    };
    // TODO: until https://product-fabric.atlassian.net/browse/ED-5013
    // we (unfortunately) need to re-render to pass down any updated context.
    // selectively do this for nodeviews that opt-in via `hasReactContext`
    PortalProviderAPI.prototype.forceUpdate = function () {
        var _this = this;
        this.portals.forEach(function (portal, container) {
            if (!portal.hasReactContext) {
                return;
            }
            Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_renderSubtreeIntoContainer"])(_this.context, portal.children(), container);
        });
    };
    PortalProviderAPI.prototype.remove = function (container) {
        this.portals.delete(container);
        Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["unmountComponentAtNode"])(container);
    };
    return PortalProviderAPI;
}(__WEBPACK_IMPORTED_MODULE_3__event_dispatcher__["a" /* EventDispatcher */]));

var PortalProvider = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](PortalProvider, _super);
    function PortalProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.portalProviderAPI = new PortalProviderAPI();
        return _this;
    }
    PortalProvider.prototype.render = function () {
        return this.props.render(this.portalProviderAPI);
    };
    PortalProvider.prototype.componentDidUpdate = function () {
        this.portalProviderAPI.forceUpdate();
    };
    return PortalProvider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

var PortalRenderer = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](PortalRenderer, _super);
    function PortalRenderer(props) {
        var _this = _super.call(this, props) || this;
        _this.handleUpdate = function (portals) { return _this.setState({ portals: portals }); };
        props.portalProviderAPI.setContext(_this);
        props.portalProviderAPI.on('update', _this.handleUpdate);
        _this.state = { portals: new Map() };
        return _this;
    }
    PortalRenderer.prototype.render = function () {
        var portals = this.state.portals;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, Array.from(portals.entries()).map(function (_a) {
            var _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](_a, 2), container = _b[0], children = _b[1];
            return Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["createPortal"])(children, container);
        })));
    };
    return PortalRenderer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_help_dialog__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__analytics__ = __webpack_require__(20);





var WithHelpTrigger = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WithHelpTrigger, _super);
    function WithHelpTrigger() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openHelp = function () {
            __WEBPACK_IMPORTED_MODULE_4__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.help.button');
            var editorView = _this.context.editorActions._privateGetEditorView();
            if (editorView) {
                Object(__WEBPACK_IMPORTED_MODULE_3__plugins_help_dialog__["c" /* openHelpCommand */])(editorView.state.tr, editorView.dispatch);
            }
        };
        return _this;
    }
    WithHelpTrigger.prototype.render = function () {
        return this.props.render(this.openHelp);
    };
    WithHelpTrigger.contextTypes = {
        editorActions: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"].isRequired,
    };
    return WithHelpTrigger;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (WithHelpTrigger);
//# sourceMappingURL=index.js.map

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return listItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__paragraph__ = __webpack_require__(885);


var listItem = function (node, prefix) {
    var result = [];
    var paragraphBuffer = [];
    node.forEach(function (n, offset, index) {
        switch (n.type.name) {
            case 'paragraph': {
                paragraphBuffer.push(Object(__WEBPACK_IMPORTED_MODULE_1__paragraph__["a" /* paragraph */])(n));
                break;
            }
            case 'bulletList':
            case 'orderedList': {
                if (paragraphBuffer.length) {
                    result.push(prefix + " " + paragraphBuffer.join('\n'));
                    paragraphBuffer = [];
                }
                var nestedList = Object(__WEBPACK_IMPORTED_MODULE_0____["a" /* encode */])(n)
                    .split('\n')
                    .map(function (line) {
                    if (['#', '*'].indexOf(line.substr(0, 1)) !== -1) {
                        return "" + prefix + line;
                    }
                    return line;
                })
                    .join('\n');
                result.push(nestedList);
                break;
            }
            default:
        }
    });
    if (paragraphBuffer.length) {
        result.push(prefix + " " + paragraphBuffer.join('\n'));
    }
    return result.join('\n');
};
//# sourceMappingURL=listItem.js.map

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return paragraph; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inlines__ = __webpack_require__(471);

var paragraph = function (node) {
    var result = '';
    node.forEach(function (n) {
        result += Object(__WEBPACK_IMPORTED_MODULE_0__inlines__["a" /* inlines */])(n);
    });
    return result;
};
//# sourceMappingURL=paragraph.js.map

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return unknown; });
var unknown = function (node) {
    var content = JSON.stringify(node.toJSON());
    return node.isBlock
        ? "{adf:display=block}\n" + content + "\n{adf}"
        : "{adf:display=inline}" + content + "{adf}";
};
//# sourceMappingURL=unknown.js.map

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = media;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nodes_mediaSingle__ = __webpack_require__(2859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_attrs__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_formatter__ = __webpack_require__(108);




function media(input, position, schema) {
    var rawContentProcessor = function (raw, length) {
        // !image.gif|align=right, vspace=4|ignore-this!
        // If it splits into more than 2 items, we ignore the rest
        var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](raw.split('|'), 2), rawContent = _a[0], _b = _a[1], rawAttrs = _b === void 0 ? '' : _b;
        var node = Object(__WEBPACK_IMPORTED_MODULE_1__nodes_mediaSingle__["a" /* default */])(schema, rawContent, Object(__WEBPACK_IMPORTED_MODULE_2__utils_attrs__["a" /* parseAttrs */])(rawAttrs, ','));
        return {
            type: 'pmnode',
            nodes: [node],
            length: length,
        };
    };
    return Object(__WEBPACK_IMPORTED_MODULE_3__common_formatter__["a" /* commonFormatter */])(input, position, schema, {
        opening: '!',
        closing: '!',
        rawContentProcessor: rawContentProcessor,
    });
}
//# sourceMappingURL=media.js.map

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LINK_TEXT_REGEXP; });
/* harmony export (immutable) */ __webpack_exports__["b"] = linkText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__ = __webpack_require__(19);

// https://www.atlassian.com
var LINK_TEXT_REGEXP = /^(https?:\/\/|irc:\/\/|mailto:)([\w.?\/\\#-=@]+)/;
function linkText(input, position, schema) {
    var match = input.substring(position).match(LINK_TEXT_REGEXP);
    if (!match) {
        return fallback(input, position);
    }
    // Remove mailto:
    var textRepresentation = match[1] === 'mailto:' ? match[2] : match[0];
    var url = unescape(match[0]);
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["L" /* isSafeUrl */])(url)) {
        return fallback(input, position);
    }
    var mark = schema.marks.link.create({
        href: encodeURI(url),
    });
    var textNode = schema.text(textRepresentation, [mark]);
    return {
        type: 'pmnode',
        nodes: [textNode],
        length: match[0].length,
    };
}
function unescape(url) {
    var result = '';
    for (var i = 0; i < url.length; i++) {
        var char = url[i];
        if (char !== '\\') {
            result += char;
            continue;
        }
        var nextChar = url[i + 1];
        if (nextChar) {
            result += nextChar;
            i++;
        }
    }
    return result;
}
function fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1,
    };
}
//# sourceMappingURL=link-text.js.map

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = escapeHandler;
/**
 * In Jira, following characters are escaped
 * private static final Pattern ESCAPING_PATTERN = Pattern.compile("(^|(?<!\\\\))\\\\([\\-\\#\\*\\_\\+\\?\\^\\~\\|\\%\\{\\}\\[\\]\\(\\)\\!\\@])");
 * https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-renderer/src/main/java/com/atlassian/renderer/v2/components/BackslashEscapeRendererComponent.java
 */
var escapedChar = [
    '-',
    '#',
    '*',
    '_',
    '+',
    '?',
    '^',
    '~',
    '|',
    '%',
    '{',
    '}',
    '[',
    ']',
    '(',
    ')',
    '!',
    '@',
];
function escapeHandler(input, position) {
    var buffer = '';
    var char = input.charAt(position);
    var prevChar = input.charAt(position - 1);
    var nextChar = input.charAt(position + 1);
    /**
     * Ported from Jira:
     * If previous char is also a backslash, then this is not a valid escape
     */
    if (escapedChar.indexOf(nextChar) === -1 || prevChar === '\\') {
        // Insert \ in buffer mode
        buffer += char;
    }
    buffer += nextChar;
    return {
        type: 'text',
        text: buffer,
        length: 2,
    };
}
//# sourceMappingURL=escape.js.map

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quoteMacro;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rawContentProcessor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_macro__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_text__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_normalize__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__text__ = __webpack_require__(50);





function quoteMacro(input, position, schema, tokenErrCallback) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__common_macro__["a" /* commonMacro */])(input.substring(position), schema, {
        keyword: 'quote',
        paired: true,
        rawContentProcessor: rawContentProcessor,
        tokenErrCallback: tokenErrCallback,
    });
}
var rawContentProcessor = function (rawAttrs, rawContent, length, schema, tokenErrCallback) {
    if (!rawContent.length) {
        var emptyQuote = emptyBlockquote(schema);
        return {
            type: 'pmnode',
            nodes: [emptyQuote],
            length: length,
        };
    }
    var parsedContent = Object(__WEBPACK_IMPORTED_MODULE_4__text__["a" /* parseString */])(rawContent, schema, [], tokenErrCallback);
    var normalizedContent = Object(__WEBPACK_IMPORTED_MODULE_3__utils_normalize__["a" /* normalizePMNodes */])(parsedContent, schema);
    return {
        type: 'pmnode',
        nodes: sanitize(normalizedContent, schema),
        length: length,
    };
};
function emptyBlockquote(schema) {
    var p = schema.nodes.paragraph.createChecked({}, []);
    return schema.nodes.blockquote.createChecked({}, p);
}
function sanitize(nodes, schema) {
    var e_1, _a;
    var output = [];
    var contentBuffer = [];
    try {
        for (var nodes_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
            var n = nodes_1_1.value;
            switch (n.type.name) {
                case 'paragraph': {
                    /**
                     * blockquote is happy with paragraph
                     */
                    contentBuffer.push(n);
                    break;
                }
                case 'heading': {
                    /**
                     * If a heading is inside a list item
                     * - h1. Bold, Uppercase
                     * - h2. Bold, Italic
                     * - h3. Bold
                     * - h4. Bold, Gray
                     * - h5. Gray, Italic
                     * - h6. Gray
                     */
                    contentBuffer.push(transformHeading(n, schema));
                    break;
                }
                default:
                    /**
                     * Anything else should be lifted
                     */
                    if (contentBuffer.length) {
                        var blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
                        output.push(blockquote);
                        contentBuffer = [];
                    }
                    output.push(n);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (contentBuffer.length) {
        var blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
        output.push(blockquote);
    }
    return output;
}
function transformHeading(heading, schema) {
    var contentBuffer = [];
    heading.content.forEach(function (n) {
        var strong = schema.marks.strong.create();
        var italic = schema.marks.em.create();
        var gray = schema.marks.textColor.create({ color: '#97a0af' });
        if (n.type.name === 'text') {
            if (n.text && heading.attrs.level === 1) {
                n.text = n.text.toUpperCase();
            }
            if (heading.attrs.level <= 4 && !Object(__WEBPACK_IMPORTED_MODULE_2__utils_text__["b" /* hasAnyOfMarks */])(n, ['strong', 'code'])) {
                n = n.mark(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](n.marks, [strong]));
            }
            if ((heading.attrs.level === 5 || heading.attrs.level === 2) &&
                !Object(__WEBPACK_IMPORTED_MODULE_2__utils_text__["b" /* hasAnyOfMarks */])(n, ['em', 'code'])) {
                n = n.mark(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](n.marks, [italic]));
            }
            if (heading.attrs.level > 3 && !Object(__WEBPACK_IMPORTED_MODULE_2__utils_text__["b" /* hasAnyOfMarks */])(n, ['textColor', 'code'])) {
                n = n.mark(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](n.marks, [gray]));
            }
        }
        contentBuffer.push(n);
    });
    return schema.nodes.paragraph.createChecked({}, contentBuffer);
}
//# sourceMappingURL=quote-macro.js.map

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createDashTokenParser; });
var createDashTokenParser = function (token, fallback) { return function (input, position) {
    /**
     * From Jira https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-renderer/src/main/java/com/atlassian/renderer/v2/components/phrase/DashRendererComponent.java
     *  public static final Replacer EN_DASH = new Replacer(Pattern.compile("(^|\\s)--(\\s|$)"), "$1&#8211;$2", "--");
     *  public static final Replacer EM_DASH = new Replacer(Pattern.compile("(^|\\s)---(\\s|$)"), "$1&#8212;$2", "---");
     */
    if (position > 0) {
        var charBeforeToken = input.charAt(position - 1);
        if (!isSpace(charBeforeToken)) {
            return fallback;
        }
    }
    if (position + token.length < input.length) {
        var charAfterToken = input.charAt(position + token.length);
        if (!isSpace(charAfterToken)) {
            return fallback;
        }
    }
    return token;
}; };
var isSpace = function (char) {
    return /\s/.test(char);
};
//# sourceMappingURL=dash-token-creator.js.map

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = emoji;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EMOJIS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

function emoji(input, position, schema) {
    var e_1, _a, e_2, _b;
    var substring = input.substring(position);
    try {
        // Look for a emoji
        for (var EMOJIS_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](EMOJIS), EMOJIS_1_1 = EMOJIS_1.next(); !EMOJIS_1_1.done; EMOJIS_1_1 = EMOJIS_1.next()) {
            var emo = EMOJIS_1_1.value;
            try {
                for (var _c = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](emo.markup), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var text = _d.value;
                    if (substring.startsWith(text)) {
                        return {
                            type: 'pmnode',
                            nodes: [schema.nodes.emoji.createChecked(emo.adf)],
                            length: text.length,
                        };
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (EMOJIS_1_1 && !EMOJIS_1_1.done && (_a = EMOJIS_1.return)) _a.call(EMOJIS_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return {
        type: 'text',
        text: substring.substr(0, 1),
        length: 1,
    };
}
var EMOJIS = [
    {
        markup: [':)', ':-)'],
        adf: {
            id: '1f642',
            shortName: ':slight_smile:',
            text: '🙂',
        },
    },
    {
        markup: [':(', ':-('],
        adf: {
            id: '1f61e',
            shortName: ':disappointed:',
            text: '😞',
        },
    },
    {
        markup: [':P', ':-P', ':p', ':-p'],
        adf: {
            id: '1f61b',
            shortName: ':stuck_out_tongue:',
            text: '😛',
        },
    },
    {
        markup: [':D', ':-D'],
        adf: {
            id: '1f603',
            shortName: ':smiley:',
            text: '😃',
        },
    },
    {
        markup: [';)', ';-)'],
        adf: {
            id: '1f609',
            shortName: ':wink:',
            text: '😉',
        },
    },
    {
        markup: ['(y)'],
        adf: {
            id: '1f44d',
            shortName: ':thumbsup:',
            text: '👍',
        },
    },
    {
        markup: ['(n)'],
        adf: {
            id: '1f44e',
            shortName: ':thumbsdown:',
            text: '👎',
        },
    },
    {
        markup: ['(i)'],
        adf: {
            id: 'atlassian-info',
            shortName: ':info:',
            text: ':info',
        },
    },
    {
        markup: ['(/)'],
        adf: {
            id: 'atlassian-check_mark',
            shortName: ':check_mark:',
            text: ':check_mark:',
        },
    },
    {
        markup: ['(x)'],
        adf: {
            id: 'atlassian-cross_mark',
            shortName: ':cross_mark:',
            text: ':cross_mark:',
        },
    },
    {
        markup: ['(!)'],
        adf: {
            id: 'atlassian-warning',
            shortName: ':warning:',
            text: ':warning:',
        },
    },
    {
        markup: ['(+)'],
        adf: {
            id: 'atlassian-plus',
            shortName: ':plus:',
            text: ':plus:',
        },
    },
    {
        markup: ['(-)'],
        adf: {
            id: 'atlassian-minus',
            shortName: ':minus:',
            text: ':minus:',
        },
    },
    {
        markup: ['(?)'],
        adf: {
            id: 'atlassian-question_mark',
            shortName: ':question:',
            text: ':question:',
        },
    },
    {
        markup: ['(on)'],
        adf: {
            id: 'atlassian-light_bulb_on',
            shortName: ':light_bulb_on:',
            text: ':light_bulb_on:',
        },
    },
    {
        markup: ['(off)'],
        adf: {
            id: 'atlassian-light_bulb_off',
            shortName: ':light_bulb_off:',
            text: ':light_bulb_off:',
        },
    },
    {
        markup: ['(*)', '(*y)'],
        adf: {
            id: 'atlassian-yellow_star',
            shortName: ':yellow_star:',
            text: ':yellow_star:',
        },
    },
    {
        markup: ['(*r)'],
        adf: {
            id: 'atlassian-red_star',
            shortName: ':red_star:',
            text: ':red_star:',
        },
    },
    {
        markup: ['(*g)'],
        adf: {
            id: 'atlassian-green_star',
            shortName: ':green_star:',
            text: ':green_star:',
        },
    },
    {
        markup: ['(*b)'],
        adf: {
            id: 'atlassian-blue_star',
            shortName: ':blue_star:',
            text: ':blue_star:',
        },
    },
    {
        markup: ['(flag)'],
        adf: {
            id: 'atlassian-flag_on',
            shortName: ':flag_on:',
            text: ':flag_on:',
        },
    },
    {
        markup: ['(flagoff)'],
        adf: {
            id: 'atlassian-flag_off',
            shortName: ':flag_off:',
            text: ':flag_off:',
        },
    },
];
//# sourceMappingURL=emoji.js.map

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(474);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__providerFactory__ = __webpack_require__(476);
/* unused harmony reexport ProviderFactory */
/* unused harmony reexport WithProviders */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(304);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui__ = __webpack_require__(895);
/* unused harmony namespace reexport */




//# sourceMappingURL=index.js.map

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PanelSharedCssClassName; });
/* unused harmony export panelSharedStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(168);

// @ts-ignore: unused variable
// prettier-ignore



var PanelSharedCssClassName = {
    PANEL_CONTAINER: 'ak-editor-panel',
};
var panelSharedStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  & .", " {\n    border-radius: ", "px;\n    margin: ", "px 0;\n    padding: ", "px;\n    min-width: ", "px;\n    display: flex;\n    align-items: baseline;\n    word-break: break-word;\n\n    .ak-editor-panel__icon {\n      display: block;\n      flex-shrink: 0;\n      height: ", "px;\n      width: ", "px;\n      box-sizing: content-box;\n      padding-right: ", "px;\n\n      > span {\n        vertical-align: middle;\n        display: inline;\n      }\n    }\n\n    .ak-editor-panel__content {\n      margin: 1px 0 1px;\n      flex: 1 0 0;\n    }\n  }\n"], ["\n  & .", " {\n    border-radius: ", "px;\n    margin: ", "px 0;\n    padding: ", "px;\n    min-width: ", "px;\n    display: flex;\n    align-items: baseline;\n    word-break: break-word;\n\n    .ak-editor-panel__icon {\n      display: block;\n      flex-shrink: 0;\n      height: ", "px;\n      width: ", "px;\n      box-sizing: content-box;\n      padding-right: ", "px;\n\n      > span {\n        vertical-align: middle;\n        display: inline;\n      }\n    }\n\n    .ak-editor-panel__content {\n      margin: 1px 0 1px;\n      flex: 1 0 0;\n    }\n  }\n"])), PanelSharedCssClassName.PANEL_CONTAINER, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])(), Object(__WEBPACK_IMPORTED_MODULE_3__consts__["n" /* relativeSize */])(1.142), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])(), __WEBPACK_IMPORTED_MODULE_3__consts__["g" /* akEditorTableCellMinWidth */], Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() * 3, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() * 3, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])());
var templateObject_1;
//# sourceMappingURL=panel.js.map

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Emoji__ = __webpack_require__(2914);
/* unused harmony reexport Emoji */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MediaSingle__ = __webpack_require__(2934);
/* unused harmony reexport MediaSingle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MediaSingle_styled__ = __webpack_require__(899);
/* unused harmony reexport MediaSingleDimensionHelper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MediaSingle_grid__ = __webpack_require__(900);
/* unused harmony reexport layoutSupportsWidth */
/* unused harmony reexport calcPxFromColumns */
/* unused harmony reexport calcPctFromPx */
/* unused harmony reexport calcPxFromPct */
/* unused harmony reexport calcColumnsFromPx */
/* unused harmony reexport snapToGrid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Mention__ = __webpack_require__(2935);
/* unused harmony reexport Mention */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Popup__ = __webpack_require__(914);
/* unused harmony reexport Popup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UnsupportedBlock__ = __webpack_require__(2959);
/* unused harmony reexport UnsupportedBlock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BaseTheme__ = __webpack_require__(2960);
/* unused harmony reexport BaseTheme */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__BaseTheme__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__with_outer_listeners__ = __webpack_require__(915);
/* unused harmony reexport withOuterListeners */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WidthProvider__ = __webpack_require__(916);
/* unused harmony reexport WidthConsumer */
/* unused harmony reexport WidthProvider */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_9__WidthProvider__["c"]; });










//# sourceMappingURL=index.js.map

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UsageFrequencyTracker; });
/* unused harmony export Gateway */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type_helpers__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DuplicateLimitedQueue__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StoredDuplicateLimitedQueue__ = __webpack_require__(2925);





/**
 * Keeps track of the last 150 emoji usages, although limiting the maximum count for a single emoji to 25 to
 * ensure we don't end up with only a single emoji being recorded. Usage is persisted to local storage for
 * consistency between 'sessions'.
 *
 * Skin tone variations for an emoji will be 'collapsed' so they are tracked as their base emoji. Gender
 * variations are not collapsed in this way and will be tracked per gender. This decision reflects the UI of
 * the EmojiPicker component.
 */
var UsageFrequencyTracker = /** @class */ (function () {
    function UsageFrequencyTracker(useStorageIfPossible) {
        if (useStorageIfPossible === void 0) { useStorageIfPossible = true; }
        var options = UsageFrequencyTracker.queueOptions;
        if (useStorageIfPossible && options.storage) {
            var queueOptions = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, options, { storage: options.storage });
            this.queue = new __WEBPACK_IMPORTED_MODULE_4__StoredDuplicateLimitedQueue__["a" /* default */](queueOptions);
        }
        else {
            this.queue = new __WEBPACK_IMPORTED_MODULE_3__DuplicateLimitedQueue__["a" /* default */](options);
        }
        this.gateway = new Gateway(10);
    }
    /**
     * Record the fact that the supplied emoji was used. You should note that usage is updated asynchronously so you can not
     * count on getOrder() reflecting this usage immediately.
     *
     * @param emoji the emoji who's usage is to be recorded. If the emoji has no id then no usage will be recorded
     */
    UsageFrequencyTracker.prototype.recordUsage = function (emoji) {
        var _this = this;
        var emojiId = emoji.id;
        if (emojiId) {
            if (Object(__WEBPACK_IMPORTED_MODULE_1__type_helpers__["g" /* isEmojiVariationDescription */])(emoji)) {
                emojiId = emoji.baseId;
            }
            this.gateway.submit(function () {
                if (emojiId) {
                    _this.queue.enqueue(emojiId);
                }
            });
        }
    };
    /**
     * Returns an array of emoji id (without skin tone variations) sorted by most used to least used. If there
     * are no usages then an empty array will be returned.
     */
    UsageFrequencyTracker.prototype.getOrder = function () {
        return this.queue.getItemsOrderedByDuplicateCount();
    };
    /**
     * Exposed for testing only. Clear any recorded usage.
     */
    UsageFrequencyTracker.prototype.clear = function () {
        this.queue.clear();
    };
    UsageFrequencyTracker.queueOptions = {
        storage: typeof window !== 'undefined' && window.localStorage,
        storagePrefix: __WEBPACK_IMPORTED_MODULE_2__constants__["m" /* localStoragePrefix */],
        maxDuplicates: 25,
        minUniqueItems: 5,
    };
    return UsageFrequencyTracker;
}());

var Gateway = /** @class */ (function () {
    function Gateway(maximumPermitted) {
        if (maximumPermitted < 1) {
            throw new RangeError('The maximumPermitted parameter must be 1 or more.');
        }
        this.maximumPermitted = maximumPermitted;
        this.count = 0;
    }
    /**
     * Run the supplied function if the count of already submitted work allows it. Drop the work
     * if it's not allowed to run.
     *
     * Will return true if the function has been submitted or false if it was not submitted.
     */
    Gateway.prototype.submit = function (f) {
        var _this = this;
        if (this.count >= this.maximumPermitted) {
            return false;
        }
        this.count++;
        var wrappedFunc = function () {
            try {
                f();
            }
            finally {
                _this.completed();
            }
        };
        window.setTimeout(wrappedFunc);
        return true;
    };
    Gateway.prototype.completed = function () {
        this.count--;
    };
    return Gateway;
}());

//# sourceMappingURL=UsageFrequencyTracker.js.map

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A queue which will limit the number of duplicates of type T that it holds. When the duplicate limit is
 * reached the earliest inserted duplicate (the "original") is removed to make room for the new insertion.
 */
var DuplicateLimitedQueue = /** @class */ (function () {
    /**
     * Construct a new DuplicateLimitedQueue.
     *
     * @param options the options for this queue.
     */
    function DuplicateLimitedQueue(options) {
        if (options.maxDuplicates < 1) {
            throw new RangeError('The maxDuplicates option must be at least 1');
        }
        if (options.minUniqueItems < 1) {
            throw new RangeError('The minUniqueItems option must be at least 1');
        }
        this.maximumSize = options.maxDuplicates * options.minUniqueItems;
        this.perItemSize = options.maxDuplicates;
        this.createEmptyState();
    }
    /**
     * @param item the item to add to the queue.
     */
    DuplicateLimitedQueue.prototype.enqueue = function (item) {
        this.enqueueWithoutOrdering(item);
        // enqueues are less time sensitive (and may happen less frequently) than queries against the queue
        // so do the ordering work on each enqueue.
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    };
    /**
     * Return the items in the queue, ordered by how often they are duplicated. The items with the
     * most duplicates come first in the returned Array.
     *
     * If there are no items in the queue then an empty Array will be returned.
     */
    DuplicateLimitedQueue.prototype.getItemsOrderedByDuplicateCount = function () {
        return this.itemsOrderedByFrequency;
    };
    /**
     * Exposed for storybook/testing purposes only. Clear the contents of the queue.
     */
    DuplicateLimitedQueue.prototype.clear = function () {
        this.createEmptyState();
    };
    /**
     * A more efficient mechanism for adding multiple items. Ordering is only performed once all
     * the items have been added.
     *
     * @param items the items to be enqueued, which happens in their presented order.
     */
    DuplicateLimitedQueue.prototype.bulkEnqueue = function (items) {
        var _this = this;
        items.map(function (item) { return _this.enqueueWithoutOrdering(item); });
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    };
    /**
     * Return the items currently stored in the queue.
     */
    DuplicateLimitedQueue.prototype.getItems = function () {
        return this.items;
    };
    DuplicateLimitedQueue.prototype.createEmptyState = function () {
        this.items = new Array();
        this.itemCountMap = new Map();
        this.itemsOrderedByFrequency = new Array();
    };
    /**
     * Enqueue the supplied item, keeping consistency with the limits configured. However no ordering is
     * performed by this enqueuing. You must trigger that manually if required.
     *
     * @param item the item to be queued
     */
    DuplicateLimitedQueue.prototype.enqueueWithoutOrdering = function (item) {
        var count = this.itemCountMap.get(item);
        if (count && count >= this.perItemSize) {
            // find the first item with that key in the array and remove it
            this.removeFirstOccurrence(item);
        }
        else {
            if (this.items.length >= this.maximumSize) {
                this.remove();
            }
        }
        this.add(item);
    };
    /**
     * Get an array of items from the queue ordered by how often they are duplicated in the queue.
     */
    DuplicateLimitedQueue.prototype.orderItemsByFrequency = function () {
        var orderedEntries = Array.from(this.itemCountMap.entries()).sort(function (a, b) {
            return b[1] - a[1];
        });
        return orderedEntries.map(function (value) { return value[0]; });
    };
    DuplicateLimitedQueue.prototype.decrementCount = function (item) {
        var count = this.itemCountMap.get(item);
        if (count) {
            count--;
            if (count > 0) {
                this.itemCountMap.set(item, count);
            }
            else {
                this.itemCountMap.delete(item);
            }
        }
    };
    /**
     * Walk the list of items and remove the first occurrence of the matching item.
     *
     * @param item the item to be removed.
     */
    DuplicateLimitedQueue.prototype.removeFirstOccurrence = function (item) {
        var index = this.items.indexOf(item);
        if (index !== -1) {
            this.items.splice(index, 1);
            this.decrementCount(item);
        }
    };
    /**
     * Remove the first item from the queue and update the itemCountMap accordingly.
     * @return the item add the front of the queue or undefined if the queue is empty
     */
    DuplicateLimitedQueue.prototype.remove = function () {
        var removed = this.items.shift();
        if (removed !== undefined) {
            this.decrementCount(removed);
        }
        return removed;
    };
    /**
     * Add the supplied item to the end of the queue and update the itemCountMap accordingly.
     * @param item the item to be added to the queue
     */
    DuplicateLimitedQueue.prototype.add = function (item) {
        this.items.push(item);
        var count = this.itemCountMap.get(item);
        if (count) {
            this.itemCountMap.set(item, count + 1);
        }
        else {
            this.itemCountMap.set(item, 1);
        }
    };
    return DuplicateLimitedQueue;
}());
/* harmony default export */ __webpack_exports__["a"] = (DuplicateLimitedQueue);
//# sourceMappingURL=DuplicateLimitedQueue.js.map

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EmojiUtils__ = __webpack_require__(229);

/**
 * Emoji providers should return JSON in the format defined by EmojiServiceResponse.
 */
var EmojiLoader = /** @class */ (function () {
    function EmojiLoader(config) {
        this.config = config;
    }
    /**
     * Returns a promise with an array of Emoji from all providers.
     */
    EmojiLoader.prototype.loadEmoji = function () {
        var emojisPromise = Object(__WEBPACK_IMPORTED_MODULE_0__EmojiUtils__["b" /* emojiRequest */])(this.config);
        return emojisPromise.then(function (emojiServiceResponse) {
            return Object(__WEBPACK_IMPORTED_MODULE_0__EmojiUtils__["a" /* denormaliseEmojiServiceResponse */])(emojiServiceResponse);
        });
    };
    return EmojiLoader;
}());
/* harmony default export */ __webpack_exports__["a"] = (EmojiLoader);
//# sourceMappingURL=EmojiLoader.js.map

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export calcLegacyWidth */
/* unused harmony export calcResizedWidth */
/* unused harmony export MediaSingleDimensionHelper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(474);




function float(layout) {
    switch (layout) {
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
/**
 * Calculates the image width for non-resized images.
 *
 * If an image has not been resized using the pctWidth attribute,
 * then an image in wide or full-width can not be wider than the image's
 * original width.
 */
function calcLegacyWidth(layout, width, containerWidth) {
    if (containerWidth === void 0) { containerWidth = 0; }
    switch (layout) {
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > __WEBPACK_IMPORTED_MODULE_2__styles__["d" /* akEditorFullPageMaxWidth */] / 2
                ? 'calc(50% - 12px)'
                : width + "px";
        case 'wide':
            return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* calcWideWidth */])(containerWidth);
        case 'full-width':
            return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* calcBreakoutWidth */])(layout, containerWidth);
        default:
            return width > __WEBPACK_IMPORTED_MODULE_2__styles__["d" /* akEditorFullPageMaxWidth */] ? '100%' : width + "px";
    }
}
/**
 * Calculates the image width for previously resized images.
 *
 * Wide and full-width images are always that size (960px and 100%); there is
 * no distinction between max-width and width.
 */
function calcResizedWidth(layout, width, containerWidth) {
    if (containerWidth === void 0) { containerWidth = 0; }
    switch (layout) {
        case 'wide':
            return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* calcWideWidth */])(containerWidth);
        case 'full-width':
            return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* calcBreakoutWidth */])(layout, containerWidth);
        default:
            return width + "px";
    }
}
function calcMaxWidth(layout, width, containerWidth) {
    switch (layout) {
        case 'wide':
            return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* calcWideWidth */])(containerWidth);
        case 'full-width':
            return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* calcBreakoutWidth */])(layout, containerWidth);
        default:
            return '100%';
    }
}
function calcMargin(layout) {
    switch (layout) {
        case 'wrap-right':
            return '12px auto 12px 24px';
        case 'wrap-left':
            return '12px 24px 12px auto';
        default:
            return '24px auto';
    }
}
function isImageAligned(layout) {
    switch (layout) {
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 */
var MediaSingleDimensionHelper = function (_a) {
    var width = _a.width, height = _a.height, layout = _a.layout, _b = _a.containerWidth, containerWidth = _b === void 0 ? 0 : _b, pctWidth = _a.pctWidth;
    return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  tr & {\n    max-width: 100%;\n  }\n  width: ", ";\n  max-width: ", ";\n  float: ", ";\n  margin: ", ";\n  ", ";\n"], ["\n  tr & {\n    max-width: 100%;\n  }\n  width: ",
        ";\n  max-width: ", ";\n  float: ", ";\n  margin: ", ";\n  ", ";\n"])), pctWidth
        ? calcResizedWidth(layout, width, containerWidth)
        : calcLegacyWidth(layout, width, containerWidth), calcMaxWidth(layout, width, containerWidth), float(layout), calcMargin(layout), isImageAligned(layout));
};
var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", ";\n  position: relative;\n\n  &::after {\n    content: '';\n    display: block;\n    padding-bottom: ", "%;\n  }\n\n  & > div {\n    position: absolute;\n    height: 100%;\n  }\n"], ["\n  ", ";\n  position: relative;\n\n  &::after {\n    content: '';\n    display: block;\n    padding-bottom: ", "%;\n  }\n\n  & > div {\n    position: absolute;\n    height: 100%;\n  }\n"])), MediaSingleDimensionHelper, function (p) { return (p.height / p.width) * 100; });
Wrapper.displayName = 'WrapperMediaSingle';
/* harmony default export */ __webpack_exports__["a"] = (Wrapper);
var templateObject_1, templateObject_2;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return layoutSupportsWidth; });
/* unused harmony export calcPxFromColumns */
/* unused harmony export calcColumnsFromPx */
/* harmony export (immutable) */ __webpack_exports__["a"] = calcPxFromPct;
/* unused harmony export calcPctFromPx */
/* unused harmony export snapToGrid */
var handleMargin = 12;
var gutterSize = handleMargin * 2;
var validWidthModes = [
    'center',
    'wrap-left',
    'wrap-right',
    'align-start',
    'align-end',
];
var layoutSupportsWidth = function (layout) {
    return validWidthModes.indexOf(layout) > -1;
};
function calcPxFromColumns(columns, lineLength, gridSize) {
    var maxWidth = lineLength + gutterSize;
    return (maxWidth / gridSize) * columns - gutterSize;
}
function calcColumnsFromPx(width, lineLength, gridSize) {
    var maxWidth = lineLength + gutterSize;
    return ((width + gutterSize) * gridSize) / maxWidth;
}
function calcPxFromPct(pct, lineLength) {
    var maxWidth = lineLength + gutterSize;
    return maxWidth * pct - gutterSize;
}
function calcPctFromPx(width, lineLength) {
    var maxWidth = lineLength + gutterSize;
    return (width + gutterSize) / maxWidth;
}
var snapToGrid = function (gridWidth, width, height, lineLength, gridSize) {
    var pxWidth = calcPxFromPct(gridWidth / 100, lineLength);
    var columnSpan = Math.round(calcColumnsFromPx(pxWidth, lineLength, gridSize));
    var alignedWidth = calcPxFromColumns(columnSpan, lineLength, gridSize);
    return {
        height: (height / width) * alignedWidth,
        width: alignedWidth,
    };
};
//# sourceMappingURL=grid.js.map

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_MentionResource__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_PresenceResource__ = __webpack_require__(2938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MentionItem__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MentionList__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ResourcedMentionList__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MentionPicker__ = __webpack_require__(2949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Mention__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Mention_ResourcedMention__ = __webpack_require__(2954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_searchIndex__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_ContextMentionResource__ = __webpack_require__(2955);
/* unused harmony reexport ContextMentionResource */
/* unused harmony reexport MentionResource */
/* unused harmony reexport PresenceResource */
/* unused harmony reexport AbstractMentionResource */
/* unused harmony reexport AbstractPresenceResource */
/* unused harmony reexport SearchIndex */
/* unused harmony reexport MentionItem */
/* unused harmony reexport MentionList */
/* unused harmony reexport ResourcedMentionList */
/* unused harmony reexport MentionPicker */
/* unused harmony reexport Mention */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__components_Mention_ResourcedMention__["a"]; });
/* unused harmony reexport isSpecialMention */
/* unused harmony reexport ELEMENTS_CHANNEL */













/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_5__components_MentionPicker__["a" /* MentionPickerWithAnalytics */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HttpError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AbstractResource; });
/* unused harmony export AbstractMentionResource */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_logger__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_searchIndex__ = __webpack_require__(903);





var MAX_QUERY_ITEMS = 100;
var MAX_NOTIFIED_ITEMS = 20;
var emptySecurityProvider = function () {
    return {
        params: {},
        headers: {},
    };
};
var AbstractResource = /** @class */ (function () {
    function AbstractResource() {
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
    }
    AbstractResource.prototype.subscribe = function (key, callback, errCallback, infoCallback, allResultsCallback) {
        if (callback) {
            this.changeListeners.set(key, callback);
        }
        if (errCallback) {
            this.errListeners.set(key, errCallback);
        }
        if (infoCallback) {
            this.infoListeners.set(key, infoCallback);
        }
        if (allResultsCallback) {
            this.allResultsListeners.set(key, allResultsCallback);
        }
    };
    AbstractResource.prototype.unsubscribe = function (key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
    };
    return AbstractResource;
}());
var AbstractMentionResource = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AbstractMentionResource, _super);
    function AbstractMentionResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AbstractMentionResource.prototype.shouldHighlightMention = function (mention) {
        return false;
    };
    // eslint-disable-next-line class-methods-use-this
    AbstractMentionResource.prototype.filter = function (query) {
        throw new Error("not yet implemented.\nParams: query=" + query);
    };
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    AbstractMentionResource.prototype.recordMentionSelection = function (mention) {
        // Do nothing
    };
    AbstractMentionResource.prototype.isFiltering = function (query) {
        return false;
    };
    AbstractMentionResource.prototype._notifyListeners = function (mentionsResult, stats) {
        Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])('ak-mention-resource._notifyListeners', mentionsResult &&
            mentionsResult.mentions &&
            mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach(function (listener, key) {
            try {
                listener(mentionsResult.mentions.slice(0, MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            }
            catch (e) {
                // ignore error from listener
                Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])("error from listener '" + key + "', ignoring", e);
            }
        });
    };
    AbstractMentionResource.prototype._notifyAllResultsListeners = function (mentionsResult) {
        Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])('ak-mention-resource._notifyAllResultsListeners', mentionsResult &&
            mentionsResult.mentions &&
            mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach(function (listener, key) {
            try {
                listener(mentionsResult.mentions.slice(0, MAX_NOTIFIED_ITEMS), mentionsResult.query);
            }
            catch (e) {
                // ignore error from listener
                Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])("error from listener '" + key + "', ignoring", e);
            }
        });
    };
    AbstractMentionResource.prototype._notifyErrorListeners = function (error, query) {
        this.errListeners.forEach(function (listener, key) {
            try {
                listener(error, query);
            }
            catch (e) {
                // ignore error from listener
                Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])("error from listener '" + key + "', ignoring", e);
            }
        });
    };
    AbstractMentionResource.prototype._notifyInfoListeners = function (info) {
        this.infoListeners.forEach(function (listener, key) {
            try {
                listener(info);
            }
            catch (e) {
                // ignore error fromr listener
                Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])("error from listener '" + key + "', ignoring", e);
            }
        });
    };
    return AbstractMentionResource;
}(AbstractResource));
/**
 * Provides a Javascript API
 */
var MentionResource = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionResource, _super);
    function MentionResource(config) {
        var _this = _super.call(this) || this;
        if (!config.url) {
            throw new Error('config.url is a required parameter');
        }
        if (!config.securityProvider) {
            config.securityProvider = emptySecurityProvider;
        }
        _this.config = config;
        _this.lastReturnedSearch = 0;
        _this.searchIndex = new __WEBPACK_IMPORTED_MODULE_4__util_searchIndex__["a" /* SearchIndex */]();
        _this.activeSearches = new Set();
        return _this;
    }
    MentionResource.prototype.shouldHighlightMention = function (mention) {
        if (this.config.shouldHighlightMention) {
            return this.config.shouldHighlightMention(mention);
        }
        return false;
    };
    MentionResource.prototype.notify = function (searchTime, mentionResult, query, remoteSearch) {
        var _this = this;
        this.sortMentionsResult(mentionResult).then(function (sortedMentionsResult) {
            if (searchTime > _this.lastReturnedSearch) {
                _this.lastReturnedSearch = searchTime;
                _this._notifyListeners(sortedMentionsResult, {
                    duration: Date.now() - searchTime,
                    remoteSearch: remoteSearch,
                });
            }
            else {
                var date = new Date(searchTime).toISOString().substr(17, 6);
                Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
            }
            _this._notifyAllResultsListeners(sortedMentionsResult);
        });
    };
    MentionResource.prototype.notifyError = function (error, query) {
        this._notifyErrorListeners(error, query);
        if (query) {
            this.activeSearches.delete(query);
        }
    };
    MentionResource.prototype.filter = function (query, contextIdentifier) {
        var _this = this;
        var searchTime = Date.now();
        if (!query) {
            this.initialState(contextIdentifier).then(function (results) { return _this.notify(searchTime, results, query, true); }, function (error) { return _this.notifyError(error, query); });
        }
        else {
            this.activeSearches.add(query);
            var searchResponse_1 = this.search(query, contextIdentifier);
            searchResponse_1.mentions.then(function (results) {
                _this.notify(searchTime, results, query, searchResponse_1.remoteSearch);
            }, function (error) { return _this.notifyError(error, query); });
        }
    };
    MentionResource.prototype.recordMentionSelection = function (mention, contextIdentifier) {
        return this.recordSelection(mention, contextIdentifier).then(function () { }, function (error) { return Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])("error recording mention selection: " + error, error); });
    };
    MentionResource.prototype.isFiltering = function (query) {
        return this.activeSearches.has(query);
    };
    MentionResource.prototype.initialState = function (contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    };
    MentionResource.prototype.getUserIdsInContext = function () {
        if (this.config.getUsersInContext) {
            return this.config
                .getUsersInContext()
                .then(function (users) {
                return users.reduce(function (acc, value) { return acc.add(value.id); }, new Set());
            });
        }
        return Promise.resolve(new Set());
    };
    MentionResource.prototype.getQueryParams = function (contextIdentifier) {
        var configParams = {};
        if (this.config.containerId) {
            configParams['containerId'] = this.config.containerId;
        }
        if (this.config.productId) {
            configParams['productIdentifier'] = this.config.productId;
        }
        // if contextParams exist then it will override configParams for containerId
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, configParams, contextIdentifier);
    };
    /**
     * Returns the initial mention display list before a search is performed for the specified
     * container.
     *
     * @param contextIdentifier
     * @returns Promise
     */
    MentionResource.prototype.remoteInitialState = function (contextIdentifier) {
        var _this = this;
        var queryParams = this.getQueryParams(contextIdentifier);
        var options = {
            path: 'bootstrap',
            queryParams: queryParams,
        };
        return __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */]
            .requestService(this.config, options)
            .then(function (result) { return _this.transformServiceResponse(result, ''); })
            .then(function (result) {
            _this.searchIndex.indexResults(result.mentions);
            return result;
        });
    };
    MentionResource.prototype.searchAsync = function (query, contextIdentifier) {
        var _this = this;
        var searchTime = Date.now() + 1; // Ensure that search time is different than the local search time
        this.remoteSearch(query, contextIdentifier).then(function (result) {
            _this.activeSearches.delete(query);
            _this.notify(searchTime, result, query, true);
            _this.searchIndex.indexResults(result.mentions);
        }, function (err) {
            _this._notifyErrorListeners(err);
        });
    };
    MentionResource.prototype.search = function (query, contextIdentifier) {
        var _this = this;
        if (this.searchIndex.hasDocuments()) {
            return {
                mentions: this.searchIndex.search(query).then(function (result) {
                    _this.searchAsync(query, contextIdentifier);
                    // return local search result quickly while the back-end search runs async
                    return result;
                }),
                remoteSearch: false,
            };
        }
        return {
            mentions: this.remoteSearch(query, contextIdentifier).then(function (result) {
                _this.searchIndex.indexResults(result.mentions);
                return result;
            }),
            remoteSearch: true,
        };
    };
    MentionResource.prototype.sortMentionsResult = function (mentionsResult) {
        return this.getUserIdsInContext().then(function (userIdsInContext) {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, mentionsResult, { mentions: mentionsResult.mentions.sort(Object(__WEBPACK_IMPORTED_MODULE_4__util_searchIndex__["b" /* mentionDescriptionComparator */])(userIdsInContext)) });
        });
    };
    MentionResource.prototype.remoteSearch = function (query, contextIdentifier) {
        var _this = this;
        var options = {
            path: 'search',
            queryParams: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ query: query, limit: MAX_QUERY_ITEMS }, this.getQueryParams(contextIdentifier)),
        };
        return __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */]
            .requestService(this.config, options)
            .then(function (result) { return _this.transformServiceResponse(result, query); });
    };
    MentionResource.prototype.transformServiceResponse = function (result, query) {
        var mentions = result.mentions.map(function (mention, index) {
            var lozenge;
            var weight = mention.weight !== undefined ? mention.weight : index;
            if (Object(__WEBPACK_IMPORTED_MODULE_2__types__["b" /* isAppMention */])(mention)) {
                lozenge = mention.userType;
            }
            else if (Object(__WEBPACK_IMPORTED_MODULE_2__types__["f" /* isTeamMention */])(mention)) {
                lozenge = mention.userType;
            }
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, mention, { lozenge: lozenge, weight: weight, query: query });
        });
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, result, { mentions: mentions, query: result.query || query });
    };
    MentionResource.prototype.recordSelection = function (mention, contextIdentifier) {
        var options = {
            path: 'record',
            queryParams: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ selectedUserId: mention.id }, this.getQueryParams(contextIdentifier)),
            requestInit: {
                method: 'POST',
            },
        };
        return __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */].requestService(this.config, options);
    };
    return MentionResource;
}(AbstractMentionResource));
var HttpError = /** @class */ (function () {
    function HttpError(statusCode, statusMessage) {
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
    return HttpError;
}());


/* unused harmony default export */ var _unused_webpack_default_export = (MentionResource);
//# sourceMappingURL=MentionResource.js.map

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Tokenizer */
/* harmony export (immutable) */ __webpack_exports__["b"] = mentionDescriptionComparator;
/* unused harmony export Highlighter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_search__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__searchIndexRegex__ = __webpack_require__(2937);




// Order by increasing weight, using a big enough number to put item without an explicit weight
// at the end
var DEFAULT_WEIGHT = 100000;
var Tokenizer = /** @class */ (function () {
    function Tokenizer() {
    }
    Tokenizer.tokenize = function (text) {
        return this.tokenizeAsTokens(text).map(function (token) { return token.token; });
    };
    Tokenizer.tokenizeAsTokens = function (text) {
        var match;
        var tokens = [];
        __WEBPACK_IMPORTED_MODULE_3__searchIndexRegex__["b" /* tokenizerRegex */].lastIndex = 0;
        while ((match = __WEBPACK_IMPORTED_MODULE_3__searchIndexRegex__["b" /* tokenizerRegex */].exec(text)) !== null) {
            if (match[0]) {
                tokens.push({
                    token: match[0],
                    start: match.index,
                });
            }
        }
        return tokens;
    };
    return Tokenizer;
}());

/**
 * Returns a comparator function for MentionDescription object.
 *
 * @param {Set<string>} inContextUsers
 * @returns {(a: MentionDescription, b: MentionDescription) => number}
 */
function mentionDescriptionComparator(inContextUsers) {
    return function (a, b) {
        var aIsSpecialMention = Object(__WEBPACK_IMPORTED_MODULE_2__types__["d" /* isSpecialMention */])(a);
        var bIsSpecialMention = Object(__WEBPACK_IMPORTED_MODULE_2__types__["d" /* isSpecialMention */])(b);
        if (aIsSpecialMention && !bIsSpecialMention) {
            return -1;
        }
        if (bIsSpecialMention && !aIsSpecialMention) {
            return 1;
        }
        var aInContext = inContextUsers.has(a.id);
        var bInContext = inContextUsers.has(b.id);
        if (aInContext && !bInContext) {
            return -1;
        }
        if (bInContext && !aInContext) {
            return 1;
        }
        var aWeight = a.weight !== undefined ? a.weight : DEFAULT_WEIGHT;
        var bWeight = b.weight !== undefined ? b.weight : DEFAULT_WEIGHT;
        if (aWeight !== bWeight) {
            return aWeight - bWeight;
        }
        if (a.name && b.name) {
            return a.name.localeCompare(b.name);
        }
        return a.id.localeCompare(b.id);
    };
}
var Highlighter = /** @class */ (function () {
    function Highlighter() {
    }
    Highlighter.find = function (field, query) {
        var e_1, _a, e_2, _b;
        var highlights = [];
        if (field) {
            var queryTokens = Tokenizer.tokenizeAsTokens(query.toLowerCase());
            queryTokens.sort(function (a, b) { return -1 * a.token.localeCompare(b.token); });
            var lowercaseField = field.toLowerCase();
            var fieldTokens = Tokenizer.tokenizeAsTokens(lowercaseField);
            try {
                for (var fieldTokens_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](fieldTokens), fieldTokens_1_1 = fieldTokens_1.next(); !fieldTokens_1_1.done; fieldTokens_1_1 = fieldTokens_1.next()) {
                    var fieldToken = fieldTokens_1_1.value;
                    try {
                        for (var queryTokens_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](queryTokens), queryTokens_1_1 = queryTokens_1.next(); !queryTokens_1_1.done; queryTokens_1_1 = queryTokens_1.next()) {
                            var queryToken = queryTokens_1_1.value;
                            if (fieldToken.token.indexOf(queryToken.token) === 0) {
                                var start = fieldToken.start;
                                var end = start + queryToken.token.length - 1;
                                var i = end + 1;
                                var combiningCharacters = 0;
                                // Includes non spacing mark in highlights (e.g. ញុំ  when searching ញ)
                                while (i < fieldToken.token.length &&
                                    __WEBPACK_IMPORTED_MODULE_3__searchIndexRegex__["a" /* nonSpacingMarkRegex */].test(fieldToken.token[i])) {
                                    ++combiningCharacters;
                                    ++i;
                                    __WEBPACK_IMPORTED_MODULE_3__searchIndexRegex__["a" /* nonSpacingMarkRegex */].lastIndex = 0;
                                }
                                highlights.push({
                                    start: start,
                                    end: end + combiningCharacters,
                                });
                                break;
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (queryTokens_1_1 && !queryTokens_1_1.done && (_b = queryTokens_1.return)) _b.call(queryTokens_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (fieldTokens_1_1 && !fieldTokens_1_1.done && (_a = fieldTokens_1.return)) _a.call(fieldTokens_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            if (highlights.length < queryTokens.length) {
                return [];
            }
        }
        return highlights;
    };
    return Highlighter;
}());

var SearchIndex = /** @class */ (function () {
    function SearchIndex() {
        this.reset();
    }
    SearchIndex.prototype.search = function (query) {
        var _this = this;
        if (query === void 0) { query = ''; }
        return new Promise(function (resolve) {
            var localResults = _this.index
                .search(query)
                .map(function (mention) {
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, mention, { highlight: {
                        name: Highlighter.find(mention.name, query),
                        mentionName: Highlighter.find(mention.mentionName, query),
                        nickname: Highlighter.find(mention.nickname, query),
                    } });
            })
                .filter(function (mention) {
                if (Object(__WEBPACK_IMPORTED_MODULE_2__types__["d" /* isSpecialMention */])(mention) &&
                    mention.highlight.nickname.length === 0) {
                    return false;
                }
                return true;
            });
            resolve({
                mentions: localResults,
                query: query,
            });
        });
    };
    SearchIndex.prototype.hasDocuments = function () {
        return this.indexedCount > 0;
    };
    SearchIndex.prototype.reset = function () {
        this.index = SearchIndex.createIndex();
        this.indexedCount = 0;
    };
    SearchIndex.prototype.indexResults = function (mentions) {
        this.index.addDocuments(mentions);
        this.indexedCount += mentions.length;
    };
    SearchIndex.createIndex = function () {
        var index = new __WEBPACK_IMPORTED_MODULE_1_js_search__["Search"]('id');
        index.searchIndex = new __WEBPACK_IMPORTED_MODULE_1_js_search__["UnorderedSearchIndex"]();
        index.tokenizer = Tokenizer;
        index.addIndex('name');
        index.addIndex('mentionName');
        index.addIndex('nickname');
        return index;
    };
    return SearchIndex;
}());

//# sourceMappingURL=searchIndex.js.map

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_avatar__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_lozenge__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_lock_circle__ = __webpack_require__(2939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_lock_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_lock_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_mouse__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(2942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_i18n__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NoAccessTooltip__ = __webpack_require__(906);











function renderHighlight(ReactComponent, value, highlights, prefix) {
    if (!value) {
        return null;
    }
    var parts = [];
    var prefixText = prefix || '';
    var lastIndex = 0;
    if (highlights) {
        for (var i = 0; i < highlights.length; i++) {
            var h = highlights[i];
            var start = h.start;
            var end = h.end;
            if (start > lastIndex) {
                parts.push({
                    value: value.substring(lastIndex, start),
                    matches: false,
                });
            }
            parts.push({
                value: value.substring(start, end + 1),
                matches: true,
            });
            lastIndex = end + 1;
        }
        if (lastIndex < value.length) {
            parts.push({
                value: value.substring(lastIndex, value.length),
                matches: false,
            });
        }
    }
    else {
        parts.push({
            value: value,
            matches: false,
        });
    }
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ReactComponent, null,
        prefixText,
        parts.map(function (part, index) {
            if (part.matches) {
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("b", { key: index }, part.value);
            }
            return part.value;
        })));
}
function renderLozenge(lozenge) {
    if (lozenge) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_lozenge__["default"], null, lozenge);
    }
    return null;
}
function renderTime(time) {
    if (time) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["i" /* TimeStyle */], null, time);
    }
    return null;
}
var MentionItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionItem, _super);
    function MentionItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // internal, used for callbacks
        _this.onMentionSelected = function (event) {
            if (Object(__WEBPACK_IMPORTED_MODULE_7__util_mouse__["b" /* leftClick */])(event) && _this.props.onSelection) {
                event.preventDefault();
                _this.props.onSelection(_this.props.mention, event);
            }
        };
        _this.onMentionMenuItemMouseMove = function (event) {
            if (_this.props.onMouseMove) {
                _this.props.onMouseMove(_this.props.mention, event);
            }
        };
        return _this;
    }
    MentionItem.prototype.render = function () {
        var _a = this.props, mention = _a.mention, selected = _a.selected;
        var id = mention.id, highlight = mention.highlight, avatarUrl = mention.avatarUrl, presence = mention.presence, name = mention.name, mentionName = mention.mentionName, nickname = mention.nickname, lozenge = mention.lozenge, accessLevel = mention.accessLevel;
        var _b = presence || {}, status = _b.status, time = _b.time;
        var restricted = Object(__WEBPACK_IMPORTED_MODULE_6__types__["c" /* isRestricted */])(accessLevel);
        var nameHighlights = highlight && highlight.name;
        var nicknameHighlights = highlight && highlight.nickname;
        var borderColor = selected ? __WEBPACK_IMPORTED_MODULE_5__atlaskit_theme__["colors"].N30 : undefined;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["e" /* MentionItemStyle */], { selected: selected, onMouseDown: this.onMentionSelected, onMouseMove: this.onMentionMenuItemMouseMove, "data-mention-id": id, "data-mention-name": mentionName },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["h" /* RowStyle */], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["b" /* AvatarStyle */], { restricted: restricted },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_avatar__["d" /* default */], { src: avatarUrl, size: "medium", presence: status, borderColor: borderColor })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["f" /* NameSectionStyle */], { restricted: restricted },
                    renderHighlight(__WEBPACK_IMPORTED_MODULE_8__styles__["c" /* FullNameStyle */], name, nameHighlights),
                    renderHighlight(__WEBPACK_IMPORTED_MODULE_8__styles__["g" /* NicknameStyle */], nickname, nicknameHighlights, '@')),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["d" /* InfoSectionStyle */], { restricted: restricted },
                    renderLozenge(lozenge),
                    renderTime(time)),
                restricted ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__NoAccessTooltip__["a" /* NoAccessTooltip */], { name: name },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* AccessSectionStyle */], null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__util_i18n__["e" /* NoAccessLabel */], null, function (text) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_lock_circle___default.a, { label: text })); } /* safe to cast to string given there is no value binding */)))) : null)));
    };
    return MentionItem;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (MentionItem);
//# sourceMappingURL=index.js.map

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = mouseLocation;
/* harmony export (immutable) */ __webpack_exports__["a"] = actualMouseMove;
/* harmony export (immutable) */ __webpack_exports__["b"] = leftClick;
function mouseLocation(event) {
    return {
        x: event.clientX,
        y: event.clientY,
    };
}
// Used to prevent invalid mouse move detection on scroll
// lastPosition is object (x, y)
function actualMouseMove(oldPosition, newPosition) {
    if (!oldPosition ||
        oldPosition.x !== newPosition.x ||
        oldPosition.y !== newPosition.y) {
        return true;
    }
    return false;
}
function leftClick(event) {
    return (event.button === 0 &&
        !event.altKey &&
        !event.ctrlKey &&
        !event.metaKey &&
        !event.shiftKey);
}
//# sourceMappingURL=mouse.js.map

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoAccessTooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_tooltip__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_i18n__ = __webpack_require__(477);



var NoAccessTooltip = function (_a) {
    var name = _a.name, children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__util_i18n__["f" /* NoAccessWarning */], { name: name }, function (text) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__atlaskit_tooltip__["a" /* default */], { content: text, position: "right" }, children)); }));
};
//# sourceMappingURL=NoAccessTooltip.js.map

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MentionListError__ = __webpack_require__(2945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MentionItem__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Scrollable__ = __webpack_require__(2947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_logger__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_mouse__ = __webpack_require__(905);








function wrapIndex(mentions, index) {
    var len = mentions.length;
    var newIndex = index;
    while (newIndex < 0 && len > 0) {
        newIndex += len;
    }
    return newIndex % len;
}
function getKey(index, mentions) {
    return mentions && mentions[index] && mentions[index].id;
}
function getIndex(key, mentions) {
    var index;
    if (mentions) {
        index = 0;
        while (index < mentions.length && mentions[index].id !== key) {
            index++;
        }
        if (index === mentions.length) {
            index = undefined;
        }
    }
    return index;
}
var MentionList = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionList, _super);
    function MentionList(props) {
        var _this = _super.call(this, props) || this;
        // API
        _this.selectNext = function () {
            var newIndex = wrapIndex(_this.props.mentions, _this.state.selectedIndex + 1);
            _this.selectIndex(newIndex);
        };
        _this.selectPrevious = function () {
            var newIndex = wrapIndex(_this.props.mentions, _this.state.selectedIndex - 1);
            _this.selectIndex(newIndex);
        };
        _this.selectIndex = function (index, callback) {
            var mentions = _this.props.mentions;
            _this.setState({
                selectedIndex: index,
                selectedKey: getKey(index, mentions),
            }, callback);
        };
        _this.selectId = function (id, callback) {
            var mentions = _this.props.mentions;
            var index = getIndex(id, mentions);
            if (index !== undefined) {
                _this.setState({
                    selectedIndex: index,
                    selectedKey: id,
                }, callback);
            }
        };
        _this.chooseCurrentSelection = function () {
            var _a = _this.props, mentions = _a.mentions, onSelection = _a.onSelection;
            var selectedIndex = _this.state.selectedIndex;
            var selectedMention = mentions && mentions[selectedIndex || 0];
            Object(__WEBPACK_IMPORTED_MODULE_6__util_logger__["a" /* default */])('ak-mention-list.chooseCurrentSelection', selectedMention);
            if (onSelection && selectedMention) {
                onSelection(selectedMention);
            }
        };
        _this.mentionsCount = function () {
            var mentions = _this.props.mentions;
            return (mentions && mentions.length) || 0;
        };
        _this.selectIndexOnHover = function (mention, event) {
            if (!event) {
                return;
            }
            var mousePosition = Object(__WEBPACK_IMPORTED_MODULE_7__util_mouse__["c" /* mouseLocation */])(event);
            if (Object(__WEBPACK_IMPORTED_MODULE_7__util_mouse__["a" /* actualMouseMove */])(_this.lastMousePosition, mousePosition)) {
                _this.selectId(mention.id);
            }
            _this.lastMousePosition = mousePosition;
        };
        _this.itemSelected = function (mention) {
            _this.selectId(mention.id, function () {
                _this.chooseCurrentSelection();
            });
        };
        _this.handleScrollableRef = function (ref) {
            _this.scrollable = ref;
        };
        _this.setDefaultSelectionState();
        return _this;
    }
    MentionList.prototype.componentWillReceiveProps = function (nextProps) {
        // adjust selection
        var mentions = nextProps.mentions;
        var selectedKey = this.state.selectedKey;
        if (mentions) {
            if (!selectedKey) {
                // don't explicitly set any selected index and go with default behaviour
                return;
            }
            for (var i = 0; i < mentions.length; i++) {
                if (selectedKey === mentions[i].id) {
                    this.setState({
                        selectedIndex: i,
                    });
                    return;
                }
            }
            // existing selection not in results so clear any current selection state and go with default behaviour
            this.setDefaultSelectionState();
        }
    };
    MentionList.prototype.componentDidUpdate = function () {
        var mentions = this.props.mentions;
        var selectedIndex = this.state.selectedIndex;
        if (mentions && mentions[selectedIndex]) {
            this.revealItem(mentions[selectedIndex].id);
        }
        // FIXME - a React version of this _may_ be required for Confluence
        // integration tests. Will remove / fix once known
        // emit(elem, mentionListRenderedEvent);
    };
    // Internal
    MentionList.prototype.revealItem = function (key) {
        var item = this.items[key];
        if (item && this.scrollable) {
            this.scrollable.reveal(item);
        }
    };
    /**
     * The default selection state is to chose index 0 and not have any particular key selected
     */
    MentionList.prototype.setDefaultSelectionState = function () {
        this.state = {
            selectedIndex: 0,
            selectedKey: undefined,
        };
    };
    MentionList.prototype.renderItems = function () {
        var _this = this;
        var mentions = this.props.mentions;
        if (mentions && mentions.length) {
            this.items = {};
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, mentions.map(function (mention, idx) {
                var key = mention.id;
                var item = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__MentionItem__["a" /* default */], { mention: mention, selected: _this.isSelectedMention(mention, idx), key: key, onMouseMove: _this.selectIndexOnHover, 
                    /* Cannot use onclick, as onblur will close the element, and prevent
                     * onClick from firing.
                     */
                    onSelection: _this.itemSelected, 
                    // tslint:disable-next-line:jsx-no-lambda
                    ref: function (ref) {
                        if (ref) {
                            _this.items[key] = ref;
                        }
                        else {
                            delete _this.items[key];
                        }
                    } }));
                return item;
            })));
        }
        return null;
    };
    MentionList.prototype.isSelectedMention = function (mention, index) {
        var selectedKey = this.state.selectedKey;
        return selectedKey ? selectedKey === mention.id : index === 0;
    };
    MentionList.prototype.render = function () {
        var _a = this.props, mentions = _a.mentions, resourceError = _a.resourceError;
        var hasMentions = mentions && mentions.length;
        // If we get an error, but existing mentions are displayed, lets
        // just continue to show the existing mentions we have
        var mustShowError = resourceError && !hasMentions;
        var errorSection;
        var resultSection;
        if (mustShowError) {
            errorSection = __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__MentionListError__["a" /* default */], { error: resourceError });
        }
        else if (hasMentions) {
            resultSection = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Scrollable__["a" /* default */], { ref: this.handleScrollableRef }, this.renderItems()));
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* MentionListStyle */], { empty: !hasMentions && !resourceError },
            errorSection,
            resultSection));
    };
    return MentionList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (MentionList);
//# sourceMappingURL=index.js.map

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MentionListErrorStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GenericErrorVisualStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MentionListErrorHeadlineStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MentionListAdviceStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



// tslint:disable:next-line variable-name
var MentionListErrorStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  background-color: white;\n  color: ", ";\n  border: 1px solid #fff;\n  border-radius: ", "px;\n"], ["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  background-color: white;\n  color: ", ";\n  border: 1px solid #fff;\n  border-radius: ", "px;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N500, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])());
var GenericErrorVisualStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  height: 108px;\n  margin-bottom: 8px;\n  margin-top: 36px;\n  width: 83px;\n"], ["\n  height: 108px;\n  margin-bottom: 8px;\n  margin-top: 36px;\n  width: 83px;\n"])));
// TODO: Figure out why the themed css function is causing type errors when passed prop children
var MentionListErrorHeadlineStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", ";\n  margin-bottom: 8px;\n"], ["\n  ", ";\n  margin-bottom: 8px;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["typography"].h400());
var MentionListAdviceStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin-bottom: 48px;\n"], ["\n  margin-bottom: 48px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MentionList__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_logger__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_id__ = __webpack_require__(910);





function applyPresence(mentions, presences) {
    var updatedMentions = [];
    for (var i = 0; i < mentions.length; i++) {
        // Shallow copy
        var mention = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, mentions[i]);
        var presence = presences[mention.id];
        if (presence) {
            mention.presence = presence;
        }
        updatedMentions.push(mention);
    }
    return updatedMentions;
}
function extractPresences(mentions) {
    var presences = {};
    for (var i = 0; i < mentions.length; i++) {
        var mention = mentions[i];
        if (mention.presence) {
            presences[mention.id] = mention.presence;
        }
    }
    return presences;
}
var ResourcedMentionList = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ResourcedMentionList, _super);
    function ResourcedMentionList(props) {
        var _this = _super.call(this, props) || this;
        // API
        _this.selectNext = function () {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectNext();
            }
        };
        _this.selectPrevious = function () {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectPrevious();
            }
        };
        _this.selectIndex = function (index, callback) {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectIndex(index, callback);
            }
        };
        _this.selectId = function (id, callback) {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectId(id, callback);
            }
        };
        _this.chooseCurrentSelection = function () {
            if (_this.mentionListRef) {
                _this.mentionListRef.chooseCurrentSelection();
            }
        };
        _this.mentionsCount = function () {
            if (_this.mentionListRef) {
                return _this.mentionListRef.mentionsCount();
            }
            return 0;
        };
        // internal, used for callbacks
        _this.filterChange = function (mentions) {
            // Retain known presence
            var currentPresences = extractPresences(_this.state.mentions);
            _this.setState({
                resourceError: undefined,
                mentions: applyPresence(mentions, currentPresences),
            });
            _this.refreshPresences(mentions);
        };
        _this.filterError = function (error) {
            Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])('ak-resourced-mentions-list._filterError', error);
            _this.setState({
                resourceError: error,
            });
        };
        _this.presenceUpdate = function (presences) {
            _this.setState({
                mentions: applyPresence(_this.state.mentions, presences),
            });
        };
        _this.notifySelection = function (mention) {
            _this.props.resourceProvider.recordMentionSelection(mention);
            if (_this.props.onSelection) {
                _this.props.onSelection(mention);
            }
        };
        _this.handleMentionListRef = function (ref) {
            _this.mentionListRef = ref;
        };
        _this.subscriberKey = Object(__WEBPACK_IMPORTED_MODULE_4__util_id__["a" /* default */])('ak-resourced-mention-list');
        _this.state = {
            resourceError: undefined,
            mentions: [],
        };
        _this.applyPropChanges({}, props);
        return _this;
    }
    ResourcedMentionList.prototype.componentDidMount = function () {
        this.subscribeMentionProvider(this.props.resourceProvider);
        this.subscribePresenceProvider(this.props.presenceProvider);
    };
    ResourcedMentionList.prototype.componentWillReceiveProps = function (nextProps) {
        this.applyPropChanges(this.props, nextProps);
    };
    ResourcedMentionList.prototype.componentWillUnmount = function () {
        this.unsubscribeMentionProvider(this.props.resourceProvider);
        this.unsubscribePresenceProvider(this.props.presenceProvider);
    };
    // internal
    ResourcedMentionList.prototype.subscribeMentionProvider = function (mentionProvider) {
        if (mentionProvider) {
            mentionProvider.subscribe(this.subscriberKey, this.filterChange, this.filterError);
        }
    };
    ResourcedMentionList.prototype.subscribePresenceProvider = function (presenceProvider) {
        if (presenceProvider) {
            presenceProvider.subscribe(this.subscriberKey, this.presenceUpdate);
        }
    };
    ResourcedMentionList.prototype.unsubscribeMentionProvider = function (mentionProvider) {
        if (mentionProvider) {
            mentionProvider.unsubscribe(this.subscriberKey);
        }
    };
    ResourcedMentionList.prototype.unsubscribePresenceProvider = function (presenceProvider) {
        if (presenceProvider) {
            presenceProvider.unsubscribe(this.subscriberKey);
        }
    };
    ResourcedMentionList.prototype.applyPropChanges = function (prevProps, nextProps) {
        var oldResourceProvider = prevProps.resourceProvider;
        var oldPresenceProvider = prevProps.presenceProvider;
        var oldQuery = prevProps.query;
        var newResourceProvider = nextProps.resourceProvider;
        var newPresenceProvider = nextProps.presenceProvider;
        var newQuery = nextProps.query;
        var resourceProviderChanged = oldResourceProvider !== newResourceProvider;
        var queryChanged = oldQuery !== newQuery;
        var canFilter = !!(typeof newQuery === 'string' && newResourceProvider);
        var shouldFilter = canFilter && (queryChanged || resourceProviderChanged);
        // resource provider
        if (resourceProviderChanged) {
            this.unsubscribeMentionProvider(oldResourceProvider);
            this.subscribeMentionProvider(newResourceProvider);
        }
        // presence provider
        if (oldPresenceProvider !== newPresenceProvider) {
            this.unsubscribePresenceProvider(oldPresenceProvider);
            this.subscribePresenceProvider(newPresenceProvider);
        }
        if (shouldFilter) {
            newResourceProvider.filter(newQuery);
        }
    };
    ResourcedMentionList.prototype.refreshPresences = function (mentions) {
        if (this.props.presenceProvider) {
            var ids = mentions.map(function (mention) { return mention.id; });
            this.props.presenceProvider.refreshPresence(ids);
        }
    };
    ResourcedMentionList.prototype.render = function () {
        var _a = this.state, mentions = _a.mentions, resourceError = _a.resourceError;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__MentionList__["a" /* default */], { mentions: mentions, resourceError: resourceError, onSelection: this.notifySelection, ref: this.handleMentionListRef }));
    };
    return ResourcedMentionList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (ResourcedMentionList);
//# sourceMappingURL=index.js.map

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid__);

/* harmony default export */ __webpack_exports__["a"] = (function (prefix) {
    if (prefix === void 0) { prefix = ''; }
    return prefix + "_" + __WEBPACK_IMPORTED_MODULE_0_uuid__();
});
//# sourceMappingURL=id.js.map

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fireAnalyticsMentionTypeaheadEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fireAnalyticsMentionEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fireAnalytics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__package_json__ = __webpack_require__(2952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(136);



var fireAnalyticsMentionTypeaheadEvent = function (props) { return function (action, duration, userIds, query) {
    if (userIds === void 0) { userIds = []; }
    if (props.createAnalyticsEvent) {
        var eventPayload = {
            action: action,
            actionSubject: 'mentionTypeahead',
            attributes: {
                packageName: __WEBPACK_IMPORTED_MODULE_1__package_json__["name"],
                packageVersion: __WEBPACK_IMPORTED_MODULE_1__package_json__["version"],
                componentName: 'mention',
                duration: Math.round(duration),
                userIds: userIds,
                queryLength: query ? query.length : 0,
            },
            eventType: 'operational',
        };
        var analyticsEvent = props.createAnalyticsEvent(eventPayload);
        analyticsEvent.fire(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ELEMENTS_CHANNEL */]);
    }
}; };
var fireAnalyticsMentionEvent = function (createEvent) { return function (actionSubject, action, text, id, accessLevel) {
    var payload = {
        action: action,
        actionSubject: actionSubject,
        eventType: 'ui',
        attributes: {
            packageName: __WEBPACK_IMPORTED_MODULE_1__package_json__["name"],
            packageVersion: __WEBPACK_IMPORTED_MODULE_1__package_json__["version"],
            componentName: 'mention',
            accessLevel: accessLevel,
            isSpecial: Object(__WEBPACK_IMPORTED_MODULE_2__types__["e" /* isSpecialMentionText */])(text),
            userId: id,
        },
    };
    var event = createEvent(payload);
    event.fire(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ELEMENTS_CHANNEL */]);
    return event;
}; };
// OLD Analytics
var MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
var fireAnalytics = function (firePrivateAnalyticsEvent) { return function (eventName, text, accessLevel) {
    if (firePrivateAnalyticsEvent) {
        firePrivateAnalyticsEvent(MENTION_ANALYTICS_PREFIX + "." + eventName, {
            accessLevel: accessLevel,
            isSpecial: Object(__WEBPACK_IMPORTED_MODULE_2__types__["e" /* isSpecialMentionText */])(text),
        });
    }
}; };
//# sourceMappingURL=analytics.js.map

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ELEMENTS_CHANNEL; });
var ELEMENTS_CHANNEL = 'fabric-elements';
//# sourceMappingURL=constants.js.map

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ANALYTICS_HOVER_DELAY */
/* unused harmony export MentionInternal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NoAccessTooltip__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_analytics__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__ = __webpack_require__(29);








var ANALYTICS_HOVER_DELAY = 1000;
var MentionInternal = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionInternal, _super);
    function MentionInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnClick = function (e) {
            var _a = _this.props, id = _a.id, text = _a.text, onClick = _a.onClick;
            if (onClick) {
                onClick(id, text, e);
            }
        };
        _this.handleOnMouseEnter = function (e) {
            var _a = _this.props, id = _a.id, text = _a.text, onMouseEnter = _a.onMouseEnter, onHover = _a.onHover;
            if (onMouseEnter) {
                onMouseEnter(id, text, e);
            }
            _this.hoverTimeout = window.setTimeout(function () {
                if (onHover) {
                    onHover();
                }
                _this.hoverTimeout = undefined;
            }, ANALYTICS_HOVER_DELAY);
        };
        _this.handleOnMouseLeave = function (e) {
            var _a = _this.props, id = _a.id, text = _a.text, onMouseLeave = _a.onMouseLeave;
            if (onMouseLeave) {
                onMouseLeave(id, text, e);
            }
            if (_this.hoverTimeout) {
                clearTimeout(_this.hoverTimeout);
            }
        };
        _this.getMentionType = function () {
            var _a = _this.props, accessLevel = _a.accessLevel, isHighlighted = _a.isHighlighted;
            if (isHighlighted) {
                return __WEBPACK_IMPORTED_MODULE_4__types__["a" /* MentionType */].SELF;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_4__types__["c" /* isRestricted */])(accessLevel)) {
                return __WEBPACK_IMPORTED_MODULE_4__types__["a" /* MentionType */].RESTRICTED;
            }
            return __WEBPACK_IMPORTED_MODULE_4__types__["a" /* MentionType */].DEFAULT;
        };
        return _this;
    }
    MentionInternal.prototype.componentWillUnmount = function () {
        if (this.hoverTimeout) {
            clearTimeout(this.hoverTimeout);
        }
    };
    MentionInternal.prototype.render = function () {
        var _a = this, handleOnClick = _a.handleOnClick, handleOnMouseEnter = _a.handleOnMouseEnter, handleOnMouseLeave = _a.handleOnMouseLeave, props = _a.props;
        var text = props.text, id = props.id, accessLevel = props.accessLevel;
        var mentionType = this.getMentionType();
        var mentionComponent = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* MentionStyle */], { mentionType: mentionType, onClick: handleOnClick, onMouseEnter: handleOnMouseEnter, onMouseLeave: handleOnMouseLeave }, text));
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { "data-mention-id": id, "data-access-level": accessLevel, spellCheck: false }, mentionType === __WEBPACK_IMPORTED_MODULE_4__types__["a" /* MentionType */].RESTRICTED ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__NoAccessTooltip__["a" /* NoAccessTooltip */], { name: text }, mentionComponent)) : (mentionComponent)));
    };
    return MentionInternal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

// tslint:disable-next-line:variable-name
var MentionWithAnalytics = Object(__WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__["withAnalyticsEvents"])({
    onClick: function (createEvent, props) {
        var id = props.id, text = props.text, accessLevel = props.accessLevel, firePrivateAnalyticsEvent = props.firePrivateAnalyticsEvent;
        var event = Object(__WEBPACK_IMPORTED_MODULE_5__util_analytics__["b" /* fireAnalyticsMentionEvent */])(createEvent)('mention', 'selected', text, id, accessLevel);
        // old analytics
        Object(__WEBPACK_IMPORTED_MODULE_5__util_analytics__["a" /* fireAnalytics */])(firePrivateAnalyticsEvent)('lozenge.select', text, accessLevel);
        return event;
    },
    onHover: function (createEvent, props) {
        var id = props.id, text = props.text, accessLevel = props.accessLevel, firePrivateAnalyticsEvent = props.firePrivateAnalyticsEvent;
        var event = Object(__WEBPACK_IMPORTED_MODULE_5__util_analytics__["b" /* fireAnalyticsMentionEvent */])(createEvent)('mention', 'hovered', text, id, accessLevel);
        // old analytics
        Object(__WEBPACK_IMPORTED_MODULE_5__util_analytics__["a" /* fireAnalytics */])(firePrivateAnalyticsEvent)('lozenge.hover', text, accessLevel);
        return event;
    },
})(MentionInternal);
var Mention = Object(__WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics__["a" /* withAnalytics */])(MentionWithAnalytics, {}, {});
/* harmony default export */ __webpack_exports__["a"] = (Mention);
//# sourceMappingURL=index.js.map

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raf_schd__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(2958);






var Popup = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Popup, _super);
    function Popup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            overflowScrollParent: false,
        };
        _this.placement = ['', ''];
        _this.handleRef = function (popup) {
            if (!popup) {
                return;
            }
            _this.initPopup(popup);
        };
        _this.scheduledUpdatePosition = Object(__WEBPACK_IMPORTED_MODULE_3_raf_schd__["a" /* default */])(function (props) {
            return _this.updatePosition(props);
        });
        _this.onResize = function () { return _this.scheduledUpdatePosition(); };
        return _this;
    }
    /**
     * Calculates new popup position
     */
    Popup.prototype.updatePosition = function (props, state) {
        if (props === void 0) { props = this.props; }
        if (state === void 0) { state = this.state; }
        var target = props.target, fitHeight = props.fitHeight, fitWidth = props.fitWidth, boundariesElement = props.boundariesElement, offset = props.offset, onPositionCalculated = props.onPositionCalculated, onPlacementChanged = props.onPlacementChanged, alignX = props.alignX, alignY = props.alignY, stickToBottom = props.stickToBottom;
        var popup = state.popup;
        if (!target || !popup) {
            return;
        }
        var placement = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* calculatePlacement */])(target, boundariesElement || document.body, fitWidth, fitHeight, alignX, alignY);
        if (onPlacementChanged && this.placement.join('') !== placement.join('')) {
            onPlacementChanged(placement);
            this.placement = placement;
        }
        var position = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* calculatePosition */])({
            placement: placement,
            popup: popup,
            target: target,
            offset: offset,
            stickToBottom: stickToBottom,
        });
        position = onPositionCalculated ? onPositionCalculated(position) : position;
        this.setState({ position: position });
    };
    Popup.prototype.cannotSetPopup = function (popup, target, overflowScrollParent) {
        /**
         * Check whether:
         * 1. Popup's offset targets which means whether or not its possible to correctly position popup along with given target.
         * 2. Popup is inside "overflow: scroll" container, but its offset parent isn't.
         *
         * Currently Popup isn't capable of position itself correctly in case 2,
         * Add "position: relative" to "overflow: scroll" container or to some other FloatingPanel wrapper inside it.
         */
        return ((document.body.contains(target) &&
            (popup.offsetParent && !popup.offsetParent.contains(target))) ||
            (overflowScrollParent &&
                !overflowScrollParent.contains(popup.offsetParent)));
    };
    /**
     * Popup initialization.
     * Checks whether it's possible to position popup along given target, and if it's not throws an error.
     */
    Popup.prototype.initPopup = function (popup) {
        var target = this.props.target;
        var overflowScrollParent = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["c" /* findOverflowScrollParent */])(popup);
        if (this.cannotSetPopup(popup, target, overflowScrollParent)) {
            return;
        }
        this.setState({ popup: popup, overflowScrollParent: overflowScrollParent }, this.scheduledUpdatePosition);
    };
    Popup.prototype.componentWillReceiveProps = function (newProps) {
        // We are delaying `updatePosition` otherwise it happens before the children
        // get rendered and we end up with a wrong position
        this.scheduledUpdatePosition(newProps);
    };
    Popup.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.onResize);
        var stickToBottom = this.props.stickToBottom;
        if (stickToBottom) {
            this.scrollElement = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["c" /* findOverflowScrollParent */])(this.props.target);
        }
        else {
            this.scrollElement = this.props.scrollableElement;
        }
        if (this.scrollElement) {
            this.scrollElement.addEventListener('scroll', this.onResize);
        }
    };
    Popup.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onResize);
        if (this.scrollElement) {
            this.scrollElement.removeEventListener('scroll', this.onResize);
        }
        this.scheduledUpdatePosition.cancel();
    };
    Popup.prototype.renderPopup = function () {
        var position = this.state.position;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this.handleRef, style: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ position: 'absolute', zIndex: this.props.zIndex || __WEBPACK_IMPORTED_MODULE_4__styles__["c" /* akEditorFloatingPanelZIndex */] }, position), "aria-label": this.props.ariaLabel || 'Popup', "data-editor-popup": true }, this.props.children));
    };
    Popup.prototype.render = function () {
        if (!this.props.target) {
            return null;
        }
        if (this.props.mountTo) {
            return Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["createPortal"])(this.renderPopup(), this.props.mountTo);
        }
        // Without mountTo property renders popup as is,
        // which means it will be cropped by "overflow: hidden" container.
        return this.renderPopup();
    };
    Popup.defaultProps = {
        offset: [0, 0],
    };
    return Popup;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Popup);
//# sourceMappingURL=index.js.map

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withOuterListeners;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);




// tslint:disable:next-line variable-name
function withOuterListeners(Component) {
    return /** @class */ (function (_super) {
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WithOutsideClick, _super);
        function WithOutsideClick() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.handleClick = function (evt) {
                var domNode = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](_this); // eslint-disable-line react/no-find-dom-node
                if (!domNode ||
                    (evt.target instanceof Node && !domNode.contains(evt.target))) {
                    _this.props.handleClickOutside();
                }
            };
            _this.handleKeydown = function (evt) {
                if (evt.code === 'Escape') {
                    _this.props.handleEscapeKeydown();
                }
            };
            return _this;
        }
        WithOutsideClick.prototype.componentDidMount = function () {
            if (this.props.handleClickOutside) {
                document.addEventListener('click', this.handleClick, false);
            }
            if (this.props.handleEscapeKeydown) {
                document.addEventListener('keydown', this.handleKeydown, false);
            }
        };
        WithOutsideClick.prototype.componentWillUnmount = function () {
            if (this.props.handleClickOutside) {
                document.removeEventListener('click', this.handleClick, false);
            }
            if (this.props.handleEscapeKeydown) {
                document.removeEventListener('keydown', this.handleKeydown, false);
            }
        };
        WithOutsideClick.prototype.render = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Component, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, this.props));
        };
        return WithOutsideClick;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
}
//# sourceMappingURL=with-outer-listeners.js.map

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Breakpoints; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getBreakpoint;
/* unused harmony export createWidthContext */
/* unused harmony export WidthProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Consumer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf_schd__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_size_detector__ = __webpack_require__(268);




var Breakpoints = {
    S: 'S',
    M: 'M',
    L: 'L',
};
var MAX_S = 1266;
var MAX_M = 2146;
function getBreakpoint(width) {
    if (width === void 0) { width = 0; }
    if (width >= MAX_S && width < MAX_M) {
        return Breakpoints.M;
    }
    else if (width >= MAX_M) {
        return Breakpoints.L;
    }
    return Breakpoints.S;
}
function createWidthContext(width) {
    if (width === void 0) { width = 0; }
    return { width: width, breakpoint: getBreakpoint(width) };
}
var _a = __WEBPACK_IMPORTED_MODULE_1_react__["createContext"](createWidthContext()), Provider = _a.Provider, Consumer = _a.Consumer;
var WidthProvider = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WidthProvider, _super);
    function WidthProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { width: 0 };
        _this.setWidth = Object(__WEBPACK_IMPORTED_MODULE_2_raf_schd__["a" /* default */])(function (width) {
            if (_this.state.width === width) {
                return;
            }
            _this.setState({ width: width });
        });
        _this.state.width = document.body.offsetWidth;
        return _this;
    }
    WidthProvider.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_size_detector__["a" /* default */], { containerStyle: {
                    height: '0',
                    borderStyle: 'none',
                } }, function (_a) {
                var width = _a.width;
                _this.setWidth(width);
                return null;
            }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Provider, { value: createWidthContext(this.state.width) }, this.props.children)));
    };
    return WidthProvider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));


//# sourceMappingURL=index.js.map

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return renderExtension; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(306);





var renderExtension = function (content, layout) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["h" /* WidthConsumer */], null, function (_a) {
    var width = _a.width;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* RendererCssClassName */].EXTENSION, style: {
            width: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["u" /* calcBreakoutWidth */])(layout, width),
        }, "data-layout": layout }, content));
})); };
var Extension = function (_a) {
    var serializer = _a.serializer, extensionHandlers = _a.extensionHandlers, rendererContext = _a.rendererContext, extensionType = _a.extensionType, extensionKey = _a.extensionKey, text = _a.text, parameters = _a.parameters, _b = _a.layout, layout = _b === void 0 ? 'default' : _b;
    try {
        if (extensionHandlers && extensionHandlers[extensionType]) {
            var content = extensionHandlers[extensionType]({
                type: 'extension',
                extensionKey: extensionKey,
                extensionType: extensionType,
                parameters: parameters,
                content: text,
            }, rendererContext.adDoc);
            switch (true) {
                case content && __WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"](content):
                    // Return the content directly if it's a valid JSX.Element
                    return renderExtension(content, layout);
                case !!content:
                    // We expect it to be Atlassian Document here
                    var nodes = Array.isArray(content) ? content : [content];
                    return Object(__WEBPACK_IMPORTED_MODULE_1____["e" /* renderNodes */])(nodes, serializer, rendererContext.schema, 'div');
            }
        }
    }
    catch (e) {
        /** We don't want this error to block renderer */
        /** We keep rendering the default content */
    }
    // Always return default content if anything goes wrong
    return renderExtension(text || 'extension', layout);
};
/* harmony default export */ __webpack_exports__["a"] = (Extension);
//# sourceMappingURL=extension.js.map

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PanelSharedCssClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return panelSharedStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(169);

// @ts-ignore: unused variable
// prettier-ignore



var PanelSharedCssClassName = {
    PANEL_CONTAINER: 'ak-editor-panel',
};
var panelSharedStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  & .", " {\n    border-radius: ", "px;\n    margin: ", "px 0;\n    padding: ", "px;\n    min-width: ", "px;\n    display: flex;\n    align-items: baseline;\n    word-break: break-word;\n\n    .ak-editor-panel__icon {\n      display: block;\n      flex-shrink: 0;\n      height: ", "px;\n      width: ", "px;\n      box-sizing: content-box;\n      padding-right: ", "px;\n\n      > span {\n        vertical-align: middle;\n        display: inline;\n      }\n    }\n\n    .ak-editor-panel__content {\n      margin: 1px 0 1px;\n      flex: 1 0 0;\n    }\n  }\n"], ["\n  & .", " {\n    border-radius: ", "px;\n    margin: ", "px 0;\n    padding: ", "px;\n    min-width: ", "px;\n    display: flex;\n    align-items: baseline;\n    word-break: break-word;\n\n    .ak-editor-panel__icon {\n      display: block;\n      flex-shrink: 0;\n      height: ", "px;\n      width: ", "px;\n      box-sizing: content-box;\n      padding-right: ", "px;\n\n      > span {\n        vertical-align: middle;\n        display: inline;\n      }\n    }\n\n    .ak-editor-panel__content {\n      margin: 1px 0 1px;\n      flex: 1 0 0;\n    }\n  }\n"])), PanelSharedCssClassName.PANEL_CONTAINER, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])(), Object(__WEBPACK_IMPORTED_MODULE_3__consts__["q" /* relativeSize */])(1.142), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])(), __WEBPACK_IMPORTED_MODULE_3__consts__["i" /* akEditorTableCellMinWidth */], Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() * 3, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() * 3, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])());
var templateObject_1;
//# sourceMappingURL=panel.js.map

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Emoji__ = __webpack_require__(2987);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Emoji__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MediaSingle__ = __webpack_require__(3007);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__MediaSingle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MediaSingle_styled__ = __webpack_require__(923);
/* unused harmony reexport MediaSingleDimensionHelper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MediaSingle_grid__ = __webpack_require__(924);
/* unused harmony reexport layoutSupportsWidth */
/* unused harmony reexport calcPxFromColumns */
/* unused harmony reexport calcPctFromPx */
/* unused harmony reexport calcPxFromPct */
/* unused harmony reexport calcColumnsFromPx */
/* unused harmony reexport snapToGrid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Mention__ = __webpack_require__(3008);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__Mention__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Popup__ = __webpack_require__(937);
/* unused harmony reexport Popup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UnsupportedBlock__ = __webpack_require__(3029);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__UnsupportedBlock__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BaseTheme__ = __webpack_require__(3030);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__BaseTheme__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__BaseTheme__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__with_outer_listeners__ = __webpack_require__(938);
/* unused harmony reexport withOuterListeners */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WidthProvider__ = __webpack_require__(939);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_9__WidthProvider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_9__WidthProvider__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_9__WidthProvider__["d"]; });










//# sourceMappingURL=index.js.map

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UsageFrequencyTracker; });
/* unused harmony export Gateway */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type_helpers__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DuplicateLimitedQueue__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StoredDuplicateLimitedQueue__ = __webpack_require__(2998);





/**
 * Keeps track of the last 150 emoji usages, although limiting the maximum count for a single emoji to 25 to
 * ensure we don't end up with only a single emoji being recorded. Usage is persisted to local storage for
 * consistency between 'sessions'.
 *
 * Skin tone variations for an emoji will be 'collapsed' so they are tracked as their base emoji. Gender
 * variations are not collapsed in this way and will be tracked per gender. This decision reflects the UI of
 * the EmojiPicker component.
 */
var UsageFrequencyTracker = /** @class */ (function () {
    function UsageFrequencyTracker(useStorageIfPossible) {
        if (useStorageIfPossible === void 0) { useStorageIfPossible = true; }
        var options = UsageFrequencyTracker.queueOptions;
        if (useStorageIfPossible && options.storage) {
            var queueOptions = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, options, { storage: options.storage });
            this.queue = new __WEBPACK_IMPORTED_MODULE_4__StoredDuplicateLimitedQueue__["a" /* default */](queueOptions);
        }
        else {
            this.queue = new __WEBPACK_IMPORTED_MODULE_3__DuplicateLimitedQueue__["a" /* default */](options);
        }
        this.gateway = new Gateway(10);
    }
    /**
     * Record the fact that the supplied emoji was used. You should note that usage is updated asynchronously so you can not
     * count on getOrder() reflecting this usage immediately.
     *
     * @param emoji the emoji who's usage is to be recorded. If the emoji has no id then no usage will be recorded
     */
    UsageFrequencyTracker.prototype.recordUsage = function (emoji) {
        var _this = this;
        var emojiId = emoji.id;
        if (emojiId) {
            if (Object(__WEBPACK_IMPORTED_MODULE_1__type_helpers__["g" /* isEmojiVariationDescription */])(emoji)) {
                emojiId = emoji.baseId;
            }
            this.gateway.submit(function () {
                if (emojiId) {
                    _this.queue.enqueue(emojiId);
                }
            });
        }
    };
    /**
     * Returns an array of emoji id (without skin tone variations) sorted by most used to least used. If there
     * are no usages then an empty array will be returned.
     */
    UsageFrequencyTracker.prototype.getOrder = function () {
        return this.queue.getItemsOrderedByDuplicateCount();
    };
    /**
     * Exposed for testing only. Clear any recorded usage.
     */
    UsageFrequencyTracker.prototype.clear = function () {
        this.queue.clear();
    };
    UsageFrequencyTracker.queueOptions = {
        storage: typeof window !== 'undefined' && window.localStorage,
        storagePrefix: __WEBPACK_IMPORTED_MODULE_2__constants__["m" /* localStoragePrefix */],
        maxDuplicates: 25,
        minUniqueItems: 5,
    };
    return UsageFrequencyTracker;
}());

var Gateway = /** @class */ (function () {
    function Gateway(maximumPermitted) {
        if (maximumPermitted < 1) {
            throw new RangeError('The maximumPermitted parameter must be 1 or more.');
        }
        this.maximumPermitted = maximumPermitted;
        this.count = 0;
    }
    /**
     * Run the supplied function if the count of already submitted work allows it. Drop the work
     * if it's not allowed to run.
     *
     * Will return true if the function has been submitted or false if it was not submitted.
     */
    Gateway.prototype.submit = function (f) {
        var _this = this;
        if (this.count >= this.maximumPermitted) {
            return false;
        }
        this.count++;
        var wrappedFunc = function () {
            try {
                f();
            }
            finally {
                _this.completed();
            }
        };
        window.setTimeout(wrappedFunc);
        return true;
    };
    Gateway.prototype.completed = function () {
        this.count--;
    };
    return Gateway;
}());

//# sourceMappingURL=UsageFrequencyTracker.js.map

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A queue which will limit the number of duplicates of type T that it holds. When the duplicate limit is
 * reached the earliest inserted duplicate (the "original") is removed to make room for the new insertion.
 */
var DuplicateLimitedQueue = /** @class */ (function () {
    /**
     * Construct a new DuplicateLimitedQueue.
     *
     * @param options the options for this queue.
     */
    function DuplicateLimitedQueue(options) {
        if (options.maxDuplicates < 1) {
            throw new RangeError('The maxDuplicates option must be at least 1');
        }
        if (options.minUniqueItems < 1) {
            throw new RangeError('The minUniqueItems option must be at least 1');
        }
        this.maximumSize = options.maxDuplicates * options.minUniqueItems;
        this.perItemSize = options.maxDuplicates;
        this.createEmptyState();
    }
    /**
     * @param item the item to add to the queue.
     */
    DuplicateLimitedQueue.prototype.enqueue = function (item) {
        this.enqueueWithoutOrdering(item);
        // enqueues are less time sensitive (and may happen less frequently) than queries against the queue
        // so do the ordering work on each enqueue.
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    };
    /**
     * Return the items in the queue, ordered by how often they are duplicated. The items with the
     * most duplicates come first in the returned Array.
     *
     * If there are no items in the queue then an empty Array will be returned.
     */
    DuplicateLimitedQueue.prototype.getItemsOrderedByDuplicateCount = function () {
        return this.itemsOrderedByFrequency;
    };
    /**
     * Exposed for storybook/testing purposes only. Clear the contents of the queue.
     */
    DuplicateLimitedQueue.prototype.clear = function () {
        this.createEmptyState();
    };
    /**
     * A more efficient mechanism for adding multiple items. Ordering is only performed once all
     * the items have been added.
     *
     * @param items the items to be enqueued, which happens in their presented order.
     */
    DuplicateLimitedQueue.prototype.bulkEnqueue = function (items) {
        var _this = this;
        items.map(function (item) { return _this.enqueueWithoutOrdering(item); });
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    };
    /**
     * Return the items currently stored in the queue.
     */
    DuplicateLimitedQueue.prototype.getItems = function () {
        return this.items;
    };
    DuplicateLimitedQueue.prototype.createEmptyState = function () {
        this.items = new Array();
        this.itemCountMap = new Map();
        this.itemsOrderedByFrequency = new Array();
    };
    /**
     * Enqueue the supplied item, keeping consistency with the limits configured. However no ordering is
     * performed by this enqueuing. You must trigger that manually if required.
     *
     * @param item the item to be queued
     */
    DuplicateLimitedQueue.prototype.enqueueWithoutOrdering = function (item) {
        var count = this.itemCountMap.get(item);
        if (count && count >= this.perItemSize) {
            // find the first item with that key in the array and remove it
            this.removeFirstOccurrence(item);
        }
        else {
            if (this.items.length >= this.maximumSize) {
                this.remove();
            }
        }
        this.add(item);
    };
    /**
     * Get an array of items from the queue ordered by how often they are duplicated in the queue.
     */
    DuplicateLimitedQueue.prototype.orderItemsByFrequency = function () {
        var orderedEntries = Array.from(this.itemCountMap.entries()).sort(function (a, b) {
            return b[1] - a[1];
        });
        return orderedEntries.map(function (value) { return value[0]; });
    };
    DuplicateLimitedQueue.prototype.decrementCount = function (item) {
        var count = this.itemCountMap.get(item);
        if (count) {
            count--;
            if (count > 0) {
                this.itemCountMap.set(item, count);
            }
            else {
                this.itemCountMap.delete(item);
            }
        }
    };
    /**
     * Walk the list of items and remove the first occurrence of the matching item.
     *
     * @param item the item to be removed.
     */
    DuplicateLimitedQueue.prototype.removeFirstOccurrence = function (item) {
        var index = this.items.indexOf(item);
        if (index !== -1) {
            this.items.splice(index, 1);
            this.decrementCount(item);
        }
    };
    /**
     * Remove the first item from the queue and update the itemCountMap accordingly.
     * @return the item add the front of the queue or undefined if the queue is empty
     */
    DuplicateLimitedQueue.prototype.remove = function () {
        var removed = this.items.shift();
        if (removed !== undefined) {
            this.decrementCount(removed);
        }
        return removed;
    };
    /**
     * Add the supplied item to the end of the queue and update the itemCountMap accordingly.
     * @param item the item to be added to the queue
     */
    DuplicateLimitedQueue.prototype.add = function (item) {
        this.items.push(item);
        var count = this.itemCountMap.get(item);
        if (count) {
            this.itemCountMap.set(item, count + 1);
        }
        else {
            this.itemCountMap.set(item, 1);
        }
    };
    return DuplicateLimitedQueue;
}());
/* harmony default export */ __webpack_exports__["a"] = (DuplicateLimitedQueue);
//# sourceMappingURL=DuplicateLimitedQueue.js.map

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EmojiUtils__ = __webpack_require__(231);

/**
 * Emoji providers should return JSON in the format defined by EmojiServiceResponse.
 */
var EmojiLoader = /** @class */ (function () {
    function EmojiLoader(config) {
        this.config = config;
    }
    /**
     * Returns a promise with an array of Emoji from all providers.
     */
    EmojiLoader.prototype.loadEmoji = function () {
        var emojisPromise = Object(__WEBPACK_IMPORTED_MODULE_0__EmojiUtils__["b" /* emojiRequest */])(this.config);
        return emojisPromise.then(function (emojiServiceResponse) {
            return Object(__WEBPACK_IMPORTED_MODULE_0__EmojiUtils__["a" /* denormaliseEmojiServiceResponse */])(emojiServiceResponse);
        });
    };
    return EmojiLoader;
}());
/* harmony default export */ __webpack_exports__["a"] = (EmojiLoader);
//# sourceMappingURL=EmojiLoader.js.map

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export calcLegacyWidth */
/* unused harmony export calcResizedWidth */
/* unused harmony export MediaSingleDimensionHelper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(479);




function float(layout) {
    switch (layout) {
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
/**
 * Calculates the image width for non-resized images.
 *
 * If an image has not been resized using the pctWidth attribute,
 * then an image in wide or full-width can not be wider than the image's
 * original width.
 */
function calcLegacyWidth(layout, width, containerWidth) {
    if (containerWidth === void 0) { containerWidth = 0; }
    switch (layout) {
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > __WEBPACK_IMPORTED_MODULE_2__styles__["e" /* akEditorFullPageMaxWidth */] / 2
                ? 'calc(50% - 12px)'
                : width + "px";
        case 'wide':
            return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* calcWideWidth */])(containerWidth);
        case 'full-width':
            return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* calcBreakoutWidth */])(layout, containerWidth);
        default:
            return width > __WEBPACK_IMPORTED_MODULE_2__styles__["e" /* akEditorFullPageMaxWidth */] ? '100%' : width + "px";
    }
}
/**
 * Calculates the image width for previously resized images.
 *
 * Wide and full-width images are always that size (960px and 100%); there is
 * no distinction between max-width and width.
 */
function calcResizedWidth(layout, width, containerWidth) {
    if (containerWidth === void 0) { containerWidth = 0; }
    switch (layout) {
        case 'wide':
            return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* calcWideWidth */])(containerWidth);
        case 'full-width':
            return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* calcBreakoutWidth */])(layout, containerWidth);
        default:
            return width + "px";
    }
}
function calcMaxWidth(layout, width, containerWidth) {
    switch (layout) {
        case 'wide':
            return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* calcWideWidth */])(containerWidth);
        case 'full-width':
            return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* calcBreakoutWidth */])(layout, containerWidth);
        default:
            return '100%';
    }
}
function calcMargin(layout) {
    switch (layout) {
        case 'wrap-right':
            return '12px auto 12px 24px';
        case 'wrap-left':
            return '12px 24px 12px auto';
        default:
            return '24px auto';
    }
}
function isImageAligned(layout) {
    switch (layout) {
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 */
var MediaSingleDimensionHelper = function (_a) {
    var width = _a.width, height = _a.height, layout = _a.layout, _b = _a.containerWidth, containerWidth = _b === void 0 ? 0 : _b, pctWidth = _a.pctWidth;
    return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  tr & {\n    max-width: 100%;\n  }\n  width: ", ";\n  max-width: ", ";\n  float: ", ";\n  margin: ", ";\n  ", ";\n"], ["\n  tr & {\n    max-width: 100%;\n  }\n  width: ",
        ";\n  max-width: ", ";\n  float: ", ";\n  margin: ", ";\n  ", ";\n"])), pctWidth
        ? calcResizedWidth(layout, width, containerWidth)
        : calcLegacyWidth(layout, width, containerWidth), calcMaxWidth(layout, width, containerWidth), float(layout), calcMargin(layout), isImageAligned(layout));
};
var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", ";\n  position: relative;\n\n  &::after {\n    content: '';\n    display: block;\n    padding-bottom: ", "%;\n  }\n\n  & > div {\n    position: absolute;\n    height: 100%;\n  }\n"], ["\n  ", ";\n  position: relative;\n\n  &::after {\n    content: '';\n    display: block;\n    padding-bottom: ", "%;\n  }\n\n  & > div {\n    position: absolute;\n    height: 100%;\n  }\n"])), MediaSingleDimensionHelper, function (p) { return (p.height / p.width) * 100; });
Wrapper.displayName = 'WrapperMediaSingle';
/* harmony default export */ __webpack_exports__["a"] = (Wrapper);
var templateObject_1, templateObject_2;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return layoutSupportsWidth; });
/* unused harmony export calcPxFromColumns */
/* unused harmony export calcColumnsFromPx */
/* harmony export (immutable) */ __webpack_exports__["a"] = calcPxFromPct;
/* unused harmony export calcPctFromPx */
/* unused harmony export snapToGrid */
var handleMargin = 12;
var gutterSize = handleMargin * 2;
var validWidthModes = [
    'center',
    'wrap-left',
    'wrap-right',
    'align-start',
    'align-end',
];
var layoutSupportsWidth = function (layout) {
    return validWidthModes.indexOf(layout) > -1;
};
function calcPxFromColumns(columns, lineLength, gridSize) {
    var maxWidth = lineLength + gutterSize;
    return (maxWidth / gridSize) * columns - gutterSize;
}
function calcColumnsFromPx(width, lineLength, gridSize) {
    var maxWidth = lineLength + gutterSize;
    return ((width + gutterSize) * gridSize) / maxWidth;
}
function calcPxFromPct(pct, lineLength) {
    var maxWidth = lineLength + gutterSize;
    return maxWidth * pct - gutterSize;
}
function calcPctFromPx(width, lineLength) {
    var maxWidth = lineLength + gutterSize;
    return (width + gutterSize) / maxWidth;
}
var snapToGrid = function (gridWidth, width, height, lineLength, gridSize) {
    var pxWidth = calcPxFromPct(gridWidth / 100, lineLength);
    var columnSpan = Math.round(calcColumnsFromPx(pxWidth, lineLength, gridSize));
    var alignedWidth = calcPxFromColumns(columnSpan, lineLength, gridSize);
    return {
        height: (height / width) * alignedWidth,
        width: alignedWidth,
    };
};
//# sourceMappingURL=grid.js.map

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_MentionResource__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_PresenceResource__ = __webpack_require__(3010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MentionItem__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MentionList__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ResourcedMentionList__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MentionPicker__ = __webpack_require__(3019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Mention__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Mention_ResourcedMention__ = __webpack_require__(3024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_ContextMentionResource__ = __webpack_require__(3025);
/* unused harmony reexport ContextMentionResource */
/* unused harmony reexport MentionResource */
/* unused harmony reexport PresenceResource */
/* unused harmony reexport AbstractMentionResource */
/* unused harmony reexport AbstractPresenceResource */
/* unused harmony reexport MentionItem */
/* unused harmony reexport MentionList */
/* unused harmony reexport ResourcedMentionList */
/* unused harmony reexport MentionPicker */
/* unused harmony reexport Mention */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__components_Mention_ResourcedMention__["a"]; });
/* unused harmony reexport isSpecialMention */
/* unused harmony reexport ELEMENTS_CHANNEL */












/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_5__components_MentionPicker__["a" /* MentionPickerWithAnalytics */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HttpError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AbstractResource; });
/* unused harmony export AbstractMentionResource */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_logger__ = __webpack_require__(232);




var MAX_QUERY_ITEMS = 100;
var MAX_NOTIFIED_ITEMS = 20;
var emptySecurityProvider = function () {
    return {
        params: {},
        headers: {},
    };
};
var AbstractResource = /** @class */ (function () {
    function AbstractResource() {
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
    }
    AbstractResource.prototype.subscribe = function (key, callback, errCallback, infoCallback, allResultsCallback) {
        if (callback) {
            this.changeListeners.set(key, callback);
        }
        if (errCallback) {
            this.errListeners.set(key, errCallback);
        }
        if (infoCallback) {
            this.infoListeners.set(key, infoCallback);
        }
        if (allResultsCallback) {
            this.allResultsListeners.set(key, allResultsCallback);
        }
    };
    AbstractResource.prototype.unsubscribe = function (key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
    };
    return AbstractResource;
}());
var AbstractMentionResource = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AbstractMentionResource, _super);
    function AbstractMentionResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AbstractMentionResource.prototype.shouldHighlightMention = function (mention) {
        return false;
    };
    // eslint-disable-next-line class-methods-use-this
    AbstractMentionResource.prototype.filter = function (query) {
        throw new Error("not yet implemented.\nParams: query=" + query);
    };
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    AbstractMentionResource.prototype.recordMentionSelection = function (mention) {
        // Do nothing
    };
    AbstractMentionResource.prototype.isFiltering = function (query) {
        return false;
    };
    AbstractMentionResource.prototype._notifyListeners = function (mentionsResult, stats) {
        Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])('ak-mention-resource._notifyListeners', mentionsResult &&
            mentionsResult.mentions &&
            mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach(function (listener, key) {
            try {
                listener(mentionsResult.mentions.slice(0, MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            }
            catch (e) {
                // ignore error from listener
                Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])("error from listener '" + key + "', ignoring", e);
            }
        });
    };
    AbstractMentionResource.prototype._notifyAllResultsListeners = function (mentionsResult) {
        Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])('ak-mention-resource._notifyAllResultsListeners', mentionsResult &&
            mentionsResult.mentions &&
            mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach(function (listener, key) {
            try {
                listener(mentionsResult.mentions.slice(0, MAX_NOTIFIED_ITEMS), mentionsResult.query);
            }
            catch (e) {
                // ignore error from listener
                Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])("error from listener '" + key + "', ignoring", e);
            }
        });
    };
    AbstractMentionResource.prototype._notifyErrorListeners = function (error, query) {
        this.errListeners.forEach(function (listener, key) {
            try {
                listener(error, query);
            }
            catch (e) {
                // ignore error from listener
                Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])("error from listener '" + key + "', ignoring", e);
            }
        });
    };
    AbstractMentionResource.prototype._notifyInfoListeners = function (info) {
        this.infoListeners.forEach(function (listener, key) {
            try {
                listener(info);
            }
            catch (e) {
                // ignore error fromr listener
                Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])("error from listener '" + key + "', ignoring", e);
            }
        });
    };
    return AbstractMentionResource;
}(AbstractResource));
/**
 * Provides a Javascript API
 */
var MentionResource = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionResource, _super);
    function MentionResource(config) {
        var _this = _super.call(this) || this;
        if (!config.url) {
            throw new Error('config.url is a required parameter');
        }
        if (!config.securityProvider) {
            config.securityProvider = emptySecurityProvider;
        }
        _this.config = config;
        _this.lastReturnedSearch = 0;
        _this.activeSearches = new Set();
        return _this;
    }
    MentionResource.prototype.shouldHighlightMention = function (mention) {
        if (this.config.shouldHighlightMention) {
            return this.config.shouldHighlightMention(mention);
        }
        return false;
    };
    MentionResource.prototype.notify = function (searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime,
            });
        }
        else {
            var date = new Date(searchTime).toISOString().substr(17, 6);
            Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    };
    MentionResource.prototype.notifyError = function (error, query) {
        this._notifyErrorListeners(error, query);
        if (query) {
            this.activeSearches.delete(query);
        }
    };
    MentionResource.prototype.filter = function (query, contextIdentifier) {
        var _this = this;
        var searchTime = Date.now();
        if (!query) {
            this.initialState(contextIdentifier).then(function (results) { return _this.notify(searchTime, results, query); }, function (error) { return _this.notifyError(error, query); });
        }
        else {
            this.activeSearches.add(query);
            var searchResponse = this.search(query, contextIdentifier);
            searchResponse.mentions.then(function (results) {
                _this.notify(searchTime, results, query);
            }, function (error) { return _this.notifyError(error, query); });
        }
    };
    MentionResource.prototype.recordMentionSelection = function (mention, contextIdentifier) {
        return this.recordSelection(mention, contextIdentifier).then(function () { }, function (error) { return Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])("error recording mention selection: " + error, error); });
    };
    MentionResource.prototype.isFiltering = function (query) {
        return this.activeSearches.has(query);
    };
    MentionResource.prototype.initialState = function (contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    };
    MentionResource.prototype.getQueryParams = function (contextIdentifier) {
        var configParams = {};
        if (this.config.containerId) {
            configParams['containerId'] = this.config.containerId;
        }
        if (this.config.productId) {
            configParams['productIdentifier'] = this.config.productId;
        }
        // if contextParams exist then it will override configParams for containerId
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, configParams, contextIdentifier);
    };
    /**
     * Returns the initial mention display list before a search is performed for the specified
     * container.
     *
     * @param contextIdentifier
     * @returns Promise
     */
    MentionResource.prototype.remoteInitialState = function (contextIdentifier) {
        var _this = this;
        var queryParams = this.getQueryParams(contextIdentifier);
        var options = {
            path: 'bootstrap',
            queryParams: queryParams,
        };
        return __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */]
            .requestService(this.config, options)
            .then(function (result) { return _this.transformServiceResponse(result, ''); });
    };
    MentionResource.prototype.search = function (query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier),
        };
    };
    MentionResource.prototype.remoteSearch = function (query, contextIdentifier) {
        var _this = this;
        var options = {
            path: 'search',
            queryParams: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ query: query, limit: MAX_QUERY_ITEMS }, this.getQueryParams(contextIdentifier)),
        };
        return __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */]
            .requestService(this.config, options)
            .then(function (result) { return _this.transformServiceResponse(result, query); });
    };
    MentionResource.prototype.transformServiceResponse = function (result, query) {
        var mentions = result.mentions.map(function (mention, index) {
            var lozenge;
            if (Object(__WEBPACK_IMPORTED_MODULE_2__types__["b" /* isAppMention */])(mention)) {
                lozenge = mention.userType;
            }
            else if (Object(__WEBPACK_IMPORTED_MODULE_2__types__["e" /* isTeamMention */])(mention)) {
                lozenge = mention.userType;
            }
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, mention, { lozenge: lozenge, query: query });
        });
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, result, { mentions: mentions, query: result.query || query });
    };
    MentionResource.prototype.recordSelection = function (mention, contextIdentifier) {
        var options = {
            path: 'record',
            queryParams: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ selectedUserId: mention.id }, this.getQueryParams(contextIdentifier)),
            requestInit: {
                method: 'POST',
            },
        };
        return __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */].requestService(this.config, options);
    };
    return MentionResource;
}(AbstractMentionResource));
var HttpError = /** @class */ (function () {
    function HttpError(statusCode, statusMessage) {
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
    return HttpError;
}());


/* unused harmony default export */ var _unused_webpack_default_export = (MentionResource);
//# sourceMappingURL=MentionResource.js.map

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_avatar__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_lozenge__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_lock_circle__ = __webpack_require__(3011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_lock_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_lock_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_mouse__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(3012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_i18n__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NoAccessTooltip__ = __webpack_require__(929);











function renderHighlight(ReactComponent, value, highlights, prefix) {
    if (!value) {
        return null;
    }
    var parts = [];
    var prefixText = prefix || '';
    var lastIndex = 0;
    if (highlights) {
        for (var i = 0; i < highlights.length; i++) {
            var h = highlights[i];
            var start = h.start;
            var end = h.end;
            if (start > lastIndex) {
                parts.push({
                    value: value.substring(lastIndex, start),
                    matches: false,
                });
            }
            parts.push({
                value: value.substring(start, end + 1),
                matches: true,
            });
            lastIndex = end + 1;
        }
        if (lastIndex < value.length) {
            parts.push({
                value: value.substring(lastIndex, value.length),
                matches: false,
            });
        }
    }
    else {
        parts.push({
            value: value,
            matches: false,
        });
    }
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ReactComponent, null,
        prefixText,
        parts.map(function (part, index) {
            if (part.matches) {
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("b", { key: index }, part.value);
            }
            return part.value;
        })));
}
function renderLozenge(lozenge) {
    if (lozenge) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_lozenge__["default"], null, lozenge);
    }
    return null;
}
function renderTime(time) {
    if (time) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["i" /* TimeStyle */], null, time);
    }
    return null;
}
var MentionItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionItem, _super);
    function MentionItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // internal, used for callbacks
        _this.onMentionSelected = function (event) {
            if (Object(__WEBPACK_IMPORTED_MODULE_7__util_mouse__["b" /* leftClick */])(event) && _this.props.onSelection) {
                event.preventDefault();
                _this.props.onSelection(_this.props.mention, event);
            }
        };
        _this.onMentionMenuItemMouseMove = function (event) {
            if (_this.props.onMouseMove) {
                _this.props.onMouseMove(_this.props.mention, event);
            }
        };
        return _this;
    }
    MentionItem.prototype.render = function () {
        var _a = this.props, mention = _a.mention, selected = _a.selected;
        var id = mention.id, highlight = mention.highlight, avatarUrl = mention.avatarUrl, presence = mention.presence, name = mention.name, mentionName = mention.mentionName, nickname = mention.nickname, lozenge = mention.lozenge, accessLevel = mention.accessLevel;
        var _b = presence || {}, status = _b.status, time = _b.time;
        var restricted = Object(__WEBPACK_IMPORTED_MODULE_6__types__["c" /* isRestricted */])(accessLevel);
        var nameHighlights = highlight && highlight.name;
        var nicknameHighlights = highlight && highlight.nickname;
        var borderColor = selected ? __WEBPACK_IMPORTED_MODULE_5__atlaskit_theme__["colors"].N30 : undefined;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["e" /* MentionItemStyle */], { selected: selected, onMouseDown: this.onMentionSelected, onMouseMove: this.onMentionMenuItemMouseMove, "data-mention-id": id, "data-mention-name": mentionName },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["h" /* RowStyle */], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["b" /* AvatarStyle */], { restricted: restricted },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_avatar__["d" /* default */], { src: avatarUrl, size: "medium", presence: status, borderColor: borderColor })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["f" /* NameSectionStyle */], { restricted: restricted },
                    renderHighlight(__WEBPACK_IMPORTED_MODULE_8__styles__["c" /* FullNameStyle */], name, nameHighlights),
                    renderHighlight(__WEBPACK_IMPORTED_MODULE_8__styles__["g" /* NicknameStyle */], nickname, nicknameHighlights, '@')),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["d" /* InfoSectionStyle */], { restricted: restricted },
                    renderLozenge(lozenge),
                    renderTime(time)),
                restricted ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__NoAccessTooltip__["a" /* NoAccessTooltip */], { name: name },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* AccessSectionStyle */], null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__util_i18n__["e" /* NoAccessLabel */], null, function (text) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_lock_circle___default.a, { label: text })); } /* safe to cast to string given there is no value binding */)))) : null)));
    };
    return MentionItem;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (MentionItem);
//# sourceMappingURL=index.js.map

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = mouseLocation;
/* harmony export (immutable) */ __webpack_exports__["a"] = actualMouseMove;
/* harmony export (immutable) */ __webpack_exports__["b"] = leftClick;
function mouseLocation(event) {
    return {
        x: event.clientX,
        y: event.clientY,
    };
}
// Used to prevent invalid mouse move detection on scroll
// lastPosition is object (x, y)
function actualMouseMove(oldPosition, newPosition) {
    if (!oldPosition ||
        oldPosition.x !== newPosition.x ||
        oldPosition.y !== newPosition.y) {
        return true;
    }
    return false;
}
function leftClick(event) {
    return (event.button === 0 &&
        !event.altKey &&
        !event.ctrlKey &&
        !event.metaKey &&
        !event.shiftKey);
}
//# sourceMappingURL=mouse.js.map

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoAccessTooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_tooltip__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_i18n__ = __webpack_require__(482);



var NoAccessTooltip = function (_a) {
    var name = _a.name, children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__util_i18n__["f" /* NoAccessWarning */], { name: name }, function (text) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__atlaskit_tooltip__["a" /* default */], { content: text, position: "right" }, children)); }));
};
//# sourceMappingURL=NoAccessTooltip.js.map

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(3014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MentionListError__ = __webpack_require__(3015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MentionItem__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Scrollable__ = __webpack_require__(3017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_logger__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_mouse__ = __webpack_require__(928);








function wrapIndex(mentions, index) {
    var len = mentions.length;
    var newIndex = index;
    while (newIndex < 0 && len > 0) {
        newIndex += len;
    }
    return newIndex % len;
}
function getKey(index, mentions) {
    return mentions && mentions[index] && mentions[index].id;
}
function getIndex(key, mentions) {
    var index;
    if (mentions) {
        index = 0;
        while (index < mentions.length && mentions[index].id !== key) {
            index++;
        }
        if (index === mentions.length) {
            index = undefined;
        }
    }
    return index;
}
var MentionList = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionList, _super);
    function MentionList(props) {
        var _this = _super.call(this, props) || this;
        // API
        _this.selectNext = function () {
            var newIndex = wrapIndex(_this.props.mentions, _this.state.selectedIndex + 1);
            _this.selectIndex(newIndex);
        };
        _this.selectPrevious = function () {
            var newIndex = wrapIndex(_this.props.mentions, _this.state.selectedIndex - 1);
            _this.selectIndex(newIndex);
        };
        _this.selectIndex = function (index, callback) {
            var mentions = _this.props.mentions;
            _this.setState({
                selectedIndex: index,
                selectedKey: getKey(index, mentions),
            }, callback);
        };
        _this.selectId = function (id, callback) {
            var mentions = _this.props.mentions;
            var index = getIndex(id, mentions);
            if (index !== undefined) {
                _this.setState({
                    selectedIndex: index,
                    selectedKey: id,
                }, callback);
            }
        };
        _this.chooseCurrentSelection = function () {
            var _a = _this.props, mentions = _a.mentions, onSelection = _a.onSelection;
            var selectedIndex = _this.state.selectedIndex;
            var selectedMention = mentions && mentions[selectedIndex || 0];
            Object(__WEBPACK_IMPORTED_MODULE_6__util_logger__["a" /* default */])('ak-mention-list.chooseCurrentSelection', selectedMention);
            if (onSelection && selectedMention) {
                onSelection(selectedMention);
            }
        };
        _this.mentionsCount = function () {
            var mentions = _this.props.mentions;
            return (mentions && mentions.length) || 0;
        };
        _this.selectIndexOnHover = function (mention, event) {
            if (!event) {
                return;
            }
            var mousePosition = Object(__WEBPACK_IMPORTED_MODULE_7__util_mouse__["c" /* mouseLocation */])(event);
            if (Object(__WEBPACK_IMPORTED_MODULE_7__util_mouse__["a" /* actualMouseMove */])(_this.lastMousePosition, mousePosition)) {
                _this.selectId(mention.id);
            }
            _this.lastMousePosition = mousePosition;
        };
        _this.itemSelected = function (mention) {
            _this.selectId(mention.id, function () {
                _this.chooseCurrentSelection();
            });
        };
        _this.handleScrollableRef = function (ref) {
            _this.scrollable = ref;
        };
        _this.setDefaultSelectionState();
        return _this;
    }
    MentionList.prototype.componentWillReceiveProps = function (nextProps) {
        // adjust selection
        var mentions = nextProps.mentions;
        var selectedKey = this.state.selectedKey;
        if (mentions) {
            if (!selectedKey) {
                // don't explicitly set any selected index and go with default behaviour
                return;
            }
            for (var i = 0; i < mentions.length; i++) {
                if (selectedKey === mentions[i].id) {
                    this.setState({
                        selectedIndex: i,
                    });
                    return;
                }
            }
            // existing selection not in results so clear any current selection state and go with default behaviour
            this.setDefaultSelectionState();
        }
    };
    MentionList.prototype.componentDidUpdate = function () {
        var mentions = this.props.mentions;
        var selectedIndex = this.state.selectedIndex;
        if (mentions && mentions[selectedIndex]) {
            this.revealItem(mentions[selectedIndex].id);
        }
        // FIXME - a React version of this _may_ be required for Confluence
        // integration tests. Will remove / fix once known
        // emit(elem, mentionListRenderedEvent);
    };
    // Internal
    MentionList.prototype.revealItem = function (key) {
        var item = this.items[key];
        if (item && this.scrollable) {
            this.scrollable.reveal(item);
        }
    };
    /**
     * The default selection state is to chose index 0 and not have any particular key selected
     */
    MentionList.prototype.setDefaultSelectionState = function () {
        this.state = {
            selectedIndex: 0,
            selectedKey: undefined,
        };
    };
    MentionList.prototype.renderItems = function () {
        var _this = this;
        var mentions = this.props.mentions;
        if (mentions && mentions.length) {
            this.items = {};
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, mentions.map(function (mention, idx) {
                var key = mention.id;
                var item = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__MentionItem__["a" /* default */], { mention: mention, selected: _this.isSelectedMention(mention, idx), key: key, onMouseMove: _this.selectIndexOnHover, 
                    /* Cannot use onclick, as onblur will close the element, and prevent
                     * onClick from firing.
                     */
                    onSelection: _this.itemSelected, 
                    // tslint:disable-next-line:jsx-no-lambda
                    ref: function (ref) {
                        if (ref) {
                            _this.items[key] = ref;
                        }
                        else {
                            delete _this.items[key];
                        }
                    } }));
                return item;
            })));
        }
        return null;
    };
    MentionList.prototype.isSelectedMention = function (mention, index) {
        var selectedKey = this.state.selectedKey;
        return selectedKey ? selectedKey === mention.id : index === 0;
    };
    MentionList.prototype.render = function () {
        var _a = this.props, mentions = _a.mentions, resourceError = _a.resourceError;
        var hasMentions = mentions && mentions.length;
        // If we get an error, but existing mentions are displayed, lets
        // just continue to show the existing mentions we have
        var mustShowError = resourceError && !hasMentions;
        var errorSection;
        var resultSection;
        if (mustShowError) {
            errorSection = __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__MentionListError__["a" /* default */], { error: resourceError });
        }
        else if (hasMentions) {
            resultSection = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Scrollable__["a" /* default */], { ref: this.handleScrollableRef }, this.renderItems()));
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* MentionListStyle */], { empty: !hasMentions && !resourceError },
            errorSection,
            resultSection));
    };
    return MentionList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (MentionList);
//# sourceMappingURL=index.js.map

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MentionListErrorStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GenericErrorVisualStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MentionListErrorHeadlineStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MentionListAdviceStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



// tslint:disable:next-line variable-name
var MentionListErrorStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  background-color: white;\n  color: ", ";\n  border: 1px solid #fff;\n  border-radius: ", "px;\n"], ["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  background-color: white;\n  color: ", ";\n  border: 1px solid #fff;\n  border-radius: ", "px;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N500, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])());
var GenericErrorVisualStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  height: 108px;\n  margin-bottom: 8px;\n  margin-top: 36px;\n  width: 83px;\n"], ["\n  height: 108px;\n  margin-bottom: 8px;\n  margin-top: 36px;\n  width: 83px;\n"])));
// TODO: Figure out why the themed css function is causing type errors when passed prop children
var MentionListErrorHeadlineStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", ";\n  margin-bottom: 8px;\n"], ["\n  ", ";\n  margin-bottom: 8px;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["typography"].h400());
var MentionListAdviceStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin-bottom: 48px;\n"], ["\n  margin-bottom: 48px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MentionList__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_logger__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_id__ = __webpack_require__(933);





function applyPresence(mentions, presences) {
    var updatedMentions = [];
    for (var i = 0; i < mentions.length; i++) {
        // Shallow copy
        var mention = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, mentions[i]);
        var presence = presences[mention.id];
        if (presence) {
            mention.presence = presence;
        }
        updatedMentions.push(mention);
    }
    return updatedMentions;
}
function extractPresences(mentions) {
    var presences = {};
    for (var i = 0; i < mentions.length; i++) {
        var mention = mentions[i];
        if (mention.presence) {
            presences[mention.id] = mention.presence;
        }
    }
    return presences;
}
var ResourcedMentionList = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ResourcedMentionList, _super);
    function ResourcedMentionList(props) {
        var _this = _super.call(this, props) || this;
        // API
        _this.selectNext = function () {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectNext();
            }
        };
        _this.selectPrevious = function () {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectPrevious();
            }
        };
        _this.selectIndex = function (index, callback) {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectIndex(index, callback);
            }
        };
        _this.selectId = function (id, callback) {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectId(id, callback);
            }
        };
        _this.chooseCurrentSelection = function () {
            if (_this.mentionListRef) {
                _this.mentionListRef.chooseCurrentSelection();
            }
        };
        _this.mentionsCount = function () {
            if (_this.mentionListRef) {
                return _this.mentionListRef.mentionsCount();
            }
            return 0;
        };
        // internal, used for callbacks
        _this.filterChange = function (mentions) {
            // Retain known presence
            var currentPresences = extractPresences(_this.state.mentions);
            _this.setState({
                resourceError: undefined,
                mentions: applyPresence(mentions, currentPresences),
            });
            _this.refreshPresences(mentions);
        };
        _this.filterError = function (error) {
            Object(__WEBPACK_IMPORTED_MODULE_3__util_logger__["a" /* default */])('ak-resourced-mentions-list._filterError', error);
            _this.setState({
                resourceError: error,
            });
        };
        _this.presenceUpdate = function (presences) {
            _this.setState({
                mentions: applyPresence(_this.state.mentions, presences),
            });
        };
        _this.notifySelection = function (mention) {
            _this.props.resourceProvider.recordMentionSelection(mention);
            if (_this.props.onSelection) {
                _this.props.onSelection(mention);
            }
        };
        _this.handleMentionListRef = function (ref) {
            _this.mentionListRef = ref;
        };
        _this.subscriberKey = Object(__WEBPACK_IMPORTED_MODULE_4__util_id__["a" /* default */])('ak-resourced-mention-list');
        _this.state = {
            resourceError: undefined,
            mentions: [],
        };
        _this.applyPropChanges({}, props);
        return _this;
    }
    ResourcedMentionList.prototype.componentDidMount = function () {
        this.subscribeMentionProvider(this.props.resourceProvider);
        this.subscribePresenceProvider(this.props.presenceProvider);
    };
    ResourcedMentionList.prototype.componentWillReceiveProps = function (nextProps) {
        this.applyPropChanges(this.props, nextProps);
    };
    ResourcedMentionList.prototype.componentWillUnmount = function () {
        this.unsubscribeMentionProvider(this.props.resourceProvider);
        this.unsubscribePresenceProvider(this.props.presenceProvider);
    };
    // internal
    ResourcedMentionList.prototype.subscribeMentionProvider = function (mentionProvider) {
        if (mentionProvider) {
            mentionProvider.subscribe(this.subscriberKey, this.filterChange, this.filterError);
        }
    };
    ResourcedMentionList.prototype.subscribePresenceProvider = function (presenceProvider) {
        if (presenceProvider) {
            presenceProvider.subscribe(this.subscriberKey, this.presenceUpdate);
        }
    };
    ResourcedMentionList.prototype.unsubscribeMentionProvider = function (mentionProvider) {
        if (mentionProvider) {
            mentionProvider.unsubscribe(this.subscriberKey);
        }
    };
    ResourcedMentionList.prototype.unsubscribePresenceProvider = function (presenceProvider) {
        if (presenceProvider) {
            presenceProvider.unsubscribe(this.subscriberKey);
        }
    };
    ResourcedMentionList.prototype.applyPropChanges = function (prevProps, nextProps) {
        var oldResourceProvider = prevProps.resourceProvider;
        var oldPresenceProvider = prevProps.presenceProvider;
        var oldQuery = prevProps.query;
        var newResourceProvider = nextProps.resourceProvider;
        var newPresenceProvider = nextProps.presenceProvider;
        var newQuery = nextProps.query;
        var resourceProviderChanged = oldResourceProvider !== newResourceProvider;
        var queryChanged = oldQuery !== newQuery;
        var canFilter = !!(typeof newQuery === 'string' && newResourceProvider);
        var shouldFilter = canFilter && (queryChanged || resourceProviderChanged);
        // resource provider
        if (resourceProviderChanged) {
            this.unsubscribeMentionProvider(oldResourceProvider);
            this.subscribeMentionProvider(newResourceProvider);
        }
        // presence provider
        if (oldPresenceProvider !== newPresenceProvider) {
            this.unsubscribePresenceProvider(oldPresenceProvider);
            this.subscribePresenceProvider(newPresenceProvider);
        }
        if (shouldFilter) {
            newResourceProvider.filter(newQuery);
        }
    };
    ResourcedMentionList.prototype.refreshPresences = function (mentions) {
        if (this.props.presenceProvider) {
            var ids = mentions.map(function (mention) { return mention.id; });
            this.props.presenceProvider.refreshPresence(ids);
        }
    };
    ResourcedMentionList.prototype.render = function () {
        var _a = this.state, mentions = _a.mentions, resourceError = _a.resourceError;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__MentionList__["a" /* default */], { mentions: mentions, resourceError: resourceError, onSelection: this.notifySelection, ref: this.handleMentionListRef }));
    };
    return ResourcedMentionList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (ResourcedMentionList);
//# sourceMappingURL=index.js.map

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid__);

/* harmony default export */ __webpack_exports__["a"] = (function (prefix) {
    if (prefix === void 0) { prefix = ''; }
    return prefix + "_" + __WEBPACK_IMPORTED_MODULE_0_uuid__();
});
//# sourceMappingURL=id.js.map

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fireAnalyticsMentionTypeaheadEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fireAnalyticsMentionEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fireAnalytics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__package_json__ = __webpack_require__(3022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(170);



var fireAnalyticsMentionTypeaheadEvent = function (props) { return function (action, duration, userIds, query) {
    if (userIds === void 0) { userIds = []; }
    if (props.createAnalyticsEvent) {
        var eventPayload = {
            action: action,
            actionSubject: 'mentionTypeahead',
            attributes: {
                packageName: __WEBPACK_IMPORTED_MODULE_1__package_json__["name"],
                packageVersion: __WEBPACK_IMPORTED_MODULE_1__package_json__["version"],
                componentName: 'mention',
                duration: Math.round(duration),
                userIds: userIds,
                queryLength: query ? query.length : 0,
            },
            eventType: 'operational',
        };
        var analyticsEvent = props.createAnalyticsEvent(eventPayload);
        analyticsEvent.fire(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ELEMENTS_CHANNEL */]);
    }
}; };
var fireAnalyticsMentionEvent = function (createEvent) { return function (actionSubject, action, text, id, accessLevel) {
    var payload = {
        action: action,
        actionSubject: actionSubject,
        eventType: 'ui',
        attributes: {
            packageName: __WEBPACK_IMPORTED_MODULE_1__package_json__["name"],
            packageVersion: __WEBPACK_IMPORTED_MODULE_1__package_json__["version"],
            componentName: 'mention',
            accessLevel: accessLevel,
            isSpecial: Object(__WEBPACK_IMPORTED_MODULE_2__types__["d" /* isSpecialMentionText */])(text),
            userId: id,
        },
    };
    var event = createEvent(payload);
    event.fire(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ELEMENTS_CHANNEL */]);
    return event;
}; };
// OLD Analytics
var MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
var fireAnalytics = function (firePrivateAnalyticsEvent) { return function (eventName, text, accessLevel) {
    if (firePrivateAnalyticsEvent) {
        firePrivateAnalyticsEvent(MENTION_ANALYTICS_PREFIX + "." + eventName, {
            accessLevel: accessLevel,
            isSpecial: Object(__WEBPACK_IMPORTED_MODULE_2__types__["d" /* isSpecialMentionText */])(text),
        });
    }
}; };
//# sourceMappingURL=analytics.js.map

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ELEMENTS_CHANNEL; });
var ELEMENTS_CHANNEL = 'fabric-elements';
//# sourceMappingURL=constants.js.map

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ANALYTICS_HOVER_DELAY */
/* unused harmony export MentionInternal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(3023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NoAccessTooltip__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_analytics__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__ = __webpack_require__(29);








var ANALYTICS_HOVER_DELAY = 1000;
var MentionInternal = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionInternal, _super);
    function MentionInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnClick = function (e) {
            var _a = _this.props, id = _a.id, text = _a.text, onClick = _a.onClick;
            if (onClick) {
                onClick(id, text, e);
            }
        };
        _this.handleOnMouseEnter = function (e) {
            var _a = _this.props, id = _a.id, text = _a.text, onMouseEnter = _a.onMouseEnter, onHover = _a.onHover;
            if (onMouseEnter) {
                onMouseEnter(id, text, e);
            }
            _this.hoverTimeout = window.setTimeout(function () {
                if (onHover) {
                    onHover();
                }
                _this.hoverTimeout = undefined;
            }, ANALYTICS_HOVER_DELAY);
        };
        _this.handleOnMouseLeave = function (e) {
            var _a = _this.props, id = _a.id, text = _a.text, onMouseLeave = _a.onMouseLeave;
            if (onMouseLeave) {
                onMouseLeave(id, text, e);
            }
            if (_this.hoverTimeout) {
                clearTimeout(_this.hoverTimeout);
            }
        };
        _this.getMentionType = function () {
            var _a = _this.props, accessLevel = _a.accessLevel, isHighlighted = _a.isHighlighted;
            if (isHighlighted) {
                return __WEBPACK_IMPORTED_MODULE_4__types__["a" /* MentionType */].SELF;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_4__types__["c" /* isRestricted */])(accessLevel)) {
                return __WEBPACK_IMPORTED_MODULE_4__types__["a" /* MentionType */].RESTRICTED;
            }
            return __WEBPACK_IMPORTED_MODULE_4__types__["a" /* MentionType */].DEFAULT;
        };
        return _this;
    }
    MentionInternal.prototype.componentWillUnmount = function () {
        if (this.hoverTimeout) {
            clearTimeout(this.hoverTimeout);
        }
    };
    MentionInternal.prototype.render = function () {
        var _a = this, handleOnClick = _a.handleOnClick, handleOnMouseEnter = _a.handleOnMouseEnter, handleOnMouseLeave = _a.handleOnMouseLeave, props = _a.props;
        var text = props.text, id = props.id, accessLevel = props.accessLevel;
        var mentionType = this.getMentionType();
        var mentionComponent = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* MentionStyle */], { mentionType: mentionType, onClick: handleOnClick, onMouseEnter: handleOnMouseEnter, onMouseLeave: handleOnMouseLeave }, text));
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { "data-mention-id": id, "data-access-level": accessLevel, spellCheck: false }, mentionType === __WEBPACK_IMPORTED_MODULE_4__types__["a" /* MentionType */].RESTRICTED ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__NoAccessTooltip__["a" /* NoAccessTooltip */], { name: text }, mentionComponent)) : (mentionComponent)));
    };
    return MentionInternal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

// tslint:disable-next-line:variable-name
var MentionWithAnalytics = Object(__WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__["withAnalyticsEvents"])({
    onClick: function (createEvent, props) {
        var id = props.id, text = props.text, accessLevel = props.accessLevel, firePrivateAnalyticsEvent = props.firePrivateAnalyticsEvent;
        var event = Object(__WEBPACK_IMPORTED_MODULE_5__util_analytics__["b" /* fireAnalyticsMentionEvent */])(createEvent)('mention', 'selected', text, id, accessLevel);
        // old analytics
        Object(__WEBPACK_IMPORTED_MODULE_5__util_analytics__["a" /* fireAnalytics */])(firePrivateAnalyticsEvent)('lozenge.select', text, accessLevel);
        return event;
    },
    onHover: function (createEvent, props) {
        var id = props.id, text = props.text, accessLevel = props.accessLevel, firePrivateAnalyticsEvent = props.firePrivateAnalyticsEvent;
        var event = Object(__WEBPACK_IMPORTED_MODULE_5__util_analytics__["b" /* fireAnalyticsMentionEvent */])(createEvent)('mention', 'hovered', text, id, accessLevel);
        // old analytics
        Object(__WEBPACK_IMPORTED_MODULE_5__util_analytics__["a" /* fireAnalytics */])(firePrivateAnalyticsEvent)('lozenge.hover', text, accessLevel);
        return event;
    },
})(MentionInternal);
var Mention = Object(__WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics__["a" /* withAnalytics */])(MentionWithAnalytics, {}, {});
/* harmony default export */ __webpack_exports__["a"] = (Mention);
//# sourceMappingURL=index.js.map

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raf_schd__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(3028);






var Popup = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Popup, _super);
    function Popup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            overflowScrollParent: false,
        };
        _this.placement = ['', ''];
        _this.handleRef = function (popup) {
            if (!popup) {
                return;
            }
            _this.initPopup(popup);
        };
        _this.scheduledUpdatePosition = Object(__WEBPACK_IMPORTED_MODULE_3_raf_schd__["a" /* default */])(function (props) {
            return _this.updatePosition(props);
        });
        _this.onResize = function () { return _this.scheduledUpdatePosition(); };
        return _this;
    }
    /**
     * Calculates new popup position
     */
    Popup.prototype.updatePosition = function (props, state) {
        if (props === void 0) { props = this.props; }
        if (state === void 0) { state = this.state; }
        var target = props.target, fitHeight = props.fitHeight, fitWidth = props.fitWidth, boundariesElement = props.boundariesElement, offset = props.offset, onPositionCalculated = props.onPositionCalculated, onPlacementChanged = props.onPlacementChanged, alignX = props.alignX, alignY = props.alignY, stick = props.stick;
        var popup = state.popup;
        if (!target || !popup) {
            return;
        }
        var placement = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* calculatePlacement */])(target, boundariesElement || document.body, fitWidth, fitHeight, alignX, alignY);
        if (onPlacementChanged && this.placement.join('') !== placement.join('')) {
            onPlacementChanged(placement);
            this.placement = placement;
        }
        var position = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* calculatePosition */])({
            placement: placement,
            popup: popup,
            target: target,
            stick: stick,
            offset: offset,
        });
        position = onPositionCalculated ? onPositionCalculated(position) : position;
        this.setState({ position: position });
    };
    Popup.prototype.cannotSetPopup = function (popup, target, overflowScrollParent) {
        /**
         * Check whether:
         * 1. Popup's offset targets which means whether or not its possible to correctly position popup along with given target.
         * 2. Popup is inside "overflow: scroll" container, but its offset parent isn't.
         *
         * Currently Popup isn't capable of position itself correctly in case 2,
         * Add "position: relative" to "overflow: scroll" container or to some other FloatingPanel wrapper inside it.
         */
        return ((document.body.contains(target) &&
            (popup.offsetParent && !popup.offsetParent.contains(target))) ||
            (overflowScrollParent &&
                !overflowScrollParent.contains(popup.offsetParent)));
    };
    /**
     * Popup initialization.
     * Checks whether it's possible to position popup along given target, and if it's not throws an error.
     */
    Popup.prototype.initPopup = function (popup) {
        var target = this.props.target;
        var overflowScrollParent = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["c" /* findOverflowScrollParent */])(popup);
        if (this.cannotSetPopup(popup, target, overflowScrollParent)) {
            return;
        }
        this.setState({ popup: popup, overflowScrollParent: overflowScrollParent }, this.scheduledUpdatePosition);
    };
    Popup.prototype.componentWillReceiveProps = function (newProps) {
        // We are delaying `updatePosition` otherwise it happens before the children
        // get rendered and we end up with a wrong position
        this.scheduledUpdatePosition(newProps);
    };
    Popup.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.onResize);
        var stick = this.props.stick;
        if (stick) {
            this.scrollElement = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["c" /* findOverflowScrollParent */])(this.props.target);
        }
        else {
            this.scrollElement = this.props.scrollableElement;
        }
        if (this.scrollElement) {
            this.scrollElement.addEventListener('scroll', this.onResize);
        }
    };
    Popup.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onResize);
        if (this.scrollElement) {
            this.scrollElement.removeEventListener('scroll', this.onResize);
        }
        this.scheduledUpdatePosition.cancel();
    };
    Popup.prototype.renderPopup = function () {
        var position = this.state.position;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this.handleRef, style: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ position: 'absolute', zIndex: this.props.zIndex || __WEBPACK_IMPORTED_MODULE_4__styles__["d" /* akEditorFloatingPanelZIndex */] }, position), "aria-label": this.props.ariaLabel || 'Popup', "data-editor-popup": true }, this.props.children));
    };
    Popup.prototype.render = function () {
        if (!this.props.target) {
            return null;
        }
        if (this.props.mountTo) {
            return Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["createPortal"])(this.renderPopup(), this.props.mountTo);
        }
        // Without mountTo property renders popup as is,
        // which means it will be cropped by "overflow: hidden" container.
        return this.renderPopup();
    };
    Popup.defaultProps = {
        offset: [0, 0],
    };
    return Popup;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Popup);
//# sourceMappingURL=index.js.map

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withOuterListeners;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);




// tslint:disable:next-line variable-name
function withOuterListeners(Component) {
    return /** @class */ (function (_super) {
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WithOutsideClick, _super);
        function WithOutsideClick() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.handleClick = function (evt) {
                var domNode = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](_this); // eslint-disable-line react/no-find-dom-node
                if (!domNode ||
                    (evt.target instanceof Node && !domNode.contains(evt.target))) {
                    _this.props.handleClickOutside();
                }
            };
            _this.handleKeydown = function (evt) {
                if (evt.code === 'Escape') {
                    _this.props.handleEscapeKeydown();
                }
            };
            return _this;
        }
        WithOutsideClick.prototype.componentDidMount = function () {
            if (this.props.handleClickOutside) {
                document.addEventListener('click', this.handleClick, false);
            }
            if (this.props.handleEscapeKeydown) {
                document.addEventListener('keydown', this.handleKeydown, false);
            }
        };
        WithOutsideClick.prototype.componentWillUnmount = function () {
            if (this.props.handleClickOutside) {
                document.removeEventListener('click', this.handleClick, false);
            }
            if (this.props.handleEscapeKeydown) {
                document.removeEventListener('keydown', this.handleKeydown, false);
            }
        };
        WithOutsideClick.prototype.render = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Component, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, this.props));
        };
        return WithOutsideClick;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
}
//# sourceMappingURL=with-outer-listeners.js.map

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Breakpoints; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getBreakpoint;
/* unused harmony export createWidthContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WidthProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Consumer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf_schd__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_size_detector__ = __webpack_require__(268);




var Breakpoints = {
    S: 'S',
    M: 'M',
    L: 'L',
};
var MAX_S = 1266;
var MAX_M = 2146;
function getBreakpoint(width) {
    if (width === void 0) { width = 0; }
    if (width >= MAX_S && width < MAX_M) {
        return Breakpoints.M;
    }
    else if (width >= MAX_M) {
        return Breakpoints.L;
    }
    return Breakpoints.S;
}
function createWidthContext(width) {
    if (width === void 0) { width = 0; }
    return { width: width, breakpoint: getBreakpoint(width) };
}
var _a = __WEBPACK_IMPORTED_MODULE_1_react__["createContext"](createWidthContext()), Provider = _a.Provider, Consumer = _a.Consumer;
var WidthProvider = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WidthProvider, _super);
    function WidthProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { width: 0 };
        _this.setWidth = Object(__WEBPACK_IMPORTED_MODULE_2_raf_schd__["a" /* default */])(function (width) {
            if (_this.state.width === width) {
                return;
            }
            _this.setState({ width: width });
        });
        _this.state.width = document.body.offsetWidth;
        return _this;
    }
    WidthProvider.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_size_detector__["a" /* default */], { containerStyle: {
                    height: '0',
                    borderStyle: 'none',
                } }, function (_a) {
                var width = _a.width;
                _this.setWidth(width);
                return null;
            }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Provider, { value: createWidthContext(this.state.width) }, this.props.children)));
    };
    return WidthProvider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));


//# sourceMappingURL=index.js.map

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Code__ = __webpack_require__(941);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Code__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CodeBlock__ = __webpack_require__(3079);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__CodeBlock__["a"]; });



/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Code; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_syntax_highlighter__ = __webpack_require__(3034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__supportedLanguages__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__themes_themeBuilder__ = __webpack_require__(1272);











var Code =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Code, _PureComponent);

  function Code() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Code);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Code).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Code, [{
    key: "render",
    value: function render() {
      var _applyTheme = Object(__WEBPACK_IMPORTED_MODULE_10__themes_themeBuilder__["a" /* applyTheme */])(this.props.theme),
          inlineCodeStyle = _applyTheme.inlineCodeStyle;

      var language = Object(__WEBPACK_IMPORTED_MODULE_9__supportedLanguages__["a" /* normalizeLanguage */])(this.props.language);
      var props = {
        language: language,
        PreTag: this.props.preTag,
        style: this.props.codeStyle || inlineCodeStyle,
        showLineNumbers: this.props.showLineNumbers,
        lineNumberContainerStyle: this.props.lineNumberContainerStyle,
        codeTagProps: this.props.codeTagProps
      };
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_syntax_highlighter__["a" /* PrismAsyncLight */], props, this.props.text);
    }
  }]);

  return Code;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(Code, "defaultProps", {
  theme: {},
  showLineNumbers: false,
  lineNumberContainerStyle: {},
  codeTagProps: {},
  preTag: 'span'
});

var CodeWithTheme = Object(__WEBPACK_IMPORTED_MODULE_8_styled_components__["withTheme"])(Code);
var emptyTheme = {};
/* harmony default export */ __webpack_exports__["b"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_styled_components__["ThemeProvider"], {
    theme: emptyTheme
  }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(CodeWithTheme, props));
});

/***/ }),
/* 942 */
/***/ (function(module, exports) {

module.exports = function(hljs){

  // общий паттерн для определения идентификаторов
  var UNDERSCORE_IDENT_RE = '[A-Za-zА-Яа-яёЁ_][A-Za-zА-Яа-яёЁ_0-9]+';
  
  // v7 уникальные ключевые слова, отсутствующие в v8 ==> keyword
  var v7_keywords =
  'далее ';

  // v8 ключевые слова ==> keyword
  var v8_keywords =
  'возврат вызватьисключение выполнить для если и из или иначе иначеесли исключение каждого конецесли ' +
  'конецпопытки конеццикла не новый перейти перем по пока попытка прервать продолжить тогда цикл экспорт ';

  // keyword : ключевые слова
  var KEYWORD = v7_keywords + v8_keywords;
  
  // v7 уникальные директивы, отсутствующие в v8 ==> meta-keyword
  var v7_meta_keywords =
  'загрузитьизфайла ';

  // v8 ключевые слова в инструкциях препроцессора, директивах компиляции, аннотациях ==> meta-keyword
  var v8_meta_keywords =
  'вебклиент вместо внешнеесоединение клиент конецобласти мобильноеприложениеклиент мобильноеприложениесервер ' +
  'наклиенте наклиентенасервере наклиентенасерверебезконтекста насервере насерверебезконтекста область перед ' +
  'после сервер толстыйклиентобычноеприложение толстыйклиентуправляемоеприложение тонкийклиент ';

  // meta-keyword : ключевые слова в инструкциях препроцессора, директивах компиляции, аннотациях
  var METAKEYWORD = v7_meta_keywords + v8_meta_keywords;

  // v7 системные константы ==> built_in
  var v7_system_constants =
  'разделительстраниц разделительстрок символтабуляции ';
  
  // v7 уникальные методы глобального контекста, отсутствующие в v8 ==> built_in
  var v7_global_context_methods =
  'ansitooem oemtoansi ввестивидсубконто ввестиперечисление ввестипериод ввестиплансчетов выбранныйплансчетов ' +
  'датагод датамесяц датачисло заголовоксистемы значениевстроку значениеизстроки каталогиб каталогпользователя ' +
  'кодсимв конгода конецпериодаби конецрассчитанногопериодаби конецстандартногоинтервала конквартала конмесяца ' +
  'коннедели лог лог10 максимальноеколичествосубконто названиеинтерфейса названиенабораправ назначитьвид ' +
  'назначитьсчет найтиссылки началопериодаби началостандартногоинтервала начгода начквартала начмесяца ' +
  'начнедели номерднягода номерднянедели номернеделигода обработкаожидания основнойжурналрасчетов ' +
  'основнойплансчетов основнойязык очиститьокносообщений периодстр получитьвремята получитьдатута ' +
  'получитьдокументта получитьзначенияотбора получитьпозициюта получитьпустоезначение получитьта ' +
  'префиксавтонумерации пропись пустоезначение разм разобратьпозициюдокумента рассчитатьрегистрына ' +
  'рассчитатьрегистрыпо симв создатьобъект статусвозврата стрколичествострок сформироватьпозициюдокумента ' +
  'счетпокоду текущеевремя типзначения типзначениястр установитьтана установитьтапо фиксшаблон шаблон ';
  
  // v8 методы глобального контекста ==> built_in
  var v8_global_context_methods =
  'acos asin atan base64значение base64строка cos exp log log10 pow sin sqrt tan xmlзначение xmlстрока ' +
  'xmlтип xmlтипзнч активноеокно безопасныйрежим безопасныйрежимразделенияданных булево ввестидату ввестизначение ' +
  'ввестистроку ввестичисло возможностьчтенияxml вопрос восстановитьзначение врег выгрузитьжурналрегистрации ' +
  'выполнитьобработкуоповещения выполнитьпроверкуправдоступа вычислить год данныеформывзначение дата день деньгода ' +
  'деньнедели добавитьмесяц заблокироватьданныедляредактирования заблокироватьработупользователя завершитьработусистемы ' +
  'загрузитьвнешнююкомпоненту закрытьсправку записатьjson записатьxml записатьдатуjson записьжурналарегистрации ' +
  'заполнитьзначениясвойств запроситьразрешениепользователя запуститьприложение запуститьсистему зафиксироватьтранзакцию ' +
  'значениевданныеформы значениевстрокувнутр значениевфайл значениезаполнено значениеизстрокивнутр значениеизфайла ' +
  'изxmlтипа импортмоделиxdto имякомпьютера имяпользователя инициализироватьпредопределенныеданные информацияобошибке ' +
  'каталогбиблиотекимобильногоустройства каталогвременныхфайлов каталогдокументов каталогпрограммы кодироватьстроку ' +
  'кодлокализацииинформационнойбазы кодсимвола командасистемы конецгода конецдня конецквартала конецмесяца конецминуты ' +
  'конецнедели конецчаса конфигурациябазыданныхизмененадинамически конфигурацияизменена копироватьданныеформы ' +
  'копироватьфайл краткоепредставлениеошибки лев макс местноевремя месяц мин минута монопольныйрежим найти ' +
  'найтинедопустимыесимволыxml найтиокнопонавигационнойссылке найтипомеченныенаудаление найтипоссылкам найтифайлы ' +
  'началогода началодня началоквартала началомесяца началоминуты началонедели началочаса начатьзапросразрешенияпользователя ' +
  'начатьзапускприложения начатькопированиефайла начатьперемещениефайла начатьподключениевнешнейкомпоненты ' +
  'начатьподключениерасширенияработыскриптографией начатьподключениерасширенияработысфайлами начатьпоискфайлов ' +
  'начатьполучениекаталогавременныхфайлов начатьполучениекаталогадокументов начатьполучениерабочегокаталогаданныхпользователя ' +
  'начатьполучениефайлов начатьпомещениефайла начатьпомещениефайлов начатьсозданиедвоичныхданныхизфайла начатьсозданиекаталога ' +
  'начатьтранзакцию начатьудалениефайлов начатьустановкувнешнейкомпоненты начатьустановкурасширенияработыскриптографией ' +
  'начатьустановкурасширенияработысфайлами неделягода необходимостьзавершениясоединения номерсеансаинформационнойбазы ' +
  'номерсоединенияинформационнойбазы нрег нстр обновитьинтерфейс обновитьнумерациюобъектов обновитьповторноиспользуемыезначения ' +
  'обработкапрерыванияпользователя объединитьфайлы окр описаниеошибки оповестить оповеститьобизменении ' +
  'отключитьобработчикзапросанастроекклиенталицензирования отключитьобработчикожидания отключитьобработчикоповещения ' +
  'открытьзначение открытьиндекссправки открытьсодержаниесправки открытьсправку открытьформу открытьформумодально ' +
  'отменитьтранзакцию очиститьжурналрегистрации очиститьнастройкипользователя очиститьсообщения параметрыдоступа ' +
  'перейтипонавигационнойссылке переместитьфайл подключитьвнешнююкомпоненту ' +
  'подключитьобработчикзапросанастроекклиенталицензирования подключитьобработчикожидания подключитьобработчикоповещения ' +
  'подключитьрасширениеработыскриптографией подключитьрасширениеработысфайлами подробноепредставлениеошибки ' +
  'показатьвводдаты показатьвводзначения показатьвводстроки показатьвводчисла показатьвопрос показатьзначение ' +
  'показатьинформациюобошибке показатьнакарте показатьоповещениепользователя показатьпредупреждение полноеимяпользователя ' +
  'получитьcomобъект получитьxmlтип получитьадреспоместоположению получитьблокировкусеансов получитьвремязавершенияспящегосеанса ' +
  'получитьвремязасыпанияпассивногосеанса получитьвремяожиданияблокировкиданных получитьданныевыбора ' +
  'получитьдополнительныйпараметрклиенталицензирования получитьдопустимыекодылокализации получитьдопустимыечасовыепояса ' +
  'получитьзаголовокклиентскогоприложения получитьзаголовоксистемы получитьзначенияотборажурналарегистрации ' +
  'получитьидентификаторконфигурации получитьизвременногохранилища получитьимявременногофайла ' +
  'получитьимяклиенталицензирования получитьинформациюэкрановклиента получитьиспользованиежурналарегистрации ' +
  'получитьиспользованиесобытияжурналарегистрации получитькраткийзаголовокприложения получитьмакетоформления ' +
  'получитьмаскувсефайлы получитьмаскувсефайлыклиента получитьмаскувсефайлысервера получитьместоположениепоадресу ' +
  'получитьминимальнуюдлинупаролейпользователей получитьнавигационнуюссылку получитьнавигационнуюссылкуинформационнойбазы ' +
  'получитьобновлениеконфигурациибазыданных получитьобновлениепредопределенныхданныхинформационнойбазы получитьобщиймакет ' +
  'получитьобщуюформу получитьокна получитьоперативнуюотметкувремени получитьотключениебезопасногорежима ' +
  'получитьпараметрыфункциональныхопцийинтерфейса получитьполноеимяпредопределенногозначения ' +
  'получитьпредставлениянавигационныхссылок получитьпроверкусложностипаролейпользователей получитьразделительпути ' +
  'получитьразделительпутиклиента получитьразделительпутисервера получитьсеансыинформационнойбазы ' +
  'получитьскоростьклиентскогосоединения получитьсоединенияинформационнойбазы получитьсообщенияпользователю ' +
  'получитьсоответствиеобъектаиформы получитьсоставстандартногоинтерфейсаodata получитьструктурухранениябазыданных ' +
  'получитьтекущийсеансинформационнойбазы получитьфайл получитьфайлы получитьформу получитьфункциональнуюопцию ' +
  'получитьфункциональнуюопциюинтерфейса получитьчасовойпоясинформационнойбазы пользователиос поместитьвовременноехранилище ' +
  'поместитьфайл поместитьфайлы прав праводоступа предопределенноезначение представлениекодалокализации представлениепериода ' +
  'представлениеправа представлениеприложения представлениесобытияжурналарегистрации представлениечасовогопояса предупреждение ' +
  'прекратитьработусистемы привилегированныйрежим продолжитьвызов прочитатьjson прочитатьxml прочитатьдатуjson пустаястрока ' +
  'рабочийкаталогданныхпользователя разблокироватьданныедляредактирования разделитьфайл разорватьсоединениесвнешнимисточникомданных ' +
  'раскодироватьстроку рольдоступна секунда сигнал символ скопироватьжурналрегистрации смещениелетнеговремени ' +
  'смещениестандартноговремени соединитьбуферыдвоичныхданных создатькаталог создатьфабрикуxdto сокрл сокрлп сокрп сообщить ' +
  'состояние сохранитьзначение сохранитьнастройкипользователя сред стрдлина стрзаканчиваетсяна стрзаменить стрнайти стрначинаетсяс ' +
  'строка строкасоединенияинформационнойбазы стрполучитьстроку стрразделить стрсоединить стрсравнить стрчисловхождений '+
  'стрчислострок стршаблон текущаядата текущаядатасеанса текущаяуниверсальнаядата текущаяуниверсальнаядатавмиллисекундах ' +
  'текущийвариантинтерфейсаклиентскогоприложения текущийвариантосновногошрифтаклиентскогоприложения текущийкодлокализации ' +
  'текущийрежимзапуска текущийязык текущийязыксистемы тип типзнч транзакцияактивна трег удалитьданныеинформационнойбазы ' +
  'удалитьизвременногохранилища удалитьобъекты удалитьфайлы универсальноевремя установитьбезопасныйрежим ' +
  'установитьбезопасныйрежимразделенияданных установитьблокировкусеансов установитьвнешнююкомпоненту ' +
  'установитьвремязавершенияспящегосеанса установитьвремязасыпанияпассивногосеанса установитьвремяожиданияблокировкиданных ' +
  'установитьзаголовокклиентскогоприложения установитьзаголовоксистемы установитьиспользованиежурналарегистрации ' +
  'установитьиспользованиесобытияжурналарегистрации установитькраткийзаголовокприложения ' +
  'установитьминимальнуюдлинупаролейпользователей установитьмонопольныйрежим установитьнастройкиклиенталицензирования ' +
  'установитьобновлениепредопределенныхданныхинформационнойбазы установитьотключениебезопасногорежима ' +
  'установитьпараметрыфункциональныхопцийинтерфейса установитьпривилегированныйрежим ' +
  'установитьпроверкусложностипаролейпользователей установитьрасширениеработыскриптографией ' +
  'установитьрасширениеработысфайлами установитьсоединениесвнешнимисточникомданных установитьсоответствиеобъектаиформы ' +
  'установитьсоставстандартногоинтерфейсаodata установитьчасовойпоясинформационнойбазы установитьчасовойпояссеанса ' +
  'формат цел час часовойпояс часовойпояссеанса число числопрописью этоадресвременногохранилища ';

  // v8 свойства глобального контекста ==> built_in
  var v8_global_context_property =
  'wsссылки библиотекакартинок библиотекамакетовоформлениякомпоновкиданных библиотекастилей бизнеспроцессы ' +
  'внешниеисточникиданных внешниеобработки внешниеотчеты встроенныепокупки главныйинтерфейс главныйстиль ' +
  'документы доставляемыеуведомления журналыдокументов задачи информацияобинтернетсоединении использованиерабочейдаты ' +
  'историяработыпользователя константы критерииотбора метаданные обработки отображениерекламы отправкадоставляемыхуведомлений ' +
  'отчеты панельзадачос параметрзапуска параметрысеанса перечисления планывидоврасчета планывидовхарактеристик ' +
  'планыобмена планысчетов полнотекстовыйпоиск пользователиинформационнойбазы последовательности проверкавстроенныхпокупок ' +
  'рабочаядата расширенияконфигурации регистрыбухгалтерии регистрынакопления регистрырасчета регистрысведений ' +
  'регламентныезадания сериализаторxdto справочники средствагеопозиционирования средствакриптографии средствамультимедиа ' +
  'средстваотображениярекламы средствапочты средствателефонии фабрикаxdto файловыепотоки фоновыезадания хранилищанастроек ' +
  'хранилищевариантовотчетов хранилищенастроекданныхформ хранилищеобщихнастроек хранилищепользовательскихнастроекдинамическихсписков ' +
  'хранилищепользовательскихнастроекотчетов хранилищесистемныхнастроек ';

  // built_in : встроенные или библиотечные объекты (константы, классы, функции)
  var BUILTIN =
  v7_system_constants +
  v7_global_context_methods + v8_global_context_methods +
  v8_global_context_property;
  
  // v8 системные наборы значений ==> class
  var v8_system_sets_of_values =
  'webцвета windowsцвета windowsшрифты библиотекакартинок рамкистиля символы цветастиля шрифтыстиля ';

  // v8 системные перечисления - интерфейсные ==> class
  var v8_system_enums_interface =
  'автоматическоесохранениеданныхформывнастройках автонумерациявформе автораздвижениесерий ' +
  'анимациядиаграммы вариантвыравниванияэлементовизаголовков вариантуправлениявысотойтаблицы ' +
  'вертикальнаяпрокруткаформы вертикальноеположение вертикальноеположениеэлемента видгруппыформы ' +
  'виддекорацииформы виддополненияэлементаформы видизмененияданных видкнопкиформы видпереключателя ' +
  'видподписейкдиаграмме видполяформы видфлажка влияниеразмеранапузырекдиаграммы горизонтальноеположение ' +
  'горизонтальноеположениеэлемента группировкаколонок группировкаподчиненныхэлементовформы ' +
  'группыиэлементы действиеперетаскивания дополнительныйрежимотображения допустимыедействияперетаскивания ' +
  'интервалмеждуэлементамиформы использованиевывода использованиеполосыпрокрутки ' +
  'используемоезначениеточкибиржевойдиаграммы историявыборапривводе источникзначенийоситочекдиаграммы ' +
  'источникзначенияразмерапузырькадиаграммы категориягруппыкоманд максимумсерий начальноеотображениедерева ' +
  'начальноеотображениесписка обновлениетекстаредактирования ориентациядендрограммы ориентациядиаграммы ' +
  'ориентацияметокдиаграммы ориентацияметоксводнойдиаграммы ориентацияэлементаформы отображениевдиаграмме ' +
  'отображениевлегендедиаграммы отображениегруппыкнопок отображениезаголовкашкалыдиаграммы ' +
  'отображениезначенийсводнойдиаграммы отображениезначенияизмерительнойдиаграммы ' +
  'отображениеинтерваладиаграммыганта отображениекнопки отображениекнопкивыбора отображениеобсужденийформы ' +
  'отображениеобычнойгруппы отображениеотрицательныхзначенийпузырьковойдиаграммы отображениепанелипоиска ' +
  'отображениеподсказки отображениепредупрежденияприредактировании отображениеразметкиполосырегулирования ' +
  'отображениестраницформы отображениетаблицы отображениетекстазначениядиаграммыганта ' +
  'отображениеуправленияобычнойгруппы отображениефигурыкнопки палитрацветовдиаграммы поведениеобычнойгруппы ' +
  'поддержкамасштабадендрограммы поддержкамасштабадиаграммыганта поддержкамасштабасводнойдиаграммы ' +
  'поисквтаблицепривводе положениезаголовкаэлементаформы положениекартинкикнопкиформы ' +
  'положениекартинкиэлементаграфическойсхемы положениекоманднойпанелиформы положениекоманднойпанелиэлементаформы ' +
  'положениеопорнойточкиотрисовки положениеподписейкдиаграмме положениеподписейшкалызначенийизмерительнойдиаграммы ' +
  'положениесостоянияпросмотра положениестрокипоиска положениетекстасоединительнойлинии положениеуправленияпоиском ' +
  'положениешкалывремени порядокотображенияточекгоризонтальнойгистограммы порядоксерийвлегендедиаграммы ' +
  'размеркартинки расположениезаголовкашкалыдиаграммы растягиваниеповертикалидиаграммыганта ' +
  'режимавтоотображениясостояния режимвводастроктаблицы режимвыборанезаполненного режимвыделениядаты ' +
  'режимвыделениястрокитаблицы режимвыделениятаблицы режимизмененияразмера режимизменениясвязанногозначения ' +
  'режимиспользованиядиалогапечати режимиспользованияпараметракоманды режиммасштабированияпросмотра ' +
  'режимосновногоокнаклиентскогоприложения режимоткрытияокнаформы режимотображениявыделения ' +
  'режимотображениягеографическойсхемы режимотображениязначенийсерии режимотрисовкисеткиграфическойсхемы ' +
  'режимполупрозрачностидиаграммы режимпробеловдиаграммы режимразмещениянастранице режимредактированияколонки ' +
  'режимсглаживаниядиаграммы режимсглаживанияиндикатора режимсписказадач сквозноевыравнивание ' +
  'сохранениеданныхформывнастройках способзаполнениятекстазаголовкашкалыдиаграммы ' +
  'способопределенияограничивающегозначениядиаграммы стандартнаягруппакоманд стандартноеоформление ' +
  'статусоповещенияпользователя стильстрелки типаппроксимациилиниитрендадиаграммы типдиаграммы ' +
  'типединицышкалывремени типимпортасерийслоягеографическойсхемы типлиниигеографическойсхемы типлиниидиаграммы ' +
  'типмаркерагеографическойсхемы типмаркерадиаграммы типобластиоформления ' +
  'типорганизацииисточникаданныхгеографическойсхемы типотображениясериислоягеографическойсхемы ' +
  'типотображенияточечногообъектагеографическойсхемы типотображенияшкалыэлементалегендыгеографическойсхемы ' +
  'типпоискаобъектовгеографическойсхемы типпроекциигеографическойсхемы типразмещенияизмерений ' +
  'типразмещенияреквизитовизмерений типрамкиэлементауправления типсводнойдиаграммы ' +
  'типсвязидиаграммыганта типсоединениязначенийпосериямдиаграммы типсоединенияточекдиаграммы ' +
  'типсоединительнойлинии типстороныэлементаграфическойсхемы типформыотчета типшкалырадарнойдиаграммы ' +
  'факторлиниитрендадиаграммы фигуракнопки фигурыграфическойсхемы фиксациявтаблице форматдняшкалывремени ' +
  'форматкартинки ширинаподчиненныхэлементовформы ';

  // v8 системные перечисления - свойства прикладных объектов ==> class
  var v8_system_enums_objects_properties =
  'виддвижениябухгалтерии виддвижениянакопления видпериодарегистрарасчета видсчета видточкимаршрутабизнеспроцесса ' +
  'использованиеагрегатарегистранакопления использованиегруппиэлементов использованиережимапроведения ' +
  'использованиесреза периодичностьагрегатарегистранакопления режимавтовремя режимзаписидокумента режимпроведениядокумента ';

  // v8 системные перечисления - планы обмена ==> class
  var v8_system_enums_exchange_plans =
  'авторегистрацияизменений допустимыйномерсообщения отправкаэлементаданных получениеэлементаданных ';

  // v8 системные перечисления - табличный документ ==> class
  var v8_system_enums_tabular_document =
  'использованиерасшифровкитабличногодокумента ориентациястраницы положениеитоговколоноксводнойтаблицы ' +
  'положениеитоговстроксводнойтаблицы положениетекстаотносительнокартинки расположениезаголовкагруппировкитабличногодокумента ' +
  'способчтениязначенийтабличногодокумента типдвустороннейпечати типзаполненияобластитабличногодокумента ' +
  'типкурсоровтабличногодокумента типлиниирисункатабличногодокумента типлинииячейкитабличногодокумента ' +
  'типнаправленияпереходатабличногодокумента типотображениявыделениятабличногодокумента типотображениялинийсводнойтаблицы ' +
  'типразмещениятекстатабличногодокумента типрисункатабличногодокумента типсмещениятабличногодокумента ' +
  'типузоратабличногодокумента типфайлатабличногодокумента точностьпечати чередованиерасположениястраниц ';

  // v8 системные перечисления - планировщик ==> class
  var v8_system_enums_sheduler =
  'отображениевремениэлементовпланировщика ';

  // v8 системные перечисления - форматированный документ ==> class
  var v8_system_enums_formatted_document =
  'типфайлаформатированногодокумента ';

  // v8 системные перечисления - запрос ==> class
  var v8_system_enums_query =
  'обходрезультатазапроса типзаписизапроса ';

  // v8 системные перечисления - построитель отчета ==> class
  var v8_system_enums_report_builder =
  'видзаполнениярасшифровкипостроителяотчета типдобавленияпредставлений типизмеренияпостроителяотчета типразмещенияитогов ';

  // v8 системные перечисления - работа с файлами ==> class
  var v8_system_enums_files =
  'доступкфайлу режимдиалогавыборафайла режимоткрытияфайла ';

  // v8 системные перечисления - построитель запроса ==> class
  var v8_system_enums_query_builder =
  'типизмеренияпостроителязапроса ';

  // v8 системные перечисления - анализ данных ==> class
  var v8_system_enums_data_analysis =
  'видданныханализа методкластеризации типединицыинтервалавременианализаданных типзаполнениятаблицырезультатаанализаданных ' +
  'типиспользованиячисловыхзначенийанализаданных типисточникаданныхпоискаассоциаций типколонкианализаданныхдереворешений ' +
  'типколонкианализаданныхкластеризация типколонкианализаданныхобщаястатистика типколонкианализаданныхпоискассоциаций ' +
  'типколонкианализаданныхпоискпоследовательностей типколонкимоделипрогноза типмерырасстоянияанализаданных ' +
  'типотсеченияправилассоциации типполяанализаданных типстандартизациианализаданных типупорядочиванияправилассоциациианализаданных ' +
  'типупорядочиванияшаблоновпоследовательностейанализаданных типупрощениядереварешений ';

  // v8 системные перечисления - xml, json, xs, dom, xdto, web-сервисы ==> class
  var v8_system_enums_xml_json_xs_dom_xdto_ws =
  'wsнаправлениепараметра вариантxpathxs вариантзаписидатыjson вариантпростоготипаxs видгруппымоделиxs видфасетаxdto ' +
  'действиепостроителяdom завершенностьпростоготипаxs завершенностьсоставноготипаxs завершенностьсхемыxs запрещенныеподстановкиxs ' +
  'исключениягруппподстановкиxs категорияиспользованияатрибутаxs категорияограниченияидентичностиxs категорияограниченияпространствименxs ' +
  'методнаследованияxs модельсодержимогоxs назначениетипаxml недопустимыеподстановкиxs обработкапробельныхсимволовxs обработкасодержимогоxs ' +
  'ограничениезначенияxs параметрыотбораузловdom переносстрокjson позициявдокументеdom пробельныесимволыxml типатрибутаxml типзначенияjson ' +
  'типканоническогоxml типкомпонентыxs типпроверкиxml типрезультатаdomxpath типузлаdom типузлаxml формаxml формапредставленияxs ' +
  'форматдатыjson экранированиесимволовjson ';

  // v8 системные перечисления - система компоновки данных ==> class
  var v8_system_enums_data_composition_system =
  'видсравнениякомпоновкиданных действиеобработкирасшифровкикомпоновкиданных направлениесортировкикомпоновкиданных ' +
  'расположениевложенныхэлементоврезультатакомпоновкиданных расположениеитоговкомпоновкиданных расположениегруппировкикомпоновкиданных ' +
  'расположениеполейгруппировкикомпоновкиданных расположениеполякомпоновкиданных расположениереквизитовкомпоновкиданных ' +
  'расположениересурсовкомпоновкиданных типбухгалтерскогоостаткакомпоновкиданных типвыводатекстакомпоновкиданных ' +
  'типгруппировкикомпоновкиданных типгруппыэлементовотборакомпоновкиданных типдополненияпериодакомпоновкиданных ' +
  'типзаголовкаполейкомпоновкиданных типмакетагруппировкикомпоновкиданных типмакетаобластикомпоновкиданных типостаткакомпоновкиданных ' +
  'типпериодакомпоновкиданных типразмещениятекстакомпоновкиданных типсвязинаборовданныхкомпоновкиданных типэлементарезультатакомпоновкиданных ' +
  'расположениелегендыдиаграммыкомпоновкиданных типпримененияотборакомпоновкиданных режимотображенияэлементанастройкикомпоновкиданных ' +
  'режимотображениянастроеккомпоновкиданных состояниеэлементанастройкикомпоновкиданных способвосстановлениянастроеккомпоновкиданных ' +
  'режимкомпоновкирезультата использованиепараметракомпоновкиданных автопозицияресурсовкомпоновкиданных '+
  'вариантиспользованиягруппировкикомпоновкиданных расположениересурсоввдиаграммекомпоновкиданных фиксациякомпоновкиданных ' +
  'использованиеусловногооформлениякомпоновкиданных ';

  // v8 системные перечисления - почта ==> class
  var v8_system_enums_email =
  'важностьинтернетпочтовогосообщения обработкатекстаинтернетпочтовогосообщения способкодированияинтернетпочтовоговложения ' +
  'способкодированиянеasciiсимволовинтернетпочтовогосообщения типтекстапочтовогосообщения протоколинтернетпочты ' +
  'статусразборапочтовогосообщения ';

  // v8 системные перечисления - журнал регистрации ==> class
  var v8_system_enums_logbook =
  'режимтранзакциизаписижурналарегистрации статустранзакциизаписижурналарегистрации уровеньжурналарегистрации ';

  // v8 системные перечисления - криптография ==> class
  var v8_system_enums_cryptography =
  'расположениехранилищасертификатовкриптографии режимвключениясертификатовкриптографии режимпроверкисертификатакриптографии ' +
  'типхранилищасертификатовкриптографии ';

  // v8 системные перечисления - ZIP ==> class
  var v8_system_enums_zip =
  'кодировкаименфайловвzipфайле методсжатияzip методшифрованияzip режимвосстановленияпутейфайловzip режимобработкиподкаталоговzip ' +
  'режимсохраненияпутейzip уровеньсжатияzip ';

  // v8 системные перечисления - 
  // Блокировка данных, Фоновые задания, Автоматизированное тестирование,
  // Доставляемые уведомления, Встроенные покупки, Интернет, Работа с двоичными данными ==> class
  var v8_system_enums_other =
  'звуковоеоповещение направлениепереходакстроке позициявпотоке порядокбайтов режимблокировкиданных режимуправленияблокировкойданных ' +
  'сервисвстроенныхпокупок состояниефоновогозадания типподписчикадоставляемыхуведомлений уровеньиспользованиязащищенногосоединенияftp ';

  // v8 системные перечисления - схема запроса ==> class
  var v8_system_enums_request_schema =
  'направлениепорядкасхемызапроса типдополненияпериодамисхемызапроса типконтрольнойточкисхемызапроса типобъединениясхемызапроса ' +
  'типпараметрадоступнойтаблицысхемызапроса типсоединениясхемызапроса ';

  // v8 системные перечисления - свойства объектов метаданных ==> class
  var v8_system_enums_properties_of_metadata_objects =
  'httpметод автоиспользованиеобщегореквизита автопрефиксномеразадачи вариантвстроенногоязыка видиерархии видрегистранакопления ' +
  'видтаблицывнешнегоисточникаданных записьдвиженийприпроведении заполнениепоследовательностей индексирование ' +
  'использованиебазыпланавидоврасчета использованиебыстроговыбора использованиеобщегореквизита использованиеподчинения ' +
  'использованиеполнотекстовогопоиска использованиеразделяемыхданныхобщегореквизита использованиереквизита ' +
  'назначениеиспользованияприложения назначениерасширенияконфигурации направлениепередачи обновлениепредопределенныхданных ' +
  'оперативноепроведение основноепредставлениевидарасчета основноепредставлениевидахарактеристики основноепредставлениезадачи ' +
  'основноепредставлениепланаобмена основноепредставлениесправочника основноепредставлениесчета перемещениеграницыприпроведении ' +
  'периодичностьномерабизнеспроцесса периодичностьномерадокумента периодичностьрегистрарасчета периодичностьрегистрасведений ' +
  'повторноеиспользованиевозвращаемыхзначений полнотекстовыйпоискпривводепостроке принадлежностьобъекта проведение ' +
  'разделениеаутентификацииобщегореквизита разделениеданныхобщегореквизита разделениерасширенийконфигурацииобщегореквизита '+
  'режимавтонумерацииобъектов режимзаписирегистра режимиспользованиямодальности ' +
  'режимиспользованиясинхронныхвызововрасширенийплатформыивнешнихкомпонент режимповторногоиспользованиясеансов ' +
  'режимполученияданныхвыборапривводепостроке режимсовместимости режимсовместимостиинтерфейса ' +
  'режимуправленияблокировкойданныхпоумолчанию сериикодовпланавидовхарактеристик сериикодовпланасчетов ' +
  'сериикодовсправочника созданиепривводе способвыбора способпоискастрокипривводепостроке способредактирования ' +
  'типданныхтаблицывнешнегоисточникаданных типкодапланавидоврасчета типкодасправочника типмакета типномерабизнеспроцесса ' +
  'типномерадокумента типномеразадачи типформы удалениедвижений ';

  // v8 системные перечисления - разные ==> class
  var v8_system_enums_differents =
  'важностьпроблемыприменениярасширенияконфигурации вариантинтерфейсаклиентскогоприложения вариантмасштабаформклиентскогоприложения ' +
  'вариантосновногошрифтаклиентскогоприложения вариантстандартногопериода вариантстандартнойдатыначала видграницы видкартинки ' +
  'видотображенияполнотекстовогопоиска видрамки видсравнения видцвета видчисловогозначения видшрифта допустимаядлина допустимыйзнак ' +
  'использованиеbyteordermark использованиеметаданныхполнотекстовогопоиска источникрасширенийконфигурации клавиша кодвозвратадиалога ' +
  'кодировкаxbase кодировкатекста направлениепоиска направлениесортировки обновлениепредопределенныхданных обновлениеприизмененииданных ' +
  'отображениепанелиразделов проверказаполнения режимдиалогавопрос режимзапускаклиентскогоприложения режимокругления режимоткрытияформприложения ' +
  'режимполнотекстовогопоиска скоростьклиентскогосоединения состояниевнешнегоисточникаданных состояниеобновленияконфигурациибазыданных ' +
  'способвыборасертификатаwindows способкодированиястроки статуссообщения типвнешнейкомпоненты типплатформы типповеденияклавишиenter ' +
  'типэлементаинформацииовыполненииобновленияконфигурациибазыданных уровеньизоляциитранзакций хешфункция частидаты';

  // class: встроенные наборы значений, системные перечисления (содержат дочерние значения, обращения к которым через разыменование)
  var CLASS =
  v8_system_sets_of_values +
  v8_system_enums_interface +
  v8_system_enums_objects_properties +
  v8_system_enums_exchange_plans +
  v8_system_enums_tabular_document +
  v8_system_enums_sheduler +
  v8_system_enums_formatted_document +
  v8_system_enums_query +
  v8_system_enums_report_builder +
  v8_system_enums_files +
  v8_system_enums_query_builder +
  v8_system_enums_data_analysis +
  v8_system_enums_xml_json_xs_dom_xdto_ws +
  v8_system_enums_data_composition_system +
  v8_system_enums_email +
  v8_system_enums_logbook +
  v8_system_enums_cryptography +
  v8_system_enums_zip +
  v8_system_enums_other +
  v8_system_enums_request_schema +
  v8_system_enums_properties_of_metadata_objects +
  v8_system_enums_differents;

  // v8 общие объекты (у объектов есть конструктор, экземпляры создаются методом НОВЫЙ) ==> type
  var v8_shared_object =
  'comобъект ftpсоединение httpзапрос httpсервисответ httpсоединение wsопределения wsпрокси xbase анализданных аннотацияxs ' +
  'блокировкаданных буфердвоичныхданных включениеxs выражениекомпоновкиданных генераторслучайныхчисел географическаясхема ' +
  'географическиекоординаты графическаясхема группамоделиxs данныерасшифровкикомпоновкиданных двоичныеданные дендрограмма ' +
  'диаграмма диаграммаганта диалогвыборафайла диалогвыборацвета диалогвыборашрифта диалограсписаниярегламентногозадания ' +
  'диалогредактированиястандартногопериода диапазон документdom документhtml документацияxs доставляемоеуведомление ' +
  'записьdom записьfastinfoset записьhtml записьjson записьxml записьzipфайла записьданных записьтекста записьузловdom ' +
  'запрос защищенноесоединениеopenssl значенияполейрасшифровкикомпоновкиданных извлечениетекста импортxs интернетпочта ' +
  'интернетпочтовоесообщение интернетпочтовыйпрофиль интернетпрокси интернетсоединение информациядляприложенияxs ' +
  'использованиеатрибутаxs использованиесобытияжурналарегистрации источникдоступныхнастроеккомпоновкиданных ' +
  'итераторузловdom картинка квалификаторыдаты квалификаторыдвоичныхданных квалификаторыстроки квалификаторычисла ' +
  'компоновщикмакетакомпоновкиданных компоновщикнастроеккомпоновкиданных конструктормакетаоформлениякомпоновкиданных ' +
  'конструкторнастроеккомпоновкиданных конструкторформатнойстроки линия макеткомпоновкиданных макетобластикомпоновкиданных ' +
  'макетоформлениякомпоновкиданных маскаxs менеджеркриптографии наборсхемxml настройкикомпоновкиданных настройкисериализацииjson ' +
  'обработкакартинок обработкарасшифровкикомпоновкиданных обходдереваdom объявлениеатрибутаxs объявлениенотацииxs ' +
  'объявлениеэлементаxs описаниеиспользованиясобытиядоступжурналарегистрации ' +
  'описаниеиспользованиясобытияотказвдоступежурналарегистрации описаниеобработкирасшифровкикомпоновкиданных ' +
  'описаниепередаваемогофайла описаниетипов определениегруппыатрибутовxs определениегруппымоделиxs ' +
  'определениеограниченияидентичностиxs определениепростоготипаxs определениесоставноготипаxs определениетипадокументаdom ' +
  'определенияxpathxs отборкомпоновкиданных пакетотображаемыхдокументов параметрвыбора параметркомпоновкиданных ' +
  'параметрызаписиjson параметрызаписиxml параметрычтенияxml переопределениеxs планировщик полеанализаданных ' +
  'полекомпоновкиданных построительdom построительзапроса построительотчета построительотчетаанализаданных ' +
  'построительсхемxml поток потоквпамяти почта почтовоесообщение преобразованиеxsl преобразованиекканоническомуxml ' +
  'процессорвыводарезультатакомпоновкиданныхвколлекциюзначений процессорвыводарезультатакомпоновкиданныхвтабличныйдокумент ' +
  'процессоркомпоновкиданных разыменовательпространствименdom рамка расписаниерегламентногозадания расширенноеимяxml ' +
  'результатчтенияданных своднаядиаграмма связьпараметравыбора связьпотипу связьпотипукомпоновкиданных сериализаторxdto ' +
  'сертификатклиентаwindows сертификатклиентафайл сертификаткриптографии сертификатыудостоверяющихцентровwindows ' +
  'сертификатыудостоверяющихцентровфайл сжатиеданных системнаяинформация сообщениепользователю сочетаниеклавиш ' +
  'сравнениезначений стандартнаядатаначала стандартныйпериод схемаxml схемакомпоновкиданных табличныйдокумент ' +
  'текстовыйдокумент тестируемоеприложение типданныхxml уникальныйидентификатор фабрикаxdto файл файловыйпоток ' +
  'фасетдлиныxs фасетколичестваразрядовдробнойчастиxs фасетмаксимальноговключающегозначенияxs ' +
  'фасетмаксимальногоисключающегозначенияxs фасетмаксимальнойдлиныxs фасетминимальноговключающегозначенияxs ' +
  'фасетминимальногоисключающегозначенияxs фасетминимальнойдлиныxs фасетобразцаxs фасетобщегоколичестваразрядовxs ' +
  'фасетперечисленияxs фасетпробельныхсимволовxs фильтрузловdom форматированнаястрока форматированныйдокумент ' +
  'фрагментxs хешированиеданных хранилищезначения цвет чтениеfastinfoset чтениеhtml чтениеjson чтениеxml чтениеzipфайла ' +
  'чтениеданных чтениетекста чтениеузловdom шрифт элементрезультатакомпоновкиданных ';

  // v8 универсальные коллекции значений ==> type
  var v8_universal_collection =
  'comsafearray деревозначений массив соответствие списокзначений структура таблицазначений фиксированнаяструктура ' +
  'фиксированноесоответствие фиксированныймассив ';

  // type : встроенные типы
  var TYPE =
  v8_shared_object +
  v8_universal_collection;

  // literal : примитивные типы
  var LITERAL = 'null истина ложь неопределено';
  
  // number : числа
  var NUMBERS = hljs.inherit(hljs.NUMBER_MODE);

  // string : строки
  var STRINGS = {
    className: 'string',
    begin: '"|\\|', end: '"|$',
    contains: [{begin: '""'}]
  };

  // number : даты
  var DATE = {
    begin: "'", end: "'", excludeBegin: true, excludeEnd: true,
    contains: [
      {
        className: 'number',
        begin: '\\d{4}([\\.\\\\/:-]?\\d{2}){0,5}'
      }
    ]
  };
  
  // comment : комментарии
  var COMMENTS = hljs.inherit(hljs.C_LINE_COMMENT_MODE);
  
  // meta : инструкции препроцессора, директивы компиляции
  var META = {
    className: 'meta',
    lexemes: UNDERSCORE_IDENT_RE,
    begin: '#|&', end: '$',
    keywords: {'meta-keyword': KEYWORD + METAKEYWORD},
    contains: [
      COMMENTS
    ]
  };
  
  // symbol : метка goto
  var SYMBOL = {
    className: 'symbol',
    begin: '~', end: ';|:', excludeEnd: true
  };  
  
  // function : объявление процедур и функций
  var FUNCTION = {
    className: 'function',
    lexemes: UNDERSCORE_IDENT_RE,
    variants: [
      {begin: 'процедура|функция', end: '\\)', keywords: 'процедура функция'},
      {begin: 'конецпроцедуры|конецфункции', keywords: 'конецпроцедуры конецфункции'}
    ],
    contains: [
      {
        begin: '\\(', end: '\\)', endsParent : true,
        contains: [
          {
            className: 'params',
            lexemes: UNDERSCORE_IDENT_RE,
            begin: UNDERSCORE_IDENT_RE, end: ',', excludeEnd: true, endsWithParent: true,
            keywords: {
              keyword: 'знач',
              literal: LITERAL
            },
            contains: [
              NUMBERS,
              STRINGS,
              DATE
            ]
          },
          COMMENTS
        ]
      },
      hljs.inherit(hljs.TITLE_MODE, {begin: UNDERSCORE_IDENT_RE})
    ]
  };

  return {
    case_insensitive: true,
    lexemes: UNDERSCORE_IDENT_RE,
    keywords: {
      keyword: KEYWORD,
      built_in: BUILTIN,
      class: CLASS,
      type: TYPE,
      literal: LITERAL
    },
    contains: [
      META,
      FUNCTION,
      COMMENTS,
      SYMBOL,
      NUMBERS,
      STRINGS,
      DATE
    ]  
  }
};

/***/ }),
/* 943 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
    var regexes = {
        ruleDeclaration: "^[a-zA-Z][a-zA-Z0-9-]*",
        unexpectedChars: "[!@#$^&',?+~`|:]"
    };

    var keywords = [
        "ALPHA",
        "BIT",
        "CHAR",
        "CR",
        "CRLF",
        "CTL",
        "DIGIT",
        "DQUOTE",
        "HEXDIG",
        "HTAB",
        "LF",
        "LWSP",
        "OCTET",
        "SP",
        "VCHAR",
        "WSP"
    ];

    var commentMode = hljs.COMMENT(";", "$");

    var terminalBinaryMode = {
        className: "symbol",
        begin: /%b[0-1]+(-[0-1]+|(\.[0-1]+)+){0,1}/
    };

    var terminalDecimalMode = {
        className: "symbol",
        begin: /%d[0-9]+(-[0-9]+|(\.[0-9]+)+){0,1}/
    };

    var terminalHexadecimalMode = {
        className: "symbol",
        begin: /%x[0-9A-F]+(-[0-9A-F]+|(\.[0-9A-F]+)+){0,1}/,
    };

    var caseSensitivityIndicatorMode = {
        className: "symbol",
        begin: /%[si]/
    };

    var ruleDeclarationMode = {
        begin: regexes.ruleDeclaration + '\\s*=',
        returnBegin: true,
        end: /=/,
        relevance: 0,
        contains: [{className: "attribute", begin: regexes.ruleDeclaration}]
    };

    return {
      illegal: regexes.unexpectedChars,
      keywords: keywords.join(" "),
      contains: [
          ruleDeclarationMode,
          commentMode,
          terminalBinaryMode,
          terminalDecimalMode,
          terminalHexadecimalMode,
          caseSensitivityIndicatorMode,
          hljs.QUOTE_STRING_MODE,
          hljs.NUMBER_MODE
      ]
    };
};

/***/ }),
/* 944 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    contains: [
      // IP
      {
        className: 'number',
        begin: '\\b\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}(:\\d{1,5})?\\b'
      },
      // Other numbers
      {
        className: 'number',
        begin: '\\b\\d+\\b',
        relevance: 0
      },
      // Requests
      {
        className: 'string',
        begin: '"(GET|POST|HEAD|PUT|DELETE|CONNECT|OPTIONS|PATCH|TRACE)', end: '"',
        keywords: 'GET POST HEAD PUT DELETE CONNECT OPTIONS PATCH TRACE',
        illegal: '\\n',
        relevance: 10
      },
      // Dates
      {
        className: 'string',
        begin: /\[/, end: /\]/,
        illegal: '\\n'
      },
      // Strings
      {
        className: 'string',
        begin: '"', end: '"',
        illegal: '\\n'
      }
    ]
  };
};

/***/ }),
/* 945 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var IDENT_RE = '[a-zA-Z_$][a-zA-Z0-9_$]*';
  var IDENT_FUNC_RETURN_TYPE_RE = '([*]|[a-zA-Z_$][a-zA-Z0-9_$]*)';

  var AS3_REST_ARG_MODE = {
    className: 'rest_arg',
    begin: '[.]{3}', end: IDENT_RE,
    relevance: 10
  };

  return {
    aliases: ['as'],
    keywords: {
      keyword: 'as break case catch class const continue default delete do dynamic each ' +
        'else extends final finally for function get if implements import in include ' +
        'instanceof interface internal is namespace native new override package private ' +
        'protected public return set static super switch this throw try typeof use var void ' +
        'while with',
      literal: 'true false null undefined'
    },
    contains: [
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.C_NUMBER_MODE,
      {
        className: 'class',
        beginKeywords: 'package', end: '{',
        contains: [hljs.TITLE_MODE]
      },
      {
        className: 'class',
        beginKeywords: 'class interface', end: '{', excludeEnd: true,
        contains: [
          {
            beginKeywords: 'extends implements'
          },
          hljs.TITLE_MODE
        ]
      },
      {
        className: 'meta',
        beginKeywords: 'import include', end: ';',
        keywords: {'meta-keyword': 'import include'}
      },
      {
        className: 'function',
        beginKeywords: 'function', end: '[{;]', excludeEnd: true,
        illegal: '\\S',
        contains: [
          hljs.TITLE_MODE,
          {
            className: 'params',
            begin: '\\(', end: '\\)',
            contains: [
              hljs.APOS_STRING_MODE,
              hljs.QUOTE_STRING_MODE,
              hljs.C_LINE_COMMENT_MODE,
              hljs.C_BLOCK_COMMENT_MODE,
              AS3_REST_ARG_MODE
            ]
          },
          {
            begin: ':\\s*' + IDENT_FUNC_RETURN_TYPE_RE
          }
        ]
      },
      hljs.METHOD_GUARD
    ],
    illegal: /#/
  };
};

/***/ }),
/* 946 */
/***/ (function(module, exports) {

module.exports = // We try to support full Ada2012
//
// We highlight all appearances of types, keywords, literals (string, char, number, bool)
// and titles (user defined function/procedure/package)
// CSS classes are set accordingly
//
// Languages causing problems for language detection:
// xml (broken by Foo : Bar type), elm (broken by Foo : Bar type), vbscript-html (broken by body keyword)
// sql (ada default.txt has a lot of sql keywords)

function(hljs) {
    // Regular expression for Ada numeric literals.
    // stolen form the VHDL highlighter

    // Decimal literal:
    var INTEGER_RE = '\\d(_|\\d)*';
    var EXPONENT_RE = '[eE][-+]?' + INTEGER_RE;
    var DECIMAL_LITERAL_RE = INTEGER_RE + '(\\.' + INTEGER_RE + ')?' + '(' + EXPONENT_RE + ')?';

    // Based literal:
    var BASED_INTEGER_RE = '\\w+';
    var BASED_LITERAL_RE = INTEGER_RE + '#' + BASED_INTEGER_RE + '(\\.' + BASED_INTEGER_RE + ')?' + '#' + '(' + EXPONENT_RE + ')?';

    var NUMBER_RE = '\\b(' + BASED_LITERAL_RE + '|' + DECIMAL_LITERAL_RE + ')';

    // Identifier regex
    var ID_REGEX = '[A-Za-z](_?[A-Za-z0-9.])*';

    // bad chars, only allowed in literals
    var BAD_CHARS = '[]{}%#\'\"'

    // Ada doesn't have block comments, only line comments
    var COMMENTS = hljs.COMMENT('--', '$');

    // variable declarations of the form
    // Foo : Bar := Baz;
    // where only Bar will be highlighted
    var VAR_DECLS = {
        // TODO: These spaces are not required by the Ada syntax
        // however, I have yet to see handwritten Ada code where
        // someone does not put spaces around :
        begin: '\\s+:\\s+', end: '\\s*(:=|;|\\)|=>|$)',
        // endsWithParent: true,
        // returnBegin: true,
        illegal: BAD_CHARS,
        contains: [
            {
                // workaround to avoid highlighting
                // named loops and declare blocks
                beginKeywords: 'loop for declare others',
                endsParent: true,
            },
            {
                // properly highlight all modifiers
                className: 'keyword',
                beginKeywords: 'not null constant access function procedure in out aliased exception'
            },
            {
                className: 'type',
                begin: ID_REGEX,
                endsParent: true,
                relevance: 0,
            }
        ]
    };

    return {
        case_insensitive: true,
        keywords: {
            keyword:
                'abort else new return abs elsif not reverse abstract end ' +
                'accept entry select access exception of separate aliased exit or some ' +
                'all others subtype and for out synchronized array function overriding ' +
                'at tagged generic package task begin goto pragma terminate ' +
                'body private then if procedure type case in protected constant interface ' +
                'is raise use declare range delay limited record when delta loop rem while ' +
                'digits renames with do mod requeue xor',
            literal:
                'True False',
        },
        contains: [
            COMMENTS,
            // strings "foobar"
            {
                className: 'string',
                begin: /"/, end: /"/,
                contains: [{begin: /""/, relevance: 0}]
            },
            // characters ''
            {
                // character literals always contain one char
                className: 'string',
                begin: /'.'/
            },
            {
                // number literals
                className: 'number',
                begin: NUMBER_RE,
                relevance: 0
            },
            {
                // Attributes
                className: 'symbol',
                begin: "'" + ID_REGEX,
            },
            {
                // package definition, maybe inside generic
                className: 'title',
                begin: '(\\bwith\\s+)?(\\bprivate\\s+)?\\bpackage\\s+(\\bbody\\s+)?', end: '(is|$)',
                keywords: 'package body',
                excludeBegin: true,
                excludeEnd: true,
                illegal: BAD_CHARS
            },
            {
                // function/procedure declaration/definition
                // maybe inside generic
                begin: '(\\b(with|overriding)\\s+)?\\b(function|procedure)\\s+', end: '(\\bis|\\bwith|\\brenames|\\)\\s*;)',
                keywords: 'overriding function procedure with is renames return',
                // we need to re-match the 'function' keyword, so that
                // the title mode below matches only exactly once
                returnBegin: true,
                contains:
                [
                    COMMENTS,
                    {
                        // name of the function/procedure
                        className: 'title',
                        begin: '(\\bwith\\s+)?\\b(function|procedure)\\s+',
                        end: '(\\(|\\s+|$)',
                        excludeBegin: true,
                        excludeEnd: true,
                        illegal: BAD_CHARS
                    },
                    // 'self'
                    // // parameter types
                    VAR_DECLS,
                    {
                        // return type
                        className: 'type',
                        begin: '\\breturn\\s+', end: '(\\s+|;|$)',
                        keywords: 'return',
                        excludeBegin: true,
                        excludeEnd: true,
                        // we are done with functions
                        endsParent: true,
                        illegal: BAD_CHARS

                    },
                ]
            },
            {
                // new type declarations
                // maybe inside generic
                className: 'type',
                begin: '\\b(sub)?type\\s+', end: '\\s+',
                keywords: 'type',
                excludeBegin: true,
                illegal: BAD_CHARS
            },

            // see comment above the definition
            VAR_DECLS,

            // no markup
            // relevance boosters for small snippets
            // {begin: '\\s*=>\\s*'},
            // {begin: '\\s*:=\\s*'},
            // {begin: '\\s+:=\\s+'},
        ]
    };
};

/***/ }),
/* 947 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var NUMBER = {className: 'number', begin: '[\\$%]\\d+'};
  return {
    aliases: ['apacheconf'],
    case_insensitive: true,
    contains: [
      hljs.HASH_COMMENT_MODE,
      {className: 'section', begin: '</?', end: '>'},
      {
        className: 'attribute',
        begin: /\w+/,
        relevance: 0,
        // keywords aren’t needed for highlighting per se, they only boost relevance
        // for a very generally defined mode (starts with a word, ends with line-end
        keywords: {
          nomarkup:
            'order deny allow setenv rewriterule rewriteengine rewritecond documentroot ' +
            'sethandler errordocument loadmodule options header listen serverroot ' +
            'servername'
        },
        starts: {
          end: /$/,
          relevance: 0,
          keywords: {
            literal: 'on off all'
          },
          contains: [
            {
              className: 'meta',
              begin: '\\s\\[', end: '\\]$'
            },
            {
              className: 'variable',
              begin: '[\\$%]\\{', end: '\\}',
              contains: ['self', NUMBER]
            },
            NUMBER,
            hljs.QUOTE_STRING_MODE
          ]
        }
      }
    ],
    illegal: /\S/
  };
};

/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: ''});
  var PARAMS = {
    className: 'params',
    begin: '\\(', end: '\\)',
    contains: ['self', hljs.C_NUMBER_MODE, STRING]
  };
  var COMMENT_MODE_1 = hljs.COMMENT('--', '$');
  var COMMENT_MODE_2 = hljs.COMMENT(
    '\\(\\*',
    '\\*\\)',
    {
      contains: ['self', COMMENT_MODE_1] //allow nesting
    }
  );
  var COMMENTS = [
    COMMENT_MODE_1,
    COMMENT_MODE_2,
    hljs.HASH_COMMENT_MODE
  ];

  return {
    aliases: ['osascript'],
    keywords: {
      keyword:
        'about above after against and around as at back before beginning ' +
        'behind below beneath beside between but by considering ' +
        'contain contains continue copy div does eighth else end equal ' +
        'equals error every exit fifth first for fourth from front ' +
        'get given global if ignoring in into is it its last local me ' +
        'middle mod my ninth not of on onto or over prop property put ref ' +
        'reference repeat returning script second set seventh since ' +
        'sixth some tell tenth that the|0 then third through thru ' +
        'timeout times to transaction try until where while whose with ' +
        'without',
      literal:
        'AppleScript false linefeed return pi quote result space tab true',
      built_in:
        'alias application boolean class constant date file integer list ' +
        'number real record string text ' +
        'activate beep count delay launch log offset read round ' +
        'run say summarize write ' +
        'character characters contents day frontmost id item length ' +
        'month name paragraph paragraphs rest reverse running time version ' +
        'weekday word words year'
    },
    contains: [
      STRING,
      hljs.C_NUMBER_MODE,
      {
        className: 'built_in',
        begin:
          '\\b(clipboard info|the clipboard|info for|list (disks|folder)|' +
          'mount volume|path to|(close|open for) access|(get|set) eof|' +
          'current date|do shell script|get volume settings|random number|' +
          'set volume|system attribute|system info|time to GMT|' +
          '(load|run|store) script|scripting components|' +
          'ASCII (character|number)|localized string|' +
          'choose (application|color|file|file name|' +
          'folder|from list|remote application|URL)|' +
          'display (alert|dialog))\\b|^\\s*return\\b'
      },
      {
        className: 'literal',
        begin:
          '\\b(text item delimiters|current application|missing value)\\b'
      },
      {
        className: 'keyword',
        begin:
          '\\b(apart from|aside from|instead of|out of|greater than|' +
          "isn't|(doesn't|does not) (equal|come before|come after|contain)|" +
          '(greater|less) than( or equal)?|(starts?|ends|begins?) with|' +
          'contained by|comes (before|after)|a (ref|reference)|POSIX file|' +
          'POSIX path|(date|time) string|quoted form)\\b'
      },
      {
        beginKeywords: 'on',
        illegal: '[${=;\\n]',
        contains: [hljs.UNDERSCORE_TITLE_MODE, PARAMS]
      }
    ].concat(COMMENTS),
    illegal: '//|->|=>|\\[\\['
  };
};

/***/ }),
/* 949 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var CPP_PRIMITIVE_TYPES = {
    className: 'keyword',
    begin: '\\b[a-z\\d_]*_t\\b'
  };

  var STRINGS = {
    className: 'string',
    variants: [
      {
        begin: '(u8?|U)?L?"', end: '"',
        illegal: '\\n',
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      {
        begin: '(u8?|U)?R"', end: '"',
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      {
        begin: '\'\\\\?.', end: '\'',
        illegal: '.'
      }
    ]
  };

  var NUMBERS = {
    className: 'number',
    variants: [
      { begin: '\\b(0b[01\']+)' },
      { begin: '(-?)\\b([\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)(u|U|l|L|ul|UL|f|F|b|B)' },
      { begin: '(-?)(\\b0[xX][a-fA-F0-9\']+|(\\b[\\d\']+(\\.[\\d\']*)?|\\.[\\d\']+)([eE][-+]?[\\d\']+)?)' }
    ],
    relevance: 0
  };

  var PREPROCESSOR =       {
    className: 'meta',
    begin: /#\s*[a-z]+\b/, end: /$/,
    keywords: {
      'meta-keyword':
        'if else elif endif define undef warning error line ' +
        'pragma ifdef ifndef include'
    },
    contains: [
      {
        begin: /\\\n/, relevance: 0
      },
      hljs.inherit(STRINGS, {className: 'meta-string'}),
      {
        className: 'meta-string',
        begin: /<[^\n>]*>/, end: /$/,
        illegal: '\\n',
      },
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE
    ]
  };

  var FUNCTION_TITLE = hljs.IDENT_RE + '\\s*\\(';

  var CPP_KEYWORDS = {
    keyword: 'int float while private char catch import module export virtual operator sizeof ' +
      'dynamic_cast|10 typedef const_cast|10 const for static_cast|10 union namespace ' +
      'unsigned long volatile static protected bool template mutable if public friend ' +
      'do goto auto void enum else break extern using asm case typeid ' +
      'short reinterpret_cast|10 default double register explicit signed typename try this ' +
      'switch continue inline delete alignof constexpr decltype ' +
      'noexcept static_assert thread_local restrict _Bool complex _Complex _Imaginary ' +
      'atomic_bool atomic_char atomic_schar ' +
      'atomic_uchar atomic_short atomic_ushort atomic_int atomic_uint atomic_long atomic_ulong atomic_llong ' +
      'atomic_ullong new throw return ' +
      'and or not',
    built_in: 'std string cin cout cerr clog stdin stdout stderr stringstream istringstream ostringstream ' +
      'auto_ptr deque list queue stack vector map set bitset multiset multimap unordered_set ' +
      'unordered_map unordered_multiset unordered_multimap array shared_ptr abort abs acos ' +
      'asin atan2 atan calloc ceil cosh cos exit exp fabs floor fmod fprintf fputs free frexp ' +
      'fscanf isalnum isalpha iscntrl isdigit isgraph islower isprint ispunct isspace isupper ' +
      'isxdigit tolower toupper labs ldexp log10 log malloc realloc memchr memcmp memcpy memset modf pow ' +
      'printf putchar puts scanf sinh sin snprintf sprintf sqrt sscanf strcat strchr strcmp ' +
      'strcpy strcspn strlen strncat strncmp strncpy strpbrk strrchr strspn strstr tanh tan ' +
      'vfprintf vprintf vsprintf endl initializer_list unique_ptr',
    literal: 'true false nullptr NULL'
  };

  var EXPRESSION_CONTAINS = [
    CPP_PRIMITIVE_TYPES,
    hljs.C_LINE_COMMENT_MODE,
    hljs.C_BLOCK_COMMENT_MODE,
    NUMBERS,
    STRINGS
  ];

  return {
    aliases: ['c', 'cc', 'h', 'c++', 'h++', 'hpp'],
    keywords: CPP_KEYWORDS,
    illegal: '</',
    contains: EXPRESSION_CONTAINS.concat([
      PREPROCESSOR,
      {
        begin: '\\b(deque|list|queue|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array)\\s*<', end: '>',
        keywords: CPP_KEYWORDS,
        contains: ['self', CPP_PRIMITIVE_TYPES]
      },
      {
        begin: hljs.IDENT_RE + '::',
        keywords: CPP_KEYWORDS
      },
      {
        // This mode covers expression context where we can't expect a function
        // definition and shouldn't highlight anything that looks like one:
        // `return some()`, `else if()`, `(x*sum(1, 2))`
        variants: [
          {begin: /=/, end: /;/},
          {begin: /\(/, end: /\)/},
          {beginKeywords: 'new throw return else', end: /;/}
        ],
        keywords: CPP_KEYWORDS,
        contains: EXPRESSION_CONTAINS.concat([
          {
            begin: /\(/, end: /\)/,
            keywords: CPP_KEYWORDS,
            contains: EXPRESSION_CONTAINS.concat(['self']),
            relevance: 0
          }
        ]),
        relevance: 0
      },
      {
        className: 'function',
        begin: '(' + hljs.IDENT_RE + '[\\*&\\s]+)+' + FUNCTION_TITLE,
        returnBegin: true, end: /[{;=]/,
        excludeEnd: true,
        keywords: CPP_KEYWORDS,
        illegal: /[^\w\s\*&]/,
        contains: [
          {
            begin: FUNCTION_TITLE, returnBegin: true,
            contains: [hljs.TITLE_MODE],
            relevance: 0
          },
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            keywords: CPP_KEYWORDS,
            relevance: 0,
            contains: [
              hljs.C_LINE_COMMENT_MODE,
              hljs.C_BLOCK_COMMENT_MODE,
              STRINGS,
              NUMBERS,
              CPP_PRIMITIVE_TYPES
            ]
          },
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE,
          PREPROCESSOR
        ]
      },
      {
        className: 'class',
        beginKeywords: 'class struct', end: /[{;:]/,
        contains: [
          {begin: /</, end: />/, contains: ['self']}, // skip generic stuff
          hljs.TITLE_MODE
        ]
      }
    ]),
    exports: {
      preprocessor: PREPROCESSOR,
      strings: STRINGS,
      keywords: CPP_KEYWORDS
    }
  };
};

/***/ }),
/* 950 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var CPP = hljs.getLanguage('cpp').exports;
	return {
    keywords: {
      keyword:
        'boolean byte word string String array ' + CPP.keywords.keyword,
      built_in:
        'setup loop while catch for if do goto try switch case else ' +
        'default break continue return ' +
        'KeyboardController MouseController SoftwareSerial ' +
        'EthernetServer EthernetClient LiquidCrystal ' +
        'RobotControl GSMVoiceCall EthernetUDP EsploraTFT ' +
        'HttpClient RobotMotor WiFiClient GSMScanner ' +
        'FileSystem Scheduler GSMServer YunClient YunServer ' +
        'IPAddress GSMClient GSMModem Keyboard Ethernet ' +
        'Console GSMBand Esplora Stepper Process ' +
        'WiFiUDP GSM_SMS Mailbox USBHost Firmata PImage ' +
        'Client Server GSMPIN FileIO Bridge Serial ' +
        'EEPROM Stream Mouse Audio Servo File Task ' +
        'GPRS WiFi Wire TFT GSM SPI SD ' +
        'runShellCommandAsynchronously analogWriteResolution ' +
        'retrieveCallingNumber printFirmwareVersion ' +
        'analogReadResolution sendDigitalPortPair ' +
        'noListenOnLocalhost readJoystickButton setFirmwareVersion ' +
        'readJoystickSwitch scrollDisplayRight getVoiceCallStatus ' +
        'scrollDisplayLeft writeMicroseconds delayMicroseconds ' +
        'beginTransmission getSignalStrength runAsynchronously ' +
        'getAsynchronously listenOnLocalhost getCurrentCarrier ' +
        'readAccelerometer messageAvailable sendDigitalPorts ' +
        'lineFollowConfig countryNameWrite runShellCommand ' +
        'readStringUntil rewindDirectory readTemperature ' +
        'setClockDivider readLightSensor endTransmission ' +
        'analogReference detachInterrupt countryNameRead ' +
        'attachInterrupt encryptionType readBytesUntil ' +
        'robotNameWrite readMicrophone robotNameRead cityNameWrite ' +
        'userNameWrite readJoystickY readJoystickX mouseReleased ' +
        'openNextFile scanNetworks noInterrupts digitalWrite ' +
        'beginSpeaker mousePressed isActionDone mouseDragged ' +
        'displayLogos noAutoscroll addParameter remoteNumber ' +
        'getModifiers keyboardRead userNameRead waitContinue ' +
        'processInput parseCommand printVersion readNetworks ' +
        'writeMessage blinkVersion cityNameRead readMessage ' +
        'setDataMode parsePacket isListening setBitOrder ' +
        'beginPacket isDirectory motorsWrite drawCompass ' +
        'digitalRead clearScreen serialEvent rightToLeft ' +
        'setTextSize leftToRight requestFrom keyReleased ' +
        'compassRead analogWrite interrupts WiFiServer ' +
        'disconnect playMelody parseFloat autoscroll ' +
        'getPINUsed setPINUsed setTimeout sendAnalog ' +
        'readSlider analogRead beginWrite createChar ' +
        'motorsStop keyPressed tempoWrite readButton ' +
        'subnetMask debugPrint macAddress writeGreen ' +
        'randomSeed attachGPRS readString sendString ' +
        'remotePort releaseAll mouseMoved background ' +
        'getXChange getYChange answerCall getResult ' +
        'voiceCall endPacket constrain getSocket writeJSON ' +
        'getButton available connected findUntil readBytes ' +
        'exitValue readGreen writeBlue startLoop IPAddress ' +
        'isPressed sendSysex pauseMode gatewayIP setCursor ' +
        'getOemKey tuneWrite noDisplay loadImage switchPIN ' +
        'onRequest onReceive changePIN playFile noBuffer ' +
        'parseInt overflow checkPIN knobRead beginTFT ' +
        'bitClear updateIR bitWrite position writeRGB ' +
        'highByte writeRed setSpeed readBlue noStroke ' +
        'remoteIP transfer shutdown hangCall beginSMS ' +
        'endWrite attached maintain noCursor checkReg ' +
        'checkPUK shiftOut isValid shiftIn pulseIn ' +
        'connect println localIP pinMode getIMEI ' +
        'display noBlink process getBand running beginSD ' +
        'drawBMP lowByte setBand release bitRead prepare ' +
        'pointTo readRed setMode noFill remove listen ' +
        'stroke detach attach noTone exists buffer ' +
        'height bitSet circle config cursor random ' +
        'IRread setDNS endSMS getKey micros ' +
        'millis begin print write ready flush width ' +
        'isPIN blink clear press mkdir rmdir close ' +
        'point yield image BSSID click delay ' +
        'read text move peek beep rect line open ' +
        'seek fill size turn stop home find ' +
        'step tone sqrt RSSI SSID ' +
        'end bit tan cos sin pow map abs max ' +
        'min get run put',
      literal:
        'DIGITAL_MESSAGE FIRMATA_STRING ANALOG_MESSAGE ' +
        'REPORT_DIGITAL REPORT_ANALOG INPUT_PULLUP ' +
        'SET_PIN_MODE INTERNAL2V56 SYSTEM_RESET LED_BUILTIN ' +
        'INTERNAL1V1 SYSEX_START INTERNAL EXTERNAL ' +
        'DEFAULT OUTPUT INPUT HIGH LOW'
    },
    contains: [
      CPP.preprocessor,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.C_NUMBER_MODE
    ]
  };
};

/***/ }),
/* 951 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
    //local labels: %?[FB]?[AT]?\d{1,2}\w+
  return {
    case_insensitive: true,
    aliases: ['arm'],
    lexemes: '\\.?' + hljs.IDENT_RE,
    keywords: {
      meta:
        //GNU preprocs
        '.2byte .4byte .align .ascii .asciz .balign .byte .code .data .else .end .endif .endm .endr .equ .err .exitm .extern .global .hword .if .ifdef .ifndef .include .irp .long .macro .rept .req .section .set .skip .space .text .word .arm .thumb .code16 .code32 .force_thumb .thumb_func .ltorg '+
        //ARM directives
        'ALIAS ALIGN ARM AREA ASSERT ATTR CN CODE CODE16 CODE32 COMMON CP DATA DCB DCD DCDU DCDO DCFD DCFDU DCI DCQ DCQU DCW DCWU DN ELIF ELSE END ENDFUNC ENDIF ENDP ENTRY EQU EXPORT EXPORTAS EXTERN FIELD FILL FUNCTION GBLA GBLL GBLS GET GLOBAL IF IMPORT INCBIN INCLUDE INFO KEEP LCLA LCLL LCLS LTORG MACRO MAP MEND MEXIT NOFP OPT PRESERVE8 PROC QN READONLY RELOC REQUIRE REQUIRE8 RLIST FN ROUT SETA SETL SETS SN SPACE SUBT THUMB THUMBX TTL WHILE WEND ',
      built_in:
        'r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 '+ //standard registers
        'pc lr sp ip sl sb fp '+ //typical regs plus backward compatibility
        'a1 a2 a3 a4 v1 v2 v3 v4 v5 v6 v7 v8 f0 f1 f2 f3 f4 f5 f6 f7 '+ //more regs and fp
        'p0 p1 p2 p3 p4 p5 p6 p7 p8 p9 p10 p11 p12 p13 p14 p15 '+ //coprocessor regs
        'c0 c1 c2 c3 c4 c5 c6 c7 c8 c9 c10 c11 c12 c13 c14 c15 '+ //more coproc
        'q0 q1 q2 q3 q4 q5 q6 q7 q8 q9 q10 q11 q12 q13 q14 q15 '+ //advanced SIMD NEON regs

        //program status registers
        'cpsr_c cpsr_x cpsr_s cpsr_f cpsr_cx cpsr_cxs cpsr_xs cpsr_xsf cpsr_sf cpsr_cxsf '+
        'spsr_c spsr_x spsr_s spsr_f spsr_cx spsr_cxs spsr_xs spsr_xsf spsr_sf spsr_cxsf '+

        //NEON and VFP registers
        's0 s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 '+
        's16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 '+
        'd0 d1 d2 d3 d4 d5 d6 d7 d8 d9 d10 d11 d12 d13 d14 d15 '+
        'd16 d17 d18 d19 d20 d21 d22 d23 d24 d25 d26 d27 d28 d29 d30 d31 ' +

        '{PC} {VAR} {TRUE} {FALSE} {OPT} {CONFIG} {ENDIAN} {CODESIZE} {CPU} {FPU} {ARCHITECTURE} {PCSTOREOFFSET} {ARMASM_VERSION} {INTER} {ROPI} {RWPI} {SWST} {NOSWST} . @'
    },
    contains: [
      {
        className: 'keyword',
        begin: '\\b('+     //mnemonics
            'adc|'+
            '(qd?|sh?|u[qh]?)?add(8|16)?|usada?8|(q|sh?|u[qh]?)?(as|sa)x|'+
            'and|adrl?|sbc|rs[bc]|asr|b[lx]?|blx|bxj|cbn?z|tb[bh]|bic|'+
            'bfc|bfi|[su]bfx|bkpt|cdp2?|clz|clrex|cmp|cmn|cpsi[ed]|cps|'+
            'setend|dbg|dmb|dsb|eor|isb|it[te]{0,3}|lsl|lsr|ror|rrx|'+
            'ldm(([id][ab])|f[ds])?|ldr((s|ex)?[bhd])?|movt?|mvn|mra|mar|'+
            'mul|[us]mull|smul[bwt][bt]|smu[as]d|smmul|smmla|'+
            'mla|umlaal|smlal?([wbt][bt]|d)|mls|smlsl?[ds]|smc|svc|sev|'+
            'mia([bt]{2}|ph)?|mrr?c2?|mcrr2?|mrs|msr|orr|orn|pkh(tb|bt)|rbit|'+
            'rev(16|sh)?|sel|[su]sat(16)?|nop|pop|push|rfe([id][ab])?|'+
            'stm([id][ab])?|str(ex)?[bhd]?|(qd?)?sub|(sh?|q|u[qh]?)?sub(8|16)|'+
            '[su]xt(a?h|a?b(16)?)|srs([id][ab])?|swpb?|swi|smi|tst|teq|'+
            'wfe|wfi|yield'+
        ')'+
        '(eq|ne|cs|cc|mi|pl|vs|vc|hi|ls|ge|lt|gt|le|al|hs|lo)?'+ //condition codes
        '[sptrx]?' ,                                             //legal postfixes
        end: '\\s'
      },
      hljs.COMMENT('[;@]', '$', {relevance: 0}),
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        className: 'string',
        begin: '\'',
        end: '[^\\\\]\'',
        relevance: 0
      },
      {
        className: 'title',
        begin: '\\|', end: '\\|',
        illegal: '\\n',
        relevance: 0
      },
      {
        className: 'number',
        variants: [
            {begin: '[#$=]?0x[0-9a-f]+'}, //hex
            {begin: '[#$=]?0b[01]+'},     //bin
            {begin: '[#$=]\\d+'},        //literal
            {begin: '\\b\\d+'}           //bare number
        ],
        relevance: 0
      },
      {
        className: 'symbol',
        variants: [
            {begin: '^[a-z_\\.\\$][a-z0-9_\\.\\$]+'}, //ARM syntax
            {begin: '^\\s*[a-z_\\.\\$][a-z0-9_\\.\\$]+:'}, //GNU ARM syntax
            {begin: '[=#]\\w+' }  //label reference
        ],
        relevance: 0
      }
    ]
  };
};

/***/ }),
/* 952 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var XML_IDENT_RE = '[A-Za-z0-9\\._:-]+';
  var TAG_INTERNALS = {
    endsWithParent: true,
    illegal: /</,
    relevance: 0,
    contains: [
      {
        className: 'attr',
        begin: XML_IDENT_RE,
        relevance: 0
      },
      {
        begin: /=\s*/,
        relevance: 0,
        contains: [
          {
            className: 'string',
            endsParent: true,
            variants: [
              {begin: /"/, end: /"/},
              {begin: /'/, end: /'/},
              {begin: /[^\s"'=<>`]+/}
            ]
          }
        ]
      }
    ]
  };
  return {
    aliases: ['html', 'xhtml', 'rss', 'atom', 'xjb', 'xsd', 'xsl', 'plist'],
    case_insensitive: true,
    contains: [
      {
        className: 'meta',
        begin: '<!DOCTYPE', end: '>',
        relevance: 10,
        contains: [{begin: '\\[', end: '\\]'}]
      },
      hljs.COMMENT(
        '<!--',
        '-->',
        {
          relevance: 10
        }
      ),
      {
        begin: '<\\!\\[CDATA\\[', end: '\\]\\]>',
        relevance: 10
      },
      {
        begin: /<\?(php)?/, end: /\?>/,
        subLanguage: 'php',
        contains: [{begin: '/\\*', end: '\\*/', skip: true}]
      },
      {
        className: 'tag',
        /*
        The lookahead pattern (?=...) ensures that 'begin' only matches
        '<style' as a single word, followed by a whitespace or an
        ending braket. The '$' is needed for the lexeme to be recognized
        by hljs.subMode() that tests lexemes outside the stream.
        */
        begin: '<style(?=\\s|>|$)', end: '>',
        keywords: {name: 'style'},
        contains: [TAG_INTERNALS],
        starts: {
          end: '</style>', returnEnd: true,
          subLanguage: ['css', 'xml']
        }
      },
      {
        className: 'tag',
        // See the comment in the <style tag about the lookahead pattern
        begin: '<script(?=\\s|>|$)', end: '>',
        keywords: {name: 'script'},
        contains: [TAG_INTERNALS],
        starts: {
          end: '\<\/script\>', returnEnd: true,
          subLanguage: ['actionscript', 'javascript', 'handlebars', 'xml']
        }
      },
      {
        className: 'meta',
        variants: [
          {begin: /<\?xml/, end: /\?>/, relevance: 10},
          {begin: /<\?\w+/, end: /\?>/}
        ]
      },
      {
        className: 'tag',
        begin: '</?', end: '/?>',
        contains: [
          {
            className: 'name', begin: /[^\/><\s]+/, relevance: 0
          },
          TAG_INTERNALS
        ]
      }
    ]
  };
};

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    aliases: ['adoc'],
    contains: [
      // block comment
      hljs.COMMENT(
        '^/{4,}\\n',
        '\\n/{4,}$',
        // can also be done as...
        //'^/{4,}$',
        //'^/{4,}$',
        {
          relevance: 10
        }
      ),
      // line comment
      hljs.COMMENT(
        '^//',
        '$',
        {
          relevance: 0
        }
      ),
      // title
      {
        className: 'title',
        begin: '^\\.\\w.*$'
      },
      // example, admonition & sidebar blocks
      {
        begin: '^[=\\*]{4,}\\n',
        end: '\\n^[=\\*]{4,}$',
        relevance: 10
      },
      // headings
      {
        className: 'section',
        relevance: 10,
        variants: [
          {begin: '^(={1,5}) .+?( \\1)?$'},
          {begin: '^[^\\[\\]\\n]+?\\n[=\\-~\\^\\+]{2,}$'},
        ]
      },
      // document attributes
      {
        className: 'meta',
        begin: '^:.+?:',
        end: '\\s',
        excludeEnd: true,
        relevance: 10
      },
      // block attributes
      {
        className: 'meta',
        begin: '^\\[.+?\\]$',
        relevance: 0
      },
      // quoteblocks
      {
        className: 'quote',
        begin: '^_{4,}\\n',
        end: '\\n_{4,}$',
        relevance: 10
      },
      // listing and literal blocks
      {
        className: 'code',
        begin: '^[\\-\\.]{4,}\\n',
        end: '\\n[\\-\\.]{4,}$',
        relevance: 10
      },
      // passthrough blocks
      {
        begin: '^\\+{4,}\\n',
        end: '\\n\\+{4,}$',
        contains: [
          {
            begin: '<', end: '>',
            subLanguage: 'xml',
            relevance: 0
          }
        ],
        relevance: 10
      },
      // lists (can only capture indicators)
      {
        className: 'bullet',
        begin: '^(\\*+|\\-+|\\.+|[^\\n]+?::)\\s+'
      },
      // admonition
      {
        className: 'symbol',
        begin: '^(NOTE|TIP|IMPORTANT|WARNING|CAUTION):\\s+',
        relevance: 10
      },
      // inline strong
      {
        className: 'strong',
        // must not follow a word character or be followed by an asterisk or space
        begin: '\\B\\*(?![\\*\\s])',
        end: '(\\n{2}|\\*)',
        // allow escaped asterisk followed by word char
        contains: [
          {
            begin: '\\\\*\\w',
            relevance: 0
          }
        ]
      },
      // inline emphasis
      {
        className: 'emphasis',
        // must not follow a word character or be followed by a single quote or space
        begin: '\\B\'(?![\'\\s])',
        end: '(\\n{2}|\')',
        // allow escaped single quote followed by word char
        contains: [
          {
            begin: '\\\\\'\\w',
            relevance: 0
          }
        ],
        relevance: 0
      },
      // inline emphasis (alt)
      {
        className: 'emphasis',
        // must not follow a word character or be followed by an underline or space
        begin: '_(?![_\\s])',
        end: '(\\n{2}|_)',
        relevance: 0
      },
      // inline smart quotes
      {
        className: 'string',
        variants: [
          {begin: "``.+?''"},
          {begin: "`.+?'"}
        ]
      },
      // inline code snippets (TODO should get same treatment as strong and emphasis)
      {
        className: 'code',
        begin: '(`.+?`|\\+.+?\\+)',
        relevance: 0
      },
      // indented literal block
      {
        className: 'code',
        begin: '^[ \\t]',
        end: '$',
        relevance: 0
      },
      // horizontal rules
      {
        begin: '^\'{3,}[ \\t]*$',
        relevance: 10
      },
      // images and links
      {
        begin: '(link:)?(http|https|ftp|file|irc|image:?):\\S+\\[.*?\\]',
        returnBegin: true,
        contains: [
          {
            begin: '(link|image:?):',
            relevance: 0
          },
          {
            className: 'link',
            begin: '\\w',
            end: '[^\\[]+',
            relevance: 0
          },
          {
            className: 'string',
            begin: '\\[',
            end: '\\]',
            excludeBegin: true,
            excludeEnd: true,
            relevance: 0
          }
        ],
        relevance: 10
      }
    ]
  };
};

/***/ }),
/* 954 */
/***/ (function(module, exports) {

module.exports = function (hljs) {
  var KEYWORDS =
    'false synchronized int abstract float private char boolean static null if const ' +
    'for true while long throw strictfp finally protected import native final return void ' +
    'enum else extends implements break transient new catch instanceof byte super volatile case ' +
    'assert short package default double public try this switch continue throws privileged ' +
    'aspectOf adviceexecution proceed cflowbelow cflow initialization preinitialization ' +
    'staticinitialization withincode target within execution getWithinTypeName handler ' +
    'thisJoinPoint thisJoinPointStaticPart thisEnclosingJoinPointStaticPart declare parents '+
    'warning error soft precedence thisAspectInstance';
  var SHORTKEYS = 'get set args call';
  return {
    keywords : KEYWORDS,
    illegal : /<\/|#/,
    contains : [
      hljs.COMMENT(
        '/\\*\\*',
        '\\*/',
        {
          relevance : 0,
          contains : [
            {
              // eat up @'s in emails to prevent them to be recognized as doctags
              begin: /\w+@/, relevance: 0
            },
            {
              className : 'doctag',
              begin : '@[A-Za-z]+'
            }
          ]
        }
      ),
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        className : 'class',
        beginKeywords : 'aspect',
        end : /[{;=]/,
        excludeEnd : true,
        illegal : /[:;"\[\]]/,
        contains : [
          {
            beginKeywords : 'extends implements pertypewithin perthis pertarget percflowbelow percflow issingleton'
          },
          hljs.UNDERSCORE_TITLE_MODE,
          {
            begin : /\([^\)]*/,
            end : /[)]+/,
            keywords : KEYWORDS + ' ' + SHORTKEYS,
            excludeEnd : false
          }
        ]
      },
      {
        className : 'class',
        beginKeywords : 'class interface',
        end : /[{;=]/,
        excludeEnd : true,
        relevance: 0,
        keywords : 'class interface',
        illegal : /[:"\[\]]/,
        contains : [
          {beginKeywords : 'extends implements'},
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        // AspectJ Constructs
        beginKeywords : 'pointcut after before around throwing returning',
        end : /[)]/,
        excludeEnd : false,
        illegal : /["\[\]]/,
        contains : [
          {
            begin : hljs.UNDERSCORE_IDENT_RE + '\\s*\\(',
            returnBegin : true,
            contains : [hljs.UNDERSCORE_TITLE_MODE]
          }
        ]
      },
      {
        begin : /[:]/,
        returnBegin : true,
        end : /[{;]/,
        relevance: 0,
        excludeEnd : false,
        keywords : KEYWORDS,
        illegal : /["\[\]]/,
        contains : [
          {
            begin : hljs.UNDERSCORE_IDENT_RE + '\\s*\\(',
            keywords : KEYWORDS + ' ' + SHORTKEYS,
            relevance: 0
          },
          hljs.QUOTE_STRING_MODE
        ]
      },
      {
        // this prevents 'new Name(...), or throw ...' from being recognized as a function definition
        beginKeywords : 'new throw',
        relevance : 0
      },
      {
        // the function class is a bit different for AspectJ compared to the Java language
        className : 'function',
        begin : /\w+ +\w+(\.)?\w+\s*\([^\)]*\)\s*((throws)[\w\s,]+)?[\{;]/,
        returnBegin : true,
        end : /[{;=]/,
        keywords : KEYWORDS,
        excludeEnd : true,
        contains : [
          {
            begin : hljs.UNDERSCORE_IDENT_RE + '\\s*\\(',
            returnBegin : true,
            relevance: 0,
            contains : [hljs.UNDERSCORE_TITLE_MODE]
          },
          {
            className : 'params',
            begin : /\(/, end : /\)/,
            relevance: 0,
            keywords : KEYWORDS,
            contains : [
              hljs.APOS_STRING_MODE,
              hljs.QUOTE_STRING_MODE,
              hljs.C_NUMBER_MODE,
              hljs.C_BLOCK_COMMENT_MODE
            ]
          },
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      hljs.C_NUMBER_MODE,
      {
        // annotation is also used in this language
        className : 'meta',
        begin : '@[A-Za-z]+'
      }
    ]
  };
};

/***/ }),
/* 955 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var BACKTICK_ESCAPE = {
    begin: '`[\\s\\S]'
  };

  return {
    case_insensitive: true,
    aliases: [ 'ahk' ],
    keywords: {
      keyword: 'Break Continue Critical Exit ExitApp Gosub Goto New OnExit Pause return SetBatchLines SetTimer Suspend Thread Throw Until ahk_id ahk_class ahk_pid ahk_exe ahk_group',
      literal: 'A|0 true false NOT AND OR',
      built_in: 'ComSpec Clipboard ClipboardAll ErrorLevel',
    },
    contains: [
      {
        className: 'built_in',
        begin: 'A_[a-zA-Z0-9]+'
      },
      BACKTICK_ESCAPE,
      hljs.inherit(hljs.QUOTE_STRING_MODE, {contains: [BACKTICK_ESCAPE]}),
      hljs.COMMENT(';', '$', {relevance: 0}),
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'number',
        begin: hljs.NUMBER_RE,
        relevance: 0
      },
      {
        className: 'subst', // FIXED
        begin: '%(?=[a-zA-Z0-9#_$@])', end: '%',
        illegal: '[^a-zA-Z0-9#_$@]'
      },
      {
        className: 'built_in',
        begin: '^\\s*\\w+\\s*,'
        //I don't really know if this is totally relevant
      },
      {
        className: 'meta', 
        begin: '^\\s*#\w+', end:'$',
        relevance: 0
      },
      {
        className: 'symbol',
        contains: [BACKTICK_ESCAPE],
        variants: [
          {begin: '^[^\\n";]+::(?!=)'},
          {begin: '^[^\\n";]+:(?!=)', relevance: 0} // zero relevance as it catches a lot of things
                                                    // followed by a single ':' in many languages
        ]
      },
      {
        // consecutive commas, not for highlighting but just for relevance
        begin: ',\\s*,'
      }
    ]
  }
};

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
    var KEYWORDS = 'ByRef Case Const ContinueCase ContinueLoop ' +
        'Default Dim Do Else ElseIf EndFunc EndIf EndSelect ' +
        'EndSwitch EndWith Enum Exit ExitLoop For Func ' +
        'Global If In Local Next ReDim Return Select Static ' +
        'Step Switch Then To Until Volatile WEnd While With',

        LITERAL = 'True False And Null Not Or',

        BUILT_IN =
          'Abs ACos AdlibRegister AdlibUnRegister Asc AscW ASin Assign ATan AutoItSetOption AutoItWinGetTitle AutoItWinSetTitle Beep Binary BinaryLen BinaryMid BinaryToString BitAND BitNOT BitOR BitRotate BitShift BitXOR BlockInput Break Call CDTray Ceiling Chr ChrW ClipGet ClipPut ConsoleRead ConsoleWrite ConsoleWriteError ControlClick ControlCommand ControlDisable ControlEnable ControlFocus ControlGetFocus ControlGetHandle ControlGetPos ControlGetText ControlHide ControlListView ControlMove ControlSend ControlSetText ControlShow ControlTreeView Cos Dec DirCopy DirCreate DirGetSize DirMove DirRemove DllCall DllCallAddress DllCallbackFree DllCallbackGetPtr DllCallbackRegister DllClose DllOpen DllStructCreate DllStructGetData DllStructGetPtr DllStructGetSize DllStructSetData DriveGetDrive DriveGetFileSystem DriveGetLabel DriveGetSerial DriveGetType DriveMapAdd DriveMapDel DriveMapGet DriveSetLabel DriveSpaceFree DriveSpaceTotal DriveStatus EnvGet EnvSet EnvUpdate Eval Execute Exp FileChangeDir FileClose FileCopy FileCreateNTFSLink FileCreateShortcut FileDelete FileExists FileFindFirstFile FileFindNextFile FileFlush FileGetAttrib FileGetEncoding FileGetLongName FileGetPos FileGetShortcut FileGetShortName FileGetSize FileGetTime FileGetVersion FileInstall FileMove FileOpen FileOpenDialog FileRead FileReadLine FileReadToArray FileRecycle FileRecycleEmpty FileSaveDialog FileSelectFolder FileSetAttrib FileSetEnd FileSetPos FileSetTime FileWrite FileWriteLine Floor FtpSetProxy FuncName GUICreate GUICtrlCreateAvi GUICtrlCreateButton GUICtrlCreateCheckbox GUICtrlCreateCombo GUICtrlCreateContextMenu GUICtrlCreateDate GUICtrlCreateDummy GUICtrlCreateEdit GUICtrlCreateGraphic GUICtrlCreateGroup GUICtrlCreateIcon GUICtrlCreateInput GUICtrlCreateLabel GUICtrlCreateList GUICtrlCreateListView GUICtrlCreateListViewItem GUICtrlCreateMenu GUICtrlCreateMenuItem GUICtrlCreateMonthCal GUICtrlCreateObj GUICtrlCreatePic GUICtrlCreateProgress GUICtrlCreateRadio GUICtrlCreateSlider GUICtrlCreateTab GUICtrlCreateTabItem GUICtrlCreateTreeView GUICtrlCreateTreeViewItem GUICtrlCreateUpdown GUICtrlDelete GUICtrlGetHandle GUICtrlGetState GUICtrlRead GUICtrlRecvMsg GUICtrlRegisterListViewSort GUICtrlSendMsg GUICtrlSendToDummy GUICtrlSetBkColor GUICtrlSetColor GUICtrlSetCursor GUICtrlSetData GUICtrlSetDefBkColor GUICtrlSetDefColor GUICtrlSetFont GUICtrlSetGraphic GUICtrlSetImage GUICtrlSetLimit GUICtrlSetOnEvent GUICtrlSetPos GUICtrlSetResizing GUICtrlSetState GUICtrlSetStyle GUICtrlSetTip GUIDelete GUIGetCursorInfo GUIGetMsg GUIGetStyle GUIRegisterMsg GUISetAccelerators GUISetBkColor GUISetCoord GUISetCursor GUISetFont GUISetHelp GUISetIcon GUISetOnEvent GUISetState GUISetStyle GUIStartGroup GUISwitch Hex HotKeySet HttpSetProxy HttpSetUserAgent HWnd InetClose InetGet InetGetInfo InetGetSize InetRead IniDelete IniRead IniReadSection IniReadSectionNames IniRenameSection IniWrite IniWriteSection InputBox Int IsAdmin IsArray IsBinary IsBool IsDeclared IsDllStruct IsFloat IsFunc IsHWnd IsInt IsKeyword IsNumber IsObj IsPtr IsString Log MemGetStats Mod MouseClick MouseClickDrag MouseDown MouseGetCursor MouseGetPos MouseMove MouseUp MouseWheel MsgBox Number ObjCreate ObjCreateInterface ObjEvent ObjGet ObjName OnAutoItExitRegister OnAutoItExitUnRegister Ping PixelChecksum PixelGetColor PixelSearch ProcessClose ProcessExists ProcessGetStats ProcessList ProcessSetPriority ProcessWait ProcessWaitClose ProgressOff ProgressOn ProgressSet Ptr Random RegDelete RegEnumKey RegEnumVal RegRead RegWrite Round Run RunAs RunAsWait RunWait Send SendKeepActive SetError SetExtended ShellExecute ShellExecuteWait Shutdown Sin Sleep SoundPlay SoundSetWaveVolume SplashImageOn SplashOff SplashTextOn Sqrt SRandom StatusbarGetText StderrRead StdinWrite StdioClose StdoutRead String StringAddCR StringCompare StringFormat StringFromASCIIArray StringInStr StringIsAlNum StringIsAlpha StringIsASCII StringIsDigit StringIsFloat StringIsInt StringIsLower StringIsSpace StringIsUpper StringIsXDigit StringLeft StringLen StringLower StringMid StringRegExp StringRegExpReplace StringReplace StringReverse StringRight StringSplit StringStripCR StringStripWS StringToASCIIArray StringToBinary StringTrimLeft StringTrimRight StringUpper Tan TCPAccept TCPCloseSocket TCPConnect TCPListen TCPNameToIP TCPRecv TCPSend TCPShutdown, UDPShutdown TCPStartup, UDPStartup TimerDiff TimerInit ToolTip TrayCreateItem TrayCreateMenu TrayGetMsg TrayItemDelete TrayItemGetHandle TrayItemGetState TrayItemGetText TrayItemSetOnEvent TrayItemSetState TrayItemSetText TraySetClick TraySetIcon TraySetOnEvent TraySetPauseIcon TraySetState TraySetToolTip TrayTip UBound UDPBind UDPCloseSocket UDPOpen UDPRecv UDPSend VarGetType WinActivate WinActive WinClose WinExists WinFlash WinGetCaretPos WinGetClassList WinGetClientSize WinGetHandle WinGetPos WinGetProcess WinGetState WinGetText WinGetTitle WinKill WinList WinMenuSelectItem WinMinimizeAll WinMinimizeAllUndo WinMove WinSetOnTop WinSetState WinSetTitle WinSetTrans WinWait',

        COMMENT = {
            variants: [
              hljs.COMMENT(';', '$', {relevance: 0}),
              hljs.COMMENT('#cs', '#ce'),
              hljs.COMMENT('#comments-start', '#comments-end')
            ]
        },

        VARIABLE = {
            begin: '\\$[A-z0-9_]+'
        },

        STRING = {
            className: 'string',
            variants: [{
                begin: /"/,
                end: /"/,
                contains: [{
                    begin: /""/,
                    relevance: 0
                }]
            }, {
                begin: /'/,
                end: /'/,
                contains: [{
                    begin: /''/,
                    relevance: 0
                }]
            }]
        },

        NUMBER = {
            variants: [hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE]
        },

        PREPROCESSOR = {
            className: 'meta',
            begin: '#',
            end: '$',
            keywords: {'meta-keyword': 'comments include include-once NoTrayIcon OnAutoItStartRegister pragma compile RequireAdmin'},
            contains: [{
                    begin: /\\\n/,
                    relevance: 0
                }, {
                    beginKeywords: 'include',
                    keywords: {'meta-keyword': 'include'},
                    end: '$',
                    contains: [
                        STRING, {
                            className: 'meta-string',
                            variants: [{
                                begin: '<',
                                end: '>'
                            }, {
                                begin: /"/,
                                end: /"/,
                                contains: [{
                                    begin: /""/,
                                    relevance: 0
                                }]
                            }, {
                                begin: /'/,
                                end: /'/,
                                contains: [{
                                    begin: /''/,
                                    relevance: 0
                                }]
                            }]
                        }
                    ]
                },
                STRING,
                COMMENT
            ]
        },

        CONSTANT = {
            className: 'symbol',
            // begin: '@',
            // end: '$',
            // keywords: 'AppDataCommonDir AppDataDir AutoItExe AutoItPID AutoItVersion AutoItX64 COM_EventObj CommonFilesDir Compiled ComputerName ComSpec CPUArch CR CRLF DesktopCommonDir DesktopDepth DesktopDir DesktopHeight DesktopRefresh DesktopWidth DocumentsCommonDir error exitCode exitMethod extended FavoritesCommonDir FavoritesDir GUI_CtrlHandle GUI_CtrlId GUI_DragFile GUI_DragId GUI_DropId GUI_WinHandle HomeDrive HomePath HomeShare HotKeyPressed HOUR IPAddress1 IPAddress2 IPAddress3 IPAddress4 KBLayout LF LocalAppDataDir LogonDNSDomain LogonDomain LogonServer MDAY MIN MON MSEC MUILang MyDocumentsDir NumParams OSArch OSBuild OSLang OSServicePack OSType OSVersion ProgramFilesDir ProgramsCommonDir ProgramsDir ScriptDir ScriptFullPath ScriptLineNumber ScriptName SEC StartMenuCommonDir StartMenuDir StartupCommonDir StartupDir SW_DISABLE SW_ENABLE SW_HIDE SW_LOCK SW_MAXIMIZE SW_MINIMIZE SW_RESTORE SW_SHOW SW_SHOWDEFAULT SW_SHOWMAXIMIZED SW_SHOWMINIMIZED SW_SHOWMINNOACTIVE SW_SHOWNA SW_SHOWNOACTIVATE SW_SHOWNORMAL SW_UNLOCK SystemDir TAB TempDir TRAY_ID TrayIconFlashing TrayIconVisible UserName UserProfileDir WDAY WindowsDir WorkingDir YDAY YEAR',
            // relevance: 5
            begin: '@[A-z0-9_]+'
        },

        FUNCTION = {
            className: 'function',
            beginKeywords: 'Func',
            end: '$',
            illegal: '\\$|\\[|%',
            contains: [
                hljs.UNDERSCORE_TITLE_MODE, {
                    className: 'params',
                    begin: '\\(',
                    end: '\\)',
                    contains: [
                        VARIABLE,
                        STRING,
                        NUMBER
                    ]
                }
            ]
        };

    return {
        case_insensitive: true,
        illegal: /\/\*/,
        keywords: {
            keyword: KEYWORDS,
            built_in: BUILT_IN,
            literal: LITERAL
        },
        contains: [
            COMMENT,
            VARIABLE,
            STRING,
            NUMBER,
            PREPROCESSOR,
            CONSTANT,
            FUNCTION
        ]
    }
};

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    case_insensitive: true,
    lexemes: '\\.?' + hljs.IDENT_RE,
    keywords: {
      keyword:
        /* mnemonic */
        'adc add adiw and andi asr bclr bld brbc brbs brcc brcs break breq brge brhc brhs ' +
        'brid brie brlo brlt brmi brne brpl brsh brtc brts brvc brvs bset bst call cbi cbr ' +
        'clc clh cli cln clr cls clt clv clz com cp cpc cpi cpse dec eicall eijmp elpm eor ' +
        'fmul fmuls fmulsu icall ijmp in inc jmp ld ldd ldi lds lpm lsl lsr mov movw mul ' +
        'muls mulsu neg nop or ori out pop push rcall ret reti rjmp rol ror sbc sbr sbrc sbrs ' +
        'sec seh sbi sbci sbic sbis sbiw sei sen ser ses set sev sez sleep spm st std sts sub ' +
        'subi swap tst wdr',
      built_in:
        /* general purpose registers */
        'r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 r16 r17 r18 r19 r20 r21 r22 ' +
        'r23 r24 r25 r26 r27 r28 r29 r30 r31 x|0 xh xl y|0 yh yl z|0 zh zl ' +
        /* IO Registers (ATMega128) */
        'ucsr1c udr1 ucsr1a ucsr1b ubrr1l ubrr1h ucsr0c ubrr0h tccr3c tccr3a tccr3b tcnt3h ' +
        'tcnt3l ocr3ah ocr3al ocr3bh ocr3bl ocr3ch ocr3cl icr3h icr3l etimsk etifr tccr1c ' +
        'ocr1ch ocr1cl twcr twdr twar twsr twbr osccal xmcra xmcrb eicra spmcsr spmcr portg ' +
        'ddrg ping portf ddrf sreg sph spl xdiv rampz eicrb eimsk gimsk gicr eifr gifr timsk ' +
        'tifr mcucr mcucsr tccr0 tcnt0 ocr0 assr tccr1a tccr1b tcnt1h tcnt1l ocr1ah ocr1al ' +
        'ocr1bh ocr1bl icr1h icr1l tccr2 tcnt2 ocr2 ocdr wdtcr sfior eearh eearl eedr eecr ' +
        'porta ddra pina portb ddrb pinb portc ddrc pinc portd ddrd pind spdr spsr spcr udr0 ' +
        'ucsr0a ucsr0b ubrr0l acsr admux adcsr adch adcl porte ddre pine pinf',
      meta:
        '.byte .cseg .db .def .device .dseg .dw .endmacro .equ .eseg .exit .include .list ' +
        '.listmac .macro .nolist .org .set'
    },
    contains: [
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.COMMENT(
        ';',
        '$',
        {
          relevance: 0
        }
      ),
      hljs.C_NUMBER_MODE, // 0x..., decimal, float
      hljs.BINARY_NUMBER_MODE, // 0b...
      {
        className: 'number',
        begin: '\\b(\\$[a-zA-Z0-9]+|0o[0-7]+)' // $..., 0o...
      },
      hljs.QUOTE_STRING_MODE,
      {
        className: 'string',
        begin: '\'', end: '[^\\\\]\'',
        illegal: '[^\\\\][^\']'
      },
      {className: 'symbol',  begin: '^[A-Za-z0-9_.$]+:'},
      {className: 'meta', begin: '#', end: '$'},
      {  // подстановка в «.macro»
        className: 'subst',
        begin: '@[0-9]+'
      }
    ]
  };
};

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var VARIABLE = {
    className: 'variable',
    variants: [
      {begin: /\$[\w\d#@][\w\d_]*/},
      {begin: /\$\{(.*?)}/}
    ]
  };
  var KEYWORDS = 'BEGIN END if else while do for in break continue delete next nextfile function func exit|10';
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE],
    variants: [
      {
        begin: /(u|b)?r?'''/, end: /'''/,
        relevance: 10
      },
      {
        begin: /(u|b)?r?"""/, end: /"""/,
        relevance: 10
      },
      {
        begin: /(u|r|ur)'/, end: /'/,
        relevance: 10
      },
      {
        begin: /(u|r|ur)"/, end: /"/,
        relevance: 10
      },
      {
        begin: /(b|br)'/, end: /'/
      },
      {
        begin: /(b|br)"/, end: /"/
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE
    ]
  };
  return {
	 keywords: {
	   keyword: KEYWORDS
    },
    contains: [
      VARIABLE,
      STRING,
      hljs.REGEXP_MODE,
      hljs.HASH_COMMENT_MODE,
      hljs.NUMBER_MODE
    ]
  }
};

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    keywords: 'false int abstract private char boolean static null if for true ' +
      'while long throw finally protected final return void enum else ' +
      'break new catch byte super case short default double public try this switch ' +
      'continue reverse firstfast firstonly forupdate nofetch sum avg minof maxof count ' +
      'order group by asc desc index hint like dispaly edit client server ttsbegin ' +
      'ttscommit str real date container anytype common div mod',
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.C_NUMBER_MODE,
      {
        className: 'meta',
        begin: '#', end: '$'
      },
      {
        className: 'class',
        beginKeywords: 'class interface', end: '{', excludeEnd: true,
        illegal: ':',
        contains: [
          {beginKeywords: 'extends implements'},
          hljs.UNDERSCORE_TITLE_MODE
        ]
      }
    ]
  };
};

/***/ }),
/* 960 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var VAR = {
    className: 'variable',
    variants: [
      {begin: /\$[\w\d#@][\w\d_]*/},
      {begin: /\$\{(.*?)}/}
    ]
  };
  var QUOTE_STRING = {
    className: 'string',
    begin: /"/, end: /"/,
    contains: [
      hljs.BACKSLASH_ESCAPE,
      VAR,
      {
        className: 'variable',
        begin: /\$\(/, end: /\)/,
        contains: [hljs.BACKSLASH_ESCAPE]
      }
    ]
  };
  var APOS_STRING = {
    className: 'string',
    begin: /'/, end: /'/
  };

  return {
    aliases: ['sh', 'zsh'],
    lexemes: /\b-?[a-z\._]+\b/,
    keywords: {
      keyword:
        'if then else elif fi for while in do done case esac function',
      literal:
        'true false',
      built_in:
        // Shell built-ins
        // http://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
        'break cd continue eval exec exit export getopts hash pwd readonly return shift test times ' +
        'trap umask unset ' +
        // Bash built-ins
        'alias bind builtin caller command declare echo enable help let local logout mapfile printf ' +
        'read readarray source type typeset ulimit unalias ' +
        // Shell modifiers
        'set shopt ' +
        // Zsh built-ins
        'autoload bg bindkey bye cap chdir clone comparguments compcall compctl compdescribe compfiles ' +
        'compgroups compquote comptags comptry compvalues dirs disable disown echotc echoti emulate ' +
        'fc fg float functions getcap getln history integer jobs kill limit log noglob popd print ' +
        'pushd pushln rehash sched setcap setopt stat suspend ttyctl unfunction unhash unlimit ' +
        'unsetopt vared wait whence where which zcompile zformat zftp zle zmodload zparseopts zprof ' +
        'zpty zregexparse zsocket zstyle ztcp',
      _:
        '-ne -eq -lt -gt -f -d -e -s -l -a' // relevance booster
    },
    contains: [
      {
        className: 'meta',
        begin: /^#![^\n]+sh\s*$/,
        relevance: 10
      },
      {
        className: 'function',
        begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
        returnBegin: true,
        contains: [hljs.inherit(hljs.TITLE_MODE, {begin: /\w[\w\d_]*/})],
        relevance: 0
      },
      hljs.HASH_COMMENT_MODE,
      QUOTE_STRING,
      APOS_STRING,
      VAR
    ]
  };
};

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    case_insensitive: true,
    illegal: '^\.',
    // Support explicitely typed variables that end with $%! or #.
    lexemes: '[a-zA-Z][a-zA-Z0-9_\$\%\!\#]*',
    keywords: {
        keyword:
          'ABS ASC AND ATN AUTO|0 BEEP BLOAD|10 BSAVE|10 CALL CALLS CDBL CHAIN CHDIR CHR$|10 CINT CIRCLE ' +
          'CLEAR CLOSE CLS COLOR COM COMMON CONT COS CSNG CSRLIN CVD CVI CVS DATA DATE$ ' +
          'DEFDBL DEFINT DEFSNG DEFSTR DEF|0 SEG USR DELETE DIM DRAW EDIT END ENVIRON ENVIRON$ ' +
          'EOF EQV ERASE ERDEV ERDEV$ ERL ERR ERROR EXP FIELD FILES FIX FOR|0 FRE GET GOSUB|10 GOTO ' +
          'HEX$ IF|0 THEN ELSE|0 INKEY$ INP INPUT INPUT# INPUT$ INSTR IMP INT IOCTL IOCTL$ KEY ON ' +
          'OFF LIST KILL LEFT$ LEN LET LINE LLIST LOAD LOC LOCATE LOF LOG LPRINT USING LSET ' +
          'MERGE MID$ MKDIR MKD$ MKI$ MKS$ MOD NAME NEW NEXT NOISE NOT OCT$ ON OR PEN PLAY STRIG OPEN OPTION ' +
          'BASE OUT PAINT PALETTE PCOPY PEEK PMAP POINT POKE POS PRINT PRINT] PSET PRESET ' +
          'PUT RANDOMIZE READ REM RENUM RESET|0 RESTORE RESUME RETURN|0 RIGHT$ RMDIR RND RSET ' +
          'RUN SAVE SCREEN SGN SHELL SIN SOUND SPACE$ SPC SQR STEP STICK STOP STR$ STRING$ SWAP ' +
          'SYSTEM TAB TAN TIME$ TIMER TROFF TRON TO USR VAL VARPTR VARPTR$ VIEW WAIT WHILE ' +
          'WEND WIDTH WINDOW WRITE XOR'
    },
    contains: [
      hljs.QUOTE_STRING_MODE,
      hljs.COMMENT('REM', '$', {relevance: 10}),
      hljs.COMMENT('\'', '$', {relevance: 0}),
      {
        // Match line numbers
        className: 'symbol',
        begin: '^[0-9]+\ ',
        relevance: 10
      },
      {
        // Match typed numeric constants (1000, 12.34!, 1.2e5, 1.5#, 1.2D2)
        className: 'number',
        begin: '\\b([0-9]+[0-9edED\.]*[#\!]?)',
        relevance: 0
      },
      {
        // Match hexadecimal numbers (&Hxxxx)
        className: 'number',
        begin: '(\&[hH][0-9a-fA-F]{1,4})'
      },
      {
        // Match octal numbers (&Oxxxxxx)
        className: 'number',
        begin: '(\&[oO][0-7]{1,6})'
      }
    ]
  };
};

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports = function(hljs){
  return {
    contains: [
      // Attribute
      {
        className: 'attribute',
        begin: /</, end: />/
      },
      // Specific
      {
        begin: /::=/,
        starts: {
          end: /$/,
          contains: [
            {
              begin: /</, end: />/
            },
            // Common
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE
          ]
        }
      }
    ]
  };
};

/***/ }),
/* 963 */
/***/ (function(module, exports) {

module.exports = function(hljs){
  var LITERAL = {
    className: 'literal',
    begin: '[\\+\\-]',
    relevance: 0
  };
  return {
    aliases: ['bf'],
    contains: [
      hljs.COMMENT(
        '[^\\[\\]\\.,\\+\\-<> \r\n]',
        '[\\[\\]\\.,\\+\\-<> \r\n]',
        {
          returnEnd: true,
          relevance: 0
        }
      ),
      {
        className: 'title',
        begin: '[\\[\\]]',
        relevance: 0
      },
      {
        className: 'string',
        begin: '[\\.,]',
        relevance: 0
      },
      {
        // this mode works as the only relevance counter
        begin: /\+\+|\-\-/, returnBegin: true,
        contains: [LITERAL]
      },
      LITERAL
    ]
  };
};

/***/ }),
/* 964 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var KEYWORDS =
    'div mod in and or not xor asserterror begin case do downto else end exit for if of repeat then to ' +
    'until while with var';
  var LITERALS = 'false true';
  var COMMENT_MODES = [
    hljs.C_LINE_COMMENT_MODE,
    hljs.COMMENT(
      /\{/,
      /\}/,
      {
        relevance: 0
      }
    ),
    hljs.COMMENT(
      /\(\*/,
      /\*\)/,
      {
        relevance: 10
      }
    )
  ];
  var STRING = {
    className: 'string',
    begin: /'/, end: /'/,
    contains: [{begin: /''/}]
  };
  var CHAR_STRING = {
    className: 'string', begin: /(#\d+)+/
  };
  var DATE = {
      className: 'number',
      begin: '\\b\\d+(\\.\\d+)?(DT|D|T)',
      relevance: 0
  };
  var DBL_QUOTED_VARIABLE = {
      className: 'string', // not a string technically but makes sense to be highlighted in the same style
      begin: '"',
      end: '"'
  };

  var PROCEDURE = {
    className: 'function',
    beginKeywords: 'procedure', end: /[:;]/,
    keywords: 'procedure|10',
    contains: [
      hljs.TITLE_MODE,
      {
        className: 'params',
        begin: /\(/, end: /\)/,
        keywords: KEYWORDS,
        contains: [STRING, CHAR_STRING]
      }
    ].concat(COMMENT_MODES)
  };

  var OBJECT = {
    className: 'class',
    begin: 'OBJECT (Table|Form|Report|Dataport|Codeunit|XMLport|MenuSuite|Page|Query) (\\d+) ([^\\r\\n]+)',
    returnBegin: true,
    contains: [
      hljs.TITLE_MODE,
        PROCEDURE
    ]
  };

  return {
    case_insensitive: true,
    keywords: { keyword: KEYWORDS, literal: LITERALS },
    illegal: /\/\*/,
    contains: [
      STRING, CHAR_STRING,
      DATE, DBL_QUOTED_VARIABLE,
      hljs.NUMBER_MODE,
      OBJECT,
      PROCEDURE
    ]
  };
};

/***/ }),
/* 965 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    aliases: ['capnp'],
    keywords: {
      keyword:
        'struct enum interface union group import using const annotation extends in of on as with from fixed',
      built_in:
        'Void Bool Int8 Int16 Int32 Int64 UInt8 UInt16 UInt32 UInt64 Float32 Float64 ' +
        'Text Data AnyPointer AnyStruct Capability List',
      literal:
        'true false'
    },
    contains: [
      hljs.QUOTE_STRING_MODE,
      hljs.NUMBER_MODE,
      hljs.HASH_COMMENT_MODE,
      {
        className: 'meta',
        begin: /@0x[\w\d]{16};/,
        illegal: /\n/
      },
      {
        className: 'symbol',
        begin: /@\d+\b/
      },
      {
        className: 'class',
        beginKeywords: 'struct enum', end: /\{/,
        illegal: /\n/,
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {
            starts: {endsWithParent: true, excludeEnd: true} // hack: eating everything after the first title
          })
        ]
      },
      {
        className: 'class',
        beginKeywords: 'interface', end: /\{/,
        illegal: /\n/,
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {
            starts: {endsWithParent: true, excludeEnd: true} // hack: eating everything after the first title
          })
        ]
      }
    ]
  };
};

/***/ }),
/* 966 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  // 2.3. Identifiers and keywords
  var KEYWORDS =
    'assembly module package import alias class interface object given value ' +
    'assign void function new of extends satisfies abstracts in out return ' +
    'break continue throw assert dynamic if else switch case for while try ' +
    'catch finally then let this outer super is exists nonempty';
  // 7.4.1 Declaration Modifiers
  var DECLARATION_MODIFIERS =
    'shared abstract formal default actual variable late native deprecated' +
    'final sealed annotation suppressWarnings small';
  // 7.4.2 Documentation
  var DOCUMENTATION =
    'doc by license see throws tagged';
  var SUBST = {
    className: 'subst', excludeBegin: true, excludeEnd: true,
    begin: /``/, end: /``/,
    keywords: KEYWORDS,
    relevance: 10
  };
  var EXPRESSIONS = [
    {
      // verbatim string
      className: 'string',
      begin: '"""',
      end: '"""',
      relevance: 10
    },
    {
      // string literal or template
      className: 'string',
      begin: '"', end: '"',
      contains: [SUBST]
    },
    {
      // character literal
      className: 'string',
      begin: "'",
      end: "'"
    },
    {
      // numeric literal
      className: 'number',
      begin: '#[0-9a-fA-F_]+|\\$[01_]+|[0-9_]+(?:\\.[0-9_](?:[eE][+-]?\\d+)?)?[kMGTPmunpf]?',
      relevance: 0
    }
  ];
  SUBST.contains = EXPRESSIONS;

  return {
    keywords: {
      keyword: KEYWORDS + ' ' + DECLARATION_MODIFIERS,
      meta: DOCUMENTATION
    },
    illegal: '\\$[^01]|#[^0-9a-fA-F]',
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.COMMENT('/\\*', '\\*/', {contains: ['self']}),
      {
        // compiler annotation
        className: 'meta',
        begin: '@[a-z]\\w*(?:\\:\"[^\"]*\")?'
      }
    ].concat(EXPRESSIONS)
  };
};

/***/ }),
/* 967 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    aliases: ['clean','icl','dcl'],
    keywords: {
      keyword:
        'if let in with where case of class instance otherwise ' +
        'implementation definition system module from import qualified as ' +
        'special code inline foreign export ccall stdcall generic derive ' +
        'infix infixl infixr',
      literal:
        'True False'
    },
    contains: [

      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.C_NUMBER_MODE,

      {begin: '->|<-[|:]?|::|#!?|>>=|\\{\\||\\|\\}|:==|=:|\\.\\.|<>|`'} // relevance booster
    ]
  };
};

/***/ }),
/* 968 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var keywords = {
    'builtin-name':
      // Clojure keywords
      'def defonce cond apply if-not if-let if not not= = < > <= >= == + / * - rem '+
      'quot neg? pos? delay? symbol? keyword? true? false? integer? empty? coll? list? '+
      'set? ifn? fn? associative? sequential? sorted? counted? reversible? number? decimal? '+
      'class? distinct? isa? float? rational? reduced? ratio? odd? even? char? seq? vector? '+
      'string? map? nil? contains? zero? instance? not-every? not-any? libspec? -> ->> .. . '+
      'inc compare do dotimes mapcat take remove take-while drop letfn drop-last take-last '+
      'drop-while while intern condp case reduced cycle split-at split-with repeat replicate '+
      'iterate range merge zipmap declare line-seq sort comparator sort-by dorun doall nthnext '+
      'nthrest partition eval doseq await await-for let agent atom send send-off release-pending-sends '+
      'add-watch mapv filterv remove-watch agent-error restart-agent set-error-handler error-handler '+
      'set-error-mode! error-mode shutdown-agents quote var fn loop recur throw try monitor-enter '+
      'monitor-exit defmacro defn defn- macroexpand macroexpand-1 for dosync and or '+
      'when when-not when-let comp juxt partial sequence memoize constantly complement identity assert '+
      'peek pop doto proxy defstruct first rest cons defprotocol cast coll deftype defrecord last butlast '+
      'sigs reify second ffirst fnext nfirst nnext defmulti defmethod meta with-meta ns in-ns create-ns import '+
      'refer keys select-keys vals key val rseq name namespace promise into transient persistent! conj! '+
      'assoc! dissoc! pop! disj! use class type num float double short byte boolean bigint biginteger '+
      'bigdec print-method print-dup throw-if printf format load compile get-in update-in pr pr-on newline '+
      'flush read slurp read-line subvec with-open memfn time re-find re-groups rand-int rand mod locking '+
      'assert-valid-fdecl alias resolve ref deref refset swap! reset! set-validator! compare-and-set! alter-meta! '+
      'reset-meta! commute get-validator alter ref-set ref-history-count ref-min-history ref-max-history ensure sync io! '+
      'new next conj set! to-array future future-call into-array aset gen-class reduce map filter find empty '+
      'hash-map hash-set sorted-map sorted-map-by sorted-set sorted-set-by vec vector seq flatten reverse assoc dissoc list '+
      'disj get union difference intersection extend extend-type extend-protocol int nth delay count concat chunk chunk-buffer '+
      'chunk-append chunk-first chunk-rest max min dec unchecked-inc-int unchecked-inc unchecked-dec-inc unchecked-dec unchecked-negate '+
      'unchecked-add-int unchecked-add unchecked-subtract-int unchecked-subtract chunk-next chunk-cons chunked-seq? prn vary-meta '+
      'lazy-seq spread list* str find-keyword keyword symbol gensym force rationalize'
   };

  var SYMBOLSTART = 'a-zA-Z_\\-!.?+*=<>&#\'';
  var SYMBOL_RE = '[' + SYMBOLSTART + '][' + SYMBOLSTART + '0-9/;:]*';
  var SIMPLE_NUMBER_RE = '[-+]?\\d+(\\.\\d+)?';

  var SYMBOL = {
    begin: SYMBOL_RE,
    relevance: 0
  };
  var NUMBER = {
    className: 'number', begin: SIMPLE_NUMBER_RE,
    relevance: 0
  };
  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null});
  var COMMENT = hljs.COMMENT(
    ';',
    '$',
    {
      relevance: 0
    }
  );
  var LITERAL = {
    className: 'literal',
    begin: /\b(true|false|nil)\b/
  };
  var COLLECTION = {
    begin: '[\\[\\{]', end: '[\\]\\}]'
  };
  var HINT = {
    className: 'comment',
    begin: '\\^' + SYMBOL_RE
  };
  var HINT_COL = hljs.COMMENT('\\^\\{', '\\}');
  var KEY = {
    className: 'symbol',
    begin: '[:]{1,2}' + SYMBOL_RE
  };
  var LIST = {
    begin: '\\(', end: '\\)'
  };
  var BODY = {
    endsWithParent: true,
    relevance: 0
  };
  var NAME = {
    keywords: keywords,
    lexemes: SYMBOL_RE,
    className: 'name', begin: SYMBOL_RE,
    starts: BODY
  };
  var DEFAULT_CONTAINS = [LIST, STRING, HINT, HINT_COL, COMMENT, KEY, COLLECTION, NUMBER, LITERAL, SYMBOL];

  LIST.contains = [hljs.COMMENT('comment', ''), NAME, BODY];
  BODY.contains = DEFAULT_CONTAINS;
  COLLECTION.contains = DEFAULT_CONTAINS;
  HINT_COL.contains = [COLLECTION];

  return {
    aliases: ['clj'],
    illegal: /\S/,
    contains: [LIST, STRING, HINT, HINT_COL, COMMENT, KEY, COLLECTION, NUMBER, LITERAL]
  }
};

/***/ }),
/* 969 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    contains: [
      {
        className: 'meta',
        begin: /^([\w.-]+|\s*#_)=>/,
        starts: {
          end: /$/,
          subLanguage: 'clojure'
        }
      }
    ]
  }
};

/***/ }),
/* 970 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    aliases: ['cmake.in'],
    case_insensitive: true,
    keywords: {
      keyword:
        'add_custom_command add_custom_target add_definitions add_dependencies ' +
        'add_executable add_library add_subdirectory add_test aux_source_directory ' +
        'break build_command cmake_minimum_required cmake_policy configure_file ' +
        'create_test_sourcelist define_property else elseif enable_language enable_testing ' +
        'endforeach endfunction endif endmacro endwhile execute_process export find_file ' +
        'find_library find_package find_path find_program fltk_wrap_ui foreach function ' +
        'get_cmake_property get_directory_property get_filename_component get_property ' +
        'get_source_file_property get_target_property get_test_property if include ' +
        'include_directories include_external_msproject include_regular_expression install ' +
        'link_directories load_cache load_command macro mark_as_advanced message option ' +
        'output_required_files project qt_wrap_cpp qt_wrap_ui remove_definitions return ' +
        'separate_arguments set set_directory_properties set_property ' +
        'set_source_files_properties set_target_properties set_tests_properties site_name ' +
        'source_group string target_link_libraries try_compile try_run unset variable_watch ' +
        'while build_name exec_program export_library_dependencies install_files ' +
        'install_programs install_targets link_libraries make_directory remove subdir_depends ' +
        'subdirs use_mangled_mesa utility_source variable_requires write_file ' +
        'qt5_use_modules qt5_use_package qt5_wrap_cpp on off true false and or ' +
        'equal less greater strless strgreater strequal matches'
    },
    contains: [
      {
        className: 'variable',
        begin: '\\${', end: '}'
      },
      hljs.HASH_COMMENT_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.NUMBER_MODE
    ]
  };
};

/***/ }),
/* 971 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var KEYWORDS = {
    keyword:
      // JS keywords
      'in if for while finally new do return else break catch instanceof throw try this ' +
      'switch continue typeof delete debugger super yield import export from as default await ' +
      // Coffee keywords
      'then unless until loop of by when and or is isnt not',
    literal:
      // JS literals
      'true false null undefined ' +
      // Coffee literals
      'yes no on off',
    built_in:
      'npm require console print module global window document'
  };
  var JS_IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
  var SUBST = {
    className: 'subst',
    begin: /#\{/, end: /}/,
    keywords: KEYWORDS
  };
  var EXPRESSIONS = [
    hljs.BINARY_NUMBER_MODE,
    hljs.inherit(hljs.C_NUMBER_MODE, {starts: {end: '(\\s*/)?', relevance: 0}}), // a number tries to eat the following slash to prevent treating it as a regexp
    {
      className: 'string',
      variants: [
        {
          begin: /'''/, end: /'''/,
          contains: [hljs.BACKSLASH_ESCAPE]
        },
        {
          begin: /'/, end: /'/,
          contains: [hljs.BACKSLASH_ESCAPE]
        },
        {
          begin: /"""/, end: /"""/,
          contains: [hljs.BACKSLASH_ESCAPE, SUBST]
        },
        {
          begin: /"/, end: /"/,
          contains: [hljs.BACKSLASH_ESCAPE, SUBST]
        }
      ]
    },
    {
      className: 'regexp',
      variants: [
        {
          begin: '///', end: '///',
          contains: [SUBST, hljs.HASH_COMMENT_MODE]
        },
        {
          begin: '//[gim]*',
          relevance: 0
        },
        {
          // regex can't start with space to parse x / 2 / 3 as two divisions
          // regex can't start with *, and it supports an "illegal" in the main mode
          begin: /\/(?![ *])(\\\/|.)*?\/[gim]*(?=\W|$)/
        }
      ]
    },
    {
      begin: '@' + JS_IDENT_RE // relevance booster
    },
    {
      subLanguage: 'javascript',
      excludeBegin: true, excludeEnd: true,
      variants: [
        {
          begin: '```', end: '```',
        },
        {
          begin: '`', end: '`',
        }
      ]
    }
  ];
  SUBST.contains = EXPRESSIONS;

  var TITLE = hljs.inherit(hljs.TITLE_MODE, {begin: JS_IDENT_RE});
  var PARAMS_RE = '(\\(.*\\))?\\s*\\B[-=]>';
  var PARAMS = {
    className: 'params',
    begin: '\\([^\\(]', returnBegin: true,
    /* We need another contained nameless mode to not have every nested
    pair of parens to be called "params" */
    contains: [{
      begin: /\(/, end: /\)/,
      keywords: KEYWORDS,
      contains: ['self'].concat(EXPRESSIONS)
    }]
  };

  return {
    aliases: ['coffee', 'cson', 'iced'],
    keywords: KEYWORDS,
    illegal: /\/\*/,
    contains: EXPRESSIONS.concat([
      hljs.COMMENT('###', '###'),
      hljs.HASH_COMMENT_MODE,
      {
        className: 'function',
        begin: '^\\s*' + JS_IDENT_RE + '\\s*=\\s*' + PARAMS_RE, end: '[-=]>',
        returnBegin: true,
        contains: [TITLE, PARAMS]
      },
      {
        // anonymous function start
        begin: /[:\(,=]\s*/,
        relevance: 0,
        contains: [
          {
            className: 'function',
            begin: PARAMS_RE, end: '[-=]>',
            returnBegin: true,
            contains: [PARAMS]
          }
        ]
      },
      {
        className: 'class',
        beginKeywords: 'class',
        end: '$',
        illegal: /[:="\[\]]/,
        contains: [
          {
            beginKeywords: 'extends',
            endsWithParent: true,
            illegal: /[:="\[\]]/,
            contains: [TITLE]
          },
          TITLE
        ]
      },
      {
        begin: JS_IDENT_RE + ':', end: ':',
        returnBegin: true, returnEnd: true,
        relevance: 0
      }
    ])
  };
};

/***/ }),
/* 972 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    keywords: {
      keyword:
        '_ as at cofix else end exists exists2 fix for forall fun if IF in let ' +
        'match mod Prop return Set then Type using where with ' +
        'Abort About Add Admit Admitted All Arguments Assumptions Axiom Back BackTo ' +
        'Backtrack Bind Blacklist Canonical Cd Check Class Classes Close Coercion ' +
        'Coercions CoFixpoint CoInductive Collection Combined Compute Conjecture ' +
        'Conjectures Constant constr Constraint Constructors Context Corollary ' +
        'CreateHintDb Cut Declare Defined Definition Delimit Dependencies Dependent' +
        'Derive Drop eauto End Equality Eval Example Existential Existentials ' +
        'Existing Export exporting Extern Extract Extraction Fact Field Fields File ' +
        'Fixpoint Focus for From Function Functional Generalizable Global Goal Grab ' +
        'Grammar Graph Guarded Heap Hint HintDb Hints Hypotheses Hypothesis ident ' +
        'Identity If Immediate Implicit Import Include Inductive Infix Info Initial ' +
        'Inline Inspect Instance Instances Intro Intros Inversion Inversion_clear ' +
        'Language Left Lemma Let Libraries Library Load LoadPath Local Locate Ltac ML ' +
        'Mode Module Modules Monomorphic Morphism Next NoInline Notation Obligation ' +
        'Obligations Opaque Open Optimize Options Parameter Parameters Parametric ' +
        'Path Paths pattern Polymorphic Preterm Print Printing Program Projections ' +
        'Proof Proposition Pwd Qed Quit Rec Record Recursive Redirect Relation Remark ' +
        'Remove Require Reserved Reset Resolve Restart Rewrite Right Ring Rings Save ' +
        'Scheme Scope Scopes Script Search SearchAbout SearchHead SearchPattern ' +
        'SearchRewrite Section Separate Set Setoid Show Solve Sorted Step Strategies ' +
        'Strategy Structure SubClass Table Tables Tactic Term Test Theorem Time ' +
        'Timeout Transparent Type Typeclasses Types Undelimit Undo Unfocus Unfocused ' +
        'Unfold Universe Universes Unset Unshelve using Variable Variables Variant ' +
        'Verbose Visibility where with',
      built_in:
        'abstract absurd admit after apply as assert assumption at auto autorewrite ' +
        'autounfold before bottom btauto by case case_eq cbn cbv change ' +
        'classical_left classical_right clear clearbody cofix compare compute ' +
        'congruence constr_eq constructor contradict contradiction cut cutrewrite ' +
        'cycle decide decompose dependent destruct destruction dintuition ' +
        'discriminate discrR do double dtauto eapply eassumption eauto ecase ' +
        'econstructor edestruct ediscriminate eelim eexact eexists einduction ' +
        'einjection eleft elim elimtype enough equality erewrite eright ' +
        'esimplify_eq esplit evar exact exactly_once exfalso exists f_equal fail ' +
        'field field_simplify field_simplify_eq first firstorder fix fold fourier ' +
        'functional generalize generalizing gfail give_up has_evar hnf idtac in ' +
        'induction injection instantiate intro intro_pattern intros intuition ' +
        'inversion inversion_clear is_evar is_var lapply lazy left lia lra move ' +
        'native_compute nia nsatz omega once pattern pose progress proof psatz quote ' +
        'record red refine reflexivity remember rename repeat replace revert ' +
        'revgoals rewrite rewrite_strat right ring ring_simplify rtauto set ' +
        'setoid_reflexivity setoid_replace setoid_rewrite setoid_symmetry ' +
        'setoid_transitivity shelve shelve_unifiable simpl simple simplify_eq solve ' +
        'specialize split split_Rabs split_Rmult stepl stepr subst sum swap ' +
        'symmetry tactic tauto time timeout top transitivity trivial try tryif ' +
        'unfold unify until using vm_compute with'
    },
    contains: [
      hljs.QUOTE_STRING_MODE,
      hljs.COMMENT('\\(\\*', '\\*\\)'),
      hljs.C_NUMBER_MODE,
      {
        className: 'type',
        excludeBegin: true,
        begin: '\\|\\s*',
        end: '\\w+'
      },
      {begin: /[-=]>/} // relevance booster
    ]
  };
};

/***/ }),
/* 973 */
/***/ (function(module, exports) {

module.exports = function cos (hljs) {

  var STRINGS = {
    className: 'string',
    variants: [
      {
        begin: '"',
        end: '"',
        contains: [{ // escaped
          begin: "\"\"",
          relevance: 0
        }]
      }
    ]
  };

  var NUMBERS = {
    className: "number",
    begin: "\\b(\\d+(\\.\\d*)?|\\.\\d+)",
    relevance: 0
  };

  var COS_KEYWORDS =
    'property parameter class classmethod clientmethod extends as break ' +
    'catch close continue do d|0 else elseif for goto halt hang h|0 if job ' +
    'j|0 kill k|0 lock l|0 merge new open quit q|0 read r|0 return set s|0 ' +
    'tcommit throw trollback try tstart use view while write w|0 xecute x|0 ' +
    'zkill znspace zn ztrap zwrite zw zzdump zzwrite print zbreak zinsert ' +
    'zload zprint zremove zsave zzprint mv mvcall mvcrt mvdim mvprint zquit ' +
    'zsync ascii';

    // registered function - no need in them due to all functions are highlighted,
    // but I'll just leave this here.

    //"$bit", "$bitcount",
    //"$bitfind", "$bitlogic", "$case", "$char", "$classmethod", "$classname",
    //"$compile", "$data", "$decimal", "$double", "$extract", "$factor",
    //"$find", "$fnumber", "$get", "$increment", "$inumber", "$isobject",
    //"$isvaliddouble", "$isvalidnum", "$justify", "$length", "$list",
    //"$listbuild", "$listdata", "$listfind", "$listfromstring", "$listget",
    //"$listlength", "$listnext", "$listsame", "$listtostring", "$listvalid",
    //"$locate", "$match", "$method", "$name", "$nconvert", "$next",
    //"$normalize", "$now", "$number", "$order", "$parameter", "$piece",
    //"$prefetchoff", "$prefetchon", "$property", "$qlength", "$qsubscript",
    //"$query", "$random", "$replace", "$reverse", "$sconvert", "$select",
    //"$sortbegin", "$sortend", "$stack", "$text", "$translate", "$view",
    //"$wascii", "$wchar", "$wextract", "$wfind", "$wiswide", "$wlength",
    //"$wreverse", "$xecute", "$zabs", "$zarccos", "$zarcsin", "$zarctan",
    //"$zcos", "$zcot", "$zcsc", "$zdate", "$zdateh", "$zdatetime",
    //"$zdatetimeh", "$zexp", "$zhex", "$zln", "$zlog", "$zpower", "$zsec",
    //"$zsin", "$zsqr", "$ztan", "$ztime", "$ztimeh", "$zboolean",
    //"$zconvert", "$zcrc", "$zcyc", "$zdascii", "$zdchar", "$zf",
    //"$ziswide", "$zlascii", "$zlchar", "$zname", "$zposition", "$zqascii",
    //"$zqchar", "$zsearch", "$zseek", "$zstrip", "$zwascii", "$zwchar",
    //"$zwidth", "$zwpack", "$zwbpack", "$zwunpack", "$zwbunpack", "$zzenkaku",
    //"$change", "$mv", "$mvat", "$mvfmt", "$mvfmts", "$mviconv",
    //"$mviconvs", "$mvinmat", "$mvlover", "$mvoconv", "$mvoconvs", "$mvraise",
    //"$mvtrans", "$mvv", "$mvname", "$zbitand", "$zbitcount", "$zbitfind",
    //"$zbitget", "$zbitlen", "$zbitnot", "$zbitor", "$zbitset", "$zbitstr",
    //"$zbitxor", "$zincrement", "$znext", "$zorder", "$zprevious", "$zsort",
    //"device", "$ecode", "$estack", "$etrap", "$halt", "$horolog",
    //"$io", "$job", "$key", "$namespace", "$principal", "$quit", "$roles",
    //"$storage", "$system", "$test", "$this", "$tlevel", "$username",
    //"$x", "$y", "$za", "$zb", "$zchild", "$zeof", "$zeos", "$zerror",
    //"$zhorolog", "$zio", "$zjob", "$zmode", "$znspace", "$zparent", "$zpi",
    //"$zpos", "$zreference", "$zstorage", "$ztimestamp", "$ztimezone",
    //"$ztrap", "$zversion"

  return {
    case_insensitive: true,
    aliases: ["cos", "cls"],
    keywords: COS_KEYWORDS,
    contains: [
      NUMBERS,
      STRINGS,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: "comment",
        begin: /;/, end: "$",
        relevance: 0
      },
      { // Functions and user-defined functions: write $ztime(60*60*3), $$myFunc(10), $$^Val(1)
        className: "built_in",
        begin: /(?:\$\$?|\.\.)\^?[a-zA-Z]+/
      },
      { // Macro command: quit $$$OK
        className: "built_in",
        begin: /\$\$\$[a-zA-Z]+/
      },
      { // Special (global) variables: write %request.Content; Built-in classes: %Library.Integer
        className: "built_in",
        begin: /%[a-z]+(?:\.[a-z]+)*/
      },
      { // Global variable: set ^globalName = 12 write ^globalName
        className: "symbol",
        begin: /\^%?[a-zA-Z][\w]*/
      },
      { // Some control constructions: do ##class(Package.ClassName).Method(), ##super()
        className: "keyword",
        begin: /##class|##super|#define|#dim/
      },

      // sub-languages: are not fully supported by hljs by 11/15/2015
      // left for the future implementation.
      {
        begin: /&sql\(/,    end: /\)/,
        excludeBegin: true, excludeEnd: true,
        subLanguage: "sql"
      },
      {
        begin: /&(js|jscript|javascript)</, end: />/,
        excludeBegin: true, excludeEnd: true,
        subLanguage: "javascript"
      },
      {
        // this brakes first and last tag, but this is the only way to embed a valid html
        begin: /&html<\s*</, end: />\s*>/,
        subLanguage: "xml"
      }
    ]
  };
};

/***/ }),
/* 974 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var RESOURCES = 'primitive rsc_template';

  var COMMANDS = 'group clone ms master location colocation order fencing_topology ' +
      'rsc_ticket acl_target acl_group user role ' +
      'tag xml';

  var PROPERTY_SETS = 'property rsc_defaults op_defaults';

  var KEYWORDS = 'params meta operations op rule attributes utilization';

  var OPERATORS = 'read write deny defined not_defined in_range date spec in ' +
      'ref reference attribute type xpath version and or lt gt tag ' +
      'lte gte eq ne \\';

  var TYPES = 'number string';

  var LITERALS = 'Master Started Slave Stopped start promote demote stop monitor true false';

  return {
    aliases: ['crm', 'pcmk'],
    case_insensitive: true,
    keywords: {
      keyword: KEYWORDS + ' ' + OPERATORS + ' ' + TYPES,
      literal: LITERALS
    },
    contains: [
      hljs.HASH_COMMENT_MODE,
      {
        beginKeywords: 'node',
        starts: {
          end: '\\s*([\\w_-]+:)?',
          starts: {
            className: 'title',
            end: '\\s*[\\$\\w_][\\w_-]*'
          }
        }
      },
      {
        beginKeywords: RESOURCES,
        starts: {
          className: 'title',
          end: '\\s*[\\$\\w_][\\w_-]*',
          starts: {
            end: '\\s*@?[\\w_][\\w_\\.:-]*'
          }
        }
      },
      {
        begin: '\\b(' + COMMANDS.split(' ').join('|') + ')\\s+',
        keywords: COMMANDS,
        starts: {
          className: 'title',
          end: '[\\$\\w_][\\w_-]*'
        }
      },
      {
        beginKeywords: PROPERTY_SETS,
        starts: {
          className: 'title',
          end: '\\s*([\\w_-]+:)?'
        }
      },
      hljs.QUOTE_STRING_MODE,
      {
        className: 'meta',
        begin: '(ocf|systemd|service|lsb):[\\w_:-]+',
        relevance: 0
      },
      {
        className: 'number',
        begin: '\\b\\d+(\\.\\d+)?(ms|s|h|m)?',
        relevance: 0
      },
      {
        className: 'literal',
        begin: '[-]?(infinity|inf)',
        relevance: 0
      },
      {
        className: 'attr',
        begin: /([A-Za-z\$_\#][\w_-]+)=/,
        relevance: 0
      },
      {
        className: 'tag',
        begin: '</?',
        end: '/?>',
        relevance: 0
      }
    ]
  };
};

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var NUM_SUFFIX = '(_[uif](8|16|32|64))?';
  var CRYSTAL_IDENT_RE = '[a-zA-Z_]\\w*[!?=]?';
  var RE_STARTER = '!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|' +
    '>>|>|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~';
  var CRYSTAL_METHOD_RE = '[a-zA-Z_]\\w*[!?=]?|[-+~]\\@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\][=?]?';
  var CRYSTAL_KEYWORDS = {
    keyword:
      'abstract alias as as? asm begin break case class def do else elsif end ensure enum extend for fun if ' +
      'include instance_sizeof is_a? lib macro module next nil? of out pointerof private protected rescue responds_to? ' +
      'return require select self sizeof struct super then type typeof union uninitialized unless until when while with yield ' +
      '__DIR__ __END_LINE__ __FILE__ __LINE__',
    literal: 'false nil true'
  };
  var SUBST = {
    className: 'subst',
    begin: '#{', end: '}',
    keywords: CRYSTAL_KEYWORDS
  };
  var EXPANSION = {
    className: 'template-variable',
    variants: [
      {begin: '\\{\\{', end: '\\}\\}'},
      {begin: '\\{%', end: '%\\}'}
    ],
    keywords: CRYSTAL_KEYWORDS
  };

  function recursiveParen(begin, end) {
    var
    contains = [{begin: begin, end: end}];
    contains[0].contains = contains;
    return contains;
  }
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, SUBST],
    variants: [
      {begin: /'/, end: /'/},
      {begin: /"/, end: /"/},
      {begin: /`/, end: /`/},
      {begin: '%w?\\(', end: '\\)', contains: recursiveParen('\\(', '\\)')},
      {begin: '%w?\\[', end: '\\]', contains: recursiveParen('\\[', '\\]')},
      {begin: '%w?{', end: '}', contains: recursiveParen('{', '}')},
      {begin: '%w?<', end: '>', contains: recursiveParen('<', '>')},
      {begin: '%w?/', end: '/'},
      {begin: '%w?%', end: '%'},
      {begin: '%w?-', end: '-'},
      {begin: '%w?\\|', end: '\\|'},
      {begin: /<<-\w+$/, end: /^\s*\w+$/},
    ],
    relevance: 0,
  };
  var Q_STRING = {
    className: 'string',
    variants: [
      {begin: '%q\\(', end: '\\)', contains: recursiveParen('\\(', '\\)')},
      {begin: '%q\\[', end: '\\]', contains: recursiveParen('\\[', '\\]')},
      {begin: '%q{', end: '}', contains: recursiveParen('{', '}')},
      {begin: '%q<', end: '>', contains: recursiveParen('<', '>')},
      {begin: '%q/', end: '/'},
      {begin: '%q%', end: '%'},
      {begin: '%q-', end: '-'},
      {begin: '%q\\|', end: '\\|'},
      {begin: /<<-'\w+'$/, end: /^\s*\w+$/},
    ],
    relevance: 0,
  };
  var REGEXP = {
    begin: '(' + RE_STARTER + ')\\s*',
    contains: [
      {
        className: 'regexp',
        contains: [hljs.BACKSLASH_ESCAPE, SUBST],
        variants: [
          {begin: '//[a-z]*', relevance: 0},
          {begin: '/', end: '/[a-z]*'},
          {begin: '%r\\(', end: '\\)', contains: recursiveParen('\\(', '\\)')},
          {begin: '%r\\[', end: '\\]', contains: recursiveParen('\\[', '\\]')},
          {begin: '%r{', end: '}', contains: recursiveParen('{', '}')},
          {begin: '%r<', end: '>', contains: recursiveParen('<', '>')},
          {begin: '%r/', end: '/'},
          {begin: '%r%', end: '%'},
          {begin: '%r-', end: '-'},
          {begin: '%r\\|', end: '\\|'},
        ]
      }
    ],
    relevance: 0
  };
  var REGEXP2 = {
    className: 'regexp',
    contains: [hljs.BACKSLASH_ESCAPE, SUBST],
    variants: [
      {begin: '%r\\(', end: '\\)', contains: recursiveParen('\\(', '\\)')},
      {begin: '%r\\[', end: '\\]', contains: recursiveParen('\\[', '\\]')},
      {begin: '%r{', end: '}', contains: recursiveParen('{', '}')},
      {begin: '%r<', end: '>', contains: recursiveParen('<', '>')},
      {begin: '%r/', end: '/'},
      {begin: '%r%', end: '%'},
      {begin: '%r-', end: '-'},
      {begin: '%r\\|', end: '\\|'},
    ],
    relevance: 0
  };
  var ATTRIBUTE = {
    className: 'meta',
    begin: '@\\[', end: '\\]',
    contains: [
      hljs.inherit(hljs.QUOTE_STRING_MODE, {className: 'meta-string'})
    ]
  };
  var CRYSTAL_DEFAULT_CONTAINS = [
    EXPANSION,
    STRING,
    Q_STRING,
    REGEXP,
    REGEXP2,
    ATTRIBUTE,
    hljs.HASH_COMMENT_MODE,
    {
      className: 'class',
      beginKeywords: 'class module struct', end: '$|;',
      illegal: /=/,
      contains: [
        hljs.HASH_COMMENT_MODE,
        hljs.inherit(hljs.TITLE_MODE, {begin: '[A-Za-z_]\\w*(::\\w+)*(\\?|\\!)?'}),
        {begin: '<'} // relevance booster for inheritance
      ]
    },
    {
      className: 'class',
      beginKeywords: 'lib enum union', end: '$|;',
      illegal: /=/,
      contains: [
        hljs.HASH_COMMENT_MODE,
        hljs.inherit(hljs.TITLE_MODE, {begin: '[A-Za-z_]\\w*(::\\w+)*(\\?|\\!)?'}),
      ],
      relevance: 10
    },
    {
      className: 'function',
      beginKeywords: 'def', end: /\B\b/,
      contains: [
        hljs.inherit(hljs.TITLE_MODE, {
          begin: CRYSTAL_METHOD_RE,
          endsParent: true
        })
      ]
    },
    {
      className: 'function',
      beginKeywords: 'fun macro', end: /\B\b/,
      contains: [
        hljs.inherit(hljs.TITLE_MODE, {
          begin: CRYSTAL_METHOD_RE,
          endsParent: true
        })
      ],
      relevance: 5
    },
    {
      className: 'symbol',
      begin: hljs.UNDERSCORE_IDENT_RE + '(\\!|\\?)?:',
      relevance: 0
    },
    {
      className: 'symbol',
      begin: ':',
      contains: [STRING, {begin: CRYSTAL_METHOD_RE}],
      relevance: 0
    },
    {
      className: 'number',
      variants: [
        { begin: '\\b0b([01_]*[01])' + NUM_SUFFIX },
        { begin: '\\b0o([0-7_]*[0-7])' + NUM_SUFFIX },
        { begin: '\\b0x([A-Fa-f0-9_]*[A-Fa-f0-9])' + NUM_SUFFIX },
        { begin: '\\b(([0-9][0-9_]*[0-9]|[0-9])(\\.[0-9_]*[0-9])?([eE][+-]?[0-9_]*[0-9])?)' + NUM_SUFFIX}
      ],
      relevance: 0
    }
  ];
  SUBST.contains = CRYSTAL_DEFAULT_CONTAINS;
  EXPANSION.contains = CRYSTAL_DEFAULT_CONTAINS.slice(1); // without EXPANSION

  return {
    aliases: ['cr'],
    lexemes: CRYSTAL_IDENT_RE,
    keywords: CRYSTAL_KEYWORDS,
    contains: CRYSTAL_DEFAULT_CONTAINS
  };
};

/***/ }),
/* 976 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var KEYWORDS = {
    keyword:
      // Normal keywords.
      'abstract as base bool break byte case catch char checked const continue decimal ' +
      'default delegate do double enum event explicit extern finally fixed float ' +
      'for foreach goto if implicit in int interface internal is lock long nameof ' +
      'object operator out override params private protected public readonly ref sbyte ' +
      'sealed short sizeof stackalloc static string struct switch this try typeof ' +
      'uint ulong unchecked unsafe ushort using virtual void volatile while ' +
      // Contextual keywords.
      'add alias ascending async await by descending dynamic equals from get global group into join ' +
      'let on orderby partial remove select set value var where yield',
    literal:
      'null false true'
  };

  var VERBATIM_STRING = {
    className: 'string',
    begin: '@"', end: '"',
    contains: [{begin: '""'}]
  };
  var VERBATIM_STRING_NO_LF = hljs.inherit(VERBATIM_STRING, {illegal: /\n/});
  var SUBST = {
    className: 'subst',
    begin: '{', end: '}',
    keywords: KEYWORDS
  };
  var SUBST_NO_LF = hljs.inherit(SUBST, {illegal: /\n/});
  var INTERPOLATED_STRING = {
    className: 'string',
    begin: /\$"/, end: '"',
    illegal: /\n/,
    contains: [{begin: '{{'}, {begin: '}}'}, hljs.BACKSLASH_ESCAPE, SUBST_NO_LF]
  };
  var INTERPOLATED_VERBATIM_STRING = {
    className: 'string',
    begin: /\$@"/, end: '"',
    contains: [{begin: '{{'}, {begin: '}}'}, {begin: '""'}, SUBST]
  };
  var INTERPOLATED_VERBATIM_STRING_NO_LF = hljs.inherit(INTERPOLATED_VERBATIM_STRING, {
    illegal: /\n/,
    contains: [{begin: '{{'}, {begin: '}}'}, {begin: '""'}, SUBST_NO_LF]
  });
  SUBST.contains = [
    INTERPOLATED_VERBATIM_STRING,
    INTERPOLATED_STRING,
    VERBATIM_STRING,
    hljs.APOS_STRING_MODE,
    hljs.QUOTE_STRING_MODE,
    hljs.C_NUMBER_MODE,
    hljs.C_BLOCK_COMMENT_MODE
  ];
  SUBST_NO_LF.contains = [
    INTERPOLATED_VERBATIM_STRING_NO_LF,
    INTERPOLATED_STRING,
    VERBATIM_STRING_NO_LF,
    hljs.APOS_STRING_MODE,
    hljs.QUOTE_STRING_MODE,
    hljs.C_NUMBER_MODE,
    hljs.inherit(hljs.C_BLOCK_COMMENT_MODE, {illegal: /\n/})
  ];
  var STRING = {
    variants: [
      INTERPOLATED_VERBATIM_STRING,
      INTERPOLATED_STRING,
      VERBATIM_STRING,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE
    ]
  };

  var TYPE_IDENT_RE = hljs.IDENT_RE + '(<' + hljs.IDENT_RE + '(\\s*,\\s*' + hljs.IDENT_RE + ')*>)?(\\[\\])?';

  return {
    aliases: ['csharp'],
    keywords: KEYWORDS,
    illegal: /::/,
    contains: [
      hljs.COMMENT(
        '///',
        '$',
        {
          returnBegin: true,
          contains: [
            {
              className: 'doctag',
              variants: [
                {
                  begin: '///', relevance: 0
                },
                {
                  begin: '<!--|-->'
                },
                {
                  begin: '</?', end: '>'
                }
              ]
            }
          ]
        }
      ),
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'meta',
        begin: '#', end: '$',
        keywords: {
          'meta-keyword': 'if else elif endif define undef warning error line region endregion pragma checksum'
        }
      },
      STRING,
      hljs.C_NUMBER_MODE,
      {
        beginKeywords: 'class interface', end: /[{;=]/,
        illegal: /[^\s:]/,
        contains: [
          hljs.TITLE_MODE,
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        beginKeywords: 'namespace', end: /[{;=]/,
        illegal: /[^\s:]/,
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {begin: '[a-zA-Z](\\.?\\w)*'}),
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        // [Attributes("")]
        className: 'meta',
        begin: '^\\s*\\[', excludeBegin: true, end: '\\]', excludeEnd: true,
        contains: [
          {className: 'meta-string', begin: /"/, end: /"/}
        ]
      },
      {
        // Expression keywords prevent 'keyword Name(...)' from being
        // recognized as a function definition
        beginKeywords: 'new return throw await else',
        relevance: 0
      },
      {
        className: 'function',
        begin: '(' + TYPE_IDENT_RE + '\\s+)+' + hljs.IDENT_RE + '\\s*\\(', returnBegin: true,
        end: /[{;=]/, excludeEnd: true,
        keywords: KEYWORDS,
        contains: [
          {
            begin: hljs.IDENT_RE + '\\s*\\(', returnBegin: true,
            contains: [hljs.TITLE_MODE],
            relevance: 0
          },
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            excludeBegin: true,
            excludeEnd: true,
            keywords: KEYWORDS,
            relevance: 0,
            contains: [
              STRING,
              hljs.C_NUMBER_MODE,
              hljs.C_BLOCK_COMMENT_MODE
            ]
          },
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      }
    ]
  };
};

/***/ }),
/* 977 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    case_insensitive: false,
    lexemes: '[a-zA-Z][a-zA-Z0-9_-]*',
    keywords: {
      keyword: 'base-uri child-src connect-src default-src font-src form-action' +
        ' frame-ancestors frame-src img-src media-src object-src plugin-types' +
        ' report-uri sandbox script-src style-src', 
    },
    contains: [
    {
      className: 'string',
      begin: "'", end: "'"
    },
    {
      className: 'attribute',
      begin: '^Content', end: ':', excludeEnd: true,
    },
    ]
  };
};

/***/ }),
/* 978 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var IDENT_RE = '[a-zA-Z-][a-zA-Z0-9_-]*';
  var RULE = {
    begin: /[A-Z\_\.\-]+\s*:/, returnBegin: true, end: ';', endsWithParent: true,
    contains: [
      {
        className: 'attribute',
        begin: /\S/, end: ':', excludeEnd: true,
        starts: {
          endsWithParent: true, excludeEnd: true,
          contains: [
            {
              begin: /[\w-]+\(/, returnBegin: true,
              contains: [
                {
                  className: 'built_in',
                  begin: /[\w-]+/
                },
                {
                  begin: /\(/, end: /\)/,
                  contains: [
                    hljs.APOS_STRING_MODE,
                    hljs.QUOTE_STRING_MODE
                  ]
                }
              ]
            },
            hljs.CSS_NUMBER_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.APOS_STRING_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
              className: 'number', begin: '#[0-9A-Fa-f]+'
            },
            {
              className: 'meta', begin: '!important'
            }
          ]
        }
      }
    ]
  };

  return {
    case_insensitive: true,
    illegal: /[=\/|'\$]/,
    contains: [
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'selector-id', begin: /#[A-Za-z0-9_-]+/
      },
      {
        className: 'selector-class', begin: /\.[A-Za-z0-9_-]+/
      },
      {
        className: 'selector-attr',
        begin: /\[/, end: /\]/,
        illegal: '$'
      },
      {
        className: 'selector-pseudo',
        begin: /:(:)?[a-zA-Z0-9\_\-\+\(\)"'.]+/
      },
      {
        begin: '@(font-face|page)',
        lexemes: '[a-z-]+',
        keywords: 'font-face page'
      },
      {
        begin: '@', end: '[{;]', // at_rule eating first "{" is a good thing
                                 // because it doesn’t let it to be parsed as
                                 // a rule set but instead drops parser into
                                 // the default mode which is how it should be.
        illegal: /:/, // break on Less variables @var: ...
        contains: [
          {
            className: 'keyword',
            begin: /\w+/
          },
          {
            begin: /\s/, endsWithParent: true, excludeEnd: true,
            relevance: 0,
            contains: [
              hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE,
              hljs.CSS_NUMBER_MODE
            ]
          }
        ]
      },
      {
        className: 'selector-tag', begin: IDENT_RE,
        relevance: 0
      },
      {
        begin: '{', end: '}',
        illegal: /\S/,
        contains: [
          hljs.C_BLOCK_COMMENT_MODE,
          RULE,
        ]
      }
    ]
  };
};

/***/ }),
/* 979 */
/***/ (function(module, exports) {

module.exports = /**
 * Known issues:
 *
 * - invalid hex string literals will be recognized as a double quoted strings
 *   but 'x' at the beginning of string will not be matched
 *
 * - delimited string literals are not checked for matching end delimiter
 *   (not possible to do with js regexp)
 *
 * - content of token string is colored as a string (i.e. no keyword coloring inside a token string)
 *   also, content of token string is not validated to contain only valid D tokens
 *
 * - special token sequence rule is not strictly following D grammar (anything following #line
 *   up to the end of line is matched as special token sequence)
 */

function(hljs) {
  /**
   * Language keywords
   *
   * @type {Object}
   */
  var D_KEYWORDS = {
    keyword:
      'abstract alias align asm assert auto body break byte case cast catch class ' +
      'const continue debug default delete deprecated do else enum export extern final ' +
      'finally for foreach foreach_reverse|10 goto if immutable import in inout int ' +
      'interface invariant is lazy macro mixin module new nothrow out override package ' +
      'pragma private protected public pure ref return scope shared static struct ' +
      'super switch synchronized template this throw try typedef typeid typeof union ' +
      'unittest version void volatile while with __FILE__ __LINE__ __gshared|10 ' +
      '__thread __traits __DATE__ __EOF__ __TIME__ __TIMESTAMP__ __VENDOR__ __VERSION__',
    built_in:
      'bool cdouble cent cfloat char creal dchar delegate double dstring float function ' +
      'idouble ifloat ireal long real short string ubyte ucent uint ulong ushort wchar ' +
      'wstring',
    literal:
      'false null true'
  };

  /**
   * Number literal regexps
   *
   * @type {String}
   */
  var decimal_integer_re = '(0|[1-9][\\d_]*)',
    decimal_integer_nosus_re = '(0|[1-9][\\d_]*|\\d[\\d_]*|[\\d_]+?\\d)',
    binary_integer_re = '0[bB][01_]+',
    hexadecimal_digits_re = '([\\da-fA-F][\\da-fA-F_]*|_[\\da-fA-F][\\da-fA-F_]*)',
    hexadecimal_integer_re = '0[xX]' + hexadecimal_digits_re,

    decimal_exponent_re = '([eE][+-]?' + decimal_integer_nosus_re + ')',
    decimal_float_re = '(' + decimal_integer_nosus_re + '(\\.\\d*|' + decimal_exponent_re + ')|' +
                '\\d+\\.' + decimal_integer_nosus_re + decimal_integer_nosus_re + '|' +
                '\\.' + decimal_integer_re + decimal_exponent_re + '?' +
              ')',
    hexadecimal_float_re = '(0[xX](' +
                  hexadecimal_digits_re + '\\.' + hexadecimal_digits_re + '|'+
                  '\\.?' + hexadecimal_digits_re +
                 ')[pP][+-]?' + decimal_integer_nosus_re + ')',

    integer_re = '(' +
      decimal_integer_re + '|' +
      binary_integer_re  + '|' +
       hexadecimal_integer_re   +
    ')',

    float_re = '(' +
      hexadecimal_float_re + '|' +
      decimal_float_re  +
    ')';

  /**
   * Escape sequence supported in D string and character literals
   *
   * @type {String}
   */
  var escape_sequence_re = '\\\\(' +
              '[\'"\\?\\\\abfnrtv]|' +  // common escapes
              'u[\\dA-Fa-f]{4}|' +     // four hex digit unicode codepoint
              '[0-7]{1,3}|' +       // one to three octal digit ascii char code
              'x[\\dA-Fa-f]{2}|' +    // two hex digit ascii char code
              'U[\\dA-Fa-f]{8}' +      // eight hex digit unicode codepoint
              ')|' +
              '&[a-zA-Z\\d]{2,};';      // named character entity

  /**
   * D integer number literals
   *
   * @type {Object}
   */
  var D_INTEGER_MODE = {
    className: 'number',
      begin: '\\b' + integer_re + '(L|u|U|Lu|LU|uL|UL)?',
      relevance: 0
  };

  /**
   * [D_FLOAT_MODE description]
   * @type {Object}
   */
  var D_FLOAT_MODE = {
    className: 'number',
    begin: '\\b(' +
        float_re + '([fF]|L|i|[fF]i|Li)?|' +
        integer_re + '(i|[fF]i|Li)' +
      ')',
    relevance: 0
  };

  /**
   * D character literal
   *
   * @type {Object}
   */
  var D_CHARACTER_MODE = {
    className: 'string',
    begin: '\'(' + escape_sequence_re + '|.)', end: '\'',
    illegal: '.'
  };

  /**
   * D string escape sequence
   *
   * @type {Object}
   */
  var D_ESCAPE_SEQUENCE = {
    begin: escape_sequence_re,
    relevance: 0
  };

  /**
   * D double quoted string literal
   *
   * @type {Object}
   */
  var D_STRING_MODE = {
    className: 'string',
    begin: '"',
    contains: [D_ESCAPE_SEQUENCE],
    end: '"[cwd]?'
  };

  /**
   * D wysiwyg and delimited string literals
   *
   * @type {Object}
   */
  var D_WYSIWYG_DELIMITED_STRING_MODE = {
    className: 'string',
    begin: '[rq]"',
    end: '"[cwd]?',
    relevance: 5
  };

  /**
   * D alternate wysiwyg string literal
   *
   * @type {Object}
   */
  var D_ALTERNATE_WYSIWYG_STRING_MODE = {
    className: 'string',
    begin: '`',
    end: '`[cwd]?'
  };

  /**
   * D hexadecimal string literal
   *
   * @type {Object}
   */
  var D_HEX_STRING_MODE = {
    className: 'string',
    begin: 'x"[\\da-fA-F\\s\\n\\r]*"[cwd]?',
    relevance: 10
  };

  /**
   * D delimited string literal
   *
   * @type {Object}
   */
  var D_TOKEN_STRING_MODE = {
    className: 'string',
    begin: 'q"\\{',
    end: '\\}"'
  };

  /**
   * Hashbang support
   *
   * @type {Object}
   */
  var D_HASHBANG_MODE = {
    className: 'meta',
    begin: '^#!',
    end: '$',
    relevance: 5
  };

  /**
   * D special token sequence
   *
   * @type {Object}
   */
  var D_SPECIAL_TOKEN_SEQUENCE_MODE = {
    className: 'meta',
    begin: '#(line)',
    end: '$',
    relevance: 5
  };

  /**
   * D attributes
   *
   * @type {Object}
   */
  var D_ATTRIBUTE_MODE = {
    className: 'keyword',
    begin: '@[a-zA-Z_][a-zA-Z_\\d]*'
  };

  /**
   * D nesting comment
   *
   * @type {Object}
   */
  var D_NESTING_COMMENT_MODE = hljs.COMMENT(
    '\\/\\+',
    '\\+\\/',
    {
      contains: ['self'],
      relevance: 10
    }
  );

  return {
    lexemes: hljs.UNDERSCORE_IDENT_RE,
    keywords: D_KEYWORDS,
    contains: [
      hljs.C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        D_NESTING_COMMENT_MODE,
        D_HEX_STRING_MODE,
        D_STRING_MODE,
        D_WYSIWYG_DELIMITED_STRING_MODE,
        D_ALTERNATE_WYSIWYG_STRING_MODE,
        D_TOKEN_STRING_MODE,
        D_FLOAT_MODE,
        D_INTEGER_MODE,
        D_CHARACTER_MODE,
        D_HASHBANG_MODE,
        D_SPECIAL_TOKEN_SEQUENCE_MODE,
        D_ATTRIBUTE_MODE
    ]
  };
};

/***/ }),
/* 980 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    aliases: ['md', 'mkdown', 'mkd'],
    contains: [
      // highlight headers
      {
        className: 'section',
        variants: [
          { begin: '^#{1,6}', end: '$' },
          { begin: '^.+?\\n[=-]{2,}$' }
        ]
      },
      // inline html
      {
        begin: '<', end: '>',
        subLanguage: 'xml',
        relevance: 0
      },
      // lists (indicators only)
      {
        className: 'bullet',
        begin: '^([*+-]|(\\d+\\.))\\s+'
      },
      // strong segments
      {
        className: 'strong',
        begin: '[*_]{2}.+?[*_]{2}'
      },
      // emphasis segments
      {
        className: 'emphasis',
        variants: [
          { begin: '\\*.+?\\*' },
          { begin: '_.+?_'
          , relevance: 0
          }
        ]
      },
      // blockquotes
      {
        className: 'quote',
        begin: '^>\\s+', end: '$'
      },
      // code snippets
      {
        className: 'code',
        variants: [
          {
            begin: '^```\w*\s*$', end: '^```\s*$'
          },
          {
            begin: '`.+?`'
          },
          {
            begin: '^( {4}|\t)', end: '$',
            relevance: 0
          }
        ]
      },
      // horizontal rules
      {
        begin: '^[-\\*]{3,}', end: '$'
      },
      // using links - title and link
      {
        begin: '\\[.+?\\][\\(\\[].*?[\\)\\]]',
        returnBegin: true,
        contains: [
          {
            className: 'string',
            begin: '\\[', end: '\\]',
            excludeBegin: true,
            returnEnd: true,
            relevance: 0
          },
          {
            className: 'link',
            begin: '\\]\\(', end: '\\)',
            excludeBegin: true, excludeEnd: true
          },
          {
            className: 'symbol',
            begin: '\\]\\[', end: '\\]',
            excludeBegin: true, excludeEnd: true
          }
        ],
        relevance: 10
      },
      {
        begin: /^\[[^\n]+\]:/,
        returnBegin: true,
        contains: [
          {
            className: 'symbol',
            begin: /\[/, end: /\]/,
            excludeBegin: true, excludeEnd: true
          },
          {
            className: 'link',
            begin: /:\s*/, end: /$/,
            excludeBegin: true
          }
        ]
      }
    ]
  };
};

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports = function (hljs) {
  var SUBST = {
    className: 'subst',
    begin: '\\$\\{', end: '}',
    keywords: 'true false null this is new super'
  };

  var STRING = {
    className: 'string',
    variants: [
      {
        begin: 'r\'\'\'', end: '\'\'\''
      },
      {
        begin: 'r"""', end: '"""'
      },
      {
        begin: 'r\'', end: '\'',
        illegal: '\\n'
      },
      {
        begin: 'r"', end: '"',
        illegal: '\\n'
      },
      {
        begin: '\'\'\'', end: '\'\'\'',
        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
      },
      {
        begin: '"""', end: '"""',
        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
      },
      {
        begin: '\'', end: '\'',
        illegal: '\\n',
        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
      },
      {
        begin: '"', end: '"',
        illegal: '\\n',
        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
      }
    ]
  };
  SUBST.contains = [
    hljs.C_NUMBER_MODE, STRING
  ];

  var KEYWORDS = {
    keyword: 'assert async await break case catch class const continue default do else enum extends false final ' +
      'finally for if in is new null rethrow return super switch sync this throw true try var void while with yield ' +
      'abstract as dynamic export external factory get implements import library operator part set static typedef',
    built_in:
      // dart:core
      'print Comparable DateTime Duration Function Iterable Iterator List Map Match Null Object Pattern RegExp Set ' +
      'Stopwatch String StringBuffer StringSink Symbol Type Uri bool double int num ' +
      // dart:html
      'document window querySelector querySelectorAll Element ElementList'
  };

  return {
    keywords: KEYWORDS,
    contains: [
      STRING,
      hljs.COMMENT(
        '/\\*\\*',
        '\\*/',
        {
          subLanguage: 'markdown'
        }
      ),
      hljs.COMMENT(
        '///',
        '$',
        {
          subLanguage: 'markdown'
        }
      ),
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'class',
        beginKeywords: 'class interface', end: '{', excludeEnd: true,
        contains: [
          {
            beginKeywords: 'extends implements'
          },
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      hljs.C_NUMBER_MODE,
      {
        className: 'meta', begin: '@[A-Za-z]+'
      },
      {
        begin: '=>' // No markup, just a relevance booster
      }
    ]
  }
};

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var KEYWORDS =
    'exports register file shl array record property for mod while set ally label uses raise not ' +
    'stored class safecall var interface or private static exit index inherited to else stdcall ' +
    'override shr asm far resourcestring finalization packed virtual out and protected library do ' +
    'xorwrite goto near function end div overload object unit begin string on inline repeat until ' +
    'destructor write message program with read initialization except default nil if case cdecl in ' +
    'downto threadvar of try pascal const external constructor type public then implementation ' +
    'finally published procedure absolute reintroduce operator as is abstract alias assembler ' +
    'bitpacked break continue cppdecl cvar enumerator experimental platform deprecated ' +
    'unimplemented dynamic export far16 forward generic helper implements interrupt iochecks ' +
    'local name nodefault noreturn nostackframe oldfpccall otherwise saveregisters softfloat ' +
    'specialize strict unaligned varargs ';
  var COMMENT_MODES = [
    hljs.C_LINE_COMMENT_MODE,
    hljs.COMMENT(/\{/, /\}/, {relevance: 0}),
    hljs.COMMENT(/\(\*/, /\*\)/, {relevance: 10})
  ];
  var DIRECTIVE = {
    className: 'meta',
    variants: [
      {begin: /\{\$/, end: /\}/},
      {begin: /\(\*\$/, end: /\*\)/}
    ]
  };
  var STRING = {
    className: 'string',
    begin: /'/, end: /'/,
    contains: [{begin: /''/}]
  };
  var CHAR_STRING = {
    className: 'string', begin: /(#\d+)+/
  };
  var CLASS = {
    begin: hljs.IDENT_RE + '\\s*=\\s*class\\s*\\(', returnBegin: true,
    contains: [
      hljs.TITLE_MODE
    ]
  };
  var FUNCTION = {
    className: 'function',
    beginKeywords: 'function constructor destructor procedure', end: /[:;]/,
    keywords: 'function constructor|10 destructor|10 procedure|10',
    contains: [
      hljs.TITLE_MODE,
      {
        className: 'params',
        begin: /\(/, end: /\)/,
        keywords: KEYWORDS,
        contains: [STRING, CHAR_STRING, DIRECTIVE].concat(COMMENT_MODES)
      },
      DIRECTIVE
    ].concat(COMMENT_MODES)
  };
  return {
    aliases: ['dpr', 'dfm', 'pas', 'pascal', 'freepascal', 'lazarus', 'lpr', 'lfm'],
    case_insensitive: true,
    keywords: KEYWORDS,
    illegal: /"|\$[G-Zg-z]|\/\*|<\/|\|/,
    contains: [
      STRING, CHAR_STRING,
      hljs.NUMBER_MODE,
      CLASS,
      FUNCTION,
      DIRECTIVE
    ].concat(COMMENT_MODES)
  };
};

/***/ }),
/* 983 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    aliases: ['patch'],
    contains: [
      {
        className: 'meta',
        relevance: 10,
        variants: [
          {begin: /^@@ +\-\d+,\d+ +\+\d+,\d+ +@@$/},
          {begin: /^\*\*\* +\d+,\d+ +\*\*\*\*$/},
          {begin: /^\-\-\- +\d+,\d+ +\-\-\-\-$/}
        ]
      },
      {
        className: 'comment',
        variants: [
          {begin: /Index: /, end: /$/},
          {begin: /={3,}/, end: /$/},
          {begin: /^\-{3}/, end: /$/},
          {begin: /^\*{3} /, end: /$/},
          {begin: /^\+{3}/, end: /$/},
          {begin: /\*{5}/, end: /\*{5}$/}
        ]
      },
      {
        className: 'addition',
        begin: '^\\+', end: '$'
      },
      {
        className: 'deletion',
        begin: '^\\-', end: '$'
      },
      {
        className: 'addition',
        begin: '^\\!', end: '$'
      }
    ]
  };
};

/***/ }),
/* 984 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var FILTER = {
    begin: /\|[A-Za-z]+:?/,
    keywords: {
      name:
        'truncatewords removetags linebreaksbr yesno get_digit timesince random striptags ' +
        'filesizeformat escape linebreaks length_is ljust rjust cut urlize fix_ampersands ' +
        'title floatformat capfirst pprint divisibleby add make_list unordered_list urlencode ' +
        'timeuntil urlizetrunc wordcount stringformat linenumbers slice date dictsort ' +
        'dictsortreversed default_if_none pluralize lower join center default ' +
        'truncatewords_html upper length phone2numeric wordwrap time addslashes slugify first ' +
        'escapejs force_escape iriencode last safe safeseq truncatechars localize unlocalize ' +
        'localtime utc timezone'
    },
    contains: [
      hljs.QUOTE_STRING_MODE,
      hljs.APOS_STRING_MODE
    ]
  };

  return {
    aliases: ['jinja'],
    case_insensitive: true,
    subLanguage: 'xml',
    contains: [
      hljs.COMMENT(/\{%\s*comment\s*%}/, /\{%\s*endcomment\s*%}/),
      hljs.COMMENT(/\{#/, /#}/),
      {
        className: 'template-tag',
        begin: /\{%/, end: /%}/,
        contains: [
          {
            className: 'name',
            begin: /\w+/,
            keywords: {
              name:
                'comment endcomment load templatetag ifchanged endifchanged if endif firstof for ' +
                'endfor ifnotequal endifnotequal widthratio extends include spaceless ' +
                'endspaceless regroup ifequal endifequal ssi now with cycle url filter ' +
                'endfilter debug block endblock else autoescape endautoescape csrf_token empty elif ' +
                'endwith static trans blocktrans endblocktrans get_static_prefix get_media_prefix ' +
                'plural get_current_language language get_available_languages ' +
                'get_current_language_bidi get_language_info get_language_info_list localize ' +
                'endlocalize localtime endlocaltime timezone endtimezone get_current_timezone ' +
                'verbatim'
            },
            starts: {
              endsWithParent: true,
              keywords: 'in by as',
              contains: [FILTER],
              relevance: 0
            }
          }
        ]
      },
      {
        className: 'template-variable',
        begin: /\{\{/, end: /}}/,
        contains: [FILTER]
      }
    ]
  };
};

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    aliases: ['bind', 'zone'],
    keywords: {
      keyword:
        'IN A AAAA AFSDB APL CAA CDNSKEY CDS CERT CNAME DHCID DLV DNAME DNSKEY DS HIP IPSECKEY KEY KX ' +
        'LOC MX NAPTR NS NSEC NSEC3 NSEC3PARAM PTR RRSIG RP SIG SOA SRV SSHFP TA TKEY TLSA TSIG TXT'
    },
    contains: [
      hljs.COMMENT(';', '$', {relevance: 0}),
      {
        className: 'meta',
        begin: /^\$(TTL|GENERATE|INCLUDE|ORIGIN)\b/
      },
      // IPv6
      {
        className: 'number',
        begin: '((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:)))\\b'
      },
      // IPv4
      {
        className: 'number',
        begin: '((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\b'
      },
      hljs.inherit(hljs.NUMBER_MODE, {begin: /\b\d+[dhwm]?/})
    ]
  };
};

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    aliases: ['docker'],
    case_insensitive: true,
    keywords: 'from maintainer expose env arg user onbuild stopsignal',
    contains: [
      hljs.HASH_COMMENT_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.NUMBER_MODE,
      {
        beginKeywords: 'run cmd entrypoint volume add copy workdir label healthcheck shell',
        starts: {
          end: /[^\\]\n/,
          subLanguage: 'bash'
        }
      }
    ],
    illegal: '</'
  }
};

/***/ }),
/* 987 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var COMMENT = hljs.COMMENT(
    /^\s*@?rem\b/, /$/,
    {
      relevance: 10
    }
  );
  var LABEL = {
    className: 'symbol',
    begin: '^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)',
    relevance: 0
  };
  return {
    aliases: ['bat', 'cmd'],
    case_insensitive: true,
    illegal: /\/\*/,
    keywords: {
      keyword:
        'if else goto for in do call exit not exist errorlevel defined ' +
        'equ neq lss leq gtr geq',
      built_in:
        'prn nul lpt3 lpt2 lpt1 con com4 com3 com2 com1 aux ' +
        'shift cd dir echo setlocal endlocal set pause copy ' +
        'append assoc at attrib break cacls cd chcp chdir chkdsk chkntfs cls cmd color ' +
        'comp compact convert date dir diskcomp diskcopy doskey erase fs ' +
        'find findstr format ftype graftabl help keyb label md mkdir mode more move path ' +
        'pause print popd pushd promt rd recover rem rename replace restore rmdir shift' +
        'sort start subst time title tree type ver verify vol ' +
        // winutils
        'ping net ipconfig taskkill xcopy ren del'
    },
    contains: [
      {
        className: 'variable', begin: /%%[^ ]|%[^ ]+?%|![^ ]+?!/
      },
      {
        className: 'function',
        begin: LABEL.begin, end: 'goto:eof',
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {begin: '([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*'}),
          COMMENT
        ]
      },
      {
        className: 'number', begin: '\\b\\d+',
        relevance: 0
      },
      COMMENT
    ]
  };
};

/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var QUOTED_PROPERTY = {
    className: 'string',
    begin: /"/, end: /"/
  };
  var APOS_PROPERTY = {
    className: 'string',
    begin: /'/, end: /'/
  };
  var UNQUOTED_PROPERTY = {
    className: 'string',
    begin: '[\\w-?]+:\\w+', end: '\\W',
    relevance: 0
  };
  var VALUELESS_PROPERTY = {
    className: 'string',
    begin: '\\w+-?\\w+', end: '\\W',
    relevance: 0
  };

  return {
    keywords: 'dsconfig',
    contains: [
      {
        className: 'keyword',
        begin: '^dsconfig', end: '\\s', excludeEnd: true,
        relevance: 10
      },
      {
        className: 'built_in',
        begin: '(list|create|get|set|delete)-(\\w+)', end: '\\s', excludeEnd: true,
        illegal: '!@#$%^&*()',
        relevance: 10
      },
      {
        className: 'built_in',
        begin: '--(\\w+)', end: '\\s', excludeEnd: true
      },
      QUOTED_PROPERTY,
      APOS_PROPERTY,
      UNQUOTED_PROPERTY,
      VALUELESS_PROPERTY,
      hljs.HASH_COMMENT_MODE
    ]
  };
};

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var STRINGS = {
    className: 'string',
    variants: [
      hljs.inherit(hljs.QUOTE_STRING_MODE, { begin: '((u8?|U)|L)?"' }),
      {
        begin: '(u8?|U)?R"', end: '"',
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      {
        begin: '\'\\\\?.', end: '\'',
        illegal: '.'
      }
    ]
  };

  var NUMBERS = {
    className: 'number',
    variants: [
      { begin: '\\b(\\d+(\\.\\d*)?|\\.\\d+)(u|U|l|L|ul|UL|f|F)' },
      { begin: hljs.C_NUMBER_RE }
    ],
    relevance: 0
  };

  var PREPROCESSOR = {
    className: 'meta',
    begin: '#', end: '$',
    keywords: {'meta-keyword': 'if else elif endif define undef ifdef ifndef'},
    contains: [
      {
        begin: /\\\n/, relevance: 0
      },
      {
        beginKeywords: 'include', end: '$',
        keywords: {'meta-keyword': 'include'},
        contains: [
          hljs.inherit(STRINGS, {className: 'meta-string'}),
          {
            className: 'meta-string',
            begin: '<', end: '>',
            illegal: '\\n'
          }
        ]
      },
      STRINGS,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE
    ]
  };

  var DTS_REFERENCE = {
    className: 'variable',
    begin: '\\&[a-z\\d_]*\\b'
  };

  var DTS_KEYWORD = {
    className: 'meta-keyword',
    begin: '/[a-z][a-z\\d-]*/'
  };

  var DTS_LABEL = {
    className: 'symbol',
    begin: '^\\s*[a-zA-Z_][a-zA-Z\\d_]*:'
  };

  var DTS_CELL_PROPERTY = {
    className: 'params',
    begin: '<',
    end: '>',
    contains: [
      NUMBERS,
      DTS_REFERENCE
    ]
  };

  var DTS_NODE = {
    className: 'class',
    begin: /[a-zA-Z_][a-zA-Z\d_@]*\s{/,
    end: /[{;=]/,
    returnBegin: true,
    excludeEnd: true
  };

  var DTS_ROOT_NODE = {
    className: 'class',
    begin: '/\\s*{',
    end: '};',
    relevance: 10,
    contains: [
      DTS_REFERENCE,
      DTS_KEYWORD,
      DTS_LABEL,
      DTS_NODE,
      DTS_CELL_PROPERTY,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      NUMBERS,
      STRINGS
    ]
  };

  return {
    keywords: "",
    contains: [
      DTS_ROOT_NODE,
      DTS_REFERENCE,
      DTS_KEYWORD,
      DTS_LABEL,
      DTS_NODE,
      DTS_CELL_PROPERTY,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      NUMBERS,
      STRINGS,
      PREPROCESSOR,
      {
        begin: hljs.IDENT_RE + '::',
        keywords: ""
      }
    ]
  };
};

/***/ }),
/* 990 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var EXPRESSION_KEYWORDS = 'if eq ne lt lte gt gte select default math sep';
  return {
    aliases: ['dst'],
    case_insensitive: true,
    subLanguage: 'xml',
    contains: [
      {
        className: 'template-tag',
        begin: /\{[#\/]/, end: /\}/, illegal: /;/,
        contains: [
          {
            className: 'name',
            begin: /[a-zA-Z\.-]+/,
            starts: {
              endsWithParent: true, relevance: 0,
              contains: [
                hljs.QUOTE_STRING_MODE
              ]
            }
          }
        ]
      },
      {
        className: 'template-variable',
        begin: /\{/, end: /\}/, illegal: /;/,
        keywords: EXPRESSION_KEYWORDS
      }
    ]
  };
};

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
    var commentMode = hljs.COMMENT(/\(\*/, /\*\)/);

    var nonTerminalMode = {
        className: "attribute",
        begin: /^[ ]*[a-zA-Z][a-zA-Z-]*([\s-]+[a-zA-Z][a-zA-Z]*)*/
    };

    var specialSequenceMode = {
        className: "meta",
        begin: /\?.*\?/
    };

    var ruleBodyMode = {
        begin: /=/, end: /;/,
        contains: [
            commentMode,
            specialSequenceMode,
            // terminals
            hljs.APOS_STRING_MODE, hljs.QUOTE_STRING_MODE
        ]
    };

    return {
        illegal: /\S/,
        contains: [
            commentMode,
            nonTerminalMode,
            ruleBodyMode
        ]
    };
};

/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var ELIXIR_IDENT_RE = '[a-zA-Z_][a-zA-Z0-9_]*(\\!|\\?)?';
  var ELIXIR_METHOD_RE = '[a-zA-Z_]\\w*[!?=]?|[-+~]\\@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?';
  var ELIXIR_KEYWORDS =
    'and false then defined module in return redo retry end for true self when ' +
    'next until do begin unless nil break not case cond alias while ensure or ' +
    'include use alias fn quote';
  var SUBST = {
    className: 'subst',
    begin: '#\\{', end: '}',
    lexemes: ELIXIR_IDENT_RE,
    keywords: ELIXIR_KEYWORDS
  };
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, SUBST],
    variants: [
      {
        begin: /'/, end: /'/
      },
      {
        begin: /"/, end: /"/
      }
    ]
  };
  var FUNCTION = {
    className: 'function',
    beginKeywords: 'def defp defmacro', end: /\B\b/, // the mode is ended by the title
    contains: [
      hljs.inherit(hljs.TITLE_MODE, {
        begin: ELIXIR_IDENT_RE,
        endsParent: true
      })
    ]
  };
  var CLASS = hljs.inherit(FUNCTION, {
    className: 'class',
    beginKeywords: 'defimpl defmodule defprotocol defrecord', end: /\bdo\b|$|;/
  });
  var ELIXIR_DEFAULT_CONTAINS = [
    STRING,
    hljs.HASH_COMMENT_MODE,
    CLASS,
    FUNCTION,
    {
      className: 'symbol',
      begin: ':(?!\\s)',
      contains: [STRING, {begin: ELIXIR_METHOD_RE}],
      relevance: 0
    },
    {
      className: 'symbol',
      begin: ELIXIR_IDENT_RE + ':',
      relevance: 0
    },
    {
      className: 'number',
      begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
      relevance: 0
    },
    {
      className: 'variable',
      begin: '(\\$\\W)|((\\$|\\@\\@?)(\\w+))'
    },
    {
      begin: '->'
    },
    { // regexp container
      begin: '(' + hljs.RE_STARTERS_RE + ')\\s*',
      contains: [
        hljs.HASH_COMMENT_MODE,
        {
          className: 'regexp',
          illegal: '\\n',
          contains: [hljs.BACKSLASH_ESCAPE, SUBST],
          variants: [
            {
              begin: '/', end: '/[a-z]*'
            },
            {
              begin: '%r\\[', end: '\\][a-z]*'
            }
          ]
        }
      ],
      relevance: 0
    }
  ];
  SUBST.contains = ELIXIR_DEFAULT_CONTAINS;

  return {
    lexemes: ELIXIR_IDENT_RE,
    keywords: ELIXIR_KEYWORDS,
    contains: ELIXIR_DEFAULT_CONTAINS
  };
};

/***/ }),
/* 993 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var COMMENT = {
    variants: [
      hljs.COMMENT('--', '$'),
      hljs.COMMENT(
        '{-',
        '-}',
        {
          contains: ['self']
        }
      )
    ]
  };

  var CONSTRUCTOR = {
    className: 'type',
    begin: '\\b[A-Z][\\w\']*', // TODO: other constructors (built-in, infix).
    relevance: 0
  };

  var LIST = {
    begin: '\\(', end: '\\)',
    illegal: '"',
    contains: [
      {className: 'type', begin: '\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?'},
      COMMENT
    ]
  };

  var RECORD = {
    begin: '{', end: '}',
    contains: LIST.contains
  };

  return {
    keywords:
      'let in if then else case of where module import exposing ' +
      'type alias as infix infixl infixr port effect command subscription',
    contains: [

      // Top-level constructions.

      {
        beginKeywords: 'port effect module', end: 'exposing',
        keywords: 'port effect module where command subscription exposing',
        contains: [LIST, COMMENT],
        illegal: '\\W\\.|;'
      },
      {
        begin: 'import', end: '$',
        keywords: 'import as exposing',
        contains: [LIST, COMMENT],
        illegal: '\\W\\.|;'
      },
      {
        begin: 'type', end: '$',
        keywords: 'type alias',
        contains: [CONSTRUCTOR, LIST, RECORD, COMMENT]
      },
      {
        beginKeywords: 'infix infixl infixr', end: '$',
        contains: [hljs.C_NUMBER_MODE, COMMENT]
      },
      {
        begin: 'port', end: '$',
        keywords: 'port',
        contains: [COMMENT]
      },

      // Literals and names.

      // TODO: characters.
      hljs.QUOTE_STRING_MODE,
      hljs.C_NUMBER_MODE,
      CONSTRUCTOR,
      hljs.inherit(hljs.TITLE_MODE, {begin: '^[_a-z][\\w\']*'}),
      COMMENT,

      {begin: '->|<-'} // No markup, relevance booster
    ],
    illegal: /;/
  };
};

/***/ }),
/* 994 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var RUBY_METHOD_RE = '[a-zA-Z_]\\w*[!?=]?|[-+~]\\@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?';
  var RUBY_KEYWORDS = {
    keyword:
      'and then defined module in return redo if BEGIN retry end for self when ' +
      'next until do begin unless END rescue else break undef not super class case ' +
      'require yield alias while ensure elsif or include attr_reader attr_writer attr_accessor',
    literal:
      'true false nil'
  };
  var YARDOCTAG = {
    className: 'doctag',
    begin: '@[A-Za-z]+'
  };
  var IRB_OBJECT = {
    begin: '#<', end: '>'
  };
  var COMMENT_MODES = [
    hljs.COMMENT(
      '#',
      '$',
      {
        contains: [YARDOCTAG]
      }
    ),
    hljs.COMMENT(
      '^\\=begin',
      '^\\=end',
      {
        contains: [YARDOCTAG],
        relevance: 10
      }
    ),
    hljs.COMMENT('^__END__', '\\n$')
  ];
  var SUBST = {
    className: 'subst',
    begin: '#\\{', end: '}',
    keywords: RUBY_KEYWORDS
  };
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, SUBST],
    variants: [
      {begin: /'/, end: /'/},
      {begin: /"/, end: /"/},
      {begin: /`/, end: /`/},
      {begin: '%[qQwWx]?\\(', end: '\\)'},
      {begin: '%[qQwWx]?\\[', end: '\\]'},
      {begin: '%[qQwWx]?{', end: '}'},
      {begin: '%[qQwWx]?<', end: '>'},
      {begin: '%[qQwWx]?/', end: '/'},
      {begin: '%[qQwWx]?%', end: '%'},
      {begin: '%[qQwWx]?-', end: '-'},
      {begin: '%[qQwWx]?\\|', end: '\\|'},
      {
        // \B in the beginning suppresses recognition of ?-sequences where ?
        // is the last character of a preceding identifier, as in: `func?4`
        begin: /\B\?(\\\d{1,3}|\\x[A-Fa-f0-9]{1,2}|\\u[A-Fa-f0-9]{4}|\\?\S)\b/
      },
      {
        begin: /<<(-?)\w+$/, end: /^\s*\w+$/,
      }
    ]
  };
  var PARAMS = {
    className: 'params',
    begin: '\\(', end: '\\)', endsParent: true,
    keywords: RUBY_KEYWORDS
  };

  var RUBY_DEFAULT_CONTAINS = [
    STRING,
    IRB_OBJECT,
    {
      className: 'class',
      beginKeywords: 'class module', end: '$|;',
      illegal: /=/,
      contains: [
        hljs.inherit(hljs.TITLE_MODE, {begin: '[A-Za-z_]\\w*(::\\w+)*(\\?|\\!)?'}),
        {
          begin: '<\\s*',
          contains: [{
            begin: '(' + hljs.IDENT_RE + '::)?' + hljs.IDENT_RE
          }]
        }
      ].concat(COMMENT_MODES)
    },
    {
      className: 'function',
      beginKeywords: 'def', end: '$|;',
      contains: [
        hljs.inherit(hljs.TITLE_MODE, {begin: RUBY_METHOD_RE}),
        PARAMS
      ].concat(COMMENT_MODES)
    },
    {
      // swallow namespace qualifiers before symbols
      begin: hljs.IDENT_RE + '::'
    },
    {
      className: 'symbol',
      begin: hljs.UNDERSCORE_IDENT_RE + '(\\!|\\?)?:',
      relevance: 0
    },
    {
      className: 'symbol',
      begin: ':(?!\\s)',
      contains: [STRING, {begin: RUBY_METHOD_RE}],
      relevance: 0
    },
    {
      className: 'number',
      begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
      relevance: 0
    },
    {
      begin: '(\\$\\W)|((\\$|\\@\\@?)(\\w+))' // variables
    },
    {
      className: 'params',
      begin: /\|/, end: /\|/,
      keywords: RUBY_KEYWORDS
    },
    { // regexp container
      begin: '(' + hljs.RE_STARTERS_RE + '|unless)\\s*',
      keywords: 'unless',
      contains: [
        IRB_OBJECT,
        {
          className: 'regexp',
          contains: [hljs.BACKSLASH_ESCAPE, SUBST],
          illegal: /\n/,
          variants: [
            {begin: '/', end: '/[a-z]*'},
            {begin: '%r{', end: '}[a-z]*'},
            {begin: '%r\\(', end: '\\)[a-z]*'},
            {begin: '%r!', end: '![a-z]*'},
            {begin: '%r\\[', end: '\\][a-z]*'}
          ]
        }
      ].concat(COMMENT_MODES),
      relevance: 0
    }
  ].concat(COMMENT_MODES);

  SUBST.contains = RUBY_DEFAULT_CONTAINS;
  PARAMS.contains = RUBY_DEFAULT_CONTAINS;

  var SIMPLE_PROMPT = "[>?]>";
  var DEFAULT_PROMPT = "[\\w#]+\\(\\w+\\):\\d+:\\d+>";
  var RVM_PROMPT = "(\\w+-)?\\d+\\.\\d+\\.\\d(p\\d+)?[^>]+>";

  var IRB_DEFAULT = [
    {
      begin: /^\s*=>/,
      starts: {
        end: '$', contains: RUBY_DEFAULT_CONTAINS
      }
    },
    {
      className: 'meta',
      begin: '^('+SIMPLE_PROMPT+"|"+DEFAULT_PROMPT+'|'+RVM_PROMPT+')',
      starts: {
        end: '$', contains: RUBY_DEFAULT_CONTAINS
      }
    }
  ];

  return {
    aliases: ['rb', 'gemspec', 'podspec', 'thor', 'irb'],
    keywords: RUBY_KEYWORDS,
    illegal: /\/\*/,
    contains: COMMENT_MODES.concat(IRB_DEFAULT).concat(RUBY_DEFAULT_CONTAINS)
  };
};

/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    subLanguage: 'xml',
    contains: [
      hljs.COMMENT('<%#', '%>'),
      {
        begin: '<%[%=-]?', end: '[%-]?%>',
        subLanguage: 'ruby',
        excludeBegin: true,
        excludeEnd: true
      }
    ]
  };
};

/***/ }),
/* 996 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    keywords: {
      built_in:
        'spawn spawn_link self',
      keyword:
        'after and andalso|10 band begin bnot bor bsl bsr bxor case catch cond div end fun if ' +
        'let not of or orelse|10 query receive rem try when xor'
    },
    contains: [
      {
        className: 'meta', begin: '^[0-9]+> ',
        relevance: 10
      },
      hljs.COMMENT('%', '$'),
      {
        className: 'number',
        begin: '\\b(\\d+#[a-fA-F0-9]+|\\d+(\\.\\d+)?([eE][-+]?\\d+)?)',
        relevance: 0
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        begin: '\\?(::)?([A-Z]\\w*(::)?)+'
      },
      {
        begin: '->'
      },
      {
        begin: 'ok'
      },
      {
        begin: '!'
      },
      {
        begin: '(\\b[a-z\'][a-zA-Z0-9_\']*:[a-z\'][a-zA-Z0-9_\']*)|(\\b[a-z\'][a-zA-Z0-9_\']*)',
        relevance: 0
      },
      {
        begin: '[A-Z][a-zA-Z0-9_\']*',
        relevance: 0
      }
    ]
  };
};

/***/ }),
/* 997 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var BASIC_ATOM_RE = '[a-z\'][a-zA-Z0-9_\']*';
  var FUNCTION_NAME_RE = '(' + BASIC_ATOM_RE + ':' + BASIC_ATOM_RE + '|' + BASIC_ATOM_RE + ')';
  var ERLANG_RESERVED = {
    keyword:
      'after and andalso|10 band begin bnot bor bsl bzr bxor case catch cond div end fun if ' +
      'let not of orelse|10 query receive rem try when xor',
    literal:
      'false true'
  };

  var COMMENT = hljs.COMMENT('%', '$');
  var NUMBER = {
    className: 'number',
    begin: '\\b(\\d+#[a-fA-F0-9]+|\\d+(\\.\\d+)?([eE][-+]?\\d+)?)',
    relevance: 0
  };
  var NAMED_FUN = {
    begin: 'fun\\s+' + BASIC_ATOM_RE + '/\\d+'
  };
  var FUNCTION_CALL = {
    begin: FUNCTION_NAME_RE + '\\(', end: '\\)',
    returnBegin: true,
    relevance: 0,
    contains: [
      {
        begin: FUNCTION_NAME_RE, relevance: 0
      },
      {
        begin: '\\(', end: '\\)', endsWithParent: true,
        returnEnd: true,
        relevance: 0
        // "contains" defined later
      }
    ]
  };
  var TUPLE = {
    begin: '{', end: '}',
    relevance: 0
    // "contains" defined later
  };
  var VAR1 = {
    begin: '\\b_([A-Z][A-Za-z0-9_]*)?',
    relevance: 0
  };
  var VAR2 = {
    begin: '[A-Z][a-zA-Z0-9_]*',
    relevance: 0
  };
  var RECORD_ACCESS = {
    begin: '#' + hljs.UNDERSCORE_IDENT_RE,
    relevance: 0,
    returnBegin: true,
    contains: [
      {
        begin: '#' + hljs.UNDERSCORE_IDENT_RE,
        relevance: 0
      },
      {
        begin: '{', end: '}',
        relevance: 0
        // "contains" defined later
      }
    ]
  };

  var BLOCK_STATEMENTS = {
    beginKeywords: 'fun receive if try case', end: 'end',
    keywords: ERLANG_RESERVED
  };
  BLOCK_STATEMENTS.contains = [
    COMMENT,
    NAMED_FUN,
    hljs.inherit(hljs.APOS_STRING_MODE, {className: ''}),
    BLOCK_STATEMENTS,
    FUNCTION_CALL,
    hljs.QUOTE_STRING_MODE,
    NUMBER,
    TUPLE,
    VAR1, VAR2,
    RECORD_ACCESS
  ];

  var BASIC_MODES = [
    COMMENT,
    NAMED_FUN,
    BLOCK_STATEMENTS,
    FUNCTION_CALL,
    hljs.QUOTE_STRING_MODE,
    NUMBER,
    TUPLE,
    VAR1, VAR2,
    RECORD_ACCESS
  ];
  FUNCTION_CALL.contains[1].contains = BASIC_MODES;
  TUPLE.contains = BASIC_MODES;
  RECORD_ACCESS.contains[1].contains = BASIC_MODES;

  var PARAMS = {
    className: 'params',
    begin: '\\(', end: '\\)',
    contains: BASIC_MODES
  };
  return {
    aliases: ['erl'],
    keywords: ERLANG_RESERVED,
    illegal: '(</|\\*=|\\+=|-=|/\\*|\\*/|\\(\\*|\\*\\))',
    contains: [
      {
        className: 'function',
        begin: '^' + BASIC_ATOM_RE + '\\s*\\(', end: '->',
        returnBegin: true,
        illegal: '\\(|#|//|/\\*|\\\\|:|;',
        contains: [
          PARAMS,
          hljs.inherit(hljs.TITLE_MODE, {begin: BASIC_ATOM_RE})
        ],
        starts: {
          end: ';|\\.',
          keywords: ERLANG_RESERVED,
          contains: BASIC_MODES
        }
      },
      COMMENT,
      {
        begin: '^-', end: '\\.',
        relevance: 0,
        excludeEnd: true,
        returnBegin: true,
        lexemes: '-' + hljs.IDENT_RE,
        keywords:
          '-module -record -undef -export -ifdef -ifndef -author -copyright -doc -vsn ' +
          '-import -include -include_lib -compile -define -else -endif -file -behaviour ' +
          '-behavior -spec',
        contains: [PARAMS]
      },
      NUMBER,
      hljs.QUOTE_STRING_MODE,
      RECORD_ACCESS,
      VAR1, VAR2,
      TUPLE,
      {begin: /\.$/} // relevance booster
    ]
  };
};

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    aliases: ['xlsx', 'xls'],
    case_insensitive: true,
    lexemes: /[a-zA-Z][\w\.]*/,
    // built-in functions imported from https://web.archive.org/web/20160513042710/https://support.office.com/en-us/article/Excel-functions-alphabetical-b3944572-255d-4efb-bb96-c6d90033e188
    keywords: {
        built_in: 'ABS ACCRINT ACCRINTM ACOS ACOSH ACOT ACOTH AGGREGATE ADDRESS AMORDEGRC AMORLINC AND ARABIC AREAS ASC ASIN ASINH ATAN ATAN2 ATANH AVEDEV AVERAGE AVERAGEA AVERAGEIF AVERAGEIFS BAHTTEXT BASE BESSELI BESSELJ BESSELK BESSELY BETADIST BETA.DIST BETAINV BETA.INV BIN2DEC BIN2HEX BIN2OCT BINOMDIST BINOM.DIST BINOM.DIST.RANGE BINOM.INV BITAND BITLSHIFT BITOR BITRSHIFT BITXOR CALL CEILING CEILING.MATH CEILING.PRECISE CELL CHAR CHIDIST CHIINV CHITEST CHISQ.DIST CHISQ.DIST.RT CHISQ.INV CHISQ.INV.RT CHISQ.TEST CHOOSE CLEAN CODE COLUMN COLUMNS COMBIN COMBINA COMPLEX CONCAT CONCATENATE CONFIDENCE CONFIDENCE.NORM CONFIDENCE.T CONVERT CORREL COS COSH COT COTH COUNT COUNTA COUNTBLANK COUNTIF COUNTIFS COUPDAYBS COUPDAYS COUPDAYSNC COUPNCD COUPNUM COUPPCD COVAR COVARIANCE.P COVARIANCE.S CRITBINOM CSC CSCH CUBEKPIMEMBER CUBEMEMBER CUBEMEMBERPROPERTY CUBERANKEDMEMBER CUBESET CUBESETCOUNT CUBEVALUE CUMIPMT CUMPRINC DATE DATEDIF DATEVALUE DAVERAGE DAY DAYS DAYS360 DB DBCS DCOUNT DCOUNTA DDB DEC2BIN DEC2HEX DEC2OCT DECIMAL DEGREES DELTA DEVSQ DGET DISC DMAX DMIN DOLLAR DOLLARDE DOLLARFR DPRODUCT DSTDEV DSTDEVP DSUM DURATION DVAR DVARP EDATE EFFECT ENCODEURL EOMONTH ERF ERF.PRECISE ERFC ERFC.PRECISE ERROR.TYPE EUROCONVERT EVEN EXACT EXP EXPON.DIST EXPONDIST FACT FACTDOUBLE FALSE|0 F.DIST FDIST F.DIST.RT FILTERXML FIND FINDB F.INV F.INV.RT FINV FISHER FISHERINV FIXED FLOOR FLOOR.MATH FLOOR.PRECISE FORECAST FORECAST.ETS FORECAST.ETS.CONFINT FORECAST.ETS.SEASONALITY FORECAST.ETS.STAT FORECAST.LINEAR FORMULATEXT FREQUENCY F.TEST FTEST FV FVSCHEDULE GAMMA GAMMA.DIST GAMMADIST GAMMA.INV GAMMAINV GAMMALN GAMMALN.PRECISE GAUSS GCD GEOMEAN GESTEP GETPIVOTDATA GROWTH HARMEAN HEX2BIN HEX2DEC HEX2OCT HLOOKUP HOUR HYPERLINK HYPGEOM.DIST HYPGEOMDIST IF|0 IFERROR IFNA IFS IMABS IMAGINARY IMARGUMENT IMCONJUGATE IMCOS IMCOSH IMCOT IMCSC IMCSCH IMDIV IMEXP IMLN IMLOG10 IMLOG2 IMPOWER IMPRODUCT IMREAL IMSEC IMSECH IMSIN IMSINH IMSQRT IMSUB IMSUM IMTAN INDEX INDIRECT INFO INT INTERCEPT INTRATE IPMT IRR ISBLANK ISERR ISERROR ISEVEN ISFORMULA ISLOGICAL ISNA ISNONTEXT ISNUMBER ISODD ISREF ISTEXT ISO.CEILING ISOWEEKNUM ISPMT JIS KURT LARGE LCM LEFT LEFTB LEN LENB LINEST LN LOG LOG10 LOGEST LOGINV LOGNORM.DIST LOGNORMDIST LOGNORM.INV LOOKUP LOWER MATCH MAX MAXA MAXIFS MDETERM MDURATION MEDIAN MID MIDBs MIN MINIFS MINA MINUTE MINVERSE MIRR MMULT MOD MODE MODE.MULT MODE.SNGL MONTH MROUND MULTINOMIAL MUNIT N NA NEGBINOM.DIST NEGBINOMDIST NETWORKDAYS NETWORKDAYS.INTL NOMINAL NORM.DIST NORMDIST NORMINV NORM.INV NORM.S.DIST NORMSDIST NORM.S.INV NORMSINV NOT NOW NPER NPV NUMBERVALUE OCT2BIN OCT2DEC OCT2HEX ODD ODDFPRICE ODDFYIELD ODDLPRICE ODDLYIELD OFFSET OR PDURATION PEARSON PERCENTILE.EXC PERCENTILE.INC PERCENTILE PERCENTRANK.EXC PERCENTRANK.INC PERCENTRANK PERMUT PERMUTATIONA PHI PHONETIC PI PMT POISSON.DIST POISSON POWER PPMT PRICE PRICEDISC PRICEMAT PROB PRODUCT PROPER PV QUARTILE QUARTILE.EXC QUARTILE.INC QUOTIENT RADIANS RAND RANDBETWEEN RANK.AVG RANK.EQ RANK RATE RECEIVED REGISTER.ID REPLACE REPLACEB REPT RIGHT RIGHTB ROMAN ROUND ROUNDDOWN ROUNDUP ROW ROWS RRI RSQ RTD SEARCH SEARCHB SEC SECH SECOND SERIESSUM SHEET SHEETS SIGN SIN SINH SKEW SKEW.P SLN SLOPE SMALL SQL.REQUEST SQRT SQRTPI STANDARDIZE STDEV STDEV.P STDEV.S STDEVA STDEVP STDEVPA STEYX SUBSTITUTE SUBTOTAL SUM SUMIF SUMIFS SUMPRODUCT SUMSQ SUMX2MY2 SUMX2PY2 SUMXMY2 SWITCH SYD T TAN TANH TBILLEQ TBILLPRICE TBILLYIELD T.DIST T.DIST.2T T.DIST.RT TDIST TEXT TEXTJOIN TIME TIMEVALUE T.INV T.INV.2T TINV TODAY TRANSPOSE TREND TRIM TRIMMEAN TRUE|0 TRUNC T.TEST TTEST TYPE UNICHAR UNICODE UPPER VALUE VAR VAR.P VAR.S VARA VARP VARPA VDB VLOOKUP WEBSERVICE WEEKDAY WEEKNUM WEIBULL WEIBULL.DIST WORKDAY WORKDAY.INTL XIRR XNPV XOR YEAR YEARFRAC YIELD YIELDDISC YIELDMAT Z.TEST ZTEST'
    },
    contains: [
      {
        /* matches a beginning equal sign found in Excel formula examples */ 
        begin: /^=/,
        end: /[^=]/, returnEnd: true, illegal: /=/, /* only allow single equal sign at front of line */
        relevance: 10
      },
      /* technically, there can be more than 2 letters in column names, but this prevents conflict with some keywords */
      {
        /* matches a reference to a single cell */
        className: 'symbol',
        begin: /\b[A-Z]{1,2}\d+\b/,
        end: /[^\d]/, excludeEnd: true,
        relevance: 0
      },
      {
        /* matches a reference to a range of cells */
        className: 'symbol',
        begin: /[A-Z]{0,2}\d*:[A-Z]{0,2}\d*/,
        relevance: 0
      },
      hljs.BACKSLASH_ESCAPE,
      hljs.QUOTE_STRING_MODE,
      {
        className: 'number',
        begin: hljs.NUMBER_RE + '(%)?',
        relevance: 0
      },
      /* Excel formula comments are done by putting the comment in a function call to N() */
      hljs.COMMENT(/\bN\(/,/\)/,
      {
        excludeBegin: true,
        excludeEnd: true,
        illegal: /\n/
      })
    ]
  };
};

/***/ }),
/* 999 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    contains: [
    {
      begin: /[^\u2401\u0001]+/,
      end: /[\u2401\u0001]/,
      excludeEnd: true,
      returnBegin: true,
      returnEnd: false,
      contains: [
      {
        begin: /([^\u2401\u0001=]+)/,
        end: /=([^\u2401\u0001=]+)/,
        returnEnd: true,
        returnBegin: false,
        className: 'attr'
      },
      {
        begin: /=/,
        end: /([\u2401\u0001])/,
        excludeEnd: true,
        excludeBegin: true,
        className: 'string'
      }]
    }],
    case_insensitive: true
  };
};

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

module.exports = function (hljs) {

    var CHAR = {
        className: 'string',
        begin: /'(.|\\[xXuU][a-zA-Z0-9]+)'/
    };

    var STRING = {
        className: 'string',
        variants: [
            {
                begin: '"', end: '"'
            }
        ]
    };

    var NAME = {
        className: 'title',
        begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/
    };

    var METHOD = {
        className: 'function',
        beginKeywords: 'def',
        end: /[:={\[(\n;]/,
        excludeEnd: true,
        contains: [NAME]
    };

    return {
        keywords: {
            literal: 'true false',
            keyword: 'case class def else enum if impl import in lat rel index let match namespace switch type yield with'
        },
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            CHAR,
            STRING,
            METHOD,
            hljs.C_NUMBER_MODE
        ]
    };
};

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var PARAMS = {
    className: 'params',
    begin: '\\(', end: '\\)'
  };

  var F_KEYWORDS = {
    literal: '.False. .True.',
    keyword: 'kind do while private call intrinsic where elsewhere ' +
      'type endtype endmodule endselect endinterface end enddo endif if forall endforall only contains default return stop then ' +
      'public subroutine|10 function program .and. .or. .not. .le. .eq. .ge. .gt. .lt. ' +
      'goto save else use module select case ' +
      'access blank direct exist file fmt form formatted iostat name named nextrec number opened rec recl sequential status unformatted unit ' +
      'continue format pause cycle exit ' +
      'c_null_char c_alert c_backspace c_form_feed flush wait decimal round iomsg ' +
      'synchronous nopass non_overridable pass protected volatile abstract extends import ' +
      'non_intrinsic value deferred generic final enumerator class associate bind enum ' +
      'c_int c_short c_long c_long_long c_signed_char c_size_t c_int8_t c_int16_t c_int32_t c_int64_t c_int_least8_t c_int_least16_t ' +
      'c_int_least32_t c_int_least64_t c_int_fast8_t c_int_fast16_t c_int_fast32_t c_int_fast64_t c_intmax_t C_intptr_t c_float c_double ' +
      'c_long_double c_float_complex c_double_complex c_long_double_complex c_bool c_char c_null_ptr c_null_funptr ' +
      'c_new_line c_carriage_return c_horizontal_tab c_vertical_tab iso_c_binding c_loc c_funloc c_associated  c_f_pointer ' +
      'c_ptr c_funptr iso_fortran_env character_storage_size error_unit file_storage_size input_unit iostat_end iostat_eor ' +
      'numeric_storage_size output_unit c_f_procpointer ieee_arithmetic ieee_support_underflow_control ' +
      'ieee_get_underflow_mode ieee_set_underflow_mode newunit contiguous recursive ' +
      'pad position action delim readwrite eor advance nml interface procedure namelist include sequence elemental pure ' +
      'integer real character complex logical dimension allocatable|10 parameter ' +
      'external implicit|10 none double precision assign intent optional pointer ' +
      'target in out common equivalence data',
    built_in: 'alog alog10 amax0 amax1 amin0 amin1 amod cabs ccos cexp clog csin csqrt dabs dacos dasin datan datan2 dcos dcosh ddim dexp dint ' +
      'dlog dlog10 dmax1 dmin1 dmod dnint dsign dsin dsinh dsqrt dtan dtanh float iabs idim idint idnint ifix isign max0 max1 min0 min1 sngl ' +
      'algama cdabs cdcos cdexp cdlog cdsin cdsqrt cqabs cqcos cqexp cqlog cqsin cqsqrt dcmplx dconjg derf derfc dfloat dgamma dimag dlgama ' +
      'iqint qabs qacos qasin qatan qatan2 qcmplx qconjg qcos qcosh qdim qerf qerfc qexp qgamma qimag qlgama qlog qlog10 qmax1 qmin1 qmod ' +
      'qnint qsign qsin qsinh qsqrt qtan qtanh abs acos aimag aint anint asin atan atan2 char cmplx conjg cos cosh exp ichar index int log ' +
      'log10 max min nint sign sin sinh sqrt tan tanh print write dim lge lgt lle llt mod nullify allocate deallocate ' +
      'adjustl adjustr all allocated any associated bit_size btest ceiling count cshift date_and_time digits dot_product ' +
      'eoshift epsilon exponent floor fraction huge iand ibclr ibits ibset ieor ior ishft ishftc lbound len_trim matmul ' +
      'maxexponent maxloc maxval merge minexponent minloc minval modulo mvbits nearest pack present product ' +
      'radix random_number random_seed range repeat reshape rrspacing scale scan selected_int_kind selected_real_kind ' +
      'set_exponent shape size spacing spread sum system_clock tiny transpose trim ubound unpack verify achar iachar transfer ' +
      'dble entry dprod cpu_time command_argument_count get_command get_command_argument get_environment_variable is_iostat_end ' +
      'ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode ' +
      'is_iostat_eor move_alloc new_line selected_char_kind same_type_as extends_type_of'  +
      'acosh asinh atanh bessel_j0 bessel_j1 bessel_jn bessel_y0 bessel_y1 bessel_yn erf erfc erfc_scaled gamma log_gamma hypot norm2 ' +
      'atomic_define atomic_ref execute_command_line leadz trailz storage_size merge_bits ' +
      'bge bgt ble blt dshiftl dshiftr findloc iall iany iparity image_index lcobound ucobound maskl maskr ' +
      'num_images parity popcnt poppar shifta shiftl shiftr this_image'
  };
  return {
    case_insensitive: true,
    aliases: ['f90', 'f95'],
    keywords: F_KEYWORDS,
    illegal: /\/\*/,
    contains: [
      hljs.inherit(hljs.APOS_STRING_MODE, {className: 'string', relevance: 0}),
      hljs.inherit(hljs.QUOTE_STRING_MODE, {className: 'string', relevance: 0}),
      {
        className: 'function',
        beginKeywords: 'subroutine function program',
        illegal: '[${=\\n]',
        contains: [hljs.UNDERSCORE_TITLE_MODE, PARAMS]
      },
      hljs.COMMENT('!', '$', {relevance: 0}),
      {
        className: 'number',
        begin: '(?=\\b|\\+|\\-|\\.)(?=\\.\\d|\\d)(?:\\d+)?(?:\\.?\\d*)(?:[de][+-]?\\d+)?\\b\\.?',
        relevance: 0
      }
    ]
  };
};

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var TYPEPARAM = {
    begin: '<', end: '>',
    contains: [
      hljs.inherit(hljs.TITLE_MODE, {begin: /'[a-zA-Z0-9_]+/})
    ]
  };

  return {
    aliases: ['fs'],
    keywords:
      'abstract and as assert base begin class default delegate do done ' +
      'downcast downto elif else end exception extern false finally for ' +
      'fun function global if in inherit inline interface internal lazy let ' +
      'match member module mutable namespace new null of open or ' +
      'override private public rec return sig static struct then to ' +
      'true try type upcast use val void when while with yield',
    illegal: /\/\*/,
    contains: [
      {
        // monad builder keywords (matches before non-bang kws)
        className: 'keyword',
        begin: /\b(yield|return|let|do)!/
      },
      {
        className: 'string',
        begin: '@"', end: '"',
        contains: [{begin: '""'}]
      },
      {
        className: 'string',
        begin: '"""', end: '"""'
      },
      hljs.COMMENT('\\(\\*', '\\*\\)'),
      {
        className: 'class',
        beginKeywords: 'type', end: '\\(|=|$', excludeEnd: true,
        contains: [
          hljs.UNDERSCORE_TITLE_MODE,
          TYPEPARAM
        ]
      },
      {
        className: 'meta',
        begin: '\\[<', end: '>\\]',
        relevance: 10
      },
      {
        className: 'symbol',
        begin: '\\B(\'[A-Za-z])\\b',
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      hljs.C_LINE_COMMENT_MODE,
      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
      hljs.C_NUMBER_MODE
    ]
  };
};

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

module.exports = function (hljs) {
  var KEYWORDS = {
    'keyword':
      'abort acronym acronyms alias all and assign binary card diag display ' +
      'else eq file files for free ge gt if integer le loop lt maximizing ' +
      'minimizing model models ne negative no not option options or ord ' +
      'positive prod put putpage puttl repeat sameas semicont semiint smax ' +
      'smin solve sos1 sos2 sum system table then until using while xor yes',
    'literal': 'eps inf na',
    'built-in':
      'abs arccos arcsin arctan arctan2 Beta betaReg binomial ceil centropy ' +
      'cos cosh cvPower div div0 eDist entropy errorf execSeed exp fact ' +
      'floor frac gamma gammaReg log logBeta logGamma log10 log2 mapVal max ' +
      'min mod ncpCM ncpF ncpVUpow ncpVUsin normal pi poly power ' +
      'randBinomial randLinear randTriangle round rPower sigmoid sign ' +
      'signPower sin sinh slexp sllog10 slrec sqexp sqlog10 sqr sqrec sqrt ' +
      'tan tanh trunc uniform uniformInt vcPower bool_and bool_eqv bool_imp ' +
      'bool_not bool_or bool_xor ifThen rel_eq rel_ge rel_gt rel_le rel_lt ' +
      'rel_ne gday gdow ghour gleap gmillisec gminute gmonth gsecond gyear ' +
      'jdate jnow jstart jtime errorLevel execError gamsRelease gamsVersion ' +
      'handleCollect handleDelete handleStatus handleSubmit heapFree ' +
      'heapLimit heapSize jobHandle jobKill jobStatus jobTerminate ' +
      'licenseLevel licenseStatus maxExecError sleep timeClose timeComp ' +
      'timeElapsed timeExec timeStart'
  };
  var PARAMS = {
    className: 'params',
    begin: /\(/, end: /\)/,
    excludeBegin: true,
    excludeEnd: true,
  };
  var SYMBOLS = {
    className: 'symbol',
    variants: [
      {begin: /\=[lgenxc]=/},
      {begin: /\$/},
    ]
  };
  var QSTR = { // One-line quoted comment string
    className: 'comment',
    variants: [
      {begin: '\'', end: '\''},
      {begin: '"', end: '"'},
    ],
    illegal: '\\n',
    contains: [hljs.BACKSLASH_ESCAPE]
  };
  var ASSIGNMENT = {
    begin: '/',
    end: '/',
    keywords: KEYWORDS,
    contains: [
      QSTR,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.APOS_STRING_MODE,
      hljs.C_NUMBER_MODE,
    ],
  };
  var DESCTEXT = { // Parameter/set/variable description text
    begin: /[a-z][a-z0-9_]*(\([a-z0-9_, ]*\))?[ \t]+/,
    excludeBegin: true,
    end: '$',
    endsWithParent: true,
    contains: [
      QSTR,
      ASSIGNMENT,
      {
        className: 'comment',
        begin: /([ ]*[a-z0-9&#*=?@>\\<:\-,()$\[\]_.{}!+%^]+)+/,
        relevance: 0
      },
    ],
  };

  return {
    aliases: ['gms'],
    case_insensitive: true,
    keywords: KEYWORDS,
    contains: [
      hljs.COMMENT(/^\$ontext/, /^\$offtext/),
      {
        className: 'meta',
        begin: '^\\$[a-z0-9]+',
        end: '$',
        returnBegin: true,
        contains: [
          {
            className: 'meta-keyword',
            begin: '^\\$[a-z0-9]+',
          }
        ]
      },
      hljs.COMMENT('^\\*', '$'),
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.APOS_STRING_MODE,
      // Declarations
      {
        beginKeywords:
          'set sets parameter parameters variable variables ' +
          'scalar scalars equation equations',
        end: ';',
        contains: [
          hljs.COMMENT('^\\*', '$'),
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE,
          hljs.QUOTE_STRING_MODE,
          hljs.APOS_STRING_MODE,
          ASSIGNMENT,
          DESCTEXT,
        ]
      },
      { // table environment
        beginKeywords: 'table',
        end: ';',
        returnBegin: true,
        contains: [
          { // table header row
            beginKeywords: 'table',
            end: '$',
            contains: [DESCTEXT],
          },
          hljs.COMMENT('^\\*', '$'),
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE,
          hljs.QUOTE_STRING_MODE,
          hljs.APOS_STRING_MODE,
          hljs.C_NUMBER_MODE,
          // Table does not contain DESCTEXT or ASSIGNMENT
        ]
      },
      // Function definitions
      {
        className: 'function',
        begin: /^[a-z][a-z0-9_,\-+' ()$]+\.{2}/,
        returnBegin: true,
        contains: [
              { // Function title
                className: 'title',
                begin: /^[a-z0-9_]+/,
              },
              PARAMS,
              SYMBOLS,
            ],
      },
      hljs.C_NUMBER_MODE,
      SYMBOLS,
    ]
  };
};

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var KEYWORDS = {
    keyword: 'and bool break call callexe checkinterrupt clear clearg closeall cls comlog compile ' +
              'continue create debug declare delete disable dlibrary dllcall do dos ed edit else ' +
              'elseif enable end endfor endif endp endo errorlog errorlogat expr external fn ' +
              'for format goto gosub graph if keyword let lib library line load loadarray loadexe ' +
              'loadf loadk loadm loadp loads loadx local locate loopnextindex lprint lpwidth lshow ' +
              'matrix msym ndpclex new not open or output outwidth plot plotsym pop prcsn print ' +
              'printdos proc push retp return rndcon rndmod rndmult rndseed run save saveall screen ' +
              'scroll setarray show sparse stop string struct system trace trap threadfor ' +
              'threadendfor threadbegin threadjoin threadstat threadend until use while winprint',
    built_in: 'abs acf aconcat aeye amax amean AmericanBinomCall AmericanBinomCall_Greeks AmericanBinomCall_ImpVol ' +
              'AmericanBinomPut AmericanBinomPut_Greeks AmericanBinomPut_ImpVol AmericanBSCall AmericanBSCall_Greeks ' +
              'AmericanBSCall_ImpVol AmericanBSPut AmericanBSPut_Greeks AmericanBSPut_ImpVol amin amult annotationGetDefaults ' +
              'annotationSetBkd annotationSetFont annotationSetLineColor annotationSetLineStyle annotationSetLineThickness ' +
              'annualTradingDays arccos arcsin areshape arrayalloc arrayindex arrayinit arraytomat asciiload asclabel astd ' +
              'astds asum atan atan2 atranspose axmargin balance band bandchol bandcholsol bandltsol bandrv bandsolpd bar ' +
              'base10 begwind besselj bessely beta box boxcox cdfBeta cdfBetaInv cdfBinomial cdfBinomialInv cdfBvn cdfBvn2 ' +
              'cdfBvn2e cdfCauchy cdfCauchyInv cdfChic cdfChii cdfChinc cdfChincInv cdfExp cdfExpInv cdfFc cdfFnc cdfFncInv ' +
              'cdfGam cdfGenPareto cdfHyperGeo cdfLaplace cdfLaplaceInv cdfLogistic cdfLogisticInv cdfmControlCreate cdfMvn ' +
              'cdfMvn2e cdfMvnce cdfMvne cdfMvt2e cdfMvtce cdfMvte cdfN cdfN2 cdfNc cdfNegBinomial cdfNegBinomialInv cdfNi ' +
              'cdfPoisson cdfPoissonInv cdfRayleigh cdfRayleighInv cdfTc cdfTci cdfTnc cdfTvn cdfWeibull cdfWeibullInv cdir ' +
              'ceil ChangeDir chdir chiBarSquare chol choldn cholsol cholup chrs close code cols colsf combinate combinated ' +
              'complex con cond conj cons ConScore contour conv convertsatostr convertstrtosa corrm corrms corrvc corrx corrxs ' +
              'cos cosh counts countwts crossprd crout croutp csrcol csrlin csvReadM csvReadSA cumprodc cumsumc curve cvtos ' +
              'datacreate datacreatecomplex datalist dataload dataloop dataopen datasave date datestr datestring datestrymd ' +
              'dayinyr dayofweek dbAddDatabase dbClose dbCommit dbCreateQuery dbExecQuery dbGetConnectOptions dbGetDatabaseName ' +
              'dbGetDriverName dbGetDrivers dbGetHostName dbGetLastErrorNum dbGetLastErrorText dbGetNumericalPrecPolicy ' +
              'dbGetPassword dbGetPort dbGetTableHeaders dbGetTables dbGetUserName dbHasFeature dbIsDriverAvailable dbIsOpen ' +
              'dbIsOpenError dbOpen dbQueryBindValue dbQueryClear dbQueryCols dbQueryExecPrepared dbQueryFetchAllM dbQueryFetchAllSA ' +
              'dbQueryFetchOneM dbQueryFetchOneSA dbQueryFinish dbQueryGetBoundValue dbQueryGetBoundValues dbQueryGetField ' +
              'dbQueryGetLastErrorNum dbQueryGetLastErrorText dbQueryGetLastInsertID dbQueryGetLastQuery dbQueryGetPosition ' +
              'dbQueryIsActive dbQueryIsForwardOnly dbQueryIsNull dbQueryIsSelect dbQueryIsValid dbQueryPrepare dbQueryRows ' +
              'dbQuerySeek dbQuerySeekFirst dbQuerySeekLast dbQuerySeekNext dbQuerySeekPrevious dbQuerySetForwardOnly ' +
              'dbRemoveDatabase dbRollback dbSetConnectOptions dbSetDatabaseName dbSetHostName dbSetNumericalPrecPolicy ' +
              'dbSetPort dbSetUserName dbTransaction DeleteFile delif delrows denseToSp denseToSpRE denToZero design det detl ' +
              'dfft dffti diag diagrv digamma doswin DOSWinCloseall DOSWinOpen dotfeq dotfeqmt dotfge dotfgemt dotfgt dotfgtmt ' +
              'dotfle dotflemt dotflt dotfltmt dotfne dotfnemt draw drop dsCreate dstat dstatmt dstatmtControlCreate dtdate dtday ' +
              'dttime dttodtv dttostr dttoutc dtvnormal dtvtodt dtvtoutc dummy dummybr dummydn eig eigh eighv eigv elapsedTradingDays ' +
              'endwind envget eof eqSolve eqSolvemt eqSolvemtControlCreate eqSolvemtOutCreate eqSolveset erf erfc erfccplx erfcplx error ' +
              'etdays ethsec etstr EuropeanBinomCall EuropeanBinomCall_Greeks EuropeanBinomCall_ImpVol EuropeanBinomPut ' +
              'EuropeanBinomPut_Greeks EuropeanBinomPut_ImpVol EuropeanBSCall EuropeanBSCall_Greeks EuropeanBSCall_ImpVol ' +
              'EuropeanBSPut EuropeanBSPut_Greeks EuropeanBSPut_ImpVol exctsmpl exec execbg exp extern eye fcheckerr fclearerr feq ' +
              'feqmt fflush fft ffti fftm fftmi fftn fge fgemt fgets fgetsa fgetsat fgetst fgt fgtmt fileinfo filesa fle flemt ' +
              'floor flt fltmt fmod fne fnemt fonts fopen formatcv formatnv fputs fputst fseek fstrerror ftell ftocv ftos ftostrC ' +
              'gamma gammacplx gammaii gausset gdaAppend gdaCreate gdaDStat gdaDStatMat gdaGetIndex gdaGetName gdaGetNames gdaGetOrders ' +
              'gdaGetType gdaGetTypes gdaGetVarInfo gdaIsCplx gdaLoad gdaPack gdaRead gdaReadByIndex gdaReadSome gdaReadSparse ' +
              'gdaReadStruct gdaReportVarInfo gdaSave gdaUpdate gdaUpdateAndPack gdaVars gdaWrite gdaWrite32 gdaWriteSome getarray ' +
              'getdims getf getGAUSShome getmatrix getmatrix4D getname getnamef getNextTradingDay getNextWeekDay getnr getorders ' +
              'getpath getPreviousTradingDay getPreviousWeekDay getRow getscalar3D getscalar4D getTrRow getwind glm gradcplx gradMT ' +
              'gradMTm gradMTT gradMTTm gradp graphprt graphset hasimag header headermt hess hessMT hessMTg hessMTgw hessMTm ' +
              'hessMTmw hessMTT hessMTTg hessMTTgw hessMTTm hessMTw hessp hist histf histp hsec imag indcv indexcat indices indices2 ' +
              'indicesf indicesfn indnv indsav integrate1d integrateControlCreate intgrat2 intgrat3 inthp1 inthp2 inthp3 inthp4 ' +
              'inthpControlCreate intquad1 intquad2 intquad3 intrleav intrleavsa intrsect intsimp inv invpd invswp iscplx iscplxf ' +
              'isden isinfnanmiss ismiss key keyav keyw lag lag1 lagn lapEighb lapEighi lapEighvb lapEighvi lapgEig lapgEigh lapgEighv ' +
              'lapgEigv lapgSchur lapgSvdcst lapgSvds lapgSvdst lapSvdcusv lapSvds lapSvdusv ldlp ldlsol linSolve listwise ln lncdfbvn ' +
              'lncdfbvn2 lncdfmvn lncdfn lncdfn2 lncdfnc lnfact lngammacplx lnpdfmvn lnpdfmvt lnpdfn lnpdft loadd loadstruct loadwind ' +
              'loess loessmt loessmtControlCreate log loglog logx logy lower lowmat lowmat1 ltrisol lu lusol machEpsilon make makevars ' +
              'makewind margin matalloc matinit mattoarray maxbytes maxc maxindc maxv maxvec mbesselei mbesselei0 mbesselei1 mbesseli ' +
              'mbesseli0 mbesseli1 meanc median mergeby mergevar minc minindc minv miss missex missrv moment momentd movingave ' +
              'movingaveExpwgt movingaveWgt nextindex nextn nextnevn nextwind ntos null null1 numCombinations ols olsmt olsmtControlCreate ' +
              'olsqr olsqr2 olsqrmt ones optn optnevn orth outtyp pacf packedToSp packr parse pause pdfCauchy pdfChi pdfExp pdfGenPareto ' +
              'pdfHyperGeo pdfLaplace pdfLogistic pdfn pdfPoisson pdfRayleigh pdfWeibull pi pinv pinvmt plotAddArrow plotAddBar plotAddBox ' +
              'plotAddHist plotAddHistF plotAddHistP plotAddPolar plotAddScatter plotAddShape plotAddTextbox plotAddTS plotAddXY plotArea ' +
              'plotBar plotBox plotClearLayout plotContour plotCustomLayout plotGetDefaults plotHist plotHistF plotHistP plotLayout ' +
              'plotLogLog plotLogX plotLogY plotOpenWindow plotPolar plotSave plotScatter plotSetAxesPen plotSetBar plotSetBarFill ' +
              'plotSetBarStacked plotSetBkdColor plotSetFill plotSetGrid plotSetLegend plotSetLineColor plotSetLineStyle plotSetLineSymbol ' +
              'plotSetLineThickness plotSetNewWindow plotSetTitle plotSetWhichYAxis plotSetXAxisShow plotSetXLabel plotSetXRange ' +
              'plotSetXTicInterval plotSetXTicLabel plotSetYAxisShow plotSetYLabel plotSetYRange plotSetZAxisShow plotSetZLabel ' +
              'plotSurface plotTS plotXY polar polychar polyeval polygamma polyint polymake polymat polymroot polymult polyroot ' +
              'pqgwin previousindex princomp printfm printfmt prodc psi putarray putf putvals pvCreate pvGetIndex pvGetParNames ' +
              'pvGetParVector pvLength pvList pvPack pvPacki pvPackm pvPackmi pvPacks pvPacksi pvPacksm pvPacksmi pvPutParVector ' +
              'pvTest pvUnpack QNewton QNewtonmt QNewtonmtControlCreate QNewtonmtOutCreate QNewtonSet QProg QProgmt QProgmtInCreate ' +
              'qqr qqre qqrep qr qre qrep qrsol qrtsol qtyr qtyre qtyrep quantile quantiled qyr qyre qyrep qz rank rankindx readr ' +
              'real reclassify reclassifyCuts recode recserar recsercp recserrc rerun rescale reshape rets rev rfft rffti rfftip rfftn ' +
              'rfftnp rfftp rndBernoulli rndBeta rndBinomial rndCauchy rndChiSquare rndCon rndCreateState rndExp rndGamma rndGeo rndGumbel ' +
              'rndHyperGeo rndi rndKMbeta rndKMgam rndKMi rndKMn rndKMnb rndKMp rndKMu rndKMvm rndLaplace rndLCbeta rndLCgam rndLCi rndLCn ' +
              'rndLCnb rndLCp rndLCu rndLCvm rndLogNorm rndMTu rndMVn rndMVt rndn rndnb rndNegBinomial rndp rndPoisson rndRayleigh ' +
              'rndStateSkip rndu rndvm rndWeibull rndWishart rotater round rows rowsf rref sampleData satostrC saved saveStruct savewind ' +
              'scale scale3d scalerr scalinfnanmiss scalmiss schtoc schur searchsourcepath seekr select selif seqa seqm setdif setdifsa ' +
              'setvars setvwrmode setwind shell shiftr sin singleindex sinh sleep solpd sortc sortcc sortd sorthc sorthcc sortind ' +
              'sortindc sortmc sortr sortrc spBiconjGradSol spChol spConjGradSol spCreate spDenseSubmat spDiagRvMat spEigv spEye spLDL ' +
              'spline spLU spNumNZE spOnes spreadSheetReadM spreadSheetReadSA spreadSheetWrite spScale spSubmat spToDense spTrTDense ' +
              'spTScalar spZeros sqpSolve sqpSolveMT sqpSolveMTControlCreate sqpSolveMTlagrangeCreate sqpSolveMToutCreate sqpSolveSet ' +
              'sqrt statements stdc stdsc stocv stof strcombine strindx strlen strput strrindx strsect strsplit strsplitPad strtodt ' +
              'strtof strtofcplx strtriml strtrimr strtrunc strtruncl strtruncpad strtruncr submat subscat substute subvec sumc sumr ' +
              'surface svd svd1 svd2 svdcusv svds svdusv sysstate tab tan tanh tempname threadBegin threadEnd threadEndFor threadFor ' +
              'threadJoin threadStat time timedt timestr timeutc title tkf2eps tkf2ps tocart todaydt toeplitz token topolar trapchk ' +
              'trigamma trimr trunc type typecv typef union unionsa uniqindx uniqindxsa unique uniquesa upmat upmat1 upper utctodt ' +
              'utctodtv utrisol vals varCovMS varCovXS varget vargetl varmall varmares varput varputl vartypef vcm vcms vcx vcxs ' +
              'vec vech vecr vector vget view viewxyz vlist vnamecv volume vput vread vtypecv wait waitc walkindex where window ' +
              'writer xlabel xlsGetSheetCount xlsGetSheetSize xlsGetSheetTypes xlsMakeRange xlsReadM xlsReadSA xlsWrite xlsWriteM ' +
              'xlsWriteSA xpnd xtics xy xyz ylabel ytics zeros zeta zlabel ztics cdfEmpirical dot h5create h5open h5read h5readAttribute ' +
              'h5write h5writeAttribute ldl plotAddErrorBar plotAddSurface plotCDFEmpirical plotSetColormap plotSetContourLabels ' +
              'plotSetLegendFont plotSetTextInterpreter plotSetXTicCount plotSetYTicCount plotSetZLevels powerm strjoin strtrim sylvester',
    literal: 'DB_AFTER_LAST_ROW DB_ALL_TABLES DB_BATCH_OPERATIONS DB_BEFORE_FIRST_ROW DB_BLOB DB_EVENT_NOTIFICATIONS ' +
             'DB_FINISH_QUERY DB_HIGH_PRECISION DB_LAST_INSERT_ID DB_LOW_PRECISION_DOUBLE DB_LOW_PRECISION_INT32 ' +
             'DB_LOW_PRECISION_INT64 DB_LOW_PRECISION_NUMBERS DB_MULTIPLE_RESULT_SETS DB_NAMED_PLACEHOLDERS ' +
             'DB_POSITIONAL_PLACEHOLDERS DB_PREPARED_QUERIES DB_QUERY_SIZE DB_SIMPLE_LOCKING DB_SYSTEM_TABLES DB_TABLES ' +
             'DB_TRANSACTIONS DB_UNICODE DB_VIEWS'
  };

  var PREPROCESSOR =
  {
    className: 'meta',
    begin: '#', end: '$',
    keywords: {'meta-keyword': 'define definecs|10 undef ifdef ifndef iflight ifdllcall ifmac ifos2win ifunix else endif lineson linesoff srcfile srcline'},
    contains: [
      {
        begin: /\\\n/, relevance: 0
      },
      {
        beginKeywords: 'include', end: '$',
        keywords: {'meta-keyword': 'include'},
        contains: [
          {
            className: 'meta-string',
            begin: '"', end: '"',
            illegal: '\\n'
          }
        ]
      },
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE
    ]
  };

  var FUNCTION_TITLE = hljs.UNDERSCORE_IDENT_RE + '\\s*\\(?';
  var PARSE_PARAMS = [
    {
      className: 'params',
      begin: /\(/, end: /\)/,
      keywords: KEYWORDS,
      relevance: 0,
      contains: [
        hljs.C_NUMBER_MODE,
        hljs.C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE
      ]
    }
  ];

  return {
    aliases: ['gss'],
    case_insensitive: true, // language is case-insensitive
    keywords: KEYWORDS,
    illegal: '(\\{[%#]|[%#]\\})',
    contains: [
      hljs.C_NUMBER_MODE,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.COMMENT('@', '@'),
      PREPROCESSOR,
      {
        className: 'string',
        begin: '"', end: '"',
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      {
        className: 'function',
        beginKeywords: 'proc keyword',
        end: ';',
        excludeEnd: true,
        keywords: KEYWORDS,
        contains: [
          {
            begin: FUNCTION_TITLE, returnBegin: true,
            contains: [hljs.UNDERSCORE_TITLE_MODE],
            relevance: 0
          },
          hljs.C_NUMBER_MODE,
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE,
          PREPROCESSOR
        ].concat(PARSE_PARAMS)
      },
      {
        className: 'function',
        beginKeywords: 'fn',
        end: ';',
        excludeEnd: true,
        keywords: KEYWORDS,
        contains: [
          {
            begin: FUNCTION_TITLE + hljs.IDENT_RE + '\\)?\\s*\\=\\s*', returnBegin: true,
            contains: [hljs.UNDERSCORE_TITLE_MODE],
            relevance: 0
          },
          hljs.C_NUMBER_MODE,
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ].concat(PARSE_PARAMS)
      },
      {
        className: 'function',
        begin: '\\bexternal (proc|keyword|fn)\\s+',
        end: ';',
        excludeEnd: true,
        keywords: KEYWORDS,
        contains: [
          {
            begin: FUNCTION_TITLE, returnBegin: true,
            contains: [hljs.UNDERSCORE_TITLE_MODE],
            relevance: 0
          },
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        className: 'function',
        begin: '\\bexternal (matrix|string|array|sparse matrix|struct ' + hljs.IDENT_RE + ')\\s+',
        end: ';',
        excludeEnd: true,
        keywords: KEYWORDS,
        contains: [
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      }
    ]
  };
};

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
    var GCODE_IDENT_RE = '[A-Z_][A-Z0-9_.]*';
    var GCODE_CLOSE_RE = '\\%';
    var GCODE_KEYWORDS =
      'IF DO WHILE ENDWHILE CALL ENDIF SUB ENDSUB GOTO REPEAT ENDREPEAT ' +
      'EQ LT GT NE GE LE OR XOR';
    var GCODE_START = {
        className: 'meta',
        begin: '([O])([0-9]+)'
    };
    var GCODE_CODE = [
        hljs.C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        hljs.COMMENT(/\(/, /\)/),
        hljs.inherit(hljs.C_NUMBER_MODE, {begin: '([-+]?([0-9]*\\.?[0-9]+\\.?))|' + hljs.C_NUMBER_RE}),
        hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
        hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
        {
            className: 'name',
            begin: '([G])([0-9]+\\.?[0-9]?)'
        },
        {
            className: 'name',
            begin: '([M])([0-9]+\\.?[0-9]?)'
        },
        {
            className: 'attr',
            begin: '(VC|VS|#)',
            end: '(\\d+)'
        },
        {
            className: 'attr',
            begin: '(VZOFX|VZOFY|VZOFZ)'
        },
        {
            className: 'built_in',
            begin: '(ATAN|ABS|ACOS|ASIN|SIN|COS|EXP|FIX|FUP|ROUND|LN|TAN)(\\[)',
            end: '([-+]?([0-9]*\\.?[0-9]+\\.?))(\\])'
        },
        {
            className: 'symbol',
            variants: [
                {
                    begin: 'N', end: '\\d+',
                    illegal: '\\W'
                }
            ]
        }
    ];

    return {
        aliases: ['nc'],
        // Some implementations (CNC controls) of G-code are interoperable with uppercase and lowercase letters seamlessly.
        // However, most prefer all uppercase and uppercase is customary.
        case_insensitive: true,
        lexemes: GCODE_IDENT_RE,
        keywords: GCODE_KEYWORDS,
        contains: [
            {
                className: 'meta',
                begin: GCODE_CLOSE_RE
            },
            GCODE_START
        ].concat(GCODE_CODE)
    };
};

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

module.exports = function (hljs) {
  return {
    aliases: ['feature'],
    keywords: 'Feature Background Ability Business\ Need Scenario Scenarios Scenario\ Outline Scenario\ Template Examples Given And Then But When',
    contains: [
      {
        className: 'symbol',
        begin: '\\*',
        relevance: 0
      },
      {
        className: 'meta',
        begin: '@[^@\\s]+'
      },
      {
        begin: '\\|', end: '\\|\\w*$',
        contains: [
          {
            className: 'string',
            begin: '[^|]+'
          }
        ]
      },
      {
        className: 'variable',
        begin: '<', end: '>'
      },
      hljs.HASH_COMMENT_MODE,
      {
        className: 'string',
        begin: '"""', end: '"""'
      },
      hljs.QUOTE_STRING_MODE
    ]
  };
};

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    keywords: {
      keyword:
        // Statements
        'break continue discard do else for if return while switch case default ' +
        // Qualifiers
        'attribute binding buffer ccw centroid centroid varying coherent column_major const cw ' +
        'depth_any depth_greater depth_less depth_unchanged early_fragment_tests equal_spacing ' +
        'flat fractional_even_spacing fractional_odd_spacing highp in index inout invariant ' +
        'invocations isolines layout line_strip lines lines_adjacency local_size_x local_size_y ' +
        'local_size_z location lowp max_vertices mediump noperspective offset origin_upper_left ' +
        'out packed patch pixel_center_integer point_mode points precise precision quads r11f_g11f_b10f '+
        'r16 r16_snorm r16f r16i r16ui r32f r32i r32ui r8 r8_snorm r8i r8ui readonly restrict ' +
        'rg16 rg16_snorm rg16f rg16i rg16ui rg32f rg32i rg32ui rg8 rg8_snorm rg8i rg8ui rgb10_a2 ' +
        'rgb10_a2ui rgba16 rgba16_snorm rgba16f rgba16i rgba16ui rgba32f rgba32i rgba32ui rgba8 ' +
        'rgba8_snorm rgba8i rgba8ui row_major sample shared smooth std140 std430 stream triangle_strip ' +
        'triangles triangles_adjacency uniform varying vertices volatile writeonly',
      type:
        'atomic_uint bool bvec2 bvec3 bvec4 dmat2 dmat2x2 dmat2x3 dmat2x4 dmat3 dmat3x2 dmat3x3 ' +
        'dmat3x4 dmat4 dmat4x2 dmat4x3 dmat4x4 double dvec2 dvec3 dvec4 float iimage1D iimage1DArray ' +
        'iimage2D iimage2DArray iimage2DMS iimage2DMSArray iimage2DRect iimage3D iimageBuffer' +
        'iimageCube iimageCubeArray image1D image1DArray image2D image2DArray image2DMS image2DMSArray ' +
        'image2DRect image3D imageBuffer imageCube imageCubeArray int isampler1D isampler1DArray ' +
        'isampler2D isampler2DArray isampler2DMS isampler2DMSArray isampler2DRect isampler3D ' +
        'isamplerBuffer isamplerCube isamplerCubeArray ivec2 ivec3 ivec4 mat2 mat2x2 mat2x3 ' +
        'mat2x4 mat3 mat3x2 mat3x3 mat3x4 mat4 mat4x2 mat4x3 mat4x4 sampler1D sampler1DArray ' +
        'sampler1DArrayShadow sampler1DShadow sampler2D sampler2DArray sampler2DArrayShadow ' +
        'sampler2DMS sampler2DMSArray sampler2DRect sampler2DRectShadow sampler2DShadow sampler3D ' +
        'samplerBuffer samplerCube samplerCubeArray samplerCubeArrayShadow samplerCubeShadow ' +
        'image1D uimage1DArray uimage2D uimage2DArray uimage2DMS uimage2DMSArray uimage2DRect ' +
        'uimage3D uimageBuffer uimageCube uimageCubeArray uint usampler1D usampler1DArray ' +
        'usampler2D usampler2DArray usampler2DMS usampler2DMSArray usampler2DRect usampler3D ' +
        'samplerBuffer usamplerCube usamplerCubeArray uvec2 uvec3 uvec4 vec2 vec3 vec4 void',
      built_in:
        // Constants
        'gl_MaxAtomicCounterBindings gl_MaxAtomicCounterBufferSize gl_MaxClipDistances gl_MaxClipPlanes ' +
        'gl_MaxCombinedAtomicCounterBuffers gl_MaxCombinedAtomicCounters gl_MaxCombinedImageUniforms ' +
        'gl_MaxCombinedImageUnitsAndFragmentOutputs gl_MaxCombinedTextureImageUnits gl_MaxComputeAtomicCounterBuffers ' +
        'gl_MaxComputeAtomicCounters gl_MaxComputeImageUniforms gl_MaxComputeTextureImageUnits ' +
        'gl_MaxComputeUniformComponents gl_MaxComputeWorkGroupCount gl_MaxComputeWorkGroupSize ' +
        'gl_MaxDrawBuffers gl_MaxFragmentAtomicCounterBuffers gl_MaxFragmentAtomicCounters ' +
        'gl_MaxFragmentImageUniforms gl_MaxFragmentInputComponents gl_MaxFragmentInputVectors ' +
        'gl_MaxFragmentUniformComponents gl_MaxFragmentUniformVectors gl_MaxGeometryAtomicCounterBuffers ' +
        'gl_MaxGeometryAtomicCounters gl_MaxGeometryImageUniforms gl_MaxGeometryInputComponents ' +
        'gl_MaxGeometryOutputComponents gl_MaxGeometryOutputVertices gl_MaxGeometryTextureImageUnits ' +
        'gl_MaxGeometryTotalOutputComponents gl_MaxGeometryUniformComponents gl_MaxGeometryVaryingComponents ' +
        'gl_MaxImageSamples gl_MaxImageUnits gl_MaxLights gl_MaxPatchVertices gl_MaxProgramTexelOffset ' +
        'gl_MaxTessControlAtomicCounterBuffers gl_MaxTessControlAtomicCounters gl_MaxTessControlImageUniforms ' +
        'gl_MaxTessControlInputComponents gl_MaxTessControlOutputComponents gl_MaxTessControlTextureImageUnits ' +
        'gl_MaxTessControlTotalOutputComponents gl_MaxTessControlUniformComponents ' +
        'gl_MaxTessEvaluationAtomicCounterBuffers gl_MaxTessEvaluationAtomicCounters ' +
        'gl_MaxTessEvaluationImageUniforms gl_MaxTessEvaluationInputComponents gl_MaxTessEvaluationOutputComponents ' +
        'gl_MaxTessEvaluationTextureImageUnits gl_MaxTessEvaluationUniformComponents ' +
        'gl_MaxTessGenLevel gl_MaxTessPatchComponents gl_MaxTextureCoords gl_MaxTextureImageUnits ' +
        'gl_MaxTextureUnits gl_MaxVaryingComponents gl_MaxVaryingFloats gl_MaxVaryingVectors ' +
        'gl_MaxVertexAtomicCounterBuffers gl_MaxVertexAtomicCounters gl_MaxVertexAttribs gl_MaxVertexImageUniforms ' +
        'gl_MaxVertexOutputComponents gl_MaxVertexOutputVectors gl_MaxVertexTextureImageUnits ' +
        'gl_MaxVertexUniformComponents gl_MaxVertexUniformVectors gl_MaxViewports gl_MinProgramTexelOffset ' +
        // Variables
        'gl_BackColor gl_BackLightModelProduct gl_BackLightProduct gl_BackMaterial ' +
        'gl_BackSecondaryColor gl_ClipDistance gl_ClipPlane gl_ClipVertex gl_Color ' +
        'gl_DepthRange gl_EyePlaneQ gl_EyePlaneR gl_EyePlaneS gl_EyePlaneT gl_Fog gl_FogCoord ' +
        'gl_FogFragCoord gl_FragColor gl_FragCoord gl_FragData gl_FragDepth gl_FrontColor ' +
        'gl_FrontFacing gl_FrontLightModelProduct gl_FrontLightProduct gl_FrontMaterial ' +
        'gl_FrontSecondaryColor gl_GlobalInvocationID gl_InstanceID gl_InvocationID gl_Layer gl_LightModel ' +
        'gl_LightSource gl_LocalInvocationID gl_LocalInvocationIndex gl_ModelViewMatrix ' +
        'gl_ModelViewMatrixInverse gl_ModelViewMatrixInverseTranspose gl_ModelViewMatrixTranspose ' +
        'gl_ModelViewProjectionMatrix gl_ModelViewProjectionMatrixInverse gl_ModelViewProjectionMatrixInverseTranspose ' +
        'gl_ModelViewProjectionMatrixTranspose gl_MultiTexCoord0 gl_MultiTexCoord1 gl_MultiTexCoord2 ' +
        'gl_MultiTexCoord3 gl_MultiTexCoord4 gl_MultiTexCoord5 gl_MultiTexCoord6 gl_MultiTexCoord7 ' +
        'gl_Normal gl_NormalMatrix gl_NormalScale gl_NumSamples gl_NumWorkGroups gl_ObjectPlaneQ ' +
        'gl_ObjectPlaneR gl_ObjectPlaneS gl_ObjectPlaneT gl_PatchVerticesIn gl_Point gl_PointCoord ' +
        'gl_PointSize gl_Position gl_PrimitiveID gl_PrimitiveIDIn gl_ProjectionMatrix gl_ProjectionMatrixInverse ' +
        'gl_ProjectionMatrixInverseTranspose gl_ProjectionMatrixTranspose gl_SampleID gl_SampleMask ' +
        'gl_SampleMaskIn gl_SamplePosition gl_SecondaryColor gl_TessCoord gl_TessLevelInner gl_TessLevelOuter ' +
        'gl_TexCoord gl_TextureEnvColor gl_TextureMatrix gl_TextureMatrixInverse gl_TextureMatrixInverseTranspose ' +
        'gl_TextureMatrixTranspose gl_Vertex gl_VertexID gl_ViewportIndex gl_WorkGroupID gl_WorkGroupSize gl_in gl_out ' +
        // Functions
        'EmitStreamVertex EmitVertex EndPrimitive EndStreamPrimitive abs acos acosh all any asin ' +
        'asinh atan atanh atomicAdd atomicAnd atomicCompSwap atomicCounter atomicCounterDecrement ' +
        'atomicCounterIncrement atomicExchange atomicMax atomicMin atomicOr atomicXor barrier ' +
        'bitCount bitfieldExtract bitfieldInsert bitfieldReverse ceil clamp cos cosh cross ' +
        'dFdx dFdy degrees determinant distance dot equal exp exp2 faceforward findLSB findMSB ' +
        'floatBitsToInt floatBitsToUint floor fma fract frexp ftransform fwidth greaterThan ' +
        'greaterThanEqual groupMemoryBarrier imageAtomicAdd imageAtomicAnd imageAtomicCompSwap ' +
        'imageAtomicExchange imageAtomicMax imageAtomicMin imageAtomicOr imageAtomicXor imageLoad ' +
        'imageSize imageStore imulExtended intBitsToFloat interpolateAtCentroid interpolateAtOffset ' +
        'interpolateAtSample inverse inversesqrt isinf isnan ldexp length lessThan lessThanEqual log ' +
        'log2 matrixCompMult max memoryBarrier memoryBarrierAtomicCounter memoryBarrierBuffer ' +
        'memoryBarrierImage memoryBarrierShared min mix mod modf noise1 noise2 noise3 noise4 ' +
        'normalize not notEqual outerProduct packDouble2x32 packHalf2x16 packSnorm2x16 packSnorm4x8 ' +
        'packUnorm2x16 packUnorm4x8 pow radians reflect refract round roundEven shadow1D shadow1DLod ' +
        'shadow1DProj shadow1DProjLod shadow2D shadow2DLod shadow2DProj shadow2DProjLod sign sin sinh ' +
        'smoothstep sqrt step tan tanh texelFetch texelFetchOffset texture texture1D texture1DLod ' +
        'texture1DProj texture1DProjLod texture2D texture2DLod texture2DProj texture2DProjLod ' +
        'texture3D texture3DLod texture3DProj texture3DProjLod textureCube textureCubeLod ' +
        'textureGather textureGatherOffset textureGatherOffsets textureGrad textureGradOffset ' +
        'textureLod textureLodOffset textureOffset textureProj textureProjGrad textureProjGradOffset ' +
        'textureProjLod textureProjLodOffset textureProjOffset textureQueryLevels textureQueryLod ' +
        'textureSize transpose trunc uaddCarry uintBitsToFloat umulExtended unpackDouble2x32 ' +
        'unpackHalf2x16 unpackSnorm2x16 unpackSnorm4x8 unpackUnorm2x16 unpackUnorm4x8 usubBorrow',
      literal: 'true false'
    },
    illegal: '"',
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.C_NUMBER_MODE,
      {
        className: 'meta',
        begin: '#', end: '$'
      }
    ]
  };
};

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var GO_KEYWORDS = {
    keyword:
      'break default func interface select case map struct chan else goto package switch ' +
      'const fallthrough if range type continue for import return var go defer ' +
      'bool byte complex64 complex128 float32 float64 int8 int16 int32 int64 string uint8 ' +
      'uint16 uint32 uint64 int uint uintptr rune',
    literal:
       'true false iota nil',
    built_in:
      'append cap close complex copy imag len make new panic print println real recover delete'
  };
  return {
    aliases: ['golang'],
    keywords: GO_KEYWORDS,
    illegal: '</',
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'string',
        variants: [
          hljs.QUOTE_STRING_MODE,
          {begin: '\'', end: '[^\\\\]\''},
          {begin: '`', end: '`'},
        ]
      },
      {
        className: 'number',
        variants: [
          {begin: hljs.C_NUMBER_RE + '[dflsi]', relevance: 1},
          hljs.C_NUMBER_MODE
        ]
      },
      {
        begin: /:=/ // relevance booster
      },
      {
        className: 'function',
        beginKeywords: 'func', end: /\s*\{/, excludeEnd: true,
        contains: [
          hljs.TITLE_MODE,
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            keywords: GO_KEYWORDS,
            illegal: /["']/
          }
        ]
      }
    ]
  };
};

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
    return {
      keywords: {
        keyword:
          'println readln print import module function local return let var ' +
          'while for foreach times in case when match with break continue ' +
          'augment augmentation each find filter reduce ' +
          'if then else otherwise try catch finally raise throw orIfNull ' +
          'DynamicObject|10 DynamicVariable struct Observable map set vector list array',
        literal:
          'true false null'
      },
      contains: [
        hljs.HASH_COMMENT_MODE,
        hljs.QUOTE_STRING_MODE,
        hljs.C_NUMBER_MODE,
        {
          className: 'meta', begin: '@[A-Za-z]+'
        }
      ]
    }
};

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    case_insensitive: true,
    keywords: {
      keyword:
        'task project allprojects subprojects artifacts buildscript configurations ' +
        'dependencies repositories sourceSets description delete from into include ' +
        'exclude source classpath destinationDir includes options sourceCompatibility ' +
        'targetCompatibility group flatDir doLast doFirst flatten todir fromdir ant ' +
        'def abstract break case catch continue default do else extends final finally ' +
        'for if implements instanceof native new private protected public return static ' +
        'switch synchronized throw throws transient try volatile while strictfp package ' +
        'import false null super this true antlrtask checkstyle codenarc copy boolean ' +
        'byte char class double float int interface long short void compile runTime ' +
        'file fileTree abs any append asList asWritable call collect compareTo count ' +
        'div dump each eachByte eachFile eachLine every find findAll flatten getAt ' +
        'getErr getIn getOut getText grep immutable inject inspect intersect invokeMethods ' +
        'isCase join leftShift minus multiply newInputStream newOutputStream newPrintWriter ' +
        'newReader newWriter next plus pop power previous print println push putAt read ' +
        'readBytes readLines reverse reverseEach round size sort splitEachLine step subMap ' +
        'times toInteger toList tokenize upto waitForOrKill withPrintWriter withReader ' +
        'withStream withWriter withWriterAppend write writeLine'
    },
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.NUMBER_MODE,
      hljs.REGEXP_MODE

    ]
  }
};

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
    return {
        keywords: {
            literal : 'true false null',
            keyword:
            'byte short char int long boolean float double void ' +
            // groovy specific keywords
            'def as in assert trait ' +
            // common keywords with Java
            'super this abstract static volatile transient public private protected synchronized final ' +
            'class interface enum if else for while switch case break default continue ' +
            'throw throws try catch finally implements extends new import package return instanceof'
        },

        contains: [
            hljs.COMMENT(
                '/\\*\\*',
                '\\*/',
                {
                    relevance : 0,
                    contains : [
                      {
                          // eat up @'s in emails to prevent them to be recognized as doctags
                          begin: /\w+@/, relevance: 0
                      },
                      {
                          className : 'doctag',
                          begin : '@[A-Za-z]+'
                      }
                    ]
                }
            ),
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: 'string',
                begin: '"""', end: '"""'
            },
            {
                className: 'string',
                begin: "'''", end: "'''"
            },
            {
                className: 'string',
                begin: "\\$/", end: "/\\$",
                relevance: 10
            },
            hljs.APOS_STRING_MODE,
            {
                className: 'regexp',
                begin: /~?\/[^\/\n]+\//,
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            hljs.QUOTE_STRING_MODE,
            {
                className: 'meta',
                begin: "^#!/usr/bin/env", end: '$',
                illegal: '\n'
            },
            hljs.BINARY_NUMBER_MODE,
            {
                className: 'class',
                beginKeywords: 'class interface trait enum', end: '{',
                illegal: ':',
                contains: [
                    {beginKeywords: 'extends implements'},
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            hljs.C_NUMBER_MODE,
            {
                className: 'meta', begin: '@[A-Za-z]+'
            },
            {
                // highlight map keys and named parameters as strings
                className: 'string', begin: /[^\?]{0}[A-Za-z0-9_$]+ *:/
            },
            {
                // catch middle element of the ternary operator
                // to avoid highlight it as a label, named parameter, or map key
                begin: /\?/, end: /\:/
            },
            {
                // highlight labeled statements
                className: 'symbol', begin: '^\\s*[A-Za-z0-9_$]+:',
                relevance: 0
            }
        ],
        illegal: /#|<\//
    }
};

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports = // TODO support filter tags like :javascript, support inline HTML
function(hljs) {
  return {
    case_insensitive: true,
    contains: [
      {
        className: 'meta',
        begin: '^!!!( (5|1\\.1|Strict|Frameset|Basic|Mobile|RDFa|XML\\b.*))?$',
        relevance: 10
      },
      // FIXME these comments should be allowed to span indented lines
      hljs.COMMENT(
        '^\\s*(!=#|=#|-#|/).*$',
        false,
        {
          relevance: 0
        }
      ),
      {
        begin: '^\\s*(-|=|!=)(?!#)',
        starts: {
          end: '\\n',
          subLanguage: 'ruby'
        }
      },
      {
        className: 'tag',
        begin: '^\\s*%',
        contains: [
          {
            className: 'selector-tag',
            begin: '\\w+'
          },
          {
            className: 'selector-id',
            begin: '#[\\w-]+'
          },
          {
            className: 'selector-class',
            begin: '\\.[\\w-]+'
          },
          {
            begin: '{\\s*',
            end: '\\s*}',
            contains: [
              {
                begin: ':\\w+\\s*=>',
                end: ',\\s+',
                returnBegin: true,
                endsWithParent: true,
                contains: [
                  {
                    className: 'attr',
                    begin: ':\\w+'
                  },
                  hljs.APOS_STRING_MODE,
                  hljs.QUOTE_STRING_MODE,
                  {
                    begin: '\\w+',
                    relevance: 0
                  }
                ]
              }
            ]
          },
          {
            begin: '\\(\\s*',
            end: '\\s*\\)',
            excludeEnd: true,
            contains: [
              {
                begin: '\\w+\\s*=',
                end: '\\s+',
                returnBegin: true,
                endsWithParent: true,
                contains: [
                  {
                    className: 'attr',
                    begin: '\\w+',
                    relevance: 0
                  },
                  hljs.APOS_STRING_MODE,
                  hljs.QUOTE_STRING_MODE,
                  {
                    begin: '\\w+',
                    relevance: 0
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        begin: '^\\s*[=~]\\s*'
      },
      {
        begin: '#{',
        starts: {
          end: '}',
          subLanguage: 'ruby'
        }
      }
    ]
  };
};

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var BUILT_INS = {'builtin-name': 'each in with if else unless bindattr action collection debugger log outlet template unbound view yield'};
  return {
    aliases: ['hbs', 'html.hbs', 'html.handlebars'],
    case_insensitive: true,
    subLanguage: 'xml',
    contains: [
    hljs.COMMENT('{{!(--)?', '(--)?}}'),
      {
        className: 'template-tag',
        begin: /\{\{[#\/]/, end: /\}\}/,
        contains: [
          {
            className: 'name',
            begin: /[a-zA-Z\.-]+/,
            keywords: BUILT_INS,
            starts: {
              endsWithParent: true, relevance: 0,
              contains: [
                hljs.QUOTE_STRING_MODE
              ]
            }
          }
        ]
      },
      {
        className: 'template-variable',
        begin: /\{\{/, end: /\}\}/,
        keywords: BUILT_INS
      }
    ]
  };
};

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var COMMENT = {
    variants: [
      hljs.COMMENT('--', '$'),
      hljs.COMMENT(
        '{-',
        '-}',
        {
          contains: ['self']
        }
      )
    ]
  };

  var PRAGMA = {
    className: 'meta',
    begin: '{-#', end: '#-}'
  };

  var PREPROCESSOR = {
    className: 'meta',
    begin: '^#', end: '$'
  };

  var CONSTRUCTOR = {
    className: 'type',
    begin: '\\b[A-Z][\\w\']*', // TODO: other constructors (build-in, infix).
    relevance: 0
  };

  var LIST = {
    begin: '\\(', end: '\\)',
    illegal: '"',
    contains: [
      PRAGMA,
      PREPROCESSOR,
      {className: 'type', begin: '\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?'},
      hljs.inherit(hljs.TITLE_MODE, {begin: '[_a-z][\\w\']*'}),
      COMMENT
    ]
  };

  var RECORD = {
    begin: '{', end: '}',
    contains: LIST.contains
  };

  return {
    aliases: ['hs'],
    keywords:
      'let in if then else case of where do module import hiding ' +
      'qualified type data newtype deriving class instance as default ' +
      'infix infixl infixr foreign export ccall stdcall cplusplus ' +
      'jvm dotnet safe unsafe family forall mdo proc rec',
    contains: [

      // Top-level constructions.

      {
        beginKeywords: 'module', end: 'where',
        keywords: 'module where',
        contains: [LIST, COMMENT],
        illegal: '\\W\\.|;'
      },
      {
        begin: '\\bimport\\b', end: '$',
        keywords: 'import qualified as hiding',
        contains: [LIST, COMMENT],
        illegal: '\\W\\.|;'
      },

      {
        className: 'class',
        begin: '^(\\s*)?(class|instance)\\b', end: 'where',
        keywords: 'class family instance where',
        contains: [CONSTRUCTOR, LIST, COMMENT]
      },
      {
        className: 'class',
        begin: '\\b(data|(new)?type)\\b', end: '$',
        keywords: 'data family type newtype deriving',
        contains: [PRAGMA, CONSTRUCTOR, LIST, RECORD, COMMENT]
      },
      {
        beginKeywords: 'default', end: '$',
        contains: [CONSTRUCTOR, LIST, COMMENT]
      },
      {
        beginKeywords: 'infix infixl infixr', end: '$',
        contains: [hljs.C_NUMBER_MODE, COMMENT]
      },
      {
        begin: '\\bforeign\\b', end: '$',
        keywords: 'foreign import export ccall stdcall cplusplus jvm ' +
                  'dotnet safe unsafe',
        contains: [CONSTRUCTOR, hljs.QUOTE_STRING_MODE, COMMENT]
      },
      {
        className: 'meta',
        begin: '#!\\/usr\\/bin\\/env\ runhaskell', end: '$'
      },

      // "Whitespaces".

      PRAGMA,
      PREPROCESSOR,

      // Literals and names.

      // TODO: characters.
      hljs.QUOTE_STRING_MODE,
      hljs.C_NUMBER_MODE,
      CONSTRUCTOR,
      hljs.inherit(hljs.TITLE_MODE, {begin: '^[_a-z][\\w\']*'}),

      COMMENT,

      {begin: '->|<-'} // No markup, relevance booster
    ]
  };
};

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var IDENT_RE = '[a-zA-Z_$][a-zA-Z0-9_$]*';
  var IDENT_FUNC_RETURN_TYPE_RE = '([*]|[a-zA-Z_$][a-zA-Z0-9_$]*)';

  var HAXE_BASIC_TYPES = 'Int Float String Bool Dynamic Void Array ';

  return {
    aliases: ['hx'],
    keywords: {
      keyword: 'break case cast catch continue default do dynamic else enum extern ' +
               'for function here if import in inline never new override package private get set ' +
               'public return static super switch this throw trace try typedef untyped using var while ' +
               HAXE_BASIC_TYPES,
      built_in:
        'trace this',
      literal:
        'true false null _'
    },
    contains: [
      { className: 'string', // interpolate-able strings
        begin: '\'', end: '\'',
        contains: [
          hljs.BACKSLASH_ESCAPE,
          { className: 'subst', // interpolation
            begin: '\\$\\{', end: '\\}'
          },
          { className: 'subst', // interpolation
            begin: '\\$', end: '\\W}'
          }
        ]
      },
      hljs.QUOTE_STRING_MODE,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.C_NUMBER_MODE,
      { className: 'meta', // compiler meta
        begin: '@:', end: '$'
      },
      { className: 'meta', // compiler conditionals
        begin: '#', end: '$',
        keywords: {'meta-keyword': 'if else elseif end error'}
      },
      { className: 'type', // function types
        begin: ':[ \t]*', end: '[^A-Za-z0-9_ \t\\->]',
        excludeBegin: true, excludeEnd: true,
        relevance: 0
      },
      { className: 'type', // types
        begin: ':[ \t]*', end: '\\W',
        excludeBegin: true, excludeEnd: true
      },
      { className: 'type', // instantiation
        begin: 'new *', end: '\\W',
        excludeBegin: true, excludeEnd: true
      },
      { className: 'class', // enums
        beginKeywords: 'enum', end: '\\{',
        contains: [
          hljs.TITLE_MODE
        ]
      },
      { className: 'class', // abstracts
        beginKeywords: 'abstract', end: '[\\{$]',
        contains: [
          { className: 'type',
            begin: '\\(', end: '\\)',
            excludeBegin: true, excludeEnd: true
          },
          { className: 'type',
            begin: 'from +', end: '\\W',
            excludeBegin: true, excludeEnd: true
          },
          { className: 'type',
            begin: 'to +', end: '\\W',
            excludeBegin: true, excludeEnd: true
          },
          hljs.TITLE_MODE
        ],
        keywords: {
          keyword: 'abstract from to'
        }
      },
      { className: 'class', // classes
        begin: '\\b(class|interface) +', end: '[\\{$]',  excludeEnd: true,
        keywords: 'class interface',
        contains: [
          { className: 'keyword',
            begin: '\\b(extends|implements) +',
            keywords: 'extends implements',
            contains: [
              {
                className: 'type',
                begin: hljs.IDENT_RE,
                relevance: 0
              }
            ]
          },
          hljs.TITLE_MODE
        ]
      },
      { className: 'function',
        beginKeywords: 'function', end: '\\(', excludeEnd: true,
        illegal: '\\S',
        contains: [
          hljs.TITLE_MODE
        ]
      }
    ],
    illegal: /<\//
  };
};

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    case_insensitive: true,
    lexemes: /[\w\._]+/,
    keywords: 'goto gosub return break repeat loop continue wait await dim sdim foreach dimtype dup dupptr end stop newmod delmod mref run exgoto on mcall assert logmes newlab resume yield onexit onerror onkey onclick oncmd exist delete mkdir chdir dirlist bload bsave bcopy memfile if else poke wpoke lpoke getstr chdpm memexpand memcpy memset notesel noteadd notedel noteload notesave randomize noteunsel noteget split strrep setease button chgdisp exec dialog mmload mmplay mmstop mci pset pget syscolor mes print title pos circle cls font sysfont objsize picload color palcolor palette redraw width gsel gcopy gzoom gmode bmpsave hsvcolor getkey listbox chkbox combox input mesbox buffer screen bgscr mouse objsel groll line clrobj boxf objprm objmode stick grect grotate gsquare gradf objimage objskip objenable celload celdiv celput newcom querycom delcom cnvstow comres axobj winobj sendmsg comevent comevarg sarrayconv callfunc cnvwtos comevdisp libptr system hspstat hspver stat cnt err strsize looplev sublev iparam wparam lparam refstr refdval int rnd strlen length length2 length3 length4 vartype gettime peek wpeek lpeek varptr varuse noteinfo instr abs limit getease str strmid strf getpath strtrim sin cos tan atan sqrt double absf expf logf limitf powf geteasef mousex mousey mousew hwnd hinstance hdc ginfo objinfo dirinfo sysinfo thismod __hspver__ __hsp30__ __date__ __time__ __line__ __file__ _debug __hspdef__ and or xor not screen_normal screen_palette screen_hide screen_fixedsize screen_tool screen_frame gmode_gdi gmode_mem gmode_rgb0 gmode_alpha gmode_rgb0alpha gmode_add gmode_sub gmode_pixela ginfo_mx ginfo_my ginfo_act ginfo_sel ginfo_wx1 ginfo_wy1 ginfo_wx2 ginfo_wy2 ginfo_vx ginfo_vy ginfo_sizex ginfo_sizey ginfo_winx ginfo_winy ginfo_mesx ginfo_mesy ginfo_r ginfo_g ginfo_b ginfo_paluse ginfo_dispx ginfo_dispy ginfo_cx ginfo_cy ginfo_intid ginfo_newid ginfo_sx ginfo_sy objinfo_mode objinfo_bmscr objinfo_hwnd notemax notesize dir_cur dir_exe dir_win dir_sys dir_cmdline dir_desktop dir_mydoc dir_tv font_normal font_bold font_italic font_underline font_strikeout font_antialias objmode_normal objmode_guifont objmode_usefont gsquare_grad msgothic msmincho do until while wend for next _break _continue switch case default swbreak swend ddim ldim alloc m_pi rad2deg deg2rad ease_linear ease_quad_in ease_quad_out ease_quad_inout ease_cubic_in ease_cubic_out ease_cubic_inout ease_quartic_in ease_quartic_out ease_quartic_inout ease_bounce_in ease_bounce_out ease_bounce_inout ease_shake_in ease_shake_out ease_shake_inout ease_loop',
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.APOS_STRING_MODE,

      {
        // multi-line string
        className: 'string',
        begin: '{"', end: '"}',
        contains: [hljs.BACKSLASH_ESCAPE]
      },

      hljs.COMMENT(';', '$', {relevance: 0}),

      {
        // pre-processor
        className: 'meta',
        begin: '#', end: '$',
        keywords: {'meta-keyword': 'addion cfunc cmd cmpopt comfunc const defcfunc deffunc define else endif enum epack func global if ifdef ifndef include modcfunc modfunc modinit modterm module pack packopt regcmd runtime undef usecom uselib'},
        contains: [
          hljs.inherit(hljs.QUOTE_STRING_MODE, {className: 'meta-string'}),
          hljs.NUMBER_MODE,
          hljs.C_NUMBER_MODE,
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },

      {
        // label
        className: 'symbol',
        begin: '^\\*(\\w+|@)'
      },

      hljs.NUMBER_MODE,
      hljs.C_NUMBER_MODE
    ]
  };
};

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var BUILT_INS = 'action collection component concat debugger each each-in else get hash if input link-to loc log mut outlet partial query-params render textarea unbound unless with yield view';

  var ATTR_ASSIGNMENT = {
    illegal: /\}\}/,
    begin: /[a-zA-Z0-9_]+=/,
    returnBegin: true,
    relevance: 0,
    contains: [
      {
        className: 'attr', begin: /[a-zA-Z0-9_]+/
      }
    ]
  };

  var SUB_EXPR = {
    illegal: /\}\}/,
    begin: /\)/, end: /\)/,
    contains: [
      {
        begin: /[a-zA-Z\.\-]+/,
        keywords: {built_in: BUILT_INS},
        starts: {
          endsWithParent: true, relevance: 0,
          contains: [
            hljs.QUOTE_STRING_MODE,
          ]
        }
      }
    ]
  };

  var TAG_INNARDS = {
    endsWithParent: true, relevance: 0,
    keywords: {keyword: 'as', built_in: BUILT_INS},
    contains: [
      hljs.QUOTE_STRING_MODE,
      ATTR_ASSIGNMENT,
      hljs.NUMBER_MODE
    ]
  };

  return {
    case_insensitive: true,
    subLanguage: 'xml',
    contains: [
      hljs.COMMENT('{{!(--)?', '(--)?}}'),
      {
        className: 'template-tag',
        begin: /\{\{[#\/]/, end: /\}\}/,
        contains: [
          {
            className: 'name',
            begin: /[a-zA-Z\.\-]+/,
            keywords: {'builtin-name': BUILT_INS},
            starts: TAG_INNARDS
          }
        ]
      },
      {
        className: 'template-variable',
        begin: /\{\{[a-zA-Z][a-zA-Z\-]+/, end: /\}\}/,
        keywords: {keyword: 'as', built_in: BUILT_INS},
        contains: [
          hljs.QUOTE_STRING_MODE
        ]
      }
    ]
  };
};

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var VERSION = 'HTTP/[0-9\\.]+';
  return {
    aliases: ['https'],
    illegal: '\\S',
    contains: [
      {
        begin: '^' + VERSION, end: '$',
        contains: [{className: 'number', begin: '\\b\\d{3}\\b'}]
      },
      {
        begin: '^[A-Z]+ (.*?) ' + VERSION + '$', returnBegin: true, end: '$',
        contains: [
          {
            className: 'string',
            begin: ' ', end: ' ',
            excludeBegin: true, excludeEnd: true
          },
          {
            begin: VERSION
          },
          {
            className: 'keyword',
            begin: '[A-Z]+'
          }
        ]
      },
      {
        className: 'attribute',
        begin: '^\\w', end: ': ', excludeEnd: true,
        illegal: '\\n|\\s|=',
        starts: {end: '$', relevance: 0}
      },
      {
        begin: '\\n\\n',
        starts: {subLanguage: [], endsWithParent: true}
      }
    ]
  };
};

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var keywords = {
    'builtin-name':
      // keywords
      '!= % %= & &= * ** **= *= *map ' +
      '+ += , --build-class-- --import-- -= . / // //= ' +
      '/= < << <<= <= = > >= >> >>= ' +
      '@ @= ^ ^= abs accumulate all and any ap-compose ' +
      'ap-dotimes ap-each ap-each-while ap-filter ap-first ap-if ap-last ap-map ap-map-when ap-pipe ' +
      'ap-reduce ap-reject apply as-> ascii assert assoc bin break butlast ' +
      'callable calling-module-name car case cdr chain chr coll? combinations compile ' +
      'compress cond cons cons? continue count curry cut cycle dec ' +
      'def default-method defclass defmacro defmacro-alias defmacro/g! defmain defmethod defmulti defn ' +
      'defn-alias defnc defnr defreader defseq del delattr delete-route dict-comp dir ' +
      'disassemble dispatch-reader-macro distinct divmod do doto drop drop-last drop-while empty? ' +
      'end-sequence eval eval-and-compile eval-when-compile even? every? except exec filter first ' +
      'flatten float? fn fnc fnr for for* format fraction genexpr ' +
      'gensym get getattr global globals group-by hasattr hash hex id ' +
      'identity if if* if-not if-python2 import in inc input instance? ' +
      'integer integer-char? integer? interleave interpose is is-coll is-cons is-empty is-even ' +
      'is-every is-float is-instance is-integer is-integer-char is-iterable is-iterator is-keyword is-neg is-none ' +
      'is-not is-numeric is-odd is-pos is-string is-symbol is-zero isinstance islice issubclass ' +
      'iter iterable? iterate iterator? keyword keyword? lambda last len let ' +
      'lif lif-not list* list-comp locals loop macro-error macroexpand macroexpand-1 macroexpand-all ' +
      'map max merge-with method-decorator min multi-decorator multicombinations name neg? next ' +
      'none? nonlocal not not-in not? nth numeric? oct odd? open ' +
      'or ord partition permutations pos? post-route postwalk pow prewalk print ' +
      'product profile/calls profile/cpu put-route quasiquote quote raise range read read-str ' +
      'recursive-replace reduce remove repeat repeatedly repr require rest round route ' +
      'route-with-methods rwm second seq set-comp setattr setv some sorted string ' +
      'string? sum switch symbol? take take-nth take-while tee try unless ' +
      'unquote unquote-splicing vars walk when while with with* with-decorator with-gensyms ' +
      'xi xor yield yield-from zero? zip zip-longest | |= ~'
   };

  var SYMBOLSTART = 'a-zA-Z_\\-!.?+*=<>&#\'';
  var SYMBOL_RE = '[' + SYMBOLSTART + '][' + SYMBOLSTART + '0-9/;:]*';
  var SIMPLE_NUMBER_RE = '[-+]?\\d+(\\.\\d+)?';

  var SHEBANG = {
    className: 'meta',
    begin: '^#!', end: '$'
  };

  var SYMBOL = {
    begin: SYMBOL_RE,
    relevance: 0
  };
  var NUMBER = {
    className: 'number', begin: SIMPLE_NUMBER_RE,
    relevance: 0
  };
  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null});
  var COMMENT = hljs.COMMENT(
    ';',
    '$',
    {
      relevance: 0
    }
  );
  var LITERAL = {
    className: 'literal',
    begin: /\b([Tt]rue|[Ff]alse|nil|None)\b/
  };
  var COLLECTION = {
    begin: '[\\[\\{]', end: '[\\]\\}]'
  };
  var HINT = {
    className: 'comment',
    begin: '\\^' + SYMBOL_RE
  };
  var HINT_COL = hljs.COMMENT('\\^\\{', '\\}');
  var KEY = {
    className: 'symbol',
    begin: '[:]{1,2}' + SYMBOL_RE
  };
  var LIST = {
    begin: '\\(', end: '\\)'
  };
  var BODY = {
    endsWithParent: true,
    relevance: 0
  };
  var NAME = {
    keywords: keywords,
    lexemes: SYMBOL_RE,
    className: 'name', begin: SYMBOL_RE,
    starts: BODY
  };
  var DEFAULT_CONTAINS = [LIST, STRING, HINT, HINT_COL, COMMENT, KEY, COLLECTION, NUMBER, LITERAL, SYMBOL];

  LIST.contains = [hljs.COMMENT('comment', ''), NAME, BODY];
  BODY.contains = DEFAULT_CONTAINS;
  COLLECTION.contains = DEFAULT_CONTAINS;

  return {
    aliases: ['hylang'],
    illegal: /\S/,
    contains: [SHEBANG, LIST, STRING, HINT, HINT_COL, COMMENT, KEY, COLLECTION, NUMBER, LITERAL]
  }
};

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var START_BRACKET = '\\[';
  var END_BRACKET = '\\]';
  return {
    aliases: ['i7'],
    case_insensitive: true,
    keywords: {
      // Some keywords more or less unique to I7, for relevance.
      keyword:
        // kind:
        'thing room person man woman animal container ' +
        'supporter backdrop door ' +
        // characteristic:
        'scenery open closed locked inside gender ' +
        // verb:
        'is are say understand ' +
        // misc keyword:
        'kind of rule'
    },
    contains: [
      {
        className: 'string',
        begin: '"', end: '"',
        relevance: 0,
        contains: [
          {
            className: 'subst',
            begin: START_BRACKET, end: END_BRACKET
          }
        ]
      },
      {
        className: 'section',
        begin: /^(Volume|Book|Part|Chapter|Section|Table)\b/,
        end: '$'
      },
      {
        // Rule definition
        // This is here for relevance.
        begin: /^(Check|Carry out|Report|Instead of|To|Rule|When|Before|After)\b/,
        end: ':',
        contains: [
          {
            //Rule name
            begin: '\\(This', end: '\\)'
          }
        ]
      },
      {
        className: 'comment',
        begin: START_BRACKET, end: END_BRACKET,
        contains: ['self']
      }
    ]
  };
};

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var STRING = {
    className: "string",
    contains: [hljs.BACKSLASH_ESCAPE],
    variants: [
      {
        begin: "'''", end: "'''",
        relevance: 10
      }, {
        begin: '"""', end: '"""',
        relevance: 10
      }, {
        begin: '"', end: '"'
      }, {
        begin: "'", end: "'"
      }
    ]
  };
  return {
    aliases: ['toml'],
    case_insensitive: true,
    illegal: /\S/,
    contains: [
      hljs.COMMENT(';', '$'),
      hljs.HASH_COMMENT_MODE,
      {
        className: 'section',
        begin: /^\s*\[+/, end: /\]+/
      },
      {
        begin: /^[a-z0-9\[\]_-]+\s*=\s*/, end: '$',
        returnBegin: true,
        contains: [
          {
            className: 'attr',
            begin: /[a-z0-9\[\]_-]+/
          },
          {
            begin: /=/, endsWithParent: true,
            relevance: 0,
            contains: [
              {
                className: 'literal',
                begin: /\bon|off|true|false|yes|no\b/
              },
              {
                className: 'variable',
                variants: [
                  {begin: /\$[\w\d"][\w\d_]*/},
                  {begin: /\$\{(.*?)}/}
                ]
              },
              STRING,
              {
                className: 'number',
                begin: /([\+\-]+)?[\d]+_[\d_]+/
              },
              hljs.NUMBER_MODE
            ]
          }
        ]
      }
    ]
  };
};

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var PARAMS = {
    className: 'params',
    begin: '\\(', end: '\\)'
  };

  var F_KEYWORDS = {
    literal: '.False. .True.',
    keyword: 'kind do while private call intrinsic where elsewhere ' +
      'type endtype endmodule endselect endinterface end enddo endif if forall endforall only contains default return stop then ' +
      'public subroutine|10 function program .and. .or. .not. .le. .eq. .ge. .gt. .lt. ' +
      'goto save else use module select case ' +
      'access blank direct exist file fmt form formatted iostat name named nextrec number opened rec recl sequential status unformatted unit ' +
      'continue format pause cycle exit ' +
      'c_null_char c_alert c_backspace c_form_feed flush wait decimal round iomsg ' +
      'synchronous nopass non_overridable pass protected volatile abstract extends import ' +
      'non_intrinsic value deferred generic final enumerator class associate bind enum ' +
      'c_int c_short c_long c_long_long c_signed_char c_size_t c_int8_t c_int16_t c_int32_t c_int64_t c_int_least8_t c_int_least16_t ' +
      'c_int_least32_t c_int_least64_t c_int_fast8_t c_int_fast16_t c_int_fast32_t c_int_fast64_t c_intmax_t C_intptr_t c_float c_double ' +
      'c_long_double c_float_complex c_double_complex c_long_double_complex c_bool c_char c_null_ptr c_null_funptr ' +
      'c_new_line c_carriage_return c_horizontal_tab c_vertical_tab iso_c_binding c_loc c_funloc c_associated  c_f_pointer ' +
      'c_ptr c_funptr iso_fortran_env character_storage_size error_unit file_storage_size input_unit iostat_end iostat_eor ' +
      'numeric_storage_size output_unit c_f_procpointer ieee_arithmetic ieee_support_underflow_control ' +
      'ieee_get_underflow_mode ieee_set_underflow_mode newunit contiguous recursive ' +
      'pad position action delim readwrite eor advance nml interface procedure namelist include sequence elemental pure ' +
      'integer real character complex logical dimension allocatable|10 parameter ' +
      'external implicit|10 none double precision assign intent optional pointer ' +
      'target in out common equivalence data ' +
      // IRPF90 special keywords
      'begin_provider &begin_provider end_provider begin_shell end_shell begin_template end_template subst assert touch ' +
      'soft_touch provide no_dep free irp_if irp_else irp_endif irp_write irp_read',
    built_in: 'alog alog10 amax0 amax1 amin0 amin1 amod cabs ccos cexp clog csin csqrt dabs dacos dasin datan datan2 dcos dcosh ddim dexp dint ' +
      'dlog dlog10 dmax1 dmin1 dmod dnint dsign dsin dsinh dsqrt dtan dtanh float iabs idim idint idnint ifix isign max0 max1 min0 min1 sngl ' +
      'algama cdabs cdcos cdexp cdlog cdsin cdsqrt cqabs cqcos cqexp cqlog cqsin cqsqrt dcmplx dconjg derf derfc dfloat dgamma dimag dlgama ' +
      'iqint qabs qacos qasin qatan qatan2 qcmplx qconjg qcos qcosh qdim qerf qerfc qexp qgamma qimag qlgama qlog qlog10 qmax1 qmin1 qmod ' +
      'qnint qsign qsin qsinh qsqrt qtan qtanh abs acos aimag aint anint asin atan atan2 char cmplx conjg cos cosh exp ichar index int log ' +
      'log10 max min nint sign sin sinh sqrt tan tanh print write dim lge lgt lle llt mod nullify allocate deallocate ' +
      'adjustl adjustr all allocated any associated bit_size btest ceiling count cshift date_and_time digits dot_product ' +
      'eoshift epsilon exponent floor fraction huge iand ibclr ibits ibset ieor ior ishft ishftc lbound len_trim matmul ' +
      'maxexponent maxloc maxval merge minexponent minloc minval modulo mvbits nearest pack present product ' +
      'radix random_number random_seed range repeat reshape rrspacing scale scan selected_int_kind selected_real_kind ' +
      'set_exponent shape size spacing spread sum system_clock tiny transpose trim ubound unpack verify achar iachar transfer ' +
      'dble entry dprod cpu_time command_argument_count get_command get_command_argument get_environment_variable is_iostat_end ' +
      'ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode ' +
      'is_iostat_eor move_alloc new_line selected_char_kind same_type_as extends_type_of'  +
      'acosh asinh atanh bessel_j0 bessel_j1 bessel_jn bessel_y0 bessel_y1 bessel_yn erf erfc erfc_scaled gamma log_gamma hypot norm2 ' +
      'atomic_define atomic_ref execute_command_line leadz trailz storage_size merge_bits ' +
      'bge bgt ble blt dshiftl dshiftr findloc iall iany iparity image_index lcobound ucobound maskl maskr ' +
      'num_images parity popcnt poppar shifta shiftl shiftr this_image ' +
      // IRPF90 special built_ins
      'IRP_ALIGN irp_here'
  };
  return {
    case_insensitive: true,
    keywords: F_KEYWORDS,
    illegal: /\/\*/,
    contains: [
      hljs.inherit(hljs.APOS_STRING_MODE, {className: 'string', relevance: 0}),
      hljs.inherit(hljs.QUOTE_STRING_MODE, {className: 'string', relevance: 0}),
      {
        className: 'function',
        beginKeywords: 'subroutine function program',
        illegal: '[${=\\n]',
        contains: [hljs.UNDERSCORE_TITLE_MODE, PARAMS]
      },
      hljs.COMMENT('!', '$', {relevance: 0}),
      hljs.COMMENT('begin_doc', 'end_doc', {relevance: 10}),
      {
        className: 'number',
        begin: '(?=\\b|\\+|\\-|\\.)(?=\\.\\d|\\d)(?:\\d+)?(?:\\.?\\d*)(?:[de][+-]?\\d+)?\\b\\.?',
        relevance: 0
      }
    ]
  };
};

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var JAVA_IDENT_RE = '[\u00C0-\u02B8a-zA-Z_$][\u00C0-\u02B8a-zA-Z_$0-9]*';
  var GENERIC_IDENT_RE = JAVA_IDENT_RE + '(<' + JAVA_IDENT_RE + '(\\s*,\\s*' + JAVA_IDENT_RE + ')*>)?';
  var KEYWORDS =
    'false synchronized int abstract float private char boolean static null if const ' +
    'for true while long strictfp finally protected import native final void ' +
    'enum else break transient catch instanceof byte super volatile case assert short ' +
    'package default double public try this switch continue throws protected public private ' +
    'module requires exports do';

  // https://docs.oracle.com/javase/7/docs/technotes/guides/language/underscores-literals.html
  var JAVA_NUMBER_RE = '\\b' +
    '(' +
      '0[bB]([01]+[01_]+[01]+|[01]+)' + // 0b...
      '|' +
      '0[xX]([a-fA-F0-9]+[a-fA-F0-9_]+[a-fA-F0-9]+|[a-fA-F0-9]+)' + // 0x...
      '|' +
      '(' +
        '([\\d]+[\\d_]+[\\d]+|[\\d]+)(\\.([\\d]+[\\d_]+[\\d]+|[\\d]+))?' +
        '|' +
        '\\.([\\d]+[\\d_]+[\\d]+|[\\d]+)' +
      ')' +
      '([eE][-+]?\\d+)?' + // octal, decimal, float
    ')' +
    '[lLfF]?';
  var JAVA_NUMBER_MODE = {
    className: 'number',
    begin: JAVA_NUMBER_RE,
    relevance: 0
  };

  return {
    aliases: ['jsp'],
    keywords: KEYWORDS,
    illegal: /<\/|#/,
    contains: [
      hljs.COMMENT(
        '/\\*\\*',
        '\\*/',
        {
          relevance : 0,
          contains : [
            {
              // eat up @'s in emails to prevent them to be recognized as doctags
              begin: /\w+@/, relevance: 0
            },
            {
              className : 'doctag',
              begin : '@[A-Za-z]+'
            }
          ]
        }
      ),
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        className: 'class',
        beginKeywords: 'class interface', end: /[{;=]/, excludeEnd: true,
        keywords: 'class interface',
        illegal: /[:"\[\]]/,
        contains: [
          {beginKeywords: 'extends implements'},
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        // Expression keywords prevent 'keyword Name(...)' from being
        // recognized as a function definition
        beginKeywords: 'new throw return else',
        relevance: 0
      },
      {
        className: 'function',
        begin: '(' + GENERIC_IDENT_RE + '\\s+)+' + hljs.UNDERSCORE_IDENT_RE + '\\s*\\(', returnBegin: true, end: /[{;=]/,
        excludeEnd: true,
        keywords: KEYWORDS,
        contains: [
          {
            begin: hljs.UNDERSCORE_IDENT_RE + '\\s*\\(', returnBegin: true,
            relevance: 0,
            contains: [hljs.UNDERSCORE_TITLE_MODE]
          },
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            keywords: KEYWORDS,
            relevance: 0,
            contains: [
              hljs.APOS_STRING_MODE,
              hljs.QUOTE_STRING_MODE,
              hljs.C_NUMBER_MODE,
              hljs.C_BLOCK_COMMENT_MODE
            ]
          },
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      JAVA_NUMBER_MODE,
      {
        className: 'meta', begin: '@[A-Za-z]+'
      }
    ]
  };
};

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
  var KEYWORDS = {
    keyword:
      'in of if for while finally var new function do return void else break catch ' +
      'instanceof with throw case default try this switch continue typeof delete ' +
      'let yield const export super debugger as async await static ' +
      // ECMAScript 6 modules import
      'import from as'
    ,
    literal:
      'true false null undefined NaN Infinity',
    built_in:
      'eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent ' +
      'encodeURI encodeURIComponent escape unescape Object Function Boolean Error ' +
      'EvalError InternalError RangeError ReferenceError StopIteration SyntaxError ' +
      'TypeError URIError Number Math Date String RegExp Array Float32Array ' +
      'Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array ' +
      'Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require ' +
      'module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect ' +
      'Promise'
  };
  var EXPRESSIONS;
  var NUMBER = {
    className: 'number',
    variants: [
      { begin: '\\b(0[bB][01]+)' },
      { begin: '\\b(0[oO][0-7]+)' },
      { begin: hljs.C_NUMBER_RE }
    ],
    relevance: 0
  };
  var SUBST = {
    className: 'subst',
    begin: '\\$\\{', end: '\\}',
    keywords: KEYWORDS,
    contains: []  // defined later
  };
  var TEMPLATE_STRING = {
    className: 'string',
    begin: '`', end: '`',
    contains: [
      hljs.BACKSLASH_ESCAPE,
      SUBST
    ]
  };
  SUBST.contains = [
    hljs.APOS_STRING_MODE,
    hljs.QUOTE_STRING_MODE,
    TEMPLATE_STRING,
    NUMBER,
    hljs.REGEXP_MODE
  ]
  var PARAMS_CONTAINS = SUBST.contains.concat([
    hljs.C_BLOCK_COMMENT_MODE,
    hljs.C_LINE_COMMENT_MODE
  ]);

  return {
    aliases: ['js', 'jsx'],
    keywords: KEYWORDS,
    contains: [
      {
        className: 'meta',
        relevance: 10,
        begin: /^\s*['"]use (strict|asm)['"]/
      },
      {
        className: 'meta',
        begin: /^#!/, end: /$/
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      TEMPLATE_STRING,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      NUMBER,
      { // object attr container
        begin: /[{,]\s*/, relevance: 0,
        contains: [
          {
            begin: IDENT_RE + '\\s*:', returnBegin: true,
            relevance: 0,
            contains: [{className: 'attr', begin: IDENT_RE, relevance: 0}]
          }
        ]
      },
      { // "value" container
        begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
        keywords: 'return throw case',
        contains: [
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE,
          hljs.REGEXP_MODE,
          {
            className: 'function',
            begin: '(\\(.*?\\)|' + IDENT_RE + ')\\s*=>', returnBegin: true,
            end: '\\s*=>',
            contains: [
              {
                className: 'params',
                variants: [
                  {
                    begin: IDENT_RE
                  },
                  {
                    begin: /\(\s*\)/,
                  },
                  {
                    begin: /\(/, end: /\)/,
                    excludeBegin: true, excludeEnd: true,
                    keywords: KEYWORDS,
                    contains: PARAMS_CONTAINS
                  }
                ]
              }
            ]
          },
          { // E4X / JSX
            begin: /</, end: /(\/\w+|\w+\/)>/,
            subLanguage: 'xml',
            contains: [
              {begin: /<\w+\s*\/>/, skip: true},
              {
                begin: /<\w+/, end: /(\/\w+|\w+\/)>/, skip: true,
                contains: [
                  {begin: /<\w+\s*\/>/, skip: true},
                  'self'
                ]
              }
            ]
          }
        ],
        relevance: 0
      },
      {
        className: 'function',
        beginKeywords: 'function', end: /\{/, excludeEnd: true,
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {begin: IDENT_RE}),
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            excludeBegin: true,
            excludeEnd: true,
            contains: PARAMS_CONTAINS
          }
        ],
        illegal: /\[|%/
      },
      {
        begin: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
      },
      hljs.METHOD_GUARD,
      { // ES6 class
        className: 'class',
        beginKeywords: 'class', end: /[{;=]/, excludeEnd: true,
        illegal: /[:"\[\]]/,
        contains: [
          {beginKeywords: 'extends'},
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        beginKeywords: 'constructor', end: /\{/, excludeEnd: true
      }
    ],
    illegal: /#(?!!)/
  };
};

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports = function (hljs) {
  var PARAM = {
    begin: /[\w-]+ *=/, returnBegin: true,
    relevance: 0,
    contains: [{className: 'attr', begin: /[\w-]+/}]
  };
  var PARAMSBLOCK = {
    className: 'params',
    begin: /\(/,
    end: /\)/,
    contains: [PARAM],
    relevance : 0
  };
  var OPERATION = {
    className: 'function',
    begin: /:[\w\-.]+/,
    relevance: 0
  };
  var PATH = {
    className: 'string',
    begin: /\B(([\/.])[\w\-.\/=]+)+/,
  };
  var COMMAND_PARAMS = {
    className: 'params',
    begin: /--[\w\-=\/]+/,
  };
  return {
    aliases: ['wildfly-cli'],
    lexemes: '[a-z\-]+',
    keywords: {
      keyword: 'alias batch cd clear command connect connection-factory connection-info data-source deploy ' +
      'deployment-info deployment-overlay echo echo-dmr help history if jdbc-driver-info jms-queue|20 jms-topic|20 ls ' +
      'patch pwd quit read-attribute read-operation reload rollout-plan run-batch set shutdown try unalias ' +
      'undeploy unset version xa-data-source', // module
      literal: 'true false'
    },
    contains: [
      hljs.HASH_COMMENT_MODE,
      hljs.QUOTE_STRING_MODE,
      COMMAND_PARAMS,
      OPERATION,
      PATH,
      PARAMSBLOCK
    ]
  }
};

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var LITERALS = {literal: 'true false null'};
  var TYPES = [
    hljs.QUOTE_STRING_MODE,
    hljs.C_NUMBER_MODE
  ];
  var VALUE_CONTAINER = {
    end: ',', endsWithParent: true, excludeEnd: true,
    contains: TYPES,
    keywords: LITERALS
  };
  var OBJECT = {
    begin: '{', end: '}',
    contains: [
      {
        className: 'attr',
        begin: /"/, end: /"/,
        contains: [hljs.BACKSLASH_ESCAPE],
        illegal: '\\n',
      },
      hljs.inherit(VALUE_CONTAINER, {begin: /:/})
    ],
    illegal: '\\S'
  };
  var ARRAY = {
    begin: '\\[', end: '\\]',
    contains: [hljs.inherit(VALUE_CONTAINER)], // inherit is a workaround for a bug that makes shared modes with endsWithParent compile only the ending of one of the parents
    illegal: '\\S'
  };
  TYPES.splice(TYPES.length, 0, OBJECT, ARRAY);
  return {
    contains: TYPES,
    keywords: LITERALS,
    illegal: '\\S'
  };
};

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  // Since there are numerous special names in Julia, it is too much trouble
  // to maintain them by hand. Hence these names (i.e. keywords, literals and
  // built-ins) are automatically generated from Julia v0.6 itself through
  // the following scripts for each.

  var KEYWORDS = {
    // # keyword generator, multi-word keywords handled manually below
    // foreach(println, ["in", "isa", "where"])
    // for kw in Base.REPLCompletions.complete_keyword("")
    //     if !(contains(kw, " ") || kw == "struct")
    //         println(kw)
    //     end
    // end
    keyword:
      'in isa where ' +
      'baremodule begin break catch ccall const continue do else elseif end export false finally for function ' +
      'global if import importall let local macro module quote return true try using while ' +
      // legacy, to be deprecated in the next release
      'type immutable abstract bitstype typealias ',

    // # literal generator
    // println("true")
    // println("false")
    // for name in Base.REPLCompletions.completions("", 0)[1]
    //     try
    //         v = eval(Symbol(name))
    //         if !(v isa Function || v isa Type || v isa TypeVar || v isa Module || v isa Colon)
    //             println(name)
    //         end
    //     end
    // end
    literal:
      'true false ' +
      'ARGS C_NULL DevNull ENDIAN_BOM ENV I Inf Inf16 Inf32 Inf64 InsertionSort JULIA_HOME LOAD_PATH MergeSort ' +
      'NaN NaN16 NaN32 NaN64 PROGRAM_FILE QuickSort RoundDown RoundFromZero RoundNearest RoundNearestTiesAway ' +
      'RoundNearestTiesUp RoundToZero RoundUp STDERR STDIN STDOUT VERSION catalan e|0 eu|0 eulergamma golden im ' +
      'nothing pi γ π φ ',

    // # built_in generator:
    // for name in Base.REPLCompletions.completions("", 0)[1]
    //     try
    //         v = eval(Symbol(name))
    //         if v isa Type || v isa TypeVar
    //             println(name)
    //         end
    //     end
    // end
    built_in:
      'ANY AbstractArray AbstractChannel AbstractFloat AbstractMatrix AbstractRNG AbstractSerializer AbstractSet ' +
      'AbstractSparseArray AbstractSparseMatrix AbstractSparseVector AbstractString AbstractUnitRange AbstractVecOrMat ' +
      'AbstractVector Any ArgumentError Array AssertionError Associative Base64DecodePipe Base64EncodePipe Bidiagonal '+
      'BigFloat BigInt BitArray BitMatrix BitVector Bool BoundsError BufferStream CachingPool CapturedException ' +
      'CartesianIndex CartesianRange Cchar Cdouble Cfloat Channel Char Cint Cintmax_t Clong Clonglong ClusterManager ' +
      'Cmd CodeInfo Colon Complex Complex128 Complex32 Complex64 CompositeException Condition ConjArray ConjMatrix ' +
      'ConjVector Cptrdiff_t Cshort Csize_t Cssize_t Cstring Cuchar Cuint Cuintmax_t Culong Culonglong Cushort Cwchar_t ' +
      'Cwstring DataType Date DateFormat DateTime DenseArray DenseMatrix DenseVecOrMat DenseVector Diagonal Dict ' +
      'DimensionMismatch Dims DirectIndexString Display DivideError DomainError EOFError EachLine Enum Enumerate ' +
      'ErrorException Exception ExponentialBackOff Expr Factorization FileMonitor Float16 Float32 Float64 Function ' +
      'Future GlobalRef GotoNode HTML Hermitian IO IOBuffer IOContext IOStream IPAddr IPv4 IPv6 IndexCartesian IndexLinear ' +
      'IndexStyle InexactError InitError Int Int128 Int16 Int32 Int64 Int8 IntSet Integer InterruptException ' +
      'InvalidStateException Irrational KeyError LabelNode LinSpace LineNumberNode LoadError LowerTriangular MIME Matrix ' +
      'MersenneTwister Method MethodError MethodTable Module NTuple NewvarNode NullException Nullable Number ObjectIdDict ' +
      'OrdinalRange OutOfMemoryError OverflowError Pair ParseError PartialQuickSort PermutedDimsArray Pipe ' +
      'PollingFileWatcher ProcessExitedException Ptr QuoteNode RandomDevice Range RangeIndex Rational RawFD ' +
      'ReadOnlyMemoryError Real ReentrantLock Ref Regex RegexMatch RemoteChannel RemoteException RevString RoundingMode ' +
      'RowVector SSAValue SegmentationFault SerializationState Set SharedArray SharedMatrix SharedVector Signed ' +
      'SimpleVector Slot SlotNumber SparseMatrixCSC SparseVector StackFrame StackOverflowError StackTrace StepRange ' +
      'StepRangeLen StridedArray StridedMatrix StridedVecOrMat StridedVector String SubArray SubString SymTridiagonal ' +
      'Symbol Symmetric SystemError TCPSocket Task Text TextDisplay Timer Tridiagonal Tuple Type TypeError TypeMapEntry ' +
      'TypeMapLevel TypeName TypeVar TypedSlot UDPSocket UInt UInt128 UInt16 UInt32 UInt64 UInt8 UndefRefError UndefVarError ' +
      'UnicodeError UniformScaling Union UnionAll UnitRange Unsigned UpperTriangular Val Vararg VecElement VecOrMat Vector ' +
      'VersionNumber Void WeakKeyDict WeakRef WorkerConfig WorkerPool '
  };

  // ref: http://julia.readthedocs.org/en/latest/manual/variables/#allowed-variable-names
  var VARIABLE_NAME_RE = '[A-Za-z_\\u00A1-\\uFFFF][A-Za-z_0-9\\u00A1-\\uFFFF]*';

  // placeholder for recursive self-reference
  var DEFAULT = {
    lexemes: VARIABLE_NAME_RE, keywords: KEYWORDS, illegal: /<\//
  };

  // ref: http://julia.readthedocs.org/en/latest/manual/integers-and-floating-point-numbers/
  var NUMBER = {
    className: 'number',
    // supported numeric literals:
    //  * binary literal (e.g. 0x10)
    //  * octal literal (e.g. 0o76543210)
    //  * hexadecimal literal (e.g. 0xfedcba876543210)
    //  * hexadecimal floating point literal (e.g. 0x1p0, 0x1.2p2)
    //  * decimal literal (e.g. 9876543210, 100_000_000)
    //  * floating pointe literal (e.g. 1.2, 1.2f, .2, 1., 1.2e10, 1.2e-10)
    begin: /(\b0x[\d_]*(\.[\d_]*)?|0x\.\d[\d_]*)p[-+]?\d+|\b0[box][a-fA-F0-9][a-fA-F0-9_]*|(\b\d[\d_]*(\.[\d_]*)?|\.\d[\d_]*)([eEfF][-+]?\d+)?/,
    relevance: 0
  };

  var CHAR = {
    className: 'string',
    begin: /'(.|\\[xXuU][a-zA-Z0-9]+)'/
  };

  var INTERPOLATION = {
    className: 'subst',
    begin: /\$\(/, end: /\)/,
    keywords: KEYWORDS
  };

  var INTERPOLATED_VARIABLE = {
    className: 'variable',
    begin: '\\$' + VARIABLE_NAME_RE
  };

  // TODO: neatly escape normal code in string literal
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, INTERPOLATION, INTERPOLATED_VARIABLE],
    variants: [
      { begin: /\w*"""/, end: /"""\w*/, relevance: 10 },
      { begin: /\w*"/, end: /"\w*/ }
    ]
  };

  var COMMAND = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, INTERPOLATION, INTERPOLATED_VARIABLE],
    begin: '`', end: '`'
  };

  var MACROCALL = {
    className: 'meta',
    begin: '@' + VARIABLE_NAME_RE
  };

  var COMMENT = {
    className: 'comment',
    variants: [
      { begin: '#=', end: '=#', relevance: 10 },
      { begin: '#', end: '$' }
    ]
  };

  DEFAULT.contains = [
    NUMBER,
    CHAR,
    STRING,
    COMMAND,
    MACROCALL,
    COMMENT,
    hljs.HASH_COMMENT_MODE,
    {
      className: 'keyword',
      begin:
        '\\b(((abstract|primitive)\\s+)type|(mutable\\s+)?struct)\\b'
    },
    {begin: /<:/}  // relevance booster
  ];
  INTERPOLATION.contains = DEFAULT.contains;

  return DEFAULT;
};

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    contains: [
      {
        className: 'meta',
        begin: /^julia>/,
        relevance: 10,
        starts: {
          // end the highlighting if we are on a new line and the line does not have at
          // least six spaces in the beginning
          end: /^(?![ ]{6})/,
          subLanguage: 'julia'
      },
      // jldoctest Markdown blocks are used in the Julia manual and package docs indicate
      // code snippets that should be verified when the documentation is built. They can be
      // either REPL-like or script-like, but are usually REPL-like and therefore we apply
      // julia-repl highlighting to them. More information can be found in Documenter's
      // manual: https://juliadocs.github.io/Documenter.jl/latest/man/doctests.html
      aliases: ['jldoctest']
      }
    ]
  }
};

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var KEYWORDS = {
    keyword:
      'abstract as val var vararg get set class object open private protected public noinline ' +
      'crossinline dynamic final enum if else do while for when throw try catch finally ' +
      'import package is in fun override companion reified inline lateinit init' +
      'interface annotation data sealed internal infix operator out by constructor super ' +
      // to be deleted soon
      'trait volatile transient native default',
    built_in:
      'Byte Short Char Int Long Boolean Float Double Void Unit Nothing',
    literal:
      'true false null'
  };
  var KEYWORDS_WITH_LABEL = {
    className: 'keyword',
    begin: /\b(break|continue|return|this)\b/,
    starts: {
      contains: [
        {
          className: 'symbol',
          begin: /@\w+/
        }
      ]
    }
  };
  var LABEL = {
    className: 'symbol', begin: hljs.UNDERSCORE_IDENT_RE + '@'
  };

  // for string templates
  var SUBST = {
    className: 'subst',
    begin: '\\${', end: '}', contains: [hljs.APOS_STRING_MODE, hljs.C_NUMBER_MODE]
  };
  var VARIABLE = {
    className: 'variable', begin: '\\$' + hljs.UNDERSCORE_IDENT_RE
  };
  var STRING = {
    className: 'string',
    variants: [
      {
        begin: '"""', end: '"""',
        contains: [VARIABLE, SUBST]
      },
      // Can't use built-in modes easily, as we want to use STRING in the meta
      // context as 'meta-string' and there's no syntax to remove explicitly set
      // classNames in built-in modes.
      {
        begin: '\'', end: '\'',
        illegal: /\n/,
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      {
        begin: '"', end: '"',
        illegal: /\n/,
        contains: [hljs.BACKSLASH_ESCAPE, VARIABLE, SUBST]
      }
    ]
  };

  var ANNOTATION_USE_SITE = {
    className: 'meta', begin: '@(?:file|property|field|get|set|receiver|param|setparam|delegate)\\s*:(?:\\s*' + hljs.UNDERSCORE_IDENT_RE + ')?'
  };
  var ANNOTATION = {
    className: 'meta', begin: '@' + hljs.UNDERSCORE_IDENT_RE,
    contains: [
      {
        begin: /\(/, end: /\)/,
        contains: [
          hljs.inherit(STRING, {className: 'meta-string'})
        ]
      }
    ]
  };

  return {
    keywords: KEYWORDS,
    contains : [
      hljs.COMMENT(
        '/\\*\\*',
        '\\*/',
        {
          relevance : 0,
          contains : [{
            className : 'doctag',
            begin : '@[A-Za-z]+'
          }]
        }
      ),
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      KEYWORDS_WITH_LABEL,
      LABEL,
      ANNOTATION_USE_SITE,
      ANNOTATION,
      {
        className: 'function',
        beginKeywords: 'fun', end: '[(]|$',
        returnBegin: true,
        excludeEnd: true,
        keywords: KEYWORDS,
        illegal: /fun\s+(<.*>)?[^\s\(]+(\s+[^\s\(]+)\s*=/,
        relevance: 5,
        contains: [
          {
            begin: hljs.UNDERSCORE_IDENT_RE + '\\s*\\(', returnBegin: true,
            relevance: 0,
            contains: [hljs.UNDERSCORE_TITLE_MODE]
          },
          {
            className: 'type',
            begin: /</, end: />/, keywords: 'reified',
            relevance: 0
          },
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            endsParent: true,
            keywords: KEYWORDS,
            relevance: 0,
            contains: [
              {
                begin: /:/, end: /[=,\/]/, endsWithParent: true,
                contains: [
                  {className: 'type', begin: hljs.UNDERSCORE_IDENT_RE},
                  hljs.C_LINE_COMMENT_MODE,
                  hljs.C_BLOCK_COMMENT_MODE
                ],
                relevance: 0
              },
              hljs.C_LINE_COMMENT_MODE,
              hljs.C_BLOCK_COMMENT_MODE,
              ANNOTATION_USE_SITE,
              ANNOTATION,
              STRING,
              hljs.C_NUMBER_MODE
            ]
          },
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        className: 'class',
        beginKeywords: 'class interface trait', end: /[:\{(]|$/, // remove 'trait' when removed from KEYWORDS
        excludeEnd: true,
        illegal: 'extends implements',
        contains: [
          {beginKeywords: 'public protected internal private constructor'},
          hljs.UNDERSCORE_TITLE_MODE,
          {
            className: 'type',
            begin: /</, end: />/, excludeBegin: true, excludeEnd: true,
            relevance: 0
          },
          {
            className: 'type',
            begin: /[,:]\s*/, end: /[<\(,]|$/, excludeBegin: true, returnEnd: true
          },
          ANNOTATION_USE_SITE,
          ANNOTATION
        ]
      },
      STRING,
      {
        className: 'meta',
        begin: "^#!/usr/bin/env", end: '$',
        illegal: '\n'
      },
      hljs.C_NUMBER_MODE
    ]
  };
};

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var LASSO_IDENT_RE = '[a-zA-Z_][\\w.]*';
  var LASSO_ANGLE_RE = '<\\?(lasso(script)?|=)';
  var LASSO_CLOSE_RE = '\\]|\\?>';
  var LASSO_KEYWORDS = {
    literal:
      'true false none minimal full all void and or not ' +
      'bw nbw ew new cn ncn lt lte gt gte eq neq rx nrx ft',
    built_in:
      'array date decimal duration integer map pair string tag xml null ' +
      'boolean bytes keyword list locale queue set stack staticarray ' +
      'local var variable global data self inherited currentcapture givenblock',
    keyword:
      'cache database_names database_schemanames database_tablenames ' +
      'define_tag define_type email_batch encode_set html_comment handle ' +
      'handle_error header if inline iterate ljax_target link ' +
      'link_currentaction link_currentgroup link_currentrecord link_detail ' +
      'link_firstgroup link_firstrecord link_lastgroup link_lastrecord ' +
      'link_nextgroup link_nextrecord link_prevgroup link_prevrecord log ' +
      'loop namespace_using output_none portal private protect records ' +
      'referer referrer repeating resultset rows search_args ' +
      'search_arguments select sort_args sort_arguments thread_atomic ' +
      'value_list while abort case else fail_if fail_ifnot fail if_empty ' +
      'if_false if_null if_true loop_abort loop_continue loop_count params ' +
      'params_up return return_value run_children soap_definetag ' +
      'soap_lastrequest soap_lastresponse tag_name ascending average by ' +
      'define descending do equals frozen group handle_failure import in ' +
      'into join let match max min on order parent protected provide public ' +
      'require returnhome skip split_thread sum take thread to trait type ' +
      'where with yield yieldhome'
  };
  var HTML_COMMENT = hljs.COMMENT(
    '<!--',
    '-->',
    {
      relevance: 0
    }
  );
  var LASSO_NOPROCESS = {
    className: 'meta',
    begin: '\\[noprocess\\]',
    starts: {
      end: '\\[/noprocess\\]',
      returnEnd: true,
      contains: [HTML_COMMENT]
    }
  };
  var LASSO_START = {
    className: 'meta',
    begin: '\\[/noprocess|' + LASSO_ANGLE_RE
  };
  var LASSO_DATAMEMBER = {
    className: 'symbol',
    begin: '\'' + LASSO_IDENT_RE + '\''
  };
  var LASSO_CODE = [
    hljs.C_LINE_COMMENT_MODE,
    hljs.C_BLOCK_COMMENT_MODE,
    hljs.inherit(hljs.C_NUMBER_MODE, {begin: hljs.C_NUMBER_RE + '|(-?infinity|NaN)\\b'}),
    hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
    hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
    {
      className: 'string',
      begin: '`', end: '`'
    },
    { // variables
      variants: [
        {
          begin: '[#$]' + LASSO_IDENT_RE
        },
        {
          begin: '#', end: '\\d+',
          illegal: '\\W'
        }
      ]
    },
    {
      className: 'type',
      begin: '::\\s*', end: LASSO_IDENT_RE,
      illegal: '\\W'
    },
    {
      className: 'params',
      variants: [
        {
          begin: '-(?!infinity)' + LASSO_IDENT_RE,
          relevance: 0
        },
        {
          begin: '(\\.\\.\\.)'
        }
      ]
    },
    {
      begin: /(->|\.)\s*/,
      relevance: 0,
      contains: [LASSO_DATAMEMBER]
    },
    {
      className: 'class',
      beginKeywords: 'define',
      returnEnd: true, end: '\\(|=>',
      contains: [
        hljs.inherit(hljs.TITLE_MODE, {begin: LASSO_IDENT_RE + '(=(?!>))?|[-+*/%](?!>)'})
      ]
    }
  ];
  return {
    aliases: ['ls', 'lassoscript'],
    case_insensitive: true,
    lexemes: LASSO_IDENT_RE + '|&[lg]t;',
    keywords: LASSO_KEYWORDS,
    contains: [
      {
        className: 'meta',
        begin: LASSO_CLOSE_RE,
        relevance: 0,
        starts: { // markup
          end: '\\[|' + LASSO_ANGLE_RE,
          returnEnd: true,
          relevance: 0,
          contains: [HTML_COMMENT]
        }
      },
      LASSO_NOPROCESS,
      LASSO_START,
      {
        className: 'meta',
        begin: '\\[no_square_brackets',
        starts: {
          end: '\\[/no_square_brackets\\]', // not implemented in the language
          lexemes: LASSO_IDENT_RE + '|&[lg]t;',
          keywords: LASSO_KEYWORDS,
          contains: [
            {
              className: 'meta',
              begin: LASSO_CLOSE_RE,
              relevance: 0,
              starts: {
                end: '\\[noprocess\\]|' + LASSO_ANGLE_RE,
                returnEnd: true,
                contains: [HTML_COMMENT]
              }
            },
            LASSO_NOPROCESS,
            LASSO_START
          ].concat(LASSO_CODE)
        }
      },
      {
        className: 'meta',
        begin: '\\[',
        relevance: 0
      },
      {
        className: 'meta',
        begin: '^#!', end:'lasso9$',
        relevance: 10
      }
    ].concat(LASSO_CODE)
  };
};

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    contains: [
      {
        className: 'attribute',
        begin: '^dn', end: ': ', excludeEnd: true,
        starts: {end: '$', relevance: 0},
        relevance: 10
      },
      {
        className: 'attribute',
        begin: '^\\w', end: ': ', excludeEnd: true,
        starts: {end: '$', relevance: 0}
      },
      {
        className: 'literal',
        begin: '^-', end: '$'
      },
      hljs.HASH_COMMENT_MODE
    ]
  };
};

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

module.exports = function (hljs) {
  return {
    contains: [
      {
        className: 'function',
        begin: '#+' + '[A-Za-z_0-9]*' + '\\(',
        end:' {',
        returnBegin: true,
        excludeEnd: true,
        contains : [
          {
            className: 'keyword',
            begin: '#+'
          },
          {
            className: 'title',
            begin: '[A-Za-z_][A-Za-z_0-9]*'
          },
          {
            className: 'params',
            begin: '\\(', end: '\\)',
            endsParent: true,
            contains: [
              {
                className: 'string',
                begin: '"',
                end: '"'
              },
              {
                className: 'variable',
                begin: '[A-Za-z_][A-Za-z_0-9]*'
              }
            ]
          }
        ]
      }
    ]
  };
};

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var IDENT_RE        = '[\\w-]+'; // yes, Less identifiers may begin with a digit
  var INTERP_IDENT_RE = '(' + IDENT_RE + '|@{' + IDENT_RE + '})';

  /* Generic Modes */

  var RULES = [], VALUE = []; // forward def. for recursive modes

  var STRING_MODE = function(c) { return {
    // Less strings are not multiline (also include '~' for more consistent coloring of "escaped" strings)
    className: 'string', begin: '~?' + c + '.*?' + c
  };};

  var IDENT_MODE = function(name, begin, relevance) { return {
    className: name, begin: begin, relevance: relevance
  };};

  var PARENS_MODE = {
    // used only to properly balance nested parens inside mixin call, def. arg list
    begin: '\\(', end: '\\)', contains: VALUE, relevance: 0
  };

  // generic Less highlighter (used almost everywhere except selectors):
  VALUE.push(
    hljs.C_LINE_COMMENT_MODE,
    hljs.C_BLOCK_COMMENT_MODE,
    STRING_MODE("'"),
    STRING_MODE('"'),
    hljs.CSS_NUMBER_MODE, // fixme: it does not include dot for numbers like .5em :(
    {
      begin: '(url|data-uri)\\(',
      starts: {className: 'string', end: '[\\)\\n]', excludeEnd: true}
    },
    IDENT_MODE('number', '#[0-9A-Fa-f]+\\b'),
    PARENS_MODE,
    IDENT_MODE('variable', '@@?' + IDENT_RE, 10),
    IDENT_MODE('variable', '@{'  + IDENT_RE + '}'),
    IDENT_MODE('built_in', '~?`[^`]*?`'), // inline javascript (or whatever host language) *multiline* string
    { // @media features (it’s here to not duplicate things in AT_RULE_MODE with extra PARENS_MODE overriding):
      className: 'attribute', begin: IDENT_RE + '\\s*:', end: ':', returnBegin: true, excludeEnd: true
    },
    {
      className: 'meta',
      begin: '!important'
    }
  );

  var VALUE_WITH_RULESETS = VALUE.concat({
    begin: '{', end: '}', contains: RULES
  });

  var MIXIN_GUARD_MODE = {
    beginKeywords: 'when', endsWithParent: true,
    contains: [{beginKeywords: 'and not'}].concat(VALUE) // using this form to override VALUE’s 'function' match
  };

  /* Rule-Level Modes */

  var RULE_MODE = {
    begin: INTERP_IDENT_RE + '\\s*:', returnBegin: true, end: '[;}]',
    relevance: 0,
    contains: [
      {
        className: 'attribute',
        begin: INTERP_IDENT_RE, end: ':', excludeEnd: true,
        starts: {
          endsWithParent: true, illegal: '[<=$]',
          relevance: 0,
          contains: VALUE
        }
      }
    ]
  };

  var AT_RULE_MODE = {
    className: 'keyword',
    begin: '@(import|media|charset|font-face|(-[a-z]+-)?keyframes|supports|document|namespace|page|viewport|host)\\b',
    starts: {end: '[;{}]', returnEnd: true, contains: VALUE, relevance: 0}
  };

  // variable definitions and calls
  var VAR_RULE_MODE = {
    className: 'variable',
    variants: [
      // using more strict pattern for higher relevance to increase chances of Less detection.
      // this is *the only* Less specific statement used in most of the sources, so...
      // (we’ll still often loose to the css-parser unless there's '//' comment,
      // simply because 1 variable just can't beat 99 properties :)
      {begin: '@' + IDENT_RE + '\\s*:', relevance: 15},
      {begin: '@' + IDENT_RE}
    ],
    starts: {end: '[;}]', returnEnd: true, contains: VALUE_WITH_RULESETS}
  };

  var SELECTOR_MODE = {
    // first parse unambiguous selectors (i.e. those not starting with tag)
    // then fall into the scary lookahead-discriminator variant.
    // this mode also handles mixin definitions and calls
    variants: [{
      begin: '[\\.#:&\\[>]', end: '[;{}]'  // mixin calls end with ';'
      }, {
      begin: INTERP_IDENT_RE, end: '{'
    }],
    returnBegin: true,
    returnEnd:   true,
    illegal: '[<=\'$"]',
    relevance: 0,
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      MIXIN_GUARD_MODE,
      IDENT_MODE('keyword',  'all\\b'),
      IDENT_MODE('variable', '@{'  + IDENT_RE + '}'),     // otherwise it’s identified as tag
      IDENT_MODE('selector-tag',  INTERP_IDENT_RE + '%?', 0), // '%' for more consistent coloring of @keyframes "tags"
      IDENT_MODE('selector-id', '#' + INTERP_IDENT_RE),
      IDENT_MODE('selector-class', '\\.' + INTERP_IDENT_RE, 0),
      IDENT_MODE('selector-tag',  '&', 0),
      {className: 'selector-attr', begin: '\\[', end: '\\]'},
      {className: 'selector-pseudo', begin: /:(:)?[a-zA-Z0-9\_\-\+\(\)"'.]+/},
      {begin: '\\(', end: '\\)', contains: VALUE_WITH_RULESETS}, // argument list of parametric mixins
      {begin: '!important'} // eat !important after mixin call or it will be colored as tag
    ]
  };

  RULES.push(
    hljs.C_LINE_COMMENT_MODE,
    hljs.C_BLOCK_COMMENT_MODE,
    AT_RULE_MODE,
    VAR_RULE_MODE,
    RULE_MODE,
    SELECTOR_MODE
  );

  return {
    case_insensitive: true,
    illegal: '[=>\'/<($"]',
    contains: RULES
  };
};

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var LISP_IDENT_RE = '[a-zA-Z_\\-\\+\\*\\/\\<\\=\\>\\&\\#][a-zA-Z0-9_\\-\\+\\*\\/\\<\\=\\>\\&\\#!]*';
  var MEC_RE = '\\|[^]*?\\|';
  var LISP_SIMPLE_NUMBER_RE = '(\\-|\\+)?\\d+(\\.\\d+|\\/\\d+)?((d|e|f|l|s|D|E|F|L|S)(\\+|\\-)?\\d+)?';
  var SHEBANG = {
    className: 'meta',
    begin: '^#!', end: '$'
  };
  var LITERAL = {
    className: 'literal',
    begin: '\\b(t{1}|nil)\\b'
  };
  var NUMBER = {
    className: 'number',
    variants: [
      {begin: LISP_SIMPLE_NUMBER_RE, relevance: 0},
      {begin: '#(b|B)[0-1]+(/[0-1]+)?'},
      {begin: '#(o|O)[0-7]+(/[0-7]+)?'},
      {begin: '#(x|X)[0-9a-fA-F]+(/[0-9a-fA-F]+)?'},
      {begin: '#(c|C)\\(' + LISP_SIMPLE_NUMBER_RE + ' +' + LISP_SIMPLE_NUMBER_RE, end: '\\)'}
    ]
  };
  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null});
  var COMMENT = hljs.COMMENT(
    ';', '$',
    {
      relevance: 0
    }
  );
  var VARIABLE = {
    begin: '\\*', end: '\\*'
  };
  var KEYWORD = {
    className: 'symbol',
    begin: '[:&]' + LISP_IDENT_RE
  };
  var IDENT = {
    begin: LISP_IDENT_RE,
    relevance: 0
  };
  var MEC = {
    begin: MEC_RE
  };
  var QUOTED_LIST = {
    begin: '\\(', end: '\\)',
    contains: ['self', LITERAL, STRING, NUMBER, IDENT]
  };
  var QUOTED = {
    contains: [NUMBER, STRING, VARIABLE, KEYWORD, QUOTED_LIST, IDENT],
    variants: [
      {
        begin: '[\'`]\\(', end: '\\)'
      },
      {
        begin: '\\(quote ', end: '\\)',
        keywords: {name: 'quote'}
      },
      {
        begin: '\'' + MEC_RE
      }
    ]
  };
  var QUOTED_ATOM = {
    variants: [
      {begin: '\'' + LISP_IDENT_RE},
      {begin: '#\'' + LISP_IDENT_RE + '(::' + LISP_IDENT_RE + ')*'}
    ]
  };
  var LIST = {
    begin: '\\(\\s*', end: '\\)'
  };
  var BODY = {
    endsWithParent: true,
    relevance: 0
  };
  LIST.contains = [
    {
      className: 'name',
      variants: [
        {begin: LISP_IDENT_RE},
        {begin: MEC_RE}
      ]
    },
    BODY
  ];
  BODY.contains = [QUOTED, QUOTED_ATOM, LIST, LITERAL, NUMBER, STRING, COMMENT, VARIABLE, KEYWORD, MEC, IDENT];

  return {
    illegal: /\S/,
    contains: [
      NUMBER,
      SHEBANG,
      LITERAL,
      STRING,
      COMMENT,
      QUOTED,
      QUOTED_ATOM,
      LIST,
      IDENT
    ]
  };
};

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var VARIABLE = {
    begin: '\\b[gtps][A-Z]+[A-Za-z0-9_\\-]*\\b|\\$_[A-Z]+',
    relevance: 0
  };
  var COMMENT_MODES = [
    hljs.C_BLOCK_COMMENT_MODE,
    hljs.HASH_COMMENT_MODE,
    hljs.COMMENT('--', '$'),
    hljs.COMMENT('[^:]//', '$')
  ];
  var TITLE1 = hljs.inherit(hljs.TITLE_MODE, {
    variants: [
      {begin: '\\b_*rig[A-Z]+[A-Za-z0-9_\\-]*'},
      {begin: '\\b_[a-z0-9\\-]+'}
    ]
  });
  var TITLE2 = hljs.inherit(hljs.TITLE_MODE, {begin: '\\b([A-Za-z0-9_\\-]+)\\b'});
  return {
    case_insensitive: false,
    keywords: {
      keyword:
        '$_COOKIE $_FILES $_GET $_GET_BINARY $_GET_RAW $_POST $_POST_BINARY $_POST_RAW $_SESSION $_SERVER ' +
        'codepoint codepoints segment segments codeunit codeunits sentence sentences trueWord trueWords paragraph ' +
        'after byte bytes english the until http forever descending using line real8 with seventh ' +
        'for stdout finally element word words fourth before black ninth sixth characters chars stderr ' +
        'uInt1 uInt1s uInt2 uInt2s stdin string lines relative rel any fifth items from middle mid ' +
        'at else of catch then third it file milliseconds seconds second secs sec int1 int1s int4 ' +
        'int4s internet int2 int2s normal text item last long detailed effective uInt4 uInt4s repeat ' +
        'end repeat URL in try into switch to words https token binfile each tenth as ticks tick ' +
        'system real4 by dateItems without char character ascending eighth whole dateTime numeric short ' +
        'first ftp integer abbreviated abbr abbrev private case while if ' +
        'div mod wrap and or bitAnd bitNot bitOr bitXor among not in a an within ' +
        'contains ends with begins the keys of keys',
      literal:
        'SIX TEN FORMFEED NINE ZERO NONE SPACE FOUR FALSE COLON CRLF PI COMMA ENDOFFILE EOF EIGHT FIVE ' +
        'QUOTE EMPTY ONE TRUE RETURN CR LINEFEED RIGHT BACKSLASH NULL SEVEN TAB THREE TWO ' +
        'six ten formfeed nine zero none space four false colon crlf pi comma endoffile eof eight five ' +
        'quote empty one true return cr linefeed right backslash null seven tab three two ' +
        'RIVERSION RISTATE FILE_READ_MODE FILE_WRITE_MODE FILE_WRITE_MODE DIR_WRITE_MODE FILE_READ_UMASK ' +
        'FILE_WRITE_UMASK DIR_READ_UMASK DIR_WRITE_UMASK',
      built_in:
        'put abs acos aliasReference annuity arrayDecode arrayEncode asin atan atan2 average avg avgDev base64Decode ' +
        'base64Encode baseConvert binaryDecode binaryEncode byteOffset byteToNum cachedURL cachedURLs charToNum ' +
        'cipherNames codepointOffset codepointProperty codepointToNum codeunitOffset commandNames compound compress ' +
        'constantNames cos date dateFormat decompress directories ' +
        'diskSpace DNSServers exp exp1 exp2 exp10 extents files flushEvents folders format functionNames geometricMean global ' +
        'globals hasMemory harmonicMean hostAddress hostAddressToName hostName hostNameToAddress isNumber ISOToMac itemOffset ' +
        'keys len length libURLErrorData libUrlFormData libURLftpCommand libURLLastHTTPHeaders libURLLastRHHeaders ' +
        'libUrlMultipartFormAddPart libUrlMultipartFormData libURLVersion lineOffset ln ln1 localNames log log2 log10 ' +
        'longFilePath lower macToISO matchChunk matchText matrixMultiply max md5Digest median merge millisec ' +
        'millisecs millisecond milliseconds min monthNames nativeCharToNum normalizeText num number numToByte numToChar ' +
        'numToCodepoint numToNativeChar offset open openfiles openProcesses openProcessIDs openSockets ' +
        'paragraphOffset paramCount param params peerAddress pendingMessages platform popStdDev populationStandardDeviation ' +
        'populationVariance popVariance processID random randomBytes replaceText result revCreateXMLTree revCreateXMLTreeFromFile ' +
        'revCurrentRecord revCurrentRecordIsFirst revCurrentRecordIsLast revDatabaseColumnCount revDatabaseColumnIsNull ' +
        'revDatabaseColumnLengths revDatabaseColumnNames revDatabaseColumnNamed revDatabaseColumnNumbered ' +
        'revDatabaseColumnTypes revDatabaseConnectResult revDatabaseCursors revDatabaseID revDatabaseTableNames ' +
        'revDatabaseType revDataFromQuery revdb_closeCursor revdb_columnbynumber revdb_columncount revdb_columnisnull ' +
        'revdb_columnlengths revdb_columnnames revdb_columntypes revdb_commit revdb_connect revdb_connections ' +
        'revdb_connectionerr revdb_currentrecord revdb_cursorconnection revdb_cursorerr revdb_cursors revdb_dbtype ' +
        'revdb_disconnect revdb_execute revdb_iseof revdb_isbof revdb_movefirst revdb_movelast revdb_movenext ' +
        'revdb_moveprev revdb_query revdb_querylist revdb_recordcount revdb_rollback revdb_tablenames ' +
        'revGetDatabaseDriverPath revNumberOfRecords revOpenDatabase revOpenDatabases revQueryDatabase ' +
        'revQueryDatabaseBlob revQueryResult revQueryIsAtStart revQueryIsAtEnd revUnixFromMacPath revXMLAttribute ' +
        'revXMLAttributes revXMLAttributeValues revXMLChildContents revXMLChildNames revXMLCreateTreeFromFileWithNamespaces ' +
        'revXMLCreateTreeWithNamespaces revXMLDataFromXPathQuery revXMLEvaluateXPath revXMLFirstChild revXMLMatchingNode ' +
        'revXMLNextSibling revXMLNodeContents revXMLNumberOfChildren revXMLParent revXMLPreviousSibling ' +
        'revXMLRootNode revXMLRPC_CreateRequest revXMLRPC_Documents revXMLRPC_Error ' +
        'revXMLRPC_GetHost revXMLRPC_GetMethod revXMLRPC_GetParam revXMLText revXMLRPC_Execute ' +
        'revXMLRPC_GetParamCount revXMLRPC_GetParamNode revXMLRPC_GetParamType revXMLRPC_GetPath revXMLRPC_GetPort ' +
        'revXMLRPC_GetProtocol revXMLRPC_GetRequest revXMLRPC_GetResponse revXMLRPC_GetSocket revXMLTree ' +
        'revXMLTrees revXMLValidateDTD revZipDescribeItem revZipEnumerateItems revZipOpenArchives round sampVariance ' +
        'sec secs seconds sentenceOffset sha1Digest shell shortFilePath sin specialFolderPath sqrt standardDeviation statRound ' +
        'stdDev sum sysError systemVersion tan tempName textDecode textEncode tick ticks time to tokenOffset toLower toUpper ' +
        'transpose truewordOffset trunc uniDecode uniEncode upper URLDecode URLEncode URLStatus uuid value variableNames ' +
        'variance version waitDepth weekdayNames wordOffset xsltApplyStylesheet xsltApplyStylesheetFromFile xsltLoadStylesheet ' +
        'xsltLoadStylesheetFromFile add breakpoint cancel clear local variable file word line folder directory URL close socket process ' +
        'combine constant convert create new alias folder directory decrypt delete variable word line folder ' +
        'directory URL dispatch divide do encrypt filter get include intersect kill libURLDownloadToFile ' +
        'libURLFollowHttpRedirects libURLftpUpload libURLftpUploadFile libURLresetAll libUrlSetAuthCallback ' +
        'libURLSetCustomHTTPHeaders libUrlSetExpect100 libURLSetFTPListCommand libURLSetFTPMode libURLSetFTPStopTime ' +
        'libURLSetStatusCallback load multiply socket prepare process post seek rel relative read from process rename ' +
        'replace require resetAll resolve revAddXMLNode revAppendXML revCloseCursor revCloseDatabase revCommitDatabase ' +
        'revCopyFile revCopyFolder revCopyXMLNode revDeleteFolder revDeleteXMLNode revDeleteAllXMLTrees ' +
        'revDeleteXMLTree revExecuteSQL revGoURL revInsertXMLNode revMoveFolder revMoveToFirstRecord revMoveToLastRecord ' +
        'revMoveToNextRecord revMoveToPreviousRecord revMoveToRecord revMoveXMLNode revPutIntoXMLNode revRollBackDatabase ' +
        'revSetDatabaseDriverPath revSetXMLAttribute revXMLRPC_AddParam revXMLRPC_DeleteAllDocuments revXMLAddDTD ' +
        'revXMLRPC_Free revXMLRPC_FreeAll revXMLRPC_DeleteDocument revXMLRPC_DeleteParam revXMLRPC_SetHost ' +
        'revXMLRPC_SetMethod revXMLRPC_SetPort revXMLRPC_SetProtocol revXMLRPC_SetSocket revZipAddItemWithData ' +
        'revZipAddItemWithFile revZipAddUncompressedItemWithData revZipAddUncompressedItemWithFile revZipCancel ' +
        'revZipCloseArchive revZipDeleteItem revZipExtractItemToFile revZipExtractItemToVariable revZipSetProgressCallback ' +
        'revZipRenameItem revZipReplaceItemWithData revZipReplaceItemWithFile revZipOpenArchive send set sort split start stop ' +
        'subtract union unload wait write'
    },
    contains: [
      VARIABLE,
      {
        className: 'keyword',
        begin: '\\bend\\sif\\b'
      },
      {
        className: 'function',
        beginKeywords: 'function', end: '$',
        contains: [
          VARIABLE,
          TITLE2,
          hljs.APOS_STRING_MODE,
          hljs.QUOTE_STRING_MODE,
          hljs.BINARY_NUMBER_MODE,
          hljs.C_NUMBER_MODE,
          TITLE1
        ]
      },
      {
        className: 'function',
        begin: '\\bend\\s+', end: '$',
        keywords: 'end',
        contains: [
          TITLE2,
          TITLE1
        ],
        relevance: 0
      },
      {
        beginKeywords: 'command on', end: '$',
        contains: [
          VARIABLE,
          TITLE2,
          hljs.APOS_STRING_MODE,
          hljs.QUOTE_STRING_MODE,
          hljs.BINARY_NUMBER_MODE,
          hljs.C_NUMBER_MODE,
          TITLE1
        ]
      },
      {
        className: 'meta',
        variants: [
          {
            begin: '<\\?(rev|lc|livecode)',
            relevance: 10
          },
          { begin: '<\\?' },
          { begin: '\\?>' }
        ]
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.BINARY_NUMBER_MODE,
      hljs.C_NUMBER_MODE,
      TITLE1
    ].concat(COMMENT_MODES),
    illegal: ';$|^\\[|^=|&|{'
  };
};

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var KEYWORDS = {
    keyword:
      // JS keywords
      'in if for while finally new do return else break catch instanceof throw try this ' +
      'switch continue typeof delete debugger case default function var with ' +
      // LiveScript keywords
      'then unless until loop of by when and or is isnt not it that otherwise from to til fallthrough super ' +
      'case default function var void const let enum export import native ' +
      '__hasProp __extends __slice __bind __indexOf',
    literal:
      // JS literals
      'true false null undefined ' +
      // LiveScript literals
      'yes no on off it that void',
    built_in:
      'npm require console print module global window document'
  };
  var JS_IDENT_RE = '[A-Za-z$_](?:\-[0-9A-Za-z$_]|[0-9A-Za-z$_])*';
  var TITLE = hljs.inherit(hljs.TITLE_MODE, {begin: JS_IDENT_RE});
  var SUBST = {
    className: 'subst',
    begin: /#\{/, end: /}/,
    keywords: KEYWORDS
  };
  var SUBST_SIMPLE = {
    className: 'subst',
    begin: /#[A-Za-z$_]/, end: /(?:\-[0-9A-Za-z$_]|[0-9A-Za-z$_])*/,
    keywords: KEYWORDS
  };
  var EXPRESSIONS = [
    hljs.BINARY_NUMBER_MODE,
    {
      className: 'number',
      begin: '(\\b0[xX][a-fA-F0-9_]+)|(\\b\\d(\\d|_\\d)*(\\.(\\d(\\d|_\\d)*)?)?(_*[eE]([-+]\\d(_\\d|\\d)*)?)?[_a-z]*)',
      relevance: 0,
      starts: {end: '(\\s*/)?', relevance: 0} // a number tries to eat the following slash to prevent treating it as a regexp
    },
    {
      className: 'string',
      variants: [
        {
          begin: /'''/, end: /'''/,
          contains: [hljs.BACKSLASH_ESCAPE]
        },
        {
          begin: /'/, end: /'/,
          contains: [hljs.BACKSLASH_ESCAPE]
        },
        {
          begin: /"""/, end: /"""/,
          contains: [hljs.BACKSLASH_ESCAPE, SUBST, SUBST_SIMPLE]
        },
        {
          begin: /"/, end: /"/,
          contains: [hljs.BACKSLASH_ESCAPE, SUBST, SUBST_SIMPLE]
        },
        {
          begin: /\\/, end: /(\s|$)/,
          excludeEnd: true
        }
      ]
    },
    {
      className: 'regexp',
      variants: [
        {
          begin: '//', end: '//[gim]*',
          contains: [SUBST, hljs.HASH_COMMENT_MODE]
        },
        {
          // regex can't start with space to parse x / 2 / 3 as two divisions
          // regex can't start with *, and it supports an "illegal" in the main mode
          begin: /\/(?![ *])(\\\/|.)*?\/[gim]*(?=\W|$)/
        }
      ]
    },
    {
      begin: '@' + JS_IDENT_RE
    },
    {
      begin: '``', end: '``',
      excludeBegin: true, excludeEnd: true,
      subLanguage: 'javascript'
    }
  ];
  SUBST.contains = EXPRESSIONS;

  var PARAMS = {
    className: 'params',
    begin: '\\(', returnBegin: true,
    /* We need another contained nameless mode to not have every nested
    pair of parens to be called "params" */
    contains: [
      {
        begin: /\(/, end: /\)/,
        keywords: KEYWORDS,
        contains: ['self'].concat(EXPRESSIONS)
      }
    ]
  };

  return {
    aliases: ['ls'],
    keywords: KEYWORDS,
    illegal: /\/\*/,
    contains: EXPRESSIONS.concat([
      hljs.COMMENT('\\/\\*', '\\*\\/'),
      hljs.HASH_COMMENT_MODE,
      {
        className: 'function',
        contains: [TITLE, PARAMS],
        returnBegin: true,
        variants: [
          {
            begin: '(' + JS_IDENT_RE + '\\s*(?:=|:=)\\s*)?(\\(.*\\))?\\s*\\B\\->\\*?', end: '\\->\\*?'
          },
          {
            begin: '(' + JS_IDENT_RE + '\\s*(?:=|:=)\\s*)?!?(\\(.*\\))?\\s*\\B[-~]{1,2}>\\*?', end: '[-~]{1,2}>\\*?'
          },
          {
            begin: '(' + JS_IDENT_RE + '\\s*(?:=|:=)\\s*)?(\\(.*\\))?\\s*\\B!?[-~]{1,2}>\\*?', end: '!?[-~]{1,2}>\\*?'
          }
        ]
      },
      {
        className: 'class',
        beginKeywords: 'class',
        end: '$',
        illegal: /[:="\[\]]/,
        contains: [
          {
            beginKeywords: 'extends',
            endsWithParent: true,
            illegal: /[:="\[\]]/,
            contains: [TITLE]
          },
          TITLE
        ]
      },
      {
        begin: JS_IDENT_RE + ':', end: ':',
        returnBegin: true, returnEnd: true,
        relevance: 0
      }
    ])
  };
};

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var identifier = '([-a-zA-Z$._][\\w\\-$.]*)';
  return {
    //lexemes: '[.%]?' + hljs.IDENT_RE,
    keywords:
      'begin end true false declare define global ' +
      'constant private linker_private internal ' +
      'available_externally linkonce linkonce_odr weak ' +
      'weak_odr appending dllimport dllexport common ' +
      'default hidden protected extern_weak external ' +
      'thread_local zeroinitializer undef null to tail ' +
      'target triple datalayout volatile nuw nsw nnan ' +
      'ninf nsz arcp fast exact inbounds align ' +
      'addrspace section alias module asm sideeffect ' +
      'gc dbg linker_private_weak attributes blockaddress ' +
      'initialexec localdynamic localexec prefix unnamed_addr ' +
      'ccc fastcc coldcc x86_stdcallcc x86_fastcallcc ' +
      'arm_apcscc arm_aapcscc arm_aapcs_vfpcc ptx_device ' +
      'ptx_kernel intel_ocl_bicc msp430_intrcc spir_func ' +
      'spir_kernel x86_64_sysvcc x86_64_win64cc x86_thiscallcc ' +
      'cc c signext zeroext inreg sret nounwind ' +
      'noreturn noalias nocapture byval nest readnone ' +
      'readonly inlinehint noinline alwaysinline optsize ssp ' +
      'sspreq noredzone noimplicitfloat naked builtin cold ' +
      'nobuiltin noduplicate nonlazybind optnone returns_twice ' +
      'sanitize_address sanitize_memory sanitize_thread sspstrong ' +
      'uwtable returned type opaque eq ne slt sgt ' +
      'sle sge ult ugt ule uge oeq one olt ogt ' +
      'ole oge ord uno ueq une x acq_rel acquire ' +
      'alignstack atomic catch cleanup filter inteldialect ' +
      'max min monotonic nand personality release seq_cst ' +
      'singlethread umax umin unordered xchg add fadd ' +
      'sub fsub mul fmul udiv sdiv fdiv urem srem ' +
      'frem shl lshr ashr and or xor icmp fcmp ' +
      'phi call trunc zext sext fptrunc fpext uitofp ' +
      'sitofp fptoui fptosi inttoptr ptrtoint bitcast ' +
      'addrspacecast select va_arg ret br switch invoke ' +
      'unwind unreachable indirectbr landingpad resume ' +
      'malloc alloca free load store getelementptr ' +
      'extractelement insertelement shufflevector getresult ' +
      'extractvalue insertvalue atomicrmw cmpxchg fence ' +
      'argmemonly double',
    contains: [
      {
        className: 'keyword',
        begin: 'i\\d+'
      },
      hljs.COMMENT(
        ';', '\\n', {relevance: 0}
      ),
      // Double quote string
      hljs.QUOTE_STRING_MODE,
      {
        className: 'string',
        variants: [
          // Double-quoted string
          { begin: '"', end: '[^\\\\]"' },
        ],
        relevance: 0
      },
      {
        className: 'title',
        variants: [
          { begin: '@' + identifier },
          { begin: '@\\d+' },
          { begin: '!' + identifier },
          { begin: '!\\d+' + identifier }
        ]
      },
      {
        className: 'symbol',
        variants: [
          { begin: '%' + identifier },
          { begin: '%\\d+' },
          { begin: '#\\d+' },
        ]
      },
      {
        className: 'number',
        variants: [
            { begin: '0[xX][a-fA-F0-9]+' },
            { begin: '-?\\d+(?:[.]\\d+)?(?:[eE][-+]?\\d+(?:[.]\\d+)?)?' }
        ],
        relevance: 0
      },
    ]
  };
};

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports = function(hljs) {

    var LSL_STRING_ESCAPE_CHARS = {
        className: 'subst',
        begin: /\\[tn"\\]/
    };

    var LSL_STRINGS = {
        className: 'string',
        begin: '"',
        end: '"',
        contains: [
            LSL_STRING_ESCAPE_CHARS
        ]
    };

    var LSL_NUMBERS = {
        className: 'number',
        begin: hljs.C_NUMBER_RE
    };

    var LSL_CONSTANTS = {
        className: 'literal',
        variants: [
            {
                begin: '\\b(?:PI|TWO_PI|PI_BY_TWO|DEG_TO_RAD|RAD_TO_DEG|SQRT2)\\b'
            },
            {
                begin: '\\b(?:XP_ERROR_(?:EXPERIENCES_DISABLED|EXPERIENCE_(?:DISABLED|SUSPENDED)|INVALID_(?:EXPERIENCE|PARAMETERS)|KEY_NOT_FOUND|MATURITY_EXCEEDED|NONE|NOT_(?:FOUND|PERMITTED(?:_LAND)?)|NO_EXPERIENCE|QUOTA_EXCEEDED|RETRY_UPDATE|STORAGE_EXCEPTION|STORE_DISABLED|THROTTLED|UNKNOWN_ERROR)|JSON_APPEND|STATUS_(?:PHYSICS|ROTATE_[XYZ]|PHANTOM|SANDBOX|BLOCK_GRAB(?:_OBJECT)?|(?:DIE|RETURN)_AT_EDGE|CAST_SHADOWS|OK|MALFORMED_PARAMS|TYPE_MISMATCH|BOUNDS_ERROR|NOT_(?:FOUND|SUPPORTED)|INTERNAL_ERROR|WHITELIST_FAILED)|AGENT(?:_(?:BY_(?:LEGACY_|USER)NAME|FLYING|ATTACHMENTS|SCRIPTED|MOUSELOOK|SITTING|ON_OBJECT|AWAY|WALKING|IN_AIR|TYPING|CROUCHING|BUSY|ALWAYS_RUN|AUTOPILOT|LIST_(?:PARCEL(?:_OWNER)?|REGION)))?|CAMERA_(?:PITCH|DISTANCE|BEHINDNESS_(?:ANGLE|LAG)|(?:FOCUS|POSITION)(?:_(?:THRESHOLD|LOCKED|LAG))?|FOCUS_OFFSET|ACTIVE)|ANIM_ON|LOOP|REVERSE|PING_PONG|SMOOTH|ROTATE|SCALE|ALL_SIDES|LINK_(?:ROOT|SET|ALL_(?:OTHERS|CHILDREN)|THIS)|ACTIVE|PASS(?:IVE|_(?:ALWAYS|IF_NOT_HANDLED|NEVER))|SCRIPTED|CONTROL_(?:FWD|BACK|(?:ROT_)?(?:LEFT|RIGHT)|UP|DOWN|(?:ML_)?LBUTTON)|PERMISSION_(?:RETURN_OBJECTS|DEBIT|OVERRIDE_ANIMATIONS|SILENT_ESTATE_MANAGEMENT|TAKE_CONTROLS|TRIGGER_ANIMATION|ATTACH|CHANGE_LINKS|(?:CONTROL|TRACK)_CAMERA|TELEPORT)|INVENTORY_(?:TEXTURE|SOUND|OBJECT|SCRIPT|LANDMARK|CLOTHING|NOTECARD|BODYPART|ANIMATION|GESTURE|ALL|NONE)|CHANGED_(?:INVENTORY|COLOR|SHAPE|SCALE|TEXTURE|LINK|ALLOWED_DROP|OWNER|REGION(?:_START)?|TELEPORT|MEDIA)|OBJECT_(?:CLICK_ACTION|HOVER_HEIGHT|LAST_OWNER_ID|(?:PHYSICS|SERVER|STREAMING)_COST|UNKNOWN_DETAIL|CHARACTER_TIME|PHANTOM|PHYSICS|TEMP_ON_REZ|NAME|DESC|POS|PRIM_(?:COUNT|EQUIVALENCE)|RETURN_(?:PARCEL(?:_OWNER)?|REGION)|REZZER_KEY|ROO?T|VELOCITY|OMEGA|OWNER|GROUP|CREATOR|ATTACHED_POINT|RENDER_WEIGHT|(?:BODY_SHAPE|PATHFINDING)_TYPE|(?:RUNNING|TOTAL)_SCRIPT_COUNT|TOTAL_INVENTORY_COUNT|SCRIPT_(?:MEMORY|TIME))|TYPE_(?:INTEGER|FLOAT|STRING|KEY|VECTOR|ROTATION|INVALID)|(?:DEBUG|PUBLIC)_CHANNEL|ATTACH_(?:AVATAR_CENTER|CHEST|HEAD|BACK|PELVIS|MOUTH|CHIN|NECK|NOSE|BELLY|[LR](?:SHOULDER|HAND|FOOT|EAR|EYE|[UL](?:ARM|LEG)|HIP)|(?:LEFT|RIGHT)_PEC|HUD_(?:CENTER_[12]|TOP_(?:RIGHT|CENTER|LEFT)|BOTTOM(?:_(?:RIGHT|LEFT))?)|[LR]HAND_RING1|TAIL_(?:BASE|TIP)|[LR]WING|FACE_(?:JAW|[LR]EAR|[LR]EYE|TOUNGE)|GROIN|HIND_[LR]FOOT)|LAND_(?:LEVEL|RAISE|LOWER|SMOOTH|NOISE|REVERT)|DATA_(?:ONLINE|NAME|BORN|SIM_(?:POS|STATUS|RATING)|PAYINFO)|PAYMENT_INFO_(?:ON_FILE|USED)|REMOTE_DATA_(?:CHANNEL|REQUEST|REPLY)|PSYS_(?:PART_(?:BF_(?:ZERO|ONE(?:_MINUS_(?:DEST_COLOR|SOURCE_(ALPHA|COLOR)))?|DEST_COLOR|SOURCE_(ALPHA|COLOR))|BLEND_FUNC_(DEST|SOURCE)|FLAGS|(?:START|END)_(?:COLOR|ALPHA|SCALE|GLOW)|MAX_AGE|(?:RIBBON|WIND|INTERP_(?:COLOR|SCALE)|BOUNCE|FOLLOW_(?:SRC|VELOCITY)|TARGET_(?:POS|LINEAR)|EMISSIVE)_MASK)|SRC_(?:MAX_AGE|PATTERN|ANGLE_(?:BEGIN|END)|BURST_(?:RATE|PART_COUNT|RADIUS|SPEED_(?:MIN|MAX))|ACCEL|TEXTURE|TARGET_KEY|OMEGA|PATTERN_(?:DROP|EXPLODE|ANGLE(?:_CONE(?:_EMPTY)?)?)))|VEHICLE_(?:REFERENCE_FRAME|TYPE_(?:NONE|SLED|CAR|BOAT|AIRPLANE|BALLOON)|(?:LINEAR|ANGULAR)_(?:FRICTION_TIMESCALE|MOTOR_DIRECTION)|LINEAR_MOTOR_OFFSET|HOVER_(?:HEIGHT|EFFICIENCY|TIMESCALE)|BUOYANCY|(?:LINEAR|ANGULAR)_(?:DEFLECTION_(?:EFFICIENCY|TIMESCALE)|MOTOR_(?:DECAY_)?TIMESCALE)|VERTICAL_ATTRACTION_(?:EFFICIENCY|TIMESCALE)|BANKING_(?:EFFICIENCY|MIX|TIMESCALE)|FLAG_(?:NO_DEFLECTION_UP|LIMIT_(?:ROLL_ONLY|MOTOR_UP)|HOVER_(?:(?:WATER|TERRAIN|UP)_ONLY|GLOBAL_HEIGHT)|MOUSELOOK_(?:STEER|BANK)|CAMERA_DECOUPLED))|PRIM_(?:ALPHA_MODE(?:_(?:BLEND|EMISSIVE|MASK|NONE))?|NORMAL|SPECULAR|TYPE(?:_(?:BOX|CYLINDER|PRISM|SPHERE|TORUS|TUBE|RING|SCULPT))?|HOLE_(?:DEFAULT|CIRCLE|SQUARE|TRIANGLE)|MATERIAL(?:_(?:STONE|METAL|GLASS|WOOD|FLESH|PLASTIC|RUBBER))?|SHINY_(?:NONE|LOW|MEDIUM|HIGH)|BUMP_(?:NONE|BRIGHT|DARK|WOOD|BARK|BRICKS|CHECKER|CONCRETE|TILE|STONE|DISKS|GRAVEL|BLOBS|SIDING|LARGETILE|STUCCO|SUCTION|WEAVE)|TEXGEN_(?:DEFAULT|PLANAR)|SCULPT_(?:TYPE_(?:SPHERE|TORUS|PLANE|CYLINDER|MASK)|FLAG_(?:MIRROR|INVERT))|PHYSICS(?:_(?:SHAPE_(?:CONVEX|NONE|PRIM|TYPE)))?|(?:POS|ROT)_LOCAL|SLICE|TEXT|FLEXIBLE|POINT_LIGHT|TEMP_ON_REZ|PHANTOM|POSITION|SIZE|ROTATION|TEXTURE|NAME|OMEGA|DESC|LINK_TARGET|COLOR|BUMP_SHINY|FULLBRIGHT|TEXGEN|GLOW|MEDIA_(?:ALT_IMAGE_ENABLE|CONTROLS|(?:CURRENT|HOME)_URL|AUTO_(?:LOOP|PLAY|SCALE|ZOOM)|FIRST_CLICK_INTERACT|(?:WIDTH|HEIGHT)_PIXELS|WHITELIST(?:_ENABLE)?|PERMS_(?:INTERACT|CONTROL)|PARAM_MAX|CONTROLS_(?:STANDARD|MINI)|PERM_(?:NONE|OWNER|GROUP|ANYONE)|MAX_(?:URL_LENGTH|WHITELIST_(?:SIZE|COUNT)|(?:WIDTH|HEIGHT)_PIXELS)))|MASK_(?:BASE|OWNER|GROUP|EVERYONE|NEXT)|PERM_(?:TRANSFER|MODIFY|COPY|MOVE|ALL)|PARCEL_(?:MEDIA_COMMAND_(?:STOP|PAUSE|PLAY|LOOP|TEXTURE|URL|TIME|AGENT|UNLOAD|AUTO_ALIGN|TYPE|SIZE|DESC|LOOP_SET)|FLAG_(?:ALLOW_(?:FLY|(?:GROUP_)?SCRIPTS|LANDMARK|TERRAFORM|DAMAGE|CREATE_(?:GROUP_)?OBJECTS)|USE_(?:ACCESS_(?:GROUP|LIST)|BAN_LIST|LAND_PASS_LIST)|LOCAL_SOUND_ONLY|RESTRICT_PUSHOBJECT|ALLOW_(?:GROUP|ALL)_OBJECT_ENTRY)|COUNT_(?:TOTAL|OWNER|GROUP|OTHER|SELECTED|TEMP)|DETAILS_(?:NAME|DESC|OWNER|GROUP|AREA|ID|SEE_AVATARS))|LIST_STAT_(?:MAX|MIN|MEAN|MEDIAN|STD_DEV|SUM(?:_SQUARES)?|NUM_COUNT|GEOMETRIC_MEAN|RANGE)|PAY_(?:HIDE|DEFAULT)|REGION_FLAG_(?:ALLOW_DAMAGE|FIXED_SUN|BLOCK_TERRAFORM|SANDBOX|DISABLE_(?:COLLISIONS|PHYSICS)|BLOCK_FLY|ALLOW_DIRECT_TELEPORT|RESTRICT_PUSHOBJECT)|HTTP_(?:METHOD|MIMETYPE|BODY_(?:MAXLENGTH|TRUNCATED)|CUSTOM_HEADER|PRAGMA_NO_CACHE|VERBOSE_THROTTLE|VERIFY_CERT)|STRING_(?:TRIM(?:_(?:HEAD|TAIL))?)|CLICK_ACTION_(?:NONE|TOUCH|SIT|BUY|PAY|OPEN(?:_MEDIA)?|PLAY|ZOOM)|TOUCH_INVALID_FACE|PROFILE_(?:NONE|SCRIPT_MEMORY)|RC_(?:DATA_FLAGS|DETECT_PHANTOM|GET_(?:LINK_NUM|NORMAL|ROOT_KEY)|MAX_HITS|REJECT_(?:TYPES|AGENTS|(?:NON)?PHYSICAL|LAND))|RCERR_(?:CAST_TIME_EXCEEDED|SIM_PERF_LOW|UNKNOWN)|ESTATE_ACCESS_(?:ALLOWED_(?:AGENT|GROUP)_(?:ADD|REMOVE)|BANNED_AGENT_(?:ADD|REMOVE))|DENSITY|FRICTION|RESTITUTION|GRAVITY_MULTIPLIER|KFM_(?:COMMAND|CMD_(?:PLAY|STOP|PAUSE)|MODE|FORWARD|LOOP|PING_PONG|REVERSE|DATA|ROTATION|TRANSLATION)|ERR_(?:GENERIC|PARCEL_PERMISSIONS|MALFORMED_PARAMS|RUNTIME_PERMISSIONS|THROTTLED)|CHARACTER_(?:CMD_(?:(?:SMOOTH_)?STOP|JUMP)|DESIRED_(?:TURN_)?SPEED|RADIUS|STAY_WITHIN_PARCEL|LENGTH|ORIENTATION|ACCOUNT_FOR_SKIPPED_FRAMES|AVOIDANCE_MODE|TYPE(?:_(?:[ABCD]|NONE))?|MAX_(?:DECEL|TURN_RADIUS|(?:ACCEL|SPEED)))|PURSUIT_(?:OFFSET|FUZZ_FACTOR|GOAL_TOLERANCE|INTERCEPT)|REQUIRE_LINE_OF_SIGHT|FORCE_DIRECT_PATH|VERTICAL|HORIZONTAL|AVOID_(?:CHARACTERS|DYNAMIC_OBSTACLES|NONE)|PU_(?:EVADE_(?:HIDDEN|SPOTTED)|FAILURE_(?:DYNAMIC_PATHFINDING_DISABLED|INVALID_(?:GOAL|START)|NO_(?:NAVMESH|VALID_DESTINATION)|OTHER|TARGET_GONE|(?:PARCEL_)?UNREACHABLE)|(?:GOAL|SLOWDOWN_DISTANCE)_REACHED)|TRAVERSAL_TYPE(?:_(?:FAST|NONE|SLOW))?|CONTENT_TYPE_(?:ATOM|FORM|HTML|JSON|LLSD|RSS|TEXT|XHTML|XML)|GCNP_(?:RADIUS|STATIC)|(?:PATROL|WANDER)_PAUSE_AT_WAYPOINTS|OPT_(?:AVATAR|CHARACTER|EXCLUSION_VOLUME|LEGACY_LINKSET|MATERIAL_VOLUME|OTHER|STATIC_OBSTACLE|WALKABLE)|SIM_STAT_PCT_CHARS_STEPPED)\\b'
            },
            {
                begin: '\\b(?:FALSE|TRUE)\\b'
            },
            {
                begin: '\\b(?:ZERO_ROTATION)\\b'
            },
            {
                begin: '\\b(?:EOF|JSON_(?:ARRAY|DELETE|FALSE|INVALID|NULL|NUMBER|OBJECT|STRING|TRUE)|NULL_KEY|TEXTURE_(?:BLANK|DEFAULT|MEDIA|PLYWOOD|TRANSPARENT)|URL_REQUEST_(?:GRANTED|DENIED))\\b'
            },
            {
                begin: '\\b(?:ZERO_VECTOR|TOUCH_INVALID_(?:TEXCOORD|VECTOR))\\b'
            }
        ]
    };

    var LSL_FUNCTIONS = {
        className: 'built_in',
        begin: '\\b(?:ll(?:AgentInExperience|(?:Create|DataSize|Delete|KeyCount|Keys|Read|Update)KeyValue|GetExperience(?:Details|ErrorMessage)|ReturnObjectsBy(?:ID|Owner)|Json(?:2List|[GS]etValue|ValueType)|Sin|Cos|Tan|Atan2|Sqrt|Pow|Abs|Fabs|Frand|Floor|Ceil|Round|Vec(?:Mag|Norm|Dist)|Rot(?:Between|2(?:Euler|Fwd|Left|Up))|(?:Euler|Axes)2Rot|Whisper|(?:Region|Owner)?Say|Shout|Listen(?:Control|Remove)?|Sensor(?:Repeat|Remove)?|Detected(?:Name|Key|Owner|Type|Pos|Vel|Grab|Rot|Group|LinkNumber)|Die|Ground|Wind|(?:[GS]et)(?:AnimationOverride|MemoryLimit|PrimMediaParams|ParcelMusicURL|Object(?:Desc|Name)|PhysicsMaterial|Status|Scale|Color|Alpha|Texture|Pos|Rot|Force|Torque)|ResetAnimationOverride|(?:Scale|Offset|Rotate)Texture|(?:Rot)?Target(?:Remove)?|(?:Stop)?MoveToTarget|Apply(?:Rotational)?Impulse|Set(?:KeyframedMotion|ContentType|RegionPos|(?:Angular)?Velocity|Buoyancy|HoverHeight|ForceAndTorque|TimerEvent|ScriptState|Damage|TextureAnim|Sound(?:Queueing|Radius)|Vehicle(?:Type|(?:Float|Vector|Rotation)Param)|(?:Touch|Sit)?Text|Camera(?:Eye|At)Offset|PrimitiveParams|ClickAction|Link(?:Alpha|Color|PrimitiveParams(?:Fast)?|Texture(?:Anim)?|Camera|Media)|RemoteScriptAccessPin|PayPrice|LocalRot)|ScaleByFactor|Get(?:(?:Max|Min)ScaleFactor|ClosestNavPoint|StaticPath|SimStats|Env|PrimitiveParams|Link(?:PrimitiveParams|Number(?:OfSides)?|Key|Name|Media)|HTTPHeader|FreeURLs|Object(?:Details|PermMask|PrimCount)|Parcel(?:MaxPrims|Details|Prim(?:Count|Owners))|Attached(?:List)?|(?:SPMax|Free|Used)Memory|Region(?:Name|TimeDilation|FPS|Corner|AgentCount)|Root(?:Position|Rotation)|UnixTime|(?:Parcel|Region)Flags|(?:Wall|GMT)clock|SimulatorHostname|BoundingBox|GeometricCenter|Creator|NumberOf(?:Prims|NotecardLines|Sides)|Animation(?:List)?|(?:Camera|Local)(?:Pos|Rot)|Vel|Accel|Omega|Time(?:stamp|OfDay)|(?:Object|CenterOf)?Mass|MassMKS|Energy|Owner|(?:Owner)?Key|SunDirection|Texture(?:Offset|Scale|Rot)|Inventory(?:Number|Name|Key|Type|Creator|PermMask)|Permissions(?:Key)?|StartParameter|List(?:Length|EntryType)|Date|Agent(?:Size|Info|Language|List)|LandOwnerAt|NotecardLine|Script(?:Name|State))|(?:Get|Reset|GetAndReset)Time|PlaySound(?:Slave)?|LoopSound(?:Master|Slave)?|(?:Trigger|Stop|Preload)Sound|(?:(?:Get|Delete)Sub|Insert)String|To(?:Upper|Lower)|Give(?:InventoryList|Money)|RezObject|(?:Stop)?LookAt|Sleep|CollisionFilter|(?:Take|Release)Controls|DetachFromAvatar|AttachToAvatar(?:Temp)?|InstantMessage|(?:GetNext)?Email|StopHover|MinEventDelay|RotLookAt|String(?:Length|Trim)|(?:Start|Stop)Animation|TargetOmega|Request(?:Experience)?Permissions|(?:Create|Break)Link|BreakAllLinks|(?:Give|Remove)Inventory|Water|PassTouches|Request(?:Agent|Inventory)Data|TeleportAgent(?:Home|GlobalCoords)?|ModifyLand|CollisionSound|ResetScript|MessageLinked|PushObject|PassCollisions|AxisAngle2Rot|Rot2(?:Axis|Angle)|A(?:cos|sin)|AngleBetween|AllowInventoryDrop|SubStringIndex|List2(?:CSV|Integer|Json|Float|String|Key|Vector|Rot|List(?:Strided)?)|DeleteSubList|List(?:Statistics|Sort|Randomize|(?:Insert|Find|Replace)List)|EdgeOfWorld|AdjustSoundVolume|Key2Name|TriggerSoundLimited|EjectFromLand|(?:CSV|ParseString)2List|OverMyLand|SameGroup|UnSit|Ground(?:Slope|Normal|Contour)|GroundRepel|(?:Set|Remove)VehicleFlags|(?:AvatarOn)?(?:Link)?SitTarget|Script(?:Danger|Profiler)|Dialog|VolumeDetect|ResetOtherScript|RemoteLoadScriptPin|(?:Open|Close)RemoteDataChannel|SendRemoteData|RemoteDataReply|(?:Integer|String)ToBase64|XorBase64|Log(?:10)?|Base64To(?:String|Integer)|ParseStringKeepNulls|RezAtRoot|RequestSimulatorData|ForceMouselook|(?:Load|Release|(?:E|Une)scape)URL|ParcelMedia(?:CommandList|Query)|ModPow|MapDestination|(?:RemoveFrom|AddTo|Reset)Land(?:Pass|Ban)List|(?:Set|Clear)CameraParams|HTTP(?:Request|Response)|TextBox|DetectedTouch(?:UV|Face|Pos|(?:N|Bin)ormal|ST)|(?:MD5|SHA1|DumpList2)String|Request(?:Secure)?URL|Clear(?:Prim|Link)Media|(?:Link)?ParticleSystem|(?:Get|Request)(?:Username|DisplayName)|RegionSayTo|CastRay|GenerateKey|TransferLindenDollars|ManageEstateAccess|(?:Create|Delete)Character|ExecCharacterCmd|Evade|FleeFrom|NavigateTo|PatrolPoints|Pursue|UpdateCharacter|WanderWithin))\\b'
    };

    return {
        illegal: ':',
        contains: [
            LSL_STRINGS,
            {
                className: 'comment',
                variants: [
                    hljs.COMMENT('//', '$'),
                    hljs.COMMENT('/\\*', '\\*/')
                ]
            },
            LSL_NUMBERS,
            {
                className: 'section',
                variants: [
                    {
                        begin: '\\b(?:state|default)\\b'
                    },
                    {
                        begin: '\\b(?:state_(?:entry|exit)|touch(?:_(?:start|end))?|(?:land_)?collision(?:_(?:start|end))?|timer|listen|(?:no_)?sensor|control|(?:not_)?at_(?:rot_)?target|money|email|experience_permissions(?:_denied)?|run_time_permissions|changed|attach|dataserver|moving_(?:start|end)|link_message|(?:on|object)_rez|remote_data|http_re(?:sponse|quest)|path_update|transaction_result)\\b'
                    }
                ]
            },
            LSL_FUNCTIONS,
            LSL_CONSTANTS,
            {
                className: 'type',
                begin: '\\b(?:integer|float|string|key|vector|quaternion|rotation|list)\\b'
            }
        ]
    };
};

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var OPENING_LONG_BRACKET = '\\[=*\\[';
  var CLOSING_LONG_BRACKET = '\\]=*\\]';
  var LONG_BRACKETS = {
    begin: OPENING_LONG_BRACKET, end: CLOSING_LONG_BRACKET,
    contains: ['self']
  };
  var COMMENTS = [
    hljs.COMMENT('--(?!' + OPENING_LONG_BRACKET + ')', '$'),
    hljs.COMMENT(
      '--' + OPENING_LONG_BRACKET,
      CLOSING_LONG_BRACKET,
      {
        contains: [LONG_BRACKETS],
        relevance: 10
      }
    )
  ];
  return {
    lexemes: hljs.UNDERSCORE_IDENT_RE,
    keywords: {
      literal: "true false nil",
      keyword: "and break do else elseif end for goto if in local not or repeat return then until while",
      built_in:
        //Metatags and globals:
        '_G _ENV _VERSION __index __newindex __mode __call __metatable __tostring __len ' +
        '__gc __add __sub __mul __div __mod __pow __concat __unm __eq __lt __le assert ' +
        //Standard methods and properties:
        'collectgarbage dofile error getfenv getmetatable ipairs load loadfile loadstring' +
        'module next pairs pcall print rawequal rawget rawset require select setfenv' +
        'setmetatable tonumber tostring type unpack xpcall arg self' +
        //Library methods and properties (one line per library):
        'coroutine resume yield status wrap create running debug getupvalue ' +
        'debug sethook getmetatable gethook setmetatable setlocal traceback setfenv getinfo setupvalue getlocal getregistry getfenv ' +
        'io lines write close flush open output type read stderr stdin input stdout popen tmpfile ' +
        'math log max acos huge ldexp pi cos tanh pow deg tan cosh sinh random randomseed frexp ceil floor rad abs sqrt modf asin min mod fmod log10 atan2 exp sin atan ' +
        'os exit setlocale date getenv difftime remove time clock tmpname rename execute package preload loadlib loaded loaders cpath config path seeall ' +
        'string sub upper len gfind rep find match char dump gmatch reverse byte format gsub lower ' +
        'table setn insert getn foreachi maxn foreach concat sort remove'
    },
    contains: COMMENTS.concat([
      {
        className: 'function',
        beginKeywords: 'function', end: '\\)',
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {begin: '([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*'}),
          {
            className: 'params',
            begin: '\\(', endsWithParent: true,
            contains: COMMENTS
          }
        ].concat(COMMENTS)
      },
      hljs.C_NUMBER_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        className: 'string',
        begin: OPENING_LONG_BRACKET, end: CLOSING_LONG_BRACKET,
        contains: [LONG_BRACKETS],
        relevance: 5
      }
    ])
  };
};

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  /* Variables: simple (eg $(var)) and special (eg $@) */
  var VARIABLE = {
    className: 'variable',
    variants: [
      {
        begin: '\\$\\(' + hljs.UNDERSCORE_IDENT_RE + '\\)',
        contains: [hljs.BACKSLASH_ESCAPE],
      },
      {
        begin: /\$[@%<?\^\+\*]/
      },
    ]
  };
  /* Quoted string with variables inside */
  var QUOTE_STRING = {
    className: 'string',
    begin: /"/, end: /"/,
    contains: [
      hljs.BACKSLASH_ESCAPE,
      VARIABLE,
    ]
  };
  /* Function: $(func arg,...) */
  var FUNC = {
    className: 'variable',
    begin: /\$\([\w-]+\s/, end: /\)/,
    keywords: {
      built_in:
        'subst patsubst strip findstring filter filter-out sort ' +
        'word wordlist firstword lastword dir notdir suffix basename ' +
        'addsuffix addprefix join wildcard realpath abspath error warning ' +
        'shell origin flavor foreach if or and call eval file value',
    },
    contains: [
      VARIABLE,
    ]
  };
  /* Variable assignment */
  var VAR_ASSIG = {
    begin: '^' + hljs.UNDERSCORE_IDENT_RE + '\\s*[:+?]?=',
    illegal: '\\n',
    returnBegin: true,
    contains: [
      {
        begin: '^' + hljs.UNDERSCORE_IDENT_RE, end: '[:+?]?=',
        excludeEnd: true,
      }
    ]
  };
  /* Meta targets (.PHONY) */
  var META = {
    className: 'meta',
    begin: /^\.PHONY:/, end: /$/,
    keywords: {'meta-keyword': '.PHONY'},
    lexemes: /[\.\w]+/
  };
  /* Targets */
  var TARGET = {
    className: 'section',
    begin: /^[^\s]+:/, end: /$/,
    contains: [VARIABLE,]
  };
  return {
    aliases: ['mk', 'mak'],
    keywords:
      'define endef undefine ifdef ifndef ifeq ifneq else endif ' +
      'include -include sinclude override export unexport private vpath',
    lexemes: /[\w-]+/,
    contains: [
      hljs.HASH_COMMENT_MODE,
      VARIABLE,
      QUOTE_STRING,
      FUNC,
      VAR_ASSIG,
      META,
      TARGET,
    ]
  };
};

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    aliases: ['mma'],
    lexemes: '(\\$|\\b)' + hljs.IDENT_RE + '\\b',
    keywords: 'AbelianGroup Abort AbortKernels AbortProtect Above Abs Absolute AbsoluteCorrelation AbsoluteCorrelationFunction AbsoluteCurrentValue AbsoluteDashing AbsoluteFileName AbsoluteOptions AbsolutePointSize AbsoluteThickness AbsoluteTime AbsoluteTiming AccountingForm Accumulate Accuracy AccuracyGoal ActionDelay ActionMenu ActionMenuBox ActionMenuBoxOptions Active ActiveItem ActiveStyle AcyclicGraphQ AddOnHelpPath AddTo AdjacencyGraph AdjacencyList AdjacencyMatrix AdjustmentBox AdjustmentBoxOptions AdjustTimeSeriesForecast AffineTransform After AiryAi AiryAiPrime AiryAiZero AiryBi AiryBiPrime AiryBiZero AlgebraicIntegerQ AlgebraicNumber AlgebraicNumberDenominator AlgebraicNumberNorm AlgebraicNumberPolynomial AlgebraicNumberTrace AlgebraicRules AlgebraicRulesData Algebraics AlgebraicUnitQ Alignment AlignmentMarker AlignmentPoint All AllowedDimensions AllowGroupClose AllowInlineCells AllowKernelInitialization AllowReverseGroupClose AllowScriptLevelChange AlphaChannel AlternatingGroup AlternativeHypothesis Alternatives AmbientLight Analytic AnchoredSearch And AndersonDarlingTest AngerJ AngleBracket AngularGauge Animate AnimationCycleOffset AnimationCycleRepetitions AnimationDirection AnimationDisplayTime AnimationRate AnimationRepetitions AnimationRunning Animator AnimatorBox AnimatorBoxOptions AnimatorElements Annotation Annuity AnnuityDue Antialiasing Antisymmetric Apart ApartSquareFree Appearance AppearanceElements AppellF1 Append AppendTo Apply ArcCos ArcCosh ArcCot ArcCoth ArcCsc ArcCsch ArcSec ArcSech ArcSin ArcSinDistribution ArcSinh ArcTan ArcTanh Arg ArgMax ArgMin ArgumentCountQ ARIMAProcess ArithmeticGeometricMean ARMAProcess ARProcess Array ArrayComponents ArrayDepth ArrayFlatten ArrayPad ArrayPlot ArrayQ ArrayReshape ArrayRules Arrays Arrow Arrow3DBox ArrowBox Arrowheads AspectRatio AspectRatioFixed Assert Assuming Assumptions AstronomicalData Asynchronous AsynchronousTaskObject AsynchronousTasks AtomQ Attributes AugmentedSymmetricPolynomial AutoAction AutoDelete AutoEvaluateEvents AutoGeneratedPackage AutoIndent AutoIndentSpacings AutoItalicWords AutoloadPath AutoMatch Automatic AutomaticImageSize AutoMultiplicationSymbol AutoNumberFormatting AutoOpenNotebooks AutoOpenPalettes AutorunSequencing AutoScaling AutoScroll AutoSpacing AutoStyleOptions AutoStyleWords Axes AxesEdge AxesLabel AxesOrigin AxesStyle Axis ' +
      'BabyMonsterGroupB Back Background BackgroundTasksSettings Backslash Backsubstitution Backward Band BandpassFilter BandstopFilter BarabasiAlbertGraphDistribution BarChart BarChart3D BarLegend BarlowProschanImportance BarnesG BarOrigin BarSpacing BartlettHannWindow BartlettWindow BaseForm Baseline BaselinePosition BaseStyle BatesDistribution BattleLemarieWavelet Because BeckmannDistribution Beep Before Begin BeginDialogPacket BeginFrontEndInteractionPacket BeginPackage BellB BellY Below BenfordDistribution BeniniDistribution BenktanderGibratDistribution BenktanderWeibullDistribution BernoulliB BernoulliDistribution BernoulliGraphDistribution BernoulliProcess BernsteinBasis BesselFilterModel BesselI BesselJ BesselJZero BesselK BesselY BesselYZero Beta BetaBinomialDistribution BetaDistribution BetaNegativeBinomialDistribution BetaPrimeDistribution BetaRegularized BetweennessCentrality BezierCurve BezierCurve3DBox BezierCurve3DBoxOptions BezierCurveBox BezierCurveBoxOptions BezierFunction BilateralFilter Binarize BinaryFormat BinaryImageQ BinaryRead BinaryReadList BinaryWrite BinCounts BinLists Binomial BinomialDistribution BinomialProcess BinormalDistribution BiorthogonalSplineWavelet BipartiteGraphQ BirnbaumImportance BirnbaumSaundersDistribution BitAnd BitClear BitGet BitLength BitNot BitOr BitSet BitShiftLeft BitShiftRight BitXor Black BlackmanHarrisWindow BlackmanNuttallWindow BlackmanWindow Blank BlankForm BlankNullSequence BlankSequence Blend Block BlockRandom BlomqvistBeta BlomqvistBetaTest Blue Blur BodePlot BohmanWindow Bold Bookmarks Boole BooleanConsecutiveFunction BooleanConvert BooleanCountingFunction BooleanFunction BooleanGraph BooleanMaxterms BooleanMinimize BooleanMinterms Booleans BooleanTable BooleanVariables BorderDimensions BorelTannerDistribution Bottom BottomHatTransform BoundaryStyle Bounds Box BoxBaselineShift BoxData BoxDimensions Boxed Boxes BoxForm BoxFormFormatTypes BoxFrame BoxID BoxMargins BoxMatrix BoxRatios BoxRotation BoxRotationPoint BoxStyle BoxWhiskerChart Bra BracketingBar BraKet BrayCurtisDistance BreadthFirstScan Break Brown BrownForsytheTest BrownianBridgeProcess BrowserCategory BSplineBasis BSplineCurve BSplineCurve3DBox BSplineCurveBox BSplineCurveBoxOptions BSplineFunction BSplineSurface BSplineSurface3DBox BubbleChart BubbleChart3D BubbleScale BubbleSizes BulletGauge BusinessDayQ ButterflyGraph ButterworthFilterModel Button ButtonBar ButtonBox ButtonBoxOptions ButtonCell ButtonContents ButtonData ButtonEvaluator ButtonExpandable ButtonFrame ButtonFunction ButtonMargins ButtonMinHeight ButtonNote ButtonNotebook ButtonSource ButtonStyle ButtonStyleMenuListing Byte ByteCount ByteOrdering ' +
      'C CachedValue CacheGraphics CalendarData CalendarType CallPacket CanberraDistance Cancel CancelButton CandlestickChart Cap CapForm CapitalDifferentialD CardinalBSplineBasis CarmichaelLambda Cases Cashflow Casoratian Catalan CatalanNumber Catch CauchyDistribution CauchyWindow CayleyGraph CDF CDFDeploy CDFInformation CDFWavelet Ceiling Cell CellAutoOverwrite CellBaseline CellBoundingBox CellBracketOptions CellChangeTimes CellContents CellContext CellDingbat CellDynamicExpression CellEditDuplicate CellElementsBoundingBox CellElementSpacings CellEpilog CellEvaluationDuplicate CellEvaluationFunction CellEventActions CellFrame CellFrameColor CellFrameLabelMargins CellFrameLabels CellFrameMargins CellGroup CellGroupData CellGrouping CellGroupingRules CellHorizontalScrolling CellID CellLabel CellLabelAutoDelete CellLabelMargins CellLabelPositioning CellMargins CellObject CellOpen CellPrint CellProlog Cells CellSize CellStyle CellTags CellularAutomaton CensoredDistribution Censoring Center CenterDot CentralMoment CentralMomentGeneratingFunction CForm ChampernowneNumber ChanVeseBinarize Character CharacterEncoding CharacterEncodingsPath CharacteristicFunction CharacteristicPolynomial CharacterRange Characters ChartBaseStyle ChartElementData ChartElementDataFunction ChartElementFunction ChartElements ChartLabels ChartLayout ChartLegends ChartStyle Chebyshev1FilterModel Chebyshev2FilterModel ChebyshevDistance ChebyshevT ChebyshevU Check CheckAbort CheckAll Checkbox CheckboxBar CheckboxBox CheckboxBoxOptions ChemicalData ChessboardDistance ChiDistribution ChineseRemainder ChiSquareDistribution ChoiceButtons ChoiceDialog CholeskyDecomposition Chop Circle CircleBox CircleDot CircleMinus CirclePlus CircleTimes CirculantGraph CityData Clear ClearAll ClearAttributes ClearSystemCache ClebschGordan ClickPane Clip ClipboardNotebook ClipFill ClippingStyle ClipPlanes ClipRange Clock ClockGauge ClockwiseContourIntegral Close Closed CloseKernels ClosenessCentrality Closing ClosingAutoSave ClosingEvent ClusteringComponents CMYKColor Coarse Coefficient CoefficientArrays CoefficientDomain CoefficientList CoefficientRules CoifletWavelet Collect Colon ColonForm ColorCombine ColorConvert ColorData ColorDataFunction ColorFunction ColorFunctionScaling Colorize ColorNegate ColorOutput ColorProfileData ColorQuantize ColorReplace ColorRules ColorSelectorSettings ColorSeparate ColorSetter ColorSetterBox ColorSetterBoxOptions ColorSlider ColorSpace Column ColumnAlignments ColumnBackgrounds ColumnForm ColumnLines ColumnsEqual ColumnSpacings ColumnWidths CommonDefaultFormatTypes Commonest CommonestFilter CommonUnits CommunityBoundaryStyle CommunityGraphPlot CommunityLabels CommunityRegionStyle CompatibleUnitQ CompilationOptions CompilationTarget Compile Compiled CompiledFunction Complement CompleteGraph CompleteGraphQ CompleteKaryTree CompletionsListPacket Complex Complexes ComplexExpand ComplexInfinity ComplexityFunction ComponentMeasurements ' +
      'ComponentwiseContextMenu Compose ComposeList ComposeSeries Composition CompoundExpression CompoundPoissonDistribution CompoundPoissonProcess CompoundRenewalProcess Compress CompressedData Condition ConditionalExpression Conditioned Cone ConeBox ConfidenceLevel ConfidenceRange ConfidenceTransform ConfigurationPath Congruent Conjugate ConjugateTranspose Conjunction Connect ConnectedComponents ConnectedGraphQ ConnesWindow ConoverTest ConsoleMessage ConsoleMessagePacket ConsolePrint Constant ConstantArray Constants ConstrainedMax ConstrainedMin ContentPadding ContentsBoundingBox ContentSelectable ContentSize Context ContextMenu Contexts ContextToFilename ContextToFileName Continuation Continue ContinuedFraction ContinuedFractionK ContinuousAction ContinuousMarkovProcess ContinuousTimeModelQ ContinuousWaveletData ContinuousWaveletTransform ContourDetect ContourGraphics ContourIntegral ContourLabels ContourLines ContourPlot ContourPlot3D Contours ContourShading ContourSmoothing ContourStyle ContraharmonicMean Control ControlActive ControlAlignment ControllabilityGramian ControllabilityMatrix ControllableDecomposition ControllableModelQ ControllerDuration ControllerInformation ControllerInformationData ControllerLinking ControllerManipulate ControllerMethod ControllerPath ControllerState ControlPlacement ControlsRendering ControlType Convergents ConversionOptions ConversionRules ConvertToBitmapPacket ConvertToPostScript ConvertToPostScriptPacket Convolve ConwayGroupCo1 ConwayGroupCo2 ConwayGroupCo3 CoordinateChartData CoordinatesToolOptions CoordinateTransform CoordinateTransformData CoprimeQ Coproduct CopulaDistribution Copyable CopyDirectory CopyFile CopyTag CopyToClipboard CornerFilter CornerNeighbors Correlation CorrelationDistance CorrelationFunction CorrelationTest Cos Cosh CoshIntegral CosineDistance CosineWindow CosIntegral Cot Coth Count CounterAssignments CounterBox CounterBoxOptions CounterClockwiseContourIntegral CounterEvaluator CounterFunction CounterIncrements CounterStyle CounterStyleMenuListing CountRoots CountryData Covariance CovarianceEstimatorFunction CovarianceFunction CoxianDistribution CoxIngersollRossProcess CoxModel CoxModelFit CramerVonMisesTest CreateArchive CreateDialog CreateDirectory CreateDocument CreateIntermediateDirectories CreatePalette CreatePalettePacket CreateScheduledTask CreateTemporary CreateWindow CriticalityFailureImportance CriticalitySuccessImportance CriticalSection Cross CrossingDetect CrossMatrix Csc Csch CubeRoot Cubics Cuboid CuboidBox Cumulant CumulantGeneratingFunction Cup CupCap Curl CurlyDoubleQuote CurlyQuote CurrentImage CurrentlySpeakingPacket CurrentValue CurvatureFlowFilter CurveClosed Cyan CycleGraph CycleIndexPolynomial Cycles CyclicGroup Cyclotomic Cylinder CylinderBox CylindricalDecomposition ' +
      'D DagumDistribution DamerauLevenshteinDistance DampingFactor Darker Dashed Dashing DataCompression DataDistribution DataRange DataReversed Date DateDelimiters DateDifference DateFunction DateList DateListLogPlot DateListPlot DatePattern DatePlus DateRange DateString DateTicksFormat DaubechiesWavelet DavisDistribution DawsonF DayCount DayCountConvention DayMatchQ DayName DayPlus DayRange DayRound DeBruijnGraph Debug DebugTag Decimal DeclareKnownSymbols DeclarePackage Decompose Decrement DedekindEta Default DefaultAxesStyle DefaultBaseStyle DefaultBoxStyle DefaultButton DefaultColor DefaultControlPlacement DefaultDuplicateCellStyle DefaultDuration DefaultElement DefaultFaceGridsStyle DefaultFieldHintStyle DefaultFont DefaultFontProperties DefaultFormatType DefaultFormatTypeForStyle DefaultFrameStyle DefaultFrameTicksStyle DefaultGridLinesStyle DefaultInlineFormatType DefaultInputFormatType DefaultLabelStyle DefaultMenuStyle DefaultNaturalLanguage DefaultNewCellStyle DefaultNewInlineCellStyle DefaultNotebook DefaultOptions DefaultOutputFormatType DefaultStyle DefaultStyleDefinitions DefaultTextFormatType DefaultTextInlineFormatType DefaultTicksStyle DefaultTooltipStyle DefaultValues Defer DefineExternal DefineInputStreamMethod DefineOutputStreamMethod Definition Degree DegreeCentrality DegreeGraphDistribution DegreeLexicographic DegreeReverseLexicographic Deinitialization Del Deletable Delete DeleteBorderComponents DeleteCases DeleteContents DeleteDirectory DeleteDuplicates DeleteFile DeleteSmallComponents DeleteWithContents DeletionWarning Delimiter DelimiterFlashTime DelimiterMatching Delimiters Denominator DensityGraphics DensityHistogram DensityPlot DependentVariables Deploy Deployed Depth DepthFirstScan Derivative DerivativeFilter DescriptorStateSpace DesignMatrix Det DGaussianWavelet DiacriticalPositioning Diagonal DiagonalMatrix Dialog DialogIndent DialogInput DialogLevel DialogNotebook DialogProlog DialogReturn DialogSymbols Diamond DiamondMatrix DiceDissimilarity DictionaryLookup DifferenceDelta DifferenceOrder DifferenceRoot DifferenceRootReduce Differences DifferentialD DifferentialRoot DifferentialRootReduce DifferentiatorFilter DigitBlock DigitBlockMinimum DigitCharacter DigitCount DigitQ DihedralGroup Dilation Dimensions DiracComb DiracDelta DirectedEdge DirectedEdges DirectedGraph DirectedGraphQ DirectedInfinity Direction Directive Directory DirectoryName DirectoryQ DirectoryStack DirichletCharacter DirichletConvolve DirichletDistribution DirichletL DirichletTransform DirichletWindow DisableConsolePrintPacket DiscreteChirpZTransform DiscreteConvolve DiscreteDelta DiscreteHadamardTransform DiscreteIndicator DiscreteLQEstimatorGains DiscreteLQRegulatorGains DiscreteLyapunovSolve DiscreteMarkovProcess DiscretePlot DiscretePlot3D DiscreteRatio DiscreteRiccatiSolve DiscreteShift DiscreteTimeModelQ DiscreteUniformDistribution DiscreteVariables DiscreteWaveletData DiscreteWaveletPacketTransform ' +
      'DiscreteWaveletTransform Discriminant Disjunction Disk DiskBox DiskMatrix Dispatch DispersionEstimatorFunction Display DisplayAllSteps DisplayEndPacket DisplayFlushImagePacket DisplayForm DisplayFunction DisplayPacket DisplayRules DisplaySetSizePacket DisplayString DisplayTemporary DisplayWith DisplayWithRef DisplayWithVariable DistanceFunction DistanceTransform Distribute Distributed DistributedContexts DistributeDefinitions DistributionChart DistributionDomain DistributionFitTest DistributionParameterAssumptions DistributionParameterQ Dithering Div Divergence Divide DivideBy Dividers Divisible Divisors DivisorSigma DivisorSum DMSList DMSString Do DockedCells DocumentNotebook DominantColors DOSTextFormat Dot DotDashed DotEqual Dotted DoubleBracketingBar DoubleContourIntegral DoubleDownArrow DoubleLeftArrow DoubleLeftRightArrow DoubleLeftTee DoubleLongLeftArrow DoubleLongLeftRightArrow DoubleLongRightArrow DoubleRightArrow DoubleRightTee DoubleUpArrow DoubleUpDownArrow DoubleVerticalBar DoublyInfinite Down DownArrow DownArrowBar DownArrowUpArrow DownLeftRightVector DownLeftTeeVector DownLeftVector DownLeftVectorBar DownRightTeeVector DownRightVector DownRightVectorBar Downsample DownTee DownTeeArrow DownValues DragAndDrop DrawEdges DrawFrontFaces DrawHighlighted Drop DSolve Dt DualLinearProgramming DualSystemsModel DumpGet DumpSave DuplicateFreeQ Dynamic DynamicBox DynamicBoxOptions DynamicEvaluationTimeout DynamicLocation DynamicModule DynamicModuleBox DynamicModuleBoxOptions DynamicModuleParent DynamicModuleValues DynamicName DynamicNamespace DynamicReference DynamicSetting DynamicUpdating DynamicWrapper DynamicWrapperBox DynamicWrapperBoxOptions ' +
      'E EccentricityCentrality EdgeAdd EdgeBetweennessCentrality EdgeCapacity EdgeCapForm EdgeColor EdgeConnectivity EdgeCost EdgeCount EdgeCoverQ EdgeDashing EdgeDelete EdgeDetect EdgeForm EdgeIndex EdgeJoinForm EdgeLabeling EdgeLabels EdgeLabelStyle EdgeList EdgeOpacity EdgeQ EdgeRenderingFunction EdgeRules EdgeShapeFunction EdgeStyle EdgeThickness EdgeWeight Editable EditButtonSettings EditCellTagsSettings EditDistance EffectiveInterest Eigensystem Eigenvalues EigenvectorCentrality Eigenvectors Element ElementData Eliminate EliminationOrder EllipticE EllipticExp EllipticExpPrime EllipticF EllipticFilterModel EllipticK EllipticLog EllipticNomeQ EllipticPi EllipticReducedHalfPeriods EllipticTheta EllipticThetaPrime EmitSound EmphasizeSyntaxErrors EmpiricalDistribution Empty EmptyGraphQ EnableConsolePrintPacket Enabled Encode End EndAdd EndDialogPacket EndFrontEndInteractionPacket EndOfFile EndOfLine EndOfString EndPackage EngineeringForm Enter EnterExpressionPacket EnterTextPacket Entropy EntropyFilter Environment Epilog Equal EqualColumns EqualRows EqualTilde EquatedTo Equilibrium EquirippleFilterKernel Equivalent Erf Erfc Erfi ErlangB ErlangC ErlangDistribution Erosion ErrorBox ErrorBoxOptions ErrorNorm ErrorPacket ErrorsDialogSettings EstimatedDistribution EstimatedProcess EstimatorGains EstimatorRegulator EuclideanDistance EulerE EulerGamma EulerianGraphQ EulerPhi Evaluatable Evaluate Evaluated EvaluatePacket EvaluationCell EvaluationCompletionAction EvaluationElements EvaluationMode EvaluationMonitor EvaluationNotebook EvaluationObject EvaluationOrder Evaluator EvaluatorNames EvenQ EventData EventEvaluator EventHandler EventHandlerTag EventLabels ExactBlackmanWindow ExactNumberQ ExactRootIsolation ExampleData Except ExcludedForms ExcludePods Exclusions ExclusionsStyle Exists Exit ExitDialog Exp Expand ExpandAll ExpandDenominator ExpandFileName ExpandNumerator Expectation ExpectationE ExpectedValue ExpGammaDistribution ExpIntegralE ExpIntegralEi Exponent ExponentFunction ExponentialDistribution ExponentialFamily ExponentialGeneratingFunction ExponentialMovingAverage ExponentialPowerDistribution ExponentPosition ExponentStep Export ExportAutoReplacements ExportPacket ExportString Expression ExpressionCell ExpressionPacket ExpToTrig ExtendedGCD Extension ExtentElementFunction ExtentMarkers ExtentSize ExternalCall ExternalDataCharacterEncoding Extract ExtractArchive ExtremeValueDistribution ' +
      'FaceForm FaceGrids FaceGridsStyle Factor FactorComplete Factorial Factorial2 FactorialMoment FactorialMomentGeneratingFunction FactorialPower FactorInteger FactorList FactorSquareFree FactorSquareFreeList FactorTerms FactorTermsList Fail FailureDistribution False FARIMAProcess FEDisableConsolePrintPacket FeedbackSector FeedbackSectorStyle FeedbackType FEEnableConsolePrintPacket Fibonacci FieldHint FieldHintStyle FieldMasked FieldSize File FileBaseName FileByteCount FileDate FileExistsQ FileExtension FileFormat FileHash FileInformation FileName FileNameDepth FileNameDialogSettings FileNameDrop FileNameJoin FileNames FileNameSetter FileNameSplit FileNameTake FilePrint FileType FilledCurve FilledCurveBox Filling FillingStyle FillingTransform FilterRules FinancialBond FinancialData FinancialDerivative FinancialIndicator Find FindArgMax FindArgMin FindClique FindClusters FindCurvePath FindDistributionParameters FindDivisions FindEdgeCover FindEdgeCut FindEulerianCycle FindFaces FindFile FindFit FindGeneratingFunction FindGeoLocation FindGeometricTransform FindGraphCommunities FindGraphIsomorphism FindGraphPartition FindHamiltonianCycle FindIndependentEdgeSet FindIndependentVertexSet FindInstance FindIntegerNullVector FindKClan FindKClique FindKClub FindKPlex FindLibrary FindLinearRecurrence FindList FindMaximum FindMaximumFlow FindMaxValue FindMinimum FindMinimumCostFlow FindMinimumCut FindMinValue FindPermutation FindPostmanTour FindProcessParameters FindRoot FindSequenceFunction FindSettings FindShortestPath FindShortestTour FindThreshold FindVertexCover FindVertexCut Fine FinishDynamic FiniteAbelianGroupCount FiniteGroupCount FiniteGroupData First FirstPassageTimeDistribution FischerGroupFi22 FischerGroupFi23 FischerGroupFi24Prime FisherHypergeometricDistribution FisherRatioTest FisherZDistribution Fit FitAll FittedModel FixedPoint FixedPointList FlashSelection Flat Flatten FlattenAt FlatTopWindow FlipView Floor FlushPrintOutputPacket Fold FoldList Font FontColor FontFamily FontForm FontName FontOpacity FontPostScriptName FontProperties FontReencoding FontSize FontSlant FontSubstitutions FontTracking FontVariations FontWeight For ForAll Format FormatRules FormatType FormatTypeAutoConvert FormatValues FormBox FormBoxOptions FortranForm Forward ForwardBackward Fourier FourierCoefficient FourierCosCoefficient FourierCosSeries FourierCosTransform FourierDCT FourierDCTFilter FourierDCTMatrix FourierDST FourierDSTMatrix FourierMatrix FourierParameters FourierSequenceTransform FourierSeries FourierSinCoefficient FourierSinSeries FourierSinTransform FourierTransform FourierTrigSeries FractionalBrownianMotionProcess FractionalPart FractionBox FractionBoxOptions FractionLine Frame FrameBox FrameBoxOptions Framed FrameInset FrameLabel Frameless FrameMargins FrameStyle FrameTicks FrameTicksStyle FRatioDistribution FrechetDistribution FreeQ FrequencySamplingFilterKernel FresnelC FresnelS Friday FrobeniusNumber FrobeniusSolve ' +
      'FromCharacterCode FromCoefficientRules FromContinuedFraction FromDate FromDigits FromDMS Front FrontEndDynamicExpression FrontEndEventActions FrontEndExecute FrontEndObject FrontEndResource FrontEndResourceString FrontEndStackSize FrontEndToken FrontEndTokenExecute FrontEndValueCache FrontEndVersion FrontFaceColor FrontFaceOpacity Full FullAxes FullDefinition FullForm FullGraphics FullOptions FullSimplify Function FunctionExpand FunctionInterpolation FunctionSpace FussellVeselyImportance ' +
      'GaborFilter GaborMatrix GaborWavelet GainMargins GainPhaseMargins Gamma GammaDistribution GammaRegularized GapPenalty Gather GatherBy GaugeFaceElementFunction GaugeFaceStyle GaugeFrameElementFunction GaugeFrameSize GaugeFrameStyle GaugeLabels GaugeMarkers GaugeStyle GaussianFilter GaussianIntegers GaussianMatrix GaussianWindow GCD GegenbauerC General GeneralizedLinearModelFit GenerateConditions GeneratedCell GeneratedParameters GeneratingFunction Generic GenericCylindricalDecomposition GenomeData GenomeLookup GeodesicClosing GeodesicDilation GeodesicErosion GeodesicOpening GeoDestination GeodesyData GeoDirection GeoDistance GeoGridPosition GeometricBrownianMotionProcess GeometricDistribution GeometricMean GeometricMeanFilter GeometricTransformation GeometricTransformation3DBox GeometricTransformation3DBoxOptions GeometricTransformationBox GeometricTransformationBoxOptions GeoPosition GeoPositionENU GeoPositionXYZ GeoProjectionData GestureHandler GestureHandlerTag Get GetBoundingBoxSizePacket GetContext GetEnvironment GetFileName GetFrontEndOptionsDataPacket GetLinebreakInformationPacket GetMenusPacket GetPageBreakInformationPacket Glaisher GlobalClusteringCoefficient GlobalPreferences GlobalSession Glow GoldenRatio GompertzMakehamDistribution GoodmanKruskalGamma GoodmanKruskalGammaTest Goto Grad Gradient GradientFilter GradientOrientationFilter Graph GraphAssortativity GraphCenter GraphComplement GraphData GraphDensity GraphDiameter GraphDifference GraphDisjointUnion ' +
      'GraphDistance GraphDistanceMatrix GraphElementData GraphEmbedding GraphHighlight GraphHighlightStyle GraphHub Graphics Graphics3D Graphics3DBox Graphics3DBoxOptions GraphicsArray GraphicsBaseline GraphicsBox GraphicsBoxOptions GraphicsColor GraphicsColumn GraphicsComplex GraphicsComplex3DBox GraphicsComplex3DBoxOptions GraphicsComplexBox GraphicsComplexBoxOptions GraphicsContents GraphicsData GraphicsGrid GraphicsGridBox GraphicsGroup GraphicsGroup3DBox GraphicsGroup3DBoxOptions GraphicsGroupBox GraphicsGroupBoxOptions GraphicsGrouping GraphicsHighlightColor GraphicsRow GraphicsSpacing GraphicsStyle GraphIntersection GraphLayout GraphLinkEfficiency GraphPeriphery GraphPlot GraphPlot3D GraphPower GraphPropertyDistribution GraphQ GraphRadius GraphReciprocity GraphRoot GraphStyle GraphUnion Gray GrayLevel GreatCircleDistance Greater GreaterEqual GreaterEqualLess GreaterFullEqual GreaterGreater GreaterLess GreaterSlantEqual GreaterTilde Green Grid GridBaseline GridBox GridBoxAlignment GridBoxBackground GridBoxDividers GridBoxFrame GridBoxItemSize GridBoxItemStyle GridBoxOptions GridBoxSpacings GridCreationSettings GridDefaultElement GridElementStyleOptions GridFrame GridFrameMargins GridGraph GridLines GridLinesStyle GroebnerBasis GroupActionBase GroupCentralizer GroupElementFromWord GroupElementPosition GroupElementQ GroupElements GroupElementToWord GroupGenerators GroupMultiplicationTable GroupOrbits GroupOrder GroupPageBreakWithin GroupSetwiseStabilizer GroupStabilizer GroupStabilizerChain Gudermannian GumbelDistribution ' +
      'HaarWavelet HadamardMatrix HalfNormalDistribution HamiltonianGraphQ HammingDistance HammingWindow HankelH1 HankelH2 HankelMatrix HannPoissonWindow HannWindow HaradaNortonGroupHN HararyGraph HarmonicMean HarmonicMeanFilter HarmonicNumber Hash HashTable Haversine HazardFunction Head HeadCompose Heads HeavisideLambda HeavisidePi HeavisideTheta HeldGroupHe HeldPart HelpBrowserLookup HelpBrowserNotebook HelpBrowserSettings HermiteDecomposition HermiteH HermitianMatrixQ HessenbergDecomposition Hessian HexadecimalCharacter Hexahedron HexahedronBox HexahedronBoxOptions HiddenSurface HighlightGraph HighlightImage HighpassFilter HigmanSimsGroupHS HilbertFilter HilbertMatrix Histogram Histogram3D HistogramDistribution HistogramList HistogramTransform HistogramTransformInterpolation HitMissTransform HITSCentrality HodgeDual HoeffdingD HoeffdingDTest Hold HoldAll HoldAllComplete HoldComplete HoldFirst HoldForm HoldPattern HoldRest HolidayCalendar HomeDirectory HomePage Horizontal HorizontalForm HorizontalGauge HorizontalScrollPosition HornerForm HotellingTSquareDistribution HoytDistribution HTMLSave Hue HumpDownHump HumpEqual HurwitzLerchPhi HurwitzZeta HyperbolicDistribution HypercubeGraph HyperexponentialDistribution Hyperfactorial Hypergeometric0F1 Hypergeometric0F1Regularized Hypergeometric1F1 Hypergeometric1F1Regularized Hypergeometric2F1 Hypergeometric2F1Regularized HypergeometricDistribution HypergeometricPFQ HypergeometricPFQRegularized HypergeometricU Hyperlink HyperlinkCreationSettings Hyphenation HyphenationOptions HypoexponentialDistribution HypothesisTestData ' +
      'I Identity IdentityMatrix If IgnoreCase Im Image Image3D Image3DSlices ImageAccumulate ImageAdd ImageAdjust ImageAlign ImageApply ImageAspectRatio ImageAssemble ImageCache ImageCacheValid ImageCapture ImageChannels ImageClip ImageColorSpace ImageCompose ImageConvolve ImageCooccurrence ImageCorners ImageCorrelate ImageCorrespondingPoints ImageCrop ImageData ImageDataPacket ImageDeconvolve ImageDemosaic ImageDifference ImageDimensions ImageDistance ImageEffect ImageFeatureTrack ImageFileApply ImageFileFilter ImageFileScan ImageFilter ImageForestingComponents ImageForwardTransformation ImageHistogram ImageKeypoints ImageLevels ImageLines ImageMargins ImageMarkers ImageMeasurements ImageMultiply ImageOffset ImagePad ImagePadding ImagePartition ImagePeriodogram ImagePerspectiveTransformation ImageQ ImageRangeCache ImageReflect ImageRegion ImageResize ImageResolution ImageRotate ImageRotated ImageScaled ImageScan ImageSize ImageSizeAction ImageSizeCache ImageSizeMultipliers ImageSizeRaw ImageSubtract ImageTake ImageTransformation ImageTrim ImageType ImageValue ImageValuePositions Implies Import ImportAutoReplacements ImportString ImprovementImportance In IncidenceGraph IncidenceList IncidenceMatrix IncludeConstantBasis IncludeFileExtension IncludePods IncludeSingularTerm Increment Indent IndentingNewlineSpacings IndentMaxFraction IndependenceTest IndependentEdgeSetQ IndependentUnit IndependentVertexSetQ Indeterminate IndexCreationOptions Indexed IndexGraph IndexTag Inequality InexactNumberQ InexactNumbers Infinity Infix Information Inherited InheritScope Initialization InitializationCell InitializationCellEvaluation InitializationCellWarning InlineCounterAssignments InlineCounterIncrements InlineRules Inner Inpaint Input InputAliases InputAssumptions InputAutoReplacements InputField InputFieldBox InputFieldBoxOptions InputForm InputGrouping InputNamePacket InputNotebook InputPacket InputSettings InputStream InputString InputStringPacket InputToBoxFormPacket Insert InsertionPointObject InsertResults Inset Inset3DBox Inset3DBoxOptions InsetBox InsetBoxOptions Install InstallService InString Integer IntegerDigits IntegerExponent IntegerLength IntegerPart IntegerPartitions IntegerQ Integers IntegerString Integral Integrate Interactive InteractiveTradingChart Interlaced Interleaving InternallyBalancedDecomposition InterpolatingFunction InterpolatingPolynomial Interpolation InterpolationOrder InterpolationPoints InterpolationPrecision Interpretation InterpretationBox InterpretationBoxOptions InterpretationFunction ' +
      'InterpretTemplate InterquartileRange Interrupt InterruptSettings Intersection Interval IntervalIntersection IntervalMemberQ IntervalUnion Inverse InverseBetaRegularized InverseCDF InverseChiSquareDistribution InverseContinuousWaveletTransform InverseDistanceTransform InverseEllipticNomeQ InverseErf InverseErfc InverseFourier InverseFourierCosTransform InverseFourierSequenceTransform InverseFourierSinTransform InverseFourierTransform InverseFunction InverseFunctions InverseGammaDistribution InverseGammaRegularized InverseGaussianDistribution InverseGudermannian InverseHaversine InverseJacobiCD InverseJacobiCN InverseJacobiCS InverseJacobiDC InverseJacobiDN InverseJacobiDS InverseJacobiNC InverseJacobiND InverseJacobiNS InverseJacobiSC InverseJacobiSD InverseJacobiSN InverseLaplaceTransform InversePermutation InverseRadon InverseSeries InverseSurvivalFunction InverseWaveletTransform InverseWeierstrassP InverseZTransform Invisible InvisibleApplication InvisibleTimes IrreduciblePolynomialQ IsolatingInterval IsomorphicGraphQ IsotopeData Italic Item ItemBox ItemBoxOptions ItemSize ItemStyle ItoProcess ' +
      'JaccardDissimilarity JacobiAmplitude Jacobian JacobiCD JacobiCN JacobiCS JacobiDC JacobiDN JacobiDS JacobiNC JacobiND JacobiNS JacobiP JacobiSC JacobiSD JacobiSN JacobiSymbol JacobiZeta JankoGroupJ1 JankoGroupJ2 JankoGroupJ3 JankoGroupJ4 JarqueBeraALMTest JohnsonDistribution Join Joined JoinedCurve JoinedCurveBox JoinForm JordanDecomposition JordanModelDecomposition ' +
      'K KagiChart KaiserBesselWindow KaiserWindow KalmanEstimator KalmanFilter KarhunenLoeveDecomposition KaryTree KatzCentrality KCoreComponents KDistribution KelvinBei KelvinBer KelvinKei KelvinKer KendallTau KendallTauTest KernelExecute KernelMixtureDistribution KernelObject Kernels Ket Khinchin KirchhoffGraph KirchhoffMatrix KleinInvariantJ KnightTourGraph KnotData KnownUnitQ KolmogorovSmirnovTest KroneckerDelta KroneckerModelDecomposition KroneckerProduct KroneckerSymbol KuiperTest KumaraswamyDistribution Kurtosis KuwaharaFilter ' +
      'Label Labeled LabeledSlider LabelingFunction LabelStyle LaguerreL LambdaComponents LambertW LanczosWindow LandauDistribution Language LanguageCategory LaplaceDistribution LaplaceTransform Laplacian LaplacianFilter LaplacianGaussianFilter Large Larger Last Latitude LatitudeLongitude LatticeData LatticeReduce Launch LaunchKernels LayeredGraphPlot LayerSizeFunction LayoutInformation LCM LeafCount LeapYearQ LeastSquares LeastSquaresFilterKernel Left LeftArrow LeftArrowBar LeftArrowRightArrow LeftDownTeeVector LeftDownVector LeftDownVectorBar LeftRightArrow LeftRightVector LeftTee LeftTeeArrow LeftTeeVector LeftTriangle LeftTriangleBar LeftTriangleEqual LeftUpDownVector LeftUpTeeVector LeftUpVector LeftUpVectorBar LeftVector LeftVectorBar LegendAppearance Legended LegendFunction LegendLabel LegendLayout LegendMargins LegendMarkers LegendMarkerSize LegendreP LegendreQ LegendreType Length LengthWhile LerchPhi Less LessEqual LessEqualGreater LessFullEqual LessGreater LessLess LessSlantEqual LessTilde LetterCharacter LetterQ Level LeveneTest LeviCivitaTensor LevyDistribution Lexicographic LibraryFunction LibraryFunctionError LibraryFunctionInformation LibraryFunctionLoad LibraryFunctionUnload LibraryLoad LibraryUnload LicenseID LiftingFilterData LiftingWaveletTransform LightBlue LightBrown LightCyan Lighter LightGray LightGreen Lighting LightingAngle LightMagenta LightOrange LightPink LightPurple LightRed LightSources LightYellow Likelihood Limit LimitsPositioning LimitsPositioningTokens LindleyDistribution Line Line3DBox LinearFilter LinearFractionalTransform LinearModelFit LinearOffsetFunction LinearProgramming LinearRecurrence LinearSolve LinearSolveFunction LineBox LineBreak LinebreakAdjustments LineBreakChart LineBreakWithin LineColor LineForm LineGraph LineIndent LineIndentMaxFraction LineIntegralConvolutionPlot LineIntegralConvolutionScale LineLegend LineOpacity LineSpacing LineWrapParts LinkActivate LinkClose LinkConnect LinkConnectedQ LinkCreate LinkError LinkFlush LinkFunction LinkHost LinkInterrupt LinkLaunch LinkMode LinkObject LinkOpen LinkOptions LinkPatterns LinkProtocol LinkRead LinkReadHeld LinkReadyQ Links LinkWrite LinkWriteHeld LiouvilleLambda List Listable ListAnimate ListContourPlot ListContourPlot3D ListConvolve ListCorrelate ListCurvePathPlot ListDeconvolve ListDensityPlot Listen ListFourierSequenceTransform ListInterpolation ListLineIntegralConvolutionPlot ListLinePlot ListLogLinearPlot ListLogLogPlot ListLogPlot ListPicker ListPickerBox ListPickerBoxBackground ListPickerBoxOptions ListPlay ListPlot ListPlot3D ListPointPlot3D ListPolarPlot ListQ ListStreamDensityPlot ListStreamPlot ListSurfacePlot3D ListVectorDensityPlot ListVectorPlot ListVectorPlot3D ListZTransform Literal LiteralSearch LocalClusteringCoefficient LocalizeVariables LocationEquivalenceTest LocationTest Locator LocatorAutoCreate LocatorBox LocatorBoxOptions LocatorCentering LocatorPane LocatorPaneBox LocatorPaneBoxOptions ' +
      'LocatorRegion Locked Log Log10 Log2 LogBarnesG LogGamma LogGammaDistribution LogicalExpand LogIntegral LogisticDistribution LogitModelFit LogLikelihood LogLinearPlot LogLogisticDistribution LogLogPlot LogMultinormalDistribution LogNormalDistribution LogPlot LogRankTest LogSeriesDistribution LongEqual Longest LongestAscendingSequence LongestCommonSequence LongestCommonSequencePositions LongestCommonSubsequence LongestCommonSubsequencePositions LongestMatch LongForm Longitude LongLeftArrow LongLeftRightArrow LongRightArrow Loopback LoopFreeGraphQ LowerCaseQ LowerLeftArrow LowerRightArrow LowerTriangularize LowpassFilter LQEstimatorGains LQGRegulator LQOutputRegulatorGains LQRegulatorGains LUBackSubstitution LucasL LuccioSamiComponents LUDecomposition LyapunovSolve LyonsGroupLy ' +
      'MachineID MachineName MachineNumberQ MachinePrecision MacintoshSystemPageSetup Magenta Magnification Magnify MainSolve MaintainDynamicCaches Majority MakeBoxes MakeExpression MakeRules MangoldtLambda ManhattanDistance Manipulate Manipulator MannWhitneyTest MantissaExponent Manual Map MapAll MapAt MapIndexed MAProcess MapThread MarcumQ MardiaCombinedTest MardiaKurtosisTest MardiaSkewnessTest MarginalDistribution MarkovProcessProperties Masking MatchingDissimilarity MatchLocalNameQ MatchLocalNames MatchQ Material MathematicaNotation MathieuC MathieuCharacteristicA MathieuCharacteristicB MathieuCharacteristicExponent MathieuCPrime MathieuGroupM11 MathieuGroupM12 MathieuGroupM22 MathieuGroupM23 MathieuGroupM24 MathieuS MathieuSPrime MathMLForm MathMLText Matrices MatrixExp MatrixForm MatrixFunction MatrixLog MatrixPlot MatrixPower MatrixQ MatrixRank Max MaxBend MaxDetect MaxExtraBandwidths MaxExtraConditions MaxFeatures MaxFilter Maximize MaxIterations MaxMemoryUsed MaxMixtureKernels MaxPlotPoints MaxPoints MaxRecursion MaxStableDistribution MaxStepFraction MaxSteps MaxStepSize MaxValue MaxwellDistribution McLaughlinGroupMcL Mean MeanClusteringCoefficient MeanDegreeConnectivity MeanDeviation MeanFilter MeanGraphDistance MeanNeighborDegree MeanShift MeanShiftFilter Median MedianDeviation MedianFilter Medium MeijerG MeixnerDistribution MemberQ MemoryConstrained MemoryInUse Menu MenuAppearance MenuCommandKey MenuEvaluator MenuItem MenuPacket MenuSortingValue MenuStyle MenuView MergeDifferences Mesh MeshFunctions MeshRange MeshShading MeshStyle Message MessageDialog MessageList MessageName MessageOptions MessagePacket Messages MessagesNotebook MetaCharacters MetaInformation Method MethodOptions MexicanHatWavelet MeyerWavelet Min MinDetect MinFilter MinimalPolynomial MinimalStateSpaceModel Minimize Minors MinRecursion MinSize MinStableDistribution Minus MinusPlus MinValue Missing MissingDataMethod MittagLefflerE MixedRadix MixedRadixQuantity MixtureDistribution Mod Modal Mode Modular ModularLambda Module Modulus MoebiusMu Moment Momentary MomentConvert MomentEvaluate MomentGeneratingFunction Monday Monitor MonomialList MonomialOrder MonsterGroupM MorletWavelet MorphologicalBinarize MorphologicalBranchPoints MorphologicalComponents MorphologicalEulerNumber MorphologicalGraph MorphologicalPerimeter MorphologicalTransform Most MouseAnnotation MouseAppearance MouseAppearanceTag MouseButtons Mouseover MousePointerNote MousePosition MovingAverage MovingMedian MoyalDistribution MultiedgeStyle MultilaunchWarning MultiLetterItalics MultiLetterStyle MultilineFunction Multinomial MultinomialDistribution MultinormalDistribution MultiplicativeOrder Multiplicity Multiselection MultivariateHypergeometricDistribution MultivariatePoissonDistribution MultivariateTDistribution ' +
      'N NakagamiDistribution NameQ Names NamespaceBox Nand NArgMax NArgMin NBernoulliB NCache NDSolve NDSolveValue Nearest NearestFunction NeedCurrentFrontEndPackagePacket NeedCurrentFrontEndSymbolsPacket NeedlemanWunschSimilarity Needs Negative NegativeBinomialDistribution NegativeMultinomialDistribution NeighborhoodGraph Nest NestedGreaterGreater NestedLessLess NestedScriptRules NestList NestWhile NestWhileList NevilleThetaC NevilleThetaD NevilleThetaN NevilleThetaS NewPrimitiveStyle NExpectation Next NextPrime NHoldAll NHoldFirst NHoldRest NicholsGridLines NicholsPlot NIntegrate NMaximize NMaxValue NMinimize NMinValue NominalVariables NonAssociative NoncentralBetaDistribution NoncentralChiSquareDistribution NoncentralFRatioDistribution NoncentralStudentTDistribution NonCommutativeMultiply NonConstants None NonlinearModelFit NonlocalMeansFilter NonNegative NonPositive Nor NorlundB Norm Normal NormalDistribution NormalGrouping Normalize NormalizedSquaredEuclideanDistance NormalsFunction NormFunction Not NotCongruent NotCupCap NotDoubleVerticalBar Notebook NotebookApply NotebookAutoSave NotebookClose NotebookConvertSettings NotebookCreate NotebookCreateReturnObject NotebookDefault NotebookDelete NotebookDirectory NotebookDynamicExpression NotebookEvaluate NotebookEventActions NotebookFileName NotebookFind NotebookFindReturnObject NotebookGet NotebookGetLayoutInformationPacket NotebookGetMisspellingsPacket NotebookInformation NotebookInterfaceObject NotebookLocate NotebookObject NotebookOpen NotebookOpenReturnObject NotebookPath NotebookPrint NotebookPut NotebookPutReturnObject NotebookRead NotebookResetGeneratedCells Notebooks NotebookSave NotebookSaveAs NotebookSelection NotebookSetupLayoutInformationPacket NotebooksMenu NotebookWrite NotElement NotEqualTilde NotExists NotGreater NotGreaterEqual NotGreaterFullEqual NotGreaterGreater NotGreaterLess NotGreaterSlantEqual NotGreaterTilde NotHumpDownHump NotHumpEqual NotLeftTriangle NotLeftTriangleBar NotLeftTriangleEqual NotLess NotLessEqual NotLessFullEqual NotLessGreater NotLessLess NotLessSlantEqual NotLessTilde NotNestedGreaterGreater NotNestedLessLess NotPrecedes NotPrecedesEqual NotPrecedesSlantEqual NotPrecedesTilde NotReverseElement NotRightTriangle NotRightTriangleBar NotRightTriangleEqual NotSquareSubset NotSquareSubsetEqual NotSquareSuperset NotSquareSupersetEqual NotSubset NotSubsetEqual NotSucceeds NotSucceedsEqual NotSucceedsSlantEqual NotSucceedsTilde NotSuperset NotSupersetEqual NotTilde NotTildeEqual NotTildeFullEqual NotTildeTilde NotVerticalBar NProbability NProduct NProductFactors NRoots NSolve NSum NSumTerms Null NullRecords NullSpace NullWords Number NumberFieldClassNumber NumberFieldDiscriminant NumberFieldFundamentalUnits NumberFieldIntegralBasis NumberFieldNormRepresentatives NumberFieldRegulator NumberFieldRootsOfUnity NumberFieldSignature NumberForm NumberFormat NumberMarks NumberMultiplier NumberPadding NumberPoint NumberQ NumberSeparator ' +
      'NumberSigns NumberString Numerator NumericFunction NumericQ NuttallWindow NValues NyquistGridLines NyquistPlot ' +
      'O ObservabilityGramian ObservabilityMatrix ObservableDecomposition ObservableModelQ OddQ Off Offset OLEData On ONanGroupON OneIdentity Opacity Open OpenAppend Opener OpenerBox OpenerBoxOptions OpenerView OpenFunctionInspectorPacket Opening OpenRead OpenSpecialOptions OpenTemporary OpenWrite Operate OperatingSystem OptimumFlowData Optional OptionInspectorSettings OptionQ Options OptionsPacket OptionsPattern OptionValue OptionValueBox OptionValueBoxOptions Or Orange Order OrderDistribution OrderedQ Ordering Orderless OrnsteinUhlenbeckProcess Orthogonalize Out Outer OutputAutoOverwrite OutputControllabilityMatrix OutputControllableModelQ OutputForm OutputFormData OutputGrouping OutputMathEditExpression OutputNamePacket OutputResponse OutputSizeLimit OutputStream Over OverBar OverDot Overflow OverHat Overlaps Overlay OverlayBox OverlayBoxOptions Overscript OverscriptBox OverscriptBoxOptions OverTilde OverVector OwenT OwnValues ' +
      'PackingMethod PaddedForm Padding PadeApproximant PadLeft PadRight PageBreakAbove PageBreakBelow PageBreakWithin PageFooterLines PageFooters PageHeaderLines PageHeaders PageHeight PageRankCentrality PageWidth PairedBarChart PairedHistogram PairedSmoothHistogram PairedTTest PairedZTest PaletteNotebook PalettePath Pane PaneBox PaneBoxOptions Panel PanelBox PanelBoxOptions Paneled PaneSelector PaneSelectorBox PaneSelectorBoxOptions PaperWidth ParabolicCylinderD ParagraphIndent ParagraphSpacing ParallelArray ParallelCombine ParallelDo ParallelEvaluate Parallelization Parallelize ParallelMap ParallelNeeds ParallelProduct ParallelSubmit ParallelSum ParallelTable ParallelTry Parameter ParameterEstimator ParameterMixtureDistribution ParameterVariables ParametricFunction ParametricNDSolve ParametricNDSolveValue ParametricPlot ParametricPlot3D ParentConnect ParentDirectory ParentForm Parenthesize ParentList ParetoDistribution Part PartialCorrelationFunction PartialD ParticleData Partition PartitionsP PartitionsQ ParzenWindow PascalDistribution PassEventsDown PassEventsUp Paste PasteBoxFormInlineCells PasteButton Path PathGraph PathGraphQ Pattern PatternSequence PatternTest PauliMatrix PaulWavelet Pause PausedTime PDF PearsonChiSquareTest PearsonCorrelationTest PearsonDistribution PerformanceGoal PeriodicInterpolation Periodogram PeriodogramArray PermutationCycles PermutationCyclesQ PermutationGroup PermutationLength PermutationList PermutationListQ PermutationMax PermutationMin PermutationOrder PermutationPower PermutationProduct PermutationReplace Permutations PermutationSupport Permute PeronaMalikFilter Perpendicular PERTDistribution PetersenGraph PhaseMargins Pi Pick PIDData PIDDerivativeFilter PIDFeedforward PIDTune Piecewise PiecewiseExpand PieChart PieChart3D PillaiTrace PillaiTraceTest Pink Pivoting PixelConstrained PixelValue PixelValuePositions Placed Placeholder PlaceholderReplace Plain PlanarGraphQ Play PlayRange Plot Plot3D Plot3Matrix PlotDivision PlotJoined PlotLabel PlotLayout PlotLegends PlotMarkers PlotPoints PlotRange PlotRangeClipping PlotRangePadding PlotRegion PlotStyle Plus PlusMinus Pochhammer PodStates PodWidth Point Point3DBox PointBox PointFigureChart PointForm PointLegend PointSize PoissonConsulDistribution PoissonDistribution PoissonProcess PoissonWindow PolarAxes PolarAxesOrigin PolarGridLines PolarPlot PolarTicks PoleZeroMarkers PolyaAeppliDistribution PolyGamma Polygon Polygon3DBox Polygon3DBoxOptions PolygonBox PolygonBoxOptions PolygonHoleScale PolygonIntersections PolygonScale PolyhedronData PolyLog PolynomialExtendedGCD PolynomialForm PolynomialGCD PolynomialLCM PolynomialMod PolynomialQ PolynomialQuotient PolynomialQuotientRemainder PolynomialReduce PolynomialRemainder Polynomials PopupMenu PopupMenuBox PopupMenuBoxOptions PopupView PopupWindow Position Positive PositiveDefiniteMatrixQ PossibleZeroQ Postfix PostScript Power PowerDistribution PowerExpand PowerMod PowerModList ' +
      'PowerSpectralDensity PowersRepresentations PowerSymmetricPolynomial Precedence PrecedenceForm Precedes PrecedesEqual PrecedesSlantEqual PrecedesTilde Precision PrecisionGoal PreDecrement PredictionRoot PreemptProtect PreferencesPath Prefix PreIncrement Prepend PrependTo PreserveImageOptions Previous PriceGraphDistribution PrimaryPlaceholder Prime PrimeNu PrimeOmega PrimePi PrimePowerQ PrimeQ Primes PrimeZetaP PrimitiveRoot PrincipalComponents PrincipalValue Print PrintAction PrintForm PrintingCopies PrintingOptions PrintingPageRange PrintingStartingPageNumber PrintingStyleEnvironment PrintPrecision PrintTemporary Prism PrismBox PrismBoxOptions PrivateCellOptions PrivateEvaluationOptions PrivateFontOptions PrivateFrontEndOptions PrivateNotebookOptions PrivatePaths Probability ProbabilityDistribution ProbabilityPlot ProbabilityPr ProbabilityScalePlot ProbitModelFit ProcessEstimator ProcessParameterAssumptions ProcessParameterQ ProcessStateDomain ProcessTimeDomain Product ProductDistribution ProductLog ProgressIndicator ProgressIndicatorBox ProgressIndicatorBoxOptions Projection Prolog PromptForm Properties Property PropertyList PropertyValue Proportion Proportional Protect Protected ProteinData Pruning PseudoInverse Purple Put PutAppend Pyramid PyramidBox PyramidBoxOptions ' +
      'QBinomial QFactorial QGamma QHypergeometricPFQ QPochhammer QPolyGamma QRDecomposition QuadraticIrrationalQ Quantile QuantilePlot Quantity QuantityForm QuantityMagnitude QuantityQ QuantityUnit Quartics QuartileDeviation Quartiles QuartileSkewness QueueingNetworkProcess QueueingProcess QueueProperties Quiet Quit Quotient QuotientRemainder ' +
      'RadialityCentrality RadicalBox RadicalBoxOptions RadioButton RadioButtonBar RadioButtonBox RadioButtonBoxOptions Radon RamanujanTau RamanujanTauL RamanujanTauTheta RamanujanTauZ Random RandomChoice RandomComplex RandomFunction RandomGraph RandomImage RandomInteger RandomPermutation RandomPrime RandomReal RandomSample RandomSeed RandomVariate RandomWalkProcess Range RangeFilter RangeSpecification RankedMax RankedMin Raster Raster3D Raster3DBox Raster3DBoxOptions RasterArray RasterBox RasterBoxOptions Rasterize RasterSize Rational RationalFunctions Rationalize Rationals Ratios Raw RawArray RawBoxes RawData RawMedium RayleighDistribution Re Read ReadList ReadProtected Real RealBlockDiagonalForm RealDigits RealExponent Reals Reap Record RecordLists RecordSeparators Rectangle RectangleBox RectangleBoxOptions RectangleChart RectangleChart3D RecurrenceFilter RecurrenceTable RecurringDigitsForm Red Reduce RefBox ReferenceLineStyle ReferenceMarkers ReferenceMarkerStyle Refine ReflectionMatrix ReflectionTransform Refresh RefreshRate RegionBinarize RegionFunction RegionPlot RegionPlot3D RegularExpression Regularization Reinstall Release ReleaseHold ReliabilityDistribution ReliefImage ReliefPlot Remove RemoveAlphaChannel RemoveAsynchronousTask Removed RemoveInputStreamMethod RemoveOutputStreamMethod RemoveProperty RemoveScheduledTask RenameDirectory RenameFile RenderAll RenderingOptions RenewalProcess RenkoChart Repeated RepeatedNull RepeatedString Replace ReplaceAll ReplaceHeldPart ReplaceImageValue ReplaceList ReplacePart ReplacePixelValue ReplaceRepeated Resampling Rescale RescalingTransform ResetDirectory ResetMenusPacket ResetScheduledTask Residue Resolve Rest Resultant ResumePacket Return ReturnExpressionPacket ReturnInputFormPacket ReturnPacket ReturnTextPacket Reverse ReverseBiorthogonalSplineWavelet ReverseElement ReverseEquilibrium ReverseGraph ReverseUpEquilibrium RevolutionAxis RevolutionPlot3D RGBColor RiccatiSolve RiceDistribution RidgeFilter RiemannR RiemannSiegelTheta RiemannSiegelZ Riffle Right RightArrow RightArrowBar RightArrowLeftArrow RightCosetRepresentative RightDownTeeVector RightDownVector RightDownVectorBar RightTee RightTeeArrow RightTeeVector RightTriangle RightTriangleBar RightTriangleEqual RightUpDownVector RightUpTeeVector RightUpVector RightUpVectorBar RightVector RightVectorBar RiskAchievementImportance RiskReductionImportance RogersTanimotoDissimilarity Root RootApproximant RootIntervals RootLocusPlot RootMeanSquare RootOfUnityQ RootReduce Roots RootSum Rotate RotateLabel RotateLeft RotateRight RotationAction RotationBox RotationBoxOptions RotationMatrix RotationTransform Round RoundImplies RoundingRadius Row RowAlignments RowBackgrounds RowBox RowHeights RowLines RowMinHeight RowReduce RowsEqual RowSpacings RSolve RudvalisGroupRu Rule RuleCondition RuleDelayed RuleForm RulerUnits Run RunScheduledTask RunThrough RuntimeAttributes RuntimeOptions RussellRaoDissimilarity ' +
      'SameQ SameTest SampleDepth SampledSoundFunction SampledSoundList SampleRate SamplingPeriod SARIMAProcess SARMAProcess SatisfiabilityCount SatisfiabilityInstances SatisfiableQ Saturday Save Saveable SaveAutoDelete SaveDefinitions SawtoothWave Scale Scaled ScaleDivisions ScaledMousePosition ScaleOrigin ScalePadding ScaleRanges ScaleRangeStyle ScalingFunctions ScalingMatrix ScalingTransform Scan ScheduledTaskActiveQ ScheduledTaskData ScheduledTaskObject ScheduledTasks SchurDecomposition ScientificForm ScreenRectangle ScreenStyleEnvironment ScriptBaselineShifts ScriptLevel ScriptMinSize ScriptRules ScriptSizeMultipliers Scrollbars ScrollingOptions ScrollPosition Sec Sech SechDistribution SectionGrouping SectorChart SectorChart3D SectorOrigin SectorSpacing SeedRandom Select Selectable SelectComponents SelectedCells SelectedNotebook Selection SelectionAnimate SelectionCell SelectionCellCreateCell SelectionCellDefaultStyle SelectionCellParentStyle SelectionCreateCell SelectionDebuggerTag SelectionDuplicateCell SelectionEvaluate SelectionEvaluateCreateCell SelectionMove SelectionPlaceholder SelectionSetStyle SelectWithContents SelfLoops SelfLoopStyle SemialgebraicComponentInstances SendMail Sequence SequenceAlignment SequenceForm SequenceHold SequenceLimit Series SeriesCoefficient SeriesData SessionTime Set SetAccuracy SetAlphaChannel SetAttributes Setbacks SetBoxFormNamesPacket SetDelayed SetDirectory SetEnvironment SetEvaluationNotebook SetFileDate SetFileLoadingContext SetNotebookStatusLine SetOptions SetOptionsPacket SetPrecision SetProperty SetSelectedNotebook SetSharedFunction SetSharedVariable SetSpeechParametersPacket SetStreamPosition SetSystemOptions Setter SetterBar SetterBox SetterBoxOptions Setting SetValue Shading Shallow ShannonWavelet ShapiroWilkTest Share Sharpen ShearingMatrix ShearingTransform ShenCastanMatrix Short ShortDownArrow Shortest ShortestMatch ShortestPathFunction ShortLeftArrow ShortRightArrow ShortUpArrow Show ShowAutoStyles ShowCellBracket ShowCellLabel ShowCellTags ShowClosedCellArea ShowContents ShowControls ShowCursorTracker ShowGroupOpenCloseIcon ShowGroupOpener ShowInvisibleCharacters ShowPageBreaks ShowPredictiveInterface ShowSelection ShowShortBoxForm ShowSpecialCharacters ShowStringCharacters ShowSyntaxStyles ShrinkingDelay ShrinkWrapBoundingBox SiegelTheta SiegelTukeyTest Sign Signature SignedRankTest SignificanceLevel SignPadding SignTest SimilarityRules SimpleGraph SimpleGraphQ Simplify Sin Sinc SinghMaddalaDistribution SingleEvaluation SingleLetterItalics SingleLetterStyle SingularValueDecomposition SingularValueList SingularValuePlot SingularValues Sinh SinhIntegral SinIntegral SixJSymbol Skeleton SkeletonTransform SkellamDistribution Skewness SkewNormalDistribution Skip SliceDistribution Slider Slider2D Slider2DBox Slider2DBoxOptions SliderBox SliderBoxOptions SlideView Slot SlotSequence Small SmallCircle Smaller SmithDelayCompensator SmithWatermanSimilarity ' +
      'SmoothDensityHistogram SmoothHistogram SmoothHistogram3D SmoothKernelDistribution SocialMediaData Socket SokalSneathDissimilarity Solve SolveAlways SolveDelayed Sort SortBy Sound SoundAndGraphics SoundNote SoundVolume Sow Space SpaceForm Spacer Spacings Span SpanAdjustments SpanCharacterRounding SpanFromAbove SpanFromBoth SpanFromLeft SpanLineThickness SpanMaxSize SpanMinSize SpanningCharacters SpanSymmetric SparseArray SpatialGraphDistribution Speak SpeakTextPacket SpearmanRankTest SpearmanRho Spectrogram SpectrogramArray Specularity SpellingCorrection SpellingDictionaries SpellingDictionariesPath SpellingOptions SpellingSuggestionsPacket Sphere SphereBox SphericalBesselJ SphericalBesselY SphericalHankelH1 SphericalHankelH2 SphericalHarmonicY SphericalPlot3D SphericalRegion SpheroidalEigenvalue SpheroidalJoiningFactor SpheroidalPS SpheroidalPSPrime SpheroidalQS SpheroidalQSPrime SpheroidalRadialFactor SpheroidalS1 SpheroidalS1Prime SpheroidalS2 SpheroidalS2Prime Splice SplicedDistribution SplineClosed SplineDegree SplineKnots SplineWeights Split SplitBy SpokenString Sqrt SqrtBox SqrtBoxOptions Square SquaredEuclideanDistance SquareFreeQ SquareIntersection SquaresR SquareSubset SquareSubsetEqual SquareSuperset SquareSupersetEqual SquareUnion SquareWave StabilityMargins StabilityMarginsStyle StableDistribution Stack StackBegin StackComplete StackInhibit StandardDeviation StandardDeviationFilter StandardForm Standardize StandbyDistribution Star StarGraph StartAsynchronousTask StartingStepSize StartOfLine StartOfString StartScheduledTask StartupSound StateDimensions StateFeedbackGains StateOutputEstimator StateResponse StateSpaceModel StateSpaceRealization StateSpaceTransform StationaryDistribution StationaryWaveletPacketTransform StationaryWaveletTransform StatusArea StatusCentrality StepMonitor StieltjesGamma StirlingS1 StirlingS2 StopAsynchronousTask StopScheduledTask StrataVariables StratonovichProcess StreamColorFunction StreamColorFunctionScaling StreamDensityPlot StreamPlot StreamPoints StreamPosition Streams StreamScale StreamStyle String StringBreak StringByteCount StringCases StringCount StringDrop StringExpression StringForm StringFormat StringFreeQ StringInsert StringJoin StringLength StringMatchQ StringPosition StringQ StringReplace StringReplaceList StringReplacePart StringReverse StringRotateLeft StringRotateRight StringSkeleton StringSplit StringTake StringToStream StringTrim StripBoxes StripOnInput StripWrapperBoxes StrokeForm StructuralImportance StructuredArray StructuredSelection StruveH StruveL Stub StudentTDistribution Style StyleBox StyleBoxAutoDelete StyleBoxOptions StyleData StyleDefinitions StyleForm StyleKeyMapping StyleMenuListing StyleNameDialogSettings StyleNames StylePrint StyleSheetPath Subfactorial Subgraph SubMinus SubPlus SubresultantPolynomialRemainders ' +
      'SubresultantPolynomials Subresultants Subscript SubscriptBox SubscriptBoxOptions Subscripted Subset SubsetEqual Subsets SubStar Subsuperscript SubsuperscriptBox SubsuperscriptBoxOptions Subtract SubtractFrom SubValues Succeeds SucceedsEqual SucceedsSlantEqual SucceedsTilde SuchThat Sum SumConvergence Sunday SuperDagger SuperMinus SuperPlus Superscript SuperscriptBox SuperscriptBoxOptions Superset SupersetEqual SuperStar Surd SurdForm SurfaceColor SurfaceGraphics SurvivalDistribution SurvivalFunction SurvivalModel SurvivalModelFit SuspendPacket SuzukiDistribution SuzukiGroupSuz SwatchLegend Switch Symbol SymbolName SymletWavelet Symmetric SymmetricGroup SymmetricMatrixQ SymmetricPolynomial SymmetricReduction Symmetrize SymmetrizedArray SymmetrizedArrayRules SymmetrizedDependentComponents SymmetrizedIndependentComponents SymmetrizedReplacePart SynchronousInitialization SynchronousUpdating Syntax SyntaxForm SyntaxInformation SyntaxLength SyntaxPacket SyntaxQ SystemDialogInput SystemException SystemHelpPath SystemInformation SystemInformationData SystemOpen SystemOptions SystemsModelDelay SystemsModelDelayApproximate SystemsModelDelete SystemsModelDimensions SystemsModelExtract SystemsModelFeedbackConnect SystemsModelLabels SystemsModelOrder SystemsModelParallelConnect SystemsModelSeriesConnect SystemsModelStateFeedbackConnect SystemStub ' +
      'Tab TabFilling Table TableAlignments TableDepth TableDirections TableForm TableHeadings TableSpacing TableView TableViewBox TabSpacings TabView TabViewBox TabViewBoxOptions TagBox TagBoxNote TagBoxOptions TaggingRules TagSet TagSetDelayed TagStyle TagUnset Take TakeWhile Tally Tan Tanh TargetFunctions TargetUnits TautologyQ TelegraphProcess TemplateBox TemplateBoxOptions TemplateSlotSequence TemporalData Temporary TemporaryVariable TensorContract TensorDimensions TensorExpand TensorProduct TensorQ TensorRank TensorReduce TensorSymmetry TensorTranspose TensorWedge Tetrahedron TetrahedronBox TetrahedronBoxOptions TeXForm TeXSave Text Text3DBox Text3DBoxOptions TextAlignment TextBand TextBoundingBox TextBox TextCell TextClipboardType TextData TextForm TextJustification TextLine TextPacket TextParagraph TextRecognize TextRendering TextStyle Texture TextureCoordinateFunction TextureCoordinateScaling Therefore ThermometerGauge Thick Thickness Thin Thinning ThisLink ThompsonGroupTh Thread ThreeJSymbol Threshold Through Throw Thumbnail Thursday Ticks TicksStyle Tilde TildeEqual TildeFullEqual TildeTilde TimeConstrained TimeConstraint Times TimesBy TimeSeriesForecast TimeSeriesInvertibility TimeUsed TimeValue TimeZone Timing Tiny TitleGrouping TitsGroupT ToBoxes ToCharacterCode ToColor ToContinuousTimeModel ToDate ToDiscreteTimeModel ToeplitzMatrix ToExpression ToFileName Together Toggle ToggleFalse Toggler TogglerBar TogglerBox TogglerBoxOptions ToHeldExpression ToInvertibleTimeSeries TokenWords Tolerance ToLowerCase ToNumberField TooBig Tooltip TooltipBox TooltipBoxOptions TooltipDelay TooltipStyle Top TopHatTransform TopologicalSort ToRadicals ToRules ToString Total TotalHeight TotalVariationFilter TotalWidth TouchscreenAutoZoom TouchscreenControlPlacement ToUpperCase Tr Trace TraceAbove TraceAction TraceBackward TraceDepth TraceDialog TraceForward TraceInternal TraceLevel TraceOff TraceOn TraceOriginal TracePrint TraceScan TrackedSymbols TradingChart TraditionalForm TraditionalFunctionNotation TraditionalNotation TraditionalOrder TransferFunctionCancel TransferFunctionExpand TransferFunctionFactor TransferFunctionModel TransferFunctionPoles TransferFunctionTransform TransferFunctionZeros TransformationFunction TransformationFunctions TransformationMatrix TransformedDistribution TransformedField Translate TranslationTransform TransparentColor Transpose TreeForm TreeGraph TreeGraphQ TreePlot TrendStyle TriangleWave TriangularDistribution Trig TrigExpand TrigFactor TrigFactorList Trigger TrigReduce TrigToExp TrimmedMean True TrueQ TruncatedDistribution TsallisQExponentialDistribution TsallisQGaussianDistribution TTest Tube TubeBezierCurveBox TubeBezierCurveBoxOptions TubeBox TubeBSplineCurveBox TubeBSplineCurveBoxOptions Tuesday TukeyLambdaDistribution TukeyWindow Tuples TuranGraph TuringMachine ' +
      'Transparent ' +
      'UnateQ Uncompress Undefined UnderBar Underflow Underlined Underoverscript UnderoverscriptBox UnderoverscriptBoxOptions Underscript UnderscriptBox UnderscriptBoxOptions UndirectedEdge UndirectedGraph UndirectedGraphQ UndocumentedTestFEParserPacket UndocumentedTestGetSelectionPacket Unequal Unevaluated UniformDistribution UniformGraphDistribution UniformSumDistribution Uninstall Union UnionPlus Unique UnitBox UnitConvert UnitDimensions Unitize UnitRootTest UnitSimplify UnitStep UnitTriangle UnitVector Unprotect UnsameQ UnsavedVariables Unset UnsetShared UntrackedVariables Up UpArrow UpArrowBar UpArrowDownArrow Update UpdateDynamicObjects UpdateDynamicObjectsSynchronous UpdateInterval UpDownArrow UpEquilibrium UpperCaseQ UpperLeftArrow UpperRightArrow UpperTriangularize Upsample UpSet UpSetDelayed UpTee UpTeeArrow UpValues URL URLFetch URLFetchAsynchronous URLSave URLSaveAsynchronous UseGraphicsRange Using UsingFrontEnd ' +
      'V2Get ValidationLength Value ValueBox ValueBoxOptions ValueForm ValueQ ValuesData Variables Variance VarianceEquivalenceTest VarianceEstimatorFunction VarianceGammaDistribution VarianceTest VectorAngle VectorColorFunction VectorColorFunctionScaling VectorDensityPlot VectorGlyphData VectorPlot VectorPlot3D VectorPoints VectorQ Vectors VectorScale VectorStyle Vee Verbatim Verbose VerboseConvertToPostScriptPacket VerifyConvergence VerifySolutions VerifyTestAssumptions Version VersionNumber VertexAdd VertexCapacity VertexColors VertexComponent VertexConnectivity VertexCoordinateRules VertexCoordinates VertexCorrelationSimilarity VertexCosineSimilarity VertexCount VertexCoverQ VertexDataCoordinates VertexDegree VertexDelete VertexDiceSimilarity VertexEccentricity VertexInComponent VertexInDegree VertexIndex VertexJaccardSimilarity VertexLabeling VertexLabels VertexLabelStyle VertexList VertexNormals VertexOutComponent VertexOutDegree VertexQ VertexRenderingFunction VertexReplace VertexShape VertexShapeFunction VertexSize VertexStyle VertexTextureCoordinates VertexWeight Vertical VerticalBar VerticalForm VerticalGauge VerticalSeparator VerticalSlider VerticalTilde ViewAngle ViewCenter ViewMatrix ViewPoint ViewPointSelectorSettings ViewPort ViewRange ViewVector ViewVertical VirtualGroupData Visible VisibleCell VoigtDistribution VonMisesDistribution ' +
      'WaitAll WaitAsynchronousTask WaitNext WaitUntil WakebyDistribution WalleniusHypergeometricDistribution WaringYuleDistribution WatershedComponents WatsonUSquareTest WattsStrogatzGraphDistribution WaveletBestBasis WaveletFilterCoefficients WaveletImagePlot WaveletListPlot WaveletMapIndexed WaveletMatrixPlot WaveletPhi WaveletPsi WaveletScale WaveletScalogram WaveletThreshold WeaklyConnectedComponents WeaklyConnectedGraphQ WeakStationarity WeatherData WeberE Wedge Wednesday WeibullDistribution WeierstrassHalfPeriods WeierstrassInvariants WeierstrassP WeierstrassPPrime WeierstrassSigma WeierstrassZeta WeightedAdjacencyGraph WeightedAdjacencyMatrix WeightedData WeightedGraphQ Weights WelchWindow WheelGraph WhenEvent Which While White Whitespace WhitespaceCharacter WhittakerM WhittakerW WienerFilter WienerProcess WignerD WignerSemicircleDistribution WilksW WilksWTest WindowClickSelect WindowElements WindowFloating WindowFrame WindowFrameElements WindowMargins WindowMovable WindowOpacity WindowSelected WindowSize WindowStatusArea WindowTitle WindowToolbars WindowWidth With WolframAlpha WolframAlphaDate WolframAlphaQuantity WolframAlphaResult Word WordBoundary WordCharacter WordData WordSearch WordSeparators WorkingPrecision Write WriteString Wronskian ' +
      'XMLElement XMLObject Xnor Xor ' +
      'Yellow YuleDissimilarity ' +
      'ZernikeR ZeroSymmetric ZeroTest ZeroWidthTimes Zeta ZetaZero ZipfDistribution ZTest ZTransform ' +
      '$Aborted $ActivationGroupID $ActivationKey $ActivationUserRegistered $AddOnsDirectory $AssertFunction $Assumptions $AsynchronousTask $BaseDirectory $BatchInput $BatchOutput $BoxForms $ByteOrdering $Canceled $CharacterEncoding $CharacterEncodings $CommandLine $CompilationTarget $ConditionHold $ConfiguredKernels $Context $ContextPath $ControlActiveSetting $CreationDate $CurrentLink $DateStringFormat $DefaultFont $DefaultFrontEnd $DefaultImagingDevice $DefaultPath $Display $DisplayFunction $DistributedContexts $DynamicEvaluation $Echo $Epilog $ExportFormats $Failed $FinancialDataSource $FormatType $FrontEnd $FrontEndSession $GeoLocation $HistoryLength $HomeDirectory $HTTPCookies $IgnoreEOF $ImagingDevices $ImportFormats $InitialDirectory $Input $InputFileName $InputStreamMethods $Inspector $InstallationDate $InstallationDirectory $InterfaceEnvironment $IterationLimit $KernelCount $KernelID $Language $LaunchDirectory $LibraryPath $LicenseExpirationDate $LicenseID $LicenseProcesses $LicenseServer $LicenseSubprocesses $LicenseType $Line $Linked $LinkSupported $LoadedFiles $MachineAddresses $MachineDomain $MachineDomains $MachineEpsilon $MachineID $MachineName $MachinePrecision $MachineType $MaxExtraPrecision $MaxLicenseProcesses $MaxLicenseSubprocesses $MaxMachineNumber $MaxNumber $MaxPiecewiseCases $MaxPrecision $MaxRootDegree $MessageGroups $MessageList $MessagePrePrint $Messages $MinMachineNumber $MinNumber $MinorReleaseNumber $MinPrecision $ModuleNumber $NetworkLicense $NewMessage $NewSymbol $Notebooks $NumberMarks $Off $OperatingSystem $Output $OutputForms $OutputSizeLimit $OutputStreamMethods $Packages $ParentLink $ParentProcessID $PasswordFile $PatchLevelID $Path $PathnameSeparator $PerformanceGoal $PipeSupported $Post $Pre $PreferencesDirectory $PrePrint $PreRead $PrintForms $PrintLiteral $ProcessID $ProcessorCount $ProcessorType $ProductInformation $ProgramName $RandomState $RecursionLimit $ReleaseNumber $RootDirectory $ScheduledTask $ScriptCommandLine $SessionID $SetParentLink $SharedFunctions $SharedVariables $SoundDisplay $SoundDisplayFunction $SuppressInputFormHeads $SynchronousEvaluation $SyntaxHandler $System $SystemCharacterEncoding $SystemID $SystemWordLength $TemporaryDirectory $TemporaryPrefix $TextStyle $TimedOut $TimeUnit $TimeZone $TopDirectory $TraceOff $TraceOn $TracePattern $TracePostAction $TracePreAction $Urgent $UserAddOnsDirectory $UserBaseDirectory $UserDocumentsDirectory $UserName $Version $VersionNumber',
    contains: [
      {
        className: 'comment',
        begin: /\(\*/, end: /\*\)/
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.C_NUMBER_MODE,
      {
        begin: /\{/, end: /\}/,
        illegal: /:/
      }
    ]
  };
};

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var COMMON_CONTAINS = [
    hljs.C_NUMBER_MODE,
    {
      className: 'string',
      begin: '\'', end: '\'',
      contains: [hljs.BACKSLASH_ESCAPE, {begin: '\'\''}]
    }
  ];
  var TRANSPOSE = {
    relevance: 0,
    contains: [
      {
        begin: /'['\.]*/
      }
    ]
  };

  return {
    keywords: {
      keyword:
        'break case catch classdef continue else elseif end enumerated events for function ' +
        'global if methods otherwise parfor persistent properties return spmd switch try while',
      built_in:
        'sin sind sinh asin asind asinh cos cosd cosh acos acosd acosh tan tand tanh atan ' +
        'atand atan2 atanh sec secd sech asec asecd asech csc cscd csch acsc acscd acsch cot ' +
        'cotd coth acot acotd acoth hypot exp expm1 log log1p log10 log2 pow2 realpow reallog ' +
        'realsqrt sqrt nthroot nextpow2 abs angle complex conj imag real unwrap isreal ' +
        'cplxpair fix floor ceil round mod rem sign airy besselj bessely besselh besseli ' +
        'besselk beta betainc betaln ellipj ellipke erf erfc erfcx erfinv expint gamma ' +
        'gammainc gammaln psi legendre cross dot factor isprime primes gcd lcm rat rats perms ' +
        'nchoosek factorial cart2sph cart2pol pol2cart sph2cart hsv2rgb rgb2hsv zeros ones ' +
        'eye repmat rand randn linspace logspace freqspace meshgrid accumarray size length ' +
        'ndims numel disp isempty isequal isequalwithequalnans cat reshape diag blkdiag tril ' +
        'triu fliplr flipud flipdim rot90 find sub2ind ind2sub bsxfun ndgrid permute ipermute ' +
        'shiftdim circshift squeeze isscalar isvector ans eps realmax realmin pi i inf nan ' +
        'isnan isinf isfinite j why compan gallery hadamard hankel hilb invhilb magic pascal ' +
        'rosser toeplitz vander wilkinson'
    },
    illegal: '(//|"|#|/\\*|\\s+/\\w+)',
    contains: [
      {
        className: 'function',
        beginKeywords: 'function', end: '$',
        contains: [
          hljs.UNDERSCORE_TITLE_MODE,
          {
            className: 'params',
            variants: [
              {begin: '\\(', end: '\\)'},
              {begin: '\\[', end: '\\]'}
            ]
          }
        ]
      },
      {
        begin: /[a-zA-Z_][a-zA-Z_0-9]*'['\.]*/,
        returnBegin: true,
        relevance: 0,
        contains: [
          {begin: /[a-zA-Z_][a-zA-Z_0-9]*/, relevance: 0},
          TRANSPOSE.contains[0]
        ]
      },
      {
        begin: '\\[', end: '\\]',
        contains: COMMON_CONTAINS,
        relevance: 0,
        starts: TRANSPOSE
      },
      {
        begin: '\\{', end: /}/,
        contains: COMMON_CONTAINS,
        relevance: 0,
        starts: TRANSPOSE
      },
      {
        // transpose operators at the end of a function call
        begin: /\)/,
        relevance: 0,
        starts: TRANSPOSE
      },
      hljs.COMMENT('^\\s*\\%\\{\\s*$', '^\\s*\\%\\}\\s*$'),
      hljs.COMMENT('\\%', '$')
    ].concat(COMMON_CONTAINS)
  };
};

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var KEYWORDS = 'if then else elseif for thru do while unless step in and or not';
  var LITERALS = 'true false unknown inf minf ind und %e %i %pi %phi %gamma';
  var BUILTIN_FUNCTIONS =
        ' abasep abs absint absolute_real_time acos acosh acot acoth acsc acsch activate'
      + ' addcol add_edge add_edges addmatrices addrow add_vertex add_vertices adjacency_matrix'
      + ' adjoin adjoint af agd airy airy_ai airy_bi airy_dai airy_dbi algsys alg_type'
      + ' alias allroots alphacharp alphanumericp amortization %and annuity_fv'
      + ' annuity_pv antid antidiff AntiDifference append appendfile apply apply1 apply2'
      + ' applyb1 apropos args arit_amortization arithmetic arithsum array arrayapply'
      + ' arrayinfo arraymake arraysetapply ascii asec asech asin asinh askinteger'
      + ' asksign assoc assoc_legendre_p assoc_legendre_q assume assume_external_byte_order'
      + ' asympa at atan atan2 atanh atensimp atom atvalue augcoefmatrix augmented_lagrangian_method'
      + ' av average_degree backtrace bars barsplot barsplot_description base64 base64_decode'
      + ' bashindices batch batchload bc2 bdvac belln benefit_cost bern bernpoly bernstein_approx'
      + ' bernstein_expand bernstein_poly bessel bessel_i bessel_j bessel_k bessel_simplify'
      + ' bessel_y beta beta_incomplete beta_incomplete_generalized beta_incomplete_regularized'
      + ' bezout bfallroots bffac bf_find_root bf_fmin_cobyla bfhzeta bfloat bfloatp'
      + ' bfpsi bfpsi0 bfzeta biconnected_components bimetric binomial bipartition'
      + ' block blockmatrixp bode_gain bode_phase bothcoef box boxplot boxplot_description'
      + ' break bug_report build_info|10 buildq build_sample burn cabs canform canten'
      + ' cardinality carg cartan cartesian_product catch cauchy_matrix cbffac cdf_bernoulli'
      + ' cdf_beta cdf_binomial cdf_cauchy cdf_chi2 cdf_continuous_uniform cdf_discrete_uniform'
      + ' cdf_exp cdf_f cdf_gamma cdf_general_finite_discrete cdf_geometric cdf_gumbel'
      + ' cdf_hypergeometric cdf_laplace cdf_logistic cdf_lognormal cdf_negative_binomial'
      + ' cdf_noncentral_chi2 cdf_noncentral_student_t cdf_normal cdf_pareto cdf_poisson'
      + ' cdf_rank_sum cdf_rayleigh cdf_signed_rank cdf_student_t cdf_weibull cdisplay'
      + ' ceiling central_moment cequal cequalignore cf cfdisrep cfexpand cgeodesic'
      + ' cgreaterp cgreaterpignore changename changevar chaosgame charat charfun charfun2'
      + ' charlist charp charpoly chdir chebyshev_t chebyshev_u checkdiv check_overlaps'
      + ' chinese cholesky christof chromatic_index chromatic_number cint circulant_graph'
      + ' clear_edge_weight clear_rules clear_vertex_label clebsch_gordan clebsch_graph'
      + ' clessp clesspignore close closefile cmetric coeff coefmatrix cograd col collapse'
      + ' collectterms columnop columnspace columnswap columnvector combination combine'
      + ' comp2pui compare compfile compile compile_file complement_graph complete_bipartite_graph'
      + ' complete_graph complex_number_p components compose_functions concan concat'
      + ' conjugate conmetderiv connected_components connect_vertices cons constant'
      + ' constantp constituent constvalue cont2part content continuous_freq contortion'
      + ' contour_plot contract contract_edge contragrad contrib_ode convert coord'
      + ' copy copy_file copy_graph copylist copymatrix cor cos cosh cot coth cov cov1'
      + ' covdiff covect covers crc24sum create_graph create_list csc csch csetup cspline'
      + ' ctaylor ct_coordsys ctransform ctranspose cube_graph cuboctahedron_graph'
      + ' cunlisp cv cycle_digraph cycle_graph cylindrical days360 dblint deactivate'
      + ' declare declare_constvalue declare_dimensions declare_fundamental_dimensions'
      + ' declare_fundamental_units declare_qty declare_translated declare_unit_conversion'
      + ' declare_units declare_weights decsym defcon define define_alt_display define_variable'
      + ' defint defmatch defrule defstruct deftaylor degree_sequence del delete deleten'
      + ' delta demo demoivre denom depends derivdegree derivlist describe desolve'
      + ' determinant dfloat dgauss_a dgauss_b dgeev dgemm dgeqrf dgesv dgesvd diag'
      + ' diagmatrix diag_matrix diagmatrixp diameter diff digitcharp dimacs_export'
      + ' dimacs_import dimension dimensionless dimensions dimensions_as_list direct'
      + ' directory discrete_freq disjoin disjointp disolate disp dispcon dispform'
      + ' dispfun dispJordan display disprule dispterms distrib divide divisors divsum'
      + ' dkummer_m dkummer_u dlange dodecahedron_graph dotproduct dotsimp dpart'
      + ' draw draw2d draw3d drawdf draw_file draw_graph dscalar echelon edge_coloring'
      + ' edge_connectivity edges eigens_by_jacobi eigenvalues eigenvectors eighth'
      + ' einstein eivals eivects elapsed_real_time elapsed_run_time ele2comp ele2polynome'
      + ' ele2pui elem elementp elevation_grid elim elim_allbut eliminate eliminate_using'
      + ' ellipse elliptic_e elliptic_ec elliptic_eu elliptic_f elliptic_kc elliptic_pi'
      + ' ematrix empty_graph emptyp endcons entermatrix entertensor entier equal equalp'
      + ' equiv_classes erf erfc erf_generalized erfi errcatch error errormsg errors'
      + ' euler ev eval_string evenp every evolution evolution2d evundiff example exp'
      + ' expand expandwrt expandwrt_factored expint expintegral_chi expintegral_ci'
      + ' expintegral_e expintegral_e1 expintegral_ei expintegral_e_simplify expintegral_li'
      + ' expintegral_shi expintegral_si explicit explose exponentialize express expt'
      + ' exsec extdiff extract_linear_equations extremal_subset ezgcd %f f90 facsum'
      + ' factcomb factor factorfacsum factorial factorout factorsum facts fast_central_elements'
      + ' fast_linsolve fasttimes featurep fernfale fft fib fibtophi fifth filename_merge'
      + ' file_search file_type fillarray findde find_root find_root_abs find_root_error'
      + ' find_root_rel first fix flatten flength float floatnump floor flower_snark'
      + ' flush flush1deriv flushd flushnd flush_output fmin_cobyla forget fortran'
      + ' fourcos fourexpand fourier fourier_elim fourint fourintcos fourintsin foursimp'
      + ' foursin fourth fposition frame_bracket freeof freshline fresnel_c fresnel_s'
      + ' from_adjacency_matrix frucht_graph full_listify fullmap fullmapl fullratsimp'
      + ' fullratsubst fullsetify funcsolve fundamental_dimensions fundamental_units'
      + ' fundef funmake funp fv g0 g1 gamma gamma_greek gamma_incomplete gamma_incomplete_generalized'
      + ' gamma_incomplete_regularized gauss gauss_a gauss_b gaussprob gcd gcdex gcdivide'
      + ' gcfac gcfactor gd generalized_lambert_w genfact gen_laguerre genmatrix gensym'
      + ' geo_amortization geo_annuity_fv geo_annuity_pv geomap geometric geometric_mean'
      + ' geosum get getcurrentdirectory get_edge_weight getenv get_lu_factors get_output_stream_string'
      + ' get_pixel get_plot_option get_tex_environment get_tex_environment_default'
      + ' get_vertex_label gfactor gfactorsum ggf girth global_variances gn gnuplot_close'
      + ' gnuplot_replot gnuplot_reset gnuplot_restart gnuplot_start go Gosper GosperSum'
      + ' gr2d gr3d gradef gramschmidt graph6_decode graph6_encode graph6_export graph6_import'
      + ' graph_center graph_charpoly graph_eigenvalues graph_flow graph_order graph_periphery'
      + ' graph_product graph_size graph_union great_rhombicosidodecahedron_graph great_rhombicuboctahedron_graph'
      + ' grid_graph grind grobner_basis grotzch_graph hamilton_cycle hamilton_path'
      + ' hankel hankel_1 hankel_2 harmonic harmonic_mean hav heawood_graph hermite'
      + ' hessian hgfred hilbertmap hilbert_matrix hipow histogram histogram_description'
      + ' hodge horner hypergeometric i0 i1 %ibes ic1 ic2 ic_convert ichr1 ichr2 icosahedron_graph'
      + ' icosidodecahedron_graph icurvature ident identfor identity idiff idim idummy'
      + ' ieqn %if ifactors iframes ifs igcdex igeodesic_coords ilt image imagpart'
      + ' imetric implicit implicit_derivative implicit_plot indexed_tensor indices'
      + ' induced_subgraph inferencep inference_result infix info_display init_atensor'
      + ' init_ctensor in_neighbors innerproduct inpart inprod inrt integerp integer_partitions'
      + ' integrate intersect intersection intervalp intopois intosum invariant1 invariant2'
      + ' inverse_fft inverse_jacobi_cd inverse_jacobi_cn inverse_jacobi_cs inverse_jacobi_dc'
      + ' inverse_jacobi_dn inverse_jacobi_ds inverse_jacobi_nc inverse_jacobi_nd inverse_jacobi_ns'
      + ' inverse_jacobi_sc inverse_jacobi_sd inverse_jacobi_sn invert invert_by_adjoint'
      + ' invert_by_lu inv_mod irr is is_biconnected is_bipartite is_connected is_digraph'
      + ' is_edge_in_graph is_graph is_graph_or_digraph ishow is_isomorphic isolate'
      + ' isomorphism is_planar isqrt isreal_p is_sconnected is_tree is_vertex_in_graph'
      + ' items_inference %j j0 j1 jacobi jacobian jacobi_cd jacobi_cn jacobi_cs jacobi_dc'
      + ' jacobi_dn jacobi_ds jacobi_nc jacobi_nd jacobi_ns jacobi_p jacobi_sc jacobi_sd'
      + ' jacobi_sn JF jn join jordan julia julia_set julia_sin %k kdels kdelta kill'
      + ' killcontext kostka kron_delta kronecker_product kummer_m kummer_u kurtosis'
      + ' kurtosis_bernoulli kurtosis_beta kurtosis_binomial kurtosis_chi2 kurtosis_continuous_uniform'
      + ' kurtosis_discrete_uniform kurtosis_exp kurtosis_f kurtosis_gamma kurtosis_general_finite_discrete'
      + ' kurtosis_geometric kurtosis_gumbel kurtosis_hypergeometric kurtosis_laplace'
      + ' kurtosis_logistic kurtosis_lognormal kurtosis_negative_binomial kurtosis_noncentral_chi2'
      + ' kurtosis_noncentral_student_t kurtosis_normal kurtosis_pareto kurtosis_poisson'
      + ' kurtosis_rayleigh kurtosis_student_t kurtosis_weibull label labels lagrange'
      + ' laguerre lambda lambert_w laplace laplacian_matrix last lbfgs lc2kdt lcharp'
      + ' lc_l lcm lc_u ldefint ldisp ldisplay legendre_p legendre_q leinstein length'
      + ' let letrules letsimp levi_civita lfreeof lgtreillis lhs li liediff limit'
      + ' Lindstedt linear linearinterpol linear_program linear_regression line_graph'
      + ' linsolve listarray list_correlations listify list_matrix_entries list_nc_monomials'
      + ' listoftens listofvars listp lmax lmin load loadfile local locate_matrix_entry'
      + ' log logcontract log_gamma lopow lorentz_gauge lowercasep lpart lratsubst'
      + ' lreduce lriemann lsquares_estimates lsquares_estimates_approximate lsquares_estimates_exact'
      + ' lsquares_mse lsquares_residual_mse lsquares_residuals lsum ltreillis lu_backsub'
      + ' lucas lu_factor %m macroexpand macroexpand1 make_array makebox makefact makegamma'
      + ' make_graph make_level_picture makelist makeOrders make_poly_continent make_poly_country'
      + ' make_polygon make_random_state make_rgb_picture makeset make_string_input_stream'
      + ' make_string_output_stream make_transform mandelbrot mandelbrot_set map mapatom'
      + ' maplist matchdeclare matchfix mat_cond mat_fullunblocker mat_function mathml_display'
      + ' mat_norm matrix matrixmap matrixp matrix_size mattrace mat_trace mat_unblocker'
      + ' max max_clique max_degree max_flow maximize_lp max_independent_set max_matching'
      + ' maybe md5sum mean mean_bernoulli mean_beta mean_binomial mean_chi2 mean_continuous_uniform'
      + ' mean_deviation mean_discrete_uniform mean_exp mean_f mean_gamma mean_general_finite_discrete'
      + ' mean_geometric mean_gumbel mean_hypergeometric mean_laplace mean_logistic'
      + ' mean_lognormal mean_negative_binomial mean_noncentral_chi2 mean_noncentral_student_t'
      + ' mean_normal mean_pareto mean_poisson mean_rayleigh mean_student_t mean_weibull'
      + ' median median_deviation member mesh metricexpandall mgf1_sha1 min min_degree'
      + ' min_edge_cut minfactorial minimalPoly minimize_lp minimum_spanning_tree minor'
      + ' minpack_lsquares minpack_solve min_vertex_cover min_vertex_cut mkdir mnewton'
      + ' mod mode_declare mode_identity ModeMatrix moebius mon2schur mono monomial_dimensions'
      + ' multibernstein_poly multi_display_for_texinfo multi_elem multinomial multinomial_coeff'
      + ' multi_orbit multiplot_mode multi_pui multsym multthru mycielski_graph nary'
      + ' natural_unit nc_degree ncexpt ncharpoly negative_picture neighbors new newcontext'
      + ' newdet new_graph newline newton new_variable next_prime nicedummies niceindices'
      + ' ninth nofix nonarray noncentral_moment nonmetricity nonnegintegerp nonscalarp'
      + ' nonzeroandfreeof notequal nounify nptetrad npv nroots nterms ntermst'
      + ' nthroot nullity nullspace num numbered_boundaries numberp number_to_octets'
      + ' num_distinct_partitions numerval numfactor num_partitions nusum nzeta nzetai'
      + ' nzetar octets_to_number octets_to_oid odd_girth oddp ode2 ode_check odelin'
      + ' oid_to_octets op opena opena_binary openr openr_binary openw openw_binary'
      + ' operatorp opsubst optimize %or orbit orbits ordergreat ordergreatp orderless'
      + ' orderlessp orthogonal_complement orthopoly_recur orthopoly_weight outermap'
      + ' out_neighbors outofpois pade parabolic_cylinder_d parametric parametric_surface'
      + ' parg parGosper parse_string parse_timedate part part2cont partfrac partition'
      + ' partition_set partpol path_digraph path_graph pathname_directory pathname_name'
      + ' pathname_type pdf_bernoulli pdf_beta pdf_binomial pdf_cauchy pdf_chi2 pdf_continuous_uniform'
      + ' pdf_discrete_uniform pdf_exp pdf_f pdf_gamma pdf_general_finite_discrete'
      + ' pdf_geometric pdf_gumbel pdf_hypergeometric pdf_laplace pdf_logistic pdf_lognormal'
      + ' pdf_negative_binomial pdf_noncentral_chi2 pdf_noncentral_student_t pdf_normal'
      + ' pdf_pareto pdf_poisson pdf_rank_sum pdf_rayleigh pdf_signed_rank pdf_student_t'
      + ' pdf_weibull pearson_skewness permanent permut permutation permutations petersen_graph'
      + ' petrov pickapart picture_equalp picturep piechart piechart_description planar_embedding'
      + ' playback plog plot2d plot3d plotdf ploteq plsquares pochhammer points poisdiff'
      + ' poisexpt poisint poismap poisplus poissimp poissubst poistimes poistrim polar'
      + ' polarform polartorect polar_to_xy poly_add poly_buchberger poly_buchberger_criterion'
      + ' poly_colon_ideal poly_content polydecomp poly_depends_p poly_elimination_ideal'
      + ' poly_exact_divide poly_expand poly_expt poly_gcd polygon poly_grobner poly_grobner_equal'
      + ' poly_grobner_member poly_grobner_subsetp poly_ideal_intersection poly_ideal_polysaturation'
      + ' poly_ideal_polysaturation1 poly_ideal_saturation poly_ideal_saturation1 poly_lcm'
      + ' poly_minimization polymod poly_multiply polynome2ele polynomialp poly_normal_form'
      + ' poly_normalize poly_normalize_list poly_polysaturation_extension poly_primitive_part'
      + ' poly_pseudo_divide poly_reduced_grobner poly_reduction poly_saturation_extension'
      + ' poly_s_polynomial poly_subtract polytocompanion pop postfix potential power_mod'
      + ' powerseries powerset prefix prev_prime primep primes principal_components'
      + ' print printf printfile print_graph printpois printprops prodrac product properties'
      + ' propvars psi psubst ptriangularize pui pui2comp pui2ele pui2polynome pui_direct'
      + ' puireduc push put pv qput qrange qty quad_control quad_qag quad_qagi quad_qagp'
      + ' quad_qags quad_qawc quad_qawf quad_qawo quad_qaws quadrilateral quantile'
      + ' quantile_bernoulli quantile_beta quantile_binomial quantile_cauchy quantile_chi2'
      + ' quantile_continuous_uniform quantile_discrete_uniform quantile_exp quantile_f'
      + ' quantile_gamma quantile_general_finite_discrete quantile_geometric quantile_gumbel'
      + ' quantile_hypergeometric quantile_laplace quantile_logistic quantile_lognormal'
      + ' quantile_negative_binomial quantile_noncentral_chi2 quantile_noncentral_student_t'
      + ' quantile_normal quantile_pareto quantile_poisson quantile_rayleigh quantile_student_t'
      + ' quantile_weibull quartile_skewness quit qunit quotient racah_v racah_w radcan'
      + ' radius random random_bernoulli random_beta random_binomial random_bipartite_graph'
      + ' random_cauchy random_chi2 random_continuous_uniform random_digraph random_discrete_uniform'
      + ' random_exp random_f random_gamma random_general_finite_discrete random_geometric'
      + ' random_graph random_graph1 random_gumbel random_hypergeometric random_laplace'
      + ' random_logistic random_lognormal random_negative_binomial random_network'
      + ' random_noncentral_chi2 random_noncentral_student_t random_normal random_pareto'
      + ' random_permutation random_poisson random_rayleigh random_regular_graph random_student_t'
      + ' random_tournament random_tree random_weibull range rank rat ratcoef ratdenom'
      + ' ratdiff ratdisrep ratexpand ratinterpol rational rationalize ratnumer ratnump'
      + ' ratp ratsimp ratsubst ratvars ratweight read read_array read_binary_array'
      + ' read_binary_list read_binary_matrix readbyte readchar read_hashed_array readline'
      + ' read_list read_matrix read_nested_list readonly read_xpm real_imagpart_to_conjugate'
      + ' realpart realroots rearray rectangle rectform rectform_log_if_constant recttopolar'
      + ' rediff reduce_consts reduce_order region region_boundaries region_boundaries_plus'
      + ' rem remainder remarray rembox remcomps remcon remcoord remfun remfunction'
      + ' remlet remove remove_constvalue remove_dimensions remove_edge remove_fundamental_dimensions'
      + ' remove_fundamental_units remove_plot_option remove_vertex rempart remrule'
      + ' remsym remvalue rename rename_file reset reset_displays residue resolvante'
      + ' resolvante_alternee1 resolvante_bipartite resolvante_diedrale resolvante_klein'
      + ' resolvante_klein3 resolvante_produit_sym resolvante_unitaire resolvante_vierer'
      + ' rest resultant return reveal reverse revert revert2 rgb2level rhs ricci riemann'
      + ' rinvariant risch rk rmdir rncombine romberg room rootscontract round row'
      + ' rowop rowswap rreduce run_testsuite %s save saving scalarp scaled_bessel_i'
      + ' scaled_bessel_i0 scaled_bessel_i1 scalefactors scanmap scatterplot scatterplot_description'
      + ' scene schur2comp sconcat scopy scsimp scurvature sdowncase sec sech second'
      + ' sequal sequalignore set_alt_display setdifference set_draw_defaults set_edge_weight'
      + ' setelmx setequalp setify setp set_partitions set_plot_option set_prompt set_random_state'
      + ' set_tex_environment set_tex_environment_default setunits setup_autoload set_up_dot_simplifications'
      + ' set_vertex_label seventh sexplode sf sha1sum sha256sum shortest_path shortest_weighted_path'
      + ' show showcomps showratvars sierpinskiale sierpinskimap sign signum similaritytransform'
      + ' simp_inequality simplify_sum simplode simpmetderiv simtran sin sinh sinsert'
      + ' sinvertcase sixth skewness skewness_bernoulli skewness_beta skewness_binomial'
      + ' skewness_chi2 skewness_continuous_uniform skewness_discrete_uniform skewness_exp'
      + ' skewness_f skewness_gamma skewness_general_finite_discrete skewness_geometric'
      + ' skewness_gumbel skewness_hypergeometric skewness_laplace skewness_logistic'
      + ' skewness_lognormal skewness_negative_binomial skewness_noncentral_chi2 skewness_noncentral_student_t'
      + ' skewness_normal skewness_pareto skewness_poisson skewness_rayleigh skewness_student_t'
      + ' skewness_weibull slength smake small_rhombicosidodecahedron_graph small_rhombicuboctahedron_graph'
      + ' smax smin smismatch snowmap snub_cube_graph snub_dodecahedron_graph solve'
      + ' solve_rec solve_rec_rat some somrac sort sparse6_decode sparse6_encode sparse6_export'
      + ' sparse6_import specint spherical spherical_bessel_j spherical_bessel_y spherical_hankel1'
      + ' spherical_hankel2 spherical_harmonic spherical_to_xyz splice split sposition'
      + ' sprint sqfr sqrt sqrtdenest sremove sremovefirst sreverse ssearch ssort sstatus'
      + ' ssubst ssubstfirst staircase standardize standardize_inverse_trig starplot'
      + ' starplot_description status std std1 std_bernoulli std_beta std_binomial'
      + ' std_chi2 std_continuous_uniform std_discrete_uniform std_exp std_f std_gamma'
      + ' std_general_finite_discrete std_geometric std_gumbel std_hypergeometric std_laplace'
      + ' std_logistic std_lognormal std_negative_binomial std_noncentral_chi2 std_noncentral_student_t'
      + ' std_normal std_pareto std_poisson std_rayleigh std_student_t std_weibull'
      + ' stemplot stirling stirling1 stirling2 strim striml strimr string stringout'
      + ' stringp strong_components struve_h struve_l sublis sublist sublist_indices'
      + ' submatrix subsample subset subsetp subst substinpart subst_parallel substpart'
      + ' substring subvar subvarp sum sumcontract summand_to_rec supcase supcontext'
      + ' symbolp symmdifference symmetricp system take_channel take_inference tan'
      + ' tanh taylor taylorinfo taylorp taylor_simplifier taytorat tcl_output tcontract'
      + ' tellrat tellsimp tellsimpafter tentex tenth test_mean test_means_difference'
      + ' test_normality test_proportion test_proportions_difference test_rank_sum'
      + ' test_sign test_signed_rank test_variance test_variance_ratio tex tex1 tex_display'
      + ' texput %th third throw time timedate timer timer_info tldefint tlimit todd_coxeter'
      + ' toeplitz tokens to_lisp topological_sort to_poly to_poly_solve totaldisrep'
      + ' totalfourier totient tpartpol trace tracematrix trace_options transform_sample'
      + ' translate translate_file transpose treefale tree_reduce treillis treinat'
      + ' triangle triangularize trigexpand trigrat trigreduce trigsimp trunc truncate'
      + ' truncated_cube_graph truncated_dodecahedron_graph truncated_icosahedron_graph'
      + ' truncated_tetrahedron_graph tr_warnings_get tube tutte_graph ueivects uforget'
      + ' ultraspherical underlying_graph undiff union unique uniteigenvectors unitp'
      + ' units unit_step unitvector unorder unsum untellrat untimer'
      + ' untrace uppercasep uricci uriemann uvect vandermonde_matrix var var1 var_bernoulli'
      + ' var_beta var_binomial var_chi2 var_continuous_uniform var_discrete_uniform'
      + ' var_exp var_f var_gamma var_general_finite_discrete var_geometric var_gumbel'
      + ' var_hypergeometric var_laplace var_logistic var_lognormal var_negative_binomial'
      + ' var_noncentral_chi2 var_noncentral_student_t var_normal var_pareto var_poisson'
      + ' var_rayleigh var_student_t var_weibull vector vectorpotential vectorsimp'
      + ' verbify vers vertex_coloring vertex_connectivity vertex_degree vertex_distance'
      + ' vertex_eccentricity vertex_in_degree vertex_out_degree vertices vertices_to_cycle'
      + ' vertices_to_path %w weyl wheel_graph wiener_index wigner_3j wigner_6j'
      + ' wigner_9j with_stdout write_binary_data writebyte write_data writefile wronskian'
      + ' xreduce xthru %y Zeilberger zeroequiv zerofor zeromatrix zeromatrixp zeta'
      + ' zgeev zheev zlange zn_add_table zn_carmichael_lambda zn_characteristic_factors'
      + ' zn_determinant zn_factor_generators zn_invert_by_lu zn_log zn_mult_table'
      + ' absboxchar activecontexts adapt_depth additive adim aform algebraic'
      + ' algepsilon algexact aliases allbut all_dotsimp_denoms allocation allsym alphabetic'
      + ' animation antisymmetric arrays askexp assume_pos assume_pos_pred assumescalar'
      + ' asymbol atomgrad atrig1 axes axis_3d axis_bottom axis_left axis_right axis_top'
      + ' azimuth background background_color backsubst berlefact bernstein_explicit'
      + ' besselexpand beta_args_sum_to_integer beta_expand bftorat bftrunc bindtest'
      + ' border boundaries_array box boxchar breakup %c capping cauchysum cbrange'
      + ' cbtics center cflength cframe_flag cnonmet_flag color color_bar color_bar_tics'
      + ' colorbox columns commutative complex cone context contexts contour contour_levels'
      + ' cosnpiflag ctaypov ctaypt ctayswitch ctayvar ct_coords ctorsion_flag ctrgsimp'
      + ' cube current_let_rule_package cylinder data_file_name debugmode decreasing'
      + ' default_let_rule_package delay dependencies derivabbrev derivsubst detout'
      + ' diagmetric diff dim dimensions dispflag display2d|10 display_format_internal'
      + ' distribute_over doallmxops domain domxexpt domxmxops domxnctimes dontfactor'
      + ' doscmxops doscmxplus dot0nscsimp dot0simp dot1simp dotassoc dotconstrules'
      + ' dotdistrib dotexptsimp dotident dotscrules draw_graph_program draw_realpart'
      + ' edge_color edge_coloring edge_partition edge_type edge_width %edispflag'
      + ' elevation %emode endphi endtheta engineering_format_floats enhanced3d %enumer'
      + ' epsilon_lp erfflag erf_representation errormsg error_size error_syms error_type'
      + ' %e_to_numlog eval even evenfun evflag evfun ev_point expandwrt_denom expintexpand'
      + ' expintrep expon expop exptdispflag exptisolate exptsubst facexpand facsum_combine'
      + ' factlim factorflag factorial_expand factors_only fb feature features'
      + ' file_name file_output_append file_search_demo file_search_lisp file_search_maxima|10'
      + ' file_search_tests file_search_usage file_type_lisp file_type_maxima|10 fill_color'
      + ' fill_density filled_func fixed_vertices flipflag float2bf font font_size'
      + ' fortindent fortspaces fpprec fpprintprec functions gamma_expand gammalim'
      + ' gdet genindex gensumnum GGFCFMAX GGFINFINITY globalsolve gnuplot_command'
      + ' gnuplot_curve_styles gnuplot_curve_titles gnuplot_default_term_command gnuplot_dumb_term_command'
      + ' gnuplot_file_args gnuplot_file_name gnuplot_out_file gnuplot_pdf_term_command'
      + ' gnuplot_pm3d gnuplot_png_term_command gnuplot_postamble gnuplot_preamble'
      + ' gnuplot_ps_term_command gnuplot_svg_term_command gnuplot_term gnuplot_view_args'
      + ' Gosper_in_Zeilberger gradefs grid grid2d grind halfangles head_angle head_both'
      + ' head_length head_type height hypergeometric_representation %iargs ibase'
      + ' icc1 icc2 icounter idummyx ieqnprint ifb ifc1 ifc2 ifg ifgi ifr iframe_bracket_form'
      + ' ifri igeowedge_flag ikt1 ikt2 imaginary inchar increasing infeval'
      + ' infinity inflag infolists inm inmc1 inmc2 intanalysis integer integervalued'
      + ' integrate_use_rootsof integration_constant integration_constant_counter interpolate_color'
      + ' intfaclim ip_grid ip_grid_in irrational isolate_wrt_times iterations itr'
      + ' julia_parameter %k1 %k2 keepfloat key key_pos kinvariant kt label label_alignment'
      + ' label_orientation labels lassociative lbfgs_ncorrections lbfgs_nfeval_max'
      + ' leftjust legend letrat let_rule_packages lfg lg lhospitallim limsubst linear'
      + ' linear_solver linechar linel|10 linenum line_type linewidth line_width linsolve_params'
      + ' linsolvewarn lispdisp listarith listconstvars listdummyvars lmxchar load_pathname'
      + ' loadprint logabs logarc logcb logconcoeffp logexpand lognegint logsimp logx'
      + ' logx_secondary logy logy_secondary logz lriem m1pbranch macroexpansion macros'
      + ' mainvar manual_demo maperror mapprint matrix_element_add matrix_element_mult'
      + ' matrix_element_transpose maxapplydepth maxapplyheight maxima_tempdir|10 maxima_userdir|10'
      + ' maxnegex MAX_ORD maxposex maxpsifracdenom maxpsifracnum maxpsinegint maxpsiposint'
      + ' maxtayorder mesh_lines_color method mod_big_prime mode_check_errorp'
      + ' mode_checkp mode_check_warnp mod_test mod_threshold modular_linear_solver'
      + ' modulus multiplicative multiplicities myoptions nary negdistrib negsumdispflag'
      + ' newline newtonepsilon newtonmaxiter nextlayerfactor niceindicespref nm nmc'
      + ' noeval nolabels nonegative_lp noninteger nonscalar noun noundisp nouns np'
      + ' npi nticks ntrig numer numer_pbranch obase odd oddfun opacity opproperties'
      + ' opsubst optimprefix optionset orientation origin orthopoly_returns_intervals'
      + ' outative outchar packagefile palette partswitch pdf_file pfeformat phiresolution'
      + ' %piargs piece pivot_count_sx pivot_max_sx plot_format plot_options plot_realpart'
      + ' png_file pochhammer_max_index points pointsize point_size points_joined point_type'
      + ' poislim poisson poly_coefficient_ring poly_elimination_order polyfactor poly_grobner_algorithm'
      + ' poly_grobner_debug poly_monomial_order poly_primary_elimination_order poly_return_term_list'
      + ' poly_secondary_elimination_order poly_top_reduction_only posfun position'
      + ' powerdisp pred prederror primep_number_of_tests product_use_gamma program'
      + ' programmode promote_float_to_bigfloat prompt proportional_axes props psexpand'
      + ' ps_file radexpand radius radsubstflag rassociative ratalgdenom ratchristof'
      + ' ratdenomdivide rateinstein ratepsilon ratfac rational ratmx ratprint ratriemann'
      + ' ratsimpexpons ratvarswitch ratweights ratweyl ratwtlvl real realonly redraw'
      + ' refcheck resolution restart resultant ric riem rmxchar %rnum_list rombergabs'
      + ' rombergit rombergmin rombergtol rootsconmode rootsepsilon run_viewer same_xy'
      + ' same_xyz savedef savefactors scalar scalarmatrixp scale scale_lp setcheck'
      + ' setcheckbreak setval show_edge_color show_edges show_edge_type show_edge_width'
      + ' show_id show_label showtime show_vertex_color show_vertex_size show_vertex_type'
      + ' show_vertices show_weight simp simplified_output simplify_products simpproduct'
      + ' simpsum sinnpiflag solvedecomposes solveexplicit solvefactors solvenullwarn'
      + ' solveradcan solvetrigwarn space sparse sphere spring_embedding_depth sqrtdispflag'
      + ' stardisp startphi starttheta stats_numer stringdisp structures style sublis_apply_lambda'
      + ' subnumsimp sumexpand sumsplitfact surface surface_hide svg_file symmetric'
      + ' tab taylordepth taylor_logexpand taylor_order_coefficients taylor_truncate_polynomials'
      + ' tensorkill terminal testsuite_files thetaresolution timer_devalue title tlimswitch'
      + ' tr track transcompile transform transform_xy translate_fast_arrays transparent'
      + ' transrun tr_array_as_ref tr_bound_function_applyp tr_file_tty_messagesp tr_float_can_branch_complex'
      + ' tr_function_call_default trigexpandplus trigexpandtimes triginverses trigsign'
      + ' trivial_solutions tr_numer tr_optimize_max_loop tr_semicompile tr_state_vars'
      + ' tr_warn_bad_function_calls tr_warn_fexpr tr_warn_meval tr_warn_mode'
      + ' tr_warn_undeclared tr_warn_undefined_variable tstep ttyoff tube_extremes'
      + ' ufg ug %unitexpand unit_vectors uric uriem use_fast_arrays user_preamble'
      + ' usersetunits values vect_cross verbose vertex_color vertex_coloring vertex_partition'
      + ' vertex_size vertex_type view warnings weyl width windowname windowtitle wired_surface'
      + ' wireframe xaxis xaxis_color xaxis_secondary xaxis_type xaxis_width xlabel'
      + ' xlabel_secondary xlength xrange xrange_secondary xtics xtics_axis xtics_rotate'
      + ' xtics_rotate_secondary xtics_secondary xtics_secondary_axis xu_grid x_voxel'
      + ' xy_file xyplane xy_scale yaxis yaxis_color yaxis_secondary yaxis_type yaxis_width'
      + ' ylabel ylabel_secondary ylength yrange yrange_secondary ytics ytics_axis'
      + ' ytics_rotate ytics_rotate_secondary ytics_secondary ytics_secondary_axis'
      + ' yv_grid y_voxel yx_ratio zaxis zaxis_color zaxis_type zaxis_width zeroa zerob'
      + ' zerobern zeta%pi zlabel zlabel_rotate zlength zmin zn_primroot_limit zn_primroot_pretest';
  var SYMBOLS = '_ __ %|0 %%|0';

  return {
    lexemes: '[A-Za-z_%][0-9A-Za-z_%]*',
    keywords: {
      keyword: KEYWORDS,
      literal: LITERALS,
      built_in: BUILTIN_FUNCTIONS,
      symbol: SYMBOLS,
    },
    contains: [
      {
        className: 'comment',
        begin: '/\\*',
        end: '\\*/',
        contains: ['self']
      },
      hljs.QUOTE_STRING_MODE,
      {
        className: 'number',
        relevance: 0,
        variants: [
          {
            // float number w/ exponent
            // hmm, I wonder if we ought to include other exponent markers?
            begin: '\\b(\\d+|\\d+\\.|\\.\\d+|\\d+\\.\\d+)[Ee][-+]?\\d+\\b',
          },
          {
            // bigfloat number
            begin: '\\b(\\d+|\\d+\\.|\\.\\d+|\\d+\\.\\d+)[Bb][-+]?\\d+\\b',
            relevance: 10
          },
          {
            // float number w/out exponent
            // Doesn't seem to recognize floats which start with '.'
            begin: '\\b(\\.\\d+|\\d+\\.\\d+)\\b',
          },
          {
            // integer in base up to 36
            // Doesn't seem to recognize integers which end with '.'
            begin: '\\b(\\d+|0[0-9A-Za-z]+)\\.?\\b',
          }
        ]
      }
    ],
    illegal: /@/
  }
};

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    keywords:
      'int float string vector matrix if else switch case default while do for in break ' +
      'continue global proc return about abs addAttr addAttributeEditorNodeHelp addDynamic ' +
      'addNewShelfTab addPP addPanelCategory addPrefixToName advanceToNextDrivenKey ' +
      'affectedNet affects aimConstraint air alias aliasAttr align alignCtx alignCurve ' +
      'alignSurface allViewFit ambientLight angle angleBetween animCone animCurveEditor ' +
      'animDisplay animView annotate appendStringArray applicationName applyAttrPreset ' +
      'applyTake arcLenDimContext arcLengthDimension arclen arrayMapper art3dPaintCtx ' +
      'artAttrCtx artAttrPaintVertexCtx artAttrSkinPaintCtx artAttrTool artBuildPaintMenu ' +
      'artFluidAttrCtx artPuttyCtx artSelectCtx artSetPaintCtx artUserPaintCtx assignCommand ' +
      'assignInputDevice assignViewportFactories attachCurve attachDeviceAttr attachSurface ' +
      'attrColorSliderGrp attrCompatibility attrControlGrp attrEnumOptionMenu ' +
      'attrEnumOptionMenuGrp attrFieldGrp attrFieldSliderGrp attrNavigationControlGrp ' +
      'attrPresetEditWin attributeExists attributeInfo attributeMenu attributeQuery ' +
      'autoKeyframe autoPlace bakeClip bakeFluidShading bakePartialHistory bakeResults ' +
      'bakeSimulation basename basenameEx batchRender bessel bevel bevelPlus binMembership ' +
      'bindSkin blend2 blendShape blendShapeEditor blendShapePanel blendTwoAttr blindDataType ' +
      'boneLattice boundary boxDollyCtx boxZoomCtx bufferCurve buildBookmarkMenu ' +
      'buildKeyframeMenu button buttonManip CBG cacheFile cacheFileCombine cacheFileMerge ' +
      'cacheFileTrack camera cameraView canCreateManip canvas capitalizeString catch ' +
      'catchQuiet ceil changeSubdivComponentDisplayLevel changeSubdivRegion channelBox ' +
      'character characterMap characterOutlineEditor characterize chdir checkBox checkBoxGrp ' +
      'checkDefaultRenderGlobals choice circle circularFillet clamp clear clearCache clip ' +
      'clipEditor clipEditorCurrentTimeCtx clipSchedule clipSchedulerOutliner clipTrimBefore ' +
      'closeCurve closeSurface cluster cmdFileOutput cmdScrollFieldExecuter ' +
      'cmdScrollFieldReporter cmdShell coarsenSubdivSelectionList collision color ' +
      'colorAtPoint colorEditor colorIndex colorIndexSliderGrp colorSliderButtonGrp ' +
      'colorSliderGrp columnLayout commandEcho commandLine commandPort compactHairSystem ' +
      'componentEditor compositingInterop computePolysetVolume condition cone confirmDialog ' +
      'connectAttr connectControl connectDynamic connectJoint connectionInfo constrain ' +
      'constrainValue constructionHistory container containsMultibyte contextInfo control ' +
      'convertFromOldLayers convertIffToPsd convertLightmap convertSolidTx convertTessellation ' +
      'convertUnit copyArray copyFlexor copyKey copySkinWeights cos cpButton cpCache ' +
      'cpClothSet cpCollision cpConstraint cpConvClothToMesh cpForces cpGetSolverAttr cpPanel ' +
      'cpProperty cpRigidCollisionFilter cpSeam cpSetEdit cpSetSolverAttr cpSolver ' +
      'cpSolverTypes cpTool cpUpdateClothUVs createDisplayLayer createDrawCtx createEditor ' +
      'createLayeredPsdFile createMotionField createNewShelf createNode createRenderLayer ' +
      'createSubdivRegion cross crossProduct ctxAbort ctxCompletion ctxEditMode ctxTraverse ' +
      'currentCtx currentTime currentTimeCtx currentUnit curve curveAddPtCtx ' +
      'curveCVCtx curveEPCtx curveEditorCtx curveIntersect curveMoveEPCtx curveOnSurface ' +
      'curveSketchCtx cutKey cycleCheck cylinder dagPose date defaultLightListCheckBox ' +
      'defaultNavigation defineDataServer defineVirtualDevice deformer deg_to_rad delete ' +
      'deleteAttr deleteShadingGroupsAndMaterials deleteShelfTab deleteUI deleteUnusedBrushes ' +
      'delrandstr detachCurve detachDeviceAttr detachSurface deviceEditor devicePanel dgInfo ' +
      'dgdirty dgeval dgtimer dimWhen directKeyCtx directionalLight dirmap dirname disable ' +
      'disconnectAttr disconnectJoint diskCache displacementToPoly displayAffected ' +
      'displayColor displayCull displayLevelOfDetail displayPref displayRGBColor ' +
      'displaySmoothness displayStats displayString displaySurface distanceDimContext ' +
      'distanceDimension doBlur dolly dollyCtx dopeSheetEditor dot dotProduct ' +
      'doubleProfileBirailSurface drag dragAttrContext draggerContext dropoffLocator ' +
      'duplicate duplicateCurve duplicateSurface dynCache dynControl dynExport dynExpression ' +
      'dynGlobals dynPaintEditor dynParticleCtx dynPref dynRelEdPanel dynRelEditor ' +
      'dynamicLoad editAttrLimits editDisplayLayerGlobals editDisplayLayerMembers ' +
      'editRenderLayerAdjustment editRenderLayerGlobals editRenderLayerMembers editor ' +
      'editorTemplate effector emit emitter enableDevice encodeString endString endsWith env ' +
      'equivalent equivalentTol erf error eval evalDeferred evalEcho event ' +
      'exactWorldBoundingBox exclusiveLightCheckBox exec executeForEachObject exists exp ' +
      'expression expressionEditorListen extendCurve extendSurface extrude fcheck fclose feof ' +
      'fflush fgetline fgetword file fileBrowserDialog fileDialog fileExtension fileInfo ' +
      'filetest filletCurve filter filterCurve filterExpand filterStudioImport ' +
      'findAllIntersections findAnimCurves findKeyframe findMenuItem findRelatedSkinCluster ' +
      'finder firstParentOf fitBspline flexor floatEq floatField floatFieldGrp floatScrollBar ' +
      'floatSlider floatSlider2 floatSliderButtonGrp floatSliderGrp floor flow fluidCacheInfo ' +
      'fluidEmitter fluidVoxelInfo flushUndo fmod fontDialog fopen formLayout format fprint ' +
      'frameLayout fread freeFormFillet frewind fromNativePath fwrite gamma gauss ' +
      'geometryConstraint getApplicationVersionAsFloat getAttr getClassification ' +
      'getDefaultBrush getFileList getFluidAttr getInputDeviceRange getMayaPanelTypes ' +
      'getModifiers getPanel getParticleAttr getPluginResource getenv getpid glRender ' +
      'glRenderEditor globalStitch gmatch goal gotoBindPose grabColor gradientControl ' +
      'gradientControlNoAttr graphDollyCtx graphSelectContext graphTrackCtx gravity grid ' +
      'gridLayout group groupObjectsByName HfAddAttractorToAS HfAssignAS HfBuildEqualMap ' +
      'HfBuildFurFiles HfBuildFurImages HfCancelAFR HfConnectASToHF HfCreateAttractor ' +
      'HfDeleteAS HfEditAS HfPerformCreateAS HfRemoveAttractorFromAS HfSelectAttached ' +
      'HfSelectAttractors HfUnAssignAS hardenPointCurve hardware hardwareRenderPanel ' +
      'headsUpDisplay headsUpMessage help helpLine hermite hide hilite hitTest hotBox hotkey ' +
      'hotkeyCheck hsv_to_rgb hudButton hudSlider hudSliderButton hwReflectionMap hwRender ' +
      'hwRenderLoad hyperGraph hyperPanel hyperShade hypot iconTextButton iconTextCheckBox ' +
      'iconTextRadioButton iconTextRadioCollection iconTextScrollList iconTextStaticLabel ' +
      'ikHandle ikHandleCtx ikHandleDisplayScale ikSolver ikSplineHandleCtx ikSystem ' +
      'ikSystemInfo ikfkDisplayMethod illustratorCurves image imfPlugins inheritTransform ' +
      'insertJoint insertJointCtx insertKeyCtx insertKnotCurve insertKnotSurface instance ' +
      'instanceable instancer intField intFieldGrp intScrollBar intSlider intSliderGrp ' +
      'interToUI internalVar intersect iprEngine isAnimCurve isConnected isDirty isParentOf ' +
      'isSameObject isTrue isValidObjectName isValidString isValidUiName isolateSelect ' +
      'itemFilter itemFilterAttr itemFilterRender itemFilterType joint jointCluster jointCtx ' +
      'jointDisplayScale jointLattice keyTangent keyframe keyframeOutliner ' +
      'keyframeRegionCurrentTimeCtx keyframeRegionDirectKeyCtx keyframeRegionDollyCtx ' +
      'keyframeRegionInsertKeyCtx keyframeRegionMoveKeyCtx keyframeRegionScaleKeyCtx ' +
      'keyframeRegionSelectKeyCtx keyframeRegionSetKeyCtx keyframeRegionTrackCtx ' +
      'keyframeStats lassoContext lattice latticeDeformKeyCtx launch launchImageEditor ' +
      'layerButton layeredShaderPort layeredTexturePort layout layoutDialog lightList ' +
      'lightListEditor lightListPanel lightlink lineIntersection linearPrecision linstep ' +
      'listAnimatable listAttr listCameras listConnections listDeviceAttachments listHistory ' +
      'listInputDeviceAxes listInputDeviceButtons listInputDevices listMenuAnnotation ' +
      'listNodeTypes listPanelCategories listRelatives listSets listTransforms ' +
      'listUnselected listerEditor loadFluid loadNewShelf loadPlugin ' +
      'loadPluginLanguageResources loadPrefObjects localizedPanelLabel lockNode loft log ' +
      'longNameOf lookThru ls lsThroughFilter lsType lsUI Mayatomr mag makeIdentity makeLive ' +
      'makePaintable makeRoll makeSingleSurface makeTubeOn makebot manipMoveContext ' +
      'manipMoveLimitsCtx manipOptions manipRotateContext manipRotateLimitsCtx ' +
      'manipScaleContext manipScaleLimitsCtx marker match max memory menu menuBarLayout ' +
      'menuEditor menuItem menuItemToShelf menuSet menuSetPref messageLine min minimizeApp ' +
      'mirrorJoint modelCurrentTimeCtx modelEditor modelPanel mouse movIn movOut move ' +
      'moveIKtoFK moveKeyCtx moveVertexAlongDirection multiProfileBirailSurface mute ' +
      'nParticle nameCommand nameField namespace namespaceInfo newPanelItems newton nodeCast ' +
      'nodeIconButton nodeOutliner nodePreset nodeType noise nonLinear normalConstraint ' +
      'normalize nurbsBoolean nurbsCopyUVSet nurbsCube nurbsEditUV nurbsPlane nurbsSelect ' +
      'nurbsSquare nurbsToPoly nurbsToPolygonsPref nurbsToSubdiv nurbsToSubdivPref ' +
      'nurbsUVSet nurbsViewDirectionVector objExists objectCenter objectLayer objectType ' +
      'objectTypeUI obsoleteProc oceanNurbsPreviewPlane offsetCurve offsetCurveOnSurface ' +
      'offsetSurface openGLExtension openMayaPref optionMenu optionMenuGrp optionVar orbit ' +
      'orbitCtx orientConstraint outlinerEditor outlinerPanel overrideModifier ' +
      'paintEffectsDisplay pairBlend palettePort paneLayout panel panelConfiguration ' +
      'panelHistory paramDimContext paramDimension paramLocator parent parentConstraint ' +
      'particle particleExists particleInstancer particleRenderInfo partition pasteKey ' +
      'pathAnimation pause pclose percent performanceOptions pfxstrokes pickWalk picture ' +
      'pixelMove planarSrf plane play playbackOptions playblast plugAttr plugNode pluginInfo ' +
      'pluginResourceUtil pointConstraint pointCurveConstraint pointLight pointMatrixMult ' +
      'pointOnCurve pointOnSurface pointPosition poleVectorConstraint polyAppend ' +
      'polyAppendFacetCtx polyAppendVertex polyAutoProjection polyAverageNormal ' +
      'polyAverageVertex polyBevel polyBlendColor polyBlindData polyBoolOp polyBridgeEdge ' +
      'polyCacheMonitor polyCheck polyChipOff polyClipboard polyCloseBorder polyCollapseEdge ' +
      'polyCollapseFacet polyColorBlindData polyColorDel polyColorPerVertex polyColorSet ' +
      'polyCompare polyCone polyCopyUV polyCrease polyCreaseCtx polyCreateFacet ' +
      'polyCreateFacetCtx polyCube polyCut polyCutCtx polyCylinder polyCylindricalProjection ' +
      'polyDelEdge polyDelFacet polyDelVertex polyDuplicateAndConnect polyDuplicateEdge ' +
      'polyEditUV polyEditUVShell polyEvaluate polyExtrudeEdge polyExtrudeFacet ' +
      'polyExtrudeVertex polyFlipEdge polyFlipUV polyForceUV polyGeoSampler polyHelix ' +
      'polyInfo polyInstallAction polyLayoutUV polyListComponentConversion polyMapCut ' +
      'polyMapDel polyMapSew polyMapSewMove polyMergeEdge polyMergeEdgeCtx polyMergeFacet ' +
      'polyMergeFacetCtx polyMergeUV polyMergeVertex polyMirrorFace polyMoveEdge ' +
      'polyMoveFacet polyMoveFacetUV polyMoveUV polyMoveVertex polyNormal polyNormalPerVertex ' +
      'polyNormalizeUV polyOptUvs polyOptions polyOutput polyPipe polyPlanarProjection ' +
      'polyPlane polyPlatonicSolid polyPoke polyPrimitive polyPrism polyProjection ' +
      'polyPyramid polyQuad polyQueryBlindData polyReduce polySelect polySelectConstraint ' +
      'polySelectConstraintMonitor polySelectCtx polySelectEditCtx polySeparate ' +
      'polySetToFaceNormal polySewEdge polyShortestPathCtx polySmooth polySoftEdge ' +
      'polySphere polySphericalProjection polySplit polySplitCtx polySplitEdge polySplitRing ' +
      'polySplitVertex polyStraightenUVBorder polySubdivideEdge polySubdivideFacet ' +
      'polyToSubdiv polyTorus polyTransfer polyTriangulate polyUVSet polyUnite polyWedgeFace ' +
      'popen popupMenu pose pow preloadRefEd print progressBar progressWindow projFileViewer ' +
      'projectCurve projectTangent projectionContext projectionManip promptDialog propModCtx ' +
      'propMove psdChannelOutliner psdEditTextureFile psdExport psdTextureFile putenv pwd ' +
      'python querySubdiv quit rad_to_deg radial radioButton radioButtonGrp radioCollection ' +
      'radioMenuItemCollection rampColorPort rand randomizeFollicles randstate rangeControl ' +
      'readTake rebuildCurve rebuildSurface recordAttr recordDevice redo reference ' +
      'referenceEdit referenceQuery refineSubdivSelectionList refresh refreshAE ' +
      'registerPluginResource rehash reloadImage removeJoint removeMultiInstance ' +
      'removePanelCategory rename renameAttr renameSelectionList renameUI render ' +
      'renderGlobalsNode renderInfo renderLayerButton renderLayerParent ' +
      'renderLayerPostProcess renderLayerUnparent renderManip renderPartition ' +
      'renderQualityNode renderSettings renderThumbnailUpdate renderWindowEditor ' +
      'renderWindowSelectContext renderer reorder reorderDeformers requires reroot ' +
      'resampleFluid resetAE resetPfxToPolyCamera resetTool resolutionNode retarget ' +
      'reverseCurve reverseSurface revolve rgb_to_hsv rigidBody rigidSolver roll rollCtx ' +
      'rootOf rot rotate rotationInterpolation roundConstantRadius rowColumnLayout rowLayout ' +
      'runTimeCommand runup sampleImage saveAllShelves saveAttrPreset saveFluid saveImage ' +
      'saveInitialState saveMenu savePrefObjects savePrefs saveShelf saveToolSettings scale ' +
      'scaleBrushBrightness scaleComponents scaleConstraint scaleKey scaleKeyCtx sceneEditor ' +
      'sceneUIReplacement scmh scriptCtx scriptEditorInfo scriptJob scriptNode scriptTable ' +
      'scriptToShelf scriptedPanel scriptedPanelType scrollField scrollLayout sculpt ' +
      'searchPathArray seed selLoadSettings select selectContext selectCurveCV selectKey ' +
      'selectKeyCtx selectKeyframeRegionCtx selectMode selectPref selectPriority selectType ' +
      'selectedNodes selectionConnection separator setAttr setAttrEnumResource ' +
      'setAttrMapping setAttrNiceNameResource setConstraintRestPosition ' +
      'setDefaultShadingGroup setDrivenKeyframe setDynamic setEditCtx setEditor setFluidAttr ' +
      'setFocus setInfinity setInputDeviceMapping setKeyCtx setKeyPath setKeyframe ' +
      'setKeyframeBlendshapeTargetWts setMenuMode setNodeNiceNameResource setNodeTypeFlag ' +
      'setParent setParticleAttr setPfxToPolyCamera setPluginResource setProject ' +
      'setStampDensity setStartupMessage setState setToolTo setUITemplate setXformManip sets ' +
      'shadingConnection shadingGeometryRelCtx shadingLightRelCtx shadingNetworkCompare ' +
      'shadingNode shapeCompare shelfButton shelfLayout shelfTabLayout shellField ' +
      'shortNameOf showHelp showHidden showManipCtx showSelectionInTitle ' +
      'showShadingGroupAttrEditor showWindow sign simplify sin singleProfileBirailSurface ' +
      'size sizeBytes skinCluster skinPercent smoothCurve smoothTangentSurface smoothstep ' +
      'snap2to2 snapKey snapMode snapTogetherCtx snapshot soft softMod softModCtx sort sound ' +
      'soundControl source spaceLocator sphere sphrand spotLight spotLightPreviewPort ' +
      'spreadSheetEditor spring sqrt squareSurface srtContext stackTrace startString ' +
      'startsWith stitchAndExplodeShell stitchSurface stitchSurfacePoints strcmp ' +
      'stringArrayCatenate stringArrayContains stringArrayCount stringArrayInsertAtIndex ' +
      'stringArrayIntersector stringArrayRemove stringArrayRemoveAtIndex ' +
      'stringArrayRemoveDuplicates stringArrayRemoveExact stringArrayToString ' +
      'stringToStringArray strip stripPrefixFromName stroke subdAutoProjection ' +
      'subdCleanTopology subdCollapse subdDuplicateAndConnect subdEditUV ' +
      'subdListComponentConversion subdMapCut subdMapSewMove subdMatchTopology subdMirror ' +
      'subdToBlind subdToPoly subdTransferUVsToCache subdiv subdivCrease ' +
      'subdivDisplaySmoothness substitute substituteAllString substituteGeometry substring ' +
      'surface surfaceSampler surfaceShaderList swatchDisplayPort switchTable symbolButton ' +
      'symbolCheckBox sysFile system tabLayout tan tangentConstraint texLatticeDeformContext ' +
      'texManipContext texMoveContext texMoveUVShellContext texRotateContext texScaleContext ' +
      'texSelectContext texSelectShortestPathCtx texSmudgeUVContext texWinToolCtx text ' +
      'textCurves textField textFieldButtonGrp textFieldGrp textManip textScrollList ' +
      'textToShelf textureDisplacePlane textureHairColor texturePlacementContext ' +
      'textureWindow threadCount threePointArcCtx timeControl timePort timerX toNativePath ' +
      'toggle toggleAxis toggleWindowVisibility tokenize tokenizeList tolerance tolower ' +
      'toolButton toolCollection toolDropped toolHasOptions toolPropertyWindow torus toupper ' +
      'trace track trackCtx transferAttributes transformCompare transformLimits translator ' +
      'trim trunc truncateFluidCache truncateHairCache tumble tumbleCtx turbulence ' +
      'twoPointArcCtx uiRes uiTemplate unassignInputDevice undo undoInfo ungroup uniform unit ' +
      'unloadPlugin untangleUV untitledFileName untrim upAxis updateAE userCtx uvLink ' +
      'uvSnapshot validateShelfName vectorize view2dToolCtx viewCamera viewClipPlane ' +
      'viewFit viewHeadOn viewLookAt viewManip viewPlace viewSet visor volumeAxis vortex ' +
      'waitCursor warning webBrowser webBrowserPrefs whatIs window windowPref wire ' +
      'wireContext workspace wrinkle wrinkleContext writeTake xbmLangPathList xform',
    illegal: '</',
    contains: [
      hljs.C_NUMBER_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        className: 'string',
        begin: '`', end: '`',
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      { // eats variables
        begin: '[\\$\\%\\@](\\^\\w\\b|#\\w+|[^\\s\\w{]|{\\w+}|\\w+)'
      },
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE
    ]
  };
};

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var KEYWORDS = {
    keyword:
      'module use_module import_module include_module end_module initialise ' +
      'mutable initialize finalize finalise interface implementation pred ' +
      'mode func type inst solver any_pred any_func is semidet det nondet ' +
      'multi erroneous failure cc_nondet cc_multi typeclass instance where ' +
      'pragma promise external trace atomic or_else require_complete_switch ' +
      'require_det require_semidet require_multi require_nondet ' +
      'require_cc_multi require_cc_nondet require_erroneous require_failure',
    meta:
      // pragma
      'inline no_inline type_spec source_file fact_table obsolete memo ' +
      'loop_check minimal_model terminates does_not_terminate ' +
      'check_termination promise_equivalent_clauses ' +
      // preprocessor
      'foreign_proc foreign_decl foreign_code foreign_type ' +
      'foreign_import_module foreign_export_enum foreign_export ' +
      'foreign_enum may_call_mercury will_not_call_mercury thread_safe ' +
      'not_thread_safe maybe_thread_safe promise_pure promise_semipure ' +
      'tabled_for_io local untrailed trailed attach_to_io_state ' +
      'can_pass_as_mercury_type stable will_not_throw_exception ' +
      'may_modify_trail will_not_modify_trail may_duplicate ' +
      'may_not_duplicate affects_liveness does_not_affect_liveness ' +
      'doesnt_affect_liveness no_sharing unknown_sharing sharing',
    built_in:
      'some all not if then else true fail false try catch catch_any ' +
      'semidet_true semidet_false semidet_fail impure_true impure semipure'
  };

  var COMMENT = hljs.COMMENT('%', '$');

  var NUMCODE = {
    className: 'number',
    begin: "0'.\\|0[box][0-9a-fA-F]*"
  };

  var ATOM = hljs.inherit(hljs.APOS_STRING_MODE, {relevance: 0});
  var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {relevance: 0});
  var STRING_FMT = {
    className: 'subst',
    begin: '\\\\[abfnrtv]\\|\\\\x[0-9a-fA-F]*\\\\\\|%[-+# *.0-9]*[dioxXucsfeEgGp]',
    relevance: 0
  };
  STRING.contains.push(STRING_FMT);

  var IMPLICATION = {
    className: 'built_in',
    variants: [
      {begin: '<=>'},
      {begin: '<=', relevance: 0},
      {begin: '=>', relevance: 0},
      {begin: '/\\\\'},
      {begin: '\\\\/'}
    ]
  };

  var HEAD_BODY_CONJUNCTION = {
    className: 'built_in',
    variants: [
      {begin: ':-\\|-->'},
      {begin: '=', relevance: 0}
    ]
  };

  return {
    aliases: ['m', 'moo'],
    keywords: KEYWORDS,
    contains: [
      IMPLICATION,
      HEAD_BODY_CONJUNCTION,
      COMMENT,
      hljs.C_BLOCK_COMMENT_MODE,
      NUMCODE,
      hljs.NUMBER_MODE,
      ATOM,
      STRING,
      {begin: /:-/} // relevance booster
    ]
  };
};

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
    //local labels: %?[FB]?[AT]?\d{1,2}\w+
  return {
    case_insensitive: true,
    aliases: ['mips'],
    lexemes: '\\.?' + hljs.IDENT_RE,
    keywords: {
      meta:
        //GNU preprocs
        '.2byte .4byte .align .ascii .asciz .balign .byte .code .data .else .end .endif .endm .endr .equ .err .exitm .extern .global .hword .if .ifdef .ifndef .include .irp .long .macro .rept .req .section .set .skip .space .text .word .ltorg ',
      built_in:
        '$0 $1 $2 $3 $4 $5 $6 $7 $8 $9 $10 $11 $12 $13 $14 $15 ' + // integer registers
        '$16 $17 $18 $19 $20 $21 $22 $23 $24 $25 $26 $27 $28 $29 $30 $31 ' + // integer registers
        'zero at v0 v1 a0 a1 a2 a3 a4 a5 a6 a7 ' + // integer register aliases
        't0 t1 t2 t3 t4 t5 t6 t7 t8 t9 s0 s1 s2 s3 s4 s5 s6 s7 s8 ' + // integer register aliases
        'k0 k1 gp sp fp ra ' + // integer register aliases
        '$f0 $f1 $f2 $f2 $f4 $f5 $f6 $f7 $f8 $f9 $f10 $f11 $f12 $f13 $f14 $f15 ' + // floating-point registers
        '$f16 $f17 $f18 $f19 $f20 $f21 $f22 $f23 $f24 $f25 $f26 $f27 $f28 $f29 $f30 $f31 ' + // floating-point registers
        'Context Random EntryLo0 EntryLo1 Context PageMask Wired EntryHi ' + // Coprocessor 0 registers
        'HWREna BadVAddr Count Compare SR IntCtl SRSCtl SRSMap Cause EPC PRId ' + // Coprocessor 0 registers
        'EBase Config Config1 Config2 Config3 LLAddr Debug DEPC DESAVE CacheErr ' + // Coprocessor 0 registers
        'ECC ErrorEPC TagLo DataLo TagHi DataHi WatchLo WatchHi PerfCtl PerfCnt ' // Coprocessor 0 registers
    },
    contains: [
      {
        className: 'keyword',
        begin: '\\b('+     //mnemonics
            // 32-bit integer instructions
            'addi?u?|andi?|b(al)?|beql?|bgez(al)?l?|bgtzl?|blezl?|bltz(al)?l?|' +
            'bnel?|cl[oz]|divu?|ext|ins|j(al)?|jalr(\.hb)?|jr(\.hb)?|lbu?|lhu?|' +
            'll|lui|lw[lr]?|maddu?|mfhi|mflo|movn|movz|move|msubu?|mthi|mtlo|mul|' +
            'multu?|nop|nor|ori?|rotrv?|sb|sc|se[bh]|sh|sllv?|slti?u?|srav?|' +
            'srlv?|subu?|sw[lr]?|xori?|wsbh|' +
            // floating-point instructions
            'abs\.[sd]|add\.[sd]|alnv.ps|bc1[ft]l?|' +
            'c\.(s?f|un|u?eq|[ou]lt|[ou]le|ngle?|seq|l[et]|ng[et])\.[sd]|' +
            '(ceil|floor|round|trunc)\.[lw]\.[sd]|cfc1|cvt\.d\.[lsw]|' +
            'cvt\.l\.[dsw]|cvt\.ps\.s|cvt\.s\.[dlw]|cvt\.s\.p[lu]|cvt\.w\.[dls]|' +
            'div\.[ds]|ldx?c1|luxc1|lwx?c1|madd\.[sd]|mfc1|mov[fntz]?\.[ds]|' +
            'msub\.[sd]|mth?c1|mul\.[ds]|neg\.[ds]|nmadd\.[ds]|nmsub\.[ds]|' +
            'p[lu][lu]\.ps|recip\.fmt|r?sqrt\.[ds]|sdx?c1|sub\.[ds]|suxc1|' +
            'swx?c1|' +
            // system control instructions
            'break|cache|d?eret|[de]i|ehb|mfc0|mtc0|pause|prefx?|rdhwr|' +
            'rdpgpr|sdbbp|ssnop|synci?|syscall|teqi?|tgei?u?|tlb(p|r|w[ir])|' +
            'tlti?u?|tnei?|wait|wrpgpr'+
        ')',
        end: '\\s'
      },
      hljs.COMMENT('[;#]', '$'),
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        className: 'string',
        begin: '\'',
        end: '[^\\\\]\'',
        relevance: 0
      },
      {
        className: 'title',
        begin: '\\|', end: '\\|',
        illegal: '\\n',
        relevance: 0
      },
      {
        className: 'number',
        variants: [
            {begin: '0x[0-9a-f]+'}, //hex
            {begin: '\\b-?\\d+'}           //bare number
        ],
        relevance: 0
      },
      {
        className: 'symbol',
        variants: [
            {begin: '^\\s*[a-z_\\.\\$][a-z0-9_\\.\\$]+:'}, //GNU MIPS syntax
            {begin: '^\\s*[0-9]+:'}, // numbered local labels
            {begin: '[0-9]+[bf]' }  // number local label reference (backwards, forwards)
        ],
        relevance: 0
      }
    ],
    illegal: '\/'
  };
};

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    keywords:
      'environ vocabularies notations constructors definitions ' +
      'registrations theorems schemes requirements begin end definition ' +
      'registration cluster existence pred func defpred deffunc theorem ' +
      'proof let take assume then thus hence ex for st holds consider ' +
      'reconsider such that and in provided of as from be being by means ' +
      'equals implies iff redefine define now not or attr is mode ' +
      'suppose per cases set thesis contradiction scheme reserve struct ' +
      'correctness compatibility coherence symmetry assymetry ' +
      'reflexivity irreflexivity connectedness uniqueness commutativity ' +
      'idempotence involutiveness projectivity',
    contains: [
      hljs.COMMENT('::', '$')
    ]
  };
};

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var PERL_KEYWORDS = 'getpwent getservent quotemeta msgrcv scalar kill dbmclose undef lc ' +
    'ma syswrite tr send umask sysopen shmwrite vec qx utime local oct semctl localtime ' +
    'readpipe do return format read sprintf dbmopen pop getpgrp not getpwnam rewinddir qq' +
    'fileno qw endprotoent wait sethostent bless s|0 opendir continue each sleep endgrent ' +
    'shutdown dump chomp connect getsockname die socketpair close flock exists index shmget' +
    'sub for endpwent redo lstat msgctl setpgrp abs exit select print ref gethostbyaddr ' +
    'unshift fcntl syscall goto getnetbyaddr join gmtime symlink semget splice x|0 ' +
    'getpeername recv log setsockopt cos last reverse gethostbyname getgrnam study formline ' +
    'endhostent times chop length gethostent getnetent pack getprotoent getservbyname rand ' +
    'mkdir pos chmod y|0 substr endnetent printf next open msgsnd readdir use unlink ' +
    'getsockopt getpriority rindex wantarray hex system getservbyport endservent int chr ' +
    'untie rmdir prototype tell listen fork shmread ucfirst setprotoent else sysseek link ' +
    'getgrgid shmctl waitpid unpack getnetbyname reset chdir grep split require caller ' +
    'lcfirst until warn while values shift telldir getpwuid my getprotobynumber delete and ' +
    'sort uc defined srand accept package seekdir getprotobyname semop our rename seek if q|0 ' +
    'chroot sysread setpwent no crypt getc chown sqrt write setnetent setpriority foreach ' +
    'tie sin msgget map stat getlogin unless elsif truncate exec keys glob tied closedir' +
    'ioctl socket readlink eval xor readline binmode setservent eof ord bind alarm pipe ' +
    'atan2 getgrent exp time push setgrent gt lt or ne m|0 break given say state when';
  var SUBST = {
    className: 'subst',
    begin: '[$@]\\{', end: '\\}',
    keywords: PERL_KEYWORDS
  };
  var METHOD = {
    begin: '->{', end: '}'
    // contains defined later
  };
  var VAR = {
    variants: [
      {begin: /\$\d/},
      {begin: /[\$%@](\^\w\b|#\w+(::\w+)*|{\w+}|\w+(::\w*)*)/},
      {begin: /[\$%@][^\s\w{]/, relevance: 0}
    ]
  };
  var STRING_CONTAINS = [hljs.BACKSLASH_ESCAPE, SUBST, VAR];
  var PERL_DEFAULT_CONTAINS = [
    VAR,
    hljs.HASH_COMMENT_MODE,
    hljs.COMMENT(
      '^\\=\\w',
      '\\=cut',
      {
        endsWithParent: true
      }
    ),
    METHOD,
    {
      className: 'string',
      contains: STRING_CONTAINS,
      variants: [
        {
          begin: 'q[qwxr]?\\s*\\(', end: '\\)',
          relevance: 5
        },
        {
          begin: 'q[qwxr]?\\s*\\[', end: '\\]',
          relevance: 5
        },
        {
          begin: 'q[qwxr]?\\s*\\{', end: '\\}',
          relevance: 5
        },
        {
          begin: 'q[qwxr]?\\s*\\|', end: '\\|',
          relevance: 5
        },
        {
          begin: 'q[qwxr]?\\s*\\<', end: '\\>',
          relevance: 5
        },
        {
          begin: 'qw\\s+q', end: 'q',
          relevance: 5
        },
        {
          begin: '\'', end: '\'',
          contains: [hljs.BACKSLASH_ESCAPE]
        },
        {
          begin: '"', end: '"'
        },
        {
          begin: '`', end: '`',
          contains: [hljs.BACKSLASH_ESCAPE]
        },
        {
          begin: '{\\w+}',
          contains: [],
          relevance: 0
        },
        {
          begin: '\-?\\w+\\s*\\=\\>',
          contains: [],
          relevance: 0
        }
      ]
    },
    {
      className: 'number',
      begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
      relevance: 0
    },
    { // regexp container
      begin: '(\\/\\/|' + hljs.RE_STARTERS_RE + '|\\b(split|return|print|reverse|grep)\\b)\\s*',
      keywords: 'split return print reverse grep',
      relevance: 0,
      contains: [
        hljs.HASH_COMMENT_MODE,
        {
          className: 'regexp',
          begin: '(s|tr|y)/(\\\\.|[^/])*/(\\\\.|[^/])*/[a-z]*',
          relevance: 10
        },
        {
          className: 'regexp',
          begin: '(m|qr)?/', end: '/[a-z]*',
          contains: [hljs.BACKSLASH_ESCAPE],
          relevance: 0 // allows empty "//" which is a common comment delimiter in other languages
        }
      ]
    },
    {
      className: 'function',
      beginKeywords: 'sub', end: '(\\s*\\(.*?\\))?[;{]', excludeEnd: true,
      relevance: 5,
      contains: [hljs.TITLE_MODE]
    },
    {
      begin: '-\\w\\b',
      relevance: 0
    },
    {
      begin: "^__DATA__$",
      end: "^__END__$",
      subLanguage: 'mojolicious',
      contains: [
        {
            begin: "^@@.*",
            end: "$",
            className: "comment"
        }
      ]
    }
  ];
  SUBST.contains = PERL_DEFAULT_CONTAINS;
  METHOD.contains = PERL_DEFAULT_CONTAINS;

  return {
    aliases: ['pl', 'pm'],
    lexemes: /[\w\.]+/,
    keywords: PERL_KEYWORDS,
    contains: PERL_DEFAULT_CONTAINS
  };
};

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    subLanguage: 'xml',
    contains: [
      {
        className: 'meta',
        begin: '^__(END|DATA)__$'
      },
    // mojolicious line
      {
        begin: "^\\s*%{1,2}={0,2}", end: '$',
        subLanguage: 'perl'
      },
    // mojolicious block
      {
        begin: "<%{1,2}={0,2}",
        end: "={0,1}%>",
        subLanguage: 'perl',
        excludeBegin: true,
        excludeEnd: true
      }
    ]
  };
};

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var NUMBER = {
    className: 'number', relevance: 0,
    variants: [
      {
        begin: '[$][a-fA-F0-9]+'
      },
      hljs.NUMBER_MODE
    ]
  };

  return {
    case_insensitive: true,
    keywords: {
      keyword: 'public private property continue exit extern new try catch ' +
        'eachin not abstract final select case default const local global field ' +
        'end if then else elseif endif while wend repeat until forever for ' +
        'to step next return module inline throw import',

      built_in: 'DebugLog DebugStop Error Print ACos ACosr ASin ASinr ATan ATan2 ATan2r ATanr Abs Abs Ceil ' +
        'Clamp Clamp Cos Cosr Exp Floor Log Max Max Min Min Pow Sgn Sgn Sin Sinr Sqrt Tan Tanr Seed PI HALFPI TWOPI',

      literal: 'true false null and or shl shr mod'
    },
    illegal: /\/\*/,
    contains: [
      hljs.COMMENT('#rem', '#end'),
      hljs.COMMENT(
        "'",
        '$',
        {
          relevance: 0
        }
      ),
      {
        className: 'function',
        beginKeywords: 'function method', end: '[(=:]|$',
        illegal: /\n/,
        contains: [
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        className: 'class',
        beginKeywords: 'class interface', end: '$',
        contains: [
          {
            beginKeywords: 'extends implements'
          },
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        className: 'built_in',
        begin: '\\b(self|super)\\b'
      },
      {
        className: 'meta',
        begin: '\\s*#', end: '$',
        keywords: {'meta-keyword': 'if else elseif endif end then'}
      },
      {
        className: 'meta',
        begin: '^\\s*strict\\b'
      },
      {
        beginKeywords: 'alias', end: '=',
        contains: [hljs.UNDERSCORE_TITLE_MODE]
      },
      hljs.QUOTE_STRING_MODE,
      NUMBER
    ]
  }
};

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var KEYWORDS = {
    keyword:
      // Moonscript keywords
      'if then not for in while do return else elseif break continue switch and or ' +
      'unless when class extends super local import export from using',
    literal:
      'true false nil',
    built_in:
      '_G _VERSION assert collectgarbage dofile error getfenv getmetatable ipairs load ' +
      'loadfile loadstring module next pairs pcall print rawequal rawget rawset require ' +
      'select setfenv setmetatable tonumber tostring type unpack xpcall coroutine debug ' +
      'io math os package string table'
  };
  var JS_IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
  var SUBST = {
    className: 'subst',
    begin: /#\{/, end: /}/,
    keywords: KEYWORDS
  };
  var EXPRESSIONS = [
    hljs.inherit(hljs.C_NUMBER_MODE,
      {starts: {end: '(\\s*/)?', relevance: 0}}), // a number tries to eat the following slash to prevent treating it as a regexp
    {
      className: 'string',
      variants: [
        {
          begin: /'/, end: /'/,
          contains: [hljs.BACKSLASH_ESCAPE]
        },
        {
          begin: /"/, end: /"/,
          contains: [hljs.BACKSLASH_ESCAPE, SUBST]
        }
      ]
    },
    {
      className: 'built_in',
      begin: '@__' + hljs.IDENT_RE
    },
    {
      begin: '@' + hljs.IDENT_RE // relevance booster on par with CoffeeScript
    },
    {
      begin: hljs.IDENT_RE + '\\\\' + hljs.IDENT_RE // inst\method
    }
  ];
  SUBST.contains = EXPRESSIONS;

  var TITLE = hljs.inherit(hljs.TITLE_MODE, {begin: JS_IDENT_RE});
  var PARAMS_RE = '(\\(.*\\))?\\s*\\B[-=]>';
  var PARAMS = {
    className: 'params',
    begin: '\\([^\\(]', returnBegin: true,
    /* We need another contained nameless mode to not have every nested
    pair of parens to be called "params" */
    contains: [{
      begin: /\(/, end: /\)/,
      keywords: KEYWORDS,
      contains: ['self'].concat(EXPRESSIONS)
    }]
  };

  return {
    aliases: ['moon'],
    keywords: KEYWORDS,
    illegal: /\/\*/,
    contains: EXPRESSIONS.concat([
      hljs.COMMENT('--', '$'),
      {
        className: 'function',  // function: -> =>
        begin: '^\\s*' + JS_IDENT_RE + '\\s*=\\s*' + PARAMS_RE, end: '[-=]>',
        returnBegin: true,
        contains: [TITLE, PARAMS]
      },
      {
        begin: /[\(,:=]\s*/, // anonymous function start
        relevance: 0,
        contains: [
          {
            className: 'function',
            begin: PARAMS_RE, end: '[-=]>',
            returnBegin: true,
            contains: [PARAMS]
          }
        ]
      },
      {
        className: 'class',
        beginKeywords: 'class',
        end: '$',
        illegal: /[:="\[\]]/,
        contains: [
          {
            beginKeywords: 'extends',
            endsWithParent: true,
            illegal: /[:="\[\]]/,
            contains: [TITLE]
          },
          TITLE
        ]
      },
      {
        className: 'name',    // table
        begin: JS_IDENT_RE + ':', end: ':',
        returnBegin: true, returnEnd: true,
        relevance: 0
      }
    ])
  };
};

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    case_insensitive: true,
    contains: [
      {
        beginKeywords:
          'build create index delete drop explain infer|10 insert merge prepare select update upsert|10',
        end: /;/, endsWithParent: true,
        keywords: {
          // Taken from http://developer.couchbase.com/documentation/server/current/n1ql/n1ql-language-reference/reservedwords.html
          keyword:
            'all alter analyze and any array as asc begin between binary boolean break bucket build by call ' +
            'case cast cluster collate collection commit connect continue correlate cover create database ' +
            'dataset datastore declare decrement delete derived desc describe distinct do drop each element ' +
            'else end every except exclude execute exists explain fetch first flatten for force from ' +
            'function grant group gsi having if ignore ilike in include increment index infer inline inner ' +
            'insert intersect into is join key keys keyspace known last left let letting like limit lsm map ' +
            'mapping matched materialized merge minus namespace nest not number object offset on ' +
            'option or order outer over parse partition password path pool prepare primary private privilege ' +
            'procedure public raw realm reduce rename return returning revoke right role rollback satisfies ' +
            'schema select self semi set show some start statistics string system then to transaction trigger ' +
            'truncate under union unique unknown unnest unset update upsert use user using validate value ' +
            'valued values via view when where while with within work xor',
          // Taken from http://developer.couchbase.com/documentation/server/4.5/n1ql/n1ql-language-reference/literals.html
          literal:
            'true false null missing|5',
          // Taken from http://developer.couchbase.com/documentation/server/4.5/n1ql/n1ql-language-reference/functions.html
          built_in:
            'array_agg array_append array_concat array_contains array_count array_distinct array_ifnull array_length ' +
            'array_max array_min array_position array_prepend array_put array_range array_remove array_repeat array_replace ' +
            'array_reverse array_sort array_sum avg count max min sum greatest least ifmissing ifmissingornull ifnull ' +
            'missingif nullif ifinf ifnan ifnanorinf naninf neginfif posinfif clock_millis clock_str date_add_millis ' +
            'date_add_str date_diff_millis date_diff_str date_part_millis date_part_str date_trunc_millis date_trunc_str ' +
            'duration_to_str millis str_to_millis millis_to_str millis_to_utc millis_to_zone_name now_millis now_str ' +
            'str_to_duration str_to_utc str_to_zone_name decode_json encode_json encoded_size poly_length base64 base64_encode ' +
            'base64_decode meta uuid abs acos asin atan atan2 ceil cos degrees e exp ln log floor pi power radians random ' +
            'round sign sin sqrt tan trunc object_length object_names object_pairs object_inner_pairs object_values ' +
            'object_inner_values object_add object_put object_remove object_unwrap regexp_contains regexp_like regexp_position ' +
            'regexp_replace contains initcap length lower ltrim position repeat replace rtrim split substr title trim upper ' +
            'isarray isatom isboolean isnumber isobject isstring type toarray toatom toboolean tonumber toobject tostring'
        },
        contains: [
          {
            className: 'string',
            begin: '\'', end: '\'',
            contains: [hljs.BACKSLASH_ESCAPE],
            relevance: 0
          },
          {
            className: 'string',
            begin: '"', end: '"',
            contains: [hljs.BACKSLASH_ESCAPE],
            relevance: 0
          },
          {
            className: 'symbol',
            begin: '`', end: '`',
            contains: [hljs.BACKSLASH_ESCAPE],
            relevance: 2
          },
          hljs.C_NUMBER_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      hljs.C_BLOCK_COMMENT_MODE
    ]
  };
};

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var VAR = {
    className: 'variable',
    variants: [
      {begin: /\$\d+/},
      {begin: /\$\{/, end: /}/},
      {begin: '[\\$\\@]' + hljs.UNDERSCORE_IDENT_RE}
    ]
  };
  var DEFAULT = {
    endsWithParent: true,
    lexemes: '[a-z/_]+',
    keywords: {
      literal:
        'on off yes no true false none blocked debug info notice warn error crit ' +
        'select break last permanent redirect kqueue rtsig epoll poll /dev/poll'
    },
    relevance: 0,
    illegal: '=>',
    contains: [
      hljs.HASH_COMMENT_MODE,
      {
        className: 'string',
        contains: [hljs.BACKSLASH_ESCAPE, VAR],
        variants: [
          {begin: /"/, end: /"/},
          {begin: /'/, end: /'/}
        ]
      },
      // this swallows entire URLs to avoid detecting numbers within
      {
        begin: '([a-z]+):/', end: '\\s', endsWithParent: true, excludeEnd: true,
        contains: [VAR]
      },
      {
        className: 'regexp',
        contains: [hljs.BACKSLASH_ESCAPE, VAR],
        variants: [
          {begin: "\\s\\^", end: "\\s|{|;", returnEnd: true},
          // regexp locations (~, ~*)
          {begin: "~\\*?\\s+", end: "\\s|{|;", returnEnd: true},
          // *.example.com
          {begin: "\\*(\\.[a-z\\-]+)+"},
          // sub.example.*
          {begin: "([a-z\\-]+\\.)+\\*"}
        ]
      },
      // IP
      {
        className: 'number',
        begin: '\\b\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}(:\\d{1,5})?\\b'
      },
      // units
      {
        className: 'number',
        begin: '\\b\\d+[kKmMgGdshdwy]*\\b',
        relevance: 0
      },
      VAR
    ]
  };

  return {
    aliases: ['nginxconf'],
    contains: [
      hljs.HASH_COMMENT_MODE,
      {
        begin: hljs.UNDERSCORE_IDENT_RE + '\\s+{', returnBegin: true,
        end: '{',
        contains: [
          {
            className: 'section',
            begin: hljs.UNDERSCORE_IDENT_RE
          }
        ],
        relevance: 0
      },
      {
        begin: hljs.UNDERSCORE_IDENT_RE + '\\s', end: ';|{', returnBegin: true,
        contains: [
          {
            className: 'attribute',
            begin: hljs.UNDERSCORE_IDENT_RE,
            starts: DEFAULT
          }
        ],
        relevance: 0
      }
    ],
    illegal: '[^\\s\\}]'
  };
};

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    aliases: ['nim'],
    keywords: {
      keyword:
        'addr and as asm bind block break case cast const continue converter ' +
        'discard distinct div do elif else end enum except export finally ' +
        'for from generic if import in include interface is isnot iterator ' +
        'let macro method mixin mod nil not notin object of or out proc ptr ' +
        'raise ref return shl shr static template try tuple type using var ' +
        'when while with without xor yield',
      literal:
        'shared guarded stdin stdout stderr result true false',
      built_in:
        'int int8 int16 int32 int64 uint uint8 uint16 uint32 uint64 float ' +
        'float32 float64 bool char string cstring pointer expr stmt void ' +
        'auto any range array openarray varargs seq set clong culong cchar ' +
        'cschar cshort cint csize clonglong cfloat cdouble clongdouble ' +
        'cuchar cushort cuint culonglong cstringarray semistatic'
    },
    contains: [ {
        className: 'meta', // Actually pragma
        begin: /{\./,
        end: /\.}/,
        relevance: 10
      }, {
        className: 'string',
        begin: /[a-zA-Z]\w*"/,
        end: /"/,
        contains: [{begin: /""/}]
      }, {
        className: 'string',
        begin: /([a-zA-Z]\w*)?"""/,
        end: /"""/
      },
      hljs.QUOTE_STRING_MODE,
      {
        className: 'type',
        begin: /\b[A-Z]\w+\b/,
        relevance: 0
      }, {
        className: 'number',
        relevance: 0,
        variants: [
          {begin: /\b(0[xX][0-9a-fA-F][_0-9a-fA-F]*)('?[iIuU](8|16|32|64))?/},
          {begin: /\b(0o[0-7][_0-7]*)('?[iIuUfF](8|16|32|64))?/},
          {begin: /\b(0(b|B)[01][_01]*)('?[iIuUfF](8|16|32|64))?/},
          {begin: /\b(\d[_\d]*)('?[iIuUfF](8|16|32|64))?/}
        ]
      },
      hljs.HASH_COMMENT_MODE
    ]
  }
};

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var NIX_KEYWORDS = {
    keyword:
      'rec with let in inherit assert if else then',
    literal:
      'true false or and null',
    built_in:
      'import abort baseNameOf dirOf isNull builtins map removeAttrs throw ' +
      'toString derivation'
  };
  var ANTIQUOTE = {
    className: 'subst',
    begin: /\$\{/,
    end: /}/,
    keywords: NIX_KEYWORDS
  };
  var ATTRS = {
    begin: /[a-zA-Z0-9-_]+(\s*=)/, returnBegin: true,
    relevance: 0,
    contains: [
      {
        className: 'attr',
        begin: /\S+/
      }
    ]
  };
  var STRING = {
    className: 'string',
    contains: [ANTIQUOTE],
    variants: [
      {begin: "''", end: "''"},
      {begin: '"', end: '"'}
    ]
  };
  var EXPRESSIONS = [
    hljs.NUMBER_MODE,
    hljs.HASH_COMMENT_MODE,
    hljs.C_BLOCK_COMMENT_MODE,
    STRING,
    ATTRS
  ];
  ANTIQUOTE.contains = EXPRESSIONS;
  return {
    aliases: ["nixos"],
    keywords: NIX_KEYWORDS,
    contains: EXPRESSIONS
  };
};

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var CONSTANTS = {
    className: 'variable',
    begin: /\$(ADMINTOOLS|APPDATA|CDBURN_AREA|CMDLINE|COMMONFILES32|COMMONFILES64|COMMONFILES|COOKIES|DESKTOP|DOCUMENTS|EXEDIR|EXEFILE|EXEPATH|FAVORITES|FONTS|HISTORY|HWNDPARENT|INSTDIR|INTERNET_CACHE|LANGUAGE|LOCALAPPDATA|MUSIC|NETHOOD|OUTDIR|PICTURES|PLUGINSDIR|PRINTHOOD|PROFILE|PROGRAMFILES32|PROGRAMFILES64|PROGRAMFILES|QUICKLAUNCH|RECENT|RESOURCES_LOCALIZED|RESOURCES|SENDTO|SMPROGRAMS|SMSTARTUP|STARTMENU|SYSDIR|TEMP|TEMPLATES|VIDEOS|WINDIR)/
  };

  var DEFINES = {
    // ${defines}
    className: 'variable',
    begin: /\$+{[\w\.:-]+}/
  };

  var VARIABLES = {
    // $variables
    className: 'variable',
    begin: /\$+\w+/,
    illegal: /\(\){}/
  };

  var LANGUAGES = {
    // $(language_strings)
    className: 'variable',
    begin: /\$+\([\w\^\.:-]+\)/
  };

  var PARAMETERS = {
    // command parameters
    className: 'params',
    begin: '(ARCHIVE|FILE_ATTRIBUTE_ARCHIVE|FILE_ATTRIBUTE_NORMAL|FILE_ATTRIBUTE_OFFLINE|FILE_ATTRIBUTE_READONLY|FILE_ATTRIBUTE_SYSTEM|FILE_ATTRIBUTE_TEMPORARY|HKCR|HKCU|HKDD|HKEY_CLASSES_ROOT|HKEY_CURRENT_CONFIG|HKEY_CURRENT_USER|HKEY_DYN_DATA|HKEY_LOCAL_MACHINE|HKEY_PERFORMANCE_DATA|HKEY_USERS|HKLM|HKPD|HKU|IDABORT|IDCANCEL|IDIGNORE|IDNO|IDOK|IDRETRY|IDYES|MB_ABORTRETRYIGNORE|MB_DEFBUTTON1|MB_DEFBUTTON2|MB_DEFBUTTON3|MB_DEFBUTTON4|MB_ICONEXCLAMATION|MB_ICONINFORMATION|MB_ICONQUESTION|MB_ICONSTOP|MB_OK|MB_OKCANCEL|MB_RETRYCANCEL|MB_RIGHT|MB_RTLREADING|MB_SETFOREGROUND|MB_TOPMOST|MB_USERICON|MB_YESNO|NORMAL|OFFLINE|READONLY|SHCTX|SHELL_CONTEXT|SYSTEM|TEMPORARY)'
  };

  var COMPILER = {
    // !compiler_flags
    className: 'keyword',
    begin: /\!(addincludedir|addplugindir|appendfile|cd|define|delfile|echo|else|endif|error|execute|finalize|getdllversionsystem|ifdef|ifmacrodef|ifmacrondef|ifndef|if|include|insertmacro|macroend|macro|makensis|packhdr|searchparse|searchreplace|tempfile|undef|verbose|warning)/
  };

  var METACHARS = {
    // $\n, $\r, $\t, $$
    className: 'subst',
    begin: /\$(\\[nrt]|\$)/
  };

  var PLUGINS = {
    // plug::ins
    className: 'class',
    begin: /\w+\:\:\w+/
  };

    var STRING = {
      className: 'string',
      variants: [
        {
          begin: '"', end: '"'
        },
        {
          begin: '\'', end: '\''
        },
        {
          begin: '`', end: '`'
        }
      ],
      illegal: /\n/,
      contains: [
        METACHARS,
        CONSTANTS,
        DEFINES,
        VARIABLES,
        LANGUAGES
      ]
  };

  return {
    case_insensitive: false,
    keywords: {
      keyword:
      'Abort AddBrandingImage AddSize AllowRootDirInstall AllowSkipFiles AutoCloseWindow BGFont BGGradient BrandingText BringToFront Call CallInstDLL Caption ChangeUI CheckBitmap ClearErrors CompletedText ComponentText CopyFiles CRCCheck CreateDirectory CreateFont CreateShortCut Delete DeleteINISec DeleteINIStr DeleteRegKey DeleteRegValue DetailPrint DetailsButtonText DirText DirVar DirVerify EnableWindow EnumRegKey EnumRegValue Exch Exec ExecShell ExecWait ExpandEnvStrings File FileBufSize FileClose FileErrorText FileOpen FileRead FileReadByte FileReadUTF16LE FileReadWord FileSeek FileWrite FileWriteByte FileWriteUTF16LE FileWriteWord FindClose FindFirst FindNext FindWindow FlushINI FunctionEnd GetCurInstType GetCurrentAddress GetDlgItem GetDLLVersion GetDLLVersionLocal GetErrorLevel GetFileTime GetFileTimeLocal GetFullPathName GetFunctionAddress GetInstDirError GetLabelAddress GetTempFileName Goto HideWindow Icon IfAbort IfErrors IfFileExists IfRebootFlag IfSilent InitPluginsDir InstallButtonText InstallColors InstallDir InstallDirRegKey InstProgressFlags InstType InstTypeGetText InstTypeSetText IntCmp IntCmpU IntFmt IntOp IsWindow LangString LicenseBkColor LicenseData LicenseForceSelection LicenseLangString LicenseText LoadLanguageFile LockWindow LogSet LogText ManifestDPIAware ManifestSupportedOS MessageBox MiscButtonText Name Nop OutFile Page PageCallbacks PageExEnd Pop Push Quit ReadEnvStr ReadINIStr ReadRegDWORD ReadRegStr Reboot RegDLL Rename RequestExecutionLevel ReserveFile Return RMDir SearchPath SectionEnd SectionGetFlags SectionGetInstTypes SectionGetSize SectionGetText SectionGroupEnd SectionIn SectionSetFlags SectionSetInstTypes SectionSetSize SectionSetText SendMessage SetAutoClose SetBrandingImage SetCompress SetCompressor SetCompressorDictSize SetCtlColors SetCurInstType SetDatablockOptimize SetDateSave SetDetailsPrint SetDetailsView SetErrorLevel SetErrors SetFileAttributes SetFont SetOutPath SetOverwrite SetRebootFlag SetRegView SetShellVarContext SetSilent ShowInstDetails ShowUninstDetails ShowWindow SilentInstall SilentUnInstall Sleep SpaceTexts StrCmp StrCmpS StrCpy StrLen SubCaption Unicode UninstallButtonText UninstallCaption UninstallIcon UninstallSubCaption UninstallText UninstPage UnRegDLL Var VIAddVersionKey VIFileVersion VIProductVersion WindowIcon WriteINIStr WriteRegBin WriteRegDWORD WriteRegExpandStr WriteRegStr WriteUninstaller XPStyle',
      literal:
      'admin all auto both bottom bzip2 colored components current custom directory false force hide highest ifdiff ifnewer instfiles lastused leave left license listonly lzma nevershow none normal notset off on open print right show silent silentlog smooth textonly top true try un.components un.custom un.directory un.instfiles un.license uninstConfirm user Win10 Win7 Win8 WinVista zlib'
    },
    contains: [
      hljs.HASH_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.COMMENT(
        ';',
        '$',
        {
          relevance: 0
        }
      ),
      {
        className: 'function',
        beginKeywords: 'Function PageEx Section SectionGroup', end: '$'
      },
      STRING,
      COMPILER,
      DEFINES,
      VARIABLES,
      LANGUAGES,
      PARAMETERS,
      PLUGINS,
      hljs.NUMBER_MODE
    ]
  };
};

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var API_CLASS = {
    className: 'built_in',
    begin: '\\b(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)\\w+',
  };
  var OBJC_KEYWORDS = {
    keyword:
      'int float while char export sizeof typedef const struct for union ' +
      'unsigned long volatile static bool mutable if do return goto void ' +
      'enum else break extern asm case short default double register explicit ' +
      'signed typename this switch continue wchar_t inline readonly assign ' +
      'readwrite self @synchronized id typeof ' +
      'nonatomic super unichar IBOutlet IBAction strong weak copy ' +
      'in out inout bycopy byref oneway __strong __weak __block __autoreleasing ' +
      '@private @protected @public @try @property @end @throw @catch @finally ' +
      '@autoreleasepool @synthesize @dynamic @selector @optional @required ' +
      '@encode @package @import @defs @compatibility_alias ' +
      '__bridge __bridge_transfer __bridge_retained __bridge_retain ' +
      '__covariant __contravariant __kindof ' +
      '_Nonnull _Nullable _Null_unspecified ' +
      '__FUNCTION__ __PRETTY_FUNCTION__ __attribute__ ' +
      'getter setter retain unsafe_unretained ' +
      'nonnull nullable null_unspecified null_resettable class instancetype ' +
      'NS_DESIGNATED_INITIALIZER NS_UNAVAILABLE NS_REQUIRES_SUPER ' +
      'NS_RETURNS_INNER_POINTER NS_INLINE NS_AVAILABLE NS_DEPRECATED ' +
      'NS_ENUM NS_OPTIONS NS_SWIFT_UNAVAILABLE ' +
      'NS_ASSUME_NONNULL_BEGIN NS_ASSUME_NONNULL_END ' +
      'NS_REFINED_FOR_SWIFT NS_SWIFT_NAME NS_SWIFT_NOTHROW ' +
      'NS_DURING NS_HANDLER NS_ENDHANDLER NS_VALUERETURN NS_VOIDRETURN',
    literal:
      'false true FALSE TRUE nil YES NO NULL',
    built_in:
      'BOOL dispatch_once_t dispatch_queue_t dispatch_sync dispatch_async dispatch_once'
  };
  var LEXEMES = /[a-zA-Z@][a-zA-Z0-9_]*/;
  var CLASS_KEYWORDS = '@interface @class @protocol @implementation';
  return {
    aliases: ['mm', 'objc', 'obj-c'],
    keywords: OBJC_KEYWORDS,
    lexemes: LEXEMES,
    illegal: '</',
    contains: [
      API_CLASS,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.C_NUMBER_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        className: 'string',
        variants: [
          {
            begin: '@"', end: '"',
            illegal: '\\n',
            contains: [hljs.BACKSLASH_ESCAPE]
          },
          {
            begin: '\'', end: '[^\\\\]\'',
            illegal: '[^\\\\][^\']'
          }
        ]
      },
      {
        className: 'meta',
        begin: '#',
        end: '$',
        contains: [
          {
            className: 'meta-string',
            variants: [
              { begin: '\"', end: '\"' },
              { begin: '<', end: '>' }
            ]
          }
        ]
      },
      {
        className: 'class',
        begin: '(' + CLASS_KEYWORDS.split(' ').join('|') + ')\\b', end: '({|$)', excludeEnd: true,
        keywords: CLASS_KEYWORDS, lexemes: LEXEMES,
        contains: [
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        begin: '\\.'+hljs.UNDERSCORE_IDENT_RE,
        relevance: 0
      }
    ]
  };
};

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  /* missing support for heredoc-like string (OCaml 4.0.2+) */
  return {
    aliases: ['ml'],
    keywords: {
      keyword:
        'and as assert asr begin class constraint do done downto else end ' +
        'exception external for fun function functor if in include ' +
        'inherit! inherit initializer land lazy let lor lsl lsr lxor match method!|10 method ' +
        'mod module mutable new object of open! open or private rec sig struct ' +
        'then to try type val! val virtual when while with ' +
        /* camlp4 */
        'parser value',
      built_in:
        /* built-in types */
        'array bool bytes char exn|5 float int int32 int64 list lazy_t|5 nativeint|5 string unit ' +
        /* (some) types in Pervasives */
        'in_channel out_channel ref',
      literal:
        'true false'
    },
    illegal: /\/\/|>>/,
    lexemes: '[a-z_]\\w*!?',
    contains: [
      {
        className: 'literal',
        begin: '\\[(\\|\\|)?\\]|\\(\\)',
        relevance: 0
      },
      hljs.COMMENT(
        '\\(\\*',
        '\\*\\)',
        {
          contains: ['self']
        }
      ),
      { /* type variable */
        className: 'symbol',
        begin: '\'[A-Za-z_](?!\')[\\w\']*'
        /* the grammar is ambiguous on how 'a'b should be interpreted but not the compiler */
      },
      { /* polymorphic variant */
        className: 'type',
        begin: '`[A-Z][\\w\']*'
      },
      { /* module or constructor */
        className: 'type',
        begin: '\\b[A-Z][\\w\']*',
        relevance: 0
      },
      { /* don't color identifiers, but safely catch all identifiers with '*/
        begin: '[a-z_]\\w*\'[\\w\']*', relevance: 0
      },
      hljs.inherit(hljs.APOS_STRING_MODE, {className: 'string', relevance: 0}),
      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
      {
        className: 'number',
        begin:
          '\\b(0[xX][a-fA-F0-9_]+[Lln]?|' +
          '0[oO][0-7_]+[Lln]?|' +
          '0[bB][01_]+[Lln]?|' +
          '[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)',
        relevance: 0
      },
      {
        begin: /[-=]>/ // relevance booster
      }
    ]
  }
};

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
	var SPECIAL_VARS = {
		className: 'keyword',
		begin: '\\$(f[asn]|t|vp[rtd]|children)'
	},
	LITERALS = {
		className: 'literal',
		begin: 'false|true|PI|undef'
	},
	NUMBERS = {
		className: 'number',
		begin: '\\b\\d+(\\.\\d+)?(e-?\\d+)?', //adds 1e5, 1e-10
		relevance: 0
	},
	STRING = hljs.inherit(hljs.QUOTE_STRING_MODE,{illegal: null}),
	PREPRO = {
		className: 'meta',
		keywords: {'meta-keyword': 'include use'},
		begin: 'include|use <',
		end: '>'
	},
	PARAMS = {
		className: 'params',
		begin: '\\(', end: '\\)',
		contains: ['self', NUMBERS, STRING, SPECIAL_VARS, LITERALS]
	},
	MODIFIERS = {
		begin: '[*!#%]',
		relevance: 0
	},
	FUNCTIONS = {
		className: 'function',
		beginKeywords: 'module function',
		end: '\\=|\\{',
		contains: [PARAMS, hljs.UNDERSCORE_TITLE_MODE]
	};

	return {
		aliases: ['scad'],
		keywords: {
			keyword: 'function module include use for intersection_for if else \\%',
			literal: 'false true PI undef',
			built_in: 'circle square polygon text sphere cube cylinder polyhedron translate rotate scale resize mirror multmatrix color offset hull minkowski union difference intersection abs sign sin cos tan acos asin atan atan2 floor round ceil ln log pow sqrt exp rands min max concat lookup str chr search version version_num norm cross parent_module echo import import_dxf dxf_linear_extrude linear_extrude rotate_extrude surface projection render children dxf_cross dxf_dim let assign'
		},
		contains: [
			hljs.C_LINE_COMMENT_MODE,
			hljs.C_BLOCK_COMMENT_MODE,
			NUMBERS,
			PREPRO,
			STRING,
			SPECIAL_VARS,
			MODIFIERS,
			FUNCTIONS
		]
	}
};

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var OXYGENE_KEYWORDS = 'abstract add and array as asc aspect assembly async begin break block by case class concat const copy constructor continue '+
    'create default delegate desc distinct div do downto dynamic each else empty end ensure enum equals event except exit extension external false '+
    'final finalize finalizer finally flags for forward from function future global group has if implementation implements implies in index inherited '+
    'inline interface into invariants is iterator join locked locking loop matching method mod module namespace nested new nil not notify nullable of '+
    'old on operator or order out override parallel params partial pinned private procedure property protected public queryable raise read readonly '+
    'record reintroduce remove repeat require result reverse sealed select self sequence set shl shr skip static step soft take then to true try tuple '+
    'type union unit unsafe until uses using var virtual raises volatile where while with write xor yield await mapped deprecated stdcall cdecl pascal '+
    'register safecall overload library platform reference packed strict published autoreleasepool selector strong weak unretained';
  var CURLY_COMMENT =  hljs.COMMENT(
    '{',
    '}',
    {
      relevance: 0
    }
  );
  var PAREN_COMMENT = hljs.COMMENT(
    '\\(\\*',
    '\\*\\)',
    {
      relevance: 10
    }
  );
  var STRING = {
    className: 'string',
    begin: '\'', end: '\'',
    contains: [{begin: '\'\''}]
  };
  var CHAR_STRING = {
    className: 'string', begin: '(#\\d+)+'
  };
  var FUNCTION = {
    className: 'function',
    beginKeywords: 'function constructor destructor procedure method', end: '[:;]',
    keywords: 'function constructor|10 destructor|10 procedure|10 method|10',
    contains: [
      hljs.TITLE_MODE,
      {
        className: 'params',
        begin: '\\(', end: '\\)',
        keywords: OXYGENE_KEYWORDS,
        contains: [STRING, CHAR_STRING]
      },
      CURLY_COMMENT, PAREN_COMMENT
    ]
  };
  return {
    case_insensitive: true,
    lexemes: /\.?\w+/,
    keywords: OXYGENE_KEYWORDS,
    illegal: '("|\\$[G-Zg-z]|\\/\\*|</|=>|->)',
    contains: [
      CURLY_COMMENT, PAREN_COMMENT, hljs.C_LINE_COMMENT_MODE,
      STRING, CHAR_STRING,
      hljs.NUMBER_MODE,
      FUNCTION,
      {
        className: 'class',
        begin: '=\\bclass\\b', end: 'end;',
        keywords: OXYGENE_KEYWORDS,
        contains: [
          STRING, CHAR_STRING,
          CURLY_COMMENT, PAREN_COMMENT, hljs.C_LINE_COMMENT_MODE,
          FUNCTION
        ]
      }
    ]
  };
};

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var CURLY_SUBCOMMENT = hljs.COMMENT(
    '{',
    '}',
    {
      contains: ['self']
    }
  );
  return {
    subLanguage: 'xml', relevance: 0,
    contains: [
      hljs.COMMENT('^#', '$'),
      hljs.COMMENT(
        '\\^rem{',
        '}',
        {
          relevance: 10,
          contains: [
            CURLY_SUBCOMMENT
          ]
        }
      ),
      {
        className: 'meta',
        begin: '^@(?:BASE|USE|CLASS|OPTIONS)$',
        relevance: 10
      },
      {
        className: 'title',
        begin: '@[\\w\\-]+\\[[\\w^;\\-]*\\](?:\\[[\\w^;\\-]*\\])?(?:.*)$'
      },
      {
        className: 'variable',
        begin: '\\$\\{?[\\w\\-\\.\\:]+\\}?'
      },
      {
        className: 'keyword',
        begin: '\\^[\\w\\-\\.\\:]+'
      },
      {
        className: 'number',
        begin: '\\^#[0-9a-fA-F]+'
      },
      hljs.C_NUMBER_MODE
    ]
  };
};

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var MACRO = {
    className: 'variable',
    begin: /\$[\w\d#@][\w\d_]*/
  };
  var TABLE = {
    className: 'variable',
    begin: /<(?!\/)/, end: />/
  };
  var QUOTE_STRING = {
    className: 'string',
    begin: /"/, end: /"/
  };

  return {
    aliases: ['pf.conf'],
    lexemes: /[a-z0-9_<>-]+/,
    keywords: {
      built_in: /* block match pass are "actions" in pf.conf(5), the rest are
                 * lexically similar top-level commands.
                 */
        'block match pass load anchor|5 antispoof|10 set table',
      keyword:
        'in out log quick on rdomain inet inet6 proto from port os to route' +
        'allow-opts divert-packet divert-reply divert-to flags group icmp-type' +
        'icmp6-type label once probability recieved-on rtable prio queue' +
        'tos tag tagged user keep fragment for os drop' +
        'af-to|10 binat-to|10 nat-to|10 rdr-to|10 bitmask least-stats random round-robin' +
        'source-hash static-port' +
        'dup-to reply-to route-to' +
        'parent bandwidth default min max qlimit' +
        'block-policy debug fingerprints hostid limit loginterface optimization' +
        'reassemble ruleset-optimization basic none profile skip state-defaults' +
        'state-policy timeout' +
        'const counters persist' +
        'no modulate synproxy state|5 floating if-bound no-sync pflow|10 sloppy' +
        'source-track global rule max-src-nodes max-src-states max-src-conn' +
        'max-src-conn-rate overload flush' +
        'scrub|5 max-mss min-ttl no-df|10 random-id',
      literal:
        'all any no-route self urpf-failed egress|5 unknown'
    },
    contains: [
      hljs.HASH_COMMENT_MODE,
      hljs.NUMBER_MODE,
      hljs.QUOTE_STRING_MODE,
      MACRO,
      TABLE
    ]
  };
};

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var VARIABLE = {
    begin: '\\$+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*'
  };
  var PREPROCESSOR = {
    className: 'meta', begin: /<\?(php)?|\?>/
  };
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, PREPROCESSOR],
    variants: [
      {
        begin: 'b"', end: '"'
      },
      {
        begin: 'b\'', end: '\''
      },
      hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null})
    ]
  };
  var NUMBER = {variants: [hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE]};
  return {
    aliases: ['php3', 'php4', 'php5', 'php6'],
    case_insensitive: true,
    keywords:
      'and include_once list abstract global private echo interface as static endswitch ' +
      'array null if endwhile or const for endforeach self var while isset public ' +
      'protected exit foreach throw elseif include __FILE__ empty require_once do xor ' +
      'return parent clone use __CLASS__ __LINE__ else break print eval new ' +
      'catch __METHOD__ case exception default die require __FUNCTION__ ' +
      'enddeclare final try switch continue endfor endif declare unset true false ' +
      'trait goto instanceof insteadof __DIR__ __NAMESPACE__ ' +
      'yield finally',
    contains: [
      hljs.HASH_COMMENT_MODE,
      hljs.COMMENT('//', '$', {contains: [PREPROCESSOR]}),
      hljs.COMMENT(
        '/\\*',
        '\\*/',
        {
          contains: [
            {
              className: 'doctag',
              begin: '@[A-Za-z]+'
            }
          ]
        }
      ),
      hljs.COMMENT(
        '__halt_compiler.+?;',
        false,
        {
          endsWithParent: true,
          keywords: '__halt_compiler',
          lexemes: hljs.UNDERSCORE_IDENT_RE
        }
      ),
      {
        className: 'string',
        begin: /<<<['"]?\w+['"]?$/, end: /^\w+;?$/,
        contains: [
          hljs.BACKSLASH_ESCAPE,
          {
            className: 'subst',
            variants: [
              {begin: /\$\w+/},
              {begin: /\{\$/, end: /\}/}
            ]
          }
        ]
      },
      PREPROCESSOR,
      {
        className: 'keyword', begin: /\$this\b/
      },
      VARIABLE,
      {
        // swallow composed identifiers to avoid parsing them as keywords
        begin: /(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/
      },
      {
        className: 'function',
        beginKeywords: 'function', end: /[;{]/, excludeEnd: true,
        illegal: '\\$|\\[|%',
        contains: [
          hljs.UNDERSCORE_TITLE_MODE,
          {
            className: 'params',
            begin: '\\(', end: '\\)',
            contains: [
              'self',
              VARIABLE,
              hljs.C_BLOCK_COMMENT_MODE,
              STRING,
              NUMBER
            ]
          }
        ]
      },
      {
        className: 'class',
        beginKeywords: 'class interface', end: '{', excludeEnd: true,
        illegal: /[:\(\$"]/,
        contains: [
          {beginKeywords: 'extends implements'},
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        beginKeywords: 'namespace', end: ';',
        illegal: /[\.']/,
        contains: [hljs.UNDERSCORE_TITLE_MODE]
      },
      {
        beginKeywords: 'use', end: ';',
        contains: [hljs.UNDERSCORE_TITLE_MODE]
      },
      {
        begin: '=>' // No markup, just a relevance booster
      },
      STRING,
      NUMBER
    ]
  };
};

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var KEYWORDS = {
    keyword:
      'actor addressof and as be break class compile_error compile_intrinsic' +
      'consume continue delegate digestof do else elseif embed end error' +
      'for fun if ifdef in interface is isnt lambda let match new not object' +
      'or primitive recover repeat return struct then trait try type until ' +
      'use var where while with xor',
    meta:
      'iso val tag trn box ref',
    literal:
      'this false true'
  };

  var TRIPLE_QUOTE_STRING_MODE = {
    className: 'string',
    begin: '"""', end: '"""',
    relevance: 10
  };

  var QUOTE_STRING_MODE = {
    className: 'string',
    begin: '"', end: '"',
    contains: [hljs.BACKSLASH_ESCAPE]
  };

  var SINGLE_QUOTE_CHAR_MODE = {
    className: 'string',
    begin: '\'', end: '\'',
    contains: [hljs.BACKSLASH_ESCAPE],
    relevance: 0
  };

  var TYPE_NAME = {
    className: 'type',
    begin: '\\b_?[A-Z][\\w]*',
    relevance: 0
  };

  var PRIMED_NAME = {
    begin: hljs.IDENT_RE + '\'', relevance: 0
  };

  var CLASS = {
    className: 'class',
    beginKeywords: 'class actor', end: '$',
    contains: [
      hljs.TITLE_MODE,
      hljs.C_LINE_COMMENT_MODE
    ]
  }

  var FUNCTION = {
    className: 'function',
    beginKeywords: 'new fun', end: '=>',
    contains: [
      hljs.TITLE_MODE,
      {
        begin: /\(/, end: /\)/,
        contains: [
          TYPE_NAME,
          PRIMED_NAME,
          hljs.C_NUMBER_MODE,
          hljs.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        begin: /:/, endsWithParent: true,
        contains: [TYPE_NAME]
      },
      hljs.C_LINE_COMMENT_MODE
    ]
  }

  return {
    keywords: KEYWORDS,
    contains: [
      CLASS,
      FUNCTION,
      TYPE_NAME,
      TRIPLE_QUOTE_STRING_MODE,
      QUOTE_STRING_MODE,
      SINGLE_QUOTE_CHAR_MODE,
      PRIMED_NAME,
      hljs.C_NUMBER_MODE,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE
    ]
  };
};

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var BACKTICK_ESCAPE = {
    begin: '`[\\s\\S]',
    relevance: 0
  };
  var VAR = {
    className: 'variable',
    variants: [
      {begin: /\$[\w\d][\w\d_:]*/}
    ]
  };
  var LITERAL = {
    className: 'literal',
    begin: /\$(null|true|false)\b/
  };
  var QUOTE_STRING = {
    className: 'string',
    variants: [
      { begin: /"/, end: /"/ },
      { begin: /@"/, end: /^"@/ }
    ],
    contains: [
      BACKTICK_ESCAPE,
      VAR,
      {
        className: 'variable',
        begin: /\$[A-z]/, end: /[^A-z]/
      }
    ]
  };
  var APOS_STRING = {
    className: 'string',
    variants: [
      { begin: /'/, end: /'/ },
      { begin: /@'/, end: /^'@/ }
    ]
  };

  var PS_HELPTAGS = {
    className: 'doctag',
    variants: [
      /* no paramater help tags */ 
      { begin: /\.(synopsis|description|example|inputs|outputs|notes|link|component|role|functionality)/ },
      /* one parameter help tags */
      { begin: /\.(parameter|forwardhelptargetname|forwardhelpcategory|remotehelprunspace|externalhelp)\s+\S+/ }
    ]
  };
  var PS_COMMENT = hljs.inherit(
    hljs.COMMENT(null, null),
    {
      variants: [
        /* single-line comment */
        { begin: /#/, end: /$/ },
        /* multi-line comment */
        { begin: /<#/, end: /#>/ }
      ],
      contains: [PS_HELPTAGS]
    }
  );

  return {
    aliases: ['ps'],
    lexemes: /-?[A-z\.\-]+/,
    case_insensitive: true,
    keywords: {
      keyword: 'if else foreach return function do while until elseif begin for trap data dynamicparam end break throw param continue finally in switch exit filter try process catch',
      built_in: 'Add-Computer Add-Content Add-History Add-JobTrigger Add-Member Add-PSSnapin Add-Type Checkpoint-Computer Clear-Content Clear-EventLog Clear-History Clear-Host Clear-Item Clear-ItemProperty Clear-Variable Compare-Object Complete-Transaction Connect-PSSession Connect-WSMan Convert-Path ConvertFrom-Csv ConvertFrom-Json ConvertFrom-SecureString ConvertFrom-StringData ConvertTo-Csv ConvertTo-Html ConvertTo-Json ConvertTo-SecureString ConvertTo-Xml Copy-Item Copy-ItemProperty Debug-Process Disable-ComputerRestore Disable-JobTrigger Disable-PSBreakpoint Disable-PSRemoting Disable-PSSessionConfiguration Disable-WSManCredSSP Disconnect-PSSession Disconnect-WSMan Disable-ScheduledJob Enable-ComputerRestore Enable-JobTrigger Enable-PSBreakpoint Enable-PSRemoting Enable-PSSessionConfiguration Enable-ScheduledJob Enable-WSManCredSSP Enter-PSSession Exit-PSSession Export-Alias Export-Clixml Export-Console Export-Counter Export-Csv Export-FormatData Export-ModuleMember Export-PSSession ForEach-Object Format-Custom Format-List Format-Table Format-Wide Get-Acl Get-Alias Get-AuthenticodeSignature Get-ChildItem Get-Command Get-ComputerRestorePoint Get-Content Get-ControlPanelItem Get-Counter Get-Credential Get-Culture Get-Date Get-Event Get-EventLog Get-EventSubscriber Get-ExecutionPolicy Get-FormatData Get-Host Get-HotFix Get-Help Get-History Get-IseSnippet Get-Item Get-ItemProperty Get-Job Get-JobTrigger Get-Location Get-Member Get-Module Get-PfxCertificate Get-Process Get-PSBreakpoint Get-PSCallStack Get-PSDrive Get-PSProvider Get-PSSession Get-PSSessionConfiguration Get-PSSnapin Get-Random Get-ScheduledJob Get-ScheduledJobOption Get-Service Get-TraceSource Get-Transaction Get-TypeData Get-UICulture Get-Unique Get-Variable Get-Verb Get-WinEvent Get-WmiObject Get-WSManCredSSP Get-WSManInstance Group-Object Import-Alias Import-Clixml Import-Counter Import-Csv Import-IseSnippet Import-LocalizedData Import-PSSession Import-Module Invoke-AsWorkflow Invoke-Command Invoke-Expression Invoke-History Invoke-Item Invoke-RestMethod Invoke-WebRequest Invoke-WmiMethod Invoke-WSManAction Join-Path Limit-EventLog Measure-Command Measure-Object Move-Item Move-ItemProperty New-Alias New-Event New-EventLog New-IseSnippet New-Item New-ItemProperty New-JobTrigger New-Object New-Module New-ModuleManifest New-PSDrive New-PSSession New-PSSessionConfigurationFile New-PSSessionOption New-PSTransportOption New-PSWorkflowExecutionOption New-PSWorkflowSession New-ScheduledJobOption New-Service New-TimeSpan New-Variable New-WebServiceProxy New-WinEvent New-WSManInstance New-WSManSessionOption Out-Default Out-File Out-GridView Out-Host Out-Null Out-Printer Out-String Pop-Location Push-Location Read-Host Receive-Job Register-EngineEvent Register-ObjectEvent Register-PSSessionConfiguration Register-ScheduledJob Register-WmiEvent Remove-Computer Remove-Event Remove-EventLog Remove-Item Remove-ItemProperty Remove-Job Remove-JobTrigger Remove-Module Remove-PSBreakpoint Remove-PSDrive Remove-PSSession Remove-PSSnapin Remove-TypeData Remove-Variable Remove-WmiObject Remove-WSManInstance Rename-Computer Rename-Item Rename-ItemProperty Reset-ComputerMachinePassword Resolve-Path Restart-Computer Restart-Service Restore-Computer Resume-Job Resume-Service Save-Help Select-Object Select-String Select-Xml Send-MailMessage Set-Acl Set-Alias Set-AuthenticodeSignature Set-Content Set-Date Set-ExecutionPolicy Set-Item Set-ItemProperty Set-JobTrigger Set-Location Set-PSBreakpoint Set-PSDebug Set-PSSessionConfiguration Set-ScheduledJob Set-ScheduledJobOption Set-Service Set-StrictMode Set-TraceSource Set-Variable Set-WmiInstance Set-WSManInstance Set-WSManQuickConfig Show-Command Show-ControlPanelItem Show-EventLog Sort-Object Split-Path Start-Job Start-Process Start-Service Start-Sleep Start-Transaction Start-Transcript Stop-Computer Stop-Job Stop-Process Stop-Service Stop-Transcript Suspend-Job Suspend-Service Tee-Object Test-ComputerSecureChannel Test-Connection Test-ModuleManifest Test-Path Test-PSSessionConfigurationFile Trace-Command Unblock-File Undo-Transaction Unregister-Event Unregister-PSSessionConfiguration Unregister-ScheduledJob Update-FormatData Update-Help Update-List Update-TypeData Use-Transaction Wait-Event Wait-Job Wait-Process Where-Object Write-Debug Write-Error Write-EventLog Write-Host Write-Output Write-Progress Write-Verbose Write-Warning Add-MDTPersistentDrive Disable-MDTMonitorService Enable-MDTMonitorService Get-MDTDeploymentShareStatistics Get-MDTMonitorData Get-MDTOperatingSystemCatalog Get-MDTPersistentDrive Import-MDTApplication Import-MDTDriver Import-MDTOperatingSystem Import-MDTPackage Import-MDTTaskSequence New-MDTDatabase Remove-MDTMonitorData Remove-MDTPersistentDrive Restore-MDTPersistentDrive Set-MDTMonitorData Test-MDTDeploymentShare Test-MDTMonitorData Update-MDTDatabaseSchema Update-MDTDeploymentShare Update-MDTLinkedDS Update-MDTMedia Update-MDTMedia Add-VamtProductKey Export-VamtData Find-VamtManagedMachine Get-VamtConfirmationId Get-VamtProduct Get-VamtProductKey Import-VamtData Initialize-VamtData Install-VamtConfirmationId Install-VamtProductActivation Install-VamtProductKey Update-VamtProduct',
      nomarkup: '-ne -eq -lt -gt -ge -le -not -like -notlike -match -notmatch -contains -notcontains -in -notin -replace'
    },
    contains: [
      BACKTICK_ESCAPE,
      hljs.NUMBER_MODE,
      QUOTE_STRING,
      APOS_STRING,
      LITERAL,
      VAR,
      PS_COMMENT
    ]
  };
};

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    keywords: {
      keyword: 'BufferedReader PVector PFont PImage PGraphics HashMap boolean byte char color ' +
        'double float int long String Array FloatDict FloatList IntDict IntList JSONArray JSONObject ' +
        'Object StringDict StringList Table TableRow XML ' +
        // Java keywords
        'false synchronized int abstract float private char boolean static null if const ' +
        'for true while long throw strictfp finally protected import native final return void ' +
        'enum else break transient new catch instanceof byte super volatile case assert short ' +
        'package default double public try this switch continue throws protected public private',
      literal: 'P2D P3D HALF_PI PI QUARTER_PI TAU TWO_PI',
      title: 'setup draw',
      built_in: 'displayHeight displayWidth mouseY mouseX mousePressed pmouseX pmouseY key ' +
        'keyCode pixels focused frameCount frameRate height width ' +
        'size createGraphics beginDraw createShape loadShape PShape arc ellipse line point ' +
        'quad rect triangle bezier bezierDetail bezierPoint bezierTangent curve curveDetail curvePoint ' +
        'curveTangent curveTightness shape shapeMode beginContour beginShape bezierVertex curveVertex ' +
        'endContour endShape quadraticVertex vertex ellipseMode noSmooth rectMode smooth strokeCap ' +
        'strokeJoin strokeWeight mouseClicked mouseDragged mouseMoved mousePressed mouseReleased ' +
        'mouseWheel keyPressed keyPressedkeyReleased keyTyped print println save saveFrame day hour ' +
        'millis minute month second year background clear colorMode fill noFill noStroke stroke alpha ' +
        'blue brightness color green hue lerpColor red saturation modelX modelY modelZ screenX screenY ' +
        'screenZ ambient emissive shininess specular add createImage beginCamera camera endCamera frustum ' +
        'ortho perspective printCamera printProjection cursor frameRate noCursor exit loop noLoop popStyle ' +
        'pushStyle redraw binary boolean byte char float hex int str unbinary unhex join match matchAll nf ' +
        'nfc nfp nfs split splitTokens trim append arrayCopy concat expand reverse shorten sort splice subset ' +
        'box sphere sphereDetail createInput createReader loadBytes loadJSONArray loadJSONObject loadStrings ' +
        'loadTable loadXML open parseXML saveTable selectFolder selectInput beginRaw beginRecord createOutput ' +
        'createWriter endRaw endRecord PrintWritersaveBytes saveJSONArray saveJSONObject saveStream saveStrings ' +
        'saveXML selectOutput popMatrix printMatrix pushMatrix resetMatrix rotate rotateX rotateY rotateZ scale ' +
        'shearX shearY translate ambientLight directionalLight lightFalloff lights lightSpecular noLights normal ' +
        'pointLight spotLight image imageMode loadImage noTint requestImage tint texture textureMode textureWrap ' +
        'blend copy filter get loadPixels set updatePixels blendMode loadShader PShaderresetShader shader createFont ' +
        'loadFont text textFont textAlign textLeading textMode textSize textWidth textAscent textDescent abs ceil ' +
        'constrain dist exp floor lerp log mag map max min norm pow round sq sqrt acos asin atan atan2 cos degrees ' +
        'radians sin tan noise noiseDetail noiseSeed random randomGaussian randomSeed'
    },
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.C_NUMBER_MODE
    ]
  };
};

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    contains: [
      hljs.C_NUMBER_MODE,
      {
        begin: '[a-zA-Z_][\\da-zA-Z_]+\\.[\\da-zA-Z_]{1,3}', end: ':',
        excludeEnd: true
      },
      {
        begin: '(ncalls|tottime|cumtime)', end: '$',
        keywords: 'ncalls tottime|10 cumtime|10 filename',
        relevance: 10
      },
      {
        begin: 'function calls', end: '$',
        contains: [hljs.C_NUMBER_MODE],
        relevance: 10
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        className: 'string',
        begin: '\\(', end: '\\)$',
        excludeBegin: true, excludeEnd: true,
        relevance: 0
      }
    ]
  };
};

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

module.exports = function(hljs) {

  var ATOM = {

    begin: /[a-z][A-Za-z0-9_]*/,
    relevance: 0
  };

  var VAR = {

    className: 'symbol',
    variants: [
      {begin: /[A-Z][a-zA-Z0-9_]*/},
      {begin: /_[A-Za-z0-9_]*/},
    ],
    relevance: 0
  };

  var PARENTED = {

    begin: /\(/,
    end: /\)/,
    relevance: 0
  };

  var LIST = {

    begin: /\[/,
    end: /\]/
  };

  var LINE_COMMENT = {

    className: 'comment',
    begin: /%/, end: /$/,
    contains: [hljs.PHRASAL_WORDS_MODE]
  };

  var BACKTICK_STRING = {

    className: 'string',
    begin: /`/, end: /`/,
    contains: [hljs.BACKSLASH_ESCAPE]
  };

  var CHAR_CODE = {

    className: 'string', // 0'a etc.
    begin: /0\'(\\\'|.)/
  };

  var SPACE_CODE = {

    className: 'string',
    begin: /0\'\\s/ // 0'\s
  };

  var PRED_OP = { // relevance booster
    begin: /:-/
  };

  var inner = [

    ATOM,
    VAR,
    PARENTED,
    PRED_OP,
    LIST,
    LINE_COMMENT,
    hljs.C_BLOCK_COMMENT_MODE,
    hljs.QUOTE_STRING_MODE,
    hljs.APOS_STRING_MODE,
    BACKTICK_STRING,
    CHAR_CODE,
    SPACE_CODE,
    hljs.C_NUMBER_MODE
  ];

  PARENTED.contains = inner;
  LIST.contains = inner;

  return {
    contains: inner.concat([
      {begin: /\.$/} // relevance booster
    ])
  };
};

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    keywords: {
      keyword: 'package import option optional required repeated group',
      built_in: 'double float int32 int64 uint32 uint64 sint32 sint64 ' +
        'fixed32 fixed64 sfixed32 sfixed64 bool string bytes',
      literal: 'true false'
    },
    contains: [
      hljs.QUOTE_STRING_MODE,
      hljs.NUMBER_MODE,
      hljs.C_LINE_COMMENT_MODE,
      {
        className: 'class',
        beginKeywords: 'message enum service', end: /\{/,
        illegal: /\n/,
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {
            starts: {endsWithParent: true, excludeEnd: true} // hack: eating everything after the first title
          })
        ]
      },
      {
        className: 'function',
        beginKeywords: 'rpc',
        end: /;/, excludeEnd: true,
        keywords: 'rpc returns'
      },
      {
        begin: /^\s*[A-Z_]+/,
        end: /\s*=/, excludeEnd: true
      }
    ]
  };
};

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

module.exports = function(hljs) {

  var PUPPET_KEYWORDS = {
    keyword:
    /* language keywords */
      'and case default else elsif false if in import enherits node or true undef unless main settings $string ',
    literal:
    /* metaparameters */
      'alias audit before loglevel noop require subscribe tag ' +
    /* normal attributes */
      'owner ensure group mode name|0 changes context force incl lens load_path onlyif provider returns root show_diff type_check ' +
      'en_address ip_address realname command environment hour monute month monthday special target weekday '+
      'creates cwd ogoutput refresh refreshonly tries try_sleep umask backup checksum content ctime force ignore ' +
      'links mtime purge recurse recurselimit replace selinux_ignore_defaults selrange selrole seltype seluser source ' +
      'souirce_permissions sourceselect validate_cmd validate_replacement allowdupe attribute_membership auth_membership forcelocal gid '+
      'ia_load_module members system host_aliases ip allowed_trunk_vlans description device_url duplex encapsulation etherchannel ' +
      'native_vlan speed principals allow_root auth_class auth_type authenticate_user k_of_n mechanisms rule session_owner shared options ' +
      'device fstype enable hasrestart directory present absent link atboot blockdevice device dump pass remounts poller_tag use ' +
      'message withpath adminfile allow_virtual allowcdrom category configfiles flavor install_options instance package_settings platform ' +
      'responsefile status uninstall_options vendor unless_system_user unless_uid binary control flags hasstatus manifest pattern restart running ' +
      'start stop allowdupe auths expiry gid groups home iterations key_membership keys managehome membership password password_max_age ' +
      'password_min_age profile_membership profiles project purge_ssh_keys role_membership roles salt shell uid baseurl cost descr enabled ' +
      'enablegroups exclude failovermethod gpgcheck gpgkey http_caching include includepkgs keepalive metadata_expire metalink mirrorlist ' +
      'priority protect proxy proxy_password proxy_username repo_gpgcheck s3_enabled skip_if_unavailable sslcacert sslclientcert sslclientkey ' +
      'sslverify mounted',
    built_in:
    /* core facts */
      'architecture augeasversion blockdevices boardmanufacturer boardproductname boardserialnumber cfkey dhcp_servers ' +
      'domain ec2_ ec2_userdata facterversion filesystems ldom fqdn gid hardwareisa hardwaremodel hostname id|0 interfaces '+
      'ipaddress ipaddress_ ipaddress6 ipaddress6_ iphostnumber is_virtual kernel kernelmajversion kernelrelease kernelversion ' +
      'kernelrelease kernelversion lsbdistcodename lsbdistdescription lsbdistid lsbdistrelease lsbmajdistrelease lsbminordistrelease ' +
      'lsbrelease macaddress macaddress_ macosx_buildversion macosx_productname macosx_productversion macosx_productverson_major ' +
      'macosx_productversion_minor manufacturer memoryfree memorysize netmask metmask_ network_ operatingsystem operatingsystemmajrelease '+
      'operatingsystemrelease osfamily partitions path physicalprocessorcount processor processorcount productname ps puppetversion '+
      'rubysitedir rubyversion selinux selinux_config_mode selinux_config_policy selinux_current_mode selinux_current_mode selinux_enforced '+
      'selinux_policyversion serialnumber sp_ sshdsakey sshecdsakey sshrsakey swapencrypted swapfree swapsize timezone type uniqueid uptime '+
      'uptime_days uptime_hours uptime_seconds uuid virtual vlans xendomains zfs_version zonenae zones zpool_version'
  };

  var COMMENT = hljs.COMMENT('#', '$');

  var IDENT_RE = '([A-Za-z_]|::)(\\w|::)*';

  var TITLE = hljs.inherit(hljs.TITLE_MODE, {begin: IDENT_RE});

  var VARIABLE = {className: 'variable', begin: '\\$' + IDENT_RE};

  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE, VARIABLE],
    variants: [
      {begin: /'/, end: /'/},
      {begin: /"/, end: /"/}
    ]
  };

  return {
    aliases: ['pp'],
    contains: [
      COMMENT,
      VARIABLE,
      STRING,
      {
        beginKeywords: 'class', end: '\\{|;',
        illegal: /=/,
        contains: [TITLE, COMMENT]
      },
      {
        beginKeywords: 'define', end: /\{/,
        contains: [
          {
            className: 'section', begin: hljs.IDENT_RE, endsParent: true
          }
        ]
      },
      {
        begin: hljs.IDENT_RE + '\\s+\\{', returnBegin: true,
        end: /\S/,
        contains: [
          {
            className: 'keyword',
            begin: hljs.IDENT_RE
          },
          {
            begin: /\{/, end: /\}/,
            keywords: PUPPET_KEYWORDS,
            relevance: 0,
            contains: [
              STRING,
              COMMENT,
              {
                begin:'[a-zA-Z_]+\\s*=>',
                returnBegin: true, end: '=>',
                contains: [
                  {
                    className: 'attr',
                    begin: hljs.IDENT_RE,
                  }
                ]
              },
              {
                className: 'number',
                begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
                relevance: 0
              },
              VARIABLE
            ]
          }
        ],
        relevance: 0
      }
    ]
  }
};

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

module.exports = // Base deafult colors in PB IDE: background: #FFFFDF; foreground: #000000;

function(hljs) {
  var STRINGS = { // PB IDE color: #0080FF (Azure Radiance)
    className: 'string',
    begin: '(~)?"', end: '"',
    illegal: '\\n'
  };
  var CONSTANTS = { // PB IDE color: #924B72 (Cannon Pink)
    //  "#" + a letter or underscore + letters, digits or underscores + (optional) "$"
    className: 'symbol',
    begin: '#[a-zA-Z_]\\w*\\$?'
  };

  return {
    aliases: ['pb', 'pbi'],
    keywords: // PB IDE color: #006666 (Blue Stone) + Bold
      // The following keywords list was taken and adapted from GuShH's PureBasic language file for GeSHi...
      'And As Break CallDebugger Case CompilerCase CompilerDefault CompilerElse CompilerEndIf CompilerEndSelect ' +
      'CompilerError CompilerIf CompilerSelect Continue Data DataSection EndDataSection Debug DebugLevel ' +
      'Default Define Dim DisableASM DisableDebugger DisableExplicit Else ElseIf EnableASM ' +
      'EnableDebugger EnableExplicit End EndEnumeration EndIf EndImport EndInterface EndMacro EndProcedure ' +
      'EndSelect EndStructure EndStructureUnion EndWith Enumeration Extends FakeReturn For Next ForEach ' +
      'ForEver Global Gosub Goto If Import ImportC IncludeBinary IncludeFile IncludePath Interface Macro ' +
      'NewList Not Or ProcedureReturn Protected Prototype ' +
      'PrototypeC Read ReDim Repeat Until Restore Return Select Shared Static Step Structure StructureUnion ' +
      'Swap To Wend While With XIncludeFile XOr ' +
      'Procedure ProcedureC ProcedureCDLL ProcedureDLL Declare DeclareC DeclareCDLL DeclareDLL',
    contains: [
      // COMMENTS | PB IDE color: #00AAAA (Persian Green)
      hljs.COMMENT(';', '$', {relevance: 0}),

      { // PROCEDURES DEFINITIONS
        className: 'function',
        begin: '\\b(Procedure|Declare)(C|CDLL|DLL)?\\b',
        end: '\\(',
        excludeEnd: true,
        returnBegin: true,
        contains: [
          { // PROCEDURE KEYWORDS | PB IDE color: #006666 (Blue Stone) + Bold
            className: 'keyword',
            begin: '(Procedure|Declare)(C|CDLL|DLL)?',
            excludeEnd: true
          },
          { // PROCEDURE RETURN TYPE SETTING | PB IDE color: #000000 (Black)
            className: 'type',
            begin: '\\.\\w*'
            // end: ' ',
          },
          hljs.UNDERSCORE_TITLE_MODE // PROCEDURE NAME | PB IDE color: #006666 (Blue Stone)
        ]
      },
      STRINGS,
      CONSTANTS
    ]
  };
};

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var KEYWORDS = {
    keyword:
      'and elif is global as in if from raise for except finally print import pass return ' +
      'exec else break not with class assert yield try while continue del or def lambda ' +
      'async await nonlocal|10 None True False',
    built_in:
      'Ellipsis NotImplemented'
  };
  var PROMPT = {
    className: 'meta',  begin: /^(>>>|\.\.\.) /
  };
  var SUBST = {
    className: 'subst',
    begin: /\{/, end: /\}/,
    keywords: KEYWORDS,
    illegal: /#/
  };
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE],
    variants: [
      {
        begin: /(u|b)?r?'''/, end: /'''/,
        contains: [PROMPT],
        relevance: 10
      },
      {
        begin: /(u|b)?r?"""/, end: /"""/,
        contains: [PROMPT],
        relevance: 10
      },
      {
        begin: /(fr|rf|f)'''/, end: /'''/,
        contains: [PROMPT, SUBST]
      },
      {
        begin: /(fr|rf|f)"""/, end: /"""/,
        contains: [PROMPT, SUBST]
      },
      {
        begin: /(u|r|ur)'/, end: /'/,
        relevance: 10
      },
      {
        begin: /(u|r|ur)"/, end: /"/,
        relevance: 10
      },
      {
        begin: /(b|br)'/, end: /'/
      },
      {
        begin: /(b|br)"/, end: /"/
      },
      {
        begin: /(fr|rf|f)'/, end: /'/,
        contains: [SUBST]
      },
      {
        begin: /(fr|rf|f)"/, end: /"/,
        contains: [SUBST]
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE
    ]
  };
  var NUMBER = {
    className: 'number', relevance: 0,
    variants: [
      {begin: hljs.BINARY_NUMBER_RE + '[lLjJ]?'},
      {begin: '\\b(0o[0-7]+)[lLjJ]?'},
      {begin: hljs.C_NUMBER_RE + '[lLjJ]?'}
    ]
  };
  var PARAMS = {
    className: 'params',
    begin: /\(/, end: /\)/,
    contains: ['self', PROMPT, NUMBER, STRING]
  };
  SUBST.contains = [STRING, NUMBER, PROMPT];
  return {
    aliases: ['py', 'gyp'],
    keywords: KEYWORDS,
    illegal: /(<\/|->|\?)|=>/,
    contains: [
      PROMPT,
      NUMBER,
      STRING,
      hljs.HASH_COMMENT_MODE,
      {
        variants: [
          {className: 'function', beginKeywords: 'def'},
          {className: 'class', beginKeywords: 'class'}
        ],
        end: /:/,
        illegal: /[${=;\n,]/,
        contains: [
          hljs.UNDERSCORE_TITLE_MODE,
          PARAMS,
          {
            begin: /->/, endsWithParent: true,
            keywords: 'None'
          }
        ]
      },
      {
        className: 'meta',
        begin: /^[\t ]*@/, end: /$/
      },
      {
        begin: /\b(print|exec)\(/ // don’t highlight keywords-turned-functions in Python 3
      }
    ]
  };
};

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var Q_KEYWORDS = {
  keyword:
    'do while select delete by update from',
  literal:
    '0b 1b',
  built_in:
    'neg not null string reciprocal floor ceiling signum mod xbar xlog and or each scan over prior mmu lsq inv md5 ltime gtime count first var dev med cov cor all any rand sums prds mins maxs fills deltas ratios avgs differ prev next rank reverse iasc idesc asc desc msum mcount mavg mdev xrank mmin mmax xprev rotate distinct group where flip type key til get value attr cut set upsert raze union inter except cross sv vs sublist enlist read0 read1 hopen hclose hdel hsym hcount peach system ltrim rtrim trim lower upper ssr view tables views cols xcols keys xkey xcol xasc xdesc fkeys meta lj aj aj0 ij pj asof uj ww wj wj1 fby xgroup ungroup ej save load rsave rload show csv parse eval min max avg wavg wsum sin cos tan sum',
  type:
    '`float `double int `timestamp `timespan `datetime `time `boolean `symbol `char `byte `short `long `real `month `date `minute `second `guid'
  };
  return {
  aliases:['k', 'kdb'],
  keywords: Q_KEYWORDS,
  lexemes: /(`?)[A-Za-z0-9_]+\b/,
  contains: [
  hljs.C_LINE_COMMENT_MODE,
    hljs.QUOTE_STRING_MODE,
    hljs.C_NUMBER_MODE
     ]
  };
};

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var KEYWORDS = {
      keyword:
        'in of on if for while finally var new function do return void else break catch ' +
        'instanceof with throw case default try this switch continue typeof delete ' +
        'let yield const export super debugger as async await import',
      literal:
        'true false null undefined NaN Infinity',
      built_in:
        'eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent ' +
        'encodeURI encodeURIComponent escape unescape Object Function Boolean Error ' +
        'EvalError InternalError RangeError ReferenceError StopIteration SyntaxError ' +
        'TypeError URIError Number Math Date String RegExp Array Float32Array ' +
        'Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array ' +
        'Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require ' +
        'module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect ' +
        'Behavior bool color coordinate date double enumeration font geocircle georectangle ' +
        'geoshape int list matrix4x4 parent point quaternion real rect ' +
        'size string url variant vector2d vector3d vector4d' +
        'Promise'
    };

  var QML_IDENT_RE = '[a-zA-Z_][a-zA-Z0-9\\._]*';

  // Isolate property statements. Ends at a :, =, ;, ,, a comment or end of line.
  // Use property class.
  var PROPERTY = {
      className: 'keyword',
      begin: '\\bproperty\\b',
      starts: {
        className: 'string',
        end: '(:|=|;|,|//|/\\*|$)',
        returnEnd: true
      }
  };

  // Isolate signal statements. Ends at a ) a comment or end of line.
  // Use property class.
  var SIGNAL = {
      className: 'keyword',
      begin: '\\bsignal\\b',
      starts: {
        className: 'string',
        end: '(\\(|:|=|;|,|//|/\\*|$)',
        returnEnd: true
      }
  };

  // id: is special in QML. When we see id: we want to mark the id: as attribute and
  // emphasize the token following.
  var ID_ID = {
      className: 'attribute',
      begin: '\\bid\\s*:',
      starts: {
        className: 'string',
        end: QML_IDENT_RE,
        returnEnd: false
      }
  };

  // Find QML object attribute. An attribute is a QML identifier followed by :.
  // Unfortunately it's hard to know where it ends, as it may contain scalars,
  // objects, object definitions, or javascript. The true end is either when the parent
  // ends or the next attribute is detected.
  var QML_ATTRIBUTE = {
    begin: QML_IDENT_RE + '\\s*:',
    returnBegin: true,
    contains: [
      {
        className: 'attribute',
        begin: QML_IDENT_RE,
        end: '\\s*:',
        excludeEnd: true,
        relevance: 0
      }
    ],
    relevance: 0
  };

  // Find QML object. A QML object is a QML identifier followed by { and ends at the matching }.
  // All we really care about is finding IDENT followed by { and just mark up the IDENT and ignore the {.
  var QML_OBJECT = {
    begin: QML_IDENT_RE + '\\s*{', end: '{',
    returnBegin: true,
    relevance: 0,
    contains: [
      hljs.inherit(hljs.TITLE_MODE, {begin: QML_IDENT_RE})
    ]
  };

  return {
    aliases: ['qt'],
    case_insensitive: false,
    keywords: KEYWORDS,
    contains: [
      {
        className: 'meta',
        begin: /^\s*['"]use (strict|asm)['"]/
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      { // template string
        className: 'string',
        begin: '`', end: '`',
        contains: [
          hljs.BACKSLASH_ESCAPE,
          {
            className: 'subst',
            begin: '\\$\\{', end: '\\}'
          }
        ]
      },
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'number',
        variants: [
          { begin: '\\b(0[bB][01]+)' },
          { begin: '\\b(0[oO][0-7]+)' },
          { begin: hljs.C_NUMBER_RE }
        ],
        relevance: 0
      },
      { // "value" container
        begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
        keywords: 'return throw case',
        contains: [
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE,
          hljs.REGEXP_MODE,
          { // E4X / JSX
            begin: /</, end: />\s*[);\]]/,
            relevance: 0,
            subLanguage: 'xml'
          }
        ],
        relevance: 0
      },
      SIGNAL,
      PROPERTY,
      {
        className: 'function',
        beginKeywords: 'function', end: /\{/, excludeEnd: true,
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {begin: /[A-Za-z$_][0-9A-Za-z$_]*/}),
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            excludeBegin: true,
            excludeEnd: true,
            contains: [
              hljs.C_LINE_COMMENT_MODE,
              hljs.C_BLOCK_COMMENT_MODE
            ]
          }
        ],
        illegal: /\[|%/
      },
      {
        begin: '\\.' + hljs.IDENT_RE, relevance: 0 // hack: prevents detection of keywords after dots
      },
      ID_ID,
      QML_ATTRIBUTE,
      QML_OBJECT
    ],
    illegal: /#/
  };
};

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var IDENT_RE = '([a-zA-Z]|\\.[a-zA-Z.])[a-zA-Z0-9._]*';

  return {
    contains: [
      hljs.HASH_COMMENT_MODE,
      {
        begin: IDENT_RE,
        lexemes: IDENT_RE,
        keywords: {
          keyword:
            'function if in break next repeat else for return switch while try tryCatch ' +
            'stop warning require library attach detach source setMethod setGeneric ' +
            'setGroupGeneric setClass ...',
          literal:
            'NULL NA TRUE FALSE T F Inf NaN NA_integer_|10 NA_real_|10 NA_character_|10 ' +
            'NA_complex_|10'
        },
        relevance: 0
      },
      {
        // hex value
        className: 'number',
        begin: "0[xX][0-9a-fA-F]+[Li]?\\b",
        relevance: 0
      },
      {
        // explicit integer
        className: 'number',
        begin: "\\d+(?:[eE][+\\-]?\\d*)?L\\b",
        relevance: 0
      },
      {
        // number with trailing decimal
        className: 'number',
        begin: "\\d+\\.(?!\\d)(?:i\\b)?",
        relevance: 0
      },
      {
        // number
        className: 'number',
        begin: "\\d+(?:\\.\\d*)?(?:[eE][+\\-]?\\d*)?i?\\b",
        relevance: 0
      },
      {
        // number with leading decimal
        className: 'number',
        begin: "\\.\\d+(?:[eE][+\\-]?\\d*)?i?\\b",
        relevance: 0
      },

      {
        // escaped identifier
        begin: '`',
        end: '`',
        relevance: 0
      },

      {
        className: 'string',
        contains: [hljs.BACKSLASH_ESCAPE],
        variants: [
          {begin: '"', end: '"'},
          {begin: "'", end: "'"}
        ]
      }
    ]
  };
};

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    keywords:
      'ArchiveRecord AreaLightSource Atmosphere Attribute AttributeBegin AttributeEnd Basis ' +
      'Begin Blobby Bound Clipping ClippingPlane Color ColorSamples ConcatTransform Cone ' +
      'CoordinateSystem CoordSysTransform CropWindow Curves Cylinder DepthOfField Detail ' +
      'DetailRange Disk Displacement Display End ErrorHandler Exposure Exterior Format ' +
      'FrameAspectRatio FrameBegin FrameEnd GeneralPolygon GeometricApproximation Geometry ' +
      'Hider Hyperboloid Identity Illuminate Imager Interior LightSource ' +
      'MakeCubeFaceEnvironment MakeLatLongEnvironment MakeShadow MakeTexture Matte ' +
      'MotionBegin MotionEnd NuPatch ObjectBegin ObjectEnd ObjectInstance Opacity Option ' +
      'Orientation Paraboloid Patch PatchMesh Perspective PixelFilter PixelSamples ' +
      'PixelVariance Points PointsGeneralPolygons PointsPolygons Polygon Procedural Projection ' +
      'Quantize ReadArchive RelativeDetail ReverseOrientation Rotate Scale ScreenWindow ' +
      'ShadingInterpolation ShadingRate Shutter Sides Skew SolidBegin SolidEnd Sphere ' +
      'SubdivisionMesh Surface TextureCoordinates Torus Transform TransformBegin TransformEnd ' +
      'TransformPoints Translate TrimCurve WorldBegin WorldEnd',
    illegal: '</',
    contains: [
      hljs.HASH_COMMENT_MODE,
      hljs.C_NUMBER_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE
    ]
  };
};

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var IDENTIFIER = '[a-zA-Z-_][^\\n{]+\\{';

  var PROPERTY = {
    className: 'attribute',
    begin: /[a-zA-Z-_]+/, end: /\s*:/, excludeEnd: true,
    starts: {
      end: ';',
      relevance: 0,
      contains: [
        {
          className: 'variable',
          begin: /\.[a-zA-Z-_]+/
        },
        {
          className: 'keyword',
          begin: /\(optional\)/
        }
      ]
    }
  };

  return {
    aliases: ['graph', 'instances'],
    case_insensitive: true,
    keywords: 'import',
    contains: [
      // Facet sections
      {
        begin: '^facet ' + IDENTIFIER,
        end: '}',
        keywords: 'facet',
        contains: [
          PROPERTY,
          hljs.HASH_COMMENT_MODE
        ]
      },

      // Instance sections
      {
        begin: '^\\s*instance of ' + IDENTIFIER,
        end: '}',
        keywords: 'name count channels instance-data instance-state instance of',
        illegal: /\S/,
        contains: [
          'self',
          PROPERTY,
          hljs.HASH_COMMENT_MODE
        ]
      },

      // Component sections
      {
        begin: '^' + IDENTIFIER,
        end: '}',
        contains: [
          PROPERTY,
          hljs.HASH_COMMENT_MODE
        ]
      },

      // Comments
      hljs.HASH_COMMENT_MODE
    ]
  };
};

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

module.exports = // Colors from RouterOS terminal:
//   green        - #0E9A00
//   teal         - #0C9A9A
//   purple       - #99069A
//   light-brown  - #9A9900

function(hljs) {

  var STATEMENTS = 'foreach do while for if from to step else on-error and or not in';

  // Global commands: Every global command should start with ":" token, otherwise it will be treated as variable.
  var GLOBAL_COMMANDS = 'global local beep delay put len typeof pick log time set find environment terminal error execute parse resolve toarray tobool toid toip toip6 tonum tostr totime';

  // Common commands: Following commands available from most sub-menus:
  var COMMON_COMMANDS = 'add remove enable disable set get print export edit find run debug error info warning';

  var LITERALS = 'true false yes no nothing nil null';

  var OBJECTS = 'traffic-flow traffic-generator firewall scheduler aaa accounting address-list address align area bandwidth-server bfd bgp bridge client clock community config connection console customer default dhcp-client dhcp-server discovery dns e-mail ethernet filter firewall firmware gps graphing group hardware health hotspot identity igmp-proxy incoming instance interface ip ipsec ipv6 irq l2tp-server lcd ldp logging mac-server mac-winbox mangle manual mirror mme mpls nat nd neighbor network note ntp ospf ospf-v3 ovpn-server page peer pim ping policy pool port ppp pppoe-client pptp-server prefix profile proposal proxy queue radius resource rip ripng route routing screen script security-profiles server service service-port settings shares smb sms sniffer snmp snooper socks sstp-server system tool tracking type upgrade upnp user-manager users user vlan secret vrrp watchdog web-access wireless pptp pppoe lan wan layer7-protocol lease simple raw';

  // print parameters
  // Several parameters are available for print command:
  // ToDo: var PARAMETERS_PRINT = 'append as-value brief detail count-only file follow follow-only from interval terse value-list without-paging where info';
  // ToDo: var OPERATORS = '&& and ! not || or in ~ ^ & << >> + - * /';
  // ToDo: var TYPES = 'num number bool boolean str string ip ip6-prefix id time array';
  // ToDo: The following tokens serve as delimiters in the grammar: ()  []  {}  :   ;   $   / 

  var VAR_PREFIX = 'global local set for foreach';

  var VAR = {
    className: 'variable',
    variants: [
      {begin: /\$[\w\d#@][\w\d_]*/},
      {begin: /\$\{(.*?)}/}
    ]
  };
  
  var QUOTE_STRING = {
    className: 'string',
    begin: /"/, end: /"/,
    contains: [
      hljs.BACKSLASH_ESCAPE,
      VAR,
      {
        className: 'variable',
        begin: /\$\(/, end: /\)/,
        contains: [hljs.BACKSLASH_ESCAPE]
      }
    ]
  };
  
  var APOS_STRING = {
    className: 'string',
    begin: /'/, end: /'/
  };
  
  var IPADDR = '((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\b';
  var IPADDR_wBITMASK =  IPADDR+'/(3[0-2]|[1-2][0-9]|\\d)';
  //////////////////////////////////////////////////////////////////////
  return {
    aliases: ['routeros', 'mikrotik'],
    case_insensitive: true,
    lexemes: /:?[\w-]+/,
    keywords: {
      literal: LITERALS,
      keyword: STATEMENTS + ' :' + STATEMENTS.split(' ').join(' :') + ' :' + GLOBAL_COMMANDS.split(' ').join(' :'),
    },
    contains: [
      { // недопустимые конструкции
        variants: [
          { begin: /^@/, end: /$/, },               // dns
          { begin: /\/\*/, end: /\*\//, },          // -- comment
          { begin: /%%/, end: /$/, },               // -- comment
          { begin: /^'/, end: /$/, },               // Monkey one line comment
          { begin: /^\s*\/[\w-]+=/, end: /$/, },    // jboss-cli
          { begin: /\/\//, end: /$/, },             // Stan comment
          { begin: /^\[\</, end: /\>\]$/, },        // F# class declaration?
          { begin: /<\//, end: />/, },              // HTML tags
          { begin: /^facet /, end: /\}/, },         // roboconf - лютый костыль )))
          { begin: '^1\\.\\.(\\d+)$', end: /$/, },  // tap  
        ],
        illegal: /./,
      },
      hljs.COMMENT('^#', '$'),
      QUOTE_STRING,
      APOS_STRING,
      VAR,
      { // attribute=value
        begin: /[\w-]+\=([^\s\{\}\[\]\(\)]+)/, 
        relevance: 0,
        returnBegin: true,
        contains: [
          {
            className: 'attribute',
            begin: /[^=]+/
          },
          {
            begin: /=/, 
            endsWithParent:  true,
            relevance: 0,
            contains: [
              QUOTE_STRING,
              APOS_STRING,
              VAR,
              {
                className: 'literal',
                begin: '\\b(' + LITERALS.split(' ').join('|') + ')\\b',
              },
              /*{
                // IPv4 addresses and subnets
                className: 'number',
                variants: [
                  {begin: IPADDR_wBITMASK+'(,'+IPADDR_wBITMASK+')*'}, //192.168.0.0/24,1.2.3.0/24
                  {begin: IPADDR+'-'+IPADDR},       // 192.168.0.1-192.168.0.3
                  {begin: IPADDR+'(,'+IPADDR+')*'}, // 192.168.0.1,192.168.0.34,192.168.24.1,192.168.0.1
                ]
              }, // */
              /*{
                // MAC addresses and DHCP Client IDs
                className: 'number',
                begin: /\b(1:)?([0-9A-Fa-f]{1,2}[:-]){5}([0-9A-Fa-f]){1,2}\b/,
              }, //*/
              {
                // Не форматировать не классифицированные значения. Необходимо для исключения подсветки значений как built_in.
                // className: 'number',  
                begin: /("[^"]*"|[^\s\{\}\[\]]+)/,
              }, //*/
            ]
          } //*/
        ]
      },//*/
      {
        // HEX values
        className: 'number',
        begin: /\*[0-9a-fA-F]+/,
      }, //*/

      { 
        begin: '\\b(' + COMMON_COMMANDS.split(' ').join('|') + ')([\\s\[\(]|\])',
        returnBegin: true,
        contains: [
          {
            className: 'builtin-name', //'function',
            begin: /\w+/,
          },
        ],  
      },
      
      { 
        className: 'built_in',
        variants: [
          {begin: '(\\.\\./|/|\\s)((' + OBJECTS.split(' ').join('|') + ');?\\s)+',relevance: 10,},
          {begin: /\.\./,},
        ],
      },//*/
    ]
  };
};

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    keywords: {
      keyword:
        'float color point normal vector matrix while for if do return else break extern continue',
      built_in:
        'abs acos ambient area asin atan atmosphere attribute calculatenormal ceil cellnoise ' +
        'clamp comp concat cos degrees depth Deriv diffuse distance Du Dv environment exp ' +
        'faceforward filterstep floor format fresnel incident length lightsource log match ' +
        'max min mod noise normalize ntransform opposite option phong pnoise pow printf ' +
        'ptlined radians random reflect refract renderinfo round setcomp setxcomp setycomp ' +
        'setzcomp shadow sign sin smoothstep specular specularbrdf spline sqrt step tan ' +
        'texture textureinfo trace transform vtransform xcomp ycomp zcomp'
    },
    illegal: '</',
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.APOS_STRING_MODE,
      hljs.C_NUMBER_MODE,
      {
        className: 'meta',
        begin: '#', end: '$'
      },
      {
        className: 'class',
        beginKeywords: 'surface displacement light volume imager', end: '\\('
      },
      {
        beginKeywords: 'illuminate illuminance gather', end: '\\('
      }
    ]
  };
};

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    keywords: {
       keyword: 'BILL_PERIOD BILL_START BILL_STOP RS_EFFECTIVE_START RS_EFFECTIVE_STOP RS_JURIS_CODE RS_OPCO_CODE ' +
         'INTDADDATTRIBUTE|5 INTDADDVMSG|5 INTDBLOCKOP|5 INTDBLOCKOPNA|5 INTDCLOSE|5 INTDCOUNT|5 ' +
         'INTDCOUNTSTATUSCODE|5 INTDCREATEMASK|5 INTDCREATEDAYMASK|5 INTDCREATEFACTORMASK|5 ' +
         'INTDCREATEHANDLE|5 INTDCREATEOVERRIDEDAYMASK|5 INTDCREATEOVERRIDEMASK|5 ' +
         'INTDCREATESTATUSCODEMASK|5 INTDCREATETOUPERIOD|5 INTDDELETE|5 INTDDIPTEST|5 INTDEXPORT|5 ' +
         'INTDGETERRORCODE|5 INTDGETERRORMESSAGE|5 INTDISEQUAL|5 INTDJOIN|5 INTDLOAD|5 INTDLOADACTUALCUT|5 ' +
         'INTDLOADDATES|5 INTDLOADHIST|5 INTDLOADLIST|5 INTDLOADLISTDATES|5 INTDLOADLISTENERGY|5 ' +
         'INTDLOADLISTHIST|5 INTDLOADRELATEDCHANNEL|5 INTDLOADSP|5 INTDLOADSTAGING|5 INTDLOADUOM|5 ' +
         'INTDLOADUOMDATES|5 INTDLOADUOMHIST|5 INTDLOADVERSION|5 INTDOPEN|5 INTDREADFIRST|5 INTDREADNEXT|5 ' +
         'INTDRECCOUNT|5 INTDRELEASE|5 INTDREPLACE|5 INTDROLLAVG|5 INTDROLLPEAK|5 INTDSCALAROP|5 INTDSCALE|5 ' +
         'INTDSETATTRIBUTE|5 INTDSETDSTPARTICIPANT|5 INTDSETSTRING|5 INTDSETVALUE|5 INTDSETVALUESTATUS|5 ' +
         'INTDSHIFTSTARTTIME|5 INTDSMOOTH|5 INTDSORT|5 INTDSPIKETEST|5 INTDSUBSET|5 INTDTOU|5 ' +
         'INTDTOURELEASE|5 INTDTOUVALUE|5 INTDUPDATESTATS|5 INTDVALUE|5 STDEV INTDDELETEEX|5 ' +
         'INTDLOADEXACTUAL|5 INTDLOADEXCUT|5 INTDLOADEXDATES|5 INTDLOADEX|5 INTDLOADEXRELATEDCHANNEL|5 ' +
         'INTDSAVEEX|5 MVLOAD|5 MVLOADACCT|5 MVLOADACCTDATES|5 MVLOADACCTHIST|5 MVLOADDATES|5 MVLOADHIST|5 ' +
         'MVLOADLIST|5 MVLOADLISTDATES|5 MVLOADLISTHIST|5 IF FOR NEXT DONE SELECT END CALL ABORT CLEAR CHANNEL FACTOR LIST NUMBER ' +
         'OVERRIDE SET WEEK DISTRIBUTIONNODE ELSE WHEN THEN OTHERWISE IENUM CSV INCLUDE LEAVE RIDER SAVE DELETE ' +
         'NOVALUE SECTION WARN SAVE_UPDATE DETERMINANT LABEL REPORT REVENUE EACH ' +
         'IN FROM TOTAL CHARGE BLOCK AND OR CSV_FILE RATE_CODE AUXILIARY_DEMAND ' +
         'UIDACCOUNT RS BILL_PERIOD_SELECT HOURS_PER_MONTH INTD_ERROR_STOP SEASON_SCHEDULE_NAME ' +
         'ACCOUNTFACTOR ARRAYUPPERBOUND CALLSTOREDPROC GETADOCONNECTION GETCONNECT GETDATASOURCE ' +
         'GETQUALIFIER GETUSERID HASVALUE LISTCOUNT LISTOP LISTUPDATE LISTVALUE PRORATEFACTOR RSPRORATE ' +
         'SETBINPATH SETDBMONITOR WQ_OPEN BILLINGHOURS DATE DATEFROMFLOAT DATETIMEFROMSTRING ' +
         'DATETIMETOSTRING DATETOFLOAT DAY DAYDIFF DAYNAME DBDATETIME HOUR MINUTE MONTH MONTHDIFF ' +
         'MONTHHOURS MONTHNAME ROUNDDATE SAMEWEEKDAYLASTYEAR SECOND WEEKDAY WEEKDIFF YEAR YEARDAY ' +
         'YEARSTR COMPSUM HISTCOUNT HISTMAX HISTMIN HISTMINNZ HISTVALUE MAXNRANGE MAXRANGE MINRANGE ' +
         'COMPIKVA COMPKVA COMPKVARFROMKQKW COMPLF IDATTR FLAG LF2KW LF2KWH MAXKW POWERFACTOR ' +
         'READING2USAGE AVGSEASON MAXSEASON MONTHLYMERGE SEASONVALUE SUMSEASON ACCTREADDATES ' +
         'ACCTTABLELOAD CONFIGADD CONFIGGET CREATEOBJECT CREATEREPORT EMAILCLIENT EXPBLKMDMUSAGE ' +
         'EXPMDMUSAGE EXPORT_USAGE FACTORINEFFECT GETUSERSPECIFIEDSTOP INEFFECT ISHOLIDAY RUNRATE ' +
         'SAVE_PROFILE SETREPORTTITLE USEREXIT WATFORRUNRATE TO TABLE ACOS ASIN ATAN ATAN2 BITAND CEIL ' +
         'COS COSECANT COSH COTANGENT DIVQUOT DIVREM EXP FABS FLOOR FMOD FREPM FREXPN LOG LOG10 MAX MAXN ' +
         'MIN MINNZ MODF POW ROUND ROUND2VALUE ROUNDINT SECANT SIN SINH SQROOT TAN TANH FLOAT2STRING ' +
         'FLOAT2STRINGNC INSTR LEFT LEN LTRIM MID RIGHT RTRIM STRING STRINGNC TOLOWER TOUPPER TRIM ' +
         'NUMDAYS READ_DATE STAGING',
       built_in: 'IDENTIFIER OPTIONS XML_ELEMENT XML_OP XML_ELEMENT_OF DOMDOCCREATE DOMDOCLOADFILE DOMDOCLOADXML ' +
         'DOMDOCSAVEFILE DOMDOCGETROOT DOMDOCADDPI DOMNODEGETNAME DOMNODEGETTYPE DOMNODEGETVALUE DOMNODEGETCHILDCT ' +
         'DOMNODEGETFIRSTCHILD DOMNODEGETSIBLING DOMNODECREATECHILDELEMENT DOMNODESETATTRIBUTE ' +
         'DOMNODEGETCHILDELEMENTCT DOMNODEGETFIRSTCHILDELEMENT DOMNODEGETSIBLINGELEMENT DOMNODEGETATTRIBUTECT ' +
         'DOMNODEGETATTRIBUTEI DOMNODEGETATTRIBUTEBYNAME DOMNODEGETBYNAME'
    },
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.C_NUMBER_MODE,
      {
        className: 'literal',
        variants: [
          {begin: '#\\s+[a-zA-Z\\ \\.]*', relevance: 0}, // looks like #-comment
          {begin: '#[a-zA-Z\\ \\.]+'}
        ]
      }
    ]
  };
};

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var NUM_SUFFIX = '([ui](8|16|32|64|128|size)|f(32|64))\?';
  var KEYWORDS =
    'alignof as be box break const continue crate do else enum extern ' +
    'false fn for if impl in let loop match mod mut offsetof once priv ' +
    'proc pub pure ref return self Self sizeof static struct super trait true ' +
    'type typeof unsafe unsized use virtual while where yield move default';
  var BUILTINS =
    // functions
    'drop ' +
    // types
    'i8 i16 i32 i64 i128 isize ' +
    'u8 u16 u32 u64 u128 usize ' +
    'f32 f64 ' +
    'str char bool ' +
    'Box Option Result String Vec ' +
    // traits
    'Copy Send Sized Sync Drop Fn FnMut FnOnce ToOwned Clone Debug ' +
    'PartialEq PartialOrd Eq Ord AsRef AsMut Into From Default Iterator ' +
    'Extend IntoIterator DoubleEndedIterator ExactSizeIterator ' +
    'SliceConcatExt ToString ' +
    // macros
    'assert! assert_eq! bitflags! bytes! cfg! col! concat! concat_idents! ' +
    'debug_assert! debug_assert_eq! env! panic! file! format! format_args! ' +
    'include_bin! include_str! line! local_data_key! module_path! ' +
    'option_env! print! println! select! stringify! try! unimplemented! ' +
    'unreachable! vec! write! writeln! macro_rules! assert_ne! debug_assert_ne!';
  return {
    aliases: ['rs'],
    keywords: {
      keyword:
        KEYWORDS,
      literal:
        'true false Some None Ok Err',
      built_in:
        BUILTINS
    },
    lexemes: hljs.IDENT_RE + '!?',
    illegal: '</',
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.COMMENT('/\\*', '\\*/', {contains: ['self']}),
      hljs.inherit(hljs.QUOTE_STRING_MODE, {begin: /b?"/, illegal: null}),
      {
        className: 'string',
        variants: [
           { begin: /r(#*)"(.|\n)*?"\1(?!#)/ },
           { begin: /b?'\\?(x\w{2}|u\w{4}|U\w{8}|.)'/ }
        ]
      },
      {
        className: 'symbol',
        begin: /'[a-zA-Z_][a-zA-Z0-9_]*/
      },
      {
        className: 'number',
        variants: [
          { begin: '\\b0b([01_]+)' + NUM_SUFFIX },
          { begin: '\\b0o([0-7_]+)' + NUM_SUFFIX },
          { begin: '\\b0x([A-Fa-f0-9_]+)' + NUM_SUFFIX },
          { begin: '\\b(\\d[\\d_]*(\\.[0-9_]+)?([eE][+-]?[0-9_]+)?)' +
                   NUM_SUFFIX
          }
        ],
        relevance: 0
      },
      {
        className: 'function',
        beginKeywords: 'fn', end: '(\\(|<)', excludeEnd: true,
        contains: [hljs.UNDERSCORE_TITLE_MODE]
      },
      {
        className: 'meta',
        begin: '#\\!?\\[', end: '\\]',
        contains: [
          {
            className: 'meta-string',
            begin: /"/, end: /"/
          }
        ]
      },
      {
        className: 'class',
        beginKeywords: 'type', end: ';',
        contains: [
          hljs.inherit(hljs.UNDERSCORE_TITLE_MODE, {endsParent: true})
        ],
        illegal: '\\S'
      },
      {
        className: 'class',
        beginKeywords: 'trait enum struct union', end: '{',
        contains: [
          hljs.inherit(hljs.UNDERSCORE_TITLE_MODE, {endsParent: true})
        ],
        illegal: '[\\w\\d]'
      },
      {
        begin: hljs.IDENT_RE + '::',
        keywords: {built_in: BUILTINS}
      },
      {
        begin: '->'
      }
    ]
  };
};

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

module.exports = function(hljs) {

  var ANNOTATION = { className: 'meta', begin: '@[A-Za-z]+' };

  // used in strings for escaping/interpolation/substitution
  var SUBST = {
    className: 'subst',
    variants: [
      {begin: '\\$[A-Za-z0-9_]+'},
      {begin: '\\${', end: '}'}
    ]
  };

  var STRING = {
    className: 'string',
    variants: [
      {
        begin: '"', end: '"',
        illegal: '\\n',
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      {
        begin: '"""', end: '"""',
        relevance: 10
      },
      {
        begin: '[a-z]+"', end: '"',
        illegal: '\\n',
        contains: [hljs.BACKSLASH_ESCAPE, SUBST]
      },
      {
        className: 'string',
        begin: '[a-z]+"""', end: '"""',
        contains: [SUBST],
        relevance: 10
      }
    ]

  };

  var SYMBOL = {
    className: 'symbol',
    begin: '\'\\w[\\w\\d_]*(?!\')'
  };

  var TYPE = {
    className: 'type',
    begin: '\\b[A-Z][A-Za-z0-9_]*',
    relevance: 0
  };

  var NAME = {
    className: 'title',
    begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/,
    relevance: 0
  };

  var CLASS = {
    className: 'class',
    beginKeywords: 'class object trait type',
    end: /[:={\[\n;]/,
    excludeEnd: true,
    contains: [
      {
        beginKeywords: 'extends with',
        relevance: 10
      },
      {
        begin: /\[/,
        end: /\]/,
        excludeBegin: true,
        excludeEnd: true,
        relevance: 0,
        contains: [TYPE]
      },
      {
        className: 'params',
        begin: /\(/,
        end: /\)/,
        excludeBegin: true,
        excludeEnd: true,
        relevance: 0,
        contains: [TYPE]
      },
      NAME
    ]
  };

  var METHOD = {
    className: 'function',
    beginKeywords: 'def',
    end: /[:={\[(\n;]/,
    excludeEnd: true,
    contains: [NAME]
  };

  return {
    keywords: {
      literal: 'true false null',
      keyword: 'type yield lazy override def with val var sealed abstract private trait object if forSome for while throw finally protected extends import final return else break new catch super class case package default try this match continue throws implicit'
    },
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      STRING,
      SYMBOL,
      TYPE,
      METHOD,
      CLASS,
      hljs.C_NUMBER_MODE,
      ANNOTATION
    ]
  };
};

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var SCHEME_IDENT_RE = '[^\\(\\)\\[\\]\\{\\}",\'`;#|\\\\\\s]+';
  var SCHEME_SIMPLE_NUMBER_RE = '(\\-|\\+)?\\d+([./]\\d+)?';
  var SCHEME_COMPLEX_NUMBER_RE = SCHEME_SIMPLE_NUMBER_RE + '[+\\-]' + SCHEME_SIMPLE_NUMBER_RE + 'i';
  var BUILTINS = {
    'builtin-name':
      'case-lambda call/cc class define-class exit-handler field import ' +
      'inherit init-field interface let*-values let-values let/ec mixin ' +
      'opt-lambda override protect provide public rename require ' +
      'require-for-syntax syntax syntax-case syntax-error unit/sig unless ' +
      'when with-syntax and begin call-with-current-continuation ' +
      'call-with-input-file call-with-output-file case cond define ' +
      'define-syntax delay do dynamic-wind else for-each if lambda let let* ' +
      'let-syntax letrec letrec-syntax map or syntax-rules \' * + , ,@ - ... / ' +
      '; < <= = => > >= ` abs acos angle append apply asin assoc assq assv atan ' +
      'boolean? caar cadr call-with-input-file call-with-output-file ' +
      'call-with-values car cdddar cddddr cdr ceiling char->integer ' +
      'char-alphabetic? char-ci<=? char-ci<? char-ci=? char-ci>=? char-ci>? ' +
      'char-downcase char-lower-case? char-numeric? char-ready? char-upcase ' +
      'char-upper-case? char-whitespace? char<=? char<? char=? char>=? char>? ' +
      'char? close-input-port close-output-port complex? cons cos ' +
      'current-input-port current-output-port denominator display eof-object? ' +
      'eq? equal? eqv? eval even? exact->inexact exact? exp expt floor ' +
      'force gcd imag-part inexact->exact inexact? input-port? integer->char ' +
      'integer? interaction-environment lcm length list list->string ' +
      'list->vector list-ref list-tail list? load log magnitude make-polar ' +
      'make-rectangular make-string make-vector max member memq memv min ' +
      'modulo negative? newline not null-environment null? number->string ' +
      'number? numerator odd? open-input-file open-output-file output-port? ' +
      'pair? peek-char port? positive? procedure? quasiquote quote quotient ' +
      'rational? rationalize read read-char real-part real? remainder reverse ' +
      'round scheme-report-environment set! set-car! set-cdr! sin sqrt string ' +
      'string->list string->number string->symbol string-append string-ci<=? ' +
      'string-ci<? string-ci=? string-ci>=? string-ci>? string-copy ' +
      'string-fill! string-length string-ref string-set! string<=? string<? ' +
      'string=? string>=? string>? string? substring symbol->string symbol? ' +
      'tan transcript-off transcript-on truncate values vector ' +
      'vector->list vector-fill! vector-length vector-ref vector-set! ' +
      'with-input-from-file with-output-to-file write write-char zero?'
  };

  var SHEBANG = {
    className: 'meta',
    begin: '^#!',
    end: '$'
  };

  var LITERAL = {
    className: 'literal',
    begin: '(#t|#f|#\\\\' + SCHEME_IDENT_RE + '|#\\\\.)'
  };

  var NUMBER = {
    className: 'number',
    variants: [
      { begin: SCHEME_SIMPLE_NUMBER_RE, relevance: 0 },
      { begin: SCHEME_COMPLEX_NUMBER_RE, relevance: 0 },
      { begin: '#b[0-1]+(/[0-1]+)?' },
      { begin: '#o[0-7]+(/[0-7]+)?' },
      { begin: '#x[0-9a-f]+(/[0-9a-f]+)?' }
    ]
  };

  var STRING = hljs.QUOTE_STRING_MODE;

  var REGULAR_EXPRESSION = {
    className: 'regexp',
    begin: '#[pr]x"',
    end: '[^\\\\]"'
  };

  var COMMENT_MODES = [
    hljs.COMMENT(
      ';',
      '$',
      {
        relevance: 0
      }
    ),
    hljs.COMMENT('#\\|', '\\|#')
  ];

  var IDENT = {
    begin: SCHEME_IDENT_RE,
    relevance: 0
  };

  var QUOTED_IDENT = {
    className: 'symbol',
    begin: '\'' + SCHEME_IDENT_RE
  };

  var BODY = {
    endsWithParent: true,
    relevance: 0
  };

  var QUOTED_LIST = {
    variants: [
      { begin: /'/ },
      { begin: '`' }
    ],
    contains: [
      {
        begin: '\\(', end: '\\)',
        contains: ['self', LITERAL, STRING, NUMBER, IDENT, QUOTED_IDENT]
      }
    ]
  };

  var NAME = {
    className: 'name',
    begin: SCHEME_IDENT_RE,
    lexemes: SCHEME_IDENT_RE,
    keywords: BUILTINS
  };

  var LAMBDA = {
    begin: /lambda/, endsWithParent: true, returnBegin: true,
    contains: [
      NAME,
      {
        begin: /\(/, end: /\)/, endsParent: true,
        contains: [IDENT],
      }
    ]
  };

  var LIST = {
    variants: [
      { begin: '\\(', end: '\\)' },
      { begin: '\\[', end: '\\]' }
    ],
    contains: [LAMBDA, NAME, BODY]
  };

  BODY.contains = [LITERAL, NUMBER, STRING, IDENT, QUOTED_IDENT, QUOTED_LIST, LIST].concat(COMMENT_MODES);

  return {
    illegal: /\S/,
    contains: [SHEBANG, NUMBER, STRING, QUOTED_IDENT, QUOTED_LIST, LIST].concat(COMMENT_MODES)
  };
};

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

module.exports = function(hljs) {

  var COMMON_CONTAINS = [
    hljs.C_NUMBER_MODE,
    {
      className: 'string',
      begin: '\'|\"', end: '\'|\"',
      contains: [hljs.BACKSLASH_ESCAPE, {begin: '\'\''}]
    }
  ];

  return {
    aliases: ['sci'],
    lexemes: /%?\w+/,
    keywords: {
      keyword: 'abort break case clear catch continue do elseif else endfunction end for function '+
        'global if pause return resume select try then while',
      literal:
        '%f %F %t %T %pi %eps %inf %nan %e %i %z %s',
      built_in: // Scilab has more than 2000 functions. Just list the most commons
       'abs and acos asin atan ceil cd chdir clearglobal cosh cos cumprod deff disp error '+
       'exec execstr exists exp eye gettext floor fprintf fread fsolve imag isdef isempty '+
       'isinfisnan isvector lasterror length load linspace list listfiles log10 log2 log '+
       'max min msprintf mclose mopen ones or pathconvert poly printf prod pwd rand real '+
       'round sinh sin size gsort sprintf sqrt strcat strcmps tring sum system tanh tan '+
       'type typename warning zeros matrix'
    },
    illegal: '("|#|/\\*|\\s+/\\w+)',
    contains: [
      {
        className: 'function',
        beginKeywords: 'function', end: '$',
        contains: [
          hljs.UNDERSCORE_TITLE_MODE,
          {
            className: 'params',
            begin: '\\(', end: '\\)'
          }
        ]
      },
      {
        begin: '[a-zA-Z_][a-zA-Z_0-9]*(\'+[\\.\']*|[\\.\']+)', end: '',
        relevance: 0
      },
      {
        begin: '\\[', end: '\\]\'*[\\.\']*',
        relevance: 0,
        contains: COMMON_CONTAINS
      },
      hljs.COMMENT('//', '$')
    ].concat(COMMON_CONTAINS)
  };
};

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var IDENT_RE = '[a-zA-Z-][a-zA-Z0-9_-]*';
  var VARIABLE = {
    className: 'variable',
    begin: '(\\$' + IDENT_RE + ')\\b'
  };
  var HEXCOLOR = {
    className: 'number', begin: '#[0-9A-Fa-f]+'
  };
  var DEF_INTERNALS = {
    className: 'attribute',
    begin: '[A-Z\\_\\.\\-]+', end: ':',
    excludeEnd: true,
    illegal: '[^\\s]',
    starts: {
      endsWithParent: true, excludeEnd: true,
      contains: [
        HEXCOLOR,
        hljs.CSS_NUMBER_MODE,
        hljs.QUOTE_STRING_MODE,
        hljs.APOS_STRING_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        {
          className: 'meta', begin: '!important'
        }
      ]
    }
  };
  return {
    case_insensitive: true,
    illegal: '[=/|\']',
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'selector-id', begin: '\\#[A-Za-z0-9_-]+',
        relevance: 0
      },
      {
        className: 'selector-class', begin: '\\.[A-Za-z0-9_-]+',
        relevance: 0
      },
      {
        className: 'selector-attr', begin: '\\[', end: '\\]',
        illegal: '$'
      },
      {
        className: 'selector-tag', // begin: IDENT_RE, end: '[,|\\s]'
        begin: '\\b(a|abbr|acronym|address|area|article|aside|audio|b|base|big|blockquote|body|br|button|canvas|caption|cite|code|col|colgroup|command|datalist|dd|del|details|dfn|div|dl|dt|em|embed|fieldset|figcaption|figure|footer|form|frame|frameset|(h[1-6])|head|header|hgroup|hr|html|i|iframe|img|input|ins|kbd|keygen|label|legend|li|link|map|mark|meta|meter|nav|noframes|noscript|object|ol|optgroup|option|output|p|param|pre|progress|q|rp|rt|ruby|samp|script|section|select|small|span|strike|strong|style|sub|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|tt|ul|var|video)\\b',
        relevance: 0
      },
      {
        begin: ':(visited|valid|root|right|required|read-write|read-only|out-range|optional|only-of-type|only-child|nth-of-type|nth-last-of-type|nth-last-child|nth-child|not|link|left|last-of-type|last-child|lang|invalid|indeterminate|in-range|hover|focus|first-of-type|first-line|first-letter|first-child|first|enabled|empty|disabled|default|checked|before|after|active)'
      },
      {
        begin: '::(after|before|choices|first-letter|first-line|repeat-index|repeat-item|selection|value)'
      },
      VARIABLE,
      {
        className: 'attribute',
        begin: '\\b(z-index|word-wrap|word-spacing|word-break|width|widows|white-space|visibility|vertical-align|unicode-bidi|transition-timing-function|transition-property|transition-duration|transition-delay|transition|transform-style|transform-origin|transform|top|text-underline-position|text-transform|text-shadow|text-rendering|text-overflow|text-indent|text-decoration-style|text-decoration-line|text-decoration-color|text-decoration|text-align-last|text-align|tab-size|table-layout|right|resize|quotes|position|pointer-events|perspective-origin|perspective|page-break-inside|page-break-before|page-break-after|padding-top|padding-right|padding-left|padding-bottom|padding|overflow-y|overflow-x|overflow-wrap|overflow|outline-width|outline-style|outline-offset|outline-color|outline|orphans|order|opacity|object-position|object-fit|normal|none|nav-up|nav-right|nav-left|nav-index|nav-down|min-width|min-height|max-width|max-height|mask|marks|margin-top|margin-right|margin-left|margin-bottom|margin|list-style-type|list-style-position|list-style-image|list-style|line-height|letter-spacing|left|justify-content|initial|inherit|ime-mode|image-orientation|image-resolution|image-rendering|icon|hyphens|height|font-weight|font-variant-ligatures|font-variant|font-style|font-stretch|font-size-adjust|font-size|font-language-override|font-kerning|font-feature-settings|font-family|font|float|flex-wrap|flex-shrink|flex-grow|flex-flow|flex-direction|flex-basis|flex|filter|empty-cells|display|direction|cursor|counter-reset|counter-increment|content|column-width|column-span|column-rule-width|column-rule-style|column-rule-color|column-rule|column-gap|column-fill|column-count|columns|color|clip-path|clip|clear|caption-side|break-inside|break-before|break-after|box-sizing|box-shadow|box-decoration-break|bottom|border-width|border-top-width|border-top-style|border-top-right-radius|border-top-left-radius|border-top-color|border-top|border-style|border-spacing|border-right-width|border-right-style|border-right-color|border-right|border-radius|border-left-width|border-left-style|border-left-color|border-left|border-image-width|border-image-source|border-image-slice|border-image-repeat|border-image-outset|border-image|border-color|border-collapse|border-bottom-width|border-bottom-style|border-bottom-right-radius|border-bottom-left-radius|border-bottom-color|border-bottom|border|background-size|background-repeat|background-position|background-origin|background-image|background-color|background-clip|background-attachment|background-blend-mode|background|backface-visibility|auto|animation-timing-function|animation-play-state|animation-name|animation-iteration-count|animation-fill-mode|animation-duration|animation-direction|animation-delay|animation|align-self|align-items|align-content)\\b',
        illegal: '[^\\s]'
      },
      {
        begin: '\\b(whitespace|wait|w-resize|visible|vertical-text|vertical-ideographic|uppercase|upper-roman|upper-alpha|underline|transparent|top|thin|thick|text|text-top|text-bottom|tb-rl|table-header-group|table-footer-group|sw-resize|super|strict|static|square|solid|small-caps|separate|se-resize|scroll|s-resize|rtl|row-resize|ridge|right|repeat|repeat-y|repeat-x|relative|progress|pointer|overline|outside|outset|oblique|nowrap|not-allowed|normal|none|nw-resize|no-repeat|no-drop|newspaper|ne-resize|n-resize|move|middle|medium|ltr|lr-tb|lowercase|lower-roman|lower-alpha|loose|list-item|line|line-through|line-edge|lighter|left|keep-all|justify|italic|inter-word|inter-ideograph|inside|inset|inline|inline-block|inherit|inactive|ideograph-space|ideograph-parenthesis|ideograph-numeric|ideograph-alpha|horizontal|hidden|help|hand|groove|fixed|ellipsis|e-resize|double|dotted|distribute|distribute-space|distribute-letter|distribute-all-lines|disc|disabled|default|decimal|dashed|crosshair|collapse|col-resize|circle|char|center|capitalize|break-word|break-all|bottom|both|bolder|bold|block|bidi-override|below|baseline|auto|always|all-scroll|absolute|table|table-cell)\\b'
      },
      {
        begin: ':', end: ';',
        contains: [
          VARIABLE,
          HEXCOLOR,
          hljs.CSS_NUMBER_MODE,
          hljs.QUOTE_STRING_MODE,
          hljs.APOS_STRING_MODE,
          {
            className: 'meta', begin: '!important'
          }
        ]
      },
      {
        begin: '@', end: '[{;]',
        keywords: 'mixin include extend for if else each while charset import debug media page content font-face namespace warn',
        contains: [
          VARIABLE,
          hljs.QUOTE_STRING_MODE,
          hljs.APOS_STRING_MODE,
          HEXCOLOR,
          hljs.CSS_NUMBER_MODE,
          {
            begin: '\\s[A-Za-z0-9_.-]+',
            relevance: 0
          }
        ]
      }
    ]
  };
};

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    aliases: ['console'],
    contains: [
      {
        className: 'meta',
        begin: '^\\s{0,3}[\\w\\d\\[\\]()@-]*[>%$#]',
        starts: {
          end: '$', subLanguage: 'bash'
        }
      },
    ]
  }
};

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var smali_instr_low_prio = ['add', 'and', 'cmp', 'cmpg', 'cmpl', 'const', 'div', 'double', 'float', 'goto', 'if', 'int', 'long', 'move', 'mul', 'neg', 'new', 'nop', 'not', 'or', 'rem', 'return', 'shl', 'shr', 'sput', 'sub', 'throw', 'ushr', 'xor'];
  var smali_instr_high_prio = ['aget', 'aput', 'array', 'check', 'execute', 'fill', 'filled', 'goto/16', 'goto/32', 'iget', 'instance', 'invoke', 'iput', 'monitor', 'packed', 'sget', 'sparse'];
  var smali_keywords = ['transient', 'constructor', 'abstract', 'final', 'synthetic', 'public', 'private', 'protected', 'static', 'bridge', 'system'];
  return {
    aliases: ['smali'],
    contains: [
      {
        className: 'string',
        begin: '"', end: '"',
        relevance: 0
      },
      hljs.COMMENT(
        '#',
        '$',
        {
          relevance: 0
        }
      ),
      {
        className: 'keyword',
        variants: [
          {begin: '\\s*\\.end\\s[a-zA-Z0-9]*'},
          {begin: '^[ ]*\\.[a-zA-Z]*', relevance: 0},
          {begin: '\\s:[a-zA-Z_0-9]*', relevance: 0},
          {begin: '\\s(' + smali_keywords.join('|') + ')'}
        ]
      },
      {
        className: 'built_in',
        variants : [
          {
            begin: '\\s('+smali_instr_low_prio.join('|')+')\\s'
          },
          {
            begin: '\\s('+smali_instr_low_prio.join('|')+')((\\-|/)[a-zA-Z0-9]+)+\\s',
            relevance: 10
          },
          {
            begin: '\\s('+smali_instr_high_prio.join('|')+')((\\-|/)[a-zA-Z0-9]+)*\\s',
            relevance: 10
          },
        ]
      },
      {
        className: 'class',
        begin: 'L[^\(;:\n]*;',
        relevance: 0
      },
      {
        begin: '[vp][0-9]+',
      }
    ]
  };
};

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var VAR_IDENT_RE = '[a-z][a-zA-Z0-9_]*';
  var CHAR = {
    className: 'string',
    begin: '\\$.{1}'
  };
  var SYMBOL = {
    className: 'symbol',
    begin: '#' + hljs.UNDERSCORE_IDENT_RE
  };
  return {
    aliases: ['st'],
    keywords: 'self super nil true false thisContext', // only 6
    contains: [
      hljs.COMMENT('"', '"'),
      hljs.APOS_STRING_MODE,
      {
        className: 'type',
        begin: '\\b[A-Z][A-Za-z0-9_]*',
        relevance: 0
      },
      {
        begin: VAR_IDENT_RE + ':',
        relevance: 0
      },
      hljs.C_NUMBER_MODE,
      SYMBOL,
      CHAR,
      {
        // This looks more complicated than needed to avoid combinatorial
        // explosion under V8. It effectively means `| var1 var2 ... |` with
        // whitespace adjacent to `|` being optional.
        begin: '\\|[ ]*' + VAR_IDENT_RE + '([ ]+' + VAR_IDENT_RE + ')*[ ]*\\|',
        returnBegin: true, end: /\|/,
        illegal: /\S/,
        contains: [{begin: '(\\|[ ]*)?' + VAR_IDENT_RE}]
      },
      {
        begin: '\\#\\(', end: '\\)',
        contains: [
          hljs.APOS_STRING_MODE,
          CHAR,
          hljs.C_NUMBER_MODE,
          SYMBOL
        ]
      }
    ]
  };
};

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    aliases: ['ml'],
    keywords: {
      keyword:
        /* according to Definition of Standard ML 97  */
        'abstype and andalso as case datatype do else end eqtype ' +
        'exception fn fun functor handle if in include infix infixr ' +
        'let local nonfix of op open orelse raise rec sharing sig ' +
        'signature struct structure then type val with withtype where while',
      built_in:
        /* built-in types according to basis library */
        'array bool char exn int list option order real ref string substring vector unit word',
      literal:
        'true false NONE SOME LESS EQUAL GREATER nil'
    },
    illegal: /\/\/|>>/,
    lexemes: '[a-z_]\\w*!?',
    contains: [
      {
        className: 'literal',
        begin: /\[(\|\|)?\]|\(\)/,
        relevance: 0
      },
      hljs.COMMENT(
        '\\(\\*',
        '\\*\\)',
        {
          contains: ['self']
        }
      ),
      { /* type variable */
        className: 'symbol',
        begin: '\'[A-Za-z_](?!\')[\\w\']*'
        /* the grammar is ambiguous on how 'a'b should be interpreted but not the compiler */
      },
      { /* polymorphic variant */
        className: 'type',
        begin: '`[A-Z][\\w\']*'
      },
      { /* module or constructor */
        className: 'type',
        begin: '\\b[A-Z][\\w\']*',
        relevance: 0
      },
      { /* don't color identifiers, but safely catch all identifiers with '*/
        begin: '[a-z_]\\w*\'[\\w\']*'
      },
      hljs.inherit(hljs.APOS_STRING_MODE, {className: 'string', relevance: 0}),
      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
      {
        className: 'number',
        begin:
          '\\b(0[xX][a-fA-F0-9_]+[Lln]?|' +
          '0[oO][0-7_]+[Lln]?|' +
          '0[bB][01_]+[Lln]?|' +
          '[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)',
        relevance: 0
      },
      {
        begin: /[-=]>/ // relevance booster
      }
    ]
  };
};

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var CPP = hljs.getLanguage('cpp').exports;

  // In SQF, a variable start with _
  var VARIABLE = {
    className: 'variable',
    begin: /\b_+[a-zA-Z_]\w*/
  };

  // In SQF, a function should fit myTag_fnc_myFunction pattern
  // https://community.bistudio.com/wiki/Functions_Library_(Arma_3)#Adding_a_Function
  var FUNCTION = {
    className: 'title',
    begin: /[a-zA-Z][a-zA-Z0-9]+_fnc_\w*/
  };

  // In SQF strings, quotes matching the start are escaped by adding a consecutive.
  // Example of single escaped quotes: " "" " and  ' '' '.
  var STRINGS = {
    className: 'string',
    variants: [
      {
        begin: '"',
        end: '"',
        contains: [{begin: '""', relevance: 0}]
      },
      {
        begin: '\'',
        end: '\'',
        contains: [{begin: '\'\'', relevance: 0}]
      }
    ]
  };

  return {
    aliases: ['sqf'],
    case_insensitive: true,
    keywords: {
      keyword:
        'case catch default do else exit exitWith for forEach from if ' +
        'switch then throw to try waitUntil while with',
      built_in:
        'abs accTime acos action actionIDs actionKeys actionKeysImages actionKeysNames ' +
        'actionKeysNamesArray actionName actionParams activateAddons activatedAddons activateKey ' +
        'add3DENConnection add3DENEventHandler add3DENLayer addAction addBackpack addBackpackCargo ' +
        'addBackpackCargoGlobal addBackpackGlobal addCamShake addCuratorAddons addCuratorCameraArea ' +
        'addCuratorEditableObjects addCuratorEditingArea addCuratorPoints addEditorObject addEventHandler ' +
        'addGoggles addGroupIcon addHandgunItem addHeadgear addItem addItemCargo addItemCargoGlobal ' +
        'addItemPool addItemToBackpack addItemToUniform addItemToVest addLiveStats addMagazine ' +
        'addMagazineAmmoCargo addMagazineCargo addMagazineCargoGlobal addMagazineGlobal addMagazinePool ' +
        'addMagazines addMagazineTurret addMenu addMenuItem addMissionEventHandler addMPEventHandler ' +
        'addMusicEventHandler addOwnedMine addPlayerScores addPrimaryWeaponItem ' +
        'addPublicVariableEventHandler addRating addResources addScore addScoreSide addSecondaryWeaponItem ' +
        'addSwitchableUnit addTeamMember addToRemainsCollector addUniform addVehicle addVest addWaypoint ' +
        'addWeapon addWeaponCargo addWeaponCargoGlobal addWeaponGlobal addWeaponItem addWeaponPool ' +
        'addWeaponTurret agent agents AGLToASL aimedAtTarget aimPos airDensityRTD airportSide ' +
        'AISFinishHeal alive all3DENEntities allControls allCurators allCutLayers allDead allDeadMen ' +
        'allDisplays allGroups allMapMarkers allMines allMissionObjects allow3DMode allowCrewInImmobile ' +
        'allowCuratorLogicIgnoreAreas allowDamage allowDammage allowFileOperations allowFleeing allowGetIn ' +
        'allowSprint allPlayers allSites allTurrets allUnits allUnitsUAV allVariables ammo and animate ' +
        'animateDoor animateSource animationNames animationPhase animationSourcePhase animationState ' +
        'append apply armoryPoints arrayIntersect asin ASLToAGL ASLToATL assert assignAsCargo ' +
        'assignAsCargoIndex assignAsCommander assignAsDriver assignAsGunner assignAsTurret assignCurator ' +
        'assignedCargo assignedCommander assignedDriver assignedGunner assignedItems assignedTarget ' +
        'assignedTeam assignedVehicle assignedVehicleRole assignItem assignTeam assignToAirport atan atan2 ' +
        'atg ATLToASL attachedObject attachedObjects attachedTo attachObject attachTo attackEnabled ' +
        'backpack backpackCargo backpackContainer backpackItems backpackMagazines backpackSpaceFor ' +
        'behaviour benchmark binocular blufor boundingBox boundingBoxReal boundingCenter breakOut breakTo ' +
        'briefingName buildingExit buildingPos buttonAction buttonSetAction cadetMode call callExtension ' +
        'camCommand camCommit camCommitPrepared camCommitted camConstuctionSetParams camCreate camDestroy ' +
        'cameraEffect cameraEffectEnableHUD cameraInterest cameraOn cameraView campaignConfigFile ' +
        'camPreload camPreloaded camPrepareBank camPrepareDir camPrepareDive camPrepareFocus camPrepareFov ' +
        'camPrepareFovRange camPreparePos camPrepareRelPos camPrepareTarget camSetBank camSetDir ' +
        'camSetDive camSetFocus camSetFov camSetFovRange camSetPos camSetRelPos camSetTarget camTarget ' +
        'camUseNVG canAdd canAddItemToBackpack canAddItemToUniform canAddItemToVest ' +
        'cancelSimpleTaskDestination canFire canMove canSlingLoad canStand canSuspend canUnloadInCombat ' +
        'canVehicleCargo captive captiveNum cbChecked cbSetChecked ceil channelEnabled cheatsEnabled ' +
        'checkAIFeature checkVisibility civilian className clearAllItemsFromBackpack clearBackpackCargo ' +
        'clearBackpackCargoGlobal clearGroupIcons clearItemCargo clearItemCargoGlobal clearItemPool ' +
        'clearMagazineCargo clearMagazineCargoGlobal clearMagazinePool clearOverlay clearRadio ' +
        'clearWeaponCargo clearWeaponCargoGlobal clearWeaponPool clientOwner closeDialog closeDisplay ' +
        'closeOverlay collapseObjectTree collect3DENHistory combatMode commandArtilleryFire commandChat ' +
        'commander commandFire commandFollow commandFSM commandGetOut commandingMenu commandMove ' +
        'commandRadio commandStop commandSuppressiveFire commandTarget commandWatch comment commitOverlay ' +
        'compile compileFinal completedFSM composeText configClasses configFile configHierarchy configName ' +
        'configNull configProperties configSourceAddonList configSourceMod configSourceModList ' +
        'connectTerminalToUAV controlNull controlsGroupCtrl copyFromClipboard copyToClipboard ' +
        'copyWaypoints cos count countEnemy countFriendly countSide countType countUnknown ' +
        'create3DENComposition create3DENEntity createAgent createCenter createDialog createDiaryLink ' +
        'createDiaryRecord createDiarySubject createDisplay createGearDialog createGroup ' +
        'createGuardedPoint createLocation createMarker createMarkerLocal createMenu createMine ' +
        'createMissionDisplay createMPCampaignDisplay createSimpleObject createSimpleTask createSite ' +
        'createSoundSource createTask createTeam createTrigger createUnit createVehicle createVehicleCrew ' +
        'createVehicleLocal crew ctrlActivate ctrlAddEventHandler ctrlAngle ctrlAutoScrollDelay ' +
        'ctrlAutoScrollRewind ctrlAutoScrollSpeed ctrlChecked ctrlClassName ctrlCommit ctrlCommitted ' +
        'ctrlCreate ctrlDelete ctrlEnable ctrlEnabled ctrlFade ctrlHTMLLoaded ctrlIDC ctrlIDD ' +
        'ctrlMapAnimAdd ctrlMapAnimClear ctrlMapAnimCommit ctrlMapAnimDone ctrlMapCursor ctrlMapMouseOver ' +
        'ctrlMapScale ctrlMapScreenToWorld ctrlMapWorldToScreen ctrlModel ctrlModelDirAndUp ctrlModelScale ' +
        'ctrlParent ctrlParentControlsGroup ctrlPosition ctrlRemoveAllEventHandlers ctrlRemoveEventHandler ' +
        'ctrlScale ctrlSetActiveColor ctrlSetAngle ctrlSetAutoScrollDelay ctrlSetAutoScrollRewind ' +
        'ctrlSetAutoScrollSpeed ctrlSetBackgroundColor ctrlSetChecked ctrlSetEventHandler ctrlSetFade ' +
        'ctrlSetFocus ctrlSetFont ctrlSetFontH1 ctrlSetFontH1B ctrlSetFontH2 ctrlSetFontH2B ctrlSetFontH3 ' +
        'ctrlSetFontH3B ctrlSetFontH4 ctrlSetFontH4B ctrlSetFontH5 ctrlSetFontH5B ctrlSetFontH6 ' +
        'ctrlSetFontH6B ctrlSetFontHeight ctrlSetFontHeightH1 ctrlSetFontHeightH2 ctrlSetFontHeightH3 ' +
        'ctrlSetFontHeightH4 ctrlSetFontHeightH5 ctrlSetFontHeightH6 ctrlSetFontHeightSecondary ' +
        'ctrlSetFontP ctrlSetFontPB ctrlSetFontSecondary ctrlSetForegroundColor ctrlSetModel ' +
        'ctrlSetModelDirAndUp ctrlSetModelScale ctrlSetPosition ctrlSetScale ctrlSetStructuredText ' +
        'ctrlSetText ctrlSetTextColor ctrlSetTooltip ctrlSetTooltipColorBox ctrlSetTooltipColorShade ' +
        'ctrlSetTooltipColorText ctrlShow ctrlShown ctrlText ctrlTextHeight ctrlType ctrlVisible ' +
        'curatorAddons curatorCamera curatorCameraArea curatorCameraAreaCeiling curatorCoef ' +
        'curatorEditableObjects curatorEditingArea curatorEditingAreaType curatorMouseOver curatorPoints ' +
        'curatorRegisteredObjects curatorSelected curatorWaypointCost current3DENOperation currentChannel ' +
        'currentCommand currentMagazine currentMagazineDetail currentMagazineDetailTurret ' +
        'currentMagazineTurret currentMuzzle currentNamespace currentTask currentTasks currentThrowable ' +
        'currentVisionMode currentWaypoint currentWeapon currentWeaponMode currentWeaponTurret ' +
        'currentZeroing cursorObject cursorTarget customChat customRadio cutFadeOut cutObj cutRsc cutText ' +
        'damage date dateToNumber daytime deActivateKey debriefingText debugFSM debugLog deg ' +
        'delete3DENEntities deleteAt deleteCenter deleteCollection deleteEditorObject deleteGroup ' +
        'deleteIdentity deleteLocation deleteMarker deleteMarkerLocal deleteRange deleteResources ' +
        'deleteSite deleteStatus deleteTeam deleteVehicle deleteVehicleCrew deleteWaypoint detach ' +
        'detectedMines diag_activeMissionFSMs diag_activeScripts diag_activeSQFScripts ' +
        'diag_activeSQSScripts diag_captureFrame diag_captureSlowFrame diag_codePerformance diag_drawMode ' +
        'diag_enable diag_enabled diag_fps diag_fpsMin diag_frameNo diag_list diag_log diag_logSlowFrame ' +
        'diag_mergeConfigFile diag_recordTurretLimits diag_tickTime diag_toggle dialog diarySubjectExists ' +
        'didJIP didJIPOwner difficulty difficultyEnabled difficultyEnabledRTD difficultyOption direction ' +
        'directSay disableAI disableCollisionWith disableConversation disableDebriefingStats ' +
        'disableNVGEquipment disableRemoteSensors disableSerialization disableTIEquipment ' +
        'disableUAVConnectability disableUserInput displayAddEventHandler displayCtrl displayNull ' +
        'displayParent displayRemoveAllEventHandlers displayRemoveEventHandler displaySetEventHandler ' +
        'dissolveTeam distance distance2D distanceSqr distributionRegion do3DENAction doArtilleryFire ' +
        'doFire doFollow doFSM doGetOut doMove doorPhase doStop doSuppressiveFire doTarget doWatch ' +
        'drawArrow drawEllipse drawIcon drawIcon3D drawLine drawLine3D drawLink drawLocation drawPolygon ' +
        'drawRectangle driver drop east echo edit3DENMissionAttributes editObject editorSetEventHandler ' +
        'effectiveCommander emptyPositions enableAI enableAIFeature enableAimPrecision enableAttack ' +
        'enableAudioFeature enableCamShake enableCaustics enableChannel enableCollisionWith enableCopilot ' +
        'enableDebriefingStats enableDiagLegend enableEndDialog enableEngineArtillery enableEnvironment ' +
        'enableFatigue enableGunLights enableIRLasers enableMimics enablePersonTurret enableRadio ' +
        'enableReload enableRopeAttach enableSatNormalOnDetail enableSaving enableSentences ' +
        'enableSimulation enableSimulationGlobal enableStamina enableTeamSwitch enableUAVConnectability ' +
        'enableUAVWaypoints enableVehicleCargo endLoadingScreen endMission engineOn enginesIsOnRTD ' +
        'enginesRpmRTD enginesTorqueRTD entities estimatedEndServerTime estimatedTimeLeft ' +
        'evalObjectArgument everyBackpack everyContainer exec execEditorScript execFSM execVM exp ' +
        'expectedDestination exportJIPMessages eyeDirection eyePos face faction fadeMusic fadeRadio ' +
        'fadeSound fadeSpeech failMission fillWeaponsFromPool find findCover findDisplay findEditorObject ' +
        'findEmptyPosition findEmptyPositionReady findNearestEnemy finishMissionInit finite fire ' +
        'fireAtTarget firstBackpack flag flagOwner flagSide flagTexture fleeing floor flyInHeight ' +
        'flyInHeightASL fog fogForecast fogParams forceAddUniform forcedMap forceEnd forceMap forceRespawn ' +
        'forceSpeed forceWalk forceWeaponFire forceWeatherChange forEachMember forEachMemberAgent ' +
        'forEachMemberTeam format formation formationDirection formationLeader formationMembers ' +
        'formationPosition formationTask formatText formLeader freeLook fromEditor fuel fullCrew ' +
        'gearIDCAmmoCount gearSlotAmmoCount gearSlotData get3DENActionState get3DENAttribute get3DENCamera ' +
        'get3DENConnections get3DENEntity get3DENEntityID get3DENGrid get3DENIconsVisible ' +
        'get3DENLayerEntities get3DENLinesVisible get3DENMissionAttribute get3DENMouseOver get3DENSelected ' +
        'getAimingCoef getAllHitPointsDamage getAllOwnedMines getAmmoCargo getAnimAimPrecision ' +
        'getAnimSpeedCoef getArray getArtilleryAmmo getArtilleryComputerSettings getArtilleryETA ' +
        'getAssignedCuratorLogic getAssignedCuratorUnit getBackpackCargo getBleedingRemaining ' +
        'getBurningValue getCameraViewDirection getCargoIndex getCenterOfMass getClientState ' +
        'getClientStateNumber getConnectedUAV getCustomAimingCoef getDammage getDescription getDir ' +
        'getDirVisual getDLCs getEditorCamera getEditorMode getEditorObjectScope getElevationOffset ' +
        'getFatigue getFriend getFSMVariable getFuelCargo getGroupIcon getGroupIconParams getGroupIcons ' +
        'getHideFrom getHit getHitIndex getHitPointDamage getItemCargo getMagazineCargo getMarkerColor ' +
        'getMarkerPos getMarkerSize getMarkerType getMass getMissionConfig getMissionConfigValue ' +
        'getMissionDLCs getMissionLayerEntities getModelInfo getMousePosition getNumber getObjectArgument ' +
        'getObjectChildren getObjectDLC getObjectMaterials getObjectProxy getObjectTextures getObjectType ' +
        'getObjectViewDistance getOxygenRemaining getPersonUsedDLCs getPilotCameraDirection ' +
        'getPilotCameraPosition getPilotCameraRotation getPilotCameraTarget getPlayerChannel ' +
        'getPlayerScores getPlayerUID getPos getPosASL getPosASLVisual getPosASLW getPosATL ' +
        'getPosATLVisual getPosVisual getPosWorld getRelDir getRelPos getRemoteSensorsDisabled ' +
        'getRepairCargo getResolution getShadowDistance getShotParents getSlingLoad getSpeed getStamina ' +
        'getStatValue getSuppression getTerrainHeightASL getText getUnitLoadout getUnitTrait getVariable ' +
        'getVehicleCargo getWeaponCargo getWeaponSway getWPPos glanceAt globalChat globalRadio goggles ' +
        'goto group groupChat groupFromNetId groupIconSelectable groupIconsVisible groupId groupOwner ' +
        'groupRadio groupSelectedUnits groupSelectUnit grpNull gunner gusts halt handgunItems ' +
        'handgunMagazine handgunWeapon handsHit hasInterface hasPilotCamera hasWeapon hcAllGroups ' +
        'hcGroupParams hcLeader hcRemoveAllGroups hcRemoveGroup hcSelected hcSelectGroup hcSetGroup ' +
        'hcShowBar hcShownBar headgear hideBody hideObject hideObjectGlobal hideSelection hint hintC ' +
        'hintCadet hintSilent hmd hostMission htmlLoad HUDMovementLevels humidity image importAllGroups ' +
        'importance in inArea inAreaArray incapacitatedState independent inflame inflamed ' +
        'inGameUISetEventHandler inheritsFrom initAmbientLife inPolygon inputAction inRangeOfArtillery ' +
        'insertEditorObject intersect is3DEN is3DENMultiplayer isAbleToBreathe isAgent isArray ' +
        'isAutoHoverOn isAutonomous isAutotest isBleeding isBurning isClass isCollisionLightOn ' +
        'isCopilotEnabled isDedicated isDLCAvailable isEngineOn isEqualTo isEqualType isEqualTypeAll ' +
        'isEqualTypeAny isEqualTypeArray isEqualTypeParams isFilePatchingEnabled isFlashlightOn ' +
        'isFlatEmpty isForcedWalk isFormationLeader isHidden isInRemainsCollector ' +
        'isInstructorFigureEnabled isIRLaserOn isKeyActive isKindOf isLightOn isLocalized isManualFire ' +
        'isMarkedForCollection isMultiplayer isMultiplayerSolo isNil isNull isNumber isObjectHidden ' +
        'isObjectRTD isOnRoad isPipEnabled isPlayer isRealTime isRemoteExecuted isRemoteExecutedJIP ' +
        'isServer isShowing3DIcons isSprintAllowed isStaminaEnabled isSteamMission ' +
        'isStreamFriendlyUIEnabled isText isTouchingGround isTurnedOut isTutHintsEnabled isUAVConnectable ' +
        'isUAVConnected isUniformAllowed isVehicleCargo isWalking isWeaponDeployed isWeaponRested ' +
        'itemCargo items itemsWithMagazines join joinAs joinAsSilent joinSilent joinString kbAddDatabase ' +
        'kbAddDatabaseTargets kbAddTopic kbHasTopic kbReact kbRemoveTopic kbTell kbWasSaid keyImage ' +
        'keyName knowsAbout land landAt landResult language laserTarget lbAdd lbClear lbColor lbCurSel ' +
        'lbData lbDelete lbIsSelected lbPicture lbSelection lbSetColor lbSetCurSel lbSetData lbSetPicture ' +
        'lbSetPictureColor lbSetPictureColorDisabled lbSetPictureColorSelected lbSetSelectColor ' +
        'lbSetSelectColorRight lbSetSelected lbSetTooltip lbSetValue lbSize lbSort lbSortByValue lbText ' +
        'lbValue leader leaderboardDeInit leaderboardGetRows leaderboardInit leaveVehicle libraryCredits ' +
        'libraryDisclaimers lifeState lightAttachObject lightDetachObject lightIsOn lightnings limitSpeed ' +
        'linearConversion lineBreak lineIntersects lineIntersectsObjs lineIntersectsSurfaces ' +
        'lineIntersectsWith linkItem list listObjects ln lnbAddArray lnbAddColumn lnbAddRow lnbClear ' +
        'lnbColor lnbCurSelRow lnbData lnbDeleteColumn lnbDeleteRow lnbGetColumnsPosition lnbPicture ' +
        'lnbSetColor lnbSetColumnsPos lnbSetCurSelRow lnbSetData lnbSetPicture lnbSetText lnbSetValue ' +
        'lnbSize lnbText lnbValue load loadAbs loadBackpack loadFile loadGame loadIdentity loadMagazine ' +
        'loadOverlay loadStatus loadUniform loadVest local localize locationNull locationPosition lock ' +
        'lockCameraTo lockCargo lockDriver locked lockedCargo lockedDriver lockedTurret lockIdentity ' +
        'lockTurret lockWP log logEntities logNetwork logNetworkTerminate lookAt lookAtPos magazineCargo ' +
        'magazines magazinesAllTurrets magazinesAmmo magazinesAmmoCargo magazinesAmmoFull magazinesDetail ' +
        'magazinesDetailBackpack magazinesDetailUniform magazinesDetailVest magazinesTurret ' +
        'magazineTurretAmmo mapAnimAdd mapAnimClear mapAnimCommit mapAnimDone mapCenterOnCamera ' +
        'mapGridPosition markAsFinishedOnSteam markerAlpha markerBrush markerColor markerDir markerPos ' +
        'markerShape markerSize markerText markerType max members menuAction menuAdd menuChecked menuClear ' +
        'menuCollapse menuData menuDelete menuEnable menuEnabled menuExpand menuHover menuPicture ' +
        'menuSetAction menuSetCheck menuSetData menuSetPicture menuSetValue menuShortcut menuShortcutText ' +
        'menuSize menuSort menuText menuURL menuValue min mineActive mineDetectedBy missionConfigFile ' +
        'missionDifficulty missionName missionNamespace missionStart missionVersion mod modelToWorld ' +
        'modelToWorldVisual modParams moonIntensity moonPhase morale move move3DENCamera moveInAny ' +
        'moveInCargo moveInCommander moveInDriver moveInGunner moveInTurret moveObjectToEnd moveOut ' +
        'moveTime moveTo moveToCompleted moveToFailed musicVolume name nameSound nearEntities ' +
        'nearestBuilding nearestLocation nearestLocations nearestLocationWithDubbing nearestObject ' +
        'nearestObjects nearestTerrainObjects nearObjects nearObjectsReady nearRoads nearSupplies ' +
        'nearTargets needReload netId netObjNull newOverlay nextMenuItemIndex nextWeatherChange nMenuItems ' +
        'not numberToDate objectCurators objectFromNetId objectParent objNull objStatus onBriefingGroup ' +
        'onBriefingNotes onBriefingPlan onBriefingTeamSwitch onCommandModeChanged onDoubleClick ' +
        'onEachFrame onGroupIconClick onGroupIconOverEnter onGroupIconOverLeave onHCGroupSelectionChanged ' +
        'onMapSingleClick onPlayerConnected onPlayerDisconnected onPreloadFinished onPreloadStarted ' +
        'onShowNewObject onTeamSwitch openCuratorInterface openDLCPage openMap openYoutubeVideo opfor or ' +
        'orderGetIn overcast overcastForecast owner param params parseNumber parseText parsingNamespace ' +
        'particlesQuality pi pickWeaponPool pitch pixelGrid pixelGridBase pixelGridNoUIScale pixelH pixelW ' +
        'playableSlotsNumber playableUnits playAction playActionNow player playerRespawnTime playerSide ' +
        'playersNumber playGesture playMission playMove playMoveNow playMusic playScriptedMission ' +
        'playSound playSound3D position positionCameraToWorld posScreenToWorld posWorldToScreen ' +
        'ppEffectAdjust ppEffectCommit ppEffectCommitted ppEffectCreate ppEffectDestroy ppEffectEnable ' +
        'ppEffectEnabled ppEffectForceInNVG precision preloadCamera preloadObject preloadSound ' +
        'preloadTitleObj preloadTitleRsc preprocessFile preprocessFileLineNumbers primaryWeapon ' +
        'primaryWeaponItems primaryWeaponMagazine priority private processDiaryLink productVersion ' +
        'profileName profileNamespace profileNameSteam progressLoadingScreen progressPosition ' +
        'progressSetPosition publicVariable publicVariableClient publicVariableServer pushBack ' +
        'pushBackUnique putWeaponPool queryItemsPool queryMagazinePool queryWeaponPool rad radioChannelAdd ' +
        'radioChannelCreate radioChannelRemove radioChannelSetCallSign radioChannelSetLabel radioVolume ' +
        'rain rainbow random rank rankId rating rectangular registeredTasks registerTask reload ' +
        'reloadEnabled remoteControl remoteExec remoteExecCall remove3DENConnection remove3DENEventHandler ' +
        'remove3DENLayer removeAction removeAll3DENEventHandlers removeAllActions removeAllAssignedItems ' +
        'removeAllContainers removeAllCuratorAddons removeAllCuratorCameraAreas ' +
        'removeAllCuratorEditingAreas removeAllEventHandlers removeAllHandgunItems removeAllItems ' +
        'removeAllItemsWithMagazines removeAllMissionEventHandlers removeAllMPEventHandlers ' +
        'removeAllMusicEventHandlers removeAllOwnedMines removeAllPrimaryWeaponItems removeAllWeapons ' +
        'removeBackpack removeBackpackGlobal removeCuratorAddons removeCuratorCameraArea ' +
        'removeCuratorEditableObjects removeCuratorEditingArea removeDrawIcon removeDrawLinks ' +
        'removeEventHandler removeFromRemainsCollector removeGoggles removeGroupIcon removeHandgunItem ' +
        'removeHeadgear removeItem removeItemFromBackpack removeItemFromUniform removeItemFromVest ' +
        'removeItems removeMagazine removeMagazineGlobal removeMagazines removeMagazinesTurret ' +
        'removeMagazineTurret removeMenuItem removeMissionEventHandler removeMPEventHandler ' +
        'removeMusicEventHandler removeOwnedMine removePrimaryWeaponItem removeSecondaryWeaponItem ' +
        'removeSimpleTask removeSwitchableUnit removeTeamMember removeUniform removeVest removeWeapon ' +
        'removeWeaponGlobal removeWeaponTurret requiredVersion resetCamShake resetSubgroupDirection ' +
        'resistance resize resources respawnVehicle restartEditorCamera reveal revealMine reverse ' +
        'reversedMouseY roadAt roadsConnectedTo roleDescription ropeAttachedObjects ropeAttachedTo ' +
        'ropeAttachEnabled ropeAttachTo ropeCreate ropeCut ropeDestroy ropeDetach ropeEndPosition ' +
        'ropeLength ropes ropeUnwind ropeUnwound rotorsForcesRTD rotorsRpmRTD round runInitScript ' +
        'safeZoneH safeZoneW safeZoneWAbs safeZoneX safeZoneXAbs safeZoneY save3DENInventory saveGame ' +
        'saveIdentity saveJoysticks saveOverlay saveProfileNamespace saveStatus saveVar savingEnabled say ' +
        'say2D say3D scopeName score scoreSide screenshot screenToWorld scriptDone scriptName scriptNull ' +
        'scudState secondaryWeapon secondaryWeaponItems secondaryWeaponMagazine select selectBestPlaces ' +
        'selectDiarySubject selectedEditorObjects selectEditorObject selectionNames selectionPosition ' +
        'selectLeader selectMax selectMin selectNoPlayer selectPlayer selectRandom selectWeapon ' +
        'selectWeaponTurret sendAUMessage sendSimpleCommand sendTask sendTaskResult sendUDPMessage ' +
        'serverCommand serverCommandAvailable serverCommandExecutable serverName serverTime set ' +
        'set3DENAttribute set3DENAttributes set3DENGrid set3DENIconsVisible set3DENLayer ' +
        'set3DENLinesVisible set3DENMissionAttributes set3DENModelsVisible set3DENObjectType ' +
        'set3DENSelected setAccTime setAirportSide setAmmo setAmmoCargo setAnimSpeedCoef setAperture ' +
        'setApertureNew setArmoryPoints setAttributes setAutonomous setBehaviour setBleedingRemaining ' +
        'setCameraInterest setCamShakeDefParams setCamShakeParams setCamUseTi setCaptive setCenterOfMass ' +
        'setCollisionLight setCombatMode setCompassOscillation setCuratorCameraAreaCeiling setCuratorCoef ' +
        'setCuratorEditingAreaType setCuratorWaypointCost setCurrentChannel setCurrentTask ' +
        'setCurrentWaypoint setCustomAimCoef setDamage setDammage setDate setDebriefingText ' +
        'setDefaultCamera setDestination setDetailMapBlendPars setDir setDirection setDrawIcon ' +
        'setDropInterval setEditorMode setEditorObjectScope setEffectCondition setFace setFaceAnimation ' +
        'setFatigue setFlagOwner setFlagSide setFlagTexture setFog setFormation setFormationTask ' +
        'setFormDir setFriend setFromEditor setFSMVariable setFuel setFuelCargo setGroupIcon ' +
        'setGroupIconParams setGroupIconsSelectable setGroupIconsVisible setGroupId setGroupIdGlobal ' +
        'setGroupOwner setGusts setHideBehind setHit setHitIndex setHitPointDamage setHorizonParallaxCoef ' +
        'setHUDMovementLevels setIdentity setImportance setLeader setLightAmbient setLightAttenuation ' +
        'setLightBrightness setLightColor setLightDayLight setLightFlareMaxDistance setLightFlareSize ' +
        'setLightIntensity setLightnings setLightUseFlare setLocalWindParams setMagazineTurretAmmo ' +
        'setMarkerAlpha setMarkerAlphaLocal setMarkerBrush setMarkerBrushLocal setMarkerColor ' +
        'setMarkerColorLocal setMarkerDir setMarkerDirLocal setMarkerPos setMarkerPosLocal setMarkerShape ' +
        'setMarkerShapeLocal setMarkerSize setMarkerSizeLocal setMarkerText setMarkerTextLocal ' +
        'setMarkerType setMarkerTypeLocal setMass setMimic setMousePosition setMusicEffect ' +
        'setMusicEventHandler setName setNameSound setObjectArguments setObjectMaterial ' +
        'setObjectMaterialGlobal setObjectProxy setObjectTexture setObjectTextureGlobal ' +
        'setObjectViewDistance setOvercast setOwner setOxygenRemaining setParticleCircle setParticleClass ' +
        'setParticleFire setParticleParams setParticleRandom setPilotCameraDirection ' +
        'setPilotCameraRotation setPilotCameraTarget setPilotLight setPiPEffect setPitch setPlayable ' +
        'setPlayerRespawnTime setPos setPosASL setPosASL2 setPosASLW setPosATL setPosition setPosWorld ' +
        'setRadioMsg setRain setRainbow setRandomLip setRank setRectangular setRepairCargo ' +
        'setShadowDistance setShotParents setSide setSimpleTaskAlwaysVisible setSimpleTaskCustomData ' +
        'setSimpleTaskDescription setSimpleTaskDestination setSimpleTaskTarget setSimpleTaskType ' +
        'setSimulWeatherLayers setSize setSkill setSlingLoad setSoundEffect setSpeaker setSpeech ' +
        'setSpeedMode setStamina setStaminaScheme setStatValue setSuppression setSystemOfUnits ' +
        'setTargetAge setTaskResult setTaskState setTerrainGrid setText setTimeMultiplier setTitleEffect ' +
        'setTriggerActivation setTriggerArea setTriggerStatements setTriggerText setTriggerTimeout ' +
        'setTriggerType setType setUnconscious setUnitAbility setUnitLoadout setUnitPos setUnitPosWeak ' +
        'setUnitRank setUnitRecoilCoefficient setUnitTrait setUnloadInCombat setUserActionText setVariable ' +
        'setVectorDir setVectorDirAndUp setVectorUp setVehicleAmmo setVehicleAmmoDef setVehicleArmor ' +
        'setVehicleCargo setVehicleId setVehicleLock setVehiclePosition setVehicleTiPars setVehicleVarName ' +
        'setVelocity setVelocityTransformation setViewDistance setVisibleIfTreeCollapsed setWaves ' +
        'setWaypointBehaviour setWaypointCombatMode setWaypointCompletionRadius setWaypointDescription ' +
        'setWaypointForceBehaviour setWaypointFormation setWaypointHousePosition setWaypointLoiterRadius ' +
        'setWaypointLoiterType setWaypointName setWaypointPosition setWaypointScript setWaypointSpeed ' +
        'setWaypointStatements setWaypointTimeout setWaypointType setWaypointVisible ' +
        'setWeaponReloadingTime setWind setWindDir setWindForce setWindStr setWPPos show3DIcons showChat ' +
        'showCinemaBorder showCommandingMenu showCompass showCuratorCompass showGPS showHUD showLegend ' +
        'showMap shownArtilleryComputer shownChat shownCompass shownCuratorCompass showNewEditorObject ' +
        'shownGPS shownHUD shownMap shownPad shownRadio shownScoretable shownUAVFeed shownWarrant ' +
        'shownWatch showPad showRadio showScoretable showSubtitles showUAVFeed showWarrant showWatch ' +
        'showWaypoint showWaypoints side sideAmbientLife sideChat sideEmpty sideEnemy sideFriendly ' +
        'sideLogic sideRadio sideUnknown simpleTasks simulationEnabled simulCloudDensity ' +
        'simulCloudOcclusion simulInClouds simulWeatherSync sin size sizeOf skill skillFinal skipTime ' +
        'sleep sliderPosition sliderRange sliderSetPosition sliderSetRange sliderSetSpeed sliderSpeed ' +
        'slingLoadAssistantShown soldierMagazines someAmmo sort soundVolume spawn speaker speed speedMode ' +
        'splitString sqrt squadParams stance startLoadingScreen step stop stopEngineRTD stopped str ' +
        'sunOrMoon supportInfo suppressFor surfaceIsWater surfaceNormal surfaceType swimInDepth ' +
        'switchableUnits switchAction switchCamera switchGesture switchLight switchMove ' +
        'synchronizedObjects synchronizedTriggers synchronizedWaypoints synchronizeObjectsAdd ' +
        'synchronizeObjectsRemove synchronizeTrigger synchronizeWaypoint systemChat systemOfUnits tan ' +
        'targetKnowledge targetsAggregate targetsQuery taskAlwaysVisible taskChildren taskCompleted ' +
        'taskCustomData taskDescription taskDestination taskHint taskMarkerOffset taskNull taskParent ' +
        'taskResult taskState taskType teamMember teamMemberNull teamName teams teamSwitch ' +
        'teamSwitchEnabled teamType terminate terrainIntersect terrainIntersectASL text textLog ' +
        'textLogFormat tg time timeMultiplier titleCut titleFadeOut titleObj titleRsc titleText toArray ' +
        'toFixed toLower toString toUpper triggerActivated triggerActivation triggerArea ' +
        'triggerAttachedVehicle triggerAttachObject triggerAttachVehicle triggerStatements triggerText ' +
        'triggerTimeout triggerTimeoutCurrent triggerType turretLocal turretOwner turretUnit tvAdd tvClear ' +
        'tvCollapse tvCount tvCurSel tvData tvDelete tvExpand tvPicture tvSetCurSel tvSetData tvSetPicture ' +
        'tvSetPictureColor tvSetPictureColorDisabled tvSetPictureColorSelected tvSetPictureRight ' +
        'tvSetPictureRightColor tvSetPictureRightColorDisabled tvSetPictureRightColorSelected tvSetText ' +
        'tvSetTooltip tvSetValue tvSort tvSortByValue tvText tvTooltip tvValue type typeName typeOf ' +
        'UAVControl uiNamespace uiSleep unassignCurator unassignItem unassignTeam unassignVehicle ' +
        'underwater uniform uniformContainer uniformItems uniformMagazines unitAddons unitAimPosition ' +
        'unitAimPositionVisual unitBackpack unitIsUAV unitPos unitReady unitRecoilCoefficient units ' +
        'unitsBelowHeight unlinkItem unlockAchievement unregisterTask updateDrawIcon updateMenuItem ' +
        'updateObjectTree useAISteeringComponent useAudioTimeForMoves vectorAdd vectorCos ' +
        'vectorCrossProduct vectorDiff vectorDir vectorDirVisual vectorDistance vectorDistanceSqr ' +
        'vectorDotProduct vectorFromTo vectorMagnitude vectorMagnitudeSqr vectorMultiply vectorNormalized ' +
        'vectorUp vectorUpVisual vehicle vehicleCargoEnabled vehicleChat vehicleRadio vehicles ' +
        'vehicleVarName velocity velocityModelSpace verifySignature vest vestContainer vestItems ' +
        'vestMagazines viewDistance visibleCompass visibleGPS visibleMap visiblePosition ' +
        'visiblePositionASL visibleScoretable visibleWatch waves waypointAttachedObject ' +
        'waypointAttachedVehicle waypointAttachObject waypointAttachVehicle waypointBehaviour ' +
        'waypointCombatMode waypointCompletionRadius waypointDescription waypointForceBehaviour ' +
        'waypointFormation waypointHousePosition waypointLoiterRadius waypointLoiterType waypointName ' +
        'waypointPosition waypoints waypointScript waypointsEnabledUAV waypointShow waypointSpeed ' +
        'waypointStatements waypointTimeout waypointTimeoutCurrent waypointType waypointVisible ' +
        'weaponAccessories weaponAccessoriesCargo weaponCargo weaponDirection weaponInertia weaponLowered ' +
        'weapons weaponsItems weaponsItemsCargo weaponState weaponsTurret weightRTD west WFSideText wind',
      literal:
        'true false nil'
    },
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.NUMBER_MODE,
      VARIABLE,
      FUNCTION,
      STRINGS,
      CPP.preprocessor
    ],
    illegal: /#/
  };
};

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var COMMENT_MODE = hljs.COMMENT('--', '$');
  return {
    case_insensitive: true,
    illegal: /[<>{}*#]/,
    contains: [
      {
        beginKeywords:
          'begin end start commit rollback savepoint lock alter create drop rename call ' +
          'delete do handler insert load replace select truncate update set show pragma grant ' +
          'merge describe use explain help declare prepare execute deallocate release ' +
          'unlock purge reset change stop analyze cache flush optimize repair kill ' +
          'install uninstall checksum restore check backup revoke comment',
        end: /;/, endsWithParent: true,
        lexemes: /[\w\.]+/,
        keywords: {
          keyword:
            'abort abs absolute acc acce accep accept access accessed accessible account acos action activate add ' +
            'addtime admin administer advanced advise aes_decrypt aes_encrypt after agent aggregate ali alia alias ' +
            'allocate allow alter always analyze ancillary and any anydata anydataset anyschema anytype apply ' +
            'archive archived archivelog are as asc ascii asin assembly assertion associate asynchronous at atan ' +
            'atn2 attr attri attrib attribu attribut attribute attributes audit authenticated authentication authid ' +
            'authors auto autoallocate autodblink autoextend automatic availability avg backup badfile basicfile ' +
            'before begin beginning benchmark between bfile bfile_base big bigfile bin binary_double binary_float ' +
            'binlog bit_and bit_count bit_length bit_or bit_xor bitmap blob_base block blocksize body both bound ' +
            'buffer_cache buffer_pool build bulk by byte byteordermark bytes cache caching call calling cancel ' +
            'capacity cascade cascaded case cast catalog category ceil ceiling chain change changed char_base ' +
            'char_length character_length characters characterset charindex charset charsetform charsetid check ' +
            'checksum checksum_agg child choose chr chunk class cleanup clear client clob clob_base clone close ' +
            'cluster_id cluster_probability cluster_set clustering coalesce coercibility col collate collation ' +
            'collect colu colum column column_value columns columns_updated comment commit compact compatibility ' +
            'compiled complete composite_limit compound compress compute concat concat_ws concurrent confirm conn ' +
            'connec connect connect_by_iscycle connect_by_isleaf connect_by_root connect_time connection ' +
            'consider consistent constant constraint constraints constructor container content contents context ' +
            'contributors controlfile conv convert convert_tz corr corr_k corr_s corresponding corruption cos cost ' +
            'count count_big counted covar_pop covar_samp cpu_per_call cpu_per_session crc32 create creation ' +
            'critical cross cube cume_dist curdate current current_date current_time current_timestamp current_user ' +
            'cursor curtime customdatum cycle data database databases datafile datafiles datalength date_add ' +
            'date_cache date_format date_sub dateadd datediff datefromparts datename datepart datetime2fromparts ' +
            'day day_to_second dayname dayofmonth dayofweek dayofyear days db_role_change dbtimezone ddl deallocate ' +
            'declare decode decompose decrement decrypt deduplicate def defa defau defaul default defaults ' +
            'deferred defi defin define degrees delayed delegate delete delete_all delimited demand dense_rank ' +
            'depth dequeue des_decrypt des_encrypt des_key_file desc descr descri describ describe descriptor ' +
            'deterministic diagnostics difference dimension direct_load directory disable disable_all ' +
            'disallow disassociate discardfile disconnect diskgroup distinct distinctrow distribute distributed div ' +
            'do document domain dotnet double downgrade drop dumpfile duplicate duration each edition editionable ' +
            'editions element ellipsis else elsif elt empty enable enable_all enclosed encode encoding encrypt ' +
            'end end-exec endian enforced engine engines enqueue enterprise entityescaping eomonth error errors ' +
            'escaped evalname evaluate event eventdata events except exception exceptions exchange exclude excluding ' +
            'execu execut execute exempt exists exit exp expire explain export export_set extended extent external ' +
            'external_1 external_2 externally extract failed failed_login_attempts failover failure far fast ' +
            'feature_set feature_value fetch field fields file file_name_convert filesystem_like_logging final ' +
            'finish first first_value fixed flash_cache flashback floor flush following follows for forall force ' +
            'form forma format found found_rows freelist freelists freepools fresh from from_base64 from_days ' +
            'ftp full function general generated get get_format get_lock getdate getutcdate global global_name ' +
            'globally go goto grant grants greatest group group_concat group_id grouping grouping_id groups ' +
            'gtid_subtract guarantee guard handler hash hashkeys having hea head headi headin heading heap help hex ' +
            'hierarchy high high_priority hosts hour http id ident_current ident_incr ident_seed identified ' +
            'identity idle_time if ifnull ignore iif ilike ilm immediate import in include including increment ' +
            'index indexes indexing indextype indicator indices inet6_aton inet6_ntoa inet_aton inet_ntoa infile ' +
            'initial initialized initially initrans inmemory inner innodb input insert install instance instantiable ' +
            'instr interface interleaved intersect into invalidate invisible is is_free_lock is_ipv4 is_ipv4_compat ' +
            'is_not is_not_null is_used_lock isdate isnull isolation iterate java join json json_exists ' +
            'keep keep_duplicates key keys kill language large last last_day last_insert_id last_value lax lcase ' +
            'lead leading least leaves left len lenght length less level levels library like like2 like4 likec limit ' +
            'lines link list listagg little ln load load_file lob lobs local localtime localtimestamp locate ' +
            'locator lock locked log log10 log2 logfile logfiles logging logical logical_reads_per_call ' +
            'logoff logon logs long loop low low_priority lower lpad lrtrim ltrim main make_set makedate maketime ' +
            'managed management manual map mapping mask master master_pos_wait match matched materialized max ' +
            'maxextents maximize maxinstances maxlen maxlogfiles maxloghistory maxlogmembers maxsize maxtrans ' +
            'md5 measures median medium member memcompress memory merge microsecond mid migration min minextents ' +
            'minimum mining minus minute minvalue missing mod mode model modification modify module monitoring month ' +
            'months mount move movement multiset mutex name name_const names nan national native natural nav nchar ' +
            'nclob nested never new newline next nextval no no_write_to_binlog noarchivelog noaudit nobadfile ' +
            'nocheck nocompress nocopy nocycle nodelay nodiscardfile noentityescaping noguarantee nokeep nologfile ' +
            'nomapping nomaxvalue nominimize nominvalue nomonitoring none noneditionable nonschema noorder ' +
            'nopr nopro noprom nopromp noprompt norely noresetlogs noreverse normal norowdependencies noschemacheck ' +
            'noswitch not nothing notice notrim novalidate now nowait nth_value nullif nulls num numb numbe ' +
            'nvarchar nvarchar2 object ocicoll ocidate ocidatetime ociduration ociinterval ociloblocator ocinumber ' +
            'ociref ocirefcursor ocirowid ocistring ocitype oct octet_length of off offline offset oid oidindex old ' +
            'on online only opaque open operations operator optimal optimize option optionally or oracle oracle_date ' +
            'oradata ord ordaudio orddicom orddoc order ordimage ordinality ordvideo organization orlany orlvary ' +
            'out outer outfile outline output over overflow overriding package pad parallel parallel_enable ' +
            'parameters parent parse partial partition partitions pascal passing password password_grace_time ' +
            'password_lock_time password_reuse_max password_reuse_time password_verify_function patch path patindex ' +
            'pctincrease pctthreshold pctused pctversion percent percent_rank percentile_cont percentile_disc ' +
            'performance period period_add period_diff permanent physical pi pipe pipelined pivot pluggable plugin ' +
            'policy position post_transaction pow power pragma prebuilt precedes preceding precision prediction ' +
            'prediction_cost prediction_details prediction_probability prediction_set prepare present preserve ' +
            'prior priority private private_sga privileges procedural procedure procedure_analyze processlist ' +
            'profiles project prompt protection public publishingservername purge quarter query quick quiesce quota ' +
            'quotename radians raise rand range rank raw read reads readsize rebuild record records ' +
            'recover recovery recursive recycle redo reduced ref reference referenced references referencing refresh ' +
            'regexp_like register regr_avgx regr_avgy regr_count regr_intercept regr_r2 regr_slope regr_sxx regr_sxy ' +
            'reject rekey relational relative relaylog release release_lock relies_on relocate rely rem remainder rename ' +
            'repair repeat replace replicate replication required reset resetlogs resize resource respect restore ' +
            'restricted result result_cache resumable resume retention return returning returns reuse reverse revoke ' +
            'right rlike role roles rollback rolling rollup round row row_count rowdependencies rowid rownum rows ' +
            'rtrim rules safe salt sample save savepoint sb1 sb2 sb4 scan schema schemacheck scn scope scroll ' +
            'sdo_georaster sdo_topo_geometry search sec_to_time second section securefile security seed segment select ' +
            'self sequence sequential serializable server servererror session session_user sessions_per_user set ' +
            'sets settings sha sha1 sha2 share shared shared_pool short show shrink shutdown si_averagecolor ' +
            'si_colorhistogram si_featurelist si_positionalcolor si_stillimage si_texture siblings sid sign sin ' +
            'size size_t sizes skip slave sleep smalldatetimefromparts smallfile snapshot some soname sort soundex ' +
            'source space sparse spfile split sql sql_big_result sql_buffer_result sql_cache sql_calc_found_rows ' +
            'sql_small_result sql_variant_property sqlcode sqldata sqlerror sqlname sqlstate sqrt square standalone ' +
            'standby start starting startup statement static statistics stats_binomial_test stats_crosstab ' +
            'stats_ks_test stats_mode stats_mw_test stats_one_way_anova stats_t_test_ stats_t_test_indep ' +
            'stats_t_test_one stats_t_test_paired stats_wsr_test status std stddev stddev_pop stddev_samp stdev ' +
            'stop storage store stored str str_to_date straight_join strcmp strict string struct stuff style subdate ' +
            'subpartition subpartitions substitutable substr substring subtime subtring_index subtype success sum ' +
            'suspend switch switchoffset switchover sync synchronous synonym sys sys_xmlagg sysasm sysaux sysdate ' +
            'sysdatetimeoffset sysdba sysoper system system_user sysutcdatetime table tables tablespace tan tdo ' +
            'template temporary terminated tertiary_weights test than then thread through tier ties time time_format ' +
            'time_zone timediff timefromparts timeout timestamp timestampadd timestampdiff timezone_abbr ' +
            'timezone_minute timezone_region to to_base64 to_date to_days to_seconds todatetimeoffset trace tracking ' +
            'transaction transactional translate translation treat trigger trigger_nestlevel triggers trim truncate ' +
            'try_cast try_convert try_parse type ub1 ub2 ub4 ucase unarchived unbounded uncompress ' +
            'under undo unhex unicode uniform uninstall union unique unix_timestamp unknown unlimited unlock unpivot ' +
            'unrecoverable unsafe unsigned until untrusted unusable unused update updated upgrade upped upper upsert ' +
            'url urowid usable usage use use_stored_outlines user user_data user_resources users using utc_date ' +
            'utc_timestamp uuid uuid_short validate validate_password_strength validation valist value values var ' +
            'var_samp varcharc vari varia variab variabl variable variables variance varp varraw varrawc varray ' +
            'verify version versions view virtual visible void wait wallet warning warnings week weekday weekofyear ' +
            'wellformed when whene whenev wheneve whenever where while whitespace with within without work wrapped ' +
            'xdb xml xmlagg xmlattributes xmlcast xmlcolattval xmlelement xmlexists xmlforest xmlindex xmlnamespaces ' +
            'xmlpi xmlquery xmlroot xmlschema xmlserialize xmltable xmltype xor year year_to_month years yearweek',
          literal:
            'true false null',
          built_in:
            'array bigint binary bit blob boolean char character date dec decimal float int int8 integer interval number ' +
            'numeric real record serial serial8 smallint text varchar varying void'
        },
        contains: [
          {
            className: 'string',
            begin: '\'', end: '\'',
            contains: [hljs.BACKSLASH_ESCAPE, {begin: '\'\''}]
          },
          {
            className: 'string',
            begin: '"', end: '"',
            contains: [hljs.BACKSLASH_ESCAPE, {begin: '""'}]
          },
          {
            className: 'string',
            begin: '`', end: '`',
            contains: [hljs.BACKSLASH_ESCAPE]
          },
          hljs.C_NUMBER_MODE,
          hljs.C_BLOCK_COMMENT_MODE,
          COMMENT_MODE
        ]
      },
      hljs.C_BLOCK_COMMENT_MODE,
      COMMENT_MODE
    ]
  };
};

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    contains: [
      hljs.HASH_COMMENT_MODE,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        begin: hljs.UNDERSCORE_IDENT_RE,
        lexemes: hljs.UNDERSCORE_IDENT_RE,
        keywords: {
          // Stan's keywords
          name:
            'for in while repeat until if then else',
          // Stan's probablity distributions (less beta and gamma, as commonly
          // used for parameter names). So far, _log and _rng variants are not
          // included
          symbol:
            'bernoulli bernoulli_logit binomial binomial_logit '               +
            'beta_binomial hypergeometric categorical categorical_logit '      +
            'ordered_logistic neg_binomial neg_binomial_2 '                    +
            'neg_binomial_2_log poisson poisson_log multinomial normal '       +
            'exp_mod_normal skew_normal student_t cauchy double_exponential '  +
            'logistic gumbel lognormal chi_square inv_chi_square '             +
            'scaled_inv_chi_square exponential inv_gamma weibull frechet '     +
            'rayleigh wiener pareto pareto_type_2 von_mises uniform '          +
            'multi_normal multi_normal_prec multi_normal_cholesky multi_gp '   +
            'multi_gp_cholesky multi_student_t gaussian_dlm_obs dirichlet '    +
            'lkj_corr lkj_corr_cholesky wishart inv_wishart',
          // Stan's data types
          'selector-tag':
            'int real vector simplex unit_vector ordered positive_ordered '    +
            'row_vector matrix cholesky_factor_corr cholesky_factor_cov '      +
            'corr_matrix cov_matrix',
          // Stan's model blocks
          title:
            'functions model data parameters quantities transformed '          +
            'generated',
          literal:
            'true false'
        },
        relevance: 0
      },
      // The below is all taken from the R language definition
      {
        // hex value
        className: 'number',
        begin: "0[xX][0-9a-fA-F]+[Li]?\\b",
        relevance: 0
      },
      {
        // hex value
        className: 'number',
        begin: "0[xX][0-9a-fA-F]+[Li]?\\b",
        relevance: 0
      },
      {
        // explicit integer
        className: 'number',
        begin: "\\d+(?:[eE][+\\-]?\\d*)?L\\b",
        relevance: 0
      },
      {
        // number with trailing decimal
        className: 'number',
        begin: "\\d+\\.(?!\\d)(?:i\\b)?",
        relevance: 0
      },
      {
        // number
        className: 'number',
        begin: "\\d+(?:\\.\\d*)?(?:[eE][+\\-]?\\d*)?i?\\b",
        relevance: 0
      },
      {
        // number with leading decimal
        className: 'number',
        begin: "\\.\\d+(?:[eE][+\\-]?\\d*)?i?\\b",
        relevance: 0
      }
    ]
  };
};

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    aliases: ['do', 'ado'],
    case_insensitive: true,
    keywords: 'if else in foreach for forv forva forval forvalu forvalue forvalues by bys bysort xi quietly qui capture about ac ac_7 acprplot acprplot_7 adjust ado adopath adoupdate alpha ameans an ano anov anova anova_estat anova_terms anovadef aorder ap app appe appen append arch arch_dr arch_estat arch_p archlm areg areg_p args arima arima_dr arima_estat arima_p as asmprobit asmprobit_estat asmprobit_lf asmprobit_mfx__dlg asmprobit_p ass asse asser assert avplot avplot_7 avplots avplots_7 bcskew0 bgodfrey binreg bip0_lf biplot bipp_lf bipr_lf bipr_p biprobit bitest bitesti bitowt blogit bmemsize boot bootsamp bootstrap bootstrap_8 boxco_l boxco_p boxcox boxcox_6 boxcox_p bprobit br break brier bro brow brows browse brr brrstat bs bs_7 bsampl_w bsample bsample_7 bsqreg bstat bstat_7 bstat_8 bstrap bstrap_7 ca ca_estat ca_p cabiplot camat canon canon_8 canon_8_p canon_estat canon_p cap caprojection capt captu captur capture cat cc cchart cchart_7 cci cd censobs_table centile cf char chdir checkdlgfiles checkestimationsample checkhlpfiles checksum chelp ci cii cl class classutil clear cli clis clist clo clog clog_lf clog_p clogi clogi_sw clogit clogit_lf clogit_p clogitp clogl_sw cloglog clonevar clslistarray cluster cluster_measures cluster_stop cluster_tree cluster_tree_8 clustermat cmdlog cnr cnre cnreg cnreg_p cnreg_sw cnsreg codebook collaps4 collapse colormult_nb colormult_nw compare compress conf confi confir confirm conren cons const constr constra constrai constrain constraint continue contract copy copyright copysource cor corc corr corr2data corr_anti corr_kmo corr_smc corre correl correla correlat correlate corrgram cou coun count cox cox_p cox_sw coxbase coxhaz coxvar cprplot cprplot_7 crc cret cretu cretur creturn cross cs cscript cscript_log csi ct ct_is ctset ctst_5 ctst_st cttost cumsp cumsp_7 cumul cusum cusum_7 cutil d|0 datasig datasign datasigna datasignat datasignatu datasignatur datasignature datetof db dbeta de dec deco decod decode deff des desc descr descri describ describe destring dfbeta dfgls dfuller di di_g dir dirstats dis discard disp disp_res disp_s displ displa display distinct do doe doed doedi doedit dotplot dotplot_7 dprobit drawnorm drop ds ds_util dstdize duplicates durbina dwstat dydx e|0 ed edi edit egen eivreg emdef en enc enco encod encode eq erase ereg ereg_lf ereg_p ereg_sw ereghet ereghet_glf ereghet_glf_sh ereghet_gp ereghet_ilf ereghet_ilf_sh ereghet_ip eret eretu eretur ereturn err erro error est est_cfexist est_cfname est_clickable est_expand est_hold est_table est_unhold est_unholdok estat estat_default estat_summ estat_vce_only esti estimates etodow etof etomdy ex exi exit expand expandcl fac fact facto factor factor_estat factor_p factor_pca_rotated factor_rotate factormat fcast fcast_compute fcast_graph fdades fdadesc fdadescr fdadescri fdadescrib fdadescribe fdasav fdasave fdause fh_st file open file read file close file filefilter fillin find_hlp_file findfile findit findit_7 fit fl fli flis flist for5_0 form forma format fpredict frac_154 frac_adj frac_chk frac_cox frac_ddp frac_dis frac_dv frac_in frac_mun frac_pp frac_pq frac_pv frac_wgt frac_xo fracgen fracplot fracplot_7 fracpoly fracpred fron_ex fron_hn fron_p fron_tn fron_tn2 frontier ftodate ftoe ftomdy ftowdate g|0 gamhet_glf gamhet_gp gamhet_ilf gamhet_ip gamma gamma_d2 gamma_p gamma_sw gammahet gdi_hexagon gdi_spokes ge gen gene gener genera generat generate genrank genstd genvmean gettoken gl gladder gladder_7 glim_l01 glim_l02 glim_l03 glim_l04 glim_l05 glim_l06 glim_l07 glim_l08 glim_l09 glim_l10 glim_l11 glim_l12 glim_lf glim_mu glim_nw1 glim_nw2 glim_nw3 glim_p glim_v1 glim_v2 glim_v3 glim_v4 glim_v5 glim_v6 glim_v7 glm glm_6 glm_p glm_sw glmpred glo glob globa global glogit glogit_8 glogit_p gmeans gnbre_lf gnbreg gnbreg_5 gnbreg_p gomp_lf gompe_sw gomper_p gompertz gompertzhet gomphet_glf gomphet_glf_sh gomphet_gp gomphet_ilf gomphet_ilf_sh gomphet_ip gphdot gphpen gphprint gprefs gprobi_p gprobit gprobit_8 gr gr7 gr_copy gr_current gr_db gr_describe gr_dir gr_draw gr_draw_replay gr_drop gr_edit gr_editviewopts gr_example gr_example2 gr_export gr_print gr_qscheme gr_query gr_read gr_rename gr_replay gr_save gr_set gr_setscheme gr_table gr_undo gr_use graph graph7 grebar greigen greigen_7 greigen_8 grmeanby grmeanby_7 gs_fileinfo gs_filetype gs_graphinfo gs_stat gsort gwood h|0 hadimvo hareg hausman haver he heck_d2 heckma_p heckman heckp_lf heckpr_p heckprob hel help hereg hetpr_lf hetpr_p hetprob hettest hexdump hilite hist hist_7 histogram hlogit hlu hmeans hotel hotelling hprobit hreg hsearch icd9 icd9_ff icd9p iis impute imtest inbase include inf infi infil infile infix inp inpu input ins insheet insp inspe inspec inspect integ inten intreg intreg_7 intreg_p intrg2_ll intrg_ll intrg_ll2 ipolate iqreg ir irf irf_create irfm iri is_svy is_svysum isid istdize ivprob_1_lf ivprob_lf ivprobit ivprobit_p ivreg ivreg_footnote ivtob_1_lf ivtob_lf ivtobit ivtobit_p jackknife jacknife jknife jknife_6 jknife_8 jkstat joinby kalarma1 kap kap_3 kapmeier kappa kapwgt kdensity kdensity_7 keep ksm ksmirnov ktau kwallis l|0 la lab labe label labelbook ladder levels levelsof leverage lfit lfit_p li lincom line linktest lis list lloghet_glf lloghet_glf_sh lloghet_gp lloghet_ilf lloghet_ilf_sh lloghet_ip llogi_sw llogis_p llogist llogistic llogistichet lnorm_lf lnorm_sw lnorma_p lnormal lnormalhet lnormhet_glf lnormhet_glf_sh lnormhet_gp lnormhet_ilf lnormhet_ilf_sh lnormhet_ip lnskew0 loadingplot loc loca local log logi logis_lf logistic logistic_p logit logit_estat logit_p loglogs logrank loneway lookfor lookup lowess lowess_7 lpredict lrecomp lroc lroc_7 lrtest ls lsens lsens_7 lsens_x lstat ltable ltable_7 ltriang lv lvr2plot lvr2plot_7 m|0 ma mac macr macro makecns man manova manova_estat manova_p manovatest mantel mark markin markout marksample mat mat_capp mat_order mat_put_rr mat_rapp mata mata_clear mata_describe mata_drop mata_matdescribe mata_matsave mata_matuse mata_memory mata_mlib mata_mosave mata_rename mata_which matalabel matcproc matlist matname matr matri matrix matrix_input__dlg matstrik mcc mcci md0_ md1_ md1debug_ md2_ md2debug_ mds mds_estat mds_p mdsconfig mdslong mdsmat mdsshepard mdytoe mdytof me_derd mean means median memory memsize meqparse mer merg merge mfp mfx mhelp mhodds minbound mixed_ll mixed_ll_reparm mkassert mkdir mkmat mkspline ml ml_5 ml_adjs ml_bhhhs ml_c_d ml_check ml_clear ml_cnt ml_debug ml_defd ml_e0 ml_e0_bfgs ml_e0_cycle ml_e0_dfp ml_e0i ml_e1 ml_e1_bfgs ml_e1_bhhh ml_e1_cycle ml_e1_dfp ml_e2 ml_e2_cycle ml_ebfg0 ml_ebfr0 ml_ebfr1 ml_ebh0q ml_ebhh0 ml_ebhr0 ml_ebr0i ml_ecr0i ml_edfp0 ml_edfr0 ml_edfr1 ml_edr0i ml_eds ml_eer0i ml_egr0i ml_elf ml_elf_bfgs ml_elf_bhhh ml_elf_cycle ml_elf_dfp ml_elfi ml_elfs ml_enr0i ml_enrr0 ml_erdu0 ml_erdu0_bfgs ml_erdu0_bhhh ml_erdu0_bhhhq ml_erdu0_cycle ml_erdu0_dfp ml_erdu0_nrbfgs ml_exde ml_footnote ml_geqnr ml_grad0 ml_graph ml_hbhhh ml_hd0 ml_hold ml_init ml_inv ml_log ml_max ml_mlout ml_mlout_8 ml_model ml_nb0 ml_opt ml_p ml_plot ml_query ml_rdgrd ml_repor ml_s_e ml_score ml_searc ml_technique ml_unhold mleval mlf_ mlmatbysum mlmatsum mlog mlogi mlogit mlogit_footnote mlogit_p mlopts mlsum mlvecsum mnl0_ mor more mov move mprobit mprobit_lf mprobit_p mrdu0_ mrdu1_ mvdecode mvencode mvreg mvreg_estat n|0 nbreg nbreg_al nbreg_lf nbreg_p nbreg_sw nestreg net newey newey_7 newey_p news nl nl_7 nl_9 nl_9_p nl_p nl_p_7 nlcom nlcom_p nlexp2 nlexp2_7 nlexp2a nlexp2a_7 nlexp3 nlexp3_7 nlgom3 nlgom3_7 nlgom4 nlgom4_7 nlinit nllog3 nllog3_7 nllog4 nllog4_7 nlog_rd nlogit nlogit_p nlogitgen nlogittree nlpred no nobreak noi nois noisi noisil noisily note notes notes_dlg nptrend numlabel numlist odbc old_ver olo olog ologi ologi_sw ologit ologit_p ologitp on one onew onewa oneway op_colnm op_comp op_diff op_inv op_str opr opro oprob oprob_sw oprobi oprobi_p oprobit oprobitp opts_exclusive order orthog orthpoly ou out outf outfi outfil outfile outs outsh outshe outshee outsheet ovtest pac pac_7 palette parse parse_dissim pause pca pca_8 pca_display pca_estat pca_p pca_rotate pcamat pchart pchart_7 pchi pchi_7 pcorr pctile pentium pergram pergram_7 permute permute_8 personal peto_st pkcollapse pkcross pkequiv pkexamine pkexamine_7 pkshape pksumm pksumm_7 pl plo plot plugin pnorm pnorm_7 poisgof poiss_lf poiss_sw poisso_p poisson poisson_estat post postclose postfile postutil pperron pr prais prais_e prais_e2 prais_p predict predictnl preserve print pro prob probi probit probit_estat probit_p proc_time procoverlay procrustes procrustes_estat procrustes_p profiler prog progr progra program prop proportion prtest prtesti pwcorr pwd q\\s qby qbys qchi qchi_7 qladder qladder_7 qnorm qnorm_7 qqplot qqplot_7 qreg qreg_c qreg_p qreg_sw qu quadchk quantile quantile_7 que quer query range ranksum ratio rchart rchart_7 rcof recast reclink recode reg reg3 reg3_p regdw regr regre regre_p2 regres regres_p regress regress_estat regriv_p remap ren rena renam rename renpfix repeat replace report reshape restore ret retu retur return rm rmdir robvar roccomp roccomp_7 roccomp_8 rocf_lf rocfit rocfit_8 rocgold rocplot rocplot_7 roctab roctab_7 rolling rologit rologit_p rot rota rotat rotate rotatemat rreg rreg_p ru run runtest rvfplot rvfplot_7 rvpplot rvpplot_7 sa safesum sample sampsi sav save savedresults saveold sc sca scal scala scalar scatter scm_mine sco scob_lf scob_p scobi_sw scobit scor score scoreplot scoreplot_help scree screeplot screeplot_help sdtest sdtesti se search separate seperate serrbar serrbar_7 serset set set_defaults sfrancia sh she shel shell shewhart shewhart_7 signestimationsample signrank signtest simul simul_7 simulate simulate_8 sktest sleep slogit slogit_d2 slogit_p smooth snapspan so sor sort spearman spikeplot spikeplot_7 spikeplt spline_x split sqreg sqreg_p sret sretu sretur sreturn ssc st st_ct st_hc st_hcd st_hcd_sh st_is st_issys st_note st_promo st_set st_show st_smpl st_subid stack statsby statsby_8 stbase stci stci_7 stcox stcox_estat stcox_fr stcox_fr_ll stcox_p stcox_sw stcoxkm stcoxkm_7 stcstat stcurv stcurve stcurve_7 stdes stem stepwise stereg stfill stgen stir stjoin stmc stmh stphplot stphplot_7 stphtest stphtest_7 stptime strate strate_7 streg streg_sw streset sts sts_7 stset stsplit stsum sttocc sttoct stvary stweib su suest suest_8 sum summ summa summar summari summariz summarize sunflower sureg survcurv survsum svar svar_p svmat svy svy_disp svy_dreg svy_est svy_est_7 svy_estat svy_get svy_gnbreg_p svy_head svy_header svy_heckman_p svy_heckprob_p svy_intreg_p svy_ivreg_p svy_logistic_p svy_logit_p svy_mlogit_p svy_nbreg_p svy_ologit_p svy_oprobit_p svy_poisson_p svy_probit_p svy_regress_p svy_sub svy_sub_7 svy_x svy_x_7 svy_x_p svydes svydes_8 svygen svygnbreg svyheckman svyheckprob svyintreg svyintreg_7 svyintrg svyivreg svylc svylog_p svylogit svymarkout svymarkout_8 svymean svymlog svymlogit svynbreg svyolog svyologit svyoprob svyoprobit svyopts svypois svypois_7 svypoisson svyprobit svyprobt svyprop svyprop_7 svyratio svyreg svyreg_p svyregress svyset svyset_7 svyset_8 svytab svytab_7 svytest svytotal sw sw_8 swcnreg swcox swereg swilk swlogis swlogit swologit swoprbt swpois swprobit swqreg swtobit swweib symmetry symmi symplot symplot_7 syntax sysdescribe sysdir sysuse szroeter ta tab tab1 tab2 tab_or tabd tabdi tabdis tabdisp tabi table tabodds tabodds_7 tabstat tabu tabul tabula tabulat tabulate te tempfile tempname tempvar tes test testnl testparm teststd tetrachoric time_it timer tis tob tobi tobit tobit_p tobit_sw token tokeni tokeniz tokenize tostring total translate translator transmap treat_ll treatr_p treatreg trim trnb_cons trnb_mean trpoiss_d2 trunc_ll truncr_p truncreg tsappend tset tsfill tsline tsline_ex tsreport tsrevar tsrline tsset tssmooth tsunab ttest ttesti tut_chk tut_wait tutorial tw tware_st two twoway twoway__fpfit_serset twoway__function_gen twoway__histogram_gen twoway__ipoint_serset twoway__ipoints_serset twoway__kdensity_gen twoway__lfit_serset twoway__normgen_gen twoway__pci_serset twoway__qfit_serset twoway__scatteri_serset twoway__sunflower_gen twoway_ksm_serset ty typ type typeof u|0 unab unabbrev unabcmd update us use uselabel var var_mkcompanion var_p varbasic varfcast vargranger varirf varirf_add varirf_cgraph varirf_create varirf_ctable varirf_describe varirf_dir varirf_drop varirf_erase varirf_graph varirf_ograph varirf_rename varirf_set varirf_table varlist varlmar varnorm varsoc varstable varstable_w varstable_w2 varwle vce vec vec_fevd vec_mkphi vec_p vec_p_w vecirf_create veclmar veclmar_w vecnorm vecnorm_w vecrank vecstable verinst vers versi versio version view viewsource vif vwls wdatetof webdescribe webseek webuse weib1_lf weib2_lf weib_lf weib_lf0 weibhet_glf weibhet_glf_sh weibhet_glfa weibhet_glfa_sh weibhet_gp weibhet_ilf weibhet_ilf_sh weibhet_ilfa weibhet_ilfa_sh weibhet_ip weibu_sw weibul_p weibull weibull_c weibull_s weibullhet wh whelp whi which whil while wilc_st wilcoxon win wind windo window winexec wntestb wntestb_7 wntestq xchart xchart_7 xcorr xcorr_7 xi xi_6 xmlsav xmlsave xmluse xpose xsh xshe xshel xshell xt_iis xt_tis xtab_p xtabond xtbin_p xtclog xtcloglog xtcloglog_8 xtcloglog_d2 xtcloglog_pa_p xtcloglog_re_p xtcnt_p xtcorr xtdata xtdes xtfront_p xtfrontier xtgee xtgee_elink xtgee_estat xtgee_makeivar xtgee_p xtgee_plink xtgls xtgls_p xthaus xthausman xtht_p xthtaylor xtile xtint_p xtintreg xtintreg_8 xtintreg_d2 xtintreg_p xtivp_1 xtivp_2 xtivreg xtline xtline_ex xtlogit xtlogit_8 xtlogit_d2 xtlogit_fe_p xtlogit_pa_p xtlogit_re_p xtmixed xtmixed_estat xtmixed_p xtnb_fe xtnb_lf xtnbreg xtnbreg_pa_p xtnbreg_refe_p xtpcse xtpcse_p xtpois xtpoisson xtpoisson_d2 xtpoisson_pa_p xtpoisson_refe_p xtpred xtprobit xtprobit_8 xtprobit_d2 xtprobit_re_p xtps_fe xtps_lf xtps_ren xtps_ren_8 xtrar_p xtrc xtrc_p xtrchh xtrefe_p xtreg xtreg_be xtreg_fe xtreg_ml xtreg_pa_p xtreg_re xtregar xtrere_p xtset xtsf_ll xtsf_llti xtsum xttab xttest0 xttobit xttobit_8 xttobit_p xttrans yx yxview__barlike_draw yxview_area_draw yxview_bar_draw yxview_dot_draw yxview_dropline_draw yxview_function_draw yxview_iarrow_draw yxview_ilabels_draw yxview_normal_draw yxview_pcarrow_draw yxview_pcbarrow_draw yxview_pccapsym_draw yxview_pcscatter_draw yxview_pcspike_draw yxview_rarea_draw yxview_rbar_draw yxview_rbarm_draw yxview_rcap_draw yxview_rcapsym_draw yxview_rconnected_draw yxview_rline_draw yxview_rscatter_draw yxview_rspike_draw yxview_spike_draw yxview_sunflower_draw zap_s zinb zinb_llf zinb_plf zip zip_llf zip_p zip_plf zt_ct_5 zt_hc_5 zt_hcd_5 zt_is_5 zt_iss_5 zt_sho_5 zt_smp_5 ztbase_5 ztcox_5 ztdes_5 ztereg_5 ztfill_5 ztgen_5 ztir_5 ztjoin_5 ztnb ztnb_p ztp ztp_p zts_5 ztset_5 ztspli_5 ztsum_5 zttoct_5 ztvary_5 ztweib_5',
        contains: [
      {
        className: 'symbol',
        begin: /`[a-zA-Z0-9_]+'/
      },
      {
        className: 'variable',
        begin: /\$\{?[a-zA-Z0-9_]+\}?/
      },
      {
        className: 'string',
        variants: [
          {begin: '`"[^\r\n]*?"\''},
          {begin: '"[^\r\n"]*"'}
        ]
      },

      {
        className: 'built_in',
        variants: [
          {
            begin: '\\b(abs|acos|asin|atan|atan2|atanh|ceil|cloglog|comb|cos|digamma|exp|floor|invcloglog|invlogit|ln|lnfact|lnfactorial|lngamma|log|log10|max|min|mod|reldif|round|sign|sin|sqrt|sum|tan|tanh|trigamma|trunc|betaden|Binomial|binorm|binormal|chi2|chi2tail|dgammapda|dgammapdada|dgammapdadx|dgammapdx|dgammapdxdx|F|Fden|Ftail|gammaden|gammap|ibeta|invbinomial|invchi2|invchi2tail|invF|invFtail|invgammap|invibeta|invnchi2|invnFtail|invnibeta|invnorm|invnormal|invttail|nbetaden|nchi2|nFden|nFtail|nibeta|norm|normal|normalden|normd|npnchi2|tden|ttail|uniform|abbrev|char|index|indexnot|length|lower|ltrim|match|plural|proper|real|regexm|regexr|regexs|reverse|rtrim|string|strlen|strlower|strltrim|strmatch|strofreal|strpos|strproper|strreverse|strrtrim|strtrim|strupper|subinstr|subinword|substr|trim|upper|word|wordcount|_caller|autocode|byteorder|chop|clip|cond|e|epsdouble|epsfloat|group|inlist|inrange|irecode|matrix|maxbyte|maxdouble|maxfloat|maxint|maxlong|mi|minbyte|mindouble|minfloat|minint|minlong|missing|r|recode|replay|return|s|scalar|d|date|day|dow|doy|halfyear|mdy|month|quarter|week|year|d|daily|dofd|dofh|dofm|dofq|dofw|dofy|h|halfyearly|hofd|m|mofd|monthly|q|qofd|quarterly|tin|twithin|w|weekly|wofd|y|yearly|yh|ym|yofd|yq|yw|cholesky|colnumb|colsof|corr|det|diag|diag0cnt|el|get|hadamard|I|inv|invsym|issym|issymmetric|J|matmissing|matuniform|mreldif|nullmat|rownumb|rowsof|sweep|syminv|trace|vec|vecdiag)(?=\\(|$)'
          }
        ]
      },

      hljs.COMMENT('^[ \t]*\\*.*$', false),
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE
    ]
  };
};

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var STEP21_IDENT_RE = '[A-Z_][A-Z0-9_.]*';
  var STEP21_KEYWORDS = {
    keyword: 'HEADER ENDSEC DATA'
  };
  var STEP21_START = {
    className: 'meta',
    begin: 'ISO-10303-21;',
    relevance: 10
  };
  var STEP21_CLOSE = {
    className: 'meta',
    begin: 'END-ISO-10303-21;',
    relevance: 10
  };

  return {
    aliases: ['p21', 'step', 'stp'],
    case_insensitive: true, // STEP 21 is case insensitive in theory, in practice all non-comments are capitalized.
    lexemes: STEP21_IDENT_RE,
    keywords: STEP21_KEYWORDS,
    contains: [
      STEP21_START,
      STEP21_CLOSE,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.COMMENT('/\\*\\*!', '\\*/'),
      hljs.C_NUMBER_MODE,
      hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null}),
      {
        className: 'string',
        begin: "'", end: "'"
      },
      {
        className: 'symbol',
        variants: [
          {
            begin: '#', end: '\\d+',
            illegal: '\\W'
          }
        ]
      }
    ]
  };
};

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

module.exports = function(hljs) {

  var VARIABLE = {
    className: 'variable',
    begin: '\\$' + hljs.IDENT_RE
  };

  var HEX_COLOR = {
    className: 'number',
    begin: '#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})'
  };

  var AT_KEYWORDS = [
    'charset',
    'css',
    'debug',
    'extend',
    'font-face',
    'for',
    'import',
    'include',
    'media',
    'mixin',
    'page',
    'warn',
    'while'
  ];

  var PSEUDO_SELECTORS = [
    'after',
    'before',
    'first-letter',
    'first-line',
    'active',
    'first-child',
    'focus',
    'hover',
    'lang',
    'link',
    'visited'
  ];

  var TAGS = [
    'a',
    'abbr',
    'address',
    'article',
    'aside',
    'audio',
    'b',
    'blockquote',
    'body',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'dd',
    'del',
    'details',
    'dfn',
    'div',
    'dl',
    'dt',
    'em',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'header',
    'hgroup',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'label',
    'legend',
    'li',
    'mark',
    'menu',
    'nav',
    'object',
    'ol',
    'p',
    'q',
    'quote',
    'samp',
    'section',
    'span',
    'strong',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'tr',
    'ul',
    'var',
    'video'
  ];

  var TAG_END = '[\\.\\s\\n\\[\\:,]';

  var ATTRIBUTES = [
    'align-content',
    'align-items',
    'align-self',
    'animation',
    'animation-delay',
    'animation-direction',
    'animation-duration',
    'animation-fill-mode',
    'animation-iteration-count',
    'animation-name',
    'animation-play-state',
    'animation-timing-function',
    'auto',
    'backface-visibility',
    'background',
    'background-attachment',
    'background-clip',
    'background-color',
    'background-image',
    'background-origin',
    'background-position',
    'background-repeat',
    'background-size',
    'border',
    'border-bottom',
    'border-bottom-color',
    'border-bottom-left-radius',
    'border-bottom-right-radius',
    'border-bottom-style',
    'border-bottom-width',
    'border-collapse',
    'border-color',
    'border-image',
    'border-image-outset',
    'border-image-repeat',
    'border-image-slice',
    'border-image-source',
    'border-image-width',
    'border-left',
    'border-left-color',
    'border-left-style',
    'border-left-width',
    'border-radius',
    'border-right',
    'border-right-color',
    'border-right-style',
    'border-right-width',
    'border-spacing',
    'border-style',
    'border-top',
    'border-top-color',
    'border-top-left-radius',
    'border-top-right-radius',
    'border-top-style',
    'border-top-width',
    'border-width',
    'bottom',
    'box-decoration-break',
    'box-shadow',
    'box-sizing',
    'break-after',
    'break-before',
    'break-inside',
    'caption-side',
    'clear',
    'clip',
    'clip-path',
    'color',
    'column-count',
    'column-fill',
    'column-gap',
    'column-rule',
    'column-rule-color',
    'column-rule-style',
    'column-rule-width',
    'column-span',
    'column-width',
    'columns',
    'content',
    'counter-increment',
    'counter-reset',
    'cursor',
    'direction',
    'display',
    'empty-cells',
    'filter',
    'flex',
    'flex-basis',
    'flex-direction',
    'flex-flow',
    'flex-grow',
    'flex-shrink',
    'flex-wrap',
    'float',
    'font',
    'font-family',
    'font-feature-settings',
    'font-kerning',
    'font-language-override',
    'font-size',
    'font-size-adjust',
    'font-stretch',
    'font-style',
    'font-variant',
    'font-variant-ligatures',
    'font-weight',
    'height',
    'hyphens',
    'icon',
    'image-orientation',
    'image-rendering',
    'image-resolution',
    'ime-mode',
    'inherit',
    'initial',
    'justify-content',
    'left',
    'letter-spacing',
    'line-height',
    'list-style',
    'list-style-image',
    'list-style-position',
    'list-style-type',
    'margin',
    'margin-bottom',
    'margin-left',
    'margin-right',
    'margin-top',
    'marks',
    'mask',
    'max-height',
    'max-width',
    'min-height',
    'min-width',
    'nav-down',
    'nav-index',
    'nav-left',
    'nav-right',
    'nav-up',
    'none',
    'normal',
    'object-fit',
    'object-position',
    'opacity',
    'order',
    'orphans',
    'outline',
    'outline-color',
    'outline-offset',
    'outline-style',
    'outline-width',
    'overflow',
    'overflow-wrap',
    'overflow-x',
    'overflow-y',
    'padding',
    'padding-bottom',
    'padding-left',
    'padding-right',
    'padding-top',
    'page-break-after',
    'page-break-before',
    'page-break-inside',
    'perspective',
    'perspective-origin',
    'pointer-events',
    'position',
    'quotes',
    'resize',
    'right',
    'tab-size',
    'table-layout',
    'text-align',
    'text-align-last',
    'text-decoration',
    'text-decoration-color',
    'text-decoration-line',
    'text-decoration-style',
    'text-indent',
    'text-overflow',
    'text-rendering',
    'text-shadow',
    'text-transform',
    'text-underline-position',
    'top',
    'transform',
    'transform-origin',
    'transform-style',
    'transition',
    'transition-delay',
    'transition-duration',
    'transition-property',
    'transition-timing-function',
    'unicode-bidi',
    'vertical-align',
    'visibility',
    'white-space',
    'widows',
    'width',
    'word-break',
    'word-spacing',
    'word-wrap',
    'z-index'
  ];

  // illegals
  var ILLEGAL = [
    '\\?',
    '(\\bReturn\\b)', // monkey
    '(\\bEnd\\b)', // monkey
    '(\\bend\\b)', // vbscript
    '(\\bdef\\b)', // gradle
    ';', // a whole lot of languages
    '#\\s', // markdown
    '\\*\\s', // markdown
    '===\\s', // markdown
    '\\|',
    '%', // prolog
  ];

  return {
    aliases: ['styl'],
    case_insensitive: false,
    keywords: 'if else for in',
    illegal: '(' + ILLEGAL.join('|') + ')',
    contains: [

      // strings
      hljs.QUOTE_STRING_MODE,
      hljs.APOS_STRING_MODE,

      // comments
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,

      // hex colors
      HEX_COLOR,

      // class tag
      {
        begin: '\\.[a-zA-Z][a-zA-Z0-9_-]*' + TAG_END,
        returnBegin: true,
        contains: [
          {className: 'selector-class', begin: '\\.[a-zA-Z][a-zA-Z0-9_-]*'}
        ]
      },

      // id tag
      {
        begin: '\\#[a-zA-Z][a-zA-Z0-9_-]*' + TAG_END,
        returnBegin: true,
        contains: [
          {className: 'selector-id', begin: '\\#[a-zA-Z][a-zA-Z0-9_-]*'}
        ]
      },

      // tags
      {
        begin: '\\b(' + TAGS.join('|') + ')' + TAG_END,
        returnBegin: true,
        contains: [
          {className: 'selector-tag', begin: '\\b[a-zA-Z][a-zA-Z0-9_-]*'}
        ]
      },

      // psuedo selectors
      {
        begin: '&?:?:\\b(' + PSEUDO_SELECTORS.join('|') + ')' + TAG_END
      },

      // @ keywords
      {
        begin: '\@(' + AT_KEYWORDS.join('|') + ')\\b'
      },

      // variables
      VARIABLE,

      // dimension
      hljs.CSS_NUMBER_MODE,

      // number
      hljs.NUMBER_MODE,

      // functions
      //  - only from beginning of line + whitespace
      {
        className: 'function',
        begin: '^[a-zA-Z][a-zA-Z0-9_\-]*\\(.*\\)',
        illegal: '[\\n]',
        returnBegin: true,
        contains: [
          {className: 'title', begin: '\\b[a-zA-Z][a-zA-Z0-9_\-]*'},
          {
            className: 'params',
            begin: /\(/,
            end: /\)/,
            contains: [
              HEX_COLOR,
              VARIABLE,
              hljs.APOS_STRING_MODE,
              hljs.CSS_NUMBER_MODE,
              hljs.NUMBER_MODE,
              hljs.QUOTE_STRING_MODE
            ]
          }
        ]
      },

      // attributes
      //  - only from beginning of line + whitespace
      //  - must have whitespace after it
      {
        className: 'attribute',
        begin: '\\b(' + ATTRIBUTES.reverse().join('|') + ')\\b',
        starts: {
          // value container
          end: /;|$/,
          contains: [
            HEX_COLOR,
            VARIABLE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.CSS_NUMBER_MODE,
            hljs.NUMBER_MODE,
            hljs.C_BLOCK_COMMENT_MODE
          ],
          illegal: /\./,
          relevance: 0
        }
      }
    ]
  };
};

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var DETAILS = {
    className: 'string',
    begin: '\\[\n(multipart)?', end: '\\]\n'
  };
  var TIME = {
    className: 'string',
    begin: '\\d{4}-\\d{2}-\\d{2}(\\s+)\\d{2}:\\d{2}:\\d{2}\.\\d+Z'
  };
  var PROGRESSVALUE = {
    className: 'string',
    begin: '(\\+|-)\\d+'
  };
  var KEYWORDS = {
    className: 'keyword',
    relevance: 10,
    variants: [
      { begin: '^(test|testing|success|successful|failure|error|skip|xfail|uxsuccess)(:?)\\s+(test)?' },
      { begin: '^progress(:?)(\\s+)?(pop|push)?' },
      { begin: '^tags:' },
      { begin: '^time:' }
    ],
  };
  return {
    case_insensitive: true,
    contains: [
      DETAILS,
      TIME,
      PROGRESSVALUE,
      KEYWORDS
    ]
  };
};

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var SWIFT_KEYWORDS = {
      keyword: '__COLUMN__ __FILE__ __FUNCTION__ __LINE__ as as! as? associativity ' +
        'break case catch class continue convenience default defer deinit didSet do ' +
        'dynamic dynamicType else enum extension fallthrough false fileprivate final for func ' +
        'get guard if import in indirect infix init inout internal is lazy left let ' +
        'mutating nil none nonmutating open operator optional override postfix precedence ' +
        'prefix private protocol Protocol public repeat required rethrows return ' +
        'right self Self set static struct subscript super switch throw throws true ' +
        'try try! try? Type typealias unowned var weak where while willSet',
      literal: 'true false nil',
      built_in: 'abs advance alignof alignofValue anyGenerator assert assertionFailure ' +
        'bridgeFromObjectiveC bridgeFromObjectiveCUnconditional bridgeToObjectiveC ' +
        'bridgeToObjectiveCUnconditional c contains count countElements countLeadingZeros ' +
        'debugPrint debugPrintln distance dropFirst dropLast dump encodeBitsAsWords ' +
        'enumerate equal fatalError filter find getBridgedObjectiveCType getVaList ' +
        'indices insertionSort isBridgedToObjectiveC isBridgedVerbatimToObjectiveC ' +
        'isUniquelyReferenced isUniquelyReferencedNonObjC join lazy lexicographicalCompare ' +
        'map max maxElement min minElement numericCast overlaps partition posix ' +
        'precondition preconditionFailure print println quickSort readLine reduce reflect ' +
        'reinterpretCast reverse roundUpToAlignment sizeof sizeofValue sort split ' +
        'startsWith stride strideof strideofValue swap toString transcode ' +
        'underestimateCount unsafeAddressOf unsafeBitCast unsafeDowncast unsafeUnwrap ' +
        'unsafeReflect withExtendedLifetime withObjectAtPlusZero withUnsafePointer ' +
        'withUnsafePointerToObject withUnsafeMutablePointer withUnsafeMutablePointers ' +
        'withUnsafePointer withUnsafePointers withVaList zip'
    };

  var TYPE = {
    className: 'type',
    begin: '\\b[A-Z][\\w\u00C0-\u02B8\']*',
    relevance: 0
  };
  var BLOCK_COMMENT = hljs.COMMENT(
    '/\\*',
    '\\*/',
    {
      contains: ['self']
    }
  );
  var SUBST = {
    className: 'subst',
    begin: /\\\(/, end: '\\)',
    keywords: SWIFT_KEYWORDS,
    contains: [] // assigned later
  };
  var NUMBERS = {
      className: 'number',
      begin: '\\b([\\d_]+(\\.[\\deE_]+)?|0x[a-fA-F0-9_]+(\\.[a-fA-F0-9p_]+)?|0b[01_]+|0o[0-7_]+)\\b',
      relevance: 0
  };
  var QUOTE_STRING_MODE = hljs.inherit(hljs.QUOTE_STRING_MODE, {
    contains: [SUBST, hljs.BACKSLASH_ESCAPE]
  });
  SUBST.contains = [NUMBERS];

  return {
    keywords: SWIFT_KEYWORDS,
    contains: [
      QUOTE_STRING_MODE,
      hljs.C_LINE_COMMENT_MODE,
      BLOCK_COMMENT,
      TYPE,
      NUMBERS,
      {
        className: 'function',
        beginKeywords: 'func', end: '{', excludeEnd: true,
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {
            begin: /[A-Za-z$_][0-9A-Za-z$_]*/
          }),
          {
            begin: /</, end: />/
          },
          {
            className: 'params',
            begin: /\(/, end: /\)/, endsParent: true,
            keywords: SWIFT_KEYWORDS,
            contains: [
              'self',
              NUMBERS,
              QUOTE_STRING_MODE,
              hljs.C_BLOCK_COMMENT_MODE,
              {begin: ':'} // relevance booster
            ],
            illegal: /["']/
          }
        ],
        illegal: /\[|%/
      },
      {
        className: 'class',
        beginKeywords: 'struct protocol class extension enum',
        keywords: SWIFT_KEYWORDS,
        end: '\\{',
        excludeEnd: true,
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {begin: /[A-Za-z$_][\u00C0-\u02B80-9A-Za-z$_]*/})
        ]
      },
      {
        className: 'meta', // @attributes
        begin: '(@warn_unused_result|@exported|@lazy|@noescape|' +
                  '@NSCopying|@NSManaged|@objc|@convention|@required|' +
                  '@noreturn|@IBAction|@IBDesignable|@IBInspectable|@IBOutlet|' +
                  '@infix|@prefix|@postfix|@autoclosure|@testable|@available|' +
                  '@nonobjc|@NSApplicationMain|@UIApplicationMain)'

      },
      {
        beginKeywords: 'import', end: /$/,
        contains: [hljs.C_LINE_COMMENT_MODE, BLOCK_COMMENT]
      }
    ]
  };
};

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

module.exports = function(hljs) {

  var COMMENT = {
    className: 'comment',
    begin: /\$noop\(/,
    end: /\)/,
    contains: [{
      begin: /\(/,
      end: /\)/,
      contains: ['self', {
        begin: /\\./
      }]
    }],
    relevance: 10
  };

  var FUNCTION = {
    className: 'keyword',
    begin: /\$(?!noop)[a-zA-Z][_a-zA-Z0-9]*/,
    end: /\(/,
    excludeEnd: true
  };

  var VARIABLE = {
    className: 'variable',
    begin: /%[_a-zA-Z0-9:]*/,
    end: '%'
  };

  var ESCAPE_SEQUENCE = {
    className: 'symbol',
    begin: /\\./
  };

  return {
    contains: [
      COMMENT,
      FUNCTION,
      VARIABLE,
      ESCAPE_SEQUENCE
    ]
  };
};

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var LITERALS = 'true false yes no null';

  var keyPrefix = '^[ \\-]*';
  var keyName =  '[a-zA-Z_][\\w\\-]*';
  var KEY = {
    className: 'attr',
    variants: [
      { begin: keyPrefix + keyName + ":"},
      { begin: keyPrefix + '"' + keyName + '"' + ":"},
      { begin: keyPrefix + "'" + keyName + "'" + ":"}
    ]
  };

  var TEMPLATE_VARIABLES = {
    className: 'template-variable',
    variants: [
      { begin: '\{\{', end: '\}\}' }, // jinja templates Ansible
      { begin: '%\{', end: '\}' } // Ruby i18n
    ]
  };
  var STRING = {
    className: 'string',
    relevance: 0,
    variants: [
      {begin: /'/, end: /'/},
      {begin: /"/, end: /"/},
      {begin: /\S+/}
    ],
    contains: [
      hljs.BACKSLASH_ESCAPE,
      TEMPLATE_VARIABLES
    ]
  };

  return {
    case_insensitive: true,
    aliases: ['yml', 'YAML', 'yaml'],
    contains: [
      KEY,
      {
        className: 'meta',
        begin: '^---\s*$',
        relevance: 10
      },
      { // multi line string
        className: 'string',
        begin: '[\\|>] *$',
        returnEnd: true,
        contains: STRING.contains,
        // very simple termination: next hash key
        end: KEY.variants[0].begin
      },
      { // Ruby/Rails erb
        begin: '<%[%=-]?', end: '[%-]?%>',
        subLanguage: 'ruby',
        excludeBegin: true,
        excludeEnd: true,
        relevance: 0
      },
      { // data type
        className: 'type',
        begin: '!!' + hljs.UNDERSCORE_IDENT_RE,
      },
      { // fragment id &ref
        className: 'meta',
        begin: '&' + hljs.UNDERSCORE_IDENT_RE + '$',
      },
      { // fragment reference *ref
        className: 'meta',
        begin: '\\*' + hljs.UNDERSCORE_IDENT_RE + '$'
      },
      { // array listing
        className: 'bullet',
        begin: '^ *-',
        relevance: 0
      },
      hljs.HASH_COMMENT_MODE,
      {
        beginKeywords: LITERALS,
        keywords: {literal: LITERALS}
      },
      hljs.C_NUMBER_MODE,
      STRING
    ]
  };
};

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    case_insensitive: true,
    contains: [
      hljs.HASH_COMMENT_MODE,
      // version of format and total amount of testcases
      {
        className: 'meta',
        variants: [
          { begin: '^TAP version (\\d+)$' },
          { begin: '^1\\.\\.(\\d+)$' }
        ],
      },
      // YAML block
      {
        begin: '(\s+)?---$', end: '\\.\\.\\.$',
        subLanguage: 'yaml',
        relevance: 0
      },
	  // testcase number
      {
        className: 'number',
        begin: ' (\\d+) '
      },
	  // testcase status and description
      {
        className: 'symbol',
        variants: [
          { begin: '^ok' },
          { begin: '^not ok' }
        ],
      },
    ]
  };
};

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    aliases: ['tk'],
    keywords: 'after append apply array auto_execok auto_import auto_load auto_mkindex ' +
      'auto_mkindex_old auto_qualify auto_reset bgerror binary break catch cd chan clock ' +
      'close concat continue dde dict encoding eof error eval exec exit expr fblocked ' +
      'fconfigure fcopy file fileevent filename flush for foreach format gets glob global ' +
      'history http if incr info interp join lappend|10 lassign|10 lindex|10 linsert|10 list ' +
      'llength|10 load lrange|10 lrepeat|10 lreplace|10 lreverse|10 lsearch|10 lset|10 lsort|10 '+
      'mathfunc mathop memory msgcat namespace open package parray pid pkg::create pkg_mkIndex '+
      'platform platform::shell proc puts pwd read refchan regexp registry regsub|10 rename '+
      'return safe scan seek set socket source split string subst switch tcl_endOfWord '+
      'tcl_findLibrary tcl_startOfNextWord tcl_startOfPreviousWord tcl_wordBreakAfter '+
      'tcl_wordBreakBefore tcltest tclvars tell time tm trace unknown unload unset update '+
      'uplevel upvar variable vwait while',
    contains: [
      hljs.COMMENT(';[ \\t]*#', '$'),
      hljs.COMMENT('^[ \\t]*#', '$'),
      {
        beginKeywords: 'proc',
        end: '[\\{]',
        excludeEnd: true,
        contains: [
          {
            className: 'title',
            begin: '[ \\t\\n\\r]+(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*',
            end: '[ \\t\\n\\r]',
            endsWithParent: true,
            excludeEnd: true
          }
        ]
      },
      {
        excludeEnd: true,
        variants: [
          {
            begin: '\\$(\\{)?(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*\\(([a-zA-Z0-9_])*\\)',
            end: '[^a-zA-Z0-9_\\}\\$]'
          },
          {
            begin: '\\$(\\{)?(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*',
            end: '(\\))?[^a-zA-Z0-9_\\}\\$]'
          }
        ]
      },
      {
        className: 'string',
        contains: [hljs.BACKSLASH_ESCAPE],
        variants: [
          hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
          hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null})
        ]
      },
      {
        className: 'number',
        variants: [hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE]
      }
    ]
  }
};

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var COMMAND = {
    className: 'tag',
    begin: /\\/,
    relevance: 0,
    contains: [
      {
        className: 'name',
        variants: [
          {begin: /[a-zA-Zа-яА-я]+[*]?/},
          {begin: /[^a-zA-Zа-яА-я0-9]/}
        ],
        starts: {
          endsWithParent: true,
          relevance: 0,
          contains: [
            {
              className: 'string', // because it looks like attributes in HTML tags
              variants: [
                {begin: /\[/, end: /\]/},
                {begin: /\{/, end: /\}/}
              ]
            },
            {
              begin: /\s*=\s*/, endsWithParent: true,
              relevance: 0,
              contains: [
                {
                  className: 'number',
                  begin: /-?\d*\.?\d+(pt|pc|mm|cm|in|dd|cc|ex|em)?/
                }
              ]
            }
          ]
        }
      }
    ]
  };

  return {
    contains: [
      COMMAND,
      {
        className: 'formula',
        contains: [COMMAND],
        relevance: 0,
        variants: [
          {begin: /\$\$/, end: /\$\$/},
          {begin: /\$/, end: /\$/}
        ]
      },
      hljs.COMMENT(
        '%',
        '$',
        {
          relevance: 0
        }
      )
    ]
  };
};

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var BUILT_IN_TYPES = 'bool byte i16 i32 i64 double string binary';
  return {
    keywords: {
      keyword:
        'namespace const typedef struct enum service exception void oneway set list map required optional',
      built_in:
        BUILT_IN_TYPES,
      literal:
        'true false'
    },
    contains: [
      hljs.QUOTE_STRING_MODE,
      hljs.NUMBER_MODE,
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'class',
        beginKeywords: 'struct enum service exception', end: /\{/,
        illegal: /\n/,
        contains: [
          hljs.inherit(hljs.TITLE_MODE, {
            starts: {endsWithParent: true, excludeEnd: true} // hack: eating everything after the first title
          })
        ]
      },
      {
        begin: '\\b(set|list|map)\\s*<', end: '>',
        keywords: BUILT_IN_TYPES,
        contains: ['self']
      }
    ]
  };
};

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var TPID = {
    className: 'number',
    begin: '[1-9][0-9]*', /* no leading zeros */
    relevance: 0
  };
  var TPLABEL = {
    className: 'symbol',
    begin: ':[^\\]]+'
  };
  var TPDATA = {
    className: 'built_in',
    begin: '(AR|P|PAYLOAD|PR|R|SR|RSR|LBL|VR|UALM|MESSAGE|UTOOL|UFRAME|TIMER|\
    TIMER_OVERFLOW|JOINT_MAX_SPEED|RESUME_PROG|DIAG_REC)\\[', end: '\\]',
    contains: [
      'self',
      TPID,
      TPLABEL
    ]
  };
  var TPIO = {
    className: 'built_in',
    begin: '(AI|AO|DI|DO|F|RI|RO|UI|UO|GI|GO|SI|SO)\\[', end: '\\]',
    contains: [
      'self',
      TPID,
      hljs.QUOTE_STRING_MODE, /* for pos section at bottom */
      TPLABEL
    ]
  };

  return {
    keywords: {
      keyword:
        'ABORT ACC ADJUST AND AP_LD BREAK CALL CNT COL CONDITION CONFIG DA DB ' +
        'DIV DETECT ELSE END ENDFOR ERR_NUM ERROR_PROG FINE FOR GP GUARD INC ' +
        'IF JMP LINEAR_MAX_SPEED LOCK MOD MONITOR OFFSET Offset OR OVERRIDE ' +
        'PAUSE PREG PTH RT_LD RUN SELECT SKIP Skip TA TB TO TOOL_OFFSET ' +
        'Tool_Offset UF UT UFRAME_NUM UTOOL_NUM UNLOCK WAIT X Y Z W P R STRLEN ' +
        'SUBSTR FINDSTR VOFFSET PROG ATTR MN POS',
      literal:
        'ON OFF max_speed LPOS JPOS ENABLE DISABLE START STOP RESET'
    },
    contains: [
      TPDATA,
      TPIO,
      {
        className: 'keyword',
        begin: '/(PROG|ATTR|MN|POS|END)\\b'
      },
      {
        /* this is for cases like ,CALL */
        className: 'keyword',
        begin: '(CALL|RUN|POINT_LOGIC|LBL)\\b'
      },
      {
        /* this is for cases like CNT100 where the default lexemes do not
         * separate the keyword and the number */
        className: 'keyword',
        begin: '\\b(ACC|CNT|Skip|Offset|PSPD|RT_LD|AP_LD|Tool_Offset)'
      },
      {
        /* to catch numbers that do not have a word boundary on the left */
        className: 'number',
        begin: '\\d+(sec|msec|mm/sec|cm/min|inch/min|deg/sec|mm|in|cm)?\\b',
        relevance: 0
      },
      hljs.COMMENT('//', '[;$]'),
      hljs.COMMENT('!', '[;$]'),
      hljs.COMMENT('--eg:', '$'),
      hljs.QUOTE_STRING_MODE,
      {
        className: 'string',
        begin: '\'', end: '\''
      },
      hljs.C_NUMBER_MODE,
      {
        className: 'variable',
        begin: '\\$[A-Za-z0-9_]+'
      }
    ]
  };
};

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var PARAMS = {
    className: 'params',
    begin: '\\(', end: '\\)'
  };

  var FUNCTION_NAMES = 'attribute block constant cycle date dump include ' +
                  'max min parent random range source template_from_string';

  var FUNCTIONS = {
    beginKeywords: FUNCTION_NAMES,
    keywords: {name: FUNCTION_NAMES},
    relevance: 0,
    contains: [
      PARAMS
    ]
  };

  var FILTER = {
    begin: /\|[A-Za-z_]+:?/,
    keywords:
      'abs batch capitalize convert_encoding date date_modify default ' +
      'escape first format join json_encode keys last length lower ' +
      'merge nl2br number_format raw replace reverse round slice sort split ' +
      'striptags title trim upper url_encode',
    contains: [
      FUNCTIONS
    ]
  };

  var TAGS = 'autoescape block do embed extends filter flush for ' +
    'if import include macro sandbox set spaceless use verbatim';

  TAGS = TAGS + ' ' + TAGS.split(' ').map(function(t){return 'end' + t}).join(' ');

  return {
    aliases: ['craftcms'],
    case_insensitive: true,
    subLanguage: 'xml',
    contains: [
      hljs.COMMENT(/\{#/, /#}/),
      {
        className: 'template-tag',
        begin: /\{%/, end: /%}/,
        contains: [
          {
            className: 'name',
            begin: /\w+/,
            keywords: TAGS,
            starts: {
              endsWithParent: true,
              contains: [FILTER, FUNCTIONS],
              relevance: 0
            }
          }
        ]
      },
      {
        className: 'template-variable',
        begin: /\{\{/, end: /}}/,
        contains: ['self', FILTER, FUNCTIONS]
      }
    ]
  };
};

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var KEYWORDS = {
    keyword:
      'in if for while finally var new function do return void else break catch ' +
      'instanceof with throw case default try this switch continue typeof delete ' +
      'let yield const class public private protected get set super ' +
      'static implements enum export import declare type namespace abstract ' +
      'as from extends async await',
    literal:
      'true false null undefined NaN Infinity',
    built_in:
      'eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent ' +
      'encodeURI encodeURIComponent escape unescape Object Function Boolean Error ' +
      'EvalError InternalError RangeError ReferenceError StopIteration SyntaxError ' +
      'TypeError URIError Number Math Date String RegExp Array Float32Array ' +
      'Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array ' +
      'Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require ' +
      'module console window document any number boolean string void Promise'
  };

  return {
    aliases: ['ts'],
    keywords: KEYWORDS,
    contains: [
      {
        className: 'meta',
        begin: /^\s*['"]use strict['"]/
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      { // template string
        className: 'string',
        begin: '`', end: '`',
        contains: [
          hljs.BACKSLASH_ESCAPE,
          {
            className: 'subst',
            begin: '\\$\\{', end: '\\}'
          }
        ]
      },
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'number',
        variants: [
          { begin: '\\b(0[bB][01]+)' },
          { begin: '\\b(0[oO][0-7]+)' },
          { begin: hljs.C_NUMBER_RE }
        ],
        relevance: 0
      },
      { // "value" container
        begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
        keywords: 'return throw case',
        contains: [
          hljs.C_LINE_COMMENT_MODE,
          hljs.C_BLOCK_COMMENT_MODE,
          hljs.REGEXP_MODE,
          {
            className: 'function',
            begin: '(\\(.*?\\)|' + hljs.IDENT_RE + ')\\s*=>', returnBegin: true,
            end: '\\s*=>',
            contains: [
              {
                className: 'params',
                variants: [
                  {
                    begin: hljs.IDENT_RE
                  },
                  {
                    begin: /\(\s*\)/,
                  },
                  {
                    begin: /\(/, end: /\)/,
                    excludeBegin: true, excludeEnd: true,
                    keywords: KEYWORDS,
                    contains: [
                      'self',
                      hljs.C_LINE_COMMENT_MODE,
                      hljs.C_BLOCK_COMMENT_MODE
                    ]
                  }
                ]
              }
            ]
          }
        ],
        relevance: 0
      },
      {
        className: 'function',
        begin: 'function', end: /[\{;]/, excludeEnd: true,
        keywords: KEYWORDS,
        contains: [
          'self',
          hljs.inherit(hljs.TITLE_MODE, {begin: /[A-Za-z$_][0-9A-Za-z$_]*/}),
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            excludeBegin: true,
            excludeEnd: true,
            keywords: KEYWORDS,
            contains: [
              hljs.C_LINE_COMMENT_MODE,
              hljs.C_BLOCK_COMMENT_MODE
            ],
            illegal: /["'\(]/
          }
        ],
        illegal: /%/,
        relevance: 0 // () => {} is more typical in TypeScript
      },
      {
        beginKeywords: 'constructor', end: /\{/, excludeEnd: true,
        contains: [
          'self',
          {
            className: 'params',
            begin: /\(/, end: /\)/,
            excludeBegin: true,
            excludeEnd: true,
            keywords: KEYWORDS,
            contains: [
              hljs.C_LINE_COMMENT_MODE,
              hljs.C_BLOCK_COMMENT_MODE
            ],
            illegal: /["'\(]/
          }
        ]
      },
      { // prevent references like module.id from being higlighted as module definitions
        begin: /module\./,
        keywords: {built_in: 'module'},
        relevance: 0
      },
      {
        beginKeywords: 'module', end: /\{/, excludeEnd: true
      },
      {
        beginKeywords: 'interface', end: /\{/, excludeEnd: true,
        keywords: 'interface extends'
      },
      {
        begin: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
      },
      {
        begin: '\\.' + hljs.IDENT_RE, relevance: 0 // hack: prevents detection of keywords after dots
      },
      {
        className: 'meta', begin: '@[A-Za-z]+'
      }
    ]
  };
};

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    keywords: {
      keyword:
        // Value types
        'char uchar unichar int uint long ulong short ushort int8 int16 int32 int64 uint8 ' +
        'uint16 uint32 uint64 float double bool struct enum string void ' +
        // Reference types
        'weak unowned owned ' +
        // Modifiers
        'async signal static abstract interface override virtual delegate ' +
        // Control Structures
        'if while do for foreach else switch case break default return try catch ' +
        // Visibility
        'public private protected internal ' +
        // Other
        'using new this get set const stdout stdin stderr var',
      built_in:
        'DBus GLib CCode Gee Object Gtk Posix',
      literal:
        'false true null'
    },
    contains: [
      {
        className: 'class',
        beginKeywords: 'class interface namespace', end: '{', excludeEnd: true,
        illegal: '[^,:\\n\\s\\.]',
        contains: [
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      hljs.C_LINE_COMMENT_MODE,
      hljs.C_BLOCK_COMMENT_MODE,
      {
        className: 'string',
        begin: '"""', end: '"""',
        relevance: 5
      },
      hljs.APOS_STRING_MODE,
      hljs.QUOTE_STRING_MODE,
      hljs.C_NUMBER_MODE,
      {
        className: 'meta',
        begin: '^#', end: '$',
        relevance: 2
      }
    ]
  };
};

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    aliases: ['vb'],
    case_insensitive: true,
    keywords: {
      keyword:
        'addhandler addressof alias and andalso aggregate ansi as assembly auto binary by byref byval ' + /* a-b */
        'call case catch class compare const continue custom declare default delegate dim distinct do ' + /* c-d */
        'each equals else elseif end enum erase error event exit explicit finally for friend from function ' + /* e-f */
        'get global goto group handles if implements imports in inherits interface into is isfalse isnot istrue ' + /* g-i */
        'join key let lib like loop me mid mod module mustinherit mustoverride mybase myclass ' + /* j-m */
        'namespace narrowing new next not notinheritable notoverridable ' + /* n */
        'of off on operator option optional or order orelse overloads overridable overrides ' + /* o */
        'paramarray partial preserve private property protected public ' + /* p */
        'raiseevent readonly redim rem removehandler resume return ' + /* r */
        'select set shadows shared skip static step stop structure strict sub synclock ' + /* s */
        'take text then throw to try unicode until using when where while widening with withevents writeonly xor', /* t-x */
      built_in:
        'boolean byte cbool cbyte cchar cdate cdec cdbl char cint clng cobj csbyte cshort csng cstr ctype ' +  /* b-c */
        'date decimal directcast double gettype getxmlnamespace iif integer long object ' + /* d-o */
        'sbyte short single string trycast typeof uinteger ulong ushort', /* s-u */
      literal:
        'true false nothing'
    },
    illegal: '//|{|}|endif|gosub|variant|wend', /* reserved deprecated keywords */
    contains: [
      hljs.inherit(hljs.QUOTE_STRING_MODE, {contains: [{begin: '""'}]}),
      hljs.COMMENT(
        '\'',
        '$',
        {
          returnBegin: true,
          contains: [
            {
              className: 'doctag',
              begin: '\'\'\'|<!--|-->',
              contains: [hljs.PHRASAL_WORDS_MODE]
            },
            {
              className: 'doctag',
              begin: '</?', end: '>',
              contains: [hljs.PHRASAL_WORDS_MODE]
            }
          ]
        }
      ),
      hljs.C_NUMBER_MODE,
      {
        className: 'meta',
        begin: '#', end: '$',
        keywords: {'meta-keyword': 'if else elseif end region externalsource'}
      }
    ]
  };
};

/***/ }),
/* 1109 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    aliases: ['vbs'],
    case_insensitive: true,
    keywords: {
      keyword:
        'call class const dim do loop erase execute executeglobal exit for each next function ' +
        'if then else on error option explicit new private property let get public randomize ' +
        'redim rem select case set stop sub while wend with end to elseif is or xor and not ' +
        'class_initialize class_terminate default preserve in me byval byref step resume goto',
      built_in:
        'lcase month vartype instrrev ubound setlocale getobject rgb getref string ' +
        'weekdayname rnd dateadd monthname now day minute isarray cbool round formatcurrency ' +
        'conversions csng timevalue second year space abs clng timeserial fixs len asc ' +
        'isempty maths dateserial atn timer isobject filter weekday datevalue ccur isdate ' +
        'instr datediff formatdatetime replace isnull right sgn array snumeric log cdbl hex ' +
        'chr lbound msgbox ucase getlocale cos cdate cbyte rtrim join hour oct typename trim ' +
        'strcomp int createobject loadpicture tan formatnumber mid scriptenginebuildversion ' +
        'scriptengine split scriptengineminorversion cint sin datepart ltrim sqr ' +
        'scriptenginemajorversion time derived eval date formatpercent exp inputbox left ascw ' +
        'chrw regexp server response request cstr err',
      literal:
        'true false null nothing empty'
    },
    illegal: '//',
    contains: [
      hljs.inherit(hljs.QUOTE_STRING_MODE, {contains: [{begin: '""'}]}),
      hljs.COMMENT(
        /'/,
        /$/,
        {
          relevance: 0
        }
      ),
      hljs.C_NUMBER_MODE
    ]
  };
};

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    subLanguage: 'xml',
    contains: [
      {
        begin: '<%', end: '%>',
        subLanguage: 'vbscript'
      }
    ]
  };
};

/***/ }),
/* 1111 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var SV_KEYWORDS = {
    keyword:
      'accept_on alias always always_comb always_ff always_latch and assert assign ' +
      'assume automatic before begin bind bins binsof bit break buf|0 bufif0 bufif1 ' +
      'byte case casex casez cell chandle checker class clocking cmos config const ' +
      'constraint context continue cover covergroup coverpoint cross deassign default ' +
      'defparam design disable dist do edge else end endcase endchecker endclass ' +
      'endclocking endconfig endfunction endgenerate endgroup endinterface endmodule ' +
      'endpackage endprimitive endprogram endproperty endspecify endsequence endtable ' +
      'endtask enum event eventually expect export extends extern final first_match for ' +
      'force foreach forever fork forkjoin function generate|5 genvar global highz0 highz1 ' +
      'if iff ifnone ignore_bins illegal_bins implements implies import incdir include ' +
      'initial inout input inside instance int integer interconnect interface intersect ' +
      'join join_any join_none large let liblist library local localparam logic longint ' +
      'macromodule matches medium modport module nand negedge nettype new nexttime nmos ' +
      'nor noshowcancelled not notif0 notif1 or output package packed parameter pmos ' +
      'posedge primitive priority program property protected pull0 pull1 pulldown pullup ' +
      'pulsestyle_ondetect pulsestyle_onevent pure rand randc randcase randsequence rcmos ' +
      'real realtime ref reg reject_on release repeat restrict return rnmos rpmos rtran ' +
      'rtranif0 rtranif1 s_always s_eventually s_nexttime s_until s_until_with scalared ' +
      'sequence shortint shortreal showcancelled signed small soft solve specify specparam ' +
      'static string strong strong0 strong1 struct super supply0 supply1 sync_accept_on ' +
      'sync_reject_on table tagged task this throughout time timeprecision timeunit tran ' +
      'tranif0 tranif1 tri tri0 tri1 triand trior trireg type typedef union unique unique0 ' +
      'unsigned until until_with untyped use uwire var vectored virtual void wait wait_order ' +
      'wand weak weak0 weak1 while wildcard wire with within wor xnor xor',
    literal:
      'null',
    built_in:
      '$finish $stop $exit $fatal $error $warning $info $realtime $time $printtimescale ' +
      '$bitstoreal $bitstoshortreal $itor $signed $cast $bits $stime $timeformat ' +
      '$realtobits $shortrealtobits $rtoi $unsigned $asserton $assertkill $assertpasson ' +
      '$assertfailon $assertnonvacuouson $assertoff $assertcontrol $assertpassoff ' +
      '$assertfailoff $assertvacuousoff $isunbounded $sampled $fell $changed $past_gclk ' +
      '$fell_gclk $changed_gclk $rising_gclk $steady_gclk $coverage_control ' +
      '$coverage_get $coverage_save $set_coverage_db_name $rose $stable $past ' +
      '$rose_gclk $stable_gclk $future_gclk $falling_gclk $changing_gclk $display ' +
      '$coverage_get_max $coverage_merge $get_coverage $load_coverage_db $typename ' +
      '$unpacked_dimensions $left $low $increment $clog2 $ln $log10 $exp $sqrt $pow ' +
      '$floor $ceil $sin $cos $tan $countbits $onehot $isunknown $fatal $warning ' +
      '$dimensions $right $high $size $asin $acos $atan $atan2 $hypot $sinh $cosh ' +
      '$tanh $asinh $acosh $atanh $countones $onehot0 $error $info $random ' +
      '$dist_chi_square $dist_erlang $dist_exponential $dist_normal $dist_poisson ' +
      '$dist_t $dist_uniform $q_initialize $q_remove $q_exam $async$and$array ' +
      '$async$nand$array $async$or$array $async$nor$array $sync$and$array ' +
      '$sync$nand$array $sync$or$array $sync$nor$array $q_add $q_full $psprintf ' +
      '$async$and$plane $async$nand$plane $async$or$plane $async$nor$plane ' +
      '$sync$and$plane $sync$nand$plane $sync$or$plane $sync$nor$plane $system ' +
      '$display $displayb $displayh $displayo $strobe $strobeb $strobeh $strobeo ' +
      '$write $readmemb $readmemh $writememh $value$plusargs ' +
      '$dumpvars $dumpon $dumplimit $dumpports $dumpportson $dumpportslimit ' +
      '$writeb $writeh $writeo $monitor $monitorb $monitorh $monitoro $writememb ' +
      '$dumpfile $dumpoff $dumpall $dumpflush $dumpportsoff $dumpportsall ' +
      '$dumpportsflush $fclose $fdisplay $fdisplayb $fdisplayh $fdisplayo ' +
      '$fstrobe $fstrobeb $fstrobeh $fstrobeo $swrite $swriteb $swriteh ' +
      '$swriteo $fscanf $fread $fseek $fflush $feof $fopen $fwrite $fwriteb ' +
      '$fwriteh $fwriteo $fmonitor $fmonitorb $fmonitorh $fmonitoro $sformat ' +
      '$sformatf $fgetc $ungetc $fgets $sscanf $rewind $ftell $ferror'
    };
  return {
    aliases: ['v', 'sv', 'svh'],
    case_insensitive: false,
    keywords: SV_KEYWORDS, lexemes: /[\w\$]+/,
    contains: [
      hljs.C_BLOCK_COMMENT_MODE,
      hljs.C_LINE_COMMENT_MODE,
      hljs.QUOTE_STRING_MODE,
      {
        className: 'number',
        contains: [hljs.BACKSLASH_ESCAPE],
        variants: [
          {begin: '\\b((\\d+\'(b|h|o|d|B|H|O|D))[0-9xzXZa-fA-F_]+)'},
          {begin: '\\B((\'(b|h|o|d|B|H|O|D))[0-9xzXZa-fA-F_]+)'},
          {begin: '\\b([0-9_])+', relevance: 0}
        ]
      },
      /* parameters to instances */
      {
        className: 'variable',
        variants: [
          {begin: '#\\((?!parameter).+\\)'},
          {begin: '\\.\\w+', relevance: 0},
        ]
      },
      {
        className: 'meta',
        begin: '`', end: '$',
        keywords: {'meta-keyword': 'define __FILE__ ' +
          '__LINE__ begin_keywords celldefine default_nettype define ' +
          'else elsif end_keywords endcelldefine endif ifdef ifndef ' +
          'include line nounconnected_drive pragma resetall timescale ' +
          'unconnected_drive undef undefineall'},
        relevance: 0
      }
    ]
  }; // return
};

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  // Regular expression for VHDL numeric literals.

  // Decimal literal:
  var INTEGER_RE = '\\d(_|\\d)*';
  var EXPONENT_RE = '[eE][-+]?' + INTEGER_RE;
  var DECIMAL_LITERAL_RE = INTEGER_RE + '(\\.' + INTEGER_RE + ')?' + '(' + EXPONENT_RE + ')?';
  // Based literal:
  var BASED_INTEGER_RE = '\\w+';
  var BASED_LITERAL_RE = INTEGER_RE + '#' + BASED_INTEGER_RE + '(\\.' + BASED_INTEGER_RE + ')?' + '#' + '(' + EXPONENT_RE + ')?';

  var NUMBER_RE = '\\b(' + BASED_LITERAL_RE + '|' + DECIMAL_LITERAL_RE + ')';

  return {
    case_insensitive: true,
    keywords: {
      keyword:
        'abs access after alias all and architecture array assert assume assume_guarantee attribute ' +
        'begin block body buffer bus case component configuration constant context cover disconnect ' +
        'downto default else elsif end entity exit fairness file for force function generate ' +
        'generic group guarded if impure in inertial inout is label library linkage literal ' +
        'loop map mod nand new next nor not null of on open or others out package port ' +
        'postponed procedure process property protected pure range record register reject ' +
        'release rem report restrict restrict_guarantee return rol ror select sequence ' +
        'severity shared signal sla sll sra srl strong subtype then to transport type ' +
        'unaffected units until use variable vmode vprop vunit wait when while with xnor xor',
      built_in:
        'boolean bit character ' +
        'integer time delay_length natural positive ' +
        'string bit_vector file_open_kind file_open_status ' +
        'std_logic std_logic_vector unsigned signed boolean_vector integer_vector ' +
        'std_ulogic std_ulogic_vector unresolved_unsigned u_unsigned unresolved_signed u_signed' +
        'real_vector time_vector',
      literal:
        'false true note warning error failure ' +  // severity_level
        'line text side width'                      // textio
    },
    illegal: '{',
    contains: [
      hljs.C_BLOCK_COMMENT_MODE,      // VHDL-2008 block commenting.
      hljs.COMMENT('--', '$'),
      hljs.QUOTE_STRING_MODE,
      {
        className: 'number',
        begin: NUMBER_RE,
        relevance: 0
      },
      {
        className: 'string',
        begin: '\'(U|X|0|1|Z|W|L|H|-)\'',
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      {
        className: 'symbol',
        begin: '\'[A-Za-z](_?[A-Za-z0-9])*',
        contains: [hljs.BACKSLASH_ESCAPE]
      }
    ]
  };
};

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    lexemes: /[!#@\w]+/,
    keywords: {
      keyword:
        // express version except: ! & * < = > !! # @ @@
        'N|0 P|0 X|0 a|0 ab abc abo al am an|0 ar arga argd arge argdo argg argl argu as au aug aun b|0 bN ba bad bd be bel bf bl bm bn bo bp br brea breaka breakd breakl bro bufdo buffers bun bw c|0 cN cNf ca cabc caddb cad caddf cal cat cb cc ccl cd ce cex cf cfir cgetb cgete cg changes chd che checkt cl cla clo cm cmapc cme cn cnew cnf cno cnorea cnoreme co col colo com comc comp con conf cope '+
        'cp cpf cq cr cs cst cu cuna cunme cw delm deb debugg delc delf dif diffg diffo diffp diffpu diffs diffthis dig di dl dell dj dli do doautoa dp dr ds dsp e|0 ea ec echoe echoh echom echon el elsei em en endfo endf endt endw ene ex exe exi exu f|0 files filet fin fina fini fir fix fo foldc foldd folddoc foldo for fu go gr grepa gu gv ha helpf helpg helpt hi hid his ia iabc if ij il im imapc '+
        'ime ino inorea inoreme int is isp iu iuna iunme j|0 ju k|0 keepa kee keepj lN lNf l|0 lad laddb laddf la lan lat lb lc lch lcl lcs le lefta let lex lf lfir lgetb lgete lg lgr lgrepa lh ll lla lli lmak lm lmapc lne lnew lnf ln loadk lo loc lockv lol lope lp lpf lr ls lt lu lua luad luaf lv lvimgrepa lw m|0 ma mak map mapc marks mat me menut mes mk mks mksp mkv mkvie mod mz mzf nbc nb nbs new nm nmapc nme nn nnoreme noa no noh norea noreme norm nu nun nunme ol o|0 om omapc ome on ono onoreme opt ou ounme ow p|0 '+
        'profd prof pro promptr pc ped pe perld po popu pp pre prev ps pt ptN ptf ptj ptl ptn ptp ptr pts pu pw py3 python3 py3d py3f py pyd pyf quita qa rec red redi redr redraws reg res ret retu rew ri rightb rub rubyd rubyf rund ru rv sN san sa sal sav sb sbN sba sbf sbl sbm sbn sbp sbr scrip scripte scs se setf setg setl sf sfir sh sim sig sil sl sla sm smap smapc sme sn sni sno snor snoreme sor '+
        'so spelld spe spelli spellr spellu spellw sp spr sre st sta startg startr star stopi stj sts sun sunm sunme sus sv sw sy synti sync tN tabN tabc tabdo tabe tabf tabfir tabl tabm tabnew '+
        'tabn tabo tabp tabr tabs tab ta tags tc tcld tclf te tf th tj tl tm tn to tp tr try ts tu u|0 undoj undol una unh unl unlo unm unme uns up ve verb vert vim vimgrepa vi viu vie vm vmapc vme vne vn vnoreme vs vu vunme windo w|0 wN wa wh wi winc winp wn wp wq wqa ws wu wv x|0 xa xmapc xm xme xn xnoreme xu xunme y|0 z|0 ~ '+
        // full version
        'Next Print append abbreviate abclear aboveleft all amenu anoremenu args argadd argdelete argedit argglobal arglocal argument ascii autocmd augroup aunmenu buffer bNext ball badd bdelete behave belowright bfirst blast bmodified bnext botright bprevious brewind break breakadd breakdel breaklist browse bunload '+
        'bwipeout change cNext cNfile cabbrev cabclear caddbuffer caddexpr caddfile call catch cbuffer cclose center cexpr cfile cfirst cgetbuffer cgetexpr cgetfile chdir checkpath checktime clist clast close cmap cmapclear cmenu cnext cnewer cnfile cnoremap cnoreabbrev cnoremenu copy colder colorscheme command comclear compiler continue confirm copen cprevious cpfile cquit crewind cscope cstag cunmap '+
        'cunabbrev cunmenu cwindow delete delmarks debug debuggreedy delcommand delfunction diffupdate diffget diffoff diffpatch diffput diffsplit digraphs display deletel djump dlist doautocmd doautoall deletep drop dsearch dsplit edit earlier echo echoerr echohl echomsg else elseif emenu endif endfor '+
        'endfunction endtry endwhile enew execute exit exusage file filetype find finally finish first fixdel fold foldclose folddoopen folddoclosed foldopen function global goto grep grepadd gui gvim hardcopy help helpfind helpgrep helptags highlight hide history insert iabbrev iabclear ijump ilist imap '+
        'imapclear imenu inoremap inoreabbrev inoremenu intro isearch isplit iunmap iunabbrev iunmenu join jumps keepalt keepmarks keepjumps lNext lNfile list laddexpr laddbuffer laddfile last language later lbuffer lcd lchdir lclose lcscope left leftabove lexpr lfile lfirst lgetbuffer lgetexpr lgetfile lgrep lgrepadd lhelpgrep llast llist lmake lmap lmapclear lnext lnewer lnfile lnoremap loadkeymap loadview '+
        'lockmarks lockvar lolder lopen lprevious lpfile lrewind ltag lunmap luado luafile lvimgrep lvimgrepadd lwindow move mark make mapclear match menu menutranslate messages mkexrc mksession mkspell mkvimrc mkview mode mzscheme mzfile nbclose nbkey nbsart next nmap nmapclear nmenu nnoremap '+
        'nnoremenu noautocmd noremap nohlsearch noreabbrev noremenu normal number nunmap nunmenu oldfiles open omap omapclear omenu only onoremap onoremenu options ounmap ounmenu ownsyntax print profdel profile promptfind promptrepl pclose pedit perl perldo pop popup ppop preserve previous psearch ptag ptNext '+
        'ptfirst ptjump ptlast ptnext ptprevious ptrewind ptselect put pwd py3do py3file python pydo pyfile quit quitall qall read recover redo redir redraw redrawstatus registers resize retab return rewind right rightbelow ruby rubydo rubyfile rundo runtime rviminfo substitute sNext sandbox sargument sall saveas sbuffer sbNext sball sbfirst sblast sbmodified sbnext sbprevious sbrewind scriptnames scriptencoding '+
        'scscope set setfiletype setglobal setlocal sfind sfirst shell simalt sign silent sleep slast smagic smapclear smenu snext sniff snomagic snoremap snoremenu sort source spelldump spellgood spellinfo spellrepall spellundo spellwrong split sprevious srewind stop stag startgreplace startreplace '+
        'startinsert stopinsert stjump stselect sunhide sunmap sunmenu suspend sview swapname syntax syntime syncbind tNext tabNext tabclose tabedit tabfind tabfirst tablast tabmove tabnext tabonly tabprevious tabrewind tag tcl tcldo tclfile tearoff tfirst throw tjump tlast tmenu tnext topleft tprevious '+'trewind tselect tunmenu undo undojoin undolist unabbreviate unhide unlet unlockvar unmap unmenu unsilent update vglobal version verbose vertical vimgrep vimgrepadd visual viusage view vmap vmapclear vmenu vnew '+
        'vnoremap vnoremenu vsplit vunmap vunmenu write wNext wall while winsize wincmd winpos wnext wprevious wqall wsverb wundo wviminfo xit xall xmapclear xmap xmenu xnoremap xnoremenu xunmap xunmenu yank',
      built_in: //built in func
        'synIDtrans atan2 range matcharg did_filetype asin feedkeys xor argv ' +
        'complete_check add getwinposx getqflist getwinposy screencol ' +
        'clearmatches empty extend getcmdpos mzeval garbagecollect setreg ' +
        'ceil sqrt diff_hlID inputsecret get getfperm getpid filewritable ' +
        'shiftwidth max sinh isdirectory synID system inputrestore winline ' +
        'atan visualmode inputlist tabpagewinnr round getregtype mapcheck ' +
        'hasmapto histdel argidx findfile sha256 exists toupper getcmdline ' +
        'taglist string getmatches bufnr strftime winwidth bufexists ' +
        'strtrans tabpagebuflist setcmdpos remote_read printf setloclist ' +
        'getpos getline bufwinnr float2nr len getcmdtype diff_filler luaeval ' +
        'resolve libcallnr foldclosedend reverse filter has_key bufname ' +
        'str2float strlen setline getcharmod setbufvar index searchpos ' +
        'shellescape undofile foldclosed setqflist buflisted strchars str2nr ' +
        'virtcol floor remove undotree remote_expr winheight gettabwinvar ' +
        'reltime cursor tabpagenr finddir localtime acos getloclist search ' +
        'tanh matchend rename gettabvar strdisplaywidth type abs py3eval ' +
        'setwinvar tolower wildmenumode log10 spellsuggest bufloaded ' +
        'synconcealed nextnonblank server2client complete settabwinvar ' +
        'executable input wincol setmatches getftype hlID inputsave ' +
        'searchpair or screenrow line settabvar histadd deepcopy strpart ' +
        'remote_peek and eval getftime submatch screenchar winsaveview ' +
        'matchadd mkdir screenattr getfontname libcall reltimestr getfsize ' +
        'winnr invert pow getbufline byte2line soundfold repeat fnameescape ' +
        'tagfiles sin strwidth spellbadword trunc maparg log lispindent ' +
        'hostname setpos globpath remote_foreground getchar synIDattr ' +
        'fnamemodify cscope_connection stridx winbufnr indent min ' +
        'complete_add nr2char searchpairpos inputdialog values matchlist ' +
        'items hlexists strridx browsedir expand fmod pathshorten line2byte ' +
        'argc count getwinvar glob foldtextresult getreg foreground cosh ' +
        'matchdelete has char2nr simplify histget searchdecl iconv ' +
        'winrestcmd pumvisible writefile foldlevel haslocaldir keys cos ' +
        'matchstr foldtext histnr tan tempname getcwd byteidx getbufvar ' +
        'islocked escape eventhandler remote_send serverlist winrestview ' +
        'synstack pyeval prevnonblank readfile cindent filereadable changenr ' +
        'exp'
    },
    illegal: /;/,
    contains: [
      hljs.NUMBER_MODE,
      hljs.APOS_STRING_MODE,

      /*
      A double quote can start either a string or a line comment. Strings are
      ended before the end of a line by another double quote and can contain
      escaped double-quotes and post-escaped line breaks.

      Also, any double quote at the beginning of a line is a comment but we
      don't handle that properly at the moment: any double quote inside will
      turn them into a string. Handling it properly will require a smarter
      parser.
      */
      {
        className: 'string',
        begin: /"(\\"|\n\\|[^"\n])*"/
      },
      hljs.COMMENT('"', '$'),

      {
        className: 'variable',
        begin: /[bwtglsav]:[\w\d_]*/
      },
      {
        className: 'function',
        beginKeywords: 'function function!', end: '$',
        relevance: 0,
        contains: [
          hljs.TITLE_MODE,
          {
            className: 'params',
            begin: '\\(', end: '\\)'
          }
        ]
      },
      {
        className: 'symbol',
        begin: /<[\w-]+>/
      }
    ]
  };
};

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  return {
    case_insensitive: true,
    lexemes: '[.%]?' + hljs.IDENT_RE,
    keywords: {
      keyword:
        'lock rep repe repz repne repnz xaquire xrelease bnd nobnd ' +
        'aaa aad aam aas adc add and arpl bb0_reset bb1_reset bound bsf bsr bswap bt btc btr bts call cbw cdq cdqe clc cld cli clts cmc cmp cmpsb cmpsd cmpsq cmpsw cmpxchg cmpxchg486 cmpxchg8b cmpxchg16b cpuid cpu_read cpu_write cqo cwd cwde daa das dec div dmint emms enter equ f2xm1 fabs fadd faddp fbld fbstp fchs fclex fcmovb fcmovbe fcmove fcmovnb fcmovnbe fcmovne fcmovnu fcmovu fcom fcomi fcomip fcomp fcompp fcos fdecstp fdisi fdiv fdivp fdivr fdivrp femms feni ffree ffreep fiadd ficom ficomp fidiv fidivr fild fimul fincstp finit fist fistp fisttp fisub fisubr fld fld1 fldcw fldenv fldl2e fldl2t fldlg2 fldln2 fldpi fldz fmul fmulp fnclex fndisi fneni fninit fnop fnsave fnstcw fnstenv fnstsw fpatan fprem fprem1 fptan frndint frstor fsave fscale fsetpm fsin fsincos fsqrt fst fstcw fstenv fstp fstsw fsub fsubp fsubr fsubrp ftst fucom fucomi fucomip fucomp fucompp fxam fxch fxtract fyl2x fyl2xp1 hlt ibts icebp idiv imul in inc incbin insb insd insw int int01 int1 int03 int3 into invd invpcid invlpg invlpga iret iretd iretq iretw jcxz jecxz jrcxz jmp jmpe lahf lar lds lea leave les lfence lfs lgdt lgs lidt lldt lmsw loadall loadall286 lodsb lodsd lodsq lodsw loop loope loopne loopnz loopz lsl lss ltr mfence monitor mov movd movq movsb movsd movsq movsw movsx movsxd movzx mul mwait neg nop not or out outsb outsd outsw packssdw packsswb packuswb paddb paddd paddsb paddsiw paddsw paddusb paddusw paddw pand pandn pause paveb pavgusb pcmpeqb pcmpeqd pcmpeqw pcmpgtb pcmpgtd pcmpgtw pdistib pf2id pfacc pfadd pfcmpeq pfcmpge pfcmpgt pfmax pfmin pfmul pfrcp pfrcpit1 pfrcpit2 pfrsqit1 pfrsqrt pfsub pfsubr pi2fd pmachriw pmaddwd pmagw pmulhriw pmulhrwa pmulhrwc pmulhw pmullw pmvgezb pmvlzb pmvnzb pmvzb pop popa popad popaw popf popfd popfq popfw por prefetch prefetchw pslld psllq psllw psrad psraw psrld psrlq psrlw psubb psubd psubsb psubsiw psubsw psubusb psubusw psubw punpckhbw punpckhdq punpckhwd punpcklbw punpckldq punpcklwd push pusha pushad pushaw pushf pushfd pushfq pushfw pxor rcl rcr rdshr rdmsr rdpmc rdtsc rdtscp ret retf retn rol ror rdm rsdc rsldt rsm rsts sahf sal salc sar sbb scasb scasd scasq scasw sfence sgdt shl shld shr shrd sidt sldt skinit smi smint smintold smsw stc std sti stosb stosd stosq stosw str sub svdc svldt svts swapgs syscall sysenter sysexit sysret test ud0 ud1 ud2b ud2 ud2a umov verr verw fwait wbinvd wrshr wrmsr xadd xbts xchg xlatb xlat xor cmove cmovz cmovne cmovnz cmova cmovnbe cmovae cmovnb cmovb cmovnae cmovbe cmovna cmovg cmovnle cmovge cmovnl cmovl cmovnge cmovle cmovng cmovc cmovnc cmovo cmovno cmovs cmovns cmovp cmovpe cmovnp cmovpo je jz jne jnz ja jnbe jae jnb jb jnae jbe jna jg jnle jge jnl jl jnge jle jng jc jnc jo jno js jns jpo jnp jpe jp sete setz setne setnz seta setnbe setae setnb setnc setb setnae setcset setbe setna setg setnle setge setnl setl setnge setle setng sets setns seto setno setpe setp setpo setnp addps addss andnps andps cmpeqps cmpeqss cmpleps cmpless cmpltps cmpltss cmpneqps cmpneqss cmpnleps cmpnless cmpnltps cmpnltss cmpordps cmpordss cmpunordps cmpunordss cmpps cmpss comiss cvtpi2ps cvtps2pi cvtsi2ss cvtss2si cvttps2pi cvttss2si divps divss ldmxcsr maxps maxss minps minss movaps movhps movlhps movlps movhlps movmskps movntps movss movups mulps mulss orps rcpps rcpss rsqrtps rsqrtss shufps sqrtps sqrtss stmxcsr subps subss ucomiss unpckhps unpcklps xorps fxrstor fxrstor64 fxsave fxsave64 xgetbv xsetbv xsave xsave64 xsaveopt xsaveopt64 xrstor xrstor64 prefetchnta prefetcht0 prefetcht1 prefetcht2 maskmovq movntq pavgb pavgw pextrw pinsrw pmaxsw pmaxub pminsw pminub pmovmskb pmulhuw psadbw pshufw pf2iw pfnacc pfpnacc pi2fw pswapd maskmovdqu clflush movntdq movnti movntpd movdqa movdqu movdq2q movq2dq paddq pmuludq pshufd pshufhw pshuflw pslldq psrldq psubq punpckhqdq punpcklqdq addpd addsd andnpd andpd cmpeqpd cmpeqsd cmplepd cmplesd cmpltpd cmpltsd cmpneqpd cmpneqsd cmpnlepd cmpnlesd cmpnltpd cmpnltsd cmpordpd cmpordsd cmpunordpd cmpunordsd cmppd comisd cvtdq2pd cvtdq2ps cvtpd2dq cvtpd2pi cvtpd2ps cvtpi2pd cvtps2dq cvtps2pd cvtsd2si cvtsd2ss cvtsi2sd cvtss2sd cvttpd2pi cvttpd2dq cvttps2dq cvttsd2si divpd divsd maxpd maxsd minpd minsd movapd movhpd movlpd movmskpd movupd mulpd mulsd orpd shufpd sqrtpd sqrtsd subpd subsd ucomisd unpckhpd unpcklpd xorpd addsubpd addsubps haddpd haddps hsubpd hsubps lddqu movddup movshdup movsldup clgi stgi vmcall vmclear vmfunc vmlaunch vmload vmmcall vmptrld vmptrst vmread vmresume vmrun vmsave vmwrite vmxoff vmxon invept invvpid pabsb pabsw pabsd palignr phaddw phaddd phaddsw phsubw phsubd phsubsw pmaddubsw pmulhrsw pshufb psignb psignw psignd extrq insertq movntsd movntss lzcnt blendpd blendps blendvpd blendvps dppd dpps extractps insertps movntdqa mpsadbw packusdw pblendvb pblendw pcmpeqq pextrb pextrd pextrq phminposuw pinsrb pinsrd pinsrq pmaxsb pmaxsd pmaxud pmaxuw pminsb pminsd pminud pminuw pmovsxbw pmovsxbd pmovsxbq pmovsxwd pmovsxwq pmovsxdq pmovzxbw pmovzxbd pmovzxbq pmovzxwd pmovzxwq pmovzxdq pmuldq pmulld ptest roundpd roundps roundsd roundss crc32 pcmpestri pcmpestrm pcmpistri pcmpistrm pcmpgtq popcnt getsec pfrcpv pfrsqrtv movbe aesenc aesenclast aesdec aesdeclast aesimc aeskeygenassist vaesenc vaesenclast vaesdec vaesdeclast vaesimc vaeskeygenassist vaddpd vaddps vaddsd vaddss vaddsubpd vaddsubps vandpd vandps vandnpd vandnps vblendpd vblendps vblendvpd vblendvps vbroadcastss vbroadcastsd vbroadcastf128 vcmpeq_ospd vcmpeqpd vcmplt_ospd vcmpltpd vcmple_ospd vcmplepd vcmpunord_qpd vcmpunordpd vcmpneq_uqpd vcmpneqpd vcmpnlt_uspd vcmpnltpd vcmpnle_uspd vcmpnlepd vcmpord_qpd vcmpordpd vcmpeq_uqpd vcmpnge_uspd vcmpngepd vcmpngt_uspd vcmpngtpd vcmpfalse_oqpd vcmpfalsepd vcmpneq_oqpd vcmpge_ospd vcmpgepd vcmpgt_ospd vcmpgtpd vcmptrue_uqpd vcmptruepd vcmplt_oqpd vcmple_oqpd vcmpunord_spd vcmpneq_uspd vcmpnlt_uqpd vcmpnle_uqpd vcmpord_spd vcmpeq_uspd vcmpnge_uqpd vcmpngt_uqpd vcmpfalse_ospd vcmpneq_ospd vcmpge_oqpd vcmpgt_oqpd vcmptrue_uspd vcmppd vcmpeq_osps vcmpeqps vcmplt_osps vcmpltps vcmple_osps vcmpleps vcmpunord_qps vcmpunordps vcmpneq_uqps vcmpneqps vcmpnlt_usps vcmpnltps vcmpnle_usps vcmpnleps vcmpord_qps vcmpordps vcmpeq_uqps vcmpnge_usps vcmpngeps vcmpngt_usps vcmpngtps vcmpfalse_oqps vcmpfalseps vcmpneq_oqps vcmpge_osps vcmpgeps vcmpgt_osps vcmpgtps vcmptrue_uqps vcmptrueps vcmplt_oqps vcmple_oqps vcmpunord_sps vcmpneq_usps vcmpnlt_uqps vcmpnle_uqps vcmpord_sps vcmpeq_usps vcmpnge_uqps vcmpngt_uqps vcmpfalse_osps vcmpneq_osps vcmpge_oqps vcmpgt_oqps vcmptrue_usps vcmpps vcmpeq_ossd vcmpeqsd vcmplt_ossd vcmpltsd vcmple_ossd vcmplesd vcmpunord_qsd vcmpunordsd vcmpneq_uqsd vcmpneqsd vcmpnlt_ussd vcmpnltsd vcmpnle_ussd vcmpnlesd vcmpord_qsd vcmpordsd vcmpeq_uqsd vcmpnge_ussd vcmpngesd vcmpngt_ussd vcmpngtsd vcmpfalse_oqsd vcmpfalsesd vcmpneq_oqsd vcmpge_ossd vcmpgesd vcmpgt_ossd vcmpgtsd vcmptrue_uqsd vcmptruesd vcmplt_oqsd vcmple_oqsd vcmpunord_ssd vcmpneq_ussd vcmpnlt_uqsd vcmpnle_uqsd vcmpord_ssd vcmpeq_ussd vcmpnge_uqsd vcmpngt_uqsd vcmpfalse_ossd vcmpneq_ossd vcmpge_oqsd vcmpgt_oqsd vcmptrue_ussd vcmpsd vcmpeq_osss vcmpeqss vcmplt_osss vcmpltss vcmple_osss vcmpless vcmpunord_qss vcmpunordss vcmpneq_uqss vcmpneqss vcmpnlt_usss vcmpnltss vcmpnle_usss vcmpnless vcmpord_qss vcmpordss vcmpeq_uqss vcmpnge_usss vcmpngess vcmpngt_usss vcmpngtss vcmpfalse_oqss vcmpfalsess vcmpneq_oqss vcmpge_osss vcmpgess vcmpgt_osss vcmpgtss vcmptrue_uqss vcmptruess vcmplt_oqss vcmple_oqss vcmpunord_sss vcmpneq_usss vcmpnlt_uqss vcmpnle_uqss vcmpord_sss vcmpeq_usss vcmpnge_uqss vcmpngt_uqss vcmpfalse_osss vcmpneq_osss vcmpge_oqss vcmpgt_oqss vcmptrue_usss vcmpss vcomisd vcomiss vcvtdq2pd vcvtdq2ps vcvtpd2dq vcvtpd2ps vcvtps2dq vcvtps2pd vcvtsd2si vcvtsd2ss vcvtsi2sd vcvtsi2ss vcvtss2sd vcvtss2si vcvttpd2dq vcvttps2dq vcvttsd2si vcvttss2si vdivpd vdivps vdivsd vdivss vdppd vdpps vextractf128 vextractps vhaddpd vhaddps vhsubpd vhsubps vinsertf128 vinsertps vlddqu vldqqu vldmxcsr vmaskmovdqu vmaskmovps vmaskmovpd vmaxpd vmaxps vmaxsd vmaxss vminpd vminps vminsd vminss vmovapd vmovaps vmovd vmovq vmovddup vmovdqa vmovqqa vmovdqu vmovqqu vmovhlps vmovhpd vmovhps vmovlhps vmovlpd vmovlps vmovmskpd vmovmskps vmovntdq vmovntqq vmovntdqa vmovntpd vmovntps vmovsd vmovshdup vmovsldup vmovss vmovupd vmovups vmpsadbw vmulpd vmulps vmulsd vmulss vorpd vorps vpabsb vpabsw vpabsd vpacksswb vpackssdw vpackuswb vpackusdw vpaddb vpaddw vpaddd vpaddq vpaddsb vpaddsw vpaddusb vpaddusw vpalignr vpand vpandn vpavgb vpavgw vpblendvb vpblendw vpcmpestri vpcmpestrm vpcmpistri vpcmpistrm vpcmpeqb vpcmpeqw vpcmpeqd vpcmpeqq vpcmpgtb vpcmpgtw vpcmpgtd vpcmpgtq vpermilpd vpermilps vperm2f128 vpextrb vpextrw vpextrd vpextrq vphaddw vphaddd vphaddsw vphminposuw vphsubw vphsubd vphsubsw vpinsrb vpinsrw vpinsrd vpinsrq vpmaddwd vpmaddubsw vpmaxsb vpmaxsw vpmaxsd vpmaxub vpmaxuw vpmaxud vpminsb vpminsw vpminsd vpminub vpminuw vpminud vpmovmskb vpmovsxbw vpmovsxbd vpmovsxbq vpmovsxwd vpmovsxwq vpmovsxdq vpmovzxbw vpmovzxbd vpmovzxbq vpmovzxwd vpmovzxwq vpmovzxdq vpmulhuw vpmulhrsw vpmulhw vpmullw vpmulld vpmuludq vpmuldq vpor vpsadbw vpshufb vpshufd vpshufhw vpshuflw vpsignb vpsignw vpsignd vpslldq vpsrldq vpsllw vpslld vpsllq vpsraw vpsrad vpsrlw vpsrld vpsrlq vptest vpsubb vpsubw vpsubd vpsubq vpsubsb vpsubsw vpsubusb vpsubusw vpunpckhbw vpunpckhwd vpunpckhdq vpunpckhqdq vpunpcklbw vpunpcklwd vpunpckldq vpunpcklqdq vpxor vrcpps vrcpss vrsqrtps vrsqrtss vroundpd vroundps vroundsd vroundss vshufpd vshufps vsqrtpd vsqrtps vsqrtsd vsqrtss vstmxcsr vsubpd vsubps vsubsd vsubss vtestps vtestpd vucomisd vucomiss vunpckhpd vunpckhps vunpcklpd vunpcklps vxorpd vxorps vzeroall vzeroupper pclmullqlqdq pclmulhqlqdq pclmullqhqdq pclmulhqhqdq pclmulqdq vpclmullqlqdq vpclmulhqlqdq vpclmullqhqdq vpclmulhqhqdq vpclmulqdq vfmadd132ps vfmadd132pd vfmadd312ps vfmadd312pd vfmadd213ps vfmadd213pd vfmadd123ps vfmadd123pd vfmadd231ps vfmadd231pd vfmadd321ps vfmadd321pd vfmaddsub132ps vfmaddsub132pd vfmaddsub312ps vfmaddsub312pd vfmaddsub213ps vfmaddsub213pd vfmaddsub123ps vfmaddsub123pd vfmaddsub231ps vfmaddsub231pd vfmaddsub321ps vfmaddsub321pd vfmsub132ps vfmsub132pd vfmsub312ps vfmsub312pd vfmsub213ps vfmsub213pd vfmsub123ps vfmsub123pd vfmsub231ps vfmsub231pd vfmsub321ps vfmsub321pd vfmsubadd132ps vfmsubadd132pd vfmsubadd312ps vfmsubadd312pd vfmsubadd213ps vfmsubadd213pd vfmsubadd123ps vfmsubadd123pd vfmsubadd231ps vfmsubadd231pd vfmsubadd321ps vfmsubadd321pd vfnmadd132ps vfnmadd132pd vfnmadd312ps vfnmadd312pd vfnmadd213ps vfnmadd213pd vfnmadd123ps vfnmadd123pd vfnmadd231ps vfnmadd231pd vfnmadd321ps vfnmadd321pd vfnmsub132ps vfnmsub132pd vfnmsub312ps vfnmsub312pd vfnmsub213ps vfnmsub213pd vfnmsub123ps vfnmsub123pd vfnmsub231ps vfnmsub231pd vfnmsub321ps vfnmsub321pd vfmadd132ss vfmadd132sd vfmadd312ss vfmadd312sd vfmadd213ss vfmadd213sd vfmadd123ss vfmadd123sd vfmadd231ss vfmadd231sd vfmadd321ss vfmadd321sd vfmsub132ss vfmsub132sd vfmsub312ss vfmsub312sd vfmsub213ss vfmsub213sd vfmsub123ss vfmsub123sd vfmsub231ss vfmsub231sd vfmsub321ss vfmsub321sd vfnmadd132ss vfnmadd132sd vfnmadd312ss vfnmadd312sd vfnmadd213ss vfnmadd213sd vfnmadd123ss vfnmadd123sd vfnmadd231ss vfnmadd231sd vfnmadd321ss vfnmadd321sd vfnmsub132ss vfnmsub132sd vfnmsub312ss vfnmsub312sd vfnmsub213ss vfnmsub213sd vfnmsub123ss vfnmsub123sd vfnmsub231ss vfnmsub231sd vfnmsub321ss vfnmsub321sd rdfsbase rdgsbase rdrand wrfsbase wrgsbase vcvtph2ps vcvtps2ph adcx adox rdseed clac stac xstore xcryptecb xcryptcbc xcryptctr xcryptcfb xcryptofb montmul xsha1 xsha256 llwpcb slwpcb lwpval lwpins vfmaddpd vfmaddps vfmaddsd vfmaddss vfmaddsubpd vfmaddsubps vfmsubaddpd vfmsubaddps vfmsubpd vfmsubps vfmsubsd vfmsubss vfnmaddpd vfnmaddps vfnmaddsd vfnmaddss vfnmsubpd vfnmsubps vfnmsubsd vfnmsubss vfrczpd vfrczps vfrczsd vfrczss vpcmov vpcomb vpcomd vpcomq vpcomub vpcomud vpcomuq vpcomuw vpcomw vphaddbd vphaddbq vphaddbw vphadddq vphaddubd vphaddubq vphaddubw vphaddudq vphadduwd vphadduwq vphaddwd vphaddwq vphsubbw vphsubdq vphsubwd vpmacsdd vpmacsdqh vpmacsdql vpmacssdd vpmacssdqh vpmacssdql vpmacsswd vpmacssww vpmacswd vpmacsww vpmadcsswd vpmadcswd vpperm vprotb vprotd vprotq vprotw vpshab vpshad vpshaq vpshaw vpshlb vpshld vpshlq vpshlw vbroadcasti128 vpblendd vpbroadcastb vpbroadcastw vpbroadcastd vpbroadcastq vpermd vpermpd vpermps vpermq vperm2i128 vextracti128 vinserti128 vpmaskmovd vpmaskmovq vpsllvd vpsllvq vpsravd vpsrlvd vpsrlvq vgatherdpd vgatherqpd vgatherdps vgatherqps vpgatherdd vpgatherqd vpgatherdq vpgatherqq xabort xbegin xend xtest andn bextr blci blcic blsi blsic blcfill blsfill blcmsk blsmsk blsr blcs bzhi mulx pdep pext rorx sarx shlx shrx tzcnt tzmsk t1mskc valignd valignq vblendmpd vblendmps vbroadcastf32x4 vbroadcastf64x4 vbroadcasti32x4 vbroadcasti64x4 vcompresspd vcompressps vcvtpd2udq vcvtps2udq vcvtsd2usi vcvtss2usi vcvttpd2udq vcvttps2udq vcvttsd2usi vcvttss2usi vcvtudq2pd vcvtudq2ps vcvtusi2sd vcvtusi2ss vexpandpd vexpandps vextractf32x4 vextractf64x4 vextracti32x4 vextracti64x4 vfixupimmpd vfixupimmps vfixupimmsd vfixupimmss vgetexppd vgetexpps vgetexpsd vgetexpss vgetmantpd vgetmantps vgetmantsd vgetmantss vinsertf32x4 vinsertf64x4 vinserti32x4 vinserti64x4 vmovdqa32 vmovdqa64 vmovdqu32 vmovdqu64 vpabsq vpandd vpandnd vpandnq vpandq vpblendmd vpblendmq vpcmpltd vpcmpled vpcmpneqd vpcmpnltd vpcmpnled vpcmpd vpcmpltq vpcmpleq vpcmpneqq vpcmpnltq vpcmpnleq vpcmpq vpcmpequd vpcmpltud vpcmpleud vpcmpnequd vpcmpnltud vpcmpnleud vpcmpud vpcmpequq vpcmpltuq vpcmpleuq vpcmpnequq vpcmpnltuq vpcmpnleuq vpcmpuq vpcompressd vpcompressq vpermi2d vpermi2pd vpermi2ps vpermi2q vpermt2d vpermt2pd vpermt2ps vpermt2q vpexpandd vpexpandq vpmaxsq vpmaxuq vpminsq vpminuq vpmovdb vpmovdw vpmovqb vpmovqd vpmovqw vpmovsdb vpmovsdw vpmovsqb vpmovsqd vpmovsqw vpmovusdb vpmovusdw vpmovusqb vpmovusqd vpmovusqw vpord vporq vprold vprolq vprolvd vprolvq vprord vprorq vprorvd vprorvq vpscatterdd vpscatterdq vpscatterqd vpscatterqq vpsraq vpsravq vpternlogd vpternlogq vptestmd vptestmq vptestnmd vptestnmq vpxord vpxorq vrcp14pd vrcp14ps vrcp14sd vrcp14ss vrndscalepd vrndscaleps vrndscalesd vrndscaless vrsqrt14pd vrsqrt14ps vrsqrt14sd vrsqrt14ss vscalefpd vscalefps vscalefsd vscalefss vscatterdpd vscatterdps vscatterqpd vscatterqps vshuff32x4 vshuff64x2 vshufi32x4 vshufi64x2 kandnw kandw kmovw knotw kortestw korw kshiftlw kshiftrw kunpckbw kxnorw kxorw vpbroadcastmb2q vpbroadcastmw2d vpconflictd vpconflictq vplzcntd vplzcntq vexp2pd vexp2ps vrcp28pd vrcp28ps vrcp28sd vrcp28ss vrsqrt28pd vrsqrt28ps vrsqrt28sd vrsqrt28ss vgatherpf0dpd vgatherpf0dps vgatherpf0qpd vgatherpf0qps vgatherpf1dpd vgatherpf1dps vgatherpf1qpd vgatherpf1qps vscatterpf0dpd vscatterpf0dps vscatterpf0qpd vscatterpf0qps vscatterpf1dpd vscatterpf1dps vscatterpf1qpd vscatterpf1qps prefetchwt1 bndmk bndcl bndcu bndcn bndmov bndldx bndstx sha1rnds4 sha1nexte sha1msg1 sha1msg2 sha256rnds2 sha256msg1 sha256msg2 hint_nop0 hint_nop1 hint_nop2 hint_nop3 hint_nop4 hint_nop5 hint_nop6 hint_nop7 hint_nop8 hint_nop9 hint_nop10 hint_nop11 hint_nop12 hint_nop13 hint_nop14 hint_nop15 hint_nop16 hint_nop17 hint_nop18 hint_nop19 hint_nop20 hint_nop21 hint_nop22 hint_nop23 hint_nop24 hint_nop25 hint_nop26 hint_nop27 hint_nop28 hint_nop29 hint_nop30 hint_nop31 hint_nop32 hint_nop33 hint_nop34 hint_nop35 hint_nop36 hint_nop37 hint_nop38 hint_nop39 hint_nop40 hint_nop41 hint_nop42 hint_nop43 hint_nop44 hint_nop45 hint_nop46 hint_nop47 hint_nop48 hint_nop49 hint_nop50 hint_nop51 hint_nop52 hint_nop53 hint_nop54 hint_nop55 hint_nop56 hint_nop57 hint_nop58 hint_nop59 hint_nop60 hint_nop61 hint_nop62 hint_nop63',
      built_in:
        // Instruction pointer
        'ip eip rip ' +
        // 8-bit registers
        'al ah bl bh cl ch dl dh sil dil bpl spl r8b r9b r10b r11b r12b r13b r14b r15b ' +
        // 16-bit registers
        'ax bx cx dx si di bp sp r8w r9w r10w r11w r12w r13w r14w r15w ' +
        // 32-bit registers
        'eax ebx ecx edx esi edi ebp esp eip r8d r9d r10d r11d r12d r13d r14d r15d ' +
        // 64-bit registers
        'rax rbx rcx rdx rsi rdi rbp rsp r8 r9 r10 r11 r12 r13 r14 r15 ' +
        // Segment registers
        'cs ds es fs gs ss ' +
        // Floating point stack registers
        'st st0 st1 st2 st3 st4 st5 st6 st7 ' +
        // MMX Registers
        'mm0 mm1 mm2 mm3 mm4 mm5 mm6 mm7 ' +
        // SSE registers
        'xmm0  xmm1  xmm2  xmm3  xmm4  xmm5  xmm6  xmm7  xmm8  xmm9 xmm10  xmm11 xmm12 xmm13 xmm14 xmm15 ' +
        'xmm16 xmm17 xmm18 xmm19 xmm20 xmm21 xmm22 xmm23 xmm24 xmm25 xmm26 xmm27 xmm28 xmm29 xmm30 xmm31 ' +
        // AVX registers
        'ymm0  ymm1  ymm2  ymm3  ymm4  ymm5  ymm6  ymm7  ymm8  ymm9 ymm10  ymm11 ymm12 ymm13 ymm14 ymm15 ' +
        'ymm16 ymm17 ymm18 ymm19 ymm20 ymm21 ymm22 ymm23 ymm24 ymm25 ymm26 ymm27 ymm28 ymm29 ymm30 ymm31 ' +
        // AVX-512F registers
        'zmm0  zmm1  zmm2  zmm3  zmm4  zmm5  zmm6  zmm7  zmm8  zmm9 zmm10  zmm11 zmm12 zmm13 zmm14 zmm15 ' +
        'zmm16 zmm17 zmm18 zmm19 zmm20 zmm21 zmm22 zmm23 zmm24 zmm25 zmm26 zmm27 zmm28 zmm29 zmm30 zmm31 ' +
        // AVX-512F mask registers
        'k0 k1 k2 k3 k4 k5 k6 k7 ' +
        // Bound (MPX) register
        'bnd0 bnd1 bnd2 bnd3 ' +
        // Special register
        'cr0 cr1 cr2 cr3 cr4 cr8 dr0 dr1 dr2 dr3 dr8 tr3 tr4 tr5 tr6 tr7 ' +
        // NASM altreg package
        'r0 r1 r2 r3 r4 r5 r6 r7 r0b r1b r2b r3b r4b r5b r6b r7b ' +
        'r0w r1w r2w r3w r4w r5w r6w r7w r0d r1d r2d r3d r4d r5d r6d r7d ' +
        'r0h r1h r2h r3h ' +
        'r0l r1l r2l r3l r4l r5l r6l r7l r8l r9l r10l r11l r12l r13l r14l r15l ' +

        'db dw dd dq dt ddq do dy dz ' +
        'resb resw resd resq rest resdq reso resy resz ' +
        'incbin equ times ' +
        'byte word dword qword nosplit rel abs seg wrt strict near far a32 ptr',

      meta:
        '%define %xdefine %+ %undef %defstr %deftok %assign %strcat %strlen %substr %rotate %elif %else %endif ' +
        '%if %ifmacro %ifctx %ifidn %ifidni %ifid %ifnum %ifstr %iftoken %ifempty %ifenv %error %warning %fatal %rep ' +
        '%endrep %include %push %pop %repl %pathsearch %depend %use %arg %stacksize %local %line %comment %endcomment ' +
        '.nolist ' +
        '__FILE__ __LINE__ __SECT__  __BITS__ __OUTPUT_FORMAT__ __DATE__ __TIME__ __DATE_NUM__ __TIME_NUM__ ' +
        '__UTC_DATE__ __UTC_TIME__ __UTC_DATE_NUM__ __UTC_TIME_NUM__  __PASS__ struc endstruc istruc at iend ' +
        'align alignb sectalign daz nodaz up down zero default option assume public ' +

        'bits use16 use32 use64 default section segment absolute extern global common cpu float ' +
        '__utf16__ __utf16le__ __utf16be__ __utf32__ __utf32le__ __utf32be__ ' +
        '__float8__ __float16__ __float32__ __float64__ __float80m__ __float80e__ __float128l__ __float128h__ ' +
        '__Infinity__ __QNaN__ __SNaN__ Inf NaN QNaN SNaN float8 float16 float32 float64 float80m float80e ' +
        'float128l float128h __FLOAT_DAZ__ __FLOAT_ROUND__ __FLOAT__'
    },
    contains: [
      hljs.COMMENT(
        ';',
        '$',
        {
          relevance: 0
        }
      ),
      {
        className: 'number',
        variants: [
          // Float number and x87 BCD
          {
            begin: '\\b(?:([0-9][0-9_]*)?\\.[0-9_]*(?:[eE][+-]?[0-9_]+)?|' +
                   '(0[Xx])?[0-9][0-9_]*\\.?[0-9_]*(?:[pP](?:[+-]?[0-9_]+)?)?)\\b',
            relevance: 0
          },

          // Hex number in $
          { begin: '\\$[0-9][0-9A-Fa-f]*', relevance: 0 },

          // Number in H,D,T,Q,O,B,Y suffix
          { begin: '\\b(?:[0-9A-Fa-f][0-9A-Fa-f_]*[Hh]|[0-9][0-9_]*[DdTt]?|[0-7][0-7_]*[QqOo]|[0-1][0-1_]*[BbYy])\\b' },

          // Number in X,D,T,Q,O,B,Y prefix
          { begin: '\\b(?:0[Xx][0-9A-Fa-f_]+|0[DdTt][0-9_]+|0[QqOo][0-7_]+|0[BbYy][0-1_]+)\\b'}
        ]
      },
      // Double quote string
      hljs.QUOTE_STRING_MODE,
      {
        className: 'string',
        variants: [
          // Single-quoted string
          { begin: '\'', end: '[^\\\\]\'' },
          // Backquoted string
          { begin: '`', end: '[^\\\\]`' }
        ],
        relevance: 0
      },
      {
        className: 'symbol',
        variants: [
          // Global label and local label
          { begin: '^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)' },
          // Macro-local label
          { begin: '^\\s*%%[A-Za-z0-9_$#@~.?]*:' }
        ],
        relevance: 0
      },
      // Macro parameter
      {
        className: 'subst',
        begin: '%[0-9]+',
        relevance: 0
      },
      // Macro parameter
      {
        className: 'subst',
        begin: '%!\S+',
        relevance: 0
      },
      {
        className: 'meta',
        begin: /^\s*\.[\w_-]+/
      }
    ]
  };
};

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var BUILTIN_MODULES =
    'ObjectLoader Animate MovieCredits Slides Filters Shading Materials LensFlare Mapping VLCAudioVideo ' +
    'StereoDecoder PointCloud NetworkAccess RemoteControl RegExp ChromaKey Snowfall NodeJS Speech Charts';

  var XL_KEYWORDS = {
    keyword:
      'if then else do while until for loop import with is as where when by data constant ' +
      'integer real text name boolean symbol infix prefix postfix block tree',
    literal:
      'true false nil',
    built_in:
      'in mod rem and or xor not abs sign floor ceil sqrt sin cos tan asin ' +
      'acos atan exp expm1 log log2 log10 log1p pi at text_length text_range ' +
      'text_find text_replace contains page slide basic_slide title_slide ' +
      'title subtitle fade_in fade_out fade_at clear_color color line_color ' +
      'line_width texture_wrap texture_transform texture scale_?x scale_?y ' +
      'scale_?z? translate_?x translate_?y translate_?z? rotate_?x rotate_?y ' +
      'rotate_?z? rectangle circle ellipse sphere path line_to move_to ' +
      'quad_to curve_to theme background contents locally time mouse_?x ' +
      'mouse_?y mouse_buttons ' +
      BUILTIN_MODULES
  };

  var DOUBLE_QUOTE_TEXT = {
    className: 'string',
    begin: '"', end: '"', illegal: '\\n'
  };
  var SINGLE_QUOTE_TEXT = {
    className: 'string',
    begin: '\'', end: '\'', illegal: '\\n'
  };
  var LONG_TEXT = {
    className: 'string',
    begin: '<<', end: '>>'
  };
  var BASED_NUMBER = {
    className: 'number',
    begin: '[0-9]+#[0-9A-Z_]+(\\.[0-9-A-Z_]+)?#?([Ee][+-]?[0-9]+)?'
  };
  var IMPORT = {
    beginKeywords: 'import', end: '$',
    keywords: XL_KEYWORDS,
    contains: [DOUBLE_QUOTE_TEXT]
  };
  var FUNCTION_DEFINITION = {
    className: 'function',
    begin: /[a-z][^\n]*->/, returnBegin: true, end: /->/,
    contains: [
      hljs.inherit(hljs.TITLE_MODE, {starts: {
        endsWithParent: true,
        keywords: XL_KEYWORDS
      }})
    ]
  };
  return {
    aliases: ['tao'],
    lexemes: /[a-zA-Z][a-zA-Z0-9_?]*/,
    keywords: XL_KEYWORDS,
    contains: [
    hljs.C_LINE_COMMENT_MODE,
    hljs.C_BLOCK_COMMENT_MODE,
    DOUBLE_QUOTE_TEXT,
    SINGLE_QUOTE_TEXT,
    LONG_TEXT,
    FUNCTION_DEFINITION,
    IMPORT,
    BASED_NUMBER,
    hljs.NUMBER_MODE
    ]
  };
};

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var KEYWORDS = 'for let if while then else return where group by xquery encoding version' +
    'module namespace boundary-space preserve strip default collation base-uri ordering' +
    'copy-namespaces order declare import schema namespace function option in allowing empty' +
    'at tumbling window sliding window start when only end when previous next stable ascending' +
    'descending empty greatest least some every satisfies switch case typeswitch try catch and' +
    'or to union intersect instance of treat as castable cast map array delete insert into' +
    'replace value rename copy modify update';
  var LITERAL = 'false true xs:string xs:integer element item xs:date xs:datetime xs:float xs:double xs:decimal QName xs:anyURI xs:long xs:int xs:short xs:byte attribute';
  var VAR = {
    begin: /\$[a-zA-Z0-9\-]+/
  };

  var NUMBER = {
    className: 'number',
    begin: '(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',
    relevance: 0
  };

  var STRING = {
    className: 'string',
    variants: [
      {begin: /"/, end: /"/, contains: [{begin: /""/, relevance: 0}]},
      {begin: /'/, end: /'/, contains: [{begin: /''/, relevance: 0}]}
    ]
  };

  var ANNOTATION = {
    className: 'meta',
    begin: '%\\w+'
  };

  var COMMENT = {
    className: 'comment',
    begin: '\\(:', end: ':\\)',
    relevance: 10,
    contains: [
      {
        className: 'doctag', begin: '@\\w+'
      }
    ]
  };

  var METHOD = {
    begin: '{', end: '}'
  };

  var CONTAINS = [
    VAR,
    STRING,
    NUMBER,
    COMMENT,
    ANNOTATION,
    METHOD
  ];
  METHOD.contains = CONTAINS;


  return {
    aliases: ['xpath', 'xq'],
    case_insensitive: false,
    lexemes: /[a-zA-Z\$][a-zA-Z0-9_:\-]*/,
    illegal: /(proc)|(abstract)|(extends)|(until)|(#)/,
    keywords: {
      keyword: KEYWORDS,
      literal: LITERAL
    },
    contains: CONTAINS
  };
};

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

module.exports = function(hljs) {
  var STRING = {
    className: 'string',
    contains: [hljs.BACKSLASH_ESCAPE],
    variants: [
      {
        begin: 'b"', end: '"'
      },
      {
        begin: 'b\'', end: '\''
      },
      hljs.inherit(hljs.APOS_STRING_MODE, {illegal: null}),
      hljs.inherit(hljs.QUOTE_STRING_MODE, {illegal: null})
    ]
  };
  var NUMBER = {variants: [hljs.BINARY_NUMBER_MODE, hljs.C_NUMBER_MODE]};
  return {
    aliases: ['zep'],
    case_insensitive: true,
    keywords:
      'and include_once list abstract global private echo interface as static endswitch ' +
      'array null if endwhile or const for endforeach self var let while isset public ' +
      'protected exit foreach throw elseif include __FILE__ empty require_once do xor ' +
      'return parent clone use __CLASS__ __LINE__ else break print eval new ' +
      'catch __METHOD__ case exception default die require __FUNCTION__ ' +
      'enddeclare final try switch continue endfor endif declare unset true false ' +
      'trait goto instanceof insteadof __DIR__ __NAMESPACE__ ' +
      'yield finally int uint long ulong char uchar double float bool boolean string' +
      'likely unlikely',
    contains: [
      hljs.C_LINE_COMMENT_MODE,
      hljs.HASH_COMMENT_MODE,
      hljs.COMMENT(
        '/\\*',
        '\\*/',
        {
          contains: [
            {
              className: 'doctag',
              begin: '@[A-Za-z]+'
            }
          ]
        }
      ),
      hljs.COMMENT(
        '__halt_compiler.+?;',
        false,
        {
          endsWithParent: true,
          keywords: '__halt_compiler',
          lexemes: hljs.UNDERSCORE_IDENT_RE
        }
      ),
      {
        className: 'string',
        begin: '<<<[\'"]?\\w+[\'"]?$', end: '^\\w+;',
        contains: [hljs.BACKSLASH_ESCAPE]
      },
      {
        // swallow composed identifiers to avoid parsing them as keywords
        begin: /(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/
      },
      {
        className: 'function',
        beginKeywords: 'function', end: /[;{]/, excludeEnd: true,
        illegal: '\\$|\\[|%',
        contains: [
          hljs.UNDERSCORE_TITLE_MODE,
          {
            className: 'params',
            begin: '\\(', end: '\\)',
            contains: [
              'self',
              hljs.C_BLOCK_COMMENT_MODE,
              STRING,
              NUMBER
            ]
          }
        ]
      },
      {
        className: 'class',
        beginKeywords: 'class interface', end: '{', excludeEnd: true,
        illegal: /[:\(\$"]/,
        contains: [
          {beginKeywords: 'extends implements'},
          hljs.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        beginKeywords: 'namespace', end: ';',
        illegal: /[\.']/,
        contains: [hljs.UNDERSCORE_TITLE_MODE]
      },
      {
        beginKeywords: 'use', end: ';',
        contains: [hljs.UNDERSCORE_TITLE_MODE]
      },
      {
        begin: '=>' // No markup, just a relevance booster
      },
      STRING,
      NUMBER
    ]
  };
};

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(3044);


/***/ }),
/* 1119 */
/***/ (function(module, exports) {

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator;

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);


/* harmony default export */ __webpack_exports__["a"] = (function (name, loader) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(
      /*#__PURE__*/
      __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.mark(function _callee(registerLanguage) {
        var module;
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return loader();

              case 2:
                module = _context.sent;
                registerLanguage(name, module.default || module);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
});

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = abap
abap.displayName = 'abap'
abap.aliases = []
function abap(Prism) {
  Prism.languages.abap = {
    comment: /^\*.*/m,
    string: /(`|')(?:\\.|(?!\1)[^\\\r\n])*\1/m,
    'string-template': {
      pattern: /([|}])(?:\\.|[^\\|{\r\n])*(?=[|{])/,
      lookbehind: true,
      alias: 'string'
    },
    /* End Of Line comments should not interfere with strings when the
quote character occurs within them. We assume a string being highlighted
inside an EOL comment is more acceptable than the opposite.
*/
    'eol-comment': {
      pattern: /(^|\s)".*/m,
      lookbehind: true,
      alias: 'comment'
    },
    keyword: {
      pattern: /(\s|\.|^)(?:SCIENTIFIC_WITH_LEADING_ZERO|SCALE_PRESERVING_SCIENTIFIC|RMC_COMMUNICATION_FAILURE|END-ENHANCEMENT-SECTION|MULTIPLY-CORRESPONDING|SUBTRACT-CORRESPONDING|VERIFICATION-MESSAGE|DIVIDE-CORRESPONDING|ENHANCEMENT-SECTION|CURRENCY_CONVERSION|RMC_SYSTEM_FAILURE|START-OF-SELECTION|MOVE-CORRESPONDING|RMC_INVALID_STATUS|CUSTOMER-FUNCTION|END-OF-DEFINITION|ENHANCEMENT-POINT|SYSTEM-EXCEPTIONS|ADD-CORRESPONDING|SCALE_PRESERVING|SELECTION-SCREEN|CURSOR-SELECTION|END-OF-SELECTION|LOAD-OF-PROGRAM|SCROLL-BOUNDARY|SELECTION-TABLE|EXCEPTION-TABLE|IMPLEMENTATIONS|PARAMETER-TABLE|RIGHT-JUSTIFIED|UNIT_CONVERSION|AUTHORITY-CHECK|LIST-PROCESSING|SIGN_AS_POSTFIX|COL_BACKGROUND|IMPLEMENTATION|INTERFACE-POOL|TRANSFORMATION|IDENTIFICATION|ENDENHANCEMENT|LINE-SELECTION|INITIALIZATION|LEFT-JUSTIFIED|SELECT-OPTIONS|SELECTION-SETS|COMMUNICATION|CORRESPONDING|DECIMAL_SHIFT|PRINT-CONTROL|VALUE-REQUEST|CHAIN-REQUEST|FUNCTION-POOL|FIELD-SYMBOLS|FUNCTIONALITY|INVERTED-DATE|SELECTION-SET|CLASS-METHODS|OUTPUT-LENGTH|CLASS-CODING|COL_NEGATIVE|ERRORMESSAGE|FIELD-GROUPS|HELP-REQUEST|NO-EXTENSION|NO-TOPOFPAGE|REDEFINITION|DISPLAY-MODE|ENDINTERFACE|EXIT-COMMAND|FIELD-SYMBOL|NO-SCROLLING|SHORTDUMP-ID|ACCESSPOLICY|CLASS-EVENTS|COL_POSITIVE|DECLARATIONS|ENHANCEMENTS|FILTER-TABLE|SWITCHSTATES|SYNTAX-CHECK|TRANSPORTING|ASYNCHRONOUS|SYNTAX-TRACE|TOKENIZATION|USER-COMMAND|WITH-HEADING|ABAP-SOURCE|BREAK-POINT|CHAIN-INPUT|COMPRESSION|FIXED-POINT|NEW-SECTION|NON-UNICODE|OCCURRENCES|RESPONSIBLE|SYSTEM-CALL|TRACE-TABLE|ABBREVIATED|CHAR-TO-HEX|END-OF-FILE|ENDFUNCTION|ENVIRONMENT|ASSOCIATION|COL_HEADING|EDITOR-CALL|END-OF-PAGE|ENGINEERING|IMPLEMENTED|INTENSIFIED|RADIOBUTTON|SYSTEM-EXIT|TOP-OF-PAGE|TRANSACTION|APPLICATION|CONCATENATE|DESTINATION|ENHANCEMENT|IMMEDIATELY|NO-GROUPING|PRECOMPILED|REPLACEMENT|TITLE-LINES|ACTIVATION|BYTE-ORDER|CLASS-POOL|CONNECTION|CONVERSION|DEFINITION|DEPARTMENT|EXPIRATION|INHERITING|MESSAGE-ID|NO-HEADING|PERFORMING|QUEUE-ONLY|RIGHTSPACE|SCIENTIFIC|STATUSINFO|STRUCTURES|SYNCPOINTS|WITH-TITLE|ATTRIBUTES|BOUNDARIES|CLASS-DATA|COL_NORMAL|DD\/MM\/YYYY|DESCENDING|INTERFACES|LINE-COUNT|MM\/DD\/YYYY|NON-UNIQUE|PRESERVING|SELECTIONS|STATEMENTS|SUBROUTINE|TRUNCATION|TYPE-POOLS|ARITHMETIC|BACKGROUND|ENDPROVIDE|EXCEPTIONS|IDENTIFIER|INDEX-LINE|OBLIGATORY|PARAMETERS|PERCENTAGE|PUSHBUTTON|RESOLUTION|COMPONENTS|DEALLOCATE|DISCONNECT|DUPLICATES|FIRST-LINE|HEAD-LINES|NO-DISPLAY|OCCURRENCE|RESPECTING|RETURNCODE|SUBMATCHES|TRACE-FILE|ASCENDING|BYPASSING|ENDMODULE|EXCEPTION|EXCLUDING|EXPORTING|INCREMENT|MATCHCODE|PARAMETER|PARTIALLY|PREFERRED|REFERENCE|REPLACING|RETURNING|SELECTION|SEPARATED|SPECIFIED|STATEMENT|TIMESTAMP|TYPE-POOL|ACCEPTING|APPENDAGE|ASSIGNING|COL_GROUP|COMPARING|CONSTANTS|DANGEROUS|IMPORTING|INSTANCES|LEFTSPACE|LOG-POINT|QUICKINFO|READ-ONLY|SCROLLING|SQLSCRIPT|STEP-LOOP|TOP-LINES|TRANSLATE|APPENDING|AUTHORITY|CHARACTER|COMPONENT|CONDITION|DIRECTORY|DUPLICATE|MESSAGING|RECEIVING|SUBSCREEN|ACCORDING|COL_TOTAL|END-LINES|ENDMETHOD|ENDSELECT|EXPANDING|EXTENSION|INCLUDING|INFOTYPES|INTERFACE|INTERVALS|LINE-SIZE|PF-STATUS|PROCEDURE|PROTECTED|REQUESTED|RESUMABLE|RIGHTPLUS|SAP-SPOOL|SECONDARY|STRUCTURE|SUBSTRING|TABLEVIEW|NUMOFCHAR|ADJACENT|ANALYSIS|ASSIGNED|BACKWARD|CHANNELS|CHECKBOX|CONTINUE|CRITICAL|DATAINFO|DD\/MM\/YY|DURATION|ENCODING|ENDCLASS|FUNCTION|LEFTPLUS|LINEFEED|MM\/DD\/YY|OVERFLOW|RECEIVED|SKIPPING|SORTABLE|STANDARD|SUBTRACT|SUPPRESS|TABSTRIP|TITLEBAR|TRUNCATE|UNASSIGN|WHENEVER|ANALYZER|COALESCE|COMMENTS|CONDENSE|DECIMALS|DEFERRED|ENDWHILE|EXPLICIT|KEYWORDS|MESSAGES|POSITION|PRIORITY|RECEIVER|RENAMING|TIMEZONE|TRAILING|ALLOCATE|CENTERED|CIRCULAR|CONTROLS|CURRENCY|DELETING|DESCRIBE|DISTANCE|ENDCATCH|EXPONENT|EXTENDED|GENERATE|IGNORING|INCLUDES|INTERNAL|MAJOR-ID|MODIFIER|NEW-LINE|OPTIONAL|PROPERTY|ROLLBACK|STARTING|SUPPLIED|ABSTRACT|CHANGING|CONTEXTS|CREATING|CUSTOMER|DATABASE|DAYLIGHT|DEFINING|DISTINCT|DIVISION|ENABLING|ENDCHAIN|ESCAPING|HARMLESS|IMPLICIT|INACTIVE|LANGUAGE|MINOR-ID|MULTIPLY|NEW-PAGE|NO-TITLE|POS_HIGH|SEPARATE|TEXTPOOL|TRANSFER|SELECTOR|DBMAXLEN|ITERATOR|SELECTOR|ARCHIVE|BIT-XOR|BYTE-CO|COLLECT|COMMENT|CURRENT|DEFAULT|DISPLAY|ENDFORM|EXTRACT|LEADING|LISTBOX|LOCATOR|MEMBERS|METHODS|NESTING|POS_LOW|PROCESS|PROVIDE|RAISING|RESERVE|SECONDS|SUMMARY|VISIBLE|BETWEEN|BIT-AND|BYTE-CS|CLEANUP|COMPUTE|CONTROL|CONVERT|DATASET|ENDCASE|FORWARD|HEADERS|HOTSPOT|INCLUDE|INVERSE|KEEPING|NO-ZERO|OBJECTS|OVERLAY|PADDING|PATTERN|PROGRAM|REFRESH|SECTION|SUMMING|TESTING|VERSION|WINDOWS|WITHOUT|BIT-NOT|BYTE-CA|BYTE-NA|CASTING|CONTEXT|COUNTRY|DYNAMIC|ENABLED|ENDLOOP|EXECUTE|FRIENDS|HANDLER|HEADING|INITIAL|\*-INPUT|LOGFILE|MAXIMUM|MINIMUM|NO-GAPS|NO-SIGN|PRAGMAS|PRIMARY|PRIVATE|REDUCED|REPLACE|REQUEST|RESULTS|UNICODE|WARNING|ALIASES|BYTE-CN|BYTE-NS|CALLING|COL_KEY|COLUMNS|CONNECT|ENDEXEC|ENTRIES|EXCLUDE|FILTERS|FURTHER|HELP-ID|LOGICAL|MAPPING|MESSAGE|NAMETAB|OPTIONS|PACKAGE|PERFORM|RECEIVE|STATICS|VARYING|BINDING|CHARLEN|GREATER|XSTRLEN|ACCEPT|APPEND|DETAIL|ELSEIF|ENDING|ENDTRY|FORMAT|FRAMES|GIVING|HASHED|HEADER|IMPORT|INSERT|MARGIN|MODULE|NATIVE|OBJECT|OFFSET|REMOTE|RESUME|SAVING|SIMPLE|SUBMIT|TABBED|TOKENS|UNIQUE|UNPACK|UPDATE|WINDOW|YELLOW|ACTUAL|ASPECT|CENTER|CURSOR|DELETE|DIALOG|DIVIDE|DURING|ERRORS|EVENTS|EXTEND|FILTER|HANDLE|HAVING|IGNORE|LITTLE|MEMORY|NO-GAP|OCCURS|OPTION|PERSON|PLACES|PUBLIC|REDUCE|REPORT|RESULT|SINGLE|SORTED|SWITCH|SYNTAX|TARGET|VALUES|WRITER|ASSERT|BLOCKS|BOUNDS|BUFFER|CHANGE|COLUMN|COMMIT|CONCAT|COPIES|CREATE|DDMMYY|DEFINE|ENDIAN|ESCAPE|EXPAND|KERNEL|LAYOUT|LEGACY|LEVELS|MMDDYY|NUMBER|OUTPUT|RANGES|READER|RETURN|SCREEN|SEARCH|SELECT|SHARED|SOURCE|STABLE|STATIC|SUBKEY|SUFFIX|TABLES|UNWIND|YYMMDD|ASSIGN|BACKUP|BEFORE|BINARY|BIT-OR|BLANKS|CLIENT|CODING|COMMON|DEMAND|DYNPRO|EXCEPT|EXISTS|EXPORT|FIELDS|GLOBAL|GROUPS|LENGTH|LOCALE|MEDIUM|METHOD|MODIFY|NESTED|OTHERS|REJECT|SCROLL|SUPPLY|SYMBOL|ENDFOR|STRLEN|ALIGN|BEGIN|BOUND|ENDAT|ENTRY|EVENT|FINAL|FLUSH|GRANT|INNER|SHORT|USING|WRITE|AFTER|BLACK|BLOCK|CLOCK|COLOR|COUNT|DUMMY|EMPTY|ENDDO|ENDON|GREEN|INDEX|INOUT|LEAVE|LEVEL|LINES|MODIF|ORDER|OUTER|RANGE|RESET|RETRY|RIGHT|SMART|SPLIT|STYLE|TABLE|THROW|UNDER|UNTIL|UPPER|UTF-8|WHERE|ALIAS|BLANK|CLEAR|CLOSE|EXACT|FETCH|FIRST|FOUND|GROUP|LLANG|LOCAL|OTHER|REGEX|SPOOL|TITLE|TYPES|VALID|WHILE|ALPHA|BOXED|CATCH|CHAIN|CHECK|CLASS|COVER|ENDIF|EQUIV|FIELD|FLOOR|FRAME|INPUT|LOWER|MATCH|NODES|PAGES|PRINT|RAISE|ROUND|SHIFT|SPACE|SPOTS|STAMP|STATE|TASKS|TIMES|TRMAC|ULINE|UNION|VALUE|WIDTH|EQUAL|LOG10|TRUNC|BLOB|CASE|CEIL|CLOB|COND|EXIT|FILE|GAPS|HOLD|INCL|INTO|KEEP|KEYS|LAST|LINE|LONG|LPAD|MAIL|MODE|OPEN|PINK|READ|ROWS|TEST|THEN|ZERO|AREA|BACK|BADI|BYTE|CAST|EDIT|EXEC|FAIL|FIND|FKEQ|FONT|FREE|GKEQ|HIDE|INIT|ITNO|LATE|LOOP|MAIN|MARK|MOVE|NEXT|NULL|RISK|ROLE|UNIT|WAIT|ZONE|BASE|CALL|CODE|DATA|DATE|FKGE|GKGE|HIGH|KIND|LEFT|LIST|MASK|MESH|NAME|NODE|PACK|PAGE|POOL|SEND|SIGN|SIZE|SOME|STOP|TASK|TEXT|TIME|USER|VARY|WITH|WORD|BLUE|CONV|COPY|DEEP|ELSE|FORM|FROM|HINT|ICON|JOIN|LIKE|LOAD|ONLY|PART|SCAN|SKIP|SORT|TYPE|UNIX|VIEW|WHEN|WORK|ACOS|ASIN|ATAN|COSH|EACH|FRAC|LESS|RTTI|SINH|SQRT|TANH|AVG|BIT|DIV|ISO|LET|OUT|PAD|SQL|ALL|CI_|CPI|END|LOB|LPI|MAX|MIN|NEW|OLE|RUN|SET|\?TO|YES|ABS|ADD|AND|BIG|FOR|HDB|JOB|LOW|NOT|SAP|TRY|VIA|XML|ANY|GET|IDS|KEY|MOD|OFF|PUT|RAW|RED|REF|SUM|TAB|XSD|CNT|COS|EXP|LOG|SIN|TAN|XOR|AT|CO|CP|DO|GT|ID|IF|NS|OR|BT|CA|CS|GE|NA|NB|EQ|IN|LT|NE|NO|OF|ON|PF|TO|AS|BY|CN|IS|LE|NP|UP|E|I|M|O|Z|C|X)\b/i,
      lookbehind: true
    },
    /* Numbers can be only integers. Decimal or Hex appear only as strings */
    number: /\b\d+\b/,
    /* Operators must always be surrounded by whitespace, they cannot be put
adjacent to operands.
*/
    operator: {
      pattern: /(\s)(?:\*\*?|<[=>]?|>=?|\?=|[-+\/=])(?=\s)/,
      lookbehind: true
    },
    'string-operator': {
      pattern: /(\s)&&?(?=\s)/,
      lookbehind: true,
      /* The official editor highlights */
      alias: 'keyword'
    },
    'token-operator': [
      {
        /* Special operators used to access structure components, class methods/attributes, etc. */
        pattern: /(\w)(?:->?|=>|[~|{}])(?=\w)/,
        lookbehind: true,
        alias: 'punctuation'
      },
      {
        /* Special tokens used do delimit string templates */
        pattern: /[|{}]/,
        alias: 'punctuation'
      }
    ],
    punctuation: /[,.:()]/
  }
}


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = actionscript
actionscript.displayName = 'actionscript'
actionscript.aliases = []
function actionscript(Prism) {
  Prism.languages.actionscript = Prism.languages.extend('javascript', {
    keyword: /\b(?:as|break|case|catch|class|const|default|delete|do|else|extends|finally|for|function|if|implements|import|in|instanceof|interface|internal|is|native|new|null|package|private|protected|public|return|super|switch|this|throw|try|typeof|use|var|void|while|with|dynamic|each|final|get|include|namespace|native|override|set|static)\b/,
    operator: /\+\+|--|(?:[+\-*\/%^]|&&?|\|\|?|<<?|>>?>?|[!=]=?)=?|[~?@]/
  })
  Prism.languages.actionscript['class-name'].alias = 'function'
  if (Prism.languages.markup) {
    Prism.languages.insertBefore('actionscript', 'string', {
      xml: {
        pattern: /(^|[^.])<\/?\w+(?:\s+[^\s>\/=]+=("|')(?:\\[\s\S]|(?!\2)[^\\])*\2)*\s*\/?>/,
        lookbehind: true,
        inside: {
          rest: Prism.languages.markup
        }
      }
    })
  }
}


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = ada
ada.displayName = 'ada'
ada.aliases = []
function ada(Prism) {
  Prism.languages.ada = {
    comment: /--.*/,
    string: /"(?:""|[^"\r\f\n])*"/i,
    number: [
      {
        pattern: /\b\d(?:_?\d)*#[\dA-F](?:_?[\dA-F])*(?:\.[\dA-F](?:_?[\dA-F])*)?#(?:E[+-]?\d(?:_?\d)*)?/i
      },
      {
        pattern: /\b\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:E[+-]?\d(?:_?\d)*)?\b/i
      }
    ],
    'attr-name': /\b'\w+/i,
    keyword: /\b(?:abort|abs|abstract|accept|access|aliased|all|and|array|at|begin|body|case|constant|declare|delay|delta|digits|do|else|new|return|elsif|end|entry|exception|exit|for|function|generic|goto|if|in|interface|is|limited|loop|mod|not|null|of|others|out|overriding|package|pragma|private|procedure|protected|raise|range|record|rem|renames|requeue|reverse|select|separate|some|subtype|synchronized|tagged|task|terminate|then|type|until|use|when|while|with|xor)\b/i,
    boolean: /\b(?:true|false)\b/i,
    operator: /<[=>]?|>=?|=>?|:=|\/=?|\*\*?|[&+-]/,
    punctuation: /\.\.?|[,;():]/,
    char: /'.'/,
    variable: /\b[a-z](?:[_a-z\d])*\b/i
  }
}


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = apacheconf
apacheconf.displayName = 'apacheconf'
apacheconf.aliases = []
function apacheconf(Prism) {
  Prism.languages.apacheconf = {
    comment: /#.*/,
    'directive-inline': {
      pattern: /^(\s*)\b(?:AcceptFilter|AcceptPathInfo|AccessFileName|Action|AddAlt|AddAltByEncoding|AddAltByType|AddCharset|AddDefaultCharset|AddDescription|AddEncoding|AddHandler|AddIcon|AddIconByEncoding|AddIconByType|AddInputFilter|AddLanguage|AddModuleInfo|AddOutputFilter|AddOutputFilterByType|AddType|Alias|AliasMatch|Allow|AllowCONNECT|AllowEncodedSlashes|AllowMethods|AllowOverride|AllowOverrideList|Anonymous|Anonymous_LogEmail|Anonymous_MustGiveEmail|Anonymous_NoUserID|Anonymous_VerifyEmail|AsyncRequestWorkerFactor|AuthBasicAuthoritative|AuthBasicFake|AuthBasicProvider|AuthBasicUseDigestAlgorithm|AuthDBDUserPWQuery|AuthDBDUserRealmQuery|AuthDBMGroupFile|AuthDBMType|AuthDBMUserFile|AuthDigestAlgorithm|AuthDigestDomain|AuthDigestNonceLifetime|AuthDigestProvider|AuthDigestQop|AuthDigestShmemSize|AuthFormAuthoritative|AuthFormBody|AuthFormDisableNoStore|AuthFormFakeBasicAuth|AuthFormLocation|AuthFormLoginRequiredLocation|AuthFormLoginSuccessLocation|AuthFormLogoutLocation|AuthFormMethod|AuthFormMimetype|AuthFormPassword|AuthFormProvider|AuthFormSitePassphrase|AuthFormSize|AuthFormUsername|AuthGroupFile|AuthLDAPAuthorizePrefix|AuthLDAPBindAuthoritative|AuthLDAPBindDN|AuthLDAPBindPassword|AuthLDAPCharsetConfig|AuthLDAPCompareAsUser|AuthLDAPCompareDNOnServer|AuthLDAPDereferenceAliases|AuthLDAPGroupAttribute|AuthLDAPGroupAttributeIsDN|AuthLDAPInitialBindAsUser|AuthLDAPInitialBindPattern|AuthLDAPMaxSubGroupDepth|AuthLDAPRemoteUserAttribute|AuthLDAPRemoteUserIsDN|AuthLDAPSearchAsUser|AuthLDAPSubGroupAttribute|AuthLDAPSubGroupClass|AuthLDAPUrl|AuthMerging|AuthName|AuthnCacheContext|AuthnCacheEnable|AuthnCacheProvideFor|AuthnCacheSOCache|AuthnCacheTimeout|AuthnzFcgiCheckAuthnProvider|AuthnzFcgiDefineProvider|AuthType|AuthUserFile|AuthzDBDLoginToReferer|AuthzDBDQuery|AuthzDBDRedirectQuery|AuthzDBMType|AuthzSendForbiddenOnFailure|BalancerGrowth|BalancerInherit|BalancerMember|BalancerPersist|BrowserMatch|BrowserMatchNoCase|BufferedLogs|BufferSize|CacheDefaultExpire|CacheDetailHeader|CacheDirLength|CacheDirLevels|CacheDisable|CacheEnable|CacheFile|CacheHeader|CacheIgnoreCacheControl|CacheIgnoreHeaders|CacheIgnoreNoLastMod|CacheIgnoreQueryString|CacheIgnoreURLSessionIdentifiers|CacheKeyBaseURL|CacheLastModifiedFactor|CacheLock|CacheLockMaxAge|CacheLockPath|CacheMaxExpire|CacheMaxFileSize|CacheMinExpire|CacheMinFileSize|CacheNegotiatedDocs|CacheQuickHandler|CacheReadSize|CacheReadTime|CacheRoot|CacheSocache|CacheSocacheMaxSize|CacheSocacheMaxTime|CacheSocacheMinTime|CacheSocacheReadSize|CacheSocacheReadTime|CacheStaleOnError|CacheStoreExpired|CacheStoreNoStore|CacheStorePrivate|CGIDScriptTimeout|CGIMapExtension|CharsetDefault|CharsetOptions|CharsetSourceEnc|CheckCaseOnly|CheckSpelling|ChrootDir|ContentDigest|CookieDomain|CookieExpires|CookieName|CookieStyle|CookieTracking|CoreDumpDirectory|CustomLog|Dav|DavDepthInfinity|DavGenericLockDB|DavLockDB|DavMinTimeout|DBDExptime|DBDInitSQL|DBDKeep|DBDMax|DBDMin|DBDParams|DBDPersist|DBDPrepareSQL|DBDriver|DefaultIcon|DefaultLanguage|DefaultRuntimeDir|DefaultType|Define|DeflateBufferSize|DeflateCompressionLevel|DeflateFilterNote|DeflateInflateLimitRequestBody|DeflateInflateRatioBurst|DeflateInflateRatioLimit|DeflateMemLevel|DeflateWindowSize|Deny|DirectoryCheckHandler|DirectoryIndex|DirectoryIndexRedirect|DirectorySlash|DocumentRoot|DTracePrivileges|DumpIOInput|DumpIOOutput|EnableExceptionHook|EnableMMAP|EnableSendfile|Error|ErrorDocument|ErrorLog|ErrorLogFormat|Example|ExpiresActive|ExpiresByType|ExpiresDefault|ExtendedStatus|ExtFilterDefine|ExtFilterOptions|FallbackResource|FileETag|FilterChain|FilterDeclare|FilterProtocol|FilterProvider|FilterTrace|ForceLanguagePriority|ForceType|ForensicLog|GprofDir|GracefulShutdownTimeout|Group|Header|HeaderName|HeartbeatAddress|HeartbeatListen|HeartbeatMaxServers|HeartbeatStorage|HeartbeatStorage|HostnameLookups|IdentityCheck|IdentityCheckTimeout|ImapBase|ImapDefault|ImapMenu|Include|IncludeOptional|IndexHeadInsert|IndexIgnore|IndexIgnoreReset|IndexOptions|IndexOrderDefault|IndexStyleSheet|InputSed|ISAPIAppendLogToErrors|ISAPIAppendLogToQuery|ISAPICacheFile|ISAPIFakeAsync|ISAPILogNotSupported|ISAPIReadAheadBuffer|KeepAlive|KeepAliveTimeout|KeptBodySize|LanguagePriority|LDAPCacheEntries|LDAPCacheTTL|LDAPConnectionPoolTTL|LDAPConnectionTimeout|LDAPLibraryDebug|LDAPOpCacheEntries|LDAPOpCacheTTL|LDAPReferralHopLimit|LDAPReferrals|LDAPRetries|LDAPRetryDelay|LDAPSharedCacheFile|LDAPSharedCacheSize|LDAPTimeout|LDAPTrustedClientCert|LDAPTrustedGlobalCert|LDAPTrustedMode|LDAPVerifyServerCert|LimitInternalRecursion|LimitRequestBody|LimitRequestFields|LimitRequestFieldSize|LimitRequestLine|LimitXMLRequestBody|Listen|ListenBackLog|LoadFile|LoadModule|LogFormat|LogLevel|LogMessage|LuaAuthzProvider|LuaCodeCache|LuaHookAccessChecker|LuaHookAuthChecker|LuaHookCheckUserID|LuaHookFixups|LuaHookInsertFilter|LuaHookLog|LuaHookMapToStorage|LuaHookTranslateName|LuaHookTypeChecker|LuaInherit|LuaInputFilter|LuaMapHandler|LuaOutputFilter|LuaPackageCPath|LuaPackagePath|LuaQuickHandler|LuaRoot|LuaScope|MaxConnectionsPerChild|MaxKeepAliveRequests|MaxMemFree|MaxRangeOverlaps|MaxRangeReversals|MaxRanges|MaxRequestWorkers|MaxSpareServers|MaxSpareThreads|MaxThreads|MergeTrailers|MetaDir|MetaFiles|MetaSuffix|MimeMagicFile|MinSpareServers|MinSpareThreads|MMapFile|ModemStandard|ModMimeUsePathInfo|MultiviewsMatch|Mutex|NameVirtualHost|NoProxy|NWSSLTrustedCerts|NWSSLUpgradeable|Options|Order|OutputSed|PassEnv|PidFile|PrivilegesMode|Protocol|ProtocolEcho|ProxyAddHeaders|ProxyBadHeader|ProxyBlock|ProxyDomain|ProxyErrorOverride|ProxyExpressDBMFile|ProxyExpressDBMType|ProxyExpressEnable|ProxyFtpDirCharset|ProxyFtpEscapeWildcards|ProxyFtpListOnWildcard|ProxyHTMLBufSize|ProxyHTMLCharsetOut|ProxyHTMLDocType|ProxyHTMLEnable|ProxyHTMLEvents|ProxyHTMLExtended|ProxyHTMLFixups|ProxyHTMLInterp|ProxyHTMLLinks|ProxyHTMLMeta|ProxyHTMLStripComments|ProxyHTMLURLMap|ProxyIOBufferSize|ProxyMaxForwards|ProxyPass|ProxyPassInherit|ProxyPassInterpolateEnv|ProxyPassMatch|ProxyPassReverse|ProxyPassReverseCookieDomain|ProxyPassReverseCookiePath|ProxyPreserveHost|ProxyReceiveBufferSize|ProxyRemote|ProxyRemoteMatch|ProxyRequests|ProxySCGIInternalRedirect|ProxySCGISendfile|ProxySet|ProxySourceAddress|ProxyStatus|ProxyTimeout|ProxyVia|ReadmeName|ReceiveBufferSize|Redirect|RedirectMatch|RedirectPermanent|RedirectTemp|ReflectorHeader|RemoteIPHeader|RemoteIPInternalProxy|RemoteIPInternalProxyList|RemoteIPProxiesHeader|RemoteIPTrustedProxy|RemoteIPTrustedProxyList|RemoveCharset|RemoveEncoding|RemoveHandler|RemoveInputFilter|RemoveLanguage|RemoveOutputFilter|RemoveType|RequestHeader|RequestReadTimeout|Require|RewriteBase|RewriteCond|RewriteEngine|RewriteMap|RewriteOptions|RewriteRule|RLimitCPU|RLimitMEM|RLimitNPROC|Satisfy|ScoreBoardFile|Script|ScriptAlias|ScriptAliasMatch|ScriptInterpreterSource|ScriptLog|ScriptLogBuffer|ScriptLogLength|ScriptSock|SecureListen|SeeRequestTail|SendBufferSize|ServerAdmin|ServerAlias|ServerLimit|ServerName|ServerPath|ServerRoot|ServerSignature|ServerTokens|Session|SessionCookieName|SessionCookieName2|SessionCookieRemove|SessionCryptoCipher|SessionCryptoDriver|SessionCryptoPassphrase|SessionCryptoPassphraseFile|SessionDBDCookieName|SessionDBDCookieName2|SessionDBDCookieRemove|SessionDBDDeleteLabel|SessionDBDInsertLabel|SessionDBDPerUser|SessionDBDSelectLabel|SessionDBDUpdateLabel|SessionEnv|SessionExclude|SessionHeader|SessionInclude|SessionMaxAge|SetEnv|SetEnvIf|SetEnvIfExpr|SetEnvIfNoCase|SetHandler|SetInputFilter|SetOutputFilter|SSIEndTag|SSIErrorMsg|SSIETag|SSILastModified|SSILegacyExprParser|SSIStartTag|SSITimeFormat|SSIUndefinedEcho|SSLCACertificateFile|SSLCACertificatePath|SSLCADNRequestFile|SSLCADNRequestPath|SSLCARevocationCheck|SSLCARevocationFile|SSLCARevocationPath|SSLCertificateChainFile|SSLCertificateFile|SSLCertificateKeyFile|SSLCipherSuite|SSLCompression|SSLCryptoDevice|SSLEngine|SSLFIPS|SSLHonorCipherOrder|SSLInsecureRenegotiation|SSLOCSPDefaultResponder|SSLOCSPEnable|SSLOCSPOverrideResponder|SSLOCSPResponderTimeout|SSLOCSPResponseMaxAge|SSLOCSPResponseTimeSkew|SSLOCSPUseRequestNonce|SSLOpenSSLConfCmd|SSLOptions|SSLPassPhraseDialog|SSLProtocol|SSLProxyCACertificateFile|SSLProxyCACertificatePath|SSLProxyCARevocationCheck|SSLProxyCARevocationFile|SSLProxyCARevocationPath|SSLProxyCheckPeerCN|SSLProxyCheckPeerExpire|SSLProxyCheckPeerName|SSLProxyCipherSuite|SSLProxyEngine|SSLProxyMachineCertificateChainFile|SSLProxyMachineCertificateFile|SSLProxyMachineCertificatePath|SSLProxyProtocol|SSLProxyVerify|SSLProxyVerifyDepth|SSLRandomSeed|SSLRenegBufferSize|SSLRequire|SSLRequireSSL|SSLSessionCache|SSLSessionCacheTimeout|SSLSessionTicketKeyFile|SSLSRPUnknownUserSeed|SSLSRPVerifierFile|SSLStaplingCache|SSLStaplingErrorCacheTimeout|SSLStaplingFakeTryLater|SSLStaplingForceURL|SSLStaplingResponderTimeout|SSLStaplingResponseMaxAge|SSLStaplingResponseTimeSkew|SSLStaplingReturnResponderErrors|SSLStaplingStandardCacheTimeout|SSLStrictSNIVHostCheck|SSLUserName|SSLUseStapling|SSLVerifyClient|SSLVerifyDepth|StartServers|StartThreads|Substitute|Suexec|SuexecUserGroup|ThreadLimit|ThreadsPerChild|ThreadStackSize|TimeOut|TraceEnable|TransferLog|TypesConfig|UnDefine|UndefMacro|UnsetEnv|Use|UseCanonicalName|UseCanonicalPhysicalPort|User|UserDir|VHostCGIMode|VHostCGIPrivs|VHostGroup|VHostPrivs|VHostSecure|VHostUser|VirtualDocumentRoot|VirtualDocumentRootIP|VirtualScriptAlias|VirtualScriptAliasIP|WatchdogInterval|XBitHack|xml2EncAlias|xml2EncDefault|xml2StartParse)\b/im,
      lookbehind: true,
      alias: 'property'
    },
    'directive-block': {
      pattern: /<\/?\b(?:AuthnProviderAlias|AuthzProviderAlias|Directory|DirectoryMatch|Else|ElseIf|Files|FilesMatch|If|IfDefine|IfModule|IfVersion|Limit|LimitExcept|Location|LocationMatch|Macro|Proxy|RequireAll|RequireAny|RequireNone|VirtualHost)\b *.*>/i,
      inside: {
        'directive-block': {
          pattern: /^<\/?\w+/,
          inside: {
            punctuation: /^<\/?/
          },
          alias: 'tag'
        },
        'directive-block-parameter': {
          pattern: /.*[^>]/,
          inside: {
            punctuation: /:/,
            string: {
              pattern: /("|').*\1/,
              inside: {
                variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/
              }
            }
          },
          alias: 'attr-value'
        },
        punctuation: />/
      },
      alias: 'tag'
    },
    'directive-flags': {
      pattern: /\[(?:\w,?)+\]/,
      alias: 'keyword'
    },
    string: {
      pattern: /("|').*\1/,
      inside: {
        variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/
      }
    },
    variable: /[$%]\{?(?:\w\.?[-+:]?)+\}?/,
    regex: /\^?.*\$|\^.*\$?/
  }
}


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = apl
apl.displayName = 'apl'
apl.aliases = []
function apl(Prism) {
  Prism.languages.apl = {
    comment: /(?:⍝|#[! ]).*$/m,
    string: {
      pattern: /'(?:[^'\r\n]|'')*'/,
      greedy: true
    },
    number: /¯?(?:\d*\.?\d+(?:e[+¯]?\d+)?|¯|∞)(?:j¯?(?:\d*\.?\d+(?:e[+¯]?\d+)?|¯|∞))?/i,
    statement: /:[A-Z][a-z][A-Za-z]*\b/,
    'system-function': {
      pattern: /⎕[A-Z]+/i,
      alias: 'function'
    },
    constant: /[⍬⌾#⎕⍞]/,
    function: /[-+×÷⌈⌊∣|⍳⍸?*⍟○!⌹<≤=>≥≠≡≢∊⍷∪∩~∨∧⍱⍲⍴,⍪⌽⊖⍉↑↓⊂⊃⊆⊇⌷⍋⍒⊤⊥⍕⍎⊣⊢⍁⍂≈⍯↗¤→]/,
    'monadic-operator': {
      pattern: /[\\\/⌿⍀¨⍨⌶&∥]/,
      alias: 'operator'
    },
    'dyadic-operator': {
      pattern: /[.⍣⍠⍤∘⌸@⌺]/,
      alias: 'operator'
    },
    assignment: {
      pattern: /←/,
      alias: 'keyword'
    },
    punctuation: /[\[;\]()◇⋄]/,
    dfn: {
      pattern: /[{}⍺⍵⍶⍹∇⍫:]/,
      alias: 'builtin'
    }
  }
}


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = applescript
applescript.displayName = 'applescript'
applescript.aliases = []
function applescript(Prism) {
  Prism.languages.applescript = {
    comment: [
      // Allow one level of nesting
      /\(\*(?:\(\*[\s\S]*?\*\)|[\s\S])*?\*\)/,
      /--.+/,
      /#.+/
    ],
    string: /"(?:\\.|[^"\\\r\n])*"/,
    number: /(?:\b\d+\.?\d*|\B\.\d+)(?:e-?\d+)?\b/i,
    operator: [
      /[&=≠≤≥*+\-\/÷^]|[<>]=?/,
      /\b(?:(?:start|begin|end)s? with|(?:(?:does not|doesn't) contain|contains?)|(?:is|isn't|is not) (?:in|contained by)|(?:(?:is|isn't|is not) )?(?:greater|less) than(?: or equal)?(?: to)?|(?:(?:does not|doesn't) come|comes) (?:before|after)|(?:is|isn't|is not) equal(?: to)?|(?:(?:does not|doesn't) equal|equals|equal to|isn't|is not)|(?:a )?(?:ref(?: to)?|reference to)|(?:and|or|div|mod|as|not))\b/
    ],
    keyword: /\b(?:about|above|after|against|apart from|around|aside from|at|back|before|beginning|behind|below|beneath|beside|between|but|by|considering|continue|copy|does|eighth|else|end|equal|error|every|exit|false|fifth|first|for|fourth|from|front|get|given|global|if|ignoring|in|instead of|into|is|it|its|last|local|me|middle|my|ninth|of|on|onto|out of|over|prop|property|put|repeat|return|returning|second|set|seventh|since|sixth|some|tell|tenth|that|the|then|third|through|thru|timeout|times|to|transaction|true|try|until|where|while|whose|with|without)\b/,
    class: {
      pattern: /\b(?:alias|application|boolean|class|constant|date|file|integer|list|number|POSIX file|real|record|reference|RGB color|script|text|centimetres|centimeters|feet|inches|kilometres|kilometers|metres|meters|miles|yards|square feet|square kilometres|square kilometers|square metres|square meters|square miles|square yards|cubic centimetres|cubic centimeters|cubic feet|cubic inches|cubic metres|cubic meters|cubic yards|gallons|litres|liters|quarts|grams|kilograms|ounces|pounds|degrees Celsius|degrees Fahrenheit|degrees Kelvin)\b/,
      alias: 'builtin'
    },
    punctuation: /[{}():,¬«»《》]/
  }
}


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var refractorCpp = __webpack_require__(307)
module.exports = arduino
arduino.displayName = 'arduino'
arduino.aliases = []
function arduino(Prism) {
  Prism.register(refractorCpp)
  Prism.languages.arduino = Prism.languages.extend('cpp', {
    keyword: /\b(?:setup|if|else|while|do|for|return|in|instanceof|default|function|loop|goto|switch|case|new|try|throw|catch|finally|null|break|continue|boolean|bool|void|byte|word|string|String|array|int|long|integer|double)\b/,
    builtin: /\b(?:KeyboardController|MouseController|SoftwareSerial|EthernetServer|EthernetClient|LiquidCrystal|LiquidCrystal_I2C|RobotControl|GSMVoiceCall|EthernetUDP|EsploraTFT|HttpClient|RobotMotor|WiFiClient|GSMScanner|FileSystem|Scheduler|GSMServer|YunClient|YunServer|IPAddress|GSMClient|GSMModem|Keyboard|Ethernet|Console|GSMBand|Esplora|Stepper|Process|WiFiUDP|GSM_SMS|Mailbox|USBHost|Firmata|PImage|Client|Server|GSMPIN|FileIO|Bridge|Serial|EEPROM|Stream|Mouse|Audio|Servo|File|Task|GPRS|WiFi|Wire|TFT|GSM|SPI|SD|runShellCommandAsynchronously|analogWriteResolution|retrieveCallingNumber|printFirmwareVersion|analogReadResolution|sendDigitalPortPair|noListenOnLocalhost|readJoystickButton|setFirmwareVersion|readJoystickSwitch|scrollDisplayRight|getVoiceCallStatus|scrollDisplayLeft|writeMicroseconds|delayMicroseconds|beginTransmission|getSignalStrength|runAsynchronously|getAsynchronously|listenOnLocalhost|getCurrentCarrier|readAccelerometer|messageAvailable|sendDigitalPorts|lineFollowConfig|countryNameWrite|runShellCommand|readStringUntil|rewindDirectory|readTemperature|setClockDivider|readLightSensor|endTransmission|analogReference|detachInterrupt|countryNameRead|attachInterrupt|encryptionType|readBytesUntil|robotNameWrite|readMicrophone|robotNameRead|cityNameWrite|userNameWrite|readJoystickY|readJoystickX|mouseReleased|openNextFile|scanNetworks|noInterrupts|digitalWrite|beginSpeaker|mousePressed|isActionDone|mouseDragged|displayLogos|noAutoscroll|addParameter|remoteNumber|getModifiers|keyboardRead|userNameRead|waitContinue|processInput|parseCommand|printVersion|readNetworks|writeMessage|blinkVersion|cityNameRead|readMessage|setDataMode|parsePacket|isListening|setBitOrder|beginPacket|isDirectory|motorsWrite|drawCompass|digitalRead|clearScreen|serialEvent|rightToLeft|setTextSize|leftToRight|requestFrom|keyReleased|compassRead|analogWrite|interrupts|WiFiServer|disconnect|playMelody|parseFloat|autoscroll|getPINUsed|setPINUsed|setTimeout|sendAnalog|readSlider|analogRead|beginWrite|createChar|motorsStop|keyPressed|tempoWrite|readButton|subnetMask|debugPrint|macAddress|writeGreen|randomSeed|attachGPRS|readString|sendString|remotePort|releaseAll|mouseMoved|background|getXChange|getYChange|answerCall|getResult|voiceCall|endPacket|constrain|getSocket|writeJSON|getButton|available|connected|findUntil|readBytes|exitValue|readGreen|writeBlue|startLoop|IPAddress|isPressed|sendSysex|pauseMode|gatewayIP|setCursor|getOemKey|tuneWrite|noDisplay|loadImage|switchPIN|onRequest|onReceive|changePIN|playFile|noBuffer|parseInt|overflow|checkPIN|knobRead|beginTFT|bitClear|updateIR|bitWrite|position|writeRGB|highByte|writeRed|setSpeed|readBlue|noStroke|remoteIP|transfer|shutdown|hangCall|beginSMS|endWrite|attached|maintain|noCursor|checkReg|checkPUK|shiftOut|isValid|shiftIn|pulseIn|connect|println|localIP|pinMode|getIMEI|display|noBlink|process|getBand|running|beginSD|drawBMP|lowByte|setBand|release|bitRead|prepare|pointTo|readRed|setMode|noFill|remove|listen|stroke|detach|attach|noTone|exists|buffer|height|bitSet|circle|config|cursor|random|IRread|setDNS|endSMS|getKey|micros|millis|begin|print|write|ready|flush|width|isPIN|blink|clear|press|mkdir|rmdir|close|point|yield|image|BSSID|click|delay|read|text|move|peek|beep|rect|line|open|seek|fill|size|turn|stop|home|find|step|tone|sqrt|RSSI|SSID|end|bit|tan|cos|sin|pow|map|abs|max|min|get|run|put)\b/,
    constant: /\b(?:DIGITAL_MESSAGE|FIRMATA_STRING|ANALOG_MESSAGE|REPORT_DIGITAL|REPORT_ANALOG|INPUT_PULLUP|SET_PIN_MODE|INTERNAL2V56|SYSTEM_RESET|LED_BUILTIN|INTERNAL1V1|SYSEX_START|INTERNAL|EXTERNAL|DEFAULT|OUTPUT|INPUT|HIGH|LOW)\b/
  })
}


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = arff
arff.displayName = 'arff'
arff.aliases = []
function arff(Prism) {
  Prism.languages.arff = {
    comment: /%.*/,
    string: {
      pattern: /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
      greedy: true
    },
    keyword: /@(?:attribute|data|end|relation)\b/i,
    number: /\b\d+(?:\.\d+)?\b/,
    punctuation: /[{},]/
  }
}


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = asciidoc
asciidoc.displayName = 'asciidoc'
asciidoc.aliases = []
function asciidoc(Prism) {
  ;(function(Prism) {
    var attributes = {
      pattern: /(^[ \t]*)\[(?!\[)(?:(["'$`])(?:(?!\2)[^\\]|\\.)*\2|\[(?:[^\]\\]|\\.)*\]|[^\]\\]|\\.)*\]/m,
      lookbehind: true,
      inside: {
        quoted: {
          pattern: /([$`])(?:(?!\1)[^\\]|\\.)*\1/,
          inside: {
            punctuation: /^[$`]|[$`]$/
          }
        },
        interpreted: {
          pattern: /'(?:[^'\\]|\\.)*'/,
          inside: {
            punctuation: /^'|'$/
            // See rest below
          }
        },
        string: /"(?:[^"\\]|\\.)*"/,
        variable: /\w+(?==)/,
        punctuation: /^\[|\]$|,/,
        operator: /=/,
        // The negative look-ahead prevents blank matches
        'attr-value': /(?!^\s+$).+/
      }
    }
    Prism.languages.asciidoc = {
      'comment-block': {
        pattern: /^(\/{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1/m,
        alias: 'comment'
      },
      table: {
        pattern: /^\|={3,}(?:(?:\r?\n|\r).*)*?(?:\r?\n|\r)\|={3,}$/m,
        inside: {
          specifiers: {
            pattern: /(?!\|)(?:(?:(?:\d+(?:\.\d+)?|\.\d+)[+*])?(?:[<^>](?:\.[<^>])?|\.[<^>])?[a-z]*)(?=\|)/,
            alias: 'attr-value'
          },
          punctuation: {
            pattern: /(^|[^\\])[|!]=*/,
            lookbehind: true
            // See rest below
          }
        }
      },
      'passthrough-block': {
        pattern: /^(\+{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
        inside: {
          punctuation: /^\++|\++$/
          // See rest below
        }
      },
      // Literal blocks and listing blocks
      'literal-block': {
        pattern: /^(-{4,}|\.{4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
        inside: {
          punctuation: /^(?:-+|\.+)|(?:-+|\.+)$/
          // See rest below
        }
      },
      // Sidebar blocks, quote blocks, example blocks and open blocks
      'other-block': {
        pattern: /^(--|\*{4,}|_{4,}|={4,})(?:\r?\n|\r)(?:[\s\S]*(?:\r?\n|\r))??\1$/m,
        inside: {
          punctuation: /^(?:-+|\*+|_+|=+)|(?:-+|\*+|_+|=+)$/
          // See rest below
        }
      },
      // list-punctuation and list-label must appear before indented-block
      'list-punctuation': {
        pattern: /(^[ \t]*)(?:-|\*{1,5}|\.{1,5}|(?:[a-z]|\d+)\.|[xvi]+\))(?= )/im,
        lookbehind: true,
        alias: 'punctuation'
      },
      'list-label': {
        pattern: /(^[ \t]*)[a-z\d].+(?::{2,4}|;;)(?=\s)/im,
        lookbehind: true,
        alias: 'symbol'
      },
      'indented-block': {
        pattern: /((\r?\n|\r)\2)([ \t]+)\S.*(?:(?:\r?\n|\r)\3.+)*(?=\2{2}|$)/,
        lookbehind: true
      },
      comment: /^\/\/.*/m,
      title: {
        pattern: /^.+(?:\r?\n|\r)(?:={3,}|-{3,}|~{3,}|\^{3,}|\+{3,})$|^={1,5} +.+|^\.(?![\s.]).*/m,
        alias: 'important',
        inside: {
          punctuation: /^(?:\.|=+)|(?:=+|-+|~+|\^+|\++)$/
          // See rest below
        }
      },
      'attribute-entry': {
        pattern: /^:[^:\r\n]+:(?: .*?(?: \+(?:\r?\n|\r).*?)*)?$/m,
        alias: 'tag'
      },
      attributes: attributes,
      hr: {
        pattern: /^'{3,}$/m,
        alias: 'punctuation'
      },
      'page-break': {
        pattern: /^<{3,}$/m,
        alias: 'punctuation'
      },
      admonition: {
        pattern: /^(?:TIP|NOTE|IMPORTANT|WARNING|CAUTION):/m,
        alias: 'keyword'
      },
      callout: [
        {
          pattern: /(^[ \t]*)<?\d*>/m,
          lookbehind: true,
          alias: 'symbol'
        },
        {
          pattern: /<\d+>/,
          alias: 'symbol'
        }
      ],
      macro: {
        pattern: /\b[a-z\d][a-z\d-]*::?(?:(?:\S+)??\[(?:[^\]\\"]|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
        inside: {
          function: /^[a-z\d-]+(?=:)/,
          punctuation: /^::?/,
          attributes: {
            pattern: /(?:\[(?:[^\]\\"]|(["'])(?:(?!\1)[^\\]|\\.)*\1|\\.)*\])/,
            inside: attributes.inside
          }
        }
      },
      inline: {
        /*
The initial look-behind prevents the highlighting of escaped quoted text.
Quoted text can be multi-line but cannot span an empty line.
All quoted text can have attributes before [foobar, 'foobar', baz="bar"].
First, we handle the constrained quotes.
Those must be bounded by non-word chars and cannot have spaces between the delimiter and the first char.
They are, in order: _emphasis_, ``double quotes'', `single quotes', `monospace`, 'emphasis', *strong*, +monospace+ and #unquoted#
Then we handle the unconstrained quotes.
Those do not have the restrictions of the constrained quotes.
They are, in order: __emphasis__, **strong**, ++monospace++, +++passthrough+++, ##unquoted##, $$passthrough$$, ~subscript~, ^superscript^, {attribute-reference}, [[anchor]], [[[bibliography anchor]]], <<xref>>, (((indexes))) and ((indexes))
*/
        pattern: /(^|[^\\])(?:(?:\B\[(?:[^\]\\"]|(["'])(?:(?!\2)[^\\]|\\.)*\2|\\.)*\])?(?:\b_(?!\s)(?: _|[^_\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: _|[^_\\\r\n]|\\.)+)*_\b|\B``(?!\s).+?(?:(?:\r?\n|\r).+?)*''\B|\B`(?!\s)(?: ['`]|.)+?(?:(?:\r?\n|\r)(?: ['`]|.)+?)*['`]\B|\B(['*+#])(?!\s)(?: \3|(?!\3)[^\\\r\n]|\\.)+(?:(?:\r?\n|\r)(?: \3|(?!\3)[^\\\r\n]|\\.)+)*\3\B)|(?:\[(?:[^\]\\"]|(["'])(?:(?!\4)[^\\]|\\.)*\4|\\.)*\])?(?:(__|\*\*|\+\+\+?|##|\$\$|[~^]).+?(?:(?:\r?\n|\r).+?)*\5|\{[^}\r\n]+\}|\[\[\[?.+?(?:(?:\r?\n|\r).+?)*\]?\]\]|<<.+?(?:(?:\r?\n|\r).+?)*>>|\(\(\(?.+?(?:(?:\r?\n|\r).+?)*\)?\)\)))/m,
        lookbehind: true,
        inside: {
          attributes: attributes,
          url: {
            pattern: /^(?:\[\[\[?.+?\]?\]\]|<<.+?>>)$/,
            inside: {
              punctuation: /^(?:\[\[\[?|<<)|(?:\]\]\]?|>>)$/
            }
          },
          'attribute-ref': {
            pattern: /^\{.+\}$/,
            inside: {
              variable: {
                pattern: /(^\{)[a-z\d,+_-]+/,
                lookbehind: true
              },
              operator: /^[=?!#%@$]|!(?=[:}])/,
              punctuation: /^\{|\}$|::?/
            }
          },
          italic: {
            pattern: /^(['_])[\s\S]+\1$/,
            inside: {
              punctuation: /^(?:''?|__?)|(?:''?|__?)$/
            }
          },
          bold: {
            pattern: /^\*[\s\S]+\*$/,
            inside: {
              punctuation: /^\*\*?|\*\*?$/
            }
          },
          punctuation: /^(?:``?|\+{1,3}|##?|\$\$|[~^]|\(\(\(?)|(?:''?|\+{1,3}|##?|\$\$|[~^`]|\)?\)\))$/
        }
      },
      replacement: {
        pattern: /\((?:C|TM|R)\)/,
        alias: 'builtin'
      },
      entity: /&#?[\da-z]{1,8};/i,
      'line-continuation': {
        pattern: /(^| )\+$/m,
        lookbehind: true,
        alias: 'punctuation'
      }
    }
    // Allow some nesting. There is no recursion though, so cloning should not be needed.
    attributes.inside['interpreted'].inside.rest = {
      macro: Prism.languages.asciidoc['macro'],
      inline: Prism.languages.asciidoc['inline'],
      replacement: Prism.languages.asciidoc['replacement'],
      entity: Prism.languages.asciidoc['entity']
    }
    Prism.languages.asciidoc['passthrough-block'].inside.rest = {
      macro: Prism.languages.asciidoc['macro']
    }
    Prism.languages.asciidoc['literal-block'].inside.rest = {
      callout: Prism.languages.asciidoc['callout']
    }
    Prism.languages.asciidoc['table'].inside.rest = {
      'comment-block': Prism.languages.asciidoc['comment-block'],
      'passthrough-block': Prism.languages.asciidoc['passthrough-block'],
      'literal-block': Prism.languages.asciidoc['literal-block'],
      'other-block': Prism.languages.asciidoc['other-block'],
      'list-punctuation': Prism.languages.asciidoc['list-punctuation'],
      'indented-block': Prism.languages.asciidoc['indented-block'],
      comment: Prism.languages.asciidoc['comment'],
      title: Prism.languages.asciidoc['title'],
      'attribute-entry': Prism.languages.asciidoc['attribute-entry'],
      attributes: Prism.languages.asciidoc['attributes'],
      hr: Prism.languages.asciidoc['hr'],
      'page-break': Prism.languages.asciidoc['page-break'],
      admonition: Prism.languages.asciidoc['admonition'],
      'list-label': Prism.languages.asciidoc['list-label'],
      callout: Prism.languages.asciidoc['callout'],
      macro: Prism.languages.asciidoc['macro'],
      inline: Prism.languages.asciidoc['inline'],
      replacement: Prism.languages.asciidoc['replacement'],
      entity: Prism.languages.asciidoc['entity'],
      'line-continuation': Prism.languages.asciidoc['line-continuation']
    }
    Prism.languages.asciidoc['other-block'].inside.rest = {
      table: Prism.languages.asciidoc['table'],
      'list-punctuation': Prism.languages.asciidoc['list-punctuation'],
      'indented-block': Prism.languages.asciidoc['indented-block'],
      comment: Prism.languages.asciidoc['comment'],
      'attribute-entry': Prism.languages.asciidoc['attribute-entry'],
      attributes: Prism.languages.asciidoc['attributes'],
      hr: Prism.languages.asciidoc['hr'],
      'page-break': Prism.languages.asciidoc['page-break'],
      admonition: Prism.languages.asciidoc['admonition'],
      'list-label': Prism.languages.asciidoc['list-label'],
      macro: Prism.languages.asciidoc['macro'],
      inline: Prism.languages.asciidoc['inline'],
      replacement: Prism.languages.asciidoc['replacement'],
      entity: Prism.languages.asciidoc['entity'],
      'line-continuation': Prism.languages.asciidoc['line-continuation']
    }
    Prism.languages.asciidoc['title'].inside.rest = {
      macro: Prism.languages.asciidoc['macro'],
      inline: Prism.languages.asciidoc['inline'],
      replacement: Prism.languages.asciidoc['replacement'],
      entity: Prism.languages.asciidoc['entity']
    }
    // Plugin to make entity title show the real entity, idea by Roman Komarov
    Prism.hooks.add('wrap', function(env) {
      if (env.type === 'entity') {
        env.attributes['title'] = env.content.value.replace(/&amp;/, '&')
      }
    })
  })(Prism)
}


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = asm6502
asm6502.displayName = 'asm6502'
asm6502.aliases = []
function asm6502(Prism) {
  Prism.languages.asm6502 = {
    comment: /;.*/,
    directive: {
      pattern: /\.\w+(?= )/,
      alias: 'keyword'
    },
    string: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
    opcode: {
      pattern: /\b(?:adc|and|asl|bcc|bcs|beq|bit|bmi|bne|bpl|brk|bvc|bvs|clc|cld|cli|clv|cmp|cpx|cpy|dec|dex|dey|eor|inc|inx|iny|jmp|jsr|lda|ldx|ldy|lsr|nop|ora|pha|php|pla|plp|rol|ror|rti|rts|sbc|sec|sed|sei|sta|stx|sty|tax|tay|tsx|txa|txs|tya|ADC|AND|ASL|BCC|BCS|BEQ|BIT|BMI|BNE|BPL|BRK|BVC|BVS|CLC|CLD|CLI|CLV|CMP|CPX|CPY|DEC|DEX|DEY|EOR|INC|INX|INY|JMP|JSR|LDA|LDX|LDY|LSR|NOP|ORA|PHA|PHP|PLA|PLP|ROL|ROR|RTI|RTS|SBC|SEC|SED|SEI|STA|STX|STY|TAX|TAY|TSX|TXA|TXS|TYA)\b/,
      alias: 'property'
    },
    hexnumber: {
      pattern: /#?\$[\da-f]{2,4}/i,
      alias: 'string'
    },
    binarynumber: {
      pattern: /#?%[01]+/,
      alias: 'string'
    },
    decimalnumber: {
      pattern: /#?\d+/,
      alias: 'string'
    },
    register: {
      pattern: /\b[xya]\b/i,
      alias: 'variable'
    }
  }
}


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = aspnet
aspnet.displayName = 'aspnet'
aspnet.aliases = []
function aspnet(Prism) {
  Prism.languages.aspnet = Prism.languages.extend('markup', {
    'page-directive tag': {
      pattern: /<%\s*@.*%>/i,
      inside: {
        'page-directive tag': /<%\s*@\s*(?:Assembly|Control|Implements|Import|Master(?:Type)?|OutputCache|Page|PreviousPageType|Reference|Register)?|%>/i,
        rest: Prism.languages.markup.tag.inside
      }
    },
    'directive tag': {
      pattern: /<%.*%>/i,
      inside: {
        'directive tag': /<%\s*?[$=%#:]{0,2}|%>/i,
        rest: Prism.languages.csharp
      }
    }
  })
  // Regexp copied from prism-markup, with a negative look-ahead added
  Prism.languages.aspnet.tag.pattern = /<(?!%)\/?[^\s>\/]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/i
  // match directives of attribute value foo="<% Bar %>"
  Prism.languages.insertBefore(
    'inside',
    'punctuation',
    {
      'directive tag': Prism.languages.aspnet['directive tag']
    },
    Prism.languages.aspnet.tag.inside['attr-value']
  )
  Prism.languages.insertBefore('aspnet', 'comment', {
    'asp comment': /<%--[\s\S]*?--%>/
  })
  // script runat="server" contains csharp, not javascript
  Prism.languages.insertBefore(
    'aspnet',
    Prism.languages.javascript ? 'script' : 'tag',
    {
      'asp script': {
        pattern: /(<script(?=.*runat=['"]?server['"]?)[\s\S]*?>)[\s\S]*?(?=<\/script>)/i,
        lookbehind: true,
        inside: Prism.languages.csharp || {}
      }
    }
  )
}


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = autohotkey
autohotkey.displayName = 'autohotkey'
autohotkey.aliases = []
function autohotkey(Prism) {
  // NOTES - follows first-first highlight method, block is locked after highlight, different from SyntaxHl
  Prism.languages.autohotkey = {
    comment: {
      pattern: /(^[^";\n]*("[^"\n]*?"[^"\n]*?)*)(?:;.*$|^\s*\/\*[\s\S]*\n\*\/)/m,
      lookbehind: true
    },
    string: /"(?:[^"\n\r]|"")*"/m,
    function: /[^(); \t,\n+*\-=?>:\\\/<&%\[\]]+?(?=\()/m, //function - don't use .*\) in the end bcoz string locks it
    tag: /^[ \t]*[^\s:]+?(?=:(?:[^:]|$))/m, //labels
    variable: /%\w+%/,
    number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+\.?\d*|\B\.\d+)(?:[Ee]-?\d+)?/,
    operator: /\?|\/\/?=?|:=|\|[=|]?|&[=&]?|\+[=+]?|-[=-]?|\*[=*]?|<(?:<=?|>|=)?|>>?=?|[.^!=~]=?|\b(?:AND|NOT|OR)\b/,
    punctuation: /[{}[\]():,]/,
    boolean: /\b(?:true|false)\b/,
    selector: /\b(?:AutoTrim|BlockInput|Break|Click|ClipWait|Continue|Control|ControlClick|ControlFocus|ControlGet|ControlGetFocus|ControlGetPos|ControlGetText|ControlMove|ControlSend|ControlSendRaw|ControlSetText|CoordMode|Critical|DetectHiddenText|DetectHiddenWindows|Drive|DriveGet|DriveSpaceFree|EnvAdd|EnvDiv|EnvGet|EnvMult|EnvSet|EnvSub|EnvUpdate|Exit|ExitApp|FileAppend|FileCopy|FileCopyDir|FileCreateDir|FileCreateShortcut|FileDelete|FileEncoding|FileGetAttrib|FileGetShortcut|FileGetSize|FileGetTime|FileGetVersion|FileInstall|FileMove|FileMoveDir|FileRead|FileReadLine|FileRecycle|FileRecycleEmpty|FileRemoveDir|FileSelectFile|FileSelectFolder|FileSetAttrib|FileSetTime|FormatTime|GetKeyState|Gosub|Goto|GroupActivate|GroupAdd|GroupClose|GroupDeactivate|Gui|GuiControl|GuiControlGet|Hotkey|ImageSearch|IniDelete|IniRead|IniWrite|Input|InputBox|KeyWait|ListHotkeys|ListLines|ListVars|Loop|Menu|MouseClick|MouseClickDrag|MouseGetPos|MouseMove|MsgBox|OnExit|OutputDebug|Pause|PixelGetColor|PixelSearch|PostMessage|Process|Progress|Random|RegDelete|RegRead|RegWrite|Reload|Repeat|Return|Run|RunAs|RunWait|Send|SendEvent|SendInput|SendMessage|SendMode|SendPlay|SendRaw|SetBatchLines|SetCapslockState|SetControlDelay|SetDefaultMouseSpeed|SetEnv|SetFormat|SetKeyDelay|SetMouseDelay|SetNumlockState|SetScrollLockState|SetStoreCapslockMode|SetTimer|SetTitleMatchMode|SetWinDelay|SetWorkingDir|Shutdown|Sleep|Sort|SoundBeep|SoundGet|SoundGetWaveVolume|SoundPlay|SoundSet|SoundSetWaveVolume|SplashImage|SplashTextOff|SplashTextOn|SplitPath|StatusBarGetText|StatusBarWait|StringCaseSense|StringGetPos|StringLeft|StringLen|StringLower|StringMid|StringReplace|StringRight|StringSplit|StringTrimLeft|StringTrimRight|StringUpper|Suspend|SysGet|Thread|ToolTip|Transform|TrayTip|URLDownloadToFile|WinActivate|WinActivateBottom|WinClose|WinGet|WinGetActiveStats|WinGetActiveTitle|WinGetClass|WinGetPos|WinGetText|WinGetTitle|WinHide|WinKill|WinMaximize|WinMenuSelectItem|WinMinimize|WinMinimizeAll|WinMinimizeAllUndo|WinMove|WinRestore|WinSet|WinSetTitle|WinShow|WinWait|WinWaitActive|WinWaitClose|WinWaitNotActive)\b/i,
    constant: /\b(?:a_ahkpath|a_ahkversion|a_appdata|a_appdatacommon|a_autotrim|a_batchlines|a_caretx|a_carety|a_computername|a_controldelay|a_cursor|a_dd|a_ddd|a_dddd|a_defaultmousespeed|a_desktop|a_desktopcommon|a_detecthiddentext|a_detecthiddenwindows|a_endchar|a_eventinfo|a_exitreason|a_formatfloat|a_formatinteger|a_gui|a_guievent|a_guicontrol|a_guicontrolevent|a_guiheight|a_guiwidth|a_guix|a_guiy|a_hour|a_iconfile|a_iconhidden|a_iconnumber|a_icontip|a_index|a_ipaddress1|a_ipaddress2|a_ipaddress3|a_ipaddress4|a_isadmin|a_iscompiled|a_iscritical|a_ispaused|a_issuspended|a_isunicode|a_keydelay|a_language|a_lasterror|a_linefile|a_linenumber|a_loopfield|a_loopfileattrib|a_loopfiledir|a_loopfileext|a_loopfilefullpath|a_loopfilelongpath|a_loopfilename|a_loopfileshortname|a_loopfileshortpath|a_loopfilesize|a_loopfilesizekb|a_loopfilesizemb|a_loopfiletimeaccessed|a_loopfiletimecreated|a_loopfiletimemodified|a_loopreadline|a_loopregkey|a_loopregname|a_loopregsubkey|a_loopregtimemodified|a_loopregtype|a_mday|a_min|a_mm|a_mmm|a_mmmm|a_mon|a_mousedelay|a_msec|a_mydocuments|a_now|a_nowutc|a_numbatchlines|a_ostype|a_osversion|a_priorhotkey|programfiles|a_programfiles|a_programs|a_programscommon|a_screenheight|a_screenwidth|a_scriptdir|a_scriptfullpath|a_scriptname|a_sec|a_space|a_startmenu|a_startmenucommon|a_startup|a_startupcommon|a_stringcasesense|a_tab|a_temp|a_thisfunc|a_thishotkey|a_thislabel|a_thismenu|a_thismenuitem|a_thismenuitempos|a_tickcount|a_timeidle|a_timeidlephysical|a_timesincepriorhotkey|a_timesincethishotkey|a_titlematchmode|a_titlematchmodespeed|a_username|a_wday|a_windelay|a_windir|a_workingdir|a_yday|a_year|a_yweek|a_yyyy|clipboard|clipboardall|comspec|errorlevel)\b/i,
    builtin: /\b(?:abs|acos|asc|asin|atan|ceil|chr|class|cos|dllcall|exp|fileexist|Fileopen|floor|il_add|il_create|il_destroy|instr|substr|isfunc|islabel|IsObject|ln|log|lv_add|lv_delete|lv_deletecol|lv_getcount|lv_getnext|lv_gettext|lv_insert|lv_insertcol|lv_modify|lv_modifycol|lv_setimagelist|mod|onmessage|numget|numput|registercallback|regexmatch|regexreplace|round|sin|tan|sqrt|strlen|sb_seticon|sb_setparts|sb_settext|strsplit|tv_add|tv_delete|tv_getchild|tv_getcount|tv_getnext|tv_get|tv_getparent|tv_getprev|tv_getselection|tv_gettext|tv_modify|varsetcapacity|winactive|winexist|__New|__Call|__Get|__Set)\b/i,
    symbol: /\b(?:alt|altdown|altup|appskey|backspace|browser_back|browser_favorites|browser_forward|browser_home|browser_refresh|browser_search|browser_stop|bs|capslock|ctrl|ctrlbreak|ctrldown|ctrlup|del|delete|down|end|enter|esc|escape|f1|f10|f11|f12|f13|f14|f15|f16|f17|f18|f19|f2|f20|f21|f22|f23|f24|f3|f4|f5|f6|f7|f8|f9|home|ins|insert|joy1|joy10|joy11|joy12|joy13|joy14|joy15|joy16|joy17|joy18|joy19|joy2|joy20|joy21|joy22|joy23|joy24|joy25|joy26|joy27|joy28|joy29|joy3|joy30|joy31|joy32|joy4|joy5|joy6|joy7|joy8|joy9|joyaxes|joybuttons|joyinfo|joyname|joypov|joyr|joyu|joyv|joyx|joyy|joyz|lalt|launch_app1|launch_app2|launch_mail|launch_media|lbutton|lcontrol|lctrl|left|lshift|lwin|lwindown|lwinup|mbutton|media_next|media_play_pause|media_prev|media_stop|numlock|numpad0|numpad1|numpad2|numpad3|numpad4|numpad5|numpad6|numpad7|numpad8|numpad9|numpadadd|numpadclear|numpaddel|numpaddiv|numpaddot|numpaddown|numpadend|numpadenter|numpadhome|numpadins|numpadleft|numpadmult|numpadpgdn|numpadpgup|numpadright|numpadsub|numpadup|pgdn|pgup|printscreen|ralt|rbutton|rcontrol|rctrl|right|rshift|rwin|rwindown|rwinup|scrolllock|shift|shiftdown|shiftup|space|tab|up|volume_down|volume_mute|volume_up|wheeldown|wheelleft|wheelright|wheelup|xbutton1|xbutton2)\b/i,
    important: /#\b(?:AllowSameLineComments|ClipboardTimeout|CommentFlag|ErrorStdOut|EscapeChar|HotkeyInterval|HotkeyModifierTimeout|Hotstring|IfWinActive|IfWinExist|IfWinNotActive|IfWinNotExist|Include|IncludeAgain|InstallKeybdHook|InstallMouseHook|KeyHistory|LTrim|MaxHotkeysPerInterval|MaxMem|MaxThreads|MaxThreadsBuffer|MaxThreadsPerHotkey|NoEnv|NoTrayIcon|Persistent|SingleInstance|UseHook|WinActivateForce)\b/i,
    keyword: /\b(?:Abort|AboveNormal|Add|ahk_class|ahk_group|ahk_id|ahk_pid|All|Alnum|Alpha|AltSubmit|AltTab|AltTabAndMenu|AltTabMenu|AltTabMenuDismiss|AlwaysOnTop|AutoSize|Background|BackgroundTrans|BelowNormal|between|BitAnd|BitNot|BitOr|BitShiftLeft|BitShiftRight|BitXOr|Bold|Border|Button|ByRef|Checkbox|Checked|CheckedGray|Choose|ChooseString|Close|Color|ComboBox|Contains|ControlList|Count|Date|DateTime|Days|DDL|Default|DeleteAll|Delimiter|Deref|Destroy|Digit|Disable|Disabled|DropDownList|Edit|Eject|Else|Enable|Enabled|Error|Exist|Expand|ExStyle|FileSystem|First|Flash|Float|FloatFast|Focus|Font|for|global|Grid|Group|GroupBox|GuiClose|GuiContextMenu|GuiDropFiles|GuiEscape|GuiSize|Hdr|Hidden|Hide|High|HKCC|HKCR|HKCU|HKEY_CLASSES_ROOT|HKEY_CURRENT_CONFIG|HKEY_CURRENT_USER|HKEY_LOCAL_MACHINE|HKEY_USERS|HKLM|HKU|Hours|HScroll|Icon|IconSmall|ID|IDLast|If|IfEqual|IfExist|IfGreater|IfGreaterOrEqual|IfInString|IfLess|IfLessOrEqual|IfMsgBox|IfNotEqual|IfNotExist|IfNotInString|IfWinActive|IfWinExist|IfWinNotActive|IfWinNotExist|Ignore|ImageList|in|Integer|IntegerFast|Interrupt|is|italic|Join|Label|LastFound|LastFoundExist|Limit|Lines|List|ListBox|ListView|local|Lock|Logoff|Low|Lower|Lowercase|MainWindow|Margin|Maximize|MaximizeBox|MaxSize|Minimize|MinimizeBox|MinMax|MinSize|Minutes|MonthCal|Mouse|Move|Multi|NA|No|NoActivate|NoDefault|NoHide|NoIcon|NoMainWindow|norm|Normal|NoSort|NoSortHdr|NoStandard|Not|NoTab|NoTimers|Number|Off|Ok|On|OwnDialogs|Owner|Parse|Password|Picture|Pixel|Pos|Pow|Priority|ProcessName|Radio|Range|Read|ReadOnly|Realtime|Redraw|REG_BINARY|REG_DWORD|REG_EXPAND_SZ|REG_MULTI_SZ|REG_SZ|Region|Relative|Rename|Report|Resize|Restore|Retry|RGB|Screen|Seconds|Section|Serial|SetLabel|ShiftAltTab|Show|Single|Slider|SortDesc|Standard|static|Status|StatusBar|StatusCD|strike|Style|Submit|SysMenu|Tab2|TabStop|Text|Theme|Tile|ToggleCheck|ToggleEnable|ToolWindow|Top|Topmost|TransColor|Transparent|Tray|TreeView|TryAgain|Type|UnCheck|underline|Unicode|Unlock|UpDown|Upper|Uppercase|UseErrorLevel|Vis|VisFirst|Visible|VScroll|Wait|WaitClose|WantCtrlA|WantF2|WantReturn|While|Wrap|Xdigit|xm|xp|xs|Yes|ym|yp|ys)\b/i
  }
}


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = autoit
autoit.displayName = 'autoit'
autoit.aliases = []
function autoit(Prism) {
  Prism.languages.autoit = {
    comment: [
      /;.*/,
      {
        // The multi-line comments delimiters can actually be commented out with ";"
        pattern: /(^\s*)#(?:comments-start|cs)[\s\S]*?^\s*#(?:comments-end|ce)/m,
        lookbehind: true
      }
    ],
    url: {
      pattern: /(^\s*#include\s+)(?:<[^\r\n>]+>|"[^\r\n"]+")/m,
      lookbehind: true
    },
    string: {
      pattern: /(["'])(?:\1\1|(?!\1)[^\r\n])*\1/,
      greedy: true,
      inside: {
        variable: /([%$@])\w+\1/
      }
    },
    directive: {
      pattern: /(^\s*)#\w+/m,
      lookbehind: true,
      alias: 'keyword'
    },
    function: /\b\w+(?=\()/,
    // Variables and macros
    variable: /[$@]\w+/,
    keyword: /\b(?:Case|Const|Continue(?:Case|Loop)|Default|Dim|Do|Else(?:If)?|End(?:Func|If|Select|Switch|With)|Enum|Exit(?:Loop)?|For|Func|Global|If|In|Local|Next|Null|ReDim|Select|Static|Step|Switch|Then|To|Until|Volatile|WEnd|While|With)\b/i,
    number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b/i,
    boolean: /\b(?:True|False)\b/i,
    operator: /<[=>]?|[-+*\/=&>]=?|[?^]|\b(?:And|Or|Not)\b/i,
    punctuation: /[\[\]().,:]/
  }
}


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = bash
bash.displayName = 'bash'
bash.aliases = ['shell']
function bash(Prism) {
  ;(function(Prism) {
    var insideString = {
      variable: [
        // Arithmetic Environment
        {
          pattern: /\$?\(\([\s\S]+?\)\)/,
          inside: {
            // If there is a $ sign at the beginning highlight $(( and )) as variable
            variable: [
              {
                pattern: /(^\$\(\([\s\S]+)\)\)/,
                lookbehind: true
              },
              /^\$\(\(/
            ],
            number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+\.?\d*|\B\.\d+)(?:[Ee]-?\d+)?/,
            // Operators according to https://www.gnu.org/software/bash/manual/bashref.html#Shell-Arithmetic
            operator: /--?|-=|\+\+?|\+=|!=?|~|\*\*?|\*=|\/=?|%=?|<<=?|>>=?|<=?|>=?|==?|&&?|&=|\^=?|\|\|?|\|=|\?|:/,
            // If there is no $ sign at the beginning highlight (( and )) as punctuation
            punctuation: /\(\(?|\)\)?|,|;/
          }
        },
        // Command Substitution
        {
          pattern: /\$\([^)]+\)|`[^`]+`/,
          greedy: true,
          inside: {
            variable: /^\$\(|^`|\)$|`$/
          }
        },
        /\$(?:[\w#?*!@]+|\{[^}]+\})/i
      ]
    }
    Prism.languages.bash = {
      shebang: {
        pattern: /^#!\s*\/bin\/bash|^#!\s*\/bin\/sh/,
        alias: 'important'
      },
      comment: {
        pattern: /(^|[^"{\\])#.*/,
        lookbehind: true
      },
      string: [
        //Support for Here-Documents https://en.wikipedia.org/wiki/Here_document
        {
          pattern: /((?:^|[^<])<<\s*)["']?(\w+?)["']?\s*\r?\n(?:[\s\S])*?\r?\n\2/,
          lookbehind: true,
          greedy: true,
          inside: insideString
        },
        {
          pattern: /(["'])(?:\\[\s\S]|\$\([^)]+\)|`[^`]+`|(?!\1)[^\\])*\1/,
          greedy: true,
          inside: insideString
        }
      ],
      variable: insideString.variable,
      // Originally based on http://ss64.com/bash/
      function: {
        pattern: /(^|[\s;|&])(?:alias|apropos|apt-get|aptitude|aspell|awk|basename|bash|bc|bg|builtin|bzip2|cal|cat|cd|cfdisk|chgrp|chmod|chown|chroot|chkconfig|cksum|clear|cmp|comm|command|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|du|egrep|eject|enable|env|ethtool|eval|exec|expand|expect|export|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|getopts|git|grep|groupadd|groupdel|groupmod|groups|gzip|hash|head|help|hg|history|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|jobs|join|kill|killall|less|link|ln|locate|logname|logout|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|make|man|mkdir|mkfifo|mkisofs|mknod|more|most|mount|mtools|mtr|mv|mmv|nano|netstat|nice|nl|nohup|notify-send|npm|nslookup|open|op|passwd|paste|pathchk|ping|pkill|popd|pr|printcap|printenv|printf|ps|pushd|pv|pwd|quota|quotacheck|quotactl|ram|rar|rcp|read|readarray|readonly|reboot|rename|renice|remsync|rev|rm|rmdir|rsync|screen|scp|sdiff|sed|seq|service|sftp|shift|shopt|shutdown|sleep|slocate|sort|source|split|ssh|stat|strace|su|sudo|sum|suspend|sync|tail|tar|tee|test|time|timeout|times|touch|top|traceroute|trap|tr|tsort|tty|type|ulimit|umask|umount|unalias|uname|unexpand|uniq|units|unrar|unshar|uptime|useradd|userdel|usermod|users|uuencode|uudecode|v|vdir|vi|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yes|zip)(?=$|[\s;|&])/,
        lookbehind: true
      },
      keyword: {
        pattern: /(^|[\s;|&])(?:let|:|\.|if|then|else|elif|fi|for|break|continue|while|in|case|function|select|do|done|until|echo|exit|return|set|declare)(?=$|[\s;|&])/,
        lookbehind: true
      },
      boolean: {
        pattern: /(^|[\s;|&])(?:true|false)(?=$|[\s;|&])/,
        lookbehind: true
      },
      operator: /&&?|\|\|?|==?|!=?|<<<?|>>|<=?|>=?|=~/,
      punctuation: /\$?\(\(?|\)\)?|\.\.|[{}[\];]/
    }
    var inside = insideString.variable[1].inside
    inside.string = Prism.languages.bash.string
    inside['function'] = Prism.languages.bash['function']
    inside.keyword = Prism.languages.bash.keyword
    inside['boolean'] = Prism.languages.bash['boolean']
    inside.operator = Prism.languages.bash.operator
    inside.punctuation = Prism.languages.bash.punctuation
    Prism.languages.shell = Prism.languages.bash
  })(Prism)
}


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = batch
batch.displayName = 'batch'
batch.aliases = []
function batch(Prism) {
  ;(function(Prism) {
    var variable = /%%?[~:\w]+%?|!\S+!/
    var parameter = {
      pattern: /\/[a-z?]+(?=[ :]|$):?|-[a-z]\b|--[a-z-]+\b/im,
      alias: 'attr-name',
      inside: {
        punctuation: /:/
      }
    }
    var string = /"[^"]*"/
    var number = /(?:\b|-)\d+\b/
    Prism.languages.batch = {
      comment: [
        /^::.*/m,
        {
          pattern: /((?:^|[&(])[ \t]*)rem\b(?:[^^&)\r\n]|\^(?:\r\n|[\s\S]))*/im,
          lookbehind: true
        }
      ],
      label: {
        pattern: /^:.*/m,
        alias: 'property'
      },
      command: [
        {
          // FOR command
          pattern: /((?:^|[&(])[ \t]*)for(?: ?\/[a-z?](?:[ :](?:"[^"]*"|\S+))?)* \S+ in \([^)]+\) do/im,
          lookbehind: true,
          inside: {
            keyword: /^for\b|\b(?:in|do)\b/i,
            string: string,
            parameter: parameter,
            variable: variable,
            number: number,
            punctuation: /[()',]/
          }
        },
        {
          // IF command
          pattern: /((?:^|[&(])[ \t]*)if(?: ?\/[a-z?](?:[ :](?:"[^"]*"|\S+))?)* (?:not )?(?:cmdextversion \d+|defined \w+|errorlevel \d+|exist \S+|(?:"[^"]*"|\S+)?(?:==| (?:equ|neq|lss|leq|gtr|geq) )(?:"[^"]*"|\S+))/im,
          lookbehind: true,
          inside: {
            keyword: /^if\b|\b(?:not|cmdextversion|defined|errorlevel|exist)\b/i,
            string: string,
            parameter: parameter,
            variable: variable,
            number: number,
            operator: /\^|==|\b(?:equ|neq|lss|leq|gtr|geq)\b/i
          }
        },
        {
          // ELSE command
          pattern: /((?:^|[&()])[ \t]*)else\b/im,
          lookbehind: true,
          inside: {
            keyword: /^else\b/i
          }
        },
        {
          // SET command
          pattern: /((?:^|[&(])[ \t]*)set(?: ?\/[a-z](?:[ :](?:"[^"]*"|\S+))?)* (?:[^^&)\r\n]|\^(?:\r\n|[\s\S]))*/im,
          lookbehind: true,
          inside: {
            keyword: /^set\b/i,
            string: string,
            parameter: parameter,
            variable: [variable, /\w+(?=(?:[*\/%+\-&^|]|<<|>>)?=)/],
            number: number,
            operator: /[*\/%+\-&^|]=?|<<=?|>>=?|[!~_=]/,
            punctuation: /[()',]/
          }
        },
        {
          // Other commands
          pattern: /((?:^|[&(])[ \t]*@?)\w+\b(?:[^^&)\r\n]|\^(?:\r\n|[\s\S]))*/im,
          lookbehind: true,
          inside: {
            keyword: /^\w+\b/i,
            string: string,
            parameter: parameter,
            label: {
              pattern: /(^\s*):\S+/m,
              lookbehind: true,
              alias: 'property'
            },
            variable: variable,
            number: number,
            operator: /\^/
          }
        }
      ],
      operator: /[&@]/,
      punctuation: /[()']/
    }
  })(Prism)
}


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var refractorC = __webpack_require__(137)
module.exports = bison
bison.displayName = 'bison'
bison.aliases = []
function bison(Prism) {
  Prism.register(refractorC)
  Prism.languages.bison = Prism.languages.extend('c', {})
  Prism.languages.insertBefore('bison', 'comment', {
    bison: {
      // This should match all the beginning of the file
      // including the prologue(s), the bison declarations and
      // the grammar rules.
      pattern: /^[\s\S]*?%%[\s\S]*?%%/,
      inside: {
        c: {
          // Allow for one level of nested braces
          pattern: /%\{[\s\S]*?%\}|\{(?:\{[^}]*\}|[^{}])*\}/,
          inside: {
            delimiter: {
              pattern: /^%?\{|%?\}$/,
              alias: 'punctuation'
            },
            'bison-variable': {
              pattern: /[$@](?:<[^\s>]+>)?[\w$]+/,
              alias: 'variable',
              inside: {
                punctuation: /<|>/
              }
            },
            rest: Prism.languages.c
          }
        },
        comment: Prism.languages.c.comment,
        string: Prism.languages.c.string,
        property: /\S+(?=:)/,
        keyword: /%\w+/,
        number: {
          pattern: /(^|[^@])\b(?:0x[\da-f]+|\d+)/i,
          lookbehind: true
        },
        punctuation: /%[%?]|[|:;\[\]<>]/
      }
    }
  })
}


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = brainfuck
brainfuck.displayName = 'brainfuck'
brainfuck.aliases = []
function brainfuck(Prism) {
  Prism.languages.brainfuck = {
    pointer: {
      pattern: /<|>/,
      alias: 'keyword'
    },
    increment: {
      pattern: /\+/,
      alias: 'inserted'
    },
    decrement: {
      pattern: /-/,
      alias: 'deleted'
    },
    branching: {
      pattern: /\[|\]/,
      alias: 'important'
    },
    operator: /[.,]/,
    comment: /\S+/
  }
}


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = bro
bro.displayName = 'bro'
bro.aliases = []
function bro(Prism) {
  Prism.languages.bro = {
    comment: {
      pattern: /(^|[^\\$])#.*/,
      lookbehind: true,
      inside: {
        italic: /\b(?:TODO|FIXME|XXX)\b/
      }
    },
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: true
    },
    boolean: /\b[TF]\b/,
    function: {
      pattern: /(?:function|hook|event) \w+(?:::\w+)?/,
      inside: {
        keyword: /^(?:function|hook|event)/
      }
    },
    variable: {
      pattern: /(?:global|local) \w+/i,
      inside: {
        keyword: /(?:global|local)/
      }
    },
    builtin: /(?:@(?:load(?:-(?:sigs|plugin))?|unload|prefixes|ifn?def|else|(?:end)?if|DIR|FILENAME))|(?:&?(?:redef|priority|log|optional|default|add_func|delete_func|expire_func|read_expire|write_expire|create_expire|synchronized|persistent|rotate_interval|rotate_size|encrypt|raw_output|mergeable|group|error_handler|type_column))/,
    constant: {
      pattern: /const \w+/i,
      inside: {
        keyword: /const/
      }
    },
    keyword: /\b(?:break|next|continue|alarm|using|of|add|delete|export|print|return|schedule|when|timeout|addr|any|bool|count|double|enum|file|int|interval|pattern|opaque|port|record|set|string|subnet|table|time|vector|for|if|else|in|module|function)\b/,
    operator: /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&|\|\|?|\?|\*|\/|~|\^|%/,
    number: /\b0x[\da-f]+\b|(?:\b\d+\.?\d*|\B\.\d+)(?:e[+-]?\d+)?/i,
    punctuation: /[{}[\];(),.:]/
  }
}


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = clike
clike.displayName = 'clike'
clike.aliases = []
function clike(Prism) {
  Prism.languages.clike = {
    comment: [
      {
        pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
        lookbehind: true
      },
      {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: true,
        greedy: true
      }
    ],
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: true
    },
    'class-name': {
      pattern: /((?:\b(?:class|interface|extends|implements|trait|instanceof|new)\s+)|(?:catch\s+\())[\w.\\]+/i,
      lookbehind: true,
      inside: {
        punctuation: /[.\\]/
      }
    },
    keyword: /\b(?:if|else|while|do|for|return|in|instanceof|function|new|try|throw|catch|finally|null|break|continue)\b/,
    boolean: /\b(?:true|false)\b/,
    function: /[a-z0-9_]+(?=\()/i,
    number: /\b0x[\da-f]+\b|(?:\b\d+\.?\d*|\B\.\d+)(?:e[+-]?\d+)?/i,
    operator: /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&?|\|\|?|\?|\*|\/|~|\^|%/,
    punctuation: /[{}[\];(),.:]/
  }
}


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = clojure
clojure.displayName = 'clojure'
clojure.aliases = []
function clojure(Prism) {
  // Copied from https://github.com/jeluard/prism-clojure
  Prism.languages.clojure = {
    comment: /;+.*/,
    string: /"(?:\\.|[^\\"\r\n])*"/,
    operator: /(?:::|[:|'])\b[a-z][\w*+!?-]*\b/i, //used for symbols and keywords
    keyword: {
      pattern: /([^\w+*'?-])(?:def|if|do|let|\.\.|quote|var|->>|->|fn|loop|recur|throw|try|monitor-enter|\.|new|set!|def\-|defn|defn\-|defmacro|defmulti|defmethod|defstruct|defonce|declare|definline|definterface|defprotocol|==|defrecord|>=|deftype|<=|defproject|ns|\*|\+|\-|\/|<|=|>|accessor|agent|agent-errors|aget|alength|all-ns|alter|and|append-child|apply|array-map|aset|aset-boolean|aset-byte|aset-char|aset-double|aset-float|aset-int|aset-long|aset-short|assert|assoc|await|await-for|bean|binding|bit-and|bit-not|bit-or|bit-shift-left|bit-shift-right|bit-xor|boolean|branch\?|butlast|byte|cast|char|children|class|clear-agent-errors|comment|commute|comp|comparator|complement|concat|conj|cons|constantly|cond|if-not|construct-proxy|contains\?|count|create-ns|create-struct|cycle|dec|deref|difference|disj|dissoc|distinct|doall|doc|dorun|doseq|dosync|dotimes|doto|double|down|drop|drop-while|edit|end\?|ensure|eval|every\?|false\?|ffirst|file-seq|filter|find|find-doc|find-ns|find-var|first|float|flush|for|fnseq|frest|gensym|get-proxy-class|get|hash-map|hash-set|identical\?|identity|if-let|import|in-ns|inc|index|insert-child|insert-left|insert-right|inspect-table|inspect-tree|instance\?|int|interleave|intersection|into|into-array|iterate|join|key|keys|keyword|keyword\?|last|lazy-cat|lazy-cons|left|lefts|line-seq|list\*|list|load|load-file|locking|long|loop|macroexpand|macroexpand-1|make-array|make-node|map|map-invert|map\?|mapcat|max|max-key|memfn|merge|merge-with|meta|min|min-key|name|namespace|neg\?|new|newline|next|nil\?|node|not|not-any\?|not-every\?|not=|ns-imports|ns-interns|ns-map|ns-name|ns-publics|ns-refers|ns-resolve|ns-unmap|nth|nthrest|or|parse|partial|path|peek|pop|pos\?|pr|pr-str|print|print-str|println|println-str|prn|prn-str|project|proxy|proxy-mappings|quot|rand|rand-int|range|re-find|re-groups|re-matcher|re-matches|re-pattern|re-seq|read|read-line|reduce|ref|ref-set|refer|rem|remove|remove-method|remove-ns|rename|rename-keys|repeat|replace|replicate|resolve|rest|resultset-seq|reverse|rfirst|right|rights|root|rrest|rseq|second|select|select-keys|send|send-off|seq|seq-zip|seq\?|set|short|slurp|some|sort|sort-by|sorted-map|sorted-map-by|sorted-set|special-symbol\?|split-at|split-with|str|string\?|struct|struct-map|subs|subvec|symbol|symbol\?|sync|take|take-nth|take-while|test|time|to-array|to-array-2d|tree-seq|true\?|union|up|update-proxy|val|vals|var-get|var-set|var\?|vector|vector-zip|vector\?|when|when-first|when-let|when-not|with-local-vars|with-meta|with-open|with-out-str|xml-seq|xml-zip|zero\?|zipmap|zipper)(?=[^\w+*'?-])/,
      lookbehind: true
    },
    boolean: /\b(?:true|false|nil)\b/,
    number: /\b[0-9A-Fa-f]+\b/,
    punctuation: /[{}\[\](),]/
  }
}


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = coffeescript
coffeescript.displayName = 'coffeescript'
coffeescript.aliases = []
function coffeescript(Prism) {
  ;(function(Prism) {
    // Ignore comments starting with { to privilege string interpolation highlighting
    var comment = /#(?!\{).+/,
      interpolation = {
        pattern: /#\{[^}]+\}/,
        alias: 'variable'
      }
    Prism.languages.coffeescript = Prism.languages.extend('javascript', {
      comment: comment,
      string: [
        // Strings are multiline
        {
          pattern: /'(?:\\[\s\S]|[^\\'])*'/,
          greedy: true
        },
        {
          // Strings are multiline
          pattern: /"(?:\\[\s\S]|[^\\"])*"/,
          greedy: true,
          inside: {
            interpolation: interpolation
          }
        }
      ],
      keyword: /\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/,
      'class-member': {
        pattern: /@(?!\d)\w+/,
        alias: 'variable'
      }
    })
    Prism.languages.insertBefore('coffeescript', 'comment', {
      'multiline-comment': {
        pattern: /###[\s\S]+?###/,
        alias: 'comment'
      },
      // Block regexp can contain comments and interpolation
      'block-regex': {
        pattern: /\/{3}[\s\S]*?\/{3}/,
        alias: 'regex',
        inside: {
          comment: comment,
          interpolation: interpolation
        }
      }
    })
    Prism.languages.insertBefore('coffeescript', 'string', {
      'inline-javascript': {
        pattern: /`(?:\\[\s\S]|[^\\`])*`/,
        inside: {
          delimiter: {
            pattern: /^`|`$/,
            alias: 'punctuation'
          },
          rest: Prism.languages.javascript
        }
      },
      // Block strings
      'multiline-string': [
        {
          pattern: /'''[\s\S]*?'''/,
          greedy: true,
          alias: 'string'
        },
        {
          pattern: /"""[\s\S]*?"""/,
          greedy: true,
          alias: 'string',
          inside: {
            interpolation: interpolation
          }
        }
      ]
    })
    Prism.languages.insertBefore('coffeescript', 'keyword', {
      // Object property
      property: /(?!\d)\w+(?=\s*:(?!:))/
    })
    delete Prism.languages.coffeescript['template-string']
  })(Prism)
}


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var refractorRuby = __webpack_require__(308)
module.exports = crystal
crystal.displayName = 'crystal'
crystal.aliases = []
function crystal(Prism) {
  Prism.register(refractorRuby)
  ;(function(Prism) {
    Prism.languages.crystal = Prism.languages.extend('ruby', {
      keyword: [
        /\b(?:abstract|alias|as|asm|begin|break|case|class|def|do|else|elsif|end|ensure|enum|extend|for|fun|if|include|instance_sizeof|lib|macro|module|next|of|out|pointerof|private|protected|rescue|return|require|select|self|sizeof|struct|super|then|type|typeof|uninitialized|union|unless|until|when|while|with|yield|__DIR__|__END_LINE__|__FILE__|__LINE__)\b/,
        {
          pattern: /(\.\s*)(?:is_a|responds_to)\?/,
          lookbehind: true
        }
      ],
      number: /\b(?:0b[01_]*[01]|0o[0-7_]*[0-7]|0x[\da-fA-F_]*[\da-fA-F]|(?:\d(?:[\d_]*\d)?)(?:\.[\d_]*\d)?(?:[eE][+-]?[\d_]*\d)?)(?:_(?:[uif](?:8|16|32|64))?)?\b/
    })
    Prism.languages.insertBefore('crystal', 'string', {
      attribute: {
        pattern: /@\[.+?\]/,
        alias: 'attr-name',
        inside: {
          delimiter: {
            pattern: /^@\[|\]$/,
            alias: 'tag'
          },
          rest: Prism.languages.crystal
        }
      },
      expansion: [
        {
          pattern: /\{\{.+?\}\}/,
          inside: {
            delimiter: {
              pattern: /^\{\{|\}\}$/,
              alias: 'tag'
            },
            rest: Prism.languages.crystal
          }
        },
        {
          pattern: /\{%.+?%\}/,
          inside: {
            delimiter: {
              pattern: /^\{%|%\}$/,
              alias: 'tag'
            },
            rest: Prism.languages.crystal
          }
        }
      ]
    })
  })(Prism)
}


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = csharp
csharp.displayName = 'csharp'
csharp.aliases = ['dotnet']
function csharp(Prism) {
  Prism.languages.csharp = Prism.languages.extend('clike', {
    keyword: /\b(?:abstract|add|alias|as|ascending|async|await|base|bool|break|byte|case|catch|char|checked|class|const|continue|decimal|default|delegate|descending|do|double|dynamic|else|enum|event|explicit|extern|false|finally|fixed|float|for|foreach|from|get|global|goto|group|if|implicit|in|int|interface|internal|into|is|join|let|lock|long|namespace|new|null|object|operator|orderby|out|override|params|partial|private|protected|public|readonly|ref|remove|return|sbyte|sealed|select|set|short|sizeof|stackalloc|static|string|struct|switch|this|throw|true|try|typeof|uint|ulong|unchecked|unsafe|ushort|using|value|var|virtual|void|volatile|where|while|yield)\b/,
    string: [
      {
        pattern: /@("|')(?:\1\1|\\[\s\S]|(?!\1)[^\\])*\1/,
        greedy: true
      },
      {
        pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*?\1/,
        greedy: true
      }
    ],
    'class-name': [
      {
        // (Foo bar, Bar baz)
        pattern: /\b[A-Z]\w*(?:\.\w+)*\b(?=\s+\w+)/,
        inside: {
          punctuation: /\./
        }
      },
      {
        // [Foo]
        pattern: /(\[)[A-Z]\w*(?:\.\w+)*\b/,
        lookbehind: true,
        inside: {
          punctuation: /\./
        }
      },
      {
        // class Foo : Bar
        pattern: /(\b(?:class|interface)\s+[A-Z]\w*(?:\.\w+)*\s*:\s*)[A-Z]\w*(?:\.\w+)*\b/,
        lookbehind: true,
        inside: {
          punctuation: /\./
        }
      },
      {
        // class Foo
        pattern: /((?:\b(?:class|interface|new)\s+)|(?:catch\s+\())[A-Z]\w*(?:\.\w+)*\b/,
        lookbehind: true,
        inside: {
          punctuation: /\./
        }
      }
    ],
    number: /\b0x[\da-f]+\b|(?:\b\d+\.?\d*|\B\.\d+)f?/i
  })
  Prism.languages.insertBefore('csharp', 'class-name', {
    'generic-method': {
      pattern: /\w+\s*<[^>\r\n]+?>\s*(?=\()/,
      inside: {
        function: /^\w+/,
        'class-name': {
          pattern: /\b[A-Z]\w*(?:\.\w+)*\b/,
          inside: {
            punctuation: /\./
          }
        },
        keyword: Prism.languages.csharp.keyword,
        punctuation: /[<>(),.:]/
      }
    },
    preprocessor: {
      pattern: /(^\s*)#.*/m,
      lookbehind: true,
      alias: 'property',
      inside: {
        // highlight preprocessor directives as keywords
        directive: {
          pattern: /(\s*#)\b(?:define|elif|else|endif|endregion|error|if|line|pragma|region|undef|warning)\b/,
          lookbehind: true,
          alias: 'keyword'
        }
      }
    }
  })
  Prism.languages.dotnet = Prism.languages.csharp
}


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = csp
csp.displayName = 'csp'
csp.aliases = []
function csp(Prism) {
  /**
   * Original by Scott Helme.
   *
   * Reference: https://scotthelme.co.uk/csp-cheat-sheet/
   *
   * Supports the following:
   *  - CSP Level 1
   *  - CSP Level 2
   *  - CSP Level 3
   */
  Prism.languages.csp = {
    directive: {
      pattern: /\b(?:(?:base-uri|form-action|frame-ancestors|plugin-types|referrer|reflected-xss|report-to|report-uri|require-sri-for|sandbox) |(?:block-all-mixed-content|disown-opener|upgrade-insecure-requests)(?: |;)|(?:child|connect|default|font|frame|img|manifest|media|object|script|style|worker)-src )/i,
      alias: 'keyword'
    },
    safe: {
      pattern: /'(?:self|none|strict-dynamic|(?:nonce-|sha(?:256|384|512)-)[a-zA-Z\d+=/]+)'/,
      alias: 'selector'
    },
    unsafe: {
      pattern: /(?:'unsafe-inline'|'unsafe-eval'|'unsafe-hashed-attributes'|\*)/,
      alias: 'function'
    }
  }
}


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = cssExtras
cssExtras.displayName = 'cssExtras'
cssExtras.aliases = []
function cssExtras(Prism) {
  Prism.languages.css.selector = {
    pattern: /[^{}\s][^{}]*(?=\s*\{)/,
    inside: {
      'pseudo-element': /:(?:after|before|first-letter|first-line|selection)|::[-\w]+/,
      'pseudo-class': /:[-\w]+(?:\(.*\))?/,
      class: /\.[-:.\w]+/,
      id: /#[-:.\w]+/,
      attribute: /\[[^\]]+\]/
    }
  }
  Prism.languages.insertBefore('css', 'function', {
    hexcode: /#[\da-f]{3,8}/i,
    entity: /\\[\da-f]{1,8}/i,
    number: /[\d%.]+/
  })
}


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = css
css.displayName = 'css'
css.aliases = []
function css(Prism) {
  Prism.languages.css = {
    comment: /\/\*[\s\S]*?\*\//,
    atrule: {
      pattern: /@[\w-]+?.*?(?:;|(?=\s*\{))/i,
      inside: {
        rule: /@[\w-]+/
        // See rest below
      }
    },
    url: /url\((?:(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1|.*?)\)/i,
    selector: /[^{}\s][^{};]*?(?=\s*\{)/,
    string: {
      pattern: /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: true
    },
    property: /[-_a-z\xA0-\uFFFF][-\w\xA0-\uFFFF]*(?=\s*:)/i,
    important: /\B!important\b/i,
    function: /[-a-z0-9]+(?=\()/i,
    punctuation: /[(){};:]/
  }
  Prism.languages.css['atrule'].inside.rest = Prism.languages.css
  if (Prism.languages.markup) {
    Prism.languages.insertBefore('markup', 'tag', {
      style: {
        pattern: /(<style[\s\S]*?>)[\s\S]*?(?=<\/style>)/i,
        lookbehind: true,
        inside: Prism.languages.css,
        alias: 'language-css',
        greedy: true
      }
    })
    Prism.languages.insertBefore(
      'inside',
      'attr-value',
      {
        'style-attr': {
          pattern: /\s*style=("|')(?:\\[\s\S]|(?!\1)[^\\])*\1/i,
          inside: {
            'attr-name': {
              pattern: /^\s*style/i,
              inside: Prism.languages.markup.tag.inside
            },
            punctuation: /^\s*=\s*['"]|['"]\s*$/,
            'attr-value': {
              pattern: /.+/i,
              inside: Prism.languages.css
            }
          },
          alias: 'language-css'
        }
      },
      Prism.languages.markup.tag
    )
  }
}


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = d
d.displayName = 'd'
d.aliases = []
function d(Prism) {
  Prism.languages.d = Prism.languages.extend('clike', {
    string: [
      // r"", x""
      /\b[rx]"(?:\\[\s\S]|[^\\"])*"[cwd]?/,
      // q"[]", q"()", q"<>", q"{}"
      /\bq"(?:\[[\s\S]*?\]|\([\s\S]*?\)|<[\s\S]*?>|\{[\s\S]*?\})"/,
      // q"IDENT
      // ...
      // IDENT"
      /\bq"([_a-zA-Z][_a-zA-Z\d]*)(?:\r?\n|\r)[\s\S]*?(?:\r?\n|\r)\1"/,
      // q"//", q"||", etc.
      /\bq"(.)[\s\S]*?\1"/,
      // Characters
      /'(?:\\'|\\?[^']+)'/,
      /(["`])(?:\\[\s\S]|(?!\1)[^\\])*\1[cwd]?/
    ],
    number: [
      // The lookbehind and the negative look-ahead try to prevent bad highlighting of the .. operator
      // Hexadecimal numbers must be handled separately to avoid problems with exponent "e"
      /\b0x\.?[a-f\d_]+(?:(?!\.\.)\.[a-f\d_]*)?(?:p[+-]?[a-f\d_]+)?[ulfi]*/i,
      {
        pattern: /((?:\.\.)?)(?:\b0b\.?|\b|\.)\d[\d_]*(?:(?!\.\.)\.[\d_]*)?(?:e[+-]?\d[\d_]*)?[ulfi]*/i,
        lookbehind: true
      }
    ],
    // In order: $, keywords and special tokens, globally defined symbols
    keyword: /\$|\b(?:abstract|alias|align|asm|assert|auto|body|bool|break|byte|case|cast|catch|cdouble|cent|cfloat|char|class|const|continue|creal|dchar|debug|default|delegate|delete|deprecated|do|double|else|enum|export|extern|false|final|finally|float|for|foreach|foreach_reverse|function|goto|idouble|if|ifloat|immutable|import|inout|int|interface|invariant|ireal|lazy|long|macro|mixin|module|new|nothrow|null|out|override|package|pragma|private|protected|public|pure|real|ref|return|scope|shared|short|static|struct|super|switch|synchronized|template|this|throw|true|try|typedef|typeid|typeof|ubyte|ucent|uint|ulong|union|unittest|ushort|version|void|volatile|wchar|while|with|__(?:(?:FILE|MODULE|LINE|FUNCTION|PRETTY_FUNCTION|DATE|EOF|TIME|TIMESTAMP|VENDOR|VERSION)__|gshared|traits|vector|parameters)|string|wstring|dstring|size_t|ptrdiff_t)\b/,
    operator: /\|[|=]?|&[&=]?|\+[+=]?|-[-=]?|\.?\.\.|=[>=]?|!(?:i[ns]\b|<>?=?|>=?|=)?|\bi[ns]\b|(?:<[<>]?|>>?>?|\^\^|[*\/%^~])=?/
  })
  Prism.languages.d.comment = [
    // Shebang
    /^\s*#!.+/,
    // /+ +/
    {
      // Allow one level of nesting
      pattern: /(^|[^\\])\/\+(?:\/\+[\s\S]*?\+\/|[\s\S])*?\+\//,
      lookbehind: true
    }
  ].concat(Prism.languages.d.comment)
  Prism.languages.insertBefore('d', 'comment', {
    'token-string': {
      // Allow one level of nesting
      pattern: /\bq\{(?:\{[^}]*\}|[^}])*\}/,
      alias: 'string'
    }
  })
  Prism.languages.insertBefore('d', 'keyword', {
    property: /\B@\w*/
  })
  Prism.languages.insertBefore('d', 'function', {
    register: {
      // Iasm registers
      pattern: /\b(?:[ABCD][LHX]|E[ABCD]X|E?(?:BP|SP|DI|SI)|[ECSDGF]S|CR[0234]|DR[012367]|TR[3-7]|X?MM[0-7]|R[ABCD]X|[BS]PL|R[BS]P|[DS]IL|R[DS]I|R(?:[89]|1[0-5])[BWD]?|XMM(?:[89]|1[0-5])|YMM(?:1[0-5]|\d))\b|\bST(?:\([0-7]\)|\b)/,
      alias: 'variable'
    }
  })
}


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = dart
dart.displayName = 'dart'
dart.aliases = []
function dart(Prism) {
  Prism.languages.dart = Prism.languages.extend('clike', {
    string: [
      {
        pattern: /r?("""|''')[\s\S]*?\1/,
        greedy: true
      },
      {
        pattern: /r?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: true
      }
    ],
    keyword: [
      /\b(?:async|sync|yield)\*/,
      /\b(?:abstract|assert|async|await|break|case|catch|class|const|continue|default|deferred|do|dynamic|else|enum|export|external|extends|factory|final|finally|for|get|if|implements|import|in|library|new|null|operator|part|rethrow|return|set|static|super|switch|this|throw|try|typedef|var|void|while|with|yield)\b/
    ],
    operator: /\bis!|\b(?:as|is)\b|\+\+|--|&&|\|\||<<=?|>>=?|~(?:\/=?)?|[+\-*\/%&^|=!<>]=?|\?/
  })
  Prism.languages.insertBefore('dart', 'function', {
    metadata: {
      pattern: /@\w+/,
      alias: 'symbol'
    }
  })
}


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = diff
diff.displayName = 'diff'
diff.aliases = []
function diff(Prism) {
  Prism.languages.diff = {
    coord: [
      // Match all kinds of coord lines (prefixed by "+++", "---" or "***").
      /^(?:\*{3}|-{3}|\+{3}).*$/m,
      // Match "@@ ... @@" coord lines in unified diff.
      /^@@.*@@$/m,
      // Match coord lines in normal diff (starts with a number).
      /^\d+.*$/m
    ],
    // Match inserted and deleted lines. Support both +/- and >/< styles.
    deleted: /^[-<].*$/m,
    inserted: /^[+>].*$/m,
    // Match "different" lines (prefixed with "!") in context diff.
    diff: {
      pattern: /^!(?!!).+$/m,
      alias: 'important'
    }
  }
}


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = django
django.displayName = 'django'
django.aliases = ['jinja2']
function django(Prism) {
  // Django/Jinja2 syntax definition for Prism.js <http://prismjs.com> syntax highlighter.
  // Mostly it works OK but can paint code incorrectly on complex html/template tag combinations.
  var _django_template = {
    property: {
      pattern: /(?:{{|{%)[\s\S]*?(?:%}|}})/g,
      greedy: true,
      inside: {
        string: {
          pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
          greedy: true
        },
        keyword: /\b(?:\||load|verbatim|widthratio|ssi|firstof|for|url|ifchanged|csrf_token|lorem|ifnotequal|autoescape|now|templatetag|debug|cycle|ifequal|regroup|comment|filter|endfilter|if|spaceless|with|extends|block|include|else|empty|endif|endfor|as|endblock|endautoescape|endverbatim|trans|endtrans|[Tt]rue|[Ff]alse|[Nn]one|in|is|static|macro|endmacro|call|endcall|set|endset|raw|endraw)\b/,
        operator: /[-+=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]|\b(?:or|and|not)\b/,
        function: /\b(?:_|abs|add|addslashes|attr|batch|callable|capfirst|capitalize|center|count|cut|d|date|default|default_if_none|defined|dictsort|dictsortreversed|divisibleby|e|equalto|escape|escaped|escapejs|even|filesizeformat|first|float|floatformat|force_escape|forceescape|format|get_digit|groupby|indent|int|iriencode|iterable|join|last|length|length_is|linebreaks|linebreaksbr|linenumbers|list|ljust|lower|make_list|map|mapping|number|odd|phone2numeric|pluralize|pprint|random|reject|rejectattr|removetags|replace|reverse|rjust|round|safe|safeseq|sameas|select|selectattr|sequence|slice|slugify|sort|string|stringformat|striptags|sum|time|timesince|timeuntil|title|trim|truncate|truncatechars|truncatechars_html|truncatewords|truncatewords_html|undefined|unordered_list|upper|urlencode|urlize|urlizetrunc|wordcount|wordwrap|xmlattr|yesno)\b/,
        important: /\b-?\d+(?:\.\d+)?\b/,
        variable: /\b\w+?\b/,
        punctuation: /[[\];(),.:]/
      }
    }
  }
  Prism.languages.django = Prism.languages.extend('markup', {
    comment: /(?:<!--|{#)[\s\S]*?(?:#}|-->)/
  })
  // Updated html tag pattern to allow template tags inside html tags
  Prism.languages.django.tag.pattern = /<\/?(?!\d)[^\s>\/=$<]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^>=]+))?)*\s*\/?>/i
  Prism.languages.insertBefore('django', 'entity', _django_template)
  Prism.languages.insertBefore(
    'inside',
    'tag',
    _django_template,
    Prism.languages.django.tag
  )
  if (Prism.languages.javascript) {
    // Combine js code and template tags painting inside <script> blocks
    Prism.languages.insertBefore(
      'inside',
      'string',
      _django_template,
      Prism.languages.django.script
    )
    Prism.languages.django.script.inside.string.inside = _django_template
  }
  if (Prism.languages.css) {
    // Combine css code and template tags painting inside <style> blocks
    Prism.languages.insertBefore(
      'inside',
      'atrule',
      {tag: _django_template.property},
      Prism.languages.django.style
    )
    Prism.languages.django.style.inside.string.inside = _django_template
  }
  // Add an Jinja2 alias
  Prism.languages.jinja2 = Prism.languages.django
}


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = docker
docker.displayName = 'docker'
docker.aliases = ['dockerfile']
function docker(Prism) {
  Prism.languages.docker = {
    keyword: {
      pattern: /(^\s*)(?:ADD|ARG|CMD|COPY|ENTRYPOINT|ENV|EXPOSE|FROM|HEALTHCHECK|LABEL|MAINTAINER|ONBUILD|RUN|SHELL|STOPSIGNAL|USER|VOLUME|WORKDIR)(?=\s)/im,
      lookbehind: true
    },
    string: /("|')(?:(?!\1)[^\\\r\n]|\\(?:\r\n|[\s\S]))*\1/,
    comment: /#.*/,
    punctuation: /---|\.\.\.|[:[\]{}\-,|>?]/
  }
  Prism.languages.dockerfile = Prism.languages.docker
}


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = eiffel
eiffel.displayName = 'eiffel'
eiffel.aliases = []
function eiffel(Prism) {
  Prism.languages.eiffel = {
    comment: /--.*/,
    string: [
      // Aligned-verbatim-strings
      {
        pattern: /"([^[]*)\[[\s\S]*?\]\1"/,
        greedy: true
      },
      // Non-aligned-verbatim-strings
      {
        pattern: /"([^{]*)\{[\s\S]*?\}\1"/,
        greedy: true
      },
      // Single-line string
      {
        pattern: /"(?:%\s+%|%.|[^%"\r\n])*"/,
        greedy: true
      }
    ],
    // normal char | special char | char code
    char: /'(?:%.|[^%'\r\n])+'/,
    keyword: /\b(?:across|agent|alias|all|and|attached|as|assign|attribute|check|class|convert|create|Current|debug|deferred|detachable|do|else|elseif|end|ensure|expanded|export|external|feature|from|frozen|if|implies|inherit|inspect|invariant|like|local|loop|not|note|obsolete|old|once|or|Precursor|redefine|rename|require|rescue|Result|retry|select|separate|some|then|undefine|until|variant|Void|when|xor)\b/i,
    boolean: /\b(?:True|False)\b/i,
    // Convention: class-names are always all upper-case characters
    'class-name': {
      pattern: /\b[A-Z][\dA-Z_]*\b/,
      alias: 'builtin'
    },
    number: [
      // hexa | octal | bin
      /\b0[xcb][\da-f](?:_*[\da-f])*\b/i,
      // Decimal
      /(?:\d(?:_*\d)*)?\.(?:(?:\d(?:_*\d)*)?e[+-]?)?\d(?:_*\d)*|\d(?:_*\d)*\.?/i
    ],
    punctuation: /:=|<<|>>|\(\||\|\)|->|\.(?=\w)|[{}[\];(),:?]/,
    operator: /\\\\|\|\.\.\||\.\.|\/[~\/=]?|[><]=?|[-+*^=~]/
  }
}


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = elixir
elixir.displayName = 'elixir'
elixir.aliases = []
function elixir(Prism) {
  Prism.languages.elixir = {
    comment: {
      pattern: /#.*/m,
      lookbehind: true
    },
    // ~r"""foo""" (multi-line), ~r'''foo''' (multi-line), ~r/foo/, ~r|foo|, ~r"foo", ~r'foo', ~r(foo), ~r[foo], ~r{foo}, ~r<foo>
    regex: {
      pattern: /~[rR](?:("""|''')(?:\\[\s\S]|(?!\1)[^\\])+\1|([\/|"'])(?:\\.|(?!\2)[^\\\r\n])+\2|\((?:\\.|[^\\)\r\n])+\)|\[(?:\\.|[^\\\]\r\n])+\]|\{(?:\\.|[^\\}\r\n])+\}|<(?:\\.|[^\\>\r\n])+>)[uismxfr]*/,
      greedy: true
    },
    string: [
      {
        // ~s"""foo""" (multi-line), ~s'''foo''' (multi-line), ~s/foo/, ~s|foo|, ~s"foo", ~s'foo', ~s(foo), ~s[foo], ~s{foo} (with interpolation care), ~s<foo>
        pattern: /~[cCsSwW](?:("""|''')(?:\\[\s\S]|(?!\1)[^\\])+\1|([\/|"'])(?:\\.|(?!\2)[^\\\r\n])+\2|\((?:\\.|[^\\)\r\n])+\)|\[(?:\\.|[^\\\]\r\n])+\]|\{(?:\\.|#\{[^}]+\}|[^\\}\r\n])+\}|<(?:\\.|[^\\>\r\n])+>)[csa]?/,
        greedy: true,
        inside: {
          // See interpolation below
        }
      },
      {
        pattern: /("""|''')[\s\S]*?\1/,
        greedy: true,
        inside: {
          // See interpolation below
        }
      },
      {
        // Multi-line strings are allowed
        pattern: /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true,
        inside: {
          // See interpolation below
        }
      }
    ],
    atom: {
      // Look-behind prevents bad highlighting of the :: operator
      pattern: /(^|[^:]):\w+/,
      lookbehind: true,
      alias: 'symbol'
    },
    // Look-ahead prevents bad highlighting of the :: operator
    'attr-name': /\w+:(?!:)/,
    capture: {
      // Look-behind prevents bad highlighting of the && operator
      pattern: /(^|[^&])&(?:[^&\s\d()][^\s()]*|(?=\())/,
      lookbehind: true,
      alias: 'function'
    },
    argument: {
      // Look-behind prevents bad highlighting of the && operator
      pattern: /(^|[^&])&\d+/,
      lookbehind: true,
      alias: 'variable'
    },
    attribute: {
      pattern: /@\w+/,
      alias: 'variable'
    },
    number: /\b(?:0[box][a-f\d_]+|\d[\d_]*)(?:\.[\d_]+)?(?:e[+-]?[\d_]+)?\b/i,
    keyword: /\b(?:after|alias|and|case|catch|cond|def(?:callback|exception|impl|module|p|protocol|struct)?|do|else|end|fn|for|if|import|not|or|require|rescue|try|unless|use|when)\b/,
    boolean: /\b(?:true|false|nil)\b/,
    operator: [
      /\bin\b|&&?|\|[|>]?|\\\\|::|\.\.\.?|\+\+?|-[->]?|<[-=>]|>=|!==?|\B!|=(?:==?|[>~])?|[*\/^]/,
      {
        // We don't want to match <<
        pattern: /([^<])<(?!<)/,
        lookbehind: true
      },
      {
        // We don't want to match >>
        pattern: /([^>])>(?!>)/,
        lookbehind: true
      }
    ],
    punctuation: /<<|>>|[.,%\[\]{}()]/
  }
  Prism.languages.elixir.string.forEach(function(o) {
    o.inside = {
      interpolation: {
        pattern: /#\{[^}]+\}/,
        inside: {
          delimiter: {
            pattern: /^#\{|\}$/,
            alias: 'punctuation'
          },
          rest: Prism.languages.elixir
        }
      }
    }
  })
}


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = elm
elm.displayName = 'elm'
elm.aliases = []
function elm(Prism) {
  Prism.languages.elm = {
    comment: /--.*|{-[\s\S]*?-}/,
    char: {
      pattern: /'(?:[^\\'\r\n]|\\(?:[abfnrtv\\']|\d+|x[0-9a-fA-F]+))'/,
      greedy: true
    },
    string: [
      {
        // Multiline strings are wrapped in triple ". Quotes may appear unescaped.
        pattern: /"""[\s\S]*?"""/,
        greedy: true
      },
      {
        pattern: /"(?:[^\\"\r\n]|\\(?:[abfnrtv\\"]|\d+|x[0-9a-fA-F]+))*"/,
        greedy: true
      }
    ],
    import_statement: {
      // The imported or hidden names are not included in this import
      // statement. This is because we want to highlight those exactly like
      // we do for the names in the program.
      pattern: /^\s*import\s+[A-Z]\w*(?:\.[A-Z]\w*)*(?:\s+as\s+([A-Z]\w*)(?:\.[A-Z]\w*)*)?(?:\s+exposing\s+)?/m,
      inside: {
        keyword: /\b(?:import|as|exposing)\b/
      }
    },
    keyword: /\b(?:alias|as|case|else|exposing|if|in|infixl|infixr|let|module|of|then|type)\b/,
    // These are builtin variables only. Constructors are highlighted later as a constant.
    builtin: /\b(?:abs|acos|always|asin|atan|atan2|ceiling|clamp|compare|cos|curry|degrees|e|flip|floor|fromPolar|identity|isInfinite|isNaN|logBase|max|min|negate|never|not|pi|radians|rem|round|sin|sqrt|tan|toFloat|toPolar|toString|truncate|turns|uncurry|xor)\b/,
    // decimal integers and floating point numbers | hexadecimal integers
    number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0x[0-9a-f]+)\b/i,
    // Most of this is needed because of the meaning of a single '.'.
    // If it stands alone freely, it is the function composition.
    // It may also be a separator between a module name and an identifier => no
    // operator. If it comes together with other special characters it is an
    // operator too.
    // Valid operator characters in 0.18: +-/*=.$<>:&|^?%#@~!
    // Ref: https://groups.google.com/forum/#!msg/elm-dev/0AHSnDdkSkQ/E0SVU70JEQAJ
    operator: /\s\.\s|[+\-/*=.$<>:&|^?%#@~!]{2,}|[+\-/*=$<>:&|^?%#@~!]/,
    // In Elm, nearly everything is a variable, do not highlight these.
    hvariable: /\b(?:[A-Z]\w*\.)*[a-z]\w*\b/,
    constant: /\b(?:[A-Z]\w*\.)*[A-Z]\w*\b/,
    punctuation: /[{}[\]|(),.:]/
  }
}


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var refractorRuby = __webpack_require__(308)
module.exports = erb
erb.displayName = 'erb'
erb.aliases = []
function erb(Prism) {
  Prism.register(refractorRuby)
  ;(function(Prism) {
    Prism.languages.erb = Prism.languages.extend('ruby', {})
    Prism.languages.insertBefore('erb', 'comment', {
      delimiter: {
        pattern: /^<%=?|%>$/,
        alias: 'punctuation'
      }
    })
    Prism.hooks.add('before-tokenize', function(env) {
      var erbPattern = /<%=?[\s\S]+?%>/g
      Prism.languages['markup-templating'].buildPlaceholders(
        env,
        'erb',
        erbPattern
      )
    })
    Prism.hooks.add('after-tokenize', function(env) {
      Prism.languages['markup-templating'].tokenizePlaceholders(env, 'erb')
    })
  })(Prism)
}


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = erlang
erlang.displayName = 'erlang'
erlang.aliases = []
function erlang(Prism) {
  Prism.languages.erlang = {
    comment: /%.+/,
    string: {
      pattern: /"(?:\\.|[^\\"\r\n])*"/,
      greedy: true
    },
    'quoted-function': {
      pattern: /'(?:\\.|[^\\'\r\n])+'(?=\()/,
      alias: 'function'
    },
    'quoted-atom': {
      pattern: /'(?:\\.|[^\\'\r\n])+'/,
      alias: 'atom'
    },
    boolean: /\b(?:true|false)\b/,
    keyword: /\b(?:fun|when|case|of|end|if|receive|after|try|catch)\b/,
    number: [
      /\$\\?./,
      /\d+#[a-z0-9]+/i,
      /(?:\b\d+\.?\d*|\B\.\d+)(?:e[+-]?\d+)?/i
    ],
    function: /\b[a-z][\w@]*(?=\()/,
    variable: {
      // Look-behind is used to prevent wrong highlighting of atoms containing "@"
      pattern: /(^|[^@])(?:\b|\?)[A-Z_][\w@]*/,
      lookbehind: true
    },
    operator: [
      /[=\/<>:]=|=[:\/]=|\+\+?|--?|[=*\/!]|\b(?:bnot|div|rem|band|bor|bxor|bsl|bsr|not|and|or|xor|orelse|andalso)\b/,
      {
        // We don't want to match <<
        pattern: /(^|[^<])<(?!<)/,
        lookbehind: true
      },
      {
        // We don't want to match >>
        pattern: /(^|[^>])>(?!>)/,
        lookbehind: true
      }
    ],
    atom: /\b[a-z][\w@]*/,
    punctuation: /[()[\]{}:;,.#|]|<<|>>/
  }
}


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = flow
flow.displayName = 'flow'
flow.aliases = []
function flow(Prism) {
  ;(function(Prism) {
    Prism.languages.flow = Prism.languages.extend('javascript', {})
    Prism.languages.insertBefore('flow', 'keyword', {
      type: [
        {
          pattern: /\b(?:[Nn]umber|[Ss]tring|[Bb]oolean|Function|any|mixed|null|void)\b/,
          alias: 'tag'
        }
      ]
    })
    Prism.languages.flow[
      'function-variable'
    ].pattern = /[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*=\s*(?:function\b|(?:\([^()]*\)(?:\s*:\s*\w+)?|[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*)\s*=>))/i
    Prism.languages.insertBefore('flow', 'operator', {
      'flow-punctuation': {
        pattern: /\{\||\|\}/,
        alias: 'punctuation'
      }
    })
    if (Prism.util.type(Prism.languages.flow.keyword) !== 'Array') {
      Prism.languages.flow.keyword = [Prism.languages.flow.keyword]
    }
    Prism.languages.flow.keyword.unshift(
      {
        pattern: /(^|[^$]\b)(?:type|opaque|declare|Class)\b(?!\$)/,
        lookbehind: true
      },
      {
        pattern: /(^|[^$]\B)\$(?:await|Diff|Exact|Keys|ObjMap|PropertyType|Shape|Record|Supertype|Subtype|Enum)\b(?!\$)/,
        lookbehind: true
      }
    )
  })(Prism)
}


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = fortran
fortran.displayName = 'fortran'
fortran.aliases = []
function fortran(Prism) {
  Prism.languages.fortran = {
    'quoted-number': {
      pattern: /[BOZ](['"])[A-F0-9]+\1/i,
      alias: 'number'
    },
    string: {
      pattern: /(?:\w+_)?(['"])(?:\1\1|&(?:\r\n?|\n)(?:\s*!.+(?:\r\n?|\n))?|(?!\1).)*(?:\1|&)/,
      inside: {
        comment: {
          pattern: /(&(?:\r\n?|\n)\s*)!.*/,
          lookbehind: true
        }
      }
    },
    comment: {
      pattern: /!.*/,
      greedy: true
    },
    boolean: /\.(?:TRUE|FALSE)\.(?:_\w+)?/i,
    number: /(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[ED][+-]?\d+)?(?:_\w+)?/i,
    keyword: [
      // Types
      /\b(?:INTEGER|REAL|DOUBLE ?PRECISION|COMPLEX|CHARACTER|LOGICAL)\b/i,
      // END statements
      /\b(?:END ?)?(?:BLOCK ?DATA|DO|FILE|FORALL|FUNCTION|IF|INTERFACE|MODULE(?! PROCEDURE)|PROGRAM|SELECT|SUBROUTINE|TYPE|WHERE)\b/i,
      // Statements
      /\b(?:ALLOCATABLE|ALLOCATE|BACKSPACE|CALL|CASE|CLOSE|COMMON|CONTAINS|CONTINUE|CYCLE|DATA|DEALLOCATE|DIMENSION|DO|END|EQUIVALENCE|EXIT|EXTERNAL|FORMAT|GO ?TO|IMPLICIT(?: NONE)?|INQUIRE|INTENT|INTRINSIC|MODULE PROCEDURE|NAMELIST|NULLIFY|OPEN|OPTIONAL|PARAMETER|POINTER|PRINT|PRIVATE|PUBLIC|READ|RETURN|REWIND|SAVE|SELECT|STOP|TARGET|WHILE|WRITE)\b/i,
      // Others
      /\b(?:ASSIGNMENT|DEFAULT|ELEMENTAL|ELSE|ELSEWHERE|ELSEIF|ENTRY|IN|INCLUDE|INOUT|KIND|NULL|ONLY|OPERATOR|OUT|PURE|RECURSIVE|RESULT|SEQUENCE|STAT|THEN|USE)\b/i
    ],
    operator: [
      /\*\*|\/\/|=>|[=\/]=|[<>]=?|::|[+\-*=%]|\.(?:EQ|NE|LT|LE|GT|GE|NOT|AND|OR|EQV|NEQV)\.|\.[A-Z]+\./i,
      {
        // Use lookbehind to prevent confusion with (/ /)
        pattern: /(^|(?!\().)\/(?!\))/,
        lookbehind: true
      }
    ],
    punctuation: /\(\/|\/\)|[(),;:&]/
  }
}


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = fsharp
fsharp.displayName = 'fsharp'
fsharp.aliases = []
function fsharp(Prism) {
  Prism.languages.fsharp = Prism.languages.extend('clike', {
    comment: [
      {
        pattern: /(^|[^\\])\(\*[\s\S]*?\*\)/,
        lookbehind: true
      },
      {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: true
      }
    ],
    keyword: /\b(?:let|return|use|yield)(?:!\B|\b)|\b(abstract|and|as|assert|base|begin|class|default|delegate|do|done|downcast|downto|elif|else|end|exception|extern|false|finally|for|fun|function|global|if|in|inherit|inline|interface|internal|lazy|match|member|module|mutable|namespace|new|not|null|of|open|or|override|private|public|rec|select|static|struct|then|to|true|try|type|upcast|val|void|when|while|with|asr|land|lor|lsl|lsr|lxor|mod|sig|atomic|break|checked|component|const|constraint|constructor|continue|eager|event|external|fixed|functor|include|method|mixin|object|parallel|process|protected|pure|sealed|tailcall|trait|virtual|volatile)\b/,
    string: {
      pattern: /(?:"""[\s\S]*?"""|@"(?:""|[^"])*"|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1)B?/,
      greedy: true
    },
    number: [
      /\b0x[\da-fA-F]+(?:un|lf|LF)?\b/,
      /\b0b[01]+(?:y|uy)?\b/,
      /(?:\b\d+\.?\d*|\B\.\d+)(?:[fm]|e[+-]?\d+)?\b/i,
      /\b\d+(?:[IlLsy]|u[lsy]?|UL)?\b/
    ]
  })
  Prism.languages.insertBefore('fsharp', 'keyword', {
    preprocessor: {
      pattern: /^[^\r\n\S]*#.*/m,
      alias: 'property',
      inside: {
        directive: {
          pattern: /(\s*#)\b(?:else|endif|if|light|line|nowarn)\b/,
          lookbehind: true,
          alias: 'keyword'
        }
      }
    }
  })
}


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = gedcom
gedcom.displayName = 'gedcom'
gedcom.aliases = []
function gedcom(Prism) {
  Prism.languages.gedcom = {
    'line-value': {
      // Preceded by level, optional pointer, and tag
      pattern: /(^\s*\d+ +(?:@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@ +)?\w+ +).+/m,
      lookbehind: true,
      inside: {
        pointer: {
          pattern: /^@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@$/,
          alias: 'variable'
        }
      }
    },
    tag: {
      // Preceded by level and optional pointer
      pattern: /(^\s*\d+ +(?:@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@ +)?)\w+/m,
      lookbehind: true,
      alias: 'string'
    },
    level: {
      pattern: /(^\s*)\d+/m,
      lookbehind: true,
      alias: 'number'
    },
    pointer: {
      pattern: /@\w[\w!"$%&'()*+,\-./:;<=>?[\\\]^`{|}~\x80-\xfe #]*@/,
      alias: 'variable'
    }
  }
}


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = gherkin
gherkin.displayName = 'gherkin'
gherkin.aliases = []
function gherkin(Prism) {
  Prism.languages.gherkin = {
    pystring: {
      pattern: /("""|''')[\s\S]+?\1/,
      alias: 'string'
    },
    comment: {
      pattern: /((?:^|\r?\n|\r)[ \t]*)#.*/,
      lookbehind: true
    },
    tag: {
      pattern: /((?:^|\r?\n|\r)[ \t]*)@\S*/,
      lookbehind: true
    },
    feature: {
      pattern: /((?:^|\r?\n|\r)[ \t]*)(?:Ability|Ahoy matey!|Arwedd|Aspekt|Besigheid Behoefte|Business Need|Caracteristica|Característica|Egenskab|Egenskap|Eiginleiki|Feature|Fīča|Fitur|Fonctionnalité|Fonksyonalite|Funcionalidade|Funcionalitat|Functionalitate|Funcţionalitate|Funcționalitate|Functionaliteit|Fungsi|Funkcia|Funkcija|Funkcionalitāte|Funkcionalnost|Funkcja|Funksie|Funktionalität|Funktionalitéit|Funzionalità|Hwaet|Hwæt|Jellemző|Karakteristik|laH|Lastnost|Mak|Mogucnost|Mogućnost|Moznosti|Možnosti|OH HAI|Omadus|Ominaisuus|Osobina|Özellik|perbogh|poQbogh malja'|Potrzeba biznesowa|Požadavek|Požiadavka|Pretty much|Qap|Qu'meH 'ut|Savybė|Tính năng|Trajto|Vermoë|Vlastnosť|Właściwość|Značilnost|Δυνατότητα|Λειτουργία|Могућност|Мөмкинлек|Особина|Свойство|Үзенчәлеклелек|Функционал|Функционалност|Функция|Функціонал|תכונה|خاصية|خصوصیت|صلاحیت|کاروبار کی ضرورت|وِیژگی|रूप लेख|ਖਾਸੀਅਤ|ਨਕਸ਼ ਨੁਹਾਰ|ਮੁਹਾਂਦਰਾ|గుణము|ಹೆಚ್ಚಳ|ความต้องการทางธุรกิจ|ความสามารถ|โครงหลัก|기능|フィーチャ|功能|機能):(?:[^:]+(?:\r?\n|\r|$))*/,
      lookbehind: true,
      inside: {
        important: {
          pattern: /(:)[^\r\n]+/,
          lookbehind: true
        },
        keyword: /[^:\r\n]+:/
      }
    },
    scenario: {
      pattern: /((?:^|\r?\n|\r)[ \t]*)(?:Abstract Scenario|Abstrakt Scenario|Achtergrond|Aer|Ær|Agtergrond|All y'all|Antecedentes|Antecedents|Atburðarás|Atburðarásir|Awww, look mate|B4|Background|Baggrund|Bakgrund|Bakgrunn|Bakgrunnur|Beispiele|Beispiller|Bối cảnh|Cefndir|Cenario|Cenário|Cenario de Fundo|Cenário de Fundo|Cenarios|Cenários|Contesto|Context|Contexte|Contexto|Conto|Contoh|Contone|Dæmi|Dasar|Dead men tell no tales|Delineacao do Cenario|Delineação do Cenário|Dis is what went down|Dữ liệu|Dyagram senaryo|Dyagram Senaryo|Egzanp|Ejemplos|Eksempler|Ekzemploj|Enghreifftiau|Esbozo do escenario|Escenari|Escenario|Esempi|Esquema de l'escenari|Esquema del escenario|Esquema do Cenario|Esquema do Cenário|Examples|EXAMPLZ|Exempel|Exemple|Exemples|Exemplos|First off|Fono|Forgatókönyv|Forgatókönyv vázlat|Fundo|Geçmiş|ghantoH|Grundlage|Hannergrond|Háttér|Heave to|Istorik|Juhtumid|Keadaan|Khung kịch bản|Khung tình huống|Kịch bản|Koncept|Konsep skenario|Kontèks|Kontekst|Kontekstas|Konteksts|Kontext|Konturo de la scenaro|Latar Belakang|lut|lut chovnatlh|lutmey|Lýsing Atburðarásar|Lýsing Dæma|Menggariskan Senario|MISHUN|MISHUN SRSLY|mo'|Náčrt Scenára|Náčrt Scénáře|Náčrt Scenáru|Oris scenarija|Örnekler|Osnova|Osnova Scenára|Osnova scénáře|Osnutek|Ozadje|Paraugs|Pavyzdžiai|Példák|Piemēri|Plan du scénario|Plan du Scénario|Plan senaryo|Plan Senaryo|Plang vum Szenario|Pozadí|Pozadie|Pozadina|Príklady|Příklady|Primer|Primeri|Primjeri|Przykłady|Raamstsenaarium|Reckon it's like|Rerefons|Scenár|Scénář|Scenarie|Scenarij|Scenarijai|Scenarijaus šablonas|Scenariji|Scenārijs|Scenārijs pēc parauga|Scenarijus|Scenario|Scénario|Scenario Amlinellol|Scenario Outline|Scenario Template|Scenariomal|Scenariomall|Scenarios|Scenariu|Scenariusz|Scenaro|Schema dello scenario|Se ðe|Se the|Se þe|Senario|Senaryo|Senaryo deskripsyon|Senaryo Deskripsyon|Senaryo taslağı|Shiver me timbers|Situācija|Situai|Situasie|Situasie Uiteensetting|Skenario|Skenario konsep|Skica|Structura scenariu|Structură scenariu|Struktura scenarija|Stsenaarium|Swa|Swa hwaer swa|Swa hwær swa|Szablon scenariusza|Szenario|Szenariogrundriss|Tapaukset|Tapaus|Tapausaihio|Taust|Tausta|Template Keadaan|Template Senario|Template Situai|The thing of it is|Tình huống|Variantai|Voorbeelde|Voorbeelden|Wharrimean is|Yo\-ho\-ho|You'll wanna|Założenia|Παραδείγματα|Περιγραφή Σεναρίου|Σενάρια|Σενάριο|Υπόβαθρο|Кереш|Контекст|Концепт|Мисаллар|Мисоллар|Основа|Передумова|Позадина|Предистория|Предыстория|Приклади|Пример|Примери|Примеры|Рамка на сценарий|Скица|Структура сценарија|Структура сценария|Структура сценарію|Сценарий|Сценарий структураси|Сценарийның төзелеше|Сценарији|Сценарио|Сценарій|Тарих|Үрнәкләр|דוגמאות|רקע|תבנית תרחיש|תרחיש|الخلفية|الگوی سناریو|امثلة|پس منظر|زمینه|سناریو|سيناريو|سيناريو مخطط|مثالیں|منظر نامے کا خاکہ|منظرنامہ|نمونه ها|उदाहरण|परिदृश्य|परिदृश्य रूपरेखा|पृष्ठभूमि|ਉਦਾਹਰਨਾਂ|ਪਟਕਥਾ|ਪਟਕਥਾ ਢਾਂਚਾ|ਪਟਕਥਾ ਰੂਪ ਰੇਖਾ|ਪਿਛੋਕੜ|ఉదాహరణలు|కథనం|నేపథ్యం|సన్నివేశం|ಉದಾಹರಣೆಗಳು|ಕಥಾಸಾರಾಂಶ|ವಿವರಣೆ|ಹಿನ್ನೆಲೆ|โครงสร้างของเหตุการณ์|ชุดของตัวอย่าง|ชุดของเหตุการณ์|แนวคิด|สรุปเหตุการณ์|เหตุการณ์|배경|시나리오|시나리오 개요|예|サンプル|シナリオ|シナリオアウトライン|シナリオテンプレ|シナリオテンプレート|テンプレ|例|例子|剧本|剧本大纲|劇本|劇本大綱|场景|场景大纲|場景|場景大綱|背景):[^:\r\n]*/,
      lookbehind: true,
      inside: {
        important: {
          pattern: /(:)[^\r\n]*/,
          lookbehind: true
        },
        keyword: /[^:\r\n]+:/
      }
    },
    'table-body': {
      // Look-behind is used to skip the table head, which has the same format as any table row
      pattern: /((?:\r?\n|\r)[ \t]*\|.+\|[^\r\n]*)+/,
      lookbehind: true,
      inside: {
        outline: {
          pattern: /<[^>]+?>/,
          alias: 'variable'
        },
        td: {
          pattern: /\s*[^\s|][^|]*/,
          alias: 'string'
        },
        punctuation: /\|/
      }
    },
    'table-head': {
      pattern: /(?:\r?\n|\r)[ \t]*\|.+\|[^\r\n]*/,
      inside: {
        th: {
          pattern: /\s*[^\s|][^|]*/,
          alias: 'variable'
        },
        punctuation: /\|/
      }
    },
    atrule: {
      pattern: /((?:\r?\n|\r)[ \t]+)(?:'ach|'a|'ej|7|a|A také|A taktiež|A tiež|A zároveň|Aber|Ac|Adott|Akkor|Ak|Aleshores|Ale|Ali|Allora|Alors|Als|Ama|Amennyiben|Amikor|Ampak|an|AN|Ananging|And y'all|And|Angenommen|Anrhegedig a|An|Apabila|Atès|Atesa|Atunci|Avast!|Aye|A|awer|Bagi|Banjur|Bet|Biết|Blimey!|Buh|But at the end of the day I reckon|But y'all|But|BUT|Cal|Când|Cando|Cand|Ce|Cuando|Če|Ða ðe|Ða|Dadas|Dada|Dados|Dado|DaH ghu' bejlu'|dann|Dann|Dano|Dan|Dar|Dat fiind|Data|Date fiind|Date|Dati fiind|Dati|Daţi fiind|Dați fiind|Dato|DEN|Den youse gotta|Dengan|De|Diberi|Diyelim ki|Donada|Donat|Donitaĵo|Do|Dun|Duota|Ðurh|Eeldades|Ef|Eğer ki|Entao|Então|Entón|Entonces|En|Epi|E|És|Etant donnée|Etant donné|Et|Étant données|Étant donnée|Étant donné|Etant données|Etant donnés|Étant donnés|Fakat|Gangway!|Gdy|Gegeben seien|Gegeben sei|Gegeven|Gegewe|ghu' noblu'|Gitt|Given y'all|Given|Givet|Givun|Ha|Cho|I CAN HAZ|In|Ir|It's just unbelievable|I|Ja|Jeśli|Jeżeli|Kadar|Kada|Kad|Kai|Kaj|Když|Keď|Kemudian|Ketika|Khi|Kiedy|Ko|Kuid|Kui|Kun|Lan|latlh|Le sa a|Let go and haul|Le|Lè sa a|Lè|Logo|Lorsqu'<|Lorsque|mä|Maar|Mais|Mając|Majd|Maka|Manawa|Mas|Ma|Menawa|Men|Mutta|Nalikaning|Nalika|Nanging|Når|När|Nato|Nhưng|Niin|Njuk|O zaman|Og|Och|Oletetaan|Onda|Ond|Oraz|Pak|Pero|Però|Podano|Pokiaľ|Pokud|Potem|Potom|Privzeto|Pryd|qaSDI'|Quando|Quand|Quan|Så|Sed|Se|Siis|Sipoze ke|Sipoze Ke|Sipoze|Si|Şi|Și|Soit|Stel|Tada|Tad|Takrat|Tak|Tapi|Ter|Tetapi|Tha the|Tha|Then y'all|Then|Thì|Thurh|Toda|Too right|ugeholl|Und|Un|Và|vaj|Vendar|Ve|wann|Wanneer|WEN|Wenn|When y'all|When|Wtedy|Wun|Y'know|Yeah nah|Yna|Youse know like when|Youse know when youse got|Y|Za predpokladu|Za předpokladu|Zadani|Zadano|Zadan|Zadate|Zadato|Zakładając|Zaradi|Zatati|Þa þe|Þa|Þá|Þegar|Þurh|Αλλά|Δεδομένου|Και|Όταν|Τότε|А також|Агар|Але|Али|Аммо|А|Әгәр|Әйтик|Әмма|Бирок|Ва|Вә|Дадено|Дано|Допустим|Если|Задате|Задати|Задато|И|І|К тому же|Када|Кад|Когато|Когда|Коли|Ләкин|Лекин|Нәтиҗәдә|Нехай|Но|Онда|Припустимо, що|Припустимо|Пусть|Также|Та|Тогда|Тоді|То|Унда|Һәм|Якщо|אבל|אזי|אז|בהינתן|וגם|כאשר|آنگاه|اذاً|اگر|اما|اور|با فرض|بالفرض|بفرض|پھر|تب|ثم|جب|عندما|فرض کیا|لكن|لیکن|متى|هنگامی|و|अगर|और|कदा|किन्तु|चूंकि|जब|तथा|तदा|तब|परन्तु|पर|यदि|ਅਤੇ|ਜਦੋਂ|ਜਿਵੇਂ ਕਿ|ਜੇਕਰ|ਤਦ|ਪਰ|అప్పుడు|ఈ పరిస్థితిలో|కాని|చెప్పబడినది|మరియు|ಆದರೆ|ನಂತರ|ನೀಡಿದ|ಮತ್ತು|ಸ್ಥಿತಿಯನ್ನು|กำหนดให้|ดังนั้น|แต่|เมื่อ|และ|그러면<|그리고<|단<|만약<|만일<|먼저<|조건<|하지만<|かつ<|しかし<|ただし<|ならば<|もし<|並且<|但し<|但是<|假如<|假定<|假設<|假设<|前提<|同时<|同時<|并且<|当<|當<|而且<|那么<|那麼<)(?=[ \t]+)/,
      lookbehind: true
    },
    string: {
      pattern: /"(?:\\.|[^"\\\r\n])*"|'(?:\\.|[^'\\\r\n])*'/,
      inside: {
        outline: {
          pattern: /<[^>]+?>/,
          alias: 'variable'
        }
      }
    },
    outline: {
      pattern: /<[^>]+?>/,
      alias: 'variable'
    }
  }
}


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = git
git.displayName = 'git'
git.aliases = []
function git(Prism) {
  Prism.languages.git = {
    /*
     * A simple one line comment like in a git status command
     * For instance:
     * $ git status
     * # On branch infinite-scroll
     * # Your branch and 'origin/sharedBranches/frontendTeam/infinite-scroll' have diverged,
     * # and have 1 and 2 different commits each, respectively.
     * nothing to commit (working directory clean)
     */
    comment: /^#.*/m,
    /*
     * Regexp to match the changed lines in a git diff output. Check the example below.
     */
    deleted: /^[-–].*/m,
    inserted: /^\+.*/m,
    /*
     * a string (double and simple quote)
     */
    string: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/m,
    /*
     * a git command. It starts with a random prompt finishing by a $, then "git" then some other parameters
     * For instance:
     * $ git add file.txt
     */
    command: {
      pattern: /^.*\$ git .*$/m,
      inside: {
        /*
         * A git command can contain a parameter starting by a single or a double dash followed by a string
         * For instance:
         * $ git diff --cached
         * $ git log -p
         */
        parameter: /\s--?\w+/m
      }
    },
    /*
     * Coordinates displayed in a git diff command
     * For instance:
     * $ git diff
     * diff --git file.txt file.txt
     * index 6214953..1d54a52 100644
     * --- file.txt
     * +++ file.txt
     * @@ -1 +1,2 @@
     * -Here's my tetx file
     * +Here's my text file
     * +And this is the second line
     */
    coord: /^@@.*@@$/m,
    /*
     * Match a "commit [SHA1]" line in a git log output.
     * For instance:
     * $ git log
     * commit a11a14ef7e26f2ca62d4b35eac455ce636d0dc09
     * Author: lgiraudel
     * Date:   Mon Feb 17 11:18:34 2014 +0100
     *
     *     Add of a new line
     */
    commit_sha1: /^commit \w{40}$/m
  }
}


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = glsl
glsl.displayName = 'glsl'
glsl.aliases = []
function glsl(Prism) {
  Prism.languages.glsl = Prism.languages.extend('clike', {
    comment: [/\/\*[\s\S]*?\*\//, /\/\/(?:\\(?:\r\n|[\s\S])|[^\\\r\n])*/],
    number: /(?:\b0x[\da-f]+|(?:\b\d+\.?\d*|\B\.\d+)(?:e[+-]?\d+)?)[ulf]*/i,
    keyword: /\b(?:attribute|const|uniform|varying|buffer|shared|coherent|volatile|restrict|readonly|writeonly|atomic_uint|layout|centroid|flat|smooth|noperspective|patch|sample|break|continue|do|for|while|switch|case|default|if|else|subroutine|in|out|inout|float|double|int|void|bool|true|false|invariant|precise|discard|return|d?mat[234](?:x[234])?|[ibdu]?vec[234]|uint|lowp|mediump|highp|precision|[iu]?sampler[123]D|[iu]?samplerCube|sampler[12]DShadow|samplerCubeShadow|[iu]?sampler[12]DArray|sampler[12]DArrayShadow|[iu]?sampler2DRect|sampler2DRectShadow|[iu]?samplerBuffer|[iu]?sampler2DMS(?:Array)?|[iu]?samplerCubeArray|samplerCubeArrayShadow|[iu]?image[123]D|[iu]?image2DRect|[iu]?imageCube|[iu]?imageBuffer|[iu]?image[12]DArray|[iu]?imageCubeArray|[iu]?image2DMS(?:Array)?|struct|common|partition|active|asm|class|union|enum|typedef|template|this|resource|goto|inline|noinline|public|static|extern|external|interface|long|short|half|fixed|unsigned|superp|input|output|hvec[234]|fvec[234]|sampler3DRect|filter|sizeof|cast|namespace|using)\b/
  })
  Prism.languages.insertBefore('glsl', 'comment', {
    preprocessor: {
      pattern: /(^[ \t]*)#(?:(?:define|undef|if|ifdef|ifndef|else|elif|endif|error|pragma|extension|version|line)\b)?/m,
      lookbehind: true,
      alias: 'builtin'
    }
  })
}


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = go
go.displayName = 'go'
go.aliases = []
function go(Prism) {
  Prism.languages.go = Prism.languages.extend('clike', {
    keyword: /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,
    builtin: /\b(?:bool|byte|complex(?:64|128)|error|float(?:32|64)|rune|string|u?int(?:8|16|32|64)?|uintptr|append|cap|close|complex|copy|delete|imag|len|make|new|panic|print(?:ln)?|real|recover)\b/,
    boolean: /\b(?:_|iota|nil|true|false)\b/,
    operator: /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,
    number: /(?:\b0x[a-f\d]+|(?:\b\d+\.?\d*|\B\.\d+)(?:e[-+]?\d+)?)i?/i,
    string: {
      pattern: /(["'`])(\\[\s\S]|(?!\1)[^\\])*\1/,
      greedy: true
    }
  })
  delete Prism.languages.go['class-name']
}


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = graphql
graphql.displayName = 'graphql'
graphql.aliases = []
function graphql(Prism) {
  Prism.languages.graphql = {
    comment: /#.*/,
    string: {
      pattern: /"(?:\\.|[^\\"\r\n])*"/,
      greedy: true
    },
    number: /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
    boolean: /\b(?:true|false)\b/,
    variable: /\$[a-z_]\w*/i,
    directive: {
      pattern: /@[a-z_]\w*/i,
      alias: 'function'
    },
    'attr-name': /[a-z_]\w*(?=\s*:)/i,
    keyword: [
      {
        pattern: /(fragment\s+(?!on)[a-z_]\w*\s+|\.{3}\s*)on\b/,
        lookbehind: true
      },
      /\b(?:query|fragment|mutation)\b/
    ],
    operator: /!|=|\.{3}/,
    punctuation: /[!(){}\[\]:=,]/
  }
}


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = groovy
groovy.displayName = 'groovy'
groovy.aliases = []
function groovy(Prism) {
  Prism.languages.groovy = Prism.languages.extend('clike', {
    keyword: /\b(?:as|def|in|abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|native|new|package|private|protected|public|return|short|static|strictfp|super|switch|synchronized|this|throw|throws|trait|transient|try|void|volatile|while)\b/,
    string: [
      {
        pattern: /("""|''')[\s\S]*?\1|(?:\$\/)(?:\$\/\$|[\s\S])*?\/\$/,
        greedy: true
      },
      {
        pattern: /(["'\/])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: true
      }
    ],
    number: /\b(?:0b[01_]+|0x[\da-f_]+(?:\.[\da-f_p\-]+)?|[\d_]+(?:\.[\d_]+)?(?:e[+-]?[\d]+)?)[glidf]?\b/i,
    operator: {
      pattern: /(^|[^.])(?:~|==?~?|\?[.:]?|\*(?:[.=]|\*=?)?|\.[@&]|\.\.<|\.{1,2}(?!\.)|-[-=>]?|\+[+=]?|!=?|<(?:<=?|=>?)?|>(?:>>?=?|=)?|&[&=]?|\|[|=]?|\/=?|\^=?|%=?)/,
      lookbehind: true
    },
    punctuation: /\.+|[{}[\];(),:$]/
  })
  Prism.languages.insertBefore('groovy', 'string', {
    shebang: {
      pattern: /#!.+/,
      alias: 'comment'
    }
  })
  Prism.languages.insertBefore('groovy', 'punctuation', {
    'spock-block': /\b(?:setup|given|when|then|and|cleanup|expect|where):/
  })
  Prism.languages.insertBefore('groovy', 'function', {
    annotation: {
      alias: 'punctuation',
      pattern: /(^|[^.])@\w+/,
      lookbehind: true
    }
  })
  // Handle string interpolation
  Prism.hooks.add('wrap', function(env) {
    if (env.language === 'groovy' && env.type === 'string') {
      var delimiter = env.content.value[0]
      if (delimiter != "'") {
        var pattern = /([^\\])(?:\$(?:\{.*?\}|[\w.]+))/
        if (delimiter === '$') {
          pattern = /([^\$])(?:\$(?:\{.*?\}|[\w.]+))/
        }
        // To prevent double HTML-encoding we have to decode env.content first
        env.content.value = env.content.value
          .replace(/&lt;/g, '<')
          .replace(/&amp;/g, '&')
        env.content = Prism.highlight(env.content.value, {
          expression: {
            pattern: pattern,
            lookbehind: true,
            inside: Prism.languages.groovy
          }
        })
        env.classes.push(delimiter === '/' ? 'regex' : 'gstring')
      }
    }
  })
}


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = haml
haml.displayName = 'haml'
haml.aliases = []
function haml(Prism) {
  /* TODO
Handle multiline code after tag
%foo= some |
multiline |
code |
*/
  ;(function(Prism) {
    Prism.languages.haml = {
      // Multiline stuff should appear before the rest
      'multiline-comment': {
        pattern: /((?:^|\r?\n|\r)([\t ]*))(?:\/|-#).*(?:(?:\r?\n|\r)\2[\t ]+.+)*/,
        lookbehind: true,
        alias: 'comment'
      },
      'multiline-code': [
        {
          pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*,[\t ]*(?:(?:\r?\n|\r)\2[\t ]+.*,[\t ]*)*(?:(?:\r?\n|\r)\2[\t ]+.+)/,
          lookbehind: true,
          inside: {
            rest: Prism.languages.ruby
          }
        },
        {
          pattern: /((?:^|\r?\n|\r)([\t ]*)(?:[~-]|[&!]?=)).*\|[\t ]*(?:(?:\r?\n|\r)\2[\t ]+.*\|[\t ]*)*/,
          lookbehind: true,
          inside: {
            rest: Prism.languages.ruby
          }
        }
      ],
      // See at the end of the file for known filters
      filter: {
        pattern: /((?:^|\r?\n|\r)([\t ]*)):[\w-]+(?:(?:\r?\n|\r)(?:\2[\t ]+.+|\s*?(?=\r?\n|\r)))+/,
        lookbehind: true,
        inside: {
          'filter-name': {
            pattern: /^:[\w-]+/,
            alias: 'variable'
          }
        }
      },
      markup: {
        pattern: /((?:^|\r?\n|\r)[\t ]*)<.+/,
        lookbehind: true,
        inside: {
          rest: Prism.languages.markup
        }
      },
      doctype: {
        pattern: /((?:^|\r?\n|\r)[\t ]*)!!!(?: .+)?/,
        lookbehind: true
      },
      tag: {
        // Allows for one nested group of braces
        pattern: /((?:^|\r?\n|\r)[\t ]*)[%.#][\w\-#.]*[\w\-](?:\([^)]+\)|\{(?:\{[^}]+\}|[^}])+\}|\[[^\]]+\])*[\/<>]*/,
        lookbehind: true,
        inside: {
          attributes: [
            {
              // Lookbehind tries to prevent interpolations from breaking it all
              // Allows for one nested group of braces
              pattern: /(^|[^#])\{(?:\{[^}]+\}|[^}])+\}/,
              lookbehind: true,
              inside: {
                rest: Prism.languages.ruby
              }
            },
            {
              pattern: /\([^)]+\)/,
              inside: {
                'attr-value': {
                  pattern: /(=\s*)(?:"(?:\\.|[^\\"\r\n])*"|[^)\s]+)/,
                  lookbehind: true
                },
                'attr-name': /[\w:-]+(?=\s*!?=|\s*[,)])/,
                punctuation: /[=(),]/
              }
            },
            {
              pattern: /\[[^\]]+\]/,
              inside: {
                rest: Prism.languages.ruby
              }
            }
          ],
          punctuation: /[<>]/
        }
      },
      code: {
        pattern: /((?:^|\r?\n|\r)[\t ]*(?:[~-]|[&!]?=)).+/,
        lookbehind: true,
        inside: {
          rest: Prism.languages.ruby
        }
      },
      // Interpolations in plain text
      interpolation: {
        pattern: /#\{[^}]+\}/,
        inside: {
          delimiter: {
            pattern: /^#\{|\}$/,
            alias: 'punctuation'
          },
          rest: Prism.languages.ruby
        }
      },
      punctuation: {
        pattern: /((?:^|\r?\n|\r)[\t ]*)[~=\-&!]+/,
        lookbehind: true
      }
    }
    var filter_pattern =
      '((?:^|\\r?\\n|\\r)([\\t ]*)):{{filter_name}}(?:(?:\\r?\\n|\\r)(?:\\2[\\t ]+.+|\\s*?(?=\\r?\\n|\\r)))+'
    // Non exhaustive list of available filters and associated languages
    var filters = [
      'css',
      {filter: 'coffee', language: 'coffeescript'},
      'erb',
      'javascript',
      'less',
      'markdown',
      'ruby',
      'scss',
      'textile'
    ]
    var all_filters = {}
    for (var i = 0, l = filters.length; i < l; i++) {
      var filter = filters[i]
      filter =
        typeof filter === 'string' ? {filter: filter, language: filter} : filter
      if (Prism.languages[filter.language]) {
        all_filters['filter-' + filter.filter] = {
          pattern: RegExp(
            filter_pattern.replace('{{filter_name}}', filter.filter)
          ),
          lookbehind: true,
          inside: {
            'filter-name': {
              pattern: /^:[\w-]+/,
              alias: 'variable'
            },
            rest: Prism.languages[filter.language]
          }
        }
      }
    }
    Prism.languages.insertBefore('haml', 'filter', all_filters)
  })(Prism)
}


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = handlebars
handlebars.displayName = 'handlebars'
handlebars.aliases = []
function handlebars(Prism) {
  ;(function(Prism) {
    Prism.languages.handlebars = {
      comment: /\{\{![\s\S]*?\}\}/,
      delimiter: {
        pattern: /^\{\{\{?|\}\}\}?$/i,
        alias: 'punctuation'
      },
      string: /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
      number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+\.?\d*|\B\.\d+)(?:[Ee][+-]?\d+)?/,
      boolean: /\b(?:true|false)\b/,
      block: {
        pattern: /^(\s*~?\s*)[#\/]\S+?(?=\s*~?\s*$|\s)/i,
        lookbehind: true,
        alias: 'keyword'
      },
      brackets: {
        pattern: /\[[^\]]+\]/,
        inside: {
          punctuation: /\[|\]/,
          variable: /[\s\S]+/
        }
      },
      punctuation: /[!"#%&'()*+,.\/;<=>@\[\\\]^`{|}~]/,
      variable: /[^!"#%&'()*+,.\/;<=>@\[\\\]^`{|}~\s]+/
    }
    Prism.hooks.add('before-tokenize', function(env) {
      var handlebarsPattern = /\{\{\{[\s\S]+?\}\}\}|\{\{[\s\S]+?\}\}/g
      Prism.languages['markup-templating'].buildPlaceholders(
        env,
        'handlebars',
        handlebarsPattern
      )
    })
    Prism.hooks.add('after-tokenize', function(env) {
      Prism.languages['markup-templating'].tokenizePlaceholders(
        env,
        'handlebars'
      )
    })
  })(Prism)
}


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = haskell
haskell.displayName = 'haskell'
haskell.aliases = []
function haskell(Prism) {
  Prism.languages.haskell = {
    comment: {
      pattern: /(^|[^-!#$%*+=?&@|~.:<>^\\\/])(?:--[^-!#$%*+=?&@|~.:<>^\\\/].*|{-[\s\S]*?-})/m,
      lookbehind: true
    },
    char: /'(?:[^\\']|\\(?:[abfnrtv\\"'&]|\^[A-Z@[\]^_]|NUL|SOH|STX|ETX|EOT|ENQ|ACK|BEL|BS|HT|LF|VT|FF|CR|SO|SI|DLE|DC1|DC2|DC3|DC4|NAK|SYN|ETB|CAN|EM|SUB|ESC|FS|GS|RS|US|SP|DEL|\d+|o[0-7]+|x[0-9a-fA-F]+))'/,
    string: {
      pattern: /"(?:[^\\"]|\\(?:[abfnrtv\\"'&]|\^[A-Z@[\]^_]|NUL|SOH|STX|ETX|EOT|ENQ|ACK|BEL|BS|HT|LF|VT|FF|CR|SO|SI|DLE|DC1|DC2|DC3|DC4|NAK|SYN|ETB|CAN|EM|SUB|ESC|FS|GS|RS|US|SP|DEL|\d+|o[0-7]+|x[0-9a-fA-F]+)|\\\s+\\)*"/,
      greedy: true
    },
    keyword: /\b(?:case|class|data|deriving|do|else|if|in|infixl|infixr|instance|let|module|newtype|of|primitive|then|type|where)\b/,
    import_statement: {
      // The imported or hidden names are not included in this import
      // statement. This is because we want to highlight those exactly like
      // we do for the names in the program.
      pattern: /((?:\r?\n|\r|^)\s*)import\s+(?:qualified\s+)?(?:[A-Z][\w']*)(?:\.[A-Z][\w']*)*(?:\s+as\s+(?:[A-Z][_a-zA-Z0-9']*)(?:\.[A-Z][\w']*)*)?(?:\s+hiding\b)?/m,
      lookbehind: true,
      inside: {
        keyword: /\b(?:import|qualified|as|hiding)\b/
      }
    },
    // These are builtin variables only. Constructors are highlighted later as a constant.
    builtin: /\b(?:abs|acos|acosh|all|and|any|appendFile|approxRational|asTypeOf|asin|asinh|atan|atan2|atanh|basicIORun|break|catch|ceiling|chr|compare|concat|concatMap|const|cos|cosh|curry|cycle|decodeFloat|denominator|digitToInt|div|divMod|drop|dropWhile|either|elem|encodeFloat|enumFrom|enumFromThen|enumFromThenTo|enumFromTo|error|even|exp|exponent|fail|filter|flip|floatDigits|floatRadix|floatRange|floor|fmap|foldl|foldl1|foldr|foldr1|fromDouble|fromEnum|fromInt|fromInteger|fromIntegral|fromRational|fst|gcd|getChar|getContents|getLine|group|head|id|inRange|index|init|intToDigit|interact|ioError|isAlpha|isAlphaNum|isAscii|isControl|isDenormalized|isDigit|isHexDigit|isIEEE|isInfinite|isLower|isNaN|isNegativeZero|isOctDigit|isPrint|isSpace|isUpper|iterate|last|lcm|length|lex|lexDigits|lexLitChar|lines|log|logBase|lookup|map|mapM|mapM_|max|maxBound|maximum|maybe|min|minBound|minimum|mod|negate|not|notElem|null|numerator|odd|or|ord|otherwise|pack|pi|pred|primExitWith|print|product|properFraction|putChar|putStr|putStrLn|quot|quotRem|range|rangeSize|read|readDec|readFile|readFloat|readHex|readIO|readInt|readList|readLitChar|readLn|readOct|readParen|readSigned|reads|readsPrec|realToFrac|recip|rem|repeat|replicate|return|reverse|round|scaleFloat|scanl|scanl1|scanr|scanr1|seq|sequence|sequence_|show|showChar|showInt|showList|showLitChar|showParen|showSigned|showString|shows|showsPrec|significand|signum|sin|sinh|snd|sort|span|splitAt|sqrt|subtract|succ|sum|tail|take|takeWhile|tan|tanh|threadToIOResult|toEnum|toInt|toInteger|toLower|toRational|toUpper|truncate|uncurry|undefined|unlines|until|unwords|unzip|unzip3|userError|words|writeFile|zip|zip3|zipWith|zipWith3)\b/,
    // decimal integers and floating point numbers | octal integers | hexadecimal integers
    number: /\b(?:\d+(?:\.\d+)?(?:e[+-]?\d+)?|0o[0-7]+|0x[0-9a-f]+)\b/i,
    // Most of this is needed because of the meaning of a single '.'.
    // If it stands alone freely, it is the function composition.
    // It may also be a separator between a module name and an identifier => no
    // operator. If it comes together with other special characters it is an
    // operator too.
    operator: /\s\.\s|[-!#$%*+=?&@|~.:<>^\\\/]*\.[-!#$%*+=?&@|~.:<>^\\\/]+|[-!#$%*+=?&@|~.:<>^\\\/]+\.[-!#$%*+=?&@|~.:<>^\\\/]*|[-!#$%*+=?&@|~:<>^\\\/]+|`([A-Z][\w']*\.)*[_a-z][\w']*`/,
    // In Haskell, nearly everything is a variable, do not highlight these.
    hvariable: /\b(?:[A-Z][\w']*\.)*[_a-z][\w']*\b/,
    constant: /\b(?:[A-Z][\w']*\.)*[A-Z][\w']*\b/,
    punctuation: /[{}[\];(),.:]/
  }
}


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = haxe
haxe.displayName = 'haxe'
haxe.aliases = []
function haxe(Prism) {
  Prism.languages.haxe = Prism.languages.extend('clike', {
    // Strings can be multi-line
    string: {
      pattern: /(["'])(?:(?!\1)[^\\]|\\[\s\S])*\1/,
      greedy: true,
      inside: {
        interpolation: {
          pattern: /(^|[^\\])\$(?:\w+|\{[^}]+\})/,
          lookbehind: true,
          inside: {
            interpolation: {
              pattern: /^\$\w*/,
              alias: 'variable'
              // See rest below
            }
          }
        }
      }
    },
    // The final look-ahead prevents highlighting of keywords if expressions such as "haxe.macro.Expr"
    keyword: /\bthis\b|\b(?:abstract|as|break|case|cast|catch|class|continue|default|do|dynamic|else|enum|extends|extern|from|for|function|if|implements|import|in|inline|interface|macro|new|null|override|public|private|return|static|super|switch|throw|to|try|typedef|using|var|while)(?!\.)\b/,
    operator: /\.{3}|\+\+?|-[->]?|[=!]=?|&&?|\|\|?|<[<=]?|>[>=]?|[*\/%~^]/
  })
  Prism.languages.insertBefore('haxe', 'class-name', {
    regex: {
      pattern: /~\/(?:[^\/\\\r\n]|\\.)+\/[igmsu]*/,
      greedy: true
    }
  })
  Prism.languages.insertBefore('haxe', 'keyword', {
    preprocessor: {
      pattern: /#\w+/,
      alias: 'builtin'
    },
    metadata: {
      pattern: /@:?\w+/,
      alias: 'symbol'
    },
    reification: {
      pattern: /\$(?:\w+|(?=\{))/,
      alias: 'variable'
    }
  })
  Prism.languages.haxe['string'].inside['interpolation'].inside.rest =
    Prism.languages.haxe
  delete Prism.languages.haxe['class-name']
}


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = hpkp
hpkp.displayName = 'hpkp'
hpkp.aliases = []
function hpkp(Prism) {
  /**
   * Original by Scott Helme.
   *
   * Reference: https://scotthelme.co.uk/hpkp-cheat-sheet/
   */
  Prism.languages.hpkp = {
    directive: {
      pattern: /\b(?:(?:includeSubDomains|preload|strict)(?: |;)|pin-sha256="[a-zA-Z\d+=/]+"|(?:max-age|report-uri)=|report-to )/,
      alias: 'keyword'
    },
    safe: {
      pattern: /\d{7,}/,
      alias: 'selector'
    },
    unsafe: {
      pattern: /\d{0,6}/,
      alias: 'function'
    }
  }
}


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = hsts
hsts.displayName = 'hsts'
hsts.aliases = []
function hsts(Prism) {
  /**
   * Original by Scott Helme.
   *
   * Reference: https://scotthelme.co.uk/hsts-cheat-sheet/
   */
  Prism.languages.hsts = {
    directive: {
      pattern: /\b(?:max-age=|includeSubDomains|preload)/,
      alias: 'keyword'
    },
    safe: {
      pattern: /\d{8,}/,
      alias: 'selector'
    },
    unsafe: {
      pattern: /\d{0,7}/,
      alias: 'function'
    }
  }
}


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = http
http.displayName = 'http'
http.aliases = []
function http(Prism) {
  Prism.languages.http = {
    'request-line': {
      pattern: /^(?:POST|GET|PUT|DELETE|OPTIONS|PATCH|TRACE|CONNECT)\s(?:https?:\/\/|\/)\S+\sHTTP\/[0-9.]+/m,
      inside: {
        // HTTP Verb
        property: /^(?:POST|GET|PUT|DELETE|OPTIONS|PATCH|TRACE|CONNECT)\b/,
        // Path or query argument
        'attr-name': /:\w+/
      }
    },
    'response-status': {
      pattern: /^HTTP\/1.[01] \d+.*/m,
      inside: {
        // Status, e.g. 200 OK
        property: {
          pattern: /(^HTTP\/1.[01] )\d+.*/i,
          lookbehind: true
        }
      }
    },
    // HTTP header name
    'header-name': {
      pattern: /^[\w-]+:(?=.)/m,
      alias: 'keyword'
    }
  }
  // Create a mapping of Content-Type headers to language definitions
  var httpLanguages = {
    'application/json': Prism.languages.javascript,
    'application/xml': Prism.languages.markup,
    'text/xml': Prism.languages.markup,
    'text/html': Prism.languages.markup
  }
  // Insert each content type parser that has its associated language
  // currently loaded.
  for (var contentType in httpLanguages) {
    if (httpLanguages[contentType]) {
      var options = {}
      options[contentType] = {
        pattern: new RegExp(
          '(content-type:\\s*' +
            contentType +
            '[\\w\\W]*?)(?:\\r?\\n|\\r){2}[\\w\\W]*',
          'i'
        ),
        lookbehind: true,
        inside: {
          rest: httpLanguages[contentType]
        }
      }
      Prism.languages.insertBefore('http', 'header-name', options)
    }
  }
}


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = ichigojam
ichigojam.displayName = 'ichigojam'
ichigojam.aliases = []
function ichigojam(Prism) {
  // according to the offical reference (EN)
  // https://ichigojam.net/IchigoJam-en.html
  Prism.languages.ichigojam = {
    comment: /(?:\B'|REM)(?:[^\n\r]*)/i,
    string: {
      pattern: /"(?:""|[!#$%&'()*,\/:;<=>?^_ +\-.A-Z\d])*"/i,
      greedy: true
    },
    number: /\B#[0-9A-F]+|\B`[01]+|(?:\b\d+\.?\d*|\B\.\d+)(?:E[+-]?\d+)?/i,
    keyword: /\b(?:BEEP|BPS|CASE|CLEAR|CLK|CLO|CLP|CLS|CLT|CLV|CONT|COPY|ELSE|END|FILE|FILES|FOR|GOSUB|GSB|GOTO|IF|INPUT|KBD|LED|LET|LIST|LOAD|LOCATE|LRUN|NEW|NEXT|OUT|RIGHT|PLAY|POKE|PRINT|PWM|REM|RENUM|RESET|RETURN|RTN|RUN|SAVE|SCROLL|SLEEP|SRND|STEP|STOP|SUB|TEMPO|THEN|TO|UART|VIDEO|WAIT)(?:\$|\b)/i,
    function: /\b(?:ABS|ANA|ASC|BIN|BTN|DEC|END|FREE|HELP|HEX|I2CR|I2CW|IN|INKEY|LEN|LINE|PEEK|RND|SCR|SOUND|STR|TICK|USR|VER|VPEEK|ZER)(?:\$|\b)/i,
    label: /(?:\B@[^\s]+)/i,
    operator: /<[=>]?|>=?|\|\||&&|[+\-*\/=|&^~!]|\b(?:AND|NOT|OR)\b/i,
    punctuation: /[\[,;:()\]]/
  }
}


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = icon
icon.displayName = 'icon'
icon.aliases = []
function icon(Prism) {
  Prism.languages.icon = {
    comment: /#.*/,
    string: {
      pattern: /(["'])(?:(?!\1)[^\\\r\n_]|\\.|_(?!\1)(?:\r\n|[\s\S]))*\1/,
      greedy: true
    },
    number: /\b(?:\d+r[a-z\d]+|\d+(?:\.\d+)?(?:e[+-]?\d+)?)\b|\.\d+\b/i,
    'builtin-keyword': {
      pattern: /&(?:allocated|ascii|clock|collections|cset|current|date|dateline|digits|dump|e|error(?:number|text|value)?|errout|fail|features|file|host|input|lcase|letters|level|line|main|null|output|phi|pi|pos|progname|random|regions|source|storage|subject|time|trace|ucase|version)\b/,
      alias: 'variable'
    },
    directive: {
      pattern: /\$\w+/,
      alias: 'builtin'
    },
    keyword: /\b(?:break|by|case|create|default|do|else|end|every|fail|global|if|initial|invocable|link|local|next|not|of|procedure|record|repeat|return|static|suspend|then|to|until|while)\b/,
    function: /(?!\d)\w+(?=\s*[({]|\s*!\s*\[)/,
    operator: /[+-]:(?!=)|(?:[\/?@^%&]|\+\+?|--?|==?=?|~==?=?|\*\*?|\|\|\|?|<(?:->?|<?=?)|>>?=?)(?::=)?|:(?:=:?)?|[!.\\|~]/,
    punctuation: /[\[\](){},;]/
  }
}


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = inform7
inform7.displayName = 'inform7'
inform7.aliases = []
function inform7(Prism) {
  Prism.languages.inform7 = {
    string: {
      pattern: /"[^"]*"/,
      inside: {
        substitution: {
          pattern: /\[[^\]]+\]/,
          inside: {
            delimiter: {
              pattern: /\[|\]/,
              alias: 'punctuation'
              // See rest below
            }
          }
        }
      }
    },
    comment: {
      pattern: /\[[^\]]+\]/,
      greedy: true
    },
    title: {
      pattern: /^[ \t]*(?:volume|book|part(?! of)|chapter|section|table)\b.+/im,
      alias: 'important'
    },
    number: {
      pattern: /(^|[^-])(?:\b\d+(?:\.\d+)?(?:\^\d+)?\w*|\b(?:one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve))\b(?!-)/i,
      lookbehind: true
    },
    verb: {
      pattern: /(^|[^-])\b(?:applying to|are|attacking|answering|asking|be(?:ing)?|burning|buying|called|carries|carry(?! out)|carrying|climbing|closing|conceal(?:s|ing)?|consulting|contain(?:s|ing)?|cutting|drinking|dropping|eating|enclos(?:es?|ing)|entering|examining|exiting|getting|giving|going|ha(?:ve|s|ving)|hold(?:s|ing)?|impl(?:y|ies)|incorporat(?:es?|ing)|inserting|is|jumping|kissing|listening|locking|looking|mean(?:s|ing)?|opening|provid(?:es?|ing)|pulling|pushing|putting|relat(?:es?|ing)|removing|searching|see(?:s|ing)?|setting|showing|singing|sleeping|smelling|squeezing|switching|support(?:s|ing)?|swearing|taking|tasting|telling|thinking|throwing|touching|turning|tying|unlock(?:s|ing)?|var(?:y|ies|ying)|waiting|waking|waving|wear(?:s|ing)?)\b(?!-)/i,
      lookbehind: true,
      alias: 'operator'
    },
    keyword: {
      pattern: /(^|[^-])\b(?:after|before|carry out|check|continue the action|definition(?= *:)|do nothing|else|end (?:if|unless|the story)|every turn|if|include|instead(?: of)?|let|move|no|now|otherwise|repeat|report|resume the story|rule for|running through|say(?:ing)?|stop the action|test|try(?:ing)?|understand|unless|use|when|while|yes)\b(?!-)/i,
      lookbehind: true
    },
    property: {
      pattern: /(^|[^-])\b(?:adjacent(?! to)|carried|closed|concealed|contained|dark|described|edible|empty|enclosed|enterable|even|female|fixed in place|full|handled|held|improper-named|incorporated|inedible|invisible|lighted|lit|lock(?:able|ed)|male|marked for listing|mentioned|negative|neuter|non-(?:empty|full|recurring)|odd|opaque|open(?:able)?|plural-named|portable|positive|privately-named|proper-named|provided|publically-named|pushable between rooms|recurring|related|rubbing|scenery|seen|singular-named|supported|swinging|switch(?:able|ed(?: on| off)?)|touch(?:able|ed)|transparent|unconcealed|undescribed|unlit|unlocked|unmarked for listing|unmentioned|unopenable|untouchable|unvisited|variable|visible|visited|wearable|worn)\b(?!-)/i,
      lookbehind: true,
      alias: 'symbol'
    },
    position: {
      pattern: /(^|[^-])\b(?:above|adjacent to|back side of|below|between|down|east|everywhere|front side|here|in|inside(?: from)?|north(?:east|west)?|nowhere|on(?: top of)?|other side|outside(?: from)?|parts? of|regionally in|south(?:east|west)?|through|up|west|within)\b(?!-)/i,
      lookbehind: true,
      alias: 'keyword'
    },
    type: {
      pattern: /(^|[^-])\b(?:actions?|activit(?:y|ies)|actors?|animals?|backdrops?|containers?|devices?|directions?|doors?|holders?|kinds?|lists?|m[ae]n|nobody|nothing|nouns?|numbers?|objects?|people|persons?|player(?:'s holdall)?|regions?|relations?|rooms?|rule(?:book)?s?|scenes?|someone|something|supporters?|tables?|texts?|things?|time|vehicles?|wom[ae]n)\b(?!-)/i,
      lookbehind: true,
      alias: 'variable'
    },
    punctuation: /[.,:;(){}]/
  }
  Prism.languages.inform7['string'].inside['substitution'].inside.rest =
    Prism.languages.inform7
  // We don't want the remaining text in the substitution to be highlighted as the string.
  Prism.languages.inform7['string'].inside['substitution'].inside.rest.text = {
    pattern: /\S(?:\s*\S)*/,
    alias: 'comment'
  }
}


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = ini
ini.displayName = 'ini'
ini.aliases = []
function ini(Prism) {
  Prism.languages.ini = {
    comment: /^[ \t]*;.*$/m,
    selector: /^[ \t]*\[.*?\]/m,
    constant: /^[ \t]*[^\s=]+?(?=[ \t]*=)/m,
    'attr-value': {
      pattern: /=.*/,
      inside: {
        punctuation: /^[=]/
      }
    }
  }
}


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = io
io.displayName = 'io'
io.aliases = []
function io(Prism) {
  Prism.languages.io = {
    comment: [
      {
        pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
        lookbehind: true
      },
      {
        pattern: /(^|[^\\])\/\/.*/,
        lookbehind: true
      },
      {
        pattern: /(^|[^\\])#.*/,
        lookbehind: true
      }
    ],
    'triple-quoted-string': {
      pattern: /"""(?:\\[\s\S]|(?!""")[^\\])*"""/,
      greedy: true,
      alias: 'string'
    },
    string: {
      pattern: /"(?:\\.|[^\\\r\n"])*"/,
      greedy: true
    },
    keyword: /\b(?:activate|activeCoroCount|asString|block|break|catch|clone|collectGarbage|compileString|continue|do|doFile|doMessage|doString|else|elseif|exit|for|foreach|forward|getSlot|getEnvironmentVariable|hasSlot|if|ifFalse|ifNil|ifNilEval|ifTrue|isActive|isNil|isResumable|list|message|method|parent|pass|pause|perform|performWithArgList|print|println|proto|raise|raiseResumable|removeSlot|resend|resume|schedulerSleepSeconds|self|sender|setSchedulerSleepSeconds|setSlot|shallowCopy|slotNames|super|system|then|thisBlock|thisContext|call|try|type|uniqueId|updateSlot|wait|while|write|yield)\b/,
    builtin: /\b(?:Array|AudioDevice|AudioMixer|Block|Box|Buffer|CFunction|CGI|Color|Curses|DBM|DNSResolver|DOConnection|DOProxy|DOServer|Date|Directory|Duration|DynLib|Error|Exception|FFT|File|Fnmatch|Font|Future|GL|GLE|GLScissor|GLU|GLUCylinder|GLUQuadric|GLUSphere|GLUT|Host|Image|Importer|LinkList|List|Lobby|Locals|MD5|MP3Decoder|MP3Encoder|Map|Message|Movie|Notification|Number|Object|OpenGL|Point|Protos|Regex|SGML|SGMLElement|SGMLParser|SQLite|Server|Sequence|ShowMessage|SleepyCat|SleepyCatCursor|Socket|SocketManager|Sound|Soup|Store|String|Tree|UDPSender|UPDReceiver|URL|User|Warning|WeakLink|Random|BigNum|Sequence)\b/,
    boolean: /\b(?:true|false|nil)\b/,
    number: /\b0x[\da-f]+\b|(?:\b\d+\.?\d*|\B\.\d+)(?:e-?\d+)?/i,
    operator: /[=!*/%+-^&|]=|>>?=?|<<?=?|:?:?=|\+\+?|--?|\*\*?|\/\/?|%|\|\|?|&&?|(\b(?:return|and|or|not)\b)|@@?|\?\??|\.\./,
    punctuation: /[{}[\];(),.:]/
  }
}


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = j
j.displayName = 'j'
j.aliases = []
function j(Prism) {
  Prism.languages.j = {
    comment: /\bNB\..*/,
    string: {
      pattern: /'(?:''|[^'\r\n])*'/,
      greedy: true
    },
    keyword: /\b(?:(?:adverb|conjunction|CR|def|define|dyad|LF|monad|noun|verb)\b|(?:assert|break|case|catch[dt]?|continue|do|else|elseif|end|fcase|for|for_\w+|goto_\w+|if|label_\w+|return|select|throw|try|while|whilst)\.)/,
    verb: {
      // Negative look-ahead prevents bad highlighting
      // of ^: ;. =. =: !. !:
      pattern: /(?!\^:|;\.|[=!][.:])(?:\{(?:\.|::?)?|p(?:\.\.?|:)|[=!\]]|[<>+*\-%$|,#][.:]?|[?^]\.?|[;\[]:?|[~}"i][.:]|[ACeEIjLor]\.|(?:[_\/\\qsux]|_?\d):)/,
      alias: 'keyword'
    },
    number: /\b_?(?:(?!\d:)\d+(?:\.\d+)?(?:(?:[ejpx]|ad|ar)_?\d+(?:\.\d+)?)*(?:b_?[\da-z]+(?:\.[\da-z]+)?)?|_(?!\.))/,
    adverb: {
      pattern: /[~}]|[\/\\]\.?|[bfM]\.|t[.:]/,
      alias: 'builtin'
    },
    operator: /[=a][.:]|_\./,
    conjunction: {
      pattern: /&(?:\.:?|:)?|[.:@][.:]?|[!D][.:]|[;dHT]\.|`:?|[\^LS]:|"/,
      alias: 'variable'
    },
    punctuation: /[()]/
  }
}


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = javascript
javascript.displayName = 'javascript'
javascript.aliases = ['js']
function javascript(Prism) {
  Prism.languages.javascript = Prism.languages.extend('clike', {
    keyword: /\b(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|var|void|while|with|yield)\b/,
    number: /\b(?:0[xX][\dA-Fa-f]+|0[bB][01]+|0[oO][0-7]+|NaN|Infinity)\b|(?:\b\d+\.?\d*|\B\.\d+)(?:[Ee][+-]?\d+)?/,
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    function: /[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*\()/i,
    operator: /-[-=]?|\+[+=]?|!=?=?|<<?=?|>>?>?=?|=(?:==?|>)?|&[&=]?|\|[|=]?|\*\*?=?|\/=?|~|\^=?|%=?|\?|\.{3}/
  })
  Prism.languages.insertBefore('javascript', 'keyword', {
    regex: {
      pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s])\s*)\/(\[[^\]\r\n]+]|\\.|[^/\\\[\r\n])+\/[gimyu]{0,5}(?=\s*($|[\r\n,.;})\]]))/,
      lookbehind: true,
      greedy: true
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    'function-variable': {
      pattern: /[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*=\s*(?:function\b|(?:\([^()]*\)|[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*)\s*=>))/i,
      alias: 'function'
    },
    constant: /\b[A-Z][A-Z\d_]*\b/
  })
  Prism.languages.insertBefore('javascript', 'string', {
    'template-string': {
      pattern: /`(?:\\[\s\S]|\${[^}]+}|[^\\`])*`/,
      greedy: true,
      inside: {
        interpolation: {
          pattern: /\${[^}]+}/,
          inside: {
            'interpolation-punctuation': {
              pattern: /^\${|}$/,
              alias: 'punctuation'
            },
            rest: null // See below
          }
        },
        string: /[\s\S]+/
      }
    }
  })
  Prism.languages.javascript['template-string'].inside[
    'interpolation'
  ].inside.rest = Prism.languages.javascript
  if (Prism.languages.markup) {
    Prism.languages.insertBefore('markup', 'tag', {
      script: {
        pattern: /(<script[\s\S]*?>)[\s\S]*?(?=<\/script>)/i,
        lookbehind: true,
        inside: Prism.languages.javascript,
        alias: 'language-javascript',
        greedy: true
      }
    })
  }
  Prism.languages.js = Prism.languages.javascript
}


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = jolie
jolie.displayName = 'jolie'
jolie.aliases = []
function jolie(Prism) {
  Prism.languages.jolie = Prism.languages.extend('clike', {
    keyword: /\b(?:include|define|is_defined|undef|main|init|outputPort|inputPort|Location|Protocol|Interfaces|RequestResponse|OneWay|type|interface|extender|throws|cset|csets|forward|Aggregates|Redirects|embedded|courier|execution|sequential|concurrent|single|scope|install|throw|comp|cH|default|global|linkIn|linkOut|synchronized|this|new|for|if|else|while|in|Jolie|Java|Javascript|nullProcess|spawn|constants|with|provide|until|exit|foreach|instanceof|over|service)\b/,
    builtin: /\b(?:undefined|string|int|void|long|Byte|bool|double|float|char|any)\b/,
    number: /(?:\b\d+\.?\d*|\B\.\d+)(?:e[+-]?\d+)?l?/i,
    operator: /-[-=>]?|\+[+=]?|<[<=]?|[>=*!]=?|&&|\|\||[:?\/%^]/,
    symbol: /[|;@]/,
    punctuation: /[,.]/,
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: true
    }
  })
  delete Prism.languages.jolie['class-name']
  delete Prism.languages.jolie['function']
  Prism.languages.insertBefore('jolie', 'keyword', {
    function: {
      pattern: /((?:\b(?:outputPort|inputPort|in|service|courier)\b|@)\s*)\w+/,
      lookbehind: true
    },
    aggregates: {
      pattern: /(\bAggregates\s*:\s*)(?:\w+(?:\s+with\s+\w+)?\s*,\s*)*\w+(?:\s+with\s+\w+)?/,
      lookbehind: true,
      inside: {
        withExtension: {
          pattern: /\bwith\s+\w+/,
          inside: {
            keyword: /\bwith\b/
          }
        },
        function: {
          pattern: /\w+/
        },
        punctuation: {
          pattern: /,/
        }
      }
    },
    redirects: {
      pattern: /(\bRedirects\s*:\s*)(?:\w+\s*=>\s*\w+\s*,\s*)*(?:\w+\s*=>\s*\w+)/,
      lookbehind: true,
      inside: {
        punctuation: {
          pattern: /,/
        },
        function: {
          pattern: /\w+/
        },
        symbol: {
          pattern: /=>/
        }
      }
    }
  })
}


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = json
json.displayName = 'json'
json.aliases = ['jsonp']
function json(Prism) {
  Prism.languages.json = {
    property: /"(?:\\.|[^\\"\r\n])*"(?=\s*:)/i,
    string: {
      pattern: /"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
      greedy: true
    },
    number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+\.?\d*|\B\.\d+)(?:[Ee][+-]?\d+)?/,
    punctuation: /[{}[\]);,]/,
    operator: /:/g,
    boolean: /\b(?:true|false)\b/i,
    null: /\bnull\b/i
  }
  Prism.languages.jsonp = Prism.languages.json
}


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = julia
julia.displayName = 'julia'
julia.aliases = []
function julia(Prism) {
  Prism.languages.julia = {
    comment: {
      pattern: /(^|[^\\])#.*/,
      lookbehind: true
    },
    string: /("""|''')[\s\S]+?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2/,
    keyword: /\b(?:abstract|baremodule|begin|bitstype|break|catch|ccall|const|continue|do|else|elseif|end|export|finally|for|function|global|if|immutable|import|importall|let|local|macro|module|print|println|quote|return|try|type|typealias|using|while)\b/,
    boolean: /\b(?:true|false)\b/,
    number: /(?:\b(?=\d)|\B(?=\.))(?:0[box])?(?:[\da-f]+\.?\d*|\.\d+)(?:[efp][+-]?\d+)?j?/i,
    operator: /[-+*^%÷&$\\]=?|\/[\/=]?|!=?=?|\|[=>]?|<(?:<=?|[=:])?|>(?:=|>>?=?)?|==?=?|[~≠≤≥]/,
    punctuation: /[{}[\];(),.:]/
  }
}


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = keyman
keyman.displayName = 'keyman'
keyman.aliases = []
function keyman(Prism) {
  Prism.languages.keyman = {
    comment: /\bc\s.*/i,
    function: /\[\s*(?:(?:CTRL|SHIFT|ALT|LCTRL|RCTRL|LALT|RALT|CAPS|NCAPS)\s+)*(?:[TKU]_[\w?]+|".+?"|'.+?')\s*\]/i, // virtual key
    string: /("|').*?\1/,
    bold: [
      // header statements, system stores and variable system stores
      /&(?:baselayout|bitmap|capsononly|capsalwaysoff|shiftfreescaps|copyright|ethnologuecode|hotkey|includecodes|keyboardversion|kmw_embedcss|kmw_embedjs|kmw_helpfile|kmw_helptext|kmw_rtl|language|layer|layoutfile|message|mnemoniclayout|name|oldcharposmatching|platform|targets|version|visualkeyboard|windowslanguages)\b/i,
      /\b(?:bitmap|bitmaps|caps on only|caps always off|shift frees caps|copyright|hotkey|language|layout|message|name|version)\b/i
    ],
    keyword: /\b(?:any|baselayout|beep|call|context|deadkey|dk|if|index|layer|notany|nul|outs|platform|return|reset|save|set|store|use)\b/i, // rule keywords
    atrule: /\b(?:ansi|begin|unicode|group|using keys|match|nomatch)\b/i, // structural keywords
    number: /\b(?:U\+[\dA-F]+|d\d+|x[\da-f]+|\d+)\b/i, // U+####, x###, d### characters and numbers
    operator: /[+>\\,()]/,
    tag: /\$(?:keyman|kmfl|weaver|keymanweb|keymanonly):/i // prefixes
  }
}


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = kotlin
kotlin.displayName = 'kotlin'
kotlin.aliases = []
function kotlin(Prism) {
  ;(function(Prism) {
    Prism.languages.kotlin = Prism.languages.extend('clike', {
      keyword: {
        // The lookbehind prevents wrong highlighting of e.g. kotlin.properties.get
        pattern: /(^|[^.])\b(?:abstract|actual|annotation|as|break|by|catch|class|companion|const|constructor|continue|crossinline|data|do|dynamic|else|enum|expect|external|final|finally|for|fun|get|if|import|in|infix|init|inline|inner|interface|internal|is|lateinit|noinline|null|object|open|operator|out|override|package|private|protected|public|reified|return|sealed|set|super|suspend|tailrec|this|throw|to|try|typealias|val|var|vararg|when|where|while)\b/,
        lookbehind: true
      },
      function: [
        /\w+(?=\s*\()/,
        {
          pattern: /(\.)\w+(?=\s*\{)/,
          lookbehind: true
        }
      ],
      number: /\b(?:0[xX][\da-fA-F]+(?:_[\da-fA-F]+)*|0[bB][01]+(?:_[01]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?[fFL]?)\b/,
      operator: /\+[+=]?|-[-=>]?|==?=?|!(?:!|==?)?|[\/*%<>]=?|[?:]:?|\.\.|&&|\|\||\b(?:and|inv|or|shl|shr|ushr|xor)\b/
    })
    delete Prism.languages.kotlin['class-name']
    Prism.languages.insertBefore('kotlin', 'string', {
      'raw-string': {
        pattern: /("""|''')[\s\S]*?\1/,
        alias: 'string'
        // See interpolation below
      }
    })
    Prism.languages.insertBefore('kotlin', 'keyword', {
      annotation: {
        pattern: /\B@(?:\w+:)?(?:[A-Z]\w*|\[[^\]]+\])/,
        alias: 'builtin'
      }
    })
    Prism.languages.insertBefore('kotlin', 'function', {
      label: {
        pattern: /\w+@|@\w+/,
        alias: 'symbol'
      }
    })
    var interpolation = [
      {
        pattern: /\$\{[^}]+\}/,
        inside: {
          delimiter: {
            pattern: /^\$\{|\}$/,
            alias: 'variable'
          },
          rest: Prism.languages.kotlin
        }
      },
      {
        pattern: /\$\w+/,
        alias: 'variable'
      }
    ]
    Prism.languages.kotlin['string'].inside = Prism.languages.kotlin[
      'raw-string'
    ].inside = {
      interpolation: interpolation
    }
  })(Prism)
}


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = latex
latex.displayName = 'latex'
latex.aliases = []
function latex(Prism) {
  ;(function(Prism) {
    var funcPattern = /\\(?:[^a-z()[\]]|[a-z*]+)/i,
      insideEqu = {
        'equation-command': {
          pattern: funcPattern,
          alias: 'regex'
        }
      }
    Prism.languages.latex = {
      comment: /%.*/m,
      // the verbatim environment prints whitespace to the document
      cdata: {
        pattern: /(\\begin\{((?:verbatim|lstlisting)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
        lookbehind: true
      },
      /*
       * equations can be between $ $ or \( \) or \[ \]
       * (all are multiline)
       */
      equation: [
        {
          pattern: /\$(?:\\[\s\S]|[^\\$])*\$|\\\([\s\S]*?\\\)|\\\[[\s\S]*?\\\]/,
          inside: insideEqu,
          alias: 'string'
        },
        {
          pattern: /(\\begin\{((?:equation|math|eqnarray|align|multline|gather)\*?)\})[\s\S]*?(?=\\end\{\2\})/,
          lookbehind: true,
          inside: insideEqu,
          alias: 'string'
        }
      ],
      /*
       * arguments which are keywords or references are highlighted
       * as keywords
       */
      keyword: {
        pattern: /(\\(?:begin|end|ref|cite|label|usepackage|documentclass)(?:\[[^\]]+\])?\{)[^}]+(?=\})/,
        lookbehind: true
      },
      url: {
        pattern: /(\\url\{)[^}]+(?=\})/,
        lookbehind: true
      },
      /*
       * section or chapter headlines are highlighted as bold so that
       * they stand out more
       */
      headline: {
        pattern: /(\\(?:part|chapter|section|subsection|frametitle|subsubsection|paragraph|subparagraph|subsubparagraph|subsubsubparagraph)\*?(?:\[[^\]]+\])?\{)[^}]+(?=\}(?:\[[^\]]+\])?)/,
        lookbehind: true,
        alias: 'class-name'
      },
      function: {
        pattern: funcPattern,
        alias: 'selector'
      },
      punctuation: /[[\]{}&]/
    }
  })(Prism)
}


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = less
less.displayName = 'less'
less.aliases = []
function less(Prism) {
  /* FIXME :
:extend() is not handled specifically : its highlighting is buggy.
Mixin usage must be inside a ruleset to be highlighted.
At-rules (e.g. import) containing interpolations are buggy.
Detached rulesets are highlighted as at-rules.
A comment before a mixin usage prevents the latter to be properly highlighted.
*/
  Prism.languages.less = Prism.languages.extend('css', {
    comment: [
      /\/\*[\s\S]*?\*\//,
      {
        pattern: /(^|[^\\])\/\/.*/,
        lookbehind: true
      }
    ],
    atrule: {
      pattern: /@[\w-]+?(?:\([^{}]+\)|[^(){};])*?(?=\s*\{)/i,
      inside: {
        punctuation: /[:()]/
      }
    },
    // selectors and mixins are considered the same
    selector: {
      pattern: /(?:@\{[\w-]+\}|[^{};\s@])(?:@\{[\w-]+\}|\([^{}]*\)|[^{};@])*?(?=\s*\{)/,
      inside: {
        // mixin parameters
        variable: /@+[\w-]+/
      }
    },
    property: /(?:@\{[\w-]+\}|[\w-])+(?:\+_?)?(?=\s*:)/i,
    punctuation: /[{}();:,]/,
    operator: /[+\-*\/]/
  })
  // Invert function and punctuation positions
  Prism.languages.insertBefore('less', 'punctuation', {
    function: Prism.languages.less.function
  })
  Prism.languages.insertBefore('less', 'property', {
    variable: [
      // Variable declaration (the colon must be consumed!)
      {
        pattern: /@[\w-]+\s*:/,
        inside: {
          punctuation: /:/
        }
      },
      // Variable usage
      /@@?[\w-]+/
    ],
    'mixin-usage': {
      pattern: /([{;]\s*)[.#](?!\d)[\w-]+.*?(?=[(;])/,
      lookbehind: true,
      alias: 'function'
    }
  })
}


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = liquid
liquid.displayName = 'liquid'
liquid.aliases = []
function liquid(Prism) {
  Prism.languages.liquid = {
    keyword: /\b(?:comment|endcomment|if|elsif|else|endif|unless|endunless|for|endfor|case|endcase|when|in|break|assign|continue|limit|offset|range|reversed|raw|endraw|capture|endcapture|tablerow|endtablerow)\b/,
    number: /\b0b[01]+\b|\b0x[\da-f]*\.?[\da-fp-]+\b|(?:\b\d+\.?\d*|\B\.\d+)(?:e[+-]?\d+)?[df]?/i,
    operator: {
      pattern: /(^|[^.])(?:\+[+=]?|-[-=]?|!=?|<<?=?|>>?>?=?|==?|&[&=]?|\|[|=]?|\*=?|\/=?|%=?|\^=?|[?:~])/m,
      lookbehind: true
    },
    function: {
      pattern: /(^|[\s;|&])(?:append|prepend|capitalize|cycle|cols|increment|decrement|abs|at_least|at_most|ceil|compact|concat|date|default|divided_by|downcase|escape|escape_once|first|floor|join|last|lstrip|map|minus|modulo|newline_to_br|plus|remove|remove_first|replace|replace_first|reverse|round|rstrip|size|slice|sort|sort_natural|split|strip|strip_html|strip_newlines|times|truncate|truncatewords|uniq|upcase|url_decode|url_encode|include|paginate)(?=$|[\s;|&])/,
      lookbehind: true
    }
  }
}


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = lisp
lisp.displayName = 'lisp'
lisp.aliases = []
function lisp(Prism) {
  ;(function(Prism) {
    // Functions to construct regular expressions
    // simple form
    // e.g. (interactive ... or (interactive)
    function simple_form(name) {
      return new RegExp('(\\()' + name + '(?=[\\s\\)])')
    }
    // booleans and numbers
    function primitive(pattern) {
      return new RegExp('([\\s([])' + pattern + '(?=[\\s)])')
    }
    // Patterns in regular expressions
    // Symbol name. See https://www.gnu.org/software/emacs/manual/html_node/elisp/Symbol-Type.html
    // & and : are excluded as they are usually used for special purposes
    var symbol = '[-+*/_~!@$%^=<>{}\\w]+'
    // symbol starting with & used in function arguments
    var marker = '&' + symbol
    // Open parenthesis for look-behind
    var par = '(\\()'
    var endpar = '(?=\\))'
    // End the pattern with look-ahead space
    var space = '(?=\\s)'
    var language = {
      // Three or four semicolons are considered a heading.
      // See https://www.gnu.org/software/emacs/manual/html_node/elisp/Comment-Tips.html
      heading: {
        pattern: /;;;.*/,
        alias: ['comment', 'title']
      },
      comment: /;.*/,
      string: {
        pattern: /"(?:[^"\\]*|\\.)*"/,
        greedy: true,
        inside: {
          argument: /[-A-Z]+(?=[.,\s])/,
          symbol: new RegExp('`' + symbol + "'")
        }
      },
      'quoted-symbol': {
        pattern: new RegExp("#?'" + symbol),
        alias: ['variable', 'symbol']
      },
      'lisp-property': {
        pattern: new RegExp(':' + symbol),
        alias: 'property'
      },
      splice: {
        pattern: new RegExp(',@?' + symbol),
        alias: ['symbol', 'variable']
      },
      keyword: [
        {
          pattern: new RegExp(
            par +
              '(?:(?:lexical-)?let\\*?|(?:cl-)?letf|if|when|while|unless|cons|cl-loop|and|or|not|cond|setq|error|message|null|require|provide|use-package)' +
              space
          ),
          lookbehind: true
        },
        {
          pattern: new RegExp(
            par +
              '(?:for|do|collect|return|finally|append|concat|in|by)' +
              space
          ),
          lookbehind: true
        }
      ],
      declare: {
        pattern: simple_form('declare'),
        lookbehind: true,
        alias: 'keyword'
      },
      interactive: {
        pattern: simple_form('interactive'),
        lookbehind: true,
        alias: 'keyword'
      },
      boolean: {
        pattern: primitive('(?:t|nil)'),
        lookbehind: true
      },
      number: {
        pattern: primitive('[-+]?\\d+(?:\\.\\d*)?'),
        lookbehind: true
      },
      defvar: {
        pattern: new RegExp(par + 'def(?:var|const|custom|group)\\s+' + symbol),
        lookbehind: true,
        inside: {
          keyword: /^def[a-z]+/,
          variable: new RegExp(symbol)
        }
      },
      defun: {
        pattern: new RegExp(
          par +
            '(?:cl-)?(?:defun\\*?|defmacro)\\s+' +
            symbol +
            '\\s+\\([\\s\\S]*?\\)'
        ),
        lookbehind: true,
        inside: {
          keyword: /^(?:cl-)?def\S+/,
          // See below, this property needs to be defined later so that it can
          // reference the language object.
          arguments: null,
          function: {
            pattern: new RegExp('(^\\s)' + symbol),
            lookbehind: true
          },
          punctuation: /[()]/
        }
      },
      lambda: {
        pattern: new RegExp(par + 'lambda\\s+\\((?:&?' + symbol + '\\s*)*\\)'),
        lookbehind: true,
        inside: {
          keyword: /^lambda/,
          // See below, this property needs to be defined later so that it can
          // reference the language object.
          arguments: null,
          punctuation: /[()]/
        }
      },
      car: {
        pattern: new RegExp(par + symbol),
        lookbehind: true
      },
      punctuation: [
        // open paren, brackets, and close paren
        /(['`,]?\(|[)\[\]])/,
        // cons
        {
          pattern: /(\s)\.(?=\s)/,
          lookbehind: true
        }
      ]
    }
    var arg = {
      'lisp-marker': new RegExp(marker),
      rest: {
        argument: {
          pattern: new RegExp(symbol),
          alias: 'variable'
        },
        varform: {
          pattern: new RegExp(par + symbol + '\\s+\\S[\\s\\S]*' + endpar),
          lookbehind: true,
          inside: {
            string: language.string,
            boolean: language.boolean,
            number: language.number,
            symbol: language.symbol,
            punctuation: /[()]/
          }
        }
      }
    }
    var forms = '\\S+(?:\\s+\\S+)*'
    var arglist = {
      pattern: new RegExp(par + '[\\s\\S]*' + endpar),
      lookbehind: true,
      inside: {
        'rest-vars': {
          pattern: new RegExp('&(?:rest|body)\\s+' + forms),
          inside: arg
        },
        'other-marker-vars': {
          pattern: new RegExp('&(?:optional|aux)\\s+' + forms),
          inside: arg
        },
        keys: {
          pattern: new RegExp(
            '&key\\s+' + forms + '(?:\\s+&allow-other-keys)?'
          ),
          inside: arg
        },
        argument: {
          pattern: new RegExp(symbol),
          alias: 'variable'
        },
        punctuation: /[()]/
      }
    }
    language['lambda'].inside.arguments = arglist
    language['defun'].inside.arguments = Prism.util.clone(arglist)
    language['defun'].inside.arguments.inside.sublist = arglist
    Prism.languages.lisp = language
    Prism.languages.elisp = language
    Prism.languages.emacs = language
    Prism.languages['emacs-lisp'] = language
  })(Prism)
}


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = livescript
livescript.displayName = 'livescript'
livescript.aliases = []
function livescript(Prism) {
  Prism.languages.livescript = {
    comment: [
      {
        pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
        lookbehind: true
      },
      {
        pattern: /(^|[^\\])#.*/,
        lookbehind: true
      }
    ],
    'interpolated-string': {
      /* Look-behind and look-ahead prevents wrong behavior of the greedy pattern
       * forcing it to match """-quoted string when it would otherwise match "-quoted first. */
      pattern: /(^|[^"])("""|")(?:\\[\s\S]|(?!\2)[^\\])*\2(?!")/,
      lookbehind: true,
      greedy: true,
      inside: {
        variable: {
          pattern: /(^|[^\\])#[a-z_](?:-?[a-z]|[\d_])*/m,
          lookbehind: true
        },
        interpolation: {
          pattern: /(^|[^\\])#\{[^}]+\}/m,
          lookbehind: true,
          inside: {
            'interpolation-punctuation': {
              pattern: /^#\{|\}$/,
              alias: 'variable'
              // See rest below
            }
          }
        },
        string: /[\s\S]+/
      }
    },
    string: [
      {
        pattern: /('''|')(?:\\[\s\S]|(?!\1)[^\\])*\1/,
        greedy: true
      },
      {
        pattern: /<\[[\s\S]*?\]>/,
        greedy: true
      },
      /\\[^\s,;\])}]+/
    ],
    regex: [
      {
        pattern: /\/\/(\[.+?]|\\.|(?!\/\/)[^\\])+\/\/[gimyu]{0,5}/,
        greedy: true,
        inside: {
          comment: {
            pattern: /(^|[^\\])#.*/,
            lookbehind: true
          }
        }
      },
      {
        pattern: /\/(\[.+?]|\\.|[^/\\\r\n])+\/[gimyu]{0,5}/,
        greedy: true
      }
    ],
    keyword: {
      pattern: /(^|(?!-).)\b(?:break|case|catch|class|const|continue|default|do|else|extends|fallthrough|finally|for(?: ever)?|function|if|implements|it|let|loop|new|null|otherwise|own|return|super|switch|that|then|this|throw|try|unless|until|var|void|when|while|yield)(?!-)\b/m,
      lookbehind: true
    },
    'keyword-operator': {
      pattern: /(^|[^-])\b(?:(?:delete|require|typeof)!|(?:and|by|delete|export|from|import(?: all)?|in|instanceof|is(?:nt| not)?|not|of|or|til|to|typeof|with|xor)(?!-)\b)/m,
      lookbehind: true,
      alias: 'operator'
    },
    boolean: {
      pattern: /(^|[^-])\b(?:false|no|off|on|true|yes)(?!-)\b/m,
      lookbehind: true
    },
    argument: {
      // Don't match .&. nor &&
      pattern: /(^|(?!\.&\.)[^&])&(?!&)\d*/m,
      lookbehind: true,
      alias: 'variable'
    },
    number: /\b(?:\d+~[\da-z]+|\d[\d_]*(?:\.\d[\d_]*)?(?:[a-z]\w*)?)/i,
    identifier: /[a-z_](?:-?[a-z]|[\d_])*/i,
    operator: [
      // Spaced .
      {
        pattern: /( )\.(?= )/,
        lookbehind: true
      },
      // Full list, in order:
      // .= .~ .. ...
      // .&. .^. .<<. .>>. .>>>.
      // := :: ::=
      // &&
      // || |>
      // < << <<< <<<<
      // <- <-- <-! <--!
      // <~ <~~ <~! <~~!
      // <| <= <?
      // > >> >= >?
      // - -- -> -->
      // + ++
      // @ @@
      // % %%
      // * **
      // ! != !~=
      // !~> !~~>
      // !-> !-->
      // ~ ~> ~~> ~=
      // = ==
      // ^ ^^
      // / ?
      /\.(?:[=~]|\.\.?)|\.(?:[&|^]|<<|>>>?)\.|:(?:=|:=?)|&&|\|[|>]|<(?:<<?<?|--?!?|~~?!?|[|=?])?|>[>=?]?|-(?:->?|>)?|\+\+?|@@?|%%?|\*\*?|!(?:~?=|--?>|~?~>)?|~(?:~?>|=)?|==?|\^\^?|[\/?]/
    ],
    punctuation: /[(){}\[\]|.,:;`]/
  }
  Prism.languages.livescript['interpolated-string'].inside[
    'interpolation'
  ].inside.rest = Prism.languages.livescript
}


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = lolcode
lolcode.displayName = 'lolcode'
lolcode.aliases = []
function lolcode(Prism) {
  Prism.languages.lolcode = {
    comment: [/\bOBTW\s+[\s\S]*?\s+TLDR\b/, /\bBTW.+/],
    string: {
      pattern: /"(?::.|[^"])*"/,
      inside: {
        variable: /:\{[^}]+\}/,
        symbol: [/:\([a-f\d]+\)/i, /:\[[^\]]+\]/, /:[)>o":]/]
      },
      greedy: true
    },
    number: /(?:\B-)?(?:\b\d+\.?\d*|\B\.\d+)/,
    symbol: {
      pattern: /(^|\s)(?:A )?(?:YARN|NUMBR|NUMBAR|TROOF|BUKKIT|NOOB)(?=\s|,|$)/,
      lookbehind: true,
      inside: {
        keyword: /A(?=\s)/
      }
    },
    label: {
      pattern: /((?:^|\s)(?:IM IN YR|IM OUTTA YR) )[a-zA-Z]\w*/,
      lookbehind: true,
      alias: 'string'
    },
    function: {
      pattern: /((?:^|\s)(?:I IZ|HOW IZ I|IZ) )[a-zA-Z]\w*/,
      lookbehind: true
    },
    keyword: [
      {
        pattern: /(^|\s)(?:O HAI IM|KTHX|HAI|KTHXBYE|I HAS A|ITZ(?: A)?|R|AN|MKAY|SMOOSH|MAEK|IS NOW(?: A)?|VISIBLE|GIMMEH|O RLY\?|YA RLY|NO WAI|OIC|MEBBE|WTF\?|OMG|OMGWTF|GTFO|IM IN YR|IM OUTTA YR|FOUND YR|YR|TIL|WILE|UPPIN|NERFIN|I IZ|HOW IZ I|IF U SAY SO|SRS|HAS A|LIEK(?: A)?|IZ)(?=\s|,|$)/,
        lookbehind: true
      },
      /'Z(?=\s|,|$)/
    ],
    boolean: {
      pattern: /(^|\s)(?:WIN|FAIL)(?=\s|,|$)/,
      lookbehind: true
    },
    variable: {
      pattern: /(^|\s)IT(?=\s|,|$)/,
      lookbehind: true
    },
    operator: {
      pattern: /(^|\s)(?:NOT|BOTH SAEM|DIFFRINT|(?:SUM|DIFF|PRODUKT|QUOSHUNT|MOD|BIGGR|SMALLR|BOTH|EITHER|WON|ALL|ANY) OF)(?=\s|,|$)/,
      lookbehind: true
    },
    punctuation: /\.{3}|…|,|!/
  }
}


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = lua
lua.displayName = 'lua'
lua.aliases = []
function lua(Prism) {
  Prism.languages.lua = {
    comment: /^#!.+|--(?:\[(=*)\[[\s\S]*?\]\1\]|.*)/m,
    // \z may be used to skip the following space
    string: {
      pattern: /(["'])(?:(?!\1)[^\\\r\n]|\\z(?:\r\n|\s)|\\(?:\r\n|[\s\S]))*\1|\[(=*)\[[\s\S]*?\]\2\]/,
      greedy: true
    },
    number: /\b0x[a-f\d]+\.?[a-f\d]*(?:p[+-]?\d+)?\b|\b\d+(?:\.\B|\.?\d*(?:e[+-]?\d+)?\b)|\B\.\d+(?:e[+-]?\d+)?\b/i,
    keyword: /\b(?:and|break|do|else|elseif|end|false|for|function|goto|if|in|local|nil|not|or|repeat|return|then|true|until|while)\b/,
    function: /(?!\d)\w+(?=\s*(?:[({]))/,
    operator: [
      /[-+*%^&|#]|\/\/?|<[<=]?|>[>=]?|[=~]=?/,
      {
        // Match ".." but don't break "..."
        pattern: /(^|[^.])\.\.(?!\.)/,
        lookbehind: true
      }
    ],
    punctuation: /[\[\](){},;]|\.+|:+/
  }
}


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = makefile
makefile.displayName = 'makefile'
makefile.aliases = []
function makefile(Prism) {
  Prism.languages.makefile = {
    comment: {
      pattern: /(^|[^\\])#(?:\\(?:\r\n|[\s\S])|[^\\\r\n])*/,
      lookbehind: true
    },
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: true
    },
    // Built-in target names
    builtin: /\.[A-Z][^:#=\s]+(?=\s*:(?!=))/,
    // Targets
    symbol: {
      pattern: /^[^:=\r\n]+(?=\s*:(?!=))/m,
      inside: {
        variable: /\$+(?:[^(){}:#=\s]+|(?=[({]))/
      }
    },
    variable: /\$+(?:[^(){}:#=\s]+|\([@*%<^+?][DF]\)|(?=[({]))/,
    keyword: [
      // Directives
      /-include\b|\b(?:define|else|endef|endif|export|ifn?def|ifn?eq|include|override|private|sinclude|undefine|unexport|vpath)\b/,
      // Functions
      {
        pattern: /(\()(?:addsuffix|abspath|and|basename|call|dir|error|eval|file|filter(?:-out)?|findstring|firstword|flavor|foreach|guile|if|info|join|lastword|load|notdir|or|origin|patsubst|realpath|shell|sort|strip|subst|suffix|value|warning|wildcard|word(?:s|list)?)(?=[ \t])/,
        lookbehind: true
      }
    ],
    operator: /(?:::|[?:+!])?=|[|@]/,
    punctuation: /[:;(){}]/
  }
}


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = markdown
markdown.displayName = 'markdown'
markdown.aliases = []
function markdown(Prism) {
  Prism.languages.markdown = Prism.languages.extend('markup', {})
  Prism.languages.insertBefore('markdown', 'prolog', {
    blockquote: {
      // > ...
      pattern: /^>(?:[\t ]*>)*/m,
      alias: 'punctuation'
    },
    code: [
      {
        // Prefixed by 4 spaces or 1 tab
        pattern: /^(?: {4}|\t).+/m,
        alias: 'keyword'
      },
      {
        // `code`
        // ``code``
        pattern: /``.+?``|`[^`\n]+`/,
        alias: 'keyword'
      }
    ],
    title: [
      {
        // title 1
        // =======
        // title 2
        // -------
        pattern: /\w+.*(?:\r?\n|\r)(?:==+|--+)/,
        alias: 'important',
        inside: {
          punctuation: /==+$|--+$/
        }
      },
      {
        // # title 1
        // ###### title 6
        pattern: /(^\s*)#+.+/m,
        lookbehind: true,
        alias: 'important',
        inside: {
          punctuation: /^#+|#+$/
        }
      }
    ],
    hr: {
      // ***
      // ---
      // * * *
      // -----------
      pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
      lookbehind: true,
      alias: 'punctuation'
    },
    list: {
      // * item
      // + item
      // - item
      // 1. item
      pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
      lookbehind: true,
      alias: 'punctuation'
    },
    'url-reference': {
      // [id]: http://example.com "Optional title"
      // [id]: http://example.com 'Optional title'
      // [id]: http://example.com (Optional title)
      // [id]: <http://example.com> "Optional title"
      pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
      inside: {
        variable: {
          pattern: /^(!?\[)[^\]]+/,
          lookbehind: true
        },
        string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
        punctuation: /^[\[\]!:]|[<>]/
      },
      alias: 'url'
    },
    bold: {
      // **strong**
      // __strong__
      // Allow only one line break
      pattern: /(^|[^\\])(\*\*|__)(?:(?:\r?\n|\r)(?!\r?\n|\r)|.)+?\2/,
      lookbehind: true,
      inside: {
        punctuation: /^\*\*|^__|\*\*$|__$/
      }
    },
    italic: {
      // *em*
      // _em_
      // Allow only one line break
      pattern: /(^|[^\\])([*_])(?:(?:\r?\n|\r)(?!\r?\n|\r)|.)+?\2/,
      lookbehind: true,
      inside: {
        punctuation: /^[*_]|[*_]$/
      }
    },
    url: {
      // [example](http://example.com "Optional title")
      // [example] [id]
      pattern: /!?\[[^\]]+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)| ?\[[^\]\n]*\])/,
      inside: {
        variable: {
          pattern: /(!?\[)[^\]]+(?=\]$)/,
          lookbehind: true
        },
        string: {
          pattern: /"(?:\\.|[^"\\])*"(?=\)$)/
        }
      }
    }
  })
  Prism.languages.markdown['bold'].inside['url'] =
    Prism.languages.markdown['url']
  Prism.languages.markdown['italic'].inside['url'] =
    Prism.languages.markdown['url']
  Prism.languages.markdown['bold'].inside['italic'] =
    Prism.languages.markdown['italic']
  Prism.languages.markdown['italic'].inside['bold'] =
    Prism.languages.markdown['bold']
}


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = markupTemplating
markupTemplating.displayName = 'markupTemplating'
markupTemplating.aliases = []
function markupTemplating(Prism) {
  Prism.languages['markup-templating'] = {}
  Object.defineProperties(Prism.languages['markup-templating'], {
    buildPlaceholders: {
      // Tokenize all inline templating expressions matching placeholderPattern
      // If the replaceFilter function is provided, it will be called with every match.
      // If it returns false, the match will not be replaced.
      value: function(env, language, placeholderPattern, replaceFilter) {
        if (env.language !== language) {
          return
        }
        env.tokenStack = []
        env.code = env.code.replace(placeholderPattern, function(match) {
          if (typeof replaceFilter === 'function' && !replaceFilter(match)) {
            return match
          }
          var i = env.tokenStack.length
          // Check for existing strings
          while (
            env.code.indexOf('___' + language.toUpperCase() + i + '___') !== -1
          )
            ++i
          // Create a sparse array
          env.tokenStack[i] = match
          return '___' + language.toUpperCase() + i + '___'
        })
        // Switch the grammar to markup
        env.grammar = Prism.languages.markup
      }
    },
    tokenizePlaceholders: {
      // Replace placeholders with proper tokens after tokenizing
      value: function(env, language) {
        if (env.language !== language || !env.tokenStack) {
          return
        }
        // Switch the grammar back
        env.grammar = Prism.languages[language]
        var j = 0
        var keys = Object.keys(env.tokenStack)
        var walkTokens = function(tokens) {
          if (j >= keys.length) {
            return
          }
          for (var i = 0; i < tokens.length; i++) {
            var token = tokens[i]
            if (
              typeof token === 'string' ||
              (token.content && typeof token.content === 'string')
            ) {
              var k = keys[j]
              var t = env.tokenStack[k]
              var s = typeof token === 'string' ? token : token.content
              var index = s.indexOf('___' + language.toUpperCase() + k + '___')
              if (index > -1) {
                ++j
                var before = s.substring(0, index)
                var middle = new Prism.Token(
                  language,
                  Prism.tokenize(t, env.grammar, language),
                  'language-' + language,
                  t
                )
                var after = s.substring(
                  index + ('___' + language.toUpperCase() + k + '___').length
                )
                var replacement
                if (before || after) {
                  replacement = [before, middle, after].filter(function(v) {
                    return !!v
                  })
                  walkTokens(replacement)
                } else {
                  replacement = middle
                }
                if (typeof token === 'string') {
                  Array.prototype.splice.apply(
                    tokens,
                    [i, 1].concat(replacement)
                  )
                } else {
                  token.content = replacement
                }
                if (j >= keys.length) {
                  break
                }
              }
            } else if (token.content && typeof token.content !== 'string') {
              walkTokens(token.content)
            }
          }
        }
        walkTokens(env.tokens)
      }
    }
  })
}


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = markup
markup.displayName = 'markup'
markup.aliases = ['xml', 'html', 'mathml', 'svg']
function markup(Prism) {
  Prism.languages.markup = {
    comment: /<!--[\s\S]*?-->/,
    prolog: /<\?[\s\S]+?\?>/,
    doctype: /<!DOCTYPE[\s\S]+?>/i,
    cdata: /<!\[CDATA\[[\s\S]*?]]>/i,
    tag: {
      pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/i,
      greedy: true,
      inside: {
        tag: {
          pattern: /^<\/?[^\s>\/]+/i,
          inside: {
            punctuation: /^<\/?/,
            namespace: /^[^\s>\/:]+:/
          }
        },
        'attr-value': {
          pattern: /=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+)/i,
          inside: {
            punctuation: [
              /^=/,
              {
                pattern: /(^|[^\\])["']/,
                lookbehind: true
              }
            ]
          }
        },
        punctuation: /\/?>/,
        'attr-name': {
          pattern: /[^\s>\/]+/,
          inside: {
            namespace: /^[^\s>\/:]+:/
          }
        }
      }
    },
    entity: /&#?[\da-z]{1,8};/i
  }
  Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] =
    Prism.languages.markup['entity']
  // Plugin to make entity title show the real entity, idea by Roman Komarov
  Prism.hooks.add('wrap', function(env) {
    if (env.type === 'entity') {
      env.attributes['title'] = env.content.value.replace(/&amp;/, '&')
    }
  })
  Prism.languages.xml = Prism.languages.markup
  Prism.languages.html = Prism.languages.markup
  Prism.languages.mathml = Prism.languages.markup
  Prism.languages.svg = Prism.languages.markup
}


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = matlab
matlab.displayName = 'matlab'
matlab.aliases = []
function matlab(Prism) {
  Prism.languages.matlab = {
    comment: [/%\{[\s\S]*?\}%/, /%.+/],
    string: {
      pattern: /\B'(?:''|[^'\r\n])*'/,
      greedy: true
    },
    // FIXME We could handle imaginary numbers as a whole
    number: /(?:\b\d+\.?\d*|\B\.\d+)(?:[eE][+-]?\d+)?(?:[ij])?|\b[ij]\b/,
    keyword: /\b(?:break|case|catch|continue|else|elseif|end|for|function|if|inf|NaN|otherwise|parfor|pause|pi|return|switch|try|while)\b/,
    function: /(?!\d)\w+(?=\s*\()/,
    operator: /\.?[*^\/\\']|[+\-:@]|[<>=~]=?|&&?|\|\|?/,
    punctuation: /\.{3}|[.,;\[\](){}!]/
  }
}


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = mel
mel.displayName = 'mel'
mel.aliases = []
function mel(Prism) {
  Prism.languages.mel = {
    comment: /\/\/.*/,
    code: {
      pattern: /`(?:\\.|[^\\`\r\n])*`/,
      greedy: true,
      alias: 'italic',
      inside: {
        delimiter: {
          pattern: /^`|`$/,
          alias: 'punctuation'
          // See rest below
        }
      }
    },
    string: {
      pattern: /"(?:\\.|[^\\"\r\n])*"/,
      greedy: true
    },
    variable: /\$\w+/,
    number: /\b0x[\da-fA-F]+\b|\b\d+\.?\d*|\B\.\d+/,
    flag: {
      pattern: /-[^\d\W]\w*/,
      alias: 'operator'
    },
    keyword: /\b(?:break|case|continue|default|do|else|float|for|global|if|in|int|matrix|proc|return|string|switch|vector|while)\b/,
    function: /\w+(?=\()|\b(?:about|abs|addAttr|addAttributeEditorNodeHelp|addDynamic|addNewShelfTab|addPP|addPanelCategory|addPrefixToName|advanceToNextDrivenKey|affectedNet|affects|aimConstraint|air|alias|aliasAttr|align|alignCtx|alignCurve|alignSurface|allViewFit|ambientLight|angle|angleBetween|animCone|animCurveEditor|animDisplay|animView|annotate|appendStringArray|applicationName|applyAttrPreset|applyTake|arcLenDimContext|arcLengthDimension|arclen|arrayMapper|art3dPaintCtx|artAttrCtx|artAttrPaintVertexCtx|artAttrSkinPaintCtx|artAttrTool|artBuildPaintMenu|artFluidAttrCtx|artPuttyCtx|artSelectCtx|artSetPaintCtx|artUserPaintCtx|assignCommand|assignInputDevice|assignViewportFactories|attachCurve|attachDeviceAttr|attachSurface|attrColorSliderGrp|attrCompatibility|attrControlGrp|attrEnumOptionMenu|attrEnumOptionMenuGrp|attrFieldGrp|attrFieldSliderGrp|attrNavigationControlGrp|attrPresetEditWin|attributeExists|attributeInfo|attributeMenu|attributeQuery|autoKeyframe|autoPlace|bakeClip|bakeFluidShading|bakePartialHistory|bakeResults|bakeSimulation|basename|basenameEx|batchRender|bessel|bevel|bevelPlus|binMembership|bindSkin|blend2|blendShape|blendShapeEditor|blendShapePanel|blendTwoAttr|blindDataType|boneLattice|boundary|boxDollyCtx|boxZoomCtx|bufferCurve|buildBookmarkMenu|buildKeyframeMenu|button|buttonManip|CBG|cacheFile|cacheFileCombine|cacheFileMerge|cacheFileTrack|camera|cameraView|canCreateManip|canvas|capitalizeString|catch|catchQuiet|ceil|changeSubdivComponentDisplayLevel|changeSubdivRegion|channelBox|character|characterMap|characterOutlineEditor|characterize|chdir|checkBox|checkBoxGrp|checkDefaultRenderGlobals|choice|circle|circularFillet|clamp|clear|clearCache|clip|clipEditor|clipEditorCurrentTimeCtx|clipSchedule|clipSchedulerOutliner|clipTrimBefore|closeCurve|closeSurface|cluster|cmdFileOutput|cmdScrollFieldExecuter|cmdScrollFieldReporter|cmdShell|coarsenSubdivSelectionList|collision|color|colorAtPoint|colorEditor|colorIndex|colorIndexSliderGrp|colorSliderButtonGrp|colorSliderGrp|columnLayout|commandEcho|commandLine|commandPort|compactHairSystem|componentEditor|compositingInterop|computePolysetVolume|condition|cone|confirmDialog|connectAttr|connectControl|connectDynamic|connectJoint|connectionInfo|constrain|constrainValue|constructionHistory|container|containsMultibyte|contextInfo|control|convertFromOldLayers|convertIffToPsd|convertLightmap|convertSolidTx|convertTessellation|convertUnit|copyArray|copyFlexor|copyKey|copySkinWeights|cos|cpButton|cpCache|cpClothSet|cpCollision|cpConstraint|cpConvClothToMesh|cpForces|cpGetSolverAttr|cpPanel|cpProperty|cpRigidCollisionFilter|cpSeam|cpSetEdit|cpSetSolverAttr|cpSolver|cpSolverTypes|cpTool|cpUpdateClothUVs|createDisplayLayer|createDrawCtx|createEditor|createLayeredPsdFile|createMotionField|createNewShelf|createNode|createRenderLayer|createSubdivRegion|cross|crossProduct|ctxAbort|ctxCompletion|ctxEditMode|ctxTraverse|currentCtx|currentTime|currentTimeCtx|currentUnit|curve|curveAddPtCtx|curveCVCtx|curveEPCtx|curveEditorCtx|curveIntersect|curveMoveEPCtx|curveOnSurface|curveSketchCtx|cutKey|cycleCheck|cylinder|dagPose|date|defaultLightListCheckBox|defaultNavigation|defineDataServer|defineVirtualDevice|deformer|deg_to_rad|delete|deleteAttr|deleteShadingGroupsAndMaterials|deleteShelfTab|deleteUI|deleteUnusedBrushes|delrandstr|detachCurve|detachDeviceAttr|detachSurface|deviceEditor|devicePanel|dgInfo|dgdirty|dgeval|dgtimer|dimWhen|directKeyCtx|directionalLight|dirmap|dirname|disable|disconnectAttr|disconnectJoint|diskCache|displacementToPoly|displayAffected|displayColor|displayCull|displayLevelOfDetail|displayPref|displayRGBColor|displaySmoothness|displayStats|displayString|displaySurface|distanceDimContext|distanceDimension|doBlur|dolly|dollyCtx|dopeSheetEditor|dot|dotProduct|doubleProfileBirailSurface|drag|dragAttrContext|draggerContext|dropoffLocator|duplicate|duplicateCurve|duplicateSurface|dynCache|dynControl|dynExport|dynExpression|dynGlobals|dynPaintEditor|dynParticleCtx|dynPref|dynRelEdPanel|dynRelEditor|dynamicLoad|editAttrLimits|editDisplayLayerGlobals|editDisplayLayerMembers|editRenderLayerAdjustment|editRenderLayerGlobals|editRenderLayerMembers|editor|editorTemplate|effector|emit|emitter|enableDevice|encodeString|endString|endsWith|env|equivalent|equivalentTol|erf|error|eval|evalDeferred|evalEcho|event|exactWorldBoundingBox|exclusiveLightCheckBox|exec|executeForEachObject|exists|exp|expression|expressionEditorListen|extendCurve|extendSurface|extrude|fcheck|fclose|feof|fflush|fgetline|fgetword|file|fileBrowserDialog|fileDialog|fileExtension|fileInfo|filetest|filletCurve|filter|filterCurve|filterExpand|filterStudioImport|findAllIntersections|findAnimCurves|findKeyframe|findMenuItem|findRelatedSkinCluster|finder|firstParentOf|fitBspline|flexor|floatEq|floatField|floatFieldGrp|floatScrollBar|floatSlider|floatSlider2|floatSliderButtonGrp|floatSliderGrp|floor|flow|fluidCacheInfo|fluidEmitter|fluidVoxelInfo|flushUndo|fmod|fontDialog|fopen|formLayout|format|fprint|frameLayout|fread|freeFormFillet|frewind|fromNativePath|fwrite|gamma|gauss|geometryConstraint|getApplicationVersionAsFloat|getAttr|getClassification|getDefaultBrush|getFileList|getFluidAttr|getInputDeviceRange|getMayaPanelTypes|getModifiers|getPanel|getParticleAttr|getPluginResource|getenv|getpid|glRender|glRenderEditor|globalStitch|gmatch|goal|gotoBindPose|grabColor|gradientControl|gradientControlNoAttr|graphDollyCtx|graphSelectContext|graphTrackCtx|gravity|grid|gridLayout|group|groupObjectsByName|HfAddAttractorToAS|HfAssignAS|HfBuildEqualMap|HfBuildFurFiles|HfBuildFurImages|HfCancelAFR|HfConnectASToHF|HfCreateAttractor|HfDeleteAS|HfEditAS|HfPerformCreateAS|HfRemoveAttractorFromAS|HfSelectAttached|HfSelectAttractors|HfUnAssignAS|hardenPointCurve|hardware|hardwareRenderPanel|headsUpDisplay|headsUpMessage|help|helpLine|hermite|hide|hilite|hitTest|hotBox|hotkey|hotkeyCheck|hsv_to_rgb|hudButton|hudSlider|hudSliderButton|hwReflectionMap|hwRender|hwRenderLoad|hyperGraph|hyperPanel|hyperShade|hypot|iconTextButton|iconTextCheckBox|iconTextRadioButton|iconTextRadioCollection|iconTextScrollList|iconTextStaticLabel|ikHandle|ikHandleCtx|ikHandleDisplayScale|ikSolver|ikSplineHandleCtx|ikSystem|ikSystemInfo|ikfkDisplayMethod|illustratorCurves|image|imfPlugins|inheritTransform|insertJoint|insertJointCtx|insertKeyCtx|insertKnotCurve|insertKnotSurface|instance|instanceable|instancer|intField|intFieldGrp|intScrollBar|intSlider|intSliderGrp|interToUI|internalVar|intersect|iprEngine|isAnimCurve|isConnected|isDirty|isParentOf|isSameObject|isTrue|isValidObjectName|isValidString|isValidUiName|isolateSelect|itemFilter|itemFilterAttr|itemFilterRender|itemFilterType|joint|jointCluster|jointCtx|jointDisplayScale|jointLattice|keyTangent|keyframe|keyframeOutliner|keyframeRegionCurrentTimeCtx|keyframeRegionDirectKeyCtx|keyframeRegionDollyCtx|keyframeRegionInsertKeyCtx|keyframeRegionMoveKeyCtx|keyframeRegionScaleKeyCtx|keyframeRegionSelectKeyCtx|keyframeRegionSetKeyCtx|keyframeRegionTrackCtx|keyframeStats|lassoContext|lattice|latticeDeformKeyCtx|launch|launchImageEditor|layerButton|layeredShaderPort|layeredTexturePort|layout|layoutDialog|lightList|lightListEditor|lightListPanel|lightlink|lineIntersection|linearPrecision|linstep|listAnimatable|listAttr|listCameras|listConnections|listDeviceAttachments|listHistory|listInputDeviceAxes|listInputDeviceButtons|listInputDevices|listMenuAnnotation|listNodeTypes|listPanelCategories|listRelatives|listSets|listTransforms|listUnselected|listerEditor|loadFluid|loadNewShelf|loadPlugin|loadPluginLanguageResources|loadPrefObjects|localizedPanelLabel|lockNode|loft|log|longNameOf|lookThru|ls|lsThroughFilter|lsType|lsUI|Mayatomr|mag|makeIdentity|makeLive|makePaintable|makeRoll|makeSingleSurface|makeTubeOn|makebot|manipMoveContext|manipMoveLimitsCtx|manipOptions|manipRotateContext|manipRotateLimitsCtx|manipScaleContext|manipScaleLimitsCtx|marker|match|max|memory|menu|menuBarLayout|menuEditor|menuItem|menuItemToShelf|menuSet|menuSetPref|messageLine|min|minimizeApp|mirrorJoint|modelCurrentTimeCtx|modelEditor|modelPanel|mouse|movIn|movOut|move|moveIKtoFK|moveKeyCtx|moveVertexAlongDirection|multiProfileBirailSurface|mute|nParticle|nameCommand|nameField|namespace|namespaceInfo|newPanelItems|newton|nodeCast|nodeIconButton|nodeOutliner|nodePreset|nodeType|noise|nonLinear|normalConstraint|normalize|nurbsBoolean|nurbsCopyUVSet|nurbsCube|nurbsEditUV|nurbsPlane|nurbsSelect|nurbsSquare|nurbsToPoly|nurbsToPolygonsPref|nurbsToSubdiv|nurbsToSubdivPref|nurbsUVSet|nurbsViewDirectionVector|objExists|objectCenter|objectLayer|objectType|objectTypeUI|obsoleteProc|oceanNurbsPreviewPlane|offsetCurve|offsetCurveOnSurface|offsetSurface|openGLExtension|openMayaPref|optionMenu|optionMenuGrp|optionVar|orbit|orbitCtx|orientConstraint|outlinerEditor|outlinerPanel|overrideModifier|paintEffectsDisplay|pairBlend|palettePort|paneLayout|panel|panelConfiguration|panelHistory|paramDimContext|paramDimension|paramLocator|parent|parentConstraint|particle|particleExists|particleInstancer|particleRenderInfo|partition|pasteKey|pathAnimation|pause|pclose|percent|performanceOptions|pfxstrokes|pickWalk|picture|pixelMove|planarSrf|plane|play|playbackOptions|playblast|plugAttr|plugNode|pluginInfo|pluginResourceUtil|pointConstraint|pointCurveConstraint|pointLight|pointMatrixMult|pointOnCurve|pointOnSurface|pointPosition|poleVectorConstraint|polyAppend|polyAppendFacetCtx|polyAppendVertex|polyAutoProjection|polyAverageNormal|polyAverageVertex|polyBevel|polyBlendColor|polyBlindData|polyBoolOp|polyBridgeEdge|polyCacheMonitor|polyCheck|polyChipOff|polyClipboard|polyCloseBorder|polyCollapseEdge|polyCollapseFacet|polyColorBlindData|polyColorDel|polyColorPerVertex|polyColorSet|polyCompare|polyCone|polyCopyUV|polyCrease|polyCreaseCtx|polyCreateFacet|polyCreateFacetCtx|polyCube|polyCut|polyCutCtx|polyCylinder|polyCylindricalProjection|polyDelEdge|polyDelFacet|polyDelVertex|polyDuplicateAndConnect|polyDuplicateEdge|polyEditUV|polyEditUVShell|polyEvaluate|polyExtrudeEdge|polyExtrudeFacet|polyExtrudeVertex|polyFlipEdge|polyFlipUV|polyForceUV|polyGeoSampler|polyHelix|polyInfo|polyInstallAction|polyLayoutUV|polyListComponentConversion|polyMapCut|polyMapDel|polyMapSew|polyMapSewMove|polyMergeEdge|polyMergeEdgeCtx|polyMergeFacet|polyMergeFacetCtx|polyMergeUV|polyMergeVertex|polyMirrorFace|polyMoveEdge|polyMoveFacet|polyMoveFacetUV|polyMoveUV|polyMoveVertex|polyNormal|polyNormalPerVertex|polyNormalizeUV|polyOptUvs|polyOptions|polyOutput|polyPipe|polyPlanarProjection|polyPlane|polyPlatonicSolid|polyPoke|polyPrimitive|polyPrism|polyProjection|polyPyramid|polyQuad|polyQueryBlindData|polyReduce|polySelect|polySelectConstraint|polySelectConstraintMonitor|polySelectCtx|polySelectEditCtx|polySeparate|polySetToFaceNormal|polySewEdge|polyShortestPathCtx|polySmooth|polySoftEdge|polySphere|polySphericalProjection|polySplit|polySplitCtx|polySplitEdge|polySplitRing|polySplitVertex|polyStraightenUVBorder|polySubdivideEdge|polySubdivideFacet|polyToSubdiv|polyTorus|polyTransfer|polyTriangulate|polyUVSet|polyUnite|polyWedgeFace|popen|popupMenu|pose|pow|preloadRefEd|print|progressBar|progressWindow|projFileViewer|projectCurve|projectTangent|projectionContext|projectionManip|promptDialog|propModCtx|propMove|psdChannelOutliner|psdEditTextureFile|psdExport|psdTextureFile|putenv|pwd|python|querySubdiv|quit|rad_to_deg|radial|radioButton|radioButtonGrp|radioCollection|radioMenuItemCollection|rampColorPort|rand|randomizeFollicles|randstate|rangeControl|readTake|rebuildCurve|rebuildSurface|recordAttr|recordDevice|redo|reference|referenceEdit|referenceQuery|refineSubdivSelectionList|refresh|refreshAE|registerPluginResource|rehash|reloadImage|removeJoint|removeMultiInstance|removePanelCategory|rename|renameAttr|renameSelectionList|renameUI|render|renderGlobalsNode|renderInfo|renderLayerButton|renderLayerParent|renderLayerPostProcess|renderLayerUnparent|renderManip|renderPartition|renderQualityNode|renderSettings|renderThumbnailUpdate|renderWindowEditor|renderWindowSelectContext|renderer|reorder|reorderDeformers|requires|reroot|resampleFluid|resetAE|resetPfxToPolyCamera|resetTool|resolutionNode|retarget|reverseCurve|reverseSurface|revolve|rgb_to_hsv|rigidBody|rigidSolver|roll|rollCtx|rootOf|rot|rotate|rotationInterpolation|roundConstantRadius|rowColumnLayout|rowLayout|runTimeCommand|runup|sampleImage|saveAllShelves|saveAttrPreset|saveFluid|saveImage|saveInitialState|saveMenu|savePrefObjects|savePrefs|saveShelf|saveToolSettings|scale|scaleBrushBrightness|scaleComponents|scaleConstraint|scaleKey|scaleKeyCtx|sceneEditor|sceneUIReplacement|scmh|scriptCtx|scriptEditorInfo|scriptJob|scriptNode|scriptTable|scriptToShelf|scriptedPanel|scriptedPanelType|scrollField|scrollLayout|sculpt|searchPathArray|seed|selLoadSettings|select|selectContext|selectCurveCV|selectKey|selectKeyCtx|selectKeyframeRegionCtx|selectMode|selectPref|selectPriority|selectType|selectedNodes|selectionConnection|separator|setAttr|setAttrEnumResource|setAttrMapping|setAttrNiceNameResource|setConstraintRestPosition|setDefaultShadingGroup|setDrivenKeyframe|setDynamic|setEditCtx|setEditor|setFluidAttr|setFocus|setInfinity|setInputDeviceMapping|setKeyCtx|setKeyPath|setKeyframe|setKeyframeBlendshapeTargetWts|setMenuMode|setNodeNiceNameResource|setNodeTypeFlag|setParent|setParticleAttr|setPfxToPolyCamera|setPluginResource|setProject|setStampDensity|setStartupMessage|setState|setToolTo|setUITemplate|setXformManip|sets|shadingConnection|shadingGeometryRelCtx|shadingLightRelCtx|shadingNetworkCompare|shadingNode|shapeCompare|shelfButton|shelfLayout|shelfTabLayout|shellField|shortNameOf|showHelp|showHidden|showManipCtx|showSelectionInTitle|showShadingGroupAttrEditor|showWindow|sign|simplify|sin|singleProfileBirailSurface|size|sizeBytes|skinCluster|skinPercent|smoothCurve|smoothTangentSurface|smoothstep|snap2to2|snapKey|snapMode|snapTogetherCtx|snapshot|soft|softMod|softModCtx|sort|sound|soundControl|source|spaceLocator|sphere|sphrand|spotLight|spotLightPreviewPort|spreadSheetEditor|spring|sqrt|squareSurface|srtContext|stackTrace|startString|startsWith|stitchAndExplodeShell|stitchSurface|stitchSurfacePoints|strcmp|stringArrayCatenate|stringArrayContains|stringArrayCount|stringArrayInsertAtIndex|stringArrayIntersector|stringArrayRemove|stringArrayRemoveAtIndex|stringArrayRemoveDuplicates|stringArrayRemoveExact|stringArrayToString|stringToStringArray|strip|stripPrefixFromName|stroke|subdAutoProjection|subdCleanTopology|subdCollapse|subdDuplicateAndConnect|subdEditUV|subdListComponentConversion|subdMapCut|subdMapSewMove|subdMatchTopology|subdMirror|subdToBlind|subdToPoly|subdTransferUVsToCache|subdiv|subdivCrease|subdivDisplaySmoothness|substitute|substituteAllString|substituteGeometry|substring|surface|surfaceSampler|surfaceShaderList|swatchDisplayPort|switchTable|symbolButton|symbolCheckBox|sysFile|system|tabLayout|tan|tangentConstraint|texLatticeDeformContext|texManipContext|texMoveContext|texMoveUVShellContext|texRotateContext|texScaleContext|texSelectContext|texSelectShortestPathCtx|texSmudgeUVContext|texWinToolCtx|text|textCurves|textField|textFieldButtonGrp|textFieldGrp|textManip|textScrollList|textToShelf|textureDisplacePlane|textureHairColor|texturePlacementContext|textureWindow|threadCount|threePointArcCtx|timeControl|timePort|timerX|toNativePath|toggle|toggleAxis|toggleWindowVisibility|tokenize|tokenizeList|tolerance|tolower|toolButton|toolCollection|toolDropped|toolHasOptions|toolPropertyWindow|torus|toupper|trace|track|trackCtx|transferAttributes|transformCompare|transformLimits|translator|trim|trunc|truncateFluidCache|truncateHairCache|tumble|tumbleCtx|turbulence|twoPointArcCtx|uiRes|uiTemplate|unassignInputDevice|undo|undoInfo|ungroup|uniform|unit|unloadPlugin|untangleUV|untitledFileName|untrim|upAxis|updateAE|userCtx|uvLink|uvSnapshot|validateShelfName|vectorize|view2dToolCtx|viewCamera|viewClipPlane|viewFit|viewHeadOn|viewLookAt|viewManip|viewPlace|viewSet|visor|volumeAxis|vortex|waitCursor|warning|webBrowser|webBrowserPrefs|whatIs|window|windowPref|wire|wireContext|workspace|wrinkle|wrinkleContext|writeTake|xbmLangPathList|xform)\b/,
    operator: [
      /\+[+=]?|-[-=]?|&&|\|\||[<>]=|[*\/!=]=?|[%^]/,
      {
        // We don't want to match <<
        pattern: /(^|[^<])<(?!<)/,
        lookbehind: true
      },
      {
        // We don't want to match >>
        pattern: /(^|[^>])>(?!>)/,
        lookbehind: true
      }
    ],
    punctuation: /<<|>>|[.,:;?\[\](){}]/
  }
  Prism.languages.mel['code'].inside.rest = Prism.languages.mel
}


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = mizar
mizar.displayName = 'mizar'
mizar.aliases = []
function mizar(Prism) {
  Prism.languages.mizar = {
    comment: /::.+/,
    keyword: /@proof\b|\b(?:according|aggregate|all|and|antonym|are|as|associativity|assume|asymmetry|attr|be|begin|being|by|canceled|case|cases|clusters?|coherence|commutativity|compatibility|connectedness|consider|consistency|constructors|contradiction|correctness|def|deffunc|define|definitions?|defpred|do|does|equals|end|environ|ex|exactly|existence|for|from|func|given|hence|hereby|holds|idempotence|identity|iff?|implies|involutiveness|irreflexivity|is|it|let|means|mode|non|not|notations?|now|of|or|otherwise|over|per|pred|prefix|projectivity|proof|provided|qua|reconsider|redefine|reduce|reducibility|reflexivity|registrations?|requirements|reserve|sch|schemes?|section|selector|set|sethood|st|struct|such|suppose|symmetry|synonym|take|that|the|then|theorems?|thesis|thus|to|transitivity|uniqueness|vocabular(?:y|ies)|when|where|with|wrt)\b/,
    parameter: {
      pattern: /\$(?:10|\d)/,
      alias: 'variable'
    },
    variable: /\w+(?=:)/,
    number: /(?:\b|-)\d+\b/,
    operator: /\.\.\.|->|&|\.?=/,
    punctuation: /\(#|#\)|[,:;\[\](){}]/
  }
}


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = monkey
monkey.displayName = 'monkey'
monkey.aliases = []
function monkey(Prism) {
  Prism.languages.monkey = {
    string: /"[^"\r\n]*"/,
    comment: [
      {
        pattern: /^#Rem\s+[\s\S]*?^#End/im,
        greedy: true
      },
      {
        pattern: /'.+/,
        greedy: true
      }
    ],
    preprocessor: {
      pattern: /(^[ \t]*)#.+/m,
      lookbehind: true,
      alias: 'comment'
    },
    function: /\w+(?=\()/,
    'type-char': {
      pattern: /(\w)[?%#$]/,
      lookbehind: true,
      alias: 'variable'
    },
    number: {
      pattern: /((?:\.\.)?)(?:(?:\b|\B-\.?|\B\.)\d+(?:(?!\.\.)\.\d*)?|\$[\da-f]+)/i,
      lookbehind: true
    },
    keyword: /\b(?:Void|Strict|Public|Private|Property|Bool|Int|Float|String|Array|Object|Continue|Exit|Import|Extern|New|Self|Super|Try|Catch|Eachin|True|False|Extends|Abstract|Final|Select|Case|Default|Const|Local|Global|Field|Method|Function|Class|End|If|Then|Else|ElseIf|EndIf|While|Wend|Repeat|Until|Forever|For|To|Step|Next|Return|Module|Interface|Implements|Inline|Throw|Null)\b/i,
    operator: /\.\.|<[=>]?|>=?|:?=|(?:[+\-*\/&~|]|\b(?:Mod|Shl|Shr)\b)=?|\b(?:And|Not|Or)\b/i,
    punctuation: /[.,:;()\[\]]/
  }
}


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = n4js
n4js.displayName = 'n4js'
n4js.aliases = []
function n4js(Prism) {
  Prism.languages.n4js = Prism.languages.extend('javascript', {
    // Keywords from N4JS language spec: https://numberfour.github.io/n4js/spec/N4JSSpec.html
    keyword: /\b(?:any|Array|boolean|break|case|catch|class|const|constructor|continue|debugger|declare|default|delete|do|else|enum|export|extends|false|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|module|new|null|number|package|private|protected|public|return|set|static|string|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b/
  })
  Prism.languages.insertBefore('n4js', 'constant', {
    // Annotations in N4JS spec: https://numberfour.github.io/n4js/spec/N4JSSpec.html#_annotations
    annotation: {
      pattern: /@+\w+/,
      alias: 'operator'
    }
  })
  Prism.languages.n4jsd = Prism.languages.n4js
}


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = nasm
nasm.displayName = 'nasm'
nasm.aliases = []
function nasm(Prism) {
  Prism.languages.nasm = {
    comment: /;.*$/m,
    string: /(["'`])(?:\\.|(?!\1)[^\\\r\n])*\1/,
    label: {
      pattern: /(^\s*)[A-Za-z._?$][\w.?$@~#]*:/m,
      lookbehind: true,
      alias: 'function'
    },
    keyword: [
      /\[?BITS (?:16|32|64)\]?/,
      {
        pattern: /(^\s*)section\s*[a-zA-Z.]+:?/im,
        lookbehind: true
      },
      /(?:extern|global)[^;\r\n]*/i,
      /(?:CPU|FLOAT|DEFAULT).*$/m
    ],
    register: {
      pattern: /\b(?:st\d|[xyz]mm\d\d?|[cdt]r\d|r\d\d?[bwd]?|[er]?[abcd]x|[abcd][hl]|[er]?(?:bp|sp|si|di)|[cdefgs]s)\b/i,
      alias: 'variable'
    },
    number: /(?:\b|(?=\$))(?:0[hx][\da-f]*\.?[\da-f]+(?:p[+-]?\d+)?|\d[\da-f]+[hx]|\$\d[\da-f]*|0[oq][0-7]+|[0-7]+[oq]|0[by][01]+|[01]+[by]|0[dt]\d+|\d*\.?\d+(?:\.?e[+-]?\d+)?[dt]?)\b/i,
    operator: /[\[\]*+\-\/%<>=&|$!]/
  }
}


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = nginx
nginx.displayName = 'nginx'
nginx.aliases = []
function nginx(Prism) {
  Prism.languages.nginx = Prism.languages.extend('clike', {
    comment: {
      pattern: /(^|[^"{\\])#.*/,
      lookbehind: true
    },
    keyword: /\b(?:CONTENT_|DOCUMENT_|GATEWAY_|HTTP_|HTTPS|if_not_empty|PATH_|QUERY_|REDIRECT_|REMOTE_|REQUEST_|SCGI|SCRIPT_|SERVER_|http|events|accept_mutex|accept_mutex_delay|access_log|add_after_body|add_before_body|add_header|addition_types|aio|alias|allow|ancient_browser|ancient_browser_value|auth|auth_basic|auth_basic_user_file|auth_http|auth_http_header|auth_http_timeout|autoindex|autoindex_exact_size|autoindex_localtime|break|charset|charset_map|charset_types|chunked_transfer_encoding|client_body_buffer_size|client_body_in_file_only|client_body_in_single_buffer|client_body_temp_path|client_body_timeout|client_header_buffer_size|client_header_timeout|client_max_body_size|connection_pool_size|create_full_put_path|daemon|dav_access|dav_methods|debug_connection|debug_points|default_type|deny|devpoll_changes|devpoll_events|directio|directio_alignment|disable_symlinks|empty_gif|env|epoll_events|error_log|error_page|expires|fastcgi_buffer_size|fastcgi_buffers|fastcgi_busy_buffers_size|fastcgi_cache|fastcgi_cache_bypass|fastcgi_cache_key|fastcgi_cache_lock|fastcgi_cache_lock_timeout|fastcgi_cache_methods|fastcgi_cache_min_uses|fastcgi_cache_path|fastcgi_cache_purge|fastcgi_cache_use_stale|fastcgi_cache_valid|fastcgi_connect_timeout|fastcgi_hide_header|fastcgi_ignore_client_abort|fastcgi_ignore_headers|fastcgi_index|fastcgi_intercept_errors|fastcgi_keep_conn|fastcgi_max_temp_file_size|fastcgi_next_upstream|fastcgi_no_cache|fastcgi_param|fastcgi_pass|fastcgi_pass_header|fastcgi_read_timeout|fastcgi_redirect_errors|fastcgi_send_timeout|fastcgi_split_path_info|fastcgi_store|fastcgi_store_access|fastcgi_temp_file_write_size|fastcgi_temp_path|flv|geo|geoip_city|geoip_country|google_perftools_profiles|gzip|gzip_buffers|gzip_comp_level|gzip_disable|gzip_http_version|gzip_min_length|gzip_proxied|gzip_static|gzip_types|gzip_vary|if|if_modified_since|ignore_invalid_headers|image_filter|image_filter_buffer|image_filter_jpeg_quality|image_filter_sharpen|image_filter_transparency|imap_capabilities|imap_client_buffer|include|index|internal|ip_hash|keepalive|keepalive_disable|keepalive_requests|keepalive_timeout|kqueue_changes|kqueue_events|large_client_header_buffers|limit_conn|limit_conn_log_level|limit_conn_zone|limit_except|limit_rate|limit_rate_after|limit_req|limit_req_log_level|limit_req_zone|limit_zone|lingering_close|lingering_time|lingering_timeout|listen|location|lock_file|log_format|log_format_combined|log_not_found|log_subrequest|map|map_hash_bucket_size|map_hash_max_size|master_process|max_ranges|memcached_buffer_size|memcached_connect_timeout|memcached_next_upstream|memcached_pass|memcached_read_timeout|memcached_send_timeout|merge_slashes|min_delete_depth|modern_browser|modern_browser_value|mp4|mp4_buffer_size|mp4_max_buffer_size|msie_padding|msie_refresh|multi_accept|open_file_cache|open_file_cache_errors|open_file_cache_min_uses|open_file_cache_valid|open_log_file_cache|optimize_server_names|override_charset|pcre_jit|perl|perl_modules|perl_require|perl_set|pid|pop3_auth|pop3_capabilities|port_in_redirect|post_action|postpone_output|protocol|proxy|proxy_buffer|proxy_buffer_size|proxy_buffering|proxy_buffers|proxy_busy_buffers_size|proxy_cache|proxy_cache_bypass|proxy_cache_key|proxy_cache_lock|proxy_cache_lock_timeout|proxy_cache_methods|proxy_cache_min_uses|proxy_cache_path|proxy_cache_use_stale|proxy_cache_valid|proxy_connect_timeout|proxy_cookie_domain|proxy_cookie_path|proxy_headers_hash_bucket_size|proxy_headers_hash_max_size|proxy_hide_header|proxy_http_version|proxy_ignore_client_abort|proxy_ignore_headers|proxy_intercept_errors|proxy_max_temp_file_size|proxy_method|proxy_next_upstream|proxy_no_cache|proxy_pass|proxy_pass_error_message|proxy_pass_header|proxy_pass_request_body|proxy_pass_request_headers|proxy_read_timeout|proxy_redirect|proxy_redirect_errors|proxy_send_lowat|proxy_send_timeout|proxy_set_body|proxy_set_header|proxy_ssl_session_reuse|proxy_store|proxy_store_access|proxy_temp_file_write_size|proxy_temp_path|proxy_timeout|proxy_upstream_fail_timeout|proxy_upstream_max_fails|random_index|read_ahead|real_ip_header|recursive_error_pages|request_pool_size|reset_timedout_connection|resolver|resolver_timeout|return|rewrite|root|rtsig_overflow_events|rtsig_overflow_test|rtsig_overflow_threshold|rtsig_signo|satisfy|satisfy_any|secure_link_secret|send_lowat|send_timeout|sendfile|sendfile_max_chunk|server|server_name|server_name_in_redirect|server_names_hash_bucket_size|server_names_hash_max_size|server_tokens|set|set_real_ip_from|smtp_auth|smtp_capabilities|so_keepalive|source_charset|split_clients|ssi|ssi_silent_errors|ssi_types|ssi_value_length|ssl|ssl_certificate|ssl_certificate_key|ssl_ciphers|ssl_client_certificate|ssl_crl|ssl_dhparam|ssl_engine|ssl_prefer_server_ciphers|ssl_protocols|ssl_session_cache|ssl_session_timeout|ssl_verify_client|ssl_verify_depth|starttls|stub_status|sub_filter|sub_filter_once|sub_filter_types|tcp_nodelay|tcp_nopush|timeout|timer_resolution|try_files|types|types_hash_bucket_size|types_hash_max_size|underscores_in_headers|uninitialized_variable_warn|upstream|use|user|userid|userid_domain|userid_expires|userid_name|userid_p3p|userid_path|userid_service|valid_referers|variables_hash_bucket_size|variables_hash_max_size|worker_connections|worker_cpu_affinity|worker_priority|worker_processes|worker_rlimit_core|worker_rlimit_nofile|worker_rlimit_sigpending|working_directory|xclient|xml_entities|xslt_entities|xslt_stylesheet|xslt_types)\b/i
  })
  Prism.languages.insertBefore('nginx', 'keyword', {
    variable: /\$[a-z_]+/i
  })
}


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = nim
nim.displayName = 'nim'
nim.aliases = []
function nim(Prism) {
  Prism.languages.nim = {
    comment: /#.*/,
    // Double-quoted strings can be prefixed by an identifier (Generalized raw string literals)
    // Character literals are handled specifically to prevent issues with numeric type suffixes
    string: {
      pattern: /(?:(?:\b(?!\d)(?:\w|\\x[8-9a-fA-F][0-9a-fA-F])+)?(?:"""[\s\S]*?"""(?!")|"(?:\\[\s\S]|""|[^"\\])*")|'(?:\\(?:\d+|x[\da-fA-F]{2}|.)|[^'])')/,
      greedy: true
    },
    // The negative look ahead prevents wrong highlighting of the .. operator
    number: /\b(?:0[xXoObB][\da-fA-F_]+|\d[\d_]*(?:(?!\.\.)\.[\d_]*)?(?:[eE][+-]?\d[\d_]*)?)(?:'?[iuf]\d*)?/,
    keyword: /\b(?:addr|as|asm|atomic|bind|block|break|case|cast|concept|const|continue|converter|defer|discard|distinct|do|elif|else|end|enum|except|export|finally|for|from|func|generic|if|import|include|interface|iterator|let|macro|method|mixin|nil|object|out|proc|ptr|raise|ref|return|static|template|try|tuple|type|using|var|when|while|with|without|yield)\b/,
    function: {
      pattern: /(?:(?!\d)(?:\w|\\x[8-9a-fA-F][0-9a-fA-F])+|`[^`\r\n]+`)\*?(?:\[[^\]]+\])?(?=\s*\()/,
      inside: {
        operator: /\*$/
      }
    },
    // We don't want to highlight operators inside backticks
    ignore: {
      pattern: /`[^`\r\n]+`/,
      inside: {
        punctuation: /`/
      }
    },
    operator: {
      // Look behind and look ahead prevent wrong highlighting of punctuations [. .] {. .} (. .)
      // but allow the slice operator .. to take precedence over them
      // One can define his own operators in Nim so all combination of operators might be an operator.
      pattern: /(^|[({\[](?=\.\.)|(?![({\[]\.).)(?:(?:[=+\-*\/<>@$~&%|!?^:\\]|\.\.|\.(?![)}\]]))+|\b(?:and|div|of|or|in|is|isnot|mod|not|notin|shl|shr|xor)\b)/m,
      lookbehind: true
    },
    punctuation: /[({\[]\.|\.[)}\]]|[`(){}\[\],:]/
  }
}


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = nix
nix.displayName = 'nix'
nix.aliases = []
function nix(Prism) {
  Prism.languages.nix = {
    comment: /\/\*[\s\S]*?\*\/|#.*/,
    string: {
      pattern: /"(?:[^"\\]|\\[\s\S])*"|''(?:(?!'')[\s\S]|''(?:'|\\|\$\{))*''/,
      greedy: true,
      inside: {
        interpolation: {
          // The lookbehind ensures the ${} is not preceded by \ or ''
          pattern: /(^|(?:^|(?!'').)[^\\])\$\{(?:[^}]|\{[^}]*\})*}/,
          lookbehind: true,
          inside: {
            antiquotation: {
              pattern: /^\$(?=\{)/,
              alias: 'variable'
              // See rest below
            }
          }
        }
      }
    },
    url: [
      /\b(?:[a-z]{3,7}:\/\/)[\w\-+%~\/.:#=?&]+/,
      {
        pattern: /([^\/])(?:[\w\-+%~.:#=?&]*(?!\/\/)[\w\-+%~\/.:#=?&])?(?!\/\/)\/[\w\-+%~\/.:#=?&]*/,
        lookbehind: true
      }
    ],
    antiquotation: {
      pattern: /\$(?=\{)/,
      alias: 'variable'
    },
    number: /\b\d+\b/,
    keyword: /\b(?:assert|builtins|else|if|in|inherit|let|null|or|then|with)\b/,
    function: /\b(?:abort|add|all|any|attrNames|attrValues|baseNameOf|compareVersions|concatLists|currentSystem|deepSeq|derivation|dirOf|div|elem(?:At)?|fetch(?:url|Tarball)|filter(?:Source)?|fromJSON|genList|getAttr|getEnv|hasAttr|hashString|head|import|intersectAttrs|is(?:Attrs|Bool|Function|Int|List|Null|String)|length|lessThan|listToAttrs|map|mul|parseDrvName|pathExists|read(?:Dir|File)|removeAttrs|replaceStrings|seq|sort|stringLength|sub(?:string)?|tail|throw|to(?:File|JSON|Path|String|XML)|trace|typeOf)\b|\bfoldl'\B/,
    boolean: /\b(?:true|false)\b/,
    operator: /[=!<>]=?|\+\+?|\|\||&&|\/\/|->?|[?@]/,
    punctuation: /[{}()[\].,:;]/
  }
  Prism.languages.nix.string.inside.interpolation.inside.rest =
    Prism.languages.nix
}


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = nsis
nsis.displayName = 'nsis'
nsis.aliases = []
function nsis(Prism) {
  /**
   * Original by Jan T. Sott (http://github.com/idleberg)
   *
   * Includes all commands and plug-ins shipped with NSIS 3.02
   */
  Prism.languages.nsis = {
    comment: {
      pattern: /(^|[^\\])(\/\*[\s\S]*?\*\/|[#;].*)/,
      lookbehind: true
    },
    string: {
      pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
      greedy: true
    },
    keyword: {
      pattern: /(^\s*)(?:Abort|Add(?:BrandingImage|Size)|AdvSplash|Allow(?:RootDirInstall|SkipFiles)|AutoCloseWindow|Banner|BG(?:Font|Gradient|Image)|BrandingText|BringToFront|Call(?:InstDLL)?|Caption|ChangeUI|CheckBitmap|ClearErrors|CompletedText|ComponentText|CopyFiles|CRCCheck|Create(?:Directory|Font|ShortCut)|Delete(?:INISec|INIStr|RegKey|RegValue)?|Detail(?:Print|sButtonText)|Dialer|Dir(?:Text|Var|Verify)|EnableWindow|Enum(?:RegKey|RegValue)|Exch|Exec(?:Shell(?:Wait)?|Wait)?|ExpandEnvStrings|File(?:BufSize|Close|ErrorText|Open|Read|ReadByte|ReadUTF16LE|ReadWord|WriteUTF16LE|Seek|Write|WriteByte|WriteWord)?|Find(?:Close|First|Next|Window)|FlushINI|Get(?:CurInstType|CurrentAddress|DlgItem|DLLVersion(?:Local)?|ErrorLevel|FileTime(?:Local)?|FullPathName|Function(?:Address|End)?|InstDirError|LabelAddress|TempFileName)|Goto|HideWindow|Icon|If(?:Abort|Errors|FileExists|RebootFlag|Silent)|InitPluginsDir|Install(?:ButtonText|Colors|Dir(?:RegKey)?)|InstProgressFlags|Inst(?:Type(?:GetText|SetText)?)|Int(?:64|Ptr)?CmpU?|Int(?:64)?Fmt|Int(?:Ptr)?Op|IsWindow|Lang(?:DLL|String)|License(?:BkColor|Data|ForceSelection|LangString|Text)|LoadLanguageFile|LockWindow|Log(?:Set|Text)|Manifest(?:DPIAware|SupportedOS)|Math|MessageBox|MiscButtonText|Name|Nop|ns(?:Dialogs|Exec)|NSISdl|OutFile|Page(?:Callbacks)?|PE(?:DllCharacteristics|SubsysVer)|Pop|Push|Quit|Read(?:EnvStr|INIStr|RegDWORD|RegStr)|Reboot|RegDLL|Rename|RequestExecutionLevel|ReserveFile|Return|RMDir|SearchPath|Section(?:End|GetFlags|GetInstTypes|GetSize|GetText|Group|In|SetFlags|SetInstTypes|SetSize|SetText)?|SendMessage|Set(?:AutoClose|BrandingImage|Compress|Compressor(?:DictSize)?|CtlColors|CurInstType|DatablockOptimize|DateSave|Details(?:Print|View)|ErrorLevel|Errors|FileAttributes|Font|OutPath|Overwrite|PluginUnload|RebootFlag|RegView|ShellVarContext|Silent)|Show(?:InstDetails|UninstDetails|Window)|Silent(?:Install|UnInstall)|Sleep|SpaceTexts|Splash|StartMenu|Str(?:CmpS?|Cpy|Len)|SubCaption|System|Unicode|Uninstall(?:ButtonText|Caption|Icon|SubCaption|Text)|UninstPage|UnRegDLL|UserInfo|Var|VI(?:AddVersionKey|FileVersion|ProductVersion)|VPatch|WindowIcon|Write(?:INIStr|Reg(?:Bin|DWORD|ExpandStr|MultiStr|None|Str)|Uninstaller)|XPStyle)\b/m,
      lookbehind: true
    },
    property: /\b(?:admin|all|auto|both|colored|false|force|hide|highest|lastused|leave|listonly|none|normal|notset|off|on|open|print|show|silent|silentlog|smooth|textonly|true|user|ARCHIVE|FILE_(ATTRIBUTE_ARCHIVE|ATTRIBUTE_NORMAL|ATTRIBUTE_OFFLINE|ATTRIBUTE_READONLY|ATTRIBUTE_SYSTEM|ATTRIBUTE_TEMPORARY)|HK((CR|CU|LM)(32|64)?|DD|PD|U)|HKEY_(CLASSES_ROOT|CURRENT_CONFIG|CURRENT_USER|DYN_DATA|LOCAL_MACHINE|PERFORMANCE_DATA|USERS)|ID(ABORT|CANCEL|IGNORE|NO|OK|RETRY|YES)|MB_(ABORTRETRYIGNORE|DEFBUTTON1|DEFBUTTON2|DEFBUTTON3|DEFBUTTON4|ICONEXCLAMATION|ICONINFORMATION|ICONQUESTION|ICONSTOP|OK|OKCANCEL|RETRYCANCEL|RIGHT|RTLREADING|SETFOREGROUND|TOPMOST|USERICON|YESNO)|NORMAL|OFFLINE|READONLY|SHCTX|SHELL_CONTEXT|SYSTEM|TEMPORARY)\b/,
    constant: /\${[\w\.:\^-]+}|\$\([\w\.:\^-]+\)/i,
    variable: /\$\w+/i,
    number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+\.?\d*|\B\.\d+)(?:[Ee]-?\d+)?/,
    operator: /--?|\+\+?|<=?|>=?|==?=?|&&?|\|\|?|[?*\/~^%]/,
    punctuation: /[{}[\];(),.:]/,
    important: {
      pattern: /(^\s*)!(?:addincludedir|addplugindir|appendfile|cd|define|delfile|echo|else|endif|error|execute|finalize|getdllversion|gettlbversion|ifdef|ifmacrodef|ifmacrondef|ifndef|if|include|insertmacro|macroend|macro|makensis|packhdr|pragma|searchparse|searchreplace|system|tempfile|undef|verbose|warning)\b/im,
      lookbehind: true
    }
  }
}


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var refractorC = __webpack_require__(137)
module.exports = objectivec
objectivec.displayName = 'objectivec'
objectivec.aliases = []
function objectivec(Prism) {
  Prism.register(refractorC)
  Prism.languages.objectivec = Prism.languages.extend('c', {
    keyword: /\b(?:asm|typeof|inline|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|union|unsigned|void|volatile|while|in|self|super)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
    string: /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1|@"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
    operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
  })
}


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = ocaml
ocaml.displayName = 'ocaml'
ocaml.aliases = []
function ocaml(Prism) {
  Prism.languages.ocaml = {
    comment: /\(\*[\s\S]*?\*\)/,
    string: [
      {
        pattern: /"(?:\\.|[^\\\r\n"])*"/,
        greedy: true
      },
      {
        pattern: /(['`])(?:\\(?:\d+|x[\da-f]+|.)|(?!\1)[^\\\r\n])\1/i,
        greedy: true
      }
    ],
    number: /\b(?:0x[\da-f][\da-f_]+|(?:0[bo])?\d[\d_]*\.?[\d_]*(?:e[+-]?[\d_]+)?)/i,
    type: {
      pattern: /\B['`]\w*/,
      alias: 'variable'
    },
    directive: {
      pattern: /\B#\w+/,
      alias: 'function'
    },
    keyword: /\b(?:as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|match|method|module|mutable|new|object|of|open|prefix|private|rec|then|sig|struct|to|try|type|val|value|virtual|where|while|with)\b/,
    boolean: /\b(?:false|true)\b/,
    // Custom operators are allowed
    operator: /:=|[=<>@^|&+\-*\/$%!?~][!$%&*+\-.\/:<=>?@^|~]*|\b(?:and|asr|land|lor|lxor|lsl|lsr|mod|nor|or)\b/,
    punctuation: /[(){}\[\]|_.,:;]/
  }
}


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var refractorC = __webpack_require__(137)
var refractorCpp = __webpack_require__(307)
module.exports = opencl
opencl.displayName = 'opencl'
opencl.aliases = []
function opencl(Prism) {
  Prism.register(refractorC)
  Prism.register(refractorCpp)
  ;(function(Prism) {
    /* OpenCL kernel language */
    Prism.languages.opencl = Prism.languages.extend('c', {
      // Extracted from the official specs (2.0) and http://streamcomputing.eu/downloads/?opencl.lang (opencl-keywords, opencl-types) and http://sourceforge.net/tracker/?func=detail&aid=2957794&group_id=95717&atid=612384 (Words2, partly Words3)
      keyword: /\b(?:__attribute__|(?:__)?(?:constant|global|kernel|local|private|read_only|read_write|write_only)|_cl_(?:command_queue|context|device_id|event|kernel|mem|platform_id|program|sampler)|auto|break|case|cl_(?:image_format|mem_fence_flags)|clk_event_t|complex|const|continue|default|do|(?:float|double)(?:16(?:x(?:1|16|2|4|8))?|1x(?:1|16|2|4|8)|2(?:x(?:1|16|2|4|8))?|3|4(?:x(?:1|16|2|4|8))?|8(?:x(?:1|16|2|4|8))?)?|else|enum|event_t|extern|for|goto|(?:u?(?:char|short|int|long)|half|quad|bool)(?:2|3|4|8|16)?|if|image(?:1d_(?:array_|buffer_)?t|2d_(?:array_(?:depth_|msaa_depth_|msaa_)?|depth_|msaa_depth_|msaa_)?t|3d_t)|imaginary|inline|intptr_t|ndrange_t|packed|pipe|ptrdiff_t|queue_t|register|reserve_id_t|restrict|return|sampler_t|signed|size_t|sizeof|static|struct|switch|typedef|uintptr_t|uniform|union|unsigned|void|volatile|while)\b/,
      // Extracted from http://streamcomputing.eu/downloads/?opencl.lang (global-vars, opencl-dev)
      'function-opencl-kernel': {
        pattern: /\b(?:abs(?:_diff)?|a?(?:cos|sin)(?:h|pi)?|add_sat|aligned|all|and|any|async(?:_work_group_copy|_work_group_strided_copy)?|atan(?:2?(?:pi)?|h)?|atom_(?:add|and|cmpxchg|dec|inc|max|min|or|sub|xchg|xor)|barrier|bitselect|cbrt|ceil|clamp|clz|copies|copysign|cross|degrees|distance|dot|endian|erf|erfc|exp(?:2|10)?|expm1|fabs|fast_(?:distance|length|normalize)|fdim|floor|fma|fmax|fmin|fract|frexp|fro|from|get_(?:global_(?:id|offset|size)|group_id|image_(?:channel_data_type|channel_order|depth|dim|height|width)|local(?:_id|_size)|num_groups|work_dim)|hadd|(?:half|native)_(?:cos|divide|exp(?:2|10)?|log(?:2|10)?|powr|recip|r?sqrt|sin|tan)|hypot|ilogb|is(?:equal|finite|greater(?:equal)?|inf|less(?:equal|greater)?|nan|normal|notequal|(?:un)?ordered)|ldexp|length|lgamma|lgamma_r|log(?:b|1p|2|10)?|mad(?:24|_hi|_sat)?|max|mem(?:_fence)?|min|mix|modf|mul24|mul_hi|nan|nextafter|normalize|pow[nr]?|prefetch|radians|read_(?:image)(?:f|h|u?i)|read_mem_fence|remainder|remquo|reqd_work_group_size|rhadd|rint|rootn|rotate|round|rsqrt|select|shuffle2?|sign|signbit|sincos|smoothstep|sqrt|step|sub_sat|tan|tanh|tanpi|tgamma|to|trunc|upsample|vec_(?:step|type_hint)|v(?:load|store)(?:_half)?(?:2|3|4|8|16)?|v(?:loada_half|storea?(?:_half)?)(?:2|3|4|8|16)?(?:_(?:rte|rtn|rtp|rtz))?|wait_group_events|work_group_size_hint|write_image(?:f|h|u?i)|write_mem_fence)\b/,
        alias: 'function'
      },
      // Extracted from http://streamcomputing.eu/downloads/?opencl.lang (opencl-const)
      'constant-opencl-kernel': {
        pattern: /\b(?:CHAR_(?:BIT|MAX|MIN)|CLK_(?:ADDRESS_(?:CLAMP(?:_TO_EDGE)?|NONE|REPEAT)|FILTER_(?:LINEAR|NEAREST)|(?:LOCAL|GLOBAL)_MEM_FENCE|NORMALIZED_COORDS_(?:FALSE|TRUE))|CL_(?:BGRA|(?:HALF_)?FLOAT|INTENSITY|LUMINANCE|A?R?G?B?[Ax]?|(?:(?:UN)?SIGNED|[US]NORM)_(?:INT(?:8|16|32))|UNORM_(?:INT_101010|SHORT_(?:555|565)))|(?:DBL|FLT)_(?:DIG|EPSILON|MANT_DIG|(?:MIN|MAX)(?:(?:_10)?_EXP)?)|FLT_RADIX|HUGE_VALF|INFINITY|(?:INT|LONG|SCHAR|SHRT|UCHAR|UINT|ULONG)_(?:MAX|MIN)|MAXFLOAT|M_(?:[12]_PI|2_SQRTPI|E|LN(?:2|10)|LOG(?:10|2)E?|PI[24]?|SQRT(?:1_2|2))|NAN)\b/,
        alias: 'constant'
      }
    })
    var attributes = {
      // Extracted from http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-types and opencl-host)
      'type-opencl-host': {
        pattern: /\b(?:cl_(?:GLenum|GLint|GLuin|addressing_mode|bitfield|bool|buffer_create_type|build_status|channel_(?:order|type)|(?:u?(?:char|short|int|long)|float|double)(?:2|3|4|8|16)?|command_(?:queue(?:_info|_properties)?|type)|context(?:_info|_properties)?|device_(?:exec_capabilities|fp_config|id|info|local_mem_type|mem_cache_type|type)|(?:event|sampler)(?:_info)?|filter_mode|half|image_info|kernel(?:_info|_work_group_info)?|map_flags|mem(?:_flags|_info|_object_type)?|platform_(?:id|info)|profiling_info|program(?:_build_info|_info)?))\b/,
        alias: 'keyword'
      },
      'boolean-opencl-host': {
        pattern: /\bCL_(?:TRUE|FALSE)\b/,
        alias: 'boolean'
      },
      // Extracted from cl.h (2.0) and http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-const)
      'constant-opencl-host': {
        pattern: /\bCL_(?:A|ABGR|ADDRESS_(?:CLAMP(?:_TO_EDGE)?|MIRRORED_REPEAT|NONE|REPEAT)|ARGB|BGRA|BLOCKING|BUFFER_CREATE_TYPE_REGION|BUILD_(?:ERROR|IN_PROGRESS|NONE|PROGRAM_FAILURE|SUCCESS)|COMMAND_(?:ACQUIRE_GL_OBJECTS|BARRIER|COPY_(?:BUFFER(?:_RECT|_TO_IMAGE)?|IMAGE(?:_TO_BUFFER)?)|FILL_(?:BUFFER|IMAGE)|MAP(?:_BUFFER|_IMAGE)|MARKER|MIGRATE(?:_SVM)?_MEM_OBJECTS|NATIVE_KERNEL|NDRANGE_KERNEL|READ_(?:BUFFER(?:_RECT)?|IMAGE)|RELEASE_GL_OBJECTS|SVM_(?:FREE|MAP|MEMCPY|MEMFILL|UNMAP)|TASK|UNMAP_MEM_OBJECT|USER|WRITE_(?:BUFFER(?:_RECT)?|IMAGE))|COMPILER_NOT_AVAILABLE|COMPILE_PROGRAM_FAILURE|COMPLETE|CONTEXT_(?:DEVICES|INTEROP_USER_SYNC|NUM_DEVICES|PLATFORM|PROPERTIES|REFERENCE_COUNT)|DEPTH(?:_STENCIL)?|DEVICE_(?:ADDRESS_BITS|AFFINITY_DOMAIN_(?:L[1-4]_CACHE|NEXT_PARTITIONABLE|NUMA)|AVAILABLE|BUILT_IN_KERNELS|COMPILER_AVAILABLE|DOUBLE_FP_CONFIG|ENDIAN_LITTLE|ERROR_CORRECTION_SUPPORT|EXECUTION_CAPABILITIES|EXTENSIONS|GLOBAL_(?:MEM_(?:CACHELINE_SIZE|CACHE_SIZE|CACHE_TYPE|SIZE)|VARIABLE_PREFERRED_TOTAL_SIZE)|HOST_UNIFIED_MEMORY|IL_VERSION|IMAGE(?:2D_MAX_(?:HEIGHT|WIDTH)|3D_MAX_(?:DEPTH|HEIGHT|WIDTH)|_BASE_ADDRESS_ALIGNMENT|_MAX_ARRAY_SIZE|_MAX_BUFFER_SIZE|_PITCH_ALIGNMENT|_SUPPORT)|LINKER_AVAILABLE|LOCAL_MEM_SIZE|LOCAL_MEM_TYPE|MAX_(?:CLOCK_FREQUENCY|COMPUTE_UNITS|CONSTANT_ARGS|CONSTANT_BUFFER_SIZE|GLOBAL_VARIABLE_SIZE|MEM_ALLOC_SIZE|NUM_SUB_GROUPS|ON_DEVICE_(?:EVENTS|QUEUES)|PARAMETER_SIZE|PIPE_ARGS|READ_IMAGE_ARGS|READ_WRITE_IMAGE_ARGS|SAMPLERS|WORK_GROUP_SIZE|WORK_ITEM_DIMENSIONS|WORK_ITEM_SIZES|WRITE_IMAGE_ARGS)|MEM_BASE_ADDR_ALIGN|MIN_DATA_TYPE_ALIGN_SIZE|NAME|NATIVE_VECTOR_WIDTH_(?:CHAR|DOUBLE|FLOAT|HALF|INT|LONG|SHORT)|NOT_(?:AVAILABLE|FOUND)|OPENCL_C_VERSION|PARENT_DEVICE|PARTITION_(?:AFFINITY_DOMAIN|BY_AFFINITY_DOMAIN|BY_COUNTS|BY_COUNTS_LIST_END|EQUALLY|FAILED|MAX_SUB_DEVICES|PROPERTIES|TYPE)|PIPE_MAX_(?:ACTIVE_RESERVATIONS|PACKET_SIZE)|PLATFORM|PREFERRED_(?:GLOBAL_ATOMIC_ALIGNMENT|INTEROP_USER_SYNC|LOCAL_ATOMIC_ALIGNMENT|PLATFORM_ATOMIC_ALIGNMENT|VECTOR_WIDTH_(?:CHAR|DOUBLE|FLOAT|HALF|INT|LONG|SHORT))|PRINTF_BUFFER_SIZE|PROFILE|PROFILING_TIMER_RESOLUTION|QUEUE_(?:ON_(?:DEVICE_(?:MAX_SIZE|PREFERRED_SIZE|PROPERTIES)|HOST_PROPERTIES)|PROPERTIES)|REFERENCE_COUNT|SINGLE_FP_CONFIG|SUB_GROUP_INDEPENDENT_FORWARD_PROGRESS|SVM_(?:ATOMICS|CAPABILITIES|COARSE_GRAIN_BUFFER|FINE_GRAIN_BUFFER|FINE_GRAIN_SYSTEM)|TYPE(?:_ACCELERATOR|_ALL|_CPU|_CUSTOM|_DEFAULT|_GPU)?|VENDOR(?:_ID)?|VERSION)|DRIVER_VERSION|EVENT_(?:COMMAND_(?:EXECUTION_STATUS|QUEUE|TYPE)|CONTEXT|REFERENCE_COUNT)|EXEC_(?:KERNEL|NATIVE_KERNEL|STATUS_ERROR_FOR_EVENTS_IN_WAIT_LIST)|FILTER_(?:LINEAR|NEAREST)|FLOAT|FP_(?:CORRECTLY_ROUNDED_DIVIDE_SQRT|DENORM|FMA|INF_NAN|ROUND_TO_INF|ROUND_TO_NEAREST|ROUND_TO_ZERO|SOFT_FLOAT)|GLOBAL|HALF_FLOAT|IMAGE_(?:ARRAY_SIZE|BUFFER|DEPTH|ELEMENT_SIZE|FORMAT|FORMAT_MISMATCH|FORMAT_NOT_SUPPORTED|HEIGHT|NUM_MIP_LEVELS|NUM_SAMPLES|ROW_PITCH|SLICE_PITCH|WIDTH)|INTENSITY|INVALID_(?:ARG_INDEX|ARG_SIZE|ARG_VALUE|BINARY|BUFFER_SIZE|BUILD_OPTIONS|COMMAND_QUEUE|COMPILER_OPTIONS|CONTEXT|DEVICE|DEVICE_PARTITION_COUNT|DEVICE_QUEUE|DEVICE_TYPE|EVENT|EVENT_WAIT_LIST|GLOBAL_OFFSET|GLOBAL_WORK_SIZE|GL_OBJECT|HOST_PTR|IMAGE_DESCRIPTOR|IMAGE_FORMAT_DESCRIPTOR|IMAGE_SIZE|KERNEL|KERNEL_ARGS|KERNEL_DEFINITION|KERNEL_NAME|LINKER_OPTIONS|MEM_OBJECT|MIP_LEVEL|OPERATION|PIPE_SIZE|PLATFORM|PROGRAM|PROGRAM_EXECUTABLE|PROPERTY|QUEUE_PROPERTIES|SAMPLER|VALUE|WORK_DIMENSION|WORK_GROUP_SIZE|WORK_ITEM_SIZE)|KERNEL_(?:ARG_(?:ACCESS_(?:NONE|QUALIFIER|READ_ONLY|READ_WRITE|WRITE_ONLY)|ADDRESS_(?:CONSTANT|GLOBAL|LOCAL|PRIVATE|QUALIFIER)|INFO_NOT_AVAILABLE|NAME|TYPE_(?:CONST|NAME|NONE|PIPE|QUALIFIER|RESTRICT|VOLATILE))|ATTRIBUTES|COMPILE_NUM_SUB_GROUPS|COMPILE_WORK_GROUP_SIZE|CONTEXT|EXEC_INFO_SVM_FINE_GRAIN_SYSTEM|EXEC_INFO_SVM_PTRS|FUNCTION_NAME|GLOBAL_WORK_SIZE|LOCAL_MEM_SIZE|LOCAL_SIZE_FOR_SUB_GROUP_COUNT|MAX_NUM_SUB_GROUPS|MAX_SUB_GROUP_SIZE_FOR_NDRANGE|NUM_ARGS|PREFERRED_WORK_GROUP_SIZE_MULTIPLE|PRIVATE_MEM_SIZE|PROGRAM|REFERENCE_COUNT|SUB_GROUP_COUNT_FOR_NDRANGE|WORK_GROUP_SIZE)|LINKER_NOT_AVAILABLE|LINK_PROGRAM_FAILURE|LOCAL|LUMINANCE|MAP_(?:FAILURE|READ|WRITE|WRITE_INVALIDATE_REGION)|MEM_(?:ALLOC_HOST_PTR|ASSOCIATED_MEMOBJECT|CONTEXT|COPY_HOST_PTR|COPY_OVERLAP|FLAGS|HOST_NO_ACCESS|HOST_PTR|HOST_READ_ONLY|HOST_WRITE_ONLY|KERNEL_READ_AND_WRITE|MAP_COUNT|OBJECT_(?:ALLOCATION_FAILURE|BUFFER|IMAGE1D|IMAGE1D_ARRAY|IMAGE1D_BUFFER|IMAGE2D|IMAGE2D_ARRAY|IMAGE3D|PIPE)|OFFSET|READ_ONLY|READ_WRITE|REFERENCE_COUNT|SIZE|SVM_ATOMICS|SVM_FINE_GRAIN_BUFFER|TYPE|USES_SVM_POINTER|USE_HOST_PTR|WRITE_ONLY)|MIGRATE_MEM_OBJECT_(?:CONTENT_UNDEFINED|HOST)|MISALIGNED_SUB_BUFFER_OFFSET|NONE|NON_BLOCKING|OUT_OF_(?:HOST_MEMORY|RESOURCES)|PIPE_(?:MAX_PACKETS|PACKET_SIZE)|PLATFORM_(?:EXTENSIONS|HOST_TIMER_RESOLUTION|NAME|PROFILE|VENDOR|VERSION)|PROFILING_(?:COMMAND_(?:COMPLETE|END|QUEUED|START|SUBMIT)|INFO_NOT_AVAILABLE)|PROGRAM_(?:BINARIES|BINARY_SIZES|BINARY_TYPE(?:_COMPILED_OBJECT|_EXECUTABLE|_LIBRARY|_NONE)?|BUILD_(?:GLOBAL_VARIABLE_TOTAL_SIZE|LOG|OPTIONS|STATUS)|CONTEXT|DEVICES|IL|KERNEL_NAMES|NUM_DEVICES|NUM_KERNELS|REFERENCE_COUNT|SOURCE)|QUEUED|QUEUE_(?:CONTEXT|DEVICE|DEVICE_DEFAULT|ON_DEVICE|ON_DEVICE_DEFAULT|OUT_OF_ORDER_EXEC_MODE_ENABLE|PROFILING_ENABLE|PROPERTIES|REFERENCE_COUNT|SIZE)|R|RA|READ_(?:ONLY|WRITE)_CACHE|RG|RGB|RGBA|RGBx|RGx|RUNNING|Rx|SAMPLER_(?:ADDRESSING_MODE|CONTEXT|FILTER_MODE|LOD_MAX|LOD_MIN|MIP_FILTER_MODE|NORMALIZED_COORDS|REFERENCE_COUNT)|(?:UN)?SIGNED_INT(?:8|16|32)|SNORM_INT(?:8|16)|SUBMITTED|SUCCESS|UNORM_INT(?:16|24|8|_101010|_101010_2)|UNORM_SHORT_(?:555|565)|VERSION_(?:1_0|1_1|1_2|2_0|2_1)|sBGRA|sRGB|sRGBA|sRGBx)\b/,
        alias: 'constant'
      },
      // Extracted from cl.h (2.0) and http://streamcomputing.eu/downloads/?opencl_host.lang (opencl-host)
      'function-opencl-host': {
        pattern: /\bcl(?:BuildProgram|CloneKernel|CompileProgram|Create(?:Buffer|CommandQueue(?:WithProperties)?|Context|ContextFromType|Image|Image2D|Image3D|Kernel|KernelsInProgram|Pipe|ProgramWith(?:Binary|BuiltInKernels|IL|Source)|Sampler|SamplerWithProperties|SubBuffer|SubDevices|UserEvent)|Enqueue(?:(?:Barrier|Marker)(?:WithWaitList)?|Copy(?:Buffer(?:Rect|ToImage)?|Image(?:ToBuffer)?)|(?:Fill|Map)(?:Buffer|Image)|MigrateMemObjects|NDRangeKernel|NativeKernel|(?:Read|Write)(?:Buffer(?:Rect)?|Image)|SVM(?:Free|Map|MemFill|Memcpy|MigrateMem|Unmap)|Task|UnmapMemObject|WaitForEvents)|Finish|Flush|Get(?:CommandQueueInfo|ContextInfo|Device(?:AndHostTimer|IDs|Info)|Event(?:Profiling)?Info|ExtensionFunctionAddress(?:ForPlatform)?|HostTimer|ImageInfo|Kernel(?:ArgInfo|Info|SubGroupInfo|WorkGroupInfo)|MemObjectInfo|PipeInfo|Platform(?:IDs|Info)|Program(?:Build)?Info|SamplerInfo|SupportedImageFormats)|LinkProgram|(?:Release|Retain)(?:CommandQueue|Context|Device|Event|Kernel|MemObject|Program|Sampler)|SVM(?:Alloc|Free)|Set(?:CommandQueueProperty|DefaultDeviceCommandQueue|EventCallback|Kernel(?:Arg(?:SVMPointer)?|ExecInfo)|Kernel|MemObjectDestructorCallback|UserEventStatus)|Unload(?:Platform)?Compiler|WaitForEvents)\b/,
        alias: 'function'
      }
    }
    /* OpenCL host API */
    Prism.languages.insertBefore('c', 'keyword', attributes)
    // Extracted from doxygen class list http://github.khronos.org/OpenCL-CLHPP/annotated.html
    attributes['type-opencl-host-c++'] = {
      pattern: /\b(?:Buffer|BufferGL|BufferRenderGL|CommandQueue|Context|Device|DeviceCommandQueue|EnqueueArgs|Event|Image|Image1D|Image1DArray|Image1DBuffer|Image2D|Image2DArray|Image2DGL|Image3D|Image3DGL|ImageFormat|ImageGL|Kernel|KernelFunctor|LocalSpaceArg|Memory|NDRange|Pipe|Platform|Program|Sampler|SVMAllocator|SVMTraitAtomic|SVMTraitCoarse|SVMTraitFine|SVMTraitReadOnly|SVMTraitReadWrite|SVMTraitWriteOnly|UserEvent)\b/,
      alias: 'keyword'
    }
    // C++ includes everything from the OpenCL C host API plus the classes defined in cl2.h
    Prism.languages.insertBefore('cpp', 'keyword', attributes)
  })(Prism)
}


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = oz
oz.displayName = 'oz'
oz.aliases = []
function oz(Prism) {
  Prism.languages.oz = {
    comment: /\/\*[\s\S]*?\*\/|%.*/,
    string: {
      pattern: /"(?:[^"\\]|\\[\s\S])*"/,
      greedy: true
    },
    atom: {
      pattern: /'(?:[^'\\]|\\[\s\S])*'/,
      greedy: true,
      alias: 'builtin'
    },
    keyword: /[$_]|\[\]|\b(?:at|attr|case|catch|choice|class|cond|declare|define|dis|else(?:case|if)?|end|export|fail|false|feat|finally|from|fun|functor|if|import|in|local|lock|meth|nil|not|of|or|prepare|proc|prop|raise|require|self|skip|then|thread|true|try|unit)\b/,
    function: [
      /[a-z][A-Za-z\d]*(?=\()/,
      {
        pattern: /(\{)[A-Z][A-Za-z\d]*/,
        lookbehind: true
      }
    ],
    number: /\b(?:0[bx][\da-f]+|\d+\.?\d*(?:e~?\d+)?\b)|&(?:[^\\]|\\(?:\d{3}|.))/i,
    variable: /\b[A-Z][A-Za-z\d]*|`(?:[^`\\]|\\.)+`/,
    'attr-name': /\w+(?=:)/,
    operator: /:(?:=|::?)|<[-:=]?|=(?:=|<?:?)|>=?:?|\\=:?|!!?|[|#+\-*\/,~^@]|\b(?:andthen|div|mod|orelse)\b/,
    punctuation: /[\[\](){}.:;?]/
  }
}


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = parigp
parigp.displayName = 'parigp'
parigp.aliases = []
function parigp(Prism) {
  Prism.languages.parigp = {
    comment: /\/\*[\s\S]*?\*\/|\\\\.*/,
    string: {
      pattern: /"(?:[^"\\\r\n]|\\.)*"/,
      greedy: true
    },
    // PARI/GP does not care about white spaces at all
    // so let's process the keywords to build an appropriate regexp
    // (e.g. "b *r *e *a *k", etc.)
    keyword: (function() {
      var keywords = [
        'breakpoint',
        'break',
        'dbg_down',
        'dbg_err',
        'dbg_up',
        'dbg_x',
        'forcomposite',
        'fordiv',
        'forell',
        'forpart',
        'forprime',
        'forstep',
        'forsubgroup',
        'forvec',
        'for',
        'iferr',
        'if',
        'local',
        'my',
        'next',
        'return',
        'until',
        'while'
      ]
      keywords = keywords
        .map(function(keyword) {
          return keyword.split('').join(' *')
        })
        .join('|')
      return RegExp('\\b(?:' + keywords + ')\\b')
    })(),
    function: /\w[\w ]*?(?= *\()/,
    number: {
      // The lookbehind and the negative lookahead prevent from breaking the .. operator
      pattern: /((?:\. *\. *)?)(?:\d(?: *\d)*(?: *(?!\. *\.)\.(?: *\d)*)?|\. *\d(?: *\d)*)(?: *e *[+-]? *\d(?: *\d)*)?/i,
      lookbehind: true
    },
    operator: /\. *\.|[*\/!](?: *=)?|%(?: *=|(?: *#)?(?: *')*)?|\+(?: *[+=])?|-(?: *[-=>])?|<(?:(?: *<)?(?: *=)?| *>)?|>(?: *>)?(?: *=)?|=(?: *=){0,2}|\\(?: *\/)?(?: *=)?|&(?: *&)?|\| *\||['#~^]/,
    punctuation: /[\[\]{}().,:;|]/
  }
}


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = parser
parser.displayName = 'parser'
parser.aliases = []
function parser(Prism) {
  Prism.languages.parser = Prism.languages.extend('markup', {
    keyword: {
      pattern: /(^|[^^])(?:\^(?:case|eval|for|if|switch|throw)\b|@(?:BASE|CLASS|GET(?:_DEFAULT)?|OPTIONS|SET_DEFAULT|USE)\b)/,
      lookbehind: true
    },
    variable: {
      pattern: /(^|[^^])\B\$(?:\w+|(?=[.{]))(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
      lookbehind: true,
      inside: {
        punctuation: /\.|:+/
      }
    },
    function: {
      pattern: /(^|[^^])\B[@^]\w+(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
      lookbehind: true,
      inside: {
        keyword: {
          pattern: /(^@)(?:GET_|SET_)/,
          lookbehind: true
        },
        punctuation: /\.|:+/
      }
    },
    escape: {
      pattern: /\^(?:[$^;@()\[\]{}"':]|#[a-f\d]*)/i,
      alias: 'builtin'
    },
    punctuation: /[\[\](){};]/
  })
  Prism.languages.insertBefore('parser', 'keyword', {
    'parser-comment': {
      pattern: /(\s)#.*/,
      lookbehind: true,
      alias: 'comment'
    },
    expression: {
      // Allow for 3 levels of depth
      pattern: /(^|[^^])\((?:[^()]|\((?:[^()]|\((?:[^()])*\))*\))*\)/,
      greedy: true,
      lookbehind: true,
      inside: {
        string: {
          pattern: /(^|[^^])(["'])(?:(?!\2)[^^]|\^[\s\S])*\2/,
          lookbehind: true
        },
        keyword: Prism.languages.parser.keyword,
        variable: Prism.languages.parser.variable,
        function: Prism.languages.parser.function,
        boolean: /\b(?:true|false)\b/,
        number: /\b(?:0x[a-f\d]+|\d+\.?\d*(?:e[+-]?\d+)?)\b/i,
        escape: Prism.languages.parser.escape,
        operator: /[~+*\/\\%]|!(?:\|\|?|=)?|&&?|\|\|?|==|<[<=]?|>[>=]?|-[fd]?|\b(?:def|eq|ge|gt|in|is|le|lt|ne)\b/,
        punctuation: Prism.languages.parser.punctuation
      }
    }
  })
  Prism.languages.insertBefore(
    'inside',
    'punctuation',
    {
      expression: Prism.languages.parser.expression,
      keyword: Prism.languages.parser.keyword,
      variable: Prism.languages.parser.variable,
      function: Prism.languages.parser.function,
      escape: Prism.languages.parser.escape,
      'parser-punctuation': {
        pattern: Prism.languages.parser.punctuation,
        alias: 'punctuation'
      }
    },
    Prism.languages.parser['tag'].inside['attr-value']
  )
}


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = pascal
pascal.displayName = 'pascal'
pascal.aliases = ['objectpascal']
function pascal(Prism) {
  // Based on Free Pascal
  /* TODO
Support inline asm ?
*/
  Prism.languages.pascal = {
    comment: [/\(\*[\s\S]+?\*\)/, /\{[\s\S]+?\}/, /\/\/.*/],
    string: {
      pattern: /(?:'(?:''|[^'\r\n])*'|#[&$%]?[a-f\d]+)+|\^[a-z]/i,
      greedy: true
    },
    keyword: [
      {
        // Turbo Pascal
        pattern: /(^|[^&])\b(?:absolute|array|asm|begin|case|const|constructor|destructor|do|downto|else|end|file|for|function|goto|if|implementation|inherited|inline|interface|label|nil|object|of|operator|packed|procedure|program|record|reintroduce|repeat|self|set|string|then|to|type|unit|until|uses|var|while|with)\b/i,
        lookbehind: true
      },
      {
        // Free Pascal
        pattern: /(^|[^&])\b(?:dispose|exit|false|new|true)\b/i,
        lookbehind: true
      },
      {
        // Object Pascal
        pattern: /(^|[^&])\b(?:class|dispinterface|except|exports|finalization|finally|initialization|inline|library|on|out|packed|property|raise|resourcestring|threadvar|try)\b/i,
        lookbehind: true
      },
      {
        // Modifiers
        pattern: /(^|[^&])\b(?:absolute|abstract|alias|assembler|bitpacked|break|cdecl|continue|cppdecl|cvar|default|deprecated|dynamic|enumerator|experimental|export|external|far|far16|forward|generic|helper|implements|index|interrupt|iochecks|local|message|name|near|nodefault|noreturn|nostackframe|oldfpccall|otherwise|overload|override|pascal|platform|private|protected|public|published|read|register|reintroduce|result|safecall|saveregisters|softfloat|specialize|static|stdcall|stored|strict|unaligned|unimplemented|varargs|virtual|write)\b/i,
        lookbehind: true
      }
    ],
    number: [
      // Hexadecimal, octal and binary
      /(?:[&%]\d+|\$[a-f\d]+)/i,
      // Decimal
      /\b\d+(?:\.\d+)?(?:e[+-]?\d+)?/i
    ],
    operator: [
      /\.\.|\*\*|:=|<[<=>]?|>[>=]?|[+\-*\/]=?|[@^=]/i,
      {
        pattern: /(^|[^&])\b(?:and|as|div|exclude|in|include|is|mod|not|or|shl|shr|xor)\b/,
        lookbehind: true
      }
    ],
    punctuation: /\(\.|\.\)|[()\[\]:;,.]/
  }
  Prism.languages.objectpascal = Prism.languages.pascal
}


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = perl
perl.displayName = 'perl'
perl.aliases = []
function perl(Prism) {
  Prism.languages.perl = {
    comment: [
      {
        // POD
        pattern: /(^\s*)=\w+[\s\S]*?=cut.*/m,
        lookbehind: true
      },
      {
        pattern: /(^|[^\\$])#.*/,
        lookbehind: true
      }
    ],
    // TODO Could be nice to handle Heredoc too.
    string: [
      // q/.../
      {
        pattern: /\b(?:q|qq|qx|qw)\s*([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/,
        greedy: true
      },
      // q a...a
      {
        pattern: /\b(?:q|qq|qx|qw)\s+([a-zA-Z0-9])(?:(?!\1)[^\\]|\\[\s\S])*\1/,
        greedy: true
      },
      // q(...)
      {
        pattern: /\b(?:q|qq|qx|qw)\s*\((?:[^()\\]|\\[\s\S])*\)/,
        greedy: true
      },
      // q{...}
      {
        pattern: /\b(?:q|qq|qx|qw)\s*\{(?:[^{}\\]|\\[\s\S])*\}/,
        greedy: true
      },
      // q[...]
      {
        pattern: /\b(?:q|qq|qx|qw)\s*\[(?:[^[\]\\]|\\[\s\S])*\]/,
        greedy: true
      },
      // q<...>
      {
        pattern: /\b(?:q|qq|qx|qw)\s*<(?:[^<>\\]|\\[\s\S])*>/,
        greedy: true
      },
      // "...", `...`
      {
        pattern: /("|`)(?:(?!\1)[^\\]|\\[\s\S])*\1/,
        greedy: true
      },
      // '...'
      // FIXME Multi-line single-quoted strings are not supported as they would break variables containing '
      {
        pattern: /'(?:[^'\\\r\n]|\\.)*'/,
        greedy: true
      }
    ],
    regex: [
      // m/.../
      {
        pattern: /\b(?:m|qr)\s*([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1[msixpodualngc]*/,
        greedy: true
      },
      // m a...a
      {
        pattern: /\b(?:m|qr)\s+([a-zA-Z0-9])(?:(?!\1)[^\\]|\\[\s\S])*\1[msixpodualngc]*/,
        greedy: true
      },
      // m(...)
      {
        pattern: /\b(?:m|qr)\s*\((?:[^()\\]|\\[\s\S])*\)[msixpodualngc]*/,
        greedy: true
      },
      // m{...}
      {
        pattern: /\b(?:m|qr)\s*\{(?:[^{}\\]|\\[\s\S])*\}[msixpodualngc]*/,
        greedy: true
      },
      // m[...]
      {
        pattern: /\b(?:m|qr)\s*\[(?:[^[\]\\]|\\[\s\S])*\][msixpodualngc]*/,
        greedy: true
      },
      // m<...>
      {
        pattern: /\b(?:m|qr)\s*<(?:[^<>\\]|\\[\s\S])*>[msixpodualngc]*/,
        greedy: true
      },
      // The lookbehinds prevent -s from breaking
      // FIXME We don't handle change of separator like s(...)[...]
      // s/.../.../
      {
        pattern: /(^|[^-]\b)(?:s|tr|y)\s*([^a-zA-Z0-9\s{(\[<])(?:(?!\2)[^\\]|\\[\s\S])*\2(?:(?!\2)[^\\]|\\[\s\S])*\2[msixpodualngcer]*/,
        lookbehind: true,
        greedy: true
      },
      // s a...a...a
      {
        pattern: /(^|[^-]\b)(?:s|tr|y)\s+([a-zA-Z0-9])(?:(?!\2)[^\\]|\\[\s\S])*\2(?:(?!\2)[^\\]|\\[\s\S])*\2[msixpodualngcer]*/,
        lookbehind: true,
        greedy: true
      },
      // s(...)(...)
      {
        pattern: /(^|[^-]\b)(?:s|tr|y)\s*\((?:[^()\\]|\\[\s\S])*\)\s*\((?:[^()\\]|\\[\s\S])*\)[msixpodualngcer]*/,
        lookbehind: true,
        greedy: true
      },
      // s{...}{...}
      {
        pattern: /(^|[^-]\b)(?:s|tr|y)\s*\{(?:[^{}\\]|\\[\s\S])*\}\s*\{(?:[^{}\\]|\\[\s\S])*\}[msixpodualngcer]*/,
        lookbehind: true,
        greedy: true
      },
      // s[...][...]
      {
        pattern: /(^|[^-]\b)(?:s|tr|y)\s*\[(?:[^[\]\\]|\\[\s\S])*\]\s*\[(?:[^[\]\\]|\\[\s\S])*\][msixpodualngcer]*/,
        lookbehind: true,
        greedy: true
      },
      // s<...><...>
      {
        pattern: /(^|[^-]\b)(?:s|tr|y)\s*<(?:[^<>\\]|\\[\s\S])*>\s*<(?:[^<>\\]|\\[\s\S])*>[msixpodualngcer]*/,
        lookbehind: true,
        greedy: true
      },
      // /.../
      // The look-ahead tries to prevent two divisions on
      // the same line from being highlighted as regex.
      // This does not support multi-line regex.
      {
        pattern: /\/(?:[^\/\\\r\n]|\\.)*\/[msixpodualngc]*(?=\s*(?:$|[\r\n,.;})&|\-+*~<>!?^]|(lt|gt|le|ge|eq|ne|cmp|not|and|or|xor|x)\b))/,
        greedy: true
      }
    ],
    // FIXME Not sure about the handling of ::, ', and #
    variable: [
      // ${^POSTMATCH}
      /[&*$@%]\{\^[A-Z]+\}/,
      // $^V
      /[&*$@%]\^[A-Z_]/,
      // ${...}
      /[&*$@%]#?(?=\{)/,
      // $foo
      /[&*$@%]#?(?:(?:::)*'?(?!\d)[\w$]+)+(?:::)*/i,
      // $1
      /[&*$@%]\d+/,
      // $_, @_, %!
      // The negative lookahead prevents from breaking the %= operator
      /(?!%=)[$@%][!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~]/
    ],
    filehandle: {
      // <>, <FOO>, _
      pattern: /<(?![<=])\S*>|\b_\b/,
      alias: 'symbol'
    },
    vstring: {
      // v1.2, 1.2.3
      pattern: /v\d+(?:\.\d+)*|\d+(?:\.\d+){2,}/,
      alias: 'string'
    },
    function: {
      pattern: /sub [a-z0-9_]+/i,
      inside: {
        keyword: /sub/
      }
    },
    keyword: /\b(?:any|break|continue|default|delete|die|do|else|elsif|eval|for|foreach|given|goto|if|last|local|my|next|our|package|print|redo|require|say|state|sub|switch|undef|unless|until|use|when|while)\b/,
    number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0b[01](?:_?[01])*|(?:\d(?:_?\d)*)?\.?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)\b/,
    operator: /-[rwxoRWXOezsfdlpSbctugkTBMAC]\b|\+[+=]?|-[-=>]?|\*\*?=?|\/\/?=?|=[=~>]?|~[~=]?|\|\|?=?|&&?=?|<(?:=>?|<=?)?|>>?=?|![~=]?|[%^]=?|\.(?:=|\.\.?)?|[\\?]|\bx(?:=|\b)|\b(?:lt|gt|le|ge|eq|ne|cmp|not|and|or|xor)\b/,
    punctuation: /[{}[\];(),:]/
  }
}


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var refractorPhp = __webpack_require__(489)
module.exports = phpExtras
phpExtras.displayName = 'phpExtras'
phpExtras.aliases = []
function phpExtras(Prism) {
  Prism.register(refractorPhp)
  Prism.languages.insertBefore('php', 'variable', {
    this: /\$this\b/,
    global: /\$(?:_(?:SERVER|GET|POST|FILES|REQUEST|SESSION|ENV|COOKIE)|GLOBALS|HTTP_RAW_POST_DATA|argc|argv|php_errormsg|http_response_header)\b/,
    scope: {
      pattern: /\b[\w\\]+::/,
      inside: {
        keyword: /static|self|parent/,
        punctuation: /::|\\/
      }
    }
  })
}


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var refractorSql = __webpack_require__(490)
module.exports = plsql
plsql.displayName = 'plsql'
plsql.aliases = []
function plsql(Prism) {
  Prism.register(refractorSql)
  Prism.languages.plsql = Prism.languages.extend('sql', {
    comment: [/\/\*[\s\S]*?\*\//, /--.*/]
  })
  if (Prism.util.type(Prism.languages.plsql['keyword']) !== 'Array') {
    Prism.languages.plsql['keyword'] = [Prism.languages.plsql['keyword']]
  }
  Prism.languages.plsql['keyword'].unshift(
    /\b(?:ACCESS|AGENT|AGGREGATE|ARRAY|ARROW|AT|ATTRIBUTE|AUDIT|AUTHID|BFILE_BASE|BLOB_BASE|BLOCK|BODY|BOTH|BOUND|BYTE|CALLING|CHAR_BASE|CHARSET(?:FORM|ID)|CLOB_BASE|COLAUTH|COLLECT|CLUSTERS?|COMPILED|COMPRESS|CONSTANT|CONSTRUCTOR|CONTEXT|CRASH|CUSTOMDATUM|DANGLING|DATE_BASE|DEFINE|DETERMINISTIC|DURATION|ELEMENT|EMPTY|EXCEPTIONS?|EXCLUSIVE|EXTERNAL|FINAL|FORALL|FORM|FOUND|GENERAL|HEAP|HIDDEN|IDENTIFIED|IMMEDIATE|INCLUDING|INCREMENT|INDICATOR|INDEXES|INDICES|INFINITE|INITIAL|ISOPEN|INSTANTIABLE|INTERFACE|INVALIDATE|JAVA|LARGE|LEADING|LENGTH|LIBRARY|LIKE[24C]|LIMITED|LONG|LOOP|MAP|MAXEXTENTS|MAXLEN|MEMBER|MINUS|MLSLABEL|MULTISET|NAME|NAN|NATIVE|NEW|NOAUDIT|NOCOMPRESS|NOCOPY|NOTFOUND|NOWAIT|NUMBER(?:_BASE)?|OBJECT|OCI(?:COLL|DATE|DATETIME|DURATION|INTERVAL|LOBLOCATOR|NUMBER|RAW|REF|REFCURSOR|ROWID|STRING|TYPE)|OFFLINE|ONLINE|ONLY|OPAQUE|OPERATOR|ORACLE|ORADATA|ORGANIZATION|ORL(?:ANY|VARY)|OTHERS|OVERLAPS|OVERRIDING|PACKAGE|PARALLEL_ENABLE|PARAMETERS?|PASCAL|PCTFREE|PIPE(?:LINED)?|PRAGMA|PRIOR|PRIVATE|RAISE|RANGE|RAW|RECORD|REF|REFERENCE|REM|REMAINDER|RESULT|RESOURCE|RETURNING|REVERSE|ROW(?:ID|NUM|TYPE)|SAMPLE|SB[124]|SEGMENT|SELF|SEPARATE|SEQUENCE|SHORT|SIZE(?:_T)?|SPARSE|SQL(?:CODE|DATA|NAME|STATE)|STANDARD|STATIC|STDDEV|STORED|STRING|STRUCT|STYLE|SUBMULTISET|SUBPARTITION|SUBSTITUTABLE|SUBTYPE|SUCCESSFUL|SYNONYM|SYSDATE|TABAUTH|TDO|THE|TIMEZONE_(?:ABBR|HOUR|MINUTE|REGION)|TRAILING|TRANSAC(?:TIONAL)?|TRUSTED|UB[124]|UID|UNDER|UNTRUSTED|VALIDATE|VALIST|VARCHAR2|VARIABLE|VARIANCE|VARRAY|VIEWS|VOID|WHENEVER|WRAPPED|ZONE)\b/i
  )
  if (Prism.util.type(Prism.languages.plsql['operator']) !== 'Array') {
    Prism.languages.plsql['operator'] = [Prism.languages.plsql['operator']]
  }
  Prism.languages.plsql['operator'].unshift(/:=/)
}


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = powershell
powershell.displayName = 'powershell'
powershell.aliases = []
function powershell(Prism) {
  Prism.languages.powershell = {
    comment: [
      {
        pattern: /(^|[^`])<#[\s\S]*?#>/,
        lookbehind: true
      },
      {
        pattern: /(^|[^`])#.*/,
        lookbehind: true
      }
    ],
    string: [
      {
        pattern: /"(?:`[\s\S]|[^`"])*"/,
        greedy: true,
        inside: {
          function: {
            // Allow for one level of nesting
            pattern: /(^|[^`])\$\((?:\$\(.*?\)|(?!\$\()[^\r\n)])*\)/,
            lookbehind: true,
            // Populated at end of file
            inside: {}
          }
        }
      },
      {
        pattern: /'(?:[^']|'')*'/,
        greedy: true
      }
    ],
    // Matches name spaces as well as casts, attribute decorators. Force starting with letter to avoid matching array indices
    // Supports two levels of nested brackets (e.g. `[OutputType([System.Collections.Generic.List[int]])]`)
    namespace: /\[[a-z](?:\[(?:\[[^\]]*]|[^\[\]])*]|[^\[\]])*]/i,
    boolean: /\$(?:true|false)\b/i,
    variable: /\$\w+\b/i,
    // Cmdlets and aliases. Aliases should come last, otherwise "write" gets preferred over "write-host" for example
    // Get-Command | ?{ $_.ModuleName -match "Microsoft.PowerShell.(Util|Core|Management)" }
    // Get-Alias | ?{ $_.ReferencedCommand.Module.Name -match "Microsoft.PowerShell.(Util|Core|Management)" }
    function: [
      /\b(?:Add-(?:Computer|Content|History|Member|PSSnapin|Type)|Checkpoint-Computer|Clear-(?:Content|EventLog|History|Item|ItemProperty|Variable)|Compare-Object|Complete-Transaction|Connect-PSSession|ConvertFrom-(?:Csv|Json|StringData)|Convert-Path|ConvertTo-(?:Csv|Html|Json|Xml)|Copy-(?:Item|ItemProperty)|Debug-Process|Disable-(?:ComputerRestore|PSBreakpoint|PSRemoting|PSSessionConfiguration)|Disconnect-PSSession|Enable-(?:ComputerRestore|PSBreakpoint|PSRemoting|PSSessionConfiguration)|Enter-PSSession|Exit-PSSession|Export-(?:Alias|Clixml|Console|Csv|FormatData|ModuleMember|PSSession)|ForEach-Object|Format-(?:Custom|List|Table|Wide)|Get-(?:Alias|ChildItem|Command|ComputerRestorePoint|Content|ControlPanelItem|Culture|Date|Event|EventLog|EventSubscriber|FormatData|Help|History|Host|HotFix|Item|ItemProperty|Job|Location|Member|Module|Process|PSBreakpoint|PSCallStack|PSDrive|PSProvider|PSSession|PSSessionConfiguration|PSSnapin|Random|Service|TraceSource|Transaction|TypeData|UICulture|Unique|Variable|WmiObject)|Group-Object|Import-(?:Alias|Clixml|Csv|LocalizedData|Module|PSSession)|Invoke-(?:Command|Expression|History|Item|RestMethod|WebRequest|WmiMethod)|Join-Path|Limit-EventLog|Measure-(?:Command|Object)|Move-(?:Item|ItemProperty)|New-(?:Alias|Event|EventLog|Item|ItemProperty|Module|ModuleManifest|Object|PSDrive|PSSession|PSSessionConfigurationFile|PSSessionOption|PSTransportOption|Service|TimeSpan|Variable|WebServiceProxy)|Out-(?:Default|File|GridView|Host|Null|Printer|String)|Pop-Location|Push-Location|Read-Host|Receive-(?:Job|PSSession)|Register-(?:EngineEvent|ObjectEvent|PSSessionConfiguration|WmiEvent)|Remove-(?:Computer|Event|EventLog|Item|ItemProperty|Job|Module|PSBreakpoint|PSDrive|PSSession|PSSnapin|TypeData|Variable|WmiObject)|Rename-(?:Computer|Item|ItemProperty)|Reset-ComputerMachinePassword|Resolve-Path|Restart-(?:Computer|Service)|Restore-Computer|Resume-(?:Job|Service)|Save-Help|Select-(?:Object|String|Xml)|Send-MailMessage|Set-(?:Alias|Content|Date|Item|ItemProperty|Location|PSBreakpoint|PSDebug|PSSessionConfiguration|Service|StrictMode|TraceSource|Variable|WmiInstance)|Show-(?:Command|ControlPanelItem|EventLog)|Sort-Object|Split-Path|Start-(?:Job|Process|Service|Sleep|Transaction)|Stop-(?:Computer|Job|Process|Service)|Suspend-(?:Job|Service)|Tee-Object|Test-(?:ComputerSecureChannel|Connection|ModuleManifest|Path|PSSessionConfigurationFile)|Trace-Command|Unblock-File|Undo-Transaction|Unregister-(?:Event|PSSessionConfiguration)|Update-(?:FormatData|Help|List|TypeData)|Use-Transaction|Wait-(?:Event|Job|Process)|Where-Object|Write-(?:Debug|Error|EventLog|Host|Output|Progress|Verbose|Warning))\b/i,
      /\b(?:ac|cat|chdir|clc|cli|clp|clv|compare|copy|cp|cpi|cpp|cvpa|dbp|del|diff|dir|ebp|echo|epal|epcsv|epsn|erase|fc|fl|ft|fw|gal|gbp|gc|gci|gcs|gdr|gi|gl|gm|gp|gps|group|gsv|gu|gv|gwmi|iex|ii|ipal|ipcsv|ipsn|irm|iwmi|iwr|kill|lp|ls|measure|mi|mount|move|mp|mv|nal|ndr|ni|nv|ogv|popd|ps|pushd|pwd|rbp|rd|rdr|ren|ri|rm|rmdir|rni|rnp|rp|rv|rvpa|rwmi|sal|saps|sasv|sbp|sc|select|set|shcm|si|sl|sleep|sls|sort|sp|spps|spsv|start|sv|swmi|tee|trcm|type|write)\b/i
    ],
    // per http://technet.microsoft.com/en-us/library/hh847744.aspx
    keyword: /\b(?:Begin|Break|Catch|Class|Continue|Data|Define|Do|DynamicParam|Else|ElseIf|End|Exit|Filter|Finally|For|ForEach|From|Function|If|InlineScript|Parallel|Param|Process|Return|Sequence|Switch|Throw|Trap|Try|Until|Using|Var|While|Workflow)\b/i,
    operator: {
      pattern: /(\W?)(?:!|-(eq|ne|gt|ge|lt|le|sh[lr]|not|b?(?:and|x?or)|(?:Not)?(?:Like|Match|Contains|In)|Replace|Join|is(?:Not)?|as)\b|-[-=]?|\+[+=]?|[*\/%]=?)/i,
      lookbehind: true
    },
    punctuation: /[|{}[\];(),.]/
  }
  // Variable interpolation inside strings, and nested expressions
  Prism.languages.powershell.string[0].inside.boolean =
    Prism.languages.powershell.boolean
  Prism.languages.powershell.string[0].inside.variable =
    Prism.languages.powershell.variable
  Prism.languages.powershell.string[0].inside.function.inside =
    Prism.languages.powershell
}


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = processing
processing.displayName = 'processing'
processing.aliases = []
function processing(Prism) {
  Prism.languages.processing = Prism.languages.extend('clike', {
    keyword: /\b(?:break|catch|case|class|continue|default|else|extends|final|for|if|implements|import|new|null|private|public|return|static|super|switch|this|try|void|while)\b/,
    operator: /<[<=]?|>[>=]?|&&?|\|\|?|[%?]|[!=+\-*\/]=?/
  })
  Prism.languages.insertBefore('processing', 'number', {
    // Special case: XML is a type
    constant: /\b(?!XML\b)[A-Z][A-Z\d_]+\b/,
    type: {
      pattern: /\b(?:boolean|byte|char|color|double|float|int|XML|[A-Z]\w*)\b/,
      alias: 'variable'
    }
  })
  // Spaces are allowed between function name and parenthesis
  Prism.languages.processing['function'].pattern = /\w+(?=\s*\()/
  // Class-names is not styled by default
  Prism.languages.processing['class-name'].alias = 'variable'
}


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = prolog
prolog.displayName = 'prolog'
prolog.aliases = []
function prolog(Prism) {
  Prism.languages.prolog = {
    // Syntax depends on the implementation
    comment: [/%.+/, /\/\*[\s\S]*?\*\//],
    // Depending on the implementation, strings may allow escaped newlines and quote-escape
    string: {
      pattern: /(["'])(?:\1\1|\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: true
    },
    builtin: /\b(?:fx|fy|xf[xy]?|yfx?)\b/,
    variable: /\b[A-Z_]\w*/,
    // FIXME: Should we list all null-ary predicates (not followed by a parenthesis) like halt, trace, etc.?
    function: /\b[a-z]\w*(?:(?=\()|\/\d+)/,
    number: /\b\d+\.?\d*/,
    // Custom operators are allowed
    operator: /[:\\=><\-?*@\/;+^|!$.]+|\b(?:is|mod|not|xor)\b/,
    punctuation: /[(){}\[\],]/
  }
}


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = properties
properties.displayName = 'properties'
properties.aliases = []
function properties(Prism) {
  Prism.languages.properties = {
    comment: /^[ \t]*[#!].*$/m,
    'attr-value': {
      pattern: /(^[ \t]*(?:\\(?:\r\n|[\s\S])|[^\\\s:=])+?(?: *[=:] *| ))(?:\\(?:\r\n|[\s\S])|[^\\\r\n])+/m,
      lookbehind: true
    },
    'attr-name': /^[ \t]*(?:\\(?:\r\n|[\s\S])|[^\\\s:=])+?(?= *[=:] *| )/m,
    punctuation: /[=:]/
  }
}


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = protobuf
protobuf.displayName = 'protobuf'
protobuf.aliases = []
function protobuf(Prism) {
  Prism.languages.protobuf = Prism.languages.extend('clike', {
    keyword: /\b(?:package|import|message|enum)\b/,
    builtin: /\b(?:required|repeated|optional|reserved)\b/,
    primitive: {
      pattern: /\b(?:double|float|int32|int64|uint32|uint64|sint32|sint64|fixed32|fixed64|sfixed32|sfixed64|bool|string|bytes)\b/,
      alias: 'symbol'
    }
  })
}


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = pug
pug.displayName = 'pug'
pug.aliases = []
function pug(Prism) {
  ;(function(Prism) {
    // TODO:
    // - Add CSS highlighting inside <style> tags
    // - Add support for multi-line code blocks
    // - Add support for interpolation #{} and !{}
    // - Add support for tag interpolation #[]
    // - Add explicit support for plain text using |
    // - Add support for markup embedded in plain text
    Prism.languages.pug = {
      // Multiline stuff should appear before the rest
      // This handles both single-line and multi-line comments
      comment: {
        pattern: /(^([\t ]*))\/\/.*(?:(?:\r?\n|\r)\2[\t ]+.+)*/m,
        lookbehind: true
      },
      // All the tag-related part is in lookbehind
      // so that it can be highlighted by the "tag" pattern
      'multiline-script': {
        pattern: /(^([\t ]*)script\b.*\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ]+.+|\s*?(?=\r?\n|\r)))+/m,
        lookbehind: true,
        inside: {
          rest: Prism.languages.javascript
        }
      },
      // See at the end of the file for known filters
      filter: {
        pattern: /(^([\t ]*)):.+(?:(?:\r?\n|\r(?!\n))(?:\2[\t ]+.+|\s*?(?=\r?\n|\r)))+/m,
        lookbehind: true,
        inside: {
          'filter-name': {
            pattern: /^:[\w-]+/,
            alias: 'variable'
          }
        }
      },
      'multiline-plain-text': {
        pattern: /(^([\t ]*)[\w\-#.]+\.[\t ]*)(?:(?:\r?\n|\r(?!\n))(?:\2[\t ]+.+|\s*?(?=\r?\n|\r)))+/m,
        lookbehind: true
      },
      markup: {
        pattern: /(^[\t ]*)<.+/m,
        lookbehind: true,
        inside: {
          rest: Prism.languages.markup
        }
      },
      doctype: {
        pattern: /((?:^|\n)[\t ]*)doctype(?: .+)?/,
        lookbehind: true
      },
      // This handle all conditional and loop keywords
      'flow-control': {
        pattern: /(^[\t ]*)(?:if|unless|else|case|when|default|each|while)\b(?: .+)?/m,
        lookbehind: true,
        inside: {
          each: {
            pattern: /^each .+? in\b/,
            inside: {
              keyword: /\b(?:each|in)\b/,
              punctuation: /,/
            }
          },
          branch: {
            pattern: /^(?:if|unless|else|case|when|default|while)\b/,
            alias: 'keyword'
          },
          rest: Prism.languages.javascript
        }
      },
      keyword: {
        pattern: /(^[\t ]*)(?:block|extends|include|append|prepend)\b.+/m,
        lookbehind: true
      },
      mixin: [
        // Declaration
        {
          pattern: /(^[\t ]*)mixin .+/m,
          lookbehind: true,
          inside: {
            keyword: /^mixin/,
            function: /\w+(?=\s*\(|\s*$)/,
            punctuation: /[(),.]/
          }
        },
        // Usage
        {
          pattern: /(^[\t ]*)\+.+/m,
          lookbehind: true,
          inside: {
            name: {
              pattern: /^\+\w+/,
              alias: 'function'
            },
            rest: Prism.languages.javascript
          }
        }
      ],
      script: {
        pattern: /(^[\t ]*script(?:(?:&[^(]+)?\([^)]+\))*[\t ]+).+/m,
        lookbehind: true,
        inside: {
          rest: Prism.languages.javascript
        }
      },
      'plain-text': {
        pattern: /(^[\t ]*(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?[\t ]+).+/m,
        lookbehind: true
      },
      tag: {
        pattern: /(^[\t ]*)(?!-)[\w\-#.]*[\w\-](?:(?:&[^(]+)?\([^)]+\))*\/?:?/m,
        lookbehind: true,
        inside: {
          attributes: [
            {
              pattern: /&[^(]+\([^)]+\)/,
              inside: {
                rest: Prism.languages.javascript
              }
            },
            {
              pattern: /\([^)]+\)/,
              inside: {
                'attr-value': {
                  pattern: /(=\s*)(?:\{[^}]*\}|[^,)\r\n]+)/,
                  lookbehind: true,
                  inside: {
                    rest: Prism.languages.javascript
                  }
                },
                'attr-name': /[\w-]+(?=\s*!?=|\s*[,)])/,
                punctuation: /[!=(),]+/
              }
            }
          ],
          punctuation: /:/
        }
      },
      code: [
        {
          pattern: /(^[\t ]*(?:-|!?=)).+/m,
          lookbehind: true,
          inside: {
            rest: Prism.languages.javascript
          }
        }
      ],
      punctuation: /[.\-!=|]+/
    }
    var filter_pattern =
      '(^([\\t ]*)):{{filter_name}}(?:(?:\\r?\\n|\\r(?!\\n))(?:\\2[\\t ]+.+|\\s*?(?=\\r?\\n|\\r)))+'
    // Non exhaustive list of available filters and associated languages
    var filters = [
      {filter: 'atpl', language: 'twig'},
      {filter: 'coffee', language: 'coffeescript'},
      'ejs',
      'handlebars',
      'hogan',
      'less',
      'livescript',
      'markdown',
      'mustache',
      'plates',
      {filter: 'sass', language: 'scss'},
      'stylus',
      'swig'
    ]
    var all_filters = {}
    for (var i = 0, l = filters.length; i < l; i++) {
      var filter = filters[i]
      filter =
        typeof filter === 'string' ? {filter: filter, language: filter} : filter
      if (Prism.languages[filter.language]) {
        all_filters['filter-' + filter.filter] = {
          pattern: RegExp(
            filter_pattern.replace('{{filter_name}}', filter.filter),
            'm'
          ),
          lookbehind: true,
          inside: {
            'filter-name': {
              pattern: /^:[\w-]+/,
              alias: 'variable'
            },
            rest: Prism.languages[filter.language]
          }
        }
      }
    }
    Prism.languages.insertBefore('pug', 'filter', all_filters)
  })(Prism)
}


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = puppet
puppet.displayName = 'puppet'
puppet.aliases = []
function puppet(Prism) {
  ;(function(Prism) {
    Prism.languages.puppet = {
      heredoc: [
        // Matches the content of a quoted heredoc string (subject to interpolation)
        {
          pattern: /(@\("([^"\r\n\/):]+)"(?:\/[nrts$uL]*)?\).*(?:\r?\n|\r))(?:.*(?:\r?\n|\r))*?[ \t]*\|?[ \t]*-?[ \t]*\2/,
          lookbehind: true,
          alias: 'string',
          inside: {
            // Matches the end tag
            punctuation: /(?=\S).*\S(?= *$)/
            // See interpolation below
          }
        },
        // Matches the content of an unquoted heredoc string (no interpolation)
        {
          pattern: /(@\(([^"\r\n\/):]+)(?:\/[nrts$uL]*)?\).*(?:\r?\n|\r))(?:.*(?:\r?\n|\r))*?[ \t]*\|?[ \t]*-?[ \t]*\2/,
          lookbehind: true,
          greedy: true,
          alias: 'string',
          inside: {
            // Matches the end tag
            punctuation: /(?=\S).*\S(?= *$)/
          }
        },
        // Matches the start tag of heredoc strings
        {
          pattern: /@\("?(?:[^"\r\n\/):]+)"?(?:\/[nrts$uL]*)?\)/,
          alias: 'string',
          inside: {
            punctuation: {
              pattern: /(\().+?(?=\))/,
              lookbehind: true
            }
          }
        }
      ],
      'multiline-comment': {
        pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
        lookbehind: true,
        greedy: true,
        alias: 'comment'
      },
      regex: {
        // Must be prefixed with the keyword "node" or a non-word char
        pattern: /((?:\bnode\s+|[~=\(\[\{,]\s*|[=+]>\s*|^\s*))\/(?:[^\/\\]|\\[\s\S])+\/(?:[imx]+\b|\B)/,
        lookbehind: true,
        greedy: true,
        inside: {
          // Extended regexes must have the x flag. They can contain single-line comments.
          'extended-regex': {
            pattern: /^\/(?:[^\/\\]|\\[\s\S])+\/[im]*x[im]*$/,
            inside: {
              comment: /#.*/
            }
          }
        }
      },
      comment: {
        pattern: /(^|[^\\])#.*/,
        lookbehind: true,
        greedy: true
      },
      string: {
        // Allow for one nested level of double quotes inside interpolation
        pattern: /(["'])(?:\$\{(?:[^'"}]|(["'])(?:(?!\2)[^\\]|\\[\s\S])*\2)+\}|(?!\1)[^\\]|\\[\s\S])*\1/,
        greedy: true,
        inside: {
          'double-quoted': {
            pattern: /^"[\s\S]*"$/,
            inside: {
              // See interpolation below
            }
          }
        }
      },
      variable: {
        pattern: /\$(?:::)?\w+(?:::\w+)*/,
        inside: {
          punctuation: /::/
        }
      },
      'attr-name': /(?:\w+|\*)(?=\s*=>)/,
      function: [
        {
          pattern: /(\.)(?!\d)\w+/,
          lookbehind: true
        },
        /\b(?:contain|debug|err|fail|include|info|notice|realize|require|tag|warning)\b|\b(?!\d)\w+(?=\()/
      ],
      number: /\b(?:0x[a-f\d]+|\d+(?:\.\d+)?(?:e-?\d+)?)\b/i,
      boolean: /\b(?:true|false)\b/,
      // Includes words reserved for future use
      keyword: /\b(?:application|attr|case|class|consumes|default|define|else|elsif|function|if|import|inherits|node|private|produces|type|undef|unless)\b/,
      datatype: {
        pattern: /\b(?:Any|Array|Boolean|Callable|Catalogentry|Class|Collection|Data|Default|Enum|Float|Hash|Integer|NotUndef|Numeric|Optional|Pattern|Regexp|Resource|Runtime|Scalar|String|Struct|Tuple|Type|Undef|Variant)\b/,
        alias: 'symbol'
      },
      operator: /=[=~>]?|![=~]?|<(?:<\|?|[=~|-])?|>[>=]?|->?|~>|\|>?>?|[*\/%+?]|\b(?:and|in|or)\b/,
      punctuation: /[\[\]{}().,;]|:+/
    }
    var interpolation = [
      {
        // Allow for one nested level of braces inside interpolation
        pattern: /(^|[^\\])\$\{(?:[^'"{}]|\{[^}]*\}|(["'])(?:(?!\2)[^\\]|\\[\s\S])*\2)+\}/,
        lookbehind: true,
        inside: {
          'short-variable': {
            // Negative look-ahead prevent wrong highlighting of functions
            pattern: /(^\$\{)(?!\w+\()(?:::)?\w+(?:::\w+)*/,
            lookbehind: true,
            alias: 'variable',
            inside: {
              punctuation: /::/
            }
          },
          delimiter: {
            pattern: /^\$/,
            alias: 'variable'
          },
          rest: Prism.languages.puppet
        }
      },
      {
        pattern: /(^|[^\\])\$(?:::)?\w+(?:::\w+)*/,
        lookbehind: true,
        alias: 'variable',
        inside: {
          punctuation: /::/
        }
      }
    ]
    Prism.languages.puppet['heredoc'][0].inside.interpolation = interpolation
    Prism.languages.puppet['string'].inside[
      'double-quoted'
    ].inside.interpolation = interpolation
  })(Prism)
}


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var refractorC = __webpack_require__(137)
module.exports = pure
pure.displayName = 'pure'
pure.aliases = []
function pure(Prism) {
  Prism.register(refractorC)
  ;(function(Prism) {
    Prism.languages.pure = {
      comment: [
        {
          pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
          lookbehind: true
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: true
        },
        /#!.+/
      ],
      'inline-lang': {
        pattern: /%<[\s\S]+?%>/,
        greedy: true,
        inside: {
          lang: {
            pattern: /(^%< *)-\*-.+?-\*-/,
            lookbehind: true,
            alias: 'comment'
          },
          delimiter: {
            pattern: /^%<.*|%>$/,
            alias: 'punctuation'
          }
        }
      },
      string: {
        pattern: /"(?:\\.|[^"\\\r\n])*"/,
        greedy: true
      },
      number: {
        // The look-behind prevents wrong highlighting of the .. operator
        pattern: /((?:\.\.)?)(?:\b(?:inf|nan)\b|\b0x[\da-f]+|(?:\b(?:0b)?\d+(?:\.\d)?|\B\.\d)\d*(?:e[+-]?\d+)?L?)/i,
        lookbehind: true
      },
      keyword: /\b(?:ans|break|bt|case|catch|cd|clear|const|def|del|dump|else|end|exit|extern|false|force|help|if|infix[lr]?|interface|let|ls|mem|namespace|nonfix|NULL|of|otherwise|outfix|override|postfix|prefix|private|public|pwd|quit|run|save|show|stats|then|throw|trace|true|type|underride|using|when|with)\b/,
      function: /\b(?:abs|add_(?:(?:fundef|interface|macdef|typedef)(?:_at)?|addr|constdef|vardef)|all|any|applp?|arity|bigintp?|blob(?:_crc|_size|p)?|boolp?|byte_(?:matrix|pointer)|byte_c?string(?:_pointer)?|calloc|cat|catmap|ceil|char[ps]?|check_ptrtag|chr|clear_sentry|clearsym|closurep?|cmatrixp?|cols?|colcat(?:map)?|colmap|colrev|colvector(?:p|seq)?|complex(?:_float_(?:matrix|pointer)|_matrix(?:_view)?|_pointer|p)?|conj|cookedp?|cst|cstring(?:_(?:dup|list|vector))?|curry3?|cyclen?|del_(?:constdef|fundef|interface|macdef|typedef|vardef)|delete|diag(?:mat)?|dim|dmatrixp?|do|double(?:_matrix(?:_view)?|_pointer|p)?|dowith3?|drop|dropwhile|eval(?:cmd)?|exactp|filter|fix|fixity|flip|float(?:_matrix|_pointer)|floor|fold[lr]1?|frac|free|funp?|functionp?|gcd|get(?:_(?:byte|constdef|double|float|fundef|int(?:64)?|interface(?:_typedef)?|long|macdef|pointer|ptrtag|short|sentry|string|typedef|vardef))?|globsym|hash|head|id|im|imatrixp?|index|inexactp|infp|init|insert|int(?:_matrix(?:_view)?|_pointer|p)?|int64_(?:matrix|pointer)|integerp?|iteraten?|iterwhile|join|keys?|lambdap?|last(?:err(?:pos)?)?|lcd|list[2p]?|listmap|make_ptrtag|malloc|map|matcat|matrixp?|max|member|min|nanp|nargs|nmatrixp?|null|numberp?|ord|pack(?:ed)?|pointer(?:_cast|_tag|_type|p)?|pow|pred|ptrtag|put(?:_(?:byte|double|float|int(?:64)?|long|pointer|short|string))?|rationalp?|re|realp?|realloc|recordp?|redim|reduce(?:_with)?|refp?|repeatn?|reverse|rlistp?|round|rows?|rowcat(?:map)?|rowmap|rowrev|rowvector(?:p|seq)?|same|scan[lr]1?|sentry|sgn|short_(?:matrix|pointer)|slice|smatrixp?|sort|split|str|strcat|stream|stride|string(?:_(?:dup|list|vector)|p)?|subdiag(?:mat)?|submat|subseq2?|substr|succ|supdiag(?:mat)?|symbolp?|tail|take|takewhile|thunkp?|transpose|trunc|tuplep?|typep|ubyte|uint(?:64)?|ulong|uncurry3?|unref|unzip3?|update|ushort|vals?|varp?|vector(?:p|seq)?|void|zip3?|zipwith3?)\b/,
      special: {
        pattern: /\b__[a-z]+__\b/i,
        alias: 'builtin'
      },
      // Any combination of operator chars can be an operator
      operator: /(?=\b_|[^_])[!"#$%&'*+,\-.\/:<=>?@\\^_`|~\u00a1-\u00bf\u00d7-\u00f7\u20d0-\u2bff]+|\b(?:and|div|mod|not|or)\b/,
      // FIXME: How can we prevent | and , to be highlighted as operator when they are used alone?
      punctuation: /[(){}\[\];,|]/
    }
    var inlineLanguages = [
      'c',
      {lang: 'c++', alias: 'cpp'},
      'fortran',
      'ats',
      'dsp'
    ]
    var inlineLanguageRe = '%< *-\\*- *{lang}\\d* *-\\*-[\\s\\S]+?%>'
    inlineLanguages.forEach(function(lang) {
      var alias = lang
      if (typeof lang !== 'string') {
        alias = lang.alias
        lang = lang.lang
      }
      if (Prism.languages[alias]) {
        var o = {}
        o['inline-lang-' + alias] = {
          pattern: RegExp(
            inlineLanguageRe.replace(
              '{lang}',
              lang.replace(/([.+*?\/\\(){}\[\]])/g, '\\$1')
            ),
            'i'
          ),
          inside: Prism.util.clone(Prism.languages.pure['inline-lang'].inside)
        }
        o['inline-lang-' + alias].inside.rest = Prism.util.clone(
          Prism.languages[alias]
        )
        Prism.languages.insertBefore('pure', 'inline-lang', o)
      }
    })
    // C is the default inline language
    if (Prism.languages.c) {
      Prism.languages.pure['inline-lang'].inside.rest = Prism.util.clone(
        Prism.languages.c
      )
    }
  })(Prism)
}


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = python
python.displayName = 'python'
python.aliases = []
function python(Prism) {
  Prism.languages.python = {
    comment: {
      pattern: /(^|[^\\])#.*/,
      lookbehind: true
    },
    'triple-quoted-string': {
      pattern: /("""|''')[\s\S]+?\1/,
      greedy: true,
      alias: 'string'
    },
    string: {
      pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
      greedy: true
    },
    function: {
      pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
      lookbehind: true
    },
    'class-name': {
      pattern: /(\bclass\s+)\w+/i,
      lookbehind: true
    },
    keyword: /\b(?:as|assert|async|await|break|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|nonlocal|pass|print|raise|return|try|while|with|yield)\b/,
    builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
    boolean: /\b(?:True|False|None)\b/,
    number: /(?:\b(?=\d)|\B(?=\.))(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*\.?\d*|\.\d+)(?:e[+-]?\d+)?j?\b/i,
    operator: /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]|\b(?:or|and|not)\b/,
    punctuation: /[{}[\];(),.:]/
  }
}


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = q
q.displayName = 'q'
q.aliases = []
function q(Prism) {
  Prism.languages.q = {
    string: /"(?:\\.|[^"\\\r\n])*"/,
    comment: [
      // From http://code.kx.com/wiki/Reference/Slash:
      // When / is following a space (or a right parenthesis, bracket, or brace), it is ignored with the rest of the line.
      {
        pattern: /([\t )\]}])\/.*/,
        lookbehind: true,
        greedy: true
      },
      // From http://code.kx.com/wiki/Reference/Slash:
      // A line which has / as its first character and contains at least one other non-whitespace character is a whole-line comment and is ignored entirely.
      // A / on a line by itself begins a multiline comment which is terminated by the next \ on a line by itself.
      // If a / is not matched by a \, the multiline comment is unterminated and continues to end of file.
      // The / and \ must be the first char on the line, but may be followed by any amount of whitespace.
      {
        pattern: /(^|\r?\n|\r)\/[\t ]*(?:(?:\r?\n|\r)(?:.*(?:\r?\n|\r))*?(?:\\(?=[\t ]*(?:\r?\n|\r))|$)|\S.*)/,
        lookbehind: true,
        greedy: true
      },
      // From http://code.kx.com/wiki/Reference/Slash:
      // A \ on a line by itself with no preceding matching / will comment to end of file.
      {
        pattern: /^\\[\t ]*(?:\r?\n|\r)[\s\S]+/m,
        greedy: true
      },
      {
        pattern: /^#!.+/m,
        greedy: true
      }
    ],
    symbol: /`(?::\S+|[\w.]*)/,
    datetime: {
      pattern: /0N[mdzuvt]|0W[dtz]|\d{4}\.\d\d(?:m|\.\d\d(?:T(?:\d\d(?::\d\d(?::\d\d(?:[.:]\d\d\d)?)?)?)?)?[dz]?)|\d\d:\d\d(?::\d\d(?:[.:]\d\d\d)?)?[uvt]?/,
      alias: 'number'
    },
    // The negative look-ahead prevents bad highlighting
    // of verbs 0: and 1:
    number: /\b(?![01]:)(?:0[wn]|0W[hj]?|0N[hje]?|0x[\da-fA-F]+|\d+\.?\d*(?:e[+-]?\d+)?[hjfeb]?)/,
    keyword: /\\\w+\b|\b(?:abs|acos|aj0?|all|and|any|asc|asin|asof|atan|attr|avgs?|binr?|by|ceiling|cols|cor|cos|count|cov|cross|csv|cut|delete|deltas|desc|dev|differ|distinct|div|do|dsave|ej|enlist|eval|except|exec|exit|exp|fby|fills|first|fkeys|flip|floor|from|get|getenv|group|gtime|hclose|hcount|hdel|hopen|hsym|iasc|identity|idesc|if|ij|in|insert|inter|inv|keys?|last|like|list|ljf?|load|log|lower|lsq|ltime|ltrim|mavg|maxs?|mcount|md5|mdev|med|meta|mins?|mmax|mmin|mmu|mod|msum|neg|next|not|null|or|over|parse|peach|pj|plist|prds?|prev|prior|rand|rank|ratios|raze|read0|read1|reciprocal|reval|reverse|rload|rotate|rsave|rtrim|save|scan|scov|sdev|select|set|setenv|show|signum|sin|sqrt|ssr?|string|sublist|sums?|sv|svar|system|tables|tan|til|trim|txf|type|uj|ungroup|union|update|upper|upsert|value|var|views?|vs|wavg|where|while|within|wj1?|wsum|ww|xasc|xbar|xcols?|xdesc|xexp|xgroup|xkey|xlog|xprev|xrank)\b/,
    adverb: {
      pattern: /['\/\\]:?|\beach\b/,
      alias: 'function'
    },
    verb: {
      pattern: /(?:\B\.\B|\b[01]:|<[=>]?|>=?|[:+\-*%,!?_~=|$&#@^]):?/,
      alias: 'operator'
    },
    punctuation: /[(){}\[\];.]/
  }
}


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = qore
qore.displayName = 'qore'
qore.aliases = []
function qore(Prism) {
  Prism.languages.qore = Prism.languages.extend('clike', {
    comment: {
      pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:\/\/|#).*)/,
      lookbehind: true
    },
    // Overridden to allow unescaped multi-line strings
    string: {
      pattern: /("|')(\\[\s\S]|(?!\1)[^\\])*\1/,
      greedy: true
    },
    variable: /\$(?!\d)\w+\b/,
    keyword: /\b(?:abstract|any|assert|binary|bool|boolean|break|byte|case|catch|char|class|code|const|continue|data|default|do|double|else|enum|extends|final|finally|float|for|goto|hash|if|implements|import|inherits|instanceof|int|interface|long|my|native|new|nothing|null|object|our|own|private|reference|rethrow|return|short|soft(?:int|float|number|bool|string|date|list)|static|strictfp|string|sub|super|switch|synchronized|this|throw|throws|transient|try|void|volatile|while)\b/,
    number: /\b(?:0b[01]+|0x[\da-f]*\.?[\da-fp\-]+|\d*\.?\d+e?\d*[df]|\d*\.?\d+)\b/i,
    boolean: /\b(?:true|false)\b/i,
    operator: {
      pattern: /(^|[^.])(?:\+[+=]?|-[-=]?|[!=](?:==?|~)?|>>?=?|<(?:=>?|<=?)?|&[&=]?|\|[|=]?|[*\/%^]=?|[~?])/,
      lookbehind: true
    },
    function: /\$?\b(?!\d)\w+(?=\()/
  })
}


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = r
r.displayName = 'r'
r.aliases = []
function r(Prism) {
  Prism.languages.r = {
    comment: /#.*/,
    string: {
      pattern: /(['"])(?:\\.|(?!\1)[^\\\r\n])*\1/,
      greedy: true
    },
    'percent-operator': {
      // Includes user-defined operators
      // and %%, %*%, %/%, %in%, %o%, %x%
      pattern: /%[^%\s]*%/,
      alias: 'operator'
    },
    boolean: /\b(?:TRUE|FALSE)\b/,
    ellipsis: /\.\.(?:\.|\d+)/,
    number: [
      /\b(?:NaN|Inf)\b/,
      /(?:\b0x[\dA-Fa-f]+(?:\.\d*)?|\b\d+\.?\d*|\B\.\d+)(?:[EePp][+-]?\d+)?[iL]?/
    ],
    keyword: /\b(?:if|else|repeat|while|function|for|in|next|break|NULL|NA|NA_integer_|NA_real_|NA_complex_|NA_character_)\b/,
    operator: /->?>?|<(?:=|<?-)?|[>=!]=?|::?|&&?|\|\|?|[+*\/^$@~]/,
    punctuation: /[(){}\[\],;]/
  }
}


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = reason
reason.displayName = 'reason'
reason.aliases = []
function reason(Prism) {
  Prism.languages.reason = Prism.languages.extend('clike', {
    comment: {
      pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
      lookbehind: true
    },
    string: {
      pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
      greedy: true
    },
    // 'class-name' must be matched *after* 'constructor' defined below
    'class-name': /\b[A-Z]\w*/,
    keyword: /\b(?:and|as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|sig|struct|switch|then|to|try|type|val|virtual|when|while|with)\b/,
    operator: /\.{3}|:[:=]|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:mod|land|lor|lxor|lsl|lsr|asr)\b/
  })
  Prism.languages.insertBefore('reason', 'class-name', {
    character: {
      pattern: /'(?:\\x[\da-f]{2}|\\o[0-3][0-7][0-7]|\\\d{3}|\\.|[^'\\\r\n])'/,
      alias: 'string'
    },
    constructor: {
      // Negative look-ahead prevents from matching things like String.capitalize
      pattern: /\b[A-Z]\w*\b(?!\s*\.)/,
      alias: 'variable'
    },
    label: {
      pattern: /\b[a-z]\w*(?=::)/,
      alias: 'symbol'
    }
  })
  // We can't match functions property, so let's not even try.
  delete Prism.languages.reason.function
}


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = renpy
renpy.displayName = 'renpy'
renpy.aliases = []
function renpy(Prism) {
  Prism.languages.renpy = {
    // TODO Write tests.
    comment: {
      pattern: /(^|[^\\])#.+/,
      lookbehind: true
    },
    string: {
      pattern: /("""|''')[\s\S]+?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2|(?:^#?(?:(?:[0-9a-fA-F]{2}){3}|(?:[0-9a-fA-F]){3})$)/m,
      greedy: true
    },
    function: /[a-z_]\w*(?=\()/i,
    property: /\b(?:insensitive|idle|hover|selected_idle|selected_hover|background|position|alt|xpos|ypos|pos|xanchor|yanchor|anchor|xalign|yalign|align|xcenter|ycenter|xofsset|yoffset|ymaximum|maximum|xmaximum|xminimum|yminimum|minimum|xsize|ysizexysize|xfill|yfill|area|antialias|black_color|bold|caret|color|first_indent|font|size|italic|justify|kerning|language|layout|line_leading|line_overlap_split|line_spacing|min_width|newline_indent|outlines|rest_indent|ruby_style|slow_cps|slow_cps_multiplier|strikethrough|text_align|underline|hyperlink_functions|vertical|hinting|foreground|left_margin|xmargin|top_margin|bottom_margin|ymargin|left_padding|right_padding|xpadding|top_padding|bottom_padding|ypadding|size_group|child|hover_sound|activate_sound|mouse|focus_mask|keyboard_focus|bar_vertical|bar_invert|bar_resizing|left_gutter|right_gutter|top_gutter|bottom_gutter|left_bar|right_bar|top_bar|bottom_bar|thumb|thumb_shadow|thumb_offset|unscrollable|spacing|first_spacing|box_reverse|box_wrap|order_reverse|fit_first|ysize|thumbnail_width|thumbnail_height|help|text_ypos|text_xpos|idle_color|hover_color|selected_idle_color|selected_hover_color|insensitive_color|alpha|insensitive_background|hover_background|zorder|value|width|xadjustment|xanchoraround|xaround|xinitial|xoffset|xzoom|yadjustment|yanchoraround|yaround|yinitial|yzoom|zoom|ground|height|text_style|text_y_fudge|selected_insensitive|has_sound|has_music|has_voice|focus|hovered|image_style|length|minwidth|mousewheel|offset|prefix|radius|range|right_margin|rotate|rotate_pad|developer|screen_width|screen_height|window_title|name|version|windows_icon|default_fullscreen|default_text_cps|default_afm_time|main_menu_music|sample_sound|enter_sound|exit_sound|save_directory|enter_transition|exit_transition|intra_transition|main_game_transition|game_main_transition|end_splash_transition|end_game_transition|after_load_transition|window_show_transition|window_hide_transition|adv_nvl_transition|nvl_adv_transition|enter_yesno_transition|exit_yesno_transition|enter_replay_transition|exit_replay_transition|say_attribute_transition|directory_name|executable_name|include_update|window_icon|modal|google_play_key|google_play_salt|drag_name|drag_handle|draggable|dragged|droppable|dropped|narrator_menu|action|default_afm_enable|version_name|version_tuple|inside|fadeout|fadein|layers|layer_clipping|linear|scrollbars|side_xpos|side_ypos|side_spacing|edgescroll|drag_joined|drag_raise|drop_shadow|drop_shadow_color|subpixel|easein|easeout|time|crop|auto|update|get_installed_packages|can_update|UpdateVersion|Update|overlay_functions|translations|window_left_padding|show_side_image|show_two_window)\b/,
    tag: /\b(?:label|image|menu|[hv]box|frame|text|imagemap|imagebutton|bar|vbar|screen|textbutton|buttoscreenn|fixed|grid|input|key|mousearea|side|timer|viewport|window|hotspot|hotbar|self|button|drag|draggroup|tag|mm_menu_frame|nvl|block|parallel)\b|\$/,
    keyword: /\b(?:as|assert|break|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|pass|print|raise|return|try|while|yield|adjustment|alignaround|allow|angle|around|box_layout|cache|changed|child_size|clicked|clipping|corner1|corner2|default|delay|exclude|scope|slow|slow_abortable|slow_done|sound|style_group|substitute|suffix|transform_anchor|transpose|unhovered|config|theme|mm_root|gm_root|rounded_window|build|disabled_text|disabled|widget_selected|widget_text|widget_hover|widget|updater|behind|call|expression|hide|init|jump|onlayer|python|renpy|scene|set|show|transform|play|queue|stop|pause|define|window|repeat|contains|choice|on|function|event|animation|clockwise|counterclockwise|circles|knot|null|None|random|has|add|use|fade|dissolve|style|store|id|voice|center|left|right|less_rounded|music|movie|clear|persistent|ui)\b/,
    boolean: /\b(?:[Tt]rue|[Ff]alse)\b/,
    number: /(?:\b(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*\.?\d*)|\B\.\d+)(?:e[+-]?\d+)?j?/i,
    operator: /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]|\b(?:or|and|not|with|at)\b/,
    punctuation: /[{}[\];(),.:]/
  }
}


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = rest
rest.displayName = 'rest'
rest.aliases = []
function rest(Prism) {
  Prism.languages.rest = {
    table: [
      {
        pattern: /(\s*)(?:\+[=-]+)+\+(?:\r?\n|\r)(?:\1(?:[+|].+)+[+|](?:\r?\n|\r))+\1(?:\+[=-]+)+\+/,
        lookbehind: true,
        inside: {
          punctuation: /\||(?:\+[=-]+)+\+/
        }
      },
      {
        pattern: /(\s*)(?:=+ +)+=+(?:(?:\r?\n|\r)\1.+)+(?:\r?\n|\r)\1(?:=+ +)+=+(?=(?:\r?\n|\r){2}|\s*$)/,
        lookbehind: true,
        inside: {
          punctuation: /[=-]+/
        }
      }
    ],
    // Directive-like patterns
    'substitution-def': {
      pattern: /(^\s*\.\. )\|(?:[^|\s](?:[^|]*[^|\s])?)\| [^:]+::/m,
      lookbehind: true,
      inside: {
        substitution: {
          pattern: /^\|(?:[^|\s]|[^|\s][^|]*[^|\s])\|/,
          alias: 'attr-value',
          inside: {
            punctuation: /^\||\|$/
          }
        },
        directive: {
          pattern: /( +)[^:]+::/,
          lookbehind: true,
          alias: 'function',
          inside: {
            punctuation: /::$/
          }
        }
      }
    },
    'link-target': [
      {
        pattern: /(^\s*\.\. )\[[^\]]+\]/m,
        lookbehind: true,
        alias: 'string',
        inside: {
          punctuation: /^\[|\]$/
        }
      },
      {
        pattern: /(^\s*\.\. )_(?:`[^`]+`|(?:[^:\\]|\\.)+):/m,
        lookbehind: true,
        alias: 'string',
        inside: {
          punctuation: /^_|:$/
        }
      }
    ],
    directive: {
      pattern: /(^\s*\.\. )[^:]+::/m,
      lookbehind: true,
      alias: 'function',
      inside: {
        punctuation: /::$/
      }
    },
    comment: {
      // The two alternatives try to prevent highlighting of blank comments
      pattern: /(^\s*\.\.)(?:(?: .+)?(?:(?:\r?\n|\r).+)+| .+)(?=(?:\r?\n|\r){2}|$)/m,
      lookbehind: true
    },
    title: [
      // Overlined and underlined
      {
        pattern: /^(([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2+)(?:\r?\n|\r).+(?:\r?\n|\r)\1$/m,
        inside: {
          punctuation: /^[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+|[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+$/,
          important: /.+/
        }
      },
      // Underlined only
      {
        pattern: /(^|(?:\r?\n|\r){2}).+(?:\r?\n|\r)([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2+(?=\r?\n|\r|$)/,
        lookbehind: true,
        inside: {
          punctuation: /[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]+$/,
          important: /.+/
        }
      }
    ],
    hr: {
      pattern: /((?:\r?\n|\r){2})([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\2{3,}(?=(?:\r?\n|\r){2})/,
      lookbehind: true,
      alias: 'punctuation'
    },
    field: {
      pattern: /(^\s*):[^:\r\n]+:(?= )/m,
      lookbehind: true,
      alias: 'attr-name'
    },
    'command-line-option': {
      pattern: /(^\s*)(?:[+-][a-z\d]|(?:--|\/)[a-z\d-]+)(?:[ =](?:[a-z][\w-]*|<[^<>]+>))?(?:, (?:[+-][a-z\d]|(?:--|\/)[a-z\d-]+)(?:[ =](?:[a-z][\w-]*|<[^<>]+>))?)*(?=(?:\r?\n|\r)? {2,}\S)/im,
      lookbehind: true,
      alias: 'symbol'
    },
    'literal-block': {
      pattern: /::(?:\r?\n|\r){2}([ \t]+).+(?:(?:\r?\n|\r)\1.+)*/,
      inside: {
        'literal-block-punctuation': {
          pattern: /^::/,
          alias: 'punctuation'
        }
      }
    },
    'quoted-literal-block': {
      pattern: /::(?:\r?\n|\r){2}([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~]).*(?:(?:\r?\n|\r)\1.*)*/,
      inside: {
        'literal-block-punctuation': {
          pattern: /^(?:::|([!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~])\1*)/m,
          alias: 'punctuation'
        }
      }
    },
    'list-bullet': {
      pattern: /(^\s*)(?:[*+\-•‣⁃]|\(?(?:\d+|[a-z]|[ivxdclm]+)\)|(?:\d+|[a-z]|[ivxdclm]+)\.)(?= )/im,
      lookbehind: true,
      alias: 'punctuation'
    },
    'doctest-block': {
      pattern: /(^\s*)>>> .+(?:(?:\r?\n|\r).+)*/m,
      lookbehind: true,
      inside: {
        punctuation: /^>>>/
      }
    },
    inline: [
      {
        pattern: /(^|[\s\-:\/'"<(\[{])(?::[^:]+:`.*?`|`.*?`:[^:]+:|(\*\*?|``?|\|)(?!\s).*?[^\s]\2(?=[\s\-.,:;!?\\\/'")\]}]|$))/m,
        lookbehind: true,
        inside: {
          bold: {
            pattern: /(^\*\*).+(?=\*\*$)/,
            lookbehind: true
          },
          italic: {
            pattern: /(^\*).+(?=\*$)/,
            lookbehind: true
          },
          'inline-literal': {
            pattern: /(^``).+(?=``$)/,
            lookbehind: true,
            alias: 'symbol'
          },
          role: {
            pattern: /^:[^:]+:|:[^:]+:$/,
            alias: 'function',
            inside: {
              punctuation: /^:|:$/
            }
          },
          'interpreted-text': {
            pattern: /(^`).+(?=`$)/,
            lookbehind: true,
            alias: 'attr-value'
          },
          substitution: {
            pattern: /(^\|).+(?=\|$)/,
            lookbehind: true,
            alias: 'attr-value'
          },
          punctuation: /\*\*?|``?|\|/
        }
      }
    ],
    link: [
      {
        pattern: /\[[^\]]+\]_(?=[\s\-.,:;!?\\\/'")\]}]|$)/,
        alias: 'string',
        inside: {
          punctuation: /^\[|\]_$/
        }
      },
      {
        pattern: /(?:\b[a-z\d](?:[_.:+]?[a-z\d]+)*_?_|`[^`]+`_?_|_`[^`]+`)(?=[\s\-.,:;!?\\\/'")\]}]|$)/i,
        alias: 'string',
        inside: {
          punctuation: /^_?`|`$|`?_?_$/
        }
      }
    ],
    // Line block start,
    // quote attribution,
    // explicit markup start,
    // and anonymous hyperlink target shortcut (__)
    punctuation: {
      pattern: /(^\s*)(?:\|(?= |$)|(?:---?|—|\.\.|__)(?= )|\.\.$)/m,
      lookbehind: true
    }
  }
}


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = rip
rip.displayName = 'rip'
rip.aliases = []
function rip(Prism) {
  Prism.languages.rip = {
    comment: /#.*/,
    keyword: /(?:=>|->)|\b(?:class|if|else|switch|case|return|exit|try|catch|finally|raise)\b/,
    builtin: /@|\bSystem\b/,
    boolean: /\b(?:true|false)\b/,
    date: /\b\d{4}-\d{2}-\d{2}\b/,
    time: /\b\d{2}:\d{2}:\d{2}\b/,
    datetime: /\b\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\b/,
    character: /\B`[^\s`'",.:;#\/\\()<>\[\]{}]\b/,
    regex: {
      pattern: /(^|[^/])\/(?!\/)(\[.+?]|\\.|[^/\\\r\n])+\/(?=\s*($|[\r\n,.;})]))/,
      lookbehind: true,
      greedy: true
    },
    symbol: /:[^\d\s`'",.:;#\/\\()<>\[\]{}][^\s`'",.:;#\/\\()<>\[\]{}]*/,
    string: {
      pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
      greedy: true
    },
    number: /[+-]?(?:(?:\d+\.\d+)|(?:\d+))/,
    punctuation: /(?:\.{2,3})|[`,.:;=\/\\()<>\[\]{}]/,
    reference: /[^\d\s`'",.:;#\/\\()<>\[\]{}][^\s`'",.:;#\/\\()<>\[\]{}]*/
  }
}


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = roboconf
roboconf.displayName = 'roboconf'
roboconf.aliases = []
function roboconf(Prism) {
  Prism.languages.roboconf = {
    comment: /#.*/,
    keyword: {
      pattern: /(^|\s)(?:(?:facet|instance of)(?=[ \t]+[\w-]+[ \t]*\{)|(?:external|import)\b)/,
      lookbehind: true
    },
    component: {
      pattern: /[\w-]+(?=[ \t]*\{)/,
      alias: 'variable'
    },
    property: /[\w.-]+(?=[ \t]*:)/,
    value: {
      pattern: /(=[ \t]*)[^,;]+/,
      lookbehind: true,
      alias: 'attr-value'
    },
    optional: {
      pattern: /\(optional\)/,
      alias: 'builtin'
    },
    wildcard: {
      pattern: /(\.)\*/,
      lookbehind: true,
      alias: 'operator'
    },
    punctuation: /[{},.;:=]/
  }
}


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = rust
rust.displayName = 'rust'
rust.aliases = []
function rust(Prism) {
  /* TODO
Add support for Markdown notation inside doc comments
Add support for nested block comments...
Match closure params even when not followed by dash or brace
Add better support for macro definition
*/
  Prism.languages.rust = {
    comment: [
      {
        pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
        lookbehind: true
      },
      {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: true
      }
    ],
    string: [
      {
        pattern: /b?r(#*)"(?:\\.|(?!"\1)[^\\\r\n])*"\1/,
        greedy: true
      },
      {
        pattern: /b?"(?:\\.|[^\\\r\n"])*"/,
        greedy: true
      }
    ],
    char: {
      pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u{(?:[\da-fA-F]_*){1,6}|.)|[^\\\r\n\t'])'/,
      alias: 'string'
    },
    'lifetime-annotation': {
      pattern: /'[^\s>']+/,
      alias: 'symbol'
    },
    keyword: /\b(?:abstract|alignof|as|be|box|break|const|continue|crate|do|else|enum|extern|false|final|fn|for|if|impl|in|let|loop|match|mod|move|mut|offsetof|once|override|priv|pub|pure|ref|return|sizeof|static|self|struct|super|true|trait|type|typeof|unsafe|unsized|use|virtual|where|while|yield)\b/,
    attribute: {
      pattern: /#!?\[.+?\]/,
      greedy: true,
      alias: 'attr-name'
    },
    function: [
      /\w+(?=\s*\()/,
      // Macros can use parens or brackets
      /\w+!(?=\s*\(|\[)/
    ],
    'macro-rules': {
      pattern: /\w+!/,
      alias: 'function'
    },
    // Hex, oct, bin, dec numbers with visual separators and type suffix
    number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(\d(?:_?\d)*)?\.?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:[iu](?:8|16|32|64)?|f32|f64))?\b/,
    // Closure params should not be confused with bitwise OR |
    'closure-params': {
      pattern: /\|[^|]*\|(?=\s*[{-])/,
      inside: {
        punctuation: /[|:,]/,
        operator: /[&*]/
      }
    },
    punctuation: /[{}[\];(),:]|\.+|->/,
    operator: /[-+*\/%!^]=?|=[=>]?|@|&[&=]?|\|[|=]?|<<?=?|>>?=?/
  }
}


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = sas
sas.displayName = 'sas'
sas.aliases = []
function sas(Prism) {
  Prism.languages.sas = {
    datalines: {
      pattern: /^\s*(?:(?:data)?lines|cards);[\s\S]+?(?:\r?\n|\r);/im,
      alias: 'string',
      inside: {
        keyword: {
          pattern: /^(\s*)(?:(?:data)?lines|cards)/i,
          lookbehind: true
        },
        punctuation: /;/
      }
    },
    comment: [
      {
        pattern: /(^\s*|;\s*)\*.*;/m,
        lookbehind: true
      },
      /\/\*[\s\S]+?\*\//
    ],
    datetime: {
      // '1jan2013'd, '9:25:19pm't, '18jan2003:9:27:05am'dt
      pattern: /'[^']+'(?:dt?|t)\b/i,
      alias: 'number'
    },
    string: {
      pattern: /(["'])(?:\1\1|(?!\1)[\s\S])*\1/,
      greedy: true
    },
    keyword: /\b(?:data|else|format|if|input|proc\s\w+|quit|run|then)\b/i,
    // Decimal (1.2e23), hexadecimal (0c1x)
    number: /\b(?:[\da-f]+x|\d+(?:\.\d+)?(?:e[+-]?\d+)?)/i,
    operator: /\*\*?|\|\|?|!!?|¦¦?|<[>=]?|>[<=]?|[-+\/=&]|[~¬^]=?|\b(?:eq|ne|gt|lt|ge|le|in|not)\b/i,
    punctuation: /[$%@.(){}\[\];,\\]/
  }
}


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = sass
sass.displayName = 'sass'
sass.aliases = []
function sass(Prism) {
  ;(function(Prism) {
    Prism.languages.sass = Prism.languages.extend('css', {
      // Sass comments don't need to be closed, only indented
      comment: {
        pattern: /^([ \t]*)\/[\/*].*(?:(?:\r?\n|\r)\1[ \t]+.+)*/m,
        lookbehind: true
      }
    })
    Prism.languages.insertBefore('sass', 'atrule', {
      // We want to consume the whole line
      'atrule-line': {
        // Includes support for = and + shortcuts
        pattern: /^(?:[ \t]*)[@+=].+/m,
        inside: {
          atrule: /(?:@[\w-]+|[+=])/m
        }
      }
    })
    delete Prism.languages.sass.atrule
    var variable = /\$[-\w]+|#\{\$[-\w]+\}/
    var operator = [
      /[+*\/%]|[=!]=|<=?|>=?|\b(?:and|or|not)\b/,
      {
        pattern: /(\s+)-(?=\s)/,
        lookbehind: true
      }
    ]
    Prism.languages.insertBefore('sass', 'property', {
      // We want to consume the whole line
      'variable-line': {
        pattern: /^[ \t]*\$.+/m,
        inside: {
          punctuation: /:/,
          variable: variable,
          operator: operator
        }
      },
      // We want to consume the whole line
      'property-line': {
        pattern: /^[ \t]*(?:[^:\s]+ *:.*|:[^:\s]+.*)/m,
        inside: {
          property: [
            /[^:\s]+(?=\s*:)/,
            {
              pattern: /(:)[^:\s]+/,
              lookbehind: true
            }
          ],
          punctuation: /:/,
          variable: variable,
          operator: operator,
          important: Prism.languages.sass.important
        }
      }
    })
    delete Prism.languages.sass.property
    delete Prism.languages.sass.important
    // Now that whole lines for other patterns are consumed,
    // what's left should be selectors
    delete Prism.languages.sass.selector
    Prism.languages.insertBefore('sass', 'punctuation', {
      selector: {
        pattern: /([ \t]*)\S(?:,?[^,\r\n]+)*(?:,(?:\r?\n|\r)\1[ \t]+\S(?:,?[^,\r\n]+)*)*/,
        lookbehind: true
      }
    })
  })(Prism)
}


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var refractorJava = __webpack_require__(487)
module.exports = scala
scala.displayName = 'scala'
scala.aliases = []
function scala(Prism) {
  Prism.register(refractorJava)
  Prism.languages.scala = Prism.languages.extend('java', {
    keyword: /<-|=>|\b(?:abstract|case|catch|class|def|do|else|extends|final|finally|for|forSome|if|implicit|import|lazy|match|new|null|object|override|package|private|protected|return|sealed|self|super|this|throw|trait|try|type|val|var|while|with|yield)\b/,
    string: [
      {
        pattern: /"""[\s\S]*?"""/,
        greedy: true
      },
      {
        pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: true
      }
    ],
    builtin: /\b(?:String|Int|Long|Short|Byte|Boolean|Double|Float|Char|Any|AnyRef|AnyVal|Unit|Nothing)\b/,
    number: /\b0x[\da-f]*\.?[\da-f]+|(?:\b\d+\.?\d*|\B\.\d+)(?:e\d+)?[dfl]?/i,
    symbol: /'[^\d\s\\]\w*/
  })
  delete Prism.languages.scala['class-name']
  delete Prism.languages.scala['function']
}


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = scheme
scheme.displayName = 'scheme'
scheme.aliases = []
function scheme(Prism) {
  Prism.languages.scheme = {
    comment: /;.*/,
    string: {
      pattern: /"(?:[^"\\\r\n]|\\.)*"|'[^('\s]*/,
      greedy: true
    },
    keyword: {
      pattern: /(\()(?:define(?:-syntax|-library|-values)?|(?:case-)?lambda|let(?:\*|rec)?(?:-values)?|else|if|cond|begin|delay(?:-force)?|parameterize|guard|set!|(?:quasi-)?quote|syntax-rules)/,
      lookbehind: true
    },
    builtin: {
      pattern: /(\()(?:(?:cons|car|cdr|list|call-with-current-continuation|call\/cc|append|abs|apply|eval)\b|null\?|pair\?|boolean\?|eof-object\?|char\?|procedure\?|number\?|port\?|string\?|vector\?|symbol\?|bytevector\?)/,
      lookbehind: true
    },
    number: {
      pattern: /(\s|[()])[-+]?\d*\.?\d+(?:\s*[-+]\s*\d*\.?\d+i)?\b/,
      lookbehind: true
    },
    boolean: /#[tf]/,
    operator: {
      pattern: /(\()(?:[-+*%\/]|[<>]=?|=>?)/,
      lookbehind: true
    },
    function: {
      pattern: /(\()[^\s()]*(?=\s)/,
      lookbehind: true
    },
    punctuation: /[()]/
  }
}


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = scss
scss.displayName = 'scss'
scss.aliases = []
function scss(Prism) {
  Prism.languages.scss = Prism.languages.extend('css', {
    comment: {
      pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
      lookbehind: true
    },
    atrule: {
      pattern: /@[\w-]+(?:\([^()]+\)|[^(])*?(?=\s+[{;])/,
      inside: {
        rule: /@[\w-]+/
        // See rest below
      }
    },
    // url, compassified
    url: /(?:[-a-z]+-)*url(?=\()/i,
    // CSS selector regex is not appropriate for Sass
    // since there can be lot more things (var, @ directive, nesting..)
    // a selector must start at the end of a property or after a brace (end of other rules or nesting)
    // it can contain some characters that aren't used for defining rules or end of selector, & (parent selector), or interpolated variable
    // the end of a selector is found when there is no rules in it ( {} or {\s}) or if there is a property (because an interpolated var
    // can "pass" as a selector- e.g: proper#{$erty})
    // this one was hard to do, so please be careful if you edit this one :)
    selector: {
      // Initial look-ahead is used to prevent matching of blank selectors
      pattern: /(?=\S)[^@;{}()]?(?:[^@;{}()]|&|#\{\$[-\w]+\})+(?=\s*\{(?:\}|\s|[^}]+[:{][^}]+))/m,
      inside: {
        parent: {
          pattern: /&/,
          alias: 'important'
        },
        placeholder: /%[-\w]+/,
        variable: /\$[-\w]+|#\{\$[-\w]+\}/
      }
    }
  })
  Prism.languages.insertBefore('scss', 'atrule', {
    keyword: [
      /@(?:if|else(?: if)?|for|each|while|import|extend|debug|warn|mixin|include|function|return|content)/i,
      {
        pattern: /( +)(?:from|through)(?= )/,
        lookbehind: true
      }
    ]
  })
  Prism.languages.scss.property = {
    pattern: /(?:[\w-]|\$[-\w]+|#\{\$[-\w]+\})+(?=\s*:)/i,
    inside: {
      variable: /\$[-\w]+|#\{\$[-\w]+\}/
    }
  }
  Prism.languages.insertBefore('scss', 'important', {
    // var and interpolated vars
    variable: /\$[-\w]+|#\{\$[-\w]+\}/
  })
  Prism.languages.insertBefore('scss', 'function', {
    placeholder: {
      pattern: /%[-\w]+/,
      alias: 'selector'
    },
    statement: {
      pattern: /\B!(?:default|optional)\b/i,
      alias: 'keyword'
    },
    boolean: /\b(?:true|false)\b/,
    null: /\bnull\b/,
    operator: {
      pattern: /(\s)(?:[-+*\/%]|[=!]=|<=?|>=?|and|or|not)(?=\s)/,
      lookbehind: true
    }
  })
  Prism.languages.scss['atrule'].inside.rest = Prism.languages.scss
}


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = smalltalk
smalltalk.displayName = 'smalltalk'
smalltalk.aliases = []
function smalltalk(Prism) {
  Prism.languages.smalltalk = {
    comment: /"(?:""|[^"])+"/,
    string: /'(?:''|[^'])+'/,
    symbol: /#[\da-z]+|#(?:-|([+\/\\*~<>=@%|&?!])\1?)|#(?=\()/i,
    'block-arguments': {
      pattern: /(\[\s*):[^\[|]*\|/,
      lookbehind: true,
      inside: {
        variable: /:[\da-z]+/i,
        punctuation: /\|/
      }
    },
    'temporary-variables': {
      pattern: /\|[^|]+\|/,
      inside: {
        variable: /[\da-z]+/i,
        punctuation: /\|/
      }
    },
    keyword: /\b(?:nil|true|false|self|super|new)\b/,
    character: {
      pattern: /\$./,
      alias: 'string'
    },
    number: [
      /\d+r-?[\dA-Z]+(?:\.[\dA-Z]+)?(?:e-?\d+)?/,
      /\b\d+(?:\.\d+)?(?:e-?\d+)?/
    ],
    operator: /[<=]=?|:=|~[~=]|\/\/?|\\\\|>[>=]?|[!^+\-*&|,@]/,
    punctuation: /[.;:?\[\](){}]/
  }
}


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = smarty
smarty.displayName = 'smarty'
smarty.aliases = []
function smarty(Prism) {
  /* TODO
Add support for variables inside double quoted strings
Add support for {php}
*/
  ;(function(Prism) {
    Prism.languages.smarty = {
      comment: /\{\*[\s\S]*?\*\}/,
      delimiter: {
        pattern: /^\{|\}$/i,
        alias: 'punctuation'
      },
      string: /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
      number: /\b0x[\dA-Fa-f]+|(?:\b\d+\.?\d*|\B\.\d+)(?:[Ee][-+]?\d+)?/,
      variable: [
        /\$(?!\d)\w+/,
        /#(?!\d)\w+#/,
        {
          pattern: /(\.|->)(?!\d)\w+/,
          lookbehind: true
        },
        {
          pattern: /(\[)(?!\d)\w+(?=\])/,
          lookbehind: true
        }
      ],
      function: [
        {
          pattern: /(\|\s*)@?(?!\d)\w+/,
          lookbehind: true
        },
        /^\/?(?!\d)\w+/,
        /(?!\d)\w+(?=\()/
      ],
      'attr-name': {
        // Value is made optional because it may have already been tokenized
        pattern: /\w+\s*=\s*(?:(?!\d)\w+)?/,
        inside: {
          variable: {
            pattern: /(=\s*)(?!\d)\w+/,
            lookbehind: true
          },
          operator: /=/
        }
      },
      punctuation: [/[\[\]().,:`]|->/],
      operator: [
        /[+\-*\/%]|==?=?|[!<>]=?|&&|\|\|?/,
        /\bis\s+(?:not\s+)?(?:div|even|odd)(?:\s+by)?\b/,
        /\b(?:eq|neq?|gt|lt|gt?e|lt?e|not|mod|or|and)\b/
      ],
      keyword: /\b(?:false|off|on|no|true|yes)\b/
    }
    // Comments are inserted at top so that they can
    // surround markup
    Prism.languages.insertBefore('smarty', 'tag', {
      'smarty-comment': {
        pattern: /\{\*[\s\S]*?\*\}/,
        alias: ['smarty', 'comment']
      }
    })
    // Tokenize all inline Smarty expressions
    Prism.hooks.add('before-tokenize', function(env) {
      var smartyPattern = /\{\*[\s\S]*?\*\}|\{[\s\S]+?\}/g
      var smartyLitteralStart = '{literal}'
      var smartyLitteralEnd = '{/literal}'
      var smartyLitteralMode = false
      Prism.languages['markup-templating'].buildPlaceholders(
        env,
        'smarty',
        smartyPattern,
        function(match) {
          // Smarty tags inside {literal} block are ignored
          if (match === smartyLitteralEnd) {
            smartyLitteralMode = false
          }
          if (!smartyLitteralMode) {
            if (match === smartyLitteralStart) {
              smartyLitteralMode = true
            }
            return true
          }
          return false
        }
      )
    })
    // Re-insert the tokens after tokenizing
    Prism.hooks.add('after-tokenize', function(env) {
      Prism.languages['markup-templating'].tokenizePlaceholders(env, 'smarty')
    })
  })(Prism)
}


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = soy
soy.displayName = 'soy'
soy.aliases = []
function soy(Prism) {
  ;(function(Prism) {
    var stringPattern = /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/
    var numberPattern = /\b\d+(?:\.\d+)?(?:[eE][+-]?\d+)?\b|\b0x[\dA-F]+\b/
    Prism.languages.soy = {
      comment: [
        /\/\*[\s\S]*?\*\//,
        {
          pattern: /(\s)\/\/.*/,
          lookbehind: true,
          greedy: true
        }
      ],
      'command-arg': {
        pattern: /({+\/?\s*(?:alias|call|delcall|delpackage|deltemplate|namespace|template)\s+)\.?[\w.]+/,
        lookbehind: true,
        alias: 'string',
        inside: {
          punctuation: /\./
        }
      },
      parameter: {
        pattern: /({+\/?\s*@?param\??\s+)\.?[\w.]+/,
        lookbehind: true,
        alias: 'variable'
      },
      keyword: [
        {
          pattern: /({+\/?[^\S\r\n]*)(?:\\[nrt]|alias|call|case|css|default|delcall|delpackage|deltemplate|else(?:if)?|fallbackmsg|for(?:each)?|if(?:empty)?|lb|let|literal|msg|namespace|nil|@?param\??|rb|sp|switch|template|xid)/,
          lookbehind: true
        },
        /\b(?:any|as|attributes|bool|css|float|in|int|js|html|list|map|null|number|string|uri)\b/
      ],
      delimiter: {
        pattern: /^{+\/?|\/?}+$/,
        alias: 'punctuation'
      },
      property: /\w+(?==)/,
      variable: {
        pattern: /\$[^\W\d]\w*(?:\??(?:\.\w+|\[[^\]]+]))*/,
        inside: {
          string: {
            pattern: stringPattern,
            greedy: true
          },
          number: numberPattern,
          punctuation: /[\[\].?]/
        }
      },
      string: {
        pattern: stringPattern,
        greedy: true
      },
      function: [
        /\w+(?=\()/,
        {
          pattern: /(\|[^\S\r\n]*)\w+/,
          lookbehind: true
        }
      ],
      boolean: /\b(?:true|false)\b/,
      number: numberPattern,
      operator: /\?:?|<=?|>=?|==?|!=|[+*/%-]|\b(?:and|not|or)\b/,
      punctuation: /[{}()\[\]|.,:]/
    }
    // Tokenize all inline Soy expressions
    Prism.hooks.add('before-tokenize', function(env) {
      var soyPattern = /{{.+?}}|{.+?}|\s\/\/.*|\/\*[\s\S]*?\*\//g
      var soyLitteralStart = '{literal}'
      var soyLitteralEnd = '{/literal}'
      var soyLitteralMode = false
      Prism.languages['markup-templating'].buildPlaceholders(
        env,
        'soy',
        soyPattern,
        function(match) {
          // Soy tags inside {literal} block are ignored
          if (match === soyLitteralEnd) {
            soyLitteralMode = false
          }
          if (!soyLitteralMode) {
            if (match === soyLitteralStart) {
              soyLitteralMode = true
            }
            return true
          }
          return false
        }
      )
    })
    // Re-insert the tokens after tokenizing
    Prism.hooks.add('after-tokenize', function(env) {
      Prism.languages['markup-templating'].tokenizePlaceholders(env, 'soy')
    })
  })(Prism)
}


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = stylus
stylus.displayName = 'stylus'
stylus.aliases = []
function stylus(Prism) {
  ;(function(Prism) {
    var inside = {
      url: /url\((["']?).*?\1\)/i,
      string: {
        pattern: /("|')(?:(?!\1)[^\\\r\n]|\\(?:\r\n|[\s\S]))*\1/,
        greedy: true
      },
      interpolation: null, // See below
      func: null, // See below
      important: /\B!(?:important|optional)\b/i,
      keyword: {
        pattern: /(^|\s+)(?:(?:if|else|for|return|unless)(?=\s+|$)|@[\w-]+)/,
        lookbehind: true
      },
      hexcode: /#[\da-f]{3,6}/i,
      number: /\b\d+(?:\.\d+)?%?/,
      boolean: /\b(?:true|false)\b/,
      operator: [
        // We want non-word chars around "-" because it is
        // accepted in property names.
        /~|[+!\/%<>?=]=?|[-:]=|\*[*=]?|\.+|&&|\|\||\B-\B|\b(?:and|in|is(?: a| defined| not|nt)?|not|or)\b/
      ],
      punctuation: /[{}()\[\];:,]/
    }
    inside['interpolation'] = {
      pattern: /\{[^\r\n}:]+\}/,
      alias: 'variable',
      inside: {
        delimiter: {
          pattern: /^{|}$/,
          alias: 'punctuation'
        },
        rest: inside
      }
    }
    inside['func'] = {
      pattern: /[\w-]+\([^)]*\).*/,
      inside: {
        function: /^[^(]+/,
        rest: inside
      }
    }
    Prism.languages.stylus = {
      comment: {
        pattern: /(^|[^\\])(\/\*[\s\S]*?\*\/|\/\/.*)/,
        lookbehind: true
      },
      'atrule-declaration': {
        pattern: /(^\s*)@.+/m,
        lookbehind: true,
        inside: {
          atrule: /^@[\w-]+/,
          rest: inside
        }
      },
      'variable-declaration': {
        pattern: /(^[ \t]*)[\w$-]+\s*.?=[ \t]*(?:(?:\{[^}]*\}|.+)|$)/m,
        lookbehind: true,
        inside: {
          variable: /^\S+/,
          rest: inside
        }
      },
      statement: {
        pattern: /(^[ \t]*)(?:if|else|for|return|unless)[ \t]+.+/m,
        lookbehind: true,
        inside: {
          keyword: /^\S+/,
          rest: inside
        }
      },
      // A property/value pair cannot end with a comma or a brace
      // It cannot have indented content unless it ended with a semicolon
      'property-declaration': {
        pattern: /((?:^|\{)([ \t]*))(?:[\w-]|\{[^}\r\n]+\})+(?:\s*:\s*|[ \t]+)[^{\r\n]*(?:;|[^{\r\n,](?=$)(?!(\r?\n|\r)(?:\{|\2[ \t]+)))/m,
        lookbehind: true,
        inside: {
          property: {
            pattern: /^[^\s:]+/,
            inside: {
              interpolation: inside.interpolation
            }
          },
          rest: inside
        }
      },
      // A selector can contain parentheses only as part of a pseudo-element
      // It can span multiple lines.
      // It must end with a comma or an accolade or have indented content.
      selector: {
        pattern: /(^[ \t]*)(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\))?|\{[^}\r\n]+\})+)(?:(?:\r?\n|\r)(?:\1(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\))?|\{[^}\r\n]+\})+)))*(?:,$|\{|(?=(?:\r?\n|\r)(?:\{|\1[ \t]+)))/m,
        lookbehind: true,
        inside: {
          interpolation: inside.interpolation,
          punctuation: /[{},]/
        }
      },
      func: inside.func,
      string: inside.string,
      interpolation: inside.interpolation,
      punctuation: /[{}()\[\];:.]/
    }
  })(Prism)
}


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = swift
swift.displayName = 'swift'
swift.aliases = []
function swift(Prism) {
  // issues: nested multiline comments
  Prism.languages.swift = Prism.languages.extend('clike', {
    string: {
      pattern: /("|')(\\(?:\((?:[^()]|\([^)]+\))+\)|\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: true,
      inside: {
        interpolation: {
          pattern: /\\\((?:[^()]|\([^)]+\))+\)/,
          inside: {
            delimiter: {
              pattern: /^\\\(|\)$/,
              alias: 'variable'
              // See rest below
            }
          }
        }
      }
    },
    keyword: /\b(?:as|associativity|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic(?:Type)?|else|enum|extension|fallthrough|final|for|func|get|guard|if|import|in|infix|init|inout|internal|is|lazy|left|let|mutating|new|none|nonmutating|operator|optional|override|postfix|precedence|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|Self|set|static|struct|subscript|super|switch|throws?|try|Type|typealias|unowned|unsafe|var|weak|where|while|willSet|__(?:COLUMN__|FILE__|FUNCTION__|LINE__))\b/,
    number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
    constant: /\b(?:nil|[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
    atrule: /@\b(?:IB(?:Outlet|Designable|Action|Inspectable)|class_protocol|exported|noreturn|NS(?:Copying|Managed)|objc|UIApplicationMain|auto_closure)\b/,
    builtin: /\b(?:[A-Z]\S+|abs|advance|alignof(?:Value)?|assert|contains|count(?:Elements)?|debugPrint(?:ln)?|distance|drop(?:First|Last)|dump|enumerate|equal|filter|find|first|getVaList|indices|isEmpty|join|last|lexicographicalCompare|map|max(?:Element)?|min(?:Element)?|numericCast|overlaps|partition|print(?:ln)?|reduce|reflect|reverse|sizeof(?:Value)?|sort(?:ed)?|split|startsWith|stride(?:of(?:Value)?)?|suffix|swap|toDebugString|toString|transcode|underestimateCount|unsafeBitCast|with(?:ExtendedLifetime|Unsafe(?:MutablePointers?|Pointers?)|VaList))\b/
  })
  Prism.languages.swift['string'].inside['interpolation'].inside.rest =
    Prism.languages.swift
}


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = tap
tap.displayName = 'tap'
tap.aliases = []
function tap(Prism) {
  Prism.languages.tap = {
    fail: /not ok[^#{\n\r]*/,
    pass: /ok[^#{\n\r]*/,
    pragma: /pragma [+-][a-z]+/,
    bailout: /bail out!.*/i,
    version: /TAP version \d+/i,
    plan: /\d+\.\.\d+(?: +#.*)?/,
    subtest: {
      pattern: /# Subtest(?:: .*)?/,
      greedy: true
    },
    punctuation: /[{}]/,
    directive: /#.*/,
    yamlish: {
      pattern: /(^[^\S\r\n]*)---(?:\r\n?|\n)(?:.*(?:\r\n?|\n))*?[^\S\r\n]*\.\.\.$/m,
      lookbehind: true,
      inside: Prism.languages.yaml,
      alias: 'language-yaml'
    }
  }
}


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = tcl
tcl.displayName = 'tcl'
tcl.aliases = []
function tcl(Prism) {
  Prism.languages.tcl = {
    comment: {
      pattern: /(^|[^\\])#.*/,
      lookbehind: true
    },
    string: {
      pattern: /"(?:[^"\\\r\n]|\\(?:\r\n|[\s\S]))*"/,
      greedy: true
    },
    variable: [
      {
        pattern: /(\$)(?:::)?(?:[a-zA-Z0-9]+::)*\w+/,
        lookbehind: true
      },
      {
        pattern: /(\$){[^}]+}/,
        lookbehind: true
      },
      {
        pattern: /(^\s*set[ \t]+)(?:::)?(?:[a-zA-Z0-9]+::)*\w+/m,
        lookbehind: true
      }
    ],
    function: {
      pattern: /(^\s*proc[ \t]+)[^\s]+/m,
      lookbehind: true
    },
    builtin: [
      {
        pattern: /(^\s*)(?:proc|return|class|error|eval|exit|for|foreach|if|switch|while|break|continue)\b/m,
        lookbehind: true
      },
      /\b(?:elseif|else)\b/
    ],
    scope: {
      pattern: /(^\s*)(?:global|upvar|variable)\b/m,
      lookbehind: true,
      alias: 'constant'
    },
    keyword: {
      pattern: /(^\s*|\[)(?:after|append|apply|array|auto_(?:execok|import|load|mkindex|qualify|reset)|automkindex_old|bgerror|binary|catch|cd|chan|clock|close|concat|dde|dict|encoding|eof|exec|expr|fblocked|fconfigure|fcopy|file(?:event|name)?|flush|gets|glob|history|http|incr|info|interp|join|lappend|lassign|lindex|linsert|list|llength|load|lrange|lrepeat|lreplace|lreverse|lsearch|lset|lsort|math(?:func|op)|memory|msgcat|namespace|open|package|parray|pid|pkg_mkIndex|platform|puts|pwd|re_syntax|read|refchan|regexp|registry|regsub|rename|Safe_Base|scan|seek|set|socket|source|split|string|subst|Tcl|tcl(?:_endOfWord|_findLibrary|startOf(?:Next|Previous)Word|wordBreak(?:After|Before)|test|vars)|tell|time|tm|trace|unknown|unload|unset|update|uplevel|vwait)\b/m,
      lookbehind: true
    },
    operator: /!=?|\*\*?|==|&&?|\|\|?|<[=<]?|>[=>]?|[-+~\/%?^]|\b(?:eq|ne|in|ni)\b/,
    punctuation: /[{}()\[\]]/
  }
}


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = textile
textile.displayName = 'textile'
textile.aliases = []
function textile(Prism) {
  ;(function(Prism) {
    // We don't allow for pipes inside parentheses
    // to not break table pattern |(. foo |). bar |
    var modifierRegex = '(?:\\([^|)]+\\)|\\[[^\\]]+\\]|\\{[^}]+\\})+'
    var modifierTokens = {
      css: {
        pattern: /\{[^}]+\}/,
        inside: {
          rest: Prism.languages.css
        }
      },
      'class-id': {
        pattern: /(\()[^)]+(?=\))/,
        lookbehind: true,
        alias: 'attr-value'
      },
      lang: {
        pattern: /(\[)[^\]]+(?=\])/,
        lookbehind: true,
        alias: 'attr-value'
      },
      // Anything else is punctuation (the first pattern is for row/col spans inside tables)
      punctuation: /[\\\/]\d+|\S/
    }
    Prism.languages.textile = Prism.languages.extend('markup', {
      phrase: {
        pattern: /(^|\r|\n)\S[\s\S]*?(?=$|\r?\n\r?\n|\r\r)/,
        lookbehind: true,
        inside: {
          // h1. Header 1
          'block-tag': {
            pattern: RegExp('^[a-z]\\w*(?:' + modifierRegex + '|[<>=()])*\\.'),
            inside: {
              modifier: {
                pattern: RegExp(
                  '(^[a-z]\\w*)(?:' + modifierRegex + '|[<>=()])+(?=\\.)'
                ),
                lookbehind: true,
                inside: modifierTokens
              },
              tag: /^[a-z]\w*/,
              punctuation: /\.$/
            }
          },
          // # List item
          // * List item
          list: {
            pattern: RegExp('^[*#]+(?:' + modifierRegex + ')?\\s+.+', 'm'),
            inside: {
              modifier: {
                pattern: RegExp('(^[*#]+)' + modifierRegex),
                lookbehind: true,
                inside: modifierTokens
              },
              punctuation: /^[*#]+/
            }
          },
          // | cell | cell | cell |
          table: {
            // Modifiers can be applied to the row: {color:red}.|1|2|3|
            // or the cell: |{color:red}.1|2|3|
            pattern: RegExp(
              '^(?:(?:' +
                modifierRegex +
                '|[<>=()^~])+\\.\\s*)?(?:\\|(?:(?:' +
                modifierRegex +
                '|[<>=()^~_]|[\\\\/]\\d+)+\\.)?[^|]*)+\\|',
              'm'
            ),
            inside: {
              modifier: {
                // Modifiers for rows after the first one are
                // preceded by a pipe and a line feed
                pattern: RegExp(
                  '(^|\\|(?:\\r?\\n|\\r)?)(?:' +
                    modifierRegex +
                    '|[<>=()^~_]|[\\\\/]\\d+)+(?=\\.)'
                ),
                lookbehind: true,
                inside: modifierTokens
              },
              punctuation: /\||^\./
            }
          },
          inline: {
            pattern: RegExp(
              '(\\*\\*|__|\\?\\?|[*_%@+\\-^~])(?:' + modifierRegex + ')?.+?\\1'
            ),
            inside: {
              // Note: superscripts and subscripts are not handled specifically
              // *bold*, **bold**
              bold: {
                pattern: RegExp(
                  '(^(\\*\\*?)(?:' + modifierRegex + ')?).+?(?=\\2)'
                ),
                lookbehind: true
              },
              // _italic_, __italic__
              italic: {
                pattern: RegExp('(^(__?)(?:' + modifierRegex + ')?).+?(?=\\2)'),
                lookbehind: true
              },
              // ??cite??
              cite: {
                pattern: RegExp(
                  '(^\\?\\?(?:' + modifierRegex + ')?).+?(?=\\?\\?)'
                ),
                lookbehind: true,
                alias: 'string'
              },
              // @code@
              code: {
                pattern: RegExp('(^@(?:' + modifierRegex + ')?).+?(?=@)'),
                lookbehind: true,
                alias: 'keyword'
              },
              // +inserted+
              inserted: {
                pattern: RegExp('(^\\+(?:' + modifierRegex + ')?).+?(?=\\+)'),
                lookbehind: true
              },
              // -deleted-
              deleted: {
                pattern: RegExp('(^-(?:' + modifierRegex + ')?).+?(?=-)'),
                lookbehind: true
              },
              // %span%
              span: {
                pattern: RegExp('(^%(?:' + modifierRegex + ')?).+?(?=%)'),
                lookbehind: true
              },
              modifier: {
                pattern: RegExp(
                  '(^\\*\\*|__|\\?\\?|[*_%@+\\-^~])' + modifierRegex
                ),
                lookbehind: true,
                inside: modifierTokens
              },
              punctuation: /[*_%?@+\-^~]+/
            }
          },
          // [alias]http://example.com
          'link-ref': {
            pattern: /^\[[^\]]+\]\S+$/m,
            inside: {
              string: {
                pattern: /(\[)[^\]]+(?=\])/,
                lookbehind: true
              },
              url: {
                pattern: /(\])\S+$/,
                lookbehind: true
              },
              punctuation: /[\[\]]/
            }
          },
          // "text":http://example.com
          // "text":link-ref
          link: {
            pattern: RegExp(
              '"(?:' + modifierRegex + ')?[^"]+":.+?(?=[^\\w/]?(?:\\s|$))'
            ),
            inside: {
              text: {
                pattern: RegExp('(^"(?:' + modifierRegex + ')?)[^"]+(?=")'),
                lookbehind: true
              },
              modifier: {
                pattern: RegExp('(^")' + modifierRegex),
                lookbehind: true,
                inside: modifierTokens
              },
              url: {
                pattern: /(:).+/,
                lookbehind: true
              },
              punctuation: /[":]/
            }
          },
          // !image.jpg!
          // !image.jpg(Title)!:http://example.com
          image: {
            pattern: RegExp(
              '!(?:' +
                modifierRegex +
                '|[<>=()])*[^!\\s()]+(?:\\([^)]+\\))?!(?::.+?(?=[^\\w/]?(?:\\s|$)))?'
            ),
            inside: {
              source: {
                pattern: RegExp(
                  '(^!(?:' +
                    modifierRegex +
                    '|[<>=()])*)[^!\\s()]+(?:\\([^)]+\\))?(?=!)'
                ),
                lookbehind: true,
                alias: 'url'
              },
              modifier: {
                pattern: RegExp('(^!)(?:' + modifierRegex + '|[<>=()])+'),
                lookbehind: true,
                inside: modifierTokens
              },
              url: {
                pattern: /(:).+/,
                lookbehind: true
              },
              punctuation: /[!:]/
            }
          },
          // Footnote[1]
          footnote: {
            pattern: /\b\[\d+\]/,
            alias: 'comment',
            inside: {
              punctuation: /\[|\]/
            }
          },
          // CSS(Cascading Style Sheet)
          acronym: {
            pattern: /\b[A-Z\d]+\([^)]+\)/,
            inside: {
              comment: {
                pattern: /(\()[^)]+(?=\))/,
                lookbehind: true
              },
              punctuation: /[()]/
            }
          },
          // Prism(C)
          mark: {
            pattern: /\b\((?:TM|R|C)\)/,
            alias: 'comment',
            inside: {
              punctuation: /[()]/
            }
          }
        }
      }
    })
    var nestedPatterns = {
      inline: Prism.languages.textile['phrase'].inside['inline'],
      link: Prism.languages.textile['phrase'].inside['link'],
      image: Prism.languages.textile['phrase'].inside['image'],
      footnote: Prism.languages.textile['phrase'].inside['footnote'],
      acronym: Prism.languages.textile['phrase'].inside['acronym'],
      mark: Prism.languages.textile['phrase'].inside['mark']
    }
    // Only allow alpha-numeric HTML tags, not XML tags
    Prism.languages.textile.tag.pattern = /<\/?(?!\d)[a-z0-9]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/i
    // Allow some nesting
    Prism.languages.textile['phrase'].inside['inline'].inside[
      'bold'
    ].inside = nestedPatterns
    Prism.languages.textile['phrase'].inside['inline'].inside[
      'italic'
    ].inside = nestedPatterns
    Prism.languages.textile['phrase'].inside['inline'].inside[
      'inserted'
    ].inside = nestedPatterns
    Prism.languages.textile['phrase'].inside['inline'].inside[
      'deleted'
    ].inside = nestedPatterns
    Prism.languages.textile['phrase'].inside['inline'].inside[
      'span'
    ].inside = nestedPatterns
    // Allow some styles inside table cells
    Prism.languages.textile['phrase'].inside['table'].inside['inline'] =
      nestedPatterns['inline']
    Prism.languages.textile['phrase'].inside['table'].inside['link'] =
      nestedPatterns['link']
    Prism.languages.textile['phrase'].inside['table'].inside['image'] =
      nestedPatterns['image']
    Prism.languages.textile['phrase'].inside['table'].inside['footnote'] =
      nestedPatterns['footnote']
    Prism.languages.textile['phrase'].inside['table'].inside['acronym'] =
      nestedPatterns['acronym']
    Prism.languages.textile['phrase'].inside['table'].inside['mark'] =
      nestedPatterns['mark']
  })(Prism)
}


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var refractorJsx = __webpack_require__(488)
var refractorTypescript = __webpack_require__(491)
module.exports = tsx
tsx.displayName = 'tsx'
tsx.aliases = []
function tsx(Prism) {
  Prism.register(refractorJsx)
  Prism.register(refractorTypescript)
  var typescript = Prism.util.clone(Prism.languages.typescript)
  Prism.languages.tsx = Prism.languages.extend('jsx', typescript)
}


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = tt2
tt2.displayName = 'tt2'
tt2.aliases = []
function tt2(Prism) {
  ;(function(Prism) {
    Prism.languages.tt2 = Prism.languages.extend('clike', {
      comment: {
        pattern: /#.*|\[%#[\s\S]*?%\]/,
        lookbehind: true
      },
      keyword: /\b(?:BLOCK|CALL|CASE|CATCH|CLEAR|DEBUG|DEFAULT|ELSE|ELSIF|END|FILTER|FINAL|FOREACH|GET|IF|IN|INCLUDE|INSERT|LAST|MACRO|META|NEXT|PERL|PROCESS|RAWPERL|RETURN|SET|STOP|TAGS|THROW|TRY|SWITCH|UNLESS|USE|WHILE|WRAPPER)\b/,
      punctuation: /[[\]{},()]/
    })
    delete Prism.languages.tt2['operator']
    delete Prism.languages.tt2['variable']
    Prism.languages.insertBefore('tt2', 'number', {
      operator: /=[>=]?|!=?|<=?|>=?|&&|\|\|?|\b(?:and|or|not)\b/,
      variable: {
        pattern: /[a-z]\w*(?:\s*\.\s*(?:\d+|\$?[a-z]\w*))*/i
      }
    })
    delete Prism.languages.tt2['delimiter']
    Prism.languages.insertBefore('tt2', 'keyword', {
      delimiter: {
        pattern: /^(?:\[%|%%)-?|-?%]$/,
        alias: 'punctuation'
      }
    })
    Prism.languages.insertBefore('tt2', 'string', {
      'single-quoted-string': {
        pattern: /'[^\\']*(?:\\[\s\S][^\\']*)*'/,
        greedy: true,
        alias: 'string'
      },
      'double-quoted-string': {
        pattern: /"[^\\"]*(?:\\[\s\S][^\\"]*)*"/,
        greedy: true,
        alias: 'string',
        inside: {
          variable: {
            pattern: /\$(?:[a-z]\w*(?:\.(?:\d+|\$?[a-z]\w*))*)/i
          }
        }
      }
    })
    // The different types of TT2 strings "replace" the C-like standard string
    delete Prism.languages.tt2.string
    Prism.hooks.add('before-tokenize', function(env) {
      var tt2Pattern = /\[%[\s\S]+?%\]/g
      Prism.languages['markup-templating'].buildPlaceholders(
        env,
        'tt2',
        tt2Pattern
      )
    })
    Prism.hooks.add('after-tokenize', function(env) {
      Prism.languages['markup-templating'].tokenizePlaceholders(env, 'tt2')
    })
  })(Prism)
}


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = twig
twig.displayName = 'twig'
twig.aliases = []
function twig(Prism) {
  Prism.languages.twig = {
    comment: /\{#[\s\S]*?#\}/,
    tag: {
      pattern: /\{\{[\s\S]*?\}\}|\{%[\s\S]*?%\}/,
      inside: {
        ld: {
          pattern: /^(?:\{\{-?|\{%-?\s*\w+)/,
          inside: {
            punctuation: /^(?:\{\{|\{%)-?/,
            keyword: /\w+/
          }
        },
        rd: {
          pattern: /-?(?:%\}|\}\})$/,
          inside: {
            punctuation: /.*/
          }
        },
        string: {
          pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
          inside: {
            punctuation: /^['"]|['"]$/
          }
        },
        keyword: /\b(?:even|if|odd)\b/,
        boolean: /\b(?:true|false|null)\b/,
        number: /\b0x[\dA-Fa-f]+|(?:\b\d+\.?\d*|\B\.\d+)(?:[Ee][-+]?\d+)?/,
        operator: [
          {
            pattern: /(\s)(?:and|b-and|b-xor|b-or|ends with|in|is|matches|not|or|same as|starts with)(?=\s)/,
            lookbehind: true
          },
          /[=<>]=?|!=|\*\*?|\/\/?|\?:?|[-+~%|]/
        ],
        property: /\b[a-zA-Z_]\w*\b/,
        punctuation: /[()\[\]{}:.,]/
      }
    },
    // The rest can be parsed as HTML
    other: {
      // We want non-blank matches
      pattern: /\S(?:[\s\S]*\S)?/,
      inside: Prism.languages.markup
    }
  }
}


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var refractorBasic = __webpack_require__(486)
module.exports = vbnet
vbnet.displayName = 'vbnet'
vbnet.aliases = []
function vbnet(Prism) {
  Prism.register(refractorBasic)
  Prism.languages.vbnet = Prism.languages.extend('basic', {
    keyword: /(?:\b(?:ADDHANDLER|ADDRESSOF|ALIAS|AND|ANDALSO|AS|BEEP|BLOAD|BOOLEAN|BSAVE|BYREF|BYTE|BYVAL|CALL(?: ABSOLUTE)?|CASE|CATCH|CBOOL|CBYTE|CCHAR|CDATE|CDEC|CDBL|CHAIN|CHAR|CHDIR|CINT|CLASS|CLEAR|CLNG|CLOSE|CLS|COBJ|COM|COMMON|CONST|CONTINUE|CSBYTE|CSHORT|CSNG|CSTR|CTYPE|CUINT|CULNG|CUSHORT|DATA|DATE|DECIMAL|DECLARE|DEFAULT|DEF(?: FN| SEG|DBL|INT|LNG|SNG|STR)|DELEGATE|DIM|DIRECTCAST|DO|DOUBLE|ELSE|ELSEIF|END|ENUM|ENVIRON|ERASE|ERROR|EVENT|EXIT|FALSE|FIELD|FILES|FINALLY|FOR(?: EACH)?|FRIEND|FUNCTION|GET|GETTYPE|GETXMLNAMESPACE|GLOBAL|GOSUB|GOTO|HANDLES|IF|IMPLEMENTS|IMPORTS|IN|INHERITS|INPUT|INTEGER|INTERFACE|IOCTL|IS|ISNOT|KEY|KILL|LINE INPUT|LET|LIB|LIKE|LOCATE|LOCK|LONG|LOOP|LSET|ME|MKDIR|MOD|MODULE|MUSTINHERIT|MUSTOVERRIDE|MYBASE|MYCLASS|NAME|NAMESPACE|NARROWING|NEW|NEXT|NOT|NOTHING|NOTINHERITABLE|NOTOVERRIDABLE|OBJECT|OF|OFF|ON(?: COM| ERROR| KEY| TIMER)?|OPERATOR|OPEN|OPTION(?: BASE)?|OPTIONAL|OR|ORELSE|OUT|OVERLOADS|OVERRIDABLE|OVERRIDES|PARAMARRAY|PARTIAL|POKE|PRIVATE|PROPERTY|PROTECTED|PUBLIC|PUT|RAISEEVENT|READ|READONLY|REDIM|REM|REMOVEHANDLER|RESTORE|RESUME|RETURN|RMDIR|RSET|RUN|SBYTE|SELECT(?: CASE)?|SET|SHADOWS|SHARED|SHORT|SINGLE|SHELL|SLEEP|STATIC|STEP|STOP|STRING|STRUCTURE|SUB|SYNCLOCK|SWAP|SYSTEM|THEN|THROW|TIMER|TO|TROFF|TRON|TRUE|TRY|TRYCAST|TYPE|TYPEOF|UINTEGER|ULONG|UNLOCK|UNTIL|USHORT|USING|VIEW PRINT|WAIT|WEND|WHEN|WHILE|WIDENING|WITH|WITHEVENTS|WRITE|WRITEONLY|XOR)|\B(?:#CONST|#ELSE|#ELSEIF|#END|#IF))(?:\$|\b)/i,
    comment: [
      {
        pattern: /(?:!|REM\b).+/i,
        inside: {
          keyword: /^REM/i
        }
      },
      {
        pattern: /(^|[^\\:])'.*/,
        lookbehind: true
      }
    ]
  })
}


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = velocity
velocity.displayName = 'velocity'
velocity.aliases = []
function velocity(Prism) {
  ;(function(Prism) {
    Prism.languages.velocity = Prism.languages.extend('markup', {})
    var velocity = {
      variable: {
        pattern: /(^|[^\\](?:\\\\)*)\$!?(?:[a-z][\w-]*(?:\([^)]*\))?(?:\.[a-z][\w-]*(?:\([^)]*\))?|\[[^\]]+])*|{[^}]+})/i,
        lookbehind: true,
        inside: {} // See below
      },
      string: {
        pattern: /"[^"]*"|'[^']*'/,
        greedy: true
      },
      number: /\b\d+\b/,
      boolean: /\b(?:true|false)\b/,
      operator: /[=!<>]=?|[+*/%-]|&&|\|\||\.\.|\b(?:eq|g[et]|l[et]|n(?:e|ot))\b/,
      punctuation: /[(){}[\]:,.]/
    }
    velocity.variable.inside = {
      string: velocity['string'],
      function: {
        pattern: /([^\w-])[a-z][\w-]*(?=\()/,
        lookbehind: true
      },
      number: velocity['number'],
      boolean: velocity['boolean'],
      punctuation: velocity['punctuation']
    }
    Prism.languages.insertBefore('velocity', 'comment', {
      unparsed: {
        pattern: /(^|[^\\])#\[\[[\s\S]*?]]#/,
        lookbehind: true,
        greedy: true,
        inside: {
          punctuation: /^#\[\[|]]#$/
        }
      },
      'velocity-comment': [
        {
          pattern: /(^|[^\\])#\*[\s\S]*?\*#/,
          lookbehind: true,
          greedy: true,
          alias: 'comment'
        },
        {
          pattern: /(^|[^\\])##.*/,
          lookbehind: true,
          greedy: true,
          alias: 'comment'
        }
      ],
      directive: {
        pattern: /(^|[^\\](?:\\\\)*)#@?(?:[a-z][\w-]*|{[a-z][\w-]*})(?:\s*\((?:[^()]|\([^()]*\))*\))?/i,
        lookbehind: true,
        inside: {
          keyword: {
            pattern: /^#@?(?:[a-z][\w-]*|{[a-z][\w-]*})|\bin\b/,
            inside: {
              punctuation: /[{}]/
            }
          },
          rest: velocity
        }
      },
      variable: velocity['variable']
    })
    Prism.languages.velocity['tag'].inside['attr-value'].inside.rest =
      Prism.languages.velocity
  })(Prism)
}


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = verilog
verilog.displayName = 'verilog'
verilog.aliases = []
function verilog(Prism) {
  Prism.languages.verilog = {
    comment: /\/\/.*|\/\*[\s\S]*?\*\//,
    string: {
      pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
      greedy: true
    },
    // support for any kernel function (ex: $display())
    property: /\B\$\w+\b/,
    // support for user defined constants (ex: `define)
    constant: /\B`\w+\b/,
    function: /\w+(?=\()/,
    // support for verilog and system verilog keywords
    keyword: /\b(?:alias|and|assert|assign|assume|automatic|before|begin|bind|bins|binsof|bit|break|buf|bufif0|bufif1|byte|class|case|casex|casez|cell|chandle|clocking|cmos|config|const|constraint|context|continue|cover|covergroup|coverpoint|cross|deassign|default|defparam|design|disable|dist|do|edge|else|end|endcase|endclass|endclocking|endconfig|endfunction|endgenerate|endgroup|endinterface|endmodule|endpackage|endprimitive|endprogram|endproperty|endspecify|endsequence|endtable|endtask|enum|event|expect|export|extends|extern|final|first_match|for|force|foreach|forever|fork|forkjoin|function|generate|genvar|highz0|highz1|if|iff|ifnone|ignore_bins|illegal_bins|import|incdir|include|initial|inout|input|inside|instance|int|integer|interface|intersect|join|join_any|join_none|large|liblist|library|local|localparam|logic|longint|macromodule|matches|medium|modport|module|nand|negedge|new|nmos|nor|noshowcancelled|not|notif0|notif1|null|or|output|package|packed|parameter|pmos|posedge|primitive|priority|program|property|protected|pull0|pull1|pulldown|pullup|pulsestyle_onevent|pulsestyle_ondetect|pure|rand|randc|randcase|randsequence|rcmos|real|realtime|ref|reg|release|repeat|return|rnmos|rpmos|rtran|rtranif0|rtranif1|scalared|sequence|shortint|shortreal|showcancelled|signed|small|solve|specify|specparam|static|string|strong0|strong1|struct|super|supply0|supply1|table|tagged|task|this|throughout|time|timeprecision|timeunit|tran|tranif0|tranif1|tri|tri0|tri1|triand|trior|trireg|type|typedef|union|unique|unsigned|use|uwire|var|vectored|virtual|void|wait|wait_order|wand|weak0|weak1|while|wildcard|wire|with|within|wor|xnor|xor)\b/,
    // bold highlighting for all verilog and system verilog logic blocks
    important: /\b(?:always_latch|always_comb|always_ff|always)\b ?@?/,
    // support for time ticks, vectors, and real numbers
    number: /\B##?\d+|(?:\b\d+)?'[odbh] ?[\da-fzx_?]+|\b\d*[._]?\d+(?:e[-+]?\d+)?/i,
    operator: /[-+{}^~%*\/?=!<>&|]+/,
    punctuation: /[[\];(),.:]/
  }
}


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = vhdl
vhdl.displayName = 'vhdl'
vhdl.aliases = []
function vhdl(Prism) {
  Prism.languages.vhdl = {
    comment: /--.+/,
    // support for all logic vectors
    'vhdl-vectors': {
      pattern: /\b[oxb]"[\da-f_]+"|"[01uxzwlh-]+"/i,
      alias: 'number'
    },
    // support for operator overloading included
    'quoted-function': {
      pattern: /"\S+?"(?=\()/,
      alias: 'function'
    },
    string: /"(?:[^\\"\r\n]|\\(?:\r\n|[\s\S]))*"/,
    constant: /\b(?:use|library)\b/i,
    // support for predefined attributes included
    keyword: /\b(?:'active|'ascending|'base|'delayed|'driving|'driving_value|'event|'high|'image|'instance_name|'last_active|'last_event|'last_value|'left|'leftof|'length|'low|'path_name|'pos|'pred|'quiet|'range|'reverse_range|'right|'rightof|'simple_name|'stable|'succ|'transaction|'val|'value|access|after|alias|all|architecture|array|assert|attribute|begin|block|body|buffer|bus|case|component|configuration|constant|disconnect|downto|else|elsif|end|entity|exit|file|for|function|generate|generic|group|guarded|if|impure|in|inertial|inout|is|label|library|linkage|literal|loop|map|new|next|null|of|on|open|others|out|package|port|postponed|procedure|process|pure|range|record|register|reject|report|return|select|severity|shared|signal|subtype|then|to|transport|type|unaffected|units|until|use|variable|wait|when|while|with)\b/i,
    boolean: /\b(?:true|false)\b/i,
    function: /\w+(?=\()/,
    // decimal, based, physical, and exponential numbers supported
    number: /'[01uxzwlh-]'|\b(?:\d+#[\da-f_.]+#|\d[\d_.]*)(?:e[-+]?\d+)?/i,
    operator: /[<>]=?|:=|[-+*/&=]|\b(?:abs|not|mod|rem|sll|srl|sla|sra|rol|ror|and|or|nand|xnor|xor|nor)\b/i,
    punctuation: /[{}[\];(),.:]/
  }
}


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = vim
vim.displayName = 'vim'
vim.aliases = []
function vim(Prism) {
  Prism.languages.vim = {
    string: /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\r\n]|'')*'/,
    comment: /".*/,
    function: /\w+(?=\()/,
    keyword: /\b(?:ab|abbreviate|abc|abclear|abo|aboveleft|al|all|arga|argadd|argd|argdelete|argdo|arge|argedit|argg|argglobal|argl|arglocal|ar|args|argu|argument|as|ascii|bad|badd|ba|ball|bd|bdelete|be|bel|belowright|bf|bfirst|bl|blast|bm|bmodified|bn|bnext|bN|bNext|bo|botright|bp|bprevious|brea|break|breaka|breakadd|breakd|breakdel|breakl|breaklist|br|brewind|bro|browse|bufdo|b|buffer|buffers|bun|bunload|bw|bwipeout|ca|cabbrev|cabc|cabclear|caddb|caddbuffer|cad|caddexpr|caddf|caddfile|cal|call|cat|catch|cb|cbuffer|cc|ccl|cclose|cd|ce|center|cex|cexpr|cf|cfile|cfir|cfirst|cgetb|cgetbuffer|cgete|cgetexpr|cg|cgetfile|c|change|changes|chd|chdir|che|checkpath|checkt|checktime|cla|clast|cl|clist|clo|close|cmapc|cmapclear|cnew|cnewer|cn|cnext|cN|cNext|cnf|cnfile|cNfcNfile|cnorea|cnoreabbrev|col|colder|colo|colorscheme|comc|comclear|comp|compiler|conf|confirm|con|continue|cope|copen|co|copy|cpf|cpfile|cp|cprevious|cq|cquit|cr|crewind|cuna|cunabbrev|cu|cunmap|cw|cwindow|debugg|debuggreedy|delc|delcommand|d|delete|delf|delfunction|delm|delmarks|diffg|diffget|diffoff|diffpatch|diffpu|diffput|diffsplit|diffthis|diffu|diffupdate|dig|digraphs|di|display|dj|djump|dl|dlist|dr|drop|ds|dsearch|dsp|dsplit|earlier|echoe|echoerr|echom|echomsg|echon|e|edit|el|else|elsei|elseif|em|emenu|endfo|endfor|endf|endfunction|endfun|en|endif|endt|endtry|endw|endwhile|ene|enew|ex|exi|exit|exu|exusage|f|file|files|filetype|fina|finally|fin|find|fini|finish|fir|first|fix|fixdel|fo|fold|foldc|foldclose|folddoc|folddoclosed|foldd|folddoopen|foldo|foldopen|for|fu|fun|function|go|goto|gr|grep|grepa|grepadd|ha|hardcopy|h|help|helpf|helpfind|helpg|helpgrep|helpt|helptags|hid|hide|his|history|ia|iabbrev|iabc|iabclear|if|ij|ijump|il|ilist|imapc|imapclear|in|inorea|inoreabbrev|isearch|isp|isplit|iuna|iunabbrev|iu|iunmap|j|join|ju|jumps|k|keepalt|keepj|keepjumps|kee|keepmarks|laddb|laddbuffer|lad|laddexpr|laddf|laddfile|lan|language|la|last|later|lb|lbuffer|lc|lcd|lch|lchdir|lcl|lclose|let|left|lefta|leftabove|lex|lexpr|lf|lfile|lfir|lfirst|lgetb|lgetbuffer|lgete|lgetexpr|lg|lgetfile|lgr|lgrep|lgrepa|lgrepadd|lh|lhelpgrep|l|list|ll|lla|llast|lli|llist|lmak|lmake|lm|lmap|lmapc|lmapclear|lnew|lnewer|lne|lnext|lN|lNext|lnf|lnfile|lNf|lNfile|ln|lnoremap|lo|loadview|loc|lockmarks|lockv|lockvar|lol|lolder|lop|lopen|lpf|lpfile|lp|lprevious|lr|lrewind|ls|lt|ltag|lu|lunmap|lv|lvimgrep|lvimgrepa|lvimgrepadd|lw|lwindow|mak|make|ma|mark|marks|mat|match|menut|menutranslate|mk|mkexrc|mks|mksession|mksp|mkspell|mkvie|mkview|mkv|mkvimrc|mod|mode|m|move|mzf|mzfile|mz|mzscheme|nbkey|new|n|next|N|Next|nmapc|nmapclear|noh|nohlsearch|norea|noreabbrev|nu|number|nun|nunmap|omapc|omapclear|on|only|o|open|opt|options|ou|ounmap|pc|pclose|ped|pedit|pe|perl|perld|perldo|po|pop|popu|popup|pp|ppop|pre|preserve|prev|previous|p|print|P|Print|profd|profdel|prof|profile|promptf|promptfind|promptr|promptrepl|ps|psearch|pta|ptag|ptf|ptfirst|ptj|ptjump|ptl|ptlast|ptn|ptnext|ptN|ptNext|ptp|ptprevious|ptr|ptrewind|pts|ptselect|pu|put|pw|pwd|pyf|pyfile|py|python|qa|qall|q|quit|quita|quitall|r|read|rec|recover|redi|redir|red|redo|redr|redraw|redraws|redrawstatus|reg|registers|res|resize|ret|retab|retu|return|rew|rewind|ri|right|rightb|rightbelow|rub|ruby|rubyd|rubydo|rubyf|rubyfile|ru|runtime|rv|rviminfo|sal|sall|san|sandbox|sa|sargument|sav|saveas|sba|sball|sbf|sbfirst|sbl|sblast|sbm|sbmodified|sbn|sbnext|sbN|sbNext|sbp|sbprevious|sbr|sbrewind|sb|sbuffer|scripte|scriptencoding|scrip|scriptnames|se|set|setf|setfiletype|setg|setglobal|setl|setlocal|sf|sfind|sfir|sfirst|sh|shell|sign|sil|silent|sim|simalt|sla|slast|sl|sleep|sm|smagic|sm|smap|smapc|smapclear|sme|smenu|sn|snext|sN|sNext|sni|sniff|sno|snomagic|snor|snoremap|snoreme|snoremenu|sor|sort|so|source|spelld|spelldump|spe|spellgood|spelli|spellinfo|spellr|spellrepall|spellu|spellundo|spellw|spellwrong|sp|split|spr|sprevious|sre|srewind|sta|stag|startg|startgreplace|star|startinsert|startr|startreplace|stj|stjump|st|stop|stopi|stopinsert|sts|stselect|sun|sunhide|sunm|sunmap|sus|suspend|sv|sview|syncbind|t|tab|tabc|tabclose|tabd|tabdo|tabe|tabedit|tabf|tabfind|tabfir|tabfirst|tabl|tablast|tabm|tabmove|tabnew|tabn|tabnext|tabN|tabNext|tabo|tabonly|tabp|tabprevious|tabr|tabrewind|tabs|ta|tag|tags|tc|tcl|tcld|tcldo|tclf|tclfile|te|tearoff|tf|tfirst|th|throw|tj|tjump|tl|tlast|tm|tm|tmenu|tn|tnext|tN|tNext|to|topleft|tp|tprevious|tr|trewind|try|ts|tselect|tu|tu|tunmenu|una|unabbreviate|u|undo|undoj|undojoin|undol|undolist|unh|unhide|unlet|unlo|unlockvar|unm|unmap|up|update|verb|verbose|ve|version|vert|vertical|vie|view|vim|vimgrep|vimgrepa|vimgrepadd|vi|visual|viu|viusage|vmapc|vmapclear|vne|vnew|vs|vsplit|vu|vunmap|wa|wall|wh|while|winc|wincmd|windo|winp|winpos|win|winsize|wn|wnext|wN|wNext|wp|wprevious|wq|wqa|wqall|w|write|ws|wsverb|wv|wviminfo|X|xa|xall|x|xit|xm|xmap|xmapc|xmapclear|xme|xmenu|XMLent|XMLns|xn|xnoremap|xnoreme|xnoremenu|xu|xunmap|y|yank)\b/,
    builtin: /\b(?:autocmd|acd|ai|akm|aleph|allowrevins|altkeymap|ambiwidth|ambw|anti|antialias|arab|arabic|arabicshape|ari|arshape|autochdir|autoindent|autoread|autowrite|autowriteall|aw|awa|background|backspace|backup|backupcopy|backupdir|backupext|backupskip|balloondelay|ballooneval|balloonexpr|bdir|bdlay|beval|bex|bexpr|bg|bh|bin|binary|biosk|bioskey|bk|bkc|bomb|breakat|brk|browsedir|bs|bsdir|bsk|bt|bufhidden|buflisted|buftype|casemap|ccv|cdpath|cedit|cfu|ch|charconvert|ci|cin|cindent|cink|cinkeys|cino|cinoptions|cinw|cinwords|clipboard|cmdheight|cmdwinheight|cmp|cms|columns|com|comments|commentstring|compatible|complete|completefunc|completeopt|consk|conskey|copyindent|cot|cpo|cpoptions|cpt|cscopepathcomp|cscopeprg|cscopequickfix|cscopetag|cscopetagorder|cscopeverbose|cspc|csprg|csqf|cst|csto|csverb|cuc|cul|cursorcolumn|cursorline|cwh|debug|deco|def|define|delcombine|dex|dg|dict|dictionary|diff|diffexpr|diffopt|digraph|dip|dir|directory|dy|ea|ead|eadirection|eb|ed|edcompatible|ef|efm|ei|ek|enc|encoding|endofline|eol|ep|equalalways|equalprg|errorbells|errorfile|errorformat|esckeys|et|eventignore|expandtab|exrc|fcl|fcs|fdc|fde|fdi|fdl|fdls|fdm|fdn|fdo|fdt|fen|fenc|fencs|fex|ff|ffs|fileencoding|fileencodings|fileformat|fileformats|fillchars|fk|fkmap|flp|fml|fmr|foldcolumn|foldenable|foldexpr|foldignore|foldlevel|foldlevelstart|foldmarker|foldmethod|foldminlines|foldnestmax|foldtext|formatexpr|formatlistpat|formatoptions|formatprg|fp|fs|fsync|ft|gcr|gd|gdefault|gfm|gfn|gfs|gfw|ghr|gp|grepformat|grepprg|gtl|gtt|guicursor|guifont|guifontset|guifontwide|guiheadroom|guioptions|guipty|guitablabel|guitabtooltip|helpfile|helpheight|helplang|hf|hh|hi|hidden|highlight|hk|hkmap|hkmapp|hkp|hl|hlg|hls|hlsearch|ic|icon|iconstring|ignorecase|im|imactivatekey|imak|imc|imcmdline|imd|imdisable|imi|iminsert|ims|imsearch|inc|include|includeexpr|incsearch|inde|indentexpr|indentkeys|indk|inex|inf|infercase|insertmode|isf|isfname|isi|isident|isk|iskeyword|isprint|joinspaces|js|key|keymap|keymodel|keywordprg|km|kmp|kp|langmap|langmenu|laststatus|lazyredraw|lbr|lcs|linebreak|lines|linespace|lisp|lispwords|listchars|loadplugins|lpl|lsp|lz|macatsui|magic|makeef|makeprg|matchpairs|matchtime|maxcombine|maxfuncdepth|maxmapdepth|maxmem|maxmempattern|maxmemtot|mco|mef|menuitems|mfd|mh|mis|mkspellmem|ml|mls|mm|mmd|mmp|mmt|modeline|modelines|modifiable|modified|more|mouse|mousef|mousefocus|mousehide|mousem|mousemodel|mouses|mouseshape|mouset|mousetime|mp|mps|msm|mzq|mzquantum|nf|nrformats|numberwidth|nuw|odev|oft|ofu|omnifunc|opendevice|operatorfunc|opfunc|osfiletype|pa|para|paragraphs|paste|pastetoggle|patchexpr|patchmode|path|pdev|penc|pex|pexpr|pfn|ph|pheader|pi|pm|pmbcs|pmbfn|popt|preserveindent|previewheight|previewwindow|printdevice|printencoding|printexpr|printfont|printheader|printmbcharset|printmbfont|printoptions|prompt|pt|pumheight|pvh|pvw|qe|quoteescape|readonly|remap|report|restorescreen|revins|rightleft|rightleftcmd|rl|rlc|ro|rs|rtp|ruf|ruler|rulerformat|runtimepath|sbo|sc|scb|scr|scroll|scrollbind|scrolljump|scrolloff|scrollopt|scs|sect|sections|secure|sel|selection|selectmode|sessionoptions|sft|shcf|shellcmdflag|shellpipe|shellquote|shellredir|shellslash|shelltemp|shelltype|shellxquote|shiftround|shiftwidth|shm|shortmess|shortname|showbreak|showcmd|showfulltag|showmatch|showmode|showtabline|shq|si|sidescroll|sidescrolloff|siso|sj|slm|smartcase|smartindent|smarttab|smc|smd|softtabstop|sol|spc|spell|spellcapcheck|spellfile|spelllang|spellsuggest|spf|spl|splitbelow|splitright|sps|sr|srr|ss|ssl|ssop|stal|startofline|statusline|stl|stmp|su|sua|suffixes|suffixesadd|sw|swapfile|swapsync|swb|swf|switchbuf|sws|sxq|syn|synmaxcol|syntax|tabline|tabpagemax|tabstop|tagbsearch|taglength|tagrelative|tagstack|tal|tb|tbi|tbidi|tbis|tbs|tenc|term|termbidi|termencoding|terse|textauto|textmode|textwidth|tgst|thesaurus|tildeop|timeout|timeoutlen|title|titlelen|titleold|titlestring|toolbar|toolbariconsize|top|tpm|tsl|tsr|ttimeout|ttimeoutlen|ttm|tty|ttybuiltin|ttyfast|ttym|ttymouse|ttyscroll|ttytype|tw|tx|uc|ul|undolevels|updatecount|updatetime|ut|vb|vbs|vdir|verbosefile|vfile|viewdir|viewoptions|viminfo|virtualedit|visualbell|vop|wak|warn|wb|wc|wcm|wd|weirdinvert|wfh|wfw|whichwrap|wi|wig|wildchar|wildcharm|wildignore|wildmenu|wildmode|wildoptions|wim|winaltkeys|window|winfixheight|winfixwidth|winheight|winminheight|winminwidth|winwidth|wiv|wiw|wm|wmh|wmnu|wmw|wop|wrap|wrapmargin|wrapscan|writeany|writebackup|writedelay|ww|noacd|noai|noakm|noallowrevins|noaltkeymap|noanti|noantialias|noar|noarab|noarabic|noarabicshape|noari|noarshape|noautochdir|noautoindent|noautoread|noautowrite|noautowriteall|noaw|noawa|nobackup|noballooneval|nobeval|nobin|nobinary|nobiosk|nobioskey|nobk|nobl|nobomb|nobuflisted|nocf|noci|nocin|nocindent|nocompatible|noconfirm|noconsk|noconskey|nocopyindent|nocp|nocscopetag|nocscopeverbose|nocst|nocsverb|nocuc|nocul|nocursorcolumn|nocursorline|nodeco|nodelcombine|nodg|nodiff|nodigraph|nodisable|noea|noeb|noed|noedcompatible|noek|noendofline|noeol|noequalalways|noerrorbells|noesckeys|noet|noex|noexpandtab|noexrc|nofen|nofk|nofkmap|nofoldenable|nogd|nogdefault|noguipty|nohid|nohidden|nohk|nohkmap|nohkmapp|nohkp|nohls|noic|noicon|noignorecase|noim|noimc|noimcmdline|noimd|noincsearch|noinf|noinfercase|noinsertmode|nois|nojoinspaces|nojs|nolazyredraw|nolbr|nolinebreak|nolisp|nolist|noloadplugins|nolpl|nolz|noma|nomacatsui|nomagic|nomh|noml|nomod|nomodeline|nomodifiable|nomodified|nomore|nomousef|nomousefocus|nomousehide|nonu|nonumber|noodev|noopendevice|nopaste|nopi|nopreserveindent|nopreviewwindow|noprompt|nopvw|noreadonly|noremap|norestorescreen|norevins|nori|norightleft|norightleftcmd|norl|norlc|noro|nors|noru|noruler|nosb|nosc|noscb|noscrollbind|noscs|nosecure|nosft|noshellslash|noshelltemp|noshiftround|noshortname|noshowcmd|noshowfulltag|noshowmatch|noshowmode|nosi|nosm|nosmartcase|nosmartindent|nosmarttab|nosmd|nosn|nosol|nospell|nosplitbelow|nosplitright|nospr|nosr|nossl|nosta|nostartofline|nostmp|noswapfile|noswf|nota|notagbsearch|notagrelative|notagstack|notbi|notbidi|notbs|notermbidi|noterse|notextauto|notextmode|notf|notgst|notildeop|notimeout|notitle|noto|notop|notr|nottimeout|nottybuiltin|nottyfast|notx|novb|novisualbell|nowa|nowarn|nowb|noweirdinvert|nowfh|nowfw|nowildmenu|nowinfixheight|nowinfixwidth|nowiv|nowmnu|nowrap|nowrapscan|nowrite|nowriteany|nowritebackup|nows|invacd|invai|invakm|invallowrevins|invaltkeymap|invanti|invantialias|invar|invarab|invarabic|invarabicshape|invari|invarshape|invautochdir|invautoindent|invautoread|invautowrite|invautowriteall|invaw|invawa|invbackup|invballooneval|invbeval|invbin|invbinary|invbiosk|invbioskey|invbk|invbl|invbomb|invbuflisted|invcf|invci|invcin|invcindent|invcompatible|invconfirm|invconsk|invconskey|invcopyindent|invcp|invcscopetag|invcscopeverbose|invcst|invcsverb|invcuc|invcul|invcursorcolumn|invcursorline|invdeco|invdelcombine|invdg|invdiff|invdigraph|invdisable|invea|inveb|inved|invedcompatible|invek|invendofline|inveol|invequalalways|inverrorbells|invesckeys|invet|invex|invexpandtab|invexrc|invfen|invfk|invfkmap|invfoldenable|invgd|invgdefault|invguipty|invhid|invhidden|invhk|invhkmap|invhkmapp|invhkp|invhls|invhlsearch|invic|invicon|invignorecase|invim|invimc|invimcmdline|invimd|invincsearch|invinf|invinfercase|invinsertmode|invis|invjoinspaces|invjs|invlazyredraw|invlbr|invlinebreak|invlisp|invlist|invloadplugins|invlpl|invlz|invma|invmacatsui|invmagic|invmh|invml|invmod|invmodeline|invmodifiable|invmodified|invmore|invmousef|invmousefocus|invmousehide|invnu|invnumber|invodev|invopendevice|invpaste|invpi|invpreserveindent|invpreviewwindow|invprompt|invpvw|invreadonly|invremap|invrestorescreen|invrevins|invri|invrightleft|invrightleftcmd|invrl|invrlc|invro|invrs|invru|invruler|invsb|invsc|invscb|invscrollbind|invscs|invsecure|invsft|invshellslash|invshelltemp|invshiftround|invshortname|invshowcmd|invshowfulltag|invshowmatch|invshowmode|invsi|invsm|invsmartcase|invsmartindent|invsmarttab|invsmd|invsn|invsol|invspell|invsplitbelow|invsplitright|invspr|invsr|invssl|invsta|invstartofline|invstmp|invswapfile|invswf|invta|invtagbsearch|invtagrelative|invtagstack|invtbi|invtbidi|invtbs|invtermbidi|invterse|invtextauto|invtextmode|invtf|invtgst|invtildeop|invtimeout|invtitle|invto|invtop|invtr|invttimeout|invttybuiltin|invttyfast|invtx|invvb|invvisualbell|invwa|invwarn|invwb|invweirdinvert|invwfh|invwfw|invwildmenu|invwinfixheight|invwinfixwidth|invwiv|invwmnu|invwrap|invwrapscan|invwrite|invwriteany|invwritebackup|invws|t_AB|t_AF|t_al|t_AL|t_bc|t_cd|t_ce|t_Ce|t_cl|t_cm|t_Co|t_cs|t_Cs|t_CS|t_CV|t_da|t_db|t_dl|t_DL|t_EI|t_F1|t_F2|t_F3|t_F4|t_F5|t_F6|t_F7|t_F8|t_F9|t_fs|t_IE|t_IS|t_k1|t_K1|t_k2|t_k3|t_K3|t_k4|t_K4|t_k5|t_K5|t_k6|t_K6|t_k7|t_K7|t_k8|t_K8|t_k9|t_K9|t_KA|t_kb|t_kB|t_KB|t_KC|t_kd|t_kD|t_KD|t_ke|t_KE|t_KF|t_KG|t_kh|t_KH|t_kI|t_KI|t_KJ|t_KK|t_kl|t_KL|t_kN|t_kP|t_kr|t_ks|t_ku|t_le|t_mb|t_md|t_me|t_mr|t_ms|t_nd|t_op|t_RI|t_RV|t_Sb|t_se|t_Sf|t_SI|t_so|t_sr|t_te|t_ti|t_ts|t_ue|t_us|t_ut|t_vb|t_ve|t_vi|t_vs|t_WP|t_WS|t_xs|t_ZH|t_ZR)\b/,
    number: /\b(?:0x[\da-f]+|\d+(?:\.\d+)?)\b/i,
    operator: /\|\||&&|[-+.]=?|[=!](?:[=~][#?]?)?|[<>]=?[#?]?|[*\/%?]|\b(?:is(?:not)?)\b/,
    punctuation: /[{}[\](),;:]/
  }
}


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = visualBasic
visualBasic.displayName = 'visualBasic'
visualBasic.aliases = []
function visualBasic(Prism) {
  Prism.languages['visual-basic'] = {
    comment: {
      pattern: /(?:['‘’]|REM\b).*/i,
      inside: {
        keyword: /^REM/i
      }
    },
    directive: {
      pattern: /#(?:Const|Else|ElseIf|End|ExternalChecksum|ExternalSource|If|Region)(?:[^\S\r\n]_[^\S\r\n]*(?:\r\n?|\n)|.)+/i,
      alias: 'comment',
      greedy: true
    },
    string: {
      pattern: /["“”](?:["“”]{2}|[^"“”])*["“”]C?/i,
      greedy: true
    },
    date: {
      pattern: /#[^\S\r\n]*(?:\d+([/-])\d+\1\d+(?:[^\S\r\n]+(?:\d+[^\S\r\n]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[^\S\r\n]*(?:AM|PM))?))?|(?:\d+[^\S\r\n]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[^\S\r\n]*(?:AM|PM))?))[^\S\r\n]*#/i,
      alias: 'builtin'
    },
    number: /(?:(?:\b\d+(?:\.\d+)?|\.\d+)(?:E[+-]?\d+)?|&[HO][\dA-F]+)(?:U?[ILS]|[FRD])?/i,
    boolean: /\b(?:True|False|Nothing)\b/i,
    keyword: /\b(?:AddHandler|AddressOf|Alias|And(?:Also)?|As|Boolean|ByRef|Byte|ByVal|Call|Case|Catch|C(?:Bool|Byte|Char|Date|Dbl|Dec|Int|Lng|Obj|SByte|Short|Sng|Str|Type|UInt|ULng|UShort)|Char|Class|Const|Continue|Date|Decimal|Declare|Default|Delegate|Dim|DirectCast|Do|Double|Each|Else(?:If)?|End(?:If)?|Enum|Erase|Error|Event|Exit|Finally|For|Friend|Function|Get(?:Type|XMLNamespace)?|Global|GoSub|GoTo|Handles|If|Implements|Imports|In|Inherits|Integer|Interface|Is|IsNot|Let|Lib|Like|Long|Loop|Me|Mod|Module|Must(?:Inherit|Override)|My(?:Base|Class)|Namespace|Narrowing|New|Next|Not(?:Inheritable|Overridable)?|Object|Of|On|Operator|Option(?:al)?|Or(?:Else)?|Out|Overloads|Overridable|Overrides|ParamArray|Partial|Private|Property|Protected|Public|RaiseEvent|ReadOnly|ReDim|RemoveHandler|Resume|Return|SByte|Select|Set|Shadows|Shared|short|Single|Static|Step|Stop|String|Structure|Sub|SyncLock|Then|Throw|To|Try|TryCast|TypeOf|U(?:Integer|Long|Short)|Using|Variant|Wend|When|While|Widening|With(?:Events)?|WriteOnly|Xor)\b/i,
    operator: [
      /[+\-*/\\^<=>&#@$%!]/,
      {
        pattern: /([^\S\r\n])_(?=[^\S\r\n]*[\r\n])/,
        lookbehind: true
      }
    ],
    punctuation: /[{}().,:?]/
  }
  Prism.languages.vb = Prism.languages['visual-basic']
}


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = wasm
wasm.displayName = 'wasm'
wasm.aliases = []
function wasm(Prism) {
  Prism.languages.wasm = {
    comment: [
      /\(;[\s\S]*?;\)/,
      {
        pattern: /;;.*/,
        greedy: true
      }
    ],
    string: {
      pattern: /"(?:\\[\s\S]|[^"\\])*"/,
      greedy: true
    },
    keyword: [
      {
        pattern: /\b(?:align|offset)=/,
        inside: {
          operator: /=/
        }
      },
      {
        pattern: /\b(?:(?:f32|f64|i32|i64)(?:\.(?:abs|add|and|ceil|clz|const|convert_[su]\/i(?:32|64)|copysign|ctz|demote\/f64|div(?:_[su])?|eqz?|extend_[su]\/i32|floor|ge(?:_[su])?|gt(?:_[su])?|le(?:_[su])?|load(?:(?:8|16|32)_[su])?|lt(?:_[su])?|max|min|mul|nearest|neg?|or|popcnt|promote\/f32|reinterpret\/[fi](?:32|64)|rem_[su]|rot[lr]|shl|shr_[su]|store(?:8|16|32)?|sqrt|sub|trunc(?:_[su]\/f(?:32|64))?|wrap\/i64|xor))?|memory\.(?:grow|size))\b/,
        inside: {
          punctuation: /\./
        }
      },
      /\b(?:anyfunc|block|br(?:_if|_table)?|call(?:_indirect)?|data|drop|elem|else|end|export|func|get_(?:global|local)|global|if|import|local|loop|memory|module|mut|nop|offset|param|result|return|select|set_(?:global|local)|start|table|tee_local|then|type|unreachable)\b/
    ],
    variable: /\$[\w!#$%&'*+\-./:<=>?@\\^_`|~]+/i,
    number: /[+-]?\b(?:\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:[eE][+-]?\d(?:_?\d)*)?|0x[\da-fA-F](?:_?[\da-fA-F])*(?:\.[\da-fA-F](?:_?[\da-fA-D])*)?(?:[pP][+-]?\d(?:_?\d)*)?)\b|\binf\b|\bnan(?::0x[\da-fA-F](?:_?[\da-fA-D])*)?\b/,
    punctuation: /[()]/
  }
}


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = wiki
wiki.displayName = 'wiki'
wiki.aliases = []
function wiki(Prism) {
  Prism.languages.wiki = Prism.languages.extend('markup', {
    'block-comment': {
      pattern: /(^|[^\\])\/\*[\s\S]*?\*\//,
      lookbehind: true,
      alias: 'comment'
    },
    heading: {
      pattern: /^(=+).+?\1/m,
      inside: {
        punctuation: /^=+|=+$/,
        important: /.+/
      }
    },
    emphasis: {
      // TODO Multi-line
      pattern: /('{2,5}).+?\1/,
      inside: {
        'bold italic': {
          pattern: /(''''').+?(?=\1)/,
          lookbehind: true
        },
        bold: {
          pattern: /(''')[^'](?:.*?[^'])?(?=\1)/,
          lookbehind: true
        },
        italic: {
          pattern: /('')[^'](?:.*?[^'])?(?=\1)/,
          lookbehind: true
        },
        punctuation: /^''+|''+$/
      }
    },
    hr: {
      pattern: /^-{4,}/m,
      alias: 'punctuation'
    },
    url: [
      /ISBN +(?:97[89][ -]?)?(?:\d[ -]?){9}[\dx]\b|(?:RFC|PMID) +\d+/i,
      /\[\[.+?\]\]|\[.+?\]/
    ],
    variable: [
      /__[A-Z]+__/,
      // FIXME Nested structures should be handled
      // {{formatnum:{{#expr:{{{3}}}}}}}
      /\{{3}.+?\}{3}/,
      /\{\{.+?\}\}/
    ],
    symbol: [/^#redirect/im, /~{3,5}/],
    // Handle table attrs:
    // {|
    // ! style="text-align:left;"| Item
    // |}
    'table-tag': {
      pattern: /((?:^|[|!])[|!])[^|\r\n]+\|(?!\|)/m,
      lookbehind: true,
      inside: {
        'table-bar': {
          pattern: /\|$/,
          alias: 'punctuation'
        },
        rest: Prism.languages.markup['tag'].inside
      }
    },
    punctuation: /^(?:\{\||\|\}|\|-|[*#:;!|])|\|\||!!/m
  })
  Prism.languages.insertBefore('wiki', 'tag', {
    // Prevent highlighting inside <nowiki>, <source> and <pre> tags
    nowiki: {
      pattern: /<(nowiki|pre|source)\b[\s\S]*?>[\s\S]*?<\/\1>/i,
      inside: {
        tag: {
          pattern: /<(?:nowiki|pre|source)\b[\s\S]*?>|<\/(?:nowiki|pre|source)>/i,
          inside: Prism.languages.markup['tag'].inside
        }
      }
    }
  })
}


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = xeora
xeora.displayName = 'xeora'
xeora.aliases = ['xeoracube']
function xeora(Prism) {
  ;(function(Prism) {
    Prism.languages.xeora = Prism.languages.extend('markup', {
      constant: {
        pattern: /\$(?:DomainContents|PageRenderDuration)\$/,
        inside: {
          punctuation: {
            pattern: /\$/
          }
        }
      },
      variable: {
        pattern: /\$@?(?:#+|[-+*~=^])?[\w.]+\$/,
        inside: {
          punctuation: {
            pattern: /[$.]/
          },
          operator: {
            pattern: /#+|[-+*~=^@]/
          }
        }
      },
      'function-inline': {
        pattern: /\$F:[-\w.]+\?[-\w.]+(?:,(?:\|?(?:[-#.^+*~]*(?:[\w+][^$]*)|=(?:[\S+][^$]*)|@[-#]*(?:\w+.)[\w+.]+)?)*)?\$/,
        inside: {
          variable: {
            pattern: /(?:[,|])@?(?:#+|[-+*~=^])?[\w.]+/,
            inside: {
              punctuation: {
                pattern: /[,.|]/
              },
              operator: {
                pattern: /#+|[-+*~=^@]/
              }
            }
          },
          punctuation: {
            pattern: /\$\w:|[$:?.,|]/
          }
        },
        alias: 'function'
      },
      'function-block': {
        pattern: /\$XF:{[-\w.]+\?[-\w.]+(?:,(?:\|?(?:[-#.^+*~]*(?:[\w+][^$]*)|=(?:[\S+][^$]*)|@[-#]*(?:\w+.)[\w+.]+)?)*)?}:XF\$/,
        inside: {
          punctuation: {
            pattern: /[$:{}?.,|]/
          }
        },
        alias: 'function'
      },
      'directive-inline': {
        pattern: /\$\w(?:#\d+\+?)?(?:\[[-\w.]+])?:[-\/\w.]+\$/,
        inside: {
          punctuation: {
            pattern: /\$(?:\w:|C(?:\[|#\d))?|[:{[\]]/,
            inside: {
              tag: {
                pattern: /#\d/
              }
            }
          }
        },
        alias: 'function'
      },
      'directive-block-open': {
        pattern: /\$\w+:{|\$\w(?:#\d+\+?)?(?:\[[-\w.]+])?:[-\w.]+:{(![A-Z]+)?/,
        inside: {
          punctuation: {
            pattern: /\$(?:\w:|C(?:\[|#\d))?|[:{[\]]/,
            inside: {
              tag: {
                pattern: /#\d/
              }
            }
          },
          attribute: {
            pattern: /![A-Z]+$/,
            inside: {
              punctuation: {
                pattern: /!/
              }
            },
            alias: 'keyword'
          }
        },
        alias: 'function'
      },
      'directive-block-separator': {
        pattern: /}:[-\w.]+:{/,
        inside: {
          punctuation: {
            pattern: /[:{}]/
          }
        },
        alias: 'function'
      },
      'directive-block-close': {
        pattern: /}:[-\w.]+\$/,
        inside: {
          punctuation: {
            pattern: /[:{}$]/
          }
        },
        alias: 'function'
      }
    })
    Prism.languages.insertBefore(
      'inside',
      'punctuation',
      {
        variable: Prism.languages.xeora['function-inline'].inside['variable']
      },
      Prism.languages.xeora['function-block']
    )
    Prism.languages.xeoracube = Prism.languages.xeora
  })(Prism)
}


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = xojo
xojo.displayName = 'xojo'
xojo.aliases = []
function xojo(Prism) {
  Prism.languages.xojo = {
    comment: {
      pattern: /(?:'|\/\/|Rem\b).+/i,
      inside: {
        keyword: /^Rem/i
      }
    },
    string: {
      pattern: /"(?:""|[^"])*"/,
      greedy: true
    },
    number: [/(?:\b\d+\.?\d*|\B\.\d+)(?:E[+-]?\d+)?/i, /&[bchou][a-z\d]+/i],
    symbol: /#(?:If|Else|ElseIf|Endif|Pragma)\b/i,
    keyword: /\b(?:AddHandler|App|Array|As(?:signs)?|By(?:Ref|Val)|Break|Call|Case|Catch|Const|Continue|CurrentMethodName|Declare|Dim|Do(?:wnTo)?|Each|Else(?:If)?|End|Exit|Extends|False|Finally|For|Global|If|In|Lib|Loop|Me|Next|Nil|Optional|ParamArray|Raise(?:Event)?|ReDim|Rem|RemoveHandler|Return|Select|Self|Soft|Static|Step|Super|Then|To|True|Try|Ubound|Until|Using|Wend|While)\b/i,
    operator: /<[=>]?|>=?|[+\-*\/\\^=]|\b(?:AddressOf|And|Ctype|IsA?|Mod|New|Not|Or|Xor|WeakAddressOf)\b/i,
    punctuation: /[.,;:()]/
  }
}


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = xquery
xquery.displayName = 'xquery'
xquery.aliases = []
function xquery(Prism) {
  ;(function(Prism) {
    Prism.languages.xquery = Prism.languages.extend('markup', {
      'xquery-comment': {
        pattern: /\(:[\s\S]*?:\)/,
        greedy: true,
        alias: 'comment'
      },
      string: {
        pattern: /(["'])(?:\1\1|(?!\1)[\s\S])*\1/,
        greedy: true
      },
      extension: {
        pattern: /\(#.+?#\)/,
        alias: 'symbol'
      },
      variable: /\$[\w-:]+/,
      axis: {
        pattern: /(^|[^-])(?:ancestor(?:-or-self)?|attribute|child|descendant(?:-or-self)?|following(?:-sibling)?|parent|preceding(?:-sibling)?|self)(?=::)/,
        lookbehind: true,
        alias: 'operator'
      },
      'keyword-operator': {
        pattern: /(^|[^:-])\b(?:and|castable as|div|eq|except|ge|gt|idiv|instance of|intersect|is|le|lt|mod|ne|or|union)\b(?=$|[^:-])/,
        lookbehind: true,
        alias: 'operator'
      },
      keyword: {
        pattern: /(^|[^:-])\b(?:as|ascending|at|base-uri|boundary-space|case|cast as|collation|construction|copy-namespaces|declare|default|descending|else|empty (?:greatest|least)|encoding|every|external|for|function|if|import|in|inherit|lax|let|map|module|namespace|no-inherit|no-preserve|option|order(?: by|ed|ing)?|preserve|return|satisfies|schema|some|stable|strict|strip|then|to|treat as|typeswitch|unordered|validate|variable|version|where|xquery)\b(?=$|[^:-])/,
        lookbehind: true
      },
      function: /[\w-]+(?::[\w-]+)*(?=\s*\()/,
      'xquery-element': {
        pattern: /(element\s+)[\w-]+(?::[\w-]+)*/,
        lookbehind: true,
        alias: 'tag'
      },
      'xquery-attribute': {
        pattern: /(attribute\s+)[\w-]+(?::[\w-]+)*/,
        lookbehind: true,
        alias: 'attr-name'
      },
      builtin: {
        pattern: /(^|[^:-])\b(?:attribute|comment|document|element|processing-instruction|text|xs:(?:anyAtomicType|anyType|anyURI|base64Binary|boolean|byte|date|dateTime|dayTimeDuration|decimal|double|duration|ENTITIES|ENTITY|float|gDay|gMonth|gMonthDay|gYear|gYearMonth|hexBinary|ID|IDREFS?|int|integer|language|long|Name|NCName|negativeInteger|NMTOKENS?|nonNegativeInteger|nonPositiveInteger|normalizedString|NOTATION|positiveInteger|QName|short|string|time|token|unsigned(?:Byte|Int|Long|Short)|untyped(?:Atomic)?|yearMonthDuration))\b(?=$|[^:-])/,
        lookbehind: true
      },
      number: /\b\d+(?:\.\d+)?(?:E[+-]?\d+)?/,
      operator: [
        /[+*=?|@]|\.\.?|:=|!=|<[=<]?|>[=>]?/,
        {
          pattern: /(\s)-(?=\s)/,
          lookbehind: true
        }
      ],
      punctuation: /[[\](){},;:/]/
    })
    Prism.languages.xquery.tag.pattern = /<\/?(?!\d)[^\s>\/=$<%]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|{(?!{)(?:{(?:{[^}]*}|[^}])*}|[^}])+}|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/i
    Prism.languages.xquery['tag'].inside[
      'attr-value'
    ].pattern = /=(?:("|')(?:\\[\s\S]|{(?!{)(?:{(?:{[^}]*}|[^}])*}|[^}])+}|(?!\1)[^\\])*\1|[^\s'">=]+)/i
    Prism.languages.xquery['tag'].inside['attr-value'].inside[
      'punctuation'
    ] = /^="|"$/
    Prism.languages.xquery['tag'].inside['attr-value'].inside['expression'] = {
      // Allow for two levels of nesting
      pattern: /{(?!{)(?:{(?:{[^}]*}|[^}])*}|[^}])+}/,
      inside: {
        rest: Prism.languages.xquery
      },
      alias: 'language-xquery'
    }
    // The following will handle plain text inside tags
    var stringifyToken = function(token) {
      if (typeof token === 'string') {
        return token
      }
      if (typeof token.content === 'string') {
        return token.content
      }
      return token.content.map(stringifyToken).join('')
    }
    var walkTokens = function(tokens) {
      var openedTags = []
      for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i]
        var notTagNorBrace = false
        if (typeof token !== 'string') {
          if (
            token.type === 'tag' &&
            token.content[0] &&
            token.content[0].type === 'tag'
          ) {
            // We found a tag, now find its kind
            if (token.content[0].content[0].content === '</') {
              // Closing tag
              if (
                openedTags.length > 0 &&
                openedTags[openedTags.length - 1].tagName ===
                  stringifyToken(token.content[0].content[1])
              ) {
                // Pop matching opening tag
                openedTags.pop()
              }
            } else {
              if (token.content[token.content.length - 1].content === '/>') {
                // Autoclosed tag, ignore
              } else {
                // Opening tag
                openedTags.push({
                  tagName: stringifyToken(token.content[0].content[1]),
                  openedBraces: 0
                })
              }
            }
          } else if (
            openedTags.length > 0 &&
            token.type === 'punctuation' &&
            token.content === '{' &&
            // Ignore `{{`
            (!tokens[i + 1] ||
              tokens[i + 1].type !== 'punctuation' ||
              tokens[i + 1].content !== '{') &&
            (!tokens[i - 1] ||
              tokens[i - 1].type !== 'plain-text' ||
              tokens[i - 1].content !== '{')
          ) {
            // Here we might have entered an XQuery expression inside a tag
            openedTags[openedTags.length - 1].openedBraces++
          } else if (
            openedTags.length > 0 &&
            openedTags[openedTags.length - 1].openedBraces > 0 &&
            token.type === 'punctuation' &&
            token.content === '}'
          ) {
            // Here we might have left an XQuery expression inside a tag
            openedTags[openedTags.length - 1].openedBraces--
          } else if (token.type !== 'comment') {
            notTagNorBrace = true
          }
        }
        if (notTagNorBrace || typeof token === 'string') {
          if (
            openedTags.length > 0 &&
            openedTags[openedTags.length - 1].openedBraces === 0
          ) {
            // Here we are inside a tag, and not inside an XQuery expression.
            // That's plain text: drop any tokens matched.
            var plainText = stringifyToken(token)
            // And merge text with adjacent text
            if (
              i < tokens.length - 1 &&
              (typeof tokens[i + 1] === 'string' ||
                tokens[i + 1].type === 'plain-text')
            ) {
              plainText += stringifyToken(tokens[i + 1])
              tokens.splice(i + 1, 1)
            }
            if (
              i > 0 &&
              (typeof tokens[i - 1] === 'string' ||
                tokens[i - 1].type === 'plain-text')
            ) {
              plainText = stringifyToken(tokens[i - 1]) + plainText
              tokens.splice(i - 1, 1)
              i--
            }
            if (/^\s+$/.test(plainText)) {
              tokens[i] = plainText
            } else {
              tokens[i] = new Prism.Token(
                'plain-text',
                plainText,
                null,
                plainText
              )
            }
          }
        }
        if (token.content && typeof token.content !== 'string') {
          walkTokens(token.content)
        }
      }
    }
    Prism.hooks.add('after-tokenize', function(env) {
      if (env.language !== 'xquery') {
        return
      }
      walkTokens(env.tokens)
    })
  })(Prism)
}


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = yaml
yaml.displayName = 'yaml'
yaml.aliases = []
function yaml(Prism) {
  Prism.languages.yaml = {
    scalar: {
      pattern: /([\-:]\s*(?:![^\s]+)?[ \t]*[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)[^\r\n]+(?:\2[^\r\n]+)*)/,
      lookbehind: true,
      alias: 'string'
    },
    comment: /#.*/,
    key: {
      pattern: /(\s*(?:^|[:\-,[{\r\n?])[ \t]*(?:![^\s]+)?[ \t]*)[^\r\n{[\]},#\s]+?(?=\s*:\s)/,
      lookbehind: true,
      alias: 'atrule'
    },
    directive: {
      pattern: /(^[ \t]*)%.+/m,
      lookbehind: true,
      alias: 'important'
    },
    datetime: {
      pattern: /([:\-,[{]\s*(?:![^\s]+)?[ \t]*)(?:\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?)?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?)(?=[ \t]*(?:$|,|]|}))/m,
      lookbehind: true,
      alias: 'number'
    },
    boolean: {
      pattern: /([:\-,[{]\s*(?:![^\s]+)?[ \t]*)(?:true|false)[ \t]*(?=$|,|]|})/im,
      lookbehind: true,
      alias: 'important'
    },
    null: {
      pattern: /([:\-,[{]\s*(?:![^\s]+)?[ \t]*)(?:null|~)[ \t]*(?=$|,|]|})/im,
      lookbehind: true,
      alias: 'important'
    },
    string: {
      pattern: /([:\-,[{]\s*(?:![^\s]+)?[ \t]*)("|')(?:(?!\2)[^\\\r\n]|\\.)*\2(?=[ \t]*(?:$|,|]|}))/m,
      lookbehind: true,
      greedy: true
    },
    number: {
      pattern: /([:\-,[{]\s*(?:![^\s]+)?[ \t]*)[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+\.?\d*|\.?\d+)(?:e[+-]?\d+)?|\.inf|\.nan)[ \t]*(?=$|,|]|})/im,
      lookbehind: true
    },
    tag: /![^\s]+/,
    important: /[&*][\w]+/,
    punctuation: /---|[:[\]{}\-,|>?]|\.\.\./
  }
}


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = Schema

var proto = Schema.prototype

proto.space = null
proto.normal = {}
proto.property = {}

function Schema(property, normal, space) {
  this.property = property
  this.normal = normal

  if (space) {
    this.space = space
  }
}


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Info = __webpack_require__(1265)
var types = __webpack_require__(494)

module.exports = DefinedInfo

DefinedInfo.prototype = new Info()
DefinedInfo.prototype.defined = true

function DefinedInfo(property, attribute, mask, space) {
  mark(this, 'space', space)
  Info.call(this, property, attribute)
  mark(this, 'boolean', check(mask, types.boolean))
  mark(this, 'booleanish', check(mask, types.booleanish))
  mark(this, 'overloadedBoolean', check(mask, types.overloadedBoolean))
  mark(this, 'number', check(mask, types.number))
  mark(this, 'commaSeparated', check(mask, types.commaSeparated))
  mark(this, 'spaceSeparated', check(mask, types.spaceSeparated))
  mark(this, 'commaOrSpaceSeparated', check(mask, types.commaOrSpaceSeparated))
}

function mark(values, key, value) {
  if (value) {
    values[key] = value
  }
}

function check(value, mask) {
  return (value & mask) === mask
}


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = Info

var proto = Info.prototype

proto.space = null
proto.attribute = null
proto.property = null
proto.boolean = false
proto.booleanish = false
proto.overloadedBoolean = false
proto.number = false
proto.commaSeparated = false
proto.spaceSeparated = false
proto.commaOrSpaceSeparated = false
proto.mustUseProperty = false
proto.defined = false

function Info(property, attribute) {
  this.property = property
  this.attribute = attribute
}


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var caseSensitiveTransform = __webpack_require__(3058)

module.exports = caseInsensitiveTransform

function caseInsensitiveTransform(attributes, property) {
  return caseSensitiveTransform(attributes, property.toLowerCase())
}


/***/ }),
/* 1267 */
/***/ (function(module, exports) {

exports = module.exports = trim;

function trim(str){
  if (str.trim) return str.trim();
  return exports.right(exports.left(str));
}

exports.left = function(str){
  if (str.trimLeft) return str.trimLeft();

  return str.replace(/^\s\s*/, '');
};

exports.right = function(str){
  if (str.trimRight) return str.trimRight();

  var whitespace_pattern = /\s/,
      i = str.length;
  while (whitespace_pattern.test(str.charAt(--i)));

  return str.slice(0, i + 1);
};


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = decimal

/* Check if the given character code, or the character
 * code at the first character, is decimal. */
function decimal(character) {
  var code = typeof character === 'string' ? character.charCodeAt(0) : character

  return code >= 48 && code <= 57 /* 0-9 */
}


/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (['abap', 'actionscript', 'ada', 'apacheconf', 'apl', 'applescript', 'arduino', 'arff', 'asciidoc', 'asm6502', 'aspnet', 'autohotkey', 'autoit', 'bash', 'basic', 'batch', 'bison', 'brainfuck', 'bro', 'c', 'clike', 'clojure', 'coffeescript', 'cpp', 'crystal', 'csharp', 'csp', 'css-extras', 'css', 'd', 'dart', 'diff', 'django', 'docker', 'eiffel', 'elixir', 'elm', 'erb', 'erlang', 'flow', 'fortran', 'fsharp', 'gedcom', 'gherkin', 'git', 'glsl', 'go', 'graphql', 'groovy', 'haml', 'handlebars', 'haskell', 'haxe', 'hpkp', 'hsts', 'http', 'ichigojam', 'icon', 'inform7', 'ini', 'io', 'j', 'java', 'javascript', 'jolie', 'json', 'jsx', 'julia', 'keyman', 'kotlin', 'latex', 'less', 'liquid', 'lisp', 'livescript', 'lolcode', 'lua', 'makefile', 'markdown', 'markup-templating', 'markup', 'matlab', 'mel', 'mizar', 'monkey', 'n4js', 'nasm', 'nginx', 'nim', 'nix', 'nsis', 'objectivec', 'ocaml', 'opencl', 'oz', 'parigp', 'parser', 'pascal', 'perl', 'php-extras', 'php', 'plsql', 'powershell', 'processing', 'prolog', 'properties', 'protobuf', 'pug', 'puppet', 'pure', 'python', 'q', 'qore', 'r', 'reason', 'renpy', 'rest', 'rip', 'roboconf', 'ruby', 'rust', 'sas', 'sass', 'scala', 'scheme', 'scss', 'smalltalk', 'smarty', 'soy', 'sql', 'stylus', 'swift', 'tap', 'tcl', 'textile', 'tsx', 'tt2', 'twig', 'typescript', 'vbnet', 'velocity', 'verilog', 'vhdl', 'vim', 'visual-basic', 'wasm', 'wiki', 'xeora', 'xojo', 'xquery', 'yaml']);

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var refractor = __webpack_require__(492)

module.exports = refractor

refractor.register(__webpack_require__(1121))
refractor.register(__webpack_require__(1122))
refractor.register(__webpack_require__(1123))
refractor.register(__webpack_require__(1124))
refractor.register(__webpack_require__(1125))
refractor.register(__webpack_require__(1126))
refractor.register(__webpack_require__(1127))
refractor.register(__webpack_require__(1128))
refractor.register(__webpack_require__(1129))
refractor.register(__webpack_require__(1130))
refractor.register(__webpack_require__(1131))
refractor.register(__webpack_require__(1132))
refractor.register(__webpack_require__(1133))
refractor.register(__webpack_require__(1134))
refractor.register(__webpack_require__(486))
refractor.register(__webpack_require__(1135))
refractor.register(__webpack_require__(1136))
refractor.register(__webpack_require__(1137))
refractor.register(__webpack_require__(1138))
refractor.register(__webpack_require__(137))
refractor.register(__webpack_require__(1140))
refractor.register(__webpack_require__(1141))
refractor.register(__webpack_require__(307))
refractor.register(__webpack_require__(1142))
refractor.register(__webpack_require__(1143))
refractor.register(__webpack_require__(1144))
refractor.register(__webpack_require__(1145))
refractor.register(__webpack_require__(1147))
refractor.register(__webpack_require__(1148))
refractor.register(__webpack_require__(1149))
refractor.register(__webpack_require__(1150))
refractor.register(__webpack_require__(1151))
refractor.register(__webpack_require__(1152))
refractor.register(__webpack_require__(1153))
refractor.register(__webpack_require__(1154))
refractor.register(__webpack_require__(1155))
refractor.register(__webpack_require__(1156))
refractor.register(__webpack_require__(1157))
refractor.register(__webpack_require__(1158))
refractor.register(__webpack_require__(1159))
refractor.register(__webpack_require__(1160))
refractor.register(__webpack_require__(1161))
refractor.register(__webpack_require__(1162))
refractor.register(__webpack_require__(1163))
refractor.register(__webpack_require__(1164))
refractor.register(__webpack_require__(1165))
refractor.register(__webpack_require__(1166))
refractor.register(__webpack_require__(1167))
refractor.register(__webpack_require__(1168))
refractor.register(__webpack_require__(1169))
refractor.register(__webpack_require__(1170))
refractor.register(__webpack_require__(1171))
refractor.register(__webpack_require__(1172))
refractor.register(__webpack_require__(1173))
refractor.register(__webpack_require__(1174))
refractor.register(__webpack_require__(1175))
refractor.register(__webpack_require__(1176))
refractor.register(__webpack_require__(1177))
refractor.register(__webpack_require__(1178))
refractor.register(__webpack_require__(1179))
refractor.register(__webpack_require__(487))
refractor.register(__webpack_require__(1181))
refractor.register(__webpack_require__(1182))
refractor.register(__webpack_require__(488))
refractor.register(__webpack_require__(1183))
refractor.register(__webpack_require__(1184))
refractor.register(__webpack_require__(1185))
refractor.register(__webpack_require__(1186))
refractor.register(__webpack_require__(1187))
refractor.register(__webpack_require__(1188))
refractor.register(__webpack_require__(1189))
refractor.register(__webpack_require__(1190))
refractor.register(__webpack_require__(1191))
refractor.register(__webpack_require__(1192))
refractor.register(__webpack_require__(1193))
refractor.register(__webpack_require__(1194))
refractor.register(__webpack_require__(1195))
refractor.register(__webpack_require__(1197))
refractor.register(__webpack_require__(1198))
refractor.register(__webpack_require__(1199))
refractor.register(__webpack_require__(1200))
refractor.register(__webpack_require__(1201))
refractor.register(__webpack_require__(1202))
refractor.register(__webpack_require__(1203))
refractor.register(__webpack_require__(1204))
refractor.register(__webpack_require__(1205))
refractor.register(__webpack_require__(1206))
refractor.register(__webpack_require__(1207))
refractor.register(__webpack_require__(1208))
refractor.register(__webpack_require__(1209))
refractor.register(__webpack_require__(1210))
refractor.register(__webpack_require__(1211))
refractor.register(__webpack_require__(1212))
refractor.register(__webpack_require__(1213))
refractor.register(__webpack_require__(1214))
refractor.register(__webpack_require__(1215))
refractor.register(__webpack_require__(489))
refractor.register(__webpack_require__(1216))
refractor.register(__webpack_require__(1217))
refractor.register(__webpack_require__(1218))
refractor.register(__webpack_require__(1219))
refractor.register(__webpack_require__(1220))
refractor.register(__webpack_require__(1221))
refractor.register(__webpack_require__(1222))
refractor.register(__webpack_require__(1223))
refractor.register(__webpack_require__(1224))
refractor.register(__webpack_require__(1225))
refractor.register(__webpack_require__(1226))
refractor.register(__webpack_require__(1227))
refractor.register(__webpack_require__(1228))
refractor.register(__webpack_require__(1229))
refractor.register(__webpack_require__(1230))
refractor.register(__webpack_require__(1231))
refractor.register(__webpack_require__(1232))
refractor.register(__webpack_require__(1233))
refractor.register(__webpack_require__(308))
refractor.register(__webpack_require__(1234))
refractor.register(__webpack_require__(1235))
refractor.register(__webpack_require__(1236))
refractor.register(__webpack_require__(1237))
refractor.register(__webpack_require__(1238))
refractor.register(__webpack_require__(1239))
refractor.register(__webpack_require__(1240))
refractor.register(__webpack_require__(1241))
refractor.register(__webpack_require__(1242))
refractor.register(__webpack_require__(490))
refractor.register(__webpack_require__(1243))
refractor.register(__webpack_require__(1244))
refractor.register(__webpack_require__(1245))
refractor.register(__webpack_require__(1246))
refractor.register(__webpack_require__(1247))
refractor.register(__webpack_require__(1248))
refractor.register(__webpack_require__(1249))
refractor.register(__webpack_require__(1250))
refractor.register(__webpack_require__(491))
refractor.register(__webpack_require__(1251))
refractor.register(__webpack_require__(1252))
refractor.register(__webpack_require__(1253))
refractor.register(__webpack_require__(1254))
refractor.register(__webpack_require__(1255))
refractor.register(__webpack_require__(1256))
refractor.register(__webpack_require__(1257))
refractor.register(__webpack_require__(1258))
refractor.register(__webpack_require__(1259))
refractor.register(__webpack_require__(1260))
refractor.register(__webpack_require__(1261))
refractor.register(__webpack_require__(1262))


/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SUPPORTED_LANGUAGE_ALIASES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeLanguage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_memoize_one__ = __webpack_require__(339);
/* eslint import/no-dynamic-require: 0, global-require: 0 */

/*
 * These values all those are supported by ADF.
 * The comments show mappings of these values to the corresponding
 * language definition file, or to that of the most
 * syntactically similar language supported by highlightjs
 */

var SUPPORTED_LANGUAGE_ALIASES = Object.freeze([{
  name: 'PHP',
  alias: ['php', 'php3', 'php4', 'php5'],
  value: 'php'
}, {
  name: 'Java',
  alias: ['java'],
  value: 'java'
}, {
  name: 'CSharp',
  alias: ['csharp', 'c#'],
  value: 'cs'
}, {
  name: 'Python',
  alias: ['python', 'py'],
  value: 'python'
}, {
  name: 'JavaScript',
  alias: ['javascript', 'js'],
  value: 'javascript'
}, {
  name: 'Html',
  alias: ['html'],
  value: 'xml'
}, {
  name: 'C++',
  alias: ['c++', 'cpp', 'clike'],
  value: 'cpp'
}, {
  name: 'Ruby',
  alias: ['ruby', 'rb', 'duby'],
  value: 'ruby'
}, {
  name: 'Objective-C',
  alias: ['objective-c', 'objectivec', 'obj-c', 'objc'],
  value: 'objectivec'
}, {
  name: 'C',
  alias: ['c'],
  value: 'cpp'
}, {
  name: 'Swift',
  alias: ['swift'],
  value: 'swift'
}, {
  name: 'TeX',
  alias: ['tex', 'latex'],
  value: 'tex'
}, {
  name: 'Shell',
  alias: ['shell', 'bash', 'sh', 'ksh', 'zsh'],
  value: 'shell'
}, {
  name: 'Scala',
  alias: ['scala'],
  value: 'scala'
}, {
  name: 'Go',
  alias: ['go'],
  value: 'go'
}, {
  name: 'ActionScript',
  alias: ['actionscript', 'actionscript3', 'as'],
  value: 'actionscript'
}, {
  name: 'ColdFusion',
  alias: ['coldfusion'],
  value: 'xml'
}, {
  name: 'JavaFX',
  alias: ['javafx', 'jfx'],
  value: 'java'
}, {
  name: 'VbNet',
  alias: ['vbnet', 'vb.net'],
  value: 'vbnet'
}, {
  name: 'JSON',
  alias: ['json'],
  value: 'json'
}, {
  name: 'MATLAB',
  alias: ['matlab'],
  value: 'matlab'
}, {
  name: 'Groovy',
  alias: ['groovy'],
  value: 'groovy'
}, {
  name: 'SQL',
  alias: ['sql', 'postgresql', 'postgres', 'plpgsql', 'psql', 'postgresql-console', 'postgres-console', 'tsql', 't-sql', 'mysql', 'sqlite'],
  value: 'sql'
}, {
  name: 'R',
  alias: ['r'],
  value: 'r'
}, {
  name: 'Perl',
  alias: ['perl', 'pl'],
  value: 'perl'
}, {
  name: 'Lua',
  alias: ['lua'],
  value: 'lua'
}, {
  name: 'Delphi',
  alias: ['delphi', 'pas', 'pascal', 'objectpascal'],
  value: 'delphi'
}, {
  name: 'XML',
  alias: ['xml'],
  value: 'xml'
}, {
  name: 'TypeScript',
  alias: ['typescript', 'ts'],
  value: 'typescript'
}, {
  name: 'CoffeeScript',
  alias: ['coffeescript', 'coffee-script', 'coffee'],
  value: 'coffeescript'
}, {
  name: 'Haskell',
  alias: ['haskell', 'hs'],
  value: 'haskell'
}, {
  name: 'Puppet',
  alias: ['puppet'],
  value: 'puppet'
}, {
  name: 'Arduino',
  alias: ['arduino'],
  value: 'arduino'
}, {
  name: 'Fortran',
  alias: ['fortran'],
  value: 'fortran'
}, {
  name: 'Erlang',
  alias: ['erlang', 'erl'],
  value: 'erlang'
}, {
  name: 'PowerShell',
  alias: ['powershell', 'posh', 'ps1', 'psm1'],
  value: 'powershell'
}, {
  name: 'Haxe',
  alias: ['haxe', 'hx', 'hxsl'],
  value: 'haxe'
}, {
  name: 'Elixir',
  alias: ['elixir', 'ex', 'exs'],
  value: 'elixir'
}, {
  name: 'Verilog',
  alias: ['verilog', 'v'],
  value: 'verilog'
}, {
  name: 'Rust',
  alias: ['rust'],
  value: 'rust'
}, {
  name: 'VHDL',
  alias: ['vhdl'],
  value: 'vhdl'
}, {
  name: 'Sass',
  alias: ['sass'],
  value: 'less'
}, {
  name: 'OCaml',
  alias: ['ocaml'],
  value: 'ocaml'
}, {
  name: 'Dart',
  alias: ['dart'],
  value: 'dart'
}, {
  name: 'CSS',
  alias: ['css'],
  value: 'css'
}, {
  name: 'reStructuredText',
  alias: ['restructuredtext', 'rst', 'rest'],
  value: 'rest'
}, {
  name: 'ObjectPascal',
  alias: ['objectpascal'],
  value: 'delphi'
}, {
  name: 'Kotlin',
  alias: ['kotlin'],
  value: 'kotlin'
}, {
  name: 'D',
  alias: ['d'],
  value: 'd'
}, {
  name: 'Octave',
  alias: ['octave'],
  value: 'matlab'
}, {
  name: 'QML',
  alias: ['qbs', 'qml'],
  value: 'qml'
}, {
  name: 'Prolog',
  alias: ['prolog'],
  value: 'prolog'
}, {
  name: 'FoxPro',
  alias: ['foxpro', 'vfp', 'clipper', 'xbase'],
  value: 'vbnet'
}, {
  name: 'Scheme',
  alias: ['scheme', 'scm'],
  value: 'scheme'
}, {
  name: 'CUDA',
  alias: ['cuda', 'cu'],
  value: 'cpp'
}, {
  name: 'Julia',
  alias: ['julia', 'jl'],
  value: 'julia'
}, {
  name: 'Racket',
  alias: ['racket', 'rkt'],
  value: 'lisp'
}, {
  name: 'Ada',
  alias: ['ada', 'ada95', 'ada2005'],
  value: 'ada'
}, {
  name: 'Tcl',
  alias: ['tcl'],
  value: 'tcl'
}, {
  name: 'Mathematica',
  alias: ['mathematica', 'mma', 'nb'],
  value: 'mathematica'
}, {
  name: 'Autoit',
  alias: ['autoit'],
  value: 'autoit'
}, {
  name: 'StandardML',
  alias: ['standardmL', 'sml', 'standardml'],
  value: 'sml'
}, {
  name: 'Objective-J',
  alias: ['objective-j', 'objectivej', 'obj-j', 'objj'],
  value: 'objectivec'
}, {
  name: 'Smalltalk',
  alias: ['smalltalk', 'squeak', 'st'],
  value: 'smalltalk'
}, {
  name: 'Vala',
  alias: ['vala', 'vapi'],
  value: 'vala'
}, {
  name: 'ABAP',
  alias: ['abap'],
  value: 'sql'
}, {
  name: 'LiveScript',
  alias: ['livescript', 'live-script'],
  value: 'livescript'
}, {
  name: 'XQuery',
  alias: ['xquery', 'xqy', 'xq', 'xql', 'xqm'],
  value: 'xquery'
}, {
  name: 'PlainText',
  alias: ['text', 'plaintext'],
  value: 'text'
}, {
  name: 'Yaml',
  alias: ['yaml', 'yml'],
  value: 'yaml'
}]);
var normalizeLanguage = Object(__WEBPACK_IMPORTED_MODULE_0_memoize_one__["a" /* default */])(function (language) {
  if (!language) {
    return '';
  }

  var match = SUPPORTED_LANGUAGE_ALIASES.find(function (val) {
    return val.name === language || val.alias.includes(language);
  }); // Fallback to plain monospaced text if language passed but not supported

  return match ? match.value : 'text';
});

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultTheme__ = __webpack_require__(3078);



var codeContainerStyle = {
  fontFamily: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["codeFontFamily"],
  fontSize: '12px',
  lineHeight: 20 / 12,
  padding: Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])()
};

var lineNumberContainerStyle = function lineNumberContainerStyle(theme) {
  return {
    fontSize: "".concat(Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["fontSize"])(), "px"),
    lineHeight: 20 / 14,
    color: theme.lineNumberColor,
    backgroundColor: theme.lineNumberBgColor,
    flexShrink: 0,
    padding: Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])(),
    textAlign: 'right',
    userSelect: 'none'
  };
};

var sharedCodeStyle = function sharedCodeStyle(theme) {
  return {
    key: {
      color: theme.keywordColor,
      fontWeight: 'bolder'
    },
    keyword: {
      color: theme.keywordColor,
      fontWeight: 'bolder'
    },
    'attr-name': {
      color: theme.attributeColor
    },
    selector: {
      color: theme.selectorTagColor
    },
    comment: {
      color: theme.commentColor,
      fontFamily: "SFMono-MediumItalic, ".concat(Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["codeFontFamily"])()),
      fontStyle: 'italic'
    },
    'block-comment': {
      color: theme.commentColor,
      fontFamily: "SFMono-MediumItalic, ".concat(Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["codeFontFamily"])()),
      fontStyle: 'italic'
    },
    'function-name': {
      color: theme.sectionColor
    },
    'class-name': {
      color: theme.sectionColor
    },
    doctype: {
      color: theme.docTagColor
    },
    substr: {
      color: theme.substringColor
    },
    namespace: {
      color: theme.nameColor
    },
    builtin: {
      color: theme.builtInColor
    },
    entity: {
      color: theme.literalColor
    },
    bullet: {
      color: theme.bulletColor
    },
    code: {
      color: theme.codeColor
    },
    addition: {
      color: theme.additionColor
    },
    regex: {
      color: theme.regexpColor
    },
    symbol: {
      color: theme.symbolColor
    },
    variable: {
      color: theme.variableColor
    },
    url: {
      color: theme.linkColor
    },
    'selector-attr': {
      color: theme.selectorAttributeColor
    },
    'selector-pseudo': {
      color: theme.selectorPseudoColor
    },
    type: {
      color: theme.typeColor
    },
    string: {
      color: theme.stringColor
    },
    quote: {
      color: theme.quoteColor
    },
    tag: {
      color: theme.templateTagColor
    },
    deletion: {
      color: theme.deletionColor
    },
    title: {
      color: theme.titleColor
    },
    section: {
      color: theme.sectionColor
    },
    'meta-keyword': {
      color: theme.metaKeywordColor
    },
    meta: {
      color: theme.metaColor
    },
    italic: {
      fontStyle: 'italic'
    },
    bold: {
      fontWeight: 'bolder'
    },
    function: {
      color: theme.functionColor
    },
    number: {
      color: theme.numberColor
    }
  };
};

var codeStyle = function codeStyle(theme) {
  return {
    fontFamily: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["codeFontFamily"],
    fontSize: '12px',
    background: theme.backgroundColor,
    color: theme.textColor,
    borderRadius: Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["borderRadius"])(),
    display: 'flex',
    lineHeight: 20 / 12,
    overflowX: 'auto',
    whiteSpace: 'pre'
  };
};

var codeBlockStyle = function codeBlockStyle(theme) {
  return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({
    'pre[class*="language-"]': codeStyle(theme)
  }, sharedCodeStyle(theme));
};

var inlineCodeStyle = function inlineCodeStyle(theme) {
  return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({
    'pre[class*="language-"]': __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, codeStyle(theme), {
      padding: '2px 4px',
      display: 'inline',
      whiteSpace: 'pre-wrap'
    })
  }, sharedCodeStyle(theme));
};

function applyTheme() {
  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var newTheme = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__defaultTheme__["a" /* defaultColors */])(theme), theme);

  return {
    lineNumberContainerStyle: lineNumberContainerStyle(newTheme),
    codeBlockStyle: codeBlockStyle(newTheme),
    inlineCodeStyle: inlineCodeStyle(newTheme),
    codeContainerStyle: codeContainerStyle
  };
}

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = overflowShadow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf_schd__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Renderer_style__ = __webpack_require__(495);





var isIE11 = __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["t" /* browser */].ie_version === 11;
function overflowShadow(Component, options) {
    return /** @class */ (function (_super) {
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](OverflowShadow, _super);
        function OverflowShadow() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = {
                showLeftShadow: false,
                showRightShadow: false,
            };
            _this.handleScroll = function (event) {
                if (!_this.overflowContainer || event.target !== _this.overflowContainer) {
                    return;
                }
                _this.setState(function () { return ({
                    showLeftShadow: _this.overflowContainer.scrollLeft > 0,
                }); });
            };
            _this.updateRightShadow = function () {
                if (_this.overflowContainer && _this.scrollable.length) {
                    var scrollableWidth = _this.calcualteScrollableWidth();
                    var diff = scrollableWidth - _this.overflowContainer.offsetWidth;
                    var showRightShadow_1 = diff > 0 && diff > _this.overflowContainer.scrollLeft;
                    if (showRightShadow_1 !== _this.state.showRightShadow) {
                        _this.setState(function () { return ({
                            showRightShadow: showRightShadow_1,
                        }); });
                    }
                }
            };
            _this.handleUpdateRightShadow = Object(__WEBPACK_IMPORTED_MODULE_2_raf_schd__["a" /* default */])(_this.updateRightShadow);
            _this.handleScrollDebounced = Object(__WEBPACK_IMPORTED_MODULE_2_raf_schd__["a" /* default */])(_this.handleScroll);
            _this.calcualteScrollableWidth = function () {
                var width = 0;
                for (var i = 0; i < _this.scrollable.length; i++) {
                    var scrollableElement = _this.scrollable[i];
                    width += scrollableElement.scrollWidth;
                }
                return width;
            };
            _this.handleContainer = function (container) {
                if (!container || _this.container) {
                    return;
                }
                _this.container = container;
                _this.overflowContainer = container.querySelector(options.overflowSelector);
                _this.scrollable = container.querySelectorAll(options.scrollableSelector);
                if (!(_this.overflowContainer && _this.scrollable)) {
                    return;
                }
                _this.updateRightShadow();
                if (!isIE11) {
                    _this.overflowContainer.addEventListener('scroll', _this.handleScrollDebounced);
                }
            };
            return _this;
        }
        OverflowShadow.prototype.componentWillUnmount = function () {
            if (this.overflowContainer && !isIE11) {
                this.overflowContainer.removeEventListener('scroll', this.handleScrollDebounced);
            }
            this.handleUpdateRightShadow.cancel();
            this.handleScrollDebounced.cancel();
        };
        OverflowShadow.prototype.componentDidUpdate = function () {
            this.handleUpdateRightShadow();
        };
        OverflowShadow.prototype.render = function () {
            var _a = this.state, showLeftShadow = _a.showLeftShadow, showRightShadow = _a.showRightShadow;
            var classNames = [
                showRightShadow && __WEBPACK_IMPORTED_MODULE_4__Renderer_style__["c" /* shadowClassNames */].RIGHT_SHADOW,
                showLeftShadow && __WEBPACK_IMPORTED_MODULE_4__Renderer_style__["c" /* shadowClassNames */].LEFT_SHADOW,
            ]
                .filter(Boolean)
                .join(' ');
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Component, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ handleRef: this.handleContainer, shadowClassNames: classNames }, this.props)));
        };
        return OverflowShadow;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
}
//# sourceMappingURL=overflow-shadow.js.map

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Inline;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function Inline(props) {
    var children = props.children;
    var childCount = __WEBPACK_IMPORTED_MODULE_0_react__["Children"].toArray(children).length;
    if (!childCount) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, "\u00A0");
    }
    return children;
}
//# sourceMappingURL=inline.js.map

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var TableHeader = function (props) {
    var style = {};
    if (props.background) {
        style.backgroundColor = props.background;
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("th", { style: style, rowSpan: props.rowspan, colSpan: props.colspan }, props.children));
};
/* harmony default export */ __webpack_exports__["a"] = (TableHeader);
//# sourceMappingURL=tableHeader.js.map

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return nodeSerializers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return markSerializers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nodes_blockquote__ = __webpack_require__(3138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nodes_bullet_list__ = __webpack_require__(3139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodes_code_block__ = __webpack_require__(3140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nodes_decision_item__ = __webpack_require__(3141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nodes_decision_list__ = __webpack_require__(3142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nodes_emoji__ = __webpack_require__(3143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nodes_hard_break__ = __webpack_require__(3144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__nodes_heading__ = __webpack_require__(3145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__nodes_list_item__ = __webpack_require__(3146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__nodes_mention__ = __webpack_require__(3147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__nodes_ordered_list__ = __webpack_require__(3148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__nodes_panel__ = __webpack_require__(3149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__nodes_paragraph__ = __webpack_require__(3150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__nodes_rule__ = __webpack_require__(3151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__nodes_table__ = __webpack_require__(3152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__nodes_table_cell__ = __webpack_require__(3153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__nodes_table_header__ = __webpack_require__(3154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__nodes_table_row__ = __webpack_require__(3155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__nodes_text__ = __webpack_require__(3156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__nodes_unknown_block__ = __webpack_require__(3157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__marks_code__ = __webpack_require__(3158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__marks_strong__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__marks_link__ = __webpack_require__(3159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__marks_strike__ = __webpack_require__(3160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__marks_subsup__ = __webpack_require__(3161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__marks_text_color__ = __webpack_require__(3162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__marks_underline__ = __webpack_require__(3163);




























var renderNothing = function () { return ''; };
var nodeSerializers = {
    bodiedExtension: renderNothing,
    blockquote: __WEBPACK_IMPORTED_MODULE_0__nodes_blockquote__["a" /* default */],
    bulletList: __WEBPACK_IMPORTED_MODULE_1__nodes_bullet_list__["a" /* default */],
    codeBlock: __WEBPACK_IMPORTED_MODULE_2__nodes_code_block__["a" /* default */],
    decisionList: __WEBPACK_IMPORTED_MODULE_4__nodes_decision_list__["a" /* default */],
    decisionItem: __WEBPACK_IMPORTED_MODULE_3__nodes_decision_item__["a" /* default */],
    emoji: __WEBPACK_IMPORTED_MODULE_5__nodes_emoji__["a" /* default */],
    image: renderNothing,
    hardBreak: __WEBPACK_IMPORTED_MODULE_6__nodes_hard_break__["a" /* default */],
    heading: __WEBPACK_IMPORTED_MODULE_7__nodes_heading__["a" /* default */],
    listItem: __WEBPACK_IMPORTED_MODULE_8__nodes_list_item__["a" /* default */],
    mediaGroup: renderNothing,
    mention: __WEBPACK_IMPORTED_MODULE_9__nodes_mention__["a" /* default */],
    orderedList: __WEBPACK_IMPORTED_MODULE_10__nodes_ordered_list__["a" /* default */],
    panel: __WEBPACK_IMPORTED_MODULE_11__nodes_panel__["a" /* default */],
    paragraph: __WEBPACK_IMPORTED_MODULE_12__nodes_paragraph__["a" /* default */],
    rule: __WEBPACK_IMPORTED_MODULE_13__nodes_rule__["a" /* default */],
    table: __WEBPACK_IMPORTED_MODULE_14__nodes_table__["a" /* default */],
    tableCell: __WEBPACK_IMPORTED_MODULE_15__nodes_table_cell__["a" /* default */],
    tableHeader: __WEBPACK_IMPORTED_MODULE_16__nodes_table_header__["a" /* default */],
    tableRow: __WEBPACK_IMPORTED_MODULE_17__nodes_table_row__["a" /* default */],
    taskList: renderNothing,
    text: __WEBPACK_IMPORTED_MODULE_18__nodes_text__["a" /* default */],
    unknownBlock: __WEBPACK_IMPORTED_MODULE_19__nodes_unknown_block__["a" /* default */],
};
var markSerializers = {
    code: __WEBPACK_IMPORTED_MODULE_20__marks_code__["a" /* default */],
    em: __WEBPACK_IMPORTED_MODULE_21__marks_strong__["a" /* default */],
    link: __WEBPACK_IMPORTED_MODULE_22__marks_link__["a" /* default */],
    strike: __WEBPACK_IMPORTED_MODULE_23__marks_strike__["a" /* default */],
    strong: __WEBPACK_IMPORTED_MODULE_21__marks_strong__["a" /* default */],
    subsup: __WEBPACK_IMPORTED_MODULE_24__marks_subsup__["a" /* default */],
    textColor: __WEBPACK_IMPORTED_MODULE_25__marks_text_color__["a" /* default */],
    underline: __WEBPACK_IMPORTED_MODULE_26__marks_underline__["a" /* default */],
};
//# sourceMappingURL=serializers.js.map

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = strong;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(33);

var css = Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* serializeStyle */])({
    'font-weight': 'bold',
});
function strong(_a) {
    var mark = _a.mark, text = _a.text;
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* createTag */])('span', { style: css }, text);
}
//# sourceMappingURL=strong.js.map

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tabs__ = __webpack_require__(3173);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Tabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabList__ = __webpack_require__(3175);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__components_TabList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Tab__ = __webpack_require__(3176);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__components_Tab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TabPanel__ = __webpack_require__(3177);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__components_TabPanel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_uuid__ = __webpack_require__(1280);
/* unused harmony reexport resetIdCounter */






/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export childrenPropType */
/* unused harmony export onSelectPropType */
/* unused harmony export selectedIndexPropType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elementTypes__ = __webpack_require__(309);


function childrenPropType(props, propName, componentName) {
  var error;
  var tabsCount = 0;
  var panelsCount = 0;
  var tabListFound = false;
  var listTabs = [];
  var children = props[propName];
  Object(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["a" /* deepForEach */])(children, function (child) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["b" /* isTabList */])(child)) {
      if (child.props && child.props.children && typeof child.props.children === 'object') {
        Object(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["a" /* deepForEach */])(child.props.children, function (listChild) {
          return listTabs.push(listChild);
        });
      }

      if (tabListFound) {
        error = new Error("Found multiple 'TabList' components inside 'Tabs'. Only one is allowed.");
      }

      tabListFound = true;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["a" /* isTab */])(child)) {
      if (!tabListFound || listTabs.indexOf(child) === -1) {
        error = new Error("Found a 'Tab' component outside of the 'TabList' component. 'Tab' components " + "have to be inside the 'TabList' component.");
      }

      tabsCount++;
    } else if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child)) {
      panelsCount++;
    }
  });

  if (!error && tabsCount !== panelsCount) {
    error = new Error("There should be an equal number of 'Tab' and 'TabPanel' in `" + componentName + "`. " + ("Received " + tabsCount + " 'Tab' and " + panelsCount + " 'TabPanel'."));
  }

  return error;
}
function onSelectPropType(props, propName, componentName, location, propFullName) {
  var prop = props[propName];
  var name = propFullName || propName;
  var error = null;

  if (prop && typeof prop !== 'function') {
    error = new Error("Invalid " + location + " `" + name + "` of type `" + typeof prop + "` supplied " + ("to `" + componentName + "`, expected `function`."));
  } else if (props.selectedIndex != null && prop == null) {
    error = new Error("The " + location + " `" + name + "` is marked as required in `" + componentName + "`, but " + "its value is `undefined` or `null`.\n" + "`onSelect` is required when `selectedIndex` is also set. Not doing so will " + "make the tabs not do anything, as `selectedIndex` indicates that you want to " + "handle the selected tab yourself.\n" + "If you only want to set the inital tab replace `selectedIndex` with `defaultIndex`.");
  }

  return error;
}
function selectedIndexPropType(props, propName, componentName, location, propFullName) {
  var prop = props[propName];
  var name = propFullName || propName;
  var error = null;

  if (prop != null && typeof prop !== 'number') {
    error = new Error("Invalid " + location + " `" + name + "` of type `" + typeof prop + "` supplied to " + ("`" + componentName + "`, expected `number`."));
  } else if (props.defaultIndex != null && prop != null) {
    return new Error("The " + location + " `" + name + "` cannot be used together with `defaultIndex` " + ("in `" + componentName + "`.\n") + ("Either remove `" + name + "` to let `" + componentName + "` handle the selected ") + "tab internally or remove `defaultIndex` to handle it yourself.");
  }

  return error;
}

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uuid;
/* unused harmony export reset */
// Get a universally unique identifier
var count = 0;
function uuid() {
  return "react-tabs-" + count++;
}
function reset() {
  count = 0;
}

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getTabsCount;
/* harmony export (immutable) */ __webpack_exports__["a"] = getPanelsCount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elementTypes__ = __webpack_require__(309);


function getTabsCount(children) {
  var tabCount = 0;
  Object(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["a" /* deepForEach */])(children, function (child) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["a" /* isTab */])(child)) tabCount++;
  });
  return tabCount;
}
function getPanelsCount(children) {
  var panelCount = 0;
  Object(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["a" /* deepForEach */])(children, function (child) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child)) panelCount++;
  });
  return panelCount;
}

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(310);

function getTheme(props) {
  if (props && props.theme && props.theme.__ATLASKIT_THEME__) {
    // $FlowFixMe - cannot narrow type between input types
    return props.theme.__ATLASKIT_THEME__;
  }

  if (props && props.theme && props.theme.mode) {
    // $FlowFixMe - cannot narrow type between input types
    return props.theme;
  }

  return {
    mode: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_THEME_MODE */]
  };
}

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = forceImmutable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(97);
function forceImmutable(obj){return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["d" /* isImmutable */])(obj)?obj:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["c" /* fromJS */])(obj);}

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_index__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AccessGuide=function(_React$Component){_inherits(AccessGuide,_React$Component);function AccessGuide(){_classCallCheck(this,AccessGuide);return _possibleConstructorReturn(this,(AccessGuide.__proto__||Object.getPrototypeOf(AccessGuide)).apply(this,arguments));}_createClass(AccessGuide,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["f" /* Container */],{section:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["i" /* H1 */],null,'How Tool Access Works'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'We run 3 applications from vendor Atlassian',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ncss-list-ul'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},'Bitbucket'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},'Confluence'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},'Jira')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Access within each Atlassian app is based on permission levels. These levels work in a top-down hierarchy.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["k" /* H4 */],{className:'pb5-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Primary Permission level')),'At the topmost level, you must have ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'application access'),' permission, namely login rights to an application.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["k" /* H4 */],{className:'pb5-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Secondary permission levels')),'At subsequent levels, permissions are focused on specific ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'objects'),' within an application such as projects or spaces. Permissions at lower levels require that higher levels are in place. As an example, Confluence Page Restrictions won\'t take effect unless higher level App and Space permissions are in place.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{className:'dobule-space'}),'The Tool Access Guide below describes objects within each app and their respective permission layers.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["f" /* Container */],{section:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["i" /* H1 */],null,'Tool Access Guide'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'triple-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'split-container-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["j" /* H3 */],{className:'pb5-sm'},'JIRA Access'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["k" /* H4 */],{className:'pb5-sm indent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Permission Levels')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',{className:'double-indent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Application access.'),' Use this portal to check and gain access'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Project permissions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'(Optional) Issue Scurity')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["j" /* H3 */],{className:'pb5-sm'},'Project'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Project permissions are based on a permission "scheme" configured for the project at its creation time. The permission scheme consists of about 30 different rights including:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ncss-list-ul double-indent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},'View issue (called "Browse project")'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},'Edit issue'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},'Transition issue'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},'Manage sprints')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Each right is assigned to one or more fields or ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'roles'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["k" /* H4 */],{className:'pb5-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Roles')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Project admins can assign users or groups to specific ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'roles'),'.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'There are 3 main roles:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',{className:'double-indent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Administrators - Manage the project'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Developers - Can be assigned & work issues'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Users - Read only access to issues')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Roles are an abstraction layer above users and groups. In one project you may be an Admin, in another a Developer, and a third a User.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["k" /* H4 */],{className:'pb5-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Roles + Permission Scheme = Your rights within a project')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The intersection of roles and the project permission scheme determines the rights you have within a project.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'Example:'),' In many project permission schemes, the ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Administrators'),' role is assigned the "Manage Sprint" permission.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["j" /* H3 */],{className:'pb5-sm'},'Issue Security'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ncss-list-ul double-indent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},'Optional'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},'Is ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'subtractive'),' - cannot be used to grant access if a user does not have project permissions')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["k" /* H4 */],{className:'pb5-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Reference Pages')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ncss-list-ul double-indent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'link',href:'https://confluence.nike.com/display/BAAT/About+JIRA+Permissions',target:'_blank'},'About JIRA Permissions')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'link',href:'https://confluence.nike.com/display/BAAT/How+to+add+users+to+project+roles+in+JIRA',target:'_blank'},'How to add users to project roles in JIRA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'link',href:'https://confluence.nike.com/display/BAAT/How+to+find+JIRA+project+admins',target:'_blank'},'How to find JIRA project admins')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'split-container-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["j" /* H3 */],{className:'pb5-sm'},'Confluence Access'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["k" /* H4 */],{className:'pb5-sm indent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Permission Levels')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',{className:'double-indent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Application access.'),' Use this portal to check and gain access'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Space permissions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'(Optional) Page Restrictions')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["j" /* H3 */],{className:'pb5-sm'},'Space'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Space permissions are managed locally by space admins. There are about 15 different rights specified including:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ncss-list-ul double-indent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},'View space'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},'Add or edit pages'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},'Add attachments and comments')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Space admins may add users and/or groups to space permissions.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'To list the space admins, navigate to the space. Use the ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'gear'),' icon in the lower left corner and select ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Overview'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["j" /* H3 */],{className:'pb5-sm'},'Page Restrictions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ncss-list-ul double-indent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},'Optional'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},'Is ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'subtractive'),' - cannot be used to grant access if a user does not have space permissions')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["k" /* H4 */],{className:'pb5-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Reference Pages')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ncss-list-ul double-indent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'link',href:'https://confluence.nike.com/display/BAAT/About+Confluence+Permissions',target:'_blank'},'About Confluence Permissions')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'link',href:'https://confluence.nike.com/display/BAAT/About+Confluence+Page+Restrictions',target:'_blank'},'About Confluence Page Restrictions')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'link',href:'https://confluence.nike.com/display/BAAT/How+a+Space+Administrator+can+manage+access+within+their+space',target:'_blank'},'How a Space Administrator can manage access within their space')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'link',href:'https://confluence.nike.com/display/BAAT/How+to+find+Confluence+space+admins',target:'_blank'},'How to find Confluence space admins')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'split-container-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["j" /* H3 */],{className:'pb5-sm'},'Bitbucket Access'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["k" /* H4 */],{className:'pb5-sm indent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Permission Levels')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',{className:'double-indent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Application access.'),' Use this portal to check and gain access'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Project permissions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Repo permissions')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["j" /* H3 */],{className:'pb5-sm'},'Project'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ncss-list-ul double-indent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},'Project permissions are managed locally by project admins'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},'To request a list of the Bitbucket Project admins, use the ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'General Request'),' form to submit a ticket')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["j" /* H3 */],{className:'pb5-sm'},'Repository'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ncss-list-ul double-indent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},'Repository permissions allow you to extend access to users and groups beyond that already granted via project permissions.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},'Repository permissions are managed locally by repo admins')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index__["k" /* H4 */],{className:'pb5-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Reference Pages')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ncss-list-ul double-indent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ncss-li'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'link',href:'https://confluence.nike.com/display/BAAT/Create+and+manage+Bitbucket+Repositories',target:'_blank'},'Create and manage Bitbucket Repositories')))))));}}]);return AccessGuide;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AccessGuide);

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_index__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_button__ = __webpack_require__(35);
var UserCheckForm=function UserCheckForm(props){var handleSubmit=props.handleSubmit,actionInProgress=props.actionInProgress;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'access-user-check-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */],{key:'UserId',name:'UserId',component:__WEBPACK_IMPORTED_MODULE_2__components_forms_index__["d" /* TextInput */],label:'Nike Username or Email address',title:'Enter a Nike (NTID) username or email address to check a user\'s BAAT application access status. A Nike Username is the short name you use to login to your laptop',placeholder:'Nike Username or Email address',disabled:actionInProgress,className:'pt4-sm ncss-input pr4-sm pb2-sm pl4-sm'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__atlaskit_button__["default"],{type:'submit',appearance:'primary',isLoading:actionInProgress,className:'search-form-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'g72 g72-search'}),' Search')));};var validate=function validate(values){return!values.UserId?'You need to enter Nike username or Email address to check':undefined;};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* reduxForm */])({form:'UserCheck',validate:validate})(UserCheckForm));

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(507);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var arrayInsert = function arrayInsert(form, field, index, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_INSERT"],
    meta: { form: form, field: field, index: index },
    payload: value
  };
};

var arrayMove = function arrayMove(form, field, from, to) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_MOVE"],
    meta: { form: form, field: field, from: from, to: to }
  };
};

var arrayPop = function arrayPop(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_POP"],
    meta: { form: form, field: field }
  };
};

var arrayPush = function arrayPush(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_PUSH"],
    meta: { form: form, field: field },
    payload: value
  };
};

var arrayRemove = function arrayRemove(form, field, index) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE"],
    meta: { form: form, field: field, index: index }
  };
};

var arrayRemoveAll = function arrayRemoveAll(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE_ALL"],
    meta: { form: form, field: field }
  };
};

var arrayShift = function arrayShift(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SHIFT"],
    meta: { form: form, field: field }
  };
};

var arraySplice = function arraySplice(form, field, index, removeNum, value) {
  var action = {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SPLICE"],
    meta: { form: form, field: field, index: index, removeNum: removeNum }
  };
  if (value !== undefined) {
    action.payload = value;
  }
  return action;
};

var arraySwap = function arraySwap(form, field, indexA, indexB) {
  if (indexA === indexB) {
    throw new Error('Swap indices cannot be equal');
  }
  if (indexA < 0 || indexB < 0) {
    throw new Error('Swap indices cannot be negative');
  }
  return { type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SWAP"], meta: { form: form, field: field, indexA: indexA, indexB: indexB } };
};

var arrayUnshift = function arrayUnshift(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_UNSHIFT"],
    meta: { form: form, field: field },
    payload: value
  };
};

var autofill = function autofill(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["AUTOFILL"],
    meta: { form: form, field: field },
    payload: value
  };
};

var blur = function blur(form, field, value, touch) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["BLUR"],
    meta: { form: form, field: field, touch: touch },
    payload: value
  };
};

var change = function change(form, field, value, touch, persistentSubmitErrors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CHANGE"],
    meta: { form: form, field: field, touch: touch, persistentSubmitErrors: persistentSubmitErrors },
    payload: value
  };
};

var clearSubmit = function clearSubmit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT"],
    meta: { form: form }
  };
};

var clearSubmitErrors = function clearSubmitErrors(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT_ERRORS"],
    meta: { form: form }
  };
};

var clearAsyncError = function clearAsyncError(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_ASYNC_ERROR"],
    meta: { form: form, field: field }
  };
};

var clearFields = function clearFields(form, keepTouched, persistentSubmitErrors) {
  for (var _len = arguments.length, fields = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    fields[_key - 3] = arguments[_key];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_FIELDS"],
    meta: { form: form, keepTouched: keepTouched, persistentSubmitErrors: persistentSubmitErrors, fields: fields }
  };
};

var destroy = function destroy() {
  for (var _len2 = arguments.length, form = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    form[_key2] = arguments[_key2];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["DESTROY"],
    meta: { form: form }
  };
};

var focus = function focus(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["FOCUS"],
    meta: { form: form, field: field }
  };
};

var initialize = function initialize(form, values, keepDirty) {
  var otherMeta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (keepDirty instanceof Object) {
    otherMeta = keepDirty;
    keepDirty = false;
  }
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["INITIALIZE"],
    meta: _extends({ form: form, keepDirty: keepDirty }, otherMeta),
    payload: values
  };
};

var registerField = function registerField(form, name, type) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["REGISTER_FIELD"],
    meta: { form: form },
    payload: { name: name, type: type }
  };
};

var reset = function reset(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET"],
    meta: { form: form }
  };
};

var resetSection = function resetSection(form) {
  for (var _len3 = arguments.length, sections = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    sections[_key3 - 1] = arguments[_key3];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET_SECTION"],
    meta: { form: form, sections: sections }
  };
};

var startAsyncValidation = function startAsyncValidation(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_ASYNC_VALIDATION"],
    meta: { form: form, field: field }
  };
};

var startSubmit = function startSubmit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_SUBMIT"],
    meta: { form: form }
  };
};

var stopAsyncValidation = function stopAsyncValidation(form, errors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_ASYNC_VALIDATION"],
    meta: { form: form },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var stopSubmit = function stopSubmit(form, errors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_SUBMIT"],
    meta: { form: form },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var submit = function submit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SUBMIT"],
    meta: { form: form }
  };
};

var setSubmitFailed = function setSubmitFailed(form) {
  for (var _len4 = arguments.length, fields = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    fields[_key4 - 1] = arguments[_key4];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_FAILED"],
    meta: { form: form, fields: fields },
    error: true
  };
};

var setSubmitSucceeded = function setSubmitSucceeded(form) {
  for (var _len5 = arguments.length, fields = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    fields[_key5 - 1] = arguments[_key5];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_SUCCEEDED"],
    meta: { form: form, fields: fields },
    error: false
  };
};

var touch = function touch(form) {
  for (var _len6 = arguments.length, fields = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    fields[_key6 - 1] = arguments[_key6];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["TOUCH"],
    meta: { form: form, fields: fields }
  };
};

var unregisterField = function unregisterField(form, name) {
  var destroyOnUnmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNREGISTER_FIELD"],
    meta: { form: form },
    payload: { name: name, destroyOnUnmount: destroyOnUnmount }
  };
};

var untouch = function untouch(form) {
  for (var _len7 = arguments.length, fields = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    fields[_key7 - 1] = arguments[_key7];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNTOUCH"],
    meta: { form: form, fields: fields }
  };
};

var updateSyncErrors = function updateSyncErrors(form) {
  var syncErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var error = arguments[2];
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_ERRORS"],
    meta: { form: form },
    payload: { syncErrors: syncErrors, error: error }
  };
};

var updateSyncWarnings = function updateSyncWarnings(form) {
  var syncWarnings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var warning = arguments[2];
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_WARNINGS"],
    meta: { form: form },
    payload: { syncWarnings: syncWarnings, warning: warning }
  };
};

var actions = {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift,
  autofill: autofill,
  blur: blur,
  change: change,
  clearFields: clearFields,
  clearSubmit: clearSubmit,
  clearSubmitErrors: clearSubmitErrors,
  clearAsyncError: clearAsyncError,
  destroy: destroy,
  focus: focus,
  initialize: initialize,
  registerField: registerField,
  reset: reset,
  resetSection: resetSection,
  startAsyncValidation: startAsyncValidation,
  startSubmit: startSubmit,
  stopAsyncValidation: stopAsyncValidation,
  stopSubmit: stopSubmit,
  submit: submit,
  setSubmitFailed: setSubmitFailed,
  setSubmitSucceeded: setSubmitSucceeded,
  touch: touch,
  unregisterField: unregisterField,
  untouch: untouch,
  updateSyncErrors: updateSyncErrors,
  updateSyncWarnings: updateSyncWarnings
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
  var initialized = _ref.initialized,
      trigger = _ref.trigger,
      pristine = _ref.pristine,
      syncValidationPasses = _ref.syncValidationPasses;

  if (!syncValidationPasses) {
    return false;
  }
  switch (trigger) {
    case 'blur':
    case 'change':
      // blurring
      return true;
    case 'submit':
      // submitting, so only async validate if form is dirty or was never initialized
      // conversely, DON'T async validate if the form is pristine just as it was initialized
      return !pristine || !initialized;
    default:
      return false;
  }
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldAsyncValidate);

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldValidate = function defaultShouldValidate(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldValidate);

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldError = function defaultShouldError(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldError);

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldWarn = function defaultShouldWarn(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldWarn);

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_error__ = __webpack_require__(3202);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var SubmissionError = function (_ExtendableError) {
  _inherits(SubmissionError, _ExtendableError);

  function SubmissionError(errors) {
    _classCallCheck(this, SubmissionError);

    var _this = _possibleConstructorReturn(this, (SubmissionError.__proto__ || Object.getPrototypeOf(SubmissionError)).call(this, 'Submit Validation Failed'));

    _this.errors = errors;
    return _this;
  }

  return SubmissionError;
}(__WEBPACK_IMPORTED_MODULE_0_es6_error__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SubmissionError);

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var processProps = function processProps(type, props, _value, deepEqual) {
  var value = props.value;

  if (type === 'checkbox') {
    return _extends({}, props, {
      checked: !!value
    });
  }
  if (type === 'radio') {
    return _extends({}, props, {
      checked: deepEqual(value, _value),
      value: _value
    });
  }
  if (type === 'select-multiple') {
    return _extends({}, props, {
      value: value || []
    });
  }
  if (type === 'file') {
    return _extends({}, props, {
      value: value || undefined
    });
  }
  return props;
};

var createFieldProps = function createFieldProps(_ref2, name, _ref) {
  var getIn = _ref2.getIn,
      toJS = _ref2.toJS,
      deepEqual = _ref2.deepEqual;

  var asyncError = _ref.asyncError,
      asyncValidating = _ref.asyncValidating,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onDrop = _ref.onDrop,
      onDragStart = _ref.onDragStart,
      dirty = _ref.dirty,
      dispatch = _ref.dispatch,
      onFocus = _ref.onFocus,
      form = _ref.form,
      format = _ref.format,
      initial = _ref.initial,
      parse = _ref.parse,
      pristine = _ref.pristine,
      props = _ref.props,
      state = _ref.state,
      submitError = _ref.submitError,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      validate = _ref.validate,
      value = _ref.value,
      _value = _ref._value,
      warn = _ref.warn,
      custom = _objectWithoutProperties(_ref, ['asyncError', 'asyncValidating', 'onBlur', 'onChange', 'onDrop', 'onDragStart', 'dirty', 'dispatch', 'onFocus', 'form', 'format', 'initial', 'parse', 'pristine', 'props', 'state', 'submitError', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'validate', 'value', '_value', 'warn']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;

  var formatFieldValue = function formatFieldValue(value, format) {
    if (format === null) {
      return value;
    }
    var defaultFormattedValue = value == null ? '' : value;
    return format ? format(value, name) : defaultFormattedValue;
  };

  var formattedFieldValue = formatFieldValue(value, format);

  return {
    input: processProps(custom.type, {
      name: name,
      onBlur: onBlur,
      onChange: onChange,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onFocus: onFocus,
      value: formattedFieldValue
    }, _value, deepEqual),
    meta: _extends({}, toJS(state), {
      active: !!(state && getIn(state, 'active')),
      asyncValidating: asyncValidating,
      autofilled: !!(state && getIn(state, 'autofilled')),
      dirty: dirty,
      dispatch: dispatch,
      error: error,
      form: form,
      initial: initial,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: !!submitting,
      submitFailed: !!submitFailed,
      touched: !!(state && getIn(state, 'touched')),
      valid: !error,
      visited: !!(state && getIn(state, 'visited'))
    }),
    custom: _extends({}, custom, props)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createFieldProps);

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getValue__ = __webpack_require__(3207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isReactNative__ = __webpack_require__(1296);




var onChangeValue = function onChangeValue(event, _ref) {
  var name = _ref.name,
      parse = _ref.parse,
      normalize = _ref.normalize;

  // read value from input
  var value = Object(__WEBPACK_IMPORTED_MODULE_0__getValue__["a" /* default */])(event, __WEBPACK_IMPORTED_MODULE_1__isReactNative__["a" /* default */]);

  // parse value if we have a parser
  if (parse) {
    value = parse(value, name);
  }

  // normalize value
  if (normalize) {
    value = normalize(name, value);
  }

  return value;
};

/* harmony default export */ __webpack_exports__["a"] = (onChangeValue);

/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isEvent = function isEvent(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};

/* harmony default export */ __webpack_exports__["a"] = (isEvent);

/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';

/* harmony default export */ __webpack_exports__["a"] = (isReactNative);

/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayMap);


/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (copyArray);


/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__ = __webpack_require__(3211);


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = Object(__WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__["a" /* default */])(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ __webpack_exports__["a"] = (stringToPath);


/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (toSource);


/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(3234);


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : Object(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (toString);


/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(317);


/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(value, other, undefined, customizer) : !!result;
}

/* harmony default export */ __webpack_exports__["a"] = (isEqualWith);


/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SetCache_js__ = __webpack_require__(3243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arraySome_js__ = __webpack_require__(3246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cacheHas_js__ = __webpack_require__(3247);




/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new __WEBPACK_IMPORTED_MODULE_0__SetCache_js__["a" /* default */] : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__arraySome_js__["a" /* default */])(other, function(othValue, othIndex) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__cacheHas_js__["a" /* default */])(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalArrays);


/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(96);


/** Built-in value references. */
var Uint8Array = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Uint8Array;

/* harmony default export */ __webpack_exports__["a"] = (Uint8Array);


/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTimes_js__ = __webpack_require__(3258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBuffer_js__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIndex_js__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__ = __webpack_require__(320);







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value),
      isArg = !isArr && Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(value),
      isBuff = !isArr && !isArg && Object(__WEBPACK_IMPORTED_MODULE_3__isBuffer_js__["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__["a" /* default */])(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? Object(__WEBPACK_IMPORTED_MODULE_0__baseTimes_js__["a" /* default */])(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           Object(__WEBPACK_IMPORTED_MODULE_4__isIndex_js__["a" /* default */])(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayLikeKeys);


/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPrototype_js__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__ = __webpack_require__(3264);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPrototype_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__["a" /* default */])(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeys);


/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataView_js__ = __webpack_require__(3265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Promise_js__ = __webpack_require__(3266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Set_js__ = __webpack_require__(3267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__ = __webpack_require__(3268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toSource_js__ = __webpack_require__(1300);








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */]),
    mapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]),
    promiseCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */]),
    setCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]),
    weakMapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */];

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */](new ArrayBuffer(1))) != dataViewTag) ||
    (__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]) != mapTag) ||
    (__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */] && getTag(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */].resolve()) != promiseTag) ||
    (__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]) != setTag) ||
    (__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]) != weakMapTag)) {
  getTag = function(value) {
    var result = Object(__WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */])(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getTag);


/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__ = __webpack_require__(1302);



var customizer = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
  // https://lodash.com/docs/4.17.4#isEqualWith
  if (stack) {
    // Shallow compares
    // For 1st level, stack === undefined.
    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
    // For 2nd level and up, stack !== undefined.
    //   -> Compare by === operator
    return objectValue === otherValue;
  }
};

var shallowCompare = function shallowCompare(instance, nextProps, nextState) {
  var propsEqual = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(instance.props, nextProps, customizer);
  var stateEqual = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(instance.state, nextState, customizer);

  return !propsEqual || !stateEqual;
};

/* harmony default export */ __webpack_exports__["a"] = (shallowCompare);

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(139);


var defineProperty = (function() {
  try {
    var func = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (defineProperty);


/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__ = __webpack_require__(3278);


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = Object(__WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (baseFor);


/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(117);


/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isStrictComparable);


/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (matchesStrictComparable);


/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toKey_js__ = __webpack_require__(240);



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[Object(__WEBPACK_IMPORTED_MODULE_1__toKey_js__["a" /* default */])(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (baseGet);


/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isKey_js__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stringToPath_js__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(1301);





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return value;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__isKey_js__["a" /* default */])(value, object) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_2__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (castPath);


/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsPristine = function createIsPristine(_ref) {
  var deepEqual = _ref.deepEqual,
      empty = _ref.empty,
      getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      var formState = nonNullGetFormState(state);
      if (fields && fields.length) {
        return fields.every(function (field) {
          var fieldInitial = getIn(formState, form + '.initial.' + field);
          var fieldValue = getIn(formState, form + '.values.' + field);
          return deepEqual(fieldInitial, fieldValue);
        });
      }
      var initial = getIn(formState, form + '.initial') || empty;
      var values = getIn(formState, form + '.values') || initial;
      return deepEqual(initial, values);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsPristine);

/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(239);



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(object[key], value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignMergeValue);


/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (safeGet);


/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__ = __webpack_require__(3345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(241);




/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object, true) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keysIn);


/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isEvent__ = __webpack_require__(1295);


var silenceEvent = function silenceEvent(event) {
  var is = Object(__WEBPACK_IMPORTED_MODULE_0__isEvent__["a" /* default */])(event);
  if (is) {
    event.preventDefault();
  }
  return is;
};

/* harmony default export */ __webpack_exports__["a"] = (silenceEvent);

/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_index__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SchemaArray__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_index__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(73);
var setDefaults=function setDefaults(schema){var properties=schema.properties;if(!properties)return{};return properties.reduce(function(result,field){result[field.id]=field.properties?setDefaults(field.properties):field.default;return result;},{});};var DynamicForm=function DynamicForm(props){var RequestType=props.RequestType,isNew=props.isNew,handleSubmit=props.handleSubmit,actionInProgress=props.actionInProgress,cancel=props.cancel;var _RequestType$inputs=RequestType.inputs,properties=_RequestType$inputs.properties,required=_RequestType$inputs.required;var formProps=Object.keys(properties);var mentionProvider=Object(__WEBPACK_IMPORTED_MODULE_6__components_index__["n" /* MentionProvider */])(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].mentionsIssue);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:handleSubmit,id:'dynamicForm'},formProps.map(function(key){var prop=properties[key];switch(prop.type){case'object':var isNestedRequire=required&&required.includes(prop.name);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["c" /* FormSection */],{key:prop.id,name:prop.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{name:'_include',className:'ncss-label',label:prop.title,disabled:isNestedRequire,component:__WEBPACK_IMPORTED_MODULE_3__components_forms_index__["a" /* Checkbox */],title:prop.description}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SchemaObject,{title:prop.title,schema:prop}));case'string':return prop.enum?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{key:prop.id,name:prop.id,component:__WEBPACK_IMPORTED_MODULE_3__components_forms_index__["c" /* Select */],label:prop.title,options:prop.enum.map(function(e){return{label:e,value:e};}),title:prop.description,placeholder:prop.default,disabled:actionInProgress}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{key:prop.id,name:prop.id,component:__WEBPACK_IMPORTED_MODULE_3__components_forms_index__["d" /* TextInput */],label:prop.title,title:prop.description,placeholder:prop.default,disabled:actionInProgress});case'textArea':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{key:prop.id,name:prop.id,component:__WEBPACK_IMPORTED_MODULE_3__components_forms_index__["d" /* TextInput */],textArea:true,label:prop.title,title:prop.description,placeholder:prop.default,disabled:actionInProgress});case'wiki':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{key:prop.id,name:prop.id,component:__WEBPACK_IMPORTED_MODULE_3__components_forms_index__["e" /* WikiInput */],label:prop.title,title:prop.description,placeholder:prop.default,mentionProvider:mentionProvider,className:'top-layer',disabled:actionInProgress});case'boolean':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{key:prop.id,name:prop.id,component:__WEBPACK_IMPORTED_MODULE_3__components_forms_index__["a" /* Checkbox */],label:prop.title,title:prop.description,disabled:actionInProgress});case'array':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["b" /* FieldArray */],{key:prop.id,name:prop.id,prop:prop,component:__WEBPACK_IMPORTED_MODULE_4__SchemaArray__["a" /* default */],disabled:actionInProgress});case'number':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{key:prop.id,name:prop.id,component:__WEBPACK_IMPORTED_MODULE_3__components_forms_index__["b" /* NumericInput */],label:prop.title,title:prop.description,disabled:actionInProgress});default:throw new Error('unknown prop type '+prop.type+' in '+RequestType.description);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__atlaskit_button__["ButtonGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__atlaskit_button__["default"],{type:'submit',appearance:'primary'},isNew?'Submit':'Update',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa '+(actionInProgress?'fa-circle-o-notch fa-spin':null)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__atlaskit_button__["default"],{type:'button',appearance:'link',onClick:cancel},'Cancel')));};var validate=function validate(values,props){var properties=props.RequestType.inputs.required;var result={};properties.forEach(function(field){result[field]=!values[field]?'Cannot not be empty':undefined;});return result;};var IssueDynamicForm=Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* reduxForm */])({form:'request',enableReinitialize:true,updateUnregisteredFields:true,keepDirty:true,validate:validate})(DynamicForm);IssueDynamicForm=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,ownProps){var initialValues=ownProps.Issue?ownProps.Issue:setDefaults(ownProps.RequestType.inputs);if(initialValues.undefined){delete initialValues.undefined;}return{initialValues:Object.assign({},initialValues)};})(IssueDynamicForm);/* harmony default export */ __webpack_exports__["a"] = (IssueDynamicForm);

/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_jsonSchema__ = __webpack_require__(3375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SchemaObject__ = __webpack_require__(3410);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var SchemaFormArray=function SchemaFormArray(_ref){var fields=_ref.fields,prop=_ref.prop,props=_objectWithoutProperties(_ref,['fields','prop']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-white mt2-sm mb2-sm p4-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-container pb5-md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["k" /* H4 */],{className:'flex-fill u-bold'},prop.title),props.invalid&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ncss-error-msg',key:'error'},props.error),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["d" /* Button */],{onClick:function onClick(){return fields.push(Object.assign({_include:true},Object(__WEBPACK_IMPORTED_MODULE_2__util_jsonSchema__["a" /* makeDefaultItem */])(prop.items)));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'g72-plus-large'}),' Add')),fields.map(function(member,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mb3-sm p5-md border-top',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-container fl-md-r'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["d" /* Button */],{color:'white',onClick:function onClick(){return fields.remove(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'g72-x-thick text-color-error'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ncss-col-md-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["c" /* FormSection */],{name:member},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SchemaObject__["a" /* default */],{schema:prop.items}))));}));};/* harmony default export */ __webpack_exports__["a"] = (SchemaFormArray);

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(176);

module.exports = SchemaObject;

function SchemaObject(obj) {
  util.copy(obj, this);
}


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_validate(it, $keyword, $ruleType) {
  var out = '';
  var $async = it.schema.$async === true,
    $refKeywords = it.util.schemaHasRulesExcept(it.schema, it.RULES.all, '$ref'),
    $id = it.self._getId(it.schema);
  if (it.opts.strictKeywords) {
    var $unknownKwd = it.util.schemaUnknownRules(it.schema, it.RULES.keywords);
    if ($unknownKwd) {
      var $keywordsMsg = 'unknown keyword: ' + $unknownKwd;
      if (it.opts.strictKeywords === 'log') it.logger.warn($keywordsMsg);
      else throw new Error($keywordsMsg);
    }
  }
  if (it.isTop) {
    out += ' var validate = ';
    if ($async) {
      it.async = true;
      out += 'async ';
    }
    out += 'function(data, dataPath, parentData, parentDataProperty, rootData) { \'use strict\'; ';
    if ($id && (it.opts.sourceCode || it.opts.processCode)) {
      out += ' ' + ('/\*# sourceURL=' + $id + ' */') + ' ';
    }
  }
  if (typeof it.schema == 'boolean' || !($refKeywords || it.schema.$ref)) {
    var $keyword = 'false schema';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    if (it.schema === false) {
      if (it.isTop) {
        $breakOnError = true;
      } else {
        out += ' var ' + ($valid) + ' = false; ';
      }
      var $$outStack = $$outStack || [];
      $$outStack.push(out);
      out = ''; /* istanbul ignore else */
      if (it.createErrors !== false) {
        out += ' { keyword: \'' + ($errorKeyword || 'false schema') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
        if (it.opts.messages !== false) {
          out += ' , message: \'boolean schema is false\' ';
        }
        if (it.opts.verbose) {
          out += ' , schema: false , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
        }
        out += ' } ';
      } else {
        out += ' {} ';
      }
      var __err = out;
      out = $$outStack.pop();
      if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */
        if (it.async) {
          out += ' throw new ValidationError([' + (__err) + ']); ';
        } else {
          out += ' validate.errors = [' + (__err) + ']; return false; ';
        }
      } else {
        out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
      }
    } else {
      if (it.isTop) {
        if ($async) {
          out += ' return data; ';
        } else {
          out += ' validate.errors = null; return true; ';
        }
      } else {
        out += ' var ' + ($valid) + ' = true; ';
      }
    }
    if (it.isTop) {
      out += ' }; return validate; ';
    }
    return out;
  }
  if (it.isTop) {
    var $top = it.isTop,
      $lvl = it.level = 0,
      $dataLvl = it.dataLevel = 0,
      $data = 'data';
    it.rootId = it.resolve.fullPath(it.self._getId(it.root.schema));
    it.baseId = it.baseId || it.rootId;
    delete it.isTop;
    it.dataPathArr = [""];
    if (it.schema.default !== undefined && it.opts.useDefaults && it.opts.strictDefaults) {
      var $defaultMsg = 'default is ignored in the schema root';
      if (it.opts.strictDefaults === 'log') it.logger.warn($defaultMsg);
      else throw new Error($defaultMsg);
    }
    out += ' var vErrors = null; ';
    out += ' var errors = 0;     ';
    out += ' if (rootData === undefined) rootData = data; ';
  } else {
    var $lvl = it.level,
      $dataLvl = it.dataLevel,
      $data = 'data' + ($dataLvl || '');
    if ($id) it.baseId = it.resolve.url(it.baseId, $id);
    if ($async && !it.async) throw new Error('async schema in sync schema');
    out += ' var errs_' + ($lvl) + ' = errors;';
  }
  var $valid = 'valid' + $lvl,
    $breakOnError = !it.opts.allErrors,
    $closingBraces1 = '',
    $closingBraces2 = '';
  var $errorKeyword;
  var $typeSchema = it.schema.type,
    $typeIsArray = Array.isArray($typeSchema);
  if ($typeSchema && it.opts.nullable && it.schema.nullable === true) {
    if ($typeIsArray) {
      if ($typeSchema.indexOf('null') == -1) $typeSchema = $typeSchema.concat('null');
    } else if ($typeSchema != 'null') {
      $typeSchema = [$typeSchema, 'null'];
      $typeIsArray = true;
    }
  }
  if ($typeIsArray && $typeSchema.length == 1) {
    $typeSchema = $typeSchema[0];
    $typeIsArray = false;
  }
  if (it.schema.$ref && $refKeywords) {
    if (it.opts.extendRefs == 'fail') {
      throw new Error('$ref: validation keywords used in schema at path "' + it.errSchemaPath + '" (see option extendRefs)');
    } else if (it.opts.extendRefs !== true) {
      $refKeywords = false;
      it.logger.warn('$ref: keywords ignored in schema at path "' + it.errSchemaPath + '"');
    }
  }
  if (it.schema.$comment && it.opts.$comment) {
    out += ' ' + (it.RULES.all.$comment.code(it, '$comment'));
  }
  if ($typeSchema) {
    if (it.opts.coerceTypes) {
      var $coerceToTypes = it.util.coerceToTypes(it.opts.coerceTypes, $typeSchema);
    }
    var $rulesGroup = it.RULES.types[$typeSchema];
    if ($coerceToTypes || $typeIsArray || $rulesGroup === true || ($rulesGroup && !$shouldUseGroup($rulesGroup))) {
      var $schemaPath = it.schemaPath + '.type',
        $errSchemaPath = it.errSchemaPath + '/type';
      var $schemaPath = it.schemaPath + '.type',
        $errSchemaPath = it.errSchemaPath + '/type',
        $method = $typeIsArray ? 'checkDataTypes' : 'checkDataType';
      out += ' if (' + (it.util[$method]($typeSchema, $data, it.opts.strictNumbers, true)) + ') { ';
      if ($coerceToTypes) {
        var $dataType = 'dataType' + $lvl,
          $coerced = 'coerced' + $lvl;
        out += ' var ' + ($dataType) + ' = typeof ' + ($data) + '; var ' + ($coerced) + ' = undefined; ';
        if (it.opts.coerceTypes == 'array') {
          out += ' if (' + ($dataType) + ' == \'object\' && Array.isArray(' + ($data) + ') && ' + ($data) + '.length == 1) { ' + ($data) + ' = ' + ($data) + '[0]; ' + ($dataType) + ' = typeof ' + ($data) + '; if (' + (it.util.checkDataType(it.schema.type, $data, it.opts.strictNumbers)) + ') ' + ($coerced) + ' = ' + ($data) + '; } ';
        }
        out += ' if (' + ($coerced) + ' !== undefined) ; ';
        var arr1 = $coerceToTypes;
        if (arr1) {
          var $type, $i = -1,
            l1 = arr1.length - 1;
          while ($i < l1) {
            $type = arr1[$i += 1];
            if ($type == 'string') {
              out += ' else if (' + ($dataType) + ' == \'number\' || ' + ($dataType) + ' == \'boolean\') ' + ($coerced) + ' = \'\' + ' + ($data) + '; else if (' + ($data) + ' === null) ' + ($coerced) + ' = \'\'; ';
            } else if ($type == 'number' || $type == 'integer') {
              out += ' else if (' + ($dataType) + ' == \'boolean\' || ' + ($data) + ' === null || (' + ($dataType) + ' == \'string\' && ' + ($data) + ' && ' + ($data) + ' == +' + ($data) + ' ';
              if ($type == 'integer') {
                out += ' && !(' + ($data) + ' % 1)';
              }
              out += ')) ' + ($coerced) + ' = +' + ($data) + '; ';
            } else if ($type == 'boolean') {
              out += ' else if (' + ($data) + ' === \'false\' || ' + ($data) + ' === 0 || ' + ($data) + ' === null) ' + ($coerced) + ' = false; else if (' + ($data) + ' === \'true\' || ' + ($data) + ' === 1) ' + ($coerced) + ' = true; ';
            } else if ($type == 'null') {
              out += ' else if (' + ($data) + ' === \'\' || ' + ($data) + ' === 0 || ' + ($data) + ' === false) ' + ($coerced) + ' = null; ';
            } else if (it.opts.coerceTypes == 'array' && $type == 'array') {
              out += ' else if (' + ($dataType) + ' == \'string\' || ' + ($dataType) + ' == \'number\' || ' + ($dataType) + ' == \'boolean\' || ' + ($data) + ' == null) ' + ($coerced) + ' = [' + ($data) + ']; ';
            }
          }
        }
        out += ' else {   ';
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ($errorKeyword || 'type') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { type: \'';
          if ($typeIsArray) {
            out += '' + ($typeSchema.join(","));
          } else {
            out += '' + ($typeSchema);
          }
          out += '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'should be ';
            if ($typeIsArray) {
              out += '' + ($typeSchema.join(","));
            } else {
              out += '' + ($typeSchema);
            }
            out += '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
        out += ' } if (' + ($coerced) + ' !== undefined) {  ';
        var $parentData = $dataLvl ? 'data' + (($dataLvl - 1) || '') : 'parentData',
          $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : 'parentDataProperty';
        out += ' ' + ($data) + ' = ' + ($coerced) + '; ';
        if (!$dataLvl) {
          out += 'if (' + ($parentData) + ' !== undefined)';
        }
        out += ' ' + ($parentData) + '[' + ($parentDataProperty) + '] = ' + ($coerced) + '; } ';
      } else {
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ($errorKeyword || 'type') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { type: \'';
          if ($typeIsArray) {
            out += '' + ($typeSchema.join(","));
          } else {
            out += '' + ($typeSchema);
          }
          out += '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'should be ';
            if ($typeIsArray) {
              out += '' + ($typeSchema.join(","));
            } else {
              out += '' + ($typeSchema);
            }
            out += '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
      }
      out += ' } ';
    }
  }
  if (it.schema.$ref && !$refKeywords) {
    out += ' ' + (it.RULES.all.$ref.code(it, '$ref')) + ' ';
    if ($breakOnError) {
      out += ' } if (errors === ';
      if ($top) {
        out += '0';
      } else {
        out += 'errs_' + ($lvl);
      }
      out += ') { ';
      $closingBraces2 += '}';
    }
  } else {
    var arr2 = it.RULES;
    if (arr2) {
      var $rulesGroup, i2 = -1,
        l2 = arr2.length - 1;
      while (i2 < l2) {
        $rulesGroup = arr2[i2 += 1];
        if ($shouldUseGroup($rulesGroup)) {
          if ($rulesGroup.type) {
            out += ' if (' + (it.util.checkDataType($rulesGroup.type, $data, it.opts.strictNumbers)) + ') { ';
          }
          if (it.opts.useDefaults) {
            if ($rulesGroup.type == 'object' && it.schema.properties) {
              var $schema = it.schema.properties,
                $schemaKeys = Object.keys($schema);
              var arr3 = $schemaKeys;
              if (arr3) {
                var $propertyKey, i3 = -1,
                  l3 = arr3.length - 1;
                while (i3 < l3) {
                  $propertyKey = arr3[i3 += 1];
                  var $sch = $schema[$propertyKey];
                  if ($sch.default !== undefined) {
                    var $passData = $data + it.util.getProperty($propertyKey);
                    if (it.compositeRule) {
                      if (it.opts.strictDefaults) {
                        var $defaultMsg = 'default is ignored for: ' + $passData;
                        if (it.opts.strictDefaults === 'log') it.logger.warn($defaultMsg);
                        else throw new Error($defaultMsg);
                      }
                    } else {
                      out += ' if (' + ($passData) + ' === undefined ';
                      if (it.opts.useDefaults == 'empty') {
                        out += ' || ' + ($passData) + ' === null || ' + ($passData) + ' === \'\' ';
                      }
                      out += ' ) ' + ($passData) + ' = ';
                      if (it.opts.useDefaults == 'shared') {
                        out += ' ' + (it.useDefault($sch.default)) + ' ';
                      } else {
                        out += ' ' + (JSON.stringify($sch.default)) + ' ';
                      }
                      out += '; ';
                    }
                  }
                }
              }
            } else if ($rulesGroup.type == 'array' && Array.isArray(it.schema.items)) {
              var arr4 = it.schema.items;
              if (arr4) {
                var $sch, $i = -1,
                  l4 = arr4.length - 1;
                while ($i < l4) {
                  $sch = arr4[$i += 1];
                  if ($sch.default !== undefined) {
                    var $passData = $data + '[' + $i + ']';
                    if (it.compositeRule) {
                      if (it.opts.strictDefaults) {
                        var $defaultMsg = 'default is ignored for: ' + $passData;
                        if (it.opts.strictDefaults === 'log') it.logger.warn($defaultMsg);
                        else throw new Error($defaultMsg);
                      }
                    } else {
                      out += ' if (' + ($passData) + ' === undefined ';
                      if (it.opts.useDefaults == 'empty') {
                        out += ' || ' + ($passData) + ' === null || ' + ($passData) + ' === \'\' ';
                      }
                      out += ' ) ' + ($passData) + ' = ';
                      if (it.opts.useDefaults == 'shared') {
                        out += ' ' + (it.useDefault($sch.default)) + ' ';
                      } else {
                        out += ' ' + (JSON.stringify($sch.default)) + ' ';
                      }
                      out += '; ';
                    }
                  }
                }
              }
            }
          }
          var arr5 = $rulesGroup.rules;
          if (arr5) {
            var $rule, i5 = -1,
              l5 = arr5.length - 1;
            while (i5 < l5) {
              $rule = arr5[i5 += 1];
              if ($shouldUseRule($rule)) {
                var $code = $rule.code(it, $rule.keyword, $rulesGroup.type);
                if ($code) {
                  out += ' ' + ($code) + ' ';
                  if ($breakOnError) {
                    $closingBraces1 += '}';
                  }
                }
              }
            }
          }
          if ($breakOnError) {
            out += ' ' + ($closingBraces1) + ' ';
            $closingBraces1 = '';
          }
          if ($rulesGroup.type) {
            out += ' } ';
            if ($typeSchema && $typeSchema === $rulesGroup.type && !$coerceToTypes) {
              out += ' else { ';
              var $schemaPath = it.schemaPath + '.type',
                $errSchemaPath = it.errSchemaPath + '/type';
              var $$outStack = $$outStack || [];
              $$outStack.push(out);
              out = ''; /* istanbul ignore else */
              if (it.createErrors !== false) {
                out += ' { keyword: \'' + ($errorKeyword || 'type') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { type: \'';
                if ($typeIsArray) {
                  out += '' + ($typeSchema.join(","));
                } else {
                  out += '' + ($typeSchema);
                }
                out += '\' } ';
                if (it.opts.messages !== false) {
                  out += ' , message: \'should be ';
                  if ($typeIsArray) {
                    out += '' + ($typeSchema.join(","));
                  } else {
                    out += '' + ($typeSchema);
                  }
                  out += '\' ';
                }
                if (it.opts.verbose) {
                  out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
                }
                out += ' } ';
              } else {
                out += ' {} ';
              }
              var __err = out;
              out = $$outStack.pop();
              if (!it.compositeRule && $breakOnError) {
                /* istanbul ignore if */
                if (it.async) {
                  out += ' throw new ValidationError([' + (__err) + ']); ';
                } else {
                  out += ' validate.errors = [' + (__err) + ']; return false; ';
                }
              } else {
                out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
              }
              out += ' } ';
            }
          }
          if ($breakOnError) {
            out += ' if (errors === ';
            if ($top) {
              out += '0';
            } else {
              out += 'errs_' + ($lvl);
            }
            out += ') { ';
            $closingBraces2 += '}';
          }
        }
      }
    }
  }
  if ($breakOnError) {
    out += ' ' + ($closingBraces2) + ' ';
  }
  if ($top) {
    if ($async) {
      out += ' if (errors === 0) return data;           ';
      out += ' else throw new ValidationError(vErrors); ';
    } else {
      out += ' validate.errors = vErrors; ';
      out += ' return errors === 0;       ';
    }
    out += ' }; return validate;';
  } else {
    out += ' var ' + ($valid) + ' = errors === errs_' + ($lvl) + ';';
  }

  function $shouldUseGroup($rulesGroup) {
    var rules = $rulesGroup.rules;
    for (var i = 0; i < rules.length; i++)
      if ($shouldUseRule(rules[i])) return true;
  }

  function $shouldUseRule($rule) {
    return it.schema[$rule.keyword] !== undefined || ($rule.implements && $ruleImplementsSomeKeyword($rule));
  }

  function $ruleImplementsSomeKeyword($rule) {
    var impl = $rule.implements;
    for (var i = 0; i < impl.length; i++)
      if (it.schema[impl[i]] !== undefined) return true;
  }
  return out;
}


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate__limit(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = 'data' + ($dataLvl || '');
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $isMax = $keyword == 'maximum',
    $exclusiveKeyword = $isMax ? 'exclusiveMaximum' : 'exclusiveMinimum',
    $schemaExcl = it.schema[$exclusiveKeyword],
    $isDataExcl = it.opts.$data && $schemaExcl && $schemaExcl.$data,
    $op = $isMax ? '<' : '>',
    $notOp = $isMax ? '>' : '<',
    $errorKeyword = undefined;
  if (!($isData || typeof $schema == 'number' || $schema === undefined)) {
    throw new Error($keyword + ' must be number');
  }
  if (!($isDataExcl || $schemaExcl === undefined || typeof $schemaExcl == 'number' || typeof $schemaExcl == 'boolean')) {
    throw new Error($exclusiveKeyword + ' must be number or boolean');
  }
  if ($isDataExcl) {
    var $schemaValueExcl = it.util.getData($schemaExcl.$data, $dataLvl, it.dataPathArr),
      $exclusive = 'exclusive' + $lvl,
      $exclType = 'exclType' + $lvl,
      $exclIsNumber = 'exclIsNumber' + $lvl,
      $opExpr = 'op' + $lvl,
      $opStr = '\' + ' + $opExpr + ' + \'';
    out += ' var schemaExcl' + ($lvl) + ' = ' + ($schemaValueExcl) + '; ';
    $schemaValueExcl = 'schemaExcl' + $lvl;
    out += ' var ' + ($exclusive) + '; var ' + ($exclType) + ' = typeof ' + ($schemaValueExcl) + '; if (' + ($exclType) + ' != \'boolean\' && ' + ($exclType) + ' != \'undefined\' && ' + ($exclType) + ' != \'number\') { ';
    var $errorKeyword = $exclusiveKeyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ($errorKeyword || '_exclusiveLimit') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
      if (it.opts.messages !== false) {
        out += ' , message: \'' + ($exclusiveKeyword) + ' should be boolean\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
      /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError([' + (__err) + ']); ';
      } else {
        out += ' validate.errors = [' + (__err) + ']; return false; ';
      }
    } else {
      out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    }
    out += ' } else if ( ';
    if ($isData) {
      out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
    }
    out += ' ' + ($exclType) + ' == \'number\' ? ( (' + ($exclusive) + ' = ' + ($schemaValue) + ' === undefined || ' + ($schemaValueExcl) + ' ' + ($op) + '= ' + ($schemaValue) + ') ? ' + ($data) + ' ' + ($notOp) + '= ' + ($schemaValueExcl) + ' : ' + ($data) + ' ' + ($notOp) + ' ' + ($schemaValue) + ' ) : ( (' + ($exclusive) + ' = ' + ($schemaValueExcl) + ' === true) ? ' + ($data) + ' ' + ($notOp) + '= ' + ($schemaValue) + ' : ' + ($data) + ' ' + ($notOp) + ' ' + ($schemaValue) + ' ) || ' + ($data) + ' !== ' + ($data) + ') { var op' + ($lvl) + ' = ' + ($exclusive) + ' ? \'' + ($op) + '\' : \'' + ($op) + '=\'; ';
    if ($schema === undefined) {
      $errorKeyword = $exclusiveKeyword;
      $errSchemaPath = it.errSchemaPath + '/' + $exclusiveKeyword;
      $schemaValue = $schemaValueExcl;
      $isData = $isDataExcl;
    }
  } else {
    var $exclIsNumber = typeof $schemaExcl == 'number',
      $opStr = $op;
    if ($exclIsNumber && $isData) {
      var $opExpr = '\'' + $opStr + '\'';
      out += ' if ( ';
      if ($isData) {
        out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
      }
      out += ' ( ' + ($schemaValue) + ' === undefined || ' + ($schemaExcl) + ' ' + ($op) + '= ' + ($schemaValue) + ' ? ' + ($data) + ' ' + ($notOp) + '= ' + ($schemaExcl) + ' : ' + ($data) + ' ' + ($notOp) + ' ' + ($schemaValue) + ' ) || ' + ($data) + ' !== ' + ($data) + ') { ';
    } else {
      if ($exclIsNumber && $schema === undefined) {
        $exclusive = true;
        $errorKeyword = $exclusiveKeyword;
        $errSchemaPath = it.errSchemaPath + '/' + $exclusiveKeyword;
        $schemaValue = $schemaExcl;
        $notOp += '=';
      } else {
        if ($exclIsNumber) $schemaValue = Math[$isMax ? 'min' : 'max']($schemaExcl, $schema);
        if ($schemaExcl === ($exclIsNumber ? $schemaValue : true)) {
          $exclusive = true;
          $errorKeyword = $exclusiveKeyword;
          $errSchemaPath = it.errSchemaPath + '/' + $exclusiveKeyword;
          $notOp += '=';
        } else {
          $exclusive = false;
          $opStr += '=';
        }
      }
      var $opExpr = '\'' + $opStr + '\'';
      out += ' if ( ';
      if ($isData) {
        out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
      }
      out += ' ' + ($data) + ' ' + ($notOp) + ' ' + ($schemaValue) + ' || ' + ($data) + ' !== ' + ($data) + ') { ';
    }
  }
  $errorKeyword = $errorKeyword || $keyword;
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ($errorKeyword || '_limit') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { comparison: ' + ($opExpr) + ', limit: ' + ($schemaValue) + ', exclusive: ' + ($exclusive) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should be ' + ($opStr) + ' ';
      if ($isData) {
        out += '\' + ' + ($schemaValue);
      } else {
        out += '' + ($schemaValue) + '\'';
      }
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + ($schema);
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += ' } ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate__limitItems(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = 'data' + ($dataLvl || '');
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  if (!($isData || typeof $schema == 'number')) {
    throw new Error($keyword + ' must be number');
  }
  var $op = $keyword == 'maxItems' ? '>' : '<';
  out += 'if ( ';
  if ($isData) {
    out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
  }
  out += ' ' + ($data) + '.length ' + ($op) + ' ' + ($schemaValue) + ') { ';
  var $errorKeyword = $keyword;
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ($errorKeyword || '_limitItems') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { limit: ' + ($schemaValue) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should NOT have ';
      if ($keyword == 'maxItems') {
        out += 'more';
      } else {
        out += 'fewer';
      }
      out += ' than ';
      if ($isData) {
        out += '\' + ' + ($schemaValue) + ' + \'';
      } else {
        out += '' + ($schema);
      }
      out += ' items\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + ($schema);
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += '} ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate__limitLength(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = 'data' + ($dataLvl || '');
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  if (!($isData || typeof $schema == 'number')) {
    throw new Error($keyword + ' must be number');
  }
  var $op = $keyword == 'maxLength' ? '>' : '<';
  out += 'if ( ';
  if ($isData) {
    out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
  }
  if (it.opts.unicode === false) {
    out += ' ' + ($data) + '.length ';
  } else {
    out += ' ucs2length(' + ($data) + ') ';
  }
  out += ' ' + ($op) + ' ' + ($schemaValue) + ') { ';
  var $errorKeyword = $keyword;
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ($errorKeyword || '_limitLength') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { limit: ' + ($schemaValue) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should NOT be ';
      if ($keyword == 'maxLength') {
        out += 'longer';
      } else {
        out += 'shorter';
      }
      out += ' than ';
      if ($isData) {
        out += '\' + ' + ($schemaValue) + ' + \'';
      } else {
        out += '' + ($schema);
      }
      out += ' characters\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + ($schema);
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += '} ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate__limitProperties(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = 'data' + ($dataLvl || '');
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  if (!($isData || typeof $schema == 'number')) {
    throw new Error($keyword + ' must be number');
  }
  var $op = $keyword == 'maxProperties' ? '>' : '<';
  out += 'if ( ';
  if ($isData) {
    out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
  }
  out += ' Object.keys(' + ($data) + ').length ' + ($op) + ' ' + ($schemaValue) + ') { ';
  var $errorKeyword = $keyword;
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ($errorKeyword || '_limitProperties') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { limit: ' + ($schemaValue) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should NOT have ';
      if ($keyword == 'maxProperties') {
        out += 'more';
      } else {
        out += 'fewer';
      }
      out += ' than ';
      if ($isData) {
        out += '\' + ' + ($schemaValue) + ' + \'';
      } else {
        out += '' + ($schema);
      }
      out += ' properties\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + ($schema);
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += '} ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),
/* 1329 */
/***/ (function(module, exports) {

module.exports = {"$schema":"http://json-schema.org/draft-07/schema#","$id":"http://json-schema.org/draft-07/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"$comment":{"type":"string"},"title":{"type":"string"},"description":{"type":"string"},"default":true,"readOnly":{"type":"boolean","default":false},"examples":{"type":"array","items":true},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":true},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"propertyNames":{"format":"regex"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":true,"enum":{"type":"array","items":true,"minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"contentMediaType":{"type":"string"},"contentEncoding":{"type":"string"},"if":{"$ref":"#"},"then":{"$ref":"#"},"else":{"$ref":"#"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":true}

/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Layout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styled_LayoutStyles__ = __webpack_require__(3418);








var Layout =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Layout, _Component);

  function Layout() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Layout);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Layout).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Layout, [{
    key: "renderAvatar",
    value: function renderAvatar() {
      var avatar = this.props.avatar;
      return avatar ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styled_LayoutStyles__["a" /* AvatarSectionDiv */], null, avatar) : null;
    }
  }, {
    key: "renderNestedComments",
    value: function renderNestedComments() {
      var children = this.props.children;
      return children ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styled_LayoutStyles__["e" /* NestedCommentsDiv */], null, children) : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          content = _this$props.content,
          highlighted = _this$props.highlighted,
          id = _this$props.id;
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styled_LayoutStyles__["b" /* Container */], {
        id: id
      }, this.renderAvatar(), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styled_LayoutStyles__["c" /* ContentSectionDiv */], null, content), this.renderNestedComments(), highlighted && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styled_LayoutStyles__["d" /* Highlight */], null));
    }
  }]);

  return Layout;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);



/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return verticalPadding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actionsPadding; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);

var verticalPadding = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["gridSize"])() * 3.5;
var actionsPadding = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["gridSize"])() * 2;

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(54);

var _interopRequireDefault = __webpack_require__(53);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.size = exports.default = exports.IconWrapper = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(4));

var _createClass2 = _interopRequireDefault(__webpack_require__(5));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(7));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(6));

var _inherits2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _styledComponents = _interopRequireDefault(__webpack_require__(2));

var _uuid = _interopRequireDefault(__webpack_require__(22));

var _theme = __webpack_require__(3);

var _constants = __webpack_require__(3421);

var getSize = function getSize(props) {
  if (props.size) {
    return "height: ".concat(_constants.sizes[props.size], "; width: ").concat(_constants.sizes[props.size], ";");
  }

  return null;
};

var IconWrapper = _styledComponents.default.span.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "dyhwwi-0"
})(["\n  ", " color: ", ";\n  display: inline-block;\n  fill: ", ";\n  flex-shrink: 0;\n  line-height: 1;\n\n  > svg {\n    ", " max-height: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    pointer-events: none;\n    vertical-align: bottom;\n  }\n  /* Stop-color doesn't properly apply in chrome when the inherited/current color changes.\n   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS\n   * rule) and then override it with currentColor for the color changes to be picked up.\n   */\n  stop {\n    stop-color: currentColor;\n  }\n"], getSize, function (p) {
  return p.primaryColor || 'currentColor';
}, function (p) {
  return p.secondaryColor || _theme.colors.background;
}, getSize);

exports.IconWrapper = IconWrapper;

var Icon =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Icon, _Component);

  function Icon() {
    (0, _classCallCheck2.default)(this, Icon);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Icon).apply(this, arguments));
  }

  (0, _createClass2.default)(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Glyph = _this$props.glyph,
          dangerouslySetGlyph = _this$props.dangerouslySetGlyph,
          onClick = _this$props.onClick,
          primaryColor = _this$props.primaryColor,
          secondaryColor = _this$props.secondaryColor,
          size = _this$props.size; // handling the glyphs as strings

      if (dangerouslySetGlyph) {
        return _react.default.createElement(IconWrapper, {
          onClick: onClick,
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          size: size,
          "aria-label": this.props.label,
          dangerouslySetInnerHTML: {
            __html: Icon.insertDynamicGradientID(dangerouslySetGlyph)
          }
        });
      } // handling the glyphs when passed through as functions


      return _react.default.createElement(IconWrapper, {
        onClick: onClick,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        "aria-label": this.props.label
      }, Glyph ? _react.default.createElement(Glyph, {
        role: "presentation"
      }) : null);
    }
  }], [{
    key: "insertDynamicGradientID",

    /* Icons need unique gradient IDs across instances for different gradient definitions to work
     * correctly.
     * A step in the icon build process replaces linear gradient IDs and their references in paths
     * to a placeholder string so we can replace them with a dynamic ID here.
     * Replacing the original IDs with placeholders in the build process is more robust than not
     * using placeholders as we do not have to rely on regular expressions to find specific element
     * to replace.
     */
    value: function insertDynamicGradientID(svgStr) {
      var id = (0, _uuid.default)();
      var replacedSvgStr = svgStr.replace(/id="([^"]+)-idPlaceholder"/g, "id=$1-".concat(id)).replace(/fill="url\(#([^"]+)-idPlaceholder\)"/g, "fill=\"url(#$1-".concat(id, ")\""));
      return replacedSvgStr;
    }
  }]);
  return Icon;
}(_react.Component);

exports.default = Icon;
(0, _defineProperty2.default)(Icon, "defaultProps", {
  onClick: function onClick() {}
});
var size = Object.keys(_constants.sizes).reduce(function (p, c) {
  return Object.assign(p, (0, _defineProperty2.default)({}, c, c));
}, {});
exports.size = size;

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommentField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styled_FieldStyles__ = __webpack_require__(3429);








var CommentField =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(CommentField, _Component);

  function CommentField() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, CommentField);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(CommentField).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(CommentField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          hasAuthor = _this$props.hasAuthor,
          href = _this$props.href,
          onClick = _this$props.onClick,
          onFocus = _this$props.onFocus,
          onMouseOver = _this$props.onMouseOver;
      /* eslint-disable jsx-a11y/no-static-element-interactions */

      return href ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styled_FieldStyles__["a" /* Anchor */], {
        href: href,
        hasAuthor: hasAuthor,
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver
      }, children) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styled_FieldStyles__["b" /* Span */], {
        hasAuthor: hasAuthor,
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver
      }, children);
      /* eslint-enable jsx-a11y/no-static-element-interactions */
    }
  }]);

  return CommentField;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);



/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmulateUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url_join__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_url_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(73);
var api=__WEBPACK_IMPORTED_MODULE_0_url_join___default.a.bind(null,__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].apiUrl);var EmulateUser=Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* asyncAction */])({baseName:'EMULATION_USER',action:function action(_action){return function(id,setADandJiraUser,clearIssues){return function(dispatch){dispatch(_action.start());return __WEBPACK_IMPORTED_MODULE_1__util__["d" /* http */].get(api('/ssp/user?id='+id)).then(function(userInfo){dispatch(_action.success());dispatch(setADandJiraUser(userInfo));dispatch(clearIssues());}).catch(function(err){console.error('error getting api response',err);dispatch(_action.error(err));});};};}});

/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = navigation;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectIsMenuOpen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__navigation_actions_js__ = __webpack_require__(523);
var defaultState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["c" /* fromJS */])({isMenuOpen:false});function navigation(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];state=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["c" /* fromJS */])(state);switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__navigation_actions_js__["b" /* openNavMenu */].type:return state.set('isMenuOpen',true);case __WEBPACK_IMPORTED_MODULE_1__navigation_actions_js__["a" /* closeNavMenu */].type:return state.set('isMenuOpen',false);case __WEBPACK_IMPORTED_MODULE_1__navigation_actions_js__["c" /* toggleNavMenu */].type:return state.set('isMenuOpen',!state.get('isMenuOpen'));default:return state;}}var selectIsMenuOpen=function selectIsMenuOpen(state){return state.navigation.get('isMenuOpen');};

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addNotification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeNotification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearNotifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return notify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return notifyError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_actions_js__ = __webpack_require__(357);
var addNotification=Object(__WEBPACK_IMPORTED_MODULE_0__util_actions_js__["b" /* createAction */])('NOTIFICATIONS_ADD');var removeNotification=Object(__WEBPACK_IMPORTED_MODULE_0__util_actions_js__["b" /* createAction */])('NOTIFICATIONS_REMOVE');var clearNotifications=Object(__WEBPACK_IMPORTED_MODULE_0__util_actions_js__["b" /* createAction */])('NOTIFICATIONS_CLEAR_ALL');var notificationId=0;var notify=function notify(_ref){var message=_ref.message,_ref$closeOnClick=_ref.closeOnClick,closeOnClick=_ref$closeOnClick===undefined?true:_ref$closeOnClick,_ref$type=_ref.type,type=_ref$type===undefined?'success':_ref$type,_ref$timeoutMs=_ref.timeoutMs,timeoutMs=_ref$timeoutMs===undefined?3000:_ref$timeoutMs;return function(dispatch,getState){notificationId++;// create closed value so other notifications' incrementing doesn't interfere with timeout
var id=notificationId;dispatch(addNotification({message:message,type:type,closeOnClick:closeOnClick,id:id}));if(timeoutMs!==0){setTimeout(function(){dispatch(removeNotification(id));},timeoutMs);}return id;};};var notifyError=function notifyError(_ref2){var message=_ref2.message;return notify({message:message,closeOnClick:true,type:'error',timeoutMs:0});};

/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = notifications;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectNotifications; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_js__ = __webpack_require__(1337);
var defaultState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["a" /* Map */])({notifications:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["b" /* OrderedMap */])({})});function notifications(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];state=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["c" /* fromJS */])(state);switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions_js__["a" /* addNotification */].type:state=state.setIn(['notifications',action.payload.id],action.payload);while(state.get('notifications').size>2){state=state.deleteIn(['notifications',state.get('notifications').first().id]);}return state;case __WEBPACK_IMPORTED_MODULE_1__actions_js__["e" /* removeNotification */].type:return state.deleteIn(['notifications',action.payload]);case __WEBPACK_IMPORTED_MODULE_1__actions_js__["b" /* clearNotifications */].type:return state.set('notifications',Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["b" /* OrderedMap */])({}));default:return state;}}var selectNotifications=function selectNotifications(state){return state.notifications.get('notifications');};

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UI_EVENT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRACK_EVENT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SCREEN_EVENT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPERATIONAL_EVENT_TYPE; });
/* unused harmony export DEFAULT_SOURCE */
var UI_EVENT_TYPE = 'ui';
var TRACK_EVENT_TYPE = 'track';
var SCREEN_EVENT_TYPE = 'screen';
var OPERATIONAL_EVENT_TYPE = 'operational';
var DEFAULT_SOURCE = 'unknown';
//# sourceMappingURL=index.js.map

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCSSUnitValue;
function getCSSUnitValue(value) {
    return typeof value === 'string' ? value : value + "px";
}
//# sourceMappingURL=getCSSUnitValue.js.map

/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCSSUnitValue;
function getCSSUnitValue(value) {
    return typeof value === 'string' ? value : value + "px";
}
//# sourceMappingURL=getCSSUnitValue.js.map

/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultSmallCardDimensions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultImageCardDimensions; });
/* unused harmony export defaultHorizontalCardDimensions */
/* unused harmony export defaultSquareCardDimensions */
/* unused harmony export minSmallCardDimensions */
/* unused harmony export minImageCardDimensions */
/* unused harmony export minSquareCardDimensions */
/* unused harmony export minHorizontalCardDimensions */
/* unused harmony export maxImageCardDimensions */
/* unused harmony export maxHorizontalCardDimensions */
/* unused harmony export maxSquareCardDimensions */
/* unused harmony export getCardMaxHeight */
/* unused harmony export getCardMinWidth */
/* unused harmony export getCardMaxWidth */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCSSBoundaries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDefaultCardDimensions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getCSSUnitValue__ = __webpack_require__(1340);

// Default dimensions
var defaultSmallCardDimensions = {
    width: '100%',
    height: 42,
};
var defaultImageCardDimensions = {
    width: 156,
    height: 125,
};
var defaultHorizontalCardDimensions = {
    width: 435,
    height: 125,
};
var defaultSquareCardDimensions = {
    width: 300,
    height: 300,
};
// Small dimensions
var minSmallCardDimensions = {
    width: 200,
    height: 32,
};
var minImageCardDimensions = {
    width: 144,
    height: 96,
};
var minSquareCardDimensions = {
    width: 272,
    height: 275,
};
var minHorizontalCardDimensions = {
    width: 400,
    height: 125,
};
// Max dimensions
var maxImageCardDimensions = {
    width: 480,
    height: 360,
};
var maxHorizontalCardDimensions = {
    width: 400,
    height: 116,
};
var maxSquareCardDimensions = {
    width: 400,
    height: 348,
};
var getCardMaxHeight = function (appearance) {
    if (appearance === 'image') {
        return maxImageCardDimensions.height;
    }
    if (appearance === 'horizontal') {
        return maxHorizontalCardDimensions.height;
    }
    if (appearance === 'square') {
        return maxSquareCardDimensions.height;
    }
    return maxSquareCardDimensions.width;
};
var getCardMinWidth = function (appearance) {
    if (appearance === 'image') {
        return minImageCardDimensions.width;
    }
    if (appearance === 'horizontal') {
        return minHorizontalCardDimensions.width;
    }
    if (appearance === 'square') {
        return minSquareCardDimensions.width;
    }
    return minSmallCardDimensions.width;
};
var getCardMaxWidth = function (appearance) {
    if (appearance === 'image') {
        return maxImageCardDimensions.width;
    }
    if (appearance === 'horizontal') {
        return maxHorizontalCardDimensions.width;
    }
    if (appearance === 'square') {
        return maxSquareCardDimensions.width;
    }
    return maxSquareCardDimensions.width;
};
var getCSSBoundaries = function (appearance) {
    var width = "\n    min-width: " + Object(__WEBPACK_IMPORTED_MODULE_0__getCSSUnitValue__["a" /* getCSSUnitValue */])(getCardMinWidth(appearance)) + ";\n    max-width: " + Object(__WEBPACK_IMPORTED_MODULE_0__getCSSUnitValue__["a" /* getCSSUnitValue */])(getCardMaxWidth(appearance)) + ";\n  ";
    var height = '';
    if (appearance === 'horizontal') {
        height = "\n      height: " + Object(__WEBPACK_IMPORTED_MODULE_0__getCSSUnitValue__["a" /* getCSSUnitValue */])(defaultHorizontalCardDimensions.height || '') + ";\n    ";
    }
    return width + height;
};
var getDefaultCardDimensions = function (appearance) {
    if (appearance === 'image') {
        return defaultImageCardDimensions;
    }
    if (appearance === 'square') {
        return defaultSquareCardDimensions;
    }
    if (appearance === 'horizontal') {
        return defaultHorizontalCardDimensions;
    }
    return defaultImageCardDimensions;
};
//# sourceMappingURL=cardDimensions.js.map

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultSmallCardDimensions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultImageCardDimensions; });
/* unused harmony export defaultHorizontalCardDimensions */
/* unused harmony export defaultSquareCardDimensions */
/* unused harmony export minSmallCardDimensions */
/* unused harmony export minImageCardDimensions */
/* unused harmony export minSquareCardDimensions */
/* unused harmony export minHorizontalCardDimensions */
/* unused harmony export maxImageCardDimensions */
/* unused harmony export maxHorizontalCardDimensions */
/* unused harmony export maxSquareCardDimensions */
/* unused harmony export getCardMaxHeight */
/* unused harmony export getCardMinWidth */
/* unused harmony export getCardMaxWidth */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCSSBoundaries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDefaultCardDimensions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getCSSUnitValue__ = __webpack_require__(1341);

// Default dimensions
var defaultSmallCardDimensions = {
    width: '100%',
    height: 42,
};
var defaultImageCardDimensions = {
    width: 156,
    height: 125,
};
var defaultHorizontalCardDimensions = {
    width: 435,
    height: 125,
};
var defaultSquareCardDimensions = {
    width: 300,
    height: 300,
};
// Small dimensions
var minSmallCardDimensions = {
    width: 200,
    height: 32,
};
var minImageCardDimensions = {
    width: 144,
    height: 96,
};
var minSquareCardDimensions = {
    width: 272,
    height: 275,
};
var minHorizontalCardDimensions = {
    width: 400,
    height: 125,
};
// Max dimensions
var maxImageCardDimensions = {
    width: 480,
    height: 360,
};
var maxHorizontalCardDimensions = {
    width: 400,
    height: 116,
};
var maxSquareCardDimensions = {
    width: 400,
    height: 348,
};
var getCardMaxHeight = function (appearance) {
    if (appearance === 'image') {
        return maxImageCardDimensions.height;
    }
    if (appearance === 'horizontal') {
        return maxHorizontalCardDimensions.height;
    }
    if (appearance === 'square') {
        return maxSquareCardDimensions.height;
    }
    return maxSquareCardDimensions.width;
};
var getCardMinWidth = function (appearance) {
    if (appearance === 'image') {
        return minImageCardDimensions.width;
    }
    if (appearance === 'horizontal') {
        return minHorizontalCardDimensions.width;
    }
    if (appearance === 'square') {
        return minSquareCardDimensions.width;
    }
    return minSmallCardDimensions.width;
};
var getCardMaxWidth = function (appearance) {
    if (appearance === 'image') {
        return maxImageCardDimensions.width;
    }
    if (appearance === 'horizontal') {
        return maxHorizontalCardDimensions.width;
    }
    if (appearance === 'square') {
        return maxSquareCardDimensions.width;
    }
    return maxSquareCardDimensions.width;
};
var getCSSBoundaries = function (appearance) {
    var width = "\n    min-width: " + Object(__WEBPACK_IMPORTED_MODULE_0__getCSSUnitValue__["a" /* getCSSUnitValue */])(getCardMinWidth(appearance)) + ";\n    max-width: " + Object(__WEBPACK_IMPORTED_MODULE_0__getCSSUnitValue__["a" /* getCSSUnitValue */])(getCardMaxWidth(appearance)) + ";\n  ";
    var height = '';
    if (appearance === 'horizontal') {
        height = "\n      height: " + Object(__WEBPACK_IMPORTED_MODULE_0__getCSSUnitValue__["a" /* getCSSUnitValue */])(defaultHorizontalCardDimensions.height || '') + ";\n    ";
    }
    return width + height;
};
var getDefaultCardDimensions = function (appearance) {
    if (appearance === 'image') {
        return defaultImageCardDimensions;
    }
    if (appearance === 'square') {
        return defaultSquareCardDimensions;
    }
    if (appearance === 'horizontal') {
        return defaultHorizontalCardDimensions;
    }
    return defaultImageCardDimensions;
};
//# sourceMappingURL=cardDimensions.js.map

/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = mouseLocation;
/* harmony export (immutable) */ __webpack_exports__["a"] = actualMouseMove;
/* harmony export (immutable) */ __webpack_exports__["b"] = leftClick;
function mouseLocation(event) {
    return {
        x: event.clientX,
        y: event.clientY,
    };
}
// Used to prevent invalid mouse move detection on scroll
// lastPosition is object (x, y)
function actualMouseMove(oldPosition, newPosition) {
    if (!oldPosition ||
        oldPosition.x !== newPosition.x ||
        oldPosition.y !== newPosition.y) {
        return true;
    }
    return false;
}
function leftClick(reactEvent) {
    return (reactEvent.button === 0 &&
        !reactEvent.altKey &&
        !reactEvent.ctrlKey &&
        !reactEvent.metaKey &&
        !reactEvent.shiftKey);
}
//# sourceMappingURL=mouse.js.map

/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CachingEmoji */
/* unused harmony export CachingMediaEmoji */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type_helpers__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_logger__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Emoji__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EmojiPlaceholder__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_EmojiUtils__ = __webpack_require__(195);









/**
 * Renders an emoji from a cached image, if required.
 */
var CachingEmoji = function (props) {
    // tslint:disable-line:variable-name
    // Optimisation to only render the class based CachingMediaEmoji if necessary
    // slight performance hit, which accumulates for a large number of emoji.
    var placeholderSize = props.placeholderSize, emojiProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](props, ["placeholderSize"]);
    if (Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["j" /* isMediaEmoji */])(props.emoji)) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CachingMediaEmoji, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, props));
    }
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Emoji__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, emojiProps));
};
/**
 * Rendering a media emoji image from a cache for media emoji, with different
 * rendering paths depending on caching strategy.
 */
var CachingMediaEmoji = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CachingMediaEmoji, _super);
    function CachingMediaEmoji(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.handleLoadError = function (emojiId, emoji) {
            var invalidImage = _this.state.invalidImage;
            if (invalidImage || !emoji) {
                // do nothing, bad image
                return;
            }
            _this.setState({
                cachedEmoji: _this.loadEmoji(emoji, _this.context, true),
            });
        };
        _this.state = {
            cachedEmoji: _this.loadEmoji(props.emoji, context, false),
        };
        return _this;
    }
    CachingMediaEmoji.prototype.componentDidMount = function () {
        this.mounted = true;
    };
    CachingMediaEmoji.prototype.componentWillUnmount = function () {
        this.mounted = false;
    };
    CachingMediaEmoji.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        if (nextProps.emoji !== this.props.emoji) {
            if (this.mounted) {
                this.setState({
                    cachedEmoji: this.loadEmoji(nextProps.emoji, nextContext, false),
                });
            }
        }
    };
    CachingMediaEmoji.prototype.loadEmoji = function (emoji, context, forceLoad) {
        var _this = this;
        if (!context.emoji) {
            return undefined;
        }
        var emojiProvider = context.emoji.emojiProvider;
        if (!emojiProvider) {
            return undefined;
        }
        var fitToHeight = this.props.fitToHeight;
        var useAlt = Object(__WEBPACK_IMPORTED_MODULE_7__api_EmojiUtils__["d" /* shouldUseAltRepresentation */])(emoji, fitToHeight);
        var optimisticRendering = emojiProvider.optimisticMediaRendering(emoji, useAlt);
        if (optimisticRendering && !forceLoad) {
            Object(__WEBPACK_IMPORTED_MODULE_4__util_logger__["a" /* default */])('Optimistic rendering', emoji.shortName);
            return emoji;
        }
        Object(__WEBPACK_IMPORTED_MODULE_4__util_logger__["a" /* default */])('Loading image via media cache', emoji.shortName);
        var loadedEmoji = emojiProvider.loadMediaEmoji(emoji, useAlt);
        if (Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["l" /* isPromise */])(loadedEmoji)) {
            loadedEmoji
                .then(function (cachedEmoji) {
                if (_this.mounted) {
                    _this.setState({
                        cachedEmoji: cachedEmoji,
                        invalidImage: !cachedEmoji,
                    });
                }
            })
                .catch(function (err) {
                if (_this.mounted) {
                    _this.setState({
                        cachedEmoji: undefined,
                        invalidImage: true,
                    });
                }
            });
            return undefined;
        }
        return loadedEmoji;
    };
    CachingMediaEmoji.prototype.render = function () {
        var cachedEmoji = this.state.cachedEmoji;
        var _a = this.props, children = _a.children, placeholderSize = _a.placeholderSize, otherProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["children", "placeholderSize"]);
        var emojiComponent;
        if (cachedEmoji) {
            emojiComponent = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Emoji__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, otherProps, { emoji: cachedEmoji, onLoadError: this.handleLoadError })));
        }
        else {
            var _b = this.props, emoji = _b.emoji, placeholderSize_1 = _b.placeholderSize, showTooltip = _b.showTooltip, fitToHeight = _b.fitToHeight;
            var shortName = emoji.shortName, representation = emoji.representation;
            emojiComponent = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__EmojiPlaceholder__["a" /* default */], { size: fitToHeight || placeholderSize_1, shortName: shortName, showTooltip: showTooltip, representation: representation }));
        }
        return emojiComponent;
    };
    CachingMediaEmoji.contextTypes = {
        emoji: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    };
    return CachingMediaEmoji;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

/* harmony default export */ __webpack_exports__["a"] = (CachingEmoji);
//# sourceMappingURL=CachingEmoji.js.map

/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MediaImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_media_ui__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styled__ = __webpack_require__(2270);

/**
 * Only used internally ATM
 */





var MediaImage = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MediaImage, _super);
    function MediaImage(props) {
        var _this = _super.call(this, props) || this;
        _this.onImageLoad = function () {
            if (!_this.imageRef || !_this.imageRef.current) {
                return;
            }
            _this.setState({
                isImageLoaded: true,
                imgWidth: _this.imageRef.current.naturalWidth,
                imgHeight: _this.imageRef.current.naturalHeight,
            });
        };
        _this.imageRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.state = {
            isImageLoaded: false,
            imgWidth: 0,
            imgHeight: 0,
            parentWidth: Infinity,
            parentHeight: Infinity,
        };
        return _this;
    }
    // TODO FIL-4060 we need to check whether the dataURI changes in componentWillReceiveProps()
    // and if it does recalculate the image height and width
    MediaImage.prototype.componentDidMount = function () {
        var parent = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](this).parentElement;
        if (!parent) {
            return;
        }
        var _a = parent.getBoundingClientRect(), width = _a.width, height = _a.height;
        this.setState({
            parentWidth: width,
            parentHeight: height,
        });
    };
    MediaImage.prototype.render = function () {
        var _a = this.props, crop = _a.crop, stretch = _a.stretch, dataURI = _a.dataURI, previewOrientation = _a.previewOrientation;
        var _b = this.state, parentWidth = _b.parentWidth, parentHeight = _b.parentHeight, imgWidth = _b.imgWidth, imgHeight = _b.imgHeight, isImageLoaded = _b.isImageLoaded;
        var parentRatio = parentWidth / parentHeight;
        var imgRatio = imgWidth / imgHeight;
        /*
          Cover strategy means we want to full entire screen with an image. Here is an example:
    
             Image           Container   Result (░ - is what cropped out)
         ┌──────────────┐    ┌──────┐    ┌───┬──────┬───┐
         │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
         │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │░░░│▓▓▓▓▓▓│░░░│
         │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
         │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    └──────┘    └───┴──────┴───┘
         └──────────────┘
        */
        var isCoverStrategy = crop;
        /*
          Fit strategy means image is fully inside container even if there is empty space left.
          Here is an example:
    
                 Image            Container     Result
         ┌────────────────────┐    ┌──────┐    ┌──────┐
         │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
         │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │▓▓▓▓▓▓│
         │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │▓▓▓▓▓▓│
         │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
         └────────────────────┘    └──────┘    └──────┘
         */
        var isFitStrategy = !crop;
        /*
          Here is an example of when isImageMoreLandscapyThanContainer is true:
    
            Image      Container   OR   Image      Container
           ________      _____          ____           __
          |        | -> |     |        |    |   ->    |  |
          |________|    |_____|        |    |         |  |
                                       |    |         |  |
                                       |    |         |  |
                                       |____|         |__|
    
          For false just swap "Image" and "Container" in the example above.
         */
        var isImageMoreLandscapyThanContainer = imgRatio > parentRatio;
        /*
          When isStretchingAllowed is false image is as big as it is, but as small as container
          (according to strategy - cover or fit).
          isStretchingAllowed is true if image is bigger then container.
         */
        var isStretchingAllowed = stretch;
        /*
          We do not want to show image until we finish deciding on sizing strategy.
          Though if it is a "fit" strategy we can display it right away, since it doesn't depend
          on isImageMoreLandscapyThanContainer nor it will change when isStretchingAllowed changes
          it's value after imgRatio and parentRatio get defined.
         */
        var showImage = isImageLoaded || isFitStrategy;
        var style = {
            transform: 'translate(-50%, -50%)',
        };
        if (isStretchingAllowed) {
            if (isFitStrategy && isImageMoreLandscapyThanContainer) {
                /*
                  Image matches its width to container's and height scales accordingly.
        
                    Image       Container       Result
                               ┌─────────┐    ┌─────────┐
                   ┌──────┐    │         │    ├─────────┤
                   │▓▓▓▓▓▓│ -> │         │ => │▓▓▓▓▓▓▓▓▓│
                   │▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
                   └──────┘    │         │    ├─────────┤
                               └─────────┘    └─────────┘
                 */
                style.width = '100%';
            }
            else if (isFitStrategy && !isImageMoreLandscapyThanContainer) {
                /*
                  Image matches its height to container's and width scales accordingly.
                 */
                style.height = '100%';
            }
            else if (isCoverStrategy && isImageMoreLandscapyThanContainer) {
                /*
                  In order to cover whole container guaranteed (even in expense of stretching)
                  image matches its height to container's. Width scales accordingly and crops out sides.
        
                     Image       Container    Result (░ - is what cropped out)
                               ┌─────────┐    ┌──┬──────┬──┐
                   ┌──────┐    │         │    │░░│▓▓▓▓▓▓│░░│
                   │▓▓▓▓▓▓│ -> │         │ => │░░│▓▓▓▓▓▓│░░│
                   │▓▓▓▓▓▓│    │         │    │░░│▓▓▓▓▓▓│░░│
                   └──────┘    │         │    │░░│▓▓▓▓▓▓│░░│
                               └─────────┘    └──┴──────┴──┘
                 */
                style.height = '100%';
            }
            else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) {
                style.width = '100%';
            }
        }
        else {
            if (isFitStrategy) {
                /*
                  We want image to be as wide and as height as container but not bigger then it's own size.
        
                    Image       Container       Result
                   ┌───────────┐    ┌─────────┐    ┌─────────┐
                   │▓▓▓▓▓▓▓▓▓▓▓│    │         │    ├─────────┤
                   │▓▓▓▓▓▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
                   │▓▓▓▓▓▓▓▓▓▓▓│->  │         │ => │▓▓▓▓▓▓▓▓▓│
                   └───────────┘    │         │    │▓▓▓▓▓▓▓▓▓│
                                    │         │    ├─────────┤
                                    └─────────┘    └─────────┘
        
                 And if image is smaller it doesn't change its size
        
                    Image       Container       Result
                               ┌──────────┐    ┌──────────┐
                               │          │    │          │
                   ┌──────┐    │          │    │ ┌──────┐ │
                   │▓▓▓▓▓▓│ -> │          │ => │ │▓▓▓▓▓▓│ │
                   │▓▓▓▓▓▓│    │          │    │ │▓▓▓▓▓▓│ │
                   └──────┘    │          │    │ └──────┘ │
                               │          │    │          │
                               └──────────┘    └──────────┘
                 */
                style.maxWidth = '100%';
                style.maxHeight = '100%';
            }
            else if (isCoverStrategy && isImageMoreLandscapyThanContainer) {
                /*
                  We want to fill container but we can't stretch an image if it's smaller then container.
        
                    Image            Container       Result
                   ┌────────────┐    ┌───────┐    ┌──┬───────┬──┐
                   │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
                   │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
                   │▓▓▓▓▓▓▓▓▓▓▓▓│->  │       │ => │░░│▓▓▓▓▓▓▓│░░│
                   │▓▓▓▓▓▓▓▓▓▓▓▓│    └───────┘    └──┴───────┴──┘
                   └────────────┘
        
                 */
                style.maxHeight = '100%';
            }
            else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) {
                style.maxWidth = '100%';
            }
        }
        if (!showImage) {
            style.display = 'none';
        }
        if (previewOrientation && previewOrientation > 1) {
            var transform = Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_media_ui__["t" /* getCssFromImageOrientation */])(previewOrientation);
            style.transform += " " + transform;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styled__["a" /* ImageComponent */], { draggable: false, style: style, onLoad: this.onImageLoad, innerRef: this.imageRef, src: dataURI }));
    };
    MediaImage.defaultProps = {
        crop: true,
        stretch: false,
        width: '100%',
        height: '100%',
        className: '',
    };
    return MediaImage;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardActionsView__ = __webpack_require__(2271);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__cardActionsView__["a"]; });
/* unused harmony reexport CardActionsView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardActionIconButton__ = __webpack_require__(781);
/* unused harmony reexport CardActionIconButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cardActionsDropdownMenu__ = __webpack_require__(782);
/* unused harmony reexport CardActionsDropdownMenu */



//# sourceMappingURL=index.js.map

/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cardShadow; });
/* unused harmony export FadeinImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_media_ui__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(780);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins__ = __webpack_require__(2272);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__mixins__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__mixins__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__mixins__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__mixins__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__easing__ = __webpack_require__(2273);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__easing__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__animations__ = __webpack_require__(2274);
/* unused harmony namespace reexport */
/* tslint:disable:variable-name */








var Root = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  box-sizing: border-box;\n  font-family: ", ";\n\n  * {\n    box-sizing: border-box;\n  }\n"], ["\n  box-sizing: border-box;\n  font-family: ", ";\n\n  * {\n    box-sizing: border-box;\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akFontFamily"]);
var cardShadow = "\n  box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);\n";
var FadeinImage = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", ";\n"], ["\n  ", ";\n"])), __WEBPACK_IMPORTED_MODULE_3__atlaskit_media_ui__["s" /* fadeIn */]);
/* unused harmony default export */ var _unused_webpack_default_export = (Root);
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map

/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return breakpointSize; });
/* unused harmony export cardBreakpointSizes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return breakpointStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_media_ui__ = __webpack_require__(51);

var breakpointSize = function (width, sizes) {
    if (sizes === void 0) { sizes = cardBreakpointSizes; }
    var value = parseInt("" + width, 10); // Normalize value
    var keys = Object.keys(sizes);
    var defaultValue = keys[0];
    var breakpoint;
    keys.forEach(function (label) {
        if (value < sizes[label] && !breakpoint) {
            breakpoint = label;
        }
    });
    return breakpoint || defaultValue;
};
var cardBreakpointSizes = {
    small: 173,
    medium: 225,
    large: 300,
    xlarge: Infinity,
};
var breakpointStyles = function (_a) {
    var breakpointSize = _a.breakpointSize;
    switch (breakpointSize) {
        case 'small':
            return "\n        .title {\n          font-size: 12px;\n        }\n        .file-type-icon span {\n          // We need to use important here since we can't use the dimensions provided by the Icon component\n          " + Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_media_ui__["y" /* size */])('14px !important') + "\n        }\n      ";
        case 'medium':
            return "\n        .title {\n          font-size: 14px;\n        }\n        .file-type-icon span {\n          " + Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_media_ui__["y" /* size */])('16px !important') + "\n        }\n      ";
        case 'large':
            return "\n        .overlay {\n          padding: 24px;\n        }\n        .title {\n          font-size: 14px;\n        }\n        .file-size {\n          font-size: 14px;\n        }\n        .file-type-icon span {\n          " + Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_media_ui__["y" /* size */])('18px !important') + "\n        }\n      ";
        case 'xlarge':
            return "\n        border-radius: 2px;\n\n        .title {\n          font-size: 16px;\n        }\n\n        .file-size {\n          font-size: 14px;\n        }\n        \n        .wrapper, .img-wrapper {\n          border-radius: 2px;\n        }\n\n        .overlay {\n          padding: 24px;\n        }\n\n        .file-type-icon span {\n          " + Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_media_ui__["y" /* size */])('18px !important') + "\n        }\n      ";
    }
};
//# sourceMappingURL=breakpoint.js.map

/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isValidPercentageUnit; });
// Utility used to know if the integrator is using percentage values
var isValidPercentageUnit = function (value) {
    var valueString = "" + value;
    return (valueString[valueString.length - 1] === '%' &&
        !isNaN(+valueString.slice(0, -1)));
};
//# sourceMappingURL=isValidPercentageUnit.js.map

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _scrollparent = __webpack_require__(2287);

var _scrollparent2 = _interopRequireDefault(_scrollparent);

__webpack_require__(208);

var _getViewportBounds2 = __webpack_require__(2288);

var _getViewportBounds3 = _interopRequireDefault(_getViewportBounds2);

var _getElementBounds2 = __webpack_require__(783);

var _getElementBounds3 = _interopRequireDefault(_getElementBounds2);

var _convertOffsetToBounds = __webpack_require__(2289);

var _convertOffsetToBounds2 = _interopRequireDefault(_convertOffsetToBounds);

var _isElementInViewport = __webpack_require__(2290);

var _isElementInViewport2 = _interopRequireDefault(_isElementInViewport);

var _isBackCompatMode = __webpack_require__(2291);

var _isBackCompatMode2 = _interopRequireDefault(_isBackCompatMode);

var _eventListenerOptions = __webpack_require__(2292);

var _eventListenerOptions2 = _interopRequireDefault(_eventListenerOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LazilyRender = function (_React$Component) {
  _inherits(LazilyRender, _React$Component);

  function LazilyRender() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LazilyRender);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LazilyRender.__proto__ || Object.getPrototypeOf(LazilyRender)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hasBeenScrolledIntoView: false
    }, _this.update = function () {
      cancelAnimationFrame(_this.raf);
      _this.raf = requestAnimationFrame(function () {

        var elementBounds = _this.getElementBounds();
        var viewportBounds = _this.getViewportBounds();
        var offsetBounds = _this.getOffsetBounds();

        if (!elementBounds || !viewportBounds) {
          return;
        }

        if ((0, _isElementInViewport2.default)(elementBounds, viewportBounds, offsetBounds)) {
          _this.stopListening();
          _this.setState({
            hasBeenScrolledIntoView: true
          }, function () {
            var onRender = _this.props.onRender;

            if (onRender) {
              onRender();
            }
          });
        }
      });
    }, _this.handleMount = function (element) {
      _this.element = element;
      if (_this.element) {
        _this.container = _this.getContainer();
      } else {
        _this.container = undefined;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LazilyRender, [{
    key: 'getContainer',
    value: function getContainer() {
      var container = (0, _scrollparent2.default)(this.element);
      if (container === document.scrollingElement || container === document.documentElement || !(0, _isBackCompatMode2.default)() && container == document.body) {
        return window;
      } else {
        return container;
      }
    }
  }, {
    key: 'getViewportBounds',
    value: function getViewportBounds() {
      return (0, _getViewportBounds3.default)(this.container);
    }
  }, {
    key: 'getElementBounds',
    value: function getElementBounds() {
      return (0, _getElementBounds3.default)(this.element);
    }
  }, {
    key: 'getOffsetBounds',
    value: function getOffsetBounds() {
      var offset = this.props.offset;

      return (0, _convertOffsetToBounds2.default)(offset);
    }
  }, {
    key: 'startListening',
    value: function startListening() {
      var container = this.container;
      if (container) container.addEventListener('scroll', this.update, _eventListenerOptions2.default);
      window.addEventListener('resize', this.update);
    }
  }, {
    key: 'stopListening',
    value: function stopListening() {
      var container = this.container;
      if (container) container.removeEventListener('scroll', this.update, _eventListenerOptions2.default);
      window.removeEventListener('resize', this.update);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.update();
      this.startListening();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopListening();
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var _props = this.props,
          placeholder = _props.placeholder,
          content = _props.content,
          children = _props.children;
      var hasBeenScrolledIntoView = this.state.hasBeenScrolledIntoView;


      if (!hasBeenScrolledIntoView && placeholder) {
        return placeholder;
      }

      if (hasBeenScrolledIntoView && content) {
        return content;
      }

      if (children) {
        return children(hasBeenScrolledIntoView);
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          component = _props2.component;

      return React.createElement(component || 'div', {
        ref: this.handleMount,
        className: className,
        children: this.renderChildren()
      });
    }
  }]);

  return LazilyRender;
}(React.Component);

exports.default = LazilyRender;

/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MediaImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_media_ui__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styled__ = __webpack_require__(2609);

/**
 * Only used internally ATM
 */





var MediaImage = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MediaImage, _super);
    function MediaImage(props) {
        var _this = _super.call(this, props) || this;
        _this.onImageLoad = function () {
            if (!_this.imageRef || !_this.imageRef.current) {
                return;
            }
            _this.setState({
                isImageLoaded: true,
                imgWidth: _this.imageRef.current.naturalWidth,
                imgHeight: _this.imageRef.current.naturalHeight,
            });
        };
        _this.imageRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.state = {
            isImageLoaded: false,
            imgWidth: 0,
            imgHeight: 0,
            parentWidth: Infinity,
            parentHeight: Infinity,
        };
        return _this;
    }
    // TODO FIL-4060 we need to check whether the dataURI changes in componentWillReceiveProps()
    // and if it does recalculate the image height and width
    MediaImage.prototype.componentDidMount = function () {
        var parent = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](this).parentElement;
        if (!parent) {
            return;
        }
        var _a = parent.getBoundingClientRect(), width = _a.width, height = _a.height;
        this.setState({
            parentWidth: width,
            parentHeight: height,
        });
    };
    MediaImage.prototype.render = function () {
        var _a = this.props, crop = _a.crop, stretch = _a.stretch, dataURI = _a.dataURI, previewOrientation = _a.previewOrientation;
        var _b = this.state, parentWidth = _b.parentWidth, parentHeight = _b.parentHeight, imgWidth = _b.imgWidth, imgHeight = _b.imgHeight, isImageLoaded = _b.isImageLoaded;
        var parentRatio = parentWidth / parentHeight;
        var imgRatio = imgWidth / imgHeight;
        /*
          Cover strategy means we want to full entire screen with an image. Here is an example:
    
             Image           Container   Result (░ - is what cropped out)
         ┌──────────────┐    ┌──────┐    ┌───┬──────┬───┐
         │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
         │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │░░░│▓▓▓▓▓▓│░░░│
         │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
         │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    └──────┘    └───┴──────┴───┘
         └──────────────┘
        */
        var isCoverStrategy = crop;
        /*
          Fit strategy means image is fully inside container even if there is empty space left.
          Here is an example:
    
                 Image            Container     Result
         ┌────────────────────┐    ┌──────┐    ┌──────┐
         │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
         │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │▓▓▓▓▓▓│
         │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │▓▓▓▓▓▓│
         │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
         └────────────────────┘    └──────┘    └──────┘
         */
        var isFitStrategy = !crop;
        /*
          Here is an example of when isImageMoreLandscapyThanContainer is true:
    
            Image      Container   OR   Image      Container
           ________      _____          ____           __
          |        | -> |     |        |    |   ->    |  |
          |________|    |_____|        |    |         |  |
                                       |    |         |  |
                                       |    |         |  |
                                       |____|         |__|
    
          For false just swap "Image" and "Container" in the example above.
         */
        var isImageMoreLandscapyThanContainer = imgRatio > parentRatio;
        /*
          When isStretchingAllowed is false image is as big as it is, but as small as container
          (according to strategy - cover or fit).
          isStretchingAllowed is true if image is bigger then container.
         */
        var isStretchingAllowed = stretch;
        /*
          We do not want to show image until we finish deciding on sizing strategy.
          Though if it is a "fit" strategy we can display it right away, since it doesn't depend
          on isImageMoreLandscapyThanContainer nor it will change when isStretchingAllowed changes
          it's value after imgRatio and parentRatio get defined.
         */
        var showImage = isImageLoaded || isFitStrategy;
        var style = {
            transform: 'translate(-50%, -50%)',
        };
        if (isStretchingAllowed) {
            if (isFitStrategy && isImageMoreLandscapyThanContainer) {
                /*
                  Image matches its width to container's and height scales accordingly.
        
                    Image       Container       Result
                               ┌─────────┐    ┌─────────┐
                   ┌──────┐    │         │    ├─────────┤
                   │▓▓▓▓▓▓│ -> │         │ => │▓▓▓▓▓▓▓▓▓│
                   │▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
                   └──────┘    │         │    ├─────────┤
                               └─────────┘    └─────────┘
                 */
                style.width = '100%';
            }
            else if (isFitStrategy && !isImageMoreLandscapyThanContainer) {
                /*
                  Image matches its height to container's and width scales accordingly.
                 */
                style.height = '100%';
            }
            else if (isCoverStrategy && isImageMoreLandscapyThanContainer) {
                /*
                  In order to cover whole container guaranteed (even in expense of stretching)
                  image matches its height to container's. Width scales accordingly and crops out sides.
        
                     Image       Container    Result (░ - is what cropped out)
                               ┌─────────┐    ┌──┬──────┬──┐
                   ┌──────┐    │         │    │░░│▓▓▓▓▓▓│░░│
                   │▓▓▓▓▓▓│ -> │         │ => │░░│▓▓▓▓▓▓│░░│
                   │▓▓▓▓▓▓│    │         │    │░░│▓▓▓▓▓▓│░░│
                   └──────┘    │         │    │░░│▓▓▓▓▓▓│░░│
                               └─────────┘    └──┴──────┴──┘
                 */
                style.height = '100%';
            }
            else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) {
                style.width = '100%';
            }
        }
        else {
            if (isFitStrategy) {
                /*
                  We want image to be as wide and as height as container but not bigger then it's own size.
        
                    Image       Container       Result
                   ┌───────────┐    ┌─────────┐    ┌─────────┐
                   │▓▓▓▓▓▓▓▓▓▓▓│    │         │    ├─────────┤
                   │▓▓▓▓▓▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
                   │▓▓▓▓▓▓▓▓▓▓▓│->  │         │ => │▓▓▓▓▓▓▓▓▓│
                   └───────────┘    │         │    │▓▓▓▓▓▓▓▓▓│
                                    │         │    ├─────────┤
                                    └─────────┘    └─────────┘
        
                 And if image is smaller it doesn't change its size
        
                    Image       Container       Result
                               ┌──────────┐    ┌──────────┐
                               │          │    │          │
                   ┌──────┐    │          │    │ ┌──────┐ │
                   │▓▓▓▓▓▓│ -> │          │ => │ │▓▓▓▓▓▓│ │
                   │▓▓▓▓▓▓│    │          │    │ │▓▓▓▓▓▓│ │
                   └──────┘    │          │    │ └──────┘ │
                               │          │    │          │
                               └──────────┘    └──────────┘
                 */
                style.maxWidth = '100%';
                style.maxHeight = '100%';
            }
            else if (isCoverStrategy && isImageMoreLandscapyThanContainer) {
                /*
                  We want to fill container but we can't stretch an image if it's smaller then container.
        
                    Image            Container       Result
                   ┌────────────┐    ┌───────┐    ┌──┬───────┬──┐
                   │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
                   │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
                   │▓▓▓▓▓▓▓▓▓▓▓▓│->  │       │ => │░░│▓▓▓▓▓▓▓│░░│
                   │▓▓▓▓▓▓▓▓▓▓▓▓│    └───────┘    └──┴───────┴──┘
                   └────────────┘
        
                 */
                style.maxHeight = '100%';
            }
            else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) {
                style.maxWidth = '100%';
            }
        }
        if (!showImage) {
            style.display = 'none';
        }
        if (previewOrientation && previewOrientation > 1) {
            var transform = Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_media_ui__["t" /* getCssFromImageOrientation */])(previewOrientation);
            style.transform += " " + transform;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styled__["a" /* ImageComponent */], { draggable: false, style: style, onLoad: this.onImageLoad, innerRef: this.imageRef, src: dataURI }));
    };
    MediaImage.defaultProps = {
        crop: true,
        stretch: false,
        width: '100%',
        height: '100%',
        className: '',
    };
    return MediaImage;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardActionsView__ = __webpack_require__(2610);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__cardActionsView__["a"]; });
/* unused harmony reexport CardActionsView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardActionIconButton__ = __webpack_require__(855);
/* unused harmony reexport CardActionIconButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cardActionsDropdownMenu__ = __webpack_require__(856);
/* unused harmony reexport CardActionsDropdownMenu */



//# sourceMappingURL=index.js.map

/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cardShadow; });
/* unused harmony export FadeinImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_media_ui__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(854);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins__ = __webpack_require__(2611);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__mixins__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__mixins__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__mixins__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__mixins__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__easing__ = __webpack_require__(2612);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__easing__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__animations__ = __webpack_require__(2613);
/* unused harmony namespace reexport */
/* tslint:disable:variable-name */








var Root = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  box-sizing: border-box;\n  font-family: ", ";\n\n  * {\n    box-sizing: border-box;\n  }\n"], ["\n  box-sizing: border-box;\n  font-family: ", ";\n\n  * {\n    box-sizing: border-box;\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akFontFamily"]);
var cardShadow = "\n  box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);\n";
var FadeinImage = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", ";\n"], ["\n  ", ";\n"])), __WEBPACK_IMPORTED_MODULE_3__atlaskit_media_ui__["s" /* fadeIn */]);
/* unused harmony default export */ var _unused_webpack_default_export = (Root);
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map

/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return breakpointSize; });
/* unused harmony export cardBreakpointSizes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return breakpointStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_media_ui__ = __webpack_require__(51);

var breakpointSize = function (width, sizes) {
    if (sizes === void 0) { sizes = cardBreakpointSizes; }
    var value = parseInt("" + width, 10); // Normalize value
    var keys = Object.keys(sizes);
    var defaultValue = keys[0];
    var breakpoint;
    keys.forEach(function (label) {
        if (value < sizes[label] && !breakpoint) {
            breakpoint = label;
        }
    });
    return breakpoint || defaultValue;
};
var cardBreakpointSizes = {
    small: 173,
    medium: 225,
    large: 300,
    xlarge: Infinity,
};
var breakpointStyles = function (_a) {
    var breakpointSize = _a.breakpointSize;
    switch (breakpointSize) {
        case 'small':
            return "\n        .title {\n          font-size: 12px;\n        }\n        .file-type-icon span {\n          // We need to use important here since we can't use the dimensions provided by the Icon component\n          " + Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_media_ui__["y" /* size */])('14px !important') + "\n        }\n      ";
        case 'medium':
            return "\n        .title {\n          font-size: 14px;\n        }\n        .file-type-icon span {\n          " + Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_media_ui__["y" /* size */])('16px !important') + "\n        }\n      ";
        case 'large':
            return "\n        .overlay {\n          padding: 24px;\n        }\n        .title {\n          font-size: 14px;\n        }\n        .file-size {\n          font-size: 14px;\n        }\n        .file-type-icon span {\n          " + Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_media_ui__["y" /* size */])('18px !important') + "\n        }\n      ";
        case 'xlarge':
            return "\n        border-radius: 2px;\n\n        .title {\n          font-size: 16px;\n        }\n\n        .file-size {\n          font-size: 14px;\n        }\n        \n        .wrapper, .img-wrapper {\n          border-radius: 2px;\n        }\n\n        .overlay {\n          padding: 24px;\n        }\n\n        .file-type-icon span {\n          " + Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_media_ui__["y" /* size */])('18px !important') + "\n        }\n      ";
    }
};
//# sourceMappingURL=breakpoint.js.map

/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isValidPercentageUnit; });
// Utility used to know if the integrator is using percentage values
var isValidPercentageUnit = function (value) {
    var valueString = "" + value;
    return (valueString[valueString.length - 1] === '%' &&
        !isNaN(+valueString.slice(0, -1)));
};
//# sourceMappingURL=isValidPercentageUnit.js.map

/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = mouseLocation;
/* harmony export (immutable) */ __webpack_exports__["a"] = actualMouseMove;
/* harmony export (immutable) */ __webpack_exports__["b"] = leftClick;
function mouseLocation(event) {
    return {
        x: event.clientX,
        y: event.clientY,
    };
}
// Used to prevent invalid mouse move detection on scroll
// lastPosition is object (x, y)
function actualMouseMove(oldPosition, newPosition) {
    if (!oldPosition ||
        oldPosition.x !== newPosition.x ||
        oldPosition.y !== newPosition.y) {
        return true;
    }
    return false;
}
function leftClick(reactEvent) {
    return (reactEvent.button === 0 &&
        !reactEvent.altKey &&
        !reactEvent.ctrlKey &&
        !reactEvent.metaKey &&
        !reactEvent.shiftKey);
}
//# sourceMappingURL=mouse.js.map

/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CachingEmoji */
/* unused harmony export CachingMediaEmoji */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type_helpers__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_logger__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Emoji__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EmojiPlaceholder__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_EmojiUtils__ = __webpack_require__(229);









/**
 * Renders an emoji from a cached image, if required.
 */
var CachingEmoji = function (props) {
    // tslint:disable-line:variable-name
    // Optimisation to only render the class based CachingMediaEmoji if necessary
    // slight performance hit, which accumulates for a large number of emoji.
    var placeholderSize = props.placeholderSize, emojiProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](props, ["placeholderSize"]);
    if (Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["j" /* isMediaEmoji */])(props.emoji)) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CachingMediaEmoji, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, props));
    }
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Emoji__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, emojiProps));
};
/**
 * Rendering a media emoji image from a cache for media emoji, with different
 * rendering paths depending on caching strategy.
 */
var CachingMediaEmoji = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CachingMediaEmoji, _super);
    function CachingMediaEmoji(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.handleLoadError = function (emojiId, emoji) {
            var invalidImage = _this.state.invalidImage;
            if (invalidImage || !emoji) {
                // do nothing, bad image
                return;
            }
            _this.setState({
                cachedEmoji: _this.loadEmoji(emoji, _this.context, true),
            });
        };
        _this.state = {
            cachedEmoji: _this.loadEmoji(props.emoji, context, false),
        };
        return _this;
    }
    CachingMediaEmoji.prototype.componentDidMount = function () {
        this.mounted = true;
    };
    CachingMediaEmoji.prototype.componentWillUnmount = function () {
        this.mounted = false;
    };
    CachingMediaEmoji.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        if (nextProps.emoji !== this.props.emoji) {
            if (this.mounted) {
                this.setState({
                    cachedEmoji: this.loadEmoji(nextProps.emoji, nextContext, false),
                });
            }
        }
    };
    CachingMediaEmoji.prototype.loadEmoji = function (emoji, context, forceLoad) {
        var _this = this;
        if (!context.emoji) {
            return undefined;
        }
        var emojiProvider = context.emoji.emojiProvider;
        if (!emojiProvider) {
            return undefined;
        }
        var fitToHeight = this.props.fitToHeight;
        var useAlt = Object(__WEBPACK_IMPORTED_MODULE_7__api_EmojiUtils__["d" /* shouldUseAltRepresentation */])(emoji, fitToHeight);
        var optimisticRendering = emojiProvider.optimisticMediaRendering(emoji, useAlt);
        if (optimisticRendering && !forceLoad) {
            Object(__WEBPACK_IMPORTED_MODULE_4__util_logger__["a" /* default */])('Optimistic rendering', emoji.shortName);
            return emoji;
        }
        Object(__WEBPACK_IMPORTED_MODULE_4__util_logger__["a" /* default */])('Loading image via media cache', emoji.shortName);
        var loadedEmoji = emojiProvider.loadMediaEmoji(emoji, useAlt);
        if (Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["l" /* isPromise */])(loadedEmoji)) {
            loadedEmoji
                .then(function (cachedEmoji) {
                if (_this.mounted) {
                    _this.setState({
                        cachedEmoji: cachedEmoji,
                        invalidImage: !cachedEmoji,
                    });
                }
            })
                .catch(function (err) {
                if (_this.mounted) {
                    _this.setState({
                        cachedEmoji: undefined,
                        invalidImage: true,
                    });
                }
            });
            return undefined;
        }
        return loadedEmoji;
    };
    CachingMediaEmoji.prototype.render = function () {
        var cachedEmoji = this.state.cachedEmoji;
        var _a = this.props, children = _a.children, placeholderSize = _a.placeholderSize, otherProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["children", "placeholderSize"]);
        var emojiComponent;
        if (cachedEmoji) {
            emojiComponent = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Emoji__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, otherProps, { emoji: cachedEmoji, onLoadError: this.handleLoadError })));
        }
        else {
            var _b = this.props, emoji = _b.emoji, placeholderSize_1 = _b.placeholderSize, showTooltip = _b.showTooltip, fitToHeight = _b.fitToHeight;
            var shortName = emoji.shortName, representation = emoji.representation;
            emojiComponent = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__EmojiPlaceholder__["a" /* default */], { size: fitToHeight || placeholderSize_1, shortName: shortName, showTooltip: showTooltip, representation: representation }));
        }
        return emojiComponent;
    };
    CachingMediaEmoji.contextTypes = {
        emoji: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    };
    return CachingMediaEmoji;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

/* harmony default export */ __webpack_exports__["a"] = (CachingEmoji);
//# sourceMappingURL=CachingEmoji.js.map

/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = mouseLocation;
/* harmony export (immutable) */ __webpack_exports__["a"] = actualMouseMove;
/* harmony export (immutable) */ __webpack_exports__["b"] = leftClick;
function mouseLocation(event) {
    return {
        x: event.clientX,
        y: event.clientY,
    };
}
// Used to prevent invalid mouse move detection on scroll
// lastPosition is object (x, y)
function actualMouseMove(oldPosition, newPosition) {
    if (!oldPosition ||
        oldPosition.x !== newPosition.x ||
        oldPosition.y !== newPosition.y) {
        return true;
    }
    return false;
}
function leftClick(reactEvent) {
    return (reactEvent.button === 0 &&
        !reactEvent.altKey &&
        !reactEvent.ctrlKey &&
        !reactEvent.metaKey &&
        !reactEvent.shiftKey);
}
//# sourceMappingURL=mouse.js.map

/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CachingEmoji */
/* unused harmony export CachingMediaEmoji */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type_helpers__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_logger__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Emoji__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EmojiPlaceholder__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_EmojiUtils__ = __webpack_require__(231);









/**
 * Renders an emoji from a cached image, if required.
 */
var CachingEmoji = function (props) {
    // tslint:disable-line:variable-name
    // Optimisation to only render the class based CachingMediaEmoji if necessary
    // slight performance hit, which accumulates for a large number of emoji.
    var placeholderSize = props.placeholderSize, emojiProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](props, ["placeholderSize"]);
    if (Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["j" /* isMediaEmoji */])(props.emoji)) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CachingMediaEmoji, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, props));
    }
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Emoji__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, emojiProps));
};
/**
 * Rendering a media emoji image from a cache for media emoji, with different
 * rendering paths depending on caching strategy.
 */
var CachingMediaEmoji = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CachingMediaEmoji, _super);
    function CachingMediaEmoji(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.handleLoadError = function (emojiId, emoji) {
            var invalidImage = _this.state.invalidImage;
            if (invalidImage || !emoji) {
                // do nothing, bad image
                return;
            }
            _this.setState({
                cachedEmoji: _this.loadEmoji(emoji, _this.context, true),
            });
        };
        _this.state = {
            cachedEmoji: _this.loadEmoji(props.emoji, context, false),
        };
        return _this;
    }
    CachingMediaEmoji.prototype.componentDidMount = function () {
        this.mounted = true;
    };
    CachingMediaEmoji.prototype.componentWillUnmount = function () {
        this.mounted = false;
    };
    CachingMediaEmoji.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        if (nextProps.emoji !== this.props.emoji) {
            if (this.mounted) {
                this.setState({
                    cachedEmoji: this.loadEmoji(nextProps.emoji, nextContext, false),
                });
            }
        }
    };
    CachingMediaEmoji.prototype.loadEmoji = function (emoji, context, forceLoad) {
        var _this = this;
        if (!context.emoji) {
            return undefined;
        }
        var emojiProvider = context.emoji.emojiProvider;
        if (!emojiProvider) {
            return undefined;
        }
        var fitToHeight = this.props.fitToHeight;
        var useAlt = Object(__WEBPACK_IMPORTED_MODULE_7__api_EmojiUtils__["d" /* shouldUseAltRepresentation */])(emoji, fitToHeight);
        var optimisticRendering = emojiProvider.optimisticMediaRendering(emoji, useAlt);
        if (optimisticRendering && !forceLoad) {
            Object(__WEBPACK_IMPORTED_MODULE_4__util_logger__["a" /* default */])('Optimistic rendering', emoji.shortName);
            return emoji;
        }
        Object(__WEBPACK_IMPORTED_MODULE_4__util_logger__["a" /* default */])('Loading image via media cache', emoji.shortName);
        var loadedEmoji = emojiProvider.loadMediaEmoji(emoji, useAlt);
        if (Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["l" /* isPromise */])(loadedEmoji)) {
            loadedEmoji
                .then(function (cachedEmoji) {
                if (_this.mounted) {
                    _this.setState({
                        cachedEmoji: cachedEmoji,
                        invalidImage: !cachedEmoji,
                    });
                }
            })
                .catch(function (err) {
                if (_this.mounted) {
                    _this.setState({
                        cachedEmoji: undefined,
                        invalidImage: true,
                    });
                }
            });
            return undefined;
        }
        return loadedEmoji;
    };
    CachingMediaEmoji.prototype.render = function () {
        var cachedEmoji = this.state.cachedEmoji;
        var _a = this.props, children = _a.children, placeholderSize = _a.placeholderSize, otherProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["children", "placeholderSize"]);
        var emojiComponent;
        if (cachedEmoji) {
            emojiComponent = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Emoji__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, otherProps, { emoji: cachedEmoji, onLoadError: this.handleLoadError })));
        }
        else {
            var _b = this.props, emoji = _b.emoji, placeholderSize_1 = _b.placeholderSize, showTooltip = _b.showTooltip, fitToHeight = _b.fitToHeight;
            var shortName = emoji.shortName, representation = emoji.representation;
            emojiComponent = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__EmojiPlaceholder__["a" /* default */], { size: fitToHeight || placeholderSize_1, shortName: shortName, showTooltip: showTooltip, representation: representation }));
        }
        return emojiComponent;
    };
    CachingMediaEmoji.contextTypes = {
        emoji: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    };
    return CachingMediaEmoji;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

/* harmony default export */ __webpack_exports__["a"] = (CachingEmoji);
//# sourceMappingURL=CachingEmoji.js.map

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getElementDimension; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);

var getElementDimension = function (component, dimension) {
    var element = __WEBPACK_IMPORTED_MODULE_0_react_dom__["findDOMNode"](component);
    var dimensionValue = element.getBoundingClientRect()[dimension];
    return Math.round(dimensionValue);
};
//# sourceMappingURL=getElementDimension.js.map

/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModalWrapper__ = __webpack_require__(2298);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_ModalWrapper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ModalTransition__ = __webpack_require__(784);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__components_ModalTransition__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled_Content__ = __webpack_require__(275);
/* unused harmony reexport ModalBody */
/* unused harmony reexport ModalHeader */
/* unused harmony reexport ModalFooter */
/* unused harmony reexport ModalTitle */




/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getElementDimension; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);

var getElementDimension = function (component, dimension) {
    var element = __WEBPACK_IMPORTED_MODULE_0_react_dom__["findDOMNode"](component);
    var dimensionValue = element.getBoundingClientRect()[dimension];
    return Math.round(dimensionValue);
};
//# sourceMappingURL=getElementDimension.js.map

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(118);
var core = __webpack_require__(95);
var fails = __webpack_require__(153);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mediaTypeIcon__ = __webpack_require__(2278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__(2285);

/* tslint:disable:variable-name */




var fileTypeIconClass = 'file-type-icon';
var FileIcon = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](FileIcon, _super);
    function FileIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FileIcon.prototype.render = function () {
        var _a = this.props, mediaType = _a.mediaType, iconUrl = _a.iconUrl, style = _a.style;
        var type = mediaType || 'unknown';
        var defaultIcon = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__mediaTypeIcon__["a" /* MediaTypeIcon */], { type: mediaType, size: "small", className: fileTypeIconClass }));
        var icon = iconUrl ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { src: iconUrl, className: "custom-icon", alt: type })) : (defaultIcon);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* FileTypeIcon */], { style: style, className: fileTypeIconClass }, icon));
    };
    return FileIcon;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_warning__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__(2286);





var ErrorIcon = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ErrorIcon, _super);
    function ErrorIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorIcon.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* ErrorIconWrapper */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_warning___default.a, { label: "Error", size: "small" })));
    };
    return ErrorIcon;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__errorIcon__ = __webpack_require__(1367);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fileIcon__ = __webpack_require__(1366);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cardActions__ = __webpack_require__(1347);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isRetina__ = __webpack_require__(1390);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mediaImage__ = __webpack_require__(1346);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cardLoading__ = __webpack_require__(332);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cardDimensions__ = __webpack_require__(1342);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__cardDimensions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__breakpoint__ = __webpack_require__(1349);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__isValidPercentageUnit__ = __webpack_require__(1350);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getElementDimension__ = __webpack_require__(1362);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containsPixelUnit__ = __webpack_require__(1369);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_media_ui__ = __webpack_require__(51);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_11__atlaskit_media_ui__["z"]; });












//# sourceMappingURL=index.js.map

/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return containsPixelUnit; });
var containsPixelUnit = function (value) {
    return value.substr(-2) === 'px' && !isNaN(+value.slice(0, -2));
};
//# sourceMappingURL=containsPixelUnit.js.map

/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mediaTypeIcon__ = __webpack_require__(2617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__(2624);

/* tslint:disable:variable-name */




var fileTypeIconClass = 'file-type-icon';
var FileIcon = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](FileIcon, _super);
    function FileIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FileIcon.prototype.render = function () {
        var _a = this.props, mediaType = _a.mediaType, iconUrl = _a.iconUrl, style = _a.style;
        var type = mediaType || 'unknown';
        var defaultIcon = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__mediaTypeIcon__["a" /* MediaTypeIcon */], { type: mediaType, size: "small", className: fileTypeIconClass }));
        var icon = iconUrl ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { src: iconUrl, className: "custom-icon", alt: type })) : (defaultIcon);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* FileTypeIcon */], { style: style, className: fileTypeIconClass }, icon));
    };
    return FileIcon;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_warning__ = __webpack_require__(2625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__(2626);





var ErrorIcon = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ErrorIcon, _super);
    function ErrorIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorIcon.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* ErrorIconWrapper */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_warning___default.a, { label: "Error", size: "small" })));
    };
    return ErrorIcon;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__errorIcon__ = __webpack_require__(1371);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fileIcon__ = __webpack_require__(1370);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cardActions__ = __webpack_require__(1353);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isRetina__ = __webpack_require__(1399);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mediaImage__ = __webpack_require__(1352);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cardLoading__ = __webpack_require__(333);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cardDimensions__ = __webpack_require__(1343);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__cardDimensions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__breakpoint__ = __webpack_require__(1355);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__isValidPercentageUnit__ = __webpack_require__(1356);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getElementDimension__ = __webpack_require__(1364);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containsPixelUnit__ = __webpack_require__(1373);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_media_ui__ = __webpack_require__(51);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_11__atlaskit_media_ui__["z"]; });












//# sourceMappingURL=index.js.map

/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return containsPixelUnit; });
var containsPixelUnit = function (value) {
    return value.substr(-2) === 'px' && !isNaN(+value.slice(0, -2));
};
//# sourceMappingURL=containsPixelUnit.js.map

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(360);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(1507)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(607)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(110).document;
module.exports = document && document.documentElement;


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(129);
var toObject = __webpack_require__(337);
var IE_PROTO = __webpack_require__(361)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1510);
var global = __webpack_require__(110);
var hide = __webpack_require__(145);
var Iterators = __webpack_require__(334);
var TO_STRING_TAG = __webpack_require__(140)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 1379 */
/***/ (function(module, exports) {



/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1557)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Portal__ = __webpack_require__(1754);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Portal__["a"]; });


/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AbstractItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SearchItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EmojisRowItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LoadingItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CategoryHeadingItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return virtualItemRenderer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_spinner__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EmojiPickerSizes__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EmojiPickerListSearch__ = __webpack_require__(1800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EmojiPickerEmojiRow__ = __webpack_require__(1815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EmojiPickerCategoryHeading__ = __webpack_require__(1816);








var AbstractItem = /** @class */ (function () {
    function AbstractItem(props, height) {
        this.props = props;
        this.height = height;
    }
    return AbstractItem;
}());

var SearchItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SearchItem, _super);
    function SearchItem(props) {
        var _this = _super.call(this, props, __WEBPACK_IMPORTED_MODULE_4__EmojiPickerSizes__["a" /* sizes */].searchHeight) || this;
        _this.renderItem = function () { return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__EmojiPickerListSearch__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, _this.props)); };
        return _this;
    }
    return SearchItem;
}(AbstractItem));

var EmojisRowItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojisRowItem, _super);
    function EmojisRowItem(props) {
        var _this = _super.call(this, props, __WEBPACK_IMPORTED_MODULE_4__EmojiPickerSizes__["a" /* sizes */].emojiRowHeight) || this;
        _this.renderItem = function (context) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__EmojiPickerEmojiRow__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, _this.props))); };
        return _this;
    }
    return EmojisRowItem;
}(AbstractItem));

var LoadingItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](LoadingItem, _super);
    function LoadingItem() {
        var _this = _super.call(this, {}, __WEBPACK_IMPORTED_MODULE_4__EmojiPickerSizes__["a" /* sizes */].loadingRowHeight) || this;
        _this.renderItem = function () { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3__styles__["l" /* emojiPickerSpinner */] },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_spinner__["a" /* default */], { size: "medium" })))); };
        return _this;
    }
    return LoadingItem;
}(AbstractItem));

var CategoryHeadingItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CategoryHeadingItem, _super);
    function CategoryHeadingItem(props) {
        var _this = _super.call(this, props, __WEBPACK_IMPORTED_MODULE_4__EmojiPickerSizes__["a" /* sizes */].categoryHeadingHeight) || this;
        _this.renderItem = function () { return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__EmojiPickerCategoryHeading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, _this.props)); };
        return _this;
    }
    return CategoryHeadingItem;
}(AbstractItem));

var virtualItemRenderer = function (rows, context) {
    var index = context.index, key = context.key, style = context.style;
    var row = rows[index];
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: style, key: key }, row.renderItem(context)));
};
//# sourceMappingURL=EmojiPickerVirtualItems.js.map

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sizes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(69);

var sizes = {
    listHeight: 208,
    listWidth: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* emojiPickerWidth */],
    searchHeight: 52,
    categoryHeadingHeight: 30,
    emojiRowHeight: 40,
    addEmojiHeight: 32,
    loadingRowHeight: 150,
    uploadActionHeight: 40,
    emojiPerRow: 8,
};
//# sourceMappingURL=EmojiPickerSizes.js.map

/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return supportsUploadFeature; });
/* unused harmony export EmojiResource */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type_helpers__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_logger__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EmojiLoader__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EmojiRepository__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__media_SiteEmojiResource__ = __webpack_require__(1832);








/**
 * Checks if the emojiProvider can support uploading at a feature level.
 *
 * Follow this up with an isUploadSupported() check to see if the provider is actually
 * configured to support uploads.
 */
var supportsUploadFeature = function (emojiProvider) {
    var _a = emojiProvider, isUploadSupported = _a.isUploadSupported, prepareForUpload = _a.prepareForUpload, uploadCustomEmoji = _a.uploadCustomEmoji;
    return !!(isUploadSupported && prepareForUpload && uploadCustomEmoji);
};
var EmojiResource = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiResource, _super);
    function EmojiResource(config) {
        var _this = _super.call(this) || this;
        _this.activeLoaders = 0;
        _this.retries = new Map();
        _this.isLoaded = function () { return _this.activeLoaders === 0 && _this.emojiRepository; };
        _this.recordConfig = config.recordConfig;
        _this.currentUser = config.currentUser;
        // Ensure order is retained by tracking until all done.
        var emojiResponses = [];
        _this.activeLoaders = config.providers.length;
        config.providers.forEach(function (provider, index) {
            var loader = new __WEBPACK_IMPORTED_MODULE_5__EmojiLoader__["a" /* default */](provider);
            var emojis = loader.loadEmoji();
            emojis
                .then(function (emojiResponse) {
                emojiResponses[index] = emojiResponse;
                _this.initEmojiRepository(emojiResponses);
                _this.initSiteEmojiResource(emojiResponse, provider).then(function () {
                    _this.activeLoaders--;
                    _this.performRetries();
                    _this.refreshLastFilter();
                });
            })
                .catch(function (reason) {
                _this.activeLoaders--;
                _this.notifyError(reason);
            });
        });
        if (window.localStorage) {
            _this.selectedTone = _this.loadStoredTone();
        }
        if (config.providers.length === 0) {
            throw new Error('No providers specified');
        }
        return _this;
    }
    EmojiResource.prototype.initEmojiRepository = function (emojiResponses) {
        var emojis = [];
        emojiResponses.forEach(function (emojiResponse) {
            emojis = emojis.concat(emojiResponse.emojis);
        });
        this.emojiRepository = new __WEBPACK_IMPORTED_MODULE_6__EmojiRepository__["a" /* default */](emojis);
    };
    EmojiResource.prototype.initSiteEmojiResource = function (emojiResponse, provider) {
        if (!this.siteEmojiResource && emojiResponse.mediaApiToken) {
            this.siteEmojiResource = new __WEBPACK_IMPORTED_MODULE_7__media_SiteEmojiResource__["a" /* default */](provider, emojiResponse.mediaApiToken);
            // Prime cache type + optimistic rendering by checking first Emoji.
            // If this is fails, it won't be primed until a good emoji is loaded later.
            var emojis = emojiResponse.emojis;
            if (emojis.length) {
                var done = this.siteEmojiResource.optimisticRendering(emojis[0]);
                if (Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["l" /* isPromise */])(done)) {
                    return done
                        .then(function () {
                        Object(__WEBPACK_IMPORTED_MODULE_4__util_logger__["a" /* default */])('Primed siteEmojiResource');
                    })
                        .catch(function () {
                        Object(__WEBPACK_IMPORTED_MODULE_4__util_logger__["a" /* default */])('Failed to prime siteEmojiResource');
                    });
                }
                else {
                    Object(__WEBPACK_IMPORTED_MODULE_4__util_logger__["a" /* default */])('Already primed siteEmojiResource');
                }
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_4__util_logger__["a" /* default */])('No emoji to prime siteEmojiResource with');
            }
        }
        return Promise.resolve();
    };
    EmojiResource.prototype.performRetries = function () {
        var currentRetries = this.retries;
        this.retries = new Map();
        currentRetries.forEach(function (resolveReject, retry) {
            var result = retry();
            if (Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["l" /* isPromise */])(result)) {
                result
                    .then(function (response) {
                    resolveReject.resolve(response);
                })
                    .catch(function (reason) {
                    resolveReject.reject(reason);
                });
            }
            else {
                resolveReject.resolve(result);
            }
        });
    };
    EmojiResource.prototype.loadStoredTone = function () {
        var storedToneString = window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__constants__["n" /* selectedToneStorageKey */]);
        if (storedToneString) {
            var storedTone = parseInt(storedToneString, 10);
            return !isNaN(storedTone) ? storedTone : undefined;
        }
        return undefined;
    };
    EmojiResource.prototype.refreshLastFilter = function () {
        if (typeof this.lastQuery !== 'undefined') {
            var _a = this.lastQuery, query = _a.query, options = _a.options;
            this.filter(query, options);
        }
    };
    EmojiResource.prototype.retryIfLoading = function (retry, defaultResponse) {
        var _this = this;
        if (!this.isLoaded()) {
            return new Promise(function (resolve, reject) {
                _this.retries.set(retry, { resolve: resolve, reject: reject });
            });
        }
        return Promise.resolve(defaultResponse);
    };
    EmojiResource.prototype.notifyResult = function (result) {
        if (result.query === this.lastQuery.query) {
            _super.prototype.notifyResult.call(this, result);
        }
    };
    EmojiResource.prototype.loadMediaEmoji = function (emoji, useAlt) {
        if (!this.siteEmojiResource || !Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["j" /* isMediaEmoji */])(emoji)) {
            return emoji;
        }
        return this.siteEmojiResource.loadMediaEmoji(emoji, useAlt);
    };
    EmojiResource.prototype.optimisticMediaRendering = function (emoji, useAlt) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["j" /* isMediaEmoji */])(emoji)) {
            return true;
        }
        if (!this.siteEmojiResource) {
            // Shouldn't have a media emoji without a siteEmojiResouce, but anyway ;)
            return false;
        }
        var optimistic = this.siteEmojiResource.optimisticRendering(emoji, useAlt);
        if (Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["l" /* isPromise */])(optimistic)) {
            // Not sure yet, so lets say no for now (this should normally be primed in most/all cases)
            return false;
        }
        return optimistic;
    };
    EmojiResource.prototype.filter = function (query, options) {
        this.lastQuery = {
            query: query,
            options: options,
        };
        if (this.emojiRepository) {
            this.notifyResult(this.emojiRepository.search(query, options));
        }
        else {
            // not ready
            this.notifyNotReady();
        }
    };
    EmojiResource.prototype.findByShortName = function (shortName) {
        var _this = this;
        if (this.isLoaded()) {
            // Wait for all emoji to load before looking by shortName (to ensure correct priority)
            return this.emojiRepository.findByShortName(shortName);
        }
        return this.retryIfLoading(function () { return _this.findByShortName(shortName); }, undefined);
    };
    EmojiResource.prototype.findByEmojiId = function (emojiId) {
        var _this = this;
        var id = emojiId.id, shortName = emojiId.shortName;
        if (this.emojiRepository) {
            if (id) {
                var emoji = this.emojiRepository.findById(id);
                if (emoji) {
                    return emoji;
                }
                if (this.isLoaded()) {
                    // all loaded but not found by id, try server to see if
                    // this is a newly uploaded emoji
                    if (this.siteEmojiResource) {
                        return this.siteEmojiResource.findEmoji(emojiId).then(function (emoji) {
                            if (!emoji) {
                                // if not, fallback to searching by shortName to
                                // at least render an alternative
                                return _this.findByShortName(shortName);
                            }
                            _this.addUnknownEmoji(emoji);
                            return emoji;
                        });
                    }
                    // if not, fallback to searching by shortName to
                    // at least render an alternative
                    return this.findByShortName(shortName);
                }
            }
            else {
                // no id fallback to shortName
                return this.findByShortName(shortName);
            }
        }
        return this.retryIfLoading(function () { return _this.findByEmojiId(emojiId); }, undefined);
    };
    EmojiResource.prototype.findById = function (id) {
        var _this = this;
        if (this.isLoaded()) {
            return this.emojiRepository.findById(id);
        }
        return this.retryIfLoading(function () { return _this.findById(id); }, undefined);
    };
    EmojiResource.prototype.findInCategory = function (categoryId) {
        var _this = this;
        if (this.isLoaded()) {
            return Promise.resolve(this.emojiRepository.findInCategory(categoryId));
        }
        return this.retryIfLoading(function () { return _this.findInCategory(categoryId); }, []);
    };
    EmojiResource.prototype.getAsciiMap = function () {
        var _this = this;
        if (this.isLoaded()) {
            return Promise.resolve(this.emojiRepository.getAsciiMap());
        }
        return this.retryIfLoading(function () { return _this.getAsciiMap(); }, new Map());
    };
    EmojiResource.prototype.getFrequentlyUsed = function (options) {
        var _this = this;
        if (this.isLoaded()) {
            return Promise.resolve(this.emojiRepository.getFrequentlyUsed(options));
        }
        return this.retryIfLoading(function () { return _this.getFrequentlyUsed(options); }, []);
    };
    /**
     * Record the selection of an emoji to a remote service if 'recordConfig' has been supplied.
     * Regardless of the recordConfig, emoji selections will always be recorded on the EmojiRepository
     * for the purposes of tracking the frequency of use.
     *
     * @param emoji The full description of the emoji to record usage for.
     */
    EmojiResource.prototype.recordSelection = function (emoji) {
        var recordConfig = this.recordConfig;
        if (this.emojiRepository) {
            this.emojiRepository.used(emoji);
        }
        if (recordConfig) {
            var queryParams = {
                emojiId: Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["o" /* toEmojiId */])(emoji),
            };
            var requestInit = {
                method: 'POST',
            };
            return __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */].requestService(recordConfig, {
                queryParams: queryParams,
                requestInit: requestInit,
            });
        }
        return Promise.resolve();
    };
    EmojiResource.prototype.deleteSiteEmoji = function (emoji) {
        var _this = this;
        if (this.siteEmojiResource && emoji.id) {
            return this.siteEmojiResource
                .deleteEmoji(emoji)
                .then(function (success) {
                if (success && _this.emojiRepository) {
                    _this.emojiRepository.delete(emoji);
                    return true;
                }
                return false;
            })
                .catch(function (err) {
                // tslint:disable-next-line:no-console
                console.error('failed to delete site emoji', err);
                return false;
            });
        }
        return this.retryIfLoading(function () { return _this.deleteSiteEmoji(emoji); }, false);
    };
    EmojiResource.prototype.getSelectedTone = function () {
        return this.selectedTone;
    };
    EmojiResource.prototype.setSelectedTone = function (tone) {
        this.selectedTone = tone;
        if (window.localStorage) {
            try {
                window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_2__constants__["n" /* selectedToneStorageKey */], tone ? tone.toString() : '');
            }
            catch (e) {
                // tslint:disable-next-line:no-console
                console.error('failed to store selected emoji skin tone', e);
            }
        }
    };
    EmojiResource.prototype.calculateDynamicCategories = function () {
        var _this = this;
        if (this.isLoaded()) {
            return Promise.resolve(this.emojiRepository.getDynamicCategoryList());
        }
        return this.retryIfLoading(function () { return _this.calculateDynamicCategories(); }, []);
    };
    EmojiResource.prototype.getCurrentUser = function () {
        return this.currentUser;
    };
    EmojiResource.prototype.addUnknownEmoji = function (emoji) {
        if (this.emojiRepository) {
            this.emojiRepository.addUnknownEmoji(emoji);
        }
    };
    return EmojiResource;
}(__WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["a" /* AbstractResource */]));

var UploadingEmojiResource = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](UploadingEmojiResource, _super);
    function UploadingEmojiResource(config) {
        var _this = _super.call(this, config) || this;
        _this.allowUpload = !!config.allowUpload;
        return _this;
    }
    UploadingEmojiResource.prototype.isUploadSupported = function () {
        var _this = this;
        if (!this.allowUpload) {
            return Promise.resolve(false);
        }
        if (this.siteEmojiResource) {
            return this.siteEmojiResource.hasUploadToken();
        }
        return this.retryIfLoading(function () { return _this.isUploadSupported(); }, false);
    };
    UploadingEmojiResource.prototype.uploadCustomEmoji = function (upload) {
        var _this = this;
        return this.isUploadSupported().then(function (supported) {
            if (!supported || !_this.siteEmojiResource) {
                return Promise.reject('No media api support is configured');
            }
            return _this.siteEmojiResource.uploadEmoji(upload).then(function (emoji) {
                _this.addUnknownEmoji(emoji);
                _this.refreshLastFilter();
                return emoji;
            });
        });
    };
    UploadingEmojiResource.prototype.prepareForUpload = function () {
        var _this = this;
        if (this.siteEmojiResource) {
            this.siteEmojiResource.prepareForUpload();
        }
        return this.retryIfLoading(function () { return _this.prepareForUpload(); }, undefined);
    };
    return UploadingEmojiResource;
}(EmojiResource));
/* unused harmony default export */ var _unused_webpack_default_export = (UploadingEmojiResource);
//# sourceMappingURL=EmojiResource.js.map

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNaturalImageSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parseImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasFileExceededSize; });
/* unused harmony export checkWebpSupport */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return imageAcceptHeader; });
var maxEmojiSizeInBytes = 1048576;
var getNaturalImageSize = function (dataURL) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.addEventListener('load', function () {
            resolve({
                width: img.naturalWidth,
                height: img.naturalHeight,
            });
        });
        img.addEventListener('error', reject);
        img.src = dataURL;
    });
};
var parseImage = function (dataURL) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () { return resolve({ src: img.src }); };
        img.onerror = function () { return reject(); };
        img.src = dataURL;
    });
};
var hasFileExceededSize = function (file) {
    return file && file.size > maxEmojiSizeInBytes;
};
// Duplicates https://bitbucket.org/atlassian/atlaskit/src/0e843df6df8bcd33fa7fc16cc63f11a0f6094957/packages/media-core/src/utils/checkWebpSupport.ts?at=master&fileviewer=file-view-default
// Didn't want to depend on the whole of media-core just for this util
/**
 * Checks if Webp support is enabled in the browser.
 * We know that creating a new image in memory and checking its height,
 * later on we cache this value forever.
 */
var isWebpSupported;
var checkWebpSupport = function () {
    if (isWebpSupported !== undefined) {
        return Promise.resolve(isWebpSupported);
    }
    return new Promise(function (resolve) {
        var img = new Image();
        var checkSupport = function () {
            isWebpSupported = img.height === 2;
            resolve(isWebpSupported);
        };
        img.addEventListener('load', checkSupport);
        img.addEventListener('error', checkSupport);
        img.src =
            'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMwAgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
    });
};
var imageAcceptHeader = function () {
    return checkWebpSupport().then(function (isWebpSupported) {
        // q=0.8 stands for 'quality factor' => http://stackoverflow.com/a/10496722
        var noWebpAcceptHeader = 'image/*,*/*;q=0.8';
        var webpAcceptHeader = 'image/webp,image/*,*/*;q=0.8';
        return isWebpSupported ? webpAcceptHeader : noWebpAcceptHeader;
    });
};
//# sourceMappingURL=image.js.map

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1890), __esModule: true };

/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_card_cardLoader__ = __webpack_require__(2118);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__root_card_cardLoader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_cardViewLoader__ = __webpack_require__(2295);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__root_cardViewLoader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__root_domain__ = __webpack_require__(1389);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_identifier__ = __webpack_require__(1391);
/* unused harmony reexport isUrlPreviewIdentifier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1368);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__utils__["a"]; });
// the only components we expose to consumers is Card and CardView





//# sourceMappingURL=index.js.map

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isPreviewableType; });
var isPreviewableType = function (type) {
    return ['audio', 'video', 'image'].indexOf(type) > -1;
};
//# sourceMappingURL=domain.js.map

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isRetina;
function isRetina() {
    var mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return (window.devicePixelRatio > 1 ||
        (window.matchMedia && window.matchMedia(mediaQuery).matches));
}
//# sourceMappingURL=isRetina.js.map

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isUrlPreviewIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isFileIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isExternalImageIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isDifferentIdentifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_deep_equal__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_deep_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_deep_equal__);

var isUrlPreviewIdentifier = function (identifier) {
    var preview = identifier;
    return preview && preview.url !== undefined;
};
var isFileIdentifier = function (identifier) {
    return identifier.mediaItemType === 'file';
};
var isExternalImageIdentifier = function (identifier) {
    return identifier.mediaItemType === 'external-image';
};
// TODO: unit test
var isDifferentIdentifier = function (a, b) {
    if (isFileIdentifier(a) && isFileIdentifier(b)) {
        return (a.id !== b.id ||
            a.collectionName !== b.collectionName ||
            a.occurrenceKey !== b.occurrenceKey);
    }
    else {
        return !__WEBPACK_IMPORTED_MODULE_0_deep_equal__(a, b);
    }
};
//# sourceMappingURL=identifier.js.map

/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FieldText__ = __webpack_require__(2351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FieldTextStateless__ = __webpack_require__(795);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FieldTextStateless", function() { return __WEBPACK_IMPORTED_MODULE_1__FieldTextStateless__["a"]; });


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__FieldText__["a" /* default */]);


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorDoneIcon = function EditorDoneIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.501.501 0 0 0-.003.71l3.706 3.707a.501.501 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0l-2.288-2.287z\" fill=\"currentColor\"/></svg>"
  }, props));
};

EditorDoneIcon.displayName = 'EditorDoneIcon';
var _default = EditorDoneIcon;
exports.default = _default;

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return messages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_bold__ = __webpack_require__(2485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_bold___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_bold__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_italic__ = __webpack_require__(2486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_italic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_italic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__keymaps__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_ToolbarButton__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_styles__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commands_text_formatting__ = __webpack_require__(166);











var messages = Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["defineMessages"])({
    bold: {
        id: 'fabric.editor.bold',
        defaultMessage: 'Bold',
        description: 'This refers to bold or “strong” formatting, indicates that its contents have strong importance, seriousness, or urgency.',
    },
    italic: {
        id: 'fabric.editor.italic',
        defaultMessage: 'Italic',
        description: 'This refers to italics or emphasized formatting.',
    },
});
var ToolbarTextFormatting = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ToolbarTextFormatting, _super);
    function ToolbarTextFormatting() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleBoldClick = Object(__WEBPACK_IMPORTED_MODULE_5__analytics__["c" /* withAnalytics */])('atlassian.editor.format.strong.button', function () {
            var strongDisabled = _this.props.textFormattingState.strongDisabled;
            if (!strongDisabled) {
                var _a = _this.props.editorView, state = _a.state, dispatch = _a.dispatch;
                return Object(__WEBPACK_IMPORTED_MODULE_9__commands_text_formatting__["h" /* toggleStrong */])()(state, dispatch);
            }
            return false;
        });
        _this.handleItalicClick = Object(__WEBPACK_IMPORTED_MODULE_5__analytics__["c" /* withAnalytics */])('atlassian.editor.format.em.button', function () {
            var emDisabled = _this.props.textFormattingState.emDisabled;
            if (!emDisabled) {
                var _a = _this.props.editorView, state = _a.state, dispatch = _a.dispatch;
                return Object(__WEBPACK_IMPORTED_MODULE_9__commands_text_formatting__["f" /* toggleEm */])()(state, dispatch);
            }
            return false;
        });
        return _this;
    }
    ToolbarTextFormatting.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, isReducedSpacing = _a.isReducedSpacing, textFormattingState = _a.textFormattingState, formatMessage = _a.intl.formatMessage;
        var strongHidden = textFormattingState.strongHidden, strongActive = textFormattingState.strongActive, strongDisabled = textFormattingState.strongDisabled, emHidden = textFormattingState.emHidden, emActive = textFormattingState.emActive, emDisabled = textFormattingState.emDisabled;
        var labelBold = formatMessage(messages.bold);
        var labelItalic = formatMessage(messages.italic);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ui_styles__["b" /* ButtonGroup */], { width: isReducedSpacing ? 'small' : 'large' },
            strongHidden ? null : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ui_ToolbarButton__["a" /* default */], { spacing: isReducedSpacing ? 'none' : 'default', onClick: this.handleBoldClick, selected: strongActive, disabled: disabled || strongDisabled, title: Object(__WEBPACK_IMPORTED_MODULE_6__keymaps__["S" /* tooltip */])(__WEBPACK_IMPORTED_MODULE_6__keymaps__["K" /* toggleBold */], labelBold), iconBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_bold___default.a, { label: labelBold }) })),
            emHidden ? null : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ui_ToolbarButton__["a" /* default */], { spacing: isReducedSpacing ? 'none' : 'default', onClick: this.handleItalicClick, selected: emActive, disabled: disabled || emDisabled, title: Object(__WEBPACK_IMPORTED_MODULE_6__keymaps__["S" /* tooltip */])(__WEBPACK_IMPORTED_MODULE_6__keymaps__["N" /* toggleItalic */], labelItalic), iconBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_italic___default.a, { label: labelItalic }) }))));
    };
    return ToolbarTextFormatting;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["injectIntl"])(ToolbarTextFormatting));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return messages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_more__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_more___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_more__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__keymaps__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_ToolbarButton__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_DropdownMenu__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_styles__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commands_text_formatting__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commands_clear_formatting__ = __webpack_require__(452);













var messages = Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["defineMessages"])({
    underline: {
        id: 'fabric.editor.underline',
        defaultMessage: 'Underline',
        description: 'Whether the text selection has underlined text',
    },
    strike: {
        id: 'fabric.editor.strike',
        defaultMessage: 'Strikethrough',
        description: 'Whether the text selection has crossed out text',
    },
    code: {
        id: 'fabric.editor.code',
        defaultMessage: 'Code',
        description: 'Whether the text selection has monospaced/code font',
    },
    subscript: {
        id: 'fabric.editor.subscript',
        defaultMessage: 'Subscript',
        description: 'Whether the text selection is written below the line in a slightly smaller size',
    },
    superscript: {
        id: 'fabric.editor.superscript',
        defaultMessage: 'Superscript',
        description: 'Whether the text selection is written above the line in a slightly smaller size',
    },
    clearFormatting: {
        id: 'fabric.editor.clearFormatting',
        defaultMessage: 'Clear formatting',
        description: 'Remove all rich text formatting from the selected text',
    },
    moreFormatting: {
        id: 'fabric.editor.moreFormatting',
        defaultMessage: 'More formatting',
        description: 'Clicking this will show a menu with additional formatting options',
    },
});
var ToolbarAdvancedTextFormatting = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ToolbarAdvancedTextFormatting, _super);
    function ToolbarAdvancedTextFormatting() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false,
        };
        _this.onOpenChange = function (attrs) {
            _this.setState({
                isOpen: attrs.isOpen,
            });
        };
        _this.handleTriggerClick = function () {
            _this.onOpenChange({ isOpen: !_this.state.isOpen });
        };
        _this.createItems = function () {
            var _a = _this.props, textFormattingState = _a.textFormattingState, clearFormattingState = _a.clearFormattingState, editorView = _a.editorView, formatMessage = _a.intl.formatMessage;
            var _b = editorView.state.schema.marks, code = _b.code, underline = _b.underline, subsup = _b.subsup, strike = _b.strike;
            var items = [];
            if (textFormattingState) {
                var underlineHidden = textFormattingState.underlineHidden, codeHidden = textFormattingState.codeHidden, strikeHidden = textFormattingState.strikeHidden, subscriptHidden = textFormattingState.subscriptHidden, superscriptHidden = textFormattingState.superscriptHidden;
                if (!underlineHidden && underline) {
                    _this.addRecordToItems(items, formatMessage(messages.underline), 'underline', Object(__WEBPACK_IMPORTED_MODULE_6__keymaps__["S" /* tooltip */])(__WEBPACK_IMPORTED_MODULE_6__keymaps__["R" /* toggleUnderline */]));
                }
                if (!strikeHidden && strike) {
                    _this.addRecordToItems(items, formatMessage(messages.strike), 'strike', Object(__WEBPACK_IMPORTED_MODULE_6__keymaps__["S" /* tooltip */])(__WEBPACK_IMPORTED_MODULE_6__keymaps__["P" /* toggleStrikethrough */]));
                }
                if (!codeHidden && code) {
                    _this.addRecordToItems(items, formatMessage(messages.code), 'code', Object(__WEBPACK_IMPORTED_MODULE_6__keymaps__["S" /* tooltip */])(__WEBPACK_IMPORTED_MODULE_6__keymaps__["M" /* toggleCode */]));
                }
                if (!subscriptHidden && subsup) {
                    _this.addRecordToItems(items, formatMessage(messages.subscript), 'subscript');
                }
                if (!superscriptHidden && subsup) {
                    _this.addRecordToItems(items, formatMessage(messages.superscript), 'superscript');
                }
            }
            if (clearFormattingState) {
                _this.addRecordToItems(items, formatMessage(messages.clearFormatting), 'clearFormatting', Object(__WEBPACK_IMPORTED_MODULE_6__keymaps__["S" /* tooltip */])(__WEBPACK_IMPORTED_MODULE_6__keymaps__["i" /* clearFormatting */]), !clearFormattingState.formattingIsPresent);
            }
            return [{ items: items }];
        };
        _this.addRecordToItems = function (items, content, value, tooltip, isDisabled) {
            items.push({
                key: value,
                content: content,
                elemAfter: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ui_styles__["f" /* Shortcut */], null, tooltip),
                value: value,
                isActive: _this.state[value + "Active"],
                isDisabled: isDisabled || _this.state[value + "Disabled"],
            });
        };
        _this.onItemActivated = function (_a) {
            var item = _a.item;
            __WEBPACK_IMPORTED_MODULE_5__analytics__["a" /* analyticsService */].trackEvent("atlassian.editor.format." + item.value + ".button");
            var _b = _this.props.editorView, state = _b.state, dispatch = _b.dispatch;
            switch (item.value) {
                case 'underline':
                    __WEBPACK_IMPORTED_MODULE_10__commands_text_formatting__["k" /* toggleUnderline */]()(state, dispatch);
                    break;
                case 'code':
                    __WEBPACK_IMPORTED_MODULE_10__commands_text_formatting__["e" /* toggleCode */]()(state, dispatch);
                    break;
                case 'strike':
                    __WEBPACK_IMPORTED_MODULE_10__commands_text_formatting__["g" /* toggleStrike */]()(state, dispatch);
                    break;
                case 'subscript':
                    __WEBPACK_IMPORTED_MODULE_10__commands_text_formatting__["i" /* toggleSubscript */]()(state, dispatch);
                    break;
                case 'superscript':
                    __WEBPACK_IMPORTED_MODULE_10__commands_text_formatting__["j" /* toggleSuperscript */]()(state, dispatch);
                    break;
                case 'clearFormatting':
                    Object(__WEBPACK_IMPORTED_MODULE_11__commands_clear_formatting__["c" /* clearFormatting */])()(state, dispatch);
                    break;
            }
            _this.setState({ isOpen: false });
        };
        return _this;
    }
    ToolbarAdvancedTextFormatting.prototype.render = function () {
        var _this = this;
        var isOpen = this.state.isOpen;
        var _a = this.props, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, popupsScrollableElement = _a.popupsScrollableElement, isReducedSpacing = _a.isReducedSpacing, _b = _a.textFormattingState, textFormattingState = _b === void 0 ? {} : _b, _c = _a.clearFormattingState, clearFormattingState = _c === void 0 ? {} : _c, formatMessage = _a.intl.formatMessage;
        var codeActive = textFormattingState.codeActive, underlineActive = textFormattingState.underlineActive, strikeActive = textFormattingState.strikeActive, subscriptActive = textFormattingState.subscriptActive, superscriptActive = textFormattingState.superscriptActive, codeDisabled = textFormattingState.codeDisabled, underlineDisabled = textFormattingState.underlineDisabled, strikeDisabled = textFormattingState.strikeDisabled, subscriptDisabled = textFormattingState.subscriptDisabled, superscriptDisabled = textFormattingState.superscriptDisabled;
        var formattingIsPresent = clearFormattingState.formattingIsPresent;
        var items = this.createItems();
        var labelMoreFormatting = formatMessage(messages.moreFormatting);
        var toolbarButtonFactory = function (disabled) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ui_ToolbarButton__["a" /* default */], { spacing: isReducedSpacing ? 'none' : 'default', selected: isOpen ||
                underlineActive ||
                codeActive ||
                strikeActive ||
                subscriptActive ||
                superscriptActive, disabled: disabled, onClick: _this.handleTriggerClick, title: labelMoreFormatting, iconBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ui_styles__["g" /* TriggerWrapper */], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_more___default.a, { label: labelMoreFormatting })) })); };
        if (!this.props.isDisabled &&
            !(strikeDisabled &&
                !formattingIsPresent &&
                codeDisabled &&
                subscriptDisabled &&
                superscriptDisabled &&
                underlineDisabled) &&
            items[0].items.length > 0) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ui_styles__["h" /* Wrapper */], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ui_DropdownMenu__["a" /* default */], { items: items, onItemActivated: this.onItemActivated, onOpenChange: this.onOpenChange, mountTo: popupsMountPoint, boundariesElement: popupsBoundariesElement, scrollableElement: popupsScrollableElement, isOpen: isOpen, zIndex: __WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__["r" /* akEditorMenuZIndex */], fitHeight: 188, fitWidth: 136 }, toolbarButtonFactory(false)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ui_styles__["e" /* Separator */], null)));
        }
        else {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ui_styles__["h" /* Wrapper */], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, toolbarButtonFactory(true)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ui_styles__["e" /* Separator */], null)));
        }
    };
    return ToolbarAdvancedTextFormatting;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["injectIntl"])(ToolbarAdvancedTextFormatting));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return messages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(17);
// Common Translations will live here

var messages = Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["defineMessages"])({
    unorderedList: {
        id: 'fabric.editor.unorderedList',
        defaultMessage: 'Bullet list',
        description: 'A list with bullets. Also known as an “unordered” list',
    },
    orderedList: {
        id: 'fabric.editor.orderedList',
        defaultMessage: 'Numbered list',
        description: 'A list with ordered items 1… 2… 3…',
    },
    lists: {
        id: 'fabric.editor.lists',
        defaultMessage: 'Lists',
        description: 'Menu shows ordered/bullet list and unordered/numbered lists',
    },
});
//# sourceMappingURL=messages.js.map

/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filmstripView__ = __webpack_require__(851);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__filmstripView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filmstrip__ = __webpack_require__(2604);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__filmstrip__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isPreviewableType; });
var isPreviewableType = function (type) {
    return ['audio', 'video', 'image'].indexOf(type) > -1;
};
//# sourceMappingURL=domain.js.map

/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isRetina;
function isRetina() {
    var mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return (window.devicePixelRatio > 1 ||
        (window.matchMedia && window.matchMedia(mediaQuery).matches));
}
//# sourceMappingURL=isRetina.js.map

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isUrlPreviewIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isFileIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isExternalImageIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isDifferentIdentifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_deep_equal__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_deep_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_deep_equal__);

var isUrlPreviewIdentifier = function (identifier) {
    var preview = identifier;
    return preview && preview.url !== undefined;
};
var isFileIdentifier = function (identifier) {
    return identifier.mediaItemType === 'file';
};
var isExternalImageIdentifier = function (identifier) {
    return identifier.mediaItemType === 'external-image';
};
// TODO: unit test
var isDifferentIdentifier = function (a, b) {
    if (isFileIdentifier(a) && isFileIdentifier(b)) {
        return (a.id !== b.id ||
            a.collectionName !== b.collectionName ||
            a.occurrenceKey !== b.occurrenceKey);
    }
    else {
        return !__WEBPACK_IMPORTED_MODULE_0_deep_equal__(a, b);
    }
};
//# sourceMappingURL=identifier.js.map

/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AbstractItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SearchItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EmojisRowItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LoadingItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CategoryHeadingItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return virtualItemRenderer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_spinner__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EmojiPickerSizes__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EmojiPickerListSearch__ = __webpack_require__(2920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EmojiPickerEmojiRow__ = __webpack_require__(2922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EmojiPickerCategoryHeading__ = __webpack_require__(2923);








var AbstractItem = /** @class */ (function () {
    function AbstractItem(props, height) {
        this.props = props;
        this.height = height;
    }
    return AbstractItem;
}());

var SearchItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SearchItem, _super);
    function SearchItem(props) {
        var _this = _super.call(this, props, __WEBPACK_IMPORTED_MODULE_4__EmojiPickerSizes__["a" /* sizes */].searchHeight) || this;
        _this.renderItem = function () { return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__EmojiPickerListSearch__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, _this.props)); };
        return _this;
    }
    return SearchItem;
}(AbstractItem));

var EmojisRowItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojisRowItem, _super);
    function EmojisRowItem(props) {
        var _this = _super.call(this, props, __WEBPACK_IMPORTED_MODULE_4__EmojiPickerSizes__["a" /* sizes */].emojiRowHeight) || this;
        _this.renderItem = function (context) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__EmojiPickerEmojiRow__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, _this.props))); };
        return _this;
    }
    return EmojisRowItem;
}(AbstractItem));

var LoadingItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](LoadingItem, _super);
    function LoadingItem() {
        var _this = _super.call(this, {}, __WEBPACK_IMPORTED_MODULE_4__EmojiPickerSizes__["a" /* sizes */].loadingRowHeight) || this;
        _this.renderItem = function () { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3__styles__["l" /* emojiPickerSpinner */] },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_spinner__["a" /* default */], { size: "medium" })))); };
        return _this;
    }
    return LoadingItem;
}(AbstractItem));

var CategoryHeadingItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CategoryHeadingItem, _super);
    function CategoryHeadingItem(props) {
        var _this = _super.call(this, props, __WEBPACK_IMPORTED_MODULE_4__EmojiPickerSizes__["a" /* sizes */].categoryHeadingHeight) || this;
        _this.renderItem = function () { return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__EmojiPickerCategoryHeading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, _this.props)); };
        return _this;
    }
    return CategoryHeadingItem;
}(AbstractItem));

var virtualItemRenderer = function (rows, context) {
    var index = context.index, key = context.key, style = context.style;
    var row = rows[index];
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: style, key: key }, row.renderItem(context)));
};
//# sourceMappingURL=EmojiPickerVirtualItems.js.map

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sizes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(70);

var sizes = {
    listHeight: 208,
    listWidth: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* emojiPickerWidth */],
    searchHeight: 52,
    categoryHeadingHeight: 30,
    emojiRowHeight: 40,
    addEmojiHeight: 32,
    loadingRowHeight: 150,
    uploadActionHeight: 40,
    emojiPerRow: 8,
};
//# sourceMappingURL=EmojiPickerSizes.js.map

/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return supportsUploadFeature; });
/* unused harmony export EmojiResource */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type_helpers__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_logger__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EmojiLoader__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EmojiRepository__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__media_SiteEmojiResource__ = __webpack_require__(2927);








/**
 * Checks if the emojiProvider can support uploading at a feature level.
 *
 * Follow this up with an isUploadSupported() check to see if the provider is actually
 * configured to support uploads.
 */
var supportsUploadFeature = function (emojiProvider) {
    var _a = emojiProvider, isUploadSupported = _a.isUploadSupported, prepareForUpload = _a.prepareForUpload, uploadCustomEmoji = _a.uploadCustomEmoji;
    return !!(isUploadSupported && prepareForUpload && uploadCustomEmoji);
};
var EmojiResource = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiResource, _super);
    function EmojiResource(config) {
        var _this = _super.call(this) || this;
        _this.activeLoaders = 0;
        _this.retries = new Map();
        _this.isLoaded = function () { return _this.activeLoaders === 0 && _this.emojiRepository; };
        _this.recordConfig = config.recordConfig;
        _this.currentUser = config.currentUser;
        // Ensure order is retained by tracking until all done.
        var emojiResponses = [];
        _this.activeLoaders = config.providers.length;
        config.providers.forEach(function (provider, index) {
            var loader = new __WEBPACK_IMPORTED_MODULE_5__EmojiLoader__["a" /* default */](provider);
            var emojis = loader.loadEmoji();
            emojis
                .then(function (emojiResponse) {
                emojiResponses[index] = emojiResponse;
                _this.initEmojiRepository(emojiResponses);
                _this.initSiteEmojiResource(emojiResponse, provider).then(function () {
                    _this.activeLoaders--;
                    _this.performRetries();
                    _this.refreshLastFilter();
                });
            })
                .catch(function (reason) {
                _this.activeLoaders--;
                _this.notifyError(reason);
            });
        });
        if (window.localStorage) {
            _this.selectedTone = _this.loadStoredTone();
        }
        if (config.providers.length === 0) {
            throw new Error('No providers specified');
        }
        return _this;
    }
    EmojiResource.prototype.initEmojiRepository = function (emojiResponses) {
        var emojis = [];
        emojiResponses.forEach(function (emojiResponse) {
            emojis = emojis.concat(emojiResponse.emojis);
        });
        this.emojiRepository = new __WEBPACK_IMPORTED_MODULE_6__EmojiRepository__["a" /* default */](emojis);
    };
    EmojiResource.prototype.initSiteEmojiResource = function (emojiResponse, provider) {
        if (!this.siteEmojiResource && emojiResponse.mediaApiToken) {
            this.siteEmojiResource = new __WEBPACK_IMPORTED_MODULE_7__media_SiteEmojiResource__["a" /* default */](provider, emojiResponse.mediaApiToken);
            // Prime cache type + optimistic rendering by checking first Emoji.
            // If this is fails, it won't be primed until a good emoji is loaded later.
            var emojis = emojiResponse.emojis;
            if (emojis.length) {
                var done = this.siteEmojiResource.optimisticRendering(emojis[0]);
                if (Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["l" /* isPromise */])(done)) {
                    return done
                        .then(function () {
                        Object(__WEBPACK_IMPORTED_MODULE_4__util_logger__["a" /* default */])('Primed siteEmojiResource');
                    })
                        .catch(function () {
                        Object(__WEBPACK_IMPORTED_MODULE_4__util_logger__["a" /* default */])('Failed to prime siteEmojiResource');
                    });
                }
                else {
                    Object(__WEBPACK_IMPORTED_MODULE_4__util_logger__["a" /* default */])('Already primed siteEmojiResource');
                }
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_4__util_logger__["a" /* default */])('No emoji to prime siteEmojiResource with');
            }
        }
        return Promise.resolve();
    };
    EmojiResource.prototype.performRetries = function () {
        var currentRetries = this.retries;
        this.retries = new Map();
        currentRetries.forEach(function (resolveReject, retry) {
            var result = retry();
            if (Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["l" /* isPromise */])(result)) {
                result
                    .then(function (response) {
                    resolveReject.resolve(response);
                })
                    .catch(function (reason) {
                    resolveReject.reject(reason);
                });
            }
            else {
                resolveReject.resolve(result);
            }
        });
    };
    EmojiResource.prototype.loadStoredTone = function () {
        var storedToneString = window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__constants__["n" /* selectedToneStorageKey */]);
        if (storedToneString) {
            var storedTone = parseInt(storedToneString, 10);
            return !isNaN(storedTone) ? storedTone : undefined;
        }
        return undefined;
    };
    EmojiResource.prototype.refreshLastFilter = function () {
        if (typeof this.lastQuery !== 'undefined') {
            var _a = this.lastQuery, query = _a.query, options = _a.options;
            this.filter(query, options);
        }
    };
    EmojiResource.prototype.retryIfLoading = function (retry, defaultResponse) {
        var _this = this;
        if (!this.isLoaded()) {
            return new Promise(function (resolve, reject) {
                _this.retries.set(retry, { resolve: resolve, reject: reject });
            });
        }
        return Promise.resolve(defaultResponse);
    };
    EmojiResource.prototype.notifyResult = function (result) {
        if (result.query === this.lastQuery.query) {
            _super.prototype.notifyResult.call(this, result);
        }
    };
    EmojiResource.prototype.loadMediaEmoji = function (emoji, useAlt) {
        if (!this.siteEmojiResource || !Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["j" /* isMediaEmoji */])(emoji)) {
            return emoji;
        }
        return this.siteEmojiResource.loadMediaEmoji(emoji, useAlt);
    };
    EmojiResource.prototype.optimisticMediaRendering = function (emoji, useAlt) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["j" /* isMediaEmoji */])(emoji)) {
            return true;
        }
        if (!this.siteEmojiResource) {
            // Shouldn't have a media emoji without a siteEmojiResouce, but anyway ;)
            return false;
        }
        var optimistic = this.siteEmojiResource.optimisticRendering(emoji, useAlt);
        if (Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["l" /* isPromise */])(optimistic)) {
            // Not sure yet, so lets say no for now (this should normally be primed in most/all cases)
            return false;
        }
        return optimistic;
    };
    EmojiResource.prototype.filter = function (query, options) {
        this.lastQuery = {
            query: query,
            options: options,
        };
        if (this.emojiRepository) {
            this.notifyResult(this.emojiRepository.search(query, options));
        }
        else {
            // not ready
            this.notifyNotReady();
        }
    };
    EmojiResource.prototype.findByShortName = function (shortName) {
        var _this = this;
        if (this.isLoaded()) {
            // Wait for all emoji to load before looking by shortName (to ensure correct priority)
            return this.emojiRepository.findByShortName(shortName);
        }
        return this.retryIfLoading(function () { return _this.findByShortName(shortName); }, undefined);
    };
    EmojiResource.prototype.findByEmojiId = function (emojiId) {
        var _this = this;
        var id = emojiId.id, shortName = emojiId.shortName;
        if (this.emojiRepository) {
            if (id) {
                var emoji = this.emojiRepository.findById(id);
                if (emoji) {
                    return emoji;
                }
                if (this.isLoaded()) {
                    // all loaded but not found by id, try server to see if
                    // this is a newly uploaded emoji
                    if (this.siteEmojiResource) {
                        return this.siteEmojiResource.findEmoji(emojiId).then(function (emoji) {
                            if (!emoji) {
                                // if not, fallback to searching by shortName to
                                // at least render an alternative
                                return _this.findByShortName(shortName);
                            }
                            _this.addUnknownEmoji(emoji);
                            return emoji;
                        });
                    }
                    // if not, fallback to searching by shortName to
                    // at least render an alternative
                    return this.findByShortName(shortName);
                }
            }
            else {
                // no id fallback to shortName
                return this.findByShortName(shortName);
            }
        }
        return this.retryIfLoading(function () { return _this.findByEmojiId(emojiId); }, undefined);
    };
    EmojiResource.prototype.findById = function (id) {
        var _this = this;
        if (this.isLoaded()) {
            return this.emojiRepository.findById(id);
        }
        return this.retryIfLoading(function () { return _this.findById(id); }, undefined);
    };
    EmojiResource.prototype.findInCategory = function (categoryId) {
        var _this = this;
        if (this.isLoaded()) {
            return Promise.resolve(this.emojiRepository.findInCategory(categoryId));
        }
        return this.retryIfLoading(function () { return _this.findInCategory(categoryId); }, []);
    };
    EmojiResource.prototype.getAsciiMap = function () {
        var _this = this;
        if (this.isLoaded()) {
            return Promise.resolve(this.emojiRepository.getAsciiMap());
        }
        return this.retryIfLoading(function () { return _this.getAsciiMap(); }, new Map());
    };
    EmojiResource.prototype.getFrequentlyUsed = function (options) {
        var _this = this;
        if (this.isLoaded()) {
            return Promise.resolve(this.emojiRepository.getFrequentlyUsed(options));
        }
        return this.retryIfLoading(function () { return _this.getFrequentlyUsed(options); }, []);
    };
    /**
     * Record the selection of an emoji to a remote service if 'recordConfig' has been supplied.
     * Regardless of the recordConfig, emoji selections will always be recorded on the EmojiRepository
     * for the purposes of tracking the frequency of use.
     *
     * @param emoji The full description of the emoji to record usage for.
     */
    EmojiResource.prototype.recordSelection = function (emoji) {
        var recordConfig = this.recordConfig;
        if (this.emojiRepository) {
            this.emojiRepository.used(emoji);
        }
        if (recordConfig) {
            var queryParams = {
                emojiId: Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["o" /* toEmojiId */])(emoji),
            };
            var requestInit = {
                method: 'POST',
            };
            return __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */].requestService(recordConfig, {
                queryParams: queryParams,
                requestInit: requestInit,
            });
        }
        return Promise.resolve();
    };
    EmojiResource.prototype.deleteSiteEmoji = function (emoji) {
        var _this = this;
        if (this.siteEmojiResource && emoji.id) {
            return this.siteEmojiResource
                .deleteEmoji(emoji)
                .then(function (success) {
                if (success && _this.emojiRepository) {
                    _this.emojiRepository.delete(emoji);
                    return true;
                }
                return false;
            })
                .catch(function (err) {
                // tslint:disable-next-line:no-console
                console.error('failed to delete site emoji', err);
                return false;
            });
        }
        return this.retryIfLoading(function () { return _this.deleteSiteEmoji(emoji); }, false);
    };
    EmojiResource.prototype.getSelectedTone = function () {
        return this.selectedTone;
    };
    EmojiResource.prototype.setSelectedTone = function (tone) {
        this.selectedTone = tone;
        if (window.localStorage) {
            try {
                window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_2__constants__["n" /* selectedToneStorageKey */], tone ? tone.toString() : '');
            }
            catch (e) {
                // tslint:disable-next-line:no-console
                console.error('failed to store selected emoji skin tone', e);
            }
        }
    };
    EmojiResource.prototype.calculateDynamicCategories = function () {
        var _this = this;
        if (this.isLoaded()) {
            return Promise.resolve(this.emojiRepository.getDynamicCategoryList());
        }
        return this.retryIfLoading(function () { return _this.calculateDynamicCategories(); }, []);
    };
    EmojiResource.prototype.getCurrentUser = function () {
        return this.currentUser;
    };
    EmojiResource.prototype.addUnknownEmoji = function (emoji) {
        if (this.emojiRepository) {
            this.emojiRepository.addUnknownEmoji(emoji);
        }
    };
    return EmojiResource;
}(__WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["a" /* AbstractResource */]));

var UploadingEmojiResource = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](UploadingEmojiResource, _super);
    function UploadingEmojiResource(config) {
        var _this = _super.call(this, config) || this;
        _this.allowUpload = !!config.allowUpload;
        return _this;
    }
    UploadingEmojiResource.prototype.isUploadSupported = function () {
        var _this = this;
        if (!this.allowUpload) {
            return Promise.resolve(false);
        }
        if (this.siteEmojiResource) {
            return this.siteEmojiResource.hasUploadToken();
        }
        return this.retryIfLoading(function () { return _this.isUploadSupported(); }, false);
    };
    UploadingEmojiResource.prototype.uploadCustomEmoji = function (upload) {
        var _this = this;
        return this.isUploadSupported().then(function (supported) {
            if (!supported || !_this.siteEmojiResource) {
                return Promise.reject('No media api support is configured');
            }
            return _this.siteEmojiResource.uploadEmoji(upload).then(function (emoji) {
                _this.addUnknownEmoji(emoji);
                _this.refreshLastFilter();
                return emoji;
            });
        });
    };
    UploadingEmojiResource.prototype.prepareForUpload = function () {
        var _this = this;
        if (this.siteEmojiResource) {
            this.siteEmojiResource.prepareForUpload();
        }
        return this.retryIfLoading(function () { return _this.prepareForUpload(); }, undefined);
    };
    return UploadingEmojiResource;
}(EmojiResource));
/* unused harmony default export */ var _unused_webpack_default_export = (UploadingEmojiResource);
//# sourceMappingURL=EmojiResource.js.map

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNaturalImageSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parseImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasFileExceededSize; });
/* unused harmony export checkWebpSupport */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return imageAcceptHeader; });
var maxEmojiSizeInBytes = 1048576;
var getNaturalImageSize = function (dataURL) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.addEventListener('load', function () {
            resolve({
                width: img.naturalWidth,
                height: img.naturalHeight,
            });
        });
        img.addEventListener('error', reject);
        img.src = dataURL;
    });
};
var parseImage = function (dataURL) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () { return resolve({ src: img.src }); };
        img.onerror = function () { return reject(); };
        img.src = dataURL;
    });
};
var hasFileExceededSize = function (file) {
    return file && file.size > maxEmojiSizeInBytes;
};
// Duplicates https://bitbucket.org/atlassian/atlaskit/src/0e843df6df8bcd33fa7fc16cc63f11a0f6094957/packages/media-core/src/utils/checkWebpSupport.ts?at=master&fileviewer=file-view-default
// Didn't want to depend on the whole of media-core just for this util
/**
 * Checks if Webp support is enabled in the browser.
 * We know that creating a new image in memory and checking its height,
 * later on we cache this value forever.
 */
var isWebpSupported;
var checkWebpSupport = function () {
    if (isWebpSupported !== undefined) {
        return Promise.resolve(isWebpSupported);
    }
    return new Promise(function (resolve) {
        var img = new Image();
        var checkSupport = function () {
            isWebpSupported = img.height === 2;
            resolve(isWebpSupported);
        };
        img.addEventListener('load', checkSupport);
        img.addEventListener('error', checkSupport);
        img.src =
            'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMwAgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
    });
};
var imageAcceptHeader = function () {
    return checkWebpSupport().then(function (isWebpSupported) {
        // q=0.8 stands for 'quality factor' => http://stackoverflow.com/a/10496722
        var noWebpAcceptHeader = 'image/*,*/*;q=0.8';
        var webpAcceptHeader = 'image/webp,image/*,*/*;q=0.8';
        return isWebpSupported ? webpAcceptHeader : noWebpAcceptHeader;
    });
};
//# sourceMappingURL=image.js.map

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AbstractItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SearchItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EmojisRowItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LoadingItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CategoryHeadingItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return virtualItemRenderer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_spinner__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EmojiPickerSizes__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EmojiPickerListSearch__ = __webpack_require__(2993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EmojiPickerEmojiRow__ = __webpack_require__(2995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EmojiPickerCategoryHeading__ = __webpack_require__(2996);








var AbstractItem = /** @class */ (function () {
    function AbstractItem(props, height) {
        this.props = props;
        this.height = height;
    }
    return AbstractItem;
}());

var SearchItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SearchItem, _super);
    function SearchItem(props) {
        var _this = _super.call(this, props, __WEBPACK_IMPORTED_MODULE_4__EmojiPickerSizes__["a" /* sizes */].searchHeight) || this;
        _this.renderItem = function () { return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__EmojiPickerListSearch__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, _this.props)); };
        return _this;
    }
    return SearchItem;
}(AbstractItem));

var EmojisRowItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojisRowItem, _super);
    function EmojisRowItem(props) {
        var _this = _super.call(this, props, __WEBPACK_IMPORTED_MODULE_4__EmojiPickerSizes__["a" /* sizes */].emojiRowHeight) || this;
        _this.renderItem = function (context) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__EmojiPickerEmojiRow__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, _this.props))); };
        return _this;
    }
    return EmojisRowItem;
}(AbstractItem));

var LoadingItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](LoadingItem, _super);
    function LoadingItem() {
        var _this = _super.call(this, {}, __WEBPACK_IMPORTED_MODULE_4__EmojiPickerSizes__["a" /* sizes */].loadingRowHeight) || this;
        _this.renderItem = function () { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3__styles__["l" /* emojiPickerSpinner */] },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_spinner__["a" /* default */], { size: "medium" })))); };
        return _this;
    }
    return LoadingItem;
}(AbstractItem));

var CategoryHeadingItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CategoryHeadingItem, _super);
    function CategoryHeadingItem(props) {
        var _this = _super.call(this, props, __WEBPACK_IMPORTED_MODULE_4__EmojiPickerSizes__["a" /* sizes */].categoryHeadingHeight) || this;
        _this.renderItem = function () { return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__EmojiPickerCategoryHeading__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, _this.props)); };
        return _this;
    }
    return CategoryHeadingItem;
}(AbstractItem));

var virtualItemRenderer = function (rows, context) {
    var index = context.index, key = context.key, style = context.style;
    var row = rows[index];
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: style, key: key }, row.renderItem(context)));
};
//# sourceMappingURL=EmojiPickerVirtualItems.js.map

/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sizes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(71);

var sizes = {
    listHeight: 208,
    listWidth: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* emojiPickerWidth */],
    searchHeight: 52,
    categoryHeadingHeight: 30,
    emojiRowHeight: 40,
    addEmojiHeight: 32,
    loadingRowHeight: 150,
    uploadActionHeight: 40,
    emojiPerRow: 8,
};
//# sourceMappingURL=EmojiPickerSizes.js.map

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return supportsUploadFeature; });
/* unused harmony export EmojiResource */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type_helpers__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_logger__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EmojiLoader__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EmojiRepository__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__media_SiteEmojiResource__ = __webpack_require__(3000);








/**
 * Checks if the emojiProvider can support uploading at a feature level.
 *
 * Follow this up with an isUploadSupported() check to see if the provider is actually
 * configured to support uploads.
 */
var supportsUploadFeature = function (emojiProvider) {
    var _a = emojiProvider, isUploadSupported = _a.isUploadSupported, prepareForUpload = _a.prepareForUpload, uploadCustomEmoji = _a.uploadCustomEmoji;
    return !!(isUploadSupported && prepareForUpload && uploadCustomEmoji);
};
var EmojiResource = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiResource, _super);
    function EmojiResource(config) {
        var _this = _super.call(this) || this;
        _this.activeLoaders = 0;
        _this.retries = new Map();
        _this.isLoaded = function () { return _this.activeLoaders === 0 && _this.emojiRepository; };
        _this.recordConfig = config.recordConfig;
        _this.currentUser = config.currentUser;
        // Ensure order is retained by tracking until all done.
        var emojiResponses = [];
        _this.activeLoaders = config.providers.length;
        config.providers.forEach(function (provider, index) {
            var loader = new __WEBPACK_IMPORTED_MODULE_5__EmojiLoader__["a" /* default */](provider);
            var emojis = loader.loadEmoji();
            emojis
                .then(function (emojiResponse) {
                emojiResponses[index] = emojiResponse;
                _this.initEmojiRepository(emojiResponses);
                _this.initSiteEmojiResource(emojiResponse, provider).then(function () {
                    _this.activeLoaders--;
                    _this.performRetries();
                    _this.refreshLastFilter();
                });
            })
                .catch(function (reason) {
                _this.activeLoaders--;
                _this.notifyError(reason);
            });
        });
        if (window.localStorage) {
            _this.selectedTone = _this.loadStoredTone();
        }
        if (config.providers.length === 0) {
            throw new Error('No providers specified');
        }
        return _this;
    }
    EmojiResource.prototype.initEmojiRepository = function (emojiResponses) {
        var emojis = [];
        emojiResponses.forEach(function (emojiResponse) {
            emojis = emojis.concat(emojiResponse.emojis);
        });
        this.emojiRepository = new __WEBPACK_IMPORTED_MODULE_6__EmojiRepository__["a" /* default */](emojis);
    };
    EmojiResource.prototype.initSiteEmojiResource = function (emojiResponse, provider) {
        if (!this.siteEmojiResource && emojiResponse.mediaApiToken) {
            this.siteEmojiResource = new __WEBPACK_IMPORTED_MODULE_7__media_SiteEmojiResource__["a" /* default */](provider, emojiResponse.mediaApiToken);
            // Prime cache type + optimistic rendering by checking first Emoji.
            // If this is fails, it won't be primed until a good emoji is loaded later.
            var emojis = emojiResponse.emojis;
            if (emojis.length) {
                var done = this.siteEmojiResource.optimisticRendering(emojis[0]);
                if (Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["l" /* isPromise */])(done)) {
                    return done
                        .then(function () {
                        Object(__WEBPACK_IMPORTED_MODULE_4__util_logger__["a" /* default */])('Primed siteEmojiResource');
                    })
                        .catch(function () {
                        Object(__WEBPACK_IMPORTED_MODULE_4__util_logger__["a" /* default */])('Failed to prime siteEmojiResource');
                    });
                }
                else {
                    Object(__WEBPACK_IMPORTED_MODULE_4__util_logger__["a" /* default */])('Already primed siteEmojiResource');
                }
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_4__util_logger__["a" /* default */])('No emoji to prime siteEmojiResource with');
            }
        }
        return Promise.resolve();
    };
    EmojiResource.prototype.performRetries = function () {
        var currentRetries = this.retries;
        this.retries = new Map();
        currentRetries.forEach(function (resolveReject, retry) {
            var result = retry();
            if (Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["l" /* isPromise */])(result)) {
                result
                    .then(function (response) {
                    resolveReject.resolve(response);
                })
                    .catch(function (reason) {
                    resolveReject.reject(reason);
                });
            }
            else {
                resolveReject.resolve(result);
            }
        });
    };
    EmojiResource.prototype.loadStoredTone = function () {
        var storedToneString = window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__constants__["n" /* selectedToneStorageKey */]);
        if (storedToneString) {
            var storedTone = parseInt(storedToneString, 10);
            return !isNaN(storedTone) ? storedTone : undefined;
        }
        return undefined;
    };
    EmojiResource.prototype.refreshLastFilter = function () {
        if (typeof this.lastQuery !== 'undefined') {
            var _a = this.lastQuery, query = _a.query, options = _a.options;
            this.filter(query, options);
        }
    };
    EmojiResource.prototype.retryIfLoading = function (retry, defaultResponse) {
        var _this = this;
        if (!this.isLoaded()) {
            return new Promise(function (resolve, reject) {
                _this.retries.set(retry, { resolve: resolve, reject: reject });
            });
        }
        return Promise.resolve(defaultResponse);
    };
    EmojiResource.prototype.notifyResult = function (result) {
        if (result.query === this.lastQuery.query) {
            _super.prototype.notifyResult.call(this, result);
        }
    };
    EmojiResource.prototype.loadMediaEmoji = function (emoji, useAlt) {
        if (!this.siteEmojiResource || !Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["j" /* isMediaEmoji */])(emoji)) {
            return emoji;
        }
        return this.siteEmojiResource.loadMediaEmoji(emoji, useAlt);
    };
    EmojiResource.prototype.optimisticMediaRendering = function (emoji, useAlt) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["j" /* isMediaEmoji */])(emoji)) {
            return true;
        }
        if (!this.siteEmojiResource) {
            // Shouldn't have a media emoji without a siteEmojiResouce, but anyway ;)
            return false;
        }
        var optimistic = this.siteEmojiResource.optimisticRendering(emoji, useAlt);
        if (Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["l" /* isPromise */])(optimistic)) {
            // Not sure yet, so lets say no for now (this should normally be primed in most/all cases)
            return false;
        }
        return optimistic;
    };
    EmojiResource.prototype.filter = function (query, options) {
        this.lastQuery = {
            query: query,
            options: options,
        };
        if (this.emojiRepository) {
            this.notifyResult(this.emojiRepository.search(query, options));
        }
        else {
            // not ready
            this.notifyNotReady();
        }
    };
    EmojiResource.prototype.findByShortName = function (shortName) {
        var _this = this;
        if (this.isLoaded()) {
            // Wait for all emoji to load before looking by shortName (to ensure correct priority)
            return this.emojiRepository.findByShortName(shortName);
        }
        return this.retryIfLoading(function () { return _this.findByShortName(shortName); }, undefined);
    };
    EmojiResource.prototype.findByEmojiId = function (emojiId) {
        var _this = this;
        var id = emojiId.id, shortName = emojiId.shortName;
        if (this.emojiRepository) {
            if (id) {
                var emoji = this.emojiRepository.findById(id);
                if (emoji) {
                    return emoji;
                }
                if (this.isLoaded()) {
                    // all loaded but not found by id, try server to see if
                    // this is a newly uploaded emoji
                    if (this.siteEmojiResource) {
                        return this.siteEmojiResource.findEmoji(emojiId).then(function (emoji) {
                            if (!emoji) {
                                // if not, fallback to searching by shortName to
                                // at least render an alternative
                                return _this.findByShortName(shortName);
                            }
                            _this.addUnknownEmoji(emoji);
                            return emoji;
                        });
                    }
                    // if not, fallback to searching by shortName to
                    // at least render an alternative
                    return this.findByShortName(shortName);
                }
            }
            else {
                // no id fallback to shortName
                return this.findByShortName(shortName);
            }
        }
        return this.retryIfLoading(function () { return _this.findByEmojiId(emojiId); }, undefined);
    };
    EmojiResource.prototype.findById = function (id) {
        var _this = this;
        if (this.isLoaded()) {
            return this.emojiRepository.findById(id);
        }
        return this.retryIfLoading(function () { return _this.findById(id); }, undefined);
    };
    EmojiResource.prototype.findInCategory = function (categoryId) {
        var _this = this;
        if (this.isLoaded()) {
            return Promise.resolve(this.emojiRepository.findInCategory(categoryId));
        }
        return this.retryIfLoading(function () { return _this.findInCategory(categoryId); }, []);
    };
    EmojiResource.prototype.getAsciiMap = function () {
        var _this = this;
        if (this.isLoaded()) {
            return Promise.resolve(this.emojiRepository.getAsciiMap());
        }
        return this.retryIfLoading(function () { return _this.getAsciiMap(); }, new Map());
    };
    EmojiResource.prototype.getFrequentlyUsed = function (options) {
        var _this = this;
        if (this.isLoaded()) {
            return Promise.resolve(this.emojiRepository.getFrequentlyUsed(options));
        }
        return this.retryIfLoading(function () { return _this.getFrequentlyUsed(options); }, []);
    };
    /**
     * Record the selection of an emoji to a remote service if 'recordConfig' has been supplied.
     * Regardless of the recordConfig, emoji selections will always be recorded on the EmojiRepository
     * for the purposes of tracking the frequency of use.
     *
     * @param emoji The full description of the emoji to record usage for.
     */
    EmojiResource.prototype.recordSelection = function (emoji) {
        var recordConfig = this.recordConfig;
        if (this.emojiRepository) {
            this.emojiRepository.used(emoji);
        }
        if (recordConfig) {
            var queryParams = {
                emojiId: Object(__WEBPACK_IMPORTED_MODULE_3__type_helpers__["o" /* toEmojiId */])(emoji),
            };
            var requestInit = {
                method: 'POST',
            };
            return __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */].requestService(recordConfig, {
                queryParams: queryParams,
                requestInit: requestInit,
            });
        }
        return Promise.resolve();
    };
    EmojiResource.prototype.deleteSiteEmoji = function (emoji) {
        var _this = this;
        if (this.siteEmojiResource && emoji.id) {
            return this.siteEmojiResource
                .deleteEmoji(emoji)
                .then(function (success) {
                if (success && _this.emojiRepository) {
                    _this.emojiRepository.delete(emoji);
                    return true;
                }
                return false;
            })
                .catch(function (err) {
                // tslint:disable-next-line:no-console
                console.error('failed to delete site emoji', err);
                return false;
            });
        }
        return this.retryIfLoading(function () { return _this.deleteSiteEmoji(emoji); }, false);
    };
    EmojiResource.prototype.getSelectedTone = function () {
        return this.selectedTone;
    };
    EmojiResource.prototype.setSelectedTone = function (tone) {
        this.selectedTone = tone;
        if (window.localStorage) {
            try {
                window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_2__constants__["n" /* selectedToneStorageKey */], tone ? tone.toString() : '');
            }
            catch (e) {
                // tslint:disable-next-line:no-console
                console.error('failed to store selected emoji skin tone', e);
            }
        }
    };
    EmojiResource.prototype.calculateDynamicCategories = function () {
        var _this = this;
        if (this.isLoaded()) {
            return Promise.resolve(this.emojiRepository.getDynamicCategoryList());
        }
        return this.retryIfLoading(function () { return _this.calculateDynamicCategories(); }, []);
    };
    EmojiResource.prototype.getCurrentUser = function () {
        return this.currentUser;
    };
    EmojiResource.prototype.addUnknownEmoji = function (emoji) {
        if (this.emojiRepository) {
            this.emojiRepository.addUnknownEmoji(emoji);
        }
    };
    return EmojiResource;
}(__WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["a" /* AbstractResource */]));

var UploadingEmojiResource = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](UploadingEmojiResource, _super);
    function UploadingEmojiResource(config) {
        var _this = _super.call(this, config) || this;
        _this.allowUpload = !!config.allowUpload;
        return _this;
    }
    UploadingEmojiResource.prototype.isUploadSupported = function () {
        var _this = this;
        if (!this.allowUpload) {
            return Promise.resolve(false);
        }
        if (this.siteEmojiResource) {
            return this.siteEmojiResource.hasUploadToken();
        }
        return this.retryIfLoading(function () { return _this.isUploadSupported(); }, false);
    };
    UploadingEmojiResource.prototype.uploadCustomEmoji = function (upload) {
        var _this = this;
        return this.isUploadSupported().then(function (supported) {
            if (!supported || !_this.siteEmojiResource) {
                return Promise.reject('No media api support is configured');
            }
            return _this.siteEmojiResource.uploadEmoji(upload).then(function (emoji) {
                _this.addUnknownEmoji(emoji);
                _this.refreshLastFilter();
                return emoji;
            });
        });
    };
    UploadingEmojiResource.prototype.prepareForUpload = function () {
        var _this = this;
        if (this.siteEmojiResource) {
            this.siteEmojiResource.prepareForUpload();
        }
        return this.retryIfLoading(function () { return _this.prepareForUpload(); }, undefined);
    };
    return UploadingEmojiResource;
}(EmojiResource));
/* unused harmony default export */ var _unused_webpack_default_export = (UploadingEmojiResource);
//# sourceMappingURL=EmojiResource.js.map

/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNaturalImageSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parseImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasFileExceededSize; });
/* unused harmony export checkWebpSupport */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return imageAcceptHeader; });
var maxEmojiSizeInBytes = 1048576;
var getNaturalImageSize = function (dataURL) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.addEventListener('load', function () {
            resolve({
                width: img.naturalWidth,
                height: img.naturalHeight,
            });
        });
        img.addEventListener('error', reject);
        img.src = dataURL;
    });
};
var parseImage = function (dataURL) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () { return resolve({ src: img.src }); };
        img.onerror = function () { return reject(); };
        img.src = dataURL;
    });
};
var hasFileExceededSize = function (file) {
    return file && file.size > maxEmojiSizeInBytes;
};
// Duplicates https://bitbucket.org/atlassian/atlaskit/src/0e843df6df8bcd33fa7fc16cc63f11a0f6094957/packages/media-core/src/utils/checkWebpSupport.ts?at=master&fileviewer=file-view-default
// Didn't want to depend on the whole of media-core just for this util
/**
 * Checks if Webp support is enabled in the browser.
 * We know that creating a new image in memory and checking its height,
 * later on we cache this value forever.
 */
var isWebpSupported;
var checkWebpSupport = function () {
    if (isWebpSupported !== undefined) {
        return Promise.resolve(isWebpSupported);
    }
    return new Promise(function (resolve) {
        var img = new Image();
        var checkSupport = function () {
            isWebpSupported = img.height === 2;
            resolve(isWebpSupported);
        };
        img.addEventListener('load', checkSupport);
        img.addEventListener('error', checkSupport);
        img.src =
            'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMwAgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
    });
};
var imageAcceptHeader = function () {
    return checkWebpSupport().then(function (isWebpSupported) {
        // q=0.8 stands for 'quality factor' => http://stackoverflow.com/a/10496722
        var noWebpAcceptHeader = 'image/*,*/*;q=0.8';
        var webpAcceptHeader = 'image/webp,image/*,*/*;q=0.8';
        return isWebpSupported ? webpAcceptHeader : noWebpAcceptHeader;
    });
};
//# sourceMappingURL=image.js.map

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1410);
module.exports = __webpack_require__(1414);


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(1411).enable();
  window.Promise = __webpack_require__(1413);
}

// fetch() polyfill for making API calls.
__webpack_require__(561);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(184);


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(560);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(560);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "store", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__root_Root_js__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__root_store_js__ = __webpack_require__(3449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__ = __webpack_require__(3455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__offline_actions_js__ = __webpack_require__(500);
// Render an empty div until the token check is done
var appRoot=document.getElementById('app-host');var store=Object(__WEBPACK_IMPORTED_MODULE_3__root_store_js__["a" /* default */])();// Track browser's online state
Object(__WEBPACK_IMPORTED_MODULE_5__offline_actions_js__["b" /* watchOnlineState */])(store);// Start the app
Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__root_Root_js__["a" /* default */],{store:store}),appRoot);Object(__WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(184),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(184),r=__webpack_require__(1417);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1418);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__root_routes_js__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__root_App_js__ = __webpack_require__(3437);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Root=function(_Component){_inherits(Root,_Component);function Root(){_classCallCheck(this,Root);return _possibleConstructorReturn(this,(Root.__proto__||Object.getPrototypeOf(Root)).apply(this,arguments));}_createClass(Root,[{key:'render',value:function render(){var store=this.props.store;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux__["a" /* Provider */],{store:store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__root_routes_js__["a" /* default */],{component:__WEBPACK_IMPORTED_MODULE_3__root_App_js__["a" /* default */]}));}}]);return Root;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Root);

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(344);





var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1422);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(347);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = TYPE_STATICS[targetComponent['$$typeof']] || REACT_STATICS;
        var sourceStatics = TYPE_STATICS[sourceComponent['$$typeof']] || REACT_STATICS;

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.7.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(1440);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(571);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(249);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(1433);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(43), __webpack_require__(149)(module)))

/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(569);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(570);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(571);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(572);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(1441);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(344);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(350);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(575);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createBrowserHistory);

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(575);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createHashHistory);

/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(349);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createMemoryHistory);

/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(350);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(577);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(576);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(580);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(581);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(582);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(583);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(352);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(252);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(584);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(587);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ConnectedRouter = function (_Component) {
  _inherits(ConnectedRouter, _Component);

  function ConnectedRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, ConnectedRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleLocationChange = function (location) {
      _this.store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_3__reducer__["a" /* LOCATION_CHANGE */],
        payload: location
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ConnectedRouter.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        propsStore = _props.store,
        history = _props.history;

    this.store = propsStore || this.context.store;
    this.handleLocationChange(history.location);
  };

  ConnectedRouter.prototype.componentDidMount = function componentDidMount() {
    var history = this.props.history;

    this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
  };

  ConnectedRouter.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
  };

  ConnectedRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Router */], this.props);
  };

  return ConnectedRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ConnectedRouter.propTypes = {
  store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
ConnectedRouter.contextTypes = {
  store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (ConnectedRouter);

/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getLocation */
/* unused harmony export createMatchSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(586);


var getLocation = function getLocation(state) {
  return state.router.location;
};

var createMatchSelector = function createMatchSelector(path) {
  var lastPathname = null;
  var lastMatch = null;
  return function (state) {
    var _getLocation = getLocation(state),
        pathname = _getLocation.pathname;

    if (pathname === lastPathname) {
      return lastMatch;
    }
    lastPathname = pathname;
    var match = Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["b" /* matchPath */])(pathname, path);
    if (!match || !lastMatch || match.url !== lastMatch.url) {
      lastMatch = match;
    }
    return lastMatch;
  };
};

/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(588);


/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* CALL_HISTORY_METHOD */]) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, args);
      };
    };
  };
}

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__(589);
var utils = __webpack_require__(598);
var formats = __webpack_require__(356);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    filter: void undefined,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined'
            ? key.value
            : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        var value = obj[key];

        if (options.skipNulls && value === null) {
            continue;
        }
        pushToArray(keys, stringify(
            value,
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 1463 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inspect = __webpack_require__(254);

var $TypeError = __webpack_require__(152);

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('./list.d.ts').listGetNode} */
// eslint-disable-next-line consistent-return
var listGetNode = function (list, key, isDelete) {
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	// eslint-disable-next-line eqeqeq
	for (; (curr = prev.next) != null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			if (!isDelete) {
				// eslint-disable-next-line no-extra-parens
				curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
				list.next = curr; // eslint-disable-line no-param-reassign
			}
			return curr;
		}
	}
};

/** @type {import('./list.d.ts').listGet} */
var listGet = function (objects, key) {
	if (!objects) {
		return void undefined;
	}
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('./list.d.ts').listHas} */
var listHas = function (objects, key) {
	if (!objects) {
		return false;
	}
	return !!listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */
// eslint-disable-next-line consistent-return
var listDelete = function (objects, key) {
	if (objects) {
		return listGetNode(objects, key, true);
	}
};

/** @type {import('.')} */
module.exports = function getSideChannelList() {
	/** @typedef {ReturnType<typeof getSideChannelList>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			var root = $o && $o.next;
			var deletedNode = listDelete($o, key);
			if (deletedNode && root && root === deletedNode) {
				$o = void undefined;
			}
			return !!deletedNode;
		},
		get: function (key) {
			return listGet($o, key);
		},
		has: function (key) {
			return listHas($o, key);
		},
		set: function (key, value) {
			if (!$o) {
				// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
				$o = {
					next: void undefined
				};
			}
			// eslint-disable-next-line no-extra-parens
			listSet(/** @type {NonNullable<typeof $o>} */ ($o), key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
module.exports = Error;


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./abs')} */
module.exports = Math.abs;


/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./floor')} */
module.exports = Math.floor;


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./max')} */
module.exports = Math.max;


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./min')} */
module.exports = Math.min;


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./pow')} */
module.exports = Math.pow;


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./round')} */
module.exports = Math.round;


/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(1478);

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(1482);

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reflectGetProto = __webpack_require__(593);
var originalGetProto = __webpack_require__(594);

var getDunderProto = __webpack_require__(1484);

/** @type {import('.')} */
module.exports = reflectGetProto
	? function getProto(O) {
		// @ts-expect-error TS can't narrow inside a closure, for some reason
		return reflectGetProto(O);
	}
	: originalGetProto
		? function getProto(O) {
			if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
				throw new TypeError('getProto: not an object');
			}
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return originalGetProto(O);
		}
		: getDunderProto
			? function getProto(O) {
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return getDunderProto(O);
			}
			: null;


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBind = __webpack_require__(595);
var gOPD = __webpack_require__(592);

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(255);

var $apply = __webpack_require__(596);
var $call = __webpack_require__(355);
var $reflectApply = __webpack_require__(1487);

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);


/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(255);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(354);
var callBound = __webpack_require__(597);
var inspect = __webpack_require__(254);
var getSideChannelMap = __webpack_require__(590);

var $TypeError = __webpack_require__(152);
var $WeakMap = GetIntrinsic('%WeakMap%', true);

/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */
var $weakMapGet = callBound('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */
var $weakMapSet = callBound('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapHas = callBound('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapDelete = callBound('WeakMap.prototype.delete', true);

/** @type {import('.')} */
module.exports = $WeakMap
	? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
		/** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */

		/** @type {WeakMap<K & object, V> | undefined} */ var $wm;
		/** @type {Channel | undefined} */ var $m;

		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapDelete($wm, key);
					}
				} else if (getSideChannelMap) {
					if ($m) {
						return $m['delete'](key);
					}
				}
				return false;
			},
			get: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapGet($wm, key);
					}
				}
				return $m && $m.get(key);
			},
			has: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapHas($wm, key);
					}
				}
				return !!$m && $m.has(key);
			},
			set: function (key, value) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if (!$wm) {
						$wm = new $WeakMap();
					}
					$weakMapSet($wm, key, value);
				} else if (getSideChannelMap) {
					if (!$m) {
						$m = getSideChannelMap();
					}
					// eslint-disable-next-line no-extra-parens
					/** @type {NonNullable<typeof $m>} */ ($m).set(key, value);
				}
			}
		};

		// @ts-expect-error TODO: figure out why this is erroring
		return channel;
	}
	: getSideChannelMap;


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(598);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictMerge: true,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) {
        throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');

    var limit = options.parameterLimit === Infinity ? void undefined : options.parameterLimit;
    var parts = cleanStr.split(
        options.delimiter,
        options.throwOnLimitExceeded ? limit + 1 : limit
    );

    if (options.throwOnLimitExceeded && parts.length > limit) {
        throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    }

    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');

            if (key !== null) {
                val = utils.maybeMap(
                    parseArrayValue(
                        part.slice(pos + 1),
                        options,
                        isArray(obj[key]) ? obj[key].length : 0
                    ),
                    function (encodedVal) {
                        return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                    }
                );
            }
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(String(val));
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (options.comma && isArray(val) && val.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) {
                throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            }
            val = utils.combine([], val, options.arrayLimit, options.plainObjects);
        }

        if (key !== null) {
            var existing = has.call(obj, key);
            if (existing && (options.duplicates === 'combine' || part.indexOf('[]=') > -1)) {
                obj[key] = utils.combine(
                    obj[key],
                    val,
                    options.arrayLimit,
                    options.plainObjects
                );
            } else if (!existing || options.duplicates === 'last') {
                obj[key] = val;
            }
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }

    var leaf = valuesParsed ? val : parseArrayValue(val, options, currentArrayLength);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            if (utils.isOverflow(leaf)) {
                // leaf is already an overflow object, preserve it
                obj = leaf;
            } else {
                obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
                    ? []
                    : utils.combine(
                        [],
                        leaf,
                        options.arrayLimit,
                        options.plainObjects
                    );
            }
        } else {
            obj = options.plainObjects ? { __proto__: null } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            var isValidArrayIndex = !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && options.parseArrays;
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (isValidArrayIndex && index < options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (isValidArrayIndex && options.throwOnLimitExceeded) {
                throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            } else if (isValidArrayIndex) {
                obj[index] = leaf;
                utils.markOverflow(obj, index);
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var splitKeyIntoSegments = function splitKeyIntoSegments(givenKey, options) {
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    if (options.depth <= 0) {
        if (!options.plainObjects && has.call(Object.prototype, key)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        return [key];
    }

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    var keys = [];

    if (parent) {
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys[keys.length] = parent;
    }

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;

        var segmentContent = segment[1].slice(1, -1);
        if (!options.plainObjects && has.call(Object.prototype, segmentContent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys[keys.length] = segment[1];
    }

    if (segment) {
        if (options.strictDepth === true) {
            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        }

        keys[keys.length] = '[' + key.slice(segment.index) + ']';
    }

    return keys;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    var keys = splitKeyIntoSegments(givenKey, options);

    if (!keys) {
        return;
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') {
        throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    }

    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictMerge: typeof opts.strictMerge === 'boolean' ? !!opts.strictMerge : defaults.strictMerge,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? { __proto__: null } : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? { __proto__: null } : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_requireLogin_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_reducer__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_avatar__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__accessSelfService_AccessStatus__ = __webpack_require__(171);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserPage=function(_Component){_inherits(UserPage,_Component);function UserPage(){_classCallCheck(this,UserPage);return _possibleConstructorReturn(this,(UserPage.__proto__||Object.getPrototypeOf(UserPage)).apply(this,arguments));}_createClass(UserPage,[{key:'render',value:function render(){var _props=this.props,jiraUser=_props.jiraUser,adUser=_props.adUser;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index_js__["s" /* PageTitle */],{title:'User'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index_js__["f" /* Container */],{section:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index_js__["i" /* H1 */],null,'User'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__atlaskit_avatar__["a" /* AvatarItem */],{avatar:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__atlaskit_avatar__["d" /* default */],{src:jiraUser&&jiraUser.avatarUrls?jiraUser.avatarUrls['48x48']:null,size:'large'}),key:jiraUser?jiraUser.emailAddress:adUser.email,primaryText:jiraUser?jiraUser.displayName:adUser.firstName+' '+adUser.lastName,secondaryText:jiraUser?jiraUser.emailAddress:adUser.email,enableTextTruncate:true}),!jiraUser?null:!jiraUser.avatarUrls?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'u-sm-ib p4-sm mb-2-sm u-va-b'},'Your user icon is pulled from JIRA. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Reasons one is not displayed: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'1) You don\'t have a JIRA account - Not needed to use this tool. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'2) You haven\'t added an Avatar to your profile'):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section-header'},'Application Access Status',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__accessSelfService_AccessStatus__["a" /* default */],{username:adUser.username}))));}}]);return UserPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_3__auth_requireLogin_js__["b" /* default */])('User'),Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{jiraUser:Object(__WEBPACK_IMPORTED_MODULE_4__auth_reducer__["h" /* selectJiraUser */])(state),adUser:Object(__WEBPACK_IMPORTED_MODULE_4__auth_reducer__["f" /* selectADUserInfo */])(state)};},{}))(UserPage));

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
 * @description Recursive object extending
 * @author Viacheslav Lotsmanov <lotsmanov89@gmail.com>
 * @license MIT
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2013-2018 Viacheslav Lotsmanov
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */



function isSpecificValue(val) {
	return (
		val instanceof Buffer
		|| val instanceof Date
		|| val instanceof RegExp
	) ? true : false;
}

function cloneSpecificValue(val) {
	if (val instanceof Buffer) {
		var x = Buffer.alloc
			? Buffer.alloc(val.length)
			: new Buffer(val.length);
		val.copy(x);
		return x;
	} else if (val instanceof Date) {
		return new Date(val.getTime());
	} else if (val instanceof RegExp) {
		return new RegExp(val);
	} else {
		throw new Error('Unexpected situation');
	}
}

/**
 * Recursive cloning array.
 */
function deepCloneArray(arr) {
	var clone = [];
	arr.forEach(function (item, index) {
		if (typeof item === 'object' && item !== null) {
			if (Array.isArray(item)) {
				clone[index] = deepCloneArray(item);
			} else if (isSpecificValue(item)) {
				clone[index] = cloneSpecificValue(item);
			} else {
				clone[index] = deepExtend({}, item);
			}
		} else {
			clone[index] = item;
		}
	});
	return clone;
}

function safeGetProperty(object, property) {
	return property === '__proto__' ? undefined : object[property];
}

/**
 * Extening object that entered in first argument.
 *
 * Returns extended object or false if have no target object or incorrect type.
 *
 * If you wish to clone source object (without modify it), just use empty new
 * object as first argument, like this:
 *   deepExtend({}, yourObj_1, [yourObj_N]);
 */
var deepExtend = module.exports = function (/*obj_1, [obj_2], [obj_N]*/) {
	if (arguments.length < 1 || typeof arguments[0] !== 'object') {
		return false;
	}

	if (arguments.length < 2) {
		return arguments[0];
	}

	var target = arguments[0];

	// convert arguments to array and cut off target object
	var args = Array.prototype.slice.call(arguments, 1);

	var val, src, clone;

	args.forEach(function (obj) {
		// skip argument if isn't an object, is null, or is an array
		if (typeof obj !== 'object' || obj === null || Array.isArray(obj)) {
			return;
		}

		Object.keys(obj).forEach(function (key) {
			src = safeGetProperty(target, key); // source value
			val = safeGetProperty(obj, key); // new value

			// recursion prevention
			if (val === target) {
				return;

			/**
			 * if new value isn't object then just overwrite by new value
			 * instead of extending.
			 */
			} else if (typeof val !== 'object' || val === null) {
				target[key] = val;
				return;

			// just clone arrays (and recursive clone objects inside)
			} else if (Array.isArray(val)) {
				target[key] = deepCloneArray(val);
				return;

			// custom cloning and overwrite for specific objects
			} else if (isSpecificValue(val)) {
				target[key] = cloneSpecificValue(val);
				return;

			// overwrite by new value if source isn't object or array
			} else if (typeof src !== 'object' || src === null || Array.isArray(src)) {
				target[key] = deepExtend({}, val);
				return;

			// source value and new value is objects both, extending...
			} else {
				target[key] = deepExtend(src, val);
				return;
			}
		});
	});

	return target;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(331).Buffer))

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 1494 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1495 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Container=function Container(_ref){var children=_ref.children,fluid=_ref.fluid,section=_ref.section,extraClassName=_ref.extraClassName,className=_ref.className,style=_ref.style;var containerClass=[className||'ncss-container'];if(extraClassName)containerClass.push(extraClassName);if(fluid)containerClass.push('fixed-fluid');if(section)containerClass.push('bg-white border p6-sm mb5-sm');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:containerClass.join(' '),style:style},children);};/* harmony default export */ __webpack_exports__["a"] = (Container);

/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Select=function(_Component){_inherits(Select,_Component);function Select(){var _ref;_classCallCheck(this,Select);for(var _len=arguments.length,props=Array(_len),_key=0;_key<_len;_key++){props[_key]=arguments[_key];}var _this=_possibleConstructorReturn(this,(_ref=Select.__proto__||Object.getPrototypeOf(Select)).call.apply(_ref,[this].concat(props)));_this._onWindowClick=function(event){var dropdownElement=Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(_this);if(event.target!==dropdownElement&&!dropdownElement.contains(event.target)&&_this.state.isFocused){_this.setState({isFocused:false});}};_this.openMenu=function(e){e.preventDefault();if(!_this.state.isFocused){_this.setState({isFocused:true});}};_this.handleChange=function(newValue){_this.props.onChange(newValue);_this.setState({isFocused:false});};_this.state={isFocused:false};return _this;}_createClass(Select,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('click',this._onWindowClick);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('click',this._onWindowClick);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,value=_props.value,_onChange=_props.onChange,placeholder=_props.placeholder,label=_props.label,clearable=_props.clearable;var options=this.props.options.slice(0);placeholder=placeholder||'Select an option';if(clearable===undefined){clearable=false;}if(clearable||value===null||value===undefined){options.unshift({label:placeholder,value:''});value=value||'';}var selectedOptionLabel=(options.find(function(o){return o.value===value;})||{}).label;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'typeahead-dropdown-container '+(this.state.isFocused?'focus':'')},label?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'ncss-label pr3-sm'},label):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'u-sm-b u-md-h'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:value,onChange:function onChange(e){return _onChange(e.target.value);}},options.map(function(v){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:v.value,value:v.value},v.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'typeahead-input z2 u-sm-h u-md-b'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ncss-flyout-btn bg-white u-full-width',onClick:this.openMenu},selectedOptionLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'typeahead-options ncss-flyout-options'},options.map(function(o){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ncss-option pt1-sm pr5-sm pb1-sm pl5-sm '+(o.value===value?'active':''),onClick:function onClick(){return _this2.handleChange(o.value);},key:o.value},o.label);}))));}}]);return Select;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (Select);

/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(1499);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Tooltip__["a" /* default */]);

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_trigger__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__placements__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Content__ = __webpack_require__(1561);











var Tooltip = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tooltip, _Component);

  function Tooltip() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
      var _this$props = _this.props,
          arrowContent = _this$props.arrowContent,
          overlay = _this$props.overlay,
          prefixCls = _this$props.prefixCls,
          id = _this$props.id;

      return [__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-arrow', key: 'arrow' },
        arrowContent
      ), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Content__["a" /* default */], {
        key: 'content',
        trigger: _this.trigger,
        prefixCls: prefixCls,
        id: id,
        overlay: overlay
      })];
    }, _this.saveTrigger = function (node) {
      _this.trigger = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
    return this.trigger.getPopupDomNode();
  };

  Tooltip.prototype.render = function render() {
    var _props = this.props,
        overlayClassName = _props.overlayClassName,
        trigger = _props.trigger,
        mouseEnterDelay = _props.mouseEnterDelay,
        mouseLeaveDelay = _props.mouseLeaveDelay,
        overlayStyle = _props.overlayStyle,
        prefixCls = _props.prefixCls,
        children = _props.children,
        onVisibleChange = _props.onVisibleChange,
        afterVisibleChange = _props.afterVisibleChange,
        transitionName = _props.transitionName,
        animation = _props.animation,
        placement = _props.placement,
        align = _props.align,
        destroyTooltipOnHide = _props.destroyTooltipOnHide,
        defaultVisible = _props.defaultVisible,
        getTooltipContainer = _props.getTooltipContainer,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);

    var extraProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, restProps);
    if ('visible' in this.props) {
      extraProps.popupVisible = this.props.visible;
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_rc_trigger__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        popupClassName: overlayClassName,
        ref: this.saveTrigger,
        prefixCls: prefixCls,
        popup: this.getPopupElement,
        action: trigger,
        builtinPlacements: __WEBPACK_IMPORTED_MODULE_8__placements__["a" /* placements */],
        popupPlacement: placement,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
      }, extraProps),
      children
    );
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Tooltip.propTypes = {
  trigger: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  defaultVisible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  placement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  onVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  afterVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  overlay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]).isRequired,
  overlayStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  overlayClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  getTooltipContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  destroyTooltipOnHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  align: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  arrowContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
Tooltip.defaultProps = {
  prefixCls: 'rc-tooltip',
  mouseEnterDelay: 0,
  destroyTooltipOnHide: false,
  mouseLeaveDelay: 0.1,
  align: {},
  placement: 'right',
  trigger: ['hover'],
  arrowContent: null
};


/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1501);
module.exports = __webpack_require__(95).Object.assign;


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(118);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1502) });


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(190);
var gOPS = __webpack_require__(364);
var pIE = __webpack_require__(259);
var toObject = __webpack_require__(337);
var IObject = __webpack_require__(606);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(153)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(146);
var toLength = __webpack_require__(1374);
var toAbsoluteIndex = __webpack_require__(1504);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(360);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1506), __esModule: true };

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1375);
__webpack_require__(1378);
module.exports = __webpack_require__(366).f('iterator');


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(360);
var defined = __webpack_require__(359);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(365);
var descriptor = __webpack_require__(257);
var setToStringTag = __webpack_require__(338);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(145)(IteratorPrototype, __webpack_require__(140)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(123);
var anObject = __webpack_require__(177);
var getKeys = __webpack_require__(190);

module.exports = __webpack_require__(124) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(1511);
var step = __webpack_require__(1512);
var Iterators = __webpack_require__(334);
var toIObject = __webpack_require__(146);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(607)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 1511 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 1512 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1514), __esModule: true };

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1515);
__webpack_require__(1379);
__webpack_require__(1520);
__webpack_require__(1521);
module.exports = __webpack_require__(95).Symbol;


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(110);
var has = __webpack_require__(129);
var DESCRIPTORS = __webpack_require__(124);
var $export = __webpack_require__(118);
var redefine = __webpack_require__(608);
var META = __webpack_require__(1516).KEY;
var $fails = __webpack_require__(153);
var shared = __webpack_require__(362);
var setToStringTag = __webpack_require__(338);
var uid = __webpack_require__(258);
var wks = __webpack_require__(140);
var wksExt = __webpack_require__(366);
var wksDefine = __webpack_require__(367);
var enumKeys = __webpack_require__(1517);
var isArray = __webpack_require__(1518);
var anObject = __webpack_require__(177);
var isObject = __webpack_require__(143);
var toIObject = __webpack_require__(146);
var toPrimitive = __webpack_require__(358);
var createDesc = __webpack_require__(257);
var _create = __webpack_require__(365);
var gOPNExt = __webpack_require__(1519);
var $GOPD = __webpack_require__(546);
var $DP = __webpack_require__(123);
var $keys = __webpack_require__(190);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(609).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(259).f = $propertyIsEnumerable;
  __webpack_require__(364).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(247)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(145)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(258)('meta');
var isObject = __webpack_require__(143);
var has = __webpack_require__(129);
var setDesc = __webpack_require__(123).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(153)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(190);
var gOPS = __webpack_require__(364);
var pIE = __webpack_require__(259);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(531);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(146);
var gOPN = __webpack_require__(609).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(367)('asyncIterator');


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(367)('observable');


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1523), __esModule: true };

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1524);
module.exports = __webpack_require__(95).Object.setPrototypeOf;


/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(118);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1525).set });


/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(143);
var anObject = __webpack_require__(177);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(530)(Function.call, __webpack_require__(546).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1527), __esModule: true };

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1528);
var $Object = __webpack_require__(95).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(118);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(365) });


/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_ContainerRender__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_Portal__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Popup__ = __webpack_require__(1538);
















function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];

var IS_REACT_16 = !!__WEBPACK_IMPORTED_MODULE_6_react_dom__["createPortal"];

var contextTypes = {
  rcTrigger: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    onPopupMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
  })
};

var Trigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Trigger, _React$Component);

  function Trigger(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Trigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }

    _this.prevPopupVisible = popupVisible;

    _this.state = {
      popupVisible: popupVisible
    };
    return _this;
  }

  Trigger.prototype.getChildContext = function getChildContext() {
    return {
      rcTrigger: {
        onPopupMouseDown: this.onPopupMouseDown
      }
    };
  };

  Trigger.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    ALL_HANDLERS.forEach(function (h) {
      _this2['fire' + h] = function (e) {
        _this2.fireEvents(h, e);
      };
    });
  };

  Trigger.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  };

  Trigger.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var popupVisible = _ref.popupVisible;

    if (popupVisible !== undefined) {
      this.setState({
        popupVisible: popupVisible
      });
    }
  };

  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    };
    if (!IS_REACT_16) {
      this.renderComponent(null, triggerAfterPopupVisibleChange);
    }

    this.prevPopupVisible = prevState.popupVisible;

    // We must listen to `mousedown` or `touchstart`, edge case:
    // https://github.com/ant-design/ant-design/issues/5804
    // https://github.com/react-component/calendar/issues/250
    // https://github.com/react-component/trigger/issues/50
    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'mousedown', this.onDocumentClick);
      }
      // always hide on mobile
      if (!this.touchOutsideHandler) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'touchstart', this.onDocumentClick);
      }
      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
        currentDocument = currentDocument || props.getDocument();
        this.contextMenuOutsideHandler1 = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'scroll', this.onContextMenuClose);
      }
      // close popup when trigger type contains 'onContextMenu' and window is blur.
      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
        this.contextMenuOutsideHandler2 = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'blur', this.onContextMenuClose);
      }
      return;
    }

    this.clearOutsideHandler();
  };

  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
    clearTimeout(this.mouseDownTimeout);
  };

  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
    // for test
    if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  };

  Trigger.prototype.getPopupAlign = function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return Object(__WEBPACK_IMPORTED_MODULE_12__utils__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  };

  /**
   * @param popupVisible    Show or not the popup element
   * @param event           SyntheticEvent, used for `pointAlign`
   */
  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
    var alignPoint = this.props.alignPoint;


    this.clearDelayTimer();

    if (this.state.popupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({ popupVisible: popupVisible });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }

    // Always record the point position since mouseEnterDelay will delay the show
    if (alignPoint && event) {
      this.setPoint(event);
    }
  };

  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
    var _this3 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
      this.delayTimer = setTimeout(function () {
        _this3.setPopupVisible(visible, point);
        _this3.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible, event);
    }
  };

  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  };

  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.contextMenuOutsideHandler1) {
      this.contextMenuOutsideHandler1.remove();
      this.contextMenuOutsideHandler1 = null;
    }

    if (this.contextMenuOutsideHandler2) {
      this.contextMenuOutsideHandler2.remove();
      this.contextMenuOutsideHandler2 = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  };

  Trigger.prototype.createTwoChains = function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  };

  Trigger.prototype.isClickToShow = function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
    var _props2 = this.props,
        action = _props2.action,
        showAction = _props2.showAction;

    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
  };

  Trigger.prototype.isClickToHide = function isClickToHide() {
    var _props3 = this.props,
        action = _props3.action,
        hideAction = _props3.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
    var _props4 = this.props,
        action = _props4.action,
        showAction = _props4.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  };

  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
    var _props5 = this.props,
        action = _props5.action,
        hideAction = _props5.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  };

  Trigger.prototype.isFocusToShow = function isFocusToShow() {
    var _props6 = this.props,
        action = _props6.action,
        showAction = _props6.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  };

  Trigger.prototype.isBlurToHide = function isBlurToHide() {
    var _props7 = this.props,
        action = _props7.action,
        hideAction = _props7.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  };

  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  };

  Trigger.prototype.fireEvents = function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  };

  Trigger.prototype.close = function close() {
    this.setPopupVisible(false);
  };

  Trigger.prototype.render = function render() {
    var _this4 = this;

    var popupVisible = this.state.popupVisible;
    var _props8 = this.props,
        children = _props8.children,
        forceRender = _props8.forceRender,
        alignPoint = _props8.alignPoint,
        className = _props8.className;

    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    var newChildProps = { key: 'trigger' };

    if (this.isContextMenuToShow()) {
      newChildProps.onContextMenu = this.onContextMenu;
    } else {
      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
    }

    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
      if (alignPoint) {
        newChildProps.onMouseMove = this.onMouseMove;
      }
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    var childrenClassName = __WEBPACK_IMPORTED_MODULE_11_classnames___default()(child && child.props && child.props.className, className);
    if (childrenClassName) {
      newChildProps.className = childrenClassName;
    }
    var trigger = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newChildProps);

    if (!IS_REACT_16) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_rc_util_es_ContainerRender__["a" /* default */],
        {
          parent: this,
          visible: popupVisible,
          autoMount: false,
          forceRender: forceRender,
          getComponent: this.getComponent,
          getContainer: this.getContainer
        },
        function (_ref2) {
          var renderComponent = _ref2.renderComponent;

          _this4.renderComponent = renderComponent;
          return trigger;
        }
      );
    }

    var portal = void 0;
    // prevent unmounting after it's rendered
    if (popupVisible || this._component || forceRender) {
      portal = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_rc_util_es_Portal__["a" /* default */],
        {
          key: 'portal',
          getContainer: this.getContainer,
          didUpdate: this.handlePortalUpdate
        },
        this.getComponent()
      );
    }

    return [trigger, portal];
  };

  return Trigger;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Trigger.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  action: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string)]),
  showAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  hideAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  getPopupClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  onPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  afterPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
  popupStyle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  builtinPlacements: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  popupAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  zIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  focusDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  blurDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getDocument: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  forceRender: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  mask: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskClosable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onPopupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  defaultPopupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  maskAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  alignPoint: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool // Maybe we can support user pass position in the future
};
Trigger.contextTypes = contextTypes;
Trigger.childContextTypes = contextTypes;
Trigger.defaultProps = {
  prefixCls: 'rc-trigger-popup',
  getPopupClassNameFromAlign: returnEmptyString,
  getDocument: returnDocument,
  onPopupVisibleChange: noop,
  afterPopupVisibleChange: noop,
  onPopupAlign: noop,
  popupClassName: '',
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0.1,
  focusDelay: 0,
  blurDelay: 0.15,
  popupStyle: {},
  destroyPopupOnHide: false,
  popupAlign: {},
  defaultPopupVisible: false,
  mask: false,
  maskClosable: true,
  action: [],
  showAction: [],
  hideAction: []
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.onMouseEnter = function (e) {
    var mouseEnterDelay = _this5.props.mouseEnterDelay;

    _this5.fireEvents('onMouseEnter', e);
    _this5.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
  };

  this.onMouseMove = function (e) {
    _this5.fireEvents('onMouseMove', e);
    _this5.setPoint(e);
  };

  this.onMouseLeave = function (e) {
    _this5.fireEvents('onMouseLeave', e);
    _this5.delaySetPopupVisible(false, _this5.props.mouseLeaveDelay);
  };

  this.onPopupMouseEnter = function () {
    _this5.clearDelayTimer();
  };

  this.onPopupMouseLeave = function (e) {
    // https://github.com/react-component/trigger/pull/13
    // react bug?
    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this5._component && _this5._component.getPopupDomNode && Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__["a" /* default */])(_this5._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    _this5.delaySetPopupVisible(false, _this5.props.mouseLeaveDelay);
  };

  this.onFocus = function (e) {
    _this5.fireEvents('onFocus', e);
    // incase focusin and focusout
    _this5.clearDelayTimer();
    if (_this5.isFocusToShow()) {
      _this5.focusTime = Date.now();
      _this5.delaySetPopupVisible(true, _this5.props.focusDelay);
    }
  };

  this.onMouseDown = function (e) {
    _this5.fireEvents('onMouseDown', e);
    _this5.preClickTime = Date.now();
  };

  this.onTouchStart = function (e) {
    _this5.fireEvents('onTouchStart', e);
    _this5.preTouchTime = Date.now();
  };

  this.onBlur = function (e) {
    _this5.fireEvents('onBlur', e);
    _this5.clearDelayTimer();
    if (_this5.isBlurToHide()) {
      _this5.delaySetPopupVisible(false, _this5.props.blurDelay);
    }
  };

  this.onContextMenu = function (e) {
    e.preventDefault();
    _this5.fireEvents('onContextMenu', e);
    _this5.setPopupVisible(true, e);
  };

  this.onContextMenuClose = function () {
    if (_this5.isContextMenuToShow()) {
      _this5.close();
    }
  };

  this.onClick = function (event) {
    _this5.fireEvents('onClick', event);
    // focus will trigger click
    if (_this5.focusTime) {
      var preTime = void 0;
      if (_this5.preClickTime && _this5.preTouchTime) {
        preTime = Math.min(_this5.preClickTime, _this5.preTouchTime);
      } else if (_this5.preClickTime) {
        preTime = _this5.preClickTime;
      } else if (_this5.preTouchTime) {
        preTime = _this5.preTouchTime;
      }
      if (Math.abs(preTime - _this5.focusTime) < 20) {
        return;
      }
      _this5.focusTime = 0;
    }
    _this5.preClickTime = 0;
    _this5.preTouchTime = 0;
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    var nextVisible = !_this5.state.popupVisible;
    if (_this5.isClickToHide() && !nextVisible || nextVisible && _this5.isClickToShow()) {
      _this5.setPopupVisible(!_this5.state.popupVisible, event);
    }
  };

  this.onPopupMouseDown = function () {
    var _context$rcTrigger = _this5.context.rcTrigger,
        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;

    _this5.hasPopupMouseDown = true;

    clearTimeout(_this5.mouseDownTimeout);
    _this5.mouseDownTimeout = setTimeout(function () {
      _this5.hasPopupMouseDown = false;
    }, 0);

    if (rcTrigger.onPopupMouseDown) {
      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
    }
  };

  this.onDocumentClick = function (event) {
    if (_this5.props.mask && !_this5.props.maskClosable) {
      return;
    }

    var target = event.target;
    var root = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this5);
    if (!Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !_this5.hasPopupMouseDown) {
      _this5.close();
    }
  };

  this.getRootDomNode = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this5);
  };

  this.getPopupClassNameFromAlign = function (align) {
    var className = [];
    var _props9 = _this5.props,
        popupPlacement = _props9.popupPlacement,
        builtinPlacements = _props9.builtinPlacements,
        prefixCls = _props9.prefixCls,
        alignPoint = _props9.alignPoint,
        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;

    if (popupPlacement && builtinPlacements) {
      className.push(Object(__WEBPACK_IMPORTED_MODULE_12__utils__["b" /* getAlignPopupClassName */])(builtinPlacements, prefixCls, align, alignPoint));
    }
    if (getPopupClassNameFromAlign) {
      className.push(getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  };

  this.getComponent = function () {
    var _props10 = _this5.props,
        prefixCls = _props10.prefixCls,
        destroyPopupOnHide = _props10.destroyPopupOnHide,
        popupClassName = _props10.popupClassName,
        action = _props10.action,
        onPopupAlign = _props10.onPopupAlign,
        popupAnimation = _props10.popupAnimation,
        popupTransitionName = _props10.popupTransitionName,
        popupStyle = _props10.popupStyle,
        mask = _props10.mask,
        maskAnimation = _props10.maskAnimation,
        maskTransitionName = _props10.maskTransitionName,
        zIndex = _props10.zIndex,
        popup = _props10.popup,
        stretch = _props10.stretch,
        alignPoint = _props10.alignPoint;
    var _state = _this5.state,
        popupVisible = _state.popupVisible,
        point = _state.point;


    var align = _this5.getPopupAlign();

    var mouseProps = {};
    if (_this5.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = _this5.onPopupMouseEnter;
    }
    if (_this5.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = _this5.onPopupMouseLeave;
    }

    mouseProps.onMouseDown = _this5.onPopupMouseDown;
    mouseProps.onTouchStart = _this5.onPopupMouseDown;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_13__Popup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        prefixCls: prefixCls,
        destroyPopupOnHide: destroyPopupOnHide,
        visible: popupVisible,
        point: alignPoint && point,
        className: popupClassName,
        action: action,
        align: align,
        onAlign: onPopupAlign,
        animation: popupAnimation,
        getClassNameFromAlign: _this5.getPopupClassNameFromAlign
      }, mouseProps, {
        stretch: stretch,
        getRootDomNode: _this5.getRootDomNode,
        style: popupStyle,
        mask: mask,
        zIndex: zIndex,
        transitionName: popupTransitionName,
        maskAnimation: maskAnimation,
        maskTransitionName: maskTransitionName,
        ref: _this5.savePopup
      }),
      typeof popup === 'function' ? popup() : popup
    );
  };

  this.getContainer = function () {
    var props = _this5.props;

    var popupContainer = document.createElement('div');
    // Make sure default popup container will never cause scrollbar appearing
    // https://github.com/react-component/trigger/issues/41
    popupContainer.style.position = 'absolute';
    popupContainer.style.top = '0';
    popupContainer.style.left = '0';
    popupContainer.style.width = '100%';
    var mountNode = props.getPopupContainer ? props.getPopupContainer(Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this5)) : props.getDocument().body;
    mountNode.appendChild(popupContainer);
    return popupContainer;
  };

  this.setPoint = function (point) {
    var alignPoint = _this5.props.alignPoint;

    if (!alignPoint || !point) return;

    _this5.setState({
      point: {
        pageX: point.pageX,
        pageY: point.pageY
      }
    });
  };

  this.handlePortalUpdate = function () {
    if (_this5.prevPopupVisible !== _this5.state.popupVisible) {
      _this5.props.afterPopupVisibleChange(_this5.state.popupVisible);
    }
  };

  this.savePopup = function (node) {
    _this5._component = node;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Trigger);

/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }

  return false;
}

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = addEventListener;

var _EventObject = __webpack_require__(1532);

var _EventObject2 = _interopRequireDefault(_EventObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function addEventListener(target, eventType, callback) {
  function wrapCallback(e) {
    var ne = new _EventObject2["default"](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    target.addEventListener(eventType, wrapCallback, false);
    return {
      remove: function remove() {
        target.removeEventListener(eventType, wrapCallback, false);
      }
    };
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}
module.exports = exports['default'];

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EventBaseObject = __webpack_require__(1533);

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__(184);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = void 0;
    var deltaY = void 0;
    var delta = void 0;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = void 0;
    var doc = void 0;
    var body = void 0;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2["default"].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = void 0;
  var l = void 0;
  var prop = void 0;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2["default"].prototype;

(0, _objectAssign2["default"])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },
  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports["default"] = DomEventObject;
module.exports = exports['default'];

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */

function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },
  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },
  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },
  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports['default'];

/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








var ContainerRender = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ContainerRender, _React$Component);

  function ContainerRender() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ContainerRender);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ContainerRender.__proto__ || Object.getPrototypeOf(ContainerRender)).call.apply(_ref, [this].concat(args))), _this), _this.removeContainer = function () {
      if (_this.container) {
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unmountComponentAtNode(_this.container);
        _this.container.parentNode.removeChild(_this.container);
        _this.container = null;
      }
    }, _this.renderComponent = function (props, ready) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          getComponent = _this$props.getComponent,
          forceRender = _this$props.forceRender,
          getContainer = _this$props.getContainer,
          parent = _this$props.parent;

      if (visible || parent._component || forceRender) {
        if (!_this.container) {
          _this.container = getContainer();
        }
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
          if (ready) {
            ready.call(this);
          }
        });
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ContainerRender, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.autoDestroy) {
        this.removeContainer();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]);

  return ContainerRender;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ContainerRender.propTypes = {
  autoMount: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  autoDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  parent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  getComponent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  getContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired
};
ContainerRender.defaultProps = {
  autoMount: true,
  autoDestroy: true,
  forceRender: false
};
/* harmony default export */ __webpack_exports__["a"] = (ContainerRender);

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1536);
var $Object = __webpack_require__(95).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(118);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(124), 'Object', { defineProperty: __webpack_require__(123).f });


/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








var Portal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Portal, _React$Component);

  function Portal() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Portal);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var didUpdate = this.props.didUpdate;

      if (didUpdate) {
        didUpdate(prevProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: 'createContainer',
    value: function createContainer() {
      this._container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: 'removeContainer',
    value: function removeContainer() {
      if (this._container) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this._container) {
        return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.createPortal(this.props.children, this._container);
      }
      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Portal.propTypes = {
  getContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired,
  didUpdate: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 1538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_align__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopupInner__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(612);













var Popup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      // Used for stretch
      stretchChecked: false,
      targetWidth: undefined,
      targetHeight: undefined
    };

    _this.savePopupRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'popupInstance');
    _this.saveAlignRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'alignInstance');
    return _this;
  }

  Popup.prototype.componentDidMount = function componentDidMount() {
    this.rootNode = this.getPopupDomNode();
    this.setStretchSize();
  };

  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
    this.setStretchSize();
  };

  // Record size if stretch needed


  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
    return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.popupInstance);
  };

  // `target` on `rc-align` can accept as a function to get the bind element or a point.
  // ref: https://www.npmjs.com/package/rc-align


  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
    var props = this.props;
    var transitionName = props.maskTransitionName;
    var animation = props.maskAnimation;
    if (!transitionName && animation) {
      transitionName = props.prefixCls + '-' + animation;
    }
    return transitionName;
  };

  Popup.prototype.getTransitionName = function getTransitionName() {
    var props = this.props;
    var transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = props.prefixCls + '-' + props.animation;
    }
    return transitionName;
  };

  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
  };

  Popup.prototype.getPopupElement = function getPopupElement() {
    var _this2 = this;

    var savePopupRef = this.savePopupRef;
    var _state = this.state,
        stretchChecked = _state.stretchChecked,
        targetHeight = _state.targetHeight,
        targetWidth = _state.targetWidth;
    var _props = this.props,
        align = _props.align,
        visible = _props.visible,
        prefixCls = _props.prefixCls,
        style = _props.style,
        getClassNameFromAlign = _props.getClassNameFromAlign,
        destroyPopupOnHide = _props.destroyPopupOnHide,
        stretch = _props.stretch,
        children = _props.children,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        onMouseDown = _props.onMouseDown,
        onTouchStart = _props.onTouchStart;

    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
    var hiddenClassName = prefixCls + '-hidden';

    if (!visible) {
      this.currentAlignClassName = null;
    }

    var sizeStyle = {};
    if (stretch) {
      // Stretch with target
      if (stretch.indexOf('height') !== -1) {
        sizeStyle.height = targetHeight;
      } else if (stretch.indexOf('minHeight') !== -1) {
        sizeStyle.minHeight = targetHeight;
      }
      if (stretch.indexOf('width') !== -1) {
        sizeStyle.width = targetWidth;
      } else if (stretch.indexOf('minWidth') !== -1) {
        sizeStyle.minWidth = targetWidth;
      }

      // Delay force align to makes ui smooth
      if (!stretchChecked) {
        sizeStyle.visibility = 'hidden';
        setTimeout(function () {
          if (_this2.alignInstance) {
            _this2.alignInstance.forceAlign();
          }
        }, 0);
      }
    }

    var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sizeStyle, style, this.getZIndexStyle());

    var popupInnerProps = {
      className: className,
      prefixCls: prefixCls,
      ref: savePopupRef,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseDown: onMouseDown,
      onTouchStart: onTouchStart,
      style: newStyle
    };
    if (destroyPopupOnHide) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
        {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName()
        },
        visible ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
          {
            target: this.getAlignTarget(),
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            align: align,
            onAlign: this.onAlign
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              visible: true
            }, popupInnerProps),
            children
          )
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
      {
        component: '',
        exclusive: true,
        transitionAppear: true,
        transitionName: this.getTransitionName(),
        showProp: 'xVisible'
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
        {
          target: this.getAlignTarget(),
          key: 'popup',
          ref: this.saveAlignRef,
          monitorWindowResize: true,
          xVisible: visible,
          childrenProps: { visible: 'xVisible' },
          disabled: !visible,
          align: align,
          onAlign: this.onAlign
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            hiddenClassName: hiddenClassName
          }, popupInnerProps),
          children
        )
      )
    );
  };

  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
    var style = {};
    var props = this.props;
    if (props.zIndex !== undefined) {
      style.zIndex = props.zIndex;
    }
    return style;
  };

  Popup.prototype.getMaskElement = function getMaskElement() {
    var props = this.props;
    var maskElement = void 0;
    if (props.mask) {
      var maskTransition = this.getMaskTransitionName();
      maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__["a" /* default */], {
        style: this.getZIndexStyle(),
        key: 'mask',
        className: props.prefixCls + '-mask',
        hiddenClassName: props.prefixCls + '-mask-hidden',
        visible: props.visible
      });
      if (maskTransition) {
        maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
          {
            key: 'mask',
            showProp: 'visible',
            transitionAppear: true,
            component: '',
            transitionName: maskTransition
          },
          maskElement
        );
      }
    }
    return maskElement;
  };

  Popup.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      null,
      this.getMaskElement(),
      this.getPopupElement()
    );
  };

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Popup.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  getClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getRootDomNode: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  point: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this3.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this3.currentAlignClassName !== currentAlignClassName) {
      _this3.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this3.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.setStretchSize = function () {
    var _props2 = _this3.props,
        stretch = _props2.stretch,
        getRootDomNode = _props2.getRootDomNode,
        visible = _props2.visible;
    var _state2 = _this3.state,
        stretchChecked = _state2.stretchChecked,
        targetHeight = _state2.targetHeight,
        targetWidth = _state2.targetWidth;


    if (!stretch || !visible) {
      if (stretchChecked) {
        _this3.setState({ stretchChecked: false });
      }
      return;
    }

    var $ele = getRootDomNode();
    if (!$ele) return;

    var height = $ele.offsetHeight;
    var width = $ele.offsetWidth;

    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
      _this3.setState({
        stretchChecked: true,
        targetHeight: height,
        targetWidth: width
      });
    }
  };

  this.getTargetElement = function () {
    return _this3.props.getRootDomNode();
  };

  this.getAlignTarget = function () {
    var point = _this3.props.point;

    if (point) {
      return point;
    }
    return _this3.getTargetElement;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(1540);
// export this package's api


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),
/* 1540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_align__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(1549);











function getElement(func) {
  if (typeof func !== 'function' || !func) return null;
  return func();
}

function getPoint(point) {
  if (typeof point !== 'object' || !point) return null;
  return point;
}

var Align = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Align, _Component);

  function Align() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.forceAlign = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          target = _this$props.target,
          align = _this$props.align,
          onAlign = _this$props.onAlign;

      if (!disabled && target) {
        var source = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(_this);

        var result = void 0;
        var element = getElement(target);
        var point = getPoint(target);

        if (element) {
          result = Object(__WEBPACK_IMPORTED_MODULE_6_dom_align__["a" /* alignElement */])(source, element, align);
        } else if (point) {
          result = Object(__WEBPACK_IMPORTED_MODULE_6_dom_align__["b" /* alignPoint */])(source, point, align);
        }

        if (onAlign) {
          onAlign(source, result);
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Align.prototype.componentDidMount = function componentDidMount() {
    var props = this.props;
    // if parent ref not attached .... use document.getElementById
    this.forceAlign();
    if (!props.disabled && props.monitorWindowResize) {
      this.startMonitorWindowResize();
    }
  };

  Align.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var reAlign = false;
    var props = this.props;

    if (!props.disabled) {
      var source = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var sourceRect = source ? source.getBoundingClientRect() : null;

      if (prevProps.disabled) {
        reAlign = true;
      } else {
        var lastElement = getElement(prevProps.target);
        var currentElement = getElement(props.target);
        var lastPoint = getPoint(prevProps.target);
        var currentPoint = getPoint(props.target);

        if (Object(__WEBPACK_IMPORTED_MODULE_8__util__["c" /* isWindow */])(lastElement) && Object(__WEBPACK_IMPORTED_MODULE_8__util__["c" /* isWindow */])(currentElement)) {
          // Skip if is window
          reAlign = false;
        } else if (lastElement !== currentElement || // Element change
        lastElement && !currentElement && currentPoint || // Change from element to point
        lastPoint && currentPoint && currentElement || // Change from point to element
        currentPoint && !Object(__WEBPACK_IMPORTED_MODULE_8__util__["b" /* isSamePoint */])(lastPoint, currentPoint)) {
          reAlign = true;
        }

        // If source element size changed
        var preRect = this.sourceRect || {};
        if (!reAlign && source && (preRect.width !== sourceRect.width || preRect.height !== sourceRect.height)) {
          reAlign = true;
        }
      }

      this.sourceRect = sourceRect;
    }

    if (reAlign) {
      this.forceAlign();
    }

    if (props.monitorWindowResize && !props.disabled) {
      this.startMonitorWindowResize();
    } else {
      this.stopMonitorWindowResize();
    }
  };

  Align.prototype.componentWillUnmount = function componentWillUnmount() {
    this.stopMonitorWindowResize();
  };

  Align.prototype.startMonitorWindowResize = function startMonitorWindowResize() {
    if (!this.resizeHandler) {
      this.bufferMonitor = Object(__WEBPACK_IMPORTED_MODULE_8__util__["a" /* buffer */])(this.forceAlign, this.props.monitorBufferTime);
      this.resizeHandler = Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.bufferMonitor);
    }
  };

  Align.prototype.stopMonitorWindowResize = function stopMonitorWindowResize() {
    if (this.resizeHandler) {
      this.bufferMonitor.clear();
      this.resizeHandler.remove();
      this.resizeHandler = null;
    }
  };

  Align.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        childrenProps = _props.childrenProps,
        children = _props.children;

    var child = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(children);
    if (childrenProps) {
      var newProps = {};
      var propList = Object.keys(childrenProps);
      propList.forEach(function (prop) {
        newProps[prop] = _this2.props[childrenProps[prop]];
      });

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, newProps);
    }
    return child;
  };

  return Align;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Align.propTypes = {
  childrenProps: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  align: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    clientX: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    clientY: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    pageX: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
  })]),
  onAlign: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  monitorBufferTime: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  monitorWindowResize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};
Align.defaultProps = {
  target: function target() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};


/* harmony default export */ __webpack_exports__["a"] = (Align);

/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__align_alignElement__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__align_alignPoint__ = __webpack_require__(1548);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__align_alignElement__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__align_alignPoint__["a"]; });





/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__align_alignElement__["a" /* default */]);

/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__align__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getRegion__ = __webpack_require__(616);





function isOutOfVisibleRect(target) {
  var visibleRect = Object(__WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__["a" /* default */])(target);
  var targetRegion = Object(__WEBPACK_IMPORTED_MODULE_3__getRegion__["a" /* default */])(target);

  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}

function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = Object(__WEBPACK_IMPORTED_MODULE_3__getRegion__["a" /* default */])(target);

  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target);

  return Object(__WEBPACK_IMPORTED_MODULE_0__align__["a" /* default */])(el, refNodeRegion, align, isTargetNotOutOfVisible);
}

alignElement.__getOffsetParent = __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */];

alignElement.__getVisibleRectForElement = __WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (alignElement);

/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransformName;
/* harmony export (immutable) */ __webpack_exports__["e"] = setTransitionProperty;
/* harmony export (immutable) */ __webpack_exports__["c"] = getTransitionProperty;
/* harmony export (immutable) */ __webpack_exports__["b"] = getTransformXY;
/* harmony export (immutable) */ __webpack_exports__["d"] = setTransformXY;
var vendorPrefix = void 0;

var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};

function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }
  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';
  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }
  return vendorPrefix;
}

function getTransitionName() {
  return getVendorPrefix() ? getVendorPrefix() + 'TransitionProperty' : 'transitionProperty';
}

function getTransformName() {
  return getVendorPrefix() ? getVendorPrefix() + 'Transform' : 'transform';
}

function setTransitionProperty(node, value) {
  var name = getTransitionName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}

function setTransform(node, value) {
  var name = getTransformName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}

function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}

function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return { x: parseFloat(matrix[12] || matrix[4], 0), y: parseFloat(matrix[13] || matrix[5], 0) };
  }
  return {
    x: 0,
    y: 0
  };
}

var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;

function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var arr = void 0;
    var match2d = transform.match(matrix2d);
    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, 'matrix(' + arr.join(',') + ')');
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, 'matrix3d(' + arr.join(',') + ')');
    }
  } else {
    setTransform(node, 'translateX(' + xy.x + 'px) translateY(' + xy.y + 'px) translateZ(0)');
  }
}

/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isAncestorFixed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(130);


function isAncestorFixed(element) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) || element.nodeType === 9) {
    return false;
  }

  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var body = doc.body;
  var parent = null;
  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
    var positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(parent, 'position');
    if (positionStyle === 'fixed') {
      return true;
    }
  }
  return false;
}

/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(130);


function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };

  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  }

  // Left edge inside and right edge outside viewport, try to resize it.
  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  }

  // Right edge outside viewport, try to move it.
  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  }

  // Top edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  }

  // Top edge inside and bottom edge outside viewport, try to resize it.
  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  }

  // Bottom edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }

  return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].mix(pos, size);
}

/* harmony default export */ __webpack_exports__["a"] = (adjustForViewport);

/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAlignOffset__ = __webpack_require__(1547);


function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = Object(__WEBPACK_IMPORTED_MODULE_0__getAlignOffset__["a" /* default */])(refNodeRegion, points[1]);
  var p2 = Object(__WEBPACK_IMPORTED_MODULE_0__getAlignOffset__["a" /* default */])(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];

  return {
    left: elRegion.left - diff[0] + offset[0] - targetOffset[0],
    top: elRegion.top - diff[1] + offset[1] - targetOffset[1]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getElFuturePos);

/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */

function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;

  var x = region.left;
  var y = region.top;

  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }

  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }

  return {
    left: x,
    top: y
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getAlignOffset);

/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__align__ = __webpack_require__(613);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX = void 0;
  var pageY = void 0;

  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(el);
  var win = doc.defaultView || doc.parentWindow;

  var scrollX = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollLeft(win);
  var scrollY = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollTop(win);
  var viewportWidth = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportWidth(win);
  var viewportHeight = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportHeight(win);

  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }

  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }

  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };

  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;

  // Provide default target point
  var points = [align.points[0], 'cc'];

  return Object(__WEBPACK_IMPORTED_MODULE_1__align__["a" /* default */])(el, tgtRegion, _extends({}, align, { points: points }), pointInView);
}

/* harmony default export */ __webpack_exports__["a"] = (alignPoint);

/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buffer;
/* harmony export (immutable) */ __webpack_exports__["b"] = isSamePoint;
/* harmony export (immutable) */ __webpack_exports__["c"] = isWindow;
function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}

function isWindow(obj) {
  return obj && typeof obj === 'object' && obj.window === obj;
}

/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AnimateChild__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CSSMotion__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_animate__ = __webpack_require__(619);













var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  } // eslint-disable-line

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.CSSMotion = __WEBPACK_IMPORTED_MODULE_10__CSSMotion__["a" /* default */];
Animate.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Animate);

/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__(619);










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_7_css_animation__["a" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["a"] = (cssAnimation);

/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete EVENT_NAME_MAP.transitionend.transition;
  }

  for (var baseEventName in EVENT_NAME_MAP) {
    if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
      var baseEvents = EVENT_NAME_MAP[baseEventName];
      for (var styleName in baseEvents) {
        if (styleName in style) {
          endEvents.push(baseEvents[styleName]);
          break;
        }
      }
    }
  }
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },


  endEvents: endEvents,

  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(618);
} catch (err) {
  var index = __webpack_require__(618);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export genCSSMotion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_raf__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_motion__ = __webpack_require__(1558);














var STATUS_NONE = 'none';
var STATUS_APPEAR = 'appear';
var STATUS_ENTER = 'enter';
var STATUS_LEAVE = 'leave';

/**
 * `transitionSupport` is used for none transition test case.
 * Default we use browser transition event support check.
 */
function genCSSMotion(transitionSupport) {
  function isSupportTransition(props) {
    return !!(props.motionName && transitionSupport);
  }

  var CSSMotion = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CSSMotion, _React$Component);

    function CSSMotion() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CSSMotion);

      var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CSSMotion.__proto__ || Object.getPrototypeOf(CSSMotion)).call(this));

      _this.onDomUpdate = function () {
        var _this$state = _this.state,
            status = _this$state.status,
            newStatus = _this$state.newStatus;
        var _this$props = _this.props,
            onAppearStart = _this$props.onAppearStart,
            onEnterStart = _this$props.onEnterStart,
            onLeaveStart = _this$props.onLeaveStart,
            onAppearActive = _this$props.onAppearActive,
            onEnterActive = _this$props.onEnterActive,
            onLeaveActive = _this$props.onLeaveActive,
            motionAppear = _this$props.motionAppear,
            motionEnter = _this$props.motionEnter,
            motionLeave = _this$props.motionLeave;


        if (!isSupportTransition(_this.props)) {
          return;
        }

        // Event injection
        var $ele = __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(_this);
        if (_this.$ele !== $ele) {
          _this.removeEventListener(_this.$ele);
          _this.addEventListener($ele);
          _this.$ele = $ele;
        }

        // Init status
        if (newStatus && status === STATUS_APPEAR && motionAppear) {
          _this.updateStatus(onAppearStart, null, null, function () {
            _this.updateActiveStatus(onAppearActive, STATUS_APPEAR);
          });
        } else if (newStatus && status === STATUS_ENTER && motionEnter) {
          _this.updateStatus(onEnterStart, null, null, function () {
            _this.updateActiveStatus(onEnterActive, STATUS_ENTER);
          });
        } else if (newStatus && status === STATUS_LEAVE && motionLeave) {
          _this.updateStatus(onLeaveStart, null, null, function () {
            _this.updateActiveStatus(onLeaveActive, STATUS_LEAVE);
          });
        }
      };

      _this.onMotionEnd = function (event) {
        var _this$state2 = _this.state,
            status = _this$state2.status,
            statusActive = _this$state2.statusActive;
        var _this$props2 = _this.props,
            onAppearEnd = _this$props2.onAppearEnd,
            onEnterEnd = _this$props2.onEnterEnd,
            onLeaveEnd = _this$props2.onLeaveEnd;

        if (status === STATUS_APPEAR && statusActive) {
          _this.updateStatus(onAppearEnd, { status: STATUS_NONE }, event);
        } else if (status === STATUS_ENTER && statusActive) {
          _this.updateStatus(onEnterEnd, { status: STATUS_NONE }, event);
        } else if (status === STATUS_LEAVE && statusActive) {
          _this.updateStatus(onLeaveEnd, { status: STATUS_NONE }, event);
        }
      };

      _this.addEventListener = function ($ele) {
        if (!$ele) return;

        $ele.addEventListener(__WEBPACK_IMPORTED_MODULE_12__util_motion__["d" /* transitionEndName */], _this.onMotionEnd);
        $ele.addEventListener(__WEBPACK_IMPORTED_MODULE_12__util_motion__["a" /* animationEndName */], _this.onMotionEnd);
      };

      _this.removeEventListener = function ($ele) {
        if (!$ele) return;

        $ele.removeEventListener(__WEBPACK_IMPORTED_MODULE_12__util_motion__["d" /* transitionEndName */], _this.onMotionEnd);
        $ele.removeEventListener(__WEBPACK_IMPORTED_MODULE_12__util_motion__["a" /* animationEndName */], _this.onMotionEnd);
      };

      _this.updateStatus = function (styleFunc, additionalState, event, callback) {
        var statusStyle = styleFunc ? styleFunc(__WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(_this), event) : null;

        if (statusStyle === false || _this._destroyed) return;

        var nextStep = void 0;
        if (callback) {
          nextStep = function nextStep() {
            _this.nextFrame(callback);
          };
        }

        _this.setState(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          statusStyle: typeof statusStyle === 'object' ? statusStyle : null,
          newStatus: false
        }, additionalState), nextStep); // Trigger before next frame & after `componentDidMount`
      };

      _this.updateActiveStatus = function (styleFunc, currentStatus) {
        // `setState` use `postMessage` to trigger at the end of frame.
        // Let's use requestAnimationFrame to update new state in next frame.
        _this.nextFrame(function () {
          var status = _this.state.status;

          if (status !== currentStatus) return;

          _this.updateStatus(styleFunc, { statusActive: true });
        });
      };

      _this.nextFrame = function (func) {
        _this.cancelNextFrame();
        _this.raf = __WEBPACK_IMPORTED_MODULE_11_raf___default()(func);
      };

      _this.cancelNextFrame = function () {
        if (_this.raf) {
          __WEBPACK_IMPORTED_MODULE_11_raf___default.a.cancel(_this.raf);
          _this.raf = null;
        }
      };

      _this.state = {
        status: STATUS_NONE,
        statusActive: false,
        newStatus: false,
        statusStyle: null
      };
      _this.$ele = null;
      _this.raf = null;
      return _this;
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CSSMotion, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.onDomUpdate();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        this.onDomUpdate();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this._destroyed = true;
        this.removeEventListener(this.$ele);
        this.cancelNextFrame();
      }
    }, {
      key: 'render',
      value: function render() {
        var _classNames;

        var _state = this.state,
            status = _state.status,
            statusActive = _state.statusActive,
            statusStyle = _state.statusStyle;
        var _props = this.props,
            children = _props.children,
            motionName = _props.motionName,
            visible = _props.visible,
            removeOnLeave = _props.removeOnLeave;


        if (!children) return null;

        if (status === STATUS_NONE || !isSupportTransition(this.props)) {
          return visible || !removeOnLeave ? children({}) : null;
        }

        return children({
          className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, Object(__WEBPACK_IMPORTED_MODULE_12__util_motion__["b" /* getTransitionName */])(motionName, status), status !== STATUS_NONE), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, Object(__WEBPACK_IMPORTED_MODULE_12__util_motion__["b" /* getTransitionName */])(motionName, status + '-active'), status !== STATUS_NONE && statusActive), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, motionName, typeof motionName === 'string'), _classNames)),
          style: statusStyle
        });
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(props, _ref) {
        var prevProps = _ref.prevProps;

        if (!isSupportTransition(props)) return {};

        var visible = props.visible,
            motionAppear = props.motionAppear,
            motionEnter = props.motionEnter,
            motionLeave = props.motionLeave,
            motionLeaveImmediately = props.motionLeaveImmediately;

        var newState = {
          prevProps: props
        };

        // Appear
        if (!prevProps && visible && motionAppear) {
          newState.status = STATUS_APPEAR;
          newState.statusActive = false;
          newState.newStatus = true;
        }

        // Enter
        if (prevProps && !prevProps.visible && visible && motionEnter) {
          newState.status = STATUS_ENTER;
          newState.statusActive = false;
          newState.newStatus = true;
        }

        // Leave
        if (prevProps && prevProps.visible && !visible && motionLeave || !prevProps && motionLeaveImmediately && !visible && motionLeave) {
          newState.status = STATUS_LEAVE;
          newState.statusActive = false;
          newState.newStatus = true;
        }

        return newState;
      }
    }]);

    return CSSMotion;
  }(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

  CSSMotion.propTypes = {
    visible: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    motionName: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object]),
    motionAppear: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    motionEnter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    motionLeave: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    motionLeaveImmediately: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool, // Trigger leave motion immediately
    removeOnLeave: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    onAppearStart: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onAppearActive: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onAppearEnd: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onEnterStart: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onEnterActive: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onEnterEnd: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onLeaveStart: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onLeaveActive: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onLeaveEnd: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
  };
  CSSMotion.defaultProps = {
    visible: true,
    motionEnter: true,
    motionAppear: true,
    motionLeave: true,
    removeOnLeave: true
  };


  Object(__WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__["polyfill"])(CSSMotion);

  return CSSMotion;
}

/* harmony default export */ __webpack_exports__["a"] = (genCSSMotion(__WEBPACK_IMPORTED_MODULE_12__util_motion__["c" /* supportTransition */]));

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(122)))

/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getVendorPrefixes */
/* unused harmony export getVendorPrefixedEventName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return animationEndName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return transitionEndName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return supportTransition; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getTransitionName;
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

// ================= Transition =================
// Event wrapper. Copy from react source code
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

function getVendorPrefixes(domSupport, win) {
  var prefixes = {
    animationend: makePrefixMap('Animation', 'AnimationEnd'),
    transitionend: makePrefixMap('Transition', 'TransitionEnd')
  };

  if (domSupport) {
    if (!('AnimationEvent' in win)) {
      delete prefixes.animationend.animation;
    }

    if (!('TransitionEvent' in win)) {
      delete prefixes.transitionend.transition;
    }
  }

  return prefixes;
}

var vendorPrefixes = getVendorPrefixes(canUseDOM, typeof window !== 'undefined' ? window : {});

var style = {};

if (canUseDOM) {
  style = document.createElement('div').style;
}

var prefixedEventNames = {};

function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  }

  var prefixMap = vendorPrefixes[eventName];

  if (prefixMap) {
    var stylePropList = Object.keys(prefixMap);
    var len = stylePropList.length;
    for (var i = 0; i < len; i += 1) {
      var styleProp = stylePropList[i];
      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
        prefixedEventNames[eventName] = prefixMap[styleProp];
        return prefixedEventNames[eventName];
      }
    }
  }

  return '';
}

var animationEndName = getVendorPrefixedEventName('animationend');
var transitionEndName = getVendorPrefixedEventName('transitionend');
var supportTransition = !!(animationEndName && transitionEndName);

function getTransitionName(transitionName, transitionType) {
  if (!transitionName) return null;

  if (typeof transitionName === 'object') {
    var type = transitionType.replace(/-\w/g, function (match) {
      return match[1].toUpperCase();
    });
    return transitionName[type];
  }

  return transitionName + '-' + transitionType;
}

/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__ = __webpack_require__(620);







var PopupInner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PopupInner, _Component);

  function PopupInner() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PopupInner);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  PopupInner.prototype.render = function render() {
    var props = this.props;
    var className = props.className;
    if (!props.visible) {
      className += ' ' + props.hiddenClassName;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      {
        className: className,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseDown: props.onMouseDown,
        onTouchStart: props.onTouchStart,
        style: props.style
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__["a" /* default */],
        { className: props.prefixCls + '-content', visible: props.visible },
        props.children
      )
    );
  };

  return PopupInner;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

PopupInner.propTypes = {
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (PopupInner);

/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placements; });
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (placements);

/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var Content = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Content, _React$Component);

  function Content() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Content);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Content.prototype.componentDidUpdate = function componentDidUpdate() {
    var trigger = this.props.trigger;

    if (trigger) {
      trigger.forcePopupAlign();
    }
  };

  Content.prototype.render = function render() {
    var _props = this.props,
        overlay = _props.overlay,
        prefixCls = _props.prefixCls,
        id = _props.id;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: prefixCls + '-inner', id: id, role: 'tooltip' },
      typeof overlay === 'function' ? overlay() : overlay
    );
  };

  return Content;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Content.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  overlay: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]).isRequired,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  trigger: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function shallowDiffers(a, b) {
  for (var i in a) {
    if (!(i in b)) return true;
  }for (var _i in b) {
    if (a[_i] !== b[_i]) return true;
  }return false;
}

/* harmony default export */ __webpack_exports__["a"] = (function (instance, nextProps, nextState) {
  return shallowDiffers(instance.props, nextProps) || shallowDiffers(instance.state, nextState);
});

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var Parser = __webpack_require__(1565).Parser;
var ReactRenderer = __webpack_require__(1578);
var propTypes = __webpack_require__(10);

function ReactMarkdown(props) {
    React.Component.call(this, props);
}

ReactMarkdown.prototype = Object.create(React.Component.prototype);
ReactMarkdown.prototype.constructor = ReactMarkdown;

ReactMarkdown.prototype.render = function() {
    var containerProps = this.props.containerProps || {};
    var renderer = new ReactRenderer(this.props);
    var parser = new Parser(this.props.parserOptions);
    var ast = parser.parse(this.props.source || '');

    if (this.props.walker) {
        var walker = ast.walker();
        var event;

        while ((event = walker.next())) {
            this.props.walker.call(this, event, walker);
        }
    }

    if (this.props.className) {
        containerProps.className = this.props.className;
    }

    return React.createElement.apply(React,
        [this.props.containerTagName, containerProps, this.props.childBefore]
            .concat(renderer.render(ast).concat(
                [this.props.childAfter]
            ))
    );
};

ReactMarkdown.propTypes = {
    className: propTypes.string,
    containerProps: propTypes.object,
    source: propTypes.string.isRequired,
    containerTagName: propTypes.string,
    childBefore: propTypes.object,
    childAfter: propTypes.object,
    sourcePos: propTypes.bool,
    escapeHtml: propTypes.bool,
    skipHtml: propTypes.bool,
    softBreak: propTypes.string,
    allowNode: propTypes.func,
    allowedTypes: propTypes.array,
    disallowedTypes: propTypes.array,
    transformLinkUri: propTypes.func,
    transformImageUri: propTypes.func,
    unwrapDisallowed: propTypes.bool,
    renderers: propTypes.object,
    walker: propTypes.func,
    parserOptions: propTypes.object
};

ReactMarkdown.defaultProps = {
    containerTagName: 'div',
    parserOptions: {}
};

ReactMarkdown.types = ReactRenderer.types;
ReactMarkdown.renderers = ReactRenderer.renderers;
ReactMarkdown.uriTransformer = ReactRenderer.uriTransformer;

module.exports = ReactMarkdown;


/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// commonmark.js - CommomMark in JavaScript
// Copyright (C) 2014 John MacFarlane
// License: BSD3.

// Basic usage:
//
// var commonmark = require('commonmark');
// var parser = new commonmark.Parser();
// var renderer = new commonmark.HtmlRenderer();
// console.log(renderer.render(parser.parse('Hello *world*')));

module.exports.version = '0.24.0'
module.exports.Node = __webpack_require__(368);
module.exports.Parser = __webpack_require__(1566);
module.exports.HtmlRenderer = __webpack_require__(1576);
module.exports.XmlRenderer = __webpack_require__(1577);


/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Node = __webpack_require__(368);
var unescapeString = __webpack_require__(154).unescapeString;
var OPENTAG = __webpack_require__(154).OPENTAG;
var CLOSETAG = __webpack_require__(154).CLOSETAG;

var CODE_INDENT = 4;

var C_TAB = 9;
var C_NEWLINE = 10;
var C_GREATERTHAN = 62;
var C_LESSTHAN = 60;
var C_SPACE = 32;
var C_OPEN_BRACKET = 91;

var InlineParser = __webpack_require__(1572);

var reHtmlBlockOpen = [
   /./, // dummy for 0
   /^<(?:script|pre|style)(?:\s|>|$)/i,
   /^<!--/,
   /^<[?]/,
   /^<![A-Z]/,
   /^<!\[CDATA\[/,
   /^<[/]?(?:address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h1|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|title|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul)(?:\s|[/]?[>]|$)/i,
    new RegExp('^(?:' + OPENTAG + '|' + CLOSETAG + ')\s*$', 'i')
];

var reHtmlBlockClose = [
   /./, // dummy for 0
   /<\/(?:script|pre|style)>/i,
   /-->/,
   /\?>/,
   />/,
   /\]\]>/
];

var reThematicBreak = /^(?:(?:\* *){3,}|(?:_ *){3,}|(?:- *){3,}) *$/;

var reMaybeSpecial = /^[#`~*+_=<>0-9-]/;

var reNonSpace = /[^ \t\f\v\r\n]/;

var reBulletListMarker = /^[*+-]/;

var reOrderedListMarker = /^(\d{1,9})([.)])/;

var reATXHeadingMarker = /^#{1,6}(?: +|$)/;

var reCodeFence = /^`{3,}(?!.*`)|^~{3,}(?!.*~)/;

var reClosingCodeFence = /^(?:`{3,}|~{3,})(?= *$)/;

var reSetextHeadingLine = /^(?:=+|-+) *$/;

var reLineEnding = /\r\n|\n|\r/;

// Returns true if string contains only space characters.
var isBlank = function(s) {
    return !(reNonSpace.test(s));
};

var peek = function(ln, pos) {
    if (pos < ln.length) {
        return ln.charCodeAt(pos);
    } else {
        return -1;
    }
};

// DOC PARSER

// These are methods of a Parser object, defined below.

// Returns true if block ends with a blank line, descending if needed
// into lists and sublists.
var endsWithBlankLine = function(block) {
    while (block) {
        if (block._lastLineBlank) {
            return true;
        }
        var t = block.type;
        if (t === 'List' || t === 'Item') {
            block = block._lastChild;
        } else {
            break;
        }
    }
    return false;
};

// Break out of all containing lists, resetting the tip of the
// document to the parent of the highest list, and finalizing
// all the lists.  (This is used to implement the "two blank lines
// break out of all lists" feature.)
var breakOutOfLists = function(block) {
    var b = block;
    var last_list = null;
    do {
        if (b.type === 'List') {
            last_list = b;
        }
        b = b._parent;
    } while (b);

    if (last_list) {
        while (block !== last_list) {
            this.finalize(block, this.lineNumber);
            block = block._parent;
        }
        this.finalize(last_list, this.lineNumber);
        this.tip = last_list._parent;
    }
};

// Add a line to the block at the tip.  We assume the tip
// can accept lines -- that check should be done before calling this.
var addLine = function() {
    this.tip._string_content += this.currentLine.slice(this.offset) + '\n';
};

// Add block of type tag as a child of the tip.  If the tip can't
// accept children, close and finalize it and try its parent,
// and so on til we find a block that can accept children.
var addChild = function(tag, offset) {
    while (!this.blocks[this.tip.type].canContain(tag)) {
        this.finalize(this.tip, this.lineNumber - 1);
    }

    var column_number = offset + 1; // offset 0 = column 1
    var newBlock = new Node(tag, [[this.lineNumber, column_number], [0, 0]]);
    newBlock._string_content = '';
    this.tip.appendChild(newBlock);
    this.tip = newBlock;
    return newBlock;
};

// Parse a list marker and return data on the marker (type,
// start, delimiter, bullet character, padding) or null.
var parseListMarker = function(parser) {
    var rest = parser.currentLine.slice(parser.nextNonspace);
    var match;
    var nextc;
    var spacesStartCol;
    var spacesStartOffset;
    var data = { type: null,
                 tight: true,  // lists are tight by default
                 bulletChar: null,
                 start: null,
                 delimiter: null,
                 padding: null,
                 markerOffset: parser.indent };
    if ((match = rest.match(reBulletListMarker))) {
        data.type = 'Bullet';
        data.bulletChar = match[0][0];

    } else if ((match = rest.match(reOrderedListMarker))) {
        data.type = 'Ordered';
        data.start = parseInt(match[1]);
        data.delimiter = match[2];
    } else {
        return null;
    }
    // make sure we have spaces after
    nextc = peek(parser.currentLine, parser.nextNonspace + match[0].length);
    if (!(nextc === -1 || nextc === C_TAB || nextc === C_SPACE)) {
        return null;
    }

    // we've got a match! advance offset and calculate padding
    parser.advanceNextNonspace(); // to start of marker
    parser.advanceOffset(match[0].length, true); // to end of marker
    spacesStartCol = parser.column;
    spacesStartOffset = parser.offset;
    do {
        parser.advanceOffset(1, true);
        nextc = peek(parser.currentLine, parser.offset);
    } while (parser.column - spacesStartCol < 5 &&
           (nextc === C_SPACE || nextc === C_TAB));
    var blank_item = peek(parser.currentLine, parser.offset) === -1;
    var spaces_after_marker = parser.column - spacesStartCol;
    if (spaces_after_marker >= 5 ||
        spaces_after_marker < 1 ||
        blank_item) {
        data.padding = match[0].length + 1;
        parser.column = spacesStartCol;
        parser.offset = spacesStartOffset;
        if (peek(parser.currentLine, parser.offset) === C_SPACE) {
            parser.advanceOffset(1, true);
        }
    } else {
        data.padding = match[0].length + spaces_after_marker;
    }
    return data;
};

// Returns true if the two list items are of the same type,
// with the same delimiter and bullet character.  This is used
// in agglomerating list items into lists.
var listsMatch = function(list_data, item_data) {
    return (list_data.type === item_data.type &&
            list_data.delimiter === item_data.delimiter &&
            list_data.bulletChar === item_data.bulletChar);
};

// Finalize and close any unmatched blocks.
var closeUnmatchedBlocks = function() {
    if (!this.allClosed) {
        // finalize any blocks not matched
        while (this.oldtip !== this.lastMatchedContainer) {
            var parent = this.oldtip._parent;
            this.finalize(this.oldtip, this.lineNumber - 1);
            this.oldtip = parent;
        }
        this.allClosed = true;
    }
};

// 'finalize' is run when the block is closed.
// 'continue' is run to check whether the block is continuing
// at a certain line and offset (e.g. whether a block quote
// contains a `>`.  It returns 0 for matched, 1 for not matched,
// and 2 for "we've dealt with this line completely, go to next."
var blocks = {
    Document: {
        continue: function() { return 0; },
        finalize: function() { return; },
        canContain: function(t) { return (t !== 'Item'); },
        acceptsLines: false
    },
    List: {
        continue: function() { return 0; },
        finalize: function(parser, block) {
            var item = block._firstChild;
            while (item) {
                // check for non-final list item ending with blank line:
                if (endsWithBlankLine(item) && item._next) {
                    block._listData.tight = false;
                    break;
                }
                // recurse into children of list item, to see if there are
                // spaces between any of them:
                var subitem = item._firstChild;
                while (subitem) {
                    if (endsWithBlankLine(subitem) &&
                        (item._next || subitem._next)) {
                        block._listData.tight = false;
                        break;
                    }
                    subitem = subitem._next;
                }
                item = item._next;
            }
        },
        canContain: function(t) { return (t === 'Item'); },
        acceptsLines: false
    },
    BlockQuote: {
        continue: function(parser) {
            var ln = parser.currentLine;
            if (!parser.indented &&
                peek(ln, parser.nextNonspace) === C_GREATERTHAN) {
                parser.advanceNextNonspace();
                parser.advanceOffset(1, false);
                if (peek(ln, parser.offset) === C_SPACE) {
                    parser.offset++;
                }
            } else {
                return 1;
            }
            return 0;
        },
        finalize: function() { return; },
        canContain: function(t) { return (t !== 'Item'); },
        acceptsLines: false
    },
    Item: {
        continue: function(parser, container) {
            if (parser.blank && container._firstChild !== null) {
                parser.advanceNextNonspace();
            } else if (parser.indent >=
                       container._listData.markerOffset +
                       container._listData.padding) {
                parser.advanceOffset(container._listData.markerOffset +
                    container._listData.padding, true);
            } else {
                return 1;
            }
            return 0;
        },
        finalize: function() { return; },
        canContain: function(t) { return (t !== 'Item'); },
        acceptsLines: false
    },
    Heading: {
        continue: function() {
            // a heading can never container > 1 line, so fail to match:
            return 1;
        },
        finalize: function() { return; },
        canContain: function() { return false; },
        acceptsLines: false
    },
    ThematicBreak: {
        continue: function() {
            // a thematic break can never container > 1 line, so fail to match:
            return 1;
        },
        finalize: function() { return; },
        canContain: function() { return false; },
        acceptsLines: false
    },
    CodeBlock: {
        continue: function(parser, container) {
            var ln = parser.currentLine;
            var indent = parser.indent;
            if (container._isFenced) { // fenced
                var match = (indent <= 3 &&
                    ln.charAt(parser.nextNonspace) === container._fenceChar &&
                    ln.slice(parser.nextNonspace).match(reClosingCodeFence));
                if (match && match[0].length >= container._fenceLength) {
                    // closing fence - we're at end of line, so we can return
                    parser.finalize(container, parser.lineNumber);
                    return 2;
                } else {
                    // skip optional spaces of fence offset
                    var i = container._fenceOffset;
                    while (i > 0 && peek(ln, parser.offset) === C_SPACE) {
                        parser.advanceOffset(1, false);
                        i--;
                    }
                }
            } else { // indented
                if (indent >= CODE_INDENT) {
                    parser.advanceOffset(CODE_INDENT, true);
                } else if (parser.blank) {
                    parser.advanceNextNonspace();
                } else {
                    return 1;
                }
            }
            return 0;
        },
        finalize: function(parser, block) {
            if (block._isFenced) { // fenced
                // first line becomes info string
                var content = block._string_content;
                var newlinePos = content.indexOf('\n');
                var firstLine = content.slice(0, newlinePos);
                var rest = content.slice(newlinePos + 1);
                block.info = unescapeString(firstLine.trim());
                block._literal = rest;
            } else { // indented
                block._literal = block._string_content.replace(/(\n *)+$/, '\n');
            }
            block._string_content = null; // allow GC
        },
        canContain: function() { return false; },
        acceptsLines: true
    },
    HtmlBlock: {
        continue: function(parser, container) {
            return ((parser.blank &&
                     (container._htmlBlockType === 6 ||
                      container._htmlBlockType === 7)) ? 1 : 0);
        },
        finalize: function(parser, block) {
            block._literal = block._string_content.replace(/(\n *)+$/, '');
            block._string_content = null; // allow GC
        },
        canContain: function() { return false; },
        acceptsLines: true
    },
    Paragraph: {
        continue: function(parser) {
            return (parser.blank ? 1 : 0);
        },
        finalize: function(parser, block) {
            var pos;
            var hasReferenceDefs = false;

            // try parsing the beginning as link reference definitions:
            while (peek(block._string_content, 0) === C_OPEN_BRACKET &&
                   (pos =
                    parser.inlineParser.parseReference(block._string_content,
                                                       parser.refmap))) {
                block._string_content = block._string_content.slice(pos);
                hasReferenceDefs = true;
            }
            if (hasReferenceDefs && isBlank(block._string_content)) {
                block.unlink();
            }
        },
        canContain: function() { return false; },
        acceptsLines: true
    }
};

// block start functions.  Return values:
// 0 = no match
// 1 = matched container, keep going
// 2 = matched leaf, no more block starts
var blockStarts = [
    // block quote
    function(parser) {
        if (!parser.indented &&
            peek(parser.currentLine, parser.nextNonspace) === C_GREATERTHAN) {
            parser.advanceNextNonspace();
            parser.advanceOffset(1, false);
            // optional following space
            if (peek(parser.currentLine, parser.offset) === C_SPACE) {
                parser.advanceOffset(1, false);
            }
            parser.closeUnmatchedBlocks();
            parser.addChild('BlockQuote', parser.nextNonspace);
            return 1;
        } else {
            return 0;
        }
    },

    // ATX heading
    function(parser) {
        var match;
        if (!parser.indented &&
            (match = parser.currentLine.slice(parser.nextNonspace).match(reATXHeadingMarker))) {
            parser.advanceNextNonspace();
            parser.advanceOffset(match[0].length, false);
            parser.closeUnmatchedBlocks();
            var container = parser.addChild('Heading', parser.nextNonspace);
            container.level = match[0].trim().length; // number of #s
            // remove trailing ###s:
            container._string_content =
                parser.currentLine.slice(parser.offset).replace(/^ *#+ *$/, '').replace(/ +#+ *$/, '');
            parser.advanceOffset(parser.currentLine.length - parser.offset);
            return 2;
        } else {
            return 0;
        }
    },

    // Fenced code block
    function(parser) {
        var match;
        if (!parser.indented &&
            (match = parser.currentLine.slice(parser.nextNonspace).match(reCodeFence))) {
            var fenceLength = match[0].length;
            parser.closeUnmatchedBlocks();
            var container = parser.addChild('CodeBlock', parser.nextNonspace);
            container._isFenced = true;
            container._fenceLength = fenceLength;
            container._fenceChar = match[0][0];
            container._fenceOffset = parser.indent;
            parser.advanceNextNonspace();
            parser.advanceOffset(fenceLength, false);
            return 2;
        } else {
            return 0;
        }
    },

    // HTML block
    function(parser, container) {
        if (!parser.indented &&
            peek(parser.currentLine, parser.nextNonspace) === C_LESSTHAN) {
            var s = parser.currentLine.slice(parser.nextNonspace);
            var blockType;

            for (blockType = 1; blockType <= 7; blockType++) {
                if (reHtmlBlockOpen[blockType].test(s) &&
                    (blockType < 7 ||
                     container.type !== 'Paragraph')) {
                    parser.closeUnmatchedBlocks();
                    // We don't adjust parser.offset;
                    // spaces are part of the HTML block:
                    var b = parser.addChild('HtmlBlock',
                                            parser.offset);
                    b._htmlBlockType = blockType;
                    return 2;
                }
            }
        }

        return 0;

    },

    // Setext heading
    function(parser, container) {
        var match;
        if (!parser.indented &&
            container.type === 'Paragraph' &&
                   ((match = parser.currentLine.slice(parser.nextNonspace).match(reSetextHeadingLine)))) {
            parser.closeUnmatchedBlocks();
            var heading = new Node('Heading', container.sourcepos);
            heading.level = match[0][0] === '=' ? 1 : 2;
            heading._string_content = container._string_content;
            container.insertAfter(heading);
            container.unlink();
            parser.tip = heading;
            parser.advanceOffset(parser.currentLine.length - parser.offset, false);
            return 2;
        } else {
            return 0;
        }
    },

    // thematic break
    function(parser) {
        if (!parser.indented &&
            reThematicBreak.test(parser.currentLine.slice(parser.nextNonspace))) {
            parser.closeUnmatchedBlocks();
            parser.addChild('ThematicBreak', parser.nextNonspace);
            parser.advanceOffset(parser.currentLine.length - parser.offset, false);
            return 2;
        } else {
            return 0;
        }
    },

    // list item
    function(parser, container) {
        var data;

        if ((!parser.indented || container.type === 'List')
                && (data = parseListMarker(parser))) {
            parser.closeUnmatchedBlocks();

            // add the list if needed
            if (parser.tip.type !== 'List' ||
                !(listsMatch(container._listData, data))) {
                container = parser.addChild('List', parser.nextNonspace);
                container._listData = data;
            }

            // add the list item
            container = parser.addChild('Item', parser.nextNonspace);
            container._listData = data;
            return 1;
        } else {
            return 0;
        }
    },

    // indented code block
    function(parser) {
        if (parser.indented &&
            parser.tip.type !== 'Paragraph' &&
            !parser.blank) {
            // indented code
            parser.advanceOffset(CODE_INDENT, true);
            parser.closeUnmatchedBlocks();
            parser.addChild('CodeBlock', parser.offset);
            return 2;
        } else {
            return 0;
        }
     }

];

var advanceOffset = function(count, columns) {
    var cols = 0;
    var currentLine = this.currentLine;
    var charsToTab;
    var c;
    while (count > 0 && (c = currentLine[this.offset])) {
        if (c === '\t') {
            charsToTab = 4 - (this.column % 4);
            this.column += charsToTab;
            this.offset += 1;
            count -= (columns ? charsToTab : 1);
        } else {
            cols += 1;
            this.offset += 1;
            this.column += 1; // assume ascii; block starts are ascii
            count -= 1;
        }
    }
};

var advanceNextNonspace = function() {
    this.offset = this.nextNonspace;
    this.column = this.nextNonspaceColumn;
};

var findNextNonspace = function() {
    var currentLine = this.currentLine;
    var i = this.offset;
    var cols = this.column;
    var c;

    while ((c = currentLine.charAt(i)) !== '') {
        if (c === ' ') {
            i++;
            cols++;
        } else if (c === '\t') {
            i++;
            cols += (4 - (cols % 4));
        } else {
            break;
        }
    }
    this.blank = (c === '\n' || c === '\r' || c === '');
    this.nextNonspace = i;
    this.nextNonspaceColumn = cols;
    this.indent = this.nextNonspaceColumn - this.column;
    this.indented = this.indent >= CODE_INDENT;
};

// Analyze a line of text and update the document appropriately.
// We parse markdown text by calling this on each line of input,
// then finalizing the document.
var incorporateLine = function(ln) {
    var all_matched = true;
    var t;

    var container = this.doc;
    this.oldtip = this.tip;
    this.offset = 0;
    this.column = 0;
    this.lineNumber += 1;

    // replace NUL characters for security
    if (ln.indexOf('\u0000') !== -1) {
        ln = ln.replace(/\0/g, '\uFFFD');
    }

    this.currentLine = ln;

    // For each containing block, try to parse the associated line start.
    // Bail out on failure: container will point to the last matching block.
    // Set all_matched to false if not all containers match.
    var lastChild;
    while ((lastChild = container._lastChild) && lastChild._open) {
        container = lastChild;

        this.findNextNonspace();

        switch (this.blocks[container.type].continue(this, container)) {
        case 0: // we've matched, keep going
            break;
        case 1: // we've failed to match a block
            all_matched = false;
            break;
        case 2: // we've hit end of line for fenced code close and can return
            this.lastLineLength = ln.length;
            return;
        default:
            throw 'continue returned illegal value, must be 0, 1, or 2';
        }
        if (!all_matched) {
            container = container._parent; // back up to last matching block
            break;
        }
    }

    this.allClosed = (container === this.oldtip);
    this.lastMatchedContainer = container;

    // Check to see if we've hit 2nd blank line; if so break out of list:
    if (this.blank && container._lastLineBlank) {
        this.breakOutOfLists(container);
        container = this.tip;
    }

    var matchedLeaf = container.type !== 'Paragraph' &&
            blocks[container.type].acceptsLines;
    var starts = this.blockStarts;
    var startsLen = starts.length;
    // Unless last matched container is a code block, try new container starts,
    // adding children to the last matched container:
    while (!matchedLeaf) {

        this.findNextNonspace();

        // this is a little performance optimization:
        if (!this.indented &&
            !reMaybeSpecial.test(ln.slice(this.nextNonspace))) {
            this.advanceNextNonspace();
            break;
        }

        var i = 0;
        while (i < startsLen) {
            var res = starts[i](this, container);
            if (res === 1) {
                container = this.tip;
                break;
            } else if (res === 2) {
                container = this.tip;
                matchedLeaf = true;
                break;
            } else {
                i++;
            }
        }

        if (i === startsLen) { // nothing matched
            this.advanceNextNonspace();
            break;
        }
    }

    // What remains at the offset is a text line.  Add the text to the
    // appropriate container.

   // First check for a lazy paragraph continuation:
    if (!this.allClosed && !this.blank &&
        this.tip.type === 'Paragraph') {
        // lazy paragraph continuation
        this.addLine();

    } else { // not a lazy continuation

        // finalize any blocks not matched
        this.closeUnmatchedBlocks();
        if (this.blank && container.lastChild) {
            container.lastChild._lastLineBlank = true;
        }

        t = container.type;

        // Block quote lines are never blank as they start with >
        // and we don't count blanks in fenced code for purposes of tight/loose
        // lists or breaking out of lists.  We also don't set _lastLineBlank
        // on an empty list item, or if we just closed a fenced block.
        var lastLineBlank = this.blank &&
            !(t === 'BlockQuote' ||
              (t === 'CodeBlock' && container._isFenced) ||
              (t === 'Item' &&
               !container._firstChild &&
               container.sourcepos[0][0] === this.lineNumber));

        // propagate lastLineBlank up through parents:
        var cont = container;
        while (cont) {
            cont._lastLineBlank = lastLineBlank;
            cont = cont._parent;
        }

        if (this.blocks[t].acceptsLines) {
            this.addLine();
            // if HtmlBlock, check for end condition
            if (t === 'HtmlBlock' &&
                container._htmlBlockType >= 1 &&
                container._htmlBlockType <= 5 &&
                reHtmlBlockClose[container._htmlBlockType].test(this.currentLine.slice(this.offset))) {
                this.finalize(container, this.lineNumber);
            }

        } else if (this.offset < ln.length && !this.blank) {
            // create paragraph container for line
            container = this.addChild('Paragraph', this.offset);
            this.advanceNextNonspace();
            this.addLine();
        }
    }
    this.lastLineLength = ln.length;
};

// Finalize a block.  Close it and do any necessary postprocessing,
// e.g. creating string_content from strings, setting the 'tight'
// or 'loose' status of a list, and parsing the beginnings
// of paragraphs for reference definitions.  Reset the tip to the
// parent of the closed block.
var finalize = function(block, lineNumber) {
    var above = block._parent;
    block._open = false;
    block.sourcepos[1] = [lineNumber, this.lastLineLength];

    this.blocks[block.type].finalize(this, block);

    this.tip = above;
};

// Walk through a block & children recursively, parsing string content
// into inline content where appropriate.
var processInlines = function(block) {
    var node, event, t;
    var walker = block.walker();
    this.inlineParser.refmap = this.refmap;
    this.inlineParser.options = this.options;
    while ((event = walker.next())) {
        node = event.node;
        t = node.type;
        if (!event.entering && (t === 'Paragraph' || t === 'Heading')) {
            this.inlineParser.parse(node);
        }
    }
};

var Document = function() {
    var doc = new Node('Document', [[1, 1], [0, 0]]);
    return doc;
};

// The main parsing function.  Returns a parsed document AST.
var parse = function(input) {
    this.doc = new Document();
    this.tip = this.doc;
    this.refmap = {};
    this.lineNumber = 0;
    this.lastLineLength = 0;
    this.offset = 0;
    this.column = 0;
    this.lastMatchedContainer = this.doc;
    this.currentLine = "";
    if (this.options.time) { console.time("preparing input"); }
    var lines = input.split(reLineEnding);
    var len = lines.length;
    if (input.charCodeAt(input.length - 1) === C_NEWLINE) {
        // ignore last blank line created by final newline
        len -= 1;
    }
    if (this.options.time) { console.timeEnd("preparing input"); }
    if (this.options.time) { console.time("block parsing"); }
    for (var i = 0; i < len; i++) {
        this.incorporateLine(lines[i]);
    }
    while (this.tip) {
        this.finalize(this.tip, len);
    }
    if (this.options.time) { console.timeEnd("block parsing"); }
    if (this.options.time) { console.time("inline parsing"); }
    this.processInlines(this.doc);
    if (this.options.time) { console.timeEnd("inline parsing"); }
    return this.doc;
};


// The Parser object.
function Parser(options){
    return {
        doc: new Document(),
        blocks: blocks,
        blockStarts: blockStarts,
        tip: this.doc,
        oldtip: this.doc,
        currentLine: "",
        lineNumber: 0,
        offset: 0,
        column: 0,
        nextNonspace: 0,
        nextNonspaceColumn: 0,
        indent: 0,
        indented: false,
        blank: false,
        allClosed: true,
        lastMatchedContainer: this.doc,
        refmap: {},
        lastLineLength: 0,
        inlineParser: new InlineParser(options),
        findNextNonspace: findNextNonspace,
        advanceOffset: advanceOffset,
        advanceNextNonspace: advanceNextNonspace,
        breakOutOfLists: breakOutOfLists,
        addLine: addLine,
        addChild: addChild,
        incorporateLine: incorporateLine,
        finalize: finalize,
        processInlines: processInlines,
        closeUnmatchedBlocks: closeUnmatchedBlocks,
        parse: parse,
        options: options || {}
    };
}

module.exports = Parser;


/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

var inverseXML = getInverseObj(__webpack_require__(625)),
    xmlReplacer = getInverseReplacer(inverseXML);

exports.XML = getInverse(inverseXML, xmlReplacer);

var inverseHTML = getInverseObj(__webpack_require__(369)),
    htmlReplacer = getInverseReplacer(inverseHTML);

exports.HTML = getInverse(inverseHTML, htmlReplacer);

function getInverseObj(obj){
	return Object.keys(obj).sort().reduce(function(inverse, name){
		inverse[obj[name]] = "&" + name + ";";
		return inverse;
	}, {});
}

function getInverseReplacer(inverse){
	var single = [],
	    multiple = [];

	Object.keys(inverse).forEach(function(k){
		if(k.length === 1){
			single.push("\\" + k);
		} else {
			multiple.push(k);
		}
	});

	//TODO add ranges
	multiple.unshift("[" + single.join("") + "]");

	return new RegExp(multiple.join("|"), "g");
}

var re_nonASCII = /[^\0-\x7F]/g,
    re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;

function singleCharReplacer(c){
	return "&#x" + c.charCodeAt(0).toString(16).toUpperCase() + ";";
}

function astralReplacer(c){
	// http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	var high = c.charCodeAt(0);
	var low  = c.charCodeAt(1);
	var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
	return "&#x" + codePoint.toString(16).toUpperCase() + ";";
}

function getInverse(inverse, re){
	function func(name){
		return inverse[name];
	}

	return function(data){
		return data
				.replace(re, func)
				.replace(re_astralSymbols, astralReplacer)
				.replace(re_nonASCII, singleCharReplacer);
	};
}

var re_xmlChars = getInverseReplacer(inverseXML);

function escapeXML(data){
	return data
			.replace(re_xmlChars, singleCharReplacer)
			.replace(re_astralSymbols, astralReplacer)
			.replace(re_nonASCII, singleCharReplacer);
}

exports.escape = escapeXML;


/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

var entityMap = __webpack_require__(369),
    legacyMap = __webpack_require__(1569),
    xmlMap    = __webpack_require__(625),
    decodeCodePoint = __webpack_require__(1570);

var decodeXMLStrict  = getStrictDecoder(xmlMap),
    decodeHTMLStrict = getStrictDecoder(entityMap);

function getStrictDecoder(map){
	var keys = Object.keys(map).join("|"),
	    replace = getReplacer(map);

	keys += "|#[xX][\\da-fA-F]+|#\\d+";

	var re = new RegExp("&(?:" + keys + ");", "g");

	return function(str){
		return String(str).replace(re, replace);
	};
}

var decodeHTML = (function(){
	var legacy = Object.keys(legacyMap)
		.sort(sorter);

	var keys = Object.keys(entityMap)
		.sort(sorter);

	for(var i = 0, j = 0; i < keys.length; i++){
		if(legacy[j] === keys[i]){
			keys[i] += ";?";
			j++;
		} else {
			keys[i] += ";";
		}
	}

	var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
	    replace = getReplacer(entityMap);

	function replacer(str){
		if(str.substr(-1) !== ";") str += ";";
		return replace(str);
	}

	//TODO consider creating a merged map
	return function(str){
		return String(str).replace(re, replacer);
	};
}());

function sorter(a, b){
	return a < b ? 1 : -1;
}

function getReplacer(map){
	return function replace(str){
		if(str.charAt(1) === "#"){
			if(str.charAt(2) === "X" || str.charAt(2) === "x"){
				return decodeCodePoint(parseInt(str.substr(3), 16));
			}
			return decodeCodePoint(parseInt(str.substr(2), 10));
		}
		return map[str.slice(1, -1)];
	};
}

module.exports = {
	XML: decodeXMLStrict,
	HTML: decodeHTML,
	HTMLStrict: decodeHTMLStrict
};

/***/ }),
/* 1569 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

var decodeMap = __webpack_require__(1571);

module.exports = decodeCodePoint;

// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint){

	if((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF){
		return "\uFFFD";
	}

	if(codePoint in decodeMap){
		codePoint = decodeMap[codePoint];
	}

	var output = "";

	if(codePoint > 0xFFFF){
		codePoint -= 0x10000;
		output += String.fromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
		codePoint = 0xDC00 | codePoint & 0x3FF;
	}

	output += String.fromCharCode(codePoint);
	return output;
}


/***/ }),
/* 1571 */
/***/ (function(module, exports) {

module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Node = __webpack_require__(368);
var common = __webpack_require__(154);
var normalizeReference = __webpack_require__(1573);

var normalizeURI = common.normalizeURI;
var unescapeString = common.unescapeString;
var fromCodePoint = __webpack_require__(1574);
var decodeHTML = __webpack_require__(624).decodeHTML;
__webpack_require__(1575); // Polyfill for String.prototype.repeat

// Constants for character codes:

var C_NEWLINE = 10;
var C_ASTERISK = 42;
var C_UNDERSCORE = 95;
var C_BACKTICK = 96;
var C_OPEN_BRACKET = 91;
var C_CLOSE_BRACKET = 93;
var C_LESSTHAN = 60;
var C_BANG = 33;
var C_BACKSLASH = 92;
var C_AMPERSAND = 38;
var C_OPEN_PAREN = 40;
var C_CLOSE_PAREN = 41;
var C_COLON = 58;
var C_SINGLEQUOTE = 39;
var C_DOUBLEQUOTE = 34;

// Some regexps used in inline parser:

var ESCAPABLE = common.ESCAPABLE;
var ESCAPED_CHAR = '\\\\' + ESCAPABLE;
var REG_CHAR = '[^\\\\()\\x00-\\x20]';
var IN_PARENS_NOSP = '\\((' + REG_CHAR + '|' + ESCAPED_CHAR + '|\\\\)*\\)';

var ENTITY = common.ENTITY;
var reHtmlTag = common.reHtmlTag;

var rePunctuation = new RegExp(/^[\u2000-\u206F\u2E00-\u2E7F\\'!"#\$%&\(\)\*\+,\-\.\/:;<=>\?@\[\]\^_`\{\|\}~]/);

var reLinkTitle = new RegExp(
    '^(?:"(' + ESCAPED_CHAR + '|[^"\\x00])*"' +
        '|' +
        '\'(' + ESCAPED_CHAR + '|[^\'\\x00])*\'' +
        '|' +
        '\\((' + ESCAPED_CHAR + '|[^)\\x00])*\\))');

var reLinkDestinationBraces = new RegExp(
    '^(?:[<](?:[^ <>\\t\\n\\\\\\x00]' + '|' + ESCAPED_CHAR + '|' + '\\\\)*[>])');

var reLinkDestination = new RegExp(
    '^(?:' + REG_CHAR + '+|' + ESCAPED_CHAR + '|\\\\|' + IN_PARENS_NOSP + ')*');

var reEscapable = new RegExp('^' + ESCAPABLE);

var reEntityHere = new RegExp('^' + ENTITY, 'i');

var reTicks = /`+/;

var reTicksHere = /^`+/;

var reEllipses = /\.\.\./g;

var reDash = /--+/g;

var reEmailAutolink = /^<([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)>/;

var reAutolink = /^<[A-Za-z][A-Za-z0-9.+-]{1,31}:[^<>\x00-\x20]*>/i;

var reSpnl = /^ *(?:\n *)?/;

var reWhitespaceChar = /^\s/;

var reWhitespace = /\s+/g;

var reFinalSpace = / *$/;

var reInitialSpace = /^ */;

var reSpaceAtEndOfLine = /^ *(?:\n|$)/;

var reLinkLabel = new RegExp('^\\[(?:[^\\\\\\[\\]]|' + ESCAPED_CHAR +
  '|\\\\){0,1000}\\]');

// Matches a string of non-special characters.
var reMain = /^[^\n`\[\]\\!<&*_'"]+/m;

var text = function(s) {
    var node = new Node('Text');
    node._literal = s;
    return node;
};

// INLINE PARSER

// These are methods of an InlineParser object, defined below.
// An InlineParser keeps track of a subject (a string to be
// parsed) and a position in that subject.

// If re matches at current position in the subject, advance
// position in subject and return the match; otherwise return null.
var match = function(re) {
    var m = re.exec(this.subject.slice(this.pos));
    if (m === null) {
        return null;
    } else {
        this.pos += m.index + m[0].length;
        return m[0];
    }
};

// Returns the code for the character at the current subject position, or -1
// there are no more characters.
var peek = function() {
    if (this.pos < this.subject.length) {
        return this.subject.charCodeAt(this.pos);
    } else {
        return -1;
    }
};

// Parse zero or more space characters, including at most one newline
var spnl = function() {
    this.match(reSpnl);
    return true;
};

// All of the parsers below try to match something at the current position
// in the subject.  If they succeed in matching anything, they
// return the inline matched, advancing the subject.

// Attempt to parse backticks, adding either a backtick code span or a
// literal sequence of backticks.
var parseBackticks = function(block) {
    var ticks = this.match(reTicksHere);
    if (ticks === null) {
        return false;
    }
    var afterOpenTicks = this.pos;
    var matched;
    var node;
    while ((matched = this.match(reTicks)) !== null) {
        if (matched === ticks) {
            node = new Node('Code');
            node._literal = this.subject.slice(afterOpenTicks,
                                        this.pos - ticks.length)
                          .trim().replace(reWhitespace, ' ');
            block.appendChild(node);
            return true;
        }
    }
    // If we got here, we didn't match a closing backtick sequence.
    this.pos = afterOpenTicks;
    block.appendChild(text(ticks));
    return true;
};

// Parse a backslash-escaped special character, adding either the escaped
// character, a hard line break (if the backslash is followed by a newline),
// or a literal backslash to the block's children.  Assumes current character
// is a backslash.
var parseBackslash = function(block) {
    var subj = this.subject;
    var node;
    this.pos += 1;
    if (this.peek() === C_NEWLINE) {
        this.pos += 1;
        node = new Node('Hardbreak');
        block.appendChild(node);
    } else if (reEscapable.test(subj.charAt(this.pos))) {
        block.appendChild(text(subj.charAt(this.pos)));
        this.pos += 1;
    } else {
        block.appendChild(text('\\'));
    }
    return true;
};

// Attempt to parse an autolink (URL or email in pointy brackets).
var parseAutolink = function(block) {
    var m;
    var dest;
    var node;
    if ((m = this.match(reEmailAutolink))) {
        dest = m.slice(1, m.length - 1);
        node = new Node('Link');
        node._destination = normalizeURI('mailto:' + dest);
        node._title = '';
        node.appendChild(text(dest));
        block.appendChild(node);
        return true;
    } else if ((m = this.match(reAutolink))) {
        dest = m.slice(1, m.length - 1);
        node = new Node('Link');
        node._destination = normalizeURI(dest);
        node._title = '';
        node.appendChild(text(dest));
        block.appendChild(node);
        return true;
    } else {
        return false;
    }
};

// Attempt to parse a raw HTML tag.
var parseHtmlTag = function(block) {
    var m = this.match(reHtmlTag);
    if (m === null) {
        return false;
    } else {
        var node = new Node('HtmlInline');
        node._literal = m;
        block.appendChild(node);
        return true;
    }
};

// Scan a sequence of characters with code cc, and return information about
// the number of delimiters and whether they are positioned such that
// they can open and/or close emphasis or strong emphasis.  A utility
// function for strong/emph parsing.
var scanDelims = function(cc) {
    var numdelims = 0;
    var char_before, char_after, cc_after;
    var startpos = this.pos;
    var left_flanking, right_flanking, can_open, can_close;
    var after_is_whitespace, after_is_punctuation, before_is_whitespace, before_is_punctuation;

    if (cc === C_SINGLEQUOTE || cc === C_DOUBLEQUOTE) {
        numdelims++;
        this.pos++;
    } else {
        while (this.peek() === cc) {
            numdelims++;
            this.pos++;
        }
    }

    if (numdelims === 0) {
        return null;
    }

    char_before = startpos === 0 ? '\n' : this.subject.charAt(startpos - 1);

    cc_after = this.peek();
    if (cc_after === -1) {
        char_after = '\n';
    } else {
        char_after = fromCodePoint(cc_after);
    }

    after_is_whitespace = reWhitespaceChar.test(char_after);
    after_is_punctuation = rePunctuation.test(char_after);
    before_is_whitespace = reWhitespaceChar.test(char_before);
    before_is_punctuation = rePunctuation.test(char_before);

    left_flanking = !after_is_whitespace &&
            !(after_is_punctuation && !before_is_whitespace && !before_is_punctuation);
    right_flanking = !before_is_whitespace &&
            !(before_is_punctuation && !after_is_whitespace && !after_is_punctuation);
    if (cc === C_UNDERSCORE) {
        can_open = left_flanking &&
            (!right_flanking || before_is_punctuation);
        can_close = right_flanking &&
            (!left_flanking || after_is_punctuation);
    } else if (cc === C_SINGLEQUOTE || cc === C_DOUBLEQUOTE) {
        can_open = left_flanking && !right_flanking;
        can_close = right_flanking;
    } else {
        can_open = left_flanking;
        can_close = right_flanking;
    }
    this.pos = startpos;
    return { numdelims: numdelims,
             can_open: can_open,
             can_close: can_close };
};

// Handle a delimiter marker for emphasis or a quote.
var handleDelim = function(cc, block) {
    var res = this.scanDelims(cc);
    if (!res) {
        return false;
    }
    var numdelims = res.numdelims;
    var startpos = this.pos;
    var contents;

    this.pos += numdelims;
    if (cc === C_SINGLEQUOTE) {
        contents = "\u2019";
    } else if (cc === C_DOUBLEQUOTE) {
        contents = "\u201C";
    } else {
        contents = this.subject.slice(startpos, this.pos);
    }
    var node = text(contents);
    block.appendChild(node);

    // Add entry to stack for this opener
    this.delimiters = { cc: cc,
                        numdelims: numdelims,
                        node: node,
                        previous: this.delimiters,
                        next: null,
                        can_open: res.can_open,
                        can_close: res.can_close,
                        active: true };
    if (this.delimiters.previous !== null) {
        this.delimiters.previous.next = this.delimiters;
    }

    return true;

};

var removeDelimiter = function(delim) {
    if (delim.previous !== null) {
        delim.previous.next = delim.next;
    }
    if (delim.next === null) {
        // top of stack
        this.delimiters = delim.previous;
    } else {
        delim.next.previous = delim.previous;
    }
};

var removeDelimitersBetween = function(bottom, top) {
    if (bottom.next !== top) {
        bottom.next = top;
        top.previous = bottom;
    }
};

var processEmphasis = function(stack_bottom) {
    var opener, closer, old_closer;
    var opener_inl, closer_inl;
    var tempstack;
    var use_delims;
    var tmp, next;
    var opener_found;
    var openers_bottom = [];

    openers_bottom[C_UNDERSCORE] = stack_bottom;
    openers_bottom[C_ASTERISK] = stack_bottom;
    openers_bottom[C_SINGLEQUOTE] = stack_bottom;
    openers_bottom[C_DOUBLEQUOTE] = stack_bottom;

    // find first closer above stack_bottom:
    closer = this.delimiters;
    while (closer !== null && closer.previous !== stack_bottom) {
        closer = closer.previous;
    }
    // move forward, looking for closers, and handling each
    while (closer !== null) {
        var closercc = closer.cc;
        if (!(closer.can_close && (closercc === C_UNDERSCORE ||
                                   closercc === C_ASTERISK ||
                                   closercc === C_SINGLEQUOTE ||
                                   closercc === C_DOUBLEQUOTE))) {
            closer = closer.next;
        } else {
            // found emphasis closer. now look back for first matching opener:
            opener = closer.previous;
            opener_found = false;
            while (opener !== null && opener !== stack_bottom &&
                   opener !== openers_bottom[closercc]) {
                if (opener.cc === closer.cc && opener.can_open) {
                    opener_found = true;
                    break;
                }
                opener = opener.previous;
            }
            old_closer = closer;

            if (closercc === C_ASTERISK || closercc === C_UNDERSCORE) {
                if (!opener_found) {
                    closer = closer.next;
                } else {
                    // calculate actual number of delimiters used from closer
                    if (closer.numdelims < 3 || opener.numdelims < 3) {
                        use_delims = closer.numdelims <= opener.numdelims ?
                            closer.numdelims : opener.numdelims;
                    } else {
                        use_delims = closer.numdelims % 2 === 0 ? 2 : 1;
                    }

                    opener_inl = opener.node;
                    closer_inl = closer.node;

                    // remove used delimiters from stack elts and inlines
                    opener.numdelims -= use_delims;
                    closer.numdelims -= use_delims;
                    opener_inl._literal =
                        opener_inl._literal.slice(0,
                                                  opener_inl._literal.length - use_delims);
                    closer_inl._literal =
                        closer_inl._literal.slice(0,
                                                  closer_inl._literal.length - use_delims);

                    // build contents for new emph element
                    var emph = new Node(use_delims === 1 ? 'Emph' : 'Strong');

                    tmp = opener_inl._next;
                    while (tmp && tmp !== closer_inl) {
                        next = tmp._next;
                        tmp.unlink();
                        emph.appendChild(tmp);
                        tmp = next;
                    }

                    opener_inl.insertAfter(emph);

                    // remove elts between opener and closer in delimiters stack
                    removeDelimitersBetween(opener, closer);

                    // if opener has 0 delims, remove it and the inline
                    if (opener.numdelims === 0) {
                        opener_inl.unlink();
                        this.removeDelimiter(opener);
                    }

                    if (closer.numdelims === 0) {
                        closer_inl.unlink();
                        tempstack = closer.next;
                        this.removeDelimiter(closer);
                        closer = tempstack;
                    }

                }

            } else if (closercc === C_SINGLEQUOTE) {
                closer.node._literal = "\u2019";
                if (opener_found) {
                    opener.node._literal = "\u2018";
                }
                closer = closer.next;

            } else if (closercc === C_DOUBLEQUOTE) {
                closer.node._literal = "\u201D";
                if (opener_found) {
                    opener.node.literal = "\u201C";
                }
                closer = closer.next;

            }
            if (!opener_found) {
                // Set lower bound for future searches for openers:
                openers_bottom[closercc] = old_closer.previous;
                if (!old_closer.can_open) {
                    // We can remove a closer that can't be an opener,
                    // once we've seen there's no matching opener:
                    this.removeDelimiter(old_closer);
                }
            }
        }

    }

    // remove all delimiters
    while (this.delimiters !== null && this.delimiters !== stack_bottom) {
        this.removeDelimiter(this.delimiters);
    }
};

// Attempt to parse link title (sans quotes), returning the string
// or null if no match.
var parseLinkTitle = function() {
    var title = this.match(reLinkTitle);
    if (title === null) {
        return null;
    } else {
        // chop off quotes from title and unescape:
        return unescapeString(title.substr(1, title.length - 2));
    }
};

// Attempt to parse link destination, returning the string or
// null if no match.
var parseLinkDestination = function() {
    var res = this.match(reLinkDestinationBraces);
    if (res === null) {
        res = this.match(reLinkDestination);
        if (res === null) {
            return null;
        } else {
            return normalizeURI(unescapeString(res));
        }
    } else {  // chop off surrounding <..>:
        return normalizeURI(unescapeString(res.substr(1, res.length - 2)));
    }
};

// Attempt to parse a link label, returning number of characters parsed.
var parseLinkLabel = function() {
    var m = this.match(reLinkLabel);
    if (m === null || m.length > 1001) {
        return 0;
    } else {
        return m.length;
    }
};

// Add open bracket to delimiter stack and add a text node to block's children.
var parseOpenBracket = function(block) {
    var startpos = this.pos;
    this.pos += 1;

    var node = text('[');
    block.appendChild(node);

    // Add entry to stack for this opener
    this.delimiters = { cc: C_OPEN_BRACKET,
                        numdelims: 1,
                        node: node,
                        previous: this.delimiters,
                        next: null,
                        can_open: true,
                        can_close: false,
                        index: startpos,
                        active: true };
    if (this.delimiters.previous !== null) {
        this.delimiters.previous.next = this.delimiters;
    }

    return true;

};

// IF next character is [, and ! delimiter to delimiter stack and
// add a text node to block's children.  Otherwise just add a text node.
var parseBang = function(block) {
    var startpos = this.pos;
    this.pos += 1;
    if (this.peek() === C_OPEN_BRACKET) {
        this.pos += 1;

        var node = text('![');
        block.appendChild(node);

        // Add entry to stack for this opener
        this.delimiters = { cc: C_BANG,
                            numdelims: 1,
                            node: node,
                            previous: this.delimiters,
                            next: null,
                            can_open: true,
                            can_close: false,
                            index: startpos + 1,
                            active: true };
        if (this.delimiters.previous !== null) {
            this.delimiters.previous.next = this.delimiters;
        }
    } else {
        block.appendChild(text('!'));
    }
    return true;
};

// Try to match close bracket against an opening in the delimiter
// stack.  Add either a link or image, or a plain [ character,
// to block's children.  If there is a matching delimiter,
// remove it from the delimiter stack.
var parseCloseBracket = function(block) {
    var startpos;
    var is_image;
    var dest;
    var title;
    var matched = false;
    var reflabel;
    var opener;

    this.pos += 1;
    startpos = this.pos;

    // look through stack of delimiters for a [ or ![
    opener = this.delimiters;

    while (opener !== null) {
        if (opener.cc === C_OPEN_BRACKET || opener.cc === C_BANG) {
            break;
        }
        opener = opener.previous;
    }

    if (opener === null) {
        // no matched opener, just return a literal
        block.appendChild(text(']'));
        return true;
    }

    if (!opener.active) {
        // no matched opener, just return a literal
        block.appendChild(text(']'));
        // take opener off emphasis stack
        this.removeDelimiter(opener);
        return true;
    }

    // If we got here, open is a potential opener
    is_image = opener.cc === C_BANG;

    // Check to see if we have a link/image

    // Inline link?
    if (this.peek() === C_OPEN_PAREN) {
        this.pos++;
        if (this.spnl() &&
            ((dest = this.parseLinkDestination()) !== null) &&
            this.spnl() &&
            // make sure there's a space before the title:
            (reWhitespaceChar.test(this.subject.charAt(this.pos - 1)) &&
             (title = this.parseLinkTitle()) || true) &&
            this.spnl() &&
            this.peek() === C_CLOSE_PAREN) {
            this.pos += 1;
            matched = true;
        }
    } else {

        // Next, see if there's a link label
        var savepos = this.pos;
        var beforelabel = this.pos;
        var n = this.parseLinkLabel();
        if (n === 0 || n === 2) {
            // empty or missing second label
            reflabel = this.subject.slice(opener.index, startpos);
        } else {
            reflabel = this.subject.slice(beforelabel, beforelabel + n);
        }
        if (n === 0) {
            // If shortcut reference link, rewind before spaces we skipped.
            this.pos = savepos;
        }

        // lookup rawlabel in refmap
        var link = this.refmap[normalizeReference(reflabel)];
        if (link) {
            dest = link.destination;
            title = link.title;
            matched = true;
        }
    }

    if (matched) {
        var node = new Node(is_image ? 'Image' : 'Link');
        node._destination = dest;
        node._title = title || '';

        var tmp, next;
        tmp = opener.node._next;
        while (tmp) {
            next = tmp._next;
            tmp.unlink();
            node.appendChild(tmp);
            tmp = next;
        }
        block.appendChild(node);
        this.processEmphasis(opener.previous);

        opener.node.unlink();

        // processEmphasis will remove this and later delimiters.
        // Now, for a link, we also deactivate earlier link openers.
        // (no links in links)
        if (!is_image) {
          opener = this.delimiters;
          while (opener !== null) {
            if (opener.cc === C_OPEN_BRACKET) {
                opener.active = false; // deactivate this opener
            }
            opener = opener.previous;
          }
        }

        return true;

    } else { // no match

        this.removeDelimiter(opener);  // remove this opener from stack
        this.pos = startpos;
        block.appendChild(text(']'));
        return true;
    }

};

// Attempt to parse an entity.
var parseEntity = function(block) {
    var m;
    if ((m = this.match(reEntityHere))) {
        block.appendChild(text(decodeHTML(m)));
        return true;
    } else {
        return false;
    }
};

// Parse a run of ordinary characters, or a single character with
// a special meaning in markdown, as a plain string.
var parseString = function(block) {
    var m;
    if ((m = this.match(reMain))) {
        if (this.options.smart) {
            block.appendChild(text(
                m.replace(reEllipses, "\u2026")
                    .replace(reDash, function(chars) {
                        var enCount = 0;
                        var emCount = 0;
                        if (chars.length % 3 === 0) { // If divisible by 3, use all em dashes
                            emCount = chars.length / 3;
                        } else if (chars.length % 2 === 0) { // If divisible by 2, use all en dashes
                            enCount = chars.length / 2;
                        } else if (chars.length % 3 === 2) { // If 2 extra dashes, use en dash for last 2; em dashes for rest
                            enCount = 1;
                            emCount = (chars.length - 2) / 3;
                        } else { // Use en dashes for last 4 hyphens; em dashes for rest
                            enCount = 2;
                            emCount = (chars.length - 4) / 3;
                        }
                        return "\u2014".repeat(emCount) + "\u2013".repeat(enCount);
                    })));
        } else {
            block.appendChild(text(m));
        }
        return true;
    } else {
        return false;
    }
};

// Parse a newline.  If it was preceded by two spaces, return a hard
// line break; otherwise a soft line break.
var parseNewline = function(block) {
    this.pos += 1; // assume we're at a \n
    // check previous node for trailing spaces
    var lastc = block._lastChild;
    if (lastc && lastc.type === 'Text' && lastc._literal[lastc._literal.length - 1] === ' ') {
        var hardbreak = lastc._literal[lastc._literal.length - 2] === ' ';
        lastc._literal = lastc._literal.replace(reFinalSpace, '');
        block.appendChild(new Node(hardbreak ? 'Hardbreak' : 'Softbreak'));
    } else {
        block.appendChild(new Node('Softbreak'));
    }
    this.match(reInitialSpace); // gobble leading spaces in next line
    return true;
};

// Attempt to parse a link reference, modifying refmap.
var parseReference = function(s, refmap) {
    this.subject = s;
    this.pos = 0;
    var rawlabel;
    var dest;
    var title;
    var matchChars;
    var startpos = this.pos;

    // label:
    matchChars = this.parseLinkLabel();
    if (matchChars === 0) {
        return 0;
    } else {
        rawlabel = this.subject.substr(0, matchChars);
    }

    // colon:
    if (this.peek() === C_COLON) {
        this.pos++;
    } else {
        this.pos = startpos;
        return 0;
    }

    //  link url
    this.spnl();

    dest = this.parseLinkDestination();
    if (dest === null || dest.length === 0) {
        this.pos = startpos;
        return 0;
    }

    var beforetitle = this.pos;
    this.spnl();
    title = this.parseLinkTitle();
    if (title === null) {
        title = '';
        // rewind before spaces
        this.pos = beforetitle;
    }

    // make sure we're at line end:
    var atLineEnd = true;
    if (this.match(reSpaceAtEndOfLine) === null) {
        if (title === '') {
            atLineEnd = false;
        } else {
            // the potential title we found is not at the line end,
            // but it could still be a legal link reference if we
            // discard the title
            title = '';
            // rewind before spaces
            this.pos = beforetitle;
            // and instead check if the link URL is at the line end
            atLineEnd = this.match(reSpaceAtEndOfLine) !== null;
        }
    }

    if (!atLineEnd) {
        this.pos = startpos;
        return 0;
    }

    var normlabel = normalizeReference(rawlabel);
    if (normlabel === '') {
        // label must contain non-whitespace characters
        this.pos = startpos;
        return 0;
    }

    if (!refmap[normlabel]) {
        refmap[normlabel] = { destination: dest, title: title };
    }
    return this.pos - startpos;
};

// Parse the next inline element in subject, advancing subject position.
// On success, add the result to block's children and return true.
// On failure, return false.
var parseInline = function(block) {
    var res = false;
    var c = this.peek();
    if (c === -1) {
        return false;
    }
    switch(c) {
    case C_NEWLINE:
        res = this.parseNewline(block);
        break;
    case C_BACKSLASH:
        res = this.parseBackslash(block);
        break;
    case C_BACKTICK:
        res = this.parseBackticks(block);
        break;
    case C_ASTERISK:
    case C_UNDERSCORE:
        res = this.handleDelim(c, block);
        break;
    case C_SINGLEQUOTE:
    case C_DOUBLEQUOTE:
        res = this.options.smart && this.handleDelim(c, block);
        break;
    case C_OPEN_BRACKET:
        res = this.parseOpenBracket(block);
        break;
    case C_BANG:
        res = this.parseBang(block);
        break;
    case C_CLOSE_BRACKET:
        res = this.parseCloseBracket(block);
        break;
    case C_LESSTHAN:
        res = this.parseAutolink(block) || this.parseHtmlTag(block);
        break;
    case C_AMPERSAND:
        res = this.parseEntity(block);
        break;
    default:
        res = this.parseString(block);
        break;
    }
    if (!res) {
        this.pos += 1;
        block.appendChild(text(fromCodePoint(c)));
    }

    return true;
};

// Parse string content in block into inline children,
// using refmap to resolve references.
var parseInlines = function(block) {
    this.subject = block._string_content.trim();
    this.pos = 0;
    this.delimiters = null;
    while (this.parseInline(block)) {
    }
    block._string_content = null; // allow raw string to be garbage collected
    this.processEmphasis(null);
};

// The InlineParser object.
function InlineParser(options){
    return {
        subject: '',
        delimiters: null,  // used by handleDelim method
        pos: 0,
        refmap: {},
        match: match,
        peek: peek,
        spnl: spnl,
        parseBackticks: parseBackticks,
        parseBackslash: parseBackslash,
        parseAutolink: parseAutolink,
        parseHtmlTag: parseHtmlTag,
        scanDelims: scanDelims,
        handleDelim: handleDelim,
        parseLinkTitle: parseLinkTitle,
        parseLinkDestination: parseLinkDestination,
        parseLinkLabel: parseLinkLabel,
        parseOpenBracket: parseOpenBracket,
        parseCloseBracket: parseCloseBracket,
        parseBang: parseBang,
        parseEntity: parseEntity,
        parseString: parseString,
        parseNewline: parseNewline,
        parseReference: parseReference,
        parseInline: parseInline,
        processEmphasis: processEmphasis,
        removeDelimiter: removeDelimiter,
        options: options || {},
        parse: parseInlines
    };
}

module.exports = InlineParser;


/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* The bulk of this code derives from https://github.com/dmoscrop/fold-case
But in addition to case-folding, we also normalize whitespace.

fold-case is Copyright Mathias Bynens <https://mathiasbynens.be/>

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

/*eslint-disable  key-spacing, comma-spacing */

var regex = /[ \t\r\n]+|[A-Z\xB5\xC0-\xD6\xD8-\xDF\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u0149\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u017F\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C5\u01C7\u01C8\u01CA\u01CB\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F0-\u01F2\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0345\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03AB\u03B0\u03C2\u03CF-\u03D1\u03D5\u03D6\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F0\u03F1\u03F4\u03F5\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u0587\u10A0-\u10C5\u10C7\u10CD\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E96-\u1E9B\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F50\u1F52\u1F54\u1F56\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1F80-\u1FAF\u1FB2-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD2\u1FD3\u1FD6-\u1FDB\u1FE2-\u1FE4\u1FE6-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2126\u212A\u212B\u2132\u2160-\u216F\u2183\u24B6-\u24CF\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0\uA7B1\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A]|\uD801[\uDC00-\uDC27]|\uD806[\uDCA0-\uDCBF]/g;

var map = {'A':'a','B':'b','C':'c','D':'d','E':'e','F':'f','G':'g','H':'h','I':'i','J':'j','K':'k','L':'l','M':'m','N':'n','O':'o','P':'p','Q':'q','R':'r','S':'s','T':'t','U':'u','V':'v','W':'w','X':'x','Y':'y','Z':'z','\xB5':'\u03BC','\xC0':'\xE0','\xC1':'\xE1','\xC2':'\xE2','\xC3':'\xE3','\xC4':'\xE4','\xC5':'\xE5','\xC6':'\xE6','\xC7':'\xE7','\xC8':'\xE8','\xC9':'\xE9','\xCA':'\xEA','\xCB':'\xEB','\xCC':'\xEC','\xCD':'\xED','\xCE':'\xEE','\xCF':'\xEF','\xD0':'\xF0','\xD1':'\xF1','\xD2':'\xF2','\xD3':'\xF3','\xD4':'\xF4','\xD5':'\xF5','\xD6':'\xF6','\xD8':'\xF8','\xD9':'\xF9','\xDA':'\xFA','\xDB':'\xFB','\xDC':'\xFC','\xDD':'\xFD','\xDE':'\xFE','\u0100':'\u0101','\u0102':'\u0103','\u0104':'\u0105','\u0106':'\u0107','\u0108':'\u0109','\u010A':'\u010B','\u010C':'\u010D','\u010E':'\u010F','\u0110':'\u0111','\u0112':'\u0113','\u0114':'\u0115','\u0116':'\u0117','\u0118':'\u0119','\u011A':'\u011B','\u011C':'\u011D','\u011E':'\u011F','\u0120':'\u0121','\u0122':'\u0123','\u0124':'\u0125','\u0126':'\u0127','\u0128':'\u0129','\u012A':'\u012B','\u012C':'\u012D','\u012E':'\u012F','\u0132':'\u0133','\u0134':'\u0135','\u0136':'\u0137','\u0139':'\u013A','\u013B':'\u013C','\u013D':'\u013E','\u013F':'\u0140','\u0141':'\u0142','\u0143':'\u0144','\u0145':'\u0146','\u0147':'\u0148','\u014A':'\u014B','\u014C':'\u014D','\u014E':'\u014F','\u0150':'\u0151','\u0152':'\u0153','\u0154':'\u0155','\u0156':'\u0157','\u0158':'\u0159','\u015A':'\u015B','\u015C':'\u015D','\u015E':'\u015F','\u0160':'\u0161','\u0162':'\u0163','\u0164':'\u0165','\u0166':'\u0167','\u0168':'\u0169','\u016A':'\u016B','\u016C':'\u016D','\u016E':'\u016F','\u0170':'\u0171','\u0172':'\u0173','\u0174':'\u0175','\u0176':'\u0177','\u0178':'\xFF','\u0179':'\u017A','\u017B':'\u017C','\u017D':'\u017E','\u017F':'s','\u0181':'\u0253','\u0182':'\u0183','\u0184':'\u0185','\u0186':'\u0254','\u0187':'\u0188','\u0189':'\u0256','\u018A':'\u0257','\u018B':'\u018C','\u018E':'\u01DD','\u018F':'\u0259','\u0190':'\u025B','\u0191':'\u0192','\u0193':'\u0260','\u0194':'\u0263','\u0196':'\u0269','\u0197':'\u0268','\u0198':'\u0199','\u019C':'\u026F','\u019D':'\u0272','\u019F':'\u0275','\u01A0':'\u01A1','\u01A2':'\u01A3','\u01A4':'\u01A5','\u01A6':'\u0280','\u01A7':'\u01A8','\u01A9':'\u0283','\u01AC':'\u01AD','\u01AE':'\u0288','\u01AF':'\u01B0','\u01B1':'\u028A','\u01B2':'\u028B','\u01B3':'\u01B4','\u01B5':'\u01B6','\u01B7':'\u0292','\u01B8':'\u01B9','\u01BC':'\u01BD','\u01C4':'\u01C6','\u01C5':'\u01C6','\u01C7':'\u01C9','\u01C8':'\u01C9','\u01CA':'\u01CC','\u01CB':'\u01CC','\u01CD':'\u01CE','\u01CF':'\u01D0','\u01D1':'\u01D2','\u01D3':'\u01D4','\u01D5':'\u01D6','\u01D7':'\u01D8','\u01D9':'\u01DA','\u01DB':'\u01DC','\u01DE':'\u01DF','\u01E0':'\u01E1','\u01E2':'\u01E3','\u01E4':'\u01E5','\u01E6':'\u01E7','\u01E8':'\u01E9','\u01EA':'\u01EB','\u01EC':'\u01ED','\u01EE':'\u01EF','\u01F1':'\u01F3','\u01F2':'\u01F3','\u01F4':'\u01F5','\u01F6':'\u0195','\u01F7':'\u01BF','\u01F8':'\u01F9','\u01FA':'\u01FB','\u01FC':'\u01FD','\u01FE':'\u01FF','\u0200':'\u0201','\u0202':'\u0203','\u0204':'\u0205','\u0206':'\u0207','\u0208':'\u0209','\u020A':'\u020B','\u020C':'\u020D','\u020E':'\u020F','\u0210':'\u0211','\u0212':'\u0213','\u0214':'\u0215','\u0216':'\u0217','\u0218':'\u0219','\u021A':'\u021B','\u021C':'\u021D','\u021E':'\u021F','\u0220':'\u019E','\u0222':'\u0223','\u0224':'\u0225','\u0226':'\u0227','\u0228':'\u0229','\u022A':'\u022B','\u022C':'\u022D','\u022E':'\u022F','\u0230':'\u0231','\u0232':'\u0233','\u023A':'\u2C65','\u023B':'\u023C','\u023D':'\u019A','\u023E':'\u2C66','\u0241':'\u0242','\u0243':'\u0180','\u0244':'\u0289','\u0245':'\u028C','\u0246':'\u0247','\u0248':'\u0249','\u024A':'\u024B','\u024C':'\u024D','\u024E':'\u024F','\u0345':'\u03B9','\u0370':'\u0371','\u0372':'\u0373','\u0376':'\u0377','\u037F':'\u03F3','\u0386':'\u03AC','\u0388':'\u03AD','\u0389':'\u03AE','\u038A':'\u03AF','\u038C':'\u03CC','\u038E':'\u03CD','\u038F':'\u03CE','\u0391':'\u03B1','\u0392':'\u03B2','\u0393':'\u03B3','\u0394':'\u03B4','\u0395':'\u03B5','\u0396':'\u03B6','\u0397':'\u03B7','\u0398':'\u03B8','\u0399':'\u03B9','\u039A':'\u03BA','\u039B':'\u03BB','\u039C':'\u03BC','\u039D':'\u03BD','\u039E':'\u03BE','\u039F':'\u03BF','\u03A0':'\u03C0','\u03A1':'\u03C1','\u03A3':'\u03C3','\u03A4':'\u03C4','\u03A5':'\u03C5','\u03A6':'\u03C6','\u03A7':'\u03C7','\u03A8':'\u03C8','\u03A9':'\u03C9','\u03AA':'\u03CA','\u03AB':'\u03CB','\u03C2':'\u03C3','\u03CF':'\u03D7','\u03D0':'\u03B2','\u03D1':'\u03B8','\u03D5':'\u03C6','\u03D6':'\u03C0','\u03D8':'\u03D9','\u03DA':'\u03DB','\u03DC':'\u03DD','\u03DE':'\u03DF','\u03E0':'\u03E1','\u03E2':'\u03E3','\u03E4':'\u03E5','\u03E6':'\u03E7','\u03E8':'\u03E9','\u03EA':'\u03EB','\u03EC':'\u03ED','\u03EE':'\u03EF','\u03F0':'\u03BA','\u03F1':'\u03C1','\u03F4':'\u03B8','\u03F5':'\u03B5','\u03F7':'\u03F8','\u03F9':'\u03F2','\u03FA':'\u03FB','\u03FD':'\u037B','\u03FE':'\u037C','\u03FF':'\u037D','\u0400':'\u0450','\u0401':'\u0451','\u0402':'\u0452','\u0403':'\u0453','\u0404':'\u0454','\u0405':'\u0455','\u0406':'\u0456','\u0407':'\u0457','\u0408':'\u0458','\u0409':'\u0459','\u040A':'\u045A','\u040B':'\u045B','\u040C':'\u045C','\u040D':'\u045D','\u040E':'\u045E','\u040F':'\u045F','\u0410':'\u0430','\u0411':'\u0431','\u0412':'\u0432','\u0413':'\u0433','\u0414':'\u0434','\u0415':'\u0435','\u0416':'\u0436','\u0417':'\u0437','\u0418':'\u0438','\u0419':'\u0439','\u041A':'\u043A','\u041B':'\u043B','\u041C':'\u043C','\u041D':'\u043D','\u041E':'\u043E','\u041F':'\u043F','\u0420':'\u0440','\u0421':'\u0441','\u0422':'\u0442','\u0423':'\u0443','\u0424':'\u0444','\u0425':'\u0445','\u0426':'\u0446','\u0427':'\u0447','\u0428':'\u0448','\u0429':'\u0449','\u042A':'\u044A','\u042B':'\u044B','\u042C':'\u044C','\u042D':'\u044D','\u042E':'\u044E','\u042F':'\u044F','\u0460':'\u0461','\u0462':'\u0463','\u0464':'\u0465','\u0466':'\u0467','\u0468':'\u0469','\u046A':'\u046B','\u046C':'\u046D','\u046E':'\u046F','\u0470':'\u0471','\u0472':'\u0473','\u0474':'\u0475','\u0476':'\u0477','\u0478':'\u0479','\u047A':'\u047B','\u047C':'\u047D','\u047E':'\u047F','\u0480':'\u0481','\u048A':'\u048B','\u048C':'\u048D','\u048E':'\u048F','\u0490':'\u0491','\u0492':'\u0493','\u0494':'\u0495','\u0496':'\u0497','\u0498':'\u0499','\u049A':'\u049B','\u049C':'\u049D','\u049E':'\u049F','\u04A0':'\u04A1','\u04A2':'\u04A3','\u04A4':'\u04A5','\u04A6':'\u04A7','\u04A8':'\u04A9','\u04AA':'\u04AB','\u04AC':'\u04AD','\u04AE':'\u04AF','\u04B0':'\u04B1','\u04B2':'\u04B3','\u04B4':'\u04B5','\u04B6':'\u04B7','\u04B8':'\u04B9','\u04BA':'\u04BB','\u04BC':'\u04BD','\u04BE':'\u04BF','\u04C0':'\u04CF','\u04C1':'\u04C2','\u04C3':'\u04C4','\u04C5':'\u04C6','\u04C7':'\u04C8','\u04C9':'\u04CA','\u04CB':'\u04CC','\u04CD':'\u04CE','\u04D0':'\u04D1','\u04D2':'\u04D3','\u04D4':'\u04D5','\u04D6':'\u04D7','\u04D8':'\u04D9','\u04DA':'\u04DB','\u04DC':'\u04DD','\u04DE':'\u04DF','\u04E0':'\u04E1','\u04E2':'\u04E3','\u04E4':'\u04E5','\u04E6':'\u04E7','\u04E8':'\u04E9','\u04EA':'\u04EB','\u04EC':'\u04ED','\u04EE':'\u04EF','\u04F0':'\u04F1','\u04F2':'\u04F3','\u04F4':'\u04F5','\u04F6':'\u04F7','\u04F8':'\u04F9','\u04FA':'\u04FB','\u04FC':'\u04FD','\u04FE':'\u04FF','\u0500':'\u0501','\u0502':'\u0503','\u0504':'\u0505','\u0506':'\u0507','\u0508':'\u0509','\u050A':'\u050B','\u050C':'\u050D','\u050E':'\u050F','\u0510':'\u0511','\u0512':'\u0513','\u0514':'\u0515','\u0516':'\u0517','\u0518':'\u0519','\u051A':'\u051B','\u051C':'\u051D','\u051E':'\u051F','\u0520':'\u0521','\u0522':'\u0523','\u0524':'\u0525','\u0526':'\u0527','\u0528':'\u0529','\u052A':'\u052B','\u052C':'\u052D','\u052E':'\u052F','\u0531':'\u0561','\u0532':'\u0562','\u0533':'\u0563','\u0534':'\u0564','\u0535':'\u0565','\u0536':'\u0566','\u0537':'\u0567','\u0538':'\u0568','\u0539':'\u0569','\u053A':'\u056A','\u053B':'\u056B','\u053C':'\u056C','\u053D':'\u056D','\u053E':'\u056E','\u053F':'\u056F','\u0540':'\u0570','\u0541':'\u0571','\u0542':'\u0572','\u0543':'\u0573','\u0544':'\u0574','\u0545':'\u0575','\u0546':'\u0576','\u0547':'\u0577','\u0548':'\u0578','\u0549':'\u0579','\u054A':'\u057A','\u054B':'\u057B','\u054C':'\u057C','\u054D':'\u057D','\u054E':'\u057E','\u054F':'\u057F','\u0550':'\u0580','\u0551':'\u0581','\u0552':'\u0582','\u0553':'\u0583','\u0554':'\u0584','\u0555':'\u0585','\u0556':'\u0586','\u10A0':'\u2D00','\u10A1':'\u2D01','\u10A2':'\u2D02','\u10A3':'\u2D03','\u10A4':'\u2D04','\u10A5':'\u2D05','\u10A6':'\u2D06','\u10A7':'\u2D07','\u10A8':'\u2D08','\u10A9':'\u2D09','\u10AA':'\u2D0A','\u10AB':'\u2D0B','\u10AC':'\u2D0C','\u10AD':'\u2D0D','\u10AE':'\u2D0E','\u10AF':'\u2D0F','\u10B0':'\u2D10','\u10B1':'\u2D11','\u10B2':'\u2D12','\u10B3':'\u2D13','\u10B4':'\u2D14','\u10B5':'\u2D15','\u10B6':'\u2D16','\u10B7':'\u2D17','\u10B8':'\u2D18','\u10B9':'\u2D19','\u10BA':'\u2D1A','\u10BB':'\u2D1B','\u10BC':'\u2D1C','\u10BD':'\u2D1D','\u10BE':'\u2D1E','\u10BF':'\u2D1F','\u10C0':'\u2D20','\u10C1':'\u2D21','\u10C2':'\u2D22','\u10C3':'\u2D23','\u10C4':'\u2D24','\u10C5':'\u2D25','\u10C7':'\u2D27','\u10CD':'\u2D2D','\u1E00':'\u1E01','\u1E02':'\u1E03','\u1E04':'\u1E05','\u1E06':'\u1E07','\u1E08':'\u1E09','\u1E0A':'\u1E0B','\u1E0C':'\u1E0D','\u1E0E':'\u1E0F','\u1E10':'\u1E11','\u1E12':'\u1E13','\u1E14':'\u1E15','\u1E16':'\u1E17','\u1E18':'\u1E19','\u1E1A':'\u1E1B','\u1E1C':'\u1E1D','\u1E1E':'\u1E1F','\u1E20':'\u1E21','\u1E22':'\u1E23','\u1E24':'\u1E25','\u1E26':'\u1E27','\u1E28':'\u1E29','\u1E2A':'\u1E2B','\u1E2C':'\u1E2D','\u1E2E':'\u1E2F','\u1E30':'\u1E31','\u1E32':'\u1E33','\u1E34':'\u1E35','\u1E36':'\u1E37','\u1E38':'\u1E39','\u1E3A':'\u1E3B','\u1E3C':'\u1E3D','\u1E3E':'\u1E3F','\u1E40':'\u1E41','\u1E42':'\u1E43','\u1E44':'\u1E45','\u1E46':'\u1E47','\u1E48':'\u1E49','\u1E4A':'\u1E4B','\u1E4C':'\u1E4D','\u1E4E':'\u1E4F','\u1E50':'\u1E51','\u1E52':'\u1E53','\u1E54':'\u1E55','\u1E56':'\u1E57','\u1E58':'\u1E59','\u1E5A':'\u1E5B','\u1E5C':'\u1E5D','\u1E5E':'\u1E5F','\u1E60':'\u1E61','\u1E62':'\u1E63','\u1E64':'\u1E65','\u1E66':'\u1E67','\u1E68':'\u1E69','\u1E6A':'\u1E6B','\u1E6C':'\u1E6D','\u1E6E':'\u1E6F','\u1E70':'\u1E71','\u1E72':'\u1E73','\u1E74':'\u1E75','\u1E76':'\u1E77','\u1E78':'\u1E79','\u1E7A':'\u1E7B','\u1E7C':'\u1E7D','\u1E7E':'\u1E7F','\u1E80':'\u1E81','\u1E82':'\u1E83','\u1E84':'\u1E85','\u1E86':'\u1E87','\u1E88':'\u1E89','\u1E8A':'\u1E8B','\u1E8C':'\u1E8D','\u1E8E':'\u1E8F','\u1E90':'\u1E91','\u1E92':'\u1E93','\u1E94':'\u1E95','\u1E9B':'\u1E61','\u1EA0':'\u1EA1','\u1EA2':'\u1EA3','\u1EA4':'\u1EA5','\u1EA6':'\u1EA7','\u1EA8':'\u1EA9','\u1EAA':'\u1EAB','\u1EAC':'\u1EAD','\u1EAE':'\u1EAF','\u1EB0':'\u1EB1','\u1EB2':'\u1EB3','\u1EB4':'\u1EB5','\u1EB6':'\u1EB7','\u1EB8':'\u1EB9','\u1EBA':'\u1EBB','\u1EBC':'\u1EBD','\u1EBE':'\u1EBF','\u1EC0':'\u1EC1','\u1EC2':'\u1EC3','\u1EC4':'\u1EC5','\u1EC6':'\u1EC7','\u1EC8':'\u1EC9','\u1ECA':'\u1ECB','\u1ECC':'\u1ECD','\u1ECE':'\u1ECF','\u1ED0':'\u1ED1','\u1ED2':'\u1ED3','\u1ED4':'\u1ED5','\u1ED6':'\u1ED7','\u1ED8':'\u1ED9','\u1EDA':'\u1EDB','\u1EDC':'\u1EDD','\u1EDE':'\u1EDF','\u1EE0':'\u1EE1','\u1EE2':'\u1EE3','\u1EE4':'\u1EE5','\u1EE6':'\u1EE7','\u1EE8':'\u1EE9','\u1EEA':'\u1EEB','\u1EEC':'\u1EED','\u1EEE':'\u1EEF','\u1EF0':'\u1EF1','\u1EF2':'\u1EF3','\u1EF4':'\u1EF5','\u1EF6':'\u1EF7','\u1EF8':'\u1EF9','\u1EFA':'\u1EFB','\u1EFC':'\u1EFD','\u1EFE':'\u1EFF','\u1F08':'\u1F00','\u1F09':'\u1F01','\u1F0A':'\u1F02','\u1F0B':'\u1F03','\u1F0C':'\u1F04','\u1F0D':'\u1F05','\u1F0E':'\u1F06','\u1F0F':'\u1F07','\u1F18':'\u1F10','\u1F19':'\u1F11','\u1F1A':'\u1F12','\u1F1B':'\u1F13','\u1F1C':'\u1F14','\u1F1D':'\u1F15','\u1F28':'\u1F20','\u1F29':'\u1F21','\u1F2A':'\u1F22','\u1F2B':'\u1F23','\u1F2C':'\u1F24','\u1F2D':'\u1F25','\u1F2E':'\u1F26','\u1F2F':'\u1F27','\u1F38':'\u1F30','\u1F39':'\u1F31','\u1F3A':'\u1F32','\u1F3B':'\u1F33','\u1F3C':'\u1F34','\u1F3D':'\u1F35','\u1F3E':'\u1F36','\u1F3F':'\u1F37','\u1F48':'\u1F40','\u1F49':'\u1F41','\u1F4A':'\u1F42','\u1F4B':'\u1F43','\u1F4C':'\u1F44','\u1F4D':'\u1F45','\u1F59':'\u1F51','\u1F5B':'\u1F53','\u1F5D':'\u1F55','\u1F5F':'\u1F57','\u1F68':'\u1F60','\u1F69':'\u1F61','\u1F6A':'\u1F62','\u1F6B':'\u1F63','\u1F6C':'\u1F64','\u1F6D':'\u1F65','\u1F6E':'\u1F66','\u1F6F':'\u1F67','\u1FB8':'\u1FB0','\u1FB9':'\u1FB1','\u1FBA':'\u1F70','\u1FBB':'\u1F71','\u1FBE':'\u03B9','\u1FC8':'\u1F72','\u1FC9':'\u1F73','\u1FCA':'\u1F74','\u1FCB':'\u1F75','\u1FD8':'\u1FD0','\u1FD9':'\u1FD1','\u1FDA':'\u1F76','\u1FDB':'\u1F77','\u1FE8':'\u1FE0','\u1FE9':'\u1FE1','\u1FEA':'\u1F7A','\u1FEB':'\u1F7B','\u1FEC':'\u1FE5','\u1FF8':'\u1F78','\u1FF9':'\u1F79','\u1FFA':'\u1F7C','\u1FFB':'\u1F7D','\u2126':'\u03C9','\u212A':'k','\u212B':'\xE5','\u2132':'\u214E','\u2160':'\u2170','\u2161':'\u2171','\u2162':'\u2172','\u2163':'\u2173','\u2164':'\u2174','\u2165':'\u2175','\u2166':'\u2176','\u2167':'\u2177','\u2168':'\u2178','\u2169':'\u2179','\u216A':'\u217A','\u216B':'\u217B','\u216C':'\u217C','\u216D':'\u217D','\u216E':'\u217E','\u216F':'\u217F','\u2183':'\u2184','\u24B6':'\u24D0','\u24B7':'\u24D1','\u24B8':'\u24D2','\u24B9':'\u24D3','\u24BA':'\u24D4','\u24BB':'\u24D5','\u24BC':'\u24D6','\u24BD':'\u24D7','\u24BE':'\u24D8','\u24BF':'\u24D9','\u24C0':'\u24DA','\u24C1':'\u24DB','\u24C2':'\u24DC','\u24C3':'\u24DD','\u24C4':'\u24DE','\u24C5':'\u24DF','\u24C6':'\u24E0','\u24C7':'\u24E1','\u24C8':'\u24E2','\u24C9':'\u24E3','\u24CA':'\u24E4','\u24CB':'\u24E5','\u24CC':'\u24E6','\u24CD':'\u24E7','\u24CE':'\u24E8','\u24CF':'\u24E9','\u2C00':'\u2C30','\u2C01':'\u2C31','\u2C02':'\u2C32','\u2C03':'\u2C33','\u2C04':'\u2C34','\u2C05':'\u2C35','\u2C06':'\u2C36','\u2C07':'\u2C37','\u2C08':'\u2C38','\u2C09':'\u2C39','\u2C0A':'\u2C3A','\u2C0B':'\u2C3B','\u2C0C':'\u2C3C','\u2C0D':'\u2C3D','\u2C0E':'\u2C3E','\u2C0F':'\u2C3F','\u2C10':'\u2C40','\u2C11':'\u2C41','\u2C12':'\u2C42','\u2C13':'\u2C43','\u2C14':'\u2C44','\u2C15':'\u2C45','\u2C16':'\u2C46','\u2C17':'\u2C47','\u2C18':'\u2C48','\u2C19':'\u2C49','\u2C1A':'\u2C4A','\u2C1B':'\u2C4B','\u2C1C':'\u2C4C','\u2C1D':'\u2C4D','\u2C1E':'\u2C4E','\u2C1F':'\u2C4F','\u2C20':'\u2C50','\u2C21':'\u2C51','\u2C22':'\u2C52','\u2C23':'\u2C53','\u2C24':'\u2C54','\u2C25':'\u2C55','\u2C26':'\u2C56','\u2C27':'\u2C57','\u2C28':'\u2C58','\u2C29':'\u2C59','\u2C2A':'\u2C5A','\u2C2B':'\u2C5B','\u2C2C':'\u2C5C','\u2C2D':'\u2C5D','\u2C2E':'\u2C5E','\u2C60':'\u2C61','\u2C62':'\u026B','\u2C63':'\u1D7D','\u2C64':'\u027D','\u2C67':'\u2C68','\u2C69':'\u2C6A','\u2C6B':'\u2C6C','\u2C6D':'\u0251','\u2C6E':'\u0271','\u2C6F':'\u0250','\u2C70':'\u0252','\u2C72':'\u2C73','\u2C75':'\u2C76','\u2C7E':'\u023F','\u2C7F':'\u0240','\u2C80':'\u2C81','\u2C82':'\u2C83','\u2C84':'\u2C85','\u2C86':'\u2C87','\u2C88':'\u2C89','\u2C8A':'\u2C8B','\u2C8C':'\u2C8D','\u2C8E':'\u2C8F','\u2C90':'\u2C91','\u2C92':'\u2C93','\u2C94':'\u2C95','\u2C96':'\u2C97','\u2C98':'\u2C99','\u2C9A':'\u2C9B','\u2C9C':'\u2C9D','\u2C9E':'\u2C9F','\u2CA0':'\u2CA1','\u2CA2':'\u2CA3','\u2CA4':'\u2CA5','\u2CA6':'\u2CA7','\u2CA8':'\u2CA9','\u2CAA':'\u2CAB','\u2CAC':'\u2CAD','\u2CAE':'\u2CAF','\u2CB0':'\u2CB1','\u2CB2':'\u2CB3','\u2CB4':'\u2CB5','\u2CB6':'\u2CB7','\u2CB8':'\u2CB9','\u2CBA':'\u2CBB','\u2CBC':'\u2CBD','\u2CBE':'\u2CBF','\u2CC0':'\u2CC1','\u2CC2':'\u2CC3','\u2CC4':'\u2CC5','\u2CC6':'\u2CC7','\u2CC8':'\u2CC9','\u2CCA':'\u2CCB','\u2CCC':'\u2CCD','\u2CCE':'\u2CCF','\u2CD0':'\u2CD1','\u2CD2':'\u2CD3','\u2CD4':'\u2CD5','\u2CD6':'\u2CD7','\u2CD8':'\u2CD9','\u2CDA':'\u2CDB','\u2CDC':'\u2CDD','\u2CDE':'\u2CDF','\u2CE0':'\u2CE1','\u2CE2':'\u2CE3','\u2CEB':'\u2CEC','\u2CED':'\u2CEE','\u2CF2':'\u2CF3','\uA640':'\uA641','\uA642':'\uA643','\uA644':'\uA645','\uA646':'\uA647','\uA648':'\uA649','\uA64A':'\uA64B','\uA64C':'\uA64D','\uA64E':'\uA64F','\uA650':'\uA651','\uA652':'\uA653','\uA654':'\uA655','\uA656':'\uA657','\uA658':'\uA659','\uA65A':'\uA65B','\uA65C':'\uA65D','\uA65E':'\uA65F','\uA660':'\uA661','\uA662':'\uA663','\uA664':'\uA665','\uA666':'\uA667','\uA668':'\uA669','\uA66A':'\uA66B','\uA66C':'\uA66D','\uA680':'\uA681','\uA682':'\uA683','\uA684':'\uA685','\uA686':'\uA687','\uA688':'\uA689','\uA68A':'\uA68B','\uA68C':'\uA68D','\uA68E':'\uA68F','\uA690':'\uA691','\uA692':'\uA693','\uA694':'\uA695','\uA696':'\uA697','\uA698':'\uA699','\uA69A':'\uA69B','\uA722':'\uA723','\uA724':'\uA725','\uA726':'\uA727','\uA728':'\uA729','\uA72A':'\uA72B','\uA72C':'\uA72D','\uA72E':'\uA72F','\uA732':'\uA733','\uA734':'\uA735','\uA736':'\uA737','\uA738':'\uA739','\uA73A':'\uA73B','\uA73C':'\uA73D','\uA73E':'\uA73F','\uA740':'\uA741','\uA742':'\uA743','\uA744':'\uA745','\uA746':'\uA747','\uA748':'\uA749','\uA74A':'\uA74B','\uA74C':'\uA74D','\uA74E':'\uA74F','\uA750':'\uA751','\uA752':'\uA753','\uA754':'\uA755','\uA756':'\uA757','\uA758':'\uA759','\uA75A':'\uA75B','\uA75C':'\uA75D','\uA75E':'\uA75F','\uA760':'\uA761','\uA762':'\uA763','\uA764':'\uA765','\uA766':'\uA767','\uA768':'\uA769','\uA76A':'\uA76B','\uA76C':'\uA76D','\uA76E':'\uA76F','\uA779':'\uA77A','\uA77B':'\uA77C','\uA77D':'\u1D79','\uA77E':'\uA77F','\uA780':'\uA781','\uA782':'\uA783','\uA784':'\uA785','\uA786':'\uA787','\uA78B':'\uA78C','\uA78D':'\u0265','\uA790':'\uA791','\uA792':'\uA793','\uA796':'\uA797','\uA798':'\uA799','\uA79A':'\uA79B','\uA79C':'\uA79D','\uA79E':'\uA79F','\uA7A0':'\uA7A1','\uA7A2':'\uA7A3','\uA7A4':'\uA7A5','\uA7A6':'\uA7A7','\uA7A8':'\uA7A9','\uA7AA':'\u0266','\uA7AB':'\u025C','\uA7AC':'\u0261','\uA7AD':'\u026C','\uA7B0':'\u029E','\uA7B1':'\u0287','\uFF21':'\uFF41','\uFF22':'\uFF42','\uFF23':'\uFF43','\uFF24':'\uFF44','\uFF25':'\uFF45','\uFF26':'\uFF46','\uFF27':'\uFF47','\uFF28':'\uFF48','\uFF29':'\uFF49','\uFF2A':'\uFF4A','\uFF2B':'\uFF4B','\uFF2C':'\uFF4C','\uFF2D':'\uFF4D','\uFF2E':'\uFF4E','\uFF2F':'\uFF4F','\uFF30':'\uFF50','\uFF31':'\uFF51','\uFF32':'\uFF52','\uFF33':'\uFF53','\uFF34':'\uFF54','\uFF35':'\uFF55','\uFF36':'\uFF56','\uFF37':'\uFF57','\uFF38':'\uFF58','\uFF39':'\uFF59','\uFF3A':'\uFF5A','\uD801\uDC00':'\uD801\uDC28','\uD801\uDC01':'\uD801\uDC29','\uD801\uDC02':'\uD801\uDC2A','\uD801\uDC03':'\uD801\uDC2B','\uD801\uDC04':'\uD801\uDC2C','\uD801\uDC05':'\uD801\uDC2D','\uD801\uDC06':'\uD801\uDC2E','\uD801\uDC07':'\uD801\uDC2F','\uD801\uDC08':'\uD801\uDC30','\uD801\uDC09':'\uD801\uDC31','\uD801\uDC0A':'\uD801\uDC32','\uD801\uDC0B':'\uD801\uDC33','\uD801\uDC0C':'\uD801\uDC34','\uD801\uDC0D':'\uD801\uDC35','\uD801\uDC0E':'\uD801\uDC36','\uD801\uDC0F':'\uD801\uDC37','\uD801\uDC10':'\uD801\uDC38','\uD801\uDC11':'\uD801\uDC39','\uD801\uDC12':'\uD801\uDC3A','\uD801\uDC13':'\uD801\uDC3B','\uD801\uDC14':'\uD801\uDC3C','\uD801\uDC15':'\uD801\uDC3D','\uD801\uDC16':'\uD801\uDC3E','\uD801\uDC17':'\uD801\uDC3F','\uD801\uDC18':'\uD801\uDC40','\uD801\uDC19':'\uD801\uDC41','\uD801\uDC1A':'\uD801\uDC42','\uD801\uDC1B':'\uD801\uDC43','\uD801\uDC1C':'\uD801\uDC44','\uD801\uDC1D':'\uD801\uDC45','\uD801\uDC1E':'\uD801\uDC46','\uD801\uDC1F':'\uD801\uDC47','\uD801\uDC20':'\uD801\uDC48','\uD801\uDC21':'\uD801\uDC49','\uD801\uDC22':'\uD801\uDC4A','\uD801\uDC23':'\uD801\uDC4B','\uD801\uDC24':'\uD801\uDC4C','\uD801\uDC25':'\uD801\uDC4D','\uD801\uDC26':'\uD801\uDC4E','\uD801\uDC27':'\uD801\uDC4F','\uD806\uDCA0':'\uD806\uDCC0','\uD806\uDCA1':'\uD806\uDCC1','\uD806\uDCA2':'\uD806\uDCC2','\uD806\uDCA3':'\uD806\uDCC3','\uD806\uDCA4':'\uD806\uDCC4','\uD806\uDCA5':'\uD806\uDCC5','\uD806\uDCA6':'\uD806\uDCC6','\uD806\uDCA7':'\uD806\uDCC7','\uD806\uDCA8':'\uD806\uDCC8','\uD806\uDCA9':'\uD806\uDCC9','\uD806\uDCAA':'\uD806\uDCCA','\uD806\uDCAB':'\uD806\uDCCB','\uD806\uDCAC':'\uD806\uDCCC','\uD806\uDCAD':'\uD806\uDCCD','\uD806\uDCAE':'\uD806\uDCCE','\uD806\uDCAF':'\uD806\uDCCF','\uD806\uDCB0':'\uD806\uDCD0','\uD806\uDCB1':'\uD806\uDCD1','\uD806\uDCB2':'\uD806\uDCD2','\uD806\uDCB3':'\uD806\uDCD3','\uD806\uDCB4':'\uD806\uDCD4','\uD806\uDCB5':'\uD806\uDCD5','\uD806\uDCB6':'\uD806\uDCD6','\uD806\uDCB7':'\uD806\uDCD7','\uD806\uDCB8':'\uD806\uDCD8','\uD806\uDCB9':'\uD806\uDCD9','\uD806\uDCBA':'\uD806\uDCDA','\uD806\uDCBB':'\uD806\uDCDB','\uD806\uDCBC':'\uD806\uDCDC','\uD806\uDCBD':'\uD806\uDCDD','\uD806\uDCBE':'\uD806\uDCDE','\uD806\uDCBF':'\uD806\uDCDF','\xDF':'ss','\u0130':'i\u0307','\u0149':'\u02BCn','\u01F0':'j\u030C','\u0390':'\u03B9\u0308\u0301','\u03B0':'\u03C5\u0308\u0301','\u0587':'\u0565\u0582','\u1E96':'h\u0331','\u1E97':'t\u0308','\u1E98':'w\u030A','\u1E99':'y\u030A','\u1E9A':'a\u02BE','\u1E9E':'ss','\u1F50':'\u03C5\u0313','\u1F52':'\u03C5\u0313\u0300','\u1F54':'\u03C5\u0313\u0301','\u1F56':'\u03C5\u0313\u0342','\u1F80':'\u1F00\u03B9','\u1F81':'\u1F01\u03B9','\u1F82':'\u1F02\u03B9','\u1F83':'\u1F03\u03B9','\u1F84':'\u1F04\u03B9','\u1F85':'\u1F05\u03B9','\u1F86':'\u1F06\u03B9','\u1F87':'\u1F07\u03B9','\u1F88':'\u1F00\u03B9','\u1F89':'\u1F01\u03B9','\u1F8A':'\u1F02\u03B9','\u1F8B':'\u1F03\u03B9','\u1F8C':'\u1F04\u03B9','\u1F8D':'\u1F05\u03B9','\u1F8E':'\u1F06\u03B9','\u1F8F':'\u1F07\u03B9','\u1F90':'\u1F20\u03B9','\u1F91':'\u1F21\u03B9','\u1F92':'\u1F22\u03B9','\u1F93':'\u1F23\u03B9','\u1F94':'\u1F24\u03B9','\u1F95':'\u1F25\u03B9','\u1F96':'\u1F26\u03B9','\u1F97':'\u1F27\u03B9','\u1F98':'\u1F20\u03B9','\u1F99':'\u1F21\u03B9','\u1F9A':'\u1F22\u03B9','\u1F9B':'\u1F23\u03B9','\u1F9C':'\u1F24\u03B9','\u1F9D':'\u1F25\u03B9','\u1F9E':'\u1F26\u03B9','\u1F9F':'\u1F27\u03B9','\u1FA0':'\u1F60\u03B9','\u1FA1':'\u1F61\u03B9','\u1FA2':'\u1F62\u03B9','\u1FA3':'\u1F63\u03B9','\u1FA4':'\u1F64\u03B9','\u1FA5':'\u1F65\u03B9','\u1FA6':'\u1F66\u03B9','\u1FA7':'\u1F67\u03B9','\u1FA8':'\u1F60\u03B9','\u1FA9':'\u1F61\u03B9','\u1FAA':'\u1F62\u03B9','\u1FAB':'\u1F63\u03B9','\u1FAC':'\u1F64\u03B9','\u1FAD':'\u1F65\u03B9','\u1FAE':'\u1F66\u03B9','\u1FAF':'\u1F67\u03B9','\u1FB2':'\u1F70\u03B9','\u1FB3':'\u03B1\u03B9','\u1FB4':'\u03AC\u03B9','\u1FB6':'\u03B1\u0342','\u1FB7':'\u03B1\u0342\u03B9','\u1FBC':'\u03B1\u03B9','\u1FC2':'\u1F74\u03B9','\u1FC3':'\u03B7\u03B9','\u1FC4':'\u03AE\u03B9','\u1FC6':'\u03B7\u0342','\u1FC7':'\u03B7\u0342\u03B9','\u1FCC':'\u03B7\u03B9','\u1FD2':'\u03B9\u0308\u0300','\u1FD3':'\u03B9\u0308\u0301','\u1FD6':'\u03B9\u0342','\u1FD7':'\u03B9\u0308\u0342','\u1FE2':'\u03C5\u0308\u0300','\u1FE3':'\u03C5\u0308\u0301','\u1FE4':'\u03C1\u0313','\u1FE6':'\u03C5\u0342','\u1FE7':'\u03C5\u0308\u0342','\u1FF2':'\u1F7C\u03B9','\u1FF3':'\u03C9\u03B9','\u1FF4':'\u03CE\u03B9','\u1FF6':'\u03C9\u0342','\u1FF7':'\u03C9\u0342\u03B9','\u1FFC':'\u03C9\u03B9','\uFB00':'ff','\uFB01':'fi','\uFB02':'fl','\uFB03':'ffi','\uFB04':'ffl','\uFB05':'st','\uFB06':'st','\uFB13':'\u0574\u0576','\uFB14':'\u0574\u0565','\uFB15':'\u0574\u056B','\uFB16':'\u057E\u0576','\uFB17':'\u0574\u056D'};

// Normalize reference label: collapse internal whitespace
// to single space, remove leading/trailing whitespace, case fold.
module.exports = function(string) {
    return string.slice(1, string.length - 1).trim().replace(regex, function($0) {
        // Note: there is no need to check `hasOwnProperty($0)` here.
        // If character not found in lookup table, it must be whitespace.
        return map[$0] || ' ';
    });
};


/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// derived from https://github.com/mathiasbynens/String.fromCodePoint
/*! http://mths.be/fromcodepoint v0.2.1 by @mathias */
if (String.fromCodePoint) {
    module.exports = function (_) {
        try {
            return String.fromCodePoint(_);
        } catch (e) {
            if (e instanceof RangeError) {
                return String.fromCharCode(0xFFFD);
            }
            throw e;
        }
    };

} else {

  var stringFromCharCode = String.fromCharCode;
  var floor = Math.floor;
  var fromCodePoint = function() {
      var MAX_SIZE = 0x4000;
      var codeUnits = [];
      var highSurrogate;
      var lowSurrogate;
      var index = -1;
      var length = arguments.length;
      if (!length) {
          return '';
      }
      var result = '';
      while (++index < length) {
          var codePoint = Number(arguments[index]);
          if (
              !isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
                  codePoint < 0 || // not a valid Unicode code point
                  codePoint > 0x10FFFF || // not a valid Unicode code point
                  floor(codePoint) !== codePoint // not an integer
          ) {
              return String.fromCharCode(0xFFFD);
          }
          if (codePoint <= 0xFFFF) { // BMP code point
              codeUnits.push(codePoint);
          } else { // Astral code point; split in surrogate halves
              // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
              codePoint -= 0x10000;
              highSurrogate = (codePoint >> 10) + 0xD800;
              lowSurrogate = (codePoint % 0x400) + 0xDC00;
              codeUnits.push(highSurrogate, lowSurrogate);
          }
          if (index + 1 === length || codeUnits.length > MAX_SIZE) {
              result += stringFromCharCode.apply(null, codeUnits);
              codeUnits.length = 0;
          }
      }
      return result;
  };
  module.exports = fromCodePoint;
}


/***/ }),
/* 1575 */
/***/ (function(module, exports) {

/*! http://mths.be/repeat v0.2.0 by @mathias */
if (!String.prototype.repeat) {
	(function() {
		'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
		var defineProperty = (function() {
			// IE 8 only supports `Object.defineProperty` on DOM elements
			try {
				var object = {};
				var $defineProperty = Object.defineProperty;
				var result = $defineProperty(object, object, object) && $defineProperty;
			} catch(error) {}
			return result;
		}());
		var repeat = function(count) {
			if (this == null) {
				throw TypeError();
			}
			var string = String(this);
			// `ToInteger`
			var n = count ? Number(count) : 0;
			if (n != n) { // better `isNaN`
				n = 0;
			}
			// Account for out-of-bounds indices
			if (n < 0 || n == Infinity) {
				throw RangeError();
			}
			var result = '';
			while (n) {
				if (n % 2 == 1) {
					result += string;
				}
				if (n > 1) {
					string += string;
				}
				n >>= 1;
			}
			return result;
		};
		if (defineProperty) {
			defineProperty(String.prototype, 'repeat', {
				'value': repeat,
				'configurable': true,
				'writable': true
			});
		} else {
			String.prototype.repeat = repeat;
		}
	}());
}


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var escapeXml = __webpack_require__(154).escapeXml;

// Helper function to produce an HTML tag.
var tag = function(name, attrs, selfclosing) {
    var result = '<' + name;
    if (attrs && attrs.length > 0) {
        var i = 0;
        var attrib;
        while ((attrib = attrs[i]) !== undefined) {
            result += ' ' + attrib[0] + '="' + attrib[1] + '"';
            i++;
        }
    }
    if (selfclosing) {
        result += ' /';
    }

    result += '>';
    return result;
};

var reHtmlTag = /\<[^>]*\>/;
var reUnsafeProtocol = /^javascript:|vbscript:|file:|data:/i;
var reSafeDataProtocol = /^data:image\/(?:png|gif|jpeg|webp)/i;

var potentiallyUnsafe = function(url) {
    return reUnsafeProtocol.test(url) &&
        !reSafeDataProtocol.test(url);
};

var renderNodes = function(block) {

    var attrs;
    var info_words;
    var tagname;
    var walker = block.walker();
    var event, node, entering;
    var buffer = "";
    var lastOut = "\n";
    var disableTags = 0;
    var grandparent;
    var out = function(s) {
        if (disableTags > 0) {
            buffer += s.replace(reHtmlTag, '');
        } else {
            buffer += s;
        }
        lastOut = s;
    };
    var esc = this.escape;
    var cr = function() {
        if (lastOut !== '\n') {
            buffer += '\n';
            lastOut = '\n';
        }
    };

    var options = this.options;

    if (options.time) { console.time("rendering"); }

    while ((event = walker.next())) {
        entering = event.entering;
        node = event.node;

        attrs = [];
        if (options.sourcepos) {
            var pos = node.sourcepos;
            if (pos) {
                attrs.push(['data-sourcepos', String(pos[0][0]) + ':' +
                            String(pos[0][1]) + '-' + String(pos[1][0]) + ':' +
                            String(pos[1][1])]);
            }
        }

        switch (node.type) {
        case 'Text':
            out(esc(node.literal, false));
            break;

        case 'Softbreak':
            out(this.softbreak);
            break;

        case 'Hardbreak':
            out(tag('br', [], true));
            cr();
            break;

        case 'Emph':
            out(tag(entering ? 'em' : '/em'));
            break;

        case 'Strong':
            out(tag(entering ? 'strong' : '/strong'));
            break;

        case 'HtmlInline':
            if (options.safe) {
                out('<!-- raw HTML omitted -->');
            } else {
                out(node.literal);
            }
            break;

        case 'CustomInline':
            if (entering && node.onEnter) {
                out(node.onEnter);
            } else if (!entering && node.onExit) {
                out(node.onExit);
            }
            break;

        case 'Link':
            if (entering) {
                if (!(options.safe && potentiallyUnsafe(node.destination))) {
                    attrs.push(['href', esc(node.destination, true)]);
                }
                if (node.title) {
                    attrs.push(['title', esc(node.title, true)]);
                }
                out(tag('a', attrs));
            } else {
                out(tag('/a'));
            }
            break;

        case 'Image':
            if (entering) {
                if (disableTags === 0) {
                    if (options.safe &&
                         potentiallyUnsafe(node.destination)) {
                        out('<img src="" alt="');
                    } else {
                        out('<img src="' + esc(node.destination, true) +
                            '" alt="');
                    }
                }
                disableTags += 1;
            } else {
                disableTags -= 1;
                if (disableTags === 0) {
                    if (node.title) {
                        out('" title="' + esc(node.title, true));
                    }
                    out('" />');
                }
            }
            break;

        case 'Code':
            out(tag('code') + esc(node.literal, false) + tag('/code'));
            break;

        case 'Document':
            break;

        case 'Paragraph':
            grandparent = node.parent.parent;
            if (grandparent !== null &&
                grandparent.type === 'List') {
                if (grandparent.listTight) {
                    break;
                }
            }
            if (entering) {
                cr();
                out(tag('p', attrs));
            } else {
                out(tag('/p'));
                cr();
            }
            break;

        case 'BlockQuote':
            if (entering) {
                cr();
                out(tag('blockquote', attrs));
                cr();
            } else {
                cr();
                out(tag('/blockquote'));
                cr();
            }
            break;

        case 'Item':
            if (entering) {
                out(tag('li', attrs));
            } else {
                out(tag('/li'));
                cr();
            }
            break;

        case 'List':
            tagname = node.listType === 'Bullet' ? 'ul' : 'ol';
            if (entering) {
                var start = node.listStart;
                if (start !== null && start !== 1) {
                    attrs.push(['start', start.toString()]);
                }
                cr();
                out(tag(tagname, attrs));
                cr();
            } else {
                cr();
                out(tag('/' + tagname));
                cr();
            }
            break;

        case 'Heading':
            tagname = 'h' + node.level;
            if (entering) {
                cr();
                out(tag(tagname, attrs));
            } else {
                out(tag('/' + tagname));
                cr();
            }
            break;

        case 'CodeBlock':
            info_words = node.info ? node.info.split(/\s+/) : [];
            if (info_words.length > 0 && info_words[0].length > 0) {
                attrs.push(['class', 'language-' + esc(info_words[0], true)]);
            }
            cr();
            out(tag('pre') + tag('code', attrs));
            out(esc(node.literal, false));
            out(tag('/code') + tag('/pre'));
            cr();
            break;

        case 'HtmlBlock':
            cr();
            if (options.safe) {
                out('<!-- raw HTML omitted -->');
            } else {
                out(node.literal);
            }
            cr();
            break;

        case 'CustomBlock':
            cr();
            if (entering && node.onEnter) {
                out(node.onEnter);
            } else if (!entering && node.onExit) {
                out(node.onExit);
            }
            cr();
            break;

        case 'ThematicBreak':
            cr();
            out(tag('hr', attrs, true));
            cr();
            break;

        default:
            throw "Unknown node type " + node.type;
        }

    }
    if (options.time) { console.timeEnd("rendering"); }
    return buffer;
};

// The HtmlRenderer object.
function HtmlRenderer(options){
    return {
        // default options:
        softbreak: '\n', // by default, soft breaks are rendered as newlines in HTML
        // set to "<br />" to make them hard breaks
        // set to " " if you want to ignore line wrapping in source
        escape: escapeXml,
        options: options || {},
        render: renderNodes
    };
}

module.exports = HtmlRenderer;


/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var escapeXml = __webpack_require__(154).escapeXml;

// Helper function to produce an XML tag.
var tag = function(name, attrs, selfclosing) {
    var result = '<' + name;
    if (attrs && attrs.length > 0) {
        var i = 0;
        var attrib;
        while ((attrib = attrs[i]) !== undefined) {
            result += ' ' + attrib[0] + '="' + attrib[1] + '"';
            i++;
        }
    }
    if (selfclosing) {
        result += ' /';
    }

    result += '>';
    return result;
};

var reXMLTag = /\<[^>]*\>/;

var toTagName = function(s) {
    return s.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
};

var renderNodes = function(block) {

    var attrs;
    var tagname;
    var walker = block.walker();
    var event, node, entering;
    var buffer = "";
    var lastOut = "\n";
    var disableTags = 0;
    var indentLevel = 0;
    var indent = '  ';
    var container;
    var selfClosing;
    var nodetype;

    var out = function(s) {
        if (disableTags > 0) {
            buffer += s.replace(reXMLTag, '');
        } else {
            buffer += s;
        }
        lastOut = s;
    };
    var esc = this.escape;
    var cr = function() {
        if (lastOut !== '\n') {
            buffer += '\n';
            lastOut = '\n';
            for (var i = indentLevel; i > 0; i--) {
                buffer += indent;
            }
        }
    };

    var options = this.options;

    if (options.time) { console.time("rendering"); }

    buffer += '<?xml version="1.0" encoding="UTF-8"?>\n';
    buffer += '<!DOCTYPE CommonMark SYSTEM "CommonMark.dtd">\n';

    while ((event = walker.next())) {
        entering = event.entering;
        node = event.node;
        nodetype = node.type;

        container = node.isContainer;
        selfClosing = nodetype === 'ThematicBreak' || nodetype === 'Hardbreak' ||
            nodetype === 'Softbreak';
        tagname = toTagName(nodetype);

        if (entering) {

            attrs = [];

            switch (nodetype) {
            case 'Document':
                attrs.push(['xmlns', 'http://commonmark.org/xml/1.0']);
                break;
            case 'List':
                if (node.listType !== null) {
                    attrs.push(['type', node.listType.toLowerCase()]);
                }
                if (node.listStart !== null) {
                    attrs.push(['start', String(node.listStart)]);
                }
                if (node.listTight !== null) {
                    attrs.push(['tight', (node.listTight ? 'true' : 'false')]);
                }
                var delim = node.listDelimiter;
                if (delim !== null) {
                    var delimword = '';
                    if (delim === '.') {
                        delimword = 'period';
                    } else {
                        delimword = 'paren';
                    }
                    attrs.push(['delimiter', delimword]);
                }
                break;
            case 'CodeBlock':
                if (node.info) {
                    attrs.push(['info', node.info]);
                }
                break;
            case 'Heading':
                attrs.push(['level', String(node.level)]);
                break;
            case 'Link':
            case 'Image':
                attrs.push(['destination', node.destination]);
                attrs.push(['title', node.title]);
                break;
            case 'CustomInline':
            case 'CustomBlock':
                attrs.push(['on_enter', node.onEnter]);
                attrs.push(['on_exit', node.onExit]);
                break;
            default:
                break;
            }
            if (options.sourcepos) {
                var pos = node.sourcepos;
                if (pos) {
                    attrs.push(['sourcepos', String(pos[0][0]) + ':' +
                                String(pos[0][1]) + '-' + String(pos[1][0]) + ':' +
                                String(pos[1][1])]);
                }
            }

            cr();
            out(tag(tagname, attrs, selfClosing));
            if (container) {
                indentLevel += 1;
            } else if (!container && !selfClosing) {
                var lit = node.literal;
                if (lit) {
                    out(esc(lit));
                }
                out(tag('/' + tagname));
            }
        } else {
            indentLevel -= 1;
            cr();
            out(tag('/' + tagname));
        }


    }
    if (options.time) { console.timeEnd("rendering"); }
    buffer += '\n';
    return buffer;
};

// The XmlRenderer object.
function XmlRenderer(options){
    return {
        // default options:
        softbreak: '\n', // by default, soft breaks are rendered as newlines in HTML
        // set to "<br />" to make them hard breaks
        // set to " " if you want to ignore line wrapping in source
        escape: escapeXml,
        options: options || {},
        render: renderNodes
    };
}

module.exports = XmlRenderer;


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var assign = __webpack_require__(1579);
var isPlainObject = __webpack_require__(1580);
var xssFilters = __webpack_require__(1581);
var pascalCase = __webpack_require__(1582);

var typeAliases = {
    blockquote: 'block_quote',
    thematicbreak: 'thematic_break',
    htmlblock: 'html_block',
    htmlinline: 'html_inline',
    codeblock: 'code_block',
    hardbreak: 'linebreak'
};

var defaultRenderers = {
    block_quote: 'blockquote', // eslint-disable-line camelcase
    emph: 'em',
    linebreak: 'br',
    image: 'img',
    item: 'li',
    link: 'a',
    paragraph: 'p',
    strong: 'strong',
    thematic_break: 'hr', // eslint-disable-line camelcase

    html_block: HtmlRenderer, // eslint-disable-line camelcase
    html_inline: HtmlRenderer, // eslint-disable-line camelcase

    list: function List(props) {
        var tag = props.type.toLowerCase() === 'bullet' ? 'ul' : 'ol';
        var attrs = getCoreProps(props);

        if (props.start !== null && props.start !== 1) {
            attrs.start = props.start.toString();
        }

        return createElement(tag, attrs, props.children);
    },
    code_block: function CodeBlock(props) { // eslint-disable-line camelcase
        var className = props.language && 'language-' + props.language;
        var code = createElement('code', { className: className }, props.literal);
        return createElement('pre', getCoreProps(props), code);
    },
    code: function Code(props) {
        return createElement('code', getCoreProps(props), props.children);
    },
    heading: function Heading(props) {
        return createElement('h' + props.level, getCoreProps(props), props.children);
    },

    text: null,
    softbreak: null
};

var coreTypes = Object.keys(defaultRenderers);

function getCoreProps(props) {
    return {
        'key': props.nodeKey,
        'className': props.className,
        'data-sourcepos': props['data-sourcepos']
    };
}

function normalizeTypeName(typeName) {
    var norm = typeName.toLowerCase();
    var type = typeAliases[norm] || norm;
    return typeof defaultRenderers[type] !== 'undefined' ? type : typeName;
}

function normalizeRenderers(renderers) {
    return Object.keys(renderers || {}).reduce(function(normalized, type) {
        var norm = normalizeTypeName(type);
        normalized[norm] = renderers[type];
        return normalized;
    }, {});
}

function HtmlRenderer(props) {
    var coreProps = getCoreProps(props);
    var nodeProps = props.escapeHtml ? {} : { dangerouslySetInnerHTML: { __html: props.literal } };
    var children = props.escapeHtml ? [props.literal] : null;

    if (props.escapeHtml || !props.skipHtml) {
        var actualProps = assign(coreProps, nodeProps);
        return createElement(props.isBlock ? 'div' : 'span', actualProps, children);
    }
}

function isGrandChildOfList(node) {
    var grandparent = node.parent.parent;
    return (
        grandparent &&
        grandparent.type.toLowerCase() === 'list' &&
        grandparent.listTight
    );
}

function addChild(node, child) {
    var parent = node;
    do {
        parent = parent.parent;
    } while (!parent.react);

    parent.react.children.push(child);
}

function createElement(tagName, props, children) {
    var nodeChildren = Array.isArray(children) && children.reduce(reduceChildren, []);
    var args = [tagName, props].concat(nodeChildren || children);
    return React.createElement.apply(React, args);
}

function reduceChildren(children, child) {
    var lastIndex = children.length - 1;
    if (typeof child === 'string' && typeof children[lastIndex] === 'string') {
        children[lastIndex] += child;
    } else {
        children.push(child);
    }

    return children;
}

function flattenPosition(pos) {
    return [
        pos[0][0], ':', pos[0][1], '-',
        pos[1][0], ':', pos[1][1]
    ].map(String).join('');
}

// For some nodes, we want to include more props than for others
function getNodeProps(node, key, opts, renderer) {
    var props = { key: key }, undef;

    // `sourcePos` is true if the user wants source information (line/column info from markdown source)
    if (opts.sourcePos && node.sourcepos) {
        props['data-sourcepos'] = flattenPosition(node.sourcepos);
    }

    var type = normalizeTypeName(node.type);

    switch (type) {
        case 'html_inline':
        case 'html_block':
            props.isBlock = type === 'html_block';
            props.escapeHtml = opts.escapeHtml;
            props.skipHtml = opts.skipHtml;
            break;
        case 'code_block':
            var codeInfo = node.info ? node.info.split(/ +/) : [];
            if (codeInfo.length > 0 && codeInfo[0].length > 0) {
                props.language = codeInfo[0];
                props.codeinfo = codeInfo;
            }
            break;
        case 'code':
            props.children = node.literal;
            props.inline = true;
            break;
        case 'heading':
            props.level = node.level;
            break;
        case 'softbreak':
            props.softBreak = opts.softBreak;
            break;
        case 'link':
            props.href = opts.transformLinkUri ? opts.transformLinkUri(node.destination) : node.destination;
            props.title = node.title || undef;
            if (opts.linkTarget) {
                props.target = opts.linkTarget;
            }
            break;
        case 'image':
            props.src = opts.transformImageUri ? opts.transformImageUri(node.destination) : node.destination;
            props.title = node.title || undef;

            // Commonmark treats image description as children. We just want the text
            props.alt = node.react.children.join('');
            node.react.children = undef;
            break;
        case 'list':
            props.start = node.listStart;
            props.type = node.listType;
            props.tight = node.listTight;
            break;
        default:
    }

    if (typeof renderer !== 'string') {
        props.literal = node.literal;
    }

    var children = props.children || (node.react && node.react.children);
    if (Array.isArray(children)) {
        props.children = children.reduce(reduceChildren, []) || null;
    }

    return props;
}

function getPosition(node) {
    if (!node) {
        return null;
    }

    if (node.sourcepos) {
        return flattenPosition(node.sourcepos);
    }

    return getPosition(node.parent);
}

function renderNodes(block) {
    var walker = block.walker();

    var propOptions = {
        sourcePos: this.sourcePos,
        escapeHtml: this.escapeHtml,
        skipHtml: this.skipHtml,
        transformLinkUri: this.transformLinkUri,
        transformImageUri: this.transformImageUri,
        softBreak: this.softBreak,
        linkTarget: this.linkTarget
    };

    var e, node, entering, leaving, type, doc, key, nodeProps, prevPos, prevIndex = 0;
    while ((e = walker.next())) {
        var pos = getPosition(e.node.sourcepos ? e.node : e.node.parent);
        if (prevPos === pos) {
            key = pos + prevIndex;
            prevIndex++;
        } else {
            key = pos;
            prevIndex = 0;
        }

        prevPos = pos;
        entering = e.entering;
        leaving = !entering;
        node = e.node;
        type = normalizeTypeName(node.type);
        nodeProps = null;

        // If we have not assigned a document yet, assume the current node is just that
        if (!doc) {
            doc = node;
            node.react = { children: [] };
            continue;
        } else if (node === doc) {
            // When we're leaving...
            continue;
        }

        // In HTML, we don't want paragraphs inside of list items
        if (type === 'paragraph' && isGrandChildOfList(node)) {
            continue;
        }

        // If we're skipping HTML nodes, don't keep processing
        if (this.skipHtml && (type === 'html_block' || type === 'html_inline')) {
            continue;
        }

        var isDocument = node === doc;
        var disallowedByConfig = this.allowedTypes.indexOf(type) === -1;
        var disallowedByUser = false;

        // Do we have a user-defined function?
        var isCompleteParent = node.isContainer && leaving;
        var renderer = this.renderers[type];
        if (this.allowNode && (isCompleteParent || !node.isContainer)) {
            var nodeChildren = isCompleteParent ? node.react.children : [];

            nodeProps = getNodeProps(node, key, propOptions, renderer);
            disallowedByUser = !this.allowNode({
                type: pascalCase(type),
                renderer: this.renderers[type],
                props: nodeProps,
                children: nodeChildren
            });
        }

        if (!isDocument && (disallowedByUser || disallowedByConfig)) {
            if (!this.unwrapDisallowed && entering && node.isContainer) {
                walker.resumeAt(node, false);
            }

            continue;
        }

        var isSimpleNode = type === 'text' || type === 'softbreak';
        if (typeof renderer !== 'function' && !isSimpleNode && typeof renderer !== 'string') {
            throw new Error(
                'Renderer for type `' + pascalCase(node.type) + '` not defined or is not renderable'
            );
        }

        if (node.isContainer && entering) {
            node.react = {
                component: renderer,
                props: {},
                children: []
            };
        } else {
            var childProps = nodeProps || getNodeProps(node, key, propOptions, renderer);
            if (renderer) {
                childProps = typeof renderer === 'string'
                    ? childProps
                    : assign(childProps, {nodeKey: childProps.key});

                addChild(node, React.createElement(renderer, childProps));
            } else if (type === 'text') {
                addChild(node, node.literal);
            } else if (type === 'softbreak') {
                // Softbreaks are usually treated as newlines, but in HTML we might want explicit linebreaks
                var softBreak = (
                    this.softBreak === 'br' ?
                    React.createElement('br', {key: key}) :
                    this.softBreak
                );
                addChild(node, softBreak);
            }
        }
    }

    return doc.react.children;
}

function defaultLinkUriFilter(uri) {
    var url = uri.replace(/file:\/\//g, 'x-file://');

    // React does a pretty swell job of escaping attributes,
    // so to prevent double-escaping, we need to decode
    return decodeURI(xssFilters.uriInDoubleQuotedAttr(url));
}

function ReactRenderer(options) {
    var opts = options || {};

    if (opts.allowedTypes && opts.disallowedTypes) {
        throw new Error('Only one of `allowedTypes` and `disallowedTypes` should be defined');
    }

    if (opts.allowedTypes && !Array.isArray(opts.allowedTypes)) {
        throw new Error('`allowedTypes` must be an array');
    }

    if (opts.disallowedTypes && !Array.isArray(opts.disallowedTypes)) {
        throw new Error('`disallowedTypes` must be an array');
    }

    if (opts.allowNode && typeof opts.allowNode !== 'function') {
        throw new Error('`allowNode` must be a function');
    }

    var linkFilter = opts.transformLinkUri;
    if (typeof linkFilter === 'undefined') {
        linkFilter = defaultLinkUriFilter;
    } else if (linkFilter && typeof linkFilter !== 'function') {
        throw new Error('`transformLinkUri` must either be a function, or `null` to disable');
    }

    var imageFilter = opts.transformImageUri;
    if (typeof imageFilter !== 'undefined' && typeof imageFilter !== 'function') {
        throw new Error('`transformImageUri` must be a function');
    }

    if (opts.renderers && !isPlainObject(opts.renderers)) {
        throw new Error('`renderers` must be a plain object of `Type`: `Renderer` pairs');
    }

    var allowedTypes = (opts.allowedTypes && opts.allowedTypes.map(normalizeTypeName)) || coreTypes;
    if (opts.disallowedTypes) {
        var disallowed = opts.disallowedTypes.map(normalizeTypeName);
        allowedTypes = allowedTypes.filter(function filterDisallowed(type) {
            return disallowed.indexOf(type) === -1;
        });
    }

    return {
        sourcePos: Boolean(opts.sourcePos),
        softBreak: opts.softBreak || '\n',
        renderers: assign({}, defaultRenderers, normalizeRenderers(opts.renderers)),
        escapeHtml: Boolean(opts.escapeHtml),
        skipHtml: Boolean(opts.skipHtml),
        transformLinkUri: linkFilter,
        transformImageUri: imageFilter,
        allowNode: opts.allowNode,
        allowedTypes: allowedTypes,
        unwrapDisallowed: Boolean(opts.unwrapDisallowed),
        render: renderNodes,
        linkTarget: opts.linkTarget || false
    };
}

ReactRenderer.uriTransformer = defaultLinkUriFilter;
ReactRenderer.types = coreTypes.map(pascalCase);
ReactRenderer.renderers = coreTypes.reduce(function(renderers, type) {
    renderers[pascalCase(type)] = defaultRenderers[type];
    return renderers;
}, {});

module.exports = ReactRenderer;


/***/ }),
/* 1579 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),
/* 1580 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) ||
      objectToString.call(value) != objectTag || isHostObject(value)) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return (typeof Ctor == 'function' &&
    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
}

module.exports = isPlainObject;


/***/ }),
/* 1581 */
/***/ (function(module, exports) {

/*
Copyright (c) 2015, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.

Authors: Nera Liu <neraliu@yahoo-inc.com>
         Adonis Fung <adon@yahoo-inc.com>
         Albert Yu <albertyu@yahoo-inc.com>
*/
/*jshint node: true */

exports._getPrivFilters = function () {

    var LT     = /</g,
        QUOT   = /"/g,
        SQUOT  = /'/g,
        AMP    = /&/g,
        NULL   = /\x00/g,
        SPECIAL_ATTR_VALUE_UNQUOTED_CHARS = /(?:^$|[\x00\x09-\x0D "'`=<>])/g,
        SPECIAL_HTML_CHARS = /[&<>"'`]/g, 
        SPECIAL_COMMENT_CHARS = /(?:\x00|^-*!?>|--!?>|--?!?$|\]>|\]$)/g;

    // CSS sensitive chars: ()"'/,!*@{}:;
    // By CSS: (Tab|NewLine|colon|semi|lpar|rpar|apos|sol|comma|excl|ast|midast);|(quot|QUOT)
    // By URI_PROTOCOL: (Tab|NewLine);
    var SENSITIVE_HTML_ENTITIES = /&(?:#([xX][0-9A-Fa-f]+|\d+);?|(Tab|NewLine|colon|semi|lpar|rpar|apos|sol|comma|excl|ast|midast|ensp|emsp|thinsp);|(nbsp|amp|AMP|lt|LT|gt|GT|quot|QUOT);?)/g,
        SENSITIVE_NAMED_REF_MAP = {Tab: '\t', NewLine: '\n', colon: ':', semi: ';', lpar: '(', rpar: ')', apos: '\'', sol: '/', comma: ',', excl: '!', ast: '*', midast: '*', ensp: '\u2002', emsp: '\u2003', thinsp: '\u2009', nbsp: '\xA0', amp: '&', lt: '<', gt: '>', quot: '"', QUOT: '"'};

    // var CSS_VALID_VALUE = 
    //     /^(?:
    //     (?!-*expression)#?[-\w]+
    //     |[+-]?(?:\d+|\d*\.\d+)(?:em|ex|ch|rem|px|mm|cm|in|pt|pc|%|vh|vw|vmin|vmax)?
    //     |!important
    //     | //empty
    //     )$/i;
    var CSS_VALID_VALUE = /^(?:(?!-*expression)#?[-\w]+|[+-]?(?:\d+|\d*\.\d+)(?:r?em|ex|ch|cm|mm|in|px|pt|pc|%|vh|vw|vmin|vmax)?|!important|)$/i,
        // TODO: prevent double css escaping by not encoding \ again, but this may require CSS decoding
        // \x7F and \x01-\x1F less \x09 are for Safari 5.0, added []{}/* for unbalanced quote
        CSS_DOUBLE_QUOTED_CHARS = /[\x00-\x1F\x7F\[\]{}\\"]/g,
        CSS_SINGLE_QUOTED_CHARS = /[\x00-\x1F\x7F\[\]{}\\']/g,
        // (, \u207D and \u208D can be used in background: 'url(...)' in IE, assumed all \ chars are encoded by QUOTED_CHARS, and null is already replaced with \uFFFD
        // otherwise, use this CSS_BLACKLIST instead (enhance it with url matching): /(?:\\?\(|[\u207D\u208D]|\\0{0,4}28 ?|\\0{0,2}20[78][Dd] ?)+/g
        CSS_BLACKLIST = /url[\(\u207D\u208D]+/g,
        // this assumes encodeURI() and encodeURIComponent() has escaped 1-32, 127 for IE8
        CSS_UNQUOTED_URL = /['\(\)]/g; // " \ treated by encodeURI()

    // Given a full URI, need to support "[" ( IPv6address ) "]" in URI as per RFC3986
    // Reference: https://tools.ietf.org/html/rfc3986
    var URL_IPV6 = /\/\/%5[Bb]([A-Fa-f0-9:]+)%5[Dd]/;


    // Reference: http://shazzer.co.uk/database/All/characters-allowd-in-html-entities
    // Reference: http://shazzer.co.uk/vector/Characters-allowed-after-ampersand-in-named-character-references
    // Reference: http://shazzer.co.uk/database/All/Characters-before-javascript-uri
    // Reference: http://shazzer.co.uk/database/All/Characters-after-javascript-uri
    // Reference: https://html.spec.whatwg.org/multipage/syntax.html#consume-a-character-reference
    // Reference for named characters: https://html.spec.whatwg.org/multipage/entities.json
    var URI_BLACKLIST_PROTOCOLS = {'javascript':1, 'data':1, 'vbscript':1, 'mhtml':1, 'x-schema':1},
        URI_PROTOCOL_COLON = /(?::|&#[xX]0*3[aA];?|&#0*58;?|&colon;)/,
        URI_PROTOCOL_WHITESPACES = /(?:^[\x00-\x20]+|[\t\n\r\x00]+)/g,
        URI_PROTOCOL_NAMED_REF_MAP = {Tab: '\t', NewLine: '\n'};

    var x, 
        strReplace = function (s, regexp, callback) {
            return s === undefined ? 'undefined'
                    : s === null            ? 'null'
                    : s.toString().replace(regexp, callback);
        },
        fromCodePoint = String.fromCodePoint || function(codePoint) {
            if (arguments.length === 0) {
                return '';
            }
            if (codePoint <= 0xFFFF) { // BMP code point
                return String.fromCharCode(codePoint);
            }

            // Astral code point; split in surrogate halves
            // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            codePoint -= 0x10000;
            return String.fromCharCode((codePoint >> 10) + 0xD800, (codePoint % 0x400) + 0xDC00);
        };


    function getProtocol(str) {
        var s = str.split(URI_PROTOCOL_COLON, 2);
        // str.length !== s[0].length is for older IE (e.g., v8), where delimeter residing at last will result in length equals 1, but not 2
        return (s[0] && (s.length === 2 || str.length !== s[0].length)) ? s[0] : null;
    }

    function htmlDecode(s, namedRefMap, reNamedRef, skipReplacement) {
        
        namedRefMap = namedRefMap || SENSITIVE_NAMED_REF_MAP;
        reNamedRef = reNamedRef || SENSITIVE_HTML_ENTITIES;

        function regExpFunction(m, num, named, named1) {
            if (num) {
                num = Number(num[0] <= '9' ? num : '0' + num);
                // switch(num) {
                //     case 0x80: return '\u20AC';  // EURO SIGN (€)
                //     case 0x82: return '\u201A';  // SINGLE LOW-9 QUOTATION MARK (‚)
                //     case 0x83: return '\u0192';  // LATIN SMALL LETTER F WITH HOOK (ƒ)
                //     case 0x84: return '\u201E';  // DOUBLE LOW-9 QUOTATION MARK („)
                //     case 0x85: return '\u2026';  // HORIZONTAL ELLIPSIS (…)
                //     case 0x86: return '\u2020';  // DAGGER (†)
                //     case 0x87: return '\u2021';  // DOUBLE DAGGER (‡)
                //     case 0x88: return '\u02C6';  // MODIFIER LETTER CIRCUMFLEX ACCENT (ˆ)
                //     case 0x89: return '\u2030';  // PER MILLE SIGN (‰)
                //     case 0x8A: return '\u0160';  // LATIN CAPITAL LETTER S WITH CARON (Š)
                //     case 0x8B: return '\u2039';  // SINGLE LEFT-POINTING ANGLE QUOTATION MARK (‹)
                //     case 0x8C: return '\u0152';  // LATIN CAPITAL LIGATURE OE (Œ)
                //     case 0x8E: return '\u017D';  // LATIN CAPITAL LETTER Z WITH CARON (Ž)
                //     case 0x91: return '\u2018';  // LEFT SINGLE QUOTATION MARK (‘)
                //     case 0x92: return '\u2019';  // RIGHT SINGLE QUOTATION MARK (’)
                //     case 0x93: return '\u201C';  // LEFT DOUBLE QUOTATION MARK (“)
                //     case 0x94: return '\u201D';  // RIGHT DOUBLE QUOTATION MARK (”)
                //     case 0x95: return '\u2022';  // BULLET (•)
                //     case 0x96: return '\u2013';  // EN DASH (–)
                //     case 0x97: return '\u2014';  // EM DASH (—)
                //     case 0x98: return '\u02DC';  // SMALL TILDE (˜)
                //     case 0x99: return '\u2122';  // TRADE MARK SIGN (™)
                //     case 0x9A: return '\u0161';  // LATIN SMALL LETTER S WITH CARON (š)
                //     case 0x9B: return '\u203A';  // SINGLE RIGHT-POINTING ANGLE QUOTATION MARK (›)
                //     case 0x9C: return '\u0153';  // LATIN SMALL LIGATURE OE (œ)
                //     case 0x9E: return '\u017E';  // LATIN SMALL LETTER Z WITH CARON (ž)
                //     case 0x9F: return '\u0178';  // LATIN CAPITAL LETTER Y WITH DIAERESIS (Ÿ)
                // }
                // // num >= 0xD800 && num <= 0xDFFF, and 0x0D is separately handled, as it doesn't fall into the range of x.pec()
                // return (num >= 0xD800 && num <= 0xDFFF) || num === 0x0D ? '\uFFFD' : x.frCoPt(num);

                return skipReplacement ? fromCodePoint(num)
                        : num === 0x80 ? '\u20AC'  // EURO SIGN (€)
                        : num === 0x82 ? '\u201A'  // SINGLE LOW-9 QUOTATION MARK (‚)
                        : num === 0x83 ? '\u0192'  // LATIN SMALL LETTER F WITH HOOK (ƒ)
                        : num === 0x84 ? '\u201E'  // DOUBLE LOW-9 QUOTATION MARK („)
                        : num === 0x85 ? '\u2026'  // HORIZONTAL ELLIPSIS (…)
                        : num === 0x86 ? '\u2020'  // DAGGER (†)
                        : num === 0x87 ? '\u2021'  // DOUBLE DAGGER (‡)
                        : num === 0x88 ? '\u02C6'  // MODIFIER LETTER CIRCUMFLEX ACCENT (ˆ)
                        : num === 0x89 ? '\u2030'  // PER MILLE SIGN (‰)
                        : num === 0x8A ? '\u0160'  // LATIN CAPITAL LETTER S WITH CARON (Š)
                        : num === 0x8B ? '\u2039'  // SINGLE LEFT-POINTING ANGLE QUOTATION MARK (‹)
                        : num === 0x8C ? '\u0152'  // LATIN CAPITAL LIGATURE OE (Œ)
                        : num === 0x8E ? '\u017D'  // LATIN CAPITAL LETTER Z WITH CARON (Ž)
                        : num === 0x91 ? '\u2018'  // LEFT SINGLE QUOTATION MARK (‘)
                        : num === 0x92 ? '\u2019'  // RIGHT SINGLE QUOTATION MARK (’)
                        : num === 0x93 ? '\u201C'  // LEFT DOUBLE QUOTATION MARK (“)
                        : num === 0x94 ? '\u201D'  // RIGHT DOUBLE QUOTATION MARK (”)
                        : num === 0x95 ? '\u2022'  // BULLET (•)
                        : num === 0x96 ? '\u2013'  // EN DASH (–)
                        : num === 0x97 ? '\u2014'  // EM DASH (—)
                        : num === 0x98 ? '\u02DC'  // SMALL TILDE (˜)
                        : num === 0x99 ? '\u2122'  // TRADE MARK SIGN (™)
                        : num === 0x9A ? '\u0161'  // LATIN SMALL LETTER S WITH CARON (š)
                        : num === 0x9B ? '\u203A'  // SINGLE RIGHT-POINTING ANGLE QUOTATION MARK (›)
                        : num === 0x9C ? '\u0153'  // LATIN SMALL LIGATURE OE (œ)
                        : num === 0x9E ? '\u017E'  // LATIN SMALL LETTER Z WITH CARON (ž)
                        : num === 0x9F ? '\u0178'  // LATIN CAPITAL LETTER Y WITH DIAERESIS (Ÿ)
                        : (num >= 0xD800 && num <= 0xDFFF) || num === 0x0D ? '\uFFFD'
                        : x.frCoPt(num);
            }
            return namedRefMap[named || named1] || m;
        }

        return s === undefined  ? 'undefined'
            : s === null        ? 'null'
            : s.toString().replace(NULL, '\uFFFD').replace(reNamedRef, regExpFunction);
    }

    function cssEncode(chr) {
        // space after \\HEX is needed by spec
        return '\\' + chr.charCodeAt(0).toString(16).toLowerCase() + ' ';
    }
    function cssBlacklist(s) {
        return s.replace(CSS_BLACKLIST, function(m){ return '-x-' + m; });
    }
    function cssUrl(s) {
        // encodeURI() in yufull() will throw error for use of the CSS_UNSUPPORTED_CODE_POINT (i.e., [\uD800-\uDFFF])
        s = x.yufull(htmlDecode(s));
        var protocol = getProtocol(s);

        // prefix ## for blacklisted protocols
        // here .replace(URI_PROTOCOL_WHITESPACES, '') is not needed since yufull has already percent-encoded the whitespaces
        return (protocol && URI_BLACKLIST_PROTOCOLS[protocol.toLowerCase()]) ? '##' + s : s;
    }

    return (x = {
        // turn invalid codePoints and that of non-characters to \uFFFD, and then fromCodePoint()
        frCoPt: function(num) {
            return num === undefined || num === null ? '' :
                !isFinite(num = Number(num)) || // `NaN`, `+Infinity`, or `-Infinity`
                num <= 0 ||                     // not a valid Unicode code point
                num > 0x10FFFF ||               // not a valid Unicode code point
                // Math.floor(num) != num || 

                (num >= 0x01 && num <= 0x08) ||
                (num >= 0x0E && num <= 0x1F) ||
                (num >= 0x7F && num <= 0x9F) ||
                (num >= 0xFDD0 && num <= 0xFDEF) ||
                
                 num === 0x0B || 
                (num & 0xFFFF) === 0xFFFF || 
                (num & 0xFFFF) === 0xFFFE ? '\uFFFD' : fromCodePoint(num);
        },
        d: htmlDecode,
        /*
         * @param {string} s - An untrusted uri input
         * @returns {string} s - null if relative url, otherwise the protocol with whitespaces stripped and lower-cased
         */
        yup: function(s) {
            s = getProtocol(s.replace(NULL, ''));
            // URI_PROTOCOL_WHITESPACES is required for left trim and remove interim whitespaces
            return s ? htmlDecode(s, URI_PROTOCOL_NAMED_REF_MAP, null, true).replace(URI_PROTOCOL_WHITESPACES, '').toLowerCase() : null;
        },

        /*
         * @deprecated
         * @param {string} s - An untrusted user input
         * @returns {string} s - The original user input with & < > " ' ` encoded respectively as &amp; &lt; &gt; &quot; &#39; and &#96;.
         *
         */
        y: function(s) {
            return strReplace(s, SPECIAL_HTML_CHARS, function (m) {
                return m === '&' ? '&amp;'
                    :  m === '<' ? '&lt;'
                    :  m === '>' ? '&gt;'
                    :  m === '"' ? '&quot;'
                    :  m === "'" ? '&#39;'
                    :  /*m === '`'*/ '&#96;';       // in hex: 60
            });
        },

        // This filter is meant to introduce double-encoding, and should be used with extra care.
        ya: function(s) {
            return strReplace(s, AMP, '&amp;');
        },

        // FOR DETAILS, refer to inHTMLData()
        // Reference: https://html.spec.whatwg.org/multipage/syntax.html#data-state
        yd: function (s) {
            return strReplace(s, LT, '&lt;');
        },

        // FOR DETAILS, refer to inHTMLComment()
        // All NULL characters in s are first replaced with \uFFFD.
        // If s contains -->, --!>, or starts with -*>, insert a space right before > to stop state breaking at <!--{{{yc s}}}-->
        // If s ends with --!, --, or -, append a space to stop collaborative state breaking at {{{yc s}}}>, {{{yc s}}}!>, {{{yc s}}}-!>, {{{yc s}}}->
        // Reference: https://html.spec.whatwg.org/multipage/syntax.html#comment-state
        // Reference: http://shazzer.co.uk/vector/Characters-that-close-a-HTML-comment-3
        // Reference: http://shazzer.co.uk/vector/Characters-that-close-a-HTML-comment
        // Reference: http://shazzer.co.uk/vector/Characters-that-close-a-HTML-comment-0021
        // If s contains ]> or ends with ], append a space after ] is verified in IE to stop IE conditional comments.
        // Reference: http://msdn.microsoft.com/en-us/library/ms537512%28v=vs.85%29.aspx
        // We do not care --\s>, which can possibly be intepreted as a valid close comment tag in very old browsers (e.g., firefox 3.6), as specified in the html4 spec
        // Reference: http://www.w3.org/TR/html401/intro/sgmltut.html#h-3.2.4
        yc: function (s) {
            return strReplace(s, SPECIAL_COMMENT_CHARS, function(m){
                return m === '\x00' ? '\uFFFD'
                    : m === '--!' || m === '--' || m === '-' || m === ']' ? m + ' '
                    :/*
                    :  m === ']>'   ? '] >'
                    :  m === '-->'  ? '-- >'
                    :  m === '--!>' ? '--! >'
                    : /-*!?>/.test(m) ? */ m.slice(0, -1) + ' >';
            });
        },

        // FOR DETAILS, refer to inDoubleQuotedAttr()
        // Reference: https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(double-quoted)-state
        yavd: function (s) {
            return strReplace(s, QUOT, '&quot;');
        },

        // FOR DETAILS, refer to inSingleQuotedAttr()
        // Reference: https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(single-quoted)-state
        yavs: function (s) {
            return strReplace(s, SQUOT, '&#39;');
        },

        // FOR DETAILS, refer to inUnQuotedAttr()
        // PART A.
        // if s contains any state breaking chars (\t, \n, \v, \f, \r, space, and >),
        // they are escaped and encoded into their equivalent HTML entity representations. 
        // Reference: http://shazzer.co.uk/database/All/Characters-which-break-attributes-without-quotes
        // Reference: https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(unquoted)-state
        //
        // PART B. 
        // if s starts with ', " or `, encode it resp. as &#39;, &quot;, or &#96; to 
        // enforce the attr value (unquoted) state
        // Reference: https://html.spec.whatwg.org/multipage/syntax.html#before-attribute-value-state
        // Reference: http://shazzer.co.uk/vector/Characters-allowed-attribute-quote
        // 
        // PART C.
        // Inject a \uFFFD character if an empty or all null string is encountered in 
        // unquoted attribute value state.
        // 
        // Rationale 1: our belief is that developers wouldn't expect an 
        //   empty string would result in ' name="passwd"' rendered as 
        //   attribute value, even though this is how HTML5 is specified.
        // Rationale 2: an empty or all null string (for IE) can 
        //   effectively alter its immediate subsequent state, we choose
        //   \uFFFD to end the unquoted attr 
        //   state, which therefore will not mess up later contexts.
        // Rationale 3: Since IE 6, it is verified that NULL chars are stripped.
        // Reference: https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(unquoted)-state
        // 
        // Example:
        // <input value={{{yavu s}}} name="passwd"/>
        yavu: function (s) {
            return strReplace(s, SPECIAL_ATTR_VALUE_UNQUOTED_CHARS, function (m) {
                return m === '\t'   ? '&#9;'  // in hex: 09
                    :  m === '\n'   ? '&#10;' // in hex: 0A
                    :  m === '\x0B' ? '&#11;' // in hex: 0B  for IE. IE<9 \v equals v, so use \x0B instead
                    :  m === '\f'   ? '&#12;' // in hex: 0C
                    :  m === '\r'   ? '&#13;' // in hex: 0D
                    :  m === ' '    ? '&#32;' // in hex: 20
                    :  m === '='    ? '&#61;' // in hex: 3D
                    :  m === '<'    ? '&lt;'
                    :  m === '>'    ? '&gt;'
                    :  m === '"'    ? '&quot;'
                    :  m === "'"    ? '&#39;'
                    :  m === '`'    ? '&#96;'
                    : /*empty or null*/ '\uFFFD';
            });
        },

        yu: encodeURI,
        yuc: encodeURIComponent,

        // Notice that yubl MUST BE APPLIED LAST, and will not be used independently (expected output from encodeURI/encodeURIComponent and yavd/yavs/yavu)
        // This is used to disable JS execution capabilities by prefixing x- to ^javascript:, ^vbscript: or ^data: that possibly could trigger script execution in URI attribute context
        yubl: function (s) {
            return URI_BLACKLIST_PROTOCOLS[x.yup(s)] ? 'x-' + s : s;
        },

        // This is NOT a security-critical filter.
        // Reference: https://tools.ietf.org/html/rfc3986
        yufull: function (s) {
            return x.yu(s).replace(URL_IPV6, function(m, p) {
                return '//[' + p + ']';
            });
        },

        // chain yufull() with yubl()
        yublf: function (s) {
            return x.yubl(x.yufull(s));
        },

        // The design principle of the CSS filter MUST meet the following goal(s).
        // (1) The input cannot break out of the context (expr) and this is to fulfill the just sufficient encoding principle.
        // (2) The input cannot introduce CSS parsing error and this is to address the concern of UI redressing.
        //
        // term
        //   : unary_operator?
        //     [ NUMBER S* | PERCENTAGE S* | LENGTH S* | EMS S* | EXS S* | ANGLE S* |
        //     TIME S* | FREQ S* ]
        //   | STRING S* | IDENT S* | URI S* | hexcolor | function
        // 
        // Reference:
        // * http://www.w3.org/TR/CSS21/grammar.html 
        // * http://www.w3.org/TR/css-syntax-3/
        // 
        // NOTE: delimiter in CSS -  \  _  :  ;  (  )  "  '  /  ,  %  #  !  *  @  .  {  }
        //                        2d 5c 5f 3a 3b 28 29 22 27 2f 2c 25 23 21 2a 40 2e 7b 7d

        yceu: function(s) {
            s = htmlDecode(s);
            return CSS_VALID_VALUE.test(s) ? s : ";-x:'" + cssBlacklist(s.replace(CSS_SINGLE_QUOTED_CHARS, cssEncode)) + "';-v:";
        },

        // string1 = \"([^\n\r\f\\"]|\\{nl}|\\[^\n\r\f0-9a-f]|\\[0-9a-f]{1,6}(\r\n|[ \n\r\t\f])?)*\"
        yced: function(s) {
            return cssBlacklist(htmlDecode(s).replace(CSS_DOUBLE_QUOTED_CHARS, cssEncode));
        },

        // string2 = \'([^\n\r\f\\']|\\{nl}|\\[^\n\r\f0-9a-f]|\\[0-9a-f]{1,6}(\r\n|[ \n\r\t\f])?)*\'
        yces: function(s) {
            return cssBlacklist(htmlDecode(s).replace(CSS_SINGLE_QUOTED_CHARS, cssEncode));
        },

        // for url({{{yceuu url}}}
        // unquoted_url = ([!#$%&*-~]|\\{h}{1,6}(\r\n|[ \t\r\n\f])?|\\[^\r\n\f0-9a-f])* (CSS 2.1 definition)
        // unquoted_url = ([^"'()\\ \t\n\r\f\v\u0000\u0008\u000b\u000e-\u001f\u007f]|\\{h}{1,6}(\r\n|[ \t\r\n\f])?|\\[^\r\n\f0-9a-f])* (CSS 3.0 definition)
        // The state machine in CSS 3.0 is more well defined - http://www.w3.org/TR/css-syntax-3/#consume-a-url-token0
        // CSS_UNQUOTED_URL = /['\(\)]/g; // " \ treated by encodeURI()   
        yceuu: function(s) {
            return cssUrl(s).replace(CSS_UNQUOTED_URL, function (chr) {
                return  chr === '\''        ? '\\27 ' :
                        chr === '('         ? '%28' :
                        /* chr === ')' ? */   '%29';
            });
        },

        // for url("{{{yceud url}}}
        yceud: function(s) { 
            return cssUrl(s);
        },

        // for url('{{{yceus url}}}
        yceus: function(s) { 
            return cssUrl(s).replace(SQUOT, '\\27 ');
        }
    });
};

// exposing privFilters
// this is an undocumented feature, and please use it with extra care
var privFilters = exports._privFilters = exports._getPrivFilters();


/* chaining filters */

// uriInAttr and literally uriPathInAttr
// yubl is always used 
// Rationale: given pattern like this: <a href="{{{uriPathInDoubleQuotedAttr s}}}">
//            developer may expect s is always prefixed with ? or /, but an attacker can abuse it with 'javascript:alert(1)'
function uriInAttr (s, yav, yu) {
    return privFilters.yubl(yav((yu || privFilters.yufull)(s)));
}

/** 
* Yahoo Secure XSS Filters - just sufficient output filtering to prevent XSS!
* @module xss-filters 
*/

/**
* @function module:xss-filters#inHTMLData
*
* @param {string} s - An untrusted user input
* @returns {string} The string s with '<' encoded as '&amp;lt;'
*
* @description
* This filter is to be placed in HTML Data context to encode all '<' characters into '&amp;lt;'
* <ul>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#data-state">HTML5 Data State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <div>{{{inHTMLData htmlData}}}</div>
*
*/
exports.inHTMLData = privFilters.yd;

/**
* @function module:xss-filters#inHTMLComment
*
* @param {string} s - An untrusted user input
* @returns {string} All NULL characters in s are first replaced with \uFFFD. If s contains -->, --!>, or starts with -*>, insert a space right before > to stop state breaking at <!--{{{yc s}}}-->. If s ends with --!, --, or -, append a space to stop collaborative state breaking at {{{yc s}}}>, {{{yc s}}}!>, {{{yc s}}}-!>, {{{yc s}}}->. If s contains ]> or ends with ], append a space after ] is verified in IE to stop IE conditional comments.
*
* @description
* This filter is to be placed in HTML Comment context
* <ul>
* <li><a href="http://shazzer.co.uk/vector/Characters-that-close-a-HTML-comment-3">Shazzer - Closing comments for -.-></a>
* <li><a href="http://shazzer.co.uk/vector/Characters-that-close-a-HTML-comment">Shazzer - Closing comments for --.></a>
* <li><a href="http://shazzer.co.uk/vector/Characters-that-close-a-HTML-comment-0021">Shazzer - Closing comments for .></a>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#comment-start-state">HTML5 Comment Start State</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#comment-start-dash-state">HTML5 Comment Start Dash State</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#comment-state">HTML5 Comment State</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#comment-end-dash-state">HTML5 Comment End Dash State</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#comment-end-state">HTML5 Comment End State</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#comment-end-bang-state">HTML5 Comment End Bang State</a></li>
* <li><a href="http://msdn.microsoft.com/en-us/library/ms537512%28v=vs.85%29.aspx">Conditional Comments in Internet Explorer</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <!-- {{{inHTMLComment html_comment}}} -->
*
*/
exports.inHTMLComment = privFilters.yc;

/**
* @function module:xss-filters#inSingleQuotedAttr
*
* @param {string} s - An untrusted user input
* @returns {string} The string s with any single-quote characters encoded into '&amp;&#39;'.
*
* @description
* <p class="warning">Warning: This is NOT designed for any onX (e.g., onclick) attributes!</p>
* <p class="warning">Warning: If you're working on URI/components, use the more specific uri___InSingleQuotedAttr filter </p>
* This filter is to be placed in HTML Attribute Value (single-quoted) state to encode all single-quote characters into '&amp;&#39;'
*
* <ul>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(single-quoted)-state">HTML5 Attribute Value (Single-Quoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <input name='firstname' value='{{{inSingleQuotedAttr firstname}}}' />
*
*/
exports.inSingleQuotedAttr = privFilters.yavs;

/**
* @function module:xss-filters#inDoubleQuotedAttr
*
* @param {string} s - An untrusted user input
* @returns {string} The string s with any single-quote characters encoded into '&amp;&quot;'.
*
* @description
* <p class="warning">Warning: This is NOT designed for any onX (e.g., onclick) attributes!</p>
* <p class="warning">Warning: If you're working on URI/components, use the more specific uri___InDoubleQuotedAttr filter </p>
* This filter is to be placed in HTML Attribute Value (double-quoted) state to encode all single-quote characters into '&amp;&quot;'
*
* <ul>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(double-quoted)-state">HTML5 Attribute Value (Double-Quoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <input name="firstname" value="{{{inDoubleQuotedAttr firstname}}}" />
*
*/
exports.inDoubleQuotedAttr = privFilters.yavd;

/**
* @function module:xss-filters#inUnQuotedAttr
*
* @param {string} s - An untrusted user input
* @returns {string} If s contains any state breaking chars (\t, \n, \v, \f, \r, space, null, ', ", `, <, >, and =), they are escaped and encoded into their equivalent HTML entity representations. If the string is empty, inject a \uFFFD character.
*
* @description
* <p class="warning">Warning: This is NOT designed for any onX (e.g., onclick) attributes!</p>
* <p class="warning">Warning: If you're working on URI/components, use the more specific uri___InUnQuotedAttr filter </p>
* <p>Regarding \uFFFD injection, given <a id={{{id}}} name="passwd">,<br/>
*        Rationale 1: our belief is that developers wouldn't expect when id equals an
*          empty string would result in ' name="passwd"' rendered as 
*          attribute value, even though this is how HTML5 is specified.<br/>
*        Rationale 2: an empty or all null string (for IE) can 
*          effectively alter its immediate subsequent state, we choose
*          \uFFFD to end the unquoted attr 
*          state, which therefore will not mess up later contexts.<br/>
*        Rationale 3: Since IE 6, it is verified that NULL chars are stripped.<br/>
*        Reference: https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(unquoted)-state</p>
* <ul>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(unquoted)-state">HTML5 Attribute Value (Unquoted) State</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#before-attribute-value-state">HTML5 Before Attribute Value State</a></li>
* <li><a href="http://shazzer.co.uk/database/All/Characters-which-break-attributes-without-quotes">Shazzer - Characters-which-break-attributes-without-quotes</a></li>
* <li><a href="http://shazzer.co.uk/vector/Characters-allowed-attribute-quote">Shazzer - Characters-allowed-attribute-quote</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <input name="firstname" value={{{inUnQuotedAttr firstname}}} />
*
*/
exports.inUnQuotedAttr = privFilters.yavu;


/**
* @function module:xss-filters#uriInSingleQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly an <strong>absolute</strong> URI
* @returns {string} The string s encoded first by window.encodeURI(), then inSingleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* @description
* This filter is to be placed in HTML Attribute Value (single-quoted) state for an <strong>absolute</strong> URI.<br/>
* The correct order of encoders is thus: first window.encodeURI(), then inSingleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* <p>Notice: This filter is IPv6 friendly by not encoding '[' and ']'.</p>
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI">encodeURI | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(single-quoted)-state">HTML5 Attribute Value (Single-Quoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href='{{{uriInSingleQuotedAttr full_uri}}}'>link</a>
* 
*/
exports.uriInSingleQuotedAttr = function (s) {
    return uriInAttr(s, privFilters.yavs);
};

/**
* @function module:xss-filters#uriInDoubleQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly an <strong>absolute</strong> URI
* @returns {string} The string s encoded first by window.encodeURI(), then inDoubleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* @description
* This filter is to be placed in HTML Attribute Value (double-quoted) state for an <strong>absolute</strong> URI.<br/>
* The correct order of encoders is thus: first window.encodeURI(), then inDoubleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* <p>Notice: This filter is IPv6 friendly by not encoding '[' and ']'.</p>
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI">encodeURI | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(double-quoted)-state">HTML5 Attribute Value (Double-Quoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href="{{{uriInDoubleQuotedAttr full_uri}}}">link</a>
* 
*/
exports.uriInDoubleQuotedAttr = function (s) {
    return uriInAttr(s, privFilters.yavd);
};


/**
* @function module:xss-filters#uriInUnQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly an <strong>absolute</strong> URI
* @returns {string} The string s encoded first by window.encodeURI(), then inUnQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* @description
* This filter is to be placed in HTML Attribute Value (unquoted) state for an <strong>absolute</strong> URI.<br/>
* The correct order of encoders is thus: first the built-in encodeURI(), then inUnQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* <p>Notice: This filter is IPv6 friendly by not encoding '[' and ']'.</p>
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI">encodeURI | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(unquoted)-state">HTML5 Attribute Value (Unquoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href={{{uriInUnQuotedAttr full_uri}}}>link</a>
* 
*/
exports.uriInUnQuotedAttr = function (s) {
    return uriInAttr(s, privFilters.yavu);
};

/**
* @function module:xss-filters#uriInHTMLData
*
* @param {string} s - An untrusted user input, supposedly an <strong>absolute</strong> URI
* @returns {string} The string s encoded by window.encodeURI() and then inHTMLData()
*
* @description
* This filter is to be placed in HTML Data state for an <strong>absolute</strong> URI.
*
* <p>Notice: The actual implementation skips inHTMLData(), since '<' is already encoded as '%3C' by encodeURI().</p>
* <p>Notice: This filter is IPv6 friendly by not encoding '[' and ']'.</p>
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI">encodeURI | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#data-state">HTML5 Data State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href="/somewhere">{{{uriInHTMLData full_uri}}}</a>
* 
*/
exports.uriInHTMLData = privFilters.yufull;


/**
* @function module:xss-filters#uriInHTMLComment
*
* @param {string} s - An untrusted user input, supposedly an <strong>absolute</strong> URI
* @returns {string} The string s encoded by window.encodeURI(), and finally inHTMLComment()
*
* @description
* This filter is to be placed in HTML Comment state for an <strong>absolute</strong> URI.
*
* <p>Notice: This filter is IPv6 friendly by not encoding '[' and ']'.</p>
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI">encodeURI | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#data-state">HTML5 Data State</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#comment-state">HTML5 Comment State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <!-- {{{uriInHTMLComment full_uri}}} -->
* 
*/
exports.uriInHTMLComment = function (s) {
    return privFilters.yc(privFilters.yufull(s));
};




/**
* @function module:xss-filters#uriPathInSingleQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly a URI Path/Query or relative URI
* @returns {string} The string s encoded first by window.encodeURI(), then inSingleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* @description
* This filter is to be placed in HTML Attribute Value (single-quoted) state for a URI Path/Query or relative URI.<br/>
* The correct order of encoders is thus: first window.encodeURI(), then inSingleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI">encodeURI | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(single-quoted)-state">HTML5 Attribute Value (Single-Quoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href='http://example.com/{{{uriPathInSingleQuotedAttr uri_path}}}'>link</a>
* <a href='http://example.com/?{{{uriQueryInSingleQuotedAttr uri_query}}}'>link</a>
* 
*/
exports.uriPathInSingleQuotedAttr = function (s) {
    return uriInAttr(s, privFilters.yavs, privFilters.yu);
};

/**
* @function module:xss-filters#uriPathInDoubleQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly a URI Path/Query or relative URI
* @returns {string} The string s encoded first by window.encodeURI(), then inDoubleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* @description
* This filter is to be placed in HTML Attribute Value (double-quoted) state for a URI Path/Query or relative URI.<br/>
* The correct order of encoders is thus: first window.encodeURI(), then inDoubleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI">encodeURI | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(double-quoted)-state">HTML5 Attribute Value (Double-Quoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href="http://example.com/{{{uriPathInDoubleQuotedAttr uri_path}}}">link</a>
* <a href="http://example.com/?{{{uriQueryInDoubleQuotedAttr uri_query}}}">link</a>
* 
*/
exports.uriPathInDoubleQuotedAttr = function (s) {
    return uriInAttr(s, privFilters.yavd, privFilters.yu);
};


/**
* @function module:xss-filters#uriPathInUnQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly a URI Path/Query or relative URI
* @returns {string} The string s encoded first by window.encodeURI(), then inUnQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* @description
* This filter is to be placed in HTML Attribute Value (unquoted) state for a URI Path/Query or relative URI.<br/>
* The correct order of encoders is thus: first the built-in encodeURI(), then inUnQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI">encodeURI | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(unquoted)-state">HTML5 Attribute Value (Unquoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href=http://example.com/{{{uriPathInUnQuotedAttr uri_path}}}>link</a>
* <a href=http://example.com/?{{{uriQueryInUnQuotedAttr uri_query}}}>link</a>
* 
*/
exports.uriPathInUnQuotedAttr = function (s) {
    return uriInAttr(s, privFilters.yavu, privFilters.yu);
};

/**
* @function module:xss-filters#uriPathInHTMLData
*
* @param {string} s - An untrusted user input, supposedly a URI Path/Query or relative URI
* @returns {string} The string s encoded by window.encodeURI() and then inHTMLData()
*
* @description
* This filter is to be placed in HTML Data state for a URI Path/Query or relative URI.
*
* <p>Notice: The actual implementation skips inHTMLData(), since '<' is already encoded as '%3C' by encodeURI().</p>
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI">encodeURI | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#data-state">HTML5 Data State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href="http://example.com/">http://example.com/{{{uriPathInHTMLData uri_path}}}</a>
* <a href="http://example.com/">http://example.com/?{{{uriQueryInHTMLData uri_query}}}</a>
* 
*/
exports.uriPathInHTMLData = privFilters.yu;


/**
* @function module:xss-filters#uriPathInHTMLComment
*
* @param {string} s - An untrusted user input, supposedly a URI Path/Query or relative URI
* @returns {string} The string s encoded by window.encodeURI(), and finally inHTMLComment()
*
* @description
* This filter is to be placed in HTML Comment state for a URI Path/Query or relative URI.
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI">encodeURI | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#data-state">HTML5 Data State</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#comment-state">HTML5 Comment State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <!-- http://example.com/{{{uriPathInHTMLComment uri_path}}} -->
* <!-- http://example.com/?{{{uriQueryInHTMLComment uri_query}}} -->
*/
exports.uriPathInHTMLComment = function (s) {
    return privFilters.yc(privFilters.yu(s));
};


/**
* @function module:xss-filters#uriQueryInSingleQuotedAttr
* @description This is an alias of {@link module:xss-filters#uriPathInSingleQuotedAttr}
* 
* @alias module:xss-filters#uriPathInSingleQuotedAttr
*/
exports.uriQueryInSingleQuotedAttr = exports.uriPathInSingleQuotedAttr;

/**
* @function module:xss-filters#uriQueryInDoubleQuotedAttr
* @description This is an alias of {@link module:xss-filters#uriPathInDoubleQuotedAttr}
* 
* @alias module:xss-filters#uriPathInDoubleQuotedAttr
*/
exports.uriQueryInDoubleQuotedAttr = exports.uriPathInDoubleQuotedAttr;

/**
* @function module:xss-filters#uriQueryInUnQuotedAttr
* @description This is an alias of {@link module:xss-filters#uriPathInUnQuotedAttr}
* 
* @alias module:xss-filters#uriPathInUnQuotedAttr
*/
exports.uriQueryInUnQuotedAttr = exports.uriPathInUnQuotedAttr;

/**
* @function module:xss-filters#uriQueryInHTMLData
* @description This is an alias of {@link module:xss-filters#uriPathInHTMLData}
* 
* @alias module:xss-filters#uriPathInHTMLData
*/
exports.uriQueryInHTMLData = exports.uriPathInHTMLData;

/**
* @function module:xss-filters#uriQueryInHTMLComment
* @description This is an alias of {@link module:xss-filters#uriPathInHTMLComment}
* 
* @alias module:xss-filters#uriPathInHTMLComment
*/
exports.uriQueryInHTMLComment = exports.uriPathInHTMLComment;



/**
* @function module:xss-filters#uriComponentInSingleQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly a URI Component
* @returns {string} The string s encoded first by window.encodeURIComponent(), then inSingleQuotedAttr()
*
* @description
* This filter is to be placed in HTML Attribute Value (single-quoted) state for a URI Component.<br/>
* The correct order of encoders is thus: first window.encodeURIComponent(), then inSingleQuotedAttr()
*
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent">encodeURIComponent | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(single-quoted)-state">HTML5 Attribute Value (Single-Quoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href='http://example.com/?q={{{uriComponentInSingleQuotedAttr uri_component}}}'>link</a>
* 
*/
exports.uriComponentInSingleQuotedAttr = function (s) {
    return privFilters.yavs(privFilters.yuc(s));
};

/**
* @function module:xss-filters#uriComponentInDoubleQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly a URI Component
* @returns {string} The string s encoded first by window.encodeURIComponent(), then inDoubleQuotedAttr()
*
* @description
* This filter is to be placed in HTML Attribute Value (double-quoted) state for a URI Component.<br/>
* The correct order of encoders is thus: first window.encodeURIComponent(), then inDoubleQuotedAttr()
*
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent">encodeURIComponent | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(double-quoted)-state">HTML5 Attribute Value (Double-Quoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href="http://example.com/?q={{{uriComponentInDoubleQuotedAttr uri_component}}}">link</a>
* 
*/
exports.uriComponentInDoubleQuotedAttr = function (s) {
    return privFilters.yavd(privFilters.yuc(s));
};


/**
* @function module:xss-filters#uriComponentInUnQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly a URI Component
* @returns {string} The string s encoded first by window.encodeURIComponent(), then inUnQuotedAttr()
*
* @description
* This filter is to be placed in HTML Attribute Value (unquoted) state for a URI Component.<br/>
* The correct order of encoders is thus: first the built-in encodeURIComponent(), then inUnQuotedAttr()
*
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent">encodeURIComponent | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(unquoted)-state">HTML5 Attribute Value (Unquoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href=http://example.com/?q={{{uriComponentInUnQuotedAttr uri_component}}}>link</a>
* 
*/
exports.uriComponentInUnQuotedAttr = function (s) {
    return privFilters.yavu(privFilters.yuc(s));
};

/**
* @function module:xss-filters#uriComponentInHTMLData
*
* @param {string} s - An untrusted user input, supposedly a URI Component
* @returns {string} The string s encoded by window.encodeURIComponent() and then inHTMLData()
*
* @description
* This filter is to be placed in HTML Data state for a URI Component.
*
* <p>Notice: The actual implementation skips inHTMLData(), since '<' is already encoded as '%3C' by encodeURIComponent().</p>
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent">encodeURIComponent | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#data-state">HTML5 Data State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href="http://example.com/">http://example.com/?q={{{uriComponentInHTMLData uri_component}}}</a>
* <a href="http://example.com/">http://example.com/#{{{uriComponentInHTMLData uri_fragment}}}</a>
* 
*/
exports.uriComponentInHTMLData = privFilters.yuc;


/**
* @function module:xss-filters#uriComponentInHTMLComment
*
* @param {string} s - An untrusted user input, supposedly a URI Component
* @returns {string} The string s encoded by window.encodeURIComponent(), and finally inHTMLComment()
*
* @description
* This filter is to be placed in HTML Comment state for a URI Component.
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent">encodeURIComponent | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#data-state">HTML5 Data State</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#comment-state">HTML5 Comment State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <!-- http://example.com/?q={{{uriComponentInHTMLComment uri_component}}} -->
* <!-- http://example.com/#{{{uriComponentInHTMLComment uri_fragment}}} -->
*/
exports.uriComponentInHTMLComment = function (s) {
    return privFilters.yc(privFilters.yuc(s));
};


// uriFragmentInSingleQuotedAttr
// added yubl on top of uriComponentInAttr 
// Rationale: given pattern like this: <a href='{{{uriFragmentInSingleQuotedAttr s}}}'>
//            developer may expect s is always prefixed with #, but an attacker can abuse it with 'javascript:alert(1)'

/**
* @function module:xss-filters#uriFragmentInSingleQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly a URI Fragment
* @returns {string} The string s encoded first by window.encodeURIComponent(), then inSingleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* @description
* This filter is to be placed in HTML Attribute Value (single-quoted) state for a URI Fragment.<br/>
* The correct order of encoders is thus: first window.encodeURIComponent(), then inSingleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent">encodeURIComponent | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(single-quoted)-state">HTML5 Attribute Value (Single-Quoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href='http://example.com/#{{{uriFragmentInSingleQuotedAttr uri_fragment}}}'>link</a>
* 
*/
exports.uriFragmentInSingleQuotedAttr = function (s) {
    return privFilters.yubl(privFilters.yavs(privFilters.yuc(s)));
};

// uriFragmentInDoubleQuotedAttr
// added yubl on top of uriComponentInAttr 
// Rationale: given pattern like this: <a href="{{{uriFragmentInDoubleQuotedAttr s}}}">
//            developer may expect s is always prefixed with #, but an attacker can abuse it with 'javascript:alert(1)'

/**
* @function module:xss-filters#uriFragmentInDoubleQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly a URI Fragment
* @returns {string} The string s encoded first by window.encodeURIComponent(), then inDoubleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* @description
* This filter is to be placed in HTML Attribute Value (double-quoted) state for a URI Fragment.<br/>
* The correct order of encoders is thus: first window.encodeURIComponent(), then inDoubleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent">encodeURIComponent | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(double-quoted)-state">HTML5 Attribute Value (Double-Quoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href="http://example.com/#{{{uriFragmentInDoubleQuotedAttr uri_fragment}}}">link</a>
* 
*/
exports.uriFragmentInDoubleQuotedAttr = function (s) {
    return privFilters.yubl(privFilters.yavd(privFilters.yuc(s)));
};

// uriFragmentInUnQuotedAttr
// added yubl on top of uriComponentInAttr 
// Rationale: given pattern like this: <a href={{{uriFragmentInUnQuotedAttr s}}}>
//            developer may expect s is always prefixed with #, but an attacker can abuse it with 'javascript:alert(1)'

/**
* @function module:xss-filters#uriFragmentInUnQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly a URI Fragment
* @returns {string} The string s encoded first by window.encodeURIComponent(), then inUnQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* @description
* This filter is to be placed in HTML Attribute Value (unquoted) state for a URI Fragment.<br/>
* The correct order of encoders is thus: first the built-in encodeURIComponent(), then inUnQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent">encodeURIComponent | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(unquoted)-state">HTML5 Attribute Value (Unquoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href=http://example.com/#{{{uriFragmentInUnQuotedAttr uri_fragment}}}>link</a>
* 
*/
exports.uriFragmentInUnQuotedAttr = function (s) {
    return privFilters.yubl(privFilters.yavu(privFilters.yuc(s)));
};


/**
* @function module:xss-filters#uriFragmentInHTMLData
* @description This is an alias of {@link module:xss-filters#uriComponentInHTMLData}
* 
* @alias module:xss-filters#uriComponentInHTMLData
*/
exports.uriFragmentInHTMLData = exports.uriComponentInHTMLData;

/**
* @function module:xss-filters#uriFragmentInHTMLComment
* @description This is an alias of {@link module:xss-filters#uriComponentInHTMLComment}
* 
* @alias module:xss-filters#uriComponentInHTMLComment
*/
exports.uriFragmentInHTMLComment = exports.uriComponentInHTMLComment;


/***/ }),
/* 1582 */
/***/ (function(module, exports) {

/*!
 * pascalcase <https://github.com/jonschlinkert/pascalcase>
 *
 * Copyright (c) 2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */

function pascalcase(str) {
  if (typeof str !== 'string') {
    throw new TypeError('expected a string.');
  }
  str = str.replace(/([A-Z])/g, ' $1');
  if (str.length === 1) { return str.toUpperCase(); }
  str = str.replace(/^[\W_]+|[\W_]+$/g, '').toLowerCase();
  str = str.charAt(0).toUpperCase() + str.slice(1);
  return str.replace(/[\W_]+(\w|$)/g, function (_, ch) {
    return ch.toUpperCase();
  });
}

module.exports = pascalcase;


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/*! highlight.js v9.10.0 | BSD3 License | git.io/hljslicense *//* eslint-disable */!function(e){var t="object"==(typeof window==="undefined"?"undefined":_typeof(window))&&window||"object"==(typeof self==="undefined"?"undefined":_typeof(self))&&self; true?e(exports):t&&(t.hljs=e({}),"function"==typeof define&&define.amd&&define([],function(){return t.hljs;}));}(function(e){function t(e){return e.replace(/[&<>]/gm,function(e){return R[e];});}function r(e){return e.nodeName.toLowerCase();}function a(e,t){var r=e&&e.exec(t);return r&&0===r.index;}function n(e){return E.test(e);}function i(e){var t,r,a,i,s=e.className+" ";if(s+=e.parentNode?e.parentNode.className:"",r=M.exec(s))return w(r[1])?r[1]:"no-highlight";for(s=s.split(/\s+/),t=0,a=s.length;a>t;t++){if(i=s[t],n(i)||w(i))return i;}}function s(e){var t,r={},a=Array.prototype.slice.call(arguments,1);for(t in e){r[t]=e[t];}return a.forEach(function(e){for(t in e){r[t]=e[t];}}),r;}function c(e){var t=[];return function a(e,n){for(var i=e.firstChild;i;i=i.nextSibling){3===i.nodeType?n+=i.nodeValue.length:1===i.nodeType&&(t.push({event:"start",offset:n,node:i}),n=a(i,n),r(i).match(/br|hr|img|input/)||t.push({event:"stop",offset:n,node:i}));}return n;}(e,0),t;}function o(e,a,n){function i(){return e.length&&a.length?e[0].offset!==a[0].offset?e[0].offset<a[0].offset?e:a:"start"===a[0].event?e:a:e.length?e:a;}function s(e){function a(e){return" "+e.nodeName+'="'+t(e.value)+'"';}u+="<"+r(e)+N.map.call(e.attributes,a).join("")+">";}function c(e){u+="</"+r(e)+">";}function o(e){("start"===e.event?s:c)(e.node);}for(var l=0,u="",d=[];e.length||a.length;){var b=i();if(u+=t(n.substring(l,b[0].offset)),l=b[0].offset,b===e){d.reverse().forEach(c);do{o(b.splice(0,1)[0]),b=i();}while(b===e&&b.length&&b[0].offset===l);d.reverse().forEach(s);}else"start"===b[0].event?d.push(b[0].node):d.pop(),o(b.splice(0,1)[0]);}return u+t(n.substr(l));}function l(e){return e.v&&!e.cached_variants&&(e.cached_variants=e.v.map(function(t){return s(e,{v:null},t);})),e.cached_variants||e.eW&&[s(e)]||[e];}function u(e){function t(e){return e&&e.source||e;}function r(r,a){return new RegExp(t(r),"m"+(e.cI?"i":"")+(a?"g":""));}function a(n,i){if(!n.compiled){if(n.compiled=!0,n.k=n.k||n.bK,n.k){var s={},c=function c(t,r){e.cI&&(r=r.toLowerCase()),r.split(" ").forEach(function(e){var r=e.split("|");s[r[0]]=[t,r[1]?Number(r[1]):1];});};"string"==typeof n.k?c("keyword",n.k):k(n.k).forEach(function(e){c(e,n.k[e]);}),n.k=s;}n.lR=r(n.l||/\w+/,!0),i&&(n.bK&&(n.b="\\b("+n.bK.split(" ").join("|")+")\\b"),n.b||(n.b=/\B|\b/),n.bR=r(n.b),n.e||n.eW||(n.e=/\B|\b/),n.e&&(n.eR=r(n.e)),n.tE=t(n.e)||"",n.eW&&i.tE&&(n.tE+=(n.e?"|":"")+i.tE)),n.i&&(n.iR=r(n.i)),null==n.r&&(n.r=1),n.c||(n.c=[]),n.c=Array.prototype.concat.apply([],n.c.map(function(e){return l("self"===e?n:e);})),n.c.forEach(function(e){a(e,n);}),n.starts&&a(n.starts,i);var o=n.c.map(function(e){return e.bK?"\\.?("+e.b+")\\.?":e.b;}).concat([n.tE,n.i]).map(t).filter(Boolean);n.t=o.length?r(o.join("|"),!0):{exec:function exec(){return null;}};}}a(e);}function d(e,r,n,i){function s(e,t){var r,n;for(r=0,n=t.c.length;n>r;r++){if(a(t.c[r].bR,e))return t.c[r];}}function c(e,t){if(a(e.eR,t)){for(;e.endsParent&&e.parent;){e=e.parent;}return e;}return e.eW?c(e.parent,t):void 0;}function o(e,t){return!n&&a(t.iR,e);}function l(e,t){var r=v.cI?t[0].toLowerCase():t[0];return e.k.hasOwnProperty(r)&&e.k[r];}function p(e,t,r,a){var n=a?"":L.classPrefix,i='<span class="'+n,s=r?"":S;return i+=e+'">',i+t+s;}function m(){var e,r,a,n;if(!N.k)return t(E);for(n="",r=0,N.lR.lastIndex=0,a=N.lR.exec(E);a;){n+=t(E.substring(r,a.index)),e=l(N,a),e?(M+=e[1],n+=p(e[0],t(a[0]))):n+=t(a[0]),r=N.lR.lastIndex,a=N.lR.exec(E);}return n+t(E.substr(r));}function f(){var e="string"==typeof N.sL;if(e&&!x[N.sL])return t(E);var r=e?d(N.sL,E,!0,k[N.sL]):b(E,N.sL.length?N.sL:void 0);return N.r>0&&(M+=r.r),e&&(k[N.sL]=r.top),p(r.language,r.value,!1,!0);}function g(){C+=null!=N.sL?f():m(),E="";}function _(e){C+=e.cN?p(e.cN,"",!0):"",N=Object.create(e,{parent:{value:N}});}function h(e,t){if(E+=e,null==t)return g(),0;var r=s(t,N);if(r)return r.skip?E+=t:(r.eB&&(E+=t),g(),r.rB||r.eB||(E=t)),_(r,t),r.rB?0:t.length;var a=c(N,t);if(a){var n=N;n.skip?E+=t:(n.rE||n.eE||(E+=t),g(),n.eE&&(E=t));do{N.cN&&(C+=S),N.skip||(M+=N.r),N=N.parent;}while(N!==a.parent);return a.starts&&_(a.starts,""),n.rE?0:t.length;}if(o(t,N))throw new Error('Illegal lexeme "'+t+'" for mode "'+(N.cN||"<unnamed>")+'"');return E+=t,t.length||1;}var v=w(e);if(!v)throw new Error('Unknown language: "'+e+'"');u(v);var y,N=i||v,k={},C="";for(y=N;y!==v;y=y.parent){y.cN&&(C=p(y.cN,"",!0)+C);}var E="",M=0;try{for(var B,R,A=0;;){if(N.t.lastIndex=A,B=N.t.exec(r),!B)break;R=h(r.substring(A,B.index),B[0]),A=B.index+R;}for(h(r.substr(A)),y=N;y.parent;y=y.parent){y.cN&&(C+=S);}return{r:M,value:C,language:e,top:N};}catch($){if($.message&&-1!==$.message.indexOf("Illegal"))return{r:0,value:t(r)};throw $;}}function b(e,r){r=r||L.languages||k(x);var a={r:0,value:t(e)},n=a;return r.filter(w).forEach(function(t){var r=d(t,e,!1);r.language=t,r.r>n.r&&(n=r),r.r>a.r&&(n=a,a=r);}),n.language&&(a.second_best=n),a;}function p(e){return L.tabReplace||L.useBR?e.replace(B,function(e,t){return L.useBR&&"\n"===e?"<br>":L.tabReplace?t.replace(/\t/g,L.tabReplace):"";}):e;}function m(e,t,r){var a=t?C[t]:r,n=[e.trim()];return e.match(/\bhljs\b/)||n.push("hljs"),-1===e.indexOf(a)&&n.push(a),n.join(" ").trim();}function f(e){var t,r,a,s,l,u=i(e);n(u)||(L.useBR?(t=document.createElementNS("http://www.w3.org/1999/xhtml","div"),t.innerHTML=e.innerHTML.replace(/\n/g,"").replace(/<br[ \/]*>/g,"\n")):t=e,l=t.textContent,a=u?d(u,l,!0):b(l),r=c(t),r.length&&(s=document.createElementNS("http://www.w3.org/1999/xhtml","div"),s.innerHTML=a.value,a.value=o(r,c(s),l)),a.value=p(a.value),e.innerHTML=a.value,e.className=m(e.className,u,a.language),e.result={language:a.language,re:a.r},a.second_best&&(e.second_best={language:a.second_best.language,re:a.second_best.r}));}function g(e){L=s(L,e);}function _(){if(!_.called){_.called=!0;var e=document.querySelectorAll("pre code");N.forEach.call(e,f);}}function h(){addEventListener("DOMContentLoaded",_,!1),addEventListener("load",_,!1);}function v(t,r){var a=x[t]=r(e);a.aliases&&a.aliases.forEach(function(e){C[e]=t;});}function y(){return k(x);}function w(e){return e=(e||"").toLowerCase(),x[e]||x[C[e]];}var N=[],k=Object.keys,x={},C={},E=/^(no-?highlight|plain|text)$/i,M=/\blang(?:uage)?-([\w-]+)\b/i,B=/((^(<[^>]+>|\t|)+|(?:\n)))/gm,S="</span>",L={classPrefix:"hljs-",tabReplace:null,useBR:!1,languages:void 0},R={"&":"&amp;","<":"&lt;",">":"&gt;"};return e.highlight=d,e.highlightAuto=b,e.fixMarkup=p,e.highlightBlock=f,e.configure=g,e.initHighlighting=_,e.initHighlightingOnLoad=h,e.registerLanguage=v,e.listLanguages=y,e.getLanguage=w,e.inherit=s,e.IR="[a-zA-Z]\\w*",e.UIR="[a-zA-Z_]\\w*",e.NR="\\b\\d+(\\.\\d+)?",e.CNR="(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)",e.BNR="\\b(0b[01]+)",e.RSR="!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~",e.BE={b:"\\\\[\\s\\S]",r:0},e.ASM={cN:"string",b:"'",e:"'",i:"\\n",c:[e.BE]},e.QSM={cN:"string",b:'"',e:'"',i:"\\n",c:[e.BE]},e.PWM={b:/\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|like)\b/},e.C=function(t,r,a){var n=e.inherit({cN:"comment",b:t,e:r,c:[]},a||{});return n.c.push(e.PWM),n.c.push({cN:"doctag",b:"(?:TODO|FIXME|NOTE|BUG|XXX):",r:0}),n;},e.CLCM=e.C("//","$"),e.CBCM=e.C("/\\*","\\*/"),e.HCM=e.C("#","$"),e.NM={cN:"number",b:e.NR,r:0},e.CNM={cN:"number",b:e.CNR,r:0},e.BNM={cN:"number",b:e.BNR,r:0},e.CSSNM={cN:"number",b:e.NR+"(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",r:0},e.RM={cN:"regexp",b:/\//,e:/\/[gimuy]*/,i:/\n/,c:[e.BE,{b:/\[/,e:/\]/,r:0,c:[e.BE]}]},e.TM={cN:"title",b:e.IR,r:0},e.UTM={cN:"title",b:e.UIR,r:0},e.METHOD_GUARD={b:"\\.\\s*"+e.UIR,r:0},e.registerLanguage("apache",function(e){var t={cN:"number",b:"[\\$%]\\d+"};return{aliases:["apacheconf"],cI:!0,c:[e.HCM,{cN:"section",b:"</?",e:">"},{cN:"attribute",b:/\w+/,r:0,k:{nomarkup:"order deny allow setenv rewriterule rewriteengine rewritecond documentroot sethandler errordocument loadmodule options header listen serverroot servername"},starts:{e:/$/,r:0,k:{literal:"on off all"},c:[{cN:"meta",b:"\\s\\[",e:"\\]$"},{cN:"variable",b:"[\\$%]\\{",e:"\\}",c:["self",t]},t,e.QSM]}}],i:/\S/};}),e.registerLanguage("bash",function(e){var t={cN:"variable",v:[{b:/\$[\w\d#@][\w\d_]*/},{b:/\$\{(.*?)}/}]},r={cN:"string",b:/"/,e:/"/,c:[e.BE,t,{cN:"variable",b:/\$\(/,e:/\)/,c:[e.BE]}]},a={cN:"string",b:/'/,e:/'/};return{aliases:["sh","zsh"],l:/-?[a-z\._]+/,k:{keyword:"if then else elif fi for while in do done case esac function",literal:"true false",built_in:"break cd continue eval exec exit export getopts hash pwd readonly return shift test times trap umask unset alias bind builtin caller command declare echo enable help let local logout mapfile printf read readarray source type typeset ulimit unalias set shopt autoload bg bindkey bye cap chdir clone comparguments compcall compctl compdescribe compfiles compgroups compquote comptags comptry compvalues dirs disable disown echotc echoti emulate fc fg float functions getcap getln history integer jobs kill limit log noglob popd print pushd pushln rehash sched setcap setopt stat suspend ttyctl unfunction unhash unlimit unsetopt vared wait whence where which zcompile zformat zftp zle zmodload zparseopts zprof zpty zregexparse zsocket zstyle ztcp",_:"-ne -eq -lt -gt -f -d -e -s -l -a"},c:[{cN:"meta",b:/^#![^\n]+sh\s*$/,r:10},{cN:"function",b:/\w[\w\d_]*\s*\(\s*\)\s*\{/,rB:!0,c:[e.inherit(e.TM,{b:/\w[\w\d_]*/})],r:0},e.HCM,r,a,t]};}),e.registerLanguage("coffeescript",function(e){var t={keyword:"in if for while finally new do return else break catch instanceof throw try this switch continue typeof delete debugger super yield import export from as default await then unless until loop of by when and or is isnt not",literal:"true false null undefined yes no on off",built_in:"npm require console print module global window document"},r="[A-Za-z$_][0-9A-Za-z$_]*",a={cN:"subst",b:/#\{/,e:/}/,k:t},n=[e.BNM,e.inherit(e.CNM,{starts:{e:"(\\s*/)?",r:0}}),{cN:"string",v:[{b:/'''/,e:/'''/,c:[e.BE]},{b:/'/,e:/'/,c:[e.BE]},{b:/"""/,e:/"""/,c:[e.BE,a]},{b:/"/,e:/"/,c:[e.BE,a]}]},{cN:"regexp",v:[{b:"///",e:"///",c:[a,e.HCM]},{b:"//[gim]*",r:0},{b:/\/(?![ *])(\\\/|.)*?\/[gim]*(?=\W|$)/}]},{b:"@"+r},{sL:"javascript",eB:!0,eE:!0,v:[{b:"```",e:"```"},{b:"`",e:"`"}]}];a.c=n;var i=e.inherit(e.TM,{b:r}),s="(\\(.*\\))?\\s*\\B[-=]>",c={cN:"params",b:"\\([^\\(]",rB:!0,c:[{b:/\(/,e:/\)/,k:t,c:["self"].concat(n)}]};return{aliases:["coffee","cson","iced"],k:t,i:/\/\*/,c:n.concat([e.C("###","###"),e.HCM,{cN:"function",b:"^\\s*"+r+"\\s*=\\s*"+s,e:"[-=]>",rB:!0,c:[i,c]},{b:/[:\(,=]\s*/,r:0,c:[{cN:"function",b:s,e:"[-=]>",rB:!0,c:[c]}]},{cN:"class",bK:"class",e:"$",i:/[:="\[\]]/,c:[{bK:"extends",eW:!0,i:/[:="\[\]]/,c:[i]},i]},{b:r+":",e:":",rB:!0,rE:!0,r:0}])};}),e.registerLanguage("cpp",function(e){var t={cN:"keyword",b:"\\b[a-z\\d_]*_t\\b"},r={cN:"string",v:[{b:'(u8?|U)?L?"',e:'"',i:"\\n",c:[e.BE]},{b:'(u8?|U)?R"',e:'"',c:[e.BE]},{b:"'\\\\?.",e:"'",i:"."}]},a={cN:"number",v:[{b:"\\b(0b[01']+)"},{b:"\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)(u|U|l|L|ul|UL|f|F|b|B)"},{b:"(-?)(\\b0[xX][a-fA-F0-9']+|(\\b[\\d']+(\\.[\\d']*)?|\\.[\\d']+)([eE][-+]?[\\d']+)?)"}],r:0},n={cN:"meta",b:/#\s*[a-z]+\b/,e:/$/,k:{"meta-keyword":"if else elif endif define undef warning error line pragma ifdef ifndef include"},c:[{b:/\\\n/,r:0},e.inherit(r,{cN:"meta-string"}),{cN:"meta-string",b:/<[^\n>]*>/,e:/$/,i:"\\n"},e.CLCM,e.CBCM]},i=e.IR+"\\s*\\(",s={keyword:"int float while private char catch import module export virtual operator sizeof dynamic_cast|10 typedef const_cast|10 const struct for static_cast|10 union namespace unsigned long volatile static protected bool template mutable if public friend do goto auto void enum else break extern using class asm case typeid short reinterpret_cast|10 default double register explicit signed typename try this switch continue inline delete alignof constexpr decltype noexcept static_assert thread_local restrict _Bool complex _Complex _Imaginary atomic_bool atomic_char atomic_schar atomic_uchar atomic_short atomic_ushort atomic_int atomic_uint atomic_long atomic_ulong atomic_llong atomic_ullong new throw return",built_in:"std string cin cout cerr clog stdin stdout stderr stringstream istringstream ostringstream auto_ptr deque list queue stack vector map set bitset multiset multimap unordered_set unordered_map unordered_multiset unordered_multimap array shared_ptr abort abs acos asin atan2 atan calloc ceil cosh cos exit exp fabs floor fmod fprintf fputs free frexp fscanf isalnum isalpha iscntrl isdigit isgraph islower isprint ispunct isspace isupper isxdigit tolower toupper labs ldexp log10 log malloc realloc memchr memcmp memcpy memset modf pow printf putchar puts scanf sinh sin snprintf sprintf sqrt sscanf strcat strchr strcmp strcpy strcspn strlen strncat strncmp strncpy strpbrk strrchr strspn strstr tanh tan vfprintf vprintf vsprintf endl initializer_list unique_ptr",literal:"true false nullptr NULL"},c=[t,e.CLCM,e.CBCM,a,r];return{aliases:["c","cc","h","c++","h++","hpp"],k:s,i:"</",c:c.concat([n,{b:"\\b(deque|list|queue|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array)\\s*<",e:">",k:s,c:["self",t]},{b:e.IR+"::",k:s},{v:[{b:/=/,e:/;/},{b:/\(/,e:/\)/},{bK:"new throw return else",e:/;/}],k:s,c:c.concat([{b:/\(/,e:/\)/,k:s,c:c.concat(["self"]),r:0}]),r:0},{cN:"function",b:"("+e.IR+"[\\*&\\s]+)+"+i,rB:!0,e:/[{;=]/,eE:!0,k:s,i:/[^\w\s\*&]/,c:[{b:i,rB:!0,c:[e.TM],r:0},{cN:"params",b:/\(/,e:/\)/,k:s,r:0,c:[e.CLCM,e.CBCM,r,a,t]},e.CLCM,e.CBCM,n]}]),exports:{preprocessor:n,strings:r,k:s}};}),e.registerLanguage("cs",function(e){var t={keyword:"abstract as base bool break byte case catch char checked const continue decimal default delegate do double else enum event explicit extern finally fixed float for foreach goto if implicit in int interface internal is lock long object operator out override params private protected public readonly ref sbyte sealed short sizeof stackalloc static string struct switch this try typeof uint ulong unchecked unsafe ushort using virtual void volatile while nameof add alias ascending async await by descending dynamic equals from get global group into join let on orderby partial remove select set value var where yield",literal:"null false true"},r={cN:"string",b:'@"',e:'"',c:[{b:'""'}]},a=e.inherit(r,{i:/\n/}),n={cN:"subst",b:"{",e:"}",k:t},i=e.inherit(n,{i:/\n/}),s={cN:"string",b:/\$"/,e:'"',i:/\n/,c:[{b:"{{"},{b:"}}"},e.BE,i]},c={cN:"string",b:/\$@"/,e:'"',c:[{b:"{{"},{b:"}}"},{b:'""'},n]},o=e.inherit(c,{i:/\n/,c:[{b:"{{"},{b:"}}"},{b:'""'},i]});n.c=[c,s,r,e.ASM,e.QSM,e.CNM,e.CBCM],i.c=[o,s,a,e.ASM,e.QSM,e.CNM,e.inherit(e.CBCM,{i:/\n/})];var l={v:[c,s,r,e.ASM,e.QSM]},u=e.IR+"(<"+e.IR+"(\\s*,\\s*"+e.IR+")*>)?(\\[\\])?";return{aliases:["csharp"],k:t,i:/::/,c:[e.C("///","$",{rB:!0,c:[{cN:"doctag",v:[{b:"///",r:0},{b:"<!--|-->"},{b:"</?",e:">"}]}]}),e.CLCM,e.CBCM,{cN:"meta",b:"#",e:"$",k:{"meta-keyword":"if else elif endif define undef warning error line region endregion pragma checksum"}},l,e.CNM,{bK:"class interface",e:/[{;=]/,i:/[^\s:]/,c:[e.TM,e.CLCM,e.CBCM]},{bK:"namespace",e:/[{;=]/,i:/[^\s:]/,c:[e.inherit(e.TM,{b:"[a-zA-Z](\\.?\\w)*"}),e.CLCM,e.CBCM]},{bK:"new return throw await",r:0},{cN:"function",b:"("+u+"\\s+)+"+e.IR+"\\s*\\(",rB:!0,e:/[{;=]/,eE:!0,k:t,c:[{b:e.IR+"\\s*\\(",rB:!0,c:[e.TM],r:0},{cN:"params",b:/\(/,e:/\)/,eB:!0,eE:!0,k:t,r:0,c:[l,e.CNM,e.CBCM]},e.CLCM,e.CBCM]}]};}),e.registerLanguage("css",function(e){var t="[a-zA-Z-][a-zA-Z0-9_-]*",r={b:/[A-Z\_\.\-]+\s*:/,rB:!0,e:";",eW:!0,c:[{cN:"attribute",b:/\S/,e:":",eE:!0,starts:{eW:!0,eE:!0,c:[{b:/[\w-]+\(/,rB:!0,c:[{cN:"built_in",b:/[\w-]+/},{b:/\(/,e:/\)/,c:[e.ASM,e.QSM]}]},e.CSSNM,e.QSM,e.ASM,e.CBCM,{cN:"number",b:"#[0-9A-Fa-f]+"},{cN:"meta",b:"!important"}]}}]};return{cI:!0,i:/[=\/|'\$]/,c:[e.CBCM,{cN:"selector-id",b:/#[A-Za-z0-9_-]+/},{cN:"selector-class",b:/\.[A-Za-z0-9_-]+/},{cN:"selector-attr",b:/\[/,e:/\]/,i:"$"},{cN:"selector-pseudo",b:/:(:)?[a-zA-Z0-9\_\-\+\(\)"'.]+/},{b:"@(font-face|page)",l:"[a-z-]+",k:"font-face page"},{b:"@",e:"[{;]",i:/:/,c:[{cN:"keyword",b:/\w+/},{b:/\s/,eW:!0,eE:!0,r:0,c:[e.ASM,e.QSM,e.CSSNM]}]},{cN:"selector-tag",b:t,r:0},{b:"{",e:"}",i:/\S/,c:[e.CBCM,r]}]};}),e.registerLanguage("diff",function(e){return{aliases:["patch"],c:[{cN:"meta",r:10,v:[{b:/^@@ +\-\d+,\d+ +\+\d+,\d+ +@@$/},{b:/^\*\*\* +\d+,\d+ +\*\*\*\*$/},{b:/^\-\-\- +\d+,\d+ +\-\-\-\-$/}]},{cN:"comment",v:[{b:/Index: /,e:/$/},{b:/={3,}/,e:/$/},{b:/^\-{3}/,e:/$/},{b:/^\*{3} /,e:/$/},{b:/^\+{3}/,e:/$/},{b:/\*{5}/,e:/\*{5}$/}]},{cN:"addition",b:"^\\+",e:"$"},{cN:"deletion",b:"^\\-",e:"$"},{cN:"addition",b:"^\\!",e:"$"}]};}),e.registerLanguage("http",function(e){var t="HTTP/[0-9\\.]+";return{aliases:["https"],i:"\\S",c:[{b:"^"+t,e:"$",c:[{cN:"number",b:"\\b\\d{3}\\b"}]},{b:"^[A-Z]+ (.*?) "+t+"$",rB:!0,e:"$",c:[{cN:"string",b:" ",e:" ",eB:!0,eE:!0},{b:t},{cN:"keyword",b:"[A-Z]+"}]},{cN:"attribute",b:"^\\w",e:": ",eE:!0,i:"\\n|\\s|=",starts:{e:"$",r:0}},{b:"\\n\\n",starts:{sL:[],eW:!0}}]};}),e.registerLanguage("ini",function(e){var t={cN:"string",c:[e.BE],v:[{b:"'''",e:"'''",r:10},{b:'"""',e:'"""',r:10},{b:'"',e:'"'},{b:"'",e:"'"}]};return{aliases:["toml"],cI:!0,i:/\S/,c:[e.C(";","$"),e.HCM,{cN:"section",b:/^\s*\[+/,e:/\]+/},{b:/^[a-z0-9\[\]_-]+\s*=\s*/,e:"$",rB:!0,c:[{cN:"attr",b:/[a-z0-9\[\]_-]+/},{b:/=/,eW:!0,r:0,c:[{cN:"literal",b:/\bon|off|true|false|yes|no\b/},{cN:"variable",v:[{b:/\$[\w\d"][\w\d_]*/},{b:/\$\{(.*?)}/}]},t,{cN:"number",b:/([\+\-]+)?[\d]+_[\d_]+/},e.NM]}]}]};}),e.registerLanguage("java",function(e){var t="[À-ʸa-zA-Z_$][À-ʸa-zA-Z_$0-9]*",r=t+"(<"+t+"(\\s*,\\s*"+t+")*>)?",a="false synchronized int abstract float private char boolean static null if const for true while long strictfp finally protected import native final void enum else break transient catch instanceof byte super volatile case assert short package default double public try this switch continue throws protected public private module requires exports do",n="\\b(0[bB]([01]+[01_]+[01]+|[01]+)|0[xX]([a-fA-F0-9]+[a-fA-F0-9_]+[a-fA-F0-9]+|[a-fA-F0-9]+)|(([\\d]+[\\d_]+[\\d]+|[\\d]+)(\\.([\\d]+[\\d_]+[\\d]+|[\\d]+))?|\\.([\\d]+[\\d_]+[\\d]+|[\\d]+))([eE][-+]?\\d+)?)[lLfF]?",i={cN:"number",b:n,r:0};return{aliases:["jsp"],k:a,i:/<\/|#/,c:[e.C("/\\*\\*","\\*/",{r:0,c:[{b:/\w+@/,r:0},{cN:"doctag",b:"@[A-Za-z]+"}]}),e.CLCM,e.CBCM,e.ASM,e.QSM,{cN:"class",bK:"class interface",e:/[{;=]/,eE:!0,k:"class interface",i:/[:"\[\]]/,c:[{bK:"extends implements"},e.UTM]},{bK:"new throw return else",r:0},{cN:"function",b:"("+r+"\\s+)+"+e.UIR+"\\s*\\(",rB:!0,e:/[{;=]/,eE:!0,k:a,c:[{b:e.UIR+"\\s*\\(",rB:!0,r:0,c:[e.UTM]},{cN:"params",b:/\(/,e:/\)/,k:a,r:0,c:[e.ASM,e.QSM,e.CNM,e.CBCM]},e.CLCM,e.CBCM]},i,{cN:"meta",b:"@[A-Za-z]+"}]};}),e.registerLanguage("javascript",function(e){var t="[A-Za-z$_][0-9A-Za-z$_]*",r={keyword:"in of if for while finally var new function do return void else break catch instanceof with throw case default try this switch continue typeof delete let yield const export super debugger as async await static import from as",literal:"true false null undefined NaN Infinity",built_in:"eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent encodeURI encodeURIComponent escape unescape Object Function Boolean Error EvalError InternalError RangeError ReferenceError StopIteration SyntaxError TypeError URIError Number Math Date String RegExp Array Float32Array Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect Promise"},a={cN:"number",v:[{b:"\\b(0[bB][01]+)"},{b:"\\b(0[oO][0-7]+)"},{b:e.CNR}],r:0},n={cN:"subst",b:"\\$\\{",e:"\\}",k:r,c:[]},i={cN:"string",b:"`",e:"`",c:[e.BE,n]};n.c=[e.ASM,e.QSM,i,a,e.RM];var s=n.c.concat([e.CBCM,e.CLCM]);return{aliases:["js","jsx"],k:r,c:[{cN:"meta",r:10,b:/^\s*['"]use (strict|asm)['"]/},{cN:"meta",b:/^#!/,e:/$/},e.ASM,e.QSM,i,e.CLCM,e.CBCM,a,{b:/[{,]\s*/,r:0,c:[{b:t+"\\s*:",rB:!0,r:0,c:[{cN:"attr",b:t,r:0}]}]},{b:"("+e.RSR+"|\\b(case|return|throw)\\b)\\s*",k:"return throw case",c:[e.CLCM,e.CBCM,e.RM,{cN:"function",b:"(\\(.*?\\)|"+t+")\\s*=>",rB:!0,e:"\\s*=>",c:[{cN:"params",v:[{b:t},{b:/\(\s*\)/},{b:/\(/,e:/\)/,eB:!0,eE:!0,k:r,c:s}]}]},{b:/</,e:/(\/\w+|\w+\/)>/,sL:"xml",c:[{b:/<\w+\s*\/>/,skip:!0},{b:/<\w+/,e:/(\/\w+|\w+\/)>/,skip:!0,c:[{b:/<\w+\s*\/>/,skip:!0},"self"]}]}],r:0},{cN:"function",bK:"function",e:/\{/,eE:!0,c:[e.inherit(e.TM,{b:t}),{cN:"params",b:/\(/,e:/\)/,eB:!0,eE:!0,c:s}],i:/\[|%/},{b:/\$[(.]/},e.METHOD_GUARD,{cN:"class",bK:"class",e:/[{;=]/,eE:!0,i:/[:"\[\]]/,c:[{bK:"extends"},e.UTM]},{bK:"constructor",e:/\{/,eE:!0}],i:/#(?!!)/};}),e.registerLanguage("json",function(e){var t={literal:"true false null"},r=[e.QSM,e.CNM],a={e:",",eW:!0,eE:!0,c:r,k:t},n={b:"{",e:"}",c:[{cN:"attr",b:/"/,e:/"/,c:[e.BE],i:"\\n"},e.inherit(a,{b:/:/})],i:"\\S"},i={b:"\\[",e:"\\]",c:[e.inherit(a)],i:"\\S"};return r.splice(r.length,0,n,i),{c:r,k:t,i:"\\S"};}),e.registerLanguage("makefile",function(e){var t={cN:"variable",b:/\$\(/,e:/\)/,c:[e.BE]};return{aliases:["mk","mak"],c:[e.HCM,{b:/^\w+\s*\W*=/,rB:!0,r:0,starts:{e:/\s*\W*=/,eE:!0,starts:{e:/$/,r:0,c:[t]}}},{cN:"section",b:/^[\w]+:\s*$/},{cN:"meta",b:/^\.PHONY:/,e:/$/,k:{"meta-keyword":".PHONY"},l:/[\.\w]+/},{b:/^\t+/,e:/$/,r:0,c:[e.QSM,t]}]};}),e.registerLanguage("xml",function(e){var t="[A-Za-z0-9\\._:-]+",r={eW:!0,i:/</,r:0,c:[{cN:"attr",b:t,r:0},{b:/=\s*/,r:0,c:[{cN:"string",endsParent:!0,v:[{b:/"/,e:/"/},{b:/'/,e:/'/},{b:/[^\s"'=<>`]+/}]}]}]};return{aliases:["html","xhtml","rss","atom","xjb","xsd","xsl","plist"],cI:!0,c:[{cN:"meta",b:"<!DOCTYPE",e:">",r:10,c:[{b:"\\[",e:"\\]"}]},e.C("<!--","-->",{r:10}),{b:"<\\!\\[CDATA\\[",e:"\\]\\]>",r:10},{b:/<\?(php)?/,e:/\?>/,sL:"php",c:[{b:"/\\*",e:"\\*/",skip:!0}]},{cN:"tag",b:"<style(?=\\s|>|$)",e:">",k:{name:"style"},c:[r],starts:{e:"</style>",rE:!0,sL:["css","xml"]}},{cN:"tag",b:"<script(?=\\s|>|$)",e:">",k:{name:"script"},c:[r],starts:{e:"</script>",rE:!0,sL:["actionscript","javascript","handlebars","xml"]}},{cN:"meta",v:[{b:/<\?xml/,e:/\?>/,r:10},{b:/<\?\w+/,e:/\?>/}]},{cN:"tag",b:"</?",e:"/?>",c:[{cN:"name",b:/[^\/><\s]+/,r:0},r]}]};}),e.registerLanguage("markdown",function(e){return{aliases:["md","mkdown","mkd"],c:[{cN:"section",v:[{b:"^#{1,6}",e:"$"},{b:"^.+?\\n[=-]{2,}$"}]},{b:"<",e:">",sL:"xml",r:0},{cN:"bullet",b:"^([*+-]|(\\d+\\.))\\s+"},{cN:"strong",b:"[*_]{2}.+?[*_]{2}"},{cN:"emphasis",v:[{b:"\\*.+?\\*"},{b:"_.+?_",r:0}]},{cN:"quote",b:"^>\\s+",e:"$"},{cN:"code",v:[{b:"^```w*s*$",e:"^```s*$"},{b:"`.+?`"},{b:"^( {4}|	)",e:"$",r:0}]},{b:"^[-\\*]{3,}",e:"$"},{b:"\\[.+?\\][\\(\\[].*?[\\)\\]]",rB:!0,c:[{cN:"string",b:"\\[",e:"\\]",eB:!0,rE:!0,r:0},{cN:"link",b:"\\]\\(",e:"\\)",eB:!0,eE:!0},{cN:"symbol",b:"\\]\\[",e:"\\]",eB:!0,eE:!0}],r:10},{b:/^\[[^\n]+\]:/,rB:!0,c:[{cN:"symbol",b:/\[/,e:/\]/,eB:!0,eE:!0},{cN:"link",b:/:\s*/,e:/$/,eB:!0}]}]};}),e.registerLanguage("nginx",function(e){var t={cN:"variable",v:[{b:/\$\d+/},{b:/\$\{/,e:/}/},{b:"[\\$\\@]"+e.UIR}]},r={eW:!0,l:"[a-z/_]+",k:{literal:"on off yes no true false none blocked debug info notice warn error crit select break last permanent redirect kqueue rtsig epoll poll /dev/poll"},r:0,i:"=>",c:[e.HCM,{cN:"string",c:[e.BE,t],v:[{b:/"/,e:/"/},{b:/'/,e:/'/}]},{b:"([a-z]+):/",e:"\\s",eW:!0,eE:!0,c:[t]},{cN:"regexp",c:[e.BE,t],v:[{b:"\\s\\^",e:"\\s|{|;",rE:!0},{b:"~\\*?\\s+",e:"\\s|{|;",rE:!0},{b:"\\*(\\.[a-z\\-]+)+"},{b:"([a-z\\-]+\\.)+\\*"}]},{cN:"number",b:"\\b\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}(:\\d{1,5})?\\b"},{cN:"number",b:"\\b\\d+[kKmMgGdshdwy]*\\b",r:0},t]};return{aliases:["nginxconf"],c:[e.HCM,{b:e.UIR+"\\s+{",rB:!0,e:"{",c:[{cN:"section",b:e.UIR}],r:0},{b:e.UIR+"\\s",e:";|{",rB:!0,c:[{cN:"attribute",b:e.UIR,starts:r}],r:0}],i:"[^\\s\\}]"};}),e.registerLanguage("objectivec",function(e){var t={cN:"built_in",b:"\\b(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)\\w+"},r={keyword:"int float while char export sizeof typedef const struct for union unsigned long volatile static bool mutable if do return goto void enum else break extern asm case short default double register explicit signed typename this switch continue wchar_t inline readonly assign readwrite self @synchronized id typeof nonatomic super unichar IBOutlet IBAction strong weak copy in out inout bycopy byref oneway __strong __weak __block __autoreleasing @private @protected @public @try @property @end @throw @catch @finally @autoreleasepool @synthesize @dynamic @selector @optional @required @encode @package @import @defs @compatibility_alias __bridge __bridge_transfer __bridge_retained __bridge_retain __covariant __contravariant __kindof _Nonnull _Nullable _Null_unspecified __FUNCTION__ __PRETTY_FUNCTION__ __attribute__ getter setter retain unsafe_unretained nonnull nullable null_unspecified null_resettable class instancetype NS_DESIGNATED_INITIALIZER NS_UNAVAILABLE NS_REQUIRES_SUPER NS_RETURNS_INNER_POINTER NS_INLINE NS_AVAILABLE NS_DEPRECATED NS_ENUM NS_OPTIONS NS_SWIFT_UNAVAILABLE NS_ASSUME_NONNULL_BEGIN NS_ASSUME_NONNULL_END NS_REFINED_FOR_SWIFT NS_SWIFT_NAME NS_SWIFT_NOTHROW NS_DURING NS_HANDLER NS_ENDHANDLER NS_VALUERETURN NS_VOIDRETURN",literal:"false true FALSE TRUE nil YES NO NULL",built_in:"BOOL dispatch_once_t dispatch_queue_t dispatch_sync dispatch_async dispatch_once"},a=/[a-zA-Z@][a-zA-Z0-9_]*/,n="@interface @class @protocol @implementation";return{aliases:["mm","objc","obj-c"],k:r,l:a,i:"</",c:[t,e.CLCM,e.CBCM,e.CNM,e.QSM,{cN:"string",v:[{b:'@"',e:'"',i:"\\n",c:[e.BE]},{b:"'",e:"[^\\\\]'",i:"[^\\\\][^']"}]},{cN:"meta",b:"#",e:"$",c:[{cN:"meta-string",v:[{b:'"',e:'"'},{b:"<",e:">"}]}]},{cN:"class",b:"("+n.split(" ").join("|")+")\\b",e:"({|$)",eE:!0,k:n,l:a,c:[e.UTM]},{b:"\\."+e.UIR,r:0}]};}),e.registerLanguage("perl",function(e){var t="getpwent getservent quotemeta msgrcv scalar kill dbmclose undef lc ma syswrite tr send umask sysopen shmwrite vec qx utime local oct semctl localtime readpipe do return format read sprintf dbmopen pop getpgrp not getpwnam rewinddir qqfileno qw endprotoent wait sethostent bless s|0 opendir continue each sleep endgrent shutdown dump chomp connect getsockname die socketpair close flock exists index shmgetsub for endpwent redo lstat msgctl setpgrp abs exit select print ref gethostbyaddr unshift fcntl syscall goto getnetbyaddr join gmtime symlink semget splice x|0 getpeername recv log setsockopt cos last reverse gethostbyname getgrnam study formline endhostent times chop length gethostent getnetent pack getprotoent getservbyname rand mkdir pos chmod y|0 substr endnetent printf next open msgsnd readdir use unlink getsockopt getpriority rindex wantarray hex system getservbyport endservent int chr untie rmdir prototype tell listen fork shmread ucfirst setprotoent else sysseek link getgrgid shmctl waitpid unpack getnetbyname reset chdir grep split require caller lcfirst until warn while values shift telldir getpwuid my getprotobynumber delete and sort uc defined srand accept package seekdir getprotobyname semop our rename seek if q|0 chroot sysread setpwent no crypt getc chown sqrt write setnetent setpriority foreach tie sin msgget map stat getlogin unless elsif truncate exec keys glob tied closedirioctl socket readlink eval xor readline binmode setservent eof ord bind alarm pipe atan2 getgrent exp time push setgrent gt lt or ne m|0 break given say state when",r={cN:"subst",b:"[$@]\\{",e:"\\}",k:t},a={b:"->{",e:"}"},n={v:[{b:/\$\d/},{b:/[\$%@](\^\w\b|#\w+(::\w+)*|{\w+}|\w+(::\w*)*)/},{b:/[\$%@][^\s\w{]/,r:0}]},i=[e.BE,r,n],s=[n,e.HCM,e.C("^\\=\\w","\\=cut",{eW:!0}),a,{cN:"string",c:i,v:[{b:"q[qwxr]?\\s*\\(",e:"\\)",r:5},{b:"q[qwxr]?\\s*\\[",e:"\\]",r:5},{b:"q[qwxr]?\\s*\\{",e:"\\}",r:5},{b:"q[qwxr]?\\s*\\|",e:"\\|",r:5},{b:"q[qwxr]?\\s*\\<",e:"\\>",r:5},{b:"qw\\s+q",e:"q",r:5},{b:"'",e:"'",c:[e.BE]},{b:'"',e:'"'},{b:"`",e:"`",c:[e.BE]},{b:"{\\w+}",c:[],r:0},{b:"-?\\w+\\s*\\=\\>",c:[],r:0}]},{cN:"number",b:"(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b",r:0},{b:"(\\/\\/|"+e.RSR+"|\\b(split|return|print|reverse|grep)\\b)\\s*",k:"split return print reverse grep",r:0,c:[e.HCM,{cN:"regexp",b:"(s|tr|y)/(\\\\.|[^/])*/(\\\\.|[^/])*/[a-z]*",r:10},{cN:"regexp",b:"(m|qr)?/",e:"/[a-z]*",c:[e.BE],r:0}]},{cN:"function",bK:"sub",e:"(\\s*\\(.*?\\))?[;{]",eE:!0,r:5,c:[e.TM]},{b:"-\\w\\b",r:0},{b:"^__DATA__$",e:"^__END__$",sL:"mojolicious",c:[{b:"^@@.*",e:"$",cN:"comment"}]}];return r.c=s,a.c=s,{aliases:["pl","pm"],l:/[\w\.]+/,k:t,c:s};}),e.registerLanguage("php",function(e){var t={b:"\\$+[a-zA-Z_-ÿ][a-zA-Z0-9_-ÿ]*"},r={cN:"meta",b:/<\?(php)?|\?>/},a={cN:"string",c:[e.BE,r],v:[{b:'b"',e:'"'},{b:"b'",e:"'"},e.inherit(e.ASM,{i:null}),e.inherit(e.QSM,{i:null})]},n={v:[e.BNM,e.CNM]};return{aliases:["php3","php4","php5","php6"],cI:!0,k:"and include_once list abstract global private echo interface as static endswitch array null if endwhile or const for endforeach self var while isset public protected exit foreach throw elseif include __FILE__ empty require_once do xor return parent clone use __CLASS__ __LINE__ else break print eval new catch __METHOD__ case exception default die require __FUNCTION__ enddeclare final try switch continue endfor endif declare unset true false trait goto instanceof insteadof __DIR__ __NAMESPACE__ yield finally",c:[e.HCM,e.C("//","$",{c:[r]}),e.C("/\\*","\\*/",{c:[{cN:"doctag",b:"@[A-Za-z]+"}]}),e.C("__halt_compiler.+?;",!1,{eW:!0,k:"__halt_compiler",l:e.UIR}),{cN:"string",b:/<<<['"]?\w+['"]?$/,e:/^\w+;?$/,c:[e.BE,{cN:"subst",v:[{b:/\$\w+/},{b:/\{\$/,e:/\}/}]}]},r,{cN:"keyword",b:/\$this\b/},t,{b:/(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/},{cN:"function",bK:"function",e:/[;{]/,eE:!0,i:"\\$|\\[|%",c:[e.UTM,{cN:"params",b:"\\(",e:"\\)",c:["self",t,e.CBCM,a,n]}]},{cN:"class",bK:"class interface",e:"{",eE:!0,i:/[:\(\$"]/,c:[{bK:"extends implements"},e.UTM]},{bK:"namespace",e:";",i:/[\.']/,c:[e.UTM]},{bK:"use",e:";",c:[e.UTM]},{b:"=>"},a,n]};}),e.registerLanguage("python",function(e){var t={keyword:"and elif is global as in if from raise for except finally print import pass return exec else break not with class assert yield try while continue del or def lambda async await nonlocal|10 None True False",built_in:"Ellipsis NotImplemented"},r={cN:"meta",b:/^(>>>|\.\.\.) /},a={cN:"subst",b:/\{/,e:/\}/,k:t,i:/#/},n={cN:"string",c:[e.BE],v:[{b:/(u|b)?r?'''/,e:/'''/,c:[r],r:10},{b:/(u|b)?r?"""/,e:/"""/,c:[r],r:10},{b:/(fr|rf|f)'''/,e:/'''/,c:[r,a]},{b:/(fr|rf|f)"""/,e:/"""/,c:[r,a]},{b:/(u|r|ur)'/,e:/'/,r:10},{b:/(u|r|ur)"/,e:/"/,r:10},{b:/(b|br)'/,e:/'/},{b:/(b|br)"/,e:/"/},{b:/(fr|rf|f)'/,e:/'/,c:[a]},{b:/(fr|rf|f)"/,e:/"/,c:[a]},e.ASM,e.QSM]},i={cN:"number",r:0,v:[{b:e.BNR+"[lLjJ]?"},{b:"\\b(0o[0-7]+)[lLjJ]?"},{b:e.CNR+"[lLjJ]?"}]},s={cN:"params",b:/\(/,e:/\)/,c:["self",r,i,n]};return a.c=[n,i,r],{aliases:["py","gyp"],k:t,i:/(<\/|->|\?)|=>/,c:[r,i,n,e.HCM,{v:[{cN:"function",bK:"def"},{cN:"class",bK:"class"}],e:/:/,i:/[${=;\n,]/,c:[e.UTM,s,{b:/->/,eW:!0,k:"None"}]},{cN:"meta",b:/^[\t ]*@/,e:/$/},{b:/\b(print|exec)\(/}]};}),e.registerLanguage("ruby",function(e){var t="[a-zA-Z_]\\w*[!?=]?|[-+~]\\@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?",r={keyword:"and then defined module in return redo if BEGIN retry end for self when next until do begin unless END rescue else break undef not super class case require yield alias while ensure elsif or include attr_reader attr_writer attr_accessor",literal:"true false nil"},a={cN:"doctag",b:"@[A-Za-z]+"},n={b:"#<",e:">"},i=[e.C("#","$",{c:[a]}),e.C("^\\=begin","^\\=end",{c:[a],r:10}),e.C("^__END__","\\n$")],s={cN:"subst",b:"#\\{",e:"}",k:r},c={cN:"string",c:[e.BE,s],v:[{b:/'/,e:/'/},{b:/"/,e:/"/},{b:/`/,e:/`/},{b:"%[qQwWx]?\\(",e:"\\)"},{b:"%[qQwWx]?\\[",e:"\\]"},{b:"%[qQwWx]?{",e:'}'},{b:'%[qQwWx]?<',e:'>'},{b:'%[qQwWx]?/',e:'/'},{b:'%[qQwWx]?%',e:'%'},{b:'%[qQwWx]?-',e:'-'},{b:'%[qQwWx]?\\|',e:'\\|'},{b:/\B\?(\\\d{1,3}|\\x[A-Fa-f0-9]{1,2}|\\u[A-Fa-f0-9]{4}|\\?\S)\b/},{b:/<<(-?)\w+$/,e:/^\s*\w+$/}]},o={cN:'params',b:'\\(',e:'\\)',endsParent:!0,k:r},l=[c,n,{cN:'class',bK:'class module',e:'$|;',i:/=/,c:[e.inherit(e.TM,{b:'[A-Za-z_]\\w*(::\\w+)*(\\?|\\!)?'}),{b:'<\\s*',c:[{b:'('+e.IR+'::)?'+e.IR}]}].concat(i)},{cN:'function',bK:'def',e:'$|;',c:[e.inherit(e.TM,{b:t}),o].concat(i)},{b:e.IR+'::'},{cN:'symbol',b:e.UIR+'(\\!|\\?)?:',r:0},{cN:'symbol',b:':(?!\\s)',c:[c,{b:t}],r:0},{cN:'number',b:'(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b',r:0},{b:'(\\$\\W)|((\\$|\\@\\@?)(\\w+))'},{cN:'params',b:/\|/,e:/\|/,k:r},{b:'('+e.RSR+'|unless)\\s*',c:[n,{cN:'regexp',c:[e.BE,s],i:/\n/,v:[{b:'/',e:'/[a-z]*'},{b:'%r{',e:'}[a-z]*'},{b:'%r\\(',e:'\\)[a-z]*'},{b:'%r!',e:'![a-z]*'},{b:'%r\\[',e:'\\][a-z]*'}]}].concat(i),r:0}].concat(i);s.c=l,o.c=l;var u='[>?]>',d='[\\w#]+\\(\\w+\\):\\d+:\\d+>',b='(\\w+-)?\\d+\\.\\d+\\.\\d(p\\d+)?[^>]+>',p=[{b:/^\s*=>/,starts:{e:'$',c:l}},{cN:'meta',b:'^('+u+'|'+d+'|'+b+')',starts:{e:'$',c:l}}];return{aliases:['rb','gemspec','podspec','thor','irb'],k:r,i:/\/\*/,c:i.concat(p).concat(l)};}),e.registerLanguage('sql',function(e){var t=e.C('--','$');return{cI:!0,i:/[<>{}*#]/,c:[{bK:'begin end start commit rollback savepoint lock alter create drop rename call delete do handler insert load replace select truncate update set show pragma grant merge describe use explain help declare prepare execute deallocate release unlock purge reset change stop analyze cache flush optimize repair kill install uninstall checksum restore check backup revoke comment',e:/;/,eW:!0,l:/[\w\.]+/,k:{keyword:'abort abs absolute acc acce accep accept access accessed accessible account acos action activate add addtime admin administer advanced advise aes_decrypt aes_encrypt after agent aggregate ali alia alias allocate allow alter always analyze ancillary and any anydata anydataset anyschema anytype apply archive archived archivelog are as asc ascii asin assembly assertion associate asynchronous at atan atn2 attr attri attrib attribu attribut attribute attributes audit authenticated authentication authid authors auto autoallocate autodblink autoextend automatic availability avg backup badfile basicfile before begin beginning benchmark between bfile bfile_base big bigfile bin binary_double binary_float binlog bit_and bit_count bit_length bit_or bit_xor bitmap blob_base block blocksize body both bound buffer_cache buffer_pool build bulk by byte byteordermark bytes cache caching call calling cancel capacity cascade cascaded case cast catalog category ceil ceiling chain change changed char_base char_length character_length characters characterset charindex charset charsetform charsetid check checksum checksum_agg child choose chr chunk class cleanup clear client clob clob_base clone close cluster_id cluster_probability cluster_set clustering coalesce coercibility col collate collation collect colu colum column column_value columns columns_updated comment commit compact compatibility compiled complete composite_limit compound compress compute concat concat_ws concurrent confirm conn connec connect connect_by_iscycle connect_by_isleaf connect_by_root connect_time connection consider consistent constant constraint constraints constructor container content contents context contributors controlfile conv convert convert_tz corr corr_k corr_s corresponding corruption cos cost count count_big counted covar_pop covar_samp cpu_per_call cpu_per_session crc32 create creation critical cross cube cume_dist curdate current current_date current_time current_timestamp current_user cursor curtime customdatum cycle data database databases datafile datafiles datalength date_add date_cache date_format date_sub dateadd datediff datefromparts datename datepart datetime2fromparts day day_to_second dayname dayofmonth dayofweek dayofyear days db_role_change dbtimezone ddl deallocate declare decode decompose decrement decrypt deduplicate def defa defau defaul default defaults deferred defi defin define degrees delayed delegate delete delete_all delimited demand dense_rank depth dequeue des_decrypt des_encrypt des_key_file desc descr descri describ describe descriptor deterministic diagnostics difference dimension direct_load directory disable disable_all disallow disassociate discardfile disconnect diskgroup distinct distinctrow distribute distributed div do document domain dotnet double downgrade drop dumpfile duplicate duration each edition editionable editions element ellipsis else elsif elt empty enable enable_all enclosed encode encoding encrypt end end-exec endian enforced engine engines enqueue enterprise entityescaping eomonth error errors escaped evalname evaluate event eventdata events except exception exceptions exchange exclude excluding execu execut execute exempt exists exit exp expire explain export export_set extended extent external external_1 external_2 externally extract failed failed_login_attempts failover failure far fast feature_set feature_value fetch field fields file file_name_convert filesystem_like_logging final finish first first_value fixed flash_cache flashback floor flush following follows for forall force form forma format found found_rows freelist freelists freepools fresh from from_base64 from_days ftp full function general generated get get_format get_lock getdate getutcdate global global_name globally go goto grant grants greatest group group_concat group_id grouping grouping_id groups gtid_subtract guarantee guard handler hash hashkeys having hea head headi headin heading heap help hex hierarchy high high_priority hosts hour http id ident_current ident_incr ident_seed identified identity idle_time if ifnull ignore iif ilike ilm immediate import in include including increment index indexes indexing indextype indicator indices inet6_aton inet6_ntoa inet_aton inet_ntoa infile initial initialized initially initrans inmemory inner innodb input insert install instance instantiable instr interface interleaved intersect into invalidate invisible is is_free_lock is_ipv4 is_ipv4_compat is_not is_not_null is_used_lock isdate isnull isolation iterate java join json json_exists keep keep_duplicates key keys kill language large last last_day last_insert_id last_value lax lcase lead leading least leaves left len lenght length less level levels library like like2 like4 likec limit lines link list listagg little ln load load_file lob lobs local localtime localtimestamp locate locator lock locked log log10 log2 logfile logfiles logging logical logical_reads_per_call logoff logon logs long loop low low_priority lower lpad lrtrim ltrim main make_set makedate maketime managed management manual map mapping mask master master_pos_wait match matched materialized max maxextents maximize maxinstances maxlen maxlogfiles maxloghistory maxlogmembers maxsize maxtrans md5 measures median medium member memcompress memory merge microsecond mid migration min minextents minimum mining minus minute minvalue missing mod mode model modification modify module monitoring month months mount move movement multiset mutex name name_const names nan national native natural nav nchar nclob nested never new newline next nextval no no_write_to_binlog noarchivelog noaudit nobadfile nocheck nocompress nocopy nocycle nodelay nodiscardfile noentityescaping noguarantee nokeep nologfile nomapping nomaxvalue nominimize nominvalue nomonitoring none noneditionable nonschema noorder nopr nopro noprom nopromp noprompt norely noresetlogs noreverse normal norowdependencies noschemacheck noswitch not nothing notice notrim novalidate now nowait nth_value nullif nulls num numb numbe nvarchar nvarchar2 object ocicoll ocidate ocidatetime ociduration ociinterval ociloblocator ocinumber ociref ocirefcursor ocirowid ocistring ocitype oct octet_length of off offline offset oid oidindex old on online only opaque open operations operator optimal optimize option optionally or oracle oracle_date oradata ord ordaudio orddicom orddoc order ordimage ordinality ordvideo organization orlany orlvary out outer outfile outline output over overflow overriding package pad parallel parallel_enable parameters parent parse partial partition partitions pascal passing password password_grace_time password_lock_time password_reuse_max password_reuse_time password_verify_function patch path patindex pctincrease pctthreshold pctused pctversion percent percent_rank percentile_cont percentile_disc performance period period_add period_diff permanent physical pi pipe pipelined pivot pluggable plugin policy position post_transaction pow power pragma prebuilt precedes preceding precision prediction prediction_cost prediction_details prediction_probability prediction_set prepare present preserve prior priority private private_sga privileges procedural procedure procedure_analyze processlist profiles project prompt protection public publishingservername purge quarter query quick quiesce quota quotename radians raise rand range rank raw read reads readsize rebuild record records recover recovery recursive recycle redo reduced ref reference referenced references referencing refresh regexp_like register regr_avgx regr_avgy regr_count regr_intercept regr_r2 regr_slope regr_sxx regr_sxy reject rekey relational relative relaylog release release_lock relies_on relocate rely rem remainder rename repair repeat replace replicate replication required reset resetlogs resize resource respect restore restricted result result_cache resumable resume retention return returning returns reuse reverse revoke right rlike role roles rollback rolling rollup round row row_count rowdependencies rowid rownum rows rtrim rules safe salt sample save savepoint sb1 sb2 sb4 scan schema schemacheck scn scope scroll sdo_georaster sdo_topo_geometry search sec_to_time second section securefile security seed segment select self sequence sequential serializable server servererror session session_user sessions_per_user set sets settings sha sha1 sha2 share shared shared_pool short show shrink shutdown si_averagecolor si_colorhistogram si_featurelist si_positionalcolor si_stillimage si_texture siblings sid sign sin size size_t sizes skip slave sleep smalldatetimefromparts smallfile snapshot some soname sort soundex source space sparse spfile split sql sql_big_result sql_buffer_result sql_cache sql_calc_found_rows sql_small_result sql_variant_property sqlcode sqldata sqlerror sqlname sqlstate sqrt square standalone standby start starting startup statement static statistics stats_binomial_test stats_crosstab stats_ks_test stats_mode stats_mw_test stats_one_way_anova stats_t_test_ stats_t_test_indep stats_t_test_one stats_t_test_paired stats_wsr_test status std stddev stddev_pop stddev_samp stdev stop storage store stored str str_to_date straight_join strcmp strict string struct stuff style subdate subpartition subpartitions substitutable substr substring subtime subtring_index subtype success sum suspend switch switchoffset switchover sync synchronous synonym sys sys_xmlagg sysasm sysaux sysdate sysdatetimeoffset sysdba sysoper system system_user sysutcdatetime table tables tablespace tan tdo template temporary terminated tertiary_weights test than then thread through tier ties time time_format time_zone timediff timefromparts timeout timestamp timestampadd timestampdiff timezone_abbr timezone_minute timezone_region to to_base64 to_date to_days to_seconds todatetimeoffset trace tracking transaction transactional translate translation treat trigger trigger_nestlevel triggers trim truncate try_cast try_convert try_parse type ub1 ub2 ub4 ucase unarchived unbounded uncompress under undo unhex unicode uniform uninstall union unique unix_timestamp unknown unlimited unlock unpivot unrecoverable unsafe unsigned until untrusted unusable unused update updated upgrade upped upper upsert url urowid usable usage use use_stored_outlines user user_data user_resources users using utc_date utc_timestamp uuid uuid_short validate validate_password_strength validation valist value values var var_samp varcharc vari varia variab variabl variable variables variance varp varraw varrawc varray verify version versions view virtual visible void wait wallet warning warnings week weekday weekofyear wellformed when whene whenev wheneve whenever where while whitespace with within without work wrapped xdb xml xmlagg xmlattributes xmlcast xmlcolattval xmlelement xmlexists xmlforest xmlindex xmlnamespaces xmlpi xmlquery xmlroot xmlschema xmlserialize xmltable xmltype xor year year_to_month years yearweek',literal:'true false null',built_in:'array bigint binary bit blob boolean char character date dec decimal float int int8 integer interval number numeric real record serial serial8 smallint text varchar varying void'},c:[{cN:'string',b:"'",e:"'",c:[e.BE,{b:"''"}]},{cN:'string',b:'"',e:'"',c:[e.BE,{b:'""'}]},{cN:'string',b:'`',e:'`',c:[e.BE]},e.CNM,e.CBCM,t]},e.CBCM,t]};}),e;});/* eslint-enable */

/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return H1; });
/* unused harmony export H2 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return H3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return H4; });
/* unused harmony export H5 */
/* unused harmony export H6 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var defaultClasses={1:'fs30-sm lh30-sm fs30-md lh30-md',2:'fs20-sm lh20-sm fs28-md lh28-md fs34-lg lh34-lg',3:'fs20-sm lh20-sm fs24-md lh24-md fs28-lg lh28-lg',4:'fs16-sm lh16-sm',5:'',6:''};function header(size){return function(_ref){var _ref$className=_ref.className,className=_ref$className===undefined?'':_ref$className,useBareClass=_ref.useBareClass,children=_ref.children,props=_objectWithoutProperties(_ref,['className','useBareClass','children']);return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('h'+size,Object.assign({},props,{className:useBareClass?className:defaultClasses[size]+' '+className}),children);};}var H1=header(1);var H2=header(2);var H3=header(3);var H4=header(4);var H5=header(5);var H6=header(6);

/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_js__ = __webpack_require__(25);
var is404=function is404(error){return error&&(error.status&&error.status===404||error.response&&is404(error.response));};var Generic=function Generic(_ref){var error=_ref.error;if(is404(error))return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__index_js__["p" /* NotFound */],null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__index_js__["f" /* Container */],{section:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__index_js__["i" /* H1 */],null,'An error occured, unable to load page.'),error?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre',null,error.message||error):null);};/* harmony default export */ __webpack_exports__["a"] = (Generic);

/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_js__ = __webpack_require__(25);
/* unused harmony default export */ var _unused_webpack_default_export = (function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__index_js__["f" /* Container */],{section:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__index_js__["i" /* H1 */],null,'\uD83D\uDD12 You are not authorized to view this page'));});

/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_js__ = __webpack_require__(25);
/* harmony default export */ __webpack_exports__["a"] = (function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__index_js__["f" /* Container */],{section:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__index_js__["i" /* H1 */],null,'\uD83D\uDE41 The resource you requested was not found'));});

/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(65);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var defaultClass='link';/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var external=_ref.external,extraClassName=_ref.extraClassName,className=_ref.className,children=_ref.children,props=_objectWithoutProperties(_ref,['external','extraClassName','className','children']);if(extraClassName&&className)throw new Error('extraClassName and className are mutually exclusive');className=className===undefined?defaultClass:className;if(extraClassName)className+=' '+extraClassName;return external?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.to,className:className,target:'_blank'},children):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],Object.assign({className:className},props),children);});

/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var badgeStyle={position:'relative'};var Badge=function Badge(_ref){var count=_ref.count,className=_ref.className;return count?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:badgeStyle,className:className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge-notification ncss-brand circle'},count)):null;};/* harmony default export */ __webpack_exports__["a"] = (Badge);

/***/ }),
/* 1590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_index_js__ = __webpack_require__(25);
var PageHeader=function PageHeader(_ref){var title=_ref.title,back=_ref.back,children=_ref.children;var headerStyle=['ncss-brand u-uppercase flex-fill'];if(back)headerStyle.push('page-title-has-back');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index_js__["f" /* Container */],{section:true,extraClassName:'flex-container start page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_index_js__["i" /* H1 */],{className:headerStyle.join(' ')},title,back||null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(children)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-static'},children):null);};/* harmony default export */ __webpack_exports__["a"] = (PageHeader);

/***/ }),
/* 1591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(73);
var baseTitle=window.document&&window.document.title||__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].appName;function formatTitle(pageTitle){return pageTitle?pageTitle+' - '+baseTitle:baseTitle;}var PageTitle=function PageTitle(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:formatTitle(props.title)},props.children);};/* harmony default export */ __webpack_exports__["a"] = (PageTitle);

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var ExecutionEnvironment = _interopDefault(__webpack_require__(78));
var shallowEqual = _interopDefault(__webpack_require__(1593));

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;


    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 1593 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 1594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_js__ = __webpack_require__(25);
var PageSpinner=function PageSpinner(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__index_js__["s" /* PageTitle */],{title:props.title}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__index_js__["q" /* PageHeader */],{title:props.title}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__index_js__["f" /* Container */],{fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__index_js__["v" /* Spinner */],{large:true})));};/* harmony default export */ __webpack_exports__["a"] = (PageSpinner);

/***/ }),
/* 1595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RenderInBody=function(_Component){_inherits(RenderInBody,_Component);function RenderInBody(){var _ref;_classCallCheck(this,RenderInBody);for(var _len=arguments.length,props=Array(_len),_key=0;_key<_len;_key++){props[_key]=arguments[_key];}var _this=_possibleConstructorReturn(this,(_ref=RenderInBody.__proto__||Object.getPrototypeOf(RenderInBody)).call.apply(_ref,[this].concat(props)));_this._renderLayer=function(){Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(_this.props.children,_this.popup);};_this.propup=null;return _this;}_createClass(RenderInBody,[{key:'componentDidMount',value:function componentDidMount(){this.popup=document.createElement('div');document.body.appendChild(this.popup);this._renderLayer();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this._renderLayer();}},{key:'componentWillUnmount',value:function componentWillUnmount(){Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["unmountComponentAtNode"])(this.popup);document.body.removeChild(this.popup);}},{key:'render',value:function render(){return null;}}]);return RenderInBody;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RenderInBody);

/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Spinner=function Spinner(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'spinner '+(props.large?'spinner-lg':'')+' '+(props.className||'')});};/* harmony default export */ __webpack_exports__["a"] = (Spinner);

/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_codemirror__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_codemirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_codemirror__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_codemirror2__ = __webpack_require__(1598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_codemirror2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_codemirror2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_codemirror_mode_markdown_markdown__ = __webpack_require__(1599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_codemirror_mode_markdown_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_codemirror_mode_markdown_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_codemirror_addon_mode_overlay__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_codemirror_addon_mode_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_codemirror_addon_mode_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_codemirror_addon_display_placeholder__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_codemirror_addon_display_placeholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_codemirror_addon_display_placeholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_codemirror_spell_checker__ = __webpack_require__(1604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_codemirror_spell_checker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_codemirror_spell_checker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ncss_Checkbox_js__ = __webpack_require__(370);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}__WEBPACK_IMPORTED_MODULE_6_codemirror_spell_checker___default()({codeMirrorInstance:__WEBPACK_IMPORTED_MODULE_1_codemirror___default.a});var MarkdownEditor=function(_Component){_inherits(MarkdownEditor,_Component);function MarkdownEditor(){var _ref;_classCallCheck(this,MarkdownEditor);for(var _len=arguments.length,props=Array(_len),_key=0;_key<_len;_key++){props[_key]=arguments[_key];}var _this=_possibleConstructorReturn(this,(_ref=MarkdownEditor.__proto__||Object.getPrototypeOf(MarkdownEditor)).call.apply(_ref,[this].concat(props)));_this.handleChange=function(editor,data,value){_this.props.onChange(value);};_this.setSpellCheck=function(value){_this.setState({isSpellCheckActive:value});};_this.state={isSpellCheckActive:false};return _this;}_createClass(MarkdownEditor,[{key:'render',value:function render(){var _props=this.props,value=_props.value,placeholder=_props.placeholder,className=_props.className;var isSpellCheckActive=this.state.isSpellCheckActive;var codeMirrorOptions={mode:isSpellCheckActive?'spell-checker':'markdown',backdrop:'markdown',lineWrapping:true,placeholder:placeholder,viewportMargin:Infinity};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'markdown-controls editor-controls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_ncss_Checkbox_js__["a" /* default */],{checked:isSpellCheckActive,onChange:this.setSpellCheck,label:'Spell Check'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_codemirror2__["Controlled"],{options:codeMirrorOptions,value:value,onBeforeChange:this.handleChange}));}}]);return MarkdownEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (MarkdownEditor);

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, '__esModule', { value: true });
var React = __webpack_require__(0);
var cm;
var SERVER_RENDERED = typeof navigator === 'undefined';
if (!SERVER_RENDERED) {
    cm = __webpack_require__(131);
}
var Shared = (function () {
    function Shared(editor, props) {
        this.editor = editor;
        this.props = props;
        this.notifyOfDeprecation();
    }
    Shared.prototype.notifyOfDeprecation = function () {
        if (this.props.autoScrollCursorOnSet !== undefined) {
            console.warn('`autoScrollCursorOnSet` has been deprecated. Use `autoScroll` instead\n\nSee https://github.com/scniro/react-codemirror2#props');
        }
        if (this.props.resetCursorOnSet !== undefined) {
            console.warn('`resetCursorOnSet` has been deprecated. Use `autoCursor` instead\n\nSee https://github.com/scniro/react-codemirror2#props');
        }
        if (this.props.onSet !== undefined) {
            console.warn('`onSet` has been deprecated. User `editorDidMount` instead. See https://github.com/scniro/react-codemirror2#events');
        }
        if (this.props.onBeforeSet !== undefined) {
            console.warn('`onBeforeSet` has been deprecated. User `onBeforeChange` for `Controlled`. instead. See https://github.com/scniro/react-codemirror2#events');
        }
    };
    Shared.prototype.wire = function (name) {
        var _this = this;
        switch (name) {
            case 'onBlur':
                {
                    this.editor.on('blur', function (cm, event) {
                        _this.props.onBlur(_this.editor, event);
                    });
                }
                break;
            case 'onCursor':
                {
                    this.editor.on('cursorActivity', function (cm) {
                        _this.props.onCursor(_this.editor, _this.editor.getCursor());
                    });
                }
                break;
            case 'onCursorActivity':
                {
                    this.editor.on('cursorActivity', function (cm) {
                        _this.props.onCursorActivity(_this.editor);
                    });
                }
                break;
            case 'onDragEnter':
                {
                    this.editor.on('dragenter', function (cm, event) {
                        _this.props.onDragEnter(_this.editor, event);
                    });
                }
                break;
            case 'onDragOver':
                {
                    this.editor.on('dragover', function (cm, event) {
                        _this.props.onDragOver(_this.editor, event);
                    });
                }
                break;
            case 'onDrop':
                {
                    this.editor.on('drop', function (cm, event) {
                        _this.props.onDrop(_this.editor, event);
                    });
                }
                break;
            case 'onFocus':
                {
                    this.editor.on('focus', function (cm, event) {
                        _this.props.onFocus(_this.editor, event);
                    });
                }
                break;
            case 'onGutterClick':
                {
                    this.editor.on('gutterClick', function (cm, lineNumber, gutter, event) {
                        _this.props.onGutterClick(_this.editor, lineNumber, gutter, event);
                    });
                }
                break;
            case 'onKeyDown':
                {
                    this.editor.on('keydown', function (cm, event) {
                        _this.props.onKeyDown(_this.editor, event);
                    });
                }
                break;
            case 'onKeyPress':
                {
                    this.editor.on('keypress', function (cm, event) {
                        _this.props.onKeyPress(_this.editor, event);
                    });
                }
                break;
            case 'onKeyUp':
                {
                    this.editor.on('keyup', function (cm, event) {
                        _this.props.onKeyUp(_this.editor, event);
                    });
                }
                break;
            case 'onScroll':
                {
                    this.editor.on('scroll', function (cm) {
                        _this.props.onScroll(_this.editor, _this.editor.getScrollInfo());
                    });
                }
                break;
            case 'onSelection':
                {
                    this.editor.on('beforeSelectionChange', function (cm, data) {
                        _this.props.onSelection(_this.editor, data);
                    });
                }
                break;
            case 'onUpdate':
                {
                    this.editor.on('update', function (cm) {
                        _this.props.onUpdate(_this.editor);
                    });
                }
                break;
            case 'onViewportChange':
                {
                    this.editor.on('viewportChange', function (cm, from, to) {
                        _this.props.onViewportChange(_this.editor, from, to);
                    });
                }
                break;
        }
    };
    return Shared;
}());
var Controlled = (function (_super) {
    __extends(Controlled, _super);
    function Controlled(props) {
        var _this = _super.call(this, props) || this;
        if (SERVER_RENDERED)
            return _this;
        _this.deferred = null;
        _this.emulating = false;
        _this.hydrated = false;
        _this.initCb = function () {
            if (_this.props.editorDidConfigure) {
                _this.props.editorDidConfigure(_this.editor);
            }
        };
        _this.mounted = false;
        return _this;
    }
    Controlled.prototype.setCursor = function (cursorPos, scroll, focus) {
        var doc = this.editor.getDoc();
        if (focus) {
            this.editor.focus();
        }
        if (scroll) {
            doc.setCursor(cursorPos);
        }
        else {
            doc.setCursor(cursorPos, null, { scroll: false });
        }
    };
    Controlled.prototype.moveCursor = function (cursorPos, scroll) {
        var doc = this.editor.getDoc();
        if (scroll) {
            doc.setCursor(cursorPos);
        }
        else {
            doc.setCursor(cursorPos, null, { scroll: false });
        }
    };
    Controlled.prototype.hydrate = function (props) {
        var _this = this;
        Object.keys(props.options || {}).forEach(function (key) {
            _this.editor.setOption(key, props.options[key]);
            _this.mirror.setOption(key, props.options[key]);
        });
        if (!this.hydrated) {
            if (!this.mounted) {
                this.initChange(props.value || '');
            }
            else {
                if (this.deferred) {
                    this.resolveChange();
                }
                else {
                    this.initChange(props.value || '');
                }
            }
        }
        this.hydrated = true;
    };
    Controlled.prototype.initChange = function (value) {
        this.emulating = true;
        var lastLine = this.editor.lastLine();
        var lastChar = this.editor.getLine(this.editor.lastLine()).length;
        this.editor.replaceRange(value || '', { line: 0, ch: 0 }, { line: lastLine, ch: lastChar });
        this.mirror.setValue(value);
        this.editor.clearHistory();
        this.mirror.clearHistory();
        this.emulating = false;
    };
    Controlled.prototype.resolveChange = function () {
        this.emulating = true;
        if (this.deferred.origin === 'undo') {
            this.editor.undo();
        }
        else if (this.deferred.origin === 'redo') {
            this.editor.redo();
        }
        else {
            this.editor.replaceRange(this.deferred.text, this.deferred.from, this.deferred.to, this.deferred.origin);
        }
        this.emulating = false;
        this.deferred = null;
    };
    Controlled.prototype.mirrorChange = function (deferred) {
        if (deferred.origin === 'undo') {
            this.editor.setHistory(this.mirror.getHistory());
            this.mirror.undo();
        }
        else if (deferred.origin === 'redo') {
            this.editor.setHistory(this.mirror.getHistory());
            this.mirror.redo();
        }
        else {
            this.mirror.replaceRange(deferred.text, deferred.from, deferred.to, deferred.origin);
        }
        return this.mirror.getValue();
    };
    Controlled.prototype.componentWillMount = function () {
        if (SERVER_RENDERED)
            return;
        if (this.props.editorWillMount) {
            this.props.editorWillMount();
        }
    };
    Controlled.prototype.componentDidMount = function () {
        var _this = this;
        if (SERVER_RENDERED)
            return;
        if (this.props.defineMode) {
            if (this.props.defineMode.name && this.props.defineMode.fn) {
                cm.defineMode(this.props.defineMode.name, this.props.defineMode.fn);
            }
        }
        this.editor = cm(this.ref);
        this.shared = new Shared(this.editor, this.props);
        this.mirror = cm(function () {
        });
        this.editor.on('electricInput', function () {
            _this.mirror.setHistory(_this.editor.getHistory());
        });
        this.editor.on('cursorActivity', function () {
            _this.mirror.setCursor(_this.editor.getCursor());
        });
        this.editor.on('beforeChange', function (cm, data) {
            if (_this.emulating) {
                return;
            }
            data.cancel();
            _this.deferred = data;
            var phantomChange = _this.mirrorChange(_this.deferred);
            if (_this.props.onBeforeChange)
                _this.props.onBeforeChange(_this.editor, _this.deferred, phantomChange);
        });
        this.editor.on('change', function (cm, data) {
            if (!_this.mounted) {
                return;
            }
            if (_this.props.onChange) {
                _this.props.onChange(_this.editor, data, _this.editor.getValue());
            }
        });
        if (this.props.onBlur)
            this.shared.wire('onBlur');
        if (this.props.onCursor)
            this.shared.wire('onCursor');
        if (this.props.onCursorActivity)
            this.shared.wire('onCursorActivity');
        if (this.props.onDragEnter)
            this.shared.wire('onDragEnter');
        if (this.props.onDragOver)
            this.shared.wire('onDragOver');
        if (this.props.onDrop)
            this.shared.wire('onDrop');
        if (this.props.onFocus)
            this.shared.wire('onFocus');
        if (this.props.onGutterClick)
            this.shared.wire('onGutterClick');
        if (this.props.onKeyDown)
            this.shared.wire('onKeyDown');
        if (this.props.onKeyPress)
            this.shared.wire('onKeyPress');
        if (this.props.onKeyUp)
            this.shared.wire('onKeyUp');
        if (this.props.onScroll)
            this.shared.wire('onScroll');
        if (this.props.onSelection)
            this.shared.wire('onSelection');
        if (this.props.onUpdate)
            this.shared.wire('onUpdate');
        if (this.props.onViewportChange)
            this.shared.wire('onViewportChange');
        this.hydrate(this.props);
        if (this.props.selection) {
            var doc = this.editor.getDoc();
            doc.setSelections(this.props.selection);
        }
        if (this.props.cursor) {
            this.setCursor(this.props.cursor, this.props.autoScroll || false, this.props.autoFocus || false);
        }
        if (this.props.scroll) {
            this.editor.scrollTo(this.props.scroll.x, this.props.scroll.y);
        }
        this.mounted = true;
        if (this.props.editorDidMount) {
            this.props.editorDidMount(this.editor, this.editor.getValue(), this.initCb);
        }
    };
    Controlled.prototype.componentWillReceiveProps = function (nextProps) {
        if (SERVER_RENDERED)
            return;
        var cursorPos;
        if (nextProps.value !== this.props.value) {
            this.hydrated = false;
        }
        if (!this.props.autoCursor && this.props.autoCursor !== undefined) {
            cursorPos = this.editor.getCursor();
        }
        this.hydrate(nextProps);
        if (!this.props.autoCursor && this.props.autoCursor !== undefined) {
            this.moveCursor(cursorPos, this.props.autoScroll || false);
        }
    };
    Controlled.prototype.componentWillUnmount = function () {
        if (SERVER_RENDERED)
            return;
        if (this.props.editorWillUnmount) {
            this.props.editorWillUnmount(cm);
        }
    };
    Controlled.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return !SERVER_RENDERED;
    };
    Controlled.prototype.render = function () {
        var _this = this;
        if (SERVER_RENDERED)
            return null;
        var className = this.props.className ? 'react-codemirror2 ' + this.props.className : 'react-codemirror2';
        return (React.createElement('div', { className: className, ref: function (self) { return _this.ref = self; } }));
    };
    return Controlled;
}(React.Component));
exports.Controlled = Controlled;
var UnControlled = (function (_super) {
    __extends(UnControlled, _super);
    function UnControlled(props) {
        var _this = _super.call(this, props) || this;
        if (SERVER_RENDERED)
            return _this;
        _this.continueChange = false;
        _this.hydrated = false;
        _this.initCb = function () {
            if (_this.props.editorDidConfigure) {
                _this.props.editorDidConfigure(_this.editor);
            }
        };
        _this.mounted = false;
        _this.onBeforeChangeCb = function () {
            _this.continueChange = true;
        };
        return _this;
    }
    UnControlled.prototype.setCursor = function (cursorPos, scroll, focus) {
        var doc = this.editor.getDoc();
        if (focus) {
            this.editor.focus();
        }
        if (scroll) {
            doc.setCursor(cursorPos);
        }
        else {
            doc.setCursor(cursorPos, null, { scroll: false });
        }
    };
    UnControlled.prototype.moveCursor = function (cursorPos, scroll) {
        var doc = this.editor.getDoc();
        if (scroll) {
            doc.setCursor(cursorPos);
        }
        else {
            doc.setCursor(cursorPos, null, { scroll: false });
        }
    };
    UnControlled.prototype.hydrate = function (props) {
        var _this = this;
        Object.keys(props.options || {}).forEach(function (key) { return _this.editor.setOption(key, props.options[key]); });
        if (!this.hydrated) {
            var lastLine = this.editor.lastLine();
            var lastChar = this.editor.getLine(this.editor.lastLine()).length;
            this.editor.replaceRange(props.value || '', { line: 0, ch: 0 }, { line: lastLine, ch: lastChar });
        }
        this.hydrated = true;
    };
    UnControlled.prototype.componentWillMount = function () {
        if (SERVER_RENDERED)
            return;
        if (this.props.editorWillMount) {
            this.props.editorWillMount();
        }
    };
    UnControlled.prototype.componentDidMount = function () {
        var _this = this;
        if (SERVER_RENDERED)
            return;
        if (this.props.defineMode) {
            if (this.props.defineMode.name && this.props.defineMode.fn) {
                cm.defineMode(this.props.defineMode.name, this.props.defineMode.fn);
            }
        }
        this.editor = cm(this.ref);
        this.shared = new Shared(this.editor, this.props);
        this.editor.on('beforeChange', function (cm, data) {
            if (_this.props.onBeforeChange) {
                _this.props.onBeforeChange(_this.editor, data, null, _this.onBeforeChangeCb);
            }
        });
        this.editor.on('change', function (cm, data) {
            if (!_this.mounted) {
                return;
            }
            if (_this.props.onBeforeChange) {
                if (_this.continueChange) {
                    _this.props.onChange(_this.editor, data, _this.editor.getValue());
                }
                else {
                    return;
                }
            }
            else {
                _this.props.onChange(_this.editor, data, _this.editor.getValue());
            }
        });
        if (this.props.onBlur)
            this.shared.wire('onBlur');
        if (this.props.onCursor)
            this.shared.wire('onCursor');
        if (this.props.onCursorActivity)
            this.shared.wire('onCursorActivity');
        if (this.props.onDragEnter)
            this.shared.wire('onDragEnter');
        if (this.props.onDragOver)
            this.shared.wire('onDragOver');
        if (this.props.onDrop)
            this.shared.wire('onDrop');
        if (this.props.onFocus)
            this.shared.wire('onFocus');
        if (this.props.onGutterClick)
            this.shared.wire('onGutterClick');
        if (this.props.onKeyDown)
            this.shared.wire('onKeyDown');
        if (this.props.onKeyPress)
            this.shared.wire('onKeyPress');
        if (this.props.onKeyUp)
            this.shared.wire('onKeyUp');
        if (this.props.onScroll)
            this.shared.wire('onScroll');
        if (this.props.onSelection)
            this.shared.wire('onSelection');
        if (this.props.onUpdate)
            this.shared.wire('onUpdate');
        if (this.props.onViewportChange)
            this.shared.wire('onViewportChange');
        this.hydrate(this.props);
        if (this.props.selection) {
            var doc = this.editor.getDoc();
            doc.setSelections(this.props.selection);
        }
        if (this.props.cursor) {
            this.setCursor(this.props.cursor, this.props.autoScroll || false, this.props.autoFocus || false);
        }
        if (this.props.scroll) {
            this.editor.scrollTo(this.props.scroll.x, this.props.scroll.y);
        }
        this.mounted = true;
        this.editor.clearHistory();
        if (this.props.editorDidMount) {
            this.props.editorDidMount(this.editor, this.editor.getValue(), this.initCb);
        }
    };
    UnControlled.prototype.componentWillReceiveProps = function (nextProps) {
        if (SERVER_RENDERED)
            return;
        var cursorPos;
        if (nextProps.value !== this.props.value) {
            this.hydrated = false;
        }
        if (!this.props.autoCursor && this.props.autoCursor !== undefined) {
            cursorPos = this.editor.getCursor();
        }
        this.hydrate(nextProps);
        if (!this.props.autoCursor && this.props.autoCursor !== undefined) {
            this.moveCursor(cursorPos, this.props.autoScroll || false);
        }
    };
    UnControlled.prototype.componentWillUnmount = function () {
        if (SERVER_RENDERED)
            return;
        if (this.props.editorWillUnmount) {
            this.props.editorWillUnmount(cm);
        }
    };
    UnControlled.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return !SERVER_RENDERED;
    };
    UnControlled.prototype.render = function () {
        var _this = this;
        if (SERVER_RENDERED)
            return null;
        var className = this.props.className ? 'react-codemirror2 ' + this.props.className : 'react-codemirror2';
        return (React.createElement('div', { className: className, ref: function (self) { return _this.ref = self; } }));
    };
    return UnControlled;
}(React.Component));
exports.UnControlled = UnControlled;


/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

(function(mod) {
  if (true) // CommonJS
    mod(__webpack_require__(131), __webpack_require__(1600), __webpack_require__(1601));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../../lib/codemirror", "../xml/xml", "../meta"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
"use strict";

CodeMirror.defineMode("markdown", function(cmCfg, modeCfg) {

  var htmlMode = CodeMirror.getMode(cmCfg, "text/html");
  var htmlModeMissing = htmlMode.name == "null"

  function getMode(name) {
    if (CodeMirror.findModeByName) {
      var found = CodeMirror.findModeByName(name);
      if (found) name = found.mime || found.mimes[0];
    }
    var mode = CodeMirror.getMode(cmCfg, name);
    return mode.name == "null" ? null : mode;
  }

  // Should characters that affect highlighting be highlighted separate?
  // Does not include characters that will be output (such as `1.` and `-` for lists)
  if (modeCfg.highlightFormatting === undefined)
    modeCfg.highlightFormatting = false;

  // Maximum number of nested blockquotes. Set to 0 for infinite nesting.
  // Excess `>` will emit `error` token.
  if (modeCfg.maxBlockquoteDepth === undefined)
    modeCfg.maxBlockquoteDepth = 0;

  // Turn on task lists? ("- [ ] " and "- [x] ")
  if (modeCfg.taskLists === undefined) modeCfg.taskLists = false;

  // Turn on strikethrough syntax
  if (modeCfg.strikethrough === undefined)
    modeCfg.strikethrough = false;

  if (modeCfg.emoji === undefined)
    modeCfg.emoji = false;

  if (modeCfg.fencedCodeBlockHighlighting === undefined)
    modeCfg.fencedCodeBlockHighlighting = true;

  if (modeCfg.xml === undefined)
    modeCfg.xml = true;

  // Allow token types to be overridden by user-provided token types.
  if (modeCfg.tokenTypeOverrides === undefined)
    modeCfg.tokenTypeOverrides = {};

  var tokenTypes = {
    header: "header",
    code: "comment",
    quote: "quote",
    list1: "variable-2",
    list2: "variable-3",
    list3: "keyword",
    hr: "hr",
    image: "image",
    imageAltText: "image-alt-text",
    imageMarker: "image-marker",
    formatting: "formatting",
    linkInline: "link",
    linkEmail: "link",
    linkText: "link",
    linkHref: "string",
    em: "em",
    strong: "strong",
    strikethrough: "strikethrough",
    emoji: "builtin"
  };

  for (var tokenType in tokenTypes) {
    if (tokenTypes.hasOwnProperty(tokenType) && modeCfg.tokenTypeOverrides[tokenType]) {
      tokenTypes[tokenType] = modeCfg.tokenTypeOverrides[tokenType];
    }
  }

  var hrRE = /^([*\-_])(?:\s*\1){2,}\s*$/
  ,   listRE = /^(?:[*\-+]|^[0-9]+([.)]))\s+/
  ,   taskListRE = /^\[(x| )\](?=\s)/i // Must follow listRE
  ,   atxHeaderRE = modeCfg.allowAtxHeaderWithoutSpace ? /^(#+)/ : /^(#+)(?: |$)/
  ,   setextHeaderRE = /^ *(?:\={1,}|-{1,})\s*$/
  ,   textRE = /^[^#!\[\]*_\\<>` "'(~:]+/
  ,   fencedCodeRE = /^(~~~+|```+)[ \t]*([\w+#-]*)[^\n`]*$/
  ,   linkDefRE = /^\s*\[[^\]]+?\]:.*$/ // naive link-definition
  ,   punctuation = /[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E42\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDF3C-\uDF3E]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]/
  ,   expandedTab = "    " // CommonMark specifies tab as 4 spaces

  function switchInline(stream, state, f) {
    state.f = state.inline = f;
    return f(stream, state);
  }

  function switchBlock(stream, state, f) {
    state.f = state.block = f;
    return f(stream, state);
  }

  function lineIsEmpty(line) {
    return !line || !/\S/.test(line.string)
  }

  // Blocks

  function blankLine(state) {
    // Reset linkTitle state
    state.linkTitle = false;
    state.linkHref = false;
    state.linkText = false;
    // Reset EM state
    state.em = false;
    // Reset STRONG state
    state.strong = false;
    // Reset strikethrough state
    state.strikethrough = false;
    // Reset state.quote
    state.quote = 0;
    // Reset state.indentedCode
    state.indentedCode = false;
    if (state.f == htmlBlock) {
      var exit = htmlModeMissing
      if (!exit) {
        var inner = CodeMirror.innerMode(htmlMode, state.htmlState)
        exit = inner.mode.name == "xml" && inner.state.tagStart === null &&
          (!inner.state.context && inner.state.tokenize.isInText)
      }
      if (exit) {
        state.f = inlineNormal;
        state.block = blockNormal;
        state.htmlState = null;
      }
    }
    // Reset state.trailingSpace
    state.trailingSpace = 0;
    state.trailingSpaceNewLine = false;
    // Mark this line as blank
    state.prevLine = state.thisLine
    state.thisLine = {stream: null}
    return null;
  }

  function blockNormal(stream, state) {
    var firstTokenOnLine = stream.column() === state.indentation;
    var prevLineLineIsEmpty = lineIsEmpty(state.prevLine.stream);
    var prevLineIsIndentedCode = state.indentedCode;
    var prevLineIsHr = state.prevLine.hr;
    var prevLineIsList = state.list !== false;
    var maxNonCodeIndentation = (state.listStack[state.listStack.length - 1] || 0) + 3;

    state.indentedCode = false;

    var lineIndentation = state.indentation;
    // compute once per line (on first token)
    if (state.indentationDiff === null) {
      state.indentationDiff = state.indentation;
      if (prevLineIsList) {
        // Reset inline styles which shouldn't propagate aross list items
        state.em = false;
        state.strong = false;
        state.code = false;
        state.strikethrough = false;

        state.list = null;
        // While this list item's marker's indentation is less than the deepest
        //  list item's content's indentation,pop the deepest list item
        //  indentation off the stack, and update block indentation state
        while (lineIndentation < state.listStack[state.listStack.length - 1]) {
          state.listStack.pop();
          if (state.listStack.length) {
            state.indentation = state.listStack[state.listStack.length - 1];
          // less than the first list's indent -> the line is no longer a list
          } else {
            state.list = false;
          }
        }
        if (state.list !== false) {
          state.indentationDiff = lineIndentation - state.listStack[state.listStack.length - 1]
        }
      }
    }

    // not comprehensive (currently only for setext detection purposes)
    var allowsInlineContinuation = (
        !prevLineLineIsEmpty && !prevLineIsHr && !state.prevLine.header &&
        (!prevLineIsList || !prevLineIsIndentedCode) &&
        !state.prevLine.fencedCodeEnd
    );

    var isHr = (state.list === false || prevLineIsHr || prevLineLineIsEmpty) &&
      state.indentation <= maxNonCodeIndentation && stream.match(hrRE);

    var match = null;
    if (state.indentationDiff >= 4 && (prevLineIsIndentedCode || state.prevLine.fencedCodeEnd ||
         state.prevLine.header || prevLineLineIsEmpty)) {
      stream.skipToEnd();
      state.indentedCode = true;
      return tokenTypes.code;
    } else if (stream.eatSpace()) {
      return null;
    } else if (firstTokenOnLine && state.indentation <= maxNonCodeIndentation && (match = stream.match(atxHeaderRE)) && match[1].length <= 6) {
      state.quote = 0;
      state.header = match[1].length;
      state.thisLine.header = true;
      if (modeCfg.highlightFormatting) state.formatting = "header";
      state.f = state.inline;
      return getType(state);
    } else if (state.indentation <= maxNonCodeIndentation && stream.eat('>')) {
      state.quote = firstTokenOnLine ? 1 : state.quote + 1;
      if (modeCfg.highlightFormatting) state.formatting = "quote";
      stream.eatSpace();
      return getType(state);
    } else if (!isHr && !state.setext && firstTokenOnLine && state.indentation <= maxNonCodeIndentation && (match = stream.match(listRE))) {
      var listType = match[1] ? "ol" : "ul";

      state.indentation = lineIndentation + stream.current().length;
      state.list = true;
      state.quote = 0;

      // Add this list item's content's indentation to the stack
      state.listStack.push(state.indentation);

      if (modeCfg.taskLists && stream.match(taskListRE, false)) {
        state.taskList = true;
      }
      state.f = state.inline;
      if (modeCfg.highlightFormatting) state.formatting = ["list", "list-" + listType];
      return getType(state);
    } else if (firstTokenOnLine && state.indentation <= maxNonCodeIndentation && (match = stream.match(fencedCodeRE, true))) {
      state.quote = 0;
      state.fencedEndRE = new RegExp(match[1] + "+ *$");
      // try switching mode
      state.localMode = modeCfg.fencedCodeBlockHighlighting && getMode(match[2]);
      if (state.localMode) state.localState = CodeMirror.startState(state.localMode);
      state.f = state.block = local;
      if (modeCfg.highlightFormatting) state.formatting = "code-block";
      state.code = -1
      return getType(state);
    // SETEXT has lowest block-scope precedence after HR, so check it after
    //  the others (code, blockquote, list...)
    } else if (
      // if setext set, indicates line after ---/===
      state.setext || (
        // line before ---/===
        (!allowsInlineContinuation || !prevLineIsList) && !state.quote && state.list === false &&
        !state.code && !isHr && !linkDefRE.test(stream.string) &&
        (match = stream.lookAhead(1)) && (match = match.match(setextHeaderRE))
      )
    ) {
      if ( !state.setext ) {
        state.header = match[0].charAt(0) == '=' ? 1 : 2;
        state.setext = state.header;
      } else {
        state.header = state.setext;
        // has no effect on type so we can reset it now
        state.setext = 0;
        stream.skipToEnd();
        if (modeCfg.highlightFormatting) state.formatting = "header";
      }
      state.thisLine.header = true;
      state.f = state.inline;
      return getType(state);
    } else if (isHr) {
      stream.skipToEnd();
      state.hr = true;
      state.thisLine.hr = true;
      return tokenTypes.hr;
    } else if (stream.peek() === '[') {
      return switchInline(stream, state, footnoteLink);
    }

    return switchInline(stream, state, state.inline);
  }

  function htmlBlock(stream, state) {
    var style = htmlMode.token(stream, state.htmlState);
    if (!htmlModeMissing) {
      var inner = CodeMirror.innerMode(htmlMode, state.htmlState)
      if ((inner.mode.name == "xml" && inner.state.tagStart === null &&
           (!inner.state.context && inner.state.tokenize.isInText)) ||
          (state.md_inside && stream.current().indexOf(">") > -1)) {
        state.f = inlineNormal;
        state.block = blockNormal;
        state.htmlState = null;
      }
    }
    return style;
  }

  function local(stream, state) {
    var currListInd = state.listStack[state.listStack.length - 1] || 0;
    var hasExitedList = state.indentation < currListInd;
    var maxFencedEndInd = currListInd + 3;
    if (state.fencedEndRE && state.indentation <= maxFencedEndInd && (hasExitedList || stream.match(state.fencedEndRE))) {
      if (modeCfg.highlightFormatting) state.formatting = "code-block";
      var returnType;
      if (!hasExitedList) returnType = getType(state)
      state.localMode = state.localState = null;
      state.block = blockNormal;
      state.f = inlineNormal;
      state.fencedEndRE = null;
      state.code = 0
      state.thisLine.fencedCodeEnd = true;
      if (hasExitedList) return switchBlock(stream, state, state.block);
      return returnType;
    } else if (state.localMode) {
      return state.localMode.token(stream, state.localState);
    } else {
      stream.skipToEnd();
      return tokenTypes.code;
    }
  }

  // Inline
  function getType(state) {
    var styles = [];

    if (state.formatting) {
      styles.push(tokenTypes.formatting);

      if (typeof state.formatting === "string") state.formatting = [state.formatting];

      for (var i = 0; i < state.formatting.length; i++) {
        styles.push(tokenTypes.formatting + "-" + state.formatting[i]);

        if (state.formatting[i] === "header") {
          styles.push(tokenTypes.formatting + "-" + state.formatting[i] + "-" + state.header);
        }

        // Add `formatting-quote` and `formatting-quote-#` for blockquotes
        // Add `error` instead if the maximum blockquote nesting depth is passed
        if (state.formatting[i] === "quote") {
          if (!modeCfg.maxBlockquoteDepth || modeCfg.maxBlockquoteDepth >= state.quote) {
            styles.push(tokenTypes.formatting + "-" + state.formatting[i] + "-" + state.quote);
          } else {
            styles.push("error");
          }
        }
      }
    }

    if (state.taskOpen) {
      styles.push("meta");
      return styles.length ? styles.join(' ') : null;
    }
    if (state.taskClosed) {
      styles.push("property");
      return styles.length ? styles.join(' ') : null;
    }

    if (state.linkHref) {
      styles.push(tokenTypes.linkHref, "url");
    } else { // Only apply inline styles to non-url text
      if (state.strong) { styles.push(tokenTypes.strong); }
      if (state.em) { styles.push(tokenTypes.em); }
      if (state.strikethrough) { styles.push(tokenTypes.strikethrough); }
      if (state.emoji) { styles.push(tokenTypes.emoji); }
      if (state.linkText) { styles.push(tokenTypes.linkText); }
      if (state.code) { styles.push(tokenTypes.code); }
      if (state.image) { styles.push(tokenTypes.image); }
      if (state.imageAltText) { styles.push(tokenTypes.imageAltText, "link"); }
      if (state.imageMarker) { styles.push(tokenTypes.imageMarker); }
    }

    if (state.header) { styles.push(tokenTypes.header, tokenTypes.header + "-" + state.header); }

    if (state.quote) {
      styles.push(tokenTypes.quote);

      // Add `quote-#` where the maximum for `#` is modeCfg.maxBlockquoteDepth
      if (!modeCfg.maxBlockquoteDepth || modeCfg.maxBlockquoteDepth >= state.quote) {
        styles.push(tokenTypes.quote + "-" + state.quote);
      } else {
        styles.push(tokenTypes.quote + "-" + modeCfg.maxBlockquoteDepth);
      }
    }

    if (state.list !== false) {
      var listMod = (state.listStack.length - 1) % 3;
      if (!listMod) {
        styles.push(tokenTypes.list1);
      } else if (listMod === 1) {
        styles.push(tokenTypes.list2);
      } else {
        styles.push(tokenTypes.list3);
      }
    }

    if (state.trailingSpaceNewLine) {
      styles.push("trailing-space-new-line");
    } else if (state.trailingSpace) {
      styles.push("trailing-space-" + (state.trailingSpace % 2 ? "a" : "b"));
    }

    return styles.length ? styles.join(' ') : null;
  }

  function handleText(stream, state) {
    if (stream.match(textRE, true)) {
      return getType(state);
    }
    return undefined;
  }

  function inlineNormal(stream, state) {
    var style = state.text(stream, state);
    if (typeof style !== 'undefined')
      return style;

    if (state.list) { // List marker (*, +, -, 1., etc)
      state.list = null;
      return getType(state);
    }

    if (state.taskList) {
      var taskOpen = stream.match(taskListRE, true)[1] === " ";
      if (taskOpen) state.taskOpen = true;
      else state.taskClosed = true;
      if (modeCfg.highlightFormatting) state.formatting = "task";
      state.taskList = false;
      return getType(state);
    }

    state.taskOpen = false;
    state.taskClosed = false;

    if (state.header && stream.match(/^#+$/, true)) {
      if (modeCfg.highlightFormatting) state.formatting = "header";
      return getType(state);
    }

    var ch = stream.next();

    // Matches link titles present on next line
    if (state.linkTitle) {
      state.linkTitle = false;
      var matchCh = ch;
      if (ch === '(') {
        matchCh = ')';
      }
      matchCh = (matchCh+'').replace(/([.?*+^\[\]\\(){}|-])/g, "\\$1");
      var regex = '^\\s*(?:[^' + matchCh + '\\\\]+|\\\\\\\\|\\\\.)' + matchCh;
      if (stream.match(new RegExp(regex), true)) {
        return tokenTypes.linkHref;
      }
    }

    // If this block is changed, it may need to be updated in GFM mode
    if (ch === '`') {
      var previousFormatting = state.formatting;
      if (modeCfg.highlightFormatting) state.formatting = "code";
      stream.eatWhile('`');
      var count = stream.current().length
      if (state.code == 0 && (!state.quote || count == 1)) {
        state.code = count
        return getType(state)
      } else if (count == state.code) { // Must be exact
        var t = getType(state)
        state.code = 0
        return t
      } else {
        state.formatting = previousFormatting
        return getType(state)
      }
    } else if (state.code) {
      return getType(state);
    }

    if (ch === '\\') {
      stream.next();
      if (modeCfg.highlightFormatting) {
        var type = getType(state);
        var formattingEscape = tokenTypes.formatting + "-escape";
        return type ? type + " " + formattingEscape : formattingEscape;
      }
    }

    if (ch === '!' && stream.match(/\[[^\]]*\] ?(?:\(|\[)/, false)) {
      state.imageMarker = true;
      state.image = true;
      if (modeCfg.highlightFormatting) state.formatting = "image";
      return getType(state);
    }

    if (ch === '[' && state.imageMarker && stream.match(/[^\]]*\](\(.*?\)| ?\[.*?\])/, false)) {
      state.imageMarker = false;
      state.imageAltText = true
      if (modeCfg.highlightFormatting) state.formatting = "image";
      return getType(state);
    }

    if (ch === ']' && state.imageAltText) {
      if (modeCfg.highlightFormatting) state.formatting = "image";
      var type = getType(state);
      state.imageAltText = false;
      state.image = false;
      state.inline = state.f = linkHref;
      return type;
    }

    if (ch === '[' && !state.image) {
      if (state.linkText && stream.match(/^.*?\]/)) return getType(state)
      state.linkText = true;
      if (modeCfg.highlightFormatting) state.formatting = "link";
      return getType(state);
    }

    if (ch === ']' && state.linkText) {
      if (modeCfg.highlightFormatting) state.formatting = "link";
      var type = getType(state);
      state.linkText = false;
      state.inline = state.f = stream.match(/\(.*?\)| ?\[.*?\]/, false) ? linkHref : inlineNormal
      return type;
    }

    if (ch === '<' && stream.match(/^(https?|ftps?):\/\/(?:[^\\>]|\\.)+>/, false)) {
      state.f = state.inline = linkInline;
      if (modeCfg.highlightFormatting) state.formatting = "link";
      var type = getType(state);
      if (type){
        type += " ";
      } else {
        type = "";
      }
      return type + tokenTypes.linkInline;
    }

    if (ch === '<' && stream.match(/^[^> \\]+@(?:[^\\>]|\\.)+>/, false)) {
      state.f = state.inline = linkInline;
      if (modeCfg.highlightFormatting) state.formatting = "link";
      var type = getType(state);
      if (type){
        type += " ";
      } else {
        type = "";
      }
      return type + tokenTypes.linkEmail;
    }

    if (modeCfg.xml && ch === '<' && stream.match(/^(!--|\?|!\[CDATA\[|[a-z][a-z0-9-]*(?:\s+[a-z_:.\-]+(?:\s*=\s*[^>]+)?)*\s*(?:>|$))/i, false)) {
      var end = stream.string.indexOf(">", stream.pos);
      if (end != -1) {
        var atts = stream.string.substring(stream.start, end);
        if (/markdown\s*=\s*('|"){0,1}1('|"){0,1}/.test(atts)) state.md_inside = true;
      }
      stream.backUp(1);
      state.htmlState = CodeMirror.startState(htmlMode);
      return switchBlock(stream, state, htmlBlock);
    }

    if (modeCfg.xml && ch === '<' && stream.match(/^\/\w*?>/)) {
      state.md_inside = false;
      return "tag";
    } else if (ch === "*" || ch === "_") {
      var len = 1, before = stream.pos == 1 ? " " : stream.string.charAt(stream.pos - 2)
      while (len < 3 && stream.eat(ch)) len++
      var after = stream.peek() || " "
      // See http://spec.commonmark.org/0.27/#emphasis-and-strong-emphasis
      var leftFlanking = !/\s/.test(after) && (!punctuation.test(after) || /\s/.test(before) || punctuation.test(before))
      var rightFlanking = !/\s/.test(before) && (!punctuation.test(before) || /\s/.test(after) || punctuation.test(after))
      var setEm = null, setStrong = null
      if (len % 2) { // Em
        if (!state.em && leftFlanking && (ch === "*" || !rightFlanking || punctuation.test(before)))
          setEm = true
        else if (state.em == ch && rightFlanking && (ch === "*" || !leftFlanking || punctuation.test(after)))
          setEm = false
      }
      if (len > 1) { // Strong
        if (!state.strong && leftFlanking && (ch === "*" || !rightFlanking || punctuation.test(before)))
          setStrong = true
        else if (state.strong == ch && rightFlanking && (ch === "*" || !leftFlanking || punctuation.test(after)))
          setStrong = false
      }
      if (setStrong != null || setEm != null) {
        if (modeCfg.highlightFormatting) state.formatting = setEm == null ? "strong" : setStrong == null ? "em" : "strong em"
        if (setEm === true) state.em = ch
        if (setStrong === true) state.strong = ch
        var t = getType(state)
        if (setEm === false) state.em = false
        if (setStrong === false) state.strong = false
        return t
      }
    } else if (ch === ' ') {
      if (stream.eat('*') || stream.eat('_')) { // Probably surrounded by spaces
        if (stream.peek() === ' ') { // Surrounded by spaces, ignore
          return getType(state);
        } else { // Not surrounded by spaces, back up pointer
          stream.backUp(1);
        }
      }
    }

    if (modeCfg.strikethrough) {
      if (ch === '~' && stream.eatWhile(ch)) {
        if (state.strikethrough) {// Remove strikethrough
          if (modeCfg.highlightFormatting) state.formatting = "strikethrough";
          var t = getType(state);
          state.strikethrough = false;
          return t;
        } else if (stream.match(/^[^\s]/, false)) {// Add strikethrough
          state.strikethrough = true;
          if (modeCfg.highlightFormatting) state.formatting = "strikethrough";
          return getType(state);
        }
      } else if (ch === ' ') {
        if (stream.match(/^~~/, true)) { // Probably surrounded by space
          if (stream.peek() === ' ') { // Surrounded by spaces, ignore
            return getType(state);
          } else { // Not surrounded by spaces, back up pointer
            stream.backUp(2);
          }
        }
      }
    }

    if (modeCfg.emoji && ch === ":" && stream.match(/^(?:[a-z_\d+][a-z_\d+-]*|\-[a-z_\d+][a-z_\d+-]*):/)) {
      state.emoji = true;
      if (modeCfg.highlightFormatting) state.formatting = "emoji";
      var retType = getType(state);
      state.emoji = false;
      return retType;
    }

    if (ch === ' ') {
      if (stream.match(/^ +$/, false)) {
        state.trailingSpace++;
      } else if (state.trailingSpace) {
        state.trailingSpaceNewLine = true;
      }
    }

    return getType(state);
  }

  function linkInline(stream, state) {
    var ch = stream.next();

    if (ch === ">") {
      state.f = state.inline = inlineNormal;
      if (modeCfg.highlightFormatting) state.formatting = "link";
      var type = getType(state);
      if (type){
        type += " ";
      } else {
        type = "";
      }
      return type + tokenTypes.linkInline;
    }

    stream.match(/^[^>]+/, true);

    return tokenTypes.linkInline;
  }

  function linkHref(stream, state) {
    // Check if space, and return NULL if so (to avoid marking the space)
    if(stream.eatSpace()){
      return null;
    }
    var ch = stream.next();
    if (ch === '(' || ch === '[') {
      state.f = state.inline = getLinkHrefInside(ch === "(" ? ")" : "]");
      if (modeCfg.highlightFormatting) state.formatting = "link-string";
      state.linkHref = true;
      return getType(state);
    }
    return 'error';
  }

  var linkRE = {
    ")": /^(?:[^\\\(\)]|\\.|\((?:[^\\\(\)]|\\.)*\))*?(?=\))/,
    "]": /^(?:[^\\\[\]]|\\.|\[(?:[^\\\[\]]|\\.)*\])*?(?=\])/
  }

  function getLinkHrefInside(endChar) {
    return function(stream, state) {
      var ch = stream.next();

      if (ch === endChar) {
        state.f = state.inline = inlineNormal;
        if (modeCfg.highlightFormatting) state.formatting = "link-string";
        var returnState = getType(state);
        state.linkHref = false;
        return returnState;
      }

      stream.match(linkRE[endChar])
      state.linkHref = true;
      return getType(state);
    };
  }

  function footnoteLink(stream, state) {
    if (stream.match(/^([^\]\\]|\\.)*\]:/, false)) {
      state.f = footnoteLinkInside;
      stream.next(); // Consume [
      if (modeCfg.highlightFormatting) state.formatting = "link";
      state.linkText = true;
      return getType(state);
    }
    return switchInline(stream, state, inlineNormal);
  }

  function footnoteLinkInside(stream, state) {
    if (stream.match(/^\]:/, true)) {
      state.f = state.inline = footnoteUrl;
      if (modeCfg.highlightFormatting) state.formatting = "link";
      var returnType = getType(state);
      state.linkText = false;
      return returnType;
    }

    stream.match(/^([^\]\\]|\\.)+/, true);

    return tokenTypes.linkText;
  }

  function footnoteUrl(stream, state) {
    // Check if space, and return NULL if so (to avoid marking the space)
    if(stream.eatSpace()){
      return null;
    }
    // Match URL
    stream.match(/^[^\s]+/, true);
    // Check for link title
    if (stream.peek() === undefined) { // End of line, set flag to check next line
      state.linkTitle = true;
    } else { // More content on line, check if link title
      stream.match(/^(?:\s+(?:"(?:[^"\\]|\\\\|\\.)+"|'(?:[^'\\]|\\\\|\\.)+'|\((?:[^)\\]|\\\\|\\.)+\)))?/, true);
    }
    state.f = state.inline = inlineNormal;
    return tokenTypes.linkHref + " url";
  }

  var mode = {
    startState: function() {
      return {
        f: blockNormal,

        prevLine: {stream: null},
        thisLine: {stream: null},

        block: blockNormal,
        htmlState: null,
        indentation: 0,

        inline: inlineNormal,
        text: handleText,

        formatting: false,
        linkText: false,
        linkHref: false,
        linkTitle: false,
        code: 0,
        em: false,
        strong: false,
        header: 0,
        setext: 0,
        hr: false,
        taskList: false,
        list: false,
        listStack: [],
        quote: 0,
        trailingSpace: 0,
        trailingSpaceNewLine: false,
        strikethrough: false,
        emoji: false,
        fencedEndRE: null
      };
    },

    copyState: function(s) {
      return {
        f: s.f,

        prevLine: s.prevLine,
        thisLine: s.thisLine,

        block: s.block,
        htmlState: s.htmlState && CodeMirror.copyState(htmlMode, s.htmlState),
        indentation: s.indentation,

        localMode: s.localMode,
        localState: s.localMode ? CodeMirror.copyState(s.localMode, s.localState) : null,

        inline: s.inline,
        text: s.text,
        formatting: false,
        linkText: s.linkText,
        linkTitle: s.linkTitle,
        linkHref: s.linkHref,
        code: s.code,
        em: s.em,
        strong: s.strong,
        strikethrough: s.strikethrough,
        emoji: s.emoji,
        header: s.header,
        setext: s.setext,
        hr: s.hr,
        taskList: s.taskList,
        list: s.list,
        listStack: s.listStack.slice(0),
        quote: s.quote,
        indentedCode: s.indentedCode,
        trailingSpace: s.trailingSpace,
        trailingSpaceNewLine: s.trailingSpaceNewLine,
        md_inside: s.md_inside,
        fencedEndRE: s.fencedEndRE
      };
    },

    token: function(stream, state) {

      // Reset state.formatting
      state.formatting = false;

      if (stream != state.thisLine.stream) {
        state.header = 0;
        state.hr = false;

        if (stream.match(/^\s*$/, true)) {
          blankLine(state);
          return null;
        }

        state.prevLine = state.thisLine
        state.thisLine = {stream: stream}

        // Reset state.taskList
        state.taskList = false;

        // Reset state.trailingSpace
        state.trailingSpace = 0;
        state.trailingSpaceNewLine = false;

        if (!state.localState) {
          state.f = state.block;
          if (state.f != htmlBlock) {
            var indentation = stream.match(/^\s*/, true)[0].replace(/\t/g, expandedTab).length;
            state.indentation = indentation;
            state.indentationDiff = null;
            if (indentation > 0) return null;
          }
        }
      }
      return state.f(stream, state);
    },

    innerMode: function(state) {
      if (state.block == htmlBlock) return {state: state.htmlState, mode: htmlMode};
      if (state.localState) return {state: state.localState, mode: state.localMode};
      return {state: state, mode: mode};
    },

    indent: function(state, textAfter, line) {
      if (state.block == htmlBlock && htmlMode.indent) return htmlMode.indent(state.htmlState, textAfter, line)
      if (state.localState && state.localMode.indent) return state.localMode.indent(state.localState, textAfter, line)
      return CodeMirror.Pass
    },

    blankLine: blankLine,

    getType: getType,

    blockCommentStart: "<!--",
    blockCommentEnd: "-->",
    closeBrackets: "()[]{}''\"\"``",
    fold: "markdown"
  };
  return mode;
}, "xml");

CodeMirror.defineMIME("text/markdown", "markdown");

CodeMirror.defineMIME("text/x-markdown", "markdown");

});


/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

(function(mod) {
  if (true) // CommonJS
    mod(__webpack_require__(131));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../../lib/codemirror"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
"use strict";

var htmlConfig = {
  autoSelfClosers: {'area': true, 'base': true, 'br': true, 'col': true, 'command': true,
                    'embed': true, 'frame': true, 'hr': true, 'img': true, 'input': true,
                    'keygen': true, 'link': true, 'meta': true, 'param': true, 'source': true,
                    'track': true, 'wbr': true, 'menuitem': true},
  implicitlyClosed: {'dd': true, 'li': true, 'optgroup': true, 'option': true, 'p': true,
                     'rp': true, 'rt': true, 'tbody': true, 'td': true, 'tfoot': true,
                     'th': true, 'tr': true},
  contextGrabbers: {
    'dd': {'dd': true, 'dt': true},
    'dt': {'dd': true, 'dt': true},
    'li': {'li': true},
    'option': {'option': true, 'optgroup': true},
    'optgroup': {'optgroup': true},
    'p': {'address': true, 'article': true, 'aside': true, 'blockquote': true, 'dir': true,
          'div': true, 'dl': true, 'fieldset': true, 'footer': true, 'form': true,
          'h1': true, 'h2': true, 'h3': true, 'h4': true, 'h5': true, 'h6': true,
          'header': true, 'hgroup': true, 'hr': true, 'menu': true, 'nav': true, 'ol': true,
          'p': true, 'pre': true, 'section': true, 'table': true, 'ul': true},
    'rp': {'rp': true, 'rt': true},
    'rt': {'rp': true, 'rt': true},
    'tbody': {'tbody': true, 'tfoot': true},
    'td': {'td': true, 'th': true},
    'tfoot': {'tbody': true},
    'th': {'td': true, 'th': true},
    'thead': {'tbody': true, 'tfoot': true},
    'tr': {'tr': true}
  },
  doNotIndent: {"pre": true},
  allowUnquoted: true,
  allowMissing: true,
  caseFold: true
}

var xmlConfig = {
  autoSelfClosers: {},
  implicitlyClosed: {},
  contextGrabbers: {},
  doNotIndent: {},
  allowUnquoted: false,
  allowMissing: false,
  allowMissingTagName: false,
  caseFold: false
}

CodeMirror.defineMode("xml", function(editorConf, config_) {
  var indentUnit = editorConf.indentUnit
  var config = {}
  var defaults = config_.htmlMode ? htmlConfig : xmlConfig
  for (var prop in defaults) config[prop] = defaults[prop]
  for (var prop in config_) config[prop] = config_[prop]

  // Return variables for tokenizers
  var type, setStyle;

  function inText(stream, state) {
    function chain(parser) {
      state.tokenize = parser;
      return parser(stream, state);
    }

    var ch = stream.next();
    if (ch == "<") {
      if (stream.eat("!")) {
        if (stream.eat("[")) {
          if (stream.match("CDATA[")) return chain(inBlock("atom", "]]>"));
          else return null;
        } else if (stream.match("--")) {
          return chain(inBlock("comment", "-->"));
        } else if (stream.match("DOCTYPE", true, true)) {
          stream.eatWhile(/[\w\._\-]/);
          return chain(doctype(1));
        } else {
          return null;
        }
      } else if (stream.eat("?")) {
        stream.eatWhile(/[\w\._\-]/);
        state.tokenize = inBlock("meta", "?>");
        return "meta";
      } else {
        type = stream.eat("/") ? "closeTag" : "openTag";
        state.tokenize = inTag;
        return "tag bracket";
      }
    } else if (ch == "&") {
      var ok;
      if (stream.eat("#")) {
        if (stream.eat("x")) {
          ok = stream.eatWhile(/[a-fA-F\d]/) && stream.eat(";");
        } else {
          ok = stream.eatWhile(/[\d]/) && stream.eat(";");
        }
      } else {
        ok = stream.eatWhile(/[\w\.\-:]/) && stream.eat(";");
      }
      return ok ? "atom" : "error";
    } else {
      stream.eatWhile(/[^&<]/);
      return null;
    }
  }
  inText.isInText = true;

  function inTag(stream, state) {
    var ch = stream.next();
    if (ch == ">" || (ch == "/" && stream.eat(">"))) {
      state.tokenize = inText;
      type = ch == ">" ? "endTag" : "selfcloseTag";
      return "tag bracket";
    } else if (ch == "=") {
      type = "equals";
      return null;
    } else if (ch == "<") {
      state.tokenize = inText;
      state.state = baseState;
      state.tagName = state.tagStart = null;
      var next = state.tokenize(stream, state);
      return next ? next + " tag error" : "tag error";
    } else if (/[\'\"]/.test(ch)) {
      state.tokenize = inAttribute(ch);
      state.stringStartCol = stream.column();
      return state.tokenize(stream, state);
    } else {
      stream.match(/^[^\s\u00a0=<>\"\']*[^\s\u00a0=<>\"\'\/]/);
      return "word";
    }
  }

  function inAttribute(quote) {
    var closure = function(stream, state) {
      while (!stream.eol()) {
        if (stream.next() == quote) {
          state.tokenize = inTag;
          break;
        }
      }
      return "string";
    };
    closure.isInAttribute = true;
    return closure;
  }

  function inBlock(style, terminator) {
    return function(stream, state) {
      while (!stream.eol()) {
        if (stream.match(terminator)) {
          state.tokenize = inText;
          break;
        }
        stream.next();
      }
      return style;
    }
  }

  function doctype(depth) {
    return function(stream, state) {
      var ch;
      while ((ch = stream.next()) != null) {
        if (ch == "<") {
          state.tokenize = doctype(depth + 1);
          return state.tokenize(stream, state);
        } else if (ch == ">") {
          if (depth == 1) {
            state.tokenize = inText;
            break;
          } else {
            state.tokenize = doctype(depth - 1);
            return state.tokenize(stream, state);
          }
        }
      }
      return "meta";
    };
  }

  function Context(state, tagName, startOfLine) {
    this.prev = state.context;
    this.tagName = tagName;
    this.indent = state.indented;
    this.startOfLine = startOfLine;
    if (config.doNotIndent.hasOwnProperty(tagName) || (state.context && state.context.noIndent))
      this.noIndent = true;
  }
  function popContext(state) {
    if (state.context) state.context = state.context.prev;
  }
  function maybePopContext(state, nextTagName) {
    var parentTagName;
    while (true) {
      if (!state.context) {
        return;
      }
      parentTagName = state.context.tagName;
      if (!config.contextGrabbers.hasOwnProperty(parentTagName) ||
          !config.contextGrabbers[parentTagName].hasOwnProperty(nextTagName)) {
        return;
      }
      popContext(state);
    }
  }

  function baseState(type, stream, state) {
    if (type == "openTag") {
      state.tagStart = stream.column();
      return tagNameState;
    } else if (type == "closeTag") {
      return closeTagNameState;
    } else {
      return baseState;
    }
  }
  function tagNameState(type, stream, state) {
    if (type == "word") {
      state.tagName = stream.current();
      setStyle = "tag";
      return attrState;
    } else if (config.allowMissingTagName && type == "endTag") {
      setStyle = "tag bracket";
      return attrState(type, stream, state);
    } else {
      setStyle = "error";
      return tagNameState;
    }
  }
  function closeTagNameState(type, stream, state) {
    if (type == "word") {
      var tagName = stream.current();
      if (state.context && state.context.tagName != tagName &&
          config.implicitlyClosed.hasOwnProperty(state.context.tagName))
        popContext(state);
      if ((state.context && state.context.tagName == tagName) || config.matchClosing === false) {
        setStyle = "tag";
        return closeState;
      } else {
        setStyle = "tag error";
        return closeStateErr;
      }
    } else if (config.allowMissingTagName && type == "endTag") {
      setStyle = "tag bracket";
      return closeState(type, stream, state);
    } else {
      setStyle = "error";
      return closeStateErr;
    }
  }

  function closeState(type, _stream, state) {
    if (type != "endTag") {
      setStyle = "error";
      return closeState;
    }
    popContext(state);
    return baseState;
  }
  function closeStateErr(type, stream, state) {
    setStyle = "error";
    return closeState(type, stream, state);
  }

  function attrState(type, _stream, state) {
    if (type == "word") {
      setStyle = "attribute";
      return attrEqState;
    } else if (type == "endTag" || type == "selfcloseTag") {
      var tagName = state.tagName, tagStart = state.tagStart;
      state.tagName = state.tagStart = null;
      if (type == "selfcloseTag" ||
          config.autoSelfClosers.hasOwnProperty(tagName)) {
        maybePopContext(state, tagName);
      } else {
        maybePopContext(state, tagName);
        state.context = new Context(state, tagName, tagStart == state.indented);
      }
      return baseState;
    }
    setStyle = "error";
    return attrState;
  }
  function attrEqState(type, stream, state) {
    if (type == "equals") return attrValueState;
    if (!config.allowMissing) setStyle = "error";
    return attrState(type, stream, state);
  }
  function attrValueState(type, stream, state) {
    if (type == "string") return attrContinuedState;
    if (type == "word" && config.allowUnquoted) {setStyle = "string"; return attrState;}
    setStyle = "error";
    return attrState(type, stream, state);
  }
  function attrContinuedState(type, stream, state) {
    if (type == "string") return attrContinuedState;
    return attrState(type, stream, state);
  }

  return {
    startState: function(baseIndent) {
      var state = {tokenize: inText,
                   state: baseState,
                   indented: baseIndent || 0,
                   tagName: null, tagStart: null,
                   context: null}
      if (baseIndent != null) state.baseIndent = baseIndent
      return state
    },

    token: function(stream, state) {
      if (!state.tagName && stream.sol())
        state.indented = stream.indentation();

      if (stream.eatSpace()) return null;
      type = null;
      var style = state.tokenize(stream, state);
      if ((style || type) && style != "comment") {
        setStyle = null;
        state.state = state.state(type || style, stream, state);
        if (setStyle)
          style = setStyle == "error" ? style + " error" : setStyle;
      }
      return style;
    },

    indent: function(state, textAfter, fullLine) {
      var context = state.context;
      // Indent multi-line strings (e.g. css).
      if (state.tokenize.isInAttribute) {
        if (state.tagStart == state.indented)
          return state.stringStartCol + 1;
        else
          return state.indented + indentUnit;
      }
      if (context && context.noIndent) return CodeMirror.Pass;
      if (state.tokenize != inTag && state.tokenize != inText)
        return fullLine ? fullLine.match(/^(\s*)/)[0].length : 0;
      // Indent the starts of attribute names.
      if (state.tagName) {
        if (config.multilineTagIndentPastTag !== false)
          return state.tagStart + state.tagName.length + 2;
        else
          return state.tagStart + indentUnit * (config.multilineTagIndentFactor || 1);
      }
      if (config.alignCDATA && /<!\[CDATA\[/.test(textAfter)) return 0;
      var tagAfter = textAfter && /^<(\/)?([\w_:\.-]*)/.exec(textAfter);
      if (tagAfter && tagAfter[1]) { // Closing tag spotted
        while (context) {
          if (context.tagName == tagAfter[2]) {
            context = context.prev;
            break;
          } else if (config.implicitlyClosed.hasOwnProperty(context.tagName)) {
            context = context.prev;
          } else {
            break;
          }
        }
      } else if (tagAfter) { // Opening tag spotted
        while (context) {
          var grabbers = config.contextGrabbers[context.tagName];
          if (grabbers && grabbers.hasOwnProperty(tagAfter[2]))
            context = context.prev;
          else
            break;
        }
      }
      while (context && context.prev && !context.startOfLine)
        context = context.prev;
      if (context) return context.indent + indentUnit;
      else return state.baseIndent || 0;
    },

    electricInput: /<\/[\s\w:]+>$/,
    blockCommentStart: "<!--",
    blockCommentEnd: "-->",

    configuration: config.htmlMode ? "html" : "xml",
    helperType: config.htmlMode ? "html" : "xml",

    skipAttribute: function(state) {
      if (state.state == attrValueState)
        state.state = attrState
    }
  };
});

CodeMirror.defineMIME("text/xml", "xml");
CodeMirror.defineMIME("application/xml", "xml");
if (!CodeMirror.mimeModes.hasOwnProperty("text/html"))
  CodeMirror.defineMIME("text/html", {name: "xml", htmlMode: true});

});


/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

(function(mod) {
  if (true) // CommonJS
    mod(__webpack_require__(131));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../lib/codemirror"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
  "use strict";

  CodeMirror.modeInfo = [
    {name: "APL", mime: "text/apl", mode: "apl", ext: ["dyalog", "apl"]},
    {name: "PGP", mimes: ["application/pgp", "application/pgp-encrypted", "application/pgp-keys", "application/pgp-signature"], mode: "asciiarmor", ext: ["asc", "pgp", "sig"]},
    {name: "ASN.1", mime: "text/x-ttcn-asn", mode: "asn.1", ext: ["asn", "asn1"]},
    {name: "Asterisk", mime: "text/x-asterisk", mode: "asterisk", file: /^extensions\.conf$/i},
    {name: "Brainfuck", mime: "text/x-brainfuck", mode: "brainfuck", ext: ["b", "bf"]},
    {name: "C", mime: "text/x-csrc", mode: "clike", ext: ["c", "h", "ino"]},
    {name: "C++", mime: "text/x-c++src", mode: "clike", ext: ["cpp", "c++", "cc", "cxx", "hpp", "h++", "hh", "hxx"], alias: ["cpp"]},
    {name: "Cobol", mime: "text/x-cobol", mode: "cobol", ext: ["cob", "cpy"]},
    {name: "C#", mime: "text/x-csharp", mode: "clike", ext: ["cs"], alias: ["csharp"]},
    {name: "Clojure", mime: "text/x-clojure", mode: "clojure", ext: ["clj", "cljc", "cljx"]},
    {name: "ClojureScript", mime: "text/x-clojurescript", mode: "clojure", ext: ["cljs"]},
    {name: "Closure Stylesheets (GSS)", mime: "text/x-gss", mode: "css", ext: ["gss"]},
    {name: "CMake", mime: "text/x-cmake", mode: "cmake", ext: ["cmake", "cmake.in"], file: /^CMakeLists.txt$/},
    {name: "CoffeeScript", mimes: ["application/vnd.coffeescript", "text/coffeescript", "text/x-coffeescript"], mode: "coffeescript", ext: ["coffee"], alias: ["coffee", "coffee-script"]},
    {name: "Common Lisp", mime: "text/x-common-lisp", mode: "commonlisp", ext: ["cl", "lisp", "el"], alias: ["lisp"]},
    {name: "Cypher", mime: "application/x-cypher-query", mode: "cypher", ext: ["cyp", "cypher"]},
    {name: "Cython", mime: "text/x-cython", mode: "python", ext: ["pyx", "pxd", "pxi"]},
    {name: "Crystal", mime: "text/x-crystal", mode: "crystal", ext: ["cr"]},
    {name: "CSS", mime: "text/css", mode: "css", ext: ["css"]},
    {name: "CQL", mime: "text/x-cassandra", mode: "sql", ext: ["cql"]},
    {name: "D", mime: "text/x-d", mode: "d", ext: ["d"]},
    {name: "Dart", mimes: ["application/dart", "text/x-dart"], mode: "dart", ext: ["dart"]},
    {name: "diff", mime: "text/x-diff", mode: "diff", ext: ["diff", "patch"]},
    {name: "Django", mime: "text/x-django", mode: "django"},
    {name: "Dockerfile", mime: "text/x-dockerfile", mode: "dockerfile", file: /^Dockerfile$/},
    {name: "DTD", mime: "application/xml-dtd", mode: "dtd", ext: ["dtd"]},
    {name: "Dylan", mime: "text/x-dylan", mode: "dylan", ext: ["dylan", "dyl", "intr"]},
    {name: "EBNF", mime: "text/x-ebnf", mode: "ebnf"},
    {name: "ECL", mime: "text/x-ecl", mode: "ecl", ext: ["ecl"]},
    {name: "edn", mime: "application/edn", mode: "clojure", ext: ["edn"]},
    {name: "Eiffel", mime: "text/x-eiffel", mode: "eiffel", ext: ["e"]},
    {name: "Elm", mime: "text/x-elm", mode: "elm", ext: ["elm"]},
    {name: "Embedded Javascript", mime: "application/x-ejs", mode: "htmlembedded", ext: ["ejs"]},
    {name: "Embedded Ruby", mime: "application/x-erb", mode: "htmlembedded", ext: ["erb"]},
    {name: "Erlang", mime: "text/x-erlang", mode: "erlang", ext: ["erl"]},
    {name: "Esper", mime: "text/x-esper", mode: "sql"},
    {name: "Factor", mime: "text/x-factor", mode: "factor", ext: ["factor"]},
    {name: "FCL", mime: "text/x-fcl", mode: "fcl"},
    {name: "Forth", mime: "text/x-forth", mode: "forth", ext: ["forth", "fth", "4th"]},
    {name: "Fortran", mime: "text/x-fortran", mode: "fortran", ext: ["f", "for", "f77", "f90", "f95"]},
    {name: "F#", mime: "text/x-fsharp", mode: "mllike", ext: ["fs"], alias: ["fsharp"]},
    {name: "Gas", mime: "text/x-gas", mode: "gas", ext: ["s"]},
    {name: "Gherkin", mime: "text/x-feature", mode: "gherkin", ext: ["feature"]},
    {name: "GitHub Flavored Markdown", mime: "text/x-gfm", mode: "gfm", file: /^(readme|contributing|history).md$/i},
    {name: "Go", mime: "text/x-go", mode: "go", ext: ["go"]},
    {name: "Groovy", mime: "text/x-groovy", mode: "groovy", ext: ["groovy", "gradle"], file: /^Jenkinsfile$/},
    {name: "HAML", mime: "text/x-haml", mode: "haml", ext: ["haml"]},
    {name: "Haskell", mime: "text/x-haskell", mode: "haskell", ext: ["hs"]},
    {name: "Haskell (Literate)", mime: "text/x-literate-haskell", mode: "haskell-literate", ext: ["lhs"]},
    {name: "Haxe", mime: "text/x-haxe", mode: "haxe", ext: ["hx"]},
    {name: "HXML", mime: "text/x-hxml", mode: "haxe", ext: ["hxml"]},
    {name: "ASP.NET", mime: "application/x-aspx", mode: "htmlembedded", ext: ["aspx"], alias: ["asp", "aspx"]},
    {name: "HTML", mime: "text/html", mode: "htmlmixed", ext: ["html", "htm", "handlebars", "hbs"], alias: ["xhtml"]},
    {name: "HTTP", mime: "message/http", mode: "http"},
    {name: "IDL", mime: "text/x-idl", mode: "idl", ext: ["pro"]},
    {name: "Pug", mime: "text/x-pug", mode: "pug", ext: ["jade", "pug"], alias: ["jade"]},
    {name: "Java", mime: "text/x-java", mode: "clike", ext: ["java"]},
    {name: "Java Server Pages", mime: "application/x-jsp", mode: "htmlembedded", ext: ["jsp"], alias: ["jsp"]},
    {name: "JavaScript", mimes: ["text/javascript", "text/ecmascript", "application/javascript", "application/x-javascript", "application/ecmascript"],
     mode: "javascript", ext: ["js"], alias: ["ecmascript", "js", "node"]},
    {name: "JSON", mimes: ["application/json", "application/x-json"], mode: "javascript", ext: ["json", "map"], alias: ["json5"]},
    {name: "JSON-LD", mime: "application/ld+json", mode: "javascript", ext: ["jsonld"], alias: ["jsonld"]},
    {name: "JSX", mime: "text/jsx", mode: "jsx", ext: ["jsx"]},
    {name: "Jinja2", mime: "null", mode: "jinja2", ext: ["j2", "jinja", "jinja2"]},
    {name: "Julia", mime: "text/x-julia", mode: "julia", ext: ["jl"]},
    {name: "Kotlin", mime: "text/x-kotlin", mode: "clike", ext: ["kt"]},
    {name: "LESS", mime: "text/x-less", mode: "css", ext: ["less"]},
    {name: "LiveScript", mime: "text/x-livescript", mode: "livescript", ext: ["ls"], alias: ["ls"]},
    {name: "Lua", mime: "text/x-lua", mode: "lua", ext: ["lua"]},
    {name: "Markdown", mime: "text/x-markdown", mode: "markdown", ext: ["markdown", "md", "mkd"]},
    {name: "mIRC", mime: "text/mirc", mode: "mirc"},
    {name: "MariaDB SQL", mime: "text/x-mariadb", mode: "sql"},
    {name: "Mathematica", mime: "text/x-mathematica", mode: "mathematica", ext: ["m", "nb"]},
    {name: "Modelica", mime: "text/x-modelica", mode: "modelica", ext: ["mo"]},
    {name: "MUMPS", mime: "text/x-mumps", mode: "mumps", ext: ["mps"]},
    {name: "MS SQL", mime: "text/x-mssql", mode: "sql"},
    {name: "mbox", mime: "application/mbox", mode: "mbox", ext: ["mbox"]},
    {name: "MySQL", mime: "text/x-mysql", mode: "sql"},
    {name: "Nginx", mime: "text/x-nginx-conf", mode: "nginx", file: /nginx.*\.conf$/i},
    {name: "NSIS", mime: "text/x-nsis", mode: "nsis", ext: ["nsh", "nsi"]},
    {name: "NTriples", mimes: ["application/n-triples", "application/n-quads", "text/n-triples"],
     mode: "ntriples", ext: ["nt", "nq"]},
    {name: "Objective-C", mime: "text/x-objectivec", mode: "clike", ext: ["m", "mm"], alias: ["objective-c", "objc"]},
    {name: "OCaml", mime: "text/x-ocaml", mode: "mllike", ext: ["ml", "mli", "mll", "mly"]},
    {name: "Octave", mime: "text/x-octave", mode: "octave", ext: ["m"]},
    {name: "Oz", mime: "text/x-oz", mode: "oz", ext: ["oz"]},
    {name: "Pascal", mime: "text/x-pascal", mode: "pascal", ext: ["p", "pas"]},
    {name: "PEG.js", mime: "null", mode: "pegjs", ext: ["jsonld"]},
    {name: "Perl", mime: "text/x-perl", mode: "perl", ext: ["pl", "pm"]},
    {name: "PHP", mimes: ["text/x-php", "application/x-httpd-php", "application/x-httpd-php-open"], mode: "php", ext: ["php", "php3", "php4", "php5", "php7", "phtml"]},
    {name: "Pig", mime: "text/x-pig", mode: "pig", ext: ["pig"]},
    {name: "Plain Text", mime: "text/plain", mode: "null", ext: ["txt", "text", "conf", "def", "list", "log"]},
    {name: "PLSQL", mime: "text/x-plsql", mode: "sql", ext: ["pls"]},
    {name: "PowerShell", mime: "application/x-powershell", mode: "powershell", ext: ["ps1", "psd1", "psm1"]},
    {name: "Properties files", mime: "text/x-properties", mode: "properties", ext: ["properties", "ini", "in"], alias: ["ini", "properties"]},
    {name: "ProtoBuf", mime: "text/x-protobuf", mode: "protobuf", ext: ["proto"]},
    {name: "Python", mime: "text/x-python", mode: "python", ext: ["BUILD", "bzl", "py", "pyw"], file: /^(BUCK|BUILD)$/},
    {name: "Puppet", mime: "text/x-puppet", mode: "puppet", ext: ["pp"]},
    {name: "Q", mime: "text/x-q", mode: "q", ext: ["q"]},
    {name: "R", mime: "text/x-rsrc", mode: "r", ext: ["r", "R"], alias: ["rscript"]},
    {name: "reStructuredText", mime: "text/x-rst", mode: "rst", ext: ["rst"], alias: ["rst"]},
    {name: "RPM Changes", mime: "text/x-rpm-changes", mode: "rpm"},
    {name: "RPM Spec", mime: "text/x-rpm-spec", mode: "rpm", ext: ["spec"]},
    {name: "Ruby", mime: "text/x-ruby", mode: "ruby", ext: ["rb"], alias: ["jruby", "macruby", "rake", "rb", "rbx"]},
    {name: "Rust", mime: "text/x-rustsrc", mode: "rust", ext: ["rs"]},
    {name: "SAS", mime: "text/x-sas", mode: "sas", ext: ["sas"]},
    {name: "Sass", mime: "text/x-sass", mode: "sass", ext: ["sass"]},
    {name: "Scala", mime: "text/x-scala", mode: "clike", ext: ["scala"]},
    {name: "Scheme", mime: "text/x-scheme", mode: "scheme", ext: ["scm", "ss"]},
    {name: "SCSS", mime: "text/x-scss", mode: "css", ext: ["scss"]},
    {name: "Shell", mimes: ["text/x-sh", "application/x-sh"], mode: "shell", ext: ["sh", "ksh", "bash"], alias: ["bash", "sh", "zsh"], file: /^PKGBUILD$/},
    {name: "Sieve", mime: "application/sieve", mode: "sieve", ext: ["siv", "sieve"]},
    {name: "Slim", mimes: ["text/x-slim", "application/x-slim"], mode: "slim", ext: ["slim"]},
    {name: "Smalltalk", mime: "text/x-stsrc", mode: "smalltalk", ext: ["st"]},
    {name: "Smarty", mime: "text/x-smarty", mode: "smarty", ext: ["tpl"]},
    {name: "Solr", mime: "text/x-solr", mode: "solr"},
    {name: "SML", mime: "text/x-sml", mode: "mllike", ext: ["sml", "sig", "fun", "smackspec"]},
    {name: "Soy", mime: "text/x-soy", mode: "soy", ext: ["soy"], alias: ["closure template"]},
    {name: "SPARQL", mime: "application/sparql-query", mode: "sparql", ext: ["rq", "sparql"], alias: ["sparul"]},
    {name: "Spreadsheet", mime: "text/x-spreadsheet", mode: "spreadsheet", alias: ["excel", "formula"]},
    {name: "SQL", mime: "text/x-sql", mode: "sql", ext: ["sql"]},
    {name: "SQLite", mime: "text/x-sqlite", mode: "sql"},
    {name: "Squirrel", mime: "text/x-squirrel", mode: "clike", ext: ["nut"]},
    {name: "Stylus", mime: "text/x-styl", mode: "stylus", ext: ["styl"]},
    {name: "Swift", mime: "text/x-swift", mode: "swift", ext: ["swift"]},
    {name: "sTeX", mime: "text/x-stex", mode: "stex"},
    {name: "LaTeX", mime: "text/x-latex", mode: "stex", ext: ["text", "ltx", "tex"], alias: ["tex"]},
    {name: "SystemVerilog", mime: "text/x-systemverilog", mode: "verilog", ext: ["v", "sv", "svh"]},
    {name: "Tcl", mime: "text/x-tcl", mode: "tcl", ext: ["tcl"]},
    {name: "Textile", mime: "text/x-textile", mode: "textile", ext: ["textile"]},
    {name: "TiddlyWiki ", mime: "text/x-tiddlywiki", mode: "tiddlywiki"},
    {name: "Tiki wiki", mime: "text/tiki", mode: "tiki"},
    {name: "TOML", mime: "text/x-toml", mode: "toml", ext: ["toml"]},
    {name: "Tornado", mime: "text/x-tornado", mode: "tornado"},
    {name: "troff", mime: "text/troff", mode: "troff", ext: ["1", "2", "3", "4", "5", "6", "7", "8", "9"]},
    {name: "TTCN", mime: "text/x-ttcn", mode: "ttcn", ext: ["ttcn", "ttcn3", "ttcnpp"]},
    {name: "TTCN_CFG", mime: "text/x-ttcn-cfg", mode: "ttcn-cfg", ext: ["cfg"]},
    {name: "Turtle", mime: "text/turtle", mode: "turtle", ext: ["ttl"]},
    {name: "TypeScript", mime: "application/typescript", mode: "javascript", ext: ["ts"], alias: ["ts"]},
    {name: "TypeScript-JSX", mime: "text/typescript-jsx", mode: "jsx", ext: ["tsx"], alias: ["tsx"]},
    {name: "Twig", mime: "text/x-twig", mode: "twig"},
    {name: "Web IDL", mime: "text/x-webidl", mode: "webidl", ext: ["webidl"]},
    {name: "VB.NET", mime: "text/x-vb", mode: "vb", ext: ["vb"]},
    {name: "VBScript", mime: "text/vbscript", mode: "vbscript", ext: ["vbs"]},
    {name: "Velocity", mime: "text/velocity", mode: "velocity", ext: ["vtl"]},
    {name: "Verilog", mime: "text/x-verilog", mode: "verilog", ext: ["v"]},
    {name: "VHDL", mime: "text/x-vhdl", mode: "vhdl", ext: ["vhd", "vhdl"]},
    {name: "Vue.js Component", mimes: ["script/x-vue", "text/x-vue"], mode: "vue", ext: ["vue"]},
    {name: "XML", mimes: ["application/xml", "text/xml"], mode: "xml", ext: ["xml", "xsl", "xsd", "svg"], alias: ["rss", "wsdl", "xsd"]},
    {name: "XQuery", mime: "application/xquery", mode: "xquery", ext: ["xy", "xquery"]},
    {name: "Yacas", mime: "text/x-yacas", mode: "yacas", ext: ["ys"]},
    {name: "YAML", mimes: ["text/x-yaml", "text/yaml"], mode: "yaml", ext: ["yaml", "yml"], alias: ["yml"]},
    {name: "Z80", mime: "text/x-z80", mode: "z80", ext: ["z80"]},
    {name: "mscgen", mime: "text/x-mscgen", mode: "mscgen", ext: ["mscgen", "mscin", "msc"]},
    {name: "xu", mime: "text/x-xu", mode: "mscgen", ext: ["xu"]},
    {name: "msgenny", mime: "text/x-msgenny", mode: "mscgen", ext: ["msgenny"]}
  ];
  // Ensure all modes have a mime property for backwards compatibility
  for (var i = 0; i < CodeMirror.modeInfo.length; i++) {
    var info = CodeMirror.modeInfo[i];
    if (info.mimes) info.mime = info.mimes[0];
  }

  CodeMirror.findModeByMIME = function(mime) {
    mime = mime.toLowerCase();
    for (var i = 0; i < CodeMirror.modeInfo.length; i++) {
      var info = CodeMirror.modeInfo[i];
      if (info.mime == mime) return info;
      if (info.mimes) for (var j = 0; j < info.mimes.length; j++)
        if (info.mimes[j] == mime) return info;
    }
    if (/\+xml$/.test(mime)) return CodeMirror.findModeByMIME("application/xml")
    if (/\+json$/.test(mime)) return CodeMirror.findModeByMIME("application/json")
  };

  CodeMirror.findModeByExtension = function(ext) {
    for (var i = 0; i < CodeMirror.modeInfo.length; i++) {
      var info = CodeMirror.modeInfo[i];
      if (info.ext) for (var j = 0; j < info.ext.length; j++)
        if (info.ext[j] == ext) return info;
    }
  };

  CodeMirror.findModeByFileName = function(filename) {
    for (var i = 0; i < CodeMirror.modeInfo.length; i++) {
      var info = CodeMirror.modeInfo[i];
      if (info.file && info.file.test(filename)) return info;
    }
    var dot = filename.lastIndexOf(".");
    var ext = dot > -1 && filename.substring(dot + 1, filename.length);
    if (ext) return CodeMirror.findModeByExtension(ext);
  };

  CodeMirror.findModeByName = function(name) {
    name = name.toLowerCase();
    for (var i = 0; i < CodeMirror.modeInfo.length; i++) {
      var info = CodeMirror.modeInfo[i];
      if (info.name.toLowerCase() == name) return info;
      if (info.alias) for (var j = 0; j < info.alias.length; j++)
        if (info.alias[j].toLowerCase() == name) return info;
    }
  };
});


/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

// Utility function that allows modes to be combined. The mode given
// as the base argument takes care of most of the normal mode
// functionality, but a second (typically simple) mode is used, which
// can override the style of text. Both modes get to parse all of the
// text, but when both assign a non-null style to a piece of code, the
// overlay wins, unless the combine argument was true and not overridden,
// or state.overlay.combineTokens was true, in which case the styles are
// combined.

(function(mod) {
  if (true) // CommonJS
    mod(__webpack_require__(131));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../../lib/codemirror"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
"use strict";

CodeMirror.overlayMode = function(base, overlay, combine) {
  return {
    startState: function() {
      return {
        base: CodeMirror.startState(base),
        overlay: CodeMirror.startState(overlay),
        basePos: 0, baseCur: null,
        overlayPos: 0, overlayCur: null,
        streamSeen: null
      };
    },
    copyState: function(state) {
      return {
        base: CodeMirror.copyState(base, state.base),
        overlay: CodeMirror.copyState(overlay, state.overlay),
        basePos: state.basePos, baseCur: null,
        overlayPos: state.overlayPos, overlayCur: null
      };
    },

    token: function(stream, state) {
      if (stream != state.streamSeen ||
          Math.min(state.basePos, state.overlayPos) < stream.start) {
        state.streamSeen = stream;
        state.basePos = state.overlayPos = stream.start;
      }

      if (stream.start == state.basePos) {
        state.baseCur = base.token(stream, state.base);
        state.basePos = stream.pos;
      }
      if (stream.start == state.overlayPos) {
        stream.pos = stream.start;
        state.overlayCur = overlay.token(stream, state.overlay);
        state.overlayPos = stream.pos;
      }
      stream.pos = Math.min(state.basePos, state.overlayPos);

      // state.overlay.combineTokens always takes precedence over combine,
      // unless set to null
      if (state.overlayCur == null) return state.baseCur;
      else if (state.baseCur != null &&
               state.overlay.combineTokens ||
               combine && state.overlay.combineTokens == null)
        return state.baseCur + " " + state.overlayCur;
      else return state.overlayCur;
    },

    indent: base.indent && function(state, textAfter) {
      return base.indent(state.base, textAfter);
    },
    electricChars: base.electricChars,

    innerMode: function(state) { return {state: state.base, mode: base}; },

    blankLine: function(state) {
      var baseToken, overlayToken;
      if (base.blankLine) baseToken = base.blankLine(state.base);
      if (overlay.blankLine) overlayToken = overlay.blankLine(state.overlay);

      return overlayToken == null ?
        baseToken :
        (combine && baseToken != null ? baseToken + " " + overlayToken : overlayToken);
    }
  };
};

});


/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

(function(mod) {
  if (true) // CommonJS
    mod(__webpack_require__(131));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../../lib/codemirror"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
  CodeMirror.defineOption("placeholder", "", function(cm, val, old) {
    var prev = old && old != CodeMirror.Init;
    if (val && !prev) {
      cm.on("blur", onBlur);
      cm.on("change", onChange);
      cm.on("swapDoc", onChange);
      onChange(cm);
    } else if (!val && prev) {
      cm.off("blur", onBlur);
      cm.off("change", onChange);
      cm.off("swapDoc", onChange);
      clearPlaceholder(cm);
      var wrapper = cm.getWrapperElement();
      wrapper.className = wrapper.className.replace(" CodeMirror-empty", "");
    }

    if (val && !cm.hasFocus()) onBlur(cm);
  });

  function clearPlaceholder(cm) {
    if (cm.state.placeholder) {
      cm.state.placeholder.parentNode.removeChild(cm.state.placeholder);
      cm.state.placeholder = null;
    }
  }
  function setPlaceholder(cm) {
    clearPlaceholder(cm);
    var elt = cm.state.placeholder = document.createElement("pre");
    elt.style.cssText = "height: 0; overflow: visible";
    elt.style.direction = cm.getOption("direction");
    elt.className = "CodeMirror-placeholder";
    var placeHolder = cm.getOption("placeholder")
    if (typeof placeHolder == "string") placeHolder = document.createTextNode(placeHolder)
    elt.appendChild(placeHolder)
    cm.display.lineSpace.insertBefore(elt, cm.display.lineSpace.firstChild);
  }

  function onBlur(cm) {
    if (isEmpty(cm)) setPlaceholder(cm);
  }
  function onChange(cm) {
    var wrapper = cm.getWrapperElement(), empty = isEmpty(cm);
    wrapper.className = wrapper.className.replace(" CodeMirror-empty", "") + (empty ? " CodeMirror-empty" : "");

    if (empty) setPlaceholder(cm);
    else clearPlaceholder(cm);
  }

  function isEmpty(cm) {
    return (cm.lineCount() === 1) && (cm.getLine(0) === "");
  }
});


/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Use strict mode (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Strict_mode)



// Requires
var Typo = __webpack_require__(1605);


// Create function
function CodeMirrorSpellChecker(options) {
	// Initialize
	options = options || {};


	// Verify
	if(typeof options.codeMirrorInstance !== "function" || typeof options.codeMirrorInstance.defineMode !== "function") {
		console.log("CodeMirror Spell Checker: You must provide an instance of CodeMirror via the option `codeMirrorInstance`");
		return;
	}


	// Because some browsers don't support this functionality yet
	if(!String.prototype.includes) {
		String.prototype.includes = function() {
			"use strict";
			return String.prototype.indexOf.apply(this, arguments) !== -1;
		};
	}


	// Define the new mode
	options.codeMirrorInstance.defineMode("spell-checker", function(config) {
		// Load AFF/DIC data
		if(!CodeMirrorSpellChecker.aff_loading) {
			CodeMirrorSpellChecker.aff_loading = true;
			var xhr_aff = new XMLHttpRequest();
			xhr_aff.open("GET", "https://cdn.jsdelivr.net/codemirror.spell-checker/latest/en_US.aff", true);
			xhr_aff.onload = function() {
				if(xhr_aff.readyState === 4 && xhr_aff.status === 200) {
					CodeMirrorSpellChecker.aff_data = xhr_aff.responseText;
					CodeMirrorSpellChecker.num_loaded++;

					if(CodeMirrorSpellChecker.num_loaded == 2) {
						CodeMirrorSpellChecker.typo = new Typo("en_US", CodeMirrorSpellChecker.aff_data, CodeMirrorSpellChecker.dic_data, {
							platform: "any"
						});
					}
				}
			};
			xhr_aff.send(null);
		}

		if(!CodeMirrorSpellChecker.dic_loading) {
			CodeMirrorSpellChecker.dic_loading = true;
			var xhr_dic = new XMLHttpRequest();
			xhr_dic.open("GET", "https://cdn.jsdelivr.net/codemirror.spell-checker/latest/en_US.dic", true);
			xhr_dic.onload = function() {
				if(xhr_dic.readyState === 4 && xhr_dic.status === 200) {
					CodeMirrorSpellChecker.dic_data = xhr_dic.responseText;
					CodeMirrorSpellChecker.num_loaded++;

					if(CodeMirrorSpellChecker.num_loaded == 2) {
						CodeMirrorSpellChecker.typo = new Typo("en_US", CodeMirrorSpellChecker.aff_data, CodeMirrorSpellChecker.dic_data, {
							platform: "any"
						});
					}
				}
			};
			xhr_dic.send(null);
		}


		// Define what separates a word
		var rx_word = "!\"#$%&()*+,-./:;<=>?@[\\]^_`{|}~ ";


		// Create the overlay and such
		var overlay = {
			token: function(stream) {
				var ch = stream.peek();
				var word = "";

				if(rx_word.includes(ch)) {
					stream.next();
					return null;
				}

				while((ch = stream.peek()) != null && !rx_word.includes(ch)) {
					word += ch;
					stream.next();
				}

				if(CodeMirrorSpellChecker.typo && !CodeMirrorSpellChecker.typo.check(word))
					return "spell-error"; // CSS class: cm-spell-error

				return null;
			}
		};

		var mode = options.codeMirrorInstance.getMode(
			config, config.backdrop || "text/plain"
		);

		return options.codeMirrorInstance.overlayMode(mode, overlay, true);
	});
}


// Initialize data globally to reduce memory consumption
CodeMirrorSpellChecker.num_loaded = 0;
CodeMirrorSpellChecker.aff_loading = false;
CodeMirrorSpellChecker.dic_loading = false;
CodeMirrorSpellChecker.aff_data = "";
CodeMirrorSpellChecker.dic_data = "";
CodeMirrorSpellChecker.typo;


// Export
module.exports = CodeMirrorSpellChecker;

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__dirname, Buffer) {/* globals chrome: false */
/* globals __dirname: false */
/* globals require: false */
/* globals Buffer: false */
/* globals module: false */

/**
 * Typo is a JavaScript implementation of a spellchecker using hunspell-style 
 * dictionaries.
 */

var Typo;

(function () {
"use strict";

/**
 * Typo constructor.
 *
 * @param {String} [dictionary] The locale code of the dictionary being used. e.g.,
 *                              "en_US". This is only used to auto-load dictionaries.
 * @param {String} [affData]    The data from the dictionary's .aff file. If omitted
 *                              and Typo.js is being used in a Chrome extension, the .aff
 *                              file will be loaded automatically from
 *                              lib/typo/dictionaries/[dictionary]/[dictionary].aff
 *                              In other environments, it will be loaded from
 *                              [settings.dictionaryPath]/dictionaries/[dictionary]/[dictionary].aff
 * @param {String} [wordsData]  The data from the dictionary's .dic file. If omitted
 *                              and Typo.js is being used in a Chrome extension, the .dic
 *                              file will be loaded automatically from
 *                              lib/typo/dictionaries/[dictionary]/[dictionary].dic
 *                              In other environments, it will be loaded from
 *                              [settings.dictionaryPath]/dictionaries/[dictionary]/[dictionary].dic
 * @param {Object} [settings]   Constructor settings. Available properties are:
 *                              {String} [dictionaryPath]: path to load dictionary from in non-chrome
 *                              environment.
 *                              {Object} [flags]: flag information.
 *                              {Boolean} [asyncLoad]: If true, affData and wordsData will be loaded
 *                              asynchronously.
 *                              {Function} [loadedCallback]: Called when both affData and wordsData
 *                              have been loaded. Only used if asyncLoad is set to true. The parameter
 *                              is the instantiated Typo object.
 *
 * @returns {Typo} A Typo object.
 */

Typo = function (dictionary, affData, wordsData, settings) {
	settings = settings || {};

	this.dictionary = null;
	
	this.rules = {};
	this.dictionaryTable = {};
	
	this.compoundRules = [];
	this.compoundRuleCodes = {};
	
	this.replacementTable = [];
	
	this.flags = settings.flags || {}; 
	
	this.memoized = {};

	this.loaded = false;
	
	var self = this;
	
	var path;
	
	// Loop-control variables.
	var i, j, _len, _jlen;
	
	if (dictionary) {
		self.dictionary = dictionary;
		
		// If the data is preloaded, just setup the Typo object.
		if (affData && wordsData) {
			setup();
		}
		// Loading data for Chrome extentions.
		else if (typeof window !== 'undefined' && 'chrome' in window && 'extension' in window.chrome && 'getURL' in window.chrome.extension) {
			if (settings.dictionaryPath) {
				path = settings.dictionaryPath;
			}
			else {
				path = "typo/dictionaries";
			}
			
			if (!affData) readDataFile(chrome.extension.getURL(path + "/" + dictionary + "/" + dictionary + ".aff"), setAffData);
			if (!wordsData) readDataFile(chrome.extension.getURL(path + "/" + dictionary + "/" + dictionary + ".dic"), setWordsData);
		}
		else {
			if (settings.dictionaryPath) {
				path = settings.dictionaryPath;
			}
			else if (true) {
				path = __dirname + '/dictionaries';
			}
			else {
				path = './dictionaries';
			}
			
			if (!affData) readDataFile(path + "/" + dictionary + "/" + dictionary + ".aff", setAffData);
			if (!wordsData) readDataFile(path + "/" + dictionary + "/" + dictionary + ".dic", setWordsData);
		}
	}
	
	function readDataFile(url, setFunc) {
		var response = self._readFile(url, null, settings.asyncLoad);
		
		if (settings.asyncLoad) {
			response.then(function(data) {
				setFunc(data);
			});
		}
		else {
			setFunc(response);
		}
	}

	function setAffData(data) {
		affData = data;

		if (wordsData) {
			setup();
		}
	}

	function setWordsData(data) {
		wordsData = data;

		if (affData) {
			setup();
		}
	}

	function setup() {
		self.rules = self._parseAFF(affData);
		
		// Save the rule codes that are used in compound rules.
		self.compoundRuleCodes = {};
		
		for (i = 0, _len = self.compoundRules.length; i < _len; i++) {
			var rule = self.compoundRules[i];
			
			for (j = 0, _jlen = rule.length; j < _jlen; j++) {
				self.compoundRuleCodes[rule[j]] = [];
			}
		}
		
		// If we add this ONLYINCOMPOUND flag to self.compoundRuleCodes, then _parseDIC
		// will do the work of saving the list of words that are compound-only.
		if ("ONLYINCOMPOUND" in self.flags) {
			self.compoundRuleCodes[self.flags.ONLYINCOMPOUND] = [];
		}
		
		self.dictionaryTable = self._parseDIC(wordsData);
		
		// Get rid of any codes from the compound rule codes that are never used 
		// (or that were special regex characters).  Not especially necessary... 
		for (i in self.compoundRuleCodes) {
			if (self.compoundRuleCodes[i].length === 0) {
				delete self.compoundRuleCodes[i];
			}
		}
		
		// Build the full regular expressions for each compound rule.
		// I have a feeling (but no confirmation yet) that this method of 
		// testing for compound words is probably slow.
		for (i = 0, _len = self.compoundRules.length; i < _len; i++) {
			var ruleText = self.compoundRules[i];
			
			var expressionText = "";
			
			for (j = 0, _jlen = ruleText.length; j < _jlen; j++) {
				var character = ruleText[j];
				
				if (character in self.compoundRuleCodes) {
					expressionText += "(" + self.compoundRuleCodes[character].join("|") + ")";
				}
				else {
					expressionText += character;
				}
			}
			
			self.compoundRules[i] = new RegExp(expressionText, "i");
		}
		
		self.loaded = true;
		
		if (settings.asyncLoad && settings.loadedCallback) {
			settings.loadedCallback(self);
		}
	}
	
	return this;
};

Typo.prototype = {
	/**
	 * Loads a Typo instance from a hash of all of the Typo properties.
	 *
	 * @param object obj A hash of Typo properties, probably gotten from a JSON.parse(JSON.stringify(typo_instance)).
	 */
	
	load : function (obj) {
		for (var i in obj) {
			if (obj.hasOwnProperty(i)) {
				this[i] = obj[i];
			}
		}
		
		return this;
	},
	
	/**
	 * Read the contents of a file.
	 * 
	 * @param {String} path The path (relative) to the file.
	 * @param {String} [charset="ISO8859-1"] The expected charset of the file
	 * @param {Boolean} async If true, the file will be read asynchronously. For node.js this does nothing, all
	 *        files are read synchronously.
	 * @returns {String} The file data if async is false, otherwise a promise object. If running node.js, the data is
	 *          always returned.
	 */
	
	_readFile : function (path, charset, async) {
		charset = charset || "utf8";
		
		if (typeof XMLHttpRequest !== 'undefined') {
			var promise;
			var req = new XMLHttpRequest();
			req.open("GET", path, async);
			
			if (async) {
				promise = new Promise(function(resolve, reject) {
					req.onload = function() {
						if (req.status === 200) {
							resolve(req.responseText);
						}
						else {
							reject(req.statusText);
						}
					};
					
					req.onerror = function() {
						reject(req.statusText);
					}
				});
			}
		
			if (req.overrideMimeType)
				req.overrideMimeType("text/plain; charset=" + charset);
		
			req.send(null);
			
			return async ? promise : req.responseText;
		}
		else if (true) {
			// Node.js
			var fs = __webpack_require__(1606);
			
			try {
				if (fs.existsSync(path)) {
					var stats = fs.statSync(path);
					
					var fileDescriptor = fs.openSync(path, 'r');
					
					var buffer = new Buffer(stats.size);
					
					fs.readSync(fileDescriptor, buffer, 0, buffer.length, null);
					
					return buffer.toString(charset, 0, buffer.length);
				}
				else {
					console.log("Path " + path + " does not exist.");
				}
			} catch (e) {
				console.log(e);
				return '';
			}
		}
	},
	
	/**
	 * Parse the rules out from a .aff file.
	 *
	 * @param {String} data The contents of the affix file.
	 * @returns object The rules from the file.
	 */
	
	_parseAFF : function (data) {
		var rules = {};
		
		var line, subline, numEntries, lineParts;
		var i, j, _len, _jlen;
		
		// Remove comment lines
		data = this._removeAffixComments(data);
		
		var lines = data.split("\n");
		
		for (i = 0, _len = lines.length; i < _len; i++) {
			line = lines[i];
			
			var definitionParts = line.split(/\s+/);
			
			var ruleType = definitionParts[0];
			
			if (ruleType == "PFX" || ruleType == "SFX") {
				var ruleCode = definitionParts[1];
				var combineable = definitionParts[2];
				numEntries = parseInt(definitionParts[3], 10);
				
				var entries = [];
				
				for (j = i + 1, _jlen = i + 1 + numEntries; j < _jlen; j++) {
					subline = lines[j];
					
					lineParts = subline.split(/\s+/);
					var charactersToRemove = lineParts[2];
					
					var additionParts = lineParts[3].split("/");
					
					var charactersToAdd = additionParts[0];
					if (charactersToAdd === "0") charactersToAdd = "";
					
					var continuationClasses = this.parseRuleCodes(additionParts[1]);
					
					var regexToMatch = lineParts[4];
					
					var entry = {};
					entry.add = charactersToAdd;
					
					if (continuationClasses.length > 0) entry.continuationClasses = continuationClasses;
					
					if (regexToMatch !== ".") {
						if (ruleType === "SFX") {
							entry.match = new RegExp(regexToMatch + "$");
						}
						else {
							entry.match = new RegExp("^" + regexToMatch);
						}
					}
					
					if (charactersToRemove != "0") {
						if (ruleType === "SFX") {
							entry.remove = new RegExp(charactersToRemove  + "$");
						}
						else {
							entry.remove = charactersToRemove;
						}
					}
					
					entries.push(entry);
				}
				
				rules[ruleCode] = { "type" : ruleType, "combineable" : (combineable == "Y"), "entries" : entries };
				
				i += numEntries;
			}
			else if (ruleType === "COMPOUNDRULE") {
				numEntries = parseInt(definitionParts[1], 10);
				
				for (j = i + 1, _jlen = i + 1 + numEntries; j < _jlen; j++) {
					line = lines[j];
					
					lineParts = line.split(/\s+/);
					this.compoundRules.push(lineParts[1]);
				}
				
				i += numEntries;
			}
			else if (ruleType === "REP") {
				lineParts = line.split(/\s+/);
				
				if (lineParts.length === 3) {
					this.replacementTable.push([ lineParts[1], lineParts[2] ]);
				}
			}
			else {
				// ONLYINCOMPOUND
				// COMPOUNDMIN
				// FLAG
				// KEEPCASE
				// NEEDAFFIX
				
				this.flags[ruleType] = definitionParts[1];
			}
		}
		
		return rules;
	},
	
	/**
	 * Removes comment lines and then cleans up blank lines and trailing whitespace.
	 *
	 * @param {String} data The data from an affix file.
	 * @return {String} The cleaned-up data.
	 */
	
	_removeAffixComments : function (data) {
		// Remove comments
		// This used to remove any string starting with '#' up to the end of the line,
		// but some COMPOUNDRULE definitions include '#' as part of the rule.
		// I haven't seen any affix files that use comments on the same line as real data,
		// so I don't think this will break anything.
		data = data.replace(/^\s*#.*$/mg, "");
		
		// Trim each line
		data = data.replace(/^\s\s*/m, '').replace(/\s\s*$/m, '');
		
		// Remove blank lines.
		data = data.replace(/\n{2,}/g, "\n");
		
		// Trim the entire string
		data = data.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
		
		return data;
	},
	
	/**
	 * Parses the words out from the .dic file.
	 *
	 * @param {String} data The data from the dictionary file.
	 * @returns object The lookup table containing all of the words and
	 *                 word forms from the dictionary.
	 */
	
	_parseDIC : function (data) {
		data = this._removeDicComments(data);
		
		var lines = data.split("\n");
		var dictionaryTable = {};
		
		function addWord(word, rules) {
			// Some dictionaries will list the same word multiple times with different rule sets.
			if (!dictionaryTable.hasOwnProperty(word)) {
				dictionaryTable[word] = null;
			}
			
			if (rules.length > 0) {
				if (dictionaryTable[word] === null) {
					dictionaryTable[word] = [];
				}

				dictionaryTable[word].push(rules);
			}
		}
		
		// The first line is the number of words in the dictionary.
		for (var i = 1, _len = lines.length; i < _len; i++) {
			var line = lines[i];
			
			var parts = line.split("/", 2);
			
			var word = parts[0];

			// Now for each affix rule, generate that form of the word.
			if (parts.length > 1) {
				var ruleCodesArray = this.parseRuleCodes(parts[1]);
				
				// Save the ruleCodes for compound word situations.
				if (!("NEEDAFFIX" in this.flags) || ruleCodesArray.indexOf(this.flags.NEEDAFFIX) == -1) {
					addWord(word, ruleCodesArray);
				}
				
				for (var j = 0, _jlen = ruleCodesArray.length; j < _jlen; j++) {
					var code = ruleCodesArray[j];
					
					var rule = this.rules[code];
					
					if (rule) {
						var newWords = this._applyRule(word, rule);
						
						for (var ii = 0, _iilen = newWords.length; ii < _iilen; ii++) {
							var newWord = newWords[ii];
							
							addWord(newWord, []);
							
							if (rule.combineable) {
								for (var k = j + 1; k < _jlen; k++) {
									var combineCode = ruleCodesArray[k];
									
									var combineRule = this.rules[combineCode];
									
									if (combineRule) {
										if (combineRule.combineable && (rule.type != combineRule.type)) {
											var otherNewWords = this._applyRule(newWord, combineRule);
											
											for (var iii = 0, _iiilen = otherNewWords.length; iii < _iiilen; iii++) {
												var otherNewWord = otherNewWords[iii];
												addWord(otherNewWord, []);
											}
										}
									}
								}
							}
						}
					}
					
					if (code in this.compoundRuleCodes) {
						this.compoundRuleCodes[code].push(word);
					}
				}
			}
			else {
				addWord(word.trim(), []);
			}
		}
		
		return dictionaryTable;
	},
	
	
	/**
	 * Removes comment lines and then cleans up blank lines and trailing whitespace.
	 *
	 * @param {String} data The data from a .dic file.
	 * @return {String} The cleaned-up data.
	 */
	
	_removeDicComments : function (data) {
		// I can't find any official documentation on it, but at least the de_DE
		// dictionary uses tab-indented lines as comments.
		
		// Remove comments
		data = data.replace(/^\t.*$/mg, "");
		
		return data;
	},
	
	parseRuleCodes : function (textCodes) {
		if (!textCodes) {
			return [];
		}
		else if (!("FLAG" in this.flags)) {
			return textCodes.split("");
		}
		else if (this.flags.FLAG === "long") {
			var flags = [];
			
			for (var i = 0, _len = textCodes.length; i < _len; i += 2) {
				flags.push(textCodes.substr(i, 2));
			}
			
			return flags;
		}
		else if (this.flags.FLAG === "num") {
			return textCodes.split(",");
		}
	},
	
	/**
	 * Applies an affix rule to a word.
	 *
	 * @param {String} word The base word.
	 * @param {Object} rule The affix rule.
	 * @returns {String[]} The new words generated by the rule.
	 */
	
	_applyRule : function (word, rule) {
		var entries = rule.entries;
		var newWords = [];
		
		for (var i = 0, _len = entries.length; i < _len; i++) {
			var entry = entries[i];
			
			if (!entry.match || word.match(entry.match)) {
				var newWord = word;
				
				if (entry.remove) {
					newWord = newWord.replace(entry.remove, "");
				}
				
				if (rule.type === "SFX") {
					newWord = newWord + entry.add;
				}
				else {
					newWord = entry.add + newWord;
				}
				
				newWords.push(newWord);
				
				if ("continuationClasses" in entry) {
					for (var j = 0, _jlen = entry.continuationClasses.length; j < _jlen; j++) {
						var continuationRule = this.rules[entry.continuationClasses[j]];
						
						if (continuationRule) {
							newWords = newWords.concat(this._applyRule(newWord, continuationRule));
						}
						/*
						else {
							// This shouldn't happen, but it does, at least in the de_DE dictionary.
							// I think the author mistakenly supplied lower-case rule codes instead 
							// of upper-case.
						}
						*/
					}
				}
			}
		}
		
		return newWords;
	},
	
	/**
	 * Checks whether a word or a capitalization variant exists in the current dictionary.
	 * The word is trimmed and several variations of capitalizations are checked.
	 * If you want to check a word without any changes made to it, call checkExact()
	 *
	 * @see http://blog.stevenlevithan.com/archives/faster-trim-javascript re:trimming function
	 *
	 * @param {String} aWord The word to check.
	 * @returns {Boolean}
	 */
	
	check : function (aWord) {
		if (!this.loaded) {
			throw "Dictionary not loaded.";
		}
		
		// Remove leading and trailing whitespace
		var trimmedWord = aWord.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
		
		if (this.checkExact(trimmedWord)) {
			return true;
		}
		
		// The exact word is not in the dictionary.
		if (trimmedWord.toUpperCase() === trimmedWord) {
			// The word was supplied in all uppercase.
			// Check for a capitalized form of the word.
			var capitalizedWord = trimmedWord[0] + trimmedWord.substring(1).toLowerCase();
			
			if (this.hasFlag(capitalizedWord, "KEEPCASE")) {
				// Capitalization variants are not allowed for this word.
				return false;
			}
			
			if (this.checkExact(capitalizedWord)) {
				return true;
			}
		}
		
		var lowercaseWord = trimmedWord.toLowerCase();
		
		if (lowercaseWord !== trimmedWord) {
			if (this.hasFlag(lowercaseWord, "KEEPCASE")) {
				// Capitalization variants are not allowed for this word.
				return false;
			}
			
			// Check for a lowercase form
			if (this.checkExact(lowercaseWord)) {
				return true;
			}
		}
		
		return false;
	},
	
	/**
	 * Checks whether a word exists in the current dictionary.
	 *
	 * @param {String} word The word to check.
	 * @returns {Boolean}
	 */
	
	checkExact : function (word) {
		if (!this.loaded) {
			throw "Dictionary not loaded.";
		}

		var ruleCodes = this.dictionaryTable[word];
		
		var i, _len;
		
		if (typeof ruleCodes === 'undefined') {
			// Check if this might be a compound word.
			if ("COMPOUNDMIN" in this.flags && word.length >= this.flags.COMPOUNDMIN) {
				for (i = 0, _len = this.compoundRules.length; i < _len; i++) {
					if (word.match(this.compoundRules[i])) {
						return true;
					}
				}
			}
		}
		else if (ruleCodes === null) {
			// a null (but not undefined) value for an entry in the dictionary table
			// means that the word is in the dictionary but has no flags.
			return true;
		}
		else if (typeof ruleCodes === 'object') { // this.dictionary['hasOwnProperty'] will be a function.
			for (i = 0, _len = ruleCodes.length; i < _len; i++) {
				if (!this.hasFlag(word, "ONLYINCOMPOUND", ruleCodes[i])) {
					return true;
				}
			}
		}

		return false;
	},
	
	/**
	 * Looks up whether a given word is flagged with a given flag.
	 *
	 * @param {String} word The word in question.
	 * @param {String} flag The flag in question.
	 * @return {Boolean}
	 */
	 
	hasFlag : function (word, flag, wordFlags) {
		if (!this.loaded) {
			throw "Dictionary not loaded.";
		}

		if (flag in this.flags) {
			if (typeof wordFlags === 'undefined') {
				wordFlags = Array.prototype.concat.apply([], this.dictionaryTable[word]);
			}
			
			if (wordFlags && wordFlags.indexOf(this.flags[flag]) !== -1) {
				return true;
			}
		}
		
		return false;
	},
	
	/**
	 * Returns a list of suggestions for a misspelled word.
	 *
	 * @see http://www.norvig.com/spell-correct.html for the basis of this suggestor.
	 * This suggestor is primitive, but it works.
	 *
	 * @param {String} word The misspelling.
	 * @param {Number} [limit=5] The maximum number of suggestions to return.
	 * @returns {String[]} The array of suggestions.
	 */
	
	alphabet : "",
	
	suggest : function (word, limit) {
		if (!this.loaded) {
			throw "Dictionary not loaded.";
		}

		limit = limit || 5;

		if (this.memoized.hasOwnProperty(word)) {
			var memoizedLimit = this.memoized[word]['limit'];

			// Only return the cached list if it's big enough or if there weren't enough suggestions
			// to fill a smaller limit.
			if (limit <= memoizedLimit || this.memoized[word]['suggestions'].length < memoizedLimit) {
				return this.memoized[word]['suggestions'].slice(0, limit);
			}
		}
		
		if (this.check(word)) return [];
		
		// Check the replacement table.
		for (var i = 0, _len = this.replacementTable.length; i < _len; i++) {
			var replacementEntry = this.replacementTable[i];
			
			if (word.indexOf(replacementEntry[0]) !== -1) {
				var correctedWord = word.replace(replacementEntry[0], replacementEntry[1]);
				
				if (this.check(correctedWord)) {
					return [ correctedWord ];
				}
			}
		}
		
		var self = this;
		self.alphabet = "abcdefghijklmnopqrstuvwxyz";
		
		/*
		if (!self.alphabet) {
			// Use the alphabet as implicitly defined by the words in the dictionary.
			var alphaHash = {};
			
			for (var i in self.dictionaryTable) {
				for (var j = 0, _len = i.length; j < _len; j++) {
					alphaHash[i[j]] = true;
				}
			}
			
			for (var i in alphaHash) {
				self.alphabet += i;
			}
			
			var alphaArray = self.alphabet.split("");
			alphaArray.sort();
			self.alphabet = alphaArray.join("");
		}
		*/
		
		function edits1(words) {
			var rv = [];
			
			var ii, i, j, _iilen, _len, _jlen;
			
			for (ii = 0, _iilen = words.length; ii < _iilen; ii++) {
				var word = words[ii];
				
				for (i = 0, _len = word.length + 1; i < _len; i++) {
					var s = [ word.substring(0, i), word.substring(i) ];
				
					if (s[1]) {
						rv.push(s[0] + s[1].substring(1));
					}
					
					// Eliminate transpositions of identical letters
					if (s[1].length > 1 && s[1][1] !== s[1][0]) {
						rv.push(s[0] + s[1][1] + s[1][0] + s[1].substring(2));
					}

					if (s[1]) {
						for (j = 0, _jlen = self.alphabet.length; j < _jlen; j++) {
							// Eliminate replacement of a letter by itself
							if (self.alphabet[j] != s[1].substring(0,1)){
								rv.push(s[0] + self.alphabet[j] + s[1].substring(1));
							}
						}
					}

					if (s[1]) {
						for (j = 0, _jlen = self.alphabet.length; j < _jlen; j++) {
							rv.push(s[0] + self.alphabet[j] + s[1]);
						}
					}
				}
			}
			
			return rv;
		}
		
		function known(words) {
			var rv = [];
			
			for (var i = 0, _len = words.length; i < _len; i++) {
				if (self.check(words[i])) {
					rv.push(words[i]);
				}
			}
			
			return rv;
		}
		
		function correct(word) {
			// Get the edit-distance-1 and edit-distance-2 forms of this word.
			var ed1 = edits1([word]);
			var ed2 = edits1(ed1);
			
			var corrections = known(ed1.concat(ed2));
			
			var i, _len;
			
			// Sort the edits based on how many different ways they were created.
			var weighted_corrections = {};
			
			for (i = 0, _len = corrections.length; i < _len; i++) {
				if (!(corrections[i] in weighted_corrections)) {
					weighted_corrections[corrections[i]] = 1;
				}
				else {
					weighted_corrections[corrections[i]] += 1;
				}
			}
			
			var sorted_corrections = [];
			
			for (i in weighted_corrections) {
				if (weighted_corrections.hasOwnProperty(i)) {
					sorted_corrections.push([ i, weighted_corrections[i] ]);
				}
			}
			
			function sorter(a, b) {
				if (a[1] < b[1]) {
					return -1;
				}
				
				return 1;
			}
			
			sorted_corrections.sort(sorter).reverse();
			
			var rv = [];

			var capitalization_scheme = "lowercase";
			
			if (word.toUpperCase() === word) {
				capitalization_scheme = "uppercase";
			}
			else if (word.substr(0, 1).toUpperCase() + word.substr(1).toLowerCase() === word) {
				capitalization_scheme = "capitalized";
			}
			
			for (i = 0, _len = Math.min(limit, sorted_corrections.length); i < _len; i++) {
				if ("uppercase" === capitalization_scheme) {
					sorted_corrections[i][0] = sorted_corrections[i][0].toUpperCase();
				}
				else if ("capitalized" === capitalization_scheme) {
					sorted_corrections[i][0] = sorted_corrections[i][0].substr(0, 1).toUpperCase() + sorted_corrections[i][0].substr(1);
				}
				
				if (!self.hasFlag(sorted_corrections[i][0], "NOSUGGEST")) {
					rv.push(sorted_corrections[i][0]);
				}
			}
			
			return rv;
		}
		
		this.memoized[word] = {
			'suggestions': correct(word),
			'limit': limit
		};

		return this.memoized[word]['suggestions'];
	}
};
})();

// Support for use as a node.js module.
if (true) {
	module.exports = Typo;
}
/* WEBPACK VAR INJECTION */}.call(exports, "/", __webpack_require__(331).Buffer))

/***/ }),
/* 1606 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_md5_js__ = __webpack_require__(1608);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var query=function query(v){var q=__WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(v);return q?'?'+q:'';};/* unused harmony default export */ var _unused_webpack_default_export = (function(_ref){var _ref$email=_ref.email,email=_ref$email===undefined?'':_ref$email,_ref$missing=_ref.missing,missing=_ref$missing===undefined?'mm':_ref$missing,_ref$size=_ref.size,size=_ref$size===undefined?40:_ref$size,className=_ref.className,_ref$extraClassName=_ref.extraClassName,extraClassName=_ref$extraClassName===undefined?'':_ref$extraClassName,props=_objectWithoutProperties(_ref,['email','missing','size','className','extraClassName']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:(className||'u-sm-ib')+' '+extraClassName,src:'https://www.gravatar.com/avatar/'+Object(__WEBPACK_IMPORTED_MODULE_2__util_md5_js__["a" /* default */])(email.trim().toLowerCase())+query({d:missing,s:size})});});

/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// eslint-disable-next-line
/* harmony default export */ __webpack_exports__["a"] = (function(s){function L(k,d){return k<<d|k>>>32-d;}function K(G,k){var I,d,F,H,x;F=G&2147483648;H=k&2147483648;I=G&1073741824;d=k&1073741824;x=(G&1073741823)+(k&1073741823);if(I&d){return x^2147483648^F^H;}if(I|d){if(x&1073741824){return x^3221225472^F^H;}else{return x^1073741824^F^H;}}else{return x^F^H;}}function r(d,F,k){return d&F|~d&k;}function q(d,F,k){return d&k|F&~k;}function p(d,F,k){return d^F^k;}function n(d,F,k){return F^(d|~k);}function u(G,F,aa,Z,k,H,I){G=K(G,K(K(r(F,aa,Z),k),I));return K(L(G,H),F);}function f(G,F,aa,Z,k,H,I){G=K(G,K(K(q(F,aa,Z),k),I));return K(L(G,H),F);}function D(G,F,aa,Z,k,H,I){G=K(G,K(K(p(F,aa,Z),k),I));return K(L(G,H),F);}function t(G,F,aa,Z,k,H,I){G=K(G,K(K(n(F,aa,Z),k),I));return K(L(G,H),F);}function e(G){var Z;var F=G.length;var x=F+8;var k=(x-x%64)/64;var I=(k+1)*16;var aa=Array(I-1);var d=0;var H=0;while(H<F){Z=(H-H%4)/4;d=H%4*8;aa[Z]=aa[Z]|G.charCodeAt(H)<<d;H++;}Z=(H-H%4)/4;d=H%4*8;aa[Z]=aa[Z]|128<<d;aa[I-2]=F<<3;aa[I-1]=F>>>29;return aa;}function B(x){var k="",F="",G,d;for(d=0;d<=3;d++){G=x>>>d*8&255;F="0"+G.toString(16);k=k+F.substr(F.length-2,2);}return k;}function J(k){k=k.replace(/rn/g,"n");var d="";for(var F=0;F<k.length;F++){var x=k.charCodeAt(F);if(x<128){d+=String.fromCharCode(x);}else{if(x>127&&x<2048){d+=String.fromCharCode(x>>6|192);d+=String.fromCharCode(x&63|128);}else{d+=String.fromCharCode(x>>12|224);d+=String.fromCharCode(x>>6&63|128);d+=String.fromCharCode(x&63|128);}}}return d;}var C=Array();var P,h,E,v,g,Y,X,W,V;var S=7,Q=12,N=17,M=22;var A=5,z=9,y=14,w=20;var o=4,m=11,l=16,j=23;var U=6,T=10,R=15,O=21;s=J(s);C=e(s);Y=1732584193;X=4023233417;W=2562383102;V=271733878;for(P=0;P<C.length;P+=16){h=Y;E=X;v=W;g=V;Y=u(Y,X,W,V,C[P+0],S,3614090360);V=u(V,Y,X,W,C[P+1],Q,3905402710);W=u(W,V,Y,X,C[P+2],N,606105819);X=u(X,W,V,Y,C[P+3],M,3250441966);Y=u(Y,X,W,V,C[P+4],S,4118548399);V=u(V,Y,X,W,C[P+5],Q,1200080426);W=u(W,V,Y,X,C[P+6],N,2821735955);X=u(X,W,V,Y,C[P+7],M,4249261313);Y=u(Y,X,W,V,C[P+8],S,1770035416);V=u(V,Y,X,W,C[P+9],Q,2336552879);W=u(W,V,Y,X,C[P+10],N,4294925233);X=u(X,W,V,Y,C[P+11],M,2304563134);Y=u(Y,X,W,V,C[P+12],S,1804603682);V=u(V,Y,X,W,C[P+13],Q,4254626195);W=u(W,V,Y,X,C[P+14],N,2792965006);X=u(X,W,V,Y,C[P+15],M,1236535329);Y=f(Y,X,W,V,C[P+1],A,4129170786);V=f(V,Y,X,W,C[P+6],z,3225465664);W=f(W,V,Y,X,C[P+11],y,643717713);X=f(X,W,V,Y,C[P+0],w,3921069994);Y=f(Y,X,W,V,C[P+5],A,3593408605);V=f(V,Y,X,W,C[P+10],z,38016083);W=f(W,V,Y,X,C[P+15],y,3634488961);X=f(X,W,V,Y,C[P+4],w,3889429448);Y=f(Y,X,W,V,C[P+9],A,568446438);V=f(V,Y,X,W,C[P+14],z,3275163606);W=f(W,V,Y,X,C[P+3],y,4107603335);X=f(X,W,V,Y,C[P+8],w,1163531501);Y=f(Y,X,W,V,C[P+13],A,2850285829);V=f(V,Y,X,W,C[P+2],z,4243563512);W=f(W,V,Y,X,C[P+7],y,1735328473);X=f(X,W,V,Y,C[P+12],w,2368359562);Y=D(Y,X,W,V,C[P+5],o,4294588738);V=D(V,Y,X,W,C[P+8],m,2272392833);W=D(W,V,Y,X,C[P+11],l,1839030562);X=D(X,W,V,Y,C[P+14],j,4259657740);Y=D(Y,X,W,V,C[P+1],o,2763975236);V=D(V,Y,X,W,C[P+4],m,1272893353);W=D(W,V,Y,X,C[P+7],l,4139469664);X=D(X,W,V,Y,C[P+10],j,3200236656);Y=D(Y,X,W,V,C[P+13],o,681279174);V=D(V,Y,X,W,C[P+0],m,3936430074);W=D(W,V,Y,X,C[P+3],l,3572445317);X=D(X,W,V,Y,C[P+6],j,76029189);Y=D(Y,X,W,V,C[P+9],o,3654602809);V=D(V,Y,X,W,C[P+12],m,3873151461);W=D(W,V,Y,X,C[P+15],l,530742520);X=D(X,W,V,Y,C[P+2],j,3299628645);Y=t(Y,X,W,V,C[P+0],U,4096336452);V=t(V,Y,X,W,C[P+7],T,1126891415);W=t(W,V,Y,X,C[P+14],R,2878612391);X=t(X,W,V,Y,C[P+5],O,4237533241);Y=t(Y,X,W,V,C[P+12],U,1700485571);V=t(V,Y,X,W,C[P+3],T,2399980690);W=t(W,V,Y,X,C[P+10],R,4293915773);X=t(X,W,V,Y,C[P+1],O,2240044497);Y=t(Y,X,W,V,C[P+8],U,1873313359);V=t(V,Y,X,W,C[P+15],T,4264355552);W=t(W,V,Y,X,C[P+6],R,2734768916);X=t(X,W,V,Y,C[P+13],O,1309151649);Y=t(Y,X,W,V,C[P+4],U,4149444226);V=t(V,Y,X,W,C[P+11],T,3174756917);W=t(W,V,Y,X,C[P+2],R,718787259);X=t(X,W,V,Y,C[P+9],O,3951481745);Y=K(Y,h);X=K(X,E);W=K(W,v);V=K(V,g);}var i=B(Y)+B(X)+B(W)+B(V);return i.toLowerCase();});;

/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Async */
/* unused harmony export AsyncCreatable */
/* unused harmony export Creatable */
/* unused harmony export Value */
/* unused harmony export Option */
/* unused harmony export defaultMenuRenderer */
/* unused harmony export defaultArrowRenderer */
/* unused harmony export defaultClearRenderer */
/* unused harmony export defaultFilterOptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);






var arrowRenderer = function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

arrowRenderer.propTypes = {
	onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var clearRenderer = function clearRenderer() {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

var trim = function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var isValid = function isValid(value) {
	return typeof value !== 'undefined' && value !== null && value !== '';
};

var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
	if (props.ignoreAccents) {
		filterValue = stripDiacritics(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (props.trimFilter) {
		filterValue = trim(filterValue);
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
		if (!filterValue) return true;

		var value = option[props.valueKey];
		var label = option[props.labelKey];
		var hasValue = isValid(value);
		var hasLabel = isValid(label);

		if (!hasValue && !hasLabel) {
			return false;
		}

		var valueTest = hasValue ? String(value) : null;
		var labelTest = hasLabel ? String(label) : null;

		if (props.ignoreAccents) {
			if (valueTest && props.matchProp !== 'label') valueTest = stripDiacritics(valueTest);
			if (labelTest && props.matchProp !== 'value') labelTest = stripDiacritics(labelTest);
		}

		if (props.ignoreCase) {
			if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}

		return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
};

var menuRenderer = function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    focusOption = _ref.focusOption,
	    inputValue = _ref.inputValue,
	    instancePrefix = _ref.instancePrefix,
	    onFocus = _ref.onFocus,
	    onOptionRef = _ref.onOptionRef,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    removeValue = _ref.removeValue,
	    selectValue = _ref.selectValue,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.some(function (x) {
			return x[valueKey] === option[valueKey];
		});
		var isFocused = option === focusedOption;
		var optionClass = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
			Option,
			{
				className: optionClass,
				focusOption: focusOption,
				inputValue: inputValue,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				},
				removeValue: removeValue,
				selectValue: selectValue
			},
			optionRenderer(option, i, inputValue)
		);
	});
};

menuRenderer.propTypes = {
	focusOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	focusedOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
	inputValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onOptionRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	removeValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	selectValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	valueArray: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

var blockEvent = (function (event) {
	event.preventDefault();
	event.stopPropagation();
	if (event.target.tagName !== 'A' || !('href' in event.target)) {
		return;
	}
	if (event.target.target) {
		window.open(event.target.href, event.target.target);
	} else {
		window.location.href = event.target.href;
	}
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Option = function (_React$Component) {
	inherits(Option, _React$Component);

	function Option(props) {
		classCallCheck(this, Option);

		var _this = possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	createClass(Option, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(this.props.className, option.className);

			return option.disabled ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					onMouseDown: blockEvent,
					onClick: blockEvent },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					'aria-label': option.label,
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);
	return Option;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Option.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className (based on mouse position)
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is disabled
	isFocused: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is focused
	isSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is selected
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseEnter on option element
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on option element
	onUnfocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseLeave on option element
	option: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, // object that is base for that option
	optionIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number // index of the option, used to generate unique ids for aria
};

var Value = function (_React$Component) {
	inherits(Value, _React$Component);

	function Value(props) {
		classCallCheck(this, Value);

		var _this = possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);
	return Value;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Value.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // disabled prop passed to ReactSelect
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // Unique id for the value - used for aria
	onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on value label
	onRemove: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle removal of the value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired // the option object for this value
};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/
var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]);
var stringOrNumber = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]);

var instanceId = 1;

var shouldShowValue = function shouldShowValue(state, props) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	if (!inputValue) return true;

	if (!onSelectResetsInput) {
		return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
	}

	return false;
};

var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
};

/**
 * Retrieve a value from the given options and valueKey
 * @param {String|Number|Array} value	- the selected value(s)
 * @param {Object}		 props	- the Select component's props (or nextProps)
 */
var expandValue = function expandValue(value, props) {
	var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
	var options = props.options,
	    valueKey = props.valueKey;

	if (!options) return;
	for (var i = 0; i < options.length; i++) {
		if (String(options[i][valueKey]) === String(value)) return options[i];
	}
};

var handleRequired = function handleRequired(value, multi) {
	if (!value) return true;
	return multi ? value.length === 0 : Object.keys(value).length === 0;
};

var Select$1 = function (_React$Component) {
	inherits(Select, _React$Component);

	function Select(props) {
		classCallCheck(this, Select);

		var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
				console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
			}
			if (this.props.autoFocus || this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}

			if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
				this.setState({ inputValue: this.handleInputValueChange('') });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuNode = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);

				var scrollTop = menuNode.scrollTop;
				var scrollBottom = scrollTop + menuNode.offsetHeight;
				var optionTop = focusedOptionNode.offsetTop;
				var optionBottom = optionTop + focusedOptionNode.offsetHeight;

				if (scrollTop > optionTop || scrollBottom < optionBottom) {
					menuNode.scrollTop = focusedOptionNode.offsetTop;
				}

				// We still set hasScrolledToOption to true even if we didn't
				// actually need to scroll, as we've still confirmed that the
				// option is in view.
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuDOM = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
			if (prevState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(this.state.isOpen);
				var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.toggleTouchOutsideEvent(false);
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
			var pref = document.addEventListener ? '' : 'on';

			document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
			document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				if (!this.state.isFocused) {
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
				} else if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						isPseudoFocused: false,
						focusedOption: null
					});
				}

				return;
			}

			// prevent default event handlers
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen,
					focusedOption: null
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				var toOpen = true;

				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				if (this._focusAfterClear) {
					toOpen = false;
					this._focusAfterClear = false;
				}

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: toOpen,
					isPseudoFocused: false,
					focusedOption: null
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
				this.setState({ focusedOption: null });
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (this.state.isOpen) {
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				this.closeMenu();
			} else {
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				this.setState({
					isOpen: true
				});
			}
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;

			var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.

			if (this.props.onFocus) {
				this.props.onFocus(event);
			}

			this.setState({
				isFocused: true,
				isOpen: !!toOpen
			});

			this._focusAfterClear = false;
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				inputValue: newInputValue,
				isOpen: true,
				isPseudoFocused: false
			});
		}
	}, {
		key: 'setInputValue',
		value: function setInputValue(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			this.setState({
				inputValue: newValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						break;
					}
					event.preventDefault();
					this.selectFocusedOption();
					break;
				case 13:
					// enter
					event.preventDefault();
					event.stopPropagation();
					if (this.state.isOpen) {
						this.selectFocusedOption();
					} else {
						this.focusNextOption();
					}
					break;
				case 27:
					// escape
					event.preventDefault();
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 32:
					// space
					if (this.props.searchable) {
						break;
					}
					event.preventDefault();
					if (!this.state.isOpen) {
						this.focusNextOption();
						break;
					}
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 38:
					// up
					event.preventDefault();
					this.focusPreviousOption();
					break;
				case 40:
					// down
					event.preventDefault();
					this.focusNextOption();
					break;
				case 33:
					// page up
					event.preventDefault();
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					event.preventDefault();
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusStartOption();
					break;
				case 46:
					// delete
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
			}
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param {String|Number|Array} value		- the value of the select input
   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value) {
			var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') {
					value = value.split(props.delimiter);
				}
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this2 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			if (this.props.onChange) {
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this3 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
			if (this.props.multi) {
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					var valueArray = _this3.getValueArray(_this3.props.value);
					if (valueArray.some(function (i) {
						return i[_this3.props.valueKey] === value[_this3.props.valueKey];
					})) {
						_this3.removeValue(value);
					} else {
						_this3.addValue(value);
					}
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (!this.props.closeOnSelect) {
				return;
			}
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var _this4 = this;

			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.preventDefault();

			this.setValue(this.getResetValue());
			this.setState({
				inputValue: this.handleInputValueChange(''),
				isOpen: false
			}, this.focus);

			this._focusAfterClear = true;
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				var newState = {
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
					isOpen: true
				};
				if (this.props.onSelectResetsInput) {
					newState.inputValue = '';
				}
				this.setState(newState);
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var _potentialIndex = focusedIndex + this.props.pageSize;
				if (_potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = _potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this5 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
				return showPlaceholder ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						ValueComponent,
						{
							disabled: _this5.props.disabled || value.clearableValue === false,
							id: _this5._instancePrefix + '-value-' + i,
							instancePrefix: _this5._instancePrefix,
							key: 'value-' + i + '-' + value[_this5.props.valueKey],
							onClick: onClick,
							onRemove: _this5.removeValue,
							placeholder: _this5.props.placeholder,
							value: value,
							values: valueArray
						},
						renderLabel(value, i),
						__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (shouldShowValue(this.state, this.props)) {
				if (isOpen) onClick = null;
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					ValueComponent,
					{
						disabled: this.props.disabled,
						id: this._instancePrefix + '-value-item',
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						placeholder: this.props.placeholder,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this6 = this;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-input', this.props.inputProps.className);
			var isOpen = this.state.isOpen;

			var ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames = {}, defineProperty(_classNames, this._instancePrefix + '-list', isOpen), defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

			var value = this.state.inputValue;
			if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
				// it hides input value when it is not focused and was not reset on select
				value = '';
			}

			var inputProps = _extends({}, this.props.inputProps, {
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-expanded': '' + isOpen,
				'aria-haspopup': '' + isOpen,
				'aria-label': this.props['aria-label'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-owns': ariaOwns,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this6.input = _ref;
				},
				role: 'combobox',
				required: this.state.required,
				tabIndex: this.props.tabIndex,
				value: value
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var divProps = objectWithoutProperties(this.props.inputProps, []);


				var _ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(defineProperty({}, this._instancePrefix + '-list', isOpen));
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', _extends({}, divProps, {
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-disabled': '' + this.props.disabled,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					className: className,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this6.input = _ref2;
					},
					role: 'combobox',
					style: { border: 0, width: 1, display: 'inline-block' },
					tabIndex: this.props.tabIndex || 0
				}));
			}

			if (this.props.autosize) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default.a, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
			}
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', _extends({ id: this.props.id }, inputProps))
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			var valueArray = this.getValueArray(this.props.value);
			if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
			var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
			var clear = this.props.clearRenderer();

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					'aria-label': ariaLabel,
					className: 'Select-clear-zone',
					onMouseDown: this.clearValue,
					onTouchEnd: this.handleTouchEndClearValue,
					onTouchMove: this.handleTouchMove,
					onTouchStart: this.handleTouchStart,
					title: ariaLabel
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			if (!this.props.arrowRenderer) return;

			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			if (!arrow) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions$$1 = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : filterOptions;

				return filterOptions$$1(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					trimFilter: this.props.trimFilter,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					inputValue: this.state.inputValue,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onOptionRef: this.onOptionRef,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					removeValue: this.removeValue,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey
				});
			} else if (this.props.noResultsText) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this7 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this7.props.valueKey]);
				}).join(this.props.delimiter);
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: this.props.disabled,
					name: this.props.name,
					ref: function ref(_ref3) {
						return _this7.value = _ref3;
					},
					type: 'hidden',
					value: value
				});
			}
			return valueArray.map(function (item, index) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: _this7.props.disabled,
					key: 'hidden.' + index,
					name: _this7.props.name,
					ref: 'value' + index,
					type: 'hidden',
					value: stringifyValue(item[_this7.props.valueKey])
				});
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this8 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this8.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{
						className: 'Select-menu',
						id: this._instancePrefix + '-list',
						onMouseDown: this.handleMouseDownOnMenu,
						onScroll: this.handleMenuScroll,
						ref: function ref(_ref4) {
							return _this8.menu = _ref4;
						},
						role: 'listbox',
						style: this.props.menuStyle,
						tabIndex: -1
					},
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select', this.props.className, {
				'has-value': valueArray.length,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'Select--multi': this.props.multi,
				'Select--rtl': this.props.rtl,
				'Select--single': !this.props.multi
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this9.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this9.control = _ref6;
						},
						className: 'Select-control',
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						style: this.props.style
					},
					__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						'div',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
			);
		}
	}]);
	return Select;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Select$1.propTypes = {
	'aria-describedby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // aria label (for assistive tech)
	'aria-labelledby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id of an element that should be used as the label (for assistive tech)
	arrowRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create the drop-down caret element
	autoBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // automatically blur the component when an option is selected
	autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // autofocus the component on mount
	autofocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // deprecated; use autoFocus instead
	autosize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable autosizing or not
	backspaceRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // should it be possible to reset value
	closeOnSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to close the menu when a value is selected
	deleteRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether delete removes an item if there is no text input
	delimiter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // delimiter to use to join multiple values for the hidden field value
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is disabled or not
	escapeClearsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether escape clears the value when the menu is closed
	filterOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to filter a single option (option, filterString)
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id to set on the input element for accessibility or tests
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to strip diacritics when filtering
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to perform case-insensitive filtering
	inputProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // custom attributes for the Input
	inputRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // returns a custom input component
	instanceId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // set the components instanceId
	isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	matchPos: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|start) match the start or entire string when filtering
	matchProp: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|label|value) which option property to filter on
	menuBuffer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu container
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // renders a custom menu with options
	menuStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onBlur handler: function (event) {}
	onBlurResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on blur
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is closed
	onCloseResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onFocus handler: function (event) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is opened
	onSelectResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // always open options menu on focus
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // option component to render in dropdown
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optionRenderer: function (option) {}
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, // array of options
	pageSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	removeSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the selected option is removed from the dropdown on multi selects
	required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // applies HTML5 required attribute when needed
	resetValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // value to use when you clear the control
	rtl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // set to true in order to use react-select in right-to-left direction
	scrollMenuIntoView: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable searching feature or not
	simpleValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the control
	tabIndex: stringOrNumber, // optional tab index of the control
	tabSelectsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to treat tabbing out while focused to be value selection
	trimFilter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to trim whitespace around filter value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // initial field value
	valueComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // value component to render
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	valueRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // valueRenderer: function (option) {}
	wrapperStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object // optional style to apply to the component wrapper
};

Select$1.defaultProps = {
	arrowRenderer: arrowRenderer,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: clearRenderer,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: filterOptions,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: menuRenderer,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onCloseResetsInput: true,
	onSelectResetsInput: true,
	openOnClick: true,
	optionComponent: Option,
	pageSize: 5,
	placeholder: 'Select...',
	removeSelected: true,
	required: false,
	rtl: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	trimFilter: true,
	valueComponent: Value,
	valueKey: 'value'
};

var propTypes = {
	autoload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // object to use to cache results; set to null/false to disable caching
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// replaces the placeholder while options are loading
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	noResultsText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field noResultsText, displayed when no options come back from the server
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optional for keeping track of what is being typed
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired, // array of options
	placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	searchPromptText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// label to prompt for search input
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any // initial field value
};

var defaultCache = {};

var defaultChildren = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	inherits(Async, _Component);

	function Async(props, context) {
		classCallCheck(this, Async);

		var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this._callback = null;

				this.setState({
					isLoading: false,
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				var options = data && data.options || [];

				if (cache) {
					cache[inputValue] = options;
				}

				if (callback === _this2._callback) {
					_this2._callback = null;

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var newInputValue = inputValue;

			if (onInputChange) {
				var value = onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
					newInputValue = '' + value;
				}
			}

			var transformedInputValue = newInputValue;

			if (ignoreAccents) {
				transformedInputValue = stripDiacritics(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			this.setState({ inputValue: newInputValue });
			this.loadOptions(transformedInputValue);

			// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
			return newInputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    placeholder = _props3.placeholder;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);
	return Async;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

var CreatableSelect = function (_React$Component) {
	inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		classCallCheck(this, CreatableSelect);

		var _this = possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option, options: options });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1() {
			var _props2 = this.props,
			    filterOptions$$1 = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    promptTextCreator = _props2.promptTextCreator,
			    showNewOptionAtTop = _props2.showNewOptionAtTop;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions$$1.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					if (showNewOptionAtTop) {
						filteredOptions.unshift(this._createPlaceholderOption);
					} else {
						filteredOptions.push(this._createPlaceholderOption);
					}
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.props.options;

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer$$1(params) {
			var menuRenderer$$1 = this.props.menuRenderer;


			return menuRenderer$$1(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;

			// This value may be needed in between Select mounts (when this.select is null)

			this.inputValue = input;

			if (onInputChange) {
				this.inputValue = onInputChange(input);
			}

			return this.inputValue;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    refProp = _props4.ref,
			    restProps = objectWithoutProperties(_props4, ['ref']);
			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren$2;
			}

			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
					if (refProp) {
						refProp(_ref2);
					}
				}
			});

			return children(props);
		}
	}]);
	return CreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$2 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var isOptionUnique = function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	if (!options || !options.length) {
		return true;
	}

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

var isValidNewOption = function isValidNewOption(_ref4) {
	var label = _ref4.label;
	return !!label;
};

var newOptionCreator = function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';

	return option;
};

var promptTextCreator = function promptTextCreator(label) {
	return 'Create option "' + label + '"';
};

var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
		default:
			return false;
	}
};

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: filterOptions,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: menuRenderer,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
	showNewOptionAtTop: true
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.filterOptions
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input change handler: function (inputValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// new option click handler: function (option) {}
	onNewOptionClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.options
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	ref: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Where to show prompt/placeholder option text.
	// true: new option prompt at top of list (default)
	// false: new option prompt at bottom of list
	showNewOptionAtTop: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

var AsyncCreatableSelect = function (_React$Component) {
	inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		classCallCheck(this, AsyncCreatableSelect);
		return possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				Async,
				this.props,
				function (_ref) {
					var ref = _ref.ref,
					    asyncProps = objectWithoutProperties(_ref, ['ref']);

					var asyncRef = ref;
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						CreatableSelect,
						asyncProps,
						function (_ref2) {
							var ref = _ref2.ref,
							    creatableProps = objectWithoutProperties(_ref2, ['ref']);

							var creatableRef = ref;
							return _this2.props.children(_extends({}, creatableProps, {
								ref: function ref(select) {
									creatableRef(select);
									asyncRef(select);
									_this2.select = select;
								}
							}));
						}
					);
				}
			);
		}
	}]);
	return AsyncCreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$1 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

AsyncCreatableSelect.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
};

AsyncCreatableSelect.defaultProps = {
	children: defaultChildren$1
};

Select$1.Async = Async;
Select$1.AsyncCreatable = AsyncCreatableSelect;
Select$1.Creatable = CreatableSelect;
Select$1.Value = Value;
Select$1.Option = Option;


/* harmony default export */ __webpack_exports__["a"] = (Select$1);


/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_collapsible__ = __webpack_require__(1611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_collapsible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_collapsible__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var props=_objectWithoutProperties(_ref,[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_collapsible___default.a,Object.assign({},props,{overflowWhenOpen:'visible'}));});

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Collapsible = function (_Component) {
  _inherits(Collapsible, _Component);

  function Collapsible(props) {
    _classCallCheck(this, Collapsible);

    // Bind class methods
    var _this = _possibleConstructorReturn(this, (Collapsible.__proto__ || Object.getPrototypeOf(Collapsible)).call(this, props));

    _this.handleTriggerClick = _this.handleTriggerClick.bind(_this);
    _this.handleTransitionEnd = _this.handleTransitionEnd.bind(_this);
    _this.continueOpenCollapsible = _this.continueOpenCollapsible.bind(_this);
    _this.setInnerRef = _this.setInnerRef.bind(_this);

    // Defaults the dropdown to be closed
    if (props.open) {
      _this.state = {
        isClosed: false,
        shouldSwitchAutoOnNextCycle: false,
        height: 'auto',
        transition: 'none',
        hasBeenOpened: true,
        overflow: props.overflowWhenOpen,
        inTransition: false
      };
    } else {
      _this.state = {
        isClosed: true,
        shouldSwitchAutoOnNextCycle: false,
        height: 0,
        transition: 'height ' + props.transitionTime + 'ms ' + props.easing,
        hasBeenOpened: false,
        overflow: 'hidden',
        inTransition: false
      };
    }
    return _this;
  }

  _createClass(Collapsible, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (this.state.shouldOpenOnNextCycle) {
        this.continueOpenCollapsible();
      }

      if (prevState.height === 'auto' && this.state.shouldSwitchAutoOnNextCycle === true) {
        window.setTimeout(function () {
          // Set small timeout to ensure a true re-render
          _this2.setState({
            height: 0,
            overflow: 'hidden',
            isClosed: true,
            shouldSwitchAutoOnNextCycle: false
          });
        }, 50);
      }

      // If there has been a change in the open prop (controlled by accordion)
      if (prevProps.open !== this.props.open) {
        if (this.props.open === true) {
          this.openCollapsible();
          this.props.onOpening();
        } else {
          this.closeCollapsible();
          this.props.onClosing();
        }
      }
    }
  }, {
    key: 'closeCollapsible',
    value: function closeCollapsible() {
      this.setState({
        shouldSwitchAutoOnNextCycle: true,
        height: this.innerRef.offsetHeight,
        transition: 'height ' + (this.props.transitionCloseTime ? this.props.transitionCloseTime : this.props.transitionTime) + 'ms ' + this.props.easing,
        inTransition: true
      });
    }
  }, {
    key: 'openCollapsible',
    value: function openCollapsible() {
      this.setState({
        inTransition: true,
        shouldOpenOnNextCycle: true
      });
    }
  }, {
    key: 'continueOpenCollapsible',
    value: function continueOpenCollapsible() {
      this.setState({
        height: this.innerRef.offsetHeight,
        transition: 'height ' + this.props.transitionTime + 'ms ' + this.props.easing,
        isClosed: false,
        hasBeenOpened: true,
        inTransition: true,
        shouldOpenOnNextCycle: false
      });
    }
  }, {
    key: 'handleTriggerClick',
    value: function handleTriggerClick(event) {
      event.preventDefault();

      if (this.props.triggerDisabled) {
        return;
      }

      if (this.props.handleTriggerClick) {
        this.props.handleTriggerClick(this.props.accordionPosition);
      } else {
        if (this.state.isClosed === true) {
          this.openCollapsible();
          this.props.onOpening();
        } else {
          this.closeCollapsible();
          this.props.onClosing();
        }
      }
    }
  }, {
    key: 'renderNonClickableTriggerElement',
    value: function renderNonClickableTriggerElement() {
      if (this.props.triggerSibling && typeof this.props.triggerSibling === 'string') {
        return _react2.default.createElement(
          'span',
          { className: this.props.classParentString + '__trigger-sibling' },
          this.props.triggerSibling
        );
      } else if (this.props.triggerSibling) {
        return _react2.default.createElement(this.props.triggerSibling, null);
      }

      return null;
    }
  }, {
    key: 'handleTransitionEnd',
    value: function handleTransitionEnd() {
      // Switch to height auto to make the container responsive
      if (!this.state.isClosed) {
        this.setState({ height: 'auto', overflow: this.props.overflowWhenOpen, inTransition: false });
        this.props.onOpen();
      } else {
        this.setState({ inTransition: false });
        this.props.onClose();
      }
    }
  }, {
    key: 'setInnerRef',
    value: function setInnerRef(ref) {
      this.innerRef = ref;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var dropdownStyle = {
        height: this.state.height,
        WebkitTransition: this.state.transition,
        msTransition: this.state.transition,
        transition: this.state.transition,
        overflow: this.state.overflow
      };

      var openClass = this.state.isClosed ? 'is-closed' : 'is-open';
      var disabledClass = this.props.triggerDisabled ? 'is-disabled' : '';

      //If user wants different text when tray is open
      var trigger = this.state.isClosed === false && this.props.triggerWhenOpen !== undefined ? this.props.triggerWhenOpen : this.props.trigger;

      // If user wants a trigger wrapping element different than 'span'
      var TriggerElement = this.props.triggerTagName;

      // Don't render children until the first opening of the Collapsible if lazy rendering is enabled
      var children = this.props.lazyRender && !this.state.hasBeenOpened && this.state.isClosed && !this.state.inTransition ? null : this.props.children;

      // Construct CSS classes strings
      var triggerClassString = this.props.classParentString + '__trigger ' + openClass + ' ' + disabledClass + ' ' + (this.state.isClosed ? this.props.triggerClassName : this.props.triggerOpenedClassName);
      var parentClassString = this.props.classParentString + ' ' + (this.state.isClosed ? this.props.className : this.props.openedClassName);
      var outerClassString = this.props.classParentString + '__contentOuter ' + this.props.contentOuterClassName;
      var innerClassString = this.props.classParentString + '__contentInner ' + this.props.contentInnerClassName;

      return _react2.default.createElement(
        'div',
        { className: parentClassString.trim() },
        _react2.default.createElement(
          TriggerElement,
          {
            className: triggerClassString.trim(),
            onClick: this.handleTriggerClick,
            style: this.props.triggerStyle && this.props.triggerStyle,
            onKeyPress: function onKeyPress(event) {
              var key = event.key;

              if (key === ' ' || key === 'Enter') {
                _this3.handleTriggerClick(event);
              }
            },
            tabIndex: this.props.tabIndex && this.props.tabIndex
          },
          trigger
        ),
        this.renderNonClickableTriggerElement(),
        _react2.default.createElement(
          'div',
          {
            className: outerClassString.trim(),
            style: dropdownStyle,
            onTransitionEnd: this.handleTransitionEnd
          },
          _react2.default.createElement(
            'div',
            {
              className: innerClassString.trim(),
              ref: this.setInnerRef
            },
            children
          )
        )
      );
    }
  }]);

  return Collapsible;
}(_react.Component);

Collapsible.propTypes = {
  transitionTime: _propTypes2.default.number,
  transitionCloseTime: _propTypes2.default.number,
  triggerTagName: _propTypes2.default.string,
  easing: _propTypes2.default.string,
  open: _propTypes2.default.bool,
  classParentString: _propTypes2.default.string,
  openedClassName: _propTypes2.default.string,
  triggerStyle: _propTypes2.default.object,
  triggerClassName: _propTypes2.default.string,
  triggerOpenedClassName: _propTypes2.default.string,
  contentOuterClassName: _propTypes2.default.string,
  contentInnerClassName: _propTypes2.default.string,
  accordionPosition: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  handleTriggerClick: _propTypes2.default.func,
  onOpen: _propTypes2.default.func,
  onClose: _propTypes2.default.func,
  onOpening: _propTypes2.default.func,
  onClosing: _propTypes2.default.func,
  trigger: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  triggerWhenOpen: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  triggerDisabled: _propTypes2.default.bool,
  lazyRender: _propTypes2.default.bool,
  overflowWhenOpen: _propTypes2.default.oneOf(['hidden', 'visible', 'auto', 'scroll', 'inherit', 'initial', 'unset']),
  triggerSibling: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
  tabIndex: _propTypes2.default.number
};

Collapsible.defaultProps = {
  transitionTime: 400,
  transitionCloseTime: null,
  triggerTagName: 'span',
  easing: 'linear',
  open: false,
  classParentString: 'Collapsible',
  triggerDisabled: false,
  lazyRender: false,
  overflowWhenOpen: 'hidden',
  openedClassName: '',
  triggerStyle: null,
  triggerClassName: '',
  triggerOpenedClassName: '',
  contentOuterClassName: '',
  contentInnerClassName: '',
  className: '',
  triggerSibling: null,
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  onOpening: function onOpening() {},
  onClosing: function onClosing() {},
  tabIndex: null
};

exports.default = Collapsible;



/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* unused harmony default export */ var _unused_webpack_default_export = (function(_ref){var extraClassName=_ref.extraClassName,children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-container '+extraClassName},children);});

/***/ }),
/* 1613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DescriptionList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_objects_js__ = __webpack_require__(1614);
function DescriptionList(_ref){var _ref$items=_ref.items,items=_ref$items===undefined?{}:_ref$items,className=_ref.className,inline=_ref.inline,hideEmpty=_ref.hideEmpty;if(hideEmpty)items=Object(__WEBPACK_IMPORTED_MODULE_1__util_objects_js__["a" /* filterMissing */])(items);var labels=Object.keys(items);var style=className===undefined?'ncss-dl':className;if(inline){style=style.replace(/ncss-dl\s?$/,'');style+=' ncss-dl-inline';}var definitions=labels.reduce(function(list,label,i){list.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dt',{key:label+'-'+i+'-dt'},label));list.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',{key:label+'-'+i+'-dd'},items[label]));return list;},[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dl',{className:style},definitions);}

/***/ }),
/* 1614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pick */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterMissing; });
var pick=function pick(obj,props){return props.reduce(function(result,prop){result[prop]=obj[prop];return result;},{});};var filterMissing=function filterMissing(obj){return Object.keys(obj).reduce(function(result,prop){if(obj[prop]){result[prop]=obj[prop];}return result;},{});};

/***/ }),
/* 1615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__version__ = __webpack_require__(371);
/* unused harmony reexport name */
/* unused harmony reexport version */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editor__ = __webpack_require__(372);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__editor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_editor_get_props_preset__ = __webpack_require__(881);
/* unused harmony reexport getPropsPreset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_EditorContext__ = __webpack_require__(470);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__ui_EditorContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_WithEditorActions__ = __webpack_require__(468);
/* unused harmony reexport WithEditorActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_WithHelpTrigger__ = __webpack_require__(883);
/* unused harmony reexport WithHelpTrigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_CollapsedEditor__ = __webpack_require__(2822);
/* unused harmony reexport CollapsedEditor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_ToolbarHelp__ = __webpack_require__(2826);
/* unused harmony reexport ToolbarHelp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_ToolbarFeedback__ = __webpack_require__(2828);
/* unused harmony reexport ToolbarFeedback */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_emoji__ = __webpack_require__(157);
/* unused harmony reexport EmojiResource */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plugins_media__ = __webpack_require__(850);
/* unused harmony reexport DefaultMediaStateManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_mention__ = __webpack_require__(159);
/* unused harmony reexport AbstractMentionResource */
/* unused harmony reexport MentionResource */
/* unused harmony reexport PresenceResource */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__plugins_media_pm_plugins_main__ = __webpack_require__(100);
/* unused harmony reexport mediaPluginKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__plugins_mentions__ = __webpack_require__(297);
/* unused harmony reexport mentionPluginKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__plugins_text_formatting_pm_plugins_main__ = __webpack_require__(876);
/* unused harmony reexport textFormattingStateKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__plugins_text_color__ = __webpack_require__(873);
/* unused harmony reexport textColorPluginKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__plugins_text_color_commands_change_color__ = __webpack_require__(875);
/* unused harmony reexport changeColor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__plugins__ = __webpack_require__(799);
/* unused harmony reexport blockPluginStateKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__plugins_lists_pm_plugins_main__ = __webpack_require__(849);
/* unused harmony reexport listsStateKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__plugins_lists_commands__ = __webpack_require__(287);
/* unused harmony reexport indentList */
/* unused harmony reexport outdentList */
/* unused harmony reexport toggleOrderedList */
/* unused harmony reexport toggleBulletList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__plugins_text_formatting_commands_text_formatting__ = __webpack_require__(166);
/* unused harmony reexport toggleSuperscript */
/* unused harmony reexport toggleSubscript */
/* unused harmony reexport toggleStrike */
/* unused harmony reexport toggleCode */
/* unused harmony reexport toggleUnderline */
/* unused harmony reexport toggleEm */
/* unused harmony reexport toggleStrong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__plugins_block_type_commands__ = __webpack_require__(280);
/* unused harmony reexport insertBlockType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__plugins_table_actions__ = __webpack_require__(61);
/* unused harmony reexport createTable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__plugins_tasks_and_decisions_commands__ = __webpack_require__(163);
/* unused harmony reexport insertTaskDecision */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__event_dispatcher__ = __webpack_require__(200);
/* unused harmony reexport EventDispatcher */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__plugins_status_plugin__ = __webpack_require__(291);
/* unused harmony reexport statusPluginKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__plugins_status_actions__ = __webpack_require__(217);
/* unused harmony reexport commitStatusPicker */
/* unused harmony reexport setStatusPickerAt */
/* unused harmony reexport updateStatus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils__ = __webpack_require__(21);
/* unused harmony reexport setTextSelection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__create_editor__ = __webpack_require__(408);
/* unused harmony reexport ReactEditorView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__create_editor_create_plugins_list__ = __webpack_require__(434);
/* unused harmony reexport getDefaultPluginsList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__actions__ = __webpack_require__(469);
/* unused harmony reexport EditorActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ui_PortalProvider__ = __webpack_require__(882);
/* unused harmony reexport PortalProvider */
/* unused harmony reexport PortalProviderAPI */
/* unused harmony reexport PortalRenderer */
// Used in products integration code












// Used in mobile bridge















// Used in editor-test-helpers





//# sourceMappingURL=index.js.map

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(1618), src$en$$ = __webpack_require__(1623);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(632), src$es5$$ = __webpack_require__(1619), src$compiler$$ = __webpack_require__(1620), intl$messageformat$parser$$ = __webpack_require__(1621);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(632);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(1622)['default'];
exports['default'] = exports;


/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  "use strict";

  /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.location = location;
    this.name     = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  function peg$parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},
        parser  = this,

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements,
                    location: location()
                };
            },
        peg$c1 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c2 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText,
                    location: location()
                };
            },
        peg$c3 = /^[^ \t\n\r,.+={}#]/,
        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c5 = "{",
        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c7 = ",",
        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
        peg$c9 = "}",
        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c11 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2],
                    location: location()
                };
            },
        peg$c12 = "number",
        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c14 = "date",
        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c16 = "time",
        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c18 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2],
                    location: location()
                };
            },
        peg$c19 = "plural",
        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c21 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                };
            },
        peg$c22 = "selectordinal",
        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                }
            },
        peg$c25 = "select",
        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c27 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options,
                    location: location()
                };
            },
        peg$c28 = "=",
        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c30 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern,
                    location: location()
                };
            },
        peg$c31 = "offset:",
        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c33 = function(number) {
                return number;
            },
        peg$c34 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options,
                    location: location()
                };
            },
        peg$c35 = { type: "other", description: "whitespace" },
        peg$c36 = /^[ \t\n\r]/,
        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c38 = { type: "other", description: "optionalWhitespace" },
        peg$c39 = /^[0-9]/,
        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c41 = /^[0-9a-f]/i,
        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c43 = "0",
        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c45 = /^[1-9]/,
        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c47 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
        peg$c50 = "\\\\",
        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c52 = function() { return '\\'; },
        peg$c53 = "\\#",
        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c55 = function() { return '\\#'; },
        peg$c56 = "\\{",
        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c58 = function() { return '\u007B'; },
        peg$c59 = "\\}",
        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c61 = function() { return '\u007D'; },
        peg$c62 = "\\u",
        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c64 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c65 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$savedPos         = 0,
        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function error(message) {
      throw peg$buildException(
        message,
        null,
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p, ch;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line:   details.line,
          column: details.column,
          seenCR: details.seenCR
        };

        while (p < pos) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails   = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line:   startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line:   endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, found, location) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new peg$SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        location
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c2(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c3.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c4); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c3.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c4); }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c6); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c7;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c8); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              if (s5 === peg$FAILED) {
                s5 = null;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c9;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c11(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c13); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c14) {
          s1 = peg$c14;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c15); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c16) {
            s1 = peg$c16;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c17); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c18(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c19) {
        s1 = peg$c19;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c20); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c21(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c28;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c5;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c9;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s1 = peg$c31;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c33(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c36.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c37); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c36.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c37); }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c39.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c41.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c42); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c43;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c44); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c45.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c46); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c47(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c48.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c49); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c50) {
          s1 = peg$c50;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c51); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c54); }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c56) {
              s1 = peg$c56;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c57); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c58();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c59) {
                s1 = peg$c59;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c60); }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c61();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c62) {
                  s1 = peg$c62;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                  } else {
                    s2 = s3;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c64(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c65(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(
        null,
        peg$maxFailExpected,
        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
        peg$maxFailPos < input.length
          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
      );
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse:       peg$parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 1624 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(1626)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(1631);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(1627), src$en$$ = __webpack_require__(1630);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var intl$messageformat$$ = __webpack_require__(631), src$diff$$ = __webpack_require__(1628), src$es5$$ = __webpack_require__(1629);
exports["default"] = RelativeFormat;

// -----------------------------------------------------------------------------

var FIELDS = [
    'second', 'second-short',
    'minute', 'minute-short',
    'hour', 'hour-short',
    'day', 'day-short',
    'month', 'month-short',
    'year', 'year-short'
];
var STYLES = ['best fit', 'numeric'];

// -- RelativeFormat -----------------------------------------------------------

function RelativeFormat(locales, options) {
    options = options || {};

    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (src$es5$$.isArray(locales)) {
        locales = locales.concat();
    }

    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
    src$es5$$.defineProperty(this, '_options', {value: {
        style: this._resolveStyle(options.style),
        units: this._isValidUnits(options.units) && options.units
    }});

    src$es5$$.defineProperty(this, '_locales', {value: locales});
    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlRelativeFormat is missing a ' +
            '`locale` property value'
        );
    }

    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;

    // Add data to IntlMessageFormat.
    intl$messageformat$$["default"].__addLocaleData(data);
}});

// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,

    value: {
        second: 45, 'second-short': 45,  // seconds to minute
        minute: 45, 'minute-short': 45, // minutes to hour
        hour  : 22, 'hour-short': 22, // hours to day
        day   : 26, 'day-short': 26, // days to month
        month : 11, 'month-short': 11 // months to year
    }
});

RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style : this._options.style,
        units : this._options.units
    };
};

RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales        = this._locales;
    var resolvedLocale = this._locale;

    var field        = this._fields[units];
    var relativeTime = field.relativeTime;
    var future       = '';
    var past         = '';
    var i;

    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }

    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }

    var message = '{when, select, future {{0, plural, ' + future + '}}' +
                                 'past {{0, plural, ' + past + '}}}';

    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl$messageformat$$["default"](message, locales);
};

RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;

    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }

    return messages[units];
};

RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];

    if (field.relative) {
        return field.relative[diff];
    }
};

RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale
    );
};

RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();

    if (date === undefined) {
        date = now;
    }

    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError(
            'The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    if (!isFinite(date)) {
        throw new RangeError(
            'The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    var diffReport  = src$diff$$["default"](now, date);
    var units       = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];

    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }

    return this._getMessage(units).format({
        '0' : Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};

RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }

    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error(
                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion
            );
        }
    }

    throw new Error(
        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"'
    );
};

RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);

    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }

    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }

    throw new Error(
        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"'
    );
};

RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;
    var fields = FIELDS.filter(function(field) {
        return field.indexOf('-short') < 1;
    });

    for (i = 0, l = fields.length; i < l; i += 1) {
        units = fields[i];

        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }

    return units;
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



var round = Math.round;

function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}

exports["default"] = function (from, to) {
    // Convert to ms timestamps.
    from = +from;
    to   = +to;

    var millisecond = round(to - from),
        second      = round(millisecond / 1000),
        minute      = round(second / 60),
        hour        = round(minute / 60),
        day         = round(hour / 24),
        week        = round(day / 7);

    var rawYears = daysToYears(day),
        month    = round(rawYears * 12),
        year     = round(rawYears);

    return {
        millisecond    : millisecond,
        second         : second,
        'second-short' : second,
        minute         : minute,
        'minute-short' : minute,
        hour           : hour,
        'hour-short'   : hour,
        day            : day,
        'day-short'    : day,
        week           : week,
        'week-short'   : week,
        month          : month,
        'month-short'  : month,
        year           : year,
        'year-short'   : year
    };
};

//# sourceMappingURL=diff.js.map

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License



var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }

    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }

    return -1;
};

var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};

var dateNow = Date.now || function () {
    return new Date().getTime();
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"year-short":{"displayName":"yr.","relative":{"0":"this yr.","1":"next yr.","-1":"last yr."},"relativeTime":{"future":{"one":"in {0} yr.","other":"in {0} yr."},"past":{"one":"{0} yr. ago","other":"{0} yr. ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"month-short":{"displayName":"mo.","relative":{"0":"this mo.","1":"next mo.","-1":"last mo."},"relativeTime":{"future":{"one":"in {0} mo.","other":"in {0} mo."},"past":{"one":"{0} mo. ago","other":"{0} mo. ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"day-short":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relative":{"0":"this hour"},"relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"hour-short":{"displayName":"hr.","relative":{"0":"this hour"},"relativeTime":{"future":{"one":"in {0} hr.","other":"in {0} hr."},"past":{"one":"{0} hr. ago","other":"{0} hr. ago"}}},"minute":{"displayName":"minute","relative":{"0":"this minute"},"relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"minute-short":{"displayName":"min.","relative":{"0":"this minute"},"relativeTime":{"future":{"one":"in {0} min.","other":"in {0} min."},"past":{"one":"{0} min. ago","other":"{0} min. ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}},"second-short":{"displayName":"sec.","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} sec.","other":"in {0} sec."},"past":{"one":"{0} sec. ago","other":"{0} sec. ago"}}}}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 1631 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(1633)['default'];
exports['default'] = exports;


/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jshint esnext: true */


var src$es5$$ = __webpack_require__(1634);
exports["default"] = createFormatCache;

// -----------------------------------------------------------------------------

function createFormatCache(FormatConstructor) {
    var cache = src$es5$$.objCreate(null);

    return function () {
        var args    = Array.prototype.slice.call(arguments);
        var cacheId = getCacheId(args);
        var format  = cacheId && cache[cacheId];

        if (!format) {
            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();

            if (cacheId) {
                cache[cacheId] = format;
            }
        }

        return format;
    };
}

// -- Utilities ----------------------------------------------------------------

function getCacheId(inputs) {
    // When JSON is not available in the runtime, we will not create a cache id.
    if (typeof JSON === 'undefined') { return; }

    var cacheId = [];

    var i, len, input;

    for (i = 0, len = inputs.length; i < len; i += 1) {
        input = inputs[i];

        if (input && typeof input === 'object') {
            cacheId.push(orderedProps(input));
        } else {
            cacheId.push(input);
        }
    }

    return JSON.stringify(cacheId);
}

function orderedProps(obj) {
    var props = [],
        keys  = [];

    var key, i, len, prop;

    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            keys.push(key);
        }
    }

    var orderedKeys = keys.sort();

    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
        key  = orderedKeys[i];
        prop = {};

        prop[key] = obj[key];
        props[i]  = prop;
    }

    return props;
}

//# sourceMappingURL=memoizer.js.map

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Function.prototype.bind implementation from Mozilla Developer Network:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill



var bind = Function.prototype.bind || function (oThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs   = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP    = function() {},
        fBound  = function() {
          return fToBind.apply(this instanceof fNOP
                 ? this
                 : oThis,
                 aArgs.concat(Array.prototype.slice.call(arguments)));
        };

    if (this.prototype) {
      // native functions don't have a prototype
      fNOP.prototype = this.prototype;
    }
    fBound.prototype = new fNOP();

    return fBound;
};

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 1635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export normalizeHexColor */
/* unused harmony export hexToRgb */
/* harmony export (immutable) */ __webpack_exports__["a"] = hexToRgba;
/* unused harmony export rgbToHex */
/* unused harmony export isRgb */
/* unused harmony export isHex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_css_color_names__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_css_color_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_css_color_names__);


/**
 * @return String with HEX-coded color
 */
function normalizeHexColor(color, defaultColor) {
    if (!color) {
        return null;
    }
    // Normalize to hex
    color = color.trim().toLowerCase();
    if (isHex(color)) {
        // Normalize 3-hex to 6-hex colours
        if (color.length === 4) {
            color = color
                .split('')
                .map(function (c) { return (c === '#' ? '#' : "" + c + c); })
                .join('');
        }
    }
    else if (isRgb(color)) {
        return rgbToHex(color);
    }
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (__WEBPACK_IMPORTED_MODULE_1_css_color_names__["default"] && __WEBPACK_IMPORTED_MODULE_1_css_color_names__["default"][color]) {
            color = __WEBPACK_IMPORTED_MODULE_1_css_color_names__["default"][color];
        }
        else if (__WEBPACK_IMPORTED_MODULE_1_css_color_names__ && __WEBPACK_IMPORTED_MODULE_1_css_color_names__[color]) {
            color = __WEBPACK_IMPORTED_MODULE_1_css_color_names__[color];
        }
        else {
            return null;
        }
    }
    if (color === defaultColor) {
        return null;
    }
    return color;
}
/**
 * Converts hex color format to rgb.
 * Works well with full hex color format and shortcut as well.
 *
 * @param hex - hex color string (#xxx, or #xxxxxx)
 */
function hexToRgb(color) {
    if (!isHex(color)) {
        return null;
    }
    var colorBits = color.substring(1).split('');
    if (colorBits.length === 3) {
        colorBits = [
            colorBits[0],
            colorBits[0],
            colorBits[1],
            colorBits[1],
            colorBits[2],
            colorBits[2],
        ];
    }
    var rgb = Number("0x" + colorBits.join(''));
    // tslint:disable-next-line:no-bitwise
    return "rgb(" + ((rgb >> 16) & 255) + "," + ((rgb >> 8) & 255) + "," + (rgb & 255) + ")";
}
/**
 * Converts hex color format to rgba.
 *
 * @param hex - hex color string (#xxx, or #xxxxxx)
 */
function hexToRgba(rawColor, alpha) {
    var color = normalizeHexColor(rawColor);
    if (!color) {
        return null;
    }
    var hex2rgb = function (color) {
        return color.match(/[a-z0-9]{2}/gi).map(function (hex) { return parseInt(hex, 16); });
    };
    return "rgba(" + hex2rgb(color)
        .concat(alpha)
        .join(',') + ")";
}
function rgbToHex(value) {
    var matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](matches.map(Number), 3), red = _a[0], green = _a[1], blue = _a[2];
        return ('#' +
            (blue | (green << 8) | (red << 16) | (1 << 24)).toString(16).slice(1) // tslint:disable-line:no-bitwise
        );
    }
    return null;
}
function isRgb(color) {
    return /rgba?\(/.test(color);
}
function isHex(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}
//# sourceMappingURL=color.js.map

/***/ }),
/* 1636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getExtensionLozengeData; });
var getExtensionLozengeData = function (_a) {
    var node = _a.node, type = _a.type;
    if (!node.attrs.parameters) {
        return;
    }
    var macroMetadata = node.attrs.parameters.macroMetadata;
    if (macroMetadata && macroMetadata.placeholder) {
        var placeholderData_1;
        macroMetadata.placeholder.forEach(function (placeholder) {
            if (placeholder.type === type &&
                placeholder.data &&
                placeholder.data.url) {
                placeholderData_1 = placeholder.data;
            }
        });
        return placeholderData_1;
    }
};
//# sourceMappingURL=macro.js.map

/***/ }),
/* 1637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export markOrder */
/* unused harmony export isSubSupType */
/* unused harmony export getMarksByOrder */
/* unused harmony export isSameMark */
/* unused harmony export getValidDocument */
/* unused harmony export getValidContent */
/* unused harmony export getValidUnknownNode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getValidNode; });
/* unused harmony export getValidMark */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__ = __webpack_require__(19);


/*
 * It's important that this order follows the marks rank defined here:
 * https://product-fabric.atlassian.net/wiki/spaces/E/pages/11174043/Document+structure#Documentstructure-Rank
 */
var markOrder = [
    'link',
    'em',
    'strong',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'textColor',
];
var isSubSupType = function (type) {
    return type === 'sub' || type === 'sup';
};
/*
 * Sorts mark by the predefined order above
 */
var getMarksByOrder = function (marks) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](marks).sort(function (a, b) { return markOrder.indexOf(a.type.name) - markOrder.indexOf(b.type.name); });
};
/*
 * Check if two marks are the same by comparing type and attrs
 */
var isSameMark = function (mark, otherMark) {
    if (!mark || !otherMark) {
        return false;
    }
    return mark.eq(otherMark);
};
var getValidDocument = function (doc, schema, adfStage) {
    if (schema === void 0) { schema = __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["x" /* defaultSchema */]; }
    if (adfStage === void 0) { adfStage = 'final'; }
    var node = getValidNode(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
var wrapInlineNodes = function (nodes) {
    if (nodes === void 0) { nodes = []; }
    return nodes.map(function (node) {
        return __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["K" /* inlineNodes */].has(node.type) ? { type: 'paragraph', content: [node] } : node;
    });
};
var getValidContent = function (content, schema, adfStage) {
    if (schema === void 0) { schema = __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["x" /* defaultSchema */]; }
    if (adfStage === void 0) { adfStage = 'final'; }
    return content.map(function (node) { return getValidNode(node, schema, adfStage); });
};
var TEXT_COLOR_PATTERN = /^#[0-9a-f]{6}$/i;
var RELATIVE_LINK = /^\//;
var flattenUnknownBlockTree = function (node, schema, adfStage) {
    if (schema === void 0) { schema = __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["x" /* defaultSchema */]; }
    if (adfStage === void 0) { adfStage = 'final'; }
    var output = [];
    var isPrevLeafNode = false;
    for (var i = 0; i < node.content.length; i++) {
        var childNode = node.content[i];
        var isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) {
                output.push({ type: 'text', text: ' ' });
            }
            else {
                output.push({ type: 'hardBreak' });
            }
        }
        if (isLeafNode) {
            output.push(getValidNode(childNode, schema, adfStage));
        }
        else {
            output.push.apply(output, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](flattenUnknownBlockTree(childNode, schema, adfStage)));
        }
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
// null is Object, also maybe check obj.constructor == Object if we want to skip Class
var isValidObject = function (obj) { return obj !== null && typeof obj === 'object'; };
var isValidString = function (str) { return typeof str === 'string'; };
var keysLen = function (obj) { return Object.keys(obj).length; };
var isValidIcon = function (icon) {
    return isValidObject(icon) &&
        keysLen(icon) === 2 &&
        isValidString(icon.url) &&
        isValidString(icon.label);
};
var isValidUser = function (user) {
    var len = keysLen(user);
    return (isValidObject(user) &&
        len <= 2 &&
        isValidIcon(user.icon) &&
        (len === 1 || isValidString(user.id)));
};
/**
 * Sanitize unknown node tree
 *
 * @see https://product-fabric.atlassian.net/wiki/spaces/E/pages/11174043/Document+structure#Documentstructure-ImplementationdetailsforHCNGwebrenderer
 */
var getValidUnknownNode = function (node) {
    var _a = node.attrs, attrs = _a === void 0 ? {} : _a, content = node.content, text = node.text, type = node.type;
    if (!content || !content.length) {
        var unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || "[" + type + "]",
        };
        var textUrl = attrs.textUrl;
        if (textUrl && Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["L" /* isSafeUrl */])(textUrl)) {
            unknownInlineNode.marks = [
                {
                    type: 'link',
                    attrs: {
                        href: textUrl,
                    },
                },
            ];
        }
        return unknownInlineNode;
    }
    /*
     * Find leaf nodes and join them. If leaf nodes' parent node is the same node
     * join with a blank space, otherwise they are children of different branches, i.e.
     * we need to join them with a hardBreak node
     */
    return {
        type: 'unknownBlock',
        content: flattenUnknownBlockTree(node),
    };
};
/*
 * This method will validate a Node according to the spec defined here
 * https://product-fabric.atlassian.net/wiki/spaces/E/pages/11174043/Document+structure#Documentstructure-Nodes
 *
 * This is also the place to handle backwards compatibility.
 *
 * If a node is not recognized or is missing required attributes, we should return 'unknown'
 *
 */
var getValidNode = function (originalNode, schema, adfStage) {
    if (schema === void 0) { schema = __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["x" /* defaultSchema */]; }
    if (adfStage === void 0) { adfStage = 'final'; }
    var attrs = originalNode.attrs, marks = originalNode.marks, text = originalNode.text, type = originalNode.type;
    var content = originalNode.content;
    var node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type,
    };
    if (content) {
        node.content = content = getValidContent(content, schema, adfStage);
    }
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) {
        return getValidUnknownNode(node);
    }
    if (type) {
        switch (type) {
            case 'applicationCard': {
                if (!attrs) {
                    break;
                }
                var text_1 = attrs.text, link = attrs.link, background = attrs.background, preview = attrs.preview, title = attrs.title, description = attrs.description, details = attrs.details, actions = attrs.actions, context = attrs.context;
                if (!isValidString(text_1) || !isValidObject(title) || !title.text) {
                    break;
                }
                // title can contain at most two keys (text, user)
                var titleKeys = Object.keys(title);
                if (titleKeys.length > 2) {
                    break;
                }
                if (titleKeys.length === 2 && !title.user) {
                    break;
                }
                if (title.user && !isValidUser(title.user)) {
                    break;
                }
                if ((link && !link.url) ||
                    (background && !background.url) ||
                    (preview && !preview.url) ||
                    (description && !description.text)) {
                    break;
                }
                if (context && !isValidString(context.text)) {
                    break;
                }
                if (context && (context.icon && !isValidIcon(context.icon))) {
                    break;
                }
                if (actions && !Array.isArray(actions)) {
                    break;
                }
                if (actions && !actions.length) {
                    break;
                }
                if (actions &&
                    actions.some(function (meta) {
                        var key = meta.key, title = meta.title, target = meta.target, parameters = meta.parameters;
                        if (key && !isValidString(key)) {
                            return true;
                        }
                        if (!isValidString(title)) {
                            return true;
                        }
                        if (!target) {
                            return true;
                        }
                        if (!isValidString(target.key)) {
                            return true;
                        }
                        if (target.receiver && !isValidString(target.receiver)) {
                            return true;
                        }
                        if (parameters && !isValidObject(parameters)) {
                            return true;
                        }
                    })) {
                    break;
                }
                if (details && !Array.isArray(details)) {
                    break;
                }
                if (details &&
                    details.some(function (meta) {
                        var badge = meta.badge, lozenge = meta.lozenge, users = meta.users;
                        if (badge && typeof badge.value !== 'number') {
                            return true;
                        }
                        if (lozenge && !lozenge.text) {
                            return true;
                        }
                        if (users && !Array.isArray(users)) {
                            return true;
                        }
                        if (users && !users.every(isValidUser)) {
                            return true;
                        }
                    })) {
                    break;
                }
                return {
                    type: type,
                    text: text_1,
                    attrs: attrs,
                };
            }
            case 'doc': {
                var version = originalNode.version;
                if (version && content && content.length) {
                    return {
                        type: type,
                        content: content,
                    };
                }
                break;
            }
            case 'codeBlock': {
                if (content) {
                    content = content.reduce(function (acc, val) {
                        if (val.type === 'text') {
                            acc.push({ type: val.type, text: val.text });
                        }
                        return acc;
                    }, []);
                }
                if (attrs && attrs.language) {
                    return {
                        type: type,
                        attrs: attrs,
                        content: content,
                        marks: marks,
                    };
                }
                return {
                    type: type,
                    content: content,
                    marks: marks,
                };
            }
            case 'date': {
                if (attrs && attrs.timestamp) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'status': {
                if (attrs && attrs.text && attrs.color) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'emoji': {
                if (attrs && attrs.shortName) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'inlineExtension':
            case 'extension': {
                if (attrs && attrs.extensionType && attrs.extensionKey) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'inlineCard':
            case 'blockCard': {
                if (attrs && (attrs.url || attrs.data)) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'bodiedExtension': {
                if (attrs && attrs.extensionType && attrs.extensionKey && content) {
                    return {
                        type: type,
                        attrs: attrs,
                        content: content,
                    };
                }
                break;
            }
            case 'hardBreak': {
                return {
                    type: type,
                };
            }
            case 'media': {
                var mediaId = '';
                var mediaType = '';
                var mediaCollection = [];
                var mediaUrl = '';
                if (attrs) {
                    var id = attrs.id, collection = attrs.collection, type_1 = attrs.type, url = attrs.url;
                    mediaId = id;
                    mediaType = type_1;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    return {
                        type: type,
                        attrs: {
                            type: mediaType,
                            url: mediaUrl,
                            width: attrs.width,
                            height: attrs.height,
                        },
                    };
                }
                else if (mediaId && mediaType) {
                    var mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection,
                    };
                    if (attrs.width) {
                        mediaAttrs.width = attrs.width;
                    }
                    if (attrs.height) {
                        mediaAttrs.height = attrs.height;
                    }
                    return {
                        type: type,
                        attrs: mediaAttrs,
                    };
                }
                break;
            }
            case 'mediaGroup': {
                if (Array.isArray(content) && !content.some(function (e) { return e.type !== 'media'; })) {
                    return {
                        type: type,
                        content: content,
                    };
                }
                break;
            }
            case 'mediaSingle': {
                if (Array.isArray(content) &&
                    content.length === 1 &&
                    content[0].type === 'media') {
                    return {
                        type: type,
                        attrs: attrs,
                        content: content,
                        marks: marks,
                    };
                }
                break;
            }
            case 'mention': {
                var mentionText = '';
                var mentionId = void 0;
                var mentionAccess = void 0;
                if (attrs) {
                    var text_2 = attrs.text, displayName = attrs.displayName, id = attrs.id, accessLevel = attrs.accessLevel;
                    mentionText = text_2 || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                }
                if (!mentionText) {
                    mentionText = text || '@unknown';
                }
                if (mentionText && mentionId) {
                    var mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                        },
                    };
                    if (mentionAccess) {
                        mentionNode.attrs['accessLevel'] = mentionAccess;
                    }
                    return mentionNode;
                }
                break;
            }
            case 'paragraph': {
                return marks
                    ? {
                        type: type,
                        content: content || [],
                        marks: marks,
                    }
                    : { type: type, content: content || [] };
            }
            case 'rule': {
                return {
                    type: type,
                };
            }
            case 'text': {
                var marks_1 = node.marks;
                if (text) {
                    if (marks_1) {
                        marks_1 = marks_1.reduce(function (acc, mark) {
                            var validMark = getValidMark(mark, adfStage);
                            if (validMark) {
                                acc.push(validMark);
                            }
                            return acc;
                        }, []);
                    }
                    return marks_1 ? { type: type, text: text, marks: marks_1 } : { type: type, text: text };
                }
                break;
            }
            case 'heading': {
                if (attrs) {
                    var level = attrs.level;
                    var between = function (x, a, b) { return x >= a && x <= b; };
                    if (level && between(level, 1, 6)) {
                        return marks
                            ? {
                                type: type,
                                content: content,
                                marks: marks,
                                attrs: {
                                    level: level,
                                },
                            }
                            : {
                                type: type,
                                content: content,
                                attrs: {
                                    level: level,
                                },
                            };
                    }
                }
                break;
            }
            case 'bulletList': {
                if (content) {
                    return {
                        type: type,
                        content: content,
                    };
                }
                break;
            }
            case 'orderedList': {
                if (content) {
                    return {
                        type: type,
                        content: content,
                        attrs: {
                            order: attrs && attrs.order,
                        },
                    };
                }
                break;
            }
            case 'listItem': {
                if (content) {
                    return {
                        type: type,
                        content: wrapInlineNodes(content),
                    };
                }
                break;
            }
            case 'blockquote': {
                if (content) {
                    return {
                        type: type,
                        content: content,
                    };
                }
                break;
            }
            case 'panel': {
                var types = ['info', 'note', 'tip', 'success', 'warning', 'error'];
                if (attrs && content) {
                    var panelType = attrs.panelType;
                    if (types.indexOf(panelType) > -1) {
                        return {
                            type: type,
                            attrs: { panelType: panelType },
                            content: content,
                        };
                    }
                }
                break;
            }
            case 'layoutSection': {
                if (content) {
                    return {
                        type: type,
                        marks: marks,
                        content: content,
                    };
                }
                break;
            }
            case 'layoutColumn': {
                if (attrs && content) {
                    if (attrs.width > 0 && attrs.width <= 100) {
                        return {
                            type: type,
                            content: content,
                            attrs: attrs,
                        };
                    }
                }
                break;
            }
            case 'decisionList': {
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: (attrs && attrs.localId) || Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["D" /* generateUuid */])(),
                    },
                };
            }
            case 'decisionItem': {
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: (attrs && attrs.localId) || Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["D" /* generateUuid */])(),
                        state: (attrs && attrs.state) || 'DECIDED',
                    },
                };
            }
            case 'taskList': {
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: (attrs && attrs.localId) || Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["D" /* generateUuid */])(),
                    },
                };
            }
            case 'taskItem': {
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: (attrs && attrs.localId) || Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["D" /* generateUuid */])(),
                        state: (attrs && attrs.state) || 'TODO',
                    },
                };
            }
            case 'table': {
                if (Array.isArray(content) &&
                    content.length > 0 &&
                    !content.some(function (e) { return e.type !== 'tableRow'; })) {
                    return {
                        type: type,
                        content: content,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'tableRow': {
                if (Array.isArray(content) &&
                    content.length > 0 &&
                    !content.some(function (e) { return e.type !== 'tableCell' && e.type !== 'tableHeader'; })) {
                    return {
                        type: type,
                        content: content,
                    };
                }
                break;
            }
            case 'tableCell':
            case 'tableHeader': {
                if (content) {
                    var cellAttrs = {};
                    if (attrs) {
                        if (attrs.colspan && attrs.colspan > 1) {
                            cellAttrs.colspan = attrs.colspan;
                        }
                        if (attrs.rowspan && attrs.rowspan > 1) {
                            cellAttrs.rowspan = attrs.rowspan;
                        }
                        if (attrs.background) {
                            cellAttrs.background = attrs.background;
                        }
                        if (attrs.colwidth && Array.isArray(attrs.colwidth)) {
                            cellAttrs.colwidth = attrs.colwidth;
                        }
                    }
                    return {
                        type: type,
                        content: wrapInlineNodes(content),
                        attrs: attrs ? cellAttrs : undefined,
                    };
                }
                break;
            }
            case 'image': {
                if (attrs && attrs.src) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'placeholder': {
                if (attrs && typeof attrs.text !== 'undefined') {
                    return { type: type, attrs: attrs };
                }
                break;
            }
        }
    }
    return getValidUnknownNode(node);
};
/*
 * This method will validate a Mark according to the spec defined here
 * https://product-fabric.atlassian.net/wiki/spaces/E/pages/11174043/Document+structure#Documentstructure-Marks
 *
 * This is also the place to handle backwards compatibility.
 *
 * If a node is not recognized or is missing required attributes, we should return null
 *
 */
var getValidMark = function (mark, adfStage) {
    if (adfStage === void 0) { adfStage = 'final'; }
    var attrs = mark.attrs, type = mark.type;
    if (type) {
        switch (type) {
            case 'action': {
                if (attrs && attrs.target && attrs.target.key) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'code': {
                return {
                    type: type,
                };
            }
            case 'em': {
                return {
                    type: type,
                };
            }
            case 'link': {
                if (attrs) {
                    var href = attrs.href, url = attrs.url, __confluenceMetadata = attrs.__confluenceMetadata;
                    var linkHref = href || url;
                    if (linkHref &&
                        linkHref.indexOf(':') === -1 &&
                        !RELATIVE_LINK.test(linkHref)) {
                        linkHref = "http://" + linkHref;
                    }
                    var linkAttrs = {
                        href: linkHref,
                    };
                    if (__confluenceMetadata) {
                        linkAttrs.__confluenceMetadata = __confluenceMetadata;
                    }
                    if (linkHref && Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["L" /* isSafeUrl */])(linkHref)) {
                        return {
                            type: type,
                            attrs: linkAttrs,
                        };
                    }
                }
                break;
            }
            case 'strike': {
                return {
                    type: type,
                };
            }
            case 'strong': {
                return {
                    type: type,
                };
            }
            case 'subsup': {
                if (attrs && attrs['type']) {
                    var subSupType = attrs['type'];
                    if (isSubSupType(subSupType)) {
                        return {
                            type: type,
                            attrs: {
                                type: subSupType,
                            },
                        };
                    }
                }
                break;
            }
            case 'textColor': {
                if (attrs && TEXT_COLOR_PATTERN.test(attrs.color)) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'underline': {
                return {
                    type: type,
                };
            }
        }
    }
    if (adfStage === 'stage0') {
        switch (type) {
            case 'confluenceInlineComment': {
                return {
                    type: type,
                    attrs: attrs,
                };
            }
        }
    }
    return null;
};
//# sourceMappingURL=validator.js.map

/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nodes__ = __webpack_require__(374);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["blockCard"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["blockquote"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["bodiedExtension"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["bulletList"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["calcTableColumnWidths"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["codeBlock"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["codeBlockToJSON"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["confluenceJiraIssue"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["confluenceUnsupportedBlock"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["confluenceUnsupportedInline"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["date"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["decisionItem"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["decisionList"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["doc"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["emoji"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["extension"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["hardBreak"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["heading"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["inlineCard"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["inlineExtension"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["layoutColumn"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["layoutSection"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["listItem"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["media"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["mediaGroup"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["mediaSingle"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["mediaSingleToJSON"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["mediaToJSON"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["mention"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["mentionToJSON"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["orderedList"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["panel"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["paragraph"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["placeholder"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["rule"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["setCellAttrs"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["status"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["table"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["tableBackgroundBorderColors"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["tableBackgroundColorPalette"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["tableCell"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["tableHeader"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["tableRow"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["tableToJSON"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["taskItem"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["taskList"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["text"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["toJSONTableCell"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["toJSONTableHeader"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["unsupportedBlock"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return __WEBPACK_IMPORTED_MODULE_0__nodes__["unsupportedInline"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__marks__ = __webpack_require__(634);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__marks__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__marks__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__marks__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__marks__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__marks__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1__marks__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1__marks__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_1__marks__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_1__marks__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_1__marks__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_1__marks__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_1__marks__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_1__marks__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_1__marks__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_1__marks__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_1__marks__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return __WEBPACK_IMPORTED_MODULE_1__marks__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return __WEBPACK_IMPORTED_MODULE_1__marks__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return __WEBPACK_IMPORTED_MODULE_1__marks__["s"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupported__ = __webpack_require__(1696);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inline_nodes__ = __webpack_require__(1697);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_3__inline_nodes__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__create_schema__ = __webpack_require__(192);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_4__create_schema__["b"]; });
/* unused harmony reexport createSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bitbucket_schema__ = __webpack_require__(1698);
/* unused harmony reexport bitbucketSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__confluence_schema__ = __webpack_require__(1699);
/* unused harmony reexport confluenceSchema */
/* unused harmony reexport confluenceSchemaWithMediaSingle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__default_schema__ = __webpack_require__(1700);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_7__default_schema__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__jira_schema__ = __webpack_require__(1701);
/* unused harmony reexport createJIRASchema */
/* unused harmony reexport isSchemaWithLists */
/* unused harmony reexport isSchemaWithMentions */
/* unused harmony reexport isSchemaWithEmojis */
/* unused harmony reexport isSchemaWithLinks */
/* unused harmony reexport isSchemaWithAdvancedTextFormattingMarks */
/* unused harmony reexport isSchemaWithCodeBlock */
/* unused harmony reexport isSchemaWithBlockQuotes */
/* unused harmony reexport isSchemaWithMedia */
/* unused harmony reexport isSchemaWithSubSupMark */
/* unused harmony reexport isSchemaWithTextColor */
/* unused harmony reexport isSchemaWithTables */
/**
 * NOTE: Ordering of export is pretty important for spec generator.
 * Make sure to run `yarn generate:spec` inside `adf-utils` package if you
 * change order here.
 */









//# sourceMappingURL=index.js.map

/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return confluenceJiraIssue; });
var name = 'confluenceJiraIssue';
var confluenceJiraIssue = {
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: { default: '' },
        macroId: { default: null },
        schemaVersion: { default: null },
        server: { default: null },
        serverId: { default: null },
    },
    parseDOM: [
        {
            tag: "span[data-node-type=\"" + name + "\"]",
            getAttrs: function (domNode) {
                var dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId,
                };
            },
        },
    ],
    toDOM: function (node) {
        var attrs = {
            'data-node-type': name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey,
        };
        return ['span', attrs, node.attrs.issueKey];
    },
};
//# sourceMappingURL=confluence-jira-issue.js.map

/***/ }),
/* 1640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return confluenceUnsupportedBlock; });
var name = 'confluenceUnsupportedBlock';
var confluenceUnsupportedBlock = {
    group: 'block',
    attrs: { cxhtml: { default: null } },
    toDOM: function (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        var attrs = {
            'data-node-type': name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml'],
        };
        return ['div', attrs, 'Unsupported content'];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"" + name + "\"]",
            getAttrs: function (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml'),
                };
            },
        },
    ],
};
//# sourceMappingURL=confluence-unsupported-block.js.map

/***/ }),
/* 1641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return confluenceUnsupportedInline; });
var name = 'confluenceUnsupportedInline';
var confluenceUnsupportedInline = {
    group: 'inline',
    inline: true,
    atom: true,
    attrs: { cxhtml: { default: null } },
    toDOM: function (node) {
        var attrs = {
            'data-node-type': name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml'],
        };
        return ['div', attrs, 'Unsupported content'];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"" + name + "\"]",
            getAttrs: function (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml'),
                };
            },
        },
    ],
};
//# sourceMappingURL=confluence-unsupported-inline.js.map

/***/ }),
/* 1642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return doc; });
var doc = {
    content: '(block|layoutSection)+',
    marks: 'alignment breakout indentation link',
};
//# sourceMappingURL=doc.js.map

/***/ }),
/* 1643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return blockquote; });
var blockquote = {
    content: 'paragraph+',
    group: 'block',
    defining: true,
    selectable: false,
    parseDOM: [{ tag: 'blockquote' }],
    toDOM: function () {
        return ['blockquote', 0];
    },
};
//# sourceMappingURL=blockquote.js.map

/***/ }),
/* 1644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bulletList; });
var bulletList = {
    group: 'block',
    content: 'listItem+',
    parseDOM: [{ tag: 'ul' }],
    toDOM: function () {
        return ['ul', 0];
    },
};
//# sourceMappingURL=bullet-list.js.map

/***/ }),
/* 1645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return codeBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toJSON; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__);

var getLanguageFromEditorStyle = function (dom) {
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
var getLanguageFromBitbucketStyle = function (dom) {
    if (dom && dom.classList.contains('codehilite')) {
        // code block html from Bitbucket always contains an extra new line
        return extractLanguageFromClass(dom.className);
    }
};
var extractLanguageFromClass = function (className) {
    var languageRegex = /(?:^|\s)language-([^\s]+)/;
    var result = languageRegex.exec(className);
    if (result && result[1]) {
        return result[1];
    }
};
var removeLastNewLine = function (dom) {
    var parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) {
        dom.textContent = dom.textContent.replace(/\n$/, '');
    }
    return dom;
};
var codeBlock = {
    attrs: { language: { default: null }, uniqueId: { default: null } },
    content: 'text*',
    marks: '',
    group: 'block',
    code: true,
    defining: true,
    parseDOM: [
        {
            tag: 'pre > code',
            preserveWhitespace: 'full',
            getAttrs: function (dom) {
                var language = dom.getAttribute('data-language');
                return { language: language };
            },
        },
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: function (domNode) {
                var dom = domNode;
                var language = getLanguageFromBitbucketStyle(dom.parentElement) ||
                    getLanguageFromEditorStyle(dom.parentElement) ||
                    dom.getAttribute('data-language');
                dom = removeLastNewLine(dom);
                return { language: language };
            },
        },
        // Handle VSCode paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: function (domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre' ||
                    (dom.style.fontFamily &&
                        dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1)) {
                    return {};
                }
                return false;
            },
            // @see ED-5682
            getContent: function (domNode, schema) {
                var dom = domNode;
                var code = Array.from(dom.children)
                    .map(function (child) { return child.textContent; })
                    // tslint:disable-next-line:triple-equals
                    .filter(function (x) { return x != undefined; })
                    .join('\n');
                return code ? __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(schema.text(code)) : __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].empty;
            },
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: function (dom) {
                if (dom.querySelector('td[class*="blob-code"]')) {
                    return {};
                }
                return false;
            },
        },
        {
            tag: 'div.CodeBlock',
            preserveWhitespace: 'full',
            getAttrs: function (domNode) {
                var dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                var linesCode = dom.querySelector('code');
                if (linesCode &&
                    linesCode.querySelector('.react-syntax-highlighter-line-number')) {
                    // It's possible to copy without the line numbers too hence this
                    // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                    linesCode.remove();
                }
                return {};
            },
        },
    ],
    toDOM: function (node) {
        return ['pre', ['code', { 'data-language': node.attrs.language }, 0]];
    },
};
var toJSON = function (node) { return ({
    attrs: Object.keys(node.attrs).reduce(function (memo, key) {
        if (key === 'uniqueId') {
            return memo;
        }
        if (key === 'language' && node.attrs.language === null) {
            return memo;
        }
        memo[key] = node.attrs[key];
        return memo;
    }, {}),
}); };
//# sourceMappingURL=code-block.js.map

/***/ }),
/* 1646 */
/***/ (function(module, exports) {

// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function OrderedMap(content) {
  this.content = content
}

OrderedMap.prototype = {
  constructor: OrderedMap,

  find: function(key) {
    for (var i = 0; i < this.content.length; i += 2)
      if (this.content[i] === key) return i
    return -1
  },

  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(key) {
    var found = this.find(key)
    return found == -1 ? undefined : this.content[found + 1]
  },

  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(key, value, newKey) {
    var self = newKey && newKey != key ? this.remove(newKey) : this
    var found = self.find(key), content = self.content.slice()
    if (found == -1) {
      content.push(newKey || key, value)
    } else {
      content[found + 1] = value
      if (newKey) content[found] = newKey
    }
    return new OrderedMap(content)
  },

  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(key) {
    var found = this.find(key)
    if (found == -1) return this
    var content = this.content.slice()
    content.splice(found, 2)
    return new OrderedMap(content)
  },

  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(key, value) {
    return new OrderedMap([key, value].concat(this.remove(key).content))
  },

  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(key, value) {
    var content = this.remove(key).content.slice()
    content.push(key, value)
    return new OrderedMap(content)
  },

  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(place, key, value) {
    var without = this.remove(key), content = without.content.slice()
    var found = without.find(place)
    content.splice(found == -1 ? content.length : found, 0, key, value)
    return new OrderedMap(content)
  },

  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(f) {
    for (var i = 0; i < this.content.length; i += 2)
      f(this.content[i], this.content[i + 1])
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(map) {
    map = OrderedMap.from(map)
    if (!map.size) return this
    return new OrderedMap(map.content.concat(this.subtract(map).content))
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(map) {
    map = OrderedMap.from(map)
    if (!map.size) return this
    return new OrderedMap(this.subtract(map).content.concat(map.content))
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(map) {
    var result = this
    map = OrderedMap.from(map)
    for (var i = 0; i < map.content.length; i += 2)
      result = result.remove(map.content[i])
    return result
  },

  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1
  }
}

// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
OrderedMap.from = function(value) {
  if (value instanceof OrderedMap) return value
  var content = []
  if (value) for (var prop in value) content.push(prop, value[prop])
  return new OrderedMap(content)
}

module.exports = OrderedMap


/***/ }),
/* 1647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hardBreak; });
var hardBreak = {
    inline: true,
    group: 'inline',
    selectable: false,
    parseDOM: [{ tag: 'br' }],
    toDOM: function () {
        return ['br'];
    },
};
//# sourceMappingURL=hard-break.js.map

/***/ }),
/* 1648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return heading; });
var heading = {
    attrs: { level: { default: 1 } },
    content: "inline*",
    group: 'block',
    defining: true,
    parseDOM: [
        { tag: 'h1', attrs: { level: 1 } },
        { tag: 'h2', attrs: { level: 2 } },
        { tag: 'h3', attrs: { level: 3 } },
        { tag: 'h4', attrs: { level: 4 } },
        { tag: 'h5', attrs: { level: 5 } },
        { tag: 'h6', attrs: { level: 6 } },
    ],
    toDOM: function (node) {
        return ['h' + node.attrs['level'], 0];
    },
};
//# sourceMappingURL=heading.js.map

/***/ }),
/* 1649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rule; });
var hrDOM = ['hr'];
var rule = {
    group: 'block',
    parseDOM: [{ tag: 'hr' }],
    toDOM: function () {
        return hrDOM;
    },
};
//# sourceMappingURL=rule.js.map

/***/ }),
/* 1650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return orderedList; });
var orderedList = {
    group: 'block',
    content: 'listItem+',
    parseDOM: [{ tag: 'ol' }],
    toDOM: function () {
        return ['ol', 0];
    },
};
//# sourceMappingURL=ordered-list.js.map

/***/ }),
/* 1651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return paragraph; });
var pDOM = ['p', 0];
var paragraph = {
    content: 'inline*',
    group: 'block',
    marks: 'strong code em link strike subsup textColor typeAheadQuery underline mentionQuery emojiQuery confluenceInlineComment action',
    parseDOM: [{ tag: 'p' }],
    toDOM: function () {
        return pDOM;
    },
};
//# sourceMappingURL=paragraph.js.map

/***/ }),
/* 1652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return emoji; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_confluence_emoji__ = __webpack_require__(633);

var emoji = {
    inline: true,
    group: 'inline',
    selectable: false,
    attrs: {
        shortName: { default: '' },
        id: { default: '' },
        text: { default: '' },
    },
    parseDOM: [
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: function (domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') ||
                        emoji.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || emoji.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || emoji.attrs.text.default,
                };
            },
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: function (dom) {
                return Object(__WEBPACK_IMPORTED_MODULE_0__utils_confluence_emoji__["a" /* acNameToEmoji */])(dom.getAttribute('data-emoticon-name'));
            },
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: function (dom) {
                return Object(__WEBPACK_IMPORTED_MODULE_0__utils_confluence_emoji__["b" /* acShortcutToEmoji */])(dom.getAttribute('data-hipchat-emoticon'));
            },
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: function (domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') ||
                        emoji.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || emoji.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || emoji.attrs.text.default,
                };
            },
        },
    ],
    toDOM: function (node) {
        var _a = node.attrs, shortName = _a.shortName, id = _a.id, text = _a.text;
        var attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false',
        };
        return ['span', attrs, text];
    },
};
//# sourceMappingURL=emoji.js.map

/***/ }),
/* 1653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return image; });
var image = {
    group: 'inline',
    inline: true,
    attrs: {
        src: { default: '' },
        alt: { default: null },
        title: { default: null },
    },
    draggable: true,
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true,
        },
        {
            tag: 'img[src]',
            getAttrs: function (domNode) {
                var dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title'),
                };
            },
        },
    ],
    toDOM: function (node) {
        return ['img', node.attrs];
    },
};
//# sourceMappingURL=image.js.map

/***/ }),
/* 1654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export USER_TYPES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mention; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toJSON; });
var USER_TYPES;
(function (USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
})(USER_TYPES || (USER_TYPES = {}));
var mention = {
    inline: true,
    group: 'inline',
    selectable: false,
    attrs: {
        id: { default: '' },
        text: { default: '' },
        accessLevel: { default: '' },
        userType: { default: null },
    },
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: function (domNode) {
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute('data-mention-id') || mention.attrs.id.default,
                    text: dom.textContent || mention.attrs.text.default,
                    accessLevel: dom.getAttribute('data-access-level') ||
                        mention.attrs.accessLevel.default,
                };
                var userType = dom.getAttribute('data-user-type');
                if (USER_TYPES[userType]) {
                    attrs['userType'] = userType;
                }
                return attrs;
            },
        },
    ],
    toDOM: function (node) {
        var _a = node.attrs, id = _a.id, accessLevel = _a.accessLevel, text = _a.text, userType = _a.userType;
        var attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false',
        };
        if (userType) {
            attrs['data-user-type'] = userType;
        }
        return ['span', attrs, text];
    },
};
var isOptional = function (key) {
    return ['userType'].indexOf(key) > -1;
};
var toJSON = function (node) { return ({
    attrs: Object.keys(node.attrs).reduce(function (obj, key) {
        if (isOptional(key) && !node.attrs[key]) {
            return obj;
        }
        obj[key] = node.attrs[key];
        return obj;
    }, {}),
}); };
//# sourceMappingURL=mention.js.map

/***/ }),
/* 1655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return listItem; });
var listItem = {
    content: '(paragraph | mediaSingle | codeBlock) (paragraph | bulletList | orderedList | mediaSingle | codeBlock)*',
    defining: true,
    parseDOM: [{ tag: 'li' }],
    toDOM: function () {
        return ['li', 0];
    },
};
//# sourceMappingURL=list-item.js.map

/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return panel; });
var panel = {
    group: 'block',
    content: '(paragraph | heading | bulletList | orderedList)+',
    attrs: {
        panelType: { default: 'info' },
    },
    parseDOM: [
        {
            tag: 'div[data-panel-type]',
            getAttrs: function (dom) { return ({
                panelType: dom.getAttribute('data-panel-type'),
            }); },
        },
    ],
    toDOM: function (node) {
        var panelType = node.attrs['panelType'];
        var attrs = {
            'data-panel-type': panelType,
        };
        return ['div', attrs, ['div', {}, 0]];
    },
};
//# sourceMappingURL=panel.js.map

/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return text; });
var text = {
    group: 'inline',
    toDebugString: 
    // @ts-ignore
     false ? undefined : function () { return 'text_node'; },
};
//# sourceMappingURL=text.js.map

/***/ }),
/* 1658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var name = 'unknownBlock';
/* harmony default export */ __webpack_exports__["a"] = ({
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM: function () {
        return ['div', { 'data-node-type': name }, 0];
    },
    parseDOM: [{ tag: "div[data-node-type=\"" + name + "\"]" }],
});
//# sourceMappingURL=unknown-block.js.map

/***/ }),
/* 1659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultAttrs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return media; });
/* unused harmony export camelCaseToKebabCase */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return copyPrivateAttributes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return toJSON; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_colors__ = __webpack_require__(155);

var defaultAttrs = {
    id: { default: '' },
    type: { default: 'file' },
    collection: { default: null },
    occurrenceKey: { default: null },
    width: { default: null },
    height: { default: null },
    url: { default: null },
    __fileName: { default: null },
    __fileSize: { default: null },
    __fileMimeType: { default: null },
    __displayType: { default: null },
    __key: { default: null },
};
var media = {
    inline: false,
    selectable: true,
    attrs: defaultAttrs,
    parseDOM: [
        {
            tag: 'div[data-node-type="media"]',
            getAttrs: function (dom) {
                var attrs = {};
                Object.keys(defaultAttrs).forEach(function (k) {
                    var key = camelCaseToKebabCase(k).replace(/^__/, '');
                    var value = dom.getAttribute("data-" + key);
                    if (value) {
                        attrs[k] = value;
                    }
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) {
                    attrs.__fileSize = +attrs.__fileSize;
                }
                return attrs;
            },
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true,
        },
        {
            tag: 'img',
            getAttrs: function (dom) {
                return {
                    type: 'external',
                    url: dom.getAttribute('src') || '',
                };
            },
        },
    ],
    toDOM: function (node) {
        var attrs = {
            'data-id': node.attrs.id,
            'data-node-type': 'media',
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: "display: inline-block; border-radius: 3px; background: " + __WEBPACK_IMPORTED_MODULE_0__utils_colors__["j" /* N30 */] + "; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);",
        };
        copyPrivateAttributes(node.attrs, attrs, function (key) { return "data-" + camelCaseToKebabCase(key.slice(2)); });
        return ['div', attrs];
    },
};
var camelCaseToKebabCase = function (str) {
    return str.replace(/([^A-Z]+)([A-Z])/g, function (_, x, y) { return x + "-" + y.toLowerCase(); });
};
var copyPrivateAttributes = function (from, to, map) {
    if (media.attrs) {
        Object.keys(media.attrs).forEach(function (key) {
            if (key[0] === '_' && key[1] === '_' && from[key]) {
                to[map ? map(key) : key] = from[key];
            }
        });
    }
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */
var optionalAttributes = ['occurrenceKey', 'width', 'height', 'url'];
var externalOnlyAttributes = ['type', 'url', 'width', 'height'];
var toJSON = function (node) { return ({
    attrs: Object.keys(node.attrs)
        .filter(function (key) { return !(key[0] === '_' && key[1] === '_'); })
        .reduce(function (obj, key) {
        if (node.attrs.type === 'external' &&
            externalOnlyAttributes.indexOf(key) === -1) {
            return obj;
        }
        if (optionalAttributes.indexOf(key) > -1 &&
            (node.attrs[key] === null || node.attrs[key] === '')) {
            return obj;
        }
        obj[key] = node.attrs[key];
        return obj;
    }, {}),
}); };
//# sourceMappingURL=media.js.map

/***/ }),
/* 1660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mediaGroup; });
var mediaGroup = {
    inline: false,
    group: 'block',
    content: 'media+',
    attrs: {},
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]',
        },
    ],
    toDOM: function () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup',
            },
            0,
        ];
    },
};
//# sourceMappingURL=media-group.js.map

/***/ }),
/* 1661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultAttrs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mediaSingle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toJSON; });
var defaultAttrs = {
    width: { default: null },
    layout: { default: 'center' },
};
var mediaSingle = {
    inline: false,
    group: 'block',
    content: 'media',
    attrs: defaultAttrs,
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaSingle"]',
            getAttrs: function (dom) { return ({
                layout: dom.getAttribute('data-layout') || 'center',
                width: Number(dom.getAttribute('data-width')) || null,
            }); },
        },
    ],
    toDOM: function (node) {
        var _a = node.attrs, layout = _a.layout, width = _a.width;
        var attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
        };
        if (width) {
            attrs['data-width'] =
                isFinite(width) && Math.floor(width) === width
                    ? width
                    : width.toFixed(2);
        }
        return ['div', attrs, 0];
    },
};
var toJSON = function (node) { return ({
    attrs: Object.keys(node.attrs).reduce(function (obj, key) {
        if (node.attrs[key] !== null) {
            obj[key] = node.attrs[key];
        }
        return obj;
    }, {}),
}); };
//# sourceMappingURL=media-single.js.map

/***/ }),
/* 1662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setCellAttrs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return tableBackgroundColorPalette; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return tableBackgroundBorderColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return tableBackgroundColorNames; });
/* harmony export (immutable) */ __webpack_exports__["a"] = calcTableColumnWidths;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return table; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return tableToJSON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return tableRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return tableCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return toJSONTableCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return tableHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return toJSONTableHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_colors__ = __webpack_require__(155);


var akEditorTableCellBackgroundOpacity = 0.5;
var akEditorTableNumberColumnWidth = 42;
var getCellAttrs = function (dom) {
    var widthAttr = dom.getAttribute('data-colwidth');
    var width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr)
        ? widthAttr.split(',').map(function (str) { return Number(str); })
        : null;
    var colspan = Number(dom.getAttribute('colspan') || 1);
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: dom.style.backgroundColor || null,
    };
};
var setCellAttrs = function (node, cell) {
    var attrs = {};
    var colspan = cell ? parseInt(cell.getAttribute('colspan') || '1', 10) : 1;
    var rowspan = cell ? parseInt(cell.getAttribute('rowspan') || '1', 10) : 1;
    if (node.attrs.colspan !== colspan) {
        attrs.colspan = node.attrs.colspan;
    }
    if (node.attrs.rowspan !== rowspan) {
        attrs.rowspan = node.attrs.rowspan;
    }
    if (node.attrs.colwidth) {
        attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    }
    if (node.attrs.background) {
        var background = node.attrs.background;
        var nodeType = node.type.name;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        var ignored = (nodeType === 'tableHeader' &&
            background === tableBackgroundColorNames.get('gray')) ||
            (nodeType === 'tableCell' &&
                background === tableBackgroundColorNames.get('white'));
        if (ignored) {
            attrs.style = '';
        }
        else {
            var color = nodeType === 'tableCell' && Object(__WEBPACK_IMPORTED_MODULE_1__utils_colors__["E" /* isHex */])(background)
                ? Object(__WEBPACK_IMPORTED_MODULE_1__utils_colors__["D" /* hexToRgba */])(background, akEditorTableCellBackgroundOpacity)
                : background;
            attrs.style = (attrs.style || '') + "background-color: " + color + ";";
        }
    }
    return attrs;
};
var tableBackgroundColorPalette = new Map();
/** New borders for colors in the color picker */
var tableBackgroundBorderColors = {
    blue: __WEBPACK_IMPORTED_MODULE_1__utils_colors__["c" /* B75 */],
    teal: __WEBPACK_IMPORTED_MODULE_1__utils_colors__["y" /* T75 */],
    red: __WEBPACK_IMPORTED_MODULE_1__utils_colors__["u" /* R75 */],
    gray: __WEBPACK_IMPORTED_MODULE_1__utils_colors__["k" /* N40 */],
    purple: __WEBPACK_IMPORTED_MODULE_1__utils_colors__["q" /* P75 */],
    green: __WEBPACK_IMPORTED_MODULE_1__utils_colors__["g" /* G75 */],
    yellow: __WEBPACK_IMPORTED_MODULE_1__utils_colors__["C" /* Y75 */],
    white: __WEBPACK_IMPORTED_MODULE_1__utils_colors__["k" /* N40 */],
};
var tableBackgroundColorNames = new Map();
[
    [__WEBPACK_IMPORTED_MODULE_1__utils_colors__["b" /* B50 */], 'Blue'],
    [__WEBPACK_IMPORTED_MODULE_1__utils_colors__["w" /* T50 */], 'Teal'],
    [__WEBPACK_IMPORTED_MODULE_1__utils_colors__["s" /* R50 */], 'Red'],
    [__WEBPACK_IMPORTED_MODULE_1__utils_colors__["i" /* N20 */], 'Gray'],
    [__WEBPACK_IMPORTED_MODULE_1__utils_colors__["o" /* P50 */], 'Purple'],
    [__WEBPACK_IMPORTED_MODULE_1__utils_colors__["e" /* G50 */], 'Green'],
    [__WEBPACK_IMPORTED_MODULE_1__utils_colors__["A" /* Y50 */], 'Yellow'],
    [__WEBPACK_IMPORTED_MODULE_1__utils_colors__["h" /* N0 */], 'White'],
].forEach(function (_a) {
    var _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](_a, 2), colorValue = _b[0], colorName = _b[1];
    tableBackgroundColorPalette.set(colorValue.toLowerCase(), colorName);
    tableBackgroundColorNames.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
function calcTableColumnWidths(node) {
    var tableColumnWidths = [];
    var isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
    node.forEach(function (rowNode, _, i) {
        rowNode.forEach(function (colNode, _, j) {
            var colwidth = colNode.attrs.colwidth || [0];
            if (isNumberColumnEnabled && j === 0) {
                if (!colwidth) {
                    colwidth = [akEditorTableNumberColumnWidth];
                }
            }
            // if we have a colwidth attr for this cell, and it contains new
            // colwidths we haven't seen for the whole table yet, add those
            // (colwidths over the table are defined as-we-go)
            if (colwidth && colwidth.length + j > tableColumnWidths.length) {
                tableColumnWidths = tableColumnWidths.slice(0, j).concat(colwidth);
            }
        });
    });
    return tableColumnWidths;
}
// TODO: Fix any, potential issue. ED-5048
var table = {
    content: 'tableRow+',
    attrs: {
        isNumberColumnEnabled: { default: false },
        layout: { default: 'default' },
        __autoSize: { default: false },
    },
    tableRole: 'table',
    isolating: true,
    selectable: false,
    group: 'block',
    parseDOM: [
        {
            tag: 'table',
            getAttrs: function (dom) { return ({
                isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true' ? true : false,
                layout: dom.getAttribute('data-layout') || 'default',
                __autoSize: dom.getAttribute('data-autosize') === 'true' ? true : false,
            }); },
        },
    ],
    toDOM: function (node) {
        var attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
        };
        return ['table', attrs, ['tbody', 0]];
    },
};
var tableToJSON = function (node) { return ({
    attrs: Object.keys(node.attrs)
        .filter(function (key) { return !key.startsWith('__'); })
        .reduce(function (obj, key) {
        obj[key] = node.attrs[key];
        return obj;
    }, {}),
}); };
// We allow empty rows here to prevent ProseMirror from trying to "fix" the table by injecting cells in random places
// Instead, we remove empty rows on our side in table plugin -> appendTransaction
var tableRow = {
    content: '(tableCell | tableHeader)*',
    tableRole: 'row',
    parseDOM: [{ tag: 'tr' }],
    toDOM: function () {
        return ['tr', 0];
    },
};
var cellAttrs = {
    colspan: { default: 1 },
    rowspan: { default: 1 },
    colwidth: { default: null },
    background: { default: null },
};
var tableCell = {
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock |  mediaGroup | mediaSingle | applicationCard | decisionList | taskList | blockCard | extension | unsupportedBlock)+',
    attrs: cellAttrs,
    tableRole: 'cell',
    marks: 'alignment',
    isolating: true,
    parseDOM: [
        {
            tag: 'td',
            getAttrs: function (dom) { return getCellAttrs(dom); },
        },
    ],
    toDOM: function (node) {
        return ['td', setCellAttrs(node), 0];
    },
};
var toJSONTableCell = function (node) { return ({
    attrs: Object.keys(node.attrs).reduce(function (obj, key) {
        if (cellAttrs[key].default !== node.attrs[key]) {
            obj[key] = node.attrs[key];
        }
        return obj;
    }, {}),
}); };
var tableHeader = {
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle  | applicationCard | decisionList | taskList | blockCard | extension)+',
    attrs: cellAttrs,
    tableRole: 'header_cell',
    isolating: true,
    marks: 'alignment',
    parseDOM: [
        {
            tag: 'th',
            getAttrs: function (dom) { return getCellAttrs(dom); },
        },
    ],
    toDOM: function (node) {
        return ['th', setCellAttrs(node), 0];
    },
};
var toJSONTableHeader = toJSONTableCell;
//# sourceMappingURL=tableNodes.js.map

/***/ }),
/* 1663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applicationCard; });
var defaultAttrs = {
    text: { default: '' },
    textUrl: { default: null },
    link: { default: null },
    background: { default: null },
    collapsible: { default: null },
    preview: { default: null },
    title: { default: { text: '' } },
    description: { default: null },
    details: { default: null },
    actions: { default: null },
    context: { default: null },
};
var applicationCard = {
    inline: false,
    selectable: true,
    attrs: defaultAttrs,
    group: 'block',
    parseDOM: [
        {
            tag: 'div[data-node-type="media"]',
            getAttrs: function (dom) {
                var attrs = {
                    text: '',
                    title: { text: '' },
                };
                Object.keys(defaultAttrs).forEach(function (key) {
                    attrs[key] = dom.dataset[key];
                });
                return attrs;
            },
        },
    ],
    toDOM: function (node) {
        return ['div', node.attrs];
    },
};
//# sourceMappingURL=applicationCard.js.map

/***/ }),
/* 1664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return decisionList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_uuid__ = __webpack_require__(191);

var decisionList = {
    group: 'block',
    defining: true,
    content: 'decisionItem+',
    attrs: {
        localId: { default: '' },
    },
    parseDOM: [
        {
            tag: 'ol[data-decision-list-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function () { return ({
                localId: __WEBPACK_IMPORTED_MODULE_0__utils_uuid__["b" /* uuid */].generate(),
            }); },
        },
    ],
    toDOM: function (node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0',
        };
        return ['ol', attrs, 0];
    },
};
//# sourceMappingURL=decision-list.js.map

/***/ }),
/* 1665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return decisionItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_uuid__ = __webpack_require__(191);

var decisionItem = {
    content: 'inline*',
    defining: true,
    marks: '_',
    attrs: {
        localId: { default: '' },
        state: { default: 'DECIDED' },
    },
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function (dom) { return ({
                localId: __WEBPACK_IMPORTED_MODULE_0__utils_uuid__["b" /* uuid */].generate(),
                state: dom.getAttribute('data-decision-state'),
            }); },
        },
    ],
    toDOM: function (node) {
        var _a = node.attrs, localId = _a.localId, state = _a.state;
        var attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state,
        };
        return ['li', attrs, 0];
    },
};
//# sourceMappingURL=decision-item.js.map

/***/ }),
/* 1666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return taskList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_uuid__ = __webpack_require__(191);

var taskList = {
    group: 'block',
    defining: true,
    content: 'taskItem+',
    attrs: {
        localId: { default: '' },
    },
    parseDOM: [
        {
            tag: 'ol[data-task-list-local-id]',
            // Default priority is 50. We normaly don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function () { return ({
                localId: __WEBPACK_IMPORTED_MODULE_0__utils_uuid__["b" /* uuid */].generate(),
            }); },
        },
    ],
    toDOM: function (node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0',
        };
        return ['ol', attrs, 0];
    },
};
//# sourceMappingURL=task-list.js.map

/***/ }),
/* 1667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return taskItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_uuid__ = __webpack_require__(191);

var taskItem = {
    content: 'inline*',
    defining: true,
    marks: '_',
    attrs: {
        localId: { default: '' },
        state: { default: 'TODO' },
    },
    parseDOM: [
        {
            tag: 'li[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function (dom) { return ({
                localId: __WEBPACK_IMPORTED_MODULE_0__utils_uuid__["b" /* uuid */].generate(),
                state: dom.getAttribute('data-task-state') || 'TODO',
            }); },
        },
    ],
    toDOM: function (node) {
        var _a = node.attrs, localId = _a.localId, state = _a.state;
        var attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO',
        };
        return ['li', attrs, 0];
    },
};
//# sourceMappingURL=task-item.js.map

/***/ }),
/* 1668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return extension; });
var extension = {
    inline: false,
    group: 'block',
    atom: true,
    selectable: true,
    attrs: {
        extensionType: { default: '' },
        extensionKey: { default: '' },
        parameters: { default: null },
        text: { default: null },
        layout: { default: 'default' },
    },
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            getAttrs: function (domNode) {
                var dom = domNode;
                return {
                    extensionType: dom.getAttribute('data-extension-type'),
                    extensionKey: dom.getAttribute('data-extension-key'),
                    text: dom.getAttribute('data-text'),
                    parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
                    layout: dom.getAttribute('data-layout') || 'default',
                };
            },
        },
    ],
    toDOM: function (node) {
        var attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
        };
        return ['div', attrs];
    },
};
//# sourceMappingURL=extension.js.map

/***/ }),
/* 1669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return inlineExtension; });
var inlineExtension = {
    inline: true,
    group: 'inline',
    selectable: true,
    attrs: {
        extensionType: { default: '' },
        extensionKey: { default: '' },
        parameters: { default: null },
        text: { default: null },
    },
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            getAttrs: function (domNode) {
                var dom = domNode;
                return {
                    extensionType: dom.getAttribute('data-extension-type'),
                    extensionKey: dom.getAttribute('data-extension-key'),
                    text: dom.getAttribute('data-text'),
                    parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
                };
            },
        },
    ],
    toDOM: function (node) {
        var attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
        };
        return ['span', attrs];
    },
};
//# sourceMappingURL=inline-extension.js.map

/***/ }),
/* 1670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bodiedExtension; });
var bodiedExtension = {
    inline: false,
    group: 'block',
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | applicationCard | decisionList | taskList | table | blockCard | extension | unsupportedBlock)+',
    defining: true,
    selectable: true,
    isolating: true,
    attrs: {
        extensionType: { default: '' },
        extensionKey: { default: '' },
        parameters: { default: null },
        text: { default: null },
        layout: { default: 'default' },
    },
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true,
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            getAttrs: function (domNode) {
                var dom = domNode;
                return {
                    extensionType: dom.getAttribute('data-extension-type'),
                    extensionKey: dom.getAttribute('data-extension-key'),
                    text: dom.getAttribute('data-text'),
                    parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
                    layout: dom.getAttribute('data-layout') || 'default',
                };
            },
        },
    ],
    toDOM: function (node) {
        var attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
        };
        return ['div', attrs, 0];
    },
};
//# sourceMappingURL=bodied-extension.js.map

/***/ }),
/* 1671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return date; });
var date = {
    inline: true,
    group: 'inline',
    selectable: true,
    attrs: {
        timestamp: { default: '' },
    },
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: function (dom) { return ({
                timestamp: dom.getAttribute('data-timestamp'),
            }); },
        },
    ],
    toDOM: function (node) {
        var attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp,
        };
        return ['span', attrs];
    },
};
//# sourceMappingURL=date.js.map

/***/ }),
/* 1672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placeholder; });
var placeholder = {
    inline: true,
    group: 'inline',
    selectable: false,
    marks: '',
    attrs: {
        text: { default: '' },
    },
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: function (dom) { return ({
                text: dom.getAttribute('data-placeholder') ||
                    placeholder.attrs.text.default,
            }); },
        },
    ],
    toDOM: function (node) {
        var text = node.attrs.text;
        var attrs = {
            'data-placeholder': text,
            contenteditable: 'false',
        };
        return ['span', attrs, text];
    },
};
//# sourceMappingURL=placeholder.js.map

/***/ }),
/* 1673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return layoutSection; });
var layoutSection = {
    content: 'layoutColumn{2,3}',
    isolating: true,
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true,
        },
        {
            tag: 'div[data-layout-section]',
        },
    ],
    toDOM: function () {
        var attrs = { 'data-layout-section': 'true' };
        return ['div', attrs, 0];
    },
};
//# sourceMappingURL=layout-section.js.map

/***/ }),
/* 1674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return layoutColumn; });
var layoutColumn = {
    content: 'block+',
    isolating: true,
    marks: 'alignment',
    attrs: {
        width: {
            default: undefined,
        },
    },
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true,
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: function (domNode) {
                var dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined,
                };
            },
        },
    ],
    toDOM: function (node) {
        var attrs = { 'data-layout-column': 'true' };
        var width = node.attrs.width;
        if (width) {
            attrs['style'] = "flex-basis: " + width + "%";
            attrs['data-column-width'] = width;
        }
        return ['div', attrs, 0];
    },
};
//# sourceMappingURL=layout-column.js.map

/***/ }),
/* 1675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return inlineCard; });
var inlineCard = {
    inline: true,
    group: 'inline',
    selectable: true,
    attrs: {
        url: { default: '' },
        data: { default: null },
    },
    parseDOM: [
        {
            tag: 'span[data-card-url]',
            getAttrs: function (dom) { return ({
                url: dom.getAttribute('data-card-url'),
                data: JSON.parse(dom.getAttribute('data-card-data') || '{}'),
            }); },
        },
    ],
    toDOM: function (node) {
        var attrs = {
            'data-card-url': node.attrs.url,
            'data-card-data': JSON.stringify(node.attrs.data),
        };
        return ['span', attrs];
    },
};
//# sourceMappingURL=inline-card.js.map

/***/ }),
/* 1676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return blockCard; });
var blockCard = {
    inline: false,
    group: 'block',
    attrs: {
        url: { default: '' },
        data: { default: null },
    },
    parseDOM: [
        {
            tag: 'div[data-block-card-url]',
            getAttrs: function (dom) { return ({
                url: dom.getAttribute('data-block-card-url'),
                data: JSON.parse(dom.getAttribute('data-block-card-data') || '{}'),
            }); },
        },
    ],
    toDOM: function (node) {
        var attrs = {
            'data-block-card-url': node.attrs.url,
            'data-block-card-data': JSON.stringify(node.attrs.data),
        };
        return ['div', attrs];
    },
};
//# sourceMappingURL=block-card.js.map

/***/ }),
/* 1677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return unsupportedBlock; });
var unsupportedBlock = {
    inline: false,
    group: 'block',
    atom: true,
    selectable: true,
    attrs: {
        originalValue: { default: {} },
    },
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: function (dom) { return ({
                originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}'),
            }); },
        },
    ],
    toDOM: function (node) {
        var attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue),
        };
        return ['div', attrs, 'Unsupported content'];
    },
};
//# sourceMappingURL=unsupported-block.js.map

/***/ }),
/* 1678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return unsupportedInline; });
var unsupportedInline = {
    inline: true,
    group: 'inline',
    selectable: true,
    attrs: {
        originalValue: { default: {} },
    },
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: function (dom) { return ({
                originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}'),
            }); },
        },
    ],
    toDOM: function (node) {
        var attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue),
        };
        return ['span', attrs, 'Unsupported content'];
    },
};
//# sourceMappingURL=unsupported-inline.js.map

/***/ }),
/* 1679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return status; });
var status = {
    inline: true,
    group: 'inline',
    selectable: true,
    attrs: {
        text: { default: '' },
        color: { default: '' },
        localId: { default: '' },
        style: { default: null },
    },
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: function (domNode) {
                var dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, '').trim(),
                    color: dom.getAttribute('data-color'),
                    localId: dom.getAttribute('data-local-id'),
                    style: dom.getAttribute('data-style'),
                };
            },
        },
    ],
    toDOM: function (node) {
        var _a = node.attrs, text = _a.text, color = _a.color, localId = _a.localId, style = _a.style;
        var attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
        };
        return ['span', attrs, text];
    },
};
//# sourceMappingURL=status.js.map

/***/ }),
/* 1680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return em; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__groups__ = __webpack_require__(66);

var emDOM = ['em'];
var em = {
    inclusive: true,
    group: __WEBPACK_IMPORTED_MODULE_0__groups__["c" /* FONT_STYLE */],
    parseDOM: [{ tag: 'i' }, { tag: 'em' }, { style: 'font-style=italic' }],
    toDOM: function () {
        return emDOM;
    },
};
//# sourceMappingURL=em.js.map

/***/ }),
/* 1681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return code; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__groups__ = __webpack_require__(66);

var code = {
    excludes: __WEBPACK_IMPORTED_MODULE_0__groups__["c" /* FONT_STYLE */] + " " + __WEBPACK_IMPORTED_MODULE_0__groups__["e" /* LINK */] + " " + __WEBPACK_IMPORTED_MODULE_0__groups__["f" /* SEARCH_QUERY */] + " " + __WEBPACK_IMPORTED_MODULE_0__groups__["b" /* COLOR */],
    inclusive: true,
    parseDOM: [
        { tag: 'span.code', preserveWhitespace: true },
        { tag: 'code', preserveWhitespace: true },
        { tag: 'tt', preserveWhitespace: true },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: function (domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre') {
                    return {};
                }
                if (dom.style.fontFamily &&
                    dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) {
                    return {};
                }
                return false;
            },
        },
    ],
    toDOM: function () {
        return [
            'span',
            {
                style: 'white-space: pre-wrap;',
                class: 'code',
            },
        ];
    },
};
//# sourceMappingURL=code.js.map

/***/ }),
/* 1682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return strike; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__groups__ = __webpack_require__(66);

var strike = {
    inclusive: true,
    group: __WEBPACK_IMPORTED_MODULE_0__groups__["c" /* FONT_STYLE */],
    parseDOM: [
        { tag: 'strike' },
        { tag: 's' },
        { tag: 'del' },
        {
            style: 'text-decoration',
            getAttrs: function (value) { return value === 'line-through' && null; },
        },
    ],
    toDOM: function () {
        return ['s'];
    },
};
//# sourceMappingURL=strike.js.map

/***/ }),
/* 1683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return strong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__groups__ = __webpack_require__(66);

var strongDOM = ['strong'];
var strong = {
    inclusive: true,
    group: __WEBPACK_IMPORTED_MODULE_0__groups__["c" /* FONT_STYLE */],
    parseDOM: [
        { tag: 'strong' },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs: function (node) {
                var element = node;
                return element.style.fontWeight !== 'normal' && null;
            },
        },
        {
            style: 'font-weight',
            getAttrs: function (value) {
                return (typeof value === 'string' &&
                    /^(bold(er)?|[5-9]\d{2,})$/.test(value) &&
                    null);
            },
        },
    ],
    toDOM: function () {
        return strongDOM;
    },
};
//# sourceMappingURL=strong.js.map

/***/ }),
/* 1684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return underline; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__groups__ = __webpack_require__(66);

var underline = {
    inclusive: true,
    group: __WEBPACK_IMPORTED_MODULE_0__groups__["c" /* FONT_STYLE */],
    parseDOM: [
        { tag: 'u' },
        {
            style: 'text-decoration',
            getAttrs: function (value) { return value === 'underline' && null; },
        },
    ],
    toDOM: function () {
        return ['u'];
    },
};
//# sourceMappingURL=underline.js.map

/***/ }),
/* 1685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toJSON; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__groups__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_url__ = __webpack_require__(635);



var link = {
    excludes: __WEBPACK_IMPORTED_MODULE_1__groups__["b" /* COLOR */],
    group: __WEBPACK_IMPORTED_MODULE_1__groups__["e" /* LINK */],
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null,
        },
    },
    inclusive: false,
    parseDOM: [
        {
            tag: 'a[href]',
            getAttrs: function (domNode) {
                var dom = domNode;
                var href = dom.getAttribute('href') || '';
                var attrs = {
                    __confluenceMetadata: dom.hasAttribute('__confluenceMetadata')
                        ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '')
                        : undefined,
                };
                if (href.slice(-1) === '/') {
                    href = href.slice(0, -1);
                }
                if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_url__["a" /* isSafeUrl */])(href)) {
                    attrs.href = Object(__WEBPACK_IMPORTED_MODULE_2__utils_url__["b" /* normalizeUrl */])(href);
                }
                else {
                    return false;
                }
                return attrs;
            },
        },
    ],
    toDOM: function (node, isInline) {
        var attrs = Object.keys(node.attrs).reduce(function (attrs, key) {
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) {
                    attrs[key] = JSON.stringify(node.attrs[key]);
                }
            }
            else {
                attrs[key] = node.attrs[key];
            }
            return attrs;
        }, {});
        if (isInline) {
            return ['a', attrs];
        }
        return [
            'a',
            __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, attrs, { class: 'blockLink' }),
            0,
        ];
    },
};
var OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata',
];
var toJSON = function (mark) { return ({
    type: mark.type.name,
    attrs: Object.keys(mark.attrs).reduce(function (attrs, key) {
        if (OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) {
            attrs[key] = mark.attrs[key];
        }
        return attrs;
    }, {}),
}); };
//# sourceMappingURL=link.js.map

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



module.exports = function (opts) {
  var re = {};

  // Use direct extract instead of `regenerate` to reduse browserified size
  re.src_Any = __webpack_require__(636).source;
  re.src_Cc  = __webpack_require__(637).source;
  re.src_Z   = __webpack_require__(638).source;
  re.src_P   = __webpack_require__(375).source;

  // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
  re.src_ZPCc = [ re.src_Z, re.src_P, re.src_Cc ].join('|');

  // \p{\Z\Cc} (white spaces + control)
  re.src_ZCc = [ re.src_Z, re.src_Cc ].join('|');

  // Experimental. List of chars, completely prohibited in links
  // because can separate it from other part of text
  var text_separators = '[><\uff5c]';

  // All possible word characters (everything without punctuation, spaces & controls)
  // Defined via punctuation & spaces to save space
  // Should be something like \p{\L\N\S\M} (\w but without `_`)
  re.src_pseudo_letter       = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
  // The same as abothe but without [0-9]
  // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';

  ////////////////////////////////////////////////////////////////////////////////

  re.src_ip4 =

    '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';

  // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
  re.src_auth    = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';

  re.src_port =

    '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';

  re.src_host_terminator =

    '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';

  re.src_path =

    '(?:' +
      '[/?#]' +
        '(?:' +
          '(?!' + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' +
          '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' +
          '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' +
          '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' +
          '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' +
          "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" +
          "\\'(?=" + re.src_pseudo_letter + '|[-]).|' +  // allow `I'm_king` if no pair found
          '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
                                     // - english
                                     // - percent-encoded
                                     // - parts of file path
                                     // until more examples found.
          '\\.(?!' + re.src_ZCc + '|[.]).|' +
          (opts && opts['---'] ?
            '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
            :
            '\\-+|'
          ) +
          '\\,(?!' + re.src_ZCc + ').|' +      // allow `,,,` in paths
          '\\!(?!' + re.src_ZCc + '|[!]).|' +
          '\\?(?!' + re.src_ZCc + '|[?]).' +
        ')+' +
      '|\\/' +
    ')?';

  re.src_email_name =

    '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';

  re.src_xn =

    'xn--[a-z0-9\\-]{1,59}';

  // More to read about domain names
  // http://serverfault.com/questions/638260/

  re.src_domain_root =

    // Allow letters & digits (http://test1)
    '(?:' +
      re.src_xn +
      '|' +
      re.src_pseudo_letter + '{1,63}' +
    ')';

  re.src_domain =

    '(?:' +
      re.src_xn +
      '|' +
      '(?:' + re.src_pseudo_letter + ')' +
      '|' +
      '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' +
    ')';

  re.src_host =

    '(?:' +
    // Don't need IP check, because digits are already allowed in normal domain names
    //   src_ip4 +
    // '|' +
      '(?:(?:(?:' + re.src_domain + ')\\.)*' + re.src_domain/*_root*/ + ')' +
    ')';

  re.tpl_host_fuzzy =

    '(?:' +
      re.src_ip4 +
    '|' +
      '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' +
    ')';

  re.tpl_host_no_ip_fuzzy =

    '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';

  re.src_host_strict =

    re.src_host + re.src_host_terminator;

  re.tpl_host_fuzzy_strict =

    re.tpl_host_fuzzy + re.src_host_terminator;

  re.src_host_port_strict =

    re.src_host + re.src_port + re.src_host_terminator;

  re.tpl_host_port_fuzzy_strict =

    re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;

  re.tpl_host_port_no_ip_fuzzy_strict =

    re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;


  ////////////////////////////////////////////////////////////////////////////////
  // Main rules

  // Rude test fuzzy links by host, for quick deny
  re.tpl_host_fuzzy_test =

    'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';

  re.tpl_email_fuzzy =

      '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';

  re.tpl_link_fuzzy =
      // Fuzzy link can't be prepended with .:/\- and non punctuation.
      // but can start with > (markdown blockquote)
      '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' +
      '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';

  re.tpl_link_no_ip_fuzzy =
      // Fuzzy link can't be prepended with .:/\- and non punctuation.
      // but can start with > (markdown blockquote)
      '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' +
      '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';

  return re;
};


/***/ }),
/* 1687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return emojiQuery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__groups__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_colors__ = __webpack_require__(155);


var emojiQuery = {
    inclusive: true,
    group: __WEBPACK_IMPORTED_MODULE_0__groups__["f" /* SEARCH_QUERY */],
    parseDOM: [{ tag: 'span[data-emoji-query]' }],
    toDOM: function () {
        return [
            'span',
            {
                'data-emoji-query': 'true',
                style: "color: " + __WEBPACK_IMPORTED_MODULE_1__utils_colors__["a" /* B400 */],
            },
        ];
    },
};
//# sourceMappingURL=emoji-query.js.map

/***/ }),
/* 1688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return typeAheadQuery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__groups__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_colors__ = __webpack_require__(155);


var typeAheadQuery = {
    excludes: "" + __WEBPACK_IMPORTED_MODULE_0__groups__["f" /* SEARCH_QUERY */],
    inclusive: true,
    group: __WEBPACK_IMPORTED_MODULE_0__groups__["f" /* SEARCH_QUERY */],
    parseDOM: [{ tag: 'span[data-type-ahead-query]' }],
    toDOM: function (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: "color: " + __WEBPACK_IMPORTED_MODULE_1__utils_colors__["a" /* B400 */],
            },
        ];
    },
    attrs: {
        trigger: { default: '' },
    },
};
//# sourceMappingURL=type-ahead-query.js.map

/***/ }),
/* 1689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subsup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__groups__ = __webpack_require__(66);

var subsup = {
    inclusive: true,
    group: __WEBPACK_IMPORTED_MODULE_0__groups__["c" /* FONT_STYLE */],
    attrs: { type: { default: 'sub' } },
    parseDOM: [
        { tag: 'sub', attrs: { type: 'sub' } },
        { tag: 'sup', attrs: { type: 'sup' } },
    ],
    toDOM: function (mark) {
        return [mark.attrs.type];
    },
};
//# sourceMappingURL=subsup.js.map

/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return borderColorPalette; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return colorPalette; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return textColor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__groups__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_colors__ = __webpack_require__(155);



/** New borders for colors in the color picker */
var borderColorPalette = {
    orange: __WEBPACK_IMPORTED_MODULE_2__utils_colors__["B" /* Y500 */],
    teal: __WEBPACK_IMPORTED_MODULE_2__utils_colors__["x" /* T500 */],
    red: __WEBPACK_IMPORTED_MODULE_2__utils_colors__["t" /* R500 */],
    'light-gray': __WEBPACK_IMPORTED_MODULE_2__utils_colors__["m" /* N90 */],
    purple: __WEBPACK_IMPORTED_MODULE_2__utils_colors__["p" /* P500 */],
    green: __WEBPACK_IMPORTED_MODULE_2__utils_colors__["f" /* G500 */],
};
// @see https://product-fabric.atlassian.net/wiki/spaces/E/pages/55979455/Colour+picker+decisions#Colourpickerdecisions-Visualdesigndecisions
var colorPalette = new Map();
[
    // [N800, default],
    [__WEBPACK_IMPORTED_MODULE_2__utils_colors__["l" /* N80 */], 'Light gray'],
    [__WEBPACK_IMPORTED_MODULE_2__utils_colors__["n" /* P300 */], 'Purple'],
    [__WEBPACK_IMPORTED_MODULE_2__utils_colors__["v" /* T300 */], 'Teal'],
    [__WEBPACK_IMPORTED_MODULE_2__utils_colors__["d" /* G300 */], 'Green'],
    [__WEBPACK_IMPORTED_MODULE_2__utils_colors__["r" /* R300 */], 'Red'],
    [__WEBPACK_IMPORTED_MODULE_2__utils_colors__["z" /* Y400 */], 'Orange'],
].forEach(function (_a) {
    var _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](_a, 2), color = _b[0], label = _b[1];
    return colorPalette.set(color.toLowerCase(), label);
});
var textColor = {
    attrs: { color: {} },
    inclusive: true,
    group: __WEBPACK_IMPORTED_MODULE_1__groups__["b" /* COLOR */],
    parseDOM: [
        {
            style: 'color',
            getAttrs: function (maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match(/^rgb/i)) {
                    hexColor = Object(__WEBPACK_IMPORTED_MODULE_2__utils_colors__["F" /* rgbToHex */])(value);
                }
                else if (value[0] === '#') {
                    hexColor = value.toLowerCase();
                }
                // else handle other colour formats
                return colorPalette.has(hexColor) ? { color: hexColor } : false;
            },
        },
    ],
    toDOM: function (mark) {
        return [
            'span',
            {
                style: "color: " + mark.attrs.color,
            },
        ];
    },
};
//# sourceMappingURL=text-color.js.map

/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return confluenceInlineComment; });
var confluenceInlineComment = {
    inclusive: false,
    excludes: '',
    attrs: {
        reference: {
            default: '',
        },
    },
    parseDOM: [{ tag: 'span[data-mark-type="confluenceInlineComment"]' }],
    toDOM: function (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference,
            },
        ];
    },
};
//# sourceMappingURL=confluence-inline-comment.js.map

/***/ }),
/* 1692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return action; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__groups__ = __webpack_require__(66);

var action = {
    excludes: __WEBPACK_IMPORTED_MODULE_0__groups__["b" /* COLOR */],
    group: __WEBPACK_IMPORTED_MODULE_0__groups__["e" /* LINK */],
    attrs: {
        key: { default: null },
        title: { default: null },
        target: { default: null },
        parameters: { default: null },
    },
    inclusive: false,
    parseDOM: [
        {
            tag: 'span[data-mark-type="action"]',
            getAttrs: function (dom) {
                var key = dom.getAttribute('data-action-mark-key');
                var targetReceiver = dom.getAttribute('data-action-mark-target-receiver');
                var targetKey = dom.getAttribute('data-action-mark-target-key');
                var title = dom.getAttribute('data-action-mark-title');
                return {
                    key: key,
                    title: title,
                    target: {
                        receiver: targetReceiver,
                        key: targetKey,
                    },
                };
            },
        },
    ],
    toDOM: function (node) {
        var _a = node.attrs, title = _a.title, key = _a.key, target = _a.target;
        return [
            'span',
            {
                'data-mark-type': 'action',
                'data-action-mark-key': key,
                'data-action-mark-title': title,
                'data-action-mark-target-receiver': target && target.receiver,
                'data-action-mark-target-key': target && target.key,
            },
        ];
    },
};
//# sourceMappingURL=action.js.map

/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return breakout; });
var allowedTypes = ['wide', 'full-width'];
var breakout = {
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs: function (dom) {
                var mode = dom.getAttribute('data-mode');
                return {
                    mode: allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                };
            },
        },
    ],
    attrs: {
        mode: { default: 'wide' },
    },
    toDOM: function (mark) {
        return [
            'div',
            { class: 'fabric-editor-breakout-mark', 'data-mode': mark.attrs.mode },
            0,
        ];
    },
};
//# sourceMappingURL=breakout.js.map

/***/ }),
/* 1694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return alignmentPositionMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alignment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__groups__ = __webpack_require__(66);

/** TODO: Flip these positions for RTL */
var alignmentPositionMap = {
    end: 'right',
    right: 'end',
    center: 'center',
};
var alignment = {
    excludes: "alignment " + __WEBPACK_IMPORTED_MODULE_0__groups__["d" /* INDENTATION */],
    group: __WEBPACK_IMPORTED_MODULE_0__groups__["a" /* ALIGNMENT */],
    attrs: {
        align: {},
    },
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: function (dom) {
                var align = dom.getAttribute('data-align');
                return align ? { align: align } : false;
            },
        },
    ],
    toDOM: function (mark) {
        return [
            'div',
            {
                class: "fabric-editor-block-mark fabric-editor-align-" + mark.attrs.align,
                'data-align': mark.attrs.align,
            },
            0,
        ];
    },
};
//# sourceMappingURL=alignment.js.map

/***/ }),
/* 1695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return indentation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__groups__ = __webpack_require__(66);

var indentation = {
    excludes: "indentation " + __WEBPACK_IMPORTED_MODULE_0__groups__["a" /* ALIGNMENT */],
    group: __WEBPACK_IMPORTED_MODULE_0__groups__["d" /* INDENTATION */],
    attrs: {
        level: {},
    },
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs: function (dom) {
                var level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level,
                };
            },
        },
    ],
    toDOM: function (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level,
            },
            0,
        ];
    },
};
//# sourceMappingURL=indentation.js.map

/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export unsupportedNodeTypesForMediaCards */
var unsupportedNodeTypesForMediaCards = new Set([
    'decisionItem',
    'taskItem',
]);
//# sourceMappingURL=unsupported.js.map

/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return inlineNodes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nodes__ = __webpack_require__(374);

var inlineNodes = new Set(Object.keys(__WEBPACK_IMPORTED_MODULE_0__nodes__).filter(function (key) { return __WEBPACK_IMPORTED_MODULE_0__nodes__[key] && __WEBPACK_IMPORTED_MODULE_0__nodes__[key].group === 'inline'; }));
//# sourceMappingURL=inline-nodes.js.map

/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bitbucketSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create_schema__ = __webpack_require__(192);

var bitbucketSchema = Object(__WEBPACK_IMPORTED_MODULE_0__create_schema__["a" /* createSchema */])({
    nodes: [
        'doc',
        'paragraph',
        'text',
        'bulletList',
        'orderedList',
        'listItem',
        'heading',
        'blockquote',
        'codeBlock',
        'hardBreak',
        'rule',
        'image',
        'media',
        'mediaSingle',
        'mention',
        'emoji',
        'table',
        'tableCell',
        'tableHeader',
        'tableRow',
    ],
    marks: [
        'em',
        'strong',
        'strike',
        'link',
        'mentionQuery',
        'emojiQuery',
        'code',
    ],
});
//# sourceMappingURL=bitbucket-schema.js.map

/***/ }),
/* 1699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export confluenceSchema */
/* unused harmony export confluenceSchemaWithMediaSingle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create_schema__ = __webpack_require__(192);

var nodes = [
    'doc',
    'paragraph',
    'blockquote',
    'codeBlock',
    'panel',
    'hardBreak',
    'orderedList',
    'bulletList',
    'heading',
    'mediaGroup',
    'mediaSingle',
    'media',
    'confluenceUnsupportedBlock',
    'confluenceJiraIssue',
    'extension',
    'inlineExtension',
    'bodiedExtension',
    'listItem',
    'mention',
    'text',
    'confluenceUnsupportedInline',
    'media',
    'rule',
    'table',
    'tableCell',
    'tableHeader',
    'tableRow',
    'emoji',
    'taskList',
    'taskItem',
    'date',
    'placeholder',
    'decisionList',
    'decisionItem',
    'layoutSection',
    'layoutColumn',
    'inlineCard',
    'unsupportedBlock',
    'unsupportedInline',
];
var marks = [
    'link',
    'em',
    'strong',
    'strike',
    'subsup',
    'underline',
    'mentionQuery',
    'code',
    'textColor',
    'confluenceInlineComment',
];
var confluenceSchema = Object(__WEBPACK_IMPORTED_MODULE_0__create_schema__["a" /* createSchema */])({ nodes: nodes, marks: marks });
var confluenceSchemaWithMediaSingle = Object(__WEBPACK_IMPORTED_MODULE_0__create_schema__["a" /* createSchema */])({
    nodes: nodes.concat('mediaSingle'),
    marks: marks,
});
//# sourceMappingURL=confluence-schema.js.map

/***/ }),
/* 1700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultSchema; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create_schema__ = __webpack_require__(192);

var defaultSchema = Object(__WEBPACK_IMPORTED_MODULE_0__create_schema__["a" /* createSchema */])({
    nodes: [
        'applicationCard',
        'doc',
        'paragraph',
        'text',
        'bulletList',
        'orderedList',
        'listItem',
        'heading',
        'blockquote',
        'codeBlock',
        'panel',
        'rule',
        'image',
        'mention',
        'media',
        'mediaGroup',
        'mediaSingle',
        'confluenceUnsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceJiraIssue',
        'extension',
        'inlineExtension',
        'bodiedExtension',
        'hardBreak',
        'emoji',
        'table',
        'tableCell',
        'tableHeader',
        'tableRow',
        'decisionList',
        'decisionItem',
        'taskList',
        'taskItem',
        'unknownBlock',
        'date',
        'status',
        'placeholder',
        'layoutSection',
        'layoutColumn',
        'inlineCard',
        'blockCard',
        'unsupportedBlock',
        'unsupportedInline',
    ],
    marks: [
        'action',
        'link',
        'em',
        'strong',
        'strike',
        'subsup',
        'underline',
        'code',
        'mentionQuery',
        'emojiQuery',
        'textColor',
        'confluenceInlineComment',
        'breakout',
        'alignment',
        'indentation',
    ],
});
//# sourceMappingURL=default-schema.js.map

/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export isSchemaWithLists */
/* unused harmony export isSchemaWithMentions */
/* unused harmony export isSchemaWithEmojis */
/* unused harmony export isSchemaWithLinks */
/* unused harmony export isSchemaWithAdvancedTextFormattingMarks */
/* unused harmony export isSchemaWithSubSupMark */
/* unused harmony export isSchemaWithCodeBlock */
/* unused harmony export isSchemaWithBlockQuotes */
/* unused harmony export isSchemaWithMedia */
/* unused harmony export isSchemaWithTextColor */
/* unused harmony export isSchemaWithTables */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create_schema__ = __webpack_require__(192);

function makeSchema(config) {
    var nodes = ['doc', 'paragraph', 'text', 'hardBreak', 'heading', 'rule'];
    var marks = ['strong', 'em', 'underline', 'typeAheadQuery'];
    if (config.allowLinks) {
        marks.push('link');
    }
    if (config.allowLists) {
        nodes.push('orderedList', 'bulletList', 'listItem');
    }
    if (config.allowMentions) {
        nodes.push('mention');
        marks.push('mentionQuery');
    }
    if (config.allowEmojis) {
        nodes.push('emoji');
    }
    if (config.allowAdvancedTextFormatting) {
        marks.push('strike', 'code');
    }
    if (config.allowSubSup) {
        marks.push('subsup');
    }
    if (config.allowCodeBlock) {
        nodes.push('codeBlock');
    }
    if (config.allowBlockQuote) {
        nodes.push('blockquote');
    }
    if (config.allowMedia) {
        nodes.push('mediaGroup', 'mediaSingle', 'media');
    }
    if (config.allowTextColor) {
        marks.push('textColor');
    }
    if (config.allowTables) {
        nodes.push('table', 'tableCell', 'tableHeader', 'tableRow');
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__create_schema__["a" /* createSchema */])({ nodes: nodes, marks: marks });
}
function isSchemaWithLists(schema) {
    return !!schema.nodes.bulletList;
}
function isSchemaWithMentions(schema) {
    return !!schema.nodes.mention;
}
function isSchemaWithEmojis(schema) {
    return !!schema.nodes.emoji;
}
function isSchemaWithLinks(schema) {
    return !!schema.marks.link;
}
function isSchemaWithAdvancedTextFormattingMarks(schema) {
    return !!schema.marks.code && !!schema.marks.strike;
}
function isSchemaWithSubSupMark(schema) {
    return !!schema.marks.subsup;
}
function isSchemaWithCodeBlock(schema) {
    return !!schema.nodes.codeBlock;
}
function isSchemaWithBlockQuotes(schema) {
    return !!schema.nodes.blockquote;
}
function isSchemaWithMedia(schema) {
    return !!schema.nodes.mediaGroup && !!schema.nodes.media;
}
function isSchemaWithTextColor(schema) {
    return !!schema.marks.textColor;
}
function isSchemaWithTables(schema) {
    return (!!schema.nodes.table &&
        !!schema.nodes.tableCell &&
        !!schema.nodes.tableHeader &&
        !!schema.nodes.tableRow);
}
//# sourceMappingURL=jira-schema.js.map

/***/ }),
/* 1702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__confluence_emoji__ = __webpack_require__(633);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uuid__ = __webpack_require__(191);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__uuid__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__uuid__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__colors__ = __webpack_require__(155);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__url__ = __webpack_require__(635);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__url__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__languageList__ = __webpack_require__(1703);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__languageList__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__languageList__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__languageList__["c"]; });





//# sourceMappingURL=index.js.map

/***/ }),
/* 1703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_LANGUAGES; });
/* unused harmony export findMatchedLanguage */
/* unused harmony export filterSupportedLanguages */
/* harmony export (immutable) */ __webpack_exports__["c"] = getLanguageIdentifier;
/* harmony export (immutable) */ __webpack_exports__["b"] = createLanguageList;
// We expect alias[0] to be used for the ADF attribute, see ED-2813
var DEFAULT_LANGUAGES = [
    { name: 'ABAP', alias: ['abap'] },
    { name: 'ActionScript', alias: ['actionscript', 'actionscript3', 'as'] },
    { name: 'Ada', alias: ['ada', 'ada95', 'ada2005'] },
    { name: 'AppleScript', alias: ['applescript'] },
    { name: 'Arduino', alias: ['arduino'] },
    { name: 'Autoit', alias: ['autoit'] },
    { name: 'C', alias: ['c'] },
    { name: 'C++', alias: ['c++', 'cpp'] },
    { name: 'Clojure', alias: ['clojure', 'clj'] },
    { name: 'CoffeeScript', alias: ['coffeescript', 'coffee-script', 'coffee'] },
    { name: 'ColdFusion', alias: ['coldfusion'] },
    { name: 'CSharp', alias: ['csharp', 'c#'] },
    { name: 'CSS', alias: ['css'] },
    { name: 'CUDA', alias: ['cuda', 'cu'] },
    { name: 'D', alias: ['d'] },
    { name: 'Dart', alias: ['dart'] },
    { name: 'Delphi', alias: ['delphi', 'pas', 'pascal', 'objectpascal'] },
    { name: 'Diff', alias: ['diff'] },
    { name: 'Elixir', alias: ['elixir', 'ex', 'exs'] },
    { name: 'Erlang', alias: ['erlang', 'erl'] },
    { name: 'Fortran', alias: ['fortran'] },
    { name: 'FoxPro', alias: ['foxpro', 'vfp', 'clipper', 'xbase'] },
    { name: 'Go', alias: ['go'] },
    { name: 'Groovy', alias: ['groovy'] },
    { name: 'Haskell', alias: ['haskell', 'hs'] },
    { name: 'Haxe', alias: ['haxe', 'hx', 'hxsl'] },
    { name: 'Html', alias: ['html'] },
    { name: 'Java', alias: ['java'] },
    { name: 'JavaFX', alias: ['javafx', 'jfx'] },
    { name: 'JavaScript', alias: ['javascript', 'js'] },
    { name: 'JSON', alias: ['json'] },
    { name: 'Julia', alias: ['julia', 'jl'] },
    { name: 'Kotlin', alias: ['kotlin'] },
    { name: 'LiveScript', alias: ['livescript', 'live-script'] },
    { name: 'Lua', alias: ['lua'] },
    { name: 'Mathematica', alias: ['mathematica', 'mma', 'nb'] },
    { name: 'MATLAB', alias: ['matlab'] },
    {
        name: 'Objective-C',
        alias: ['objective-c', 'objectivec', 'obj-c', 'objc'],
    },
    {
        name: 'Objective-J',
        alias: ['objective-j', 'objectivej', 'obj-j', 'objj'],
    },
    { name: 'ObjectPascal', alias: ['objectpascal'] },
    { name: 'OCaml', alias: ['ocaml'] },
    { name: 'Octave', alias: ['octave'] },
    { name: 'Perl', alias: ['perl', 'pl'] },
    { name: 'PHP', alias: ['php', 'php3', 'php4', 'php5'] },
    { name: 'PlainText', alias: ['plaintext', 'text'] },
    { name: 'PowerShell', alias: ['powershell', 'posh', 'ps1', 'psm1'] },
    { name: 'Prolog', alias: ['prolog'] },
    { name: 'Puppet', alias: ['puppet'] },
    { name: 'Python', alias: ['python', 'py'] },
    { name: 'QML', alias: ['qbs'] },
    { name: 'R', alias: ['r'] },
    { name: 'Racket', alias: ['racket', 'rkt'] },
    { name: 'reStructuredText', alias: ['restructuredtext', 'rst', 'rest'] },
    { name: 'Ruby', alias: ['ruby', 'rb', 'duby'] },
    { name: 'Rust', alias: ['rust'] },
    { name: 'Sass', alias: ['sass'] },
    { name: 'Scala', alias: ['scala'] },
    { name: 'Scheme', alias: ['scheme', 'scm'] },
    { name: 'Shell', alias: ['shell', 'bash', 'sh', 'ksh', 'zsh'] },
    { name: 'Smalltalk', alias: ['smalltalk', 'squeak', 'st'] },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite',
        ],
    },
    { name: 'StandardML', alias: ['standardmL', 'sml'] },
    { name: 'Swift', alias: ['swift'] },
    { name: 'Tcl', alias: ['tcl'] },
    { name: 'TeX', alias: ['tex', 'latex'] },
    { name: 'TypeScript', alias: ['typescript', 'ts'] },
    { name: 'Vala', alias: ['vala', 'vapi'] },
    { name: 'VbNet', alias: ['vbnet', 'vb.net'] },
    { name: 'Verilog', alias: ['verilog', 'v'] },
    { name: 'VHDL', alias: ['vhdl'] },
    { name: 'VisualBasic', alias: ['visualbasic', 'vb'] },
    { name: 'XML', alias: ['xml'] },
    { name: 'XQuery', alias: ['xquery', 'xqy', 'xq', 'xql', 'xqm'] },
];
function findMatchedLanguage(supportedLanguages, language) {
    if (!language) {
        return undefined;
    }
    var matches = supportedLanguages.filter(function (supportedLanguage) {
        return supportedLanguage.alias.indexOf(language.toLowerCase()) !== -1;
    });
    if (matches.length > 0) {
        return matches[0];
    }
    return undefined;
}
function filterSupportedLanguages(supportedLanguages) {
    if (!supportedLanguages || !supportedLanguages.length) {
        return DEFAULT_LANGUAGES;
    }
    return DEFAULT_LANGUAGES.filter(function (language) {
        var i = language.alias.length;
        while (i--) {
            if (supportedLanguages.indexOf(language.alias[i]) > -1) {
                return true;
            }
        }
        return false;
    });
}
function getLanguageIdentifier(language) {
    return language.alias[0];
}
function createLanguageList(supportedLanguages) {
    return supportedLanguages.sort(function (left, right) {
        if (left.name > right.name) {
            return 1;
        }
        if (left.name < right.name) {
            return -1;
        }
        return 0;
    });
}
//# sourceMappingURL=languageList.js.map

/***/ }),
/* 1704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    ios: false,
    webkit: false,
};
if (typeof navigator !== 'undefined') {
    var ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    var ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    var ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    result.mac = /Mac/.test(navigator.platform);
    var ie = (result.ie = !!(ieUpTo10 || ie11up || ieEdge));
    result.ie_version = ieUpTo10
        ? document.documentMode || 6
        : ie11up
            ? +ie11up[1]
            : ieEdge
                ? +ieEdge[1]
                : null;
    result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    result.ios =
        !ie &&
            /AppleWebKit/.test(navigator.userAgent) &&
            /Mobile\/\w+/.test(navigator.userAgent);
    result.webkit =
        !ie &&
            !!document.documentElement &&
            'WebkitAppearance' in document.documentElement.style;
}
/* harmony default export */ __webpack_exports__["a"] = (result);
//# sourceMappingURL=browser.js.map

/***/ }),
/* 1705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ErrorReporter = /** @class */ (function () {
    function ErrorReporter() {
        this.handlerStorage = null;
    }
    ErrorReporter.prototype.captureMessage = function (msg, tags) {
        if (this.handlerStorage) {
            this.handlerStorage.captureMessage(msg, tags);
        }
    };
    ErrorReporter.prototype.captureException = function (err, tags) {
        if (this.handlerStorage) {
            this.handlerStorage.captureException(err, tags);
        }
    };
    Object.defineProperty(ErrorReporter.prototype, "handler", {
        set: function (handler) {
            this.handlerStorage = handler;
        },
        enumerable: true,
        configurable: true
    });
    return ErrorReporter;
}());
/* harmony default export */ __webpack_exports__["a"] = (ErrorReporter);
//# sourceMappingURL=error-reporter.js.map

/***/ }),
/* 1706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return timestampToUTCDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return todayTimestampInUTC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return timestampToString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return timestampToIsoFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isPastDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return timestampToTaskContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_is_before__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_is_before___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_is_before__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_difference_in_calendar_days__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_difference_in_calendar_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_difference_in_calendar_days__);


var ISO_FORMAT = 'YYYY-MM-DD';
var DEFAULT_FORMAT = 'DD MMM YYYY';
var timestampToUTCDate = function (timestamp) {
    var date = new Date(Number(timestamp));
    var day = date.getUTCDate();
    var month = date.getUTCMonth() + 1;
    var year = date.getUTCFullYear();
    return { day: day, month: month, year: year };
};
var todayTimestampInUTC = function () {
    var today = new Date();
    var todayInUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    return todayInUTC.toString();
};
var addLeadingZero = function (val) {
    if (val < 10) {
        return "0" + val;
    }
    return val;
};
var months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];
var week_days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
// example: "23 Jan 2018"
var timestampToString = function (timestamp, pattern) {
    var date = new Date(Number(timestamp));
    switch (pattern) {
        case 'ddd, DD MMM':
            return week_days[date.getUTCDay()] + ", " + addLeadingZero(date.getUTCDate()) + " " + months[date.getUTCMonth()];
        case ISO_FORMAT:
            return date.getUTCFullYear() + "-" + addLeadingZero(date.getUTCMonth() + 1) + "-" + date.getUTCDate();
        default:
            return addLeadingZero(date.getUTCDate()) + " " + months[date.getUTCMonth()] + " " + date.getUTCFullYear();
    }
};
// example: "2018-01-23"
var timestampToIsoFormat = function (timestamp) {
    return timestampToString(timestamp, ISO_FORMAT);
};
var isPastDate = function (timestamp) {
    return __WEBPACK_IMPORTED_MODULE_0_date_fns_is_before__(timestampToIsoFormat(Number(timestamp)), timestampToIsoFormat(new Date().valueOf()));
};
var timestampToTaskContext = function (timestamp) {
    var curDate = new Date();
    var givenDate = new Date(Number(timestamp));
    var distance = __WEBPACK_IMPORTED_MODULE_1_date_fns_difference_in_calendar_days__(givenDate, curDate);
    var sameYear = givenDate.getUTCFullYear() === curDate.getUTCFullYear();
    var pattern = '';
    if (distance === 0) {
        return 'Today';
    }
    else if (distance === 1) {
        return 'Tomorrow';
    }
    else if (distance === -1) {
        pattern = 'Yesterday';
    }
    else if (sameYear) {
        pattern = 'ddd, DD MMM';
    }
    else {
        pattern = DEFAULT_FORMAT;
    }
    return timestampToString(timestamp, pattern);
};
//# sourceMappingURL=date.js.map

/***/ }),
/* 1707 */
/***/ (function(module, exports) {

var MILLISECONDS_IN_MINUTE = 60000

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
module.exports = function getTimezoneOffsetInMilliseconds (dirtyDate) {
  var date = new Date(dirtyDate.getTime())
  var baseTimezoneOffset = date.getTimezoneOffset()
  date.setSeconds(0, 0)
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE

  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset
}


/***/ }),
/* 1708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withImageLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



var withImageLoader = function (Wrapped) {
    return /** @class */ (function (_super) {
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WithImageLoader, _super);
        function WithImageLoader() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = {
                imageStatus: 'loading',
            };
            _this.onLoad = function () {
                _this.setState({
                    imageStatus: 'complete',
                });
                var onExternalImageLoaded = _this.props.onExternalImageLoaded;
                if (onExternalImageLoaded && _this.img) {
                    onExternalImageLoaded({
                        width: _this.img.naturalWidth,
                        height: _this.img.naturalHeight,
                    });
                }
            };
            _this.onError = function () {
                _this.setState({
                    imageStatus: 'error',
                });
            };
            return _this;
        }
        WithImageLoader.prototype.componentDidMount = function () {
            this.fetchImage(this.props);
        };
        WithImageLoader.prototype.componentWillReceiveProps = function (nextProps) {
            if (nextProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading',
                });
                this.fetchImage(nextProps);
            }
        };
        WithImageLoader.prototype.componentWillUnmount = function () {
            if (this.img) {
                this.img.removeEventListener('load', this.onLoad);
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        };
        WithImageLoader.prototype.fetchImage = function (_a) {
            var url = _a.url;
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    this.img.addEventListener('load', this.onLoad);
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        };
        WithImageLoader.prototype.render = function () {
            var imageStatus = this.state.imageStatus;
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Wrapped, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, this.props, { imageStatus: imageStatus }));
        };
        return WithImageLoader;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
};
//# sourceMappingURL=imageLoader.js.map

/***/ }),
/* 1709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calcBreakoutWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calcWideWidth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui__ = __webpack_require__(643);


var calcBreakoutWidth = function (layout, containerWidth) {
    var effectiveFullWidth = containerWidth - __WEBPACK_IMPORTED_MODULE_0__styles__["b" /* akEditorBreakoutPadding */];
    switch (layout) {
        case 'full-width':
            return effectiveFullWidth <= __WEBPACK_IMPORTED_MODULE_0__styles__["g" /* akEditorFullPageMaxWidth */]
                ? '100%'
                : effectiveFullWidth + "px";
        case 'wide':
            return calcWideWidth(containerWidth);
        default:
            return 'inherit';
    }
};
var calcWideWidth = function (containerWidth, maxWidth, fallback) {
    if (containerWidth === void 0) { containerWidth = __WEBPACK_IMPORTED_MODULE_0__styles__["c" /* akEditorDefaultLayoutWidth */]; }
    if (maxWidth === void 0) { maxWidth = Infinity; }
    if (fallback === void 0) { fallback = '100%'; }
    var effectiveFullWidth = containerWidth - __WEBPACK_IMPORTED_MODULE_0__styles__["b" /* akEditorBreakoutPadding */];
    var layoutMaxWidth = Object(__WEBPACK_IMPORTED_MODULE_1__ui__["l" /* mapBreakpointToLayoutMaxWidth */])(Object(__WEBPACK_IMPORTED_MODULE_1__ui__["k" /* getBreakpoint */])(containerWidth));
    var wideWidth = Math.min(Math.ceil(layoutMaxWidth * __WEBPACK_IMPORTED_MODULE_0__styles__["u" /* breakoutWideScaleRatio */]), effectiveFullWidth);
    return layoutMaxWidth > wideWidth
        ? fallback
        : Math.min(maxWidth, wideWidth) + "px";
};
//# sourceMappingURL=calc-breakout-width.js.map

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(1711);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */
	var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
	var imgsrcptn = /([^-])(image-set\()/

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 105 /* <at>i */
	var CHARSET = 99 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(length++)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										++caret
										code = first
										length = eof
										break
									}
									case COLON: {
										if (format > 0) {
											++caret
											code = first
										}
									}
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							switch (code = body.charCodeAt(caret)) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
								case FOWARDSLASH: {
									switch (second = body.charCodeAt(caret + 1)) {
										// /*, //
										case STAR:
										case FOWARDSLASH: {
											caret = delimited(second, caret, eol, body)
										}
									}
									break
								}
								// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
								case OPENBRACKET: {
									code++
								}
								// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
								case OPENPARENTHESES: {
									code++
								}
								// quote tail delimiter is identical to the head delimiter hence noop,
								// fallthrough clauses have been shifted to the correct tail delimiter
								case DOUBLEQUOTE:
								case SINGLEQUOTE: {
									while (caret++ < eol) {
										if (body.charCodeAt(caret) === code) {
											break
										}
									}
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first) {
								case NULL: {
									break
								}
								case AT: {
									if (second === IMPORT || second === CHARSET) {
										flat += chars + body.charAt(caret)
										break
									}
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON) {
										break
									}

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE:
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												// :globa<l>(
												if (pseudo + 7 === caret && tail === 108) {
													pseudo = 0
												}
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
			case 1015: {
				// text-shadow/text-align/text-transform, a
				return out.charCodeAt(10) === 97 ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				if (out.charCodeAt(8) === DASH) {
					return webkit + out + out
				}

				// image-set(...)
				if (out.indexOf('image-set(', 11) > 0) {
					return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
				}

				return out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// min/max
			case 973:
			case 989: {
				// min-/max- height/width/block-size/inline-size
				if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
					break
				}
			}
			// height/width: min-content / width: max-content
			case 931:
			case 953: {
				if (dimensionptn.test(input) === true) {
					// stretch
					if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
						return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
					else
						return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}
		if (out !== content) {
		  return out
		}
	}

	/**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */
	function delimited (code, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				// /*
				case FOWARDSLASH: {
					if (code === STAR) {
						if (body.charCodeAt(i - 1) === STAR &&  index + 2 !== i) {
							return i + 1
						}
					}
					break
				}
				// //
				case NEWLINE: {
					if (code === FOWARDSLASH) {
						return i + 1
					}
				}
			}
		}

		return i
	}

	/**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */
	function match (type, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				case type: {
					return i
				}
			}
		}

		return i
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				if (typeof plugin === 'function') {
					plugins[plugged++] = plugin
				}	else if (typeof plugin === 'object') {
					for (var i = 0, length = plugin.length; i < length; ++i) {
						use(plugin[i])
					}
				} else {
					unkwn = !!plugin|0
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 1714 */
/***/ (function(module, exports) {

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

module.exports = _arrayWithoutHoles;

/***/ }),
/* 1715 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),
/* 1716 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;

/***/ }),
/* 1717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e100", function() { return e100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e200", function() { return e200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e300", function() { return e300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e400", function() { return e400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e500", function() { return e500; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(377);

 // Cards on a board

var e100 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 1px 1px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px 0 ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 1px 1px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
}); // Inline dialogs

var e200 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 4px 8px -2px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 4px 8px -2px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
}); // Modals

var e300 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 8px 16px -4px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 8px 16px -4px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
}); // Panels

var e400 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 12px 24px -6px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 12px 24px -6px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
}); // Flag messages (notifications)

var e500 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 20px 32px -8px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 20px 32px -8px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
});

/***/ }),
/* 1718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h900", function() { return h900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h800", function() { return h800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h700", function() { return h700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h600", function() { return h600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h500", function() { return h500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h400", function() { return h400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h300", function() { return h300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h200", function() { return h200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h100", function() { return h100; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colors__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(3);




var baseHeading = function baseHeading(size, lineHeight) {
  return "\n  font-size: ".concat(size / Object(__WEBPACK_IMPORTED_MODULE_2__index__["fontSize"])(), "em;\n  font-style: inherit;\n  line-height: ").concat(lineHeight / size, ";\n");
};

var h900 = function h900() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ", "px;\n"], baseHeading(35, 40), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 6.5);
};
var h800 = function h800() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ", "px;\n"], baseHeading(29, 32), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 5);
};
var h700 = function h700() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ", "px;\n"], baseHeading(24, 28), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 5);
};
var h600 = function h600() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ", "px;\n"], baseHeading(20, 24), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 3.5);
};
var h500 = function h500() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ", "px;\n"], baseHeading(16, 20), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 3);
};
var h400 = function h400() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ", "px;\n"], baseHeading(14, 16), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 2);
};
var h300 = function h300() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  margin-top: ", "px;\n  text-transform: uppercase;\n"], baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 2.5);
};
var h200 = function h200() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  margin-top: ", "px;\n"], baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_1__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 2);
};
var h100 = function h100() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 700;\n  margin-top: ", "px;\n"], baseHeading(11, 16), __WEBPACK_IMPORTED_MODULE_1__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 2);
};

/***/ }),
/* 1719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["add"] = add;
/* harmony export (immutable) */ __webpack_exports__["subtract"] = subtract;
/* harmony export (immutable) */ __webpack_exports__["multiply"] = multiply;
/* harmony export (immutable) */ __webpack_exports__["divide"] = divide;
function add(fn, addend) {
  return function (props) {
    return fn(props) + addend;
  };
}
function subtract(fn, subtrahend) {
  return function (props) {
    return fn(props) - subtrahend;
  };
}
function multiply(fn, factor) {
  return function (props) {
    return fn(props) * factor;
  };
}
function divide(fn, divisor) {
  return function (props) {
    return fn(props) / divisor;
  };
}

/***/ }),
/* 1720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AtlaskitThemeProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__colors__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Theme__ = __webpack_require__(378);











 // For forward-compat until everything is upgraded.



function getStylesheetResetCSS(state) {
  var backgroundColor = __WEBPACK_IMPORTED_MODULE_10__colors__["background"](state);
  return "\n    body { background: ".concat(backgroundColor, "; }\n  ");
}

function buildThemeState(mode) {
  return {
    theme: __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */], {
      mode: mode
    })
  };
}

var LegacyReset = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div.withConfig({
  displayName: "AtlaskitThemeProvider__LegacyReset",
  componentId: "sc-431dkp-0"
})(["\n  background-color: ", ";\n  color: ", ";\n\n  a {\n    color: ", ";\n  }\n  a:hover {\n    color: ", ";\n  }\n  a:active {\n    color: ", ";\n  }\n  a:focus {\n    outline-color: ", ";\n  }\n  h1 {\n    color: ", ";\n  }\n  h2 {\n    color: ", ";\n  }\n  h3 {\n    color: ", ";\n  }\n  h4 {\n    color: ", ";\n  }\n  h5 {\n    color: ", ";\n  }\n  h6 {\n    color: ", ";\n  }\n  small {\n    color: ", ";\n  }\n"], __WEBPACK_IMPORTED_MODULE_10__colors__["background"], __WEBPACK_IMPORTED_MODULE_10__colors__["text"], __WEBPACK_IMPORTED_MODULE_10__colors__["link"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkHover"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkActive"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkOutline"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleHeading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleText"]);

var AtlaskitThemeProvider =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(AtlaskitThemeProvider, _Component);

  function AtlaskitThemeProvider(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, AtlaskitThemeProvider);

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(AtlaskitThemeProvider).call(this, props));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "stylesheet", void 0);

    _this.state = buildThemeState(props.mode);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(AtlaskitThemeProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        hasAtlaskitThemeProvider: true
      };
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      if (!this.context.hasAtlaskitThemeProvider) {
        var css = getStylesheetResetCSS(this.state);
        this.stylesheet = document.createElement('style');
        this.stylesheet.type = 'text/css';
        this.stylesheet.innerHTML = css;

        if (document && document.head) {
          document.head.appendChild(this.stylesheet);
        }
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (newProps.mode !== this.props.mode) {
        var newThemeState = buildThemeState(newProps.mode);

        if (this.stylesheet) {
          var css = getStylesheetResetCSS(newThemeState);
          this.stylesheet.innerHTML = css;
        }

        this.setState(newThemeState);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.stylesheet && document && document.head) {
        document.head.removeChild(this.stylesheet);
        delete this.stylesheet;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var theme = this.state.theme;
      return (
        /* Wrapping the new provider around the old one provides forward
        compatibility when using the old provider for styled components. This
        allows us to use components converted to use the new API with consumers
        using the old provider along side components that may still be using the
        old theming API. */
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Theme__["a" /* default */].Provider, {
          value: function value() {
            return {
              mode: theme[__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */]].mode
            };
          }
        }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_styled_components__["ThemeProvider"], {
          theme: theme
        }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(LegacyReset, null, children)))
      );
    }
  }]);

  return AtlaskitThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AtlaskitThemeProvider, "defaultProps", {
  mode: __WEBPACK_IMPORTED_MODULE_11__constants__["b" /* DEFAULT_THEME_MODE */]
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AtlaskitThemeProvider, "childContextTypes", {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AtlaskitThemeProvider, "contextTypes", {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
});



/***/ }),
/* 1721 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 1722 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 1723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);


/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var children = _ref.children,
      props = _ref.props,
      theme = _ref.theme;
  var appearance = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(props) === 'object' ? 'default' : props;
  var merged = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(props) === 'object' ? __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, props) : {};
  Object.keys(theme).forEach(function (key) {
    if (!(key in merged)) {
      merged[key] = theme[key]({
        appearance: appearance
      });
    }
  });
  return children(merged);
});

/***/ }),
/* 1724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ResetTheme; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Reset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__colors__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_createTheme__ = __webpack_require__(379);







var orTextColor = function orTextColor(preferred) {
  return function (p) {
    return p[preferred] || p.textColor;
  };
};

var Div = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div.withConfig({
  displayName: "Reset__Div",
  componentId: "sc-15i6ali-0"
})(["\n  ", ";\n"], function (p) {
  return Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["css"])(["\n    background-color: ", ";\n    color: ", ";\n\n    a {\n      color: ", ";\n    }\n    a:hover {\n      color: ", ";\n    }\n    a:active {\n      color: ", ";\n    }\n    a:focus {\n      outline-color: ", ";\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ", ";\n    }\n    h6 {\n      color: ", ";\n    }\n    small {\n      color: ", ";\n    }\n  "], p.backgroundColor, p.textColor, orTextColor('linkColor'), orTextColor('linkColorHover'), orTextColor('linkColorActive'), orTextColor('linkColorOutline'), orTextColor('headingColor'), orTextColor('subtleHeadingColor'), orTextColor('subtleTextColor'));
});
var ResetTheme = Object(__WEBPACK_IMPORTED_MODULE_5__utils_createTheme__["a" /* createTheme */])(function () {
  return {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N0"],
    linkColor: __WEBPACK_IMPORTED_MODULE_4__colors__["B400"],
    linkColorHover: __WEBPACK_IMPORTED_MODULE_4__colors__["B300"],
    linkColorActive: __WEBPACK_IMPORTED_MODULE_4__colors__["B500"],
    linkColorOutline: __WEBPACK_IMPORTED_MODULE_4__colors__["B100"],
    headingColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N800"],
    subtleHeadingColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N200"],
    subtleTextColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N200"],
    textColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N900"]
  };
});
function Reset(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ResetTheme.Provider, {
    value: props.theme
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ResetTheme.Consumer, null, function (tokens) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Div, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, tokens, {
      mode: undefined
    }), props), props.children);
  }));
}

/***/ }),
/* 1725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Theme__ = __webpack_require__(378);


 // Pre-executes the theme and passes it as a prop to the supplied component.
// This is useful for ensuring that the current theme is accessible as props
// in styled-components.

function withTheme(InnerComponent) {
  return function ComponentWithTheme(props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Theme__["a" /* default */].Consumer, null, function (tokens) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InnerComponent, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, props, {
        theme: tokens
      }));
    });
  };
}

/***/ }),
/* 1726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return tableMarginTop; });
/* unused harmony export tableMarginBottom */
/* unused harmony export tableMarginSides */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tableCellMinWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TableSharedCssClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calcTableWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return tableSharedStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__panel__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(373);






var tableMarginTop = 24;
var tableMarginBottom = 16;
var tableMarginSides = 8;
var tableCellMinWidth = 48;
var clPrefix = 'pm-table-';
var TableSharedCssClassName = {
    TABLE_CONTAINER: clPrefix + "container",
    TABLE_NODE_WRAPPER: clPrefix + "wrapper",
    TABLE_LEFT_SHADOW: clPrefix + "with-left-shadow",
    TABLE_RIGHT_SHADOW: clPrefix + "with-right-shadow",
    TABLE_CELL_NODEVIEW_CONTENT_DOM: clPrefix + "cell-nodeview-content-dom",
};
var tableSharedStyle = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .", " {\n    position: relative;\n    margin: 0 auto ", "px;\n    box-sizing: border-box;\n\n    /**\n     * Fix block top alignment inside table cells.\n     */\n    .code-block,\n    .", ",\n    .taskItemView-content-wrap > div,\n    .decisionItemView-content-wrap > div {\n      margin-top: 0;\n    }\n  }\n  .", "[data-number-column='true'] {\n    padding-left: ", "px;\n  }\n  /* avoid applying styles to nested tables (possible via extensions) */\n  .", " > table,\n  .", " > table {\n    border-collapse: collapse;\n    margin: ", "px ", "px 0;\n    border: 1px solid ", ";\n    table-layout: fixed;\n    font-size: ", "px;\n    width: 100%;\n\n    &[data-autosize='true'] {\n      table-layout: auto;\n    }\n\n    & {\n      * {\n        box-sizing: border-box;\n      }\n\n      tbody {\n        border-bottom: none;\n      }\n      th td {\n        background-color: white;\n        font-weight: normal;\n      }\n      th,\n      td {\n        min-width: ", "px;\n        height: 3em;\n        vertical-align: top;\n        border: 1px solid ", ";\n        border-right-width: 0;\n        border-bottom-width: 0;\n        padding: 10px;\n        /* https://stackoverflow.com/questions/7517127/borders-not-shown-in-firefox-with-border-collapse-on-table-position-relative-o */\n        background-clip: padding-box;\n\n        th p:not(:first-of-type),\n        td p:not(:first-of-type) {\n          margin-top: 12px;\n        }\n      }\n      th {\n        background-color: ", ";\n        text-align: left;\n        & *:not(strong) {\n          font-weight: normal;\n        }\n        & .", " > p {\n          font-weight: bold;\n        }\n      }\n    }\n  }\n"], ["\n  .", " {\n    position: relative;\n    margin: 0 auto ", "px;\n    box-sizing: border-box;\n\n    /**\n     * Fix block top alignment inside table cells.\n     */\n    .code-block,\n    .", ",\n    .taskItemView-content-wrap > div,\n    .decisionItemView-content-wrap > div {\n      margin-top: 0;\n    }\n  }\n  .", "[data-number-column='true'] {\n    padding-left: ", "px;\n  }\n  /* avoid applying styles to nested tables (possible via extensions) */\n  .", " > table,\n  .", " > table {\n    border-collapse: collapse;\n    margin: ", "px ", "px 0;\n    border: 1px solid ", ";\n    table-layout: fixed;\n    font-size: ", "px;\n    width: 100%;\n\n    &[data-autosize='true'] {\n      table-layout: auto;\n    }\n\n    & {\n      * {\n        box-sizing: border-box;\n      }\n\n      tbody {\n        border-bottom: none;\n      }\n      th td {\n        background-color: white;\n        font-weight: normal;\n      }\n      th,\n      td {\n        min-width: ", "px;\n        height: 3em;\n        vertical-align: top;\n        border: 1px solid ", ";\n        border-right-width: 0;\n        border-bottom-width: 0;\n        padding: 10px;\n        /* https://stackoverflow.com/questions/7517127/borders-not-shown-in-firefox-with-border-collapse-on-table-position-relative-o */\n        background-clip: padding-box;\n\n        th p:not(:first-of-type),\n        td p:not(:first-of-type) {\n          margin-top: 12px;\n        }\n      }\n      th {\n        background-color: ", ";\n        text-align: left;\n        & *:not(strong) {\n          font-weight: normal;\n        }\n        & .", " > p {\n          font-weight: bold;\n        }\n      }\n    }\n  }\n"])), TableSharedCssClassName.TABLE_CONTAINER, tableMarginBottom, __WEBPACK_IMPORTED_MODULE_4__panel__["a" /* PanelSharedCssClassName */].PANEL_CONTAINER, TableSharedCssClassName.TABLE_CONTAINER, __WEBPACK_IMPORTED_MODULE_3__consts__["n" /* akEditorTableNumberColumnWidth */] - 1, TableSharedCssClassName.TABLE_CONTAINER, TableSharedCssClassName.TABLE_NODE_WRAPPER, tableMarginTop, tableMarginSides, __WEBPACK_IMPORTED_MODULE_3__consts__["l" /* akEditorTableBorder */], Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["fontSize"])(), tableCellMinWidth, __WEBPACK_IMPORTED_MODULE_3__consts__["l" /* akEditorTableBorder */], __WEBPACK_IMPORTED_MODULE_3__consts__["o" /* akEditorTableToolbar */], TableSharedCssClassName.TABLE_CELL_NODEVIEW_CONTENT_DOM);
var calcTableWidth = function (layout, containerWidth, addControllerPadding) {
    if (addControllerPadding === void 0) { addControllerPadding = true; }
    switch (layout) {
        case 'full-width':
            return containerWidth
                ? containerWidth -
                    (addControllerPadding ? __WEBPACK_IMPORTED_MODULE_3__consts__["b" /* akEditorBreakoutPadding */] : 0) + "px"
                : '100%';
        case 'wide':
            if (containerWidth) {
                var targetWidth = containerWidth - (addControllerPadding ? __WEBPACK_IMPORTED_MODULE_3__consts__["b" /* akEditorBreakoutPadding */] : 0);
                return Object(__WEBPACK_IMPORTED_MODULE_5__utils__["d" /* calcWideWidth */])(containerWidth, targetWidth, targetWidth + "px");
            }
            else {
                return __WEBPACK_IMPORTED_MODULE_3__consts__["r" /* akEditorWideLayoutWidth */] + "px";
            }
        default:
            return 'inherit';
    }
};

var templateObject_1;
//# sourceMappingURL=table.js.map

/***/ }),
/* 1727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return columnLayoutSharedStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(156);



var columnLayoutSharedStyle = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  [data-layout-section] {\n    display: flex;\n    flex-direction: row;\n    & > * {\n      flex: 1;\n      min-width: 0;\n    }\n\n    @media screen and (max-width: ", "px) {\n      flex-direction: column;\n    }\n  }\n"], ["\n  [data-layout-section] {\n    display: flex;\n    flex-direction: row;\n    & > * {\n      flex: 1;\n      min-width: 0;\n    }\n\n    @media screen and (max-width: ", "px) {\n      flex-direction: column;\n    }\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__consts__["v" /* gridMediumMaxWidth */]);

var templateObject_1;
//# sourceMappingURL=column-layout.js.map

/***/ }),
/* 1728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mediaSingleSharedStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);

// @ts-ignore: unused variable
// prettier-ignore

var mediaSingleSharedStyle = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  li .media-single {\n    margin: 0;\n  }\n\n  table .media-single {\n    margin: 0;\n  }\n\n  .media-single.image-wrap-left + .media-single.image-wrap-right,\n  .media-single.image-wrap-right + .media-single.image-wrap-left,\n  .media-single.image-wrap-left + .media-single.image-wrap-left,\n  .media-single.image-wrap-right + .media-single.image-wrap-right {\n    margin-right: 0;\n    margin-left: 0;\n  }\n"], ["\n  li .media-single {\n    margin: 0;\n  }\n\n  table .media-single {\n    margin: 0;\n  }\n\n  .media-single.image-wrap-left + .media-single.image-wrap-right,\n  .media-single.image-wrap-right + .media-single.image-wrap-left,\n  .media-single.image-wrap-left + .media-single.image-wrap-left,\n  .media-single.image-wrap-right + .media-single.image-wrap-right {\n    margin-right: 0;\n    margin-left: 0;\n  }\n"])));

var templateObject_1;
//# sourceMappingURL=media-single.js.map

/***/ }),
/* 1729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return blockquoteSharedStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(156);

// @ts-ignore: unused variable



var blockquoteSharedStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  & blockquote {\n    box-sizing: border-box;\n    padding-left: ", "px;\n    border-left: 2px solid ", ";\n    margin: ", " 0 0 0;\n    margin-right: 0;\n\n    [dir='rtl'] & {\n      padding-left: 0;\n      padding-right: ", "px;\n    }\n\n    &:first-child {\n      margin-top: 0;\n    }\n\n    &::before {\n      content: '';\n    }\n\n    &::after {\n      content: none;\n    }\n\n    & p {\n      display: block;\n    }\n\n    & table,\n    & table:last-child {\n      display: inline-table;\n    }\n  }\n"], ["\n  & blockquote {\n    box-sizing: border-box;\n    padding-left: ", "px;\n    border-left: 2px solid ", ";\n    margin: ", " 0 0 0;\n    margin-right: 0;\n\n    [dir='rtl'] & {\n      padding-left: 0;\n      padding-right: ", "px;\n    }\n\n    &:first-child {\n      margin-top: 0;\n    }\n\n    &::before {\n      content: '';\n    }\n\n    &::after {\n      content: none;\n    }\n\n    & p {\n      display: block;\n    }\n\n    & table,\n    & table:last-child {\n      display: inline-table;\n    }\n  }\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() * 2, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* akEditorBlockquoteBorderColor */], __WEBPACK_IMPORTED_MODULE_3__consts__["s" /* blockNodesVerticalMargin */], Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() * 2);
var templateObject_1;
//# sourceMappingURL=blockquote.js.map

/***/ }),
/* 1730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return headingsSharedStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);

// @ts-ignore: unused variable
// prettier-ignore

// @see typography spreadsheet: https://docs.google.com/spreadsheets/d/1iYusRGCT4PoPfvxbJ8NrgjtfFgXLm5lpDWXzjua1W2E/edit#gid=93913128
// text sizing prototype: http://proto/fabricrender/
var headingsSharedStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  & h1 {\n    line-height: 1.166;\n    font-size: 1.714em;\n    margin-top: 2.857em;\n    margin-bottom: 0;\n  }\n\n  & h2 {\n    line-height: 1.2;\n    font-size: 1.43em;\n    margin-top: 2.571em;\n    margin-bottom: 0;\n  }\n\n  & h3 {\n    line-height: 1.5;\n    font-size: 1.142em;\n    margin-top: 2.585em;\n    margin-bottom: 0;\n  }\n\n  & h4 {\n    line-height: 1.428;\n    font-size: 1em;\n    margin-top: 1.714em;\n  }\n\n  & h5 {\n    line-height: 1.333;\n    font-size: 0.857em;\n    margin-top: 1.43em;\n  }\n\n  & h6 {\n    line-height: 1.454;\n    font-size: 0.785em;\n    margin-top: 1.42em;\n  }\n"], ["\n  & h1 {\n    line-height: 1.166;\n    font-size: 1.714em;\n    margin-top: 2.857em;\n    margin-bottom: 0;\n  }\n\n  & h2 {\n    line-height: 1.2;\n    font-size: 1.43em;\n    margin-top: 2.571em;\n    margin-bottom: 0;\n  }\n\n  & h3 {\n    line-height: 1.5;\n    font-size: 1.142em;\n    margin-top: 2.585em;\n    margin-bottom: 0;\n  }\n\n  & h4 {\n    line-height: 1.428;\n    font-size: 1em;\n    margin-top: 1.714em;\n  }\n\n  & h5 {\n    line-height: 1.333;\n    font-size: 0.857em;\n    margin-top: 1.43em;\n  }\n\n  & h6 {\n    line-height: 1.454;\n    font-size: 0.785em;\n    margin-top: 1.42em;\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=headings.js.map

/***/ }),
/* 1731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ruleSharedStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);

// @ts-ignore: unused variable


// @see typography spreadsheet: https://docs.google.com/spreadsheets/d/1iYusRGCT4PoPfvxbJ8NrgjtfFgXLm5lpDWXzjua1W2E/edit#gid=93913128
var ruleSharedStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  & hr {\n    border: none;\n    background-color: ", ";\n    margin: 1.714em 0;\n    height: 2px;\n    border-radius: 1px;\n\n    &.ProseMirror-selectednode {\n      outline: none;\n      background-color: ", ";\n    }\n  }\n"], ["\n  & hr {\n    border: none;\n    background-color: ", ";\n    margin: 1.714em 0;\n    height: 2px;\n    border-radius: 1px;\n\n    &.ProseMirror-selectednode {\n      outline: none;\n      background-color: ", ";\n    }\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30A, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B300);
var templateObject_1;
//# sourceMappingURL=rule.js.map

/***/ }),
/* 1732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return paragraphSharedStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(156);

// @ts-ignore: unused variable


// @see typography spreadsheet: https://docs.google.com/spreadsheets/d/1iYusRGCT4PoPfvxbJ8NrgjtfFgXLm5lpDWXzjua1W2E/edit#gid=93913128
var paragraphSharedStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  & p {\n    font-size: 1em;\n    line-height: 1.714;\n    font-weight: normal;\n    margin-top: ", ";\n    margin-bottom: 0;\n    letter-spacing: -0.005em;\n  }\n"], ["\n  & p {\n    font-size: 1em;\n    line-height: 1.714;\n    font-weight: normal;\n    margin-top: ", ";\n    margin-bottom: 0;\n    letter-spacing: -0.005em;\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__consts__["s" /* blockNodesVerticalMargin */]);
var templateObject_1;
//# sourceMappingURL=paragraph.js.map

/***/ }),
/* 1733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return linkSharedStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var linkSharedStyle = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  a.blockLink {\n    display: block;\n  }\n"], ["\n  a.blockLink {\n    display: block;\n  }\n"])));

var templateObject_1;
//# sourceMappingURL=link.js.map

/***/ }),
/* 1734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return indentationSharedStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var indentationSharedStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .fabric-editor-indentation-mark {\n    &[data-level='1'] {\n      margin-left: 30px;\n    }\n    &[data-level='2'] {\n      margin-left: 60px;\n    }\n    &[data-level='3'] {\n      margin-left: 90px;\n    }\n    &[data-level='4'] {\n      margin-left: 120px;\n    }\n    &[data-level='5'] {\n      margin-left: 150px;\n    }\n    &[data-level='6'] {\n      margin-left: 180px;\n    }\n  }\n"], ["\n  .fabric-editor-indentation-mark {\n    &[data-level='1'] {\n      margin-left: 30px;\n    }\n    &[data-level='2'] {\n      margin-left: 60px;\n    }\n    &[data-level='3'] {\n      margin-left: 90px;\n    }\n    &[data-level='4'] {\n      margin-left: 120px;\n    }\n    &[data-level='5'] {\n      margin-left: 150px;\n    }\n    &[data-level='6'] {\n      margin-left: 180px;\n    }\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=indentation.js.map

/***/ }),
/* 1735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return blockMarksSharedStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var blockMarksSharedStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  /**\n   * We need to remove margin-top from first item\n   * inside doc, tableCell, tableHeader, blockquote, etc.\n   */\n  *:not(.fabric-editor-block-mark) >,\n  /* For nested block marks */\n  *:not(.fabric-editor-block-mark) > div.fabric-editor-block-mark:first-child {\n    p,\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      &:first-child {\n        margin-top: 0;\n      }\n    }\n  }\n"], ["\n  /**\n   * We need to remove margin-top from first item\n   * inside doc, tableCell, tableHeader, blockquote, etc.\n   */\n  *:not(.fabric-editor-block-mark) >,\n  /* For nested block marks */\n  *:not(.fabric-editor-block-mark) > div.fabric-editor-block-mark:first-child {\n    p,\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      &:first-child {\n        margin-top: 0;\n      }\n    }\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=block-marks.js.map

/***/ }),
/* 1736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_emoji__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__providerFactory__ = __webpack_require__(399);





var EmojiNode = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiNode, _super);
    function EmojiNode(props) {
        var _this = _super.call(this, props) || this;
        _this.renderWithProvider = function (providers) {
            var _a = _this.props, allowTextFallback = _a.allowTextFallback, shortName = _a.shortName, id = _a.id, fallback = _a.fallback, fitToHeight = _a.fitToHeight;
            if (allowTextFallback && !providers.emojiProvider) {
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, fallback || shortName);
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_emoji__["c" /* ResourcedEmoji */], { emojiId: { id: id, fallback: fallback, shortName: shortName }, emojiProvider: providers.emojiProvider, showTooltip: true, fitToHeight: fitToHeight }));
        };
        _this.providerFactory = props.providers || new __WEBPACK_IMPORTED_MODULE_3__providerFactory__["b" /* default */]();
        return _this;
    }
    EmojiNode.prototype.componentWillUnmount = function () {
        if (!this.props.providers) {
            // new ProviderFactory is created if no `providers` has been set
            // in this case when component is unmounted it's safe to destroy this providerFactory
            this.providerFactory.destroy();
        }
    };
    EmojiNode.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__providerFactory__["a" /* WithProviders */], { providers: ['emojiProvider'], providerFactory: this.providerFactory, renderNode: this.renderWithProvider }));
    };
    return EmojiNode;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* unused harmony default export */ var _unused_webpack_default_export = (EmojiNode);
//# sourceMappingURL=index.js.map

/***/ }),
/* 1737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AbstractResource; });
var AbstractResource = /** @class */ (function () {
    function AbstractResource() {
        this.listeners = new Set();
    }
    AbstractResource.prototype.subscribe = function (onChange) {
        this.listeners.add(onChange);
        if (this.lastResult) {
            // Notify subscribe of last result (i.e. initial state)
            onChange.result(this.lastResult);
        }
    };
    AbstractResource.prototype.unsubscribe = function (onChange) {
        this.listeners.delete(onChange);
    };
    AbstractResource.prototype.notifyResult = function (result) {
        this.listeners.forEach(function (onChange) {
            onChange.result(result);
        });
    };
    AbstractResource.prototype.notifyError = function (error) {
        this.listeners.forEach(function (onChange) {
            if (onChange.error) {
                onChange.error(error);
            }
        });
    };
    AbstractResource.prototype.notifyInfo = function (info) {
        this.listeners.forEach(function (onChange) {
            if (onChange.info) {
                onChange.info(info);
            }
        });
    };
    AbstractResource.prototype.notifyNotReady = function () {
        this.listeners.forEach(function (onChange) {
            if (onChange.notReady) {
                onChange.notReady();
            }
        });
    };
    return AbstractResource;
}());

//# sourceMappingURL=serviceResources.js.map

/***/ }),
/* 1738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "requestService", function() { return requestService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url_search_params__ = __webpack_require__(1742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url_search_params___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_url_search_params__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(644);


 // IE, Safari, Mobile Chrome, Mobile Safari

var URLSearchParams = __WEBPACK_IMPORTED_MODULE_2_url_search_params__["default"] || __WEBPACK_IMPORTED_MODULE_2_url_search_params__;
var defaultRequestServiceOptions = {};
var buildUrl = function (baseUrl, path, queryParams, secOptions) {
    if (path === void 0) { path = ''; }
    var searchParam = new URLSearchParams(__WEBPACK_IMPORTED_MODULE_1_url__["parse"](baseUrl).search || undefined);
    baseUrl = baseUrl.split('?')[0];
    if (queryParams) {
        for (var key in queryParams) {
            if ({}.hasOwnProperty.call(queryParams, key)) {
                searchParam.append(key, queryParams[key]);
            }
        }
    }
    if (secOptions && secOptions.params) {
        for (var key in secOptions.params) {
            if ({}.hasOwnProperty.call(secOptions.params, key)) {
                var values = secOptions.params[key];
                if (Array.isArray(values)) {
                    for (var i = 0; i < values.length; i++) {
                        searchParam.append(key, values[i]);
                    }
                }
                else {
                    searchParam.append(key, values);
                }
            }
        }
    }
    var seperator = '';
    if (path && baseUrl.substr(-1) !== '/') {
        seperator = '/';
    }
    var params = searchParam.toString();
    if (params) {
        params = '?' + params;
    }
    return "" + baseUrl + seperator + path + params;
};
var addToHeaders = function (headers, keyValues) {
    if (keyValues) {
        for (var key in keyValues) {
            if ({}.hasOwnProperty.call(keyValues, key)) {
                var values = keyValues[key];
                if (Array.isArray(values)) {
                    for (var i = 0; i < values.length; i++) {
                        headers.append(key, values[i]);
                    }
                }
                else {
                    headers.append(key, values);
                }
            }
        }
    }
};
var buildHeaders = function (secOptions, extraHeaders) {
    var headers = new Headers();
    addToHeaders(headers, extraHeaders);
    if (secOptions) {
        addToHeaders(headers, secOptions.headers);
    }
    return headers;
};
/**
 * @returns Promise containing the json response
 */
var requestService = function (serviceConfig, options) {
    var url = serviceConfig.url, securityProvider = serviceConfig.securityProvider, refreshedSecurityProvider = serviceConfig.refreshedSecurityProvider;
    var _a = options || defaultRequestServiceOptions, path = _a.path, queryParams = _a.queryParams, requestInit = _a.requestInit;
    var secOptions = securityProvider && securityProvider();
    var requestUrl = buildUrl(url, path, queryParams, secOptions);
    var headers = buildHeaders(secOptions, requestInit && requestInit.headers);
    var credentials = Object(__WEBPACK_IMPORTED_MODULE_3__types__["a" /* buildCredentials */])(secOptions);
    var requestOptions = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, requestInit, { headers: headers,
        credentials: credentials });
    return fetch(requestUrl, requestOptions).then(function (response) {
        if (response.status === 204) {
            return Promise.resolve();
        }
        else if (response.ok) {
            return response.json();
        }
        else if (response.status === 401 && refreshedSecurityProvider) {
            // auth issue - try once
            return refreshedSecurityProvider().then(function (newSecOptions) {
                var retryServiceConfig = {
                    url: url,
                    securityProvider: function () { return newSecOptions; },
                };
                return requestService(retryServiceConfig, options);
            });
        }
        return Promise.reject({
            code: response.status,
            reason: response.statusText,
        });
    });
};
//# sourceMappingURL=serviceUtils.js.map

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
Copyright (C) 2015-2017 Andrea Giammarchi - @WebReflection

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/


function URLSearchParams(query) {
  var
    index, key, value,
    pairs, i, length,
    dict = Object.create(null)
  ;
  this[secret] = dict;
  if (!query) return;
  if (typeof query === 'string') {
    if (query.charAt(0) === '?') {
      query = query.slice(1);
    }
    for (
      pairs = query.split('&'),
      i = 0,
      length = pairs.length; i < length; i++
    ) {
      value = pairs[i];
      index = value.indexOf('=');
      if (-1 < index) {
        appendTo(
          dict,
          decode(value.slice(0, index)),
          decode(value.slice(index + 1))
        );
      } else if (value.length){
        appendTo(
          dict,
          decode(value),
          ''
        );
      }
    }
  } else {
    if (isArray(query)) {
      for (
        i = 0,
        length = query.length; i < length; i++
      ) {
        value = query[i];
        appendTo(dict, value[0], value[1]);
      }
    } else {
      for (key in query) {
         appendTo(dict, key, query[key]);
      }
    }
  }
}

var
  isArray = Array.isArray,
  URLSearchParamsProto = URLSearchParams.prototype,
  find = /[!'\(\)~]|%20|%00/g,
  plus = /\+/g,
  replace = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  },
  replacer = function (match) {
    return replace[match];
  },
  secret = '__URLSearchParams__:' + Math.random()
;

function appendTo(dict, name, value) {
  if (name in dict) {
    dict[name].push('' + value);
  } else {
    dict[name] = isArray(value) ? value : ['' + value];
  }
}

function decode(str) {
  return decodeURIComponent(str.replace(plus, ' '));
}

function encode(str) {
  return encodeURIComponent(str).replace(find, replacer);
}

URLSearchParamsProto.append = function append(name, value) {
  appendTo(this[secret], name, value);
};

URLSearchParamsProto.delete = function del(name) {
  delete this[secret][name];
};

URLSearchParamsProto.get = function get(name) {
  var dict = this[secret];
  return name in dict ? dict[name][0] : null;
};

URLSearchParamsProto.getAll = function getAll(name) {
  var dict = this[secret];
  return name in dict ? dict[name].slice(0) : [];
};

URLSearchParamsProto.has = function has(name) {
  return name in this[secret];
};

URLSearchParamsProto.set = function set(name, value) {
  this[secret][name] = ['' + value];
};

URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
  var dict = this[secret];
  Object.getOwnPropertyNames(dict).forEach(function(name) {
    dict[name].forEach(function(value) {
      callback.call(thisArg, value, name, this);
    }, this);
  }, this);
};

/*
URLSearchParamsProto.toBody = function() {
  return new Blob(
    [this.toString()],
    {type: 'application/x-www-form-urlencoded'}
  );
};
*/

URLSearchParamsProto.toJSON = function toJSON() {
  return {};
};

URLSearchParamsProto.toString = function toString() {
  var dict = this[secret], query = [], i, key, name, value;
  for (key in dict) {
    name = encode(key);
    for (
      i = 0,
      value = dict[key];
      i < value.length; i++
    ) {
      query.push(name + '=' + encode(value[i]));
    }
  }
  return query.join('&');
};

URLSearchParams = (module.exports = global.URLSearchParams || URLSearchParams);

(function (URLSearchParamsProto) {

  var iterable = (function () {
    try {
      return !!Symbol.iterator;
    } catch(error) {
      return false;
    }
  }());

  // mostly related to issue #24
  if (!('forEach' in URLSearchParamsProto)) {
    URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
      var names = Object.create(null);
      this.toString()
          .replace(/=[\s\S]*?(?:&|$)/g, '=')
          .split('=')
          .forEach(function (name) {
            if (!name.length || name in names) return;
            (names[name] = this.getAll(name)).forEach(function(value) {
              callback.call(thisArg, value, name, this);
            }, this);
          }, this);
    };
  }

  if (!('keys' in URLSearchParamsProto)) {
    URLSearchParamsProto.keys = function keys() {
      var items = [];
      this.forEach(function(value, name) { items.push(name); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (!('values' in URLSearchParamsProto)) {
    URLSearchParamsProto.values = function values() {
      var items = [];
      this.forEach(function(value) { items.push(value); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (!('entries' in URLSearchParamsProto)) {
    URLSearchParamsProto.entries = function entries() {
      var items = [];
      this.forEach(function(value, name) { items.push([name, value]); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (iterable && !(Symbol.iterator in URLSearchParamsProto)) {
    URLSearchParamsProto[Symbol.iterator] = URLSearchParamsProto.entries;
  }

  if (!('sort' in URLSearchParamsProto)) {
    URLSearchParamsProto.sort = function sort() {
      var
        entries = this.entries(),
        entry = entries.next(),
        done = entry.done,
        keys = [],
        values = Object.create(null),
        i, key, value
      ;
      while (!done) {
        value = entry.value;
        key = value[0];
        keys.push(key);
        if (!(key in values)) {
          values[key] = [];
        }
        values[key].push(value[1]);
        entry = entries.next();
        done = entry.done;
      }
      // not the champion in efficiency
      // but these two bits just do the job
      keys.sort();
      for (i = 0; i < keys.length; i++) {
        this.delete(keys[i]);
      }
      for (i = 0; i < keys.length; i++) {
        key = keys[i];
        this.append(key, values[key].shift());
      }
    };
  }

}(URLSearchParams.prototype));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 1743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TooltipWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_node_resolver__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_node_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_node_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_flushable__ = __webpack_require__(1745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_flushable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_flushable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_popper__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__atlaskit_portal__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__atlaskit_analytics_next__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__package_json__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styled__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Animation__ = __webpack_require__(1762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_analytics_payloads__ = __webpack_require__(1768);









/* eslint-disable react/require-default-props */











var SCROLL_OPTIONS = {
  capture: true,
  passive: true
};

function getMousePosition(mouseCoordinates) {
  var safeMouse = mouseCoordinates || {
    top: 0,
    left: 0
  };

  var getBoundingClientRect = function getBoundingClientRect() {
    return {
      top: safeMouse.top,
      left: safeMouse.left,
      bottom: safeMouse.top,
      right: safeMouse.left,
      width: 0,
      height: 0
    };
  };

  return {
    getBoundingClientRect: getBoundingClientRect,
    clientWidth: 0,
    clientHeight: 0
  };
}

var pendingHide;

var showTooltip = function showTooltip(fn, defaultDelay) {
  var isHidePending = pendingHide && pendingHide.pending();

  if (isHidePending) {
    pendingHide.flush();
  }

  var pendingShow = __WEBPACK_IMPORTED_MODULE_10_flushable___default()(function () {
    return fn(isHidePending);
  }, isHidePending ? 0 : defaultDelay);
  return pendingShow.cancel;
};

var hideTooltip = function hideTooltip(fn, defaultDelay) {
  pendingHide = __WEBPACK_IMPORTED_MODULE_10_flushable___default()(function (flushed) {
    return fn(flushed);
  }, defaultDelay);
  return pendingHide.cancel;
};

var Tooltip =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Tooltip, _Component);

  function Tooltip() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Tooltip)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "wrapperRef", void 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "targetRef", void 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "fakeMouseElement", void 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "cancelPendingSetState", function () {});

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      immediatelyHide: false,
      immediatelyShow: false,
      isVisible: false,
      renderTooltip: false
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleWindowScroll", function () {
      if (_this.state.isVisible) {
        _this.cancelPendingSetState();

        _this.setState({
          isVisible: false,
          immediatelyHide: true
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleMouseClick", function () {
      if (_this.props.hideTooltipOnClick) {
        _this.cancelPendingSetState();

        _this.setState({
          isVisible: false,
          immediatelyHide: true
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleMouseDown", function () {
      if (_this.props.hideTooltipOnMouseDown) {
        _this.cancelPendingSetState();

        _this.setState({
          isVisible: false,
          immediatelyHide: true
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleMouseOver", function (e) {
      if (e.target === _this.wrapperRef) return; // In the case where a tooltip is newly rendered but immediately becomes hovered,
      // we need to set the coordinates in the mouseOver event.

      if (!_this.fakeMouseElement) _this.fakeMouseElement = getMousePosition({
        left: e.clientX,
        top: e.clientY
      });

      _this.cancelPendingSetState();

      if (Boolean(_this.props.content) && !_this.state.isVisible) {
        _this.cancelPendingSetState = showTooltip(function (immediatelyShow) {
          _this.setState({
            isVisible: true,
            renderTooltip: true,
            immediatelyShow: immediatelyShow
          });
        }, _this.props.delay);
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleMouseLeave", function (e) {
      if (e.target === _this.wrapperRef) return;

      _this.cancelPendingSetState();

      if (_this.state.isVisible) {
        _this.cancelPendingSetState = hideTooltip(function (immediatelyHide) {
          _this.setState({
            isVisible: false,
            immediatelyHide: immediatelyHide
          });
        }, _this.props.delay);
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleMouseMove", function (event) {
      if (!_this.state.renderTooltip) {
        _this.fakeMouseElement = getMousePosition({
          left: event.clientX,
          top: event.clientY
        });
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Tooltip, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelPendingSetState();
      this.removeScrollListener();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevState.isVisible && this.state.isVisible) {
        if (this.props.onShow) this.props.onShow();
        window.addEventListener('scroll', this.handleWindowScroll, SCROLL_OPTIONS);
      } else if (prevState.isVisible && !this.state.isVisible) {
        if (this.props.onHide) this.props.onHide();
        this.removeScrollListener();
      }
    }
  }, {
    key: "removeScrollListener",
    value: function removeScrollListener() {
      window.removeEventListener('scroll', this.handleWindowScroll, SCROLL_OPTIONS);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          content = _this$props.content,
          position = _this$props.position,
          mousePosition = _this$props.mousePosition,
          truncate = _this$props.truncate,
          TooltipContainer = _this$props.component,
          TargetContainer = _this$props.tag;
      var _this$state = this.state,
          isVisible = _this$state.isVisible,
          renderTooltip = _this$state.renderTooltip,
          immediatelyShow = _this$state.immediatelyShow,
          immediatelyHide = _this$state.immediatelyHide;
      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(TargetContainer, {
        onClick: this.handleMouseClick,
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseLeave,
        onMouseMove: this.handleMouseMove,
        onMouseDown: this.handleMouseDown,
        ref: function ref(wrapperRef) {
          _this2.wrapperRef = wrapperRef;
        }
      }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_node_resolver___default.a, {
        innerRef: function innerRef(targetRef) {
          _this2.targetRef = targetRef;
        }
      }, __WEBPACK_IMPORTED_MODULE_8_react__["Children"].only(children))), renderTooltip && this.targetRef && this.fakeMouseElement ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__atlaskit_popper__["b" /* Popper */], {
        referenceElement: // https://github.com/FezVrasta/react-popper#usage-without-a-reference-htmlelement
        // We are using a popper technique to pass in a faked element when we use mouse.
        // This is fine.
        // $FlowFixMe
        position === 'mouse' ? this.fakeMouseElement : this.targetRef,
        placement: position === 'mouse' ? mousePosition : position
      }, function (_ref) {
        var ref = _ref.ref,
            style = _ref.style,
            placement = _ref.placement;
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Animation__["a" /* default */], {
          immediatelyShow: immediatelyShow,
          immediatelyHide: immediatelyHide,
          onExited: function onExited() {
            return _this2.setState({
              renderTooltip: false
            });
          },
          in: isVisible
        }, function (getAnimationStyles) {
          return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__atlaskit_portal__["a" /* default */], {
            zIndex: __WEBPACK_IMPORTED_MODULE_13__atlaskit_theme__["layers"].tooltip()
          }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(TooltipContainer, {
            innerRef: ref,
            style: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, getAnimationStyles(placement), style),
            truncate: truncate
          }, content));
        });
      }) : null);
    }
  }]);

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Tooltip, "defaultProps", {
  component: __WEBPACK_IMPORTED_MODULE_16__styled__["a" /* Tooltip */],
  delay: 300,
  mousePosition: 'bottom',
  position: 'bottom',
  tag: 'div'
});


var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_14__atlaskit_analytics_next__["createAndFireEvent"])('atlaskit');
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14__atlaskit_analytics_next__["withAnalyticsContext"])({
  componentName: 'tooltip',
  packageName: __WEBPACK_IMPORTED_MODULE_15__package_json__["name"],
  packageVersion: __WEBPACK_IMPORTED_MODULE_15__package_json__["version"]
})(Object(__WEBPACK_IMPORTED_MODULE_14__atlaskit_analytics_next__["withAnalyticsEvents"])({
  onHide: __WEBPACK_IMPORTED_MODULE_18__utils_analytics_payloads__["b" /* unhoveredPayload */],
  onShow: createAndFireEventOnAtlaskit(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, __WEBPACK_IMPORTED_MODULE_18__utils_analytics_payloads__["a" /* hoveredPayload */]))
})(Tooltip)));

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _reactDom = __webpack_require__(18);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NodeResolver = function (_Component) {
  _inherits(NodeResolver, _Component);

  function NodeResolver() {
    _classCallCheck(this, NodeResolver);

    return _possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
  }

  _createClass(NodeResolver, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.innerRef((0, _reactDom.findDOMNode)(this));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.innerRef(null);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return NodeResolver;
}(_react.Component);

exports.default = NodeResolver;

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.map = factory());
}(this, (function () { 'use strict';

  // a timeout function that can be flushed and cancelled
  var flushable = function flushable(onComplete, delay) {
    var timeoutId = setTimeout(function () {
      timeoutId = null;
      onComplete(false);
    }, delay);

    var clearTimer = function clearTimer() {
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
    };

    return {
      cancel: clearTimer,
      flush: function flush() {
        if (!timeoutId) {
          return;
        }

        clearTimer();
        onComplete(true);
      },
      pending: function pending() {
        return Boolean(timeoutId);
      }
    };
  };

  return flushable;

})));


/***/ }),
/* 1746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Popper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_memoize_one__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_popper__ = __webpack_require__(548);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_10_react_popper__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_10_react_popper__["c"]; });













var getFlipBehavior = function getFlipBehavior(side) {
  return {
    auto: [],
    top: ['top', 'bottom', 'top'],
    right: ['right', 'left', 'right'],
    bottom: ['bottom', 'top', 'bottom'],
    left: ['left', 'right', 'left']
  }[side];
};

var Popper =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Popper, _Component);

  function Popper() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Popper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Popper)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getModifiers", Object(__WEBPACK_IMPORTED_MODULE_9_memoize_one__["a" /* default */])(function (placement) {
      var flipBehavior = getFlipBehavior(placement.split('-')[0]);
      var modifiers = {
        flip: {
          enabled: true,
          behavior: flipBehavior,
          boundariesElement: 'viewport'
        },
        hide: {
          enabled: true,
          boundariesElement: 'scrollParent'
        },
        offset: {
          enabled: true,
          offset: _this.props.offset
        },
        preventOverflow: {
          enabled: true,
          escapeWithReference: false,
          boundariesElement: 'window'
        }
      };
      return modifiers;
    }));

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Popper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          placement = _this$props.placement,
          children = _this$props.children,
          referenceElement = _this$props.referenceElement;
      var modifiers = this.getModifiers(this.props.placement);
      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_popper__["b" /* Popper */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        positionFixed: true,
        modifiers: modifiers,
        placement: placement
      }, referenceElement ? {
        referenceElement: referenceElement
      } : {}), children);
    }
  }]);

  return Popper;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Popper, "defaultProps", {
  children: function children() {},
  offset: '0, 8px',
  placement: 'bottom-start'
});

/***/ }),
/* 1747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InnerPopper */
/* unused harmony export placements */
/* harmony export (immutable) */ __webpack_exports__["a"] = Popper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_popper_js__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Manager__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(650);










var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};

var initialArrowStyle = {};

var InnerPopper = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(InnerPopper, _React$Component);

  function InnerPopper() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, InnerPopper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      data: undefined,
      placement: undefined
    }, _this.popperNode = null, _this.arrowNode = null, _this.setPopperNode = function (popperNode) {
      if (_this.popperNode === popperNode) return;

      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* safeInvoke */])(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;

      if (!_this.popperInstance) _this.updatePopperInstance();
    }, _this.setArrowNode = function (arrowNode) {
      if (_this.arrowNode === arrowNode) return;
      _this.arrowNode = arrowNode;

      if (!_this.popperInstance) _this.updatePopperInstance();
    }, _this.updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var placement = data.placement;

        _this.setState({ data: data, placement: placement }, placement !== _this.state.placement ? _this.scheduleUpdate : undefined);
        return data;
      }
    }, _this.getOptions = function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.props.modifiers, {
          arrow: {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          },
          applyStyle: { enabled: false },
          updateStateModifier: _this.updateStateModifier
        })
      };
    }, _this.getPopperStyle = function () {
      return !_this.popperNode || !_this.state.data ? initialStyle : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    }, _this.getPopperPlacement = function () {
      return !_this.state.data ? undefined : _this.state.placement;
    }, _this.getArrowStyle = function () {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    }, _this.getOutOfBoundariesState = function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    }, _this.destroyPopperInstance = function () {
      if (!_this.popperInstance) return;

      _this.popperInstance.destroy();
      _this.popperInstance = null;
    }, _this.updatePopperInstance = function () {
      _this.destroyPopperInstance();

      var _this2 = _this,
          popperNode = _this2.popperNode;
      var referenceElement = _this.props.referenceElement;


      if (!referenceElement || !popperNode) return;

      _this.popperInstance = new __WEBPACK_IMPORTED_MODULE_5_popper_js__["a" /* default */](referenceElement, popperNode, _this.getOptions());
    }, _this.scheduleUpdate = function () {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  InnerPopper.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If the Popper.js options have changed, update the instance (destroy + create)
    if (this.props.placement !== prevProps.placement || this.props.eventsEnabled !== prevProps.eventsEnabled || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed) {
      this.updatePopperInstance();
      return;
    }

    // A placement difference in state means popper determined a new placement
    // apart from the props value. By the time the popper element is rendered with
    // the new position Popper has already measured it, if the place change triggers
    // a size change it will result in a misaligned popper. So we schedule an update to be sure.
    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };

  InnerPopper.prototype.componentWillUnmount = function componentWillUnmount() {
    this.destroyPopperInstance();
  };

  InnerPopper.prototype.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* unwrapArray */])(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };

  return InnerPopper;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

InnerPopper.defaultProps = {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
};
var placements = __WEBPACK_IMPORTED_MODULE_5_popper_js__["a" /* default */].placements;


function Popper(props) {
  return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](
    __WEBPACK_IMPORTED_MODULE_6__Manager__["a" /* ManagerContext */].Consumer,
    null,
    function (_ref) {
      var referenceNode = _ref.referenceNode;
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](InnerPopper, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ referenceElement: referenceNode }, props));
    }
  );
}

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(1749);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(1750);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(1751);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(1752);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 1753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Reference;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Manager__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(650);









var InnerReference = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(InnerReference, _React$Component);

  function InnerReference() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, InnerReference);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.refHandler = function (node) {
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* safeInvoke */])(_this.props.innerRef, node);
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* safeInvoke */])(_this.props.getReferenceRef, node);
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  InnerReference.prototype.render = function render() {
    __WEBPACK_IMPORTED_MODULE_5_warning___default()(this.props.getReferenceRef, '`Reference` should not be used outside of a `Manager` component.');
    return Object(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* unwrapArray */])(this.props.children)({ ref: this.refHandler });
  };

  return InnerReference;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

function Reference(props) {
  return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](
    __WEBPACK_IMPORTED_MODULE_6__Manager__["a" /* ManagerContext */].Consumer,
    null,
    function (_ref) {
      var getReferenceRef = _ref.getReferenceRef;
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](InnerReference, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ getReferenceRef: getReferenceRef }, props));
    }
  );
}

/***/ }),
/* 1754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_tiny_invariant__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_exenv__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_exenv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_exenv__);












var createContainer = function createContainer(zIndex) {
  var container = document.createElement('div');
  container.setAttribute('class', 'atlaskit-portal');
  container.setAttribute('style', "z-index: ".concat(zIndex, ";"));
  return container;
};

var body = function body() {
  Object(__WEBPACK_IMPORTED_MODULE_9_tiny_invariant__["a" /* default */])(document && document.body, 'cannot find document.body');
  return document.body;
};

var portalParent = function portalParent() {
  var parentElement = document.querySelector('body > .atlaskit-portal-container');

  if (!parentElement) {
    var parent = document.createElement('div');
    parent.setAttribute('class', 'atlaskit-portal-container');
    parent.setAttribute('style', "display: flex;");
    body().appendChild(parent);
    return parent;
  }

  return parentElement;
}; // This is a generic component does two things:
// 1. Portals it's children using React.createPortal
// 2. Creates the DOM node container for the portal based on props
// 3. Ensures DOM the container creates it's own stacking context


var Portal =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Portal, _React$Component);

  function Portal() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Portal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Portal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      container: __WEBPACK_IMPORTED_MODULE_10_exenv__["canUseDOM"] ? createContainer(_this.props.zIndex) : undefined
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Portal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var container = this.state.container;
      var zIndex = this.props.zIndex;

      if (container && prevProps.zIndex !== zIndex) {
        var newContainer = createContainer(zIndex);
        portalParent().replaceChild(container, newContainer); // eslint-disable-next-line react/no-did-update-set-state

        this.setState({
          container: newContainer
        });
      } else if (!prevState.container && container) {
        // SSR path
        portalParent().appendChild(container);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var container = this.state.container;
      var zIndex = this.props.zIndex;

      if (container) {
        portalParent().appendChild(container);
      } else {
        // SSR path
        var newContainer = createContainer(zIndex); // eslint-disable-next-line react/no-did-mount-set-state

        this.setState({
          container: newContainer
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var container = this.state.container;

      if (container) {
        portalParent().removeChild(container); // clean up parent element if there are no more portals

        var portals = !!document.querySelector('body > .atlaskit-portal-container > .atlaskit-portal');

        if (!portals) {
          body().removeChild(portalParent());
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var container = this.state.container;
      return container ? __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.createPortal(this.props.children, container) : this.props.children;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Portal, "defaultProps", {
  zIndex: 0
});

/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(6);

var superPropBase = __webpack_require__(1756);

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    module.exports = _get = Reflect.get;
  } else {
    module.exports = _get = function _get(target, property, receiver) {
      var base = superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

module.exports = _get;

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(6);

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

module.exports = _superPropBase;

/***/ }),
/* 1757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnalyticsListener; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__UIAnalyticsEvent__ = __webpack_require__(382);











var ContextTypes = {
  getAtlaskitAnalyticsEventHandlers: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
};

var AnalyticsListener =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(AnalyticsListener, _Component);

  function AnalyticsListener() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, AnalyticsListener);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(AnalyticsListener)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getChildContext", function () {
      return {
        getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
      };
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getAnalyticsEventHandlers", function () {
      var _this$props = _this.props,
          channel = _this$props.channel,
          onEvent = _this$props.onEvent;
      var getAtlaskitAnalyticsEventHandlers = _this.context.getAtlaskitAnalyticsEventHandlers;
      var parentEventHandlers = typeof getAtlaskitAnalyticsEventHandlers === 'function' && getAtlaskitAnalyticsEventHandlers() || [];

      var handler = function handler(event, eventChannel) {
        if (channel === '*' || channel === eventChannel) {
          onEvent(event, eventChannel);
        }
      };

      return [handler].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(parentEventHandlers));
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(AnalyticsListener, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnalyticsListener;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(AnalyticsListener, "contextTypes", ContextTypes);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(AnalyticsListener, "childContextTypes", ContextTypes);



/***/ }),
/* 1758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withAnalyticsContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AnalyticsContext__ = __webpack_require__(652);





function withAnalyticsContext() {
  var defaultData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (WrappedComponent) {
    // $FlowFixMe - flow 0.67 doesn't know about forwardRef
    var WithAnalyticsContext = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (props, ref) {
      var _props$analyticsConte = props.analyticsContext,
          analyticsContext = _props$analyticsConte === void 0 ? {} : _props$analyticsConte,
          others = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(props, ["analyticsContext"]);

      var data = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, defaultData, analyticsContext);

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AnalyticsContext__["a" /* default */], {
        data: data
      }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(WrappedComponent, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, others, {
        ref: ref
      })));
    });
    WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
    return WithAnalyticsContext;
  };
}

/***/ }),
/* 1759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withAnalyticsEvents;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__UIAnalyticsEvent__ = __webpack_require__(382);













// This component is used to grab the analytics functions off context.
// It uses legacy context, but provides an API similar to 16.3 context.
// This makes it easier to use with the forward ref API.
var AnalyticsContextConsumer =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(AnalyticsContextConsumer, _Component);

  function AnalyticsContextConsumer() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, AnalyticsContextConsumer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(AnalyticsContextConsumer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "createAnalyticsEvent", function (payload) {
      var _this$context = _this.context,
          getAtlaskitAnalyticsEventHandlers = _this$context.getAtlaskitAnalyticsEventHandlers,
          getAtlaskitAnalyticsContext = _this$context.getAtlaskitAnalyticsContext;
      var context = typeof getAtlaskitAnalyticsContext === 'function' && getAtlaskitAnalyticsContext() || [];
      var handlers = typeof getAtlaskitAnalyticsEventHandlers === 'function' && getAtlaskitAnalyticsEventHandlers() || [];
      return new __WEBPACK_IMPORTED_MODULE_11__UIAnalyticsEvent__["a" /* default */]({
        context: context,
        handlers: handlers,
        payload: payload
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(AnalyticsContextConsumer, [{
    key: "render",
    value: function render() {
      return this.props.children(this.createAnalyticsEvent);
    }
  }]);

  return AnalyticsContextConsumer;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]); // patch the callback so it provides analytics information.


__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(AnalyticsContextConsumer, "contextTypes", {
  getAtlaskitAnalyticsEventHandlers: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
  getAtlaskitAnalyticsContext: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func
});

var modifyCallbackProp = function modifyCallbackProp(propName, eventMapEntry, props, createAnalyticsEvent) {
  return function () {
    var event = typeof eventMapEntry === 'function' ? eventMapEntry(createAnalyticsEvent, props) : createAnalyticsEvent(eventMapEntry);
    var providedCallback = props[propName];

    if (providedCallback) {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      providedCallback.apply(void 0, args.concat([event]));
    }
  };
};

// helper that provides an easy way to map an object's values
// ({ string: A }, (string, A) => B) => { string: B }
var vmap = function vmap(obj, fn) {
  return Object.keys(obj).reduce(function (curr, k) {
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, curr, __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()({}, k, fn(k, obj[k])));
  }, {});
};
/* This must use $Supertype to work with multiple HOCs - https://github.com/facebook/flow/issues/6057#issuecomment-414157781
 * We also cannot alias this as a generic of withAnalyticsEvents itself as
 * that causes issues with multiple HOCs - https://github.com/facebook/flow/issues/6587
 */


function withAnalyticsEvents() {
  var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (WrappedComponent) {
    // $FlowFixMe - flow 0.67 doesn't know about forwardRef
    var WithAnalyticsEvents = __WEBPACK_IMPORTED_MODULE_9_react___default.a.forwardRef(function (props, ref) {
      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(AnalyticsContextConsumer, null, function (createAnalyticsEvent) {
        var modifiedProps = vmap(createEventMap, function (propName, entry) {
          return modifyCallbackProp(propName, entry, props, createAnalyticsEvent);
        });
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(WrappedComponent, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, props, modifiedProps, {
          createAnalyticsEvent: createAnalyticsEvent,
          ref: ref
        }));
      });
    });
    WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
    return WithAnalyticsEvents;
  };
}

/***/ }),
/* 1760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (channel) {
  return function (payload) {
    return function (createAnalyticsEvent) {
      var consumerEvent = createAnalyticsEvent(payload);
      consumerEvent.clone().fire(channel);
      return consumerEvent;
    };
  };
});

/***/ }),
/* 1761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cleanProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);


/*
cleanProps removes props added by the withAnalyticsEvents HOC from an object
*/
function cleanProps(props) {
  /* eslint-disable no-unused-vars */
  var createAnalyticsEvent = props.createAnalyticsEvent,
      cleanedProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(props, ["createAnalyticsEvent"]);
  /* eslint-enable no-unused-vars */


  return cleanedProps;
}

/***/ }),
/* 1762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group__ = __webpack_require__(1763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_transition_group__);



var ENTER_DURATION = 120;
var EXIT_DURATION = 80;
var easing = 'cubic-bezier(0.23, 1, 0.32, 1)'; // easeOutQuint

var distance = 8;
var horizontalOffset = {
  left: distance,
  right: -distance,
  top: 0,
  bottom: 0
};
var verticalOffset = {
  bottom: -distance,
  top: distance,
  left: 0,
  right: 0
};

var defaultStyle = function defaultStyle(timeout) {
  return {
    transition: "transform ".concat(timeout.enter, "ms ").concat(easing, ", opacity ").concat(timeout.enter, "ms linear"),
    opacity: 0
  };
};

var transitionStyle = function transitionStyle(timeout, state, position) {
  var transitions = {
    entering: {
      transform: "translate3d(".concat(horizontalOffset[position], "px, ").concat(verticalOffset[position], "px, 0)")
    },
    entered: {
      opacity: 1
    },
    exiting: {
      opacity: 0,
      transition: "".concat(timeout.exit, "ms linear"),
      transform: "translate3d(".concat(horizontalOffset[position] / 2, "px, ").concat(verticalOffset[position] / 2, "px, 0)")
    }
  };
  return transitions[state];
};

var getStyle = function getStyle(timeout, state) {
  return function (position) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, defaultStyle(timeout), transitionStyle(timeout, state, position));
  };
};

var Animation = function Animation(_ref) {
  var children = _ref.children,
      immediatelyHide = _ref.immediatelyHide,
      immediatelyShow = _ref.immediatelyShow,
      onExited = _ref.onExited,
      inProp = _ref.in;
  var timeout = {
    enter: immediatelyShow ? 1 : ENTER_DURATION,
    exit: immediatelyHide ? 1 : EXIT_DURATION
  };
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_transition_group__["Transition"], {
    timeout: timeout,
    in: inProp,
    onExited: onExited,
    unmountOnExit: true,
    appear: true
  }, function (state) {
    return children(getStyle(timeout, state));
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Animation);

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__(1764));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__(1766));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(657));

var _Transition = _interopRequireDefault(__webpack_require__(655));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(10));

var _addClass = _interopRequireDefault(__webpack_require__(244));

var _removeClass = _interopRequireDefault(__webpack_require__(245));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireDefault(__webpack_require__(655));

var _PropTypes = __webpack_require__(656);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};

var propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply spread
   * them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};;
/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 */

var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames7 = this.getClassNames(type),
        className = _this$getClassNames7.className,
        activeClassName = _this$getClassNames7.activeClassName,
        doneClassName = _this$getClassNames7.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(18);

var _TransitionGroup = _interopRequireDefault(__webpack_require__(657));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var propTypes =  false ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};;
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? propTypes : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 1768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hoveredPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return unhoveredPayload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);

var hoveredPayload = {
  action: 'displayed',
  actionSubject: 'tooltip',
  attributes: {
    componentName: 'tooltip',
    packageName: __WEBPACK_IMPORTED_MODULE_0__package_json__["name"],
    packageVersion: __WEBPACK_IMPORTED_MODULE_0__package_json__["version"]
  }
};
var unhoveredPayload = {
  action: 'hidden',
  actionSubject: 'tooltip',
  attributes: {
    componentName: 'tooltip',
    packageName: __WEBPACK_IMPORTED_MODULE_0__package_json__["name"],
    packageVersion: __WEBPACK_IMPORTED_MODULE_0__package_json__["version"]
  }
};

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CrossCircleIcon = function CrossCircleIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill-rule=\"evenodd\"><circle fill=\"currentColor\" cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M13.477 9.113l-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41z\" fill=\"inherit\"/><path d=\"M9.084 10.501l4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411z\" fill=\"inherit\"/></g></svg>"
  }, props));
};

CrossCircleIcon.displayName = 'CrossCircleIcon';
var _default = CrossCircleIcon;
exports.default = _default;

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = void 0;
var sizes = {
  small: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '48px'
};
exports.sizes = sizes;

/***/ }),
/* 1771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultProps; });
/* unused harmony export Button */
/* unused harmony export DefaultedButton */
/* unused harmony export ButtonBase */
/* unused harmony export ButtonWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_analytics_next__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__withDeprecationWarnings__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getButtonProps__ = __webpack_require__(1772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CustomComponentProxy__ = __webpack_require__(1773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled_getButtonStyles__ = __webpack_require__(1774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled_ButtonContent__ = __webpack_require__(1776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styled_ButtonWrapper__ = __webpack_require__(1777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styled_IconWrapper__ = __webpack_require__(1778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styled_LoadingSpinner__ = __webpack_require__(1779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__package_json__ = __webpack_require__(1787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__atlaskit_type_helpers__ = __webpack_require__(667);














var StyledButton = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].button(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", ";\n"], ["\n  ", ";\n"])), __WEBPACK_IMPORTED_MODULE_7__styled_getButtonStyles__["a" /* default */]);
StyledButton.displayName = 'StyledButton';
// Target the <a> here to override a:hover specificity.
var StyledLink = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].a(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  a& {\n    ", ";\n  }\n"], ["\n  a& {\n    ", ";\n  }\n"])), __WEBPACK_IMPORTED_MODULE_7__styled_getButtonStyles__["a" /* default */]);
StyledLink.displayName = 'StyledLink';
var StyledSpan = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", ";\n"], ["\n  ", ";\n"])), __WEBPACK_IMPORTED_MODULE_7__styled_getButtonStyles__["a" /* default */]);
StyledSpan.displayName = 'StyledSpan';
var createStyledComponent = function () {
    // Override pseudo-state specificity.
    // This is necessary because we don't know what DOM element the custom component will render.
    var component = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_6__CustomComponentProxy__["a" /* default */])(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n    &,\n    a&,\n    &:hover,\n    &:active,\n    &:focus {\n      ", "\n    }\n  "], ["\n    &,\n    a&,\n    &:hover,\n    &:active,\n    &:focus {\n      ", "\n    }\n  "])), __WEBPACK_IMPORTED_MODULE_7__styled_getButtonStyles__["a" /* default */]);
    component.displayName = 'StyledCustomComponent';
    return component;
};
var defaultProps = {
    appearance: 'default',
    isDisabled: false,
    isSelected: false,
    isLoading: false,
    spacing: 'default',
    type: 'button',
    shouldFitContainer: false,
    autoFocus: false,
};
var Button = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Button, _super);
    function Button() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isActive: false,
            isFocus: false,
            isHover: false,
        };
        _this.customComponent = null;
        _this.isInteractive = function () { return !_this.props.isDisabled && !_this.props.isLoading; };
        _this.onMouseEnter = function () {
            _this.setState({ isHover: true });
        };
        _this.onMouseLeave = function () { return _this.setState({ isHover: false, isActive: false }); };
        _this.onMouseDown = function (e) {
            e.preventDefault();
            _this.setState({ isActive: true });
        };
        _this.onMouseUp = function () { return _this.setState({ isActive: false }); };
        _this.onFocus = function (event) {
            _this.setState({ isFocus: true });
            if (_this.props.onFocus) {
                _this.props.onFocus(event);
            }
        };
        _this.onBlur = function (event) {
            _this.setState({ isFocus: false });
            if (_this.props.onBlur) {
                _this.props.onBlur(event);
            }
        };
        /* Swallow click events when the button is disabled to prevent inner child clicks bubbling up */
        _this.onInnerClick = function (e) {
            if (!_this.isInteractive()) {
                e.stopPropagation();
            }
            return true;
        };
        _this.getInnerRef = function (ref) {
            _this.button = ref;
            if (_this.props.innerRef) {
                _this.props.innerRef(ref);
            }
        };
        return _this;
    }
    Button.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.component !== nextProps.component) {
            delete this.customComponent;
        }
    };
    Button.prototype.componentDidMount = function () {
        if (this.props.autoFocus && this.button) {
            this.button.focus();
        }
    };
    Button.prototype.getStyledComponent = function () {
        if (this.props.component) {
            if (!this.customComponent) {
                this.customComponent = createStyledComponent();
            }
            return this.customComponent;
        }
        if (this.props.href) {
            return this.props.isDisabled ? StyledSpan : StyledLink;
        }
        return StyledButton;
    };
    Button.prototype.render = function () {
        var _a = this.props, children = _a.children, iconBefore = _a.iconBefore, iconAfter = _a.iconAfter, isLoading = _a.isLoading, shouldFitContainer = _a.shouldFitContainer, spacing = _a.spacing, appearance = _a.appearance, isSelected = _a.isSelected, isDisabled = _a.isDisabled;
        var buttonProps = Object(__WEBPACK_IMPORTED_MODULE_5__getButtonProps__["a" /* default */])(this);
        var StyledComponent = this.getStyledComponent();
        var iconIsOnlyChild = !!((iconBefore && !iconAfter && !children) ||
            (iconAfter && !iconBefore && !children));
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](StyledComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ innerRef: this.getInnerRef }, buttonProps),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__styled_ButtonWrapper__["a" /* default */], { onClick: this.onInnerClick, fit: !!shouldFitContainer },
                isLoading ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__styled_LoadingSpinner__["a" /* default */], { spacing: spacing, appearance: appearance, isSelected: isSelected, isDisabled: isDisabled })) : null,
                iconBefore ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styled_IconWrapper__["a" /* default */], { isLoading: isLoading, spacing: buttonProps.spacing, isOnlyChild: iconIsOnlyChild }, iconBefore)) : null,
                children ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styled_ButtonContent__["a" /* default */], { isLoading: isLoading, followsIcon: !!iconBefore, spacing: buttonProps.spacing }, children)) : null,
                iconAfter ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styled_IconWrapper__["a" /* default */], { isLoading: isLoading, spacing: buttonProps.spacing, isOnlyChild: iconIsOnlyChild }, iconAfter)) : null)));
    };
    return Button;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

var DefaultedButton = Object(__WEBPACK_IMPORTED_MODULE_13__atlaskit_type_helpers__["a" /* withDefaultProps */])(defaultProps, Button);
var ButtonBase = Button;
var ButtonWithoutAnalytics = Object(__WEBPACK_IMPORTED_MODULE_4__withDeprecationWarnings__["a" /* default */])(DefaultedButton);
var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_analytics_next__["createAndFireEvent"])('atlaskit');
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_analytics_next__["withAnalyticsContext"])({
    componentName: 'button',
    packageName: __WEBPACK_IMPORTED_MODULE_12__package_json__["name"],
    packageVersion: __WEBPACK_IMPORTED_MODULE_12__package_json__["version"],
})(Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_analytics_next__["withAnalyticsEvents"])({
    onClick: createAndFireEventOnAtlaskit({
        action: 'clicked',
        actionSubject: 'button',
        attributes: {
            componentName: 'button',
            packageName: __WEBPACK_IMPORTED_MODULE_12__package_json__["name"],
            packageVersion: __WEBPACK_IMPORTED_MODULE_12__package_json__["version"],
        },
    }),
})(ButtonWithoutAnalytics)));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Button.js.map

/***/ }),
/* 1772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

var getAppearanceProps = function (props, state) {
    var appearance = props.appearance, className = props.className, isDisabled = props.isDisabled, isLoading = props.isLoading, isSelected = props.isSelected, spacing = props.spacing, shouldFitContainer = props.shouldFitContainer;
    var isActive = state.isActive, isFocus = state.isFocus, isHover = state.isHover;
    return {
        appearance: appearance,
        className: className,
        disabled: isDisabled,
        isActive: isActive,
        isFocus: isFocus,
        isHover: isHover,
        isLoading: isLoading,
        isSelected: isSelected,
        spacing: spacing,
        fit: shouldFitContainer,
    };
};
var getInteractionProps = function (component) {
    var onBlur = component.onBlur, onFocus = component.onFocus, onMouseDown = component.onMouseDown, onMouseEnter = component.onMouseEnter, onMouseLeave = component.onMouseLeave, onMouseUp = component.onMouseUp;
    var tabIndex = component.props.tabIndex;
    // Block onClick/Keyboard submit while isLoading
    var onClick = component.props.isLoading
        ? function (e) { return e.preventDefault(); }
        : component.props.onClick;
    return {
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        tabIndex: tabIndex,
    };
};
var getLinkElementProps = function (props) {
    var href = props.href, target = props.target;
    return { href: href, target: target };
};
var getButtonElementProps = function (props) {
    var ariaHaspopup = props.ariaHaspopup, ariaExpanded = props.ariaExpanded, ariaControls = props.ariaControls, form = props.form, type = props.type;
    return {
        'aria-haspopup': ariaHaspopup,
        'aria-expanded': ariaExpanded,
        'aria-controls': ariaControls,
        form: form,
        type: type,
    };
};
var getButtonProps = function (component) {
    var props = component.props, state = component.state;
    var defaultProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ id: props.id }, getAppearanceProps(props, state), getInteractionProps(component), { 'aria-label': props.ariaLabel });
    if (props.component) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, props, defaultProps);
    }
    if (props.href) {
        if (props.isDisabled) {
            return defaultProps;
        }
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, defaultProps, getLinkElementProps(props));
    }
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, defaultProps, getButtonElementProps(props));
};
/* harmony default export */ __webpack_exports__["a"] = (getButtonProps);
//# sourceMappingURL=getButtonProps.js.map

/***/ }),
/* 1773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_analytics_next__ = __webpack_require__(29);

// @flow


var CustomComponentProxy = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CustomComponentProxy, _super);
    function CustomComponentProxy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomComponentProxy.prototype.render = function () {
        var _a = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_analytics_next__["cleanProps"])(this.props), appearance = _a.appearance, children = _a.children, component = _a.component, isActive = _a.isActive, isDisabled = _a.isDisabled, isFocus = _a.isFocus, isHover = _a.isHover, isSelected = _a.isSelected, shouldFitContainer = _a.shouldFitContainer, fit = _a.fit, iconBefore = _a.iconBefore, iconAfter = _a.iconAfter, isLoading = _a.isLoading, proxiedProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["appearance", "children", "component", "isActive", "isDisabled", "isFocus", "isHover", "isSelected", "shouldFitContainer", "fit", "iconBefore", "iconAfter", "isLoading"]);
        if (!component) {
            throw new Error('No custom component provided while trying to use custom button component');
        }
        var ProxiedComponent = component;
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ProxiedComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, proxiedProps), children);
    };
    return CustomComponentProxy;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (CustomComponentProxy);
//# sourceMappingURL=CustomComponentProxy.js.map

/***/ }),
/* 1774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPropertyAppearance */
/* harmony export (immutable) */ __webpack_exports__["a"] = getButtonStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__themeDefinitions__ = __webpack_require__(1775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__theme__ = __webpack_require__(661);





// TODO: Type correctly when @atlaskit/theme is typescript
var getProvidedTheme = function (_a) {
    var theme = _a.theme;
    return (theme && theme[__WEBPACK_IMPORTED_MODULE_4__theme__["a" /* themeNamespace */]]) || {};
};
var getAppearanceProperty = function (property, appearance, providedTheme, inBuiltTheme) {
    var defaultAppearanceStyles = inBuiltTheme.default;
    if (!appearance) {
        return defaultAppearanceStyles[property];
    }
    var providedAppearanceStyles = providedTheme[appearance];
    var inBuiltAppearanceStyles = inBuiltTheme[appearance];
    return ((providedAppearanceStyles && providedAppearanceStyles[property]) ||
        (inBuiltAppearanceStyles && inBuiltAppearanceStyles[property]) ||
        defaultAppearanceStyles[property]);
};
var getState = function (_a) {
    var disabled = _a.disabled, isActive = _a.isActive, isFocus = _a.isFocus, isHover = _a.isHover, isSelected = _a.isSelected;
    if (disabled) {
        return 'disabled';
    }
    if (isSelected && isFocus) {
        return 'focusSelected';
    }
    if (isSelected) {
        return 'selected';
    }
    if (isActive) {
        return 'active';
    }
    if (isHover) {
        return 'hover';
    }
    if (isFocus) {
        return 'focus';
    }
    return 'default';
};
var getPropertyAppearance = function (property, props, definitions) {
    if (props === void 0) { props = {}; }
    if (definitions === void 0) { definitions = __WEBPACK_IMPORTED_MODULE_3__themeDefinitions__["a" /* default */]; }
    var appearance = props.appearance;
    var fallbacks = definitions.fallbacks, inBuiltTheme = definitions.theme;
    var providedTheme = getProvidedTheme(props);
    var propertyStyles = getAppearanceProperty(property, appearance, providedTheme, inBuiltTheme);
    if (!propertyStyles) {
        return fallbacks[property] || 'initial';
    }
    var state = getState(props);
    return propertyStyles[state] || propertyStyles.default || fallbacks[property];
};
function getButtonStyles(props) {
    // $FlowFixMe - should be fixed when theme work is done
    var baseSize = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["fontSize"])(props);
    var buttonHeight = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 4), baseSize)(props) + "em";
    var compactButtonHeight = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 3), baseSize)(props) + "em";
    /**
     * Variable styles
     */
    var cursor = 'default';
    var height = buttonHeight;
    var lineHeight = buttonHeight;
    var outline = 'none';
    // $FlowFixMe - should be fixed when theme work is done
    var padding = "0 " + Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])(props) + "px";
    var transitionDuration = '0.1s, 0.15s';
    var transition = 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)';
    var verticalAlign = 'middle';
    var width = 'auto';
    /**
     * Appearance + Theme styles
     */
    var background = getPropertyAppearance('background', props);
    var color = getPropertyAppearance('color', props);
    var boxShadowColor = getPropertyAppearance('boxShadowColor', props);
    var boxShadow = boxShadowColor
        ? Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n        box-shadow: 0 0 0 2px ", ";\n      "], ["\n        box-shadow: 0 0 0 2px ", ";\n      "])), boxShadowColor) : null;
    var textDecoration = getPropertyAppearance('textDecoration', props);
    // Spacing: Compact
    if (props.spacing === 'compact') {
        height = compactButtonHeight;
        lineHeight = compactButtonHeight;
    }
    // Spacing: None
    if (props.spacing === 'none') {
        height = 'auto';
        lineHeight = 'inherit';
        padding = '0';
        verticalAlign = 'baseline';
    }
    // Interaction: Hover
    if (props.isHover) {
        cursor = 'pointer';
        transition =
            'background 0s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)';
    }
    // Interaction: Active
    if (props.isActive) {
        transitionDuration = '0s';
    }
    // Interaction: Focus
    if (props.isFocus) {
        outline = 'none';
        transitionDuration = '0s, 0.2s';
    }
    // Disabled
    if (props.disabled) {
        cursor = 'not-allowed';
    }
    // Loading
    var isLoadingStyles = function (p) {
        return p.isLoading ? 'pointer-events: none;' : null;
    };
    // Fit to parent width
    if (props.fit) {
        width = '100%';
    }
    /* Note use of !important to override the ThemeReset on anchor tag styles */
    return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n    align-items: baseline;\n    background: ", ";\n    border-radius: ", "px;\n    border-width: 0;\n    box-sizing: border-box;\n    color: ", " !important;\n    cursor: ", ";\n    display: inline-flex;\n    font-size: inherit;\n    font-style: normal;\n    height: ", ";\n    line-height: ", ";\n    margin: 0;\n    max-width: 100%;\n    outline: ", " !important;\n    padding: ", ";\n    text-align: center;\n    text-decoration: ", ";\n    transition: ", ";\n    transition-duration: ", ";\n    vertical-align: ", ";\n    white-space: nowrap;\n    width: ", ";\n    ", " &::-moz-focus-inner {\n      border: 0;\n      margin: 0;\n      padding: 0;\n    }\n    ", ";\n  "], ["\n    align-items: baseline;\n    background: ", ";\n    border-radius: ", "px;\n    border-width: 0;\n    box-sizing: border-box;\n    color: ", " !important;\n    cursor: ", ";\n    display: inline-flex;\n    font-size: inherit;\n    font-style: normal;\n    height: ", ";\n    line-height: ", ";\n    margin: 0;\n    max-width: 100%;\n    outline: ", " !important;\n    padding: ", ";\n    text-align: center;\n    text-decoration: ", ";\n    transition: ", ";\n    transition-duration: ", ";\n    vertical-align: ", ";\n    white-space: nowrap;\n    width: ", ";\n    ", " &::-moz-focus-inner {\n      border: 0;\n      margin: 0;\n      padding: 0;\n    }\n    ", ";\n  "])), background, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"], color, cursor, height, lineHeight, outline, padding, textDecoration, transition, transitionDuration, verticalAlign, width, boxShadow, isLoadingStyles);
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=getButtonStyles.js.map

/***/ }),
/* 1775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);

/**
 * Convert a hex colour code to RGBA.
 * @param {String} hex Hex colour code.
 * @param {Number} alpha Optional alpha value (defaults to 1).
 *
 */
var hex2rgba = function (hex, alpha) {
    if (alpha === void 0) { alpha = 1; }
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        var colorArr = hex.substring(1).split('');
        if (colorArr.length === 3) {
            colorArr = [
                colorArr[0],
                colorArr[0],
                colorArr[1],
                colorArr[1],
                colorArr[2],
                colorArr[2],
            ];
        }
        var color = "0x" + colorArr.join('');
        // FIXME: `>>` operand can validly take a string value
        var r = (color >> 16) & 255;
        var g = (color >> 8) & 255;
        var b = color & 255;
        return "rgba(" + [r, g, b].join(',') + ", " + alpha + ")";
    }
    throw new Error('Bad Hex');
};
/* eslint-enable no-bitwise */
/* harmony default export */ __webpack_exports__["a"] = ({
    // Fallbacks
    fallbacks: {
        background: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN70 }),
        color: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
        textDecoration: 'none',
    },
    // Themes
    theme: {
        // Default appearance
        default: {
            background: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN70 }),
                hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N30A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN60 }),
                active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75, 0.6), dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN70 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN0 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN0 }),
            },
            boxShadowColor: {
                focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200, 0.6), dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
                    light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200, 0.6),
                    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75,
                }),
            },
            color: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
                active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN30 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
            },
        },
        // Primary appearance
        primary: {
            background: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100 }),
                hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B300, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75 }),
                active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN70 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN0 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN0 }),
            },
            boxShadowColor: {
                focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200, 0.6), dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
                    light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200, 0.6),
                    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75,
                }),
            },
            color: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN30 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN30 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
            },
        },
        // Warning appearance
        warning: {
            background: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y300, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y300 }),
                hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y200, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y200 }),
                active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y400 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN70 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y400 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y400 }),
            },
            boxShadowColor: {
                focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y500 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y500 }),
            },
            color: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N800, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N800 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN30 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N800, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N800 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N800, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N800 }),
            },
        },
        // Danger appearance
        danger: {
            background: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R400 }),
                hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R300, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R300 }),
                active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R500 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN70 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R500 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R500 }),
            },
            boxShadowColor: {
                focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R100, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R100 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R100, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R100 }),
            },
            color: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN30 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0 }),
            },
        },
        // Help appearance
        help: {
            background: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P400 }),
                hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P200, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P200 }),
                active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P500 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN70 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN0 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R500 }),
            },
            boxShadowColor: {
                focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P100, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P100 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P100, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P100 }),
            },
            color: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN30 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0 }),
            },
        },
        // Link appearance
        link: {
            background: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: 'none', dark: 'none' }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20 }),
            },
            boxShadowColor: {
                focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200, 0.6), dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
                    light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200, 0.6),
                    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75,
                }),
            },
            color: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100 }),
                hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B300, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75 }),
                active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN100 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700 }),
            },
            textDecoration: {
                hover: 'underline',
            },
        },
        // Subtle appearance
        subtle: {
            background: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: 'none', dark: 'none' }),
                hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N30A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN60 }),
                active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75, 0.6), dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: 'none', dark: 'none' }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN0 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN0 }),
            },
            boxShadowColor: {
                focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200, 0.6), dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
                    light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200, 0.6),
                    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75,
                }),
            },
            color: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
                active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN100 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
            },
        },
        // Subtle Link appearance
        'subtle-link': {
            background: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: 'none', dark: 'none' }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20 }),
            },
            boxShadowColor: {
                focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200, 0.6), dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
                    light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200, 0.6),
                    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75,
                }),
            },
            color: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N200, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
                hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N90, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B50 }),
                active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN300 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN100 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
            },
            textDecoration: {
                hover: 'underline',
            },
        },
    },
});
//# sourceMappingURL=themeDefinitions.js.map

/***/ }),
/* 1776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(662);




var getAlignment = function (p) { return (p.followsIcon ? 'baseline' : 'center'); };
var gridSizeDiv2 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 2);
var getMargin = function (p) {
    return p.spacing === 'none' ? 0 : "0 " + gridSizeDiv2(p) + "px";
};
var ButtonContent = function (props) {
    var style = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ alignItems: getAlignment(props), alignSelf: getAlignment(props), flex: '1 1 auto', margin: getMargin(props), maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }, Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* getLoadingStyle */])(props));
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { style: style }, props.children);
};
/* harmony default export */ __webpack_exports__["a"] = (ButtonContent);
//# sourceMappingURL=ButtonContent.js.map

/***/ }),
/* 1777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var ButtonWrapper = function (props) {
    var style = {
        alignSelf: 'center',
        display: 'inline-flex',
        flexWrap: 'nowrap',
        maxWidth: '100%',
        position: 'relative',
    };
    if (props.fit) {
        style.width = '100%';
        style.justifyContent = 'center';
    }
    var optionalProps = {};
    if (props.onClick) {
        optionalProps.onClick = props.onClick;
    }
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ style: style }, optionalProps), props.children));
};
/* harmony default export */ __webpack_exports__["a"] = (ButtonWrapper);
//# sourceMappingURL=ButtonWrapper.js.map

/***/ }),
/* 1778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(662);




var getMargin = function (props) {
    if (props.spacing === 'none') {
        return 0;
    }
    if (props.isOnlyChild) {
        return "0 -" + __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 4)(props) + "px";
    }
    return "0 " + __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 2)(props) + "px";
};
var IconWrapper = function (props) {
    var style = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ alignSelf: 'center', display: 'flex', flexShrink: 0, lineHeight: 0, fontSize: 0, margin: getMargin(props), userSelect: 'none' }, Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* getLoadingStyle */])(props));
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { style: style }, props.children);
};
/* harmony default export */ __webpack_exports__["a"] = (IconWrapper);
//# sourceMappingURL=IconWrapper.js.map

/***/ }),
/* 1779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_spinner__ = __webpack_require__(62);




var LoadingDiv = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n"], ["\n  display: flex;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n"])));
var LoadingSpinner = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](LoadingSpinner, _super);
    function LoadingSpinner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.invertSpinner = function () {
            var _a = _this.props, appearance = _a.appearance, isSelected = _a.isSelected, isDisabled = _a.isDisabled;
            if (isSelected) {
                return true;
            }
            if (isDisabled) {
                return false;
            }
            if (appearance === 'primary' ||
                appearance === 'danger' ||
                appearance === 'help') {
                return true;
            }
            return false;
        };
        return _this;
    }
    LoadingSpinner.prototype.render = function () {
        var spacing = this.props.spacing;
        var spinnerSize = 'medium';
        if (spacing !== 'default') {
            spinnerSize = 'small';
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](LoadingDiv, null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_spinner__["a" /* default */], { size: spinnerSize, invertColor: this.invertSpinner() })));
    };
    return LoadingSpinner;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (LoadingSpinner);
var templateObject_1;
//# sourceMappingURL=LoadingSpinner.js.map

/***/ }),
/* 1780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Spinner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group__ = __webpack_require__(1781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styledContainer__ = __webpack_require__(1785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styledSvg__ = __webpack_require__(1786);













var Outer = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div.withConfig({
  displayName: "Spinner__Outer",
  componentId: "sc-1ejgacn-0"
})(["\n  display: inline-block;\n  vertical-align: middle;\n"]);
Outer.displayName = 'Outer';

var Spinner =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Spinner, _Component);

  function Spinner(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Spinner);

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Spinner).call(this, props));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "transitionNode", void 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "enter", function () {
      var delay = _this.props.delay;

      if (delay) {
        _this.setState({
          phase: 'DELAY'
        });
      } else {
        _this.setState({
          phase: 'ENTER'
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "idle", function () {
      _this.setState({
        phase: 'IDLE'
      });
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "exit", function () {
      _this.setState({
        phase: 'LEAVE'
      });
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "endListener", function (node, done) {
      var executeCallback = function executeCallback(event) {
        // ignore animation events on the glyph
        // $FlowFixMe - tagName does not exist in event.target
        if (event.target.tagName === 'svg') {
          return false;
        }

        if (_this.state.phase === 'DELAY') {
          _this.setState({
            phase: 'ENTER'
          });

          _this.endListener(node, done);
        } else {
          done();
        }

        return node && node.removeEventListener('animationend', executeCallback);
      };

      return node && node.addEventListener('animationend', executeCallback);
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "validateSize", function () {
      var size = _this.props.size;
      var spinnerSize = __WEBPACK_IMPORTED_MODULE_10__constants__["b" /* SIZES_MAP */][size] || size;
      return typeof spinnerSize === 'number' ? spinnerSize : __WEBPACK_IMPORTED_MODULE_10__constants__["a" /* DEFAULT_SIZE */];
    });

    _this.state = {
      phase: ''
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Spinner, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var phase = this.state.phase;
      var _this$props = this.props,
          delay = _this$props.delay,
          invertColor = _this$props.invertColor,
          isCompleting = _this$props.isCompleting;
      var size = this.validateSize();
      var strokeWidth = Math.round(size / 10);
      var strokeRadius = size / 2 - strokeWidth / 2;
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Outer, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_transition_group__["Transition"], {
        addEndListener: this.endListener,
        appear: true,
        in: !isCompleting,
        mountOnEnter: true,
        unmountOnExit: true,
        onEnter: this.enter,
        onEntered: this.idle,
        onExit: this.exit,
        onExited: function onExited() {
          return _this2.props.onComplete();
        },
        ref: function ref(node) {
          _this2.transitionNode = node;
        }
      }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styledContainer__["a" /* default */], {
        delay: delay / 1000,
        phase: phase,
        size: size
      }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__styledSvg__["a" /* default */], {
        focusable: "false",
        height: size,
        invertColor: invertColor,
        phase: phase,
        size: size,
        viewBox: "0 0 ".concat(size, " ").concat(size),
        width: size,
        xmlns: "http://www.w3.org/2000/svg"
      }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("circle", {
        cx: size / 2,
        cy: size / 2,
        r: strokeRadius
      })))));
    }
  }]);

  return Spinner;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Spinner, "defaultProps", {
  delay: 100,
  isCompleting: false,
  invertColor: false,
  onComplete: function onComplete() {},
  size: 'medium'
});



/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__(1782));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__(1783));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(665));

var _Transition = _interopRequireDefault(__webpack_require__(663));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(10));

var _addClass = _interopRequireDefault(__webpack_require__(244));

var _removeClass = _interopRequireDefault(__webpack_require__(245));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireDefault(__webpack_require__(663));

var _PropTypes = __webpack_require__(664);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};

var propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply spread
   * them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};;
/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 */

var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames7 = this.getClassNames(type),
        className = _this$getClassNames7.className,
        activeClassName = _this$getClassNames7.activeClassName,
        doneClassName = _this$getClassNames7.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(18);

var _TransitionGroup = _interopRequireDefault(__webpack_require__(665));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var propTypes =  false ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};;
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? propTypes : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 1785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getContainerAnimation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);


/* Define keyframes statically to prevent a perfomance issue in styled components v1 where the keyframes function
 * does not cache previous values resulting in each spinner injecting the same keyframe definition
 * in the DOM.
 * This can be reverted to use dynamic keyframes when we upgrade to styled components v2
 */
var keyframeNames = {
  noop: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["keyframes"])(["\n    from { opacity: 0; }\n    to { opacity: 0; }\n  "]),
  enterRotate: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["keyframes"])(["\n    from { transform: rotate(50deg); }\n    to { transform: rotate(230deg); }\n  "]),
  leaveRotate: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["keyframes"])(["\n    from { transform: rotate(230deg); }\n    to { transform: rotate(510deg); }\n  "]),
  leaveOpacity: Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["keyframes"])(["\n    from { opacity: 1; }\n    to { opacity: 0; }\n  "])
};
var getContainerAnimation = function getContainerAnimation(_ref) {
  var delay = _ref.delay,
      phase = _ref.phase;

  if (phase === 'DELAY') {
    /* This hides the spinner and allows us to use animationend events to move to the next phase in
     * the same way we do with the other lifecycle stages */
    return "animation: ".concat(delay, "s ").concat(keyframeNames.noop, ";");
  }

  if (phase === 'ENTER' || phase === 'IDLE') {
    return "animation: 1s ease-in-out forwards ".concat(keyframeNames.enterRotate, ";");
  }

  if (phase === 'LEAVE') {
    return "animation: 0.53s ease-in-out forwards ".concat(keyframeNames.leaveRotate, ",\n      0.2s ease-in-out 0.33s ").concat(keyframeNames.leaveOpacity, ";");
  }

  return '';
};

var getSize = function getSize(_ref2) {
  var size = _ref2.size;
  return "".concat(size, "px");
};

var Container = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "styledContainer__Container",
  componentId: "sc-1qs8wxp-0"
})(["\n  ", " display: flex;\n  height: ", ";\n  width: ", ";\n\n  /* Rapidly creating and removing spinners will result in multiple spinners being visible while\n   * they complete their exit animations. This rules hides the spinner if another one has been\n   * added. */\n  div + & {\n    display: none;\n  }\n"], getContainerAnimation, getSize, getSize);
Container.displayName = 'SpinnerContainer';
/* harmony default export */ __webpack_exports__["a"] = (Container);

/***/ }),
/* 1786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getStrokeColor */
/* unused harmony export svgStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(666);





var getStrokeWidth = function getStrokeWidth(size) {
  return Math.round(size / 10);
};

var getStrokeCircumference = function getStrokeCircumference(size) {
  var strokeWidth = getStrokeWidth(size);
  var strokeRadius = size / 2 - strokeWidth / 2;
  return Math.PI * strokeRadius * 2;
};
/* Define keyframes statically to prevent a perfomance issue in styled components v1 where the keyframes function
 * does not cache previous values resulting in each spinner injecting the same keyframe definition
 * in the DOM.
 * This can be reverted to dynamic keyframes when we upgrade to styled components v2
 */


var keyframeNames = {
  noop: Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(["\n    from { opacity: 0; }\n    to { opacity: 0; }\n  "]),
  rotate: Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(["\n    to { transform: rotate(360deg); }\n  "]),
  enterOpacity: Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(["\n    from { opacity: 0; }\n    to { opacity: 1; }\n  "]),
  smallEnterStroke: Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(["\n    from { stroke-dashoffset: ", "px; }\n    to { stroke-dashoffset: ", "px; }\n  "], getStrokeCircumference(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SIZES_MAP */].small), getStrokeCircumference(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SIZES_MAP */].small) * 0.8),
  mediumEnterStroke: Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(["\n    from { stroke-dashoffset: ", "px; }\n    to { stroke-dashoffset: ", "px; }\n  "], getStrokeCircumference(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SIZES_MAP */].medium), getStrokeCircumference(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SIZES_MAP */].medium) * 0.8),
  largeEnterStroke: Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(["\n    from { stroke-dashoffset: ", "px; }\n    to { stroke-dashoffset: ", "px; }\n  "], getStrokeCircumference(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SIZES_MAP */].large), getStrokeCircumference(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SIZES_MAP */].large) * 0.8),
  xlargeEnterStroke: Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(["\n    from { stroke-dashoffset: ", "px; }\n    to { stroke-dashoffset: ", "px; }\n  "], getStrokeCircumference(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SIZES_MAP */].xlarge), getStrokeCircumference(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SIZES_MAP */].xlarge) * 0.8)
};
/* If a standard size is used, we can use one of our statically defined keyframes, otherwise
 * we're forced to dynamically create the keyframe and incur a performance cost.
 */

var getEnterStrokeKeyframe = function getEnterStrokeKeyframe(size) {
  var standardSizeName = Object.keys(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SIZES_MAP */]).find(function (sizeName) {
    return size === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SIZES_MAP */][sizeName];
  });

  if (standardSizeName) {
    return keyframeNames["".concat(standardSizeName, "EnterStroke")];
  }

  var circumference = getStrokeCircumference(size);
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(["\n    from { stroke-dashoffset: ", "px; }\n    to { stroke-dashoffset: ", "px; }\n  "], circumference, circumference * 0.8);
};

var spinnerColor = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N500,
  dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N0
});
var spinnerColorInverted = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N0,
  dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N0
});
var getStrokeColor = function getStrokeColor(_ref // $FlowFixMe - theme is not found in props
) {
  var invertColor = _ref.invertColor,
      props = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(_ref, ["invertColor"]);

  return invertColor ? spinnerColorInverted(props) : spinnerColor(props);
};
var svgStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(["\n  ", ";\n"], function (props) {
  var circumference = getStrokeCircumference(props.size);
  var idleRotation = "0.86s cubic-bezier(0.4, 0.15, 0.6, 0.85) infinite ".concat(keyframeNames.rotate);
  var spinUpStroke = "0.8s ease-in-out ".concat(getEnterStrokeKeyframe(props.size));
  var spinUpOpacity = "0.2s ease-in-out ".concat(keyframeNames.enterOpacity);
  var activeAnimations = [idleRotation];

  if (props.phase === 'ENTER') {
    activeAnimations.push(spinUpStroke, spinUpOpacity);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(["\n      animation: ", ";\n      fill: none;\n      stroke: ", ";\n      stroke-dasharray: ", "px;\n      stroke-dashoffset: ", "px;\n      stroke-linecap: round;\n      stroke-width: ", "px;\n      transform-origin: center;\n    "], activeAnimations.join(', '), getStrokeColor, circumference, circumference * 0.8, getStrokeWidth(props.size));
});
var Svg = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].svg.withConfig({
  displayName: "styledSvg__Svg",
  componentId: "y2l69q-0"
})(["\n  ", ";\n"], svgStyles);
Svg.displayName = 'SpinnerSvg';
/* harmony default export */ __webpack_exports__["a"] = (Svg);

/***/ }),
/* 1787 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/button","version":"10.1.1","sideEffects":false}

/***/ }),
/* 1788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__withDeprecationWarnings__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled_ButtonGroup__ = __webpack_require__(1789);




var ButtonGroup = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ButtonGroup, _super);
    function ButtonGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ButtonGroup.prototype.render = function () {
        var _a = this.props, appearance = _a.appearance, children = _a.children;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled_ButtonGroup__["b" /* default */], null, __WEBPACK_IMPORTED_MODULE_1_react__["Children"].map(children, function (child, idx) {
            if (!child) {
                return null;
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled_ButtonGroup__["a" /* GroupItem */], { key: idx }, appearance
                ? __WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"](child, { appearance: appearance })
                : child));
        })));
    };
    return ButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__withDeprecationWarnings__["a" /* default */])(ButtonGroup));
//# sourceMappingURL=ButtonGroup.js.map

/***/ }),
/* 1789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: inline-flex;\n"], ["\n  display: inline-flex;\n"]))));
var GroupItem = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  flex: 1 0 auto;\n  display: flex;\n\n  /* margins don't flip when the layout uses dir=\"rtl\", whereas pseudos do */\n  & + &::before {\n    content: '';\n    display: inline-block;\n    width: ", "px;\n  }\n"], ["\n  flex: 1 0 auto;\n  display: flex;\n\n  /* margins don't flip when the layout uses dir=\"rtl\", whereas pseudos do */\n  & + &::before {\n    content: '';\n    display: inline-block;\n    width: ", "px;\n  }\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() / 2);
var templateObject_1, templateObject_2;
//# sourceMappingURL=ButtonGroup.js.map

/***/ }),
/* 1790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TypeStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatting__ = __webpack_require__(1791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_free_style__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_free_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_free_style__);



/**
 * Creates an instance of free style with our options
 */
var createFreeStyle = function () { return __WEBPACK_IMPORTED_MODULE_2_free_style__["create"](
/** Use the default hash function */
undefined, 
/** Preserve $debugName values */
true); };
/**
 * Maintains a single stylesheet and keeps it in sync with requested styles
 */
var TypeStyle = (function () {
    function TypeStyle(_a) {
        var autoGenerateTag = _a.autoGenerateTag;
        var _this = this;
        /**
         * Insert `raw` CSS as a string. This is useful for e.g.
         * - third party CSS that you are customizing with template strings
         * - generating raw CSS in JavaScript
         * - reset libraries like normalize.css that you can use without loaders
         */
        this.cssRaw = function (mustBeValidCSS) {
            if (!mustBeValidCSS) {
                return;
            }
            _this._raw += mustBeValidCSS || '';
            _this._pendingRawChange = true;
            _this._styleUpdated();
        };
        /**
         * Takes CSSProperties and registers it to a global selector (body, html, etc.)
         */
        this.cssRule = function (selector) {
            var objects = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                objects[_i - 1] = arguments[_i];
            }
            var object = Object(__WEBPACK_IMPORTED_MODULE_0__formatting__["a" /* ensureStringObj */])(__WEBPACK_IMPORTED_MODULE_1__utilities__["a" /* extend */].apply(void 0, objects)).result;
            _this._freeStyle.registerRule(selector, object);
            _this._styleUpdated();
            return;
        };
        /**
         * Renders styles to the singleton tag imediately
         * NOTE: You should only call it on initial render to prevent any non CSS flash.
         * After that it is kept sync using `requestAnimationFrame` and we haven't noticed any bad flashes.
         **/
        this.forceRenderStyles = function () {
            var target = _this._getTag();
            if (!target) {
                return;
            }
            target.textContent = _this.getStyles();
        };
        /**
         * Utility function to register an @font-face
         */
        this.fontFace = function () {
            var fontFace = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                fontFace[_i] = arguments[_i];
            }
            var freeStyle = _this._freeStyle;
            for (var _a = 0, _b = fontFace; _a < _b.length; _a++) {
                var face = _b[_a];
                freeStyle.registerRule('@font-face', face);
            }
            _this._styleUpdated();
            return;
        };
        /**
         * Allows use to use the stylesheet in a node.js environment
         */
        this.getStyles = function () {
            return (_this._raw || '') + _this._freeStyle.getStyles();
        };
        /**
         * Takes keyframes and returns a generated animationName
         */
        this.keyframes = function (frames) {
            var _a = Object(__WEBPACK_IMPORTED_MODULE_0__formatting__["b" /* explodeKeyframes */])(frames), keyframes = _a.keyframes, $debugName = _a.$debugName;
            // TODO: replace $debugName with display name
            var animationName = _this._freeStyle.registerKeyframes(keyframes, $debugName);
            _this._styleUpdated();
            return animationName;
        };
        /**
         * Helps with testing. Reinitializes FreeStyle + raw
         */
        this.reinit = function () {
            /** reinit freestyle */
            var freeStyle = createFreeStyle();
            _this._freeStyle = freeStyle;
            _this._lastFreeStyleChangeId = freeStyle.changeId;
            /** reinit raw */
            _this._raw = '';
            _this._pendingRawChange = false;
            /** Clear any styles that were flushed */
            var target = _this._getTag();
            if (target) {
                target.textContent = '';
            }
        };
        /** Sets the target tag where we write the css on style updates */
        this.setStylesTarget = function (tag) {
            /** Clear any data in any previous tag */
            if (_this._tag) {
                _this._tag.textContent = '';
            }
            _this._tag = tag;
            /** This special time buffer immediately */
            _this.forceRenderStyles();
        };
        /**
         * Takes CSSProperties and return a generated className you can use on your component
         */
        this.style = function () {
            var objects = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                objects[_i] = arguments[_i];
            }
            var freeStyle = _this._freeStyle;
            var _a = Object(__WEBPACK_IMPORTED_MODULE_0__formatting__["a" /* ensureStringObj */])(__WEBPACK_IMPORTED_MODULE_1__utilities__["a" /* extend */].apply(void 0, objects)), result = _a.result, debugName = _a.debugName;
            var className = debugName ? freeStyle.registerStyle(result, debugName) : freeStyle.registerStyle(result);
            _this._styleUpdated();
            return className;
        };
        /**
         * Takes an object where property names are ideal class names and property values are CSSProperties, and
         * returns an object where property names are the same ideal class names and the property values are
         * the actual generated class names using the ideal class name as the $debugName
         */
        this.stylesheet = function (classes) {
            var classNames = Object.getOwnPropertyNames(classes);
            var result = {};
            for (var _i = 0, classNames_1 = classNames; _i < classNames_1.length; _i++) {
                var className = classNames_1[_i];
                var classDef = classes[className];
                if (classDef) {
                    classDef.$debugName = className;
                    result[className] = _this.style(classDef);
                }
            }
            return result;
        };
        var freeStyle = createFreeStyle();
        this._autoGenerateTag = autoGenerateTag;
        this._freeStyle = freeStyle;
        this._lastFreeStyleChangeId = freeStyle.changeId;
        this._pending = 0;
        this._pendingRawChange = false;
        this._raw = '';
        this._tag = undefined;
    }
    /**
     * Only calls cb all sync operations settle
     */
    TypeStyle.prototype._afterAllSync = function (cb) {
        var _this = this;
        this._pending++;
        var pending = this._pending;
        Object(__WEBPACK_IMPORTED_MODULE_1__utilities__["b" /* raf */])(function () {
            if (pending !== _this._pending) {
                return;
            }
            cb();
        });
    };
    TypeStyle.prototype._getTag = function () {
        if (this._tag) {
            return this._tag;
        }
        if (this._autoGenerateTag) {
            var tag = typeof window === 'undefined'
                ? { textContent: '' }
                : document.createElement('style');
            if (typeof document !== 'undefined') {
                document.head.appendChild(tag);
            }
            this._tag = tag;
            return tag;
        }
        return undefined;
    };
    /** Checks if the style tag needs updating and if so queues up the change */
    TypeStyle.prototype._styleUpdated = function () {
        var _this = this;
        var changeId = this._freeStyle.changeId;
        var lastChangeId = this._lastFreeStyleChangeId;
        if (!this._pendingRawChange && changeId === lastChangeId) {
            return;
        }
        this._lastFreeStyleChangeId = changeId;
        this._pendingRawChange = false;
        this._afterAllSync(function () { return _this.forceRenderStyles(); });
    };
    return TypeStyle;
}());



/***/ }),
/* 1791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ensureStringObj;
/* harmony export (immutable) */ __webpack_exports__["b"] = explodeKeyframes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_free_style__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_free_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_free_style__);

/**
 * We need to do the following to *our* objects before passing to freestyle:
 * - For any `$nest` directive move up to FreeStyle style nesting
 * - For any `$unique` directive map to FreeStyle Unique
 * - For any `$debugName` directive return the debug name
 */
function ensureStringObj(object) {
    /** The final result we will return */
    var result = {};
    var debugName = '';
    for (var key in object) {
        /** Grab the value upfront */
        var val = object[key];
        /** TypeStyle configuration options */
        if (key === '$unique') {
            result[__WEBPACK_IMPORTED_MODULE_0_free_style__["IS_UNIQUE"]] = val;
        }
        else if (key === '$nest') {
            var nested = val;
            for (var selector in nested) {
                var subproperties = nested[selector];
                result[selector] = ensureStringObj(subproperties).result;
            }
        }
        else if (key === '$debugName') {
            debugName = val;
        }
        else {
            result[key] = val;
        }
    }
    return { result: result, debugName: debugName };
}
// todo: better name here
function explodeKeyframes(frames) {
    var result = { $debugName: undefined, keyframes: {} };
    for (var offset in frames) {
        var val = frames[offset];
        if (offset === '$debugName') {
            result.$debugName = val;
        }
        else {
            result.keyframes[offset] = val;
        }
    }
    return result;
}


/***/ }),
/* 1792 */
/***/ (function(module, exports) {



/***/ }),
/* 1793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EmojiPlaceholder__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LoadingEmojiComponent__ = __webpack_require__(383);





var resourcedEmojiModuleLoader = function () {
    return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 3458));
};
var resourcedEmojiComponentLoader = function () { return resourcedEmojiModuleLoader().then(function (module) { return module.default; }); };
var ResourcedEmoji = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ResourcedEmoji, _super);
    function ResourcedEmoji() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            asyncLoadedComponent: ResourcedEmoji.AsyncLoadedComponent,
        };
        return _this;
    }
    ResourcedEmoji.prototype.asyncLoadComponent = function () {
        var _this = this;
        resourcedEmojiComponentLoader().then(function (component) {
            ResourcedEmoji.AsyncLoadedComponent = component;
            _this.setAsyncState(component);
        });
    };
    ResourcedEmoji.prototype.renderLoading = function () {
        var _a = this.props, fitToHeight = _a.fitToHeight, emojiId = _a.emojiId, showTooltip = _a.showTooltip;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__EmojiPlaceholder__["a" /* default */], { shortName: emojiId.shortName, showTooltip: showTooltip, size: fitToHeight || __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* defaultEmojiHeight */] }));
    };
    ResourcedEmoji.prototype.renderLoaded = function (loadedEmojiProvider, ResourcedEmojiComponent) {
        var _a = this.props, emojiProvider = _a.emojiProvider, otherProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["emojiProvider"]);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ResourcedEmojiComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, otherProps, { emojiProvider: loadedEmojiProvider })));
    };
    return ResourcedEmoji;
}(__WEBPACK_IMPORTED_MODULE_4__LoadingEmojiComponent__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (ResourcedEmoji);
//# sourceMappingURL=ResourcedEmoji.js.map

/***/ }),
/* 1794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EmojiPickerInternal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_analytics__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_LoadingEmojiComponent__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EmojiPickerVirtualItems__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(179);






var emojiPickerModuleLoader = function () {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 3459));
};
var emojiPickerLoader = function () {
    return emojiPickerModuleLoader().then(function (module) { return module.default; });
};
var EmojiPickerInternal = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiPickerInternal, _super);
    function EmojiPickerInternal(props) {
        var _this = _super.call(this, props, {}) || this;
        _this.state = {
            asyncLoadedComponent: EmojiPickerInternal.AsyncLoadedComponent,
        };
        return _this;
    }
    EmojiPickerInternal.prototype.asyncLoadComponent = function () {
        var _this = this;
        emojiPickerLoader().then(function (component) {
            EmojiPickerInternal.AsyncLoadedComponent = component;
            _this.setAsyncState(component);
        });
    };
    EmojiPickerInternal.prototype.renderLoading = function () {
        var _this = this;
        var item = new __WEBPACK_IMPORTED_MODULE_4__EmojiPickerVirtualItems__["c" /* LoadingItem */]();
        var handlePickerRef = function (ref) {
            if (_this.props.onPickerRef) {
                _this.props.onPickerRef(ref);
            }
        };
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_5__styles__["g" /* emojiPicker */], ref: handlePickerRef }, item.renderItem()));
    };
    EmojiPickerInternal.prototype.renderLoaded = function (loadedEmojiProvider, EmojiPickerComponent) {
        var _a = this.props, emojiProvider = _a.emojiProvider, otherProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["emojiProvider"]);
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](EmojiPickerComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ emojiProvider: loadedEmojiProvider }, otherProps)));
    };
    return EmojiPickerInternal;
}(__WEBPACK_IMPORTED_MODULE_3__common_LoadingEmojiComponent__["a" /* default */]));

// tslint:disable-next-line:variable-name
var EmojiPicker = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_analytics__["a" /* withAnalytics */])(EmojiPickerInternal, {}, {});
/* harmony default export */ __webpack_exports__["a"] = (EmojiPicker);
//# sourceMappingURL=EmojiPicker.js.map

/***/ }),
/* 1795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchEvent__ = __webpack_require__(670);










/* eslint-disable react/sort-comp */



/* The Decorator component extends analytics event data for any events fired by
its descendents, then passes the event up the hierarchy */

var ContextTypes = {
  onAnalyticsEvent: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
  getParentAnalyticsData: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func
};

var AnalyticsDecorator =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(AnalyticsDecorator, _Component);

  function AnalyticsDecorator() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, AnalyticsDecorator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(AnalyticsDecorator)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getDecoratedAnalyticsData", function (name, srcData, isPrivate) {
      // Decorate the event data if this decorator matches the event name
      var _this$props = _this.props,
          data = _this$props.data,
          getData = _this$props.getData,
          match = _this$props.match,
          matchPrivate = _this$props.matchPrivate;

      var decoratedData = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, srcData);

      if (matchPrivate === isPrivate && Object(__WEBPACK_IMPORTED_MODULE_11__matchEvent__["a" /* default */])(match, name)) {
        if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(data) === 'object') {
          Object.assign(decoratedData, data);
        }

        if (typeof getData === 'function') {
          Object.assign(decoratedData, getData(name, decoratedData));
        }
      }

      return decoratedData;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onAnalyticsEvent", function (name, srcData, isPrivate) {
      // Check there is a listener to pass the event to, otherwise there's no need
      // to do any of this work
      var onAnalyticsEvent = _this.context.onAnalyticsEvent;
      if (typeof onAnalyticsEvent !== 'function') return;

      var decoratedData = _this.getDecoratedAnalyticsData(name, srcData, isPrivate); // Pass the decorated event data to the next listener up the hierarchy


      onAnalyticsEvent(name, decoratedData, isPrivate);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getParentAnalyticsData", function (name, isPrivate) {
      var parentData = _this.getDecoratedAnalyticsData(name, {}, isPrivate); // Get any analytics data from any decorators up the hierarchy


      var getParentAnalyticsData = _this.context.getParentAnalyticsData;

      if (typeof getParentAnalyticsData === 'function') {
        Object.assign(parentData, getParentAnalyticsData(name, isPrivate));
      }

      return parentData;
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(AnalyticsDecorator, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        onAnalyticsEvent: this.onAnalyticsEvent,
        getParentAnalyticsData: this.getParentAnalyticsData
      };
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children; // eslint-disable-line react/prop-types

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.Children.only(children);
    }
  }]);

  return AnalyticsDecorator;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(AnalyticsDecorator, "defaultProps", {
  match: '*',
  matchPrivate: false
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(AnalyticsDecorator, "contextTypes", ContextTypes);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(AnalyticsDecorator, "childContextTypes", ContextTypes);

/* unused harmony default export */ var _unused_webpack_default_export = (AnalyticsDecorator);

/***/ }),
/* 1796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);









/* eslint-disable react/sort-comp */


/*
Listens to public and private events and delegates to an analytics
stack in a different React root.
*/

var ContextTypes = {
  onAnalyticsEvent: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
};

var AnalyticsDelegate =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(AnalyticsDelegate, _Component);

  function AnalyticsDelegate() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, AnalyticsDelegate);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(AnalyticsDelegate)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onAnalyticsEvent", function (name, data, isPrivate) {
      var delegateAnalyticsEvent = _this.props.delegateAnalyticsEvent; // send a clean data object so it can't be mutated between listeners

      var eventData = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, data);

      if (delegateAnalyticsEvent) {
        delegateAnalyticsEvent(name, eventData, isPrivate);
      } // Pass the event up the hierarchy


      var onAnalyticsEvent = _this.context.onAnalyticsEvent;

      if (typeof onAnalyticsEvent === 'function') {
        onAnalyticsEvent(name, data, isPrivate);
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(AnalyticsDelegate, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        onAnalyticsEvent: this.onAnalyticsEvent
      };
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children; // eslint-disable-line react/prop-types

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.Children.only(children);
    }
  }]);

  return AnalyticsDelegate;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(AnalyticsDelegate, "contextTypes", ContextTypes);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(AnalyticsDelegate, "childContextTypes", ContextTypes);

/* unused harmony default export */ var _unused_webpack_default_export = (AnalyticsDelegate);

/***/ }),
/* 1797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__matchEvent__ = __webpack_require__(670);









/* eslint-disable react/sort-comp */



/*
The Listener component is responsible for calling its `onEvent` handler when a
child component fires an analytics event, and passing the event up the hierarchy
*/

var ContextTypes = {
  onAnalyticsEvent: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
};

var AnalyticsListener =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(AnalyticsListener, _Component);

  function AnalyticsListener() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, AnalyticsListener);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(AnalyticsListener)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onAnalyticsEvent", function (name, data, isPrivate) {
      // Call this component's onEvent method if it's a match
      var _this$props = _this.props,
          onEvent = _this$props.onEvent,
          match = _this$props.match,
          matchPrivate = _this$props.matchPrivate;

      if (matchPrivate === isPrivate && Object(__WEBPACK_IMPORTED_MODULE_10__matchEvent__["a" /* default */])(match, name) && typeof onEvent === 'function') {
        // send a clean data object so it can't be mutated between listeners
        var _eventData = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, data);

        onEvent(name, _eventData);
      } // Pass the event up the hierarchy


      var onAnalyticsEvent = _this.context.onAnalyticsEvent;

      if (typeof onAnalyticsEvent === 'function') {
        onAnalyticsEvent(name, data, isPrivate);
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(AnalyticsListener, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        onAnalyticsEvent: this.onAnalyticsEvent
      };
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children; // eslint-disable-line react/prop-types

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.Children.only(children);
    }
  }]);

  return AnalyticsListener;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(AnalyticsListener, "defaultProps", {
  match: '*',
  matchPrivate: false
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(AnalyticsListener, "contextTypes", ContextTypes);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(AnalyticsListener, "childContextTypes", ContextTypes);

/* unused harmony default export */ var _unused_webpack_default_export = (AnalyticsListener);

/***/ }),
/* 1798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);


/*
cleanProps removes props added by the withAnalytics HOC from an object
*/
function cleanProps(props) {
  /* eslint-disable no-unused-vars */
  var analyticsId = props.analyticsId,
      analyticsData = props.analyticsData,
      delegateAnalyticsEvent = props.delegateAnalyticsEvent,
      fireAnalyticsEvent = props.fireAnalyticsEvent,
      firePrivateAnalyticsEvent = props.firePrivateAnalyticsEvent,
      getParentAnalyticsData = props.getParentAnalyticsData,
      cleanedProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(props, ["analyticsId", "analyticsData", "delegateAnalyticsEvent", "fireAnalyticsEvent", "firePrivateAnalyticsEvent", "getParentAnalyticsData"]);
  /* eslint-enable no-unused-vars */


  return cleanedProps;
}

/* unused harmony default export */ var _unused_webpack_default_export = (cleanProps);

/***/ }),
/* 1799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);













/*
The withAnalytics HOC wraps a component and provides the `fireAnalyticsEvent`
and `firePrivateAnalyticsEvent` methods to it as props. It contains the logic
for how to fire events, including handling the analyticsId and analyticsData
props. The `map` argument may be an object or a function that returns an object.
The properties of the `map` object/result can be strings (the name of the event
that will be fired) or functions (which are responsible for firing the event).
You can specify a default `analyticsId` and `analyticsData` with the `defaultProps`
param. Please be aware that specifying a default `analyticsId` will cause public
events to always fire for your component unless it has been set to a falsy by
the component consumer.
*/
var withAnalytics = function withAnalytics(WrappedComponent) {
  var _class, _temp;

  var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var withDelegation = arguments.length > 3 ? arguments[3] : undefined;
  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(WithAnalytics, _Component);

    function WithAnalytics() {
      var _getPrototypeOf2;

      var _this;

      __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, WithAnalytics);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(WithAnalytics)).call.apply(_getPrototypeOf2, [this].concat(args)));

      __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)), "props", void 0);

      __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)), "evaluatedMap", {});

      __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)), "delegateAnalyticsEvent", function (analyticsId, data, isPrivate) {
        var onAnalyticsEvent = _this.context.onAnalyticsEvent;
        if (!onAnalyticsEvent) return;
        onAnalyticsEvent(analyticsId, data, isPrivate);
      });

      __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)), "fireAnalyticsEvent", function (name, data) {
        var _this$props = _this.props,
            analyticsData = _this$props.analyticsData,
            analyticsId = _this$props.analyticsId;
        var onAnalyticsEvent = _this.context.onAnalyticsEvent;
        if (!analyticsId || !onAnalyticsEvent) return;

        var eventData = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({}, analyticsData, data);

        onAnalyticsEvent("".concat(analyticsId, ".").concat(name), eventData, false);
      });

      __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)), "privateAnalyticsEvent", function (name, data) {
        var onAnalyticsEvent = _this.context.onAnalyticsEvent;
        if (!onAnalyticsEvent) return;
        onAnalyticsEvent("".concat(name), data, true);
      });

      __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getParentAnalyticsData", function (name) {
        var getParentAnalyticsData = _this.context.getParentAnalyticsData;
        var parentData = {};

        if (typeof getParentAnalyticsData === 'function' && _this.props.analyticsId) {
          var analyticsId = _this.props.analyticsId;
          parentData = getParentAnalyticsData("".concat(analyticsId, ".").concat(name), false);
        }

        return parentData;
      });

      return _this;
    }

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(WithAnalytics, [{
      key: "componentWillMount",
      value: function componentWillMount() {
        this.evaluatedMap = typeof map === 'function' ? map(this.fireAnalyticsEvent) : map;
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        /* eslint-disable no-unused-vars */
        var _this$props2 = this.props,
            analyticsId = _this$props2.analyticsId,
            analyticsData = _this$props2.analyticsData,
            componentProps = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_this$props2, ["analyticsId", "analyticsData"]);
        /* eslint-enable no-unused-vars */


        Object.keys(this.evaluatedMap).forEach(function (prop) {
          var handler = _this2.evaluatedMap[prop]; // may be eventName or a function

          var originalProp = componentProps[prop];

          componentProps[prop] = function () {
            if (typeof handler === 'function') {
              handler.apply(void 0, arguments);
            } else {
              _this2.fireAnalyticsEvent(handler);
            }

            if (typeof originalProp === 'function') originalProp.apply(void 0, arguments);
          };
        });
        return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(WrappedComponent, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          fireAnalyticsEvent: this.fireAnalyticsEvent,
          firePrivateAnalyticsEvent: this.privateAnalyticsEvent,
          getParentAnalyticsData: this.getParentAnalyticsData,
          delegateAnalyticsEvent: withDelegation ? this.delegateAnalyticsEvent : undefined,
          analyticsId: analyticsId,
          ref: this.props.innerRef
        }, componentProps));
      }
    }]);

    return WithAnalytics;
  }(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]), __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_class, "displayName", "WithAnalytics(".concat(WrappedComponent.displayName || WrappedComponent.name, ")")), __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_class, "contextTypes", {
    onAnalyticsEvent: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,
    getParentAnalyticsData: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func
  }), __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_class, "defaultProps", {
    analyticsId: defaultProps.analyticsId,
    analyticsData: defaultProps.analyticsData
  }), _temp;
};

/* harmony default export */ __webpack_exports__["a"] = (withAnalytics);

/***/ }),
/* 1800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_field_base__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_search__ = __webpack_require__(1814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(179);








var EmojiPickerListSearch = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiPickerListSearch, _super);
    function EmojiPickerListSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onBlur = function (e) {
            var activeElement = document.activeElement;
            // Input lost focus to emoji picker container (happens in IE11 when updating search results)
            // See FS-2111
            if (activeElement instanceof HTMLElement &&
                activeElement.getAttribute('data-emoji-picker-container')) {
                _this.restoreInputFocus();
            }
        };
        _this.onChange = function (e) {
            _this.saveInputSelection();
            _this.props.onChange(e);
        };
        _this.focusInput = function () {
            if (_this.inputRef) {
                _this.inputRef.focus();
            }
        };
        _this.handleInputRef = function (input) {
            if (input) {
                // Defer focus so it give some time to position the popup before
                // setting the focus to search input.
                // see FS-2056
                _this.inputRef = input;
                window.setTimeout(_this.focusInput);
            }
        };
        return _this;
    }
    EmojiPickerListSearch.prototype.saveInputSelection = function () {
        this.inputSelection = undefined;
        if (this.inputRef) {
            var _a = this.inputRef, selectionStart = _a.selectionStart, selectionEnd = _a.selectionEnd, selectionDirection = _a.selectionDirection;
            if (selectionStart !== undefined) {
                this.inputSelection = {
                    selectionStart: selectionStart,
                    selectionEnd: selectionEnd,
                    selectionDirection: selectionDirection,
                };
            }
        }
    };
    EmojiPickerListSearch.prototype.restoreInputFocus = function () {
        this.focusInput();
        if (this.inputSelection &&
            this.inputRef &&
            this.inputRef.setSelectionRange) {
            var _a = this.inputSelection, selectionStart = _a.selectionStart, selectionEnd = _a.selectionEnd, selectionDirection = _a.selectionDirection;
            this.inputRef.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
        }
    };
    EmojiPickerListSearch.prototype.render = function () {
        var _this = this;
        var _a = this.props, style = _a.style, query = _a.query;
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_6__styles__["n" /* pickerSearch */], style: style },
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_intl__["FormattedMessage"], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, __WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* messages */].searchLabel), function (searchLabel) { return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__atlaskit_field_base__["b" /* default */], { appearance: "standard", isCompact: true, isLabelHidden: true, isFitContainerWidthEnabled: true },
                __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_6__styles__["o" /* searchIcon */] },
                    __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_search___default.a, { label: searchLabel })),
                __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("input", { className: __WEBPACK_IMPORTED_MODULE_6__styles__["m" /* input */], autoComplete: "off", disabled: false, name: "search", placeholder: searchLabel + "...", required: false, onChange: _this.onChange, value: query || '', ref: _this.handleInputRef, onBlur: _this.onBlur }))); })));
    };
    EmojiPickerListSearch.defaultProps = {
        style: {},
    };
    return EmojiPickerListSearch;
}(__WEBPACK_IMPORTED_MODULE_3_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (EmojiPickerListSearch);
//# sourceMappingURL=EmojiPickerListSearch.js.map

/***/ }),
/* 1801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FieldBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FieldBaseStateless__ = __webpack_require__(671);











var ON_BLUR_KEY = 'onBlurKey';
var ON_CONTENT_BLUR_KEY = 'onContentBlurKey';

function waitForRender(cb) {
  // Execute the callback after any upcoming render calls in the execution queue
  setTimeout(cb, 0);
}

var FieldBase =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(FieldBase, _Component);

  function FieldBase() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, FieldBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(FieldBase)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      isFocused: _this.props.defaultIsFocused,
      isDialogFocused: false,
      shouldIgnoreNextDialogBlur: false
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "timers", void 0);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onFocus", function (e) {
      _this.setState({
        isFocused: true
      });

      _this.props.onFocus(e); // Escape from a possible race-condition when blur and focus happen one by one
      // (otherwise the dialog might be left closed)


      _this.cancelSchedule(ON_BLUR_KEY);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onBlur", function (e) {
      // Because the blur event fires before the focus event, we want to make sure that we don't
      // render and close the dialog before we can check if the dialog is focused.
      _this.reschedule(ON_BLUR_KEY, function () {
        _this.setState({
          isFocused: false
        });

        _this.props.onBlur(e);
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onContentFocus", function () {
      if (_this.state.isDialogFocused) {
        // If we are tabbing between two elements in the warning dialog, we need to prevent the
        // dialog from closing.
        _this.setState({
          shouldIgnoreNextDialogBlur: true
        });
      } else {
        _this.setState({
          isDialogFocused: true
        });
      } // Escape from a possible race-condition when blur and focus happen one by one
      // (otherwise the dialog might be left closed)


      _this.cancelSchedule(ON_CONTENT_BLUR_KEY);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onContentBlur", function () {
      waitForRender(function () {
        if (_this.state.shouldIgnoreNextDialogBlur) {
          // Ignore the blur event if we are still focused in the dialog.
          _this.setState({
            shouldIgnoreNextDialogBlur: false
          });
        } else {
          _this.setState({
            isDialogFocused: false
          });
        }
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(FieldBase, [{
    key: "cancelSchedule",
    value: function cancelSchedule(key) {
      this.timers = this.timers || {};

      if (this.timers[key]) {
        clearTimeout(this.timers[key]);
        delete this.timers[key];
      }
    }
  }, {
    key: "reschedule",
    value: function reschedule(key, callback) {
      var _this2 = this;

      // Use reschedule (not just schedule) to avoid race conditions when multiple blur events
      // happen one by one.
      this.timers = this.timers || {};
      this.cancelSchedule(key);
      this.timers[key] = setTimeout(function () {
        callback();

        _this2.cancelSchedule(key);
      }, 0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          defaultIsFocused = _this$props.defaultIsFocused,
          props = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_this$props, ["defaultIsFocused"]);

      var _this$state = this.state,
          isFocused = _this$state.isFocused,
          isDialogFocused = _this$state.isDialogFocused;
      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__FieldBaseStateless__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, props, {
        isDialogOpen: isFocused || isDialogFocused,
        isFocused: isFocused,
        onBlur: this.onBlur,
        onFocus: this.onFocus,
        onDialogFocus: this.onContentFocus,
        onDialogBlur: this.onContentBlur
      }));
    }
  }]);

  return FieldBase;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(FieldBase, "defaultProps", {
  defaultIsFocused: false,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {}
});



/***/ }),
/* 1802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InlineDialog__ = __webpack_require__(1803);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InlineDialog__["a"]; });


/***/ }),
/* 1803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InlineDialogWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_analytics_next__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_node_resolver__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_node_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_node_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_popper__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__package_json__ = __webpack_require__(1804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styled__ = __webpack_require__(1805);














var InlineDialog =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(InlineDialog, _Component);

  function InlineDialog() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, InlineDialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(InlineDialog)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "containerRef", null);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "triggerRef", null);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleClickOutside", function (event) {
      var _this$props = _this.props,
          isOpen = _this$props.isOpen,
          onClose = _this$props.onClose;
      if (event.defaultPrevented) return;
      var container = _this.containerRef;
      var trigger = _this.triggerRef;
      var target = event.target; // exit if we click outside but on the trigger — it can handle the clicks itself

      if (trigger && trigger.contains(target)) return; // call onClose if the click originated from outside the dialog

      if (isOpen && container && !container.contains(target)) {
        onClose({
          isOpen: false,
          event: event
        });
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(InlineDialog, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (typeof window === 'undefined') return;

      if (!prevProps.isOpen && this.props.isOpen) {
        window.addEventListener('click', this.handleClickOutside, true);
      } else if (prevProps.isOpen && !this.props.isOpen) {
        window.removeEventListener('click', this.handleClickOutside);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (typeof window === 'undefined') return;

      if (this.props.isOpen) {
        window.addEventListener('click', this.handleClickOutside, true);
      }
    }
  }, {
    key: "componentWillUnMount",
    value: function componentWillUnMount() {
      if (typeof window === 'undefined') return;
      window.removeEventListener('click', this.handleClickOutside);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          placement = _this$props2.placement,
          isOpen = _this$props2.isOpen,
          content = _this$props2.content,
          onContentBlur = _this$props2.onContentBlur,
          onContentFocus = _this$props2.onContentFocus,
          onContentClick = _this$props2.onContentClick;
      var popper = isOpen ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__atlaskit_popper__["b" /* Popper */], {
        placement: placement
      }, function (_ref) {
        var ref = _ref.ref,
            style = _ref.style,
            outOfBoundaries = _ref.outOfBoundaries;
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__styled__["a" /* Container */], {
          onBlur: onContentBlur,
          onFocus: onContentFocus,
          onClick: onContentClick,
          outOfBoundaries: outOfBoundaries,
          innerRef: function innerRef(node) {
            _this2.containerRef = node;
            ref(node);
          },
          style: style
        }, content);
      }) : null;
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__atlaskit_popper__["a" /* Manager */], null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__atlaskit_popper__["c" /* Reference */], null, function (_ref2) {
        var ref = _ref2.ref;
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_node_resolver___default.a, {
          innerRef: function innerRef(node) {
            _this2.triggerRef = node;
            ref(node);
          }
        }, children);
      }), popper);
    }
  }]);

  return InlineDialog;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(InlineDialog, "defaultProps", {
  children: null,
  content: null,
  isOpen: false,
  onContentBlur: function onContentBlur() {},
  onContentClick: function onContentClick() {},
  onContentFocus: function onContentFocus() {},
  onClose: function onClose() {},
  placement: 'bottom-start'
});


var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_8__atlaskit_analytics_next__["createAndFireEvent"])('atlaskit');
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__atlaskit_analytics_next__["withAnalyticsContext"])({
  componentName: 'inlineDialog',
  packageName: __WEBPACK_IMPORTED_MODULE_11__package_json__["name"],
  packageVersion: __WEBPACK_IMPORTED_MODULE_11__package_json__["version"]
})(Object(__WEBPACK_IMPORTED_MODULE_8__atlaskit_analytics_next__["withAnalyticsEvents"])({
  onClose: createAndFireEventOnAtlaskit({
    action: 'closed',
    actionSubject: 'inlineDialog',
    attributes: {
      componentName: 'inlineDialog',
      packageName: __WEBPACK_IMPORTED_MODULE_11__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_11__package_json__["version"]
    }
  })
})(InlineDialog)));

/***/ }),
/* 1804 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/inline-dialog","version":"9.0.13","sideEffects":false}

/***/ }),
/* 1805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Container; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);


var backgroundColor = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N0,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN50
});
var textColor = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N900,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN600
}); // eslint-disable-next-line import/prefer-default-export

var Container = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "styled__Container",
  componentId: "sc-1v7azd6-0"
})(["\n  background: ", ";\n  border-radius: ", "px;\n  box-sizing: content-box; /* do not set this to border-box or it will break the overflow handling */\n  color: ", ";\n  max-height: ", "px;\n  max-width: ", "px;\n  padding: ", "px ", "px;\n  z-index: ", ";\n\n  ", ";\n\n  &:focus {\n    outline: none;\n  }\n"], backgroundColor, __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["borderRadius"], textColor, __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"], 56), __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"], 56), __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"], 2), __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"], 3), __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["layers"].dialog, __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["elevation"].e200);

/***/ }),
/* 1806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChildWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ContentWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme__ = __webpack_require__(1807);



var borderRadius = '3px';
var borderWidth = 2;
var grid = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])();
var lineHeightBase = grid * 2.5;
var lineHeightCompact = grid * 2;
var heightBase = grid * 5;
var heightCompact = grid * 4;
var horizontalPadding = grid;
var innerHeight = grid * 3;
var transitionDuration = '0.2s';

var getBorderAndPadding = function getBorderAndPadding(_ref) {
  var paddingDisabled = _ref.paddingDisabled,
      compact = _ref.compact;
  var height = compact ? heightCompact : heightBase;
  var padding = paddingDisabled ? "0" : "".concat((height - 2 * borderWidth - innerHeight) / 2, "px ").concat(horizontalPadding - borderWidth, "px");
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n    border-width: ", "px;\n    padding: ", ";\n  "], borderWidth, padding);
};

var getLineHeight = function getLineHeight(props) {
  var currentLineHeight = props.compact ? lineHeightCompact : lineHeightBase;
  return currentLineHeight / Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["fontSize"])();
};

var getDisabledColor = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N70,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN90
});

var getDisabledState = function getDisabledState(props) {
  return props.disabled && Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n    color: ", ";\n    pointer-events: none;\n  "], getDisabledColor(props));
};

var getHoverState = function getHoverState(props) {
  if (props.readOnly || props.isFocused || props.none) return null;
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n    &:hover {\n      background-color: ", ";\n    }\n  "], Object(__WEBPACK_IMPORTED_MODULE_2__theme__["c" /* getBackgroundColorHover */])(props));
};

var getBorderStyle = function getBorderStyle(props) {
  return props.appearance === 'none' ? 'none' : 'solid';
};

var getMinHeight = function getMinHeight(_ref2) {
  var compact = _ref2.compact;
  var minHeight = compact ? heightCompact : heightBase;
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n    min-height: ", "px;\n  "], minHeight);
}; // need an element wrapping the children because IE11 doesn't apply min-height correctly
// to flex-elements. See https://github.com/philipwalton/flexbugs#3-min-height-on-a-flex-container-wont-apply-to-its-flex-items


var ChildWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Content__ChildWrapper",
  componentId: "ve26fj-0"
})(["\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 auto;\n  max-width: 100%;\n  ", ";\n"], function (p) {
  return getMinHeight(p);
});
var getColor = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N900,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN600
});
var Content = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Content",
  componentId: "ve26fj-1"
})(["\n  align-items: center;\n  background-color: ", ";\n  border-color: ", ";\n  border-radius: ", ";\n  border-style: ", ";\n  box-sizing: border-box;\n  color: ", ";\n  display: flex;\n  flex: 1 0 auto;\n  font-size: ", "px;\n  justify-content: space-between;\n  line-height: ", ";\n  max-width: 100%;\n  overflow: hidden;\n  transition: background-color ", " ease-in-out,\n    border-color ", " ease-in-out;\n  word-wrap: break-word;\n  ", " ", " ", ";\n"], function (props) {
  return props.isFocused ? Object(__WEBPACK_IMPORTED_MODULE_2__theme__["b" /* getBackgroundColorFocus */])(props) : Object(__WEBPACK_IMPORTED_MODULE_2__theme__["a" /* getBackgroundColor */])(props);
}, function (props) {
  return props.isFocused ? Object(__WEBPACK_IMPORTED_MODULE_2__theme__["e" /* getBorderColorFocus */])(props) : Object(__WEBPACK_IMPORTED_MODULE_2__theme__["d" /* getBorderColor */])(props);
}, borderRadius, getBorderStyle, getColor, __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["fontSize"], getLineHeight, transitionDuration, transitionDuration, getBorderAndPadding, getHoverState, getDisabledState);

var getMaxWidth = function getMaxWidth(maxWidth) {
  return maxWidth ? "".concat(maxWidth, "px") : '100%';
};
/* IE11 does not respect max-width when using flex-grow + nested flex content, similar to https://github.com/philipwalton/flexbugs#flexbug-11
 * and https://github.com/philipwalton/flexbugs#flexbug-17.
 * This can be fixed by setting the basis to 100%, allowing shrinking and setting the min-width to the original flex-basis value
 * (or 0 if it was auto).
 * Alternatively since we're just setting the contents to fit parent container when grow is set to true, we can just change flex-basis
 * to 100% and not worry about shrinking or growing.
 * See AK-4285.
 */


var ContentWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Content__ContentWrapper",
  componentId: "ve26fj-2"
})(["\n  ", " ", " ", " max-width: ", ";\n"], function (props) {
  return props.disabled && "\n      cursor: not-allowed;\n    ";
}, function (props) {
  return props.grow ? Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n        flex: 0 0 ", ";\n      "], getMaxWidth(props.maxWidth)) : "\n          flex: 0 0 auto;\n        ";
}, function (props) {
  return props.grow ? "\n          display: block;\n        " : "\n          display: inline-block;\n          vertical-align: top;\n        ";
}, function (props) {
  return getMaxWidth(props.maxWidth);
});

/***/ }),
/* 1807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBackgroundColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getBackgroundColorFocus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBackgroundColorHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getBorderColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getBorderColorFocus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);
 // The following are the name for color mappings in @atlaskit/themes
// The exports are the functions, not the objects, so could not be used here

var disabled = {
  light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20,
  dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN20
}; // For validation red is the new 'yellow' which was { light: colors.Y300, dark: colors.Y300 }

var red = {
  light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R400,
  dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R400
}; // The following do not yet have a darkmode 'map': N20A, N10

var getBackgroundColor = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])('appearance', {
  standard: {
    light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N10,
    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN10
  },
  disabled: disabled,
  invalid: {
    light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N10,
    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN10
  },
  subtle: {
    light: 'transparent',
    dark: 'transparent'
  },
  none: {
    light: 'transparent',
    dark: 'transparent'
  }
});
var getBackgroundColorFocus = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])('appearance', {
  standard: {
    light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0,
    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN10
  },
  disabled: disabled,
  invalid: {
    light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0,
    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN10
  },
  subtle: {
    light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0,
    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN10
  },
  none: {
    light: 'transparent',
    dark: 'transparent'
  }
});
var getBackgroundColorHover = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])('appearance', {
  standard: {
    light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N30,
    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN30
  },
  disabled: disabled,
  invalid: {
    light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N30,
    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN30
  },
  subtle: {
    light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N30,
    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN30
  },
  none: {
    light: 'transparent',
    dark: 'transparent'
  }
});
var getBorderColor = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])('appearance', {
  standard: {
    light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N40,
    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN40
  },
  disabled: {
    light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N40,
    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN40
  },
  invalid: red,
  subtle: {
    light: 'transparent',
    dark: 'transparent'
  },
  none: {
    light: 'transparent',
    dark: 'transparent'
  }
});
var getBorderColorFocus = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])('appearance', {
  standard: {
    light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100,
    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75
  },
  disabled: {
    light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100,
    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75
  },
  invalid: {
    light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100,
    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75
  },
  subtle: {
    light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100,
    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75
  },
  none: {
    light: 'transparent',
    dark: 'transparent'
  }
});

/***/ }),
/* 1808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WarningIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ValidationElement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_spinner__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_warning__ = __webpack_require__(1809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_warning__);










 // exported for testing

var WarningIcon = __WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div.withConfig({
  displayName: "ValidationElement__WarningIcon",
  componentId: "sc-1fk9yms-0"
})(["\n  align-items: center;\n  color: ", ";\n  display: flex;\n  flex-shrink: 0;\n"], __WEBPACK_IMPORTED_MODULE_8__atlaskit_theme__["colors"].yellow); // Spinner needs set height to avoid height jumping
// Also needs a margin so there is space between it and preceding text

var SpinnerParent = __WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div.withConfig({
  displayName: "ValidationElement__SpinnerParent",
  componentId: "sc-1fk9yms-1"
})(["\n  height: 20px;\n  margin-left: 10px;\n"]);

var ValidationElement =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(ValidationElement, _Component);

  function ValidationElement() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ValidationElement);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ValidationElement).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ValidationElement, [{
    key: "render",
    value: function render() {
      if (!this.props.isDisabled && this.props.isInvalid) {
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(WarningIcon, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_warning___default.a, {
          label: "warning"
        }));
      }

      return this.props.isLoading ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(SpinnerParent, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__atlaskit_spinner__["a" /* default */], {
        size: "small"
      })) : null;
    }
  }]);

  return ValidationElement;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(ValidationElement, "defaultProps", {
  isDisabled: false,
  isInvalid: false,
  isLoading: false
});



/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(1810));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var WarningIcon = function WarningIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill-rule=\"evenodd\"><path d=\"M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771L12.938 4.967z\" fill=\"currentColor\"/><path d=\"M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2\" fill=\"inherit\"/></g></svg>"
  }, props));
};

WarningIcon.displayName = 'WarningIcon';
var _default = WarningIcon;
exports.default = _default;

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(54);

var _interopRequireDefault = __webpack_require__(53);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.size = exports.default = exports.IconWrapper = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(4));

var _createClass2 = _interopRequireDefault(__webpack_require__(5));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(7));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(6));

var _inherits2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _styledComponents = _interopRequireDefault(__webpack_require__(2));

var _uuid = _interopRequireDefault(__webpack_require__(22));

var _theme = __webpack_require__(3);

var _constants = __webpack_require__(1811);

var getSize = function getSize(props) {
  if (props.size) {
    return "height: ".concat(_constants.sizes[props.size], "; width: ").concat(_constants.sizes[props.size], ";");
  }

  return null;
};

var IconWrapper = _styledComponents.default.span.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "dyhwwi-0"
})(["\n  ", " color: ", ";\n  display: inline-block;\n  fill: ", ";\n  flex-shrink: 0;\n  line-height: 1;\n\n  > svg {\n    ", " max-height: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    pointer-events: none;\n    vertical-align: bottom;\n  }\n  /* Stop-color doesn't properly apply in chrome when the inherited/current color changes.\n   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS\n   * rule) and then override it with currentColor for the color changes to be picked up.\n   */\n  stop {\n    stop-color: currentColor;\n  }\n"], getSize, function (p) {
  return p.primaryColor || 'currentColor';
}, function (p) {
  return p.secondaryColor || _theme.colors.background;
}, getSize);

exports.IconWrapper = IconWrapper;

var Icon =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Icon, _Component);

  function Icon() {
    (0, _classCallCheck2.default)(this, Icon);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Icon).apply(this, arguments));
  }

  (0, _createClass2.default)(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Glyph = _this$props.glyph,
          dangerouslySetGlyph = _this$props.dangerouslySetGlyph,
          onClick = _this$props.onClick,
          primaryColor = _this$props.primaryColor,
          secondaryColor = _this$props.secondaryColor,
          size = _this$props.size; // handling the glyphs as strings

      if (dangerouslySetGlyph) {
        return _react.default.createElement(IconWrapper, {
          onClick: onClick,
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          size: size,
          "aria-label": this.props.label,
          dangerouslySetInnerHTML: {
            __html: Icon.insertDynamicGradientID(dangerouslySetGlyph)
          }
        });
      } // handling the glyphs when passed through as functions


      return _react.default.createElement(IconWrapper, {
        onClick: onClick,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        "aria-label": this.props.label
      }, Glyph ? _react.default.createElement(Glyph, {
        role: "presentation"
      }) : null);
    }
  }], [{
    key: "insertDynamicGradientID",

    /* Icons need unique gradient IDs across instances for different gradient definitions to work
     * correctly.
     * A step in the icon build process replaces linear gradient IDs and their references in paths
     * to a placeholder string so we can replace them with a dynamic ID here.
     * Replacing the original IDs with placeholders in the build process is more robust than not
     * using placeholders as we do not have to rely on regular expressions to find specific element
     * to replace.
     */
    value: function insertDynamicGradientID(svgStr) {
      var id = (0, _uuid.default)();
      var replacedSvgStr = svgStr.replace(/id="([^"]+)-idPlaceholder"/g, "id=$1-".concat(id)).replace(/fill="url\(#([^"]+)-idPlaceholder\)"/g, "fill=\"url(#$1-".concat(id, ")\""));
      return replacedSvgStr;
    }
  }]);
  return Icon;
}(_react.Component);

exports.default = Icon;
(0, _defineProperty2.default)(Icon, "defaultProps", {
  onClick: function onClick() {}
});
var size = Object.keys(_constants.sizes).reduce(function (p, c) {
  return Object.assign(p, (0, _defineProperty2.default)({}, c, c));
}, {});
exports.size = size;

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = void 0;
var sizes = {
  small: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '48px'
};
exports.sizes = sizes;

/***/ }),
/* 1812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Label; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled_Label__ = __webpack_require__(1813);









var Label =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Label, _Component);

  function Label() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Label);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Label).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Label, [{
    key: "render",

    /* eslint-disable jsx-a11y/no-static-element-interactions */
    value: function render() {
      var _this$props = this.props,
          appearance = _this$props.appearance,
          children = _this$props.children,
          htmlFor = _this$props.htmlFor,
          isFirstChild = _this$props.isFirstChild,
          isLabelHidden = _this$props.isLabelHidden,
          isDisabled = _this$props.isDisabled,
          isRequired = _this$props.isRequired,
          label = _this$props.label,
          onClick = _this$props.onClick;
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled_Label__["b" /* LabelWrapper */], {
        htmlFor: htmlFor
      }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled_Label__["a" /* LabelInner */], {
        isHidden: isLabelHidden,
        inlineEdit: appearance === 'inline-edit',
        firstChild: isFirstChild,
        isDisabled: isDisabled
      }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("span", {
        onClick: onClick
      }, label), isRequired ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled_Label__["c" /* RequiredIndicator */], {
        role: "presentation"
      }, "*") : null), children);
    }
  }]);

  return Label;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(Label, "defaultProps", {
  appearance: 'default'
});



/***/ }),
/* 1813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LabelWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LabelInner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RequiredIndicator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);


var spacing = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])();
var fontSize = 12;
var innerHeight = spacing * 2; // 16px

var lineHeight = innerHeight / fontSize;

var getPadding = function getPadding(_ref) {
  var firstChild = _ref.firstChild,
      inlineEdit = _ref.inlineEdit;
  var right = 0;
  var bottom = spacing / 2;
  var left = 0;
  var top = spacing * 2.5;

  if (inlineEdit) {
    bottom = 0;
    left = spacing;
    top = spacing;
  }

  if (firstChild) {
    top = spacing / 2;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n    padding: ", "px ", "px ", "px ", "px;\n  "], top, right, bottom, left);
};

var LabelWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].label.withConfig({
  displayName: "Label__LabelWrapper",
  componentId: "sc-17towfw-0"
})(["\n  display: block;\n"]);
var getColor = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N200,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN90
});
var getDisabledColor = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N60,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN300
});
var LabelInner = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Label__LabelInner",
  componentId: "sc-17towfw-1"
})(["\n  color: ", ";\n  font-size: ", "px;\n  font-weight: 600;\n  line-height: ", ";\n  ", ";\n\n  ", ";\n"], function (props) {
  return props.isDisabled ? getDisabledColor(props) : getColor(props);
}, fontSize, lineHeight, getPadding, function (p) {
  return p.isHidden && 'display: none;';
});
var RequiredIndicator = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "Label__RequiredIndicator",
  componentId: "sc-17towfw-2"
})(["\n  color: ", ";\n  padding-left: 2px;\n"], __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].red);

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SearchIcon = function SearchIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

SearchIcon.displayName = 'SearchIcon';
var _default = SearchIcon;
exports.default = _default;

/***/ }),
/* 1815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_CachingEmoji__ = __webpack_require__(1345);





var EmojiPickerEmojiRow = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiPickerEmojiRow, _super);
    function EmojiPickerEmojiRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmojiPickerEmojiRow.prototype.render = function () {
        var _a = this.props, emojis = _a.emojis, onSelected = _a.onSelected, onMouseMove = _a.onMouseMove, title = _a.title, showDelete = _a.showDelete, onDelete = _a.onDelete;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2__styles__["k" /* emojiPickerRow */] }, emojis.map(function (emoji) {
            var shortName = emoji.shortName, id = emoji.id;
            var key = id ? id + "-" + title : shortName + "-" + title;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_2__styles__["f" /* emojiItem */], key: key },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_CachingEmoji__["a" /* default */], { emoji: emoji, selectOnHover: true, onSelected: onSelected, onMouseMove: onMouseMove, showDelete: showDelete, onDelete: onDelete, placeholderSize: 24 })));
        })));
    };
    return EmojiPickerEmojiRow;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (EmojiPickerEmojiRow);
//# sourceMappingURL=EmojiPickerEmojiRow.js.map

/***/ }),
/* 1816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(179);







var EmojiPickerCategoryHeading = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiPickerCategoryHeading, _super);
    function EmojiPickerCategoryHeading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmojiPickerCategoryHeading.prototype.render = function () {
        var _a = this.props, id = _a.id, title = _a.title, className = _a.className;
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { id: id, "data-category-id": id, className: __WEBPACK_IMPORTED_MODULE_1_classnames__(className) },
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_5__styles__["e" /* emojiCategoryTitle */] },
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["FormattedMessage"], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* messages */][title])))));
    };
    return EmojiPickerCategoryHeading;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (EmojiPickerCategoryHeading);
//# sourceMappingURL=EmojiPickerCategoryHeading.js.map

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Indexes for all substring searches (e.g. the term "cat" is indexed as "c", "ca", "cat", "a", "at", and "t").
 */
var AllSubstringsIndexStrategy = exports.AllSubstringsIndexStrategy = function () {
  function AllSubstringsIndexStrategy() {
    _classCallCheck(this, AllSubstringsIndexStrategy);
  }

  _createClass(AllSubstringsIndexStrategy, [{
    key: 'expandToken',


    /**
     * @inheritDocs
     */
    value: function expandToken(token) {
      var expandedTokens = [];
      var string;

      for (var i = 0, length = token.length; i < length; ++i) {
        string = '';

        for (var j = i; j < length; ++j) {
          string += token.charAt(j);
          expandedTokens.push(string);
        }
      }

      return expandedTokens;
    }
  }]);

  return AllSubstringsIndexStrategy;
}();

;
//# sourceMappingURL=AllSubstringsIndexStrategy.js.map

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Indexes for exact word matches.
 */
var ExactWordIndexStrategy = exports.ExactWordIndexStrategy = function () {
  function ExactWordIndexStrategy() {
    _classCallCheck(this, ExactWordIndexStrategy);
  }

  _createClass(ExactWordIndexStrategy, [{
    key: 'expandToken',


    /**
     * @inheritDocs
     */
    value: function expandToken(token) {
      return token ? [token] : [];
    }
  }]);

  return ExactWordIndexStrategy;
}();

;
//# sourceMappingURL=ExactWordIndexStrategy.js.map

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Indexes for prefix searches (e.g. the term "cat" is indexed as "c", "ca", and "cat" allowing prefix search lookups).
 */
var PrefixIndexStrategy = exports.PrefixIndexStrategy = function () {
  function PrefixIndexStrategy() {
    _classCallCheck(this, PrefixIndexStrategy);
  }

  _createClass(PrefixIndexStrategy, [{
    key: 'expandToken',


    /**
     * @inheritDocs
     */
    value: function expandToken(token) {
      var expandedTokens = [];
      var string = '';

      for (var i = 0, length = token.length; i < length; ++i) {
        string += token.charAt(i);
        expandedTokens.push(string);
      }

      return expandedTokens;
    }
  }]);

  return PrefixIndexStrategy;
}();

;
//# sourceMappingURL=PrefixIndexStrategy.js.map

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Enforces case-sensitive text matches.
 */
var CaseSensitiveSanitizer = exports.CaseSensitiveSanitizer = function () {
  function CaseSensitiveSanitizer() {
    _classCallCheck(this, CaseSensitiveSanitizer);
  }

  _createClass(CaseSensitiveSanitizer, [{
    key: 'sanitize',


    /**
     * @inheritDocs
     */
    value: function sanitize(text) {
      return text ? text.trim() : '';
    }
  }]);

  return CaseSensitiveSanitizer;
}();

;
//# sourceMappingURL=CaseSensitiveSanitizer.js.map

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Sanitizes text by converting to a locale-friendly lower-case version and triming leading and trailing whitespace.
 */
var LowerCaseSanitizer = exports.LowerCaseSanitizer = function () {
  function LowerCaseSanitizer() {
    _classCallCheck(this, LowerCaseSanitizer);
  }

  _createClass(LowerCaseSanitizer, [{
    key: 'sanitize',


    /**
     * @inheritDocs
     */
    value: function sanitize(text) {
      return text ? text.toLocaleLowerCase().trim() : '';
    }
  }]);

  return LowerCaseSanitizer;
}();

;
//# sourceMappingURL=LowerCaseSanitizer.js.map

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TfIdfSearchIndex = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _getNestedFieldValue = __webpack_require__(673);

var _getNestedFieldValue2 = _interopRequireDefault(_getNestedFieldValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Search index capable of returning results matching a set of tokens and ranked according to TF-IDF.
 */
var TfIdfSearchIndex = exports.TfIdfSearchIndex = function () {
  function TfIdfSearchIndex(uidFieldName) {
    _classCallCheck(this, TfIdfSearchIndex);

    this._uidFieldName = uidFieldName;
    this._tokenToIdfCache = {};
    this._tokenMap = {};
  }

  /**
   * @inheritDocs
   */


  _createClass(TfIdfSearchIndex, [{
    key: 'indexDocument',
    value: function indexDocument(token, uid, doc) {
      this._tokenToIdfCache = {}; // New index invalidates previous IDF caches

      var tokenMap = this._tokenMap;
      var tokenDatum;

      if (_typeof(tokenMap[token]) !== 'object') {
        tokenMap[token] = tokenDatum = {
          $numDocumentOccurrences: 0,
          $totalNumOccurrences: 1,
          $uidMap: {}
        };
      } else {
        tokenDatum = tokenMap[token];
        tokenDatum.$totalNumOccurrences++;
      }

      var uidMap = tokenDatum.$uidMap;

      if (_typeof(uidMap[uid]) !== 'object') {
        tokenDatum.$numDocumentOccurrences++;
        uidMap[uid] = {
          $document: doc,
          $numTokenOccurrences: 1
        };
      } else {
        uidMap[uid].$numTokenOccurrences++;
      }
    }

    /**
     * @inheritDocs
     */

  }, {
    key: 'search',
    value: function search(tokens, corpus) {
      var uidToDocumentMap = {};

      for (var i = 0, numTokens = tokens.length; i < numTokens; i++) {
        var token = tokens[i];
        var tokenMetadata = this._tokenMap[token];

        // Short circuit if no matches were found for any given token.
        if (!tokenMetadata) {
          return [];
        }

        if (i === 0) {
          var keys = Object.keys(tokenMetadata.$uidMap);
          for (var j = 0, numKeys = keys.length; j < numKeys; j++) {
            var uid = keys[j];

            uidToDocumentMap[uid] = tokenMetadata.$uidMap[uid].$document;
          }
        } else {
          var keys = Object.keys(uidToDocumentMap);
          for (var j = 0, numKeys = keys.length; j < numKeys; j++) {
            var uid = keys[j];

            if (_typeof(tokenMetadata.$uidMap[uid]) !== 'object') {
              delete uidToDocumentMap[uid];
            }
          }
        }
      }

      var documents = [];

      for (var uid in uidToDocumentMap) {
        documents.push(uidToDocumentMap[uid]);
      }

      var calculateTfIdf = this._createCalculateTfIdf();

      // Return documents sorted by TF-IDF
      return documents.sort(function (documentA, documentB) {
        return calculateTfIdf(tokens, documentB, corpus) - calculateTfIdf(tokens, documentA, corpus);
      });
    }
  }, {
    key: '_createCalculateIdf',
    value: function _createCalculateIdf() {
      var tokenMap = this._tokenMap;
      var tokenToIdfCache = this._tokenToIdfCache;

      return function calculateIdf(token, documents) {
        if (!tokenToIdfCache[token]) {
          var numDocumentsWithToken = typeof tokenMap[token] !== 'undefined' ? tokenMap[token].$numDocumentOccurrences : 0;

          tokenToIdfCache[token] = 1 + Math.log(documents.length / (1 + numDocumentsWithToken));
        }

        return tokenToIdfCache[token];
      };
    }
  }, {
    key: '_createCalculateTfIdf',
    value: function _createCalculateTfIdf() {
      var tokenMap = this._tokenMap;
      var uidFieldName = this._uidFieldName;
      var calculateIdf = this._createCalculateIdf();

      return function calculateTfIdf(tokens, document, documents) {
        var score = 0;

        for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
          var token = tokens[i];

          var inverseDocumentFrequency = calculateIdf(token, documents);

          if (inverseDocumentFrequency === Infinity) {
            inverseDocumentFrequency = 0;
          }

          var uid;
          if (uidFieldName instanceof Array) {
            uid = document && (0, _getNestedFieldValue2.default)(document, uidFieldName);
          } else {
            uid = document && document[uidFieldName];
          }

          var termFrequency = typeof tokenMap[token] !== 'undefined' && typeof tokenMap[token].$uidMap[uid] !== 'undefined' ? tokenMap[token].$uidMap[uid].$numTokenOccurrences : 0;

          score += termFrequency * inverseDocumentFrequency;
        }

        return score;
      };
    }
  }]);

  return TfIdfSearchIndex;
}();

;
//# sourceMappingURL=TfIdfSearchIndex.js.map

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Search index capable of returning results matching a set of tokens but without any meaningful rank or order.
 */
var UnorderedSearchIndex = exports.UnorderedSearchIndex = function () {
  function UnorderedSearchIndex() {
    _classCallCheck(this, UnorderedSearchIndex);

    this._tokenToUidToDocumentMap = {};
  }

  /**
   * @inheritDocs
   */


  _createClass(UnorderedSearchIndex, [{
    key: 'indexDocument',
    value: function indexDocument(token, uid, doc) {
      if (_typeof(this._tokenToUidToDocumentMap[token]) !== 'object') {
        this._tokenToUidToDocumentMap[token] = {};
      }

      this._tokenToUidToDocumentMap[token][uid] = doc;
    }

    /**
     * @inheritDocs
     */

  }, {
    key: 'search',
    value: function search(tokens, corpus) {
      var intersectingDocumentMap = {};

      var tokenToUidToDocumentMap = this._tokenToUidToDocumentMap;

      for (var i = 0, numTokens = tokens.length; i < numTokens; i++) {
        var token = tokens[i];
        var documentMap = tokenToUidToDocumentMap[token];

        // Short circuit if no matches were found for any given token.
        if (!documentMap) {
          return [];
        }

        if (i === 0) {
          var keys = Object.keys(documentMap);

          for (var j = 0, numKeys = keys.length; j < numKeys; j++) {
            var uid = keys[j];

            intersectingDocumentMap[uid] = documentMap[uid];
          }
        } else {
          var keys = Object.keys(intersectingDocumentMap);

          for (var j = 0, numKeys = keys.length; j < numKeys; j++) {
            var uid = keys[j];

            if (_typeof(documentMap[uid]) !== 'object') {
              delete intersectingDocumentMap[uid];
            }
          }
        }
      }

      var keys = Object.keys(intersectingDocumentMap);
      var documents = [];

      for (var i = 0, numKeys = keys.length; i < numKeys; i++) {
        var uid = keys[i];

        documents.push(intersectingDocumentMap[uid]);
      }

      return documents;
    }
  }]);

  return UnorderedSearchIndex;
}();

;
//# sourceMappingURL=UnorderedSearchIndex.js.map

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var REGEX = /[^a-zа-яё0-9\-']+/i;

/**
 * Simple tokenizer that splits strings on whitespace characters and returns an array of all non-empty substrings.
 */


var SimpleTokenizer = exports.SimpleTokenizer = function () {
  function SimpleTokenizer() {
    _classCallCheck(this, SimpleTokenizer);
  }

  _createClass(SimpleTokenizer, [{
    key: 'tokenize',


    /**
     * @inheritDocs
     */
    value: function tokenize(text) {
      return text.split(REGEX).filter(function (text) {
        return text;
      } // Filter empty tokens
      );
    }
  }]);

  return SimpleTokenizer;
}();

;
//# sourceMappingURL=SimpleTokenizer.js.map

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Stemming is the process of reducing search tokens to their root (or stem) so that searches for different forms of a
 * word will match. For example "search", "searching" and "searched" are all reduced to the stem "search".
 *
 * <p>This stemming tokenizer converts tokens (words) to their stem forms before returning them. It requires an
 * external stemming function to be provided; for this purpose I recommend the NPM 'porter-stemmer' library.
 *
 * <p>For more information see http : //tartarus.org/~martin/PorterStemmer/
 */
var StemmingTokenizer = exports.StemmingTokenizer = function () {

  /**
   * Constructor.
   *
   * @param stemmingFunction Function capable of accepting a word and returning its stem.
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */
  function StemmingTokenizer(stemmingFunction, decoratedTokenizer) {
    _classCallCheck(this, StemmingTokenizer);

    this._stemmingFunction = stemmingFunction;
    this._tokenizer = decoratedTokenizer;
  }

  /**
   * @inheritDocs
   */


  _createClass(StemmingTokenizer, [{
    key: 'tokenize',
    value: function tokenize(text) {
      return this._tokenizer.tokenize(text).map(this._stemmingFunction);
    }
  }]);

  return StemmingTokenizer;
}();

;
//# sourceMappingURL=StemmingTokenizer.js.map

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StopWordsTokenizer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _StopWordsMap = __webpack_require__(675);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Stop words are very common (e.g. "a", "and", "the") and are often not semantically meaningful in the context of a
 * search. This tokenizer removes stop words from a set of tokens before passing the remaining tokens along for
 * indexing or searching purposes.
 */
var StopWordsTokenizer = exports.StopWordsTokenizer = function () {

  /**
   * Constructor.
   *
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */
  function StopWordsTokenizer(decoratedTokenizer) {
    _classCallCheck(this, StopWordsTokenizer);

    this._tokenizer = decoratedTokenizer;
  }

  /**
   * @inheritDocs
   */


  _createClass(StopWordsTokenizer, [{
    key: 'tokenize',
    value: function tokenize(text) {
      return this._tokenizer.tokenize(text).filter(function (token) {
        return !_StopWordsMap.StopWordsMap[token];
      });
    }
  }]);

  return StopWordsTokenizer;
}();

;
//# sourceMappingURL=StopWordsTokenizer.js.map

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Search = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _getNestedFieldValue = __webpack_require__(673);

var _getNestedFieldValue2 = _interopRequireDefault(_getNestedFieldValue);

var _index = __webpack_require__(384);

var _index2 = __webpack_require__(385);

var _index3 = __webpack_require__(672);

var _index4 = __webpack_require__(674);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Simple client-side searching within a set of documents.
 *
 * <p>Documents can be searched by any number of fields. Indexing and search strategies are highly customizable.
 */
var Search = exports.Search = function () {

  /**
   * Constructor.
   * @param uidFieldName Field containing values that uniquely identify search documents; this field's values are used
   *                     to ensure that a search result set does not contain duplicate objects.
   */


  /**
   * Array containing either a property name or a path (list of property names) to a nested value
   */
  function Search(uidFieldName) {
    _classCallCheck(this, Search);

    if (!uidFieldName) {
      throw Error('js-search requires a uid field name constructor parameter');
    }

    this._uidFieldName = uidFieldName;

    // Set default/recommended strategies
    this._indexStrategy = new _index.PrefixIndexStrategy();
    this._searchIndex = new _index3.TfIdfSearchIndex(uidFieldName);
    this._sanitizer = new _index2.LowerCaseSanitizer();
    this._tokenizer = new _index4.SimpleTokenizer();

    this._documents = [];
    this._searchableFields = [];
  }

  /**
   * Override the default index strategy.
   * @param value Custom index strategy
   * @throws Error if documents have already been indexed by this search instance
   */


  _createClass(Search, [{
    key: 'addDocument',


    /**
     * Add a searchable document to the index. Document will automatically be indexed for search.
     * @param document
     */
    value: function addDocument(document) {
      this.addDocuments([document]);
    }

    /**
     * Adds searchable documents to the index. Documents will automatically be indexed for search.
     * @param document
     */

  }, {
    key: 'addDocuments',
    value: function addDocuments(documents) {
      this._documents = this._documents.concat(documents);
      this.indexDocuments_(documents, this._searchableFields);
    }

    /**
     * Add a new searchable field to the index. Existing documents will automatically be indexed using this new field.
     *
     * @param field Searchable field or field path. Pass a string to index a top-level field and an array of strings for nested fields.
     */

  }, {
    key: 'addIndex',
    value: function addIndex(field) {
      this._searchableFields.push(field);
      this.indexDocuments_(this._documents, [field]);
    }

    /**
     * Search all documents for ones matching the specified query text.
     * @param query
     * @returns {Array<Object>}
     */

  }, {
    key: 'search',
    value: function search(query) {
      var tokens = this._tokenizer.tokenize(this._sanitizer.sanitize(query));

      return this._searchIndex.search(tokens, this._documents);
    }

    /**
     * @param documents
     * @param _searchableFields Array containing property names and paths (lists of property names) to nested values
     * @private
     */

  }, {
    key: 'indexDocuments_',
    value: function indexDocuments_(documents, _searchableFields) {
      this._initialized = true;

      var indexStrategy = this._indexStrategy;
      var sanitizer = this._sanitizer;
      var searchIndex = this._searchIndex;
      var tokenizer = this._tokenizer;
      var uidFieldName = this._uidFieldName;

      for (var di = 0, numDocuments = documents.length; di < numDocuments; di++) {
        var doc = documents[di];
        var uid;

        if (uidFieldName instanceof Array) {
          uid = (0, _getNestedFieldValue2.default)(doc, uidFieldName);
        } else {
          uid = doc[uidFieldName];
        }

        for (var sfi = 0, numSearchableFields = _searchableFields.length; sfi < numSearchableFields; sfi++) {
          var fieldValue;
          var searchableField = _searchableFields[sfi];

          if (searchableField instanceof Array) {
            fieldValue = (0, _getNestedFieldValue2.default)(doc, searchableField);
          } else {
            fieldValue = doc[searchableField];
          }

          if (fieldValue != null && typeof fieldValue !== 'string' && fieldValue.toString) {
            fieldValue = fieldValue.toString();
          }

          if (typeof fieldValue === 'string') {
            var fieldTokens = tokenizer.tokenize(sanitizer.sanitize(fieldValue));

            for (var fti = 0, numFieldValues = fieldTokens.length; fti < numFieldValues; fti++) {
              var fieldToken = fieldTokens[fti];
              var expandedTokens = indexStrategy.expandToken(fieldToken);

              for (var eti = 0, nummExpandedTokens = expandedTokens.length; eti < nummExpandedTokens; eti++) {
                var expandedToken = expandedTokens[eti];

                searchIndex.indexDocument(expandedToken, uid, doc);
              }
            }
          }
        }
      }
    }
  }, {
    key: 'indexStrategy',
    set: function set(value) {
      if (this._initialized) {
        throw Error('IIndexStrategy cannot be set after initialization');
      }

      this._indexStrategy = value;
    },
    get: function get() {
      return this._indexStrategy;
    }

    /**
     * Override the default text sanitizing strategy.
     * @param value Custom text sanitizing strategy
     * @throws Error if documents have already been indexed by this search instance
     */

  }, {
    key: 'sanitizer',
    set: function set(value) {
      if (this._initialized) {
        throw Error('ISanitizer cannot be set after initialization');
      }

      this._sanitizer = value;
    },
    get: function get() {
      return this._sanitizer;
    }

    /**
     * Override the default search index strategy.
     * @param value Custom search index strategy
     * @throws Error if documents have already been indexed
     */

  }, {
    key: 'searchIndex',
    set: function set(value) {
      if (this._initialized) {
        throw Error('ISearchIndex cannot be set after initialization');
      }

      this._searchIndex = value;
    },
    get: function get() {
      return this._searchIndex;
    }

    /**
     * Override the default text tokenizing strategy.
     * @param value Custom text tokenizing strategy
     * @throws Error if documents have already been indexed by this search instance
     */

  }, {
    key: 'tokenizer',
    set: function set(value) {
      if (this._initialized) {
        throw Error('ITokenizer cannot be set after initialization');
      }

      this._tokenizer = value;
    },
    get: function get() {
      return this._tokenizer;
    }
  }]);

  return Search;
}();
//# sourceMappingURL=Search.js.map

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TokenHighlighter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__(384);

var _index2 = __webpack_require__(385);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This utility highlights the occurrences of tokens within a string of text. It can be used to give visual indicators
 * of match criteria within searchable fields.
 *
 * <p>For performance purposes this highlighter only works with full-word or prefix token indexes.
 */
var TokenHighlighter = exports.TokenHighlighter = function () {

  /**
   * Constructor.
   *
   * @param opt_indexStrategy Index strategy used by Search
   * @param opt_sanitizer Sanitizer used by Search
   * @param opt_wrapperTagName Optional wrapper tag name; defaults to 'mark' (e.g. <mark>)
   */
  function TokenHighlighter(opt_indexStrategy, opt_sanitizer, opt_wrapperTagName) {
    _classCallCheck(this, TokenHighlighter);

    this._indexStrategy = opt_indexStrategy || new _index.PrefixIndexStrategy();
    this._sanitizer = opt_sanitizer || new _index2.LowerCaseSanitizer();
    this._wrapperTagName = opt_wrapperTagName || 'mark';
  }

  /**
   * Highlights token occurrences within a string by wrapping them with a DOM element.
   *
   * @param text e.g. "john wayne"
   * @param tokens e.g. ["wa"]
   * @returns {string} e.g. "john <mark>wa</mark>yne"
   */


  _createClass(TokenHighlighter, [{
    key: 'highlight',
    value: function highlight(text, tokens) {
      var tagsLength = this._wrapText('').length;

      var tokenDictionary = {};

      // Create a token map for easier lookup below.
      for (var i = 0, numTokens = tokens.length; i < numTokens; i++) {
        var token = this._sanitizer.sanitize(tokens[i]);
        var expandedTokens = this._indexStrategy.expandToken(token);

        for (var j = 0, numExpandedTokens = expandedTokens.length; j < numExpandedTokens; j++) {
          var expandedToken = expandedTokens[j];

          if (!tokenDictionary[expandedToken]) {
            tokenDictionary[expandedToken] = [token];
          } else {
            tokenDictionary[expandedToken].push(token);
          }
        }
      }

      // Track actualCurrentWord and sanitizedCurrentWord separately in case we encounter nested tags.
      var actualCurrentWord = '';
      var sanitizedCurrentWord = '';
      var currentWordStartIndex = 0;

      // Note this assumes either prefix or full word matching.
      for (var i = 0, textLength = text.length; i < textLength; i++) {
        var character = text.charAt(i);

        if (character === ' ') {
          actualCurrentWord = '';
          sanitizedCurrentWord = '';
          currentWordStartIndex = i + 1;
        } else {
          actualCurrentWord += character;
          sanitizedCurrentWord += this._sanitizer.sanitize(character);
        }

        if (tokenDictionary[sanitizedCurrentWord] && tokenDictionary[sanitizedCurrentWord].indexOf(sanitizedCurrentWord) >= 0) {

          actualCurrentWord = this._wrapText(actualCurrentWord);
          text = text.substring(0, currentWordStartIndex) + actualCurrentWord + text.substring(i + 1);

          i += tagsLength;
          textLength += tagsLength;
        }
      }

      return text;
    }

    /**
     * @param text to wrap
     * @returns Text wrapped by wrapper tag (e.g. "foo" becomes "<mark>foo</mark>")
     * @private
     */

  }, {
    key: '_wrapText',
    value: function _wrapText(text) {
      var tagName = this._wrapperTagName;
      return '<' + tagName + '>' + text + '</' + tagName + '>';
    }
  }]);

  return TokenHighlighter;
}();

;
//# sourceMappingURL=TokenHighlighter.js.map

/***/ }),
/* 1829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSearchEmojiComparator;
/* harmony export (immutable) */ __webpack_exports__["b"] = createUsageOnlyEmojiComparator;
/* unused harmony export ChainedEmojiComparator */
/* unused harmony export AsciiMatchComparator */
/* unused harmony export ExactShortNameMatchComparator */
/* unused harmony export EmojiTypeComparator */
/* unused harmony export UsageFrequencyComparator */
/* unused harmony export QueryStringPositionMatchComparator */
/* unused harmony export OrderComparator */
/* unused harmony export AlphabeticalShortnameComparator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type_helpers__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(69);



/**
 * Create the default sort comparator to be used for the user queries against emoji
 *
 * @param query the query used in the search to be sorted. Any colons will be stripped from the query and it will be
 * converted to lowercase.
 * @param orderedIds the id of emoji ordered by how frequently they are used
 */
function createSearchEmojiComparator(query, orderedIds) {
    var textQuery = query
        ? query
            .replace(/:/g, '')
            .toLowerCase()
            .trim()
        : undefined;
    var comparators = [];
    if (query) {
        comparators.push(new AsciiMatchComparator(query));
    }
    // Add the comparators to the 'chain'. The order of adding each comparator is important to the sort that is applied by the
    // ChainedEmojiComparator. (Which is why you may see the same 'if' a few times.)
    if (textQuery) {
        comparators.push(new ExactShortNameMatchComparator(textQuery));
    }
    if (orderedIds && orderedIds.length) {
        comparators.push(new UsageFrequencyComparator(orderedIds));
    }
    if (textQuery) {
        comparators.push(new QueryStringPositionMatchComparator(textQuery, 'shortName'), new QueryStringPositionMatchComparator(textQuery, 'name'));
    }
    comparators.push(OrderComparator.Instance, AlphabeticalShortnameComparator.Instance);
    var comparator = new (ChainedEmojiComparator.bind.apply(ChainedEmojiComparator, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"]([void 0], comparators)))();
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
function createUsageOnlyEmojiComparator(orderedIds) {
    var comparator = new ChainedEmojiComparator(new UsageFrequencyComparator(orderedIds), new EmojiTypeComparator(), OrderComparator.Instance);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
/**
 * A combinator comparator that applies an ordered chained of sub-comparators. The first comparator that
 * returns a non-zero value stops the chain and causes that value to be returned. If a comparator returns a
 * zero then the next one in the chain is tried.
 *
 * If no comparators in the chain return a non-zero value then zero will be returned.
 */
var ChainedEmojiComparator = /** @class */ (function () {
    function ChainedEmojiComparator() {
        var comparators = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            comparators[_i] = arguments[_i];
        }
        this.chain = comparators;
    }
    ChainedEmojiComparator.prototype.compare = function (e1, e2) {
        for (var i = 0; i < this.chain.length; i++) {
            var result = this.chain[i].compare(e1, e2);
            if (result !== 0) {
                return result;
            }
        }
        return 0;
    };
    return ChainedEmojiComparator;
}());

/**
 * Orders two emoji such that if one of them has an ascii representation that exactly matches the query then it will
 * be ordered first.
 */
var AsciiMatchComparator = /** @class */ (function () {
    function AsciiMatchComparator(query) {
        this.query = query;
    }
    AsciiMatchComparator.prototype.compare = function (e1, e2) {
        var e1HasAscii = e1.ascii && e1.ascii.indexOf(this.query) !== -1;
        var e2HasAscii = e2.ascii && e2.ascii.indexOf(this.query) !== -1;
        if (e1HasAscii && !e2HasAscii) {
            return -1;
        }
        else if (!e1HasAscii && e2HasAscii) {
            return 1;
        }
        return 0;
    };
    return AsciiMatchComparator;
}());

/**
 * Orders two emoji such that the one who's shortname matches the query exactly comes first. If there are matching
 * shortnames then the type of emoji is taken into account with SITE emoji coming first.
 */
var ExactShortNameMatchComparator = /** @class */ (function () {
    function ExactShortNameMatchComparator(query) {
        this.colonQuery = ":" + query + ":";
        this.typeComparator = new EmojiTypeComparator(true);
    }
    ExactShortNameMatchComparator.prototype.compare = function (e1, e2) {
        if (e1.shortName === this.colonQuery && e2.shortName === this.colonQuery) {
            return this.typeComparator.compare(e1, e2);
        }
        else if (e1.shortName === this.colonQuery) {
            return -1;
        }
        else if (e2.shortName === this.colonQuery) {
            return 1;
        }
        return 0;
    };
    return ExactShortNameMatchComparator;
}());

/**
 * Orders two emoji based on their type, with the types being STANDARD, ATLASSIAN and SITE (in that order).
 * If the comparator is configured to 'reverse' then the order will be SITE, ATLASSIAN, STANDARD.
 *
 * Regardless of the reverse setting, an unknown type will always come last.
 */
var EmojiTypeComparator = /** @class */ (function () {
    function EmojiTypeComparator(reverse) {
        if (reverse) {
            this.typeToNumber = new Map([
                ['SITE', 0],
                ['ATLASSIAN', 1],
                ['STANDARD', 2],
            ]);
        }
        else {
            this.typeToNumber = new Map([
                ['STANDARD', 0],
                ['ATLASSIAN', 1],
                ['SITE', 2],
            ]);
        }
    }
    EmojiTypeComparator.prototype.compare = function (e1, e2) {
        return this.emojiTypeToOrdinal(e1) - this.emojiTypeToOrdinal(e2);
    };
    EmojiTypeComparator.prototype.emojiTypeToOrdinal = function (emoji) {
        var ordinal = this.typeToNumber.get(emoji.type);
        if (ordinal === undefined) {
            ordinal = 10;
        }
        return ordinal;
    };
    return EmojiTypeComparator;
}());

/**
 * Order two emoji such as the one which is more frequently used comes first. If neither have any usage
 * information then leave their order unchanged.
 */
var UsageFrequencyComparator = /** @class */ (function () {
    function UsageFrequencyComparator(orderedIds) {
        var _this = this;
        this.positionLookup = new Map();
        // Make ordering start from 1 to avoid having zero in the map (which is falsey)
        orderedIds.map(function (id, index) { return _this.positionLookup.set(id, index + 1); });
    }
    UsageFrequencyComparator.prototype.compare = function (e1, e2) {
        if (!e1.id || !e2.id) {
            return 0; // this shouldn't occur. Leave position unchanged if there is any missing id.
        }
        var i1 = this.getPositionInOrder(e1);
        var i2 = this.getPositionInOrder(e2);
        return i1 - i2;
    };
    /**
     * Get the ordinal representing the position of this emoji.
     *
     * @param id the id of the emoji
     */
    UsageFrequencyComparator.prototype.getPositionInOrder = function (emoji) {
        var id = emoji.id ? emoji.id : '0';
        if (Object(__WEBPACK_IMPORTED_MODULE_1__type_helpers__["g" /* isEmojiVariationDescription */])(emoji)) {
            id = emoji.baseId;
        }
        var position = this.positionLookup.get(id);
        if (position) {
            return position;
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* MAX_ORDINAL */];
        }
    };
    return UsageFrequencyComparator;
}());

/**
 * A comparator that will sort higher an emoji which matches the query string earliest in the indicated
 * property.
 */
var QueryStringPositionMatchComparator = /** @class */ (function () {
    /**
     * @param query the query to match
     * @param propertyToCompare the property of EmojiDescription to check for query within
     */
    function QueryStringPositionMatchComparator(query, propertyToCompare) {
        this.query = query;
        this.propertyName = propertyToCompare;
    }
    QueryStringPositionMatchComparator.prototype.compare = function (e1, e2) {
        var i1 = e1[this.propertyName]
            ? e1[this.propertyName].indexOf(this.query)
            : __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* MAX_ORDINAL */];
        var i2 = e2[this.propertyName]
            ? e2[this.propertyName].indexOf(this.query)
            : __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* MAX_ORDINAL */];
        i1 = i1 === -1 ? __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* MAX_ORDINAL */] : i1;
        i2 = i2 === -1 ? __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* MAX_ORDINAL */] : i2;
        return i1 - i2;
    };
    return QueryStringPositionMatchComparator;
}());

var OrderComparator = /** @class */ (function () {
    function OrderComparator() {
    }
    Object.defineProperty(OrderComparator, "Instance", {
        get: function () {
            return this.INSTANCE || (this.INSTANCE = new this());
        },
        enumerable: true,
        configurable: true
    });
    OrderComparator.prototype.compare = function (e1, e2) {
        var o1 = e1.order ? e1.order : __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* MAX_ORDINAL */];
        var o2 = e2.order ? e2.order : __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* MAX_ORDINAL */];
        return o1 - o2;
    };
    return OrderComparator;
}());

var AlphabeticalShortnameComparator = /** @class */ (function () {
    function AlphabeticalShortnameComparator() {
    }
    Object.defineProperty(AlphabeticalShortnameComparator, "Instance", {
        get: function () {
            return this.INSTANCE || (this.INSTANCE = new this());
        },
        enumerable: true,
        configurable: true
    });
    AlphabeticalShortnameComparator.prototype.compare = function (e1, e2) {
        return e1.shortName.localeCompare(e2.shortName);
    };
    return AlphabeticalShortnameComparator;
}());

//# sourceMappingURL=Comparators.js.map

/***/ }),
/* 1830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DuplicateLimitedQueue__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_logger__ = __webpack_require__(119);



/**
 * An extension to the DuplicateLimitedQueue that will initialise its contents from the
 * supplied Storage and will also update the storage for every new item enqueued.
 */
var StoredDuplicateLimitedQueue = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](StoredDuplicateLimitedQueue, _super);
    function StoredDuplicateLimitedQueue(options) {
        var _this = _super.call(this, options) || this;
        _this.storage = options.storage;
        _this.prefixedStorageKey = options.storagePrefix + "." + StoredDuplicateLimitedQueue.storageKey;
        _this.load();
        return _this;
    }
    /**
     * Enqueue the supplied item and also persist the new contents of the queue to storage.
     *
     * @param item the item to be enqueued
     */
    StoredDuplicateLimitedQueue.prototype.enqueue = function (item) {
        _super.prototype.enqueue.call(this, item);
        this.save();
    };
    /**
     * Exposed for storybook/testing purposes only. Clear the contents of the queue, and localStorage.
     */
    StoredDuplicateLimitedQueue.prototype.clear = function () {
        _super.prototype.clear.call(this);
        this.storage.removeItem(this.prefixedStorageKey);
    };
    /**
     * Initialise the queue contents from the configured Storage. If there is no data found in
     * storage then the queue will have no items added. Likewise, a failure to read or parse stored
     * data will be swallowed and no items are added to the queue.
     */
    StoredDuplicateLimitedQueue.prototype.load = function () {
        var itemsJson = this.storage.getItem(this.prefixedStorageKey);
        if (itemsJson !== null) {
            try {
                var items = JSON.parse(itemsJson);
                this.bulkEnqueue(items);
            }
            catch (e) {
                Object(__WEBPACK_IMPORTED_MODULE_2__util_logger__["a" /* default */])("Error parsing the queue stored as " + this.prefixedStorageKey + " key from storage", e);
            }
        }
    };
    /**
     * Save the current items in the queue, overwriting any previously stored queue.
     * Any failure in saving will be silently ignored with the likely outcome that any previous
     * saved items will remain unchanged in storage.
     */
    StoredDuplicateLimitedQueue.prototype.save = function () {
        var itemsJson = JSON.stringify(this.getItems());
        try {
            this.storage.setItem(this.prefixedStorageKey, itemsJson);
        }
        catch (e) {
            Object(__WEBPACK_IMPORTED_MODULE_2__util_logger__["a" /* default */])("Error saving the queued items as " + this.prefixedStorageKey, e);
        }
    };
    StoredDuplicateLimitedQueue.storageKey = 'lastUsed';
    return StoredDuplicateLimitedQueue;
}(__WEBPACK_IMPORTED_MODULE_1__DuplicateLimitedQueue__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (StoredDuplicateLimitedQueue);
//# sourceMappingURL=StoredDuplicateLimitedQueue.js.map

/***/ }),
/* 1831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tokenizerRegex; });
// \p{Han} => each chinese character is a separate token
// \p{L}+[\p{Mn}|']*\p{L} => consecutive letters, including non spacing mark and apostrophe are a single token
// const tokenizerRegex = new XRegExp("\\p{Han}|[\\p{L}|\\p{N}]+[\\p{Mn}|']*\\p{L}*", 'gi');
// Note: regex compiled to unicode charsets using @atlaskit/xregexp-transformer (packages/elements/xregexp-transformer). Refer to it if you need to compile it again.
var tokenizerRegex = new RegExp("[\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FEF\uF900-\uFA6D\uFA70-\uFAD9]|[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC|0-9\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F|']*[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*", 'gi');
//# sourceMappingURL=EmojiRepositoryRegex.js.map

/***/ }),
/* 1832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mediaProportionOfProgress */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type_helpers__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MediaEmojiCache__ = __webpack_require__(1833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EmojiUtils__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TokenManager__ = __webpack_require__(1835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_logger__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_media_core__ = __webpack_require__(325);








// Assume media is 95% of total upload time.
var mediaProportionOfProgress = 95 / 100;
var SiteEmojiResource = /** @class */ (function () {
    function SiteEmojiResource(siteServiceConfig, mediaApiToken) {
        var _this = this;
        this.postToEmojiService = function (upload, fileId) {
            var shortName = upload.shortName, name = upload.name;
            var width = upload.width, height = upload.height;
            var requestInit = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    shortName: shortName,
                    name: name,
                    width: width,
                    height: height,
                    fileId: fileId,
                }),
            };
            return __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */]
                .requestService(_this.siteServiceConfig, {
                requestInit: requestInit,
            })
                .then(function (response) {
                var emojis = response.emojis;
                if (emojis.length) {
                    var _a = emojis[0], altRepresentations = _a.altRepresentations, emoji = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["altRepresentations"]);
                    var response_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, emoji, { representation: Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["c" /* convertImageToMediaRepresentation */])(emoji.representation) });
                    var altRepresentation = Object(__WEBPACK_IMPORTED_MODULE_4__EmojiUtils__["c" /* getAltRepresentation */])(altRepresentations || {});
                    var imgAltRepresentation = altRepresentation
                        ? Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["c" /* convertImageToMediaRepresentation */])(altRepresentation)
                        : undefined;
                    return Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["a" /* buildEmojiDescriptionWithAltRepresentation */])(response_1, imgAltRepresentation);
                }
                throw new Error('No emoji returns from upload. Upload failed.');
            });
        };
        this.siteServiceConfig = siteServiceConfig;
        this.mediaApiToken = mediaApiToken;
        this.tokenManager = new __WEBPACK_IMPORTED_MODULE_5__TokenManager__["a" /* default */](siteServiceConfig);
        this.tokenManager.addToken('read', mediaApiToken);
        this.mediaEmojiCache = new __WEBPACK_IMPORTED_MODULE_3__MediaEmojiCache__["a" /* default */](this.tokenManager);
    }
    /**
     * Will load media emoji, returning a new EmojiDescription if, for example,
     * the URL has changed.
     */
    SiteEmojiResource.prototype.loadMediaEmoji = function (emoji, useAlt) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["j" /* isMediaEmoji */])(emoji)) {
            throw new Error('Only supported for media emoji');
        }
        return this.mediaEmojiCache.loadEmoji(emoji, useAlt);
    };
    SiteEmojiResource.prototype.optimisticRendering = function (emoji, useAlt) {
        var representation = useAlt
            ? emoji.altRepresentation
            : emoji.representation;
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["k" /* isMediaRepresentation */])(representation)) {
            throw new Error('Only supported for media emoji');
        }
        var mediaPath = representation.mediaPath;
        return this.mediaEmojiCache.optimisticRendering(mediaPath);
    };
    SiteEmojiResource.prototype.uploadEmoji = function (upload, progressCallback) {
        var _this = this;
        var startTime = Date.now();
        return this.tokenManager.getToken('upload').then(function (uploadToken) {
            var tokenLoadTime = Date.now() - startTime;
            Object(__WEBPACK_IMPORTED_MODULE_6__util_logger__["a" /* default */])('upload token load time', tokenLoadTime);
            return new Promise(function (resolve, reject) {
                var url = uploadToken.url, clientId = uploadToken.clientId, collectionName = uploadToken.collectionName;
                var context = __WEBPACK_IMPORTED_MODULE_7__atlaskit_media_core__["a" /* ContextFactory */].create({
                    authProvider: function () {
                        return Promise.resolve({
                            clientId: clientId,
                            token: uploadToken.jwt,
                            baseUrl: url,
                        });
                    },
                });
                var subscription = context.file
                    .upload({
                    content: upload.dataURL,
                    name: upload.filename,
                    collection: collectionName,
                })
                    .subscribe({
                    next: function (state) {
                        if (state.status === 'uploading' && progressCallback) {
                            progressCallback({
                                percent: state.progress * mediaProportionOfProgress,
                            });
                        }
                        else if (state.status === 'processing') {
                            subscription.unsubscribe();
                            var totalUploadTime = Date.now() - startTime;
                            var mediaUploadTime = totalUploadTime - tokenLoadTime;
                            Object(__WEBPACK_IMPORTED_MODULE_6__util_logger__["a" /* default */])('total upload / media upload times', totalUploadTime, mediaUploadTime);
                            _this.postToEmojiService(upload, state.id)
                                .then(function (emoji) {
                                resolve(emoji);
                            })
                                .catch(function (httpError) {
                                reject(httpError.reason || httpError);
                            });
                        }
                    },
                    error: function (error) {
                        reject(error);
                    },
                });
            });
        });
    };
    /**
     * Check if the MediaEmojiResource has been able to initialise an uploadToken. Retrieving an upload token
     * is asynchronous so the Promise will need to resolve before the state is known. If the token retrieval
     * completes with failure then the Promise will resolve to false.
     */
    SiteEmojiResource.prototype.hasUploadToken = function () {
        var tokenPromise = this.tokenManager.getToken('upload');
        return tokenPromise.then(function (token) {
            return token !== undefined;
        }, function () {
            return false;
        });
    };
    SiteEmojiResource.prototype.prepareForUpload = function () {
        // make sure a token is loaded from the emoji service if we don't have one
        // as future request to uploadEmoji will use this, this to preload it, as it
        // usually takes 1-2 seconds to generate
        this.tokenManager.getToken('upload');
    };
    SiteEmojiResource.prototype.findEmoji = function (emojiId) {
        var path = "../" + emojiId.id;
        return Object(__WEBPACK_IMPORTED_MODULE_4__EmojiUtils__["b" /* emojiRequest */])(this.siteServiceConfig, { path: path })
            .then(function (serviceResponse) {
            var response = Object(__WEBPACK_IMPORTED_MODULE_4__EmojiUtils__["a" /* denormaliseEmojiServiceResponse */])(serviceResponse);
            return response.emojis[0];
        })
            .catch(function (error) {
            Object(__WEBPACK_IMPORTED_MODULE_6__util_logger__["a" /* default */])('failed to load emoji', emojiId, error);
            return undefined;
        });
    };
    /**
     * Calls to site-scoped EmojiResource to delete emoji
     * @param emoji media emoji to delete
     * @returns Promise.resolve() if success and Promise.reject() for failure
     */
    SiteEmojiResource.prototype.deleteEmoji = function (emoji) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["j" /* isMediaEmoji */])(emoji) && !Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["i" /* isLoadedMediaEmoji */])(emoji)) {
            return Promise.reject(false);
        }
        var path = "" + emoji.id;
        var requestInit = {
            method: 'DELETE',
        };
        return (__WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */]
            .requestService(this.siteServiceConfig, { path: path, requestInit: requestInit })
            // Successful delete on Promise.resolve
            .then(function () { return true; })
            // Unsuccessful delete on Promise.reject
            .catch(function () { return false; }));
    };
    return SiteEmojiResource;
}());
/* harmony default export */ __webpack_exports__["a"] = (SiteEmojiResource);
//# sourceMappingURL=SiteEmojiResource.js.map

/***/ }),
/* 1833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BrowserCacheStrategy */
/* unused harmony export MemoryCacheStrategy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type_helpers__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MediaImageLoader__ = __webpack_require__(1834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_logger__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lru_fast__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lru_fast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lru_fast__);




var getRequiredRepresentation = function (emoji, useAlt) {
    return useAlt ? emoji.altRepresentation : emoji.representation;
};
var isUnsupportedBrowser = function () {
    var isIE = /*@cc_on!@*/ false || !!document.documentMode; // Internet Explorer 6-11
    var isEdge = !isIE && !!window.StyleMedia; // Edge 20+
    return isIE || isEdge;
};
/**
 * For browsers that support caching for resources
 * regardless of originally supplied headers (basically everything but Firefox).
 */
var BrowserCacheStrategy = /** @class */ (function () {
    function BrowserCacheStrategy(mediaImageLoader) {
        this.cachedImageUrls = new Set();
        Object(__WEBPACK_IMPORTED_MODULE_2__util_logger__["a" /* default */])('BrowserCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
    }
    BrowserCacheStrategy.prototype.loadEmoji = function (emoji, useAlt) {
        var _this = this;
        var representation = getRequiredRepresentation(emoji, useAlt);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__type_helpers__["k" /* isMediaRepresentation */])(representation)) {
            return emoji;
        }
        var mediaPath = representation.mediaPath;
        if (this.cachedImageUrls.has(mediaPath)) {
            // Already cached
            return emoji;
        }
        return this.mediaImageLoader
            .loadMediaImage(mediaPath)
            .then(function () {
            // Media is loaded, can use original URL now, so just return original emoji
            _this.cachedImageUrls.add(mediaPath);
            return emoji;
        })
            .catch(function () {
            return undefined;
        });
    };
    BrowserCacheStrategy.prototype.optimisticRendering = function () {
        return true;
    };
    BrowserCacheStrategy.supported = function (mediaPath, mediaImageLoader) {
        // IE/Edge uses memory cache strategy else images can fail to load
        // from a clean cache/if they are downloaded from the service
        // TODO: fix as a part of FS-1592
        if (isUnsupportedBrowser()) {
            return Promise.resolve(false);
        }
        return mediaImageLoader
            .loadMediaImage(mediaPath)
            .then(function () {
            // Image should be cached in browser, if supported it should be accessible from the cache by an <img/>
            // Try to load without via image to confirm this support (this fails in Firefox)
            return new Promise(function (resolve) {
                var img = new Image();
                img.addEventListener('load', function () {
                    resolve(true);
                });
                img.addEventListener('error', function () {
                    resolve(false);
                });
                img.src = mediaPath;
            });
        })
            .catch(function () { return false; });
    };
    return BrowserCacheStrategy;
}());

var maxImageCached = 1000;
// Don't cache images large than this - dataUrl size in characters
var maxImageSize = 10000;
/**
 * For browsers that do no cache images without equivalent headers (e.g. Firefox).
 *
 * Images are cached in memory in a LRU cache. Images considered too large,
 * are not cached, but retrieved each time.
 *
 * Images are still cached by the browser, but loading in asynchronous with
 * small delay noticable to the end user.
 */
var MemoryCacheStrategy = /** @class */ (function () {
    function MemoryCacheStrategy(mediaImageLoader) {
        Object(__WEBPACK_IMPORTED_MODULE_2__util_logger__["a" /* default */])('MemoryCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
        this.dataURLCache = new __WEBPACK_IMPORTED_MODULE_3_lru_fast__["LRUCache"](maxImageCached);
    }
    MemoryCacheStrategy.prototype.loadEmoji = function (emoji, useAlt) {
        var _this = this;
        var representation = getRequiredRepresentation(emoji, useAlt);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__type_helpers__["k" /* isMediaRepresentation */])(representation)) {
            return emoji;
        }
        var mediaPath = representation.mediaPath;
        var dataURL = this.dataURLCache.get(mediaPath);
        if (dataURL) {
            // Already cached
            return Object(__WEBPACK_IMPORTED_MODULE_0__type_helpers__["d" /* convertMediaToImageEmoji */])(emoji, dataURL, useAlt);
        }
        // Not cached, load
        return this.mediaImageLoader
            .loadMediaImage(mediaPath)
            .then(function (dataURL) {
            var loadedEmoji = Object(__WEBPACK_IMPORTED_MODULE_0__type_helpers__["d" /* convertMediaToImageEmoji */])(emoji, dataURL, useAlt);
            if (dataURL.length <= maxImageSize) {
                // Only cache if not large than max size
                _this.dataURLCache.put(mediaPath, dataURL);
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_2__util_logger__["a" /* default */])('No caching as image is too large', dataURL.length, dataURL.slice(0, 15), emoji.shortName);
            }
            return loadedEmoji;
        })
            .catch(function () {
            return undefined;
        });
    };
    MemoryCacheStrategy.prototype.optimisticRendering = function () {
        return false;
    };
    return MemoryCacheStrategy;
}());

/**
 * Provides a cache for Media Emoji.
 *
 * Emoji are returned immediately if cached and ready to use by the browser.
 *
 * Otherwise, they are loaded and returned via a promise.
 */
var MediaEmojiCache = /** @class */ (function () {
    function MediaEmojiCache(tokenManager) {
        this.waitingInitUrls = [];
        Object(__WEBPACK_IMPORTED_MODULE_2__util_logger__["a" /* default */])('MediaEmojiCache');
        this.mediaImageLoader = new __WEBPACK_IMPORTED_MODULE_1__MediaImageLoader__["a" /* default */](tokenManager);
    }
    MediaEmojiCache.prototype.loadEmoji = function (emoji, useAlt) {
        var representation = getRequiredRepresentation(emoji, useAlt);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__type_helpers__["k" /* isMediaRepresentation */])(representation)) {
            return emoji;
        }
        var mediaPath = representation.mediaPath;
        var emojiCache = this.getCache(mediaPath);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__type_helpers__["l" /* isPromise */])(emojiCache)) {
            // Promise based
            return emojiCache
                .then(function (cache) { return cache.loadEmoji(emoji, useAlt); })
                .catch(function () { return undefined; });
        }
        return emojiCache.loadEmoji(emoji, useAlt);
    };
    MediaEmojiCache.prototype.optimisticRendering = function (url) {
        var emojiCache = this.getCache(url);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__type_helpers__["l" /* isPromise */])(emojiCache)) {
            // Promise based
            return emojiCache
                .then(function (cache) { return cache.optimisticRendering(); })
                .catch(function () { return false; });
        }
        return emojiCache.optimisticRendering();
    };
    MediaEmojiCache.prototype.getCache = function (url) {
        var _this = this;
        if (this.cache) {
            return this.cache;
        }
        this.waitingInitUrls.push(url);
        if (!this.cacheLoading) {
            this.cacheLoading = this.initCache()
                .then(function (cache) {
                _this.cache = cache;
                _this.cacheLoading = undefined;
                return cache;
            })
                .catch(function (err) {
                _this.cacheLoading = undefined;
                throw err;
            });
        }
        return this.cacheLoading;
    };
    MediaEmojiCache.prototype.initCache = function () {
        var _this = this;
        var url = this.waitingInitUrls.pop();
        if (!url) {
            return Promise.reject('Unable to initialise cache based on provided url(s)');
        }
        return BrowserCacheStrategy.supported(url, this.mediaImageLoader)
            .then(function (supported) {
            _this.waitingInitUrls = []; // clear
            _this.cacheLoading = undefined;
            if (supported) {
                return new BrowserCacheStrategy(_this.mediaImageLoader);
            }
            return new MemoryCacheStrategy(_this.mediaImageLoader);
        })
            .catch(function () {
            return _this.initCache();
        });
    };
    return MediaEmojiCache;
}());
/* harmony default export */ __webpack_exports__["a"] = (MediaEmojiCache);
//# sourceMappingURL=MediaEmojiCache.js.map

/***/ }),
/* 1834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_image__ = __webpack_require__(1386);

var defaultConcurrentDownloadLimit = 16;
var MediaImageLoader = /** @class */ (function () {
    function MediaImageLoader(tokenManager, options) {
        this.mediaImageQueue = [];
        this.activeProcessing = 0;
        this.pendingRequests = new Map();
        this.concurrentDownloadLimit =
            (options && options.concurrentDownloadLimit) ||
                defaultConcurrentDownloadLimit;
        this.tokenManager = tokenManager;
    }
    MediaImageLoader.prototype.loadMediaImage = function (url) {
        var _this = this;
        var maybePending = this.pendingRequests.get(url);
        if (maybePending !== undefined) {
            return maybePending;
        }
        var pending = new Promise(function (resolve, reject) {
            _this.mediaImageQueue.push({
                url: url,
                resolve: resolve,
                reject: reject,
            });
            _this.processFromQueue();
        })
            .then(function (result) {
            _this.pendingRequests.delete(url);
            return result;
        })
            .catch(function (error) {
            _this.pendingRequests.delete(url);
            throw error;
        });
        this.pendingRequests.set(url, pending);
        return pending;
    };
    MediaImageLoader.prototype.getQueueSize = function () {
        return this.mediaImageQueue.length;
    };
    MediaImageLoader.prototype.getActiveDownloads = function () {
        return this.activeProcessing;
    };
    MediaImageLoader.prototype.processFromQueue = function () {
        var _this = this;
        var _loop_1 = function () {
            this_1.activeProcessing++;
            var item = this_1.mediaImageQueue.shift();
            var url = item.url, resolve = item.resolve, reject = item.reject;
            this_1.tokenManager
                .getToken('read', false)
                .then(function (token) {
                _this.requestMediaEmoji(url, token, true)
                    .then(function (dataURL) {
                    resolve(dataURL);
                    _this.completedItem();
                })
                    .catch(function (error) {
                    reject(error);
                    _this.completedItem();
                });
            })
                .catch(function (error) {
                // Failed to load, just resolve to original emoji
                reject(error);
                _this.completedItem();
            });
        };
        var this_1 = this;
        while (this.activeProcessing < this.concurrentDownloadLimit &&
            this.mediaImageQueue.length > 0) {
            _loop_1();
        }
    };
    MediaImageLoader.prototype.completedItem = function () {
        this.activeProcessing--;
        this.processFromQueue();
    };
    MediaImageLoader.prototype.requestMediaEmoji = function (url, token, retryOnAuthError) {
        var _this = this;
        return Object(__WEBPACK_IMPORTED_MODULE_0__util_image__["c" /* imageAcceptHeader */])().then(function (acceptHeader) {
            // Media REST API: https://media-api-internal.atlassian.io/api.html#file__fileId__image_get
            var options = {
                headers: {
                    Authorization: "Bearer " + token.jwt,
                    'X-Client-Id': token.clientId,
                    Accept: acceptHeader,
                },
            };
            return fetch(url, options).then(function (response) {
                if (response.status === 403 && retryOnAuthError) {
                    // retry once if 403
                    return _this.tokenManager
                        .getToken('read', true)
                        .then(function (newToken) { return _this.requestMediaEmoji(url, newToken, false); });
                }
                else if (response.ok) {
                    return response.blob().then(function (blob) { return _this.readBlob(blob); });
                }
                throw new Error("Unable to load media image. Status=" + response.status + " " + response.statusText);
            });
        });
    };
    MediaImageLoader.prototype.readBlob = function (blob) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            // TODO: [ts30] Add proper handling for null and ArrayBuffer
            reader.addEventListener('load', function () { return resolve(reader.result); });
            reader.addEventListener('error', function () { return reject(reader.error); });
            reader.readAsDataURL(blob);
        });
    };
    return MediaImageLoader;
}());
/* harmony default export */ __webpack_exports__["a"] = (MediaImageLoader);
//# sourceMappingURL=MediaImageLoader.js.map

/***/ }),
/* 1835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export expireAdjustment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_util_service_support__ = __webpack_require__(41);

// expire 30 seconds early to factor in latency, slow services, etc
var expireAdjustment = 30;
var TokenManager = /** @class */ (function () {
    function TokenManager(siteServiceConfig) {
        this.siteServiceConfig = siteServiceConfig;
        this.tokens = new Map();
    }
    TokenManager.prototype.addToken = function (type, mediaApiToken) {
        this.tokens.set(type, {
            mediaApiToken: mediaApiToken,
        });
    };
    TokenManager.prototype.getToken = function (type, forceRefresh) {
        var tokenDetail = this.tokens.get(type);
        if (!tokenDetail) {
            tokenDetail = {};
            this.tokens.set(type, tokenDetail);
        }
        var mediaApiToken = tokenDetail.mediaApiToken, activeTokenRefresh = tokenDetail.activeTokenRefresh;
        if (mediaApiToken) {
            var nowInSeconds = Date.now() / 1000;
            var expiresAt = mediaApiToken.expiresAt - expireAdjustment;
            if (nowInSeconds < expiresAt && !forceRefresh) {
                // still valid
                return Promise.resolve(mediaApiToken);
            }
            if (activeTokenRefresh) {
                // refresh already active, return that
                return activeTokenRefresh;
            }
            // clear expired token
            tokenDetail.mediaApiToken = undefined;
        }
        var path = "token/" + type;
        // request a new token and track the promise for future requests until completed
        tokenDetail.activeTokenRefresh = __WEBPACK_IMPORTED_MODULE_0__atlaskit_util_service_support__["b" /* utils */]
            .requestService(this.siteServiceConfig, { path: path })
            .then(function (mediaApiToken) {
            tokenDetail.activeTokenRefresh = undefined;
            tokenDetail.mediaApiToken = mediaApiToken;
            return mediaApiToken;
        });
        return tokenDetail.activeTokenRefresh;
    };
    return TokenManager;
}());
/* harmony default export */ __webpack_exports__["a"] = (TokenManager);
//# sourceMappingURL=TokenManager.js.map

/***/ }),
/* 1836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MediaStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_request__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_artifacts__ = __webpack_require__(680);



var defaultImageOptions = {
    'max-age': 3600,
    allowAnimated: true,
    mode: 'crop',
};
var defaultGetCollectionItems = {
    limit: 30,
    sortDirection: 'desc',
};
var extendImageParams = function (params) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, defaultImageOptions, params);
};
var jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};
var MediaStore = /** @class */ (function () {
    function MediaStore(config) {
        var _this = this;
        this.config = config;
        this.getFile = function (fileId, params) {
            if (params === void 0) { params = {}; }
            return _this.request("/file/" + fileId, {
                params: params,
                authContext: { collectionName: params.collection },
            }).then(__WEBPACK_IMPORTED_MODULE_1__utils_request__["c" /* mapResponseToJson */]);
        };
        this.getFileImageURL = function (id, params) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](_this, void 0, void 0, function () {
            var auth;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.config.authProvider()];
                    case 1:
                        auth = _a.sent();
                        return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_1__utils_request__["a" /* createUrl */])(auth.baseUrl + "/file/" + id + "/image", {
                                params: extendImageParams(params),
                                auth: auth,
                            })];
                }
            });
        }); };
        this.getFileBinaryURL = function (id, collectionName) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](_this, void 0, void 0, function () {
            var auth;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.config.authProvider({ collectionName: collectionName })];
                    case 1:
                        auth = _a.sent();
                        return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_1__utils_request__["a" /* createUrl */])(auth.baseUrl + "/file/" + id + "/binary", {
                                params: { dl: true, collection: collectionName },
                                auth: auth,
                            })];
                }
            });
        }); };
        this.getArtifactURL = function (artifacts, artifactName, collectionName) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](_this, void 0, void 0, function () {
            var artifactUrl, auth;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        artifactUrl = Object(__WEBPACK_IMPORTED_MODULE_2__models_artifacts__["a" /* getArtifactUrl */])(artifacts, artifactName);
                        if (!artifactUrl) {
                            throw new Error("artifact " + artifactName + " not found");
                        }
                        return [4 /*yield*/, this.config.authProvider({ collectionName: collectionName })];
                    case 1:
                        auth = _a.sent();
                        return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_1__utils_request__["a" /* createUrl */])("" + auth.baseUrl + artifactUrl, {
                                params: { collection: collectionName },
                                auth: auth,
                            })];
                }
            });
        }); };
        // TODO [MS-1352]: add WEBP header
        this.getImage = function (id, params, controller) {
            return _this.request("/file/" + id + "/image", {
                params: extendImageParams(params),
                authContext: { collectionName: params && params.collection },
            }, controller).then(__WEBPACK_IMPORTED_MODULE_1__utils_request__["b" /* mapResponseToBlob */]);
        };
        this.getItems = function (ids, collectionName) {
            var descriptors = ids.map(function (id) { return ({
                type: 'file',
                id: id,
                collection: collectionName,
            }); });
            return _this.request('/items', {
                method: 'POST',
                body: JSON.stringify({ descriptors: descriptors }),
                headers: jsonHeaders,
                authContext: { collectionName: collectionName },
            }).then(__WEBPACK_IMPORTED_MODULE_1__utils_request__["c" /* mapResponseToJson */]);
        };
        this.getImageMetadata = function (id, params) {
            return _this.request("/file/" + id + "/image/metadata", {
                params: params,
                authContext: { collectionName: params && params.collection },
            }).then(__WEBPACK_IMPORTED_MODULE_1__utils_request__["c" /* mapResponseToJson */]);
        };
    }
    MediaStore.prototype.createCollection = function (collectionName) {
        return this.request('/collection', {
            method: 'POST',
            body: JSON.stringify({ name: collectionName }),
            authContext: { collectionName: collectionName },
            headers: jsonHeaders,
        }).then(__WEBPACK_IMPORTED_MODULE_1__utils_request__["c" /* mapResponseToJson */]);
    };
    MediaStore.prototype.getCollection = function (collectionName) {
        return this.request("/collection/" + collectionName, {
            authContext: { collectionName: collectionName },
            headers: {
                Accept: 'application/json',
            },
        }).then(__WEBPACK_IMPORTED_MODULE_1__utils_request__["c" /* mapResponseToJson */]);
    };
    MediaStore.prototype.getCollectionItems = function (collectionName, params) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
            var response, _a, contents, nextInclusiveStartKey, contentsWithoutEmptyFiles;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.request("/collection/" + collectionName + "/items", {
                            authContext: { collectionName: collectionName },
                            params: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, defaultGetCollectionItems, params),
                            headers: {
                                Accept: 'application/json',
                            },
                        })];
                    case 1:
                        response = _b.sent();
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_1__utils_request__["c" /* mapResponseToJson */])(response)];
                    case 2:
                        _a = (_b.sent()).data, contents = _a.contents, nextInclusiveStartKey = _a.nextInclusiveStartKey;
                        contentsWithoutEmptyFiles = contents.filter(function (item) { return item.details.size && item.details.size > 0; });
                        return [2 /*return*/, {
                                data: {
                                    contents: contentsWithoutEmptyFiles,
                                    nextInclusiveStartKey: nextInclusiveStartKey,
                                },
                            }];
                }
            });
        });
    };
    MediaStore.prototype.removeCollectionFile = function (id, collectionName, occurrenceKey) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
            var body;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = {
                            actions: [
                                {
                                    action: 'remove',
                                    item: {
                                        type: 'file',
                                        id: id,
                                        occurrenceKey: occurrenceKey,
                                    },
                                },
                            ],
                        };
                        return [4 /*yield*/, this.request("/collection/" + collectionName, {
                                method: 'PUT',
                                authContext: { collectionName: collectionName },
                                body: JSON.stringify(body),
                                headers: {
                                    Accept: 'application/json',
                                    'Content-Type': 'application/json',
                                },
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MediaStore.prototype.createUpload = function (createUpTo, collectionName) {
        if (createUpTo === void 0) { createUpTo = 1; }
        return this.request("/upload", {
            method: 'POST',
            authContext: { collectionName: collectionName },
            params: {
                createUpTo: createUpTo,
            },
            headers: {
                Accept: 'application/json',
            },
        }).then(__WEBPACK_IMPORTED_MODULE_1__utils_request__["c" /* mapResponseToJson */]);
    };
    MediaStore.prototype.uploadChunk = function (etag, blob, collectionName) {
        return this.request("/chunk/" + etag, {
            method: 'PUT',
            authContext: { collectionName: collectionName },
            body: blob,
        }).then(__WEBPACK_IMPORTED_MODULE_1__utils_request__["d" /* mapResponseToVoid */]);
    };
    MediaStore.prototype.probeChunks = function (chunks, collectionName) {
        return this.request("/chunk/probe", {
            method: 'POST',
            authContext: { collectionName: collectionName },
            body: JSON.stringify({
                chunks: chunks,
            }),
            headers: jsonHeaders,
        }).then(__WEBPACK_IMPORTED_MODULE_1__utils_request__["c" /* mapResponseToJson */]);
    };
    MediaStore.prototype.createFileFromUpload = function (body, params) {
        if (params === void 0) { params = {}; }
        return this.request('/file/upload', {
            method: 'POST',
            authContext: { collectionName: params.collection },
            params: params,
            body: JSON.stringify(body),
            headers: jsonHeaders,
        }).then(__WEBPACK_IMPORTED_MODULE_1__utils_request__["c" /* mapResponseToJson */]);
    };
    MediaStore.prototype.touchFiles = function (body, params) {
        if (params === void 0) { params = {}; }
        return this.request('/upload/createWithFiles', {
            method: 'POST',
            headers: jsonHeaders,
            body: JSON.stringify(body),
            authContext: { collectionName: params.collection },
        }).then(__WEBPACK_IMPORTED_MODULE_1__utils_request__["c" /* mapResponseToJson */]);
    };
    MediaStore.prototype.createFile = function (params) {
        if (params === void 0) { params = {}; }
        return this.request('/file', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
            },
            params: params,
            authContext: { collectionName: params.collection },
        }).then(__WEBPACK_IMPORTED_MODULE_1__utils_request__["c" /* mapResponseToJson */]);
    };
    MediaStore.prototype.createFileFromBinary = function (blob, params) {
        if (params === void 0) { params = {}; }
        return this.request('/file/binary', {
            method: 'POST',
            body: blob,
            params: params,
            headers: {
                Accept: 'application/json',
                'Content-Type': blob.type,
            },
            authContext: { collectionName: params.collection },
        }).then(__WEBPACK_IMPORTED_MODULE_1__utils_request__["c" /* mapResponseToJson */]);
    };
    MediaStore.prototype.appendChunksToUpload = function (uploadId, body, collectionName) {
        return this.request("/upload/" + uploadId + "/chunks", {
            method: 'PUT',
            authContext: { collectionName: collectionName },
            body: JSON.stringify(body),
            headers: jsonHeaders,
        }).then(__WEBPACK_IMPORTED_MODULE_1__utils_request__["d" /* mapResponseToVoid */]);
    };
    MediaStore.prototype.copyFileWithToken = function (body, params) {
        return this.request('/file/copy/withToken', {
            method: 'POST',
            authContext: { collectionName: params.collection },
            body: JSON.stringify(body),
            headers: jsonHeaders,
            params: params,
        }).then(__WEBPACK_IMPORTED_MODULE_1__utils_request__["c" /* mapResponseToJson */]);
    };
    MediaStore.prototype.request = function (path, options, controller) {
        if (options === void 0) { options = {
            method: 'GET',
            authContext: {},
        }; }
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
            var authProvider, method, authContext, params, headers, body, auth;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        authProvider = this.config.authProvider;
                        method = options.method, authContext = options.authContext, params = options.params, headers = options.headers, body = options.body;
                        return [4 /*yield*/, authProvider(authContext)];
                    case 1:
                        auth = _a.sent();
                        return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_1__utils_request__["e" /* request */])("" + auth.baseUrl + path, {
                                method: method,
                                auth: auth,
                                params: params,
                                headers: headers,
                                body: body,
                            }, controller)];
                }
            });
        });
    };
    return MediaStore;
}());

//# sourceMappingURL=media-store.js.map

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(1838);
var objectAssign = __webpack_require__(184);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 1839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapAuthToQueryParameters;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth__ = __webpack_require__(386);

function mapAuthToQueryParameters(auth) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__auth__["a" /* isClientBasedAuth */])(auth)) {
        return {
            client: auth.clientId,
            token: auth.token,
        };
    }
    else {
        return {
            issuer: auth.asapIssuer,
            token: auth.token,
        };
    }
}
//# sourceMappingURL=auth-query-parameters.js.map

/***/ }),
/* 1840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isPreviewableType */
var isPreviewableType = function (type) {
    return ['audio', 'video', 'image'].indexOf(type) > -1;
};
//# sourceMappingURL=media.js.map

/***/ }),
/* 1841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UploadController; });
var UploadController = /** @class */ (function () {
    function UploadController() {
    }
    UploadController.prototype.setAbort = function (abortFunction) {
        this.abortFunction = abortFunction;
    };
    UploadController.prototype.abort = function () {
        if (this.abortFunction) {
            this.abortFunction();
        }
    };
    return UploadController;
}());

//# sourceMappingURL=upload-controller.js.map

/***/ }),
/* 1842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return uploadFile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chunkinator__ = __webpack_require__(1843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chunkinator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chunkinator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_hashing_hasherCreator__ = __webpack_require__(1869);
var _this = this;



var hashingFunction = function (blob) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](_this, void 0, void 0, function () {
    var hasher;
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_2__utils_hashing_hasherCreator__["a" /* createHasher */])()];
            case 1:
                hasher = _a.sent();
                return [2 /*return*/, hasher.hash(blob)];
        }
    });
}); };
var createProbingFunction = function (store, collection) { return function (chunks) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](_this, void 0, void 0, function () {
    var response, results;
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, store.probeChunks(hashedChunks(chunks), collection)];
            case 1:
                response = _a.sent();
                results = response.data.results;
                return [2 /*return*/, Object.values(results).map(function (result) { return result.exists; })];
        }
    });
}); }; };
var createUploadingFunction = function (store, collection) {
    return function (chunk) {
        return store.uploadChunk(chunk.hash, chunk.blob, collection);
    };
};
var createProcessingFunction = function (store, deferredUploadId, collection) {
    var offset = 0;
    return function (chunks) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](_this, void 0, void 0, function () {
        var _a, _b;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_c) {
            switch (_c.label) {
                case 0:
                    _b = (_a = store).appendChunksToUpload;
                    return [4 /*yield*/, deferredUploadId];
                case 1: return [4 /*yield*/, _b.apply(_a, [_c.sent(),
                        {
                            chunks: hashedChunks(chunks),
                            offset: offset,
                        },
                        collection])];
                case 2:
                    _c.sent();
                    offset += chunks.length;
                    return [2 /*return*/];
            }
        });
    }); };
};
var uploadFile = function (file, store, uploadableFileUpfrontIds, callbacks) {
    var content = file.content, collection = file.collection, name = file.name, mimeType = file.mimeType;
    var id = uploadableFileUpfrontIds.id, occurrenceKey = uploadableFileUpfrontIds.occurrenceKey, deferredUploadId = uploadableFileUpfrontIds.deferredUploadId;
    var _a = __WEBPACK_IMPORTED_MODULE_1_chunkinator___default()(content, {
        hashingFunction: hashingFunction,
        hashingConcurrency: 5,
        probingBatchSize: 100,
        chunkSize: 4 * 1024 * 1024,
        uploadingConcurrency: 3,
        uploadingFunction: createUploadingFunction(store, collection),
        probingFunction: createProbingFunction(store, collection),
        processingBatchSize: 1000,
        processingFunction: createProcessingFunction(store, deferredUploadId, collection),
    }, {
        onProgress: function (progress) {
            if (callbacks) {
                callbacks.onProgress(progress);
            }
        },
    }), response = _a.response, cancel = _a.cancel;
    var onUploadFinish = (callbacks && callbacks.onUploadFinish) || (function () { });
    Promise.all([deferredUploadId, response])
        .then(function (_a) {
        var _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](_a, 1), uploadId = _b[0];
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](_this, void 0, void 0, function () {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, store.createFileFromUpload({ uploadId: uploadId, name: name, mimeType: mimeType }, {
                            occurrenceKey: occurrenceKey,
                            collection: collection,
                            replaceFileId: id,
                        })];
                    case 1:
                        _c.sent();
                        onUploadFinish();
                        return [2 /*return*/];
                }
            });
        });
    })
        .catch(onUploadFinish);
    return { cancel: cancel };
};
var hashedChunks = function (chunks) { return chunks.map(function (chunk) { return chunk.hash; }); };
//# sourceMappingURL=uploader.js.map

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var chunkinator_1 = __webpack_require__(1844);
exports.default = chunkinator_1.chunkinator;
//# sourceMappingURL=index.js.map

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tap_1 = __webpack_require__(1845);
var concatMap_1 = __webpack_require__(388);
var fromPromise_1 = __webpack_require__(688);
var Subject_1 = __webpack_require__(394);
var slicenator_1 = __webpack_require__(1852);
var hashinator_1 = __webpack_require__(1858);
var probinator_1 = __webpack_require__(1860);
var uploadinator_1 = __webpack_require__(1866);
var processinator_1 = __webpack_require__(1867);
var utils_1 = __webpack_require__(1868);
exports.getObservableFromFile = function (file, options, callbacks) {
    return fromPromise_1.fromPromise(utils_1.fetchBlob(file)).pipe(concatMap_1.concatMap(function (blob) {
        var chunkSize = options.chunkSize;
        var onProgress = callbacks.onProgress;
        var totalChunks = Math.ceil(blob.size / chunkSize);
        var slicenatedBlobs = slicenator_1.slicenator(blob, { size: chunkSize });
        var hashinatedBlobs = hashinator_1.hashinator(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        var probinatedBlobs = probinator_1.probinator(hashinatedBlobs, {
            batchSize: options.probingBatchSize,
            prober: options.probingFunction
        });
        var uploadedChunks = 0;
        var uploadedBlobs = uploadinator_1.uploadinator(probinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) {
            uploadedBlobs = uploadedBlobs.pipe(tap_1.tap(function () {
                uploadedChunks += 1;
                onProgress(uploadedChunks / totalChunks);
            }));
        }
        return processinator_1.processinator(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        });
    }));
};
exports.chunkinator = function (file, options, callbacks) {
    return toCancelablePromise(exports.getObservableFromFile(file, options, callbacks));
};
function toCancelablePromise(observable) {
    var subject = new Subject_1.Subject();
    var subscription = observable.subscribe(subject);
    return {
        response: subject.toPromise(),
        cancel: function () {
            subscription.unsubscribe();
            subject.error("canceled");
        }
    };
}
exports.toCancelablePromise = toCancelablePromise;
//# sourceMappingURL=chunkinator.js.map

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(90);
/* tslint:enable:max-line-length */
/**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @name tap
 */
function tap(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new DoOperator(nextOrObserver, error, complete));
    };
}
exports.tap = tap;
var DoOperator = (function () {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DoSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DoSubscriber = (function (_super) {
    __extends(DoSubscriber, _super);
    function DoSubscriber(destination, nextOrObserver, error, complete) {
        _super.call(this, destination);
        var safeSubscriber = new Subscriber_1.Subscriber(nextOrObserver, error, complete);
        safeSubscriber.syncErrorThrowable = true;
        this.add(safeSubscriber);
        this.safeSubscriber = safeSubscriber;
    }
    DoSubscriber.prototype._next = function (value) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.next(value);
        if (safeSubscriber.syncErrorThrown) {
            this.destination.error(safeSubscriber.syncErrorValue);
        }
        else {
            this.destination.next(value);
        }
    };
    DoSubscriber.prototype._error = function (err) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.error(err);
        if (safeSubscriber.syncErrorThrown) {
            this.destination.error(safeSubscriber.syncErrorValue);
        }
        else {
            this.destination.error(err);
        }
    };
    DoSubscriber.prototype._complete = function () {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.complete();
        if (safeSubscriber.syncErrorThrown) {
            this.destination.error(safeSubscriber.syncErrorValue);
        }
        else {
            this.destination.complete();
        }
    };
    return DoSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=tap.js.map

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var errorObject_1 = __webpack_require__(684);
var tryCatchTarget;
function tryCatcher() {
    try {
        return tryCatchTarget.apply(this, arguments);
    }
    catch (e) {
        errorObject_1.errorObject.e = e;
        return errorObject_1.errorObject;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}
exports.tryCatch = tryCatch;
;
//# sourceMappingURL=tryCatch.js.map

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */
var UnsubscriptionError = (function (_super) {
    __extends(UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        _super.call(this);
        this.errors = errors;
        var err = Error.call(this, errors ?
            errors.length + " errors occurred during unsubscription:\n  " + errors.map(function (err, i) { return ((i + 1) + ") " + err.toString()); }).join('\n  ') : '');
        this.name = err.name = 'UnsubscriptionError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return UnsubscriptionError;
}(Error));
exports.UnsubscriptionError = UnsubscriptionError;
//# sourceMappingURL=UnsubscriptionError.js.map

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Subscriber_1 = __webpack_require__(90);
var rxSubscriber_1 = __webpack_require__(387);
var Observer_1 = __webpack_require__(685);
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof Subscriber_1.Subscriber) {
            return nextOrObserver;
        }
        if (nextOrObserver[rxSubscriber_1.rxSubscriber]) {
            return nextOrObserver[rxSubscriber_1.rxSubscriber]();
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new Subscriber_1.Subscriber(Observer_1.empty);
    }
    return new Subscriber_1.Subscriber(nextOrObserver, error, complete);
}
exports.toSubscriber = toSubscriber;
//# sourceMappingURL=toSubscriber.js.map

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var noop_1 = __webpack_require__(1850);
/* tslint:enable:max-line-length */
function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i - 0] = arguments[_i];
    }
    return pipeFromArray(fns);
}
exports.pipe = pipe;
/* @internal */
function pipeFromArray(fns) {
    if (!fns) {
        return noop_1.noop;
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}
exports.pipeFromArray = pipeFromArray;
//# sourceMappingURL=pipe.js.map

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable:no-empty */
function noop() { }
exports.noop = noop;
//# sourceMappingURL=noop.js.map

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(90);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var InnerSubscriber = (function (_super) {
    __extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        _super.call(this);
        this.parent = parent;
        this.outerValue = outerValue;
        this.outerIndex = outerIndex;
        this.index = 0;
    }
    InnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}(Subscriber_1.Subscriber));
exports.InnerSubscriber = InnerSubscriber;
//# sourceMappingURL=InnerSubscriber.js.map

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = __webpack_require__(42);
__webpack_require__(1853);
__webpack_require__(1856);
exports.slicenator = function (blob, _a) {
    var chunkSize = _a.size;
    var totalChunks = Math.ceil(blob.size / chunkSize);
    return Observable_1.Observable.range(0, totalChunks).map(function (index) {
        return blob.slice(index * chunkSize, (index + 1) * chunkSize);
    });
};
//# sourceMappingURL=slicenator.js.map

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(42);
var range_1 = __webpack_require__(1854);
Observable_1.Observable.range = range_1.range;
//# sourceMappingURL=range.js.map

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var RangeObservable_1 = __webpack_require__(1855);
exports.range = RangeObservable_1.RangeObservable.create;
//# sourceMappingURL=range.js.map

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(42);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var RangeObservable = (function (_super) {
    __extends(RangeObservable, _super);
    function RangeObservable(start, count, scheduler) {
        _super.call(this);
        this.start = start;
        this._count = count;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits a sequence of numbers within a specified
     * range.
     *
     * <span class="informal">Emits a sequence of numbers in a range.</span>
     *
     * <img src="./img/range.png" width="100%">
     *
     * `range` operator emits a range of sequential integers, in order, where you
     * select the `start` of the range and its `length`. By default, uses no
     * IScheduler and just delivers the notifications synchronously, but may use
     * an optional IScheduler to regulate those deliveries.
     *
     * @example <caption>Emits the numbers 1 to 10</caption>
     * var numbers = Rx.Observable.range(1, 10);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link timer}
     * @see {@link interval}
     *
     * @param {number} [start=0] The value of the first integer in the sequence.
     * @param {number} [count=0] The number of sequential integers to generate.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the notifications.
     * @return {Observable} An Observable of numbers that emits a finite range of
     * sequential integers.
     * @static true
     * @name range
     * @owner Observable
     */
    RangeObservable.create = function (start, count, scheduler) {
        if (start === void 0) { start = 0; }
        if (count === void 0) { count = 0; }
        return new RangeObservable(start, count, scheduler);
    };
    RangeObservable.dispatch = function (state) {
        var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(start);
        if (subscriber.closed) {
            return;
        }
        state.index = index + 1;
        state.start = start + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ RangeObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var start = this.start;
        var count = this._count;
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(RangeObservable.dispatch, 0, {
                index: index, count: count, start: start, subscriber: subscriber
            });
        }
        else {
            do {
                if (index++ >= count) {
                    subscriber.complete();
                    break;
                }
                subscriber.next(start++);
                if (subscriber.closed) {
                    break;
                }
            } while (true);
        }
    };
    return RangeObservable;
}(Observable_1.Observable));
exports.RangeObservable = RangeObservable;
//# sourceMappingURL=RangeObservable.js.map

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(42);
var map_1 = __webpack_require__(1857);
Observable_1.Observable.prototype.map = map_1.map;
//# sourceMappingURL=map.js.map

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var map_1 = __webpack_require__(551);
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */
function map(project, thisArg) {
    return map_1.map(project, thisArg)(this);
}
exports.map = map;
//# sourceMappingURL=map.js.map

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_async_map_1 = __webpack_require__(692);
function arrayBufferToHex(buffer) {
    return Array.prototype.map.call(new Uint8Array(buffer), function (x) { return ('00' + x.toString(16)).slice(-2); }).join('');
}
function blobToArrayBuffer(blob) {
    var fileReader = new FileReader();
    return new Promise(function (resolve, reject) {
        fileReader.onload = function () {
            resolve(this.result);
        };
        fileReader.onerror = reject;
        fileReader.readAsArrayBuffer(blob);
    });
}
exports.defaultHasher = function (blob) {
    return blobToArrayBuffer(blob)
        .then(function (arrayBuffer) { return crypto.subtle.digest('SHA-1', arrayBuffer); })
        .then(arrayBufferToHex);
};
exports.blobToHashedBlob = function (hasher) { return function (blob) {
    return hasher(blob)
        .then(function (hash) { return ({ blob: blob, hash: hash + "-" + blob.size }); });
}; };
exports.hashinator = function (blobs$, _a) {
    var hasher = _a.hasher, concurrency = _a.concurrency;
    return rxjs_async_map_1.asyncMap(exports.blobToHashedBlob(hasher || exports.defaultHasher), concurrency)(blobs$);
};
//# sourceMappingURL=hashinator.js.map

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.notify = function (promise, observer, onReady) {
    var notifier = {
        notifyIfReady: function () { return false; }
    };
    promise.then(function (value) {
        notifier.notifyIfReady = function () {
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, function (reason) {
        notifier.notifyIfReady = function () {
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
//# sourceMappingURL=notify.js.map

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var Observable_1 = __webpack_require__(42);
var bufferCount_1 = __webpack_require__(693);
var concatMap_1 = __webpack_require__(388);
__webpack_require__(1861);
function probinator(hashedBlob$, _a) {
    var batchSize = _a.batchSize, prober = _a.prober;
    return hashedBlob$.pipe(bufferCount_1.bufferCount(batchSize), concatMap_1.concatMap(function (hashedBlobs) {
        return prober(hashedBlobs).then(function (probes) {
            return hashedBlobs.map(function (hashedBlob, index) { return (tslib_1.__assign({}, hashedBlob, { exists: probes[index] })); });
        });
    }), concatMap_1.concatMap(function (probedBlobs) { return Observable_1.Observable.from(probedBlobs); }));
}
exports.probinator = probinator;
//# sourceMappingURL=probinator.js.map

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(42);
var from_1 = __webpack_require__(1862);
Observable_1.Observable.from = from_1.from;
//# sourceMappingURL=from.js.map

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var FromObservable_1 = __webpack_require__(1863);
exports.from = FromObservable_1.FromObservable.create;
//# sourceMappingURL=from.js.map

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isArray_1 = __webpack_require__(682);
var isArrayLike_1 = __webpack_require__(686);
var isPromise_1 = __webpack_require__(687);
var PromiseObservable_1 = __webpack_require__(689);
var IteratorObservable_1 = __webpack_require__(1864);
var ArrayObservable_1 = __webpack_require__(395);
var ArrayLikeObservable_1 = __webpack_require__(1865);
var iterator_1 = __webpack_require__(392);
var Observable_1 = __webpack_require__(42);
var observeOn_1 = __webpack_require__(697);
var observable_1 = __webpack_require__(391);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var FromObservable = (function (_super) {
    __extends(FromObservable, _super);
    function FromObservable(ish, scheduler) {
        _super.call(this, null);
        this.ish = ish;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable from an Array, an array-like object, a Promise, an
     * iterable object, or an Observable-like object.
     *
     * <span class="informal">Converts almost anything to an Observable.</span>
     *
     * <img src="./img/from.png" width="100%">
     *
     * Convert various other objects and data types into Observables. `from`
     * converts a Promise or an array-like or an
     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
     * object into an Observable that emits the items in that promise or array or
     * iterable. A String, in this context, is treated as an array of characters.
     * Observable-like objects (contains a function named with the ES2015 Symbol
     * for Observable) can also be converted through this operator.
     *
     * @example <caption>Converts an array to an Observable</caption>
     * var array = [10, 20, 30];
     * var result = Rx.Observable.from(array);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 10 20 30
     *
     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
     * function* generateDoubles(seed) {
     *   var i = seed;
     *   while (true) {
     *     yield i;
     *     i = 2 * i; // double it
     *   }
     * }
     *
     * var iterator = generateDoubles(3);
     * var result = Rx.Observable.from(iterator).take(10);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 3 6 12 24 48 96 192 384 768 1536
     *
     * @see {@link create}
     * @see {@link fromEvent}
     * @see {@link fromEventPattern}
     * @see {@link fromPromise}
     *
     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
     * Observable-like, an Array, an iterable or an array-like object to be
     * converted.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * emissions of values.
     * @return {Observable<T>} The Observable whose values are originally from the
     * input object that was converted.
     * @static true
     * @name from
     * @owner Observable
     */
    FromObservable.create = function (ish, scheduler) {
        if (ish != null) {
            if (typeof ish[observable_1.observable] === 'function') {
                if (ish instanceof Observable_1.Observable && !scheduler) {
                    return ish;
                }
                return new FromObservable(ish, scheduler);
            }
            else if (isArray_1.isArray(ish)) {
                return new ArrayObservable_1.ArrayObservable(ish, scheduler);
            }
            else if (isPromise_1.isPromise(ish)) {
                return new PromiseObservable_1.PromiseObservable(ish, scheduler);
            }
            else if (typeof ish[iterator_1.iterator] === 'function' || typeof ish === 'string') {
                return new IteratorObservable_1.IteratorObservable(ish, scheduler);
            }
            else if (isArrayLike_1.isArrayLike(ish)) {
                return new ArrayLikeObservable_1.ArrayLikeObservable(ish, scheduler);
            }
        }
        throw new TypeError((ish !== null && typeof ish || ish) + ' is not observable');
    };
    /** @deprecated internal use only */ FromObservable.prototype._subscribe = function (subscriber) {
        var ish = this.ish;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            return ish[observable_1.observable]().subscribe(subscriber);
        }
        else {
            return ish[observable_1.observable]().subscribe(new observeOn_1.ObserveOnSubscriber(subscriber, scheduler, 0));
        }
    };
    return FromObservable;
}(Observable_1.Observable));
exports.FromObservable = FromObservable;
//# sourceMappingURL=FromObservable.js.map

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__(112);
var Observable_1 = __webpack_require__(42);
var iterator_1 = __webpack_require__(392);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var IteratorObservable = (function (_super) {
    __extends(IteratorObservable, _super);
    function IteratorObservable(iterator, scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
        if (iterator == null) {
            throw new Error('iterator cannot be null.');
        }
        this.iterator = getIterator(iterator);
    }
    IteratorObservable.create = function (iterator, scheduler) {
        return new IteratorObservable(iterator, scheduler);
    };
    IteratorObservable.dispatch = function (state) {
        var index = state.index, hasError = state.hasError, iterator = state.iterator, subscriber = state.subscriber;
        if (hasError) {
            subscriber.error(state.error);
            return;
        }
        var result = iterator.next();
        if (result.done) {
            subscriber.complete();
            return;
        }
        subscriber.next(result.value);
        state.index = index + 1;
        if (subscriber.closed) {
            if (typeof iterator.return === 'function') {
                iterator.return();
            }
            return;
        }
        this.schedule(state);
    };
    /** @deprecated internal use only */ IteratorObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var _a = this, iterator = _a.iterator, scheduler = _a.scheduler;
        if (scheduler) {
            return scheduler.schedule(IteratorObservable.dispatch, 0, {
                index: index, iterator: iterator, subscriber: subscriber
            });
        }
        else {
            do {
                var result = iterator.next();
                if (result.done) {
                    subscriber.complete();
                    break;
                }
                else {
                    subscriber.next(result.value);
                }
                if (subscriber.closed) {
                    if (typeof iterator.return === 'function') {
                        iterator.return();
                    }
                    break;
                }
            } while (true);
        }
    };
    return IteratorObservable;
}(Observable_1.Observable));
exports.IteratorObservable = IteratorObservable;
var StringIterator = (function () {
    function StringIterator(str, idx, len) {
        if (idx === void 0) { idx = 0; }
        if (len === void 0) { len = str.length; }
        this.str = str;
        this.idx = idx;
        this.len = len;
    }
    StringIterator.prototype[iterator_1.iterator] = function () { return (this); };
    StringIterator.prototype.next = function () {
        return this.idx < this.len ? {
            done: false,
            value: this.str.charAt(this.idx++)
        } : {
            done: true,
            value: undefined
        };
    };
    return StringIterator;
}());
var ArrayIterator = (function () {
    function ArrayIterator(arr, idx, len) {
        if (idx === void 0) { idx = 0; }
        if (len === void 0) { len = toLength(arr); }
        this.arr = arr;
        this.idx = idx;
        this.len = len;
    }
    ArrayIterator.prototype[iterator_1.iterator] = function () { return this; };
    ArrayIterator.prototype.next = function () {
        return this.idx < this.len ? {
            done: false,
            value: this.arr[this.idx++]
        } : {
            done: true,
            value: undefined
        };
    };
    return ArrayIterator;
}());
function getIterator(obj) {
    var i = obj[iterator_1.iterator];
    if (!i && typeof obj === 'string') {
        return new StringIterator(obj);
    }
    if (!i && obj.length !== undefined) {
        return new ArrayIterator(obj);
    }
    if (!i) {
        throw new TypeError('object is not iterable');
    }
    return obj[iterator_1.iterator]();
}
var maxSafeInteger = Math.pow(2, 53) - 1;
function toLength(o) {
    var len = +o.length;
    if (isNaN(len)) {
        return 0;
    }
    if (len === 0 || !numberIsFinite(len)) {
        return len;
    }
    len = sign(len) * Math.floor(Math.abs(len));
    if (len <= 0) {
        return 0;
    }
    if (len > maxSafeInteger) {
        return maxSafeInteger;
    }
    return len;
}
function numberIsFinite(value) {
    return typeof value === 'number' && root_1.root.isFinite(value);
}
function sign(value) {
    var valueAsNumber = +value;
    if (valueAsNumber === 0) {
        return valueAsNumber;
    }
    if (isNaN(valueAsNumber)) {
        return valueAsNumber;
    }
    return valueAsNumber < 0 ? -1 : 1;
}
//# sourceMappingURL=IteratorObservable.js.map

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(42);
var ScalarObservable_1 = __webpack_require__(694);
var EmptyObservable_1 = __webpack_require__(695);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ArrayLikeObservable = (function (_super) {
    __extends(ArrayLikeObservable, _super);
    function ArrayLikeObservable(arrayLike, scheduler) {
        _super.call(this);
        this.arrayLike = arrayLike;
        this.scheduler = scheduler;
        if (!scheduler && arrayLike.length === 1) {
            this._isScalar = true;
            this.value = arrayLike[0];
        }
    }
    ArrayLikeObservable.create = function (arrayLike, scheduler) {
        var length = arrayLike.length;
        if (length === 0) {
            return new EmptyObservable_1.EmptyObservable();
        }
        else if (length === 1) {
            return new ScalarObservable_1.ScalarObservable(arrayLike[0], scheduler);
        }
        else {
            return new ArrayLikeObservable(arrayLike, scheduler);
        }
    };
    ArrayLikeObservable.dispatch = function (state) {
        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
        if (subscriber.closed) {
            return;
        }
        if (index >= length) {
            subscriber.complete();
            return;
        }
        subscriber.next(arrayLike[index]);
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayLikeObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
        var length = arrayLike.length;
        if (scheduler) {
            return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
                arrayLike: arrayLike, index: index, length: length, subscriber: subscriber
            });
        }
        else {
            for (var i = 0; i < length && !subscriber.closed; i++) {
                subscriber.next(arrayLike[i]);
            }
            subscriber.complete();
        }
    };
    return ArrayLikeObservable;
}(Observable_1.Observable));
exports.ArrayLikeObservable = ArrayLikeObservable;
//# sourceMappingURL=ArrayLikeObservable.js.map

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_async_map_1 = __webpack_require__(692);
var uploadinator = function (probedBlobs$, options) {
    var upload = function (probedBlob) {
        if (!probedBlob.exists) {
            return options.uploader(probedBlob).then(function () { return probedBlob; });
        }
        else {
            return Promise.resolve(probedBlob);
        }
    };
    return probedBlobs$.pipe(rxjs_async_map_1.asyncMap(upload, options.concurrency));
};
exports.uploadinator = uploadinator;
//# sourceMappingURL=uploadinator.js.map

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var bufferCount_1 = __webpack_require__(693);
var concatMap_1 = __webpack_require__(388);
var processinator = function (probedBlobs$, options) {
    var process = function (probedBlobs) {
        if (options.processor) {
            return options.processor(probedBlobs).then(function () { return probedBlobs; });
        }
        else {
            return Promise.resolve(probedBlobs);
        }
    };
    return probedBlobs$.pipe(bufferCount_1.bufferCount(options.batchSize)).pipe(concatMap_1.concatMap(process));
};
exports.processinator = processinator;
//# sourceMappingURL=processinator.js.map

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
function fetchBlob(file) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(typeof file === "string")) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetch(file).then(function (response) { return response.blob(); })];
                case 1: return [2 /*return*/, _a.sent()];
                case 2: return [2 /*return*/, file];
            }
        });
    });
}
exports.fetchBlob = fetchBlob;
//# sourceMappingURL=utils.js.map

/***/ }),
/* 1869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export destroyHasher */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createHasher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
var _this = this;

var hasher = null;
var destroyHasher = function () { return (hasher = null); };
var createHasher = function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](_this, void 0, void 0, function () {
    var numWorkers, WorkerHasher, error_1, SimpleHasher;
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
        switch (_a.label) {
            case 0:
                numWorkers = 3;
                if (!!hasher) return [3 /*break*/, 5];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 5]);
                return [4 /*yield*/, __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 3460))];
            case 2:
                WorkerHasher = (_a.sent()).WorkerHasher;
                hasher = new WorkerHasher(numWorkers);
                return [3 /*break*/, 5];
            case 3:
                error_1 = _a.sent();
                return [4 /*yield*/, __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 3461))];
            case 4:
                SimpleHasher = (_a.sent()).SimpleHasher;
                hasher = new SimpleHasher();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/, hasher];
        }
    });
}); };
//# sourceMappingURL=hasherCreator.js.map

/***/ }),
/* 1870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_media_store__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__collection__ = __webpack_require__(1871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__file__ = __webpack_require__(1877);




var ContextFactory = /** @class */ (function () {
    function ContextFactory() {
    }
    ContextFactory.create = function (config) {
        return new ContextImpl(config);
    };
    return ContextFactory;
}());

var ContextImpl = /** @class */ (function () {
    function ContextImpl(config) {
        this.config = config;
        this.mediaStore = new __WEBPACK_IMPORTED_MODULE_1__atlaskit_media_store__["a" /* MediaStore */]({
            authProvider: config.authProvider,
        });
        this.collection = new __WEBPACK_IMPORTED_MODULE_2__collection__["a" /* CollectionFetcher */](this.mediaStore);
        this.file = new __WEBPACK_IMPORTED_MODULE_3__file__["a" /* FileFetcher */](this.mediaStore);
    }
    ContextImpl.prototype.getImage = function (id, params, controller) {
        return this.mediaStore.getImage(id, params, controller);
    };
    ContextImpl.prototype.getImageMetadata = function (id, params) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mediaStore.getImageMetadata(id, params)];
                    case 1: return [2 /*return*/, (_a.sent()).metadata];
                }
            });
        });
    };
    return ContextImpl;
}());
//# sourceMappingURL=context.js.map

/***/ }),
/* 1871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export collectionCache */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CollectionFetcher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_ReplaySubject__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_ReplaySubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_ReplaySubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fileState__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_fileStreamCache__ = __webpack_require__(398);




var collectionCache = {};
var createCacheEntry = function () { return ({
    items: [],
    subject: new __WEBPACK_IMPORTED_MODULE_1_rxjs_ReplaySubject__["ReplaySubject"](1),
    isLoadingNextPage: false,
}); };
var CollectionFetcher = /** @class */ (function () {
    function CollectionFetcher(mediaStore) {
        this.mediaStore = mediaStore;
    }
    CollectionFetcher.prototype.createFileStateObserver = function (id, details) {
        var subject = new __WEBPACK_IMPORTED_MODULE_1_rxjs_ReplaySubject__["ReplaySubject"](1);
        var mediaFile = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ id: id }, details);
        var fileState = Object(__WEBPACK_IMPORTED_MODULE_2__fileState__["a" /* mapMediaFileToFileState */])({ data: mediaFile });
        subject.next(fileState);
        return subject;
    };
    CollectionFetcher.prototype.populateCache = function (items) {
        var _this = this;
        items.forEach(function (item) {
            var fileStream = _this.createFileStateObserver(item.id, item.details);
            __WEBPACK_IMPORTED_MODULE_3__context_fileStreamCache__["a" /* fileStreamsCache */].set(item.id, fileStream);
        });
    };
    CollectionFetcher.prototype.removeFromCache = function (id, collectionName) {
        __WEBPACK_IMPORTED_MODULE_3__context_fileStreamCache__["a" /* fileStreamsCache */].remove(id);
        var collectionCacheIndex = collectionCache[collectionName].items.findIndex(function (item) { return item.id === id; });
        collectionCache[collectionName].items.splice(collectionCacheIndex, 1);
    };
    CollectionFetcher.prototype.getItems = function (collectionName, params) {
        var _this = this;
        if (!collectionCache[collectionName]) {
            collectionCache[collectionName] = createCacheEntry();
        }
        var collection = collectionCache[collectionName];
        var subject = collection.subject;
        this.mediaStore
            .getCollectionItems(collectionName, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, params, { details: 'full' }))
            .then(function (items) {
            var _a = items.data, contents = _a.contents, nextInclusiveStartKey = _a.nextInclusiveStartKey;
            _this.populateCache(contents);
            // It's hard to merge two together, so we just take what's came from the server.
            // Since we load only one page > 2 pages will be ditched from the cache.
            collection.items = items.data.contents;
            collection.nextInclusiveStartKey = nextInclusiveStartKey;
            subject.next(collection.items);
        });
        return subject;
    };
    CollectionFetcher.prototype.removeFile = function (id, collectionName, occurrenceKey) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
            var collection;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey)];
                    case 1:
                        _a.sent();
                        this.removeFromCache(id, collectionName);
                        collection = collectionCache[collectionName];
                        collection.subject.next(collection.items);
                        return [2 /*return*/];
                }
            });
        });
    };
    CollectionFetcher.prototype.loadNextPage = function (collectionName, params) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
            var collection, isLoading, _a, inclusiveStartKey, currentItems, subject, response, _b, contents, nextInclusiveStartKey, newItems, items;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_c) {
                switch (_c.label) {
                    case 0:
                        collection = collectionCache[collectionName];
                        isLoading = collection ? collection.isLoadingNextPage : false;
                        if (!collection || !collection.nextInclusiveStartKey || isLoading) {
                            return [2 /*return*/];
                        }
                        collection.isLoadingNextPage = true;
                        _a = collectionCache[collectionName], inclusiveStartKey = _a.nextInclusiveStartKey, currentItems = _a.items, subject = _a.subject;
                        return [4 /*yield*/, this.mediaStore.getCollectionItems(collectionName, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, params, { inclusiveStartKey: inclusiveStartKey, details: 'full' }))];
                    case 1:
                        response = _c.sent();
                        _b = response.data, contents = _b.contents, nextInclusiveStartKey = _b.nextInclusiveStartKey;
                        this.populateCache(contents);
                        newItems = response.data.contents;
                        items = currentItems.concat(newItems);
                        subject.next(items);
                        collectionCache[collectionName] = {
                            items: items,
                            nextInclusiveStartKey: nextInclusiveStartKey,
                            subject: subject,
                            isLoadingNextPage: false,
                        };
                        return [2 /*return*/];
                }
            });
        });
    };
    return CollectionFetcher;
}());

//# sourceMappingURL=index.js.map

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var QueueAction_1 = __webpack_require__(1873);
var QueueScheduler_1 = __webpack_require__(1875);
/**
 *
 * Queue Scheduler
 *
 * <span class="informal">Put every next task on a queue, instead of executing it immediately</span>
 *
 * `queue` scheduler, when used with delay, behaves the same as {@link async} scheduler.
 *
 * When used without delay, it schedules given task synchronously - executes it right when
 * it is scheduled. However when called recursively, that is when inside the scheduled task,
 * another task is scheduled with queue scheduler, instead of executing immediately as well,
 * that task will be put on a queue and wait for current one to finish.
 *
 * This means that when you execute task with `queue` scheduler, you are sure it will end
 * before any other task scheduled with that scheduler will start.
 *
 * @examples <caption>Schedule recursively first, then do something</caption>
 *
 * Rx.Scheduler.queue.schedule(() => {
 *   Rx.Scheduler.queue.schedule(() => console.log('second')); // will not happen now, but will be put on a queue
 *
 *   console.log('first');
 * });
 *
 * // Logs:
 * // "first"
 * // "second"
 *
 *
 * @example <caption>Reschedule itself recursively</caption>
 *
 * Rx.Scheduler.queue.schedule(function(state) {
 *   if (state !== 0) {
 *     console.log('before', state);
 *     this.schedule(state - 1); // `this` references currently executing Action,
 *                               // which we reschedule with new state
 *     console.log('after', state);
 *   }
 * }, 0, 3);
 *
 * // In scheduler that runs recursively, you would expect:
 * // "before", 3
 * // "before", 2
 * // "before", 1
 * // "after", 1
 * // "after", 2
 * // "after", 3
 *
 * // But with queue it logs:
 * // "before", 3
 * // "after", 3
 * // "before", 2
 * // "after", 2
 * // "before", 1
 * // "after", 1
 *
 *
 * @static true
 * @name queue
 * @owner Scheduler
 */
exports.queue = new QueueScheduler_1.QueueScheduler(QueueAction_1.QueueAction);
//# sourceMappingURL=queue.js.map

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncAction_1 = __webpack_require__(699);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var QueueAction = (function (_super) {
    __extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    QueueAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay > 0) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function (state, delay) {
        return (delay > 0 || this.closed) ?
            _super.prototype.execute.call(this, state, delay) :
            this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        // Otherwise flush the scheduler starting with this action.
        return scheduler.flush(this);
    };
    return QueueAction;
}(AsyncAction_1.AsyncAction));
exports.QueueAction = QueueAction;
//# sourceMappingURL=QueueAction.js.map

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscription_1 = __webpack_require__(158);
/**
 * A unit of work to be executed in a {@link Scheduler}. An action is typically
 * created from within a Scheduler and an RxJS user does not need to concern
 * themselves about creating and manipulating an Action.
 *
 * ```ts
 * class Action<T> extends Subscription {
 *   new (scheduler: Scheduler, work: (state?: T) => void);
 *   schedule(state?: T, delay: number = 0): Subscription;
 * }
 * ```
 *
 * @class Action<T>
 */
var Action = (function (_super) {
    __extends(Action, _super);
    function Action(scheduler, work) {
        _super.call(this);
    }
    /**
     * Schedules this action on its parent Scheduler for execution. May be passed
     * some context object, `state`. May happen at some point in the future,
     * according to the `delay` parameter, if specified.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler.
     * @return {void}
     */
    Action.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        return this;
    };
    return Action;
}(Subscription_1.Subscription));
exports.Action = Action;
//# sourceMappingURL=Action.js.map

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncScheduler_1 = __webpack_require__(700);
var QueueScheduler = (function (_super) {
    __extends(QueueScheduler, _super);
    function QueueScheduler() {
        _super.apply(this, arguments);
    }
    return QueueScheduler;
}(AsyncScheduler_1.AsyncScheduler));
exports.QueueScheduler = QueueScheduler;
//# sourceMappingURL=QueueScheduler.js.map

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * An execution context and a data structure to order tasks and schedule their
 * execution. Provides a notion of (potentially virtual) time, through the
 * `now()` getter method.
 *
 * Each unit of work in a Scheduler is called an {@link Action}.
 *
 * ```ts
 * class Scheduler {
 *   now(): number;
 *   schedule(work, delay?, state?): Subscription;
 * }
 * ```
 *
 * @class Scheduler
 */
var Scheduler = (function () {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) { now = Scheduler.now; }
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    /**
     * Schedules a function, `work`, for execution. May happen at some point in
     * the future, according to the `delay` parameter, if specified. May be passed
     * some context object, `state`, which will be passed to the `work` function.
     *
     * The given arguments will be processed an stored as an Action object in a
     * queue of actions.
     *
     * @param {function(state: ?T): ?Subscription} work A function representing a
     * task, or some unit of work to be executed by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler itself.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @return {Subscription} A subscription in order to be able to unsubscribe
     * the scheduled work.
     */
    Scheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) { delay = 0; }
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = Date.now ? Date.now : function () { return +new Date(); };
    return Scheduler;
}());
exports.Scheduler = Scheduler;
//# sourceMappingURL=Scheduler.js.map

/***/ }),
/* 1877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getItemsFromKeys */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileFetcher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_ReplaySubject__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_ReplaySubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_ReplaySubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operators_publishReplay__ = __webpack_require__(1878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operators_publishReplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators_publishReplay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dataloader__ = __webpack_require__(1882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dataloader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dataloader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_media_store__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uuid_validate__ = __webpack_require__(1885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uuid_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_uuid_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fileState__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__context_fileStreamCache__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_getMediaTypeFromUploadableFile__ = __webpack_require__(1886);











var POLLING_INTERVAL = 1000;
var maxNumberOfItemsPerCall = 100;
var makeCacheKey = function (id, collection) {
    return collection ? id + "-" + collection : id;
};
var getItemsFromKeys = function (dataloaderKeys, fileItems) {
    var itemsByKey = fileItems.reduce(function (prev, nextFileItem) {
        var id = nextFileItem.id, collection = nextFileItem.collection;
        var key = makeCacheKey(id, collection);
        prev[key] = nextFileItem.details;
        return prev;
    }, {});
    return dataloaderKeys.map(function (dataloaderKey) {
        var id = dataloaderKey.id, collection = dataloaderKey.collection;
        var key = makeCacheKey(id, collection);
        return itemsByKey[key];
    });
};
var FileFetcher = /** @class */ (function () {
    function FileFetcher(mediaStore) {
        var _this = this;
        this.mediaStore = mediaStore;
        // Returns an array of the same length as the keys filled with file items
        this.batchLoadingFunc = function (keys) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](_this, void 0, void 0, function () {
            var nonCollectionName, fileIdsByCollection, items;
            var _this = this;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        nonCollectionName = '__media-single-file-collection__';
                        fileIdsByCollection = keys.reduce(function (prev, next) {
                            var collectionName = next.collection || nonCollectionName;
                            var fileIds = prev[collectionName] || [];
                            fileIds.push(next.id);
                            prev[collectionName] = fileIds;
                            return prev;
                        }, {});
                        items = [];
                        return [4 /*yield*/, Promise.all(Object.keys(fileIdsByCollection).map(function (collectionNameKey) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](_this, void 0, void 0, function () {
                                var fileIds, collectionName, response;
                                return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            fileIds = fileIdsByCollection[collectionNameKey];
                                            collectionName = collectionNameKey === nonCollectionName
                                                ? undefined
                                                : collectionNameKey;
                                            return [4 /*yield*/, this.mediaStore.getItems(fileIds, collectionName)];
                                        case 1:
                                            response = _a.sent();
                                            items.push.apply(items, response.data.items);
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, getItemsFromKeys(keys, items)];
                }
            });
        }); };
        this.createDownloadFileStream = function (id, collection) {
            return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].create(function (observer) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](_this, void 0, void 0, function () {
                var timeoutId, fetchFile;
                var _this = this;
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
                    fetchFile = function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](_this, void 0, void 0, function () {
                        var response, fileState, e_1;
                        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, this.dataloader.load({ id: id, collection: collection })];
                                case 1:
                                    response = _a.sent();
                                    if (!response) {
                                        return [2 /*return*/];
                                    }
                                    fileState = Object(__WEBPACK_IMPORTED_MODULE_8__fileState__["b" /* mapMediaItemToFileState */])(id, response);
                                    observer.next(fileState);
                                    if (fileState.status === 'processing') {
                                        timeoutId = window.setTimeout(fetchFile, POLLING_INTERVAL);
                                    }
                                    else {
                                        observer.complete();
                                    }
                                    return [3 /*break*/, 3];
                                case 2:
                                    e_1 = _a.sent();
                                    observer.error(e_1);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); };
                    fetchFile();
                    return [2 /*return*/, function () {
                            window.clearTimeout(timeoutId);
                        }];
                });
            }); });
        };
        this.dataloader = new __WEBPACK_IMPORTED_MODULE_5_dataloader__(this.batchLoadingFunc, {
            maxBatchSize: maxNumberOfItemsPerCall,
        });
    }
    FileFetcher.prototype.getFileState = function (id, options) {
        var _this = this;
        if (!__WEBPACK_IMPORTED_MODULE_7_uuid_validate__(id)) {
            return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].create(function (observer) {
                observer.error(id + " is not a valid file id");
            });
        }
        return __WEBPACK_IMPORTED_MODULE_9__context_fileStreamCache__["a" /* fileStreamsCache */].getOrInsert(id, function () {
            var collection = options && options.collectionName;
            var fileStream$ = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators_publishReplay__["publishReplay"])(1)(_this.createDownloadFileStream(id, collection));
            fileStream$.connect();
            return fileStream$;
        });
    };
    FileFetcher.prototype.getArtifactURL = function (artifacts, artifactName, collectionName) {
        return this.mediaStore.getArtifactURL(artifacts, artifactName, collectionName);
    };
    FileFetcher.prototype.touchFiles = function (descriptors, collection) {
        return this.mediaStore
            .touchFiles({ descriptors: descriptors }, { collection: collection })
            .then(function (_a) {
            var data = _a.data;
            return data;
        });
    };
    FileFetcher.prototype.generateUploadableFileUpfrontIds = function (collection) {
        var id = __WEBPACK_IMPORTED_MODULE_4_uuid_v4__();
        var occurrenceKey = __WEBPACK_IMPORTED_MODULE_4_uuid_v4__();
        var touchFileDescriptor = {
            fileId: id,
            occurrenceKey: occurrenceKey,
            collection: collection,
        };
        var deferredUploadId = this.touchFiles([touchFileDescriptor], collection).then(function (touchedFiles) { return touchedFiles.created[0].uploadId; });
        return {
            id: id,
            occurrenceKey: occurrenceKey,
            deferredUploadId: deferredUploadId,
        };
    };
    FileFetcher.prototype.upload = function (file, controller, uploadableFileUpfrontIds) {
        var content = file.content, _a = file.name, name = _a === void 0 ? '' : _a, // name property is not available in base64 image
        collection = file.collection;
        if (!uploadableFileUpfrontIds) {
            uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection);
        }
        var id = uploadableFileUpfrontIds.id;
        var occurrenceKey = uploadableFileUpfrontIds.occurrenceKey;
        var mimeType = '';
        var size = 0;
        var preview;
        // TODO [MSW-796]: get file size for base64
        var mediaType = Object(__WEBPACK_IMPORTED_MODULE_10__utils_getMediaTypeFromUploadableFile__["a" /* getMediaTypeFromUploadableFile */])(file);
        var subject = new __WEBPACK_IMPORTED_MODULE_2_rxjs_ReplaySubject__["ReplaySubject"](1);
        if (content instanceof Blob) {
            size = content.size;
            mimeType = content.type;
            preview = {
                blob: content,
            };
        }
        var stateBase = {
            name: name,
            size: size,
            mediaType: mediaType,
            mimeType: mimeType,
            id: id,
            occurrenceKey: occurrenceKey,
            preview: preview,
        };
        var onProgress = function (progress) {
            subject.next(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ status: 'uploading' }, stateBase, { progress: progress }));
        };
        var onUploadFinish = function (error) {
            if (error) {
                return subject.error(error);
            }
            subject.next(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ status: 'processing' }, stateBase));
            subject.complete();
        };
        var cancel = Object(__WEBPACK_IMPORTED_MODULE_6__atlaskit_media_store__["d" /* uploadFile */])(file, this.mediaStore, uploadableFileUpfrontIds, {
            onUploadFinish: onUploadFinish,
            onProgress: onProgress,
        }).cancel;
        // We should report progress asynchronously, since this is what consumer expects
        // (otherwise in newUploadService file-converting event will be emitted before files-added)
        setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_9__context_fileStreamCache__["a" /* fileStreamsCache */].set(id, subject);
            onProgress(0);
        }, 0);
        if (controller) {
            controller.setAbort(cancel);
        }
        return subject;
    };
    FileFetcher.prototype.downloadBinary = function (id, name, collectionName) {
        if (name === void 0) { name = 'download'; }
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
            var isIE11, iframeName, link, iframe, _a;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_b) {
                switch (_b.label) {
                    case 0:
                        isIE11 = !!window.MSInputMethodContext &&
                            !!document.documentMode;
                        iframeName = 'media-download-iframe';
                        link = document.createElement('a');
                        iframe = document.getElementById(iframeName);
                        if (!iframe) {
                            iframe = document.createElement('iframe');
                            iframe.style.display = 'none';
                            iframe.id = iframeName;
                            iframe.name = iframeName;
                            document.body.appendChild(iframe);
                        }
                        _a = link;
                        return [4 /*yield*/, this.mediaStore.getFileBinaryURL(id, collectionName)];
                    case 1:
                        _a.href = _b.sent();
                        link.download = name;
                        link.target = isIE11 ? '_blank' : iframeName;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        return [2 /*return*/];
                }
            });
        });
    };
    return FileFetcher;
}());

//# sourceMappingURL=index.js.map

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ReplaySubject_1 = __webpack_require__(396);
var multicast_1 = __webpack_require__(1879);
/* tslint:enable:max-line-length */
function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') {
        scheduler = selectorOrScheduler;
    }
    var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
    var subject = new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler);
    return function (source) { return multicast_1.multicast(function () { return subject; }, selector)(source); };
}
exports.publishReplay = publishReplay;
//# sourceMappingURL=publishReplay.js.map

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ConnectableObservable_1 = __webpack_require__(1880);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits the results of invoking a specified selector on items
 * emitted by a ConnectableObservable that shares a single subscription to the underlying stream.
 *
 * <img src="./img/multicast.png" width="100%">
 *
 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate subject through
 * which the source sequence's elements will be multicast to the selector function
 * or Subject to push source elements into.
 * @param {Function} [selector] - Optional selector function that can use the multicasted source stream
 * as many times as needed, without causing multiple subscriptions to the source stream.
 * Subscribers to the given source will receive all notifications of the source from the
 * time of the subscription forward.
 * @return {Observable} An Observable that emits the results of invoking the selector
 * on the items emitted by a `ConnectableObservable` that shares a single subscription to
 * the underlying stream.
 * @method multicast
 * @owner Observable
 */
function multicast(subjectOrSubjectFactory, selector) {
    return function multicastOperatorFunction(source) {
        var subjectFactory;
        if (typeof subjectOrSubjectFactory === 'function') {
            subjectFactory = subjectOrSubjectFactory;
        }
        else {
            subjectFactory = function subjectFactory() {
                return subjectOrSubjectFactory;
            };
        }
        if (typeof selector === 'function') {
            return source.lift(new MulticastOperator(subjectFactory, selector));
        }
        var connectable = Object.create(source, ConnectableObservable_1.connectableObservableDescriptor);
        connectable.source = source;
        connectable.subjectFactory = subjectFactory;
        return connectable;
    };
}
exports.multicast = multicast;
var MulticastOperator = (function () {
    function MulticastOperator(subjectFactory, selector) {
        this.subjectFactory = subjectFactory;
        this.selector = selector;
    }
    MulticastOperator.prototype.call = function (subscriber, source) {
        var selector = this.selector;
        var subject = this.subjectFactory();
        var subscription = selector(subject).subscribe(subscriber);
        subscription.add(source.subscribe(subject));
        return subscription;
    };
    return MulticastOperator;
}());
exports.MulticastOperator = MulticastOperator;
//# sourceMappingURL=multicast.js.map

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(394);
var Observable_1 = __webpack_require__(42);
var Subscriber_1 = __webpack_require__(90);
var Subscription_1 = __webpack_require__(158);
var refCount_1 = __webpack_require__(1881);
/**
 * @class ConnectableObservable<T>
 */
var ConnectableObservable = (function (_super) {
    __extends(ConnectableObservable, _super);
    function ConnectableObservable(/** @deprecated internal use only */ source, 
        /** @deprecated internal use only */ subjectFactory) {
        _super.call(this);
        this.source = source;
        this.subjectFactory = subjectFactory;
        /** @deprecated internal use only */ this._refCount = 0;
        this._isComplete = false;
    }
    /** @deprecated internal use only */ ConnectableObservable.prototype._subscribe = function (subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    /** @deprecated internal use only */ ConnectableObservable.prototype.getSubject = function () {
        var subject = this._subject;
        if (!subject || subject.isStopped) {
            this._subject = this.subjectFactory();
        }
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function () {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new Subscription_1.Subscription();
            connection.add(this.source
                .subscribe(new ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = Subscription_1.Subscription.EMPTY;
            }
            else {
                this._connection = connection;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function () {
        return refCount_1.refCount()(this);
    };
    return ConnectableObservable;
}(Observable_1.Observable));
exports.ConnectableObservable = ConnectableObservable;
var connectableProto = ConnectableObservable.prototype;
exports.connectableObservableDescriptor = {
    operator: { value: null },
    _refCount: { value: 0, writable: true },
    _subject: { value: null, writable: true },
    _connection: { value: null, writable: true },
    _subscribe: { value: connectableProto._subscribe },
    _isComplete: { value: connectableProto._isComplete, writable: true },
    getSubject: { value: connectableProto.getSubject },
    connect: { value: connectableProto.connect },
    refCount: { value: connectableProto.refCount }
};
var ConnectableSubscriber = (function (_super) {
    __extends(ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    ConnectableSubscriber.prototype._error = function (err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function () {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ ConnectableSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) {
                connection.unsubscribe();
            }
        }
    };
    return ConnectableSubscriber;
}(Subject_1.SubjectSubscriber));
var RefCountOperator = (function () {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function (subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var RefCountSubscriber = (function (_super) {
    __extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
            sharedConnection.unsubscribe();
        }
    };
    return RefCountSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=ConnectableObservable.js.map

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(90);
function refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new RefCountOperator(source));
    };
}
exports.refCount = refCount;
var RefCountOperator = (function () {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function (subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var RefCountSubscriber = (function (_super) {
    __extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
            sharedConnection.unsubscribe();
        }
    };
    return RefCountSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=refCount.js.map

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, setImmediate) {function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */


// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
var DataLoader = function () {
  function DataLoader(batchLoadFn, options) {
    _classCallCheck(this, DataLoader);

    if (typeof batchLoadFn !== 'function') {
      throw new TypeError('DataLoader must be constructed with a function which accepts ' + ('Array<key> and returns Promise<Array<value>>, but got: ' + batchLoadFn + '.'));
    }
    this._batchLoadFn = batchLoadFn;
    this._options = options;
    this._promiseCache = getValidCacheMap(options);
    this._queue = [];
  }

  // Private


  /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */
  DataLoader.prototype.load = function load(key) {
    var _this = this;

    if (key === null || key === undefined) {
      throw new TypeError('The loader.load() function must be called with a value,' + ('but got: ' + String(key) + '.'));
    }

    // Determine options
    var options = this._options;
    var shouldBatch = !options || options.batch !== false;
    var shouldCache = !options || options.cache !== false;
    var cacheKeyFn = options && options.cacheKeyFn;
    var cacheKey = cacheKeyFn ? cacheKeyFn(key) : key;

    // If caching and there is a cache-hit, return cached Promise.
    if (shouldCache) {
      var cachedPromise = this._promiseCache.get(cacheKey);
      if (cachedPromise) {
        return cachedPromise;
      }
    }

    // Otherwise, produce a new Promise for this value.
    var promise = new Promise(function (resolve, reject) {
      // Enqueue this Promise to be dispatched.
      _this._queue.push({ key: key, resolve: resolve, reject: reject });

      // Determine if a dispatch of this queue should be scheduled.
      // A single dispatch should be scheduled per queue at the time when the
      // queue changes from "empty" to "full".
      if (_this._queue.length === 1) {
        if (shouldBatch) {
          // If batching, schedule a task to dispatch the queue.
          enqueuePostPromiseJob(function () {
            return dispatchQueue(_this);
          });
        } else {
          // Otherwise dispatch the (queue of one) immediately.
          dispatchQueue(_this);
        }
      }
    });

    // If caching, cache this promise.
    if (shouldCache) {
      this._promiseCache.set(cacheKey, promise);
    }

    return promise;
  };

  /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is equivalent to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   */


  DataLoader.prototype.loadMany = function loadMany(keys) {
    var _this2 = this;

    if (!Array.isArray(keys)) {
      throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ('but got: ' + keys + '.'));
    }
    return Promise.all(keys.map(function (key) {
      return _this2.load(key);
    }));
  };

  /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */


  DataLoader.prototype.clear = function clear(key) {
    var cacheKeyFn = this._options && this._options.cacheKeyFn;
    var cacheKey = cacheKeyFn ? cacheKeyFn(key) : key;
    this._promiseCache.delete(cacheKey);
    return this;
  };

  /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */


  DataLoader.prototype.clearAll = function clearAll() {
    this._promiseCache.clear();
    return this;
  };

  /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   */


  DataLoader.prototype.prime = function prime(key, value) {
    var cacheKeyFn = this._options && this._options.cacheKeyFn;
    var cacheKey = cacheKeyFn ? cacheKeyFn(key) : key;

    // Only add the key if it does not already exist.
    if (this._promiseCache.get(cacheKey) === undefined) {
      // Cache a rejected promise if the value is an Error, in order to match
      // the behavior of load(key).
      var promise = value instanceof Error ? Promise.reject(value) : Promise.resolve(value);

      this._promiseCache.set(cacheKey, promise);
    }

    return this;
  };

  return DataLoader;
}();

// Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.


// If a custom cache is provided, it must be of this type (a subset of ES6 Map).

/**
 *  Copyright (c) 2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 */

// A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.


var enqueuePostPromiseJob = typeof process === 'object' && typeof process.nextTick === 'function' ? function (fn) {
  if (!resolvedPromise) {
    resolvedPromise = Promise.resolve();
  }
  resolvedPromise.then(function () {
    return process.nextTick(fn);
  });
} : setImmediate || setTimeout;

// Private: cached resolved Promise instance
var resolvedPromise;

// Private: given the current state of a Loader instance, perform a batch load
// from its current queue.
function dispatchQueue(loader) {
  // Take the current loader queue, replacing it with an empty queue.
  var queue = loader._queue;
  loader._queue = [];

  // If a maxBatchSize was provided and the queue is longer, then segment the
  // queue into multiple batches, otherwise treat the queue as a single batch.
  var maxBatchSize = loader._options && loader._options.maxBatchSize;
  if (maxBatchSize && maxBatchSize > 0 && maxBatchSize < queue.length) {
    for (var i = 0; i < queue.length / maxBatchSize; i++) {
      dispatchQueueBatch(loader, queue.slice(i * maxBatchSize, (i + 1) * maxBatchSize));
    }
  } else {
    dispatchQueueBatch(loader, queue);
  }
}

function dispatchQueueBatch(loader, queue) {
  // Collect all keys to be loaded in this dispatch
  var keys = queue.map(function (_ref) {
    var key = _ref.key;
    return key;
  });

  // Call the provided batchLoadFn for this loader with the loader queue's keys.
  var batchLoadFn = loader._batchLoadFn;
  var batchPromise = batchLoadFn(keys);

  // Assert the expected response from batchLoadFn
  if (!batchPromise || typeof batchPromise.then !== 'function') {
    return failedDispatch(loader, queue, new TypeError('DataLoader must be constructed with a function which accepts ' + 'Array<key> and returns Promise<Array<value>>, but the function did ' + ('not return a Promise: ' + String(batchPromise) + '.')));
  }

  // Await the resolution of the call to batchLoadFn.
  batchPromise.then(function (values) {

    // Assert the expected resolution from batchLoadFn.
    if (!Array.isArray(values)) {
      throw new TypeError('DataLoader must be constructed with a function which accepts ' + 'Array<key> and returns Promise<Array<value>>, but the function did ' + ('not return a Promise of an Array: ' + String(values) + '.'));
    }
    if (values.length !== keys.length) {
      throw new TypeError('DataLoader must be constructed with a function which accepts ' + 'Array<key> and returns Promise<Array<value>>, but the function did ' + 'not return a Promise of an Array of the same length as the Array ' + 'of keys.' + ('\n\nKeys:\n' + String(keys)) + ('\n\nValues:\n' + String(values)));
    }

    // Step through the values, resolving or rejecting each Promise in the
    // loaded queue.
    queue.forEach(function (_ref2, index) {
      var resolve = _ref2.resolve,
          reject = _ref2.reject;

      var value = values[index];
      if (value instanceof Error) {
        reject(value);
      } else {
        resolve(value);
      }
    });
  }).catch(function (error) {
    return failedDispatch(loader, queue, error);
  });
}

// Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function failedDispatch(loader, queue, error) {
  queue.forEach(function (_ref3) {
    var key = _ref3.key,
        reject = _ref3.reject;

    loader.clear(key);
    reject(error);
  });
}

// Private: given the DataLoader's options, produce a CacheMap to be used.
function getValidCacheMap(options) {
  var cacheMap = options && options.cacheMap;
  if (!cacheMap) {
    return new Map();
  }
  var cacheFunctions = ['get', 'set', 'delete', 'clear'];
  var missingFunctions = cacheFunctions.filter(function (fnName) {
    return cacheMap && typeof cacheMap[fnName] !== 'function';
  });
  if (missingFunctions.length !== 0) {
    throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
  }
  return cacheMap;
}

// Private


module.exports = DataLoader;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(122), __webpack_require__(1883).setImmediate))

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1884);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43), __webpack_require__(122)))

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Regular expression used for basic parsing of the uuid.
var pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Unparses a UUID buffer to a string. From node-uuid:
 * https://github.com/defunctzombie/node-uuid/blob/master/uuid.js
 *
 * Copyright (c) 2010-2012 Robert Kieffer
 * MIT License - http://opensource.org/licenses/mit-license.php
 *
 * @param  {Buffer} buf
 * @param  {Number=0} offset
 * @return {String}
 */
var _byteToHex = [];
for (var i = 0; i < 256; i++) {
    _byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function unparse(buf, offset) {
  var i = offset || 0, bth = _byteToHex;
  return  bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

/**
 * Determines whether the uuid is valid, converting
 * it from a buffer if necessary.
 *
 * @param  {String|Buffer}  uuid
 * @param  {Number=}  version
 * @return {Boolean}
 */
module.exports = function (uuid, version) {
    var parsedUuid;
    // If the uuid is a biffer, parse it...
    if (Buffer.isBuffer(uuid)) {
        parsedUuid = unparse(uuid);
    }
    // If it's a string, it's already good.
    else if (Object.prototype.toString.call(uuid) === '[object String]') {
        parsedUuid = uuid;
    }
    // Otherwise, it's not valid.
    else {
        return false;
    }

    parsedUuid = parsedUuid.toLowerCase();

    // All UUIDs fit a basic schema. Match that.
    if (!pattern.test(parsedUuid)) {
        return false;
    }

    // Now extract the version...
    if (version === undefined) {
        version = extractVersion(parsedUuid);
    } else if (extractVersion(parsedUuid) !== version) {
        return false;
    }

    switch (version) {
        // For certain versions, the checks we did up to this point are fine.
        case 1:
        case 2:
            return true;

        // For versions 3 and 4, they must specify a variant.
        case 3:
        case 4:
        case 5:
            return ['8', '9', 'a', 'b'].indexOf(parsedUuid.charAt(19)) !== -1;

        default:
            // We should only be able to reach this if the consumer explicitly
            // provided an invalid version. Prior to extractVersion we check
            // that it's 1-4 in the regex.
            throw new Error('Invalid version provided.');
    }
};

/**
 * Extracts the version from the UUID, which is (by definition) the M in
 * xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 *
 * @param  {String} uuid
 * @return {Number}
 */
var extractVersion = module.exports.version = function (uuid) {
    return uuid.charAt(14)|0;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(331).Buffer))

/***/ }),
/* 1886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMediaTypeFromUploadableFile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMediaTypeFromMimeType__ = __webpack_require__(701);

var getMediaTypeFromUploadableFile = function (file) {
    if (file.content instanceof Blob) {
        var type = file.content.type;
        return Object(__WEBPACK_IMPORTED_MODULE_0__getMediaTypeFromMimeType__["a" /* getMediaTypeFromMimeType */])(type);
    }
    else {
        return 'unknown';
    }
};
//# sourceMappingURL=getMediaTypeFromUploadableFile.js.map

/***/ }),
/* 1887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isImageRemote__ = __webpack_require__(1888);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__isImageRemote__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__checkWebpSupport__ = __webpack_require__(1889);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 1888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isImageRemote; });
// Returns true if you need to set crossorigin property of an img element.
var isImageRemote = function (imageUrl, windowOrigin) {
    if (windowOrigin === void 0) { windowOrigin = window.location.origin; }
    if (URL && URL.prototype) {
        var url = new URL(imageUrl);
        if (!url.host) {
            // This is a local resource. Safari will fail to load it if we set crossorigin
            return false;
        }
        return url.origin !== windowOrigin;
    }
    else {
        // IE doesn't have support to 'new URL'.
        // But it can load local and remote images with crossorigin set.
        return true;
    }
};
//# sourceMappingURL=isImageRemote.js.map

/***/ }),
/* 1889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export checkWebpSupport */
/**
 * Checks if Webp support is enabled in the browser.
 * We know that creating a new image in memory and checking its height,
 * later on we cache this value forever.
 */
var isSupported;
var checkWebpSupport = function () {
    if (isSupported !== undefined) {
        return Promise.resolve(isSupported);
    }
    return new Promise(function (resolve) {
        var img = new Image();
        // Following base64 encoded binary content is in webp format. If browser supports this standard,
        // 2px height image will be displayed. If not, standard "not found" image placeholder will be
        // displayed and it will be not 2px height.
        img.src =
            'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMwAgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
        img.onload = img.onerror = function () {
            isSupported = img.height === 2;
            resolve(isSupported);
        };
    });
};
//# sourceMappingURL=checkWebpSupport.js.map

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1891);
module.exports = __webpack_require__(95).Object.keys;


/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(337);
var $keys = __webpack_require__(190);

__webpack_require__(1365)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_LoadingEmojiComponent__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Popup__ = __webpack_require__(1893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_logger__ = __webpack_require__(119);





var emojiTypeAheadModuleLoader = function () {
    return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 3462));
};
var emojiTypeAheadComponentLoader = function () { return emojiTypeAheadModuleLoader().then(function (module) { return module.default; }); };
var EmojiTypeahead = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiTypeahead, _super);
    function EmojiTypeahead(props) {
        var _this = _super.call(this, props, {}) || this;
        _this.state = {
            asyncLoadedComponent: EmojiTypeahead.AsyncLoadedComponent,
        };
        _this.selectNext = function () {
            if (_this.refs.typeAhead) {
                _this.refs.typeAhead.selectNext();
            }
        };
        _this.selectPrevious = function () {
            if (_this.refs.typeAhead) {
                _this.refs.typeAhead.selectPrevious();
            }
        };
        _this.chooseCurrentSelection = function () {
            if (_this.refs.typeAhead) {
                _this.refs.typeAhead.chooseCurrentSelection();
            }
        };
        _this.count = function () {
            if (_this.refs.typeAhead) {
                return _this.refs.typeAhead.count();
            }
            return 0;
        };
        return _this;
    }
    EmojiTypeahead.prototype.asyncLoadComponent = function () {
        var _this = this;
        emojiTypeAheadComponentLoader().then(function (component) {
            EmojiTypeahead.AsyncLoadedComponent = component;
            _this.setAsyncState(component);
        });
    };
    EmojiTypeahead.prototype.renderLoaded = function (loadedEmojiProvider, EmojiTypeAheadComponent) {
        var _a = this.props, emojiProvider = _a.emojiProvider, target = _a.target, position = _a.position, zIndex = _a.zIndex, offsetX = _a.offsetX, offsetY = _a.offsetY, otherProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["emojiProvider", "target", "position", "zIndex", "offsetX", "offsetY"]);
        var typeAhead = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](EmojiTypeAheadComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, otherProps, { emojiProvider: loadedEmojiProvider, ref: "typeAhead" })));
        if (position) {
            Object(__WEBPACK_IMPORTED_MODULE_4__util_logger__["a" /* default */])('target, position', target, position);
            if (target) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Popup__["a" /* default */], { target: target, relativePosition: position, zIndex: zIndex, offsetX: offsetX, offsetY: offsetY, children: typeAhead }));
            }
            // don't show if we have a position, but no target yet
            return null;
        }
        return typeAhead;
    };
    return EmojiTypeahead;
}(__WEBPACK_IMPORTED_MODULE_2__common_LoadingEmojiComponent__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EmojiTypeahead);
//# sourceMappingURL=EmojiTypeAhead.js.map

/***/ }),
/* 1893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);




var getTargetNode = function (target) {
    if (typeof target === 'string') {
        return document.querySelector(target);
    }
    // Expect to be an element
    return target;
};
/*
 * Simple implementation of popup while waiting for ak-inline-dialog
 */
var Popup = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Popup, _super);
    function Popup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.debounced = null;
        _this.handleResize = function () {
            if (_this.debounced) {
                clearTimeout(_this.debounced);
                _this.debounced = null;
            }
            // Timeout set to 30ms as to not throttle IE11
            _this.debounced = window.setTimeout(function () {
                _this.applyAbsolutePosition();
                _this.debounced = null;
            }, 30);
        };
        return _this;
    }
    Popup.prototype.componentDidMount = function () {
        this.popup = document.createElement('div');
        document.body.appendChild(this.popup);
        this.popup.style.position = 'absolute';
        window.addEventListener('resize', this.handleResize);
        this.applyAbsolutePosition();
        this.renderContent();
    };
    Popup.prototype.componentDidUpdate = function () {
        this.applyAbsolutePosition();
        this.renderContent();
    };
    Popup.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleResize);
        __WEBPACK_IMPORTED_MODULE_2_react_dom__["unmountComponentAtNode"](this.popup);
        document.body.removeChild(this.popup);
    };
    // Internal
    Popup.prototype.applyBelowPosition = function () {
        var targetNode = getTargetNode(this.props.target);
        if (targetNode) {
            var box = targetNode.getBoundingClientRect();
            var top_1 = box.bottom + (this.props.offsetY || 0);
            var left = box.left + (this.props.offsetX || 0);
            this.popup.style.top = top_1 + "px";
            this.popup.style.bottom = '';
            this.popup.style.left = left + "px";
        }
    };
    Popup.prototype.applyAbovePosition = function () {
        var targetNode = getTargetNode(this.props.target);
        if (targetNode) {
            var box = targetNode.getBoundingClientRect();
            var bottom = window.innerHeight - box.top + (this.props.offsetY || 0);
            var left = box.left + (this.props.offsetX || 0);
            this.popup.style.top = '';
            this.popup.style.bottom = bottom + "px";
            this.popup.style.left = left + "px";
        }
    };
    Popup.prototype.applyAbsolutePosition = function () {
        if (this.props.relativePosition === 'above') {
            this.applyAbovePosition();
        }
        else if (this.props.relativePosition === 'below') {
            this.applyBelowPosition();
        }
        else {
            var targetNode = getTargetNode(this.props.target);
            if (targetNode) {
                var box = targetNode.getBoundingClientRect();
                var viewPortHeight = window.innerHeight;
                if (box.top < viewPortHeight / 2) {
                    this.applyBelowPosition();
                }
                else {
                    this.applyAbovePosition();
                }
            }
        }
        if (this.props.zIndex) {
            this.popup.style.zIndex = "" + this.props.zIndex;
        }
    };
    Popup.prototype.renderContent = function () {
        __WEBPACK_IMPORTED_MODULE_2_react_dom__["render"](this.props.children, this.popup);
    };
    Popup.prototype.render = function () {
        // inline placeholder element for react to render inplace
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null);
    };
    Popup.defaultProps = {
        relativePosition: 'auto',
        offsetX: 0,
        offsetY: 0,
        zIndex: 0,
    };
    return Popup;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Popup);
//# sourceMappingURL=Popup.js.map

/***/ }),
/* 1894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WithProviders; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var WithProviders = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WithProviders, _super);
    function WithProviders(props) {
        var _this = _super.call(this, props) || this;
        _this.handleProvider = function (name, provider) {
            _this.setState(function (_a) {
                var providers = _a.providers;
                var _b;
                return {
                    providers: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, providers, (_b = {}, _b[name] = provider, _b)),
                };
            });
        };
        var providers = {};
        _this.props.providers.forEach(function (name) {
            providers[name] = undefined;
        });
        _this.state = {
            providers: providers,
        };
        return _this;
    }
    WithProviders.prototype.componentWillMount = function () {
        var _this = this;
        var _a = this.props, providers = _a.providers, providerFactory = _a.providerFactory;
        providers.forEach(function (name) {
            providerFactory.subscribe(name, _this.handleProvider);
        });
    };
    WithProviders.prototype.componentWillUnmount = function () {
        var _this = this;
        var _a = this.props, providers = _a.providers, providerFactory = _a.providerFactory;
        providers.forEach(function (name) {
            providerFactory.unsubscribe(name, _this.handleProvider);
        });
    };
    WithProviders.prototype.render = function () {
        var _a = this, state = _a.state, props = _a.props;
        var renderNode = props.renderNode;
        return renderNode(state.providers);
    };
    return WithProviders;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

//# sourceMappingURL=withProviders.js.map

/***/ }),
/* 1895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MediaSingle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styled__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__grid__ = __webpack_require__(703);




function MediaSingle(_a) {
    var children = _a.children, layout = _a.layout, width = _a.width, height = _a.height, _b = _a.containerWidth, containerWidth = _b === void 0 ? width : _b, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c, pctWidth = _a.pctWidth, lineLength = _a.lineLength, className = _a.className;
    var usePctWidth = pctWidth && Object(__WEBPACK_IMPORTED_MODULE_3__grid__["e" /* layoutSupportsWidth */])(layout);
    if (pctWidth && usePctWidth) {
        var pxWidth = Math.ceil(Object(__WEBPACK_IMPORTED_MODULE_3__grid__["d" /* calcPxFromPct */])(pctWidth / 100, lineLength || containerWidth));
        // scale, keeping aspect ratio
        height = (height / width) * pxWidth;
        width = pxWidth;
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styled__["b" /* default */], { layout: layout, width: width, height: height, containerWidth: containerWidth, pctWidth: pctWidth, className: __WEBPACK_IMPORTED_MODULE_2_classnames__('media-single', "image-" + layout, className, {
            'is-loading': isLoading,
            'media-wrapped': layout === 'wrap-left' || layout === 'wrap-right',
        }) }, __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children)));
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 1896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mention_with_providers__ = __webpack_require__(1897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__providerFactory__ = __webpack_require__(399);





var Mention = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Mention, _super);
    function Mention(props) {
        var _this = _super.call(this, props) || this;
        _this.renderWithProvider = function (providers) {
            var _a = _this.props, accessLevel = _a.accessLevel, eventHandlers = _a.eventHandlers, id = _a.id, portal = _a.portal, text = _a.text;
            var mentionProvider = providers.mentionProvider, profilecardProvider = providers.profilecardProvider;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__mention_with_providers__["a" /* default */], { id: id, text: text, accessLevel: accessLevel, eventHandlers: eventHandlers, mentionProvider: mentionProvider, profilecardProvider: profilecardProvider, portal: portal }));
        };
        _this.providerFactory = props.providers || new __WEBPACK_IMPORTED_MODULE_3__providerFactory__["b" /* default */]();
        return _this;
    }
    Mention.prototype.componentWillUnmount = function () {
        if (!this.props.providers) {
            // new ProviderFactory is created if no `providers` has been set
            // in this case when component is unmounted it's safe to destroy this providerFactory
            this.providerFactory.destroy();
        }
    };
    Mention.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__providerFactory__["a" /* WithProviders */], { providers: ['mentionProvider', 'profilecardProvider'], providerFactory: this.providerFactory, renderNode: this.renderWithProvider }));
    };
    return Mention;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* unused harmony default export */ var _unused_webpack_default_export = (Mention);
//# sourceMappingURL=index.js.map

/***/ }),
/* 1897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_mention__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mention_with_profilecard__ = __webpack_require__(1934);





var GENERIC_USER_IDS = ['HipChat', 'all', 'here'];
var noop = function () { };
var MentionWithProviders = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionWithProviders, _super);
    function MentionWithProviders() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { profilecardProvider: null };
        return _this;
    }
    MentionWithProviders.prototype.componentWillMount = function () {
        this.updateProfilecardProvider(this.props);
    };
    MentionWithProviders.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.profilecardProvider !== this.props.profilecardProvider) {
            this.updateProfilecardProvider(nextProps);
        }
    };
    MentionWithProviders.prototype.updateProfilecardProvider = function (props) {
        var _this = this;
        // We are not using async/await here to avoid having an intermediate Promise
        // introduced by the transpiler.
        // This will allow consumer to use a SynchronousPromise.resolve and avoid useless
        // rerendering
        if (props.profilecardProvider) {
            props.profilecardProvider
                .then(function (profilecardProvider) {
                _this.setState({ profilecardProvider: profilecardProvider });
            })
                .catch(function (err) {
                _this.setState({ profilecardProvider: null });
            });
        }
        else {
            this.setState({ profilecardProvider: null });
        }
    };
    MentionWithProviders.prototype.render = function () {
        var _a = this.props, accessLevel = _a.accessLevel, userType = _a.userType, eventHandlers = _a.eventHandlers, id = _a.id, mentionProvider = _a.mentionProvider, portal = _a.portal, text = _a.text;
        var profilecardProvider = this.state.profilecardProvider;
        var actionHandlers = {};
        ['onClick', 'onMouseEnter', 'onMouseLeave'].forEach(function (handler) {
            actionHandlers[handler] =
                (eventHandlers && eventHandlers[handler]) || noop;
        });
        // tslint:disable-next-line:variable-name
        var MentionComponent = profilecardProvider && GENERIC_USER_IDS.indexOf(id) === -1
            ? __WEBPACK_IMPORTED_MODULE_3__mention_with_profilecard__["a" /* default */]
            : __WEBPACK_IMPORTED_MODULE_2__atlaskit_mention__["c" /* ResourcedMention */];
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MentionComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ id: id, text: text, accessLevel: accessLevel, userType: userType, mentionProvider: mentionProvider, profilecardProvider: profilecardProvider, portal: portal }, actionHandlers)));
    };
    return MentionWithProviders;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (MentionWithProviders);
//# sourceMappingURL=mention-with-providers.js.map

/***/ }),
/* 1898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tokenizerRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return nonSpacingMarkRegex; });
// \p{Han} => each chinese character is a separate token
// \p{L}+[\p{Mn}|']*\p{L} => consecutive letters, including non spacing mark and apostrophe are a single token
// const tokenizerRegex = new XRegExp("\\p{Han}|\\p{L}+[\\p{Mn}|']*\\p{L}*", 'gi');
// const nonSpacingMarkRegex = new XRegExp('\\p{Mn}', 'gi');
// Note: regex compiled to unicode charsets using @atlaskit/xregexp-transformer (packages/elements/xregexp-transformer). Refer to it if you need to compile it again.
var tokenizerRegex = new RegExp("[\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FEF\uF900-\uFA6D\uFA70-\uFAD9]|[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]+[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F|']*[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*", 'gi');
var nonSpacingMarkRegex = new RegExp('[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]', 'gi');
//# sourceMappingURL=searchIndexRegex.js.map

/***/ }),
/* 1899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DefaultPresenceCache */
/* unused harmony export DefaultPresenceParser */
/* unused harmony export AbstractPresenceResource */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_logger__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MentionResource__ = __webpack_require__(704);



var CacheEntry = /** @class */ (function () {
    function CacheEntry(pres, timeout) {
        this.presence = pres;
        this.expiry = Date.now() + timeout;
    }
    CacheEntry.prototype.expired = function () {
        return Date.now() > this.expiry;
    };
    return CacheEntry;
}());
var AbstractPresenceResource = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AbstractPresenceResource, _super);
    function AbstractPresenceResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AbstractPresenceResource.prototype.refreshPresence = function (userIds) {
        throw new Error("not yet implemented.\nParams: userIds=" + userIds);
    };
    AbstractPresenceResource.prototype.notifyListeners = function (presences) {
        this.changeListeners.forEach(function (listener, key) {
            try {
                listener(presences);
            }
            catch (e) {
                // ignore error from listener
                Object(__WEBPACK_IMPORTED_MODULE_1__util_logger__["a" /* default */])("error from listener '" + key + "', ignoring", e);
            }
        });
    };
    return AbstractPresenceResource;
}(__WEBPACK_IMPORTED_MODULE_2__MentionResource__["a" /* AbstractResource */]));
var PresenceResource = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](PresenceResource, _super);
    function PresenceResource(config) {
        var _this = _super.call(this) || this;
        if (!config.url) {
            throw new Error('config.url is a required parameter');
        }
        if (!config.cloudId) {
            throw new Error('config.cloudId is a required parameter');
        }
        _this.config = config;
        _this.config.url = PresenceResource.cleanUrl(config.url);
        _this.presenceCache =
            config.cache || new DefaultPresenceCache(config.cacheExpiry);
        _this.presenceParser = config.parser || new DefaultPresenceParser();
        return _this;
    }
    PresenceResource.prototype.refreshPresence = function (userIds) {
        var cacheHits = this.presenceCache.getBulk(userIds);
        this.notifyListeners(cacheHits);
        var cacheMisses = this.presenceCache.getMissingUserIds(userIds);
        if (cacheMisses.length) {
            this.retrievePresence(cacheMisses);
        }
    };
    PresenceResource.prototype.retrievePresence = function (userIds) {
        var _this = this;
        this.queryDirectoryForPresences(userIds)
            .then(function (res) { return _this.presenceParser.parse(res); })
            .then(function (presences) {
            _this.notifyListeners(presences);
            _this.presenceCache.update(presences);
        });
    };
    PresenceResource.prototype.queryDirectoryForPresences = function (userIds) {
        var data = {
            query: "query getPresenceForMentions($organizationId: String!, $userIds: [String!], $productId: String) {\n                PresenceBulk(organizationId: $organizationId, product: $productId, userIds: $userIds) {\n                  userId\n                  state\n                  stateMetadata\n                }\n              }",
            variables: {
                organizationId: this.config.cloudId,
                userIds: userIds,
            },
        };
        if (this.config.productId) {
            data.variables['productId'] = this.config.productId;
        }
        var options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(data),
        };
        return fetch(this.config.url, options).then(function (response) { return response.json(); });
    };
    PresenceResource.cleanUrl = function (url) {
        if (url.substr(-1) !== '/') {
            url += '/';
        }
        return url;
    };
    return PresenceResource;
}(AbstractPresenceResource));
var DefaultPresenceCache = /** @class */ (function () {
    function DefaultPresenceCache(cacheTimeout, cacheTrigger) {
        this.expiryInMillis = cacheTimeout
            ? cacheTimeout
            : DefaultPresenceCache.defaultTimeout;
        this.flushTrigger = cacheTrigger
            ? cacheTrigger
            : DefaultPresenceCache.defaultFlushTrigger;
        this.cache = {};
        this.size = 0;
    }
    /**
     * Precondition: _delete is only called internally if userId exists in cache
     * Removes cache entry
     * @param userId
     */
    DefaultPresenceCache.prototype._delete = function (userId) {
        delete this.cache[userId];
        this.size--;
    };
    /**
     * Checks a cache entry and calls delete if the info has expired
     * @param userId
     */
    DefaultPresenceCache.prototype._deleteIfExpired = function (userId) {
        if (this.contains(userId) && this.cache[userId].expired()) {
            this._delete(userId);
        }
    };
    /**
     * Cleans expired entries from cache
     */
    DefaultPresenceCache.prototype._removeExpired = function () {
        var _this = this;
        Object.keys(this.cache).forEach(function (id) {
            _this._deleteIfExpired(id);
        });
    };
    /**
     * Checks if a user exists in the cache
     * @param userId
     */
    DefaultPresenceCache.prototype.contains = function (userId) {
        return this.cache.hasOwnProperty(userId);
    };
    /**
     * Retrieves a presence from the cache after checking for expired entries
     * @param userId - to index the cache
     * @returns Presence - the presence that matches the userId
     */
    DefaultPresenceCache.prototype.get = function (userId) {
        this._deleteIfExpired(userId);
        if (!this.contains(userId)) {
            return {};
        }
        return this.cache[userId].presence;
    };
    /**
     * Retrieve multiple presences at once from the cache
     * @param userIds - to index the cache
     * @returns PresenceMap - A map of userIds to cached Presences
     */
    DefaultPresenceCache.prototype.getBulk = function (userIds) {
        var e_1, _a;
        var presences = {};
        try {
            for (var userIds_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](userIds), userIds_1_1 = userIds_1.next(); !userIds_1_1.done; userIds_1_1 = userIds_1.next()) {
                var userId = userIds_1_1.value;
                if (this.contains(userId)) {
                    presences[userId] = this.get(userId);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (userIds_1_1 && !userIds_1_1.done && (_a = userIds_1.return)) _a.call(userIds_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return presences;
    };
    /**
     * For a given list of ids, returns a subset
     * of all the ids with missing cache entries.
     * @param userIds - to index the cache
     * @returns string[] - ids missing from the cache
     */
    DefaultPresenceCache.prototype.getMissingUserIds = function (userIds) {
        var _this = this;
        return userIds.filter(function (id) { return !_this.contains(id); });
    };
    /**
     * Precondition: presMap only contains ids of users not in cache
     *               expired users must first be removed then reinserted with updated presence
     * Updates the cache by adding the new Presence entries and setting the expiry time
     * @param presMap
     */
    DefaultPresenceCache.prototype.update = function (presMap) {
        var _this = this;
        if (this.size >= this.flushTrigger) {
            this._removeExpired();
        }
        Object.keys(presMap).forEach(function (userId) {
            _this.cache[userId] = new CacheEntry(presMap[userId], _this.expiryInMillis);
            _this.size++;
        });
    };
    DefaultPresenceCache.defaultTimeout = 20000;
    DefaultPresenceCache.defaultFlushTrigger = 50;
    return DefaultPresenceCache;
}());

var DefaultPresenceParser = /** @class */ (function () {
    function DefaultPresenceParser() {
    }
    DefaultPresenceParser.prototype.mapState = function (state) {
        if (state === 'unavailable') {
            return 'offline';
        }
        else if (state === 'available') {
            return 'online';
        }
        else {
            return state;
        }
    };
    DefaultPresenceParser.prototype.parse = function (response) {
        var e_2, _a;
        var presences = {};
        if (response.hasOwnProperty('data') &&
            response['data'].hasOwnProperty('PresenceBulk')) {
            var results = response['data'].PresenceBulk;
            try {
                // Store map of state and time indexed by userId.  Ignore null results.
                for (var results_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](results), results_1_1 = results_1.next(); !results_1_1.done; results_1_1 = results_1.next()) {
                    var user = results_1_1.value;
                    if (user.userId && user.state) {
                        var state = DefaultPresenceParser.extractState(user);
                        presences[user.userId] = {
                            status: this.mapState(state),
                        };
                    }
                    else if (!user.hasOwnProperty('userId') ||
                        !user.hasOwnProperty('state')) {
                        // tslint:disable-next-line:no-console
                        console.error('Unexpected response from presence service contains keys: ' +
                            Object.keys(user));
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (results_1_1 && !results_1_1.done && (_a = results_1.return)) _a.call(results_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        return presences;
    };
    DefaultPresenceParser.extractState = function (presence) {
        if (DefaultPresenceParser.isFocusState(presence)) {
            return DefaultPresenceParser.FOCUS_STATE;
        }
        return presence.state;
    };
    /*
      This is a bit of an odd exception. In the case where a user is in "Focus Mode", their presence state
      is returned as 'busy' along with a `stateMetadata` object containing a `focus` field.
      In this case we ignore the value of the `state` field and treat the presence as a 'focus' state.
     */
    DefaultPresenceParser.isFocusState = function (presence) {
        if (presence.stateMetadata) {
            try {
                var metadata = JSON.parse(presence.stateMetadata);
                return metadata && !!metadata.focus;
            }
            catch (e) {
                // tslint:disable-next-line:no-console
                console.error("Failed to parse presence's stateMetadata for user with id " + presence.userId + ": " + presence.stateMetadata);
                // tslint:disable-next-line:no-console
                console.error(e);
            }
        }
        return false;
    };
    DefaultPresenceParser.FOCUS_STATE = 'focus';
    return DefaultPresenceParser;
}());


/* unused harmony default export */ var _unused_webpack_default_export = (PresenceResource);
//# sourceMappingURL=PresenceResource.js.map

/***/ }),
/* 1900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AvatarWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_analytics_next__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__atlaskit_tooltip__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__package_json__ = __webpack_require__(1901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Presence__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AvatarImage__ = __webpack_require__(1902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Status__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styled_Avatar__ = __webpack_require__(1904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__helpers__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__hoc__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__theme__ = __webpack_require__(266);
























var warn = function warn(message) {
  if (false) {
    console.warn(message); // eslint-disable-line no-console
  }
};

var Avatar =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Avatar, _Component);

  function Avatar() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, Avatar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(Avatar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)), "ref", void 0);

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)), "createAndFireEventOnAtlaskit", Object(__WEBPACK_IMPORTED_MODULE_11__atlaskit_analytics_next__["createAndFireEvent"])('atlaskit'));

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)), "clickAnalyticsCaller", function () {
      var createAnalyticsEvent = _this.props.createAnalyticsEvent;

      if (createAnalyticsEvent) {
        return _this.createAndFireEventOnAtlaskit({
          action: 'clicked',
          actionSubject: 'avatar',
          attributes: {
            componentName: 'avatar',
            packageName: __WEBPACK_IMPORTED_MODULE_13__package_json__["name"],
            packageVersion: __WEBPACK_IMPORTED_MODULE_13__package_json__["version"]
          }
        })(createAnalyticsEvent);
      }

      return undefined;
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)), "blur", function () {
      if (_this.ref) _this.ref.blur();
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)), "focus", function () {
      if (_this.ref) _this.ref.focus();
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)), "guardedClick", function (event) {
      var _this$props = _this.props,
          isDisabled = _this$props.isDisabled,
          onClick = _this$props.onClick;
      if (isDisabled || typeof onClick !== 'function') return;
      var item = __WEBPACK_IMPORTED_MODULE_19__utils__["b" /* omit */].apply(void 0, [_this.props].concat(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_14__constants__["a" /* propsOmittedFromClickData */])));

      var analyticsEvent = _this.clickAnalyticsCaller();

      onClick({
        item: item,
        event: event
      }, analyticsEvent);
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)), "renderIcon", function () {
      var _this$props2 = _this.props,
          appearance = _this$props2.appearance,
          borderColor = _this$props2.borderColor,
          presence = _this$props2.presence,
          status = _this$props2.status;
      var showPresence = Boolean(presence);
      var showStatus = Boolean(status); // no icon needed

      if (!showStatus && !showPresence) {
        return null;
      } // cannot display both


      if (showStatus && showPresence) {
        warn('Avatar supports `presence` OR `status` properties, not both.');
        return null;
      } // only support particular sizes


      if (__WEBPACK_IMPORTED_MODULE_14__constants__["b" /* validIconSizes */].indexOf(_this.props.size) === -1) {
        warn("Avatar size \"".concat(String(_this.props.size), "\" does NOT support ").concat(showPresence ? 'presence' : 'status'));
        return null;
      } // we can cast here because we already know that it is a valid icon size


      var size = _this.props.size;

      var indicator = function () {
        if (showPresence) {
          var customPresenceNode = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(presence) === 'object' ? presence : null;
          return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__styled_Avatar__["a" /* PresenceWrapper */], {
            appearance: appearance,
            size: size
          }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Presence__["a" /* default */], {
            borderColor: borderColor,
            presence: !customPresenceNode && presence,
            size: size
          }, customPresenceNode));
        } // showStatus


        var customStatusNode = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(status) === 'object' ? status : null;
        return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__styled_Avatar__["b" /* StatusWrapper */], {
          appearance: appearance,
          size: size
        }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Status__["a" /* default */], {
          borderColor: borderColor,
          status: !customStatusNode && status,
          size: size
        }, customStatusNode));
      }();

      return indicator;
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)), "setRef", function (ref) {
      _this.ref = ref;
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(Avatar, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          appearance = _this$props3.appearance,
          enableTooltip = _this$props3.enableTooltip,
          name = _this$props3.name,
          size = _this$props3.size,
          src = _this$props3.src,
          stackIndex = _this$props3.stackIndex,
          onClick = _this$props3.onClick,
          theme = _this$props3.theme; // distill props from context, props, and state

      var enhancedProps = Object(__WEBPACK_IMPORTED_MODULE_20__helpers__["a" /* getProps */])(this); // provide element type based on props
      // TODO: why not enhanced props?

      var Inner = Object(__WEBPACK_IMPORTED_MODULE_20__helpers__["b" /* getStyledAvatar */])(this.props);
      Inner.displayName = 'Inner';
      var AvatarNode = __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__theme__["a" /* Theme */].Provider, {
        value: theme
      }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__styled_Avatar__["c" /* default */], {
        size: size,
        stackIndex: stackIndex
      }, __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Inner, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        innerRef: this.setRef
      }, enhancedProps, {
        onClick: onClick != null ? this.guardedClick : undefined
      }), __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__AvatarImage__["a" /* default */], {
        alt: name,
        appearance: appearance,
        size: size,
        src: src
      })), this.renderIcon()));
      return enableTooltip && name ? __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__atlaskit_tooltip__["a" /* default */], {
        content: name
      }, AvatarNode) : AvatarNode;
    }
  }]);

  return Avatar;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(Avatar, "defaultProps", {
  appearance: 'circle',
  enableTooltip: true,
  size: 'medium'
});

var AvatarWithoutAnalytics = Object(__WEBPACK_IMPORTED_MODULE_21__hoc__["a" /* mapProps */])({
  appearance: function appearance(props) {
    return props.appearance || Avatar.defaultProps.appearance;
  },
  // 1
  isInteractive: function isInteractive(props) {
    return Boolean((typeof props.enableTooltip !== 'undefined' ? props.enableTooltip : Avatar.defaultProps.enableTooltip) && props.name);
  } // 2

})(Object(__WEBPACK_IMPORTED_MODULE_21__hoc__["b" /* withPseudoState */])(Avatar));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__atlaskit_analytics_next__["withAnalyticsContext"])({
  componentName: 'avatar',
  packageName: __WEBPACK_IMPORTED_MODULE_13__package_json__["name"],
  packageVersion: __WEBPACK_IMPORTED_MODULE_13__package_json__["version"]
})(Object(__WEBPACK_IMPORTED_MODULE_11__atlaskit_analytics_next__["withAnalyticsEvents"])()(AvatarWithoutAnalytics)));

/***/ }),
/* 1901 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/avatar","version":"14.1.7","sideEffects":false}

/***/ }),
/* 1902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DefaultImage */
/* unused harmony export clearCache */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AvatarImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styled_AvatarImage__ = __webpack_require__(1903);










function DefaultImage(_ref) {
  var appearance = _ref.appearance,
      size = _ref.size,
      title = _ref.title,
      isLoading = _ref.isLoading;
  var rectBounds = 128;
  return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__atlaskit_theme__["default"].Consumer, null, function (_ref2) {
    var mode = _ref2.mode;
    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styled_AvatarImage__["c" /* Svg */], {
      appearance: appearance,
      isLoading: isLoading,
      size: size,
      viewBox: "0 0 ".concat(rectBounds, " ").concat(rectBounds),
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": title
    }, appearance === 'circle' ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styled_AvatarImage__["a" /* ShapeGroup */], {
      mode: mode
    }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("circle", {
      cx: "64",
      cy: "64",
      r: "64"
    }), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("g", null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("path", {
      d: "M103,102.1388 C93.094,111.92 79.3504,118 64.1638,118 C48.8056,118 34.9294,111.768 25,101.7892 L25,95.2 C25,86.8096 31.981,80 40.6,80 L87.4,80 C96.019,80 103,86.8096 103,95.2 L103,102.1388 Z"
    }), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("path", {
      d: "M63.9961647,24 C51.2938136,24 41,34.2938136 41,46.9961647 C41,59.7061864 51.2938136,70 63.9961647,70 C76.6985159,70 87,59.7061864 87,46.9961647 C87,34.2938136 76.6985159,24 63.9961647,24"
    }))) : __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styled_AvatarImage__["a" /* ShapeGroup */], {
      mode: mode
    }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("rect", {
      x: "0",
      y: "0",
      width: rectBounds,
      height: rectBounds
    }), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("g", {
      transform: "translate(19.000000, 32.000000)"
    }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("path", {
      d: "M18.25,32.5 L54.5833333,32.5 L54.5833333,23.4166667 L18.25,23.4166667 L18.25,32.5 Z M9.16666667,18.8331166 C9.16666667,16.3479549 11.236581,14.3333333 13.7195662,14.3333333 L59.1137671,14.3333333 C61.6282641,14.3333333 63.6666667,16.3815123 63.6666667,18.8331166 L63.6666667,41.5833333 L9.16666667,41.5833333 L9.16666667,18.8331166 Z"
    }), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("path", {
      d: "M18.25,9.81383682 C18.25,4.7850061 22.3296003,0.708333333 27.3238554,0.708333333 L36.4261446,0.708333333 C41.4374965,0.708333333 45.5,4.76812825 45.5,9.81383682 L45.5,23.4166667 L18.25,23.4166667 L18.25,9.81383682 Z M36.4166667,9.81383682 C36.4166667,9.79803315 36.4184748,9.79303784 36.4207515,9.79166667 L27.3238554,9.79166667 C27.3447224,9.79166667 27.3333333,9.80308059 27.3333333,9.81383682 L27.3333333,14.3333333 L36.4166667,14.3333333 L36.4166667,9.81383682 Z"
    }), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("path", {
      d: "M11.4386532,55.2083333 L74.9953562,55.2083333 L79.5452242,41.5833333 L9.80449752,41.5833333 L11.4386532,55.2083333 Z M0.1048547,36.987541 C-0.192399775,34.5091405 1.5865717,32.5 4.09502839,32.5 L87.6264735,32.5 C90.1274401,32.5 91.5225656,34.393506 90.7231047,36.7875656 L82.9702846,60.004101 C82.1795402,62.3720582 79.5279445,64.2916667 76.9985338,64.2916667 L7.91963924,64.2916667 C5.41227673,64.2916667 3.14113571,62.3029555 2.84143097,59.8041257 L0.1048547,36.987541 Z"
    }))));
  });
}
var cache = {};
var clearCache = function clearCache() {
  cache = {};
};

var AvatarImage =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(AvatarImage, _PureComponent);

  function AvatarImage() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, AvatarImage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(AvatarImage)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      hasError: false,
      // if provided a scr - we need to load it
      isLoading: Boolean(_this.props.src)
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "isComponentMounted", void 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "loadImage", function () {
      // nothing to load
      if (!_this.props.src) {
        return;
      }

      var img = new Image();
      img.onload = _this.handleLoadSuccess;
      img.onerror = _this.handleLoadError;
      img.src = _this.props.src;
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleLoad", function (hasError) {
      if (_this.isComponentMounted) {
        _this.setState({
          hasError: hasError,
          isLoading: false
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleLoadSuccess", function () {
      if (typeof _this.props.src === 'string') {
        cache[_this.props.src] = true;
      }

      _this.handleLoad(false);
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleLoadError", function () {
      return _this.handleLoad(true);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(AvatarImage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.isComponentMounted = true;
      this.loadImage();
    } // handle case where `src` is modified after mount

  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.src && this.props.src !== nextProps.src) {
        this.setState({
          isLoading: true
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.src && this.props.src !== prevProps.src) {
        this.loadImage();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isComponentMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          alt = _this$props.alt,
          src = _this$props.src,
          appearance = _this$props.appearance,
          size = _this$props.size;
      var _this$state = this.state,
          hasError = _this$state.hasError,
          isLoading = _this$state.isLoading;
      var showDefault = !isLoading && (!src || hasError);
      var imageUrl = src && (!isLoading || cache[src]) ? src : null;
      return showDefault ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(DefaultImage, {
        appearance: appearance,
        size: size,
        title: alt,
        isLoading: isLoading
      }) : __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styled_AvatarImage__["b" /* Slot */], {
        appearance: appearance,
        isLoading: isLoading,
        size: size,
        role: "img",
        label: alt,
        backgroundImage: imageUrl
      });
    }
  }]);

  return AvatarImage;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);



/***/ }),
/* 1903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShapeGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Slot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Svg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__theme__ = __webpack_require__(266);






var ShapeGroup = Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["withTheme"])(__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].g.withConfig({
  displayName: "AvatarImage__ShapeGroup",
  componentId: "sc-1hf6c4m-0"
})(["\n  & circle,\n  & rect {\n    fill: ", ";\n  }\n  & g {\n    fill: ", ";\n  }\n"], Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["colors"].N50,
  dark: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["colors"].DN100
}), __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["colors"].background));
var Slot = function Slot(_ref) {
  var isLoading = _ref.isLoading,
      appearance = _ref.appearance,
      size = _ref.size,
      backgroundImage = _ref.backgroundImage,
      label = _ref.label,
      role = _ref.role;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__theme__["a" /* Theme */].Consumer, {
    appearance: appearance,
    isLoading: isLoading,
    size: size
  }, function (_ref2) {
    var backgroundColor = _ref2.backgroundColor,
        borderRadius = _ref2.borderRadius;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      style: {
        backgroundColor: backgroundColor,
        backgroundImage: backgroundImage ? "url(".concat(backgroundImage, ")") : null,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        borderRadius: borderRadius,
        display: 'flex',
        flex: '1 1 100%',
        height: '100%',
        width: '100%'
      },
      role: role,
      "aria-label": label
    });
  });
};
var Svg = function Svg(_ref3) {
  var appearance = _ref3.appearance,
      size = _ref3.size,
      children = _ref3.children,
      isLoading = _ref3.isLoading,
      otherProps = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref3, ["appearance", "size", "children", "isLoading"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__theme__["a" /* Theme */].Consumer, {
    appearance: appearance,
    isLoading: isLoading,
    size: size
  }, function (_ref4) {
    var backgroundColor = _ref4.backgroundColor,
        borderRadius = _ref4.borderRadius;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("svg", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      style: {
        backgroundColor: backgroundColor,
        borderRadius: borderRadius,
        height: '100%',
        width: '100%'
      }
    }, otherProps), children);
  });
};

/***/ }),
/* 1904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Inner */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PresenceWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StatusWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__theme__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(400);







/* harmony default export */ __webpack_exports__["c"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__theme__["a" /* Theme */].Consumer, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, props, {
    includeBorderWidth: true
  }), function (_ref) {
    var dimensions = _ref.dimensions;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
      style: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({
        display: 'inline-block',
        position: 'relative',
        outline: 0,
        zIndex: props.stackIndex
      }, dimensions)
    }, props.children);
  });
}); // TODO this doesn't appear to be used anywhere so we should look at removing.

var Inner = Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["withTheme"])(__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div.withConfig({
  displayName: "Avatar__Inner",
  componentId: "r9c9gb-0"
})(["\n  ", ";\n"], __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* getInnerStyles */]));
var PresenceWrapper = function PresenceWrapper(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__theme__["a" /* Theme */].Consumer, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, props, {
    includeBorderWidth: true
  }), function (_ref2) {
    var presence = _ref2.presence;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      style: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({
        pointerEvents: 'none',
        position: 'absolute'
      }, presence)
    }, props.children);
  });
};
var StatusWrapper = function StatusWrapper(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__theme__["a" /* Theme */].Consumer, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, props, {
    includeBorderWidth: true
  }), function (_ref3) {
    var status = _ref3.status;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      style: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({
        position: 'absolute'
      }, status)
    }, props.children);
  });
};

/***/ }),
/* 1905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);


var getAppearanceProps = function getAppearanceProps(props) {
  var appearance = props.appearance,
      backgroundColor = props.backgroundColor,
      borderColor = props.borderColor,
      groupAppearance = props.groupAppearance,
      isActive = props.isActive,
      isDisabled = props.isDisabled,
      isFocus = props.isFocus,
      isHover = props.isHover,
      isInteractive = props.isInteractive,
      isSelected = props.isSelected,
      size = props.size,
      stackIndex = props.stackIndex;
  return {
    appearance: appearance,
    backgroundColor: backgroundColor,
    borderColor: borderColor,
    groupAppearance: groupAppearance,
    isActive: isActive,
    isDisabled: isDisabled,
    isFocus: isFocus,
    isHover: isHover,
    isInteractive: isInteractive,
    isSelected: isSelected,
    size: size,
    stackIndex: stackIndex
  };
};

var getInteractionProps = function getInteractionProps(props) {
  var onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      tabIndex = props.tabIndex;
  return {
    onBlur: onBlur,
    onClick: onClick,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onMouseDown: onMouseDown,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onMouseUp: onMouseUp,
    tabIndex: tabIndex
  };
};

var getLinkElementProps = function getLinkElementProps(props) {
  var href = props.href,
      target = props.target; // handle security issue for consumer
  // https://mathiasbynens.github.io/rel-noopener

  var rel = target === '_blank' ? 'noopener noreferrer' : null;
  return {
    href: href,
    rel: rel,
    target: target
  };
};

var getButtonElementProps = function getButtonElementProps(props) {
  var id = props.id,
      isDisabled = props.isDisabled;
  return {
    id: id,
    type: 'button',
    disabled: isDisabled
  };
}; // TODO: type this correctly


function getProps(component) {
  var props = component.props;

  var defaultProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, getAppearanceProps(props), getInteractionProps(props));

  if (props.component) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, defaultProps, props);
  }

  if (props.href) {
    if (props.isDisabled) {
      return defaultProps;
    }

    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, defaultProps, getLinkElementProps(props));
  }

  if (props.onClick) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, defaultProps, getButtonElementProps(props));
  }

  return defaultProps;
}

/***/ }),
/* 1906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styledCache__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styled_utils__ = __webpack_require__(400);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__styledCache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__styled_utils__["b" /* getInnerStyles */]));

/***/ }),
/* 1907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomComponentProxy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








/**
 * Styling a avatar is complicated and there are a number of properties which
 * inform its appearance. We want to be able to style any arbitrary component
 * like a Link, but we don't want to pass all of these appearance-related props
 * through to the component or underlying DOM node. This component acts as a
 * layer which catches the appearance-related properties so that they can be
 * used by styled-components, then passes the rest of the props on to the custom
 * component.
 */
var CustomComponentProxy =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(CustomComponentProxy, _Component);

  function CustomComponentProxy() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, CustomComponentProxy);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(CustomComponentProxy).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(CustomComponentProxy, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          appearance = _this$props.appearance,
          avatar = _this$props.avatar,
          borderColor = _this$props.borderColor,
          ProxiedComponent = _this$props.component,
          enableTooltip = _this$props.enableTooltip,
          groupAppearance = _this$props.groupAppearance,
          innerRef = _this$props.innerRef,
          isActive = _this$props.isActive,
          isDisabled = _this$props.isDisabled,
          isFocus = _this$props.isFocus,
          isHover = _this$props.isHover,
          isSelected = _this$props.isSelected,
          primaryText = _this$props.primaryText,
          secondaryText = _this$props.secondaryText,
          stackIndex = _this$props.stackIndex,
          rest = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(_this$props, ["appearance", "avatar", "borderColor", "component", "enableTooltip", "groupAppearance", "innerRef", "isActive", "isDisabled", "isFocus", "isHover", "isSelected", "primaryText", "secondaryText", "stackIndex"]);

      return ProxiedComponent ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ProxiedComponent, rest) : null;
    }
  }]);

  return CustomComponentProxy;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);



/***/ }),
/* 1908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styledCache__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styled_AvatarItem__ = __webpack_require__(714);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__styledCache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__styled_AvatarItem__["e" /* getStyles */]));

/***/ }),
/* 1909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(267);











function mapProps(mapping) {
  return function (DecoratedComponent // TODO: type this correctly
  ) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_Component) {
      __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(MapProps, _Component);

      function MapProps() {
        var _getPrototypeOf2;

        var _this;

        __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, MapProps);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(MapProps)).call.apply(_getPrototypeOf2, [this].concat(args)));

        __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "component", void 0);

        __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "blur", function () {
          if (_this.component && _this.component.blur) _this.component.blur();
        });

        __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "focus", function () {
          if (_this.component && _this.component.focus) _this.component.focus();
        });

        __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "setComponent", function (component) {
          _this.component = component;
        });

        return _this;
      }

      __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(MapProps, [{
        key: "render",
        value: function render() {
          var _this2 = this;

          var mapped = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, this.props, Object.keys(mapping).reduce(function (acc, key) {
            return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, acc, __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()({}, key, mapping[key](_this2.props)));
          }, {}));

          return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(DecoratedComponent, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
            ref: this.setComponent
          }, mapped));
        }
      }]);

      return MapProps;
    }(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]), __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(_class, "displayName", Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* getDisplayName */])('mapProps', DecoratedComponent)), __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(_class, "DecoratedComponent", DecoratedComponent), _temp;
  };
}

/***/ }),
/* 1910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withPseudoState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(267);










var INTERNAL_HANDLERS = ['onBlur', 'onFocus', 'onKeyDown', 'onKeyUp', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseUp'];
function withPseudoState(WrappedComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ComponentWithPseudoState, _Component);

    function ComponentWithPseudoState() {
      var _getPrototypeOf2;

      var _this;

      __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ComponentWithPseudoState);

      for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
        _args[_key] = arguments[_key];
      }

      _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ComponentWithPseudoState)).call.apply(_getPrototypeOf2, [this].concat(_args)));

      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "component", void 0);

      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "actionKeys", void 0);

      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
        isActive: Boolean(_this.props.isActive),
        isFocus: Boolean(_this.props.isActive),
        isHover: Boolean(_this.props.isActive),
        isInteractive: Boolean(_this.props.href || _this.props.isInteractive || _this.props.onClick)
      });

      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "blur", function () {
        if (_this.component && _this.component.blur) _this.component.blur();
      });

      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "focus", function () {
        if (_this.component && _this.component.focus) _this.component.focus();
      });

      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "setComponent", function (component) {
        _this.component = component;
      });

      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onBlur", function () {
        return _this.setState({
          isActive: false,
          isFocus: false
        });
      });

      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onFocus", function () {
        return _this.setState({
          isFocus: true
        });
      });

      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onMouseLeave", function () {
        return _this.setState({
          isActive: false,
          isHover: false
        });
      });

      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onMouseEnter", function () {
        return _this.setState({
          isHover: true
        });
      });

      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onMouseUp", function () {
        return _this.setState({
          isActive: false
        });
      });

      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onMouseDown", function () {
        return _this.setState({
          isActive: true
        });
      });

      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onKeyDown", function (event) {
        if (_this.actionKeys.indexOf(event.key) > -1) {
          _this.setState({
            isActive: true
          });
        }
      });

      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onKeyUp", function (event) {
        if (_this.actionKeys.indexOf(event.key) > -1) {
          _this.setState({
            isActive: false
          });
        }
      });

      __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getProps", function () {
        var isInteractive = _this.state.isInteractive; // strip the consumer's handlers off props, then merge with our handlers
        // if the element is interactive
        // We cannot properly type omit because of the inability to convert from
        // an array to a union of the array's items. See https://github.com/facebook/flow/issues/961
        // if you want to learn more about this
        // $FlowFixMe

        var props = __WEBPACK_IMPORTED_MODULE_9__utils__["b" /* omit */].apply(void 0, [_this.props].concat(INTERNAL_HANDLERS));

        var self = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));

        if (isInteractive) {
          INTERNAL_HANDLERS.forEach(function (handler) {
            if (_this.props[handler]) {
              props[handler] = function () {
                var _this$props;

                self[handler].apply(self, arguments);

                (_this$props = _this.props)[handler].apply(_this$props, arguments);
              };
            } else {
              props[handler] = self[handler];
            }
          });
        }

        return props;
      });

      return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ComponentWithPseudoState, [{
      key: "componentWillMount",
      value: function componentWillMount() {
        var _this$props2 = this.props,
            href = _this$props2.href,
            isInteractive = _this$props2.isInteractive,
            onClick = _this$props2.onClick;

        if (href || isInteractive || onClick) {
          this.actionKeys = onClick || isInteractive ? ['Enter', ' '] : ['Enter'];
        }
      }
    }, {
      key: "render",
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(WrappedComponent, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          ref: this.setComponent
        }, this.state, this.getProps()));
      }
    }]);

    return ComponentWithPseudoState;
  }(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]), __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_class, "displayName", Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* getDisplayName */])('withPseudoState', WrappedComponent)), _temp;
}

/***/ }),
/* 1911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styled_AvatarItem__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hoc__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__theme_item__ = __webpack_require__(715);



















var AvatarItem =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(AvatarItem, _Component);

  function AvatarItem() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, AvatarItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(AvatarItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)), "node", void 0);

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)), "blur", function () {
      if (_this.node) _this.node.blur();
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)), "focus", function () {
      if (_this.node) _this.node.focus();
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)), "guardedClick", function (event) {
      var _this$props = _this.props,
          isDisabled = _this$props.isDisabled,
          onClick = _this$props.onClick;
      if (isDisabled || typeof onClick !== 'function') return;
      var item = __WEBPACK_IMPORTED_MODULE_13__utils__["b" /* omit */].apply(void 0, [_this.props].concat(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_12__constants__["a" /* propsOmittedFromClickData */])));
      onClick({
        item: item,
        event: event
      });
    });

    __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)), "setNode", function (ref) {
      _this.node = ref;
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(AvatarItem, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          avatar = _this$props2.avatar,
          enableTextTruncate = _this$props2.enableTextTruncate,
          primaryText = _this$props2.primaryText,
          secondaryText = _this$props2.secondaryText; // distill props from context, props, and state

      var enhancedProps = Object(__WEBPACK_IMPORTED_MODULE_15__helpers__["a" /* getProps */])(this); // provide element type based on props

      var StyledComponent = Object(__WEBPACK_IMPORTED_MODULE_15__helpers__["c" /* getStyledAvatarItem */])(this.props);
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__atlaskit_theme__["default"].Consumer, null, function (_ref) {
        var mode = _ref.mode;
        return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__theme_item__["a" /* ThemeItem */].Provider, {
          value: _this2.props.theme
        }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__theme_item__["a" /* ThemeItem */].Consumer, null, function (tokens) {
          // maintain the illusion of a mask around presence/status
          var borderColor = Object(__WEBPACK_IMPORTED_MODULE_14__styled_AvatarItem__["d" /* getBackgroundColor */])(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, _this2.props, tokens, {
            mode: mode
          }));
          return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(StyledComponent, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
            innerRef: _this2.setNode
          }, enhancedProps, {
            onClick: _this2.guardedClick
          }), Object(__WEBPACK_IMPORTED_MODULE_11_react__["cloneElement"])(avatar, {
            borderColor: borderColor
          }), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled_AvatarItem__["a" /* Content */], {
            truncate: enableTextTruncate
          }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled_AvatarItem__["b" /* PrimaryText */], {
            truncate: enableTextTruncate
          }, primaryText), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled_AvatarItem__["c" /* SecondaryText */], {
            truncate: enableTextTruncate
          }, secondaryText)));
        }));
      });
    }
  }]);

  return AvatarItem;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(AvatarItem, "defaultProps", {
  enableTextTruncate: true
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_16__hoc__["b" /* withPseudoState */])(AvatarItem));

/***/ }),
/* 1912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled_Skeleton__ = __webpack_require__(1913);









var Skeleton =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Skeleton, _Component);

  function Skeleton() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Skeleton);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Skeleton).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Skeleton, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled_Skeleton__["a" /* default */], this.props);
    }
  }]);

  return Skeleton;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(Skeleton, "defaultProps", {
  appearance: 'circle',
  size: 'medium',
  weight: 'normal'
});



/***/ }),
/* 1913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(199);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Skeleton",
  componentId: "sc-1wbn63x-0"
})(["\n  width: ", "px;\n  height: ", "px;\n  display: inline-block;\n  border-radius: ", ";\n  background-color: ", ";\n  border: ", "px solid transparent;\n  opacity: ", ";\n"], function (_ref) {
  var size = _ref.size;
  return __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* AVATAR_SIZES */][size];
}, function (_ref2) {
  var size = _ref2.size;
  return __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* AVATAR_SIZES */][size];
}, function (props) {
  return props.appearance === 'square' ? "".concat(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* AVATAR_RADIUS */][props.size], "px") : '50%';
}, function (_ref3) {
  var color = _ref3.color;
  return color || 'currentColor';
}, function (_ref4) {
  var size = _ref4.size;
  return __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BORDER_WIDTH */][size];
}, function (_ref5) {
  var weight = _ref5.weight;
  return weight === 'strong' ? 0.3 : 0.15;
}));

/***/ }),
/* 1914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Lozenge; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styledContainer__ = __webpack_require__(1915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styledContent__ = __webpack_require__(1916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__theme__ = __webpack_require__(1917);











var Lozenge =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Lozenge, _PureComponent);

  function Lozenge() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Lozenge);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Lozenge).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Lozenge, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__theme__["a" /* Theme */].Provider, {
        value: props.theme
      }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__theme__["a" /* Theme */].Consumer, props, function (tokens) {
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styledContainer__["a" /* default */], tokens, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styledContent__["a" /* default */], tokens, props.children));
      }));
    }
  }]);

  return Lozenge;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(Lozenge, "defaultProps", {
  isBold: false,
  appearance: 'default',
  maxWidth: 200
});



/***/ }),
/* 1915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "styledContainer",
  componentId: "sc-1vjy1uk-0"
})(["\n  ", ";\n  border-radius: ", "px;\n  box-sizing: border-box;\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1;\n  max-width: 100%;\n  padding: 2px 0 3px 0;\n  text-transform: uppercase;\n  vertical-align: baseline;\n"], function (props) {
  return "\n    background-color: ".concat(props.backgroundColor, ";\n    color: ").concat(props.textColor, ";\n  ");
}, Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["borderRadius"])()));

/***/ }),
/* 1916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);


var HORIZONTAL_SPACING = "".concat(Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])() / 2, "px");
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "styledContent",
  componentId: "ku88a7-0"
})(["\n  display: inline-block;\n  vertical-align: top;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  box-sizing: border-box;\n  padding: 0 ", ";\n  max-width: ", ";\n  width: 100%;\n"], HORIZONTAL_SPACING, function (props) {
  return typeof props.maxWidth === 'number' ? "".concat(props.maxWidth, "px") : props.maxWidth;
}));

/***/ }),
/* 1917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export backgroundColor */
/* unused harmony export textColor */
/* unused harmony export boldBackgroundColor */
/* unused harmony export boldTextColor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Theme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



/* Note:
 Lozenge does not support dark mode at the moment,
 it will be implemented later.
 Hence, color values are the same.
 */

var backgroundColor = {
  default: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N40,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N40
  },
  inprogress: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B50,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B50
  },
  moved: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].Y75,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].Y75
  },
  new: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].P50,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].P50
  },
  removed: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R50,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R50
  },
  success: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].G50,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].G50
  }
};
var textColor = {
  default: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N500,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N500
  },
  inprogress: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B500,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B500
  },
  moved: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N800,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N800
  },
  new: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].P500,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].P500
  },
  removed: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R500,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R500
  },
  success: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].G500,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].G500
  }
};
var boldBackgroundColor = {
  default: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N500,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N500
  },
  inprogress: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B400,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B400
  },
  moved: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].Y500,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].Y500
  },
  new: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].P400,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].P400
  },
  removed: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R400,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R400
  },
  success: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].G400,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].G400
  }
};
var boldTextColor = {
  default: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N0,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N0
  },
  inprogress: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N0,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N0
  },
  moved: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N800,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N800
  },
  new: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N0,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N0
  },
  removed: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N0,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N0
  },
  success: {
    light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N0,
    dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N0
  }
};
var Theme = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["createTheme"])(function (_ref) {
  var appearance = _ref.appearance,
      isBold = _ref.isBold,
      maxWidth = _ref.maxWidth;
  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(appearance) === 'object' ? __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({
    backgroundColor: (isBold ? boldBackgroundColor : backgroundColor).default.light,
    textColor: (isBold ? boldTextColor : textColor).default.light
  }, appearance) : {
    backgroundColor: (isBold ? boldBackgroundColor[appearance] : backgroundColor[appearance]).light,
    textColor: (isBold ? boldTextColor[appearance] : textColor[appearance]).light
  }, {
    maxWidth: maxWidth
  });
});

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var LockCircleIcon = function LockCircleIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill-rule=\"evenodd\"><circle fill=\"currentColor\" cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M12.02 8h-.04A1.98 1.98 0 0 0 10 9.98V11h1V9.99a.99.99 0 0 1 .99-.99h.02a.99.99 0 0 1 .99.99V11h1V9.98A1.98 1.98 0 0 0 12.02 8M10 11h1v1h-1zm3 0h1v1h-1zm0 1h-3a1 1 0 0 0-1 1v2.001a1 1 0 0 0 .991.999h4.018a.992.992 0 0 0 .991-.999V13a1 1 0 0 0-1-1h-1z\" fill=\"inherit\"/></g></svg>"
  }, props));
};

LockCircleIcon.displayName = 'LockCircleIcon';
var _default = LockCircleIcon;
exports.default = _default;

/***/ }),
/* 1919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RowStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AvatarStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NameSectionStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FullNameStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NicknameStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return InfoSectionStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TimeStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MentionItemStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccessSectionStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



var RowStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  overflow: hidden;\n  padding: 6px 14px;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  overflow: hidden;\n  padding: 6px 14px;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n"])));
var AvatarStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  position: relative;\n  flex: initial;\n  opacity: ", ";\n"], ["\n  position: relative;\n  flex: initial;\n  opacity: ",
    ";\n"])), function (props) {
    return props.restricted ? '0.5' : 'inherit';
});
var NameSectionStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  flex: 1;\n  min-width: 0;\n  margin-left: 14px;\n  opacity: ", ";\n"], ["\n  flex: 1;\n  min-width: 0;\n  margin-left: 14px;\n  opacity: ",
    ";\n"])), function (props) {
    return props.restricted ? '0.5' : 'inherit';
});
var FullNameStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: ", ";\n"], ["\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N900);
var NicknameStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_5 || (templateObject_5 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  color: ", ";\n  font-size: 12px;\n\n  margin-top: 2px;\n\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  color: ", ";\n  font-size: 12px;\n\n  margin-top: 2px;\n\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N100);
var InfoSectionStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_6 || (templateObject_6 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  flex-direction: column;\n  text-align: right;\n  opacity: ", ";\n\n  & {\n    /* Lozenge */\n    & > span {\n      margin-bottom: 2px;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  text-align: right;\n  opacity: ",
    ";\n\n  & {\n    /* Lozenge */\n    & > span {\n      margin-bottom: 2px;\n    }\n  }\n"])), function (props) {
    return props.restricted ? '0.5' : 'inherit';
});
// tslint:disable:next-line variable-name
var TimeStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_7 || (templateObject_7 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin-left: 20px;\n  flex: none;\n  color: ", ";\n  font-size: 12px;\n"], ["\n  margin-left: 20px;\n  flex: none;\n  color: ", ";\n  font-size: 12px;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N100);
var MentionItemStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_8 || (templateObject_8 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  background-color: ", ";\n  display: block;\n  overflow: hidden;\n  list-style-type: none;\n  height: 48px;\n  line-height: 1.2;\n  cursor: pointer;\n"], ["\n  background-color: ",
    ";\n  display: block;\n  overflow: hidden;\n  list-style-type: none;\n  height: 48px;\n  line-height: 1.2;\n  cursor: pointer;\n"])), function (props) {
    return props.selected ? __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30 : 'transparent';
});
var AccessSectionStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_9 || (templateObject_9 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  padding-left: 5px;\n  color: ", ";\n"], ["\n  padding-left: 5px;\n  color: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N500);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 1920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return messages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(17);

var messages = Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["defineMessages"])({
    noAccessWarning: {
        id: 'fabric.mention.noAccess.warning',
        defaultMessage: "{name} won't be notified as they have no access",
        description: "Warning message to show that the mentioned user won't be notified",
    },
    noAccessLabel: {
        id: 'fabric.mention.noAccess.label',
        defaultMessage: 'No access',
        description: 'Label for no access icon',
    },
    defaultHeadline: {
        id: 'fabric.mention.error.defaultHeadline',
        defaultMessage: 'Something went wrong',
        description: 'Error message shown when there is an error communicating with backend',
    },
    defaultAdvisedAction: {
        id: 'fabric.mention.error.defaultAction',
        defaultMessage: 'Try again in a few seconds',
        description: 'Default advised action when an error occurs',
    },
    loginAgain: {
        id: 'fabric.mention.error.loginAgain',
        defaultMessage: 'Try logging out then in again',
        description: 'Login again message when there is an authentication error occurs',
    },
    differentText: {
        id: 'fabric.mention.error.differentText',
        defaultMessage: 'Try entering different text',
        description: 'Enter different text message when a forbidden error occurs',
    },
});
//# sourceMappingURL=i18n.js.map

/***/ }),
/* 1921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MentionListStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_styles__ = __webpack_require__(404);



var MentionListStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: ", ";\n\n  /* list style */\n  width: ", ";\n  color: #333;\n\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n"], ["\n  display: ",
    ";\n\n  /* list style */\n  width: ", ";\n  color: #333;\n\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n"])), function (props) {
    return props.empty ? 'none' : 'block';
}, __WEBPACK_IMPORTED_MODULE_2__shared_styles__["a" /* mentionListWidth */], __WEBPACK_IMPORTED_MODULE_2__shared_styles__["b" /* noDialogContainerBorderColor */], __WEBPACK_IMPORTED_MODULE_2__shared_styles__["c" /* noDialogContainerBorderRadius */], __WEBPACK_IMPORTED_MODULE_2__shared_styles__["d" /* noDialogContainerBoxShadow */]);
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 1922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GenericErrorIllustration__ = __webpack_require__(1923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_i18n__ = __webpack_require__(403);





var advisedActionMessages = {
    '401': __WEBPACK_IMPORTED_MODULE_4__util_i18n__["d" /* LoginAgain */],
    '403': __WEBPACK_IMPORTED_MODULE_4__util_i18n__["c" /* DifferentText */],
    default: __WEBPACK_IMPORTED_MODULE_4__util_i18n__["a" /* DefaultAdvisedAction */],
};
var MentionListError = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionListError, _super);
    function MentionListError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Translate the supplied Error into a message suitable for display in the MentionList.
     *
     * @param error the error to be displayed
     */
    MentionListError.getAdvisedActionMessage = function (error) {
        if (error && error.hasOwnProperty('statusCode')) {
            var httpError = error;
            return (advisedActionMessages[httpError.statusCode.toString()] ||
                advisedActionMessages.default);
        }
        return advisedActionMessages.default;
    };
    MentionListError.prototype.render = function () {
        var error = this.props.error;
        var ErrorMessage = MentionListError.getAdvisedActionMessage(error);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* MentionListErrorStyle */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__GenericErrorIllustration__["a" /* GenericErrorIllustration */], null),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* MentionListErrorHeadlineStyle */], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__util_i18n__["b" /* DefaultHeadline */], null)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* MentionListAdviceStyle */], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ErrorMessage, null))));
    };
    return MentionListError;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (MentionListError);
//# sourceMappingURL=index.js.map

/***/ }),
/* 1923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GenericErrorIllustration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(719);



var GenericErrorIllustration = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](GenericErrorIllustration, _super);
    function GenericErrorIllustration() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GenericErrorIllustration.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* GenericErrorVisualStyle */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 163.3 212", "aria-labelledby": "title" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("defs", null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("style", { dangerouslySetInnerHTML: {
                            __html: '.cls-1{fill:url(#linear-gradient);}.cls-2,.cls-5{opacity:0.6;}.cls-3{fill:#c1c7d0;}.cls-4{fill:#b3bac5;}.cls-5{isolation:isolate;}',
                        } }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("linearGradient", { id: "linear-gradient", x1: "25.54", y1: "806.64", x2: "137.75", y2: "694.44", gradientTransform: "translate(0 -578)", gradientUnits: "userSpaceOnUse" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("stop", { offset: 0, stopColor: "#c1c7d0" }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("stop", { offset: "0.24", stopColor: "#c4cad2", stopOpacity: "0.97" }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("stop", { offset: "0.5", stopColor: "#cdd1d9", stopOpacity: "0.89" }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("stop", { offset: "0.78", stopColor: "#dcdee4", stopOpacity: "0.75" }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("stop", { offset: 1, stopColor: "#ebecf0", stopOpacity: "0.6" }))),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("title", null, this.props.title ? this.props.title : 'Generic Error'),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { "data-name": "Layer 2" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { "data-name": "Layer 1-2" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { className: "cls-1", d: "M94.8,74.2l66.4,115.1a15.16,15.16,0,0,1-5.5,20.7,15.4,15.4,0,0,1-7.6,2H15.2A15.19,15.19,0,0,1,0,196.8a15.4,15.4,0,0,1,2-7.6l66.5-115a15.21,15.21,0,0,1,20.7-5.6A15.81,15.81,0,0,1,94.8,74.2Zm-7.6,83.5,2.9-44.3a9.26,9.26,0,0,0-8.6-9.8h-.6a9.18,9.18,0,0,0-9.2,9.2v.6l2.9,44.3a6.33,6.33,0,0,0,6.3,5.9h0A6.26,6.26,0,0,0,87.2,157.7ZM71.4,181.2a9.5,9.5,0,0,0,9.4,9.6h.9a9.79,9.79,0,0,0,8.8-10.5,9.69,9.69,0,0,0-9.7-8.8A9.58,9.58,0,0,0,71.4,181.2Z" }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { className: "cls-2" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { className: "cls-3", d: "M92.7,27.2,85.3.4a.57.57,0,0,0-.7-.4c-.2.1-.4.2-.4.5L79.5,25.6l-5.8-1.1c-.3-.1-.6.2-.7.5v.3L80.3,52a.75.75,0,0,0,.7.5.82.82,0,0,0,.5-.5l4.7-25.1,5.8,1c.3.1.6-.2.7-.5Z" }),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { className: "cls-3", d: "M66.1,41.8,55.2,33.2a.3.3,0,0,0-.4,0,.19.19,0,0,0,0,.3L60.4,45l-2.7,1.3c-.1.1-.2.2-.1.4a.1.1,0,0,0,.1.1l10.9,8.5a.3.3,0,0,0,.4,0,.19.19,0,0,0,0-.3L63.4,43.6l2.7-1.3a.33.33,0,0,0,0-.5Z" })),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { className: "cls-2" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { className: "cls-4", d: "M102.1,56.8a1.42,1.42,0,0,1-.6-.2,1,1,0,0,1-.3-1.2c-.2-.8-2.3-2.8-3.5-4.1-3-3-4.9-5-3.8-6.5s3.6-.2,7.3,1.7a28.41,28.41,0,0,0,4.5,2,21.58,21.58,0,0,0-3.3-3.6c-3-3-4.9-5-3.8-6.5s3.6-.2,7.4,1.7a27.65,27.65,0,0,0,4.4,2,21.58,21.58,0,0,0-3.3-3.6c-3-3-4.9-5-3.8-6.5s3.6-.2,7.3,1.7c1.6.8,4.2,2.1,5,2.1a.91.91,0,0,1,1.2,0,1.08,1.08,0,0,1,.2,1.4c-1.1,1.5-3.6.2-7.3-1.7a27.65,27.65,0,0,0-4.4-2,21.58,21.58,0,0,0,3.3,3.6c3,3,4.9,5,3.8,6.5s-3.6.2-7.3-1.7a28.41,28.41,0,0,0-4.5-2,21.58,21.58,0,0,0,3.3,3.6c3,3,4.9,5,3.8,6.5s-3.6.2-7.3-1.7a28.41,28.41,0,0,0-4.5-2,21.58,21.58,0,0,0,3.3,3.6c3,3,4.9,5,3.8,6.5A1.8,1.8,0,0,1,102.1,56.8Z" })),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { className: "cls-5" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { className: "cls-4", d: "M107.7,71.1a1.05,1.05,0,0,1-.9-.5c-1-1.9-2.2-4-.9-5.2s3.3.2,5.5,1.6a19.31,19.31,0,0,0,2.9,1.7,15.89,15.89,0,0,0-1.4-3.1c-1.3-2.3-2.5-4.4-1.1-5.6s3.3.2,5.5,1.6c1,.6,2.5,1.7,3.1,1.7a1,1,0,0,1,1.3.1,1,1,0,0,1-.1,1.4c-1.3,1.2-3.3-.2-5.5-1.6a19.31,19.31,0,0,0-2.9-1.7,13.64,13.64,0,0,0,1.4,3.1c1.3,2.3,2.4,4.4,1.1,5.6s-3.3-.2-5.5-1.6a19.31,19.31,0,0,0-2.9-1.7,13.07,13.07,0,0,0,1.2,2.7,1,1,0,0,1-.4,1.4A.6.6,0,0,1,107.7,71.1Zm12.5-7.6Z" })),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { className: "cls-5" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { className: "cls-4", d: "M53.4,68.1a2,2,0,0,1-.7-.1c-1.6-.7-1.2-3.1-.8-5.6a10.87,10.87,0,0,0,.3-3.4A15,15,0,0,0,50,61.6c-1.5,2.1-3,4.1-4.6,3.4a1,1,0,0,1-.5-1.3,1,1,0,0,1,1.2-.6,11.23,11.23,0,0,0,2.3-2.7c1.5-2.1,3-4.1,4.7-3.4s1.3,3.1.8,5.7a13.86,13.86,0,0,0-.3,3.3,11.82,11.82,0,0,0,2.1-2.6c1.5-2.1,3-4.1,4.7-3.4s1.2,3.1.9,5.2a1,1,0,1,1-1.9-.3,14.28,14.28,0,0,0,.3-2.9,15,15,0,0,0-2.2,2.6C56,66.4,54.7,68.1,53.4,68.1Z" })))))));
    };
    return GenericErrorIllustration;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

//# sourceMappingURL=GenericErrorIllustration.js.map

/***/ }),
/* 1924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(1925);




var Scrollable = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Scrollable, _super);
    function Scrollable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // API
        _this.reveal = function (child) {
            if (child && _this.scrollableDiv) {
                var childNode = Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(child);
                // Not using Element.scrollIntoView as it scrolls even to top/bottom of view even if
                // already visible
                var scrollableRect = _this.scrollableDiv.getBoundingClientRect();
                var elementRect = childNode.getBoundingClientRect();
                if (elementRect.top < scrollableRect.top) {
                    _this.scrollableDiv.scrollTop += elementRect.top - scrollableRect.top;
                }
                else if (elementRect.bottom > scrollableRect.bottom) {
                    _this.scrollableDiv.scrollTop +=
                        elementRect.bottom - scrollableRect.bottom;
                }
            }
        };
        _this.handleRef = function (ref) {
            _this.scrollableDiv = ref;
        };
        return _this;
    }
    Scrollable.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* ScrollableStyle */], { innerRef: this.handleRef }, this.props.children));
    };
    return Scrollable;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Scrollable);
//# sourceMappingURL=index.js.map

/***/ }),
/* 1925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollableStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_styles__ = __webpack_require__(404);




var ScrollableStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: block;\n  overflow-x: hidden;\n  overflow-y: auto;\n\n  padding: 4px 0;\n  margin: 0;\n\n  background: white;\n  max-height: ", ";\n\n  border-radius: ", "px;\n"], ["\n  display: block;\n  overflow-x: hidden;\n  overflow-y: auto;\n\n  padding: 4px 0;\n  margin: 0;\n\n  background: white;\n  max-height: ", ";\n\n  border-radius: ", "px;\n"])), __WEBPACK_IMPORTED_MODULE_3__shared_styles__["e" /* scrollableMaxHeight */], Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])());
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 1926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MentionPicker */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MentionPickerWithAnalytics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(1927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResourcedMentionList__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Popup__ = __webpack_require__(1928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_logger__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_id__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_analytics__ = __webpack_require__(722);









/**
 * @class MentionPicker
 */
var MentionPicker = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionPicker, _super);
    function MentionPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.selectNext = function () {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectNext();
            }
        };
        _this.selectPrevious = function () {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectPrevious();
            }
        };
        _this.selectIndex = function (index, callback) {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectIndex(index, callback);
            }
        };
        _this.selectId = function (id, callback) {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectId(id, callback);
            }
        };
        _this.chooseCurrentSelection = function () {
            if (_this.mentionListRef) {
                _this.mentionListRef.chooseCurrentSelection();
            }
        };
        _this.mentionsCount = function () {
            if (_this.mentionListRef) {
                return _this.mentionListRef.mentionsCount();
            }
            return 0;
        };
        /**
         * Called after the 'visible' state is changed to decide whether the onOpen or onClose
         * handlers should be called.
         *
         * It should be noted that the visible state of the component is not considered in
         * this function. Instead the old state and new state should be passed as parameters.
         */
        _this.onFilterVisibilityChange = function (oldVisibility, newVisibility) {
            if (oldVisibility !== newVisibility) {
                if (newVisibility) {
                    if (_this.props.onOpen) {
                        _this.props.onOpen();
                    }
                }
                else {
                    if (_this.props.onClose) {
                        _this.props.onClose();
                    }
                }
            }
        };
        // internal, used for callbacks
        _this.filterChange = function (mentions, query, stats) {
            Object(__WEBPACK_IMPORTED_MODULE_5__util_logger__["a" /* default */])('ak-mention-picker.filterChange', mentions.length);
            var wasVisible = _this.state.visible;
            var visible = mentions.length > 0;
            _this.setState({
                visible: visible,
            });
            _this.onFilterVisibilityChange(wasVisible, visible);
            if (stats && stats.remoteSearch) {
                __WEBPACK_IMPORTED_MODULE_8__util_analytics__["c" /* fireAnalyticsMentionTypeaheadEvent */](_this.props)('rendered', stats.duration, mentions.map(function (mention) { return mention.id; }), query);
            }
        };
        _this.filterError = function (error) {
            Object(__WEBPACK_IMPORTED_MODULE_5__util_logger__["a" /* default */])('ak-mention-picker.filterError', error);
            var wasVisible = _this.state.visible;
            _this.setState({
                visible: true,
                info: undefined,
            });
            _this.onFilterVisibilityChange(wasVisible, true);
        };
        _this.filterInfo = function (info) {
            Object(__WEBPACK_IMPORTED_MODULE_5__util_logger__["a" /* default */])('ak-mention-picker.filterInfo', info);
            _this.setState({
                info: info,
            });
        };
        _this.handleMentionListRef = function (ref) {
            _this.mentionListRef = ref;
        };
        _this.subscriberKey = Object(__WEBPACK_IMPORTED_MODULE_6__util_id__["a" /* default */])('ak-mention-picker');
        _this.state = {
            visible: false,
        };
        _this.applyPropChanges({}, props);
        return _this;
    }
    MentionPicker.prototype.componentDidMount = function () {
        this.subscribeResourceProvider(this.props.resourceProvider);
    };
    MentionPicker.prototype.componentWillReceiveProps = function (nextProps) {
        this.applyPropChanges(this.props, nextProps);
    };
    MentionPicker.prototype.componentWillUnmount = function () {
        this.unsubscribeResourceProvider(this.props.resourceProvider);
    };
    // Internal
    MentionPicker.prototype.applyPropChanges = function (prevProps, nextProps) {
        var oldResourceProvider = prevProps.resourceProvider;
        var newResourceProvider = nextProps.resourceProvider;
        var resourceProviderChanged = oldResourceProvider !== newResourceProvider;
        // resource provider
        if (resourceProviderChanged) {
            this.unsubscribeResourceProvider(oldResourceProvider);
            this.subscribeResourceProvider(newResourceProvider);
        }
    };
    MentionPicker.prototype.subscribeResourceProvider = function (resourceProvider) {
        if (resourceProvider) {
            resourceProvider.subscribe(this.subscriberKey, this.filterChange, this.filterError, this.filterInfo);
        }
    };
    MentionPicker.prototype.unsubscribeResourceProvider = function (resourceProvider) {
        if (resourceProvider) {
            resourceProvider.unsubscribe(this.subscriberKey);
        }
    };
    MentionPicker.prototype.render = function () {
        var _a = this.props, resourceProvider = _a.resourceProvider, presenceProvider = _a.presenceProvider, onSelection = _a.onSelection, query = _a.query, target = _a.target, position = _a.position, zIndex = _a.zIndex, offsetX = _a.offsetX, offsetY = _a.offsetY;
        var _b = this.state, visible = _b.visible, info = _b.info;
        var resourceMentionList = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ResourcedMentionList__["a" /* default */], { resourceProvider: resourceProvider, presenceProvider: presenceProvider, onSelection: onSelection, query: query, ref: this.handleMentionListRef }));
        var infoContent = info && !visible ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* MentionPickerInfoStyle */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", null, info))) : null;
        var content;
        if (position) {
            Object(__WEBPACK_IMPORTED_MODULE_5__util_logger__["a" /* default */])('target, position', target, position);
            if (target) {
                content = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Popup__["a" /* default */], { target: target, relativePosition: position, zIndex: zIndex, offsetX: offsetX, offsetY: offsetY },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                        resourceMentionList,
                        infoContent)));
            }
            else {
                // don't show if we have a position, but no target yet
                content = null;
            }
        }
        else {
            content = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                resourceMentionList,
                infoContent));
        }
        return (
        /* old classnames are essential for Confluence tests */
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* MentionPickerStyle */], { className: "ak-mention-picker", visible: visible || info }, content));
    };
    MentionPicker.defaultProps = {
        onSelection: function () { },
        onOpen: function () { },
        onClose: function () { },
    };
    return MentionPicker;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

var MentionPickerWithAnalytics = Object(__WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__["withAnalyticsEvents"])({})(MentionPicker);
/* unused harmony default export */ var _unused_webpack_default_export = (MentionPickerWithAnalytics);
//# sourceMappingURL=index.js.map

/***/ }),
/* 1927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MentionPickerStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MentionPickerInfoStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_styles__ = __webpack_require__(404);




var MentionPickerStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: ", ";\n"], ["\n  display: ",
    ";\n"])), function (props) {
    return props.visible ? 'block' : 'none';
});
var MentionPickerInfoStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  background: #fff;\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  display: block;\n  width: ", ";\n  white-space: nowrap;\n\n  & {\n    p {\n      margin: 0;\n      overflow: hidden;\n      padding: 9px;\n      text-overflow: ellipsis;\n    }\n  }\n"], ["\n  background: #fff;\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  display: block;\n  width: ", ";\n  white-space: nowrap;\n\n  & {\n    p {\n      margin: 0;\n      overflow: hidden;\n      padding: 9px;\n      text-overflow: ellipsis;\n    }\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N100, __WEBPACK_IMPORTED_MODULE_3__shared_styles__["b" /* noDialogContainerBorderColor */], __WEBPACK_IMPORTED_MODULE_3__shared_styles__["c" /* noDialogContainerBorderRadius */], __WEBPACK_IMPORTED_MODULE_3__shared_styles__["d" /* noDialogContainerBoxShadow */], __WEBPACK_IMPORTED_MODULE_3__shared_styles__["a" /* mentionListWidth */]);
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 1928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);



/*
 * Simple implementation of popup while waiting for ak-inline-dialog
 */
var Popup = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Popup, _super);
    function Popup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Popup.prototype.componentDidMount = function () {
        this.popup = document.createElement('div');
        document.body.appendChild(this.popup);
        this.popup.style.position = 'absolute';
        this._applyAbsolutePosition();
        this._renderContent();
    };
    Popup.prototype.componentDidUpdate = function () {
        this._renderContent();
    };
    Popup.prototype.componentWillUnmount = function () {
        __WEBPACK_IMPORTED_MODULE_2_react_dom__["unmountComponentAtNode"](this.popup);
        document.body.removeChild(this.popup);
    };
    Popup.prototype._applyBelowPosition = function () {
        var targetNode = this.props.target && document.getElementById(this.props.target);
        if (targetNode) {
            var box = targetNode.getBoundingClientRect();
            var top_1 = box.bottom + (this.props.offsetY || 0);
            var left = box.left + (this.props.offsetX || 0);
            this.popup.style.top = top_1 + "px";
            this.popup.style.bottom = '';
            this.popup.style.left = left + "px";
        }
    };
    Popup.prototype._applyAbovePosition = function () {
        var targetNode = this.props.target && document.getElementById(this.props.target);
        if (targetNode) {
            var box = targetNode.getBoundingClientRect();
            var bottom = window.innerHeight - box.top + (this.props.offsetY || 0);
            var left = box.left + (this.props.offsetX || 0);
            this.popup.style.top = '';
            this.popup.style.bottom = bottom + "px";
            this.popup.style.left = left + "px";
        }
    };
    Popup.prototype._applyAbsolutePosition = function () {
        if (this.props.relativePosition === 'above') {
            this._applyAbovePosition();
        }
        else if (this.props.relativePosition === 'below') {
            this._applyBelowPosition();
        }
        else {
            var targetNode = this.props.target && document.getElementById(this.props.target);
            if (targetNode) {
                var box = targetNode.getBoundingClientRect();
                var viewPortHeight = window.innerHeight;
                if (box.top < viewPortHeight / 2) {
                    this._applyBelowPosition();
                }
                else {
                    this._applyAbovePosition();
                }
            }
        }
        if (this.props.zIndex) {
            this.popup.style.zIndex = "" + this.props.zIndex;
        }
    };
    Popup.prototype._renderContent = function () {
        __WEBPACK_IMPORTED_MODULE_2_react_dom__["render"](this.props.children, this.popup);
    };
    Popup.prototype.render = function () {
        // Placeholder element for react to render inplace
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null);
    };
    Popup.defaultProps = {
        relativePosition: 'auto',
        offsetX: 0,
        offsetY: 0,
        zIndex: 0,
    };
    return Popup;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Popup);
//# sourceMappingURL=index.js.map

/***/ }),
/* 1929 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/mention","version":"15.3.0","sideEffects":false}

/***/ }),
/* 1930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MentionStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(132);




var mentionStyle = {};
mentionStyle[__WEBPACK_IMPORTED_MODULE_3__types__["a" /* MentionType */].SELF] = {
    background: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B400, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B200 }),
    border: 'transparent',
    text: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN30 }),
};
mentionStyle[__WEBPACK_IMPORTED_MODULE_3__types__["a" /* MentionType */].RESTRICTED] = {
    background: 'transparent',
    border: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N500, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN80 }),
    text: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N500, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN100 }),
};
mentionStyle[__WEBPACK_IMPORTED_MODULE_3__types__["a" /* MentionType */].DEFAULT] = {
    background: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30A, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN80 }),
    border: 'transparent',
    text: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N500, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN800 }),
};
var getStyle = function (props, property) {
    var obj = mentionStyle[props.mentionType][property];
    // themed() returns a function
    return typeof obj === 'string' ? obj : obj(props);
};
var MentionStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) { return "\n  display: inline;\n  background: " + getStyle(props, 'background') + ";\n  border: 1px solid " + getStyle(props, 'border') + ";\n  border-radius: 20px;\n  color: " + getStyle(props, 'text') + ";\n  cursor: pointer;\n  padding: 0 0.3em 2px 0.23em;\n  line-height: 1.714;\n  font-size: 1em;\n  font-weight: normal;\n  word-break: break-word;\n"; });
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 1931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(724);



var ResourcedMention = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ResourcedMention, _super);
    function ResourcedMention(props) {
        var _this = _super.call(this, props) || this;
        _this.handleMentionProvider = function (props) {
            var id = props.id, mentionProvider = props.mentionProvider;
            if (mentionProvider) {
                mentionProvider
                    .then(function (provider) {
                    _this.setState({
                        isHighlighted: provider.shouldHighlightMention({ id: id }),
                    });
                })
                    .catch(function (e) {
                    _this.setState({
                        isHighlighted: false,
                    });
                });
            }
            else {
                _this.setState({
                    isHighlighted: false,
                });
            }
        };
        _this.state = {
            isHighlighted: false,
        };
        return _this;
    }
    ResourcedMention.prototype.componentDidMount = function () {
        this.handleMentionProvider(this.props);
    };
    ResourcedMention.prototype.componentWillReceiveProps = function (nextProps) {
        var props = this.props;
        if (props.id !== nextProps.id ||
            props.mentionProvider !== nextProps.mentionProvider) {
            this.handleMentionProvider(nextProps);
        }
    };
    ResourcedMention.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2____["a" /* default */], { id: props.id, text: props.text, isHighlighted: state.isHighlighted, accessLevel: props.accessLevel, onClick: props.onClick, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave }));
    };
    return ResourcedMention;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (ResourcedMention);
//# sourceMappingURL=ResourcedMention.js.map

/***/ }),
/* 1932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(1933);


/**
 * This component is stateful and should be instantianted per contextIdentifiers.
 */
var ContextMentionResource = /** @class */ (function () {
    function ContextMentionResource(mentionProvider, contextIdentifier) {
        var _this = this;
        this.callWithContextIds = function (f, declaredArgs) { return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _a;
            var argsLength = args ? args.length : 0;
            // cover the scenario where optional parameters are not passed
            // by passing undefined instead to keep the contextIdentifiers parameter in the right position
            var mentionArgs = argsLength !== declaredArgs
                ? Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* padArray */])(args, declaredArgs - argsLength, undefined)
                : args;
            return (_a = _this.mentionProvider)[f].apply(_a, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](mentionArgs, [_this.contextIdentifier]));
        }; };
        this.callDefault = function (f) { return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _a;
            return (_a = _this.mentionProvider)[f].apply(_a, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](args));
        }; };
        this.subscribe = this.callDefault('subscribe');
        this.unsubscribe = this.callDefault('unsubscribe');
        this.filter = this.callWithContextIds('filter', 1);
        this.recordMentionSelection = this.callWithContextIds('recordMentionSelection', 1);
        this.shouldHighlightMention = this.callDefault('shouldHighlightMention');
        this.isFiltering = this.callDefault('isFiltering');
        this.mentionProvider = mentionProvider;
        this.contextIdentifier = contextIdentifier;
    }
    ContextMentionResource.prototype.getContextIdentifier = function () {
        return this.contextIdentifier;
    };
    return ContextMentionResource;
}());
/* unused harmony default export */ var _unused_webpack_default_export = (ContextMentionResource);
//# sourceMappingURL=ContextMentionResource.js.map

/***/ }),
/* 1933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return padArray; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

var padArray = function (arr, size, value) {
    if (size === 0) {
        return arr;
    }
    var gap = new Array(size);
    gap.fill(value);
    return arr.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](arr, gap) : gap;
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 1934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_mention__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_profilecard__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Popup__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__with_outer_listeners__ = __webpack_require__(733);








// tslint:disable-next-line:variable-name
var ProfilecardResourcedWithListeners = Object(__WEBPACK_IMPORTED_MODULE_6__with_outer_listeners__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__atlaskit_profilecard__["a" /* default */]);
var MentionWithProfileCard = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionWithProfileCard, _super);
    function MentionWithProfileCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            target: null,
            visible: false,
            popupAlignX: 'left',
            popupAlignY: 'top',
        };
        _this.handleRef = function (target) {
            _this.setState({ target: target });
        };
        _this.handleMentionNodeRef = function (component) {
            if (!component) {
                _this.domNode = null;
            }
            else {
                _this.domNode = Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(component);
            }
        };
        _this.showProfilecard = function () {
            if (!_this.domNode) {
                return;
            }
            var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](_this.calculateLayerPosition(), 2), popupAlignX = _a[0], popupAlignY = _a[1];
            _this.setState({
                popupAlignX: popupAlignX,
                popupAlignY: popupAlignY,
                visible: true,
            });
        };
        _this.hideProfilecard = function () {
            _this.setState({ visible: false });
        };
        return _this;
    }
    MentionWithProfileCard.prototype.calculateLayerPosition = function () {
        var domNodeCentreCoords = this.getDomNodeCenterCoords();
        var visibleAreaCentreCoords = this.getVisibleAreaCentreCoords();
        var popupAlignY = domNodeCentreCoords.y > visibleAreaCentreCoords.y ? 'top' : 'bottom';
        var popupAlignX = domNodeCentreCoords.x > visibleAreaCentreCoords.x ? 'right' : 'left';
        return [popupAlignX, popupAlignY];
    };
    MentionWithProfileCard.prototype.getDomNodeCenterCoords = function () {
        var rect = this.domNode.getBoundingClientRect();
        return {
            x: rect.left + rect.width / 2,
            y: rect.top + rect.height / 2,
        };
    };
    MentionWithProfileCard.prototype.getVisibleAreaCentreCoords = function () {
        return {
            x: window.innerWidth / 2,
            y: window.innerHeight / 2,
        };
    };
    MentionWithProfileCard.prototype.getActions = function (id, text, accessLevel) {
        var _this = this;
        var profilecardProvider = this.props.profilecardProvider;
        var actions = profilecardProvider.getActions(id, text, accessLevel);
        return actions.map(function (action) {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, action, { callback: function () {
                    _this.setState({ visible: false });
                    action.callback();
                } });
        });
    };
    MentionWithProfileCard.prototype.render = function () {
        var _a = this.props, accessLevel = _a.accessLevel, id = _a.id, mentionProvider = _a.mentionProvider, profilecardProvider = _a.profilecardProvider, text = _a.text, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, portal = _a.portal;
        var _b = this.state, popupAlignX = _b.popupAlignX, popupAlignY = _b.popupAlignY, target = _b.target, visible = _b.visible;
        var cloudId = profilecardProvider.cloudId, resourceClient = profilecardProvider.resourceClient;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { ref: this.handleRef, onClick: this.showProfilecard },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_mention__["c" /* ResourcedMention */], { ref: this.handleMentionNodeRef, id: id, text: text, accessLevel: accessLevel, mentionProvider: mentionProvider, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }),
            target && portal && visible && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Popup__["a" /* default */], { offset: [0, 8], target: target, mountTo: portal, alignX: popupAlignX, alignY: popupAlignY },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ProfilecardResourcedWithListeners, { handleClickOutside: this.hideProfilecard, handleEscapeKeydown: this.hideProfilecard, cloudId: cloudId, userId: id, resourceClient: resourceClient, actions: this.getActions(id, text, accessLevel) })))));
    };
    return MentionWithProfileCard;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (MentionWithProfileCard);
//# sourceMappingURL=mention-with-profilecard.js.map

/***/ }),
/* 1935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_cross_circle__ = __webpack_require__(1936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_cross_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_cross_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styled_Error__ = __webpack_require__(1938);












var ErrorMessage =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(ErrorMessage, _PureComponent);

  function ErrorMessage() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ErrorMessage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ErrorMessage)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "renderNotFound", function () {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styled_Error__["b" /* ErrorTitle */], null, "The user is no longer available for the site");
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "renderDefault", function () {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styled_Error__["b" /* ErrorTitle */], null, "Oops, looks like we\u2019re having issues", __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("br", null), _this.props.reload ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styled_Error__["a" /* ErrorText */], null, "Try again and we\u2019ll give it another shot") : null);
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "renderRetryButton", function () {
      return _this.props.reload ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__atlaskit_button__["default"], {
        appearance: "link",
        compact: true,
        onClick: _this.props.reload
      }, "Try again") : null;
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ErrorMessage, [{
    key: "renderErrorContent",
    value: function renderErrorContent() {
      var errorType = this.props.errorType || {
        reason: 'default'
      };

      switch (errorType.reason) {
        case 'NotFound':
          return this.renderNotFound();

        default:
          return this.renderDefault();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styled_Error__["c" /* ErrorWrapper */], null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_cross_circle___default.a, {
        label: "icon error",
        size: "xlarge"
      }), this.renderErrorContent(), this.renderRetryButton());
    }
  }]);

  return ErrorMessage;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ErrorMessage, "defaultProps", {
  errorType: {
    reason: 'default'
  }
});



/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(160));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CrossCircleIcon = function CrossCircleIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill-rule=\"evenodd\"><circle fill=\"currentColor\" cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M13.477 9.113l-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41z\" fill=\"inherit\"/><path d=\"M9.084 10.501l4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411z\" fill=\"inherit\"/></g></svg>"
  }, props));
};

CrossCircleIcon.displayName = 'CrossCircleIcon';
var _default = CrossCircleIcon;
exports.default = _default;

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = void 0;
var sizes = {
  small: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '48px'
};
exports.sizes = sizes;

/***/ }),
/* 1938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ErrorWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ErrorTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled_constants__ = __webpack_require__(406);



var ErrorWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Error__ErrorWrapper",
  componentId: "sc-1sg8cu3-0"
})(["\n  text-align: center;\n  padding: ", "px;\n  color: ", ";\n"], __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"], 3), __WEBPACK_IMPORTED_MODULE_2__styled_constants__["d" /* errorIconColor */]);
var ErrorTitle = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].p.withConfig({
  displayName: "Error__ErrorTitle",
  componentId: "sc-1sg8cu3-1"
})(["\n  color: ", ";\n  line-height: ", "px;\n  margin: ", "px 0;\n"], __WEBPACK_IMPORTED_MODULE_2__styled_constants__["f" /* errorTitleColor */], __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"], 3), __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"]);
var ErrorText = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "Error__ErrorText",
  componentId: "sc-1sg8cu3-2"
})(["\n  color: ", ";\n"], __WEBPACK_IMPORTED_MODULE_2__styled_constants__["e" /* errorTextColor */]);

/***/ }),
/* 1939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeightTransitionWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styled_constants__ = __webpack_require__(406);











var CardAnimationWrapper = __WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div.withConfig({
  displayName: "HeightTransitionWrapper__CardAnimationWrapper",
  componentId: "z7e07w-0"
})(["\n  background-color: ", ";\n  border-radius: ", "px;\n  ", ";\n  cursor: default;\n  font-family: ", ";\n  font-size: ", "px;\n  overflow: hidden;\n  position: relative;\n  transition: height 0.25s ease;\n  width: ", "px;\n"], __WEBPACK_IMPORTED_MODULE_10__styled_constants__["c" /* bgColor */], __WEBPACK_IMPORTED_MODULE_9__atlaskit_theme__["borderRadius"], function (props) {
  return props.customElevation && __WEBPACK_IMPORTED_MODULE_9__atlaskit_theme__["elevation"][props.customElevation] ? __WEBPACK_IMPORTED_MODULE_9__atlaskit_theme__["elevation"][props.customElevation] : __WEBPACK_IMPORTED_MODULE_9__atlaskit_theme__["elevation"].e200;
}, __WEBPACK_IMPORTED_MODULE_9__atlaskit_theme__["fontFamily"], __WEBPACK_IMPORTED_MODULE_9__atlaskit_theme__["fontSize"], __WEBPACK_IMPORTED_MODULE_9__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_9__atlaskit_theme__["gridSize"], 45));

var HeightTransitionWrapper =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(HeightTransitionWrapper, _PureComponent);

  function HeightTransitionWrapper() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, HeightTransitionWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(HeightTransitionWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "ref", void 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      height: 'auto'
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(HeightTransitionWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateRefHeight();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateRefHeight();
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "preventDefault",
    value: function preventDefault(event) {
      event.persist();
      event.preventDefault();
    }
  }, {
    key: "updateRefHeight",
    value: function updateRefHeight() {
      this.setState({
        height: this.ref && this.ref.children.length ? this.ref.children[0].offsetHeight : 'auto'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var customElevation = this.props.customElevation;
      var inlineHeight = {
        height: this.state.height
      };
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(CardAnimationWrapper, {
        customElevation: customElevation,
        style: inlineHeight,
        innerRef: function innerRef(ref) {
          _this2.ref = ref;
        },
        onClick: this.preventDefault
      }, this.props.children);
    }
  }]);

  return HeightTransitionWrapper;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);



/***/ }),
/* 1940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_location__ = __webpack_require__(1941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_location___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_location__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_recent__ = __webpack_require__(1942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_recent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_recent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_mention__ = __webpack_require__(1943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_mention___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_mention__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_email__ = __webpack_require__(1944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_email__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_icon_glyph_office_building__ = __webpack_require__(1945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_icon_glyph_office_building___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__atlaskit_icon_glyph_office_building__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__atlaskit_avatar__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styled_Card__ = __webpack_require__(726);














var icons = {
  location: __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_location___default.a,
  time: __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_recent___default.a,
  mention: __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_mention___default.a,
  email: __WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_email___default.a,
  companyName: __WEBPACK_IMPORTED_MODULE_11__atlaskit_icon_glyph_office_building___default.a,
  available: function available() {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__atlaskit_avatar__["c" /* Presence */], {
      presence: "online",
      borderColor: "transparent"
    });
  },
  unavailable: function unavailable() {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__atlaskit_avatar__["c" /* Presence */], {
      presence: "offline",
      borderColor: "transparent"
    });
  },
  busy: function busy() {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__atlaskit_avatar__["c" /* Presence */], {
      presence: "busy",
      borderColor: "transparent"
    });
  },
  focus: function focus() {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__atlaskit_avatar__["c" /* Presence */], {
      presence: "focus",
      borderColor: "transparent"
    });
  }
};

var IconLabel =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(IconLabel, _PureComponent);

  function IconLabel() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, IconLabel);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(IconLabel).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(IconLabel, [{
    key: "render",
    value: function render() {
      if (!this.props.children) {
        return null;
      }

      var IconElement = this.props.icon && icons[this.props.icon];
      var displayIcon = IconElement ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(IconElement, {
        label: "icon ".concat(this.props.icon),
        size: "small"
      }) : null;
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled_Card__["g" /* DetailsLabel */], null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled_Card__["h" /* DetailsLabelIcon */], null, displayIcon), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled_Card__["i" /* DetailsLabelText */], null, this.props.children));
    }
  }]);

  return IconLabel;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(IconLabel, "defaultProps", {
  icon: ''
});



/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(160));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var LocationIcon = function LocationIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M12 21c-2.28 0-6-8.686-6-12a6 6 0 1 1 12 0c0 3.314-3.72 12-6 12zm0-9a2.912 2.912 0 1 0 0-5.824A2.912 2.912 0 0 0 12 12z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

LocationIcon.displayName = 'LocationIcon';
var _default = LocationIcon;
exports.default = _default;

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(160));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var RecentIcon = function RecentIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M11 8.002v4.002c0 .28.116.53.301.712l2.47 2.47a1.003 1.003 0 0 0 1.414 0 1.003 1.003 0 0 0 0-1.415L13 11.586V8.004A1.009 1.009 0 0 0 13 8V6a1 1 0 0 0-2 0v2.002zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

RecentIcon.displayName = 'RecentIcon';
var _default = RecentIcon;
exports.default = _default;

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(160));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var MentionIcon = function MentionIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M11.94 12H5.008A2.006 2.006 0 0 0 3 14v4.446c0 2.233 5.16 3.002 8.713 2.306A6.475 6.475 0 0 1 10.13 16.5c0-1.746.689-3.332 1.81-4.5z\"/><path d=\"M21.153 13.123c.795 1.036 1.042 2.316.69 3.603-.34 1.254-.95 2.077-1.814 2.446-1.139.486-2.2-.052-2.315-.114a2.21 2.21 0 0 1-.575-.482c-.448.328-.94.52-1.417.52a1.74 1.74 0 0 1-.832-.206 1.837 1.837 0 0 1-.883-1.12c-.21-.715-.08-1.574.357-2.358.718-1.288 2.168-1.882 3.23-1.335.058.028.094.082.147.117a.85.85 0 0 1 .808-.1c.442.18.654.683.471 1.123l-.072.173c-.438 1.052-.768 1.94-.386 2.168.005 0 .423.19.795.029.343-.154.627-.607.82-1.313.21-.778.077-1.488-.397-2.106-.675-.879-1.953-1.446-3.255-1.446-2.093 0-3.796 1.694-3.796 3.778 0 2.083 1.703 3.78 3.796 3.78.478 0 .865.385.865.86s-.387.86-.865.86C13.478 22 11 19.533 11 16.5s2.478-5.5 5.525-5.5c1.848 0 3.622.814 4.628 2.123zm-3.898 3.757c.413-.738.354-1.466-.141-1.72-.522-.267-1.274.129-1.637.776-.414.737-.35 1.545.14 1.806.491.26 1.224-.126 1.638-.863z\"/><circle cx=\"9\" cy=\"7\" r=\"4\"/></g></svg>"
  }, props));
};

MentionIcon.displayName = 'MentionIcon';
var _default = MentionIcon;
exports.default = _default;

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(160));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EmailIcon = function EmailIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M5 7v10h14V7H5zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h14z\" fill-rule=\"nonzero\"/><path d=\"M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.119 1.119 0 0 1-1.583 0L5.498 6.5z\"/></g></svg>"
  }, props));
};

EmailIcon.displayName = 'EmailIcon';
var _default = EmailIcon;
exports.default = _default;

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(160));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var OfficeBuildingIcon = function OfficeBuildingIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M8 6H5.009C3.902 6 3 6.962 3 8.15v10.7C3 20.04 3.9 21 5.009 21h5.487H8v-2.145c-1.616-.001-3-.003-3-.004 0 0 .005-10.708.009-10.708L8 8.144V6z\" fill-rule=\"nonzero\"/><path d=\"M12 7h2v2h-2zm-6 3h2v2H6zm0 3h2v2H6zm6-3h2v2h-2zm0 3h2v2h-2zm2 3h2v3h-2zm2-9h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z\"/><path d=\"M18.991 19C18.998 19 19 4.995 19 4.995c0 .006-7.991.005-7.991.005C11.002 5 11 19 11 19h7.991zM9 4.995C9 3.893 9.902 3 11.009 3h7.982C20.101 3 21 3.893 21 4.995v14.01A2.004 2.004 0 0 1 18.991 21H9V4.995z\" fill-rule=\"nonzero\"/></g></svg>"
  }, props));
};

OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var _default = OfficeBuildingIcon;
exports.default = _default;

/***/ }),
/* 1946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__internal_i18n_util__ = __webpack_require__(1947);









var MessagesIntlProvider =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(MessagesIntlProvider, _PureComponent);

  function MessagesIntlProvider() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, MessagesIntlProvider);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(MessagesIntlProvider).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(MessagesIntlProvider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          intl = _this$props.intl,
          children = _this$props.children;
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["IntlProvider"], {
        messages: Object(__WEBPACK_IMPORTED_MODULE_7__internal_i18n_util__["a" /* getMessagesForLocale */])(intl.locale)
      }, children);
    }
  }]);

  return MessagesIntlProvider;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_intl__["injectIntl"])(MessagesIntlProvider));

/***/ }),
/* 1947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMessagesForLocale; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n__ = __webpack_require__(1948);



var localesMessagesMap = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, __WEBPACK_IMPORTED_MODULE_1__i18n__, {
  'pt-BR': __WEBPACK_IMPORTED_MODULE_1__i18n__["pt_BR"],
  // should resolve pt-BR and pt_BR
  'pt-PT': __WEBPACK_IMPORTED_MODULE_1__i18n__["pt_PT"]
});
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */


var getMessagesForLocale = function getMessagesForLocale(locale) {
  var messages = localesMessagesMap[locale];

  if (!messages) {
    var parentLocale = locale.split(/[-_]/)[0];
    messages = localesMessagesMap[parentLocale];
  }

  if (!messages) {
    messages = __WEBPACK_IMPORTED_MODULE_1__i18n__["en"];
  }

  return messages;
};

/***/ }),
/* 1948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zh__ = __webpack_require__(1949);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "zh", function() { return __WEBPACK_IMPORTED_MODULE_0__zh__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cs__ = __webpack_require__(1950);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cs", function() { return __WEBPACK_IMPORTED_MODULE_1__cs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__da__ = __webpack_require__(1951);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "da", function() { return __WEBPACK_IMPORTED_MODULE_2__da__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nl__ = __webpack_require__(1952);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "nl", function() { return __WEBPACK_IMPORTED_MODULE_3__nl__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__en__ = __webpack_require__(1953);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "en", function() { return __WEBPACK_IMPORTED_MODULE_4__en__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__en_GB__ = __webpack_require__(1954);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "en_GB", function() { return __WEBPACK_IMPORTED_MODULE_5__en_GB__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__et__ = __webpack_require__(1955);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "et", function() { return __WEBPACK_IMPORTED_MODULE_6__et__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fi__ = __webpack_require__(1956);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fi", function() { return __WEBPACK_IMPORTED_MODULE_7__fi__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fr__ = __webpack_require__(1957);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fr", function() { return __WEBPACK_IMPORTED_MODULE_8__fr__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__de__ = __webpack_require__(1958);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "de", function() { return __WEBPACK_IMPORTED_MODULE_9__de__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hu__ = __webpack_require__(1959);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hu", function() { return __WEBPACK_IMPORTED_MODULE_10__hu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__is__ = __webpack_require__(1960);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "is", function() { return __WEBPACK_IMPORTED_MODULE_11__is__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__it__ = __webpack_require__(1961);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "it", function() { return __WEBPACK_IMPORTED_MODULE_12__it__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ja__ = __webpack_require__(1962);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ja", function() { return __WEBPACK_IMPORTED_MODULE_13__ja__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ko__ = __webpack_require__(1963);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ko", function() { return __WEBPACK_IMPORTED_MODULE_14__ko__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__nb__ = __webpack_require__(1964);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "nb", function() { return __WEBPACK_IMPORTED_MODULE_15__nb__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pl__ = __webpack_require__(1965);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pl", function() { return __WEBPACK_IMPORTED_MODULE_16__pl__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pt_BR__ = __webpack_require__(1966);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pt_BR", function() { return __WEBPACK_IMPORTED_MODULE_17__pt_BR__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pt_PT__ = __webpack_require__(1967);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pt_PT", function() { return __WEBPACK_IMPORTED_MODULE_18__pt_PT__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ro__ = __webpack_require__(1968);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ro", function() { return __WEBPACK_IMPORTED_MODULE_19__ro__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ru__ = __webpack_require__(1969);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ru", function() { return __WEBPACK_IMPORTED_MODULE_20__ru__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__sk__ = __webpack_require__(1970);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sk", function() { return __WEBPACK_IMPORTED_MODULE_21__sk__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__es__ = __webpack_require__(1971);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "es", function() { return __WEBPACK_IMPORTED_MODULE_22__es__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__sv__ = __webpack_require__(1972);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sv", function() { return __WEBPACK_IMPORTED_MODULE_23__sv__["a"]; });

























/***/ }),
/* 1949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Chinese
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': '账户已停用',
  'pt.profile-card.general.msg.disabled.user': '您无法再与此人合作。',
  'pt.profile-card.inactive.account.no.date': '他的账户已被停用。',
  'pt.profile-card.inactive.account.has.date.this.week': '他的账户本周已被停用。',
  'pt.profile-card.inactive.account.has.date.this.month': '他的账户本月已被停用。',
  'pt.profile-card.inactive.account.has.date.last.month': '他的账户上月已被停用。',
  'pt.profile-card.inactive.account.has.date.a.few.months': '他的账户已被停用数月。',
  'pt.profile-card.inactive.account.has.date.several.months': '他的账户已被停用数月。',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': '他的账户已被停用超过一年。',
  'pt.profile-card.closed.account': '账户已被删除',
  'pt.profile-card.closed.account.no.date': '他的账户已被删除。',
  'pt.profile-card.closed.account.has.date.this.week': '他的账户本周已被删除。',
  'pt.profile-card.closed.account.has.date.this.month': '他的账户本月已被删除。',
  'pt.profile-card.closed.account.has.date.last.month': '他的账户上月已被删除。',
  'pt.profile-card.closed.account.has.date.a.few.months': '他的账户已被删除数月。',
  'pt.profile-card.closed.account.has.date.several.months': '他的账户已被删除数月。',
  'pt.profile-card.closed.account.has.date.more.than.a.year': '他的账户已被删除超过一年。',
  'pt.profile-card.disabled.account.default.name': '前用户'
});

/***/ }),
/* 1950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Czech
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': 'Deaktivovaný účet',
  'pt.profile-card.general.msg.disabled.user': 'S touto osobou již nemůžete spolupracovat.',
  'pt.profile-card.inactive.account.no.date': 'Účet uživatele byl deaktivován.',
  'pt.profile-card.inactive.account.has.date.this.week': 'Účet uživatele byl deaktivován tento týden.',
  'pt.profile-card.inactive.account.has.date.this.month': 'Účet uživatele byl tento měsíc deaktivován.',
  'pt.profile-card.inactive.account.has.date.last.month': 'Účet uživatele byl deaktivován minulý měsíc.',
  'pt.profile-card.inactive.account.has.date.a.few.months': 'Účet uživatele je deaktivovaný již několik měsíců.',
  'pt.profile-card.inactive.account.has.date.several.months': 'Účet uživatele je deaktivovaný již několik měsíců.',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': 'Účet uživatele je deaktivovaný více než rok.',
  'pt.profile-card.closed.account': 'Smazaný účet',
  'pt.profile-card.closed.account.no.date': 'Účet uživatele byl smazán.',
  'pt.profile-card.closed.account.has.date.this.week': 'Účet uživatele byl smazán tento týden.',
  'pt.profile-card.closed.account.has.date.this.month': 'Účet uživatele byl tento měsíc smazán.',
  'pt.profile-card.closed.account.has.date.last.month': 'Účet uživatele byl minulý měsíc smazán.',
  'pt.profile-card.closed.account.has.date.a.few.months': 'Účet uživatele je smazaný již několik měsíců.',
  'pt.profile-card.closed.account.has.date.several.months': 'Účet uživatele je smazaný již několik měsíců.',
  'pt.profile-card.closed.account.has.date.more.than.a.year': 'Účet uživatele je smazaný více než rok.',
  'pt.profile-card.disabled.account.default.name': 'Bývalý uživatel'
});

/***/ }),
/* 1951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Danish
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': 'Konto deaktiveret',
  'pt.profile-card.general.msg.disabled.user': 'Du kan ikke længere samarbejde med denne person.',
  'pt.profile-card.inactive.account.no.date': 'Personens konto er blevet deaktiveret.',
  'pt.profile-card.inactive.account.has.date.this.week': 'Personens konto blev deaktiveret i denne uge.',
  'pt.profile-card.inactive.account.has.date.this.month': 'Personens konto blev deaktiveret i denne måned.',
  'pt.profile-card.inactive.account.has.date.last.month': 'Personens konto blev deaktiveret i sidste måned.',
  'pt.profile-card.inactive.account.has.date.a.few.months': 'Personens konto har været deaktiveret i nogle måneder.',
  'pt.profile-card.inactive.account.has.date.several.months': 'Personens konto har været deaktiveret i adskillige måneder.',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': 'Personens konto har været deaktiveret i over et år.',
  'pt.profile-card.closed.account': 'Konto slettet',
  'pt.profile-card.closed.account.no.date': 'Personens konto er blevet slettet.',
  'pt.profile-card.closed.account.has.date.this.week': 'Personens konto blev slettet i denne uge.',
  'pt.profile-card.closed.account.has.date.this.month': 'Personens konto blev slettet i denne måned.',
  'pt.profile-card.closed.account.has.date.last.month': 'Personens konto blev slettet i sidste måned.',
  'pt.profile-card.closed.account.has.date.a.few.months': 'Personens konto har været slettet i nogle måneder.',
  'pt.profile-card.closed.account.has.date.several.months': 'Personens konto har været slettet i adskillige måneder.',
  'pt.profile-card.closed.account.has.date.more.than.a.year': 'Personens konto har været slettet i over et år.',
  'pt.profile-card.disabled.account.default.name': 'Forhenværende bruger'
});

/***/ }),
/* 1952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Dutch
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': 'Account gedeactiveerd',
  'pt.profile-card.general.msg.disabled.user': 'Je kunt niet meer samenwerken met deze persoon.',
  'pt.profile-card.inactive.account.no.date': 'Zijn/haar account is gedeactiveerd.',
  'pt.profile-card.inactive.account.has.date.this.week': 'Zijn/haar account is deze week gedeactiveerd.',
  'pt.profile-card.inactive.account.has.date.this.month': 'Zijn/haar account is deze maand gedeactiveerd.',
  'pt.profile-card.inactive.account.has.date.last.month': 'Zijn/haar account is vorige maand gedeactiveerd.',
  'pt.profile-card.inactive.account.has.date.a.few.months': 'Zijn/haar account is een paar maanden geleden gedeactiveerd.',
  'pt.profile-card.inactive.account.has.date.several.months': 'Zijn/haar account is een paar maanden geleden gedeactiveerd.',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': 'Zijn/haar account is ruim een jaar geleden gedeactiveerd.',
  'pt.profile-card.closed.account': 'Account verwijderd',
  'pt.profile-card.closed.account.no.date': 'Zijn/haar account is verwijderd.',
  'pt.profile-card.closed.account.has.date.this.week': 'Zijn/haar account is deze week verwijderd.',
  'pt.profile-card.closed.account.has.date.this.month': 'Zijn/haar account is deze maand verwijderd.',
  'pt.profile-card.closed.account.has.date.last.month': 'Zijn/haar account is vorige maand verwijderd.',
  'pt.profile-card.closed.account.has.date.a.few.months': 'Zijn/haar account is een paar maanden geleden verwijderd.',
  'pt.profile-card.closed.account.has.date.several.months': 'Zijn/haar account is een paar maanden geleden verwijderd.',
  'pt.profile-card.closed.account.has.date.more.than.a.year': 'Zijn/haar account is ruim een jaar geleden verwijderd.',
  'pt.profile-card.disabled.account.default.name': 'Voormalige gebruiker'
});

/***/ }),
/* 1953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// English
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': 'Account deactivated',
  'pt.profile-card.general.msg.disabled.user': 'You can no longer collaborate with this person.',
  'pt.profile-card.inactive.account.no.date': 'Their account has been deactivated.',
  'pt.profile-card.inactive.account.has.date.this.week': 'Their account was deactivated this week.',
  'pt.profile-card.inactive.account.has.date.this.month': 'Their account was deactivated this month.',
  'pt.profile-card.inactive.account.has.date.last.month': 'Their account was deactivated last month.',
  'pt.profile-card.inactive.account.has.date.a.few.months': 'Their account has been deactivated for a few months.',
  'pt.profile-card.inactive.account.has.date.several.months': 'Their account has been deactivated for several months.',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': 'Their account has been deactivated for more than a year.',
  'pt.profile-card.closed.account': 'Account deleted',
  'pt.profile-card.closed.account.no.date': 'Their account has been deleted.',
  'pt.profile-card.closed.account.has.date.this.week': 'Their account was deleted this week.',
  'pt.profile-card.closed.account.has.date.this.month': 'Their account was deleted this month.',
  'pt.profile-card.closed.account.has.date.last.month': 'Their account was deleted last month.',
  'pt.profile-card.closed.account.has.date.a.few.months': 'Their account has been deleted for a few months.',
  'pt.profile-card.closed.account.has.date.several.months': 'Their account has been deleted for several months.',
  'pt.profile-card.closed.account.has.date.more.than.a.year': 'Their account has been deleted for more than a year.',
  'pt.profile-card.disabled.account.default.name': 'Former user'
});

/***/ }),
/* 1954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// English (United Kingdom)
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': 'Account deactivated',
  'pt.profile-card.general.msg.disabled.user': 'You can no longer collaborate with this person.',
  'pt.profile-card.inactive.account.no.date': 'Their account has been deactivated.',
  'pt.profile-card.inactive.account.has.date.this.week': 'Their account was deactivated this week.',
  'pt.profile-card.inactive.account.has.date.this.month': 'Their account was deactivated this month.',
  'pt.profile-card.inactive.account.has.date.last.month': 'Their account was deactivated last month.',
  'pt.profile-card.inactive.account.has.date.a.few.months': 'Their account has been deactivated for a few months.',
  'pt.profile-card.inactive.account.has.date.several.months': 'Their account has been deactivated for several months.',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': 'Their account has been deactivated for more than a year.',
  'pt.profile-card.closed.account': 'Account deleted',
  'pt.profile-card.closed.account.no.date': 'Their account has been deleted.',
  'pt.profile-card.closed.account.has.date.this.week': 'Their account was deleted this week.',
  'pt.profile-card.closed.account.has.date.this.month': 'Their account was deleted this month.',
  'pt.profile-card.closed.account.has.date.last.month': 'Their account was deleted last month.',
  'pt.profile-card.closed.account.has.date.a.few.months': 'Their account has been deleted for a few months.',
  'pt.profile-card.closed.account.has.date.several.months': 'Their account has been deleted for several months.',
  'pt.profile-card.closed.account.has.date.more.than.a.year': 'Their account has been deleted for more than a year.',
  'pt.profile-card.disabled.account.default.name': 'Former user'
});

/***/ }),
/* 1955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Estonian
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': 'Konto on deaktiveeritud',
  'pt.profile-card.general.msg.disabled.user': 'Te ei saa enam selle inimesega koostööd teha.',
  'pt.profile-card.inactive.account.no.date': 'Nende konto on deaktiveeritud.',
  'pt.profile-card.inactive.account.has.date.this.week': 'Nende konto deaktiveeriti sel nädalal.',
  'pt.profile-card.inactive.account.has.date.this.month': 'Nende konto deaktiveeriti sel kuul.',
  'pt.profile-card.inactive.account.has.date.last.month': 'Nende konto deaktiveeriti eelmisel kuul.',
  'pt.profile-card.inactive.account.has.date.a.few.months': 'Nende konto on olnud juba paar kuud deaktiveeritud.',
  'pt.profile-card.inactive.account.has.date.several.months': 'Nende konto on olnud juba mitu kuud deaktiveeritud.',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': 'Nende konto on olnud juba üle aasta deaktiveeritud.',
  'pt.profile-card.closed.account': 'Konto on kustutatud',
  'pt.profile-card.closed.account.no.date': 'Nende konto on kustutatud.',
  'pt.profile-card.closed.account.has.date.this.week': 'Nende konto kustutati sel nädalal.',
  'pt.profile-card.closed.account.has.date.this.month': 'Nende konto kustutati sel kuul.',
  'pt.profile-card.closed.account.has.date.last.month': 'Nende konto kustutati eelmisel kuul.',
  'pt.profile-card.closed.account.has.date.a.few.months': 'Nende konto on olnud juba paar kuud kustutatud.',
  'pt.profile-card.closed.account.has.date.several.months': 'Nende konto on olnud juba mitu kuud kustutatud.',
  'pt.profile-card.closed.account.has.date.more.than.a.year': 'Nende konto on olnud juba üle aasta kustutatud.',
  'pt.profile-card.disabled.account.default.name': 'Endine kasutaja'
});

/***/ }),
/* 1956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Finnish
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': 'Tili poistettu käytöstä',
  'pt.profile-card.general.msg.disabled.user': 'Et voi enää tehdä yhteistyötä tämän henkilön kanssa.',
  'pt.profile-card.inactive.account.no.date': 'Hänen tilinsä on poistettu käytöstä.',
  'pt.profile-card.inactive.account.has.date.this.week': 'Hänen tilinsä poistettiin käytöstä tällä viikolla.',
  'pt.profile-card.inactive.account.has.date.this.month': 'Hänen tilinsä poistettiin käytöstä tässä kuussa.',
  'pt.profile-card.inactive.account.has.date.last.month': 'Hänen tilinsä poistettiin käytöstä viime kuussa.',
  'pt.profile-card.inactive.account.has.date.a.few.months': 'Hänen tilinsä on ollut poissa käytöstä muutaman kuukauden ajan.',
  'pt.profile-card.inactive.account.has.date.several.months': 'Hänen tilinsä on ollut poissa käytöstä usean kuukauden ajan.',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': 'Hänen tilinsä on ollut poissa käytöstä yli vuoden.',
  'pt.profile-card.closed.account': 'Tili poistettu',
  'pt.profile-card.closed.account.no.date': 'Hänen tilinsä on poistettu.',
  'pt.profile-card.closed.account.has.date.this.week': 'Hänen tilinsä poistettiin tällä viikolla.',
  'pt.profile-card.closed.account.has.date.this.month': 'Hänen tilinsä poistettiin tässä kuussa.',
  'pt.profile-card.closed.account.has.date.last.month': 'Hänen tilinsä poistettiin viime kuussa.',
  'pt.profile-card.closed.account.has.date.a.few.months': 'Hänen tilinsä on ollut poistettuna muutaman kuukauden ajan.',
  'pt.profile-card.closed.account.has.date.several.months': 'Hänen tilinsä on ollut poistettuna usean kuukauden ajan.',
  'pt.profile-card.closed.account.has.date.more.than.a.year': 'Hänen tilinsä on ollut poistettuna yli vuoden.',
  'pt.profile-card.disabled.account.default.name': 'Entinen käyttäjä'
});

/***/ }),
/* 1957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// French
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': 'Compte désactivé',
  'pt.profile-card.general.msg.disabled.user': 'Vous ne pouvez plus collaborer avec cette personne.',
  'pt.profile-card.inactive.account.no.date': 'Son compte a été désactivé.',
  'pt.profile-card.inactive.account.has.date.this.week': 'Son compte a été désactivé cette semaine.',
  'pt.profile-card.inactive.account.has.date.this.month': 'Son compte a été désactivé ce mois-ci.',
  'pt.profile-card.inactive.account.has.date.last.month': 'Son compte a été désactivé le mois dernier.',
  'pt.profile-card.inactive.account.has.date.a.few.months': 'Son compte a été désactivé il y a quelques mois.',
  'pt.profile-card.inactive.account.has.date.several.months': 'Son compte a été désactivé il y a plusieurs mois.',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': "Son compte a été désactivé depuis plus d'un an.",
  'pt.profile-card.closed.account': 'Compte supprimé',
  'pt.profile-card.closed.account.no.date': 'Son compte a été supprimé.',
  'pt.profile-card.closed.account.has.date.this.week': 'Son compte a été supprimé cette semaine.',
  'pt.profile-card.closed.account.has.date.this.month': 'Son compte a été supprimé ce mois-ci.',
  'pt.profile-card.closed.account.has.date.last.month': 'Son compte a été supprimé le mois dernier.',
  'pt.profile-card.closed.account.has.date.a.few.months': 'Son compte a été supprimé il y a quelques mois.',
  'pt.profile-card.closed.account.has.date.several.months': 'Son compte a été supprimé il y a plusieurs mois.',
  'pt.profile-card.closed.account.has.date.more.than.a.year': "Son compte a été supprimé depuis plus d'un an.",
  'pt.profile-card.disabled.account.default.name': 'Ancien utilisateur'
});

/***/ }),
/* 1958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// German
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': 'Account deaktiviert',
  'pt.profile-card.general.msg.disabled.user': 'Sie können mit dieser Person nicht mehr zusammenarbeiten.',
  'pt.profile-card.inactive.account.no.date': 'Der Account dieser Person wurde deaktiviert.',
  'pt.profile-card.inactive.account.has.date.this.week': 'Der Account dieser Person wurde diese Woche deaktiviert.',
  'pt.profile-card.inactive.account.has.date.this.month': 'Der Account dieser Person wurde diesen Monat deaktiviert.',
  'pt.profile-card.inactive.account.has.date.last.month': 'Der Account dieser Person wurde letzten Monat deaktiviert.',
  'pt.profile-card.inactive.account.has.date.a.few.months': 'Der Account dieser Person wurde vor wenigen Monaten gelöscht.',
  'pt.profile-card.inactive.account.has.date.several.months': 'Der Account dieser Person wurde vor mehreren Monaten deaktiviert.',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': 'Der Account dieser Person wurde vor mehr als einem Jahr deaktiviert.',
  'pt.profile-card.closed.account': 'Account gelöscht',
  'pt.profile-card.closed.account.no.date': 'Der Account dieser Person wurde gelöscht.',
  'pt.profile-card.closed.account.has.date.this.week': 'Der Account dieser Person wurde diese Woche gelöscht.',
  'pt.profile-card.closed.account.has.date.this.month': 'Der Account dieser Person wurde diesen Monat gelöscht.',
  'pt.profile-card.closed.account.has.date.last.month': 'Der Account dieser Person wurde letzten Monat gelöscht.',
  'pt.profile-card.closed.account.has.date.a.few.months': 'Der Account dieser Person wurde vor wenigen Monaten gelöscht.',
  'pt.profile-card.closed.account.has.date.several.months': 'Der Account dieser Person wurde vor mehreren Monaten gelöscht.',
  'pt.profile-card.closed.account.has.date.more.than.a.year': 'Der Account dieser Person wurde vor mehr als einem Jahr gelöscht.',
  'pt.profile-card.disabled.account.default.name': 'Ehemaliger Benutzer'
});

/***/ }),
/* 1959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Hungarian
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': 'A fiók inaktiválva.',
  'pt.profile-card.general.msg.disabled.user': 'A továbbiakban nem működhet együtt ezzel a személlyel.',
  'pt.profile-card.inactive.account.no.date': 'A fiókját inaktiváltuk.',
  'pt.profile-card.inactive.account.has.date.this.week': 'A fiókját ezen a héten inaktiváltuk.',
  'pt.profile-card.inactive.account.has.date.this.month': 'A fiókját ebben a hónapban inaktiváltuk.',
  'pt.profile-card.inactive.account.has.date.last.month': 'A fiókját a múlt hónapban inaktiváltuk.',
  'pt.profile-card.inactive.account.has.date.a.few.months': 'A fiókját néhány hónapja inaktiváltuk.',
  'pt.profile-card.inactive.account.has.date.several.months': 'A fiókját több hónapja inaktiváltuk.',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': 'A fiókját több mint egy éve inaktiváltuk.',
  'pt.profile-card.closed.account': 'A fiók törölve.',
  'pt.profile-card.closed.account.no.date': 'A fiókját töröltük.',
  'pt.profile-card.closed.account.has.date.this.week': 'A fiókját ezen a héten töröltük.',
  'pt.profile-card.closed.account.has.date.this.month': 'A fiókját ebben a hónapban töröltük.',
  'pt.profile-card.closed.account.has.date.last.month': 'A fiókját a múlt hónapban töröltük.',
  'pt.profile-card.closed.account.has.date.a.few.months': 'A fiókját néhány hónapja töröltük.',
  'pt.profile-card.closed.account.has.date.several.months': 'A fiókját több hónapja töröltük.',
  'pt.profile-card.closed.account.has.date.more.than.a.year': 'A fiókját több mint egy éve töröltük.',
  'pt.profile-card.disabled.account.default.name': 'Korábbi felhasználó'
});

/***/ }),
/* 1960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Icelandic
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': 'Reikningur gerður óvirkur',
  'pt.profile-card.general.msg.disabled.user': 'Þú getur ekki lengur átt samstarf við þennan einstakling.',
  'pt.profile-card.inactive.account.no.date': 'Reikningurinn þeirra hefur verið gerður óvirkur.',
  'pt.profile-card.inactive.account.has.date.this.week': 'Reikningurinn þeirra var gerður óvirkur í þessari viku.',
  'pt.profile-card.inactive.account.has.date.this.month': 'Reikningurinn þeirra var gerður óvirkur í þessum mánuði.',
  'pt.profile-card.inactive.account.has.date.last.month': 'Reikningurinn þeirra var gerður óvirkur í síðasta mánuði.',
  'pt.profile-card.inactive.account.has.date.a.few.months': 'Reikningurinn þeirra var gerður óvirkur fyrir nokkrum mánuðum.',
  'pt.profile-card.inactive.account.has.date.several.months': 'Reikningurinn þeirra hefur verið ávirkur í þó nokkra mánuði.',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': 'Reikningurinn þeirra hefur verið óvirkur í meira en ár.',
  'pt.profile-card.closed.account': 'Account eytt',
  'pt.profile-card.closed.account.no.date': 'Reikningnum þeirra hefur verið eytt.',
  'pt.profile-card.closed.account.has.date.this.week': 'Reikningnum þeirra var eytt í þessari viku.',
  'pt.profile-card.closed.account.has.date.this.month': 'Reikningnum þeirra var eytt í þessum mánuði.',
  'pt.profile-card.closed.account.has.date.last.month': 'Reikningnum þeirra var eytt í síðasta mánuði.',
  'pt.profile-card.closed.account.has.date.a.few.months': 'Reikningnum þeirra var eytt fyrir nokkrum mánuðum.',
  'pt.profile-card.closed.account.has.date.several.months': 'Reikningnum þeirra var eytt fyrir þó nokkrum mánuðum.',
  'pt.profile-card.closed.account.has.date.more.than.a.year': 'Reikningnum þeirra var eytt fyrir meira en ári.',
  'pt.profile-card.disabled.account.default.name': 'Fyrrverandi notandi'
});

/***/ }),
/* 1961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Italian
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': 'Account disattivato',
  'pt.profile-card.general.msg.disabled.user': 'Non puoi più collaborare con questa persona.',
  'pt.profile-card.inactive.account.no.date': 'Il suo account è stato disattivato.',
  'pt.profile-card.inactive.account.has.date.this.week': 'Il suo account è stato disattivato questa settimana.',
  'pt.profile-card.inactive.account.has.date.this.month': 'Il suo account è stato disattivato questo mese.',
  'pt.profile-card.inactive.account.has.date.last.month': 'Il suo account è stato disattivato il mese scorso.',
  'pt.profile-card.inactive.account.has.date.a.few.months': 'Il suo account è disattivato da qualche mese.',
  'pt.profile-card.inactive.account.has.date.several.months': 'Il suo account è disattivato da diversi mesi.',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': 'Il suo account è disattivato da più di un anno.',
  'pt.profile-card.closed.account': 'Account eliminato',
  'pt.profile-card.closed.account.no.date': 'Il suo account è stato eliminato.',
  'pt.profile-card.closed.account.has.date.this.week': 'Il suo account è stato eliminato questa settimana.',
  'pt.profile-card.closed.account.has.date.this.month': 'Il suo account è stato eliminato questo mese.',
  'pt.profile-card.closed.account.has.date.last.month': 'Il suo account è stato eliminato lo scorso mese.',
  'pt.profile-card.closed.account.has.date.a.few.months': 'Il suo account è stato eliminato da qualche mese.',
  'pt.profile-card.closed.account.has.date.several.months': 'Il suo account è stato eliminato da diversi mesi.',
  'pt.profile-card.closed.account.has.date.more.than.a.year': 'Il suo account è stato eliminato da più di un anno.',
  'pt.profile-card.disabled.account.default.name': 'Ex utente'
});

/***/ }),
/* 1962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Japanese
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': '無効なアカウント',
  'pt.profile-card.general.msg.disabled.user': 'もうこの人とコラボレーションすることはできません。',
  'pt.profile-card.inactive.account.no.date': 'アカウントは無効になっています。',
  'pt.profile-card.inactive.account.has.date.this.week': 'アカウントは今週無効になりました。',
  'pt.profile-card.inactive.account.has.date.this.month': 'アカウントは今月無効になりました。',
  'pt.profile-card.inactive.account.has.date.last.month': 'アカウントは先月無効になりました。',
  'pt.profile-card.inactive.account.has.date.a.few.months': 'アカウントは 2〜3 か月前に無効になりました。',
  'pt.profile-card.inactive.account.has.date.several.months': 'アカウントは数か月前に無効になりました。',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': 'アカウントは 1 年以上前に無効になりました。',
  'pt.profile-card.closed.account': '削除済みアカウント',
  'pt.profile-card.closed.account.no.date': 'アカウントは削除されています。',
  'pt.profile-card.closed.account.has.date.this.week': 'アカウントは今週削除されました。',
  'pt.profile-card.closed.account.has.date.this.month': 'アカウントは今月削除されました。',
  'pt.profile-card.closed.account.has.date.last.month': 'アカウントは先月削除されました。',
  'pt.profile-card.closed.account.has.date.a.few.months': 'アカウントは 2〜3 か月前に削除されました。',
  'pt.profile-card.closed.account.has.date.several.months': 'アカウントは数か月前に削除されました。',
  'pt.profile-card.closed.account.has.date.more.than.a.year': 'アカウントは 1 年以上前に削除されました。',
  'pt.profile-card.disabled.account.default.name': '元ユーザー'
});

/***/ }),
/* 1963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Korean
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': '계정이 비활성화됨',
  'pt.profile-card.general.msg.disabled.user': '더 이상 이 사람과 협업할 수 없습니다.',
  'pt.profile-card.inactive.account.no.date': '해당 계정은 비활성화되었습니다.',
  'pt.profile-card.inactive.account.has.date.this.week': '해당 계정은 이번 주에 비활성화되었습니다.',
  'pt.profile-card.inactive.account.has.date.this.month': '해당 계정은 이번 달에 비활성화되었습니다.',
  'pt.profile-card.inactive.account.has.date.last.month': '해당 계정은 지난달에 비활성화되었습니다.',
  'pt.profile-card.inactive.account.has.date.a.few.months': '해당 계정은 몇 달 전에 비활성화되었습니다.',
  'pt.profile-card.inactive.account.has.date.several.months': '해당 계정은 몇 달 전에 비활성화되었습니다.',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': '해당 계정이 비활성화된 지 1년이 넘었습니다.',
  'pt.profile-card.closed.account': '계정이 삭제됨',
  'pt.profile-card.closed.account.no.date': '해당 계정은 삭제되었습니다.',
  'pt.profile-card.closed.account.has.date.this.week': '해당 계정은 이번 주에 삭제되었습니다.',
  'pt.profile-card.closed.account.has.date.this.month': '해당 계정은 이번 달에 삭제되었습니다.',
  'pt.profile-card.closed.account.has.date.last.month': '해당 계정은 지난달에 삭제되었습니다.',
  'pt.profile-card.closed.account.has.date.a.few.months': '해당 계정은 몇 달 전에 삭제되었습니다.',
  'pt.profile-card.closed.account.has.date.several.months': '해당 계정은 몇 달 전에 삭제되었습니다.',
  'pt.profile-card.closed.account.has.date.more.than.a.year': '해당 계정은 삭제된 지 1년이 넘었습니다.',
  'pt.profile-card.disabled.account.default.name': '이전 사용자'
});

/***/ }),
/* 1964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Norwegian Bokmål
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': 'Kontoen er deaktivert',
  'pt.profile-card.general.msg.disabled.user': 'Du kan ikke lenger samarbeide med denne personen.',
  'pt.profile-card.inactive.account.no.date': 'Vedkommendes konto er deaktivert.',
  'pt.profile-card.inactive.account.has.date.this.week': 'Vedkommendes konto ble deaktivert denne uken.',
  'pt.profile-card.inactive.account.has.date.this.month': 'Vedkommendes konto ble deaktivert denne uken.',
  'pt.profile-card.inactive.account.has.date.last.month': 'Vedkommendes konto ble deaktivert denne måneden.',
  'pt.profile-card.inactive.account.has.date.a.few.months': 'Vedkommendes konto har vært  deaktivert i noen måneder.',
  'pt.profile-card.inactive.account.has.date.several.months': 'Vedkommendes konto har vært  deaktivert i flere måneder.',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': 'Vedkommendes konto har vært deaktivert i over et år.',
  'pt.profile-card.closed.account': 'Kontoen er slettet',
  'pt.profile-card.closed.account.no.date': 'Vedkommendes konto er slettet.',
  'pt.profile-card.closed.account.has.date.this.week': 'Vedkommendes konto ble slettet denne uken.',
  'pt.profile-card.closed.account.has.date.this.month': 'Vedkommendes konto ble slettet denne måneden.',
  'pt.profile-card.closed.account.has.date.last.month': 'Vedkommendes konto ble slettet i forrige måned.',
  'pt.profile-card.closed.account.has.date.a.few.months': 'Vedkommendes konto har vært slettet i noen måneder.',
  'pt.profile-card.closed.account.has.date.several.months': 'Vedkommendes konto har vært slettet i flere måneder.',
  'pt.profile-card.closed.account.has.date.more.than.a.year': 'Vedkommendes konto har vært slettet i over et år.',
  'pt.profile-card.disabled.account.default.name': 'Tidligere bruker'
});

/***/ }),
/* 1965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Polish
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': 'Konto zdezaktywowane',
  'pt.profile-card.general.msg.disabled.user': 'Nie możesz już współpracować z tą osobą',
  'pt.profile-card.inactive.account.no.date': 'Jej konto zostało zdezaktywowane pomyślnie.',
  'pt.profile-card.inactive.account.has.date.this.week': 'Jej konto zostało zdezaktywowane w tym tygodniu.',
  'pt.profile-card.inactive.account.has.date.this.month': 'Jej konto zdezaktywowane w tym miesiącu.',
  'pt.profile-card.inactive.account.has.date.last.month': 'Jej konto zdezaktywowane w zeszłym miesiącu.',
  'pt.profile-card.inactive.account.has.date.a.few.months': 'Jej konto zostało zdezaktywowane przynajmniej kilka miesięcy temu.',
  'pt.profile-card.inactive.account.has.date.several.months': 'Jej konto zostało zdezaktywowane przynajmniej kilka miesięcy temu.',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': 'Jej konto zostało zdezaktywowane przynajmniej rok temu.',
  'pt.profile-card.closed.account': 'Konto zostało usunięte',
  'pt.profile-card.closed.account.no.date': 'Jej konto zostało usunięte.',
  'pt.profile-card.closed.account.has.date.this.week': 'Jej konto usunięte w tym tygodniu.',
  'pt.profile-card.closed.account.has.date.this.month': 'Jej konto zostało usunięte w tym miesiącu.',
  'pt.profile-card.closed.account.has.date.last.month': 'Jej konto usunięte w zeszłym miesiącu.',
  'pt.profile-card.closed.account.has.date.a.few.months': 'Jej konto zostało zdezaktywowane przynajmniej kilka miesięcy temu.',
  'pt.profile-card.closed.account.has.date.several.months': 'Jej konto zostało usunięte przynajmniej kilka miesięcy temu.',
  'pt.profile-card.closed.account.has.date.more.than.a.year': 'Jej konto zostało usunięte przynajmniej rok temu.',
  'pt.profile-card.disabled.account.default.name': 'Były użytkownik'
});

/***/ }),
/* 1966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Portuguese (Brazil)
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': 'Conta desativada',
  'pt.profile-card.general.msg.disabled.user': 'Você não pode mais colaborar com essa pessoa.',
  'pt.profile-card.inactive.account.no.date': 'A conta do usuário foi desativada.',
  'pt.profile-card.inactive.account.has.date.this.week': 'A conta do usuário foi desativada nesta semana.',
  'pt.profile-card.inactive.account.has.date.this.month': 'A conta do usuário foi desativada neste mês.',
  'pt.profile-card.inactive.account.has.date.last.month': 'A conta do usuário foi desativada no mês passado.',
  'pt.profile-card.inactive.account.has.date.a.few.months': 'A conta do usuário foi desativada há alguns meses.',
  'pt.profile-card.inactive.account.has.date.several.months': 'A conta do usuário foi desativada há vários meses.',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': 'A conta do usuário foi desativada há mais de um ano.',
  'pt.profile-card.closed.account': 'Conta excluída',
  'pt.profile-card.closed.account.no.date': 'A conta do usuário foi excluída.',
  'pt.profile-card.closed.account.has.date.this.week': 'A conta do usuário foi excluída nesta semana.',
  'pt.profile-card.closed.account.has.date.this.month': 'A conta do usuário foi excluída neste mês.',
  'pt.profile-card.closed.account.has.date.last.month': 'A conta do usuário foi excluída no mês passado.',
  'pt.profile-card.closed.account.has.date.a.few.months': 'A conta do usuário foi excluída há alguns meses.',
  'pt.profile-card.closed.account.has.date.several.months': 'A conta do usuário foi excluída há vários meses.',
  'pt.profile-card.closed.account.has.date.more.than.a.year': 'A conta do usuário foi excluída há mais de um ano.',
  'pt.profile-card.disabled.account.default.name': 'Ex-usuário'
});

/***/ }),
/* 1967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Portuguese (Portugal)
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': 'Conta desativada',
  'pt.profile-card.general.msg.disabled.user': 'Já não pode colaborar com este utilizador.',
  'pt.profile-card.inactive.account.no.date': 'A conta foi desativada.',
  'pt.profile-card.inactive.account.has.date.this.week': 'A conta foi desativada esta semana.',
  'pt.profile-card.inactive.account.has.date.this.month': 'A conta foi desativada este mês.',
  'pt.profile-card.inactive.account.has.date.last.month': 'A conta foi desativada no mês passado.',
  'pt.profile-card.inactive.account.has.date.a.few.months': 'A conta foi desativada há alguns meses.',
  'pt.profile-card.inactive.account.has.date.several.months': 'A conta foi desativada há vários meses.',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': 'A conta foi desativada há mais de um ano.',
  'pt.profile-card.closed.account': 'Conta eliminada',
  'pt.profile-card.closed.account.no.date': 'A conta foi eliminada.',
  'pt.profile-card.closed.account.has.date.this.week': 'A conta foi eliminada esta semana.',
  'pt.profile-card.closed.account.has.date.this.month': 'A conta foi eliminada este mês.',
  'pt.profile-card.closed.account.has.date.last.month': 'A conta foi eliminada no mês passado.',
  'pt.profile-card.closed.account.has.date.a.few.months': 'A conta foi eliminada há alguns meses.',
  'pt.profile-card.closed.account.has.date.several.months': 'A conta foi eliminada há vários meses.',
  'pt.profile-card.closed.account.has.date.more.than.a.year': 'A conta foi eliminada há mais de um ano.',
  'pt.profile-card.disabled.account.default.name': 'Utilizador antigo'
});

/***/ }),
/* 1968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Romanian
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': 'Cont dezactivat',
  'pt.profile-card.general.msg.disabled.user': 'Nu mai puteți colabora cu această persoană.',
  'pt.profile-card.inactive.account.no.date': 'Contul acesteia a fost dezactivat.',
  'pt.profile-card.inactive.account.has.date.this.week': 'Contul acesteia a fost dezactivat săptămâna aceasta.',
  'pt.profile-card.inactive.account.has.date.this.month': 'Contul acesteia a fost dezactivat luna aceasta.',
  'pt.profile-card.inactive.account.has.date.last.month': 'Contul acesteia a fost dezactivat luna aceasta.',
  'pt.profile-card.inactive.account.has.date.a.few.months': 'Contul acesteia a fost dezactivat de câteva luni.',
  'pt.profile-card.inactive.account.has.date.several.months': 'Contul acesteia a fost dezactivat de mai multe luni.',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': 'Contul acesteia a fost dezactivat de peste un an.',
  'pt.profile-card.closed.account': 'Cont șters',
  'pt.profile-card.closed.account.no.date': 'Contul acesteia a fost șters.',
  'pt.profile-card.closed.account.has.date.this.week': 'Contul acesteia a fost șters săptămâna aceasta.',
  'pt.profile-card.closed.account.has.date.this.month': 'Contul acesteia a fost șters luna aceasta.',
  'pt.profile-card.closed.account.has.date.last.month': 'Contul acesteia a fost șters luna trecută.',
  'pt.profile-card.closed.account.has.date.a.few.months': 'Contul acesteia a fost șters de câteva luni.',
  'pt.profile-card.closed.account.has.date.several.months': 'Contul acesteia a fost șters de mai multe luni.',
  'pt.profile-card.closed.account.has.date.more.than.a.year': 'Contul acesteia a fost șters de peste un an.',
  'pt.profile-card.disabled.account.default.name': 'Fost utilizator'
});

/***/ }),
/* 1969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Russian
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': 'Аккаунт отключен',
  'pt.profile-card.general.msg.disabled.user': 'Вы больше не можете работать с этим пользователем.',
  'pt.profile-card.inactive.account.no.date': 'Его аккаунт был отключен.',
  'pt.profile-card.inactive.account.has.date.this.week': 'Его аккаунт был отключен на этой неделе.',
  'pt.profile-card.inactive.account.has.date.this.month': 'Его аккаунт был отключен в этом месяце.',
  'pt.profile-card.inactive.account.has.date.last.month': 'Его аккаунт был отключен в прошлом месяце.',
  'pt.profile-card.inactive.account.has.date.a.few.months': 'Его аккаунт был отключен несколько месяцев назад.',
  'pt.profile-card.inactive.account.has.date.several.months': 'Его аккаунт уже несколько месяцев отключен.',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': 'Его аккаунт был отключен более года назад.',
  'pt.profile-card.closed.account': 'Аккаунт удален',
  'pt.profile-card.closed.account.no.date': 'Его аккаунт был удален.',
  'pt.profile-card.closed.account.has.date.this.week': 'Его аккаунт был удален на этой неделе.',
  'pt.profile-card.closed.account.has.date.this.month': 'Его аккаунт был удален в этом месяце.',
  'pt.profile-card.closed.account.has.date.last.month': 'Его аккаунт был удален в прошлом месяце.',
  'pt.profile-card.closed.account.has.date.a.few.months': 'Его аккаунт был удален несколько месяцев назад.',
  'pt.profile-card.closed.account.has.date.several.months': 'Его аккаунт удален уже несколько месяцев назад.',
  'pt.profile-card.closed.account.has.date.more.than.a.year': 'Его аккаунт был удален более года назад.',
  'pt.profile-card.disabled.account.default.name': 'Бывший пользователь'
});

/***/ }),
/* 1970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Slovak
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': 'Účet deaktivovaný',
  'pt.profile-card.general.msg.disabled.user': 'S touto osobou už nemôžete spolupracovať.',
  'pt.profile-card.inactive.account.no.date': 'Jej účet bol deaktivovaný.',
  'pt.profile-card.inactive.account.has.date.this.week': 'Jej účet bol tento týždeň deaktivovaný.',
  'pt.profile-card.inactive.account.has.date.this.month': 'Jej účet bol tento mesiac deaktivovaný.',
  'pt.profile-card.inactive.account.has.date.last.month': 'Jej účet bol minulý mesiac deaktivovaný.',
  'pt.profile-card.inactive.account.has.date.a.few.months': 'Jej účet je už niekoľko mesiacov deaktivovaný.',
  'pt.profile-card.inactive.account.has.date.several.months': 'Jej účet je už niekoľko mesiacov deaktivovaný.',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': 'Jej účet je už viac ako rok deaktivovaný.',
  'pt.profile-card.closed.account': 'Účet odstránený',
  'pt.profile-card.closed.account.no.date': 'Jej účet bol odstránený.',
  'pt.profile-card.closed.account.has.date.this.week': 'Jej účet bol tento týždeň odstránený.',
  'pt.profile-card.closed.account.has.date.this.month': 'Jej účet bol tento mesiac odstránený.',
  'pt.profile-card.closed.account.has.date.last.month': 'Jej účet bol minulý mesiac odstránený.',
  'pt.profile-card.closed.account.has.date.a.few.months': 'Jej účet je už niekoľko mesiacov odstránený.',
  'pt.profile-card.closed.account.has.date.several.months': 'Jej účet je už niekoľko mesiacov odstránený.',
  'pt.profile-card.closed.account.has.date.more.than.a.year': 'Jej účet je už viac ako rok odstránený.',
  'pt.profile-card.disabled.account.default.name': 'Bývalý používateľ'
});

/***/ }),
/* 1971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Spanish
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': 'Cuenta desactivada',
  'pt.profile-card.general.msg.disabled.user': 'Ya no puedes colaborar con esta persona.',
  'pt.profile-card.inactive.account.no.date': 'Su cuenta está desactivada.',
  'pt.profile-card.inactive.account.has.date.this.week': 'Su cuenta se ha desactivado esta semana.',
  'pt.profile-card.inactive.account.has.date.this.month': 'Su cuenta se ha desactivado este mes.',
  'pt.profile-card.inactive.account.has.date.last.month': 'Su cuenta se desactivó el mes pasado.',
  'pt.profile-card.inactive.account.has.date.a.few.months': 'Su cuenta se desactivó hace algunos meses.',
  'pt.profile-card.inactive.account.has.date.several.months': 'Su cuenta se desactivó hace varios meses.',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': 'Su cuenta se desactivó hace más de un año.',
  'pt.profile-card.closed.account': 'Cuenta eliminada',
  'pt.profile-card.closed.account.no.date': 'Su cuenta está eliminada.',
  'pt.profile-card.closed.account.has.date.this.week': 'Su cuenta se ha eliminado esta semana.',
  'pt.profile-card.closed.account.has.date.this.month': 'Su cuenta se ha eliminado este mes.',
  'pt.profile-card.closed.account.has.date.last.month': 'Su cuenta se eliminó el mes pasado.',
  'pt.profile-card.closed.account.has.date.a.few.months': 'Su cuenta se desactivó hace algunos meses.',
  'pt.profile-card.closed.account.has.date.several.months': 'Su cuenta se eliminó hace varios meses.',
  'pt.profile-card.closed.account.has.date.more.than.a.year': 'Su cuenta se eliminó hace más de un año.',
  'pt.profile-card.disabled.account.default.name': 'Antiguo usuario'
});

/***/ }),
/* 1972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Swedish
/* harmony default export */ __webpack_exports__["a"] = ({
  'pt.profile-card.inactive.account': 'Kontot är inaktiverat',
  'pt.profile-card.general.msg.disabled.user': 'Du kan inte längre samarbeta med den här personen.',
  'pt.profile-card.inactive.account.no.date': 'Personens konto har inaktiverats.',
  'pt.profile-card.inactive.account.has.date.this.week': 'Personens konto inaktiverades den här veckan.',
  'pt.profile-card.inactive.account.has.date.this.month': 'Personens konto inaktiverades den här månaden.',
  'pt.profile-card.inactive.account.has.date.last.month': 'Personens konto inaktiverades förra månaden.',
  'pt.profile-card.inactive.account.has.date.a.few.months': 'Personens konto har varit inaktiverat i några få månader.',
  'pt.profile-card.inactive.account.has.date.several.months': 'Personens konto har varit inaktiverat i flera månader.',
  'pt.profile-card.inactive.account.has.date.more.than.a.year': 'Personens konto har varit inaktiverat i mer än ett år.',
  'pt.profile-card.closed.account': 'Kontot är borttaget',
  'pt.profile-card.closed.account.no.date': 'Personens konto har tagits bort.',
  'pt.profile-card.closed.account.has.date.this.week': 'Personens konto togs bort den här veckan.',
  'pt.profile-card.closed.account.has.date.this.month': 'Personens konto togs bort den här månaden.',
  'pt.profile-card.closed.account.has.date.last.month': 'Personens konto togs bort förra månaden.',
  'pt.profile-card.closed.account.has.date.a.few.months': 'Personens konto har varit borttaget i några få månader.',
  'pt.profile-card.closed.account.has.date.several.months': 'Personens konto har varit borttaget i flera månader.',
  'pt.profile-card.closed.account.has.date.more.than.a.year': 'Personens konto har varit borttaget i mer än ett år.',
  'pt.profile-card.disabled.account.default.name': 'Före detta användare'
});

/***/ }),
/* 1973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isValidDate */
/* harmony export (immutable) */ __webpack_exports__["a"] = getRelativeDateKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_is_this_week__ = __webpack_require__(1974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_is_this_week___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_is_this_week__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_is_this_month__ = __webpack_require__(1976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_is_this_month___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_is_this_month__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_months__ = __webpack_require__(1978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_months___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_months__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_is_valid__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_is_valid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_is_valid__);




function isValidDate(date) {
  var today = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  return !!date.getTime && __WEBPACK_IMPORTED_MODULE_3_date_fns_is_valid___default()(date) && date.getTime() <= today.getTime();
}
function getRelativeDateKey(date) {
  var today = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();

  if (!date || !isValidDate(date, today)) {
    return null;
  }

  if (__WEBPACK_IMPORTED_MODULE_0_date_fns_is_this_week___default()(date)) {
    return 'ThisWeek';
  }

  if (__WEBPACK_IMPORTED_MODULE_1_date_fns_is_this_month___default()(date)) {
    return 'ThisMonth';
  }

  if (date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() - 1) {
    return 'LastMonth';
  }

  var diffInMonths = __WEBPACK_IMPORTED_MODULE_2_date_fns_difference_in_months___default()(today, date);

  if (diffInMonths < 6) {
    return 'AFewMonths';
  }

  if (diffInMonths <= 12) {
    return 'SeveralMonths';
  }

  return 'MoreThanAYear';
}

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

var isSameWeek = __webpack_require__(1975)

/**
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21), {weekStartsOn: 1})
 * //=> false
 */
function isThisWeek (dirtyDate, dirtyOptions) {
  return isSameWeek(new Date(), dirtyDate, dirtyOptions)
}

module.exports = isThisWeek


/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(727)

/**
 * @category Week Helpers
 * @summary Are the given dates in the same week?
 *
 * @description
 * Are the given dates in the same week?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the dates are in the same week
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4)
 * )
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4),
 *   {weekStartsOn: 1}
 * )
 * //=> false
 */
function isSameWeek (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  var dateLeftStartOfWeek = startOfWeek(dirtyDateLeft, dirtyOptions)
  var dateRightStartOfWeek = startOfWeek(dirtyDateRight, dirtyOptions)

  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime()
}

module.exports = isSameWeek


/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

var isSameMonth = __webpack_require__(1977)

/**
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * var result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */
function isThisMonth (dirtyDate) {
  return isSameMonth(new Date(), dirtyDate)
}

module.exports = isThisMonth


/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(74)

/**
 * @category Month Helpers
 * @summary Are the given dates in the same month?
 *
 * @description
 * Are the given dates in the same month?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameMonth (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getFullYear() === dateRight.getFullYear() &&
    dateLeft.getMonth() === dateRight.getMonth()
}

module.exports = isSameMonth


/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(74)
var differenceInCalendarMonths = __webpack_require__(1979)
var compareAsc = __webpack_require__(1980)

/**
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 7
 */
function differenceInMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight))
  dateLeft.setMonth(dateLeft.getMonth() - sign * difference)

  // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastMonthNotFull)
}

module.exports = differenceInMonths


/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(74)

/**
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth()

  return yearDiff * 12 + monthDiff
}

module.exports = differenceInCalendarMonths


/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(74)

/**
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * var result = compareAsc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft < timeRight) {
    return -1
  } else if (timeLeft > timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareAsc


/***/ }),
/* 1981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var presences = {
  none: '',
  available: 'Available',
  busy: 'Busy',
  unavailable: 'Away',
  focus: 'Focused'
};
/* harmony default export */ __webpack_exports__["a"] = (presences);

/***/ }),
/* 1982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(17);

var messages = Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["defineMessages"])({
  inactiveAccountMsg: {
    id: 'pt.profile-card.inactive.account',
    defaultMessage: 'Account deactivated',
    description: 'A text in a grey lozenge shows that this user is inactive'
  },
  generalDescMsgForDisabledUser: {
    id: 'pt.profile-card.general.msg.disabled.user',
    defaultMessage: 'You can no longer collaborate with this person.',
    description: 'A first sentence of a long text explains this user is inactive/closed'
  },
  inactiveAccountDescMsgNoDate: {
    id: 'pt.profile-card.inactive.account.no.date',
    defaultMessage: 'Their account has been deactivated.',
    description: 'A long text explains this user is inactive when we do not know the date of starting to deactivate'
  },
  inactiveAccountDescMsgHasDateThisWeek: {
    id: 'pt.profile-card.inactive.account.has.date.this.week',
    defaultMessage: 'Their account was deactivated this week.',
    description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
  },
  inactiveAccountDescMsgHasDateThisMonth: {
    id: 'pt.profile-card.inactive.account.has.date.this.month',
    defaultMessage: 'Their account was deactivated this month.',
    description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
  },
  inactiveAccountDescMsgHasDateLastMonth: {
    id: 'pt.profile-card.inactive.account.has.date.last.month',
    defaultMessage: 'Their account was deactivated last month.',
    description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
  },
  inactiveAccountDescMsgHasDateAFewMonths: {
    id: 'pt.profile-card.inactive.account.has.date.a.few.months',
    defaultMessage: 'Their account has been deactivated for a few months.',
    description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
  },
  inactiveAccountDescMsgHasDateSeveralMonths: {
    id: 'pt.profile-card.inactive.account.has.date.several.months',
    defaultMessage: 'Their account has been deactivated for several months.',
    description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
  },
  inactiveAccountDescMsgHasDateMoreThanAYear: {
    id: 'pt.profile-card.inactive.account.has.date.more.than.a.year',
    defaultMessage: 'Their account has been deactivated for more than a year.',
    description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
  },
  closedAccountMsg: {
    id: 'pt.profile-card.closed.account',
    defaultMessage: 'Account deleted',
    description: 'A text in a grey lozenge shows that this user is closed/deleted'
  },
  closedAccountDescMsgNoDate: {
    id: 'pt.profile-card.closed.account.no.date',
    defaultMessage: 'Their account has been deleted.',
    description: 'A long text explains this user is closed when we do not know the date of starting to close'
  },
  closedAccountDescMsgHasDateThisWeek: {
    id: 'pt.profile-card.closed.account.has.date.this.week',
    defaultMessage: 'Their account was deleted this week.',
    description: 'A long text explains this user is closed when we know the date of starting to close'
  },
  closedAccountDescMsgHasDateThisMonth: {
    id: 'pt.profile-card.closed.account.has.date.this.month',
    defaultMessage: 'Their account was deleted this month.',
    description: 'A long text explains this user is closed when we know the date of starting to close'
  },
  closedAccountDescMsgHasDateLastMonth: {
    id: 'pt.profile-card.closed.account.has.date.last.month',
    defaultMessage: 'Their account was deleted last month.',
    description: 'A long text explains this user is closed when we know the date of starting to close'
  },
  closedAccountDescMsgHasDateAFewMonths: {
    id: 'pt.profile-card.closed.account.has.date.a.few.months',
    defaultMessage: 'Their account has been deleted for a few months.',
    description: 'A long text explains this user is closed when we know the date of starting to close'
  },
  closedAccountDescMsgHasDateSeveralMonths: {
    id: 'pt.profile-card.closed.account.has.date.several.months',
    defaultMessage: 'Their account has been deleted for several months.',
    description: 'A long text explains this user is closed when we know the date of starting to close'
  },
  closedAccountDescMsgHasDateMoreThanAYear: {
    id: 'pt.profile-card.closed.account.has.date.more.than.a.year',
    defaultMessage: 'Their account has been deleted for more than a year.',
    description: 'A long text explains this user is closed when we know the date of starting to close'
  },
  disabledAccountDefaultName: {
    id: 'pt.profile-card.disabled.account.default.name',
    defaultMessage: 'Former user',
    description: 'A default name when we cannot get name of an inactive or closed user'
  }
});
/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 1983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export modifyResponse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lru_fast__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lru_fast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lru_fast__);






/**
 * Transform presence response to atlaskit/avatar compatible presence value
 * @param presenceResponse
 * @returns {string}
 */
var calculatePresence = function calculatePresence(presenceResponse) {
  if (!presenceResponse) {
    return null;
  }

  var state = presenceResponse.state;
  var stateMetadata = presenceResponse.stateMetadata ? JSON.parse(presenceResponse.stateMetadata) : null;

  if (state === 'busy') {
    if (stateMetadata && stateMetadata.focus) {
      state = 'focus';
    }
  }

  return state;
};
/**
 * Transform response from GraphQL
 * - Prefix `timestring` with `remoteWeekdayString` depending on `remoteWeekdayIndex`
 * - Remove properties which will be not used later
 * @ignore
 * @param  {object} response
 * @return {object}
 */


var modifyResponse = function modifyResponse(response) {
  var presence = calculatePresence(response.Presence);

  var data = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({}, response.User, {
    presence: presence,
    presenceMessage: response.Presence && response.Presence.message
  });

  var localWeekdayIndex = new Date().getDay().toString();

  if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) {
    data.remoteTimeString = "".concat(data.remoteWeekdayString, " ").concat(data.remoteTimeString);
  }

  data.timestring = data.remoteTimeString;
  delete data.remoteWeekdayIndex;
  delete data.remoteWeekdayString;
  delete data.remoteTimeString;
  delete data.id;
  return data;
};

var buildHeaders = function buildHeaders() {
  var headers = new Headers();
  headers.append('Content-Type', 'application/json');
  return headers;
};
/**
 * @param  {string} userId
 * @param  {string} cloudId
 * @return {string} GraphQL Query String
 */


var buildUserQuery = function buildUserQuery(cloudId, userId) {
  return {
    query: "query User($userId: String!, $cloudId: String!) {\n    User: CloudUser(userId: $userId, cloudId: $cloudId) {\n      id,\n      isCurrentUser,\n      status,\n      statusModifiedDate,\n      isBot,\n      isNotMentionable,\n      fullName,\n      nickname,\n      email,\n      meta: title,\n      location,\n      companyName,\n      avatarUrl(size: 192),\n      remoteWeekdayIndex: localTime(format: \"d\"),\n      remoteWeekdayString: localTime(format: \"ddd\"),\n      remoteTimeString: localTime(format: \"h:mma\"),\n    }\n    Presence: Presence(organizationId: $cloudId, userId: $userId) {\n      state,\n      type,\n      date,\n      stateMetadata,\n      message\n    }\n  }",
    variables: {
      cloudId: cloudId,
      userId: userId
    }
  };
};
/**
 * @param {string} serviceUrl - GraphQL service endpoint
 * @param {string} userId
 * @param {string} cloudId
 */


var requestService = function requestService(serviceUrl, cloudId, userId) {
  var headers = buildHeaders();
  var userQuery = buildUserQuery(cloudId, userId);
  return fetch(new Request(serviceUrl, {
    method: 'POST',
    credentials: 'include',
    mode: 'cors',
    headers: headers,
    body: JSON.stringify(userQuery)
  })).then(function (response) {
    if (!response.ok) {
      return Promise.reject({
        code: response.status,
        reason: response.statusText
      });
    }

    return response.json().then(function (json) {
      if (json.errors) {
        return Promise.reject({
          reason: json.errors[0].category || 'default'
        });
      }

      return modifyResponse(json.data);
    });
  });
};

var ProfileClient =
/*#__PURE__*/
function () {
  function ProfileClient(config) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ProfileClient);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "config", void 0);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "cache", void 0);

    var defaults = {
      cacheSize: 10,
      cacheMaxAge: 0
    };
    this.config = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({}, defaults, config); // never set cacheSize or cacheMaxAge to negative numbers

    this.config.cacheSize = Math.max(parseInt(this.config.cacheSize, 10), 0);
    this.config.cacheMaxAge = Math.max(parseInt(this.config.cacheMaxAge, 10), 0); // DIR-474: cap cache at 30 days.

    if (this.config.cacheMaxAge) {
      this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 30 * 24 * 60 * 60 * 1000);
    } // Only set cache if maxCacheAge and cacheSize are set


    this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new __WEBPACK_IMPORTED_MODULE_4_lru_fast__["LRUCache"](this.config.cacheSize);
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ProfileClient, [{
    key: "makeRequest",
    value: function makeRequest(cloudId, userId) {
      if (!this.config.url) {
        throw new Error('config.url is a required parameter');
      }

      return requestService(this.config.url, cloudId, userId);
    }
  }, {
    key: "setCachedProfile",
    value: function setCachedProfile(cloudId, userId, cacheItem) {
      var cacheIdentifier = "".concat(cloudId, "/").concat(userId);
      this.cache.put(cacheIdentifier, cacheItem);
    }
  }, {
    key: "getCachedProfile",
    value: function getCachedProfile(cloudId, userId) {
      var cacheIdentifier = "".concat(cloudId, "/").concat(userId);
      var cached = this.cache && this.cache.get(cacheIdentifier);

      if (!cached) {
        return null;
      }

      if (cached.expire < Date.now()) {
        this.cache.remove(cacheIdentifier);
        return null;
      }

      this.cache.set(cacheIdentifier, {
        expire: Date.now() + this.config.cacheMaxAge,
        profile: cached.profile
      });
      return cached.profile;
    }
  }, {
    key: "flushCache",
    value: function flushCache() {
      if (this.cache) {
        this.cache.removeAll();
      }
    }
  }, {
    key: "getProfile",
    value: function getProfile(cloudId, userId) {
      var _this = this;

      if (!cloudId || !userId) {
        return Promise.reject(new Error('cloudId or userId missing'));
      }

      var cache = this.getCachedProfile(cloudId, userId);

      if (cache) {
        return Promise.resolve(cache);
      }

      return new Promise(function (resolve, reject) {
        _this.makeRequest(cloudId, userId).then(function (data) {
          if (_this.cache) {
            _this.setCachedProfile(cloudId, userId, {
              expire: Date.now() + _this.config.cacheMaxAge,
              profile: data
            });
          }

          resolve(data);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }]);

  return ProfileClient;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (ProfileClient);

/***/ }),
/* 1984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_layer__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_PositionWrapper__ = __webpack_require__(1992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_withOuterListeners__ = __webpack_require__(1993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__profilecard_resourced__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styled_Trigger__ = __webpack_require__(1994);














var AkLayerWithOuterListeners = Object(__WEBPACK_IMPORTED_MODULE_11__components_withOuterListeners__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__atlaskit_layer__["a" /* default */]);

var ProfilecardTrigger =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ProfilecardTrigger, _PureComponent);

  function ProfilecardTrigger() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ProfilecardTrigger);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ProfilecardTrigger)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "showDelay", 500);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "hideDelay", 500);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "showTimer", void 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "hideTimer", void 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      visible: false,
      isFlipped: false
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleLayerFlipChange", function (_ref) {
      var flipped = _ref.flipped;

      _this.setState({
        isFlipped: flipped
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "hideProfilecard", function () {
      clearTimeout(_this.showTimer);
      _this.hideTimer = setTimeout(function () {
        _this.setState({
          visible: false
        });
      }, _this.hideDelay);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "showProfilecard", function () {
      clearTimeout(_this.hideTimer);
      _this.showTimer = setTimeout(function () {
        _this.setState({
          visible: true
        });
      }, _this.showDelay);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ProfilecardTrigger, [{
    key: "renderProfilecard",
    value: function renderProfilecard() {
      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_PositionWrapper__["a" /* default */], {
        position: this.props.position,
        isFlipped: this.state.isFlipped
      }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styled_Trigger__["a" /* AnimationWrapper */], {
        position: this.props.position,
        isFlipped: this.state.isFlipped
      }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__profilecard_resourced__["a" /* default */], {
        userId: this.props.userId,
        cloudId: this.props.cloudId,
        resourceClient: this.props.resourceClient,
        actions: this.props.actions,
        analytics: this.props.analytics
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          position = _this$props.position,
          trigger = _this$props.trigger;
      var Layer = trigger === 'hover' ? __WEBPACK_IMPORTED_MODULE_9__atlaskit_layer__["a" /* default */] : AkLayerWithOuterListeners;
      var containerListeners = {};
      var layerListeners = {};

      if (trigger === 'hover') {
        containerListeners.onMouseEnter = this.showProfilecard;
        containerListeners.onMouseLeave = this.hideProfilecard;
      } else {
        containerListeners.onClick = this.showProfilecard;
        layerListeners.handleClickOutside = this.hideProfilecard;
        layerListeners.handleEscapeKeydown = this.hideProfilecard;
      }

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        style: {
          display: 'inline-block',
          maxWidth: '100%'
        }
      }, containerListeners), this.state.visible ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Layer, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        autoFlip: true,
        content: this.renderProfilecard(),
        offset: "0 4",
        onFlippedChange: this.handleLayerFlipChange,
        position: position
      }, layerListeners), children) : children);
    }
  }]);

  return ProfilecardTrigger;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(ProfilecardTrigger, "defaultProps", {
  position: 'top left',
  actions: [],
  trigger: 'hover'
});



/***/ }),
/* 1985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Layer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_raf_schd__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_popper_js__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__internal_ScrollBlock__ = __webpack_require__(1986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__internal_helpers__ = __webpack_require__(1990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styledContentContainer__ = __webpack_require__(1991);
















// We create a dummy target when making the menu fixed so that we can force popper.js to use fixed positioning
// without affecting child layout of the actual target since children of fixed position elements can't use percentage
// heights/widths.
var FixedTarget = __WEBPACK_IMPORTED_MODULE_10_styled_components__["default"].div.withConfig({
  displayName: "Layer__FixedTarget",
  componentId: "qunuuz-0"
})(["\n  ", ";\n"], function (_ref) {
  var fixedOffset = _ref.fixedOffset,
      targetRef = _ref.targetRef;

  if (fixedOffset && targetRef) {
    var actualTarget = targetRef.firstChild;
    var rect = actualTarget.getBoundingClientRect();
    return "\n        position: fixed;\n        top: ".concat(fixedOffset.top, "px;\n        left: ").concat(fixedOffset.left, "px;\n        height: ").concat(rect.height, "px;\n        width: ").concat(rect.width, "px;\n        z-index: -1;\n      ");
  }

  return 'display: none;';
});

var Layer =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Layer, _Component);

  // TODO: get the value of zIndex from theme, not using it now as it is not
  // working with extract-react-types
  function Layer(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Layer);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Layer).call(this, props));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "popper", void 0);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "targetRef", void 0);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "contentRef", void 0);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "fixedRef", void 0);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "extractStyles", function (state) {
      if (state) {
        var popperHeight = state.offsets.popper.height;
        var left = Math.round(state.offsets.popper.left); // The offset position is sometimes an object and sometimes just a string...

        var cssPosition = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(state.offsets.popper.position) === 'object' ? state.offsets.popper.position.position : state.offsets.popper.position;

        var top = _this.fixPositionTopUnderflow(state.offsets.popper.top, cssPosition);

        var originalHeight = _this.state.originalHeight || popperHeight;

        var maxHeight = _this.calculateMaxHeight(originalHeight, popperHeight, top, cssPosition);

        _this.setState({
          // position: fixed or absolute
          cssPosition: cssPosition,
          hasExtractedStyles: true,
          transform: "translate3d(".concat(left, "px, ").concat(top, "px, 0px)"),
          // state.flipped is either true or undefined
          flipped: !!state.flipped,
          actualPosition: state.position,
          originalPosition: state.originalPosition,
          originalHeight: originalHeight,
          maxHeight: maxHeight
        });
      }
    });

    _this.state = {
      hasExtractedStyles: false,
      position: null,
      transform: null,
      flipped: false,
      actualPosition: null,
      // We set these default offsets to prevent a flash of popper content in the wrong position
      // which can cause incorrect height calculations. Popper will calculate these values
      offsets: {
        popper: {
          left: -9999,
          top: -9999
        }
      },
      originalPosition: null,
      // fix Safari parent width: https://product-fabric.atlassian.net/browse/ED-1784
      cssPosition: 'absolute',
      originalHeight: null,
      maxHeight: null,
      fixedOffset: null
    };
    _this.extractStyles = Object(__WEBPACK_IMPORTED_MODULE_11_raf_schd__["a" /* default */])(_this.extractStyles.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this))));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Layer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.applyPopper(this.props);
      this.calculateFixedOffset(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.applyPopper(nextProps);
      this.calculateFixedOffset(nextProps);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props,
          onFlippedChange = _this$props.onFlippedChange,
          onPositioned = _this$props.onPositioned;
      var _this$state = this.state,
          flipped = _this$state.flipped,
          actualPosition = _this$state.actualPosition,
          originalPosition = _this$state.originalPosition,
          hasExtractedStyles = _this$state.hasExtractedStyles;

      if (prevState.flipped !== flipped && onFlippedChange) {
        onFlippedChange({
          flipped: flipped,
          actualPosition: actualPosition,
          originalPosition: originalPosition
        });
      } // This flag is set the first time the position is calculated from Popper and applied to the content


      if (!prevState.hasExtractedStyles && hasExtractedStyles && onPositioned) {
        onPositioned();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.extractStyles.cancel();

      if (this.popper) {
        this.popper.destroy();
      }
    }
    /* Calculate the max height of the popper if it's height is greater than the viewport to prevent
     * the bottom of the popper not being viewable.
     * Only works if the popper uses viewport as the boundary and has a fixed position ancestor.
     */

  }, {
    key: "calculateMaxHeight",
    value: function calculateMaxHeight(originalHeight, currentHeight, positionTop, cssPosition) {
      var DocumentElementClientHeight = 0;

      if (document.documentElement) {
        DocumentElementClientHeight = document.documentElement.clientHeight;
      }

      if (cssPosition !== 'fixed' || this.props.boundariesElement !== 'viewport') {
        return null;
      }

      var viewportHeight = Math.max(DocumentElementClientHeight, window.innerHeight || 0);
      return viewportHeight < originalHeight && currentHeight + positionTop >= viewportHeight - 50 ? // allow some spacing either side of viewport height
      viewportHeight - 12 : null;
    }
    /* Popper may return either a fixed or absolute position which would be applied to the
     * content style. In order to overcome clipping issues for overflow containing blocks when
     * the position is absolute, we create a fixed position wrapper.
     */

  }, {
    key: "calculateFixedOffset",
    value: function calculateFixedOffset(props) {
      var isAlwaysFixed = props.isAlwaysFixed;

      if (isAlwaysFixed && this.targetRef) {
        var actualTarget = this.targetRef.firstChild;
        this.setState({
          fixedOffset: {
            top: actualTarget.getBoundingClientRect().top,
            left: actualTarget.getBoundingClientRect().left
          }
        });
      } else if (!isAlwaysFixed && this.state.fixedOffset !== null) {
        this.setState({
          fixedOffset: null
        });
      }
    }
    /* Clamp fixed position to the window for fixed position poppers that flow off the top of the
     * window.
     * A fixed position popper is a popper who has an ancestor with position: fixed.
     *
     * It is too difficult to fix this for non-fixed position poppers without re-implementing popper's
     * offset functionality or fixing the issue upstream.
     */
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: "fixPositionTopUnderflow",
    value: function fixPositionTopUnderflow(popperTop, cssPosition) {
      return popperTop >= 0 || cssPosition !== 'fixed' ? Math.round(popperTop) : 0;
    }
  }, {
    key: "applyPopper",
    value: function applyPopper(props) {
      if (!this.fixedRef || !this.targetRef || !this.contentRef) {
        return;
      }

      if (this.popper) {
        this.popper.destroy();
      } // "new Popper(...)" operation is very expensive when called on virtual DOM.
      // This condition reduces the number of calls so we can run our tests faster
      // (time was reduced from 100s to 13s).


      if (!props.content) {
        return;
      } // we wrap our target in a div so that we can safely get a reference to it, but we pass the
      // actual target to popper


      var actualTarget = props.isAlwaysFixed ? this.fixedRef : this.targetRef.firstChild;
      var popperOpts = {
        placement: Object(__WEBPACK_IMPORTED_MODULE_14__internal_helpers__["b" /* positionPropToPopperPosition */])(props.position),
        onCreate: this.extractStyles,
        onUpdate: this.extractStyles,
        modifiers: {
          applyStyle: {
            enabled: false
          },
          hide: {
            enabled: false
          },
          offset: {
            enabled: true,
            offset: this.props.offset
          },
          flip: {
            enabled: !!this.props.autoFlip,
            flipVariations: true,
            boundariesElement: this.props.boundariesElement,
            padding: 0 // leave 0 pixels between popper and the boundariesElement

          },
          preventOverflow: {
            enabled: !!this.props.autoFlip,
            escapeWithReference: !(this.props.boundariesElement === 'scrollParent')
          }
        }
      };
      var flipBehavior = Object(__WEBPACK_IMPORTED_MODULE_14__internal_helpers__["a" /* getFlipBehavior */])(props);

      if (flipBehavior) {
        popperOpts.modifiers.flip.behavior = flipBehavior;
      }

      this.popper = new __WEBPACK_IMPORTED_MODULE_12_popper_js__["a" /* default */](actualTarget, this.contentRef, popperOpts);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          zIndex = _this$props2.zIndex,
          lockScroll = _this$props2.lockScroll;
      var _this$state2 = this.state,
          cssPosition = _this$state2.cssPosition,
          transform = _this$state2.transform,
          hasExtractedStyles = _this$state2.hasExtractedStyles,
          maxHeight = _this$state2.maxHeight,
          fixedOffset = _this$state2.fixedOffset;
      var opacity = hasExtractedStyles ? {} : {
        opacity: 0
      };
      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", {
        ref: function ref(_ref2) {
          _this2.targetRef = _ref2;
        }
      }, this.props.children), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(FixedTarget, {
        targetRef: this.targetRef,
        fixedOffset: fixedOffset
      }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", {
        style: {
          height: '100%',
          width: '100%'
        },
        ref: function ref(_ref3) {
          _this2.fixedRef = _ref3;
        }
      })), lockScroll && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__internal_ScrollBlock__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styledContentContainer__["a" /* default */], {
        maxHeight: maxHeight
      }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", {
        ref: function ref(_ref4) {
          _this2.contentRef = _ref4;
        },
        style: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({
          top: 0,
          left: 0,
          position: cssPosition,
          transform: transform,
          zIndex: zIndex
        }, opacity)
      }, this.props.content)));
    }
  }]);

  return Layer;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);
/* eslint-enable react/no-unused-prop-types */


__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Layer, "defaultProps", {
  autoFlip: true,
  boundariesElement: 'viewport',
  children: null,
  content: null,
  offset: '0 0',
  onFlippedChange: function onFlippedChange() {},
  position: 'right middle',
  zIndex: 400,
  lockScroll: false,
  isAlwaysFixed: false,
  onPositioned: function onPositioned() {}
});



/***/ }),
/* 1986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ScrollBlock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scrolllock__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scrolllock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_scrolllock__);



var Blanket = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div.withConfig({
  displayName: "ScrollBlock__Blanket",
  componentId: "sc-1xiww8k-0"
})(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: transparent;\n"]);
function ScrollBlock() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Blanket, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_scrolllock___default.a, null));
}

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(78);

var _utils = __webpack_require__(407);

var _withTouchListeners = __webpack_require__(1988);

var _withTouchListeners2 = _interopRequireDefault(_withTouchListeners);

var _StyleSheet = __webpack_require__(1989);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScrollLock = function (_PureComponent) {
  _inherits(ScrollLock, _PureComponent);

  function ScrollLock() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ScrollLock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).call.apply(_ref, [this].concat(args))), _this), _this.getStyles = function () {
      var accountForScrollbars = _this.props.accountForScrollbars;


      var height = (0, _utils.getDocumentHeight)();
      var paddingRight = accountForScrollbars ? (0, _utils.getPadding)() : null;
      var styles = 'body {\n      box-sizing: border-box !important;\n      overflow: hidden !important;\n      position: relative !important;\n      ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n      ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n    }';

      return styles;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ScrollLock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_exenv.canUseDOM) return;
      this.initialHeight = window.innerHeight;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var offset = window.innerHeight - this.initialHeight;

      // adjust scroll if the window has been resized since the lock was engaged
      // e.g. mobile safari dynamic chrome heights
      if (offset) {
        window.scrollTo(0, window.pageYOffset + offset);
      }

      // reset the initial height in case this scroll lock is used again
      this.initialHeight = window.innerHeight;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_StyleSheet2.default, { styles: this.getStyles() });
    }
  }]);

  return ScrollLock;
}(_react.PureComponent);

ScrollLock.defaultProps = {
  accountForScrollbars: true
};
exports.default = (0, _withTouchListeners2.default)(ScrollLock);

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = withTouchListeners;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(78);

var _utils = __webpack_require__(407);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withTouchListeners(WrappedComponent) {
  return function (_PureComponent) {
    _inherits(TouchProvider, _PureComponent);

    function TouchProvider() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, TouchProvider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).call.apply(_ref, [this].concat(args))), _this), _this.listenerOptions = {
        capture: false,
        passive: false
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TouchProvider, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (!_exenv.canUseDOM) return;

        var touchScrollTarget = this.props.touchScrollTarget;

        var target = document.body;

        // account for touch devices
        if (target && (0, _utils.isTouchDevice)()) {
          // Mobile Safari ignores { overflow: hidden } declaration on the body.
          target.addEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);

          // Allow scroll on provided target
          if (touchScrollTarget) {
            touchScrollTarget.addEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
            touchScrollTarget.addEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
          }
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (!_exenv.canUseDOM) return;

        var touchScrollTarget = this.props.touchScrollTarget;

        var target = document.body;

        // remove touch listeners
        if (target && (0, _utils.isTouchDevice)()) {
          target.removeEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);

          if (touchScrollTarget) {
            touchScrollTarget.removeEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
            touchScrollTarget.removeEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
          }
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      }
    }]);

    return TouchProvider;
  }(_react.PureComponent);
}

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(78);

var _utils = __webpack_require__(407);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Sheet = function (_PureComponent) {
  _inherits(Sheet, _PureComponent);

  function Sheet() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Sheet);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Sheet.__proto__ || Object.getPrototypeOf(Sheet)).call.apply(_ref, [this].concat(args))), _this), _this.addSheet = function () {
      var styles = _this.props.styles;


      var sheet = (0, _utils.makeStyleTag)();
      if (!sheet) return;

      (0, _utils.injectStyles)(sheet, styles);
      (0, _utils.insertStyleTag)(sheet);

      _this.sheet = sheet;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Sheet, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_exenv.canUseDOM) return;
      this.addSheet();
    }
  }, {
    key: 'removeSheet',
    value: function removeSheet() {
      if (!this.sheet) return;

      // $FlowFixMe
      this.sheet.parentNode.removeChild(this.sheet);
      this.sheet = null;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeSheet();
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Sheet;
}(_react.PureComponent);

exports.default = Sheet;

/***/ }),
/* 1990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export POSITION_ATTRIBUTE_ENUM */
/* harmony export (immutable) */ __webpack_exports__["a"] = getFlipBehavior;
/* harmony export (immutable) */ __webpack_exports__["b"] = positionPropToPopperPosition;
var positionMap = {
  'top left': {
    position: 'top-start',
    animation: 'top'
  },
  'top center': {
    position: 'top',
    animation: 'top'
  },
  'top right': {
    position: 'top-end',
    animation: 'top'
  },
  'right top': {
    position: 'right-start',
    animation: 'right'
  },
  'right middle': {
    position: 'right',
    animation: 'right'
  },
  'right bottom': {
    position: 'right-end',
    animation: 'right'
  },
  'bottom left': {
    position: 'bottom-start',
    animation: 'bottom'
  },
  'bottom center': {
    position: 'bottom',
    animation: 'bottom'
  },
  'bottom right': {
    position: 'bottom-end',
    animation: 'bottom'
  },
  'left top': {
    position: 'left-start',
    animation: 'left'
  },
  'left middle': {
    position: 'left',
    animation: 'left'
  },
  'left bottom': {
    position: 'left-end',
    animation: 'left'
  }
};
var POSITION_ATTRIBUTE_ENUM = {
  values: ['top left', 'top center', 'top right', 'right top', 'right middle', 'right bottom', 'bottom left', 'bottom center', 'bottom right', 'left top', 'left middle', 'left bottom'],
  default: 'right middle'
};

function positionToPopper(position) {
  return position && positionMap[position] ? positionMap[position].position : null;
}
/* Convert the autoFlip property into the array format that Popper expects.
 * The first item must not include the edge-position variation, or Popper will not understand it.
 */


function getFlipBehavior(props) {
  return props.position && Array.isArray(props.autoFlip) ? [props.position.split(' ')[0]].concat(props.autoFlip) : null;
}
function positionPropToPopperPosition(position) {
  return positionToPopper(position) || positionMap[POSITION_ATTRIBUTE_ENUM.default].position;
}

/***/ }),
/* 1991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "styledContentContainer",
  componentId: "p0j3f7-0"
})(["\n  [data-role='droplistContent'] {\n    ", ";\n  }\n"], function (_ref) {
  var maxHeight = _ref.maxHeight;
  return maxHeight ? "max-height: ".concat(maxHeight, "px") : '';
}));

/***/ }),
/* 1992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DirectionWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(2);








var positionStyles = {
  'top left': {
    left: 0,
    bottom: 0
  },
  'top right': {
    right: 0,
    bottom: 0
  },
  'right top': {
    left: 0,
    top: 0
  },
  'right bottom': {
    left: 0,
    bottom: 0
  },
  'bottom right': {
    right: 0,
    top: 0
  },
  'bottom left': {
    left: 0,
    top: 0
  },
  'left bottom': {
    right: 0,
    bottom: 0
  },
  'left top': {
    right: 0,
    top: 0
  }
};
var ContainerRelative = __WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div.withConfig({
  displayName: "PositionWrapper__ContainerRelative",
  componentId: "sc-1tzqpdz-0"
})(["\n  position: relative;\n"]);
var ContainerDirection = __WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div.withConfig({
  displayName: "PositionWrapper__ContainerDirection",
  componentId: "sc-1tzqpdz-1"
})(["\n  position: absolute;\n  ", ";\n"], function (props) {
  return positionStyles[props.position];
});

var DirectionWrapper =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(DirectionWrapper, _PureComponent);

  function DirectionWrapper() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, DirectionWrapper);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DirectionWrapper).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(DirectionWrapper, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContainerRelative, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ContainerDirection, {
        position: this.props.position
      }, this.props.children));
    }
  }]);

  return DirectionWrapper;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(DirectionWrapper, "defaultProps", {
  position: 'top left'
});



/***/ }),
/* 1993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withOuterListeners;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);









function withOuterListeners(Component) {
  return (
    /*#__PURE__*/
    function (_PureComponent) {
      __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(WithOutsideClick, _PureComponent);

      function WithOutsideClick() {
        var _getPrototypeOf2;

        var _this;

        __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, WithOutsideClick);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(WithOutsideClick)).call.apply(_getPrototypeOf2, [this].concat(args)));

        __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleClick", function (evt) {
          var domNode = __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this))); // eslint-disable-line react/no-find-dom-node

          if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) {
            _this.props.handleClickOutside();
          }
        });

        __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleKeydown", function (evt) {
          if (evt.code === 'Escape') {
            _this.props.handleEscapeKeydown();
          }
        });

        return _this;
      }

      __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(WithOutsideClick, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          if (this.props.handleClickOutside) {
            document.addEventListener('click', this.handleClick, false);
          }

          if (this.props.handleEscapeKeydown) {
            document.addEventListener('keydown', this.handleKeydown, false);
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (this.props.handleClickOutside) {
            document.removeEventListener('click', this.handleClick, false);
          }

          if (this.props.handleEscapeKeydown) {
            document.removeEventListener('keydown', this.handleKeydown, false);
          }
        }
      }, {
        key: "render",
        value: function render() {
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Component, this.props);
        }
      }]);

      return WithOutsideClick;
    }(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"])
  );
}

/***/ }),
/* 1994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getKeyframeName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimationWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(1995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__);


function _templateObject4() {
  var data = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_taggedTemplateLiteral___default()(["translateX(", "px)"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_taggedTemplateLiteral___default()(["translateX(", "px)"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_taggedTemplateLiteral___default()(["translateY(", "px)"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_taggedTemplateLiteral___default()(["translateY(", "px)"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}



var createBold = __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akAnimationMixins"].createBold,
    interpolate = __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akAnimationMixins"].interpolate; // animation constants

var animDistance = 2 * __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akGridSizeUnitless"];
var animDelay = 0.1;
var animTime = animDelay + 1; // properties to animate

var slideUp = {
  property: 'transform',
  value: interpolate(_templateObject(), function (t) {
    return t;
  }),
  deltas: [{
    from: animDistance,
    to: 0
  }]
};
var slideDown = {
  property: 'transform',
  value: interpolate(_templateObject2(), function (t) {
    return t;
  }),
  deltas: [{
    from: -animDistance,
    to: 0
  }]
};
var slideLeft = {
  property: 'transform',
  value: interpolate(_templateObject3(), function (t) {
    return t;
  }),
  deltas: [{
    from: animDistance,
    to: 0
  }]
};
var slideRight = {
  property: 'transform',
  value: interpolate(_templateObject4(), function (t) {
    return t;
  }),
  deltas: [{
    from: -animDistance,
    to: 0
  }]
};
var fadeIn = {
  property: 'opacity',
  deltas: [{
    from: 0,
    to: 1
  }]
};
var KEYFRAMES = {
  bottom: Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(["", ""], createBold([slideDown, fadeIn])),
  left: Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(["", ""], createBold([slideLeft, fadeIn])),
  right: Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(["", ""], createBold([slideRight, fadeIn])),
  top: Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(["", ""], createBold([slideUp, fadeIn]))
};
var KEYFRAMES_FLIPPED = {
  bottom: KEYFRAMES.top,
  left: KEYFRAMES.right,
  right: KEYFRAMES.left,
  top: KEYFRAMES.bottom
};
var getKeyframeName = function getKeyframeName(props) {
  var position = props.position,
      isFlipped = props.isFlipped;
  var mainPosition = position.split(' ')[0];
  return isFlipped ? KEYFRAMES_FLIPPED[mainPosition] : KEYFRAMES[mainPosition];
};
var AnimationWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div.withConfig({
  displayName: "Trigger__AnimationWrapper",
  componentId: "sc-1g1sd6n-0"
})(["\n  animation: ", " ", "s ", "s\n    backwards;\n"], function (props) {
  return getKeyframeName(props);
}, animTime, animDelay);

/***/ }),
/* 1995 */
/***/ (function(module, exports) {

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

module.exports = _taggedTemplateLiteral;

/***/ }),
/* 1996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isBody */
/* unused harmony export isTextNode */
/* unused harmony export getVerticalPlacement */
/* unused harmony export getHorizontalPlacement */
/* harmony export (immutable) */ __webpack_exports__["a"] = calculatePlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = calculatePosition;
/* harmony export (immutable) */ __webpack_exports__["c"] = findOverflowScrollParent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

function isBody(elem) {
    return elem === document.body;
}
function isTextNode(elem) {
    return elem && elem.nodeType === 3;
}
/**
 * Decides if given fitHeight fits below or above the target taking boundaries into account.
 */
function getVerticalPlacement(target, boundariesElement, fitHeight, alignY) {
    if (alignY) {
        return alignY;
    }
    if (!fitHeight) {
        return 'bottom';
    }
    if (isTextNode(target)) {
        target = target.parentElement;
    }
    var boundariesClientRect = boundariesElement.getBoundingClientRect();
    var boundariesHeight = boundariesClientRect.height;
    var boundariesTop = isBody(boundariesElement)
        ? 0
        : boundariesClientRect.top;
    var _a = target.getBoundingClientRect(), targetTop = _a.top, targetHeight = _a.height;
    var spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
    var spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
    if (spaceBelow >= fitHeight || spaceBelow >= spaceAbove) {
        return 'bottom';
    }
    return 'top';
}
/**
 * Decides if given fitWidth fits to the left or to the right of the target taking boundaries into account.
 */
function getHorizontalPlacement(target, boundariesElement, fitWidth, alignX) {
    if (alignX) {
        return alignX;
    }
    if (!fitWidth) {
        return 'left';
    }
    if (isTextNode(target)) {
        target = target.parentElement;
    }
    var _a = target.getBoundingClientRect(), targetLeft = _a.left, targetWidth = _a.width;
    var _b = boundariesElement.getBoundingClientRect(), boundariesLeft = _b.left, boundariesWidth = _b.width;
    var spaceLeft = targetLeft - boundariesLeft + targetWidth;
    var spaceRight = boundariesLeft + boundariesWidth - targetLeft;
    if (spaceRight >= fitWidth || spaceRight >= spaceLeft) {
        return 'left';
    }
    return 'right';
}
function calculatePlacement(target, boundariesElement, fitWidth, fitHeight, alignX, alignY) {
    return [
        getVerticalPlacement(target, boundariesElement, fitHeight, alignY),
        getHorizontalPlacement(target, boundariesElement, fitWidth, alignX),
    ];
}
var calculateHorizontalPlacement = function (_a) {
    var placement = _a.placement, targetLeft = _a.targetLeft, targetRight = _a.targetRight, targetWidth = _a.targetWidth, isPopupParentBody = _a.isPopupParentBody, popupOffsetParentLeft = _a.popupOffsetParentLeft, popupOffsetParentRight = _a.popupOffsetParentRight, popupOffsetParentScrollLeft = _a.popupOffsetParentScrollLeft, popupClientWidth = _a.popupClientWidth, offset = _a.offset;
    var position = {};
    if (placement === 'left') {
        position.left = Math.ceil(targetLeft -
            popupOffsetParentLeft +
            (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) +
            offset[0]);
    }
    else if (placement === 'center') {
        position.left = Math.ceil(targetLeft -
            popupOffsetParentLeft +
            (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) +
            offset[0] +
            targetWidth / 2 -
            popupClientWidth / 2);
    }
    else {
        position.right = Math.ceil(popupOffsetParentRight -
            targetRight -
            (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) +
            offset[0]);
    }
    return position;
};
var calculateVerticalStickBottom = function (_a) {
    var target = _a.target, targetTop = _a.targetTop, targetHeight = _a.targetHeight, popup = _a.popup, offset = _a.offset, position = _a.position;
    var scrollParent = findOverflowScrollParent(target);
    var newPos = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, position);
    if (scrollParent) {
        var topOffsetTop = targetTop - scrollParent.getBoundingClientRect().top;
        var targetEnd = targetHeight + topOffsetTop;
        if (scrollParent.clientHeight - targetEnd <=
            popup.clientHeight + offset[1] * 2 &&
            topOffsetTop < scrollParent.clientHeight) {
            var scroll_1 = targetEnd - scrollParent.clientHeight + offset[1] * 2;
            var top_1 = newPos.top || 0;
            top_1 = top_1 - (scroll_1 + popup.clientHeight);
            newPos.top = top_1;
        }
    }
    return newPos;
};
var calculateVerticalStickTop = function (_a) {
    var target = _a.target, targetTop = _a.targetTop, targetHeight = _a.targetHeight, popupOffsetParentHeight = _a.popupOffsetParentHeight, popupOffsetParent = _a.popupOffsetParent, popup = _a.popup, offset = _a.offset, position = _a.position;
    var scrollParent = findOverflowScrollParent(target);
    var newPos = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, position);
    if (scrollParent) {
        var scrollParentTop = scrollParent.getBoundingClientRect().top;
        var topBoundary = targetTop - scrollParentTop;
        var scrollParentScrollTop = scrollParent.scrollTop;
        if (topBoundary < 0) {
            if (targetTop +
                (scrollParentScrollTop - scrollParentTop) +
                targetHeight +
                offset[1] <
                scrollParentScrollTop) {
                newPos.bottom =
                    popupOffsetParentHeight -
                        (topBoundary + popupOffsetParent.scrollTop + targetHeight);
            }
            else {
                newPos.bottom += topBoundary;
            }
        }
    }
    return newPos;
};
var calculateVerticalPlacement = function (_a) {
    var placement = _a.placement, targetTop = _a.targetTop, targetHeight = _a.targetHeight, isPopupParentBody = _a.isPopupParentBody, popupOffsetParentHeight = _a.popupOffsetParentHeight, popupOffsetParentTop = _a.popupOffsetParentTop, popupOffsetParentScrollTop = _a.popupOffsetParentScrollTop, borderBottomWidth = _a.borderBottomWidth, offset = _a.offset;
    var position = {};
    if (placement === 'top') {
        position.bottom = Math.ceil(popupOffsetParentHeight -
            (targetTop - popupOffsetParentTop) -
            (isPopupParentBody ? 0 : popupOffsetParentScrollTop) -
            borderBottomWidth +
            offset[1]);
    }
    else {
        var top_2 = Math.ceil(targetTop -
            popupOffsetParentTop +
            targetHeight +
            (isPopupParentBody ? 0 : popupOffsetParentScrollTop) -
            borderBottomWidth +
            offset[1]);
        position.top = top_2;
    }
    return position;
};
/**
 * Calculates relative coordinates for placing popup along with the target.
 * Uses placement from calculatePlacement.
 */
function calculatePosition(_a) {
    var placement = _a.placement, target = _a.target, popup = _a.popup, offset = _a.offset, stick = _a.stick;
    var position = {};
    if (!target || !popup || !popup.offsetParent) {
        return position;
    }
    if (isTextNode(target)) {
        target = target.parentElement;
    }
    var popupOffsetParent = popup.offsetParent;
    var offsetParentStyle = popupOffsetParent.style;
    var borderBottomWidth = 0;
    if (offsetParentStyle && offsetParentStyle.borderBottomWidth) {
        borderBottomWidth = parseInt(offsetParentStyle.borderBottomWidth, 10);
    }
    var _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](placement, 2), verticalPlacement = _b[0], horizontalPlacement = _b[1];
    var _c = popupOffsetParent.getBoundingClientRect(), popupOffsetParentTop = _c.top, popupOffsetParentLeft = _c.left, popupOffsetParentRight = _c.right, popupOffsetParentHeight = _c.height;
    var _d = target.getBoundingClientRect(), targetTop = _d.top, targetLeft = _d.left, targetRight = _d.right, targetHeight = _d.height, targetWidth = _d.width;
    var isPopupParentBody = isBody(popupOffsetParent);
    var verticalPosition = calculateVerticalPlacement({
        placement: verticalPlacement,
        targetTop: targetTop,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentHeight: popupOffsetParentHeight,
        popupOffsetParentTop: popupOffsetParentTop,
        popupOffsetParentScrollTop: popupOffsetParent.scrollTop || 0,
        targetHeight: targetHeight,
        borderBottomWidth: borderBottomWidth,
        offset: offset,
    });
    position = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, position, verticalPosition);
    if (verticalPlacement !== 'top' && stick) {
        position = calculateVerticalStickBottom({
            target: target,
            targetTop: targetTop,
            targetHeight: targetHeight,
            popup: popup,
            offset: offset,
            position: position,
        });
    }
    if (verticalPlacement === 'top' && stick) {
        position = calculateVerticalStickTop({
            target: target,
            targetTop: targetTop,
            targetHeight: targetHeight,
            popupOffsetParentHeight: popupOffsetParentHeight,
            popupOffsetParent: popupOffsetParent,
            popup: popup,
            offset: offset,
            position: position,
        });
    }
    var horizontalPosition = calculateHorizontalPlacement({
        placement: horizontalPlacement,
        targetLeft: targetLeft,
        targetRight: targetRight,
        targetWidth: targetWidth,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentLeft: popupOffsetParentLeft,
        popupOffsetParentRight: popupOffsetParentRight,
        popupOffsetParentScrollLeft: popupOffsetParent.scrollLeft || 0,
        popupClientWidth: popup.clientWidth || 0,
        offset: offset,
    });
    position = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, position, horizontalPosition);
    return position;
}
/**
 * Traverse DOM Tree upwards looking for popup parents with "overflow: scroll".
 */
function findOverflowScrollParent(popup) {
    var parent = popup;
    if (!parent) {
        return false;
    }
    while ((parent = parent.parentElement)) {
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        var style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' ||
            style.overflowX === 'scroll' ||
            style.overflowY === 'scroll' ||
            parent.classList.contains('fabric-editor-popup-scroll-parent')) {
            return parent;
        }
    }
    return false;
}
//# sourceMappingURL=utils.js.map

/***/ }),
/* 1997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__ = __webpack_require__(3);





// tslint:disable-next-line:variable-name
var BlockNode = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  align-items: center;\n  background: ", ";\n  border: 1px dashed ", ";\n  border-radius: ", "px;\n  box-sizing: border-box;\n  cursor: default;\n  display: block;\n  font-size: 13px;\n  margin: 10px 0;\n  min-height: 24px;\n  padding: 10px;\n  text-align: center;\n  user-select: all;\n  vertical-align: text-bottom;\n  white-space: nowrap;\n\n  '&.ProseMirror-selectednode' {\n    background: ", ";\n    outline: none;\n  }\n"], ["\n  align-items: center;\n  background: ", ";\n  border: 1px dashed ", ";\n  border-radius: ", "px;\n  box-sizing: border-box;\n  cursor: default;\n  display: block;\n  font-size: 13px;\n  margin: 10px 0;\n  min-height: 24px;\n  padding: 10px;\n  text-align: center;\n  user-select: all;\n  vertical-align: text-bottom;\n  white-space: nowrap;\n\n  '&.ProseMirror-selectednode' {\n    background: ", ";\n    outline: none;\n  }\n"])), __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N30, __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N50, Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["borderRadius"])(), __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N50);
var UnsupportedBlockNode = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](UnsupportedBlockNode, _super);
    function UnsupportedBlockNode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UnsupportedBlockNode.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](BlockNode, null, "Unsupported content");
    };
    return UnsupportedBlockNode;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* unused harmony default export */ var _unused_webpack_default_export = (UnsupportedBlockNode);
var templateObject_1;
//# sourceMappingURL=index.js.map

/***/ }),
/* 1998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = mapBreakpointToLayoutMaxWidth;
/* harmony export (immutable) */ __webpack_exports__["a"] = BaseTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WidthProvider__ = __webpack_require__(734);




function mapBreakpointToFontSize(breakpoint) {
    switch (breakpoint) {
        case __WEBPACK_IMPORTED_MODULE_3__WidthProvider__["a" /* Breakpoints */].M:
            return Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["fontSize"])() + 2;
        case __WEBPACK_IMPORTED_MODULE_3__WidthProvider__["a" /* Breakpoints */].L:
            return Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["fontSize"])() + 4;
        default:
            return Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["fontSize"])();
    }
}
function mapBreakpointToLayoutMaxWidth(breakpoint) {
    switch (breakpoint) {
        case __WEBPACK_IMPORTED_MODULE_3__WidthProvider__["a" /* Breakpoints */].M:
            return 760;
        case __WEBPACK_IMPORTED_MODULE_3__WidthProvider__["a" /* Breakpoints */].L:
            return 850;
        default:
            return 680;
    }
}
function BaseTheme(_a) {
    var children = _a.children, dynamicTextSizing = _a.dynamicTextSizing;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__WidthProvider__["b" /* WidthConsumer */], null, function (_a) {
        var breakpoint = _a.breakpoint;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_styled_components__["ThemeProvider"], { theme: {
                baseFontSize: dynamicTextSizing
                    ? mapBreakpointToFontSize(breakpoint)
                    : mapBreakpointToFontSize(__WEBPACK_IMPORTED_MODULE_3__WidthProvider__["a" /* Breakpoints */].S),
                layoutMaxWidth: dynamicTextSizing
                    ? mapBreakpointToLayoutMaxWidth(breakpoint)
                    : mapBreakpointToLayoutMaxWidth(__WEBPACK_IMPORTED_MODULE_3__WidthProvider__["a" /* Breakpoints */].S),
            } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, children)));
    }));
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 1999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SizeDetector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_raf_schd__ = __webpack_require__(75);









 // Need to make outer div full height in case consumer wants to align
// child content vertically center. These styles can be overridden by the
// product using the optional SizeDetector.containerStyle prop.

var containerDivStyle = {
  height: '100%',
  flex: '1 0 auto',
  position: 'relative'
}; // Not using styled-components here for performance
// and framework-agnostic reasons.

var objectStyle = {
  display: 'block',
  position: 'absolute',
  top: 0,
  left: 0,
  height: '100%',
  width: '100%',
  opacity: 0,
  overflow: 'hidden',
  pointerEvents: 'none',
  zIndex: -1
};

var SizeDetector =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(SizeDetector, _Component);

  function SizeDetector(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, SizeDetector);

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(SizeDetector).call(this, props));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "props", void 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", void 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "container", void 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "resizeObjectDocument", void 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "resizeObject", void 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleResize", Object(__WEBPACK_IMPORTED_MODULE_9_raf_schd__["a" /* default */])(function () {
      var _assertThisInitialize = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)),
          container = _assertThisInitialize.container;

      if (!container) {
        return;
      }

      var sizeMetrics = {
        width: container.offsetWidth,
        height: container.offsetHeight
      };

      _this.setState({
        sizeMetrics: sizeMetrics
      });

      if (_this.props.onResize) {
        _this.props.onResize(sizeMetrics);
      }
    }));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleContainerRef", function (ref) {
      if (!ref) {
        return;
      }

      _this.container = ref;

      _this.handleResize();
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleObjectRef", function (ref) {
      if (!ref) {
        return;
      }

      _this.resizeObject = ref;
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleObjectLoad", function () {
      if (!_this.resizeObject) {
        return;
      } // $FlowFixMe - resizeObject is typed as HTMLElement which has no contentDocument prop


      _this.resizeObjectDocument = _this.resizeObject.contentDocument.defaultView;

      _this.resizeObjectDocument.addEventListener('resize', _this.handleResize); // Calculate width first time, after object has loaded.
      // Prevents it from getting in a weird state where width is always 0.


      _this.handleResize();
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "renderChildren", function () {
      var sizeMetrics = _this.state.sizeMetrics;

      if (!sizeMetrics) {
        return null;
      }

      return _this.props.children(sizeMetrics);
    });

    _this.state = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(SizeDetector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.resizeObject) {
        // $FlowFixMe - resizeObject is HTMLElement which doesn't contain .data prop
        this.resizeObject.data = 'about:blank';
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.cancel();

      if (this.resizeObjectDocument) {
        this.resizeObjectDocument.removeEventListener('resize', this.handleResize);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", {
        style: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, containerDivStyle, this.props.containerStyle),
        ref: this.handleContainerRef
      }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("object", {
        type: "text/html",
        style: objectStyle,
        ref: this.handleObjectRef,
        onLoad: this.handleObjectLoad,
        "aria-hidden": true,
        tabIndex: -1
      }), this.renderChildren());
    }
  }]);

  return SizeDetector;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(SizeDetector, "defaultProps", {
  // eslint-disable-line react/sort-comp
  containerStyle: {}
});



/***/ }),
/* 2000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ADFTraversor = /** @class */ (function () {
    function ADFTraversor(doc) {
        this.subscribers = new Map();
        this.doc = doc;
    }
    ADFTraversor.prototype.subscribe = function (type, callback) {
        var callbacks = this.subscribers.get(type);
        if (!callbacks) {
            this.subscribers.set(type, [callback]);
        }
        else {
            callbacks.push(callback);
        }
    };
    ADFTraversor.prototype.exec = function () {
        if (!this.doc || !Array.isArray(this.doc.content)) {
            return;
        }
        var candidates = this.doc.content.slice(0);
        while (candidates.length) {
            var node = candidates.shift();
            if (Array.isArray(node.content)) {
                candidates = candidates.concat(node.content);
            }
            var callbacks = this.subscribers.get(node.type);
            if (!callbacks) {
                continue;
            }
            for (var i = 0; i < callbacks.length; i++) {
                callbacks[i](node);
            }
        }
    };
    return ADFTraversor;
}());
/* unused harmony default export */ var _unused_webpack_default_export = (ADFTraversor);
//# sourceMappingURL=traversor.js.map

/***/ }),
/* 2001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_view__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prosemirror_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event_dispatcher__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__create_plugins_list__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_editor_disabled__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__create_editor__ = __webpack_require__(2789);











var ReactEditorView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ReactEditorView, _super);
    function ReactEditorView(props) {
        var _this = _super.call(this, props) || this;
        _this.broadcastDisabled = function (disabled) {
            var editorView = _this.view;
            if (editorView) {
                var tr = editorView.state.tr.setMeta(__WEBPACK_IMPORTED_MODULE_9__plugins_editor_disabled__["b" /* pluginKey */], {
                    editorDisabled: disabled,
                });
                tr.setMeta('isLocal', true);
                editorView.dispatch(tr);
            }
        };
        _this.createEditorState = function (options) {
            if (_this.view) {
                /**
                 * There's presently a number of issues with changing the schema of a
                 * editor inflight. A significant issue is that we lose the ability
                 * to keep track of a user's history as the internal plugin state
                 * keeps a list of Steps to undo/redo (which are tied to the schema).
                 * Without a good way to do work around this, we prevent this for now.
                 */
                // tslint:disable-next-line:no-console
                console.warn('The editor does not support changing the schema dynamically.');
                return _this.editorState;
            }
            _this.config = Object(__WEBPACK_IMPORTED_MODULE_10__create_editor__["e" /* processPluginsList */])(_this.getPlugins(options.props.editorProps, options.props.createAnalyticsEvent), options.props.editorProps);
            var schema = Object(__WEBPACK_IMPORTED_MODULE_10__create_editor__["c" /* createSchema */])(_this.config);
            var _a = options.props.editorProps, contentTransformerProvider = _a.contentTransformerProvider, defaultValue = _a.defaultValue, errorReporterHandler = _a.errorReporterHandler;
            _this.eventDispatcher = new __WEBPACK_IMPORTED_MODULE_6__event_dispatcher__["a" /* EventDispatcher */]();
            var dispatch = Object(__WEBPACK_IMPORTED_MODULE_6__event_dispatcher__["b" /* createDispatch */])(_this.eventDispatcher);
            var errorReporter = Object(__WEBPACK_IMPORTED_MODULE_10__create_editor__["a" /* createErrorReporter */])(errorReporterHandler);
            var plugins = Object(__WEBPACK_IMPORTED_MODULE_10__create_editor__["b" /* createPMPlugins */])({
                schema: schema,
                dispatch: dispatch,
                errorReporter: errorReporter,
                editorConfig: _this.config,
                props: options.props.editorProps,
                eventDispatcher: _this.eventDispatcher,
                providerFactory: options.props.providerFactory,
                portalProviderAPI: _this.props.portalProviderAPI,
                reactContext: function () { return _this.context; },
            });
            _this.contentTransformer = contentTransformerProvider
                ? contentTransformerProvider(schema)
                : undefined;
            var doc;
            if (options.replaceDoc) {
                doc =
                    _this.contentTransformer && typeof defaultValue === 'string'
                        ? _this.contentTransformer.parse(defaultValue)
                        : Object(__WEBPACK_IMPORTED_MODULE_7__utils__["E" /* processRawValue */])(schema, defaultValue);
            }
            var selection;
            if (doc) {
                // ED-4759: Don't set selection at end for full-page editor - should be at start
                selection =
                    options.props.editorProps.appearance === 'full-page'
                        ? __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["Selection"].atStart(doc)
                        : __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["Selection"].atEnd(doc);
            }
            // Workaround for ED-3507: When media node is the last element, scrollIntoView throws an error
            var patchedSelection = selection
                ? __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["Selection"].findFrom(selection.$head, -1, true) || undefined
                : undefined;
            return __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["EditorState"].create({
                schema: schema,
                plugins: plugins,
                doc: doc,
                selection: patchedSelection,
            });
        };
        _this.createEditorView = function (node) {
            // Creates the editor-view from this.editorState. If an editor has been mounted
            // previously, this will contain the previous state of the editor.
            _this.view = new __WEBPACK_IMPORTED_MODULE_4_prosemirror_view__["EditorView"]({ mount: node }, {
                state: _this.editorState,
                dispatchTransaction: function (transaction) {
                    if (!_this.view) {
                        return;
                    }
                    var editorState = _this.view.state.apply(transaction);
                    _this.view.updateState(editorState);
                    if (_this.props.editorProps.onChange && transaction.docChanged) {
                        _this.props.editorProps.onChange(_this.view);
                    }
                    _this.editorState = editorState;
                },
                // Disables the contentEditable attribute of the editor if the editor is disabled
                editable: function (state) { return !_this.props.editorProps.disabled; },
                attributes: { 'data-gramm': 'false' },
            });
        };
        _this.handleEditorViewRef = function (node) {
            if (!_this.view && node) {
                _this.createEditorView(node);
                _this.props.onEditorCreated({
                    view: _this.view,
                    config: _this.config,
                    eventDispatcher: _this.eventDispatcher,
                    transformer: _this.contentTransformer,
                });
                // Set the state of the EditorDisabled plugin to the current value
                _this.broadcastDisabled(!!_this.props.editorProps.disabled);
                // Force React to re-render so consumers get a reference to the editor view
                _this.forceUpdate();
            }
            else if (_this.view && !node) {
                // When the appearance is changed, React will call handleEditorViewRef with node === null
                // to destroy the old EditorView, before calling this method again with node === div to
                // create the new EditorView
                _this.props.onEditorDestroyed({
                    view: _this.view,
                    config: _this.config,
                    eventDispatcher: _this.eventDispatcher,
                    transformer: _this.contentTransformer,
                });
                _this.view.destroy(); // Destroys the dom node & all node views
                _this.view = undefined;
            }
        };
        Object(__WEBPACK_IMPORTED_MODULE_10__create_editor__["d" /* initAnalytics */])(props.editorProps.analyticsHandler);
        _this.editorState = _this.createEditorState({ props: props, replaceDoc: true });
        return _this;
    }
    ReactEditorView.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.view &&
            this.props.editorProps.disabled !== nextProps.editorProps.disabled) {
            this.broadcastDisabled(!!nextProps.editorProps.disabled);
            // Disables the contentEditable attribute of the editor if the editor is disabled
            this.view.setProps({
                editable: function (state) { return !nextProps.editorProps.disabled; },
            });
        }
    };
    /**
     * Clean up any non-PM resources when the editor is unmounted
     */
    ReactEditorView.prototype.componentWillUnmount = function () {
        this.eventDispatcher.destroy();
        if (this.view) {
            // Destroy the state if the Editor is being unmounted
            var editorState_1 = this.view.state;
            editorState_1.plugins.forEach(function (plugin) {
                var state = plugin.getState(editorState_1);
                if (state && state.destroy) {
                    state.destroy();
                }
            });
        }
        // this.view will be destroyed when React unmounts in handleEditorViewRef
    };
    // Helper to allow tests to inject plugins directly
    ReactEditorView.prototype.getPlugins = function (editorProps, createAnalyticsEvent) {
        return Object(__WEBPACK_IMPORTED_MODULE_8__create_plugins_list__["a" /* default */])(editorProps, createAnalyticsEvent);
    };
    ReactEditorView.prototype.render = function () {
        var editor = __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: "ProseMirror", ref: this.handleEditorViewRef });
        return this.props.render
            ? this.props.render({
                editor: editor,
                view: this.view,
                config: this.config,
                eventDispatcher: this.eventDispatcher,
                transformer: this.contentTransformer,
            })
            : editor;
    };
    ReactEditorView.contextTypes = {
        getAtlaskitAnalyticsEventHandlers: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
        intl: __WEBPACK_IMPORTED_MODULE_5_react_intl__["intlShape"],
    };
    return ReactEditorView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ReactEditorView);
//# sourceMappingURL=ReactEditorView.js.map

/***/ }),
/* 2002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JSONTransformer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__ = __webpack_require__(19);


var isType = function (type) { return function (node) {
    return node.type.name === type;
}; };
var isCodeBlock = isType('codeBlock');
var isMediaNode = isType('media');
var isMediaSingleNode = isType('mediaSingle');
var isMentionNode = isType('mention');
var isParagraph = isType('paragraph');
var isHeading = isType('heading');
var isTable = isType('table');
var isTableCell = isType('tableCell');
var isTableHeader = isType('tableHeader');
var isLinkMark = isType('link');
var isUnsupportedNode = function (node) {
    return isType('unsupportedBlock')(node) || isType('unsupportedInline')(node);
};
var filterNull = function (subject) {
    return Object.keys(subject).reduce(function (acc, key) {
        var _a;
        var current = subject[key];
        if (current === null) {
            return acc;
        }
        if (typeof current === 'object' && !Array.isArray(current)) {
            current = filterNull(current);
        }
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, acc, (_a = {}, _a[key] = current, _a));
    }, {});
};
var toJSON = function (node) {
    var obj = { type: node.type.name };
    if (isUnsupportedNode(node)) {
        return node.attrs.originalValue;
    }
    else if (isMediaNode(node)) {
        obj.attrs = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["V" /* mediaToJSON */])(node).attrs;
    }
    else if (isMediaSingleNode(node)) {
        obj.attrs = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["U" /* mediaSingleToJSON */])(node).attrs;
    }
    else if (isMentionNode(node)) {
        obj.attrs = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["X" /* mentionToJSON */])(node).attrs;
    }
    else if (isCodeBlock(node)) {
        obj.attrs = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["n" /* codeBlockToJSON */])(node).attrs;
    }
    else if (isTable(node)) {
        obj.attrs = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["_15" /* tableToJSON */])(node).attrs;
    }
    else if (isTableCell(node)) {
        obj.attrs = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["_20" /* toJSONTableCell */])(node).attrs;
    }
    else if (isTableHeader(node)) {
        obj.attrs = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["_21" /* toJSONTableHeader */])(node).attrs;
    }
    else if (Object.keys(node.attrs).length) {
        obj.attrs = node.attrs;
    }
    if (obj.attrs) {
        obj.attrs = filterNull(obj.attrs);
    }
    if (node.isText) {
        obj.text = node.textContent;
    }
    else {
        node.content.forEach(function (child) {
            obj.content = obj.content || [];
            obj.content.push(toJSON(child));
        });
    }
    if (isParagraph(node) || isHeading(node)) {
        obj.content = obj.content || [];
    }
    if (node.marks.length) {
        obj.marks = node.marks.map(function (n) {
            if (isLinkMark(n)) {
                return Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["P" /* linkToJSON */])(n);
            }
            return n.toJSON();
        });
    }
    return obj;
};
var JSONTransformer = /** @class */ (function () {
    function JSONTransformer() {
    }
    JSONTransformer.prototype.encode = function (node) {
        var content = [];
        node.content.forEach(function (child) {
            content.push(toJSON(child));
        });
        return {
            version: 1,
            type: 'doc',
            content: content,
        };
    };
    JSONTransformer.prototype.parse = function (content) {
        if (content.type !== 'doc') {
            throw new Error('Expected content format to be ADF');
        }
        var doc = __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["x" /* defaultSchema */].nodeFromJSON(content);
        doc.check();
        return doc;
    };
    return JSONTransformer;
}());

//# sourceMappingURL=index.js.map

/***/ }),
/* 2003 */
/***/ (function(module, exports) {

var base = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'",
  229: "q"
}
var shift = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ";",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: "\"",
  229: "Q"
}

var chrome = typeof navigator != "undefined" && /Chrome\/(\d+)/.exec(navigator.userAgent)
var safari = typeof navigator != "undefined" && /Apple Computer/.test(navigator.vendor)
var gecko = typeof navigator != "undefined" && /Gecko\/\d+/.test(navigator.userAgent)
var mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform)
var brokenModifierNames = chrome && (mac || +chrome[1] < 57) || gecko && mac

// Fill in the digit keys
for (var i = 0; i < 10; i++) base[48 + i] = base[96 + i] = String(i)

// The function keys
for (var i = 1; i <= 24; i++) base[i + 111] = "F" + i

// And the alphabetic keys
for (var i = 65; i <= 90; i++) {
  base[i] = String.fromCharCode(i + 32)
  shift[i] = String.fromCharCode(i)
}

// For each code that doesn't have a shift-equivalent, copy the base name
for (var code in base) if (!shift.hasOwnProperty(code)) shift[code] = base[code]

function keyName(event) {
  // Don't trust event.key in Chrome when there are modifiers until
  // they fix https://bugs.chromium.org/p/chromium/issues/detail?id=633838
  var ignoreKey = brokenModifierNames && (event.ctrlKey || event.altKey || event.metaKey) ||
    safari && event.shiftKey && event.key && event.key.length == 1
  var name = (!ignoreKey && event.key) ||
    (event.shiftKey ? shift : base)[event.keyCode] ||
    event.key || "Unidentified"
  // Edge sometimes produces wrong names (Issue #3)
  if (name == "Esc") name = "Escape"
  if (name == "Del") name = "Delete"
  // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
  if (name == "Left") name = "ArrowLeft"
  if (name == "Up") name = "ArrowUp"
  if (name == "Right") name = "ArrowRight"
  if (name == "Down") name = "ArrowDown"
  return name
}

module.exports = keyName
keyName.base = base
keyName.shift = shift


/***/ }),
/* 2004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__marks_action__ = __webpack_require__(2005);
/* unused harmony reexport action */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__marks_breakout__ = __webpack_require__(2007);
/* unused harmony reexport breakout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__marks_code__ = __webpack_require__(2008);
/* unused harmony reexport code */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__marks_em__ = __webpack_require__(2009);
/* unused harmony reexport em */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__marks_link__ = __webpack_require__(736);
/* unused harmony reexport link */
/* unused harmony reexport a */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__marks_strike__ = __webpack_require__(2010);
/* unused harmony reexport strike */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__marks_strong__ = __webpack_require__(737);
/* unused harmony reexport strong */
/* unused harmony reexport b */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__marks_subsup__ = __webpack_require__(2011);
/* unused harmony reexport subsup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__marks_text_color__ = __webpack_require__(2012);
/* unused harmony reexport textColor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__marks_underline__ = __webpack_require__(738);
/* unused harmony reexport underline */
/* unused harmony reexport u */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__marks_alignment__ = __webpack_require__(2013);
/* unused harmony reexport alignment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__marks_indentation__ = __webpack_require__(2014);
/* unused harmony reexport indentation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__nodes_blockquote__ = __webpack_require__(2015);
/* unused harmony reexport blockQuote */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__nodes_bodied_extension__ = __webpack_require__(2016);
/* unused harmony reexport bodiedExtension */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__nodes_block_card__ = __webpack_require__(2017);
/* unused harmony reexport blockCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__nodes_bullet_list__ = __webpack_require__(739);
/* unused harmony reexport bulletList */
/* unused harmony reexport ul */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__nodes_code_block__ = __webpack_require__(2018);
/* unused harmony reexport codeBlock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__nodes_date__ = __webpack_require__(2019);
/* unused harmony reexport date */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__nodes_decision_item__ = __webpack_require__(2020);
/* unused harmony reexport decisionItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__nodes_decision_list__ = __webpack_require__(2021);
/* unused harmony reexport decisionList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__nodes_doc__ = __webpack_require__(2022);
/* unused harmony reexport doc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__nodes_emoji__ = __webpack_require__(2023);
/* unused harmony reexport emoji */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__nodes_extension__ = __webpack_require__(2024);
/* unused harmony reexport extension */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__nodes_hard_break__ = __webpack_require__(740);
/* unused harmony reexport hardBreak */
/* unused harmony reexport br */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__nodes_heading__ = __webpack_require__(2025);
/* unused harmony reexport heading */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__nodes_inline_extension__ = __webpack_require__(2026);
/* unused harmony reexport inlineExtension */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__nodes_layout_column__ = __webpack_require__(2027);
/* unused harmony reexport layoutColumn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__nodes_layout_section__ = __webpack_require__(2028);
/* unused harmony reexport layoutSection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__nodes_list_item__ = __webpack_require__(741);
/* unused harmony reexport listItem */
/* unused harmony reexport li */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__nodes_media_group__ = __webpack_require__(2029);
/* unused harmony reexport mediaGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__nodes_media_single__ = __webpack_require__(2030);
/* unused harmony reexport mediaSingle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__nodes_media__ = __webpack_require__(2031);
/* unused harmony reexport media */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__nodes_mention__ = __webpack_require__(2032);
/* unused harmony reexport mention */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__nodes_ordered_list__ = __webpack_require__(742);
/* unused harmony reexport orderedList */
/* unused harmony reexport ol */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__nodes_panel__ = __webpack_require__(2033);
/* unused harmony reexport panel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__nodes_paragraph__ = __webpack_require__(743);
/* unused harmony reexport paragraph */
/* unused harmony reexport p */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__nodes_placeholder__ = __webpack_require__(2035);
/* unused harmony reexport placeholder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__nodes_rule__ = __webpack_require__(744);
/* unused harmony reexport rule */
/* unused harmony reexport hr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__nodes_table_cell__ = __webpack_require__(745);
/* unused harmony reexport tableCell */
/* unused harmony reexport td */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__nodes_table_header__ = __webpack_require__(746);
/* unused harmony reexport tableHeader */
/* unused harmony reexport th */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__nodes_table_row__ = __webpack_require__(747);
/* unused harmony reexport tableRow */
/* unused harmony reexport tr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__nodes_table__ = __webpack_require__(2036);
/* unused harmony reexport table */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__nodes_task_item__ = __webpack_require__(2037);
/* unused harmony reexport taskItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__nodes_task_list__ = __webpack_require__(2038);
/* unused harmony reexport taskList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__nodes_text__ = __webpack_require__(412);
/* unused harmony reexport text */
// Marks Builders















// Nodes Builders










































//# sourceMappingURL=index.js.map

/***/ }),
/* 2005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export action */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__ = __webpack_require__(82);

var action = function (attrs) { return function (maybeNode) { return Object(__WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__["a" /* applyMark */])({ type: 'action', attrs: attrs }, maybeNode); }; };
//# sourceMappingURL=action.js.map

/***/ }),
/* 2006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isDuplicateMark;
/* harmony export (immutable) */ __webpack_exports__["a"] = duplicateMarkError;
function isDuplicateMark(node, type) {
    if (node.marks && node.marks.some(function (mark) { return mark.type === type; })) {
        return true;
    }
    return false;
}
function duplicateMarkError(node, type) {
    return "Mark with the same name '" + type + "' already exists on a node: " + JSON.stringify(node);
}
//# sourceMappingURL=is-duplicate-mark.js.map

/***/ }),
/* 2007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export breakout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__ = __webpack_require__(82);

var breakout = function (attrs) { return function (maybeNode) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__["a" /* applyMark */])({ type: 'breakout', attrs: attrs }, maybeNode);
}; };
//# sourceMappingURL=breakout.js.map

/***/ }),
/* 2008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export code */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__ = __webpack_require__(82);

var code = function (maybeNode) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__["a" /* applyMark */])({ type: 'code' }, maybeNode);
};
//# sourceMappingURL=code.js.map

/***/ }),
/* 2009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export em */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__ = __webpack_require__(82);

var em = function (maybeNode) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__["a" /* applyMark */])({ type: 'em' }, maybeNode);
};
//# sourceMappingURL=em.js.map

/***/ }),
/* 2010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export strike */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__ = __webpack_require__(82);

var strike = function (maybeNode) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__["a" /* applyMark */])({ type: 'strike' }, maybeNode);
};
//# sourceMappingURL=strike.js.map

/***/ }),
/* 2011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export subsup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__ = __webpack_require__(82);

var subsup = function (attrs) { return function (maybeNode) { return Object(__WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__["a" /* applyMark */])({ type: 'subsup', attrs: attrs }, maybeNode); }; };
//# sourceMappingURL=subsup.js.map

/***/ }),
/* 2012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export textColor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__ = __webpack_require__(82);

var textColor = function (attrs) { return function (maybeNode) { return Object(__WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__["a" /* applyMark */])({ type: 'textColor', attrs: attrs }, maybeNode); }; };
//# sourceMappingURL=text-color.js.map

/***/ }),
/* 2013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export alignment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__ = __webpack_require__(82);

var alignment = function (attrs) { return function (maybeNode) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__["a" /* applyMark */])({ type: 'alignment', attrs: attrs }, maybeNode);
}; };
//# sourceMappingURL=alignment.js.map

/***/ }),
/* 2014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export indentation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__ = __webpack_require__(82);

var indentation = function (attrs) { return function (maybeNode) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_apply_mark__["a" /* applyMark */])({ type: 'indentation', attrs: attrs }, maybeNode);
}; };
//# sourceMappingURL=indentation.js.map

/***/ }),
/* 2015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export blockQuote */
var blockQuote = function () {
    var content = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        content[_i] = arguments[_i];
    }
    return ({
        type: 'blockquote',
        content: content,
    });
};
//# sourceMappingURL=blockquote.js.map

/***/ }),
/* 2016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bodiedExtension */
var bodiedExtension = function (attrs) { return function () {
    var content = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        content[_i] = arguments[_i];
    }
    return ({
        type: 'bodiedExtension',
        attrs: attrs,
        content: content,
    });
}; };
//# sourceMappingURL=bodied-extension.js.map

/***/ }),
/* 2017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export blockCard */
var blockCard = function (attrs) { return ({
    type: 'blockCard',
    attrs: attrs,
}); };
//# sourceMappingURL=block-card.js.map

/***/ }),
/* 2018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export codeBlock */
var codeBlock = function (attrs) { return function () {
    var content = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        content[_i] = arguments[_i];
    }
    return ({
        type: 'codeBlock',
        attrs: attrs,
        content: content,
    });
}; };
//# sourceMappingURL=code-block.js.map

/***/ }),
/* 2019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export date */
var date = function (attrs) {
    if (attrs === void 0) { attrs = { timestamp: '' }; }
    return ({
        type: 'date',
        attrs: attrs,
    });
};
//# sourceMappingURL=date.js.map

/***/ }),
/* 2020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export decisionItem */
var decisionItem = function (attrs) { return function () {
    var content = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        content[_i] = arguments[_i];
    }
    return ({
        type: 'decisionItem',
        attrs: attrs,
        content: content,
    });
}; };
//# sourceMappingURL=decision-item.js.map

/***/ }),
/* 2021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export decisionList */
var decisionList = function (attrs) { return function () {
    var content = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        content[_i] = arguments[_i];
    }
    return ({
        type: 'decisionList',
        attrs: attrs,
        content: content,
    });
}; };
//# sourceMappingURL=decision-list.js.map

/***/ }),
/* 2022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export doc */
var doc = function () {
    var content = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        content[_i] = arguments[_i];
    }
    return ({
        type: 'doc',
        version: 1,
        content: content,
    });
};
//# sourceMappingURL=doc.js.map

/***/ }),
/* 2023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export emoji */
var emoji = function (attrs) { return ({
    type: 'emoji',
    attrs: attrs,
}); };
//# sourceMappingURL=emoji.js.map

/***/ }),
/* 2024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export extension */
var extension = function (attrs) { return ({
    type: 'extension',
    attrs: attrs,
}); };
//# sourceMappingURL=extension.js.map

/***/ }),
/* 2025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export heading */
var heading = function (attrs) { return function () {
    var content = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        content[_i] = arguments[_i];
    }
    return ({
        type: 'heading',
        attrs: attrs,
        content: content,
    });
}; };
//# sourceMappingURL=heading.js.map

/***/ }),
/* 2026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export inlineExtension */
var inlineExtension = function (attrs) { return function () { return ({
    type: 'inlineExtension',
    attrs: attrs,
}); }; };
//# sourceMappingURL=inline-extension.js.map

/***/ }),
/* 2027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export layoutColumn */
var layoutColumn = function (attrs) { return function (content) { return ({
    type: 'layoutColumn',
    attrs: attrs,
    content: content,
}); }; };
//# sourceMappingURL=layout-column.js.map

/***/ }),
/* 2028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export layoutSection */
var layoutSection = function () { return function (content) { return ({
    type: 'layoutSection',
    content: content,
}); }; };
//# sourceMappingURL=layout-section.js.map

/***/ }),
/* 2029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mediaGroup */
var mediaGroup = function () {
    var content = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        content[_i] = arguments[_i];
    }
    return ({
        type: 'mediaGroup',
        content: content,
    });
};
//# sourceMappingURL=media-group.js.map

/***/ }),
/* 2030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mediaSingle */
var mediaSingle = function (attrs) { return function (content) { return ({
    type: 'mediaSingle',
    attrs: attrs,
    content: [content],
}); }; };
//# sourceMappingURL=media-single.js.map

/***/ }),
/* 2031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export media */
var media = function (attrs) { return ({
    type: 'media',
    attrs: attrs,
}); };
//# sourceMappingURL=media.js.map

/***/ }),
/* 2032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mention */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

var mention = function (attrs) { return ({
    type: 'mention',
    attrs: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ accessLevel: '' }, attrs),
}); };
//# sourceMappingURL=mention.js.map

/***/ }),
/* 2033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export panel */
var panel = function (attrs) { return function () {
    var content = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        content[_i] = arguments[_i];
    }
    return ({
        type: 'panel',
        attrs: attrs,
        content: content,
    });
}; };
//# sourceMappingURL=panel.js.map

/***/ }),
/* 2034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTextNodes;
/* unused harmony export createTextFromString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nodes_text__ = __webpack_require__(412);

function createTextNodes(nodes) {
    return nodes.map(createTextFromString);
}
function createTextFromString(str) {
    return typeof str === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_0__nodes_text__["a" /* text */])(str) : str;
}
//# sourceMappingURL=create-text-nodes.js.map

/***/ }),
/* 2035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export placeholder */
var placeholder = function (attrs) { return ({
    type: 'placeholder',
    attrs: attrs,
}); };
//# sourceMappingURL=placeholder.js.map

/***/ }),
/* 2036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export table */
var table = function () {
    var content = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        content[_i] = arguments[_i];
    }
    return ({
        type: 'table',
        content: content,
    });
};
//# sourceMappingURL=table.js.map

/***/ }),
/* 2037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export taskItem */
var taskItem = function (attrs) { return function () {
    var content = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        content[_i] = arguments[_i];
    }
    return ({
        type: 'taskItem',
        attrs: attrs,
        content: content,
    });
}; };
//# sourceMappingURL=task-item.js.map

/***/ }),
/* 2038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export taskList */
var taskList = function (attrs) { return function () {
    var content = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        content[_i] = arguments[_i];
    }
    return ({
        type: 'taskList',
        attrs: attrs,
        content: content,
    });
}; };
//# sourceMappingURL=task-list.js.map

/***/ }),
/* 2039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__traverse__ = __webpack_require__(269);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__traverse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__map__ = __webpack_require__(2040);
/* unused harmony reexport map */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reduce__ = __webpack_require__(2041);
/* unused harmony reexport reduce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filter__ = __webpack_require__(2042);
/* unused harmony reexport filter */




//# sourceMappingURL=index.js.map

/***/ }),
/* 2040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export map */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__traverse__ = __webpack_require__(269);

function map(adf, callback) {
    var result = [];
    Object(__WEBPACK_IMPORTED_MODULE_0__traverse__["a" /* traverse */])(adf, {
        any: function (node) {
            result.push(callback(node));
        },
    });
    return result;
}
//# sourceMappingURL=map.js.map

/***/ }),
/* 2041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reduce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__traverse__ = __webpack_require__(269);

function reduce(adf, callback, initial) {
    var result = initial;
    Object(__WEBPACK_IMPORTED_MODULE_0__traverse__["a" /* traverse */])(adf, {
        any: function (node) {
            result = callback(result, node);
        },
    });
    return result;
}
//# sourceMappingURL=reduce.js.map

/***/ }),
/* 2042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export filter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__traverse__ = __webpack_require__(269);

function filter(adf, callback) {
    var result = [];
    Object(__WEBPACK_IMPORTED_MODULE_0__traverse__["a" /* traverse */])(adf, {
        any: function (node) {
            if (callback(node)) {
                result.push(node);
            }
        },
    });
    return result;
}
//# sourceMappingURL=filter.js.map

/***/ }),
/* 2043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__specs__ = __webpack_require__(2044);


// tslint:disable-next-line:triple-equals
var isDefined = function (x) { return x != null; };
var isNumber = function (x) {
    return typeof x === 'number' && !isNaN(x) && isFinite(x);
};
var isBoolean = function (x) {
    return x === true || x === false || toString.call(x) === '[object Boolean]';
};
// This is a kludge, might replace with something like _.isString in future
var isString = function (s) {
    return typeof s === 'string' || s instanceof String;
};
var isPlainObject = function (x) {
    return typeof x === 'object' && x !== null && !Array.isArray(x);
};
var copy = function (source, dest, key) {
    dest[key] = source[key];
    return dest;
};
// Helpers
var makeArray = function (maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
};
function mapMarksItems(spec, fn) {
    if (fn === void 0) { fn = function (x) { return x; }; }
    var _a = spec.props.marks, items = _a.items, rest = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["items"]);
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, spec, { props: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, spec.props, { marks: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, rest, { 
                /**
                 * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
                 * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
                 */
                items: items.length
                    ? Array.isArray(items[0])
                        ? items.map(fn)
                        : [fn(items)]
                    : [[]] }) }) });
}
function createSpec(nodes, marks) {
    return Object.keys(__WEBPACK_IMPORTED_MODULE_1__specs__).reduce(function (newSpecs, k) {
        var spec = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, __WEBPACK_IMPORTED_MODULE_1__specs__[k]);
        if (spec.props) {
            spec.props = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, spec.props);
            if (isString(spec.props.content)) {
                spec.props.content = __WEBPACK_IMPORTED_MODULE_1__specs__[spec.props.content];
            }
            if (spec.props.content) {
                if (!spec.props.content.items) {
                    /**
                     * Flatten
                     *
                     * Input:
                     * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
                     *
                     * Output:
                     * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
                     */
                    spec.props.content = {
                        type: 'array',
                        items: (spec.props.content || []).map(function (arr) { return arr.items; }),
                    };
                }
                else {
                    spec.props.content = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, spec.props.content);
                }
                spec.props.content.items = spec.props.content.items
                    // ['inline'] => [['emoji', 'hr', ...]]
                    // ['media'] => [['media']]
                    .map(function (item) {
                    return isString(item)
                        ? Array.isArray(__WEBPACK_IMPORTED_MODULE_1__specs__[item])
                            ? __WEBPACK_IMPORTED_MODULE_1__specs__[item]
                            : [item]
                        : item;
                })
                    // [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                    .map(function (item) {
                    return item
                        .map(function (subItem) {
                        return Array.isArray(__WEBPACK_IMPORTED_MODULE_1__specs__[subItem])
                            ? __WEBPACK_IMPORTED_MODULE_1__specs__[subItem]
                            : isString(subItem)
                                ? subItem
                                : // Now `NoMark` produces `items: []`, should be fixed in generator
                                    ['text', subItem];
                    })
                        // Remove unsupported nodes & marks
                        // Filter nodes
                        .filter(function (subItem) {
                        // When Mark or `nodes` is undefined don't filter
                        return !nodes
                            ? true
                            : nodes.indexOf(Array.isArray(subItem) ? subItem[0] : subItem) > -1;
                    })
                        // Filter marks
                        .map(function (subItem) {
                        return Array.isArray(subItem) && marks
                            ? /**
                               * TODO: Probably try something like immer, but it's 3.3kb gzipped.
                               * Not worth it just for this.
                               */
                                [subItem[0], mapMarksItems(subItem[1])]
                            : subItem;
                    });
                });
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
function getOptionsForType(type, list) {
    var _a;
    if (!list) {
        return {};
    }
    for (var i = 0, len = list.length; i < len; i++) {
        var spec = list[i];
        var name_1 = spec;
        var options = {};
        if (Array.isArray(spec)) {
            _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](spec, 2), name_1 = _a[0], options = _a[1];
        }
        if (name_1 === type) {
            return options;
        }
    }
    return false;
}
function validateAttrs(spec, value) {
    // extension_node parameters has no type
    if (!isDefined(spec.type)) {
        return !!spec.optional;
    }
    if (!isDefined(value)) {
        return !!spec.optional;
    }
    switch (spec.type) {
        case 'boolean':
            return isBoolean(value);
        case 'number':
            return (isNumber(value) &&
                (isDefined(spec.minimum) ? spec.minimum <= value : true) &&
                (isDefined(spec.maximum) ? spec.maximum >= value : true));
        case 'string':
            return (isString(value) &&
                (isDefined(spec.minLength) ? spec.minLength <= value.length : true) &&
                (spec.pattern ? new RegExp(spec.pattern).test(value) : true));
        case 'object':
            return isPlainObject(value);
        case 'enum':
            return spec.values.indexOf(value) > -1;
    }
}
var getUnsupportedOptions = function (spec) {
    if (spec && spec.props && spec.props.content) {
        var _a = spec.props.content, allowUnsupportedBlock = _a.allowUnsupportedBlock, allowUnsupportedInline = _a.allowUnsupportedInline;
        return { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline };
    }
    return {};
};
var invalidChildContent = function (child, errorCallback, parentSpec) {
    var message = child.type + ": invalid content.";
    if (!errorCallback) {
        throw new Error(message);
    }
    else {
        return errorCallback(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, child), {
            code: "INVALID_CONTENT" /* INVALID_CONTENT */,
            message: message,
        }, getUnsupportedOptions(parentSpec));
    }
};
function validator(nodes, marks, options) {
    var validatorSpecs = createSpec(nodes, marks);
    var _a = options || {}, _b = _a.mode, mode = _b === void 0 ? 'strict' : _b, _c = _a.allowPrivateAttributes, allowPrivateAttributes = _c === void 0 ? false : _c;
    var validate = function (entity, errorCallback, allowed, parentSpec) {
        var type = entity.type;
        var newEntity = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, entity);
        var err = function (code, msg, meta) {
            var message = type + ": " + msg + ".";
            if (errorCallback) {
                return {
                    valid: false,
                    entity: errorCallback(newEntity, { code: code, message: message, meta: meta }, getUnsupportedOptions(parentSpec)),
                };
            }
            else {
                throw new Error(message);
            }
        };
        // Don't validate applicationCard
        if (type === 'applicationCard') {
            return err("DEPRECATED" /* DEPRECATED */, 'applicationCard is not supported');
        }
        if (type) {
            var typeOptions = getOptionsForType(type, allowed);
            if (typeOptions === false) {
                return err("INVALID_TYPE" /* INVALID_TYPE */, 'type not allowed here');
            }
            var spec = validatorSpecs[type];
            if (!spec) {
                return err("INVALID_TYPE" /* INVALID_TYPE */, type + ": No validation spec found for type!");
            }
            var validator_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, spec, typeOptions, (spec.props
                ? { props: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, spec.props, (typeOptions['props'] || {})) }
                : {}));
            if (validator_1) {
                // Required
                if (validator_1.required) {
                    if (!validator_1.required.every(function (prop) { return isDefined(entity[prop]); })) {
                        return err("MISSING_PROPERTY" /* MISSING_PROPERTY */, 'required prop missing');
                    }
                }
                if (validator_1.props) {
                    // Accumulate the Content validator
                    if (validator_1.props.content) {
                    }
                    // Check text
                    if (validator_1.props.text) {
                        if (isDefined(entity.text) &&
                            !validateAttrs(validator_1.props.text, entity.text)) {
                            return err("INVALID_TEXT" /* INVALID_TEXT */, "'text' validation failed");
                        }
                    }
                    // Content Length
                    if (validator_1.props.content &&
                        isDefined(validator_1.props.content.minItems) &&
                        validator_1.props.content.minItems >
                            ((entity.content && entity.content.length) || 0)) {
                        var _a = validator_1.props.content, minItems = _a.minItems, rest = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["minItems"]);
                        return err("INVALID_CONTENT_LENGTH" /* INVALID_CONTENT_LENGTH */, "'content' should have more than " + minItems + " child", { minItems: minItems, rest: rest });
                    }
                    // Required Props
                    if (!Object.keys(validator_1.props).every(function (v) { return validator_1.props[v].optional || entity[v]; })) {
                        return err("MISSING_PROPERTY" /* MISSING_PROPERTY */, 'required prop missing');
                    }
                    // Attributes
                    var validatorAttrs_1;
                    // Attributes Validation
                    if (validator_1.props.attrs && entity.attrs) {
                        var attrOptions = makeArray(validator_1.props.attrs);
                        var invalidAttrs = void 0;
                        var _loop_1 = function (i, length_1) {
                            var attrOption = attrOptions[i];
                            invalidAttrs = Object.keys(attrOption.props).reduce(function (attrs, k) {
                                return validateAttrs(attrOption.props[k], entity.attrs[k])
                                    ? attrs
                                    : attrs.concat(k);
                            }, []);
                            if (!invalidAttrs.length) {
                                validatorAttrs_1 = attrOption;
                                return "break";
                            }
                        };
                        /**
                         * Attrs can be union type so try each path
                         * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
                         * Gotcha: It will always report the last failure.
                         */
                        for (var i = 0, length_1 = attrOptions.length; i < length_1; ++i) {
                            var state_1 = _loop_1(i, length_1);
                            if (state_1 === "break")
                                break;
                        }
                        if (invalidAttrs.length) {
                            return err("INVALID_ATTRIBUTES" /* INVALID_ATTRIBUTES */, "'attrs' validation failed", { attrs: invalidAttrs });
                        }
                    }
                    // Extra Props
                    // Filter out private and required properties
                    var props = Object.keys(entity).filter(function (k) { return !(validator_1.props[k] && !validator_1.props[k].optional); });
                    if (!props.every(function (p) { return !!validator_1.props[p]; })) {
                        if (mode === 'loose') {
                            newEntity = { type: type };
                            props
                                .filter(function (p) { return !!validator_1.props[p]; })
                                .reduce(function (acc, p) { return copy(entity, acc, p); }, newEntity);
                        }
                        else {
                            return err("REDUNDANT_PROPERTIES" /* REDUNDANT_PROPERTIES */, "redundant props found: " + props.join(', '));
                        }
                    }
                    // Extra Attributes
                    if (entity.attrs) {
                        var attrs = Object.keys(entity.attrs).filter(function (k) { return !(allowPrivateAttributes && k.startsWith('__')); });
                        if (!validatorAttrs_1 ||
                            !attrs.every(function (a) { return !!validatorAttrs_1.props[a]; })) {
                            if (mode === 'loose') {
                                newEntity.attrs = {};
                                attrs
                                    .filter(function (a) { return !!validatorAttrs_1.props[a]; })
                                    .reduce(function (acc, p) { return copy(entity.attrs, acc, p); }, newEntity.attrs);
                            }
                            else {
                                return err("REDUNDANT_ATTRIBUTES" /* REDUNDANT_ATTRIBUTES */, "redundant attributes found: " + attrs
                                    .filter(function (a) { return !validatorAttrs_1.props[a]; })
                                    .join(', '));
                            }
                        }
                    }
                    // Children
                    if (validator_1.props.content) {
                        if (entity.content) {
                            newEntity.content = entity.content
                                .map(function (child, index) {
                                // Only go inside valid branch
                                var validSets = validator_1.props.content.items.filter(function (set) {
                                    /**
                                     * Manually treat listItem content as Tuple,
                                     * hopefully tsc has new AST for Tuple in v3.0
                                     */
                                    return type === 'listItem'
                                        ? true
                                        : set.some(
                                        // [p, hr, ...] or [p, [text, {}], ...]
                                        function (spec) {
                                            return (Array.isArray(spec) ? spec[0] : spec) ===
                                                child.type;
                                        });
                                });
                                if (validSets.length) {
                                    /**
                                     * In case of multiple valid branches, we are treating them as Tuple.
                                     * Thought this assumption is incorrect but it works for us since we don't
                                     * have any valid alternative branches.
                                     */
                                    var setIndex = validSets.length > 1
                                        ? Math.min(index, validSets.length - 1)
                                        : 0;
                                    var set = validSets[setIndex].filter(function (item) {
                                        return (Array.isArray(item) ? item[0] : item) === child.type;
                                    });
                                    if (set.length === 0) {
                                        return invalidChildContent(child, errorCallback, validator_1);
                                    }
                                    /**
                                     * When there's multiple possible branches try all of them.
                                     * If all of them fails, throw the first one.
                                     * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
                                     */
                                    var firstError = void 0;
                                    var firstChild = void 0;
                                    for (var i = 0, len = set.length; i < len; i++) {
                                        try {
                                            var _a = validate(child, errorCallback, [set[i]], validator_1), valid = _a.valid, newChildEntity = _a.entity;
                                            if (valid) {
                                                return newChildEntity;
                                            }
                                            else {
                                                firstChild = firstChild || newChildEntity;
                                            }
                                        }
                                        catch (error) {
                                            firstError = firstError || error;
                                        }
                                    }
                                    if (!errorCallback) {
                                        throw firstError;
                                    }
                                    else {
                                        return firstChild;
                                    }
                                }
                                else {
                                    return invalidChildContent(child, errorCallback, validator_1);
                                }
                            })
                                .filter(Boolean);
                        }
                        else if (!validator_1.props.content.optional) {
                            return err("MISSING_PROPERTY" /* MISSING_PROPERTY */, 'missing `content` prop');
                        }
                    }
                    // Marks
                    if (entity.marks) {
                        if (validator_1.props.marks) {
                            var items = validator_1.props.marks.items;
                            var marksSet_1 = items.length
                                ? Array.isArray(items[0])
                                    ? items[0]
                                    : items
                                : [];
                            var newMarks = entity.marks
                                .filter(function (mark) {
                                return mode === 'strict' && marks
                                    ? marks.indexOf(mark.type) > -1
                                    : true;
                            })
                                .map(function (mark) {
                                return validate(mark, errorCallback, marksSet_1, validator_1).entity;
                            })
                                .filter(Boolean);
                            if (newMarks.length) {
                                newEntity.marks = newMarks;
                            }
                            else {
                                delete newEntity.marks;
                                return { valid: false, entity: newEntity };
                            }
                        }
                        else {
                            return err("REDUNDANT_MARKS" /* REDUNDANT_MARKS */, 'redundant marks');
                        }
                    }
                }
                else {
                    // If there's no validator.props then there shouldn't be any key except `type`
                    if (Object.keys(entity).length > 1) {
                        return err("REDUNDANT_PROPERTIES" /* REDUNDANT_PROPERTIES */, "redundant props found: " + Object.keys(entity).join(', '));
                    }
                }
            }
        }
        else {
            return err("INVALID_TYPE" /* INVALID_TYPE */, 'ProseMirror Node/Mark should contain a `type`');
        }
        return { valid: true, entity: newEntity };
    };
    return validate;
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 2044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__em__ = __webpack_require__(2045);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "em", function() { return __WEBPACK_IMPORTED_MODULE_0__em__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__code__ = __webpack_require__(2046);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "code", function() { return __WEBPACK_IMPORTED_MODULE_1__code__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__strike__ = __webpack_require__(2047);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "strike", function() { return __WEBPACK_IMPORTED_MODULE_2__strike__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__strong__ = __webpack_require__(2048);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "strong", function() { return __WEBPACK_IMPORTED_MODULE_3__strong__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__underline__ = __webpack_require__(2049);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "underline", function() { return __WEBPACK_IMPORTED_MODULE_4__underline__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__table__ = __webpack_require__(2050);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "table", function() { return __WEBPACK_IMPORTED_MODULE_5__table__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tableRow__ = __webpack_require__(2051);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tableRow", function() { return __WEBPACK_IMPORTED_MODULE_6__tableRow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tableCell__ = __webpack_require__(2052);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tableCell", function() { return __WEBPACK_IMPORTED_MODULE_7__tableCell__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tableHeader__ = __webpack_require__(2053);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tableHeader", function() { return __WEBPACK_IMPORTED_MODULE_8__tableHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__link__ = __webpack_require__(2054);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "link", function() { return __WEBPACK_IMPORTED_MODULE_9__link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__subsup__ = __webpack_require__(2055);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "subsup", function() { return __WEBPACK_IMPORTED_MODULE_10__subsup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__textColor__ = __webpack_require__(2056);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "textColor", function() { return __WEBPACK_IMPORTED_MODULE_11__textColor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__inline_comment_marker__ = __webpack_require__(2057);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "inline_comment_marker", function() { return __WEBPACK_IMPORTED_MODULE_12__inline_comment_marker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__action__ = __webpack_require__(2058);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "action", function() { return __WEBPACK_IMPORTED_MODULE_13__action__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__breakout__ = __webpack_require__(2059);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "breakout", function() { return __WEBPACK_IMPORTED_MODULE_14__breakout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__alignment__ = __webpack_require__(2060);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "alignment", function() { return __WEBPACK_IMPORTED_MODULE_15__alignment__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__indentation__ = __webpack_require__(2061);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "indentation", function() { return __WEBPACK_IMPORTED_MODULE_16__indentation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__paragraph__ = __webpack_require__(2062);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "paragraph", function() { return __WEBPACK_IMPORTED_MODULE_17__paragraph__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__paragraph_with_no_marks__ = __webpack_require__(2063);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "paragraph_with_no_marks", function() { return __WEBPACK_IMPORTED_MODULE_18__paragraph_with_no_marks__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__paragraph_with_alignment__ = __webpack_require__(2064);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "paragraph_with_alignment", function() { return __WEBPACK_IMPORTED_MODULE_19__paragraph_with_alignment__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__paragraph_with_indentation__ = __webpack_require__(2065);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "paragraph_with_indentation", function() { return __WEBPACK_IMPORTED_MODULE_20__paragraph_with_indentation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__bulletList__ = __webpack_require__(2066);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bulletList", function() { return __WEBPACK_IMPORTED_MODULE_21__bulletList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__media__ = __webpack_require__(2067);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "media", function() { return __WEBPACK_IMPORTED_MODULE_22__media__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__mediaSingle__ = __webpack_require__(2068);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mediaSingle", function() { return __WEBPACK_IMPORTED_MODULE_23__mediaSingle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__text__ = __webpack_require__(2069);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "text", function() { return __WEBPACK_IMPORTED_MODULE_24__text__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__codeBlock__ = __webpack_require__(2070);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "codeBlock", function() { return __WEBPACK_IMPORTED_MODULE_25__codeBlock__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__codeBlock_with_no_marks__ = __webpack_require__(2071);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "codeBlock_with_no_marks", function() { return __WEBPACK_IMPORTED_MODULE_26__codeBlock_with_no_marks__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__codeBlock_with_marks__ = __webpack_require__(2072);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "codeBlock_with_marks", function() { return __WEBPACK_IMPORTED_MODULE_27__codeBlock_with_marks__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__listItem__ = __webpack_require__(2073);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "listItem", function() { return __WEBPACK_IMPORTED_MODULE_28__listItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__orderedList__ = __webpack_require__(2074);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "orderedList", function() { return __WEBPACK_IMPORTED_MODULE_29__orderedList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__heading__ = __webpack_require__(2075);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "heading", function() { return __WEBPACK_IMPORTED_MODULE_30__heading__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__heading_with_no_marks__ = __webpack_require__(2076);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "heading_with_no_marks", function() { return __WEBPACK_IMPORTED_MODULE_31__heading_with_no_marks__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__heading_with_alignment__ = __webpack_require__(2077);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "heading_with_alignment", function() { return __WEBPACK_IMPORTED_MODULE_32__heading_with_alignment__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__heading_with_indentation__ = __webpack_require__(2078);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "heading_with_indentation", function() { return __WEBPACK_IMPORTED_MODULE_33__heading_with_indentation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__panel__ = __webpack_require__(2079);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "panel", function() { return __WEBPACK_IMPORTED_MODULE_34__panel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__blockquote__ = __webpack_require__(2080);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "blockquote", function() { return __WEBPACK_IMPORTED_MODULE_35__blockquote__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__rule__ = __webpack_require__(2081);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "rule", function() { return __WEBPACK_IMPORTED_MODULE_36__rule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__mediaGroup__ = __webpack_require__(2082);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mediaGroup", function() { return __WEBPACK_IMPORTED_MODULE_37__mediaGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__applicationCard__ = __webpack_require__(2083);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applicationCard", function() { return __WEBPACK_IMPORTED_MODULE_38__applicationCard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__decisionItem__ = __webpack_require__(2084);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "decisionItem", function() { return __WEBPACK_IMPORTED_MODULE_39__decisionItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__decisionList__ = __webpack_require__(2085);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "decisionList", function() { return __WEBPACK_IMPORTED_MODULE_40__decisionList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__taskItem__ = __webpack_require__(2086);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "taskItem", function() { return __WEBPACK_IMPORTED_MODULE_41__taskItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__taskList__ = __webpack_require__(2087);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "taskList", function() { return __WEBPACK_IMPORTED_MODULE_42__taskList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__extension__ = __webpack_require__(2088);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "extension", function() { return __WEBPACK_IMPORTED_MODULE_43__extension__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__inlineExtension__ = __webpack_require__(2089);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "inlineExtension", function() { return __WEBPACK_IMPORTED_MODULE_44__inlineExtension__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__bodiedExtension__ = __webpack_require__(2090);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bodiedExtension", function() { return __WEBPACK_IMPORTED_MODULE_45__bodiedExtension__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__hardBreak__ = __webpack_require__(2091);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hardBreak", function() { return __WEBPACK_IMPORTED_MODULE_46__hardBreak__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__mention__ = __webpack_require__(2092);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mention", function() { return __WEBPACK_IMPORTED_MODULE_47__mention__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__emoji__ = __webpack_require__(2093);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "emoji", function() { return __WEBPACK_IMPORTED_MODULE_48__emoji__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__date__ = __webpack_require__(2094);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "date", function() { return __WEBPACK_IMPORTED_MODULE_49__date__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__status__ = __webpack_require__(2095);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "status", function() { return __WEBPACK_IMPORTED_MODULE_50__status__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__placeholder__ = __webpack_require__(2096);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "placeholder", function() { return __WEBPACK_IMPORTED_MODULE_51__placeholder__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__blockCard__ = __webpack_require__(2097);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "blockCard", function() { return __WEBPACK_IMPORTED_MODULE_52__blockCard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__inlineCard__ = __webpack_require__(2098);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "inlineCard", function() { return __WEBPACK_IMPORTED_MODULE_53__inlineCard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__layoutColumn__ = __webpack_require__(2099);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "layoutColumn", function() { return __WEBPACK_IMPORTED_MODULE_54__layoutColumn__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__layoutSection__ = __webpack_require__(2100);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "layoutSection", function() { return __WEBPACK_IMPORTED_MODULE_55__layoutSection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__block_content__ = __webpack_require__(2101);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "block_content", function() { return __WEBPACK_IMPORTED_MODULE_56__block_content__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__tableCell_content__ = __webpack_require__(2102);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tableCell_content", function() { return __WEBPACK_IMPORTED_MODULE_57__tableCell_content__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__extension_content__ = __webpack_require__(2103);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "extension_content", function() { return __WEBPACK_IMPORTED_MODULE_58__extension_content__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__formatted_text_inline__ = __webpack_require__(2104);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatted_text_inline", function() { return __WEBPACK_IMPORTED_MODULE_59__formatted_text_inline__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__link_text_inline__ = __webpack_require__(2105);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "link_text_inline", function() { return __WEBPACK_IMPORTED_MODULE_60__link_text_inline__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__code_inline__ = __webpack_require__(2106);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "code_inline", function() { return __WEBPACK_IMPORTED_MODULE_61__code_inline__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__atomic_inline__ = __webpack_require__(2107);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "atomic_inline", function() { return __WEBPACK_IMPORTED_MODULE_62__atomic_inline__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__inline__ = __webpack_require__(2108);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "inline", function() { return __WEBPACK_IMPORTED_MODULE_63__inline__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__doc__ = __webpack_require__(2109);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "doc", function() { return __WEBPACK_IMPORTED_MODULE_64__doc__["a"]; });
// DO NOT MODIFY THIS FILE, USE `yarn generate:spec`

































































//# sourceMappingURL=index.js.map

/***/ }),
/* 2045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({ props: { type: { type: 'enum', values: ['em'] } } });
//# sourceMappingURL=em.js.map

/***/ }),
/* 2046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({ props: { type: { type: 'enum', values: ['code'] } } });
//# sourceMappingURL=code.js.map

/***/ }),
/* 2047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({ props: { type: { type: 'enum', values: ['strike'] } } });
//# sourceMappingURL=strike.js.map

/***/ }),
/* 2048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({ props: { type: { type: 'enum', values: ['strong'] } } });
//# sourceMappingURL=strong.js.map

/***/ }),
/* 2049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({ props: { type: { type: 'enum', values: ['underline'] } } });
//# sourceMappingURL=underline.js.map

/***/ }),
/* 2050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['table'] },
        attrs: {
            props: {
                isNumberColumnEnabled: { type: 'boolean', optional: true },
                layout: {
                    type: 'enum',
                    values: ['default', 'full-width', 'wide'],
                    optional: true,
                },
            },
            optional: true,
        },
        content: { type: 'array', items: ['tableRow'], minItems: 1 },
    },
});
//# sourceMappingURL=table.js.map

/***/ }),
/* 2051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['tableRow'] },
        content: [
            { type: 'array', items: ['tableHeader'] },
            { type: 'array', items: ['tableCell'] },
        ],
    },
    required: ['content'],
});
//# sourceMappingURL=tableRow.js.map

/***/ }),
/* 2052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['tableCell'] },
        attrs: {
            props: {
                colspan: { type: 'number', optional: true },
                rowspan: { type: 'number', optional: true },
                colwidth: {
                    type: 'array',
                    items: [{ type: 'number' }],
                    optional: true,
                },
                background: { type: 'string', optional: true },
            },
            optional: true,
        },
        content: 'tableCell_content',
    },
    required: ['content'],
});
//# sourceMappingURL=tableCell.js.map

/***/ }),
/* 2053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['tableHeader'] },
        attrs: {
            props: {
                colspan: { type: 'number', optional: true },
                rowspan: { type: 'number', optional: true },
                colwidth: {
                    type: 'array',
                    items: [{ type: 'number' }],
                    optional: true,
                },
                background: { type: 'string', optional: true },
            },
            optional: true,
        },
        content: 'tableCell_content',
    },
    required: ['content'],
});
//# sourceMappingURL=tableHeader.js.map

/***/ }),
/* 2054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['link'] },
        attrs: {
            props: {
                href: { type: 'string' },
                title: { type: 'string', optional: true },
                id: { type: 'string', optional: true },
                collection: { type: 'string', optional: true },
                occurrenceKey: { type: 'string', optional: true },
            },
        },
    },
});
//# sourceMappingURL=link.js.map

/***/ }),
/* 2055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['subsup'] },
        attrs: { props: { type: { type: 'enum', values: ['sub', 'sup'] } } },
    },
});
//# sourceMappingURL=subsup.js.map

/***/ }),
/* 2056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['textColor'] },
        attrs: { props: { color: { type: 'string', pattern: '^#[0-9a-f]{6}$' } } },
    },
});
//# sourceMappingURL=textColor.js.map

/***/ }),
/* 2057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['confluenceInlineComment'] },
        attrs: { props: { reference: { type: 'string' } } },
    },
});
//# sourceMappingURL=inline_comment_marker.js.map

/***/ }),
/* 2058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['action'] },
        attrs: {
            props: {
                title: { type: 'string' },
                key: { type: 'string', optional: true },
                target: {
                    props: {
                        receiver: { type: 'string', optional: true },
                        key: { type: 'string' },
                    },
                },
                parameters: { type: 'object', optional: true },
            },
        },
    },
});
//# sourceMappingURL=action.js.map

/***/ }),
/* 2059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['breakout'] },
        attrs: {
            props: { mode: { type: 'enum', values: ['full-width', 'wide'] } },
        },
    },
});
//# sourceMappingURL=breakout.js.map

/***/ }),
/* 2060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['alignment'] },
        attrs: { props: { align: { type: 'enum', values: ['center', 'end'] } } },
    },
});
//# sourceMappingURL=alignment.js.map

/***/ }),
/* 2061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['indentation'] },
        attrs: { props: { level: { type: 'number', minimum: 1, maximum: 6 } } },
    },
});
//# sourceMappingURL=indentation.js.map

/***/ }),
/* 2062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['paragraph'] },
        content: {
            type: 'array',
            items: ['inline'],
            allowUnsupportedInline: true,
            optional: true,
        },
        marks: { type: 'array', items: [], optional: true },
    },
});
//# sourceMappingURL=paragraph.js.map

/***/ }),
/* 2063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([
    'paragraph',
    {
        props: { marks: { type: 'array', items: [], maxItems: 0, optional: true } },
    },
]);
//# sourceMappingURL=paragraph_with_no_marks.js.map

/***/ }),
/* 2064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([
    'paragraph',
    { props: { marks: { type: 'array', items: ['alignment'], optional: true } } },
]);
//# sourceMappingURL=paragraph_with_alignment.js.map

/***/ }),
/* 2065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([
    'paragraph',
    {
        props: { marks: { type: 'array', items: ['indentation'], optional: true } },
    },
]);
//# sourceMappingURL=paragraph_with_indentation.js.map

/***/ }),
/* 2066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['bulletList'] },
        content: { type: 'array', items: ['listItem'], minItems: 1 },
    },
});
//# sourceMappingURL=bulletList.js.map

/***/ }),
/* 2067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['media'] },
        attrs: [
            {
                props: {
                    type: { type: 'enum', values: ['link', 'file'] },
                    id: { type: 'string', minLength: 1 },
                    collection: { type: 'string' },
                    height: { type: 'number', optional: true },
                    width: { type: 'number', optional: true },
                    occurrenceKey: { type: 'string', minLength: 1, optional: true },
                },
            },
            {
                props: {
                    type: { type: 'enum', values: ['external'] },
                    url: { type: 'string' },
                    width: { type: 'number', optional: true },
                    height: { type: 'number', optional: true },
                },
            },
        ],
    },
    required: ['attrs'],
});
//# sourceMappingURL=media.js.map

/***/ }),
/* 2068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['mediaSingle'] },
        content: { type: 'array', items: ['media'], minItems: 1, maxItems: 1 },
        attrs: {
            props: {
                width: { type: 'number', minimum: 0, maximum: 100, optional: true },
                layout: {
                    type: 'enum',
                    values: ['full-width', 'wide', 'center', 'wrap-right', 'wrap-left'],
                },
            },
            optional: true,
        },
        marks: { type: 'array', items: ['link'], optional: true },
    },
});
//# sourceMappingURL=mediaSingle.js.map

/***/ }),
/* 2069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['text'] },
        text: { type: 'string', minLength: 1 },
        marks: { type: 'array', items: [], optional: true },
    },
});
//# sourceMappingURL=text.js.map

/***/ }),
/* 2070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['codeBlock'] },
        content: {
            type: 'array',
            items: [
                [
                    'text',
                    {
                        props: {
                            marks: { type: 'array', items: [], maxItems: 0, optional: true },
                        },
                    },
                ],
            ],
            optional: true,
        },
        marks: { type: 'array', items: [], optional: true },
        attrs: {
            props: { language: { type: 'string', optional: true } },
            optional: true,
        },
    },
});
//# sourceMappingURL=codeBlock.js.map

/***/ }),
/* 2071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([
    'codeBlock',
    {
        props: { marks: { type: 'array', items: [], maxItems: 0, optional: true } },
    },
]);
//# sourceMappingURL=codeBlock_with_no_marks.js.map

/***/ }),
/* 2072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([
    'codeBlock',
    { props: { marks: { type: 'array', items: ['breakout'], optional: true } } },
]);
//# sourceMappingURL=codeBlock_with_marks.js.map

/***/ }),
/* 2073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['listItem'] },
        content: {
            type: 'array',
            items: [
                ['paragraph_with_no_marks', 'mediaSingle', 'codeBlock_with_no_marks'],
                [
                    'paragraph_with_no_marks',
                    'bulletList',
                    'mediaSingle',
                    'codeBlock_with_no_marks',
                    'orderedList',
                ],
            ],
            minItems: 1,
        },
    },
});
//# sourceMappingURL=listItem.js.map

/***/ }),
/* 2074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['orderedList'] },
        content: { type: 'array', items: ['listItem'], minItems: 1 },
        attrs: { props: { order: { type: 'number', minimum: 1 } }, optional: true },
    },
});
//# sourceMappingURL=orderedList.js.map

/***/ }),
/* 2075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['heading'] },
        content: {
            type: 'array',
            items: ['inline'],
            allowUnsupportedInline: true,
            optional: true,
        },
        marks: { type: 'array', items: [], optional: true },
        attrs: { props: { level: { type: 'number', minimum: 1, maximum: 6 } } },
    },
});
//# sourceMappingURL=heading.js.map

/***/ }),
/* 2076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([
    'heading',
    {
        props: { marks: { type: 'array', items: [], maxItems: 0, optional: true } },
    },
]);
//# sourceMappingURL=heading_with_no_marks.js.map

/***/ }),
/* 2077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([
    'heading',
    { props: { marks: { type: 'array', items: ['alignment'], optional: true } } },
]);
//# sourceMappingURL=heading_with_alignment.js.map

/***/ }),
/* 2078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([
    'heading',
    {
        props: { marks: { type: 'array', items: ['indentation'], optional: true } },
    },
]);
//# sourceMappingURL=heading_with_indentation.js.map

/***/ }),
/* 2079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['panel'] },
        attrs: {
            props: {
                panelType: {
                    type: 'enum',
                    values: ['info', 'note', 'tip', 'warning', 'error', 'success'],
                },
            },
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                ],
            ],
            minItems: 1,
        },
    },
});
//# sourceMappingURL=panel.js.map

/***/ }),
/* 2080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['blockquote'] },
        content: { type: 'array', items: ['paragraph_with_no_marks'], minItems: 1 },
    },
});
//# sourceMappingURL=blockquote.js.map

/***/ }),
/* 2081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({ props: { type: { type: 'enum', values: ['rule'] } } });
//# sourceMappingURL=rule.js.map

/***/ }),
/* 2082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['mediaGroup'] },
        content: { type: 'array', items: ['media'], minItems: 1 },
    },
});
//# sourceMappingURL=mediaGroup.js.map

/***/ }),
/* 2083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});
//# sourceMappingURL=applicationCard.js.map

/***/ }),
/* 2084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['decisionItem'] },
        content: {
            type: 'array',
            items: ['inline'],
            allowUnsupportedInline: true,
            optional: true,
        },
        attrs: {
            props: { localId: { type: 'string' }, state: { type: 'string' } },
        },
    },
});
//# sourceMappingURL=decisionItem.js.map

/***/ }),
/* 2085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['decisionList'] },
        content: { type: 'array', items: ['decisionItem'], minItems: 1 },
        attrs: { props: { localId: { type: 'string' } } },
    },
});
//# sourceMappingURL=decisionList.js.map

/***/ }),
/* 2086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['taskItem'] },
        content: {
            type: 'array',
            items: ['inline'],
            allowUnsupportedInline: true,
            optional: true,
        },
        attrs: {
            props: {
                localId: { type: 'string' },
                state: { type: 'enum', values: ['TODO', 'DONE'] },
            },
        },
    },
});
//# sourceMappingURL=taskItem.js.map

/***/ }),
/* 2087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['taskList'] },
        content: { type: 'array', items: ['taskItem'], minItems: 1 },
        attrs: { props: { localId: { type: 'string' } } },
    },
});
//# sourceMappingURL=taskList.js.map

/***/ }),
/* 2088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['extension'] },
        attrs: {
            props: {
                extensionKey: { type: 'string', minLength: 1 },
                extensionType: { type: 'string', minLength: 1 },
                parameters: { type: 'object', optional: true },
                text: { type: 'string', optional: true },
                layout: {
                    type: 'enum',
                    values: ['default', 'full-width', 'wide'],
                    optional: true,
                },
            },
        },
    },
});
//# sourceMappingURL=extension.js.map

/***/ }),
/* 2089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['inlineExtension'] },
        attrs: {
            props: {
                extensionKey: { type: 'string', minLength: 1 },
                extensionType: { type: 'string', minLength: 1 },
                parameters: { type: 'object', optional: true },
                text: { type: 'string', optional: true },
            },
        },
    },
});
//# sourceMappingURL=inlineExtension.js.map

/***/ }),
/* 2090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['bodiedExtension'] },
        attrs: {
            props: {
                extensionKey: { type: 'string', minLength: 1 },
                extensionType: { type: 'string', minLength: 1 },
                parameters: { type: 'object', optional: true },
                text: { type: 'string', optional: true },
                layout: {
                    type: 'enum',
                    values: ['default', 'full-width', 'wide'],
                    optional: true,
                },
            },
        },
        content: 'extension_content',
    },
    required: ['content'],
});
//# sourceMappingURL=bodiedExtension.js.map

/***/ }),
/* 2091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['hardBreak'] },
        attrs: {
            props: { text: { type: 'enum', values: ['\n'], optional: true } },
            optional: true,
        },
    },
});
//# sourceMappingURL=hardBreak.js.map

/***/ }),
/* 2092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['mention'] },
        attrs: {
            props: {
                id: { type: 'string' },
                text: { type: 'string', optional: true },
                userType: {
                    type: 'enum',
                    values: ['DEFAULT', 'SPECIAL', 'APP'],
                    optional: true,
                },
                accessLevel: { type: 'string', optional: true },
            },
        },
    },
});
//# sourceMappingURL=mention.js.map

/***/ }),
/* 2093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['emoji'] },
        attrs: {
            props: {
                id: { type: 'string', optional: true },
                shortName: { type: 'string' },
                text: { type: 'string', optional: true },
            },
        },
    },
});
//# sourceMappingURL=emoji.js.map

/***/ }),
/* 2094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['date'] },
        attrs: { props: { timestamp: { type: 'string', minLength: 1 } } },
    },
});
//# sourceMappingURL=date.js.map

/***/ }),
/* 2095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['status'] },
        attrs: {
            props: {
                text: { type: 'string', minLength: 1 },
                color: {
                    type: 'enum',
                    values: ['neutral', 'purple', 'blue', 'red', 'yellow', 'green'],
                },
                localId: { type: 'string', optional: true },
                style: { type: 'string', optional: true },
            },
        },
    },
});
//# sourceMappingURL=status.js.map

/***/ }),
/* 2096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['placeholder'] },
        attrs: { props: { text: { type: 'string' } } },
    },
});
//# sourceMappingURL=placeholder.js.map

/***/ }),
/* 2097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['blockCard'] },
        attrs: [
            { props: { url: { type: 'string' } } },
            { props: { data: { type: 'object' } } },
        ],
    },
    required: ['attrs'],
});
//# sourceMappingURL=blockCard.js.map

/***/ }),
/* 2098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['inlineCard'] },
        attrs: [
            { props: { url: { type: 'string' } } },
            { props: { data: { type: 'object' } } },
        ],
    },
    required: ['attrs'],
});
//# sourceMappingURL=inlineCard.js.map

/***/ }),
/* 2099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['layoutColumn'] },
        attrs: { props: { width: { type: 'number', minimum: 0, maximum: 100 } } },
        content: { type: 'array', items: ['block_content'], minItems: 1 },
    },
});
//# sourceMappingURL=layoutColumn.js.map

/***/ }),
/* 2100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: { type: 'enum', values: ['layoutSection'] },
        content: {
            type: 'array',
            items: ['layoutColumn'],
            minItems: 2,
            maxItems: 3,
        },
        marks: { type: 'array', items: ['breakout'], optional: true },
    },
});
//# sourceMappingURL=layoutSection.js.map

/***/ }),
/* 2101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([
    'table',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'bulletList',
    'mediaSingle',
    'codeBlock_with_no_marks',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'panel',
    'blockquote',
    'rule',
    'mediaGroup',
    'applicationCard',
    'decisionList',
    'taskList',
    'extension',
    'bodiedExtension',
    'blockCard',
]);
//# sourceMappingURL=block_content.js.map

/***/ }),
/* 2102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'paragraph_with_alignment',
            'paragraph_with_indentation',
            'bulletList',
            'mediaSingle',
            'codeBlock_with_no_marks',
            'orderedList',
            'heading_with_no_marks',
            'heading_with_alignment',
            'heading_with_indentation',
            'panel',
            'blockquote',
            'rule',
            'mediaGroup',
            'applicationCard',
            'decisionList',
            'taskList',
            'extension',
            'blockCard',
        ],
    ],
    minItems: 1,
    allowUnsupportedBlock: true,
});
//# sourceMappingURL=tableCell_content.js.map

/***/ }),
/* 2103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    type: 'array',
    items: [
        [
            'table',
            'paragraph_with_no_marks',
            'bulletList',
            'mediaSingle',
            'codeBlock_with_no_marks',
            'orderedList',
            'heading_with_no_marks',
            'panel',
            'blockquote',
            'rule',
            'mediaGroup',
            'applicationCard',
            'decisionList',
            'taskList',
            'extension',
            'blockCard',
        ],
    ],
    minItems: 1,
    allowUnsupportedBlock: true,
});
//# sourceMappingURL=extension_content.js.map

/***/ }),
/* 2104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([
    'text',
    {
        props: {
            marks: {
                type: 'array',
                items: [
                    [
                        'em',
                        'strike',
                        'strong',
                        'underline',
                        'link',
                        'subsup',
                        'textColor',
                        'action',
                    ],
                ],
                optional: true,
            },
        },
    },
]);
//# sourceMappingURL=formatted_text_inline.js.map

/***/ }),
/* 2105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([
    'text',
    { props: { marks: { type: 'array', items: ['link'], optional: true } } },
]);
//# sourceMappingURL=link_text_inline.js.map

/***/ }),
/* 2106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([
    'text',
    {
        props: {
            marks: { type: 'array', items: [['code', 'link']], optional: true },
        },
    },
]);
//# sourceMappingURL=code_inline.js.map

/***/ }),
/* 2107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([
    'inlineExtension',
    'hardBreak',
    'mention',
    'emoji',
    'date',
    'status',
    'placeholder',
    'inlineCard',
]);
//# sourceMappingURL=atomic_inline.js.map

/***/ }),
/* 2108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([
    'inlineExtension',
    'hardBreak',
    'mention',
    'emoji',
    'date',
    'status',
    'placeholder',
    'inlineCard',
    'formatted_text_inline',
    'code_inline',
]);
//# sourceMappingURL=inline.js.map

/***/ }),
/* 2109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        version: { type: 'enum', values: [1] },
        type: { type: 'enum', values: ['doc'] },
        content: {
            type: 'array',
            items: [
                [
                    'table',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'bulletList',
                    'mediaSingle',
                    'codeBlock_with_no_marks',
                    'codeBlock_with_marks',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'panel',
                    'blockquote',
                    'rule',
                    'mediaGroup',
                    'applicationCard',
                    'decisionList',
                    'taskList',
                    'extension',
                    'bodiedExtension',
                    'blockCard',
                    'layoutSection',
                ],
            ],
            allowUnsupportedBlock: true,
        },
    },
});
//# sourceMappingURL=doc.js.map

/***/ }),
/* 2110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withAnalytics;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service__ = __webpack_require__(270);


function withAnalytics(analyticsEventName, trackedFn) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var result = trackedFn.apply(void 0, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](args));
        if (result) {
            try {
                __WEBPACK_IMPORTED_MODULE_1__service__["a" /* default */].trackEvent(analyticsEventName);
            }
            catch (e) {
                // tslint:disable-next-line:no-console
                console.error('An exception has been thrown when trying to track analytics event:', e);
            }
        }
        return result;
    };
}
//# sourceMappingURL=withAnalytics.js.map

/***/ }),
/* 2111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = trackAndInvoke;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service__ = __webpack_require__(270);

/**
 * Returns a sequence of tracking analytics event and the provided function.
 *
 * Usage:
 *
 *     let doSomething = function(a, b) { // ... }
 *     doSomething = trackAndInvoke('atlassian.editor.dosomething', doSomething);
 *
 *     doSomething(); // this will send analytics event and call the original function
 *
 */
function trackAndInvoke(analyticsEventName, fn) {
    return function (a, b, c, d) {
        var result = fn(a, b, c, d);
        if (result) {
            __WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].trackEvent(analyticsEventName);
        }
        return result;
    };
}
//# sourceMappingURL=trackAndInvoke.js.map

/***/ }),
/* 2112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getEditorValueWithMedia;
/* harmony export (immutable) */ __webpack_exports__["b"] = insertFileFromDataUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_media_pm_plugins_main__ = __webpack_require__(100);


function getEditorValueWithMedia(editorView) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
        var state, mediaPluginState;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!editorView) {
                        return [2 /*return*/];
                    }
                    state = editorView.state;
                    mediaPluginState = state && __WEBPACK_IMPORTED_MODULE_1__plugins_media_pm_plugins_main__["b" /* stateKey */].getState(state);
                    if (!(mediaPluginState && mediaPluginState.waitForMediaUpload)) return [3 /*break*/, 2];
                    return [4 /*yield*/, mediaPluginState.waitForPendingTasks()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/, editorView.state.doc];
            }
        });
    });
}
function insertFileFromDataUrl(editorState, url, fileName) {
    if (!editorState) {
        return;
    }
    var mediaPluginState = __WEBPACK_IMPORTED_MODULE_1__plugins_media_pm_plugins_main__["b" /* stateKey */].getState(editorState);
    mediaPluginState.insertFileFromDataUrl(url, fileName);
}
//# sourceMappingURL=action.js.map

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production","PUBLIC_URL":""}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(2114);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(2115);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43), __webpack_require__(122)))

/***/ }),
/* 2114 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 2115 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 2116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_document_filled__ = __webpack_require__(2117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_document_filled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_document_filled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nodeviews_media__ = __webpack_require__(750);







var IconWrapper = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  color: ", ";\n  background: ", ";\n  border-radius: ", "px;\n  margin: 5px 3px 25px;\n  width: ", "px;\n  min-height: ", "px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  color: ", ";\n  background: ", ";\n  border-radius: ", "px;\n  margin: 5px 3px 25px;\n  width: ", "px;\n  min-height: ", "px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), Object(__WEBPACK_IMPORTED_MODULE_5__atlaskit_editor_common__["R" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].B400, 0.4) || __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].B400, Object(__WEBPACK_IMPORTED_MODULE_5__atlaskit_editor_common__["R" /* hexToRgba */])(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].B300, 0.6) || __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].B300, Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["borderRadius"])(), __WEBPACK_IMPORTED_MODULE_6__nodeviews_media__["a" /* FILE_WIDTH */], __WEBPACK_IMPORTED_MODULE_6__nodeviews_media__["b" /* MEDIA_HEIGHT */]);
var DropLine = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  background: ", ";\n  border-radius: ", "px;\n  margin: 2px 0;\n  width: 100%;\n  height: 2px;\n"], ["\n  background: ", ";\n  border-radius: ", "px;\n  margin: 2px 0;\n  width: 100%;\n  height: 2px;\n"])), __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].B200, Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["borderRadius"])());
/* harmony default export */ __webpack_exports__["a"] = (function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'group' : _b;
    return type === 'single' ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](DropLine, null)) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](IconWrapper, null,
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_document_filled___default.a, { label: "Document", size: "medium" })));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=DropPlaceholder.js.map

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DocumentFilledIcon = function DocumentFilledIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M18.99 8.99l.01 1.015V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.275c.469 0 .922.164 1.282.464L18.631 7.7c.227.19.359.471.359.768v.521zM12.02 5L12 8.192a.99.99 0 0 0 .994.991h4L12.02 5z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

DocumentFilledIcon.displayName = 'DocumentFilledIcon';
var _default = DocumentFilledIcon;
exports.default = _default;

/***/ }),
/* 2118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_cardLoading__ = __webpack_require__(332);



var Card = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Card, _super);
    function Card() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            Card: Card.Card,
        };
        return _this;
    }
    Card.prototype.componentWillMount = function () {
        var _this = this;
        if (!this.state.Card) {
            __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 3465)).then(function (module) {
                Card.Card = module.Card;
                _this.setState({ Card: module.Card });
            });
        }
    };
    Card.prototype.render = function () {
        var _a = this.props, dimensions = _a.dimensions, identifier = _a.identifier;
        if (!this.state.Card) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__utils_cardLoading__["a" /* CardLoading */], { dimensions: dimensions, mediaItemType: identifier.mediaItemType }));
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](this.state.Card, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, this.props));
    };
    Card.displayName = 'AsyncCard';
    return Card;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Card);
//# sourceMappingURL=cardLoader.js.map

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FileIcon = function FileIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M17 10.005V19H7V5h5.99v2.49a1.5 1.5 0 0 0 1.5 1.5h4.5v-.522c0-.297-.132-.578-.359-.768l-5.074-4.236c-.36-.3-.813-.464-1.282-.464H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8.995h-2z\"/><rect x=\"8\" y=\"12\" width=\"8\" height=\"2\" rx=\"1\"/><rect x=\"8\" y=\"15\" width=\"4\" height=\"2\" rx=\"1\"/></g></svg>"
  }, props));
};

FileIcon.displayName = 'FileIcon';
var _default = FileIcon;
exports.default = _default;

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var LinkIcon = function LinkIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M12.856 5.457l-.937.92a1.002 1.002 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47\"/><path d=\"M11.144 19.543l.937-.92a1.002 1.002 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47\"/></g></svg>"
  }, props));
};

LinkIcon.displayName = 'LinkIcon';
var _default = LinkIcon;
exports.default = _default;

/***/ }),
/* 2121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export blinkLoadingAnimation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_media_ui__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__ = __webpack_require__(529);

/* tslint:disable:variable-name */



var blinkLoadingAnimation = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  0%{\n    opacity: 1;\n  }\n\n  50%{\n    opacity: 0.6;\n  }\n\n  100%{\n    opacity: 1;\n  }\n"], ["\n  0%{\n    opacity: 1;\n  }\n\n  50%{\n    opacity: 0.6;\n  }\n\n  100%{\n    opacity: 1;\n  }\n"])));
var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", " background: ", ";\n  color: ", ";\n  border-radius: inherit;\n  max-height: 100%;\n  max-width: 100%;\n \n  ", "\n  > span {\n    animation: ", " 0.8s infinite;\n  }\n"], ["\n  ", " background: ", ";\n  color: ", ";\n  border-radius: inherit;\n  max-height: 100%;\n  max-width: 100%;\n \n  ",
    "\n  > span {\n    animation: ", " 0.8s infinite;\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_media_ui__["q" /* center */], Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["d" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["a" /* colors */].N20, dark: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["a" /* colors */].DN50 }), Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["d" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["a" /* colors */].N50, dark: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["a" /* colors */].DN100 }), function (props) {
    return "\n      width: " + props.dimensions.width + ";\n      height: " + props.dimensions.height + ";\n    ";
}, blinkLoadingAnimation);
var templateObject_1, templateObject_2;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zh__ = __webpack_require__(2123);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "zh", function() { return __WEBPACK_IMPORTED_MODULE_0__zh__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cs__ = __webpack_require__(2124);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cs", function() { return __WEBPACK_IMPORTED_MODULE_1__cs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__da__ = __webpack_require__(2125);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "da", function() { return __WEBPACK_IMPORTED_MODULE_2__da__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nl__ = __webpack_require__(2126);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "nl", function() { return __WEBPACK_IMPORTED_MODULE_3__nl__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__en__ = __webpack_require__(2127);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "en", function() { return __WEBPACK_IMPORTED_MODULE_4__en__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__en_GB__ = __webpack_require__(2128);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "en_GB", function() { return __WEBPACK_IMPORTED_MODULE_5__en_GB__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__et__ = __webpack_require__(2129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "et", function() { return __WEBPACK_IMPORTED_MODULE_6__et__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fi__ = __webpack_require__(2130);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fi", function() { return __WEBPACK_IMPORTED_MODULE_7__fi__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fr__ = __webpack_require__(2131);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fr", function() { return __WEBPACK_IMPORTED_MODULE_8__fr__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__de__ = __webpack_require__(2132);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "de", function() { return __WEBPACK_IMPORTED_MODULE_9__de__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hu__ = __webpack_require__(2133);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hu", function() { return __WEBPACK_IMPORTED_MODULE_10__hu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__is__ = __webpack_require__(2134);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "is", function() { return __WEBPACK_IMPORTED_MODULE_11__is__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__it__ = __webpack_require__(2135);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "it", function() { return __WEBPACK_IMPORTED_MODULE_12__it__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ja__ = __webpack_require__(2136);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ja", function() { return __WEBPACK_IMPORTED_MODULE_13__ja__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ko__ = __webpack_require__(2137);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ko", function() { return __WEBPACK_IMPORTED_MODULE_14__ko__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__nb__ = __webpack_require__(2138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "nb", function() { return __WEBPACK_IMPORTED_MODULE_15__nb__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pl__ = __webpack_require__(2139);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pl", function() { return __WEBPACK_IMPORTED_MODULE_16__pl__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pt_BR__ = __webpack_require__(2140);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pt_BR", function() { return __WEBPACK_IMPORTED_MODULE_17__pt_BR__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pt_PT__ = __webpack_require__(2141);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pt_PT", function() { return __WEBPACK_IMPORTED_MODULE_18__pt_PT__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ro__ = __webpack_require__(2142);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ro", function() { return __WEBPACK_IMPORTED_MODULE_19__ro__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ru__ = __webpack_require__(2143);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ru", function() { return __WEBPACK_IMPORTED_MODULE_20__ru__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__sk__ = __webpack_require__(2144);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sk", function() { return __WEBPACK_IMPORTED_MODULE_21__sk__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__es__ = __webpack_require__(2145);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "es", function() { return __WEBPACK_IMPORTED_MODULE_22__es__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__sv__ = __webpack_require__(2146);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sv", function() { return __WEBPACK_IMPORTED_MODULE_23__sv__["a"]; });
























//# sourceMappingURL=index.js.map

/***/ }),
/* 2123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Chinese
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': '重试',
    'fabric.media.failed_to_load': '无法加载',
    'fabric.media.recent_uploads': '最近上传',
    'fabric.media.upload_file': '上传文件',
    'fabric.media.drag_and_drop_your_files': '拖放您的文件至任何地方或',
    'fabric.media.drop_your_files': '拖放文件进行上传',
    'fabric.media.upload': '上传',
    'fabric.media.cancel': '取消',
    'fabric.media.search_all_gifs': '搜索所有 GIFs！',
    'fabric.media.cant_retrieve_gifs': '噢！检索不到任何 GIFs',
    'fabric.media.check_your_network': '检查网络连接',
    'fabric.media.try_again': '重试',
    'fabric.media.no_gifs_found': '您好？您在寻找我吗？',
    'fabric.media.no_gifs_found_suggestion': '找不到 "{query}"的任何信息',
    'fabric.media.load_more_gifs': '加载更多 GIFs',
    'fabric.media.add_account': '添加账户',
    'fabric.media.unlink_account': '取消链接账户',
    'fabric.media.upload_file_from': '上传{name}中的文件',
    'fabric.media.connect_to': '连接至{name}',
    'fabric.media.connect_account_description': '我们将打开新页面帮助您连接{name}账户',
    'fabric.media.upload_an_avatar': '上传头像',
    'fabric.media.save': '保存',
    'fabric.media.or': '或者',
    'fabric.media.upload_photo': '上传一张照片',
    'fabric.media.default_avatars': '默认图片',
    'fabric.media.drag_and_drop_images_here': '拖拽图片到这里',
    'fabric.media.upload_image': '上传图像',
    'fabric.media.image_url_invalid_error': '无法加载图像，当前网址无效。',
    'fabric.media.image_format_invalid_error': '无法加载图像，当前格式无效。',
    'fabric.media.image_size_too_large_error': '图像过大，必须小于{MAX_SIZE_MB} MB',
    'fabric.media.something_went_wrong': '出错了。',
    'fabric.media.might_be_a_hiccup': '它只是一个小问题。',
    'fabric.media.couldnt_generate_preview': '我们无法为此文件生成预览。',
    'fabric.media.cant_preview_file_type': '我们无法预览此文件类型。',
    'fabric.media.item_not_found_in_list': '选中项未在列表中找到。',
    'fabric.media.no_pdf_artifacts': '此文件中未找到PDF文件。',
    'fabric.media.give_feedback': '提供反馈意见',
    'fabric.media.try_downloading_file': '尝试下载该文件并查看。',
    'fabric.media.webgl_warning_description': '您的浏览器不支持网页图形库。请使用支持网页图形库的浏览器来标注图像。',
    'fabric.media.unable_to_annotate_image': '您无法标注此图像。',
    'fabric.media.learn_more': '了解更多',
    'fabric.media.accounts': '帐户',
    'fabric.media.actions': '操作',
    'fabric.media.error_hint_retry': '请重试，我们会再次尝试。',
    'fabric.media.error_hint_critical': '若该问题仍无法解决，联系我们。',
    'fabric.media.close': '关闭',
    'fabric.media.could_not_load_editor': '哎哟！我们无法加载编辑器。',
    'fabric.media.could_not_save_image': '哎哟！我们无法保存该图片',
    'fabric.media.annotate': '标注',
    'fabric.media.drop_your_files_here': '拖放您的文件至此',
    'fabric.media.share_files_instantly': '我们会立即共享您的文件',
    'fabric.media.insert_files': '{0, plural, other{Insert a file}}',
    'fabric.media.zoom_out': 'zoom out',
    'fabric.media.zoom_in': 'zoom in',
    'fabric.media.remove_image': 'Remove image',
    'fabric.media.play': 'play',
    'fabric.media.pause': 'pause',
    'fabric.media.disable_fullscreen': 'disable fullscreen',
    'fabric.media.enable_fullscreen': 'enable fullscreen',
    'fabric.media.error_loading_file': 'Error loading file',
    'fabric.media.error_generating_preview': 'Error generating preview',
    'fabric.media.download': 'Download',
    'fabric.media.unknown': 'unknown',
    'fabric.media.document': 'document',
    'fabric.media.audio': 'audio',
    'fabric.media.video': 'video',
    'fabric.media.image': 'image',
});
//# sourceMappingURL=zh.js.map

/***/ }),
/* 2124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Czech
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': 'Zkusit znovu',
    'fabric.media.failed_to_load': 'Nepodařilo se načíst ',
    'fabric.media.recent_uploads': 'Nedávno nahráno',
    'fabric.media.upload_file': 'Nahrát soubor',
    'fabric.media.drag_and_drop_your_files': 'Přetáhněte své soubory kamkoli na stránku nebo',
    'fabric.media.drop_your_files': 'Chcete-li nahrát soubory, přetáhněte je sem',
    'fabric.media.upload': 'Nahrát',
    'fabric.media.cancel': 'Zrušit',
    'fabric.media.search_all_gifs': 'Prohledejte všechny GIFy!',
    'fabric.media.cant_retrieve_gifs': 'Nepodařilo se nám dohledat žádné GIFy.',
    'fabric.media.check_your_network': 'Zkontrolujte své připojení k síti.',
    'fabric.media.try_again': 'Zkusit znovu',
    'fabric.media.no_gifs_found': 'Haló? Hledali jste mě?',
    'fabric.media.no_gifs_found_suggestion': 'Pro výraz „{query}“ jsme nic nenašli.',
    'fabric.media.load_more_gifs': 'Nahrát více GIFů',
    'fabric.media.add_account': 'Přidat účet',
    'fabric.media.unlink_account': 'Odpojit účet',
    'fabric.media.upload_file_from': 'Nahrát soubor z: {name}',
    'fabric.media.connect_to': 'Připojit k {name}',
    'fabric.media.connect_account_description': 'Otevřeme novou stránku, abychom vám pomohli připojit váš {name} účet.',
    'fabric.media.upload_an_avatar': 'Nahrát avatar',
    'fabric.media.save': 'Uložit',
    'fabric.media.or': 'nebo',
    'fabric.media.upload_photo': 'Nahrát fotku',
    'fabric.media.default_avatars': 'Výchozí avatary',
    'fabric.media.drag_and_drop_images_here': 'Přetáhněte své obrázky sem.',
    'fabric.media.upload_image': 'Nahrát obrázek',
    'fabric.media.image_url_invalid_error': 'Nepodařilo se nahrát obrázek, adresa URL je neplatná.',
    'fabric.media.image_format_invalid_error': 'Nepodařilo se nahrát obrázek, formát je neplatný.',
    'fabric.media.image_size_too_large_error': 'Obrázek je příliš velký. Maximální velikost je {MAX_SIZE_MB} MB.',
    'fabric.media.something_went_wrong': 'Něco se pokazilo.',
    'fabric.media.might_be_a_hiccup': 'Chybička se vloudila, ale nevíme kam.',
    'fabric.media.couldnt_generate_preview': 'Náhled tohoto souboru se nepodařilo vytvořit.',
    'fabric.media.cant_preview_file_type': 'Nemůžeme zobrazit náhled tohoto typu souboru.',
    'fabric.media.item_not_found_in_list': 'Vybraná položka nebyla v tomto seznamu nalezena.',
    'fabric.media.no_pdf_artifacts': 'Pro tento soubor nebyly nalezeny žádné PDF artefakty.',
    'fabric.media.give_feedback': 'Váš názor',
    'fabric.media.try_downloading_file': 'Pokud chcete soubor zobrazit, zkuste ho stáhnout.',
    'fabric.media.webgl_warning_description': 'Váš prohlížeč nepodporuje knihovnu WebGL. Chcete-li přidávat k obrázkům poznámky, použijte prohlížeč, který ji podporuje.',
    'fabric.media.unable_to_annotate_image': 'K tomuto obrázku nemůžete přidávat poznámky.',
    'fabric.media.learn_more': 'Další informace',
    'fabric.media.accounts': 'Účty',
    'fabric.media.actions': 'Akce',
    'fabric.media.error_hint_retry': 'Zkuste to znovu a my se o to také pokusíme.',
    'fabric.media.error_hint_critical': 'Pokud problém přetrvává, kontaktujte podporu.',
    'fabric.media.close': 'Zavřít',
    'fabric.media.could_not_load_editor': 'Editor se nepodařilo načíst.',
    'fabric.media.could_not_save_image': 'Obrázek se nepodařilo uložit.',
    'fabric.media.annotate': 'Přidat poznámku',
    'fabric.media.drop_your_files_here': 'Přetáhněte své soubory sem.',
    'fabric.media.share_files_instantly': 'Okamžitě je nasdílíme.',
    'fabric.media.insert_files': '{0, plural, one{Vložit soubor} few{Vložit {0} soubory} many{Insert a file} other{Vložit {0} souborů}}',
    'fabric.media.zoom_out': 'zoom out',
    'fabric.media.zoom_in': 'zoom in',
    'fabric.media.remove_image': 'Remove image',
    'fabric.media.play': 'play',
    'fabric.media.pause': 'pause',
    'fabric.media.disable_fullscreen': 'disable fullscreen',
    'fabric.media.enable_fullscreen': 'enable fullscreen',
    'fabric.media.error_loading_file': 'Error loading file',
    'fabric.media.error_generating_preview': 'Error generating preview',
    'fabric.media.download': 'Download',
    'fabric.media.unknown': 'unknown',
    'fabric.media.document': 'document',
    'fabric.media.audio': 'audio',
    'fabric.media.video': 'video',
    'fabric.media.image': 'image',
});
//# sourceMappingURL=cs.js.map

/***/ }),
/* 2125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Danish
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': 'Prøv igen',
    'fabric.media.failed_to_load': 'Kunne ikke indlæses',
    'fabric.media.recent_uploads': 'Senest uploadet',
    'fabric.media.upload_file': 'Upload en fil',
    'fabric.media.drag_and_drop_your_files': 'Træk, og slip dine filer hertil, eller',
    'fabric.media.drop_your_files': 'Træk filer hertil for at uploade',
    'fabric.media.upload': 'Upload',
    'fabric.media.cancel': 'Annullér',
    'fabric.media.search_all_gifs': "Søg i alle GIF'er!",
    'fabric.media.cant_retrieve_gifs': "Ups! Vi kunne ikke hente GIF'er",
    'fabric.media.check_your_network': 'Tjek din netværksforbindelse',
    'fabric.media.try_again': 'Prøv igen',
    'fabric.media.no_gifs_found': 'Hallo? Var det mig, du ledte efter?',
    'fabric.media.no_gifs_found_suggestion': 'Vi kunne ikke finde noget for "{query}"',
    'fabric.media.load_more_gifs': "Indlæs flere GIF'er",
    'fabric.media.add_account': 'Tilføj konto',
    'fabric.media.unlink_account': 'Fjern link til konto',
    'fabric.media.upload_file_from': 'Upload en fil fra {name}',
    'fabric.media.connect_to': 'Forbind til {name}',
    'fabric.media.connect_account_description': 'Vi åbner en ny side for at hjælpe dig til at forbinde din {name}-konto',
    'fabric.media.upload_an_avatar': 'Upload en avatar',
    'fabric.media.save': 'Gem',
    'fabric.media.or': 'eller',
    'fabric.media.upload_photo': 'Upload et foto',
    'fabric.media.default_avatars': 'Standard-avatarer',
    'fabric.media.drag_and_drop_images_here': 'Træk dine billeder herover, og slip dem',
    'fabric.media.upload_image': 'Upload billede',
    'fabric.media.image_url_invalid_error': 'Billedet kunne ikke indlæses; ugyldig URL.',
    'fabric.media.image_format_invalid_error': 'Billedet kunne ikke indlæses; ugyldigt format.',
    'fabric.media.image_size_too_large_error': 'Billedet er for stort. Det må ikke være større end  {MAX_SIZE_MB}MB',
    'fabric.media.something_went_wrong': 'Noget gik galt.',
    'fabric.media.might_be_a_hiccup': 'Det må være et midlertidigt problem.',
    'fabric.media.couldnt_generate_preview': 'Vi kunne ikke vise denne fil.',
    'fabric.media.cant_preview_file_type': 'Vi kan ikke vise denne filtype.',
    'fabric.media.item_not_found_in_list': 'Det valgte element blev ikke fundet på listen.',
    'fabric.media.no_pdf_artifacts': 'Ingen PDF-artefakter for denne fil fundet.',
    'fabric.media.give_feedback': 'Giv feedback',
    'fabric.media.try_downloading_file': 'Prøv at downloade filen for at vise den.',
    'fabric.media.webgl_warning_description': 'Din browser understøtter ikke WebGL. Brug en WebGL-kompatibel browser for at annotere billeder.',
    'fabric.media.unable_to_annotate_image': 'Du kan ikke annotere dette billede',
    'fabric.media.learn_more': 'Få mere at vide',
    'fabric.media.accounts': 'Konti',
    'fabric.media.actions': 'Handlinger',
    'fabric.media.error_hint_retry': 'Prøv igen, så giver vi det endnu et forsøg.',
    'fabric.media.error_hint_critical': 'Hvis problemet fortsat opstår, skal du kontakte support.',
    'fabric.media.close': 'Luk',
    'fabric.media.could_not_load_editor': 'Ups! Vi kunne ikke indlæse editoren',
    'fabric.media.could_not_save_image': 'Ups! Vi kunne ikke gemme billedet',
    'fabric.media.annotate': 'Annotér',
    'fabric.media.drop_your_files_here': 'Træk dine filer hertil',
    'fabric.media.share_files_instantly': 'Vi deler dem med det samme',
    'fabric.media.insert_files': '{0, plural, one{Indsæt en fil} other{Indsæt {0} filer}}',
    'fabric.media.zoom_out': 'zoom ud',
    'fabric.media.zoom_in': 'zoom ind',
    'fabric.media.remove_image': 'Fjern billede',
    'fabric.media.play': 'afspil',
    'fabric.media.pause': 'pause',
    'fabric.media.disable_fullscreen': 'slå fuldskærmsvisning fra',
    'fabric.media.enable_fullscreen': 'slå fuldskærmsvisning til',
    'fabric.media.error_loading_file': 'Fejl ved indlæsning af fil',
    'fabric.media.error_generating_preview': 'Fejl ved forhåndsvisning',
    'fabric.media.download': 'Hent',
    'fabric.media.unknown': 'ukendt',
    'fabric.media.document': 'dokument',
    'fabric.media.audio': 'lyd',
    'fabric.media.video': 'video',
    'fabric.media.image': 'billede',
});
//# sourceMappingURL=da.js.map

/***/ }),
/* 2126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Dutch
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': 'Probeer opnieuw',
    'fabric.media.failed_to_load': 'Fout bij het laden',
    'fabric.media.recent_uploads': 'Recente uploads',
    'fabric.media.upload_file': 'Bestand uploaden',
    'fabric.media.drag_and_drop_your_files': 'Bestanden ergens naartoe slepen en neerzetten of',
    'fabric.media.drop_your_files': 'Zet hier je te uploaden bestanden neer',
    'fabric.media.upload': 'Uploaden',
    'fabric.media.cancel': 'Annuleren',
    'fabric.media.search_all_gifs': "Doorzoek alle GIF's!",
    'fabric.media.cant_retrieve_gifs': "Oei! We konden geen GIF's vinden",
    'fabric.media.check_your_network': 'Controleer je netwerkverbinding',
    'fabric.media.try_again': 'Opnieuw proberen',
    'fabric.media.no_gifs_found': 'Hallo? Was je naar mij op zoek?',
    'fabric.media.no_gifs_found_suggestion': 'We konden niks vinden voor "{query}"',
    'fabric.media.load_more_gifs': "Meer GIF's laden",
    'fabric.media.add_account': 'Account toevoegen',
    'fabric.media.unlink_account': 'Verbinding met account verwijderen',
    'fabric.media.upload_file_from': 'Een bestand vanaf {name} uploaden',
    'fabric.media.connect_to': 'Met {name} verbinden',
    'fabric.media.connect_account_description': 'We zullen een nieuwe pagina openen waarop je je {name}-account kunt verbinden',
    'fabric.media.upload_an_avatar': 'Profielfoto uploaden',
    'fabric.media.save': 'Opslaan',
    'fabric.media.or': 'of',
    'fabric.media.upload_photo': 'Foto uploaden',
    'fabric.media.default_avatars': "Standaard profielfoto's",
    'fabric.media.drag_and_drop_images_here': 'Afbeelding hierheen slepen en neerzetten',
    'fabric.media.upload_image': 'Afbeelding uploaden',
    'fabric.media.image_url_invalid_error': 'De afbeelding kon niet geladen worden omdat de URL ongeldig is.',
    'fabric.media.image_format_invalid_error': 'De afbeelding kon niet geladen worden omdat het bestandsformaat ongeldig is.',
    'fabric.media.image_size_too_large_error': 'De afbeelding is te groot. Het mag niet groter zijn dan {MAX_SIZE_MB} MB.',
    'fabric.media.something_went_wrong': 'Er is iets misgegaan.',
    'fabric.media.might_be_a_hiccup': 'Het kan even een tijdelijke kink in de kabel zijn.',
    'fabric.media.couldnt_generate_preview': 'Voor dit bestandstype kunnen we geen voorvertoning weergeven.',
    'fabric.media.cant_preview_file_type': 'Voor dit bestandstype kunnen we geen voorvertoning weergeven.',
    'fabric.media.item_not_found_in_list': 'Het geselecteerde item is niet op de lijst gevonden.',
    'fabric.media.no_pdf_artifacts': 'Geen PDF-artefacten gevonden voor dit bestand.',
    'fabric.media.give_feedback': 'Feedback geven',
    'fabric.media.try_downloading_file': 'Probeer het bestand te downloaden om het te bekijken.',
    'fabric.media.webgl_warning_description': 'Je browser ondersteunt niet WebGL. Gebruik een browser met WebGL-functie om aantekeningen te maken bij afbeeldingen.',
    'fabric.media.unable_to_annotate_image': 'Je kunt bij deze afbeelding geen aantekeningen maken',
    'fabric.media.learn_more': 'Meer informatie',
    'fabric.media.accounts': 'Accounts',
    'fabric.media.actions': 'Acties',
    'fabric.media.error_hint_retry': 'Probeer het opnieuw.',
    'fabric.media.error_hint_critical': 'Neem contact op met support als dit probleem zich blijft voordoen.',
    'fabric.media.close': 'Sluiten',
    'fabric.media.could_not_load_editor': 'Oei! De editor kon niet geladen worden',
    'fabric.media.could_not_save_image': 'Oei! De afbeelding kon niet opgeslagen worden',
    'fabric.media.annotate': 'Aantekeningen maken',
    'fabric.media.drop_your_files_here': 'Zet je bestanden hier neer.',
    'fabric.media.share_files_instantly': 'We delen de bestanden direct',
    'fabric.media.insert_files': '{0, plural, one{Een bestand invoegen} other{{0} bestanden invoegen}}',
    'fabric.media.zoom_out': 'zoom out',
    'fabric.media.zoom_in': 'zoom in',
    'fabric.media.remove_image': 'Remove image',
    'fabric.media.play': 'play',
    'fabric.media.pause': 'pause',
    'fabric.media.disable_fullscreen': 'disable fullscreen',
    'fabric.media.enable_fullscreen': 'enable fullscreen',
    'fabric.media.error_loading_file': 'Error loading file',
    'fabric.media.error_generating_preview': 'Error generating preview',
    'fabric.media.download': 'Download',
    'fabric.media.unknown': 'unknown',
    'fabric.media.document': 'document',
    'fabric.media.audio': 'audio',
    'fabric.media.video': 'video',
    'fabric.media.image': 'image',
});
//# sourceMappingURL=nl.js.map

/***/ }),
/* 2127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// English
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': 'Retry',
    'fabric.media.failed_to_load': 'Failed to load',
    'fabric.media.recent_uploads': 'Recent uploads',
    'fabric.media.upload_file': 'Upload a file',
    'fabric.media.drag_and_drop_your_files': 'Drag and drop your files anywhere or',
    'fabric.media.drop_your_files': 'Drop your files to upload',
    'fabric.media.upload': 'Upload',
    'fabric.media.cancel': 'Cancel',
    'fabric.media.search_all_gifs': 'Search all the GIFs!',
    'fabric.media.cant_retrieve_gifs': 'Ouch! We could not retrieve any GIFs',
    'fabric.media.check_your_network': 'Check your network connection',
    'fabric.media.try_again': 'Try again',
    'fabric.media.no_gifs_found': "Hello? Was it me you're looking for?",
    'fabric.media.no_gifs_found_suggestion': 'We couldn\'t find anything for "{query}"',
    'fabric.media.load_more_gifs': 'Load more GIFs',
    'fabric.media.add_account': 'Add account',
    'fabric.media.unlink_account': 'Unlink Account',
    'fabric.media.upload_file_from': 'Upload a file from {name}',
    'fabric.media.connect_to': 'Connect to {name}',
    'fabric.media.connect_account_description': "We'll open a new page to help you connect your {name} account",
    'fabric.media.upload_an_avatar': 'Upload an avatar',
    'fabric.media.save': 'Save',
    'fabric.media.or': 'or',
    'fabric.media.upload_photo': 'Upload a photo',
    'fabric.media.default_avatars': 'Default avatars',
    'fabric.media.drag_and_drop_images_here': 'Drag and drop your images here',
    'fabric.media.upload_image': 'Upload image',
    'fabric.media.image_url_invalid_error': 'Could not load image, the url is invalid.',
    'fabric.media.image_format_invalid_error': 'Could not load image, the format is invalid.',
    'fabric.media.image_size_too_large_error': 'Image is too large, must be no larger than {MAX_SIZE_MB}Mb',
    'fabric.media.something_went_wrong': 'Something went wrong.',
    'fabric.media.might_be_a_hiccup': 'It might just be a hiccup.',
    'fabric.media.couldnt_generate_preview': "We couldn't generate a preview for this file.",
    'fabric.media.cant_preview_file_type': "We can't preview this file type.",
    'fabric.media.item_not_found_in_list': 'The selected item was not found on the list.',
    'fabric.media.no_pdf_artifacts': 'No PDF artifacts found for this file.',
    'fabric.media.give_feedback': 'Give feedback',
    'fabric.media.try_downloading_file': 'Try downloading the file to view it.',
    'fabric.media.webgl_warning_description': 'Your browser does not support WebGL. Use a WebGL enabled browser to annotate images.',
    'fabric.media.unable_to_annotate_image': "You're unable to annotate this image",
    'fabric.media.learn_more': 'Learn More',
    'fabric.media.accounts': 'Accounts',
    'fabric.media.actions': 'Actions',
    'fabric.media.error_hint_retry': "Try again and we'll give it another shot.",
    'fabric.media.error_hint_critical': 'If the problem keeps happening contact support.',
    'fabric.media.close': 'Close',
    'fabric.media.could_not_load_editor': 'Ouch! We could not load the editor',
    'fabric.media.could_not_save_image': 'Ouch! We could not save the image',
    'fabric.media.annotate': 'Annotate',
    'fabric.media.drop_your_files_here': 'Drop your files here',
    'fabric.media.share_files_instantly': "We'll share them instantly",
    'fabric.media.insert_files': '{0, plural, one{Insert a file} other{Insert {0} files}}',
    'fabric.media.zoom_out': 'zoom out',
    'fabric.media.zoom_in': 'zoom in',
    'fabric.media.remove_image': 'Remove image',
    'fabric.media.play': 'play',
    'fabric.media.pause': 'pause',
    'fabric.media.disable_fullscreen': 'disable fullscreen',
    'fabric.media.enable_fullscreen': 'enable fullscreen',
    'fabric.media.error_loading_file': 'Error loading file',
    'fabric.media.error_generating_preview': 'Error generating preview',
    'fabric.media.download': 'Download',
    'fabric.media.unknown': 'unknown',
    'fabric.media.document': 'document',
    'fabric.media.audio': 'audio',
    'fabric.media.video': 'video',
    'fabric.media.image': 'image',
});
//# sourceMappingURL=en.js.map

/***/ }),
/* 2128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// English (United Kingdom)
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': 'Retry',
    'fabric.media.failed_to_load': 'Failed to load',
    'fabric.media.recent_uploads': 'Recent uploads',
    'fabric.media.upload_file': 'Upload a file',
    'fabric.media.drag_and_drop_your_files': 'Drag and drop your files anywhere or',
    'fabric.media.drop_your_files': 'Drop your files to upload',
    'fabric.media.upload': 'Upload',
    'fabric.media.cancel': 'Cancel',
    'fabric.media.search_all_gifs': 'Search all the GIFs!',
    'fabric.media.cant_retrieve_gifs': 'Ouch! We could not retrieve any GIFs',
    'fabric.media.check_your_network': 'Check your network connection',
    'fabric.media.try_again': 'Try again',
    'fabric.media.no_gifs_found': "Hello? Was it me you're looking for?",
    'fabric.media.no_gifs_found_suggestion': 'We couldn\'t find anything for "{query}"',
    'fabric.media.load_more_gifs': 'Load more GIFs',
    'fabric.media.add_account': 'Add account',
    'fabric.media.unlink_account': 'Unlink Account',
    'fabric.media.upload_file_from': 'Upload a file from {name}',
    'fabric.media.connect_to': 'Connect to {name}',
    'fabric.media.connect_account_description': "We'll open a new page to help you connect your {name} account",
    'fabric.media.upload_an_avatar': 'Upload an avatar',
    'fabric.media.save': 'Save',
    'fabric.media.or': 'or',
    'fabric.media.upload_photo': 'Upload a photo',
    'fabric.media.default_avatars': 'Default avatars',
    'fabric.media.drag_and_drop_images_here': 'Drag and drop your images here',
    'fabric.media.upload_image': 'Upload image',
    'fabric.media.image_url_invalid_error': 'Could not load image, the url is invalid.',
    'fabric.media.image_format_invalid_error': 'Could not load image, the format is invalid.',
    'fabric.media.image_size_too_large_error': 'Image is too large, must be no larger than {MAX_SIZE_MB}Mb',
    'fabric.media.something_went_wrong': 'Something went wrong.',
    'fabric.media.might_be_a_hiccup': 'It might just be a hiccup.',
    'fabric.media.couldnt_generate_preview': "We couldn't generate a preview for this file.",
    'fabric.media.cant_preview_file_type': "We can't preview this file type.",
    'fabric.media.item_not_found_in_list': 'The selected item was not found on the list.',
    'fabric.media.no_pdf_artifacts': 'No PDF artifacts found for this file.',
    'fabric.media.give_feedback': 'Give feedback',
    'fabric.media.try_downloading_file': 'Try downloading the file to view it.',
    'fabric.media.webgl_warning_description': 'Your browser does not support WebGL. Use a WebGL enabled browser to annotate images.',
    'fabric.media.unable_to_annotate_image': "You're unable to annotate this image",
    'fabric.media.learn_more': 'Learn More',
    'fabric.media.accounts': 'Accounts',
    'fabric.media.actions': 'Actions',
    'fabric.media.error_hint_retry': "Try again and we'll give it another shot.",
    'fabric.media.error_hint_critical': 'If the problem keeps happening contact support.',
    'fabric.media.close': 'Close',
    'fabric.media.could_not_load_editor': 'Ouch! We could not load the editor',
    'fabric.media.could_not_save_image': 'Ouch! We could not save the image',
    'fabric.media.annotate': 'Annotate',
    'fabric.media.drop_your_files_here': 'Drop your files here',
    'fabric.media.share_files_instantly': "We'll share them instantly",
    'fabric.media.insert_files': '{0, plural, one{Insert a file} other{Insert {0} files}}',
    'fabric.media.zoom_out': 'zoom out',
    'fabric.media.zoom_in': 'zoom in',
    'fabric.media.remove_image': 'Remove image',
    'fabric.media.play': 'play',
    'fabric.media.pause': 'pause',
    'fabric.media.disable_fullscreen': 'disable fullscreen',
    'fabric.media.enable_fullscreen': 'enable fullscreen',
    'fabric.media.error_loading_file': 'Error loading file',
    'fabric.media.error_generating_preview': 'Error generating preview',
    'fabric.media.download': 'Download',
    'fabric.media.unknown': 'unknown',
    'fabric.media.document': 'document',
    'fabric.media.audio': 'audio',
    'fabric.media.video': 'video',
    'fabric.media.image': 'image',
});
//# sourceMappingURL=en_GB.js.map

/***/ }),
/* 2129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Estonian
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': 'Proovi uuesti',
    'fabric.media.failed_to_load': 'Laadimine nurjus',
    'fabric.media.recent_uploads': 'Hiljutised üleslaadimised',
    'fabric.media.upload_file': 'Faili üleslaadimine',
    'fabric.media.drag_and_drop_your_files': 'Lohista ja aseta oma failid ükskõik, kuhu või',
    'fabric.media.drop_your_files': 'Üleslaadimiseks aseta failid',
    'fabric.media.upload': 'Laadi üles',
    'fabric.media.cancel': 'Tühista',
    'fabric.media.search_all_gifs': 'Otsi kõikide GIFide seast!',
    'fabric.media.cant_retrieve_gifs': 'Oih! Me ei leidnud ühtki GIFi',
    'fabric.media.check_your_network': 'Kontrolli oma võrguühendust',
    'fabric.media.try_again': 'Proovi uuesti',
    'fabric.media.no_gifs_found': 'Tere.. Kas otsisid mind?',
    'fabric.media.no_gifs_found_suggestion': 'Me ei leidnud seoses päringuga „{query}“ midagi',
    'fabric.media.load_more_gifs': 'Lae veel GIFe',
    'fabric.media.add_account': 'Lisa konto',
    'fabric.media.unlink_account': 'Eemalda kontolt seos',
    'fabric.media.upload_file_from': 'Laadi fail üles {name}-st',
    'fabric.media.connect_to': 'Ühendu teenusega {name}',
    'fabric.media.connect_account_description': '{name} konto ühendamisel abi pakkumiseks avame uue lehekülje',
    'fabric.media.upload_an_avatar': 'Laadi avatar üles',
    'fabric.media.save': 'Salvesta',
    'fabric.media.or': 'või',
    'fabric.media.upload_photo': 'Foto üleslaadimine',
    'fabric.media.default_avatars': 'Vaikimisi avatarid',
    'fabric.media.drag_and_drop_images_here': 'Lohista ja lisa pildid siia',
    'fabric.media.upload_image': 'Laadi pilt üles',
    'fabric.media.image_url_invalid_error': 'Pilt ei õnnestunud laadida, URL ei kehti.',
    'fabric.media.image_format_invalid_error': 'Pilt ei õnnestunud laadida, formaat ei kehti.',
    'fabric.media.image_size_too_large_error': 'Pilt on liiga suur, ei tohi olla suurem kui {MAX_SIZE_MB}Mb',
    'fabric.media.something_went_wrong': 'Midagi läks valesti.',
    'fabric.media.might_be_a_hiccup': 'Tegu võib olla väikese tagasilöögiga.',
    'fabric.media.couldnt_generate_preview': 'Selle faili eelvaadet ei saa luua.',
    'fabric.media.cant_preview_file_type': 'Seda failitüüpi ei saa eelvaadata.',
    'fabric.media.item_not_found_in_list': 'Valitut ei leitud loendist.',
    'fabric.media.no_pdf_artifacts': 'Ühtki PDF järeletehtud objekti ei leitud selle faili jaoks.',
    'fabric.media.give_feedback': 'Anna tagasisidet',
    'fabric.media.try_downloading_file': 'Faili vaatamiseks proovi see alla laadida.',
    'fabric.media.webgl_warning_description': 'Veebilehitseja ei toeta WebGLi. Piltidele märke lisamiseks kasuta WebGL toetavat veebilehitsejat.',
    'fabric.media.unable_to_annotate_image': 'Sa ei saa sellele pildile lisada märke',
    'fabric.media.learn_more': 'Lisateave',
    'fabric.media.accounts': 'Kontod',
    'fabric.media.actions': 'Toimingud',
    'fabric.media.error_hint_retry': 'Proovi uuesti ja anname uue võimaluse.',
    'fabric.media.error_hint_critical': 'Probleemi kordumisel võta ühendust klienditoega.',
    'fabric.media.close': 'Sulge',
    'fabric.media.could_not_load_editor': 'Ups! Muutja laadimine nurjus',
    'fabric.media.could_not_save_image': 'Ups! Pildi salvestamine nurjus',
    'fabric.media.annotate': 'Lisa märge',
    'fabric.media.drop_your_files_here': 'Aseta failid siia',
    'fabric.media.share_files_instantly': 'Jagame seda kohe',
    'fabric.media.insert_files': '{0, plural, one{Sisesta fail} other{Sisesta {0} faili}}',
    'fabric.media.zoom_out': 'vähenda',
    'fabric.media.zoom_in': 'Suurenda',
    'fabric.media.remove_image': 'Eemalda pilt',
    'fabric.media.play': 'esita',
    'fabric.media.pause': 'pausi',
    'fabric.media.disable_fullscreen': 'keela täisekraan',
    'fabric.media.enable_fullscreen': 'luba täisekraan',
    'fabric.media.error_loading_file': 'Faili laadimisel tekkis tõrge',
    'fabric.media.error_generating_preview': 'Eelvaate loomisel tekkis viga',
    'fabric.media.download': 'Laadi alla',
    'fabric.media.unknown': 'teadmata',
    'fabric.media.document': 'dokument',
    'fabric.media.audio': 'heli',
    'fabric.media.video': 'video',
    'fabric.media.image': 'pilt',
});
//# sourceMappingURL=et.js.map

/***/ }),
/* 2130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Finnish
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': 'Yritä uudelleen',
    'fabric.media.failed_to_load': 'Ei voitu ladata',
    'fabric.media.recent_uploads': 'Viimeaikaiset lataukset',
    'fabric.media.upload_file': 'Lataa tiedosto',
    'fabric.media.drag_and_drop_your_files': 'Vedä ja pudota tiedostosi minne tahansa tai',
    'fabric.media.drop_your_files': 'Pudota tiedostosi ladattavaksi',
    'fabric.media.upload': 'Lataa',
    'fabric.media.cancel': 'Peruuta',
    'fabric.media.search_all_gifs': 'Hae kaikista GIFeistä!',
    'fabric.media.cant_retrieve_gifs': 'Voi ei! Emme voineet noutaa yhtään GIFiä',
    'fabric.media.check_your_network': 'Tarkista verkkoyhteytesi',
    'fabric.media.try_again': 'Yritä uudelleen',
    'fabric.media.no_gifs_found': 'Hei? Minuako etsit?',
    'fabric.media.no_gifs_found_suggestion': 'Emme löytäneet tuloksia kyselylle "{query}"',
    'fabric.media.load_more_gifs': 'Lataa lisää GIFejä',
    'fabric.media.add_account': 'Lisää tili',
    'fabric.media.unlink_account': 'Poista tilin linkitys',
    'fabric.media.upload_file_from': 'Lataa tiedosto kohteesta {name}',
    'fabric.media.connect_to': 'Yhdistä kohteeseen {name}',
    'fabric.media.connect_account_description': 'Avaamme uuden sivun, jotta voimme auttaa sinua yhdistämään {name} -tilisi',
    'fabric.media.upload_an_avatar': 'Lataa avatar',
    'fabric.media.save': 'Tallenna ',
    'fabric.media.or': 'tai',
    'fabric.media.upload_photo': 'Lataa kuva',
    'fabric.media.default_avatars': 'Oletusavatarit',
    'fabric.media.drag_and_drop_images_here': 'Vedä ja pudota kuvasi tänne',
    'fabric.media.upload_image': 'Lataa kuva',
    'fabric.media.image_url_invalid_error': 'Kuvaa ei voitu ladata, url-osoite on virheellinen.',
    'fabric.media.image_format_invalid_error': 'Kuvaa ei voitu ladata, muoto on virheellinen.',
    'fabric.media.image_size_too_large_error': 'Kuva on liian suuri, se ei voi olla suurempi kuin {MAX_SIZE_MB}Mt',
    'fabric.media.something_went_wrong': 'Jotain meni pieleen.',
    'fabric.media.might_be_a_hiccup': 'Se saattaa olla vain tilapäinen ongelma.',
    'fabric.media.couldnt_generate_preview': 'Tälle tiedostolle ei voitu luoda esikatselua.',
    'fabric.media.cant_preview_file_type': 'Tätä tiedostotyyppiä ei voi esikatsella.',
    'fabric.media.item_not_found_in_list': 'Valittua kohdetta ei löytynyt luettelosta.',
    'fabric.media.no_pdf_artifacts': 'PDF-artefaktoja ei löytynyt tälle tiedostolle.',
    'fabric.media.give_feedback': 'Anna palautetta',
    'fabric.media.try_downloading_file': 'Kokeile ladata tiedosto, jotta voit tarkastella sitä.',
    'fabric.media.webgl_warning_description': 'Selaimesi ei tue WebGL:ää. Käytä WebGL:ää tukevaa selainta, jos haluat tehdä merkintöjä kuviin.',
    'fabric.media.unable_to_annotate_image': 'Et voi tehdä merkintöjä tähän kuvaan',
    'fabric.media.learn_more': 'Lue lisää   ',
    'fabric.media.accounts': 'Tilit',
    'fabric.media.actions': 'Toiminnot',
    'fabric.media.error_hint_retry': 'Yritä uudelleen, ja mekin kokeilemme vielä kerran.',
    'fabric.media.error_hint_critical': 'Jos ongelma toistuu jatkuvasti, ota yhteyttä tukeen.',
    'fabric.media.close': 'Sulje',
    'fabric.media.could_not_load_editor': 'Voi ei! Muokkainta ei voitu ladata',
    'fabric.media.could_not_save_image': 'Voi ei! Kuvaa ei voitu tallentaa',
    'fabric.media.annotate': 'Tee merkintöjä',
    'fabric.media.drop_your_files_here': 'Pudota tiedostosi tänne',
    'fabric.media.share_files_instantly': 'Jaamme ne heti',
    'fabric.media.insert_files': '{0, plural, one{Lisää tiedosto} other{Lisää {0} tiedostoa}}',
    'fabric.media.zoom_out': 'zoom out',
    'fabric.media.zoom_in': 'zoom in',
    'fabric.media.remove_image': 'Remove image',
    'fabric.media.play': 'play',
    'fabric.media.pause': 'pause',
    'fabric.media.disable_fullscreen': 'disable fullscreen',
    'fabric.media.enable_fullscreen': 'enable fullscreen',
    'fabric.media.error_loading_file': 'Error loading file',
    'fabric.media.error_generating_preview': 'Error generating preview',
    'fabric.media.download': 'Download',
    'fabric.media.unknown': 'unknown',
    'fabric.media.document': 'document',
    'fabric.media.audio': 'audio',
    'fabric.media.video': 'video',
    'fabric.media.image': 'image',
});
//# sourceMappingURL=fi.js.map

/***/ }),
/* 2131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// French
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': 'Réessayer',
    'fabric.media.failed_to_load': 'Échec du chargement',
    'fabric.media.recent_uploads': 'Importations récentes',
    'fabric.media.upload_file': 'Importer un fichier',
    'fabric.media.drag_and_drop_your_files': " Glisser-déplacer des fichiers n'importe où ou",
    'fabric.media.drop_your_files': 'Déposer vos fichiers à importer',
    'fabric.media.upload': 'Importer',
    'fabric.media.cancel': 'Annuler',
    'fabric.media.search_all_gifs': 'Rechercher parmi tous les GIF',
    'fabric.media.cant_retrieve_gifs': "Désolés, nous n'avons pu récupérer aucun GIF",
    'fabric.media.check_your_network': 'Vérifier votre connexion réseau',
    'fabric.media.try_again': 'Réessayez',
    'fabric.media.no_gifs_found': "Hello? Is it me you're looking for?",
    'fabric.media.no_gifs_found_suggestion': "Nous n'avons trouvé aucun résultat pour « {query} »",
    'fabric.media.load_more_gifs': 'Charger plus de GIF',
    'fabric.media.add_account': 'Ajouter un compte',
    'fabric.media.unlink_account': 'Dissocier le compte',
    'fabric.media.upload_file_from': 'Importer un fichier depuis {name}',
    'fabric.media.connect_to': 'Se connecter à {name}',
    'fabric.media.connect_account_description': 'Nous ouvrirons une nouvelle page pour vous aider à vous connecter à votre compte {name}',
    'fabric.media.upload_an_avatar': 'Importer un avatar',
    'fabric.media.save': 'Enregistrer',
    'fabric.media.or': 'ou',
    'fabric.media.upload_photo': 'Importer une photo',
    'fabric.media.default_avatars': 'Avatars par défaut',
    'fabric.media.drag_and_drop_images_here': ' Glisser-déplacer vos images ici',
    'fabric.media.upload_image': 'Importer une image',
    'fabric.media.image_url_invalid_error': "Impossible de charger l'image, l'URL n'est pas valide.",
    'fabric.media.image_format_invalid_error': "Impossible de charger l'image, le format n'est pas valide.",
    'fabric.media.image_size_too_large_error': "L'image est trop grande. Elle ne doit pas dépasser {MAX_SIZE_MB} Mo",
    'fabric.media.something_went_wrong': "Une erreur s'est produite.",
    'fabric.media.might_be_a_hiccup': "Ce n'est sûrement qu'un contretemps.",
    'fabric.media.couldnt_generate_preview': "Impossible de générer l'aperçu de ce fichier.",
    'fabric.media.cant_preview_file_type': 'Aucun aperçu disponible pour ce type de fichiers.',
    'fabric.media.item_not_found_in_list': "L'élément sélectionné ne fait pas partie de la liste.",
    'fabric.media.no_pdf_artifacts': 'Aucun artefact PDF trouvé pour ce fichier.',
    'fabric.media.give_feedback': 'Envoyer un commentaire',
    'fabric.media.try_downloading_file': 'Essayez de télécharger le fichier pour le consulter.',
    'fabric.media.webgl_warning_description': 'Votre navigateur ne prend pas en charge WebGL. Utilisez un navigateur compatible WebGL pour annoter les images.',
    'fabric.media.unable_to_annotate_image': 'Vous ne pouvez pas annoter cette image',
    'fabric.media.learn_more': 'En savoir plus',
    'fabric.media.accounts': 'Comptes',
    'fabric.media.actions': 'Actions',
    'fabric.media.error_hint_retry': 'Réessayez.',
    'fabric.media.error_hint_critical': "Si le problème persiste, contactez le service d'assistance.",
    'fabric.media.close': 'Fermer',
    'fabric.media.could_not_load_editor': "Désolés, nous n'avons pas pu charger l'éditeur",
    'fabric.media.could_not_save_image': "Désolés, nous n'avons pas pu enregistrer l'image",
    'fabric.media.annotate': 'Annoter',
    'fabric.media.drop_your_files_here': 'Déposer vos fichiers ici',
    'fabric.media.share_files_instantly': 'Nous les partagerons instantanément',
    'fabric.media.insert_files': '{0, plural, one{Insérer un fichier} other{Insérer {0} fichiers}}',
    'fabric.media.zoom_out': 'zoom out',
    'fabric.media.zoom_in': 'zoom in',
    'fabric.media.remove_image': 'Remove image',
    'fabric.media.play': 'play',
    'fabric.media.pause': 'pause',
    'fabric.media.disable_fullscreen': 'disable fullscreen',
    'fabric.media.enable_fullscreen': 'enable fullscreen',
    'fabric.media.error_loading_file': 'Error loading file',
    'fabric.media.error_generating_preview': 'Error generating preview',
    'fabric.media.download': 'Download',
    'fabric.media.unknown': 'unknown',
    'fabric.media.document': 'document',
    'fabric.media.audio': 'audio',
    'fabric.media.video': 'video',
    'fabric.media.image': 'image',
});
//# sourceMappingURL=fr.js.map

/***/ }),
/* 2132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// German
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': 'Erneut versuchen',
    'fabric.media.failed_to_load': 'Fehler beim Laden',
    'fabric.media.recent_uploads': 'Aktuelle Uploads',
    'fabric.media.upload_file': 'Datei hochladen',
    'fabric.media.drag_and_drop_your_files': 'Dateien irgendwohin ziehen und ablegen oder',
    'fabric.media.drop_your_files': 'Dateien zum Hochladen ablegen',
    'fabric.media.upload': 'Hochladen',
    'fabric.media.cancel': 'Abbrechen',
    'fabric.media.search_all_gifs': 'Durchsuchen Sie alle GIFs!',
    'fabric.media.cant_retrieve_gifs': 'Hoppla, es konnten keine GIFs abgerufen werden.',
    'fabric.media.check_your_network': 'Überprüfen Sie Ihre Netzwerkverbindung.',
    'fabric.media.try_again': 'Erneut versuchen',
    'fabric.media.no_gifs_found': 'Hallo? Haben Sie nach mir gesucht?',
    'fabric.media.no_gifs_found_suggestion': 'Es wurden keine Ergebnisse für „{query}” gefunden.',
    'fabric.media.load_more_gifs': 'Mehr GIFs laden',
    'fabric.media.add_account': 'Account hinzufügen',
    'fabric.media.unlink_account': 'Account-Verknüpfung löschen',
    'fabric.media.upload_file_from': 'Datei von {name} hochladen',
    'fabric.media.connect_to': 'Mit {name} verbinden',
    'fabric.media.connect_account_description': 'Es wird eine neue Seite geöffnet, auf der Sie Ihren {name}-Account verbinden können.',
    'fabric.media.upload_an_avatar': 'Avatar hochladen',
    'fabric.media.save': 'Speichern',
    'fabric.media.or': 'oder',
    'fabric.media.upload_photo': 'Foto hochladen',
    'fabric.media.default_avatars': 'Standard-Avatare',
    'fabric.media.drag_and_drop_images_here': 'Ihre Bilder hierher ziehen und ablegen.',
    'fabric.media.upload_image': 'Bild hochladen',
    'fabric.media.image_url_invalid_error': 'Das Bild konnte nicht geladen werden. Die URL ist ungültig.',
    'fabric.media.image_format_invalid_error': 'Das Bild konnte nicht geladen werden. Das Format ist ungültig.',
    'fabric.media.image_size_too_large_error': 'Das Bild ist zu groß. Es darf nicht größer sein als {MAX_SIZE_MB} MB.',
    'fabric.media.something_went_wrong': 'Irgendetwas ist schiefgelaufen.',
    'fabric.media.might_be_a_hiccup': 'Wahrscheinlich ist es nur ein vorübergehendes Problem.',
    'fabric.media.couldnt_generate_preview': 'Für diese Datei kann keine Vorschau generiert werden.',
    'fabric.media.cant_preview_file_type': 'Für diesen Dateityp kann keine Vorschau angezeigt werden.',
    'fabric.media.item_not_found_in_list': 'Das ausgewählte Element wurde nicht auf der Liste gefunden.',
    'fabric.media.no_pdf_artifacts': 'Keine PDF-Artifakte für diese Datei gefunden.',
    'fabric.media.give_feedback': 'Feedback geben',
    'fabric.media.try_downloading_file': 'Laden Sie die Datei herunter, um sie anzusehen.',
    'fabric.media.webgl_warning_description': 'Ihr Browser unterstützt WebGL nicht. Verwenden Sie zum Kommentieren von Bildern einen WebGL-fähigen Browser.',
    'fabric.media.unable_to_annotate_image': 'Sie können dieses Bild nicht kommentieren.',
    'fabric.media.learn_more': 'Mehr erfahren',
    'fabric.media.accounts': 'Accounts',
    'fabric.media.actions': 'Aktionen',
    'fabric.media.error_hint_retry': 'Versuchen Sie es erneut.',
    'fabric.media.error_hint_critical': 'Sollte das Problem bestehen bleiben, wenden Sie sich an den Support.',
    'fabric.media.close': 'Schließen',
    'fabric.media.could_not_load_editor': 'Hoppla, der Editor konnte nicht abgerufen werden.',
    'fabric.media.could_not_save_image': 'Hoppla, das Bild konnte nicht gespeichert werden.',
    'fabric.media.annotate': 'Kommentieren',
    'fabric.media.drop_your_files_here': 'Dateien hier ablegen',
    'fabric.media.share_files_instantly': 'Wir teilen sie sofort.',
    'fabric.media.insert_files': '{0, plural, one{Eine Datei einfügen} other{{0} Dateien einfügen}}',
    'fabric.media.zoom_out': 'zoom out',
    'fabric.media.zoom_in': 'zoom in',
    'fabric.media.remove_image': 'Remove image',
    'fabric.media.play': 'play',
    'fabric.media.pause': 'pause',
    'fabric.media.disable_fullscreen': 'disable fullscreen',
    'fabric.media.enable_fullscreen': 'enable fullscreen',
    'fabric.media.error_loading_file': 'Error loading file',
    'fabric.media.error_generating_preview': 'Error generating preview',
    'fabric.media.download': 'Download',
    'fabric.media.unknown': 'unknown',
    'fabric.media.document': 'document',
    'fabric.media.audio': 'audio',
    'fabric.media.video': 'video',
    'fabric.media.image': 'image',
});
//# sourceMappingURL=de.js.map

/***/ }),
/* 2133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Hungarian
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': 'Újra',
    'fabric.media.failed_to_load': 'A betöltés nem sikerült',
    'fabric.media.recent_uploads': 'Legutóbb feltöltések',
    'fabric.media.upload_file': 'Fájl feltöltése',
    'fabric.media.drag_and_drop_your_files': 'Húzza és ejtse ide egy fájlokat vagy',
    'fabric.media.drop_your_files': 'Ejtse ide a fájlokat a feltöltéshez',
    'fabric.media.upload': 'Feltöltés',
    'fabric.media.cancel': 'Mégse',
    'fabric.media.search_all_gifs': 'Keresés az összes GIF között',
    'fabric.media.cant_retrieve_gifs': 'Jaj! Nem sikerült lekérni egyetlen GIF-et sem',
    'fabric.media.check_your_network': 'Ellenőrizze a hálózati kapcsolatot',
    'fabric.media.try_again': 'Próbálja újra',
    'fabric.media.no_gifs_found': 'Hello? Engem keresett?',
    'fabric.media.no_gifs_found_suggestion': 'Nem találtunk semmit sem a következő kifejezésre: {query}',
    'fabric.media.load_more_gifs': 'További GIF-ek betöltése',
    'fabric.media.add_account': 'Fiók hozzáadása',
    'fabric.media.unlink_account': 'Fiók leválasztása',
    'fabric.media.upload_file_from': 'Fájl feltöltése innen: {name}',
    'fabric.media.connect_to': 'Csatlakozás ehhez: {name}',
    'fabric.media.connect_account_description': 'Megnyitunk egy új lapot, hogy könnyebben csatlakozhasson {name}-fiókjához',
    'fabric.media.upload_an_avatar': 'Avatár feltöltése',
    'fabric.media.save': 'Mentés',
    'fabric.media.or': 'vagy',
    'fabric.media.upload_photo': 'Fénykép feltöltése',
    'fabric.media.default_avatars': 'Alapértelmezett avatárok',
    'fabric.media.drag_and_drop_images_here': 'Húzza ide a képeket.',
    'fabric.media.upload_image': 'Kép feltöltése',
    'fabric.media.image_url_invalid_error': 'Nem sikerült feltölteni a képet, mert az URL-cím érvénytelen.',
    'fabric.media.image_format_invalid_error': 'Nem sikerült feltölteni a képet, mert a formátum érvénytelen.',
    'fabric.media.image_size_too_large_error': 'A kép túl nagy. Nem lehet {MAX_SIZE_MB}MB-nál nagyobb.',
    'fabric.media.something_went_wrong': 'Hiba történt.',
    'fabric.media.might_be_a_hiccup': 'Valószínűleg csak átmeneti hibáról van szó.',
    'fabric.media.couldnt_generate_preview': 'Ehhez a fájlhoz nem tudtunk előnézetet létrehozni.',
    'fabric.media.cant_preview_file_type': 'Ehhez a fájltípushoz nem tudunk előnézetet létrehozni.',
    'fabric.media.item_not_found_in_list': 'A kijelölt elem nem található a listán.',
    'fabric.media.no_pdf_artifacts': 'Nem található PDF-műtermék ehhez a fájlhoz.',
    'fabric.media.give_feedback': 'Visszajelzés küldése',
    'fabric.media.try_downloading_file': 'A megtekintéshez próbálja meg letölteni a fájlt.',
    'fabric.media.webgl_warning_description': 'A böngészője nem támogatja a WebGL funkciót. A képek jegyzetekkel való ellátásához használjon a WebGL funkcióval kompatibilis böngészőt.',
    'fabric.media.unable_to_annotate_image': 'Nem sikerült jegyzetet fűznie a képhez.',
    'fabric.media.learn_more': 'További információ',
    'fabric.media.accounts': 'Fiókok',
    'fabric.media.actions': 'Műveletek',
    'fabric.media.error_hint_retry': 'Próbálja meg újból, és teszünk még egy kísérletet.',
    'fabric.media.error_hint_critical': 'Ha a probléma nem szűnik meg, lépjen kapcsolatba az ügyfélszolgálattal.',
    'fabric.media.close': 'Bezárás',
    'fabric.media.could_not_load_editor': 'Nem sikerült betölteni a szerkesztőt.',
    'fabric.media.could_not_save_image': 'Nem sikerült betölteni a képet.',
    'fabric.media.annotate': 'Jegyzet készítése',
    'fabric.media.drop_your_files_here': 'Húzza ide a fájlokat.',
    'fabric.media.share_files_instantly': 'Azonnal megosztjuk őket.',
    'fabric.media.insert_files': '{0, plural, one{Fájl beszúrása} other{{0} fájl beszúrása}}',
    'fabric.media.zoom_out': 'kicsinyítés',
    'fabric.media.zoom_in': 'nagyítás',
    'fabric.media.remove_image': 'Kép eltávolítása',
    'fabric.media.play': 'lejátszás',
    'fabric.media.pause': 'szüneteltetés',
    'fabric.media.disable_fullscreen': 'teljes képernyős mód letiltása',
    'fabric.media.enable_fullscreen': 'teljes képernyős mód engedélyezése',
    'fabric.media.error_loading_file': 'Hiba történt a fájl betöltésekor.',
    'fabric.media.error_generating_preview': 'Hiba történt az előnézet létrehozásakor.',
    'fabric.media.download': 'Letöltés',
    'fabric.media.unknown': 'ismeretlen',
    'fabric.media.document': 'dokumentum',
    'fabric.media.audio': 'hang',
    'fabric.media.video': 'videó',
    'fabric.media.image': 'kép',
});
//# sourceMappingURL=hu.js.map

/***/ }),
/* 2134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Icelandic
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': 'Reyna aftur  ',
    'fabric.media.failed_to_load': 'Ekki tókst að hlaða',
    'fabric.media.recent_uploads': 'Nýlegar uppfærslur',
    'fabric.media.upload_file': 'Hlaða inn frá skrá',
    'fabric.media.drag_and_drop_your_files': 'Dragðu og slepptu skránum þínum hvar sem er eða',
    'fabric.media.drop_your_files': 'Slepptu skránum þínum til að uppfæra þær',
    'fabric.media.upload': 'Hlaða upp',
    'fabric.media.cancel': 'Hætta við',
    'fabric.media.search_all_gifs': 'Leita í öllum GIF!',
    'fabric.media.cant_retrieve_gifs': 'Æi! Við gátum ekki sótt nein GIF',
    'fabric.media.check_your_network': 'Athugaðu nettenginguna þína',
    'fabric.media.try_again': 'Reyna aftur',
    'fabric.media.no_gifs_found': "Hello? Was it me you're looking for?",
    'fabric.media.no_gifs_found_suggestion': 'Okkur tókst ekki að finna neitt fyrir "{query}"',
    'fabric.media.load_more_gifs': 'Hlaða meiru GIF',
    'fabric.media.add_account': 'Bæta við account',
    'fabric.media.unlink_account': 'Aftengjast account',
    'fabric.media.upload_file_from': 'Hladdu upp skrá frá {name}',
    'fabric.media.connect_to': 'Tengjast {name}',
    'fabric.media.connect_account_description': 'Við munum opna nýja síðu til að hjálpa þér að tengja {name} reikninginn þinn',
    'fabric.media.upload_an_avatar': 'Hala upp avatar',
    'fabric.media.save': 'Vista',
    'fabric.media.or': 'eða',
    'fabric.media.upload_photo': 'Hlaða inn mynd',
    'fabric.media.default_avatars': 'Sálfgefnir genglar',
    'fabric.media.drag_and_drop_images_here': 'Dragðu og slepptu myndunum þínum hér',
    'fabric.media.upload_image': 'Hlaða upp mynd',
    'fabric.media.image_url_invalid_error': 'Ekki tókst að hlaða mynd því vefslóðin er ógild.',
    'fabric.media.image_format_invalid_error': 'Ekki tókst að hlaða mynd því sniðið er ógilt.',
    'fabric.media.image_size_too_large_error': 'Mynd er of stór, hún má ekki vera stærri en {MAX_SIZE_MB}Mb',
    'fabric.media.something_went_wrong': 'Eitthvað fór úrskeiðis.',
    'fabric.media.might_be_a_hiccup': 'Þetta gætu bara verið smá hnökrar.',
    'fabric.media.couldnt_generate_preview': 'Ekki tókst að búa til forskoðun fyrir þessa skrá.',
    'fabric.media.cant_preview_file_type': 'Þú getur ekki forskoðað þessa skráargerð.',
    'fabric.media.item_not_found_in_list': 'Valið atriði fannst ekki á listanum.',
    'fabric.media.no_pdf_artifacts': 'Engir PDF-gervingar fundust fyrir þessa skrá.',
    'fabric.media.give_feedback': 'Gefa álit',
    'fabric.media.try_downloading_file': 'Prófaðu að hlaða skránni niður til að skoða hana.',
    'fabric.media.webgl_warning_description': 'Vafrinn þinn styður ekki WebGL. Notaðu WebGL virkan vafra til að geta skrifað skýringar við myndir.',
    'fabric.media.unable_to_annotate_image': 'Þú getur ekki skrifað skýringar við þessa mynd',
    'fabric.media.learn_more': 'Fáðu að vita meira ',
    'fabric.media.accounts': 'Account',
    'fabric.media.actions': 'Aðgerðir',
    'fabric.media.error_hint_retry': 'Reyndu aftur og við látum aftur á það reyna.',
    'fabric.media.error_hint_critical': 'Ef vandamálið er viðvarandi skaltu hafa samband við kerfisstuðning.',
    'fabric.media.close': 'Loka',
    'fabric.media.could_not_load_editor': 'Æi! Ekki tókst að hlaða ritlinum',
    'fabric.media.could_not_save_image': 'Æi! Ekki tókst að vista myndina',
    'fabric.media.annotate': 'Textaskýring',
    'fabric.media.drop_your_files_here': 'Slepptu skránum þínum hér',
    'fabric.media.share_files_instantly': 'Við munum deila þeim eins og skot',
    'fabric.media.insert_files': '{0, plural, one{Setja inn skrá} other{Setja inn {0} skrár}}',
    'fabric.media.zoom_out': 'zoom out',
    'fabric.media.zoom_in': 'zoom in',
    'fabric.media.remove_image': 'Remove image',
    'fabric.media.play': 'play',
    'fabric.media.pause': 'pause',
    'fabric.media.disable_fullscreen': 'disable fullscreen',
    'fabric.media.enable_fullscreen': 'enable fullscreen',
    'fabric.media.error_loading_file': 'Error loading file',
    'fabric.media.error_generating_preview': 'Error generating preview',
    'fabric.media.download': 'Download',
    'fabric.media.unknown': 'unknown',
    'fabric.media.document': 'document',
    'fabric.media.audio': 'audio',
    'fabric.media.video': 'video',
    'fabric.media.image': 'image',
});
//# sourceMappingURL=is.js.map

/***/ }),
/* 2135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Italian
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': 'Riprova',
    'fabric.media.failed_to_load': 'Caricamento non riuscito',
    'fabric.media.recent_uploads': 'Caricamenti recenti',
    'fabric.media.upload_file': 'Carica un file',
    'fabric.media.drag_and_drop_your_files': 'Trascina i file dove vuoi oppure',
    'fabric.media.drop_your_files': 'Trascina i file per caricarli',
    'fabric.media.upload': 'Carica',
    'fabric.media.cancel': 'Annulla',
    'fabric.media.search_all_gifs': 'Ricerca tutte le GIF!',
    'fabric.media.cant_retrieve_gifs': 'Ahi, non abbiamo trovato nessuna GIF',
    'fabric.media.check_your_network': 'Controlla la connessione di rete',
    'fabric.media.try_again': 'Riprova',
    'fabric.media.no_gifs_found': 'Pronto? Sta davvero cercando me?',
    'fabric.media.no_gifs_found_suggestion': 'Non siamo riusciti a trovare nessun risultato per “{query}”',
    'fabric.media.load_more_gifs': 'Carica altre GIF',
    'fabric.media.add_account': 'Aggiungi account',
    'fabric.media.unlink_account': 'Scollega account',
    'fabric.media.upload_file_from': 'Carica un file da {name}',
    'fabric.media.connect_to': 'Collegati a {name}',
    'fabric.media.connect_account_description': 'Apriremo una nuova pagina per aiutarti a collegare il tuo account {name}',
    'fabric.media.upload_an_avatar': 'Carica un avatar',
    'fabric.media.save': 'Salva',
    'fabric.media.or': 'o',
    'fabric.media.upload_photo': 'Carica una foto',
    'fabric.media.default_avatars': 'Avatar predefiniti',
    'fabric.media.drag_and_drop_images_here': 'Trascina le tue immagini qui',
    'fabric.media.upload_image': 'Carica immagine',
    'fabric.media.image_url_invalid_error': "Non è stato possibile caricare l'immagine, l'url non è valido.",
    'fabric.media.image_format_invalid_error': "Non è stato possibile caricare l'immagine, il formato non è valido.",
    'fabric.media.image_size_too_large_error': "L'immagine è troppo grande, non può essere maggiore di {MAX_SIZE_MB} Mb",
    'fabric.media.something_went_wrong': 'Si è verificato un errore.',
    'fabric.media.might_be_a_hiccup': 'Potrebbe essere un semplice contrattempo.',
    'fabric.media.couldnt_generate_preview': 'Non siamo riusciti a generare un’anteprima per questo file.',
    'fabric.media.cant_preview_file_type': 'Impossibile effettuare l’anteprima di questo tipo di file.',
    'fabric.media.item_not_found_in_list': 'L’elemento selezionato non è stato trovato nell’elenco.',
    'fabric.media.no_pdf_artifacts': 'Nessun PDF trovato per questo file.',
    'fabric.media.give_feedback': 'Lascia un feedback',
    'fabric.media.try_downloading_file': 'Prova a scaricare il file per visualizzarlo.',
    'fabric.media.webgl_warning_description': 'Il tuo browser non supporta WebGL. Per annotare le immagini usa un browser compatibile con WebGL.',
    'fabric.media.unable_to_annotate_image': 'Impossibile annotare questa immagine.',
    'fabric.media.learn_more': 'Scopri di più',
    'fabric.media.accounts': 'Account',
    'fabric.media.actions': 'Azioni',
    'fabric.media.error_hint_retry': 'Riprova e faremo un altro tentativo.',
    'fabric.media.error_hint_critical': 'Se il problema persiste contatta l’assistenza',
    'fabric.media.close': 'Chiudi',
    'fabric.media.could_not_load_editor': 'Ahi, non siamo riusciti a caricare l’editor',
    'fabric.media.could_not_save_image': 'Ahi, non siamo riusciti a salvare l’immagine',
    'fabric.media.annotate': 'Annota',
    'fabric.media.drop_your_files_here': 'Rilascia qui i file',
    'fabric.media.share_files_instantly': 'Li condivideremo subito',
    'fabric.media.insert_files': '{0, plural, one{Inserisci un file} other{Inserisci {0} file}}',
    'fabric.media.zoom_out': 'zoom out',
    'fabric.media.zoom_in': 'zoom in',
    'fabric.media.remove_image': 'Remove image',
    'fabric.media.play': 'play',
    'fabric.media.pause': 'pause',
    'fabric.media.disable_fullscreen': 'disable fullscreen',
    'fabric.media.enable_fullscreen': 'enable fullscreen',
    'fabric.media.error_loading_file': 'Error loading file',
    'fabric.media.error_generating_preview': 'Error generating preview',
    'fabric.media.download': 'Download',
    'fabric.media.unknown': 'unknown',
    'fabric.media.document': 'document',
    'fabric.media.audio': 'audio',
    'fabric.media.video': 'video',
    'fabric.media.image': 'image',
});
//# sourceMappingURL=it.js.map

/***/ }),
/* 2136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Japanese
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': '再試行',
    'fabric.media.failed_to_load': '読み込めませんでした',
    'fabric.media.recent_uploads': '最近アップロードしたファイル',
    'fabric.media.upload_file': 'ファイルをアップロード',
    'fabric.media.drag_and_drop_your_files': 'ファイルをここにドラッグ&ドロップ、または',
    'fabric.media.drop_your_files': 'アップロードするファイルをドロップ',
    'fabric.media.upload': 'アップロード',
    'fabric.media.cancel': 'キャンセル',
    'fabric.media.search_all_gifs': 'すべてのGIF画像を検索！',
    'fabric.media.cant_retrieve_gifs': 'GIF 画像を取得できませんでした',
    'fabric.media.check_your_network': 'ネットワーク接続を確認してください',
    'fabric.media.try_again': '再試行',
    'fabric.media.no_gifs_found': 'もしもし？お探しの画像はこちらではありませんよね？',
    'fabric.media.no_gifs_found_suggestion': '「{query}」に一致する結果が見つかりませんでした',
    'fabric.media.load_more_gifs': 'さらに GIF を読み込む',
    'fabric.media.add_account': 'アカウントを追加',
    'fabric.media.unlink_account': 'アカウントのリンクを解除',
    'fabric.media.upload_file_from': '{name} からファイルをアップロード',
    'fabric.media.connect_to': '{name} に接続',
    'fabric.media.connect_account_description': '{name} アカウントを接続するため、新ページを開きます',
    'fabric.media.upload_an_avatar': 'アバターをアップロード',
    'fabric.media.save': '保存',
    'fabric.media.or': 'または',
    'fabric.media.upload_photo': '写真をアップロード',
    'fabric.media.default_avatars': 'デフォルトのアバター',
    'fabric.media.drag_and_drop_images_here': 'ここに画像をドラッグ&ドロップ',
    'fabric.media.upload_image': '画像をアップロード',
    'fabric.media.image_url_invalid_error': '画像を読み込めませんでした。URLが無効です。',
    'fabric.media.image_format_invalid_error': '画像を読み込めませんでした。フォーマットが無効です。',
    'fabric.media.image_size_too_large_error': '画像が大きすぎます。画像サイズは {MAX_SIZE_MB}Mb以下である必要があります。',
    'fabric.media.something_went_wrong': '問題が発生しました。',
    'fabric.media.might_be_a_hiccup': '一時的な障害の可能性があります。',
    'fabric.media.couldnt_generate_preview': 'このファイル形式はプレビュー表示できません。',
    'fabric.media.cant_preview_file_type': 'このファイル形式はプレビュー表示できません。',
    'fabric.media.item_not_found_in_list': '選択されたアイテムがリストに見つかりませんでした。',
    'fabric.media.no_pdf_artifacts': 'このファイルのPDFアーティファクトが見つかりません。',
    'fabric.media.give_feedback': 'フィードバックを送信',
    'fabric.media.try_downloading_file': 'ファイルを表示するにはダウンロードしてください。',
    'fabric.media.webgl_warning_description': 'お使いのブラウザはWebGLに対応していません。画像にコメントをつけるにはWebGL対応ブラウザをご利用ください。',
    'fabric.media.unable_to_annotate_image': 'この画像にコメントをつけられませんでした',
    'fabric.media.learn_more': 'さらに詳しく',
    'fabric.media.accounts': 'アカウント',
    'fabric.media.actions': 'アクション',
    'fabric.media.error_hint_retry': '改めてお試しください。',
    'fabric.media.error_hint_critical': '問題が継続して起きる場合はサポートにご連絡ください。',
    'fabric.media.close': '閉じる',
    'fabric.media.could_not_load_editor': 'エディターを読み込めませんでした',
    'fabric.media.could_not_save_image': '画像を保存できませんでした',
    'fabric.media.annotate': 'コメント',
    'fabric.media.drop_your_files_here': 'ファイルをここにドロップ',
    'fabric.media.share_files_instantly': 'すぐに公開されます',
    'fabric.media.insert_files': '{0, plural, other{{0} 個のファイルを挿入}}',
    'fabric.media.zoom_out': 'zoom out',
    'fabric.media.zoom_in': 'zoom in',
    'fabric.media.remove_image': 'Remove image',
    'fabric.media.play': 'play',
    'fabric.media.pause': 'pause',
    'fabric.media.disable_fullscreen': 'disable fullscreen',
    'fabric.media.enable_fullscreen': 'enable fullscreen',
    'fabric.media.error_loading_file': 'Error loading file',
    'fabric.media.error_generating_preview': 'Error generating preview',
    'fabric.media.download': 'Download',
    'fabric.media.unknown': 'unknown',
    'fabric.media.document': 'document',
    'fabric.media.audio': 'audio',
    'fabric.media.video': 'video',
    'fabric.media.image': 'image',
});
//# sourceMappingURL=ja.js.map

/***/ }),
/* 2137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Korean
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': '재시도',
    'fabric.media.failed_to_load': '로드할 수 없음',
    'fabric.media.recent_uploads': '최근 업로드',
    'fabric.media.upload_file': '파일 업로드',
    'fabric.media.drag_and_drop_your_files': '파일을 끌어다 놓거나',
    'fabric.media.drop_your_files': '업로드할 파일 끌어다 놓기',
    'fabric.media.upload': '업로드',
    'fabric.media.cancel': '취소',
    'fabric.media.search_all_gifs': '모든 GIF를 검색합니다!',
    'fabric.media.cant_retrieve_gifs': '이런! GIF를 가져올 수 없습니다.',
    'fabric.media.check_your_network': '네트워크 연결을 확인하십시오.',
    'fabric.media.try_again': '재시도',
    'fabric.media.no_gifs_found': '안녕하세요. 저를 찾고 계셨나요?',
    'fabric.media.no_gifs_found_suggestion': '"{query}"에 대한 검색 결과가 없습니다.',
    'fabric.media.load_more_gifs': 'GIF 추가 로드',
    'fabric.media.add_account': '계정 추가',
    'fabric.media.unlink_account': '계정 연결 해제',
    'fabric.media.upload_file_from': '{name}에서 파일 업로드',
    'fabric.media.connect_to': '{name}에 연결',
    'fabric.media.connect_account_description': '{name} 계정을 연결할 수 있도록 새로운 페이지를 열겠습니다.',
    'fabric.media.upload_an_avatar': '아바타 업로드',
    'fabric.media.save': '저장',
    'fabric.media.or': '또는',
    'fabric.media.upload_photo': '사진 업로드',
    'fabric.media.default_avatars': '기본 아바타',
    'fabric.media.drag_and_drop_images_here': '이미지를 여기에 끌어다 놓습니다.',
    'fabric.media.upload_image': '이미지 업로드',
    'fabric.media.image_url_invalid_error': '이미지를 로드할 수 없습니다. URL이 유효하지 않습니다.',
    'fabric.media.image_format_invalid_error': '이미지를 로드할 수 없습니다. 형식이 유효하지 않습니다.',
    'fabric.media.image_size_too_large_error': '이미지가 너무 큽니다. {MAX_SIZE_MB}MB 이하여야 합니다.',
    'fabric.media.something_went_wrong': '문제가 발생했습니다.',
    'fabric.media.might_be_a_hiccup': '일시적인 문제일 수 있습니다.',
    'fabric.media.couldnt_generate_preview': '이 파일의 미리보기를 생성할 수 없습니다.',
    'fabric.media.cant_preview_file_type': '이 파일 유형은 미리 볼 수 없습니다.',
    'fabric.media.item_not_found_in_list': '선택된 항목을 목록에서 찾지 못했습니다.',
    'fabric.media.no_pdf_artifacts': '이 파일에서 PDF 파일을 찾지 못했습니다.',
    'fabric.media.give_feedback': '피드백 전송',
    'fabric.media.try_downloading_file': '파일을 보려면 다운로드하십시오.',
    'fabric.media.webgl_warning_description': '사용하시는 브라우저가 WebGL을 지원하지 않습니다. 이미지를 주석으로 달려면 WebGL을 사용할 수 있는 브라우저를 사용하십시오.',
    'fabric.media.unable_to_annotate_image': '이 이미지를 주석으로 달 수 없습니다.',
    'fabric.media.learn_more': '더 알아보기',
    'fabric.media.accounts': '계정 ',
    'fabric.media.actions': '작업',
    'fabric.media.error_hint_retry': '작업을 다시 시도하시기 바랍니다.',
    'fabric.media.error_hint_critical': '문제가 계속 발생하면 지원에 문의하십시오.',
    'fabric.media.close': '닫기',
    'fabric.media.could_not_load_editor': '이런! 편집기를 로드하지 못했습니다.',
    'fabric.media.could_not_save_image': '이런! 이미지를 저장하지 못했습니다.',
    'fabric.media.annotate': '주석 달기',
    'fabric.media.drop_your_files_here': '파일을 여기에 끌어놓으십시오.',
    'fabric.media.share_files_instantly': '즉시 공유됩니다.',
    'fabric.media.insert_files': '{0, plural, other{{0}개의 파일 삽입}}',
    'fabric.media.zoom_out': 'zoom out',
    'fabric.media.zoom_in': 'zoom in',
    'fabric.media.remove_image': 'Remove image',
    'fabric.media.play': 'play',
    'fabric.media.pause': 'pause',
    'fabric.media.disable_fullscreen': 'disable fullscreen',
    'fabric.media.enable_fullscreen': 'enable fullscreen',
    'fabric.media.error_loading_file': 'Error loading file',
    'fabric.media.error_generating_preview': 'Error generating preview',
    'fabric.media.download': 'Download',
    'fabric.media.unknown': 'unknown',
    'fabric.media.document': 'document',
    'fabric.media.audio': 'audio',
    'fabric.media.video': 'video',
    'fabric.media.image': 'image',
});
//# sourceMappingURL=ko.js.map

/***/ }),
/* 2138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Norwegian Bokmål
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': 'Prøv igjen',
    'fabric.media.failed_to_load': 'Kunne ikke lastes inn',
    'fabric.media.recent_uploads': 'Nylige opplastinger',
    'fabric.media.upload_file': 'Last opp en fil',
    'fabric.media.drag_and_drop_your_files': 'Dra og slipp filene dine hvor som helst eller',
    'fabric.media.drop_your_files': 'Slipp filer for å laste dem opp',
    'fabric.media.upload': 'Last opp',
    'fabric.media.cancel': 'Avbryt',
    'fabric.media.search_all_gifs': 'Søk i alle GIF-ene',
    'fabric.media.cant_retrieve_gifs': 'Beklager. Vi kunne ikke hente noen GIF-bilder',
    'fabric.media.check_your_network': 'Kontroller nettverksforbindelsen',
    'fabric.media.try_again': 'Prøv på nytt',
    'fabric.media.no_gifs_found': 'Hei! Var det meg du lette etter?',
    'fabric.media.no_gifs_found_suggestion': 'Vi kunne ikke finne noe for «{query}»',
    'fabric.media.load_more_gifs': 'Last opp flere GIF-bilder',
    'fabric.media.add_account': 'Legg til en konto',
    'fabric.media.unlink_account': 'Fjern kobling fra konto',
    'fabric.media.upload_file_from': 'Last opp en fil fra {name}',
    'fabric.media.connect_to': 'Koble til {name}',
    'fabric.media.connect_account_description': 'Vi vil åpne en ny side for å hjelpe deg med å koble til {name}-kontoen din',
    'fabric.media.upload_an_avatar': 'Last opp en avatar',
    'fabric.media.save': 'Lagre',
    'fabric.media.or': 'eller',
    'fabric.media.upload_photo': 'Last opp et bilde',
    'fabric.media.default_avatars': 'Standardavatarer',
    'fabric.media.drag_and_drop_images_here': 'Dra og slipp bildene her',
    'fabric.media.upload_image': 'Last opp et bilde',
    'fabric.media.image_url_invalid_error': 'Nettadressen er feil. Bildet kan derfor ikke lastes inn.',
    'fabric.media.image_format_invalid_error': 'Bildet har feil format. Det kan derfor ikke lastes inn.',
    'fabric.media.image_size_too_large_error': 'Bildet er for stort. Det kan ikke være større enn {MAX_SIZE_MB}MB',
    'fabric.media.something_went_wrong': 'Det oppsto en feil.',
    'fabric.media.might_be_a_hiccup': 'Det kan være et midlertidig problem.',
    'fabric.media.couldnt_generate_preview': 'Vi kan ikke forhåndsvise denne filen.',
    'fabric.media.cant_preview_file_type': 'Vi kan ikke forhåndsvise denne filtypen.',
    'fabric.media.item_not_found_in_list': 'Det valgte elementet ble ikke funnet på listen.',
    'fabric.media.no_pdf_artifacts': 'Kunne ikke finne noen PDF-artefakter for denne filen.',
    'fabric.media.give_feedback': 'Gi en tilbakemelding',
    'fabric.media.try_downloading_file': 'Prøv å laste ned filen for å vise den.',
    'fabric.media.webgl_warning_description': 'Nettleserdin støtter ikke WebGL. Bruk en WebGL-aktivert nettleser til å kommentere bilder.',
    'fabric.media.unable_to_annotate_image': 'Du kan ikke kommentere dette bildet',
    'fabric.media.learn_more': 'Les mer',
    'fabric.media.accounts': 'Kontoer',
    'fabric.media.actions': 'Tiltak',
    'fabric.media.error_hint_retry': 'Vent litt, så prøver vi igjen.',
    'fabric.media.error_hint_critical': 'Kontakt brukerstøtte hvis problemet ikke forsvinner.',
    'fabric.media.close': 'Lukk',
    'fabric.media.could_not_load_editor': 'Beklager. Vi kunne ikke laste opp redigeringsprogrammet',
    'fabric.media.could_not_save_image': 'Beklager. Vi kunne ikke lagre bildet',
    'fabric.media.annotate': 'Kommenter',
    'fabric.media.drop_your_files_here': 'Slipp bildene her',
    'fabric.media.share_files_instantly': 'Vi deler dem med det samme',
    'fabric.media.insert_files': '{0, plural, one{Sett inn en fil} other{Sett inn {0} filer}}',
    'fabric.media.zoom_out': 'zoom out',
    'fabric.media.zoom_in': 'zoom in',
    'fabric.media.remove_image': 'Remove image',
    'fabric.media.play': 'play',
    'fabric.media.pause': 'pause',
    'fabric.media.disable_fullscreen': 'disable fullscreen',
    'fabric.media.enable_fullscreen': 'enable fullscreen',
    'fabric.media.error_loading_file': 'Error loading file',
    'fabric.media.error_generating_preview': 'Error generating preview',
    'fabric.media.download': 'Download',
    'fabric.media.unknown': 'unknown',
    'fabric.media.document': 'document',
    'fabric.media.audio': 'audio',
    'fabric.media.video': 'video',
    'fabric.media.image': 'image',
});
//# sourceMappingURL=nb.js.map

/***/ }),
/* 2139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Polish
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': 'Ponów',
    'fabric.media.failed_to_load': 'Niepowodzenie wczytywania',
    'fabric.media.recent_uploads': 'Ostatnio dodane',
    'fabric.media.upload_file': 'Prześlij plik',
    'fabric.media.drag_and_drop_your_files': 'Przeciągnij i upuść pliki w dowolne miejsce lub',
    'fabric.media.drop_your_files': 'Upuść pliki, aby je przesłać',
    'fabric.media.upload': 'Prześlij',
    'fabric.media.cancel': 'Anuluj',
    'fabric.media.search_all_gifs': 'Szukaj wszystkich plików GIF!',
    'fabric.media.cant_retrieve_gifs': 'Ojej! Nie można pobrać żadnych plików GIF',
    'fabric.media.check_your_network': 'Sprawdź swoje połączenie sieciowe.',
    'fabric.media.try_again': 'Spróbuj ponownie',
    'fabric.media.no_gifs_found': 'Halo! Czy to mnie szukałeś?',
    'fabric.media.no_gifs_found_suggestion': 'Nie udało się znaleźć wyników pasujących do zapytania „{query}”',
    'fabric.media.load_more_gifs': 'Wczytaj więcej plików GIF',
    'fabric.media.add_account': 'Dodaj konto',
    'fabric.media.unlink_account': 'Odłącz konto',
    'fabric.media.upload_file_from': 'Prześlij plik z {name}',
    'fabric.media.connect_to': 'Połącz z {name}',
    'fabric.media.connect_account_description': 'Otworzymy nową stronę, aby pomóc Ci połączyć swoje konto {name}',
    'fabric.media.upload_an_avatar': 'Wyślij avatar',
    'fabric.media.save': 'Zapisz',
    'fabric.media.or': 'lub',
    'fabric.media.upload_photo': 'Prześlij zdjęcie',
    'fabric.media.default_avatars': 'Domyślne avatary',
    'fabric.media.drag_and_drop_images_here': 'Przeciągnij i upuść obrazy tutaj',
    'fabric.media.upload_image': 'Prześlij obraz',
    'fabric.media.image_url_invalid_error': 'Nie udało się załadować obrazu. Adres URL jest niepoprawny.',
    'fabric.media.image_format_invalid_error': 'Nie udało się załadować obrazu. Format jest niepoprawny.',
    'fabric.media.image_size_too_large_error': 'Obraz jest za duży, nie może przekroczyć {MAX_SIZE_MB} MB',
    'fabric.media.something_went_wrong': 'Coś poszło nie tak.',
    'fabric.media.might_be_a_hiccup': 'To musi być przejściowy problem.',
    'fabric.media.couldnt_generate_preview': 'Nie udało się wygenerować podglądu tego pliku.',
    'fabric.media.cant_preview_file_type': 'Podgląd plików tego typu nie jest możliwy.',
    'fabric.media.item_not_found_in_list': 'Zaznaczony element nie został odnaleziony na liście.',
    'fabric.media.no_pdf_artifacts': 'Nie znaleziono artefaktów PDF w tym pliku.',
    'fabric.media.give_feedback': 'Prześlij opinię',
    'fabric.media.try_downloading_file': 'Spróbuj pobrać plik, aby go wyświetlić.',
    'fabric.media.webgl_warning_description': 'Twoja przeglądarka nie obsługuje WebGL. Użyj przeglądarki z włączoną obsługą WebGL, aby dodawać adnotacje do obrazów',
    'fabric.media.unable_to_annotate_image': 'Nie udało się dodać adnotacji do tego obrazu',
    'fabric.media.learn_more': 'Dowiedz się więcej',
    'fabric.media.accounts': 'Konta',
    'fabric.media.actions': 'Czynności',
    'fabric.media.error_hint_retry': 'Spróbuj ponownie.',
    'fabric.media.error_hint_critical': 'Jeśli problem nadal będzie występować, skontaktuj się ze wsparciem.',
    'fabric.media.close': 'Zamknij',
    'fabric.media.could_not_load_editor': 'Oj! Nie udało się załadować edytora',
    'fabric.media.could_not_save_image': 'Oj! Nie udało się zapisać obrazu',
    'fabric.media.annotate': 'Dodaj adnotację',
    'fabric.media.drop_your_files_here': 'Upuść pliki tutaj',
    'fabric.media.share_files_instantly': 'Błyskawicznie je udostępnimy',
    'fabric.media.insert_files': '{0, plural, one{Wstaw plik} few{Wstaw {0} pliki} many{Wstaw {0} plików} other{Wstaw {0}pliku}}',
    'fabric.media.zoom_out': 'oddal',
    'fabric.media.zoom_in': 'przybliż',
    'fabric.media.remove_image': 'usuń obraz',
    'fabric.media.play': 'odtwórz',
    'fabric.media.pause': 'wstrzymaj',
    'fabric.media.disable_fullscreen': 'wyłącz tryb pełnoekranowy',
    'fabric.media.enable_fullscreen': 'włącz tryb pełnoekranowy',
    'fabric.media.error_loading_file': 'Błąd wczytywania pliku',
    'fabric.media.error_generating_preview': 'Błąd generowania podglądu',
    'fabric.media.download': 'Pobierz',
    'fabric.media.unknown': 'nieznane',
    'fabric.media.document': 'dokument',
    'fabric.media.audio': 'dźwięk',
    'fabric.media.video': 'wideo',
    'fabric.media.image': 'obraz',
});
//# sourceMappingURL=pl.js.map

/***/ }),
/* 2140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Portuguese (Brazil)
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': 'Tentar novamente',
    'fabric.media.failed_to_load': 'Falha ao carregar',
    'fabric.media.recent_uploads': 'Arquivos carregados recentemente',
    'fabric.media.upload_file': 'Carregar um arquivo',
    'fabric.media.drag_and_drop_your_files': 'Arraste e solte seus arquivos em qualquer lugar ou',
    'fabric.media.drop_your_files': 'Solte seus arquivos para carregá-los',
    'fabric.media.upload': 'Carregar',
    'fabric.media.cancel': 'Cancelar',
    'fabric.media.search_all_gifs': 'Pesquise todos os GIFs!',
    'fabric.media.cant_retrieve_gifs': 'Ops! Não foi possível encontrar nenhum GIF',
    'fabric.media.check_your_network': 'Verifique sua conexão de rede',
    'fabric.media.try_again': 'Tentar novamente',
    'fabric.media.no_gifs_found': 'Alô? Era isso que você estava procurando?',
    'fabric.media.no_gifs_found_suggestion': 'Não encontramos nenhum resultado para "{query}"',
    'fabric.media.load_more_gifs': 'Carregar mais GIFs',
    'fabric.media.add_account': 'Adicionar conta',
    'fabric.media.unlink_account': 'Desvincular conta',
    'fabric.media.upload_file_from': 'Carregar um arquivo do {name}',
    'fabric.media.connect_to': 'Conectar-se ao {name}',
    'fabric.media.connect_account_description': 'Abriremos uma nova página para ajudar você a conectar sua conta do {name}',
    'fabric.media.upload_an_avatar': 'Carregar um avatar',
    'fabric.media.save': 'Salvar',
    'fabric.media.or': 'ou',
    'fabric.media.upload_photo': 'Carregar uma foto',
    'fabric.media.default_avatars': 'Avatares padrão',
    'fabric.media.drag_and_drop_images_here': 'Arraste e solte suas imagens aqui',
    'fabric.media.upload_image': 'Carregar imagem',
    'fabric.media.image_url_invalid_error': 'Não foi possível carregar a imagem. O URL é inválido.',
    'fabric.media.image_format_invalid_error': 'Não foi possível carregar a imagem. O formato é inválido.',
    'fabric.media.image_size_too_large_error': 'A imagem é muito grande. Ela não pode ter mais de {MAX_SIZE_MB} MB',
    'fabric.media.something_went_wrong': 'Algo deu errado.',
    'fabric.media.might_be_a_hiccup': 'Deve ser algo temporário.',
    'fabric.media.couldnt_generate_preview': 'Não foi possível gerar uma visualização para este arquivo.',
    'fabric.media.cant_preview_file_type': 'Não é possível visualizar este tipo de arquivo.',
    'fabric.media.item_not_found_in_list': 'O item selecionado não foi encontrado na lista.',
    'fabric.media.no_pdf_artifacts': 'Nenhum artefato de PDF foi encontrado para este arquivo.',
    'fabric.media.give_feedback': 'Enviar feedback',
    'fabric.media.try_downloading_file': 'Tente baixar o arquivo para visualizá-lo.',
    'fabric.media.webgl_warning_description': 'Seu navegador não é compatível com WebGL. Use um navegador compatível com WebGL para fazer anotações em imagens.',
    'fabric.media.unable_to_annotate_image': 'Você não pode fazer anotações nesta imagem',
    'fabric.media.learn_more': 'Saiba mais',
    'fabric.media.accounts': 'Contas',
    'fabric.media.actions': 'Ações',
    'fabric.media.error_hint_retry': 'Tente outra vez.',
    'fabric.media.error_hint_critical': 'Se o problema persistir, entre em contato com o suporte.',
    'fabric.media.close': 'Fechar',
    'fabric.media.could_not_load_editor': 'Ops! Não foi possível carregar o editor',
    'fabric.media.could_not_save_image': 'Ops! Não foi possível salvar a imagem',
    'fabric.media.annotate': 'Anotar',
    'fabric.media.drop_your_files_here': 'Solte seus arquivos aqui',
    'fabric.media.share_files_instantly': 'Compartilharemos os arquivos instantaneamente',
    'fabric.media.insert_files': '{0, plural, one{Inserir um arquivo} other{Inserir {0} arquivos}}',
    'fabric.media.zoom_out': 'zoom out',
    'fabric.media.zoom_in': 'zoom in',
    'fabric.media.remove_image': 'Remove image',
    'fabric.media.play': 'play',
    'fabric.media.pause': 'pause',
    'fabric.media.disable_fullscreen': 'disable fullscreen',
    'fabric.media.enable_fullscreen': 'enable fullscreen',
    'fabric.media.error_loading_file': 'Error loading file',
    'fabric.media.error_generating_preview': 'Error generating preview',
    'fabric.media.download': 'Download',
    'fabric.media.unknown': 'unknown',
    'fabric.media.document': 'document',
    'fabric.media.audio': 'audio',
    'fabric.media.video': 'video',
    'fabric.media.image': 'image',
});
//# sourceMappingURL=pt_BR.js.map

/***/ }),
/* 2141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Portuguese (Portugal)
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': 'Tentar novamente',
    'fabric.media.failed_to_load': 'Falha ao carregar',
    'fabric.media.recent_uploads': 'Carregamentos recentes',
    'fabric.media.upload_file': 'Carregar um ficheiro',
    'fabric.media.drag_and_drop_your_files': 'Arraste e largue os ficheiros em qualquer local ou',
    'fabric.media.drop_your_files': 'Largue os ficheiros para carregar',
    'fabric.media.upload': 'Carregar',
    'fabric.media.cancel': 'Cancelar',
    'fabric.media.search_all_gifs': 'Procurar todos os GIF!',
    'fabric.media.cant_retrieve_gifs': 'Ups! Não é possível obter nenhum GIF',
    'fabric.media.check_your_network': 'Verifique a sua ligação à rede',
    'fabric.media.try_again': 'Tente novamente',
    'fabric.media.no_gifs_found': "Hello? Was it me you're looking for?",
    'fabric.media.no_gifs_found_suggestion': 'Não conseguimos encontrar nada para "{query}"',
    'fabric.media.load_more_gifs': 'Carregar mais GIF',
    'fabric.media.add_account': 'Adicionar conta',
    'fabric.media.unlink_account': 'Desassociar conta',
    'fabric.media.upload_file_from': 'Carregar um ficheiro de {name}',
    'fabric.media.connect_to': 'Ligar a {name}',
    'fabric.media.connect_account_description': 'Será aberta uma nova página para o ajudar a ligar a sua conta {name}',
    'fabric.media.upload_an_avatar': 'Carregar um avatar',
    'fabric.media.save': 'Guardar',
    'fabric.media.or': 'ou',
    'fabric.media.upload_photo': 'Carregar uma fotografia',
    'fabric.media.default_avatars': 'Avatares predefinidos',
    'fabric.media.drag_and_drop_images_here': 'Arraste e largue as suas imagens para aqui',
    'fabric.media.upload_image': 'Carregar imagem',
    'fabric.media.image_url_invalid_error': 'Não foi possível carregar a imagem, o url não é válido.',
    'fabric.media.image_format_invalid_error': 'Não foi possível carregar a imagem, o formato não é válido.',
    'fabric.media.image_size_too_large_error': 'A imagem é demasiado grande, o tamanho da imagem tem de ser inferior a {MAX_SIZE_MB}Mb',
    'fabric.media.something_went_wrong': 'Ocorreu um erro.',
    'fabric.media.might_be_a_hiccup': 'Deve ser só um contratempo.',
    'fabric.media.couldnt_generate_preview': 'Não foi possível gerar uma pré-visualização para este ficheiro.',
    'fabric.media.cant_preview_file_type': 'Não é possível pré-visualizar este tipo de ficheiro.',
    'fabric.media.item_not_found_in_list': 'O item selecionado não foi encontrado na lista.',
    'fabric.media.no_pdf_artifacts': 'Não foram encontrados artefactos em PDF para este ficheiro.',
    'fabric.media.give_feedback': 'Enviar comentários',
    'fabric.media.try_downloading_file': 'Tente transferir o ficheiro para o visualizar.',
    'fabric.media.webgl_warning_description': 'O seu navegador não suporta WebGL. Utilize um navegador compatível com WebGL para anotar imagens.',
    'fabric.media.unable_to_annotate_image': 'Não pode anotar esta imagem',
    'fabric.media.learn_more': 'Obter mais informações',
    'fabric.media.accounts': 'Contas',
    'fabric.media.actions': 'Ações',
    'fabric.media.error_hint_retry': 'Ocorreu uma falha, tente novamente.',
    'fabric.media.error_hint_critical': 'Se o problema persistir, contacte o suporte.',
    'fabric.media.close': 'Fechar',
    'fabric.media.could_not_load_editor': 'Ups! Não foi possível carregar o editor',
    'fabric.media.could_not_save_image': 'Ups! Não foi possível guardar a imagem',
    'fabric.media.annotate': 'Anotar',
    'fabric.media.drop_your_files_here': 'Largue os seus ficheiros aqui',
    'fabric.media.share_files_instantly': 'Os seus ficheiros serão partilhados imediatamente',
    'fabric.media.insert_files': '{0, plural, one{Inserir um ficheiro} other{Inserir {0} ficheiros}}',
    'fabric.media.zoom_out': 'zoom out',
    'fabric.media.zoom_in': 'zoom in',
    'fabric.media.remove_image': 'Remove image',
    'fabric.media.play': 'play',
    'fabric.media.pause': 'pause',
    'fabric.media.disable_fullscreen': 'disable fullscreen',
    'fabric.media.enable_fullscreen': 'enable fullscreen',
    'fabric.media.error_loading_file': 'Error loading file',
    'fabric.media.error_generating_preview': 'Error generating preview',
    'fabric.media.download': 'Download',
    'fabric.media.unknown': 'unknown',
    'fabric.media.document': 'document',
    'fabric.media.audio': 'audio',
    'fabric.media.video': 'video',
    'fabric.media.image': 'image',
});
//# sourceMappingURL=pt_PT.js.map

/***/ }),
/* 2142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Romanian
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': 'Reîncercare',
    'fabric.media.failed_to_load': 'Încărcarea a eșuat',
    'fabric.media.recent_uploads': 'Încărcări recente',
    'fabric.media.upload_file': 'Încărcare fișier',
    'fabric.media.drag_and_drop_your_files': 'Deplasați și plasați câmpurile oriunde sau',
    'fabric.media.drop_your_files': 'Fixați fișierele de încărcat',
    'fabric.media.upload': 'Încărcare',
    'fabric.media.cancel': 'Anulare',
    'fabric.media.search_all_gifs': 'Căutare în toate GIF-urile!',
    'fabric.media.cant_retrieve_gifs': 'Ups! Nu am putut obține niciun GIF!',
    'fabric.media.check_your_network': 'Verificați-vă conexiunea la rețea',
    'fabric.media.try_again': 'Încercați din nou',
    'fabric.media.no_gifs_found': 'Bună! Pe mine mă cauți?',
    'fabric.media.no_gifs_found_suggestion': 'Nu am putut găsi nimic pentru „{query}”',
    'fabric.media.load_more_gifs': 'Încarcă mai multe GIF-uri',
    'fabric.media.add_account': 'Adăugare cont',
    'fabric.media.unlink_account': 'Anulare asociere Cont',
    'fabric.media.upload_file_from': 'Încărcare fișier de pe {name}',
    'fabric.media.connect_to': 'Conectare la {name}',
    'fabric.media.connect_account_description': 'Vom deschide o pagină nouă pentru a vă ajuta să vă conectați contul {name}',
    'fabric.media.upload_an_avatar': 'Încărcați un avatar',
    'fabric.media.save': 'Salvare',
    'fabric.media.or': 'sau',
    'fabric.media.upload_photo': 'Încărcați o fotografie',
    'fabric.media.default_avatars': 'Avataruri implicite',
    'fabric.media.drag_and_drop_images_here': 'Trageți și eliberați imaginile dvs. aici',
    'fabric.media.upload_image': 'Încărcare imagine',
    'fabric.media.image_url_invalid_error': 'Nu s-a putut încărca imaginea, url-ul este nevalid.',
    'fabric.media.image_format_invalid_error': 'Nu s-a putut încărca imaginea, formatul este nevalid.',
    'fabric.media.image_size_too_large_error': 'Imaginea este prea mare, nu trebuie să fie mai mare de {MAX_SIZE_MB}Mb',
    'fabric.media.something_went_wrong': 'Ceva nu a funcționat corect.',
    'fabric.media.might_be_a_hiccup': 'Nu avem informații suplimentare.',
    'fabric.media.couldnt_generate_preview': 'Nu am putut genera o previzualizare pentru acest fișier.',
    'fabric.media.cant_preview_file_type': 'Nu se poate previzualiza acest tip de fişier.',
    'fabric.media.item_not_found_in_list': 'Elementul selectat nu a fost găsit pe listă.',
    'fabric.media.no_pdf_artifacts': 'Nu s-au găsit artefacte PDF pentru acest fișier.',
    'fabric.media.give_feedback': 'Oferiți feedback',
    'fabric.media.try_downloading_file': 'Încercaţi să descărcaţi fişierul pentru a-l vizualiza.',
    'fabric.media.webgl_warning_description': 'Browserul nu acceptă WebGL. Utilizați un browser care acceptă WebGL pentru adnotarea imaginilor.',
    'fabric.media.unable_to_annotate_image': 'Nu s-a putut adnota imaginea',
    'fabric.media.learn_more': 'Aflați mai multe',
    'fabric.media.accounts': 'Conturi',
    'fabric.media.actions': 'Acțiuni',
    'fabric.media.error_hint_retry': 'Încercați din nou.',
    'fabric.media.error_hint_critical': 'Dacă problema continuă să apară, contactați suportul tehnic.',
    'fabric.media.close': 'Închidere',
    'fabric.media.could_not_load_editor': 'Ups! Nu am putut încărca editorul',
    'fabric.media.could_not_save_image': 'Ups! Nu am putut salva imaginea',
    'fabric.media.annotate': 'Adnotare',
    'fabric.media.drop_your_files_here': 'Eliberați fișierele aici',
    'fabric.media.share_files_instantly': 'Le vom distribui instant',
    'fabric.media.insert_files': '{0, plural, one{Inserați 1 fișier} few{Inserați {0} fișiere} other{Inserați {0} fișiere}}',
    'fabric.media.zoom_out': 'zoom out',
    'fabric.media.zoom_in': 'zoom in',
    'fabric.media.remove_image': 'Remove image',
    'fabric.media.play': 'play',
    'fabric.media.pause': 'pause',
    'fabric.media.disable_fullscreen': 'disable fullscreen',
    'fabric.media.enable_fullscreen': 'enable fullscreen',
    'fabric.media.error_loading_file': 'Error loading file',
    'fabric.media.error_generating_preview': 'Error generating preview',
    'fabric.media.download': 'Download',
    'fabric.media.unknown': 'unknown',
    'fabric.media.document': 'document',
    'fabric.media.audio': 'audio',
    'fabric.media.video': 'video',
    'fabric.media.image': 'image',
});
//# sourceMappingURL=ro.js.map

/***/ }),
/* 2143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Russian
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': 'Повторить',
    'fabric.media.failed_to_load': 'Не удалось загрузить файл.',
    'fabric.media.recent_uploads': 'Недавно загруженные файлы',
    'fabric.media.upload_file': 'Загрузите файл',
    'fabric.media.drag_and_drop_your_files': 'Перетащите файлы в любое место или',
    'fabric.media.drop_your_files': 'Перетащите файлы для загрузки',
    'fabric.media.upload': 'Загрузить',
    'fabric.media.cancel': 'Отменить',
    'fabric.media.search_all_gifs': 'Поиск по всем файлам GIF',
    'fabric.media.cant_retrieve_gifs': 'Не найдено ни одного файла GIF',
    'fabric.media.check_your_network': 'Проверьте подключение к сети',
    'fabric.media.try_again': 'Повторить попытку',
    'fabric.media.no_gifs_found': 'Здравствуйте. Вы искали меня?',
    'fabric.media.no_gifs_found_suggestion': 'По запросу «{query}» ничего не найдено',
    'fabric.media.load_more_gifs': 'Другие файлы GIF',
    'fabric.media.add_account': 'Добавить аккаунт',
    'fabric.media.unlink_account': 'Отменить связь с аккаунтом',
    'fabric.media.upload_file_from': 'Загрузить файл из {name}',
    'fabric.media.connect_to': 'Подключить к {name}',
    'fabric.media.connect_account_description': 'Откроется новая страница, где вы сможете подключить свой аккаунт {name}',
    'fabric.media.upload_an_avatar': 'Загрузите аватар',
    'fabric.media.save': 'Сохраните',
    'fabric.media.or': 'или',
    'fabric.media.upload_photo': 'Загрузите фото',
    'fabric.media.default_avatars': 'Аватары по умолчанию',
    'fabric.media.drag_and_drop_images_here': 'Перетащите изображения сюда',
    'fabric.media.upload_image': 'Загрузите изображение',
    'fabric.media.image_url_invalid_error': 'Не удалось загрузить изображение (недействительный URL).',
    'fabric.media.image_format_invalid_error': 'Не удалось загрузить изображение (недействительный формат).',
    'fabric.media.image_size_too_large_error': 'Изображение превышает максимально допустимый размер ({MAX_SIZE_MB} МБ).',
    'fabric.media.something_went_wrong': 'Произошла ошибка.',
    'fabric.media.might_be_a_hiccup': 'Скорее всего, это была небольшая техническая неполадка.',
    'fabric.media.couldnt_generate_preview': 'Не удалось выполнить предварительный просмотр файла.',
    'fabric.media.cant_preview_file_type': 'Предварительный просмотр файлов такого типа невозможен.',
    'fabric.media.item_not_found_in_list': 'Выбранного объекта нет в списке.',
    'fabric.media.no_pdf_artifacts': 'Нет PDF-артефактов для этого файла.',
    'fabric.media.give_feedback': 'Оставить отзыв',
    'fabric.media.try_downloading_file': 'Чтобы просмотреть файл, скачайте его.',
    'fabric.media.webgl_warning_description': 'Эта функция недоступна. Чтобы добавлять примечания к изображениям, используйте браузер с поддержкой WebGL.',
    'fabric.media.unable_to_annotate_image': 'Невозможно добавить примечание',
    'fabric.media.learn_more': 'Подробнее…',
    'fabric.media.accounts': 'Аккаунты',
    'fabric.media.actions': 'Действия',
    'fabric.media.error_hint_retry': 'Повторите попытку.',
    'fabric.media.error_hint_critical': 'Если проблема не исчезнет, обратитесь в службу поддержки.',
    'fabric.media.close': 'Закрыть',
    'fabric.media.could_not_load_editor': 'Не удалось загрузить редактор',
    'fabric.media.could_not_save_image': 'Не удалось сохранить изображение',
    'fabric.media.annotate': 'Добавить примечание',
    'fabric.media.drop_your_files_here': 'Перетащите файлы сюда',
    'fabric.media.share_files_instantly': 'Мы загрузим их автоматически',
    'fabric.media.insert_files': '{0, plural, one{Вставить файл} few{Вставить {0} файла} many{Вставить {0} файлов} other{Вставить {0} файла}}',
    'fabric.media.zoom_out': 'уменьшить',
    'fabric.media.zoom_in': 'увеличить',
    'fabric.media.remove_image': 'Удалить изображение',
    'fabric.media.play': 'воспроизведение',
    'fabric.media.pause': 'пауза',
    'fabric.media.disable_fullscreen': 'отключить полноэкранный режим',
    'fabric.media.enable_fullscreen': 'включить полноэкранный режим',
    'fabric.media.error_loading_file': 'При загрузке файла произошла ошибка',
    'fabric.media.error_generating_preview': 'Не удалось выполнить предварительный просмотр',
    'fabric.media.download': 'Скачать',
    'fabric.media.unknown': 'неизвестно',
    'fabric.media.document': 'документ',
    'fabric.media.audio': 'аудио',
    'fabric.media.video': 'видео',
    'fabric.media.image': 'изображение',
});
//# sourceMappingURL=ru.js.map

/***/ }),
/* 2144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Slovak
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': 'Opakovať',
    'fabric.media.failed_to_load': 'Nahratie zlyhalo',
    'fabric.media.recent_uploads': 'Posledné nahrania',
    'fabric.media.upload_file': 'Nahrať súbor',
    'fabric.media.drag_and_drop_your_files': 'Kdekoľvek potiahnite a pustite súbory alebo',
    'fabric.media.drop_your_files': 'Pustite súbory na nahranie',
    'fabric.media.upload': 'Nahrať',
    'fabric.media.cancel': 'Zrušiť',
    'fabric.media.search_all_gifs': 'Prehľadať všetky obrázky GIF!',
    'fabric.media.cant_retrieve_gifs': 'Ach nie! Nepodarilo sa nám získať žiadne obrázky GIF',
    'fabric.media.check_your_network': 'Skontrolujte sieťové pripojenie',
    'fabric.media.try_again': 'Skúste to znova',
    'fabric.media.no_gifs_found': 'Dobrý deň? Poviete nám, čo hľadáte?',
    'fabric.media.no_gifs_found_suggestion': 'Nič sa nám nepodarilo nájsť pre "{query}"',
    'fabric.media.load_more_gifs': 'Načítať viac obrázkov GIF',
    'fabric.media.add_account': 'Pridať účet',
    'fabric.media.unlink_account': 'Zrušiť prepojenie účtu',
    'fabric.media.upload_file_from': 'Nahrať súbor z {name}',
    'fabric.media.connect_to': 'Pripojiť k {name}',
    'fabric.media.connect_account_description': 'Otvoríme novú stránku, aby sme vám pomohli pri pripojení k vášmu účtu {name}',
    'fabric.media.upload_an_avatar': 'Nahrať avatara',
    'fabric.media.save': 'Uložiť',
    'fabric.media.or': 'alebo',
    'fabric.media.upload_photo': 'Nahrať fotografiu',
    'fabric.media.default_avatars': 'Predvolené avatary',
    'fabric.media.drag_and_drop_images_here': 'Sem myšou presuňte obrázky',
    'fabric.media.upload_image': 'Nahrať  obrázok',
    'fabric.media.image_url_invalid_error': 'Nepodarilo sa načítať obrázok, adresa url je neplatná.',
    'fabric.media.image_format_invalid_error': 'Nepodarilo sa načítať obrázok, formát je neplatný.',
    'fabric.media.image_size_too_large_error': 'Obrázok je príliš veľký, nesmie byť väčší ako {MAX_SIZE_MB} Mb',
    'fabric.media.something_went_wrong': 'Vyskytol sa problém.',
    'fabric.media.might_be_a_hiccup': 'Môže to byť len nejaký nepodstatný problém.',
    'fabric.media.couldnt_generate_preview': 'Nepodarilo sa vytvoriť náhľad tohto súboru.',
    'fabric.media.cant_preview_file_type': 'Nemôžeme zobraziť náhľad tohto typu súboru.',
    'fabric.media.item_not_found_in_list': 'Vybraná položka sa nenašla v zozname.',
    'fabric.media.no_pdf_artifacts': 'Pre tento súbor sa nenašli žiadne časti PDF.',
    'fabric.media.give_feedback': 'Poskytnúť spätnú väzbu',
    'fabric.media.try_downloading_file': 'Skúste prevziať tento súbor na jeho zobrazenie.',
    'fabric.media.webgl_warning_description': 'Váš prehliadač nepodporuje knižnicu WebGL. Ak chcete komentovať obrázky, použite prehliadač s povolenou knižnicou WebGL.',
    'fabric.media.unable_to_annotate_image': 'Nemôžete komentovať tento obrázok',
    'fabric.media.learn_more': 'Ďalšie informácie',
    'fabric.media.accounts': 'Účty',
    'fabric.media.actions': 'Akcie',
    'fabric.media.error_hint_retry': 'Skúste to znova a my tomu dáme druhú šancu.',
    'fabric.media.error_hint_critical': 'Ak problém pretrváva, obráťte sa na podporu.',
    'fabric.media.close': 'Zatvoriť',
    'fabric.media.could_not_load_editor': 'Ľutujeme, nepodarilo sa načítať editor',
    'fabric.media.could_not_save_image': 'Ľutujeme, nepodarilo sa uložiť obrázok',
    'fabric.media.annotate': 'Komentovať',
    'fabric.media.drop_your_files_here': 'Sem presuňte súbory',
    'fabric.media.share_files_instantly': 'Okamžite ich začneme zdieľať',
    'fabric.media.insert_files': '{0, plural, one{Vložiť súbor} few{Vložiť {0} súbory} many{Vložiť {0} súborov} other{Vložiť {0} súborov}}',
    'fabric.media.zoom_out': 'zoom out',
    'fabric.media.zoom_in': 'zoom in',
    'fabric.media.remove_image': 'Remove image',
    'fabric.media.play': 'play',
    'fabric.media.pause': 'pause',
    'fabric.media.disable_fullscreen': 'disable fullscreen',
    'fabric.media.enable_fullscreen': 'enable fullscreen',
    'fabric.media.error_loading_file': 'Error loading file',
    'fabric.media.error_generating_preview': 'Error generating preview',
    'fabric.media.download': 'Download',
    'fabric.media.unknown': 'unknown',
    'fabric.media.document': 'document',
    'fabric.media.audio': 'audio',
    'fabric.media.video': 'video',
    'fabric.media.image': 'image',
});
//# sourceMappingURL=sk.js.map

/***/ }),
/* 2145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Spanish
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': 'Reintentar',
    'fabric.media.failed_to_load': 'No se pudo cargar',
    'fabric.media.recent_uploads': 'Cargas recientes',
    'fabric.media.upload_file': 'Cargar un archivo',
    'fabric.media.drag_and_drop_your_files': 'Arrastra y suelta los archivos en cualquier lugar o',
    'fabric.media.drop_your_files': 'Suelta los archivos para cargarlos',
    'fabric.media.upload': 'Cargar',
    'fabric.media.cancel': 'Cancelar',
    'fabric.media.search_all_gifs': '¡Busca todos los GIF!',
    'fabric.media.cant_retrieve_gifs': '¡Qué pena! No hemos recuperado ningún GIF',
    'fabric.media.check_your_network': 'Comprueba tu conexión de red',
    'fabric.media.try_again': 'Volver a intentarlo',
    'fabric.media.no_gifs_found': 'Hola, ¿me buscabas?',
    'fabric.media.no_gifs_found_suggestion': 'No hemos encontrado nada para "{query}"',
    'fabric.media.load_more_gifs': 'Cargar más GIF',
    'fabric.media.add_account': 'Añadir cuenta',
    'fabric.media.unlink_account': 'Desvincular cuenta',
    'fabric.media.upload_file_from': 'Carga un archivo de {name}',
    'fabric.media.connect_to': 'Conectarse a {name}',
    'fabric.media.connect_account_description': 'Abriremos otra página para ayudarte a conectar tu cuenta de {name}',
    'fabric.media.upload_an_avatar': 'Carga un avatar',
    'fabric.media.save': 'Guardar',
    'fabric.media.or': 'o',
    'fabric.media.upload_photo': 'Carga una foto',
    'fabric.media.default_avatars': 'Avatares predeterminados',
    'fabric.media.drag_and_drop_images_here': 'Arrastra y suelta las imágenes aquí',
    'fabric.media.upload_image': 'Carga una imagen',
    'fabric.media.image_url_invalid_error': 'No se pudo cargar la imagen porque la URL no es válida.',
    'fabric.media.image_format_invalid_error': 'No se pudo cargar la imagen porque el formato no es válido.',
    'fabric.media.image_size_too_large_error': 'La imagen es demasiado larga; no puede superar los {MAX_SIZE_MB} MB',
    'fabric.media.something_went_wrong': 'Algo ha ido mal.',
    'fabric.media.might_be_a_hiccup': 'Tal vez sea solo un tropiezo.',
    'fabric.media.couldnt_generate_preview': 'No hemos podido generar la previsualización de este archivo.',
    'fabric.media.cant_preview_file_type': 'No podemos previsualizar este tipo de archivo.',
    'fabric.media.item_not_found_in_list': 'No se ha encontrado el elemento seleccionado en la lista.',
    'fabric.media.no_pdf_artifacts': 'No se han encontrado artefactos de PDF en este archivo.',
    'fabric.media.give_feedback': 'Enviar comentarios',
    'fabric.media.try_downloading_file': 'Prueba a descargar el archivo para verlo.',
    'fabric.media.webgl_warning_description': 'Tu navegador no admite WebGL. Usa un navegador compatible con WebGL para anotar imágenes.',
    'fabric.media.unable_to_annotate_image': 'No puedes anotar esta imagen',
    'fabric.media.learn_more': 'Más información',
    'fabric.media.accounts': 'Cuentas',
    'fabric.media.actions': 'Acciones',
    'fabric.media.error_hint_retry': 'Vuelve a probar y lo intentaremos otra vez.',
    'fabric.media.error_hint_critical': 'Si el problema continúa, ponte en contacto con la asistencia.',
    'fabric.media.close': 'Cerrar',
    'fabric.media.could_not_load_editor': '¡Qué pena! No hemos podido cargar el editor',
    'fabric.media.could_not_save_image': '¡Qué pena! No hemos podido guardar la imagen',
    'fabric.media.annotate': 'Anotar',
    'fabric.media.drop_your_files_here': 'Arrastra tus archivos hasta aquí',
    'fabric.media.share_files_instantly': 'Los compartiremos al instante',
    'fabric.media.insert_files': '{0, plural, one{Insertar un archivo} other{Insertar {0} archivos}}',
    'fabric.media.zoom_out': 'zoom out',
    'fabric.media.zoom_in': 'zoom in',
    'fabric.media.remove_image': 'Remove image',
    'fabric.media.play': 'play',
    'fabric.media.pause': 'pause',
    'fabric.media.disable_fullscreen': 'disable fullscreen',
    'fabric.media.enable_fullscreen': 'enable fullscreen',
    'fabric.media.error_loading_file': 'Error loading file',
    'fabric.media.error_generating_preview': 'Error generating preview',
    'fabric.media.download': 'Download',
    'fabric.media.unknown': 'unknown',
    'fabric.media.document': 'document',
    'fabric.media.audio': 'audio',
    'fabric.media.video': 'video',
    'fabric.media.image': 'image',
});
//# sourceMappingURL=es.js.map

/***/ }),
/* 2146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Swedish
/* harmony default export */ __webpack_exports__["a"] = ({
    'fabric.media.retry': 'Försök igen',
    'fabric.media.failed_to_load': 'Fel vid inläsning',
    'fabric.media.recent_uploads': 'Senaste uppladdningar',
    'fabric.media.upload_file': 'Ladda upp en fil',
    'fabric.media.drag_and_drop_your_files': 'Dra och släpp dina filer var som helst eller',
    'fabric.media.drop_your_files': 'Släpp dina filer för att ladda upp',
    'fabric.media.upload': 'Ladda upp',
    'fabric.media.cancel': 'Avbryt',
    'fabric.media.search_all_gifs': 'Sök alla GIF:ar!',
    'fabric.media.cant_retrieve_gifs': 'Oj då! Vi kunde inte hämta några GIF:ar',
    'fabric.media.check_your_network': 'Kontrollera din nätverksanslutning',
    'fabric.media.try_again': 'Försök igen',
    'fabric.media.no_gifs_found': 'Hello? Var det mig du letade efter?',
    'fabric.media.no_gifs_found_suggestion': 'Vi kunde inte hitta några resultat för "{query}"',
    'fabric.media.load_more_gifs': 'Läs in fler GIF:ar',
    'fabric.media.add_account': 'Lägg till konto',
    'fabric.media.unlink_account': 'Ta bort kontolänk',
    'fabric.media.upload_file_from': 'Ladda upp en fil från {name}',
    'fabric.media.connect_to': 'Anslut till {name}',
    'fabric.media.connect_account_description': 'Vi kommer att öppna en ny sida som hjälper dig att ansluta till ditt {name}-konto',
    'fabric.media.upload_an_avatar': 'Ladda upp en avatar',
    'fabric.media.save': 'Spara',
    'fabric.media.or': 'eller',
    'fabric.media.upload_photo': 'Ladda upp en bild',
    'fabric.media.default_avatars': 'Standardavatarer',
    'fabric.media.drag_and_drop_images_here': 'Dra och släpp dina bilder här',
    'fabric.media.upload_image': 'Ladda upp bild',
    'fabric.media.image_url_invalid_error': 'Kunde inte läsa in bild på grund av felaktig URL.',
    'fabric.media.image_format_invalid_error': 'Kunde inte läsa in bild på grund av ogiltigt format.',
    'fabric.media.image_size_too_large_error': 'Bilden är för stor. Storleken får inte överstiga {MAX_SIZE_MB} MB.',
    'fabric.media.something_went_wrong': 'Något gick fel.',
    'fabric.media.might_be_a_hiccup': 'Det är nog bara lite krångel.',
    'fabric.media.couldnt_generate_preview': 'Vi kunde inte generera en förhandsgranskning av den här filen.',
    'fabric.media.cant_preview_file_type': 'Vi kan inte förhandsgranska den här filtypen.',
    'fabric.media.item_not_found_in_list': 'Det valda objektet hittades inte i listan.',
    'fabric.media.no_pdf_artifacts': 'Inga PDF-artefakter hittades för den här filen.',
    'fabric.media.give_feedback': 'Ge feedback',
    'fabric.media.try_downloading_file': 'Försök ladda ner filen för att visa den.',
    'fabric.media.webgl_warning_description': 'Din webbläsare stöder inte WebGL. Använd en webbläsare som har stöd för WebGL för att kommentera bilder.',
    'fabric.media.unable_to_annotate_image': 'Du kan inte kommentera den här bilden.',
    'fabric.media.learn_more': 'Mer information',
    'fabric.media.accounts': 'Konton',
    'fabric.media.actions': 'Åtgärder',
    'fabric.media.error_hint_retry': 'Försök igen.',
    'fabric.media.error_hint_critical': 'Kontakta kundsupport om problemet kvarstår.',
    'fabric.media.close': 'Stäng',
    'fabric.media.could_not_load_editor': 'Oj då! Vi kunde inte läsa in redigeringsprogrammet.',
    'fabric.media.could_not_save_image': 'Oj då! Vi kunde inte spara bilden',
    'fabric.media.annotate': 'Kommentera',
    'fabric.media.drop_your_files_here': 'Släpp dina filer här',
    'fabric.media.share_files_instantly': 'Vi delar dem direkt',
    'fabric.media.insert_files': '{0, plural, one{Infoga en fil} other{Infoga {0} filer}}',
    'fabric.media.zoom_out': 'zoom out',
    'fabric.media.zoom_in': 'zoom in',
    'fabric.media.remove_image': 'Remove image',
    'fabric.media.play': 'play',
    'fabric.media.pause': 'pause',
    'fabric.media.disable_fullscreen': 'disable fullscreen',
    'fabric.media.enable_fullscreen': 'enable fullscreen',
    'fabric.media.error_loading_file': 'Error loading file',
    'fabric.media.error_generating_preview': 'Error generating preview',
    'fabric.media.download': 'Download',
    'fabric.media.unknown': 'unknown',
    'fabric.media.document': 'document',
    'fabric.media.audio': 'audio',
    'fabric.media.video': 'video',
    'fabric.media.image': 'image',
});
//# sourceMappingURL=sv.js.map

/***/ }),
/* 2147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ResolvingView__ = __webpack_require__(2148);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__ResolvingView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResolvedView__ = __webpack_require__(2159);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__ResolvedView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ErroredView__ = __webpack_require__(2221);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__ErroredView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ForbiddenView__ = __webpack_require__(2226);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__ForbiddenView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UnauthorisedView__ = __webpack_require__(2228);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__UnauthorisedView__["a"]; });





//# sourceMappingURL=index.js.map

/***/ }),
/* 2148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlockCardResolvingView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_spinner__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CollapsedFrame__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dimensions__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SingleLineLayout__ = __webpack_require__(2157);






var BlockCardResolvingView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](BlockCardResolvingView, _super);
    function BlockCardResolvingView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BlockCardResolvingView.prototype.render = function () {
        var _a = this.props, onClick = _a.onClick, isSelected = _a.isSelected;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__CollapsedFrame__["a" /* CollapsedFrame */], { isSelected: isSelected, minWidth: __WEBPACK_IMPORTED_MODULE_4__dimensions__["b" /* minWidth */], maxWidth: __WEBPACK_IMPORTED_MODULE_4__dimensions__["a" /* maxWidth */], onClick: onClick },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__SingleLineLayout__["a" /* SingleLineLayout */], { left: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_spinner__["a" /* default */], { size: "small" }), middle: "Loading..." })));
    };
    return BlockCardResolvingView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 2149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wrappper; });
/* unused harmony export Icon */
/* unused harmony export Text */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(101);




function minWidth(_a) {
    var minWidth = _a.minWidth;
    if (minWidth) {
        return "min-width: " + minWidth + "px;";
    }
    else {
        return '';
    }
}
function maxWidth(_a) {
    var maxWidth = _a.maxWidth;
    if (maxWidth) {
        return "max-width: " + maxWidth + "px;";
    }
    else {
        return '';
    }
}
function interactive(_a) {
    var isInteractive = _a.isInteractive;
    if (isInteractive) {
        return "\n      cursor: pointer;\n      :hover {\n        background-color: " + __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B50 + ";\n      }\n    ";
    }
    else {
        return '';
    }
}
function selected(_a) {
    var isSelected = _a.isSelected;
    return isSelected
        ? "&::after {\n        cursor: pointer;\n        box-shadow: 0 0 0 2px " + __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B100 + ";\n        content: '';\n        outline: none;\n        position: absolute;\n        height: 100%;\n        width: 100%;\n        left: 0;\n      }"
        : '';
}
var Wrappper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  height: 40px;\n  color: ", ";\n  font-family: ", ";\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 3px;\n  background-color: ", ";\n  position: relative;\n  ", " ", " ", " ", ";\n  ", "\n"], ["\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  height: 40px;\n  color: ", ";\n  font-family: ", ";\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 3px;\n  background-color: ", ";\n  position: relative;\n  ", " ", " ", " ", ";\n  ", "\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N300, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["fontFamily"], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N20A, __WEBPACK_IMPORTED_MODULE_3__mixins__["b" /* borderRadius */], minWidth, maxWidth, interactive, selected);
var Icon = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: inline-flex;\n"], ["\n  display: inline-flex;\n"])));
var Text = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin-left: 12px;\n"], ["\n  margin-left: 12px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e100", function() { return e100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e200", function() { return e200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e300", function() { return e300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e400", function() { return e400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e500", function() { return e500; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(413);

 // Cards on a board

var e100 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 1px 1px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px 0 ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 1px 1px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
}); // Inline dialogs

var e200 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 4px 8px -2px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 4px 8px -2px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
}); // Modals

var e300 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 8px 16px -4px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 8px 16px -4px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
}); // Panels

var e400 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 12px 24px -6px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 12px 24px -6px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
}); // Flag messages (notifications)

var e500 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 20px 32px -8px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 20px 32px -8px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
});

/***/ }),
/* 2151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h900", function() { return h900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h800", function() { return h800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h700", function() { return h700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h600", function() { return h600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h500", function() { return h500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h400", function() { return h400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h300", function() { return h300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h200", function() { return h200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h100", function() { return h100; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colors__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(49);




var baseHeading = function baseHeading(size, lineHeight) {
  return "\n  font-size: ".concat(size / Object(__WEBPACK_IMPORTED_MODULE_2__index__["fontSize"])(), "em;\n  font-style: inherit;\n  line-height: ").concat(lineHeight / size, ";\n");
};

var h900 = function h900() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ", "px;\n"], baseHeading(35, 40), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 6.5);
};
var h800 = function h800() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ", "px;\n"], baseHeading(29, 32), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 5);
};
var h700 = function h700() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ", "px;\n"], baseHeading(24, 28), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 5);
};
var h600 = function h600() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ", "px;\n"], baseHeading(20, 24), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 3.5);
};
var h500 = function h500() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ", "px;\n"], baseHeading(16, 20), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 3);
};
var h400 = function h400() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ", "px;\n"], baseHeading(14, 16), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 2);
};
var h300 = function h300() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  margin-top: ", "px;\n  text-transform: uppercase;\n"], baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 2.5);
};
var h200 = function h200() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  margin-top: ", "px;\n"], baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_1__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 2);
};
var h100 = function h100() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 700;\n  margin-top: ", "px;\n"], baseHeading(11, 16), __WEBPACK_IMPORTED_MODULE_1__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 2);
};

/***/ }),
/* 2152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["add"] = add;
/* harmony export (immutable) */ __webpack_exports__["subtract"] = subtract;
/* harmony export (immutable) */ __webpack_exports__["multiply"] = multiply;
/* harmony export (immutable) */ __webpack_exports__["divide"] = divide;
function add(fn, addend) {
  return function (props) {
    return fn(props) + addend;
  };
}
function subtract(fn, subtrahend) {
  return function (props) {
    return fn(props) - subtrahend;
  };
}
function multiply(fn, factor) {
  return function (props) {
    return fn(props) * factor;
  };
}
function divide(fn, divisor) {
  return function (props) {
    return fn(props) / divisor;
  };
}

/***/ }),
/* 2153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AtlaskitThemeProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_exenv__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_exenv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_exenv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__colors__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Theme__ = __webpack_require__(414);












 // For forward-compat until everything is upgraded.



function getStylesheetResetCSS(state) {
  var backgroundColor = __WEBPACK_IMPORTED_MODULE_11__colors__["background"](state);
  return "\n    body { background: ".concat(backgroundColor, "; }\n  ");
}

function buildThemeState(mode) {
  return {
    theme: __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_12__constants__["a" /* CHANNEL */], {
      mode: mode
    })
  };
}

var LegacyReset = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div.withConfig({
  displayName: "AtlaskitThemeProvider__LegacyReset",
  componentId: "sc-431dkp-0"
})(["\n  background-color: ", ";\n  color: ", ";\n\n  a {\n    color: ", ";\n  }\n  a:hover {\n    color: ", ";\n  }\n  a:active {\n    color: ", ";\n  }\n  a:focus {\n    outline-color: ", ";\n  }\n  h1 {\n    color: ", ";\n  }\n  h2 {\n    color: ", ";\n  }\n  h3 {\n    color: ", ";\n  }\n  h4 {\n    color: ", ";\n  }\n  h5 {\n    color: ", ";\n  }\n  h6 {\n    color: ", ";\n  }\n  small {\n    color: ", ";\n  }\n"], __WEBPACK_IMPORTED_MODULE_11__colors__["background"], __WEBPACK_IMPORTED_MODULE_11__colors__["text"], __WEBPACK_IMPORTED_MODULE_11__colors__["link"], __WEBPACK_IMPORTED_MODULE_11__colors__["linkHover"], __WEBPACK_IMPORTED_MODULE_11__colors__["linkActive"], __WEBPACK_IMPORTED_MODULE_11__colors__["linkOutline"], __WEBPACK_IMPORTED_MODULE_11__colors__["heading"], __WEBPACK_IMPORTED_MODULE_11__colors__["heading"], __WEBPACK_IMPORTED_MODULE_11__colors__["heading"], __WEBPACK_IMPORTED_MODULE_11__colors__["heading"], __WEBPACK_IMPORTED_MODULE_11__colors__["heading"], __WEBPACK_IMPORTED_MODULE_11__colors__["subtleHeading"], __WEBPACK_IMPORTED_MODULE_11__colors__["subtleText"]);

var AtlaskitThemeProvider =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(AtlaskitThemeProvider, _Component);

  function AtlaskitThemeProvider(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, AtlaskitThemeProvider);

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(AtlaskitThemeProvider).call(this, props));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "stylesheet", void 0);

    _this.state = buildThemeState(props.mode);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(AtlaskitThemeProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        hasAtlaskitThemeProvider: true
      };
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      if (!this.context.hasAtlaskitThemeProvider && __WEBPACK_IMPORTED_MODULE_10_exenv___default.a.canUseDOM) {
        var css = getStylesheetResetCSS(this.state);
        this.stylesheet = document.createElement('style');
        this.stylesheet.type = 'text/css';
        this.stylesheet.innerHTML = css;

        if (document && document.head) {
          document.head.appendChild(this.stylesheet);
        }
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (newProps.mode !== this.props.mode) {
        var newThemeState = buildThemeState(newProps.mode);

        if (this.stylesheet) {
          var css = getStylesheetResetCSS(newThemeState);
          this.stylesheet.innerHTML = css;
        }

        this.setState(newThemeState);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.stylesheet && document && document.head) {
        document.head.removeChild(this.stylesheet);
        delete this.stylesheet;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var theme = this.state.theme;
      return (
        /* Wrapping the new provider around the old one provides forward
        compatibility when using the old provider for styled components. This
        allows us to use components converted to use the new API with consumers
        using the old provider along side components that may still be using the
        old theming API. */
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Theme__["a" /* default */].Provider, {
          value: function value() {
            return {
              mode: theme[__WEBPACK_IMPORTED_MODULE_12__constants__["a" /* CHANNEL */]].mode
            };
          }
        }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_styled_components__["ThemeProvider"], {
          theme: theme
        }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(LegacyReset, null, children)))
      );
    }
  }]);

  return AtlaskitThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AtlaskitThemeProvider, "defaultProps", {
  mode: __WEBPACK_IMPORTED_MODULE_12__constants__["b" /* DEFAULT_THEME_MODE */]
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AtlaskitThemeProvider, "childContextTypes", {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AtlaskitThemeProvider, "contextTypes", {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
});



/***/ }),
/* 2154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);


/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var children = _ref.children,
      props = _ref.props,
      theme = _ref.theme;
  var appearance = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(props) === 'object' ? 'default' : props;
  var merged = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(props) === 'object' ? __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, props) : {};
  Object.keys(theme).forEach(function (key) {
    if (!(key in merged)) {
      merged[key] = theme[key]({
        appearance: appearance
      });
    }
  });
  return children(merged);
});

/***/ }),
/* 2155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ResetTheme; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Reset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__colors__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_createTheme__ = __webpack_require__(415);







var orTextColor = function orTextColor(preferred) {
  return function (p) {
    return p[preferred] || p.textColor;
  };
};

var Div = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div.withConfig({
  displayName: "Reset__Div",
  componentId: "sc-15i6ali-0"
})(["\n  ", ";\n"], function (p) {
  return Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["css"])(["\n    background-color: ", ";\n    color: ", ";\n\n    a {\n      color: ", ";\n    }\n    a:hover {\n      color: ", ";\n    }\n    a:active {\n      color: ", ";\n    }\n    a:focus {\n      outline-color: ", ";\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ", ";\n    }\n    h6 {\n      color: ", ";\n    }\n    small {\n      color: ", ";\n    }\n  "], p.backgroundColor, p.textColor, orTextColor('linkColor'), orTextColor('linkColorHover'), orTextColor('linkColorActive'), orTextColor('linkColorOutline'), orTextColor('headingColor'), orTextColor('subtleHeadingColor'), orTextColor('subtleTextColor'));
});
var ResetTheme = Object(__WEBPACK_IMPORTED_MODULE_5__utils_createTheme__["a" /* createTheme */])(function () {
  return {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N0"],
    linkColor: __WEBPACK_IMPORTED_MODULE_4__colors__["B400"],
    linkColorHover: __WEBPACK_IMPORTED_MODULE_4__colors__["B300"],
    linkColorActive: __WEBPACK_IMPORTED_MODULE_4__colors__["B500"],
    linkColorOutline: __WEBPACK_IMPORTED_MODULE_4__colors__["B100"],
    headingColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N800"],
    subtleHeadingColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N200"],
    subtleTextColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N200"],
    textColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N900"]
  };
});
function Reset(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ResetTheme.Provider, {
    value: props.theme
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ResetTheme.Consumer, null, function (tokens) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Div, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, tokens, {
      mode: undefined
    }), props), props.children);
  }));
}

/***/ }),
/* 2156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Theme__ = __webpack_require__(414);


 // Pre-executes the theme and passes it as a prop to the supplied component.
// This is useful for ensuring that the current theme is accessible as props
// in styled-components.

function withTheme(InnerComponent) {
  return function ComponentWithTheme(props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Theme__["a" /* default */].Consumer, null, function (tokens) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InnerComponent, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, props, {
        theme: tokens
      }));
    });
  };
}

/***/ }),
/* 2157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SingleLineLayout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled__ = __webpack_require__(2158);



var SingleLineLayout = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SingleLineLayout, _super);
    function SingleLineLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SingleLineLayout.prototype.render = function () {
        var _a = this.props, left = _a.left, middle = _a.middle, right = _a.right;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["d" /* Wrapper */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["a" /* Left */], null, left),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["b" /* Middle */], null, middle),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["c" /* Right */], null, right)));
    };
    return SingleLineLayout;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 2158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Left; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Middle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Right; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0 12px;\n  > * + * {\n    margin-left: 12px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0 12px;\n  > * + * {\n    margin-left: 12px;\n  }\n"])));
var Left = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  > * {\n    /* hack to vertically center the spinner which is display: inline-block; */\n    display: inline-flex;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  > * {\n    /* hack to vertically center the spinner which is display: inline-block; */\n    display: inline-flex;\n  }\n"])));
var Middle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex-grow: 1;\n  overflow: hidden;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex-grow: 1;\n  overflow: hidden;\n"])));
var Right = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n"], ["\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlockCardResolvedView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_avatar__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_avatar_group__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_tooltip__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ImageIcon__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_link__ = __webpack_require__(2203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dimensions__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ExpandedFrame__ = __webpack_require__(2205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AlertView__ = __webpack_require__(2207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PreviewView__ = __webpack_require__(2209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Widgets__ = __webpack_require__(2213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styled__ = __webpack_require__(2217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Transition__ = __webpack_require__(2218);















function getActionPendingState(action) {
    return function (state) {
        var _a;
        return ({
            pendingActionsById: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, state.pendingActionsById, (_a = {}, _a[action.id] = true, _a)),
        });
    };
}
function getActionSuccessState(action, message) {
    return function (state) {
        var _a;
        return ({
            pendingActionsById: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, state.pendingActionsById, (_a = {}, _a[action.id] = false, _a)),
            alert: message
                ? {
                    type: 'success',
                    text: message,
                }
                : state.alert,
        });
    };
}
function getActionFailureState(action, message) {
    return function (state) {
        var _a;
        return ({
            lastFailedAction: action,
            pendingActionsById: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, state.pendingActionsById, (_a = {}, _a[action.id] = false, _a)),
            alert: message
                ? {
                    type: 'failure',
                    text: message,
                }
                : state.alert,
        });
    };
}
function clearActionSuccessState() {
    return {
        alert: undefined,
    };
}
function clearActionFailureState() {
    return {
        lastFailedAction: undefined,
        alert: undefined,
    };
}
var BlockCardResolvedView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](BlockCardResolvedView, _super);
    function BlockCardResolvedView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            pendingActionsById: {},
        };
        /* prevent the parent link handler from opening a URL when clicked */
        _this.handleAvatarClick = function (_a) {
            var event = _a.event;
            event.preventDefault();
            event.stopPropagation();
        };
        /* prevent the parent link handler from opening a URL when clicked */
        /* NOTE: this prevents the dropdown from showing with more items */
        _this.handleMoreAvatarsClick = function (event) {
            event.preventDefault();
            event.stopPropagation();
        };
        _this.createActionHandler = function (action) {
            return function (event) {
                /* prevent the parent handler from opening a URL when clicked */
                event.preventDefault();
                event.stopPropagation();
                // prevent the next alert from being cleared by any previous success alerts that haven't already been cleared
                if (_this.alertTimeout) {
                    clearTimeout(_this.alertTimeout);
                }
                // handle the action
                action.handler(_this.getActionHandlerCallbacks(action));
            };
        };
        _this.handleActionRetry = function () {
            var lastFailedAction = _this.state.lastFailedAction;
            if (lastFailedAction) {
                lastFailedAction.handler(_this.getActionHandlerCallbacks(lastFailedAction));
            }
        };
        _this.handleActionDismis = function () {
            _this.setState(clearActionFailureState());
        };
        return _this;
    }
    BlockCardResolvedView.prototype.getActionHandlerCallbacks = function (action) {
        var _this = this;
        return {
            pending: function () { return _this.setState(getActionPendingState(action)); },
            success: function (message) {
                _this.setState(getActionSuccessState(action, message), function () {
                    // hide the alert after 2s
                    _this.alertTimeout = window.setTimeout(function () { return _this.setState(clearActionSuccessState()); }, 2000);
                });
            },
            failure: function () {
                return _this.setState(getActionFailureState(action, 'Something went wrong.'));
            },
        };
    };
    BlockCardResolvedView.prototype.componentWillUnmount = function () {
        // prevent the alert from being cleared and unmounted
        if (this.alertTimeout) {
            clearTimeout(this.alertTimeout);
        }
    };
    BlockCardResolvedView.prototype.renderIcon = function () {
        var icon = this.props.icon;
        if (!icon) {
            return null;
        }
        if (icon.url) {
            // TODO: handle if there is an error loading the image -> show the placeholder
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__styled__["f" /* IconWrapper */], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_tooltip__["a" /* default */], { content: icon.tooltip },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ImageIcon__["a" /* ImageIcon */], { src: icon.url, size: 24 }))));
        }
        return icon;
    };
    BlockCardResolvedView.prototype.renderThumbnail = function () {
        var thumbnail = this.props.thumbnail;
        if (!thumbnail) {
            return null;
        }
        // TODO: handle if there is an error loading the image -> show the placeholder
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__styled__["i" /* Thumbnail */], { src: thumbnail });
    };
    BlockCardResolvedView.prototype.renderUser = function () {
        var user = this.props.user;
        if (!user) {
            return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_avatar__["d" /* default */], { size: "medium", src: user.icon, name: user.name });
    };
    BlockCardResolvedView.prototype.renderUsers = function () {
        var _a = this.props.users, users = _a === void 0 ? [] : _a;
        if (users.length === 0) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__styled__["k" /* UsersWrapper */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_avatar_group__["default"], { maxCount: __WEBPACK_IMPORTED_MODULE_13__styled__["l" /* maxAvatarCount */], appearance: "stack", size: "small", data: users.map(function (user) { return ({
                    name: user.name,
                    src: user.icon,
                    size: 'small',
                }); }), onAvatarClick: this.handleAvatarClick, onMoreClick: this.handleMoreAvatarsClick })));
    };
    BlockCardResolvedView.prototype.renderActions = function () {
        var _this = this;
        var _a = this.props.actions, actions = _a === void 0 ? [] : _a;
        var _b = this.state, alert = _b.alert, pendingActionsById = _b.pendingActionsById;
        if (!actions.length) {
            return null;
        }
        var isAnyActionFailed = alert && alert.type === 'failure';
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__styled__["a" /* ActionsWrapper */], null, actions.slice(0, 3).map(function (action) {
            var id = action.id, text = action.text;
            var isPending = pendingActionsById[id];
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__atlaskit_button__["default"], { key: id, spacing: "compact", isDisabled: isPending || isAnyActionFailed, isLoading: isPending, onClick: _this.createActionHandler(action) }, text));
        })));
    };
    BlockCardResolvedView.prototype.renderAlert = function () {
        var alert = this.state.alert;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__styled__["b" /* AlertWrapper */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Transition__["a" /* default */], { enter: ['fade', 'slide-up'], exit: ['fade', 'slide-down'], timeout: 300 }, alert ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__AlertView__["a" /* default */], { type: alert.type === 'success' ? 'success' : 'failure', text: alert.text, onRetry: this.handleActionRetry, onDismis: this.handleActionDismis })) : null)));
    };
    BlockCardResolvedView.prototype.renderWithToolTip = function (Elem, model) {
        if (model.tooltip) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_tooltip__["a" /* default */], { content: model.tooltip },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Elem, null, model.text)));
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Elem, null, model.text);
        }
    };
    BlockCardResolvedView.prototype.render = function () {
        var _a = this.props, link = _a.link, context = _a.context, title = _a.title, byline = _a.byline, description = _a.description, icon = _a.icon, user = _a.user, preview = _a.preview, details = _a.details, onClick = _a.onClick, isSelected = _a.isSelected;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ExpandedFrame__["a" /* ExpandedFrame */], { minWidth: __WEBPACK_IMPORTED_MODULE_8__dimensions__["b" /* minWidth */], maxWidth: __WEBPACK_IMPORTED_MODULE_8__dimensions__["a" /* maxWidth */], isSelected: isSelected, href: link, icon: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ImageIcon__["a" /* ImageIcon */], { src: context && context.icon, default: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_link___default.a, { label: "icon", size: "small" }) }), text: context && context.text, onClick: onClick },
            preview && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__PreviewView__["a" /* PreviewView */], { url: preview }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__styled__["d" /* ContentWrapper */], null,
                this.renderAlert(),
                (icon || user) && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__styled__["g" /* LeftWrapper */], null,
                    this.renderIcon(),
                    !icon && this.renderUser())),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__styled__["h" /* RightWrapper */], null,
                    this.renderThumbnail(),
                    title && title.text && this.renderWithToolTip(__WEBPACK_IMPORTED_MODULE_13__styled__["j" /* Title */], title),
                    !byline ? null : !byline.text ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__styled__["c" /* Byline */], null, byline)) : (this.renderWithToolTip(__WEBPACK_IMPORTED_MODULE_13__styled__["c" /* Byline */], byline)),
                    description &&
                        description.text &&
                        this.renderWithToolTip(__WEBPACK_IMPORTED_MODULE_13__styled__["e" /* Description */], description),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Widgets__["a" /* default */], { details: details }),
                    this.renderUsers(),
                    this.renderActions()))));
    };
    return BlockCardResolvedView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 2160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AvatarGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_dropdown_menu__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_avatar__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styled_AvatarGroup__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__MoreIndicator__ = __webpack_require__(2198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__theme_itemTheme__ = __webpack_require__(2200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AvatarGroupItem__ = __webpack_require__(2201);








/* eslint-disable react/no-array-index-key */








var GROUP_COMPONENT = {
  grid: __WEBPACK_IMPORTED_MODULE_11__styled_AvatarGroup__["a" /* Grid */],
  stack: __WEBPACK_IMPORTED_MODULE_11__styled_AvatarGroup__["b" /* Stack */]
};
var MAX_COUNT = {
  grid: 11,
  stack: 5
};

var AvatarGroup =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(AvatarGroup, _Component);

  function AvatarGroup() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, AvatarGroup);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(AvatarGroup).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(AvatarGroup, [{
    key: "renderMoreDropdown",
    value: function renderMoreDropdown(max, total) {
      var _this$props = this.props,
          appearance = _this$props.appearance,
          data = _this$props.data,
          borderColor = _this$props.borderColor,
          onMoreClick = _this$props.onMoreClick,
          showMoreButtonProps = _this$props.showMoreButtonProps,
          onAvatarClick = _this$props.onAvatarClick,
          size = _this$props.size,
          boundariesElement = _this$props.boundariesElement; // bail if there's not enough items

      if (total <= max) return null; // prepare the button -- we'll use it twice

      var MoreButton = function MoreButton(props) {
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__MoreIndicator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, showMoreButtonProps, {
          borderColor: borderColor,
          count: total - max,
          isInteractive: true,
          isStack: appearance === 'stack',
          size: size
        }, props));
      }; // bail if the consumer wants to handle onClick


      if (typeof onMoreClick === 'function') {
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(MoreButton, {
          onClick: onMoreClick
        });
      } // crop and prepare the dropdown items


      var items = data.slice(max).map(function (avatar, index) {
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__AvatarGroupItem__["a" /* default */], {
          isInteractive: true,
          avatar: avatar,
          key: index,
          onAvatarClick: onAvatarClick
        });
      });
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__atlaskit_dropdown_menu__["c" /* default */], {
        trigger: __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(MoreButton, null),
        position: "bottom right",
        boundariesElement: boundariesElement,
        shouldFlip: true
      }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_styled_components__["ThemeProvider"], {
        theme: __WEBPACK_IMPORTED_MODULE_13__theme_itemTheme__["a" /* default */]
      }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__atlaskit_dropdown_menu__["b" /* DropdownItemGroup */], null, items)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          Item = _this$props2.avatar,
          appearance = _this$props2.appearance,
          borderColor = _this$props2.borderColor,
          data = _this$props2.data,
          maxCount = _this$props2.maxCount,
          onAvatarClick = _this$props2.onAvatarClick,
          size = _this$props2.size; // NOTE: conditionally defaulting the `maxCount` prop based on `appearance`

      var max = maxCount === 0 ? MAX_COUNT[appearance] : maxCount;
      var total = data.length;
      var Group = GROUP_COMPONENT[appearance]; // Render (max - 1) avatars to leave space for moreIndicator

      var maxAvatar = total > max ? max - 1 : max;
      var items = data.slice(0, maxAvatar).map(function (avatar, idx) {
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Item, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, avatar, {
          borderColor: borderColor,
          groupAppearance: appearance,
          index: idx,
          key: idx,
          onClick: avatar.onClick || onAvatarClick,
          size: size,
          stackIndex: max - idx
        }));
      });
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Group, {
        size: size
      }, items, this.renderMoreDropdown(+maxAvatar, total));
    }
  }]);

  return AvatarGroup;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AvatarGroup, "defaultProps", {
  appearance: 'stack',
  avatar: __WEBPACK_IMPORTED_MODULE_10__atlaskit_avatar__["d" /* default */],
  maxCount: 0,
  showMoreButtonProps: {},
  size: 'medium'
});



/***/ }),
/* 2161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropdownMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DropdownMenuStateless__ = __webpack_require__(753);











var DropdownMenu =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(DropdownMenu, _Component);

  function DropdownMenu() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, DropdownMenu);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(DropdownMenu)).call.apply(_getPrototypeOf2, [this].concat(_args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      isOpen: _this.props.defaultOpen,
      items: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(_this.props.items)
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "findActivatedGroup", function (item) {
      return _this.state.items.filter(function (group) {
        return group.items.indexOf(item) > -1;
      })[0];
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleItemActivation", function (attrs) {
      var activatedItem = attrs.item;

      var activatedGroup = _this.findActivatedGroup(activatedItem);

      var items = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(_this.state.items);

      switch (activatedItem.type) {
        case 'checkbox':
          activatedItem.isChecked = !activatedItem.isChecked;

          _this.props.onItemActivated({
            item: activatedItem
          });

          _this.setState({
            items: items
          });

          break;

        case 'radio':
          activatedGroup.items.forEach(function (i) {
            if (i === activatedItem) {
              i.isChecked = true; // eslint-disable-line no-param-reassign
            } else {
              i.isChecked = false; // eslint-disable-line no-param-reassign
            }
          });

          _this.props.onItemActivated({
            item: activatedItem
          });

          _this.setState({
            items: items
          });

          break;

        case 'link':
        default:
          _this.props.onItemActivated({
            item: activatedItem
          });

          _this.close();

          break;
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleOpenChange", function (attrs) {
      var _this$props;

      if (_this.state.isOpen === attrs.isOpen) return;

      _this.setState({
        isOpen: attrs.isOpen
      });

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      (_this$props = _this.props).onOpenChange.apply(_this$props, [attrs].concat(args));
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "close", function () {
      var _this$props2;

      if (_this.state.isOpen === false) return;

      _this.setState({
        isOpen: false
      });

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      (_this$props2 = _this.props).onOpenChange.apply(_this$props2, [{
        isOpen: false
      }].concat(args));
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(DropdownMenu, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.items !== this.state.items) {
        this.setState({
          items: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(nextProps.items)
        });
      }

      if (nextProps.isOpen !== this.props.isOpen) {
        this.setState({
          isOpen: nextProps.isOpen
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var isOpen = this.state.isOpen;
      var _this$props3 = this.props,
          appearance = _this$props3.appearance,
          boundariesElement = _this$props3.boundariesElement,
          children = _this$props3.children,
          isLoading = _this$props3.isLoading,
          items = _this$props3.items,
          position = _this$props3.position,
          isMenuFixed = _this$props3.isMenuFixed,
          shouldAllowMultilineItems = _this$props3.shouldAllowMultilineItems,
          shouldFitContainer = _this$props3.shouldFitContainer,
          shouldFlip = _this$props3.shouldFlip,
          trigger = _this$props3.trigger,
          triggerButtonProps = _this$props3.triggerButtonProps,
          triggerType = _this$props3.triggerType,
          onPositioned = _this$props3.onPositioned;
      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__DropdownMenuStateless__["a" /* default */], {
        appearance: appearance,
        boundariesElement: boundariesElement,
        isOpen: isOpen,
        isLoading: isLoading,
        items: items,
        onItemActivated: this.handleItemActivation,
        onOpenChange: this.handleOpenChange,
        position: position,
        isMenuFixed: isMenuFixed,
        shouldAllowMultilineItems: shouldAllowMultilineItems,
        shouldFitContainer: shouldFitContainer,
        shouldFlip: shouldFlip,
        trigger: trigger,
        triggerButtonProps: triggerButtonProps,
        triggerType: triggerType,
        onPositioned: onPositioned
      }, children);
    }
  }]);

  return DropdownMenu;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(DropdownMenu, "defaultProps", {
  appearance: 'default',
  boundariesElement: 'viewport',
  defaultOpen: false,
  isLoading: false,
  isOpen: false,
  items: [],
  onItemActivated: function onItemActivated() {},
  onOpenChange: function onOpenChange() {},
  position: 'bottom left',
  isMenuFixed: false,
  shouldAllowMultilineItems: false,
  shouldFitContainer: false,
  shouldFlip: true,
  triggerType: 'default',
  onPositioned: function onPositioned() {}
});



/***/ }),
/* 2162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DroplistWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_analytics_next__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_layer__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_spinner__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__package_json__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styled_Droplist__ = __webpack_require__(2163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__theme_item_theme__ = __webpack_require__(2164);

















var halfFocusRing = 1;
var dropOffset = "0 ".concat(Object(__WEBPACK_IMPORTED_MODULE_13__atlaskit_theme__["gridSize"])(), "px");

var Droplist =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Droplist, _Component);

  function Droplist() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Droplist);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Droplist)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "componentDidMount", function () {
      _this.setContentWidth(); // We use a captured event here to avoid a radio or checkbox dropdown item firing its
      // click event first, which would cause a re-render of the element and prevent Droplist
      // from detecting the actual source of this original click event.


      document.addEventListener('click', _this.handleClickOutside, true);
      document.addEventListener('keydown', _this.handleEsc);
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "componentDidUpdate", function () {
      if (_this.props.isOpen) {
        _this.setContentWidth();
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "componentWillUnmount", function () {
      document.removeEventListener('click', _this.handleClickOutside, true);
      document.removeEventListener('keydown', _this.handleEsc);
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "setContentWidth", function () {
      var _assertThisInitialize = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)),
          dropContentRef = _assertThisInitialize.dropContentRef,
          triggerRef = _assertThisInitialize.triggerRef;

      var shouldFitContainer = _this.props.shouldFitContainer; // We need to manually set the content width to match the trigger width
      // if props.shouldFitContainer is true

      if (shouldFitContainer && dropContentRef && triggerRef) {
        dropContentRef.style.width = "".concat(triggerRef.offsetWidth - halfFocusRing * 2, "px");
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "dropContentRef", void 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "triggerRef", void 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleEsc", function (event) {
      if (event.key === 'Escape' && _this.props.isOpen) {
        _this.close(event);
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleClickOutside", function (event) {
      if (_this.props.isOpen) {
        // $FlowFixMe - flow is lost and if not an instance of Node
        if (event.target instanceof Node) {
          // Rather than check for the target within the entire Droplist, we specify the trigger/content.
          // This aids with future effort in scroll-locking Droplist when isMenuFixed is enabled; the scroll
          // blanket which stretches to the viewport should not stop 'close' from being triggered.
          var withinTrigger = _this.triggerRef && _this.triggerRef.contains(event.target);

          var withinContent = _this.dropContentRef && _this.dropContentRef.contains(event.target);

          if (!withinTrigger && !withinContent) {
            _this.close(event);
          }
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "close", function (event) {
      if (_this.props.onOpenChange) {
        _this.props.onOpenChange({
          isOpen: false,
          event: event
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleContentRef", function (ref) {
      _this.dropContentRef = ref; // If the dropdown has just been opened, we focus on the containing element so the
      // user can tab to the first dropdown item. We will only receive this ref if isOpen
      // is true or null, so no need to check for truthiness here.

      if (ref) {
        ref.focus();
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleTriggerRef", function (ref) {
      _this.triggerRef = ref;
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Droplist, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        shouldAllowMultilineItems: this.props.shouldAllowMultilineItems
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          appearance = _this$props.appearance,
          boundariesElement = _this$props.boundariesElement,
          children = _this$props.children,
          isLoading = _this$props.isLoading,
          isOpen = _this$props.isOpen,
          maxHeight = _this$props.maxHeight,
          onClick = _this$props.onClick,
          onKeyDown = _this$props.onKeyDown,
          position = _this$props.position,
          isMenuFixed = _this$props.isMenuFixed,
          shouldFitContainer = _this$props.shouldFitContainer,
          shouldFlip = _this$props.shouldFlip,
          trigger = _this$props.trigger,
          onPositioned = _this$props.onPositioned;
      var layerContent = isOpen ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styled_Droplist__["a" /* Content */], {
        "data-role": "droplistContent",
        isTall: appearance === 'tall',
        innerRef: this.handleContentRef,
        maxHeight: maxHeight
      }, isLoading ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styled_Droplist__["b" /* SpinnerContainer */], null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__atlaskit_spinner__["a" /* default */], {
        size: "small"
      })) : __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_styled_components__["ThemeProvider"], {
        theme: __WEBPACK_IMPORTED_MODULE_16__theme_item_theme__["a" /* default */]
      }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", null, children))) : null;
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styled_Droplist__["d" /* default */], {
        fit: shouldFitContainer,
        onClick: onClick,
        onKeyDown: onKeyDown
      }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__atlaskit_layer__["a" /* default */], {
        autoFlip: shouldFlip,
        boundariesElement: boundariesElement,
        content: layerContent,
        offset: dropOffset // $FlowFixMe - Cannot create `Layer` element because in property `position
        ,
        position: position,
        isAlwaysFixed: isOpen && isMenuFixed,
        onPositioned: onPositioned
      }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styled_Droplist__["c" /* Trigger */], {
        fit: shouldFitContainer,
        innerRef: this.handleTriggerRef
      }, trigger)));
    }
  }]);

  return Droplist;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Droplist, "defaultProps", {
  appearance: 'default',
  boundariesElement: 'viewport',
  children: null,
  isLoading: false,
  isOpen: false,
  onClick: function onClick() {},
  onKeyDown: function onKeyDown() {},
  onOpenChange: function onOpenChange() {},
  position: 'bottom left',
  isMenuFixed: false,
  shouldAllowMultilineItems: false,
  shouldFitContainer: false,
  shouldFlip: true,
  trigger: null,
  onPositioned: function onPositioned() {}
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Droplist, "childContextTypes", {
  shouldAllowMultilineItems: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
});


var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_9__atlaskit_analytics_next__["createAndFireEvent"])('atlaskit');
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__atlaskit_analytics_next__["withAnalyticsContext"])({
  componentName: 'droplist',
  packageName: __WEBPACK_IMPORTED_MODULE_14__package_json__["name"],
  packageVersion: __WEBPACK_IMPORTED_MODULE_14__package_json__["version"]
})(Object(__WEBPACK_IMPORTED_MODULE_9__atlaskit_analytics_next__["withAnalyticsEvents"])({
  onOpenChange: createAndFireEventOnAtlaskit({
    action: 'toggled',
    actionSubject: 'droplist',
    attributes: {
      componentName: 'droplist',
      packageName: __WEBPACK_IMPORTED_MODULE_14__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_14__package_json__["version"]
    }
  })
})(Droplist)));

/***/ }),
/* 2163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SpinnerContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Trigger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);


/* When dropdown contains more than 9 elements (droplist items, droplist groups),
 * it should have scroll and cut off half of the 10th item to indicate that there are more
 * items then are seen. This was previously calculated by mapping over children, but with
 * the current composed API it is simpler to just assume 9 items. */

var getMaxHeight = function getMaxHeight(_ref) {
  var isTall = _ref.isTall,
      maxHeight = _ref.maxHeight;
  if (maxHeight) return "".concat(maxHeight, "px");
  var heightWithoutPadding = 17;
  var verticalPadding = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])();
  var height = heightWithoutPadding + verticalPadding * 2;
  var defaultMaxHeight = 9.5 * height + verticalPadding / 2;
  return isTall ? '90vh' : "".concat(defaultMaxHeight, "px");
};

/* harmony default export */ __webpack_exports__["d"] = (__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Droplist",
  componentId: "sc-1z05y4v-0"
})(["\n  display: inline-flex;\n\n  ", ";\n"], function (props) {
  return props.fit && "\n    display: block;\n    flex: 1 1 auto;\n  ";
}));
var backgroundColor = __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].backgroundOnLayer;
var boxShadow = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  box-shadow: 0 ", "px ", "px -", "px ", ",\n    0 0 1px ", ";\n"], __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["math"].divide(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"], 2), __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"], __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["math"].divide(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"], 4), __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N50A, __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N60A);
var Content = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Droplist__Content",
  componentId: "sc-1z05y4v-1"
})(["\n  background: ", ";\n  border-radius: ", "px;\n  ", ";\n  box-sizing: border-box;\n  overflow: auto;\n  padding: ", "px 0;\n  max-height: ", ";\n"], backgroundColor, __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["borderRadius"], boxShadow, __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["math"].divide(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"], 2), getMaxHeight);
var SpinnerContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Droplist__SpinnerContainer",
  componentId: "sc-1z05y4v-2"
})(["\n  display: flex;\n  justify-content: center;\n  min-width: ", "px;\n  padding: ", "px;\n"], __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"], 20), __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"], 2.5));
var Trigger = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Droplist__Trigger",
  componentId: "sc-1z05y4v-3"
})(["\n  display: inline-flex;\n  transition-duration: 0.2s;\n  transition: box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38);\n\n  ", ";\n"], function (props) {
  return props.fit && "\n    box-sizing: border-box;\n    display: block;\n  ";
});

/***/ }),
/* 2164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_item__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



var dropdownPadding = {
  bottom: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"],
  left: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 1.5),
  right: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 1.5),
  top: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"]
};
var droplistItemTheme = {
  padding: {
    default: dropdownPadding,
    compact: dropdownPadding
  },
  borderRadius: function borderRadius() {
    return 0;
  },
  default: {
    background: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N0,
      dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN50
    }),
    text: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N800,
      dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN600
    }),
    secondaryText: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N200,
      dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN300
    })
  },
  hover: {
    background: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N20,
      dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN70
    }),
    text: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N800,
      dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN600
    }),
    secondaryText: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N200,
      dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN300
    })
  },
  active: {
    background: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B75,
      dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B75
    }),
    text: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N800,
      dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B400
    }),
    secondaryText: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N200,
      dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN300
    })
  },
  selected: {
    background: 'transparent',
    text: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N800,
      dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN600
    }),
    secondaryText: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N200,
      dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN300
    })
  },
  disabled: {
    background: 'transparent',
    text: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N70,
      dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN80
    }),
    secondaryText: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N50,
      dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN70
    })
  },
  focus: {
    outline: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B100,
      dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B75
    })
  }
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__atlaskit_item__["c" /* itemThemeNamespace */], droplistItemTheme));

/***/ }),
/* 2165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Item; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styled_Item__ = __webpack_require__(2166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styled_ItemParts__ = __webpack_require__(2167);













var Item =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Item, _Component);

  // eslint-disable-next-line react/sort-comp
  function Item(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Item);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Item).call(this, props)); // The type of element rendered at the root of render() can vary based on the `href`
    // and `linkComponent` props provided. We generate this component here to avoid re-
    // generating the component inside render(). This is for performance reasons, and also
    // allows us to avoid generating a new `ref` for the root element each render().

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "rootComponent", void 0);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "ref", void 0);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "setRef", function (ref) {
      _this.ref = ref;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "href", function () {
      return _this.props.isDisabled ? null : _this.props.href;
    });

    _this.rootComponent = Object(__WEBPACK_IMPORTED_MODULE_10__styled_Item__["a" /* default */])({
      href: _this.href(),
      linkComponent: props.linkComponent
    });
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Item, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.ref && this.props.autoFocus) {
        this.ref.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _onClick = _this$props.onClick,
          _onKeyDown = _this$props.onKeyDown,
          isCompact = _this$props.isCompact,
          isDisabled = _this$props.isDisabled,
          isDragging = _this$props.isDragging,
          isHidden = _this$props.isHidden,
          isSelected = _this$props.isSelected,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseLeave = _this$props.onMouseLeave,
          role = _this$props.role,
          dnd = _this$props.dnd,
          otherProps = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_this$props, ["onClick", "onKeyDown", "isCompact", "isDisabled", "isDragging", "isHidden", "isSelected", "onMouseEnter", "onMouseLeave", "role", "dnd"]);

      var Root = this.rootComponent;
      var dragHandleProps = dnd && dnd.dragHandleProps || null;
      var patchedEventHandlers = {
        onClick: function onClick(event) {
          var original = function original() {
            if (!isDisabled && _onClick) {
              _onClick(event);
            }
          };

          if (!dragHandleProps || !dragHandleProps.onClick) {
            original();
            return;
          } // Drag and drop has its own disabled mechansim
          // So not checking for isDisabled


          dragHandleProps.onClick(event); // if default is prevent - do not fire the onClick prop

          if (event.defaultPrevented) {
            return;
          }

          original();
        },
        onMouseDown: function onMouseDown(event) {
          if (dragHandleProps && dragHandleProps.onMouseDown) {
            dragHandleProps.onMouseDown(event);
          } // We want to prevent the item from getting focus when clicked


          event.preventDefault();
        },
        onKeyDown: function onKeyDown(event) {
          var original = function original() {
            if (!isDisabled && _onKeyDown) {
              _onKeyDown(event);
            }
          };

          if (!dragHandleProps || !dragHandleProps.onKeyDown) {
            original();
            return;
          }

          dragHandleProps.onKeyDown(event); // if default is prevent - do not fire other handlers

          if (event.defaultPrevented) {
            return;
          } // not allowing keyboard events on the element while dragging


          if (isDragging) {
            return;
          }

          original();
        }
      };

      var patchedInnerRef = function patchedInnerRef(ref) {
        _this2.setRef(ref);

        if (dnd && dnd.innerRef) {
          dnd.innerRef(ref);
        }
      };

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(Root, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        "aria-disabled": isDisabled,
        href: this.href(),
        isCompact: isCompact,
        isDisabled: isDisabled,
        isDragging: isDragging,
        isHidden: isHidden,
        isSelected: isSelected,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        role: role,
        tabIndex: isDisabled || isHidden || this.props.href ? null : 0,
        target: this.props.target,
        title: this.props.title,
        innerRef: patchedInnerRef
      }, dnd && dnd.draggableProps, dragHandleProps, patchedEventHandlers, otherProps), !!this.props.elemBefore && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styled_ItemParts__["b" /* Before */], {
        isCompact: isCompact
      }, this.props.elemBefore), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styled_ItemParts__["d" /* ContentWrapper */], null, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styled_ItemParts__["c" /* Content */], {
        allowMultiline: this.props.shouldAllowMultiline
      }, this.props.children), !!this.props.description && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styled_ItemParts__["e" /* Description */], {
        isCompact: this.props.isCompact,
        isDisabled: this.props.isDisabled
      }, this.props.description)), !!this.props.elemAfter && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styled_ItemParts__["a" /* After */], {
        isCompact: isCompact
      }, this.props.elemAfter));
    }
  }]);

  return Item;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Item, "defaultProps", {
  autoFocus: false,
  description: '',
  isCompact: false,
  isDisabled: false,
  isHidden: false,
  role: 'button',
  shouldAllowMultiline: false
});



/***/ }),
/* 2166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ItemBase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_theme__ = __webpack_require__(272);




var getItemState = function getItemState(stateName) {
  return function (_ref) {
    var theme = _ref.theme;
    var stateStyles = Object(__WEBPACK_IMPORTED_MODULE_2__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_2__util_theme__["e" /* themeNamespace */]], stateName);
    return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n    background-color: ", ";\n    color: ", ";\n    fill: ", ";\n    text-decoration: none;\n\n    &:focus {\n      color: ", ";\n    }\n  "], stateStyles.background, stateStyles.text, stateStyles.background, stateStyles.text);
  };
};

var getPadding = function getPadding(_ref2) {
  var isCompact = _ref2.isCompact,
      theme = _ref2.theme,
      description = _ref2.description;
  var paddingKey = isCompact ? 'compact' : 'default';

  var _getThemeStyle = Object(__WEBPACK_IMPORTED_MODULE_2__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_2__util_theme__["e" /* themeNamespace */]], paddingKey, 'padding'),
      _getThemeStyle$bottom = _getThemeStyle.bottom,
      bottom = _getThemeStyle$bottom === void 0 ? 0 : _getThemeStyle$bottom,
      _getThemeStyle$left = _getThemeStyle.left,
      left = _getThemeStyle$left === void 0 ? 0 : _getThemeStyle$left,
      _getThemeStyle$right = _getThemeStyle.right,
      right = _getThemeStyle$right === void 0 ? 0 : _getThemeStyle$right,
      _getThemeStyle$top = _getThemeStyle.top,
      top = _getThemeStyle$top === void 0 ? 0 : _getThemeStyle$top;

  var adjustedTop = typeof top === 'function' ? top() : top;
  var adjustedBottom = typeof bottom === 'function' ? bottom() : bottom; // Subtract the 1px padding-bottom added to the content and description elements
  // to maintain original height

  adjustedTop = Math.max(description ? adjustedTop - 1 : adjustedTop, 0);
  adjustedBottom = Math.max(adjustedBottom - 1, 0);
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n    padding: ", "px ", "px ", "px ", "px;\n  "], adjustedTop, right, adjustedBottom, left);
};

var getHeightStyles = function getHeightStyles(_ref3) {
  var isCompact = _ref3.isCompact,
      theme = _ref3.theme;
  var heightKey = isCompact ? 'compact' : 'default';
  var height = Object(__WEBPACK_IMPORTED_MODULE_2__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_2__util_theme__["e" /* themeNamespace */]], heightKey, 'height');
  return height ? Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n        height: ", "px;\n      "], height) : '';
}; // This function is responsible for drawing any focus styles for the element


var getInteractiveStyles = function getInteractiveStyles(_ref4) {
  var theme = _ref4.theme,
      isDisabled = _ref4.isDisabled,
      isDragging = _ref4.isDragging,
      isSelected = _ref4.isSelected;

  if (isDragging) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n      ", " box-shadow: 0 4px 8px -2px ", ",\n        0 0 1px ", ";\n    "], getItemState('dragging'), __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N60A, __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N60A);
  }

  var standardFocus = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n    &:focus {\n      box-shadow: 0 0 0 2px\n        ", " inset;\n      text-decoration: none;\n    }\n  "], Object(__WEBPACK_IMPORTED_MODULE_2__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_2__util_theme__["e" /* themeNamespace */]], 'outline', 'focus'));

  if (isDisabled) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n      cursor: not-allowed;\n      ", " ", ";\n    "], getItemState('disabled'), standardFocus);
  }

  if (isSelected) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n      ", " &:hover {\n        ", ";\n      }\n\n      &:active {\n        ", ";\n      }\n\n      ", ";\n    "], getItemState('selected'), getItemState('hover'), getItemState('active'), standardFocus);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n    &:hover {\n      ", ";\n    }\n\n    &:active {\n      ", ";\n    }\n\n    ", ";\n  "], getItemState('hover'), getItemState('active'), standardFocus);
}; // This is the main item style. It is defined as a basic style variable so it can
// later be applied to different component types (span / a / custom link component)


var ItemBase = function ItemBase(_ref5) {
  var theme = _ref5.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  && {\n    align-items: center;\n    border-radius: ", "px;\n    box-sizing: border-box;\n    cursor: pointer;\n    display: ", ";\n    flex: none;\n    ", " ", " ", " ", " &:focus {\n      /* focus shadow drawn by getInteractiveStyles */\n\n      outline: none;\n      /* relative position prevents bgcolor of a hovered element from\n      obfuscating focus ring of a focused sibling element */\n      position: relative;\n    }\n  }\n"], Object(__WEBPACK_IMPORTED_MODULE_2__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_2__util_theme__["e" /* themeNamespace */]], 'borderRadius'), function (_ref6) {
    var isHidden = _ref6.isHidden;
    return isHidden ? 'none' : 'flex';
  }, getItemState('default'), getPadding, getInteractiveStyles, getHeightStyles);
}; // Given some optional link-related props, returns the relevant styled
// component. For links, it styles the linkComponent if provided, otherwise
// falling back to a styled <a> tag. If no href is present, a styled <span>
// is returned. When we upgrade to styled-components@2.x we will be able to
// simplify this by taking advantage of the withComponent() functionality.

var styledRootElement = function styledRootElement(_ref7) {
  var href = _ref7.href,
      linkComponent = _ref7.linkComponent;

  if (linkComponent) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(linkComponent).withConfig({
      displayName: "Item",
      componentId: "z6qfkt-0"
    })(["\n      ", ";\n    "], ItemBase);
  }

  if (href) {
    return __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].a.withConfig({
      displayName: "Item",
      componentId: "z6qfkt-1"
    })(["\n      ", ";\n    "], ItemBase);
  }

  return __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
    displayName: "Item",
    componentId: "z6qfkt-2"
  })(["\n    ", ";\n  "], ItemBase);
};

/* harmony default export */ __webpack_exports__["a"] = (styledRootElement);

/***/ }),
/* 2167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InputWrapper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Before; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return After; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ContentWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Description; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_theme__ = __webpack_require__(272);


 // Checkbox/Radio wrapper -- sits left of the children

var InputWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "ItemParts__InputWrapper",
  componentId: "sc-14xek3m-0"
})(["\n  display: flex;\n  margin: 0 2px;\n"]); // Elements injected before/after the children

var BeforeAfterBase = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "ItemParts__BeforeAfterBase",
  componentId: "sc-14xek3m-1"
})(["\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n  /* Fix windows line-height issue */\n  padding-bottom: 1px;\n"]);

var getBeforeSpacing = function getBeforeSpacing(_ref) {
  var isCompact = _ref.isCompact,
      theme = _ref.theme;
  var spaceKey = isCompact ? 'compact' : 'default';
  var space = Object(__WEBPACK_IMPORTED_MODULE_2__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_2__util_theme__["e" /* themeNamespace */]], spaceKey, 'beforeItemSpacing');
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n    margin-right: ", "px;\n  "], space);
};

var Before = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(BeforeAfterBase).withConfig({
  displayName: "ItemParts__Before",
  componentId: "sc-14xek3m-2"
})(["\n  ", ";\n"], getBeforeSpacing);

var getAfterSpacing = function getAfterSpacing(_ref2) {
  var isCompact = _ref2.isCompact,
      theme = _ref2.theme;
  var spaceKey = isCompact ? 'compact' : 'default';
  var space = Object(__WEBPACK_IMPORTED_MODULE_2__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_2__util_theme__["e" /* themeNamespace */]], spaceKey, 'afterItemSpacing');
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n    margin-left: ", "px;\n  "], space);
};

var After = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(BeforeAfterBase).withConfig({
  displayName: "ItemParts__After",
  componentId: "sc-14xek3m-3"
})(["\n  ", ";\n"], getAfterSpacing); // Alignment and layout for the children

var ContentWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "ItemParts__ContentWrapper",
  componentId: "sc-14xek3m-4"
})(["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  margin: 0;\n  overflow: hidden;\n\n  &:first-child {\n    margin: 0;\n  }\n"]);
var Content = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "ItemParts__Content",
  componentId: "sc-14xek3m-5"
})(["\n  display: block;\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: ", ";\n  line-height: ", ";\n  /* Fix windows line-height issue */\n  padding-bottom: 1px;\n"], function (_ref3) {
  var allowMultiline = _ref3.allowMultiline;
  return allowMultiline ? 'normal' : 'nowrap';
}, 16 / Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["fontSize"])());

var getColorStyle = function getColorStyle(_ref4) {
  var isDisabled = _ref4.isDisabled,
      theme = _ref4.theme;

  if (isDisabled) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n      color: ", ";\n    "], Object(__WEBPACK_IMPORTED_MODULE_2__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_2__util_theme__["e" /* themeNamespace */]], 'secondaryText', 'disabled'));
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n    color: ", ";\n\n    /* This detects hover on the grandparent. Saves us having to maintain isHovered\n       state in the grandparent. */\n    *:hover > * > & {\n      color: ", ";\n    }\n\n    *:active > * > & {\n      color: ", ";\n    }\n  "], Object(__WEBPACK_IMPORTED_MODULE_2__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_2__util_theme__["e" /* themeNamespace */]], 'secondaryText', 'default'), function () {
    return Object(__WEBPACK_IMPORTED_MODULE_2__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_2__util_theme__["e" /* themeNamespace */]], 'secondaryText', 'hover');
  }, function () {
    return Object(__WEBPACK_IMPORTED_MODULE_2__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_2__util_theme__["e" /* themeNamespace */]], 'secondaryText', 'active');
  });
};

var getDescriptionFontStyles = function getDescriptionFontStyles(_ref5) {
  var isCompact = _ref5.isCompact;
  var descriptionFontSize = isCompact ? __WEBPACK_IMPORTED_MODULE_2__util_theme__["b" /* compactSmallFontSize */] : Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["fontSizeSmall"])();
  var lineHeight = isCompact ? __WEBPACK_IMPORTED_MODULE_2__util_theme__["a" /* compactLineHeight */] : 14 / descriptionFontSize;
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n    font-size: ", "px;\n    line-height: ", ";\n    /* Fix windows line-height issue */\n    padding-bottom: 1px;\n  "], descriptionFontSize, lineHeight);
}; // Description is a block element below the children, like a subtitle


var Description = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "ItemParts__Description",
  componentId: "sc-14xek3m-6"
})(["\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  ", " ", ";\n"], getColorStyle, getDescriptionFontStyles);

/***/ }),
/* 2168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItemGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_addons_text_content__ = __webpack_require__(2169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_addons_text_content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_addons_text_content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styled_ItemGroup__ = __webpack_require__(2170);











var ItemGroup =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(ItemGroup, _Component);

  function ItemGroup() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ItemGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ItemGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "headingAfterElement", void 0);

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ItemGroup, [{
    key: "render",
    // eslint-disable-line react/sort-comp
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          elemAfter = _this$props.elemAfter,
          isCompact = _this$props.isCompact,
          title = _this$props.title,
          label = _this$props.label,
          innerRef = _this$props.innerRef,
          role = _this$props.role;

      var ariaLabel = function () {
        if (label) {
          return __WEBPACK_IMPORTED_MODULE_8_react_addons_text_content___default()(label);
        }

        if (title) {
          return __WEBPACK_IMPORTED_MODULE_8_react_addons_text_content___default()(title);
        }

        return '';
      }();

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", {
        "aria-label": ariaLabel,
        role: role,
        ref: innerRef
      }, title ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styled_ItemGroup__["a" /* GroupTitle */], {
        "aria-hidden": "true",
        isCompact: isCompact
      }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styled_ItemGroup__["c" /* GroupTitleText */], null, title), elemAfter ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styled_ItemGroup__["b" /* GroupTitleAfter */], {
        innerRef: function innerRef(r) {
          _this2.headingAfterElement = r;
        }
      }, elemAfter) : null) : null, children);
    }
  }]);

  return ItemGroup;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ItemGroup, "defaultProps", {
  role: 'group'
});



/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getText(rootChild) {
  var res = '';
  var rr = function rr(child) {
    if (typeof child === 'string' || typeof child === 'number') {
      res += child;
    } else if (Array.isArray(child)) {
      child.forEach(function (c) {
        return rr(c);
      });
    } else if (child && child.props) {
      var children = child.props.children;


      if (Array.isArray(children)) {
        children.forEach(function (c) {
          return rr(c);
        });
      } else {
        rr(children);
      }
    }
  };

  rr(rootChild);

  return res;
}

module.exports = getText;

/***/ }),
/* 2170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GroupTitleAfter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GroupTitleText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_theme__ = __webpack_require__(272);




var getPadding = function getPadding(_ref) {
  var isCompact = _ref.isCompact,
      theme = _ref.theme;
  var paddingType = isCompact ? 'compact' : 'default';

  var _getThemeStyle = Object(__WEBPACK_IMPORTED_MODULE_2__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_2__util_theme__["e" /* themeNamespace */]], paddingType, 'padding'),
      _getThemeStyle$bottom = _getThemeStyle.bottom,
      bottom = _getThemeStyle$bottom === void 0 ? 0 : _getThemeStyle$bottom,
      _getThemeStyle$left = _getThemeStyle.left,
      left = _getThemeStyle$left === void 0 ? 0 : _getThemeStyle$left,
      _getThemeStyle$right = _getThemeStyle.right,
      right = _getThemeStyle$right === void 0 ? 0 : _getThemeStyle$right,
      _getThemeStyle$top = _getThemeStyle.top,
      top = _getThemeStyle$top === void 0 ? 0 : _getThemeStyle$top;

  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n    padding: ", "px ", "px ", "px ", "px;\n  "], top, right, bottom, left);
}; // eslint-disable-next-line import/prefer-default-export


var GroupTitle = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "ItemGroup__GroupTitle",
  componentId: "ofbfv9-0"
})(["\n  align-items: center;\n  color: ", ";\n  display: flex;\n  flex: 1 1 auto;\n  ", ";\n"], function (_ref2) {
  var theme = _ref2.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_2__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_2__util_theme__["e" /* themeNamespace */]], 'secondaryText', 'default');
}, getPadding);
GroupTitle.displayName = 'ItemGroupTitle';
var GroupTitleAfter = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "ItemGroup__GroupTitleAfter",
  componentId: "ofbfv9-1"
})(["\n  flex: 0 0 auto;\n  margin-right: -", "px;\n"], __WEBPACK_IMPORTED_MODULE_2__util_theme__["d" /* gridSize */] / 2);
GroupTitleAfter.displayName = 'ItemGroupTitleAfter';
var GroupTitleText = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "ItemGroup__GroupTitleText",
  componentId: "ofbfv9-2"
})(["\n  flex: 1 1 auto;\n  font-size: ", "px;\n  line-height: 1;\n  text-transform: uppercase;\n  /* Required for children to truncate */\n  min-width: 0;\n"], __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["fontSizeSmall"]);
GroupTitleText.displayName = 'ItemGroupTitleText';


/***/ }),
/* 2171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_getDisplayName__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_safeContextCall__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_contextNamespace__ = __webpack_require__(757);









// We currently need to keep the dropdown open if an item with `href` is clicked, to avoid the
// analytics package to track the href value without the event target disappearing. Without this
// requirement, we could just use a native click event all the way up to DropdownMenuStateless,
// and could get rid of this HOC and DropdownItemClickManager.






// HOC that typically wraps @atlaskit/item
var withItemClick = function withItemClick(WrappedItem) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(WithItemClick, _Component);

    function WithItemClick() {
      var _getPrototypeOf2;

      var _this;

      __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, WithItemClick);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(WithItemClick)).call.apply(_getPrototypeOf2, [this].concat(args)));

      __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "callContextFn", Object(__WEBPACK_IMPORTED_MODULE_12__util_safeContextCall__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), __WEBPACK_IMPORTED_MODULE_13__util_contextNamespace__["a" /* clickManagerContext */]));

      __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "shouldCloseAfterClick", function () {
        return !_this.props.isDisabled && !_this.props.href;
      });

      __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleClick", function (event) {
        _this.props.onClick(event);

        if (_this.shouldCloseAfterClick()) {
          _this.callContextFn('itemClicked');
        }
      });

      __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleKeyDown", function (event) {
        if (_this.props.onKeyDown) {
          _this.props.onKeyDown(event);
        } else if (event.key === 'Space' || event.key === 'Enter') {
          _this.handleClick(event);
        }
      });

      return _this;
    }

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(WithItemClick, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            children = _this$props.children,
            otherProps = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_this$props, ["children"]);

        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(WrappedItem, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, otherProps, {
          onClick: this.handleClick,
          onKeyDown: this.handleKeyDown
        }), children);
      }
    }]);

    return WithItemClick;
  }(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]), __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(_class, "displayName", "WithItemClick(".concat(Object(__WEBPACK_IMPORTED_MODULE_11__util_getDisplayName__["a" /* default */])(WrappedItem), ")")), __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(_class, "defaultProps", {
    onClick: function onClick() {}
  }), __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(_class, "contextTypes", __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_13__util_contextNamespace__["a" /* clickManagerContext */], __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object)), _temp;
};

/* harmony default export */ __webpack_exports__["a"] = (withItemClick);

/***/ }),
/* 2172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_getDisplayName__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_safeContextCall__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_contextNamespace__ = __webpack_require__(757);

















var withItemFocus = function withItemFocus(WrappedComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(WithItemFocus, _Component);

    function WithItemFocus() {
      var _getPrototypeOf2;

      var _this;

      __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, WithItemFocus);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(WithItemFocus)).call.apply(_getPrototypeOf2, [this].concat(args)));

      __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "contextId", void 0);

      __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "callContextFn", Object(__WEBPACK_IMPORTED_MODULE_14__util_safeContextCall__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), __WEBPACK_IMPORTED_MODULE_15__util_contextNamespace__["b" /* focusManagerContext */]));

      __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "isFocusable", function () {
        return !_this.props.isDisabled && !_this.props.isHidden;
      });

      __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleFocus", function () {
        if (_this.isFocusable()) {
          _this.callContextFn('itemFocused', _this.contextId);
        }
      });

      return _this;
    }

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(WithItemFocus, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (!this.isFocusable()) {
          return;
        }

        this.contextId = __WEBPACK_IMPORTED_MODULE_12_uuid___default()();
        this.callContextFn('registerItem', this.contextId, __WEBPACK_IMPORTED_MODULE_11_react_dom___default.a.findDOMNode(this) // eslint-disable-line react/no-find-dom-node
        );
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        if (!this.isFocusable()) {
          return;
        }

        this.callContextFn('updateItem', this.contextId, __WEBPACK_IMPORTED_MODULE_11_react_dom___default.a.findDOMNode(this) // eslint-disable-line react/no-find-dom-node
        );
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.isFocusable()) {
          this.callContextFn('deregisterItem', this.contextId);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            children = _this$props.children,
            otherProps = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_this$props, ["children"]);

        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(WrappedComponent, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          onFocus: this.handleFocus,
          role: "menuitem"
        }, otherProps), children);
      }
    }]);

    return WithItemFocus;
  }(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]), __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(_class, "displayName", "WithItemFocus(".concat(Object(__WEBPACK_IMPORTED_MODULE_13__util_getDisplayName__["a" /* default */])(WrappedComponent), ")")), __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(_class, "contextTypes", __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_15__util_contextNamespace__["b" /* focusManagerContext */], __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object)), _temp;
};

/* harmony default export */ __webpack_exports__["a"] = (withItemFocus);

/***/ }),
/* 2173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DroplistItemWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_analytics_next__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_icon_glyph_radio__ = __webpack_require__(2174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_icon_glyph_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__atlaskit_icon_glyph_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__atlaskit_icon_glyph_checkbox__ = __webpack_require__(2176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__atlaskit_icon_glyph_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__atlaskit_icon_glyph_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__atlaskit_tooltip__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__package_json__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styled_Item__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils__ = __webpack_require__(2177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Element__ = __webpack_require__(2178);


















var inputTypes = {
  checkbox: __WEBPACK_IMPORTED_MODULE_12__atlaskit_icon_glyph_checkbox___default.a,
  radio: __WEBPACK_IMPORTED_MODULE_11__atlaskit_icon_glyph_radio___default.a
};

var Item =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Item, _PureComponent);

  function Item() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Item);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Item)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      isHovered: false,
      isPressed: false
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "componentDidMount", function () {
      return document.addEventListener('mouseup', _this.handleMouseUp);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "componentWillUnmount", function () {
      return document.removeEventListener('mouseup', _this.handleMouseUp);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "guardedActivate", function (event) {
      var _this$props = _this.props,
          isDisabled = _this$props.isDisabled,
          onActivate = _this$props.onActivate;
      if (!isDisabled && onActivate) onActivate({
        item: __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)),
        event: event
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleClick", function (event) {
      return _this.guardedActivate(event);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleKeyPress", function (event) {
      var keyIsValid = ['Enter', ' '].indexOf(event.key) > -1;
      if (keyIsValid) _this.guardedActivate(event);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleMouseDown", function () {
      return _this.setState({
        isPressed: true
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleMouseUp", function () {
      return _this.setState({
        isPressed: false
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleMouseOut", function () {
      return _this.setState({
        isHovered: false
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleMouseOver", function () {
      return _this.setState({
        isHovered: true
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Item, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var _this$state = this.state,
          isHovered = _this$state.isHovered,
          isPressed = _this$state.isPressed;
      var type = props.type || '';
      var hasInput = ['checkbox', 'radio'].indexOf(type) > -1;
      var Input = inputTypes[type];
      var appearanceProps = {
        isActive: props.type === 'link' && props.isActive || props.type === 'option' && props.isSelected,
        isChecked: ['checkbox', 'radio'].indexOf(type) > -1 && props.isChecked,
        isDisabled: props.isDisabled,
        isFocused: props.isFocused,
        isHidden: props.isHidden,
        isHovered: isHovered,
        isPressed: isPressed,
        isSelected: type === 'option' && props.isSelected,
        isPrimary: props.appearance === 'primary'
      };
      var element = __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Element__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, appearanceProps, {
        handleClick: this.handleClick,
        handleKeyPress: this.handleKeyPress,
        handleMouseOut: this.handleMouseOut,
        handleMouseOver: this.handleMouseOver,
        handleMouseUp: this.handleMouseUp,
        handleMouseDown: this.handleMouseDown,
        href: props.href,
        target: props.target,
        title: props.title,
        type: props.type
      }), hasInput && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styled_Item__["g" /* InputWrapper */], appearanceProps, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Input, {
        label: "",
        primaryColor: Object(__WEBPACK_IMPORTED_MODULE_16__utils__["a" /* getInputBackground */])(appearanceProps),
        secondaryColor: Object(__WEBPACK_IMPORTED_MODULE_16__utils__["b" /* getInputFill */])(appearanceProps),
        size: "medium"
      })), !!props.elemBefore && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styled_Item__["c" /* Before */], null, props.elemBefore), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styled_Item__["e" /* ContentWrapper */], null, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styled_Item__["d" /* Content */], {
        allowMultiline: this.context.shouldAllowMultilineItems
      }, props.children), !!props.description && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styled_Item__["f" /* Description */], null, props.description)), !!props.elemAfter && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styled_Item__["a" /* After */], null, props.elemAfter));
      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span", {
        role: "presentation"
      }, props.tooltipDescription ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__atlaskit_tooltip__["a" /* default */], {
        content: props.tooltipDescription,
        position: props.tooltipPosition
      }, element) : element);
    }
  }]);

  return Item;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Item, "defaultProps", {
  appearance: 'default',
  children: null,
  description: '',
  elemAfter: null,
  elemBefore: null,
  href: null,
  isActive: false,
  isChecked: false,
  isDisabled: false,
  isFocused: false,
  isHidden: false,
  isSelected: false,
  itemContext: 'menu',
  onActivate: function onActivate() {},
  target: null,
  title: null,
  tooltipDescription: null,
  tooltipPosition: 'right',
  type: 'link'
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Item, "contextTypes", {
  shouldAllowMultilineItems: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool
});


var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_10__atlaskit_analytics_next__["createAndFireEvent"])('atlaskit');
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__atlaskit_analytics_next__["withAnalyticsContext"])({
  componentName: 'droplistItem',
  packageName: __WEBPACK_IMPORTED_MODULE_14__package_json__["name"],
  packageVersion: __WEBPACK_IMPORTED_MODULE_14__package_json__["version"]
})(Object(__WEBPACK_IMPORTED_MODULE_10__atlaskit_analytics_next__["withAnalyticsEvents"])({
  onActivate: createAndFireEventOnAtlaskit({
    action: 'selected',
    actionSubject: 'droplistItem',
    attributes: {
      componentName: 'droplistItem',
      packageName: __WEBPACK_IMPORTED_MODULE_14__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_14__package_json__["version"]
    }
  })
})(Item)));

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(758));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var RadioIcon = function RadioIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill-rule=\"evenodd\"><circle fill=\"currentColor\" cx=\"12\" cy=\"12\" r=\"6\"/><circle fill=\"inherit\" cx=\"12\" cy=\"12\" r=\"2\"/></g></svg>"
  }, props));
};

RadioIcon.displayName = 'RadioIcon';
var _default = RadioIcon;
exports.default = _default;

/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = void 0;
var sizes = {
  small: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '48px'
};
exports.sizes = sizes;

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(758));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CheckboxIcon = function CheckboxIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill-rule=\"evenodd\"><rect fill=\"currentColor\" x=\"6\" y=\"6\" width=\"12\" height=\"12\" rx=\"2\"/><path d=\"M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z\" fill=\"inherit\"/></g></svg>"
  }, props));
};

CheckboxIcon.displayName = 'CheckboxIcon';
var _default = CheckboxIcon;
exports.default = _default;

/***/ }),
/* 2177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getInputBackground;
/* harmony export (immutable) */ __webpack_exports__["b"] = getInputFill;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);

function getInputBackground(_ref) {
  var isChecked = _ref.isChecked,
      isDisabled = _ref.isDisabled,
      isHovered = _ref.isHovered,
      isPressed = _ref.isPressed;
  var background = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N40;
  if (isHovered) background = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N50;
  if (isPressed) background = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200;
  if (isChecked) background = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400;
  if (isDisabled) background = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20;
  if (isChecked && isDisabled) background = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N600;
  return background;
}
function getInputFill(appearanceProps) {
  return appearanceProps.isChecked ? __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0 : 'transparent';
}

/***/ }),
/* 2178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export supportsVoiceOver */
/* unused harmony export getAriaRoles */
/* unused harmony export baseTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Element; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styled_Item__ = __webpack_require__(418);











var supportsVoiceOver = function supportsVoiceOver() {
  return /Mac OS X/.test(navigator.userAgent);
};
var getAriaRoles = function getAriaRoles() {
  return {
    checkbox: supportsVoiceOver() ? 'checkbox' : 'menuitemcheckbox',
    link: 'menuitem',
    option: 'option',
    radio: supportsVoiceOver() ? 'radio' : 'menuitemradio'
  };
};
var baseTypes = {
  default: 'link',
  values: ['link', 'radio', 'checkbox', 'option']
};

var Element =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Element, _PureComponent);

  function Element() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Element);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Element)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleMouseDown", function (e) {
      e.preventDefault();

      _this.props.handleMouseDown();
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Element, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var isActive = props.isActive,
          isChecked = props.isChecked,
          isDisabled = props.isDisabled,
          isFocused = props.isFocused,
          isHidden = props.isHidden,
          isSelected = props.isSelected,
          isPrimary = props.isPrimary;
      var type = this.props.type || '';
      var appearanceProps = {
        isActive: isActive,
        isChecked: isChecked,
        isDisabled: isDisabled,
        isFocused: isFocused,
        isHidden: isHidden,
        isSelected: isSelected,
        isPrimary: isPrimary
      };
      var ariaProps = {
        'aria-checked': !!isChecked,
        'aria-disabled': !!isDisabled,
        'aria-hidden': !!isHidden,
        'aria-selected': !!isSelected
      };
      var ariaRoles = getAriaRoles();
      var commonProps = {
        'data-role': 'droplistItem',
        onClick: props.handleClick,
        onKeyPress: props.handleKeyPress,
        onMouseDown: this.handleMouseDown,
        onMouseOut: props.handleMouseOut,
        onMouseOver: props.handleMouseOver,
        onMouseUp: props.handleMouseUp,
        role: ariaRoles[type],
        title: props.title,
        tabIndex: props.type === 'option' ? null : 0
      };
      var testingProps =  false ? {
        'data-test-active': isActive,
        'data-test-checked': isChecked,
        'data-test-disabled': isDisabled,
        'data-test-hidden': isHidden,
        'data-test-selected': isSelected
      } : {};

      var consolidatedProps = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, appearanceProps, ariaProps, commonProps, testingProps);

      if (props.href && !isDisabled) {
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styled_Item__["b" /* Anchor */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          href: props.href,
          target: props.target
        }, consolidatedProps), props.children);
      }

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styled_Item__["h" /* Span */], consolidatedProps, props.children);
    }
  }]);

  return Element;
}(__WEBPACK_IMPORTED_MODULE_9_react__["PureComponent"]);



/***/ }),
/* 2179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled_Group__ = __webpack_require__(2180);










var DroplistGroup =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(DroplistGroup, _PureComponent);

  function DroplistGroup() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, DroplistGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DroplistGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      ariaLabel: _this.props.heading
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "headingElement", void 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "componentDidMount", function () {
      if (_this.props.heading || _this.props.elemAfter) {
        _this.setState({
          ariaLabel: _this.getAriaLabel()
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "componentDidUpdate", function () {
      if (_this.props.heading || _this.props.elemAfter) {
        _this.setState({
          ariaLabel: _this.getAriaLabel()
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getAriaLabel", function () {
      var _this$props = _this.props,
          elemAfter = _this$props.elemAfter,
          heading = _this$props.heading;
      var afterText = elemAfter && typeof elemAfter === 'string' ? elemAfter : _this.headingElement && _this.headingElement.textContent;
      return "".concat(heading || '', " ").concat(afterText || '');
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(DroplistGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          elemAfter = _this$props2.elemAfter,
          heading = _this$props2.heading;
      var ariaLabel = this.state.ariaLabel;
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styled_Group__["d" /* default */], {
        "aria-label": ariaLabel,
        role: "group"
      }, heading ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styled_Group__["a" /* Heading */], {
        "aria-hidden": "true",
        "data-role": "droplistGroupHeading"
      }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styled_Group__["c" /* HeadingText */], null, heading), elemAfter ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styled_Group__["b" /* HeadingAfter */], {
        innerRef: function innerRef(r) {
          _this2.headingElement = r;
        }
      }, elemAfter) : null) : null, children);
    }
  }]);

  return DroplistGroup;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

DroplistGroup.displayName = 'Group';
/* harmony default export */ __webpack_exports__["a"] = (DroplistGroup);

/***/ }),
/* 2180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HeadingAfter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HeadingText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["d"] = (__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Group",
  componentId: "sc-1q26u8b-0"
})(["\n  box-sizing: border-box;\n  display: block;\n  margin-top: ", "px;\n\n  &:first-child {\n    margin-top: 0;\n  }\n"], __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"]));
var Heading = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Group__Heading",
  componentId: "sc-1q26u8b-1"
})(["\n  align-items: baseline;\n  color: ", ";\n  display: flex;\n  flex: 1 1 auto;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 1;\n  margin: 0;\n  padding: ", "px ", "px;\n"], Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N300,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN300
}), __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"], __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"], 1.5));
var HeadingAfter = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Group__HeadingAfter",
  componentId: "sc-1q26u8b-2"
})(["\n  flex: 0 0 auto;\n"]);
var HeadingText = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Group__HeadingText",
  componentId: "sc-1q26u8b-3"
})(["\n  flex: 1 1 auto;\n  font-size: 12px;\n  text-transform: uppercase;\n"]);

/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(419));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ChevronDownIcon = function ChevronDownIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

ChevronDownIcon.displayName = 'ChevronDownIcon';
var _default = ChevronDownIcon;
exports.default = _default;

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = void 0;
var sizes = {
  small: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '48px'
};
exports.sizes = sizes;

/***/ }),
/* 2183 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/dropdown-menu","version":"6.1.25","sideEffects":false}

/***/ }),
/* 2184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropdownItemFocusManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_contextNamespace__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_keys__ = __webpack_require__(420);












var DropdownItemFocusManager =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(DropdownItemFocusManager, _Component);

  function DropdownItemFocusManager() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, DropdownItemFocusManager);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DropdownItemFocusManager)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "registeredItems", []);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "focusedItemId", void 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleItemRegistered", function (itemId, itemNode) {
      _this.registeredItems.push({
        itemId: itemId,
        itemNode: itemNode
      });

      if (_this.props.autoFocus && _this.registeredItems.length === 1) {
        _this.focusedItemId = itemId;
        itemNode.focus();
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleItemDeregistered", function (itemId) {
      _this.registeredItems = _this.registeredItems.filter(function (item) {
        return item.itemId !== itemId;
      });
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleItemFocused", function (itemId) {
      _this.focusedItemId = itemId;
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleItemUpdated", function (itemId, itemNode) {
      var matchingIndex = -1;

      for (var i = 0; i < _this.registeredItems.length; i++) {
        if (_this.registeredItems[i].itemId === itemId) {
          matchingIndex = i;
          break;
        }
      }

      if (matchingIndex === -1) {
        _this.handleItemRegistered(itemId, itemNode);

        return;
      }

      _this.registeredItems[matchingIndex].itemNode = itemNode;

      if (_this.focusedItemIndex() === matchingIndex) {
        itemNode.focus();
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "focusedItemIndex", function () {
      var _assertThisInitialize = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)),
          focusedItemId = _assertThisInitialize.focusedItemId,
          registeredItems = _assertThisInitialize.registeredItems;

      for (var i = 0; i < registeredItems.length; i++) {
        if (registeredItems[i].itemId === focusedItemId) {
          return i;
        }
      }

      return -1;
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleKeyboard", function (event) {
      var key = event.key,
          shiftKey = event.shiftKey;

      var focusedItemIndex = _this.focusedItemIndex();

      if (key === __WEBPACK_IMPORTED_MODULE_10__util_keys__["e" /* KEY_UP */] || key === __WEBPACK_IMPORTED_MODULE_10__util_keys__["a" /* KEY_DOWN */]) {
        // We prevent default here to avoid page scrolling when up/down
        // pressed while dropdown is focused.
        event.preventDefault();

        if (focusedItemIndex < 0) {
          return;
        }

        var nextItemIndex = key === __WEBPACK_IMPORTED_MODULE_10__util_keys__["e" /* KEY_UP */] ? Math.max(0, focusedItemIndex - 1) : Math.min(_this.registeredItems.length - 1, focusedItemIndex + 1);

        _this.registeredItems[nextItemIndex].itemNode.focus();
      }

      if (key === __WEBPACK_IMPORTED_MODULE_10__util_keys__["d" /* KEY_TAB */]) {
        if (!shiftKey && focusedItemIndex === _this.registeredItems.length - 1) {
          if (_this.props.close) _this.props.close({
            event: event,
            source: 'keydown'
          });
        }

        if (shiftKey && focusedItemIndex === 0) {
          if (_this.props.close) _this.props.close({
            event: event,
            source: 'keydown'
          });
        }
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(DropdownItemFocusManager, [{
    key: "getChildContext",
    value: function getChildContext() {
      return __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_9__util_contextNamespace__["b" /* focusManagerContext */], {
        itemFocused: this.handleItemFocused,
        registerItem: this.handleItemRegistered,
        deregisterItem: this.handleItemDeregistered,
        updateItem: this.handleItemUpdated
      });
    }
  }, {
    key: "render",
    value: function render() {
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", {
        onKeyDown: this.handleKeyboard
      }, this.props.children);
    }
  }]);

  return DropdownItemFocusManager;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(DropdownItemFocusManager, "childContextTypes", __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_9__util_contextNamespace__["b" /* focusManagerContext */], __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object));



/***/ }),
/* 2185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropdownItemClickManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_contextNamespace__ = __webpack_require__(204);











var DropdownItemClickManager =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(DropdownItemClickManager, _Component);

  function DropdownItemClickManager() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, DropdownItemClickManager);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DropdownItemClickManager)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleItemClicked", function (event) {
      _this.props.onItemClicked(event);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(DropdownItemClickManager, [{
    key: "getChildContext",
    value: function getChildContext() {
      return __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_9__util_contextNamespace__["a" /* clickManagerContext */], {
        itemClicked: this.handleItemClicked
      });
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return DropdownItemClickManager;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(DropdownItemClickManager, "childContextTypes", __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_9__util_contextNamespace__["a" /* clickManagerContext */], __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object));



/***/ }),
/* 2186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropdownItemSelectionCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_array_find__ = __webpack_require__(2187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_contextNamespace__ = __webpack_require__(204);













var isItemInList = function isItemInList(itemList, itemId, groupId) {
  return Boolean(__WEBPACK_IMPORTED_MODULE_10_array_find___default()(itemList, function (item) {
    return item.id === itemId && item.groupId === groupId;
  }));
};

var DropdownItemSelectionCache =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(DropdownItemSelectionCache, _Component);

  function DropdownItemSelectionCache() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, DropdownItemSelectionCache);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(DropdownItemSelectionCache)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      lastCacheUpdate: 0
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "selectedItems", []);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "alreadyDefaultedItems", []);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleItemSelectionsChanged", function (groupId, newGroupSelections) {
      var newSelectedItems = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(_this.selectedItems.filter(function (item) {
        return item.groupId !== groupId;
      })).concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(newGroupSelections));

      _this.selectedItems = newSelectedItems; // We store selectedItems in an instance variable (this.selectedItems) instead of state,
      // because if multiple children update the cache at the same time it causes unexpected
      // behaviour due to the asynchronous behaviour of setState. So we need to trigger setState
      // with a different value to cause the children to be updated with their new selection values.

      _this.setState({
        lastCacheUpdate: Date.now()
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(DropdownItemSelectionCache, [{
    key: "getChildContext",
    // eslint-disable-line react/sort-comp
    value: function getChildContext() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_11__util_contextNamespace__["c" /* selectionCacheContext */], {
        // This function returns true/false describing whether the supplied navigation item
        // (which must have a unique item and group ID) is currently selected - this is used
        // by radio and checkbox dropdown items to retreive their 'selected' state when they
        // re-mount, which happens when the dropdown is closed and then re-opened.
        isItemSelected: function isItemSelected(groupId, itemId) {
          return isItemInList(_this2.selectedItems, itemId, groupId);
        },
        itemsInGroup: function itemsInGroup(groupId) {
          return _this2.selectedItems.filter(function (item) {
            return item.groupId === groupId;
          });
        },
        itemSelectionsChanged: this.handleItemSelectionsChanged,
        hasItemAlreadyHadDefaultSelectedApplied: function hasItemAlreadyHadDefaultSelectedApplied(groupId, itemId) {
          return isItemInList(_this2.alreadyDefaultedItems, itemId, groupId);
        },
        markItemAsDefaultApplied: function markItemAsDefaultApplied(groupId, itemId) {
          _this2.alreadyDefaultedItems.push({
            id: itemId,
            groupId: groupId
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", null, this.props.children);
    }
  }]);

  return DropdownItemSelectionCache;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(DropdownItemSelectionCache, "childContextTypes", __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_11__util_contextNamespace__["c" /* selectionCacheContext */], __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape({
  isItemSelected: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  itemsInGroup: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  itemSelectionsChanged: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
})));



/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function find(array, predicate, context) {
  if (typeof Array.prototype.find === 'function') {
    return array.find(predicate, context);
  }

  context = context || this;
  var length = array.length;
  var i;

  if (typeof predicate !== 'function') {
    throw new TypeError(predicate + ' is not a function');
  }

  for (i = 0; i < length; i++) {
    if (predicate.call(context, array[i], i, array)) {
      return array[i];
    }
  }
}

module.exports = find;


/***/ }),
/* 2188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "WidthConstrainer",
  componentId: "sc-15doeus-0"
})(["\n  ", ";\n"], function (_ref) {
  var shouldFitContainer = _ref.shouldFitContainer;
  return shouldFitContainer ? '' : 'max-width: 300px;';
}));

/***/ }),
/* 2189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_item__ = __webpack_require__(111);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_item__["d" /* withItemClick */])(Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_item__["e" /* withItemFocus */])(__WEBPACK_IMPORTED_MODULE_0__atlaskit_item__["b" /* default */])));

/***/ }),
/* 2190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_icon_glyph_radio__ = __webpack_require__(2191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_icon_glyph_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__atlaskit_icon_glyph_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_item__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hoc_withToggleInteraction__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_supportsVoiceover__ = __webpack_require__(761);




/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__hoc_withToggleInteraction__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_item__["e" /* withItemFocus */])(__WEBPACK_IMPORTED_MODULE_1__atlaskit_item__["b" /* default */]), __WEBPACK_IMPORTED_MODULE_0__atlaskit_icon_glyph_radio___default.a, function () {
  return Object(__WEBPACK_IMPORTED_MODULE_3__util_supportsVoiceover__["a" /* default */])() ? 'radio' : 'menuitemradio';
}));

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(419));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var RadioIcon = function RadioIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill-rule=\"evenodd\"><circle fill=\"currentColor\" cx=\"12\" cy=\"12\" r=\"6\"/><circle fill=\"inherit\" cx=\"12\" cy=\"12\" r=\"2\"/></g></svg>"
  }, props));
};

RadioIcon.displayName = 'RadioIcon';
var _default = RadioIcon;
exports.default = _default;

/***/ }),
/* 2192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// There are cases where the context is not available, such as when a dropdown item is used
// inside @atlaskit/navigation. For this reason we have this helper function which safely calls
// the context functions if they are available.
/* harmony default export */ __webpack_exports__["a"] = (function (instance, contextKey) {
  return function (fnToCall) {
    var _instance$context$con;

    if (!instance.context[contextKey]) {
      return null;
    }

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return (_instance$context$con = instance.context[contextKey])[fnToCall].apply(_instance$context$con, args);
  };
});

/***/ }),
/* 2193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_icon_glyph_checkbox__ = __webpack_require__(2194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_icon_glyph_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__atlaskit_icon_glyph_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_item__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hoc_withToggleInteraction__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_supportsVoiceover__ = __webpack_require__(761);




/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__hoc_withToggleInteraction__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_item__["e" /* withItemFocus */])(__WEBPACK_IMPORTED_MODULE_1__atlaskit_item__["b" /* default */]), __WEBPACK_IMPORTED_MODULE_0__atlaskit_icon_glyph_checkbox___default.a, function () {
  return Object(__WEBPACK_IMPORTED_MODULE_3__util_supportsVoiceover__["a" /* default */])() ? 'checkbox' : 'menuitemcheckbox';
}));

/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(419));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CheckboxIcon = function CheckboxIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill-rule=\"evenodd\"><rect fill=\"currentColor\" x=\"6\" y=\"6\" width=\"12\" height=\"12\" rx=\"2\"/><path d=\"M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z\" fill=\"inherit\"/></g></svg>"
  }, props));
};

CheckboxIcon.displayName = 'CheckboxIcon';
var _default = CheckboxIcon;
exports.default = _default;

/***/ }),
/* 2195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DropdownItemGroup__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hoc_withItemSelectionManager__ = __webpack_require__(762);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__hoc_withItemSelectionManager__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DropdownItemGroup__["a" /* default */], 'radio'));

/***/ }),
/* 2196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropdownItemSelectionManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_contextNamespace__ = __webpack_require__(204);












var DropdownItemSelectionManager =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(DropdownItemSelectionManager, _Component);

  function DropdownItemSelectionManager() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, DropdownItemSelectionManager);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(DropdownItemSelectionManager)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "setItemSelected", function (itemId, isSelected, defaultSelected) {
      var _this$props = _this.props,
          behavior = _this$props.behavior,
          groupId = _this$props.groupId;

      var setSelected = function setSelected(finalBool) {
        if (behavior === 'checkbox' || behavior === 'menuitemcheckbox') {
          _this.setCheckboxItemSelected(itemId, finalBool);
        } else if (behavior === 'radio' || behavior === 'menuitemradio') {
          _this.setRadioItemSelected(itemId, finalBool);
        }
      }; // If a radio or checkbox item has defaultSelected set on it, that it will try to set its
      // selected state to true each time it mounts (which happens whenever the dropdown is re-
      // opened by the user. The following check makes sure that the defaultSelected behaviour
      // only applies on the first mount of the radio/checkbox.


      if (typeof isSelected === 'boolean') {
        // If isSelected is explicitly provided, set it to that
        setSelected(isSelected);
      } else if (defaultSelected) {
        if (!_this.hasAlreadyAppliedDefaultSelected(itemId)) {
          // If using defaultSelected and this is first mount, select the item
          setSelected(true);

          _this.context[__WEBPACK_IMPORTED_MODULE_10__util_contextNamespace__["c" /* selectionCacheContext */]].markItemAsDefaultApplied(groupId, itemId);
        } else {
          // If using defaultSelected and not first mount, set isSelected to cached value
          setSelected(_this.isItemSelectedInCache(itemId));
        }
      } else {
        setSelected(_this.isItemSelectedInCache(itemId));
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "setCheckboxItemSelected", function (itemId, isSelected) {
      var cache = _this.context[__WEBPACK_IMPORTED_MODULE_10__util_contextNamespace__["c" /* selectionCacheContext */]];
      var alreadySelected = cache.itemsInGroup(_this.props.groupId);
      var isAlreadySelected = cache.isItemSelected(_this.props.groupId, itemId);

      if (isSelected && !isAlreadySelected) {
        _this.updateCacheContextWithSelections(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(alreadySelected).concat([{
          id: itemId,
          groupId: _this.props.groupId
        }]));
      } else if (!isSelected && isAlreadySelected) {
        var withoutCurrentItem = alreadySelected.filter(function (item) {
          return item.id !== itemId;
        });

        _this.updateCacheContextWithSelections(withoutCurrentItem);
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "setRadioItemSelected", function (itemId, isSelected) {
      var cache = _this.context[__WEBPACK_IMPORTED_MODULE_10__util_contextNamespace__["c" /* selectionCacheContext */]];
      var isAlreadySelected = cache.isItemSelected(_this.props.groupId, itemId);

      if (isAlreadySelected && !isSelected) {
        _this.updateCacheContextWithSelections([]);
      } else if (!isAlreadySelected && isSelected) {
        _this.updateCacheContextWithSelections([{
          id: itemId,
          groupId: _this.props.groupId
        }]);
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "isItemSelectedInCache", function (itemId) {
      return _this.context[__WEBPACK_IMPORTED_MODULE_10__util_contextNamespace__["c" /* selectionCacheContext */]].isItemSelected(_this.props.groupId, itemId);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleItemClicked", function (clickedItemId) {
      var behavior = _this.props.behavior;

      if (behavior === 'checkbox' || behavior === 'menuitemcheckbox') {
        _this.handleCheckboxItemClicked(clickedItemId);
      } else if (behavior === 'radio' || behavior === 'menuitemradio') {
        _this.handleRadioItemClicked(clickedItemId);
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "hasAlreadyAppliedDefaultSelected", function (itemId) {
      return _this.context[__WEBPACK_IMPORTED_MODULE_10__util_contextNamespace__["c" /* selectionCacheContext */]].hasItemAlreadyHadDefaultSelectedApplied(_this.props.groupId, itemId);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleCheckboxItemClicked", function (clickedItemId) {
      var cache = _this.context[__WEBPACK_IMPORTED_MODULE_10__util_contextNamespace__["c" /* selectionCacheContext */]];
      var itemsInGroup = cache.itemsInGroup(_this.props.groupId);
      var newSelections = cache.isItemSelected(_this.props.groupId, clickedItemId) ? itemsInGroup.filter(function (item) {
        return item.id !== clickedItemId;
      }) : __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(itemsInGroup).concat([{
        id: clickedItemId,
        groupId: _this.props.groupId
      }]);

      _this.updateCacheContextWithSelections(newSelections);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleRadioItemClicked", function (clickedItemId) {
      _this.updateCacheContextWithSelections([{
        id: clickedItemId,
        groupId: _this.props.groupId
      }]);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "updateCacheContextWithSelections", function (itemSelections) {
      _this.context[__WEBPACK_IMPORTED_MODULE_10__util_contextNamespace__["c" /* selectionCacheContext */]].itemSelectionsChanged(_this.props.groupId, itemSelections);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(DropdownItemSelectionManager, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_10__util_contextNamespace__["d" /* selectionManagerContext */], {
        isItemSelected: function isItemSelected(itemId) {
          return _this2.context[__WEBPACK_IMPORTED_MODULE_10__util_contextNamespace__["c" /* selectionCacheContext */]].isItemSelected(_this2.props.groupId, itemId);
        },
        itemClicked: this.handleItemClicked,
        setItemSelected: this.setItemSelected
      });
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", null, this.props.children);
    }
  }]);

  return DropdownItemSelectionManager;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(DropdownItemSelectionManager, "childContextTypes", __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_10__util_contextNamespace__["d" /* selectionManagerContext */], __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object));

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(DropdownItemSelectionManager, "contextTypes", __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_10__util_contextNamespace__["c" /* selectionCacheContext */], __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object.isRequired));



/***/ }),
/* 2197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DropdownItemGroup__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hoc_withItemSelectionManager__ = __webpack_require__(762);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__hoc_withItemSelectionManager__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DropdownItemGroup__["a" /* default */], 'checkbox'));

/***/ }),
/* 2198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_avatar__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styled_MoreIndicator__ = __webpack_require__(2199);








/* eslint-disable react/no-unused-prop-types, react/prop-types, react/sort-comp */



var MAX_DISPLAY_COUNT = 99;

var MoreIndicator =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(MoreIndicator, _Component);

  function MoreIndicator() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, MoreIndicator);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(MoreIndicator).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(MoreIndicator, [{
    key: "render",
    value: function render() {
      var count = this.props.count;
      var outerProps = Object(__WEBPACK_IMPORTED_MODULE_8__atlaskit_avatar__["g" /* getProps */])(this);
      var _this$props = this.props,
          appearance = _this$props.appearance,
          isActive = _this$props.isActive,
          isFocus = _this$props.isFocus,
          isHover = _this$props.isHover,
          size = _this$props.size;
      var innerProps = {
        appearance: appearance,
        isActive: isActive,
        isFocus: isFocus,
        isHover: isHover,
        size: size
      };
      var displayCount = count > MAX_DISPLAY_COUNT ? MAX_DISPLAY_COUNT : count;
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styled_MoreIndicator__["b" /* Outer */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, outerProps, {
        isInteractive: true
      }), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styled_MoreIndicator__["a" /* Inner */], innerProps, "+", displayCount));
    }
  }]);

  return MoreIndicator;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(MoreIndicator, "defaultProps", {
  appearance: 'circle'
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__atlaskit_avatar__["h" /* withPseudoState */])(MoreIndicator));

/***/ }),
/* 2199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Outer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Inner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_avatar__ = __webpack_require__(48);



var EXCESS_INDICATOR_FONT_SIZE = {
  small: 10,
  medium: 11,
  large: 12,
  xlarge: 16
};

var getBorderWidth = function getBorderWidth(p) {
  return p.isFocus && !p.isActive ? "".concat(__WEBPACK_IMPORTED_MODULE_2__atlaskit_avatar__["b" /* BORDER_WIDTH */][p.size], "px") : 0;
};

var Outer = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["withTheme"])(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].button.withConfig({
  displayName: "MoreIndicator__Outer",
  componentId: "sc-1l94pmy-0"
})(["\n  ", " background: 0;\n"], __WEBPACK_IMPORTED_MODULE_2__atlaskit_avatar__["f" /* getInnerStyles */]));
var Inner = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["withTheme"])(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "MoreIndicator__Inner",
  componentId: "sc-1l94pmy-1"
})(["\n  background-color: ", ";\n  border-radius: ", ";\n  align-items: center;\n  box-shadow: 0 0 0 ", " ", ";\n  color: ", ";\n  cursor: pointer;\n  display: flex;\n  flex-basis: 100%;\n  flex-grow: 1;\n  font-size: ", "px;\n  justify-content: center;\n  transition: box-shadow 200ms;\n"], Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N40,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN70
}), __WEBPACK_IMPORTED_MODULE_2__atlaskit_avatar__["e" /* getBorderRadius */], getBorderWidth, __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].B200, Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N500,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN400
}), function (props) {
  return EXCESS_INDICATOR_FONT_SIZE[props.size];
}));

/***/ }),
/* 2200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_item__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



var dropdownPadding = {
  bottom: 1,
  left: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 1.5),
  right: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 1.5),
  top: 1
}; // Override specific parts of droplist's item theme

var avatarItemTheme = {
  borderRadius: '0px',
  default: {
    background: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].backgroundOnLayer,
    text: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N900
  },
  active: {
    text: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N900,
    background: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].backgroundActive
  },
  padding: {
    default: dropdownPadding,
    compact: dropdownPadding
  }
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__atlaskit_item__["c" /* itemThemeNamespace */], avatarItemTheme));

/***/ }),
/* 2201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_dropdown_menu__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_avatar__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styled_AvatarGroup__ = __webpack_require__(763);











var AvatarGroupItem =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(AvatarGroupItem, _Component);

  function AvatarGroupItem() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, AvatarGroupItem);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(AvatarGroupItem).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(AvatarGroupItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          avatar = _this$props.avatar,
          onAvatarClick = _this$props.onAvatarClick;
      var borderColor = Object(__WEBPACK_IMPORTED_MODULE_9__styled_AvatarGroup__["c" /* getBackgroundColor */])(this.props);
      var enhancedProps = Object(__WEBPACK_IMPORTED_MODULE_8__atlaskit_avatar__["g" /* getProps */])(this);
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__atlaskit_dropdown_menu__["a" /* DropdownItem */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        isInteractive: true
      }, enhancedProps, {
        elemBefore: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__atlaskit_avatar__["d" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, avatar, {
          borderColor: borderColor,
          enableTooltip: false,
          size: "small"
        })),
        href: avatar.href,
        onClick: function onClick(event) {
          if (typeof onAvatarClick === 'function') {
            onAvatarClick({
              event: event,
              item: avatar
            });
          }
        },
        rel: avatar.target ? 'noopener noreferrer' : null,
        target: avatar.target
      }), avatar.name);
    }
  }]);

  return AvatarGroupItem;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__atlaskit_avatar__["h" /* withPseudoState */])(AvatarGroupItem));

/***/ }),
/* 2202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Image; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(101);



var Image = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].img(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", " ", ";\n\n  /* hide the alt text when the image cannot be found */\n  overflow: hidden;\n"], ["\n  ", " ", ";\n\n  /* hide the alt text when the image cannot be found */\n  overflow: hidden;\n"])), function (_a) {
    var size = _a.size;
    return Object(__WEBPACK_IMPORTED_MODULE_2__mixins__["g" /* size */])(size);
}, __WEBPACK_IMPORTED_MODULE_2__mixins__["b" /* borderRadius */]);
var templateObject_1;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(91));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var LinkIcon = function LinkIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M12.856 5.457l-.937.92a1.002 1.002 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47\"/><path d=\"M11.144 19.543l.937-.92a1.002 1.002 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47\"/></g></svg>"
  }, props));
};

LinkIcon.displayName = 'LinkIcon';
var _default = LinkIcon;
exports.default = _default;

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = void 0;
var sizes = {
  small: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '48px'
};
exports.sizes = sizes;

/***/ }),
/* 2205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExpandedFrame; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled__ = __webpack_require__(2206);



var ExpandedFrame = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ExpandedFrame, _super);
    function ExpandedFrame() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (event) {
            var onClick = _this.props.onClick;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick();
            }
        };
        return _this;
    }
    Object.defineProperty(ExpandedFrame.prototype, "isInteractive", {
        get: function () {
            var _a = this.props, isPlaceholder = _a.isPlaceholder, href = _a.href, onClick = _a.onClick;
            return !isPlaceholder && (Boolean(href) || Boolean(onClick));
        },
        enumerable: true,
        configurable: true
    });
    ExpandedFrame.prototype.renderHeader = function () {
        var _a = this.props, _b = _a.isPlaceholder, isPlaceholder = _b === void 0 ? false : _b, icon = _a.icon, text = _a.text;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["b" /* Header */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["c" /* IconWrapper */], { isPlaceholder: isPlaceholder }, !isPlaceholder && icon),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["e" /* TextWrapper */], { isPlaceholder: isPlaceholder }, !isPlaceholder && text)));
    };
    ExpandedFrame.prototype.renderContent = function () {
        var isInteractive = this.isInteractive;
        var children = this.props.children;
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["a" /* Content */], { isInteractive: isInteractive }, children);
    };
    ExpandedFrame.prototype.render = function () {
        var isInteractive = this.isInteractive;
        var _a = this.props, isPlaceholder = _a.isPlaceholder, isSelected = _a.isSelected, href = _a.href, minWidth = _a.minWidth, maxWidth = _a.maxWidth;
        if (!isPlaceholder && href) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["d" /* LinkWrapper */], { target: "_blank", rel: "noopener", className: __WEBPACK_IMPORTED_MODULE_2__styled__["g" /* className */], isInteractive: isInteractive, isSelected: isSelected, href: href, minWidth: minWidth, maxWidth: maxWidth, onClick: this.handleClick },
                this.renderHeader(),
                this.renderContent()));
        }
        else {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["f" /* Wrapper */], { className: __WEBPACK_IMPORTED_MODULE_2__styled__["g" /* className */], isInteractive: isInteractive, isSelected: isSelected, minWidth: minWidth, maxWidth: maxWidth, onClick: this.handleClick },
                this.renderHeader(),
                this.renderContent()));
        }
    };
    return ExpandedFrame;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 2206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return className; });
/* unused harmony export cardShadow */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LinkWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IconWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TextWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Content; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(101);




var wrapperPadding = 8;
var className = 'media-card-frame';
var cardShadow = "\n  box-shadow: 0 0 1px 0 rgba(23, 43, 77, 0.24);";
function minWidth(_a) {
    var minWidth = _a.minWidth;
    if (minWidth) {
        return "min-width: " + minWidth + "px;";
    }
    else {
        return '';
    }
}
function maxWidth(_a) {
    var maxWidth = _a.maxWidth;
    if (maxWidth) {
        return "max-width: " + maxWidth + "px;";
    }
    else {
        return '';
    }
}
function interactive(_a) {
    var isInteractive = _a.isInteractive;
    if (isInteractive) {
        return "\n      cursor: pointer;\n      &:hover {\n        background-color: " + __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorN30"] + ";\n      }\n      &:active {\n        background-color: " + __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorB50"] + ";\n      }\n    ";
    }
    else {
        return '';
    }
}
function selected(_a) {
    var isSelected = _a.isSelected;
    return isSelected
        ? "&::after {\n        cursor: pointer;\n        box-shadow: 0 0 0 2px " + __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorB100"] + ";\n        content: '';\n        outline: none;\n        position: absolute;\n        height: 100%;\n        width: 100%;\n        left: 0;\n      }"
        : '';
}
var wrapperStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", " ", " ", " ", " display: inline-flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  font-family: ", ";\n  padding: 0 ", "px ", "px ", "px;\n  width: 100%;\n  user-select: none;\n  background-color: ", ";\n  line-height: initial;\n  transition: background 0.3s;\n  position: relative;\n  ", "\n"], ["\n  ", " ", " ", " ", " display: inline-flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  font-family: ", ";\n  padding: 0 ", "px ", "px ", "px;\n  width: 100%;\n  user-select: none;\n  background-color: ", ";\n  line-height: initial;\n  transition: background 0.3s;\n  position: relative;\n  ", "\n"])), __WEBPACK_IMPORTED_MODULE_3__mixins__["b" /* borderRadius */], minWidth, maxWidth, interactive, __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akFontFamily"], wrapperPadding, wrapperPadding, wrapperPadding, __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorN20"], selected);
// export interface ContentProps {
//   maxWidth?: number;
// }
var LinkWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].a(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", " &:hover {\n    text-decoration: none;\n  }\n"], ["\n  ", " &:hover {\n    text-decoration: none;\n  }\n"])), wrapperStyles);
var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", ";\n"], ["\n  ", ";\n"])), wrapperStyles);
var Header = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  height: 32px;\n  display: flex;\n  align-items: center;\n  color: ", ";\n"], ["\n  height: 32px;\n  display: flex;\n  align-items: center;\n  color: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorN300"]);
var IconWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_5 || (templateObject_5 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", " ", " ", " margin-right: 4px;\n"], ["\n  ", " ", " ",
    " margin-right: 4px;\n"])), __WEBPACK_IMPORTED_MODULE_3__mixins__["b" /* borderRadius */], Object(__WEBPACK_IMPORTED_MODULE_3__mixins__["g" /* size */])(16), function (_a) {
    var isPlaceholder = _a.isPlaceholder;
    if (isPlaceholder) {
        return "\n      background-color: " + __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorN30"] + ";\n    ";
    }
    else {
        return '';
    }
});
var TextWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_6 || (templateObject_6 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", " color: ", ";\n  font-size: 12px;\n  line-height: 16px;\n  ", ";\n"], ["\n  ",
    " color: ", ";\n  font-size: 12px;\n  line-height: 16px;\n  ", ";\n"])), function (_a) {
    var isPlaceholder = _a.isPlaceholder;
    if (isPlaceholder) {
        return "\n        " + __WEBPACK_IMPORTED_MODULE_3__mixins__["b" /* borderRadius */] + "\n        width: 125px;\n        height: 12px;\n        background-color: " + __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorN30"] + ";\n      ";
    }
    else {
        return '';
    }
}, __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorN300"], Object(__WEBPACK_IMPORTED_MODULE_3__mixins__["e" /* ellipsis */])('none'));
var Content = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_7 || (templateObject_7 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  position: relative;\n\n  ", " ", " background-color: white;\n  transition: box-shadow 0.3s;\n\n  ", ";\n"], ["\n  position: relative;\n\n  ", " ", " background-color: white;\n  transition: box-shadow 0.3s;\n\n  ",
    ";\n"])), __WEBPACK_IMPORTED_MODULE_3__mixins__["b" /* borderRadius */], cardShadow, function (_a) {
    var isInteractive = _a.isInteractive;
    if (isInteractive) {
        return "\n          ." + className + ":hover & {\n            box-shadow: 0 4px 8px -2px rgba(23, 43, 77, 0.32),\n              0 0 1px rgba(23, 43, 77, 0.25);\n          }\n        ";
    }
    else {
        return '';
    }
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ellipsify__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styled__ = __webpack_require__(2208);






var contentWidthWhenCardIs400px = 384;
var AlertView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AlertView, _super);
    function AlertView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.handleRetry = function (event) {
            var onRetry = _this.props.onRetry;
            if (onRetry) {
                event.preventDefault();
                event.stopPropagation();
                onRetry();
            }
        };
        _this.handleDismis = function (event) {
            var onDismis = _this.props.onDismis;
            if (onDismis) {
                event.preventDefault();
                event.stopPropagation();
                onDismis();
            }
        };
        _this.handleMount = function (el) {
            if (el) {
                _this.el = el;
            }
        };
        _this.handleResize = __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__(function () {
            if (_this.el) {
                _this.setState({ width: _this.el.clientWidth });
            }
        }, 250);
        return _this;
    }
    AlertView.prototype.componentDidMount = function () {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    };
    AlertView.prototype.componentWillUnMount = function () {
        window.removeEventListener('resize', this.handleResize);
    };
    AlertView.prototype.renderContent = function () {
        var _a = this.props, type = _a.type, text = _a.text;
        var width = this.state.width;
        var txt = type === 'success' ? text : 'Something went wrong.';
        if (width && width < contentWidthWhenCardIs400px) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ellipsify__["a" /* Ellipsify */], { text: txt, lines: 2, inline: true });
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ellipsify__["a" /* Ellipsify */], { text: txt, lines: 1, inline: true });
        }
    };
    AlertView.prototype.renderRetryAndCancel = function () {
        var type = this.props.type;
        if (type === 'success') {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_button__["default"], { appearance: "link", spacing: "none", onClick: this.handleRetry }, "Try again"),
            ' ',
            "or",
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_button__["default"], { appearance: "link", spacing: "none", onClick: this.handleDismis }, "cancel"),
            "."));
    };
    AlertView.prototype.render = function () {
        var _a = this.props, type = _a.type, style = _a.style;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styled__["a" /* Wrapper */], { innerRef: this.handleMount, type: type, style: style },
            this.renderContent(),
            " ",
            this.renderRetryAndCancel()));
    };
    return AlertView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (AlertView);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(101);




var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: 7px 4px;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center;\n  line-height: 18px;\n  pointer-events: all;\n  ", " ", ";\n"], ["\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: 7px 4px;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center;\n  line-height: 18px;\n  pointer-events: all;\n  ", " ",
    ";\n"])), __WEBPACK_IMPORTED_MODULE_3__mixins__["c" /* borderRadiusBottom */], function (_a) {
    var type = _a.type;
    if (type === 'failure') {
        return "\n        color: " + __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorN600"] + ";\n        background-color: " + __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorY300"] + ";\n      ";
    }
    else {
        return "\n        color: " + __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorN0"] + ";\n        background-color: " + __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorG300"] + ";\n      ";
    }
});
var templateObject_1;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LoadingView */
/* unused harmony export NoImageView */
/* unused harmony export LoadedView */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PreviewView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_render_image__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_render_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_render_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_image__ = __webpack_require__(2210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NoImageIcon__ = __webpack_require__(2211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styled__ = __webpack_require__(2212);






var LoadingView = function () { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styled__["a" /* IconWrapper */], null,
    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_image___default.a, { size: "xlarge", label: "loading" }))); };
var NoImageView = function () { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styled__["a" /* IconWrapper */], null,
    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__NoImageIcon__["a" /* default */], null))); };
var LoadedView = function (_a) {
    var url = _a.url;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styled__["b" /* ImageWrapper */], { url: url }));
};
var PreviewView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](PreviewView, _super);
    function PreviewView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PreviewView.prototype.renderContent = function () {
        var url = this.props.url;
        if (!url) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](NoImageView, null);
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_render_image___default.a, { src: url, loading: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](LoadingView, null), loaded: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](LoadedView, { url: url }), errored: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](NoImageView, null) }));
    };
    PreviewView.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styled__["c" /* Wrapper */], null, this.renderContent());
    };
    return PreviewView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(91));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ImageIcon = function ImageIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M3 4.995C3 3.893 3.893 3 4.995 3h14.01C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.005V4.995zM10.5 16.5L9 15l-3 3h12v-2.7L15 12l-4.5 4.5zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

ImageIcon.displayName = 'ImageIcon';
var _default = ImageIcon;
exports.default = _default;

/***/ }),
/* 2211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

// TODO: This file should be removed as soon as we get the new Icons in @atlaskit/icon
// MD-33
/* harmony default export */ __webpack_exports__["a"] = (function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg", { width: "55px", height: "55px", viewBox: "0 0 55 55", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("defs", null),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g", { id: "Link---mvp-(no-social-footer)", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g", { id: "link-2-line-title-without-image-loaded", transform: "translate(-195.000000, -139.000000)", fill: "currentColor" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g", { id: "Card-content---NYT-Copy-6", transform: "translate(32.000000, 32.000000)" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", { d: "M167.775561,152.965565 L167.775561,117.798518 L167.775561,117.798518 C167.775561,114.472131 170.472131,111.775561 173.798518,111.775561 L173.798518,111.775561 L208.965565,111.775561 L212.859085,107.882042 L212.859085,107.882042 C214.03514,106.705986 215.941903,106.705986 217.117958,107.882042 L217.117958,107.882042 C218.294014,109.058097 218.294014,110.96486 217.117958,112.140915 L168.140915,161.117958 C166.96486,162.294014 165.058097,162.294014 163.882042,161.117958 C162.705986,159.941903 162.705986,158.03514 163.882042,156.859085 L163.882042,156.859085 L167.775561,152.965565 Z M185.482662,151.928604 L187.852083,151.928604 L207.928604,151.928604 L207.928604,144.701056 L200.68175,136.729517 L215.959213,121.452054 L215.959213,153.936257 L215.959213,153.936257 C215.959213,157.262644 213.262644,159.959213 209.936257,159.959213 L177.452054,159.959213 L185.482662,151.928604 Z M181.829126,131.852083 C185.155513,131.852083 187.852083,129.155513 187.852083,125.829126 C187.852083,122.502739 185.155513,119.80617 181.829126,119.80617 C178.502739,119.80617 175.80617,122.502739 175.80617,125.829126 C175.80617,129.155513 178.502739,131.852083 181.829126,131.852083 Z", id: "Combined-Shape-Copy-3" })))))); });
//# sourceMappingURL=NoImageIcon.js.map

/***/ }),
/* 2212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ImageWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(101);




var borderRadius = "border-radius: 3px 3px 0 0;";
var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  position: relative;\n  height: 0;\n  padding-bottom: 56.25%;\n  color: ", ";\n  ", " background-color: ", ";\n  ", ";\n"], ["\n  position: relative;\n  height: 0;\n  padding-bottom: 56.25%;\n  color: ", ";\n  ", " background-color: ", ";\n  ", ";\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorN40A"], borderRadius, __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorN30"], __WEBPACK_IMPORTED_MODULE_3__mixins__["f" /* fadeIn */]);
var IconWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"])));
var ImageWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  ", " ", ";\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  ", " ",
    ";\n"])), borderRadius, function (_a) {
    var url = _a.url;
    return "\n    background-image: url(" + url + ");\n    background-repeat: no-repeat, repeat;\n    background-position: center, center;\n    background-size: cover, auto;\n  ";
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_badge__ = __webpack_require__(2214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_lozenge__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_tooltip__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ImageIcon__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styled__ = __webpack_require__(2216);







var Widgets = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Widgets, _super);
    function Widgets() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Widgets.prototype.renderTitle = function (title) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styled__["b" /* Title */], { key: "title" },
            title,
            ":");
    };
    Widgets.prototype.renderIcon = function (icon) {
        if (typeof icon === 'string') {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ImageIcon__["a" /* ImageIcon */], { key: "icon", src: icon, size: 16 });
        }
        else {
            return icon;
        }
    };
    Widgets.prototype.renderBadge = function (badge) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_badge__["a" /* default */], { key: "badge", appearance: badge.appearance || 'default', value: badge.value, max: badge.max }));
    };
    Widgets.prototype.renderLozenge = function (lozenge) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_lozenge__["default"], { key: "lozenge", appearance: lozenge.appearance || 'default', isBold: lozenge.isBold }, lozenge.text));
    };
    Widgets.prototype.renderText = function (text) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styled__["a" /* Text */], { key: "text" }, text);
    };
    Widgets.prototype.renderWidgetDetails = function (attrs, tooltip) {
        if (tooltip) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_tooltip__["a" /* default */], { content: tooltip },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styled__["c" /* WidgetDetails */], null, attrs)));
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styled__["c" /* WidgetDetails */], null, attrs);
        }
    };
    Widgets.prototype.renderWidget = function (key, detail) {
        var title = detail.title, text = detail.text, icon = detail.icon, badge = detail.badge, lozenge = detail.lozenge, tooltip = detail.tooltip;
        var attrs = [];
        if (title) {
            attrs.push(this.renderTitle(title));
        }
        if (icon) {
            attrs.push(this.renderIcon(icon));
        }
        if (badge) {
            attrs.push(this.renderBadge(badge));
        }
        if (lozenge) {
            attrs.push(this.renderLozenge(lozenge));
        }
        if (text) {
            attrs.push(this.renderText(text));
        }
        if (attrs.length === 0) {
            // tslint:disable-next-line
            console.warn("Widgets: A widget doesn't contain any supported attributes: " + JSON.stringify(attrs, null, 2));
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styled__["d" /* WidgetWrapper */], { key: key }, this.renderWidgetDetails(attrs, tooltip)));
    };
    Widgets.prototype.render = function () {
        var _this = this;
        var _a = this.props.details, details = _a === void 0 ? [] : _a;
        if (details.length === 0) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styled__["e" /* Wrapper */], null, details.map(function (detail, index) { return _this.renderWidget(index, detail); })));
    };
    return Widgets;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Widgets);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__(2215);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Container__ = __webpack_require__(766);
/* unused harmony reexport Container */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Format__ = __webpack_require__(767);
/* unused harmony reexport Format */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme__ = __webpack_require__(768);
/* unused harmony reexport backgroundColors */
/* unused harmony reexport textColors */





/***/ }),
/* 2215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Badge; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Container__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Format__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__theme__ = __webpack_require__(768);












var Badge =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Badge, _Component);

  function Badge() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Badge);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Badge).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Badge, [{
    key: "componentWillUpdate",
    // TODO This can be removed when we remove support for onValueUpdated.
    value: function componentWillUpdate(nextProps) {
      var _this$props = this.props,
          children = _this$props.children,
          onValueUpdated = _this$props.onValueUpdated,
          value = _this$props.value;
      var oldValue = children;
      var newValue = nextProps.children; // This allows us to still prefer the value prop to maintain backward
      // compatibility.

      if (value != null) {
        oldValue = value;
      }

      if (nextProps.value != null) {
        newValue = nextProps.value;
      }

      if (onValueUpdated && newValue !== oldValue) {
        onValueUpdated({
          oldValue: oldValue,
          newValue: newValue
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__theme__["a" /* Theme */].Provider, {
        value: this.props.theme
      }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__atlaskit_theme__["default"].Consumer, null, function (_ref) {
        var mode = _ref.mode;
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__theme__["a" /* Theme */].Consumer, {
          appearance: props.appearance,
          mode: mode
        }, function (tokens) {
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Container__["a" /* Container */], tokens, typeof props.children === 'string' ? props.children : __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Format__["a" /* Format */], {
            max: props.max
          }, props.value || props.children));
        });
      }));
    }
  }]);

  return Badge;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(Badge, "displayName", 'Ak.Badge');

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(Badge, "defaultProps", {
  appearance: 'default',
  children: 0,
  max: 99,
  onValueUpdated: function onValueUpdated() {},
  value: undefined
});



/***/ }),
/* 2216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return WidgetWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WidgetDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Text; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(101);




var widgetHeight = 24;
var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  flex-grow: 1;\n  flex-wrap: wrap;\n  margin-top: 3px;\n\n  max-height: ", "px;\n  overflow: hidden;\n\n  & > * {\n    margin-right: 12px;\n  }\n  & > *:last-child {\n    margin-right: auto;\n  }\n"], ["\n  display: flex;\n  flex-grow: 1;\n  flex-wrap: wrap;\n  margin-top: 3px;\n\n  max-height: ", "px;\n  overflow: hidden;\n\n  & > * {\n    margin-right: 12px;\n  }\n  & > *:last-child {\n    margin-right: auto;\n  }\n"])), widgetHeight * 2);
var WidgetWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  height: ", "px;\n  max-width: calc(100% - (2 * 12px));\n"], ["\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  height: ", "px;\n  max-width: calc(100% - (2 * 12px));\n"])), widgetHeight);
var WidgetDetails = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  align-items: center;\n\n  /* space the widget items */\n  & > * + * {\n    margin-left: 4px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n\n  /* space the widget items */\n  & > * + * {\n    margin-left: 4px;\n  }\n"])));
var Title = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  color: ", ";\n  font-size: 12px;\n  line-height: ", ";\n"], ["\n  color: ", ";\n  font-size: 12px;\n  line-height: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorN300"], 16 / 12);
var Text = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_5 || (templateObject_5 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", ";\n  color: ", ";\n  font-size: 12px;\n  line-height: ", ";\n"], ["\n  ", ";\n  color: ", ";\n  font-size: 12px;\n  line-height: ", ";\n"])), Object(__WEBPACK_IMPORTED_MODULE_3__mixins__["e" /* ellipsis */])('none'), __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorN800"], 16 / 12);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return maxAvatarCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ContentWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LeftWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RightWrapper; });
/* unused harmony export FooterWrapper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Byline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Description; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return IconWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Thumbnail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UsersWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AlertWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(101);




var thumbnailWidth = 40;
var maxAvatarCount = 6;
var ContentWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  flex-direction: row;\n  box-sizing: border-box;\n  padding: 8px 12px 12px 12px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  box-sizing: border-box;\n  padding: 8px 12px 12px 12px;\n"])));
var LeftWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  /* FIXME: top padding dependent on content */\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  margin-top: 4px;\n  margin-right: 8px;\n  min-width: ", "px;\n"], ["\n  /* FIXME: top padding dependent on content */\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  margin-top: 4px;\n  margin-right: 8px;\n  min-width: ", "px;\n"])), thumbnailWidth);
var RightWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  flex-grow: 1;\n  min-width: 0; /* for Chrome ellipsis */\n  flex-basis: 0; /* for IE ellipsis */\n"], ["\n  flex-grow: 1;\n  min-width: 0; /* for Chrome ellipsis */\n  flex-basis: 0; /* for IE ellipsis */\n"])));
var FooterWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  margin-top: 8px;\n"], ["\n  display: flex;\n  margin-top: 8px;\n"])));
var Title = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_5 || (templateObject_5 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  color: ", ";\n  font-size: 16px;\n  font-weight: 500;\n  line-height: ", ";\n  max-height: ", "px;\n  overflow: hidden;\n"], ["\n  color: ", ";\n  font-size: 16px;\n  font-weight: 500;\n  line-height: ", ";\n  max-height: ", "px;\n  overflow: hidden;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N900, 20 / 16, 20 * 4);
var Byline = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_6 || (templateObject_6 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin-top: 4px;\n  color: ", ";\n  font-size: 12px;\n  font-weight: normal;\n  line-height: ", ";\n  ", ";\n"], ["\n  margin-top: 4px;\n  color: ", ";\n  font-size: 12px;\n  font-weight: normal;\n  line-height: ", ";\n  ", ";\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N300, 16 / 12, Object(__WEBPACK_IMPORTED_MODULE_3__mixins__["e" /* ellipsis */])('100%'));
var Description = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_7 || (templateObject_7 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin-top: 7px;\n  color: ", ";\n  font-size: 12px;\n  font-weight: normal;\n  line-height: ", ";\n  max-height: ", "px;\n  overflow: hidden;\n"], ["\n  margin-top: 7px;\n  color: ", ";\n  font-size: 12px;\n  font-weight: normal;\n  line-height: ", ";\n  max-height: ", "px;\n  overflow: hidden;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N800, 18 / 12, 18 * 3);
var IconWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_8 || (templateObject_8 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin-top: 4px;\n"], ["\n  margin-top: 4px;\n"])));
var Thumbnail = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_9 || (templateObject_9 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", " ", " float: right;\n  margin: 4px 0 12px 12px;\n  background-color: ", ";\n  background-image: url(", ");\n  background-size: cover;\n"], ["\n  ", " ", " float: right;\n  margin: 4px 0 12px 12px;\n  background-color: ", ";\n  background-image: url(", ");\n  background-size: cover;\n"])), __WEBPACK_IMPORTED_MODULE_3__mixins__["b" /* borderRadius */], Object(__WEBPACK_IMPORTED_MODULE_3__mixins__["g" /* size */])(48), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30, function (_a) {
    var src = _a.src;
    return src;
});
var UsersWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_10 || (templateObject_10 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin-top: 8px;\n"], ["\n  margin-top: 8px;\n"])));
var ActionsWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_11 || (templateObject_11 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin-top: 8px;\n  text-align: right;\n\n  > * {\n    margin-top: 4px;\n  }\n\n  > * + * {\n    margin-left: 4px;\n  }\n"], ["\n  margin-top: 8px;\n  text-align: right;\n\n  > * {\n    margin-top: 4px;\n  }\n\n  > * + * {\n    margin-left: 4px;\n  }\n"])));
var AlertWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_12 || (templateObject_12 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  overflow: hidden;\n  pointer-events: none;\n  /* z-index has to be 1 higher than the number of avatars in the avatar stack */\n  z-index: ", ";\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  overflow: hidden;\n  pointer-events: none;\n  /* z-index has to be 1 higher than the number of avatars in the avatar stack */\n  z-index: ", ";\n"])), maxAvatarCount + 1);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group_Transition__ = __webpack_require__(2219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_transition_group_Transition__);



var styles = {
    enter: {
        fade: {
            entering: {
                opacity: '0',
            },
            entered: {
                opacity: '1',
            },
        },
        'slide-up': {
            entering: {
                transform: 'translate(0, 100%)',
            },
            entered: {
                transform: 'translate(0, 0)',
            },
        },
    },
    exit: {
        fade: {
            exiting: {
                opacity: '1',
            },
            exited: {
                opacity: '0',
            },
        },
        'slide-down': {
            exiting: {
                transform: 'translate(0, 0)',
            },
            exited: {
                transform: 'translate(0, 100%)',
            },
        },
    },
};
function getStyle(type, name, state) {
    return (styles && styles[type] && styles[type][name] && styles[type][name][state]);
}
var Transition = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Transition, _super);
    function Transition(props) {
        var _this = _super.call(this, props) || this;
        _this.handleExited = function () {
            var _a = _this.props, timeout = _a.timeout, children = _a.children;
            window.setTimeout(function () {
                return _this.setState({
                    visible: false,
                    children: children,
                });
            }, timeout); // FIXME: hmm not sure why we have to wait - it should have already finished
        };
        _this.state = {
            visible: props.children !== null,
            children: props.children,
        };
        return _this;
    }
    Transition.prototype.componentWillReceiveProps = function (nextProps) {
        var nextChildren = nextProps.children;
        var prevChildren = this.props.children;
        // when exiting, show the old element until the transition is finished - otherwise the Alert changes mid-transition
        if (nextChildren !== prevChildren) {
            if (nextChildren === null) {
                this.setState({
                    visible: false,
                });
            }
            else {
                this.setState({
                    visible: true,
                    children: nextChildren,
                });
            }
        }
    };
    Transition.prototype.getStyle = function (status) {
        var _a = this.props, _b = _a.enter, enter = _b === void 0 ? [] : _b, _c = _a.exit, exit = _c === void 0 ? [] : _c, timeout = _a.timeout;
        if (status === 'entering') {
            return enter.reduce(function (accum, name) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, accum, getStyle('enter', name, 'entering'))); }, {});
        }
        if (status === 'entered') {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, enter.reduce(function (accum, name) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, accum, getStyle('enter', name, 'entering'))); }, {}), enter.reduce(function (accum, name) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, accum, getStyle('enter', name, 'entered'))); }, {}), { transition: "all " + timeout + "ms ease-in-out" });
        }
        if (status === 'exiting') {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, exit.reduce(function (accum, name) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, accum, getStyle('exit', name, 'exiting'))); }, {}));
        }
        if (status === 'exited') {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, exit.reduce(function (accum, name) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, accum, getStyle('exit', name, 'exiting'))); }, {}), exit.reduce(function (accum, name) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, accum, getStyle('exit', name, 'exited'))); }, {}), { transition: "all " + timeout + "ms ease-in-out" });
        }
        return {};
    };
    Transition.prototype.render = function () {
        var _this = this;
        var timeout = this.props.timeout;
        var _a = this.state, visible = _a.visible, children = _a.children;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_transition_group_Transition___default.a, { appear: true, enter: true, exit: true, in: visible, timeout: timeout, onExited: this.handleExited }, function (status) {
            if (children) {
                return __WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"](children, {
                    style: _this.getStyle(status),
                });
            }
            else {
                return children;
            }
        }));
    };
    return Transition;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Transition);
//# sourceMappingURL=Transition.js.map

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(18));

var _reactLifecyclesCompat = __webpack_require__(72);

var _PropTypes = __webpack_require__(2220);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts(); // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing); // FIXME: appear timeout?


      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }

      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    var pt = process.env.NODE_ENV !== "production" ? _PropTypes.timeoutsShape : {};;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.transitionTimeout = transitionTimeout;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(10));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;
  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.'); // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number
}).isRequired]);

exports.timeoutsShape = timeoutsShape;

var classNamesShape = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]);

exports.classNamesShape = classNamesShape;

/***/ }),
/* 2221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlockCardErroredView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_warning__ = __webpack_require__(2222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CollapsedFrame__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dimensions__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CollapsedIconTitleDescriptionLayout__ = __webpack_require__(423);








var BlockCardErroredView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](BlockCardErroredView, _super);
    function BlockCardErroredView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleRetry = function (event) {
            var onRetry = _this.props.onRetry;
            if (onRetry) {
                event.preventDefault();
                event.stopPropagation();
                onRetry();
            }
        };
        return _this;
    }
    BlockCardErroredView.prototype.render = function () {
        var _a = this.props, url = _a.url, message = _a.message, onClick = _a.onClick, onRetry = _a.onRetry, isSelected = _a.isSelected;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__CollapsedFrame__["a" /* CollapsedFrame */], { isSelected: isSelected, minWidth: __WEBPACK_IMPORTED_MODULE_6__dimensions__["b" /* minWidth */], maxWidth: __WEBPACK_IMPORTED_MODULE_6__dimensions__["a" /* maxWidth */], onClick: onClick },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__CollapsedIconTitleDescriptionLayout__["a" /* CollapsedIconTitleDescriptionLayout */], { icon: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_warning___default.a, { label: "error", size: "medium", primaryColor: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["colors"].Y300 }), title: url, description: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                    message,
                    ' ',
                    onRetry && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_button__["default"], { appearance: "link", spacing: "none", onClick: this.handleRetry }, "Try again"))) })));
    };
    return BlockCardErroredView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(91));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var WarningIcon = function WarningIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill-rule=\"evenodd\"><path d=\"M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771L12.938 4.967z\" fill=\"currentColor\"/><path d=\"M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2\" fill=\"inherit\"/></g></svg>"
  }, props));
};

WarningIcon.displayName = 'WarningIcon';
var _default = WarningIcon;
exports.default = _default;

/***/ }),
/* 2223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MultiLineLayout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled__ = __webpack_require__(2224);



var MultiLineLayout = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MultiLineLayout, _super);
    function MultiLineLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MultiLineLayout.prototype.render = function () {
        var _a = this.props, left = _a.left, middle = _a.middle, right = _a.right;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["d" /* Wrapper */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["a" /* Left */], null, left),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["b" /* Middle */], null, middle),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["c" /* Right */], null, right)));
    };
    return MultiLineLayout;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 2224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Left; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Middle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Right; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 3px 8px;\n  > * + * {\n    margin-left: 8px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 3px 8px;\n  > * + * {\n    margin-left: 8px;\n  }\n"])));
var Left = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  > * {\n    /* hack to vertically center the spinner which is display: inline-block; */\n    display: inline-flex;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  > * {\n    /* hack to vertically center the spinner which is display: inline-block; */\n    display: inline-flex;\n  }\n"])));
var Middle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex-grow: 1;\n  overflow: hidden;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex-grow: 1;\n  overflow: hidden;\n"])));
var Right = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n"], ["\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Description; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(101);




var Title = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  color: ", ";\n  font-size: 14px;\n  font-weight: 500;\n  line-height: ", ";\n  margin-bottom: 2px;\n  ", ";\n"], ["\n  color: ", ";\n  font-size: 14px;\n  font-weight: 500;\n  line-height: ", ";\n  margin-bottom: 2px;\n  ", ";\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N800, 16 / 14, Object(__WEBPACK_IMPORTED_MODULE_3__mixins__["e" /* ellipsis */])('100%'));
var Description = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  color: ", ";\n  font-size: 12px;\n  font-weight: normal;\n  line-height: ", ";\n  margin-bottom: 2px;\n  ", ";\n"], ["\n  color: ", ";\n  font-size: 12px;\n  font-weight: normal;\n  line-height: ", ";\n  margin-bottom: 2px;\n  ", ";\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N300, 16 / 12, Object(__WEBPACK_IMPORTED_MODULE_3__mixins__["e" /* ellipsis */])('100%'));
var templateObject_1, templateObject_2;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlockCardForbiddenView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_lock_filled__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_lock_filled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_lock_filled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CollapsedFrame__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dimensions__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CollapsedIconTitleDescriptionLayout__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled__ = __webpack_require__(2227);









var BlockCardForbiddenView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](BlockCardForbiddenView, _super);
    function BlockCardForbiddenView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleAuthorise = function (event) {
            var onAuthorise = _this.props.onAuthorise;
            if (onAuthorise) {
                event.preventDefault();
                event.stopPropagation();
                onAuthorise();
            }
        };
        return _this;
    }
    BlockCardForbiddenView.prototype.render = function () {
        var _a = this.props, url = _a.url, onClick = _a.onClick, onAuthorise = _a.onAuthorise, isSelected = _a.isSelected;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__CollapsedFrame__["a" /* CollapsedFrame */], { isSelected: isSelected, minWidth: __WEBPACK_IMPORTED_MODULE_6__dimensions__["b" /* minWidth */], maxWidth: __WEBPACK_IMPORTED_MODULE_6__dimensions__["a" /* maxWidth */], onClick: onClick },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__CollapsedIconTitleDescriptionLayout__["a" /* CollapsedIconTitleDescriptionLayout */], { icon: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styled__["a" /* IconBackground */], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_lock_filled___default.a, { label: "forbidden", size: "medium", primaryColor: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N0 })), title: url, description: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                    "You don't have permission to view this.",
                    ' ',
                    onAuthorise && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_button__["default"], { appearance: "link", spacing: "none", onClick: this.handleAuthorise }, "Try another account"))) })));
    };
    return BlockCardForbiddenView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 2227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconBackground; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(101);




var IconBackground = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", "\n  ", "\n  background-color: ", ";\n"], ["\n  ", "\n  ", "\n  background-color: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_3__mixins__["b" /* borderRadius */], Object(__WEBPACK_IMPORTED_MODULE_3__mixins__["g" /* size */])(24), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B200);
var templateObject_1;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlockCardUnauthorisedView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CollapsedFrame__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dimensions__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CollapsedIconTitleDescriptionLayout__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ImageIcon__ = __webpack_require__(422);







var BlockCardUnauthorisedView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](BlockCardUnauthorisedView, _super);
    function BlockCardUnauthorisedView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleAuthorise = function (event) {
            var onAuthorise = _this.props.onAuthorise;
            if (onAuthorise) {
                event.preventDefault();
                event.stopPropagation();
                onAuthorise();
            }
        };
        return _this;
    }
    BlockCardUnauthorisedView.prototype.render = function () {
        var _a = this.props, icon = _a.icon, url = _a.url, onClick = _a.onClick, onAuthorise = _a.onAuthorise, isSelected = _a.isSelected;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__CollapsedFrame__["a" /* CollapsedFrame */], { isSelected: isSelected, minWidth: __WEBPACK_IMPORTED_MODULE_4__dimensions__["b" /* minWidth */], maxWidth: __WEBPACK_IMPORTED_MODULE_4__dimensions__["a" /* maxWidth */], onClick: onClick },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__CollapsedIconTitleDescriptionLayout__["a" /* CollapsedIconTitleDescriptionLayout */], { icon: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ImageIcon__["a" /* ImageIcon */], { src: icon, size: 24 }), title: url, description: "Connect your account to see a link preview", other: onAuthorise && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_button__["default"], { appearance: "subtle", spacing: "compact", onClick: this.handleAuthorise }, "Connect")) })));
    };
    return BlockCardUnauthorisedView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 2229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ResolvingView__ = __webpack_require__(2230);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__ResolvingView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResolvedView__ = __webpack_require__(2234);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__ResolvedView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ErroredView__ = __webpack_require__(2235);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__ErroredView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ForbiddenView__ = __webpack_require__(2237);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__ForbiddenView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UnauthorisedView__ = __webpack_require__(2239);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__UnauthorisedView__["a"]; });





//# sourceMappingURL=index.js.map

/***/ }),
/* 2230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InlineCardResolvingView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Frame__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_spinner__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IconAndTitleLayout__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styled__ = __webpack_require__(2233);






var InlineCardResolvingView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](InlineCardResolvingView, _super);
    function InlineCardResolvingView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InlineCardResolvingView.prototype.render = function () {
        var _a = this.props, url = _a.url, onClick = _a.onClick, isSelected = _a.isSelected;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Frame__["a" /* Frame */], { onClick: onClick, isSelected: isSelected },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconAndTitleLayout__["a" /* IconAndTitleLayout */], { icon: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styled__["a" /* SpinnerWrapper */], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_spinner__["a" /* default */], { size: 16 })), title: url })));
    };
    return InlineCardResolvingView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 2231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(49);




var selected = "\n  cursor: pointer;\n  box-shadow: 0 0 0 2px " + __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B100 + ";\n  outline: none;\n  &, :hover, :focus, :active {\n    text-decoration: none;\n  }\n";
var isInteractive = function (_a) {
    var isInteractive = _a.isInteractive;
    if (isInteractive) {
        return "\n      cursor: pointer;\n      :hover {\n        background-color: " + __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N20 + ";\n        text-decoration: none;\n      }\n      :active {\n        background-color: " + __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B50 + ";\n        text-decoration: none;\n      }\n      :focus {\n        " + selected + "\n        text-decoration: none;\n      }\n    ";
    }
    else {
        return '';
    }
};
var isSelected = function (_a) {
    var isSelected = _a.isSelected;
    if (isSelected) {
        return selected;
    }
    else {
        return '';
    }
};
var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].a(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  line-height: ", ";\n  margin: 2px 2px 2px 0;\n  padding: 1px 2px 2px 2px;\n  border-radius: ", "px;\n  user-select: none;\n  ", " ", ";\n"], ["\n  line-height: ", ";\n  margin: 2px 2px 2px 0;\n  padding: 1px 2px 2px 2px;\n  border-radius: ", "px;\n  user-select: none;\n  ", " ", ";\n"])), 16 / 14, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])(), isInteractive, isSelected);
var templateObject_1;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OtherWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var IconWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  vertical-align: middle;\n  display: inline-flex;\n  overflow: hidden;\n  margin-right: 5px;\n"], ["\n  vertical-align: middle;\n  display: inline-flex;\n  overflow: hidden;\n  margin-right: 5px;\n"])));
var OtherWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin-left: 4px;\n  display: inline-block;\n  vertical-align: text-bottom;\n"], ["\n  margin-left: 4px;\n  display: inline-block;\n  vertical-align: text-bottom;\n"])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpinnerWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var SpinnerWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: inline-flex;\n  width: 16px;\n  height: 16px;\n  vertical-align: middle;\n  margin-right: 3px;\n"], ["\n  display: inline-flex;\n  width: 16px;\n  height: 16px;\n  vertical-align: middle;\n  margin-right: 3px;\n"])));
var templateObject_1;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InlineCardResolvedView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Frame__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_lozenge__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IconAndTitleLayout__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon__ = __webpack_require__(770);






var InlineCardResolvedView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](InlineCardResolvedView, _super);
    function InlineCardResolvedView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InlineCardResolvedView.prototype.renderIcon = function () {
        var icon = this.props.icon;
        if (!icon) {
            return null;
        }
        if (typeof icon === 'string') {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icon__["a" /* Icon */], { src: icon });
        }
        return icon;
    };
    InlineCardResolvedView.prototype.renderLozenge = function () {
        var lozenge = this.props.lozenge;
        if (!lozenge) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_lozenge__["default"], { appearance: lozenge.appearance || 'default', isBold: lozenge.isBold }, lozenge.text));
    };
    InlineCardResolvedView.prototype.render = function () {
        var _a = this.props, title = _a.title, isSelected = _a.isSelected, onClick = _a.onClick, link = _a.link;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Frame__["a" /* Frame */], { link: link, isSelected: isSelected, onClick: onClick },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconAndTitleLayout__["a" /* IconAndTitleLayout */], { icon: this.renderIcon(), title: title }, this.renderLozenge())));
    };
    return InlineCardResolvedView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 2235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InlineCardErroredView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_error__ = __webpack_require__(2236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Frame__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IconAndTitleLayout__ = __webpack_require__(206);








var InlineCardErroredView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](InlineCardErroredView, _super);
    function InlineCardErroredView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleRetry = function (event) {
            var onRetry = _this.props.onRetry;
            if (onRetry) {
                event.preventDefault();
                event.stopPropagation();
                onRetry();
            }
        };
        return _this;
    }
    InlineCardErroredView.prototype.render = function () {
        var _a = this.props, url = _a.url, message = _a.message, onClick = _a.onClick, onRetry = _a.onRetry, isSelected = _a.isSelected;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Frame__["a" /* Frame */], { onClick: onClick, isSelected: isSelected },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__IconAndTitleLayout__["a" /* IconAndTitleLayout */], { icon: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_error___default.a, { label: "error", size: "medium", primaryColor: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R300 }), title: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { style: { color: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R300 } }, Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* truncateUrlForErrorView */])(url) + ' - ' + message.trim()) }),
            ' ',
            onRetry && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_button__["default"], { spacing: "none", appearance: "link", onClick: this.handleRetry }, "Try again"))));
    };
    return InlineCardErroredView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(91));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ErrorIcon = function ErrorIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill-rule=\"evenodd\"><path d=\"M13.416 4.417a2.002 2.002 0 0 0-2.832 0l-6.168 6.167a2.002 2.002 0 0 0 0 2.833l6.168 6.167a2.002 2.002 0 0 0 2.832 0l6.168-6.167a2.002 2.002 0 0 0 0-2.833l-6.168-6.167z\" fill=\"currentColor\"/><path d=\"M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2\" fill=\"inherit\"/></g></svg>"
  }, props));
};

ErrorIcon.displayName = 'ErrorIcon';
var _default = ErrorIcon;
exports.default = _default;

/***/ }),
/* 2237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InlineCardForbiddenView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_lock_filled__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_lock_filled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_lock_filled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Frame__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IconAndTitleLayout__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled__ = __webpack_require__(2238);









var InlineCardForbiddenView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](InlineCardForbiddenView, _super);
    function InlineCardForbiddenView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleRetry = function (event) {
            var onAuthorise = _this.props.onAuthorise;
            if (onAuthorise) {
                event.preventDefault();
                event.stopPropagation();
                onAuthorise();
            }
        };
        return _this;
    }
    InlineCardForbiddenView.prototype.render = function () {
        var _a = this.props, url = _a.url, onClick = _a.onClick, isSelected = _a.isSelected;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Frame__["a" /* Frame */], { onClick: onClick, isSelected: isSelected },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__IconAndTitleLayout__["a" /* IconAndTitleLayout */], { icon: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styled__["a" /* LockIconWrapper */], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_lock_filled___default.a, { label: "error", size: "medium", primaryColor: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B400 })), title: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* truncateUrlForErrorView */])(url) +
                    " - You don't have permissions to view" }),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_button__["default"], { spacing: "none", appearance: "link", onClick: this.handleRetry }, "Try another account")));
    };
    return InlineCardForbiddenView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 2238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LockIconWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var LockIconWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin-top: -3px;\n  height: 23px;\n  width: 23px;\n"], ["\n  margin-top: -3px;\n  height: 23px;\n  width: 23px;\n"])));
var templateObject_1;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InlineCardUnauthorizedView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IconAndTitleLayout__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Frame__ = __webpack_require__(205);







var InlineCardUnauthorizedView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](InlineCardUnauthorizedView, _super);
    function InlineCardUnauthorizedView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleConnectAccount = function (event) {
            var onAuthorise = _this.props.onAuthorise;
            event.preventDefault();
            event.stopPropagation();
            return onAuthorise();
        };
        return _this;
    }
    InlineCardUnauthorizedView.prototype.render = function () {
        var _a = this.props, url = _a.url, icon = _a.icon, onClick = _a.onClick, isSelected = _a.isSelected, onAuthorise = _a.onAuthorise;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Frame__["a" /* Frame */], { onClick: onClick, isSelected: isSelected },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__IconAndTitleLayout__["a" /* IconAndTitleLayout */], { icon: typeof icon === 'string' ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Icon__["a" /* Icon */], { src: icon }) : icon, title: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* truncateUrlForErrorView */])(url) }),
            !onAuthorise ? ('') : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                ' - ',
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_button__["default"], { spacing: "none", appearance: "link", onClick: this.handleConnectAccount }, "Connect your account to preview links")))));
    };
    return InlineCardUnauthorizedView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 2240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardLinkView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled__ = __webpack_require__(2241);



var CardLinkView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CardLinkView, _super);
    function CardLinkView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (event) {
            var onClick = _this.props.onClick;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick();
            }
        };
        return _this;
    }
    CardLinkView.prototype.render = function () {
        var text = this.props.text;
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["a" /* Link */], { onClick: this.handleClick }, text);
    };
    return CardLinkView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 2241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var Link = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].a(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  cursor: pointer;\n  margin: 2px;\n"], ["\n  cursor: pointer;\n  margin: 2px;\n"])));
var templateObject_1;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toHumanReadableMediaSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bytes__ = __webpack_require__(2243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bytes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bytes__);

// tslint:disable-next-line:no-bitwise
var ONE_MEGABYTE_IN_BYTES = 1 << 20;
/**
 * Takes a media (file) size in bytes and returns a human readable string
 */
function toHumanReadableMediaSize(size) {
    // [MS-967]: Api issue might return string for size
    var parsedSize = parseInt("" + size, 10);
    var decimalPlaces = parsedSize < ONE_MEGABYTE_IN_BYTES ? 0 : 1;
    return __WEBPACK_IMPORTED_MODULE_0_bytes__["format"](parsedSize, {
        unitSeparator: ' ',
        decimalPlaces: decimalPlaces,
    })
        .toUpperCase();
}
//# sourceMappingURL=humanReadableSize.js.map

/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * bytes
 * Copyright(c) 2012-2014 TJ Holowaychuk
 * Copyright(c) 2015 Jed Watson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

module.exports = bytes;
module.exports.format = format;
module.exports.parse = parse;

/**
 * Module variables.
 * @private
 */

var formatThousandsRegExp = /\B(?=(\d{3})+(?!\d))/g;

var formatDecimalsRegExp = /(?:\.0*|(\.[^0]+)0+)$/;

var map = {
  b:  1,
  kb: 1 << 10,
  mb: 1 << 20,
  gb: 1 << 30,
  tb: ((1 << 30) * 1024)
};

// TODO: use is-finite module?
var numberIsFinite = Number.isFinite || function (v) { return typeof v === 'number' && isFinite(v); };

var parseRegExp = /^((-|\+)?(\d+(?:\.\d+)?)) *(kb|mb|gb|tb)$/i;

/**
 * Convert the given value in bytes into a string or parse to string to an integer in bytes.
 *
 * @param {string|number} value
 * @param {{
 *  case: [string],
 *  decimalPlaces: [number]
 *  fixedDecimals: [boolean]
 *  thousandsSeparator: [string]
 *  unitSeparator: [string]
 *  }} [options] bytes options.
 *
 * @returns {string|number|null}
 */

function bytes(value, options) {
  if (typeof value === 'string') {
    return parse(value);
  }

  if (typeof value === 'number') {
    return format(value, options);
  }

  return null;
}

/**
 * Format the given value in bytes into a string.
 *
 * If the value is negative, it is kept as such. If it is a float,
 * it is rounded.
 *
 * @param {number} value
 * @param {object} [options]
 * @param {number} [options.decimalPlaces=2]
 * @param {number} [options.fixedDecimals=false]
 * @param {string} [options.thousandsSeparator=]
 * @param {string} [options.unit=]
 * @param {string} [options.unitSeparator=]
 *
 * @returns {string|null}
 * @public
 */

function format(value, options) {
  if (!numberIsFinite(value)) {
    return null;
  }

  var mag = Math.abs(value);
  var thousandsSeparator = (options && options.thousandsSeparator) || '';
  var unitSeparator = (options && options.unitSeparator) || '';
  var decimalPlaces = (options && options.decimalPlaces !== undefined) ? options.decimalPlaces : 2;
  var fixedDecimals = Boolean(options && options.fixedDecimals);
  var unit = (options && options.unit) || '';

  if (!unit || !map[unit.toLowerCase()]) {
    if (mag >= map.tb) {
      unit = 'TB';
    } else if (mag >= map.gb) {
      unit = 'GB';
    } else if (mag >= map.mb) {
      unit = 'MB';
    } else if (mag >= map.kb) {
      unit = 'kB';
    } else {
      unit = 'B';
    }
  }

  var val = value / map[unit.toLowerCase()];
  var str = val.toFixed(decimalPlaces);

  if (!fixedDecimals) {
    str = str.replace(formatDecimalsRegExp, '$1');
  }

  if (thousandsSeparator) {
    str = str.replace(formatThousandsRegExp, thousandsSeparator);
  }

  return str + unitSeparator + unit;
}

/**
 * Parse the string value into an integer in bytes.
 *
 * If no unit is given, it is assumed the value is in bytes.
 *
 * @param {number|string} val
 *
 * @returns {number|null}
 * @public
 */

function parse(val) {
  if (typeof val === 'number' && !isNaN(val)) {
    return val;
  }

  if (typeof val !== 'string') {
    return null;
  }

  // Test if the string passed is valid
  var results = parseRegExp.exec(val);
  var floatValue;
  var unit = 'b';

  if (!results) {
    // Nothing could be extracted from the given string
    floatValue = parseInt(val, 10);
    unit = 'b'
  } else {
    // Retrieve the value and the unit
    floatValue = parseFloat(results[1]);
    unit = results[4].toLowerCase();
  }

  return Math.floor(map[unit] * floatValue);
}


/***/ }),
/* 2244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Vector2 */
/* unused harmony export Rectangle */
/* unused harmony export Bounds */
/* unused harmony export Camera */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

var Vector2 = /** @class */ (function () {
    function Vector2(x, y) {
        this.x = x;
        this.y = y;
    }
    Vector2.prototype.add = function (_a) {
        var thatX = _a.x, thatY = _a.y;
        var _b = this, thisX = _b.x, thisY = _b.y;
        return new Vector2(thisX + thatX, thisY + thatY);
    };
    Vector2.prototype.sub = function (_a) {
        var thatX = _a.x, thatY = _a.y;
        var _b = this, thisX = _b.x, thisY = _b.y;
        return new Vector2(thisX - thatX, thisY - thatY);
    };
    Vector2.prototype.scaled = function (scalar) {
        var _a = this, x = _a.x, y = _a.y;
        return new Vector2(x * scalar, y * scalar);
    };
    Vector2.prototype.map = function (fn) {
        return new Vector2(fn(this.x), fn(this.y));
    };
    Vector2.prototype.clone = function () {
        return new Vector2(this.x, this.y);
    };
    Vector2.prototype.rounded = function () {
        return new Vector2(Math.round(this.x), Math.round(this.y));
    };
    Vector2.prototype.toString = function () {
        return "[" + this.x + ", " + this.y + "]";
    };
    return Vector2;
}());

var Rectangle = /** @class */ (function () {
    function Rectangle(width, height) {
        this.width = width;
        this.height = height;
    }
    Object.defineProperty(Rectangle.prototype, "aspectRatio", {
        get: function () {
            return this.width / this.height;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rectangle.prototype, "center", {
        get: function () {
            return new Vector2(this.width / 2, this.height / 2);
        },
        enumerable: true,
        configurable: true
    });
    Rectangle.prototype.scaled = function (scale) {
        return new Rectangle(this.width * scale, this.height * scale);
    };
    Rectangle.prototype.resized = function (width, height) {
        return new Rectangle(width, height);
    };
    Rectangle.prototype.flipped = function () {
        return new Rectangle(this.height, this.width);
    };
    // Computes the scaling factor that needs to be applied to this
    // Rectangle so that it
    // - is fully visible inside of the containing Rectangle
    // - is the LARGEST possible size
    // - maintains the original aspect ratio (no distortion)
    Rectangle.prototype.scaleToFit = function (containing) {
        var widthRatio = containing.width / this.width;
        var heightRatio = containing.height / this.height;
        if (widthRatio <= heightRatio) {
            return widthRatio;
        }
        else {
            return heightRatio;
        }
    };
    Rectangle.prototype.scaleToFitLargestSide = function (containing) {
        return this.scaleToFit(containing);
    };
    // Computes the scaling factor that needs to be applied to this
    // Rectangle so that it
    // - is fully visible inside of the containing Rectangle
    // - is the SMALLEST possible size
    // - maintains the original aspect ratio (no distortion)
    Rectangle.prototype.scaleToFitSmallestSide = function (containing) {
        var widthRatio = containing.width / this.width;
        var heightRatio = containing.height / this.height;
        if (widthRatio >= heightRatio) {
            return widthRatio;
        }
        else {
            return heightRatio;
        }
    };
    Rectangle.prototype.clone = function () {
        return new Rectangle(this.width, this.height);
    };
    return Rectangle;
}());

var Bounds = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Bounds, _super);
    function Bounds(x, y, width, height) {
        var _this = _super.call(this, width, height) || this;
        _this.x = x;
        _this.y = y;
        _this.width = width;
        _this.height = height;
        return _this;
    }
    Object.defineProperty(Bounds.prototype, "origin", {
        get: function () {
            return new Vector2(this.x, this.y);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Bounds.prototype, "corner", {
        get: function () {
            return new Vector2(this.x + this.width, this.y + this.height);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Bounds.prototype, "center", {
        get: function () {
            return new Vector2(this.x + this.width * 0.5, this.y + this.height * 0.5);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Bounds.prototype, "rect", {
        get: function () {
            return new Rectangle(this.width, this.height);
        },
        enumerable: true,
        configurable: true
    });
    Bounds.prototype.flipped = function () {
        var rect = this.rect.flipped();
        return new Bounds(this.x, this.y, rect.width, rect.height);
    };
    Bounds.prototype.scaled = function (scale) {
        return new Bounds(this.x * scale, this.y * scale, this.width * scale, this.height * scale);
    };
    Bounds.prototype.relativeTo = function (bounds) {
        return new Bounds(this.x - bounds.x, this.y - bounds.y, this.width, this.height);
    };
    Bounds.prototype.clone = function () {
        return new Bounds(this.x, this.y, this.width, this.height);
    };
    Bounds.prototype.map = function (fn) {
        return new Bounds(fn(this.x), fn(this.y), fn(this.width), fn(this.height));
    };
    Object.defineProperty(Bounds.prototype, "left", {
        get: function () {
            return this.x;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Bounds.prototype, "top", {
        get: function () {
            return this.y;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Bounds.prototype, "right", {
        get: function () {
            return this.x + this.width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Bounds.prototype, "bottom", {
        get: function () {
            return this.y + this.height;
        },
        enumerable: true,
        configurable: true
    });
    return Bounds;
}(Rectangle));

var Camera = /** @class */ (function () {
    function Camera(viewport, originalImg) {
        this.viewport = viewport;
        this.originalImg = originalImg;
    }
    Camera.prototype.resizedViewport = function (newViewport) {
        return new Camera(newViewport, this.originalImg);
    };
    Object.defineProperty(Camera.prototype, "scaleToFit", {
        get: function () {
            return this.originalImg.scaleToFitLargestSide(this.viewport);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Camera.prototype, "scaleDownToFit", {
        // If the image is smaller than or equal to the viewport, it won't be scaled.
        // If the image is larger than the viewport, it will be scaled down to fit.
        get: function () {
            return Math.min(1, this.scaleToFit);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Camera.prototype, "fittedImg", {
        get: function () {
            return this.originalImg.scaled(this.scaleDownToFit);
        },
        enumerable: true,
        configurable: true
    });
    Camera.prototype.scaledImg = function (newScale) {
        return this.originalImg.scaled(newScale);
    };
    Camera.prototype.scaledOffset = function (prevOffset, prevScale, newScale) {
        var viewport = this.viewport;
        return prevOffset
            .add(viewport.center)
            .scaled(newScale / prevScale)
            .sub(viewport.center);
    };
    return Camera;
}());

//# sourceMappingURL=camera.js.map

/***/ }),
/* 2245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ({
    zh: 'Chinese',
    cs: 'Czech',
    da: 'Danish',
    nl: 'Dutch',
    en: 'English',
    en_GB: 'English (United Kingdom)',
    et: 'Estonian',
    fi: 'Finnish',
    fr: 'French',
    de: 'German',
    hu: 'Hungarian',
    is: 'Icelandic',
    it: 'Italian',
    ja: 'Japanese',
    ko: 'Korean',
    nb: 'Norwegian Bokmål',
    pl: 'Polish',
    pt_BR: 'Portuguese (Brazil)',
    pt_PT: 'Portuguese (Portugal)',
    ro: 'Romanian',
    ru: 'Russian',
    sk: 'Slovak',
    es: 'Spanish',
    sv: 'Swedish',
});
//# sourceMappingURL=languages.js.map

/***/ }),
/* 2246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfiniteScroll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);




var InfiniteScroll = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](InfiniteScroll, _super);
    function InfiniteScroll(props) {
        var _this = _super.call(this, props) || this;
        _this.scrollHeight = 0;
        _this.checkThreshold = function () {
            var div = _this.div.current;
            if (div === null) {
                return;
            }
            var threshold = _this.props.threshold || 0;
            var position = div.scrollTop + div.offsetHeight;
            var thresholdModifier = 0.1;
            var adjustedThreshold = Math.min(threshold, div.scrollHeight * thresholdModifier);
            var thresholdReached = position > _this.scrollHeight &&
                position > div.scrollHeight - adjustedThreshold;
            if (thresholdReached) {
                _this.scrollHeight = div.scrollHeight;
                if (_this.props.onThresholdReached) {
                    _this.props.onThresholdReached();
                }
            }
        };
        _this.checkThresholdDebounce = __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__(_this.checkThreshold, _this.props.delay, {
            leading: true,
            trailing: true,
        });
        _this.div = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        return _this;
    }
    InfiniteScroll.prototype.componentDidMount = function () {
        this.checkThresholdDebounce();
    };
    InfiniteScroll.prototype.componentDidUpdate = function () {
        this.checkThresholdDebounce();
    };
    InfiniteScroll.prototype.render = function () {
        var _a = this.props, width = _a.width, height = _a.height, children = _a.children;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this.div, style: {
                width: width,
                height: height,
                overflowX: 'hidden',
                overflowY: 'auto',
                msOverflowStyle: 'scrollbar',
                display: 'inline-block',
            }, onScroll: this.checkThresholdDebounce }, children));
    };
    InfiniteScroll.defaultProps = {
        width: '100%',
        delay: 500,
        threshold: 100,
    };
    return InfiniteScroll;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=infiniteScroll.js.map

/***/ }),
/* 2247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getImageInfo;
/* unused harmony export getScaleFactor */
/* harmony export (immutable) */ __webpack_exports__["c"] = getOrientation;
/* unused harmony export getMetaTagNumericValue */
/* unused harmony export getScaleFactorFromFile */
/* unused harmony export readImageMetaData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metatags__ = __webpack_require__(2248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(425);
/* unused harmony reexport ExifOrientation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getCssFromImageOrientation__ = __webpack_require__(2252);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__getCssFromImageOrientation__["a"]; });




var Orientation = __WEBPACK_IMPORTED_MODULE_1__types__["c" /* SupportedImageMetaTag */].Orientation, XResolution = __WEBPACK_IMPORTED_MODULE_1__types__["c" /* SupportedImageMetaTag */].XResolution;
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
var DPI_WEB_BASELINE = 72;

function getImageInfo(fileInfo) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
        var metadata, width, height, tags, scaleFactor;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, readImageMetaData(fileInfo)];
                case 1:
                    metadata = _a.sent();
                    if (!metadata) {
                        return [2 /*return*/, null];
                    }
                    width = metadata.width, height = metadata.height, tags = metadata.tags;
                    scaleFactor = getScaleFactor(fileInfo.file, tags);
                    return [2 /*return*/, {
                            scaleFactor: scaleFactor,
                            width: width,
                            height: height,
                        }];
            }
        });
    });
}
function getScaleFactor(file, tags) {
    var scaleFactorFromFilename = getScaleFactorFromFile(file);
    if (scaleFactorFromFilename !== null) {
        return scaleFactorFromFilename;
    }
    else if (tags) {
        /**
         * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
         * So we are only relying on X axis.
         */
        if (typeof tags['PixelPerUnitX'] === 'number') {
            // 1 inch = 0.0254 meters
            return (Math.round(tags['PixelPerUnitX'] * 0.0254) /
                DPI_WEB_BASELINE);
        }
        else {
            return (getMetaTagNumericValue(tags, XResolution, DPI_WEB_BASELINE) /
                DPI_WEB_BASELINE);
        }
    }
    else {
        return 1;
    }
}
function getOrientation(file) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
        var tags, tagValue, numericValue;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_2__metatags__["a" /* readImageMetaTags */])(file)];
                case 1:
                    tags = _a.sent();
                    if (tags && tags[Orientation]) {
                        tagValue = tags[Orientation];
                        if (tagValue) {
                            numericValue = parseInt(tagValue, 10);
                            if (isNaN(numericValue)) {
                                return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* ExifOrientation */][tagValue]];
                            }
                            return [2 /*return*/, numericValue];
                        }
                    }
                    return [2 /*return*/, 1];
            }
        });
    });
}
function getMetaTagNumericValue(tags, key, defaultValue) {
    try {
        var num = parseFloat("" + tags[key]);
        if (!isNaN(num)) {
            return num;
        }
    }
    catch (e) {
        //
    }
    return defaultValue;
}
function getScaleFactorFromFile(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        var match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) {
            return parseFloat(match[1]);
        }
    }
    catch (e) {
        // parse problem, return null
    }
    return null;
}
function readImageMetaData(fileInfo) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
        var file, src, type, width, height, tags, img, e_1, naturalWidth, naturalHeight, data;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0:
                    file = fileInfo.file, src = fileInfo.src;
                    type = file.type;
                    width = 0;
                    height = 0;
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_2__metatags__["a" /* readImageMetaTags */])(file)];
                case 1:
                    tags = _a.sent();
                    // since we're reading metadata anyway, try to get dimensions from there...
                    if (tags && tags.PixelXDimension) {
                        width = getMetaTagNumericValue(tags, 'PixelXDimension', 0);
                    }
                    if (tags && tags.PixelXDimension) {
                        height = getMetaTagNumericValue(tags, 'PixelYDimension', 0);
                    }
                    if (!(width === 0 && height === 0)) return [3 /*break*/, 6];
                    img = void 0;
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_3__util__["c" /* loadImage */])(src)];
                case 3:
                    img = _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    return [2 /*return*/, null];
                case 5:
                    naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
                    width = naturalWidth;
                    height = naturalHeight;
                    _a.label = 6;
                case 6:
                    data = {
                        type: type,
                        width: width,
                        height: height,
                        tags: tags,
                    };
                    return [2 /*return*/, data];
            }
        });
    });
}

//# sourceMappingURL=index.js.map

/***/ }),
/* 2248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = readImageMetaTags;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parseJPEG__ = __webpack_require__(2249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parsePNG__ = __webpack_require__(2250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parsePNGXMP__ = __webpack_require__(2251);





function readImageMetaTags(file) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
        var type, _a, iTXt, pHYs, xmpMetaData, e_1;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_b) {
            switch (_b.label) {
                case 0:
                    type = file.type;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, , 7]);
                    if (!(type === __WEBPACK_IMPORTED_MODULE_1__types__["b" /* ImageType */].PNG)) return [3 /*break*/, 3];
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_3__parsePNG__["a" /* readPNGXMPMetaData */])(file)];
                case 2:
                    _a = _b.sent(), iTXt = _a.iTXt, pHYs = _a.pHYs;
                    xmpMetaData = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, Object(__WEBPACK_IMPORTED_MODULE_4__parsePNGXMP__["a" /* parseXMPMetaData */])(iTXt), pHYs);
                    return [2 /*return*/, xmpMetaData];
                case 3:
                    if (!(file.type === __WEBPACK_IMPORTED_MODULE_1__types__["b" /* ImageType */].JPEG)) return [3 /*break*/, 5];
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_2__parseJPEG__["a" /* readJPEGExifMetaData */])(file)];
                case 4: return [2 /*return*/, _b.sent()];
                case 5: return [3 /*break*/, 7];
                case 6:
                    e_1 = _b.sent();
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/, null];
            }
        });
    });
}
//# sourceMappingURL=metatags.js.map

/***/ }),
/* 2249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = readJPEGExifMetaData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(273);


var XResolution = __WEBPACK_IMPORTED_MODULE_1__types__["c" /* SupportedImageMetaTag */].XResolution, YResolution = __WEBPACK_IMPORTED_MODULE_1__types__["c" /* SupportedImageMetaTag */].YResolution;
var loadImage;
function readJPEGExifMetaData(file) {
    var _this = this;
    return new Promise(function (resolve, reject) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](_this, void 0, void 0, function () {
        var module_1;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!loadImage) return [3 /*break*/, 2];
                    return [4 /*yield*/, __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 3463))];
                case 1:
                    module_1 = _a.sent();
                    loadImage = module_1.default || module_1;
                    _a.label = 2;
                case 2:
                    loadImage.parseMetaData(file, function (data) {
                        try {
                            var tags_1 = data && data.exif ? data.exif.getAll() : {};
                            Object.keys(tags_1).forEach(function (key) {
                                var value = tags_1[key];
                                if (typeof value === 'object' &&
                                    (key === XResolution || key === YResolution) &&
                                    'numerator' in value) {
                                    // some test images had this structure, so just take the numerator value to simplify returned value
                                    tags_1[key] = value.numerator;
                                }
                                if (typeof tags_1[key] === 'number') {
                                    // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                                    tags_1[key] = "" + tags_1[key];
                                }
                            });
                            resolve(tags_1);
                        }
                        catch (e) {
                            reject(e);
                        }
                    });
                    return [2 /*return*/];
            }
        });
    }); });
}
//# sourceMappingURL=parseJPEG.js.map

/***/ }),
/* 2250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = readPNGXMPMetaData;
/* unused harmony export parsePNGChunks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(425);


var pngChunksExtract;
function readPNGXMPMetaData(file) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
        var module_1, buffer, chunks;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!pngChunksExtract) return [3 /*break*/, 2];
                    return [4 /*yield*/, __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 3464))];
                case 1:
                    module_1 = _a.sent();
                    pngChunksExtract = module_1.default || module_1;
                    _a.label = 2;
                case 2: return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* fileToArrayBuffer */])(file)];
                case 3:
                    buffer = _a.sent();
                    chunks = pngChunksExtract(buffer);
                    return [4 /*yield*/, parsePNGChunks(chunks)];
                case 4: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function parsePNGChunks(chunks) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
        var iTXt, pHYs, i, chunk, dv, unitSpecifier, PixelPerUnitX, PixelPerUnitY;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
            iTXt = '';
            pHYs = {};
            /**
             * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
             * Order of every chunk is not guaranteed.
             * And both iTXt and pHYs are Ancillary chunks.
             */
            for (i = 0; i < chunks.length; ++i) {
                chunk = chunks[i];
                // Must be last
                if (chunk.name === 'IEND') {
                    break;
                }
                /**
                 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
                 * iTXt contains the useful XMP/XML string data of meta tags
                 */
                if (chunk.name === 'iTXt') {
                    iTXt = String.fromCharCode.apply(null, chunk.data);
                }
                /**
                 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
                 * Pixels per unit, X axis: 4 bytes (unsigned integer)
                 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
                 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
                 */
                if (chunk.name === 'pHYs') {
                    dv = new DataView(chunk.data.buffer);
                    unitSpecifier = dv.getUint8(8);
                    // meter
                    if (unitSpecifier === 1) {
                        PixelPerUnitX = dv.getUint32(0);
                        PixelPerUnitY = dv.getUint32(4);
                        pHYs = { PixelPerUnitX: PixelPerUnitX, PixelPerUnitY: PixelPerUnitY };
                    }
                }
            }
            return [2 /*return*/, { iTXt: iTXt, pHYs: pHYs }];
        });
    });
}
//# sourceMappingURL=parsePNG.js.map

/***/ }),
/* 2251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseXMPMetaData;
function parseXMPMetaData(xmpMetaData) {
    var metadata = {};
    var tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) {
        tags.forEach(function (tag) {
            var match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
            if (match) {
                var name_1 = match[2];
                metadata[name_1] = match[3];
            }
        });
    }
    return metadata;
}
//# sourceMappingURL=parsePNGXMP.js.map

/***/ }),
/* 2252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCssFromImageOrientation; });
var ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)',
};
var getCssFromImageOrientation = function (orientation) {
    return ORIENT_TRANSFORMS[orientation];
};
//# sourceMappingURL=getCssFromImageOrientation.js.map

/***/ }),
/* 2253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CustomMediaPlayer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_vid_play__ = __webpack_require__(2254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_vid_play___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_vid_play__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_vid_pause__ = __webpack_require__(2255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_vid_pause___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_vid_pause__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_vid_full_screen_on__ = __webpack_require__(2256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_vid_full_screen_on___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_vid_full_screen_on__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_vid_full_screen_off__ = __webpack_require__(2257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_vid_full_screen_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_vid_full_screen_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_hipchat_outgoing_sound__ = __webpack_require__(2258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_hipchat_outgoing_sound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_hipchat_outgoing_sound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_vid_hd_circle__ = __webpack_require__(2259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_vid_hd_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_vid_hd_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_spinner__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_video_renderer__ = __webpack_require__(2260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_theme__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__theme__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__timeRange__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styled__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__formatDuration__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__classNames__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__shortcut__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__fullscreen__ = __webpack_require__(2262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__messages__ = __webpack_require__(771);























var CustomMediaPlayer = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CustomMediaPlayer, _super);
    function CustomMediaPlayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isFullScreenEnabled: false,
        };
        _this.onFullScreenChange = function () {
            var currentFullScreenMode = _this.state.isFullScreenEnabled;
            var isFullScreenEnabled = Object(__WEBPACK_IMPORTED_MODULE_19__fullscreen__["a" /* getFullscreenElement */])() ? true : false;
            if (currentFullScreenMode !== isFullScreenEnabled) {
                _this.setState({
                    isFullScreenEnabled: isFullScreenEnabled,
                });
            }
        };
        _this.onTimeChange = function (navigate) { return function (value) {
            navigate(value);
        }; };
        _this.onVolumeChange = function (setVolume) { return function (value) {
            return setVolume(value);
        }; };
        _this.shortcutHandler = function (toggleButtonAction) { return function () {
            var showControls = _this.props.showControls;
            toggleButtonAction();
            if (showControls) {
                showControls();
            }
        }; };
        _this.renderHDButton = function () {
            var _a = _this.props, type = _a.type, isHDAvailable = _a.isHDAvailable, isHDActive = _a.isHDActive, onHDToggleClick = _a.onHDToggleClick;
            if (type === 'audio' || !isHDAvailable) {
                return;
            }
            var primaryColor = isHDActive ? __WEBPACK_IMPORTED_MODULE_11__atlaskit_theme__["colors"].B200 : __WEBPACK_IMPORTED_MODULE_11__atlaskit_theme__["colors"].DN400;
            var secondaryColor = isHDActive ? __WEBPACK_IMPORTED_MODULE_11__atlaskit_theme__["colors"].white : __WEBPACK_IMPORTED_MODULE_11__atlaskit_theme__["colors"].DN60;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__atlaskit_button__["default"], { appearance: 'toolbar', isSelected: isHDActive, onClick: onHDToggleClick, iconBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_vid_hd_circle___default.a, { primaryColor: primaryColor, secondaryColor: secondaryColor, label: "hd" }) }));
        };
        _this.renderVolume = function (_a, actions) {
            var isMuted = _a.isMuted, volume = _a.volume;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__styled__["s" /* VolumeWrapper */], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__styled__["r" /* VolumeToggleWrapper */], { isMuted: isMuted },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__styled__["h" /* MutedIndicator */], { isMuted: isMuted }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__atlaskit_button__["default"], { appearance: 'toolbar', onClick: actions.toggleMute, iconBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_hipchat_outgoing_sound___default.a, { label: "volume" }) })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__styled__["q" /* VolumeTimeRangeWrapper */], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__timeRange__["a" /* TimeRange */], { onChange: _this.onVolumeChange(actions.setVolume), duration: 1, currentTime: volume, bufferedTime: volume, disableThumbTooltip: true, isAlwaysActive: true }))));
        };
        _this.onFullScreenClick = function () { return Object(__WEBPACK_IMPORTED_MODULE_19__fullscreen__["b" /* toggleFullscreen */])(_this.videoWrapperRef); };
        _this.saveVideoWrapperRef = function (el) { return (_this.videoWrapperRef = el); };
        _this.renderFullScreenButton = function () {
            var _a = _this.props, formatMessage = _a.intl.formatMessage, type = _a.type;
            if (type === 'audio') {
                return;
            }
            var isFullScreenEnabled = _this.state.isFullScreenEnabled;
            var icon = isFullScreenEnabled ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_vid_full_screen_off___default.a, { label: formatMessage(__WEBPACK_IMPORTED_MODULE_21__messages__["a" /* messages */].disable_fullscreen) })) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_vid_full_screen_on___default.a, { label: formatMessage(__WEBPACK_IMPORTED_MODULE_21__messages__["a" /* messages */].enable_fullscreen) }));
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__atlaskit_button__["default"], { appearance: 'toolbar', onClick: _this.onFullScreenClick, iconBefore: icon }));
        };
        _this.renderSpinner = function () { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__styled__["j" /* SpinnerWrapper */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__atlaskit_spinner__["a" /* default */], { invertColor: true, size: "large" }))); };
        return _this;
    }
    CustomMediaPlayer.prototype.componentDidMount = function () {
        document.addEventListener(Object(__WEBPACK_IMPORTED_MODULE_19__fullscreen__["c" /* vendorify */])('fullscreenchange', false), this.onFullScreenChange);
    };
    CustomMediaPlayer.prototype.componentWillUnmount = function () {
        document.removeEventListener(Object(__WEBPACK_IMPORTED_MODULE_19__fullscreen__["c" /* vendorify */])('fullscreenchange', false), this.onFullScreenChange);
    };
    CustomMediaPlayer.prototype.render = function () {
        var _this = this;
        var _a = this.props, type = _a.type, src = _a.src, isAutoPlay = _a.isAutoPlay, isShortcutEnabled = _a.isShortcutEnabled, formatMessage = _a.intl.formatMessage;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_styled_components__["ThemeProvider"], { theme: __WEBPACK_IMPORTED_MODULE_13__theme__["a" /* default */] },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__styled__["f" /* CustomVideoWrapper */], { innerRef: this.saveVideoWrapperRef },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_react_video_renderer__["a" /* default */], { sourceType: type, src: src, autoPlay: isAutoPlay }, function (video, videoState, actions) {
                    var status = videoState.status, currentTime = videoState.currentTime, buffered = videoState.buffered, duration = videoState.duration, isLoading = videoState.isLoading;
                    var isPlaying = status === 'playing';
                    var toggleButtonIcon = isPlaying ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_vid_pause___default.a, { label: formatMessage(__WEBPACK_IMPORTED_MODULE_21__messages__["a" /* messages */].play) })) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_vid_play___default.a, { label: formatMessage(__WEBPACK_IMPORTED_MODULE_21__messages__["a" /* messages */].pause) }));
                    var toggleButtonAction = isPlaying
                        ? actions.pause
                        : actions.play;
                    var button = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__atlaskit_button__["default"], { appearance: 'toolbar', iconBefore: toggleButtonIcon, onClick: toggleButtonAction }));
                    var shortcuts = isShortcutEnabled && [
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__shortcut__["a" /* Shortcut */], { key: "space-shortcut", keyCode: __WEBPACK_IMPORTED_MODULE_18__shortcut__["b" /* keyCodes */].space, handler: _this.shortcutHandler(toggleButtonAction) }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__shortcut__["a" /* Shortcut */], { key: "m-shortcut", keyCode: __WEBPACK_IMPORTED_MODULE_18__shortcut__["b" /* keyCodes */].m, handler: _this.shortcutHandler(actions.toggleMute) }),
                    ];
                    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__styled__["p" /* VideoWrapper */], null,
                        video,
                        isLoading && _this.renderSpinner(),
                        shortcuts,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__styled__["b" /* ControlsWrapper */], { className: __WEBPACK_IMPORTED_MODULE_17__classNames__["a" /* hideControlsClassName */] },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__styled__["n" /* TimeWrapper */], null,
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__timeRange__["a" /* TimeRange */], { currentTime: currentTime, bufferedTime: buffered, duration: duration, onChange: _this.onTimeChange(actions.navigate) })),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__styled__["o" /* TimebarWrapper */], null,
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__styled__["g" /* LeftControls */], null,
                                    button,
                                    _this.renderVolume(videoState, actions)),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__styled__["i" /* RightControls */], null,
                                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__styled__["c" /* CurrentTime */], { draggable: false },
                                        Object(__WEBPACK_IMPORTED_MODULE_16__formatDuration__["a" /* formatDuration */])(currentTime),
                                        " /",
                                        ' ',
                                        Object(__WEBPACK_IMPORTED_MODULE_16__formatDuration__["a" /* formatDuration */])(duration)),
                                    _this.renderHDButton(),
                                    _this.renderFullScreenButton())))));
                }))));
    };
    return CustomMediaPlayer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_20_react_intl__["injectIntl"])(CustomMediaPlayer));
//# sourceMappingURL=index.js.map

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(91));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var VidPlayIcon = function VidPlayIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M8.595 19.522C7.162 20.364 6 19.702 6 18.04V5.963C6 4.3 7.158 3.635 8.595 4.479l11.083 6.51c.951.559.958 1.46 0 2.023l-11.083 6.51z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

VidPlayIcon.displayName = 'VidPlayIcon';
var _default = VidPlayIcon;
exports.default = _default;

/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(91));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var VidPauseIcon = function VidPauseIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M6 4h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm10 0h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

VidPauseIcon.displayName = 'VidPauseIcon';
var _default = VidPauseIcon;
exports.default = _default;

/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(91));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var VidFullScreenOnIcon = function VidFullScreenOnIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M6 18h3a1 1 0 0 1 0 2H6a2 2 0 0 1-2-2v-3a1 1 0 0 1 2 0v3zm12 2h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3a2 2 0 0 1-2 2zM6 4h3a1 1 0 1 1 0 2H6v3a1 1 0 1 1-2 0V6a2 2 0 0 1 2-2zm12 2h-3a1 1 0 0 1 0-2h3a2 2 0 0 1 2 2v3a1 1 0 0 1-2 0V6z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

VidFullScreenOnIcon.displayName = 'VidFullScreenOnIcon';
var _default = VidFullScreenOnIcon;
exports.default = _default;

/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(91));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var VidFullScreenOffIcon = function VidFullScreenOffIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M9 15.003v2.995a1 1 0 1 0 2 0v-3.896C11 13.494 10.507 13 9.9 13H6a1 1 0 0 0 0 2.003h3z\" fill-rule=\"nonzero\"/><path d=\"M3.74 20.294a.997.997 0 0 0 1.407.005l5.152-5.152a1 1 0 0 0-.005-1.407l-.034-.034a.997.997 0 0 0-1.407-.005l-5.152 5.152a1 1 0 0 0 .005 1.407l.034.034z\" fill-rule=\"nonzero\"/><path d=\"M19.067 3.321L13.32 9.066a1.115 1.115 0 0 0 .005 1.57l.036.037a1.112 1.112 0 0 0 1.571.005l5.747-5.744a1.116 1.116 0 0 0-.006-1.57l-.037-.037a1.117 1.117 0 0 0-1.57-.006z\"/><path d=\"M13 6.002v3.896c0 .608.493 1.102 1.1 1.102H18a1 1 0 0 0 0-2.003h-3V6.002a1 1 0 1 0-2 0z\"/></g></svg>"
  }, props));
};

VidFullScreenOffIcon.displayName = 'VidFullScreenOffIcon';
var _default = VidFullScreenOffIcon;
exports.default = _default;

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(91));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var HipchatOutgoingSoundIcon = function HipchatOutgoingSoundIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M17.229 7.652c.04.048.124.16.238.33.198.294.398.631.584 1.006 1.138 2.288 1.243 4.648-.316 6.864a7.86 7.86 0 0 1-.377.492 1 1 0 0 0 .156 1.43 1.062 1.062 0 0 0 1.467-.152 9.55 9.55 0 0 0 .475-.62c2.045-2.907 1.907-6.017.472-8.901-.392-.788-.788-1.376-1.07-1.72a1.062 1.062 0 0 0-1.466-.158 1 1 0 0 0-.163 1.429z\" fill-rule=\"nonzero\"/><path d=\"M14.214 9.619c.079.101.225.33.376.658.608 1.318.608 2.72-.404 4.141-.32.45-.217 1.074.23 1.395a.992.992 0 0 0 1.389-.231c1.476-2.073 1.476-4.226.591-6.146a5.494 5.494 0 0 0-.619-1.055.992.992 0 0 0-1.398-.166c-.431.341-.506.97-.165 1.404z\" fill-rule=\"nonzero\"/><path d=\"M7 15V9l4.74-3.892c.57-.323 1.26.116 1.26.8v12.184c0 .684-.69 1.123-1.26.8L7 15zM4 9h2v6H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1z\"/></g></svg>"
  }, props));
};

HipchatOutgoingSoundIcon.displayName = 'HipchatOutgoingSoundIcon';
var _default = HipchatOutgoingSoundIcon;
exports.default = _default;

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(91));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var VidHdCircleIcon = function VidHdCircleIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill-rule=\"evenodd\"><circle fill=\"currentColor\" cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M11.359 15V9.004h-1.5v2.352H7.504V9.004H6V15h1.504v-2.418h2.355V15h1.5zm1.393-6v6h2.483C17.013 15 18 13.911 18 11.942 18 10.068 16.996 9 15.235 9h-2.483zm1.503 1.226h.71c.946 0 1.503.627 1.503 1.745 0 1.188-.529 1.803-1.504 1.803h-.709v-3.548z\" fill=\"inherit\"/></g></svg>"
  }, props));
};

VidHdCircleIcon.displayName = 'VidHdCircleIcon';
var _default = VidHdCircleIcon;
exports.default = _default;

/***/ }),
/* 2260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__video__ = __webpack_require__(772);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__video__["a"]; });
/* unused harmony namespace reexport */




/***/ }),
/* 2261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return requestFullScreen; });
var requestFullScreen = function (element) {
    var methods = ['requestFullscreen', 'webkitRequestFullscreen', 'mozRequestFullScreen', 'msRequestFullscreen'];
    var methodName = methods.find(function (name) { return element[name]; });
    element[methodName]();
};


/***/ }),
/* 2262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return vendorify; });
/* unused harmony export requestFullscreen */
/* unused harmony export exitFullscreen */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFullscreenElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toggleFullscreen; });
var capitalize = function (text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
};
var vendorify = function (propName, capitalizeText) {
    if (capitalizeText === void 0) { capitalizeText = true; }
    var prefix = '';
    if (HTMLElement.prototype.webkitRequestFullscreen) {
        prefix = 'webkit';
    }
    else if (HTMLElement.prototype['mozRequestFullScreen']) {
        prefix = 'moz';
    }
    else if (HTMLElement.prototype['msRequestFullScreen']) {
        prefix = 'ms';
    }
    var capitalizeProp = capitalizeText !== undefined ? capitalizeText : !!prefix;
    return "" + prefix + (capitalizeProp ? capitalize(propName) : propName);
};
var requestFullscreen = function (element) {
    var methodName = vendorify('requestFullScreen');
    if (methodName && element[methodName]) {
        element[methodName]();
    }
};
var exitFullscreen = function () {
    var methodName = vendorify('exitFullscreen');
    if (methodName && document[methodName]) {
        document[methodName]();
    }
};
var getFullscreenElement = function () {
    var propertyName = vendorify('fullscreenElement');
    return propertyName && document[propertyName];
};
var toggleFullscreen = function (element) {
    if (getFullscreenElement()) {
        exitFullscreen();
    }
    else if (element) {
        requestFullscreen(element);
    }
};
//# sourceMappingURL=fullscreen.js.map

/***/ }),
/* 2263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export e100 */
/* unused harmony export e200 */
/* unused harmony export e300 */
/* unused harmony export e400 */
/* unused harmony export e500 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(427);

 // Cards on a board

var e100 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 1px 1px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px 0 ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 1px 1px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
}); // Inline dialogs

var e200 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 4px 8px -2px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 4px 8px -2px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
}); // Modals

var e300 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 8px 16px -4px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 8px 16px -4px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
}); // Panels

var e400 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 12px 24px -6px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 12px 24px -6px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
}); // Flag messages (notifications)

var e500 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 20px 32px -8px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 20px 32px -8px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
});

/***/ }),
/* 2264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export h900 */
/* unused harmony export h800 */
/* unused harmony export h700 */
/* unused harmony export h600 */
/* unused harmony export h500 */
/* unused harmony export h400 */
/* unused harmony export h300 */
/* unused harmony export h200 */
/* unused harmony export h100 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colors__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(529);




var baseHeading = function baseHeading(size, lineHeight) {
  return "\n  font-size: ".concat(size / Object(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* fontSize */])(), "em;\n  font-style: inherit;\n  line-height: ").concat(lineHeight / size, ";\n");
};

var h900 = function h900() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ", "px;\n"], baseHeading(35, 40), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["c" /* gridSize */])() * 6.5);
};
var h800 = function h800() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ", "px;\n"], baseHeading(29, 32), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["c" /* gridSize */])() * 5);
};
var h700 = function h700() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ", "px;\n"], baseHeading(24, 28), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["c" /* gridSize */])() * 5);
};
var h600 = function h600() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ", "px;\n"], baseHeading(20, 24), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["c" /* gridSize */])() * 3.5);
};
var h500 = function h500() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ", "px;\n"], baseHeading(16, 20), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["c" /* gridSize */])() * 3);
};
var h400 = function h400() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ", "px;\n"], baseHeading(14, 16), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["c" /* gridSize */])() * 2);
};
var h300 = function h300() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  margin-top: ", "px;\n  text-transform: uppercase;\n"], baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["c" /* gridSize */])() * 2.5);
};
var h200 = function h200() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  margin-top: ", "px;\n"], baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_1__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["c" /* gridSize */])() * 2);
};
var h100 = function h100() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 700;\n  margin-top: ", "px;\n"], baseHeading(11, 16), __WEBPACK_IMPORTED_MODULE_1__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["c" /* gridSize */])() * 2);
};

/***/ }),
/* 2265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export add */
/* unused harmony export subtract */
/* unused harmony export multiply */
/* unused harmony export divide */
function add(fn, addend) {
  return function (props) {
    return fn(props) + addend;
  };
}
function subtract(fn, subtrahend) {
  return function (props) {
    return fn(props) - subtrahend;
  };
}
function multiply(fn, factor) {
  return function (props) {
    return fn(props) * factor;
  };
}
function divide(fn, divisor) {
  return function (props) {
    return fn(props) / divisor;
  };
}

/***/ }),
/* 2266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AtlaskitThemeProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_exenv__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_exenv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_exenv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__colors__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Theme__ = __webpack_require__(428);












 // For forward-compat until everything is upgraded.



function getStylesheetResetCSS(state) {
  var backgroundColor = __WEBPACK_IMPORTED_MODULE_11__colors__["background"](state);
  return "\n    body { background: ".concat(backgroundColor, "; }\n  ");
}

function buildThemeState(mode) {
  return {
    theme: __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_12__constants__["a" /* CHANNEL */], {
      mode: mode
    })
  };
}

var LegacyReset = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div.withConfig({
  displayName: "AtlaskitThemeProvider__LegacyReset",
  componentId: "sc-431dkp-0"
})(["\n  background-color: ", ";\n  color: ", ";\n\n  a {\n    color: ", ";\n  }\n  a:hover {\n    color: ", ";\n  }\n  a:active {\n    color: ", ";\n  }\n  a:focus {\n    outline-color: ", ";\n  }\n  h1 {\n    color: ", ";\n  }\n  h2 {\n    color: ", ";\n  }\n  h3 {\n    color: ", ";\n  }\n  h4 {\n    color: ", ";\n  }\n  h5 {\n    color: ", ";\n  }\n  h6 {\n    color: ", ";\n  }\n  small {\n    color: ", ";\n  }\n"], __WEBPACK_IMPORTED_MODULE_11__colors__["background"], __WEBPACK_IMPORTED_MODULE_11__colors__["text"], __WEBPACK_IMPORTED_MODULE_11__colors__["link"], __WEBPACK_IMPORTED_MODULE_11__colors__["linkHover"], __WEBPACK_IMPORTED_MODULE_11__colors__["linkActive"], __WEBPACK_IMPORTED_MODULE_11__colors__["linkOutline"], __WEBPACK_IMPORTED_MODULE_11__colors__["heading"], __WEBPACK_IMPORTED_MODULE_11__colors__["heading"], __WEBPACK_IMPORTED_MODULE_11__colors__["heading"], __WEBPACK_IMPORTED_MODULE_11__colors__["heading"], __WEBPACK_IMPORTED_MODULE_11__colors__["heading"], __WEBPACK_IMPORTED_MODULE_11__colors__["subtleHeading"], __WEBPACK_IMPORTED_MODULE_11__colors__["subtleText"]);

var AtlaskitThemeProvider =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(AtlaskitThemeProvider, _Component);

  function AtlaskitThemeProvider(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, AtlaskitThemeProvider);

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(AtlaskitThemeProvider).call(this, props));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "stylesheet", void 0);

    _this.state = buildThemeState(props.mode);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(AtlaskitThemeProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        hasAtlaskitThemeProvider: true
      };
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      if (!this.context.hasAtlaskitThemeProvider && __WEBPACK_IMPORTED_MODULE_10_exenv___default.a.canUseDOM) {
        var css = getStylesheetResetCSS(this.state);
        this.stylesheet = document.createElement('style');
        this.stylesheet.type = 'text/css';
        this.stylesheet.innerHTML = css;

        if (document && document.head) {
          document.head.appendChild(this.stylesheet);
        }
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (newProps.mode !== this.props.mode) {
        var newThemeState = buildThemeState(newProps.mode);

        if (this.stylesheet) {
          var css = getStylesheetResetCSS(newThemeState);
          this.stylesheet.innerHTML = css;
        }

        this.setState(newThemeState);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.stylesheet && document && document.head) {
        document.head.removeChild(this.stylesheet);
        delete this.stylesheet;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var theme = this.state.theme;
      return (
        /* Wrapping the new provider around the old one provides forward
        compatibility when using the old provider for styled components. This
        allows us to use components converted to use the new API with consumers
        using the old provider along side components that may still be using the
        old theming API. */
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Theme__["a" /* default */].Provider, {
          value: function value() {
            return {
              mode: theme[__WEBPACK_IMPORTED_MODULE_12__constants__["a" /* CHANNEL */]].mode
            };
          }
        }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_styled_components__["ThemeProvider"], {
          theme: theme
        }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(LegacyReset, null, children)))
      );
    }
  }]);

  return AtlaskitThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AtlaskitThemeProvider, "defaultProps", {
  mode: __WEBPACK_IMPORTED_MODULE_12__constants__["b" /* DEFAULT_THEME_MODE */]
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AtlaskitThemeProvider, "childContextTypes", {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AtlaskitThemeProvider, "contextTypes", {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
});



/***/ }),
/* 2267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);


/* unused harmony default export */ var _unused_webpack_default_export = (function (_ref) {
  var children = _ref.children,
      props = _ref.props,
      theme = _ref.theme;
  var appearance = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(props) === 'object' ? 'default' : props;
  var merged = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(props) === 'object' ? __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, props) : {};
  Object.keys(theme).forEach(function (key) {
    if (!(key in merged)) {
      merged[key] = theme[key]({
        appearance: appearance
      });
    }
  });
  return children(merged);
});

/***/ }),
/* 2268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ResetTheme */
/* unused harmony export Reset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__colors__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_createTheme__ = __webpack_require__(429);







var orTextColor = function orTextColor(preferred) {
  return function (p) {
    return p[preferred] || p.textColor;
  };
};

var Div = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div.withConfig({
  displayName: "Reset__Div",
  componentId: "sc-15i6ali-0"
})(["\n  ", ";\n"], function (p) {
  return Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["css"])(["\n    background-color: ", ";\n    color: ", ";\n\n    a {\n      color: ", ";\n    }\n    a:hover {\n      color: ", ";\n    }\n    a:active {\n      color: ", ";\n    }\n    a:focus {\n      outline-color: ", ";\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ", ";\n    }\n    h6 {\n      color: ", ";\n    }\n    small {\n      color: ", ";\n    }\n  "], p.backgroundColor, p.textColor, orTextColor('linkColor'), orTextColor('linkColorHover'), orTextColor('linkColorActive'), orTextColor('linkColorOutline'), orTextColor('headingColor'), orTextColor('subtleHeadingColor'), orTextColor('subtleTextColor'));
});
var ResetTheme = Object(__WEBPACK_IMPORTED_MODULE_5__utils_createTheme__["a" /* createTheme */])(function () {
  return {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N0"],
    linkColor: __WEBPACK_IMPORTED_MODULE_4__colors__["B400"],
    linkColorHover: __WEBPACK_IMPORTED_MODULE_4__colors__["B300"],
    linkColorActive: __WEBPACK_IMPORTED_MODULE_4__colors__["B500"],
    linkColorOutline: __WEBPACK_IMPORTED_MODULE_4__colors__["B100"],
    headingColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N800"],
    subtleHeadingColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N200"],
    subtleTextColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N200"],
    textColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N900"]
  };
});
function Reset(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ResetTheme.Provider, {
    value: props.theme
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ResetTheme.Consumer, null, function (tokens) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Div, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, tokens, {
      mode: undefined
    }), props), props.children);
  }));
}

/***/ }),
/* 2269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export withTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Theme__ = __webpack_require__(428);


 // Pre-executes the theme and passes it as a prop to the supplied component.
// This is useful for ensuring that the current theme is accessible as props
// in styled-components.

function withTheme(InnerComponent) {
  return function ComponentWithTheme(props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Theme__["a" /* default */].Consumer, null, function (tokens) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InnerComponent, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, props, {
        theme: tokens
      }));
    });
  };
}

/***/ }),
/* 2270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var ImageComponent = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].img(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  position: absolute;\n  left: 50%;\n  top: 50%;\n"], ["\n  position: absolute;\n  left: 50%;\n  top: 50%;\n"])));
var templateObject_1;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardActionsView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cardActionIconButton__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cardActionsDropdownMenu__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__preventClickThrough__ = __webpack_require__(2276);







var CardActionsView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CardActionsView, _super);
    function CardActionsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardActionsView.prototype.render = function () {
        var actions = this.props.actions;
        if (!actions.length) {
            return null;
        }
        var primaryAction = actions.find(actionWithIcon);
        var otherActions = actions.filter(actionNotEqualTo(primaryAction));
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__preventClickThrough__["a" /* PreventClickThrough */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["b" /* Wrapper */], null,
                primaryAction ? this.renderActionIconButton(primaryAction) : null,
                this.renderOtherActionButtons(otherActions))));
    };
    CardActionsView.prototype.renderActionIconButton = function (action) {
        var triggerColor = this.props.triggerColor;
        var icon = action.icon, handler = action.handler;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__cardActionIconButton__["a" /* CardActionIconButton */], { icon: icon, triggerColor: triggerColor, onClick: function () { return handler(); } }));
    };
    CardActionsView.prototype.renderOtherActionButtons = function (actions) {
        if (actions.length === 0) {
            return null;
        }
        else {
            var _a = this.props, triggerColor = _a.triggerColor, onToggle = _a.onToggle;
            var firstActionWithIcon = actions.find(actionWithIcon);
            var otherActions = actions.filter(actionNotEqualTo(firstActionWithIcon));
            if (firstActionWithIcon && otherActions.length === 0) {
                return this.renderActionIconButton(firstActionWithIcon);
            }
            else {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__cardActionsDropdownMenu__["a" /* CardActionsDropdownMenu */], { actions: actions, triggerColor: triggerColor, onOpenChange: onToggle }));
            }
        }
    };
    return CardActionsView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

function actionWithIcon(action) {
    return !!action.icon;
}
function actionNotEqualTo(otherAction) {
    return function (action) { return action !== otherAction; };
}
//# sourceMappingURL=cardActionsView.js.map

/***/ }),
/* 2272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return centerX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return antialiased; });
/* unused harmony export centerSelfY */
/* unused harmony export centerSelfX */
/* unused harmony export centerSelf */
/* unused harmony export borderRadiusLeft */
/* unused harmony export spaceAround */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return transition; });
/* unused harmony export hexToRgb */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rgba; });
/* unused harmony export capitalize */
/* unused harmony export withAppearance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_util_shared_styles__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_util_shared_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__atlaskit_util_shared_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(780);
/* tslint:disable:variable-name */


var centerX = "\n  display: flex;\n  justify-content: center;\n";
var antialiased = "\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n";
var centerSelfY = "\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n";
var centerSelfX = "\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n";
var centerSelf = "\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n";
var borderRadiusLeft = "\n  border-top-left-radius: " + __WEBPACK_IMPORTED_MODULE_0__atlaskit_util_shared_styles__["akBorderRadius"] + ";\n  border-bottom-left-radius: " + __WEBPACK_IMPORTED_MODULE_0__atlaskit_util_shared_styles__["akBorderRadius"] + ";\n";
var spaceAround = "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n";
var transition = function (propertyName) {
    if (propertyName === void 0) { propertyName = 'all'; }
    return "\n  transition: " + propertyName + " " + __WEBPACK_IMPORTED_MODULE_1__config__["a" /* defaultTransitionDuration */] + ";\n";
};
var hexToRgb = function (hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? parseInt(result[1], 16) + "," + parseInt(result[2], 16) + "," + parseInt(result[3], 16)
        : null;
};
var rgba = function (hex, opacity) {
    return "rgba(" + hexToRgb(hex) + ", " + opacity + ")";
};
var capitalize = "\n  &::first-letter {\n    text-transform: uppercase;\n  }\n";
var withAppearance = function (styleMap) { return function (_a) {
    var appearance = _a.appearance;
    return (appearance && styleMap[appearance]) || '';
}; };
//# sourceMappingURL=mixins.js.map

/***/ }),
/* 2273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return easeOutCubic; });
/* unused harmony export easeOutExpo */
var easeOutCubic = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
var easeOutExpo = 'cubic-bezier(0.19, 1, 0.22, 1)';
//# sourceMappingURL=easing.js.map

/***/ }),
/* 2274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export spin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var spin = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  to { transform: rotate(360deg); }\n"], ["\n  to { transform: rotate(360deg); }\n"])));
var templateObject_1;
//# sourceMappingURL=animations.js.map

/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var MoreIcon = function MoreIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><circle cx=\"5\" cy=\"12\" r=\"2\"/><circle cx=\"12\" cy=\"12\" r=\"2\"/><circle cx=\"19\" cy=\"12\" r=\"2\"/></g></svg>"
  }, props));
};

MoreIcon.displayName = 'MoreIcon';
var _default = MoreIcon;
exports.default = _default;

/***/ }),
/* 2276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__preventClickThrough__ = __webpack_require__(2277);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__preventClickThrough__["a"]; });
/* unused harmony reexport default */

//# sourceMappingURL=index.js.map

/***/ }),
/* 2277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PreventClickThrough;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function PreventClickThrough(_a) {
    var children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { onClick: function (event) {
            event.stopPropagation();
            event.preventDefault();
        } }, children));
}
//# sourceMappingURL=preventClickThrough.js.map

/***/ }),
/* 2278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MediaTypeIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_image__ = __webpack_require__(2279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_audio__ = __webpack_require__(2280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_audio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_audio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_media_services_video__ = __webpack_require__(2281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_media_services_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_media_services_video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_document__ = __webpack_require__(2282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_document___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_document__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_page__ = __webpack_require__(2283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled__ = __webpack_require__(2284);

/* tslint:disable:variable-name */







var icons = {
    image: __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_image___default.a,
    audio: __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_audio___default.a,
    video: __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_media_services_video___default.a,
    doc: __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_document___default.a,
    unknown: __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_page___default.a,
};
var MediaTypeIcon = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MediaTypeIcon, _super);
    function MediaTypeIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MediaTypeIcon.prototype.render = function () {
        var _a = this.props, type = _a.type, _b = _a.size, size = _b === void 0 ? 'small' : _b, className = _a.className;
        var Icon = (type && icons[type]) || icons.unknown;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styled__["a" /* IconWrapper */], { type: type || 'unknown' },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Icon, { label: "media-type", size: size, className: className })));
    };
    return MediaTypeIcon;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ImageIcon = function ImageIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M3 4.995C3 3.893 3.893 3 4.995 3h14.01C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.005V4.995zM10.5 16.5L9 15l-3 3h12v-2.7L15 12l-4.5 4.5zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

ImageIcon.displayName = 'ImageIcon';
var _default = ImageIcon;
exports.default = _default;

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var AudioIcon = function AudioIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M19 6.673V15.2a2.8 2.8 0 0 1-2.8 2.8h-.4a2.8 2.8 0 0 1-2.8-2.8v-.4a2.8 2.8 0 0 1 2.8-2.8h.4c.278 0 .547.04.8.116V8.242l-6 .621V16.2A2.8 2.8 0 0 1 8.2 19h-.4A2.8 2.8 0 0 1 5 16.2v-.4A2.8 2.8 0 0 1 7.8 13h.4c.278 0 .547.04.8.116V6.654c0-.38.31-.721.72-.764l8.56-.886c.398-.041.72.235.72.615v1.054z\" fill=\"currentColor\"/></svg>"
  }, props));
};

AudioIcon.displayName = 'AudioIcon';
var _default = AudioIcon;
exports.default = _default;

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var MediaServicesVideoIcon = function MediaServicesVideoIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill-rule=\"evenodd\"><rect fill=\"currentColor\" x=\"4\" y=\"4\" width=\"16\" height=\"16\" rx=\"2\"/><path d=\"M16.37 14.954L14 13.807v-3.613l2.37-1.148c.285-.138.63.05.63.343v5.222c0 .293-.345.481-.63.343\" fill=\"inherit\"/><rect fill=\"inherit\" x=\"7\" y=\"9\" width=\"6\" height=\"6\" rx=\"1\"/></g></svg>"
  }, props));
};

MediaServicesVideoIcon.displayName = 'MediaServicesVideoIcon';
var _default = MediaServicesVideoIcon;
exports.default = _default;

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DocumentIcon = function DocumentIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M17 10.005V19H7V5h5.99v2.49a1.5 1.5 0 0 0 1.5 1.5h4.5v-.522c0-.297-.132-.578-.359-.768l-5.074-4.236c-.36-.3-.813-.464-1.282-.464H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8.995h-2z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

DocumentIcon.displayName = 'DocumentIcon';
var _default = DocumentIcon;
exports.default = _default;

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var PageIcon = function PageIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><rect x=\"8\" y=\"6\" width=\"8\" height=\"2\" rx=\"1\"/><rect x=\"8\" y=\"9\" width=\"8\" height=\"2\" rx=\"1\"/><rect x=\"8\" y=\"12\" width=\"4\" height=\"2\" rx=\"1\"/><path d=\"M7 4v16h10V4H7zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01V3.99z\" fill-rule=\"nonzero\"/></g></svg>"
  }, props));
};

PageIcon.displayName = 'PageIcon';
var _default = PageIcon;
exports.default = _default;

/***/ }),
/* 2284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__);
/* tslint:disable:variable-name */



var colors = {
    image: __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorY200"],
    audio: __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorP200"],
    video: '#ff7143',
    doc: __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorB300"],
    unknown: '#3dc7dc',
};
var IconWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: inline-flex;\n  color: ", ";\n"], ["\n  display: inline-flex;\n  color: ", ";\n"])), function (_a) {
    var type = _a.type;
    return colors[type] || colors.unknown;
});
var templateObject_1;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileTypeIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_media_ui__ = __webpack_require__(51);

/* tslint:disable:variable-name */


var FileTypeIcon = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  float: left;\n  margin-right: 6px;\n  position: relative;\n  top: 1px;\n  img {\n    ", ";\n  }\n"], ["\n  float: left;\n  margin-right: 6px;\n  position: relative;\n  top: 1px;\n  img {\n    ", ";\n  }\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_media_ui__["y" /* size */])('12px !important'));
var templateObject_1;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorIconWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* tslint:disable:variable-name */


var ErrorIconWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  color: #ff991f;\n"], ["\n  display: flex;\n  color: #ff991f;\n"])));
var templateObject_1;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === "object" && module.exports) {
    module.exports = factory();
  } else {
    root.Scrollparent = factory();
  }
}(this, function () {
  var regex = /(auto|scroll)/;

  var parents = function (node, ps) {
    if (node.parentNode === null) { return ps; }

    return parents(node.parentNode, ps.concat([node]));
  };

  var style = function (node, prop) {
    return getComputedStyle(node, null).getPropertyValue(prop);
  };

  var overflow = function (node) {
    return style(node, "overflow") + style(node, "overflow-y") + style(node, "overflow-x");
  };

  var scroll = function (node) {
   return regex.test(overflow(node));
  };

  var scrollParent = function (node) {
    if (!(node instanceof HTMLElement || node instanceof SVGElement)) {
      return ;
    }

    var ps = parents(node.parentNode, []);

    for (var i = 0; i < ps.length; i += 1) {
      if (scroll(ps[i])) {
        return ps[i];
      }
    }

    return document.scrollingElement || document.documentElement;
  };

  return scrollParent;
}));


/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (container) {
  if (!container) {
    return undefined;
  }
  if (container === window) {
    return {
      top: window.pageYOffset,
      left: window.pageXOffset,
      bottom: window.pageYOffset + window.innerHeight,
      right: window.pageXOffset + window.innerWidth
    };
  } else {
    var bounds = (0, _getElementBounds2.default)(container);
    if (bounds) {
      return _extends({}, bounds, {
        bottom: bounds.top + container.offsetHeight,
        right: bounds.left + container.offsetWidth
      });
    } else {
      return undefined;
    }
  }
};

__webpack_require__(208);

var _getElementBounds = __webpack_require__(783);

var _getElementBounds2 = _interopRequireDefault(_getElementBounds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = function (offset) {

  if (!offset) {
    return undefined;
  }

  var offsetTop = void 0;
  var offsetRight = void 0;
  var offsetBottom = void 0;
  var offsetLeft = void 0;

  if ((typeof offset === 'undefined' ? 'undefined' : _typeof(offset)) === 'object') {
    offsetTop = offset.top || 0;
    offsetRight = offset.right || 0;
    offsetBottom = offset.bottom || 0;
    offsetLeft = offset.left || 0;
  } else {
    offsetTop = offset || 0;
    offsetRight = offset || 0;
    offsetBottom = offset || 0;
    offsetLeft = offset || 0;
  }

  return {
    top: offsetTop,
    right: offsetRight,
    bottom: offsetBottom,
    left: offsetLeft
  };
};

__webpack_require__(208);

/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (elementBounds, viewportBounds, offset) {
  var offsetTop = offset && offset.top || 0;
  var offsetRight = offset && offset.right || 0;
  var offsetBottom = offset && offset.bottom || 0;
  var offsetLeft = offset && offset.left || 0;
  return elementBounds.bottom + offsetBottom >= viewportBounds.top && elementBounds.top - offsetTop <= viewportBounds.bottom && elementBounds.right + offsetRight >= viewportBounds.left && elementBounds.left - offsetLeft <= viewportBounds.right;
};

__webpack_require__(208);

/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    return document.compatMode === "BackCompat";
};

/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isPassiveListenerSupported = function isPassiveListenerSupported() {
  var supported = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supported = true;
      }
    });

    window.addEventListener('test', null, opts);
    window.removeEventListener('test', null, opts);
  } catch (e) {}

  return supported;
};

exports.default = isPassiveListenerSupported() ? {
  passive: true
} : undefined;

/***/ }),
/* 2293 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 2294 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 2295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_cardLoading__ = __webpack_require__(332);



/**
 * TODO: MS-699 Remove these loaders when CardView is no longer used externally
 */
var CardView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CardView, _super);
    function CardView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            CardView: CardView.CardView,
        };
        return _this;
    }
    CardView.prototype.componentWillMount = function () {
        var _this = this;
        if (!this.state.CardView) {
            __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 3456)).then(function (module) {
                CardView.CardView = module.CardView;
                _this.setState({ CardView: module.CardView });
            });
        }
    };
    CardView.prototype.render = function () {
        var _a = this.props, dimensions = _a.dimensions, mediaItemType = _a.mediaItemType;
        if (!this.state.CardView) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__utils_cardLoading__["a" /* CardLoading */], { dimensions: dimensions, mediaItemType: mediaItemType }));
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](this.state.CardView, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, this.props));
    };
    return CardView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

//# sourceMappingURL=cardViewLoader.js.map

/***/ }),
/* 2296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return insertMediaGroupNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isNonImagesBanned; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__media_common__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__);




/** These nodes don't allow non images to exist inside them */
var nonImagesBannedNodes = ['listItem'];
var insertMediaGroupNode = function (view, mediaStates, collection) {
    var state = view.state, dispatch = view.dispatch;
    var tr = state.tr, schema = state.schema;
    var _a = schema.nodes, media = _a.media, paragraph = _a.paragraph;
    if (!collection || !media || !mediaStates.length) {
        return;
    }
    var mediaNodes = createMediaFileNodes(mediaStates, collection, media);
    var mediaInsertPos = findMediaInsertPos(state);
    var resolvedInsertPos = tr.doc.resolve(mediaInsertPos);
    var parent = resolvedInsertPos.parent;
    var grandParent = state.selection.$from.node(-1);
    var selectionParent = state.selection.$anchor.node();
    var shouldSplit = selectionParent &&
        selectionParent.type !== schema.nodes.mediaGroup &&
        grandParent &&
        grandParent.type.validContent(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(state.schema.nodes.mediaGroup.createChecked({}, mediaNodes)));
    // insert a paragraph after if reach the end of doc
    // and there is no media group in the front or selection is a non media block node
    var shouldAppendParagraph = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["A" /* isTableCell */])(state) ||
        Object(__WEBPACK_IMPORTED_MODULE_1__utils__["w" /* isInListItem */])(state) ||
        (Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* atTheEndOfDoc */])(state) &&
            (!Object(__WEBPACK_IMPORTED_MODULE_2__media_common__["f" /* posOfPrecedingMediaGroup */])(state) ||
                Object(__WEBPACK_IMPORTED_MODULE_2__media_common__["c" /* isSelectionNonMediaBlockNode */])(state)));
    if (shouldSplit) {
        var content_1 = shouldAppendParagraph
            ? mediaNodes.concat(paragraph.create())
            : mediaNodes;
        // delete the selection or empty paragraph
        var deleteRange = findDeleteRange(state);
        if (!deleteRange) {
            tr.insert(mediaInsertPos, content_1);
        }
        else if (mediaInsertPos <= deleteRange.start) {
            tr.deleteRange(deleteRange.start, deleteRange.end).insert(mediaInsertPos, content_1);
        }
        else {
            tr.insert(mediaInsertPos, content_1).deleteRange(deleteRange.start, deleteRange.end);
        }
        dispatch(tr);
        setSelectionAfterMediaInsertion(view, mediaInsertPos);
        return;
    }
    var content = parent.type === schema.nodes.mediaGroup
        ? mediaNodes // If parent is a mediaGroup do not wrap items again.
        : [schema.nodes.mediaGroup.createChecked({}, mediaNodes)];
    // Don't append new paragraph when adding media to a existing mediaGroup
    if (shouldAppendParagraph && parent.type !== schema.nodes.mediaGroup) {
        content.push(paragraph.create());
    }
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["safeInsert"])(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].fromArray(content), mediaInsertPos)(tr));
};
var createMediaFileNodes = function (mediaStates, collection, media) {
    var nodes = mediaStates.map(function (mediaState) {
        var id = mediaState.id;
        var node = media.create({
            id: id,
            type: 'file',
            collection: collection,
            __key: id,
        });
        Object(__WEBPACK_IMPORTED_MODULE_2__media_common__["a" /* copyOptionalAttrsFromMediaState */])(mediaState, node);
        return node;
    });
    return nodes;
};
var findMediaInsertPos = function (state) {
    var _a = state.selection, $from = _a.$from, $to = _a.$to;
    var nearbyMediaGroupPos = Object(__WEBPACK_IMPORTED_MODULE_2__media_common__["d" /* posOfMediaGroupNearby */])(state);
    if (nearbyMediaGroupPos &&
        (!Object(__WEBPACK_IMPORTED_MODULE_2__media_common__["c" /* isSelectionNonMediaBlockNode */])(state) ||
            ($from.pos < nearbyMediaGroupPos && $to.pos < nearbyMediaGroupPos))) {
        return nearbyMediaGroupPos;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_2__media_common__["c" /* isSelectionNonMediaBlockNode */])(state)) {
        return $to.pos;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* atTheEndOfBlock */])(state)) {
        return $to.pos + 1;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* atTheBeginningOfBlock */])(state)) {
        return $from.pos - 1;
    }
    return $to.pos;
};
var findDeleteRange = function (state) {
    var _a = state.selection, $from = _a.$from, $to = _a.$to;
    if (Object(__WEBPACK_IMPORTED_MODULE_2__media_common__["e" /* posOfParentMediaGroup */])(state)) {
        return;
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__media_common__["b" /* isInsidePotentialEmptyParagraph */])(state) || Object(__WEBPACK_IMPORTED_MODULE_2__media_common__["d" /* posOfMediaGroupNearby */])(state)) {
        return range($from.pos, $to.pos);
    }
    return range(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["I" /* startPositionOfParent */])($from) - 1, Object(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* endPositionOfParent */])($to));
};
var range = function (start, end) {
    if (end === void 0) { end = start; }
    return { start: start, end: end };
};
var setSelectionAfterMediaInsertion = function (view, insertPos) {
    var state = view.state;
    var doc = state.doc;
    var mediaPos = Object(__WEBPACK_IMPORTED_MODULE_2__media_common__["d" /* posOfMediaGroupNearby */])(state);
    if (!mediaPos) {
        return;
    }
    var $mediaPos = doc.resolve(mediaPos);
    var endOfMediaGroup = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* endPositionOfParent */])($mediaPos);
    if (endOfMediaGroup + 1 >= doc.nodeSize - 1) {
        // if nothing after the media group, fallback to select the newest uploaded media item
        Object(__WEBPACK_IMPORTED_MODULE_1__utils__["G" /* setNodeSelection */])(view, mediaPos);
    }
    else {
        Object(__WEBPACK_IMPORTED_MODULE_1__utils__["H" /* setTextSelection */])(view, endOfMediaGroup + 1);
    }
};
var isNonImagesBanned = function (node) {
    return node && nonImagesBannedNodes.indexOf(node.type.name) > -1;
};
//# sourceMappingURL=media-files.js.map

/***/ }),
/* 2297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
    return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 3466)).then(function (module) { return module.default; });
});
//# sourceMappingURL=picker-facade-loader.js.map

/***/ }),
/* 2298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_portal__ = __webpack_require__(2299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ModalTransition__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__StackConsumer__ = __webpack_require__(2301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Modal__ = __webpack_require__(2302);















var ModalWrapper =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ModalWrapper, _Component);

  function ModalWrapper() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ModalWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ModalWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onModalClosed", function (onExited) {
      return function (e) {
        if (onExited) {
          onExited();
        }

        if (_this.props.onCloseComplete) {
          _this.props.onCloseComplete(e);
        }
      };
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ModalWrapper, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ModalTransition__["a" /* ModalTransitionConsumer */], null, function (_ref) {
        var isOpen = _ref.isOpen,
            onExited = _ref.onExited;
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__atlaskit_portal__["a" /* default */], {
          zIndex: __WEBPACK_IMPORTED_MODULE_9__atlaskit_theme__["layers"].modal()
        }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__StackConsumer__["a" /* default */], {
          isOpen: isOpen
        }, function (naturalStackIndex) {
          return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Modal__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, _this2.props, {
            isOpen: isOpen,
            stackIndex: _this2.props.stackIndex || naturalStackIndex,
            onCloseComplete: _this2.onModalClosed(onExited)
          }));
        }));
      });
    }
  }]);

  return ModalWrapper;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(ModalWrapper, "defaultProps", {
  autoFocus: true,
  scrollBehavior: 'inside',
  shouldCloseOnEscapePress: true,
  shouldCloseOnOverlayClick: true,
  isChromeless: false,
  width: 'medium',
  isHeadingMultiline: true,
  onClose: function onClose() {}
});

/* harmony default export */ __webpack_exports__["a"] = (ModalWrapper);

/***/ }),
/* 2299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Portal__ = __webpack_require__(2300);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Portal__["a"]; });


/***/ }),
/* 2300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_tiny_invariant__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_exenv__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_exenv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_exenv__);












var createContainer = function createContainer(zIndex) {
  var container = document.createElement('div');
  container.setAttribute('class', 'atlaskit-portal');
  container.setAttribute('style', "z-index: ".concat(zIndex, ";"));
  return container;
};

var body = function body() {
  Object(__WEBPACK_IMPORTED_MODULE_9_tiny_invariant__["a" /* default */])(document && document.body, 'cannot find document.body');
  return document.body;
};

var portalParent = function portalParent() {
  var parentElement = document.querySelector('body > .atlaskit-portal-container');

  if (!parentElement) {
    var parent = document.createElement('div');
    parent.setAttribute('class', 'atlaskit-portal-container');
    parent.setAttribute('style', "display: flex;");
    body().appendChild(parent);
    return parent;
  }

  return parentElement;
}; // This is a generic component does two things:
// 1. Portals it's children using React.createPortal
// 2. Creates the DOM node container for the portal based on props
// 3. Ensures DOM the container creates it's own stacking context


var Portal =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Portal, _React$Component);

  function Portal() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Portal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Portal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      container: __WEBPACK_IMPORTED_MODULE_10_exenv__["canUseDOM"] ? createContainer(_this.props.zIndex) : undefined,
      portalIsMounted: false
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Portal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var container = this.state.container;
      var zIndex = this.props.zIndex;

      if (container && prevProps.zIndex !== zIndex) {
        var newContainer = createContainer(zIndex);
        portalParent().replaceChild(container, newContainer); // eslint-disable-next-line react/no-did-update-set-state

        this.setState({
          container: newContainer
        });
      } else if (!prevState.container && container) {
        // SSR path
        portalParent().appendChild(container);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var container = this.state.container;
      var zIndex = this.props.zIndex;

      if (container) {
        portalParent().appendChild(container);
      } else {
        // SSR path
        var newContainer = createContainer(zIndex); // eslint-disable-next-line react/no-did-mount-set-state

        this.setState({
          container: newContainer
        });
      } // eslint-disable-next-line react/no-did-mount-set-state


      this.setState({
        portalIsMounted: true
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var container = this.state.container;

      if (container) {
        portalParent().removeChild(container); // clean up parent element if there are no more portals

        var portals = !!document.querySelector('body > .atlaskit-portal-container > .atlaskit-portal');

        if (!portals) {
          body().removeChild(portalParent());
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          container = _this$state.container,
          portalIsMounted = _this$state.portalIsMounted;
      return container && portalIsMounted ? __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.createPortal(this.props.children, container) : null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Portal, "defaultProps", {
  zIndex: 0
});

/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 2301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);









// This is the source of truth for open modals
var stackConsumers = []; // This component provides the position of a modal dialog in the list of all open dialogs.
// The key behaviours are:
// - When a modal renders for the first time it takes the first stack position
// - When a modal mounts, all other modals have to adjust their position
// - When a modal unmounts, all other modals have to adjust their position

var StackConsumer =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(StackConsumer, _React$Component);

  function StackConsumer() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, StackConsumer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(StackConsumer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      stackIndex: 0
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "update", function () {
      var stackIndex = stackConsumers.indexOf(_this.update);

      if (_this.state.stackIndex !== stackIndex) {
        _this.setState({
          stackIndex: stackIndex
        });
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(StackConsumer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      stackConsumers.forEach(function (updateFn) {
        return updateFn();
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this2 = this;

      // This check will pass if the <Transition><Modal/></Transition> pattern has not been
      // implemented correctly. In this case, will still need to make sure we remove ourselves
      // from the stack list.
      if (stackConsumers.indexOf(this.update) !== -1) {
        stackConsumers = stackConsumers.filter(function (stack) {
          return stack !== _this2.update;
        });
        stackConsumers.forEach(function (updateFn) {
          return updateFn();
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      if (prevProps.isOpen && !this.props.isOpen) {
        stackConsumers = stackConsumers.filter(function (stack) {
          return stack !== _this3.update;
        });
        stackConsumers.forEach(function (updateFn) {
          return updateFn();
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (stackConsumers.indexOf(this.update) === -1) {
        // add this instance to stack consumer list
        stackConsumers = [this.update].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(stackConsumers));
      }

      return this.props.children(this.state.stackIndex);
    }
  }]);

  return StackConsumer;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (StackConsumer);

/***/ }),
/* 2302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Positioner */
/* unused harmony export ModalDialogWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_exenv__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_exenv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_exenv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_analytics_next__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_blanket__ = __webpack_require__(2303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__package_json__ = __webpack_require__(2307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_variables__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styled_Modal__ = __webpack_require__(2308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Animation__ = __webpack_require__(2309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Content__ = __webpack_require__(2314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__FocusLock__ = __webpack_require__(2333);


















var Positioner = function Positioner(_ref) {
  var scrollBehavior = _ref.scrollBehavior,
      props = __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectWithoutProperties___default()(_ref, ["scrollBehavior"]);

  var PositionComponent = scrollBehavior === 'inside' ? __WEBPACK_IMPORTED_MODULE_14__styled_Modal__["c" /* PositionerAbsolute */] : __WEBPACK_IMPORTED_MODULE_14__styled_Modal__["d" /* PositionerRelative */];
  return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(PositionComponent, props);
};

function getScrollDistance() {
  return window.pageYOffset || document.documentElement && document.documentElement.scrollTop || document.body && document.body.scrollTop || 0;
}

var Modal =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Modal, _Component);

  function Modal() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Modal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      dialogNode: null,
      scrollDistance: __WEBPACK_IMPORTED_MODULE_9_exenv__["canUseDOM"] ? getScrollDistance() : 0,
      isExiting: false
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleWindowScroll", function () {
      if (getScrollDistance() !== _this.state.scrollDistance) {
        window.scrollTo(window.pageXOffset, _this.state.scrollDistance);
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleOverlayClick", function (e) {
      if (_this.props.shouldCloseOnOverlayClick) {
        _this.props.onClose(e);
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var scrollDistance = getScrollDistance();

      if (getScrollDistance() !== this.state.scrollDistance) {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({
          scrollDistance: scrollDistance
        });
      }

      window.addEventListener('scroll', this.handleWindowScroll);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleWindowScroll);
    }
    /* Prevent window from being scrolled programatically so that the modal is positioned correctly
     * and to prevent scrollIntoView from scrolling the window.
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          actions = _this$props.actions,
          appearance = _this$props.appearance,
          autoFocus = _this$props.autoFocus,
          body = _this$props.body,
          children = _this$props.children,
          components = _this$props.components,
          footer = _this$props.footer,
          header = _this$props.header,
          height = _this$props.height,
          isChromeless = _this$props.isChromeless,
          isHeadingMultiline = _this$props.isHeadingMultiline,
          isOpen = _this$props.isOpen,
          onClose = _this$props.onClose,
          onCloseComplete = _this$props.onCloseComplete,
          onOpenComplete = _this$props.onOpenComplete,
          onStackChange = _this$props.onStackChange,
          shouldCloseOnEscapePress = _this$props.shouldCloseOnEscapePress,
          stackIndex = _this$props.stackIndex,
          heading = _this$props.heading,
          width = _this$props.width,
          scrollBehavior = _this$props.scrollBehavior;
      var scrollDistance = this.state.scrollDistance;
      var isBackground = stackIndex != null && stackIndex > 0; // If a custom width (number or percentage) is supplied, set inline style
      // otherwise allow styled component to consume as named prop

      var widthName = __WEBPACK_IMPORTED_MODULE_13__shared_variables__["a" /* WIDTH_ENUM */].values.includes(width) ? width : null;
      var widthValue = widthName ? null : width;
      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Animation__["a" /* Animation */], {
        in: isOpen,
        onExited: onCloseComplete,
        onEntered: onOpenComplete,
        stackIndex: stackIndex
      }, function (_ref2) {
        var fade = _ref2.fade,
            slide = _ref2.slide;
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled_Modal__["b" /* FillScreen */], {
          style: fade,
          "aria-hidden": isBackground,
          scrollDistance: scrollDistance
        }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__FocusLock__["a" /* default */], {
          isEnabled: stackIndex === 0 && isOpen,
          autoFocus: autoFocus
        }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__atlaskit_blanket__["a" /* default */], {
          isTinted: true,
          onBlanketClicked: _this2.handleOverlayClick
        }), __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Positioner, {
          style: slide,
          scrollBehavior: scrollBehavior,
          widthName: widthName,
          widthValue: widthValue
        }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styled_Modal__["a" /* Dialog */], {
          heightValue: height,
          isChromeless: isChromeless,
          role: "dialog",
          tabIndex: "-1"
        }, __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Content__["a" /* default */], {
          actions: actions,
          appearance: appearance,
          components: components,
          footer: footer,
          heading: heading,
          isHeadingMultiline: isHeadingMultiline,
          header: header,
          onClose: onClose,
          shouldScroll: scrollBehavior === 'inside',
          shouldCloseOnEscapePress: shouldCloseOnEscapePress,
          onStackChange: onStackChange,
          isChromeless: isChromeless,
          stackIndex: stackIndex,
          body: body
        }, children)))));
      });
    }
  }]);

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Modal, "defaultProps", {
  autoFocus: true,
  scrollBehavior: 'inside',
  shouldCloseOnEscapePress: true,
  shouldCloseOnOverlayClick: true,
  isChromeless: false,
  isOpen: true,
  stackIndex: 0,
  width: 'medium',
  isHeadingMultiline: true
});

var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_10__atlaskit_analytics_next__["createAndFireEvent"])('atlaskit');
var ModalDialogWithoutAnalytics = Modal;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__atlaskit_analytics_next__["withAnalyticsContext"])({
  componentName: 'modalDialog',
  packageName: __WEBPACK_IMPORTED_MODULE_12__package_json__["name"],
  packageVersion: __WEBPACK_IMPORTED_MODULE_12__package_json__["version"]
})(Object(__WEBPACK_IMPORTED_MODULE_10__atlaskit_analytics_next__["withAnalyticsEvents"])({
  onClose: createAndFireEventOnAtlaskit({
    action: 'closed',
    actionSubject: 'modalDialog',
    attributes: {
      componentName: 'modalDialog',
      packageName: __WEBPACK_IMPORTED_MODULE_12__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_12__package_json__["version"]
    }
  })
})(Modal)));

/***/ }),
/* 2303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Blanket__ = __webpack_require__(2304);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Blanket__["a"]; });


/***/ }),
/* 2304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BlanketWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__package_json__ = __webpack_require__(2305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styled__ = __webpack_require__(2306);











var Blanket =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Blanket, _PureComponent);

  function Blanket() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Blanket);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Blanket).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Blanket, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          canClickThrough = _this$props.canClickThrough,
          isTinted = _this$props.isTinted,
          onBlanketClicked = _this$props.onBlanketClicked;
      var onClick = canClickThrough ? null : onBlanketClicked;
      var containerProps = {
        canClickThrough: canClickThrough,
        isTinted: isTinted,
        onClick: onClick
      };
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styled__["a" /* default */], containerProps);
    }
  }]);

  return Blanket;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(Blanket, "defaultProps", {
  canClickThrough: false,
  isTinted: false,
  onBlanketClicked: function onBlanketClicked() {}
});


var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__["createAndFireEvent"])('atlaskit');
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__["withAnalyticsContext"])({
  componentName: 'blanket',
  packageName: __WEBPACK_IMPORTED_MODULE_8__package_json__["name"],
  packageVersion: __WEBPACK_IMPORTED_MODULE_8__package_json__["version"]
})(Object(__WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__["withAnalyticsEvents"])({
  onBlanketClicked: createAndFireEventOnAtlaskit({
    action: 'clicked',
    actionSubject: 'blanket',
    attributes: {
      componentName: 'blanket',
      packageName: __WEBPACK_IMPORTED_MODULE_8__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_8__package_json__["version"]
    }
  })
})(Blanket)));

/***/ }),
/* 2305 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/blanket","version":"7.0.12","sideEffects":false}

/***/ }),
/* 2306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export opacity */
/* unused harmony export pointerEvents */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);


var backgroundColor = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
  light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N100A,
  dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN90A
});
var opacity = function opacity(p) {
  return p.isTinted ? 1 : 0;
};
var pointerEvents = function pointerEvents(p) {
  return p.canClickThrough ? 'none' : 'initial';
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "styled",
  componentId: "knyj0u-0"
})(["\n  background: ", ";\n  bottom: 0;\n  left: 0;\n  opacity: ", ";\n  pointer-events: ", ";\n  position: fixed;\n  right: 0;\n  top: 0;\n  transition: opacity 220ms;\n  z-index: ", ";\n"], backgroundColor, opacity, pointerEvents, __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["layers"].blanket));

/***/ }),
/* 2307 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/modal-dialog","version":"7.2.3","sideEffects":false}

/***/ }),
/* 2308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dialogWidth */
/* unused harmony export dialogHeight */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FillScreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PositionerAbsolute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PositionerRelative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_flex_max_height_ie_fix__ = __webpack_require__(786);





var boxShadow = function boxShadow(_ref) {
  var isChromeless = _ref.isChromeless;
  return isChromeless ? 'none' : "\n    0 0 0 1px ".concat(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N30A, ", 0 2px 1px ").concat(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N30A, ",\n    0 0 20px -6px ").concat(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N60A, "\n  ");
};

var dialogBgColor = function dialogBgColor(_ref2) {
  var isChromeless = _ref2.isChromeless;
  return isChromeless ? 'transparent' : Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
    light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N0,
    dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN50
  });
};

var maxDimensions = "calc(100% - ".concat(__WEBPACK_IMPORTED_MODULE_2__shared_variables__["b" /* gutter */] * 2, "px)");
var maxHeightDimensions = "calc(100% - ".concat(__WEBPACK_IMPORTED_MODULE_2__shared_variables__["b" /* gutter */] * 2 - __WEBPACK_IMPORTED_MODULE_3__utils_flex_max_height_ie_fix__["a" /* IEMaxHeightCalcPx */], "px)");
var dialogWidth = function dialogWidth(_ref3) {
  var widthName = _ref3.widthName,
      widthValue = _ref3.widthValue;

  if (typeof widthValue === 'number') {
    return "".concat(widthValue, "px");
  }

  return widthName ? "".concat(__WEBPACK_IMPORTED_MODULE_2__shared_variables__["a" /* WIDTH_ENUM */].widths[widthName], "px") : widthValue || 'auto';
};
var dialogHeight = function dialogHeight(_ref4) {
  var heightValue = _ref4.heightValue;

  if (typeof heightValue === 'number') {
    return "".concat(heightValue, "px");
  }

  return heightValue || 'auto';
};
/**
  NOTE:
  z-index
  - temporarily added to beat @atlaskit/navigation

  absolute + top
  - rather than fixed position so popper.js children are properly positioned

  overflow-y
  - only active when popper.js children envoked below the dialog
*/

var FillScreen = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Modal__FillScreen",
  componentId: "sc-1jmnqyd-0"
})(["\n  height: 100vh;\n  left: 0;\n  overflow-y: auto;\n  position: absolute;\n  top: ", "px;\n  width: 100%;\n  z-index: ", ";\n  -webkit-overflow-scrolling: touch;\n"], function (p) {
  return p.scrollDistance;
}, __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["layers"].modal);
var PositionerAbsolute = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Modal__PositionerAbsolute",
  componentId: "sc-1jmnqyd-1"
})(["\n  display: flex;\n  flex-direction: column;\n  height: ", ";\n  left: 0;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: ", ";\n  position: absolute;\n  right: 0;\n  top: ", "px;\n  width: ", ";\n  z-index: ", ";\n  pointer-events: none;\n"], maxHeightDimensions, maxDimensions, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["b" /* gutter */], dialogWidth, __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["layers"].modal);
var PositionerRelative = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Modal__PositionerRelative",
  componentId: "sc-1jmnqyd-2"
})(["\n  margin: ", "px auto;\n  position: relative;\n  width: ", ";\n  z-index: ", ";\n  pointer-events: none;\n"], __WEBPACK_IMPORTED_MODULE_2__shared_variables__["b" /* gutter */], dialogWidth, __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["layers"].modal);
var Dialog = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "Modal__Dialog",
  componentId: "sc-1jmnqyd-3"
})(["\n  ", " color: ", ";\n  display: flex;\n  flex-direction: column;\n  height: ", ";\n  ", ";\n  outline: 0;\n  pointer-events: auto;\n"], function (p) {
  return p.isChromeless ? null : Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n          background-color: ", ";\n          border-radius: ", "px;\n          box-shadow: ", ";\n        "], dialogBgColor, __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["borderRadius"], boxShadow);
}, __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].text, dialogHeight, __WEBPACK_IMPORTED_MODULE_3__utils_flex_max_height_ie_fix__["b" /* flexMaxHeightIEFix */]);
PositionerAbsolute.displayName = 'PositionerAbsolute';
Dialog.displayName = 'Dialog';
FillScreen.displayName = 'FillScreen';
PositionerRelative.displayName = 'PositionerRelative';

/***/ }),
/* 2309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Animation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group__ = __webpack_require__(2310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_transition_group__);



var duration = 500;
var easing = 'cubic-bezier(0.23, 1, 0.32, 1)'; // easeOutQuint

var verticalOffset = 16; // Animation
// ==============================
// Modal has two parts that need to be animated. Everything should fade in/out
// and the popup should slide up/up (sic). These animations happen at the same time.
// This component calls it's children with the styles for both animations.

var Animation = function Animation(_ref) {
  var hasEntered = _ref.in,
      _ref$stackIndex = _ref.stackIndex,
      stackIndex = _ref$stackIndex === void 0 ? 0 : _ref$stackIndex,
      onExited = _ref.onExited,
      onEntered = _ref.onEntered,
      children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_transition_group__["Transition"], {
    in: hasEntered,
    timeout: {
      enter: 0,
      exit: duration
    },
    onExited: onExited,
    onEntered: onEntered,
    appear: true
  }, function (unadjustedStatus) {
    // when we first render, we want to finish the 'entering' state render
    // then jump to the 'entered' state as quick as possible.
    var adjustedStatus = hasEntered && unadjustedStatus === 'exited' ? 'entering' : unadjustedStatus; // Fade styles

    var fadeBase = {
      transition: "opacity ".concat(duration / 2, "ms"),
      opacity: 1
    };
    var fadeTransitions = {
      entering: {
        opacity: 0
      },
      exiting: {
        opacity: 0
      }
    }; // Slide styles

    var slideBase = {
      transition: "transform ".concat(duration, "ms ").concat(easing),
      transform: "translate3d(0, ".concat(verticalOffset * 2, "px, 0)")
    };
    var slideTransitions = {
      entering: {},
      entered: {
        transform: stackIndex > 0 ? "translate3d(0, ".concat(stackIndex * (verticalOffset / 2), "px, 0)") : null
      },
      exiting: {
        transform: "translate3d(0, -".concat(verticalOffset * 2, "px, 0)")
      }
    };
    return children({
      fade: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, fadeBase, fadeTransitions[adjustedStatus]),
      slide: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, slideBase, slideTransitions[adjustedStatus])
    });
  });
};

/***/ }),
/* 2310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__(2311));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__(2312));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(789));

var _Transition = _interopRequireDefault(__webpack_require__(787));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),
/* 2311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(10));

var _addClass = _interopRequireDefault(__webpack_require__(244));

var _removeClass = _interopRequireDefault(__webpack_require__(245));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireDefault(__webpack_require__(787));

var _PropTypes = __webpack_require__(788);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames7 = this.getClassNames(type),
        className = _this$getClassNames7.className,
        activeClassName = _this$getClassNames7.activeClassName,
        doneClassName = _this$getClassNames7.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply spread
   * them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(18);

var _TransitionGroup = _interopRequireDefault(__webpack_require__(789));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 2314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Content; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_raf_schd__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_scrolllock__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_scrolllock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_scrolllock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Footer__ = __webpack_require__(2315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Header__ = __webpack_require__(2329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styled_Content__ = __webpack_require__(275);














function getInitialState() {
  return {
    showFooterKeyline: false,
    showHeaderKeyline: false,
    tabbableElements: []
  };
}

var Content =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Content, _Component);

  function Content() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Content);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Content)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "escapeIsHeldDown", false);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "_isMounted", false);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "scrollContainer", void 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", getInitialState());

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "determineKeylines", Object(__WEBPACK_IMPORTED_MODULE_8_raf_schd__["a" /* default */])(function () {
      if (!_this.scrollContainer) return;
      var _this$scrollContainer = _this.scrollContainer,
          scrollTop = _this$scrollContainer.scrollTop,
          scrollHeight = _this$scrollContainer.scrollHeight,
          clientHeight = _this$scrollContainer.clientHeight;
      var scrollableDistance = scrollHeight - clientHeight;
      var showHeaderKeyline = scrollTop > __WEBPACK_IMPORTED_MODULE_12__styled_Content__["j" /* keylineHeight */];
      var showFooterKeyline = scrollTop <= scrollableDistance - __WEBPACK_IMPORTED_MODULE_12__styled_Content__["j" /* keylineHeight */];

      _this.setState({
        showHeaderKeyline: showHeaderKeyline,
        showFooterKeyline: showFooterKeyline
      });
    }));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "getScrollContainer", function (ref) {
      if (!ref) return;
      _this.scrollContainer = ref;
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleKeyUp", function () {
      _this.escapeIsHeldDown = false;
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleKeyDown", function (event) {
      var _this$props = _this.props,
          onClose = _this$props.onClose,
          shouldCloseOnEscapePress = _this$props.shouldCloseOnEscapePress,
          _this$props$stackInde = _this$props.stackIndex,
          stackIndex = _this$props$stackInde === void 0 ? 0 : _this$props$stackInde; // avoid consumers accidently closing multiple modals if they hold escape.

      if (_this.escapeIsHeldDown) return;
      if (event.key === 'Escape') _this.escapeIsHeldDown = true; // only the foremost modal should be interactive.

      if (!_this._isMounted || stackIndex > 0) return;

      switch (event.key) {
        case 'Escape':
          if (shouldCloseOnEscapePress) onClose(event);
          break;

        default:
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleStackChange", function (stackIndex) {
      var onStackChange = _this.props.onStackChange;
      if (onStackChange) onStackChange(stackIndex);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Content, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true; // $FlowFixMe - issue with document.addEventListener - Enum incompatible

      document.addEventListener('keydown', this.handleKeyDown, false);
      document.addEventListener('keyup', this.handleKeyUp, false);

      if (this.scrollContainer) {
        var capturedScrollContainer = this.scrollContainer;
        window.addEventListener('resize', this.determineKeylines, false);
        capturedScrollContainer.addEventListener('scroll', this.determineKeylines, false);
        this.determineKeylines();
      }
      /* eslint-disable no-console */
      // Check for deprecated props


      if (this.props.header) console.warn("@atlaskit/modal-dialog: Deprecation warning - Use of the header prop in ModalDialog is deprecated. Please compose your ModalDialog using the 'components' prop instead");
      if (this.props.footer) console.warn("@atlaskit/modal-dialog: Deprecation warning - Use of the footer prop in ModalDialog is deprecated. Please compose your ModalDialog using the 'components' prop instead");
      if (this.props.body) console.warn("@atlaskit/modal-dialog: Deprecation warning - Use of the body prop in ModalDialog is deprecated. Please compose your ModalDialog using the 'components' prop instead"); // Check that custom body components have used ForwardRef to attach to a DOM element

      if (this.props.components.Body) {
        if (!(this.scrollContainer instanceof HTMLElement)) {
          console.warn('@atlaskit/modal-dialog: Warning - Ref must attach to a DOM element; check you are using forwardRef and attaching the ref to an appropriate element. Check the examples for more details.');
        }
      }
      /* eslint-enable no-console */

    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var stackIndex = this.props.stackIndex; // update focus scope and let consumer know when stack index has changed

      if (nextProps.stackIndex && nextProps.stackIndex !== stackIndex) {
        this.handleStackChange(nextProps.stackIndex);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false; // $FlowFixMe - issue with document.addEventListener - Enum incompatible

      document.removeEventListener('keydown', this.handleKeyDown, false);
      document.removeEventListener('keyup', this.handleKeyUp, false);

      if (this.scrollContainer) {
        var capturedScrollContainer = this.scrollContainer;
        window.removeEventListener('resize', this.determineKeylines, false);
        capturedScrollContainer.removeEventListener('scroll', this.determineKeylines, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          actions = _this$props2.actions,
          appearance = _this$props2.appearance,
          DeprecatedBody = _this$props2.body,
          components = _this$props2.components,
          children = _this$props2.children,
          footer = _this$props2.footer,
          header = _this$props2.header,
          heading = _this$props2.heading,
          onClose = _this$props2.onClose,
          isChromeless = _this$props2.isChromeless,
          isHeadingMultiline = _this$props2.isHeadingMultiline,
          shouldScroll = _this$props2.shouldScroll;
      var _components$Container = components.Container,
          Container = _components$Container === void 0 ? 'div' : _components$Container,
          CustomBody = components.Body; // Only load in 'div' default if there's no deprecated 'body' prop provided
      // Prefer components.Body over deprecated body prop and default to DefaultBody

      var BodyComponent = Object(__WEBPACK_IMPORTED_MODULE_12__styled_Content__["k" /* styledBody */])(CustomBody) || DeprecatedBody || __WEBPACK_IMPORTED_MODULE_12__styled_Content__["c" /* Body */];
      var _this$state = this.state,
          showFooterKeyline = _this$state.showFooterKeyline,
          showHeaderKeyline = _this$state.showHeaderKeyline;
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__styled_Content__["i" /* Wrapper */], {
        component: Container
      }, isChromeless ? children : __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Header__["a" /* default */], {
        appearance: appearance,
        component: components.Header ? components.Header : header,
        heading: heading,
        onClose: onClose,
        isHeadingMultiline: isHeadingMultiline,
        showKeyline: showHeaderKeyline
      }), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(BodyComponent, {
        innerRef: this.getScrollContainer,
        shouldScroll: shouldScroll
      }, children), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Footer__["a" /* default */], {
        actions: actions,
        appearance: appearance,
        component: components.Footer ? components.Footer : footer,
        onClose: onClose,
        showKeyline: showFooterKeyline
      })), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_scrolllock___default.a, null));
    }
  }]);

  return Content;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Content, "defaultProps", {
  autoFocus: false,
  components: {},
  isChromeless: false,
  stackIndex: 0,
  isHeadingMultiline: true
});



/***/ }),
/* 2315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalFooter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_button__ = __webpack_require__(2316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styled_Content__ = __webpack_require__(275);













var JustifyShim = function JustifyShim(props) {
  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("span", props);
};

var ModalFooter =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(ModalFooter, _Component);

  function ModalFooter() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, ModalFooter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(ModalFooter)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)), "props", void 0);

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(ModalFooter, [{
    key: "render",
    // eslint-disable-line react/sort-comp
    value: function render() {
      var _this$props = this.props,
          actions = _this$props.actions,
          appearance = _this$props.appearance,
          component = _this$props.component,
          onClose = _this$props.onClose,
          showKeyline = _this$props.showKeyline;
      var warning = 'You can provide `component` OR `actions`, not both.';
      if (!component && !actions) return null;
      if (component && actions) return console.warn(warning); // eslint-disable-line no-console

      if (component) {
        return Object(__WEBPACK_IMPORTED_MODULE_9_react__["createElement"])(component, {
          appearance: appearance,
          onClose: onClose,
          showKeyline: showKeyline
        });
      }

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styled_Content__["d" /* Footer */], {
        showKeyline: showKeyline
      }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(JustifyShim, null), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styled_Content__["b" /* Actions */], null, actions ? actions.map(function (_ref, idx) {
        var text = _ref.text,
            rest = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref, ["text"]);

        var variant = idx ? 'subtle' : appearance || 'primary';
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styled_Content__["a" /* ActionItem */], {
          key: text || idx
        }, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__atlaskit_button__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          appearance: variant
        }, rest), text));
      }) : null));
    }
  }]);

  return ModalFooter;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);



/***/ }),
/* 2316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Button__ = __webpack_require__(2317);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Button__["a"]; });
/* unused harmony reexport defaultProps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ButtonGroup__ = __webpack_require__(2327);
/* unused harmony reexport ButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme__ = __webpack_require__(791);
/* unused harmony reexport themeNamespace */



//# sourceMappingURL=index.js.map

/***/ }),
/* 2317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultProps */
/* unused harmony export Button */
/* unused harmony export DefaultedButton */
/* unused harmony export ButtonBase */
/* unused harmony export ButtonWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_analytics_next__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__withDeprecationWarnings__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getButtonProps__ = __webpack_require__(2318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CustomComponentProxy__ = __webpack_require__(2319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled_getButtonStyles__ = __webpack_require__(2320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled_ButtonContent__ = __webpack_require__(2322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styled_ButtonWrapper__ = __webpack_require__(2323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styled_IconWrapper__ = __webpack_require__(2324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styled_LoadingSpinner__ = __webpack_require__(2325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__package_json__ = __webpack_require__(2326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__atlaskit_type_helpers__ = __webpack_require__(667);














var StyledButton = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].button(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", ";\n"], ["\n  ", ";\n"])), __WEBPACK_IMPORTED_MODULE_7__styled_getButtonStyles__["a" /* default */]);
StyledButton.displayName = 'StyledButton';
// Target the <a> here to override a:hover specificity.
var StyledLink = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].a(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  a& {\n    ", ";\n  }\n"], ["\n  a& {\n    ", ";\n  }\n"])), __WEBPACK_IMPORTED_MODULE_7__styled_getButtonStyles__["a" /* default */]);
StyledLink.displayName = 'StyledLink';
var StyledSpan = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", ";\n"], ["\n  ", ";\n"])), __WEBPACK_IMPORTED_MODULE_7__styled_getButtonStyles__["a" /* default */]);
StyledSpan.displayName = 'StyledSpan';
var createStyledComponent = function () {
    // Override pseudo-state specificity.
    // This is necessary because we don't know what DOM element the custom component will render.
    var component = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_6__CustomComponentProxy__["a" /* default */])(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n    &,\n    a&,\n    &:hover,\n    &:active,\n    &:focus {\n      ", "\n    }\n  "], ["\n    &,\n    a&,\n    &:hover,\n    &:active,\n    &:focus {\n      ", "\n    }\n  "])), __WEBPACK_IMPORTED_MODULE_7__styled_getButtonStyles__["a" /* default */]);
    component.displayName = 'StyledCustomComponent';
    return component;
};
var defaultProps = {
    appearance: 'default',
    isDisabled: false,
    isSelected: false,
    isLoading: false,
    spacing: 'default',
    type: 'button',
    shouldFitContainer: false,
    autoFocus: false,
};
var Button = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Button, _super);
    function Button() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isActive: false,
            isFocus: false,
            isHover: false,
        };
        _this.customComponent = null;
        _this.isInteractive = function () { return !_this.props.isDisabled && !_this.props.isLoading; };
        _this.onMouseEnter = function () {
            _this.setState({ isHover: true });
        };
        _this.onMouseLeave = function () { return _this.setState({ isHover: false, isActive: false }); };
        _this.onMouseDown = function (e) {
            e.preventDefault();
            _this.setState({ isActive: true });
        };
        _this.onMouseUp = function () { return _this.setState({ isActive: false }); };
        _this.onFocus = function (event) {
            _this.setState({ isFocus: true });
            if (_this.props.onFocus) {
                _this.props.onFocus(event);
            }
        };
        _this.onBlur = function (event) {
            _this.setState({ isFocus: false });
            if (_this.props.onBlur) {
                _this.props.onBlur(event);
            }
        };
        /* Swallow click events when the button is disabled to prevent inner child clicks bubbling up */
        _this.onInnerClick = function (e) {
            if (!_this.isInteractive()) {
                e.stopPropagation();
            }
            return true;
        };
        _this.getInnerRef = function (ref) {
            _this.button = ref;
            if (_this.props.innerRef) {
                _this.props.innerRef(ref);
            }
        };
        return _this;
    }
    Button.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.component !== nextProps.component) {
            delete this.customComponent;
        }
    };
    Button.prototype.componentDidMount = function () {
        if (this.props.autoFocus && this.button) {
            this.button.focus();
        }
    };
    Button.prototype.getStyledComponent = function () {
        if (this.props.component) {
            if (!this.customComponent) {
                this.customComponent = createStyledComponent();
            }
            return this.customComponent;
        }
        if (this.props.href) {
            return this.props.isDisabled ? StyledSpan : StyledLink;
        }
        return StyledButton;
    };
    Button.prototype.render = function () {
        var _a = this.props, children = _a.children, iconBefore = _a.iconBefore, iconAfter = _a.iconAfter, isLoading = _a.isLoading, shouldFitContainer = _a.shouldFitContainer, spacing = _a.spacing, appearance = _a.appearance, isSelected = _a.isSelected, isDisabled = _a.isDisabled;
        var buttonProps = Object(__WEBPACK_IMPORTED_MODULE_5__getButtonProps__["a" /* default */])(this);
        var StyledComponent = this.getStyledComponent();
        var iconIsOnlyChild = !!((iconBefore && !iconAfter && !children) ||
            (iconAfter && !iconBefore && !children));
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](StyledComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ innerRef: this.getInnerRef }, buttonProps),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__styled_ButtonWrapper__["a" /* default */], { onClick: this.onInnerClick, fit: !!shouldFitContainer },
                isLoading ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__styled_LoadingSpinner__["a" /* default */], { spacing: spacing, appearance: appearance, isSelected: isSelected, isDisabled: isDisabled })) : null,
                iconBefore ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styled_IconWrapper__["a" /* default */], { isLoading: isLoading, spacing: buttonProps.spacing, isOnlyChild: iconIsOnlyChild }, iconBefore)) : null,
                children ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styled_ButtonContent__["a" /* default */], { isLoading: isLoading, followsIcon: !!iconBefore, spacing: buttonProps.spacing }, children)) : null,
                iconAfter ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styled_IconWrapper__["a" /* default */], { isLoading: isLoading, spacing: buttonProps.spacing, isOnlyChild: iconIsOnlyChild }, iconAfter)) : null)));
    };
    return Button;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

var DefaultedButton = Object(__WEBPACK_IMPORTED_MODULE_13__atlaskit_type_helpers__["a" /* withDefaultProps */])(defaultProps, Button);
var ButtonBase = Button;
var ButtonWithoutAnalytics = Object(__WEBPACK_IMPORTED_MODULE_4__withDeprecationWarnings__["a" /* default */])(DefaultedButton);
var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_analytics_next__["createAndFireEvent"])('atlaskit');
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_analytics_next__["withAnalyticsContext"])({
    componentName: 'button',
    packageName: __WEBPACK_IMPORTED_MODULE_12__package_json__["name"],
    packageVersion: __WEBPACK_IMPORTED_MODULE_12__package_json__["version"],
})(Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_analytics_next__["withAnalyticsEvents"])({
    onClick: createAndFireEventOnAtlaskit({
        action: 'clicked',
        actionSubject: 'button',
        attributes: {
            componentName: 'button',
            packageName: __WEBPACK_IMPORTED_MODULE_12__package_json__["name"],
            packageVersion: __WEBPACK_IMPORTED_MODULE_12__package_json__["version"],
        },
    }),
})(ButtonWithoutAnalytics)));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Button.js.map

/***/ }),
/* 2318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

var getAppearanceProps = function (props, state) {
    var appearance = props.appearance, className = props.className, isDisabled = props.isDisabled, isLoading = props.isLoading, isSelected = props.isSelected, spacing = props.spacing, shouldFitContainer = props.shouldFitContainer;
    var isActive = state.isActive, isFocus = state.isFocus, isHover = state.isHover;
    return {
        appearance: appearance,
        className: className,
        disabled: isDisabled,
        isActive: isActive,
        isFocus: isFocus,
        isHover: isHover,
        isLoading: isLoading,
        isSelected: isSelected,
        spacing: spacing,
        fit: shouldFitContainer,
    };
};
var getInteractionProps = function (component) {
    var onBlur = component.onBlur, onFocus = component.onFocus, onMouseDown = component.onMouseDown, onMouseEnter = component.onMouseEnter, onMouseLeave = component.onMouseLeave, onMouseUp = component.onMouseUp;
    var tabIndex = component.props.tabIndex;
    // Block onClick/Keyboard submit while isLoading
    var onClick = component.props.isLoading
        ? function (e) { return e.preventDefault(); }
        : component.props.onClick;
    return {
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        tabIndex: tabIndex,
    };
};
var getLinkElementProps = function (props) {
    var href = props.href, target = props.target;
    return { href: href, target: target };
};
var getButtonElementProps = function (props) {
    var ariaHaspopup = props.ariaHaspopup, ariaExpanded = props.ariaExpanded, ariaControls = props.ariaControls, form = props.form, type = props.type;
    return {
        'aria-haspopup': ariaHaspopup,
        'aria-expanded': ariaExpanded,
        'aria-controls': ariaControls,
        form: form,
        type: type,
    };
};
var getButtonProps = function (component) {
    var props = component.props, state = component.state;
    var defaultProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ id: props.id }, getAppearanceProps(props, state), getInteractionProps(component), { 'aria-label': props.ariaLabel });
    if (props.component) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, props, defaultProps);
    }
    if (props.href) {
        if (props.isDisabled) {
            return defaultProps;
        }
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, defaultProps, getLinkElementProps(props));
    }
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, defaultProps, getButtonElementProps(props));
};
/* harmony default export */ __webpack_exports__["a"] = (getButtonProps);
//# sourceMappingURL=getButtonProps.js.map

/***/ }),
/* 2319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_analytics_next__ = __webpack_require__(29);

// @flow


var CustomComponentProxy = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CustomComponentProxy, _super);
    function CustomComponentProxy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomComponentProxy.prototype.render = function () {
        var _a = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_analytics_next__["cleanProps"])(this.props), appearance = _a.appearance, children = _a.children, component = _a.component, isActive = _a.isActive, isDisabled = _a.isDisabled, isFocus = _a.isFocus, isHover = _a.isHover, isSelected = _a.isSelected, shouldFitContainer = _a.shouldFitContainer, fit = _a.fit, iconBefore = _a.iconBefore, iconAfter = _a.iconAfter, isLoading = _a.isLoading, proxiedProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["appearance", "children", "component", "isActive", "isDisabled", "isFocus", "isHover", "isSelected", "shouldFitContainer", "fit", "iconBefore", "iconAfter", "isLoading"]);
        if (!component) {
            throw new Error('No custom component provided while trying to use custom button component');
        }
        var ProxiedComponent = component;
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ProxiedComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, proxiedProps), children);
    };
    return CustomComponentProxy;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (CustomComponentProxy);
//# sourceMappingURL=CustomComponentProxy.js.map

/***/ }),
/* 2320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPropertyAppearance */
/* harmony export (immutable) */ __webpack_exports__["a"] = getButtonStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__themeDefinitions__ = __webpack_require__(2321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__theme__ = __webpack_require__(791);





// TODO: Type correctly when @atlaskit/theme is typescript
var getProvidedTheme = function (_a) {
    var theme = _a.theme;
    return (theme && theme[__WEBPACK_IMPORTED_MODULE_4__theme__["a" /* themeNamespace */]]) || {};
};
var getAppearanceProperty = function (property, appearance, providedTheme, inBuiltTheme) {
    var defaultAppearanceStyles = inBuiltTheme.default;
    if (!appearance) {
        return defaultAppearanceStyles[property];
    }
    var providedAppearanceStyles = providedTheme[appearance];
    var inBuiltAppearanceStyles = inBuiltTheme[appearance];
    return ((providedAppearanceStyles && providedAppearanceStyles[property]) ||
        (inBuiltAppearanceStyles && inBuiltAppearanceStyles[property]) ||
        defaultAppearanceStyles[property]);
};
var getState = function (_a) {
    var disabled = _a.disabled, isActive = _a.isActive, isFocus = _a.isFocus, isHover = _a.isHover, isSelected = _a.isSelected;
    if (disabled) {
        return 'disabled';
    }
    if (isSelected && isFocus) {
        return 'focusSelected';
    }
    if (isSelected) {
        return 'selected';
    }
    if (isActive) {
        return 'active';
    }
    if (isHover) {
        return 'hover';
    }
    if (isFocus) {
        return 'focus';
    }
    return 'default';
};
var getPropertyAppearance = function (property, props, definitions) {
    if (props === void 0) { props = {}; }
    if (definitions === void 0) { definitions = __WEBPACK_IMPORTED_MODULE_3__themeDefinitions__["a" /* default */]; }
    var appearance = props.appearance;
    var fallbacks = definitions.fallbacks, inBuiltTheme = definitions.theme;
    var providedTheme = getProvidedTheme(props);
    var propertyStyles = getAppearanceProperty(property, appearance, providedTheme, inBuiltTheme);
    if (!propertyStyles) {
        return fallbacks[property] || 'initial';
    }
    var state = getState(props);
    return propertyStyles[state] || propertyStyles.default || fallbacks[property];
};
function getButtonStyles(props) {
    // $FlowFixMe - should be fixed when theme work is done
    var baseSize = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["fontSize"])(props);
    var buttonHeight = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 4), baseSize)(props) + "em";
    var compactButtonHeight = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 3), baseSize)(props) + "em";
    /**
     * Variable styles
     */
    var cursor = 'default';
    var height = buttonHeight;
    var lineHeight = buttonHeight;
    var outline = 'none';
    // $FlowFixMe - should be fixed when theme work is done
    var padding = "0 " + Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])(props) + "px";
    var transitionDuration = '0.1s, 0.15s';
    var transition = 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)';
    var verticalAlign = 'middle';
    var width = 'auto';
    /**
     * Appearance + Theme styles
     */
    var background = getPropertyAppearance('background', props);
    var color = getPropertyAppearance('color', props);
    var boxShadowColor = getPropertyAppearance('boxShadowColor', props);
    var boxShadow = boxShadowColor
        ? Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n        box-shadow: 0 0 0 2px ", ";\n      "], ["\n        box-shadow: 0 0 0 2px ", ";\n      "])), boxShadowColor) : null;
    var textDecoration = getPropertyAppearance('textDecoration', props);
    // Spacing: Compact
    if (props.spacing === 'compact') {
        height = compactButtonHeight;
        lineHeight = compactButtonHeight;
    }
    // Spacing: None
    if (props.spacing === 'none') {
        height = 'auto';
        lineHeight = 'inherit';
        padding = '0';
        verticalAlign = 'baseline';
    }
    // Interaction: Hover
    if (props.isHover) {
        cursor = 'pointer';
        transition =
            'background 0s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)';
    }
    // Interaction: Active
    if (props.isActive) {
        transitionDuration = '0s';
    }
    // Interaction: Focus
    if (props.isFocus) {
        outline = 'none';
        transitionDuration = '0s, 0.2s';
    }
    // Disabled
    if (props.disabled) {
        cursor = 'not-allowed';
    }
    // Loading
    var isLoadingStyles = function (p) {
        return p.isLoading ? 'pointer-events: none;' : null;
    };
    // Fit to parent width
    if (props.fit) {
        width = '100%';
    }
    /* Note use of !important to override the ThemeReset on anchor tag styles */
    return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n    align-items: baseline;\n    background: ", ";\n    border-radius: ", "px;\n    border-width: 0;\n    box-sizing: border-box;\n    color: ", " !important;\n    cursor: ", ";\n    display: inline-flex;\n    font-size: inherit;\n    font-style: normal;\n    height: ", ";\n    line-height: ", ";\n    margin: 0;\n    max-width: 100%;\n    outline: ", " !important;\n    padding: ", ";\n    text-align: center;\n    text-decoration: ", ";\n    transition: ", ";\n    transition-duration: ", ";\n    vertical-align: ", ";\n    white-space: nowrap;\n    width: ", ";\n    ", " &::-moz-focus-inner {\n      border: 0;\n      margin: 0;\n      padding: 0;\n    }\n    ", ";\n  "], ["\n    align-items: baseline;\n    background: ", ";\n    border-radius: ", "px;\n    border-width: 0;\n    box-sizing: border-box;\n    color: ", " !important;\n    cursor: ", ";\n    display: inline-flex;\n    font-size: inherit;\n    font-style: normal;\n    height: ", ";\n    line-height: ", ";\n    margin: 0;\n    max-width: 100%;\n    outline: ", " !important;\n    padding: ", ";\n    text-align: center;\n    text-decoration: ", ";\n    transition: ", ";\n    transition-duration: ", ";\n    vertical-align: ", ";\n    white-space: nowrap;\n    width: ", ";\n    ", " &::-moz-focus-inner {\n      border: 0;\n      margin: 0;\n      padding: 0;\n    }\n    ", ";\n  "])), background, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"], color, cursor, height, lineHeight, outline, padding, textDecoration, transition, transitionDuration, verticalAlign, width, boxShadow, isLoadingStyles);
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=getButtonStyles.js.map

/***/ }),
/* 2321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);

/**
 * Convert a hex colour code to RGBA.
 * @param {String} hex Hex colour code.
 * @param {Number} alpha Optional alpha value (defaults to 1).
 *
 */
var hex2rgba = function (hex, alpha) {
    if (alpha === void 0) { alpha = 1; }
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        var colorArr = hex.substring(1).split('');
        if (colorArr.length === 3) {
            colorArr = [
                colorArr[0],
                colorArr[0],
                colorArr[1],
                colorArr[1],
                colorArr[2],
                colorArr[2],
            ];
        }
        var color = "0x" + colorArr.join('');
        // FIXME: `>>` operand can validly take a string value
        var r = (color >> 16) & 255;
        var g = (color >> 8) & 255;
        var b = color & 255;
        return "rgba(" + [r, g, b].join(',') + ", " + alpha + ")";
    }
    throw new Error('Bad Hex');
};
/* eslint-enable no-bitwise */
/* harmony default export */ __webpack_exports__["a"] = ({
    // Fallbacks
    fallbacks: {
        background: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN70 }),
        color: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
        textDecoration: 'none',
    },
    // Themes
    theme: {
        // Default appearance
        default: {
            background: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN70 }),
                hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N30A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN60 }),
                active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75, 0.6), dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN70 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN0 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN0 }),
            },
            boxShadowColor: {
                focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200, 0.6), dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
                    light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200, 0.6),
                    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75,
                }),
            },
            color: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
                active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN30 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
            },
        },
        // Primary appearance
        primary: {
            background: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100 }),
                hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B300, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75 }),
                active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN70 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN0 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN0 }),
            },
            boxShadowColor: {
                focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200, 0.6), dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
                    light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200, 0.6),
                    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75,
                }),
            },
            color: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN30 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN30 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
            },
        },
        // Warning appearance
        warning: {
            background: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y300, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y300 }),
                hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y200, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y200 }),
                active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y400 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN70 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y400 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y400 }),
            },
            boxShadowColor: {
                focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y500 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y500 }),
            },
            color: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N800, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N800 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN30 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N800, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N800 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N800, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N800 }),
            },
        },
        // Danger appearance
        danger: {
            background: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R400 }),
                hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R300, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R300 }),
                active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R500 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN70 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R500 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R500 }),
            },
            boxShadowColor: {
                focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R100, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R100 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R100, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R100 }),
            },
            color: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN30 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0 }),
            },
        },
        // Help appearance
        help: {
            background: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P400 }),
                hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P200, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P200 }),
                active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P500 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN70 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN0 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R500 }),
            },
            boxShadowColor: {
                focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P100, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P100 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P100, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P100 }),
            },
            color: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN30 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N0 }),
            },
        },
        // Link appearance
        link: {
            background: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: 'none', dark: 'none' }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20 }),
            },
            boxShadowColor: {
                focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200, 0.6), dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
                    light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200, 0.6),
                    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75,
                }),
            },
            color: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100 }),
                hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B300, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75 }),
                active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN100 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700 }),
            },
            textDecoration: {
                hover: 'underline',
            },
        },
        // Subtle appearance
        subtle: {
            background: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: 'none', dark: 'none' }),
                hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N30A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN60 }),
                active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75, 0.6), dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: 'none', dark: 'none' }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN0 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN0 }),
            },
            boxShadowColor: {
                focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200, 0.6), dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
                    light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200, 0.6),
                    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75,
                }),
            },
            color: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
                active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN100 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
            },
        },
        // Subtle Link appearance
        'subtle-link': {
            background: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: 'none', dark: 'none' }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20 }),
            },
            boxShadowColor: {
                focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200, 0.6), dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
                    light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B200, 0.6),
                    dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B75,
                }),
            },
            color: {
                default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N200, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
                hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N90, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B50 }),
                active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN300 }),
                disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN100 }),
                selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
                focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400 }),
            },
            textDecoration: {
                hover: 'underline',
            },
        },
    },
});
//# sourceMappingURL=themeDefinitions.js.map

/***/ }),
/* 2322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(792);




var getAlignment = function (p) { return (p.followsIcon ? 'baseline' : 'center'); };
var gridSizeDiv2 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 2);
var getMargin = function (p) {
    return p.spacing === 'none' ? 0 : "0 " + gridSizeDiv2(p) + "px";
};
var ButtonContent = function (props) {
    var style = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ alignItems: getAlignment(props), alignSelf: getAlignment(props), flex: '1 1 auto', margin: getMargin(props), maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }, Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* getLoadingStyle */])(props));
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { style: style }, props.children);
};
/* harmony default export */ __webpack_exports__["a"] = (ButtonContent);
//# sourceMappingURL=ButtonContent.js.map

/***/ }),
/* 2323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var ButtonWrapper = function (props) {
    var style = {
        alignSelf: 'center',
        display: 'inline-flex',
        flexWrap: 'nowrap',
        maxWidth: '100%',
        position: 'relative',
    };
    if (props.fit) {
        style.width = '100%';
        style.justifyContent = 'center';
    }
    var optionalProps = {};
    if (props.onClick) {
        optionalProps.onClick = props.onClick;
    }
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ style: style }, optionalProps), props.children));
};
/* harmony default export */ __webpack_exports__["a"] = (ButtonWrapper);
//# sourceMappingURL=ButtonWrapper.js.map

/***/ }),
/* 2324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(792);




var getMargin = function (props) {
    if (props.spacing === 'none') {
        return 0;
    }
    if (props.isOnlyChild) {
        return "0 -" + __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 4)(props) + "px";
    }
    return "0 " + __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["math"].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"], 2)(props) + "px";
};
var IconWrapper = function (props) {
    var style = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ alignSelf: 'center', display: 'flex', flexShrink: 0, lineHeight: 0, fontSize: 0, margin: getMargin(props), userSelect: 'none' }, Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* getLoadingStyle */])(props));
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { style: style }, props.children);
};
/* harmony default export */ __webpack_exports__["a"] = (IconWrapper);
//# sourceMappingURL=IconWrapper.js.map

/***/ }),
/* 2325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_spinner__ = __webpack_require__(62);




var LoadingDiv = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n"], ["\n  display: flex;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n"])));
var LoadingSpinner = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](LoadingSpinner, _super);
    function LoadingSpinner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.invertSpinner = function () {
            var _a = _this.props, appearance = _a.appearance, isSelected = _a.isSelected, isDisabled = _a.isDisabled;
            if (isSelected) {
                return true;
            }
            if (isDisabled) {
                return false;
            }
            if (appearance === 'primary' ||
                appearance === 'danger' ||
                appearance === 'help') {
                return true;
            }
            return false;
        };
        return _this;
    }
    LoadingSpinner.prototype.render = function () {
        var spacing = this.props.spacing;
        var spinnerSize = 'medium';
        if (spacing !== 'default') {
            spinnerSize = 'small';
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](LoadingDiv, null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_spinner__["a" /* default */], { size: spinnerSize, invertColor: this.invertSpinner() })));
    };
    return LoadingSpinner;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (LoadingSpinner);
var templateObject_1;
//# sourceMappingURL=LoadingSpinner.js.map

/***/ }),
/* 2326 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/button","version":"10.1.2","sideEffects":false}

/***/ }),
/* 2327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__withDeprecationWarnings__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled_ButtonGroup__ = __webpack_require__(2328);




var ButtonGroup = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ButtonGroup, _super);
    function ButtonGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ButtonGroup.prototype.render = function () {
        var _a = this.props, appearance = _a.appearance, children = _a.children;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled_ButtonGroup__["b" /* default */], null, __WEBPACK_IMPORTED_MODULE_1_react__["Children"].map(children, function (child, idx) {
            if (!child) {
                return null;
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled_ButtonGroup__["a" /* GroupItem */], { key: idx }, appearance
                ? __WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"](child, { appearance: appearance })
                : child));
        })));
    };
    return ButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__withDeprecationWarnings__["a" /* default */])(ButtonGroup));
//# sourceMappingURL=ButtonGroup.js.map

/***/ }),
/* 2328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: inline-flex;\n"], ["\n  display: inline-flex;\n"]))));
var GroupItem = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  flex: 1 0 auto;\n  display: flex;\n\n  /* margins don't flip when the layout uses dir=\"rtl\", whereas pseudos do */\n  & + &::before {\n    content: '';\n    display: inline-block;\n    width: ", "px;\n  }\n"], ["\n  flex: 1 0 auto;\n  display: flex;\n\n  /* margins don't flip when the layout uses dir=\"rtl\", whereas pseudos do */\n  & + &::before {\n    content: '';\n    display: inline-block;\n    width: ", "px;\n  }\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() / 2);
var templateObject_1, templateObject_2;
//# sourceMappingURL=ButtonGroup.js.map

/***/ }),
/* 2329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_error__ = __webpack_require__(2330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_warning__ = __webpack_require__(2332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styled_Content__ = __webpack_require__(275);











var icon = {
  danger: __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_error___default.a,
  warning: __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_warning___default.a
};

var TitleIcon = function TitleIcon(_ref) {
  var appearance = _ref.appearance;
  if (!appearance) return null;
  var Icon = icon[appearance];
  return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styled_Content__["g" /* TitleIconWrapper */], {
    appearance: appearance
  }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Icon, {
    label: "".concat(appearance, " icon")
  }));
};

var ModalHeader =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(ModalHeader, _Component);

  function ModalHeader() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ModalHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ModalHeader)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "props", void 0);

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ModalHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          appearance = _this$props.appearance,
          component = _this$props.component,
          heading = _this$props.heading,
          onClose = _this$props.onClose,
          showKeyline = _this$props.showKeyline,
          isHeadingMultiline = _this$props.isHeadingMultiline;
      var warning = 'You can provide `component` OR `heading`, not both.';
      if (!component && !heading) return null;
      if (component && heading) return console.warn(warning); // eslint-disable-line no-console

      if (component) {
        return Object(__WEBPACK_IMPORTED_MODULE_7_react__["createElement"])(component, {
          appearance: appearance,
          onClose: onClose,
          showKeyline: showKeyline,
          isHeadingMultiline: isHeadingMultiline
        });
      }

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styled_Content__["e" /* Header */], {
        showKeyline: showKeyline
      }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styled_Content__["f" /* Title */], {
        isHeadingMultiline: isHeadingMultiline
      }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(TitleIcon, {
        appearance: appearance
      }), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styled_Content__["h" /* TitleText */], {
        isHeadingMultiline: isHeadingMultiline
      }, heading)));
    }
  }]);

  return ModalHeader;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ModalHeader, "defaultProps", {
  isHeadingMultiline: true
});



/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(793));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ErrorIcon = function ErrorIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill-rule=\"evenodd\"><path d=\"M13.416 4.417a2.002 2.002 0 0 0-2.832 0l-6.168 6.167a2.002 2.002 0 0 0 0 2.833l6.168 6.167a2.002 2.002 0 0 0 2.832 0l6.168-6.167a2.002 2.002 0 0 0 0-2.833l-6.168-6.167z\" fill=\"currentColor\"/><path d=\"M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2\" fill=\"inherit\"/></g></svg>"
  }, props));
};

ErrorIcon.displayName = 'ErrorIcon';
var _default = ErrorIcon;
exports.default = _default;

/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = void 0;
var sizes = {
  small: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '48px'
};
exports.sizes = sizes;

/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(793));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var WarningIcon = function WarningIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill-rule=\"evenodd\"><path d=\"M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771L12.938 4.967z\" fill=\"currentColor\"/><path d=\"M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2\" fill=\"inherit\"/></g></svg>"
  }, props));
};

WarningIcon.displayName = 'WarningIcon';
var _default = WarningIcon;
exports.default = _default;

/***/ }),
/* 2333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FocusLock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_tiny_invariant__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_focus_lock__ = __webpack_require__(2334);










// Thin wrapper over react-focus-lock. This wrapper only exists to ensure API compatibility.
// This component should be deleted during https://ecosystem.atlassian.net/browse/AK-5658
var FocusLock =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(FocusLock, _Component);

  function FocusLock() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, FocusLock);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(FocusLock).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(FocusLock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          isEnabled = _this$props.isEnabled,
          autoFocus = _this$props.autoFocus;

      if (false) {
        invariant(typeof autoFocus === 'boolean', '@atlaskit/modal-dialog: Passing a function as autoFocus is deprecated. Instead call focus on the element ref or use the autofocus property.');
      }

      if (typeof autoFocus === 'function' && isEnabled) {
        var elem = autoFocus();

        if (elem && elem.focus) {
          elem.focus();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          isEnabled = _this$props2.isEnabled,
          autoFocus = _this$props2.autoFocus,
          shouldReturnFocus = _this$props2.shouldReturnFocus;
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_focus_lock__["a" /* default */], {
        disabled: !isEnabled,
        autoFocus: !!autoFocus,
        returnFocus: shouldReturnFocus
      }, this.props.children);
    }
  }]);

  return FocusLock;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(FocusLock, "defaultProps", {
  autoFocus: true,
  isEnabled: true,
  shouldReturnFocus: true
});



/***/ }),
/* 2334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Lock__ = __webpack_require__(2335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AutoFocusInside__ = __webpack_require__(2348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MoveFocusInside__ = __webpack_require__(2349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FreeFocusInside__ = __webpack_require__(2350);
/* unused harmony reexport AutoFocusInside */
/* unused harmony reexport MoveFocusInside */
/* unused harmony reexport FreeFocusInside */





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Lock__["a" /* default */]);

/***/ }),
/* 2335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_focus_lock__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Trap__ = __webpack_require__(2345);









var RenderChildren = function RenderChildren(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", null, children);
};

RenderChildren.propTypes =  false ? {
  children: PropTypes.node.isRequired
} : {};
var Fragment = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment : RenderChildren;
var hidden = {
  width: '1px',
  height: '0px',
  padding: 0,
  overflow: 'hidden',
  position: 'fixed',
  top: '1px',
  left: '1px'
};

var FocusLock =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(FocusLock, _Component);

  function FocusLock() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      observed: undefined
    });

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onActivation", function () {
      _this.originalFocusedElement = _this.originalFocusedElement || document && document.activeElement;

      if (_this.state.observed && _this.props.onActivation) {
        _this.props.onActivation(_this.state.observed);
      }

      _this.isActive = true;
    });

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onDeactivation", function () {
      _this.isActive = false;

      if (_this.props.returnFocus && _this.originalFocusedElement && _this.originalFocusedElement.focus) {
        _this.originalFocusedElement.focus();

        _this.originalFocusedElement = null;
      }

      if (_this.props.onDeactivation) {
        _this.props.onDeactivation(_this.state.observed);
      }
    });

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onFocus", function (event) {
      if (_this.isActive) {
        Object(__WEBPACK_IMPORTED_MODULE_7__Trap__["c" /* onFocus */])(event);
      }
    });

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onBlur", __WEBPACK_IMPORTED_MODULE_7__Trap__["b" /* onBlur */]);

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this)), "setObserveNode", function (observed) {
      return _this.setState({
        observed: observed
      });
    });

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this)), "isActive", false);

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this)), "update", function () {
      return _this.setState(function (prevState) {
        return {
          escapeAttempts: prevState.escapeAttempts + 1
        };
      });
    });

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this)), "originalFocusedElement", null);

    return _this;
  }

  var _proto = FocusLock.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        children = _this$props.children,
        disabled = _this$props.disabled,
        noFocusGuards = _this$props.noFocusGuards,
        persistentFocus = _this$props.persistentFocus,
        autoFocus = _this$props.autoFocus,
        allowTextSelection = _this$props.allowTextSelection,
        group = _this$props.group,
        className = _this$props.className,
        whiteList = _this$props.whiteList,
        _this$props$as = _this$props.as,
        Container = _this$props$as === void 0 ? 'div' : _this$props$as,
        _this$props$lockProps = _this$props.lockProps,
        containerProps = _this$props$lockProps === void 0 ? {} : _this$props$lockProps;
    var observed = this.state.observed;

    if (false) {
      if (typeof allowTextSelection !== 'undefined') {
        // eslint-disable-next-line no-console
        console.warn('React-Focus-Lock: allowTextSelection is deprecated and enabled by default');
      }
    }

    var lockProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()((_extends2 = {}, _extends2[__WEBPACK_IMPORTED_MODULE_6_focus_lock__["a" /* constants */].FOCUS_DISABLED] = disabled && 'disabled', _extends2[__WEBPACK_IMPORTED_MODULE_6_focus_lock__["a" /* constants */].FOCUS_GROUP] = group, _extends2), containerProps);

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Fragment, null, !noFocusGuards && [__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      key: "guard-first",
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 0,
      style: hidden
    }), // nearest focus guard
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 1,
      style: hidden
    })], __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Container, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      ref: this.setObserveNode
    }, lockProps, {
      className: className,
      onBlur: this.onBlur,
      onFocus: this.onFocus
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Trap__["a" /* default */], {
      observed: observed,
      disabled: disabled,
      persistentFocus: persistentFocus,
      autoFocus: autoFocus,
      whiteList: whiteList,
      onActivation: this.onActivation,
      onDeactivation: this.onDeactivation
    }), children), !noFocusGuards && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 0,
      style: hidden
    }));
  };

  return FocusLock;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FocusLock.propTypes =  false ? {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  returnFocus: PropTypes.bool,
  noFocusGuards: PropTypes.bool,
  allowTextSelection: PropTypes.bool,
  autoFocus: PropTypes.bool,
  persistentFocus: PropTypes.bool,
  group: PropTypes.string,
  className: PropTypes.string,
  whiteList: PropTypes.func,
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
  lockProps: PropTypes.object,
  onActivation: PropTypes.func,
  onDeactivation: PropTypes.func
} : {};
FocusLock.defaultProps = {
  disabled: false,
  returnFocus: false,
  noFocusGuards: false,
  autoFocus: true,
  persistentFocus: false,
  allowTextSelection: undefined,
  group: undefined,
  className: undefined,
  whiteList: undefined,
  as: 'div',
  lockProps: {},
  onActivation: undefined,
  onDeactivation: undefined
};
/* harmony default export */ __webpack_exports__["a"] = (FocusLock);

/***/ }),
/* 2336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ({
  attach: function attach(node, enabled) {},
  detach: function detach() {}
});

/***/ }),
/* 2337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isVisible */
/* unused harmony export notHiddenInput */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCommonParent; });
/* unused harmony export filterFocusable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTabbableNodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllTabbableNodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parentAutofocusables; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabOrder__ = __webpack_require__(2338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabUtils__ = __webpack_require__(2339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(161);




var isElementHidden = function isElementHidden(computedStyle) {
  if (!computedStyle || !computedStyle.getPropertyValue) {
    return false;
  }
  return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};

var isVisible = function isVisible(node) {
  return !node || node === document || !isElementHidden(window.getComputedStyle(node, null)) && isVisible(node.parentNode);
};

var notHiddenInput = function notHiddenInput(node) {
  return !((node.tagName === 'INPUT' || node.tagName === 'BUTTON') && (node.type === 'hidden' || node.disabled));
};

var getParents = function getParents(node) {
  var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  parents.push(node);
  if (node.parentNode) {
    getParents(node.parentNode, parents);
  }
  return parents;
};

var getCommonParent = function getCommonParent(nodea, nodeb) {
  var parentsA = getParents(nodea);
  var parentsB = getParents(nodeb);

  for (var i = 0; i < parentsA.length; i += 1) {
    var currentParent = parentsA[i];
    if (parentsB.indexOf(currentParent) >= 0) {
      return currentParent;
    }
  }
  return false;
};

var filterFocusable = function filterFocusable(nodes) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__array__["b" /* toArray */])(nodes).filter(function (node) {
    return isVisible(node);
  }).filter(function (node) {
    return notHiddenInput(node);
  });
};

var getTabbableNodes = function getTabbableNodes(topNodes) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__tabOrder__["a" /* orderByTabIndex */])(filterFocusable(Object(__WEBPACK_IMPORTED_MODULE_1__tabUtils__["a" /* getFocusables */])(topNodes)), true);
};

var getAllTabbableNodes = function getAllTabbableNodes(topNodes) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__tabOrder__["a" /* orderByTabIndex */])(filterFocusable(Object(__WEBPACK_IMPORTED_MODULE_1__tabUtils__["a" /* getFocusables */])(topNodes)), false);
};

var parentAutofocusables = function parentAutofocusables(topNode) {
  return filterFocusable(Object(__WEBPACK_IMPORTED_MODULE_1__tabUtils__["b" /* getParentAutofocusables */])(topNode));
};

/***/ }),
/* 2338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export tabSort */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return orderByTabIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(161);


var tabSort = function tabSort(a, b) {
  var tabDiff = a.tabIndex - b.tabIndex;
  var indexDiff = a.index - b.index;

  if (tabDiff) {
    if (!a.tabIndex) return 1;
    if (!b.tabIndex) return -1;
  }

  return tabDiff || indexDiff;
};

var orderByTabIndex = function orderByTabIndex(nodes, filterNegative) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* toArray */])(nodes).map(function (node, index) {
    return {
      node: node,
      index: index,
      tabIndex: node.tabIndex
    };
  }).filter(function (data) {
    return !filterNegative || data.tabIndex >= 0;
  }).sort(tabSort);
};

/***/ }),
/* 2339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFocusables; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getParentAutofocusables; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabbables__ = __webpack_require__(2340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(276);




var getFocusables = function getFocusables(parents) {
  return parents.reduce(function (acc, parent) {
    return acc.concat(Object(__WEBPACK_IMPORTED_MODULE_1__array__["b" /* toArray */])(parent.querySelectorAll(__WEBPACK_IMPORTED_MODULE_0__tabbables__["a" /* default */].join(','))));
  }, []);
};

var getParentAutofocusables = function getParentAutofocusables(parent) {
  var parentFocus = parent.querySelectorAll('[' + __WEBPACK_IMPORTED_MODULE_2__constants__["FOCUS_AUTO"] + ']');
  return Object(__WEBPACK_IMPORTED_MODULE_1__array__["b" /* toArray */])(parentFocus).map(function (node) {
    return getFocusables([node]);
  }).reduce(function (acc, nodes) {
    return acc.concat(nodes);
  }, []);
};

/***/ }),
/* 2340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (['button:enabled:not([readonly])', 'select:enabled:not([readonly])', 'textarea:enabled:not([readonly])', 'input:enabled:not([readonly])', 'a[href]', 'area[href]', 'iframe', 'object', 'embed', '[tabindex]', '[contenteditable]', '[autofocus]']);

/***/ }),
/* 2341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isRadio = function isRadio(node) {
  return node.tagName === 'INPUT' && node.type === 'radio';
};

var findSelectedRadio = function findSelectedRadio(node, nodes) {
  return nodes.filter(isRadio).filter(function (el) {
    return el.name === node.name;
  }).filter(function (el) {
    return el.checked;
  })[0] || node;
};

var pickFirstFocus = function pickFirstFocus(nodes) {
  if (nodes[0] && nodes.length > 1) {
    if (isRadio(nodes[0]) && nodes[0].name) {
      return findSelectedRadio(nodes[0], nodes);
    }
  }
  return nodes[0];
};

/* harmony default export */ __webpack_exports__["a"] = (pickFirstFocus);

/***/ }),
/* 2342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_all_affected__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array__ = __webpack_require__(161);



var focusInFrame = function focusInFrame(frame) {
  return frame === document.activeElement;
};

var focusInsideIframe = function focusInsideIframe(topNode) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_all_affected__["a" /* default */])(topNode).reduce(function (result, node) {
    return result || !!Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["a" /* arrayFind */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["b" /* toArray */])(node.querySelectorAll('iframe')), focusInFrame);
  }, false);
};

var focusInside = function focusInside(topNode) {
  var activeElement = document && document.activeElement;

  if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) {
    return false;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_all_affected__["a" /* default */])(topNode).reduce(function (result, node) {
    return result || node.contains(activeElement) || focusInsideIframe(topNode);
  }, false);
};

/* harmony default export */ __webpack_exports__["a"] = (focusInside);

/***/ }),
/* 2343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_array__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(276);



var focusIsHidden = function focusIsHidden() {
  return document && Object(__WEBPACK_IMPORTED_MODULE_0__utils_array__["b" /* toArray */])(document.querySelectorAll('[' + __WEBPACK_IMPORTED_MODULE_1__constants__["FOCUS_ALLOW"] + ']')).some(function (node) {
    return node.contains(document.activeElement);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (focusIsHidden);

/***/ }),
/* 2344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export focusOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__focusMerge__ = __webpack_require__(794);


var focusOn = function focusOn(target) {
  target.focus();
  if (target.contentWindow) {
    target.contentWindow.focus();
  }
};

var guardCount = 0;
var lockDisabled = false;

/* harmony default export */ __webpack_exports__["a"] = (function (topNode, lastNode) {
  var focusable = Object(__WEBPACK_IMPORTED_MODULE_0__focusMerge__["a" /* default */])(topNode, lastNode);

  if (lockDisabled) {
    return;
  }

  if (focusable) {
    if (guardCount > 2) {
      if (false) {
        // eslint-disable-next-line no-console
        console.error('FocusLock: focus-fighting detected. Only one focus management system could be active. ' + 'See https://github.com/theKashey/focus-lock/#focus-fighting');
        lockDisabled = true;
        setTimeout(function () {
          lockDisabled = false;
        }, 1);
      }
      return;
    }
    guardCount++;
    focusOn(focusable.node);
    guardCount--;
  }
});

/***/ }),
/* 2345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return onBlur; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return onFocus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_clientside_effect__ = __webpack_require__(2346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_focus_lock__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(277);






var focusOnBody = function focusOnBody() {
  return document && document.activeElement === document.body;
};

var isFreeFocus = function isFreeFocus() {
  return focusOnBody() || Object(__WEBPACK_IMPORTED_MODULE_3_focus_lock__["d" /* focusIsHidden */])();
};

var lastActiveTrap = null;
var lastActiveFocus = null;
var lastPortaledElement = null;

var defaultWhitelist = function defaultWhitelist() {
  return true;
};

var focusWhitelisted = function focusWhitelisted(activeElement) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
};

var recordPortal = function recordPortal(observerNode, portaledElement) {
  lastPortaledElement = {
    observerNode: observerNode,
    portaledElement: portaledElement
  };
};

var focusIsPortaledPair = function focusIsPortaledPair(element) {
  return lastPortaledElement && lastPortaledElement.portaledElement === element;
};

var activateTrap = function activateTrap() {
  var result = false;

  if (lastActiveTrap) {
    var _lastActiveTrap = lastActiveTrap,
        observed = _lastActiveTrap.observed,
        persistentFocus = _lastActiveTrap.persistentFocus,
        autoFocus = _lastActiveTrap.autoFocus;
    var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
    var activeElement = document && document.activeElement;

    if (!activeElement || focusWhitelisted(activeElement)) {
      if (persistentFocus || !isFreeFocus() || !lastActiveFocus && autoFocus) {
        if (workingNode && !(Object(__WEBPACK_IMPORTED_MODULE_3_focus_lock__["c" /* focusInside */])(workingNode) || focusIsPortaledPair(activeElement, workingNode))) {
          if (document && !lastActiveFocus && activeElement && !autoFocus) {
            activeElement.blur();
            document.body.focus();
          } else {
            result = Object(__WEBPACK_IMPORTED_MODULE_3_focus_lock__["b" /* default */])(workingNode, lastActiveFocus);
            lastPortaledElement = {};
          }
        }

        lastActiveFocus = document && document.activeElement;
      }
    }
  }

  return result;
};

var onTrap = function onTrap(event) {
  if (activateTrap() && event) {
    // prevent scroll jump
    event.stopPropagation();
    event.preventDefault();
  }
};

var onBlur = function onBlur() {
  return Object(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* deferAction */])(activateTrap);
};
var onFocus = function onFocus(event) {
  // detect portal
  var source = event.target;
  var currentNode = event.currentTarget;

  if (!currentNode.contains(source)) {
    recordPortal(currentNode, source);
  }
};

var FocusWatcher = function FocusWatcher() {
  return null;
};

var FocusTrap = function FocusTrap(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    onBlur: onBlur,
    onFocus: onFocus
  }, children);
};

FocusTrap.propTypes =  false ? {
  children: PropTypes.node.isRequired
} : {};

var attachHandler = function attachHandler() {
  document.addEventListener('focusin', onTrap, true);
  document.addEventListener('focusout', onBlur);
};

var detachHandler = function detachHandler() {
  document.removeEventListener('focusin', onTrap, true);
  document.removeEventListener('focusout', onBlur);
};

function reducePropsToState(propsList) {
  return propsList.filter(function (_ref2) {
    var disabled = _ref2.disabled;
    return !disabled;
  }).slice(-1)[0];
}

function handleStateChangeOnClient(trap) {
  if (trap && !lastActiveTrap) {
    attachHandler();
  }

  var lastTrap = lastActiveTrap;
  var sameTrap = lastTrap && trap && trap.onActivation === lastTrap.onActivation;
  lastActiveTrap = trap;

  if (lastTrap && !sameTrap) {
    lastTrap.onDeactivation();
  }

  if (trap) {
    lastActiveFocus = null;

    if (!sameTrap || lastTrap.observed !== trap.observed) {
      trap.onActivation();
    }

    activateTrap(true);
    Object(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* deferAction */])(activateTrap);
  } else {
    detachHandler();
    lastActiveFocus = null;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_clientside_effect__["a" /* default */])(reducePropsToState, handleStateChangeOnClient)(FocusWatcher));

/***/ }),
/* 2346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shallowequal__ = __webpack_require__(2347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shallowequal__);





function withSideEffect(reducePropsToState, handleStateChangeOnClient) {
  if (false) {
    if (typeof reducePropsToState !== 'function') {
      throw new Error('Expected reducePropsToState to be a function.');
    }

    if (typeof handleStateChangeOnClient !== 'function') {
      throw new Error('Expected handleStateChangeOnClient to be a function.');
    }
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (false) {
      if (typeof WrappedComponent !== 'function') {
        throw new Error('Expected WrappedComponent to be a React component.');
      }
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));
      handleStateChangeOnClient(state);
    }

    var SideEffect =
    /*#__PURE__*/
    function (_Component) {
      __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose___default()(SideEffect, _Component);

      function SideEffect() {
        return _Component.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      var _proto = SideEffect.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !__WEBPACK_IMPORTED_MODULE_3_shallowequal___default()(nextProps, this.props);
      };

      _proto.componentDidMount = function componentDidMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    return SideEffect;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (withSideEffect);


/***/ }),
/* 2347 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 2348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_focus_lock__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(277);






var AutoFocusInside = function AutoFocusInside(_ref) {
  var disabled = _ref.disabled,
      children = _ref.children,
      className = _ref.className;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4__util__["b" /* inlineProp */])(__WEBPACK_IMPORTED_MODULE_3_focus_lock__["a" /* constants */].FOCUS_AUTO, !disabled), {
    className: className
  }), children);
};

AutoFocusInside.propTypes =  false ? {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string
} : {};
AutoFocusInside.defaultProps = {
  disabled: false,
  className: undefined
};
/* unused harmony default export */ var _unused_webpack_default_export = (AutoFocusInside);

/***/ }),
/* 2349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_focus_lock__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(277);









var MoveFocusInside =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(MoveFocusInside, _Component);

  function MoveFocusInside() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this)), "setObserveNode", function (ref) {
      _this.observed = ref;

      _this.moveFocus();
    });

    return _this;
  }

  var _proto = MoveFocusInside.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.moveFocus();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.disabled && !this.props.disabled) {
      this.moveFocus();
    }
  };

  _proto.moveFocus = function moveFocus() {
    var observed = this.observed;

    if (!this.props.disabled && observed) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_6_focus_lock__["c" /* focusInside */])(observed)) {
        Object(__WEBPACK_IMPORTED_MODULE_6_focus_lock__["b" /* default */])(observed, null);
      }
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        disabled = _this$props.disabled,
        className = _this$props.className;
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7__util__["b" /* inlineProp */])(__WEBPACK_IMPORTED_MODULE_6_focus_lock__["a" /* constants */].FOCUS_AUTO, !disabled), {
      ref: this.setObserveNode,
      className: className
    }), children);
  };

  return MoveFocusInside;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(MoveFocusInside, "defaultProps", {
  disabled: false,
  className: undefined
});


MoveFocusInside.propTypes =  false ? {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string
} : {};

/***/ }),
/* 2350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_focus_lock__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(277);






var FreeFocusInside = function FreeFocusInside(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4__util__["b" /* inlineProp */])(__WEBPACK_IMPORTED_MODULE_3_focus_lock__["a" /* constants */].FOCUS_ALLOW, true), {
    className: className
  }), children);
};

FreeFocusInside.propTypes =  false ? {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
} : {};
FreeFocusInside.defaultProps = {
  disabled: false,
  className: undefined
};
/* unused harmony default export */ var _unused_webpack_default_export = (FreeFocusInside);

/***/ }),
/* 2351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FieldText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FieldTextStateless__ = __webpack_require__(795);











var FieldText =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(FieldText, _Component);

  function FieldText() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, FieldText);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(FieldText)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "input", void 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "state", {
      value: _this.props.value
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleOnChange", function (e) {
      _this.setState({
        value: e.target.value
      });

      if (_this.props.onChange) {
        _this.props.onChange(e);
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(FieldText, [{
    key: "focus",
    value: function focus() {
      if (this.input) {
        this.input.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__FieldTextStateless__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        value: this.state.value,
        onChange: this.handleOnChange,
        innerRef: function innerRef(fieldRef) {
          _this2.input = fieldRef;
        }
      }));
    }
  }]);

  return FieldText;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(FieldText, "defaultProps", {
  onChange: function onChange() {}
});



/***/ }),
/* 2352 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/field-text","version":"7.0.19","sideEffects":false}

/***/ }),
/* 2353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);



var getPlaceholderColor = function getPlaceholderColor(_ref) {
  var disabled = _ref.disabled;

  if (disabled) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N70,
      dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN90
    });
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["themed"])({
    light: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N100,
    dark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].DN90
  });
}; // can't group these placeholder styles into one block because browsers drop
// entire style blocks when any single selector fails to parse


var getPlaceholderStyle = function getPlaceholderStyle() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  &::-webkit-input-placeholder {\n    /* WebKit, Blink, Edge */\n    color: ", ";\n  }\n  &::-moz-placeholder {\n    /* Mozilla Firefox 19+ */\n    color: ", ";\n    opacity: 1;\n  }\n  &::-ms-input-placeholder {\n    /* Microsoft Edge */\n    color: ", ";\n  }\n  &:-ms-input-placeholder {\n    /* Internet Explorer 10-11 */\n    color: ", ";\n  }\n"], getPlaceholderColor, getPlaceholderColor, getPlaceholderColor, getPlaceholderColor);
}; // Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases


var overrideSafariDisabledStyles = "\n  -webkit-text-fill-color: unset;\n  -webkit-opacity: 1;\n";
var InputElement = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].input.withConfig({
  displayName: "Input__InputElement",
  componentId: "sc-1o6bj35-0"
})(["\n  background: transparent;\n  border: 0;\n  box-sizing: border-box;\n  color: inherit;\n  cursor: inherit;\n  font-family: ", ";\n  font-size: ", "px;\n  min-width: 0;\n  outline: none;\n  width: 100%;\n\n  [disabled] {\n    ", ";\n  }\n\n  &::-ms-clear {\n    display: none;\n  }\n\n  &:invalid {\n    box-shadow: none;\n  }\n  ", ";\n"], function (p) {
  return p.isMonospaced ? Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["codeFontFamily"])() : 'inherit';
}, __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["fontSize"], overrideSafariDisabledStyles, getPlaceholderStyle);
/* harmony default export */ __webpack_exports__["a"] = (InputElement);

/***/ }),
/* 2354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_dispatcher__ = __webpack_require__(200);


var DefaultMediaStateManager = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](DefaultMediaStateManager, _super);
    function DefaultMediaStateManager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = new Map();
        return _this;
    }
    DefaultMediaStateManager.prototype.getState = function (id) {
        return id ? this.state.get(id) : undefined;
    };
    DefaultMediaStateManager.prototype.getAllState = function () {
        return this.state;
    };
    DefaultMediaStateManager.prototype.newState = function (id, newState) {
        var state = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, (this.state.get(id) || {}), newState, { id: id });
        this.state.set(id, state);
        return state;
    };
    DefaultMediaStateManager.prototype.updateState = function (id, newState) {
        var state = this.newState(id, newState);
        this.emit(id, state);
        return state;
    };
    DefaultMediaStateManager.prototype.destroy = function () {
        this.state.clear();
        _super.prototype.destroy.call(this);
    };
    return DefaultMediaStateManager;
}(__WEBPACK_IMPORTED_MODULE_1__event_dispatcher__["a" /* EventDispatcher */]));
/* harmony default export */ __webpack_exports__["a"] = (DefaultMediaStateManager);
//# sourceMappingURL=default-state-manager.js.map

/***/ }),
/* 2355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SetAttrsStep; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_transform__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_transform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_transform__);



/**
 * For more context on what this is about:
 * @see https://discuss.prosemirror.net/t/preventing-image-placeholder-replacement-from-being-undone/1394
 */
var SetAttrsStep = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SetAttrsStep, _super);
    function SetAttrsStep(pos, attrs) {
        var _this = _super.call(this) || this;
        _this.pos = pos;
        _this.attrs = attrs;
        return _this;
    }
    SetAttrsStep.prototype.apply = function (doc) {
        var target = doc.nodeAt(this.pos);
        if (!target) {
            return __WEBPACK_IMPORTED_MODULE_2_prosemirror_transform__["StepResult"].fail('No node at given position');
        }
        var attrs = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, (target.attrs || {}), (this.attrs || {}));
        var newNode = target.type.create(attrs, __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].empty, target.marks);
        var slice = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"](__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(newNode), 0, target.isLeaf ? 0 : 1);
        return __WEBPACK_IMPORTED_MODULE_2_prosemirror_transform__["StepResult"].fromReplace(doc, this.pos, this.pos + 1, slice);
    };
    SetAttrsStep.prototype.invert = function (doc) {
        var target = doc.nodeAt(this.pos);
        return new SetAttrsStep(this.pos, target ? target.attrs : null);
    };
    SetAttrsStep.prototype.map = function (mapping) {
        var result = mapping.mapResult(this.pos, 1);
        return result.deleted ? null : new SetAttrsStep(result.pos, this.attrs);
    };
    SetAttrsStep.prototype.toJSON = function () {
        return { stepType: 'setAttrs', pos: this.pos, attrs: this.attrs };
    };
    SetAttrsStep.fromJSON = function (schema, json) {
        if (typeof json.pos !== 'number' ||
            (json.attrs !== null && typeof json.attrs !== 'object')) {
            throw new RangeError('Invalid input for SetAttrsStep.fromJSON');
        }
        return new SetAttrsStep(json.pos, json.attrs);
    };
    return SetAttrsStep;
}(__WEBPACK_IMPORTED_MODULE_2_prosemirror_transform__["Step"]));

__WEBPACK_IMPORTED_MODULE_2_prosemirror_transform__["Step"].jsonID('setAttrs', SetAttrsStep);
//# sourceMappingURL=step.js.map

/***/ }),
/* 2356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export taskDecisionDocFilter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return taskDecisionSliceFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter__ = __webpack_require__(798);

var taskDecisionAllowedNodeTypes = new Set([
    'text',
    'emoji',
    'mention',
    'hardBreak',
]);
var taskDecisionDocFilter = function (doc, schema) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__filter__["a" /* filterContentByType */])(doc, taskDecisionAllowedNodeTypes, schema, true);
};
var taskDecisionSliceFilter = function (slice, schema) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__filter__["b" /* filterSliceByType */])(slice, taskDecisionAllowedNodeTypes, schema, true);
};
//# sourceMappingURL=task-decision-filter.js.map

/***/ }),
/* 2357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_commands__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_commands___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_commands__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_history__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_history___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_history__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_keymap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pm_plugins_focus_handler__ = __webpack_require__(2359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pm_plugins_inline_cursor_target__ = __webpack_require__(2360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pm_plugins_react_nodeview__ = __webpack_require__(210);








var basePlugin = {
    pmPlugins: function () {
        return [
            {
                name: 'inlineCursorTargetPlugin',
                plugin: function () { return Object(__WEBPACK_IMPORTED_MODULE_6__pm_plugins_inline_cursor_target__["a" /* default */])(); },
            },
            {
                name: 'focusHandlerPlugin',
                plugin: function (_a) {
                    var dispatch = _a.dispatch;
                    return Object(__WEBPACK_IMPORTED_MODULE_5__pm_plugins_focus_handler__["a" /* default */])(dispatch);
                },
            },
            { name: 'reactNodeView', plugin: function () { return __WEBPACK_IMPORTED_MODULE_7__pm_plugins_react_nodeview__["a" /* plugin */]; } },
            { name: 'history', plugin: function () { return Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_history__["history"])(); } },
            // should be last :(
            {
                name: 'codeBlockIndent',
                plugin: function () {
                    return Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_keymap__["keymap"])(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, __WEBPACK_IMPORTED_MODULE_1_prosemirror_commands__["baseKeymap"], { 'Mod-[': function () { return true; }, 'Mod-]': function () { return true; } }));
                },
            },
        ];
    },
    nodes: function () {
        return [
            { name: 'doc', node: __WEBPACK_IMPORTED_MODULE_4__atlaskit_adf_schema__["y" /* doc */] },
            { name: 'paragraph', node: __WEBPACK_IMPORTED_MODULE_4__atlaskit_adf_schema__["_0" /* paragraph */] },
            { name: 'text', node: __WEBPACK_IMPORTED_MODULE_4__atlaskit_adf_schema__["_18" /* text */] },
        ];
    },
};
/* harmony default export */ __webpack_exports__["a"] = (basePlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2358 */
/***/ (function(module, exports) {

var GOOD_LEAF_SIZE = 200

// :: class<T> A rope sequence is a persistent sequence data structure
// that supports appending, prepending, and slicing without doing a
// full copy. It is represented as a mostly-balanced tree.
var RopeSequence = function RopeSequence () {};

RopeSequence.prototype.append = function append (other) {
  if (!other.length) { return this }
  other = RopeSequence.from(other)

  return (!this.length && other) ||
    (other.length < GOOD_LEAF_SIZE && this.leafAppend(other)) ||
    (this.length < GOOD_LEAF_SIZE && other.leafPrepend(this)) ||
    this.appendInner(other)
};

// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
// Prepend an array or other rope to this one, returning a new rope.
RopeSequence.prototype.prepend = function prepend (other) {
  if (!other.length) { return this }
  return RopeSequence.from(other).append(this)
};

RopeSequence.prototype.appendInner = function appendInner (other) {
  return new Append(this, other)
};

// :: (?number, ?number) → RopeSequence<T>
// Create a rope repesenting a sub-sequence of this rope.
RopeSequence.prototype.slice = function slice (from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  if (from >= to) { return RopeSequence.empty }
  return this.sliceInner(Math.max(0, from), Math.min(this.length, to))
};

// :: (number) → T
// Retrieve the element at the given position from this rope.
RopeSequence.prototype.get = function get (i) {
  if (i < 0 || i >= this.length) { return undefined }
  return this.getInner(i)
};

// :: ((element: T, index: number) → ?bool, ?number, ?number)
// Call the given function for each element between the given
// indices. This tends to be more efficient than looping over the
// indices and calling `get`, because it doesn't have to descend the
// tree for every element.
RopeSequence.prototype.forEach = function forEach (f, from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  if (from <= to)
    { this.forEachInner(f, from, to, 0) }
  else
    { this.forEachInvertedInner(f, from, to, 0) }
};

// :: ((element: T, index: number) → U, ?number, ?number) → [U]
// Map the given functions over the elements of the rope, producing
// a flat array.
RopeSequence.prototype.map = function map (f, from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  var result = []
  this.forEach(function (elt, i) { return result.push(f(elt, i)); }, from, to)
  return result
};

// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
// Create a rope representing the given array, or return the rope
// itself if a rope was given.
RopeSequence.from = function from (values) {
  if (values instanceof RopeSequence) { return values }
  return values && values.length ? new Leaf(values) : RopeSequence.empty
};

var Leaf = (function (RopeSequence) {
  function Leaf(values) {
    RopeSequence.call(this)
    this.values = values
  }

  if ( RopeSequence ) Leaf.__proto__ = RopeSequence;
  Leaf.prototype = Object.create( RopeSequence && RopeSequence.prototype );
  Leaf.prototype.constructor = Leaf;

  var prototypeAccessors = { length: {},depth: {} };

  Leaf.prototype.flatten = function flatten () {
    return this.values
  };

  Leaf.prototype.sliceInner = function sliceInner (from, to) {
    if (from == 0 && to == this.length) { return this }
    return new Leaf(this.values.slice(from, to))
  };

  Leaf.prototype.getInner = function getInner (i) {
    return this.values[i]
  };

  Leaf.prototype.forEachInner = function forEachInner (f, from, to, start) {
    var this$1 = this;

    for (var i = from; i < to; i++)
      { if (f(this$1.values[i], start + i) === false) { return false } }
  };

  Leaf.prototype.forEachInvertedInner = function forEachInvertedInner (f, from, to, start) {
    var this$1 = this;

    for (var i = from - 1; i >= to; i--)
      { if (f(this$1.values[i], start + i) === false) { return false } }
  };

  Leaf.prototype.leafAppend = function leafAppend (other) {
    if (this.length + other.length <= GOOD_LEAF_SIZE)
      { return new Leaf(this.values.concat(other.flatten())) }
  };

  Leaf.prototype.leafPrepend = function leafPrepend (other) {
    if (this.length + other.length <= GOOD_LEAF_SIZE)
      { return new Leaf(other.flatten().concat(this.values)) }
  };

  prototypeAccessors.length.get = function () { return this.values.length };

  prototypeAccessors.depth.get = function () { return 0 };

  Object.defineProperties( Leaf.prototype, prototypeAccessors );

  return Leaf;
}(RopeSequence));

// :: RopeSequence
// The empty rope sequence.
RopeSequence.empty = new Leaf([])

var Append = (function (RopeSequence) {
  function Append(left, right) {
    RopeSequence.call(this)
    this.left = left
    this.right = right
    this.length = left.length + right.length
    this.depth = Math.max(left.depth, right.depth) + 1
  }

  if ( RopeSequence ) Append.__proto__ = RopeSequence;
  Append.prototype = Object.create( RopeSequence && RopeSequence.prototype );
  Append.prototype.constructor = Append;

  Append.prototype.flatten = function flatten () {
    return this.left.flatten().concat(this.right.flatten())
  };

  Append.prototype.getInner = function getInner (i) {
    return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length)
  };

  Append.prototype.forEachInner = function forEachInner (f, from, to, start) {
    var leftLen = this.left.length
    if (from < leftLen &&
        this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false)
      { return false }
    if (to > leftLen &&
        this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false)
      { return false }
  };

  Append.prototype.forEachInvertedInner = function forEachInvertedInner (f, from, to, start) {
    var leftLen = this.left.length
    if (from > leftLen &&
        this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false)
      { return false }
    if (to < leftLen &&
        this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false)
      { return false }
  };

  Append.prototype.sliceInner = function sliceInner (from, to) {
    if (from == 0 && to == this.length) { return this }
    var leftLen = this.left.length
    if (to <= leftLen) { return this.left.slice(from, to) }
    if (from >= leftLen) { return this.right.slice(from - leftLen, to - leftLen) }
    return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen))
  };

  Append.prototype.leafAppend = function leafAppend (other) {
    var inner = this.right.leafAppend(other)
    if (inner) { return new Append(this.left, inner) }
  };

  Append.prototype.leafPrepend = function leafPrepend (other) {
    var inner = this.left.leafPrepend(other)
    if (inner) { return new Append(inner, this.right) }
  };

  Append.prototype.appendInner = function appendInner (other) {
    if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1)
      { return new Append(this.left, new Append(this.right, other)) }
    return new Append(this, other)
  };

  return Append;
}(RopeSequence));

module.exports = RopeSequence


/***/ }),
/* 2359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export focusStateKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);

var focusStateKey = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["PluginKey"]('focusStatePlugin');
/* harmony default export */ __webpack_exports__["a"] = (function (dispatch) {
    return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
        key: focusStateKey,
        state: {
            init: function () { return true; },
            apply: function (tr, wasEditorFocused) {
                var meta = tr.getMeta(focusStateKey);
                if (typeof meta === 'boolean') {
                    if (meta !== wasEditorFocused) {
                        dispatch(focusStateKey, meta);
                        return meta;
                    }
                }
                return wasEditorFocused;
            },
        },
        props: {
            handleDOMEvents: {
                click: function (view) {
                    var isEditorFocused = focusStateKey.getState(view.state);
                    if (!isEditorFocused) {
                        view.dispatch(view.state.tr.setMeta(focusStateKey, view.hasFocus()));
                    }
                    return false;
                },
                focus: function (view) {
                    var isEditorFocused = focusStateKey.getState(view.state);
                    if (!isEditorFocused) {
                        view.dispatch(view.state.tr.setMeta(focusStateKey, true));
                    }
                    return false;
                },
                blur: function (view) {
                    var isEditorFocused = focusStateKey.getState(view.state);
                    if (isEditorFocused) {
                        view.dispatch(view.state.tr.setMeta(focusStateKey, false));
                    }
                    return false;
                },
            },
        },
    });
});
//# sourceMappingURL=focus-handler.js.map

/***/ }),
/* 2360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export inlineCursorTargetStateKey */
/* unused harmony export SPECIAL_NODES */
/* unused harmony export isSpecial */
/* unused harmony export findSpecialNodeAfter */
/* unused harmony export findSpecialNodeBefore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_view__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);


var inlineCursorTargetStateKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('inlineCursorTargetPlugin');
var SPECIAL_NODES = ['mention', 'emoji'];
var isSpecial = function (node) {
    return node && SPECIAL_NODES.indexOf(node.type.name) !== -1;
};
var ZWSP = '\u200b';
var findSpecialNodeAfter = function ($pos, tr) {
    if (isSpecial($pos.nodeAfter)) {
        return $pos.pos + 1;
    }
    var parentOffset = $pos.parentOffset, parent = $pos.parent;
    var docSize = tr.doc.nodeSize - 2;
    if (parentOffset === parent.content.size && $pos.pos + 1 < docSize - 2) {
        var nodeAfter = tr.doc.resolve($pos.pos + 1).nodeAfter;
        if (nodeAfter && isSpecial(nodeAfter.firstChild)) {
            return $pos.pos + 2;
        }
    }
};
var findSpecialNodeBefore = function ($pos, tr) {
    if (isSpecial($pos.nodeBefore)) {
        return $pos.pos - 1;
    }
    if ($pos.pos === 0) {
        return;
    }
    var parentOffset = $pos.parentOffset;
    if (parentOffset === 0) {
        var nodeBefore = tr.doc.resolve($pos.pos - 1).nodeBefore;
        if (nodeBefore && isSpecial(nodeBefore.firstChild)) {
            return $pos.pos - 2;
        }
    }
};
/* harmony default export */ __webpack_exports__["a"] = (function () {
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        key: inlineCursorTargetStateKey,
        state: {
            init: function () { return ({ positions: [] }); },
            apply: function (tr) {
                var selection = tr.selection;
                var $from = selection.$from;
                var positions = [];
                var posAfter = findSpecialNodeAfter($from, tr);
                var posBefore = findSpecialNodeBefore($from, tr);
                if (posAfter !== undefined) {
                    positions.push(posAfter);
                }
                if (posBefore !== undefined) {
                    positions.push(posBefore);
                }
                return { positions: positions };
            },
        },
        props: {
            decorations: function (state) {
                var doc = state.doc;
                var positions = inlineCursorTargetStateKey.getState(state).positions;
                if (positions && positions.length) {
                    var decorations = positions.map(function (position) {
                        var node = document.createElement('span');
                        node.appendChild(document.createTextNode(ZWSP));
                        return __WEBPACK_IMPORTED_MODULE_0_prosemirror_view__["Decoration"].widget(position, node, {
                            raw: true,
                            side: -1,
                        });
                    });
                    return __WEBPACK_IMPORTED_MODULE_0_prosemirror_view__["DecorationSet"].create(doc, decorations);
                }
                return null;
            },
        },
    });
});
//# sourceMappingURL=inline-cursor-target.js.map

/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorQuoteIcon = function EditorQuoteIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M15.698 17C16.97 17 18 15.982 18 14.727c0-1.255-1.03-2.273-2.302-2.273-2.301 0-.767-4.393 2.302-4.393V7c-5.478 0-7.624 10-2.302 10zm-4.33-2.273c0-1.255-1.031-2.273-2.301-2.273-2.302 0-.768-4.393 2.301-4.393V7C5.891 7 3.744 17 9.067 17c1.27 0 2.301-1.018 2.301-2.273z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorQuoteIcon.displayName = 'EditorQuoteIcon';
var _default = EditorQuoteIcon;
exports.default = _default;

/***/ }),
/* 2362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keymapPlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_commands___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_keymap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_history__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_history___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_history__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keymaps__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commands__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__block_type_commands__ = __webpack_require__(280);









var analyticsEventName = function (blockTypeName, eventSource) {
    return "atlassian.editor.format." + blockTypeName + "." + eventSource;
};
var tryUndoInputRuleElseUndoHistory = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["chainCommands"])(__WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules__["undoInputRule"], __WEBPACK_IMPORTED_MODULE_3_prosemirror_history__["undo"]);
function keymapPlugin(schema) {
    var list = {};
    __WEBPACK_IMPORTED_MODULE_4__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_4__keymaps__["s" /* insertNewLine */].common, Object(__WEBPACK_IMPORTED_MODULE_6__analytics__["b" /* trackAndInvoke */])('atlassian.editor.newline.keyboard', __WEBPACK_IMPORTED_MODULE_5__commands__["f" /* insertNewLine */]()), list);
    __WEBPACK_IMPORTED_MODULE_4__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_4__keymaps__["x" /* moveUp */].common, Object(__WEBPACK_IMPORTED_MODULE_6__analytics__["b" /* trackAndInvoke */])('atlassian.editor.moveup.keyboard', __WEBPACK_IMPORTED_MODULE_5__commands__["b" /* createNewParagraphAbove */]), list);
    __WEBPACK_IMPORTED_MODULE_4__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_4__keymaps__["u" /* moveDown */].common, Object(__WEBPACK_IMPORTED_MODULE_6__analytics__["b" /* trackAndInvoke */])('atlassian.editor.movedown.keyboard', __WEBPACK_IMPORTED_MODULE_5__commands__["c" /* createNewParagraphBelow */]), list);
    __WEBPACK_IMPORTED_MODULE_4__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_4__keymaps__["m" /* findKeyMapForBrowser */](__WEBPACK_IMPORTED_MODULE_4__keymaps__["E" /* redo */]), Object(__WEBPACK_IMPORTED_MODULE_6__analytics__["b" /* trackAndInvoke */])('atlassian.editor.redo.keyboard', __WEBPACK_IMPORTED_MODULE_3_prosemirror_history__["redo"]), list);
    __WEBPACK_IMPORTED_MODULE_4__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_4__keymaps__["T" /* undo */].common, Object(__WEBPACK_IMPORTED_MODULE_6__analytics__["b" /* trackAndInvoke */])('atlassian.editor.undo.keyboard', tryUndoInputRuleElseUndoHistory), list);
    __WEBPACK_IMPORTED_MODULE_4__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_4__keymaps__["m" /* findKeyMapForBrowser */](__WEBPACK_IMPORTED_MODULE_4__keymaps__["F" /* redoBarred */]), __WEBPACK_IMPORTED_MODULE_5__commands__["i" /* preventDefault */](), list);
    __WEBPACK_IMPORTED_MODULE_4__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_4__keymaps__["g" /* backspace */].common, __WEBPACK_IMPORTED_MODULE_8__block_type_commands__["a" /* cleanUpAtTheStartOfDocument */], list);
    [
        __WEBPACK_IMPORTED_MODULE_7__types__["k" /* NORMAL_TEXT */],
        __WEBPACK_IMPORTED_MODULE_7__types__["e" /* HEADING_1 */],
        __WEBPACK_IMPORTED_MODULE_7__types__["f" /* HEADING_2 */],
        __WEBPACK_IMPORTED_MODULE_7__types__["g" /* HEADING_3 */],
        __WEBPACK_IMPORTED_MODULE_7__types__["h" /* HEADING_4 */],
        __WEBPACK_IMPORTED_MODULE_7__types__["i" /* HEADING_5 */],
        __WEBPACK_IMPORTED_MODULE_7__types__["j" /* HEADING_6 */],
        __WEBPACK_IMPORTED_MODULE_7__types__["a" /* BLOCK_QUOTE */],
    ].forEach(function (blockType) {
        if (schema.nodes[blockType.nodeName]) {
            var shortcut = __WEBPACK_IMPORTED_MODULE_4__keymaps__["o" /* findShortcutByDescription */](blockType.title.defaultMessage);
            if (shortcut) {
                var eventName = analyticsEventName(blockType.name, 'keyboard');
                __WEBPACK_IMPORTED_MODULE_4__keymaps__["h" /* bindKeymapWithCommand */](shortcut, Object(__WEBPACK_IMPORTED_MODULE_6__analytics__["b" /* trackAndInvoke */])(eventName, Object(__WEBPACK_IMPORTED_MODULE_8__block_type_commands__["b" /* insertBlockType */])(blockType.name)), list);
            }
        }
    });
    return Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_keymap__["keymap"])(list);
}
//# sourceMappingURL=keymap.js.map

/***/ }),
/* 2363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = setBlockType;
/* unused harmony export setNormalText */
/* unused harmony export setHeading */
/* harmony export (immutable) */ __webpack_exports__["b"] = insertBlockType;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cleanUpAtTheStartOfDocument; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_transform__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_transform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_transform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_mark__ = __webpack_require__(278);




function setBlockType(name) {
    return function (state, dispatch) {
        var nodes = state.schema.nodes;
        if (name === __WEBPACK_IMPORTED_MODULE_2__types__["k" /* NORMAL_TEXT */].name && nodes.paragraph) {
            return setNormalText()(state, dispatch);
        }
        var headingBlockType = __WEBPACK_IMPORTED_MODULE_2__types__["d" /* HEADINGS_BY_NAME */][name];
        if (headingBlockType && nodes.heading && headingBlockType.level) {
            return setHeading(headingBlockType.level)(state, dispatch);
        }
        return false;
    };
}
function setNormalText() {
    return function (state, dispatch) {
        var tr = state.tr, _a = state.selection, $from = _a.$from, $to = _a.$to, schema = state.schema;
        if (dispatch) {
            dispatch(tr.setBlockType($from.pos, $to.pos, schema.nodes.paragraph));
        }
        return true;
    };
}
function setHeading(level) {
    return function (state, dispatch) {
        var tr = state.tr, _a = state.selection, $from = _a.$from, $to = _a.$to, schema = state.schema;
        if (dispatch) {
            dispatch(tr.setBlockType($from.pos, $to.pos, schema.nodes.heading, { level: level }));
        }
        return true;
    };
}
function insertBlockType(name) {
    return function (state, dispatch) {
        var nodes = state.schema.nodes;
        switch (name) {
            case __WEBPACK_IMPORTED_MODULE_2__types__["a" /* BLOCK_QUOTE */].name:
                if (nodes.paragraph && nodes.blockquote) {
                    return wrapSelectionIn(nodes.blockquote)(state, dispatch);
                }
                break;
            case __WEBPACK_IMPORTED_MODULE_2__types__["b" /* CODE_BLOCK */].name:
                if (nodes.codeBlock) {
                    return insertCodeBlock()(state, dispatch);
                }
                break;
            case __WEBPACK_IMPORTED_MODULE_2__types__["m" /* PANEL */].name:
                if (nodes.panel && nodes.paragraph) {
                    return wrapSelectionIn(nodes.panel)(state, dispatch);
                }
                break;
        }
        return false;
    };
}
/**
 * Function will add wrapping node.
 * 1. If currently selected blocks can be wrapped in the warpper type it will wrap them.
 * 2. If current block can not be wrapped inside wrapping block it will create a new block below selection,
 *  and set selection on it.
 */
function wrapSelectionIn(type) {
    return function (state, dispatch) {
        var tr = state.tr;
        var _a = state.selection, $from = _a.$from, $to = _a.$to;
        var paragraph = state.schema.nodes.paragraph;
        var _b = state.schema.marks, alignment = _b.alignment, indentation = _b.indentation;
        /** Alignment or Indentation is not valid inside block types */
        var removeAlignTr = Object(__WEBPACK_IMPORTED_MODULE_3__utils_mark__["c" /* removeBlockMarks */])(state, [alignment, indentation]);
        tr = removeAlignTr || tr;
        var range = $from.blockRange($to);
        var wrapping = range && Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_transform__["findWrapping"])(range, type);
        if (range && wrapping) {
            tr.wrap(range, wrapping).scrollIntoView();
        }
        else {
            /** We always want to append a block type */
            tr.replaceRangeWith($to.pos + 1, $to.pos + 1, type.createAndFill({}, paragraph.create()));
            tr.setSelection(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Selection"].near(tr.doc.resolve(state.selection.to + 1)));
        }
        if (dispatch) {
            dispatch(tr);
        }
        return true;
    };
}
/**
 * Function will insert code block at current selection if block is empty or below current selection and set focus on it.
 */
function insertCodeBlock() {
    return function (state, dispatch) {
        var tr = state.tr;
        var $to = state.selection.$to;
        var codeBlock = state.schema.nodes.codeBlock;
        var getNextNode = state.doc.nodeAt($to.pos + 1);
        var addPos = getNextNode && getNextNode.isText ? 0 : 1;
        /** We always want to append a block type */
        tr.replaceRangeWith($to.pos + addPos, $to.pos + addPos, codeBlock.createAndFill());
        tr.setSelection(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Selection"].near(tr.doc.resolve(state.selection.to + addPos)));
        if (dispatch) {
            dispatch(tr);
        }
        return true;
    };
}
var cleanUpAtTheStartOfDocument = function (state, dispatch) {
    var $cursor = state.selection.$cursor;
    if ($cursor &&
        !$cursor.nodeBefore &&
        !$cursor.nodeAfter &&
        $cursor.pos === 1) {
        var tr = state.tr, schema = state.schema;
        var paragraph = schema.nodes.paragraph;
        var parent_1 = $cursor.parent;
        /**
         * Use cases:
         * 1. Change `heading` to `paragraph`
         * 2. Remove block marks
         *
         * NOTE: We already know it's an empty doc so it's safe to use 0
         */
        tr.setNodeMarkup(0, paragraph, parent_1.attrs, []);
        if (dispatch) {
            dispatch(tr);
        }
        return true;
    }
    return false;
};
//# sourceMappingURL=block-type.js.map

/***/ }),
/* 2364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export headingRule */
/* unused harmony export blockQuoteRule */
/* unused harmony export codeBlockRule */
/* unused harmony export inputRulePlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_input_rules__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands_transform_to_code_block__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commands_insert_block__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prosemirror_utils__);






function headingRule(nodeType, maxLevel) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["textblockTypeInputRule"])(new RegExp('^(#{1,' + maxLevel + '})\\s$'), nodeType, function (match) { return ({ level: match[1].length }); });
}
function blockQuoteRule(nodeType) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["wrappingInputRule"])(/^\s*>\s$/, nodeType);
}
function codeBlockRule(nodeType) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["textblockTypeInputRule"])(/^```$/, nodeType);
}
function inputRulePlugin(schema) {
    var rules = [];
    if (schema.nodes.heading) {
        // '# ' for h1, '## ' for h2 and etc
        var rule = Object(__WEBPACK_IMPORTED_MODULE_2__utils_input_rules__["b" /* defaultInputRuleHandler */])(headingRule(schema.nodes.heading, 6), true);
        var currentHandler_1 = rule.handler;
        rule.handler = function (state, match, start, end) {
            __WEBPACK_IMPORTED_MODULE_1__analytics__["a" /* analyticsService */].trackEvent("atlassian.editor.format.heading" + match[1].length + ".autoformatting");
            return currentHandler_1(state, match, start, end);
        };
        rules.push(rule);
        rules.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils_input_rules__["a" /* createInputRule */])(new RegExp(__WEBPACK_IMPORTED_MODULE_2__utils_input_rules__["c" /* leafNodeReplacementCharacter */] + "(#{1,6})\\s$"), function (state, match, start, end) {
            var level = match[1].length;
            return Object(__WEBPACK_IMPORTED_MODULE_4__commands_insert_block__["a" /* insertBlock */])(state, schema.nodes.heading, "heading" + level, start, end, { level: level });
        }, true));
    }
    if (schema.nodes.blockquote) {
        // '> ' for blockquote
        var rule = Object(__WEBPACK_IMPORTED_MODULE_2__utils_input_rules__["b" /* defaultInputRuleHandler */])(blockQuoteRule(schema.nodes.blockquote), true);
        rule.handler = Object(__WEBPACK_IMPORTED_MODULE_1__analytics__["b" /* trackAndInvoke */])('atlassian.editor.format.blockquote.autoformatting', rule.handler);
        rules.push(rule);
        rules.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils_input_rules__["a" /* createInputRule */])(new RegExp(__WEBPACK_IMPORTED_MODULE_2__utils_input_rules__["c" /* leafNodeReplacementCharacter */] + "\\s*>\\s$"), function (state, match, start, end) {
            return Object(__WEBPACK_IMPORTED_MODULE_4__commands_insert_block__["a" /* insertBlock */])(state, schema.nodes.blockquote, 'blockquote', start, end);
        }, true));
    }
    if (schema.nodes.codeBlock) {
        rules.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils_input_rules__["a" /* createInputRule */])(/((^`{3,})|(\s`{3,}))(\S*)$/, function (state, match, start, end) {
            var attributes = {};
            if (match[4]) {
                attributes.language = match[4];
            }
            var newStart = match[0][0] === ' ' ? start + 1 : start;
            if (Object(__WEBPACK_IMPORTED_MODULE_3__commands_transform_to_code_block__["a" /* isConvertableToCodeBlock */])(state)) {
                __WEBPACK_IMPORTED_MODULE_1__analytics__["a" /* analyticsService */].trackEvent("atlassian.editor.format.codeblock.autoformatting");
                return (Object(__WEBPACK_IMPORTED_MODULE_3__commands_transform_to_code_block__["b" /* transformToCodeBlockAction */])(state, attributes)
                    // remove markdown decorator ```
                    .delete(newStart, end)
                    .scrollIntoView());
            }
            var tr = state.tr;
            tr = tr.delete(newStart, end);
            var codeBlock = state.schema.nodes.codeBlock.createChecked();
            return Object(__WEBPACK_IMPORTED_MODULE_5_prosemirror_utils__["safeInsert"])(codeBlock)(tr);
        }, true));
        rules.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils_input_rules__["a" /* createInputRule */])(new RegExp("((" + __WEBPACK_IMPORTED_MODULE_2__utils_input_rules__["c" /* leafNodeReplacementCharacter */] + "`{3,})|(\\s`{3,}))(\\S*)$"), function (state, match, start, end) {
            var attributes = {};
            if (match[4]) {
                attributes.language = match[4];
            }
            return Object(__WEBPACK_IMPORTED_MODULE_4__commands_insert_block__["a" /* insertBlock */])(state, schema.nodes.codeBlock, 'codeblock', start, end, attributes);
        }, true));
    }
    if (rules.length !== 0) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["inputRules"])({ rules: rules });
    }
}
/* harmony default export */ __webpack_exports__["a"] = (inputRulePlugin);
//# sourceMappingURL=input-rule.js.map

/***/ }),
/* 2365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export messages */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_chevron_down__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_chevron_down___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_chevron_down__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_text_style__ = __webpack_require__(2366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_text_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_text_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_ToolbarButton__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_DropdownMenu__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_styles__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styled__ = __webpack_require__(2368);













var messages = Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["defineMessages"])({
    textStyles: {
        id: 'fabric.editor.textStyles',
        defaultMessage: 'Text styles',
        description: 'Menu provides access to various heading styles or normal text',
    },
});
var ToolbarBlockType = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ToolbarBlockType, _super);
    function ToolbarBlockType() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            active: false,
        };
        _this.onOpenChange = function (attrs) {
            _this.setState({ active: attrs.isOpen });
        };
        _this.handleTriggerClick = function () {
            _this.onOpenChange({ isOpen: !_this.state.active });
        };
        _this.createItems = function () {
            var formatMessage = _this.props.intl.formatMessage;
            var _a = _this.props.pluginState, currentBlockType = _a.currentBlockType, availableBlockTypes = _a.availableBlockTypes;
            var items = availableBlockTypes.reduce(function (acc, blockType, blockTypeNo) {
                var isActive = currentBlockType === blockType;
                var tagName = blockType.tagName || 'p';
                acc.push({
                    content: (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__styled__["a" /* BlockTypeMenuItem */], { tagName: tagName, selected: isActive }, Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(tagName, {}, formatMessage(blockType.title)))),
                    value: blockType,
                    key: blockType + "-" + blockTypeNo,
                    // ED-2853, hiding tooltips as shortcuts are not working atm.
                    // tooltipDescription: tooltip(findKeymapByDescription(blockType.title)),
                    // tooltipPosition: 'right',
                    isActive: isActive,
                });
                return acc;
            }, []);
            return [{ items: items }];
        };
        _this.handleSelectBlockType = function (_a) {
            var item = _a.item;
            var blockType = item.value;
            _this.props.setBlockType(blockType.name);
            _this.setState({ active: false });
            __WEBPACK_IMPORTED_MODULE_6__analytics__["a" /* analyticsService */].trackEvent("atlassian.editor.format." + blockType.name + ".button");
        };
        return _this;
    }
    ToolbarBlockType.prototype.render = function () {
        var _this = this;
        var active = this.state.active;
        var _a = this.props, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, popupsScrollableElement = _a.popupsScrollableElement, isSmall = _a.isSmall, isReducedSpacing = _a.isReducedSpacing, _b = _a.pluginState, currentBlockType = _b.currentBlockType, blockTypesDisabled = _b.blockTypesDisabled, availableBlockTypes = _b.availableBlockTypes, formatMessage = _a.intl.formatMessage;
        var isHeadingDisabled = !availableBlockTypes.some(function (blockType) { return blockType.nodeName === 'heading'; });
        if (isHeadingDisabled) {
            return null;
        }
        var blockTypeTitles = availableBlockTypes
            .filter(function (blockType) { return blockType.name === currentBlockType.name; })
            .map(function (blockType) { return blockType.title; });
        var longestDropdownMenuItem = __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"]([
            __WEBPACK_IMPORTED_MODULE_10__types__["k" /* NORMAL_TEXT */]
        ], availableBlockTypes).reduce(function (longest, item) {
            var itemTitle = formatMessage(item.title);
            return itemTitle.length >= longest.length ? itemTitle : longest;
        }, '');
        var toolbarButtonFactory = function (disabled) {
            var labelTextStyles = formatMessage(messages.textStyles);
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ui_ToolbarButton__["a" /* default */], { spacing: isReducedSpacing ? 'none' : 'default', selected: active, className: "block-type-btn", disabled: disabled, onClick: _this.handleTriggerClick, title: labelTextStyles, ariaLabel: "Font style", iconAfter: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ui_styles__["h" /* Wrapper */], { isSmall: isSmall },
                    isSmall && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_text_style___default.a, { label: labelTextStyles }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ui_styles__["c" /* ExpandIconWrapper */], null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_chevron_down___default.a, { label: labelTextStyles }))) }, !isSmall && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ui_styles__["a" /* ButtonContent */], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["FormattedMessage"], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, blockTypeTitles[0] || __WEBPACK_IMPORTED_MODULE_10__types__["k" /* NORMAL_TEXT */].title)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: { overflow: 'hidden', height: 0 } }, longestDropdownMenuItem)))));
        };
        if (!this.props.isDisabled && !blockTypesDisabled) {
            var items = this.createItems();
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ui_styles__["d" /* MenuWrapper */], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ui_DropdownMenu__["a" /* default */], { items: items, onOpenChange: this.onOpenChange, onItemActivated: this.handleSelectBlockType, isOpen: active, mountTo: popupsMountPoint, boundariesElement: popupsBoundariesElement, scrollableElement: popupsScrollableElement, zIndex: __WEBPACK_IMPORTED_MODULE_5__atlaskit_editor_common__["r" /* akEditorMenuZIndex */], fitHeight: 360, fitWidth: 106 }, toolbarButtonFactory(false)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ui_styles__["e" /* Separator */], null)));
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ui_styles__["h" /* Wrapper */], null,
            toolbarButtonFactory(true),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ui_styles__["e" /* Separator */], null)));
    };
    return ToolbarBlockType;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["injectIntl"])(ToolbarBlockType));
//# sourceMappingURL=index.js.map

/***/ }),
/* 2366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorTextStyleIcon = function EditorTextStyleIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M6.26 6.678l-3.237 9.534a.5.5 0 0 0 .473.66h1.032a.75.75 0 0 0 .717-.53l.648-2.107H9.63l.647 2.107a.75.75 0 0 0 .717.53h1.113a.5.5 0 0 0 .473-.66L9.337 6.677A1 1 0 0 0 8.39 6H7.207a1 1 0 0 0-.947.678zM7.736 8.08h.051l1.364 4.453H6.372L7.736 8.08zm11.113 2.043v-.327a1 1 0 0 1 1-1H20a1 1 0 0 1 1 1v6.078a1 1 0 0 1-1 1h-.151a1 1 0 0 1-1-1v-.312h-.088c-.392.874-1.232 1.439-2.418 1.439-1.975 0-3.221-1.613-3.221-4.182 0-2.546 1.254-4.15 3.221-4.15 1.172 0 2.026.595 2.418 1.454h.088zm-.045 2.712c0-1.47-.685-2.404-1.754-2.404-1.068 0-1.725.92-1.725 2.404 0 1.491.657 2.395 1.725 2.395 1.076 0 1.754-.911 1.754-2.395z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorTextStyleIcon.displayName = 'EditorTextStyleIcon';
var _default = EditorTextStyleIcon;
exports.default = _default;

/***/ }),
/* 2367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AkButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_button__ = __webpack_require__(35);



// tslint:disable-next-line:variable-name
var AkButton = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2__atlaskit_button__["default"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  line-height: 0;\n  justify-content: center;\n\n  > span {\n    margin: 0\n      ", ";\n  }\n\n  & + & {\n    margin-left: ", ";\n  }\n\n  &[disabled] {\n    pointer-events: none;\n  }\n"], ["\n  line-height: 0;\n  justify-content: center;\n\n  > span {\n    margin: 0\n      ", ";\n  }\n\n  & + & {\n    margin-left: ",
    ";\n  }\n\n  &[disabled] {\n    pointer-events: none;\n  }\n"])), function (props) { return (props.spacing === 'none' ? '0' : '-2px'); }, function (props) {
    return props.spacing === 'none' ? '4px' : '0px';
});
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlockTypeMenuItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var BlockTypeMenuItem = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", ";\n"], ["\n  ", ";\n"])), function (props) { return (props.selected ? props.tagName + " { color: white }" : ''); });
var templateObject_1;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pluginKey */
/* unused harmony export createPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(21);


var pluginKey = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["PluginKey"]('clearMarksOnChangeToEmptyDocumentPlugin');
function createPlugin() {
    return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
        key: pluginKey,
        appendTransaction: function (transactions, oldState, newState) {
            // ED-2973: When a user clears the editor's content, remove the current active marks
            if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils__["t" /* isEmptyDocument */])(oldState.doc) && Object(__WEBPACK_IMPORTED_MODULE_1__utils__["t" /* isEmptyDocument */])(newState.doc)) {
                return newState.tr.setStoredMarks([]);
            }
        },
    });
}
var clearMarksOnChangeToEmptyDocumentPlugin = {
    pmPlugins: function () {
        return [{ name: 'clearMarksOnChange', plugin: function (schema) { return createPlugin(); } }];
    },
};
/* harmony default export */ __webpack_exports__["a"] = (clearMarksOnChangeToEmptyDocumentPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_code__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_code___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_code__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pm_plugins_main__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toolbar__ = __webpack_require__(2372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pm_plugins_keymaps__ = __webpack_require__(2378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pm_plugins_ide_ux__ = __webpack_require__(2379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__block_type_types__ = __webpack_require__(125);








var codeBlockPlugin = function (options) {
    if (options === void 0) { options = {}; }
    return ({
        nodes: function () {
            return [{ name: 'codeBlock', node: __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__["m" /* codeBlock */] }];
        },
        pmPlugins: function () {
            return [
                { name: 'codeBlock', plugin: __WEBPACK_IMPORTED_MODULE_3__pm_plugins_main__["a" /* createPlugin */] },
                {
                    name: 'codeBlockIDEKeyBindings',
                    plugin: function () { return (options.enableKeybindingsForIDE ? __WEBPACK_IMPORTED_MODULE_6__pm_plugins_ide_ux__["a" /* default */] : undefined); },
                },
                {
                    name: 'codeBlockKeyMap',
                    plugin: function (_a) {
                        var schema = _a.schema;
                        return Object(__WEBPACK_IMPORTED_MODULE_5__pm_plugins_keymaps__["a" /* default */])(schema);
                    },
                },
            ];
        },
        pluginsOptions: {
            quickInsert: function (_a) {
                var formatMessage = _a.formatMessage;
                return [
                    {
                        title: formatMessage(__WEBPACK_IMPORTED_MODULE_7__block_type_types__["p" /* messages */].codeblock),
                        priority: 700,
                        icon: function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_code___default.a, { label: formatMessage(__WEBPACK_IMPORTED_MODULE_7__block_type_types__["p" /* messages */].codeblock) })); },
                        action: function (insert, state) {
                            var schema = state.schema;
                            return insert(schema.nodes.codeBlock.createChecked());
                        },
                    },
                ];
            },
            floatingToolbar: __WEBPACK_IMPORTED_MODULE_4__toolbar__["a" /* getToolbarConfig */],
        },
    });
};
/* harmony default export */ __webpack_exports__["a"] = (codeBlockPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CodeBlockView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raf_schd__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__ = __webpack_require__(13);



var MATCH_NEWLINES = new RegExp('\n', 'g');
// For browsers <= IE11, we apply style overrides to render a basic code box
var isIE11 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["E" /* browser */].ie && __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["E" /* browser */].ie_version <= 11;
var toDOM = function (node) {
    return [
        'div',
        { class: 'code-block' + (isIE11 ? ' ie11' : '') },
        ['div', { class: 'line-number-gutter', contenteditable: 'false' }],
        [
            'div',
            { class: 'code-content' },
            [
                'pre',
                [
                    'code',
                    { 'data-language': node.attrs.language || '', spellcheck: 'false' },
                    0,
                ],
            ],
        ],
    ];
};
var CodeBlockView = /** @class */ (function () {
    function CodeBlockView(node, view, getPos) {
        var _this = this;
        this.ensureLineNumbers = Object(__WEBPACK_IMPORTED_MODULE_0_raf_schd__["a" /* default */])(function () {
            var lines = 1;
            _this.node.forEach(function (node) {
                var text = node.text;
                if (text) {
                    lines += (node.text.match(MATCH_NEWLINES) || []).length;
                }
            });
            while (_this.lineNumberGutter.childElementCount < lines) {
                _this.lineNumberGutter.appendChild(document.createElement('span'));
            }
            while (_this.lineNumberGutter.childElementCount > lines) {
                _this.lineNumberGutter.removeChild(_this.lineNumberGutter.lastChild);
            }
        });
        var _a = __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["DOMSerializer"].renderSpec(document, toDOM(node)), dom = _a.dom, contentDOM = _a.contentDOM;
        this.node = node;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.lineNumberGutter = this.dom.querySelector('.line-number-gutter');
        this.ensureLineNumbers();
    }
    CodeBlockView.prototype.update = function (node) {
        if (node.type !== this.node.type) {
            return false;
        }
        if (node !== this.node) {
            if (node.attrs.language !== this.node.attrs.language) {
                this.contentDOM.setAttribute('data-language', node.attrs.language || '');
            }
            this.node = node;
            this.ensureLineNumbers();
        }
        return true;
    };
    CodeBlockView.prototype.ignoreMutation = function (record) {
        // Ensure updating the line-number gutter doesn't trigger reparsing the codeblock
        return (record.target === this.lineNumberGutter ||
            record.target.parentNode === this.lineNumberGutter);
    };
    return CodeBlockView;
}());

/* harmony default export */ __webpack_exports__["a"] = (function (node, view, getPos) {
    return new CodeBlockView(node, view, getPos);
});
//# sourceMappingURL=code-block.js.map

/***/ }),
/* 2372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export messages */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getToolbarConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_remove__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_remove__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(2373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__messages__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pm_plugins_main__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__breakout_utils_create_breakout_toolbar_items__ = __webpack_require__(805);









var messages = Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["defineMessages"])({
    selectLanguage: {
        id: 'fabric.editor.selectLanguage',
        defaultMessage: 'Select language',
        description: 'Code blocks display software code. A prompt to select the software language the code is written in.',
    },
});
var getToolbarConfig = function (state, _a) {
    var formatMessage = _a.formatMessage;
    var codeBlockState = __WEBPACK_IMPORTED_MODULE_7__pm_plugins_main__["b" /* pluginKey */].getState(state);
    if (codeBlockState &&
        codeBlockState.toolbarVisible &&
        codeBlockState.element) {
        var parent_1 = Object(__WEBPACK_IMPORTED_MODULE_4_prosemirror_utils__["findParentNodeOfType"])(state.schema.nodes.codeBlock)(state.selection);
        var language_1 = parent_1 && parent_1.node.attrs ? parent_1.node.attrs.language : undefined;
        var options = Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_adf_schema__["t" /* createLanguageList */])(__WEBPACK_IMPORTED_MODULE_3__atlaskit_adf_schema__["a" /* DEFAULT_LANGUAGES */]).map(function (lang) { return ({
            label: lang.name,
            value: Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_adf_schema__["E" /* getLanguageIdentifier */])(lang),
        }); });
        var languageSelect = {
            type: 'select',
            onChange: function (option) { return Object(__WEBPACK_IMPORTED_MODULE_5__actions__["a" /* changeLanguage */])(option.value); },
            defaultValue: language_1
                ? options.find(function (option) { return option.value === language_1; })
                : undefined,
            placeholder: formatMessage(messages.selectLanguage),
            options: options,
        };
        var breakoutToolbar = Object(__WEBPACK_IMPORTED_MODULE_8__breakout_utils_create_breakout_toolbar_items__["a" /* createBreakoutToolbarItems */])(state, {
            formatMessage: formatMessage,
        });
        var separator = {
            type: 'separator',
        };
        var deleteButton = {
            type: 'button',
            appearance: 'danger',
            icon: __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_remove___default.a,
            onClick: __WEBPACK_IMPORTED_MODULE_5__actions__["b" /* removeCodeBlock */],
            title: formatMessage(__WEBPACK_IMPORTED_MODULE_6__messages__["a" /* default */].remove),
        };
        return {
            title: 'CodeBlock floating controls',
            getDomRef: function () { return codeBlockState.element; },
            nodeType: state.schema.nodes.codeBlock,
            items: __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"]([
                languageSelect
            ], (breakoutToolbar ? __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"]([separator], breakoutToolbar) : []), [
                separator,
                deleteButton,
            ]),
        };
    }
};
//# sourceMappingURL=toolbar.js.map

/***/ }),
/* 2373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return removeCodeBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeLanguage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__);

var removeCodeBlock = function (state, dispatch) {
    var nodes = state.schema.nodes, tr = state.tr;
    if (dispatch) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["removeParentNodeOfType"])(nodes.codeBlock)(tr));
    }
    return true;
};
var changeLanguage = function (language) { return function (state, dispatch) {
    var nodes = state.schema.nodes, tr = state.tr;
    // setParentNodeMarkup doesn't typecheck the attributes
    var attrs = { language: language };
    if (dispatch) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["setParentNodeMarkup"])(nodes.codeBlock, null, attrs)(tr));
    }
    return true;
}; };
//# sourceMappingURL=actions.js.map

/***/ }),
/* 2374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeBreakout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_is_supported_node__ = __webpack_require__(281);


function removeBreakout() {
    return function (state, dispatch) {
        var node = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["findParentNode"])(__WEBPACK_IMPORTED_MODULE_1__utils_is_supported_node__["a" /* isSupportedNodeForBreakout */])(state.selection);
        if (!node) {
            return false;
        }
        var marks = node.node.marks.filter(function (m) { return m.type.name !== 'breakout'; });
        if (dispatch) {
            dispatch(state.tr.setNodeMarkup(node.pos, node.node.type, node.node.attrs, marks));
        }
        return true;
    };
}
//# sourceMappingURL=remove-breakout.js.map

/***/ }),
/* 2375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setBreakoutMode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_is_supported_node__ = __webpack_require__(281);


function setBreakoutMode(mode) {
    return function (state, dispatch) {
        var node = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["findParentNode"])(__WEBPACK_IMPORTED_MODULE_1__utils_is_supported_node__["a" /* isSupportedNodeForBreakout */])(state.selection);
        if (!node) {
            return false;
        }
        if (dispatch) {
            dispatch(state.tr.setNodeMarkup(node.pos, node.node.type, node.node.attrs, [
                state.schema.marks.breakout.create({ mode: mode }),
            ]));
        }
        return true;
    };
}
//# sourceMappingURL=set-breakout-mode.js.map

/***/ }),
/* 2376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBreakoutMode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_supported_node__ = __webpack_require__(281);


function getBreakoutMode(state) {
    var node = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["findParentNode"])(__WEBPACK_IMPORTED_MODULE_1__is_supported_node__["a" /* isSupportedNodeForBreakout */])(state.selection);
    if (!node) {
        return;
    }
    var breakoutMark = node.node.marks.find(function (m) { return m.type.name === 'breakout'; });
    if (!breakoutMark) {
        return;
    }
    return breakoutMark.attrs.mode;
}
//# sourceMappingURL=get-breakout-mode.js.map

/***/ }),
/* 2377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isBreakoutMarkAllowed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_supported_node__ = __webpack_require__(281);


function isBreakoutMarkAllowed(state) {
    if (!state.schema.marks.breakout) {
        return false;
    }
    var node = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["findParentNode"])(__WEBPACK_IMPORTED_MODULE_1__is_supported_node__["a" /* isSupportedNodeForBreakout */])(state.selection);
    if (!node || node.depth === 0) {
        return false;
    }
    var parent = state.selection.$from.node(node.depth - 1);
    return parent.type.allowsMarkType(state.schema.marks.breakout);
}
//# sourceMappingURL=is-breakout-mark-allowed.js.map

/***/ }),
/* 2378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export keymapPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(21);



function keymapPlugin(schema) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__["keymap"])({
        Enter: function (state, dispatch) {
            var selection = state.selection, nodes = state.schema.nodes;
            var $from = selection.$from, $to = selection.$to;
            var node = $from.node($from.depth);
            var selectionIsAtEndOfCodeBlock = node &&
                node.type === nodes.codeBlock &&
                $from.parentOffset === $from.parent.nodeSize - 2 && // cursor offset is at the end of block
                $from.indexAfter($from.depth) === node.childCount; // paragraph is the last child of code block
            var codeBlockEndsWithNewLine = node.lastChild &&
                node.lastChild.text &&
                node.lastChild.text.endsWith('\n');
            if (selectionIsAtEndOfCodeBlock && codeBlockEndsWithNewLine) {
                var tr = state.tr.insert($to.pos + 1, nodes.paragraph.createChecked({}));
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["setTextSelection"])($to.pos + 1)(tr)
                    .delete($from.pos - 1, $from.pos)
                    .scrollIntoView());
                return true;
            }
            return false;
        },
        Backspace: function (state, dispatch) {
            var $cursor = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["n" /* getCursor */])(state.selection);
            var _a = state.schema.nodes, paragraph = _a.paragraph, codeBlock = _a.codeBlock, listItem = _a.listItem;
            if (!$cursor || $cursor.parent.type !== codeBlock) {
                return false;
            }
            if ($cursor.pos === 1 ||
                (Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["hasParentNodeOfType"])(listItem)(state.selection) &&
                    $cursor.parentOffset === 0)) {
                var node = Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["findParentNodeOfTypeClosestToPos"])($cursor, codeBlock);
                if (!node) {
                    return false;
                }
                dispatch(state.tr
                    .setNodeMarkup(node.pos, node.node.type, node.node.attrs, [])
                    .setBlockType($cursor.pos, $cursor.pos, paragraph));
                return true;
            }
            return false;
        },
    });
}
/* harmony default export */ __webpack_exports__["a"] = (keymapPlugin);
//# sourceMappingURL=keymaps.js.map

/***/ }),
/* 2379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_keymap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_commands__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ide_ux_bracket_handling__ = __webpack_require__(2381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ide_ux_line_handling__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ide_ux_commands__ = __webpack_require__(2382);








/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
    props: {
        handleTextInput: function (view, from, to, text) {
            var state = view.state, dispatch = view.dispatch;
            if (Object(__WEBPACK_IMPORTED_MODULE_6__ide_ux_line_handling__["f" /* isCursorInsideCodeBlock */])(state)) {
                var beforeText = Object(__WEBPACK_IMPORTED_MODULE_6__ide_ux_line_handling__["e" /* getStartOfCurrentLine */])(state).text;
                var afterText = Object(__WEBPACK_IMPORTED_MODULE_6__ide_ux_line_handling__["b" /* getEndOfCurrentLine */])(state).text;
                // If text is a closing bracket and we've already inserted it, move the selection after.
                if (Object(__WEBPACK_IMPORTED_MODULE_5__ide_ux_bracket_handling__["c" /* isCursorBeforeClosingBracket */])(afterText) &&
                    Object(__WEBPACK_IMPORTED_MODULE_5__ide_ux_bracket_handling__["b" /* isClosingBracket */])(text) &&
                    afterText.startsWith(text)) {
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["setTextSelection"])(to + text.length)(state.tr));
                    return true;
                }
                // Automatically add right-hand side bracket when user types the left bracket
                var _a = Object(__WEBPACK_IMPORTED_MODULE_5__ide_ux_bracket_handling__["a" /* getAutoClosingBracketInfo */])(beforeText + text, afterText), left = _a.left, right = _a.right;
                if (left && right) {
                    var bracketPair = state.schema.text(text + right);
                    var tr = state.tr.replaceWith(from, to, bracketPair);
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["setTextSelection"])(from + text.length)(tr));
                    return true;
                }
            }
            return false;
        },
        handleKeyDown: Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_keymap__["keydownHandler"])({
            Backspace: function (state, dispatch) {
                if (Object(__WEBPACK_IMPORTED_MODULE_6__ide_ux_line_handling__["f" /* isCursorInsideCodeBlock */])(state)) {
                    var $cursor = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["n" /* getCursor */])(state.selection);
                    var beforeText = Object(__WEBPACK_IMPORTED_MODULE_6__ide_ux_line_handling__["e" /* getStartOfCurrentLine */])(state).text;
                    var afterText = Object(__WEBPACK_IMPORTED_MODULE_6__ide_ux_line_handling__["b" /* getEndOfCurrentLine */])(state).text;
                    var _a = Object(__WEBPACK_IMPORTED_MODULE_5__ide_ux_bracket_handling__["a" /* getAutoClosingBracketInfo */])(beforeText, afterText), left = _a.left, right = _a.right, hasTrailingMatchingBracket = _a.hasTrailingMatchingBracket;
                    if (left && right && hasTrailingMatchingBracket) {
                        dispatch(state.tr.delete($cursor.pos - left.length, $cursor.pos + right.length));
                        return true;
                    }
                    var _b = Object(__WEBPACK_IMPORTED_MODULE_6__ide_ux_line_handling__["c" /* getLineInfo */])(beforeText), _c = _b.indentToken, size = _c.size, token = _c.token, indentText = _b.indentText;
                    if (beforeText === indentText) {
                        if (indentText.endsWith(token.repeat(size))) {
                            dispatch(state.tr.delete($cursor.pos - (size - (indentText.length % size) || size), $cursor.pos));
                            return true;
                        }
                    }
                }
                return false;
            },
            Enter: Object(__WEBPACK_IMPORTED_MODULE_4__utils_commands__["a" /* filter */])(__WEBPACK_IMPORTED_MODULE_6__ide_ux_line_handling__["g" /* isSelectionEntirelyInsideCodeBlock */], __WEBPACK_IMPORTED_MODULE_7__ide_ux_commands__["c" /* insertNewlineWithIndent */]),
            'Mod-]': Object(__WEBPACK_IMPORTED_MODULE_4__utils_commands__["a" /* filter */])(__WEBPACK_IMPORTED_MODULE_6__ide_ux_line_handling__["g" /* isSelectionEntirelyInsideCodeBlock */], __WEBPACK_IMPORTED_MODULE_7__ide_ux_commands__["a" /* indent */]),
            'Mod-[': Object(__WEBPACK_IMPORTED_MODULE_4__utils_commands__["a" /* filter */])(__WEBPACK_IMPORTED_MODULE_6__ide_ux_line_handling__["g" /* isSelectionEntirelyInsideCodeBlock */], __WEBPACK_IMPORTED_MODULE_7__ide_ux_commands__["d" /* outdent */]),
            Tab: Object(__WEBPACK_IMPORTED_MODULE_4__utils_commands__["a" /* filter */])(__WEBPACK_IMPORTED_MODULE_6__ide_ux_line_handling__["g" /* isSelectionEntirelyInsideCodeBlock */], function (state, dispatch) {
                if (Object(__WEBPACK_IMPORTED_MODULE_6__ide_ux_line_handling__["f" /* isCursorInsideCodeBlock */])(state)) {
                    return Object(__WEBPACK_IMPORTED_MODULE_7__ide_ux_commands__["b" /* insertIndent */])(state, dispatch);
                }
                return Object(__WEBPACK_IMPORTED_MODULE_7__ide_ux_commands__["a" /* indent */])(state, dispatch);
            }),
            'Shift-Tab': Object(__WEBPACK_IMPORTED_MODULE_4__utils_commands__["a" /* filter */])(__WEBPACK_IMPORTED_MODULE_6__ide_ux_line_handling__["g" /* isSelectionEntirelyInsideCodeBlock */], __WEBPACK_IMPORTED_MODULE_7__ide_ux_commands__["d" /* outdent */]),
            'Mod-a': function (state, dispatch) {
                if (Object(__WEBPACK_IMPORTED_MODULE_6__ide_ux_line_handling__["g" /* isSelectionEntirelyInsideCodeBlock */])(state)) {
                    var _a = state.selection, $from = _a.$from, $to = _a.$to;
                    var isFullCodeBlockSelection = $from.parentOffset === 0 &&
                        $to.parentOffset === $to.parent.nodeSize - 2;
                    if (!isFullCodeBlockSelection) {
                        dispatch(state.tr.setSelection(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"].create(state.doc, $from.start(), $to.end())));
                        return true;
                    }
                }
                return false;
            },
        }),
    },
}));
//# sourceMappingURL=ide-ux.js.map

/***/ }),
/* 2380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keymapPlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keymaps__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__direction__ = __webpack_require__(808);




function keymapPlugin() {
    var map = {};
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["v" /* moveLeft */].common, function (state, dispatch, view) {
        var endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return Object(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* arrow */])(__WEBPACK_IMPORTED_MODULE_3__direction__["a" /* Direction */].LEFT, endOfTextblock)(state, dispatch);
    }, map);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["w" /* moveRight */].common, function (state, dispatch, view) {
        var endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return Object(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* arrow */])(__WEBPACK_IMPORTED_MODULE_3__direction__["a" /* Direction */].RIGHT, endOfTextblock)(state, dispatch);
    }, map);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["x" /* moveUp */].common, function (state, dispatch, view) {
        var endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return Object(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* arrow */])(__WEBPACK_IMPORTED_MODULE_3__direction__["a" /* Direction */].UP, endOfTextblock)(state, dispatch);
    }, map);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["u" /* moveDown */].common, function (state, dispatch, view) {
        var endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return Object(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* arrow */])(__WEBPACK_IMPORTED_MODULE_3__direction__["a" /* Direction */].DOWN, endOfTextblock)(state, dispatch);
    }, map);
    // default PM's Backspace doesn't handle removing block nodes when cursor is after it
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["g" /* backspace */].common, Object(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* deleteNode */])(__WEBPACK_IMPORTED_MODULE_3__direction__["a" /* Direction */].BACKWARD), map);
    // handle Delete key (remove node after the cursor)
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["j" /* deleteKey */].common, Object(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* deleteNode */])(__WEBPACK_IMPORTED_MODULE_3__direction__["a" /* Direction */].FORWARD), map);
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__["keymap"])(map);
}
//# sourceMappingURL=keymap.js.map

/***/ }),
/* 2381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAutoClosingBracketInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isCursorBeforeClosingBracket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isClosingBracket; });
var BRACKET_MAP = {
    '{': '}',
    '[': ']',
    '(': ')',
};
var getAutoClosingBracketInfo = function (before, after) {
    var left = Object.keys(BRACKET_MAP).find(function (item) { return before.endsWith(item); });
    var right = left ? BRACKET_MAP[left] : undefined;
    var hasTrailingMatchingBracket = right ? after.startsWith(right) : false;
    return { left: left, right: right, hasTrailingMatchingBracket: hasTrailingMatchingBracket };
};
var isCursorBeforeClosingBracket = function (after) {
    return Object.keys(BRACKET_MAP).some(function (leftBracket) {
        return after.startsWith(BRACKET_MAP[leftBracket]);
    });
};
var isClosingBracket = function (text) {
    return Object.keys(BRACKET_MAP).some(function (leftBracket) { return text === BRACKET_MAP[leftBracket]; });
};
//# sourceMappingURL=bracket-handling.js.map

/***/ }),
/* 2382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = indent;
/* harmony export (immutable) */ __webpack_exports__["d"] = outdent;
/* harmony export (immutable) */ __webpack_exports__["b"] = insertIndent;
/* harmony export (immutable) */ __webpack_exports__["c"] = insertNewlineWithIndent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__line_handling__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__analytics__ = __webpack_require__(20);



function indent(state, dispatch) {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1__line_handling__["d" /* getLinesFromSelection */])(state), text = _a.text, start = _a.start;
    var tr = state.tr, selection = state.selection;
    Object(__WEBPACK_IMPORTED_MODULE_1__line_handling__["a" /* forEachLine */])(text, function (line, offset) {
        var _a = Object(__WEBPACK_IMPORTED_MODULE_1__line_handling__["c" /* getLineInfo */])(line), indentText = _a.indentText, indentToken = _a.indentToken;
        var indentToAdd = indentToken.token.repeat(indentToken.size - (indentText.length % indentToken.size) ||
            indentToken.size);
        tr.insertText(indentToAdd, tr.mapping.map(start + offset, -1));
        if (!selection.empty) {
            tr.setSelection(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"].create(tr.doc, tr.mapping.map(selection.from, -1), tr.selection.to));
        }
    });
    dispatch(tr);
    __WEBPACK_IMPORTED_MODULE_2__analytics__["a" /* analyticsService */].trackEvent("atlassian.editor.codeblock.indent");
    return true;
}
function outdent(state, dispatch) {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1__line_handling__["d" /* getLinesFromSelection */])(state), text = _a.text, start = _a.start;
    var tr = state.tr;
    Object(__WEBPACK_IMPORTED_MODULE_1__line_handling__["a" /* forEachLine */])(text, function (line, offset) {
        var _a = Object(__WEBPACK_IMPORTED_MODULE_1__line_handling__["c" /* getLineInfo */])(line), indentText = _a.indentText, indentToken = _a.indentToken;
        if (indentText) {
            var unindentLength = indentText.length % indentToken.size || indentToken.size;
            tr.delete(tr.mapping.map(start + offset), tr.mapping.map(start + offset + unindentLength));
        }
    });
    dispatch(tr);
    __WEBPACK_IMPORTED_MODULE_2__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.codeblock.outdent');
    return true;
}
function insertIndent(state, dispatch) {
    var textAtStartOfLine = Object(__WEBPACK_IMPORTED_MODULE_1__line_handling__["e" /* getStartOfCurrentLine */])(state).text;
    var indentToken = Object(__WEBPACK_IMPORTED_MODULE_1__line_handling__["c" /* getLineInfo */])(textAtStartOfLine).indentToken;
    var indentToAdd = indentToken.token.repeat(indentToken.size - (textAtStartOfLine.length % indentToken.size) ||
        indentToken.size);
    dispatch(state.tr.insertText(indentToAdd));
    __WEBPACK_IMPORTED_MODULE_2__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.codeblock.indent.insert');
    return true;
}
function insertNewlineWithIndent(state, dispatch) {
    var textAtStartOfLine = Object(__WEBPACK_IMPORTED_MODULE_1__line_handling__["e" /* getStartOfCurrentLine */])(state).text;
    var indentText = Object(__WEBPACK_IMPORTED_MODULE_1__line_handling__["c" /* getLineInfo */])(textAtStartOfLine).indentText;
    if (indentText) {
        dispatch(state.tr.insertText('\n' + indentText));
        return true;
    }
    return false;
}
//# sourceMappingURL=commands.js.map

/***/ }),
/* 2383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_collab__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_collab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_collab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugin__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__provider__ = __webpack_require__(439);
/* unused harmony reexport CollabProvider */
/* unused harmony reexport pluginKey */





var collabEditPlugin = function (options) { return ({
    pmPlugins: function () {
        var _a = options || {}, _b = _a.useNativePlugin, useNativePlugin = _b === void 0 ? false : _b, _c = _a.userId, userId = _c === void 0 ? null : _c;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"]((useNativePlugin
            ? [
                {
                    name: 'pmCollab',
                    plugin: function () { return Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_collab__["collab"])({ clientID: userId }); },
                },
            ]
            : []), [
            {
                name: 'collab',
                plugin: function (_a) {
                    var dispatch = _a.dispatch, providerFactory = _a.providerFactory;
                    return Object(__WEBPACK_IMPORTED_MODULE_2__plugin__["a" /* createPlugin */])(dispatch, providerFactory, options);
                },
            },
        ]);
    },
}); };
/* harmony default export */ __webpack_exports__["a"] = (collabEditPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleInit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleConnection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handlePresence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyRemoteData; });
/* unused harmony export applyRemoteSteps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleTelePointer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSendableSelection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_collab__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_collab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_collab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_transform__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_transform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_transform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(284);




var handleInit = function (initData, view, options) {
    var doc = initData.doc, json = initData.json, version = initData.version;
    if (doc) {
        var state = view.state;
        var tr = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["e" /* replaceDocument */])(doc, state, version, options);
        tr.setMeta('isRemote', true);
        var newState = state.apply(tr);
        view.updateState(newState);
    }
    else if (json) {
        applyRemoteSteps(json, undefined, view);
    }
};
var handleConnection = function (connectionData, view) {
    var tr = view.state.tr;
    view.dispatch(tr.setMeta('sessionId', connectionData));
};
var handlePresence = function (presenceData, view) {
    var tr = view.state.tr;
    view.dispatch(tr.setMeta('presence', presenceData));
};
var applyRemoteData = function (remoteData, view, options) {
    var json = remoteData.json, newState = remoteData.newState, _a = remoteData.userIds, userIds = _a === void 0 ? [] : _a;
    if (json) {
        applyRemoteSteps(json, userIds, view, options);
    }
    else if (newState) {
        view.updateState(newState);
    }
};
var applyRemoteSteps = function (json, userIds, view, options) {
    var state = view.state, schema = view.state.schema;
    var steps = json.map(function (step) { return __WEBPACK_IMPORTED_MODULE_1_prosemirror_transform__["Step"].fromJSON(schema, step); });
    var tr;
    if (options && options.useNativePlugin) {
        tr = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_collab__["receiveTransaction"])(state, steps, userIds);
    }
    else {
        tr = state.tr;
        steps.forEach(function (step) { return tr.step(step); });
    }
    if (tr) {
        tr.setMeta('addToHistory', false);
        tr.setMeta('isRemote', true);
        var newState = state.apply(tr);
        view.updateState(newState);
    }
};
var handleTelePointer = function (telepointerData, view) {
    var tr = view.state.tr;
    view.dispatch(tr.setMeta('telepointer', telepointerData));
};
function isAllSelection(selection) {
    return selection instanceof __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["AllSelection"];
}
function isNodeSelection(selection) {
    return selection instanceof __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["NodeSelection"];
}
var getSendableSelection = function (selection) {
    /**
     * <kbd>CMD + A</kbd> triggers a AllSelection
     * <kbd>escape</kbd> triggers a NodeSelection
     */
    return {
        type: 'textSelection',
        anchor: selection.anchor,
        head: isAllSelection(selection) || isNodeSelection(selection)
            ? selection.head - 1
            : selection.head,
    };
};
//# sourceMappingURL=actions.js.map

/***/ }),
/* 2385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Participants; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

var Participants = /** @class */ (function () {
    function Participants(participants) {
        if (participants === void 0) { participants = new Map(); }
        this.participants = participants;
    }
    Participants.prototype.add = function (data) {
        var newSet = new Map(this.participants);
        data.forEach(function (participant) {
            newSet.set(participant.sessionId, participant);
        });
        return new Participants(newSet);
    };
    Participants.prototype.remove = function (sessionIds) {
        var newSet = new Map(this.participants);
        sessionIds.forEach(function (sessionId) {
            newSet.delete(sessionId);
        });
        return new Participants(newSet);
    };
    Participants.prototype.update = function (sessionId, lastActive) {
        var newSet = new Map(this.participants);
        var data = newSet.get(sessionId);
        if (!data) {
            return this;
        }
        newSet.set(sessionId, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, data, { lastActive: lastActive }));
        return new Participants(newSet);
    };
    Participants.prototype.toArray = function () {
        return Array.from(this.participants.values());
    };
    Participants.prototype.get = function (sessionId) {
        return this.participants.get(sessionId);
    };
    Participants.prototype.eq = function (other) {
        var left = this.toArray()
            .map(function (p) { return p.sessionId; })
            .sort(function (a, b) { return (a > b ? -1 : 1); })
            .join('');
        var right = other
            .toArray()
            .map(function (p) { return p.sessionId; })
            .sort(function (a, b) { return (a > b ? -1 : 1); })
            .join('');
        return left === right;
    };
    return Participants;
}());

//# sourceMappingURL=participants.js.map

/***/ }),
/* 2386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PubSubSpecialEventType */
var PubSubSpecialEventType;
(function (PubSubSpecialEventType) {
    PubSubSpecialEventType["ERROR"] = "ERROR";
    PubSubSpecialEventType["CONNECTED"] = "CONNECTED";
    PubSubSpecialEventType["RECONNECT"] = "RECONNECT";
})(PubSubSpecialEventType || (PubSubSpecialEventType = {}));
//# sourceMappingURL=types.js.map

/***/ }),
/* 2387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CollabProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_eventemitter2__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_eventemitter2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_eventemitter2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_collab__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_collab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_collab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__channel__ = __webpack_require__(2388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mock_users__ = __webpack_require__(2389);






var CollabProvider = /** @class */ (function () {
    function CollabProvider(config, pubSubClient) {
        var _this = this;
        this.eventEmitter = new __WEBPACK_IMPORTED_MODULE_1_eventemitter2__["EventEmitter2"]();
        this.queue = [];
        this.getState = function () { };
        this.participants = new Map();
        this.pauseQueue = false;
        this.processRemoteData = function (data, forceApply) {
            if (_this.pauseQueue && !forceApply) {
                Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])("Queue is paused. Aborting.");
                return;
            }
            var version = data.version, steps = data.steps;
            Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])("Processing data. Version: " + version);
            if (steps && steps.length) {
                var userIds = steps.map(function (step) { return step.userId; });
                _this.emit('data', { json: steps, version: version, userIds: userIds });
            }
            _this.processQeueue();
        };
        this.onReceiveData = function (data, forceApply) {
            var currentVersion = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_collab__["getVersion"])(_this.getState());
            var expectedVersion = currentVersion + data.steps.length;
            if (data.version === currentVersion) {
                Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])("Received data we already have. Ignoring.");
            }
            else if (data.version === expectedVersion) {
                _this.processRemoteData(data, forceApply);
            }
            else if (data.version > expectedVersion) {
                Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])("Version too high. Expected " + expectedVersion + " but got " + data.version + ". Current local version is " + currentVersion);
                _this.queueData(data);
            }
        };
        this.onReceiveTelepointer = function (data) {
            var sessionId = data.sessionId;
            if (sessionId === _this.config.userId) {
                return;
            }
            var participant = _this.participants.get(sessionId);
            if (participant && participant.lastActive > data.timestamp) {
                Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])("Old telepointer event. Ignoring.");
                return;
            }
            _this.updateParticipant(sessionId, data.timestamp);
            Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])("Remote telepointer from " + sessionId);
            _this.emit('telepointer', data);
        };
        this.config = config;
        this.channel = new __WEBPACK_IMPORTED_MODULE_3__channel__["a" /* Channel */](config, pubSubClient);
    }
    CollabProvider.prototype.initialize = function (getState) {
        var _this = this;
        this.getState = getState;
        this.channel
            .on('connected', function (_a) {
            var doc = _a.doc, version = _a.version;
            Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])("Joined collab-session. The document version is " + version);
            var userId = _this.config.userId;
            _this.emit('init', { sid: userId, doc: doc, version: version }) // Set initial document
                .emit('connected', { sid: userId }); // Let the plugin know that we're connected an ready to go
        })
            .on('data', this.onReceiveData)
            .on('telepointer', this.onReceiveTelepointer)
            .connect();
        return this;
    };
    /**
     * Send steps from transaction to other participants
     */
    CollabProvider.prototype.send = function (tr, oldState, newState) {
        // Ignore transactions without steps
        if (!tr.steps || !tr.steps.length) {
            return;
        }
        this.channel.sendSteps(newState, this.getState);
    };
    /**
     * Send messages, such as telepointers, to other participants.
     */
    CollabProvider.prototype.sendMessage = function (data) {
        if (!data) {
            return;
        }
        var type = data.type;
        switch (type) {
            case 'telepointer':
                this.channel.sendTelepointer(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, data, { timestamp: new Date().getTime() }));
        }
    };
    CollabProvider.prototype.queueData = function (data) {
        var _this = this;
        Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])("Queuing data for version " + data.version);
        var orderedQueue = __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](this.queue, [data]).sort(function (a, b) {
            return a.version > b.version ? 1 : -1;
        });
        this.queue = orderedQueue;
        if (!this.queueTimeout && !this.pauseQueue) {
            this.queueTimeout = window.setTimeout(function () {
                _this.catchup();
            }, 1000);
        }
    };
    CollabProvider.prototype.catchup = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
            var currentVersion, _a, doc, version_1, steps, userId, _b, localSteps, err_1;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.pauseQueue = true;
                        Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])("Too far behind - fetching data from service");
                        currentVersion = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_collab__["getVersion"])(this.getState());
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.channel.getSteps(currentVersion)];
                    case 2:
                        _a = _c.sent(), doc = _a.doc, version_1 = _a.version, steps = _a.steps;
                        /**
                         * Remove steps from queue where the version is older than
                         * the version we received from service. Keep steps that might be
                         * newer.
                         */
                        this.queue = this.queue.filter(function (data) { return data.version > version_1; });
                        // We are too far behind - replace the entire document
                        if (doc) {
                            Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])("Replacing document.");
                            userId = this.config.userId;
                            _b = (Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_collab__["sendableSteps"])(this.getState()) || {}).steps, localSteps = _b === void 0 ? [] : _b;
                            // Replace local document and version number
                            this.emit('init', { sid: userId, doc: doc, version: version_1 });
                            // Re-aply local steps
                            if (localSteps.length) {
                                this.emit('local-steps', { steps: localSteps });
                            }
                            clearTimeout(this.queueTimeout);
                            this.pauseQueue = false;
                            this.queueTimeout = undefined;
                        }
                        else if (steps) {
                            Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])("Applying the new steps. Version: " + version_1);
                            this.onReceiveData({ steps: steps, version: version_1 }, true);
                            clearTimeout(this.queueTimeout);
                            this.pauseQueue = false;
                            this.queueTimeout = undefined;
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _c.sent();
                        Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])("Unable to get latest steps: " + err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CollabProvider.prototype.processQeueue = function () {
        if (this.pauseQueue) {
            Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])("Queue is paused. Aborting.");
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])("Looking for proccessable data");
        if (this.queue.length === 0) {
            return;
        }
        var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](this.queue, 1), firstItem = _a[0];
        var currentVersion = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_collab__["getVersion"])(this.getState());
        var expectedVersion = currentVersion + firstItem.steps.length;
        if (firstItem.version === expectedVersion) {
            Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])("Applying data from queue!");
            this.queue.splice(0, 1);
            this.processRemoteData(firstItem);
        }
    };
    CollabProvider.prototype.updateParticipant = function (userId, timestamp) {
        var _this = this;
        // TODO: Make batch-request to backend to resolve participants
        var _a = Object(__WEBPACK_IMPORTED_MODULE_5__mock_users__["a" /* getParticipant */])(userId), _b = _a.name, name = _b === void 0 ? '' : _b, _c = _a.email, email = _c === void 0 ? '' : _c, _d = _a.avatar, avatar = _d === void 0 ? '' : _d;
        this.participants.set(userId, {
            name: name,
            email: email,
            avatar: avatar,
            sessionId: userId,
            lastActive: timestamp,
        });
        var joined = [this.participants.get(userId)];
        // Filter out participants that's been inactive for
        // more than 5 minutes.
        var now = new Date().getTime();
        var left = Array.from(this.participants.values()).filter(function (p) { return (now - p.lastActive) / 1000 > 300; });
        left.forEach(function (p) { return _this.participants.delete(p.sessionId); });
        this.emit('presence', { joined: joined, left: left });
    };
    /**
     * Emit events to subscribers
     */
    CollabProvider.prototype.emit = function (evt, data) {
        this.eventEmitter.emit(evt, data);
        return this;
    };
    /**
     * Subscribe to events emitted by this provider
     */
    CollabProvider.prototype.on = function (evt, handler) {
        this.eventEmitter.on(evt, handler);
        return this;
    };
    /**
     * Unsubscribe from events emitted by this provider
     */
    CollabProvider.prototype.off = function (evt, handler) {
        this.eventEmitter.off(evt, handler);
        return this;
    };
    return CollabProvider;
}());

//# sourceMappingURL=collab-provider.js.map

/***/ }),
/* 2388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Channel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_eventemitter2__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_eventemitter2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_eventemitter2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_collab__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_collab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_collab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(439);





var Channel = /** @class */ (function () {
    function Channel(config, pubSubClient) {
        this.eventEmitter = new __WEBPACK_IMPORTED_MODULE_2_eventemitter2__["EventEmitter2"]();
        this.config = config;
        this.pubSubClient = pubSubClient;
    }
    /**
     * Get initial document from service
     */
    Channel.prototype.getDocument = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
            var _a, doc, version, err_1;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */].requestService(this.config, {
                                path: "document/" + this.config.docId,
                            })];
                    case 1:
                        _a = _b.sent(), doc = _a.doc, version = _a.version;
                        return [2 /*return*/, {
                                doc: doc,
                                version: version,
                            }];
                    case 2:
                        err_1 = _b.sent();
                        Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])("Collab-Edit: Document \"" + this.config.docId + "\" does not exist. Creating one locally.");
                        return [2 /*return*/, {
                                doc: {},
                                version: 1,
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Connect to pubsub to start receiving events
     */
    Channel.prototype.connect = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
            var docId, _a, doc, version;
            var _this = this;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_b) {
                switch (_b.label) {
                    case 0:
                        docId = this.config.docId;
                        return [4 /*yield*/, this.getDocument()];
                    case 1:
                        _a = _b.sent(), doc = _a.doc, version = _a.version;
                        this.pubSubClient.on('CONNECT', function () {
                            Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])('Connected to FPS-service');
                        });
                        this.pubSubClient.join(["ari:cloud::fabric:collab-service/" + docId]);
                        this.pubSubClient
                            .on('avi:pf-collab-service:steps:created', function (event, payload) {
                            Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])('Received FPS-payload', { payload: payload });
                            _this.emit('data', payload);
                        })
                            .on('avi:pf-collab-service:telepointer:updated', function (event, payload) {
                            Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])('Received telepointer-payload', { payload: payload });
                            _this.emit('telepointer', payload);
                        });
                        this.eventEmitter.emit('connected', {
                            doc: doc,
                            version: version,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Channel.prototype.debounce = function (getState) {
        var _this = this;
        Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])("Debouncing steps");
        if (this.debounced) {
            clearTimeout(this.debounced);
        }
        this.debounced = window.setTimeout(function () {
            Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])("Sending debounced");
            _this.sendSteps(getState(), getState);
        }, 250);
    };
    /**
     * Send steps to service
     */
    Channel.prototype.sendSteps = function (state, getState, localSteps) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
            var version, _a, steps, response, err_2;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.isSending) {
                            this.debounce(getState);
                            return [2 /*return*/];
                        }
                        version = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_collab__["getVersion"])(state);
                        // Don't send any steps before we're ready.
                        if (typeof version === undefined) {
                            return [2 /*return*/];
                        }
                        _a = (localSteps || Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_collab__["sendableSteps"])(state) || {}).steps, steps = _a === void 0 ? [] : _a;
                        if (steps.length === 0) {
                            Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])("No steps to send. Aborting.");
                            return [2 /*return*/];
                        }
                        this.isSending = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */].requestService(this.config, {
                                path: "document/" + this.config.docId + "/steps",
                                requestInit: {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify({
                                        version: version,
                                        steps: steps,
                                    }),
                                },
                            })];
                    case 2:
                        response = _b.sent();
                        this.isSending = false;
                        Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])("Steps sent and accepted by service.");
                        this.emit('data', response);
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _b.sent();
                        this.isSending = false;
                        Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])("Error sending steps: \"" + err_2 + "\"");
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get steps from version x to latest
     */
    Channel.prototype.getSteps = function (version) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */].requestService(this.config, {
                            path: "document/" + this.config.docId + "/steps",
                            queryParams: {
                                version: version,
                            },
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Send telepointer
     */
    Channel.prototype.sendTelepointer = function (data) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Object(__WEBPACK_IMPORTED_MODULE_4____["a" /* logger */])("Sending telepointer", data);
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */].requestService(this.config, {
                                path: "document/" + this.config.docId + "/telepointer",
                                requestInit: {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify(data),
                                },
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Subscribe to events emitted by this channel
     */
    Channel.prototype.on = function (evt, handler) {
        this.eventEmitter.on(evt, handler);
        return this;
    };
    /**
     * Unsubscribe from events emitted by this channel
     */
    Channel.prototype.off = function (evt, handler) {
        this.eventEmitter.off(evt, handler);
        return this;
    };
    /**
     * Emit events to subscribers
     */
    Channel.prototype.emit = function (evt, data) {
        this.eventEmitter.emit(evt, data);
        return this;
    };
    return Channel;
}());

//# sourceMappingURL=channel.js.map

/***/ }),
/* 2389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getParticipant; });
var participants = [
    'Awilda Mcentire',
    'Katie Iddings',
    'Serafina Mcdowell',
    'Eun Knopp',
    'Walker Reighard',
    'Keely Muth',
    'Allie April',
    'Rosamond Paton',
    'Lashawnda Peppard',
    'Hubert Feingold',
    'Idalia Mcquaig',
    'Wyatt Byer',
    'Genevieve Reeder',
    'Dona Elton',
    'Jerilyn Holte',
    'Salina Erhardt',
    'Velda Latour',
    'Regina Richer',
    'Natisha Tiger',
    'Glynda Stuckey',
    'Wilson Woodberry',
    'Elvie Furtado',
    'Lasandra Palmatier',
    'Louise Mijares',
    'Herma Vanleer',
    'Titus Plante',
    'James Fiscus',
    'Ina Ramero',
    'Jeanene Bernabe',
    'Lida Lepine',
    'Rosalina Palka',
    'Dayle Grossi',
    'Zack Leister',
    'Isobel Fay',
    'Elouise Kluge',
    'Twyla Machin',
    'Diane Herrington',
    'Fumiko Elders',
    'Kennith Howe',
    'Doloris Mccollom',
    'Daryl Wherry',
    'Sade Albury',
    'Roy Cork',
    'Hunter Hultgren',
    'Mi Miley',
    'Isabelle Halperin',
    'Kayla Starke',
    'Allyson Woomer',
    'Sirena Politte',
    'Patricia Scovil',
];
var getParticipant = function (userId) {
    var id = +userId.split('/')[1];
    var name = participants[(id | 0) % participants.length];
    return {
        userId: userId,
        name: name,
        avatar: "https://api.adorable.io/avatars/80/" + name.replace(/\s/g, '') + ".png",
        email: name.replace(/\s/g, '').toLocaleLowerCase() + "@atlassian.com",
    };
};
//# sourceMappingURL=mock-users.js.map

/***/ }),
/* 2390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__ = __webpack_require__(19);

// tslint:disable-next-line:variable-name
var confluenceInlineCommentPlugin = {
    marks: function () {
        return [
            {
                name: 'confluenceInlineComment',
                mark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["p" /* confluenceInlineComment */],
            },
        ];
    },
};
/* harmony default export */ __webpack_exports__["a"] = (confluenceInlineCommentPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_date__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_loadable__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_loadable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__insert_block_ui_ToolbarInsertBlock__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugin__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__keymap__ = __webpack_require__(2461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__editor_disabled__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_editor_common__ = __webpack_require__(13);












var DatePicker = __WEBPACK_IMPORTED_MODULE_4_react_loadable__({
    loader: function () {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 3467)).then(function (module) { return module.default; });
    },
    loading: function () { return null; },
});
var datePlugin = {
    nodes: function () {
        return [{ name: 'date', node: __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__["u" /* date */] }];
    },
    pmPlugins: function () {
        return [
            {
                name: 'date',
                plugin: function (options) {
                    DatePicker.preload();
                    return Object(__WEBPACK_IMPORTED_MODULE_8__plugin__["a" /* default */])(options);
                },
            },
            {
                name: 'dateKeymap',
                plugin: function (_a) {
                    var schema = _a.schema;
                    DatePicker.preload();
                    return Object(__WEBPACK_IMPORTED_MODULE_9__keymap__["a" /* default */])(schema);
                },
            },
        ];
    },
    contentComponent: function (_a) {
        var editorView = _a.editorView;
        var dispatch = editorView.dispatch;
        var domAtPos = editorView.domAtPos.bind(editorView);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ui_WithPluginState__["a" /* default */], { plugins: {
                datePlugin: __WEBPACK_IMPORTED_MODULE_8__plugin__["b" /* pluginKey */],
                editorDisabledPlugin: __WEBPACK_IMPORTED_MODULE_10__editor_disabled__["b" /* pluginKey */],
            }, render: function (_a) {
                var editorDisabledPlugin = _a.editorDisabledPlugin, datePlugin = _a.datePlugin;
                var showDatePickerAt = datePlugin.showDatePickerAt;
                if (!showDatePickerAt ||
                    (editorDisabledPlugin || {}).editorDisabled) {
                    return null;
                }
                var element = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findDomRefAtPos"])(showDatePickerAt, domAtPos);
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DatePicker, { key: showDatePickerAt, element: element, onSelect: function (date) { return Object(__WEBPACK_IMPORTED_MODULE_7__actions__["b" /* insertDate */])(date)(editorView.state, dispatch); }, closeDatePicker: function () {
                        return Object(__WEBPACK_IMPORTED_MODULE_7__actions__["d" /* setDatePickerAt */])(null)(editorView.state, dispatch);
                    } }));
            } }));
    },
    pluginsOptions: {
        quickInsert: function (_a) {
            var formatMessage = _a.formatMessage;
            return [
                {
                    title: formatMessage(__WEBPACK_IMPORTED_MODULE_6__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].date),
                    priority: 800,
                    keywords: ['time', 'today', '/'],
                    icon: function () { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_date___default.a, { label: formatMessage(__WEBPACK_IMPORTED_MODULE_6__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].date) }); },
                    action: function (insert, state) {
                        var dateNode = state.schema.nodes.date.createChecked({
                            timestamp: Object(__WEBPACK_IMPORTED_MODULE_11__atlaskit_editor_common__["_7" /* todayTimestampInUTC */])(),
                        });
                        var tr = insert(dateNode, { selectInlineNode: true });
                        return tr.setMeta(__WEBPACK_IMPORTED_MODULE_8__plugin__["b" /* pluginKey */], {
                            showDatePickerAt: tr.selection.from,
                        });
                    },
                },
            ];
        },
    },
};
/* harmony default export */ __webpack_exports__["a"] = (datePlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var QuoteIcon = function QuoteIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M16.051 6c-1.571 0-2.847 1.312-2.847 2.93 0 1.617 1.276 2.93 2.847 2.93 2.699 0 1.135 5.088-2.269 5.618a.68.68 0 0 0-.578.671c0 .416.372.745.784.682 6.187-.938 8.387-12.83 2.063-12.83M7.848 6C6.275 6 5 7.311 5 8.93c0 1.616 1.275 2.928 2.848 2.928 2.698 0 1.134 5.09-2.27 5.62a.68.68 0 0 0-.578.67c0 .416.372.745.783.682C11.972 17.892 14.172 6 7.848 6\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

QuoteIcon.displayName = 'QuoteIcon';
var _default = QuoteIcon;
exports.default = _default;

/***/ }),
/* 2393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorLinkIcon = function EditorLinkIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M12.654 8.764a.858.858 0 0 1-1.213-1.213l1.214-1.214a3.717 3.717 0 0 1 5.257 0 3.714 3.714 0 0 1 .001 5.258l-1.214 1.214-.804.804a3.72 3.72 0 0 1-5.263.005.858.858 0 0 1 1.214-1.214c.781.782 2.05.78 2.836-.005l.804-.803 1.214-1.214a1.998 1.998 0 0 0-.001-2.831 2 2 0 0 0-2.83 0l-1.215 1.213zm-.808 6.472a.858.858 0 0 1 1.213 1.213l-1.214 1.214a3.717 3.717 0 0 1-5.257 0 3.714 3.714 0 0 1-.001-5.258l1.214-1.214.804-.804a3.72 3.72 0 0 1 5.263-.005.858.858 0 0 1-1.214 1.214 2.005 2.005 0 0 0-2.836.005l-.804.803L7.8 13.618a1.998 1.998 0 0 0 .001 2.831 2 2 0 0 0 2.83 0l1.215-1.213z\" fill=\"currentColor\"/></svg>"
  }, props));
};

EditorLinkIcon.displayName = 'EditorLinkIcon';
var _default = EditorLinkIcon;
exports.default = _default;

/***/ }),
/* 2394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var MediaServicesTextIcon = function MediaServicesTextIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M11 7h2v11h-2zM6 5h12v2H6z\"/><path d=\"M5 5h2v3H5zm5 13h4v2h-4zm7-13h2v3h-2z\"/></g></svg>"
  }, props));
};

MediaServicesTextIcon.displayName = 'MediaServicesTextIcon';
var _default = MediaServicesTextIcon;
exports.default = _default;

/***/ }),
/* 2395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorHorizontalRuleIcon = function EditorHorizontalRuleIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><rect fill=\"currentColor\" x=\"5\" y=\"11\" width=\"14\" height=\"2\" rx=\"1\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorHorizontalRuleIcon.displayName = 'EditorHorizontalRuleIcon';
var _default = EditorHorizontalRuleIcon;
exports.default = _default;

/***/ }),
/* 2396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createTableView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nodeviews_ReactNodeView__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TableComponent__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__width__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pm_plugins_main__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pm_plugins_table_resizing_index__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index__ = __webpack_require__(822);












var tableAttributes = function (node) {
    return {
        'data-number-column': node.attrs.isNumberColumnEnabled,
        'data-layout': node.attrs.layout,
        'data-autosize': node.attrs.__autoSize,
    };
};
var toDOM = function (node, props) {
    var colgroup = '';
    if (props.allowColumnResizing) {
        // @ts-ignore
        colgroup = ['colgroup', {}].concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils__["h" /* generateColgroup */])(node));
    }
    return [
        'table',
        tableAttributes(node),
        colgroup,
        ['tbody', 0],
    ];
};
var TableView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](TableView, _super);
    function TableView(props) {
        var _this = _super.call(this, props.node, props.view, props.getPos, props.portalProviderAPI, props) || this;
        _this.componentDidMount = function () {
            // When we get a table with an 'auto' attribute, we want to:
            // 1. render with table-layout: auto
            // 2. capture the column widths
            // 3. set the column widths as attributes, and remove the 'auto' attribute,
            //    so the table renders the same, but is now fixed-width
            //
            // This can be used to migrate table appearances from other sources that are
            // usually rendered with 'auto'.
            //
            // We use this when migrating TinyMCE tables for Confluence, for example:
            // https://pug.jira-dev.com/wiki/spaces/AEC/pages/3362882215/How+do+we+map+TinyMCE+tables+to+Fabric+tables
            var _a = _this.view, state = _a.state, dispatch = _a.dispatch;
            var tr = state.tr;
            if (_this.node.attrs.__autoSize) {
                var basePos_1 = _this.getPos();
                if (typeof basePos_1 === 'undefined') {
                    return;
                }
                var colWidths_1 = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["D" /* parseDOMColumnWidths */])(_this.contentDOM);
                // overflow tables require all columns to be fixed width
                var tableWidth = colWidths_1.dividedWidths.reduce(function (sum, val) { return sum + val; }, 0);
                var isOverflowTable_1 = tableWidth > __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["p" /* akEditorFullPageMaxWidth */];
                _this.node.forEach(function (rowNode, rowOffset, i) {
                    rowNode.forEach(function (colNode, colOffset, j) {
                        var pos = rowOffset + colOffset + basePos_1 + 2;
                        tr.setNodeMarkup(pos, undefined, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, colNode.attrs, { colwidth: colWidths_1
                                .width(j, colNode.attrs.colspan, !isOverflowTable_1)
                                .map(Math.round) }));
                    });
                });
                // clear autosizing on the table node
                tr.setNodeMarkup(basePos_1, undefined, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, _this.node.attrs, { __autoSize: false }));
                dispatch(tr.setMeta('addToHistory', false));
            }
        };
        return _this;
    }
    TableView.prototype.getContentDOM = function () {
        var rendered = __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__["DOMSerializer"].renderSpec(document, toDOM(this.node, this.reactComponentProps));
        if (rendered.dom) {
            this.table = rendered.dom;
        }
        return rendered;
    };
    TableView.prototype.setDomAttrs = function (node) {
        var _this = this;
        if (!this.table) {
            return;
        }
        var attrs = tableAttributes(node);
        Object.keys(attrs).forEach(function (attr) {
            _this.table.setAttribute(attr, attrs[attr]);
        });
    };
    TableView.prototype.render = function (props, forwardRef) {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ui_WithPluginState__["a" /* default */], { plugins: {
                containerWidth: __WEBPACK_IMPORTED_MODULE_8__width__["b" /* pluginKey */],
                pluginState: __WEBPACK_IMPORTED_MODULE_9__pm_plugins_main__["e" /* pluginKey */],
                tableResizingPluginState: __WEBPACK_IMPORTED_MODULE_10__pm_plugins_table_resizing_index__["b" /* pluginKey */],
            }, editorView: props.view, render: function (pluginStates) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__TableComponent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, props, pluginStates, { node: _this.node, width: pluginStates.containerWidth.width, contentDOM: forwardRef, onComponentMount: _this.componentDidMount }))); } }));
    };
    TableView.prototype.ignoreMutation = function (record) {
        return true;
    };
    return TableView;
}(__WEBPACK_IMPORTED_MODULE_4__nodeviews_ReactNodeView__["a" /* default */]));
/* unused harmony default export */ var _unused_webpack_default_export = (TableView);
var createTableView = function (portalProviderAPI) { return function (node, view, getPos) {
    var pluginConfig = Object(__WEBPACK_IMPORTED_MODULE_9__pm_plugins_main__["d" /* getPluginState */])(view.state).pluginConfig;
    var allowColumnResizing = Object(__WEBPACK_IMPORTED_MODULE_11__index__["b" /* pluginConfig */])(pluginConfig).allowColumnResizing;
    return new TableView({
        node: node,
        view: view,
        allowColumnResizing: allowColumnResizing,
        portalProviderAPI: portalProviderAPI,
        getPos: getPos,
    }).init();
}; };
//# sourceMappingURL=table.js.map

/***/ }),
/* 2397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isHeaderRowSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isSelectionUpdated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return normalizeSelection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_tables__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__);


var isHeaderRowSelected = function (state) {
    var isSelected = false;
    if (Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["isCellSelection"])(state.selection)) {
        state.selection.forEachCell(function (cell) {
            if (cell.type === state.schema.nodes.tableHeader) {
                isSelected = true;
            }
        });
    }
    return isSelected;
};
var isSelectionUpdated = function (oldSelection, newSelection) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["isCellSelection"])(oldSelection) !== Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["isCellSelection"])(newSelection) ||
        (Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["isCellSelection"])(oldSelection) &&
            Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["isCellSelection"])(newSelection) &&
            oldSelection.ranges !== newSelection.ranges);
};
var isRectangularCellSelection = function (selection, rect) {
    var table = Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["findTable"])(selection);
    if (!table) {
        return true;
    }
    var _a = __WEBPACK_IMPORTED_MODULE_0_prosemirror_tables__["TableMap"].get(table.node), width = _a.width, height = _a.height, map = _a.map;
    var indexTop = rect.top * width + rect.left;
    var indexLeft = indexTop;
    var indexBottom = (rect.bottom - 1) * width + rect.left;
    var indexRight = indexTop + (rect.right - rect.left - 1);
    for (var i = rect.top; i < rect.bottom; i++) {
        if ((rect.left > 0 && map[indexLeft] === map[indexLeft - 1]) ||
            (rect.right < width && map[indexRight] === map[indexRight + 1])) {
            return false;
        }
        indexLeft += width;
        indexRight += width;
    }
    for (var i = rect.left; i < rect.right; i++) {
        if ((rect.top > 0 && map[indexTop] === map[indexTop - width]) ||
            (rect.bottom < height && map[indexBottom] === map[indexBottom + width])) {
            return false;
        }
        indexTop++;
        indexBottom++;
    }
    return true;
};
var normalizeSelection = function (tr) {
    var selection = tr.selection;
    var rect = Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["getSelectionRect"])(selection);
    if (!rect ||
        !(selection instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_tables__["CellSelection"]) ||
        isRectangularCellSelection(selection, rect)) {
        return tr;
    }
    if (selection.isColSelection()) {
        var $anchor = Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["getSelectionRangeInColumn"])(rect.left)(tr).$anchor;
        var $head = Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["getSelectionRangeInColumn"])(rect.right - 1)(tr).$head;
        return tr.setSelection(new __WEBPACK_IMPORTED_MODULE_0_prosemirror_tables__["CellSelection"]($anchor, $head));
    }
    if (selection.isRowSelection()) {
        var $anchor = Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["getSelectionRangeInRow"])(rect.top)(tr).$anchor;
        var $head = Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["getSelectionRangeInRow"])(rect.bottom - 1)(tr).$head;
        return tr.setSelection(new __WEBPACK_IMPORTED_MODULE_0_prosemirror_tables__["CellSelection"]($anchor, $head));
    }
    return tr;
};
//# sourceMappingURL=selection.js.map

/***/ }),
/* 2398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createControlsHoverDecoration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return findControlsHoverDecoration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_view__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(44);


var createControlsHoverDecoration = function (cells, danger) {
    var deco = cells.map(function (cell) {
        var classes = [__WEBPACK_IMPORTED_MODULE_1__types__["a" /* TableCssClassName */].HOVERED_CELL];
        if (danger) {
            classes.push('danger');
        }
        return __WEBPACK_IMPORTED_MODULE_0_prosemirror_view__["Decoration"].node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: classes.join(' '),
        }, { key: __WEBPACK_IMPORTED_MODULE_1__types__["b" /* TableDecorations */].CONTROLS_HOVER });
    });
    return deco;
};
var findControlsHoverDecoration = function (decorationSet) {
    return decorationSet.find(undefined, undefined, function (spec) { return spec.key === __WEBPACK_IMPORTED_MODULE_1__types__["b" /* TableDecorations */].CONTROLS_HOVER; });
};
//# sourceMappingURL=decoration.js.map

/***/ }),
/* 2399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isIsolating; });
/* unused harmony export containsHeaderColumn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return containsHeaderRow; });
/* unused harmony export filterNearSelection */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkIfHeaderColumnEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return checkIfHeaderRowEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return checkIfNumberColumnEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isLayoutSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_tables__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__ = __webpack_require__(83);



var isIsolating = function (node) {
    return !!node.type.spec.isolating;
};
var containsHeaderColumn = function (state, table) {
    var tableHeader = state.schema.nodes.tableHeader;
    var contains = true;
    table.content.forEach(function (row) {
        if (row.firstChild && row.firstChild.type !== tableHeader) {
            contains = false;
        }
    });
    return contains;
};
var containsHeaderRow = function (state, table) {
    var map = __WEBPACK_IMPORTED_MODULE_0_prosemirror_tables__["TableMap"].get(table);
    for (var i = 0; i < map.width; i++) {
        var cell = table.nodeAt(map.map[i]);
        if (cell && cell.type !== state.schema.nodes.tableHeader) {
            return false;
        }
    }
    return true;
};
function filterNearSelection(state, findNode, predicate, defaultValue) {
    var found = findNode(state.selection);
    if (!found) {
        return defaultValue;
    }
    return predicate(state, found.node, found.pos);
}
var checkIfHeaderColumnEnabled = function (state) {
    return filterNearSelection(state, __WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["findTable"], containsHeaderColumn, false);
};
var checkIfHeaderRowEnabled = function (state) {
    return filterNearSelection(state, __WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["findTable"], containsHeaderRow, false);
};
var checkIfNumberColumnEnabled = function (state) {
    return filterNearSelection(state, __WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["findTable"], function (_, table) { return !!table.attrs.isNumberColumnEnabled; }, false);
};
var isLayoutSupported = function (state) {
    var permittedLayouts = __WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["e" /* pluginKey */].getState(state).pluginConfig.permittedLayouts;
    var _a = state.schema.nodes, bodiedExtension = _a.bodiedExtension, layoutSection = _a.layoutSection;
    return (!Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["hasParentNodeOfType"])([layoutSection, bodiedExtension])(state.selection) &&
        permittedLayouts &&
        (permittedLayouts === 'all' ||
            (permittedLayouts.indexOf('default') > -1 &&
                permittedLayouts.indexOf('wide') > -1 &&
                permittedLayouts.indexOf('full-page') > -1)));
};
//# sourceMappingURL=nodes.js.map

/***/ }),
/* 2400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ColumnWidths */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parseDOMColumnWidths; });
var ColumnWidths = /** @class */ (function () {
    function ColumnWidths() {
        this.columns = [];
    }
    Object.defineProperty(ColumnWidths.prototype, "dividedWidths", {
        /**
         * Returns an array with individual column widths, with each column spread evenly across
         * the columns it spans.
         */
        get: function () {
            return this.columns.map(function (colInfo) { return colInfo.width / colInfo.span; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnWidths.prototype, "columnInfo", {
        get: function () {
            return this.columns;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns an array representing the widths of each (possibly spanned) column within a range.
     * @param colIdx 0-based index for the start column.
     * @param span The number of columns the cell spans.
     * @param autosizeEnd Whether to return 0 for the very last column of the table.
     */
    ColumnWidths.prototype.width = function (colIdx, span, autosizeEnd) {
        var _this = this;
        if (span === void 0) { span = 1; }
        if (autosizeEnd === void 0) { autosizeEnd = false; }
        return this.columns
            .slice(colIdx, colIdx + span)
            .map(function (colInfo, idx) {
            return autosizeEnd && idx + colIdx === _this.columns.length - 1
                ? 0
                : colInfo.width;
        });
    };
    ColumnWidths.prototype.visit = function (colIdx, width, span) {
        if (span === void 0) { span = 1; }
        if (this.columns.length && colIdx < this.columns.length) {
            var existingCol = this.columns[colIdx];
            if (span <= existingCol.span) {
                // split the column
                existingCol.span -= span;
                this.columns = this.columns.fill({
                    width: width,
                    span: span,
                }, colIdx, colIdx + span);
            }
            else if (span === existingCol.span) {
                // same column span, update the width
                existingCol.width = width;
            }
        }
        else {
            // unseen columns
            this.columns = this.columns.concat(Array(this.columns.length + span - colIdx));
            this.columns.fill({
                width: width,
                span: span,
            }, colIdx, colIdx + span);
        }
    };
    return ColumnWidths;
}());
function parseDOMColumnWidths(node) {
    var tw = new ColumnWidths();
    var rows = node.querySelectorAll('tr');
    for (var i = 0, rowCount = rows.length; i < rowCount; i++) {
        var row = rows[i];
        var cols = row.querySelectorAll('td,th');
        var colPos = 0;
        for (var j = 0, colCount = cols.length; j < colCount; j++) {
            var col = cols[j];
            var cssWidth = getComputedStyle(col).width;
            var colwidth = cssWidth.endsWith('px')
                ? Number(cssWidth.substring(0, cssWidth.length - 2))
                : 0;
            var colspan = col.hasAttribute('colspan')
                ? Number(col.getAttribute('colspan'))
                : 1;
            tw.visit(colPos, colwidth, colspan);
            colPos += colspan;
        }
    }
    return tw;
}

//# sourceMappingURL=colwidth.js.map

/***/ }),
/* 2401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export unwrapContentFromTable */
/* unused harmony export removeTableFromFirstChild */
/* unused harmony export removeTableFromLastChild */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return transformSliceToRemoveOpenTable; });
/* harmony export (immutable) */ __webpack_exports__["a"] = transformSliceToRemoveNumberColumn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_slice__ = __webpack_require__(104);




// lifts up the content of each cell, returning an array of nodes
var unwrapContentFromTable = function (maybeTable) {
    var schema = maybeTable.type.schema;
    if (maybeTable.type === schema.nodes.table) {
        var content_1 = [];
        var _a = schema.nodes, tableCell_1 = _a.tableCell, tableHeader_1 = _a.tableHeader;
        maybeTable.descendants(function (maybeCell) {
            if (maybeCell.type === tableCell_1 || maybeCell.type === tableHeader_1) {
                content_1.push.apply(content_1, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["flatten"])(maybeCell, false).map(function (child) { return child.node; })));
            }
            return true;
        });
        return content_1;
    }
    return maybeTable;
};
var removeTableFromFirstChild = function (node, i) {
    return i === 0 ? unwrapContentFromTable(node) : node;
};
var removeTableFromLastChild = function (node, i, fragment) {
    return i === fragment.childCount - 1 ? unwrapContentFromTable(node) : node;
};
var transformSliceToRemoveOpenTable = function (slice, schema) {
    // we're removing the table, tableRow and tableCell reducing the open depth by 3
    var depthDecrement = 3;
    // Case 1: A slice entirely within a single CELL
    if (
    // starts and ends inside of a cell
    slice.openStart >= 4 &&
        slice.openEnd >= 4 &&
        // slice is a table node
        slice.content.childCount === 1 &&
        slice.content.firstChild.type === schema.nodes.table) {
        return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"](Object(__WEBPACK_IMPORTED_MODULE_3__utils_slice__["a" /* flatmap */])(slice.content, unwrapContentFromTable), slice.openStart - depthDecrement, slice.openEnd - depthDecrement);
    }
    // Case 2: A slice starting inside a table and finishing outside
    // slice.openStart can only be >= 4 if its a TextSelection. CellSelection would give openStart = 1
    if (slice.openStart >= 4 &&
        slice.content.firstChild.type === schema.nodes.table) {
        return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"](Object(__WEBPACK_IMPORTED_MODULE_3__utils_slice__["a" /* flatmap */])(slice.content, removeTableFromFirstChild), slice.openStart - depthDecrement, slice.openEnd);
    }
    // Case 3: A slice starting outside a table and finishing inside
    if (slice.openEnd >= 4 &&
        slice.content.lastChild.type === schema.nodes.table) {
        return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Slice"](Object(__WEBPACK_IMPORTED_MODULE_3__utils_slice__["a" /* flatmap */])(slice.content, removeTableFromLastChild), slice.openStart, slice.openEnd - depthDecrement);
    }
    return slice;
};
function transformSliceToRemoveNumberColumn(slice, schema) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_slice__["e" /* mapSlice */])(slice, function (maybeTable) {
        if (maybeTable.type === schema.nodes.table &&
            maybeTable.attrs.isNumberColumnEnabled) {
            var rows_1 = [];
            maybeTable.forEach(function (row) {
                var cells = [];
                row.forEach(function (cell, _, index) {
                    if (index > 0) {
                        cells.push(cell);
                    }
                });
                rows_1.push(row.copy(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(cells)));
            });
            return maybeTable.copy(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Fragment"].from(rows_1));
        }
        return maybeTable;
    });
}
//# sourceMappingURL=paste.js.map

/***/ }),
/* 2402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isInsertColumnButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isInsertRowButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(21);


var isInsertColumnButton = function (node) {
    var cl = node.classList;
    return (cl.contains(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* TableCssClassName */].CONTROLS_INSERT_COLUMN) ||
        Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* closestElement */])(node, "." + __WEBPACK_IMPORTED_MODULE_0__types__["a" /* TableCssClassName */].CONTROLS_INSERT_COLUMN) ||
        (cl.contains(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* TableCssClassName */].CONTROLS_BUTTON_OVERLAY) &&
            Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* closestElement */])(node, "." + __WEBPACK_IMPORTED_MODULE_0__types__["a" /* TableCssClassName */].COLUMN_CONTROLS)));
};
var isInsertRowButton = function (node) {
    var cl = node.classList;
    return (cl.contains(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* TableCssClassName */].CONTROLS_INSERT_ROW) ||
        Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* closestElement */])(node, "." + __WEBPACK_IMPORTED_MODULE_0__types__["a" /* TableCssClassName */].CONTROLS_INSERT_ROW) ||
        (cl.contains(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* TableCssClassName */].CONTROLS_BUTTON_OVERLAY) &&
            Object(__WEBPACK_IMPORTED_MODULE_1__utils__["i" /* closestElement */])(node, "." + __WEBPACK_IMPORTED_MODULE_0__types__["a" /* TableCssClassName */].ROW_CONTROLS)));
};
var getIndex = function (target) {
    return parseInt(target.getAttribute('data-index') || '-1', 10);
};
//# sourceMappingURL=dom.js.map

/***/ }),
/* 2403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getColumnsWidths; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isColumnInsertButtonVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isColumnDeleteButtonVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getColumnDeleteButtonParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getColumnsParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getColumnClassNames; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_tables__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_styles__ = __webpack_require__(99);



var getColumnsWidths = function (view) {
    var selection = view.state.selection;
    var widths = [];
    var table = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["findTable"])(selection);
    if (table) {
        var map = __WEBPACK_IMPORTED_MODULE_1_prosemirror_tables__["TableMap"].get(table.node);
        var domAtPos = view.domAtPos.bind(view);
        for (var i = 0; i < map.width; i++) {
            var cells = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["getCellsInColumn"])(i)(selection);
            var cell = cells[0];
            if (cell) {
                var cellRef = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["findDomRefAtPos"])(cell.pos, domAtPos);
                widths[i] = cellRef.offsetWidth + 1;
                i += cell.node.attrs.colspan - 1;
            }
        }
    }
    return widths;
};
var isColumnInsertButtonVisible = function (index, selection) {
    var rect = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["getSelectionRect"])(selection);
    if (rect &&
        selection instanceof __WEBPACK_IMPORTED_MODULE_1_prosemirror_tables__["CellSelection"] &&
        selection.isColSelection() &&
        !Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["isTableSelected"])(selection) &&
        rect.right - index === index - rect.left) {
        return false;
    }
    return true;
};
var isColumnDeleteButtonVisible = function (selection) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["isTableSelected"])(selection) &&
        (selection instanceof __WEBPACK_IMPORTED_MODULE_1_prosemirror_tables__["CellSelection"] && selection.isColSelection())) {
        return true;
    }
    return false;
};
var getColumnDeleteButtonParams = function (columnsWidths, selection) {
    var rect = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["getSelectionRect"])(selection);
    if (!rect) {
        return null;
    }
    var width = 0;
    var offset = 0;
    // find the columns before the selection
    for (var i = 0; i < rect.left; i++) {
        var colWidth = columnsWidths[i];
        if (colWidth) {
            offset += colWidth - 1;
        }
    }
    // these are the selected columns widths
    var indexes = [];
    for (var i = rect.left; i < rect.right; i++) {
        var colWidth = columnsWidths[i];
        if (colWidth) {
            width += colWidth;
            indexes.push(i);
        }
    }
    var left = offset + width / 2 - __WEBPACK_IMPORTED_MODULE_2__ui_styles__["e" /* tableDeleteButtonSize */] / 2;
    return { left: left, indexes: indexes };
};
var getColumnsParams = function (columnsWidths) {
    var columns = [];
    for (var i = 0, count = columnsWidths.length; i < count; i++) {
        var width = columnsWidths[i];
        if (!width) {
            continue;
        }
        var endIndex = columnsWidths.length;
        for (var k = i + 1, count_1 = columnsWidths.length; k < count_1; k++) {
            if (columnsWidths[k]) {
                endIndex = k;
                break;
            }
        }
        columns.push({ startIndex: i, endIndex: endIndex, width: width });
    }
    return columns;
};
var getColumnClassNames = function (index, selection, hoveredColumns, isInDanger, isResizing) {
    if (hoveredColumns === void 0) { hoveredColumns = []; }
    var classNames = [];
    if (Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["isColumnSelected"])(index)(selection) ||
        (hoveredColumns.indexOf(index) > -1 && !isResizing)) {
        classNames.push('active');
        if (isInDanger) {
            classNames.push('danger');
        }
    }
    return classNames.join(' ');
};
//# sourceMappingURL=column-controls.js.map

/***/ }),
/* 2404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getRowHeights; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isRowInsertButtonVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isRowDeleteButtonVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getRowDeleteButtonParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getRowsParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRowClassNames; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_tables__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_styles__ = __webpack_require__(99);



var getRowHeights = function (tableRef) {
    var heights = [];
    var rows = tableRef.querySelectorAll('tr');
    for (var i = 0, count = rows.length; i < count; i++) {
        heights[i] = rows[i].offsetHeight + 1;
    }
    return heights;
};
var isRowInsertButtonVisible = function (index, selection) {
    var rect = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["getSelectionRect"])(selection);
    if (rect &&
        selection instanceof __WEBPACK_IMPORTED_MODULE_1_prosemirror_tables__["CellSelection"] &&
        selection.isRowSelection() &&
        !Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["isTableSelected"])(selection) &&
        rect.bottom - index === index - rect.top) {
        return false;
    }
    return true;
};
var isRowDeleteButtonVisible = function (selection) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["isTableSelected"])(selection) &&
        (selection instanceof __WEBPACK_IMPORTED_MODULE_1_prosemirror_tables__["CellSelection"] && selection.isRowSelection())) {
        return true;
    }
    return false;
};
var getRowDeleteButtonParams = function (rowsHeights, selection) {
    var rect = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["getSelectionRect"])(selection);
    if (!rect) {
        return null;
    }
    var height = 0;
    var offset = 0;
    // find the rows before the selection
    for (var i = 0; i < rect.top; i++) {
        var rowHeight = rowsHeights[i];
        if (rowHeight) {
            offset += rowHeight - 2;
        }
    }
    // these are the selected rows widths
    var indexes = [];
    for (var i = rect.top; i < rect.bottom; i++) {
        var rowHeight = rowsHeights[i];
        if (rowHeight) {
            height += rowHeight - 2;
            indexes.push(i);
        }
    }
    var top = offset + height / 2 - __WEBPACK_IMPORTED_MODULE_2__ui_styles__["e" /* tableDeleteButtonSize */] / 2;
    return { top: top, indexes: indexes };
};
var getRowsParams = function (rowsHeights) {
    var rows = [];
    for (var i = 0, count = rowsHeights.length; i < count; i++) {
        var height = rowsHeights[i];
        if (!height) {
            continue;
        }
        var endIndex = rowsHeights.length;
        for (var k = i + 1, count_1 = rowsHeights.length; k < count_1; k++) {
            if (rowsHeights[k]) {
                endIndex = k;
                break;
            }
        }
        rows.push({ startIndex: i, endIndex: endIndex, height: height });
    }
    return rows;
};
var getRowClassNames = function (index, selection, hoveredRows, isInDanger, isResizing) {
    if (hoveredRows === void 0) { hoveredRows = []; }
    var classNames = [];
    if (Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["isRowSelected"])(index)(selection) ||
        (hoveredRows.indexOf(index) > -1 && !isResizing)) {
        classNames.push('active');
        if (isInDanger) {
            classNames.push('danger');
        }
    }
    return classNames.join(' ');
};
//# sourceMappingURL=row-controls.js.map

/***/ }),
/* 2405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fixTables; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__);


var fixTable = function (table, tablePos, tr) {
    var rowPos = tablePos + 1;
    var _loop_1 = function (i) {
        var row = table.child(i);
        if (!row.childCount) {
            rowPos = tr.mapping.map(rowPos);
            tr.delete(rowPos, rowPos + row.nodeSize);
            var _loop_2 = function (j) {
                var cells = Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["getCellsInRow"])(j)(tr.selection);
                if (cells) {
                    cells.forEach(function (cell) {
                        var rowspan = cell.node.attrs.rowspan;
                        if (rowspan + j - 1 >= i) {
                            tr.setNodeMarkup(cell.pos, cell.node.type, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, cell.node.attrs, { rowspan: rowspan - 1 }));
                        }
                    });
                }
            };
            // decrement rowspans @see ED-5802
            for (var j = i - 1; j >= 0; j--) {
                _loop_2(j);
            }
        }
        rowPos += row.nodeSize;
    };
    for (var i = 0; i < table.childCount; i++) {
        _loop_1(i);
    }
    return tr;
};
var fixTables = function (tr) {
    tr.doc.descendants(function (node, pos) {
        if (node.type.name === 'table') {
            tr = fixTable(node, pos, tr);
        }
    });
    return tr;
};
//# sourceMappingURL=fix-tables.js.map

/***/ }),
/* 2406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateColgroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return renderColgroupFromNode; });
/* unused harmony export insertColgroupFromNode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasTableBeenResized; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_slice__ = __webpack_require__(104);


var generateColgroup = function (node) {
    var cols = [];
    node.content.firstChild.content.forEach(function (cell) {
        if (Array.isArray(cell.attrs.colwidth)) {
            cell.attrs.colwidth.forEach(function (width) {
                cols.push(['col', { style: "width: " + width + "px;" }]);
            });
        }
        else {
            cols.push(['col', {}]);
        }
    });
    return cols;
};
var renderColgroupFromNode = function (node) {
    var rendered = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["DOMSerializer"].renderSpec(document, 
    // @ts-ignore
    ['colgroup', {}].concat(generateColgroup(node)));
    if (rendered.dom) {
        return rendered.dom;
    }
};
var insertColgroupFromNode = function (tableElem, node) {
    var colgroup = tableElem.querySelector('colgroup');
    if (colgroup) {
        tableElem.removeChild(colgroup);
    }
    colgroup = renderColgroupFromNode(node);
    tableElem.insertBefore(colgroup, tableElem.firstChild);
    return colgroup.children;
};
var hasTableBeenResized = function (node) {
    return !!Object(__WEBPACK_IMPORTED_MODULE_1__utils_slice__["b" /* getFragmentBackingArray */])(node.content.firstChild.content).find(function (cell) { return cell.attrs.colwidth; });
};
//# sourceMappingURL=colgroup.js.map

/***/ }),
/* 2407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CornerControls__ = __webpack_require__(2408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RowControls__ = __webpack_require__(2409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NumberColumn__ = __webpack_require__(2410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(61);









var TableFloatingControls = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](TableFloatingControls, _super);
    function TableFloatingControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectRow = function (row) {
            var editorView = _this.props.editorView;
            var state = editorView.state, dispatch = editorView.dispatch;
            // fix for issue ED-4665
            if (__WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["E" /* browser */].ie_version === 11) {
                editorView.dom.blur();
            }
            Object(__WEBPACK_IMPORTED_MODULE_7__actions__["t" /* selectRow */])(row)(state, dispatch);
            Object(__WEBPACK_IMPORTED_MODULE_7__actions__["a" /* clearHoverSelection */])(editorView.state, dispatch);
        };
        _this.hoverRows = function (rows, danger) {
            var _a = _this.props.editorView, state = _a.state, dispatch = _a.dispatch;
            Object(__WEBPACK_IMPORTED_MODULE_7__actions__["n" /* hoverRows */])(rows, danger)(state, dispatch);
        };
        return _this;
    }
    TableFloatingControls.prototype.shouldComponentUpdate = function (nextProps) {
        var _a = this.props, tableRef = _a.tableRef, isInDanger = _a.isInDanger, isResizing = _a.isResizing, isHeaderRowEnabled = _a.isHeaderRowEnabled, isHeaderColumnEnabled = _a.isHeaderColumnEnabled, isNumberColumnEnabled = _a.isNumberColumnEnabled, hoveredRows = _a.hoveredRows, selection = _a.selection, tableHeight = _a.tableHeight, tableActive = _a.tableActive, insertColumnButtonIndex = _a.insertColumnButtonIndex, insertRowButtonIndex = _a.insertRowButtonIndex;
        return (tableRef !== nextProps.tableRef ||
            insertColumnButtonIndex !== nextProps.insertColumnButtonIndex ||
            insertRowButtonIndex !== nextProps.insertRowButtonIndex ||
            tableHeight !== nextProps.tableHeight ||
            tableActive !== nextProps.tableActive ||
            isInDanger !== nextProps.isInDanger ||
            isResizing !== nextProps.isResizing ||
            hoveredRows !== nextProps.hoveredRows ||
            isHeaderRowEnabled !== nextProps.isHeaderRowEnabled ||
            isHeaderColumnEnabled !== nextProps.isHeaderColumnEnabled ||
            isNumberColumnEnabled !== nextProps.isNumberColumnEnabled ||
            Object(__WEBPACK_IMPORTED_MODULE_6__utils__["B" /* isSelectionUpdated */])(selection, nextProps.selection));
    };
    TableFloatingControls.prototype.render = function () {
        var _a = this.props, editorView = _a.editorView, tableRef = _a.tableRef, isInDanger = _a.isInDanger, isResizing = _a.isResizing, isNumberColumnEnabled = _a.isNumberColumnEnabled, isHeaderColumnEnabled = _a.isHeaderColumnEnabled, isHeaderRowEnabled = _a.isHeaderRowEnabled, tableActive = _a.tableActive, hasHeaderRow = _a.hasHeaderRow, hoveredRows = _a.hoveredRows, insertColumnButtonIndex = _a.insertColumnButtonIndex, insertRowButtonIndex = _a.insertRowButtonIndex;
        if (!tableRef) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { onMouseDown: function (e) { return e.preventDefault(); } },
            isNumberColumnEnabled ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__NumberColumn__["a" /* default */], { editorView: editorView, hoverRows: this.hoverRows, tableRef: tableRef, tableActive: tableActive, hoveredRows: hoveredRows, hasHeaderRow: hasHeaderRow, isInDanger: isInDanger, isResizing: isResizing, selectRow: this.selectRow })) : null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__CornerControls__["a" /* default */], { editorView: editorView, tableRef: tableRef, isInDanger: isInDanger, isResizing: isResizing, isHeaderColumnEnabled: isHeaderColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, hoveredRows: hoveredRows }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__RowControls__["a" /* default */], { editorView: editorView, tableRef: tableRef, hoverRows: this.hoverRows, hoveredRows: hoveredRows, isInDanger: isInDanger, isResizing: isResizing, selectRow: this.selectRow, insertRowButtonIndex: insertRowButtonIndex })));
    };
    return TableFloatingControls;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (TableFloatingControls);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_tables__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prosemirror_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InsertButton__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types__ = __webpack_require__(44);









var CornerControls = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CornerControls, _super);
    function CornerControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isActive = function () {
            var _a = _this.props, editorView = _a.editorView, hoveredRows = _a.hoveredRows, isResizing = _a.isResizing;
            var selection = editorView.state.selection;
            var table = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findTable"])(selection);
            if (!table) {
                return false;
            }
            return (Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["isTableSelected"])(selection) ||
                (hoveredRows &&
                    hoveredRows.length === __WEBPACK_IMPORTED_MODULE_4_prosemirror_tables__["TableMap"].get(table.node).height &&
                    !isResizing));
        };
        _this.clearHoverSelection = function () {
            var _a = _this.props.editorView, state = _a.state, dispatch = _a.dispatch;
            Object(__WEBPACK_IMPORTED_MODULE_6__actions__["a" /* clearHoverSelection */])(state, dispatch);
        };
        _this.selectTable = function () {
            var _a = _this.props.editorView, state = _a.state, dispatch = _a.dispatch;
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["selectTable"])(state.tr).setMeta('addToHistory', false));
        };
        _this.hoverTable = function () {
            var _a = _this.props.editorView, state = _a.state, dispatch = _a.dispatch;
            Object(__WEBPACK_IMPORTED_MODULE_6__actions__["o" /* hoverTable */])()(state, dispatch);
        };
        _this.insertColumn = function () {
            var _a = _this.props.editorView, state = _a.state, dispatch = _a.dispatch;
            Object(__WEBPACK_IMPORTED_MODULE_6__actions__["p" /* insertColumn */])(0)(state, dispatch);
        };
        _this.insertRow = function () {
            var _a = _this.props.editorView, state = _a.state, dispatch = _a.dispatch;
            Object(__WEBPACK_IMPORTED_MODULE_6__actions__["q" /* insertRow */])(0)(state, dispatch);
        };
        return _this;
    }
    CornerControls.prototype.render = function () {
        var _a = this.props, isInDanger = _a.isInDanger, isResizing = _a.isResizing, isHeaderRowEnabled = _a.isHeaderRowEnabled, isHeaderColumnEnabled = _a.isHeaderColumnEnabled, insertColumnButtonIndex = _a.insertColumnButtonIndex, insertRowButtonIndex = _a.insertRowButtonIndex, tableRef = _a.tableRef;
        if (!tableRef) {
            return null;
        }
        var isActive = this.isActive();
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2_classnames__(__WEBPACK_IMPORTED_MODULE_7__types__["a" /* TableCssClassName */].CORNER_CONTROLS, {
                active: isActive,
            }) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", { type: "button", className: __WEBPACK_IMPORTED_MODULE_2_classnames__(__WEBPACK_IMPORTED_MODULE_7__types__["a" /* TableCssClassName */].CONTROLS_CORNER_BUTTON, {
                    danger: isActive && isInDanger,
                }), onClick: this.selectTable, onMouseOver: this.hoverTable, onMouseOut: this.clearHoverSelection }),
            !isHeaderColumnEnabled && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__InsertButton__["a" /* default */], { type: "column", tableRef: tableRef, index: 0, showInsertButton: !isResizing && insertColumnButtonIndex === 0, onMouseDown: this.insertColumn })),
            !isHeaderRowEnabled && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__InsertButton__["a" /* default */], { type: "row", tableRef: tableRef, index: 0, showInsertButton: !isResizing && insertRowButtonIndex === 0, onMouseDown: this.insertRow }))));
    };
    return CornerControls;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (CornerControls);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InsertButton__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DeleteButton__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__messages__ = __webpack_require__(214);










var RowControls = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](RowControls, _super);
    function RowControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clearHoverSelection = function () {
            var _a = _this.props.editorView, state = _a.state, dispatch = _a.dispatch;
            Object(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* clearHoverSelection */])(state, dispatch);
        };
        _this.insertRow = function (row) {
            var _a = _this.props.editorView, state = _a.state, dispatch = _a.dispatch;
            Object(__WEBPACK_IMPORTED_MODULE_3__actions__["q" /* insertRow */])(row)(state, dispatch);
        };
        _this.deleteSelectedRows = function () {
            var _a = _this.props.editorView, state = _a.state, dispatch = _a.dispatch;
            Object(__WEBPACK_IMPORTED_MODULE_3__actions__["f" /* deleteSelectedRows */])(state, dispatch);
            _this.clearHoverSelection();
        };
        return _this;
    }
    RowControls.prototype.render = function () {
        var _this = this;
        var _a = this.props, editorView = _a.editorView, tableRef = _a.tableRef, insertRowButtonIndex = _a.insertRowButtonIndex, hoveredRows = _a.hoveredRows, isInDanger = _a.isInDanger, isResizing = _a.isResizing;
        if (!tableRef) {
            return null;
        }
        var selection = editorView.state.selection;
        var rowHeights = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["p" /* getRowHeights */])(tableRef);
        var rowsParams = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["q" /* getRowsParams */])(rowHeights);
        var deleteBtnParams = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["o" /* getRowDeleteButtonParams */])(rowHeights, selection);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_7__types__["a" /* TableCssClassName */].ROW_CONTROLS },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_7__types__["a" /* TableCssClassName */].ROW_CONTROLS_INNER },
                rowsParams.map(function (_a) {
                    var startIndex = _a.startIndex, endIndex = _a.endIndex, height = _a.height;
                    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_7__types__["a" /* TableCssClassName */].ROW_CONTROLS_BUTTON_WRAP + " " + Object(__WEBPACK_IMPORTED_MODULE_6__utils__["n" /* getRowClassNames */])(startIndex, selection, hoveredRows, isInDanger, isResizing), key: startIndex, style: { height: height } },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", { type: "button", className: __WEBPACK_IMPORTED_MODULE_7__types__["a" /* TableCssClassName */].CONTROLS_BUTTON, onMouseDown: function () { return _this.props.selectRow(startIndex); }, onMouseOver: function () { return _this.props.hoverRows([startIndex]); }, onMouseOut: _this.clearHoverSelection }, !Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["isCellSelection"])(selection) && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_7__types__["a" /* TableCssClassName */].CONTROLS_BUTTON_OVERLAY, "data-index": startIndex }),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_7__types__["a" /* TableCssClassName */].CONTROLS_BUTTON_OVERLAY, "data-index": endIndex })))),
                        Object(__WEBPACK_IMPORTED_MODULE_6__utils__["A" /* isRowInsertButtonVisible */])(endIndex, selection) && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__InsertButton__["a" /* default */], { type: "row", tableRef: tableRef, index: endIndex, showInsertButton: !isResizing && insertRowButtonIndex === endIndex, onMouseDown: function () { return _this.insertRow(endIndex); } }))));
                }),
                Object(__WEBPACK_IMPORTED_MODULE_6__utils__["z" /* isRowDeleteButtonVisible */])(selection) && deleteBtnParams && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__DeleteButton__["a" /* default */], { key: "delete", removeLabel: __WEBPACK_IMPORTED_MODULE_8__messages__["a" /* default */].removeRows, style: { top: deleteBtnParams.top }, onClick: this.deleteSelectedRows, onMouseEnter: function () {
                        return _this.props.hoverRows(deleteBtnParams.indexes, true);
                    }, onMouseLeave: this.clearHoverSelection })))));
    };
    return RowControls;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (RowControls);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(44);






var NumberColumn = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](NumberColumn, _super);
    function NumberColumn() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hoverRows = function (index) {
            return _this.props.tableActive ? _this.props.hoverRows([index]) : null;
        };
        _this.selectRow = function (index) {
            return _this.props.tableActive ? _this.props.selectRow(index) : null;
        };
        _this.clearHoverSelection = function () {
            var _a = _this.props, tableActive = _a.tableActive, editorView = _a.editorView;
            if (tableActive) {
                var state = editorView.state, dispatch = editorView.dispatch;
                Object(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* clearHoverSelection */])(state, dispatch);
            }
        };
        _this.getClassNames = function (index) {
            var _a = _this.props, hoveredRows = _a.hoveredRows, editorView = _a.editorView, isInDanger = _a.isInDanger, isResizing = _a.isResizing;
            var isActive = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["isRowSelected"])(index)(editorView.state.selection) ||
                ((hoveredRows || []).indexOf(index) !== -1 && !isResizing);
            return [
                __WEBPACK_IMPORTED_MODULE_4__types__["a" /* TableCssClassName */].NUMBERED_COLUMN_BUTTON,
                isActive ? 'active' : '',
                isActive && isInDanger ? 'danger' : '',
            ].join(' ');
        };
        return _this;
    }
    NumberColumn.prototype.render = function () {
        var _this = this;
        var _a = this.props, tableRef = _a.tableRef, hasHeaderRow = _a.hasHeaderRow;
        var tbody = tableRef.querySelector('tbody');
        if (!tbody) {
            return null;
        }
        var rows = tbody.querySelectorAll('tr');
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_4__types__["a" /* TableCssClassName */].NUMBERED_COLUMN }, Array.from(Array(rows.length).keys()).map(function (index) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: "wrapper-" + index, className: _this.getClassNames(index), style: {
                height: rows[index].offsetHeight + 1,
            }, onClick: function () { return _this.selectRow(index); }, onMouseOver: function () { return _this.hoverRows(index); }, onMouseOut: _this.clearHoverSelection }, hasHeaderRow ? (index > 0 ? index : null) : index + 1)); })));
    };
    return NumberColumn;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (NumberColumn);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InsertButton__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DeleteButton__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__messages__ = __webpack_require__(214);











var ColumnControls = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ColumnControls, _super);
    function ColumnControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.deleteColumns = function (event) {
            event.preventDefault();
            var _a = _this.props.editorView, state = _a.state, dispatch = _a.dispatch;
            Object(__WEBPACK_IMPORTED_MODULE_7__actions__["e" /* deleteSelectedColumns */])(state, dispatch);
            _this.clearHoverSelection();
        };
        _this.selectColumn = function (column) {
            var editorView = _this.props.editorView;
            var state = editorView.state, dispatch = editorView.dispatch;
            // fix for issue ED-4665
            if (__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["E" /* browser */].ie_version === 11) {
                editorView.dom.blur();
            }
            Object(__WEBPACK_IMPORTED_MODULE_7__actions__["s" /* selectColumn */])(column)(state, dispatch);
        };
        _this.hoverColumns = function (columns, danger) {
            var _a = _this.props.editorView, state = _a.state, dispatch = _a.dispatch;
            Object(__WEBPACK_IMPORTED_MODULE_7__actions__["m" /* hoverColumns */])(columns, danger)(state, dispatch);
        };
        _this.clearHoverSelection = function () {
            var _a = _this.props.editorView, state = _a.state, dispatch = _a.dispatch;
            Object(__WEBPACK_IMPORTED_MODULE_7__actions__["a" /* clearHoverSelection */])(state, dispatch);
        };
        _this.insertColumn = function (column) {
            var _a = _this.props.editorView, state = _a.state, dispatch = _a.dispatch;
            Object(__WEBPACK_IMPORTED_MODULE_7__actions__["p" /* insertColumn */])(column)(state, dispatch);
        };
        return _this;
    }
    ColumnControls.prototype.shouldComponentUpdate = function (nextProps) {
        var _a = this.props, tableRef = _a.tableRef, selection = _a.selection, numberOfColumns = _a.numberOfColumns, hoveredColumns = _a.hoveredColumns, insertColumnButtonIndex = _a.insertColumnButtonIndex, isInDanger = _a.isInDanger, isResizing = _a.isResizing;
        if (nextProps.tableRef) {
            var controls = nextProps.tableRef.parentNode.firstChild;
            // checks if controls width is different from table width
            // 1px difference is acceptable and occurs in some situations due to the browser rendering specifics
            var shouldUpdate = Math.abs(controls.offsetWidth - nextProps.tableRef.offsetWidth) > 1;
            if (shouldUpdate) {
                return true;
            }
        }
        return (tableRef !== nextProps.tableRef ||
            insertColumnButtonIndex !== nextProps.insertColumnButtonIndex ||
            isInDanger !== nextProps.isInDanger ||
            isResizing !== nextProps.isResizing ||
            numberOfColumns !== nextProps.numberOfColumns ||
            hoveredColumns !== nextProps.hoveredColumns ||
            Object(__WEBPACK_IMPORTED_MODULE_6__utils__["B" /* isSelectionUpdated */])(selection, nextProps.selection));
    };
    ColumnControls.prototype.render = function () {
        var _this = this;
        var _a = this.props, editorView = _a.editorView, tableRef = _a.tableRef, insertColumnButtonIndex = _a.insertColumnButtonIndex, hoveredColumns = _a.hoveredColumns, isInDanger = _a.isInDanger, isResizing = _a.isResizing;
        if (!tableRef || !tableRef.querySelector('tr')) {
            return null;
        }
        var selection = editorView.state.selection;
        var columnsWidths = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["l" /* getColumnsWidths */])(editorView);
        var columnsParams = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["k" /* getColumnsParams */])(columnsWidths);
        var deleteBtnParams = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["j" /* getColumnDeleteButtonParams */])(columnsWidths, selection);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_8__types__["a" /* TableCssClassName */].COLUMN_CONTROLS },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_8__types__["a" /* TableCssClassName */].COLUMN_CONTROLS_INNER },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                    columnsParams.map(function (_a) {
                        var startIndex = _a.startIndex, endIndex = _a.endIndex, width = _a.width;
                        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_8__types__["a" /* TableCssClassName */].COLUMN_CONTROLS_BUTTON_WRAP + " " + Object(__WEBPACK_IMPORTED_MODULE_6__utils__["i" /* getColumnClassNames */])(startIndex, selection, hoveredColumns, isInDanger, isResizing), key: startIndex, style: { width: width }, onMouseDown: function (e) { return e.preventDefault(); } },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", { type: "button", className: __WEBPACK_IMPORTED_MODULE_8__types__["a" /* TableCssClassName */].CONTROLS_BUTTON, onMouseDown: function () { return _this.selectColumn(startIndex); }, onMouseOver: function () { return _this.hoverColumns([startIndex]); }, onMouseOut: _this.clearHoverSelection }, !Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["isCellSelection"])(selection) && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_8__types__["a" /* TableCssClassName */].CONTROLS_BUTTON_OVERLAY, "data-index": startIndex }),
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_8__types__["a" /* TableCssClassName */].CONTROLS_BUTTON_OVERLAY, "data-index": endIndex })))),
                            Object(__WEBPACK_IMPORTED_MODULE_6__utils__["t" /* isColumnInsertButtonVisible */])(endIndex, selection) && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__InsertButton__["a" /* default */], { type: "column", tableRef: tableRef, index: endIndex, showInsertButton: !isResizing && insertColumnButtonIndex === endIndex, onMouseDown: function () { return _this.insertColumn(endIndex); } }))));
                    }),
                    Object(__WEBPACK_IMPORTED_MODULE_6__utils__["s" /* isColumnDeleteButtonVisible */])(selection) && deleteBtnParams && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__DeleteButton__["a" /* default */], { key: "delete", removeLabel: __WEBPACK_IMPORTED_MODULE_9__messages__["a" /* default */].removeColumns, style: { left: deleteBtnParams.left }, onClick: this.deleteColumns, onMouseEnter: function () {
                            return _this.hoverColumns(deleteBtnParams.indexes, true);
                        }, onMouseLeave: this.clearHoverSelection }))))));
    };
    return ColumnControls;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ColumnControls);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluginKey; });
/* harmony export (immutable) */ __webpack_exports__["a"] = createPlugin;
/* unused harmony export ResizeState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_view__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__resizer_resizer__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__resizer_contentWidth__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__editor_disabled__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__width__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(21);













var pluginKey = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["PluginKey"]('tableFlexiColumnResizing');
function createPlugin(dispatch, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.handleWidth, handleWidth = _c === void 0 ? 5 : _c, _d = _b.cellMinWidth, cellMinWidth = _d === void 0 ? 25 : _d, _e = _b.lastColumnResizable, lastColumnResizable = _e === void 0 ? true : _e;
    return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
        key: pluginKey,
        state: {
            init: function () { return new ResizeState(-1, null); },
            apply: function (tr, pluginState, prevState, state) {
                var newPluginState = pluginState.apply(tr, state);
                if ((newPluginState &&
                    pluginState.activeHandle !== newPluginState.activeHandle) ||
                    pluginState.dragging !== newPluginState.dragging) {
                    dispatch(pluginKey, newPluginState);
                    return newPluginState;
                }
                return pluginState;
            },
        },
        view: function () { return ({
            update: function (view) {
                var _a = view.state, selection = _a.selection, schema = _a.schema;
                var table = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findParentNodeOfType"])(schema.nodes.table)(selection);
                var isInsideCells = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["hasParentNodeOfType"])([
                    schema.nodes.tableCell,
                    schema.nodes.tableHeader,
                ])(selection);
                if (table && isInsideCells) {
                    var cell = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findParentNodeOfType"])([
                        schema.nodes.tableCell,
                        schema.nodes.tableHeader,
                    ])(selection);
                    var elem = view.domAtPos(cell.start).node; // nodeview
                    var elemOrWrapper = Object(__WEBPACK_IMPORTED_MODULE_12__utils__["i" /* closestElement */])(elem, "." + __WEBPACK_IMPORTED_MODULE_9__types__["a" /* TableCssClassName */].TABLE_HEADER_NODE_WRAPPER + ", ." + __WEBPACK_IMPORTED_MODULE_9__types__["a" /* TableCssClassName */].TABLE_CELL_NODE_WRAPPER) || elem;
                    var minWidth = Object(__WEBPACK_IMPORTED_MODULE_7__resizer_contentWidth__["a" /* contentWidth */])(elem, elem).minWidth;
                    // if the contents of the element are wider than the cell
                    // we resize the cell to the new min cell width.
                    // which should cater to the nowrap element and wrap others.
                    if (elemOrWrapper && elemOrWrapper.offsetWidth < minWidth) {
                        Object(__WEBPACK_IMPORTED_MODULE_5__actions__["a" /* handleBreakoutContent */])(view, elemOrWrapper, table.pos + 1, minWidth, table.node);
                    }
                }
            },
        }); },
        props: {
            attributes: function (state) {
                var _a;
                var pluginState = pluginKey.getState(state);
                return {
                    class: __WEBPACK_IMPORTED_MODULE_4_classnames__(__WEBPACK_IMPORTED_MODULE_9__types__["a" /* TableCssClassName */].RESIZING_PLUGIN, (_a = {},
                        _a[__WEBPACK_IMPORTED_MODULE_9__types__["a" /* TableCssClassName */].RESIZE_CURSOR] = pluginState.activeHandle > -1,
                        _a[__WEBPACK_IMPORTED_MODULE_9__types__["a" /* TableCssClassName */].IS_RESIZING] = !!pluginState.dragging,
                        _a)),
                };
            },
            handleDOMEvents: {
                mousemove: function (view, event) {
                    handleMouseMove(view, event, handleWidth, lastColumnResizable);
                    var dragging = pluginKey.getState(view.state).dragging;
                    if (dragging) {
                        Object(__WEBPACK_IMPORTED_MODULE_5__actions__["f" /* updateControls */])(view.state);
                    }
                    return false;
                },
                mouseleave: function (view) {
                    handleMouseLeave(view);
                    Object(__WEBPACK_IMPORTED_MODULE_5__actions__["f" /* updateControls */])(view.state);
                    return true;
                },
                mousedown: function (view, event) {
                    return handleMouseDown(view, event, cellMinWidth);
                },
            },
            decorations: function (state) {
                var activeHandle = pluginKey.getState(state).activeHandle;
                if (typeof activeHandle === 'number' && activeHandle > -1) {
                    return handleDecorations(state, activeHandle);
                }
            },
            nodeViews: {},
        },
    });
}
var ResizeState = /** @class */ (function () {
    function ResizeState(activeHandle, dragging) {
        this.activeHandle = activeHandle;
        this.dragging = dragging;
        return Object.freeze(this);
    }
    ResizeState.prototype.apply = function (tr, state) {
        var action = tr.getMeta(pluginKey);
        var editorDisabled = __WEBPACK_IMPORTED_MODULE_10__editor_disabled__["b" /* pluginKey */].getState(state).editorDisabled;
        // Disable table resizing if the editor is disabled
        if (editorDisabled) {
            return new ResizeState(-1, null);
        }
        if (action && action.setHandle !== undefined) {
            return new ResizeState(action.setHandle, null);
        }
        if (action && action.setDragging !== undefined) {
            return new ResizeState(this.activeHandle, action.setDragging);
        }
        if (this.activeHandle > -1 && tr.docChanged) {
            var handle = tr.mapping.map(this.activeHandle, -1);
            if (!Object(__WEBPACK_IMPORTED_MODULE_8__utils__["e" /* pointsAtCell */])(tr.doc.resolve(handle))) {
                handle = -1;
            }
            return new ResizeState(handle, this.dragging);
        }
        return this;
    };
    return ResizeState;
}());

function handleMouseMove(view, event, handleWidth, lastColumnResizable) {
    var pluginState = pluginKey.getState(view.state);
    if (!pluginState.dragging) {
        var target = Object(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* domCellAround */])(event.target);
        var cell = -1;
        if (target) {
            var _a = target.getBoundingClientRect(), left = _a.left, right = _a.right;
            if (event.clientX - left <= handleWidth) {
                cell = Object(__WEBPACK_IMPORTED_MODULE_8__utils__["c" /* edgeCell */])(view, event, 'left');
            }
            else if (right - event.clientX <= handleWidth) {
                cell = Object(__WEBPACK_IMPORTED_MODULE_8__utils__["c" /* edgeCell */])(view, event, 'right');
            }
        }
        if (typeof cell === 'number' && cell !== pluginState.activeHandle) {
            if (!lastColumnResizable && cell !== -1) {
                var $cell = view.state.doc.resolve(cell);
                var table = $cell.node(-1);
                var map = __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["TableMap"].get(table);
                var start = $cell.start(-1);
                var col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
                if (col === map.width - 1) {
                    return;
                }
            }
            view.dispatch(view.state.tr.setMeta(pluginKey, { setHandle: cell }));
        }
    }
}
function handleMouseLeave(view) {
    var pluginState = pluginKey.getState(view.state);
    if (pluginState.activeHandle > -1 && !pluginState.dragging) {
        view.dispatch(view.state.tr.setMeta(pluginKey, { setHandle: -1 }));
    }
}
function handleMouseDown(view, event, cellMinWidth) {
    var state = view.state;
    var _a = pluginKey.getState(state), activeHandle = _a.activeHandle, dragging = _a.dragging;
    if (activeHandle === -1 || dragging) {
        return false;
    }
    var cell = view.state.doc.nodeAt(activeHandle);
    var $cell = view.state.doc.resolve(activeHandle);
    var dom = view.domAtPos($cell.start(-1)).node;
    while (dom.nodeName !== 'TABLE') {
        dom = dom.parentNode;
    }
    var containerWidth = __WEBPACK_IMPORTED_MODULE_11__width__["b" /* pluginKey */].getState(view.state).width;
    var resizer = __WEBPACK_IMPORTED_MODULE_6__resizer_resizer__["a" /* default */].fromDOM(dom, {
        minWidth: cellMinWidth,
        maxSize: Object(__WEBPACK_IMPORTED_MODULE_8__utils__["d" /* getLayoutSize */])(dom.getAttribute('data-layout'), containerWidth),
        node: $cell.node(-1),
    });
    resizer.apply(resizer.currentState);
    var width = Object(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* currentColWidth */])(view, activeHandle, cell.attrs);
    view.dispatch(view.state.tr.setMeta(pluginKey, {
        setDragging: { startX: event.clientX, startWidth: width },
    }));
    function finish(event) {
        var clientX = event.clientX;
        window.removeEventListener('mouseup', finish);
        window.removeEventListener('mousemove', move);
        var _a = pluginKey.getState(view.state), activeHandle = _a.activeHandle, dragging = _a.dragging;
        if (dragging) {
            var startX = dragging.startX;
            Object(__WEBPACK_IMPORTED_MODULE_5__actions__["e" /* updateColumnWidth */])(view, activeHandle, clientX - startX, resizer);
            view.dispatch(view.state.tr.setMeta(pluginKey, { setDragging: null }));
        }
    }
    function move(event) {
        var clientX = event.clientX, which = event.which;
        if (!which) {
            return finish(event);
        }
        var _a = pluginKey.getState(view.state), activeHandle = _a.activeHandle, startX = _a.dragging.startX;
        Object(__WEBPACK_IMPORTED_MODULE_5__actions__["b" /* resizeColumn */])(view, activeHandle, clientX - startX, resizer);
    }
    window.addEventListener('mouseup', finish);
    window.addEventListener('mousemove', move);
    event.preventDefault();
    return true;
}
function handleDecorations(state, cell) {
    var decorations = [];
    var $cell = state.doc.resolve(cell);
    var table = $cell.node(-1);
    var map = __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["TableMap"].get(table);
    var start = $cell.start(-1);
    var col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan;
    for (var row = 0; row < map.height; row++) {
        var index = col + row * map.width - 1;
        // For positions that are have either a different cell or the end
        // of the table to their right, and either the top of the table or
        // a different cell above them, add a decoration
        if ((col === map.width || map.map[index] !== map.map[index + 1]) &&
            (row === 0 || map.map[index - 1] !== map.map[index - 1 - map.width])) {
            var cellPos = map.map[index];
            var pos = start + cellPos + table.nodeAt(cellPos).nodeSize - 1;
            var dom = document.createElement('div');
            dom.className = __WEBPACK_IMPORTED_MODULE_9__types__["a" /* TableCssClassName */].COLUMN_RESIZE_HANDLE;
            decorations.push(__WEBPACK_IMPORTED_MODULE_1_prosemirror_view__["Decoration"].widget(pos, dom));
        }
    }
    return __WEBPACK_IMPORTED_MODULE_1_prosemirror_view__["DecorationSet"].create(state.doc, decorations);
}
//# sourceMappingURL=plugin.js.map

/***/ }),
/* 2413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ColType */
/* unused harmony export amountFor */
/* unused harmony export widthFor */
/* unused harmony export moveSpaceFrom */
/* unused harmony export getCandidates */
/* unused harmony export stackSpace */
/* unused harmony export reduceSpace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(286);


var ColType;
(function (ColType) {
    ColType["SOURCE"] = "src";
    ColType["DEST"] = "dest";
})(ColType || (ColType = {}));
function amountFor(colType) {
    return function (amount) {
        return colType === ColType.SOURCE
            ? amount > 0
                ? -amount
                : amount
            : amount < 0
                ? -amount
                : amount;
    };
}
function widthFor(colType) {
    return function (amount, srcCol, destCol) {
        return (colType === ColType.SOURCE ? srcCol : destCol).width +
            amountFor(colType)(amount);
    };
}
// TODO: should handle when destIdx:
// - is beyond the range, and then not give it back
function moveSpaceFrom(state, srcIdx, destIdx, amount, useFreeSpace) {
    if (useFreeSpace === void 0) { useFreeSpace = true; }
    var srcCol = state.cols[srcIdx];
    var destCol = state.cols[destIdx];
    if (useFreeSpace) {
        // if taking more than source column's free space, only take that much
        if (amountFor(ColType.DEST)(amount) > srcCol.freeSpace) {
            amount = amount > 0 ? srcCol.freeSpace : -srcCol.freeSpace;
        }
    }
    // if the source column shrinks past its min size, don't give the space away
    if (amountFor(ColType.SOURCE)(amount) < 0 &&
        widthFor(ColType.SOURCE)(amount, srcCol, destCol) < srcCol.minWidth) {
        amount = srcCol.width - srcCol.minWidth;
    }
    var newDest = destCol
        ? destCol.clone(widthFor(ColType.DEST)(amount, srcCol, destCol))
        : undefined;
    if (!newDest && amountFor(ColType.SOURCE)(amount) < 0) {
        // non-zero-sum game, ensure that we're not removing more than the total table width either
        if (state.totalWidth -
            srcCol.width +
            widthFor(ColType.SOURCE)(amount, srcCol, destCol) <
            state.maxSize) {
            // would shrink table below max width, stop it
            amount =
                state.maxSize - (state.totalWidth - srcCol.width) - srcCol.width - 1;
        }
    }
    var newSrc = srcCol.clone(widthFor(ColType.SOURCE)(amount, srcCol, destCol));
    var newCols = state.cols
        .map(function (existingCol, idx) {
        return idx === srcIdx ? newSrc : idx === destIdx ? newDest : existingCol;
    })
        .filter(Boolean);
    return { state: new ResizeState(newCols, state.maxSize), amount: amount };
}
function getCandidates(state, destIdx, amount) {
    var candidates = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* makeColIdxPair */])(state.cols);
    // only consider rows after the selected column in the direction of resize
    return amount < 0
        ? candidates.slice(0, destIdx)
        : candidates.slice(destIdx + 1);
}
function stackSpace(state, destIdx, amount) {
    var candidates = getCandidates(state, destIdx, amount);
    while (candidates.length && amount) {
        // search for most (or least) free space in candidates
        var candidateIdx = state.freeColFunc(candidates, amount);
        if (candidateIdx === -1) {
            // no free space remains
            break;
        }
        var _a = candidates.splice(candidateIdx, 1)[0], srcCol = _a.col, srcIdx = _a.idx;
        if (srcCol.freeSpace <= 0) {
            // no more columns with free space remain
            break;
        }
        var res = moveSpaceFrom(state, srcIdx, destIdx, amount);
        state = res.state;
        amount -= res.amount;
    }
    return {
        state: state,
        remaining: amount,
    };
}
function reduceSpace(state, amount, ignoreCols) {
    if (ignoreCols === void 0) { ignoreCols = []; }
    var remaining = amount;
    var _loop_1 = function () {
        // filter candidates only with free space
        var candidates = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* makeColIdxPair */])(state.cols).filter(function (colIdxPair) {
            return (colIdxPair.col.freeSpace && ignoreCols.indexOf(colIdxPair.idx) === -1);
        });
        if (candidates.length === 0) {
            return "break";
        }
        var requestedResize = Math.ceil(remaining / candidates.length);
        if (requestedResize === 0) {
            return "break";
        }
        candidates.forEach(function (candidate) {
            var newWidth = candidate.col.width - requestedResize;
            var remainder = 0;
            if (newWidth < candidate.col.minWidth) {
                // If the new requested width is less than our min
                // Calc what width we didn't use, we'll try extract that
                // from other cols.
                remainder = candidate.col.minWidth - newWidth;
                newWidth = candidate.col.minWidth;
            }
            state = new ResizeState(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](state.cols.slice(0, candidate.idx), [
                candidate.col.clone(newWidth)
            ], state.cols.slice(candidate.idx + 1)), state.maxSize, state.breakout, state.freeColFunc);
            remaining -= requestedResize + remainder;
        });
    };
    // keep trying to resolve resize request until we run out of free space,
    // or nothing to resize
    while (remaining) {
        var state_1 = _loop_1();
        if (state_1 === "break")
            break;
    }
    return state;
}
var ResizeState = /** @class */ (function () {
    function ResizeState(cols, maxSize, breakout, freeColFunc) {
        if (breakout === void 0) { breakout = false; }
        if (freeColFunc === void 0) { freeColFunc = __WEBPACK_IMPORTED_MODULE_1__utils__["c" /* findNextFreeCol */]; }
        this.cols = cols;
        this.maxSize = maxSize;
        this.breakout = breakout;
        this.freeColFunc = freeColFunc;
        return Object.freeze(this);
    }
    Object.defineProperty(ResizeState.prototype, "totalWidth", {
        get: function () {
            return this.cols.reduce(function (totalWidth, col) { return totalWidth + col.width; }, 0) + 1;
        },
        enumerable: true,
        configurable: true
    });
    ResizeState.prototype.grow = function (colIdx, amount) {
        // if last column
        if (!this.cols[colIdx + 1]) {
            return new ResizeState(this.cols, this.maxSize, true);
        }
        var newState = this.clone();
        if (amount && this.cols[colIdx + 1]) {
            // if we couldn't naturally resize and we're growing this one,
            // directly shrink the adjacent one with the remaining width
            var res = moveSpaceFrom(this, colIdx + 1, colIdx, amount, false);
            newState = res.state;
            amount -= res.amount;
        }
        if (amount) {
            // if we still have remaining space, directly resize the column
            var oldCol = newState.cols[colIdx];
            if (amount < 0 && oldCol.width + amount < oldCol.minWidth) {
                amount = -(oldCol.width - oldCol.minWidth);
            }
            return new ResizeState(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](newState.cols.slice(0, colIdx), [
                oldCol.clone(oldCol.width + amount)
            ], newState.cols.slice(colIdx + 1)), newState.maxSize, newState.breakout);
        }
        return newState;
    };
    ResizeState.prototype.shrink = function (colIdx, amount) {
        var canRedistribute = this.cols[colIdx + 1] || this.totalWidth > this.maxSize;
        if (!canRedistribute) {
            return this.clone();
        }
        // try to shrink this one by giving from the column to the right first
        var res = moveSpaceFrom(this, colIdx, colIdx + 1, -amount);
        var remaining = amount + res.amount;
        var newState = res.state;
        if (remaining < 0) {
            var res_1 = stackSpace(newState, colIdx, remaining);
            remaining += res_1.remaining;
            newState = res_1.state;
        }
        canRedistribute =
            newState.cols[colIdx + 1] || newState.totalWidth > newState.maxSize;
        if (remaining && canRedistribute) {
            // direct resize
            var oldCol = newState.cols[colIdx];
            var oldNextCol = newState.cols[colIdx + 1];
            if (oldCol.width + remaining < oldCol.minWidth) {
                remaining = -(oldCol.width - oldCol.minWidth);
            }
            if (!oldNextCol) {
                var newSum = newState.totalWidth + remaining;
                if (newSum < newState.maxSize) {
                    remaining = newState.maxSize - newState.totalWidth - 1;
                }
            }
            var newCol = oldCol.clone(oldCol.width + remaining);
            if (oldNextCol) {
                var nextCol = oldNextCol.clone(oldNextCol.width - remaining);
                return new ResizeState(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](newState.cols.slice(0, colIdx), [
                    newCol,
                    nextCol
                ], newState.cols.slice(colIdx + 2)), newState.maxSize);
            }
            return new ResizeState(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](newState.cols.slice(0, colIdx), [
                newCol
            ], newState.cols.slice(colIdx + 1)), newState.maxSize);
        }
        return newState;
    };
    ResizeState.prototype.resize = function (colIdx, amount) {
        if (amount > 0) {
            return this.grow(colIdx, amount);
        }
        else if (amount < 0) {
            return this.shrink(colIdx, amount);
        }
        return this.clone();
    };
    ResizeState.prototype.scale = function (newWidth) {
        var scaleFactor = newWidth / this.maxSize;
        var newState = new ResizeState(this.cols.map(function (col) {
            var minWidth = col.minWidth, width = col.width;
            var newColWidth = Math.floor(width * scaleFactor);
            // enforce min width
            if (newColWidth < minWidth) {
                newColWidth = minWidth;
            }
            return col.clone(newColWidth);
        }), newWidth);
        if (newState.totalWidth > newWidth) {
            newState = reduceSpace(newState, newState.totalWidth - newWidth);
        }
        return newState;
    };
    ResizeState.prototype.scaleColToMinWidth = function (colIdx) {
        if (this.cols[colIdx]) {
            var _a = this.cols[colIdx], minWidth = _a.minWidth, width = _a.width;
            return this.resize(colIdx, minWidth - width);
        }
        return this.clone();
    };
    ResizeState.prototype.clone = function () {
        return new ResizeState(this.cols.map(function (col) { return col.clone(); }), this.maxSize, this.breakout, this.freeColFunc);
    };
    return ResizeState;
}());
/* harmony default export */ __webpack_exports__["a"] = (ResizeState);
//# sourceMappingURL=resizeState.js.map

/***/ }),
/* 2414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contentWidth__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(286);


var ColumnState = /** @class */ (function () {
    function ColumnState(width, wrapWidth, minWidth) {
        if (minWidth === void 0) { minWidth = 0; }
        this.width = width;
        this.wrapWidth = wrapWidth;
        this.minWidth = minWidth;
        return Object.freeze(this);
    }
    Object.defineProperty(ColumnState.prototype, "freeSpace", {
        get: function () {
            var _a = this, minWidth = _a.minWidth, width = _a.width, wrapWidth = _a.wrapWidth;
            return Math.max(width - Math.max(wrapWidth, minWidth), 0);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Creates a new ResizeState based on the current
     * appearance of an element.
     * @param {HTMLElement} table Reference to the <table> node
     * @param {number} colIdx The column index
     * @param {number} minWidth Minimum width a column is permitted to be
     */
    ColumnState.fromDOM = function (table, colIdx, minWidth) {
        var minColWidth = minWidth;
        var width = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* calculateColWidth */])(table, colIdx);
        var wrapWidth = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* calculateColWidth */])(table, colIdx, function (col, computedStyle) {
            var borderWidth = computedStyle
                .borderWidth.split(' ')
                .reduce(function (acc, current) { return (acc += Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* unitToNumber */])(current)); }, 0);
            var _a = Object(__WEBPACK_IMPORTED_MODULE_0__contentWidth__["a" /* contentWidth */])(col, col), width = _a.width, minWidth = _a.minWidth;
            // Override the min width, if their is content that can't collapse
            // Past a certain width.
            minColWidth = Math.max(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* addContainerLeftRightPadding */])(minWidth, computedStyle), minColWidth);
            return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* addContainerLeftRightPadding */])(width + borderWidth, computedStyle);
        });
        return new ColumnState(width, wrapWidth, minColWidth);
    };
    ColumnState.prototype.clone = function (newWidth) {
        var _a = this, minWidth = _a.minWidth, width = _a.width, wrapWidth = _a.wrapWidth;
        return new ColumnState(newWidth ? newWidth : width, wrapWidth, minWidth);
    };
    return ColumnState;
}());
/* harmony default export */ __webpack_exports__["a"] = (ColumnState);
//# sourceMappingURL=columnState.js.map

/***/ }),
/* 2415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_expand__ = __webpack_require__(2416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_expand___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_expand__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_collapse__ = __webpack_require__(2417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__messages__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_ToolbarButton__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles__ = __webpack_require__(99);













var POPUP_OFFSET = [
    -__WEBPACK_IMPORTED_MODULE_12__styles__["c" /* layoutButtonSize */] - 5,
    -__WEBPACK_IMPORTED_MODULE_12__styles__["c" /* layoutButtonSize */] - __WEBPACK_IMPORTED_MODULE_5__atlaskit_editor_common__["_1" /* tableMarginTop */] + 2,
];
var getTitle = function (layout) {
    switch (layout) {
        case 'default':
            return __WEBPACK_IMPORTED_MODULE_8__messages__["a" /* default */].layoutWide;
        case 'wide':
            return __WEBPACK_IMPORTED_MODULE_8__messages__["a" /* default */].layoutFullWidth;
        default:
            return __WEBPACK_IMPORTED_MODULE_8__messages__["a" /* default */].layoutFixedWidth;
    }
};
var LayoutButton = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](LayoutButton, _super);
    function LayoutButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function () {
            var _a = _this.props.editorView, state = _a.state, dispatch = _a.dispatch;
            Object(__WEBPACK_IMPORTED_MODULE_11__actions__["D" /* toggleTableLayout */])(state, dispatch);
        };
        return _this;
    }
    LayoutButton.prototype.render = function () {
        var _a;
        var _b = this.props, formatMessage = _b.intl.formatMessage, mountPoint = _b.mountPoint, boundariesElement = _b.boundariesElement, scrollableElement = _b.scrollableElement, targetRef = _b.targetRef, editorView = _b.editorView, isResizing = _b.isResizing;
        if (!targetRef) {
            return null;
        }
        var table = Object(__WEBPACK_IMPORTED_MODULE_4_prosemirror_utils__["findTable"])(editorView.state.selection);
        if (!table) {
            return false;
        }
        var layout = table.node.attrs.layout;
        var title = formatMessage(getTitle(layout));
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__atlaskit_editor_common__["e" /* Popup */], { ariaLabel: title, offset: POPUP_OFFSET, target: targetRef, alignY: "top", alignX: "right", stick: true, mountTo: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_3_classnames__(__WEBPACK_IMPORTED_MODULE_10__types__["a" /* TableCssClassName */].LAYOUT_BUTTON, (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_10__types__["a" /* TableCssClassName */].IS_RESIZING] = isResizing,
                    _a)) },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ui_ToolbarButton__["a" /* default */], { title: title, onClick: this.handleClick, iconBefore: layout === 'full-width' ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_collapse___default.a, { label: title })) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_expand___default.a, { label: title })) }))));
    };
    return LayoutButton;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["injectIntl"])(LayoutButton));
//# sourceMappingURL=index.js.map

/***/ }),
/* 2416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorExpandIcon = function EditorExpandIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M18.062 11L16.5 9.914A1 1 0 1 1 17.914 8.5l2.616 2.616c.28.167.47.5.47.884s-.19.717-.47.884L17.914 15.5a1 1 0 0 1-1.414-1.414L18.062 13h-3.68c-.487 0-.882-.448-.882-1s.395-1 .882-1h3.68zM3.47 12.884c-.28-.167-.47-.5-.47-.884s.19-.717.47-.884L6.086 8.5A1 1 0 0 1 7.5 9.914L5.938 11h3.68c.487 0 .882.448.882 1s-.395 1-.882 1h-3.68L7.5 14.086A1 1 0 0 1 6.086 15.5L3.47 12.884z\" fill=\"currentColor\"/></svg>"
  }, props));
};

EditorExpandIcon.displayName = 'EditorExpandIcon';
var _default = EditorExpandIcon;
exports.default = _default;

/***/ }),
/* 2417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorCollapseIcon = function EditorCollapseIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M8.062 11L6.5 9.914A1 1 0 0 1 7.914 8.5l2.616 2.616c.28.167.47.5.47.884s-.19.717-.47.884L7.914 15.5A1 1 0 1 1 6.5 14.086L8.062 13h-3.68c-.487 0-.882-.448-.882-1s.395-1 .882-1h3.68zm5.408 1.884c-.28-.167-.47-.5-.47-.884s.19-.717.47-.884L16.086 8.5A1 1 0 0 1 17.5 9.914L15.938 11h3.68c.487 0 .882.448.882 1s-.395 1-.882 1h-3.68l1.562 1.086a1 1 0 0 1-1.414 1.414l-2.616-2.616z\" fill=\"currentColor\"/></svg>"
  }, props));
};

EditorCollapseIcon.displayName = 'EditorCollapseIcon';
var _default = EditorCollapseIcon;
exports.default = _default;

/***/ }),
/* 2418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keymapPlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keymaps__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__analytics__ = __webpack_require__(20);







function keymapPlugin() {
    var list = {};
    __WEBPACK_IMPORTED_MODULE_5__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_5__keymaps__["y" /* nextCell */].common, Object(__WEBPACK_IMPORTED_MODULE_4__actions__["i" /* goToNextCell */])(1), list);
    __WEBPACK_IMPORTED_MODULE_5__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_5__keymaps__["D" /* previousCell */].common, Object(__WEBPACK_IMPORTED_MODULE_4__actions__["i" /* goToNextCell */])(-1), list);
    __WEBPACK_IMPORTED_MODULE_5__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_5__keymaps__["Q" /* toggleTable */].common, __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* createTable */], list);
    __WEBPACK_IMPORTED_MODULE_5__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_5__keymaps__["g" /* backspace */].common, function (state, dispatch) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["isCellSelection"])(state.selection)) {
            return false;
        }
        var tr = state.tr;
        var selection = tr.selection;
        selection.forEachCell(function (node, pos) {
            var $pos = tr.doc.resolve(tr.mapping.map(pos + 1));
            tr = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["emptyCell"])(Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findCellClosestToPos"])($pos), state.schema)(tr);
        });
        if (tr.docChanged) {
            var $pos = tr.doc.resolve(tr.mapping.map(selection.$headCell.pos));
            var textSelection = __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Selection"].findFrom($pos, 1, true);
            if (textSelection) {
                tr.setSelection(textSelection);
            }
            if (dispatch) {
                dispatch(tr);
            }
            __WEBPACK_IMPORTED_MODULE_6__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.format.table.delete_content.keyboard');
            return true;
        }
        return false;
    }, list);
    __WEBPACK_IMPORTED_MODULE_5__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_5__keymaps__["g" /* backspace */].common, __WEBPACK_IMPORTED_MODULE_4__actions__["r" /* moveCursorBackward */], list);
    // Add row/column shortcuts
    __WEBPACK_IMPORTED_MODULE_5__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_5__keymaps__["f" /* addRowBefore */].common, Object(__WEBPACK_IMPORTED_MODULE_4__actions__["F" /* triggerUnlessTableHeader */])(__WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["addRowBefore"]), list);
    __WEBPACK_IMPORTED_MODULE_5__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_5__keymaps__["e" /* addRowAfter */].common, __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["addRowAfter"], list);
    __WEBPACK_IMPORTED_MODULE_5__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_5__keymaps__["c" /* addColumnBefore */].common, Object(__WEBPACK_IMPORTED_MODULE_4__actions__["F" /* triggerUnlessTableHeader */])(__WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["addColumnBefore"]), list);
    __WEBPACK_IMPORTED_MODULE_5__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_5__keymaps__["b" /* addColumnAfter */].common, __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["addColumnAfter"], list);
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__["keymap"])(list);
}
/* unused harmony default export */ var _unused_webpack_default_export = (keymapPlugin);
//# sourceMappingURL=keymap.js.map

/***/ }),
/* 2419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export messages */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getToolbarConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_remove__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_remove__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_settings__ = __webpack_require__(2420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__messages__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pm_plugins_main__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pm_plugins_table_resizing_index__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(68);









var messages = Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["defineMessages"])({
    tableOptions: {
        id: 'fabric.editor.tableOptions',
        defaultMessage: 'Table options',
        description: 'Opens a menu with additional table options',
    },
    headerRow: {
        id: 'fabric.editor.headerRow',
        defaultMessage: 'Header row',
        description: 'Marks the first table row as a header row',
    },
    headerColumn: {
        id: 'fabric.editor.headerColumn',
        defaultMessage: 'Header column',
        description: 'Marks the first table column as a header row',
    },
    numberedColumn: {
        id: 'fabric.editor.numberedColumn',
        defaultMessage: 'Numbered column',
        description: 'Adds an auto-numbering column to your table',
    },
});
var withAnalytics = function (command, eventName, properties) { return function (state, dispatch) {
    __WEBPACK_IMPORTED_MODULE_4__analytics__["a" /* analyticsService */].trackEvent(eventName, properties);
    return command(state, dispatch);
}; };
var getToolbarConfig = function (state, _a) {
    var formatMessage = _a.formatMessage;
    var tableState = __WEBPACK_IMPORTED_MODULE_5__pm_plugins_main__["e" /* pluginKey */].getState(state);
    var resizeState = __WEBPACK_IMPORTED_MODULE_6__pm_plugins_table_resizing_index__["b" /* pluginKey */].getState(state);
    if (tableState &&
        tableState.tableRef &&
        tableState.tableNode &&
        tableState.pluginConfig) {
        var pluginConfig = tableState.pluginConfig;
        return {
            title: 'Table floating controls',
            getDomRef: function () { return tableState.tableFloatingToolbarTarget; },
            nodeType: state.schema.nodes.table,
            items: [
                {
                    type: 'dropdown',
                    title: formatMessage(messages.tableOptions),
                    icon: __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_settings___default.a,
                    hidden: !(pluginConfig.allowHeaderRow && pluginConfig.allowHeaderColumn),
                    options: [
                        {
                            title: formatMessage(messages.headerRow),
                            onClick: withAnalytics(__WEBPACK_IMPORTED_MODULE_7__actions__["B" /* toggleHeaderRow */], 'atlassian.editor.format.table.toggleHeaderRow.button'),
                            selected: Object(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* checkIfHeaderRowEnabled */])(state),
                            hidden: !pluginConfig.allowHeaderRow,
                        },
                        {
                            title: formatMessage(messages.headerColumn),
                            onClick: withAnalytics(__WEBPACK_IMPORTED_MODULE_7__actions__["A" /* toggleHeaderColumn */], 'atlassian.editor.format.table.toggleHeaderColumn.button'),
                            selected: Object(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* checkIfHeaderColumnEnabled */])(state),
                            hidden: !pluginConfig.allowHeaderColumn,
                        },
                        {
                            title: formatMessage(messages.numberedColumn),
                            selected: Object(__WEBPACK_IMPORTED_MODULE_8__utils__["c" /* checkIfNumberColumnEnabled */])(state),
                            onClick: withAnalytics(__WEBPACK_IMPORTED_MODULE_7__actions__["C" /* toggleNumberColumn */], 'atlassian.editor.format.table.toggleNumberColumn.button'),
                            hidden: !pluginConfig.allowNumberColumn,
                        },
                    ],
                },
                {
                    type: 'separator',
                    hidden: !(pluginConfig.allowBackgroundColor &&
                        pluginConfig.allowHeaderRow &&
                        pluginConfig.allowHeaderColumn &&
                        pluginConfig.allowMergeCells),
                },
                {
                    type: 'button',
                    appearance: 'danger',
                    icon: __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_remove___default.a,
                    onClick: __WEBPACK_IMPORTED_MODULE_7__actions__["g" /* deleteTable */],
                    disabled: !!resizeState && !!resizeState.dragging,
                    onMouseEnter: Object(__WEBPACK_IMPORTED_MODULE_7__actions__["o" /* hoverTable */])(true),
                    onMouseLeave: __WEBPACK_IMPORTED_MODULE_7__actions__["a" /* clearHoverSelection */],
                    title: formatMessage(__WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */].remove),
                },
            ],
        };
    }
};
//# sourceMappingURL=toolbar.js.map

/***/ }),
/* 2420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorSettingsIcon = function EditorSettingsIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M12.002 15.504a3.502 3.502 0 1 1 0-7.004 3.502 3.502 0 0 1 0 7.004m6.732-1.987a1.605 1.605 0 0 1-.001-3.034.386.386 0 0 0 .253-.462 7.2 7.2 0 0 0-.672-1.604.384.384 0 0 0-.481-.156c-.31.127-.668.16-1.039.065a1.6 1.6 0 0 1-1.129-1.124 1.641 1.641 0 0 1 .061-1.043.385.385 0 0 0-.157-.48 7.225 7.225 0 0 0-1.59-.665.385.385 0 0 0-.461.252 1.604 1.604 0 0 1-3.032 0 .387.387 0 0 0-.463-.252c-.57.16-1.11.39-1.613.677a.378.378 0 0 0-.159.468 1.611 1.611 0 0 1-2.088 2.108.385.385 0 0 0-.479.158 7.2 7.2 0 0 0-.67 1.604.386.386 0 0 0 .248.46 1.605 1.605 0 0 1 0 3.021.385.385 0 0 0-.249.46c.143.504.34.986.582 1.44.096.179.318.24.502.156.479-.22 1.08-.213 1.693.191a.881.881 0 0 1 .243.242c.424.643.412 1.272.16 1.76a.381.381 0 0 0 .134.506 7.197 7.197 0 0 0 1.697.721.381.381 0 0 0 .459-.251A1.605 1.605 0 0 1 12 17.645c.707 0 1.302.457 1.518 1.09.066.19.265.306.459.251a7.212 7.212 0 0 0 1.677-.71.38.38 0 0 0 .134-.508c-.256-.49-.271-1.12.154-1.766a.884.884 0 0 1 .243-.243c.62-.411 1.228-.413 1.71-.185a.384.384 0 0 0 .505-.153c.244-.454.441-.937.585-1.443a.385.385 0 0 0-.252-.461\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorSettingsIcon.displayName = 'EditorSettingsIcon';
var _default = EditorSettingsIcon;
exports.default = _default;

/***/ }),
/* 2421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextualMenu__ = __webpack_require__(2422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pm_plugins_main__ = __webpack_require__(83);









var MenuWrapper = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", "\n"], ["\n  ", "\n"])), __WEBPACK_IMPORTED_MODULE_6__styles__["h" /* tablePopupStyles */]);
// offset of the contextual menu dropdown
var calculateOffset = function (targetCellRef, state) {
    var tableRef = __WEBPACK_IMPORTED_MODULE_7__pm_plugins_main__["e" /* pluginKey */].getState(state).tableRef;
    var top = -__WEBPACK_IMPORTED_MODULE_6__styles__["b" /* contextualMenuTriggerSize */];
    if (tableRef && targetCellRef) {
        var targetOffset = targetCellRef.getBoundingClientRect();
        var tableOffset = tableRef.getBoundingClientRect();
        var topDiff = targetOffset.top - tableOffset.top;
        if (topDiff < 200) {
            top -= topDiff + 2;
        }
    }
    return [1, top];
};
var FloatingContextualMenu = function (_a) {
    var mountPoint = _a.mountPoint, boundariesElement = _a.boundariesElement, scrollableElement = _a.scrollableElement, editorView = _a.editorView, isOpen = _a.isOpen, targetCellPosition = _a.targetCellPosition, pluginConfig = _a.pluginConfig;
    if (!isOpen || !targetCellPosition) {
        return null;
    }
    var selection = editorView.state.selection;
    var selectionRect = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["isCellSelection"])(selection)
        ? Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["getSelectionRect"])(selection)
        : Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findCellRectClosestToPos"])(selection.$from);
    if (!selectionRect) {
        return null;
    }
    var domAtPos = editorView.domAtPos.bind(editorView);
    var targetCellRef = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findDomRefAtPos"])(targetCellPosition, domAtPos);
    if (!targetCellRef) {
        return null;
    }
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__["e" /* Popup */], { alignX: "right", alignY: "top", target: targetCellRef, mountTo: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, fitHeight: 100, fitWidth: 200, 
        // z-index value below is to ensure that this menu is above other floating menu
        // in table, but below floating dialogs like typeaheads, pickers, etc.
        zIndex: __WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__["n" /* akEditorFloatingOverlapPanelZIndex */] },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MenuWrapper, null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ContextualMenu__["a" /* default */], { editorView: editorView, offset: calculateOffset(targetCellRef, editorView.state), isOpen: isOpen, targetCellPosition: targetCellPosition, allowMergeCells: pluginConfig.allowMergeCells, allowBackgroundColor: pluginConfig.allowBackgroundColor, selectionRect: selectionRect }))));
};
/* harmony default export */ __webpack_exports__["a"] = (FloatingContextualMenu);
var templateObject_1;
//# sourceMappingURL=index.js.map

/***/ }),
/* 2422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export messages */
/* unused harmony export getSelectedColumnIndexes */
/* unused harmony export getSelectedRowIndexes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_tables__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_styles__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_DropdownMenu__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_ColorPalette__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__messages__ = __webpack_require__(214);















var messages = Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["defineMessages"])({
    cellBackground: {
        id: 'fabric.editor.cellBackground',
        defaultMessage: 'Cell background',
        description: 'Change the background color of a table cell.',
    },
    mergeCells: {
        id: 'fabric.editor.mergeCells',
        defaultMessage: 'Merge cells',
        description: 'Merge tables cells together.',
    },
    splitCell: {
        id: 'fabric.editor.splitCell',
        defaultMessage: 'Split cell',
        description: 'Split a merged table cell.',
    },
    clearCells: {
        id: 'fabric.editor.clearCells',
        defaultMessage: 'Clear {0, plural, one {cell} other {cells}}',
        description: 'Clears the contents of the selected cells (this does not delete the cells themselves).',
    },
});
var ContextualMenu = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ContextualMenu, _super);
    function ContextualMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isSubmenuOpen: false,
        };
        _this.handleSubMenuRef = function (ref) {
            var boundariesElement = _this.props.boundariesElement;
            if (!(boundariesElement && ref)) {
                return;
            }
            var boundariesRect = boundariesElement.getBoundingClientRect();
            var rect = ref.getBoundingClientRect();
            if (rect.left + rect.width - boundariesRect.left > boundariesRect.width) {
                ref.style.left = "-" + rect.width + "px";
            }
        };
        _this.createItems = function () {
            var _a = _this.props, allowMergeCells = _a.allowMergeCells, allowBackgroundColor = _a.allowBackgroundColor, state = _a.editorView.state, targetCellPosition = _a.targetCellPosition, isOpen = _a.isOpen, selectionRect = _a.selectionRect, formatMessage = _a.intl.formatMessage;
            var items = [];
            var isSubmenuOpen = _this.state.isSubmenuOpen;
            if (allowBackgroundColor) {
                var node = isOpen && targetCellPosition
                    ? state.doc.nodeAt(targetCellPosition)
                    : null;
                var background = node && node.attrs.background ? node.attrs.background : '#ffffff';
                items.push({
                    content: formatMessage(messages.cellBackground),
                    value: { name: 'background' },
                    elemAfter: (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_7__types__["a" /* TableCssClassName */].CONTEXTUAL_MENU_ICON, style: { background: background } }),
                        isSubmenuOpen && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_7__types__["a" /* TableCssClassName */].CONTEXTUAL_SUBMENU, ref: _this.handleSubMenuRef },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__ui_ColorPalette__["a" /* default */], { palette: __WEBPACK_IMPORTED_MODULE_5__atlaskit_adf_schema__["_11" /* tableBackgroundColorPalette */], borderColors: __WEBPACK_IMPORTED_MODULE_5__atlaskit_adf_schema__["_10" /* tableBackgroundBorderColors */], onClick: _this.setColor, selectedColor: background, checkMarkColor: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["colors"].N500 }))))),
                });
            }
            items.push({
                content: formatMessage(__WEBPACK_IMPORTED_MODULE_13__messages__["a" /* default */].insertColumn),
                value: { name: 'insert_column' },
            });
            items.push({
                content: formatMessage(__WEBPACK_IMPORTED_MODULE_13__messages__["a" /* default */].insertRow),
                value: { name: 'insert_row' },
            });
            var right = selectionRect.right, left = selectionRect.left, top = selectionRect.top, bottom = selectionRect.bottom;
            var noOfColumns = right - left;
            var noOfRows = bottom - top;
            items.push({
                content: formatMessage(__WEBPACK_IMPORTED_MODULE_13__messages__["a" /* default */].removeColumns, {
                    0: noOfColumns,
                }),
                value: { name: 'delete_column' },
            });
            items.push({
                content: formatMessage(__WEBPACK_IMPORTED_MODULE_13__messages__["a" /* default */].removeRows, {
                    0: noOfRows,
                }),
                value: { name: 'delete_row' },
            });
            if (allowMergeCells) {
                items.push({
                    content: formatMessage(messages.mergeCells),
                    value: { name: 'merge' },
                    isDisabled: !Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_tables__["mergeCells"])(state),
                });
                items.push({
                    content: formatMessage(messages.splitCell),
                    value: { name: 'split' },
                    isDisabled: !Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_tables__["splitCell"])(state),
                });
            }
            items.push({
                content: formatMessage(messages.clearCells, {
                    0: Math.max(noOfColumns, noOfRows),
                }),
                value: { name: 'clear' },
                elemAfter: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ui_styles__["f" /* Shortcut */], null, "\u232B"),
            });
            return items.length ? [{ items: items }] : null;
        };
        _this.onMenuItemActivated = function (_a) {
            var item = _a.item;
            var _b = _this.props, editorView = _b.editorView, selectionRect = _b.selectionRect, targetCellPosition = _b.targetCellPosition;
            var state = editorView.state, dispatch = editorView.dispatch;
            switch (item.value.name) {
                case 'merge':
                    __WEBPACK_IMPORTED_MODULE_11__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.format.table.merge.button');
                    Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_tables__["mergeCells"])(state, dispatch);
                    _this.toggleOpen();
                    break;
                case 'split':
                    __WEBPACK_IMPORTED_MODULE_11__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.format.table.split.button');
                    Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_tables__["splitCell"])(state, dispatch);
                    _this.toggleOpen();
                    break;
                case 'clear':
                    __WEBPACK_IMPORTED_MODULE_11__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.format.table.split.button');
                    Object(__WEBPACK_IMPORTED_MODULE_6__actions__["h" /* emptyMultipleCells */])(targetCellPosition)(state, dispatch);
                    _this.toggleOpen();
                    break;
                case 'insert_column':
                    Object(__WEBPACK_IMPORTED_MODULE_6__actions__["p" /* insertColumn */])(selectionRect.right)(state, dispatch);
                    _this.toggleOpen();
                    break;
                case 'insert_row':
                    Object(__WEBPACK_IMPORTED_MODULE_6__actions__["q" /* insertRow */])(selectionRect.bottom)(state, dispatch);
                    _this.toggleOpen();
                    break;
                case 'delete_column':
                    __WEBPACK_IMPORTED_MODULE_11__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.format.table.delete_column.button');
                    Object(__WEBPACK_IMPORTED_MODULE_6__actions__["c" /* deleteColumns */])(getSelectedColumnIndexes(selectionRect))(state, dispatch);
                    _this.toggleOpen();
                    break;
                case 'delete_row':
                    __WEBPACK_IMPORTED_MODULE_11__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.format.table.delete_row.button');
                    Object(__WEBPACK_IMPORTED_MODULE_6__actions__["d" /* deleteRows */])(getSelectedRowIndexes(selectionRect))(state, dispatch);
                    _this.toggleOpen();
                    break;
            }
        };
        _this.toggleOpen = function () {
            var _a = _this.props, isOpen = _a.isOpen, _b = _a.editorView, state = _b.state, dispatch = _b.dispatch;
            Object(__WEBPACK_IMPORTED_MODULE_6__actions__["z" /* toggleContextualMenu */])(state, dispatch);
            if (!isOpen) {
                _this.setState({
                    isSubmenuOpen: false,
                });
            }
        };
        _this.handleOpenChange = function (_a) {
            var isOpen = _a.isOpen;
            var _b = _this.props.editorView, state = _b.state, dispatch = _b.dispatch;
            Object(__WEBPACK_IMPORTED_MODULE_6__actions__["z" /* toggleContextualMenu */])(state, dispatch);
            _this.setState({ isSubmenuOpen: false });
        };
        _this.handleItemMouseEnter = function (_a) {
            var item = _a.item;
            var _b = _this.props, _c = _b.editorView, state = _c.state, dispatch = _c.dispatch, selectionRect = _b.selectionRect;
            if (item.value.name === 'background') {
                if (!_this.state.isSubmenuOpen) {
                    _this.setState({ isSubmenuOpen: true });
                }
            }
            if (item.value.name === 'delete_column') {
                Object(__WEBPACK_IMPORTED_MODULE_6__actions__["m" /* hoverColumns */])(getSelectedColumnIndexes(selectionRect), true)(state, dispatch);
            }
            if (item.value.name === 'delete_row') {
                Object(__WEBPACK_IMPORTED_MODULE_6__actions__["n" /* hoverRows */])(getSelectedRowIndexes(selectionRect), true)(state, dispatch);
            }
        };
        _this.handleItemMouseLeave = function (_a) {
            var item = _a.item;
            var _b = _this.props.editorView, state = _b.state, dispatch = _b.dispatch;
            if (item.value.name === 'background') {
                _this.closeSubmenu();
            }
            if (item.value.name === 'delete_column' ||
                item.value.name === 'delete_row') {
                Object(__WEBPACK_IMPORTED_MODULE_6__actions__["a" /* clearHoverSelection */])(state, dispatch);
            }
        };
        _this.closeSubmenu = function () {
            if (_this.state.isSubmenuOpen) {
                _this.setState({ isSubmenuOpen: false });
            }
        };
        _this.setColor = Object(__WEBPACK_IMPORTED_MODULE_11__analytics__["c" /* withAnalytics */])('atlassian.editor.format.table.backgroundColor.button', function (color) {
            var _a = _this.props, targetCellPosition = _a.targetCellPosition, editorView = _a.editorView;
            var state = editorView.state, dispatch = editorView.dispatch;
            Object(__WEBPACK_IMPORTED_MODULE_6__actions__["v" /* setMultipleCellAttrs */])({ background: color }, targetCellPosition)(state, dispatch);
            _this.toggleOpen();
        });
        return _this;
    }
    ContextualMenu.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, mountPoint = _a.mountPoint, offset = _a.offset, boundariesElement = _a.boundariesElement;
        var items = this.createItems();
        if (!items) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { onMouseLeave: this.closeSubmenu },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ui_DropdownMenu__["a" /* default */], { mountTo: mountPoint, items: items, isOpen: isOpen, onOpenChange: this.handleOpenChange, onItemActivated: this.onMenuItemActivated, onMouseEnter: this.handleItemMouseEnter, onMouseLeave: this.handleItemMouseLeave, fitHeight: 188, fitWidth: __WEBPACK_IMPORTED_MODULE_8__styles__["a" /* contextualMenuDropdownWidth */], boundariesElement: boundariesElement, offset: offset })));
    };
    ContextualMenu.defaultProps = {
        boundariesElement: document.body,
    };
    return ContextualMenu;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
var getSelectedColumnIndexes = function (selectionRect) {
    var columnIndexes = [];
    for (var i = selectionRect.left; i < selectionRect.right; i++) {
        columnIndexes.push(i);
    }
    return columnIndexes;
};
var getSelectedRowIndexes = function (selectionRect) {
    var rowIndexes = [];
    for (var i = selectionRect.top; i < selectionRect.bottom; i++) {
        rowIndexes.push(i);
    }
    return rowIndexes;
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["injectIntl"])(ContextualMenu));
//# sourceMappingURL=ContextualMenu.js.map

/***/ }),
/* 2423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_done__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_done___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_done__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(2424);







// IMO these should live inside @atlaskit/theme
var messages = Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["defineMessages"])({
    '#172b4d': {
        id: 'fabric.theme.#172b4d',
        defaultMessage: 'Dark gray',
        description: 'Name of a color.',
    },
    '#97a0af': {
        id: 'fabric.theme.#97a0af',
        defaultMessage: 'Light grey',
        description: 'Name of a color.',
    },
    '#6554c0': {
        id: 'fabric.theme.#6554c0',
        defaultMessage: 'Purple',
        description: 'Name of a color.',
    },
    '#00b8d9': {
        id: 'fabric.theme.#00b8d9',
        defaultMessage: 'Teal',
        description: 'Name of a color.',
    },
    '#36b37e': {
        id: 'fabric.theme.#36b37e',
        defaultMessage: 'Green',
        description: 'Name of a color.',
    },
    '#ff5630': {
        id: 'fabric.theme.#ff5630',
        defaultMessage: 'Red',
        description: 'Name of a color.',
    },
    '#ff991f': {
        id: 'fabric.theme.#ff991f',
        defaultMessage: 'Orange',
        description: 'Name of a color.',
    },
    selected: {
        id: 'fabric.editor.selected',
        defaultMessage: 'Selected',
        description: 'If the item is selected or not.',
    },
});
var Color = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Color, _super);
    function Color() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onMouseDown = function (e) {
            e.preventDefault();
        };
        _this.onClick = function (e) {
            var _a = _this.props, onClick = _a.onClick, value = _a.value;
            e.preventDefault();
            onClick(value);
        };
        return _this;
    }
    Color.prototype.render = function () {
        var _a = this.props, tabIndex = _a.tabIndex, value = _a.value, label = _a.label, isSelected = _a.isSelected, borderColor = _a.borderColor, _b = _a.checkMarkColor, checkMarkColor = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["colors"].N0 : _b, formatMessage = _a.intl.formatMessage;
        var borderStyle = "1px solid " + borderColor;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["b" /* ButtonWrapper */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["a" /* Button */], { onClick: this.onClick, onMouseDown: this.onMouseDown, tabIndex: tabIndex, className: "" + (isSelected ? 'selected' : ''), title: value && messages[value] ? formatMessage(messages[value]) : label, style: {
                    backgroundColor: value || 'transparent',
                    border: borderStyle,
                } }, isSelected && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_done___default.a, { primaryColor: checkMarkColor, label: formatMessage(messages.selected) })))));
    };
    return Color;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["injectIntl"])(Color));
//# sourceMappingURL=index.js.map

/***/ }),
/* 2424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



var Button = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  height: 26px;\n  width: 26px;\n  background: ", ";\n  padding: 0;\n  border-radius: 4px;\n  border: 1px solid ", ";\n  cursor: pointer;\n  display: block;\n"], ["\n  height: 26px;\n  width: 26px;\n  background: ", ";\n  padding: 0;\n  border-radius: 4px;\n  border: 1px solid ", ";\n  cursor: pointer;\n  display: block;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N900, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N0);
var ButtonWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  border: 1px solid transparent;\n  margin: 1px;\n  font-size: 0;\n  display: flex;\n  align-items: center;\n  padding: 1px;\n  border-radius: 6px;\n  &:hover {\n    border: 1px solid ", ";\n  }\n"], ["\n  border: 1px solid transparent;\n  margin: 1px;\n  font-size: 0;\n  display: flex;\n  align-items: center;\n  padding: 1px;\n  border-radius: 6px;\n  &:hover {\n    border: 1px solid ", ";\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N50);
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColorPaletteWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



var ColorPaletteWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  padding: 0 ", "px;\n  /* Firefox bug fix: https://product-fabric.atlassian.net/browse/ED-1789 */\n  display: flex;\n  flex-wrap: wrap;\n"], ["\n  padding: 0 ", "px;\n  /* Firefox bug fix: https://product-fabric.atlassian.net/browse/ED-1789 */\n  display: flex;\n  flex-wrap: wrap;\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])());
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createCellView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_chevron_down__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_chevron_down___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_chevron_down__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nodeviews_ReactNodeView__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_ToolbarButton__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_messages__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pm_plugins_main__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pm_plugins_table_resizing_index__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__editor_disabled__ = __webpack_require__(106);















var Cell = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Cell, _super);
    function Cell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function () {
            var _a = _this.props.view, state = _a.state, dispatch = _a.dispatch;
            Object(__WEBPACK_IMPORTED_MODULE_11__actions__["z" /* toggleContextualMenu */])(state, dispatch);
        };
        return _this;
    }
    Cell.prototype.shouldComponentUpdate = function (nextProps) {
        return (this.props.withCursor !== nextProps.withCursor ||
            this.props.isResizing !== nextProps.isResizing ||
            this.props.isContextualMenuOpen !== nextProps.isContextualMenuOpen);
    };
    Cell.prototype.render = function () {
        var _a = this.props, withCursor = _a.withCursor, isResizing = _a.isResizing, isContextualMenuOpen = _a.isContextualMenuOpen, forwardRef = _a.forwardRef, formatMessage = _a.intl.formatMessage, disabled = _a.disabled, appearance = _a.appearance;
        var labelCellOptions = formatMessage(__WEBPACK_IMPORTED_MODULE_8__ui_messages__["a" /* default */].cellOptions);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_12__types__["a" /* TableCssClassName */].CELL_NODEVIEW_WRAPPER, ref: forwardRef }, withCursor && !disabled && appearance !== 'mobile' && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_12__types__["a" /* TableCssClassName */].CONTEXTUAL_MENU_BUTTON },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ui_ToolbarButton__["a" /* default */], { disabled: isResizing, selected: isContextualMenuOpen, title: labelCellOptions, onClick: this.handleClick, iconBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_chevron_down___default.a, { label: labelCellOptions }) })))));
    };
    return Cell;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
var CellComponent = Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["injectIntl"])(Cell);
var CellView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CellView, _super);
    function CellView(props) {
        return _super.call(this, props.node, props.view, props.getPos, props.portalProviderAPI, props) || this;
    }
    CellView.prototype.createDomRef = function () {
        var tableCell = this.view.state.schema.nodes.tableCell;
        this.cell = document.createElement("t" + (this.node.type === tableCell ? 'd' : 'h'));
        return this.cell;
    };
    CellView.prototype.getContentDOM = function () {
        var dom = document.createElement('div');
        dom.className = __WEBPACK_IMPORTED_MODULE_12__types__["a" /* TableCssClassName */].TABLE_CELL_NODEVIEW_CONTENT_DOM;
        return { dom: dom };
    };
    CellView.prototype.setDomAttrs = function (node) {
        var cell = this.cell;
        if (cell) {
            var attrs_1 = Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_adf_schema__["_4" /* setCellAttrs */])(node, cell);
            Object.keys(attrs_1).forEach(function (attr) {
                cell.setAttribute(attr, attrs_1[attr]);
            });
        }
    };
    CellView.prototype.render = function (props, forwardRef) {
        var _this = this;
        // nodeview does not re-render on selection changes
        // so we trigger render manually to hide/show contextual menu button when `targetCellPosition` is updated
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ui_WithPluginState__["a" /* default */], { plugins: {
                pluginState: __WEBPACK_IMPORTED_MODULE_9__pm_plugins_main__["e" /* pluginKey */],
                tableResizingPluginState: __WEBPACK_IMPORTED_MODULE_10__pm_plugins_table_resizing_index__["b" /* pluginKey */],
                editorDisabledPlugin: __WEBPACK_IMPORTED_MODULE_14__editor_disabled__["b" /* pluginKey */],
            }, editorView: props.view, render: function (_a) {
                var pluginState = _a.pluginState, tableResizingPluginState = _a.tableResizingPluginState, editorDisabledPlugin = _a.editorDisabledPlugin;
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CellComponent, { forwardRef: forwardRef, withCursor: _this.getPos() === pluginState.targetCellPosition, isResizing: !!tableResizingPluginState && !!tableResizingPluginState.dragging, isContextualMenuOpen: !!pluginState.isContextualMenuOpen, view: props.view, appearance: props.appearance, disabled: (editorDisabledPlugin || {}).editorDisabled }));
            } }));
    };
    CellView.prototype.ignoreMutation = function (record) {
        // @see https://github.com/ProseMirror/prosemirror/issues/862
        var target = record.target;
        if (record.attributeName === 'class' ||
            (target && Object(__WEBPACK_IMPORTED_MODULE_13__utils__["i" /* closestElement */])(target, "." + __WEBPACK_IMPORTED_MODULE_12__types__["a" /* TableCssClassName */].CELL_NODEVIEW_WRAPPER))) {
            return true;
        }
        return false;
    };
    return CellView;
}(__WEBPACK_IMPORTED_MODULE_5__nodeviews_ReactNodeView__["a" /* default */]));
var createCellView = function (portalProviderAPI, appearance) { return function (node, view, getPos) {
    return new CellView({
        node: node,
        view: view,
        getPos: getPos,
        portalProviderAPI: portalProviderAPI,
        appearance: appearance,
    }).init();
}; };
//# sourceMappingURL=cell.js.map

/***/ }),
/* 2427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return handleSetFocus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return handleSetTableRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return handleSetTargetCellPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleClearSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleHoverColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handleHoverRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleHoverTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleDocOrSelectionChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return handleToggleContextualMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return handleShowInsertColumnButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return handleShowInsertRowButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleHideInsertColumnOrRowButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(68);






var processDecorations = function (state, decorationSet, newDecorations, find) {
    if (newDecorations.length) {
        return decorationSet.add(state.doc, newDecorations);
    }
    else {
        return decorationSet.remove(find(decorationSet));
    }
};
var handleSetFocus = function (editorHasFocus) { return function (pluginState, dispatch) {
    var nextPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { editorHasFocus: editorHasFocus });
    dispatch(__WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["e" /* pluginKey */], nextPluginState);
    return nextPluginState;
}; };
var handleSetTableRef = function (state, tableRef) { return function (pluginState, dispatch) {
    var nextPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { tableRef: tableRef, tableFloatingToolbarTarget: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["i" /* closestElement */])(tableRef, "." + __WEBPACK_IMPORTED_MODULE_3__types__["a" /* TableCssClassName */].TABLE_NODE_WRAPPER) || undefined, tableNode: tableRef ? Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["findTable"])(state.selection).node : undefined });
    dispatch(__WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["e" /* pluginKey */], nextPluginState);
    return nextPluginState;
}; };
var handleSetTargetCellPosition = function (targetCellPosition) { return function (pluginState, dispatch) {
    var nextPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { targetCellPosition: targetCellPosition, isContextualMenuOpen: false });
    dispatch(__WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["e" /* pluginKey */], nextPluginState);
    return nextPluginState;
}; };
var handleClearSelection = function (pluginState, dispatch) {
    var decorationSet = pluginState.decorationSet;
    var nextPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, __WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["c" /* defaultTableSelection */], { decorationSet: decorationSet.remove(Object(__WEBPACK_IMPORTED_MODULE_5__utils__["f" /* findControlsHoverDecoration */])(decorationSet)) });
    dispatch(__WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["e" /* pluginKey */], nextPluginState);
    return nextPluginState;
};
var handleHoverColumns = function (state, hoverDecoration, hoveredColumns, isInDanger) { return function (pluginState, dispatch) {
    var nextPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { decorationSet: processDecorations(state, pluginState.decorationSet, hoverDecoration, __WEBPACK_IMPORTED_MODULE_5__utils__["f" /* findControlsHoverDecoration */]), hoveredColumns: hoveredColumns,
        isInDanger: isInDanger });
    dispatch(__WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["e" /* pluginKey */], nextPluginState);
    return nextPluginState;
}; };
var handleHoverRows = function (state, hoverDecoration, hoveredRows, isInDanger) { return function (pluginState, dispatch) {
    var nextPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { decorationSet: processDecorations(state, pluginState.decorationSet, hoverDecoration, __WEBPACK_IMPORTED_MODULE_5__utils__["f" /* findControlsHoverDecoration */]), hoveredRows: hoveredRows,
        isInDanger: isInDanger });
    dispatch(__WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["e" /* pluginKey */], nextPluginState);
    return nextPluginState;
}; };
var handleHoverTable = function (state, hoverDecoration, hoveredColumns, hoveredRows, isInDanger) { return function (pluginState, dispatch) {
    var nextPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { decorationSet: processDecorations(state, pluginState.decorationSet, hoverDecoration, __WEBPACK_IMPORTED_MODULE_5__utils__["f" /* findControlsHoverDecoration */]), hoveredColumns: hoveredColumns,
        hoveredRows: hoveredRows,
        isInDanger: isInDanger });
    dispatch(__WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["e" /* pluginKey */], nextPluginState);
    return nextPluginState;
}; };
var handleDocOrSelectionChanged = function (tr) { return function (pluginState, dispatch) {
    var tableNode;
    var targetCellPosition;
    var table = Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["findTable"])(tr.selection);
    if (table) {
        tableNode = table.node;
        var _a = tr.doc.type.schema.nodes, tableCell = _a.tableCell, tableHeader = _a.tableHeader;
        var cell = Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["findParentNodeOfType"])([tableCell, tableHeader])(tr.selection);
        targetCellPosition = cell ? cell.pos : undefined;
    }
    var hoverDecoration = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["f" /* findControlsHoverDecoration */])(pluginState.decorationSet);
    if (pluginState.tableNode !== tableNode ||
        pluginState.targetCellPosition !== targetCellPosition ||
        hoverDecoration.length) {
        var nextPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, __WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["c" /* defaultTableSelection */], { 
            // @see: https://product-fabric.atlassian.net/browse/ED-3796
            decorationSet: pluginState.decorationSet.remove(hoverDecoration), targetCellPosition: targetCellPosition,
            tableNode: tableNode });
        dispatch(__WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["e" /* pluginKey */], nextPluginState);
        return nextPluginState;
    }
    return pluginState;
}; };
var handleToggleContextualMenu = function (pluginState, dispatch) {
    var nextPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { isContextualMenuOpen: !pluginState.isContextualMenuOpen });
    dispatch(__WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["e" /* pluginKey */], nextPluginState);
    return nextPluginState;
};
var handleShowInsertColumnButton = function (insertColumnButtonIndex) { return function (pluginState, dispatch) {
    var nextPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { insertColumnButtonIndex: insertColumnButtonIndex });
    dispatch(__WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["e" /* pluginKey */], nextPluginState);
    return nextPluginState;
}; };
var handleShowInsertRowButton = function (insertRowButtonIndex) { return function (pluginState, dispatch) {
    var nextPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { insertRowButtonIndex: insertRowButtonIndex });
    dispatch(__WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["e" /* pluginKey */], nextPluginState);
    return nextPluginState;
}; };
var handleHideInsertColumnOrRowButton = function (pluginState, dispatch) {
    var nextPluginState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, pluginState, { insertColumnButtonIndex: undefined, insertRowButtonIndex: undefined });
    dispatch(__WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["e" /* pluginKey */], nextPluginState);
    return nextPluginState;
};
//# sourceMappingURL=action-handlers.js.map

/***/ }),
/* 2428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleBlur; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleFocus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return handleMouseOver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handleMouseLeave; });
/* harmony export (immutable) */ __webpack_exports__["g"] = handleTripleClick;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return handleMouseDown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils___ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(61);







var handleBlur = function (view, event) {
    var state = view.state, dispatch = view.dispatch;
    // fix for issue ED-4665
    if (__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["E" /* browser */].ie_version !== 11) {
        Object(__WEBPACK_IMPORTED_MODULE_6__actions__["u" /* setEditorFocus */])(false)(state, dispatch);
    }
    event.preventDefault();
    return false;
};
var handleFocus = function (view, event) {
    var state = view.state, dispatch = view.dispatch;
    Object(__WEBPACK_IMPORTED_MODULE_6__actions__["u" /* setEditorFocus */])(true)(state, dispatch);
    event.preventDefault();
    return false;
};
var handleClick = function (view, event) {
    var element = event.target;
    var table = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["findTable"])(view.state.selection);
    /**
     * Check if the table cell with an image is clicked
     * and its not the image itself
     */
    var matches = element.matches ? 'matches' : 'msMatchesSelector';
    if (!table ||
        !Object(__WEBPACK_IMPORTED_MODULE_4__utils___["s" /* isElementInTableCell */])(element) ||
        element[matches]('table .image, table p, table .image div')) {
        return false;
    }
    var map = __WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["TableMap"].get(table.node);
    /** Getting the offset of current item clicked */
    var colElement = (Object(__WEBPACK_IMPORTED_MODULE_4__utils___["i" /* closestElement */])(element, 'td') ||
        Object(__WEBPACK_IMPORTED_MODULE_4__utils___["i" /* closestElement */])(element, 'th'));
    var colIndex = colElement && colElement.cellIndex;
    var rowElement = Object(__WEBPACK_IMPORTED_MODULE_4__utils___["i" /* closestElement */])(element, 'tr');
    var rowIndex = rowElement && rowElement.rowIndex;
    var cellIndex = map.width * rowIndex + colIndex;
    var posInTable = map.map[cellIndex + 1];
    var dispatch = view.dispatch, _a = view.state, tr = _a.tr, paragraph = _a.schema.nodes.paragraph;
    var editorElement = table.node.nodeAt(map.map[cellIndex]);
    /** Only if the last item is media group, insert a paragraph */
    if (Object(__WEBPACK_IMPORTED_MODULE_4__utils___["x" /* isLastItemMediaGroup */])(editorElement)) {
        tr.insert(posInTable + table.pos, paragraph.create());
        dispatch(tr);
        Object(__WEBPACK_IMPORTED_MODULE_4__utils___["G" /* setNodeSelection */])(view, posInTable + table.pos);
    }
    return true;
};
var handleMouseOver = function (view, mouseEvent) {
    var state = view.state, dispatch = view.dispatch;
    var target = mouseEvent.target;
    if (Object(__WEBPACK_IMPORTED_MODULE_5__utils__["v" /* isInsertColumnButton */])(target)) {
        return Object(__WEBPACK_IMPORTED_MODULE_6__actions__["x" /* showInsertColumnButton */])(Object(__WEBPACK_IMPORTED_MODULE_5__utils__["m" /* getIndex */])(target))(state, dispatch);
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_5__utils__["w" /* isInsertRowButton */])(target)) {
        return Object(__WEBPACK_IMPORTED_MODULE_6__actions__["y" /* showInsertRowButton */])(Object(__WEBPACK_IMPORTED_MODULE_5__utils__["m" /* getIndex */])(target))(state, dispatch);
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_6__actions__["l" /* hideInsertColumnOrRowButton */])(state, dispatch)) {
        return true;
    }
    return false;
};
var handleMouseLeave = function (view) {
    var state = view.state, dispatch = view.dispatch;
    if (Object(__WEBPACK_IMPORTED_MODULE_6__actions__["l" /* hideInsertColumnOrRowButton */])(state, dispatch)) {
        return true;
    }
    return false;
};
function handleTripleClick(view, pos) {
    var state = view.state, dispatch = view.dispatch;
    var $cellPos = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_tables__["cellAround"])(state.doc.resolve(pos));
    if (!$cellPos) {
        return false;
    }
    var cell = state.doc.nodeAt($cellPos.pos);
    if (cell) {
        var selFrom = __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Selection"].findFrom($cellPos, 1, true);
        var selTo = __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Selection"].findFrom(state.doc.resolve($cellPos.pos + cell.nodeSize), -1, true);
        if (selFrom && selTo) {
            dispatch(state.tr.setSelection(new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["TextSelection"](selFrom.$from, selTo.$to)));
            return true;
        }
    }
    return false;
}
var handleMouseDown = function (view, event) {
    var state = view.state, dispatch = view.dispatch;
    // shift-selecting table rows/columns
    if (Object(__WEBPACK_IMPORTED_MODULE_6__actions__["k" /* handleShiftSelection */])(event)(state, dispatch)) {
        return true;
    }
    return false;
};
//# sourceMappingURL=event-handlers.js.map

/***/ }),
/* 2429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorTransform = __webpack_require__(46);
var prosemirrorModel = __webpack_require__(23);

var olDOM = ["ol", 0];
var ulDOM = ["ul", 0];
var liDOM = ["li", 0];

// :: NodeSpec
// An ordered list [node spec](#model.NodeSpec). Has a single
// attribute, `order`, which determines the number at which the list
// starts counting, and defaults to 1. Represented as an `<ol>`
// element.
var orderedList = {
  attrs: {order: {default: 1}},
  parseDOM: [{tag: "ol", getAttrs: function getAttrs(dom) {
    return {order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1}
  }}],
  toDOM: function toDOM(node) {
    return node.attrs.order == 1 ? olDOM : ["ol", {start: node.attrs.order}, 0]
  }
};

// :: NodeSpec
// A bullet list node spec, represented in the DOM as `<ul>`.
var bulletList = {
  parseDOM: [{tag: "ul"}],
  toDOM: function toDOM() { return ulDOM }
};

// :: NodeSpec
// A list item (`<li>`) spec.
var listItem = {
  parseDOM: [{tag: "li"}],
  toDOM: function toDOM() { return liDOM },
  defining: true
};

function add(obj, props) {
  var copy = {};
  for (var prop in obj) { copy[prop] = obj[prop]; }
  for (var prop$1 in props) { copy[prop$1] = props[prop$1]; }
  return copy
}

// :: (OrderedMap<NodeSpec>, string, ?string) → OrderedMap<NodeSpec>
// Convenience function for adding list-related node types to a map
// specifying the nodes for a schema. Adds
// [`orderedList`](#schema-list.orderedList) as `"ordered_list"`,
// [`bulletList`](#schema-list.bulletList) as `"bullet_list"`, and
// [`listItem`](#schema-list.listItem) as `"list_item"`.
//
// `itemContent` determines the content expression for the list items.
// If you want the commands defined in this module to apply to your
// list structure, it should have a shape like `"paragraph block*"` or
// `"paragraph (ordered_list | bullet_list)*"`. `listGroup` can be
// given to assign a group name to the list node types, for example
// `"block"`.
function addListNodes(nodes, itemContent, listGroup) {
  return nodes.append({
    ordered_list: add(orderedList, {content: "list_item+", group: listGroup}),
    bullet_list: add(bulletList, {content: "list_item+", group: listGroup}),
    list_item: add(listItem, {content: itemContent})
  })
}

// :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Returns a command function that wraps the selection in a list with
// the given type an attributes. If `dispatch` is null, only return a
// value to indicate whether this is possible, but don't actually
// perform the change.
function wrapInList(listType, attrs) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var range = $from.blockRange($to), doJoin = false, outerRange = range;
    if (!range) { return false }
    // This is at the top of an existing list item
    if (range.depth >= 2 && $from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex == 0) {
      // Don't do anything if this is the top of the list
      if ($from.index(range.depth - 1) == 0) { return false }
      var $insert = state.doc.resolve(range.start - 2);
      outerRange = new prosemirrorModel.NodeRange($insert, $insert, range.depth);
      if (range.endIndex < range.parent.childCount)
        { range = new prosemirrorModel.NodeRange($from, state.doc.resolve($to.end(range.depth)), range.depth); }
      doJoin = true;
    }
    var wrap = prosemirrorTransform.findWrapping(outerRange, listType, attrs, range);
    if (!wrap) { return false }
    if (dispatch) { dispatch(doWrapInList(state.tr, range, wrap, doJoin, listType).scrollIntoView()); }
    return true
  }
}

function doWrapInList(tr, range, wrappers, joinBefore, listType) {
  var content = prosemirrorModel.Fragment.empty;
  for (var i = wrappers.length - 1; i >= 0; i--)
    { content = prosemirrorModel.Fragment.from(wrappers[i].type.create(wrappers[i].attrs, content)); }

  tr.step(new prosemirrorTransform.ReplaceAroundStep(range.start - (joinBefore ? 2 : 0), range.end, range.start, range.end,
                                new prosemirrorModel.Slice(content, 0, 0), wrappers.length, true));

  var found = 0;
  for (var i$1 = 0; i$1 < wrappers.length; i$1++) { if (wrappers[i$1].type == listType) { found = i$1 + 1; } }
  var splitDepth = wrappers.length - found;

  var splitPos = range.start + wrappers.length - (joinBefore ? 2 : 0), parent = range.parent;
  for (var i$2 = range.startIndex, e = range.endIndex, first = true; i$2 < e; i$2++, first = false) {
    if (!first && prosemirrorTransform.canSplit(tr.doc, splitPos, splitDepth)) {
      tr.split(splitPos, splitDepth);
      splitPos += 2 * splitDepth;
    }
    splitPos += parent.child(i$2).nodeSize;
  }
  return tr
}

// :: (NodeType) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Build a command that splits a non-empty textblock at the top level
// of a list item by also splitting that list item.
function splitListItem(itemType) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var node = ref.node;
    if ((node && node.isBlock) || $from.depth < 2 || !$from.sameParent($to)) { return false }
    var grandParent = $from.node(-1);
    if (grandParent.type != itemType) { return false }
    if ($from.parent.content.size == 0) {
      // In an empty block. If this is a nested list, the wrapping
      // list item should be split. Otherwise, bail out and let next
      // command handle lifting.
      if ($from.depth == 2 || $from.node(-3).type != itemType ||
          $from.index(-2) != $from.node(-2).childCount - 1) { return false }
      if (dispatch) {
        var wrap = prosemirrorModel.Fragment.empty, keepItem = $from.index(-1) > 0;
        // Build a fragment containing empty versions of the structure
        // from the outer list item to the parent node of the cursor
        for (var d = $from.depth - (keepItem ? 1 : 2); d >= $from.depth - 3; d--)
          { wrap = prosemirrorModel.Fragment.from($from.node(d).copy(wrap)); }
        // Add a second list item with an empty default start node
        wrap = wrap.append(prosemirrorModel.Fragment.from(itemType.createAndFill()));
        var tr$1 = state.tr.replace($from.before(keepItem ? null : -1), $from.after(-3), new prosemirrorModel.Slice(wrap, keepItem ? 3 : 2, 2));
        tr$1.setSelection(state.selection.constructor.near(tr$1.doc.resolve($from.pos + (keepItem ? 3 : 2))));
        dispatch(tr$1.scrollIntoView());
      }
      return true
    }
    var nextType = $to.pos == $from.end() ? grandParent.defaultContentType(0) : null;
    var tr = state.tr.delete($from.pos, $to.pos);
    var types = nextType && [null, {type: nextType}];
    if (!prosemirrorTransform.canSplit(tr.doc, $from.pos, 2, types)) { return false }
    if (dispatch) { dispatch(tr.split($from.pos, 2, types).scrollIntoView()); }
    return true
  }
}

// :: (NodeType) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Create a command to lift the list item around the selection up into
// a wrapping list.
function liftListItem(itemType) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var range = $from.blockRange($to, function (node) { return node.childCount && node.firstChild.type == itemType; });
    if (!range) { return false }
    if (!dispatch) { return true }
    if ($from.node(range.depth - 1).type == itemType) // Inside a parent list
      { return liftToOuterList(state, dispatch, itemType, range) }
    else // Outer list node
      { return liftOutOfList(state, dispatch, range) }
  }
}

function liftToOuterList(state, dispatch, itemType, range) {
  var tr = state.tr, end = range.end, endOfList = range.$to.end(range.depth);
  if (end < endOfList) {
    // There are siblings after the lifted items, which must become
    // children of the last item
    tr.step(new prosemirrorTransform.ReplaceAroundStep(end - 1, endOfList, end, endOfList,
                                  new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(itemType.create(null, range.parent.copy())), 1, 0), 1, true));
    range = new prosemirrorModel.NodeRange(tr.doc.resolve(range.$from.pos), tr.doc.resolve(endOfList), range.depth);
  }
  dispatch(tr.lift(range, prosemirrorTransform.liftTarget(range)).scrollIntoView());
  return true
}

function liftOutOfList(state, dispatch, range) {
  var tr = state.tr, list = range.parent;
  // Merge the list items into a single big item
  for (var pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--) {
    pos -= list.child(i).nodeSize;
    tr.delete(pos - 1, pos + 1);
  }
  var $start = tr.doc.resolve(range.start), item = $start.nodeAfter;
  var atStart = range.startIndex == 0, atEnd = range.endIndex == list.childCount;
  var parent = $start.node(-1), indexBefore = $start.index(-1);
  if (!parent.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1,
                         item.content.append(atEnd ? prosemirrorModel.Fragment.empty : prosemirrorModel.Fragment.from(list))))
    { return false }
  var start = $start.pos, end = start + item.nodeSize;
  // Strip off the surrounding list. At the sides where we're not at
  // the end of the list, the existing list is closed. At sides where
  // this is the end, it is overwritten to its end.
  tr.step(new prosemirrorTransform.ReplaceAroundStep(start - (atStart ? 1 : 0), end + (atEnd ? 1 : 0), start + 1, end - 1,
                                new prosemirrorModel.Slice((atStart ? prosemirrorModel.Fragment.empty : prosemirrorModel.Fragment.from(list.copy(prosemirrorModel.Fragment.empty)))
                                          .append(atEnd ? prosemirrorModel.Fragment.empty : prosemirrorModel.Fragment.from(list.copy(prosemirrorModel.Fragment.empty))),
                                          atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 0 : 1));
  dispatch(tr.scrollIntoView());
  return true
}

// :: (NodeType) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Create a command to sink the list item around the selection down
// into an inner list.
function sinkListItem(itemType) {
  return function(state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var range = $from.blockRange($to, function (node) { return node.childCount && node.firstChild.type == itemType; });
    if (!range) { return false }
    var startIndex = range.startIndex;
    if (startIndex == 0) { return false }
    var parent = range.parent, nodeBefore = parent.child(startIndex - 1);
    if (nodeBefore.type != itemType) { return false }

    if (dispatch) {
      var nestedBefore = nodeBefore.lastChild && nodeBefore.lastChild.type == parent.type;
      var inner = prosemirrorModel.Fragment.from(nestedBefore ? itemType.create() : null);
      var slice = new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(itemType.create(null, prosemirrorModel.Fragment.from(parent.copy(inner)))),
                            nestedBefore ? 3 : 1, 0);
      var before = range.start, after = range.end;
      dispatch(state.tr.step(new prosemirrorTransform.ReplaceAroundStep(before - (nestedBefore ? 3 : 1), after,
                                                   before, after, slice, 1, true))
               .scrollIntoView());
    }
    return true
  }
}

exports.orderedList = orderedList;
exports.bulletList = bulletList;
exports.listItem = listItem;
exports.addListNodes = addListNodes;
exports.wrapInList = wrapInList;
exports.splitListItem = splitListItem;
exports.liftListItem = liftListItem;
exports.sinkListItem = sinkListItem;
//# sourceMappingURL=schema-list.js.map


/***/ }),
/* 2430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = liftFollowingList;
/* harmony export (immutable) */ __webpack_exports__["b"] = liftSelectionList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_transform__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_transform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_transform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(824);




function liftListItem(state, selection, tr) {
    var $from = selection.$from, $to = selection.$to;
    var nodeType = state.schema.nodes.listItem;
    var range = $from.blockRange($to, function (node) { return node.childCount && node.firstChild.type === nodeType; });
    if (!range ||
        range.depth < 2 ||
        $from.node(range.depth - 1).type !== nodeType) {
        return tr;
    }
    var end = range.end;
    var endOfList = $to.end(range.depth);
    if (end < endOfList) {
        tr.step(new __WEBPACK_IMPORTED_MODULE_2_prosemirror_transform__["ReplaceAroundStep"](end - 1, endOfList, end, endOfList, new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(nodeType.create(undefined, range.parent.copy())), 1, 0), 1, true));
        range = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["NodeRange"](tr.doc.resolve($from.pos), tr.doc.resolve(endOfList), range.depth);
    }
    return tr.lift(range, Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_transform__["liftTarget"])(range)).scrollIntoView();
}
// Function will lift list item following selection to level-1.
function liftFollowingList(state, from, to, rootListDepth, tr) {
    var listItem = state.schema.nodes.listItem;
    var lifted = false;
    tr.doc.nodesBetween(from, to, function (node, pos) {
        if (!lifted && node.type === listItem && pos > from) {
            lifted = true;
            var listDepth = rootListDepth + 3;
            while (listDepth > rootListDepth + 2) {
                var start = tr.doc.resolve(tr.mapping.map(pos));
                listDepth = start.depth;
                var end = tr.doc.resolve(tr.mapping.map(pos + node.textContent.length));
                var sel = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["TextSelection"](start, end);
                tr = liftListItem(state, sel, tr);
            }
        }
    });
    return tr;
}
// The function will list paragraphs in selection out to level 1 below root list.
function liftSelectionList(state, tr) {
    var _a = state.selection, from = _a.from, to = _a.to;
    var paragraph = state.schema.nodes.paragraph;
    var listCol = [];
    tr.doc.nodesBetween(from, to, function (node, pos) {
        if (node.type === paragraph) {
            listCol.push({ node: node, pos: pos });
        }
    });
    for (var i = listCol.length - 1; i >= 0; i--) {
        var paragraph_1 = listCol[i];
        var start = tr.doc.resolve(tr.mapping.map(paragraph_1.pos));
        if (start.depth > 0) {
            var end = void 0;
            if (paragraph_1.node.textContent && paragraph_1.node.textContent.length > 0) {
                end = tr.doc.resolve(tr.mapping.map(paragraph_1.pos + paragraph_1.node.textContent.length));
            }
            else {
                end = tr.doc.resolve(tr.mapping.map(paragraph_1.pos + 1));
            }
            var range = start.blockRange(end);
            if (range) {
                tr.lift(range, Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* getListLiftTarget */])(state.schema, start));
            }
        }
    }
    return tr;
}
//# sourceMappingURL=transforms.js.map

/***/ }),
/* 2431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_date__ = __webpack_require__(2432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__atlaskit_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(288);







var SelectableDate = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_5__atlaskit_date__["Date"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .ProseMirror-selectednode & {\n    display: 'relative';\n    &::before {\n      content: '';\n      border: 2px solid ", ";\n      display: 'absolute';\n      background: transparent;\n      border-radius: ", "px;\n      box-sizing: border-box;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      pointer-events: none;\n    }\n  }\n"], ["\n  .ProseMirror-selectednode & {\n    display: 'relative';\n    &::before {\n      content: '';\n      border: 2px solid ", ";\n      display: 'absolute';\n      background: transparent;\n      border-radius: ", "px;\n      box-sizing: border-box;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      pointer-events: none;\n    }\n  }\n"])), __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].B200, Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["borderRadius"])());
var DateNodeView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](DateNodeView, _super);
    function DateNodeView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (event) {
            event.nativeEvent.stopImmediatePropagation();
            var _a = _this.props.view, state = _a.state, dispatch = _a.dispatch;
            Object(__WEBPACK_IMPORTED_MODULE_6__actions__["d" /* setDatePickerAt */])(state.selection.from)(state, dispatch);
        };
        return _this;
    }
    DateNodeView.prototype.render = function () {
        var _a = this.props, timestamp = _a.node.attrs.timestamp, _b = _a.view.state, schema = _b.schema, selection = _b.selection;
        var parent = selection.$from.parent;
        var withinIncompleteTask = parent.type === schema.nodes.taskItem && parent.attrs.state !== 'DONE';
        var color = withinIncompleteTask && Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__["T" /* isPastDate */])(timestamp) ? 'red' : undefined;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { id: Math.random().toString(), onClick: this.handleClick },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](SelectableDate, { color: color, value: timestamp }, withinIncompleteTask
                ? Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__["_5" /* timestampToTaskContext */])(timestamp)
                : Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__["_4" /* timestampToString */])(timestamp))));
    };
    return DateNodeView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (DateNodeView);
var templateObject_1;
//# sourceMappingURL=date.js.map

/***/ }),
/* 2432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Date_1 = __webpack_require__(2433);
exports.Date = Date_1.Date;
var DateLozenge_1 = __webpack_require__(825);
exports.DateLozenge = DateLozenge_1.DateLozenge;
//# sourceMappingURL=index.js.map

/***/ }),
/* 2433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var DateLozenge_1 = __webpack_require__(825);
var React = __webpack_require__(0);
var format = __webpack_require__(826);
var isClickable = function (props) { return !!props.onClick; };
var Date = /** @class */ (function (_super) {
    tslib_1.__extends(Date, _super);
    function Date() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnClick = function (event) {
            if (isClickable(_this.props)) {
                _this.props.onClick(_this.props.value, event);
            }
        };
        _this.renderContent = function () {
            if (_this.props.children) {
                if (typeof _this.props.children === 'function') {
                    return _this.props.children(_this.props);
                }
                return _this.props.children;
            }
            return format(_this.props.value, _this.props.format);
        };
        return _this;
    }
    Date.prototype.render = function () {
        return (React.createElement(DateLozenge_1.DateLozenge, { className: this.props.className, onClick: isClickable(this.props) ? this.handleOnClick : undefined, color: this.props.color }, this.renderContent()));
    };
    Date.defaultProps = {
        format: 'DD/MM/YYYY',
        color: 'grey',
    };
    return Date;
}(React.Component));
exports.Date = Date;
//# sourceMappingURL=Date.js.map

/***/ }),
/* 2434 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(74)
var startOfYear = __webpack_require__(2435)
var differenceInCalendarDays = __webpack_require__(264)

/**
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * var result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = differenceInCalendarDays(date, startOfYear(date))
  var dayOfYear = diff + 1
  return dayOfYear
}

module.exports = getDayOfYear


/***/ }),
/* 2435 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(74)

/**
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear (dirtyDate) {
  var cleanDate = parse(dirtyDate)
  var date = new Date(0)
  date.setFullYear(cleanDate.getFullYear(), 0, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYear


/***/ }),
/* 2436 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(74)
var startOfISOWeek = __webpack_require__(447)
var startOfISOYear = __webpack_require__(2437)

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * var result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = startOfISOWeek(date).getTime() - startOfISOYear(date).getTime()

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
}

module.exports = getISOWeek


/***/ }),
/* 2437 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(827)
var startOfISOWeek = __webpack_require__(447)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * var result = startOfISOYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  return date
}

module.exports = startOfISOYear


/***/ }),
/* 2438 */
/***/ (function(module, exports, __webpack_require__) {

var buildDistanceInWordsLocale = __webpack_require__(2439)
var buildFormatLocale = __webpack_require__(2440)

/**
 * @category Locales
 * @summary English locale.
 */
module.exports = {
  distanceInWords: buildDistanceInWordsLocale(),
  format: buildFormatLocale()
}


/***/ }),
/* 2439 */
/***/ (function(module, exports) {

function buildDistanceInWordsLocale () {
  var distanceInWordsLocale = {
    lessThanXSeconds: {
      one: 'less than a second',
      other: 'less than {{count}} seconds'
    },

    xSeconds: {
      one: '1 second',
      other: '{{count}} seconds'
    },

    halfAMinute: 'half a minute',

    lessThanXMinutes: {
      one: 'less than a minute',
      other: 'less than {{count}} minutes'
    },

    xMinutes: {
      one: '1 minute',
      other: '{{count}} minutes'
    },

    aboutXHours: {
      one: 'about 1 hour',
      other: 'about {{count}} hours'
    },

    xHours: {
      one: '1 hour',
      other: '{{count}} hours'
    },

    xDays: {
      one: '1 day',
      other: '{{count}} days'
    },

    aboutXMonths: {
      one: 'about 1 month',
      other: 'about {{count}} months'
    },

    xMonths: {
      one: '1 month',
      other: '{{count}} months'
    },

    aboutXYears: {
      one: 'about 1 year',
      other: 'about {{count}} years'
    },

    xYears: {
      one: '1 year',
      other: '{{count}} years'
    },

    overXYears: {
      one: 'over 1 year',
      other: 'over {{count}} years'
    },

    almostXYears: {
      one: 'almost 1 year',
      other: 'almost {{count}} years'
    }
  }

  function localize (token, count, options) {
    options = options || {}

    var result
    if (typeof distanceInWordsLocale[token] === 'string') {
      result = distanceInWordsLocale[token]
    } else if (count === 1) {
      result = distanceInWordsLocale[token].one
    } else {
      result = distanceInWordsLocale[token].other.replace('{{count}}', count)
    }

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'in ' + result
      } else {
        return result + ' ago'
      }
    }

    return result
  }

  return {
    localize: localize
  }
}

module.exports = buildDistanceInWordsLocale


/***/ }),
/* 2440 */
/***/ (function(module, exports, __webpack_require__) {

var buildFormattingTokensRegExp = __webpack_require__(2441)

function buildFormatLocale () {
  // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.
  var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
  var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  var meridiemUppercase = ['AM', 'PM']
  var meridiemLowercase = ['am', 'pm']
  var meridiemFull = ['a.m.', 'p.m.']

  var formatters = {
    // Month: Jan, Feb, ..., Dec
    'MMM': function (date) {
      return months3char[date.getMonth()]
    },

    // Month: January, February, ..., December
    'MMMM': function (date) {
      return monthsFull[date.getMonth()]
    },

    // Day of week: Su, Mo, ..., Sa
    'dd': function (date) {
      return weekdays2char[date.getDay()]
    },

    // Day of week: Sun, Mon, ..., Sat
    'ddd': function (date) {
      return weekdays3char[date.getDay()]
    },

    // Day of week: Sunday, Monday, ..., Saturday
    'dddd': function (date) {
      return weekdaysFull[date.getDay()]
    },

    // AM, PM
    'A': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
    },

    // am, pm
    'a': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
    },

    // a.m., p.m.
    'aa': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
    }
  }

  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W']
  ordinalFormatters.forEach(function (formatterToken) {
    formatters[formatterToken + 'o'] = function (date, formatters) {
      return ordinal(formatters[formatterToken](date))
    }
  })

  return {
    formatters: formatters,
    formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
  }
}

function ordinal (number) {
  var rem100 = number % 100
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st'
      case 2:
        return number + 'nd'
      case 3:
        return number + 'rd'
    }
  }
  return number + 'th'
}

module.exports = buildFormatLocale


/***/ }),
/* 2441 */
/***/ (function(module, exports) {

var commonFormatterKeys = [
  'M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd',
  'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG',
  'H', 'HH', 'h', 'hh', 'm', 'mm',
  's', 'ss', 'S', 'SS', 'SSS',
  'Z', 'ZZ', 'X', 'x'
]

function buildFormattingTokensRegExp (formatters) {
  var formatterKeys = []
  for (var key in formatters) {
    if (formatters.hasOwnProperty(key)) {
      formatterKeys.push(key)
    }
  }

  var formattingTokens = commonFormatterKeys
    .concat(formatterKeys)
    .sort()
    .reverse()
  var formattingTokensRegExp = new RegExp(
    '(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g'
  )

  return formattingTokensRegExp
}

module.exports = buildFormattingTokensRegExp


/***/ }),
/* 2442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createContextAdapter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);



// injects contexts via old context API to children
// and gives access to the original Provider so that
// the child can re-emit it
var createContextAdapter = function (createContextAdapter) {
    var _a;
    return _a = /** @class */ (function (_super) {
            __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](class_1, _super);
            function class_1() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.contextState = {};
                return _this;
            }
            class_1.prototype.getChildContext = function () {
                return { contextAdapter: this.zipProvidersWithValues() };
            };
            class_1.prototype.zipProvidersWithValues = function () {
                var _this = this;
                return Object.keys(createContextAdapter).reduce(function (zipped, name) {
                    zipped[name] = {
                        Provider: createContextAdapter[name].Provider,
                        Consumer: createContextAdapter[name].Consumer,
                        value: _this.contextState[name],
                    };
                    return zipped;
                }, {});
            };
            class_1.prototype.render = function () {
                var _this = this;
                var children = this.props.children;
                // render all the consumers, and react to their value changes independently
                var consumers = Object.keys(createContextAdapter).map(function (name, idx) {
                    var Consumer = createContextAdapter[name].Consumer;
                    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Consumer, { key: idx }, function (value) {
                        // update local copy of value provided from Consumer
                        if (_this.contextState[name] !== value) {
                            _this.contextState[name] = value;
                            _this.forceUpdate();
                        }
                    }));
                });
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                    consumers,
                    children));
            };
            return class_1;
        }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"])),
        _a.childContextTypes = {
            contextAdapter: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
        },
        _a;
};
//# sourceMappingURL=context-adapter.js.map

/***/ }),
/* 2443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);


var PlaceholderTextNode = /** @class */ (function () {
    function PlaceholderTextNode(node, view, getPos) {
        var _this = this;
        this.update = function (node) {
            if (node.type !== node.type.schema.nodes.placeholder) {
                return false;
            }
            _this.dom = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["DOMSerializer"].renderSpec(document, node.type.spec.toDOM(node))
                .dom;
            _this.dom.onclick = _this.handleClick;
            return true;
        };
        this.destroy = function () {
            _this.dom = undefined;
        };
        this.handleClick = function (event) {
            var state = _this.view.state;
            var pos = _this.getPos();
            var selectionAtClick = __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["TextSelection"].create(state.tr.doc, pos);
            // In Firefox, clicking on the right-hand side of the span will place
            // the selection on the right-hand side of the node. We need to move
            // the selection to the left of this node in this case
            var nodeBefore = selectionAtClick.$anchor.nodeBefore;
            if (nodeBefore &&
                nodeBefore.type === _this.view.state.schema.nodes.placeholder &&
                _this.view.domAtPos(pos).node === event.target) {
                document.getSelection().removeAllRanges();
                // Find the nearest selection to the left to move the cursor to
                // TODO: [ts30] handle void and null properly
                var selectionToLeftOfClick = __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["TextSelection"].findFrom(selectionAtClick.$head, -1, true);
                _this.view.dispatch(state.tr.setSelection(selectionToLeftOfClick));
            }
            else {
                document.getSelection().removeAllRanges();
                _this.view.dispatch(state.tr.setSelection(selectionAtClick));
            }
            return true;
        };
        this.view = view;
        this.getPos = getPos;
        this.dom = __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["DOMSerializer"].renderSpec(document, node.type.spec.toDOM(node))
            .dom;
        // Using `onclick` rather than `addEventListener` due to ED-3728
        this.dom.onclick = this.handleClick;
    }
    return PlaceholderTextNode;
}());
/* harmony default export */ __webpack_exports__["a"] = (PlaceholderTextNode);
//# sourceMappingURL=placeholder-text.js.map

/***/ }),
/* 2444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export messages */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_PanelTextInput__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_FloatingToolbar__ = __webpack_require__(216);





var messages = Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["defineMessages"])({
    placeholderTextPlaceholder: {
        id: 'fabric.editor.placeholderTextPlaceholder',
        defaultMessage: 'Add placeholder text',
        description: '',
    },
});
var PlaceholderFloatingToolbar = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](PlaceholderFloatingToolbar, _super);
    function PlaceholderFloatingToolbar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSubmit = function (value) {
            if (value) {
                _this.props.insertPlaceholder(value);
                _this.props.setFocusInEditor();
            }
            else {
                _this.props.hidePlaceholderFloatingToolbar();
            }
        };
        _this.handleBlur = function () {
            _this.props.hidePlaceholderFloatingToolbar();
        };
        return _this;
    }
    PlaceholderFloatingToolbar.prototype.render = function () {
        var _a = this.props, getNodeFromPos = _a.getNodeFromPos, showInsertPanelAt = _a.showInsertPanelAt, editorViewDOM = _a.editorViewDOM, popupsMountPoint = _a.popupsMountPoint, getFixedCoordinatesFromPos = _a.getFixedCoordinatesFromPos, popupsBoundariesElement = _a.popupsBoundariesElement, formatMessage = _a.intl.formatMessage;
        var target = getNodeFromPos(showInsertPanelAt);
        var offsetParent = Object(__WEBPACK_IMPORTED_MODULE_4__ui_FloatingToolbar__["c" /* getOffsetParent */])(editorViewDOM, popupsMountPoint);
        var getFixedCoordinates = function () {
            return getFixedCoordinatesFromPos(showInsertPanelAt);
        };
        var handlePositionCalculated = Object(__WEBPACK_IMPORTED_MODULE_4__ui_FloatingToolbar__["d" /* handlePositionCalculatedWith */])(offsetParent, target, getFixedCoordinates);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ui_FloatingToolbar__["a" /* default */], { target: Object(__WEBPACK_IMPORTED_MODULE_4__ui_FloatingToolbar__["b" /* getNearestNonTextNode */])(target), onPositionCalculated: handlePositionCalculated, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, fitHeight: 32, offset: [0, 12] },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ui_PanelTextInput__["a" /* default */], { placeholder: formatMessage(messages.placeholderTextPlaceholder), onSubmit: this.handleSubmit, onBlur: this.handleBlur, autoFocus: true, width: 300 })));
    };
    return PlaceholderFloatingToolbar;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["injectIntl"])(PlaceholderFloatingToolbar));
//# sourceMappingURL=index.js.map

/***/ }),
/* 2445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Input; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



// Normal .className gets overridden by input[type=text] hence this hack to produce input.className
var Input = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].input(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  input& {\n    background: transparent;\n    border: 0;\n    border-radius: 0;\n    box-sizing: content-box;\n    color: ", ";\n    flex-grow: 1;\n    font-size: 13px;\n    line-height: 20px;\n    padding: 0;\n    ", ";\n    min-width: 145px;\n\n    /* Hides IE10+ built-in [x] clear input button */\n    &::-ms-clear {\n      display: none;\n    }\n\n    &:focus {\n      outline: none;\n    }\n\n    &::placeholder {\n      color: ", ";\n      opacity: 0.5;\n    }\n  }\n"], ["\n  input& {\n    background: transparent;\n    border: 0;\n    border-radius: 0;\n    box-sizing: content-box;\n    color: ", ";\n    flex-grow: 1;\n    font-size: 13px;\n    line-height: 20px;\n    padding: 0;\n    ", ";\n    min-width: 145px;\n\n    /* Hides IE10+ built-in [x] clear input button */\n    &::-ms-clear {\n      display: none;\n    }\n\n    &:focus {\n      outline: none;\n    }\n\n    &::placeholder {\n      color: ", ";\n      opacity: 0.5;\n    }\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N400, function (props) { return (props.width ? "width: " + props.width + "px" : ''); }, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N400);
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Container; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(76);




var Container = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  border-radius: ", "px;\n  ", " display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  padding: 4px 8px;\n  background-color: ", ";\n  ", ";\n"], ["\n  border-radius: ", "px;\n  ", " display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  padding: 4px 8px;\n  background-color: ", ";\n  ",
    ";\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])(), __WEBPACK_IMPORTED_MODULE_3__styles__["i" /* dropShadow */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N0, function (_a) {
    var height = _a.height;
    return height
        ? Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n          height: ", "px;\n        "], ["\n          height: ", "px;\n        "])), height) : '';
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getOffsetParent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNearestNonTextNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handlePositionCalculatedWith; });
var getCursorHeightFrom = function (node) {
    return parseFloat(window.getComputedStyle(node, undefined).lineHeight || '');
};
var getOffsetParent = function (editorViewDom, popupsMountPoint) {
    return popupsMountPoint
        ? popupsMountPoint.offsetParent
        : editorViewDom.offsetParent;
};
var getNearestNonTextNode = function (node) {
    return node.nodeType === Node.TEXT_NODE
        ? node.parentNode
        : node;
};
/**
 * We need to translate the co-ordinates because `coordsAtPos` returns co-ordinates
 * relative to `window`. And, also need to adjust the cursor container height.
 * (0, 0)
 * +--------------------- [window] ---------------------+
 * |   (left, top) +-------- [Offset Parent] --------+  |
 * | {coordsAtPos} | [Cursor]   <- cursorHeight      |  |
 * |               | [FloatingToolbar]               |  |
 */
var convertFixedCoordinatesToAbsolutePositioning = function (coordinates, offsetParent, cursorHeight) {
    var _a = offsetParent.getBoundingClientRect(), offsetParentLeft = _a.left, offsetParentTop = _a.top, offsetParentHeight = _a.height;
    return {
        left: coordinates.left - offsetParentLeft,
        right: coordinates.right - offsetParentLeft,
        top: coordinates.top -
            (offsetParentTop - cursorHeight) +
            offsetParent.scrollTop,
        bottom: offsetParentHeight -
            (coordinates.top -
                (offsetParentTop - cursorHeight) -
                offsetParent.scrollTop),
    };
};
var handlePositionCalculatedWith = function (offsetParent, node, getCurrentFixedCoordinates) { return function (position) {
    if (!offsetParent) {
        return position;
    }
    var target = getNearestNonTextNode(node);
    var cursorHeight = getCursorHeightFrom(target);
    var fixedCoordinates = getCurrentFixedCoordinates();
    var absoluteCoordinates = convertFixedCoordinatesToAbsolutePositioning(fixedCoordinates, offsetParent, cursorHeight);
    return {
        left: position.left ? absoluteCoordinates.left : undefined,
        right: position.right ? absoluteCoordinates.right : undefined,
        top: position.top ? absoluteCoordinates.top : undefined,
        bottom: position.bottom ? absoluteCoordinates.bottom : undefined,
    };
}; };
//# sourceMappingURL=utils.js.map

/***/ }),
/* 2448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TriggerWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


// tslint:disable-next-line:variable-name
var TriggerWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  width: 42px;\n\n  display: flex;\n  align-items: center;\n\n  > div,\n  > span {\n    display: flex;\n  }\n\n  > div > div {\n    display: flex;\n  }\n"], ["\n  width: 42px;\n\n  display: flex;\n  align-items: center;\n\n  > div,\n  > span {\n    display: flex;\n  }\n\n  > div > div {\n    display: flex;\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = insertTypeAheadQuery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__);

function insertTypeAheadQuery(trigger) {
    return function (state, dispatch) {
        if (dispatch) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["safeInsert"])(state.schema.text(trigger, [
                state.schema.marks.typeAheadQuery.create({ trigger: trigger }),
            ]))(state.tr));
        }
        return true;
    };
}
//# sourceMappingURL=insert-query.js.map

/***/ }),
/* 2450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StatusContainer */
/* unused harmony export messages */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_status__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_status___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_status__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugin__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_theme__ = __webpack_require__(3);








var B100 = __WEBPACK_IMPORTED_MODULE_7__atlaskit_theme__["colors"].B100;
var StatusContainer = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].span(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  cursor: pointer;\n\n  display: inline-block;\n  border-radius: 5px;\n  max-width: 100%;\n\n  /* Prevent responsive layouts increasing height of container by changing\n     font size and therefore line-height. */\n  line-height: 0;\n\n  opacity: ", ";\n\n  border: 2px solid ", ";\n  }\n\n  * ::selection {\n    background-color: transparent;\n  }\n"], ["\n  cursor: pointer;\n\n  display: inline-block;\n  border-radius: 5px;\n  max-width: 100%;\n\n  /* Prevent responsive layouts increasing height of container by changing\n     font size and therefore line-height. */\n  line-height: 0;\n\n  opacity: ",
    ";\n\n  border: 2px solid ",
    ";\n  }\n\n  * ::selection {\n    background-color: transparent;\n  }\n"])), function (props) {
    return props.placeholderStyle ? 0.5 : 1;
}, function (props) {
    return props.selected ? B100 : 'transparent';
});
var messages = Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["defineMessages"])({
    placeholder: {
        id: 'fabric.editor.statusPlaceholder',
        defaultMessage: 'Set a status',
        description: 'Placeholder description for an empty (new) status item in the editor',
    },
});
var StatusNodeView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](StatusNodeView, _super);
    function StatusNodeView(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelectionChange = function (newSelection, prevSelection) {
            var getPos = _this.props.getPos;
            var from = newSelection.from, to = newSelection.to;
            var statusPos = getPos();
            var selected = from <= statusPos && to > statusPos;
            if (_this.state.selected !== selected) {
                _this.setState({
                    selected: selected,
                });
            }
        };
        _this.handleClick = function (event) {
            if (event.nativeEvent.stopImmediatePropagation) {
                event.nativeEvent.stopImmediatePropagation();
            }
            var _a = _this.props.view, state = _a.state, dispatch = _a.dispatch;
            Object(__WEBPACK_IMPORTED_MODULE_6__actions__["d" /* setStatusPickerAt */])(state.selection.from)(state, dispatch);
        };
        _this.state = {
            selected: false,
        };
        return _this;
    }
    StatusNodeView.prototype.componentDidMount = function () {
        var view = this.props.view;
        var selectionChanges = __WEBPACK_IMPORTED_MODULE_5__plugin__["b" /* pluginKey */].getState(view.state).selectionChanges;
        if (selectionChanges) {
            selectionChanges.subscribe(this.handleSelectionChange);
        }
    };
    StatusNodeView.prototype.componentWillUnmount = function () {
        var view = this.props.view;
        var selectionChanges = __WEBPACK_IMPORTED_MODULE_5__plugin__["b" /* pluginKey */].getState(view.state).selectionChanges;
        if (selectionChanges) {
            selectionChanges.unsubscribe(this.handleSelectionChange);
        }
    };
    StatusNodeView.prototype.render = function () {
        var _a = this.props, _b = _a.node.attrs, text = _b.text, color = _b.color, localId = _b.localId, formatMessage = _a.intl.formatMessage;
        var selected = this.state.selected;
        var statusText = text ? text : formatMessage(messages.placeholder);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](StatusContainer, { selected: selected, placeholderStyle: !text },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_status__["Status"], { text: statusText, color: color, localId: localId, onClick: this.handleClick })));
    };
    return StatusNodeView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["injectIntl"])(StatusNodeView));
var templateObject_1;
//# sourceMappingURL=status.js.map

/***/ }),
/* 2451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var react_1 = __webpack_require__(0);
var lozenge_1 = __webpack_require__(98);
var analytics_next_1 = __webpack_require__(29);
var analytics_1 = __webpack_require__(2452);
var constants_1 = __webpack_require__(832);
var colorToLozengeAppearanceMap = {
    neutral: 'default',
    purple: 'new',
    blue: 'inprogress',
    red: 'removed',
    yellow: 'moved',
    green: 'success',
};
var DEFAULT_APPEARANCE = 'default';
var MAX_WIDTH = 200;
var StatusInternal = /** @class */ (function (_super) {
    tslib_1.__extends(StatusInternal, _super);
    function StatusInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hoverStartTime = 0;
        _this.handleMouseEnter = function (e) {
            _this.hoverStartTime = Date.now();
        };
        _this.handleMouseLeave = function (e) {
            var onHover = _this.props.onHover;
            var delay = Date.now() - _this.hoverStartTime;
            if (delay >= constants_1.ANALYTICS_HOVER_DELAY && onHover) {
                onHover();
            }
            _this.hoverStartTime = 0;
        };
        return _this;
    }
    StatusInternal.prototype.componentWillUnmount = function () {
        this.hoverStartTime = 0;
    };
    StatusInternal.prototype.render = function () {
        var _a = this.props, text = _a.text, color = _a.color, onClick = _a.onClick;
        if (text.trim().length === 0) {
            return null;
        }
        var appearance = colorToLozengeAppearanceMap[color] || DEFAULT_APPEARANCE;
        return (React.createElement("span", { className: "status-lozenge-span", onClick: onClick, onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave },
            React.createElement(lozenge_1.default, { appearance: appearance, maxWidth: MAX_WIDTH }, text)));
    };
    return StatusInternal;
}(react_1.PureComponent));
// tslint:disable-next-line:variable-name
exports.Status = analytics_next_1.withAnalyticsEvents({
    onClick: function (createEvent, props) {
        var localId = props.localId;
        return analytics_1.createStatusAnalyticsAndFire(createEvent)({
            action: 'clicked',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId,
            },
        });
    },
    onHover: function (createEvent, props) {
        var localId = props.localId;
        return analytics_1.createStatusAnalyticsAndFire(createEvent)({
            action: 'hovered',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId,
            },
        });
    },
})(StatusInternal);
//# sourceMappingURL=Status.js.map

/***/ }),
/* 2452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var package_json_1 = __webpack_require__(2453);
exports.ELEMENTS_CHANNEL = 'fabric-elements';
exports.createStatusAnalyticsAndFire = function (createAnalyticsEvent) { return function (payload) {
    var statusPayload = tslib_1.__assign({}, payload, { eventType: 'ui' });
    if (!statusPayload.attributes) {
        statusPayload.attributes = {};
    }
    statusPayload.attributes.packageName = package_json_1.name;
    statusPayload.attributes.packageVersion = package_json_1.version;
    statusPayload.attributes.componentName = 'status';
    var event = createAnalyticsEvent(statusPayload);
    event.fire(exports.ELEMENTS_CHANNEL);
    return event;
}; };
//# sourceMappingURL=analytics.js.map

/***/ }),
/* 2453 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/status","version":"0.3.0"}

/***/ }),
/* 2454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var react_1 = __webpack_require__(0);
var styled_components_1 = __webpack_require__(2);
var theme_1 = __webpack_require__(3);
var field_text_1 = __webpack_require__(1392);
var color_palette_1 = __webpack_require__(2455);
var FieldTextWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin: 0 ", "px;\n"], ["\n  margin: 0 ", "px;\n"])), theme_1.gridSize());
var StatusPicker = /** @class */ (function (_super) {
    tslib_1.__extends(StatusPicker, _super);
    function StatusPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fieldTextWrapperKey = Math.random().toString();
        _this.colorPaletteKey = Math.random().toString();
        _this.onChange = function (evt) {
            // @ts-ignore
            _this.props.onTextChanged(evt.target.value);
        };
        _this.onKeyPress = function (event) {
            if (event.key === 'Enter') {
                _this.props.onEnter();
            }
        };
        _this.handleInputRef = function (ref) {
            if (ref && _this.props.autoFocus) {
                // Defer to prevent editor scrolling to top (See FS-3227, also ED-2992)
                setTimeout(function () {
                    ref.focus();
                });
            }
        };
        return _this;
    }
    StatusPicker.prototype.render = function () {
        var _a = this.props, text = _a.text, selectedColor = _a.selectedColor, onColorClick = _a.onColorClick, onColorHover = _a.onColorHover;
        // Using <React.Fragment> instead of [] to workaround Enzyme
        // (https://github.com/airbnb/enzyme/issues/1149)
        return (React.createElement(React.Fragment, null,
            React.createElement(FieldTextWrapper, { key: this.fieldTextWrapperKey },
                React.createElement(field_text_1.FieldTextStateless, { value: text, isLabelHidden: true, shouldFitContainer: true, onChange: this.onChange, onKeyPress: this.onKeyPress, compact: true, innerRef: this.handleInputRef })),
            React.createElement(color_palette_1.default, { key: this.colorPaletteKey, onClick: onColorClick, onHover: onColorHover, selectedColor: selectedColor })));
    };
    StatusPicker.defaultProps = {
        autoFocus: true,
    };
    return StatusPicker;
}(react_1.PureComponent));
exports.StatusPicker = StatusPicker;
var templateObject_1;
//# sourceMappingURL=StatusPicker.js.map

/***/ }),
/* 2455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var theme_1 = __webpack_require__(3);
var React = __webpack_require__(0);
var styled_components_1 = __webpack_require__(2);
var color_1 = __webpack_require__(2456);
// color value, label, background, borderColor
var palette = [
    ['neutral', theme_1.colors.N40, theme_1.colors.N400],
    ['purple', theme_1.colors.P50, theme_1.colors.P400],
    ['blue', theme_1.colors.B50, theme_1.colors.B400],
    ['red', theme_1.colors.R50, theme_1.colors.R400],
    ['yellow', theme_1.colors.Y75, theme_1.colors.Y400],
    ['green', theme_1.colors.G50, theme_1.colors.G400],
];
var ColorPaletteWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin: ", "px ", "px 0 ", "px;\n  /* Firefox bug fix: https://product-fabric.atlassian.net/browse/ED-1789 */\n  display: flex;\n  flex-wrap: wrap;\n"], ["\n  margin: ", "px ", "px 0 ", "px;\n  /* Firefox bug fix: https://product-fabric.atlassian.net/browse/ED-1789 */\n  display: flex;\n  flex-wrap: wrap;\n"])), theme_1.gridSize(), theme_1.gridSize(), theme_1.gridSize());
exports.default = (function (_a) {
    var _b = _a.cols, cols = _b === void 0 ? 7 : _b, onClick = _a.onClick, selectedColor = _a.selectedColor, className = _a.className, onHover = _a.onHover;
    return (React.createElement(ColorPaletteWrapper, { className: className, style: { maxWidth: cols * 32 } }, palette.map(function (_a) {
        var _b = tslib_1.__read(_a, 3), colorValue = _b[0], backgroundColor = _b[1], borderColor = _b[2];
        return (React.createElement(color_1.default, { key: colorValue, value: colorValue, backgroundColor: backgroundColor, borderColor: borderColor, onClick: onClick, onHover: onHover, isSelected: colorValue === selectedColor }));
    })));
});
var templateObject_1;
//# sourceMappingURL=color-palette.js.map

/***/ }),
/* 2456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var done_1 = __webpack_require__(2457);
var theme_1 = __webpack_require__(3);
var React = __webpack_require__(0);
var react_1 = __webpack_require__(0);
var react_intl_1 = __webpack_require__(17);
var styled_components_1 = __webpack_require__(2);
var constants_1 = __webpack_require__(832);
var i18n_1 = __webpack_require__(2460);
var Button = styled_components_1.default.button(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  height: 24px;\n  width: 24px;\n  background: ", ";\n  padding: 0;\n  border-radius: 4px;\n  border: 1px solid ", ";\n  cursor: pointer;\n  display: block;\n  box-sizing: border-box;\n"], ["\n  height: 24px;\n  width: 24px;\n  background: ", ";\n  padding: 0;\n  border-radius: 4px;\n  border: 1px solid ", ";\n  cursor: pointer;\n  display: block;\n  box-sizing: border-box;\n"])), theme_1.colors.N900, theme_1.colors.N0);
var ButtonWrapper = styled_components_1.default.span(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  border: 1px solid transparent;\n  margin: 0 2px;\n  font-size: 0;\n  display: flex;\n  align-items: center;\n  padding: 1px;\n  border-radius: 6px;\n  &:hover {\n    border: 1px solid ", ";\n  }\n"], ["\n  border: 1px solid transparent;\n  margin: 0 2px;\n  font-size: 0;\n  display: flex;\n  align-items: center;\n  padding: 1px;\n  border-radius: 6px;\n  &:hover {\n    border: 1px solid ", ";\n  }\n"])), theme_1.colors.N50);
var Color = /** @class */ (function (_super) {
    tslib_1.__extends(Color, _super);
    function Color() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hoverStartTime = 0;
        _this.onMouseEnter = function () {
            _this.hoverStartTime = Date.now();
        };
        _this.onMouseLeave = function () {
            var onHover = _this.props.onHover;
            var delay = Date.now() - _this.hoverStartTime;
            if (delay >= constants_1.ANALYTICS_HOVER_DELAY && onHover) {
                onHover(_this.props.value);
            }
            _this.hoverStartTime = 0;
        };
        _this.onMouseDown = function (e) {
            e.preventDefault();
        };
        _this.onClick = function (e) {
            var _a = _this.props, onClick = _a.onClick, value = _a.value;
            e.preventDefault();
            onClick(value);
        };
        return _this;
    }
    Color.prototype.render = function () {
        var _this = this;
        var _a = this.props, tabIndex = _a.tabIndex, backgroundColor = _a.backgroundColor, isSelected = _a.isSelected, borderColor = _a.borderColor, value = _a.value;
        var borderStyle = "1px solid " + borderColor;
        return (React.createElement(ButtonWrapper, null,
            React.createElement(react_intl_1.FormattedMessage, tslib_1.__assign({}, i18n_1.messages[value + "Color"]), function (label) { return (React.createElement(Button, { onClick: _this.onClick, onMouseEnter: _this.onMouseEnter, onMouseLeave: _this.onMouseLeave, onMouseDown: _this.onMouseDown, tabIndex: tabIndex, className: "" + (isSelected ? 'selected' : ''), title: label, style: {
                    backgroundColor: backgroundColor || 'transparent',
                    border: borderStyle,
                } }, isSelected && (React.createElement(done_1.default, { primaryColor: borderColor, label: label })))); })));
    };
    Color.prototype.componentWillUnmount = function () {
        this.hoverStartTime = 0;
    };
    return Color;
}(react_1.PureComponent));
exports.default = Color;
var templateObject_1, templateObject_2;
//# sourceMappingURL=color.js.map

/***/ }),
/* 2457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(2458));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorDoneIcon = function EditorDoneIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.501.501 0 0 0-.003.71l3.706 3.707a.501.501 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0l-2.288-2.287z\" fill=\"currentColor\"/></svg>"
  }, props));
};

EditorDoneIcon.displayName = 'EditorDoneIcon';
var _default = EditorDoneIcon;
exports.default = _default;

/***/ }),
/* 2458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(54);

var _interopRequireDefault = __webpack_require__(53);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.size = exports.default = exports.IconWrapper = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(4));

var _createClass2 = _interopRequireDefault(__webpack_require__(5));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(7));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(6));

var _inherits2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _styledComponents = _interopRequireDefault(__webpack_require__(2));

var _uuid = _interopRequireDefault(__webpack_require__(22));

var _theme = __webpack_require__(3);

var _constants = __webpack_require__(2459);

var getSize = function getSize(props) {
  if (props.size) {
    return "height: ".concat(_constants.sizes[props.size], "; width: ").concat(_constants.sizes[props.size], ";");
  }

  return null;
};

var IconWrapper = _styledComponents.default.span.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "dyhwwi-0"
})(["\n  ", " color: ", ";\n  display: inline-block;\n  fill: ", ";\n  flex-shrink: 0;\n  line-height: 1;\n\n  > svg {\n    ", " max-height: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    pointer-events: none;\n    vertical-align: bottom;\n  }\n  /* Stop-color doesn't properly apply in chrome when the inherited/current color changes.\n   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS\n   * rule) and then override it with currentColor for the color changes to be picked up.\n   */\n  stop {\n    stop-color: currentColor;\n  }\n"], getSize, function (p) {
  return p.primaryColor || 'currentColor';
}, function (p) {
  return p.secondaryColor || _theme.colors.background;
}, getSize);

exports.IconWrapper = IconWrapper;

var Icon =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Icon, _Component);

  function Icon() {
    (0, _classCallCheck2.default)(this, Icon);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Icon).apply(this, arguments));
  }

  (0, _createClass2.default)(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Glyph = _this$props.glyph,
          dangerouslySetGlyph = _this$props.dangerouslySetGlyph,
          onClick = _this$props.onClick,
          primaryColor = _this$props.primaryColor,
          secondaryColor = _this$props.secondaryColor,
          size = _this$props.size; // handling the glyphs as strings

      if (dangerouslySetGlyph) {
        return _react.default.createElement(IconWrapper, {
          onClick: onClick,
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          size: size,
          "aria-label": this.props.label,
          dangerouslySetInnerHTML: {
            __html: Icon.insertDynamicGradientID(dangerouslySetGlyph)
          }
        });
      } // handling the glyphs when passed through as functions


      return _react.default.createElement(IconWrapper, {
        onClick: onClick,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        "aria-label": this.props.label
      }, Glyph ? _react.default.createElement(Glyph, {
        role: "presentation"
      }) : null);
    }
  }], [{
    key: "insertDynamicGradientID",

    /* Icons need unique gradient IDs across instances for different gradient definitions to work
     * correctly.
     * A step in the icon build process replaces linear gradient IDs and their references in paths
     * to a placeholder string so we can replace them with a dynamic ID here.
     * Replacing the original IDs with placeholders in the build process is more robust than not
     * using placeholders as we do not have to rely on regular expressions to find specific element
     * to replace.
     */
    value: function insertDynamicGradientID(svgStr) {
      var id = (0, _uuid.default)();
      var replacedSvgStr = svgStr.replace(/id="([^"]+)-idPlaceholder"/g, "id=$1-".concat(id)).replace(/fill="url\(#([^"]+)-idPlaceholder\)"/g, "fill=\"url(#$1-".concat(id, ")\""));
      return replacedSvgStr;
    }
  }]);
  return Icon;
}(_react.Component);

exports.default = Icon;
(0, _defineProperty2.default)(Icon, "defaultProps", {
  onClick: function onClick() {}
});
var size = Object.keys(_constants.sizes).reduce(function (p, c) {
  return Object.assign(p, (0, _defineProperty2.default)({}, c, c));
}, {});
exports.size = size;

/***/ }),
/* 2459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = void 0;
var sizes = {
  small: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '48px'
};
exports.sizes = sizes;

/***/ }),
/* 2460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = __webpack_require__(17);
exports.messages = react_intl_1.defineMessages({
    neutralColor: {
        id: 'fabric.status.color.grey',
        defaultMessage: 'Grey',
        description: 'Tooltip for the grey color in color palette',
    },
    purpleColor: {
        id: 'fabric.status.color.purple',
        defaultMessage: 'Purple',
        description: 'Tooltip for the purple color in color palette',
    },
    blueColor: {
        id: 'fabric.status.color.blue',
        defaultMessage: 'Blue',
        description: 'Tooltip for the blue color in color palette',
    },
    redColor: {
        id: 'fabric.status.color.red',
        defaultMessage: 'Red',
        description: 'Tooltip for the red color in color palette',
    },
    yellowColor: {
        id: 'fabric.status.color.yellow',
        defaultMessage: 'Yellow',
        description: 'Tooltip for the yellow color in color palette',
    },
    greenColor: {
        id: 'fabric.status.color.green',
        defaultMessage: 'Green',
        description: 'Tooltip for the green color in color palette',
    },
});
//# sourceMappingURL=i18n.js.map

/***/ }),
/* 2461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export keymapPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keymaps__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugin__ = __webpack_require__(289);




function keymapPlugin(schema) {
    var list = {};
    __WEBPACK_IMPORTED_MODULE_2__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_2__keymaps__["k" /* enter */].common, function (state, dispatch) {
        var datePlugin = __WEBPACK_IMPORTED_MODULE_3__plugin__["b" /* pluginKey */].getState(state);
        if (!datePlugin.showDatePickerAt) {
            return false;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__actions__["a" /* closeDatePicker */])()(state, dispatch);
        return true;
    }, list);
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__["keymap"])(list);
}
/* harmony default export */ __webpack_exports__["a"] = (keymapPlugin);
//# sourceMappingURL=keymap.js.map

/***/ }),
/* 2462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_emoji__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_emoji___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_emoji__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__insert_block_ui_ToolbarInsertBlock__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pm_plugins_main__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pm_plugins_input_rules__ = __webpack_require__(2465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pm_plugins_keymap__ = __webpack_require__(2466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pm_plugins_ascii_input_rules__ = __webpack_require__(2467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_ToolbarEmojiPicker__ = __webpack_require__(2468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_EmojiTypeAhead__ = __webpack_require__(2470);











var emojiPlugin = {
    nodes: function () {
        return [{ name: 'emoji', node: __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__["A" /* emoji */] }];
    },
    marks: function () {
        return [{ name: 'emojiQuery', mark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__["B" /* emojiQuery */] }];
    },
    pmPlugins: function () {
        return [
            {
                name: 'emoji',
                plugin: function (_a) {
                    var providerFactory = _a.providerFactory, portalProviderAPI = _a.portalProviderAPI;
                    return Object(__WEBPACK_IMPORTED_MODULE_5__pm_plugins_main__["a" /* createPlugin */])(portalProviderAPI, providerFactory);
                },
            },
            {
                name: 'emojiInputRule',
                plugin: function (_a) {
                    var schema = _a.schema;
                    return Object(__WEBPACK_IMPORTED_MODULE_6__pm_plugins_input_rules__["a" /* default */])(schema);
                },
            },
            { name: 'emojiKeymap', plugin: function (_a) {
                    var schema = _a.schema;
                    return Object(__WEBPACK_IMPORTED_MODULE_7__pm_plugins_keymap__["a" /* default */])(schema);
                } },
            {
                name: 'emojiAsciiInputRule',
                plugin: function (_a) {
                    var schema = _a.schema, providerFactory = _a.providerFactory;
                    return Object(__WEBPACK_IMPORTED_MODULE_8__pm_plugins_ascii_input_rules__["a" /* inputRulePlugin */])(schema, providerFactory);
                },
            },
        ];
    },
    contentComponent: function (_a) {
        var editorView = _a.editorView, providerFactory = _a.providerFactory, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, popupsScrollableElement = _a.popupsScrollableElement;
        var renderNode = function (providers) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ui_EmojiTypeAhead__["a" /* default */], { editorView: editorView, pluginKey: __WEBPACK_IMPORTED_MODULE_5__pm_plugins_main__["b" /* emojiPluginKey */], emojiProvider: providers.emojiProvider, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement }));
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["j" /* WithProviders */], { providerFactory: providerFactory, providers: ['emojiProvider'], renderNode: renderNode }));
    },
    secondaryToolbarComponent: function (_a) {
        var editorView = _a.editorView, eventDispatcher = _a.eventDispatcher, providerFactory = _a.providerFactory, appearance = _a.appearance, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, popupsScrollableElement = _a.popupsScrollableElement, disabled = _a.disabled;
        var renderNode = function (providers) {
            // numFollowingButtons must be changed if buttons are added after ToolbarEmojiPicker to the message editor
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ui_ToolbarEmojiPicker__["a" /* default */], { editorView: editorView, pluginKey: __WEBPACK_IMPORTED_MODULE_5__pm_plugins_main__["b" /* emojiPluginKey */], emojiProvider: providers.emojiProvider, numFollowingButtons: 4, isReducedSpacing: true, isDisabled: disabled, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }));
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["j" /* WithProviders */], { providerFactory: providerFactory, providers: ['emojiProvider'], renderNode: renderNode }));
    },
    pluginsOptions: {
        quickInsert: function (_a) {
            var formatMessage = _a.formatMessage;
            return [
                {
                    title: formatMessage(__WEBPACK_IMPORTED_MODULE_4__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].emoji),
                    priority: 500,
                    icon: function () { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_emoji___default.a, { label: formatMessage(__WEBPACK_IMPORTED_MODULE_4__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].emoji) }); },
                    action: function (insert, state) {
                        var mark = state.schema.mark('emojiQuery');
                        var emojiText = state.schema.text(':', [mark]);
                        return insert(emojiText);
                    },
                },
            ];
        },
    },
};
/* harmony default export */ __webpack_exports__["a"] = (emojiPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Emoji__ = __webpack_require__(2464);




// tslint:disable-next-line:variable-name
var Wrapper = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  user-select: all;\n"], ["\n  user-select: all;\n"])));
var EmojiNode = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiNode, _super);
    function EmojiNode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmojiNode.prototype.render = function () {
        var _a = this.props, node = _a.node, providerFactory = _a.providerFactory;
        var _b = node.attrs, shortName = _b.shortName, id = _b.id, text = _b.text;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Wrapper, null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ui_Emoji__["a" /* default */], { providers: providerFactory, id: id, shortName: shortName, fallback: text })));
    };
    return EmojiNode;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (EmojiNode);
var templateObject_1;
//# sourceMappingURL=emoji.js.map

/***/ }),
/* 2464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_emoji__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);





var EmojiNode = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiNode, _super);
    function EmojiNode(props) {
        var _this = _super.call(this, props) || this;
        _this.renderWithProvider = function (providers) {
            var _a = _this.props, allowTextFallback = _a.allowTextFallback, shortName = _a.shortName, id = _a.id, fallback = _a.fallback, fitToHeight = _a.fitToHeight;
            if (allowTextFallback && !providers.emojiProvider) {
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, fallback || shortName);
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_emoji__["c" /* ResourcedEmoji */], { emojiId: { id: id, fallback: fallback, shortName: shortName }, emojiProvider: providers.emojiProvider, showTooltip: true, fitToHeight: fitToHeight }));
        };
        _this.providerFactory = props.providers || new __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["f" /* ProviderFactory */]();
        return _this;
    }
    EmojiNode.prototype.componentWillUnmount = function () {
        if (!this.props.providers) {
            // new ProviderFactory is created if no `providers` has been set
            // in this case when component is unmounted it's safe to destroy this providerFactory
            this.providerFactory.destroy();
        }
    };
    EmojiNode.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["j" /* WithProviders */], { providers: ['emojiProvider'], providerFactory: this.providerFactory, renderNode: this.renderWithProvider }));
    };
    return EmojiNode;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (EmojiNode);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export inputRulePlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_input_rules__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(292);



function inputRulePlugin(schema) {
    var rules = [];
    if (schema.nodes.emoji && schema.marks.emojiQuery) {
        var regex = new RegExp("(^|[\\s(" + __WEBPACK_IMPORTED_MODULE_1__utils_input_rules__["c" /* leafNodeReplacementCharacter */] + "]):$");
        var emojiQueryRule = Object(__WEBPACK_IMPORTED_MODULE_1__utils_input_rules__["a" /* createInputRule */])(regex, function (state, match, start, end) {
            var emojisState = __WEBPACK_IMPORTED_MODULE_2__main__["b" /* emojiPluginKey */].getState(state);
            if (!emojisState.emojiProvider) {
                return null;
            }
            if (!emojisState.isEnabled()) {
                return null;
            }
            var mark = schema.mark('emojiQuery');
            var tr = state.tr;
            var emojiText = schema.text(':', [mark]);
            return tr.replaceSelectionWith(emojiText, false);
        });
        rules.push(emojiQueryRule);
    }
    if (rules.length !== 0) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["inputRules"])({ rules: rules });
    }
}
/* harmony default export */ __webpack_exports__["a"] = (inputRulePlugin);
//# sourceMappingURL=input-rules.js.map

/***/ }),
/* 2466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export keymapPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keymaps__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(292);



function keymapPlugin(schema) {
    var list = {};
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["x" /* moveUp */].common, function (state, dispatch) {
        var emojisPlugin = __WEBPACK_IMPORTED_MODULE_2__main__["b" /* emojiPluginKey */].getState(state);
        if (!emojisPlugin.queryActive) {
            return false;
        }
        return emojisPlugin.onSelectPrevious();
    }, list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["u" /* moveDown */].common, function (state, dispatch) {
        var emojisPlugin = __WEBPACK_IMPORTED_MODULE_2__main__["b" /* emojiPluginKey */].getState(state);
        if (!emojisPlugin.queryActive) {
            return false;
        }
        return emojisPlugin.onSelectNext();
    }, list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["k" /* enter */].common, function (state, dispatch) {
        var emojisPlugin = __WEBPACK_IMPORTED_MODULE_2__main__["b" /* emojiPluginKey */].getState(state);
        if (!emojisPlugin.queryActive) {
            return false;
        }
        return emojisPlugin.onSelectCurrent(__WEBPACK_IMPORTED_MODULE_1__keymaps__["k" /* enter */].common);
    }, list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["s" /* insertNewLine */].common, function (state, dispatch) {
        var emojisPlugin = __WEBPACK_IMPORTED_MODULE_2__main__["b" /* emojiPluginKey */].getState(state);
        if (!emojisPlugin.queryActive) {
            return false;
        }
        emojisPlugin.onSelectCurrent(__WEBPACK_IMPORTED_MODULE_1__keymaps__["s" /* insertNewLine */].common);
        return false;
    }, list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["I" /* tab */].common, function (state, dispatch) {
        var emojisPlugin = __WEBPACK_IMPORTED_MODULE_2__main__["b" /* emojiPluginKey */].getState(state);
        if (!emojisPlugin.queryActive) {
            return false;
        }
        return emojisPlugin.onSelectCurrent(__WEBPACK_IMPORTED_MODULE_1__keymaps__["I" /* tab */].common);
    }, list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["l" /* escape */].common, function (state, dispatch) {
        var emojisPlugin = __WEBPACK_IMPORTED_MODULE_2__main__["b" /* emojiPluginKey */].getState(state);
        if (!emojisPlugin.queryActive) {
            return false;
        }
        /**
         * Jira uses escape to toggle the collapsed editor
         * stop the event propagation when the picker is open
         */
        if (window.event) {
            window.event.stopPropagation();
        }
        return emojisPlugin.dismiss();
    }, list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["G" /* space */].common, function (state, dispatch) {
        var emojisPlugin = __WEBPACK_IMPORTED_MODULE_2__main__["b" /* emojiPluginKey */].getState(state);
        if (!emojisPlugin.queryActive) {
            return false;
        }
        return emojisPlugin.trySelectCurrentWithSpace(__WEBPACK_IMPORTED_MODULE_1__keymaps__["G" /* space */].common);
    }, list);
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__["keymap"])(list);
}
/* harmony default export */ __webpack_exports__["a"] = (keymapPlugin);
//# sourceMappingURL=keymap.js.map

/***/ }),
/* 2467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = inputRulePlugin;
/* unused harmony export stateKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_input_rules__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(21);





var matcher;
function inputRulePlugin(schema, providerFactory) {
    if (schema.nodes.emoji && providerFactory) {
        initMatcher(providerFactory);
        var asciiEmojiRule = Object(__WEBPACK_IMPORTED_MODULE_3__utils_input_rules__["a" /* createInputRule */])(AsciiEmojiMatcher.REGEX, inputRuleHandler);
        return Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules__["inputRules"])({
            rules: [asciiEmojiRule],
        });
    }
}
function initMatcher(providerFactory) {
    var handleProvider = function (name, provider) {
        if (!provider) {
            return;
        }
        provider.then(function (emojiProvider) {
            emojiProvider.getAsciiMap().then(function (map) {
                matcher = new RecordingAsciiEmojiMatcher(emojiProvider, map);
            });
        });
    };
    providerFactory.subscribe('emojiProvider', handleProvider);
}
function inputRuleHandler(state, matchParts, start, end) {
    if (!matcher) {
        return null;
    }
    if (!isEnabled(state)) {
        return null;
    }
    var match = matcher.match(matchParts);
    if (match) {
        var transactionCreator = new AsciiEmojiTransactionCreator(state, match, start, end);
        return transactionCreator.create();
    }
    return null;
}
function isEnabled(state) {
    var emojiQuery = state.schema.marks.emojiQuery;
    var isEmojiQueryActive = state.selection.$from
        .marks()
        .some(function (mark) { return mark.type === emojiQuery; });
    return (isEmojiQueryActive || Object(__WEBPACK_IMPORTED_MODULE_4__utils__["y" /* isMarkTypeAllowedInCurrentSelection */])(emojiQuery, state));
}
var REGEX_LEADING_CAPTURE_INDEX = 1;
var REGEX_EMOJI_LEADING_PARENTHESES = 2;
var REGEX_EMOJI_ASCII_CAPTURE_INDEX = 3;
var REGEX_TRAILING_CAPTURE_INDEX = 4;
var getLeadingString = function (match, withParenthesis) {
    if (withParenthesis === void 0) { withParenthesis = true; }
    return match[REGEX_LEADING_CAPTURE_INDEX] +
        (withParenthesis ? match[REGEX_EMOJI_LEADING_PARENTHESES] : '');
};
var getLeadingStringWithoutParentheses = function (match) {
    return getLeadingString(match, false);
};
var getAscii = function (match, withParentheses) {
    if (withParentheses === void 0) { withParentheses = false; }
    return (withParentheses ? match[REGEX_EMOJI_LEADING_PARENTHESES] : '') +
        match[REGEX_EMOJI_ASCII_CAPTURE_INDEX].trim();
};
var getAsciiWithParentheses = function (matchParts) {
    return getAscii(matchParts, true);
};
var getTrailingString = function (match) {
    return match[REGEX_TRAILING_CAPTURE_INDEX] || '';
};
var AsciiEmojiMatcher = /** @class */ (function () {
    function AsciiEmojiMatcher(asciiToEmojiMap) {
        this.asciiToEmojiMap = asciiToEmojiMap;
    }
    AsciiEmojiMatcher.prototype.match = function (matchParts) {
        return (this.getAsciiEmojiMatch(getLeadingStringWithoutParentheses(matchParts), getAsciiWithParentheses(matchParts), getTrailingString(matchParts)) ||
            this.getAsciiEmojiMatch(getLeadingString(matchParts), getAscii(matchParts), getTrailingString(matchParts)));
    };
    AsciiEmojiMatcher.prototype.getAsciiEmojiMatch = function (leading, ascii, trailing) {
        var emoji = this.asciiToEmojiMap.get(ascii);
        return emoji
            ? {
                emoji: emoji,
                leadingString: leading,
                trailingString: trailing,
            }
            : undefined;
    };
    /**
     * This regex matches 2 scenarios:
     * 1. an emoticon starting with a colon character (e.g. :D => 😃)
     * 2. an emoticon not starting with a colon character (e.g. 8-D => 😎)
     *
     * Explanation (${leafNodeReplacementCharacter} is replaced with character \ufffc)
     *
     *  1st Capturing Group ((?:^|[\s\ufffc])(?:\(*?))
     *    Non-capturing group (?:^|[\s\ufffc])
     *      1st Alternative ^
     *        ^ asserts position at start of the string
     *      2nd Alternative [\s\ufffc]
     *        matches a single character present in [\s\ufffc]
     *    Non-capturing group (?:\(*?)
     *      matches the character ( literally between zero and unlimited times, as few times as possible, expanding as needed (lazy)
     *  2nd Capturing Group (\(?)
     *    matches a single ( if present
     *  3rd Capturing Group ([^:\s\ufffc\(]\S{1,3}|:\S{1,3}( ))
     *    1st Alternative [^:\s\ufffc\(]\S{1,3}
     *      matches a single character not present in [^:\s\ufffc\(] between 1 and 3 times, as many times as possible, giving back as needed (greedy)
     *    2nd Alternative :\S{1,3}( )
     *      : matches the character : literally
     *      \S{1,3} matches any non-whitespace character between 1 and 3 times, as many times as possible, giving back as needed (greedy)
     *  4th Capturing Group ( )
     *
     * See https://regex101.com/r/HRS9O2/4
     */
    AsciiEmojiMatcher.REGEX = new RegExp("((?:^|[\\s" + __WEBPACK_IMPORTED_MODULE_3__utils_input_rules__["c" /* leafNodeReplacementCharacter */] + "])(?:\\(*?))(\\(?)([^:\\s" + __WEBPACK_IMPORTED_MODULE_3__utils_input_rules__["c" /* leafNodeReplacementCharacter */] + "\\(]\\S{1,3}|:\\S{1,3}( ))$");
    return AsciiEmojiMatcher;
}());
/**
 * A matcher that will record ascii matches as usages of the matched emoji.
 */
var RecordingAsciiEmojiMatcher = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](RecordingAsciiEmojiMatcher, _super);
    function RecordingAsciiEmojiMatcher(emojiProvider, asciiToEmojiMap) {
        var _this = _super.call(this, asciiToEmojiMap) || this;
        _this.emojiProvider = emojiProvider;
        return _this;
    }
    RecordingAsciiEmojiMatcher.prototype.match = function (matchParts) {
        var match = _super.prototype.match.call(this, matchParts);
        if (match && this.emojiProvider.recordSelection) {
            this.emojiProvider.recordSelection(match.emoji);
        }
        return match;
    };
    return RecordingAsciiEmojiMatcher;
}(AsciiEmojiMatcher));
var AsciiEmojiTransactionCreator = /** @class */ (function () {
    function AsciiEmojiTransactionCreator(state, match, start, end) {
        this.state = state;
        this.match = match;
        this.start = start;
        this.end = end;
    }
    AsciiEmojiTransactionCreator.prototype.create = function () {
        return this.state.tr.replaceWith(this.from, this.to, this.createNodes());
    };
    Object.defineProperty(AsciiEmojiTransactionCreator.prototype, "from", {
        get: function () {
            return this.start + this.match.leadingString.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AsciiEmojiTransactionCreator.prototype, "to", {
        get: function () {
            return this.end;
        },
        enumerable: true,
        configurable: true
    });
    AsciiEmojiTransactionCreator.prototype.createNodes = function () {
        var nodes = [this.createEmojiNode()];
        if (this.trailingTextNodeRequired()) {
            nodes.push(this.createTrailingTextNode());
        }
        return nodes;
    };
    AsciiEmojiTransactionCreator.prototype.createEmojiNode = function () {
        var emojiTypeNode = this.state.schema.nodes.emoji;
        return emojiTypeNode.create(this.getEmojiNodeAttrs());
    };
    AsciiEmojiTransactionCreator.prototype.getEmojiNodeAttrs = function () {
        var emoji = this.match.emoji;
        return {
            id: emoji.id,
            shortName: emoji.shortName,
            text: emoji.fallback || emoji.shortName,
        };
    };
    AsciiEmojiTransactionCreator.prototype.trailingTextNodeRequired = function () {
        return this.match.trailingString.length > 0;
    };
    AsciiEmojiTransactionCreator.prototype.createTrailingTextNode = function () {
        return this.state.schema.text(this.match.trailingString);
    };
    return AsciiEmojiTransactionCreator;
}());
var stateKey = new __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["PluginKey"]('asciiEmojiPlugin');
var plugins = function (schema, providerFactory) {
    return [inputRulePlugin(schema, providerFactory)].filter(function (plugin) { return !!plugin; });
};
/* unused harmony default export */ var _unused_webpack_default_export = (plugins);
//# sourceMappingURL=ascii-input-rules.js.map

/***/ }),
/* 2468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_emoji__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_emoji___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_emoji__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_emoji__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_ToolbarButton__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(2469);










/**
 * Checks if an element is detached (i.e. not in the current document)
 */
var isDetachedElement = function (el) { return !document.body.contains(el); };
var ToolbarEmojiPicker = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ToolbarEmojiPicker, _super);
    function ToolbarEmojiPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false,
        };
        _this.handleEscape = function (e) {
            // ESC key pressed
            if (_this.state.isOpen && (e.which === 27 || e.keyCode === 27)) {
                _this.close();
            }
        };
        _this.handlePluginStateChange = function (pluginState) {
            var disabled = !pluginState.isEnabled();
            var newState = {
                disabled: disabled,
            };
            if (disabled) {
                // Ensure closed if disabled, so it does reappear later
                newState.isOpen = false;
            }
            _this.setState(newState);
        };
        _this.handleButtonRef = function (ref) {
            _this.buttonRef = ref ? ref : null;
        };
        _this.onPickerRef = function (ref) {
            if (ref) {
                document.addEventListener('click', _this.handleClickOutside);
            }
            else {
                document.removeEventListener('click', _this.handleClickOutside);
            }
            _this.pickerRef = ref;
        };
        _this.close = function () {
            _this.setState({
                isOpen: false,
            });
        };
        _this.toggleOpen = function () {
            var isOpen = _this.state.isOpen;
            _this.setState({
                isOpen: !isOpen,
            });
        };
        _this.handleClickOutside = function (e) {
            var picker = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](_this.pickerRef);
            // Ignore click events for detached elements.
            // Workaround for FS-1322 - where two onClicks fire - one when the upload button is
            // still in the document, and one once it's detached. Does not always occur, and
            // may be a side effect of a react render optimisation
            if (!picker ||
                (!isDetachedElement(e.target) && !picker.contains(e.target))) {
                _this.close();
            }
        };
        _this.handleSelectedEmoji = Object(__WEBPACK_IMPORTED_MODULE_6__analytics__["c" /* withAnalytics */])('atlassian.editor.emoji.button', function (emojiId) {
            if (_this.state.isOpen && _this.pluginState) {
                _this.pluginState.insertEmoji(emojiId);
                _this.close();
                return true;
            }
            return false;
        });
        return _this;
    }
    ToolbarEmojiPicker.prototype.componentWillMount = function () {
        this.setPluginState(this.props);
    };
    ToolbarEmojiPicker.prototype.componentDidMount = function () {
        this.state.button = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](this.buttonRef);
        if (this.pluginState) {
            this.pluginState.subscribe(this.handlePluginStateChange);
        }
        // Keymapping must be added here at the document level as editor focus is lost
        // when the picker opens so plugins/emojis/keymaps.ts will not register ESC
        document.addEventListener('keydown', this.handleEscape);
    };
    ToolbarEmojiPicker.prototype.componentWillReceiveProps = function (props) {
        if (!this.pluginState && props.pluginKey) {
            this.setPluginState(props);
        }
    };
    ToolbarEmojiPicker.prototype.componentDidUpdate = function () {
        var button = this.state.button;
        if (!button || !button.getBoundingClientRect().width) {
            this.state.button = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](this.buttonRef);
        }
    };
    ToolbarEmojiPicker.prototype.componentWillUnmount = function () {
        document.removeEventListener('keydown', this.handleEscape);
        if (this.pluginState) {
            this.pluginState.unsubscribe(this.handlePluginStateChange);
        }
    };
    ToolbarEmojiPicker.prototype.setPluginState = function (props) {
        var editorView = props.editorView, pluginKey = props.pluginKey;
        if (!editorView) {
            return;
        }
        var pluginState = pluginKey.getState(editorView.state);
        if (pluginState) {
            this.pluginState = pluginState;
            pluginState.subscribe(this.handlePluginStateChange);
            this.handlePluginStateChange(pluginState);
        }
    };
    ToolbarEmojiPicker.prototype.renderPopup = function () {
        var _a = this.state, disabled = _a.disabled, isOpen = _a.isOpen, button = _a.button;
        var _b = this.props, popupsMountPoint = _b.popupsMountPoint, popupsBoundariesElement = _b.popupsBoundariesElement, popupsScrollableElement = _b.popupsScrollableElement, emojiProvider = _b.emojiProvider;
        if (disabled || !isOpen || !button) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["e" /* Popup */], { target: button, fitHeight: 350, fitWidth: 350, offset: [0, 3], mountTo: popupsMountPoint, boundariesElement: popupsBoundariesElement, scrollableElement: popupsScrollableElement },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__atlaskit_emoji__["a" /* EmojiPicker */], { emojiProvider: emojiProvider, onSelection: this.handleSelectedEmoji, onPickerRef: this.onPickerRef })));
    };
    ToolbarEmojiPicker.prototype.render = function () {
        var _a = this.props, isDisabled = _a.isDisabled, isReducedSpacing = _a.isReducedSpacing;
        var _b = this.state, isOpen = _b.isOpen, disabled = _b.disabled;
        var toolbarButton = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ui_ToolbarButton__["a" /* default */], { selected: isOpen, disabled: disabled || isDisabled, onClick: this.toggleOpen, iconBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_emoji___default.a, { label: "Emoji" }), ref: this.handleButtonRef, title: "Emoji :", hideTooltip: isOpen, spacing: isReducedSpacing ? 'none' : 'default' }));
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* OuterContainer */], { width: isReducedSpacing ? 'large' : 'small' },
            toolbarButton,
            this.renderPopup()));
    };
    return ToolbarEmojiPicker;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (ToolbarEmojiPicker);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OuterContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



var OuterContainer = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  position: relative;\n  margin-right: ", "px;\n  > div {\n    display: flex;\n  }\n"], ["\n  position: relative;\n  margin-right: ",
    "px;\n  > div {\n    display: flex;\n  }\n"])), function (_a) {
    var width = _a.width;
    return !width || width === 'large' ? 0 : Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])();
});
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_emoji__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__analytics_fabric_analytics_helper__ = __webpack_require__(2471);







var EmojiTypeAhead = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiTypeAhead, _super);
    function EmojiTypeAhead() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openTime = 0;
        _this.state = {};
        _this.handlePluginStateChange = function (state) {
            var anchorElement = state.anchorElement, query = state.query, queryActive = state.queryActive, focused = state.focused;
            _this.setState({ anchorElement: anchorElement, query: query, queryActive: queryActive, focused: focused });
        };
        _this.handleEmojiTypeAheadRef = function (ref) {
            _this.typeAhead = ref;
        };
        _this.calculateElapsedTime = function () { return Date.now() - _this.openTime; };
        _this.handleSelectedEmoji = function (emojiId, emoji) {
            var _emoji = emoji;
            _this.fireTypeAheadSelectedAnalytics(_emoji, _this.lastKeyTyped, _this.pluginState.query);
            _this.pluginState.insertEmoji(emojiId);
        };
        _this.handleSelectPrevious = function () {
            if (_this.typeAhead) {
                _this.typeAhead.selectPrevious();
                __WEBPACK_IMPORTED_MODULE_4__analytics__["a" /* analyticsService */].trackEvent('atlassian.fabric.emoji.typeahead.keyup', {});
            }
            return true;
        };
        _this.handleSelectNext = function () {
            if (_this.typeAhead) {
                _this.typeAhead.selectNext();
                __WEBPACK_IMPORTED_MODULE_4__analytics__["a" /* analyticsService */].trackEvent('atlassian.fabric.emoji.typeahead.keydown', {});
            }
            return true;
        };
        _this.fireTypeAheadSelectedAnalytics = function (emoji, key, query) {
            var queryLength = (query && query.length) || 0;
            var insertType = Object(__WEBPACK_IMPORTED_MODULE_5__analytics_fabric_analytics_helper__["b" /* getInsertTypeForKey */])(key) || __WEBPACK_IMPORTED_MODULE_5__analytics_fabric_analytics_helper__["a" /* InsertType */].SELECTED;
            __WEBPACK_IMPORTED_MODULE_4__analytics__["a" /* analyticsService */].trackEvent('atlassian.fabric.emoji.typeahead.select', {
                mode: insertType,
                duration: _this.calculateElapsedTime() || 0,
                emojiId: (emoji && emoji.id) || '',
                type: (emoji && emoji.type) || '',
                queryLength: queryLength,
            });
        };
        _this.handleSpaceTyped = function () {
            __WEBPACK_IMPORTED_MODULE_4__analytics__["a" /* analyticsService */].trackEvent('atlassian.fabric.emoji.typeahead.space', {});
        };
        _this.handleSpaceSelectCurrent = function (emoji, key, query) {
            _this.fireTypeAheadSelectedAnalytics(emoji, key, query);
        };
        _this.handleSelectCurrent = function (key) {
            _this.lastKeyTyped = key;
            if (_this.getEmojisCount() > 0) {
                _this.typeAhead.chooseCurrentSelection();
            }
            else {
                _this.pluginState.dismiss();
            }
            return true;
        };
        _this.handleOnOpen = function () {
            _this.lastKeyTyped = undefined;
            _this.openTime = Date.now();
            __WEBPACK_IMPORTED_MODULE_4__analytics__["a" /* analyticsService */].trackEvent('atlassian.fabric.emoji.typeahead.open', {});
        };
        _this.handleOnClose = function () {
            __WEBPACK_IMPORTED_MODULE_4__analytics__["a" /* analyticsService */].trackEvent('atlassian.fabric.emoji.typeahead.close', {});
        };
        return _this;
    }
    EmojiTypeAhead.prototype.componentWillMount = function () {
        this.setPluginState(this.props);
    };
    EmojiTypeAhead.prototype.componentWillUpdate = function (nextProps) {
        if (!this.pluginState) {
            this.setPluginState(nextProps);
        }
    };
    EmojiTypeAhead.prototype.componentWillUnmount = function () {
        var pluginState = this.pluginState;
        if (pluginState) {
            pluginState.unsubscribe(this.handlePluginStateChange);
        }
    };
    EmojiTypeAhead.prototype.setPluginState = function (props) {
        var editorView = props.editorView, pluginKey = props.pluginKey;
        if (!editorView) {
            return;
        }
        var pluginState = pluginKey.getState(editorView.state);
        if (pluginState) {
            this.pluginState = pluginState;
            pluginState.subscribe(this.handlePluginStateChange);
            // note: these bindings are required otherwise 'this' context won't be available
            pluginState.onSelectPrevious = this.handleSelectPrevious;
            pluginState.onSelectNext = this.handleSelectNext;
            pluginState.onSelectCurrent = this.handleSelectCurrent;
            // note: AkEmojiTypeAhead.onClose does not work (product-fabric.atlassian.net/browse/FS-1640)
            pluginState.onDismiss = this.handleOnClose;
            pluginState.onSpaceSelectCurrent = this.handleSpaceSelectCurrent;
            pluginState.onSpaceTyped = this.handleSpaceTyped;
        }
    };
    EmojiTypeAhead.prototype.render = function () {
        var _a = this.state, anchorElement = _a.anchorElement, query = _a.query, queryActive = _a.queryActive, focused = _a.focused;
        var _b = this.props, popupsBoundariesElement = _b.popupsBoundariesElement, popupsMountPoint = _b.popupsMountPoint, popupsScrollableElement = _b.popupsScrollableElement, emojiProvider = _b.emojiProvider;
        if (!focused ||
            !this.pluginState ||
            !anchorElement ||
            !queryActive ||
            !emojiProvider) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["e" /* Popup */], { target: anchorElement, fitHeight: 350, fitWidth: 350, zIndex: __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["m" /* akEditorFloatingDialogZIndex */], boundariesElement: popupsBoundariesElement, scrollableElement: popupsScrollableElement, mountTo: popupsMountPoint, offset: [0, 3] },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_emoji__["b" /* EmojiTypeAhead */], { emojiProvider: emojiProvider, onSelection: this.handleSelectedEmoji, onOpen: this.handleOnOpen, query: query, ref: this.handleEmojiTypeAheadRef })));
    };
    EmojiTypeAhead.prototype.getEmojisCount = function () {
        return (this.typeAhead && this.typeAhead.count()) || 0;
    };
    return EmojiTypeAhead;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (EmojiTypeAhead);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InsertType; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getInsertTypeForKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keymaps__ = __webpack_require__(38);

var InsertType;
(function (InsertType) {
    InsertType["SELECTED"] = "selected";
    InsertType["ENTER"] = "enter";
    InsertType["SHIFT_ENTER"] = "shift-enter";
    InsertType["SPACE"] = "space";
    InsertType["TAB"] = "tab";
})(InsertType || (InsertType = {}));
function getInsertTypeForKey(key) {
    if (key === __WEBPACK_IMPORTED_MODULE_0__keymaps__["G" /* space */].common) {
        return InsertType.SPACE;
    }
    if (key === __WEBPACK_IMPORTED_MODULE_0__keymaps__["k" /* enter */].common) {
        return InsertType.ENTER;
    }
    if (key === __WEBPACK_IMPORTED_MODULE_0__keymaps__["I" /* tab */].common) {
        return InsertType.TAB;
    }
    if (key === __WEBPACK_IMPORTED_MODULE_0__keymaps__["s" /* insertNewLine */].common) {
        return InsertType.SHIFT_ENTER;
    }
    return undefined;
}
//# sourceMappingURL=fabric-analytics-helper.js.map

/***/ }),
/* 2472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugin__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toolbar__ = __webpack_require__(2481);



var extensionPlugin = {
    nodes: function () {
        return [
            { name: 'extension', node: __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["C" /* extension */] },
            { name: 'bodiedExtension', node: __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["g" /* bodiedExtension */] },
            { name: 'inlineExtension', node: __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["J" /* inlineExtension */] },
        ];
    },
    pmPlugins: function () {
        return [
            {
                name: 'extension',
                plugin: function (_a) {
                    var props = _a.props, dispatch = _a.dispatch, providerFactory = _a.providerFactory, portalProviderAPI = _a.portalProviderAPI;
                    return Object(__WEBPACK_IMPORTED_MODULE_1__plugin__["a" /* default */])(dispatch, providerFactory, props.extensionHandlers || {}, portalProviderAPI, props.allowExtension);
                },
            },
        ];
    },
    pluginsOptions: {
        floatingToolbar: __WEBPACK_IMPORTED_MODULE_2__toolbar__["a" /* getToolbarConfig */],
    },
};
/* harmony default export */ __webpack_exports__["a"] = (extensionPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ExtensionNodeView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeviews__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Extension__ = __webpack_require__(2474);




var ExtensionNode = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ExtensionNode, _super);
    function ExtensionNode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExtensionNode.prototype.ignoreMutation = function (mutation) {
        // Extensions can perform async operations that will change the DOM.
        // To avoid having their tree rebuilt, we need to ignore the mutation.
        return true;
    };
    ExtensionNode.prototype.getContentDOM = function () {
        if (this.node.isInline) {
            return;
        }
        var dom = document.createElement('div');
        dom.className = this.node.type.name + "-content-dom-wrapper";
        return { dom: dom };
    };
    ExtensionNode.prototype.render = function (props, forwardRef) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ui_Extension__["a" /* default */], { editorView: this.view, node: this.node, providerFactory: props.providerFactory, handleContentDOMRef: forwardRef, extensionHandlers: props.extensionHandlers }));
    };
    return ExtensionNode;
}(__WEBPACK_IMPORTED_MODULE_2__nodeviews__["a" /* ReactNodeView */]));
function ExtensionNodeView(portalProviderAPI, providerFactory, extensionHandlers) {
    return function (node, view, getPos) {
        return new ExtensionNode(node, view, getPos, portalProviderAPI, {
            providerFactory: providerFactory,
            extensionHandlers: extensionHandlers,
        }).init();
    };
}
//# sourceMappingURL=extension.js.map

/***/ }),
/* 2474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ExtensionComponent__ = __webpack_require__(2475);





var Extension = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Extension, _super);
    function Extension(props) {
        var _this = _super.call(this, props) || this;
        _this.renderWithProvider = function (providers) {
            var _a = _this.props, node = _a.node, editorView = _a.editorView, handleContentDOMRef = _a.handleContentDOMRef, extensionHandlers = _a.extensionHandlers;
            var macroProvider = providers.macroProvider;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ExtensionComponent__["a" /* default */], { editorView: editorView, node: node, macroProvider: macroProvider, handleContentDOMRef: handleContentDOMRef, extensionHandlers: extensionHandlers }));
        };
        _this.providerFactory = props.providerFactory || new __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["f" /* ProviderFactory */]();
        return _this;
    }
    Extension.prototype.componentWillUnmount = function () {
        if (!this.props.providerFactory) {
            // new ProviderFactory is created if no `providers` has been set
            // in this case when component is unmounted it's safe to destroy this providerFactory
            this.providerFactory.destroy();
        }
    };
    Extension.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["j" /* WithProviders */], { providers: ['macroProvider'], providerFactory: this.providerFactory, renderNode: this.renderWithProvider }));
    };
    return Extension;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Extension);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InlineExtension__ = __webpack_require__(2476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Extension__ = __webpack_require__(2479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(21);







var ExtensionComponent = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ExtensionComponent, _super);
    function ExtensionComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.mounted = false;
        _this.handleMacroProvider = function (macroProvider) {
            if (_this.mounted) {
                _this.setState({ macroProvider: macroProvider });
            }
        };
        _this.handleSelectExtension = function (hasBody) {
            var _a = _this.props.editorView, state = _a.state, _b = _a.state, selection = _b.selection, schema = _b.schema, dispatch = _a.dispatch;
            var tr = state.tr;
            if (hasBody) {
                tr = Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["selectParentNodeOfType"])([schema.nodes.bodiedExtension])(state.tr);
                dispatch(tr);
            }
            else if (!Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["findSelectedNodeOfType"])([
                schema.nodes.inlineExtension,
                schema.nodes.extension,
                schema.nodes.bodiedExtension,
            ])(selection)) {
                Object(__WEBPACK_IMPORTED_MODULE_5__utils__["G" /* setNodeSelection */])(_this.props.editorView, selection.$from.pos - 1);
            }
        };
        _this.handleExtension = function (node) {
            var _a = _this.props, extensionHandlers = _a.extensionHandlers, editorView = _a.editorView;
            var _b = node.attrs, extensionType = _b.extensionType, extensionKey = _b.extensionKey, parameters = _b.parameters;
            var isBodiedExtension = node.type.name === 'bodiedExtension';
            if (!extensionHandlers ||
                !extensionHandlers[extensionType] ||
                isBodiedExtension) {
                return;
            }
            return extensionHandlers[extensionType]({
                type: node.type.name,
                extensionType: extensionType,
                extensionKey: extensionKey,
                parameters: parameters,
                content: node.content,
            }, editorView.state.doc);
        };
        return _this;
    }
    ExtensionComponent.prototype.componentWillMount = function () {
        this.mounted = true;
    };
    ExtensionComponent.prototype.componentDidMount = function () {
        var macroProvider = this.props.macroProvider;
        if (macroProvider) {
            macroProvider.then(this.handleMacroProvider);
        }
    };
    ExtensionComponent.prototype.componentWillUnmount = function () {
        this.mounted = false;
    };
    ExtensionComponent.prototype.componentWillReceiveProps = function (nextProps) {
        var macroProvider = nextProps.macroProvider;
        if (this.props.macroProvider !== macroProvider) {
            if (macroProvider) {
                macroProvider.then(this.handleMacroProvider);
            }
            else {
                this.setState({ macroProvider: macroProvider });
            }
        }
    };
    ExtensionComponent.prototype.render = function () {
        var macroProvider = this.state.macroProvider;
        var _a = this.props, node = _a.node, handleContentDOMRef = _a.handleContentDOMRef, editorView = _a.editorView;
        var extensionHandlerResult = this.tryExtensionHandler();
        switch (node.type.name) {
            case 'extension':
            case 'bodiedExtension':
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Extension__["a" /* default */], { node: node, macroProvider: macroProvider, handleContentDOMRef: handleContentDOMRef, onSelectExtension: this.handleSelectExtension, view: editorView }, extensionHandlerResult));
            case 'inlineExtension':
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__InlineExtension__["a" /* default */], { node: node, macroProvider: macroProvider }, extensionHandlerResult));
            default:
                return null;
        }
    };
    ExtensionComponent.prototype.tryExtensionHandler = function () {
        var node = this.props.node;
        try {
            var extensionContent = this.handleExtension(node);
            if (extensionContent && __WEBPACK_IMPORTED_MODULE_1_react__["isValidElement"](extensionContent)) {
                return extensionContent;
            }
        }
        catch (e) {
            /* tslint:disable-next-line:no-console */
            console.error('Provided extension handler has thrown an error\n', e);
            /** We don't want this error to block renderer */
            /** We keep rendering the default content */
        }
        return null;
    };
    return ExtensionComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ExtensionComponent);
//# sourceMappingURL=ExtensionComponent.js.map

/***/ }),
/* 2476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Lozenge__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(2478);






var InlineExtension = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](InlineExtension, _super);
    function InlineExtension() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InlineExtension.prototype.render = function () {
        var _a = this.props, node = _a.node, children = _a.children;
        var hasChildren = !!children;
        var className = hasChildren
            ? 'with-overlay with-children'
            : 'with-overlay';
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* Wrapper */], { className: "extension-container " + className },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Overlay */], { className: "extension-overlay" }),
            children ? children : __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Lozenge__["a" /* default */], { node: node })));
    };
    return InlineExtension;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (InlineExtension);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorFileIcon = function EditorFileIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M7 6.5c0-.276.228-.5.491-.5H13l4 4v7.5c0 .276-.228.5-.51.5H7.51a.508.508 0 0 1-.51-.5v-11zm5 1v2.999c0 .271.225.501.501.501H15.5L12 7.5z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorFileIcon.displayName = 'EditorFileIcon';
var _default = EditorFileIcon;
exports.default = _default;

/***/ }),
/* 2478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(218);




var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* Wrapper */])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  cursor: pointer;\n  display: inline-flex;\n  margin: 1px;\n\n  > img {\n    border-radius: ", "px;\n  }\n\n  &::after,\n  &::before {\n    vertical-align: text-top;\n    display: inline-block;\n    width: 1px;\n    content: '';\n  }\n\n  &.with-children {\n    padding: 0;\n    background: white;\n  }\n"], ["\n  cursor: pointer;\n  display: inline-flex;\n  margin: 1px;\n\n  > img {\n    border-radius: ", "px;\n  }\n\n  &::after,\n  &::before {\n    vertical-align: text-top;\n    display: inline-block;\n    width: 1px;\n    content: '';\n  }\n\n  &.with-children {\n    padding: 0;\n    background: white;\n  }\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])());
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Lozenge__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__width__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_WithPluginState__ = __webpack_require__(32);









var Extension = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Extension, _super);
    function Extension() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSelectExtension = function () {
            var _a = _this.props, onSelectExtension = _a.onSelectExtension, node = _a.node;
            onSelectExtension(node.type.name === 'bodiedExtension');
        };
        return _this;
    }
    Extension.prototype.render = function () {
        var _this = this;
        var _a = this.props, node = _a.node, handleContentDOMRef = _a.handleContentDOMRef, children = _a.children, view = _a.view;
        var hasBody = node.type.name === 'bodiedExtension';
        var hasChildren = !!children;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ui_WithPluginState__["a" /* default */], { editorView: view, plugins: {
                widthState: __WEBPACK_IMPORTED_MODULE_5__width__["b" /* pluginKey */],
            }, render: function (_a) {
                var _b = _a.widthState, widthState = _b === void 0 ? { width: 0 } : _b;
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* Wrapper */], { "data-layout": node.attrs.layout, className: "extension-container " + (hasBody ? '' : 'with-overlay'), style: {
                        width: Object(__WEBPACK_IMPORTED_MODULE_6__atlaskit_editor_common__["F" /* calcBreakoutWidth */])(node.attrs.layout, widthState.width),
                    } },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Overlay */], { className: "extension-overlay" }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* Header */], { contentEditable: false, onClick: _this.onSelectExtension, className: hasChildren ? 'with-children' : '' }, children ? children : __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Lozenge__["a" /* default */], { node: node })),
                    hasBody && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* ContentWrapper */], null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Content */], { innerRef: handleContentDOMRef, className: "extension-content" })))));
            } }));
    };
    return Extension;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Extension);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ContentWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(218);





var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* Wrapper */])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin: ", " 0;\n\n  /* extension container breakout, only works on top level */\n  .ProseMirror > [extensiontype] &[data-layout='full-width'],\n  .ProseMirror > [extensiontype] &[data-layout='wide'] {\n    margin-left: 50%;\n    transform: translateX(-50%);\n  }\n  .ProseMirror > * [extensiontype] &[data-layout='wide'],\n  .ProseMirror > * [extensiontype] &[data-layout='wide'] {\n    width: 100% !important;\n  }\n"], ["\n  margin: ", " 0;\n\n  /* extension container breakout, only works on top level */\n  .ProseMirror > [extensiontype] &[data-layout='full-width'],\n  .ProseMirror > [extensiontype] &[data-layout='wide'] {\n    margin-left: 50%;\n    transform: translateX(-50%);\n  }\n  .ProseMirror > * [extensiontype] &[data-layout='wide'],\n  .ProseMirror > * [extensiontype] &[data-layout='wide'] {\n    width: 100% !important;\n  }\n"])), __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["B" /* blockNodesVerticalMargin */]);
var Header = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  cursor: pointer;\n  padding: ", "px ", "px ", "px;\n  vertical-align: middle;\n\n  &.with-children {\n    padding: 0;\n    background: white;\n  }\n"], ["\n  cursor: pointer;\n  padding: ", "px ", "px ", "px;\n  vertical-align: middle;\n\n  &.with-children {\n    padding: 0;\n    background: white;\n  }\n"])), __WEBPACK_IMPORTED_MODULE_4__styles__["e" /* padding */] / 2, __WEBPACK_IMPORTED_MODULE_4__styles__["e" /* padding */] / 2, __WEBPACK_IMPORTED_MODULE_4__styles__["e" /* padding */] / 4);
var Content = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  padding: ", "px;\n  background: white;\n  border: 1px solid ", ";\n  border-radius: ", "px;\n"], ["\n  padding: ", "px;\n  background: white;\n  border: 1px solid ", ";\n  border-radius: ", "px;\n"])), __WEBPACK_IMPORTED_MODULE_4__styles__["e" /* padding */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])());
var ContentWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  padding: 0 ", "px ", "px;\n"], ["\n  padding: 0 ", "px ", "px;\n"])), __WEBPACK_IMPORTED_MODULE_4__styles__["e" /* padding */], __WEBPACK_IMPORTED_MODULE_4__styles__["e" /* padding */]);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export messages */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getToolbarConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_remove__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_remove__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_edit__ = __webpack_require__(2482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_media_full_width__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_media_full_width___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_media_full_width__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_media_wide__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_media_wide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_media_wide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_media_center__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_media_center___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_media_center__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__messages__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__macro__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__plugin__ = __webpack_require__(451);












var messages = Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["defineMessages"])({
    edit: {
        id: 'fabric.editor.edit',
        defaultMessage: 'Edit',
        description: 'Edit the properties for this extension.',
    },
});
var isLayoutSupported = function (state, selectedExtNode) {
    var _a = state.schema.nodes, bodiedExtension = _a.bodiedExtension, extension = _a.extension, layoutSection = _a.layoutSection, table = _a.table, selection = state.selection;
    if (!selectedExtNode) {
        return false;
    }
    return !!((selectedExtNode.node.type === bodiedExtension ||
        (selectedExtNode.node.type === extension &&
            !Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["hasParentNodeOfType"])([bodiedExtension, table])(selection))) &&
        !Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["hasParentNodeOfType"])([layoutSection])(selection));
};
var breakoutOptions = function (state, formatMessage, extensionState) {
    var layout = extensionState.layout, allowBreakout = extensionState.allowBreakout, node = extensionState.node;
    return allowBreakout && isLayoutSupported(state, node)
        ? [
            {
                type: 'button',
                icon: __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_media_center___default.a,
                onClick: Object(__WEBPACK_IMPORTED_MODULE_10__actions__["d" /* updateExtensionLayout */])('default'),
                selected: layout === 'default',
                title: formatMessage(__WEBPACK_IMPORTED_MODULE_8__messages__["a" /* default */].layoutFixedWidth),
            },
            {
                type: 'button',
                icon: __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_media_wide___default.a,
                onClick: Object(__WEBPACK_IMPORTED_MODULE_10__actions__["d" /* updateExtensionLayout */])('wide'),
                selected: layout === 'wide',
                title: formatMessage(__WEBPACK_IMPORTED_MODULE_8__messages__["a" /* default */].layoutWide),
            },
            {
                type: 'button',
                icon: __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_media_full_width___default.a,
                onClick: Object(__WEBPACK_IMPORTED_MODULE_10__actions__["d" /* updateExtensionLayout */])('full-width'),
                selected: layout === 'full-width',
                title: formatMessage(__WEBPACK_IMPORTED_MODULE_8__messages__["a" /* default */].layoutFullWidth),
            },
        ]
        : [];
};
var getToolbarConfig = function (state, _a) {
    var formatMessage = _a.formatMessage;
    var extensionState = __WEBPACK_IMPORTED_MODULE_11__plugin__["b" /* pluginKey */].getState(state);
    var macroState = __WEBPACK_IMPORTED_MODULE_9__macro__["c" /* pluginKey */].getState(state);
    if (extensionState && extensionState.element) {
        return {
            title: 'Extension floating controls',
            getDomRef: function () { return extensionState.element.parentElement || undefined; },
            nodeType: [
                state.schema.nodes.extension,
                state.schema.nodes.inlineExtension,
                state.schema.nodes.bodiedExtension,
            ],
            items: __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"]([
                {
                    type: 'button',
                    icon: __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_edit___default.a,
                    onClick: Object(__WEBPACK_IMPORTED_MODULE_10__actions__["a" /* editExtension */])(macroState && macroState.macroProvider),
                    title: formatMessage(messages.edit),
                }
            ], breakoutOptions(state, formatMessage, extensionState), [
                {
                    type: 'separator',
                },
                {
                    type: 'button',
                    icon: __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_remove___default.a,
                    appearance: 'danger',
                    onClick: Object(__WEBPACK_IMPORTED_MODULE_10__actions__["b" /* removeExtension */])(),
                    title: formatMessage(__WEBPACK_IMPORTED_MODULE_8__messages__["a" /* default */].remove),
                },
            ]),
        };
    }
};
//# sourceMappingURL=toolbar.js.map

/***/ }),
/* 2482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorEditIcon = function EditorEditIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M15.148 6.852a.502.502 0 0 1 .708.004l2.288 2.288a.5.5 0 0 1 .004.708L11 17l-3-3 7.148-7.148zM7 15l3 3-3.51.877c-.27.068-.436-.092-.367-.367L7 15z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorEditIcon.displayName = 'EditorEditIcon';
var _default = EditorEditIcon;
exports.default = _default;

/***/ }),
/* 2483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stateKey */
/* unused harmony export createPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cursor__ = __webpack_require__(409);



var stateKey = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["PluginKey"]('fakeTextCursorPlugin');
var createPlugin = function () {
    return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
        key: stateKey,
        props: {
            decorations: __WEBPACK_IMPORTED_MODULE_1__cursor__["b" /* drawFakeTextCursor */],
        },
    });
};
var fakeTextCursorPlugin = {
    pmPlugins: function () {
        return [{ name: 'fakeTextCursor', plugin: function () { return createPlugin(); } }];
    },
};
/* harmony default export */ __webpack_exports__["a"] = (fakeTextCursorPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HelpDialogLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_loadable__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_loadable__);

var HelpDialogLoader = __WEBPACK_IMPORTED_MODULE_0_react_loadable__({
    loader: function () {
        return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 3468)).then(function (module) { return module.default; });
    },
    loading: function () { return null; },
});
//# sourceMappingURL=HelpDialogLoader.js.map

/***/ }),
/* 2485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorBoldIcon = function EditorBoldIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M8 6h4.832C13.908 6 16 6.5 16 9c0 1.333-.333 2.167-1 2.5 1.333.333 2 1.333 2 3 0 .5 0 3.5-4 3.5H8a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm1 10h3.5c1 0 2-.25 2-1.5s-1.104-1.5-2-1.5H9v3zm0-4.975h3c.504 0 2 0 2-1.525S12 8 12 8H9v3.025z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorBoldIcon.displayName = 'EditorBoldIcon';
var _default = EditorBoldIcon;
exports.default = _default;

/***/ }),
/* 2486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorItalicIcon = function EditorItalicIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M10 6h6a1 1 0 0 1 0 2h-6a1 1 0 1 1 0-2zM8 16h6a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2zm4-8h2l-2 8h-2l2-8z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorItalicIcon.displayName = 'EditorItalicIcon';
var _default = EditorItalicIcon;
exports.default = _default;

/***/ }),
/* 2487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export trimChunk */
/* unused harmony export singleWord */
/* unused harmony export defaultCompareFn */
/* unused harmony export SortMode */
/* unused harmony export buildSortPredicateWith */
/* unused harmony export distance */
/* unused harmony export distanceByWords */
/* unused harmony export getSearchChunks */
/* harmony export (immutable) */ __webpack_exports__["a"] = find;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

function trimChunk(chunk) {
    return chunk.toLowerCase().replace(/\s/g, '');
}
function singleWord(search) {
    return !search.includes(' ');
}
function defaultCompareFn(a, b) {
    return typeof a === 'number' && typeof b === 'number'
        ? a - b
        : String.prototype.localeCompare.call(a, b);
}
var SortMode;
(function (SortMode) {
    SortMode["PRIORITY_FIRST"] = "first";
    SortMode["PRIORITY_LAST"] = "last";
})(SortMode || (SortMode = {}));
function buildSortPredicateWith(getProp, getPriority, sortMode, compareFn) {
    if (compareFn === void 0) { compareFn = defaultCompareFn; }
    return function (a, b) {
        var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"]([
            getProp(a),
            getProp(b),
            getPriority(a),
            getPriority(b),
        ], 4), propA = _a[0], propB = _a[1], prioA = _a[2], prioB = _a[3];
        var prioDiff = compareFn(prioA, prioB);
        if (sortMode === SortMode.PRIORITY_FIRST && prioDiff) {
            return prioDiff;
        }
        else if (sortMode === SortMode.PRIORITY_FIRST) {
            return compareFn(propA, propB);
        }
        else {
            // SortMode.PRIORITY_LAST
            return prioDiff;
        }
    };
}
function distance(search, content) {
    return trimChunk(search)
        .split('')
        .reduce(function (acc, char, index) {
        var distance = acc.distance, offset = acc.offset;
        if (distance === Infinity) {
            return acc;
        }
        var indexInContent = content.indexOf(char, offset);
        if (indexInContent === -1) {
            return { distance: Infinity, offset: 0 };
        }
        return {
            offset: indexInContent + 1,
            distance: distance +
                (index !== indexInContent ? Math.abs(index - indexInContent) : 0),
        };
    }, { distance: 0, offset: 0 }).distance;
}
// Finds the distance of the search string from each word and returns the min.
// Ensures the search string starts with the letter of one of the words
function distanceByWords(search, content) {
    if (search === '') {
        return 0;
    }
    if (!singleWord(search)) {
        return distance(search, trimChunk(content));
    }
    var lowerSearch = trimChunk(search);
    return content
        .replace(/\s/g, ' ')
        .toLowerCase()
        .split(' ')
        .filter(function (word) { return lowerSearch[0] === word[0]; })
        .map(function (word) { return trimChunk(word); })
        .reduce(function (minDist, word) { return Math.min(minDist, distance(lowerSearch, word)); }, Infinity);
}
function getSearchChunks(_a) {
    var keywords = _a.keywords, title = _a.title;
    return keywords ? [title].concat(keywords) : [title];
}
function find(query, items) {
    return (items
        // pre-sort items by title ascending, putting prioritary items first
        .sort(buildSortPredicateWith(function (item) { return item.title; }, function (item) { return item.priority || Number.POSITIVE_INFINITY; }, SortMode.PRIORITY_FIRST))
        // calculate lowest items distance to query
        .map(function (item) { return ({
        item: item,
        distance: getSearchChunks(item).reduce(function (acc, chunk) {
            var chunkDistance = distanceByWords(query, chunk);
            return chunkDistance < acc ? chunkDistance : acc;
        }, Infinity),
    }); })
        /**
         * Filter results giving:
         * - potential match when query is one word
         * - exact match when query has more words
         */
        .filter(function (_a) {
        var distance = _a.distance;
        return singleWord(query) ? distance !== Infinity : distance === 0;
    })
        // post-sort items by distance ascending, putting prioritary items last
        .sort(buildSortPredicateWith(function (agg) { return agg.distance; }, function (agg) { return agg.item.priority || Number.POSITIVE_INFINITY; }, SortMode.PRIORITY_LAST))
        .map(function (agg) { return agg.item; }));
}
//# sourceMappingURL=search.js.map

/***/ }),
/* 2488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pm_plugins_input_rule__ = __webpack_require__(2489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pm_plugins_keymap__ = __webpack_require__(2511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pm_plugins_main__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pm_plugins_fake_cursor_for_toolbar__ = __webpack_require__(2512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pm_plugins_sync_text_and_url__ = __webpack_require__(2513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui__ = __webpack_require__(2514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_editor_success__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_editor_success___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_editor_success__);











var hyperlinkPlugin = {
    marks: function () {
        return [{ name: 'link', mark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["O" /* link */] }];
    },
    pmPlugins: function () {
        return [
            {
                name: 'syncUrlText',
                plugin: function (_a) {
                    var appearance = _a.props.appearance;
                    return appearance === 'message' ? __WEBPACK_IMPORTED_MODULE_8__pm_plugins_sync_text_and_url__["a" /* default */] : undefined;
                },
            },
            { name: 'hyperlink', plugin: function (_a) {
                    var dispatch = _a.dispatch;
                    return Object(__WEBPACK_IMPORTED_MODULE_6__pm_plugins_main__["d" /* plugin */])(dispatch);
                } },
            {
                name: 'fakeCursorToolbarPlugin',
                plugin: function () { return __WEBPACK_IMPORTED_MODULE_7__pm_plugins_fake_cursor_for_toolbar__["a" /* default */]; },
            },
            {
                name: 'hyperlinkInputRule',
                plugin: function (_a) {
                    var schema = _a.schema;
                    return Object(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_input_rule__["a" /* createInputRulePlugin */])(schema);
                },
            },
            {
                name: 'hyperlinkKeymap',
                plugin: function (_a) {
                    var schema = _a.schema, props = _a.props;
                    return Object(__WEBPACK_IMPORTED_MODULE_5__pm_plugins_keymap__["a" /* createKeymapPlugin */])(schema, props);
                },
            },
        ];
    },
    pluginsOptions: {
        quickInsert: function (_a) {
            var formatMessage = _a.formatMessage;
            return [
                {
                    title: 'Hyperlink',
                    keywords: ['url', 'link', 'hyperlink'],
                    priority: 1200,
                    icon: function () { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_editor_success___default.a, { label: 'Hyperlink' }); },
                    action: function (insert, state) {
                        var pos = state.selection.from;
                        var nodeBefore = state.selection.$from.nodeBefore;
                        if (!nodeBefore) {
                            return false;
                        }
                        return state.tr
                            .setMeta(__WEBPACK_IMPORTED_MODULE_6__pm_plugins_main__["e" /* stateKey */], __WEBPACK_IMPORTED_MODULE_6__pm_plugins_main__["b" /* LinkAction */].SHOW_INSERT_TOOLBAR)
                            .delete(pos - nodeBefore.nodeSize, pos);
                    },
                },
            ];
        },
    },
    contentComponent: function (_a) {
        var appearance = _a.appearance, editorView = _a.editorView, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, providerFactory = _a.providerFactory;
        if (appearance === 'message') {
            return null;
        }
        var renderToolbar = function (providers) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ui_WithPluginState__["a" /* default */], { plugins: { hyperlinkState: __WEBPACK_IMPORTED_MODULE_6__pm_plugins_main__["e" /* stateKey */] }, render: function (_a) {
                var hyperlinkState = _a.hyperlinkState;
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ui__["a" /* default */], { hyperlinkState: hyperlinkState, view: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, activityProvider: providers ? providers.activityProvider : undefined }));
            } })); };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["j" /* WithProviders */], { providerFactory: providerFactory, providers: ['activityProvider'], renderNode: renderToolbar }));
    },
};
/* harmony default export */ __webpack_exports__["a"] = (hyperlinkPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createLinkInputRule */
/* harmony export (immutable) */ __webpack_exports__["a"] = createInputRulePlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_input_rules__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__card_pm_plugins_actions__ = __webpack_require__(294);






function createLinkInputRule(regexp, formatUrl) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_input_rules__["a" /* createInputRule */])(regexp, function (state, match, start, end) {
        var schema = state.schema;
        if (state.doc.rangeHasMark(start, end, schema.marks.link)) {
            return null;
        }
        var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](match, 1), link = _a[0];
        var markType = schema.mark('link', { href: link.url });
        __WEBPACK_IMPORTED_MODULE_2__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.format.hyperlink.autoformatting');
        var tr = state.tr
            .addMark(start - (link.input.length - link.lastIndex), end - (link.input.length - link.lastIndex), markType)
            .insertText(' ');
        return Object(__WEBPACK_IMPORTED_MODULE_5__card_pm_plugins_actions__["a" /* queueCards */])([
            {
                url: link.url,
                pos: start - (link.input.length - link.lastIndex),
                appearance: 'inline',
            },
        ])(tr);
    });
}
function createInputRulePlugin(schema) {
    if (!schema.marks.link) {
        return;
    }
    var urlWithASpaceRule = createLinkInputRule(new __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* LinkMatcher */](), function (match) { return (match[3] ? match[1] : "https?://" + match[1]); });
    // [something](link) should convert to a hyperlink
    var markdownLinkRule = Object(__WEBPACK_IMPORTED_MODULE_3__utils_input_rules__["a" /* createInputRule */])(/(^|[^!])\[(.*?)\]\((\S+)\)$/, function (state, match, start, end) {
        var schema = state.schema;
        var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](match, 4), prefix = _a[1], linkText = _a[2], linkUrl = _a[3];
        var url = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* normalizeUrl */])(linkUrl);
        var markType = schema.mark('link', { href: url });
        __WEBPACK_IMPORTED_MODULE_2__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.format.hyperlink.autoformatting');
        return state.tr.replaceWith(start + prefix.length, end, schema.text(linkText, [markType]));
    });
    return Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules__["inputRules"])({
        rules: [urlWithASpaceRule, markdownLinkRule],
    });
}
/* unused harmony default export */ var _unused_webpack_default_export = (createInputRulePlugin);
//# sourceMappingURL=input-rule.js.map

/***/ }),
/* 2490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

var queue = function (state, action) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, state, { requests: state.requests.concat(action.requests) });
};
var resolve = function (state, action) {
    var requests = state.requests.reduce(function (requests, request) {
        if (request.url !== action.url) {
            requests.push(request);
        }
        return requests;
    }, []);
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, state, { requests: requests });
};
var setProvider = function (state, action) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, state, { provider: action.provider });
};
/* harmony default export */ __webpack_exports__["a"] = (function (state, action) {
    switch (action.type) {
        case 'QUEUE':
            return queue(state, action);
        case 'SET_PROVIDER':
            return setProvider(state, action);
        case 'RESOLVE':
            return resolve(state, action);
    }
});
//# sourceMappingURL=reducers.js.map

/***/ }),
/* 2491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_smart_card__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nodeviews_legacy_nodeview_factory_ui_wrapper_click_area__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_base_pm_plugins_react_nodeview__ = __webpack_require__(210);






var InlineCardNode = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](InlineCardNode, _super);
    function InlineCardNode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function () { };
        return _this;
    }
    InlineCardNode.prototype.render = function () {
        var _a = this.props, node = _a.node, selected = _a.selected;
        var _b = node.attrs, url = _b.url, data = _b.data;
        var cardContext = this.context.contextAdapter
            ? this.context.contextAdapter.card
            : undefined;
        var card = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_smart_card__["a" /* Card */], { url: url, data: data, appearance: "inline", isSelected: selected, onClick: this.onClick }));
        return cardContext ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](cardContext.Provider, { value: cardContext.value }, card)) : (card);
    };
    InlineCardNode.contextTypes = {
        contextAdapter: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    };
    return InlineCardNode;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
var WrappedInline = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WrappedInline, _super);
    function WrappedInline() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WrappedInline.prototype.render = function () {
        var WrappedComponent = Object(__WEBPACK_IMPORTED_MODULE_4__nodeviews_legacy_nodeview_factory_ui_wrapper_click_area__["a" /* default */])(InlineCardNode, true);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](WrappedComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, this.props, { pluginState: __WEBPACK_IMPORTED_MODULE_5__plugins_base_pm_plugins_react_nodeview__["b" /* stateKey */].getState(this.props.view.state) })));
    };
    return WrappedInline;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (WrappedInline);
//# sourceMappingURL=inlineCard.js.map

/***/ }),
/* 2492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Provider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Context__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Client__ = __webpack_require__(839);




var defaultClient = new __WEBPACK_IMPORTED_MODULE_3__Client__["a" /* Client */]();
var Provider = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Provider, _super);
    function Provider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Provider.prototype.render = function () {
        var _a = this.props, client = _a.client, children = _a.children;
        // Note: the provider is also a consumer which passes through a client from
        // parent context in case a Card is wrapped with multiple Providers.
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Context__["a" /* default */].Consumer, null, function (clientFromParentContext) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Context__["a" /* default */].Provider, { value: client || clientFromParentContext || defaultClient }, children)); }));
    };
    return Provider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 2493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayObservable_1 = __webpack_require__(395);
exports.of = ArrayObservable_1.ArrayObservable.of;
//# sourceMappingURL=of.js.map

/***/ }),
/* 2494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(42);
var ArrayObservable_1 = __webpack_require__(395);
var isScheduler_1 = __webpack_require__(696);
var mergeAll_1 = __webpack_require__(2495);
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (as arguments), and simply
 * forwards (without doing any transformation) all the values from all the input
 * Observables to the output Observable. The output Observable only completes
 * once all input Observables have completed. Any error delivered by an input
 * Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // timer will emit ascending values, one every second(1000ms) to console
 * // clicks logs MouseEvents to console everytime the "document" is clicked
 * // Since the two streams are merged you see these happening
 * // as they occur.
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - First timer1 and timer2 will run concurrently
 * // - timer1 will emit a value every 1000ms for 10 iterations
 * // - timer2 will emit a value every 2000ms for 6 iterations
 * // - after timer1 hits it's max iteration, timer2 will
 * //   continue, and timer3 will start to run concurrently with timer2
 * // - when timer2 hits it's max iteration it terminates, and
 * //   timer3 will continue to emit a value every 500ms until it is complete
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {...ObservableInput} observables Input Observables to merge together.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} an Observable that emits items that are the result of
 * every input Observable.
 * @static true
 * @name merge
 * @owner Observable
 */
function merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if (isScheduler_1.isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
            concurrent = observables.pop();
        }
    }
    else if (typeof last === 'number') {
        concurrent = observables.pop();
    }
    if (scheduler === null && observables.length === 1 && observables[0] instanceof Observable_1.Observable) {
        return observables[0];
    }
    return mergeAll_1.mergeAll(concurrent)(new ArrayObservable_1.ArrayObservable(observables, scheduler));
}
exports.merge = merge;
//# sourceMappingURL=merge.js.map

/***/ }),
/* 2495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeMap_1 = __webpack_require__(389);
var identity_1 = __webpack_require__(2496);
/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */
function mergeAll(concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return mergeMap_1.mergeMap(identity_1.identity, null, concurrent);
}
exports.mergeAll = mergeAll;
//# sourceMappingURL=mergeAll.js.map

/***/ }),
/* 2496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function identity(x) {
    return x;
}
exports.identity = identity;
//# sourceMappingURL=identity.js.map

/***/ }),
/* 2497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);


/* harmony default export */ __webpack_exports__["a"] = (function (method, url, data) {
    return new __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"](function (observer) {
        var AC = new AbortController();
        var requestConfig = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ method: method, signal: AC.signal, credentials: 'include', headers: {
                'Cache-Control': 'no-cache',
                Accept: 'application/json',
                'Content-Type': 'application/json',
            } }, (data ? { body: JSON.stringify(data) } : {}));
        try {
            fetch(url, requestConfig)
                .then(function (resp) { return resp.ok && resp.json(); })
                .then(function (res) {
                observer.next(res);
                observer.complete();
            })
                .catch(function (e) {
                observer.error(e);
            });
        }
        catch (e) {
            observer.error(e);
        }
        return function () { return AC.abort(); };
    });
});
//# sourceMappingURL=fetch.js.map

/***/ }),
/* 2498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var async_1 = __webpack_require__(2499);
var isDate_1 = __webpack_require__(2500);
var Subscriber_1 = __webpack_require__(90);
var Notification_1 = __webpack_require__(698);
/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */
function delay(delay, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    var absoluteDelay = isDate_1.isDate(delay);
    var delayFor = absoluteDelay ? (+delay - scheduler.now()) : Math.abs(delay);
    return function (source) { return source.lift(new DelayOperator(delayFor, scheduler)); };
}
exports.delay = delay;
var DelayOperator = (function () {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DelaySubscriber = (function (_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function (state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while (queue.length > 0 && (queue[0].time - scheduler.now()) <= 0) {
            queue.shift().notification.observe(destination);
        }
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        }
        else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function (scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this, destination: this.destination, scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function (notification) {
        if (this.errored === true) {
            return;
        }
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) {
            this._schedule(scheduler);
        }
    };
    DelaySubscriber.prototype._next = function (value) {
        this.scheduleNotification(Notification_1.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function (err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function () {
        this.scheduleNotification(Notification_1.Notification.createComplete());
    };
    return DelaySubscriber;
}(Subscriber_1.Subscriber));
var DelayMessage = (function () {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}());
//# sourceMappingURL=delay.js.map

/***/ }),
/* 2499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var AsyncAction_1 = __webpack_require__(699);
var AsyncScheduler_1 = __webpack_require__(700);
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */
exports.async = new AsyncScheduler_1.AsyncScheduler(AsyncAction_1.AsyncAction);
//# sourceMappingURL=async.js.map

/***/ }),
/* 2500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
exports.isDate = isDate;
//# sourceMappingURL=isDate.js.map

/***/ }),
/* 2501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(393);
var subscribeToResult_1 = __webpack_require__(390);
/**
 * Emits the values emitted by the source Observable until a `notifier`
 * Observable emits a value.
 *
 * <span class="informal">Lets values pass until a second Observable,
 * `notifier`, emits something. Then, it completes.</span>
 *
 * <img src="./img/takeUntil.png" width="100%">
 *
 * `takeUntil` subscribes and begins mirroring the source Observable. It also
 * monitors a second Observable, `notifier` that you provide. If the `notifier`
 * emits a value or a complete notification, the output Observable stops
 * mirroring the source Observable and completes.
 *
 * @example <caption>Tick every second until the first click happens</caption>
 * var interval = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = interval.takeUntil(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @param {Observable} notifier The Observable whose first emitted value will
 * cause the output Observable of `takeUntil` to stop emitting values from the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable until such time as `notifier` emits its first value.
 * @method takeUntil
 * @owner Observable
 */
function takeUntil(notifier) {
    return function (source) { return source.lift(new TakeUntilOperator(notifier)); };
}
exports.takeUntil = takeUntil;
var TakeUntilOperator = (function () {
    function TakeUntilOperator(notifier) {
        this.notifier = notifier;
    }
    TakeUntilOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeUntilSubscriber(subscriber, this.notifier));
    };
    return TakeUntilOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TakeUntilSubscriber = (function (_super) {
    __extends(TakeUntilSubscriber, _super);
    function TakeUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.add(subscribeToResult_1.subscribeToResult(this, notifier));
    }
    TakeUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.complete();
    };
    TakeUntilSubscriber.prototype.notifyComplete = function () {
        // noop
    };
    return TakeUntilSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=takeUntil.js.map

/***/ }),
/* 2502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(393);
var subscribeToResult_1 = __webpack_require__(390);
/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @name catchError
 */
function catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new CatchOperator(selector);
        var caught = source.lift(operator);
        return (operator.caught = caught);
    };
}
exports.catchError = catchError;
var CatchOperator = (function () {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var CatchSubscriber = (function (_super) {
    __extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            }
            catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add(subscribeToResult_1.subscribeToResult(this, result));
        }
    };
    return CatchSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=catchError.js.map

/***/ }),
/* 2503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stateWatcher__ = __webpack_require__(2504);

var Store = /** @class */ (function () {
    function Store(getNowTimeFn) {
        this.getNowTimeFn = getNowTimeFn;
        this.store = {};
    }
    Store.prototype.get = function (url) {
        return this.store[url];
    };
    Store.prototype.getAllUrls = function () {
        return Object.keys(this.store);
    };
    Store.prototype.init = function (url) {
        if (this.store[url]) {
            throw new Error("Reinit the watcher for url: " + url);
        }
        return (this.store[url] = new __WEBPACK_IMPORTED_MODULE_0__stateWatcher__["a" /* StateWatch */](this.getNowTimeFn));
    };
    Store.prototype.set = function (url, data, lifespan) {
        if (!this.store[url]) {
            throw new Error("Set for non-existent url: " + url);
        }
        return this.store[url].update(data, lifespan);
    };
    Store.prototype.exists = function (url) {
        return this.store[url] !== undefined;
    };
    return Store;
}());

//# sourceMappingURL=store.js.map

/***/ }),
/* 2504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StateWatch; });
var StateWatch = /** @class */ (function () {
    function StateWatch(getNow) {
        this.getNow = getNow;
        this.entry = null;
        this.subscribers = [];
    }
    StateWatch.prototype.subscribe = function (uuid, fn) {
        if (!this.subscribers.find(function (sub) { return sub.uuid === uuid; })) {
            this.subscribers.push({ uuid: uuid, fn: fn });
        }
        fn([this.entry ? this.entry.state : null, this.hasExpired()]);
        return function () { };
    };
    StateWatch.prototype.invalidate = function () {
        if (this.entry) {
            this.entry.goodTill = this.getNow() - 1;
        }
        return this;
    };
    StateWatch.prototype.getProp = function (propName) {
        if (this.entry === null) {
            return;
        }
        return this.entry.state[propName];
    };
    StateWatch.prototype.unsubscribe = function (uuid) {
        this.subscribers = this.subscribers.filter(function (rec) { return rec.uuid !== uuid; });
    };
    StateWatch.prototype.hasExpired = function () {
        if (this.entry === null) {
            return true;
        }
        return this.entry.goodTill < this.getNow();
    };
    StateWatch.prototype.update = function (state, lifespan) {
        this.entry = {
            state: state,
            goodTill: this.getNow() + lifespan,
        };
        this.subscribers.forEach(function (rec) { return rec.fn([state, false]); });
    };
    return StateWatch;
}());

//# sourceMappingURL=stateWatcher.js.map

/***/ }),
/* 2505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Card; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__render__ = __webpack_require__(2506);



var Card = function (props) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__render__["c" /* isCardWithData */])(props) ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__render__["a" /* CardWithDataRenderer */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, props))) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__render__["b" /* CardWithURLRenderer */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, props)));
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 2506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isCardWithData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CardWithURLRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardWithDataRenderer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_lazily_render__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_lazily_render___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_lazily_render__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_media_ui__ = __webpack_require__(51);




var isCardWithData = function (props) {
    return !!props.data;
};
var CardWithURLRenderer = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CardWithURLRenderer, _super);
    function CardWithURLRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardWithURLRenderer.moduleImporter = function (target) {
        __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 3469)).then(function (module) {
            CardWithURLRenderer.CardContent = module.CardWithUrlContent;
            target.forceUpdate();
        });
    };
    CardWithURLRenderer.prototype.componentDidMount = function () {
        if (CardWithURLRenderer.CardContent === null) {
            (this.props.importer || CardWithURLRenderer.moduleImporter)(this);
        }
    };
    CardWithURLRenderer.prototype.render = function () {
        var _a = this.props, url = _a.url, client = _a.client, appearance = _a.appearance, isSelected = _a.isSelected, onClick = _a.onClick;
        if (!url) {
            throw new Error('@atlaskit/smart-card: url property is missing.');
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_lazily_render___default.a, { offset: 100, component: appearance === 'inline' ? 'span' : 'div', placeholder: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_media_ui__["f" /* CardLinkView */], { text: url }, url), content: CardWithURLRenderer.CardContent !== null ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CardWithURLRenderer.CardContent, { url: url, client: client, appearance: appearance, onClick: onClick, isSelected: isSelected })) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_media_ui__["f" /* CardLinkView */], { text: url }, url)) }));
    };
    CardWithURLRenderer.CardContent = null;
    return CardWithURLRenderer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

var CardWithDataRenderer = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CardWithDataRenderer, _super);
    function CardWithDataRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardWithDataRenderer.moduleImporter = function (target) {
        __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 3470)).then(function (module) {
            CardWithDataRenderer.CardContent = module.CardWithDataContent;
            target.forceUpdate();
        });
    };
    CardWithDataRenderer.prototype.componentDidMount = function () {
        if (CardWithDataRenderer.CardContent === null) {
            (this.props.importer || CardWithDataRenderer.moduleImporter)(this);
        }
    };
    CardWithDataRenderer.prototype.render = function () {
        var _a = this.props, appearance = _a.appearance, data = _a.data, isSelected = _a.isSelected, onClick = _a.onClick;
        if (!data) {
            throw new Error('@atlaskit/smart-cards: you are trying to render a card with data, but does not provide any');
        }
        if (CardWithDataRenderer.CardContent) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CardWithDataRenderer.CardContent, { appearance: appearance, data: data, isSelected: isSelected, onClick: onClick }));
        }
        return null;
    };
    CardWithDataRenderer.CardContent = null;
    return CardWithDataRenderer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=render.js.map

/***/ }),
/* 2507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EditorCardProvider */
/* unused harmony export editorCardProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

var ORS_CHECK_URL = 'https://api-private.stg.atlassian.com/object-resolver/check';
var EditorCardProvider = /** @class */ (function () {
    function EditorCardProvider() {
    }
    EditorCardProvider.prototype.resolve = function (url, appearance) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
            var result, e_1;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, fetch(ORS_CHECK_URL, {
                                method: 'POST',
                                credentials: 'include',
                                headers: {
                                    'Content-Type': 'application/json',
                                    Accept: 'application/json',
                                },
                                body: JSON.stringify({ resourceUrl: url }),
                            })];
                    case 1: return [4 /*yield*/, (_a.sent()).json()];
                    case 2:
                        result = _a.sent();
                        if (result && result.isSupported) {
                            return [2 /*return*/, {
                                    type: appearance === 'inline' ? 'inlineCard' : 'blockCard',
                                    attrs: {
                                        url: url,
                                    },
                                }];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        // tslint:disable-next-line
                        console.warn("Error when trying to check Smart Card url \"" + url + " - " + e_1.prototype.name + " " + e_1.message, e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, Promise.reject(undefined)];
                }
            });
        });
    };
    return EditorCardProvider;
}());

var editorCardProvider = new EditorCardProvider();
//# sourceMappingURL=card-provider.js.map

/***/ }),
/* 2508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_smart_card__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nodeviews_legacy_nodeview_factory_ui_wrapper_click_area__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_base_pm_plugins_react_nodeview__ = __webpack_require__(210);






var BlockCardNode = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](BlockCardNode, _super);
    function BlockCardNode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function () { };
        return _this;
    }
    BlockCardNode.prototype.render = function () {
        var _a = this.props, node = _a.node, selected = _a.selected;
        var _b = node.attrs, url = _b.url, data = _b.data;
        var cardContext = this.context.contextAdapter
            ? this.context.contextAdapter.card
            : undefined;
        // render an empty span afterwards to get around Webkit bug
        // that puts caret in next editable text element
        var cardInner = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_smart_card__["a" /* Card */], { url: url, data: data, appearance: "block", isSelected: selected, onClick: this.onClick }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { contentEditable: true })));
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, cardContext ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](cardContext.Provider, { value: cardContext.value }, cardInner)) : (cardInner)));
    };
    BlockCardNode.contextTypes = {
        contextAdapter: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"],
    };
    return BlockCardNode;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
var ClickableBlockCard = Object(__WEBPACK_IMPORTED_MODULE_4__nodeviews_legacy_nodeview_factory_ui_wrapper_click_area__["a" /* default */])(BlockCardNode);
var WrappedInline = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WrappedInline, _super);
    function WrappedInline() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WrappedInline.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ClickableBlockCard, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, this.props, { pluginState: __WEBPACK_IMPORTED_MODULE_5__plugins_base_pm_plugins_react_nodeview__["b" /* stateKey */].getState(this.props.view.state) })));
    };
    return WrappedInline;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (WrappedInline);
//# sourceMappingURL=blockCard.js.map

/***/ }),
/* 2509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return appearanceForNodeType; });
/* unused harmony export selectedCardAppearance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);

var appearanceForNodeType = function (spec) {
    if (spec.name === 'inlineCard') {
        return 'inline';
    }
    else if (spec.name === 'blockCard') {
        return 'block';
    }
};
var selectedCardAppearance = function (state) {
    return state.selection instanceof __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["NodeSelection"] &&
        appearanceForNodeType(state.selection.node.type);
};
//# sourceMappingURL=utils.js.map

/***/ }),
/* 2510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardNodeView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nodeviews__ = __webpack_require__(84);


var CardNodeView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CardNodeView, _super);
    function CardNodeView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardNodeView.fromComponent = function (component, portalProviderAPI, props) {
        return function (node, view, getPos) {
            return new CardNodeView(node, view, getPos, portalProviderAPI, props, component, true).init();
        };
    };
    return CardNodeView;
}(__WEBPACK_IMPORTED_MODULE_1__nodeviews__["a" /* ReactNodeView */]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 2511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createKeymapPlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keymaps__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commands__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__card_pm_plugins_actions__ = __webpack_require__(294);







function createKeymapPlugin(schema, props) {
    var list = {};
    if (props.appearance !== 'message') {
        __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["d" /* addLink */].common, Object(__WEBPACK_IMPORTED_MODULE_2__analytics__["b" /* trackAndInvoke */])('atlassian.editor.format.hyperlink.keyboard', Object(__WEBPACK_IMPORTED_MODULE_5__commands__["f" /* showLinkToolbar */])()), list);
    }
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["k" /* enter */].common, mayConvertLastWordToHyperlink, list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["s" /* insertNewLine */].common, mayConvertLastWordToHyperlink, list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["l" /* escape */].common, function (state, dispatch, view) {
        var hyperlinkPlugin = __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["e" /* stateKey */].getState(state);
        if (hyperlinkPlugin.activeLinkMark) {
            Object(__WEBPACK_IMPORTED_MODULE_5__commands__["a" /* hideLinkToolbar */])()(state, dispatch);
            if (view) {
                view.focus();
            }
            return false;
        }
        return false;
    }, list);
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__["keymap"])(list);
}
var mayConvertLastWordToHyperlink = function (state, dispatch) {
    var nodeBefore = state.selection.$from.nodeBefore;
    if (!nodeBefore || !nodeBefore.isText) {
        return false;
    }
    var words = nodeBefore.text.split(' ');
    var lastWord = words[words.length - 1];
    var match = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* getLinkMatch */])(lastWord);
    if (match) {
        var hyperlinkedText = match.raw;
        var start = state.selection.$from.pos - hyperlinkedText.length;
        var end = state.selection.$from.pos;
        if (state.doc.rangeHasMark(start, end, state.schema.marks.link)) {
            return false;
        }
        var url = match.url;
        var markType = state.schema.mark('link', { href: url });
        var tr = Object(__WEBPACK_IMPORTED_MODULE_6__card_pm_plugins_actions__["a" /* queueCards */])([
            {
                url: url,
                pos: start,
                appearance: 'inline',
            },
        ])(state.tr.addMark(start, end, markType));
        __WEBPACK_IMPORTED_MODULE_2__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.format.hyperlink.autoformatting');
        if (dispatch) {
            dispatch(tr);
        }
    }
    return false;
};
/* unused harmony default export */ var _unused_webpack_default_export = (createKeymapPlugin);
//# sourceMappingURL=keymap.js.map

/***/ }),
/* 2512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_view__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(164);



var createTextCursor = function (pos) {
    var node = document.createElement('div');
    node.className = 'ProseMirror-fake-text-cursor';
    return __WEBPACK_IMPORTED_MODULE_1_prosemirror_view__["Decoration"].widget(pos, node);
};
var createTextSelection = function (from, to) {
    return __WEBPACK_IMPORTED_MODULE_1_prosemirror_view__["Decoration"].inline(from, to, { class: 'ProseMirror-fake-text-selection' });
};
var getInsertLinkToolbarState = function (editorState) {
    var state = __WEBPACK_IMPORTED_MODULE_2__main__["e" /* stateKey */].getState(editorState);
    if (state && state.activeLinkMark) {
        if (state.activeLinkMark.type === __WEBPACK_IMPORTED_MODULE_2__main__["a" /* InsertStatus */].INSERT_LINK_TOOLBAR) {
            return state.activeLinkMark;
        }
    }
    return undefined;
};
var fakeCursorToolbarPlugin = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
    state: {
        init: function () {
            return __WEBPACK_IMPORTED_MODULE_1_prosemirror_view__["DecorationSet"].empty;
        },
        apply: function (tr, pluginState, oldState, newState) {
            var oldInsertToolbarState = getInsertLinkToolbarState(oldState);
            var insertToolbarState = getInsertLinkToolbarState(newState);
            // Map DecorationSet if it still refers to the same position in the document
            if (oldInsertToolbarState && insertToolbarState) {
                var from = insertToolbarState.from, to = insertToolbarState.to;
                var oldFrom = tr.mapping.map(oldInsertToolbarState.from);
                var oldTo = tr.mapping.map(oldInsertToolbarState.to);
                if (oldFrom === from && oldTo === to) {
                    return pluginState.map(tr.mapping, tr.doc);
                }
            }
            // Update DecorationSet if new insert toolbar, or if we have moved to a different position in the doc
            if (insertToolbarState) {
                var from = insertToolbarState.from, to = insertToolbarState.to;
                return __WEBPACK_IMPORTED_MODULE_1_prosemirror_view__["DecorationSet"].create(tr.doc, [
                    from === to ? createTextCursor(from) : createTextSelection(from, to),
                ]);
            }
            return __WEBPACK_IMPORTED_MODULE_1_prosemirror_view__["DecorationSet"].empty;
        },
    },
    props: {
        decorations: function (state) {
            return fakeCursorToolbarPlugin.getState(state);
        },
    },
});
/* harmony default export */ __webpack_exports__["a"] = (fakeCursorToolbarPlugin);
//# sourceMappingURL=fake-cursor-for-toolbar.js.map

/***/ }),
/* 2513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(115);




var isHrefAndTextEqual = function (node) {
    var mark = node.type.schema.marks.link.isInSet(node.marks);
    return mark ? mark.attrs.href === Object(__WEBPACK_IMPORTED_MODULE_3__utils__["e" /* normalizeUrl */])(node.text) : false;
};
var isInsideLinkMark = function (node) {
    return !!(node && node.type.schema.marks.link.isInSet(node.marks));
};
// Given the position of a link in an old document, apply the
// transactions to determine the new position of this link.
// If the link was deleted during any transactions, return null
var getLinkPosAfterTransactions = function (pos, txns) {
    var e_1, _a;
    var trPos = pos;
    try {
        for (var txns_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](txns), txns_1_1 = txns_1.next(); !txns_1_1.done; txns_1_1 = txns_1.next()) {
            var tr = txns_1_1.value;
            trPos = tr.mapping.map(trPos);
            var _b = tr.doc.resolve(trPos), nodeAfter = _b.nodeAfter, textOffset = _b.textOffset;
            trPos = trPos - textOffset;
            if (!isInsideLinkMark(nodeAfter)) {
                return null;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (txns_1_1 && !txns_1_1.done && (_a = txns_1.return)) _a.call(txns_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return trPos;
};
/**
 * Ensures that when a link that **used** to have the same text
 * as it's url gets modified, that the url is also updated.
 */
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
    appendTransaction: function (txns, oldState, newState) {
        if (txns.some(function (tr) { return tr.docChanged; })) {
            var tr_1 = newState.tr, link_1 = newState.schema.marks.link;
            Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["findChildrenByMark"])(oldState.doc, link_1).forEach(function (item) {
                if (isHrefAndTextEqual(item.node)) {
                    var pos = getLinkPosAfterTransactions(item.pos, txns);
                    if (typeof pos === 'number') {
                        var trPos = tr_1.mapping.map(pos);
                        var node = tr_1.doc.nodeAt(trPos);
                        if (!isHrefAndTextEqual(node)) {
                            var mark = link_1.isInSet(node.marks);
                            tr_1.removeMark(trPos, trPos + node.nodeSize, mark);
                            tr_1.addMark(trPos, trPos + node.nodeSize, mark.type.create({ href: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["e" /* normalizeUrl */])(node.text) }));
                        }
                    }
                }
            });
            return tr_1.docChanged ? tr_1 : undefined;
        }
    },
}));
//# sourceMappingURL=sync-text-and-url.js.map

/***/ }),
/* 2514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export messages */
/* unused harmony export AddDisplayTextToolbar */
/* unused harmony export AddDisplayTextToolbarWithIntl */
/* unused harmony export EditLinkHrefToolbar */
/* unused harmony export EditLinkHrefToolbarWithIntl */
/* unused harmony export InsertLinkToolbar */
/* unused harmony export InsertLinkToolbarWithIntl */
/* unused harmony export ActivityPoweredInsertLinkToolbar */
/* unused harmony export ActivityPoweredInsertLinkToolbarWithIntl */
/* harmony export (immutable) */ __webpack_exports__["a"] = HyperlinkToolbar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commands__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HyperlinkEdit__ = __webpack_require__(2515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RecentSearch__ = __webpack_require__(2518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pm_plugins_main__ = __webpack_require__(164);









var messages = Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["defineMessages"])({
    linkPlaceholder: {
        id: 'fabric.editor.linkPlaceholder',
        defaultMessage: 'Paste link',
        description: 'Create a new link by pasting a URL.',
    },
    linkTextPlaceholder: {
        id: 'fabric.editor.linkTextPlaceholder',
        defaultMessage: 'Text to display',
        description: 'Enter the text you’d like to display for the link (instead of the URL).',
    },
    linkPlaceholderWithSearch: {
        id: 'fabric.editor.linkPlaceholderWithSearch',
        defaultMessage: 'Paste link or search recently viewed',
        description: 'Create a new link by pasting a URL or searching pages you’ve recently visited.',
    },
});
var AddDisplayTextToolbar = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AddDisplayTextToolbar, _super);
    function AddDisplayTextToolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AddDisplayTextToolbar.prototype.render = function () {
        var _a = this.props, pos = _a.pos, node = _a.node, view = _a.view, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, formatMessage = _a.intl.formatMessage;
        var existingLink = node.type.schema.marks.link.isInSet(node.marks).attrs.href;
        var unlink = function () {
            return Object(__WEBPACK_IMPORTED_MODULE_4__commands__["c" /* removeLink */])(pos)(view.state, view.dispatch) && view.focus();
        };
        var hideToolbar = function () {
            return Object(__WEBPACK_IMPORTED_MODULE_4__commands__["a" /* hideLinkToolbar */])()(view.state, view.dispatch) && view.focus();
        };
        var updateLinkText = function (text) {
            return Object(__WEBPACK_IMPORTED_MODULE_4__commands__["e" /* setLinkText */])(pos, text)(view.state, view.dispatch) && view.focus();
        };
        var updateLinkTextOrHideToolbar = function (text) {
            return updateLinkText(text) || hideToolbar();
        };
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__HyperlinkEdit__["a" /* default */], { target: Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findDomRefAtPos"])(pos, view.domAtPos.bind(view)), popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, alwaysOpenLinkAt: existingLink, placeholder: formatMessage(messages.linkTextPlaceholder), onSubmit: updateLinkText, onBlur: updateLinkTextOrHideToolbar, onUnlink: unlink, onOpenLink: function () { } }));
    };
    return AddDisplayTextToolbar;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

var AddDisplayTextToolbarWithIntl = Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["injectIntl"])(AddDisplayTextToolbar);
var EditLinkHrefToolbar = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EditLinkHrefToolbar, _super);
    function EditLinkHrefToolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditLinkHrefToolbar.prototype.render = function () {
        var _a = this.props, pos = _a.pos, node = _a.node, view = _a.view, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, formatMessage = _a.intl.formatMessage;
        var existingLink = node.type.schema.marks.link.isInSet(node.marks).attrs.href;
        var hideToolbar = function () {
            return Object(__WEBPACK_IMPORTED_MODULE_4__commands__["a" /* hideLinkToolbar */])()(view.state, view.dispatch) && view.focus();
        };
        var updateLinkHref = function (href) {
            return Object(__WEBPACK_IMPORTED_MODULE_4__commands__["d" /* setLinkHref */])(pos, href)(view.state, view.dispatch) && view.focus();
        };
        var updateLinkHrefOrHideToolbar = function (href) {
            return updateLinkHref(href) || hideToolbar();
        };
        var unlink = function () {
            return Object(__WEBPACK_IMPORTED_MODULE_4__commands__["c" /* removeLink */])(pos)(view.state, view.dispatch) && view.focus();
        };
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__HyperlinkEdit__["a" /* default */], { target: Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findDomRefAtPos"])(pos, view.domAtPos.bind(view)), popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, defaultValue: existingLink, placeholder: formatMessage(messages.linkPlaceholder), onSubmit: updateLinkHref, onBlur: updateLinkHrefOrHideToolbar, onUnlink: unlink, onOpenLink: function () { } }));
    };
    return EditLinkHrefToolbar;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

var EditLinkHrefToolbarWithIntl = Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["injectIntl"])(EditLinkHrefToolbar);
var InsertLinkToolbar = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](InsertLinkToolbar, _super);
    function InsertLinkToolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InsertLinkToolbar.prototype.render = function () {
        var _a = this.props, from = _a.from, to = _a.to, view = _a.view, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, formatMessage = _a.intl.formatMessage;
        var hideToolbar = function () {
            return Object(__WEBPACK_IMPORTED_MODULE_4__commands__["a" /* hideLinkToolbar */])()(view.state, view.dispatch) && view.focus();
        };
        var addLink = function (href) {
            return Object(__WEBPACK_IMPORTED_MODULE_4__commands__["b" /* insertLink */])(from, to, href)(view.state, view.dispatch) && view.focus();
        };
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__HyperlinkEdit__["a" /* default */], { target: Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findDomRefAtPos"])(from, view.domAtPos.bind(view)), popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, autoFocus: true, placeholder: formatMessage(messages.linkPlaceholder), onSubmit: addLink, onBlur: hideToolbar }));
    };
    return InsertLinkToolbar;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

var InsertLinkToolbarWithIntl = Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["injectIntl"])(InsertLinkToolbar);
var ActivityPoweredInsertLinkToolbar = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ActivityPoweredInsertLinkToolbar, _super);
    function ActivityPoweredInsertLinkToolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActivityPoweredInsertLinkToolbar.prototype.render = function () {
        var _a = this.props, from = _a.from, to = _a.to, view = _a.view, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, activityProvider = _a.activityProvider, formatMessage = _a.intl.formatMessage;
        var hideToolbar = function () {
            return Object(__WEBPACK_IMPORTED_MODULE_4__commands__["a" /* hideLinkToolbar */])()(view.state, view.dispatch) && view.focus();
        };
        var addLink = function (href, text) {
            return Object(__WEBPACK_IMPORTED_MODULE_4__commands__["b" /* insertLink */])(from, to, href, text)(view.state, view.dispatch) &&
                view.focus();
        };
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__RecentSearch__["a" /* default */], { target: Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findDomRefAtPos"])(from, view.domAtPos.bind(view)), popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, autoFocus: true, activityProvider: activityProvider, placeholder: formatMessage(messages.linkPlaceholderWithSearch), onSubmit: addLink, onBlur: hideToolbar }));
    };
    return ActivityPoweredInsertLinkToolbar;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

var ActivityPoweredInsertLinkToolbarWithIntl = Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["injectIntl"])(ActivityPoweredInsertLinkToolbar);
function HyperlinkToolbar(props) {
    var hyperlinkState = props.hyperlinkState, view = props.view, popupsMountPoint = props.popupsMountPoint, popupsBoundariesElement = props.popupsBoundariesElement, activityProvider = props.activityProvider;
    if (hyperlinkState && hyperlinkState.activeLinkMark) {
        if (hyperlinkState.activeLinkMark.type === __WEBPACK_IMPORTED_MODULE_8__pm_plugins_main__["a" /* InsertStatus */].EDIT_LINK_TOOLBAR) {
            var _a = hyperlinkState.activeLinkMark, node = _a.node, pos = _a.pos;
            var mark = view.state.schema.marks.link.isInSet(node.marks);
            var isLinkTextTheSameAsTheLinkUrl = mark.attrs.href === Object(__WEBPACK_IMPORTED_MODULE_7__utils__["e" /* normalizeUrl */])(node.text);
            var Toolbar = isLinkTextTheSameAsTheLinkUrl
                ? AddDisplayTextToolbarWithIntl
                : EditLinkHrefToolbarWithIntl;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Toolbar, { pos: pos, node: node, view: view, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement }));
        }
        else if (hyperlinkState.activeLinkMark.type === __WEBPACK_IMPORTED_MODULE_8__pm_plugins_main__["a" /* InsertStatus */].INSERT_LINK_TOOLBAR) {
            var _b = hyperlinkState.activeLinkMark, from = _b.from, to = _b.to;
            if (activityProvider) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ActivityPoweredInsertLinkToolbarWithIntl, { from: from, to: to, view: view, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, activityProvider: activityProvider }));
            }
            else {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](InsertLinkToolbarWithIntl, { from: from, to: to, view: view, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement }));
            }
        }
    }
    return null;
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 2515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export messages */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_open__ = __webpack_require__(2516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_open___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_open__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_unlink__ = __webpack_require__(2517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_unlink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_unlink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_PanelTextInput__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_FloatingToolbar__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(841);









var messages = Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["defineMessages"])({
    openLink: {
        id: 'fabric.editor.openLink',
        defaultMessage: 'Open link',
        description: 'Follows the hyperlink.',
    },
    unlink: {
        id: 'fabric.editor.unlink',
        defaultMessage: 'Unlink',
        description: 'Removes the hyperlink but keeps your text.',
    },
});
var HyperlinkEdit = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](HyperlinkEdit, _super);
    function HyperlinkEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (text) {
            _this.setState({ text: text });
        };
        _this.handleBlur = function () {
            if (_this.props.onBlur) {
                _this.props.onBlur(_this.state.text);
            }
        };
        _this.handleSubmit = function () {
            if (_this.props.onSubmit) {
                _this.props.onSubmit(_this.state.text);
            }
        };
        _this.state = { text: props.defaultValue || '' };
        return _this;
    }
    HyperlinkEdit.prototype.render = function () {
        var _a = this.props, target = _a.target, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, placeholder = _a.placeholder, onUnlink = _a.onUnlink, autoFocus = _a.autoFocus, onOpenLink = _a.onOpenLink, defaultValue = _a.defaultValue, alwaysOpenLinkAt = _a.alwaysOpenLinkAt, formatMessage = _a.intl.formatMessage;
        var labelOpenLink = formatMessage(messages.openLink);
        var labelUnlink = formatMessage(messages.unlink);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* FloatingToolbar */], { target: Object(__WEBPACK_IMPORTED_MODULE_7__ui_FloatingToolbar__["b" /* getNearestNonTextNode */])(target), popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, fitWidth: 400, fitHeight: 32, offset: [0, 12], className: "normal", zIndex: __WEBPACK_IMPORTED_MODULE_5__atlaskit_editor_common__["m" /* akEditorFloatingDialogZIndex */] },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ui_PanelTextInput__["a" /* default */], { autoFocus: autoFocus, defaultValue: defaultValue || '', placeholder: placeholder, onSubmit: this.handleSubmit, onChange: this.handleChange, onBlur: this.handleBlur, onCancel: this.handleBlur }),
            (onOpenLink || onUnlink) && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["b" /* Separator */], null),
            onOpenLink && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["c" /* ToolbarButton */], { spacing: "compact", href: alwaysOpenLinkAt || this.state.text, onClick: onOpenLink, target: "_blank", title: labelOpenLink, iconBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_open___default.a, { label: labelOpenLink }) })),
            onUnlink && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["c" /* ToolbarButton */], { spacing: "compact", onClick: onUnlink, title: labelUnlink, iconBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_unlink___default.a, { label: labelUnlink }) }))));
    };
    return HyperlinkEdit;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["injectIntl"])(HyperlinkEdit));
//# sourceMappingURL=index.js.map

/***/ }),
/* 2516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorOpenIcon = function EditorOpenIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M9.873 7.63c-.28 0-.344.159-.147.357l2.436 2.436-4.386 4.386a.509.509 0 0 0 0 .713l.7.7a.495.495 0 0 0 .713.001l4.387-4.386 2.436 2.436c.197.197.357.124.357-.147V8.133a.507.507 0 0 0-.503-.503H9.873z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorOpenIcon.displayName = 'EditorOpenIcon';
var _default = EditorOpenIcon;
exports.default = _default;

/***/ }),
/* 2517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorUnlinkIcon = function EditorUnlinkIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M5 10V9h2v1H5zm4-5h1v2H9V5zm7.646 12.354l.708-.708 2 2-.708.708-2-2zM17 15v-1h2v1h-2zm-3 2h1v2h-1v-2zM7.354 6.646l-.708.708-2-2 .708-.708 2 2zm3.567 9.037l1.061-1.062a.75.75 0 1 1 1.06 1.061l-1.06 1.061a3.249 3.249 0 0 1-4.596 0 3.247 3.247 0 0 1 0-4.596l1.06-1.061.703-.703c.793-.63 1.773.35 1.06 1.06l-.702.703-1.06 1.062a1.747 1.747 0 0 0 0 2.474 1.749 1.749 0 0 0 2.474 0zm2.658-7.608l-1.061 1.061a.75.75 0 0 1-1.06-1.06l1.06-1.062a3.249 3.249 0 0 1 4.596 0 3.247 3.247 0 0 1 0 4.596l-1.06 1.062-.703.702c-.565.565-1.581-.45-1.06-1.06l.702-.703 1.06-1.061a1.747 1.747 0 0 0 0-2.475 1.749 1.749 0 0 0-2.474 0z\" fill=\"currentColor\"/></svg>"
  }, props));
};

EditorUnlinkIcon.displayName = 'EditorUnlinkIcon';
var _default = EditorUnlinkIcon;
exports.default = _default;

/***/ }),
/* 2518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_PanelTextInput__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RecentList__ = __webpack_require__(2519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_FloatingToolbar__ = __webpack_require__(216);









var Container = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  width: 420px;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n"], ["\n  width: 420px;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n"])));
var RecentSearch = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](RecentSearch, _super);
    function RecentSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedIndex: -1,
            isLoading: false,
            text: '',
            items: [],
        };
        _this.updateInput = function (input) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](_this, void 0, void 0, function () {
            var _a, _b, _c, _d, _e, _f;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_g) {
                switch (_g.label) {
                    case 0:
                        this.setState({ text: input });
                        if (!this.state.activityProvider) return [3 /*break*/, 4];
                        if (!(input.length === 0)) return [3 /*break*/, 2];
                        _a = this.setState;
                        _b = {};
                        _c = limit;
                        return [4 /*yield*/, this.state.activityProvider.getRecentItems()];
                    case 1:
                        _a.apply(this, [(_b.items = _c.apply(void 0, [_g.sent()]),
                                _b.selectedIndex = -1,
                                _b)]);
                        return [3 /*break*/, 4];
                    case 2:
                        _d = this.setState;
                        _e = {};
                        _f = limit;
                        return [4 /*yield*/, this.state.activityProvider.searchRecent(input)];
                    case 3:
                        _d.apply(this, [(_e.items = _f.apply(void 0, [_g.sent()]),
                                _e.selectedIndex = 0,
                                _e)]);
                        _g.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.handleSelected = function (href, text) {
            if (_this.props.onSubmit) {
                _this.props.onSubmit(href, text);
                _this.trackAutoCompleteAnalyticsEvent('atlassian.editor.format.hyperlink.autocomplete.click');
            }
        };
        _this.handleMouseMove = function (objectId) {
            var items = _this.state.items;
            if (items) {
                var index = findIndex(items, function (item) { return item.objectId === objectId; });
                _this.setState({
                    selectedIndex: index,
                });
            }
        };
        _this.handleSubmit = function () {
            var _a = _this.state, items = _a.items, text = _a.text, selectedIndex = _a.selectedIndex;
            // add the link selected in the dropdown if there is one, otherwise submit the value of the input field
            if (items && items.length > 0 && selectedIndex > -1) {
                var item = items[selectedIndex];
                if (_this.props.onSubmit) {
                    _this.props.onSubmit(item.url, item.name);
                    _this.trackAutoCompleteAnalyticsEvent('atlassian.editor.format.hyperlink.autocomplete.keyboard');
                }
            }
            else if (text && text.length > 0) {
                if (_this.props.onSubmit) {
                    _this.props.onSubmit(text);
                    _this.trackAutoCompleteAnalyticsEvent('atlassian.editor.format.hyperlink.autocomplete.notselected');
                }
            }
        };
        _this.handleKeyDown = function (e) {
            var _a = _this.state, items = _a.items, selectedIndex = _a.selectedIndex;
            if (!items || !items.length) {
                return;
            }
            if (e.keyCode === 40) {
                // down
                e.preventDefault();
                _this.setState({
                    selectedIndex: (selectedIndex + 1) % items.length,
                });
            }
            else if (e.keyCode === 38) {
                // up
                e.preventDefault();
                _this.setState({
                    selectedIndex: selectedIndex > 0 ? selectedIndex - 1 : items.length - 1,
                });
            }
        };
        _this.handleBlur = function () {
            if (_this.props.onBlur) {
                _this.props.onBlur(_this.state.text);
            }
        };
        return _this;
    }
    RecentSearch.prototype.resolveProvider = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
            var activityProvider;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.activityProvider];
                    case 1:
                        activityProvider = _a.sent();
                        this.setState({ activityProvider: activityProvider });
                        return [2 /*return*/, activityProvider];
                }
            });
        });
    };
    RecentSearch.prototype.componentDidMount = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
            var activityProvider;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resolveProvider()];
                    case 1:
                        activityProvider = _a.sent();
                        this.loadRecentItems(activityProvider);
                        return [2 /*return*/];
                }
            });
        });
    };
    RecentSearch.prototype.loadRecentItems = function (activityProvider) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
            var _a, _b, _c;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, , 2, 3]);
                        this.setState({ isLoading: true });
                        _a = this.setState;
                        _b = {};
                        _c = limit;
                        return [4 /*yield*/, activityProvider.getRecentItems()];
                    case 1:
                        _a.apply(this, [(_b.items = _c.apply(void 0, [_d.sent()]), _b)]);
                        return [3 /*break*/, 3];
                    case 2:
                        this.setState({ isLoading: false });
                        return [7 /*endfinally*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RecentSearch.prototype.render = function () {
        var _a = this.props, target = _a.target, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, placeholder = _a.placeholder;
        var _b = this.state, items = _b.items, isLoading = _b.isLoading, selectedIndex = _b.selectedIndex;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["a" /* FloatingToolbar */], { target: Object(__WEBPACK_IMPORTED_MODULE_7__ui_FloatingToolbar__["b" /* getNearestNonTextNode */])(target), popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, fitWidth: 420, fitHeight: 350, zIndex: 500, offset: [0, 12], className: "recent-search" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Container, null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ui_PanelTextInput__["a" /* default */], { placeholder: placeholder, autoFocus: true, onSubmit: this.handleSubmit, onChange: this.updateInput, onBlur: this.handleBlur, onCancel: this.handleBlur, onKeyDown: this.handleKeyDown }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__RecentList__["a" /* default */], { items: items, isLoading: isLoading, selectedIndex: selectedIndex, onSelect: this.handleSelected, onMouseMove: this.handleMouseMove }))));
    };
    RecentSearch.prototype.trackAutoCompleteAnalyticsEvent = function (name) {
        var numChars = this.state.text ? this.state.text.length : 0;
        __WEBPACK_IMPORTED_MODULE_3__analytics__["a" /* analyticsService */].trackEvent(name, { numChars: numChars });
    };
    return RecentSearch;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (RecentSearch);
var findIndex = function (array, predicate) {
    var index = -1;
    array.some(function (item, i) {
        if (predicate(item)) {
            index = i;
            return true;
        }
        return false;
    });
    return index;
};
var limit = function (items) {
    return items.slice(0, 5);
};
var templateObject_1;
//# sourceMappingURL=index.js.map

/***/ }),
/* 2519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_spinner__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RecentItem__ = __webpack_require__(2520);






// tslint:disable-next-line:variable-name
var Container = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  padding-top: 10px;\n"], ["\n  padding-top: 10px;\n"])));
var ListContainer = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  padding-top: 0;\n"], ["\n  padding-top: 0;\n"])));
// tslint:disable-next-line:variable-name
var SpinnerContainer = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  text-align: center;\n  min-height: 80px;\n  margin-top: 30px;\n"], ["\n  text-align: center;\n  min-height: 80px;\n  margin-top: 30px;\n"])));
// tslint:disable:next-line variable-name
var List = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].ul(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  padding: 0;\n  list-style: none;\n"], ["\n  padding: 0;\n  list-style: none;\n"])));
var RecentList = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](RecentList, _super);
    function RecentList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecentList.prototype.render = function () {
        var _a = this.props, onSelect = _a.onSelect, onMouseMove = _a.onMouseMove, items = _a.items, selectedIndex = _a.selectedIndex, isLoading = _a.isLoading;
        if (isLoading) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Container, null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](SpinnerContainer, null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_spinner__["a" /* default */], { invertColor: true, size: "medium" }))));
        }
        if (!items || items.length === 0) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ListContainer, null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](List, null, items.map(function (item, index) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__RecentItem__["a" /* default */], { item: item, selected: selectedIndex === index, onMouseMove: onMouseMove, onSelect: onSelect, key: item.objectId })); }))));
    };
    return RecentList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (RecentList);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=RecentList.js.map

/***/ }),
/* 2520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Name */
/* unused harmony export ContainerName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__ = __webpack_require__(3);




var Container = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].li(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  background-color: ", ";\n  padding: 5px 8px;\n  cursor: pointer;\n  display: flex;\n"], ["\n  background-color: ",
    ";\n  padding: 5px 8px;\n  cursor: pointer;\n  display: flex;\n"])), function (props) {
    return props.selected ? __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N20 : 'transparent';
});
var NameWrapper = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"])));
var Name = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  color: ", ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  color: ", ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])), __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N800);
var ContainerName = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  color: ", ";\n  font-size: 12px;\n"], ["\n  color: ", ";\n  font-size: 12px;\n"])), __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N100);
var Icon = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(templateObject_5 || (templateObject_5 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  min-width: 16px;\n  margin-top: 3px;\n  margin-right: 8px;\n"], ["\n  min-width: 16px;\n  margin-top: 3px;\n  margin-right: 8px;\n"])));
var RecentItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](RecentItem, _super);
    function RecentItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSelect = function (e) {
            e.preventDefault(); // don't let editor lose focus
            var _a = _this.props, item = _a.item, onSelect = _a.onSelect;
            onSelect(item.url, item.name);
        };
        _this.handleMouseMove = function () {
            var _a = _this.props, onMouseMove = _a.onMouseMove, item = _a.item;
            onMouseMove(item.objectId);
        };
        return _this;
    }
    RecentItem.prototype.render = function () {
        var _a = this.props, item = _a.item, selected = _a.selected;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Container, { selected: selected, onMouseMove: this.handleMouseMove, onMouseDown: this.handleSelect },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Icon, null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", { src: item.iconUrl })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](NameWrapper, null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Name, null, item.name),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ContainerName, null, item.container))));
    };
    return RecentItem;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (RecentItem);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=RecentItem.js.map

/***/ }),
/* 2521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pm_plugins_input_rule__ = __webpack_require__(2524);


var imageUpload = {
    pmPlugins: function () {
        return [
            {
                name: 'imageUpload',
                plugin: __WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__["a" /* createPlugin */],
            },
            {
                name: 'imageUploadInputRule',
                plugin: function (_a) {
                    var schema = _a.schema;
                    return Object(__WEBPACK_IMPORTED_MODULE_1__pm_plugins_input_rule__["a" /* default */])(schema);
                },
            },
        ];
    },
};
/* harmony default export */ __webpack_exports__["a"] = (imageUpload);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isDroppedFile;
function isDroppedFile(rawEvent) {
    var e = rawEvent;
    if (!e.dataTransfer) {
        return false;
    }
    return (Array.prototype.slice.call(e.dataTransfer.types).indexOf('Files') !== -1);
}
//# sourceMappingURL=drag-drop.js.map

/***/ }),
/* 2523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return startUpload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(296);

var imageUploadAction = function (tr, action) {
    return tr.setMeta(__WEBPACK_IMPORTED_MODULE_0__main__["b" /* stateKey */], action);
};
var startUpload = function (event) { return function (tr) {
    return imageUploadAction(tr, {
        name: 'START_UPLOAD',
        event: event,
    });
}; };
//# sourceMappingURL=actions.js.map

/***/ }),
/* 2524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export inputRulePlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_input_rules__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(455);




function inputRulePlugin(schema) {
    if (!schema.nodes.media || !schema.nodes.mediaSingle) {
        return;
    }
    // ![something](link) should convert to an image
    var imageRule = Object(__WEBPACK_IMPORTED_MODULE_2__utils_input_rules__["a" /* createInputRule */])(/!\[(.*)\]\((\S+)\)$/, function (state, match, start, end) {
        var schema = state.schema;
        var attrs = {
            src: match[2],
            alt: match[1],
        };
        var node = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* createExternalMediaNode */])(attrs.src, schema);
        if (node) {
            __WEBPACK_IMPORTED_MODULE_1__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.image.autoformatting');
            return state.tr.replaceWith(start, end, node);
        }
        return null;
    });
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["inputRules"])({
        rules: [imageRule],
    });
}
/* harmony default export */ __webpack_exports__["a"] = (inputRulePlugin);
//# sourceMappingURL=input-rule.js.map

/***/ }),
/* 2525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__block_type_pm_plugins_main__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__media_pm_plugins_main__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hyperlink_pm_plugins_main__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mentions__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__table_pm_plugins_main__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__image_upload_pm_plugins_main__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__placeholder_text__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__layout__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__macro__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__date_plugin__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__emoji_pm_plugins_main__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ui_Toolbar__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ui_ToolbarInsertBlock__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__block_type_commands__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__image_upload_pm_plugins_commands__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__type_ahead_pm_plugins_main__ = __webpack_require__(107);



















var toolbarSizeToButtons = function (toolbarSize) {
    switch (toolbarSize) {
        case __WEBPACK_IMPORTED_MODULE_14__ui_Toolbar__["a" /* ToolbarSize */].XXL:
        case __WEBPACK_IMPORTED_MODULE_14__ui_Toolbar__["a" /* ToolbarSize */].XL:
        case __WEBPACK_IMPORTED_MODULE_14__ui_Toolbar__["a" /* ToolbarSize */].L:
        case __WEBPACK_IMPORTED_MODULE_14__ui_Toolbar__["a" /* ToolbarSize */].M:
            return 6;
        case __WEBPACK_IMPORTED_MODULE_14__ui_Toolbar__["a" /* ToolbarSize */].S:
            return 2;
        default:
            return 0;
    }
};
var insertBlockPlugin = function (options) { return ({
    primaryToolbarComponent: function (_a) {
        var editorView = _a.editorView, appearance = _a.appearance, editorActions = _a.editorActions, eventDispatcher = _a.eventDispatcher, providerFactory = _a.providerFactory, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, popupsScrollableElement = _a.popupsScrollableElement, toolbarSize = _a.toolbarSize, disabled = _a.disabled, isToolbarReducedSpacing = _a.isToolbarReducedSpacing;
        var buttons = toolbarSizeToButtons(toolbarSize);
        var renderNode = function (providers) {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__ui_WithPluginState__["a" /* default */], { plugins: {
                    typeAheadState: __WEBPACK_IMPORTED_MODULE_18__type_ahead_pm_plugins_main__["d" /* pluginKey */],
                    blockTypeState: __WEBPACK_IMPORTED_MODULE_2__block_type_pm_plugins_main__["b" /* pluginKey */],
                    mediaState: __WEBPACK_IMPORTED_MODULE_3__media_pm_plugins_main__["b" /* stateKey */],
                    mentionState: __WEBPACK_IMPORTED_MODULE_5__mentions__["b" /* mentionPluginKey */],
                    tablesState: __WEBPACK_IMPORTED_MODULE_6__table_pm_plugins_main__["e" /* pluginKey */],
                    macroState: __WEBPACK_IMPORTED_MODULE_10__macro__["c" /* pluginKey */],
                    hyperlinkState: __WEBPACK_IMPORTED_MODULE_4__hyperlink_pm_plugins_main__["e" /* stateKey */],
                    emojiState: __WEBPACK_IMPORTED_MODULE_12__emoji_pm_plugins_main__["b" /* emojiPluginKey */],
                    dateState: __WEBPACK_IMPORTED_MODULE_11__date_plugin__["b" /* pluginKey */],
                    imageUpload: __WEBPACK_IMPORTED_MODULE_7__image_upload_pm_plugins_main__["b" /* stateKey */],
                    placeholderTextState: __WEBPACK_IMPORTED_MODULE_8__placeholder_text__["b" /* pluginKey */],
                    layoutState: __WEBPACK_IMPORTED_MODULE_9__layout__["b" /* pluginKey */],
                }, render: function (_a) {
                    var typeAheadState = _a.typeAheadState, mentionState = _a.mentionState, blockTypeState = _a.blockTypeState, mediaState = _a.mediaState, tablesState = _a.tablesState, _b = _a.macroState, macroState = _b === void 0 ? {} : _b, hyperlinkState = _a.hyperlinkState, emojiState = _a.emojiState, dateState = _a.dateState, imageUpload = _a.imageUpload, placeholderTextState = _a.placeholderTextState, layoutState = _a.layoutState;
                    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__ui_ToolbarInsertBlock__["a" /* default */], { buttons: buttons, isReducedSpacing: isToolbarReducedSpacing, isDisabled: disabled, isTypeAheadAllowed: typeAheadState.isAllowed, editorView: editorView, tableSupported: !!tablesState, actionSupported: !!editorView.state.schema.nodes.taskItem, mentionsSupported: !!(mentionState && mentionState.provider), mentionsEnabled: mentionState, decisionSupported: !!editorView.state.schema.nodes.decisionItem, dateEnabled: !!dateState, placeholderTextEnabled: placeholderTextState && placeholderTextState.allowInserting, layoutSectionEnabled: !!layoutState, mediaUploadsEnabled: mediaState && mediaState.allowsUploads, onShowMediaPicker: mediaState && mediaState.showMediaPicker, mediaSupported: !!mediaState, imageUploadSupported: !!imageUpload, imageUploadEnabled: imageUpload && imageUpload.enabled, handleImageUpload: __WEBPACK_IMPORTED_MODULE_17__image_upload_pm_plugins_commands__["b" /* startImageUpload */], availableWrapperBlockTypes: blockTypeState.availableWrapperBlockTypes, linkSupported: !!hyperlinkState, linkDisabled: !hyperlinkState ||
                            !hyperlinkState.canInsertLink ||
                            hyperlinkState.activeLinkMark, emojiDisabled: !emojiState || !emojiState.enabled, insertEmoji: emojiState && emojiState.insertEmoji, emojiProvider: providers.emojiProvider, nativeStatusSupported: options.nativeStatusSupported, horizontalRuleEnabled: options.horizontalRuleEnabled, onInsertBlockType: __WEBPACK_IMPORTED_MODULE_16__block_type_commands__["b" /* insertBlockType */], onInsertMacroFromMacroBrowser: __WEBPACK_IMPORTED_MODULE_10__macro__["b" /* insertMacroFromMacroBrowser */], macroProvider: macroState.macroProvider, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, insertMenuItems: options.insertMenuItems, editorActions: editorActions }));
                } }));
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__atlaskit_editor_common__["j" /* WithProviders */], { providerFactory: providerFactory, providers: ['emojiProvider'], renderNode: renderNode }));
    },
}); };
/* harmony default export */ __webpack_exports__["a"] = (insertBlockPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return itemsListUpdated; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__ = __webpack_require__(107);

var itemsListUpdated = function (items) { return function (state, dispatch) {
    if (dispatch) {
        dispatch(state.tr.setMeta(__WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__["d" /* pluginKey */], {
            action: __WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__["a" /* ACTIONS */].ITEMS_LIST_UPDATED,
            items: items,
        }));
    }
    return true;
}; };
//# sourceMappingURL=items-list-updated.js.map

/***/ }),
/* 2527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isQueryActive;
function isQueryActive(mark, doc, from, to) {
    var active = false;
    doc.nodesBetween(from, to, function (node) {
        if (!active && mark.isInSet(node.marks)) {
            active = true;
        }
    });
    return active;
}
//# sourceMappingURL=is-query-active.js.map

/***/ }),
/* 2528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_mention__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_mention___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_mention__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_ToolbarButton__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commands_insert_mention_query__ = __webpack_require__(831);







var ToolbarMention = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ToolbarMention, _super);
    function ToolbarMention() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleInsertMention = Object(__WEBPACK_IMPORTED_MODULE_3__analytics__["c" /* withAnalytics */])('atlassian.fabric.mention.picker.trigger.button', function () {
            if (!_this.props.editorView) {
                return false;
            }
            Object(__WEBPACK_IMPORTED_MODULE_5__commands_insert_mention_query__["a" /* insertMentionQuery */])()(_this.props.editorView.state, _this.props.editorView.dispatch);
            return true;
        });
        return _this;
    }
    ToolbarMention.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ui_ToolbarButton__["a" /* default */], { spacing: "none", onClick: this.handleInsertMention, disabled: this.props.isDisabled, title: "Mention @", iconBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_mention___default.a, { label: "Mention" }) }));
    };
    return ToolbarMention;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (ToolbarMention);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_Mention__ = __webpack_require__(2530);



var MentionNode = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionNode, _super);
    function MentionNode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MentionNode.prototype.render = function () {
        var _a = this.props, node = _a.node, providerFactory = _a.providerFactory;
        var _b = node.attrs, id = _b.id, text = _b.text, accessLevel = _b.accessLevel;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__ui_Mention__["a" /* default */], { id: id, text: text, accessLevel: accessLevel, providers: providerFactory }));
    };
    return MentionNode;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (MentionNode);
//# sourceMappingURL=mention.js.map

/***/ }),
/* 2530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_mention__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);





var Mention = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Mention, _super);
    function Mention(props) {
        var _this = _super.call(this, props) || this;
        _this.renderWithProvider = function (providers) {
            var _a = _this.props, accessLevel = _a.accessLevel, eventHandlers = _a.eventHandlers, id = _a.id, text = _a.text;
            var mentionProvider = providers.mentionProvider;
            var actionHandlers = {};
            ['onClick', 'onMouseEnter', 'onMouseLeave'].forEach(function (handler) {
                actionHandlers[handler] =
                    (eventHandlers && eventHandlers[handler]) || (function () { });
            });
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_mention__["c" /* ResourcedMention */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ id: id, text: text, accessLevel: accessLevel, mentionProvider: mentionProvider }, actionHandlers)));
        };
        _this.providerFactory = props.providers || new __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["f" /* ProviderFactory */]();
        return _this;
    }
    Mention.prototype.componentWillUnmount = function () {
        if (!this.props.providers) {
            // new ProviderFactory is created if no `providers` has been set
            // in this case when component is unmounted it's safe to destroy this providerFactory
            this.providerFactory.destroy();
        }
    };
    Mention.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["j" /* WithProviders */], { providers: ['mentionProvider', 'profilecardProvider'], providerFactory: this.providerFactory, renderNode: this.renderWithProvider }));
    };
    return Mention;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Mention);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export buildAnalyticsPayload */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildTypeAheadCancelPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buildTypeAheadInsertedPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return buildTypeAheadRenderedPayload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_analytics_gas_types__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_mention__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__package_json__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__package_json__);




var componentName = 'mention';
var buildAnalyticsPayload = function (actionSubject, action, eventType, sessionId, otherAttributes) {
    if (otherAttributes === void 0) { otherAttributes = {}; }
    return ({
        action: action,
        actionSubject: actionSubject,
        eventType: eventType,
        attributes: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ packageName: __WEBPACK_IMPORTED_MODULE_3__package_json__["name"],
            packageVersion: __WEBPACK_IMPORTED_MODULE_3__package_json__["version"],
            componentName: componentName,
            sessionId: sessionId }, otherAttributes),
    });
};
var emptyQueryResponse = {
    queryLength: 0,
    spaceInQuery: false,
};
var extractAttributesFromQuery = function (query) {
    if (query) {
        return {
            queryLength: query.length,
            spaceInQuery: query.indexOf(' ') !== -1,
        };
    }
    return emptyQueryResponse;
};
var buildTypeAheadCancelPayload = function (duration, upKeyCount, downKeyCount, sessionId, query) {
    var _a = extractAttributesFromQuery(query), queryLength = _a.queryLength, spaceInQuery = _a.spaceInQuery;
    return buildAnalyticsPayload('mentionTypeahead', 'cancelled', __WEBPACK_IMPORTED_MODULE_1__atlaskit_analytics_gas_types__["d" /* UI_EVENT_TYPE */], sessionId, {
        duration: duration,
        downKeyCount: downKeyCount,
        upKeyCount: upKeyCount,
        queryLength: queryLength,
        spaceInQuery: spaceInQuery,
    });
};
var getPosition = function (mentionList, selectedMention) {
    if (mentionList) {
        var index = mentionList.findIndex(function (mention) { return mention.id === selectedMention.id; });
        return index === -1 ? undefined : index;
    }
    return;
};
var isClicked = function (insertType) { return insertType === 'selected'; };
var buildTypeAheadInsertedPayload = function (duration, upKeyCount, downKeyCount, sessionId, insertType, mention, mentionList, query) {
    var _a = extractAttributesFromQuery(query), queryLength = _a.queryLength, spaceInQuery = _a.spaceInQuery;
    return buildAnalyticsPayload('mentionTypeahead', isClicked(insertType) ? 'clicked' : 'pressed', __WEBPACK_IMPORTED_MODULE_1__atlaskit_analytics_gas_types__["d" /* UI_EVENT_TYPE */], sessionId, {
        duration: duration,
        position: getPosition(mentionList, mention),
        keyboardKey: isClicked(insertType) ? undefined : insertType,
        queryLength: queryLength,
        spaceInQuery: spaceInQuery,
        isSpecial: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_mention__["d" /* isSpecialMention */])(mention),
        accessLevel: mention.accessLevel || '',
        userType: mention.userType,
        userId: mention.id,
        upKeyCount: upKeyCount,
        downKeyCount: downKeyCount,
    });
};
var buildTypeAheadRenderedPayload = function (duration, userIds, query) {
    var _a = extractAttributesFromQuery(query), queryLength = _a.queryLength, spaceInQuery = _a.spaceInQuery;
    return {
        action: 'rendered',
        actionSubject: 'mentionTypeahead',
        eventType: __WEBPACK_IMPORTED_MODULE_1__atlaskit_analytics_gas_types__["a" /* OPERATIONAL_EVENT_TYPE */],
        attributes: {
            packageName: __WEBPACK_IMPORTED_MODULE_3__package_json__["name"],
            packageVersion: __WEBPACK_IMPORTED_MODULE_3__package_json__["version"],
            componentName: componentName,
            duration: duration,
            userIds: userIds,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
        },
    };
};
//# sourceMappingURL=analytics.js.map

/***/ }),
/* 2532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export messages */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildToolbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_layout_two_equal__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_layout_two_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_layout_two_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_layout_three_equal__ = __webpack_require__(2533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_layout_three_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_layout_three_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_remove__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_remove__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__messages__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__breakout_utils_create_breakout_toolbar_items__ = __webpack_require__(805);









var messages = Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["defineMessages"])({
    twoColumns: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: 'Two columns',
        description: '',
    },
    threeColumns: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: 'Three columns',
        description: '',
    },
});
var LAYOUT_TYPES = [
    { type: 'two_equal', title: messages.twoColumns, icon: __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_layout_two_equal___default.a },
    {
        type: 'three_equal',
        title: messages.threeColumns,
        icon: __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_layout_three_equal___default.a,
    },
];
var buildLayoutButton = function (intl, item, currentLayout) { return ({
    type: 'button',
    icon: item.icon,
    title: intl.formatMessage(item.title),
    onClick: Object(__WEBPACK_IMPORTED_MODULE_7__actions__["f" /* setPresetLayout */])(item.type),
    selected: !!currentLayout && currentLayout === item.type,
}); };
var buildToolbar = function (state, intl, pos, allowBreakout) {
    var node = state.doc.nodeAt(pos);
    if (node) {
        var currentLayout_1 = Object(__WEBPACK_IMPORTED_MODULE_7__actions__["d" /* getPresetLayout */])(node);
        var breakoutToolbar = allowBreakout
            ? Object(__WEBPACK_IMPORTED_MODULE_8__breakout_utils_create_breakout_toolbar_items__["a" /* createBreakoutToolbarItems */])(state, {
                formatMessage: intl.formatMessage,
            })
            : null;
        var separator = {
            type: 'separator',
        };
        var deleteButton = {
            type: 'button',
            appearance: 'danger',
            icon: __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_remove___default.a,
            title: intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__messages__["a" /* default */].remove),
            onClick: __WEBPACK_IMPORTED_MODULE_7__actions__["b" /* deleteActiveLayoutNode */],
        };
        return {
            title: 'Columns floating controls',
            getDomRef: function (view) {
                return Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["findDomRefAtPos"])(pos, view.domAtPos.bind(view));
            },
            nodeType: state.schema.nodes.layoutSection,
            items: __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](LAYOUT_TYPES.map(function (i) { return buildLayoutButton(intl, i, currentLayout_1); }), (breakoutToolbar ? __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"]([separator], breakoutToolbar) : []), [
                separator,
                deleteButton,
            ]),
        };
    }
};
//# sourceMappingURL=toolbar.js.map

/***/ }),
/* 2533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorLayoutThreeEqualIcon = function EditorLayoutThreeEqualIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M5 5h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm6 0h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm6 0h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorLayoutThreeEqualIcon.displayName = 'EditorLayoutThreeEqualIcon';
var _default = EditorLayoutThreeEqualIcon;
exports.default = _default;

/***/ }),
/* 2534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pluginKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeviews__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nodeviews_jira_issue__ = __webpack_require__(2535);




var pluginKey = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["PluginKey"]('jiraIssuePlugin');
var createPlugin = function (_a) {
    var portalProviderAPI = _a.portalProviderAPI;
    return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
        key: pluginKey,
        props: {
            nodeViews: {
                confluenceJiraIssue: __WEBPACK_IMPORTED_MODULE_2__nodeviews__["a" /* ReactNodeView */].fromComponent(__WEBPACK_IMPORTED_MODULE_3__nodeviews_jira_issue__["a" /* default */], portalProviderAPI),
            },
        },
    });
};
var jiraIssuePlugin = {
    nodes: function () {
        return [{ name: 'confluenceJiraIssue', node: __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["q" /* confluenceJiraIssue */] }];
    },
    pmPlugins: function () {
        return [
            {
                name: 'jiraIssue',
                plugin: createPlugin,
            },
        ];
    },
};
/* harmony default export */ __webpack_exports__["a"] = (jiraIssuePlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = JIRAIssueNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_logo__ = __webpack_require__(2536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__ = __webpack_require__(3);





// tslint:disable-next-line:variable-name
var WrapperNode = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  align-items: center;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  box-sizing: border-box;\n  cursor: default;\n  display: inline-flex;\n  font-size: 13px;\n  margin: 0 2px;\n  min-height: 24px;\n  padding: 0 4px;\n  user-select: none;\n  vertical-align: middle;\n  white-space: nowrap;\n\n  .ProseMirror-selectednode & {\n    background: ", ";\n    outline: none;\n  }\n"], ["\n  align-items: center;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  box-sizing: border-box;\n  cursor: default;\n  display: inline-flex;\n  font-size: 13px;\n  margin: 0 2px;\n  min-height: 24px;\n  padding: 0 4px;\n  user-select: none;\n  vertical-align: middle;\n  white-space: nowrap;\n\n  .ProseMirror-selectednode & {\n    background: ", ";\n    outline: none;\n  }\n"])), __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["colors"].N30, __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["colors"].N50, Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["borderRadius"])(), __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["colors"].N50);
// tslint:disable-next-line:variable-name
var JiraChildNode = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: inline-block;\n  color: #707070;\n  line-height: 24px;\n  vertical-align: top;\n\n  &::before {\n    color: black;\n    content: 'JIRA | ';\n  }\n"], ["\n  display: inline-block;\n  color: #707070;\n  line-height: 24px;\n  vertical-align: top;\n\n  &::before {\n    color: black;\n    content: 'JIRA | ';\n  }\n"])));
// tslint:disable-next-line:variable-name
var SvgChildNode = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: inline-block;\n  height: 24px;\n  vertical-align: top;\n  width: 24px;\n\n  & > div {\n    height: 24px;\n    width: 24px;\n  }\n"], ["\n  display: inline-block;\n  height: 24px;\n  vertical-align: top;\n  width: 24px;\n\n  & > div {\n    height: 24px;\n    width: 24px;\n  }\n"])));
function JIRAIssueNode(props) {
    var issueKey = props.node.attrs.issueKey;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](WrapperNode, null,
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](SvgChildNode, null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_logo__["a" /* JiraIcon */], { size: "small" })),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](JiraChildNode, null, issueKey)));
}
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=jira-issue.js.map

/***/ }),
/* 2536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AtlassianLogo__ = __webpack_require__(2537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BitbucketLogo__ = __webpack_require__(2541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConfluenceLogo__ = __webpack_require__(2545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HipchatLogo__ = __webpack_require__(2549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__JiraCoreLogo__ = __webpack_require__(2553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__JiraLogo__ = __webpack_require__(2557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__JiraServiceDeskLogo__ = __webpack_require__(2561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__JiraSoftwareLogo__ = __webpack_require__(2565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StatuspageLogo__ = __webpack_require__(2569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StrideLogo__ = __webpack_require__(2573);
/* unused harmony reexport AtlassianLogo */
/* unused harmony reexport AtlassianIcon */
/* unused harmony reexport AtlassianWordmark */
/* unused harmony reexport BitbucketLogo */
/* unused harmony reexport BitbucketIcon */
/* unused harmony reexport BitbucketWordmark */
/* unused harmony reexport ConfluenceLogo */
/* unused harmony reexport ConfluenceIcon */
/* unused harmony reexport ConfluenceWordmark */
/* unused harmony reexport HipchatLogo */
/* unused harmony reexport HipchatIcon */
/* unused harmony reexport HipchatWordmark */
/* unused harmony reexport JiraCoreLogo */
/* unused harmony reexport JiraCoreIcon */
/* unused harmony reexport JiraCoreWordmark */
/* unused harmony reexport JiraLogo */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__JiraLogo__["a"]; });
/* unused harmony reexport JiraWordmark */
/* unused harmony reexport JiraServiceDeskLogo */
/* unused harmony reexport JiraServiceDeskIcon */
/* unused harmony reexport JiraServiceDeskWordmark */
/* unused harmony reexport JiraSoftwareLogo */
/* unused harmony reexport JiraSoftwareIcon */
/* unused harmony reexport JiraSoftwareWordmark */
/* unused harmony reexport StatuspageLogo */
/* unused harmony reexport StatuspageIcon */
/* unused harmony reexport StatuspageWordmark */
/* unused harmony reexport StrideLogo */
/* unused harmony reexport StrideIcon */
/* unused harmony reexport StrideWordmark */












/***/ }),
/* 2537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logo__ = __webpack_require__(2538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Wordmark__ = __webpack_require__(2540);
/* unused harmony reexport AtlassianLogo */
/* unused harmony reexport AtlassianIcon */
/* unused harmony reexport AtlassianWordmark */





/***/ }),
/* 2538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */





var svg = function svg(iconGradientStart, iconGradientStop) {
  var id = __WEBPACK_IMPORTED_MODULE_8_uuid___default()();
  return "<canvas height=\"32\" width=\"190\" aria-hidden=\"true\"></canvas>\n  <svg viewBox=\"0 0 190 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"99.684716%\" y1=\"15.8138128%\" x2=\"39.8444399%\" y2=\"97.4388388%\" id=\"".concat(id, "\">\n        <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path d=\"M6.90502605,15.6123193 C6.76436383,15.4302139 6.53773035,15.3340846 6.30742588,15.35884 C6.0771214,15.3835955 5.876643,15.525635 5.7787929,15.7333781 L0.0719979599,27.0218487 C-0.0337056449,27.2310259 -0.0224063827,27.4794358 0.101860917,27.6783741 C0.226128216,27.8773125 0.445645594,27.9984148 0.68202605,27.9984369 L8.62844459,27.9984369 C8.88847261,28.0044096 9.12761649,27.8581627 9.23847268,27.6253781 C10.9526159,24.1210252 9.91378448,18.7926722 6.90502605,15.6123193 Z\" fill=\"url(#").concat(id, ")\"></path>\n      <path d=\"M11.0859556,5.33713587 C8.19309829,9.74089822 7.85921851,15.3267488 10.2073011,20.0371359 L14.0383488,27.6176065 C14.1538739,27.8462194 14.3900332,27.9906411 14.6483769,27.9906653 L22.5933685,27.9906653 C22.829749,27.9906431 23.0492663,27.8695408 23.1735336,27.6706025 C23.2978009,27.4716641 23.3091002,27.2232543 23.2033966,27.014077 C23.2033966,27.014077 12.5147056,5.8619594 12.2460792,5.33290058 C12.1377032,5.11315026 11.9118188,4.97410225 11.6646746,4.97500451 C11.4175304,4.97590676 11.1926893,5.11660025 11.0859556,5.33713587 L11.0859556,5.33713587 Z\" fill=\"currentColor\"></path>\n      <path d=\"M104.2774,14.3919316 C104.2774,17.1872257 105.588069,19.4065198 110.714802,20.3862846 C113.773504,21.0215787 114.414212,21.5100493 114.414212,22.5187551 C114.414212,23.4985198 113.772077,24.1327551 111.617715,24.1327551 C109.013896,24.0864379 106.462135,23.403307 104.189999,22.1442846 L104.189999,26.6972257 C105.733976,27.4465198 107.772754,28.2822846 111.559566,28.2822846 C116.919251,28.2822846 119.045788,25.9175787 119.045788,22.4033434 M119.045788,22.4033434 C119.045788,19.0892257 117.268858,17.5327551 112.25878,16.4668728 C109.491535,15.8615787 108.821574,15.2566375 108.821574,14.3919316 C108.821574,13.297814 109.811889,12.835814 111.646968,12.835814 C113.860906,12.835814 116.045591,13.4986375 118.113622,14.4208728 L118.113622,10.0691081 C116.130615,9.17615406 113.970906,8.73311319 111.792518,8.7724022 C106.840589,8.7724022 104.2774,10.9048728 104.2774,14.3919316\" fill=\"inherit\"></path>\n      <polygon fill=\"inherit\" points=\"173.129997 9.07000017 173.129997 28.0038825 177.20791 28.0038825 177.20791 13.5657649 178.926691 17.3983531 184.694132 28.0038825 189.820865 28.0038825 189.820865 9.07000017 185.742952 9.07000017 185.742952 21.2891766 184.198975 17.7442355 179.567399 9.07000017\"></polygon>\n      <rect fill=\"inherit\" x=\"142.740005\" y=\"9.07000017\" width=\"4.45677247\" height=\"18.9338824\"></rect>\n      <path d=\"M137.600792,22.4033434 C137.600792,19.0892257 135.823862,17.5327551 130.813784,16.4668728 C128.046539,15.8615787 127.376579,15.2566375 127.376579,14.3919316 C127.376579,13.297814 128.366893,12.835814 130.201972,12.835814 C132.41591,12.835814 134.600595,13.4986375 136.668626,14.4208728 L136.668626,10.0691081 C134.685619,9.17615406 132.52591,8.73311319 130.347522,8.7724022 C125.395593,8.7724022 122.832404,10.9048728 122.832404,14.3919316 C122.832404,17.1872257 124.143073,19.4065198 129.269806,20.3862846 C132.328508,21.0215787 132.969216,21.5100493 132.969216,22.5187551 C132.969216,23.4985198 132.327081,24.1327551 130.172719,24.1327551 C127.568901,24.0864379 125.017139,23.403307 122.745003,22.1442846 L122.745003,26.6972257 C124.28898,27.4465198 126.327758,28.2822846 130.11457,28.2822846 C135.474256,28.2822846 137.600792,25.9175787 137.600792,22.4033434\" fill=\"inherit\"></path>\n      <polygon fill=\"inherit\" points=\"69.6599979 9.07000017 69.6599979 28.0038825 78.8204081 28.0038825 80.2627142 23.9115296 74.1456665 23.9115296 74.1456665 9.07000017\"></polygon>\n      <polygon fill=\"inherit\" points=\"51.5549984 9.07000017 51.5549984 13.1620002 56.5069282 13.1620002 56.5069282 28.0038825 60.9925967 28.0038825 60.9925967 13.1620002 66.2941332 13.1620002 66.2941332 9.07000017\"></polygon>\n      <path d=\"M45.0573091,9.07000017 L39.1785647,9.07000017 L32.5050001,28.0038825 L37.6014102,28.0038825 L38.5474889,24.815059 C40.877531,25.4919503 43.3551322,25.4919503 45.6851743,24.815059 L46.6312529,28.0038825 L51.7287333,28.0038825 L45.0573091,9.07000017 Z M42.1177585,21.4007061 C41.287584,21.4006584 40.4616854,21.2831148 39.6651602,21.0516472 L42.1177585,12.7889413 L44.5703569,21.0544708 C43.7736914,21.2849831 42.9477956,21.4015755 42.1177585,21.4007061 L42.1177585,21.4007061 Z\" fill=\"inherit\"></path>\n      <path d=\"M94.6019534,9.07000017 L88.7235658,9.07000017 L82.0500011,28.0038825 L87.1474815,28.0038825 L88.0935601,24.815059 C90.4236023,25.4919503 92.9012034,25.4919503 95.2312455,24.815059 L96.1773242,28.0038825 L101.274805,28.0038825 L94.6019534,9.07000017 Z M91.6627596,21.4007061 C90.8325851,21.4006584 90.0066865,21.2831148 89.2101613,21.0516472 L91.6627596,12.7889413 L94.1153579,21.0544708 C93.3186924,21.2849831 92.4927966,21.4015755 91.6627596,21.4007061 L91.6627596,21.4007061 Z\" fill=\"inherit\"></path>\n      <path d=\"M163.256954,9.07000017 L157.378566,9.07000017 L150.705002,28.0038825 L155.802482,28.0038825 L156.748561,24.815059 C159.078603,25.4919503 161.556204,25.4919503 163.886246,24.815059 L164.832325,28.0038825 L169.930162,28.0038825 L163.256954,9.07000017 Z M160.315977,21.4007061 C159.485802,21.4006584 158.659903,21.2831148 157.863378,21.0516472 L160.315977,12.7889413 L162.768575,21.0544708 C161.971909,21.2849831 161.146014,21.4015755 160.315977,21.4007061 L160.315977,21.4007061 Z\" fill=\"inherit\"></path>\n    </g>\n  </svg>");
};

var AtlassianLogo =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(AtlassianLogo, _Component);

  function AtlassianLogo() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, AtlassianLogo);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(AtlassianLogo).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(AtlassianLogo, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return AtlassianLogo;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AtlassianLogo, "defaultProps", __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */





var svg = function svg(iconGradientStart, iconGradientStop) {
  var id = __WEBPACK_IMPORTED_MODULE_8_uuid___default()();
  return "<canvas height=\"32\" width=\"32\" aria-hidden=\"true\"></canvas>\n  <svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"50%\" x2=\"50%\" y1=\"-17.724%\" y2=\"85.598%\" id=\"".concat(id, "\">\n        <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path d=\"M15.3919738,2.47536112 C12.1140721,7.66880375 12.3303344,13.4206726 14.4894164,17.7389677 L18.4247607,25.6099185 C18.5435803,25.8472956 18.7860721,25.9971972 19.0515148,25.9971972 L27.2130885,25.9971972 C27.5999738,25.9971972 27.9136787,25.6836234 27.9136787,25.296607 C27.9136787,25.1878857 27.8883672,25.080607 27.8397115,24.9832956 C27.8397115,24.9832956 16.8599082,3.0204103 16.5835803,2.47090211 C16.3367607,1.97896768 15.7093508,1.97227916 15.3919738,2.47536112\" fill=\"currentColor\"></path>\n      <path d=\"M9.93632602,13.3906651 L4.07411881,25.1153419 C4.02453136,25.214648 4.00065592,25.3199886 4,25.4238861 L4,25.4332001 C4.00183657,25.6884836 4.14338381,25.9335348 4.38738555,26.0555357 C4.48472387,26.1042049 4.59216334,26.1295233 4.70091465,26.1295233 L12.8650027,26.1295233 C13.132224,26.1358202 13.3779311,25.9840406 13.4917986,25.7420066 C15.2522842,22.1023141 14.1857605,16.5683286 11.0938912,13.2648599 C10.9303051,13.0902544 10.7250026,13 10.5271775,13 C10.2924898,13 10.0681657,13.1269858 9.93632602,13.3906651\" fill=\"url(#").concat(id, ")\"></path>\n    </g>\n  </svg>");
};

var AtlassianIcon =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(AtlassianIcon, _Component);

  function AtlassianIcon() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, AtlassianIcon);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(AtlassianIcon).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(AtlassianIcon, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return AtlassianIcon;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AtlassianIcon, "defaultProps", __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */



var svg = "<canvas height=\"32\" width=\"158\" aria-hidden=\"true\"></canvas>\n<svg viewBox=\"0 0 158 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">>\n  <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\" fill=\"inherit\">\n    <path d=\"M72.2774003,14.3919316 C72.2774003,17.1872257 73.5880689,19.4065198 78.714802,20.3862846 C81.7735042,21.0215787 82.4142121,21.5100493 82.4142121,22.5187551 C82.4142121,23.4985198 81.7720773,24.1327551 79.6177149,24.1327551 C77.0138964,24.0864379 74.4621351,23.403307 72.1899986,22.1442846 L72.1899986,26.6972257 C73.7339762,27.4465198 75.7727542,28.2822846 79.559566,28.2822846 C84.9192514,28.2822846 87.045788,25.9175787 87.045788,22.4033434 M87.045788,22.4033434 C87.045788,19.0892257 85.2688582,17.5327551 80.2587795,16.4668728 C77.4915351,15.8615787 76.8215745,15.2566375 76.8215745,14.3919316 C76.8215745,13.297814 77.8118891,12.835814 79.6469677,12.835814 C81.8609059,12.835814 84.0455913,13.4986375 86.1136222,14.4208728 L86.1136222,10.0691081 C84.1306149,9.17615406 81.9709058,8.73311319 79.7925183,8.7724022 C74.8405885,8.7724022 72.2774003,10.9048728 72.2774003,14.3919316\"></path>\n    <polygon points=\"141.129997 9.07000017 141.129997 28.0038825 145.20791 28.0038825 145.20791 13.5657649 146.926691 17.3983531 152.694132 28.0038825 157.820865 28.0038825 157.820865 9.07000017 153.742952 9.07000017 153.742952 21.2891766 152.198975 17.7442355 147.567399 9.07000017\"></polygon>\n    <rect x=\"110.740005\" y=\"9.07000017\" width=\"4.45677247\" height=\"18.9338824\"></rect>\n    <path d=\"M105.600792,22.4033434 C105.600792,19.0892257 103.823862,17.5327551 98.8137836,16.4668728 C96.0465393,15.8615787 95.3765786,15.2566375 95.3765786,14.3919316 C95.3765786,13.297814 96.3668932,12.835814 98.2019718,12.835814 C100.41591,12.835814 102.600595,13.4986375 104.668626,14.4208728 L104.668626,10.0691081 C102.685619,9.17615406 100.52591,8.73311319 98.3475224,8.7724022 C93.3955926,8.7724022 90.8324044,10.9048728 90.8324044,14.3919316 C90.8324044,17.1872257 92.143073,19.4065198 97.2698061,20.3862846 C100.328508,21.0215787 100.969216,21.5100493 100.969216,22.5187551 C100.969216,23.4985198 100.327081,24.1327551 98.172719,24.1327551 C95.5689006,24.0864379 93.0171392,23.403307 90.7450027,22.1442846 L90.7450027,26.6972257 C92.2889803,27.4465198 94.3277584,28.2822846 98.1145702,28.2822846 C103.474256,28.2822846 105.600792,25.9175787 105.600792,22.4033434\"></path>\n    <polygon points=\"37.6599979 9.07000017 37.6599979 28.0038825 46.8204081 28.0038825 48.2627142 23.9115296 42.1456665 23.9115296 42.1456665 9.07000017\"></polygon>\n    <polygon points=\"19.5549984 9.07000017 19.5549984 13.1620002 24.5069282 13.1620002 24.5069282 28.0038825 28.9925967 28.0038825 28.9925967 13.1620002 34.2941332 13.1620002 34.2941332 9.07000017\"></polygon>\n    <path d=\"M13.0573091,9.07000017 L7.17856472,9.07000017 L0.505000114,28.0038825 L5.60141023,28.0038825 L6.54748888,24.815059 C8.877531,25.4919503 11.3551322,25.4919503 13.6851743,24.815059 L14.6312529,28.0038825 L19.7287333,28.0038825 L13.0573091,9.07000017 Z M10.1177585,21.4007061 C9.28758405,21.4006584 8.46168544,21.2831148 7.66516023,21.0516472 L10.1177585,12.7889413 L12.5703569,21.0544708 C11.7736914,21.2849831 10.9477956,21.4015755 10.1177585,21.4007061 L10.1177585,21.4007061 Z\"></path>\n    <path d=\"M62.6019534,9.07000017 L56.7235658,9.07000017 L50.0500011,28.0038825 L55.1474815,28.0038825 L56.0935601,24.815059 C58.4236023,25.4919503 60.9012034,25.4919503 63.2312455,24.815059 L64.1773242,28.0038825 L69.2748045,28.0038825 L62.6019534,9.07000017 Z M59.6627596,21.4007061 C58.8325851,21.4006584 58.0066865,21.2831148 57.2101613,21.0516472 L59.6627596,12.7889413 L62.1153579,21.0544708 C61.3186924,21.2849831 60.4927966,21.4015755 59.6627596,21.4007061 L59.6627596,21.4007061 Z\"></path>\n    <path d=\"M131.256954,9.07000017 L125.378566,9.07000017 L118.705002,28.0038825 L123.802482,28.0038825 L124.748561,24.815059 C127.078603,25.4919503 129.556204,25.4919503 131.886246,24.815059 L132.832325,28.0038825 L137.930162,28.0038825 L131.256954,9.07000017 Z M128.315977,21.4007061 C127.485802,21.4006584 126.659903,21.2831148 125.863378,21.0516472 L128.315977,12.7889413 L130.768575,21.0544708 C129.971909,21.2849831 129.146014,21.4015755 128.315977,21.4007061 L128.315977,21.4007061 Z\"></path>\n  </g>\n</svg>";

var AtlassianWordmark =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(AtlassianWordmark, _Component);

  function AtlassianWordmark() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, AtlassianWordmark);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(AtlassianWordmark).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(AtlassianWordmark, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return AtlassianWordmark;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AtlassianWordmark, "defaultProps", __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logo__ = __webpack_require__(2542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Wordmark__ = __webpack_require__(2544);
/* unused harmony reexport BitbucketLogo */
/* unused harmony reexport BitbucketIcon */
/* unused harmony reexport BitbucketWordmark */





/***/ }),
/* 2542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */





var svg = function svg(iconGradientStart, iconGradientStop) {
  var id = __WEBPACK_IMPORTED_MODULE_8_uuid___default()();
  return "<canvas height=\"32\" width=\"137\" aria-hidden=\"true\"></canvas>\n  <svg viewBox=\"0 0 137 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"100.866322%\" y1=\"25.6261254%\" x2=\"46.5685299%\" y2=\"75.2076031%\" id=\"".concat(id, "\">\n        <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n      <path d=\"M22.38125,13.1176316 L15.3425,13.1176316 L14.16125,20.0504386 L9.28624997,20.0504386 L3.52999997,26.9266667 C3.71244766,27.0853527 3.94506033,27.173594 4.18624997,27.175614 L19.46375,27.175614 C19.8352946,27.180424 20.1543287,26.9108682 20.21375,26.5419298 L22.38125,13.1176316 Z\" fill=\"url(#").concat(id, ")\" fill-rule=\"nonzero\"></path>\n      <path d=\"M0.759678147,6 C0.53811485,5.99712567 0.326627812,6.09294508 0.181948325,6.26175474 C0.0372688368,6.4305644 -0.0257933559,6.65508453 0.00967814748,6.87508772 L3.19342815,26.315614 C3.23255884,26.5521357 3.35340224,26.7671859 3.53467815,26.9228947 L3.53467815,26.9228947 C3.71712584,27.0815808 3.94973851,27.169822 4.19092815,27.1718421 L10.1009281,20.0504386 L9.27217815,20.0504386 L7.97092815,13.1176316 L22.3859281,13.1176316 L23.3984281,6.88263158 C23.4360238,6.66342534 23.375521,6.43870373 23.2330921,6.26853487 C23.0906632,6.09836602 22.880829,6.00009878 22.6596781,6 L0.759678147,6 Z\" fill=\"currentColor\" fill-rule=\"nonzero\"></path>\n      <path d=\"M32,8.352 L38.63,8.352 C42.114,8.352 43.804,10.068 43.804,12.824 C43.804,14.878 42.868,16.152 40.944,16.62 C43.466,17.036 44.714,18.414 44.714,20.832 C44.714,23.562 42.868,25.434 39.046,25.434 L32,25.434 L32,8.352 Z M38.318,10.588 L34.34,10.588 L34.34,15.684 L38.318,15.684 C40.528,15.684 41.438,14.67 41.438,13.032 C41.438,11.368 40.45,10.588 38.318,10.588 Z M39.072,17.764 L34.34,17.764 L34.34,23.094 L39.124,23.094 C41.36,23.094 42.374,22.288 42.374,20.572 C42.374,18.752 41.412,17.764 39.072,17.764 Z M47.236,9.002 C47.236,9.99 47.886,10.562 48.796,10.562 C49.706,10.562 50.356,9.99 50.356,9.002 C50.356,8.014 49.706,7.442 48.796,7.442 C47.886,7.442 47.236,8.014 47.236,9.002 Z M47.652,25.434 L49.888,25.434 L49.888,12.434 L47.652,12.434 L47.652,25.434 Z M56.362,21.326 L56.362,14.514 L59.82,14.514 L59.82,12.434 L56.362,12.434 L56.362,9.678 L54.178,9.678 L54.178,12.434 L52.072,12.434 L52.072,14.514 L54.178,14.514 L54.178,21.378 C54.178,23.796 55.53,25.434 58.312,25.434 C58.988,25.434 59.43,25.33 59.82,25.226 L59.82,23.068 C59.43,23.146 58.936,23.25 58.416,23.25 C57.038,23.25 56.362,22.47 56.362,21.326 Z M74.51,18.934 C74.51,22.6 72.69,25.694 69.05,25.694 C67.152,25.694 65.696,24.836 64.916,23.146 L64.916,25.434 L62.68,25.434 L62.68,7 L64.916,7 L64.916,14.774 C65.748,13.058 67.308,12.174 69.31,12.174 C72.768,12.174 74.51,15.112 74.51,18.934 Z M72.274,18.934 C72.274,15.814 71.026,14.254 68.712,14.254 C66.71,14.254 64.916,15.528 64.916,18.414 L64.916,19.454 C64.916,22.34 66.554,23.614 68.452,23.614 C70.974,23.614 72.274,21.95 72.274,18.934 Z M76.85,20.052 C76.85,23.64 78.566,25.694 81.556,25.694 C83.298,25.694 84.832,24.836 85.664,23.302 L85.664,25.434 L87.9,25.434 L87.9,12.434 L85.664,12.434 L85.664,19.662 C85.664,22.288 84.234,23.666 82.154,23.666 C80.022,23.666 79.086,22.626 79.086,20.286 L79.086,12.434 L76.85,12.434 L76.85,20.052 Z M100.458,23.094 C99.652,23.38 98.82,23.562 97.494,23.562 C94.088,23.562 92.684,21.43 92.684,18.908 C92.684,16.386 94.062,14.254 97.442,14.254 C98.664,14.254 99.548,14.488 100.38,14.878 L100.38,12.798 C99.366,12.33 98.456,12.174 97.286,12.174 C92.658,12.174 90.5,14.982 90.5,18.908 C90.5,22.886 92.658,25.694 97.286,25.694 C98.482,25.694 99.678,25.512 100.458,25.096 L100.458,23.094 Z M105.242,25.434 L105.242,19.35 L110.962,25.434 L114.004,25.434 L107.634,18.83 L113.744,12.434 L110.832,12.434 L105.242,18.518 L105.242,7 L103.006,7 L103.006,25.434 L105.242,25.434 Z M126.224,24.914 C125.158,25.486 123.52,25.694 122.194,25.694 C117.332,25.694 115.2,22.886 115.2,18.908 C115.2,14.982 117.384,12.174 121.336,12.174 C125.34,12.174 126.952,14.956 126.952,18.908 L126.952,19.922 L117.462,19.922 C117.774,22.132 119.204,23.562 122.272,23.562 C123.78,23.562 125.054,23.276 126.224,22.86 L126.224,24.914 Z M121.232,14.202 C118.866,14.202 117.67,15.736 117.436,17.998 L124.69,17.998 C124.56,15.58 123.468,14.202 121.232,14.202 Z M132.698,21.326 L132.698,14.514 L136.156,14.514 L136.156,12.434 L132.698,12.434 L132.698,9.678 L130.514,9.678 L130.514,12.434 L128.408,12.434 L128.408,14.514 L130.514,14.514 L130.514,21.378 C130.514,23.796 131.866,25.434 134.648,25.434 C135.324,25.434 135.766,25.33 136.156,25.226 L136.156,23.068 C135.766,23.146 135.272,23.25 134.752,23.25 C133.374,23.25 132.698,22.47 132.698,21.326 Z\" fill=\"inherit\"></path>\n    </g>\n  </svg>");
};

var BitbucketLogo =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(BitbucketLogo, _Component);

  function BitbucketLogo() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, BitbucketLogo);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(BitbucketLogo).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(BitbucketLogo, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return BitbucketLogo;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(BitbucketLogo, "defaultProps", __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid_v1__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid_v1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid_v1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */





var svg = function svg(iconGradientStart, iconGradientStop) {
  var id = __WEBPACK_IMPORTED_MODULE_8_uuid_v1___default()();
  return "<canvas height=\"32\" width=\"32\" aria-hidden=\"true\"></canvas>\n  <svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"100%\" x2=\"45.339%\" y1=\"29.23%\" y2=\"75.038%\" id=\"".concat(id, "\">\n        <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path d=\"M4.78580435,5 C4.55423538,4.99701333 4.33319771,5.09657765 4.18198458,5.27198488 C4.03077145,5.44739211 3.96486141,5.68068714 4.00193478,5.9092887 L7.32946109,26.1096074 C7.3703589,26.355373 7.49665951,26.578828 7.68612174,26.7406224 C7.87680866,26.9055104 8.11992598,26.9972003 8.37200761,26.9992993 L14.5488998,19.5995707 L13.6827239,19.5995707 L12.3227102,12.3958093 L27.3886833,12.3958093 L28.4469072,5.91712739 C28.4862006,5.68935393 28.4229655,5.45584955 28.2741046,5.27903 C28.1252437,5.10221045 27.9059335,5.00010264 27.6747957,5 L4.78580435,5 Z\" fill=\"currentColor\"/>\n      <path fill=\"url(#").concat(id, ")\" d=\"M27.3886833,12.3958093 L20.0320674,12.3958093 L18.7974728,19.5995707 L13.7023207,19.5995707 L7.68612174,26.7445417 C7.87680866,26.9094297 8.11992598,27.0011197 8.37200761,27.0032187 L24.3394307,27.0032187 C24.727754,27.0082167 25.0611955,26.7281258 25.1233002,26.3447683 L27.3886833,12.3958093 Z\"/>\n    </g>\n  </svg>");
};

var BitbucketIcon =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(BitbucketIcon, _Component);

  function BitbucketIcon() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, BitbucketIcon);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(BitbucketIcon).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(BitbucketIcon, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return BitbucketIcon;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(BitbucketIcon, "defaultProps", __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */



var svg = "<canvas height=\"32\" width=\"105\" aria-hidden=\"true\"></canvas>\n<svg viewBox=\"0 0 105 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n  <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\" fill=\"inherit\">\n    <path d=\"M4.48530102e-14,6.918 L6.63,6.918 C10.114,6.918 11.804,8.634 11.804,11.39 C11.804,13.444 10.868,14.718 8.944,15.186 C11.466,15.602 12.714,16.98 12.714,19.398 C12.714,22.128 10.868,24 7.046,24 L4.48530102e-14,24 L4.48530102e-14,6.918 Z M6.318,9.154 L2.34,9.154 L2.34,14.25 L6.318,14.25 C8.528,14.25 9.438,13.236 9.438,11.598 C9.438,9.934 8.45,9.154 6.318,9.154 Z M7.072,16.33 L2.34,16.33 L2.34,21.66 L7.124,21.66 C9.36,21.66 10.374,20.854 10.374,19.138 C10.374,17.318 9.412,16.33 7.072,16.33 Z M15.236,7.568 C15.236,8.556 15.886,9.128 16.796,9.128 C17.706,9.128 18.356,8.556 18.356,7.568 C18.356,6.58 17.706,6.008 16.796,6.008 C15.886,6.008 15.236,6.58 15.236,7.568 Z M15.652,24 L17.888,24 L17.888,11 L15.652,11 L15.652,24 Z M24.362,19.892 L24.362,13.08 L27.82,13.08 L27.82,11 L24.362,11 L24.362,8.244 L22.178,8.244 L22.178,11 L20.072,11 L20.072,13.08 L22.178,13.08 L22.178,19.944 C22.178,22.362 23.53,24 26.312,24 C26.988,24 27.43,23.896 27.82,23.792 L27.82,21.634 C27.43,21.712 26.936,21.816 26.416,21.816 C25.038,21.816 24.362,21.036 24.362,19.892 Z M42.51,17.5 C42.51,21.166 40.69,24.26 37.05,24.26 C35.152,24.26 33.696,23.402 32.916,21.712 L32.916,24 L30.68,24 L30.68,5.566 L32.916,5.566 L32.916,13.34 C33.748,11.624 35.308,10.74 37.31,10.74 C40.768,10.74 42.51,13.678 42.51,17.5 Z M40.274,17.5 C40.274,14.38 39.026,12.82 36.712,12.82 C34.71,12.82 32.916,14.094 32.916,16.98 L32.916,18.02 C32.916,20.906 34.554,22.18 36.452,22.18 C38.974,22.18 40.274,20.516 40.274,17.5 Z M44.85,18.618 C44.85,22.206 46.566,24.26 49.556,24.26 C51.298,24.26 52.832,23.402 53.664,21.868 L53.664,24 L55.9,24 L55.9,11 L53.664,11 L53.664,18.228 C53.664,20.854 52.234,22.232 50.154,22.232 C48.022,22.232 47.086,21.192 47.086,18.852 L47.086,11 L44.85,11 L44.85,18.618 Z M68.458,21.66 C67.652,21.946 66.82,22.128 65.494,22.128 C62.088,22.128 60.684,19.996 60.684,17.474 C60.684,14.952 62.062,12.82 65.442,12.82 C66.664,12.82 67.548,13.054 68.38,13.444 L68.38,11.364 C67.366,10.896 66.456,10.74 65.286,10.74 C60.658,10.74 58.5,13.548 58.5,17.474 C58.5,21.452 60.658,24.26 65.286,24.26 C66.482,24.26 67.678,24.078 68.458,23.662 L68.458,21.66 Z M73.242,24 L73.242,17.916 L78.962,24 L82.004,24 L75.634,17.396 L81.744,11 L78.832,11 L73.242,17.084 L73.242,5.566 L71.006,5.566 L71.006,24 L73.242,24 Z M94.224,23.48 C93.158,24.052 91.52,24.26 90.194,24.26 C85.332,24.26 83.2,21.452 83.2,17.474 C83.2,13.548 85.384,10.74 89.336,10.74 C93.34,10.74 94.952,13.522 94.952,17.474 L94.952,18.488 L85.462,18.488 C85.774,20.698 87.204,22.128 90.272,22.128 C91.78,22.128 93.054,21.842 94.224,21.426 L94.224,23.48 Z M89.232,12.768 C86.866,12.768 85.67,14.302 85.436,16.564 L92.69,16.564 C92.56,14.146 91.468,12.768 89.232,12.768 Z M100.698,19.892 L100.698,13.08 L104.156,13.08 L104.156,11 L100.698,11 L100.698,8.244 L98.514,8.244 L98.514,11 L96.408,11 L96.408,13.08 L98.514,13.08 L98.514,19.944 C98.514,22.362 99.866,24 102.648,24 C103.324,24 103.766,23.896 104.156,23.792 L104.156,21.634 C103.766,21.712 103.272,21.816 102.752,21.816 C101.374,21.816 100.698,21.036 100.698,19.892 Z\"></path>\n  </g>\n</svg>";

var BitbucketWordmark =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(BitbucketWordmark, _Component);

  function BitbucketWordmark() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, BitbucketWordmark);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(BitbucketWordmark).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(BitbucketWordmark, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return BitbucketWordmark;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(BitbucketWordmark, "defaultProps", __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logo__ = __webpack_require__(2546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Wordmark__ = __webpack_require__(2548);
/* unused harmony reexport ConfluenceLogo */
/* unused harmony reexport ConfluenceIcon */
/* unused harmony reexport ConfluenceWordmark */





/***/ }),
/* 2546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */





var svg = function svg(iconGradientStart, iconGradientStop) {
  var id = __WEBPACK_IMPORTED_MODULE_8_uuid___default()();
  return "<canvas height=\"32\" width=\"158\" aria-hidden=\"true\"></canvas>\n  <svg viewBox=\"0 0 158 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"99.140087%\" y1=\"112.745465%\" x2=\"33.8589812%\" y2=\"37.7675389%\" id=\"".concat(id, "-1\">\n        <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n      <linearGradient x1=\"14.1838118%\" y1=\"5.80047897%\" x2=\"61.141783%\" y2=\"70.9663868%\" id=\"").concat(id, "-2\">\n        <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path d=\"M45.312,20.984 C44.064,21.608 42.66,22.024 40.866,22.024 C36.81,22.024 34.34,19.424 34.34,15.498 C34.34,11.572 36.732,8.92 40.736,8.92 C42.712,8.92 44.064,9.336 45.286,10.116 L45.286,7.854 C44.064,6.97 42.4,6.658 40.736,6.658 C35.172,6.658 32,10.298 32,15.498 C32,20.88 35.172,24.26 40.788,24.26 C42.556,24.26 44.246,23.948 45.312,23.246 L45.312,20.984 Z M53.918,24.26 C50.018,24.26 47.73,21.374 47.73,17.474 C47.73,13.574 50.018,10.74 53.918,10.74 C57.792,10.74 60.054,13.574 60.054,17.474 C60.054,21.374 57.792,24.26 53.918,24.26 Z M53.918,12.82 C51.136,12.82 49.914,15.004 49.914,17.474 C49.914,19.944 51.136,22.18 53.918,22.18 C56.674,22.18 57.87,19.944 57.87,17.474 C57.87,15.004 56.674,12.82 53.918,12.82 Z M73.704,16.382 C73.704,12.794 71.988,10.74 68.998,10.74 C67.256,10.74 65.722,11.598 64.89,13.132 L64.89,11 L62.654,11 L62.654,24 L64.89,24 L64.89,16.772 C64.89,14.146 66.32,12.768 68.4,12.768 C70.532,12.768 71.468,13.808 71.468,16.148 L71.468,24 L73.704,24 L73.704,16.382 Z M79.918,9.622 C79.918,8.452 80.594,7.646 81.972,7.646 C82.492,7.646 82.986,7.698 83.376,7.776 L83.376,5.722 C82.986,5.618 82.544,5.514 81.868,5.514 C79.086,5.514 77.734,7.152 77.734,9.57 L77.734,11 L75.628,11 L75.628,13.08 L77.734,13.08 L77.734,24 L79.918,24 L79.918,13.08 L83.272,13.08 L83.272,11 L79.918,11 L79.918,9.622 Z M90.318,23.974 L90.318,21.972 C90.058,21.998 89.902,21.998 89.668,21.998 C88.706,21.998 87.926,21.582 87.926,20.412 L87.926,5.566 L85.69,5.566 L85.69,20.672 C85.69,23.064 87.042,24.078 89.174,24.078 C89.746,24.078 90.136,24.026 90.318,23.974 Z M92.216,18.618 C92.216,22.206 93.932,24.26 96.922,24.26 C98.664,24.26 100.198,23.402 101.03,21.868 L101.03,24 L103.266,24 L103.266,11 L101.03,11 L101.03,18.228 C101.03,20.854 99.6,22.232 97.52,22.232 C95.388,22.232 94.452,21.192 94.452,18.852 L94.452,11 L92.216,11 L92.216,18.618 Z M116.89,23.48 C115.824,24.052 114.186,24.26 112.86,24.26 C107.998,24.26 105.866,21.452 105.866,17.474 C105.866,13.548 108.05,10.74 112.002,10.74 C116.006,10.74 117.618,13.522 117.618,17.474 L117.618,18.488 L108.128,18.488 C108.44,20.698 109.87,22.128 112.938,22.128 C114.446,22.128 115.72,21.842 116.89,21.426 L116.89,23.48 Z M111.898,12.768 C109.532,12.768 108.336,14.302 108.102,16.564 L115.356,16.564 C115.226,14.146 114.134,12.768 111.898,12.768 Z M131.32,16.382 C131.32,12.794 129.604,10.74 126.614,10.74 C124.872,10.74 123.338,11.598 122.506,13.132 L122.506,11 L120.27,11 L120.27,24 L122.506,24 L122.506,16.772 C122.506,14.146 123.936,12.768 126.016,12.768 C128.148,12.768 129.084,13.808 129.084,16.148 L129.084,24 L131.32,24 L131.32,16.382 Z M143.618,21.66 C142.812,21.946 141.98,22.128 140.654,22.128 C137.248,22.128 135.844,19.996 135.844,17.474 C135.844,14.952 137.222,12.82 140.602,12.82 C141.824,12.82 142.708,13.054 143.54,13.444 L143.54,11.364 C142.526,10.896 141.616,10.74 140.446,10.74 C135.818,10.74 133.66,13.548 133.66,17.474 C133.66,21.452 135.818,24.26 140.446,24.26 C141.642,24.26 142.838,24.078 143.618,23.662 L143.618,21.66 Z M156.41,23.48 C155.344,24.052 153.706,24.26 152.38,24.26 C147.518,24.26 145.386,21.452 145.386,17.474 C145.386,13.548 147.57,10.74 151.522,10.74 C155.526,10.74 157.138,13.522 157.138,17.474 L157.138,18.488 L147.648,18.488 C147.96,20.698 149.39,22.128 152.458,22.128 C153.966,22.128 155.24,21.842 156.41,21.426 L156.41,23.48 Z M151.418,12.768 C149.052,12.768 147.856,14.302 147.622,16.564 L154.876,16.564 C154.746,14.146 153.654,12.768 151.418,12.768 Z\" fill=\"inherit\" fill-rule=\"evenodd\"></path>\n      <path d=\"M0.85465057,21.7022581 C0.61090057,22.0783871 0.33715057,22.5148387 0.10465057,22.8625806 C-0.10345498,23.195346 0.00826440879,23.6245091 0.35590057,23.8277419 L5.23090057,26.6664516 C5.40202309,26.7664253 5.60840847,26.7971801 5.80372052,26.7518112 C5.99903257,26.7064423 6.16690583,26.5887513 6.26965057,26.4251613 C6.46465057,26.1164516 6.71590057,25.7154839 6.98965057,25.286129 C8.92090057,22.27 10.8634006,22.6390323 14.3659006,24.2216129 L19.1996506,26.3967742 C19.3827218,26.4792261 19.5932727,26.4880304 19.7833166,26.4211804 C19.9733605,26.3543303 20.1267047,26.2175221 20.2084006,26.0419355 L22.5296506,21.0741935 C22.6936507,20.7193919 22.5267777,20.3056906 22.1546506,20.1445161 C21.1346506,19.6903226 19.1059006,18.7854839 17.2796506,17.9516129 C10.7096506,14.9354839 5.12590057,15.1341935 0.85465057,21.7022581 Z\" fill=\"url(#").concat(id, "-1)\"></path>\n      <path d=\"M22.7130274,10.4325806 C22.9567774,10.0564516 23.2305274,9.62 23.4630274,9.27225806 C23.6711329,8.93949274 23.5594135,8.51032964 23.2117774,8.30709677 L18.3367774,5.4683871 C18.1633186,5.35902032 17.9495842,5.32289142 17.7468362,5.36866556 C17.5440883,5.4144397 17.3706168,5.53798759 17.2680274,5.70967742 C17.0730274,6.0183871 16.8217774,6.41935484 16.5480274,6.84870968 C14.6167774,9.86483871 12.6742774,9.49580645 9.17177736,7.91322581 L4.35302736,5.7416129 C4.16995613,5.65916098 3.95940527,5.65035674 3.76936133,5.71720675 C3.5793174,5.78405675 3.42597321,5.92086501 3.34427736,6.09645161 L1.02302736,11.0641935 C0.85902727,11.4189952 1.02590019,11.8326965 1.39802736,11.993871 C2.41802736,12.4480645 4.44677736,13.3529032 6.27302736,14.1867742 C12.8580274,17.1993548 18.4417774,17.0006452 22.7130274,10.4325806 Z\" fill=\"url(#").concat(id, "-2)\"></path>\n    </g>\n  </svg>");
};

var ConfluenceLogo =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ConfluenceLogo, _Component);

  function ConfluenceLogo() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ConfluenceLogo);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ConfluenceLogo).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ConfluenceLogo, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return ConfluenceLogo;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ConfluenceLogo, "defaultProps", __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */





var svg = function svg(iconGradientStart, iconGradientStop) {
  var id = __WEBPACK_IMPORTED_MODULE_8_uuid___default()();
  return "<canvas height=\"32\" width=\"32\" aria-hidden=\"true\"></canvas>\n  <svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"60.6779047%\" y1=\"137.626433%\" x2=\"14.341981%\" y2=\"112.08042%\" id=\"".concat(id, "-1\">\n        <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n      <linearGradient x1=\"12.3282701%\" y1=\"-53.9760846%\" x2=\"74.1300776%\" y2=\"-33.2553066%\" id=\"").concat(id, "-2\">\n        <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path d=\"M5.21454927,22.0245336 C4.97082816,22.4219865 4.69711061,22.8831818 4.46463817,23.2506383 C4.25655728,23.602269 4.36826343,24.0557627 4.71585838,24.2705174 L9.59028054,27.2701618 C9.76138278,27.3758032 9.96774369,27.4083016 10.1630326,27.3603607 C10.3583215,27.3124197 10.5261749,27.1880564 10.6289074,27.015192 C10.8238843,26.6889807 11.0751045,26.2652809 11.3488221,25.8115847 C13.2798432,22.6244625 15.2221129,23.0144163 18.7241978,24.686718 L23.5573748,26.9851956 C23.7404243,27.0723219 23.9509502,27.0816253 24.1409716,27.0109854 C24.3309931,26.9403455 24.4843191,26.7957811 24.5660052,26.61024 L26.8869801,21.3608623 C27.0509607,20.9859459 26.8841076,20.5487907 26.5120245,20.3784788 C25.4921454,19.8985357 23.4636359,18.942399 21.6376024,18.0612535 C15.0683811,14.8741313 9.48529299,15.0841064 5.21454927,22.0245336 Z\" fill=\"url(#").concat(id, "-1)\"></path>\n      <path d=\"M27.0752616,9.74267061 C27.3190367,9.34512979 27.5928148,8.88383241 27.8253387,8.51629467 C28.0334656,8.1645861 27.9217347,7.71099215 27.5740629,7.4961899 L22.6985622,4.49588177 C22.5250856,4.3802891 22.3113292,4.3421035 22.1085604,4.39048341 C21.9057917,4.43886333 21.7323024,4.56944439 21.6297024,4.75090796 C21.4346824,5.07719147 21.1834066,5.50098499 20.9096284,5.9547816 C18.9781801,9.14260899 17.0354806,8.75256893 13.5326208,7.07989715 L8.71337588,4.78466143 C8.53028584,4.69751579 8.31971336,4.68821035 8.1296499,4.75886591 C7.93958645,4.82952147 7.78622651,4.97411777 7.70452227,5.15969994 L5.38303386,10.4102392 C5.21901692,10.7852385 5.38590698,11.2224905 5.75807237,11.3928401 C6.77817714,11.8728894 8.80713551,12.8292376 10.6335731,13.7105781 C17.2192494,16.8946551 22.8035729,16.6846336 27.0752616,9.74267061 Z\" fill=\"url(#").concat(id, "-2)\"></path>\n    </g>\n  </svg>");
};

var ConfluenceIcon =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ConfluenceIcon, _Component);

  function ConfluenceIcon() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ConfluenceIcon);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ConfluenceIcon).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ConfluenceIcon, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return ConfluenceIcon;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ConfluenceIcon, "defaultProps", __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */



var svg = "<canvas height=\"32\" width=\"126\" aria-hidden=\"true\"></canvas>\n<svg viewBox=\"0 0 126 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n  <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\" fill=\"inherit\">\n    <path d=\"M13.312,20.984 C12.064,21.608 10.66,22.024 8.866,22.024 C4.81,22.024 2.34,19.424 2.34,15.498 C2.34,11.572 4.732,8.92 8.736,8.92 C10.712,8.92 12.064,9.336 13.286,10.116 L13.286,7.854 C12.064,6.97 10.4,6.658 8.736,6.658 C3.172,6.658 -2.04281037e-14,10.298 -2.04281037e-14,15.498 C-2.04281037e-14,20.88 3.172,24.26 8.788,24.26 C10.556,24.26 12.246,23.948 13.312,23.246 L13.312,20.984 Z M21.918,24.26 C18.018,24.26 15.73,21.374 15.73,17.474 C15.73,13.574 18.018,10.74 21.918,10.74 C25.792,10.74 28.054,13.574 28.054,17.474 C28.054,21.374 25.792,24.26 21.918,24.26 Z M21.918,12.82 C19.136,12.82 17.914,15.004 17.914,17.474 C17.914,19.944 19.136,22.18 21.918,22.18 C24.674,22.18 25.87,19.944 25.87,17.474 C25.87,15.004 24.674,12.82 21.918,12.82 Z M41.704,16.382 C41.704,12.794 39.988,10.74 36.998,10.74 C35.256,10.74 33.722,11.598 32.89,13.132 L32.89,11 L30.654,11 L30.654,24 L32.89,24 L32.89,16.772 C32.89,14.146 34.32,12.768 36.4,12.768 C38.532,12.768 39.468,13.808 39.468,16.148 L39.468,24 L41.704,24 L41.704,16.382 Z M47.918,9.622 C47.918,8.452 48.594,7.646 49.972,7.646 C50.492,7.646 50.986,7.698 51.376,7.776 L51.376,5.722 C50.986,5.618 50.544,5.514 49.868,5.514 C47.086,5.514 45.734,7.152 45.734,9.57 L45.734,11 L43.628,11 L43.628,13.08 L45.734,13.08 L45.734,24 L47.918,24 L47.918,13.08 L51.272,13.08 L51.272,11 L47.918,11 L47.918,9.622 Z M58.318,23.974 L58.318,21.972 C58.058,21.998 57.902,21.998 57.668,21.998 C56.706,21.998 55.926,21.582 55.926,20.412 L55.926,5.566 L53.69,5.566 L53.69,20.672 C53.69,23.064 55.042,24.078 57.174,24.078 C57.746,24.078 58.136,24.026 58.318,23.974 Z M60.216,18.618 C60.216,22.206 61.932,24.26 64.922,24.26 C66.664,24.26 68.198,23.402 69.03,21.868 L69.03,24 L71.266,24 L71.266,11 L69.03,11 L69.03,18.228 C69.03,20.854 67.6,22.232 65.52,22.232 C63.388,22.232 62.452,21.192 62.452,18.852 L62.452,11 L60.216,11 L60.216,18.618 Z M84.89,23.48 C83.824,24.052 82.186,24.26 80.86,24.26 C75.998,24.26 73.866,21.452 73.866,17.474 C73.866,13.548 76.05,10.74 80.002,10.74 C84.006,10.74 85.618,13.522 85.618,17.474 L85.618,18.488 L76.128,18.488 C76.44,20.698 77.87,22.128 80.938,22.128 C82.446,22.128 83.72,21.842 84.89,21.426 L84.89,23.48 Z M79.898,12.768 C77.532,12.768 76.336,14.302 76.102,16.564 L83.356,16.564 C83.226,14.146 82.134,12.768 79.898,12.768 Z M99.32,16.382 C99.32,12.794 97.604,10.74 94.614,10.74 C92.872,10.74 91.338,11.598 90.506,13.132 L90.506,11 L88.27,11 L88.27,24 L90.506,24 L90.506,16.772 C90.506,14.146 91.936,12.768 94.016,12.768 C96.148,12.768 97.084,13.808 97.084,16.148 L97.084,24 L99.32,24 L99.32,16.382 Z M111.618,21.66 C110.812,21.946 109.98,22.128 108.654,22.128 C105.248,22.128 103.844,19.996 103.844,17.474 C103.844,14.952 105.222,12.82 108.602,12.82 C109.824,12.82 110.708,13.054 111.54,13.444 L111.54,11.364 C110.526,10.896 109.616,10.74 108.446,10.74 C103.818,10.74 101.66,13.548 101.66,17.474 C101.66,21.452 103.818,24.26 108.446,24.26 C109.642,24.26 110.838,24.078 111.618,23.662 L111.618,21.66 Z M124.41,23.48 C123.344,24.052 121.706,24.26 120.38,24.26 C115.518,24.26 113.386,21.452 113.386,17.474 C113.386,13.548 115.57,10.74 119.522,10.74 C123.526,10.74 125.138,13.522 125.138,17.474 L125.138,18.488 L115.648,18.488 C115.96,20.698 117.39,22.128 120.458,22.128 C121.966,22.128 123.24,21.842 124.41,21.426 L124.41,23.48 Z M119.418,12.768 C117.052,12.768 115.856,14.302 115.622,16.564 L122.876,16.564 C122.746,14.146 121.654,12.768 119.418,12.768 Z\"></path>\n  </g>\n</svg>";

var ConfluenceWordmark =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ConfluenceWordmark, _Component);

  function ConfluenceWordmark() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ConfluenceWordmark);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ConfluenceWordmark).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ConfluenceWordmark, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return ConfluenceWordmark;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ConfluenceWordmark, "defaultProps", __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logo__ = __webpack_require__(2550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Wordmark__ = __webpack_require__(2552);
/* unused harmony reexport HipchatLogo */
/* unused harmony reexport HipchatIcon */
/* unused harmony reexport HipchatWordmark */





/***/ }),
/* 2550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */





var svg = function svg(iconGradientStart, iconGradientStop) {
  var id = __WEBPACK_IMPORTED_MODULE_8_uuid___default()();
  return "<canvas height=\"32\" width=\"118\" aria-hidden=\"true\"></canvas>\n  <svg viewBox=\"0 0 118 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"49.9923722%\" y1=\"107.31548%\" x2=\"49.9923722%\" y2=\"38.7491835%\" id=\"".concat(id, "\">\n        <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path d=\"M32,6.918 L32,24 L34.34,24 L34.34,16.616 L43.336,16.616 L43.336,24 L45.676,24 L45.676,6.918 L43.336,6.918 L43.336,14.38 L34.34,14.38 L34.34,6.918 L32,6.918 Z M49.524,7.568 C49.524,8.556 50.174,9.128 51.084,9.128 C51.994,9.128 52.644,8.556 52.644,7.568 C52.644,6.58 51.994,6.008 51.084,6.008 C50.174,6.008 49.524,6.58 49.524,7.568 Z M49.94,24 L52.176,24 L52.176,11 L49.94,11 L49.94,24 Z M61.926,24.26 C60.028,24.26 58.572,23.402 57.792,21.712 L57.792,29.07 L55.556,29.07 L55.556,11 L57.792,11 L57.792,13.34 C58.624,11.624 60.184,10.74 62.186,10.74 C65.644,10.74 67.386,13.678 67.386,17.5 C67.386,21.166 65.566,24.26 61.926,24.26 Z M65.15,17.5 C65.15,14.38 63.902,12.82 61.588,12.82 C59.586,12.82 57.792,14.094 57.792,16.98 L57.792,18.02 C57.792,20.906 59.43,22.18 61.328,22.18 C63.85,22.18 65.15,20.516 65.15,17.5 Z M79.164,21.66 C78.358,21.946 77.526,22.128 76.2,22.128 C72.794,22.128 71.39,19.996 71.39,17.474 C71.39,14.952 72.768,12.82 76.148,12.82 C77.37,12.82 78.254,13.054 79.086,13.444 L79.086,11.364 C78.072,10.896 77.162,10.74 75.992,10.74 C71.364,10.74 69.206,13.548 69.206,17.474 C69.206,21.452 71.364,24.26 75.992,24.26 C77.188,24.26 78.384,24.078 79.164,23.662 L79.164,21.66 Z M92.762,16.382 C92.762,12.716 91.15,10.74 88.238,10.74 C86.366,10.74 84.806,11.624 83.948,13.158 L83.948,5.566 L81.712,5.566 L81.712,24 L83.948,24 L83.948,16.772 C83.948,14.146 85.378,12.768 87.458,12.768 C89.59,12.768 90.526,14.094 90.526,16.772 L90.526,24 L92.762,24 L92.762,16.382 Z M104.722,24 L104.722,21.66 C103.89,23.376 102.33,24.26 100.328,24.26 C96.87,24.26 95.128,21.322 95.128,17.5 C95.128,13.834 96.948,10.74 100.588,10.74 C102.486,10.74 103.942,11.598 104.722,13.288 L104.722,11 L106.958,11 L106.958,24 L104.722,24 Z M97.364,17.5 C97.364,20.62 98.612,22.18 100.926,22.18 C102.928,22.18 104.722,20.906 104.722,18.02 L104.722,16.98 C104.722,14.094 103.084,12.82 101.186,12.82 C98.664,12.82 97.364,14.484 97.364,17.5 Z M113.432,19.892 L113.432,13.08 L116.89,13.08 L116.89,11 L113.432,11 L113.432,8.244 L111.248,8.244 L111.248,11 L109.142,11 L109.142,13.08 L111.248,13.08 L111.248,19.944 C111.248,22.362 112.6,24 115.382,24 C116.058,24 116.5,23.896 116.89,23.792 L116.89,21.634 C116.5,21.712 116.006,21.816 115.486,21.816 C114.108,21.816 113.432,21.036 113.432,19.892 Z\" fill=\"inherit\" fill-rule=\"evenodd\"></path>\n      <path d=\"M19.6,22.7029032 C19.6,22.7029032 19.7018182,22.6354839 19.8690909,22.5077419 C22.3054545,20.6696774 23.8363636,18.0012903 23.8363636,15.0312903 C23.8363636,9.49225806 18.4981818,5 11.9163636,5 C5.33454545,5 0,9.49225806 0,15.0312903 C0,20.5703226 5.33454545,25.0696774 11.9163636,25.0696774 C12.7567504,25.0697985 13.5953899,24.9949712 14.4218182,24.846129 L14.68,24.8 C16.3563636,25.8645161 18.7927273,26.7303226 20.9236364,26.7303226 C21.5890909,26.7303226 21.8981818,26.2016129 21.4763636,25.6658065 C20.8327273,24.8709677 19.9454545,23.653871 19.6,22.7029032 Z M18.1454545,18.3170968 C17.4363636,19.3532258 15.2363636,21.1167742 11.9345455,21.1167742 L11.8909091,21.1167742 C8.58545455,21.1167742 6.38545455,19.3425806 5.68,18.3170968 C5.53808129,18.1650868 5.44347999,17.9767692 5.40727273,17.7741935 C5.39624517,17.6454445 5.43979179,17.5179134 5.52775434,17.4213496 C5.61571689,17.3247859 5.74040319,17.267634 5.87272727,17.2632258 C5.98897276,17.2669565 6.10152459,17.3039774 6.19636364,17.3696774 C7.81185179,18.6526513 9.82983722,19.355387 11.9127273,19.3603226 L11.9127273,19.3603226 C14.0056863,19.3822708 16.0370226,18.669488 17.6363636,17.3519355 C17.7221026,17.2763864 17.8335689,17.2346492 17.9490909,17.2348387 C18.2107657,17.2348313 18.423457,17.4407925 18.4254545,17.696129 C18.3948883,17.9230374 18.3018978,18.1376272 18.1563636,18.3170968 L18.1454545,18.3170968 Z\" fill=\"url(#").concat(id, ")\" fill-rule=\"nonzero\"></path>\n    </g>\n  </svg>");
};

var HipchatLogo =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(HipchatLogo, _Component);

  function HipchatLogo() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, HipchatLogo);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(HipchatLogo).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(HipchatLogo, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return HipchatLogo;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(HipchatLogo, "defaultProps", __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */





var svg = function svg(iconGradientStart, iconGradientStop) {
  var id = __WEBPACK_IMPORTED_MODULE_8_uuid___default()();
  return "<canvas height=\"32\" width=\"32\" aria-hidden=\"true\"></canvas>\n  <svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"50%\" x2=\"50%\" y1=\"109.344%\" y2=\"50%\" id=\"".concat(id, "\">\n        <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path d=\"M23.7345538,23.2663616 C23.7345538,23.2663616 23.8370709,23.1967963 24.005492,23.0649886 C26.4585812,21.1684211 28,18.415103 28,15.3505721 C28,9.63524027 22.6251716,5 15.9981693,5 C9.37116705,5 4,9.63524027 4,15.3505721 C4,21.0659039 9.37116705,25.7084668 15.9981693,25.7084668 C16.8443253,25.7085918 17.6887221,25.6313828 18.5208238,25.4778032 L18.780778,25.4302059 C20.4686499,26.5286041 22.9217391,27.421968 25.0672769,27.421968 C25.7372998,27.421968 26.0485126,26.8764302 25.6237986,26.3235698 C24.9757437,25.5034325 24.0823799,24.2475973 23.7345538,23.2663616 Z M22.2700229,18.7409611 C21.5560641,19.8100686 19.3409611,21.6297483 16.016476,21.6297483 L15.97254,21.6297483 C12.6443936,21.6297483 10.4292906,19.7990847 9.71899314,18.7409611 C9.57610016,18.5841129 9.48084942,18.3898014 9.44439359,18.180778 C9.43329033,18.0479311 9.4771359,17.9163408 9.56570231,17.8167036 C9.65426872,17.7170664 9.77981099,17.6580954 9.91304348,17.6535469 C10.030087,17.6573963 10.1434115,17.6955956 10.2389016,17.7633867 C11.8654801,19.0871958 13.8973189,19.8122986 15.994508,19.8173913 C18.1018351,19.8400381 20.1471166,19.1045684 21.7574371,17.7450801 C21.8437646,17.6671264 21.9559962,17.6240608 22.0723112,17.6242563 C22.3357824,17.6242486 22.5499338,17.8367653 22.5519451,18.1002288 C22.521169,18.3343594 22.4275401,18.5557793 22.2810069,18.7409611 L22.2700229,18.7409611 Z\" fill=\"url(#").concat(id, ")\"></path>\n    </g>\n  </svg>");
};

var HipchatIcon =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(HipchatIcon, _Component);

  function HipchatIcon() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, HipchatIcon);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(HipchatIcon).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(HipchatIcon, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return HipchatIcon;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(HipchatIcon, "defaultProps", __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */



var svg = "<canvas height=\"32\" width=\"86\" aria-hidden=\"true\"></canvas>\n<svg viewBox=\"0 0 86 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n  <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\" fill=\"inherit\">\n    <path d=\"M-6.88338275e-14,6.918 L-6.88338275e-14,24 L2.34,24 L2.34,16.616 L11.336,16.616 L11.336,24 L13.676,24 L13.676,6.918 L11.336,6.918 L11.336,14.38 L2.34,14.38 L2.34,6.918 L-6.88338275e-14,6.918 Z M17.524,7.568 C17.524,8.556 18.174,9.128 19.084,9.128 C19.994,9.128 20.644,8.556 20.644,7.568 C20.644,6.58 19.994,6.008 19.084,6.008 C18.174,6.008 17.524,6.58 17.524,7.568 Z M17.94,24 L20.176,24 L20.176,11 L17.94,11 L17.94,24 Z M29.926,24.26 C28.028,24.26 26.572,23.402 25.792,21.712 L25.792,29.07 L23.556,29.07 L23.556,11 L25.792,11 L25.792,13.34 C26.624,11.624 28.184,10.74 30.186,10.74 C33.644,10.74 35.386,13.678 35.386,17.5 C35.386,21.166 33.566,24.26 29.926,24.26 Z M33.15,17.5 C33.15,14.38 31.902,12.82 29.588,12.82 C27.586,12.82 25.792,14.094 25.792,16.98 L25.792,18.02 C25.792,20.906 27.43,22.18 29.328,22.18 C31.85,22.18 33.15,20.516 33.15,17.5 Z M47.164,21.66 C46.358,21.946 45.526,22.128 44.2,22.128 C40.794,22.128 39.39,19.996 39.39,17.474 C39.39,14.952 40.768,12.82 44.148,12.82 C45.37,12.82 46.254,13.054 47.086,13.444 L47.086,11.364 C46.072,10.896 45.162,10.74 43.992,10.74 C39.364,10.74 37.206,13.548 37.206,17.474 C37.206,21.452 39.364,24.26 43.992,24.26 C45.188,24.26 46.384,24.078 47.164,23.662 L47.164,21.66 Z M60.762,16.382 C60.762,12.716 59.15,10.74 56.238,10.74 C54.366,10.74 52.806,11.624 51.948,13.158 L51.948,5.566 L49.712,5.566 L49.712,24 L51.948,24 L51.948,16.772 C51.948,14.146 53.378,12.768 55.458,12.768 C57.59,12.768 58.526,14.094 58.526,16.772 L58.526,24 L60.762,24 L60.762,16.382 Z M72.722,24 L72.722,21.66 C71.89,23.376 70.33,24.26 68.328,24.26 C64.87,24.26 63.128,21.322 63.128,17.5 C63.128,13.834 64.948,10.74 68.588,10.74 C70.486,10.74 71.942,11.598 72.722,13.288 L72.722,11 L74.958,11 L74.958,24 L72.722,24 Z M65.364,17.5 C65.364,20.62 66.612,22.18 68.926,22.18 C70.928,22.18 72.722,20.906 72.722,18.02 L72.722,16.98 C72.722,14.094 71.084,12.82 69.186,12.82 C66.664,12.82 65.364,14.484 65.364,17.5 Z M81.432,19.892 L81.432,13.08 L84.89,13.08 L84.89,11 L81.432,11 L81.432,8.244 L79.248,8.244 L79.248,11 L77.142,11 L77.142,13.08 L79.248,13.08 L79.248,19.944 C79.248,22.362 80.6,24 83.382,24 C84.058,24 84.5,23.896 84.89,23.792 L84.89,21.634 C84.5,21.712 84.006,21.816 83.486,21.816 C82.108,21.816 81.432,21.036 81.432,19.892 Z\"></path>\n  </g>\n</svg>";

var HipchatWordmark =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(HipchatWordmark, _Component);

  function HipchatWordmark() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, HipchatWordmark);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(HipchatWordmark).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(HipchatWordmark, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return HipchatWordmark;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(HipchatWordmark, "defaultProps", __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logo__ = __webpack_require__(2554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Wordmark__ = __webpack_require__(2556);
/* unused harmony reexport JiraCoreLogo */
/* unused harmony reexport JiraCoreIcon */
/* unused harmony reexport JiraCoreWordmark */





/***/ }),
/* 2554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */





var svg = function svg(iconGradientStart, iconGradientStop) {
  var id = __WEBPACK_IMPORTED_MODULE_8_uuid___default()();
  return "<canvas height=\"32\" width=\"123\" aria-hidden=\"true\"></canvas>\n  <svg viewBox=\"0 0 123 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"17.1933086%\" y1=\"20.0326493%\" x2=\"88.2434944%\" y2=\"53.9179104%\" id=\"".concat(id, "\">\n        <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"17%\"></stop>\n        <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n      <path d=\"M12.4602727,20.1745455 C12.4602727,24.4964247 16.0514375,28 20.4813636,28 L20.4813636,28 L20.4813636,12.4072727 L12.4602727,17.7672727 L12.4602727,20.1745455 Z\" fill=\"url(#").concat(id, ")\" fill-rule=\"nonzero\"></path>\n      <path d=\"M20.4813636,12.4072727 L20.4813636,5.16727273 C20.4805706,4.73654063 20.2359584,4.34146943 19.8455373,4.14035499 C19.4551163,3.93924054 18.9827587,3.96498483 18.6177273,4.20727273 L0,16.6072727 C2.49141839,20.1791399 7.47849106,21.1053472 11.1408182,18.6763636 L20.4813636,12.4072727 Z\" fill=\"currentColor\" fill-rule=\"nonzero\"></path>\n      <path d=\"M33.07,18.956 C33.07,20.646 32.394,21.842 30.418,21.842 C29.56,21.842 28.702,21.686 28,21.4 L28,23.662 C28.65,23.896 29.586,24.104 30.808,24.104 C34.032,24.104 35.41,21.946 35.41,18.8 L35.41,6.918 L33.07,6.918 L33.07,18.956 Z M38.894,7.568 C38.894,8.556 39.544,9.128 40.454,9.128 C41.364,9.128 42.014,8.556 42.014,7.568 C42.014,6.58 41.364,6.008 40.454,6.008 C39.544,6.008 38.894,6.58 38.894,7.568 Z M39.31,24 L41.546,24 L41.546,11 L39.31,11 L39.31,24 Z M44.926,24 L47.11,24 L47.11,16.33 C47.11,13.574 48.852,12.716 51.712,13.002 L51.712,10.818 C49.164,10.662 47.864,11.754 47.11,13.288 L47.11,11 L44.926,11 L44.926,24 Z M62.45,24 L62.45,21.66 C61.618,23.376 60.058,24.26 58.056,24.26 C54.598,24.26 52.856,21.322 52.856,17.5 C52.856,13.834 54.676,10.74 58.316,10.74 C60.214,10.74 61.67,11.598 62.45,13.288 L62.45,11 L64.686,11 L64.686,24 L62.45,24 Z M55.092,17.5 C55.092,20.62 56.34,22.18 58.654,22.18 C60.656,22.18 62.45,20.906 62.45,18.02 L62.45,16.98 C62.45,14.094 60.812,12.82 58.914,12.82 C56.392,12.82 55.092,14.484 55.092,17.5 Z M85.018,20.984 C83.77,21.608 82.366,22.024 80.572,22.024 C76.516,22.024 74.046,19.424 74.046,15.498 C74.046,11.572 76.438,8.92 80.442,8.92 C82.418,8.92 83.77,9.336 84.992,10.116 L84.992,7.854 C83.77,6.97 82.106,6.658 80.442,6.658 C74.878,6.658 71.706,10.298 71.706,15.498 C71.706,20.88 74.878,24.26 80.494,24.26 C82.262,24.26 83.952,23.948 85.018,23.246 L85.018,20.984 Z M93.624,24.26 C89.724,24.26 87.436,21.374 87.436,17.474 C87.436,13.574 89.724,10.74 93.624,10.74 C97.498,10.74 99.76,13.574 99.76,17.474 C99.76,21.374 97.498,24.26 93.624,24.26 Z M93.624,12.82 C90.842,12.82 89.62,15.004 89.62,17.474 C89.62,19.944 90.842,22.18 93.624,22.18 C96.38,22.18 97.576,19.944 97.576,17.474 C97.576,15.004 96.38,12.82 93.624,12.82 Z M102.36,24 L104.544,24 L104.544,16.33 C104.544,13.574 106.286,12.716 109.146,13.002 L109.146,10.818 C106.598,10.662 105.298,11.754 104.544,13.288 L104.544,11 L102.36,11 L102.36,24 Z M121.314,23.48 C120.248,24.052 118.61,24.26 117.284,24.26 C112.422,24.26 110.29,21.452 110.29,17.474 C110.29,13.548 112.474,10.74 116.426,10.74 C120.43,10.74 122.042,13.522 122.042,17.474 L122.042,18.488 L112.552,18.488 C112.864,20.698 114.294,22.128 117.362,22.128 C118.87,22.128 120.144,21.842 121.314,21.426 L121.314,23.48 Z M116.322,12.768 C113.956,12.768 112.76,14.302 112.526,16.564 L119.78,16.564 C119.65,14.146 118.558,12.768 116.322,12.768 Z\" fill=\"inherit\"></path>\n    </g>\n  </svg>");
};

var JiraCoreLogo =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(JiraCoreLogo, _Component);

  function JiraCoreLogo() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, JiraCoreLogo);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(JiraCoreLogo).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(JiraCoreLogo, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return JiraCoreLogo;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(JiraCoreLogo, "defaultProps", __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */





var svg = function svg(iconGradientStart, iconGradientStop) {
  var id = __WEBPACK_IMPORTED_MODULE_8_uuid___default()();
  return "<canvas height=\"32\" width=\"32\" aria-hidden=\"true\"></canvas>\n  <svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"26.51%\" y1=\"20.831%\" y2=\"63.912%\" id=\"".concat(id, "\">\n        <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"17%\"></stop>\n        <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path d=\"M15.52,20.5269517 C15.52,25.2103264 19.3166253,29.0069517 24,29.0069517 L24,12.11 L15.52,17.9183271 L15.52,20.5269517 Z\" fill=\"url(#").concat(id, ")\"></path>\n      <path d=\"M23.9969697,12.1078788 L23.9969697,4.26454545 C23.9961315,3.79791901 23.7375983,3.36992522 23.3249582,3.15205124 C22.912318,2.93417725 22.4130783,2.9620669 22.0272727,3.22454545 L2.35,16.6578788 C4.98320643,20.5274016 10.2540962,21.5307928 14.1248485,18.8993939 L23.9969697,12.1078788 Z\" fill=\"currentColor\"></path>\n    </g>\n  </svg>");
};

var JiraCoreIcon =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(JiraCoreIcon, _Component);

  function JiraCoreIcon() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, JiraCoreIcon);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(JiraCoreIcon).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(JiraCoreIcon, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return JiraCoreIcon;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(JiraCoreIcon, "defaultProps", __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */



var svg = "<canvas height=\"32\" width=\"95\" aria-hidden=\"true\"></canvas>\n<svg viewBox=\"0 0 95 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n  <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\" fill=\"inherit\">\n    <path d=\"M5.07,18.956 C5.07,20.646 4.394,21.842 2.418,21.842 C1.56,21.842 0.702,21.686 9.1038288e-15,21.4 L9.1038288e-15,23.662 C0.65,23.896 1.586,24.104 2.808,24.104 C6.032,24.104 7.41,21.946 7.41,18.8 L7.41,6.918 L5.07,6.918 L5.07,18.956 Z M10.894,7.568 C10.894,8.556 11.544,9.128 12.454,9.128 C13.364,9.128 14.014,8.556 14.014,7.568 C14.014,6.58 13.364,6.008 12.454,6.008 C11.544,6.008 10.894,6.58 10.894,7.568 Z M11.31,24 L13.546,24 L13.546,11 L11.31,11 L11.31,24 Z M16.926,24 L19.11,24 L19.11,16.33 C19.11,13.574 20.852,12.716 23.712,13.002 L23.712,10.818 C21.164,10.662 19.864,11.754 19.11,13.288 L19.11,11 L16.926,11 L16.926,24 Z M34.45,24 L34.45,21.66 C33.618,23.376 32.058,24.26 30.056,24.26 C26.598,24.26 24.856,21.322 24.856,17.5 C24.856,13.834 26.676,10.74 30.316,10.74 C32.214,10.74 33.67,11.598 34.45,13.288 L34.45,11 L36.686,11 L36.686,24 L34.45,24 Z M27.092,17.5 C27.092,20.62 28.34,22.18 30.654,22.18 C32.656,22.18 34.45,20.906 34.45,18.02 L34.45,16.98 C34.45,14.094 32.812,12.82 30.914,12.82 C28.392,12.82 27.092,14.484 27.092,17.5 Z M57.018,20.984 C55.77,21.608 54.366,22.024 52.572,22.024 C48.516,22.024 46.046,19.424 46.046,15.498 C46.046,11.572 48.438,8.92 52.442,8.92 C54.418,8.92 55.77,9.336 56.992,10.116 L56.992,7.854 C55.77,6.97 54.106,6.658 52.442,6.658 C46.878,6.658 43.706,10.298 43.706,15.498 C43.706,20.88 46.878,24.26 52.494,24.26 C54.262,24.26 55.952,23.948 57.018,23.246 L57.018,20.984 Z M65.624,24.26 C61.724,24.26 59.436,21.374 59.436,17.474 C59.436,13.574 61.724,10.74 65.624,10.74 C69.498,10.74 71.76,13.574 71.76,17.474 C71.76,21.374 69.498,24.26 65.624,24.26 Z M65.624,12.82 C62.842,12.82 61.62,15.004 61.62,17.474 C61.62,19.944 62.842,22.18 65.624,22.18 C68.38,22.18 69.576,19.944 69.576,17.474 C69.576,15.004 68.38,12.82 65.624,12.82 Z M74.36,24 L76.544,24 L76.544,16.33 C76.544,13.574 78.286,12.716 81.146,13.002 L81.146,10.818 C78.598,10.662 77.298,11.754 76.544,13.288 L76.544,11 L74.36,11 L74.36,24 Z M93.314,23.48 C92.248,24.052 90.61,24.26 89.284,24.26 C84.422,24.26 82.29,21.452 82.29,17.474 C82.29,13.548 84.474,10.74 88.426,10.74 C92.43,10.74 94.042,13.522 94.042,17.474 L94.042,18.488 L84.552,18.488 C84.864,20.698 86.294,22.128 89.362,22.128 C90.87,22.128 92.144,21.842 93.314,21.426 L93.314,23.48 Z M88.322,12.768 C85.956,12.768 84.76,14.302 84.526,16.564 L91.78,16.564 C91.65,14.146 90.558,12.768 88.322,12.768 Z\"></path>\n  </g>\n</svg>";

var JiraCoreWordmark =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(JiraCoreWordmark, _Component);

  function JiraCoreWordmark() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, JiraCoreWordmark);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(JiraCoreWordmark).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(JiraCoreWordmark, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return JiraCoreWordmark;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(JiraCoreWordmark, "defaultProps", __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logo__ = __webpack_require__(2558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Wordmark__ = __webpack_require__(2560);
/* unused harmony reexport JiraLogo */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Icon__["a"]; });
/* unused harmony reexport JiraWordmark */
/* eslint-disable max-len */





/***/ }),
/* 2558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */





var svg = function svg(iconGradientStart, iconGradientStop) {
  var id = __WEBPACK_IMPORTED_MODULE_8_uuid___default()();
  return "<canvas height=\"32\" width=\"69\" aria-hidden=\"true\"></canvas>\n  <svg viewBox=\"0 0 69 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"98.0308675%\" y1=\"0.160599572%\" x2=\"58.8877062%\" y2=\"40.7655246%\" id=\"".concat(id, "\">\n        <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"18%\"></stop>\n        <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path d=\"M22.9366667,4 L11.41,4 C11.41,5.3800098 11.9582068,6.703498 12.934021,7.67931228 C13.9098353,8.65512657 15.2333235,9.20333333 16.6133333,9.20333333 L18.7366667,9.20333333 L18.7366667,11.2533333 C18.7385054,14.1244521 21.0655479,16.4514946 23.9366667,16.4533333 L23.9366667,5 C23.9366667,4.44771525 23.4889514,4 22.9366667,4 Z\" fill=\"currentColor\"></path>\n      <path d=\"M17.2333333,9.74333333 L5.70666667,9.74333333 C5.70850536,12.6144521 8.03554792,14.9414946 10.9066667,14.9433333 L13.03,14.9433333 L13.03,17 C13.0336786,19.8711178 15.3622132,22.196669 18.2333333,22.1966667 L18.2333333,10.7433333 C18.2333333,10.1910486 17.7856181,9.74333333 17.2333333,9.74333333 Z\" fill=\"url(#").concat(id, ")\"></path>\n      <path d=\"M11.5266667,15.4833333 L0,15.4833333 C3.51929402e-16,18.357055 2.32961169,20.6866667 5.20333333,20.6866667 L7.33333333,20.6866667 L7.33333333,22.7366667 C7.33516565,25.6051863 9.65815176,27.9311544 12.5266667,27.9366667 L12.5266667,16.4833333 C12.5266667,15.9310486 12.0789514,15.4833333 11.5266667,15.4833333 Z\" fill=\"url(#").concat(id, ")\"></path>\n      <path d=\"M37.07,18.956 C37.07,20.646 36.394,21.842 34.418,21.842 C33.56,21.842 32.702,21.686 32,21.4 L32,23.662 C32.65,23.896 33.586,24.104 34.808,24.104 C38.032,24.104 39.41,21.946 39.41,18.8 L39.41,6.918 L37.07,6.918 L37.07,18.956 Z M42.894,7.568 C42.894,8.556 43.544,9.128 44.454,9.128 C45.364,9.128 46.014,8.556 46.014,7.568 C46.014,6.58 45.364,6.008 44.454,6.008 C43.544,6.008 42.894,6.58 42.894,7.568 Z M43.31,24 L45.546,24 L45.546,11 L43.31,11 L43.31,24 Z M48.926,24 L51.11,24 L51.11,16.33 C51.11,13.574 52.852,12.716 55.712,13.002 L55.712,10.818 C53.164,10.662 51.864,11.754 51.11,13.288 L51.11,11 L48.926,11 L48.926,24 Z M66.45,24 L66.45,21.66 C65.618,23.376 64.058,24.26 62.056,24.26 C58.598,24.26 56.856,21.322 56.856,17.5 C56.856,13.834 58.676,10.74 62.316,10.74 C64.214,10.74 65.67,11.598 66.45,13.288 L66.45,11 L68.686,11 L68.686,24 L66.45,24 Z M59.092,17.5 C59.092,20.62 60.34,22.18 62.654,22.18 C64.656,22.18 66.45,20.906 66.45,18.02 L66.45,16.98 C66.45,14.094 64.812,12.82 62.914,12.82 C60.392,12.82 59.092,14.484 59.092,17.5 Z\" fill-rule=\"evenodd\" fill=\"inherit\"></path>\n    </g>\n  </svg>");
};

var JiraLogo =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(JiraLogo, _Component);

  function JiraLogo() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, JiraLogo);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(JiraLogo).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(JiraLogo, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return JiraLogo;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(JiraLogo, "defaultProps", __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JiraIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */





var svg = function svg(iconGradientStart, iconGradientStop) {
  var id = __WEBPACK_IMPORTED_MODULE_8_uuid___default()();
  return "<canvas height=\"32\" width=\"32\" aria-hidden=\"true\"></canvas>\n  <svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"94.092%\" x2=\"56.535%\" y1=\"6.033%\" y2=\"43.087%\" id=\"".concat(id, "\">\n        <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"18%\"></stop>\n        <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path d=\"M26.0406546,5 L14.9983562,5 C14.9983562,6.32163748 15.5233746,7.58914413 16.4579134,8.52368295 C17.3924523,9.45822178 18.6599589,9.98324022 19.9815964,9.98324022 L22.0151159,9.98324022 L22.0151159,11.9465283 C22.0168782,14.6974491 24.2474348,16.9265768 26.9983562,16.9265762 L26.9983562,5.95770152 C26.9983562,5.42877757 26.5695786,5 26.0406546,5 Z\" fill=\"currentColor\"></path>\n      <path d=\"M20.0420436,11 L9,11 C9.00176139,13.7504065 11.2309666,15.9796117 13.9813731,15.9813731 L16.0154337,15.9813731 L16.0154337,17.9451836 C16.0154337,19.2671728 16.5405919,20.5350167 17.4753794,21.4698042 C18.4101669,22.4045917 19.6780108,22.9297499 21,22.9297499 L21,11.9579564 C21,11.4288917 20.5711083,11 20.0420436,11 Z\" fill=\"url(#").concat(id, ")\"></path>\n      <path d=\"M14.0420436,17 L3,17 C3.00176275,19.7516528 5.23291286,21.9813736 7.98456626,21.9813731 L10.0250133,21.9813731 L10.0250133,23.9451836 C10.0250082,26.6943468 12.2508419,28.9244664 15,28.9297499 L15,17.9579564 C15,17.4288917 14.5711083,17 14.0420436,17 Z\" fill=\"url(#").concat(id, ")\"></path>\n    </g>\n  </svg>");
};

var JiraIcon =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(JiraIcon, _Component);

  function JiraIcon() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, JiraIcon);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(JiraIcon).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(JiraIcon, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return JiraIcon;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(JiraIcon, "defaultProps", __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */



var svg = "<canvas height=\"32\" width=\"37\" aria-hidden=\"true\"></canvas>\n<svg viewBox=\"0 0 37 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n  <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\" fill=\"inherit\">\n    <path d=\"M5.07,18.956 C5.07,20.646 4.394,21.842 2.418,21.842 C1.56,21.842 0.702,21.686 -5.10702591e-15,21.4 L-5.10702591e-15,23.662 C0.65,23.896 1.586,24.104 2.808,24.104 C6.032,24.104 7.41,21.946 7.41,18.8 L7.41,6.918 L5.07,6.918 L5.07,18.956 Z M10.894,7.568 C10.894,8.556 11.544,9.128 12.454,9.128 C13.364,9.128 14.014,8.556 14.014,7.568 C14.014,6.58 13.364,6.008 12.454,6.008 C11.544,6.008 10.894,6.58 10.894,7.568 Z M11.31,24 L13.546,24 L13.546,11 L11.31,11 L11.31,24 Z M16.926,24 L19.11,24 L19.11,16.33 C19.11,13.574 20.852,12.716 23.712,13.002 L23.712,10.818 C21.164,10.662 19.864,11.754 19.11,13.288 L19.11,11 L16.926,11 L16.926,24 Z M34.45,24 L34.45,21.66 C33.618,23.376 32.058,24.26 30.056,24.26 C26.598,24.26 24.856,21.322 24.856,17.5 C24.856,13.834 26.676,10.74 30.316,10.74 C32.214,10.74 33.67,11.598 34.45,13.288 L34.45,11 L36.686,11 L36.686,24 L34.45,24 Z M27.092,17.5 C27.092,20.62 28.34,22.18 30.654,22.18 C32.656,22.18 34.45,20.906 34.45,18.02 L34.45,16.98 C34.45,14.094 32.812,12.82 30.914,12.82 C28.392,12.82 27.092,14.484 27.092,17.5 Z\"></path>\n  </g>\n</svg>";

var JiraWordmark =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(JiraWordmark, _Component);

  function JiraWordmark() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, JiraWordmark);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(JiraWordmark).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(JiraWordmark, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return JiraWordmark;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(JiraWordmark, "defaultProps", __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logo__ = __webpack_require__(2562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Wordmark__ = __webpack_require__(2564);
/* unused harmony reexport JiraServiceDeskLogo */
/* unused harmony reexport JiraServiceDeskIcon */
/* unused harmony reexport JiraServiceDeskWordmark */





/***/ }),
/* 2562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */





var svg = function svg(iconGradientStart, iconGradientStop) {
  var id = __WEBPACK_IMPORTED_MODULE_8_uuid___default()();
  return "<canvas height=\"32\" width=\"211\" aria-hidden=\"true\"></canvas>\n  <svg viewBox=\"0 0 211 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"38.0412357%\" y1=\"6.63683429%\" x2=\"59.8560262%\" y2=\"63.7778713%\" id=\"".concat(id, "\">\n        <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n      <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n        <path d=\"M11.191,13.4484211 L17.7175,13.4736842 C18.1019517,13.475472 18.4524969,13.6934048 18.623358,14.0368529 C18.794219,14.3803011 18.7561568,14.7904914 18.525,15.0968421 L8.892,27.9242105 C7.43758041,26.8410282 6.47431921,25.2259563 6.21419504,23.4344131 C5.95407087,21.6428699 6.41839981,19.821665 7.505,18.3715789 L11.191,13.4484211 Z\" fill=\"url(#").concat(id, ")\"></path>\n        <path d=\"M7.50183333,18.3715789 L1.01333333,18.3305263 C0.628881593,18.3287385 0.278336389,18.1108058 0.10747538,17.7673576 C-0.0633856302,17.4239094 -0.0253234719,17.0137191 0.205833333,16.7073684 L9.74383333,4 C11.1982529,5.08318232 12.1615141,6.69825426 12.4216383,8.48979744 C12.6817625,10.2813406 12.2174335,12.1025456 11.1308333,13.5526316 L7.50183333,18.3715789 Z\" fill=\"currentColor\"></path>\n        <path d=\"M32.07,18.956 C32.07,20.646 31.394,21.842 29.418,21.842 C28.56,21.842 27.702,21.686 27,21.4 L27,23.662 C27.65,23.896 28.586,24.104 29.808,24.104 C33.032,24.104 34.41,21.946 34.41,18.8 L34.41,6.918 L32.07,6.918 L32.07,18.956 Z M37.894,7.568 C37.894,8.556 38.544,9.128 39.454,9.128 C40.364,9.128 41.014,8.556 41.014,7.568 C41.014,6.58 40.364,6.008 39.454,6.008 C38.544,6.008 37.894,6.58 37.894,7.568 Z M38.31,24 L40.546,24 L40.546,11 L38.31,11 L38.31,24 Z M43.926,24 L46.11,24 L46.11,16.33 C46.11,13.574 47.852,12.716 50.712,13.002 L50.712,10.818 C48.164,10.662 46.864,11.754 46.11,13.288 L46.11,11 L43.926,11 L43.926,24 Z M61.45,24 L61.45,21.66 C60.618,23.376 59.058,24.26 57.056,24.26 C53.598,24.26 51.856,21.322 51.856,17.5 C51.856,13.834 53.676,10.74 57.316,10.74 C59.214,10.74 60.67,11.598 61.45,13.288 L61.45,11 L63.686,11 L63.686,24 L61.45,24 Z M54.092,17.5 C54.092,20.62 55.34,22.18 57.654,22.18 C59.656,22.18 61.45,20.906 61.45,18.02 L61.45,16.98 C61.45,14.094 59.812,12.82 57.914,12.82 C55.392,12.82 54.092,14.484 54.092,17.5 Z M82.926,19.294 C82.926,16.226 80.898,15.056 77.284,14.146 C74.268,13.392 73.176,12.69 73.176,11.286 C73.176,9.726 74.502,8.946 76.738,8.946 C78.506,8.946 80.352,9.258 82.068,10.246 L82.068,7.906 C80.898,7.256 79.312,6.658 76.842,6.658 C72.864,6.658 70.836,8.634 70.836,11.286 C70.836,14.094 72.552,15.42 76.4,16.356 C79.65,17.136 80.586,17.942 80.586,19.45 C80.586,20.958 79.624,21.972 77.05,21.972 C74.788,21.972 72.344,21.374 70.758,20.542 L70.758,22.934 C72.084,23.61 73.618,24.26 76.92,24.26 C81.158,24.26 82.926,22.258 82.926,19.294 Z M95.926,23.48 C94.86,24.052 93.222,24.26 91.896,24.26 C87.034,24.26 84.902,21.452 84.902,17.474 C84.902,13.548 87.086,10.74 91.038,10.74 C95.042,10.74 96.654,13.522 96.654,17.474 L96.654,18.488 L87.164,18.488 C87.476,20.698 88.906,22.128 91.974,22.128 C93.482,22.128 94.756,21.842 95.926,21.426 L95.926,23.48 Z M90.934,12.768 C88.568,12.768 87.372,14.302 87.138,16.564 L94.392,16.564 C94.262,14.146 93.17,12.768 90.934,12.768 Z M99.306,24 L101.49,24 L101.49,16.33 C101.49,13.574 103.232,12.716 106.092,13.002 L106.092,10.818 C103.544,10.662 102.244,11.754 101.49,13.288 L101.49,11 L99.306,11 L99.306,24 Z M111.604,24 L114.594,24 L119.638,11 L117.298,11 L113.112,22.102 L108.9,11 L106.56,11 L111.604,24 Z M121.146,7.568 C121.146,8.556 121.796,9.128 122.706,9.128 C123.616,9.128 124.266,8.556 124.266,7.568 C124.266,6.58 123.616,6.008 122.706,6.008 C121.796,6.008 121.146,6.58 121.146,7.568 Z M121.562,24 L123.798,24 L123.798,11 L121.562,11 L121.562,24 Z M136.356,21.66 C135.55,21.946 134.718,22.128 133.392,22.128 C129.986,22.128 128.582,19.996 128.582,17.474 C128.582,14.952 129.96,12.82 133.34,12.82 C134.562,12.82 135.446,13.054 136.278,13.444 L136.278,11.364 C135.264,10.896 134.354,10.74 133.184,10.74 C128.556,10.74 126.398,13.548 126.398,17.474 C126.398,21.452 128.556,24.26 133.184,24.26 C134.38,24.26 135.576,24.078 136.356,23.662 L136.356,21.66 Z M149.148,23.48 C148.082,24.052 146.444,24.26 145.118,24.26 C140.256,24.26 138.124,21.452 138.124,17.474 C138.124,13.548 140.308,10.74 144.26,10.74 C148.264,10.74 149.876,13.522 149.876,17.474 L149.876,18.488 L140.386,18.488 C140.698,20.698 142.128,22.128 145.196,22.128 C146.704,22.128 147.978,21.842 149.148,21.426 L149.148,23.48 Z M144.156,12.768 C141.79,12.768 140.594,14.302 140.36,16.564 L147.614,16.564 C147.484,14.146 146.392,12.768 144.156,12.768 Z M157.572,6.918 L163.864,6.918 C169.402,6.918 172.08,10.376 172.08,15.498 C172.08,20.672 169.376,24 163.864,24 L157.572,24 L157.572,6.918 Z M163.76,9.154 L159.912,9.154 L159.912,21.764 L163.89,21.764 C167.79,21.764 169.74,19.71 169.74,15.576 C169.74,11.416 167.894,9.154 163.76,9.154 Z M185.054,23.48 C183.988,24.052 182.35,24.26 181.024,24.26 C176.162,24.26 174.03,21.452 174.03,17.474 C174.03,13.548 176.214,10.74 180.166,10.74 C184.17,10.74 185.782,13.522 185.782,17.474 L185.782,18.488 L176.292,18.488 C176.604,20.698 178.034,22.128 181.102,22.128 C182.61,22.128 183.884,21.842 185.054,21.426 L185.054,23.48 Z M180.062,12.768 C177.696,12.768 176.5,14.302 176.266,16.564 L183.52,16.564 C183.39,14.146 182.298,12.768 180.062,12.768 Z M197.404,20.464 C197.404,18.202 195.948,17.136 193.062,16.434 C190.67,15.862 190.046,15.29 190.046,14.38 C190.046,13.366 190.93,12.794 192.568,12.794 C193.946,12.794 195.22,13.21 196.78,13.99 L196.78,11.676 C195.818,11.156 194.284,10.74 192.594,10.74 C189.63,10.74 187.888,12.118 187.888,14.38 C187.888,16.512 189.11,17.63 191.996,18.332 C194.466,18.93 195.22,19.502 195.22,20.49 C195.22,21.504 194.336,22.206 192.62,22.206 C190.982,22.206 189.11,21.582 187.992,20.932 L187.992,23.298 C188.98,23.818 190.566,24.26 192.516,24.26 C196,24.26 197.404,22.622 197.404,20.464 Z M202.214,24 L202.214,17.916 L207.934,24 L210.976,24 L204.606,17.396 L210.716,11 L207.804,11 L202.214,17.084 L202.214,5.566 L199.978,5.566 L199.978,24 L202.214,24 Z\" fill=\"inherit\" fill-rule=\"evenodd\"></path>\n    </g>\n  </svg>");
};

var JiraServiceDeskLogo =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(JiraServiceDeskLogo, _Component);

  function JiraServiceDeskLogo() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, JiraServiceDeskLogo);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(JiraServiceDeskLogo).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(JiraServiceDeskLogo, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return JiraServiceDeskLogo;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(JiraServiceDeskLogo, "defaultProps", __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */





var svg = function svg(iconGradientStart, iconGradientStop) {
  var id = __WEBPACK_IMPORTED_MODULE_8_uuid___default()();
  return "<canvas height=\"32\" width=\"32\" aria-hidden=\"true\"></canvas>\n  <svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"40.063%\" x2=\"69.955%\" y1=\"0%\" y2=\"50%\" id=\"".concat(id, "\">\n        <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path d=\"M18.4838727,13.07 L26.3504842,13.1005351 C26.8138769,13.102696 27.2364009,13.3661074 27.4423455,13.781227 C27.64829,14.1963467 27.6024124,14.6921363 27.3237913,15.0624169 L15.7128101,30.5666265 C13.9597489,29.2574035 12.7986975,27.3052951 12.485161,25.1398891 C12.1716246,22.974483 12.731296,20.7732253 14.041012,19.0205325 L18.4838727,13.07 Z\" fill=\"url(#").concat(id, ")\"></path>\n      <path d=\"M14.0396053,19.0156579 L6.22105263,18.9660526 C5.75779361,18.9638923 5.33539149,18.700557 5.12950634,18.2855571 C4.92362119,17.8705572 4.96948557,17.3749106 5.24802632,17.0047368 L16.7411842,1.65 C18.4937397,2.9588453 19.6544561,4.91039056 19.9679021,7.0751719 C20.2813481,9.23995324 19.7218382,11.4405759 18.4125,13.1927632 L14.0396053,19.0156579 Z\" fill=\"currentColor\"></path>\n    </g>\n  </svg>");
};

var JiraServiceDeskIcon =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(JiraServiceDeskIcon, _Component);

  function JiraServiceDeskIcon() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, JiraServiceDeskIcon);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(JiraServiceDeskIcon).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(JiraServiceDeskIcon, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return JiraServiceDeskIcon;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(JiraServiceDeskIcon, "defaultProps", __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */



var svg = "<canvas height=\"32\" width=\"185\" aria-hidden=\"true\"></canvas>\n<svg viewBox=\"0 0 185 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n  <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\" fill=\"inherit\">\n    <path d=\"M5.07,18.956 C5.07,20.646 4.394,21.842 2.418,21.842 C1.56,21.842 0.702,21.686 9.1038288e-15,21.4 L9.1038288e-15,23.662 C0.65,23.896 1.586,24.104 2.808,24.104 C6.032,24.104 7.41,21.946 7.41,18.8 L7.41,6.918 L5.07,6.918 L5.07,18.956 Z M10.894,7.568 C10.894,8.556 11.544,9.128 12.454,9.128 C13.364,9.128 14.014,8.556 14.014,7.568 C14.014,6.58 13.364,6.008 12.454,6.008 C11.544,6.008 10.894,6.58 10.894,7.568 Z M11.31,24 L13.546,24 L13.546,11 L11.31,11 L11.31,24 Z M16.926,24 L19.11,24 L19.11,16.33 C19.11,13.574 20.852,12.716 23.712,13.002 L23.712,10.818 C21.164,10.662 19.864,11.754 19.11,13.288 L19.11,11 L16.926,11 L16.926,24 Z M34.45,24 L34.45,21.66 C33.618,23.376 32.058,24.26 30.056,24.26 C26.598,24.26 24.856,21.322 24.856,17.5 C24.856,13.834 26.676,10.74 30.316,10.74 C32.214,10.74 33.67,11.598 34.45,13.288 L34.45,11 L36.686,11 L36.686,24 L34.45,24 Z M27.092,17.5 C27.092,20.62 28.34,22.18 30.654,22.18 C32.656,22.18 34.45,20.906 34.45,18.02 L34.45,16.98 C34.45,14.094 32.812,12.82 30.914,12.82 C28.392,12.82 27.092,14.484 27.092,17.5 Z M55.926,19.294 C55.926,16.226 53.898,15.056 50.284,14.146 C47.268,13.392 46.176,12.69 46.176,11.286 C46.176,9.726 47.502,8.946 49.738,8.946 C51.506,8.946 53.352,9.258 55.068,10.246 L55.068,7.906 C53.898,7.256 52.312,6.658 49.842,6.658 C45.864,6.658 43.836,8.634 43.836,11.286 C43.836,14.094 45.552,15.42 49.4,16.356 C52.65,17.136 53.586,17.942 53.586,19.45 C53.586,20.958 52.624,21.972 50.05,21.972 C47.788,21.972 45.344,21.374 43.758,20.542 L43.758,22.934 C45.084,23.61 46.618,24.26 49.92,24.26 C54.158,24.26 55.926,22.258 55.926,19.294 Z M68.926,23.48 C67.86,24.052 66.222,24.26 64.896,24.26 C60.034,24.26 57.902,21.452 57.902,17.474 C57.902,13.548 60.086,10.74 64.038,10.74 C68.042,10.74 69.654,13.522 69.654,17.474 L69.654,18.488 L60.164,18.488 C60.476,20.698 61.906,22.128 64.974,22.128 C66.482,22.128 67.756,21.842 68.926,21.426 L68.926,23.48 Z M63.934,12.768 C61.568,12.768 60.372,14.302 60.138,16.564 L67.392,16.564 C67.262,14.146 66.17,12.768 63.934,12.768 Z M72.306,24 L74.49,24 L74.49,16.33 C74.49,13.574 76.232,12.716 79.092,13.002 L79.092,10.818 C76.544,10.662 75.244,11.754 74.49,13.288 L74.49,11 L72.306,11 L72.306,24 Z M84.604,24 L87.594,24 L92.638,11 L90.298,11 L86.112,22.102 L81.9,11 L79.56,11 L84.604,24 Z M94.146,7.568 C94.146,8.556 94.796,9.128 95.706,9.128 C96.616,9.128 97.266,8.556 97.266,7.568 C97.266,6.58 96.616,6.008 95.706,6.008 C94.796,6.008 94.146,6.58 94.146,7.568 Z M94.562,24 L96.798,24 L96.798,11 L94.562,11 L94.562,24 Z M109.356,21.66 C108.55,21.946 107.718,22.128 106.392,22.128 C102.986,22.128 101.582,19.996 101.582,17.474 C101.582,14.952 102.96,12.82 106.34,12.82 C107.562,12.82 108.446,13.054 109.278,13.444 L109.278,11.364 C108.264,10.896 107.354,10.74 106.184,10.74 C101.556,10.74 99.398,13.548 99.398,17.474 C99.398,21.452 101.556,24.26 106.184,24.26 C107.38,24.26 108.576,24.078 109.356,23.662 L109.356,21.66 Z M122.148,23.48 C121.082,24.052 119.444,24.26 118.118,24.26 C113.256,24.26 111.124,21.452 111.124,17.474 C111.124,13.548 113.308,10.74 117.26,10.74 C121.264,10.74 122.876,13.522 122.876,17.474 L122.876,18.488 L113.386,18.488 C113.698,20.698 115.128,22.128 118.196,22.128 C119.704,22.128 120.978,21.842 122.148,21.426 L122.148,23.48 Z M117.156,12.768 C114.79,12.768 113.594,14.302 113.36,16.564 L120.614,16.564 C120.484,14.146 119.392,12.768 117.156,12.768 Z M130.572,6.918 L136.864,6.918 C142.402,6.918 145.08,10.376 145.08,15.498 C145.08,20.672 142.376,24 136.864,24 L130.572,24 L130.572,6.918 Z M136.76,9.154 L132.912,9.154 L132.912,21.764 L136.89,21.764 C140.79,21.764 142.74,19.71 142.74,15.576 C142.74,11.416 140.894,9.154 136.76,9.154 Z M158.054,23.48 C156.988,24.052 155.35,24.26 154.024,24.26 C149.162,24.26 147.03,21.452 147.03,17.474 C147.03,13.548 149.214,10.74 153.166,10.74 C157.17,10.74 158.782,13.522 158.782,17.474 L158.782,18.488 L149.292,18.488 C149.604,20.698 151.034,22.128 154.102,22.128 C155.61,22.128 156.884,21.842 158.054,21.426 L158.054,23.48 Z M153.062,12.768 C150.696,12.768 149.5,14.302 149.266,16.564 L156.52,16.564 C156.39,14.146 155.298,12.768 153.062,12.768 Z M170.404,20.464 C170.404,18.202 168.948,17.136 166.062,16.434 C163.67,15.862 163.046,15.29 163.046,14.38 C163.046,13.366 163.93,12.794 165.568,12.794 C166.946,12.794 168.22,13.21 169.78,13.99 L169.78,11.676 C168.818,11.156 167.284,10.74 165.594,10.74 C162.63,10.74 160.888,12.118 160.888,14.38 C160.888,16.512 162.11,17.63 164.996,18.332 C167.466,18.93 168.22,19.502 168.22,20.49 C168.22,21.504 167.336,22.206 165.62,22.206 C163.982,22.206 162.11,21.582 160.992,20.932 L160.992,23.298 C161.98,23.818 163.566,24.26 165.516,24.26 C169,24.26 170.404,22.622 170.404,20.464 Z M175.214,24 L175.214,17.916 L180.934,24 L183.976,24 L177.606,17.396 L183.716,11 L180.804,11 L175.214,17.084 L175.214,5.566 L172.978,5.566 L172.978,24 L175.214,24 Z\"></path>\n  </g>\n</svg>";

var JiraServiceDeskWordmark =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(JiraServiceDeskWordmark, _Component);

  function JiraServiceDeskWordmark() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, JiraServiceDeskWordmark);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(JiraServiceDeskWordmark).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(JiraServiceDeskWordmark, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return JiraServiceDeskWordmark;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(JiraServiceDeskWordmark, "defaultProps", __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logo__ = __webpack_require__(2566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Wordmark__ = __webpack_require__(2568);
/* unused harmony reexport JiraSoftwareLogo */
/* unused harmony reexport JiraSoftwareIcon */
/* unused harmony reexport JiraSoftwareWordmark */





/***/ }),
/* 2566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */





var svg = function svg(iconGradientStart, iconGradientStop) {
  var id = __WEBPACK_IMPORTED_MODULE_8_uuid___default()();
  return "<canvas height=\"32\" width=\"179\" aria-hidden=\"true\"></canvas>\n  <svg viewBox=\"0 0 179 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"97.6553341%\" y1=\"35.6591143%\" x2=\"37.202032%\" y2=\"75.4891864%\" id=\"".concat(id, "-1\">\n        <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"7%\"></stop>\n        <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n      <linearGradient x1=\"8.43371138%\" y1=\"60.1495759%\" x2=\"64.1161517%\" y2=\"23.5790285%\" id=\"").concat(id, "-2\">\n        <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path d=\"M11.3881081,27.9242105 C12.4881804,26.8071817 13.1062496,25.2917664 13.1062496,23.7115789 C13.1062496,22.1313915 12.4881804,20.6159762 11.3881081,19.4989474 L11.3881081,19.4989474 L3.74837838,11.7621053 L0.273513514,15.2926316 C-0.0900771727,15.6625064 -0.0900771727,16.2617042 0.273513514,16.6315789 L11.3881081,27.9242105 L11.3881081,27.9242105 Z\" fill=\"currentColor\" fill-rule=\"nonzero\"></path>\n      <path d=\"M22.5027027,15.2926316 L11.3881081,4 L11.3881081,4 L11.3539189,4.03473684 L11.3539189,4.03473684 C9.08852466,6.36456187 9.09963243,10.1156459 11.3787838,12.4315789 L19.0247297,20.1652632 L22.5027027,16.6315789 C22.8662934,16.2617042 22.8662934,15.6625064 22.5027027,15.2926316 Z\" fill=\"currentColor\" fill-rule=\"nonzero\"></path>\n      <path d=\"M11.3881081,12.4252632 C9.10895676,10.1093301 9.09784899,6.35824608 11.3632432,4.02842105 L3.43445946,12.0810526 L7.58067568,16.2936842 L11.3881081,12.4252632 Z\" fill=\"url(#").concat(id, "-1)\" fill-rule=\"nonzero\"></path>\n      <path d=\"M15.1893243,15.6368421 L11.3881081,19.4989474 C12.4881804,20.6159762 13.1062496,22.1313915 13.1062496,23.7115789 C13.1062496,25.2917664 12.4881804,26.8071817 11.3881081,27.9242105 L19.3355405,19.8494737 L15.1893243,15.6368421 Z\" fill=\"url(#").concat(id, "-2)\" fill-rule=\"nonzero\"></path>\n      <path d=\"M36.07,18.956 C36.07,20.646 35.394,21.842 33.418,21.842 C32.56,21.842 31.702,21.686 31,21.4 L31,23.662 C31.65,23.896 32.586,24.104 33.808,24.104 C37.032,24.104 38.41,21.946 38.41,18.8 L38.41,6.918 L36.07,6.918 L36.07,18.956 Z M41.894,7.568 C41.894,8.556 42.544,9.128 43.454,9.128 C44.364,9.128 45.014,8.556 45.014,7.568 C45.014,6.58 44.364,6.008 43.454,6.008 C42.544,6.008 41.894,6.58 41.894,7.568 Z M42.31,24 L44.546,24 L44.546,11 L42.31,11 L42.31,24 Z M47.926,24 L50.11,24 L50.11,16.33 C50.11,13.574 51.852,12.716 54.712,13.002 L54.712,10.818 C52.164,10.662 50.864,11.754 50.11,13.288 L50.11,11 L47.926,11 L47.926,24 Z M65.45,24 L65.45,21.66 C64.618,23.376 63.058,24.26 61.056,24.26 C57.598,24.26 55.856,21.322 55.856,17.5 C55.856,13.834 57.676,10.74 61.316,10.74 C63.214,10.74 64.67,11.598 65.45,13.288 L65.45,11 L67.686,11 L67.686,24 L65.45,24 Z M58.092,17.5 C58.092,20.62 59.34,22.18 61.654,22.18 C63.656,22.18 65.45,20.906 65.45,18.02 L65.45,16.98 C65.45,14.094 63.812,12.82 61.914,12.82 C59.392,12.82 58.092,14.484 58.092,17.5 Z M86.926,19.294 C86.926,16.226 84.898,15.056 81.284,14.146 C78.268,13.392 77.176,12.69 77.176,11.286 C77.176,9.726 78.502,8.946 80.738,8.946 C82.506,8.946 84.352,9.258 86.068,10.246 L86.068,7.906 C84.898,7.256 83.312,6.658 80.842,6.658 C76.864,6.658 74.836,8.634 74.836,11.286 C74.836,14.094 76.552,15.42 80.4,16.356 C83.65,17.136 84.586,17.942 84.586,19.45 C84.586,20.958 83.624,21.972 81.05,21.972 C78.788,21.972 76.344,21.374 74.758,20.542 L74.758,22.934 C76.084,23.61 77.618,24.26 80.92,24.26 C85.158,24.26 86.926,22.258 86.926,19.294 Z M95.09,24.26 C91.19,24.26 88.902,21.374 88.902,17.474 C88.902,13.574 91.19,10.74 95.09,10.74 C98.964,10.74 101.226,13.574 101.226,17.474 C101.226,21.374 98.964,24.26 95.09,24.26 Z M95.09,12.82 C92.308,12.82 91.086,15.004 91.086,17.474 C91.086,19.944 92.308,22.18 95.09,22.18 C97.846,22.18 99.042,19.944 99.042,17.474 C99.042,15.004 97.846,12.82 95.09,12.82 Z M106.92,9.622 C106.92,8.452 107.596,7.646 108.974,7.646 C109.494,7.646 109.988,7.698 110.378,7.776 L110.378,5.722 C109.988,5.618 109.546,5.514 108.87,5.514 C106.088,5.514 104.736,7.152 104.736,9.57 L104.736,11 L102.63,11 L102.63,13.08 L104.736,13.08 L104.736,24 L106.92,24 L106.92,13.08 L110.274,13.08 L110.274,11 L106.92,11 L106.92,9.622 Z M115.786,19.892 L115.786,13.08 L119.244,13.08 L119.244,11 L115.786,11 L115.786,8.244 L113.602,8.244 L113.602,11 L111.496,11 L111.496,13.08 L113.602,13.08 L113.602,19.944 C113.602,22.362 114.954,24 117.736,24 C118.412,24 118.854,23.896 119.244,23.792 L119.244,21.634 C118.854,21.712 118.36,21.816 117.84,21.816 C116.462,21.816 115.786,21.036 115.786,19.892 Z M125.432,24 L128.292,24 L130.528,17.708 L131.724,13.704 L132.92,17.708 L135.156,24 L138.016,24 L142.8,11 L140.33,11 L136.586,22.024 L132.79,11 L130.658,11 L126.862,22.024 L123.118,11 L120.648,11 L125.432,24 Z M153.538,24 L153.538,21.66 C152.706,23.376 151.146,24.26 149.144,24.26 C145.686,24.26 143.944,21.322 143.944,17.5 C143.944,13.834 145.764,10.74 149.404,10.74 C151.302,10.74 152.758,11.598 153.538,13.288 L153.538,11 L155.774,11 L155.774,24 L153.538,24 Z M146.18,17.5 C146.18,20.62 147.428,22.18 149.742,22.18 C151.744,22.18 153.538,20.906 153.538,18.02 L153.538,16.98 C153.538,14.094 151.9,12.82 150.002,12.82 C147.48,12.82 146.18,14.484 146.18,17.5 Z M159.154,24 L161.338,24 L161.338,16.33 C161.338,13.574 163.08,12.716 165.94,13.002 L165.94,10.818 C163.392,10.662 162.092,11.754 161.338,13.288 L161.338,11 L159.154,11 L159.154,24 Z M178.108,23.48 C177.042,24.052 175.404,24.26 174.078,24.26 C169.216,24.26 167.084,21.452 167.084,17.474 C167.084,13.548 169.268,10.74 173.22,10.74 C177.224,10.74 178.836,13.522 178.836,17.474 L178.836,18.488 L169.346,18.488 C169.658,20.698 171.088,22.128 174.156,22.128 C175.664,22.128 176.938,21.842 178.108,21.426 L178.108,23.48 Z M173.116,12.768 C170.75,12.768 169.554,14.302 169.32,16.564 L176.574,16.564 C176.444,14.146 175.352,12.768 173.116,12.768 Z\" fill=\"inherit\" fill-rule=\"evenodd\"></path>\n    </g>\n  </svg>");
};

var JiraSoftwareLogo =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(JiraSoftwareLogo, _Component);

  function JiraSoftwareLogo() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, JiraSoftwareLogo);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(JiraSoftwareLogo).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(JiraSoftwareLogo, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return JiraSoftwareLogo;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(JiraSoftwareLogo, "defaultProps", __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */





var svg = function svg(iconGradientStart, iconGradientStop) {
  var id = __WEBPACK_IMPORTED_MODULE_8_uuid___default()();
  return "<canvas height=\"32\" width=\"32\" aria-hidden=\"true\"></canvas>\n  <svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"108.695%\" x2=\"12.439%\" y1=\"-14.936%\" y2=\"45.215%\" id=\"".concat(id, "-1\">\n        <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n      <linearGradient x1=\"0%\" x2=\"91.029%\" y1=\"118.55%\" y2=\"63.971%\" id=\"").concat(id, "-2\">\n        <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">     \n      <path d=\"M15.9669691 29.3616152C17.2195568 28.1097726 17.9233158 26.4114623 17.9233158 24.6405626 17.9233158 22.8696629 17.2195568 21.1713527 15.9669691 19.91951L7.26805808 11.2489111 3.31143376 15.2055354C2.89743442 15.6200502 2.89743442 16.291565 3.31143376 16.7060799L15.9669691 29.3616152zM28.6225045 15.2055354L15.9669691 2.55 15.9280399 2.58892922C13.3485687 5.19994003 13.3612164 9.40374108 15.9563521 11.9991833L24.6623412 20.6662432 28.6225045 16.7060799C29.0365039 16.291565 29.0365039 15.6200502 28.6225045 15.2055354z\" fill=\"currentColor\"/>\n      <path d=\"M15.9669691,11.9921053 C13.3718335,9.39666304 13.3591857,5.19286199 15.938657,2.58185118 L6.91061706,11.6063521 L11.6316697,16.3274047 L15.9669691,11.9921053 Z\" fill=\"url(#").concat(id, "-1\"/>\n      <path d=\"M20.2951906,15.5912886 L15.9669691,19.91951 C17.2195568,21.1713527 17.9233158,22.8696629 17.9233158,24.6405626 C17.9233158,26.4114623 17.2195568,28.1097726 15.9669691,29.3616152 L25.0162432,20.3123412 L20.2951906,15.5912886 Z\" fill=\"url(#").concat(id, "-2\"/>\n    </g>\n  </svg>");
};

var JiraSoftwareIcon =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(JiraSoftwareIcon, _Component);

  function JiraSoftwareIcon() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, JiraSoftwareIcon);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(JiraSoftwareIcon).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(JiraSoftwareIcon, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return JiraSoftwareIcon;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(JiraSoftwareIcon, "defaultProps", __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */



var svg = "<canvas height=\"32\" width=\"148\" aria-hidden=\"true\"></canvas>\n<svg viewBox=\"0 0 148 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n  <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\" fill=\"inherit\">\n    <path d=\"M5.07,18.956 C5.07,20.646 4.394,21.842 2.418,21.842 C1.56,21.842 0.702,21.686 1.99840144e-15,21.4 L1.99840144e-15,23.662 C0.65,23.896 1.586,24.104 2.808,24.104 C6.032,24.104 7.41,21.946 7.41,18.8 L7.41,6.918 L5.07,6.918 L5.07,18.956 Z M10.894,7.568 C10.894,8.556 11.544,9.128 12.454,9.128 C13.364,9.128 14.014,8.556 14.014,7.568 C14.014,6.58 13.364,6.008 12.454,6.008 C11.544,6.008 10.894,6.58 10.894,7.568 Z M11.31,24 L13.546,24 L13.546,11 L11.31,11 L11.31,24 Z M16.926,24 L19.11,24 L19.11,16.33 C19.11,13.574 20.852,12.716 23.712,13.002 L23.712,10.818 C21.164,10.662 19.864,11.754 19.11,13.288 L19.11,11 L16.926,11 L16.926,24 Z M34.45,24 L34.45,21.66 C33.618,23.376 32.058,24.26 30.056,24.26 C26.598,24.26 24.856,21.322 24.856,17.5 C24.856,13.834 26.676,10.74 30.316,10.74 C32.214,10.74 33.67,11.598 34.45,13.288 L34.45,11 L36.686,11 L36.686,24 L34.45,24 Z M27.092,17.5 C27.092,20.62 28.34,22.18 30.654,22.18 C32.656,22.18 34.45,20.906 34.45,18.02 L34.45,16.98 C34.45,14.094 32.812,12.82 30.914,12.82 C28.392,12.82 27.092,14.484 27.092,17.5 Z M55.926,19.294 C55.926,16.226 53.898,15.056 50.284,14.146 C47.268,13.392 46.176,12.69 46.176,11.286 C46.176,9.726 47.502,8.946 49.738,8.946 C51.506,8.946 53.352,9.258 55.068,10.246 L55.068,7.906 C53.898,7.256 52.312,6.658 49.842,6.658 C45.864,6.658 43.836,8.634 43.836,11.286 C43.836,14.094 45.552,15.42 49.4,16.356 C52.65,17.136 53.586,17.942 53.586,19.45 C53.586,20.958 52.624,21.972 50.05,21.972 C47.788,21.972 45.344,21.374 43.758,20.542 L43.758,22.934 C45.084,23.61 46.618,24.26 49.92,24.26 C54.158,24.26 55.926,22.258 55.926,19.294 Z M64.09,24.26 C60.19,24.26 57.902,21.374 57.902,17.474 C57.902,13.574 60.19,10.74 64.09,10.74 C67.964,10.74 70.226,13.574 70.226,17.474 C70.226,21.374 67.964,24.26 64.09,24.26 Z M64.09,12.82 C61.308,12.82 60.086,15.004 60.086,17.474 C60.086,19.944 61.308,22.18 64.09,22.18 C66.846,22.18 68.042,19.944 68.042,17.474 C68.042,15.004 66.846,12.82 64.09,12.82 Z M75.92,9.622 C75.92,8.452 76.596,7.646 77.974,7.646 C78.494,7.646 78.988,7.698 79.378,7.776 L79.378,5.722 C78.988,5.618 78.546,5.514 77.87,5.514 C75.088,5.514 73.736,7.152 73.736,9.57 L73.736,11 L71.63,11 L71.63,13.08 L73.736,13.08 L73.736,24 L75.92,24 L75.92,13.08 L79.274,13.08 L79.274,11 L75.92,11 L75.92,9.622 Z M84.786,19.892 L84.786,13.08 L88.244,13.08 L88.244,11 L84.786,11 L84.786,8.244 L82.602,8.244 L82.602,11 L80.496,11 L80.496,13.08 L82.602,13.08 L82.602,19.944 C82.602,22.362 83.954,24 86.736,24 C87.412,24 87.854,23.896 88.244,23.792 L88.244,21.634 C87.854,21.712 87.36,21.816 86.84,21.816 C85.462,21.816 84.786,21.036 84.786,19.892 Z M94.432,24 L97.292,24 L99.528,17.708 L100.724,13.704 L101.92,17.708 L104.156,24 L107.016,24 L111.8,11 L109.33,11 L105.586,22.024 L101.79,11 L99.658,11 L95.862,22.024 L92.118,11 L89.648,11 L94.432,24 Z M122.538,24 L122.538,21.66 C121.706,23.376 120.146,24.26 118.144,24.26 C114.686,24.26 112.944,21.322 112.944,17.5 C112.944,13.834 114.764,10.74 118.404,10.74 C120.302,10.74 121.758,11.598 122.538,13.288 L122.538,11 L124.774,11 L124.774,24 L122.538,24 Z M115.18,17.5 C115.18,20.62 116.428,22.18 118.742,22.18 C120.744,22.18 122.538,20.906 122.538,18.02 L122.538,16.98 C122.538,14.094 120.9,12.82 119.002,12.82 C116.48,12.82 115.18,14.484 115.18,17.5 Z M128.154,24 L130.338,24 L130.338,16.33 C130.338,13.574 132.08,12.716 134.94,13.002 L134.94,10.818 C132.392,10.662 131.092,11.754 130.338,13.288 L130.338,11 L128.154,11 L128.154,24 Z M147.108,23.48 C146.042,24.052 144.404,24.26 143.078,24.26 C138.216,24.26 136.084,21.452 136.084,17.474 C136.084,13.548 138.268,10.74 142.22,10.74 C146.224,10.74 147.836,13.522 147.836,17.474 L147.836,18.488 L138.346,18.488 C138.658,20.698 140.088,22.128 143.156,22.128 C144.664,22.128 145.938,21.842 147.108,21.426 L147.108,23.48 Z M142.116,12.768 C139.75,12.768 138.554,14.302 138.32,16.564 L145.574,16.564 C145.444,14.146 144.352,12.768 142.116,12.768 Z\"></path>\n  </g>\n</svg>";

var JiraSoftwareWordmark =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(JiraSoftwareWordmark, _Component);

  function JiraSoftwareWordmark() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, JiraSoftwareWordmark);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(JiraSoftwareWordmark).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(JiraSoftwareWordmark, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return JiraSoftwareWordmark;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(JiraSoftwareWordmark, "defaultProps", __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logo__ = __webpack_require__(2570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Wordmark__ = __webpack_require__(2572);
/* unused harmony reexport StatuspageLogo */
/* unused harmony reexport StatuspageIcon */
/* unused harmony reexport StatuspageWordmark */





/***/ }),
/* 2570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */





var svg = function svg(iconGradientStart, iconGradientStop) {
  var id = __WEBPACK_IMPORTED_MODULE_8_uuid___default()();
  return "<canvas height=\"32\" width=\"161\" aria-hidden=\"true\"></canvas>\n  <svg viewBox=\"0 0 161 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"50%\" y1=\"-8.10423826%\" x2=\"50%\" y2=\"68.0985109%\" id=\"".concat(id, "\">\n        <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path d=\"M44.168,19.294 C44.168,16.226 42.14,15.056 38.526,14.146 C35.51,13.392 34.418,12.69 34.418,11.286 C34.418,9.726 35.744,8.946 37.98,8.946 C39.748,8.946 41.594,9.258 43.31,10.246 L43.31,7.906 C42.14,7.256 40.554,6.658 38.084,6.658 C34.106,6.658 32.078,8.634 32.078,11.286 C32.078,14.094 33.794,15.42 37.642,16.356 C40.892,17.136 41.828,17.942 41.828,19.45 C41.828,20.958 40.866,21.972 38.292,21.972 C36.03,21.972 33.586,21.374 32,20.542 L32,22.934 C33.326,23.61 34.86,24.26 38.162,24.26 C42.4,24.26 44.168,22.258 44.168,19.294 Z M50.018,19.892 L50.018,13.08 L53.476,13.08 L53.476,11 L50.018,11 L50.018,8.244 L47.834,8.244 L47.834,11 L45.728,11 L45.728,13.08 L47.834,13.08 L47.834,19.944 C47.834,22.362 49.186,24 51.968,24 C52.644,24 53.086,23.896 53.476,23.792 L53.476,21.634 C53.086,21.712 52.592,21.816 52.072,21.816 C50.694,21.816 50.018,21.036 50.018,19.892 Z M65.15,24 L65.15,21.66 C64.318,23.376 62.758,24.26 60.756,24.26 C57.298,24.26 55.556,21.322 55.556,17.5 C55.556,13.834 57.376,10.74 61.016,10.74 C62.914,10.74 64.37,11.598 65.15,13.288 L65.15,11 L67.386,11 L67.386,24 L65.15,24 Z M57.792,17.5 C57.792,20.62 59.04,22.18 61.354,22.18 C63.356,22.18 65.15,20.906 65.15,18.02 L65.15,16.98 C65.15,14.094 63.512,12.82 61.614,12.82 C59.092,12.82 57.792,14.484 57.792,17.5 Z M73.86,19.892 L73.86,13.08 L77.318,13.08 L77.318,11 L73.86,11 L73.86,8.244 L71.676,8.244 L71.676,11 L69.57,11 L69.57,13.08 L71.676,13.08 L71.676,19.944 C71.676,22.362 73.028,24 75.81,24 C76.486,24 76.928,23.896 77.318,23.792 L77.318,21.634 C76.928,21.712 76.434,21.816 75.914,21.816 C74.536,21.816 73.86,21.036 73.86,19.892 Z M79.918,18.618 C79.918,22.206 81.634,24.26 84.624,24.26 C86.366,24.26 87.9,23.402 88.732,21.868 L88.732,24 L90.968,24 L90.968,11 L88.732,11 L88.732,18.228 C88.732,20.854 87.302,22.232 85.222,22.232 C83.09,22.232 82.154,21.192 82.154,18.852 L82.154,11 L79.918,11 L79.918,18.618 Z M103.318,20.464 C103.318,18.202 101.862,17.136 98.976,16.434 C96.584,15.862 95.96,15.29 95.96,14.38 C95.96,13.366 96.844,12.794 98.482,12.794 C99.86,12.794 101.134,13.21 102.694,13.99 L102.694,11.676 C101.732,11.156 100.198,10.74 98.508,10.74 C95.544,10.74 93.802,12.118 93.802,14.38 C93.802,16.512 95.024,17.63 97.91,18.332 C100.38,18.93 101.134,19.502 101.134,20.49 C101.134,21.504 100.25,22.206 98.534,22.206 C96.896,22.206 95.024,21.582 93.906,20.932 L93.906,23.298 C94.894,23.818 96.48,24.26 98.43,24.26 C101.914,24.26 103.318,22.622 103.318,20.464 Z M112.262,24.26 C110.364,24.26 108.908,23.402 108.128,21.712 L108.128,29.07 L105.892,29.07 L105.892,11 L108.128,11 L108.128,13.34 C108.96,11.624 110.52,10.74 112.522,10.74 C115.98,10.74 117.722,13.678 117.722,17.5 C117.722,21.166 115.902,24.26 112.262,24.26 Z M115.486,17.5 C115.486,14.38 114.238,12.82 111.924,12.82 C109.922,12.82 108.128,14.094 108.128,16.98 L108.128,18.02 C108.128,20.906 109.766,22.18 111.664,22.18 C114.186,22.18 115.486,20.516 115.486,17.5 Z M129.136,24 L129.136,21.66 C128.304,23.376 126.744,24.26 124.742,24.26 C121.284,24.26 119.542,21.322 119.542,17.5 C119.542,13.834 121.362,10.74 125.002,10.74 C126.9,10.74 128.356,11.598 129.136,13.288 L129.136,11 L131.372,11 L131.372,24 L129.136,24 Z M121.778,17.5 C121.778,20.62 123.026,22.18 125.34,22.18 C127.342,22.18 129.136,20.906 129.136,18.02 L129.136,16.98 C129.136,14.094 127.498,12.82 125.6,12.82 C123.078,12.82 121.778,14.484 121.778,17.5 Z M143.514,22.96 L143.514,21.66 C142.682,23.376 141.122,24.26 139.12,24.26 C135.688,24.26 133.972,21.322 133.972,17.5 C133.972,13.834 135.766,10.74 139.38,10.74 C141.278,10.74 142.734,11.598 143.514,13.288 L143.514,11 L145.698,11 L145.698,22.83 C145.698,26.652 143.904,29.226 139.25,29.226 C137.066,29.226 135.87,28.94 134.622,28.524 L134.622,26.34 C136.052,26.808 137.534,27.12 139.146,27.12 C142.396,27.12 143.514,25.378 143.514,22.96 Z M136.156,17.5 C136.156,20.62 137.404,22.18 139.718,22.18 C141.72,22.18 143.514,20.906 143.514,18.02 L143.514,16.98 C143.514,14.094 141.876,12.82 139.978,12.82 C137.456,12.82 136.156,14.484 136.156,17.5 Z M159.322,23.48 C158.256,24.052 156.618,24.26 155.292,24.26 C150.43,24.26 148.298,21.452 148.298,17.474 C148.298,13.548 150.482,10.74 154.434,10.74 C158.438,10.74 160.05,13.522 160.05,17.474 L160.05,18.488 L150.56,18.488 C150.872,20.698 152.302,22.128 155.37,22.128 C156.878,22.128 158.152,21.842 159.322,21.426 L159.322,23.48 Z M154.33,12.768 C151.964,12.768 150.768,14.302 150.534,16.564 L157.788,16.564 C157.658,14.146 156.566,12.768 154.33,12.768 Z\" fill=\"inherit\" fill-rule=\"evenodd\"></path>\n      <ellipse fill=\"url(#").concat(id, ")\" cx=\"11.6900001\" cy=\"19.5878182\" rx=\"5.4000001\" ry=\"5.39981818\"></ellipse>\n      <path d=\"M0.150296445,13.3410909 L3.11240171,16.7750909 C3.22188902,16.9011063 3.37840885,16.9789144 3.54695495,16.9911129 C3.71550104,17.0033115 3.88201085,16.9488828 4.00924381,16.84 C8.80608592,12.6363636 14.7618754,12.6363636 19.5555596,16.84 C19.6827926,16.9488828 19.8493024,17.0033115 20.0178485,16.9911129 C20.1863946,16.9789144 20.3429144,16.9011063 20.4524017,16.7750909 L23.414507,13.3410909 C23.6383491,13.0812594 23.6059055,12.6932914 23.3418754,12.4725455 C16.3818754,6.51018182 7.18292802,6.51018182 0.222928024,12.4694545 C0.0951564484,12.5755828 0.015714237,12.7270623 0.0020917901,12.8905424 C-0.0115306568,13.0540226 0.0417835359,13.2161 0.150296445,13.3410909 Z\" fill=\"currentColor\"></path>\n    </g>\n  </svg>");
};

var StatuspageLogo =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(StatuspageLogo, _Component);

  function StatuspageLogo() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, StatuspageLogo);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(StatuspageLogo).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(StatuspageLogo, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return StatuspageLogo;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(StatuspageLogo, "defaultProps", __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */





var svg = function svg(iconGradientStart, iconGradientStop) {
  var id = __WEBPACK_IMPORTED_MODULE_8_uuid___default()();
  return "<canvas height=\"32\" width=\"32\" aria-hidden=\"true\"></canvas>\n  <svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n        <linearGradient x1=\"50%\" x2=\"50%\" y1=\"0%\" y2=\"68.184%\" id=\"".concat(id, "\">\n            <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n            <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n        </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <ellipse fill=\"url(#").concat(id, ")\" cx=\"16.0000005\" cy=\"19.5878182\" rx=\"5.4000001\" ry=\"5.39981818\"></ellipse>\n      <path d=\"M3.15511518,12.9260684 L6.43896953,16.7678667 C6.68897511,17.0467148 7.11846411,17.078724 7.40809003,16.8400939 C12.7068784,12.1590845 19.2850452,12.1590845 24.5838335,16.8400939 C24.8734595,17.078724 25.3029485,17.0467148 25.552954,16.7678667 L28.8402944,12.9260684 C29.0719048,12.6494664 29.04914,12.2436871 28.7880038,11.9939938 C21.0838444,5.3353354 10.9080792,5.3353354 3.21786399,11.9939938 C2.9535556,12.2408944 2.92622614,12.6468478 3.15511518,12.9260684 Z\" fill=\"currentColor\"></path>\n    </g>\n  </svg>");
};

var StatuspageIcon =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(StatuspageIcon, _Component);

  function StatuspageIcon() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, StatuspageIcon);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(StatuspageIcon).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(StatuspageIcon, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return StatuspageIcon;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(StatuspageIcon, "defaultProps", __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */



var svg = "<canvas height=\"32\" width=\"129\" aria-hidden=\"true\"></canvas>\n<svg viewBox=\"0 0 129 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n  <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\" fill=\"inherit\">\n    <path d=\"M12.168,19.294 C12.168,16.226 10.14,15.056 6.526,14.146 C3.51,13.392 2.418,12.69 2.418,11.286 C2.418,9.726 3.744,8.946 5.98,8.946 C7.748,8.946 9.594,9.258 11.31,10.246 L11.31,7.906 C10.14,7.256 8.554,6.658 6.084,6.658 C2.106,6.658 0.078,8.634 0.078,11.286 C0.078,14.094 1.794,15.42 5.642,16.356 C8.892,17.136 9.828,17.942 9.828,19.45 C9.828,20.958 8.866,21.972 6.292,21.972 C4.03,21.972 1.586,21.374 1.55431223e-14,20.542 L1.55431223e-14,22.934 C1.326,23.61 2.86,24.26 6.162,24.26 C10.4,24.26 12.168,22.258 12.168,19.294 Z M18.018,19.892 L18.018,13.08 L21.476,13.08 L21.476,11 L18.018,11 L18.018,8.244 L15.834,8.244 L15.834,11 L13.728,11 L13.728,13.08 L15.834,13.08 L15.834,19.944 C15.834,22.362 17.186,24 19.968,24 C20.644,24 21.086,23.896 21.476,23.792 L21.476,21.634 C21.086,21.712 20.592,21.816 20.072,21.816 C18.694,21.816 18.018,21.036 18.018,19.892 Z M33.15,24 L33.15,21.66 C32.318,23.376 30.758,24.26 28.756,24.26 C25.298,24.26 23.556,21.322 23.556,17.5 C23.556,13.834 25.376,10.74 29.016,10.74 C30.914,10.74 32.37,11.598 33.15,13.288 L33.15,11 L35.386,11 L35.386,24 L33.15,24 Z M25.792,17.5 C25.792,20.62 27.04,22.18 29.354,22.18 C31.356,22.18 33.15,20.906 33.15,18.02 L33.15,16.98 C33.15,14.094 31.512,12.82 29.614,12.82 C27.092,12.82 25.792,14.484 25.792,17.5 Z M41.86,19.892 L41.86,13.08 L45.318,13.08 L45.318,11 L41.86,11 L41.86,8.244 L39.676,8.244 L39.676,11 L37.57,11 L37.57,13.08 L39.676,13.08 L39.676,19.944 C39.676,22.362 41.028,24 43.81,24 C44.486,24 44.928,23.896 45.318,23.792 L45.318,21.634 C44.928,21.712 44.434,21.816 43.914,21.816 C42.536,21.816 41.86,21.036 41.86,19.892 Z M47.918,18.618 C47.918,22.206 49.634,24.26 52.624,24.26 C54.366,24.26 55.9,23.402 56.732,21.868 L56.732,24 L58.968,24 L58.968,11 L56.732,11 L56.732,18.228 C56.732,20.854 55.302,22.232 53.222,22.232 C51.09,22.232 50.154,21.192 50.154,18.852 L50.154,11 L47.918,11 L47.918,18.618 Z M71.318,20.464 C71.318,18.202 69.862,17.136 66.976,16.434 C64.584,15.862 63.96,15.29 63.96,14.38 C63.96,13.366 64.844,12.794 66.482,12.794 C67.86,12.794 69.134,13.21 70.694,13.99 L70.694,11.676 C69.732,11.156 68.198,10.74 66.508,10.74 C63.544,10.74 61.802,12.118 61.802,14.38 C61.802,16.512 63.024,17.63 65.91,18.332 C68.38,18.93 69.134,19.502 69.134,20.49 C69.134,21.504 68.25,22.206 66.534,22.206 C64.896,22.206 63.024,21.582 61.906,20.932 L61.906,23.298 C62.894,23.818 64.48,24.26 66.43,24.26 C69.914,24.26 71.318,22.622 71.318,20.464 Z M80.262,24.26 C78.364,24.26 76.908,23.402 76.128,21.712 L76.128,29.07 L73.892,29.07 L73.892,11 L76.128,11 L76.128,13.34 C76.96,11.624 78.52,10.74 80.522,10.74 C83.98,10.74 85.722,13.678 85.722,17.5 C85.722,21.166 83.902,24.26 80.262,24.26 Z M83.486,17.5 C83.486,14.38 82.238,12.82 79.924,12.82 C77.922,12.82 76.128,14.094 76.128,16.98 L76.128,18.02 C76.128,20.906 77.766,22.18 79.664,22.18 C82.186,22.18 83.486,20.516 83.486,17.5 Z M97.136,24 L97.136,21.66 C96.304,23.376 94.744,24.26 92.742,24.26 C89.284,24.26 87.542,21.322 87.542,17.5 C87.542,13.834 89.362,10.74 93.002,10.74 C94.9,10.74 96.356,11.598 97.136,13.288 L97.136,11 L99.372,11 L99.372,24 L97.136,24 Z M89.778,17.5 C89.778,20.62 91.026,22.18 93.34,22.18 C95.342,22.18 97.136,20.906 97.136,18.02 L97.136,16.98 C97.136,14.094 95.498,12.82 93.6,12.82 C91.078,12.82 89.778,14.484 89.778,17.5 Z M111.514,22.96 L111.514,21.66 C110.682,23.376 109.122,24.26 107.12,24.26 C103.688,24.26 101.972,21.322 101.972,17.5 C101.972,13.834 103.766,10.74 107.38,10.74 C109.278,10.74 110.734,11.598 111.514,13.288 L111.514,11 L113.698,11 L113.698,22.83 C113.698,26.652 111.904,29.226 107.25,29.226 C105.066,29.226 103.87,28.94 102.622,28.524 L102.622,26.34 C104.052,26.808 105.534,27.12 107.146,27.12 C110.396,27.12 111.514,25.378 111.514,22.96 Z M104.156,17.5 C104.156,20.62 105.404,22.18 107.718,22.18 C109.72,22.18 111.514,20.906 111.514,18.02 L111.514,16.98 C111.514,14.094 109.876,12.82 107.978,12.82 C105.456,12.82 104.156,14.484 104.156,17.5 Z M127.322,23.48 C126.256,24.052 124.618,24.26 123.292,24.26 C118.43,24.26 116.298,21.452 116.298,17.474 C116.298,13.548 118.482,10.74 122.434,10.74 C126.438,10.74 128.05,13.522 128.05,17.474 L128.05,18.488 L118.56,18.488 C118.872,20.698 120.302,22.128 123.37,22.128 C124.878,22.128 126.152,21.842 127.322,21.426 L127.322,23.48 Z M122.33,12.768 C119.964,12.768 118.768,14.302 118.534,16.564 L125.788,16.564 C125.658,14.146 124.566,12.768 122.33,12.768 Z\"></path>\n  </g>\n</svg>";

var StatuspageWordmark =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(StatuspageWordmark, _Component);

  function StatuspageWordmark() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, StatuspageWordmark);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(StatuspageWordmark).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(StatuspageWordmark, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return StatuspageWordmark;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(StatuspageWordmark, "defaultProps", __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logo__ = __webpack_require__(2574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(2575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Wordmark__ = __webpack_require__(2576);
/* unused harmony reexport StrideLogo */
/* unused harmony reexport StrideIcon */
/* unused harmony reexport StrideWordmark */





/***/ }),
/* 2574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */





var svg = function svg(iconGradientStart, iconGradientStop) {
  var id = __WEBPACK_IMPORTED_MODULE_8_uuid___default()();
  return "<canvas height=\"32\" width=\"97\" aria-hidden=\"true\"></canvas>\n  <svg viewBox=\"0 0 97 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"76.0077856%\" y1=\"30.8164837%\" x2=\"3.20549956%\" y2=\"70.7051948%\" id=\"".concat(id, "\">\n        <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"18%\"></stop>\n        <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path d=\"M44.1672398,19.2931423 C44.1672398,16.225334 42.1393665,15.0554071 38.5255923,14.145464 C35.5097807,13.3915111 34.4178489,12.6895549 34.4178489,11.2856426 C34.4178489,9.7257401 35.7437661,8.94578883 37.9796264,8.94578883 C39.7475159,8.94578883 41.5934006,9.25776934 43.3092934,10.2457076 L43.3092934,7.90585381 C42.1393665,7.25589442 40.5534656,6.65793178 38.0836199,6.65793178 C34.1058684,6.65793178 32.0779951,8.63380832 32.0779951,11.2856426 C32.0779951,14.0934672 33.7938879,15.4193844 37.6416475,16.3553259 C40.8914445,17.1352772 41.827386,17.9412268 41.827386,19.4491326 C41.827386,20.9570384 40.8654461,21.970975 38.2916069,21.970975 C36.0297482,21.970975 33.5859009,21.3730124 32,20.5410644 L32,22.9329149 C33.3259172,23.6088727 34.8598213,24.2588321 38.161615,24.2588321 C42.3993503,24.2588321 44.1672398,22.2569572 44.1672398,19.2931423 Z M50.0168743,19.891105 L50.0168743,13.0795306 L53.4746583,13.0795306 L53.4746583,10.9996605 L50.0168743,10.9996605 L50.0168743,8.24383269 L47.8330108,8.24383269 L47.8330108,10.9996605 L45.7271423,10.9996605 L45.7271423,13.0795306 L47.8330108,13.0795306 L47.8330108,19.9431017 C47.8330108,22.3609507 49.1849263,23.9988483 51.9667525,23.9988483 C52.6427103,23.9988483 53.0846826,23.8948548 53.4746583,23.7908613 L53.4746583,21.6329961 C53.0846826,21.7109913 52.5907135,21.8149848 52.070746,21.8149848 C50.6928321,21.8149848 50.0168743,21.0350335 50.0168743,19.891105 Z M56.3344796,23.9988483 L58.5183431,23.9988483 L58.5183431,16.3293275 C58.5183431,13.5734997 60.2602343,12.7155533 63.1200556,13.0015354 L63.1200556,10.8176719 C60.5722148,10.6616816 59.272296,11.7536134 58.5183431,13.2875176 L58.5183431,10.9996605 L56.3344796,10.9996605 L56.3344796,23.9988483 Z M64.6279614,7.56787492 C64.6279614,8.5558132 65.2779208,9.12777746 66.187864,9.12777746 C67.0978071,9.12777746 67.7477665,8.5558132 67.7477665,7.56787492 C67.7477665,6.57993665 67.0978071,6.00797239 66.187864,6.00797239 C65.2779208,6.00797239 64.6279614,6.57993665 64.6279614,7.56787492 Z M65.0439354,23.9988483 L67.2797957,23.9988483 L67.2797957,10.9996605 L65.0439354,10.9996605 L65.0439354,23.9988483 Z M79.4730339,23.9988483 L79.4730339,21.6589945 C78.6410859,23.3748873 77.0811833,24.2588321 75.0793084,24.2588321 C71.6215245,24.2588321 69.8796333,21.3210156 69.8796333,17.4992544 C69.8796333,13.8334835 71.6995196,10.7396768 75.3392922,10.7396768 C77.2371736,10.7396768 78.6930826,11.5976231 79.4730339,13.2875176 L79.4730339,5.566 L81.7088942,5.566 L81.7088942,23.9988483 L79.4730339,23.9988483 Z M72.1154936,17.4992544 C72.1154936,20.6190595 73.3634156,22.178962 75.6772711,22.178962 C77.679146,22.178962 79.4730339,20.9050416 79.4730339,18.0192219 L79.4730339,16.9792869 C79.4730339,14.0934672 77.8351362,12.8195468 75.9372548,12.8195468 C73.4154124,12.8195468 72.1154936,14.4834428 72.1154936,17.4992544 Z M95.332043,23.4788808 C94.2661096,24.0508451 92.628212,24.2588321 91.3022948,24.2588321 C86.4405986,24.2588321 84.3087318,21.4510075 84.3087318,17.473256 C84.3087318,13.5475013 86.4925953,10.7396768 90.4443484,10.7396768 C94.4480983,10.7396768 96.0599976,13.5215029 96.0599976,17.473256 L96.0599976,18.4871927 L86.5705905,18.4871927 C86.882571,20.6970546 88.3124816,22.1269653 91.3802899,22.1269653 C92.8881957,22.1269653 94.1621161,21.8409831 95.332043,21.4250091 L95.332043,23.4788808 Z M90.3403549,12.7675501 C87.9745027,12.7675501 86.7785775,14.3014542 86.5445921,16.5633129 L93.7981389,16.5633129 C93.668147,14.145464 92.5762152,12.7675501 90.3403549,12.7675501 Z\" fill=\"inherit\" fill-rule=\"evenodd\"></path>\n      <path d=\"M6.66434783,6 L6.66434783,10.0267857 C6.66434783,15.6020536 4.00695652,17.7545536 0.626086957,18.0803571 C0.269286057,18.1180932 -0.00179704222,18.4350964 -1.9308116e-16,18.8125 C-1.9308116e-16,20.3133929 -1.9308116e-16,23.860625 -1.9308116e-16,25.4017857 C-0.000289607564,25.6031446 0.0782306046,25.7957406 0.217087594,25.9342627 C0.355944583,26.0727847 0.542879466,26.1450036 0.733913043,26.1339286 C9.2,25.68 14.2991304,19.1785714 14.2991304,11.1066964 L14.3234783,11.1066964 L14.3234783,6 L6.66434783,6 Z\" fill=\"url(#").concat(id, ")\"></path>\n      <path d=\"M23.6521739,25.0759821 L14.6886957,6 L6.66434783,6 L16.1321739,25.5372321 C16.3109114,25.9036978 16.6694737,26.1340777 17.0608696,26.1339286 L23.0365217,26.1339286 C23.2760081,26.1312811 23.49736,25.9991651 23.6224471,25.7842135 C23.7475342,25.5692619 23.7587644,25.301705 23.6521739,25.0759821 Z\" fill=\"currentColor\"></path>\n    </g>\n  </svg>");
};

var StrideLogo =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(StrideLogo, _Component);

  function StrideLogo() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, StrideLogo);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(StrideLogo).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(StrideLogo, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return StrideLogo;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(StrideLogo, "defaultProps", __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */





var svg = function svg(iconGradientStart, iconGradientStop) {
  var id = __WEBPACK_IMPORTED_MODULE_8_uuid___default()();
  return "<canvas height=\"32\" width=\"32\" aria-hidden=\"true\"></canvas>\n  <svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n        <linearGradient x1=\"62.272%\" x2=\"15.737%\" y1=\"26.041%\" y2=\"68.741%\" id=\"".concat(id, "\">\n            <stop stop-color=\"").concat(iconGradientStart, "\" ").concat(iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"18%\"></stop>\n            <stop stop-color=\"").concat(iconGradientStop, "\" offset=\"100%\"></stop>\n        </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"nonzero\">\n      <path fill-rule=\"nonzero\" d=\"M10.6584152,4 L10.6584152,8.39679183 C10.6584152,14.48435 7.60464338,16.8346351 3.71947823,17.1903755 C3.30945638,17.231579 2.99793812,17.5777104 3.00000321,17.9897922 C3.00000321,19.6285964 3.00000321,23.5017703 3.00000321,25.1845425 C2.9996704,25.4044035 3.08990281,25.6146964 3.24947191,25.7659467 C3.40904102,25.9171971 3.62385939,25.9960518 3.84338782,25.9839592 C13.572289,25.4883208 19.4320134,18.3895005 19.4320134,9.57593146 L19.459993,9.57593146 L19.459993,4 L10.6584152,4 Z\" fill=\"url(#").concat(id, ")\"></path>\n      <path fill-rule=\"nonzero\" d=\"M30.1816696,24.829953 L19.8806163,4 L10.6588351,4 L21.5394976,25.3336133 C21.7449071,25.7337742 22.1569759,25.9853368 22.6067778,25.9851739 L29.4741467,25.9851739 C29.7493704,25.982283 30.0037535,25.8380195 30.1475068,25.6033038 C30.29126,25.3685881 30.304166,25.0764302 30.1816696,24.829953 Z\" fill=\"currentColor\"></path>\n    </g>\n  </svg>");
};

var StrideIcon =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(StrideIcon, _Component);

  function StrideIcon() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, StrideIcon);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(StrideIcon).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(StrideIcon, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return StrideIcon;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(StrideIcon, "defaultProps", __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Wrapper__ = __webpack_require__(30);








/* eslint-disable max-len */



var svg = "<canvas height=\"32\" width=\"65\" aria-hidden=\"true\"></canvas>\n<svg viewBox=\"0 0 65 32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n  <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\" fill=\"inherit\">\n    <path d=\"M12.1672398,19.2931423 C12.1672398,16.225334 10.1393665,15.0554071 6.52559228,14.145464 C3.50978071,13.3915111 2.41784893,12.6895549 2.41784893,11.2856426 C2.41784893,9.7257401 3.74376609,8.94578883 5.9796264,8.94578883 C7.74751594,8.94578883 9.59340061,9.25776934 11.3092934,10.2457076 L11.3092934,7.90585381 C10.1393665,7.25589442 8.55346558,6.65793178 6.0836199,6.65793178 C2.10586843,6.65793178 0.0779951269,8.63380832 0.0779951269,11.2856426 C0.0779951269,14.0934672 1.79388792,15.4193844 5.64164751,16.3553259 C8.89144447,17.1352772 9.82738599,17.9412268 9.82738599,19.4491326 C9.82738599,20.9570384 8.86544609,21.970975 6.2916069,21.970975 C4.02974822,21.970975 1.58590091,21.3730124 1.55431223e-14,20.5410644 L1.55431223e-14,22.9329149 C1.32591716,23.6088727 2.85982132,24.2588321 6.16161502,24.2588321 C10.3993503,24.2588321 12.1672398,22.2569572 12.1672398,19.2931423 Z M18.0168743,19.891105 L18.0168743,13.0795306 L21.4746583,13.0795306 L21.4746583,10.9996605 L18.0168743,10.9996605 L18.0168743,8.24383269 L15.8330108,8.24383269 L15.8330108,10.9996605 L13.7271423,10.9996605 L13.7271423,13.0795306 L15.8330108,13.0795306 L15.8330108,19.9431017 C15.8330108,22.3609507 17.1849263,23.9988483 19.9667525,23.9988483 C20.6427103,23.9988483 21.0846826,23.8948548 21.4746583,23.7908613 L21.4746583,21.6329961 C21.0846826,21.7109913 20.5907135,21.8149848 20.070746,21.8149848 C18.6928321,21.8149848 18.0168743,21.0350335 18.0168743,19.891105 Z M24.3344796,23.9988483 L26.5183431,23.9988483 L26.5183431,16.3293275 C26.5183431,13.5734997 28.2602343,12.7155533 31.1200556,13.0015354 L31.1200556,10.8176719 C28.5722148,10.6616816 27.272296,11.7536134 26.5183431,13.2875176 L26.5183431,10.9996605 L24.3344796,10.9996605 L24.3344796,23.9988483 Z M32.6279614,7.56787492 C32.6279614,8.5558132 33.2779208,9.12777746 34.187864,9.12777746 C35.0978071,9.12777746 35.7477665,8.5558132 35.7477665,7.56787492 C35.7477665,6.57993665 35.0978071,6.00797239 34.187864,6.00797239 C33.2779208,6.00797239 32.6279614,6.57993665 32.6279614,7.56787492 Z M33.0439354,23.9988483 L35.2797957,23.9988483 L35.2797957,10.9996605 L33.0439354,10.9996605 L33.0439354,23.9988483 Z M47.4730339,23.9988483 L47.4730339,21.6589945 C46.6410859,23.3748873 45.0811833,24.2588321 43.0793084,24.2588321 C39.6215245,24.2588321 37.8796333,21.3210156 37.8796333,17.4992544 C37.8796333,13.8334835 39.6995196,10.7396768 43.3392922,10.7396768 C45.2371736,10.7396768 46.6930826,11.5976231 47.4730339,13.2875176 L47.4730339,5.566 L49.7088942,5.566 L49.7088942,23.9988483 L47.4730339,23.9988483 Z M40.1154936,17.4992544 C40.1154936,20.6190595 41.3634156,22.178962 43.6772711,22.178962 C45.679146,22.178962 47.4730339,20.9050416 47.4730339,18.0192219 L47.4730339,16.9792869 C47.4730339,14.0934672 45.8351362,12.8195468 43.9372548,12.8195468 C41.4154124,12.8195468 40.1154936,14.4834428 40.1154936,17.4992544 Z M63.332043,23.4788808 C62.2661096,24.0508451 60.628212,24.2588321 59.3022948,24.2588321 C54.4405986,24.2588321 52.3087318,21.4510075 52.3087318,17.473256 C52.3087318,13.5475013 54.4925953,10.7396768 58.4443484,10.7396768 C62.4480983,10.7396768 64.0599976,13.5215029 64.0599976,17.473256 L64.0599976,18.4871927 L54.5705905,18.4871927 C54.882571,20.6970546 56.3124816,22.1269653 59.3802899,22.1269653 C60.8881957,22.1269653 62.1621161,21.8409831 63.332043,21.4250091 L63.332043,23.4788808 Z M58.3403549,12.7675501 C55.9745027,12.7675501 54.7785775,14.3014542 54.5445921,16.5633129 L61.7981389,16.5633129 C61.668147,14.145464 60.5762152,12.7675501 58.3403549,12.7675501 Z\"></path>\n  </g>\n</svg>";

var StrideWordmark =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(StrideWordmark, _Component);

  function StrideWordmark() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, StrideWordmark);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(StrideWordmark).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(StrideWordmark, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        svg: svg
      }));
    }
  }]);

  return StrideWordmark;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(StrideWordmark, "defaultProps", __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* DefaultProps */]);



/***/ }),
/* 2577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_Toolbar__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_ToolbarLists__ = __webpack_require__(2578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pm_plugins_input_rule__ = __webpack_require__(2579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pm_plugins_keymap__ = __webpack_require__(2580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_bullet_list__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_bullet_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_bullet_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_editor_number_list__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_editor_number_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_editor_number_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__insert_block_ui_ToolbarInsertBlock__ = __webpack_require__(81);











var listPlugin = {
    nodes: function () {
        return [
            { name: 'bulletList', node: __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["j" /* bulletList */] },
            { name: 'orderedList', node: __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["Y" /* orderedList */] },
            { name: 'listItem', node: __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["Q" /* listItem */] },
        ];
    },
    pmPlugins: function () {
        return [
            { name: 'lists', plugin: function (_a) {
                    var dispatch = _a.dispatch;
                    return Object(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["a" /* createPlugin */])(dispatch);
                } },
            {
                name: 'listsInputRule',
                plugin: function (_a) {
                    var schema = _a.schema;
                    return Object(__WEBPACK_IMPORTED_MODULE_5__pm_plugins_input_rule__["a" /* default */])(schema);
                },
            },
            { name: 'listsKeymap', plugin: function (_a) {
                    var schema = _a.schema;
                    return Object(__WEBPACK_IMPORTED_MODULE_6__pm_plugins_keymap__["a" /* default */])(schema);
                } },
        ];
    },
    pluginsOptions: {
        quickInsert: function (_a) {
            var formatMessage = _a.formatMessage;
            return [
                {
                    title: formatMessage(__WEBPACK_IMPORTED_MODULE_10__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].bulletList),
                    keywords: ['ul', 'unordered list'],
                    priority: 1100,
                    icon: function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_bullet_list___default.a, { label: formatMessage(__WEBPACK_IMPORTED_MODULE_10__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].bulletList) })); },
                    action: function (insert, state) {
                        return insert(state.schema.nodes.bulletList.createChecked({}, state.schema.nodes.listItem.createChecked({}, state.schema.nodes.paragraph.createChecked())));
                    },
                },
                {
                    title: formatMessage(__WEBPACK_IMPORTED_MODULE_10__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].orderedList),
                    keywords: ['ol', 'ordered list', 'numbered list'],
                    priority: 1200,
                    icon: function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_editor_number_list___default.a, { label: formatMessage(__WEBPACK_IMPORTED_MODULE_10__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].orderedList) })); },
                    action: function (insert, state) {
                        return insert(state.schema.nodes.orderedList.createChecked({}, state.schema.nodes.listItem.createChecked({}, state.schema.nodes.paragraph.createChecked())));
                    },
                },
            ];
        },
    },
    primaryToolbarComponent: function (_a) {
        var editorView = _a.editorView, appearance = _a.appearance, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, popupsScrollableElement = _a.popupsScrollableElement, toolbarSize = _a.toolbarSize, disabled = _a.disabled, isToolbarReducedSpacing = _a.isToolbarReducedSpacing;
        var isSmall = toolbarSize < __WEBPACK_IMPORTED_MODULE_2__ui_Toolbar__["a" /* ToolbarSize */].L;
        var isSeparator = toolbarSize >= __WEBPACK_IMPORTED_MODULE_2__ui_Toolbar__["a" /* ToolbarSize */].S;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ui_WithPluginState__["a" /* default */], { plugins: { listsState: __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["b" /* pluginKey */] }, render: function (_a) {
                var listsState = _a.listsState;
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ui_ToolbarLists__["a" /* default */], { isSmall: isSmall, isSeparator: isSeparator, isReducedSpacing: isToolbarReducedSpacing, disabled: disabled, editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, bulletListActive: listsState.bulletListActive, bulletListDisabled: listsState.bulletListDisabled, orderedListActive: listsState.orderedListActive, orderedListDisabled: listsState.orderedListDisabled }));
            } }));
    },
};
/* harmony default export */ __webpack_exports__["a"] = (listPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_bullet_list__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_bullet_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_bullet_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_number_list__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_number_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_number_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_chevron_down__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_chevron_down___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_chevron_down__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__keymaps__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_ToolbarButton__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_DropdownMenu__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_styles__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commands__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__messages__ = __webpack_require__(1396);














var ToolbarLists = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ToolbarLists, _super);
    function ToolbarLists() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isDropdownOpen: false,
        };
        _this.onOpenChange = function (attrs) {
            _this.setState({
                isDropdownOpen: attrs.isDropdownOpen,
            });
        };
        _this.handleTriggerClick = function () {
            _this.onOpenChange({ isDropdownOpen: !_this.state.isDropdownOpen });
        };
        _this.createItems = function () {
            var _a = _this.props, bulletListDisabled = _a.bulletListDisabled, orderedListDisabled = _a.orderedListDisabled, bulletListActive = _a.bulletListActive, orderedListActive = _a.orderedListActive, formatMessage = _a.intl.formatMessage;
            var labelUnorderedList = formatMessage(__WEBPACK_IMPORTED_MODULE_12__messages__["a" /* messages */].unorderedList);
            var labelOrderedList = formatMessage(__WEBPACK_IMPORTED_MODULE_12__messages__["a" /* messages */].orderedList);
            var items = [
                {
                    content: labelUnorderedList,
                    value: { name: 'bullet_list' },
                    isDisabled: bulletListDisabled,
                    isActive: Boolean(bulletListActive),
                    elemAfter: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ui_styles__["f" /* Shortcut */], null, Object(__WEBPACK_IMPORTED_MODULE_7__keymaps__["S" /* tooltip */])(__WEBPACK_IMPORTED_MODULE_7__keymaps__["L" /* toggleBulletList */])),
                },
                {
                    content: labelOrderedList,
                    value: { name: 'ordered_list' },
                    isDisabled: orderedListDisabled,
                    isActive: Boolean(orderedListActive),
                    elemAfter: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ui_styles__["f" /* Shortcut */], null, Object(__WEBPACK_IMPORTED_MODULE_7__keymaps__["S" /* tooltip */])(__WEBPACK_IMPORTED_MODULE_7__keymaps__["O" /* toggleOrderedList */])),
                },
            ];
            return [{ items: items }];
        };
        _this.handleBulletListClick = Object(__WEBPACK_IMPORTED_MODULE_6__analytics__["c" /* withAnalytics */])('atlassian.editor.format.list.bullet.button', function () {
            if (!_this.props.bulletListDisabled) {
                return Object(__WEBPACK_IMPORTED_MODULE_11__commands__["e" /* toggleBulletList */])(_this.props.editorView);
            }
            return false;
        });
        _this.handleOrderedListClick = Object(__WEBPACK_IMPORTED_MODULE_6__analytics__["c" /* withAnalytics */])('atlassian.editor.format.list.numbered.button', function () {
            if (!_this.props.orderedListDisabled) {
                return Object(__WEBPACK_IMPORTED_MODULE_11__commands__["g" /* toggleOrderedList */])(_this.props.editorView);
            }
            return false;
        });
        _this.onItemActivated = function (_a) {
            var item = _a.item;
            _this.setState({ isDropdownOpen: false });
            switch (item.value.name) {
                case 'bullet_list':
                    _this.handleBulletListClick();
                    break;
                case 'ordered_list':
                    _this.handleOrderedListClick();
                    break;
            }
        };
        return _this;
    }
    ToolbarLists.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, isSmall = _a.isSmall, isReducedSpacing = _a.isReducedSpacing, isSeparator = _a.isSeparator, bulletListActive = _a.bulletListActive, bulletListDisabled = _a.bulletListDisabled, orderedListActive = _a.orderedListActive, orderedListDisabled = _a.orderedListDisabled, formatMessage = _a.intl.formatMessage;
        var isDropdownOpen = this.state.isDropdownOpen;
        if (!isSmall) {
            var labelUnorderedList = formatMessage(__WEBPACK_IMPORTED_MODULE_12__messages__["a" /* messages */].unorderedList);
            var labelOrderedList = formatMessage(__WEBPACK_IMPORTED_MODULE_12__messages__["a" /* messages */].orderedList);
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ui_styles__["b" /* ButtonGroup */], { width: isReducedSpacing ? 'small' : 'large' },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ui_ToolbarButton__["a" /* default */], { spacing: isReducedSpacing ? 'none' : 'default', onClick: this.handleBulletListClick, selected: bulletListActive, disabled: bulletListDisabled || disabled, title: Object(__WEBPACK_IMPORTED_MODULE_7__keymaps__["S" /* tooltip */])(__WEBPACK_IMPORTED_MODULE_7__keymaps__["L" /* toggleBulletList */], labelUnorderedList), iconBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_bullet_list___default.a, { label: labelUnorderedList }) }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ui_ToolbarButton__["a" /* default */], { spacing: isReducedSpacing ? 'none' : 'default', onClick: this.handleOrderedListClick, selected: orderedListActive, disabled: orderedListDisabled || disabled, title: Object(__WEBPACK_IMPORTED_MODULE_7__keymaps__["S" /* tooltip */])(__WEBPACK_IMPORTED_MODULE_7__keymaps__["O" /* toggleOrderedList */], labelOrderedList), iconBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_number_list___default.a, { label: labelOrderedList }) }),
                isSeparator && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ui_styles__["e" /* Separator */], null)));
        }
        else {
            var items = this.createItems();
            var _b = this.props, popupsMountPoint = _b.popupsMountPoint, popupsBoundariesElement = _b.popupsBoundariesElement, popupsScrollableElement = _b.popupsScrollableElement;
            var labelLists = formatMessage(__WEBPACK_IMPORTED_MODULE_12__messages__["a" /* messages */].lists);
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ui_styles__["h" /* Wrapper */], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ui_DropdownMenu__["a" /* default */], { items: items, onItemActivated: this.onItemActivated, mountTo: popupsMountPoint, boundariesElement: popupsBoundariesElement, scrollableElement: popupsScrollableElement, isOpen: isDropdownOpen, onOpenChange: this.onOpenChange, fitHeight: 188, fitWidth: 175 },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ui_ToolbarButton__["a" /* default */], { spacing: isReducedSpacing ? 'none' : 'default', selected: bulletListActive || orderedListActive, disabled: disabled, onClick: this.handleTriggerClick, title: labelLists, iconBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ui_styles__["h" /* Wrapper */], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_bullet_list___default.a, { label: labelLists }),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ui_styles__["c" /* ExpandIconWrapper */], null,
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_chevron_down___default.a, { label: labelLists }))) })),
                isSeparator && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ui_styles__["e" /* Separator */], null)));
        }
    };
    return ToolbarLists;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["injectIntl"])(ToolbarLists));
//# sourceMappingURL=index.js.map

/***/ }),
/* 2579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createInputRule */
/* unused harmony export insertList */
/* harmony export (immutable) */ __webpack_exports__["a"] = inputRulePlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_input_rules__ = __webpack_require__(92);



function createInputRule(regexp, nodeType) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["wrappingInputRule"])(regexp, nodeType, {}, function (_, node) { return node.type === nodeType; });
}
var insertList = function (state, listType, listTypeName, start, end, matchSize) {
    // To ensure that match is done after HardBreak.
    var hardBreak = state.schema.nodes.hardBreak;
    if (state.doc.resolve(start).nodeAfter.type !== hardBreak) {
        return null;
    }
    // To ensure no nesting is done.
    if (state.doc.resolve(start).depth > 1) {
        return null;
    }
    // Track event
    __WEBPACK_IMPORTED_MODULE_1__analytics__["a" /* analyticsService */].trackEvent("atlassian.editor.format.list." + listTypeName + ".autoformatting");
    // Split at the start of autoformatting and delete formatting characters.
    var tr = state.tr.delete(start, end).split(start);
    // If node has more content split at the end of autoformatting.
    var currentNode = tr.doc.nodeAt(start + 1);
    tr.doc.nodesBetween(start, start + currentNode.nodeSize, function (node, pos) {
        if (node.type === hardBreak) {
            tr = tr.split(pos + 1).delete(pos, pos + 1);
        }
    });
    // Wrap content in list node
    var listItem = state.schema.nodes.listItem;
    var position = tr.doc.resolve(start + 2);
    var range = position.blockRange(position);
    tr = tr.wrap(range, [{ type: listType }, { type: listItem }]);
    return tr;
};
function inputRulePlugin(schema) {
    var rules = [];
    if (schema.nodes.bulletList) {
        // NOTE: we decided to restrict the creation of bullet lists to only "*"x
        var rule = Object(__WEBPACK_IMPORTED_MODULE_2__utils_input_rules__["b" /* defaultInputRuleHandler */])(createInputRule(/^\s*([\*\-]) $/, schema.nodes.bulletList), true);
        rule.handler = Object(__WEBPACK_IMPORTED_MODULE_1__analytics__["b" /* trackAndInvoke */])('atlassian.editor.format.list.bullet.autoformatting', rule.handler);
        rules.push(rule);
        rules.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils_input_rules__["a" /* createInputRule */])(new RegExp(__WEBPACK_IMPORTED_MODULE_2__utils_input_rules__["c" /* leafNodeReplacementCharacter */] + "\\s*([\\*\\-]) $"), function (state, match, start, end) {
            return insertList(state, schema.nodes.bulletList, 'bullet', start, end, 1);
        }, true));
    }
    if (schema.nodes.orderedList) {
        // NOTE: There is a built in input rule for ordered lists in ProseMirror. However, that
        // input rule will allow for a list to start at any given number, which isn't allowed in
        // markdown (where a ordered list will always start on 1). This is a slightly modified
        // version of that input rule.
        var rule = Object(__WEBPACK_IMPORTED_MODULE_2__utils_input_rules__["b" /* defaultInputRuleHandler */])(createInputRule(/^(1)[\.\)] $/, schema.nodes.orderedList), true);
        rule.handler = Object(__WEBPACK_IMPORTED_MODULE_1__analytics__["b" /* trackAndInvoke */])('atlassian.editor.format.list.numbered.autoformatting', rule.handler);
        rules.push(rule);
        rules.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils_input_rules__["a" /* createInputRule */])(new RegExp(__WEBPACK_IMPORTED_MODULE_2__utils_input_rules__["c" /* leafNodeReplacementCharacter */] + "(1)[\\.\\)] $"), function (state, match, start, end) {
            return insertList(state, schema.nodes.orderedList, 'numbered', start, end, 2);
        }, true));
    }
    if (rules.length !== 0) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["inputRules"])({ rules: rules });
    }
}
//# sourceMappingURL=input-rule.js.map

/***/ }),
/* 2580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export keymapPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keymaps__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands__ = __webpack_require__(287);




function keymapPlugin(schema) {
    var list = {};
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["p" /* findShortcutByKeymap */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["O" /* toggleOrderedList */]), Object(__WEBPACK_IMPORTED_MODULE_2__analytics__["b" /* trackAndInvoke */])('atlassian.editor.format.list.numbered.keyboard', Object(__WEBPACK_IMPORTED_MODULE_3__commands__["f" /* toggleListCommand */])('orderedList')), list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["p" /* findShortcutByKeymap */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["L" /* toggleBulletList */]), Object(__WEBPACK_IMPORTED_MODULE_2__analytics__["b" /* trackAndInvoke */])('atlassian.editor.format.list.bullet.keyboard', Object(__WEBPACK_IMPORTED_MODULE_3__commands__["f" /* toggleListCommand */])('bulletList')), list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["r" /* indentList */].common, Object(__WEBPACK_IMPORTED_MODULE_2__analytics__["b" /* trackAndInvoke */])('atlassian.editor.format.list.indent.keyboard', Object(__WEBPACK_IMPORTED_MODULE_3__commands__["c" /* indentList */])()), list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["B" /* outdentList */].common, Object(__WEBPACK_IMPORTED_MODULE_2__analytics__["b" /* trackAndInvoke */])('atlassian.editor.format.list.outdent.keyboard', Object(__WEBPACK_IMPORTED_MODULE_3__commands__["d" /* outdentList */])()), list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["k" /* enter */].common, __WEBPACK_IMPORTED_MODULE_3__commands__["b" /* enterKeyCommand */], list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["g" /* backspace */].common, __WEBPACK_IMPORTED_MODULE_3__commands__["a" /* backspaceKeyCommand */], list);
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__["keymap"])(list);
}
/* harmony default export */ __webpack_exports__["a"] = (keymapPlugin);
//# sourceMappingURL=keymap.js.map

/***/ }),
/* 2581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export keymapPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keymaps__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(21);



/**
 * When there's any empty block before another paragraph with wrap-right
 * mediaSingle. Pressing backspace at the start of the paragraph will select
 * the media but visually it makes more sense to remove the empty paragraph.
 *
 * Structure of the document: doc(block(), mediaSingle(media()), paragraph('{<>}hello!'))
 * But, visually it looks like the following:
 *
 * [empty block] <- Remove this block
 * [Cursor] x x x x x x x x  +---------------+
 * x x x x x x x x x x       |  mediaSingle  |
 * x x x x x.                +---------------+
 */
var maybeRemoveMediaSingleNode = function (schema) {
    var isEmptyNodeInSchema = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["u" /* isEmptyNode */])(schema);
    return function (state, dispatch) {
        var selection = state.selection;
        // Check if we have a structure like
        // anyBlock[empty] > mediaSingle[wrap-right] > [selection{empty, at start}]
        if (!selection.empty) {
            return false;
        }
        var $from = selection.$from;
        var doc = state.doc;
        var index = $from.index($from.depth - 1);
        if ($from.parentOffset > 0) {
            return false;
        }
        var maybeMediaSingle = doc.maybeChild(index - 1);
        if (!maybeMediaSingle ||
            maybeMediaSingle.type !== schema.nodes.mediaSingle ||
            maybeMediaSingle.attrs.layout !== 'wrap-right') {
            return false;
        }
        var maybeAnyBlock = doc.maybeChild(index - 2);
        if (!maybeAnyBlock || !isEmptyNodeInSchema(maybeAnyBlock)) {
            return false;
        }
        var tr = state.tr.replace(index - 2, maybeAnyBlock.nodeSize);
        if (dispatch) {
            dispatch(tr);
        }
        return true;
    };
};
function keymapPlugin(schema) {
    var list = {};
    var removeMediaSingleCommand = maybeRemoveMediaSingleNode(schema);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["g" /* backspace */].common, removeMediaSingleCommand, list);
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__["keymap"])(list);
}
/* harmony default export */ __webpack_exports__["a"] = (keymapPlugin);
//# sourceMappingURL=keymap-media-single.js.map

/***/ }),
/* 2582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export keymapPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keymaps__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__ = __webpack_require__(100);



function keymapPlugin() {
    var list = {};
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["g" /* backspace */].common, removeMediaNode, list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["T" /* undo */].common, ignoreLinksInSteps, list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["k" /* enter */].common, splitMediaGroup, list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["s" /* insertNewLine */].common, splitMediaGroup, list);
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__["keymap"])(list);
}
var removeMediaNode = function (state) {
    var mediaPluginState = __WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["b" /* stateKey */].getState(state);
    return mediaPluginState.removeSelectedMediaNode();
};
var ignoreLinksInSteps = function (state) {
    var mediaPluginState = __WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["b" /* stateKey */].getState(state);
    mediaPluginState.ignoreLinks = true;
    return false;
};
var splitMediaGroup = function (state) {
    var mediaPluginState = __WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["b" /* stateKey */].getState(state);
    return mediaPluginState.splitMediaGroup();
};
/* harmony default export */ __webpack_exports__["a"] = (keymapPlugin);
//# sourceMappingURL=keymap.js.map

/***/ }),
/* 2583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_attachment__ = __webpack_require__(2584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_attachment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_attachment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_ToolbarButton__ = __webpack_require__(40);






var ToolbarMedia = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ToolbarMedia, _super);
    function ToolbarMedia() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { disabled: false };
        _this.handlePluginStateChange = function (pluginState) {
            _this.setState({
                disabled: !pluginState.allowsUploads,
            });
        };
        _this.handleClickMediaButton = Object(__WEBPACK_IMPORTED_MODULE_3__analytics__["c" /* withAnalytics */])('atlassian.editor.media.button', function () {
            _this.pluginState.showMediaPicker();
            return true;
        });
        return _this;
    }
    ToolbarMedia.prototype.componentDidMount = function () {
        this.setPluginState(this.props);
    };
    ToolbarMedia.prototype.componentWillUpdate = function (nextProps) {
        if (!this.pluginState) {
            this.setPluginState(nextProps);
        }
    };
    ToolbarMedia.prototype.componentWillUnmount = function () {
        var pluginState = this.pluginState;
        if (pluginState) {
            pluginState.unsubscribe(this.handlePluginStateChange);
        }
    };
    ToolbarMedia.prototype.render = function () {
        var _a = this.props, isDisabled = _a.isDisabled, isReducedSpacing = _a.isReducedSpacing;
        var disabled = this.state.disabled;
        if (disabled) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ui_ToolbarButton__["a" /* default */], { onClick: this.handleClickMediaButton, disabled: isDisabled, title: "Files & images", spacing: isReducedSpacing ? 'none' : 'default', iconBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_attachment___default.a, { label: "Files & images" }) }));
    };
    ToolbarMedia.prototype.setPluginState = function (props) {
        var editorView = props.editorView, pluginKey = props.pluginKey;
        var pluginState = pluginKey.getState(editorView.state);
        if (pluginState) {
            this.pluginState = pluginState;
            pluginState.subscribe(this.handlePluginStateChange);
        }
    };
    return ToolbarMedia;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (ToolbarMedia);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorAttachmentIcon = function EditorAttachmentIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M17.222 11.557L12.11 16.64a3.012 3.012 0 0 1-4.238.004 2.97 2.97 0 0 1 .002-4.21L13.339 7a1.75 1.75 0 0 1 2.472-.002c.683.679.684 1.775.002 2.452l-5.126 5.095a.493.493 0 0 1-.699-.007.488.488 0 0 1 0-.701l4.764-4.735a.74.74 0 0 0 0-1.052.752.752 0 0 0-1.058 0L8.93 12.785a1.97 1.97 0 0 0 0 2.805c.781.777 2.038.78 2.816.007l5.126-5.094a3.206 3.206 0 0 0-.003-4.557 3.253 3.253 0 0 0-4.589.002l-5.466 5.433a4.451 4.451 0 0 0-.001 6.314 4.516 4.516 0 0 0 6.355-.004l5.113-5.081a.74.74 0 0 0 0-1.053.752.752 0 0 0-1.059 0z\" fill=\"currentColor\"/></svg>"
  }, props));
};

EditorAttachmentIcon.displayName = 'EditorAttachmentIcon';
var _default = EditorAttachmentIcon;
exports.default = _default;

/***/ }),
/* 2585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export messages */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_media_wrap_left__ = __webpack_require__(2586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_media_wrap_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_media_wrap_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_media_wrap_right__ = __webpack_require__(2587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_media_wrap_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_media_wrap_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_media_wide__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_media_wide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_media_wide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_media_full_width__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_media_full_width___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_media_full_width__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_remove__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_remove__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_editor_align_image_left__ = __webpack_require__(2588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_editor_align_image_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_editor_align_image_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_editor_align_image_right__ = __webpack_require__(2589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_editor_align_image_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_editor_align_image_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_icon_glyph_editor_align_image_center__ = __webpack_require__(2590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_icon_glyph_editor_align_image_center___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__atlaskit_icon_glyph_editor_align_image_center__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__messages__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ui_ToolbarButton__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ui_Separator__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ui_FloatingToolbar__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils__ = __webpack_require__(21);


















var messages = Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["defineMessages"])({
    wrapLeft: {
        id: 'fabric.editor.wrapLeft',
        defaultMessage: 'Wrap left',
        description: 'Aligns your image to the left and wraps text around it.',
    },
    wrapRight: {
        id: 'fabric.editor.wrapRight',
        defaultMessage: 'Wrap right',
        description: 'Aligns your image to the right and wraps text around it.',
    },
});
var icons = [
    { value: 'align-start', Icon: __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_editor_align_image_left___default.a },
    { value: 'center', Icon: __WEBPACK_IMPORTED_MODULE_11__atlaskit_icon_glyph_editor_align_image_center___default.a },
    { value: 'align-end', Icon: __WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_editor_align_image_right___default.a },
    { value: 'separator' },
    { value: 'wrap-left', Icon: __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_media_wrap_left___default.a },
    { value: 'wrap-right', Icon: __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_media_wrap_right___default.a },
];
var breakoutIcons = [
    { value: 'separator' },
    { value: 'wide', Icon: __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_media_wide___default.a },
    { value: 'full-width', Icon: __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_media_full_width___default.a },
];
var layoutToMessages = {
    'wrap-left': messages.wrapLeft,
    center: __WEBPACK_IMPORTED_MODULE_13__messages__["a" /* default */].alignImageCenter,
    'wrap-right': messages.wrapRight,
    wide: __WEBPACK_IMPORTED_MODULE_13__messages__["a" /* default */].layoutWide,
    'full-width': __WEBPACK_IMPORTED_MODULE_13__messages__["a" /* default */].layoutFullWidth,
    'align-end': __WEBPACK_IMPORTED_MODULE_13__messages__["a" /* default */].alignImageRight,
    'align-start': __WEBPACK_IMPORTED_MODULE_13__messages__["a" /* default */].alignImageLeft,
};
var ToolbarButton = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_14__ui_ToolbarButton__["a" /* default */])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  width: 24px;\n  padding: 0;\n  margin: 0 2px;\n"], ["\n  width: 24px;\n  padding: 0;\n  margin: 0 2px;\n"])));
var Separator = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_15__ui_Separator__["a" /* default */])(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin: 2px 6px;\n"], ["\n  margin: 2px 6px;\n"])));
// `line-height: 1` to fix extra 1px height from toolbar wrapper
var FloatingToolbar = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_16__ui_FloatingToolbar__["a" /* default */])(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  & > div {\n    line-height: 1;\n  }\n  & > div:first-child > button {\n    margin-left: 0;\n  }\n  & > div:last-child > button {\n    margin-right: 0;\n  }\n"], ["\n  & > div {\n    line-height: 1;\n  }\n  & > div:first-child > button {\n    margin-left: 0;\n  }\n  & > div:last-child > button {\n    margin-right: 0;\n  }\n"])));
var ToolbarButtonDestructive = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(ToolbarButton)(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  &:hover {\n    color: ", " !important;\n  }\n  &:active {\n    color: ", " !important;\n  }\n  &[disabled]:hover {\n    color: ", " !important;\n  }\n"], ["\n  &:hover {\n    color: ", " !important;\n  }\n  &:active {\n    color: ", " !important;\n  }\n  &[disabled]:hover {\n    color: ", " !important;\n  }\n"])), __WEBPACK_IMPORTED_MODULE_12__atlaskit_theme__["colors"].R300, __WEBPACK_IMPORTED_MODULE_12__atlaskit_theme__["colors"].R400, __WEBPACK_IMPORTED_MODULE_12__atlaskit_theme__["colors"].N70);
var MediaSingleEdit = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MediaSingleEdit, _super);
    function MediaSingleEdit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getItems = function (allowResizing, allowBreakout) {
            if (!allowResizing) {
                return icons.concat(breakoutIcons);
            }
            return icons;
        };
        _this.handleRemove = function () {
            var pluginState = _this.props.pluginState;
            pluginState.removeSelectedMediaNode();
        };
        return _this;
    }
    MediaSingleEdit.prototype.render = function () {
        var _this = this;
        var formatMessage = this.props.intl.formatMessage;
        var _a = this.props, target = _a.target, selectedLayout = _a.layout, allowBreakout = _a.allowBreakout, allowLayout = _a.allowLayout, allowResizing = _a.allowResizing, editorDisabled = _a.editorDisabled;
        var toolbarIcons = this.getItems(allowResizing, allowBreakout);
        if (target &&
            !Object(__WEBPACK_IMPORTED_MODULE_17__utils__["i" /* closestElement */])(target, 'li') &&
            !Object(__WEBPACK_IMPORTED_MODULE_17__utils__["i" /* closestElement */])(target, 'table') &&
            !editorDisabled) {
            var labelRemove = formatMessage(__WEBPACK_IMPORTED_MODULE_13__messages__["a" /* default */].remove);
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](FloatingToolbar, { target: target, offset: [0, 12], fitHeight: 32, alignX: "center" },
                allowLayout && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                    toolbarIcons.map(function (layout, index) {
                        // Don't render Wide and Full width button for image smaller than editor content width
                        var value = layout.value, Icon = layout.Icon;
                        if (value === 'separator') {
                            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Separator, { key: index });
                        }
                        var label = formatMessage(layoutToMessages[value]);
                        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ToolbarButton, { spacing: "compact", key: index, selected: value === selectedLayout, onClick: _this.handleChangeLayout.bind(_this, value), title: label, iconBefore: Icon && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Icon, { label: label }) }));
                    }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Separator, null))),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ToolbarButtonDestructive, { spacing: "compact", onClick: this.handleRemove, title: labelRemove, iconBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_remove___default.a, { label: labelRemove }) })));
        }
        else {
            return null;
        }
    };
    MediaSingleEdit.prototype.handleChangeLayout = function (layout) {
        this.props.pluginState.align(layout);
    };
    return MediaSingleEdit;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["injectIntl"])(MediaSingleEdit));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map

/***/ }),
/* 2586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorMediaWrapLeftIcon = function EditorMediaWrapLeftIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2zm8-8h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2zm0 4h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2zM6 9h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zm0-4h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorMediaWrapLeftIcon.displayName = 'EditorMediaWrapLeftIcon';
var _default = EditorMediaWrapLeftIcon;
exports.default = _default;

/***/ }),
/* 2587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorMediaWrapRightIcon = function EditorMediaWrapRightIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2zm0-8h4a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2zm0 4h4a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2zm8-4h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zM6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorMediaWrapRightIcon.displayName = 'EditorMediaWrapRightIcon';
var _default = EditorMediaWrapRightIcon;
exports.default = _default;

/***/ }),
/* 2588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorAlignImageLeftIcon = function EditorAlignImageLeftIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" focusable=\"false\" role=\"presentation\"><path d=\"M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2zm0-8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zm0-4h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorAlignImageLeftIcon.displayName = 'EditorAlignImageLeftIcon';
var _default = EditorAlignImageLeftIcon;
exports.default = _default;

/***/ }),
/* 2589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorAlignImageRightIcon = function EditorAlignImageRightIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" focusable=\"false\" role=\"presentation\"><path d=\"M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2zm8-8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zM6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorAlignImageRightIcon.displayName = 'EditorAlignImageRightIcon';
var _default = EditorAlignImageRightIcon;
exports.default = _default;

/***/ }),
/* 2590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorAlignImageCenterIcon = function EditorAlignImageCenterIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" focusable=\"false\" role=\"presentation\"><path d=\"M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2zm4-8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zM6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorAlignImageCenterIcon.displayName = 'EditorAlignImageCenterIcon';
var _default = EditorAlignImageCenterIcon;
exports.default = _default;

/***/ }),
/* 2591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReactMediaGroupNode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeviews_ReactNodeView__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_media_filmstrip__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_base_pm_plugins_react_nodeview__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_close__ = __webpack_require__(2629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__editor_disabled__ = __webpack_require__(106);










var MediaGroup = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MediaGroup, _super);
    function MediaGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            selected: null,
        };
        _this.setMediaItems = function (props) {
            var node = props.node;
            _this.mediaNodes = [];
            node.forEach(function (item, childOffset) {
                _this.mediaPluginState.mediaGroupNodes[item.attrs.__key || item.attrs.id] = {
                    node: item,
                    getPos: function () { return props.getPos() + childOffset + 1; },
                };
                _this.mediaNodes.push(item);
            });
        };
        _this.renderChildNodes = function (node) {
            var items = _this.mediaNodes.map(function (item, idx) {
                var getState = _this.mediaPluginState.stateManager.getState(item.attrs.__key || item.attrs.id);
                var identifier = {
                    id: getState ? getState.fileId : item.attrs.id,
                    mediaItemType: 'file',
                    collectionName: item.attrs.collection,
                };
                var nodePos = _this.props.getPos() + idx + 1;
                return {
                    identifier: identifier,
                    selectable: true,
                    isLazy: _this.props.editorAppearance !== 'mobile',
                    selected: _this.props.selected === nodePos,
                    onClick: function () {
                        Object(__WEBPACK_IMPORTED_MODULE_5__utils__["G" /* setNodeSelection */])(_this.props.view, nodePos);
                    },
                    actions: [
                        {
                            handler: _this.props.disabled
                                ? {}
                                : _this.mediaPluginState.handleMediaNodeRemoval.bind(null, null, function () { return nodePos; }),
                            icon: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_close___default.a, { label: "delete" }),
                        },
                    ],
                };
            });
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_media_filmstrip__["a" /* Filmstrip */], { items: items, context: _this.mediaPluginState.mediaContext }));
        };
        _this.mediaPluginState = __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["b" /* stateKey */].getState(props.view.state);
        _this.setMediaItems(props);
        return _this;
    }
    MediaGroup.prototype.componentWillReceiveProps = function (props) {
        this.setMediaItems(props);
    };
    MediaGroup.prototype.shouldComponentUpdate = function (nextProps) {
        if (this.props.selected !== nextProps.selected ||
            this.props.node !== nextProps.node) {
            return true;
        }
        return false;
    };
    MediaGroup.prototype.render = function () {
        return this.renderChildNodes(this.props.node);
    };
    return MediaGroup;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* unused harmony default export */ var _unused_webpack_default_export = (MediaGroup);
var MediaGroupNodeView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MediaGroupNodeView, _super);
    function MediaGroupNodeView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MediaGroupNodeView.prototype.render = function (props, forwardRef) {
        var _this = this;
        var editorAppearance = this.reactComponentProps.editorAppearance;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ui_WithPluginState__["a" /* default */], { editorView: this.view, plugins: {
                reactNodeViewState: __WEBPACK_IMPORTED_MODULE_7__plugins_base_pm_plugins_react_nodeview__["b" /* stateKey */],
                editorDisabledPlugin: __WEBPACK_IMPORTED_MODULE_9__editor_disabled__["b" /* pluginKey */],
            }, render: function (_a) {
                var editorDisabledPlugin = _a.editorDisabledPlugin;
                var nodePos = _this.getPos();
                var _b = _this.view.state.selection, $anchor = _b.$anchor, $head = _b.$head;
                var isSelected = nodePos < $anchor.pos && $head.pos < nodePos + _this.node.nodeSize;
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MediaGroup, { node: _this.node, getPos: _this.getPos, view: _this.view, forwardRef: forwardRef, selected: isSelected ? $anchor.pos : null, disabled: (editorDisabledPlugin || {}).editorDisabled, editorAppearance: editorAppearance }));
            } }));
    };
    MediaGroupNodeView.prototype.stopEvent = function (event) {
        event.preventDefault();
        return true;
    };
    return MediaGroupNodeView;
}(__WEBPACK_IMPORTED_MODULE_2__nodeviews_ReactNodeView__["a" /* default */]));
var ReactMediaGroupNode = function (portalProviderAPI, editorAppearance) { return function (node, view, getPos) {
    return new MediaGroupNodeView(node, view, getPos, portalProviderAPI, {
        editorAppearance: editorAppearance,
    }).init();
}; };
//# sourceMappingURL=mediaGroup.js.map

/***/ }),
/* 2592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(87));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ArrowLeftIcon = function ArrowLeftIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M8.414 11.5H18a1 1 0 0 1 0 2H8.414l3.793 3.793a1 1 0 0 1-1.414 1.414l-5.5-5.5a1 1 0 0 1 0-1.414l5.5-5.5a1 1 0 0 1 1.414 1.414L8.414 11.5z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var _default = ArrowLeftIcon;
exports.default = _default;

/***/ }),
/* 2593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e100", function() { return e100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e200", function() { return e200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e300", function() { return e300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e400", function() { return e400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e500", function() { return e500; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(458);

 // Cards on a board

var e100 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 1px 1px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px 0 ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 1px 1px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
}); // Inline dialogs

var e200 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 4px 8px -2px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 4px 8px -2px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
}); // Modals

var e300 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 8px 16px -4px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 8px 16px -4px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
}); // Panels

var e400 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 12px 24px -6px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 12px 24px -6px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
}); // Flag messages (notifications)

var e500 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 20px 32px -8px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 20px 32px -8px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
});

/***/ }),
/* 2594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h900", function() { return h900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h800", function() { return h800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h700", function() { return h700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h600", function() { return h600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h500", function() { return h500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h400", function() { return h400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h300", function() { return h300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h200", function() { return h200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h100", function() { return h100; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colors__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(330);




var baseHeading = function baseHeading(size, lineHeight) {
  return "\n  font-size: ".concat(size / Object(__WEBPACK_IMPORTED_MODULE_2__index__["fontSize"])(), "em;\n  font-style: inherit;\n  line-height: ").concat(lineHeight / size, ";\n");
};

var h900 = function h900() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ", "px;\n"], baseHeading(35, 40), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 6.5);
};
var h800 = function h800() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ", "px;\n"], baseHeading(29, 32), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 5);
};
var h700 = function h700() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ", "px;\n"], baseHeading(24, 28), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 5);
};
var h600 = function h600() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ", "px;\n"], baseHeading(20, 24), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 3.5);
};
var h500 = function h500() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ", "px;\n"], baseHeading(16, 20), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 3);
};
var h400 = function h400() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ", "px;\n"], baseHeading(14, 16), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 2);
};
var h300 = function h300() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  margin-top: ", "px;\n  text-transform: uppercase;\n"], baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 2.5);
};
var h200 = function h200() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  margin-top: ", "px;\n"], baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_1__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 2);
};
var h100 = function h100() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 700;\n  margin-top: ", "px;\n"], baseHeading(11, 16), __WEBPACK_IMPORTED_MODULE_1__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_2__index__["gridSize"])() * 2);
};

/***/ }),
/* 2595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["add"] = add;
/* harmony export (immutable) */ __webpack_exports__["subtract"] = subtract;
/* harmony export (immutable) */ __webpack_exports__["multiply"] = multiply;
/* harmony export (immutable) */ __webpack_exports__["divide"] = divide;
function add(fn, addend) {
  return function (props) {
    return fn(props) + addend;
  };
}
function subtract(fn, subtrahend) {
  return function (props) {
    return fn(props) - subtrahend;
  };
}
function multiply(fn, factor) {
  return function (props) {
    return fn(props) * factor;
  };
}
function divide(fn, divisor) {
  return function (props) {
    return fn(props) / divisor;
  };
}

/***/ }),
/* 2596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AtlaskitThemeProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_exenv__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_exenv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_exenv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__colors__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Theme__ = __webpack_require__(459);












 // For forward-compat until everything is upgraded.



function getStylesheetResetCSS(state) {
  var backgroundColor = __WEBPACK_IMPORTED_MODULE_11__colors__["background"](state);
  return "\n    body { background: ".concat(backgroundColor, "; }\n  ");
}

function buildThemeState(mode) {
  return {
    theme: __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_12__constants__["a" /* CHANNEL */], {
      mode: mode
    })
  };
}

var LegacyReset = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div.withConfig({
  displayName: "AtlaskitThemeProvider__LegacyReset",
  componentId: "sc-431dkp-0"
})(["\n  background-color: ", ";\n  color: ", ";\n\n  a {\n    color: ", ";\n  }\n  a:hover {\n    color: ", ";\n  }\n  a:active {\n    color: ", ";\n  }\n  a:focus {\n    outline-color: ", ";\n  }\n  h1 {\n    color: ", ";\n  }\n  h2 {\n    color: ", ";\n  }\n  h3 {\n    color: ", ";\n  }\n  h4 {\n    color: ", ";\n  }\n  h5 {\n    color: ", ";\n  }\n  h6 {\n    color: ", ";\n  }\n  small {\n    color: ", ";\n  }\n"], __WEBPACK_IMPORTED_MODULE_11__colors__["background"], __WEBPACK_IMPORTED_MODULE_11__colors__["text"], __WEBPACK_IMPORTED_MODULE_11__colors__["link"], __WEBPACK_IMPORTED_MODULE_11__colors__["linkHover"], __WEBPACK_IMPORTED_MODULE_11__colors__["linkActive"], __WEBPACK_IMPORTED_MODULE_11__colors__["linkOutline"], __WEBPACK_IMPORTED_MODULE_11__colors__["heading"], __WEBPACK_IMPORTED_MODULE_11__colors__["heading"], __WEBPACK_IMPORTED_MODULE_11__colors__["heading"], __WEBPACK_IMPORTED_MODULE_11__colors__["heading"], __WEBPACK_IMPORTED_MODULE_11__colors__["heading"], __WEBPACK_IMPORTED_MODULE_11__colors__["subtleHeading"], __WEBPACK_IMPORTED_MODULE_11__colors__["subtleText"]);

var AtlaskitThemeProvider =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(AtlaskitThemeProvider, _Component);

  function AtlaskitThemeProvider(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, AtlaskitThemeProvider);

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(AtlaskitThemeProvider).call(this, props));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "stylesheet", void 0);

    _this.state = buildThemeState(props.mode);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(AtlaskitThemeProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        hasAtlaskitThemeProvider: true
      };
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      if (!this.context.hasAtlaskitThemeProvider && __WEBPACK_IMPORTED_MODULE_10_exenv___default.a.canUseDOM) {
        var css = getStylesheetResetCSS(this.state);
        this.stylesheet = document.createElement('style');
        this.stylesheet.type = 'text/css';
        this.stylesheet.innerHTML = css;

        if (document && document.head) {
          document.head.appendChild(this.stylesheet);
        }
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (newProps.mode !== this.props.mode) {
        var newThemeState = buildThemeState(newProps.mode);

        if (this.stylesheet) {
          var css = getStylesheetResetCSS(newThemeState);
          this.stylesheet.innerHTML = css;
        }

        this.setState(newThemeState);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.stylesheet && document && document.head) {
        document.head.removeChild(this.stylesheet);
        delete this.stylesheet;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var theme = this.state.theme;
      return (
        /* Wrapping the new provider around the old one provides forward
        compatibility when using the old provider for styled components. This
        allows us to use components converted to use the new API with consumers
        using the old provider along side components that may still be using the
        old theming API. */
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Theme__["a" /* default */].Provider, {
          value: function value() {
            return {
              mode: theme[__WEBPACK_IMPORTED_MODULE_12__constants__["a" /* CHANNEL */]].mode
            };
          }
        }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_styled_components__["ThemeProvider"], {
          theme: theme
        }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(LegacyReset, null, children)))
      );
    }
  }]);

  return AtlaskitThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AtlaskitThemeProvider, "defaultProps", {
  mode: __WEBPACK_IMPORTED_MODULE_12__constants__["b" /* DEFAULT_THEME_MODE */]
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AtlaskitThemeProvider, "childContextTypes", {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AtlaskitThemeProvider, "contextTypes", {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
});



/***/ }),
/* 2597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);


/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var children = _ref.children,
      props = _ref.props,
      theme = _ref.theme;
  var appearance = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(props) === 'object' ? 'default' : props;
  var merged = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(props) === 'object' ? __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, props) : {};
  Object.keys(theme).forEach(function (key) {
    if (!(key in merged)) {
      merged[key] = theme[key]({
        appearance: appearance
      });
    }
  });
  return children(merged);
});

/***/ }),
/* 2598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ResetTheme; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Reset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__colors__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_createTheme__ = __webpack_require__(460);







var orTextColor = function orTextColor(preferred) {
  return function (p) {
    return p[preferred] || p.textColor;
  };
};

var Div = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div.withConfig({
  displayName: "Reset__Div",
  componentId: "sc-15i6ali-0"
})(["\n  ", ";\n"], function (p) {
  return Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["css"])(["\n    background-color: ", ";\n    color: ", ";\n\n    a {\n      color: ", ";\n    }\n    a:hover {\n      color: ", ";\n    }\n    a:active {\n      color: ", ";\n    }\n    a:focus {\n      outline-color: ", ";\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ", ";\n    }\n    h6 {\n      color: ", ";\n    }\n    small {\n      color: ", ";\n    }\n  "], p.backgroundColor, p.textColor, orTextColor('linkColor'), orTextColor('linkColorHover'), orTextColor('linkColorActive'), orTextColor('linkColorOutline'), orTextColor('headingColor'), orTextColor('subtleHeadingColor'), orTextColor('subtleTextColor'));
});
var ResetTheme = Object(__WEBPACK_IMPORTED_MODULE_5__utils_createTheme__["a" /* createTheme */])(function () {
  return {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N0"],
    linkColor: __WEBPACK_IMPORTED_MODULE_4__colors__["B400"],
    linkColorHover: __WEBPACK_IMPORTED_MODULE_4__colors__["B300"],
    linkColorActive: __WEBPACK_IMPORTED_MODULE_4__colors__["B500"],
    linkColorOutline: __WEBPACK_IMPORTED_MODULE_4__colors__["B100"],
    headingColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N800"],
    subtleHeadingColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N200"],
    subtleTextColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N200"],
    textColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N900"]
  };
});
function Reset(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ResetTheme.Provider, {
    value: props.theme
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ResetTheme.Consumer, null, function (tokens) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Div, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, tokens, {
      mode: undefined
    }), props), props.children);
  }));
}

/***/ }),
/* 2599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Theme__ = __webpack_require__(459);


 // Pre-executes the theme and passes it as a prop to the supplied component.
// This is useful for ensuring that the current theme is accessible as props
// in styled-components.

function withTheme(InnerComponent) {
  return function ComponentWithTheme(props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Theme__["a" /* default */].Consumer, null, function (tokens) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InnerComponent, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, props, {
        theme: tokens
      }));
    });
  };
}

/***/ }),
/* 2600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = void 0;
var sizes = {
  small: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '48px'
};
exports.sizes = sizes;

/***/ }),
/* 2601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(87));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ArrowRightIcon = function ArrowRightIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M11.793 5.793a.999.999 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a.999.999 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a.997.997 0 0 0 .293-.679v-.057a.996.996 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

ArrowRightIcon.displayName = 'ArrowRightIcon';
var _default = ArrowRightIcon;
exports.default = _default;

/***/ }),
/* 2602 */
/***/ (function(module, exports) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */
function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};

// Adds compatibility for ES modules
debounce.debounce = debounce;

module.exports = debounce;


/***/ }),
/* 2603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FilmStripViewWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FilmStripListWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FilmStripList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FilmStripListItem; });
/* unused harmony export ArrowWrapper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArrowLeftWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ArrowRightWrapper; });
/* unused harmony export Shadow */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ShadowLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ShadowRight; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__);
/* tslint:disable:variable-name */



var FilmStripViewWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  position: relative;\n  padding: 3px 0;\n  border-radius: 3px;\n\n  &:hover .arrow {\n    opacity: 1;\n  }\n\n  .ellipsed-text {\n    white-space: initial;\n  }\n"], ["\n  position: relative;\n  padding: 3px 0;\n  border-radius: 3px;\n\n  &:hover .arrow {\n    opacity: 1;\n  }\n\n  .ellipsed-text {\n    white-space: initial;\n  }\n"])));
var FilmStripListWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  width: inherit;\n  overflow: hidden;\n  padding: 2px 0;\n"], ["\n  width: inherit;\n  overflow: hidden;\n  padding: 2px 0;\n"])));
var FilmStripList = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].ul(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin: 0;\n  padding: 0;\n  transition-property: transform;\n  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  white-space: nowrap;\n  display: inline-block;\n"], ["\n  margin: 0;\n  padding: 0;\n  transition-property: transform;\n  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);\n  white-space: nowrap;\n  display: inline-block;\n"])));
var FilmStripListItem = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].li(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  list-style-type: none;\n  margin: 0;\n  padding: 0 4px;\n  display: inline-block;\n  vertical-align: middle;\n  /* Fixes issue with child Cards using inline-block */\n  font-size: 0;\n"], ["\n  list-style-type: none;\n  margin: 0;\n  padding: 0 4px;\n  display: inline-block;\n  vertical-align: middle;\n  /* Fixes issue with child Cards using inline-block */\n  font-size: 0;\n"])));
var ArrowWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_5 || (templateObject_5 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: ", ";\n  border-radius: 100%;\n  display: flex;\n  cursor: pointer;\n  transition: opacity 0.3s;\n  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.6);\n  color: black;\n  width: 30px;\n  height: 30px;\n  justify-content: center;\n  opacity: 0;\n\n  &:hover {\n    color: black;\n    background-color: ", ";\n  }\n\n  &:active {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  svg {\n    height: 30px;\n    width: 20px;\n  }\n"], ["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: ", ";\n  border-radius: 100%;\n  display: flex;\n  cursor: pointer;\n  transition: opacity 0.3s;\n  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.6);\n  color: black;\n  width: 30px;\n  height: 30px;\n  justify-content: center;\n  opacity: 0;\n\n  &:hover {\n    color: black;\n    background-color: ", ";\n  }\n\n  &:active {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  svg {\n    height: 30px;\n    width: 20px;\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorN20"], __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorN40"], __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorB400"], __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorB50"]);
var ArrowLeftWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(ArrowWrapper)(templateObject_6 || (templateObject_6 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  left: 8px;\n\n  svg {\n    padding-right: 2px;\n  }\n"], ["\n  left: 8px;\n\n  svg {\n    padding-right: 2px;\n  }\n"])));
var ArrowRightWrapper = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(ArrowWrapper)(templateObject_7 || (templateObject_7 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  right: 8px;\n\n  svg {\n    padding-left: 1px;\n  }\n"], ["\n  right: 8px;\n\n  svg {\n    padding-left: 1px;\n  }\n"])));
var Shadow = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_8 || (templateObject_8 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  position: absolute;\n  z-index: 10;\n  height: 100%;\n  top: 0;\n  width: 2px;\n  background-color: rgba(0, 0, 0, 0.2);\n"], ["\n  position: absolute;\n  z-index: 10;\n  height: 100%;\n  top: 0;\n  width: 2px;\n  background-color: rgba(0, 0, 0, 0.2);\n"])));
var ShadowLeft = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(Shadow)(templateObject_9 || (templateObject_9 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  left: 0;\n"], ["\n  left: 0;\n"])));
var ShadowRight = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(Shadow)(templateObject_10 || (templateObject_10 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  right: 0;\n"], ["\n  right: 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Filmstrip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_media_card__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filmstripView__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_generateIdentifierKey__ = __webpack_require__(2628);

/* tslint:disable variable-name */





var Filmstrip = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Filmstrip, _super);
    function Filmstrip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            animate: false,
            offset: 0,
        };
        _this.handleSize = function (_a) {
            var offset = _a.offset;
            return _this.setState({ offset: offset });
        };
        _this.handleScroll = function (_a) {
            var animate = _a.animate, offset = _a.offset;
            return _this.setState({ animate: animate, offset: offset });
        };
        return _this;
    }
    Filmstrip.prototype.renderCards = function () {
        var _a = this.props, items = _a.items, context = _a.context;
        var cards = items.map(function (item) {
            var key = Object(__WEBPACK_IMPORTED_MODULE_4__utils_generateIdentifierKey__["a" /* generateIdentifierKey */])(item.identifier);
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_media_card__["a" /* Card */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ key: key, context: context, dimensions: __WEBPACK_IMPORTED_MODULE_2__atlaskit_media_card__["b" /* defaultImageCardDimensions */] }, item)));
        });
        return cards;
    };
    Filmstrip.prototype.render = function () {
        var _a = this.state, animate = _a.animate, offset = _a.offset;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__filmstripView__["a" /* FilmstripView */], { animate: animate, offset: offset, onSize: this.handleSize, onScroll: this.handleScroll }, this.renderCards()));
    };
    return Filmstrip;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=filmstrip.js.map

/***/ }),
/* 2605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_cardLoading__ = __webpack_require__(333);



var Card = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Card, _super);
    function Card() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            Card: Card.Card,
        };
        return _this;
    }
    Card.prototype.componentWillMount = function () {
        var _this = this;
        if (!this.state.Card) {
            __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 3471)).then(function (module) {
                Card.Card = module.Card;
                _this.setState({ Card: module.Card });
            });
        }
    };
    Card.prototype.render = function () {
        var _a = this.props, dimensions = _a.dimensions, identifier = _a.identifier;
        if (!this.state.Card) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__utils_cardLoading__["a" /* CardLoading */], { dimensions: dimensions, mediaItemType: identifier.mediaItemType }));
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](this.state.Card, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, this.props));
    };
    Card.displayName = 'AsyncCard';
    return Card;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Card);
//# sourceMappingURL=cardLoader.js.map

/***/ }),
/* 2606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(87));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FileIcon = function FileIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M17 10.005V19H7V5h5.99v2.49a1.5 1.5 0 0 0 1.5 1.5h4.5v-.522c0-.297-.132-.578-.359-.768l-5.074-4.236c-.36-.3-.813-.464-1.282-.464H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8.995h-2z\"/><rect x=\"8\" y=\"12\" width=\"8\" height=\"2\" rx=\"1\"/><rect x=\"8\" y=\"15\" width=\"4\" height=\"2\" rx=\"1\"/></g></svg>"
  }, props));
};

FileIcon.displayName = 'FileIcon';
var _default = FileIcon;
exports.default = _default;

/***/ }),
/* 2607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(87));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var LinkIcon = function LinkIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M12.856 5.457l-.937.92a1.002 1.002 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47\"/><path d=\"M11.144 19.543l.937-.92a1.002 1.002 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47\"/></g></svg>"
  }, props));
};

LinkIcon.displayName = 'LinkIcon';
var _default = LinkIcon;
exports.default = _default;

/***/ }),
/* 2608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export blinkLoadingAnimation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_media_ui__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__ = __webpack_require__(330);

/* tslint:disable:variable-name */



var blinkLoadingAnimation = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  0%{\n    opacity: 1;\n  }\n\n  50%{\n    opacity: 0.6;\n  }\n\n  100%{\n    opacity: 1;\n  }\n"], ["\n  0%{\n    opacity: 1;\n  }\n\n  50%{\n    opacity: 0.6;\n  }\n\n  100%{\n    opacity: 1;\n  }\n"])));
var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", " background: ", ";\n  color: ", ";\n  border-radius: inherit;\n  max-height: 100%;\n  max-width: 100%;\n \n  ", "\n  > span {\n    animation: ", " 0.8s infinite;\n  }\n"], ["\n  ", " background: ", ";\n  color: ", ";\n  border-radius: inherit;\n  max-height: 100%;\n  max-width: 100%;\n \n  ",
    "\n  > span {\n    animation: ", " 0.8s infinite;\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_media_ui__["q" /* center */], Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].DN50 }), Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N50, dark: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].DN100 }), function (props) {
    return "\n      width: " + props.dimensions.width + ";\n      height: " + props.dimensions.height + ";\n    ";
}, blinkLoadingAnimation);
var templateObject_1, templateObject_2;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var ImageComponent = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].img(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  position: absolute;\n  left: 50%;\n  top: 50%;\n"], ["\n  position: absolute;\n  left: 50%;\n  top: 50%;\n"])));
var templateObject_1;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardActionsView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cardActionIconButton__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cardActionsDropdownMenu__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__preventClickThrough__ = __webpack_require__(2615);







var CardActionsView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CardActionsView, _super);
    function CardActionsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardActionsView.prototype.render = function () {
        var actions = this.props.actions;
        if (!actions.length) {
            return null;
        }
        var primaryAction = actions.find(actionWithIcon);
        var otherActions = actions.filter(actionNotEqualTo(primaryAction));
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__preventClickThrough__["a" /* PreventClickThrough */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled__["b" /* Wrapper */], null,
                primaryAction ? this.renderActionIconButton(primaryAction) : null,
                this.renderOtherActionButtons(otherActions))));
    };
    CardActionsView.prototype.renderActionIconButton = function (action) {
        var triggerColor = this.props.triggerColor;
        var icon = action.icon, handler = action.handler;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__cardActionIconButton__["a" /* CardActionIconButton */], { icon: icon, triggerColor: triggerColor, onClick: function () { return handler(); } }));
    };
    CardActionsView.prototype.renderOtherActionButtons = function (actions) {
        if (actions.length === 0) {
            return null;
        }
        else {
            var _a = this.props, triggerColor = _a.triggerColor, onToggle = _a.onToggle;
            var firstActionWithIcon = actions.find(actionWithIcon);
            var otherActions = actions.filter(actionNotEqualTo(firstActionWithIcon));
            if (firstActionWithIcon && otherActions.length === 0) {
                return this.renderActionIconButton(firstActionWithIcon);
            }
            else {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__cardActionsDropdownMenu__["a" /* CardActionsDropdownMenu */], { actions: actions, triggerColor: triggerColor, onOpenChange: onToggle }));
            }
        }
    };
    return CardActionsView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

function actionWithIcon(action) {
    return !!action.icon;
}
function actionNotEqualTo(otherAction) {
    return function (action) { return action !== otherAction; };
}
//# sourceMappingURL=cardActionsView.js.map

/***/ }),
/* 2611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return centerX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return antialiased; });
/* unused harmony export centerSelfY */
/* unused harmony export centerSelfX */
/* unused harmony export centerSelf */
/* unused harmony export borderRadiusLeft */
/* unused harmony export spaceAround */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return transition; });
/* unused harmony export hexToRgb */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rgba; });
/* unused harmony export capitalize */
/* unused harmony export withAppearance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_util_shared_styles__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_util_shared_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__atlaskit_util_shared_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(854);
/* tslint:disable:variable-name */


var centerX = "\n  display: flex;\n  justify-content: center;\n";
var antialiased = "\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n";
var centerSelfY = "\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n";
var centerSelfX = "\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n";
var centerSelf = "\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n";
var borderRadiusLeft = "\n  border-top-left-radius: " + __WEBPACK_IMPORTED_MODULE_0__atlaskit_util_shared_styles__["akBorderRadius"] + ";\n  border-bottom-left-radius: " + __WEBPACK_IMPORTED_MODULE_0__atlaskit_util_shared_styles__["akBorderRadius"] + ";\n";
var spaceAround = "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n";
var transition = function (propertyName) {
    if (propertyName === void 0) { propertyName = 'all'; }
    return "\n  transition: " + propertyName + " " + __WEBPACK_IMPORTED_MODULE_1__config__["a" /* defaultTransitionDuration */] + ";\n";
};
var hexToRgb = function (hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? parseInt(result[1], 16) + "," + parseInt(result[2], 16) + "," + parseInt(result[3], 16)
        : null;
};
var rgba = function (hex, opacity) {
    return "rgba(" + hexToRgb(hex) + ", " + opacity + ")";
};
var capitalize = "\n  &::first-letter {\n    text-transform: uppercase;\n  }\n";
var withAppearance = function (styleMap) { return function (_a) {
    var appearance = _a.appearance;
    return (appearance && styleMap[appearance]) || '';
}; };
//# sourceMappingURL=mixins.js.map

/***/ }),
/* 2612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return easeOutCubic; });
/* unused harmony export easeOutExpo */
var easeOutCubic = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
var easeOutExpo = 'cubic-bezier(0.19, 1, 0.22, 1)';
//# sourceMappingURL=easing.js.map

/***/ }),
/* 2613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export spin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var spin = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  to { transform: rotate(360deg); }\n"], ["\n  to { transform: rotate(360deg); }\n"])));
var templateObject_1;
//# sourceMappingURL=animations.js.map

/***/ }),
/* 2614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(87));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var MoreIcon = function MoreIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><circle cx=\"5\" cy=\"12\" r=\"2\"/><circle cx=\"12\" cy=\"12\" r=\"2\"/><circle cx=\"19\" cy=\"12\" r=\"2\"/></g></svg>"
  }, props));
};

MoreIcon.displayName = 'MoreIcon';
var _default = MoreIcon;
exports.default = _default;

/***/ }),
/* 2615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__preventClickThrough__ = __webpack_require__(2616);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__preventClickThrough__["a"]; });
/* unused harmony reexport default */

//# sourceMappingURL=index.js.map

/***/ }),
/* 2616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PreventClickThrough;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function PreventClickThrough(_a) {
    var children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { onClick: function (event) {
            event.stopPropagation();
            event.preventDefault();
        } }, children));
}
//# sourceMappingURL=preventClickThrough.js.map

/***/ }),
/* 2617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MediaTypeIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_image__ = __webpack_require__(2618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_audio__ = __webpack_require__(2619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_audio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_audio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_media_services_video__ = __webpack_require__(2620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_media_services_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_media_services_video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_document__ = __webpack_require__(2621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_document___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_document__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_page__ = __webpack_require__(2622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled__ = __webpack_require__(2623);

/* tslint:disable:variable-name */







var icons = {
    image: __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_image___default.a,
    audio: __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_audio___default.a,
    video: __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_media_services_video___default.a,
    doc: __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_document___default.a,
    unknown: __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_page___default.a,
};
var MediaTypeIcon = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MediaTypeIcon, _super);
    function MediaTypeIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MediaTypeIcon.prototype.render = function () {
        var _a = this.props, type = _a.type, _b = _a.size, size = _b === void 0 ? 'small' : _b, className = _a.className;
        var Icon = (type && icons[type]) || icons.unknown;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styled__["a" /* IconWrapper */], { type: type || 'unknown' },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Icon, { label: "media-type", size: size, className: className })));
    };
    return MediaTypeIcon;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=index.js.map

/***/ }),
/* 2618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(87));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ImageIcon = function ImageIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M3 4.995C3 3.893 3.893 3 4.995 3h14.01C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.005V4.995zM10.5 16.5L9 15l-3 3h12v-2.7L15 12l-4.5 4.5zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

ImageIcon.displayName = 'ImageIcon';
var _default = ImageIcon;
exports.default = _default;

/***/ }),
/* 2619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(87));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var AudioIcon = function AudioIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M19 6.673V15.2a2.8 2.8 0 0 1-2.8 2.8h-.4a2.8 2.8 0 0 1-2.8-2.8v-.4a2.8 2.8 0 0 1 2.8-2.8h.4c.278 0 .547.04.8.116V8.242l-6 .621V16.2A2.8 2.8 0 0 1 8.2 19h-.4A2.8 2.8 0 0 1 5 16.2v-.4A2.8 2.8 0 0 1 7.8 13h.4c.278 0 .547.04.8.116V6.654c0-.38.31-.721.72-.764l8.56-.886c.398-.041.72.235.72.615v1.054z\" fill=\"currentColor\"/></svg>"
  }, props));
};

AudioIcon.displayName = 'AudioIcon';
var _default = AudioIcon;
exports.default = _default;

/***/ }),
/* 2620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(87));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var MediaServicesVideoIcon = function MediaServicesVideoIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill-rule=\"evenodd\"><rect fill=\"currentColor\" x=\"4\" y=\"4\" width=\"16\" height=\"16\" rx=\"2\"/><path d=\"M16.37 14.954L14 13.807v-3.613l2.37-1.148c.285-.138.63.05.63.343v5.222c0 .293-.345.481-.63.343\" fill=\"inherit\"/><rect fill=\"inherit\" x=\"7\" y=\"9\" width=\"6\" height=\"6\" rx=\"1\"/></g></svg>"
  }, props));
};

MediaServicesVideoIcon.displayName = 'MediaServicesVideoIcon';
var _default = MediaServicesVideoIcon;
exports.default = _default;

/***/ }),
/* 2621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(87));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DocumentIcon = function DocumentIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M17 10.005V19H7V5h5.99v2.49a1.5 1.5 0 0 0 1.5 1.5h4.5v-.522c0-.297-.132-.578-.359-.768l-5.074-4.236c-.36-.3-.813-.464-1.282-.464H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8.995h-2z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

DocumentIcon.displayName = 'DocumentIcon';
var _default = DocumentIcon;
exports.default = _default;

/***/ }),
/* 2622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(87));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var PageIcon = function PageIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><rect x=\"8\" y=\"6\" width=\"8\" height=\"2\" rx=\"1\"/><rect x=\"8\" y=\"9\" width=\"8\" height=\"2\" rx=\"1\"/><rect x=\"8\" y=\"12\" width=\"4\" height=\"2\" rx=\"1\"/><path d=\"M7 4v16h10V4H7zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01V3.99z\" fill-rule=\"nonzero\"/></g></svg>"
  }, props));
};

PageIcon.displayName = 'PageIcon';
var _default = PageIcon;
exports.default = _default;

/***/ }),
/* 2623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__);
/* tslint:disable:variable-name */



var colors = {
    image: __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorY200"],
    audio: __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorP200"],
    video: '#ff7143',
    doc: __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_shared_styles__["akColorB300"],
    unknown: '#3dc7dc',
};
var IconWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: inline-flex;\n  color: ", ";\n"], ["\n  display: inline-flex;\n  color: ", ";\n"])), function (_a) {
    var type = _a.type;
    return colors[type] || colors.unknown;
});
var templateObject_1;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileTypeIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_media_ui__ = __webpack_require__(51);

/* tslint:disable:variable-name */


var FileTypeIcon = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  float: left;\n  margin-right: 6px;\n  position: relative;\n  top: 1px;\n  img {\n    ", ";\n  }\n"], ["\n  float: left;\n  margin-right: 6px;\n  position: relative;\n  top: 1px;\n  img {\n    ", ";\n  }\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_media_ui__["y" /* size */])('12px !important'));
var templateObject_1;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(87));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorWarningIcon = function EditorWarningIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M13.31 5.343l7.359 13.17A1 1 0 0 1 19.796 20H4.204a1 1 0 0 1-.873-1.488l7.36-13.169a1.5 1.5 0 0 1 2.618 0zM12 8.5a1.091 1.091 0 0 0-1.081 1.239l.513 3.766a.573.573 0 0 0 1.136 0l.513-3.766A1.091 1.091 0 0 0 12 8.5zm0 8.63a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorWarningIcon.displayName = 'EditorWarningIcon';
var _default = EditorWarningIcon;
exports.default = _default;

/***/ }),
/* 2626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorIconWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* tslint:disable:variable-name */


var ErrorIconWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  color: #ff991f;\n"], ["\n  display: flex;\n  color: #ff991f;\n"])));
var templateObject_1;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CardView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_cardLoading__ = __webpack_require__(333);



/**
 * TODO: MS-699 Remove these loaders when CardView is no longer used externally
 */
var CardView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CardView, _super);
    function CardView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            CardView: CardView.CardView,
        };
        return _this;
    }
    CardView.prototype.componentWillMount = function () {
        var _this = this;
        if (!this.state.CardView) {
            __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 3457)).then(function (module) {
                CardView.CardView = module.CardView;
                _this.setState({ CardView: module.CardView });
            });
        }
    };
    CardView.prototype.render = function () {
        var _a = this.props, dimensions = _a.dimensions, mediaItemType = _a.mediaItemType;
        if (!this.state.CardView) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__utils_cardLoading__["a" /* CardLoading */], { dimensions: dimensions, mediaItemType: mediaItemType }));
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](this.state.CardView, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, this.props));
    };
    return CardView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

//# sourceMappingURL=cardViewLoader.js.map

/***/ }),
/* 2628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateIdentifierKey; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_media_card__ = __webpack_require__(556);

var lastKey = 1;
var identifiersMap = new Map();
// Returns the same key given the same Card Identifier.
// This is needed to keep a consistent react element key for lists
// when given different types of objects
var generateIdentifierKey = function (identifier) {
    switch (identifier.mediaItemType) {
        case 'external-image':
            return identifier.dataURI;
        case 'link':
            if (Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_media_card__["c" /* isUrlPreviewIdentifier */])(identifier)) {
                return identifier.url;
            }
            else {
                return identifier.id;
            }
        case 'file':
            if (typeof identifier.id === 'string') {
                return identifier.id;
            }
            else {
                var currentKey = identifiersMap.get(identifier.id);
                if (currentKey) {
                    return currentKey;
                }
                // We want to increment the key before using it
                lastKey++;
                var newKey = "" + lastKey;
                identifiersMap.set(identifier.id, newKey);
                return newKey;
            }
    }
};
//# sourceMappingURL=generateIdentifierKey.js.map

/***/ }),
/* 2629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorCloseIcon = function EditorCloseIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M15.185 7.4l-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.508.508 0 0 0-.36-.153.5.5 0 0 0-.353.15z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorCloseIcon.displayName = 'EditorCloseIcon';
var _default = EditorCloseIcon;
exports.default = _default;

/***/ }),
/* 2630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReactMediaSingleNode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nodeviews_ReactNodeView__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__media__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__width__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_base_pm_plugins_react_nodeview__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_ResizableMediaSingle__ = __webpack_require__(2631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__plugins_grid__ = __webpack_require__(298);














var DEFAULT_WIDTH = 250;
var DEFAULT_HEIGHT = 200;
var MediaSingleNode = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MediaSingleNode, _super);
    function MediaSingleNode(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            height: undefined,
            width: undefined,
            lastMediaStatus: undefined,
        };
        _this.onExternalImageLoaded = function (_a) {
            var width = _a.width, height = _a.height;
            _this.setState({
                width: width,
                height: height,
            }, function () {
                _this.forceUpdate();
            });
        };
        _this.getMediaNodeStatus = function (childNode) {
            if (childNode) {
                var state = _this.mediaPluginState.getMediaNodeState(childNode.attrs.__key);
                return state && state.status;
            }
            return undefined;
        };
        _this.hasMediaStateUpdated = function (nextProps) {
            return (_this.getMediaNodeStatus(nextProps.node.firstChild) !==
                _this.state.lastMediaStatus);
        };
        _this.mediaChildHasUpdated = function (nextProps) {
            if (!_this.props.node.firstChild || !nextProps.node.firstChild) {
                return false;
            }
            return (_this.props.node.firstChild.attrs.collection !==
                nextProps.node.firstChild.attrs.collection ||
                _this.props.node.firstChild.attrs.id !== nextProps.node.firstChild.attrs.id);
        };
        _this.selectMediaSingle = function (_a) {
            var event = _a.event;
            // We need to call "stopPropagation" here in order to prevent the browser from navigating to
            // another URL if the media node is wrapped in a link mark.
            event.stopPropagation();
            Object(__WEBPACK_IMPORTED_MODULE_10__utils__["G" /* setNodeSelection */])(_this.props.view, _this.props.getPos() + 1);
        };
        _this.updateSize = function (width, layout) {
            var _a = _this.props.view, state = _a.state, dispatch = _a.dispatch;
            var pos = _this.props.getPos();
            if (typeof pos === 'undefined') {
                return;
            }
            return dispatch(state.tr.setNodeMarkup(pos, undefined, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, _this.props.node.attrs, { layout: layout,
                width: width })));
        };
        _this.mediaPluginState = __WEBPACK_IMPORTED_MODULE_4__pm_plugins_main__["b" /* stateKey */].getState(_this.props.view.state);
        return _this;
    }
    MediaSingleNode.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (this.props.node.attrs.width !== nextProps.node.attrs.width ||
            this.props.selected() !== nextProps.selected() ||
            this.props.node.attrs.layout !== nextProps.node.attrs.layout ||
            this.props.width !== nextProps.width ||
            this.props.lineLength !== nextProps.lineLength ||
            this.props.getPos !== nextProps.getPos ||
            this.mediaChildHasUpdated(nextProps) ||
            this.hasMediaStateUpdated(nextProps)) {
            return true;
        }
        return false;
    };
    MediaSingleNode.prototype.componentDidUpdate = function () {
        var layout = this.props.node.attrs.layout;
        if (this.props.selected()) {
            this.mediaPluginState.updateLayout(layout);
        }
        this.setState({
            lastMediaStatus: this.getMediaNodeStatus(this.props.node.firstChild),
        });
    };
    MediaSingleNode.prototype.render = function () {
        var _this = this;
        var _a = this.props, selected = _a.selected, getPos = _a.getPos, node = _a.node, state = _a.view.state, editorAppearance = _a.editorAppearance;
        var lastMediaStatus = this.state.lastMediaStatus;
        var _b = node.attrs, layout = _b.layout, mediaSingleWidth = _b.width;
        var childNode = node.firstChild;
        var _c = childNode.attrs, width = _c.width, height = _c.height, type = _c.type;
        if (type === 'external') {
            var _d = this.state, stateWidth = _d.width, stateHeight = _d.height;
            if (width === null) {
                width = stateWidth || DEFAULT_WIDTH;
            }
            if (height === null) {
                height = stateHeight || DEFAULT_HEIGHT;
            }
        }
        var isLoading = lastMediaStatus ? lastMediaStatus !== 'ready' : false;
        var canResize = !!this.mediaPluginState.options.allowResizing && !isLoading;
        var pos = getPos();
        if (pos) {
            var $pos = state.doc.resolve(pos);
            var _e = state.schema.nodes, table = _e.table, layoutSection = _e.layoutSection;
            var disabledNode = !!Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findParentNodeOfTypeClosestToPos"])($pos, [
                table,
                layoutSection,
            ]);
            canResize = canResize && !disabledNode;
        }
        if (width === null || height === null) {
            width = DEFAULT_WIDTH;
            height = DEFAULT_HEIGHT;
        }
        var cardWidth = this.props.width;
        var cardHeight = (height / width) * cardWidth;
        var cardDimensions = {
            width: cardWidth + "px",
            height: cardHeight + "px",
        };
        var props = {
            layout: layout,
            width: width,
            height: height,
            isLoading: isLoading,
            containerWidth: this.props.width,
            lineLength: this.props.lineLength,
            pctWidth: mediaSingleWidth,
        };
        var MediaChild = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["j" /* WithProviders */], { providers: ['mediaProvider'], providerFactory: this.mediaPluginState.options.providerFactory, renderNode: function (_a) {
                var mediaProvider = _a.mediaProvider;
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__media__["c" /* default */], { node: childNode, view: _this.props.view, getPos: _this.props.getPos, cardDimensions: cardDimensions, mediaProvider: mediaProvider, selected: selected(), onClick: _this.selectMediaSingle, onExternalImageLoaded: _this.onExternalImageLoaded, editorAppearance: editorAppearance }));
            } }));
        return canResize ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__ui_ResizableMediaSingle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, props, { getPos: getPos, updateSize: this.updateSize, displayGrid: Object(__WEBPACK_IMPORTED_MODULE_12__plugins_grid__["b" /* createDisplayGrid */])(this.props.eventDispatcher), gridSize: 12, state: this.props.view.state, appearance: this.mediaPluginState.options.appearance, selected: this.props.selected() }), MediaChild)) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["c" /* MediaSingle */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, props), MediaChild));
    };
    return MediaSingleNode;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* unused harmony default export */ var _unused_webpack_default_export = (MediaSingleNode);
var MediaSingleNodeView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MediaSingleNodeView, _super);
    function MediaSingleNodeView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MediaSingleNodeView.prototype.render = function (props, forwardRef) {
        var _this = this;
        var _a = this.reactComponentProps, eventDispatcher = _a.eventDispatcher, editorAppearance = _a.editorAppearance;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ui_WithPluginState__["a" /* default */], { editorView: this.view, plugins: {
                width: __WEBPACK_IMPORTED_MODULE_8__width__["b" /* pluginKey */],
                reactNodeViewState: __WEBPACK_IMPORTED_MODULE_9__plugins_base_pm_plugins_react_nodeview__["b" /* stateKey */],
            }, render: function (_a) {
                var width = _a.width, reactNodeViewState = _a.reactNodeViewState;
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MediaSingleNode, { width: width.width, lineLength: width.lineLength, node: _this.node, getPos: _this.getPos, view: _this.view, selected: function () { return _this.getPos() + 1 === reactNodeViewState; }, eventDispatcher: eventDispatcher, editorAppearance: editorAppearance }));
            } }));
    };
    return MediaSingleNodeView;
}(__WEBPACK_IMPORTED_MODULE_5__nodeviews_ReactNodeView__["a" /* default */]));
var ReactMediaSingleNode = function (portalProviderAPI, eventDispatcher, editorAppearance) { return function (node, view, getPos) {
    return new MediaSingleNodeView(node, view, getPos, portalProviderAPI, {
        eventDispatcher: eventDispatcher,
        editorAppearance: editorAppearance,
    }).init();
}; };
//# sourceMappingURL=mediaSingle.js.map

/***/ }),
/* 2631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styled__ = __webpack_require__(2632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Resizer__ = __webpack_require__(2633);






var imageAlignmentMap = {
    left: 'start',
    right: 'end',
};
var ResizableMediaSingle = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ResizableMediaSingle, _super);
    function ResizableMediaSingle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.calcNewSize = function (newWidth, stop) {
            var layout = _this.props.layout;
            var newPct = Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["H" /* calcPctFromPx */])(newWidth, _this.props.lineLength) * 100;
            if (newPct <= 100) {
                var newLayout = void 0;
                if (_this.wrappedLayout && (stop ? newPct !== 100 : true)) {
                    newLayout = layout;
                }
                else {
                    newLayout = 'center';
                }
                return {
                    width: newPct,
                    layout: newLayout,
                };
            }
            else {
                // wide or full-width
                var newLayout = newWidth <= __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["z" /* akEditorWideLayoutWidth */] ? 'wide' : 'full-width';
                return {
                    width: _this.props.pctWidth || null,
                    layout: newLayout,
                };
            }
        };
        _this.calcColumnLeft = function () {
            var offsetLeft = _this.calcOffsetLeft();
            return _this.insideInlineLike
                ? Math.floor(Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["G" /* calcColumnsFromPx */])(offsetLeft, _this.props.lineLength, _this.props.gridSize))
                : 0;
        };
        return _this;
    }
    Object.defineProperty(ResizableMediaSingle.prototype, "wrappedLayout", {
        get: function () {
            var layout = this.props.layout;
            return (layout === 'wrap-left' ||
                layout === 'wrap-right' ||
                layout === 'align-start' ||
                layout === 'align-end');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResizableMediaSingle.prototype, "$pos", {
        get: function () {
            var pos = this.props.getPos();
            if (Number.isNaN(pos) || typeof pos !== 'number') {
                return null;
            }
            return this.props.state.doc.resolve(pos);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResizableMediaSingle.prototype, "gridWidth", {
        /**
         * The maxmimum number of grid columns this node can resize to.
         */
        get: function () {
            var gridSize = this.props.gridSize;
            return !(this.wrappedLayout || this.insideInlineLike)
                ? gridSize / 2
                : gridSize;
        },
        enumerable: true,
        configurable: true
    });
    ResizableMediaSingle.prototype.calcOffsetLeft = function () {
        var offsetLeft = 0;
        if (this.wrapper && this.insideInlineLike) {
            var currentNode = this.wrapper;
            var pm = document.querySelector('.ProseMirror');
            while (currentNode &&
                currentNode.parentElement &&
                !currentNode.parentElement.classList.contains('ProseMirror') &&
                currentNode !== document.body) {
                offsetLeft += currentNode.offsetLeft;
                currentNode = currentNode.parentElement;
            }
            offsetLeft -= pm.offsetLeft;
        }
        return offsetLeft;
    };
    Object.defineProperty(ResizableMediaSingle.prototype, "snapPoints", {
        get: function () {
            var offsetLeft = this.calcOffsetLeft();
            var _a = this.props, containerWidth = _a.containerWidth, lineLength = _a.lineLength, appearance = _a.appearance;
            var snapTargets = [];
            for (var i = 0; i < this.gridWidth; i++) {
                snapTargets.push(Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["I" /* calcPxFromColumns */])(i, lineLength, this.gridWidth) - offsetLeft);
            }
            // full width
            snapTargets.push(lineLength - offsetLeft);
            var minimumWidth = Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["I" /* calcPxFromColumns */])(this.wrappedLayout || this.insideInlineLike ? 1 : 2, lineLength, this.props.gridSize);
            var snapPoints = snapTargets.filter(function (width) { return width >= minimumWidth; });
            var $pos = this.$pos;
            if (!$pos) {
                return snapPoints;
            }
            var isTopLevel = $pos.parent.type.name === 'doc';
            if (isTopLevel && appearance === 'full-page') {
                snapPoints.push(__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["z" /* akEditorWideLayoutWidth */]);
                var fullWidthPoint = containerWidth - __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["k" /* akEditorBreakoutPadding */];
                if (fullWidthPoint > __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["z" /* akEditorWideLayoutWidth */]) {
                    snapPoints.push(fullWidthPoint);
                }
            }
            return snapPoints;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResizableMediaSingle.prototype, "insideInlineLike", {
        get: function () {
            var $pos = this.$pos;
            if (!$pos) {
                return false;
            }
            var _a = this.props.state.schema.nodes, table = _a.table, listItem = _a.listItem;
            return !!Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["findParentNodeOfTypeClosestToPos"])($pos, [table, listItem]);
        },
        enumerable: true,
        configurable: true
    });
    ResizableMediaSingle.prototype.render = function () {
        var _this = this;
        var _a = this.props, origWidth = _a.width, origHeight = _a.height, layout = _a.layout, pctWidth = _a.pctWidth, lineLength = _a.lineLength, containerWidth = _a.containerWidth;
        var pxWidth = origWidth;
        if (layout === 'wide') {
            var wideWidth = lineLength * __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["D" /* breakoutWideScaleRatio */];
            pxWidth = wideWidth > containerWidth ? lineLength : wideWidth;
        }
        else if (layout === 'full-width') {
            pxWidth = containerWidth - __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["k" /* akEditorBreakoutPadding */];
        }
        else if (pctWidth && origWidth && origHeight) {
            pxWidth = Math.ceil(Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["J" /* calcPxFromPct */])(pctWidth / 100, lineLength || containerWidth));
        }
        // scale, keeping aspect ratio
        var height = (origHeight / origWidth) * pxWidth;
        var width = pxWidth;
        var enable = {};
        __WEBPACK_IMPORTED_MODULE_5__Resizer__["b" /* handleSides */].forEach(function (side) {
            var oppositeSide = side === 'left' ? 'right' : 'left';
            enable[side] =
                ['full-width', 'wide', 'center']
                    .concat("wrap-" + oppositeSide)
                    .concat("align-" + imageAlignmentMap[oppositeSide])
                    .indexOf(layout) > -1;
            if (side === 'left' && _this.insideInlineLike) {
                enable[side] = false;
            }
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styled__["a" /* Wrapper */], { width: width, height: height, layout: layout, containerWidth: containerWidth || origWidth, innerRef: function (elem) { return (_this.wrapper = elem); } },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Resizer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, this.props, { width: width, height: height, selected: this.props.selected, enable: enable, calcNewSize: this.calcNewSize, snapPoints: this.snapPoints, scaleFactor: !this.wrappedLayout && !this.insideInlineLike ? 2 : 1, isInlineLike: this.insideInlineLike, getColumnLeft: this.calcColumnLeft }), this.props.children)));
    };
    return ResizableMediaSingle;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ResizableMediaSingle);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);



var Wrapper = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  & > div {\n    ", ";\n    position: relative;\n\n    > div {\n      position: absolute;\n      height: 100%;\n    }\n  }\n\n  & > div::after {\n    content: '';\n    display: block;\n    padding-bottom: ", "%;\n  }\n"], ["\n  & > div {\n    ", ";\n    position: relative;\n\n    > div {\n      position: absolute;\n      height: 100%;\n    }\n  }\n\n  & > div::after {\n    content: '';\n    display: block;\n    padding-bottom: ", "%;\n  }\n"])), __WEBPACK_IMPORTED_MODULE_1__atlaskit_editor_common__["d" /* MediaSingleDimensionHelper */], function (p) { return (p.height / p.width) * 100; });
var templateObject_1;
//# sourceMappingURL=styled.js.map

/***/ }),
/* 2633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleSides; });
/* unused harmony export alignementLayouts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_re_resizable__ = __webpack_require__(2634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__grid__ = __webpack_require__(298);






var handleSides = ['left', 'right'];
var alignementLayouts = [
    'align-start',
    'align-end',
    'wrap-left',
    'wrap-right',
];
var snapTo = function (target, points) {
    return points.reduce(function (point, closest) {
        return Math.abs(closest - target) < Math.abs(point - target)
            ? closest
            : point;
    });
};
var Resizer = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Resizer, _super);
    function Resizer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isResizing: false,
        };
        _this.handleResizeStart = function () {
            _this.setState({ isResizing: true }, function () {
                _this.props.displayGrid(true, Object(__WEBPACK_IMPORTED_MODULE_5__grid__["d" /* gridTypeForLayout */])(_this.props.layout), _this.highlights(_this.props.width));
            });
        };
        _this.handleResize = function (event, direction, elementRef, delta) {
            if (!_this.resizable || !_this.resizable.state.original) {
                return;
            }
            var newWidth = Math.max(_this.resizable.state.original.width +
                delta.width * (_this.props.scaleFactor || 1), _this.props.snapPoints[0]);
            var newSize = _this.props.calcNewSize(newWidth, false);
            if (newSize.layout !== _this.props.layout) {
                _this.props.updateSize(newSize.width, newSize.layout);
            }
            _this.props.displayGrid(true, Object(__WEBPACK_IMPORTED_MODULE_5__grid__["d" /* gridTypeForLayout */])(newSize.layout), _this.highlights(newWidth));
            _this.resizable.updateSize({ width: newWidth, height: 'auto' });
        };
        _this.highlights = function (newWidth) {
            var snapWidth = snapTo(newWidth, _this.props.snapPoints);
            if (snapWidth > __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["z" /* akEditorWideLayoutWidth */]) {
                return ['full-width'];
            }
            var columns = Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["G" /* calcColumnsFromPx */])(snapWidth, _this.props.lineLength, _this.props.gridSize);
            var columnWidth = Math.round(columns);
            var highlight = [];
            if (_this.props.layout === 'wrap-left' ||
                _this.props.layout === 'align-start') {
                highlight.push(0);
                highlight.push(columnWidth);
            }
            else if (_this.props.layout === 'wrap-right' ||
                _this.props.layout === 'align-end') {
                highlight.push(_this.props.gridSize);
                highlight.push(_this.props.gridSize - columnWidth);
            }
            else if (_this.props.isInlineLike) {
                highlight.push(_this.props.getColumnLeft() + Math.ceil(columns));
            }
            else {
                highlight.push(Math.floor((_this.props.gridSize - columnWidth) / 2));
                highlight.push(Math.ceil((_this.props.gridSize + columnWidth) / 2));
            }
            return highlight;
        };
        _this.handleResizeStop = function (event, direction, refToElement, delta) {
            if (!_this.resizable) {
                return;
            }
            if (!_this.resizable.state.original) {
                return;
            }
            var newWidth = Math.max(_this.resizable.state.original.width + delta.width, _this.props.snapPoints[0]);
            var snapWidth = snapTo(newWidth, _this.props.snapPoints);
            var newSize = _this.props.calcNewSize(snapWidth, true);
            // show committed grid size
            _this.props.displayGrid(true, Object(__WEBPACK_IMPORTED_MODULE_5__grid__["d" /* gridTypeForLayout */])(newSize.layout), _this.highlights(newWidth));
            _this.setState({ isResizing: false }, function () {
                _this.props.updateSize(newSize.width, newSize.layout);
                _this.props.displayGrid(false, Object(__WEBPACK_IMPORTED_MODULE_5__grid__["d" /* gridTypeForLayout */])(_this.props.layout));
            });
        };
        _this.setResizableRef = function (ref) {
            _this.resizable = ref;
        };
        return _this;
    }
    Resizer.prototype.render = function () {
        /** equivalent to `calc: (50% - 12px)` from 40:MediaSingle/styled.ts */
        var halfSize = this.props.lineLength * 0.5 - 12;
        var shouldHalfSize = alignementLayouts.indexOf(this.props.layout) > -1 &&
            this.props.width > this.props.lineLength;
        var handleStyles = {};
        var handles = {};
        handleSides.forEach(function (side) {
            var _a;
            handles[side] = "mediaSingle-resize-handle-" + side;
            handleStyles[side] = (_a = {
                    width: '24px'
                },
                _a[side] = '-13px',
                _a.zIndex = 99,
                _a);
        });
        // Ideally, Resizable would let you pass in the component rather than
        // the div. For now, we just apply the same styles using CSS
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_re_resizable__["a" /* default */], { ref: this.setResizableRef, onResize: this.handleResize, size: {
                width: shouldHalfSize ? halfSize : this.props.width || 0,
            }, className: __WEBPACK_IMPORTED_MODULE_2_classnames__('media-single', "image-" + this.props.layout, this.props.className, {
                'is-loading': this.props.isLoading,
                'is-resizing': this.state.isResizing,
                'not-resized': !this.props.pctWidth,
                'mediaSingle-selected': this.props.selected,
                'media-wrapped': this.props.layout === 'wrap-left' ||
                    this.props.layout === 'wrap-right',
            }), handleWrapperClass: 'mediaSingle-resize-wrapper', handleClasses: handles, handleStyles: handleStyles, enable: this.props.enable, onResizeStop: this.handleResizeStop, onResizeStart: this.handleResizeStart }, this.props.children));
    };
    return Resizer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Resizer);
//# sourceMappingURL=Resizer.js.map

/***/ }),
/* 2634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var styles = {
  base: {
    position: 'absolute',
    userSelect: 'none',
    MsUserSelect: 'none'
  },
  top: {
    width: '100%',
    height: '10px',
    top: '-5px',
    left: '0px',
    cursor: 'row-resize'
  },
  right: {
    width: '10px',
    height: '100%',
    top: '0px',
    right: '-5px',
    cursor: 'col-resize'
  },
  bottom: {
    width: '100%',
    height: '10px',
    bottom: '-5px',
    left: '0px',
    cursor: 'row-resize'
  },
  left: {
    width: '10px',
    height: '100%',
    top: '0px',
    left: '-5px',
    cursor: 'col-resize'
  },
  topRight: {
    width: '20px',
    height: '20px',
    position: 'absolute',
    right: '-10px',
    top: '-10px',
    cursor: 'ne-resize'
  },
  bottomRight: {
    width: '20px',
    height: '20px',
    position: 'absolute',
    right: '-10px',
    bottom: '-10px',
    cursor: 'se-resize'
  },
  bottomLeft: {
    width: '20px',
    height: '20px',
    position: 'absolute',
    left: '-10px',
    bottom: '-10px',
    cursor: 'sw-resize'
  },
  topLeft: {
    width: '20px',
    height: '20px',
    position: 'absolute',
    left: '-10px',
    top: '-10px',
    cursor: 'nw-resize'
  }
};

var Resizer = (function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
    'div',
    {
      className: props.className,
      style: _extends({}, styles.base, styles[props.direction], props.replaceStyles || {}),
      onMouseDown: function onMouseDown(e) {
        props.onResizeStart(e, props.direction);
      },
      onTouchStart: function onTouchStart(e) {
        props.onResizeStart(e, props.direction);
      }
    },
    props.children
  );
});

var userSelectNone = {
  userSelect: 'none',
  MozUserSelect: 'none',
  WebkitUserSelect: 'none',
  MsUserSelect: 'none'
};

var userSelectAuto = {
  userSelect: 'auto',
  MozUserSelect: 'auto',
  WebkitUserSelect: 'auto',
  MsUserSelect: 'auto'
};

var clamp = function clamp(n, min, max) {
  return Math.max(Math.min(n, max), min);
};
var snap = function snap(n, size) {
  return Math.round(n / size) * size;
};

var findClosestSnap = function findClosestSnap(n, snapArray) {
  return snapArray.reduce(function (prev, curr) {
    return Math.abs(curr - n) < Math.abs(prev - n) ? curr : prev;
  });
};

var endsWith = function endsWith(str, searchStr) {
  return str.substr(str.length - searchStr.length, searchStr.length) === searchStr;
};

var getStringSize = function getStringSize(n) {
  if (n.toString() === 'auto') return n.toString();
  if (endsWith(n.toString(), 'px')) return n.toString();
  if (endsWith(n.toString(), '%')) return n.toString();
  if (endsWith(n.toString(), 'vh')) return n.toString();
  if (endsWith(n.toString(), 'vw')) return n.toString();
  if (endsWith(n.toString(), 'vmax')) return n.toString();
  if (endsWith(n.toString(), 'vmin')) return n.toString();
  return n + 'px';
};

var definedProps = ['style', 'className', 'grid', 'snap', 'bounds', 'size', 'defaultSize', 'minWidth', 'minHeight', 'maxWidth', 'maxHeight', 'lockAspectRatio', 'lockAspectRatioExtraWidth', 'lockAspectRatioExtraHeight', 'enable', 'handleStyles', 'handleClasses', 'handleWrapperStyle', 'handleWrapperClass', 'children', 'onResizeStart', 'onResize', 'onResizeStop', 'handleComponent', 'scale', 'resizeRatio'];

var baseClassName = '__resizable_base__';

var Resizable = function (_React$Component) {
  inherits(Resizable, _React$Component);

  function Resizable(props) {
    classCallCheck(this, Resizable);

    var _this = possibleConstructorReturn(this, (Resizable.__proto__ || Object.getPrototypeOf(Resizable)).call(this, props));

    _this.state = {
      isResizing: false,
      resizeCursor: 'auto',
      width: typeof (_this.propsSize && _this.propsSize.width) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.width,
      height: typeof (_this.propsSize && _this.propsSize.height) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.height,
      direction: 'right',
      original: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      }
    };

    _this.updateExtendsProps(props);
    _this.onResizeStart = _this.onResizeStart.bind(_this);
    _this.onMouseMove = _this.onMouseMove.bind(_this);
    _this.onMouseUp = _this.onMouseUp.bind(_this);

    if (typeof window !== 'undefined') {
      window.addEventListener('mouseup', _this.onMouseUp);
      window.addEventListener('mousemove', _this.onMouseMove);
      window.addEventListener('mouseleave', _this.onMouseUp);
      window.addEventListener('touchmove', _this.onMouseMove);
      window.addEventListener('touchend', _this.onMouseUp);
    }
    return _this;
  }

  createClass(Resizable, [{
    key: 'updateExtendsProps',
    value: function updateExtendsProps(props) {
      this.extendsProps = Object.keys(props).reduce(function (acc, key) {
        if (definedProps.indexOf(key) !== -1) return acc;
        acc[key] = props[key];
        return acc;
      }, {});
    }
  }, {
    key: 'getParentSize',
    value: function getParentSize() {
      var base = this.base;

      if (!base) return { width: window.innerWidth, height: window.innerHeight };
      // INFO: To calculate parent width with flex layout
      var wrapChanged = false;
      var wrap = this.parentNode.style.flexWrap;
      var minWidth = base.style.minWidth;
      if (wrap !== 'wrap') {
        wrapChanged = true;
        this.parentNode.style.flexWrap = 'wrap';
        // HACK: Use relative to get parent padding size
      }
      base.style.position = 'relative';
      base.style.minWidth = '100%';
      var size = {
        width: base.offsetWidth,
        height: base.offsetHeight
      };
      base.style.position = 'absolute';
      if (wrapChanged) this.parentNode.style.flexWrap = wrap;
      base.style.minWidth = minWidth;
      return size;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var size = this.size;

      this.setState({
        width: this.state.width || size.width,
        height: this.state.height || size.height
      });
      var parent = this.parentNode;
      if (!(parent instanceof HTMLElement)) return;
      if (this.base) return;
      var element = document.createElement('div');
      element.style.width = '100%';
      element.style.height = '100%';
      element.style.position = 'absolute';
      element.style.transform = 'scale(0, 0)';
      element.style.left = '0';
      element.style.flex = '0';
      if (element.classList) {
        element.classList.add(baseClassName);
      } else {
        element.className += baseClassName;
      }
      parent.appendChild(element);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(next) {
      this.updateExtendsProps(next);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('mouseup', this.onMouseUp);
        window.removeEventListener('mousemove', this.onMouseMove);
        window.removeEventListener('mouseleave', this.onMouseUp);
        window.removeEventListener('touchmove', this.onMouseMove);
        window.removeEventListener('touchend', this.onMouseUp);
        var parent = this.parentNode;
        var base = this.base;

        if (!base || !parent) return;
        if (!(parent instanceof HTMLElement) || !(base instanceof Node)) return;
        parent.removeChild(base);
      }
    }
  }, {
    key: 'calculateNewSize',
    value: function calculateNewSize(newSize, kind) {
      var propsSize = this.propsSize && this.propsSize[kind];
      return this.state[kind] === 'auto' && this.state.original[kind] === newSize && (typeof propsSize === 'undefined' || propsSize === 'auto') ? 'auto' : newSize;
    }
  }, {
    key: 'onResizeStart',
    value: function onResizeStart(event, direction) {
      var clientX = 0;
      var clientY = 0;
      if (event.nativeEvent instanceof MouseEvent) {
        clientX = event.nativeEvent.clientX;
        clientY = event.nativeEvent.clientY;

        // When user click with right button the resize is stuck in resizing mode
        // until users clicks again, dont continue if right click is used.
        // HACK: MouseEvent does not have `which` from flow-bin v0.68.
        if (event.nativeEvent.which === 3) {
          return;
        }
      } else if (event.nativeEvent instanceof TouchEvent) {
        clientX = event.nativeEvent.touches[0].clientX;
        clientY = event.nativeEvent.touches[0].clientY;
      }
      if (this.props.onResizeStart) {
        this.props.onResizeStart(event, direction, this.resizable);
      }

      // Fix #168
      if (this.props.size) {
        if (typeof this.props.size.height !== 'undefined' && this.props.size.height !== this.state.height) {
          this.setState({ height: this.props.size.height });
        }
        if (typeof this.props.size.width !== 'undefined' && this.props.size.width !== this.state.width) {
          this.setState({ width: this.props.size.width });
        }
      }

      this.setState({
        original: {
          x: clientX,
          y: clientY,
          width: this.size.width,
          height: this.size.height
        },
        isResizing: true,
        resizeCursor: window.getComputedStyle(event.target).cursor,
        direction: direction
      });
    }
  }, {
    key: 'onMouseMove',
    value: function onMouseMove(event) {
      if (!this.state.isResizing) return;
      var clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
      var clientY = event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;
      var _state = this.state,
          direction = _state.direction,
          original = _state.original,
          width = _state.width,
          height = _state.height;
      var _props = this.props,
          lockAspectRatio = _props.lockAspectRatio,
          lockAspectRatioExtraHeight = _props.lockAspectRatioExtraHeight,
          lockAspectRatioExtraWidth = _props.lockAspectRatioExtraWidth;

      var scale = this.props.scale || 1;
      var _props2 = this.props,
          maxWidth = _props2.maxWidth,
          maxHeight = _props2.maxHeight,
          minWidth = _props2.minWidth,
          minHeight = _props2.minHeight;

      var resizeRatio = this.props.resizeRatio || 1;

      // TODO: refactor
      var parentSize = this.getParentSize();
      if (maxWidth && typeof maxWidth === 'string' && endsWith(maxWidth, '%')) {
        var _ratio = Number(maxWidth.replace('%', '')) / 100;
        maxWidth = parentSize.width * _ratio;
      }
      if (maxHeight && typeof maxHeight === 'string' && endsWith(maxHeight, '%')) {
        var _ratio2 = Number(maxHeight.replace('%', '')) / 100;
        maxHeight = parentSize.height * _ratio2;
      }
      if (minWidth && typeof minWidth === 'string' && endsWith(minWidth, '%')) {
        var _ratio3 = Number(minWidth.replace('%', '')) / 100;
        minWidth = parentSize.width * _ratio3;
      }
      if (minHeight && typeof minHeight === 'string' && endsWith(minHeight, '%')) {
        var _ratio4 = Number(minHeight.replace('%', '')) / 100;
        minHeight = parentSize.height * _ratio4;
      }
      maxWidth = typeof maxWidth === 'undefined' ? undefined : Number(maxWidth);
      maxHeight = typeof maxHeight === 'undefined' ? undefined : Number(maxHeight);
      minWidth = typeof minWidth === 'undefined' ? undefined : Number(minWidth);
      minHeight = typeof minHeight === 'undefined' ? undefined : Number(minHeight);

      var ratio = typeof lockAspectRatio === 'number' ? lockAspectRatio : original.width / original.height;
      var newWidth = original.width;
      var newHeight = original.height;
      if (/right/i.test(direction)) {
        newWidth = original.width + (clientX - original.x) * resizeRatio / scale;
        if (lockAspectRatio) newHeight = (newWidth - lockAspectRatioExtraWidth) / ratio + lockAspectRatioExtraHeight;
      }
      if (/left/i.test(direction)) {
        newWidth = original.width - (clientX - original.x) * resizeRatio / scale;
        if (lockAspectRatio) newHeight = (newWidth - lockAspectRatioExtraWidth) / ratio + lockAspectRatioExtraHeight;
      }
      if (/bottom/i.test(direction)) {
        newHeight = original.height + (clientY - original.y) * resizeRatio / scale;
        if (lockAspectRatio) newWidth = (newHeight - lockAspectRatioExtraHeight) * ratio + lockAspectRatioExtraWidth;
      }
      if (/top/i.test(direction)) {
        newHeight = original.height - (clientY - original.y) * resizeRatio / scale;
        if (lockAspectRatio) newWidth = (newHeight - lockAspectRatioExtraHeight) * ratio + lockAspectRatioExtraWidth;
      }

      if (this.props.bounds === 'parent') {
        var parent = this.parentNode;
        if (parent instanceof HTMLElement) {
          var parentRect = parent.getBoundingClientRect();
          var parentLeft = parentRect.left;
          var parentTop = parentRect.top;

          var _resizable$getBoundin = this.resizable.getBoundingClientRect(),
              _left = _resizable$getBoundin.left,
              _top = _resizable$getBoundin.top;

          var boundWidth = parent.offsetWidth + (parentLeft - _left);
          var boundHeight = parent.offsetHeight + (parentTop - _top);
          maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
          maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
        }
      } else if (this.props.bounds === 'window') {
        if (typeof window !== 'undefined') {
          var _resizable$getBoundin2 = this.resizable.getBoundingClientRect(),
              _left2 = _resizable$getBoundin2.left,
              _top2 = _resizable$getBoundin2.top;

          var _boundWidth = window.innerWidth - _left2;
          var _boundHeight = window.innerHeight - _top2;
          maxWidth = maxWidth && maxWidth < _boundWidth ? maxWidth : _boundWidth;
          maxHeight = maxHeight && maxHeight < _boundHeight ? maxHeight : _boundHeight;
        }
      } else if (this.props.bounds instanceof HTMLElement) {
        var targetRect = this.props.bounds.getBoundingClientRect();
        var targetLeft = targetRect.left;
        var targetTop = targetRect.top;

        var _resizable$getBoundin3 = this.resizable.getBoundingClientRect(),
            _left3 = _resizable$getBoundin3.left,
            _top3 = _resizable$getBoundin3.top;

        if (!(this.props.bounds instanceof HTMLElement)) return;
        var _boundWidth2 = this.props.bounds.offsetWidth + (targetLeft - _left3);
        var _boundHeight2 = this.props.bounds.offsetHeight + (targetTop - _top3);
        maxWidth = maxWidth && maxWidth < _boundWidth2 ? maxWidth : _boundWidth2;
        maxHeight = maxHeight && maxHeight < _boundHeight2 ? maxHeight : _boundHeight2;
      }

      var computedMinWidth = typeof minWidth === 'undefined' ? 10 : minWidth;
      var computedMaxWidth = typeof maxWidth === 'undefined' || maxWidth < 0 ? newWidth : maxWidth;
      var computedMinHeight = typeof minHeight === 'undefined' ? 10 : minHeight;
      var computedMaxHeight = typeof maxHeight === 'undefined' || maxHeight < 0 ? newHeight : maxHeight;

      if (lockAspectRatio) {
        var extraMinWidth = (computedMinHeight - lockAspectRatioExtraHeight) * ratio + lockAspectRatioExtraWidth;
        var extraMaxWidth = (computedMaxHeight - lockAspectRatioExtraHeight) * ratio + lockAspectRatioExtraWidth;
        var extraMinHeight = (computedMinWidth - lockAspectRatioExtraWidth) / ratio + lockAspectRatioExtraHeight;
        var extraMaxHeight = (computedMaxWidth - lockAspectRatioExtraWidth) / ratio + lockAspectRatioExtraHeight;
        var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
        var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
        var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
        var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
        newWidth = clamp(newWidth, lockedMinWidth, lockedMaxWidth);
        newHeight = clamp(newHeight, lockedMinHeight, lockedMaxHeight);
      } else {
        newWidth = clamp(newWidth, computedMinWidth, computedMaxWidth);
        newHeight = clamp(newHeight, computedMinHeight, computedMaxHeight);
      }
      if (this.props.grid) {
        newWidth = snap(newWidth, this.props.grid[0]);
      }
      if (this.props.grid) {
        newHeight = snap(newHeight, this.props.grid[1]);
      }

      if (this.props.snap && this.props.snap.x) {
        newWidth = findClosestSnap(newWidth, this.props.snap.x);
      }
      if (this.props.snap && this.props.snap.y) {
        newHeight = findClosestSnap(newHeight, this.props.snap.y);
      }

      var delta = {
        width: newWidth - original.width,
        height: newHeight - original.height
      };

      if (width && typeof width === 'string' && endsWith(width, '%')) {
        var percent = newWidth / parentSize.width * 100;
        newWidth = percent + '%';
      }

      if (height && typeof height === 'string' && endsWith(height, '%')) {
        var _percent = newHeight / parentSize.height * 100;
        newHeight = _percent + '%';
      }

      this.setState({
        width: this.calculateNewSize(newWidth, 'width'),
        height: this.calculateNewSize(newHeight, 'height')
      });

      if (this.props.onResize) {
        this.props.onResize(event, direction, this.resizable, delta);
      }
    }
  }, {
    key: 'onMouseUp',
    value: function onMouseUp(event) {
      var _state2 = this.state,
          isResizing = _state2.isResizing,
          direction = _state2.direction,
          original = _state2.original;

      if (!isResizing) return;
      var delta = {
        width: this.size.width - original.width,
        height: this.size.height - original.height
      };
      if (this.props.onResizeStop) {
        this.props.onResizeStop(event, direction, this.resizable, delta);
      }
      if (this.props.size) {
        this.setState(this.props.size);
      }
      this.setState({ isResizing: false, resizeCursor: 'auto' });
    }
  }, {
    key: 'updateSize',
    value: function updateSize(size) {
      this.setState({ width: size.width, height: size.height });
    }
  }, {
    key: 'renderResizer',
    value: function renderResizer() {
      var _this2 = this;

      var _props3 = this.props,
          enable = _props3.enable,
          handleStyles = _props3.handleStyles,
          handleClasses = _props3.handleClasses,
          handleWrapperStyle = _props3.handleWrapperStyle,
          handleWrapperClass = _props3.handleWrapperClass,
          handleComponent = _props3.handleComponent;

      if (!enable) return null;
      var resizers = Object.keys(enable).map(function (dir) {
        if (enable[dir] !== false) {
          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
            Resizer,
            {
              key: dir,
              direction: dir,
              onResizeStart: _this2.onResizeStart,
              replaceStyles: handleStyles && handleStyles[dir],
              className: handleClasses && handleClasses[dir]
            },
            handleComponent && handleComponent[dir] ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(handleComponent[dir]) : null
          );
        }
        return null;
      });
      // #93 Wrap the resize box in span (will not break 100% width/height)
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        'span',
        { className: handleWrapperClass, style: handleWrapperStyle },
        resizers
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var userSelect = this.state.isResizing ? userSelectNone : userSelectAuto;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(
        'div',
        _extends({
          ref: function ref(c) {
            if (c) {
              _this3.resizable = c;
            }
          },
          style: _extends({
            position: 'relative'
          }, userSelect, this.props.style, this.sizeStyle, {
            maxWidth: this.props.maxWidth,
            maxHeight: this.props.maxHeight,
            minWidth: this.props.minWidth,
            minHeight: this.props.minHeight,
            boxSizing: 'border-box'
          }),
          className: this.props.className
        }, this.extendsProps),
        this.state.isResizing && Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])('div', {
          style: {
            height: '100%',
            width: '100%',
            backgroundColor: 'rgba(0,0,0,0)',
            cursor: '' + (this.state.resizeCursor || 'auto'),
            opacity: '0',
            position: 'fixed',
            zIndex: '9999',
            top: '0',
            left: '0',
            bottom: '0',
            right: '0'
          }
        }),
        this.props.children,
        this.renderResizer()
      );
    }
  }, {
    key: 'parentNode',
    get: function get$$1() {
      return this.resizable.parentNode;
    }
  }, {
    key: 'propsSize',
    get: function get$$1() {
      return this.props.size || this.props.defaultSize;
    }
  }, {
    key: 'base',
    get: function get$$1() {
      var parent = this.parentNode;
      if (!parent) return undefined;
      var children = [].slice.call(parent.children);
      for (var i = 0; i < children.length; i += 1) {
        var n = children[i];
        if (n instanceof HTMLElement) {
          if (n.classList.contains(baseClassName)) {
            return n;
          }
        }
      }
      return undefined;
    }
  }, {
    key: 'size',
    get: function get$$1() {
      var width = 0;
      var height = 0;
      if (typeof window !== 'undefined') {
        var orgWidth = this.resizable.offsetWidth;
        var orgHeight = this.resizable.offsetHeight;
        // HACK: Set position `relative` to get parent size.
        //       This is because when re-resizable set `absolute`, I can not get base width correctly.
        var orgPosition = this.resizable.style.position;
        if (orgPosition !== 'relative') {
          this.resizable.style.position = 'relative';
        }
        // INFO: Use original width or height if set auto.
        width = this.resizable.style.width !== 'auto' ? this.resizable.offsetWidth : orgWidth;
        height = this.resizable.style.height !== 'auto' ? this.resizable.offsetHeight : orgHeight;
        // Restore original position
        this.resizable.style.position = orgPosition;
      }
      return { width: width, height: height };
    }
  }, {
    key: 'sizeStyle',
    get: function get$$1() {
      var _this4 = this;

      var size = this.props.size;

      var getSize = function getSize(key) {
        if (typeof _this4.state[key] === 'undefined' || _this4.state[key] === 'auto') return 'auto';
        if (_this4.propsSize && _this4.propsSize[key] && endsWith(_this4.propsSize[key].toString(), '%')) {
          if (endsWith(_this4.state[key].toString(), '%')) return _this4.state[key].toString();
          var parentSize = _this4.getParentSize();
          var value = Number(_this4.state[key].toString().replace('px', ''));
          var percent = value / parentSize[key] * 100;
          return percent + '%';
        }
        return getStringSize(_this4.state[key]);
      };
      var width = size && typeof size.width !== 'undefined' && !this.state.isResizing ? getStringSize(size.width) : getSize('width');
      var height = size && typeof size.height !== 'undefined' && !this.state.isResizing ? getStringSize(size.height) : getSize('height');
      return { width: width, height: height };
    }
  }]);
  return Resizable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Resizable.defaultProps = {
  onResizeStart: function onResizeStart() {},
  onResize: function onResize() {},
  onResizeStop: function onResizeStop() {},
  enable: {
    top: true,
    right: true,
    bottom: true,
    left: true,
    topRight: true,
    bottomRight: true,
    bottomLeft: true,
    topLeft: true
  },
  style: {},
  grid: [1, 1],
  lockAspectRatio: false,
  lockAspectRatioExtraWidth: 0,
  lockAspectRatioExtraHeight: 0,
  scale: 1,
  resizeRatio: 1
};

/* harmony default export */ __webpack_exports__["a"] = (Resizable);


/***/ }),
/* 2635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_info__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_warning__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_error__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_success__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_success___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_success__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_note__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_note__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__block_type_types__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pm_plugins_main__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__toolbar__ = __webpack_require__(2638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pm_plugins_keymaps__ = __webpack_require__(2640);











var insertPanelType = function (panelType, state) {
    return state.schema.nodes.panel.createChecked({ panelType: panelType }, state.schema.nodes.paragraph.createChecked());
};
var panelPlugin = {
    nodes: function () {
        return [{ name: 'panel', node: __WEBPACK_IMPORTED_MODULE_6__atlaskit_adf_schema__["Z" /* panel */] }];
    },
    pmPlugins: function () {
        return [
            { name: 'panel', plugin: __WEBPACK_IMPORTED_MODULE_8__pm_plugins_main__["a" /* createPlugin */] },
            {
                name: 'panelKeyMap',
                plugin: function () { return Object(__WEBPACK_IMPORTED_MODULE_10__pm_plugins_keymaps__["a" /* default */])(); },
            },
        ];
    },
    pluginsOptions: {
        quickInsert: function (_a) {
            var formatMessage = _a.formatMessage;
            return [
                {
                    title: formatMessage(__WEBPACK_IMPORTED_MODULE_7__block_type_types__["p" /* messages */].panel),
                    keywords: ['info'],
                    priority: 900,
                    icon: function () { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_info___default.a, { label: formatMessage(__WEBPACK_IMPORTED_MODULE_7__block_type_types__["p" /* messages */].panel) }); },
                    action: function (insert, state) {
                        return insert(insertPanelType('info', state));
                    },
                },
                {
                    title: formatMessage(__WEBPACK_IMPORTED_MODULE_7__block_type_types__["p" /* messages */].notePanel),
                    keywords: ['note'],
                    priority: 1000,
                    icon: function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_note___default.a, { label: formatMessage(__WEBPACK_IMPORTED_MODULE_7__block_type_types__["p" /* messages */].notePanel) })); },
                    action: function (insert, state) {
                        return insert(insertPanelType('note', state));
                    },
                },
                {
                    title: formatMessage(__WEBPACK_IMPORTED_MODULE_7__block_type_types__["p" /* messages */].successPanel),
                    keywords: ['success', 'tip'],
                    priority: 1000,
                    icon: function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_success___default.a, { label: formatMessage(__WEBPACK_IMPORTED_MODULE_7__block_type_types__["p" /* messages */].successPanel) })); },
                    action: function (insert, state) {
                        return insert(insertPanelType('success', state));
                    },
                },
                {
                    title: formatMessage(__WEBPACK_IMPORTED_MODULE_7__block_type_types__["p" /* messages */].warningPanel),
                    keywords: ['warning'],
                    priority: 1000,
                    icon: function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_warning___default.a, { label: formatMessage(__WEBPACK_IMPORTED_MODULE_7__block_type_types__["p" /* messages */].warningPanel) })); },
                    action: function (insert, state) {
                        return insert(insertPanelType('warning', state));
                    },
                },
                {
                    title: formatMessage(__WEBPACK_IMPORTED_MODULE_7__block_type_types__["p" /* messages */].errorPanel),
                    keywords: ['error'],
                    priority: 1000,
                    icon: function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_error___default.a, { label: formatMessage(__WEBPACK_IMPORTED_MODULE_7__block_type_types__["p" /* messages */].errorPanel) })); },
                    action: function (insert, state) {
                        return insert(insertPanelType('error', state));
                    },
                },
            ];
        },
        floatingToolbar: __WEBPACK_IMPORTED_MODULE_9__toolbar__["a" /* getToolbarConfig */],
    },
};
/* harmony default export */ __webpack_exports__["a"] = (panelPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return panelNodeView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_info__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_success__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_success___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_success__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_note__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_note__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_warning__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_error__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_hint__ = __webpack_require__(2637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_hint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_hint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__nodeviews_ReactNodeView__ = __webpack_require__(162);










var G50 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].G50, P50 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].P50, B50 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B50, Y50 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].Y50, R50 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R50, G400 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].G400, P400 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].P400, B400 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B400, Y400 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].Y400, R400 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R400;
var panelColor = {
    info: B50,
    note: P50,
    tip: G50,
    success: G50,
    warning: Y50,
    error: R50,
};
var iconColor = {
    info: B400,
    note: P400,
    tip: G400,
    success: G400,
    warning: Y400,
    error: R400,
};
var panelIcons = {
    info: __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_info___default.a,
    success: __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_success___default.a,
    note: __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_note___default.a,
    tip: __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_editor_hint___default.a,
    warning: __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_warning___default.a,
    error: __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_error___default.a,
};
var PanelComponent = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](PanelComponent, _super);
    function PanelComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PanelComponent.prototype.shouldComponentUpdate = function (nextProps) {
        return this.props.panelType !== nextProps.panelType;
    };
    PanelComponent.prototype.render = function () {
        var _a = this.props, panelType = _a.panelType, forwardRef = _a.forwardRef;
        var Icon = panelIcons[panelType];
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: { background: panelColor[panelType] }, className: "ak-editor-panel" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { style: { color: iconColor[panelType] }, className: "ak-editor-panel__icon" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Icon, { label: "Panel " + panelType })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "ak-editor-panel__content", ref: forwardRef })));
    };
    return PanelComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
var Panel = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Panel, _super);
    function Panel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Panel.prototype.createDomRef = function () {
        var domRef = document.createElement('div');
        domRef.setAttribute('data-panel-type', this.node.attrs.panelType);
        return domRef;
    };
    Panel.prototype.getContentDOM = function () {
        var dom = document.createElement('div');
        dom.className = 'panel-content-dom';
        return { dom: dom };
    };
    Panel.prototype.render = function (props, forwardRef) {
        var panelType = this.node.attrs.panelType;
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](PanelComponent, { panelType: panelType, forwardRef: forwardRef });
    };
    Panel.prototype.update = function (node, decorations) {
        return _super.prototype.update.call(this, node, decorations, function (currentNode, newNode) {
            return currentNode.attrs.panelType === newNode.attrs.panelType;
        });
    };
    return Panel;
}(__WEBPACK_IMPORTED_MODULE_9__nodeviews_ReactNodeView__["a" /* default */]));
var panelNodeView = function (portalProviderAPI) { return function (node, view, getPos) {
    return new Panel(node, view, getPos, portalProviderAPI).init();
}; };
//# sourceMappingURL=panel.js.map

/***/ }),
/* 2637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorHintIcon = function EditorHintIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M14 16h-4s0-.5-1-2-2.5-3-2.5-5S7 4 12 4s5.5 3 5.5 5-1.5 3.5-2.5 5-1 2-1 2zm-4 1h4v1l-1.5 2h-1L10 18v-1z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorHintIcon.displayName = 'EditorHintIcon';
var _default = EditorHintIcon;
exports.default = _default;

/***/ }),
/* 2638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export messages */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getToolbarConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_success__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_success___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_success__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_info__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_note__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_note__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_remove__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_remove__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_warning__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_error__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__messages__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(2639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pm_plugins_main__ = __webpack_require__(858);










var messages = Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["defineMessages"])({
    info: {
        id: 'fabric.editor.info',
        defaultMessage: 'Info',
        description: 'Panels provide a way to highlight text. The info panel has a blue background.',
    },
    note: {
        id: 'fabric.editor.note',
        defaultMessage: 'Note',
        description: 'Panels provide a way to highlight text. The note panel has a purple background.',
    },
    success: {
        id: 'fabric.editor.success',
        defaultMessage: 'Success',
        description: 'Panels provide a way to highlight text. The success panel has a green background.',
    },
    warning: {
        id: 'fabric.editor.warning',
        defaultMessage: 'Warning',
        description: 'Panels provide a way to highlight text. The warning panel has a yellow background.',
    },
    error: {
        id: 'fabric.editor.error',
        defaultMessage: 'Error',
        description: 'Panels provide a way to highlight text. The error panel has a red background.',
    },
});
var getToolbarConfig = function (state, _a) {
    var formatMessage = _a.formatMessage;
    var panelState = __WEBPACK_IMPORTED_MODULE_9__pm_plugins_main__["b" /* pluginKey */].getState(state);
    if (panelState && panelState.toolbarVisible && panelState.element) {
        var activePanelType = panelState.activePanelType;
        return {
            title: 'Panel floating controls',
            getDomRef: function () { return panelState.element; },
            nodeType: state.schema.nodes.panel,
            items: [
                {
                    type: 'button',
                    icon: __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_info___default.a,
                    onClick: Object(__WEBPACK_IMPORTED_MODULE_8__actions__["a" /* changePanelType */])('info'),
                    selected: activePanelType === 'info',
                    title: formatMessage(messages.info),
                },
                {
                    type: 'button',
                    icon: __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_note___default.a,
                    onClick: Object(__WEBPACK_IMPORTED_MODULE_8__actions__["a" /* changePanelType */])('note'),
                    selected: activePanelType === 'note',
                    title: formatMessage(messages.note),
                },
                {
                    type: 'button',
                    icon: __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_success___default.a,
                    onClick: Object(__WEBPACK_IMPORTED_MODULE_8__actions__["a" /* changePanelType */])('success'),
                    selected: activePanelType === 'success',
                    title: formatMessage(messages.success),
                },
                {
                    type: 'button',
                    icon: __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_warning___default.a,
                    onClick: Object(__WEBPACK_IMPORTED_MODULE_8__actions__["a" /* changePanelType */])('warning'),
                    selected: activePanelType === 'warning',
                    title: formatMessage(messages.warning),
                },
                {
                    type: 'button',
                    icon: __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_error___default.a,
                    onClick: Object(__WEBPACK_IMPORTED_MODULE_8__actions__["a" /* changePanelType */])('error'),
                    selected: activePanelType === 'error',
                    title: formatMessage(messages.error),
                },
                {
                    type: 'separator',
                },
                {
                    type: 'button',
                    appearance: 'danger',
                    icon: __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_remove___default.a,
                    onClick: Object(__WEBPACK_IMPORTED_MODULE_8__actions__["b" /* removePanel */])(),
                    title: formatMessage(__WEBPACK_IMPORTED_MODULE_7__messages__["a" /* default */].remove),
                },
            ],
        };
    }
};
//# sourceMappingURL=toolbar.js.map

/***/ }),
/* 2639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return removePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changePanelType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__analytics__ = __webpack_require__(20);


var removePanel = function () { return function (state, dispatch) {
    var nodes = state.schema.nodes, tr = state.tr;
    __WEBPACK_IMPORTED_MODULE_1__analytics__["a" /* analyticsService */].trackEvent("atlassian.editor.format.panel.delete.button");
    if (dispatch) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["removeParentNodeOfType"])(nodes.panel)(tr));
    }
    return true;
}; };
var changePanelType = function (panelType) { return function (state, dispatch) {
    var nodes = state.schema.nodes, tr = state.tr;
    __WEBPACK_IMPORTED_MODULE_1__analytics__["a" /* analyticsService */].trackEvent("atlassian.editor.format.panel." + panelType + ".button");
    if (dispatch) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["setParentNodeMarkup"])(nodes.panel, null, { panelType: panelType })(tr));
    }
    return true;
}; };
//# sourceMappingURL=actions.js.map

/***/ }),
/* 2640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export keymapPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__);


function keymapPlugin() {
    var deleteCurrentItem = function ($from, tr) {
        return tr.delete($from.before($from.depth) - 1, $from.end($from.depth) + 1);
    };
    var keymaps = {
        Backspace: function (state, dispatch) {
            var selection = state.selection, nodes = state.schema.nodes, tr = state.tr;
            var panel = nodes.panel;
            var $from = selection.$from, $to = selection.$to;
            // Don't do anything if selection is a range
            if ($from.pos !== $to.pos) {
                return false;
            }
            // If not at the start of a panel, no joining will happen so allow default behaviour (backspacing characters etc..)
            if ($from.parentOffset !== 0) {
                return false;
            }
            var previousPos = tr.doc.resolve(Math.max(0, $from.before($from.depth) - 1));
            var previousNodeType = previousPos.pos > 0 && previousPos.parent && previousPos.parent.type;
            var parentNodeType = $from.parent.type;
            var isPreviousNodeAPanel = previousNodeType === panel;
            var isParentNodeAPanel = parentNodeType === panel;
            // Stops merging panels when deleting empty paragraph in between
            if (isPreviousNodeAPanel && !isParentNodeAPanel) {
                var content = $from.node($from.depth).content;
                var insertPos = previousPos.pos - 1;
                deleteCurrentItem($from, tr).insert(insertPos, content);
                dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_utils__["setTextSelection"])(insertPos)(tr).scrollIntoView());
                return true;
            }
            var nodeType = $from.node().type;
            if (nodeType !== panel) {
                return false;
            }
            return true;
        },
    };
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__["keymap"])(keymaps);
}
/* harmony default export */ __webpack_exports__["a"] = (keymapPlugin);
//# sourceMappingURL=keymaps.js.map

/***/ }),
/* 2641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__ = __webpack_require__(2642);

var paste = {
    pmPlugins: function () {
        return [
            {
                name: 'paste',
                plugin: function (_a) {
                    var schema = _a.schema, props = _a.props;
                    return Object(__WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__["a" /* createPlugin */])(schema, props.appearance);
                },
            },
        ];
    },
};
/* harmony default export */ __webpack_exports__["a"] = (paste);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stateKey */
/* harmony export (immutable) */ __webpack_exports__["a"] = createPlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_markdown_it__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_markdown_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_markdown_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_tables__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_history__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_history___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prosemirror_history__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_editor_markdown_transformer__ = __webpack_require__(2691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_clipboard__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__media_utils_media_single__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__linkify_md_plugin__ = __webpack_require__(2696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__extension_actions__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__layout_utils__ = __webpack_require__(2697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hyperlink_utils__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__table_pm_plugins_main__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__table_utils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__table_actions__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__handlers__ = __webpack_require__(2698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__code_block_utils__ = __webpack_require__(2699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__card_pm_plugins_doc__ = __webpack_require__(454);

// @ts-ignore




















var stateKey = new __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["PluginKey"]('pastePlugin');
function createPlugin(schema, editorAppearance) {
    var md = __WEBPACK_IMPORTED_MODULE_0_markdown_it__('zero', { html: false });
    md.enable([
        // Process html entity - &#123;, &#xAF;, &quot;, ...
        'entity',
        // Process escaped chars and hardbreaks
        'escape',
        'newline',
    ]);
    // enable modified version of linkify plugin
    // @see https://product-fabric.atlassian.net/browse/ED-3097
    md.use(__WEBPACK_IMPORTED_MODULE_10__linkify_md_plugin__["a" /* default */]);
    var atlassianMarkDownParser = new __WEBPACK_IMPORTED_MODULE_6__atlaskit_editor_markdown_transformer__["a" /* MarkdownTransformer */](schema, md);
    return new __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["Plugin"]({
        key: stateKey,
        props: {
            handlePaste: function (view, rawEvent, slice) {
                var event = rawEvent;
                if (!event.clipboardData) {
                    return false;
                }
                var text = event.clipboardData.getData('text/plain');
                var html = event.clipboardData.getData('text/html');
                // Bail if copied content has files
                if (__WEBPACK_IMPORTED_MODULE_8__utils_clipboard__["a" /* isPastedFile */](event)) {
                    if (!html) {
                        return true;
                    }
                    /**
                     * Microsoft Office, Number, Pages, etc. adds an image to clipboard
                     * with other mime-types so we don't let the event reach media
                     */
                    event.stopPropagation();
                }
                var state = view.state, dispatch = view.dispatch;
                var _a = state.schema.nodes, codeBlock = _a.codeBlock, media = _a.media, decisionItem = _a.decisionItem, taskItem = _a.taskItem;
                if (Object(__WEBPACK_IMPORTED_MODULE_18__handlers__["b" /* handlePasteAsPlainText */])(slice, event)(state, dispatch, view)) {
                    return true;
                }
                // send analytics
                if (Object(__WEBPACK_IMPORTED_MODULE_5_prosemirror_utils__["hasParentNodeOfType"])([decisionItem, taskItem])(state.selection)) {
                    __WEBPACK_IMPORTED_MODULE_7__analytics__["a" /* analyticsService */].trackEvent('atlassian.fabric.action-decision.editor.paste');
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_7__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.paste', {
                        source: Object(__WEBPACK_IMPORTED_MODULE_11__util__["b" /* getPasteSource */])(event),
                    });
                }
                var markdownSlice;
                if (text && !html) {
                    var doc = atlassianMarkDownParser.parse(Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* escapeLinks */])(text));
                    if (doc && doc.content) {
                        markdownSlice = new __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__["Slice"](doc.content, slice.openStart, slice.openEnd);
                    }
                    // run macro autoconvert prior to other conversions
                    if (markdownSlice &&
                        Object(__WEBPACK_IMPORTED_MODULE_18__handlers__["a" /* handleMacroAutoConvert */])(text, markdownSlice)(state, dispatch, view)) {
                        return true;
                    }
                }
                if (Object(__WEBPACK_IMPORTED_MODULE_18__handlers__["c" /* handlePasteIntoTaskAndDecision */])(slice)(state, dispatch)) {
                    return true;
                }
                // If we're in a code block, append the text contents of clipboard inside it
                if (text && Object(__WEBPACK_IMPORTED_MODULE_5_prosemirror_utils__["hasParentNodeOfType"])(codeBlock)(state.selection)) {
                    var tr = Object(__WEBPACK_IMPORTED_MODULE_4_prosemirror_history__["closeHistory"])(state.tr);
                    dispatch(tr.insertText(text));
                    return true;
                }
                if (editorAppearance !== 'message' &&
                    slice.content.childCount === 1 &&
                    slice.content.firstChild.type === media) {
                    return Object(__WEBPACK_IMPORTED_MODULE_9__media_utils_media_single__["a" /* insertMediaAsMediaSingle */])(view, slice.content.firstChild);
                }
                // If the clipboard only contains plain text, attempt to parse it as Markdown
                if (text && !html && markdownSlice) {
                    __WEBPACK_IMPORTED_MODULE_7__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.paste.markdown');
                    var tr = Object(__WEBPACK_IMPORTED_MODULE_4_prosemirror_history__["closeHistory"])(state.tr);
                    tr.replaceSelection(markdownSlice);
                    Object(__WEBPACK_IMPORTED_MODULE_20__card_pm_plugins_doc__["a" /* queueCardsFromChangedTr */])(state, tr);
                    dispatch(tr.scrollIntoView());
                    return true;
                }
                // finally, handle rich-text copy-paste
                if (html) {
                    // linkify the text where possible
                    slice = Object(__WEBPACK_IMPORTED_MODULE_14__hyperlink_utils__["c" /* linkifyContent */])(state.schema, slice);
                    // run macro autoconvert prior to other conversions
                    if (Object(__WEBPACK_IMPORTED_MODULE_18__handlers__["a" /* handleMacroAutoConvert */])(text, slice)(state, dispatch, view)) {
                        return true;
                    }
                    var _b = state.schema.nodes, table = _b.table, tableCell = _b.tableCell;
                    // if we're pasting to outside a table or outside a table
                    // header, ensure that we apply any table headers to the first
                    // row of content we see, if required
                    if (!Object(__WEBPACK_IMPORTED_MODULE_5_prosemirror_utils__["hasParentNodeOfType"])([table, tableCell])(state.selection)) {
                        var tableState = __WEBPACK_IMPORTED_MODULE_15__table_pm_plugins_main__["e" /* pluginKey */].getState(state);
                        if (tableState && tableState.pluginConfig.isHeaderRowRequired) {
                            slice = Object(__WEBPACK_IMPORTED_MODULE_17__table_actions__["E" /* transformSliceToAddTableHeaders */])(slice, state.schema);
                        }
                    }
                    // In case user is pasting inline code,
                    // any backtick ` immediately preceding it should be removed.
                    var tr = state.tr;
                    if (slice.content.firstChild &&
                        slice.content.firstChild.marks.some(function (m) { return m.type === state.schema.marks.code; })) {
                        var _c = tr.selection, nodeBefore = _c.$from.nodeBefore, from = _c.from;
                        if (nodeBefore &&
                            nodeBefore.isText &&
                            nodeBefore.text.endsWith('`')) {
                            tr.delete(from - 1, from);
                        }
                    }
                    // get prosemirror-tables to handle pasting tables if it can
                    // otherwise, just the replace the selection with the content
                    if (Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_tables__["handlePaste"])(view, null, slice)) {
                        return true;
                    }
                    Object(__WEBPACK_IMPORTED_MODULE_4_prosemirror_history__["closeHistory"])(tr);
                    tr.replaceSelection(slice);
                    tr.setStoredMarks([]);
                    if (tr.selection.empty &&
                        tr.selection.$from.parent.type === codeBlock) {
                        tr.setSelection(__WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["TextSelection"].near(tr.selection.$from, 1));
                    }
                    // queue link cards, ignoring any errors
                    dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__card_pm_plugins_doc__["a" /* queueCardsFromChangedTr */])(state, tr));
                    return true;
                }
                return false;
            },
            transformPasted: function (slice) {
                // remove table number column if its part of the node
                slice = Object(__WEBPACK_IMPORTED_MODULE_16__table_utils__["F" /* transformSliceToRemoveNumberColumn */])(slice, schema);
                /** If a partial paste of table, paste only table's content */
                slice = Object(__WEBPACK_IMPORTED_MODULE_16__table_utils__["G" /* transformSliceToRemoveOpenTable */])(slice, schema);
                // We do this separately so it also applies to drag/drop events
                slice = Object(__WEBPACK_IMPORTED_MODULE_13__layout_utils__["a" /* transformSliceToRemoveOpenLayoutNodes */])(slice, schema);
                /** If a partial paste of bodied extension, paste only text */
                slice = Object(__WEBPACK_IMPORTED_MODULE_12__extension_actions__["c" /* transformSliceToRemoveOpenBodiedExtension */])(slice, schema);
                /* Bitbucket copies diffs as multiple adjacent code blocks
                 * so we merge ALL adjacent code blocks to support paste here */
                slice = Object(__WEBPACK_IMPORTED_MODULE_19__code_block_utils__["b" /* transformSliceToJoinAdjacentCodeBlocks */])(slice);
                slice = Object(__WEBPACK_IMPORTED_MODULE_19__code_block_utils__["a" /* transformSingleLineCodeBlockToCodeMark */])(slice, schema);
                if (slice.content.childCount &&
                    slice.content.lastChild.type === schema.nodes.codeBlock) {
                    slice = new __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__["Slice"](slice.content.append(__WEBPACK_IMPORTED_MODULE_2_prosemirror_model__["Fragment"].from(schema.nodes.paragraph.createAndFill())), slice.openStart, 1);
                }
                return slice;
            },
            transformPastedHTML: function (html) {
                // Fix for issue ED-4438
                // text from google docs should not be pasted as inline code
                if (html.indexOf('id="docs-internal-guid-') >= 0) {
                    html = html.replace(/white-space:pre/g, '');
                    html = html.replace(/white-space:pre-wrap/g, '');
                }
                return html;
            },
        },
    });
}
//# sourceMappingURL=main.js.map

/***/ }),
/* 2643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Main parser class




var utils        = __webpack_require__(28);
var helpers      = __webpack_require__(2648);
var Renderer     = __webpack_require__(2652);
var ParserCore   = __webpack_require__(2653);
var ParserBlock  = __webpack_require__(2661);
var ParserInline = __webpack_require__(2675);
var LinkifyIt    = __webpack_require__(263);
var mdurl        = __webpack_require__(860);
var punycode     = __webpack_require__(645);


var config = {
  'default': __webpack_require__(2688),
  zero: __webpack_require__(2689),
  commonmark: __webpack_require__(2690)
};

////////////////////////////////////////////////////////////////////////////////
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//

var BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
var GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;

function validateLink(url) {
  // url should be normalized at this point, and existing entities are decoded
  var str = url.trim().toLowerCase();

  return BAD_PROTO_RE.test(str) ? (GOOD_DATA_RE.test(str) ? true : false) : true;
}

////////////////////////////////////////////////////////////////////////////////


var RECODE_HOSTNAME_FOR = [ 'http:', 'https:', 'mailto:' ];

function normalizeLink(url) {
  var parsed = mdurl.parse(url, true);

  if (parsed.hostname) {
    // Encode hostnames in urls like:
    // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
    //
    // We don't encode unknown schemas, because it's likely that we encode
    // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
    //
    if (!parsed.protocol || RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) {
      try {
        parsed.hostname = punycode.toASCII(parsed.hostname);
      } catch (er) { /**/ }
    }
  }

  return mdurl.encode(mdurl.format(parsed));
}

function normalizeLinkText(url) {
  var parsed = mdurl.parse(url, true);

  if (parsed.hostname) {
    // Encode hostnames in urls like:
    // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
    //
    // We don't encode unknown schemas, because it's likely that we encode
    // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
    //
    if (!parsed.protocol || RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) {
      try {
        parsed.hostname = punycode.toUnicode(parsed.hostname);
      } catch (er) { /**/ }
    }
  }

  return mdurl.decode(mdurl.format(parsed));
}


/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/

/**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(lang, str, true).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre class="hljs"><code>' +
 *                hljs.highlight(lang, str, true).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/
function MarkdownIt(presetName, options) {
  if (!(this instanceof MarkdownIt)) {
    return new MarkdownIt(presetName, options);
  }

  if (!options) {
    if (!utils.isString(presetName)) {
      options = presetName || {};
      presetName = 'default';
    }
  }

  /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/
  this.inline = new ParserInline();

  /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/
  this.block = new ParserBlock();

  /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/
  this.core = new ParserCore();

  /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/
  this.renderer = new Renderer();

  /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/
  this.linkify = new LinkifyIt();

  /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/
  this.validateLink = validateLink;

  /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/
  this.normalizeLink = normalizeLink;

  /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/
  this.normalizeLinkText = normalizeLinkText;


  // Expose utils & helpers for easy acces from plugins

  /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
   **/
  this.utils = utils;

  /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/
  this.helpers = utils.assign({}, helpers);


  this.options = {};
  this.configure(presetName);

  if (options) { this.set(options); }
}


/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/
MarkdownIt.prototype.set = function (options) {
  utils.assign(this.options, options);
  return this;
};


/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you with - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/
MarkdownIt.prototype.configure = function (presets) {
  var self = this, presetName;

  if (utils.isString(presets)) {
    presetName = presets;
    presets = config[presetName];
    if (!presets) { throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name'); }
  }

  if (!presets) { throw new Error('Wrong `markdown-it` preset, can\'t be empty'); }

  if (presets.options) { self.set(presets.options); }

  if (presets.components) {
    Object.keys(presets.components).forEach(function (name) {
      if (presets.components[name].rules) {
        self[name].ruler.enableOnly(presets.components[name].rules);
      }
      if (presets.components[name].rules2) {
        self[name].ruler2.enableOnly(presets.components[name].rules2);
      }
    });
  }
  return this;
};


/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/
MarkdownIt.prototype.enable = function (list, ignoreInvalid) {
  var result = [];

  if (!Array.isArray(list)) { list = [ list ]; }

  [ 'core', 'block', 'inline' ].forEach(function (chain) {
    result = result.concat(this[chain].ruler.enable(list, true));
  }, this);

  result = result.concat(this.inline.ruler2.enable(list, true));

  var missed = list.filter(function (name) { return result.indexOf(name) < 0; });

  if (missed.length && !ignoreInvalid) {
    throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
  }

  return this;
};


/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/
MarkdownIt.prototype.disable = function (list, ignoreInvalid) {
  var result = [];

  if (!Array.isArray(list)) { list = [ list ]; }

  [ 'core', 'block', 'inline' ].forEach(function (chain) {
    result = result.concat(this[chain].ruler.disable(list, true));
  }, this);

  result = result.concat(this.inline.ruler2.disable(list, true));

  var missed = list.filter(function (name) { return result.indexOf(name) < 0; });

  if (missed.length && !ignoreInvalid) {
    throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
  }
  return this;
};


/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/
MarkdownIt.prototype.use = function (plugin /*, params, ... */) {
  var args = [ this ].concat(Array.prototype.slice.call(arguments, 1));
  plugin.apply(plugin, args);
  return this;
};


/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and returns list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/
MarkdownIt.prototype.parse = function (src, env) {
  if (typeof src !== 'string') {
    throw new Error('Input data should be a String');
  }

  var state = new this.core.State(src, this, env);

  this.core.process(state);

  return state.tokens;
};


/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/
MarkdownIt.prototype.render = function (src, env) {
  env = env || {};

  return this.renderer.render(this.parse(src, env), this.options, env);
};


/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/
MarkdownIt.prototype.parseInline = function (src, env) {
  var state = new this.core.State(src, this, env);

  state.inlineMode = true;
  this.core.process(state);

  return state.tokens;
};


/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/
MarkdownIt.prototype.renderInline = function (src, env) {
  env = env || {};

  return this.renderer.render(this.parseInline(src, env), this.options, env);
};


module.exports = MarkdownIt;


/***/ }),
/* 2644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";




module.exports = function format(url) {
  var result = '';

  result += url.protocol || '';
  result += url.slashes ? '//' : '';
  result += url.auth ? url.auth + '@' : '';

  if (url.hostname && url.hostname.indexOf(':') !== -1) {
    // ipv6 address
    result += '[' + url.hostname + ']';
  } else {
    result += url.hostname || '';
  }

  result += url.port ? ':' + url.port : '';
  result += url.pathname || '';
  result += url.search || '';
  result += url.hash || '';

  return result;
};


/***/ }),
/* 2645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//


function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.pathname = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = [ '<', '>', '"', '`', ' ', '\r', '\n', '\t' ],

    // RFC 2396: characters not allowed for various reasons.
    unwise = [ '{', '}', '|', '\\', '^', '`' ].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = [ '\'' ].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = [ '%', '/', '?', ';', '#' ].concat(autoEscape),
    hostEndingChars = [ '/', '?', '#' ],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    /* eslint-disable no-script-url */
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    };
    /* eslint-enable no-script-url */

function urlParse(url, slashesDenoteHost) {
  if (url && url instanceof Url) { return url; }

  var u = new Url();
  u.parse(url, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, slashesDenoteHost) {
  var i, l, lowerProto, hec, slashes,
      rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    lowerProto = proto.toLowerCase();
    this.protocol = proto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (i = 0; i < hostEndingChars.length; i++) {
      hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) {
        hostEnd = hec;
      }
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = auth;
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (i = 0; i < nonHostChars.length; i++) {
      hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) {
        hostEnd = hec;
      }
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1) {
      hostEnd = rest.length;
    }

    if (rest[hostEnd - 1] === ':') { hostEnd--; }
    var host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost(host);

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) { continue; }
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    }

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
  }

  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    rest = rest.slice(0, qm);
  }
  if (rest) { this.pathname = rest; }
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '';
  }

  return this;
};

Url.prototype.parseHost = function(host) {
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) { this.hostname = host; }
};

module.exports = urlParse;


/***/ }),
/* 2646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.Any = __webpack_require__(636);
exports.Cc  = __webpack_require__(637);
exports.Cf  = __webpack_require__(2647);
exports.P   = __webpack_require__(375);
exports.Z   = __webpack_require__(638);


/***/ }),
/* 2647 */
/***/ (function(module, exports) {

module.exports=/[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804\uDCBD|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/

/***/ }),
/* 2648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Just a shortcut for bulk export



exports.parseLinkLabel       = __webpack_require__(2649);
exports.parseLinkDestination = __webpack_require__(2650);
exports.parseLinkTitle       = __webpack_require__(2651);


/***/ }),
/* 2649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//


module.exports = function parseLinkLabel(state, start, disableNested) {
  var level, found, marker, prevPos,
      labelEnd = -1,
      max = state.posMax,
      oldPos = state.pos;

  state.pos = start + 1;
  level = 1;

  while (state.pos < max) {
    marker = state.src.charCodeAt(state.pos);
    if (marker === 0x5D /* ] */) {
      level--;
      if (level === 0) {
        found = true;
        break;
      }
    }

    prevPos = state.pos;
    state.md.inline.skipToken(state);
    if (marker === 0x5B /* [ */) {
      if (prevPos === state.pos - 1) {
        // increase level if we find text `[`, which is not a part of any token
        level++;
      } else if (disableNested) {
        state.pos = oldPos;
        return -1;
      }
    }
  }

  if (found) {
    labelEnd = state.pos;
  }

  // restore old state
  state.pos = oldPos;

  return labelEnd;
};


/***/ }),
/* 2650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Parse link destination
//



var isSpace     = __webpack_require__(28).isSpace;
var unescapeAll = __webpack_require__(28).unescapeAll;


module.exports = function parseLinkDestination(str, pos, max) {
  var code, level,
      lines = 0,
      start = pos,
      result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
      };

  if (str.charCodeAt(pos) === 0x3C /* < */) {
    pos++;
    while (pos < max) {
      code = str.charCodeAt(pos);
      if (code === 0x0A /* \n */ || isSpace(code)) { return result; }
      if (code === 0x3E /* > */) {
        result.pos = pos + 1;
        result.str = unescapeAll(str.slice(start + 1, pos));
        result.ok = true;
        return result;
      }
      if (code === 0x5C /* \ */ && pos + 1 < max) {
        pos += 2;
        continue;
      }

      pos++;
    }

    // no closing '>'
    return result;
  }

  // this should be ... } else { ... branch

  level = 0;
  while (pos < max) {
    code = str.charCodeAt(pos);

    if (code === 0x20) { break; }

    // ascii control characters
    if (code < 0x20 || code === 0x7F) { break; }

    if (code === 0x5C /* \ */ && pos + 1 < max) {
      pos += 2;
      continue;
    }

    if (code === 0x28 /* ( */) {
      level++;
    }

    if (code === 0x29 /* ) */) {
      if (level === 0) { break; }
      level--;
    }

    pos++;
  }

  if (start === pos) { return result; }
  if (level !== 0) { return result; }

  result.str = unescapeAll(str.slice(start, pos));
  result.lines = lines;
  result.pos = pos;
  result.ok = true;
  return result;
};


/***/ }),
/* 2651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Parse link title
//



var unescapeAll = __webpack_require__(28).unescapeAll;


module.exports = function parseLinkTitle(str, pos, max) {
  var code,
      marker,
      lines = 0,
      start = pos,
      result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
      };

  if (pos >= max) { return result; }

  marker = str.charCodeAt(pos);

  if (marker !== 0x22 /* " */ && marker !== 0x27 /* ' */ && marker !== 0x28 /* ( */) { return result; }

  pos++;

  // if opening marker is "(", switch it to closing marker ")"
  if (marker === 0x28) { marker = 0x29; }

  while (pos < max) {
    code = str.charCodeAt(pos);
    if (code === marker) {
      result.pos = pos + 1;
      result.lines = lines;
      result.str = unescapeAll(str.slice(start + 1, pos));
      result.ok = true;
      return result;
    } else if (code === 0x0A) {
      lines++;
    } else if (code === 0x5C /* \ */ && pos + 1 < max) {
      pos++;
      if (str.charCodeAt(pos) === 0x0A) {
        lines++;
      }
    }

    pos++;
  }

  return result;
};


/***/ }),
/* 2652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/



var assign          = __webpack_require__(28).assign;
var unescapeAll     = __webpack_require__(28).unescapeAll;
var escapeHtml      = __webpack_require__(28).escapeHtml;


////////////////////////////////////////////////////////////////////////////////

var default_rules = {};


default_rules.code_inline = function (tokens, idx, options, env, slf) {
  var token = tokens[idx];

  return  '<code' + slf.renderAttrs(token) + '>' +
          escapeHtml(tokens[idx].content) +
          '</code>';
};


default_rules.code_block = function (tokens, idx, options, env, slf) {
  var token = tokens[idx];

  return  '<pre' + slf.renderAttrs(token) + '><code>' +
          escapeHtml(tokens[idx].content) +
          '</code></pre>\n';
};


default_rules.fence = function (tokens, idx, options, env, slf) {
  var token = tokens[idx],
      info = token.info ? unescapeAll(token.info).trim() : '',
      langName = '',
      highlighted, i, tmpAttrs, tmpToken;

  if (info) {
    langName = info.split(/\s+/g)[0];
  }

  if (options.highlight) {
    highlighted = options.highlight(token.content, langName) || escapeHtml(token.content);
  } else {
    highlighted = escapeHtml(token.content);
  }

  if (highlighted.indexOf('<pre') === 0) {
    return highlighted + '\n';
  }

  // If language exists, inject class gently, without modifying original token.
  // May be, one day we will add .clone() for token and simplify this part, but
  // now we prefer to keep things local.
  if (info) {
    i        = token.attrIndex('class');
    tmpAttrs = token.attrs ? token.attrs.slice() : [];

    if (i < 0) {
      tmpAttrs.push([ 'class', options.langPrefix + langName ]);
    } else {
      tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
    }

    // Fake token just to render attributes
    tmpToken = {
      attrs: tmpAttrs
    };

    return  '<pre><code' + slf.renderAttrs(tmpToken) + '>'
          + highlighted
          + '</code></pre>\n';
  }


  return  '<pre><code' + slf.renderAttrs(token) + '>'
        + highlighted
        + '</code></pre>\n';
};


default_rules.image = function (tokens, idx, options, env, slf) {
  var token = tokens[idx];

  // "alt" attr MUST be set, even if empty. Because it's mandatory and
  // should be placed on proper position for tests.
  //
  // Replace content with actual value

  token.attrs[token.attrIndex('alt')][1] =
    slf.renderInlineAsText(token.children, options, env);

  return slf.renderToken(tokens, idx, options);
};


default_rules.hardbreak = function (tokens, idx, options /*, env */) {
  return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
default_rules.softbreak = function (tokens, idx, options /*, env */) {
  return options.breaks ? (options.xhtmlOut ? '<br />\n' : '<br>\n') : '\n';
};


default_rules.text = function (tokens, idx /*, options, env */) {
  return escapeHtml(tokens[idx].content);
};


default_rules.html_block = function (tokens, idx /*, options, env */) {
  return tokens[idx].content;
};
default_rules.html_inline = function (tokens, idx /*, options, env */) {
  return tokens[idx].content;
};


/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/
function Renderer() {

  /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/
  this.rules = assign({}, default_rules);
}


/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/
Renderer.prototype.renderAttrs = function renderAttrs(token) {
  var i, l, result;

  if (!token.attrs) { return ''; }

  result = '';

  for (i = 0, l = token.attrs.length; i < l; i++) {
    result += ' ' + escapeHtml(token.attrs[i][0]) + '="' + escapeHtml(token.attrs[i][1]) + '"';
  }

  return result;
};


/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/
Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
  var nextToken,
      result = '',
      needLf = false,
      token = tokens[idx];

  // Tight list paragraphs
  if (token.hidden) {
    return '';
  }

  // Insert a newline between hidden paragraph and subsequent opening
  // block-level tag.
  //
  // For example, here we should insert a newline before blockquote:
  //  - a
  //    >
  //
  if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) {
    result += '\n';
  }

  // Add token name, e.g. `<img`
  result += (token.nesting === -1 ? '</' : '<') + token.tag;

  // Encode attributes, e.g. `<img src="foo"`
  result += this.renderAttrs(token);

  // Add a slash for self-closing tags, e.g. `<img src="foo" /`
  if (token.nesting === 0 && options.xhtmlOut) {
    result += ' /';
  }

  // Check if we need to add a newline after this tag
  if (token.block) {
    needLf = true;

    if (token.nesting === 1) {
      if (idx + 1 < tokens.length) {
        nextToken = tokens[idx + 1];

        if (nextToken.type === 'inline' || nextToken.hidden) {
          // Block-level tag containing an inline tag.
          //
          needLf = false;

        } else if (nextToken.nesting === -1 && nextToken.tag === token.tag) {
          // Opening tag + closing tag of the same type. E.g. `<li></li>`.
          //
          needLf = false;
        }
      }
    }
  }

  result += needLf ? '>\n' : '>';

  return result;
};


/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to renter
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/
Renderer.prototype.renderInline = function (tokens, options, env) {
  var type,
      result = '',
      rules = this.rules;

  for (var i = 0, len = tokens.length; i < len; i++) {
    type = tokens[i].type;

    if (typeof rules[type] !== 'undefined') {
      result += rules[type](tokens, i, options, env, this);
    } else {
      result += this.renderToken(tokens, i, options);
    }
  }

  return result;
};


/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to renter
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/
Renderer.prototype.renderInlineAsText = function (tokens, options, env) {
  var result = '';

  for (var i = 0, len = tokens.length; i < len; i++) {
    if (tokens[i].type === 'text') {
      result += tokens[i].content;
    } else if (tokens[i].type === 'image') {
      result += this.renderInlineAsText(tokens[i].children, options, env);
    }
  }

  return result;
};


/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to renter
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/
Renderer.prototype.render = function (tokens, options, env) {
  var i, len, type,
      result = '',
      rules = this.rules;

  for (i = 0, len = tokens.length; i < len; i++) {
    type = tokens[i].type;

    if (type === 'inline') {
      result += this.renderInline(tokens[i].children, options, env);
    } else if (typeof rules[type] !== 'undefined') {
      result += rules[tokens[i].type](tokens, i, options, env, this);
    } else {
      result += this.renderToken(tokens, i, options, env);
    }
  }

  return result;
};

module.exports = Renderer;


/***/ }),
/* 2653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/



var Ruler  = __webpack_require__(465);


var _rules = [
  [ 'normalize',      __webpack_require__(2654)      ],
  [ 'block',          __webpack_require__(2655)          ],
  [ 'inline',         __webpack_require__(2656)         ],
  [ 'linkify',        __webpack_require__(2657)        ],
  [ 'replacements',   __webpack_require__(2658)   ],
  [ 'smartquotes',    __webpack_require__(2659)    ]
];


/**
 * new Core()
 **/
function Core() {
  /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/
  this.ruler = new Ruler();

  for (var i = 0; i < _rules.length; i++) {
    this.ruler.push(_rules[i][0], _rules[i][1]);
  }
}


/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/
Core.prototype.process = function (state) {
  var i, l, rules;

  rules = this.ruler.getRules('');

  for (i = 0, l = rules.length; i < l; i++) {
    rules[i](state);
  }
};

Core.prototype.State = __webpack_require__(2660);


module.exports = Core;


/***/ }),
/* 2654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Normalize input string




var NEWLINES_RE  = /\r[\n\u0085]?|[\u2424\u2028\u0085]/g;
var NULL_RE      = /\u0000/g;


module.exports = function inline(state) {
  var str;

  // Normalize newlines
  str = state.src.replace(NEWLINES_RE, '\n');

  // Replace NULL characters
  str = str.replace(NULL_RE, '\uFFFD');

  state.src = str;
};


/***/ }),
/* 2655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



module.exports = function block(state) {
  var token;

  if (state.inlineMode) {
    token          = new state.Token('inline', '', 0);
    token.content  = state.src;
    token.map      = [ 0, 1 ];
    token.children = [];
    state.tokens.push(token);
  } else {
    state.md.block.parse(state.src, state.md, state.env, state.tokens);
  }
};


/***/ }),
/* 2656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function inline(state) {
  var tokens = state.tokens, tok, i, l;

  // Parse inlines
  for (i = 0, l = tokens.length; i < l; i++) {
    tok = tokens[i];
    if (tok.type === 'inline') {
      state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
  }
};


/***/ }),
/* 2657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//



var arrayReplaceAt = __webpack_require__(28).arrayReplaceAt;


function isLinkOpen(str) {
  return /^<a[>\s]/i.test(str);
}
function isLinkClose(str) {
  return /^<\/a\s*>/i.test(str);
}


module.exports = function linkify(state) {
  var i, j, l, tokens, token, currentToken, nodes, ln, text, pos, lastPos,
      level, htmlLinkLevel, url, fullUrl, urlText,
      blockTokens = state.tokens,
      links;

  if (!state.md.options.linkify) { return; }

  for (j = 0, l = blockTokens.length; j < l; j++) {
    if (blockTokens[j].type !== 'inline' ||
        !state.md.linkify.pretest(blockTokens[j].content)) {
      continue;
    }

    tokens = blockTokens[j].children;

    htmlLinkLevel = 0;

    // We scan from the end, to keep position when new tags added.
    // Use reversed logic in links start/end match
    for (i = tokens.length - 1; i >= 0; i--) {
      currentToken = tokens[i];

      // Skip content of markdown links
      if (currentToken.type === 'link_close') {
        i--;
        while (tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open') {
          i--;
        }
        continue;
      }

      // Skip content of html tag links
      if (currentToken.type === 'html_inline') {
        if (isLinkOpen(currentToken.content) && htmlLinkLevel > 0) {
          htmlLinkLevel--;
        }
        if (isLinkClose(currentToken.content)) {
          htmlLinkLevel++;
        }
      }
      if (htmlLinkLevel > 0) { continue; }

      if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {

        text = currentToken.content;
        links = state.md.linkify.match(text);

        // Now split string to nodes
        nodes = [];
        level = currentToken.level;
        lastPos = 0;

        for (ln = 0; ln < links.length; ln++) {

          url = links[ln].url;
          fullUrl = state.md.normalizeLink(url);
          if (!state.md.validateLink(fullUrl)) { continue; }

          urlText = links[ln].text;

          // Linkifier might send raw hostnames like "example.com", where url
          // starts with domain name. So we prepend http:// in those cases,
          // and remove it afterwards.
          //
          if (!links[ln].schema) {
            urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
          } else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) {
            urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
          } else {
            urlText = state.md.normalizeLinkText(urlText);
          }

          pos = links[ln].index;

          if (pos > lastPos) {
            token         = new state.Token('text', '', 0);
            token.content = text.slice(lastPos, pos);
            token.level   = level;
            nodes.push(token);
          }

          token         = new state.Token('link_open', 'a', 1);
          token.attrs   = [ [ 'href', fullUrl ] ];
          token.level   = level++;
          token.markup  = 'linkify';
          token.info    = 'auto';
          nodes.push(token);

          token         = new state.Token('text', '', 0);
          token.content = urlText;
          token.level   = level;
          nodes.push(token);

          token         = new state.Token('link_close', 'a', -1);
          token.level   = --level;
          token.markup  = 'linkify';
          token.info    = 'auto';
          nodes.push(token);

          lastPos = links[ln].lastIndex;
        }
        if (lastPos < text.length) {
          token         = new state.Token('text', '', 0);
          token.content = text.slice(lastPos);
          token.level   = level;
          nodes.push(token);
        }

        // replace current node
        blockTokens[j].children = tokens = arrayReplaceAt(tokens, i, nodes);
      }
    }
  }
};


/***/ }),
/* 2658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Simple typographyc replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// (p) (P) -> §
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//


// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - miltiplication 2 x 4 -> 2 × 4

var RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;

// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
var SCOPED_ABBR_TEST_RE = /\((c|tm|r|p)\)/i;

var SCOPED_ABBR_RE = /\((c|tm|r|p)\)/ig;
var SCOPED_ABBR = {
  c: '©',
  r: '®',
  p: '§',
  tm: '™'
};

function replaceFn(match, name) {
  return SCOPED_ABBR[name.toLowerCase()];
}

function replace_scoped(inlineTokens) {
  var i, token, inside_autolink = 0;

  for (i = inlineTokens.length - 1; i >= 0; i--) {
    token = inlineTokens[i];

    if (token.type === 'text' && !inside_autolink) {
      token.content = token.content.replace(SCOPED_ABBR_RE, replaceFn);
    }

    if (token.type === 'link_open' && token.info === 'auto') {
      inside_autolink--;
    }

    if (token.type === 'link_close' && token.info === 'auto') {
      inside_autolink++;
    }
  }
}

function replace_rare(inlineTokens) {
  var i, token, inside_autolink = 0;

  for (i = inlineTokens.length - 1; i >= 0; i--) {
    token = inlineTokens[i];

    if (token.type === 'text' && !inside_autolink) {
      if (RARE_RE.test(token.content)) {
        token.content = token.content
                    .replace(/\+-/g, '±')
                    // .., ..., ....... -> …
                    // but ?..... & !..... -> ?.. & !..
                    .replace(/\.{2,}/g, '…').replace(/([?!])…/g, '$1..')
                    .replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')
                    // em-dash
                    .replace(/(^|[^-])---([^-]|$)/mg, '$1\u2014$2')
                    // en-dash
                    .replace(/(^|\s)--(\s|$)/mg, '$1\u2013$2')
                    .replace(/(^|[^-\s])--([^-\s]|$)/mg, '$1\u2013$2');
      }
    }

    if (token.type === 'link_open' && token.info === 'auto') {
      inside_autolink--;
    }

    if (token.type === 'link_close' && token.info === 'auto') {
      inside_autolink++;
    }
  }
}


module.exports = function replace(state) {
  var blkIdx;

  if (!state.md.options.typographer) { return; }

  for (blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {

    if (state.tokens[blkIdx].type !== 'inline') { continue; }

    if (SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) {
      replace_scoped(state.tokens[blkIdx].children);
    }

    if (RARE_RE.test(state.tokens[blkIdx].content)) {
      replace_rare(state.tokens[blkIdx].children);
    }

  }
};


/***/ }),
/* 2659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Convert straight quotation marks to typographic ones
//



var isWhiteSpace   = __webpack_require__(28).isWhiteSpace;
var isPunctChar    = __webpack_require__(28).isPunctChar;
var isMdAsciiPunct = __webpack_require__(28).isMdAsciiPunct;

var QUOTE_TEST_RE = /['"]/;
var QUOTE_RE = /['"]/g;
var APOSTROPHE = '\u2019'; /* ’ */


function replaceAt(str, index, ch) {
  return str.substr(0, index) + ch + str.substr(index + 1);
}

function process_inlines(tokens, state) {
  var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar,
      isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace,
      canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;

  stack = [];

  for (i = 0; i < tokens.length; i++) {
    token = tokens[i];

    thisLevel = tokens[i].level;

    for (j = stack.length - 1; j >= 0; j--) {
      if (stack[j].level <= thisLevel) { break; }
    }
    stack.length = j + 1;

    if (token.type !== 'text') { continue; }

    text = token.content;
    pos = 0;
    max = text.length;

    /*eslint no-labels:0,block-scoped-var:0*/
    OUTER:
    while (pos < max) {
      QUOTE_RE.lastIndex = pos;
      t = QUOTE_RE.exec(text);
      if (!t) { break; }

      canOpen = canClose = true;
      pos = t.index + 1;
      isSingle = (t[0] === "'");

      // Find previous character,
      // default to space if it's the beginning of the line
      //
      lastChar = 0x20;

      if (t.index - 1 >= 0) {
        lastChar = text.charCodeAt(t.index - 1);
      } else {
        for (j = i - 1; j >= 0; j--) {
          if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
          if (tokens[j].type !== 'text') continue;

          lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
          break;
        }
      }

      // Find next character,
      // default to space if it's the end of the line
      //
      nextChar = 0x20;

      if (pos < max) {
        nextChar = text.charCodeAt(pos);
      } else {
        for (j = i + 1; j < tokens.length; j++) {
          if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
          if (tokens[j].type !== 'text') continue;

          nextChar = tokens[j].content.charCodeAt(0);
          break;
        }
      }

      isLastPunctChar = isMdAsciiPunct(lastChar) || isPunctChar(String.fromCharCode(lastChar));
      isNextPunctChar = isMdAsciiPunct(nextChar) || isPunctChar(String.fromCharCode(nextChar));

      isLastWhiteSpace = isWhiteSpace(lastChar);
      isNextWhiteSpace = isWhiteSpace(nextChar);

      if (isNextWhiteSpace) {
        canOpen = false;
      } else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) {
          canOpen = false;
        }
      }

      if (isLastWhiteSpace) {
        canClose = false;
      } else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) {
          canClose = false;
        }
      }

      if (nextChar === 0x22 /* " */ && t[0] === '"') {
        if (lastChar >= 0x30 /* 0 */ && lastChar <= 0x39 /* 9 */) {
          // special case: 1"" - count first quote as an inch
          canClose = canOpen = false;
        }
      }

      if (canOpen && canClose) {
        // treat this as the middle of the word
        canOpen = false;
        canClose = isNextPunctChar;
      }

      if (!canOpen && !canClose) {
        // middle of word
        if (isSingle) {
          token.content = replaceAt(token.content, t.index, APOSTROPHE);
        }
        continue;
      }

      if (canClose) {
        // this could be a closing quote, rewind the stack to get a match
        for (j = stack.length - 1; j >= 0; j--) {
          item = stack[j];
          if (stack[j].level < thisLevel) { break; }
          if (item.single === isSingle && stack[j].level === thisLevel) {
            item = stack[j];

            if (isSingle) {
              openQuote = state.md.options.quotes[2];
              closeQuote = state.md.options.quotes[3];
            } else {
              openQuote = state.md.options.quotes[0];
              closeQuote = state.md.options.quotes[1];
            }

            // replace token.content *before* tokens[item.token].content,
            // because, if they are pointing at the same token, replaceAt
            // could mess up indices when quote length != 1
            token.content = replaceAt(token.content, t.index, closeQuote);
            tokens[item.token].content = replaceAt(
              tokens[item.token].content, item.pos, openQuote);

            pos += closeQuote.length - 1;
            if (item.token === i) { pos += openQuote.length - 1; }

            text = token.content;
            max = text.length;

            stack.length = j;
            continue OUTER;
          }
        }
      }

      if (canOpen) {
        stack.push({
          token: i,
          pos: t.index,
          single: isSingle,
          level: thisLevel
        });
      } else if (canClose && isSingle) {
        token.content = replaceAt(token.content, t.index, APOSTROPHE);
      }
    }
  }
}


module.exports = function smartquotes(state) {
  /*eslint max-depth:0*/
  var blkIdx;

  if (!state.md.options.typographer) { return; }

  for (blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {

    if (state.tokens[blkIdx].type !== 'inline' ||
        !QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) {
      continue;
    }

    process_inlines(state.tokens[blkIdx].children, state);
  }
};


/***/ }),
/* 2660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Core state object
//


var Token = __webpack_require__(466);


function StateCore(src, md, env) {
  this.src = src;
  this.env = env;
  this.tokens = [];
  this.inlineMode = false;
  this.md = md; // link to parser instance
}

// re-export Token class to use in core rules
StateCore.prototype.Token = Token;


module.exports = StateCore;


/***/ }),
/* 2661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/



var Ruler           = __webpack_require__(465);


var _rules = [
  // First 2 params - rule name & source. Secondary array - list of rules,
  // which can be terminated by this one.
  [ 'table',      __webpack_require__(2662),      [ 'paragraph', 'reference' ] ],
  [ 'code',       __webpack_require__(2663) ],
  [ 'fence',      __webpack_require__(2664),      [ 'paragraph', 'reference', 'blockquote', 'list' ] ],
  [ 'blockquote', __webpack_require__(2665), [ 'paragraph', 'reference', 'blockquote', 'list' ] ],
  [ 'hr',         __webpack_require__(2666),         [ 'paragraph', 'reference', 'blockquote', 'list' ] ],
  [ 'list',       __webpack_require__(2667),       [ 'paragraph', 'reference', 'blockquote' ] ],
  [ 'reference',  __webpack_require__(2668) ],
  [ 'heading',    __webpack_require__(2669),    [ 'paragraph', 'reference', 'blockquote' ] ],
  [ 'lheading',   __webpack_require__(2670) ],
  [ 'html_block', __webpack_require__(2671), [ 'paragraph', 'reference', 'blockquote' ] ],
  [ 'paragraph',  __webpack_require__(2673) ]
];


/**
 * new ParserBlock()
 **/
function ParserBlock() {
  /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/
  this.ruler = new Ruler();

  for (var i = 0; i < _rules.length; i++) {
    this.ruler.push(_rules[i][0], _rules[i][1], { alt: (_rules[i][2] || []).slice() });
  }
}


// Generate tokens for input range
//
ParserBlock.prototype.tokenize = function (state, startLine, endLine) {
  var ok, i,
      rules = this.ruler.getRules(''),
      len = rules.length,
      line = startLine,
      hasEmptyLines = false,
      maxNesting = state.md.options.maxNesting;

  while (line < endLine) {
    state.line = line = state.skipEmptyLines(line);
    if (line >= endLine) { break; }

    // Termination condition for nested calls.
    // Nested calls currently used for blockquotes & lists
    if (state.sCount[line] < state.blkIndent) { break; }

    // If nesting level exceeded - skip tail to the end. That's not ordinary
    // situation and we should not care about content.
    if (state.level >= maxNesting) {
      state.line = endLine;
      break;
    }

    // Try all possible rules.
    // On success, rule should:
    //
    // - update `state.line`
    // - update `state.tokens`
    // - return true

    for (i = 0; i < len; i++) {
      ok = rules[i](state, line, endLine, false);
      if (ok) { break; }
    }

    // set state.tight if we had an empty line before current tag
    // i.e. latest empty line should not count
    state.tight = !hasEmptyLines;

    // paragraph might "eat" one newline after it in nested lists
    if (state.isEmpty(state.line - 1)) {
      hasEmptyLines = true;
    }

    line = state.line;

    if (line < endLine && state.isEmpty(line)) {
      hasEmptyLines = true;
      line++;
      state.line = line;
    }
  }
};


/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/
ParserBlock.prototype.parse = function (src, md, env, outTokens) {
  var state;

  if (!src) { return; }

  state = new this.State(src, md, env, outTokens);

  this.tokenize(state, state.line, state.lineMax);
};


ParserBlock.prototype.State = __webpack_require__(2674);


module.exports = ParserBlock;


/***/ }),
/* 2662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GFM table, non-standard



var isSpace = __webpack_require__(28).isSpace;


function getLine(state, line) {
  var pos = state.bMarks[line] + state.blkIndent,
      max = state.eMarks[line];

  return state.src.substr(pos, max - pos);
}

function escapedSplit(str) {
  var result = [],
      pos = 0,
      max = str.length,
      ch,
      escapes = 0,
      lastPos = 0,
      backTicked = false,
      lastBackTick = 0;

  ch  = str.charCodeAt(pos);

  while (pos < max) {
    if (ch === 0x60/* ` */) {
      if (backTicked) {
        // make \` close code sequence, but not open it;
        // the reason is: `\` is correct code block
        backTicked = false;
        lastBackTick = pos;
      } else if (escapes % 2 === 0) {
        backTicked = true;
        lastBackTick = pos;
      }
    } else if (ch === 0x7c/* | */ && (escapes % 2 === 0) && !backTicked) {
      result.push(str.substring(lastPos, pos));
      lastPos = pos + 1;
    }

    if (ch === 0x5c/* \ */) {
      escapes++;
    } else {
      escapes = 0;
    }

    pos++;

    // If there was an un-closed backtick, go back to just after
    // the last backtick, but as if it was a normal character
    if (pos === max && backTicked) {
      backTicked = false;
      pos = lastBackTick + 1;
    }

    ch = str.charCodeAt(pos);
  }

  result.push(str.substring(lastPos));

  return result;
}


module.exports = function table(state, startLine, endLine, silent) {
  var ch, lineText, pos, i, nextLine, columns, columnCount, token,
      aligns, t, tableLines, tbodyLines;

  // should have at least two lines
  if (startLine + 2 > endLine) { return false; }

  nextLine = startLine + 1;

  if (state.sCount[nextLine] < state.blkIndent) { return false; }

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[nextLine] - state.blkIndent >= 4) { return false; }

  // first character of the second line should be '|', '-', ':',
  // and no other characters are allowed but spaces;
  // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp

  pos = state.bMarks[nextLine] + state.tShift[nextLine];
  if (pos >= state.eMarks[nextLine]) { return false; }

  ch = state.src.charCodeAt(pos++);
  if (ch !== 0x7C/* | */ && ch !== 0x2D/* - */ && ch !== 0x3A/* : */) { return false; }

  while (pos < state.eMarks[nextLine]) {
    ch = state.src.charCodeAt(pos);

    if (ch !== 0x7C/* | */ && ch !== 0x2D/* - */ && ch !== 0x3A/* : */ && !isSpace(ch)) { return false; }

    pos++;
  }

  lineText = getLine(state, startLine + 1);

  columns = lineText.split('|');
  aligns = [];
  for (i = 0; i < columns.length; i++) {
    t = columns[i].trim();
    if (!t) {
      // allow empty columns before and after table, but not in between columns;
      // e.g. allow ` |---| `, disallow ` ---||--- `
      if (i === 0 || i === columns.length - 1) {
        continue;
      } else {
        return false;
      }
    }

    if (!/^:?-+:?$/.test(t)) { return false; }
    if (t.charCodeAt(t.length - 1) === 0x3A/* : */) {
      aligns.push(t.charCodeAt(0) === 0x3A/* : */ ? 'center' : 'right');
    } else if (t.charCodeAt(0) === 0x3A/* : */) {
      aligns.push('left');
    } else {
      aligns.push('');
    }
  }

  lineText = getLine(state, startLine).trim();
  if (lineText.indexOf('|') === -1) { return false; }
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }
  columns = escapedSplit(lineText.replace(/^\||\|$/g, ''));

  // header row will define an amount of columns in the entire table,
  // and align row shouldn't be smaller than that (the rest of the rows can)
  columnCount = columns.length;
  if (columnCount > aligns.length) { return false; }

  if (silent) { return true; }

  token     = state.push('table_open', 'table', 1);
  token.map = tableLines = [ startLine, 0 ];

  token     = state.push('thead_open', 'thead', 1);
  token.map = [ startLine, startLine + 1 ];

  token     = state.push('tr_open', 'tr', 1);
  token.map = [ startLine, startLine + 1 ];

  for (i = 0; i < columns.length; i++) {
    token          = state.push('th_open', 'th', 1);
    token.map      = [ startLine, startLine + 1 ];
    if (aligns[i]) {
      token.attrs  = [ [ 'style', 'text-align:' + aligns[i] ] ];
    }

    token          = state.push('inline', '', 0);
    token.content  = columns[i].trim();
    token.map      = [ startLine, startLine + 1 ];
    token.children = [];

    token          = state.push('th_close', 'th', -1);
  }

  token     = state.push('tr_close', 'tr', -1);
  token     = state.push('thead_close', 'thead', -1);

  token     = state.push('tbody_open', 'tbody', 1);
  token.map = tbodyLines = [ startLine + 2, 0 ];

  for (nextLine = startLine + 2; nextLine < endLine; nextLine++) {
    if (state.sCount[nextLine] < state.blkIndent) { break; }

    lineText = getLine(state, nextLine).trim();
    if (lineText.indexOf('|') === -1) { break; }
    if (state.sCount[nextLine] - state.blkIndent >= 4) { break; }
    columns = escapedSplit(lineText.replace(/^\||\|$/g, ''));

    token = state.push('tr_open', 'tr', 1);
    for (i = 0; i < columnCount; i++) {
      token          = state.push('td_open', 'td', 1);
      if (aligns[i]) {
        token.attrs  = [ [ 'style', 'text-align:' + aligns[i] ] ];
      }

      token          = state.push('inline', '', 0);
      token.content  = columns[i] ? columns[i].trim() : '';
      token.children = [];

      token          = state.push('td_close', 'td', -1);
    }
    token = state.push('tr_close', 'tr', -1);
  }
  token = state.push('tbody_close', 'tbody', -1);
  token = state.push('table_close', 'table', -1);

  tableLines[1] = tbodyLines[1] = nextLine;
  state.line = nextLine;
  return true;
};


/***/ }),
/* 2663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Code block (4 spaces padded)




module.exports = function code(state, startLine, endLine/*, silent*/) {
  var nextLine, last, token;

  if (state.sCount[startLine] - state.blkIndent < 4) { return false; }

  last = nextLine = startLine + 1;

  while (nextLine < endLine) {
    if (state.isEmpty(nextLine)) {
      nextLine++;
      continue;
    }

    if (state.sCount[nextLine] - state.blkIndent >= 4) {
      nextLine++;
      last = nextLine;
      continue;
    }
    break;
  }

  state.line = last;

  token         = state.push('code_block', 'code', 0);
  token.content = state.getLines(startLine, last, 4 + state.blkIndent, true);
  token.map     = [ startLine, state.line ];

  return true;
};


/***/ }),
/* 2664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// fences (``` lang, ~~~ lang)




module.exports = function fence(state, startLine, endLine, silent) {
  var marker, len, params, nextLine, mem, token, markup,
      haveEndMarker = false,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  if (pos + 3 > max) { return false; }

  marker = state.src.charCodeAt(pos);

  if (marker !== 0x7E/* ~ */ && marker !== 0x60 /* ` */) {
    return false;
  }

  // scan marker length
  mem = pos;
  pos = state.skipChars(pos, marker);

  len = pos - mem;

  if (len < 3) { return false; }

  markup = state.src.slice(mem, pos);
  params = state.src.slice(pos, max);

  if (params.indexOf(String.fromCharCode(marker)) >= 0) { return false; }

  // Since start is found, we can report success here in validation mode
  if (silent) { return true; }

  // search end of block
  nextLine = startLine;

  for (;;) {
    nextLine++;
    if (nextLine >= endLine) {
      // unclosed block should be autoclosed by end of document.
      // also block seems to be autoclosed by end of parent
      break;
    }

    pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
    max = state.eMarks[nextLine];

    if (pos < max && state.sCount[nextLine] < state.blkIndent) {
      // non-empty line with negative indent should stop the list:
      // - ```
      //  test
      break;
    }

    if (state.src.charCodeAt(pos) !== marker) { continue; }

    if (state.sCount[nextLine] - state.blkIndent >= 4) {
      // closing fence should be indented less than 4 spaces
      continue;
    }

    pos = state.skipChars(pos, marker);

    // closing code fence must be at least as long as the opening one
    if (pos - mem < len) { continue; }

    // make sure tail has spaces only
    pos = state.skipSpaces(pos);

    if (pos < max) { continue; }

    haveEndMarker = true;
    // found!
    break;
  }

  // If a fence has heading spaces, they should be removed from its inner block
  len = state.sCount[startLine];

  state.line = nextLine + (haveEndMarker ? 1 : 0);

  token         = state.push('fence', 'code', 0);
  token.info    = params;
  token.content = state.getLines(startLine + 1, nextLine, len, true);
  token.markup  = markup;
  token.map     = [ startLine, state.line ];

  return true;
};


/***/ }),
/* 2665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Block quotes



var isSpace = __webpack_require__(28).isSpace;


module.exports = function blockquote(state, startLine, endLine, silent) {
  var adjustTab,
      ch,
      i,
      initial,
      l,
      lastLineEmpty,
      lines,
      nextLine,
      offset,
      oldBMarks,
      oldBSCount,
      oldIndent,
      oldParentType,
      oldSCount,
      oldTShift,
      spaceAfterMarker,
      terminate,
      terminatorRules,
      token,
      wasOutdented,
      oldLineMax = state.lineMax,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  // check the block quote marker
  if (state.src.charCodeAt(pos++) !== 0x3E/* > */) { return false; }

  // we know that it's going to be a valid blockquote,
  // so no point trying to find the end of it in silent mode
  if (silent) { return true; }

  // skip spaces after ">" and re-calculate offset
  initial = offset = state.sCount[startLine] + pos - (state.bMarks[startLine] + state.tShift[startLine]);

  // skip one optional space after '>'
  if (state.src.charCodeAt(pos) === 0x20 /* space */) {
    // ' >   test '
    //     ^ -- position start of line here:
    pos++;
    initial++;
    offset++;
    adjustTab = false;
    spaceAfterMarker = true;
  } else if (state.src.charCodeAt(pos) === 0x09 /* tab */) {
    spaceAfterMarker = true;

    if ((state.bsCount[startLine] + offset) % 4 === 3) {
      // '  >\t  test '
      //       ^ -- position start of line here (tab has width===1)
      pos++;
      initial++;
      offset++;
      adjustTab = false;
    } else {
      // ' >\t  test '
      //    ^ -- position start of line here + shift bsCount slightly
      //         to make extra space appear
      adjustTab = true;
    }
  } else {
    spaceAfterMarker = false;
  }

  oldBMarks = [ state.bMarks[startLine] ];
  state.bMarks[startLine] = pos;

  while (pos < max) {
    ch = state.src.charCodeAt(pos);

    if (isSpace(ch)) {
      if (ch === 0x09) {
        offset += 4 - (offset + state.bsCount[startLine] + (adjustTab ? 1 : 0)) % 4;
      } else {
        offset++;
      }
    } else {
      break;
    }

    pos++;
  }

  oldBSCount = [ state.bsCount[startLine] ];
  state.bsCount[startLine] = state.sCount[startLine] + 1 + (spaceAfterMarker ? 1 : 0);

  lastLineEmpty = pos >= max;

  oldSCount = [ state.sCount[startLine] ];
  state.sCount[startLine] = offset - initial;

  oldTShift = [ state.tShift[startLine] ];
  state.tShift[startLine] = pos - state.bMarks[startLine];

  terminatorRules = state.md.block.ruler.getRules('blockquote');

  oldParentType = state.parentType;
  state.parentType = 'blockquote';
  wasOutdented = false;

  // Search the end of the block
  //
  // Block ends with either:
  //  1. an empty line outside:
  //     ```
  //     > test
  //
  //     ```
  //  2. an empty line inside:
  //     ```
  //     >
  //     test
  //     ```
  //  3. another tag:
  //     ```
  //     > test
  //      - - -
  //     ```
  for (nextLine = startLine + 1; nextLine < endLine; nextLine++) {
    // check if it's outdented, i.e. it's inside list item and indented
    // less than said list item:
    //
    // ```
    // 1. anything
    //    > current blockquote
    // 2. checking this line
    // ```
    if (state.sCount[nextLine] < state.blkIndent) wasOutdented = true;

    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    max = state.eMarks[nextLine];

    if (pos >= max) {
      // Case 1: line is not inside the blockquote, and this line is empty.
      break;
    }

    if (state.src.charCodeAt(pos++) === 0x3E/* > */ && !wasOutdented) {
      // This line is inside the blockquote.

      // skip spaces after ">" and re-calculate offset
      initial = offset = state.sCount[nextLine] + pos - (state.bMarks[nextLine] + state.tShift[nextLine]);

      // skip one optional space after '>'
      if (state.src.charCodeAt(pos) === 0x20 /* space */) {
        // ' >   test '
        //     ^ -- position start of line here:
        pos++;
        initial++;
        offset++;
        adjustTab = false;
        spaceAfterMarker = true;
      } else if (state.src.charCodeAt(pos) === 0x09 /* tab */) {
        spaceAfterMarker = true;

        if ((state.bsCount[nextLine] + offset) % 4 === 3) {
          // '  >\t  test '
          //       ^ -- position start of line here (tab has width===1)
          pos++;
          initial++;
          offset++;
          adjustTab = false;
        } else {
          // ' >\t  test '
          //    ^ -- position start of line here + shift bsCount slightly
          //         to make extra space appear
          adjustTab = true;
        }
      } else {
        spaceAfterMarker = false;
      }

      oldBMarks.push(state.bMarks[nextLine]);
      state.bMarks[nextLine] = pos;

      while (pos < max) {
        ch = state.src.charCodeAt(pos);

        if (isSpace(ch)) {
          if (ch === 0x09) {
            offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
          } else {
            offset++;
          }
        } else {
          break;
        }

        pos++;
      }

      lastLineEmpty = pos >= max;

      oldBSCount.push(state.bsCount[nextLine]);
      state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);

      oldSCount.push(state.sCount[nextLine]);
      state.sCount[nextLine] = offset - initial;

      oldTShift.push(state.tShift[nextLine]);
      state.tShift[nextLine] = pos - state.bMarks[nextLine];
      continue;
    }

    // Case 2: line is not inside the blockquote, and the last line was empty.
    if (lastLineEmpty) { break; }

    // Case 3: another tag found.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }

    if (terminate) {
      // Quirk to enforce "hard termination mode" for paragraphs;
      // normally if you call `tokenize(state, startLine, nextLine)`,
      // paragraphs will look below nextLine for paragraph continuation,
      // but if blockquote is terminated by another tag, they shouldn't
      state.lineMax = nextLine;

      if (state.blkIndent !== 0) {
        // state.blkIndent was non-zero, we now set it to zero,
        // so we need to re-calculate all offsets to appear as
        // if indent wasn't changed
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        state.sCount[nextLine] -= state.blkIndent;
      }

      break;
    }

    oldBMarks.push(state.bMarks[nextLine]);
    oldBSCount.push(state.bsCount[nextLine]);
    oldTShift.push(state.tShift[nextLine]);
    oldSCount.push(state.sCount[nextLine]);

    // A negative indentation means that this is a paragraph continuation
    //
    state.sCount[nextLine] = -1;
  }

  oldIndent = state.blkIndent;
  state.blkIndent = 0;

  token        = state.push('blockquote_open', 'blockquote', 1);
  token.markup = '>';
  token.map    = lines = [ startLine, 0 ];

  state.md.block.tokenize(state, startLine, nextLine);

  token        = state.push('blockquote_close', 'blockquote', -1);
  token.markup = '>';

  state.lineMax = oldLineMax;
  state.parentType = oldParentType;
  lines[1] = state.line;

  // Restore original tShift; this might not be necessary since the parser
  // has already been here, but just to make sure we can do that.
  for (i = 0; i < oldTShift.length; i++) {
    state.bMarks[i + startLine] = oldBMarks[i];
    state.tShift[i + startLine] = oldTShift[i];
    state.sCount[i + startLine] = oldSCount[i];
    state.bsCount[i + startLine] = oldBSCount[i];
  }
  state.blkIndent = oldIndent;

  return true;
};


/***/ }),
/* 2666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Horizontal rule



var isSpace = __webpack_require__(28).isSpace;


module.exports = function hr(state, startLine, endLine, silent) {
  var marker, cnt, ch, token,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  marker = state.src.charCodeAt(pos++);

  // Check hr marker
  if (marker !== 0x2A/* * */ &&
      marker !== 0x2D/* - */ &&
      marker !== 0x5F/* _ */) {
    return false;
  }

  // markers can be mixed with spaces, but there should be at least 3 of them

  cnt = 1;
  while (pos < max) {
    ch = state.src.charCodeAt(pos++);
    if (ch !== marker && !isSpace(ch)) { return false; }
    if (ch === marker) { cnt++; }
  }

  if (cnt < 3) { return false; }

  if (silent) { return true; }

  state.line = startLine + 1;

  token        = state.push('hr', 'hr', 0);
  token.map    = [ startLine, state.line ];
  token.markup = Array(cnt + 1).join(String.fromCharCode(marker));

  return true;
};


/***/ }),
/* 2667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Lists



var isSpace = __webpack_require__(28).isSpace;


// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function skipBulletListMarker(state, startLine) {
  var marker, pos, max, ch;

  pos = state.bMarks[startLine] + state.tShift[startLine];
  max = state.eMarks[startLine];

  marker = state.src.charCodeAt(pos++);
  // Check bullet
  if (marker !== 0x2A/* * */ &&
      marker !== 0x2D/* - */ &&
      marker !== 0x2B/* + */) {
    return -1;
  }

  if (pos < max) {
    ch = state.src.charCodeAt(pos);

    if (!isSpace(ch)) {
      // " -test " - is not a list item
      return -1;
    }
  }

  return pos;
}

// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function skipOrderedListMarker(state, startLine) {
  var ch,
      start = state.bMarks[startLine] + state.tShift[startLine],
      pos = start,
      max = state.eMarks[startLine];

  // List marker should have at least 2 chars (digit + dot)
  if (pos + 1 >= max) { return -1; }

  ch = state.src.charCodeAt(pos++);

  if (ch < 0x30/* 0 */ || ch > 0x39/* 9 */) { return -1; }

  for (;;) {
    // EOL -> fail
    if (pos >= max) { return -1; }

    ch = state.src.charCodeAt(pos++);

    if (ch >= 0x30/* 0 */ && ch <= 0x39/* 9 */) {

      // List marker should have no more than 9 digits
      // (prevents integer overflow in browsers)
      if (pos - start >= 10) { return -1; }

      continue;
    }

    // found valid marker
    if (ch === 0x29/* ) */ || ch === 0x2e/* . */) {
      break;
    }

    return -1;
  }


  if (pos < max) {
    ch = state.src.charCodeAt(pos);

    if (!isSpace(ch)) {
      // " 1.test " - is not a list item
      return -1;
    }
  }
  return pos;
}

function markTightParagraphs(state, idx) {
  var i, l,
      level = state.level + 2;

  for (i = idx + 2, l = state.tokens.length - 2; i < l; i++) {
    if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
      state.tokens[i + 2].hidden = true;
      state.tokens[i].hidden = true;
      i += 2;
    }
  }
}


module.exports = function list(state, startLine, endLine, silent) {
  var ch,
      contentStart,
      i,
      indent,
      indentAfterMarker,
      initial,
      isOrdered,
      itemLines,
      l,
      listLines,
      listTokIdx,
      markerCharCode,
      markerValue,
      max,
      nextLine,
      offset,
      oldIndent,
      oldLIndent,
      oldParentType,
      oldTShift,
      oldTight,
      pos,
      posAfterMarker,
      prevEmptyEnd,
      start,
      terminate,
      terminatorRules,
      token,
      isTerminatingParagraph = false,
      tight = true;

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  // limit conditions when list can interrupt
  // a paragraph (validation mode only)
  if (silent && state.parentType === 'paragraph') {
    // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    if (state.tShift[startLine] >= state.blkIndent) {
      isTerminatingParagraph = true;
    }
  }

  // Detect list type and position after marker
  if ((posAfterMarker = skipOrderedListMarker(state, startLine)) >= 0) {
    isOrdered = true;
    start = state.bMarks[startLine] + state.tShift[startLine];
    markerValue = Number(state.src.substr(start, posAfterMarker - start - 1));

    // If we're starting a new ordered list right after
    // a paragraph, it should start with 1.
    if (isTerminatingParagraph && markerValue !== 1) return false;

  } else if ((posAfterMarker = skipBulletListMarker(state, startLine)) >= 0) {
    isOrdered = false;

  } else {
    return false;
  }

  // If we're starting a new unordered list right after
  // a paragraph, first line should not be empty.
  if (isTerminatingParagraph) {
    if (state.skipSpaces(posAfterMarker) >= state.eMarks[startLine]) return false;
  }

  // We should terminate list on style change. Remember first one to compare.
  markerCharCode = state.src.charCodeAt(posAfterMarker - 1);

  // For validation mode we can terminate immediately
  if (silent) { return true; }

  // Start list
  listTokIdx = state.tokens.length;

  if (isOrdered) {
    token       = state.push('ordered_list_open', 'ol', 1);
    if (markerValue !== 1) {
      token.attrs = [ [ 'start', markerValue ] ];
    }

  } else {
    token       = state.push('bullet_list_open', 'ul', 1);
  }

  token.map    = listLines = [ startLine, 0 ];
  token.markup = String.fromCharCode(markerCharCode);

  //
  // Iterate list items
  //

  nextLine = startLine;
  prevEmptyEnd = false;
  terminatorRules = state.md.block.ruler.getRules('list');

  oldParentType = state.parentType;
  state.parentType = 'list';

  while (nextLine < endLine) {
    pos = posAfterMarker;
    max = state.eMarks[nextLine];

    initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[startLine] + state.tShift[startLine]);

    while (pos < max) {
      ch = state.src.charCodeAt(pos);

      if (ch === 0x09) {
        offset += 4 - (offset + state.bsCount[nextLine]) % 4;
      } else if (ch === 0x20) {
        offset++;
      } else {
        break;
      }

      pos++;
    }

    contentStart = pos;

    if (contentStart >= max) {
      // trimming space in "-    \n  3" case, indent is 1 here
      indentAfterMarker = 1;
    } else {
      indentAfterMarker = offset - initial;
    }

    // If we have more than 4 spaces, the indent is 1
    // (the rest is just indented code block)
    if (indentAfterMarker > 4) { indentAfterMarker = 1; }

    // "  -  test"
    //  ^^^^^ - calculating total length of this thing
    indent = initial + indentAfterMarker;

    // Run subparser & write tokens
    token        = state.push('list_item_open', 'li', 1);
    token.markup = String.fromCharCode(markerCharCode);
    token.map    = itemLines = [ startLine, 0 ];

    oldIndent = state.blkIndent;
    oldTight = state.tight;
    oldTShift = state.tShift[startLine];
    oldLIndent = state.sCount[startLine];
    state.blkIndent = indent;
    state.tight = true;
    state.tShift[startLine] = contentStart - state.bMarks[startLine];
    state.sCount[startLine] = offset;

    if (contentStart >= max && state.isEmpty(startLine + 1)) {
      // workaround for this case
      // (list item is empty, list terminates before "foo"):
      // ~~~~~~~~
      //   -
      //
      //     foo
      // ~~~~~~~~
      state.line = Math.min(state.line + 2, endLine);
    } else {
      state.md.block.tokenize(state, startLine, endLine, true);
    }

    // If any of list item is tight, mark list as tight
    if (!state.tight || prevEmptyEnd) {
      tight = false;
    }
    // Item become loose if finish with empty line,
    // but we should filter last element, because it means list finish
    prevEmptyEnd = (state.line - startLine) > 1 && state.isEmpty(state.line - 1);

    state.blkIndent = oldIndent;
    state.tShift[startLine] = oldTShift;
    state.sCount[startLine] = oldLIndent;
    state.tight = oldTight;

    token        = state.push('list_item_close', 'li', -1);
    token.markup = String.fromCharCode(markerCharCode);

    nextLine = startLine = state.line;
    itemLines[1] = nextLine;
    contentStart = state.bMarks[startLine];

    if (nextLine >= endLine) { break; }

    //
    // Try to check if list is terminated or continued.
    //
    if (state.sCount[nextLine] < state.blkIndent) { break; }

    // fail if terminating block found
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) { break; }

    // fail if list has another type
    if (isOrdered) {
      posAfterMarker = skipOrderedListMarker(state, nextLine);
      if (posAfterMarker < 0) { break; }
    } else {
      posAfterMarker = skipBulletListMarker(state, nextLine);
      if (posAfterMarker < 0) { break; }
    }

    if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) { break; }
  }

  // Finalize list
  if (isOrdered) {
    token = state.push('ordered_list_close', 'ol', -1);
  } else {
    token = state.push('bullet_list_close', 'ul', -1);
  }
  token.markup = String.fromCharCode(markerCharCode);

  listLines[1] = nextLine;
  state.line = nextLine;

  state.parentType = oldParentType;

  // mark paragraphs tight if needed
  if (tight) {
    markTightParagraphs(state, listTokIdx);
  }

  return true;
};


/***/ }),
/* 2668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var normalizeReference   = __webpack_require__(28).normalizeReference;
var isSpace              = __webpack_require__(28).isSpace;


module.exports = function reference(state, startLine, _endLine, silent) {
  var ch,
      destEndPos,
      destEndLineNo,
      endLine,
      href,
      i,
      l,
      label,
      labelEnd,
      oldParentType,
      res,
      start,
      str,
      terminate,
      terminatorRules,
      title,
      lines = 0,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine],
      nextLine = startLine + 1;

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  if (state.src.charCodeAt(pos) !== 0x5B/* [ */) { return false; }

  // Simple check to quickly interrupt scan on [link](url) at the start of line.
  // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
  while (++pos < max) {
    if (state.src.charCodeAt(pos) === 0x5D /* ] */ &&
        state.src.charCodeAt(pos - 1) !== 0x5C/* \ */) {
      if (pos + 1 === max) { return false; }
      if (state.src.charCodeAt(pos + 1) !== 0x3A/* : */) { return false; }
      break;
    }
  }

  endLine = state.lineMax;

  // jump line-by-line until empty one or EOF
  terminatorRules = state.md.block.ruler.getRules('reference');

  oldParentType = state.parentType;
  state.parentType = 'reference';

  for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
    // this would be a code block normally, but after paragraph
    // it's considered a lazy continuation regardless of what's there
    if (state.sCount[nextLine] - state.blkIndent > 3) { continue; }

    // quirk for blockquotes, this line should already be checked by that rule
    if (state.sCount[nextLine] < 0) { continue; }

    // Some tags can terminate paragraph without empty line.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) { break; }
  }

  str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
  max = str.length;

  for (pos = 1; pos < max; pos++) {
    ch = str.charCodeAt(pos);
    if (ch === 0x5B /* [ */) {
      return false;
    } else if (ch === 0x5D /* ] */) {
      labelEnd = pos;
      break;
    } else if (ch === 0x0A /* \n */) {
      lines++;
    } else if (ch === 0x5C /* \ */) {
      pos++;
      if (pos < max && str.charCodeAt(pos) === 0x0A) {
        lines++;
      }
    }
  }

  if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A/* : */) { return false; }

  // [label]:   destination   'title'
  //         ^^^ skip optional whitespace here
  for (pos = labelEnd + 2; pos < max; pos++) {
    ch = str.charCodeAt(pos);
    if (ch === 0x0A) {
      lines++;
    } else if (isSpace(ch)) {
      /*eslint no-empty:0*/
    } else {
      break;
    }
  }

  // [label]:   destination   'title'
  //            ^^^^^^^^^^^ parse this
  res = state.md.helpers.parseLinkDestination(str, pos, max);
  if (!res.ok) { return false; }

  href = state.md.normalizeLink(res.str);
  if (!state.md.validateLink(href)) { return false; }

  pos = res.pos;
  lines += res.lines;

  // save cursor state, we could require to rollback later
  destEndPos = pos;
  destEndLineNo = lines;

  // [label]:   destination   'title'
  //                       ^^^ skipping those spaces
  start = pos;
  for (; pos < max; pos++) {
    ch = str.charCodeAt(pos);
    if (ch === 0x0A) {
      lines++;
    } else if (isSpace(ch)) {
      /*eslint no-empty:0*/
    } else {
      break;
    }
  }

  // [label]:   destination   'title'
  //                          ^^^^^^^ parse this
  res = state.md.helpers.parseLinkTitle(str, pos, max);
  if (pos < max && start !== pos && res.ok) {
    title = res.str;
    pos = res.pos;
    lines += res.lines;
  } else {
    title = '';
    pos = destEndPos;
    lines = destEndLineNo;
  }

  // skip trailing spaces until the rest of the line
  while (pos < max) {
    ch = str.charCodeAt(pos);
    if (!isSpace(ch)) { break; }
    pos++;
  }

  if (pos < max && str.charCodeAt(pos) !== 0x0A) {
    if (title) {
      // garbage at the end of the line after title,
      // but it could still be a valid reference if we roll back
      title = '';
      pos = destEndPos;
      lines = destEndLineNo;
      while (pos < max) {
        ch = str.charCodeAt(pos);
        if (!isSpace(ch)) { break; }
        pos++;
      }
    }
  }

  if (pos < max && str.charCodeAt(pos) !== 0x0A) {
    // garbage at the end of the line
    return false;
  }

  label = normalizeReference(str.slice(1, labelEnd));
  if (!label) {
    // CommonMark 0.20 disallows empty labels
    return false;
  }

  // Reference can not terminate anything. This check is for safety only.
  /*istanbul ignore if*/
  if (silent) { return true; }

  if (typeof state.env.references === 'undefined') {
    state.env.references = {};
  }
  if (typeof state.env.references[label] === 'undefined') {
    state.env.references[label] = { title: title, href: href };
  }

  state.parentType = oldParentType;

  state.line = startLine + lines + 1;
  return true;
};


/***/ }),
/* 2669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// heading (#, ##, ...)



var isSpace = __webpack_require__(28).isSpace;


module.exports = function heading(state, startLine, endLine, silent) {
  var ch, level, tmp, token,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  ch  = state.src.charCodeAt(pos);

  if (ch !== 0x23/* # */ || pos >= max) { return false; }

  // count heading level
  level = 1;
  ch = state.src.charCodeAt(++pos);
  while (ch === 0x23/* # */ && pos < max && level <= 6) {
    level++;
    ch = state.src.charCodeAt(++pos);
  }

  if (level > 6 || (pos < max && !isSpace(ch))) { return false; }

  if (silent) { return true; }

  // Let's cut tails like '    ###  ' from the end of string

  max = state.skipSpacesBack(max, pos);
  tmp = state.skipCharsBack(max, 0x23, pos); // #
  if (tmp > pos && isSpace(state.src.charCodeAt(tmp - 1))) {
    max = tmp;
  }

  state.line = startLine + 1;

  token        = state.push('heading_open', 'h' + String(level), 1);
  token.markup = '########'.slice(0, level);
  token.map    = [ startLine, state.line ];

  token          = state.push('inline', '', 0);
  token.content  = state.src.slice(pos, max).trim();
  token.map      = [ startLine, state.line ];
  token.children = [];

  token        = state.push('heading_close', 'h' + String(level), -1);
  token.markup = '########'.slice(0, level);

  return true;
};


/***/ }),
/* 2670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// lheading (---, ===)




module.exports = function lheading(state, startLine, endLine/*, silent*/) {
  var content, terminate, i, l, token, pos, max, level, marker,
      nextLine = startLine + 1, oldParentType,
      terminatorRules = state.md.block.ruler.getRules('paragraph');

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  oldParentType = state.parentType;
  state.parentType = 'paragraph'; // use paragraph to match terminatorRules

  // jump line-by-line until empty one or EOF
  for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
    // this would be a code block normally, but after paragraph
    // it's considered a lazy continuation regardless of what's there
    if (state.sCount[nextLine] - state.blkIndent > 3) { continue; }

    //
    // Check for underline in setext header
    //
    if (state.sCount[nextLine] >= state.blkIndent) {
      pos = state.bMarks[nextLine] + state.tShift[nextLine];
      max = state.eMarks[nextLine];

      if (pos < max) {
        marker = state.src.charCodeAt(pos);

        if (marker === 0x2D/* - */ || marker === 0x3D/* = */) {
          pos = state.skipChars(pos, marker);
          pos = state.skipSpaces(pos);

          if (pos >= max) {
            level = (marker === 0x3D/* = */ ? 1 : 2);
            break;
          }
        }
      }
    }

    // quirk for blockquotes, this line should already be checked by that rule
    if (state.sCount[nextLine] < 0) { continue; }

    // Some tags can terminate paragraph without empty line.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) { break; }
  }

  if (!level) {
    // Didn't find valid underline
    return false;
  }

  content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();

  state.line = nextLine + 1;

  token          = state.push('heading_open', 'h' + String(level), 1);
  token.markup   = String.fromCharCode(marker);
  token.map      = [ startLine, state.line ];

  token          = state.push('inline', '', 0);
  token.content  = content;
  token.map      = [ startLine, state.line - 1 ];
  token.children = [];

  token          = state.push('heading_close', 'h' + String(level), -1);
  token.markup   = String.fromCharCode(marker);

  state.parentType = oldParentType;

  return true;
};


/***/ }),
/* 2671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// HTML block




var block_names = __webpack_require__(2672);
var HTML_OPEN_CLOSE_TAG_RE = __webpack_require__(861).HTML_OPEN_CLOSE_TAG_RE;

// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var HTML_SEQUENCES = [
  [ /^<(script|pre|style)(?=(\s|>|$))/i, /<\/(script|pre|style)>/i, true ],
  [ /^<!--/,        /-->/,   true ],
  [ /^<\?/,         /\?>/,   true ],
  [ /^<![A-Z]/,     />/,     true ],
  [ /^<!\[CDATA\[/, /\]\]>/, true ],
  [ new RegExp('^</?(' + block_names.join('|') + ')(?=(\\s|/?>|$))', 'i'), /^$/, true ],
  [ new RegExp(HTML_OPEN_CLOSE_TAG_RE.source + '\\s*$'),  /^$/, false ]
];


module.exports = function html_block(state, startLine, endLine, silent) {
  var i, nextLine, token, lineText,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  if (!state.md.options.html) { return false; }

  if (state.src.charCodeAt(pos) !== 0x3C/* < */) { return false; }

  lineText = state.src.slice(pos, max);

  for (i = 0; i < HTML_SEQUENCES.length; i++) {
    if (HTML_SEQUENCES[i][0].test(lineText)) { break; }
  }

  if (i === HTML_SEQUENCES.length) { return false; }

  if (silent) {
    // true if this sequence can be a terminator, false otherwise
    return HTML_SEQUENCES[i][2];
  }

  nextLine = startLine + 1;

  // If we are here - we detected HTML block.
  // Let's roll down till block end.
  if (!HTML_SEQUENCES[i][1].test(lineText)) {
    for (; nextLine < endLine; nextLine++) {
      if (state.sCount[nextLine] < state.blkIndent) { break; }

      pos = state.bMarks[nextLine] + state.tShift[nextLine];
      max = state.eMarks[nextLine];
      lineText = state.src.slice(pos, max);

      if (HTML_SEQUENCES[i][1].test(lineText)) {
        if (lineText.length !== 0) { nextLine++; }
        break;
      }
    }
  }

  state.line = nextLine;

  token         = state.push('html_block', '', 0);
  token.map     = [ startLine, nextLine ];
  token.content = state.getLines(startLine, nextLine, state.blkIndent, true);

  return true;
};


/***/ }),
/* 2672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks




module.exports = [
  'address',
  'article',
  'aside',
  'base',
  'basefont',
  'blockquote',
  'body',
  'caption',
  'center',
  'col',
  'colgroup',
  'dd',
  'details',
  'dialog',
  'dir',
  'div',
  'dl',
  'dt',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'frame',
  'frameset',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'head',
  'header',
  'hr',
  'html',
  'iframe',
  'legend',
  'li',
  'link',
  'main',
  'menu',
  'menuitem',
  'meta',
  'nav',
  'noframes',
  'ol',
  'optgroup',
  'option',
  'p',
  'param',
  'section',
  'source',
  'summary',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'title',
  'tr',
  'track',
  'ul'
];


/***/ }),
/* 2673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Paragraph




module.exports = function paragraph(state, startLine/*, endLine*/) {
  var content, terminate, i, l, token, oldParentType,
      nextLine = startLine + 1,
      terminatorRules = state.md.block.ruler.getRules('paragraph'),
      endLine = state.lineMax;

  oldParentType = state.parentType;
  state.parentType = 'paragraph';

  // jump line-by-line until empty one or EOF
  for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
    // this would be a code block normally, but after paragraph
    // it's considered a lazy continuation regardless of what's there
    if (state.sCount[nextLine] - state.blkIndent > 3) { continue; }

    // quirk for blockquotes, this line should already be checked by that rule
    if (state.sCount[nextLine] < 0) { continue; }

    // Some tags can terminate paragraph without empty line.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) { break; }
  }

  content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();

  state.line = nextLine;

  token          = state.push('paragraph_open', 'p', 1);
  token.map      = [ startLine, state.line ];

  token          = state.push('inline', '', 0);
  token.content  = content;
  token.map      = [ startLine, state.line ];
  token.children = [];

  token          = state.push('paragraph_close', 'p', -1);

  state.parentType = oldParentType;

  return true;
};


/***/ }),
/* 2674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Parser state class



var Token = __webpack_require__(466);
var isSpace = __webpack_require__(28).isSpace;


function StateBlock(src, md, env, tokens) {
  var ch, s, start, pos, len, indent, offset, indent_found;

  this.src = src;

  // link to parser instance
  this.md     = md;

  this.env = env;

  //
  // Internal state vartiables
  //

  this.tokens = tokens;

  this.bMarks = [];  // line begin offsets for fast jumps
  this.eMarks = [];  // line end offsets for fast jumps
  this.tShift = [];  // offsets of the first non-space characters (tabs not expanded)
  this.sCount = [];  // indents for each line (tabs expanded)

  // An amount of virtual spaces (tabs expanded) between beginning
  // of each line (bMarks) and real beginning of that line.
  //
  // It exists only as a hack because blockquotes override bMarks
  // losing information in the process.
  //
  // It's used only when expanding tabs, you can think about it as
  // an initial tab length, e.g. bsCount=21 applied to string `\t123`
  // means first tab should be expanded to 4-21%4 === 3 spaces.
  //
  this.bsCount = [];

  // block parser variables
  this.blkIndent  = 0; // required block content indent
                       // (for example, if we are in list)
  this.line       = 0; // line index in src
  this.lineMax    = 0; // lines count
  this.tight      = false;  // loose/tight mode for lists
  this.ddIndent   = -1; // indent of the current dd block (-1 if there isn't any)

  // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
  // used in lists to determine if they interrupt a paragraph
  this.parentType = 'root';

  this.level = 0;

  // renderer
  this.result = '';

  // Create caches
  // Generate markers.
  s = this.src;
  indent_found = false;

  for (start = pos = indent = offset = 0, len = s.length; pos < len; pos++) {
    ch = s.charCodeAt(pos);

    if (!indent_found) {
      if (isSpace(ch)) {
        indent++;

        if (ch === 0x09) {
          offset += 4 - offset % 4;
        } else {
          offset++;
        }
        continue;
      } else {
        indent_found = true;
      }
    }

    if (ch === 0x0A || pos === len - 1) {
      if (ch !== 0x0A) { pos++; }
      this.bMarks.push(start);
      this.eMarks.push(pos);
      this.tShift.push(indent);
      this.sCount.push(offset);
      this.bsCount.push(0);

      indent_found = false;
      indent = 0;
      offset = 0;
      start = pos + 1;
    }
  }

  // Push fake entry to simplify cache bounds checks
  this.bMarks.push(s.length);
  this.eMarks.push(s.length);
  this.tShift.push(0);
  this.sCount.push(0);
  this.bsCount.push(0);

  this.lineMax = this.bMarks.length - 1; // don't count last fake line
}

// Push new token to "stream".
//
StateBlock.prototype.push = function (type, tag, nesting) {
  var token = new Token(type, tag, nesting);
  token.block = true;

  if (nesting < 0) { this.level--; }
  token.level = this.level;
  if (nesting > 0) { this.level++; }

  this.tokens.push(token);
  return token;
};

StateBlock.prototype.isEmpty = function isEmpty(line) {
  return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};

StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
  for (var max = this.lineMax; from < max; from++) {
    if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) {
      break;
    }
  }
  return from;
};

// Skip spaces from given position.
StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
  var ch;

  for (var max = this.src.length; pos < max; pos++) {
    ch = this.src.charCodeAt(pos);
    if (!isSpace(ch)) { break; }
  }
  return pos;
};

// Skip spaces from given position in reverse.
StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
  if (pos <= min) { return pos; }

  while (pos > min) {
    if (!isSpace(this.src.charCodeAt(--pos))) { return pos + 1; }
  }
  return pos;
};

// Skip char codes from given position
StateBlock.prototype.skipChars = function skipChars(pos, code) {
  for (var max = this.src.length; pos < max; pos++) {
    if (this.src.charCodeAt(pos) !== code) { break; }
  }
  return pos;
};

// Skip char codes reverse from given position - 1
StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
  if (pos <= min) { return pos; }

  while (pos > min) {
    if (code !== this.src.charCodeAt(--pos)) { return pos + 1; }
  }
  return pos;
};

// cut lines range from source.
StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
  var i, lineIndent, ch, first, last, queue, lineStart,
      line = begin;

  if (begin >= end) {
    return '';
  }

  queue = new Array(end - begin);

  for (i = 0; line < end; line++, i++) {
    lineIndent = 0;
    lineStart = first = this.bMarks[line];

    if (line + 1 < end || keepLastLF) {
      // No need for bounds check because we have fake entry on tail.
      last = this.eMarks[line] + 1;
    } else {
      last = this.eMarks[line];
    }

    while (first < last && lineIndent < indent) {
      ch = this.src.charCodeAt(first);

      if (isSpace(ch)) {
        if (ch === 0x09) {
          lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
        } else {
          lineIndent++;
        }
      } else if (first - lineStart < this.tShift[line]) {
        // patched tShift masked characters to look like spaces (blockquotes, list markers)
        lineIndent++;
      } else {
        break;
      }

      first++;
    }

    if (lineIndent > indent) {
      // partially expanding tabs in code blocks, e.g '\t\tfoobar'
      // with indent=2 becomes '  \tfoobar'
      queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
    } else {
      queue[i] = this.src.slice(first, last);
    }
  }

  return queue.join('');
};

// re-export Token class to use in block rules
StateBlock.prototype.Token = Token;


module.exports = StateBlock;


/***/ }),
/* 2675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/



var Ruler           = __webpack_require__(465);


////////////////////////////////////////////////////////////////////////////////
// Parser rules

var _rules = [
  [ 'text',            __webpack_require__(2676) ],
  [ 'newline',         __webpack_require__(2677) ],
  [ 'escape',          __webpack_require__(2678) ],
  [ 'backticks',       __webpack_require__(2679) ],
  [ 'strikethrough',   __webpack_require__(862).tokenize ],
  [ 'emphasis',        __webpack_require__(863).tokenize ],
  [ 'link',            __webpack_require__(2680) ],
  [ 'image',           __webpack_require__(2681) ],
  [ 'autolink',        __webpack_require__(2682) ],
  [ 'html_inline',     __webpack_require__(2683) ],
  [ 'entity',          __webpack_require__(2684) ]
];

var _rules2 = [
  [ 'balance_pairs',   __webpack_require__(2685) ],
  [ 'strikethrough',   __webpack_require__(862).postProcess ],
  [ 'emphasis',        __webpack_require__(863).postProcess ],
  [ 'text_collapse',   __webpack_require__(2686) ]
];


/**
 * new ParserInline()
 **/
function ParserInline() {
  var i;

  /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/
  this.ruler = new Ruler();

  for (i = 0; i < _rules.length; i++) {
    this.ruler.push(_rules[i][0], _rules[i][1]);
  }

  /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/
  this.ruler2 = new Ruler();

  for (i = 0; i < _rules2.length; i++) {
    this.ruler2.push(_rules2[i][0], _rules2[i][1]);
  }
}


// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
ParserInline.prototype.skipToken = function (state) {
  var ok, i, pos = state.pos,
      rules = this.ruler.getRules(''),
      len = rules.length,
      maxNesting = state.md.options.maxNesting,
      cache = state.cache;


  if (typeof cache[pos] !== 'undefined') {
    state.pos = cache[pos];
    return;
  }

  if (state.level < maxNesting) {
    for (i = 0; i < len; i++) {
      // Increment state.level and decrement it later to limit recursion.
      // It's harmless to do here, because no tokens are created. But ideally,
      // we'd need a separate private state variable for this purpose.
      //
      state.level++;
      ok = rules[i](state, true);
      state.level--;

      if (ok) { break; }
    }
  } else {
    // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
  }

  if (!ok) { state.pos++; }
  cache[pos] = state.pos;
};


// Generate tokens for input range
//
ParserInline.prototype.tokenize = function (state) {
  var ok, i,
      rules = this.ruler.getRules(''),
      len = rules.length,
      end = state.posMax,
      maxNesting = state.md.options.maxNesting;

  while (state.pos < end) {
    // Try all possible rules.
    // On success, rule should:
    //
    // - update `state.pos`
    // - update `state.tokens`
    // - return true

    if (state.level < maxNesting) {
      for (i = 0; i < len; i++) {
        ok = rules[i](state, false);
        if (ok) { break; }
      }
    }

    if (ok) {
      if (state.pos >= end) { break; }
      continue;
    }

    state.pending += state.src[state.pos++];
  }

  if (state.pending) {
    state.pushPending();
  }
};


/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/
ParserInline.prototype.parse = function (str, md, env, outTokens) {
  var i, rules, len;
  var state = new this.State(str, md, env, outTokens);

  this.tokenize(state);

  rules = this.ruler2.getRules('');
  len = rules.length;

  for (i = 0; i < len; i++) {
    rules[i](state);
  }
};


ParserInline.prototype.State = __webpack_require__(2687);


module.exports = ParserInline;


/***/ }),
/* 2676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Skip text characters for text token, place those to pending buffer
// and increment current pos




// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions

// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~

// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function isTerminatorChar(ch) {
  switch (ch) {
    case 0x0A/* \n */:
    case 0x21/* ! */:
    case 0x23/* # */:
    case 0x24/* $ */:
    case 0x25/* % */:
    case 0x26/* & */:
    case 0x2A/* * */:
    case 0x2B/* + */:
    case 0x2D/* - */:
    case 0x3A/* : */:
    case 0x3C/* < */:
    case 0x3D/* = */:
    case 0x3E/* > */:
    case 0x40/* @ */:
    case 0x5B/* [ */:
    case 0x5C/* \ */:
    case 0x5D/* ] */:
    case 0x5E/* ^ */:
    case 0x5F/* _ */:
    case 0x60/* ` */:
    case 0x7B/* { */:
    case 0x7D/* } */:
    case 0x7E/* ~ */:
      return true;
    default:
      return false;
  }
}

module.exports = function text(state, silent) {
  var pos = state.pos;

  while (pos < state.posMax && !isTerminatorChar(state.src.charCodeAt(pos))) {
    pos++;
  }

  if (pos === state.pos) { return false; }

  if (!silent) { state.pending += state.src.slice(state.pos, pos); }

  state.pos = pos;

  return true;
};

// Alternative implementation, for memory.
//
// It costs 10% of performance, but allows extend terminators list, if place it
// to `ParcerInline` property. Probably, will switch to it sometime, such
// flexibility required.

/*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
};*/


/***/ }),
/* 2677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Proceess '\n'



var isSpace = __webpack_require__(28).isSpace;


module.exports = function newline(state, silent) {
  var pmax, max, pos = state.pos;

  if (state.src.charCodeAt(pos) !== 0x0A/* \n */) { return false; }

  pmax = state.pending.length - 1;
  max = state.posMax;

  // '  \n' -> hardbreak
  // Lookup in pending chars is bad practice! Don't copy to other rules!
  // Pending string is stored in concat mode, indexed lookups will cause
  // convertion to flat mode.
  if (!silent) {
    if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
      if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
        state.pending = state.pending.replace(/ +$/, '');
        state.push('hardbreak', 'br', 0);
      } else {
        state.pending = state.pending.slice(0, -1);
        state.push('softbreak', 'br', 0);
      }

    } else {
      state.push('softbreak', 'br', 0);
    }
  }

  pos++;

  // skip heading spaces for next line
  while (pos < max && isSpace(state.src.charCodeAt(pos))) { pos++; }

  state.pos = pos;
  return true;
};


/***/ }),
/* 2678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process escaped chars and hardbreaks



var isSpace = __webpack_require__(28).isSpace;

var ESCAPED = [];

for (var i = 0; i < 256; i++) { ESCAPED.push(0); }

'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'
  .split('').forEach(function (ch) { ESCAPED[ch.charCodeAt(0)] = 1; });


module.exports = function escape(state, silent) {
  var ch, pos = state.pos, max = state.posMax;

  if (state.src.charCodeAt(pos) !== 0x5C/* \ */) { return false; }

  pos++;

  if (pos < max) {
    ch = state.src.charCodeAt(pos);

    if (ch < 256 && ESCAPED[ch] !== 0) {
      if (!silent) { state.pending += state.src[pos]; }
      state.pos += 2;
      return true;
    }

    if (ch === 0x0A) {
      if (!silent) {
        state.push('hardbreak', 'br', 0);
      }

      pos++;
      // skip leading whitespaces from next line
      while (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!isSpace(ch)) { break; }
        pos++;
      }

      state.pos = pos;
      return true;
    }
  }

  if (!silent) { state.pending += '\\'; }
  state.pos++;
  return true;
};


/***/ }),
/* 2679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Parse backticks



module.exports = function backtick(state, silent) {
  var start, max, marker, matchStart, matchEnd, token,
      pos = state.pos,
      ch = state.src.charCodeAt(pos);

  if (ch !== 0x60/* ` */) { return false; }

  start = pos;
  pos++;
  max = state.posMax;

  while (pos < max && state.src.charCodeAt(pos) === 0x60/* ` */) { pos++; }

  marker = state.src.slice(start, pos);

  matchStart = matchEnd = pos;

  while ((matchStart = state.src.indexOf('`', matchEnd)) !== -1) {
    matchEnd = matchStart + 1;

    while (matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60/* ` */) { matchEnd++; }

    if (matchEnd - matchStart === marker.length) {
      if (!silent) {
        token         = state.push('code_inline', 'code', 0);
        token.markup  = marker;
        token.content = state.src.slice(pos, matchStart)
                                 .replace(/[ \n]+/g, ' ')
                                 .trim();
      }
      state.pos = matchEnd;
      return true;
    }
  }

  if (!silent) { state.pending += marker; }
  state.pos += marker.length;
  return true;
};


/***/ }),
/* 2680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process [link](<to> "stuff")



var normalizeReference   = __webpack_require__(28).normalizeReference;
var isSpace              = __webpack_require__(28).isSpace;


module.exports = function link(state, silent) {
  var attrs,
      code,
      label,
      labelEnd,
      labelStart,
      pos,
      res,
      ref,
      title,
      token,
      href = '',
      oldPos = state.pos,
      max = state.posMax,
      start = state.pos,
      parseReference = true;

  if (state.src.charCodeAt(state.pos) !== 0x5B/* [ */) { return false; }

  labelStart = state.pos + 1;
  labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);

  // parser failed to find ']', so it's not a valid link
  if (labelEnd < 0) { return false; }

  pos = labelEnd + 1;
  if (pos < max && state.src.charCodeAt(pos) === 0x28/* ( */) {
    //
    // Inline link
    //

    // might have found a valid shortcut link, disable reference parsing
    parseReference = false;

    // [link](  <href>  "title"  )
    //        ^^ skipping these spaces
    pos++;
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (!isSpace(code) && code !== 0x0A) { break; }
    }
    if (pos >= max) { return false; }

    // [link](  <href>  "title"  )
    //          ^^^^^^ parsing link destination
    start = pos;
    res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
    if (res.ok) {
      href = state.md.normalizeLink(res.str);
      if (state.md.validateLink(href)) {
        pos = res.pos;
      } else {
        href = '';
      }
    }

    // [link](  <href>  "title"  )
    //                ^^ skipping these spaces
    start = pos;
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (!isSpace(code) && code !== 0x0A) { break; }
    }

    // [link](  <href>  "title"  )
    //                  ^^^^^^^ parsing link title
    res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
    if (pos < max && start !== pos && res.ok) {
      title = res.str;
      pos = res.pos;

      // [link](  <href>  "title"  )
      //                         ^^ skipping these spaces
      for (; pos < max; pos++) {
        code = state.src.charCodeAt(pos);
        if (!isSpace(code) && code !== 0x0A) { break; }
      }
    } else {
      title = '';
    }

    if (pos >= max || state.src.charCodeAt(pos) !== 0x29/* ) */) {
      // parsing a valid shortcut link failed, fallback to reference
      parseReference = true;
    }
    pos++;
  }

  if (parseReference) {
    //
    // Link reference
    //
    if (typeof state.env.references === 'undefined') { return false; }

    if (pos < max && state.src.charCodeAt(pos) === 0x5B/* [ */) {
      start = pos + 1;
      pos = state.md.helpers.parseLinkLabel(state, pos);
      if (pos >= 0) {
        label = state.src.slice(start, pos++);
      } else {
        pos = labelEnd + 1;
      }
    } else {
      pos = labelEnd + 1;
    }

    // covers label === '' and label === undefined
    // (collapsed reference link and shortcut reference link respectively)
    if (!label) { label = state.src.slice(labelStart, labelEnd); }

    ref = state.env.references[normalizeReference(label)];
    if (!ref) {
      state.pos = oldPos;
      return false;
    }
    href = ref.href;
    title = ref.title;
  }

  //
  // We found the end of the link, and know for a fact it's a valid link;
  // so all that's left to do is to call tokenizer.
  //
  if (!silent) {
    state.pos = labelStart;
    state.posMax = labelEnd;

    token        = state.push('link_open', 'a', 1);
    token.attrs  = attrs = [ [ 'href', href ] ];
    if (title) {
      attrs.push([ 'title', title ]);
    }

    state.md.inline.tokenize(state);

    token        = state.push('link_close', 'a', -1);
  }

  state.pos = pos;
  state.posMax = max;
  return true;
};


/***/ }),
/* 2681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process ![image](<src> "title")



var normalizeReference   = __webpack_require__(28).normalizeReference;
var isSpace              = __webpack_require__(28).isSpace;


module.exports = function image(state, silent) {
  var attrs,
      code,
      content,
      label,
      labelEnd,
      labelStart,
      pos,
      ref,
      res,
      title,
      token,
      tokens,
      start,
      href = '',
      oldPos = state.pos,
      max = state.posMax;

  if (state.src.charCodeAt(state.pos) !== 0x21/* ! */) { return false; }
  if (state.src.charCodeAt(state.pos + 1) !== 0x5B/* [ */) { return false; }

  labelStart = state.pos + 2;
  labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);

  // parser failed to find ']', so it's not a valid link
  if (labelEnd < 0) { return false; }

  pos = labelEnd + 1;
  if (pos < max && state.src.charCodeAt(pos) === 0x28/* ( */) {
    //
    // Inline link
    //

    // [link](  <href>  "title"  )
    //        ^^ skipping these spaces
    pos++;
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (!isSpace(code) && code !== 0x0A) { break; }
    }
    if (pos >= max) { return false; }

    // [link](  <href>  "title"  )
    //          ^^^^^^ parsing link destination
    start = pos;
    res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
    if (res.ok) {
      href = state.md.normalizeLink(res.str);
      if (state.md.validateLink(href)) {
        pos = res.pos;
      } else {
        href = '';
      }
    }

    // [link](  <href>  "title"  )
    //                ^^ skipping these spaces
    start = pos;
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (!isSpace(code) && code !== 0x0A) { break; }
    }

    // [link](  <href>  "title"  )
    //                  ^^^^^^^ parsing link title
    res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
    if (pos < max && start !== pos && res.ok) {
      title = res.str;
      pos = res.pos;

      // [link](  <href>  "title"  )
      //                         ^^ skipping these spaces
      for (; pos < max; pos++) {
        code = state.src.charCodeAt(pos);
        if (!isSpace(code) && code !== 0x0A) { break; }
      }
    } else {
      title = '';
    }

    if (pos >= max || state.src.charCodeAt(pos) !== 0x29/* ) */) {
      state.pos = oldPos;
      return false;
    }
    pos++;
  } else {
    //
    // Link reference
    //
    if (typeof state.env.references === 'undefined') { return false; }

    if (pos < max && state.src.charCodeAt(pos) === 0x5B/* [ */) {
      start = pos + 1;
      pos = state.md.helpers.parseLinkLabel(state, pos);
      if (pos >= 0) {
        label = state.src.slice(start, pos++);
      } else {
        pos = labelEnd + 1;
      }
    } else {
      pos = labelEnd + 1;
    }

    // covers label === '' and label === undefined
    // (collapsed reference link and shortcut reference link respectively)
    if (!label) { label = state.src.slice(labelStart, labelEnd); }

    ref = state.env.references[normalizeReference(label)];
    if (!ref) {
      state.pos = oldPos;
      return false;
    }
    href = ref.href;
    title = ref.title;
  }

  //
  // We found the end of the link, and know for a fact it's a valid link;
  // so all that's left to do is to call tokenizer.
  //
  if (!silent) {
    content = state.src.slice(labelStart, labelEnd);

    state.md.inline.parse(
      content,
      state.md,
      state.env,
      tokens = []
    );

    token          = state.push('image', 'img', 0);
    token.attrs    = attrs = [ [ 'src', href ], [ 'alt', '' ] ];
    token.children = tokens;
    token.content  = content;

    if (title) {
      attrs.push([ 'title', title ]);
    }
  }

  state.pos = pos;
  state.posMax = max;
  return true;
};


/***/ }),
/* 2682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process autolinks '<protocol:...>'




/*eslint max-len:0*/
var EMAIL_RE    = /^<([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)>/;
var AUTOLINK_RE = /^<([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)>/;


module.exports = function autolink(state, silent) {
  var tail, linkMatch, emailMatch, url, fullUrl, token,
      pos = state.pos;

  if (state.src.charCodeAt(pos) !== 0x3C/* < */) { return false; }

  tail = state.src.slice(pos);

  if (tail.indexOf('>') < 0) { return false; }

  if (AUTOLINK_RE.test(tail)) {
    linkMatch = tail.match(AUTOLINK_RE);

    url = linkMatch[0].slice(1, -1);
    fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) { return false; }

    if (!silent) {
      token         = state.push('link_open', 'a', 1);
      token.attrs   = [ [ 'href', fullUrl ] ];
      token.markup  = 'autolink';
      token.info    = 'auto';

      token         = state.push('text', '', 0);
      token.content = state.md.normalizeLinkText(url);

      token         = state.push('link_close', 'a', -1);
      token.markup  = 'autolink';
      token.info    = 'auto';
    }

    state.pos += linkMatch[0].length;
    return true;
  }

  if (EMAIL_RE.test(tail)) {
    emailMatch = tail.match(EMAIL_RE);

    url = emailMatch[0].slice(1, -1);
    fullUrl = state.md.normalizeLink('mailto:' + url);
    if (!state.md.validateLink(fullUrl)) { return false; }

    if (!silent) {
      token         = state.push('link_open', 'a', 1);
      token.attrs   = [ [ 'href', fullUrl ] ];
      token.markup  = 'autolink';
      token.info    = 'auto';

      token         = state.push('text', '', 0);
      token.content = state.md.normalizeLinkText(url);

      token         = state.push('link_close', 'a', -1);
      token.markup  = 'autolink';
      token.info    = 'auto';
    }

    state.pos += emailMatch[0].length;
    return true;
  }

  return false;
};


/***/ }),
/* 2683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process html tags




var HTML_TAG_RE = __webpack_require__(861).HTML_TAG_RE;


function isLetter(ch) {
  /*eslint no-bitwise:0*/
  var lc = ch | 0x20; // to lower case
  return (lc >= 0x61/* a */) && (lc <= 0x7a/* z */);
}


module.exports = function html_inline(state, silent) {
  var ch, match, max, token,
      pos = state.pos;

  if (!state.md.options.html) { return false; }

  // Check start
  max = state.posMax;
  if (state.src.charCodeAt(pos) !== 0x3C/* < */ ||
      pos + 2 >= max) {
    return false;
  }

  // Quick fail on second char
  ch = state.src.charCodeAt(pos + 1);
  if (ch !== 0x21/* ! */ &&
      ch !== 0x3F/* ? */ &&
      ch !== 0x2F/* / */ &&
      !isLetter(ch)) {
    return false;
  }

  match = state.src.slice(pos).match(HTML_TAG_RE);
  if (!match) { return false; }

  if (!silent) {
    token         = state.push('html_inline', '', 0);
    token.content = state.src.slice(pos, pos + match[0].length);
  }
  state.pos += match[0].length;
  return true;
};


/***/ }),
/* 2684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process html entity - &#123;, &#xAF;, &quot;, ...



var entities          = __webpack_require__(859);
var has               = __webpack_require__(28).has;
var isValidEntityCode = __webpack_require__(28).isValidEntityCode;
var fromCodePoint     = __webpack_require__(28).fromCodePoint;


var DIGITAL_RE = /^&#((?:x[a-f0-9]{1,8}|[0-9]{1,8}));/i;
var NAMED_RE   = /^&([a-z][a-z0-9]{1,31});/i;


module.exports = function entity(state, silent) {
  var ch, code, match, pos = state.pos, max = state.posMax;

  if (state.src.charCodeAt(pos) !== 0x26/* & */) { return false; }

  if (pos + 1 < max) {
    ch = state.src.charCodeAt(pos + 1);

    if (ch === 0x23 /* # */) {
      match = state.src.slice(pos).match(DIGITAL_RE);
      if (match) {
        if (!silent) {
          code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
          state.pending += isValidEntityCode(code) ? fromCodePoint(code) : fromCodePoint(0xFFFD);
        }
        state.pos += match[0].length;
        return true;
      }
    } else {
      match = state.src.slice(pos).match(NAMED_RE);
      if (match) {
        if (has(entities, match[1])) {
          if (!silent) { state.pending += entities[match[1]]; }
          state.pos += match[0].length;
          return true;
        }
      }
    }
  }

  if (!silent) { state.pending += '&'; }
  state.pos++;
  return true;
};


/***/ }),
/* 2685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// For each opening emphasis-like marker find a matching closing one
//



module.exports = function link_pairs(state) {
  var i, j, lastDelim, currDelim,
      delimiters = state.delimiters,
      max = state.delimiters.length;

  for (i = 0; i < max; i++) {
    lastDelim = delimiters[i];

    if (!lastDelim.close) { continue; }

    j = i - lastDelim.jump - 1;

    while (j >= 0) {
      currDelim = delimiters[j];

      if (currDelim.open &&
          currDelim.marker === lastDelim.marker &&
          currDelim.end < 0 &&
          currDelim.level === lastDelim.level) {

        // typeofs are for backward compatibility with plugins
        var odd_match = (currDelim.close || lastDelim.open) &&
                        typeof currDelim.length !== 'undefined' &&
                        typeof lastDelim.length !== 'undefined' &&
                        (currDelim.length + lastDelim.length) % 3 === 0;

        if (!odd_match) {
          lastDelim.jump = i - j;
          lastDelim.open = false;
          currDelim.end  = i;
          currDelim.jump = 0;
          break;
        }
      }

      j -= currDelim.jump + 1;
    }
  }
};


/***/ }),
/* 2686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Merge adjacent text nodes into one, and re-calculate all token levels
//



module.exports = function text_collapse(state) {
  var curr, last,
      level = 0,
      tokens = state.tokens,
      max = state.tokens.length;

  for (curr = last = 0; curr < max; curr++) {
    // re-calculate levels
    level += tokens[curr].nesting;
    tokens[curr].level = level;

    if (tokens[curr].type === 'text' &&
        curr + 1 < max &&
        tokens[curr + 1].type === 'text') {

      // collapse two adjacent text nodes
      tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
    } else {
      if (curr !== last) { tokens[last] = tokens[curr]; }

      last++;
    }
  }

  if (curr !== last) {
    tokens.length = last;
  }
};


/***/ }),
/* 2687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Inline parser state




var Token          = __webpack_require__(466);
var isWhiteSpace   = __webpack_require__(28).isWhiteSpace;
var isPunctChar    = __webpack_require__(28).isPunctChar;
var isMdAsciiPunct = __webpack_require__(28).isMdAsciiPunct;


function StateInline(src, md, env, outTokens) {
  this.src = src;
  this.env = env;
  this.md = md;
  this.tokens = outTokens;

  this.pos = 0;
  this.posMax = this.src.length;
  this.level = 0;
  this.pending = '';
  this.pendingLevel = 0;

  this.cache = {};        // Stores { start: end } pairs. Useful for backtrack
                          // optimization of pairs parse (emphasis, strikes).

  this.delimiters = [];   // Emphasis-like delimiters
}


// Flush pending text
//
StateInline.prototype.pushPending = function () {
  var token = new Token('text', '', 0);
  token.content = this.pending;
  token.level = this.pendingLevel;
  this.tokens.push(token);
  this.pending = '';
  return token;
};


// Push new token to "stream".
// If pending text exists - flush it as text token
//
StateInline.prototype.push = function (type, tag, nesting) {
  if (this.pending) {
    this.pushPending();
  }

  var token = new Token(type, tag, nesting);

  if (nesting < 0) { this.level--; }
  token.level = this.level;
  if (nesting > 0) { this.level++; }

  this.pendingLevel = this.level;
  this.tokens.push(token);
  return token;
};


// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
StateInline.prototype.scanDelims = function (start, canSplitWord) {
  var pos = start, lastChar, nextChar, count, can_open, can_close,
      isLastWhiteSpace, isLastPunctChar,
      isNextWhiteSpace, isNextPunctChar,
      left_flanking = true,
      right_flanking = true,
      max = this.posMax,
      marker = this.src.charCodeAt(start);

  // treat beginning of the line as a whitespace
  lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;

  while (pos < max && this.src.charCodeAt(pos) === marker) { pos++; }

  count = pos - start;

  // treat end of the line as a whitespace
  nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;

  isLastPunctChar = isMdAsciiPunct(lastChar) || isPunctChar(String.fromCharCode(lastChar));
  isNextPunctChar = isMdAsciiPunct(nextChar) || isPunctChar(String.fromCharCode(nextChar));

  isLastWhiteSpace = isWhiteSpace(lastChar);
  isNextWhiteSpace = isWhiteSpace(nextChar);

  if (isNextWhiteSpace) {
    left_flanking = false;
  } else if (isNextPunctChar) {
    if (!(isLastWhiteSpace || isLastPunctChar)) {
      left_flanking = false;
    }
  }

  if (isLastWhiteSpace) {
    right_flanking = false;
  } else if (isLastPunctChar) {
    if (!(isNextWhiteSpace || isNextPunctChar)) {
      right_flanking = false;
    }
  }

  if (!canSplitWord) {
    can_open  = left_flanking  && (!right_flanking || isLastPunctChar);
    can_close = right_flanking && (!left_flanking  || isNextPunctChar);
  } else {
    can_open  = left_flanking;
    can_close = right_flanking;
  }

  return {
    can_open:  can_open,
    can_close: can_close,
    length:    count
  };
};


// re-export Token class to use in block rules
StateInline.prototype.Token = Token;


module.exports = StateInline;


/***/ }),
/* 2688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// markdown-it default options




module.exports = {
  options: {
    html:         false,        // Enable HTML tags in source
    xhtmlOut:     false,        // Use '/' to close single tags (<br />)
    breaks:       false,        // Convert '\n' in paragraphs into <br>
    langPrefix:   'language-',  // CSS language prefix for fenced blocks
    linkify:      false,        // autoconvert URL-like texts to links

    // Enable some language-neutral replacements + quotes beautification
    typographer:  false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: '\u201c\u201d\u2018\u2019', /* “”‘’ */

    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,

    maxNesting:   100            // Internal protection, recursion limit
  },

  components: {

    core: {},
    block: {},
    inline: {}
  }
};


/***/ }),
/* 2689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.




module.exports = {
  options: {
    html:         false,        // Enable HTML tags in source
    xhtmlOut:     false,        // Use '/' to close single tags (<br />)
    breaks:       false,        // Convert '\n' in paragraphs into <br>
    langPrefix:   'language-',  // CSS language prefix for fenced blocks
    linkify:      false,        // autoconvert URL-like texts to links

    // Enable some language-neutral replacements + quotes beautification
    typographer:  false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: '\u201c\u201d\u2018\u2019', /* “”‘’ */

    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,

    maxNesting:   20            // Internal protection, recursion limit
  },

  components: {

    core: {
      rules: [
        'normalize',
        'block',
        'inline'
      ]
    },

    block: {
      rules: [
        'paragraph'
      ]
    },

    inline: {
      rules: [
        'text'
      ],
      rules2: [
        'balance_pairs',
        'text_collapse'
      ]
    }
  }
};


/***/ }),
/* 2690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Commonmark default options




module.exports = {
  options: {
    html:         true,         // Enable HTML tags in source
    xhtmlOut:     true,         // Use '/' to close single tags (<br />)
    breaks:       false,        // Convert '\n' in paragraphs into <br>
    langPrefix:   'language-',  // CSS language prefix for fenced blocks
    linkify:      false,        // autoconvert URL-like texts to links

    // Enable some language-neutral replacements + quotes beautification
    typographer:  false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: '\u201c\u201d\u2018\u2019', /* “”‘’ */

    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,

    maxNesting:   20            // Internal protection, recursion limit
  },

  components: {

    core: {
      rules: [
        'normalize',
        'block',
        'inline'
      ]
    },

    block: {
      rules: [
        'blockquote',
        'code',
        'fence',
        'heading',
        'hr',
        'html_block',
        'lheading',
        'list',
        'reference',
        'paragraph'
      ]
    },

    inline: {
      rules: [
        'autolink',
        'backticks',
        'emphasis',
        'entity',
        'escape',
        'html_inline',
        'image',
        'link',
        'newline',
        'text'
      ],
      rules2: [
        'balance_pairs',
        'emphasis',
        'text_collapse'
      ]
    }
  }
};


/***/ }),
/* 2691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MarkdownTransformer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_markdown_it__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_markdown_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_markdown_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_markdown_it_table__ = __webpack_require__(2692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_markdown__ = __webpack_require__(2694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__media__ = __webpack_require__(2695);





function filterMdToPmSchemaMapping(schema, map) {
    return Object.keys(map).reduce(function (newMap, key) {
        var value = map[key];
        var block = value.block || value.node;
        var mark = value.mark;
        if ((block && schema.nodes[block]) || (mark && schema.marks[mark])) {
            newMap[key] = value;
        }
        return newMap;
    }, {});
}
var pmSchemaToMdMapping = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: ['heading', 'lheading'],
        codeBlock: ['code', 'fence'],
        listItem: 'list',
        image: 'image',
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: ['link', 'autolink', 'reference', 'linkify'],
        strike: 'strikethrough',
        code: 'backticks',
    },
};
var mdToPmMapping = {
    blockquote: { block: 'blockquote' },
    paragraph: { block: 'paragraph' },
    em: { mark: 'em' },
    strong: { mark: 'strong' },
    link: {
        mark: 'link',
        attrs: function (tok) { return ({
            href: tok.attrGet('href'),
            title: tok.attrGet('title') || null,
        }); },
    },
    hr: { node: 'rule' },
    heading: {
        block: 'heading',
        attrs: function (tok) { return ({ level: +tok.tag.slice(1) }); },
    },
    softbreak: { node: 'hardBreak' },
    hardbreak: { node: 'hardBreak' },
    code_block: { block: 'codeBlock' },
    list_item: { block: 'listItem' },
    bullet_list: { block: 'bulletList' },
    ordered_list: {
        block: 'orderedList',
        attrs: function (tok) { return ({ order: +tok.attrGet('order') || 1 }); },
    },
    code_inline: { mark: 'code' },
    fence: {
        block: 'codeBlock',
        attrs: function (tok) { return ({ language: tok.info || null }); },
    },
    media_single: {
        block: 'mediaSingle',
        attrs: function (tok) {
            return {};
        },
    },
    media: {
        node: 'media',
        attrs: function (tok) {
            return {
                url: tok.attrGet('url'),
                type: 'external',
            };
        },
    },
    emoji: {
        node: 'emoji',
        attrs: function (tok) { return ({
            shortName: ":" + tok.markup + ":",
            text: tok.content,
        }); },
    },
    table: { block: 'table' },
    tr: { block: 'tableRow' },
    th: { block: 'tableHeader' },
    td: { block: 'tableCell' },
    s: { mark: 'strike' },
};
var md = __WEBPACK_IMPORTED_MODULE_1_markdown_it__('zero', {
    html: false,
    linkify: true,
});
md.enable([
    // Process html entity - &#123;, &#xAF;, &quot;, ...
    'entity',
    // Process escaped chars and hardbreaks
    'escape',
]);
var MarkdownTransformer = /** @class */ (function () {
    function MarkdownTransformer(schema, tokenizer) {
        if (schema === void 0) { schema = __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["x" /* defaultSchema */]; }
        if (tokenizer === void 0) { tokenizer = md; }
        // Enable markdown plugins based on schema
        ['nodes', 'marks'].forEach(function (key) {
            for (var idx in pmSchemaToMdMapping[key]) {
                if (schema[key][idx]) {
                    tokenizer.enable(pmSchemaToMdMapping[key][idx]);
                }
            }
        });
        if (schema.nodes.table) {
            tokenizer.use(__WEBPACK_IMPORTED_MODULE_2_markdown_it_table__["a" /* markdownItTable */]);
        }
        if (schema.nodes.media && schema.nodes.mediaSingle) {
            tokenizer.use(__WEBPACK_IMPORTED_MODULE_4__media__["a" /* markdownItMedia */]);
        }
        this.markdownParser = new __WEBPACK_IMPORTED_MODULE_3_prosemirror_markdown__["MarkdownParser"](schema, tokenizer, filterMdToPmSchemaMapping(schema, mdToPmMapping));
    }
    MarkdownTransformer.prototype.encode = function (node) {
        throw new Error('This is not implemented yet');
    };
    MarkdownTransformer.prototype.parse = function (content) {
        return this.markdownParser.parse(content);
    };
    return MarkdownTransformer;
}());

//# sourceMappingURL=index.js.map

/***/ }),
/* 2692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return markdownItTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__(2693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__table__);


var markdownItTable = function markdownItTable(md, options) {
  md.block.ruler.before('paragraph', 'table', __WEBPACK_IMPORTED_MODULE_0__table___default.a, {
    alt: ['paragraph', 'reference']
  });
};

/***/ }),
/* 2693 */
/***/ (function(module, exports) {

// Copied from https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/table.js

function isSpace(code) {
  switch (code) {
    case 0x09:
    case 0x20:
      return true;
  }
  return false;
}

function getLine(state, line) {
  var pos = state.bMarks[line] + state.blkIndent,
      max = state.eMarks[line];

  return state.src.substr(pos, max - pos);
}

function escapedSplit(str) {
  var result = [],
      pos = 0,
      max = str.length,
      ch,
      escapes = 0,
      lastPos = 0,
      backTicked = false,
      lastBackTick = 0;

  ch = str.charCodeAt(pos);

  while (pos < max) {
    if (ch === 0x60 /* ` */) {
        if (backTicked) {
          // make \` close code sequence, but not open it;
          // the reason is: `\` is correct code block
          backTicked = false;
          lastBackTick = pos;
        } else if (escapes % 2 === 0) {
          backTicked = true;
          lastBackTick = pos;
        }
      } else if (ch === 0x7c /* | */ && escapes % 2 === 0 && !backTicked) {
      result.push(str.substring(lastPos, pos));
      lastPos = pos + 1;
    }

    if (ch === 0x5c /* \ */) {
        escapes++;
      } else {
      escapes = 0;
    }

    pos++;

    // If there was an un-closed backtick, go back to just after
    // the last backtick, but as if it was a normal character
    if (pos === max && backTicked) {
      backTicked = false;
      pos = lastBackTick + 1;
    }

    ch = str.charCodeAt(pos);
  }

  result.push(str.substring(lastPos));

  return result;
}

module.exports = function table(state, startLine, endLine, silent) {
  var ch, lineText, pos, i, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines;

  // should have at least two lines
  if (startLine + 2 > endLine) {
    return false;
  }

  nextLine = startLine + 1;

  if (state.sCount[nextLine] < state.blkIndent) {
    return false;
  }

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[nextLine] - state.blkIndent >= 4) {
    return false;
  }

  // first character of the second line should be '|', '-', ':',
  // and no other characters are allowed but spaces;
  // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp

  pos = state.bMarks[nextLine] + state.tShift[nextLine];
  if (pos >= state.eMarks[nextLine]) {
    return false;
  }

  ch = state.src.charCodeAt(pos++);
  if (ch !== 0x7c /* | */ && ch !== 0x2d /* - */ && ch !== 0x3a /* : */) {
      return false;
    }

  while (pos < state.eMarks[nextLine]) {
    ch = state.src.charCodeAt(pos);

    if (ch !== 0x7c /* | */ && ch !== 0x2d /* - */ && ch !== 0x3a /* : */ && !isSpace(ch)) {
      return false;
    }

    pos++;
  }

  lineText = getLine(state, startLine + 1);

  columns = lineText.split('|');
  aligns = [];
  for (i = 0; i < columns.length; i++) {
    t = columns[i].trim();
    if (!t) {
      // allow empty columns before and after table, but not in between columns;
      // e.g. allow ` |---| `, disallow ` ---||--- `
      if (i === 0 || i === columns.length - 1) {
        continue;
      } else {
        return false;
      }
    }

    if (!/^:?-+:?$/.test(t)) {
      return false;
    }
    if (t.charCodeAt(t.length - 1) === 0x3a /* : */) {
        aligns.push(t.charCodeAt(0) === 0x3a /* : */ ? 'center' : 'right');
      } else if (t.charCodeAt(0) === 0x3a /* : */) {
        aligns.push('left');
      } else {
      aligns.push('');
    }
  }

  lineText = getLine(state, startLine).trim();
  if (lineText.indexOf('|') === -1) {
    return false;
  }
  if (state.sCount[startLine] - state.blkIndent >= 4) {
    return false;
  }
  columns = escapedSplit(lineText.replace(/^\||\|$/g, ''));

  // header row will define an amount of columns in the entire table,
  // and align row shouldn't be smaller than that (the rest of the rows can)
  columnCount = columns.length;
  if (columnCount > aligns.length) {
    return false;
  }

  if (silent) {
    return true;
  }

  token = state.push('table_open', 'table', 1);
  token.map = tableLines = [startLine, 0];

  // token     = state.push('thead_open', 'thead', 1);
  // token.map = [ startLine, startLine + 1 ];

  token = state.push('tr_open', 'tr', 1);
  token.map = [startLine, startLine + 1];

  for (i = 0; i < columns.length; i++) {
    token = state.push('th_open', 'th', 1);
    token.map = [startLine, startLine + 1];
    if (aligns[i]) {
      token.attrs = [['style', 'text-align:' + aligns[i]]];
    }

    token = state.push('paragraph_open', 'p', 1);
    token = state.push('inline', '', 0);
    token.content = columns[i].trim();
    token.map = [startLine, startLine + 1];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);

    token = state.push('th_close', 'th', -1);
  }

  token = state.push('tr_close', 'tr', -1);
  // token     = state.push('thead_close', 'thead', -1);

  // token     = state.push('tbody_open', 'tbody', 1);
  token.map = tbodyLines = [startLine + 2, 0];

  for (nextLine = startLine + 2; nextLine < endLine; nextLine++) {
    if (state.sCount[nextLine] < state.blkIndent) {
      break;
    }

    lineText = getLine(state, nextLine).trim();
    if (lineText.indexOf('|') === -1) {
      break;
    }
    if (state.sCount[nextLine] - state.blkIndent >= 4) {
      break;
    }
    columns = escapedSplit(lineText.replace(/^\||\|$/g, ''));

    token = state.push('tr_open', 'tr', 1);

    for (var _i = 0, offset = 1; _i < columns.length; _i++) {
      token = state.push('td_open', 'td', 1);
      if (aligns[_i]) {
        token.attrs = [['style', 'text-align:' + aligns[_i]]];
      }

      // https://github.com/markdown-it/markdown-it/blob/e6f19eab4204122e85e4a342e0c1c8486ff40c2d/lib/rules_block/state_block.js#L25
      // bMarks => line begin offsets for fast jumps
      // eMarks => line end offsets for fast jumps
      // tShift => offsets of the first non-space characters (tabs not expanded)
      // sCount => indents for each line (tabs expanded)

      // Move bMarks when first char is ' ' for > to work
      var shift = columns[_i][0] === ' ' || /^(\d+\.|\*|-)$/.test(columns[_i].trim()) ? 1 : 0;
      state.bMarks[nextLine] += offset + shift;
      offset = (columns[_i] || '').length + (shift ? 0 : 1);
      state.eMarks[nextLine] = state.bMarks[nextLine] + offset - 1;
      state.lineMax = 1;
      state.md.block.tokenize(state, nextLine, nextLine + 1);

      token = state.push('td_close', 'td', -1);
    }

    token = state.push('tr_close', 'tr', -1);
  }
  // token = state.push('tbody_close', 'tbody', -1);
  token = state.push('table_close', 'table', -1);

  tableLines[1] = tbodyLines[1] = nextLine;
  state.line = nextLine;
  return true;
};

/***/ }),
/* 2694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var prosemirrorModel = __webpack_require__(23);
var markdownit = _interopDefault(__webpack_require__(464));

// ::Schema Document schema for the data model used by CommonMark.
var schema = new prosemirrorModel.Schema({
  nodes: {
    doc: {
      content: "block+"
    },

    paragraph: {
      content: "inline*",
      group: "block",
      parseDOM: [{tag: "p"}],
      toDOM: function toDOM() { return ["p", 0] }
    },

    blockquote: {
      content: "block+",
      group: "block",
      parseDOM: [{tag: "blockquote"}],
      toDOM: function toDOM() { return ["blockquote", 0] }
    },

    horizontal_rule: {
      group: "block",
      parseDOM: [{tag: "hr"}],
      toDOM: function toDOM() { return ["div", ["hr"]] }
    },

    heading: {
      attrs: {level: {default: 1}},
      content: "inline*",
      group: "block",
      defining: true,
      parseDOM: [{tag: "h1", attrs: {level: 1}},
                 {tag: "h2", attrs: {level: 2}},
                 {tag: "h3", attrs: {level: 3}},
                 {tag: "h4", attrs: {level: 4}},
                 {tag: "h5", attrs: {level: 5}},
                 {tag: "h6", attrs: {level: 6}}],
      toDOM: function toDOM(node) { return ["h" + node.attrs.level, 0] }
    },

    code_block: {
      content: "text*",
      group: "block",
      code: true,
      defining: true,
      attrs: {params: {default: ""}},
      parseDOM: [{tag: "pre", preserveWhitespace: true, getAttrs: function (node) { return ({params: node.getAttribute("data-params")}); }}],
      toDOM: function toDOM(node) { return ["pre", node.attrs.params ? {"data-params": node.attrs.params} : {}, ["code", 0]] }
    },

    ordered_list: {
      content: "list_item+",
      group: "block",
      attrs: {order: {default: 1}, tight: {default: false}},
      parseDOM: [{tag: "ol", getAttrs: function getAttrs(dom) {
        return {order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1,
                tight: dom.hasAttribute("data-tight")}
      }}],
      toDOM: function toDOM(node) {
        return ["ol", {start: node.attrs.order == 1 ? null : node.attrs.order,
                       "data-tight": node.attrs.tight ? "true" : null}, 0]
      }
    },

    bullet_list: {
      content: "list_item+",
      group: "block",
      attrs: {tight: {default: false}},
      parseDOM: [{tag: "ul", getAttrs: function (dom) { return ({tight: dom.hasAttribute("data-tight")}); }}],
      toDOM: function toDOM(node) { return ["ul", {"data-tight": node.attrs.tight ? "true" : null}, 0] }
    },

    list_item: {
      content: "paragraph block*",
      defining: true,
      parseDOM: [{tag: "li"}],
      toDOM: function toDOM() { return ["li", 0] }
    },

    text: {
      group: "inline",
      toDOM: function toDOM(node) { return node.text }
    },

    image: {
      inline: true,
      attrs: {
        src: {},
        alt: {default: null},
        title: {default: null}
      },
      group: "inline",
      draggable: true,
      parseDOM: [{tag: "img[src]", getAttrs: function getAttrs(dom) {
        return {
          src: dom.getAttribute("src"),
          title: dom.getAttribute("title"),
          alt: dom.getAttribute("alt")
        }
      }}],
      toDOM: function toDOM(node) { return ["img", node.attrs] }
    },

    hard_break: {
      inline: true,
      group: "inline",
      selectable: false,
      parseDOM: [{tag: "br"}],
      toDOM: function toDOM() { return ["br"] }
    }
  },

  marks: {
    em: {
      parseDOM: [{tag: "i"}, {tag: "em"},
                 {style: "font-style", getAttrs: function (value) { return value == "italic" && null; }}],
      toDOM: function toDOM() { return ["em"] }
    },

    strong: {
      parseDOM: [{tag: "b"}, {tag: "strong"},
                 {style: "font-weight", getAttrs: function (value) { return /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null; }}],
      toDOM: function toDOM() { return ["strong"] }
    },

    link: {
      attrs: {
        href: {},
        title: {default: null}
      },
      inclusive: false,
      parseDOM: [{tag: "a[href]", getAttrs: function getAttrs(dom) {
        return {href: dom.getAttribute("href"), title: dom.getAttribute("title")}
      }}],
      toDOM: function toDOM(node) { return ["a", node.attrs] }
    },

    code: {
      parseDOM: [{tag: "code"}],
      toDOM: function toDOM() { return ["code"] }
    }
  }
});

function maybeMerge(a, b) {
  if (a.isText && b.isText && prosemirrorModel.Mark.sameSet(a.marks, b.marks))
    { return a.copy(a.text + b.text) }
}

// Object used to track the context of a running parse.
var MarkdownParseState = function MarkdownParseState(schema$$1, tokenHandlers) {
  this.schema = schema$$1;
  this.stack = [{type: schema$$1.topNodeType, content: []}];
  this.marks = prosemirrorModel.Mark.none;
  this.tokenHandlers = tokenHandlers;
};

MarkdownParseState.prototype.top = function top () {
  return this.stack[this.stack.length - 1]
};

MarkdownParseState.prototype.push = function push (elt) {
  if (this.stack.length) { this.top().content.push(elt); }
};

// : (string)
// Adds the given text to the current position in the document,
// using the current marks as styling.
MarkdownParseState.prototype.addText = function addText (text) {
  if (!text) { return }
  var nodes = this.top().content, last = nodes[nodes.length - 1];
  var node = this.schema.text(text, this.marks), merged;
  if (last && (merged = maybeMerge(last, node))) { nodes[nodes.length - 1] = merged; }
  else { nodes.push(node); }
};

// : (Mark)
// Adds the given mark to the set of active marks.
MarkdownParseState.prototype.openMark = function openMark (mark) {
  this.marks = mark.addToSet(this.marks);
};

// : (Mark)
// Removes the given mark from the set of active marks.
MarkdownParseState.prototype.closeMark = function closeMark (mark) {
  this.marks = mark.removeFromSet(this.marks);
};

MarkdownParseState.prototype.parseTokens = function parseTokens (toks) {
    var this$1 = this;

  for (var i = 0; i < toks.length; i++) {
    var tok = toks[i];
    var handler = this$1.tokenHandlers[tok.type];
    if (!handler)
      { throw new Error("Token type `" + tok.type + "` not supported by Markdown parser") }
    handler(this$1, tok);
  }
};

// : (NodeType, ?Object, ?[Node]) → ?Node
// Add a node at the current position.
MarkdownParseState.prototype.addNode = function addNode (type, attrs, content) {
  var node = type.createAndFill(attrs, content, this.marks);
  if (!node) { return null }
  this.push(node);
  return node
};

// : (NodeType, ?Object)
// Wrap subsequent content in a node of the given type.
MarkdownParseState.prototype.openNode = function openNode (type, attrs) {
  this.stack.push({type: type, attrs: attrs, content: []});
};

// : () → ?Node
// Close and return the node that is currently on top of the stack.
MarkdownParseState.prototype.closeNode = function closeNode () {
  if (this.marks.length) { this.marks = prosemirrorModel.Mark.none; }
  var info = this.stack.pop();
  return this.addNode(info.type, info.attrs, info.content)
};

function attrs(spec, token) {
  if (spec.getAttrs) { return spec.getAttrs(token) }
  // For backwards compatibility when `attrs` is a Function
  else if (spec.attrs instanceof Function) { return spec.attrs(token) }
  else { return spec.attrs }
}

// Code content is represented as a single token with a `content`
// property in Markdown-it.
function noOpenClose(type) {
  return type == "code_inline" || type == "code_block" || type == "fence"
}

function withoutTrailingNewline(str) {
  return str[str.length - 1] == "\n" ? str.slice(0, str.length - 1) : str
}

function noOp() {}

function tokenHandlers(schema$$1, tokens) {
  var handlers = Object.create(null);
  var loop = function ( type ) {
    var spec = tokens[type];
    if (spec.block) {
      var nodeType = schema$$1.nodeType(spec.block);
      if (noOpenClose(type)) {
        handlers[type] = function (state, tok) {
          state.openNode(nodeType, attrs(spec, tok));
          state.addText(withoutTrailingNewline(tok.content));
          state.closeNode();
        };
      } else {
        handlers[type + "_open"] = function (state, tok) { return state.openNode(nodeType, attrs(spec, tok)); };
        handlers[type + "_close"] = function (state) { return state.closeNode(); };
      }
    } else if (spec.node) {
      var nodeType$1 = schema$$1.nodeType(spec.node);
      handlers[type] = function (state, tok) { return state.addNode(nodeType$1, attrs(spec, tok)); };
    } else if (spec.mark) {
      var markType = schema$$1.marks[spec.mark];
      if (noOpenClose(type)) {
        handlers[type] = function (state, tok) {
          state.openMark(markType.create(attrs(spec, tok)));
          state.addText(withoutTrailingNewline(tok.content));
          state.closeMark(markType);
        };
      } else {
        handlers[type + "_open"] = function (state, tok) { return state.openMark(markType.create(attrs(spec, tok))); };
        handlers[type + "_close"] = function (state) { return state.closeMark(markType); };
      }
    } else if (spec.ignore) {
      if (noOpenClose(type)) {
        handlers[type] = noOp;
      } else {
        handlers[type + '_open'] = noOp;
        handlers[type + '_close'] = noOp;
      }
    } else {
      throw new RangeError("Unrecognized parsing spec " + JSON.stringify(spec))
    }
  };

  for (var type in tokens) loop( type );

  handlers.text = function (state, tok) { return state.addText(tok.content); };
  handlers.inline = function (state, tok) { return state.parseTokens(tok.children); };
  handlers.softbreak = handlers.softbreak || (function (state) { return state.addText("\n"); });

  return handlers
}

// ::- A configuration of a Markdown parser. Such a parser uses
// [markdown-it](https://github.com/markdown-it/markdown-it) to
// tokenize a file, and then runs the custom rules it is given over
// the tokens to create a ProseMirror document tree.
var MarkdownParser = function MarkdownParser(schema$$1, tokenizer, tokens) {
  // :: Object The value of the `tokens` object used to construct
  // this parser. Can be useful to copy and modify to base other
  // parsers on.
  this.tokens = tokens;
  this.schema = schema$$1;
  this.tokenizer = tokenizer;
  this.tokenHandlers = tokenHandlers(schema$$1, tokens);
};

// :: (string) → Node
// Parse a string as [CommonMark](http://commonmark.org/) markup,
// and create a ProseMirror document as prescribed by this parser's
// rules.
MarkdownParser.prototype.parse = function parse (text) {
  var state = new MarkdownParseState(this.schema, this.tokenHandlers), doc;
  state.parseTokens(this.tokenizer.parse(text, {}));
  do { doc = state.closeNode(); } while (state.stack.length)
  return doc
};

// :: MarkdownParser
// A parser parsing unextended [CommonMark](http://commonmark.org/),
// without inline HTML, and producing a document in the basic schema.
var defaultMarkdownParser = new MarkdownParser(schema, markdownit("commonmark", {html: false}), {
  blockquote: {block: "blockquote"},
  paragraph: {block: "paragraph"},
  list_item: {block: "list_item"},
  bullet_list: {block: "bullet_list"},
  ordered_list: {block: "ordered_list", getAttrs: function (tok) { return ({order: +tok.attrGet("order") || 1}); }},
  heading: {block: "heading", getAttrs: function (tok) { return ({level: +tok.tag.slice(1)}); }},
  code_block: {block: "code_block"},
  fence: {block: "code_block", getAttrs: function (tok) { return ({params: tok.info || ""}); }},
  hr: {node: "horizontal_rule"},
  image: {node: "image", getAttrs: function (tok) { return ({
    src: tok.attrGet("src"),
    title: tok.attrGet("title") || null,
    alt: tok.children[0] && tok.children[0].content || null
  }); }},
  hardbreak: {node: "hard_break"},

  em: {mark: "em"},
  strong: {mark: "strong"},
  link: {mark: "link", getAttrs: function (tok) { return ({
    href: tok.attrGet("href"),
    title: tok.attrGet("title") || null
  }); }},
  code_inline: {mark: "code"}
});

// ::- A specification for serializing a ProseMirror document as
// Markdown/CommonMark text.
var MarkdownSerializer = function MarkdownSerializer(nodes, marks) {
  // :: Object<(MarkdownSerializerState, Node)> The node serializer
  // functions for this serializer.
  this.nodes = nodes;
  // :: Object The mark serializer info.
  this.marks = marks;
};

// :: (Node, ?Object) → string
// Serialize the content of the given node to
// [CommonMark](http://commonmark.org/).
MarkdownSerializer.prototype.serialize = function serialize (content, options) {
  var state = new MarkdownSerializerState(this.nodes, this.marks, options);
  state.renderContent(content);
  return state.out
};

// :: MarkdownSerializer
// A serializer for the [basic schema](#schema).
var defaultMarkdownSerializer = new MarkdownSerializer({
  blockquote: function blockquote(state, node) {
    state.wrapBlock("> ", null, node, function () { return state.renderContent(node); });
  },
  code_block: function code_block(state, node) {
    state.write("```" + (node.attrs.params || "") + "\n");
    state.text(node.textContent, false);
    state.ensureNewLine();
    state.write("```");
    state.closeBlock(node);
  },
  heading: function heading(state, node) {
    state.write(state.repeat("#", node.attrs.level) + " ");
    state.renderInline(node);
    state.closeBlock(node);
  },
  horizontal_rule: function horizontal_rule(state, node) {
    state.write(node.attrs.markup || "---");
    state.closeBlock(node);
  },
  bullet_list: function bullet_list(state, node) {
    state.renderList(node, "  ", function () { return (node.attrs.bullet || "*") + " "; });
  },
  ordered_list: function ordered_list(state, node) {
    var start = node.attrs.order || 1;
    var maxW = String(start + node.childCount - 1).length;
    var space = state.repeat(" ", maxW + 2);
    state.renderList(node, space, function (i) {
      var nStr = String(start + i);
      return state.repeat(" ", maxW - nStr.length) + nStr + ". "
    });
  },
  list_item: function list_item(state, node) {
    state.renderContent(node);
  },
  paragraph: function paragraph(state, node) {
    state.renderInline(node);
    state.closeBlock(node);
  },

  image: function image(state, node) {
    state.write("![" + state.esc(node.attrs.alt || "") + "](" + state.esc(node.attrs.src) +
                (node.attrs.title ? " " + state.quote(node.attrs.title) : "") + ")");
  },
  hard_break: function hard_break(state, node, parent, index) {
    for (var i = index + 1; i < parent.childCount; i++)
      { if (parent.child(i).type != node.type) {
        state.write("\\\n");
        return
      } }
  },
  text: function text(state, node) {
    state.text(node.text);
  }
}, {
  em: {open: "*", close: "*", mixable: true, expelEnclosingWhitespace: true},
  strong: {open: "**", close: "**", mixable: true, expelEnclosingWhitespace: true},
  link: {
    open: "[",
    close: function close(state, mark) {
      return "](" + state.esc(mark.attrs.href) + (mark.attrs.title ? " " + state.quote(mark.attrs.title) : "") + ")"
    }
  },
  code: {open: "`", close: "`", escape: false}
});

// ::- This is an object used to track state and expose
// methods related to markdown serialization. Instances are passed to
// node and mark serialization methods (see `toMarkdown`).
var MarkdownSerializerState = function MarkdownSerializerState(nodes, marks, options) {
  this.nodes = nodes;
  this.marks = marks;
  this.delim = this.out = "";
  this.closed = false;
  this.inTightList = false;
  // :: Object
  // The options passed to the serializer.
  // tightLists:: ?bool
  // Whether to render lists in a tight style. This can be overridden
  // on a node level by specifying a tight attribute on the node.
  // Defaults to false.
  this.options = options || {};
  if (typeof this.options.tightLists == "undefined")
    { this.options.tightLists = false; }
};

MarkdownSerializerState.prototype.flushClose = function flushClose (size) {
    var this$1 = this;

  if (this.closed) {
    if (!this.atBlank()) { this.out += "\n"; }
    if (size == null) { size = 2; }
    if (size > 1) {
      var delimMin = this.delim;
      var trim = /\s+$/.exec(delimMin);
      if (trim) { delimMin = delimMin.slice(0, delimMin.length - trim[0].length); }
      for (var i = 1; i < size; i++)
        { this$1.out += delimMin + "\n"; }
    }
    this.closed = false;
  }
};

// :: (string, ?string, Node, ())
// Render a block, prefixing each line with `delim`, and the first
// line in `firstDelim`. `node` should be the node that is closed at
// the end of the block, and `f` is a function that renders the
// content of the block.
MarkdownSerializerState.prototype.wrapBlock = function wrapBlock (delim, firstDelim, node, f) {
  var old = this.delim;
  this.write(firstDelim || delim);
  this.delim += delim;
  f();
  this.delim = old;
  this.closeBlock(node);
};

MarkdownSerializerState.prototype.atBlank = function atBlank () {
  return /(^|\n)$/.test(this.out)
};

// :: ()
// Ensure the current content ends with a newline.
MarkdownSerializerState.prototype.ensureNewLine = function ensureNewLine () {
  if (!this.atBlank()) { this.out += "\n"; }
};

// :: (?string)
// Prepare the state for writing output (closing closed paragraphs,
// adding delimiters, and so on), and then optionally add content
// (unescaped) to the output.
MarkdownSerializerState.prototype.write = function write (content) {
  this.flushClose();
  if (this.delim && this.atBlank())
    { this.out += this.delim; }
  if (content) { this.out += content; }
};

// :: (Node)
// Close the block for the given node.
MarkdownSerializerState.prototype.closeBlock = function closeBlock (node) {
  this.closed = node;
};

// :: (string, ?bool)
// Add the given text to the document. When escape is not `false`,
// it will be escaped.
MarkdownSerializerState.prototype.text = function text (text$1, escape) {
    var this$1 = this;

  var lines = text$1.split("\n");
  for (var i = 0; i < lines.length; i++) {
    var startOfLine = this$1.atBlank() || this$1.closed;
    this$1.write();
    this$1.out += escape !== false ? this$1.esc(lines[i], startOfLine) : lines[i];
    if (i != lines.length - 1) { this$1.out += "\n"; }
  }
};

// :: (Node)
// Render the given node as a block.
MarkdownSerializerState.prototype.render = function render (node, parent, index) {
  if (typeof parent == "number") { throw new Error("!") }
  this.nodes[node.type.name](this, node, parent, index);
};

// :: (Node)
// Render the contents of `parent` as block nodes.
MarkdownSerializerState.prototype.renderContent = function renderContent (parent) {
    var this$1 = this;

  parent.forEach(function (node, _, i) { return this$1.render(node, parent, i); });
};

// :: (Node)
// Render the contents of `parent` as inline content.
MarkdownSerializerState.prototype.renderInline = function renderInline (parent) {
    var this$1 = this;

  var active = [], trailing = "";
  var progress = function (node, _, index) {
    var marks = node ? node.marks : [];

    // Remove marks from `hard_break` that are the last node inside
    // that mark to prevent parser edge cases with new lines just
    // before closing marks.
    // (FIXME it'd be nice if we had a schema-agnostic way to
    // identify nodes that serialize as hard breaks)
    if (node && node.type.name === "hard_break")
      { marks = marks.filter(function (m) {
        if (index + 1 == parent.childCount) { return false }
        var next = parent.child(index + 1);
        return m.isInSet(next.marks) && (!next.isText || /\S/.test(next.text))
      }); }

    var leading = trailing;
    trailing = "";
    // If whitespace has to be expelled from the node, adjust
    // leading and trailing accordingly.
    if (node && node.isText && marks.some(function (mark) {
      var info = this$1.marks[mark.type.name];
      return info && info.expelEnclosingWhitespace
    })) {
      var ref = /^(\s*)(.*?)(\s*)$/m.exec(node.text);
        var lead = ref[1];
        var inner$1 = ref[2];
        var trail = ref[3];
      leading += lead;
      trailing = trail;
      if (lead || trail) {
        node = inner$1 ? node.withText(inner$1) : null;
        if (!node) { marks = active; }
      }
    }

    var inner = marks.length && marks[marks.length - 1], noEsc = inner && this$1.marks[inner.type.name].escape === false;
    var len = marks.length - (noEsc ? 1 : 0);

    // Try to reorder 'mixable' marks, such as em and strong, which
    // in Markdown may be opened and closed in different order, so
    // that order of the marks for the token matches the order in
    // active.
    outer: for (var i = 0; i < len; i++) {
      var mark = marks[i];
      if (!this$1.marks[mark.type.name].mixable) { break }
      for (var j = 0; j < active.length; j++) {
        var other = active[j];
        if (!this$1.marks[other.type.name].mixable) { break }
        if (mark.eq(other)) {
          if (i > j)
            { marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len)); }
          else if (j > i)
            { marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len)); }
          continue outer
        }
      }
    }

    // Find the prefix of the mark set that didn't change
    var keep = 0;
    while (keep < Math.min(active.length, len) && marks[keep].eq(active[keep])) { ++keep; }

    // Close the marks that need to be closed
    while (keep < active.length)
      { this$1.text(this$1.markString(active.pop(), false), false); }

    // Output any previously expelled trailing whitespace outside the marks
    if (leading) { this$1.text(leading); }

    // Open the marks that need to be opened
    if (node) {
      while (active.length < len) {
        var add = marks[active.length];
        active.push(add);
        this$1.text(this$1.markString(add, true), false);
      }

      // Render the node. Special case code marks, since their content
      // may not be escaped.
      if (noEsc && node.isText)
        { this$1.text(this$1.markString(inner, true) + node.text + this$1.markString(inner, false), false); }
      else
        { this$1.render(node, parent, index); }
    }
  };
  parent.forEach(progress);
  progress(null);
};

// :: (Node, string, (number) → string)
// Render a node's content as a list. `delim` should be the extra
// indentation added to all lines except the first in an item,
// `firstDelim` is a function going from an item index to a
// delimiter for the first line of the item.
MarkdownSerializerState.prototype.renderList = function renderList (node, delim, firstDelim) {
    var this$1 = this;

  if (this.closed && this.closed.type == node.type)
    { this.flushClose(3); }
  else if (this.inTightList)
    { this.flushClose(1); }

  var isTight = typeof node.attrs.tight != "undefined" ? node.attrs.tight : this.options.tightLists;
  var prevTight = this.inTightList;
  this.inTightList = isTight;
  node.forEach(function (child, _, i) {
    if (i && isTight) { this$1.flushClose(1); }
    this$1.wrapBlock(delim, firstDelim(i), node, function () { return this$1.render(child, node, i); });
  });
  this.inTightList = prevTight;
};

// :: (string, ?bool) → string
// Escape the given string so that it can safely appear in Markdown
// content. If `startOfLine` is true, also escape characters that
// has special meaning only at the start of the line.
MarkdownSerializerState.prototype.esc = function esc (str, startOfLine) {
  str = str.replace(/[`*\\~\[\]]/g, "\\$&");
  if (startOfLine) { str = str.replace(/^[:#\-*+]/, "\\$&").replace(/^(\d+)\./, "$1\\."); }
  return str
};

MarkdownSerializerState.prototype.quote = function quote (str) {
  var wrap = str.indexOf('"') == -1 ? '""' : str.indexOf("'") == -1 ? "''" : "()";
  return wrap[0] + str + wrap[1]
};

// :: (string, number) → string
// Repeat the given string `n` times.
MarkdownSerializerState.prototype.repeat = function repeat (str, n) {
  var out = "";
  for (var i = 0; i < n; i++) { out += str; }
  return out
};

// : (Mark, bool) → string
// Get the markdown string for a given opening or closing mark.
MarkdownSerializerState.prototype.markString = function markString (mark, open) {
  var info = this.marks[mark.type.name];
  var value = open ? info.open : info.close;
  return typeof value == "string" ? value : value(this, mark)
};

// :: (string) → { leading: ?string, trailing: ?string }
// Get leading and trailing whitespace from a string. Values of
// leading or trailing property of the return object will be undefined
// if there is no match.
MarkdownSerializerState.prototype.getEnclosingWhitespace = function getEnclosingWhitespace (text) {
  return {
    leading: (text.match(/^(\s+)/) || [])[0],
    trailing: (text.match(/(\s+)$/) || [])[0]
  }
};

// Defines a parser and serializer for [CommonMark](http://commonmark.org/) text.

exports.schema = schema;
exports.defaultMarkdownParser = defaultMarkdownParser;
exports.MarkdownParser = MarkdownParser;
exports.MarkdownSerializer = MarkdownSerializer;
exports.defaultMarkdownSerializer = defaultMarkdownSerializer;
exports.MarkdownSerializerState = MarkdownSerializerState;
//# sourceMappingURL=index.js.map


/***/ }),
/* 2695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return markdownItMedia; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

function createRule() {
    var regx = /!\[[^\]]*\]\([^)]+\)/g;
    var validParentTokens = ['th_open', 'td_open', 'list_item_open'];
    /**
     * This function looks for strings that matches ![description](url) inside Inline-tokens.
     * It will then split the Inline-token with content before and after the image, example:
     *
     * Input (tokens):
     *   paragraph_open
     *   inline - content: Hello ![](image.jpg) World!
     *   paragraph_close
     * Output (tokens):
     *   paragraph_open
     *   inline - content: Hello
     *   paragraph_close
     *   media_single_open
     *   media
     *   media_single_close
     *   paragraph_open
     *   inline - content: World!
     *   paragraph_close
     *
     * This is applied before the inline content is parsed, to ensure that the formatting of
     * remaining inline content (bold, links, etc.) is kept intact!
     */
    return function media(state, startLine, endLine, silent) {
        var getUrl = function (str) {
            var res = state.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                var href = state.md.normalizeLink(res.str);
                if (state.md.validateLink(href)) {
                    return href;
                }
            }
            return '';
        };
        var createMediaTokens = function (url) {
            var mediaSingleOpen = new state.Token('media_single_open', '', 1);
            var media = new state.Token('media', '', 0);
            media.attrs = [['url', getUrl(url)], ['type', 'external']];
            var mediaSingleClose = new state.Token('media_single_close', '', -1);
            return [mediaSingleOpen, media, mediaSingleClose];
        };
        var createInlineTokens = function (str, openingTokens, closingTokens) {
            if (!str || str.length === 0) {
                return [];
            }
            var inlineBefore = new state.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](openingTokens, [inlineBefore], closingTokens);
        };
        var processedTokens = [];
        var newTokens = state.tokens.reduce(function (tokens, token, i, arr) {
            if (token.type === 'inline' && regx.test(token.content)) {
                var openingTokens_1 = [];
                var cursor = i - 1;
                var previousToken = arr[cursor];
                var subTree_1 = [];
                while (previousToken &&
                    previousToken.level > 0 &&
                    validParentTokens.indexOf(previousToken.type) === -1) {
                    openingTokens_1.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                if (validParentTokens.indexOf(previousToken.type) === -1) {
                    openingTokens_1.unshift(previousToken);
                }
                else {
                    cursor++;
                }
                var closingTokens_1 = openingTokens_1
                    .map(function (token) {
                    return new state.Token(token.type.replace('_open', '_close'), token.tag, -1);
                })
                    .reverse();
                var matches = token.content.match(regx);
                var inlineContentStack_1 = token.content;
                matches.forEach(function (match) {
                    var start = inlineContentStack_1.indexOf(match);
                    var contentBefore = inlineContentStack_1.substr(0, start);
                    inlineContentStack_1 = inlineContentStack_1.substr(start + match.length);
                    subTree_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](subTree_1, createInlineTokens(contentBefore, openingTokens_1, closingTokens_1), createMediaTokens(match));
                });
                if (inlineContentStack_1.length) {
                    subTree_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](subTree_1, createInlineTokens(inlineContentStack_1, openingTokens_1, closingTokens_1));
                }
                processedTokens = __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](processedTokens, closingTokens_1.map(function (c) { return c.type; }));
                tokens = __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](tokens.slice(0, cursor), subTree_1);
            }
            else if (processedTokens.indexOf(token.type) !== -1) {
                // Ignore token if it's already processed
                processedTokens.splice(processedTokens.indexOf(token.type), 1);
            }
            else {
                tokens.push(token);
            }
            return tokens;
        }, []);
        state.tokens = newTokens;
        return true;
    };
}
var markdownItMedia = function (md) {
    md.core.ruler.before('inline', 'media', createRule());
};
//# sourceMappingURL=media.js.map

/***/ }),
/* 2696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_linkify_it__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_linkify_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_linkify_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hyperlink_utils__ = __webpack_require__(115);


// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
var arrayReplaceAt = function (src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
var isLinkOpen = function (str) {
    return /^<a[>\s]/i.test(str);
};
var isLinkClose = function (str) {
    return /^<\/a\s*>/i.test(str);
};
var linkify = function (state) {
    var blockTokens = state.tokens;
    var linkify = new __WEBPACK_IMPORTED_MODULE_0_linkify_it__();
    for (var j = 0, l = blockTokens.length; j < l; j++) {
        if (blockTokens[j].type !== 'inline' ||
            !linkify.pretest(blockTokens[j].content)) {
            continue;
        }
        var tokens = blockTokens[j].children;
        var htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for (var i = tokens.length - 1; i >= 0; i--) {
            var currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while (tokens[i].level !== currentToken.level &&
                    tokens[i].type !== 'link_open') {
                    i--;
                }
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if (isLinkOpen(currentToken.content) && htmlLinkLevel > 0) {
                    htmlLinkLevel--;
                }
                if (isLinkClose(currentToken.content)) {
                    htmlLinkLevel++;
                }
            }
            if (htmlLinkLevel > 0) {
                continue;
            }
            if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                var text = currentToken.content;
                var links = Object(__WEBPACK_IMPORTED_MODULE_1__hyperlink_utils__["d" /* linkifyMatch */])(text);
                if (!links.length) {
                    links = linkify.match(text);
                }
                // Now split string to nodes
                var nodes = [];
                var level = currentToken.level;
                var lastPos = 0;
                for (var ln = 0; ln < links.length; ln++) {
                    var url = links[ln].url;
                    var fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) {
                        continue;
                    }
                    var urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) {
                        urlText = state.md
                            .normalizeLinkText('http://' + urlText)
                            .replace(/^http:\/\//, '');
                    }
                    else if (links[ln].schema === 'mailto:' &&
                        !/^mailto:/i.test(urlText)) {
                        urlText = state.md
                            .normalizeLinkText('mailto:' + urlText)
                            .replace(/^mailto:/, '');
                    }
                    else {
                        urlText = state.md.normalizeLinkText(urlText);
                    }
                    var pos = links[ln].index;
                    if (pos > lastPos) {
                        var token_1 = new state.Token('text', '', 0);
                        token_1.content = text.slice(lastPos, pos);
                        token_1.level = level;
                        nodes.push(token_1);
                    }
                    var token = new state.Token('link_open', 'a', 1);
                    token.attrs = [['href', fullUrl]];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    var token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};
/* harmony default export */ __webpack_exports__["a"] = (function (md) { return md.core.ruler.push('custom-linkify', linkify); });
//# sourceMappingURL=linkify-md-plugin.js.map

/***/ }),
/* 2697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export unwrapContentFromLayout */
/* unused harmony export removeLayoutFromFirstChild */
/* unused harmony export removeLayoutFromLastChild */
/* harmony export (immutable) */ __webpack_exports__["a"] = transformSliceToRemoveOpenLayoutNodes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_slice__ = __webpack_require__(104);


var isLayoutNode = function (node) {
    return node.type === node.type.schema.nodes.layoutSection ||
        node.type === node.type.schema.nodes.layoutColumn;
};
function unwrapContentFromLayout(maybeLayoutSection) {
    var fragment = Object(__WEBPACK_IMPORTED_MODULE_1__utils_slice__["d" /* mapFragment */])(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(maybeLayoutSection), function (node) {
        return isLayoutNode(node) ? node.content : node;
    });
    var nodes = [];
    fragment.forEach(function (i) { return nodes.push(i); });
    return nodes;
}
function removeLayoutFromFirstChild(node, i) {
    return i === 0 ? unwrapContentFromLayout(node) : node;
}
function removeLayoutFromLastChild(node, i, fragment) {
    return i === fragment.childCount - 1 ? unwrapContentFromLayout(node) : node;
}
/**
 * When we have a slice that cuts across a layoutSection/layoutColumn
 * we can end up with unexpected behaviour on paste/drop where a user
 * is able to add columns to a layoutSection. By 'lifting' any content
 * inside an 'open' layoutSection/layoutColumn to the top level, we
 * can ensure prevent this.
 *
 * We only care about slices with non-zero openStart / openEnd's here
 * as we're totally fine for people to copy/paste a full layoutSection
 */
function transformSliceToRemoveOpenLayoutNodes(slice, schema) {
    // Case 1: A slice entirely within a single layoutSection
    if (slice.openStart && slice.openEnd && slice.content.childCount === 1) {
        var maybeLayoutSection = slice.content.firstChild;
        if (maybeLayoutSection.type === schema.nodes.layoutSection) {
            return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](Object(__WEBPACK_IMPORTED_MODULE_1__utils_slice__["a" /* flatmap */])(slice.content, removeLayoutFromFirstChild), 
            // '-2' here because we've removed the layoutSection/layoutColumn; reducing the open depth.
            slice.openStart - 2, slice.openEnd - 2);
        }
    }
    // Case 2: A slice starting inside a layoutSection and finishing outside
    if (slice.openStart &&
        slice.content.firstChild.type === schema.nodes.layoutSection) {
        slice = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](Object(__WEBPACK_IMPORTED_MODULE_1__utils_slice__["a" /* flatmap */])(slice.content, removeLayoutFromFirstChild), slice.openStart - 2, slice.openEnd);
    }
    // Case 3: A slice starting outside a layoutSection and finishing inside
    if (slice.openEnd &&
        slice.content.lastChild.type === schema.nodes.layoutSection) {
        slice = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](Object(__WEBPACK_IMPORTED_MODULE_1__utils_slice__["a" /* flatmap */])(slice.content, removeLayoutFromLastChild), slice.openStart, slice.openEnd - 2);
    }
    // Case 2 & 3 also handles a slice starting in one layoutSection & finishing in a different layoutSection
    return slice;
}
//# sourceMappingURL=utils.js.map

/***/ }),
/* 2698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handlePasteIntoTaskAndDecision; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handlePasteAsPlainText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleMacroAutoConvert; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_filter__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hyperlink_utils__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__macro__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prosemirror_history__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prosemirror_history___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prosemirror_history__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__card_pm_plugins_doc__ = __webpack_require__(454);








var handlePasteIntoTaskAndDecision = function (slice) { return function (state, dispatch) {
    var _a = state.schema.nodes, decisionItem = _a.decisionItem, decisionList = _a.decisionList, taskList = _a.taskList, taskItem = _a.taskItem;
    if (decisionItem && decisionList && taskList && taskItem) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["hasParentNodeOfType"])([decisionItem, taskItem])(state.selection)) {
            if (state.selection.empty) {
                slice = Object(__WEBPACK_IMPORTED_MODULE_1__utils_filter__["a" /* taskDecisionSliceFilter */])(slice, state.schema);
                slice = Object(__WEBPACK_IMPORTED_MODULE_2__hyperlink_utils__["c" /* linkifyContent */])(state.schema, slice);
                var tr = Object(__WEBPACK_IMPORTED_MODULE_5_prosemirror_history__["closeHistory"])(state.tr)
                    .replaceSelection(slice)
                    .scrollIntoView();
                Object(__WEBPACK_IMPORTED_MODULE_7__card_pm_plugins_doc__["a" /* queueCardsFromChangedTr */])(state, tr);
                dispatch(tr);
                return true;
            }
        }
    }
    return false;
}; };
var handlePasteAsPlainText = function (slice, event) { return function (state, dispatch, view) {
    // In case of SHIFT+CMD+V ("Paste and Match Style") we don't want to run the usual
    // fuzzy matching of content. ProseMirror already handles this scenario and will
    // provide us with slice containing paragraphs with plain text, which we decorate
    // with "stored marks".
    // @see prosemirror-view/src/clipboard.js:parseFromClipboard()).
    // @see prosemirror-view/src/input.js:doPaste().
    var tr = Object(__WEBPACK_IMPORTED_MODULE_5_prosemirror_history__["closeHistory"])(state.tr);
    if (view.shiftKey) {
        // <- using the same internal flag that prosemirror-view is using
        __WEBPACK_IMPORTED_MODULE_3__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.paste.alt', {
            source: Object(__WEBPACK_IMPORTED_MODULE_6__util__["b" /* getPasteSource */])(event),
        });
        tr.replaceSelection(slice);
        (state.storedMarks || []).forEach(function (mark) {
            tr.addMark(tr.selection.from, tr.selection.from + slice.size, mark);
        });
        tr.scrollIntoView();
        dispatch(tr);
        return true;
    }
    return false;
}; };
var handleMacroAutoConvert = function (text, slice) { return function (state, dispatch, view) {
    var macro = Object(__WEBPACK_IMPORTED_MODULE_4__macro__["d" /* runMacroAutoConvert */])(state, text);
    if (macro) {
        var selection = state.tr.selection;
        var tr = state.tr.replaceSelection(slice);
        var before = tr.mapping.map(selection.from, -1);
        // insert the text or linkified/md-converted clipboard data
        dispatch(tr);
        // replace the text with the macro as a separate transaction
        // so the autoconversion generates 2 undo steps
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_prosemirror_history__["closeHistory"])(view.state.tr)
            .replaceRangeWith(before, before + slice.size, macro)
            .scrollIntoView());
    }
    return !!macro;
}; };
//# sourceMappingURL=handlers.js.map

/***/ }),
/* 2699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = transformSliceToJoinAdjacentCodeBlocks;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return transformSingleLineCodeBlockToCodeMark; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_slice__ = __webpack_require__(104);


function joinCodeBlocks(left, right) {
    var textContext = left.textContent + "\n" + right.textContent;
    return left.type.create(left.attrs, left.type.schema.text(textContext));
}
function mergeAdjacentCodeBlocks(fragment) {
    var children = [];
    fragment.forEach(function (maybeCodeBlock) {
        if (maybeCodeBlock.type === maybeCodeBlock.type.schema.nodes.codeBlock) {
            var peekAtPrevious = children[children.length - 1];
            if (peekAtPrevious && peekAtPrevious.type === maybeCodeBlock.type) {
                return children.push(joinCodeBlocks(children.pop(), maybeCodeBlock));
            }
        }
        children.push(maybeCodeBlock);
    });
    return __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(children);
}
function transformSliceToJoinAdjacentCodeBlocks(slice) {
    slice = Object(__WEBPACK_IMPORTED_MODULE_1__utils_slice__["e" /* mapSlice */])(slice, function (node) {
        return node.isBlock && !node.isTextblock
            ? node.copy(mergeAdjacentCodeBlocks(node.content))
            : node;
    });
    // mapSlice won't be able to merge adjacent top-level code-blocks
    return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](mergeAdjacentCodeBlocks(slice.content), slice.openStart, slice.openEnd);
}
var transformSingleLineCodeBlockToCodeMark = function (slice, schema) {
    if (slice.content.childCount === 1 && (slice.openStart || slice.openEnd)) {
        var maybeCodeBlock = slice.content.firstChild;
        if (maybeCodeBlock && maybeCodeBlock.type === schema.nodes.codeBlock) {
            if (maybeCodeBlock.textContent &&
                maybeCodeBlock.textContent.indexOf('\n') === -1) {
                return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Slice"](__WEBPACK_IMPORTED_MODULE_0_prosemirror_model__["Fragment"].from(schema.text(maybeCodeBlock.textContent, [
                    schema.marks.code.create(),
                ])), 0, 0);
            }
        }
    }
    return slice;
};
//# sourceMappingURL=utils.js.map

/***/ }),
/* 2700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pluginKey */
/* unused harmony export createPlaceholderDecoration */
/* unused harmony export createPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_view__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(21);



var pluginKey = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["PluginKey"]('placeholderPlugin');
function createPlaceholderDecoration(doc, placeholderText) {
    var placeholderNode = document.createElement('span');
    placeholderNode.className = 'placeholder-decoration';
    placeholderNode.setAttribute('data-text', placeholderText);
    return __WEBPACK_IMPORTED_MODULE_1_prosemirror_view__["DecorationSet"].create(doc, [__WEBPACK_IMPORTED_MODULE_1_prosemirror_view__["Decoration"].widget(1, placeholderNode)]);
}
function createPlugin(placeholderText) {
    if (!placeholderText) {
        return;
    }
    return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
        key: pluginKey,
        state: {
            init: function (_, state) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["t" /* isEmptyDocument */])(state.doc); },
            apply: function (tr, _oldPluginState, oldEditorState, newEditorState) {
                var meta = tr.getMeta(pluginKey);
                if (meta) {
                    if (meta.removePlaceholder) {
                        return false;
                    }
                    if (meta.applyPlaceholderIfEmpty) {
                        return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["t" /* isEmptyDocument */])(newEditorState.doc);
                    }
                }
                // non-plugin specific transaction; don't excessively recalculate
                // if the document is empty
                if (!tr.docChanged) {
                    return _oldPluginState;
                }
                return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["t" /* isEmptyDocument */])(newEditorState.doc);
            },
        },
        props: {
            decorations: function (editorState) {
                var havePlaceholder = pluginKey.getState(editorState);
                if (havePlaceholder) {
                    return createPlaceholderDecoration(editorState.doc, placeholderText);
                }
            },
            // Workaround for ED-4063: On Mobile / Android, a user can start typing but it won't trigger
            // an Editor state update so the placeholder will still be shown. We hook into the compositionstart
            // and compositionend events instead, to make sure we show/hide the placeholder for these devices.
            handleDOMEvents: {
                compositionstart: function (view) {
                    var havePlaceholder = pluginKey.getState(view.state);
                    if (havePlaceholder) {
                        // remove placeholder, since document definitely contains text
                        view.dispatch(view.state.tr.setMeta(pluginKey, { removePlaceholder: true }));
                    }
                    return false;
                },
                compositionend: function (view) {
                    var havePlaceholder = pluginKey.getState(view.state);
                    if (!havePlaceholder) {
                        view.dispatch(view.state.tr.setMeta(pluginKey, {
                            applyPlaceholderIfEmpty: true,
                        }));
                    }
                    return false;
                },
            },
        },
    });
}
var placeholderPlugin = {
    pmPlugins: function () {
        return [
            {
                name: 'placeholder',
                plugin: function (_a) {
                    var schema = _a.schema, props = _a.props;
                    return createPlugin(props.placeholder);
                },
            },
        ];
    },
};
/* harmony default export */ __webpack_exports__["a"] = (placeholderPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_divider__ = __webpack_require__(2702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__insert_block_ui_ToolbarInsertBlock__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pm_plugins_keymap__ = __webpack_require__(2703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pm_plugins_input_rule__ = __webpack_require__(829);






var rulePlugin = {
    nodes: function () {
        return [{ name: 'rule', node: __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__["_2" /* rule */] }];
    },
    pmPlugins: function () {
        return [
            {
                name: 'ruleInputRule',
                plugin: function (_a) {
                    var schema = _a.schema;
                    return Object(__WEBPACK_IMPORTED_MODULE_5__pm_plugins_input_rule__["b" /* default */])(schema);
                },
            },
            {
                name: 'ruleKeymap',
                plugin: function (_a) {
                    var schema = _a.schema;
                    return Object(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_keymap__["a" /* default */])(schema);
                },
            },
        ];
    },
    pluginsOptions: {
        quickInsert: function (_a) {
            var formatMessage = _a.formatMessage;
            return [
                {
                    title: formatMessage(__WEBPACK_IMPORTED_MODULE_3__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].horizontalRule),
                    keywords: ['horizontal rule', 'rule', 'line'],
                    priority: 1200,
                    icon: function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_editor_divider___default.a, { label: formatMessage(__WEBPACK_IMPORTED_MODULE_3__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].horizontalRule) })); },
                    action: function (insert, state) {
                        return insert(state.schema.nodes.rule.createChecked());
                    },
                },
            ];
        },
    },
};
/* harmony default export */ __webpack_exports__["a"] = (rulePlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorDividerIcon = function EditorDividerIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><rect x=\"5\" y=\"11\" width=\"14\" height=\"2\" rx=\"1\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorDividerIcon.displayName = 'EditorDividerIcon';
var _default = EditorDividerIcon;
exports.default = _default;

/***/ }),
/* 2703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export keymapPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keymaps__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commands__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__analytics__ = __webpack_require__(20);




function keymapPlugin(schema) {
    var list = {};
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["t" /* insertRule */].common, Object(__WEBPACK_IMPORTED_MODULE_3__analytics__["b" /* trackAndInvoke */])('atlassian.editor.format.horizontalrule.keyboard', __WEBPACK_IMPORTED_MODULE_2__commands__["h" /* insertRule */]()), list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["l" /* escape */].common, function (state, dispatch) {
        return true;
    }, list);
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__["keymap"])(list);
}
/* harmony default export */ __webpack_exports__["a"] = (keymapPlugin);
//# sourceMappingURL=keymap.js.map

/***/ }),
/* 2704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__analytics__ = __webpack_require__(20);


function createPlugin(onSave) {
    if (!onSave) {
        return;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__["keymap"])({
        Enter: function (state, dispatch, editorView) {
            if (canSaveOnEnter(editorView)) {
                __WEBPACK_IMPORTED_MODULE_1__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.stop.submit');
                onSave(editorView);
                return true;
            }
            return false;
        },
    });
}
function canSaveOnEnter(editorView) {
    var $cursor = editorView.state.selection.$cursor;
    var _a = editorView.state.schema.nodes, decisionItem = _a.decisionItem, paragraph = _a.paragraph, taskItem = _a.taskItem;
    return (!$cursor ||
        ($cursor.parent.type === paragraph && $cursor.depth === 1) ||
        ($cursor.parent.type === decisionItem && !isEmptyAtCursor($cursor)) ||
        ($cursor.parent.type === taskItem && !isEmptyAtCursor($cursor)));
}
function isEmptyAtCursor($cursor) {
    var content = $cursor.parent.content;
    return !(content && content.size);
}
var saveOnEnterPlugin = {
    pmPlugins: function () {
        return [
            {
                name: 'saveOnEnter',
                plugin: function (_a) {
                    var props = _a.props;
                    return createPlugin(props.onSave);
                },
            },
        ];
    },
};
/* harmony default export */ __webpack_exports__["a"] = (saveOnEnterPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keymaps__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_media_pm_plugins_main__ = __webpack_require__(100);




function createPlugin(onSave) {
    var _a;
    if (!onSave) {
        return;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__["keymap"])((_a = {},
        _a["" + __WEBPACK_IMPORTED_MODULE_2__keymaps__["H" /* submit */].common] = function (state, dispatch, editorView) {
            var mediaState = __WEBPACK_IMPORTED_MODULE_3__plugins_media_pm_plugins_main__["b" /* stateKey */].getState(state);
            if (mediaState &&
                mediaState.waitForMediaUpload &&
                !mediaState.allUploadsFinished) {
                return true;
            }
            __WEBPACK_IMPORTED_MODULE_1__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.stop.submit');
            onSave(editorView);
            return true;
        },
        _a));
}
var submitEditorPlugin = {
    pmPlugins: function () {
        return [
            {
                name: 'submitEditor',
                plugin: function (_a) {
                    var props = _a.props;
                    return createPlugin(props.onSave);
                },
            },
        ];
    },
};
/* harmony default export */ __webpack_exports__["a"] = (submitEditorPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_task__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_task___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_task__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_decision__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_decision___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_decision__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__insert_block_ui_ToolbarInsertBlock__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pm_plugins_main__ = __webpack_require__(2707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pm_plugins_input_rules__ = __webpack_require__(2739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pm_plugins_keymaps__ = __webpack_require__(2740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_ToolbarDecision__ = __webpack_require__(2741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_ToolbarTask__ = __webpack_require__(2742);












// tslint:disable-next-line:variable-name
var TaskDecisionToolbarGroup = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var tasksAndDecisionsPlugin = {
    nodes: function () {
        return [
            { name: 'decisionList', node: __WEBPACK_IMPORTED_MODULE_5__atlaskit_adf_schema__["w" /* decisionList */] },
            { name: 'decisionItem', node: __WEBPACK_IMPORTED_MODULE_5__atlaskit_adf_schema__["v" /* decisionItem */] },
            { name: 'taskList', node: __WEBPACK_IMPORTED_MODULE_5__atlaskit_adf_schema__["_17" /* taskList */] },
            { name: 'taskItem', node: __WEBPACK_IMPORTED_MODULE_5__atlaskit_adf_schema__["_16" /* taskItem */] },
        ];
    },
    pmPlugins: function () {
        return [
            {
                name: 'tasksAndDecisions',
                plugin: function (_a) {
                    var schema = _a.schema, props = _a.props, portalProviderAPI = _a.portalProviderAPI, providerFactory = _a.providerFactory;
                    return Object(__WEBPACK_IMPORTED_MODULE_7__pm_plugins_main__["a" /* createPlugin */])(portalProviderAPI, providerFactory);
                },
            },
            {
                name: 'tasksAndDecisionsInputRule',
                plugin: function (_a) {
                    var schema = _a.schema;
                    return Object(__WEBPACK_IMPORTED_MODULE_8__pm_plugins_input_rules__["a" /* default */])(schema);
                },
            },
            {
                name: 'tasksAndDecisionsKeyMap',
                plugin: function (_a) {
                    var schema = _a.schema;
                    return Object(__WEBPACK_IMPORTED_MODULE_9__pm_plugins_keymaps__["a" /* default */])(schema);
                },
            },
        ];
    },
    secondaryToolbarComponent: function (_a) {
        var editorView = _a.editorView, disabled = _a.disabled;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](TaskDecisionToolbarGroup, null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ui_ToolbarDecision__["a" /* default */], { editorView: editorView, isDisabled: disabled, isReducedSpacing: true }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__ui_ToolbarTask__["a" /* default */], { editorView: editorView, isDisabled: disabled, isReducedSpacing: true })));
    },
    pluginsOptions: {
        quickInsert: function (_a) {
            var formatMessage = _a.formatMessage;
            return [
                {
                    title: formatMessage(__WEBPACK_IMPORTED_MODULE_6__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].action),
                    priority: 100,
                    keywords: ['checkbox', 'task', 'todo'],
                    icon: function () { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_task___default.a, { label: formatMessage(__WEBPACK_IMPORTED_MODULE_6__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].action) })); },
                    action: function (insert, state) {
                        return insert(state.schema.nodes.taskList.createChecked({ localId: __WEBPACK_IMPORTED_MODULE_5__atlaskit_adf_schema__["_26" /* uuid */].generate() }, state.schema.nodes.taskItem.createChecked({
                            localId: __WEBPACK_IMPORTED_MODULE_5__atlaskit_adf_schema__["_26" /* uuid */].generate(),
                        })));
                    },
                },
                {
                    title: formatMessage(__WEBPACK_IMPORTED_MODULE_6__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].decision),
                    priority: 900,
                    icon: function () { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_decision___default.a, { label: formatMessage(__WEBPACK_IMPORTED_MODULE_6__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].decision) })); },
                    action: function (insert, state) {
                        return insert(state.schema.nodes.decisionList.createChecked({ localId: __WEBPACK_IMPORTED_MODULE_5__atlaskit_adf_schema__["_26" /* uuid */].generate() }, state.schema.nodes.decisionItem.createChecked({
                            localId: __WEBPACK_IMPORTED_MODULE_5__atlaskit_adf_schema__["_26" /* uuid */].generate(),
                        })));
                    },
                },
            ];
        },
    },
};
/* harmony default export */ __webpack_exports__["a"] = (tasksAndDecisionsPlugin);
var templateObject_1;
//# sourceMappingURL=index.js.map

/***/ }),
/* 2707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stateKey */
/* harmony export (immutable) */ __webpack_exports__["a"] = createPlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nodeviews_decisionItem__ = __webpack_require__(2708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nodeviews_taskItem__ = __webpack_require__(2736);





var stateKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('tasksAndDecisionsPlugin');
function createPlugin(portalProviderAPI, providerFactory) {
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        props: {
            nodeViews: {
                taskItem: Object(__WEBPACK_IMPORTED_MODULE_4__nodeviews_taskItem__["a" /* taskItemNodeViewFactory */])(portalProviderAPI, providerFactory),
                decisionItem: Object(__WEBPACK_IMPORTED_MODULE_3__nodeviews_decisionItem__["a" /* decisionItemNodeView */])(portalProviderAPI),
            },
        },
        key: stateKey,
        /*
         * After each transaction, we search through the document for any decisionList/Item & taskList/Item nodes
         * that do not have the localId attribute set and generate a random UUID to use. This is to replace a previous
         * Prosemirror capabibility where node attributes could be generated dynamically.
         * See https://discuss.prosemirror.net/t/release-0-23-0-possibly-to-be-1-0-0/959/17 for a discussion of this approach.
         *
         * Note: we currently do not handle the edge case where two nodes may have the same localId
         */
        appendTransaction: function (transactions, oldState, newState) {
            var tr = newState.tr;
            var modified = false;
            if (transactions.some(function (transaction) { return transaction.docChanged; })) {
                // Adds a unique id to a node
                newState.doc.descendants(function (node, pos) {
                    var _a = newState.schema.nodes, decisionList = _a.decisionList, decisionItem = _a.decisionItem, taskList = _a.taskList, taskItem = _a.taskItem;
                    if (!!node.type &&
                        (node.type === decisionList ||
                            node.type === decisionItem ||
                            node.type === taskList ||
                            node.type === taskItem)) {
                        var _b = node.attrs, localId = _b.localId, rest = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_b, ["localId"]);
                        if (localId === undefined || localId === null || localId === '') {
                            tr.setNodeMarkup(pos, undefined, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ localId: __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__["_26" /* uuid */].generate() }, rest));
                            modified = true;
                        }
                    }
                });
            }
            if (modified) {
                return tr;
            }
        },
    });
}
//# sourceMappingURL=main.js.map

/***/ }),
/* 2708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return decisionItemNodeView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_Decision__ = __webpack_require__(2709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nodeviews__ = __webpack_require__(84);




var Decision = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Decision, _super);
    function Decision() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Decision.prototype.isContentEmpty = function () {
        return this.node.content.childCount === 0;
    };
    Decision.prototype.createDomRef = function () {
        var domRef = document.createElement('li');
        domRef.style['list-style-type'] = 'none';
        return domRef;
    };
    Decision.prototype.getContentDOM = function () {
        return { dom: document.createElement('div') };
    };
    Decision.prototype.render = function (props, forwardRef) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__ui_Decision__["a" /* default */], { contentRef: forwardRef, showPlaceholder: this.isContentEmpty() }));
    };
    Decision.prototype.update = function (node, decorations) {
        var _this = this;
        /**
         * Returning false here when the previous content was empty – fixes an error where the editor fails to set selection
         * inside the contentDOM after a transaction. See ED-2374.
         */
        return _super.prototype.update.call(this, node, decorations, function (currentNode, newNode) { return !_this.isContentEmpty(); });
    };
    return Decision;
}(__WEBPACK_IMPORTED_MODULE_3__nodeviews__["a" /* ReactNodeView */]));
var decisionItemNodeView = function (portalProviderAPI) { return function (node, view, getPos) {
    return new Decision(node, view, getPos, portalProviderAPI).init();
}; };
//# sourceMappingURL=decisionItem.js.map

/***/ }),
/* 2709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Decision */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_task_decision__ = __webpack_require__(183);




var messages = Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["defineMessages"])({
    placeholder: {
        id: 'fabric.editor.decisionPlaceholder',
        defaultMessage: 'Add a decision…',
        description: 'Placeholder description for an empty decision in the editor',
    },
});
var Decision = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Decision, _super);
    function Decision() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Decision.prototype.render = function () {
        var _a = this.props, contentRef = _a.contentRef, showPlaceholder = _a.showPlaceholder, formatMessage = _a.intl.formatMessage;
        var placeholder = formatMessage(messages.placeholder);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_task_decision__["a" /* DecisionItem */], { contentRef: contentRef, placeholder: placeholder, showPlaceholder: showPlaceholder }));
    };
    return Decision;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["injectIntl"])(Decision));
//# sourceMappingURL=index.js.map

/***/ }),
/* 2710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(2711));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorDecisionIcon = function EditorDecisionIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M9.414 8l3.293 3.293c.187.187.293.442.293.707v5a1 1 0 0 1-2 0v-4.586l-3-3V10.5a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2H9.414zm8.293-1.707a.999.999 0 0 1 0 1.414l-2.5 2.5a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414l2.5-2.5a.999.999 0 0 1 1.414 0z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorDecisionIcon.displayName = 'EditorDecisionIcon';
var _default = EditorDecisionIcon;
exports.default = _default;

/***/ }),
/* 2711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(54);

var _interopRequireDefault = __webpack_require__(53);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.size = exports.default = exports.IconWrapper = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(4));

var _createClass2 = _interopRequireDefault(__webpack_require__(5));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(7));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(6));

var _inherits2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _styledComponents = _interopRequireDefault(__webpack_require__(2));

var _uuid = _interopRequireDefault(__webpack_require__(22));

var _theme = __webpack_require__(3);

var _constants = __webpack_require__(2712);

var getSize = function getSize(props) {
  if (props.size) {
    return "height: ".concat(_constants.sizes[props.size], "; width: ").concat(_constants.sizes[props.size], ";");
  }

  return null;
};

var IconWrapper = _styledComponents.default.span.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "dyhwwi-0"
})(["\n  ", " color: ", ";\n  display: inline-block;\n  fill: ", ";\n  flex-shrink: 0;\n  line-height: 1;\n\n  > svg {\n    ", " max-height: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    pointer-events: none;\n    vertical-align: bottom;\n  }\n  /* Stop-color doesn't properly apply in chrome when the inherited/current color changes.\n   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS\n   * rule) and then override it with currentColor for the color changes to be picked up.\n   */\n  stop {\n    stop-color: currentColor;\n  }\n"], getSize, function (p) {
  return p.primaryColor || 'currentColor';
}, function (p) {
  return p.secondaryColor || _theme.colors.background;
}, getSize);

exports.IconWrapper = IconWrapper;

var Icon =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Icon, _Component);

  function Icon() {
    (0, _classCallCheck2.default)(this, Icon);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Icon).apply(this, arguments));
  }

  (0, _createClass2.default)(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Glyph = _this$props.glyph,
          dangerouslySetGlyph = _this$props.dangerouslySetGlyph,
          onClick = _this$props.onClick,
          primaryColor = _this$props.primaryColor,
          secondaryColor = _this$props.secondaryColor,
          size = _this$props.size; // handling the glyphs as strings

      if (dangerouslySetGlyph) {
        return _react.default.createElement(IconWrapper, {
          onClick: onClick,
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          size: size,
          "aria-label": this.props.label,
          dangerouslySetInnerHTML: {
            __html: Icon.insertDynamicGradientID(dangerouslySetGlyph)
          }
        });
      } // handling the glyphs when passed through as functions


      return _react.default.createElement(IconWrapper, {
        onClick: onClick,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        "aria-label": this.props.label
      }, Glyph ? _react.default.createElement(Glyph, {
        role: "presentation"
      }) : null);
    }
  }], [{
    key: "insertDynamicGradientID",

    /* Icons need unique gradient IDs across instances for different gradient definitions to work
     * correctly.
     * A step in the icon build process replaces linear gradient IDs and their references in paths
     * to a placeholder string so we can replace them with a dynamic ID here.
     * Replacing the original IDs with placeholders in the build process is more robust than not
     * using placeholders as we do not have to rely on regular expressions to find specific element
     * to replace.
     */
    value: function insertDynamicGradientID(svgStr) {
      var id = (0, _uuid.default)();
      var replacedSvgStr = svgStr.replace(/id="([^"]+)-idPlaceholder"/g, "id=$1-".concat(id)).replace(/fill="url\(#([^"]+)-idPlaceholder\)"/g, "fill=\"url(#$1-".concat(id, ")\""));
      return replacedSvgStr;
    }
  }]);
  return Icon;
}(_react.Component);

exports.default = Icon;
(0, _defineProperty2.default)(Icon, "defaultProps", {
  onClick: function onClick() {}
});
var size = Object.keys(_constants.sizes).reduce(function (p, c) {
  return Object.assign(p, (0, _defineProperty2.default)({}, c, c));
}, {});
exports.size = size;

/***/ }),
/* 2712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = void 0;
var sizes = {
  small: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '48px'
};
exports.sizes = sizes;

/***/ }),
/* 2713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditorIconWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



// tslint:disable-next-line:variable-name
var EditorIconWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  flex: 0 0 16px;\n  height: 16px;\n  width: 16px;\n  color: ", ";\n  margin: 2px ", "px 0 0;\n\n  > span {\n    margin: -8px;\n  }\n"], ["\n  flex: 0 0 16px;\n  height: 16px;\n  width: 16px;\n  color: ",
    ";\n  margin: 2px ", "px 0 0;\n\n  > span {\n    margin: -8px;\n  }\n"])), function (props) {
    return props.showPlaceholder
        ? __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N100
        : Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].G300, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].G200 });
}, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"]);
var templateObject_1;
//# sourceMappingURL=DecisionItem.js.map

/***/ }),
/* 2714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AvatarGroupLoadable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_loadable__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_loadable__);





var AvatarGroupLoadable = __WEBPACK_IMPORTED_MODULE_3_react_loadable__({
    loader: function () {
        return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 416)).then(function (module) { return module.default; });
    },
    loading: function () { return null; },
});
var Partipants = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Partipants, _super);
    function Partipants() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Partipants.prototype.getAvatarData = function () {
        return this.props.participants.map(function (p) { return ({
            src: p.avatarUrl,
            name: p.displayName,
            size: 'small',
        }); });
    };
    Partipants.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](AvatarGroupLoadable, { appearance: "stack", borderColor: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N20, maxCount: 4, size: "small", data: this.getAvatarData(), boundariesElement: "scrollParent" }));
    };
    return Partipants;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Partipants);
//# sourceMappingURL=Participants.js.map

/***/ }),
/* 2715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ContentWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ParticipantWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CardHeadingWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AttributionWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



var akGridSize = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])();
var ContentWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin: 0;\n  word-wrap: break-word;\n  min-width: 0;\n  flex: 1 1 auto;\n"], ["\n  margin: 0;\n  word-wrap: break-word;\n  min-width: 0;\n  flex: 1 1 auto;\n"])));
var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  flex-direction: ", ";\n\n  line-height: 20px;\n  border-radius: ", "px;\n  margin: ", "px 0;\n  padding: ", "px ", "px;\n  min-height: 36px;\n  box-sizing: border-box;\n  box-shadow: ", ";\n\n  &:hover {\n    box-shadow: ", ";\n    transition: box-shadow 0.2s ease-in-out;\n  }\n\n  background-color: ", ";\n  border: 1px solid: ", ";\n"], ["\n  display: flex;\n  flex-direction: ", ";\n\n  line-height: 20px;\n  border-radius: ", "px;\n  margin: ", "px 0;\n  padding: ", "px ", "px;\n  min-height: 36px;\n  box-sizing: border-box;\n  box-shadow: ",
    ";\n\n  &:hover {\n    box-shadow: ",
    ";\n    transition: box-shadow 0.2s ease-in-out;\n  }\n\n  background-color: ", ";\n  border: 1px solid: ", ";\n"])), function (props) { return (props.appearance === 'card' ? 'column' : 'row'); }, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])(), akGridSize, akGridSize, akGridSize, function (props) {
    return props.appearance === 'card'
        ? "0 1px 1px " + __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N50A + ", 0 0 1px 0 " + __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N60A
        : 'none';
}, function (props) {
    return props.appearance === 'card'
        ? "0 4px 8px -2px " + __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N60A + ", 0 0 1px " + __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N60A
        : 'none';
}, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30A, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN50 }), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: 'none', dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN60 }));
var ParticipantWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin: -2px 8px;\n"], ["\n  margin: -2px 8px;\n"])));
var CardHeadingWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 4px;\n  min-height: 24px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 4px;\n  min-height: 24px;\n"])));
var AttributionWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_5 || (templateObject_5 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  color: ", ";\n  margin-top: ", "px;\n  font-size: 12px;\n  font-weight: 500;\n"], ["\n  color: ", ";\n  margin-top: ", "px;\n  font-size: 12px;\n  font-weight: 500;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N200, akGridSize);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Item.js.map

/***/ }),
/* 2716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Placeholder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



var Placeholder = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin: 0 0 0 ", "px;\n  position: absolute;\n  color: ", ";\n  pointer-events: none;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  max-width: calc(100% - 50px);\n"], ["\n  margin: 0 0 0 ", "px;\n  position: absolute;\n  color: ", ";\n  pointer-events: none;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  max-width: calc(100% - 50px);\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() * 3, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N80);
var templateObject_1;
//# sourceMappingURL=Placeholder.js.map

/***/ }),
/* 2717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled_ListWrapper__ = __webpack_require__(467);




var DecisionList = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](DecisionList, _super);
    function DecisionList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DecisionList.prototype.render = function () {
        var children = this.props.children;
        if (!children) {
            return null;
        }
        // Data attributes are required for copy and paste from rendered content
        // to preserve the decision
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled_ListWrapper__["a" /* default */], { "data-decision-list-local-id": "" }, __WEBPACK_IMPORTED_MODULE_1_react__["Children"].map(children, function (child, idx) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { key: idx, "data-decision-local-id": "", "data-decision-state": "DECIDED" }, child)); })));
    };
    return DecisionList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (DecisionList);
//# sourceMappingURL=DecisionList.js.map

/***/ }),
/* 2718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_spinner__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_TaskDecisionLoader__ = __webpack_require__(2719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InfiniteScroll__ = __webpack_require__(2720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled_ListContainer__ = __webpack_require__(2721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled_ListWrapper__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styled_DateGroup__ = __webpack_require__(2722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styled_DateGroupHeader__ = __webpack_require__(2723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__type_helpers__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_date__ = __webpack_require__(2724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DecisionItem__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ResourcedTaskItem__ = __webpack_require__(868);

















// tslint:disable-next-line:variable-name
var LoadingWrapper = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: ", ";\n  height: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: ",
    ";\n  height: ",
    ";\n"])), function (props) {
    return props.fullHeight ? '0' : '20px 0';
}, function (props) {
    return props.fullHeight ? '100%' : 'auto';
});
var ResourcedItemList = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ResourcedItemList, _super);
    function ResourcedItemList(props) {
        var _this = _super.call(this, props) || this;
        _this.loadLatest = function (recentUpdateContext) {
            var _a = _this.props, initialQuery = _a.initialQuery, taskDecisionProvider = _a.taskDecisionProvider;
            taskDecisionProvider.then(function (provider) {
                Object(__WEBPACK_IMPORTED_MODULE_5__api_TaskDecisionLoader__["a" /* loadLatestItems */])(initialQuery, provider, recentUpdateContext).then(function (latestItems) {
                    if (_this.mounted) {
                        _this.setState({
                            items: latestItems,
                        });
                    }
                });
            });
        };
        _this.loadMore = function () {
            var nextQuery = _this.state.nextQuery;
            if (nextQuery) {
                _this.performQuery(nextQuery, false);
            }
        };
        _this.state = {
            loading: true,
            error: false,
        };
        return _this;
    }
    ResourcedItemList.prototype.componentDidMount = function () {
        this.mounted = true;
        this.performInitialQuery(this.props);
    };
    ResourcedItemList.prototype.componentWillUnmount = function () {
        this.mounted = false;
        this.unsubscribeRecentUpdates();
    };
    ResourcedItemList.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.initialQuery !== nextProps.initialQuery ||
            this.props.taskDecisionProvider !== nextProps.taskDecisionProvider) {
            this.unsubscribeRecentUpdates();
            this.performInitialQuery(nextProps);
        }
    };
    ResourcedItemList.prototype.unsubscribeRecentUpdates = function () {
        var recentUpdatesId = this.recentUpdatesId;
        if (recentUpdatesId) {
            this.props.taskDecisionProvider.then(function (provider) {
                provider.unsubscribeRecentUpdates(recentUpdatesId);
            });
        }
        this.recentUpdatesId = undefined;
    };
    ResourcedItemList.prototype.performInitialQuery = function (props) {
        var _this = this;
        var initialQuery = props.initialQuery;
        this.performQuery(initialQuery, true, {
            id: function (id) {
                _this.recentUpdatesId = id;
            },
            recentUpdates: this.loadLatest,
        });
    };
    ResourcedItemList.prototype.performQuery = function (query, replaceAll, recentUpdatesListener) {
        var _this = this;
        var taskDecisionProvider = this.props.taskDecisionProvider;
        var items = replaceAll ? [] : this.state.items;
        var _a = this.state, loading = _a.loading, nextQuery = _a.nextQuery;
        if (loading && nextQuery) {
            // Already performing a query, and not on the initial load of component, so don't run query again
            return;
        }
        this.setState({
            loading: true,
            error: false,
            items: items,
        });
        taskDecisionProvider.then(function (provider) {
            provider
                .getItems(query, recentUpdatesListener)
                .then(function (result) {
                if (!_this.mounted) {
                    return;
                }
                var items = result.items, nextQuery = result.nextQuery;
                var combinedItems;
                if (replaceAll) {
                    combinedItems = items;
                }
                else {
                    combinedItems = __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"]((_this.state.items || []), items);
                }
                _this.setState({
                    items: combinedItems,
                    nextQuery: nextQuery,
                    loading: false,
                });
                var onUpdate = _this.props.onUpdate;
                if (onUpdate) {
                    onUpdate(combinedItems, items);
                }
            })
                .catch(function (err) {
                if (!_this.mounted) {
                    return;
                }
                _this.setState({
                    loading: false,
                    error: true,
                });
            });
        });
    };
    ResourcedItemList.prototype.renderItems = function () {
        var _a = this.props, appearance = _a.appearance, groupItems = _a.groupItems, initialQuery = _a.initialQuery;
        var items = this.state.items;
        if (!items) {
            return null;
        }
        var sortCriteria = initialQuery.sortCriteria;
        var renderedItems;
        if (groupItems && Object(__WEBPACK_IMPORTED_MODULE_11__type_helpers__["a" /* isDateSortCriteria */])(sortCriteria)) {
            renderedItems = this.renderItemsGroupedByDate(items);
        }
        else {
            renderedItems = this.renderItemsUngrouped(items);
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styled_ListContainer__["a" /* default */], { theme: { appearance: appearance } }, renderedItems));
    };
    ResourcedItemList.prototype.renderItemsUngrouped = function (items) {
        var _a = this.props, appearance = _a.appearance, renderDocument = _a.renderDocument, taskDecisionProvider = _a.taskDecisionProvider;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styled_ListWrapper__["a" /* default */], null, items.map(function (item) {
            var objectKey = Object(__WEBPACK_IMPORTED_MODULE_11__type_helpers__["g" /* toObjectKey */])(item);
            if (Object(__WEBPACK_IMPORTED_MODULE_11__type_helpers__["b" /* isDecision */])(item)) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { key: Object(__WEBPACK_IMPORTED_MODULE_11__type_helpers__["f" /* objectKeyToString */])(objectKey) },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__DecisionItem__["a" /* default */], { appearance: appearance, participants: item.participants, creator: item.creator, lastUpdater: item.lastUpdater }, renderDocument(item.content, Object(__WEBPACK_IMPORTED_MODULE_11__type_helpers__["h" /* toRendererContext */])(objectKey)))));
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_11__type_helpers__["e" /* isTask */])(item)) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { key: Object(__WEBPACK_IMPORTED_MODULE_11__type_helpers__["f" /* objectKeyToString */])(objectKey) },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__ResourcedTaskItem__["a" /* default */], { key: Object(__WEBPACK_IMPORTED_MODULE_11__type_helpers__["f" /* objectKeyToString */])(objectKey), taskDecisionProvider: taskDecisionProvider, taskId: objectKey.localId, objectAri: objectKey.objectAri, containerAri: objectKey.containerAri, appearance: appearance, participants: item.participants, creator: item.creator, lastUpdater: item.lastUpdater }, renderDocument(item.content, Object(__WEBPACK_IMPORTED_MODULE_11__type_helpers__["h" /* toRendererContext */])(objectKey)))));
            }
            return null;
        })));
    };
    ResourcedItemList.prototype.renderItemsGroupedByDate = function (items) {
        var _this = this;
        var itemsByDate = this.groupItemsByDate(items);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__styled_DateGroup__["a" /* default */], null, itemsByDate.map(function (_a) {
            var date = _a.date, items = _a.items;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { key: date.toISOString() },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styled_DateGroupHeader__["a" /* default */], null, Object(__WEBPACK_IMPORTED_MODULE_12__util_date__["a" /* getFormattedDate */])(date)),
                _this.renderItemsUngrouped(items)));
        })));
    };
    ResourcedItemList.prototype.groupItemsByDate = function (items) {
        var groupByField = this.props.initialQuery.sortCriteria || __WEBPACK_IMPORTED_MODULE_4__constants__["b" /* defaultSortCriteria */];
        var lastDate;
        return items.reduce(function (groups, item) {
            var currentDate = Object(__WEBPACK_IMPORTED_MODULE_12__util_date__["b" /* getStartOfDate */])(item[groupByField]);
            if (Object(__WEBPACK_IMPORTED_MODULE_12__util_date__["c" /* isSameDate */])(lastDate, currentDate)) {
                var lastGroup = groups[groups.length - 1];
                lastGroup.items.push(item);
            }
            else {
                lastDate = currentDate;
                groups.push({
                    date: currentDate,
                    items: [item],
                });
            }
            return groups;
        }, []);
    };
    ResourcedItemList.prototype.render = function () {
        var _a = this.props, emptyComponent = _a.emptyComponent, errorComponent = _a.errorComponent, height = _a.height, useInfiniteScroll = _a.useInfiniteScroll;
        var _b = this.state, error = _b.error, items = _b.items, loading = _b.loading;
        var loadingSpinner;
        if (error && errorComponent) {
            return errorComponent || null;
        }
        if (loading) {
            var fullHeight = !items || items.length === 0;
            loadingSpinner = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](LoadingWrapper, { fullHeight: fullHeight },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_spinner__["a" /* default */], { size: "medium" })));
        }
        else if (!items || !items.length) {
            return emptyComponent || null;
        }
        if (height && useInfiniteScroll) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__InfiniteScroll__["a" /* default */], { height: height, onThresholdReached: this.loadMore },
                this.renderItems(),
                loadingSpinner));
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
            this.renderItems(),
            loadingSpinner));
    };
    ResourcedItemList.defaultProps = {
        appearance: 'card',
    };
    return ResourcedItemList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* unused harmony default export */ var _unused_webpack_default_export = (ResourcedItemList);
var templateObject_1;
//# sourceMappingURL=ResourcedItemList.js.map

/***/ }),
/* 2719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadLatestItems; });
/* unused harmony export retryIteration */
/* unused harmony export loadWithDelay */
/**
 * Grabs the latest Items from the service.
 */
var loadLatestItems = function (query, provider, recentUpdateContext) {
    if (recentUpdateContext.localId) {
        // Retry until localId is found
        return retryIteration(function () { return provider.getItems(query).then(function (r) { return r.items; }); }, recentUpdateContext);
    }
    // Just load
    return provider.getItems(query).then(function (response) { return response.items; });
};
var retryDelaysInMilliseconds = [
    500,
    1000,
    1500,
    2500,
    4000,
    6000,
    8000,
    10000,
];
var retryIteration = function (loader, recentUpdateContext, retry) {
    if (retry === void 0) { retry = 0; }
    return loadWithDelay(loader, retryDelaysInMilliseconds[retry]).then(function (items) {
        if (items.filter(function (item) { return item.localId === recentUpdateContext.localId; })
            .length > 0) {
            return items;
        }
        var delay = retryDelaysInMilliseconds[retry || 0];
        if (!delay) {
            // Give up - just retry what we've got.
            return items;
        }
        return retryIteration(loader, recentUpdateContext, retry + 1);
    });
};
var loadWithDelay = function (loader, delay) {
    return new Promise(function (resolve) {
        window.setTimeout(function () {
            loader().then(function (items) {
                resolve(items);
            });
        }, delay);
    });
};
//# sourceMappingURL=TaskDecisionLoader.js.map

/***/ }),
/* 2720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);




var InfiniteScroll = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](InfiniteScroll, _super);
    function InfiniteScroll() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.emitOnThresholdReachedWithDebounce = __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__(_this.emitOnThresholdReached, _this.props.delay, {
            leading: true,
            trailing: true,
        });
        _this.scrollHeight = 0;
        _this.checkThreshold = function (event) {
            var target = event.currentTarget;
            var threshold = _this.props.threshold || 0;
            var position = target.scrollTop + target.offsetHeight;
            var thresholdModifier = 0.1;
            var adjustedThreshold = Math.min(threshold, target.scrollHeight * thresholdModifier);
            var thresholdReached = position > _this.scrollHeight &&
                position > target.scrollHeight - adjustedThreshold;
            if (thresholdReached) {
                _this.scrollHeight = target.scrollHeight;
                _this.emitOnThresholdReachedWithDebounce();
            }
        };
        return _this;
    }
    InfiniteScroll.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: {
                width: this.props.width,
                height: this.props.height,
                overflowX: 'hidden',
                overflowY: 'auto',
                msOverflowStyle: 'scrollbar',
                display: 'inline-block',
            }, onScroll: this.checkThreshold }, this.props.children));
    };
    InfiniteScroll.prototype.emitOnThresholdReached = function () {
        if (this.props.onThresholdReached) {
            this.props.onThresholdReached();
        }
    };
    InfiniteScroll.defaultProps = {
        width: '100%',
        delay: 1000,
        threshold: 100,
    };
    return InfiniteScroll;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (InfiniteScroll);
//# sourceMappingURL=InfiniteScroll.js.map

/***/ }),
/* 2721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


// tslint:disable-next-line:variable-name
var ListContainer = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin: 0 ", ";\n  box-sizing: border-box;\n"], ["\n  margin: 0 ", ";\n  box-sizing: border-box;\n"])), function (props) { return (props.theme.appearance === 'card' ? '2px' : 0); });
/* harmony default export */ __webpack_exports__["a"] = (ListContainer);
var templateObject_1;
//# sourceMappingURL=ListContainer.js.map

/***/ }),
/* 2722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


// tslint:disable-next-line:variable-name
var DateGroup = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].ol(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  list-style-type: none;\n  padding-left: 0;\n"], ["\n  list-style-type: none;\n  padding-left: 0;\n"])));
/* harmony default export */ __webpack_exports__["a"] = (DateGroup);
var templateObject_1;
//# sourceMappingURL=DateGroup.js.map

/***/ }),
/* 2723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



// tslint:disable-next-line:variable-name
var DateGroupHeader = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  color: ", ";\n  font-size: 12px;\n  font-weight: 500;\n  margin: 12px 0 4px 0;\n"], ["\n  color: ", ";\n  font-size: 12px;\n  font-weight: 500;\n  margin: 12px 0 4px 0;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N200);
/* harmony default export */ __webpack_exports__["a"] = (DateGroupHeader);
var templateObject_1;
//# sourceMappingURL=DateGroupHeader.js.map

/***/ }),
/* 2724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFormattedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStartOfDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isSameDate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_format__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_is_same_day__ = __webpack_require__(2725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_is_same_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_is_same_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_is_today__ = __webpack_require__(2726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_is_today___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_is_today__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_is_yesterday__ = __webpack_require__(2727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_is_yesterday___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_is_yesterday__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_is_this_year__ = __webpack_require__(2728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_is_this_year___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_is_this_year__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_start_of_day__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_start_of_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns_start_of_day__);
// Only bring in the subset of date-fns that we use






var DATE_FORMAT_SAME_YEAR = 'MMMM D';
var DATE_FORMAT_PAST_YEAR = 'MMMM D, YYYY';
var getFormattedDate = function (ts) {
    // FIXME i18n messages
    if (__WEBPACK_IMPORTED_MODULE_2_date_fns_is_today__(ts)) {
        return 'Today';
    }
    if (__WEBPACK_IMPORTED_MODULE_3_date_fns_is_yesterday__(ts)) {
        return 'Yesterday';
    }
    if (__WEBPACK_IMPORTED_MODULE_4_date_fns_is_this_year__(ts)) {
        return __WEBPACK_IMPORTED_MODULE_0_date_fns_format__(ts, DATE_FORMAT_SAME_YEAR);
    }
    return __WEBPACK_IMPORTED_MODULE_0_date_fns_format__(ts, DATE_FORMAT_PAST_YEAR);
};
var getStartOfDate = function (ts) {
    return __WEBPACK_IMPORTED_MODULE_5_date_fns_start_of_day__(ts);
};
var isSameDate = function (d1, d2) {
    return d1 && d2 && __WEBPACK_IMPORTED_MODULE_1_date_fns_is_same_day__(d1, d2);
};
//# sourceMappingURL=date.js.map

/***/ }),
/* 2725 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(193)

/**
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 18, 0)
 * )
 * //=> true
 */
function isSameDay (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft)
  var dateRightStartOfDay = startOfDay(dirtyDateRight)

  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
}

module.exports = isSameDay


/***/ }),
/* 2726 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(193)

/**
 * @category Day Helpers
 * @summary Is the given date today?
 *
 * @description
 * Is the given date today?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * var result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */
function isToday (dirtyDate) {
  return startOfDay(dirtyDate).getTime() === startOfDay(new Date()).getTime()
}

module.exports = isToday


/***/ }),
/* 2727 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(193)

/**
 * @category Day Helpers
 * @summary Is the given date yesterday?
 *
 * @description
 * Is the given date yesterday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */
function isYesterday (dirtyDate) {
  var yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  return startOfDay(dirtyDate).getTime() === startOfDay(yesterday).getTime()
}

module.exports = isYesterday


/***/ }),
/* 2728 */
/***/ (function(module, exports, __webpack_require__) {

var isSameYear = __webpack_require__(2729)

/**
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * var result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */
function isThisYear (dirtyDate) {
  return isSameYear(new Date(), dirtyDate)
}

module.exports = isThisYear


/***/ }),
/* 2729 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(74)

/**
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getFullYear() === dateRight.getFullYear()
}

module.exports = isSameYear


/***/ }),
/* 2730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheckBoxWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



var CheckBoxWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  flex: 0 0 16px;\n  width: 16px;\n  height: 16px;\n  position: relative;\n  align-self: start;\n  margin: 2px ", "px 0 0;\n\n  & > input[type='checkbox'] {\n    position: absolute;\n    outline: none;\n    margin: 0;\n    opacity: 0;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n\n    + label {\n      box-sizing: border-box;\n      display: block;\n      position: relative;\n      width: 100%;\n      cursor: pointer;\n\n      &::after {\n        background: ", "\n        background-size: 16px;\n        border-radius: 3px;\n        border-style: solid;\n        border-width: 1px;\n        border-color: ", "\n        box-sizing: border-box;\n        content: '';\n        height: 16px;\n        left: 50%;\n        position: absolute;\n        transition: border-color 0.2s ease-in-out;\n        top: 8px;\n        width: 16px;\n        transform: translate(-50%, -50%);\n      }\n    }\n    &:not([disabled]) + label:hover::after {\n      background: ", "\n      transition: border 0.2s ease-in-out;\n    }\n    &[disabled] + label {\n      opacity: 0.5;\n      cursor: default;\n    }\n    &:checked {\n      + label::after {\n        background: url(data:image/svg+xml;charset=utf-8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+DQo8c3ZnIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICA8cmVjdCB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHJ4PSIyIiBmaWxsPSIjMDA1MkNDIj48L3JlY3Q+DQogIDxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik05LjM3NCA0LjkxNEw1LjQ1NiA4LjgzMmEuNzY5Ljc2OSAwIDAgMS0xLjA4OCAwTDIuNjI2IDcuMDkxYS43NjkuNzY5IDAgMSAxIDEuMDg4LTEuMDg5TDQuOTEyIDcuMmwzLjM3NC0zLjM3NGEuNzY5Ljc2OSAwIDEgMSAxLjA4OCAxLjA4OCI+PC9wYXRoPg0KPC9zdmc+)\n          no-repeat 0 0;\n        background-size: 16px;\n        border: 0;\n        border-color: transparent;\n        border-radius: 0; /* FS-1392 */\n      }\n      &:not([disabled]) + label:hover::after {\n        background: url(data:image/svg+xml;charset=utf-8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+DQo8c3ZnIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICA8cmVjdCB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHJ4PSIyIiBmaWxsPSIjMDc0N0E2Ij48L3JlY3Q+DQogIDxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik05LjM3NCA0LjkxNEw1LjQ1NiA4LjgzMmEuNzY5Ljc2OSAwIDAgMS0xLjA4OCAwTDIuNjI2IDcuMDkxYS43NjkuNzY5IDAgMSAxIDEuMDg4LTEuMDg5TDQuOTEyIDcuMmwzLjM3NC0zLjM3NGEuNzY5Ljc2OSAwIDEgMSAxLjA4OCAxLjA4OCI+PC9wYXRoPg0KPC9zdmc+)\n          no-repeat 0 0;\n        background-size: 16px;\n      }\n    }\n  }\n"], ["\n  flex: 0 0 16px;\n  width: 16px;\n  height: 16px;\n  position: relative;\n  align-self: start;\n  margin: 2px ", "px 0 0;\n\n  & > input[type='checkbox'] {\n    position: absolute;\n    outline: none;\n    margin: 0;\n    opacity: 0;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n\n    + label {\n      box-sizing: border-box;\n      display: block;\n      position: relative;\n      width: 100%;\n      cursor: pointer;\n\n      &::after {\n        background: ", "\n        background-size: 16px;\n        border-radius: 3px;\n        border-style: solid;\n        border-width: 1px;\n        border-color: ", "\n        box-sizing: border-box;\n        content: '';\n        height: 16px;\n        left: 50%;\n        position: absolute;\n        transition: border-color 0.2s ease-in-out;\n        top: 8px;\n        width: 16px;\n        transform: translate(-50%, -50%);\n      }\n    }\n    &:not([disabled]) + label:hover::after {\n      background: ", "\n      transition: border 0.2s ease-in-out;\n    }\n    &[disabled] + label {\n      opacity: 0.5;\n      cursor: default;\n    }\n    &:checked {\n      + label::after {\n        background: url(data:image/svg+xml;charset=utf-8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+DQo8c3ZnIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICA8cmVjdCB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHJ4PSIyIiBmaWxsPSIjMDA1MkNDIj48L3JlY3Q+DQogIDxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik05LjM3NCA0LjkxNEw1LjQ1NiA4LjgzMmEuNzY5Ljc2OSAwIDAgMS0xLjA4OCAwTDIuNjI2IDcuMDkxYS43NjkuNzY5IDAgMSAxIDEuMDg4LTEuMDg5TDQuOTEyIDcuMmwzLjM3NC0zLjM3NGEuNzY5Ljc2OSAwIDEgMSAxLjA4OCAxLjA4OCI+PC9wYXRoPg0KPC9zdmc+)\n          no-repeat 0 0;\n        background-size: 16px;\n        border: 0;\n        border-color: transparent;\n        border-radius: 0; /* FS-1392 */\n      }\n      &:not([disabled]) + label:hover::after {\n        background: url(data:image/svg+xml;charset=utf-8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+DQo8c3ZnIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICA8cmVjdCB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHJ4PSIyIiBmaWxsPSIjMDc0N0E2Ij48L3JlY3Q+DQogIDxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik05LjM3NCA0LjkxNEw1LjQ1NiA4LjgzMmEuNzY5Ljc2OSAwIDAgMS0xLjA4OCAwTDIuNjI2IDcuMDkxYS43NjkuNzY5IDAgMSAxIDEuMDg4LTEuMDg5TDQuOTEyIDcuMmwzLjM3NC0zLjM3NGEuNzY5Ljc2OSAwIDEgMSAxLjA4OCAxLjA4OCI+PC9wYXRoPg0KPC9zdmc+)\n          no-repeat 0 0;\n        background-size: 16px;\n      }\n    }\n  }\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])(), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N0, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN10 }), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N50, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN70 }), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B75 }));
var templateObject_1;
//# sourceMappingURL=TaskItem.js.map

/***/ }),
/* 2731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fabricElementsChannel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createAndFireEventInElementsChannel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_analytics_next__ = __webpack_require__(29);

var fabricElementsChannel = 'fabric-elements';
var createAndFireEventInElementsChannel = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_analytics_next__["createAndFireEvent"])(fabricElementsChannel);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ELEMENTS_CONTEXT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FabricElementsAnalyticsContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_createNamespaceContext__ = __webpack_require__(870);

var ELEMENTS_CONTEXT = 'fabricElementsCtx';
var FabricElementsAnalyticsContext = Object(__WEBPACK_IMPORTED_MODULE_0__helper_createNamespaceContext__["a" /* default */])(ELEMENTS_CONTEXT, 'FabricElementsAnalyticsContext');
//# sourceMappingURL=FabricElementsAnalyticsContext.js.map

/***/ }),
/* 2733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NAVIGATION_CONTEXT */
/* unused harmony export NavigationAnalyticsContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_createNamespaceContext__ = __webpack_require__(870);

var NAVIGATION_CONTEXT = 'navigationCtx';
var NavigationAnalyticsContext = Object(__WEBPACK_IMPORTED_MODULE_0__helper_createNamespaceContext__["a" /* default */])(NAVIGATION_CONTEXT, 'NavigationAnalyticsContext');
//# sourceMappingURL=NavigationAnalyticsContext.js.map

/***/ }),
/* 2734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ACTION_CREATED_FPS_EVENT */
/* unused harmony export ACTION_EDITED_FPS_EVENT */
/* unused harmony export ACTION_DELETED_FPS_EVENT */
/* unused harmony export ACTION_ARCHIVED_FPS_EVENT */
/* unused harmony export ACTION_STATE_CHANGED_FPS_EVENT */
/* unused harmony export DECISION_CREATED_FPS_EVENT */
/* unused harmony export DECISION_EDITED_FPS_EVENT */
/* unused harmony export DECISION_DELETED_FPS_EVENT */
/* unused harmony export DECISION_ARCHIVED_FPS_EVENT */
/* unused harmony export DECISION_STATE_CHANGED_FPS_EVENT */
/* unused harmony export ACTION_DECISION_FPS_EVENTS */
/* unused harmony export RecentUpdates */
/* unused harmony export ItemStateManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_service_support__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TaskDecisionUtils__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__type_helpers__ = __webpack_require__(299);







var ACTION_CREATED_FPS_EVENT = 'avi:task-decision-service:created:action';
var ACTION_EDITED_FPS_EVENT = 'avi:task-decision-service:edited:action';
var ACTION_DELETED_FPS_EVENT = 'avi:task-decision-service:deleted:action';
var ACTION_ARCHIVED_FPS_EVENT = 'avi:task-decision-service:archived:action';
var ACTION_STATE_CHANGED_FPS_EVENT = 'avi:task-decision-service:stateChanged:action';
var DECISION_CREATED_FPS_EVENT = 'avi:task-decision-service:created:decision';
var DECISION_EDITED_FPS_EVENT = 'avi:task-decision-service:edited:decision';
var DECISION_DELETED_FPS_EVENT = 'avi:task-decision-service:deleted:decision';
var DECISION_ARCHIVED_FPS_EVENT = 'avi:task-decision-service:archived:decision';
var DECISION_STATE_CHANGED_FPS_EVENT = 'avi:task-decision-service:stateChanged:decision';
var ACTION_DECISION_FPS_EVENTS = 'avi:task-decision-service:*:*';
var RecentUpdates = /** @class */ (function () {
    function RecentUpdates(pubSubClient) {
        var _this = this;
        this.idsByContainer = new Map();
        this.listenersById = new Map();
        this.onPubSubEvent = function (event, payload) {
            var containerAri = payload.containerAri;
            _this.notify({ containerAri: containerAri });
        };
        this.pubSubClient = pubSubClient;
        this.subscribeToPubSubEvents();
    }
    RecentUpdates.prototype.subscribe = function (containerAri, recentUpdatesListener) {
        var id = __WEBPACK_IMPORTED_MODULE_1_uuid__();
        var containerIds = this.idsByContainer.get(containerAri);
        if (!containerIds) {
            containerIds = [];
            this.idsByContainer.set(containerAri, containerIds);
        }
        containerIds.push(id);
        this.listenersById.set(id, {
            listener: recentUpdatesListener,
            containerAri: containerAri,
        });
        // Notify of id
        recentUpdatesListener.id(id);
    };
    RecentUpdates.prototype.unsubscribe = function (unsubscribeId) {
        var listenerDetail = this.listenersById.get(unsubscribeId);
        if (listenerDetail) {
            this.listenersById.delete(unsubscribeId);
            var containerAri = listenerDetail.containerAri;
            var idsToFilter = this.idsByContainer.get(containerAri);
            if (idsToFilter) {
                this.idsByContainer.set(containerAri, idsToFilter.filter(function (id) { return id !== unsubscribeId; }));
            }
        }
    };
    RecentUpdates.prototype.notify = function (recentUpdateContext) {
        var _this = this;
        var containerAri = recentUpdateContext.containerAri;
        var subscriberIds = this.idsByContainer.get(containerAri);
        if (subscriberIds) {
            subscriberIds.forEach(function (subscriberId) {
                var listenerDetail = _this.listenersById.get(subscriberId);
                if (listenerDetail) {
                    var listener = listenerDetail.listener;
                    listener.recentUpdates(recentUpdateContext);
                }
            });
        }
    };
    RecentUpdates.prototype.destroy = function () {
        this.unsubscribeFromPubSubEvents();
    };
    RecentUpdates.prototype.subscribeToPubSubEvents = function () {
        if (this.pubSubClient) {
            this.pubSubClient.on(ACTION_DECISION_FPS_EVENTS, this.onPubSubEvent);
        }
    };
    RecentUpdates.prototype.unsubscribeFromPubSubEvents = function () {
        if (this.pubSubClient) {
            this.pubSubClient.off(ACTION_DECISION_FPS_EVENTS, this.onPubSubEvent);
        }
    };
    return RecentUpdates;
}());

var ItemStateManager = /** @class */ (function () {
    function ItemStateManager(serviceConfig) {
        var _this = this;
        this.debouncedTaskStateQuery = null;
        this.debouncedTaskToggle = new Map();
        this.subscribers = new Map();
        this.trackedObjectKeys = new Map();
        this.cachedItems = new Map();
        this.batchedKeys = new Map();
        this.onTaskUpdatedEvent = function (event, payload) {
            var containerAri = payload.containerAri, objectAri = payload.objectAri, localId = payload.localId;
            var objectKey = { containerAri: containerAri, objectAri: objectAri, localId: localId };
            var key = Object(__WEBPACK_IMPORTED_MODULE_6__type_helpers__["f" /* objectKeyToString */])(objectKey);
            var cached = _this.cachedItems.get(key);
            if (!cached) {
                // ignore unknown task
                return;
            }
            var lastUpdateDate = new Date(payload.lastUpdateDate);
            if (lastUpdateDate > cached.lastUpdateDate) {
                _this.cachedItems.set(key, Object(__WEBPACK_IMPORTED_MODULE_5__TaskDecisionUtils__["d" /* convertServiceTaskStateToBaseItem */])(payload));
                _this.notifyUpdated(objectKey, payload.state);
                return;
            }
        };
        this.onReconnect = function () {
            _this.refreshAllTasks();
        };
        this.serviceConfig = serviceConfig;
        this.subscribeToPubSubEvents();
    }
    ItemStateManager.prototype.destroy = function () {
        if (this.debouncedTaskStateQuery) {
            clearTimeout(this.debouncedTaskStateQuery);
        }
        this.debouncedTaskToggle.forEach(function (timeout) {
            clearTimeout(timeout);
        });
        this.unsubscribeFromPubSubEvents();
    };
    ItemStateManager.prototype.toggleTask = function (objectKey, state) {
        var _this = this;
        var stringKey = Object(__WEBPACK_IMPORTED_MODULE_6__type_helpers__["f" /* objectKeyToString */])(objectKey);
        var timeout = this.debouncedTaskToggle.get(stringKey);
        if (timeout) {
            clearTimeout(timeout);
            this.debouncedTaskToggle.delete(stringKey);
        }
        // Update cache optimistically
        this.cachedItems.set(stringKey, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, objectKey, { lastUpdateDate: new Date(), type: 'TASK', state: state }));
        // Optimistically notify subscribers that the task have been updated so that they can re-render accordingly
        this.notifyUpdated(objectKey, state);
        return new Promise(function (resolve, reject) {
            _this.debouncedTaskToggle.set(stringKey, window.setTimeout(function () {
                var options = {
                    path: 'tasks',
                    requestInit: {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json; charset=UTF-8',
                        },
                        body: JSON.stringify(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, objectKey, { state: state })),
                    },
                };
                __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_service_support__["b" /* utils */]
                    .requestService(_this.serviceConfig, options)
                    .then(__WEBPACK_IMPORTED_MODULE_5__TaskDecisionUtils__["e" /* convertServiceTaskToTask */])
                    .then(function (task) {
                    var key = Object(__WEBPACK_IMPORTED_MODULE_6__type_helpers__["f" /* objectKeyToString */])(objectKey);
                    _this.cachedItems.set(key, task);
                    resolve(state);
                    // Notify subscribers that the task have been updated so that they can re-render accordingly
                    _this.notifyUpdated(objectKey, state);
                })
                    .catch(function () {
                    // Undo optimistic change
                    var previousState = Object(__WEBPACK_IMPORTED_MODULE_6__type_helpers__["i" /* toggleTaskState */])(state);
                    _this.cachedItems.set(stringKey, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, objectKey, { lastUpdateDate: new Date(), type: 'TASK', state: previousState }));
                    _this.notifyUpdated(objectKey, previousState);
                    reject();
                });
            }, 500));
        });
    };
    ItemStateManager.prototype.refreshAllTasks = function () {
        this.queueAllItems();
        this.scheduleGetTaskState();
    };
    ItemStateManager.prototype.subscribe = function (objectKey, handler) {
        var key = Object(__WEBPACK_IMPORTED_MODULE_6__type_helpers__["f" /* objectKeyToString */])(objectKey);
        var handlers = this.subscribers.get(key) || [];
        handlers.push(handler);
        this.subscribers.set(key, handlers);
        this.trackedObjectKeys.set(key, objectKey);
        var cached = this.cachedItems.get(key);
        if (cached) {
            this.notifyUpdated(objectKey, cached.state);
            return;
        }
        this.queueItem(objectKey);
        this.scheduleGetTaskState();
    };
    ItemStateManager.prototype.unsubscribe = function (objectKey, handler) {
        var key = Object(__WEBPACK_IMPORTED_MODULE_6__type_helpers__["f" /* objectKeyToString */])(objectKey);
        var handlers = this.subscribers.get(key);
        if (!handlers) {
            return;
        }
        var index = Object(__WEBPACK_IMPORTED_MODULE_5__TaskDecisionUtils__["f" /* findIndex */])(handlers, function (h) { return h === handler; });
        if (index !== -1) {
            handlers.splice(index, 1);
        }
        if (handlers.length === 0) {
            this.subscribers.delete(key);
            this.trackedObjectKeys.delete(key);
        }
        else {
            this.subscribers.set(key, handlers);
        }
    };
    ItemStateManager.prototype.getTaskState = function (keys) {
        var options = {
            path: 'tasks/state',
            requestInit: {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                },
                body: JSON.stringify({
                    taskKeys: keys,
                }),
            },
        };
        return __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_service_support__["b" /* utils */].requestService(this.serviceConfig, options);
    };
    ItemStateManager.prototype.notifyUpdated = function (objectKey, state) {
        var key = Object(__WEBPACK_IMPORTED_MODULE_6__type_helpers__["f" /* objectKeyToString */])(objectKey);
        var handlers = this.subscribers.get(key);
        if (!handlers) {
            return;
        }
        handlers.forEach(function (handler) {
            handler(state);
        });
    };
    ItemStateManager.prototype.subscribeToPubSubEvents = function () {
        if (this.serviceConfig.pubSubClient) {
            this.serviceConfig.pubSubClient.on(ACTION_STATE_CHANGED_FPS_EVENT, this.onTaskUpdatedEvent);
            this.serviceConfig.pubSubClient.on(__WEBPACK_IMPORTED_MODULE_3__types__["a" /* PubSubSpecialEventType */].RECONNECT, this.onReconnect);
        }
    };
    ItemStateManager.prototype.unsubscribeFromPubSubEvents = function () {
        if (this.serviceConfig.pubSubClient) {
            this.serviceConfig.pubSubClient.off(ACTION_STATE_CHANGED_FPS_EVENT, this.onTaskUpdatedEvent);
            this.serviceConfig.pubSubClient.off(__WEBPACK_IMPORTED_MODULE_3__types__["a" /* PubSubSpecialEventType */].RECONNECT, this.onReconnect);
        }
    };
    ItemStateManager.prototype.queueAllItems = function () {
        this.batchedKeys = new Map(this.trackedObjectKeys);
    };
    ItemStateManager.prototype.queueItem = function (objectKey) {
        var key = Object(__WEBPACK_IMPORTED_MODULE_6__type_helpers__["f" /* objectKeyToString */])(objectKey);
        if (this.batchedKeys.get(key)) {
            return;
        }
        this.batchedKeys.set(key, objectKey);
    };
    ItemStateManager.prototype.dequeueItem = function (objectKey) {
        var key = Object(__WEBPACK_IMPORTED_MODULE_6__type_helpers__["f" /* objectKeyToString */])(objectKey);
        this.batchedKeys.delete(key);
    };
    ItemStateManager.prototype.scheduleGetTaskState = function () {
        var _this = this;
        if (this.debouncedTaskStateQuery) {
            clearTimeout(this.debouncedTaskStateQuery);
        }
        this.debouncedTaskStateQuery = window.setTimeout(function () {
            _this.getTaskState(Array.from(_this.batchedKeys.values())).then(function (tasks) {
                tasks.forEach(function (task) {
                    var containerAri = task.containerAri, objectAri = task.objectAri, localId = task.localId;
                    var objectKey = { containerAri: containerAri, objectAri: objectAri, localId: localId };
                    _this.cachedItems.set(Object(__WEBPACK_IMPORTED_MODULE_6__type_helpers__["f" /* objectKeyToString */])(objectKey), Object(__WEBPACK_IMPORTED_MODULE_5__TaskDecisionUtils__["d" /* convertServiceTaskStateToBaseItem */])(task));
                    _this.dequeueItem(objectKey);
                    _this.notifyUpdated(objectKey, task.state);
                });
            });
        }, 1);
    };
    return ItemStateManager;
}());

var TaskDecisionResource = /** @class */ (function () {
    function TaskDecisionResource(serviceConfig) {
        this.serviceConfig = serviceConfig;
        this.recentUpdates = new RecentUpdates(serviceConfig.pubSubClient);
        this.itemStateManager = new ItemStateManager(serviceConfig);
    }
    TaskDecisionResource.prototype.getDecisions = function (query, recentUpdatesListener) {
        return this.query(query, 'decisions/query', __WEBPACK_IMPORTED_MODULE_5__TaskDecisionUtils__["a" /* convertServiceDecisionResponseToDecisionResponse */], recentUpdatesListener);
    };
    TaskDecisionResource.prototype.getTasks = function (query, recentUpdatesListener) {
        return this.query(query, 'tasks/query', __WEBPACK_IMPORTED_MODULE_5__TaskDecisionUtils__["c" /* convertServiceTaskResponseToTaskResponse */], recentUpdatesListener);
    };
    TaskDecisionResource.prototype.getItems = function (query, recentUpdatesListener) {
        return this.query(query, 'elements/query', __WEBPACK_IMPORTED_MODULE_5__TaskDecisionUtils__["b" /* convertServiceItemResponseToItemResponse */], recentUpdatesListener);
    };
    TaskDecisionResource.prototype.unsubscribeRecentUpdates = function (id) {
        this.recentUpdates.unsubscribe(id);
    };
    TaskDecisionResource.prototype.notifyRecentUpdates = function (recentUpdateContext) {
        this.recentUpdates.notify(recentUpdateContext);
        this.itemStateManager.refreshAllTasks();
    };
    TaskDecisionResource.prototype.query = function (query, path, converter, recentUpdatesListener) {
        var options = {
            path: path,
            requestInit: {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                },
                body: JSON.stringify(this.apiQueryToServiceQuery(query)),
            },
        };
        if (recentUpdatesListener) {
            this.recentUpdates.subscribe(query.containerAri, recentUpdatesListener);
        }
        return __WEBPACK_IMPORTED_MODULE_2__atlaskit_util_service_support__["b" /* utils */]
            .requestService(this.serviceConfig, options)
            .then(function (serviceResponse) {
            return converter(serviceResponse, query);
        });
    };
    TaskDecisionResource.prototype.apiQueryToServiceQuery = function (query) {
        var sortCriteria = query.sortCriteria, limit = query.limit, other = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](query, ["sortCriteria", "limit"]);
        var serviceQuery = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, other, { limit: limit || __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* defaultLimit */] });
        switch (sortCriteria) {
            case 'lastUpdateDate':
                serviceQuery.sortCriteria = 'LAST_UPDATE_DATE';
                break;
            case 'creationDate':
            default:
                serviceQuery.sortCriteria = 'CREATION_DATE';
                break;
        }
        return serviceQuery;
    };
    TaskDecisionResource.prototype.toggleTask = function (objectKey, state) {
        return this.itemStateManager.toggleTask(objectKey, state);
    };
    TaskDecisionResource.prototype.subscribe = function (objectKey, handler) {
        this.itemStateManager.subscribe(objectKey, handler);
    };
    TaskDecisionResource.prototype.unsubscribe = function (objectKey, handler) {
        this.itemStateManager.unsubscribe(objectKey, handler);
    };
    /**
     * Usually only needed for testing to ensure no outstanding requests
     * are sent to a server (typically mocked).
     */
    TaskDecisionResource.prototype.destroy = function () {
        this.recentUpdates.destroy();
        this.itemStateManager.destroy();
    };
    TaskDecisionResource.prototype.getCurrentUser = function () {
        return this.serviceConfig.currentUser;
    };
    return TaskDecisionResource;
}());
/* unused harmony default export */ var _unused_webpack_default_export = (TaskDecisionResource);
//# sourceMappingURL=TaskDecisionResource.js.map

/***/ }),
/* 2735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled_ListWrapper__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_analytics_namespaced_context__ = __webpack_require__(248);





var TaskList = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](TaskList, _super);
    function TaskList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TaskList.prototype.render = function () {
        var _a = this.props, listId = _a.listId, children = _a.children;
        var listSize = __WEBPACK_IMPORTED_MODULE_1_react__["Children"].count(children);
        if (!children) {
            return null;
        }
        // Data attributes are required for copy and paste from rendered content
        // to preserve the task
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styled_ListWrapper__["a" /* default */], { "data-task-list-local-id": "" }, __WEBPACK_IMPORTED_MODULE_1_react__["Children"].map(children, function (child, idx) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_analytics_namespaced_context__["a" /* FabricElementsAnalyticsContext */], { data: {
                listLocalId: listId,
                listSize: listSize,
                position: idx,
            } },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { key: idx, "data-task-local-id": "" }, child))); })));
    };
    return TaskList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (TaskList);
//# sourceMappingURL=TaskList.js.map

/***/ }),
/* 2736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = taskItemNodeViewFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_analytics_next__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nodeviews__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Task__ = __webpack_require__(2737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__editor_disabled__ = __webpack_require__(106);







var Task = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Task, _super);
    function Task() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnChange = function (taskId, isChecked) {
            var tr = _this.view.state.tr;
            var nodePos = _this.getPos();
            tr.setNodeMarkup(nodePos, undefined, {
                state: isChecked ? 'DONE' : 'TODO',
                localId: taskId,
            });
            _this.view.dispatch(tr);
        };
        /**
         * Dynamically generates analytics data relating to the parent list.
         *
         * Required to be dynamic, as list (in prosemirror model) may have
         * changed (e.g. item movements, or additional items in list).
         * This node view will have not rerendered for those changes, so
         * cannot render the position and listSize into the
         * AnalyticsContext at initial render time.
         */
        _this.addListAnalyticsData = function (event) {
            try {
                var resolvedPos = _this.view.state.doc.resolve(_this.getPos());
                var position_1 = resolvedPos.index();
                var listSize_1 = resolvedPos.parent.childCount;
                var listLocalId_1 = resolvedPos.parent.attrs.localId;
                event.update(function (payload) {
                    var _a = payload.attributes, attributes = _a === void 0 ? {} : _a, actionSubject = payload.actionSubject;
                    if (actionSubject !== 'action') {
                        // Not action related, ignore
                        return payload;
                    }
                    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, payload, { attributes: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, attributes, { position: position_1,
                            listSize: listSize_1,
                            listLocalId: listLocalId_1 }) });
                });
            }
            catch (e) {
                // This can occur if pos is NaN (seen it in some test cases)
                // Act defensively here, and lose some analytics data rather than
                // cause any user facing error.
            }
        };
        return _this;
    }
    Task.prototype.isContentEmpty = function () {
        return this.node.content.childCount === 0;
    };
    Task.prototype.createDomRef = function () {
        var domRef = document.createElement('li');
        domRef.style['list-style-type'] = 'none';
        return domRef;
    };
    Task.prototype.getContentDOM = function () {
        return { dom: document.createElement('div') };
    };
    Task.prototype.render = function (props, forwardRef) {
        var _this = this;
        var _a = this.node.attrs, localId = _a.localId, state = _a.state;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_analytics_next__["AnalyticsListener"], { channel: "fabric-elements", onEvent: this.addListAnalyticsData },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ui_WithPluginState__["a" /* default */], { plugins: {
                    editorDisabledPlugin: __WEBPACK_IMPORTED_MODULE_6__editor_disabled__["b" /* pluginKey */],
                }, render: function (_a) {
                    var editorDisabledPlugin = _a.editorDisabledPlugin;
                    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ui_Task__["a" /* default */], { taskId: localId, contentRef: forwardRef, isDone: state === 'DONE', onChange: _this.handleOnChange, showPlaceholder: _this.isContentEmpty(), providers: props.providerFactory, disabled: (editorDisabledPlugin || {}).editorDisabled }));
                } })));
    };
    Task.prototype.update = function (node, decorations) {
        /**
         * Returning false here when the previous content was empty fixes an error where the editor fails to set selection
         * inside the contentDOM after a transaction. See ED-2374.
         *
         * Returning false also when the task state has changed to force the checkbox to update. See ED-5107
         */
        var _this = this;
        return _super.prototype.update.call(this, node, decorations, function (currentNode, newNode) {
            return !_this.isContentEmpty() &&
                !!(currentNode.attrs.state === newNode.attrs.state);
        });
    };
    return Task;
}(__WEBPACK_IMPORTED_MODULE_3__nodeviews__["a" /* ReactNodeView */]));
function taskItemNodeViewFactory(portalProviderAPI, providerFactory) {
    return function (node, view, getPos) {
        return new Task(node, view, getPos, portalProviderAPI, {
            providerFactory: providerFactory,
        }).init();
    };
}
//# sourceMappingURL=taskItem.js.map

/***/ }),
/* 2737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TaskItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__task_item_with_providers__ = __webpack_require__(2738);






var messages = Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["defineMessages"])({
    placeholder: {
        id: 'fabric.editor.taskPlaceholder',
        defaultMessage: "Type your action, use '@' to assign to someone.",
        description: 'Placeholder description for an empty action/task in the editor',
    },
});
var TaskItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](TaskItem, _super);
    function TaskItem(props) {
        var _this = _super.call(this, props) || this;
        _this.renderWithProvider = function (providerFactory) {
            var _a = _this.props, providers = _a.providers, formatMessage = _a.intl.formatMessage, otherProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["providers", "intl"]);
            var taskDecisionProvider = providerFactory.taskDecisionProvider, contextIdentifierProvider = providerFactory.contextIdentifierProvider;
            var placeholder = formatMessage(messages.placeholder);
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__task_item_with_providers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, otherProps, { placeholder: placeholder, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider })));
        };
        _this.providerFactory = props.providers || new __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["f" /* ProviderFactory */]();
        return _this;
    }
    TaskItem.prototype.componentWillUnmount = function () {
        if (!this.props.providers) {
            // new ProviderFactory is created if no `providers` has been set
            // in this case when component is unmounted it's safe to destroy this providerFactory
            this.providerFactory.destroy();
        }
    };
    TaskItem.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["j" /* WithProviders */], { providers: ['taskDecisionProvider', 'contextIdentifierProvider'], providerFactory: this.providerFactory, renderNode: this.renderWithProvider }));
    };
    return TaskItem;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["injectIntl"])(TaskItem));
//# sourceMappingURL=index.js.map

/***/ }),
/* 2738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_task_decision__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_analytics_namespaced_context__ = __webpack_require__(248);





var TaskItemWithProviders = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](TaskItemWithProviders, _super);
    function TaskItemWithProviders() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { resolvedContextProvider: undefined };
        return _this;
    }
    TaskItemWithProviders.prototype.componentWillMount = function () {
        this.updateContextIdentifierProvider(this.props);
    };
    TaskItemWithProviders.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.contextIdentifierProvider !==
            this.props.contextIdentifierProvider) {
            this.updateContextIdentifierProvider(nextProps);
        }
    };
    TaskItemWithProviders.prototype.updateContextIdentifierProvider = function (props) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
            var resolvedContextProvider, err_1;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!props.contextIdentifierProvider) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, props.contextIdentifierProvider];
                    case 2:
                        resolvedContextProvider = _a.sent();
                        this.setState({ resolvedContextProvider: resolvedContextProvider });
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        this.setState({ resolvedContextProvider: undefined });
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        this.setState({ resolvedContextProvider: undefined });
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    TaskItemWithProviders.prototype.render = function () {
        var _a = this.props, contextIdentifierProvider = _a.contextIdentifierProvider, otherProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["contextIdentifierProvider"]);
        var _b = this.state.resolvedContextProvider || {}, objectId = _b.objectId, containerId = _b.containerId;
        var userContext = objectId ? 'edit' : 'new';
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_analytics_namespaced_context__["a" /* FabricElementsAnalyticsContext */], { data: {
                userContext: userContext,
            } },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_task_decision__["c" /* ResourcedTaskItem */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, otherProps, { objectAri: objectId, containerAri: containerId }))));
    };
    return TaskItemWithProviders;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (TaskItemWithProviders);
//# sourceMappingURL=task-item-with-providers.js.map

/***/ }),
/* 2739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export inputRulePlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_input_rules__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commands__ = __webpack_require__(163);







var createListRule = function (regex, name, list, item, schema, analyticType) {
    var _a = schema.nodes, paragraph = _a.paragraph, hardBreak = _a.hardBreak;
    return Object(__WEBPACK_IMPORTED_MODULE_4__utils_input_rules__["a" /* createInputRule */])(regex, function (state, match, start, end) {
        var tr = state.tr, $from = state.selection.$from;
        var content = $from.node($from.depth).content;
        var shouldBreakNode = false;
        content.forEach(function (node, offset) {
            if (node.type === hardBreak && offset < start) {
                shouldBreakNode = true;
            }
        });
        var $end = state.doc.resolve(end);
        var $endOfParent = state.doc.resolve($end.after());
        // Only allow creating list in nodes that support them.
        // Parent must be a paragraph as we don't want this applying to headings
        if ($end.parent.type !== paragraph ||
            !Object(__WEBPACK_IMPORTED_MODULE_5_prosemirror_utils__["canInsert"])($endOfParent, list.createAndFill())) {
            return null;
        }
        var where = $from.before($from.depth);
        __WEBPACK_IMPORTED_MODULE_3__analytics__["a" /* analyticsService */].trackEvent("atlassian.fabric." + analyticType + ".trigger.shortcut");
        if (!shouldBreakNode) {
            tr.delete(where, $from.end($from.depth))
                .replaceSelectionWith(list.create({ localId: __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["_26" /* uuid */].generate() }, [
                item.create({ localId: __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["_26" /* uuid */].generate() }, content),
            ]))
                .delete(start + 1, end + 1)
                .setSelection(new __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["TextSelection"](tr.doc.resolve(start + 1)));
        }
        else {
            var depthAdjustment = Object(__WEBPACK_IMPORTED_MODULE_6__commands__["a" /* changeInDepth */])($from, tr.selection.$from);
            tr.split($from.pos)
                .setSelection(new __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["NodeSelection"](tr.doc.resolve($from.pos + 1)))
                .replaceSelectionWith(list.create({ localId: __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["_26" /* uuid */].generate() }, [
                item.create({ localId: __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["_26" /* uuid */].generate() }, 
                // TODO: [ts30] handle void and null properly
                tr.doc.nodeAt($from.pos + 1).content),
            ]))
                .setSelection(new __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["TextSelection"](tr.doc.resolve($from.pos + depthAdjustment)))
                .delete(start, end + 1);
        }
        return tr;
    }, true);
};
function inputRulePlugin(schema) {
    var rules = [];
    var _a = schema.nodes, decisionList = _a.decisionList, decisionItem = _a.decisionItem, taskList = _a.taskList, taskItem = _a.taskItem;
    if (decisionList && decisionItem) {
        rules.push(createListRule(new RegExp("(^|" + __WEBPACK_IMPORTED_MODULE_4__utils_input_rules__["c" /* leafNodeReplacementCharacter */] + ")\\<\\>\\s$"), 'decisionlist', decisionList, decisionItem, schema, 'decision'));
    }
    if (taskList && taskItem) {
        rules.push(createListRule(new RegExp("(^|" + __WEBPACK_IMPORTED_MODULE_4__utils_input_rules__["c" /* leafNodeReplacementCharacter */] + ")\\[\\]\\s$"), 'tasklist', taskList, taskItem, schema, 'action'));
    }
    return Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules__["inputRules"])({ rules: rules });
}
/* harmony default export */ __webpack_exports__["a"] = (inputRulePlugin);
//# sourceMappingURL=input-rules.js.map

/***/ }),
/* 2740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export keymapPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_keymap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commands__ = __webpack_require__(163);





// tries to find a valid cursor position
var setTextSelection = function (pos) { return function (tr) {
    var newSelection = __WEBPACK_IMPORTED_MODULE_2_prosemirror_state__["Selection"].findFrom(tr.doc.resolve(pos), -1, true);
    if (newSelection) {
        tr.setSelection(newSelection);
    }
    return tr;
}; };
var isInsideTaskOrDecisionItem = function (state) {
    var _a = state.schema.nodes, decisionItem = _a.decisionItem, taskItem = _a.taskItem;
    return Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["hasParentNodeOfType"])([decisionItem, taskItem])(state.selection);
};
function keymapPlugin(schema) {
    var deleteCurrentItem = function ($from, tr) {
        return tr.delete($from.before($from.depth) - 1, $from.end($from.depth) + 1);
    };
    /*
     * Since the DecisionItem and TaskItem only accepts inline-content, we won't get any of the default behaviour from ProseMirror
     * eg. behaviour for backspace and enter etc. So we need to implement it.
     */
    var keymaps = {
        Backspace: function (state, dispatch) {
            var selection = state.selection, nodes = state.schema.nodes, tr = state.tr;
            var decisionList = nodes.decisionList, decisionItem = nodes.decisionItem, taskList = nodes.taskList, taskItem = nodes.taskItem;
            if ((!decisionItem || !decisionList) && (!taskList || !taskItem)) {
                return false;
            }
            var $from = selection.$from, $to = selection.$to;
            // Don't do anything if selection is a range
            if ($from.pos !== $to.pos) {
                return false;
            }
            // Don't do anything if the cursor isn't at the beginning of the node.
            if ($from.parentOffset !== 0) {
                return false;
            }
            var previousPos = tr.doc.resolve(Math.max(0, $from.before($from.depth) - 1));
            var previousNodeType = previousPos.pos > 0 && previousPos.node(1) && previousPos.node(1).type;
            var parentNodeType = $from.node(1).type;
            var previousNodeIsList = previousNodeType === decisionList || previousNodeType === taskList;
            var parentNodeIsList = parentNodeType === decisionList || parentNodeType === taskList;
            if (previousNodeIsList && !parentNodeIsList) {
                var content = $from.node($from.depth).content;
                var insertPos = previousPos.pos - 1;
                deleteCurrentItem($from, tr).insert(insertPos, content);
                dispatch(setTextSelection(insertPos)(tr).scrollIntoView());
                return true;
            }
            var nodeType = $from.node().type;
            if (nodeType !== decisionItem && nodeType !== taskItem) {
                return false;
            }
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__commands__["d" /* splitListAtSelection */])(tr, schema));
            return true;
        },
        Delete: function (state, dispatch) {
            var selection = state.selection, nodes = state.schema.nodes, tr = state.tr;
            var nodeIsTaskOrDecisionItem = isInsideTaskOrDecisionItem(state);
            var decisionList = nodes.decisionList, decisionItem = nodes.decisionItem, taskList = nodes.taskList, taskItem = nodes.taskItem;
            if (((!decisionItem || !decisionList) && (!taskList || !taskItem)) ||
                !nodeIsTaskOrDecisionItem) {
                return false;
            }
            var $from = selection.$from, $to = selection.$to;
            // Don't do anything if selection is a range
            if ($from.pos !== $to.pos) {
                return false;
            }
            // Don't do anything if the cursor isn't at the end of the node.
            var endOfItem = $from.end();
            var isAtEndOfItem = $from.pos === endOfItem;
            if (!isAtEndOfItem) {
                return false;
            }
            var list = $from.node($from.depth - 1);
            var isAtEndOfList = list.lastChild === $from.node();
            // split list, converted next item to a paragraph when not at end
            if (!isAtEndOfList) {
                setTextSelection(endOfItem + 2)(tr);
                Object(__WEBPACK_IMPORTED_MODULE_4__commands__["d" /* splitListAtSelection */])(tr, schema);
                setTextSelection($from.pos)(tr);
                tr.scrollIntoView();
                dispatch(tr);
                return true;
            }
            var listPos = tr.doc.resolve($from.after($from.depth - 1));
            var nodeAfterList = listPos.nodeAfter;
            if (!nodeAfterList) {
                // nothing after - default to prosemirror
                return false;
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_4__commands__["c" /* isSupportedSourceNode */])(schema, selection)) {
                // Unsupported content in following node, do nothing.
                return true;
            }
            var nodeAfterPos = tr.doc.resolve(listPos.pos + 1);
            var nodeAfterType = nodeAfterList.type;
            if (nodeAfterType === decisionList || nodeAfterType === taskList) {
                // Do nothing until FS-2896 is implemented
                return true;
            }
            var newContent = nodeAfterList.content;
            tr.delete(nodeAfterPos.before(), nodeAfterPos.after());
            tr.insert($from.pos, newContent);
            setTextSelection($from.pos)(tr);
            tr.scrollIntoView();
            dispatch(tr);
            return true;
        },
        Enter: function (state, dispatch) {
            var selection = state.selection, tr = state.tr;
            var $from = selection.$from;
            var nodeIsTaskOrDecisionItem = isInsideTaskOrDecisionItem(state);
            var node = $from.node($from.depth);
            var nodeType = node && node.type;
            var isEmpty = node && node.textContent.length === 0;
            if (nodeIsTaskOrDecisionItem) {
                if (!isEmpty) {
                    tr.split($from.pos, 1, [
                        { type: nodeType, attrs: { localId: __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["_26" /* uuid */].generate() } },
                    ]);
                    dispatch(tr);
                    return true;
                }
                // Otherwise, split list
                Object(__WEBPACK_IMPORTED_MODULE_4__commands__["d" /* splitListAtSelection */])(tr, schema);
                dispatch(tr);
                return true;
            }
            return false;
        },
    };
    return Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_keymap__["keymap"])(keymaps);
}
/* harmony default export */ __webpack_exports__["a"] = (keymapPlugin);
//# sourceMappingURL=keymaps.js.map

/***/ }),
/* 2741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ToolbarDecision */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_decision__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_decision___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_decision__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_ToolbarButton__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commands__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__insert_block_ui_ToolbarInsertBlock__ = __webpack_require__(81);









var ToolbarDecision = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ToolbarDecision, _super);
    function ToolbarDecision() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { disabled: false };
        _this.handleInsertDecision = Object(__WEBPACK_IMPORTED_MODULE_4__analytics__["c" /* withAnalytics */])('atlassian.fabric.decision.trigger.button', function () {
            var editorView = _this.props.editorView;
            if (!editorView) {
                return false;
            }
            Object(__WEBPACK_IMPORTED_MODULE_6__commands__["b" /* insertTaskDecision */])(editorView, 'decisionList');
            return true;
        });
        return _this;
    }
    ToolbarDecision.prototype.render = function () {
        var disabled = this.state.disabled;
        var _a = this.props, isDisabled = _a.isDisabled, isReducedSpacing = _a.isReducedSpacing, formatMessage = _a.intl.formatMessage;
        var label = formatMessage(__WEBPACK_IMPORTED_MODULE_7__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].decision);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ui_ToolbarButton__["a" /* default */], { onClick: this.handleInsertDecision, disabled: disabled || isDisabled, spacing: isReducedSpacing ? 'none' : 'default', title: label + " <>", iconBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_decision___default.a, { label: label }) }));
    };
    return ToolbarDecision;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["injectIntl"])(ToolbarDecision));
//# sourceMappingURL=index.js.map

/***/ }),
/* 2742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ToolbarTask */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_task__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_task___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_task__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_ToolbarButton__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commands__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__insert_block_ui_ToolbarInsertBlock__ = __webpack_require__(81);









var ToolbarTask = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ToolbarTask, _super);
    function ToolbarTask() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { disabled: false };
        _this.handleInsertTask = Object(__WEBPACK_IMPORTED_MODULE_4__analytics__["c" /* withAnalytics */])('atlassian.fabric.action.trigger.button', function () {
            var editorView = _this.props.editorView;
            if (!editorView) {
                return false;
            }
            Object(__WEBPACK_IMPORTED_MODULE_6__commands__["b" /* insertTaskDecision */])(editorView, 'taskList');
            return true;
        });
        return _this;
    }
    ToolbarTask.prototype.render = function () {
        var disabled = this.state.disabled;
        var _a = this.props, isDisabled = _a.isDisabled, isReducedSpacing = _a.isReducedSpacing, formatMessage = _a.intl.formatMessage;
        var label = formatMessage(__WEBPACK_IMPORTED_MODULE_7__insert_block_ui_ToolbarInsertBlock__["b" /* messages */].action);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ui_ToolbarButton__["a" /* default */], { onClick: this.handleInsertTask, disabled: disabled || isDisabled, spacing: isReducedSpacing ? 'none' : 'default', title: label + " []", iconBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_task___default.a, { label: label }) }));
    };
    return ToolbarTask;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["injectIntl"])(ToolbarTask));
//# sourceMappingURL=index.js.map

/***/ }),
/* 2743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getActiveColor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__ = __webpack_require__(221);

var getActiveColor = function (state) {
    var _a = state.selection, $from = _a.$from, $to = _a.$to, $cursor = _a.$cursor;
    var textColor = state.schema.marks.textColor;
    // Filter out other marks
    var marks = [];
    if ($cursor) {
        marks.push(textColor.isInSet(state.storedMarks || $cursor.marks()) || undefined);
    }
    else {
        state.doc.nodesBetween($from.pos, $to.pos, function (currentNode) {
            var mark = textColor.isInSet(currentNode.marks) || undefined;
            marks.push(mark);
            return !mark;
        });
    }
    // Merge consecutive same color marks
    var prevMark;
    marks = marks.filter(function (mark) {
        if (mark && prevMark && mark.attrs.color === prevMark.attrs.color) {
            return false;
        }
        prevMark = mark;
        return true;
    });
    var marksWithColor = marks.filter(function (mark) { return !!mark; });
    // When mutiple color is selected revert back to default color
    if (marksWithColor.length > 1 ||
        (marksWithColor.length === 1 && marks.length > 2)) {
        return null;
    }
    return marksWithColor.length
        ? marksWithColor[0].attrs.color
        : __WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__["b" /* DEFAULT_COLOR */].color;
};
//# sourceMappingURL=color.js.map

/***/ }),
/* 2744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export messages */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_chevron_down__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_chevron_down___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_chevron_down__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_text_color__ = __webpack_require__(2745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_text_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_text_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_ToolbarButton__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_ColorPalette__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_Dropdown__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles__ = __webpack_require__(2746);











var messages = Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["defineMessages"])({
    textColor: {
        id: 'fabric.editor.textColor',
        defaultMessage: 'Text color',
        description: '',
    },
});
var ToolbarTextColor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ToolbarTextColor, _super);
    function ToolbarTextColor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false,
        };
        _this.changeTextColor = Object(__WEBPACK_IMPORTED_MODULE_6__analytics__["c" /* withAnalytics */])('atlassian.editor.format.textcolor.button', function (color, disabled) {
            if (!disabled) {
                _this.toggleOpen();
                return _this.props.changeColor(color);
            }
            return false;
        });
        _this.toggleOpen = function () {
            _this.handleOpenChange({ isOpen: !_this.state.isOpen });
        };
        _this.handleOpenChange = function (_a) {
            var isOpen = _a.isOpen;
            _this.setState({ isOpen: isOpen });
        };
        _this.getIconColor = function (color, defaultColor) {
            var isOpen = _this.state.isOpen;
            var isDefaultColor = defaultColor === color;
            return isOpen || isDefaultColor ? undefined : color;
        };
        return _this;
    }
    ToolbarTextColor.prototype.render = function () {
        var _this = this;
        var isOpen = this.state.isOpen;
        var _a = this.props, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, popupsScrollableElement = _a.popupsScrollableElement, isReducedSpacing = _a.isReducedSpacing, pluginState = _a.pluginState, formatMessage = _a.intl.formatMessage;
        var labelTextColor = formatMessage(messages.textColor);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styles__["d" /* Wrapper */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ui_Dropdown__["a" /* default */], { mountTo: popupsMountPoint, boundariesElement: popupsBoundariesElement, scrollableElement: popupsScrollableElement, isOpen: isOpen && !pluginState.disabled, onOpenChange: this.handleOpenChange, fitWidth: 242, fitHeight: 80, zIndex: __WEBPACK_IMPORTED_MODULE_5__atlaskit_editor_common__["r" /* akEditorMenuZIndex */], trigger: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ui_ToolbarButton__["a" /* default */], { spacing: isReducedSpacing ? 'none' : 'default', disabled: pluginState.disabled, selected: isOpen, title: labelTextColor, onClick: this.toggleOpen, iconBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styles__["c" /* TriggerWrapper */], null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_text_color___default.a, { primaryColor: this.getIconColor(pluginState.color, pluginState.defaultColor), label: labelTextColor }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styles__["a" /* ExpandIconWrapper */], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_chevron_down___default.a, { label: labelTextColor }))) }) },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ui_ColorPalette__["a" /* default */], { palette: pluginState.palette, onClick: function (color) { return _this.changeTextColor(color, pluginState.disabled); }, selectedColor: pluginState.color, borderColors: pluginState.borderColorPalette })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styles__["b" /* Separator */], null)));
    };
    return ToolbarTextColor;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["injectIntl"])(ToolbarTextColor));
//# sourceMappingURL=index.js.map

/***/ }),
/* 2745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorTextColorIcon = function EditorTextColorIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><rect x=\"5\" y=\"5\" width=\"14\" height=\"14\" rx=\"2\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorTextColorIcon.displayName = 'EditorTextColorIcon';
var _default = EditorTextColorIcon;
exports.default = _default;

/***/ }),
/* 2746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TriggerWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Separator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExpandIconWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



var TriggerWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var Separator = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  background: ", ";\n  width: 1px;\n  height: 24px;\n  display: inline-block;\n  margin: 0 8px;\n"], ["\n  background: ", ";\n  width: 1px;\n  height: 24px;\n  display: inline-block;\n  margin: 0 8px;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30);
var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  align-items: center;\n  div {\n    display: flex;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  div {\n    display: flex;\n  }\n"])));
var ExpandIconWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin-left: -8px;\n"], ["\n  margin-left: -8px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toggleColor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_disabled__ = __webpack_require__(874);


var toggleColor = function (color) { return function (state, dispatch) {
    var textColor = state.schema.marks.textColor;
    var tr = state.tr;
    var disabledState = Object(__WEBPACK_IMPORTED_MODULE_1__utils_disabled__["a" /* getDisabledState */])(state);
    if (disabledState) {
        dispatch(tr.setMeta(__WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__["d" /* pluginKey */], { action: __WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__["a" /* ACTIONS */].DISABLE }));
        return false;
    }
    var _a = state.selection, ranges = _a.ranges, $cursor = _a.$cursor;
    if ($cursor) {
        var mark = textColor.create({ color: color });
        tr = tr.addStoredMark(mark);
        dispatch(tr.setMeta(__WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__["d" /* pluginKey */], { action: __WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__["a" /* ACTIONS */].SET_COLOR, color: color }));
        return true;
    }
    for (var i = 0; i < ranges.length; i++) {
        var _b = ranges[i], $from = _b.$from, $to = _b.$to;
        tr = tr.addMark($from.pos, $to.pos, textColor.create({ color: color }));
    }
    tr = tr.scrollIntoView();
    dispatch(tr.setMeta(__WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__["d" /* pluginKey */], { action: __WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__["a" /* ACTIONS */].SET_COLOR, color: color }));
    return true;
}; };
//# sourceMappingURL=toggle-color.js.map

/***/ }),
/* 2748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return removeColor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__ = __webpack_require__(221);

var removeColor = function () { return function (state, dispatch) {
    var textColor = state.schema.marks.textColor;
    var _a = state.selection, from = _a.from, to = _a.to, $cursor = _a.$cursor;
    var tr = state.tr;
    if ($cursor) {
        tr = state.tr.removeStoredMark(textColor);
    }
    else {
        tr = state.tr.removeMark(from, to, textColor);
    }
    dispatch(tr.setMeta(__WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__["d" /* pluginKey */], { action: __WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__["a" /* ACTIONS */].RESET_COLOR }));
}; };
//# sourceMappingURL=remove-color.js.map

/***/ }),
/* 2749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_styles__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pm_plugins_main__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pm_plugins_clear_formatting__ = __webpack_require__(2750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pm_plugins_cursor__ = __webpack_require__(2751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pm_plugins_input_rule__ = __webpack_require__(2752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pm_plugins_clear_formatting_keymap__ = __webpack_require__(2753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pm_plugins_smart_input_rule__ = __webpack_require__(2754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pm_plugins_keymap__ = __webpack_require__(2755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_ToolbarAdvancedTextFormatting__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_ToolbarTextFormatting__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_WithPluginState__ = __webpack_require__(32);













var textFormatting = function (options) { return ({
    marks: function () {
        return [
            { name: 'em', mark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["z" /* em */] },
            { name: 'strong', mark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["_7" /* strong */] },
            { name: 'strike', mark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["_6" /* strike */] },
        ]
            .concat(options.disableCode ? [] : { name: 'code', mark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["l" /* code */] })
            .concat(options.disableSuperscriptAndSubscript
            ? []
            : { name: 'subsup', mark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["_8" /* subsup */] })
            .concat(options.disableUnderline ? [] : { name: 'underline', mark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["_23" /* underline */] });
    },
    pmPlugins: function () {
        return [
            {
                name: 'textFormatting',
                plugin: function (_a) {
                    var dispatch = _a.dispatch;
                    return Object(__WEBPACK_IMPORTED_MODULE_3__pm_plugins_main__["a" /* plugin */])(dispatch);
                },
            },
            {
                name: 'textFormattingCursor',
                plugin: function () { return __WEBPACK_IMPORTED_MODULE_5__pm_plugins_cursor__["a" /* default */]; },
            },
            {
                name: 'textFormattingInputRule',
                plugin: function (_a) {
                    var schema = _a.schema;
                    return Object(__WEBPACK_IMPORTED_MODULE_6__pm_plugins_input_rule__["a" /* default */])(schema);
                },
            },
            {
                name: 'textFormattingSmartRule',
                plugin: function (_a) {
                    var schema = _a.schema;
                    return !options.disableSmartTextCompletion
                        ? __WEBPACK_IMPORTED_MODULE_8__pm_plugins_smart_input_rule__["a" /* default */]
                        : undefined;
                },
            },
            {
                name: 'textFormattingClear',
                plugin: function (_a) {
                    var dispatch = _a.dispatch;
                    return Object(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_clear_formatting__["a" /* plugin */])(dispatch);
                },
            },
            {
                name: 'textFormattingClearKeymap',
                plugin: function (_a) {
                    var schema = _a.schema;
                    return Object(__WEBPACK_IMPORTED_MODULE_7__pm_plugins_clear_formatting_keymap__["a" /* default */])(schema);
                },
            },
            {
                name: 'textFormattingKeymap',
                plugin: function (_a) {
                    var schema = _a.schema;
                    return Object(__WEBPACK_IMPORTED_MODULE_9__pm_plugins_keymap__["a" /* default */])(schema);
                },
            },
        ];
    },
    primaryToolbarComponent: function (_a) {
        var editorView = _a.editorView, popupsMountPoint = _a.popupsMountPoint, popupsScrollableElement = _a.popupsScrollableElement, isToolbarReducedSpacing = _a.isToolbarReducedSpacing, disabled = _a.disabled;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__ui_WithPluginState__["a" /* default */], { plugins: {
                textFormattingState: __WEBPACK_IMPORTED_MODULE_3__pm_plugins_main__["b" /* pluginKey */],
                clearFormattingState: __WEBPACK_IMPORTED_MODULE_4__pm_plugins_clear_formatting__["b" /* pluginKey */],
            }, render: function (_a) {
                var textFormattingState = _a.textFormattingState, clearFormattingState = _a.clearFormattingState;
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__ui_styles__["b" /* ButtonGroup */], { width: isToolbarReducedSpacing ? 'small' : 'large' },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__ui_ToolbarTextFormatting__["a" /* default */], { disabled: disabled, editorView: editorView, textFormattingState: textFormattingState, isReducedSpacing: isToolbarReducedSpacing }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ui_ToolbarAdvancedTextFormatting__["a" /* default */], { editorView: editorView, isDisabled: disabled, isReducedSpacing: isToolbarReducedSpacing, textFormattingState: textFormattingState, clearFormattingState: clearFormattingState, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement })));
            } }));
    },
}); };
/* harmony default export */ __webpack_exports__["a"] = (textFormatting);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluginKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return plugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(293);


var pluginKey = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["PluginKey"]('clearFormattingPlugin');
var plugin = function (dispatch) {
    return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
        state: {
            init: function (config, state) {
                return { formattingIsPresent: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* checkFormattingIsPresent */])(state) };
            },
            apply: function (tr, pluginState, oldState, newState) {
                var formattingIsPresent = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* checkFormattingIsPresent */])(newState);
                if (formattingIsPresent !== pluginState.formattingIsPresent) {
                    dispatch(pluginKey, { formattingIsPresent: formattingIsPresent });
                    return { formattingIsPresent: formattingIsPresent };
                }
                return pluginState;
            },
        },
        key: pluginKey,
    });
};
//# sourceMappingURL=clear-formatting.js.map

/***/ }),
/* 2751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["Plugin"]({
    props: {
        handleClick: function (view, clickPos, event) {
            // Don't apply in Edge as per ED-4546
            if (navigator && /Edge\/\d/.test(navigator.userAgent)) {
                return false;
            }
            var code = view.state.schema.marks.code;
            var $click = view.state.doc.resolve(clickPos);
            var clickWasAtEdgeOfATextNode = ($click.nodeBefore ? $click.nodeBefore.isInline : $click.nodeAfter) &&
                ($click.nodeAfter ? $click.nodeAfter.isInline : $click.nodeBefore) &&
                $click.textOffset === 0;
            var clickWasNearACodeMark = code &&
                (($click.nodeBefore && code.isInSet($click.nodeBefore.marks)) ||
                    ($click.nodeAfter && code.isInSet($click.nodeAfter.marks)));
            // Find the starting position of the clicked dom-element
            // TODO: Remove calls to private API
            var clickedDOMElementPosition = event.target &&
                event.target instanceof Node &&
                view.posAtDOM(event.target);
            if (clickWasAtEdgeOfATextNode &&
                clickWasNearACodeMark &&
                clickedDOMElementPosition) {
                var clickWasInsideNodeDOM = event.target.parentNode ===
                    view.domAtPos(clickedDOMElementPosition).node &&
                    code.isInSet(view.state.doc.resolve(clickedDOMElementPosition).nodeAfter.marks);
                var nodeNextToClick = $click.nodeBefore && code.isInSet($click.nodeBefore.marks)
                    ? $click.nodeAfter
                    : $click.nodeBefore;
                // Need to set the selection here to allow clicking between [code('text'),{<>},emoji()]
                var tr = view.state.tr.setSelection(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["TextSelection"].near($click));
                if (clickWasInsideNodeDOM) {
                    tr.setStoredMarks([code.create()]);
                }
                else {
                    tr.setStoredMarks(nodeNextToClick ? nodeNextToClick.marks : []);
                }
                view.dispatch(tr);
                return true;
            }
            return false;
        },
    },
}));
//# sourceMappingURL=cursor.js.map

/***/ }),
/* 2752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export strongRegex1 */
/* unused harmony export strongRegex2 */
/* unused harmony export italicRegex1 */
/* unused harmony export italicRegex2 */
/* unused harmony export strikeRegex */
/* unused harmony export codeRegex */
/* unused harmony export inputRulePlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands_transform_to_code__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_input_rules__ = __webpack_require__(92);





var validCombos = {
    '**': ['_', '~~'],
    '*': ['__', '~~'],
    __: ['*', '~~'],
    _: ['**', '~~'],
    '~~': ['__', '_', '**', '*'],
};
var validRegex = function (char, str) {
    for (var i = 0; i < validCombos[char].length; i++) {
        var ch = validCombos[char][i];
        if (ch === str) {
            return true;
        }
        var matchLength = str.length - ch.length;
        if (str.substr(matchLength, str.length) === ch) {
            return validRegex(ch, str.substr(0, matchLength));
        }
    }
    return false;
};
function addMark(markType, schema, charSize, char) {
    return function (state, match, start, end) {
        var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](match, 3), prefix = _a[1], textWithCombo = _a[2];
        var to = end;
        // in case of *string* pattern it matches the text from beginning of the paragraph,
        // because we want ** to work for strong text
        // that's why "start" argument is wrong and we need to calculate it ourselves
        var from = textWithCombo ? start + prefix.length : start;
        var nodeBefore = state.doc.resolve(start + prefix.length).nodeBefore;
        if (prefix &&
            prefix.length > 0 &&
            !validRegex(char, prefix) &&
            !(nodeBefore && nodeBefore.type === state.schema.nodes.hardBreak)) {
            return null;
        }
        // fixes the following case: my `*name` is *
        // expected result: should ignore special characters inside "code"
        if (state.schema.marks.code &&
            state.schema.marks.code.isInSet(state.doc.resolve(from + 1).marks())) {
            return null;
        }
        // Prevent autoformatting across hardbreaks
        var containsHardBreak;
        state.doc.nodesBetween(from, to, function (node) {
            if (node.type === schema.nodes.hardBreak) {
                containsHardBreak = true;
                return false;
            }
            return !containsHardBreak;
        });
        if (containsHardBreak) {
            return null;
        }
        // fixes autoformatting in heading nodes: # Heading *bold*
        // expected result: should not autoformat *bold*; <h1>Heading *bold*</h1>
        if (state.doc.resolve(from).sameParent(state.doc.resolve(to))) {
            if (!state.doc.resolve(from).parent.type.allowsMarkType(markType)) {
                return null;
            }
        }
        __WEBPACK_IMPORTED_MODULE_2__analytics__["a" /* analyticsService */].trackEvent("atlassian.editor.format." + markType.name + ".autoformatting");
        // apply mark to the range (from, to)
        var tr = state.tr.addMark(from, to, markType.create());
        if (charSize > 1) {
            // delete special characters after the text
            // Prosemirror removes the last symbol by itself, so we need to remove "charSize - 1" symbols
            tr = tr.delete(to - (charSize - 1), to);
        }
        return (tr
            // delete special characters before the text
            .delete(from, from + charSize)
            .removeStoredMark(markType));
    };
}
function addCodeMark(markType, schema, specialChar) {
    return function (state, match, start, end) {
        if (match[1] && match[1].length > 0) {
            var nodeBefore = state.doc.resolve(start + match[1].length).nodeBefore;
            if (!(nodeBefore && nodeBefore.type === state.schema.nodes.hardBreak)) {
                return null;
            }
        }
        // fixes autoformatting in heading nodes: # Heading `bold`
        // expected result: should not autoformat *bold*; <h1>Heading `bold`</h1>
        if (state.doc.resolve(start).sameParent(state.doc.resolve(end))) {
            if (!state.doc.resolve(start).parent.type.allowsMarkType(markType)) {
                return null;
            }
        }
        __WEBPACK_IMPORTED_MODULE_2__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.format.code.autoformatting');
        var regexStart = end - match[2].length + 1;
        return Object(__WEBPACK_IMPORTED_MODULE_3__commands_transform_to_code__["a" /* transformToCodeAction */])(regexStart, end, state.tr)
            .delete(regexStart, regexStart + specialChar.length)
            .removeStoredMark(markType);
    };
}
var strongRegex1 = /(\S*)(\_\_([^\_\s](\_(?!\_)|[^\_])*[^\_\s]|[^\_\s])\_\_)$/;
var strongRegex2 = /(\S*)(\*\*([^\*\s](\*(?!\*)|[^\*])*[^\*\s]|[^\*\s])\*\*)$/;
var italicRegex1 = /(\S*[^\s\_]*)(\_([^\s\_][^\_]*[^\s\_]|[^\s\_])\_)$/;
var italicRegex2 = /(\S*[^\s\*]*)(\*([^\s\*][^\*]*[^\s\*]|[^\s\*])\*)$/;
var strikeRegex = /(\S*)(\~\~([^\s\~](\~(?!\~)|[^\~])*[^\s\~]|[^\s\~])\~\~)$/;
var codeRegex = /(\S*)(`[^\s][^`]*`)$/;
function inputRulePlugin(schema) {
    var rules = [];
    if (schema.marks.strong) {
        // **string** or __strong__ should bold the text
        var markLength = 2;
        rules.push(Object(__WEBPACK_IMPORTED_MODULE_4__utils_input_rules__["a" /* createInputRule */])(strongRegex1, addMark(schema.marks.strong, schema, markLength, '__')));
        rules.push(Object(__WEBPACK_IMPORTED_MODULE_4__utils_input_rules__["a" /* createInputRule */])(strongRegex2, addMark(schema.marks.strong, schema, markLength, '**')));
    }
    if (schema.marks.em) {
        // *string* or _string_ should italic the text
        var markLength = 1;
        rules.push(Object(__WEBPACK_IMPORTED_MODULE_4__utils_input_rules__["a" /* createInputRule */])(italicRegex1, addMark(schema.marks.em, schema, markLength, '_')));
        rules.push(Object(__WEBPACK_IMPORTED_MODULE_4__utils_input_rules__["a" /* createInputRule */])(italicRegex2, addMark(schema.marks.em, schema, markLength, '*')));
    }
    if (schema.marks.strike) {
        // ~~string~~ should strikethrough the text
        var markLength = 2;
        rules.push(Object(__WEBPACK_IMPORTED_MODULE_4__utils_input_rules__["a" /* createInputRule */])(strikeRegex, addMark(schema.marks.strike, schema, markLength, '~~')));
    }
    if (schema.marks.code) {
        // `string` should monospace the text
        rules.push(Object(__WEBPACK_IMPORTED_MODULE_4__utils_input_rules__["a" /* createInputRule */])(codeRegex, addCodeMark(schema.marks.code, schema, '`')));
    }
    if (rules.length !== 0) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules__["inputRules"])({ rules: rules });
    }
}
/* harmony default export */ __webpack_exports__["a"] = (inputRulePlugin);
//# sourceMappingURL=input-rule.js.map

/***/ }),
/* 2753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export keymapPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keymaps__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands_clear_formatting__ = __webpack_require__(452);




function keymapPlugin(schema) {
    var list = {};
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["i" /* clearFormatting */].common, Object(__WEBPACK_IMPORTED_MODULE_2__analytics__["b" /* trackAndInvoke */])('atlassian.editor.format.clear.keyboard', Object(__WEBPACK_IMPORTED_MODULE_3__commands_clear_formatting__["c" /* clearFormatting */])()), list);
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__["keymap"])(list);
}
/* harmony default export */ __webpack_exports__["a"] = (keymapPlugin);
//# sourceMappingURL=clear-formatting-keymap.js.map

/***/ }),
/* 2754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_input_rules__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prosemirror_state__);





/**
 * Creates an InputRuleHandler that will match on a regular expression of the
 * form `(prefix, content, suffix?)`, and replace it with some given text,
 * maintaining prefix and suffix around the replacement.
 *
 * @param text text to replace with
 */
function replaceTextUsingCaptureGroup(text, trackingEventName) {
    return function (state, match, start, end) {
        var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](match, 4), prefix = _a[1], suffix = _a[3];
        var replacement = (prefix || '') + text + (suffix || '');
        if (trackingEventName) {
            __WEBPACK_IMPORTED_MODULE_2__analytics__["a" /* analyticsService */].trackEvent("atlassian.editor.format." + trackingEventName + ".autoformatting");
        }
        var tr = state.tr, $to = state.selection.$to;
        tr.replaceWith(start, end, state.schema.text(replacement, $to.marks()));
        tr.setSelection(__WEBPACK_IMPORTED_MODULE_4_prosemirror_state__["Selection"].near(tr.doc.resolve(tr.selection.to)));
        return tr;
    };
}
function createReplacementRule(to, from, trackingEventName) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_input_rules__["a" /* createInputRule */])(from, replaceTextUsingCaptureGroup(to, trackingEventName));
}
function createReplacementRules(replMap, trackingEventName) {
    var e_1, _a;
    var rules = [];
    try {
        for (var _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](Object.keys(replMap)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var replacement = _c.value;
            var regex = replMap[replacement];
            rules.push(createReplacementRule(replacement, regex, trackingEventName));
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return rules;
}
// We don't agressively upgrade single quotes to smart quotes because
// they may clash with an emoji. Only do that when we have a matching
// single quote, or a contraction.
function createSingleQuotesRules(trackingEventName) {
    return [
        // wrapped text
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_input_rules__["a" /* createInputRule */])(/(\s+|^)'(\S+.*\S+)'$/, function (state, match, start, end) {
            var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](match, 3), spacing = _a[1], innerContent = _a[2];
            var replacement = spacing + '‘' + innerContent + '’';
            __WEBPACK_IMPORTED_MODULE_2__analytics__["a" /* analyticsService */].trackEvent("atlassian.editor.format." + trackingEventName + ".autoformatting");
            return state.tr.insertText(replacement, start, end);
        }),
        // apostrophe
        createReplacementRule('’', /(\w)(')(\w)$/, trackingEventName),
    ];
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules__["inputRules"])({
    rules: __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](createReplacementRules({
        Atlassian: /(\s+|^)(atlassian)(\s)$/,
        Jira: /(\s+|^)(jira|JIRA)(\s)$/,
        Bitbucket: /(\s+|^)(bitbucket|BitBucket)(\s)$/,
        Hipchat: /(\s+|^)(hipchat|HipChat)(\s)$/,
        Trello: /(\s+|^)(trello)(\s)$/,
    }, 'product'), createReplacementRules({
        '→': /(\s+|^)(--?>)(\s)$/,
        '←': /(\s+|^)(<--?)(\s)$/,
        '↔︎': /(\s+|^)(<->?)(\s)$/,
    }, 'arrow'), createReplacementRules({
        '–': /(\s+|^)(--)(\s)$/,
        '…': /()(\.\.\.)$/,
    }, 'typography'), createReplacementRules({
        '“': /((?:^|[\s\{\[\(\<'"\u2018\u201C]))(")$/,
        '”': /"$/,
    }, 'quote'), createSingleQuotesRules('quote')),
}));
//# sourceMappingURL=smart-input-rule.js.map

/***/ }),
/* 2755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keymapPlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keymaps__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands_text_formatting__ = __webpack_require__(166);




function keymapPlugin(schema) {
    var list = {};
    if (schema.marks.strong) {
        var eventName = analyticsEventName(schema.marks.strong);
        __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["K" /* toggleBold */].common, Object(__WEBPACK_IMPORTED_MODULE_2__analytics__["b" /* trackAndInvoke */])(eventName, __WEBPACK_IMPORTED_MODULE_3__commands_text_formatting__["h" /* toggleStrong */]()), list);
    }
    if (schema.marks.em) {
        var eventName = analyticsEventName(schema.marks.em);
        __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["N" /* toggleItalic */].common, Object(__WEBPACK_IMPORTED_MODULE_2__analytics__["b" /* trackAndInvoke */])(eventName, __WEBPACK_IMPORTED_MODULE_3__commands_text_formatting__["f" /* toggleEm */]()), list);
    }
    if (schema.marks.code) {
        var eventName = analyticsEventName(schema.marks.code);
        __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["M" /* toggleCode */].common, Object(__WEBPACK_IMPORTED_MODULE_2__analytics__["b" /* trackAndInvoke */])(eventName, __WEBPACK_IMPORTED_MODULE_3__commands_text_formatting__["e" /* toggleCode */]()), list);
    }
    if (schema.marks.strike) {
        var eventName = analyticsEventName(schema.marks.strike);
        __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["P" /* toggleStrikethrough */].common, Object(__WEBPACK_IMPORTED_MODULE_2__analytics__["b" /* trackAndInvoke */])(eventName, __WEBPACK_IMPORTED_MODULE_3__commands_text_formatting__["g" /* toggleStrike */]()), list);
    }
    if (schema.marks.underline) {
        var eventName = analyticsEventName(schema.marks.underline);
        __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["R" /* toggleUnderline */].common, Object(__WEBPACK_IMPORTED_MODULE_2__analytics__["b" /* trackAndInvoke */])(eventName, __WEBPACK_IMPORTED_MODULE_3__commands_text_formatting__["k" /* toggleUnderline */]()), list);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__["keymap"])(list);
}
function analyticsEventName(markType) {
    return "atlassian.editor.format." + markType.name + ".keyboard";
}
//# sourceMappingURL=keymap.js.map

/***/ }),
/* 2756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pm_plugins_main__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pm_plugins_input_rules__ = __webpack_require__(2757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pm_plugins_keymap__ = __webpack_require__(2758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_TypeAhead__ = __webpack_require__(2759);







var typeAheadPlugin = {
    name: 'typeAhead',
    marks: function () {
        return [{ name: 'typeAheadQuery', mark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["_22" /* typeAheadQuery */] }];
    },
    pmPlugins: function (typeAhead) {
        if (typeAhead === void 0) { typeAhead = []; }
        return [
            {
                name: 'typeAhead',
                plugin: function (_a) {
                    var dispatch = _a.dispatch, reactContext = _a.reactContext;
                    return Object(__WEBPACK_IMPORTED_MODULE_3__pm_plugins_main__["c" /* createPlugin */])(dispatch, reactContext, typeAhead);
                },
            },
            {
                name: 'typeAheadInputRule',
                plugin: function (_a) {
                    var schema = _a.schema;
                    return Object(__WEBPACK_IMPORTED_MODULE_4__pm_plugins_input_rules__["a" /* inputRulePlugin */])(schema, typeAhead);
                },
            },
            {
                name: 'typeAheadKeymap',
                plugin: function () { return Object(__WEBPACK_IMPORTED_MODULE_5__pm_plugins_keymap__["a" /* keymapPlugin */])(); },
            },
        ];
    },
    contentComponent: function (_a) {
        var editorView = _a.editorView, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, popupsScrollableElement = _a.popupsScrollableElement;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__ui_WithPluginState__["a" /* default */], { plugins: {
                typeAhead: __WEBPACK_IMPORTED_MODULE_3__pm_plugins_main__["d" /* pluginKey */],
            }, render: function (_a) {
                var _b = _a.typeAhead, typeAhead = _b === void 0 ? Object(__WEBPACK_IMPORTED_MODULE_3__pm_plugins_main__["b" /* createInitialPluginState */])() : _b;
                var queryMarkPos = typeAhead.queryMarkPos;
                var domRef = queryMarkPos !== null ? editorView.domAtPos(queryMarkPos) : null;
                var anchorElement = domRef
                    ? domRef.node.childNodes[domRef.offset]
                    : undefined;
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ui_TypeAhead__["a" /* TypeAhead */], { editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, anchorElement: anchorElement, active: typeAhead.active, isLoading: !!typeAhead.itemsLoader, items: typeAhead.items, currentIndex: typeAhead.currentIndex }));
            } }));
    },
};
/* harmony default export */ __webpack_exports__["a"] = (typeAheadPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = inputRulePlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_input_rules__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(107);





function inputRulePlugin(schema, typeAheads) {
    var triggersRegex = typeAheads
        .map(function (t) { return t.customRegex || t.trigger; })
        .join('|');
    if (!triggersRegex.length) {
        return;
    }
    var regex = new RegExp("(^|[.!?\\s" + __WEBPACK_IMPORTED_MODULE_2__utils_input_rules__["c" /* leafNodeReplacementCharacter */] + "])(" + triggersRegex + ")$");
    var typeAheadInputRule = Object(__WEBPACK_IMPORTED_MODULE_2__utils_input_rules__["a" /* createInputRule */])(regex, function (state, match, start, end) {
        var typeAheadState = __WEBPACK_IMPORTED_MODULE_4__main__["d" /* pluginKey */].getState(state);
        /**
         * Why using match 2 and 3?  Regex:
         * (allowed characters before trigger)(joined|triggers|(sub capture groups))
         *            match[1]                     match[2]          match[3] – optional
         */
        var trigger = match[3] || match[2];
        if (!typeAheadState.isAllowed || !trigger) {
            return null;
        }
        var mark = schema.mark('typeAheadQuery', { trigger: trigger });
        var tr = state.tr, selection = state.selection;
        var marks = selection.$from.marks();
        __WEBPACK_IMPORTED_MODULE_3__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.typeahead.trigger', {
            trigger: trigger,
        });
        return tr.replaceSelectionWith(schema.text(trigger, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"]([mark], marks)), false);
    });
    return Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_inputrules__["inputRules"])({ rules: [typeAheadInputRule] });
}
/* unused harmony default export */ var _unused_webpack_default_export = (inputRulePlugin);
//# sourceMappingURL=input-rules.js.map

/***/ }),
/* 2758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keymapPlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keymaps__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands_select_item__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commands_dismiss__ = __webpack_require__(456);





function keymapPlugin() {
    var list = {};
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["k" /* enter */].common, function (state, dispatch) {
        var pluginState = __WEBPACK_IMPORTED_MODULE_2__main__["d" /* pluginKey */].getState(state);
        if (!pluginState || !pluginState.active) {
            return false;
        }
        return Object(__WEBPACK_IMPORTED_MODULE_3__commands_select_item__["b" /* selectCurrentItem */])('enter')(state, dispatch);
    }, list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["x" /* moveUp */].common, function (state, dispatch) {
        var pluginState = __WEBPACK_IMPORTED_MODULE_2__main__["d" /* pluginKey */].getState(state);
        if (!pluginState || !pluginState.active) {
            return false;
        }
        if (dispatch) {
            dispatch(state.tr.setMeta(__WEBPACK_IMPORTED_MODULE_2__main__["d" /* pluginKey */], { action: __WEBPACK_IMPORTED_MODULE_2__main__["a" /* ACTIONS */].SELECT_PREV }));
        }
        return true;
    }, list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["u" /* moveDown */].common, function (state, dispatch) {
        var pluginState = __WEBPACK_IMPORTED_MODULE_2__main__["d" /* pluginKey */].getState(state);
        if (!pluginState || !pluginState.active) {
            return false;
        }
        if (dispatch) {
            dispatch(state.tr.setMeta(__WEBPACK_IMPORTED_MODULE_2__main__["d" /* pluginKey */], { action: __WEBPACK_IMPORTED_MODULE_2__main__["a" /* ACTIONS */].SELECT_NEXT }));
        }
        return true;
    }, list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["s" /* insertNewLine */].common, function (state, dispatch) {
        var pluginState = __WEBPACK_IMPORTED_MODULE_2__main__["d" /* pluginKey */].getState(state);
        if (!pluginState || !pluginState.active) {
            return false;
        }
        return Object(__WEBPACK_IMPORTED_MODULE_3__commands_select_item__["b" /* selectCurrentItem */])('shift-enter')(state, dispatch);
    }, list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["I" /* tab */].common, function (state, dispatch) {
        var pluginState = __WEBPACK_IMPORTED_MODULE_2__main__["d" /* pluginKey */].getState(state);
        if (!pluginState || !pluginState.active) {
            return false;
        }
        return Object(__WEBPACK_IMPORTED_MODULE_3__commands_select_item__["b" /* selectCurrentItem */])('tab')(state, dispatch);
    }, list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["l" /* escape */].common, function (state, dispatch) {
        var pluginState = __WEBPACK_IMPORTED_MODULE_2__main__["d" /* pluginKey */].getState(state);
        if (!pluginState || !pluginState.active) {
            return false;
        }
        /**
         * Jira uses escape to toggle the collapsed editor
         * stop the event propagation when the picker is open
         */
        if (window.event) {
            window.event.stopPropagation();
        }
        return Object(__WEBPACK_IMPORTED_MODULE_4__commands_dismiss__["a" /* dismissCommand */])()(state, dispatch);
    }, list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["G" /* space */].common, function (state, dispatch) {
        var pluginState = __WEBPACK_IMPORTED_MODULE_2__main__["d" /* pluginKey */].getState(state);
        if (pluginState && pluginState.active) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__commands_select_item__["c" /* selectSingleItemOrDismiss */])('space')(state, dispatch);
        }
        return false;
    }, list);
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__["keymap"])(list);
}
/* unused harmony default export */ var _unused_webpack_default_export = (keymapPlugin);
//# sourceMappingURL=keymap.js.map

/***/ }),
/* 2759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TypeAheadContent */
/* harmony export (immutable) */ __webpack_exports__["a"] = TypeAhead;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TypeAheadItemsList__ = __webpack_require__(2760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commands_select_item__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commands_set_current_index__ = __webpack_require__(2761);








var TypeAheadContent = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  background: ", ";\n  border-radius: ", "px;\n  box-shadow: 0 0 1px ", ", 0 4px 8px -2px ", ";\n  padding: ", "px 0;\n  width: 300px;\n  max-height: 264px; /* 48px(item height) * 5.5(visible items) = 264 */\n  overflow-y: auto;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n  position: relative;\n"], ["\n  background: ", ";\n  border-radius: ", "px;\n  box-shadow: 0 0 1px ", ", 0 4px 8px -2px ", ";\n  padding: ", "px 0;\n  width: 300px;\n  max-height: 264px; /* 48px(item height) * 5.5(visible items) = 264 */\n  overflow-y: auto;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n  position: relative;\n"])), __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N0, Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["borderRadius"])(), __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N60A, __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N50A, __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["math"].divide(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["gridSize"], 2));
function TypeAhead(_a) {
    var active = _a.active, items = _a.items, isLoading = _a.isLoading, anchorElement = _a.anchorElement, currentIndex = _a.currentIndex, editorView = _a.editorView, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, popupsScrollableElement = _a.popupsScrollableElement;
    if (!active || !anchorElement || !items || !items.length) {
        return null;
    }
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__["e" /* Popup */], { zIndex: __WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__["m" /* akEditorFloatingDialogZIndex */], target: anchorElement, mountTo: popupsMountPoint, boundariesElement: popupsBoundariesElement, scrollableElement: popupsScrollableElement, fitHeight: 300, fitWidth: 340, offset: [0, 8] },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](TypeAheadContent, { className: "fabric-editor-typeahead" }, Array.isArray(items) ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__TypeAheadItemsList__["a" /* TypeAheadItemsList */], { insertByIndex: function (index) {
                return Object(__WEBPACK_IMPORTED_MODULE_6__commands_select_item__["a" /* selectByIndex */])(index)(editorView.state, editorView.dispatch);
            }, setCurrentIndex: function (index) {
                return Object(__WEBPACK_IMPORTED_MODULE_7__commands_set_current_index__["a" /* setCurrentIndex */])(index)(editorView.state, editorView.dispatch);
            }, items: items, currentIndex: currentIndex })) : !items && isLoading ? ('loading...') : ('no items'))));
}
var templateObject_1;
//# sourceMappingURL=TypeAhead.js.map

/***/ }),
/* 2760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scrollIntoViewIfNeeded */
/* harmony export (immutable) */ __webpack_exports__["a"] = TypeAheadItemsList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_item__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__ = __webpack_require__(3);
var _a;




var itemTheme = (_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_2__atlaskit_item__["c" /* itemThemeNamespace */]] = {
        padding: {
            default: {
                bottom: 12,
                left: 12,
                right: 12,
                top: 12,
            },
        },
        beforeItemSpacing: {
            default: function () { return 12; },
        },
        borderRadius: function () { return 0; },
        hover: {
            background: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].transparent,
            text: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].text,
            secondaryText: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N200,
        },
        selected: {
            background: Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].DN70 }),
            text: Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N800, dark: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].DN600 }),
            secondaryText: Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N200, dark: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].DN300 }),
        },
    },
    _a);
function scrollIntoViewIfNeeded(element) {
    var offsetTop = element.offsetTop, offsetHeight = element.offsetHeight, offsetParent = element.offsetParent;
    var _a = offsetParent, offsetParentHeight = _a.offsetHeight, scrollTop = _a.scrollTop;
    var direction = offsetTop + offsetHeight > offsetParentHeight + scrollTop
        ? 1
        : scrollTop > offsetTop
            ? -1
            : 0;
    if (direction !== 0 && offsetParent) {
        offsetParent.scrollTop =
            direction === 1
                ? offsetTop + offsetHeight - offsetParentHeight
                : offsetTop;
    }
}
function TypeAheadItemsList(_a) {
    var items = _a.items, currentIndex = _a.currentIndex, insertByIndex = _a.insertByIndex, setCurrentIndex = _a.setCurrentIndex;
    if (!Array.isArray(items)) {
        return null;
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_styled_components__["ThemeProvider"], { theme: itemTheme },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_item__["a" /* ItemGroup */], null, items.map(function (item, index) {
            return item.render ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: item.title, ref: index === currentIndex
                    ? function (ref) { return ref && scrollIntoViewIfNeeded(ref); }
                    : function () { return null; } }, item.render({
                onClick: function () { return insertByIndex(index); },
                onMouseMove: function () { return setCurrentIndex(index); },
                isSelected: index === currentIndex,
            }))) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_item__["b" /* default */], { key: item.title, onClick: function () { return insertByIndex(index); }, onMouseMove: function () { return setCurrentIndex(index); }, elemBefore: item.icon ? item.icon() : null, isSelected: index === currentIndex, ref: index === currentIndex
                    ? function (ref) { return ref && scrollIntoViewIfNeeded(ref.ref); }
                    : null }, item.title));
        }))));
}
//# sourceMappingURL=TypeAheadItemsList.js.map

/***/ }),
/* 2761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setCurrentIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__ = __webpack_require__(107);

var setCurrentIndex = function (currentIndex) { return function (state, dispatch) {
    if (dispatch) {
        dispatch(state.tr.setMeta(__WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__["d" /* pluginKey */], {
            action: __WEBPACK_IMPORTED_MODULE_0__pm_plugins_main__["a" /* ACTIONS */].SET_CURRENT_INDEX,
            params: { currentIndex: currentIndex },
        }));
    }
    return true;
}; };
//# sourceMappingURL=set-current-index.js.map

/***/ }),
/* 2762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pluginKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeviews__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nodeviews_unsupported_block__ = __webpack_require__(2763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nodeviews_unsupported_inline__ = __webpack_require__(2764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(2765);






var pluginKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('unsupportedContentPlugin');
var createPlugin = function (_a) {
    var schema = _a.schema, portalProviderAPI = _a.portalProviderAPI;
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        state: {
            init: function (config, state) {
                Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* traverseNode */])(state.doc, schema);
            },
            apply: function (tr, pluginState, oldState, newState) {
                return pluginState;
            },
        },
        key: pluginKey,
        props: {
            nodeViews: {
                confluenceUnsupportedBlock: __WEBPACK_IMPORTED_MODULE_2__nodeviews__["a" /* ReactNodeView */].fromComponent(__WEBPACK_IMPORTED_MODULE_3__nodeviews_unsupported_block__["a" /* default */], portalProviderAPI),
                confluenceUnsupportedInline: __WEBPACK_IMPORTED_MODULE_2__nodeviews__["a" /* ReactNodeView */].fromComponent(__WEBPACK_IMPORTED_MODULE_4__nodeviews_unsupported_inline__["a" /* default */], portalProviderAPI),
                unsupportedBlock: __WEBPACK_IMPORTED_MODULE_2__nodeviews__["a" /* ReactNodeView */].fromComponent(__WEBPACK_IMPORTED_MODULE_3__nodeviews_unsupported_block__["a" /* default */], portalProviderAPI),
                unsupportedInline: __WEBPACK_IMPORTED_MODULE_2__nodeviews__["a" /* ReactNodeView */].fromComponent(__WEBPACK_IMPORTED_MODULE_4__nodeviews_unsupported_inline__["a" /* default */], portalProviderAPI),
            },
        },
    });
};
var unsupportedContentPlugin = {
    nodes: function () {
        return [
            {
                name: 'confluenceUnsupportedBlock',
                node: __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["r" /* confluenceUnsupportedBlock */],
            },
            {
                name: 'confluenceUnsupportedInline',
                node: __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["s" /* confluenceUnsupportedInline */],
            },
            {
                name: 'unsupportedBlock',
                node: __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["_24" /* unsupportedBlock */],
            },
            {
                name: 'unsupportedInline',
                node: __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["_25" /* unsupportedInline */],
            },
        ];
    },
    pmPlugins: function () {
        return [
            {
                name: 'unsupportedContent',
                plugin: createPlugin,
            },
        ];
    },
};
/* harmony default export */ __webpack_exports__["a"] = (unsupportedContentPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UnsupportedBlockNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__ = __webpack_require__(3);





var BlockNode = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  align-items: center;\n  background: ", ";\n  border: 1px dashed ", ";\n  border-radius: ", "px;\n  box-sizing: border-box;\n  cursor: default;\n  display: block;\n  font-size: ", "px;\n  margin: 10px 0;\n  min-height: 24px;\n  padding: 10px;\n  text-align: center;\n  user-select: all;\n  min-width: 120px;\n\n  &.ProseMirror-selectednode {\n    background: ", ";\n    outline: none;\n  }\n"], ["\n  align-items: center;\n  background: ", ";\n  border: 1px dashed ", ";\n  border-radius: ", "px;\n  box-sizing: border-box;\n  cursor: default;\n  display: block;\n  font-size: ", "px;\n  margin: 10px 0;\n  min-height: 24px;\n  padding: 10px;\n  text-align: center;\n  user-select: all;\n  min-width: 120px;\n\n  &.ProseMirror-selectednode {\n    background: ", ";\n    outline: none;\n  }\n"])), __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N30, __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N50, Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["borderRadius"])(), Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["fontSize"])(), __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N50);
function UnsupportedBlockNode() {
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](BlockNode, null, "Unsupported content");
}
var templateObject_1;
//# sourceMappingURL=unsupported-block.js.map

/***/ }),
/* 2764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UnsupportedInlineNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__ = __webpack_require__(3);





var InlineNode = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  align-items: center;\n  background: ", ";\n  border: 1px dashed ", ";\n  border-radius: ", "px;\n  box-sizing: border-box;\n  cursor: default;\n  display: inline-flex;\n  font-size: ", "px;\n  margin: 0 2px;\n  min-height: 24px;\n  padding: 0 10px;\n  user-select: all;\n  vertical-align: middle;\n  white-space: nowrap;\n\n  &.ProseMirror-selectednode {\n    background: ", ";\n    outline: none;\n  }\n"], ["\n  align-items: center;\n  background: ", ";\n  border: 1px dashed ", ";\n  border-radius: ", "px;\n  box-sizing: border-box;\n  cursor: default;\n  display: inline-flex;\n  font-size: ", "px;\n  margin: 0 2px;\n  min-height: 24px;\n  padding: 0 10px;\n  user-select: all;\n  vertical-align: middle;\n  white-space: nowrap;\n\n  &.ProseMirror-selectednode {\n    background: ", ";\n    outline: none;\n  }\n"])), __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N30, __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N50, Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["borderRadius"])(), Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["fontSize"])(), __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N50);
function UnsupportedInlineNode() {
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](InlineNode, null, "Unsupported content");
}
var templateObject_1;
//# sourceMappingURL=unsupported-inline.js.map

/***/ }),
/* 2765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return traverseNode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__analytics__ = __webpack_require__(20);

var traverseNode = function (node, schema) {
    var cxhtml = '';
    var _a = schema.nodes, unsupportedInline = _a.unsupportedInline, unsupportedBlock = _a.unsupportedBlock;
    if (node.attrs && node.attrs.cxhtml) {
        cxhtml = node.attrs.cxhtml;
    }
    var data = {
        type: node.type.name,
        cxhtml: cxhtml,
        text: node.text || '',
    };
    if (node.type === unsupportedInline) {
        __WEBPACK_IMPORTED_MODULE_0__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.confluenceUnsupported.inline', data);
    }
    else if (node.type === unsupportedBlock) {
        __WEBPACK_IMPORTED_MODULE_0__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.confluenceUnsupported.block', data);
    }
    else {
        node.content.forEach(function (node) { return traverseNode(node, schema); });
    }
};
//# sourceMappingURL=utils.js.map

/***/ }),
/* 2766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stateKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__ = __webpack_require__(19);


var stateKey = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["PluginKey"]('inlineActionPlugin');
var inlineActionPlugin = {
    marks: function () { return [{ name: 'action', mark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["b" /* action */] }]; },
};
/* harmony default export */ __webpack_exports__["a"] = (inlineActionPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stateKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toolbar__ = __webpack_require__(2768);




var stateKey = new __WEBPACK_IMPORTED_MODULE_0_prosemirror_state__["PluginKey"]('cardPlugin');
var cardPlugin = {
    nodes: function () {
        return [
            { name: 'inlineCard', node: __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["I" /* inlineCard */] },
            { name: 'blockCard', node: __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["e" /* blockCard */] },
        ];
    },
    pmPlugins: function () {
        return [{ name: 'card', plugin: __WEBPACK_IMPORTED_MODULE_2__pm_plugins_main__["a" /* createPlugin */] }];
    },
    pluginsOptions: {
        floatingToolbar: __WEBPACK_IMPORTED_MODULE_3__toolbar__["a" /* floatingToolbar */],
    },
};
/* harmony default export */ __webpack_exports__["a"] = (cardPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export messages */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return floatingToolbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_remove__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_remove__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_open__ = __webpack_require__(2769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_open___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_open__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__messages__ = __webpack_require__(105);







var messages = Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["defineMessages"])({
    block: {
        id: 'fabric.editor.displayBlock',
        defaultMessage: 'Display as card',
        description: 'Display link as a card with a rich preview similar to in a Facebook feed with page title, description, and potentially an image.',
    },
    inline: {
        id: 'fabric.editor.displayInline',
        defaultMessage: 'Display as link',
        description: 'Display link with the title only.',
    },
    link: {
        id: 'fabric.editor.displayLink',
        defaultMessage: 'Display as text',
        description: 'Convert the card to become a regular text-based hyperlink.',
    },
});
var remove = function (state, dispatch) {
    if (dispatch) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["removeSelectedNode"])(state.tr));
    }
    __WEBPACK_IMPORTED_MODULE_5__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.format.card.delete.button');
    return true;
};
var visit = function (state) {
    if (state.selection instanceof __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["NodeSelection"]) {
        var attrs = state.selection.node.attrs;
        var data = attrs.data || {};
        var url = attrs.url || data.url;
        window.open(url);
        __WEBPACK_IMPORTED_MODULE_5__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.format.card.visit.button');
        return true;
    }
    return false;
};
// Temporarily disabled after https://product-fabric.atlassian.net/browse/MS-1308
/*
const changeAppearance = (selectedOption: SelectOption) => {
  if (selectedOption.value === 'link') {
    return changeSelectedCardToLink;
  } else {
    return setSelectedCardAppearance(selectedOption.value as CardAppearance);
  }
};

const buildDropdown = (
  state: EditorState,
  intl: InjectedIntl,
): FloatingToolbarItem<Command> => {
  const { selection } = state;
  const selectedNode = selection instanceof NodeSelection && selection.node;
  const options: SelectOption[] = [];
  const { inlineCard, blockCard } = state.schema.nodes;

  if (selectedNode && [inlineCard, blockCard].indexOf(selectedNode.type) > -1) {
    const currentAppearance = appearanceForNodeType(selectedNode.type);

    ['block', 'inline', 'link'].forEach(value => {
      // don't allow conversion to link if it has no url attached
      if (value === 'link' && !selectedNode.attrs.url) {
        return;
      }

      if (value === 'block') {
        // don't allow conversion if the parent node doesn't allow it
        const { $from } = selection;
        const containerDepth =
          currentAppearance === 'block' ? $from.depth : $from.depth - 1;

        const allowed = $from
          .node(containerDepth)
          .type.validContent(
            Fragment.from(
              blockCard.createChecked(
                selectedNode.attrs,
                undefined,
                selectedNode.marks,
              ),
            ),
          );

        if (!allowed) {
          return;
        }
      }

      options.push({
        value,
        label: intl.formatMessage(messages[value]),
        selected: currentAppearance === value,
      });
    });
  }

  return {
    type: 'select',
    options,
    defaultValue: options.find(option => !!option.selected),
    onChange: changeAppearance,
  };
}; */
var floatingToolbar = function (state, intl) {
    var _a = state.schema.nodes, inlineCard = _a.inlineCard, blockCard = _a.blockCard;
    return {
        title: 'Card floating controls',
        nodeType: [inlineCard, blockCard],
        items: [
            // Temporarily disabled after https://product-fabric.atlassian.net/browse/MS-1308
            // buildDropdown(state, intl),
            // { type: 'separator' },
            {
                type: 'button',
                icon: __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_open___default.a,
                title: intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__messages__["a" /* default */].visit),
                onClick: visit,
            },
            { type: 'separator' },
            {
                type: 'button',
                appearance: 'danger',
                icon: __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_remove___default.a,
                title: intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__messages__["a" /* default */].remove),
                onClick: remove,
            },
        ],
    };
};
//# sourceMappingURL=toolbar.js.map

/***/ }),
/* 2769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var OpenIcon = function OpenIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M11.031 7A1.03 1.03 0 0 0 10 8.036a1.05 1.05 0 0 0 1.044 1.045l3.121.014.014 3.121a1.05 1.05 0 0 0 1.045 1.044 1.03 1.03 0 0 0 1.036-1.035l-.019-4.161a1.053 1.053 0 0 0-1.045-1.045L11.035 7h-.004z\"/><path d=\"M13.364 8.292l-7.072 7.071a1.002 1.002 0 0 0 0 1.415c.39.39 1.024.39 1.415 0l7.071-7.071A1.002 1.002 0 0 0 14.071 8a1 1 0 0 0-.707.292z\"/></g></svg>"
  }, props));
};

OpenIcon.displayName = 'OpenIcon';
var _default = OpenIcon;
exports.default = _default;

/***/ }),
/* 2770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pluginKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_ToolbarLoader__ = __webpack_require__(2771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__editor_disabled__ = __webpack_require__(106);







var getRelevantConfig = function (view, configs) {
    // node selections always take precedence, see if
    var selectedConfig = configs.find(function (config) { return !!Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["findSelectedNodeOfType"])(config.nodeType)(view.state.selection); });
    if (selectedConfig) {
        return selectedConfig;
    }
    // create mapping of node type name to configs
    var configByNodeType = {};
    configs.forEach(function (config) {
        if (Array.isArray(config.nodeType)) {
            config.nodeType.forEach(function (nodeType) {
                configByNodeType[nodeType.name] = config;
            });
        }
        else {
            configByNodeType[config.nodeType.name] = config;
        }
    });
    // search up the tree from selection
    var $from = view.state.selection.$from;
    for (var i = $from.depth; i > 0; i--) {
        var node = $from.node(i);
        var matchedConfig = configByNodeType[node.type.name];
        if (matchedConfig) {
            return matchedConfig;
        }
    }
};
var getDomRefFromSelection = function (view) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_utils__["findDomRefAtPos"])(view.state.selection.from, view.domAtPos.bind(view));
};
var floatingToolbarPlugin = {
    name: 'floatingToolbar',
    pmPlugins: function (floatingToolbarHandlers) {
        if (floatingToolbarHandlers === void 0) { floatingToolbarHandlers = []; }
        return [
            {
                // Should be after all toolbar plugins
                name: 'floatingToolbar',
                plugin: function (_a) {
                    var dispatch = _a.dispatch, reactContext = _a.reactContext;
                    return floatingToolbarPluginFactory({
                        dispatch: dispatch,
                        floatingToolbarHandlers: floatingToolbarHandlers,
                        reactContext: reactContext,
                    });
                },
            },
        ];
    },
    contentComponent: function (_a) {
        var popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, popupsScrollableElement = _a.popupsScrollableElement, editorView = _a.editorView;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ui_WithPluginState__["a" /* default */], { plugins: {
                floatingToolbarConfigs: pluginKey,
                editorDisabledPlugin: __WEBPACK_IMPORTED_MODULE_6__editor_disabled__["b" /* pluginKey */],
            }, render: function (_a) {
                var editorDisabledPlugin = _a.editorDisabledPlugin, floatingToolbarConfigs = _a.floatingToolbarConfigs;
                var relevantConfig = floatingToolbarConfigs &&
                    getRelevantConfig(editorView, floatingToolbarConfigs);
                if (relevantConfig) {
                    var title = relevantConfig.title, _b = relevantConfig.getDomRef, getDomRef = _b === void 0 ? getDomRefFromSelection : _b, items = relevantConfig.items;
                    var targetRef = getDomRef(editorView);
                    if (targetRef && !(editorDisabledPlugin || {}).editorDisabled) {
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["e" /* Popup */], { ariaLabel: title, offset: [0, 12], target: targetRef, alignY: "bottom", alignX: "center", stick: true, mountTo: popupsMountPoint, boundariesElement: popupsBoundariesElement, scrollableElement: popupsScrollableElement },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ui_ToolbarLoader__["a" /* ToolbarLoader */], { items: items, dispatchCommand: function (fn) {
                                    return fn && fn(editorView.state, editorView.dispatch);
                                }, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement })));
                    }
                }
                return null;
            } }));
    },
};
/* harmony default export */ __webpack_exports__["a"] = (floatingToolbarPlugin);
/**
 *
 * ProseMirror Plugin
 *
 */
var pluginKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('floatingToolbarPluginKey');
function floatingToolbarPluginFactory(options) {
    var floatingToolbarHandlers = options.floatingToolbarHandlers, dispatch = options.dispatch, reactContext = options.reactContext;
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        key: pluginKey,
        state: {
            init: function () {
                __WEBPACK_IMPORTED_MODULE_5__ui_ToolbarLoader__["a" /* ToolbarLoader */].preload();
            },
            apply: function (tr, pluginState, oldState, newState) {
                var intl = reactContext().intl;
                var newPluginState = floatingToolbarHandlers
                    .map(function (handler) { return handler(newState, intl); })
                    .filter(Boolean);
                dispatch(pluginKey, newPluginState);
                return newPluginState;
            },
        },
    });
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 2771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToolbarLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_loadable__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_loadable__);

var ToolbarLoader = __WEBPACK_IMPORTED_MODULE_0_react_loadable__({
    loader: function () {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 3472)).then(function (module) { return module.default; });
    },
    loading: function () { return null; },
});
//# sourceMappingURL=ToolbarLoader.js.map

/***/ }),
/* 2772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_label__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_label___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_label__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugin__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_statusPicker__ = __webpack_require__(2773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(217);








var baseStatusPlugin = function () { return ({
    nodes: function () {
        return [{ name: 'status', node: __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["_5" /* status */] }];
    },
    pmPlugins: function () {
        return [
            {
                name: 'status',
                plugin: __WEBPACK_IMPORTED_MODULE_4__plugin__["a" /* default */],
            },
        ];
    },
    contentComponent: function (_a) {
        var editorView = _a.editorView;
        var domAtPos = editorView.domAtPos.bind(editorView);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ui_WithPluginState__["a" /* default */], { plugins: {
                statusState: __WEBPACK_IMPORTED_MODULE_4__plugin__["b" /* pluginKey */],
            }, render: function (_a) {
                var _b = _a.statusState, statusState = _b === void 0 ? {} : _b;
                var showStatusPickerAt = statusState.showStatusPickerAt;
                if (showStatusPickerAt === null) {
                    return null;
                }
                var target = Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_utils__["findDomRefAtPos"])(showStatusPickerAt, domAtPos);
                var statusNode = editorView.state.doc.nodeAt(showStatusPickerAt);
                if (!statusNode || statusNode.type.name !== 'status') {
                    return null;
                }
                var _c = statusNode.attrs, text = _c.text, color = _c.color, localId = _c.localId;
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ui_statusPicker__["a" /* default */], { autoFocus: statusState.autoFocus, target: target, defaultText: text, defaultColor: color, defaultLocalId: localId, onSelect: function (status) {
                        Object(__WEBPACK_IMPORTED_MODULE_7__actions__["e" /* updateStatus */])(status)(editorView);
                    }, onTextChanged: function (status) {
                        Object(__WEBPACK_IMPORTED_MODULE_7__actions__["e" /* updateStatus */])(status)(editorView);
                    }, closeStatusPicker: function () {
                        Object(__WEBPACK_IMPORTED_MODULE_7__actions__["b" /* commitStatusPicker */])()(editorView);
                    }, onEnter: function () {
                        Object(__WEBPACK_IMPORTED_MODULE_7__actions__["b" /* commitStatusPicker */])()(editorView);
                    } }));
            } }));
    },
}); };
var createQuickInsertMenuItem = function () { return ({
    title: 'Status',
    priority: 700,
    keywords: ['lozenge'],
    icon: function () { return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_label___default.a, { label: "Status" }); },
    action: Object(__WEBPACK_IMPORTED_MODULE_7__actions__["c" /* createStatus */])(),
}); };
var decorateWithPluginOptions = function (plugin, options) {
    if (options.menuDisabled === true) {
        return plugin;
    }
    plugin.pluginsOptions = {
        quickInsert: [createQuickInsertMenuItem()],
    };
    return plugin;
};
var statusPlugin = function (options) {
    return decorateWithPluginOptions(baseStatusPlugin(), options);
};
/* harmony default export */ __webpack_exports__["a"] = (statusPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InputMethod */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_status__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_status___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__atlaskit_status__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_styles__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_with_outer_listeners__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_analytics_next__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__analytics__ = __webpack_require__(2774);











var PopupWithListeners = Object(__WEBPACK_IMPORTED_MODULE_7__ui_with_outer_listeners__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["e" /* Popup */]);
var InputMethod;
(function (InputMethod) {
    InputMethod["blur"] = "blur";
    InputMethod["escKey"] = "escKey";
    InputMethod["enterKey"] = "enterKey";
})(InputMethod || (InputMethod = {}));
var PickerContainer = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  background: ", ";\n  padding: ", "px 0;\n  border-radius: ", "px;\n  ", ";\n"], ["\n  background: ", ";\n  padding: ", "px 0;\n  border-radius: ", "px;\n  ", ";\n"])), __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["colors"].N0, Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["gridSize"])(), Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["borderRadius"])(), __WEBPACK_IMPORTED_MODULE_6__ui_styles__["i" /* dropShadow */]);
var StatusPicker = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](StatusPicker, _super);
    function StatusPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.handleCloseStatusPicker = function (inputMethod) { return function () {
            _this.inputMethod = inputMethod;
            _this.props.closeStatusPicker();
        }; };
        _this.handleClickOutside = _this.handleCloseStatusPicker(InputMethod.blur);
        _this.handleEscapeKeydown = _this.handleCloseStatusPicker(InputMethod.escKey);
        _this.handleEnterKeydown = _this.handleCloseStatusPicker(InputMethod.enterKey);
        _this.onColorHover = function (color) {
            _this.createStatusAnalyticsAndFireFunc({
                action: 'hovered',
                actionSubject: 'statusColorPicker',
                attributes: {
                    color: color,
                    localId: _this.state.localId,
                },
            });
        };
        _this.onColorClick = function (color) {
            var _a = _this.state, text = _a.text, localId = _a.localId;
            _this.setState({ color: color });
            _this.props.onSelect({
                text: text,
                color: color,
                localId: localId,
            });
            _this.createStatusAnalyticsAndFireFunc({
                action: 'clicked',
                actionSubject: 'statusColorPicker',
                attributes: {
                    color: color,
                    localId: localId,
                },
            });
        };
        _this.onTextChanged = function (text) {
            var _a = _this.state, color = _a.color, localId = _a.localId;
            _this.setState({ text: text });
            _this.props.onTextChanged({
                text: text,
                color: color,
                localId: localId,
            });
        };
        _this.onEnter = function () {
            _this.props.onEnter(_this.state);
        };
        // cancel bubbling to fix clickOutside logic:
        // popup re-renders its content before the click event bubbles up to the document
        // therefore click target element would be different from the popup content
        _this.handlePopupClick = function (event) {
            return event.nativeEvent.stopImmediatePropagation();
        };
        _this.state = _this.extractStateFromProps(props);
        _this.createStatusAnalyticsAndFireFunc = Object(__WEBPACK_IMPORTED_MODULE_10__analytics__["a" /* createStatusAnalyticsAndFire */])(props.createAnalyticsEvent);
        return _this;
    }
    StatusPicker.prototype.componentDidMount = function () {
        var _a = this.state, color = _a.color, text = _a.text, localId = _a.localId;
        this.startTime = Date.now();
        this.inputMethod = InputMethod.blur;
        this.createStatusAnalyticsAndFireFunc({
            action: 'opened',
            actionSubject: 'statusPopup',
            attributes: {
                textLength: text ? text.length : 0,
                selectedColor: color,
                localId: localId,
            },
        });
    };
    StatusPicker.prototype.componentWillUnmount = function () {
        var _a = this.state, color = _a.color, text = _a.text, localId = _a.localId;
        var inputMethod = this.inputMethod;
        this.createStatusAnalyticsAndFireFunc({
            action: 'closed',
            actionSubject: 'statusPopup',
            attributes: {
                inputMethod: inputMethod,
                duration: Date.now() - this.startTime,
                textLength: text ? text.length : 0,
                selectedColor: color,
                localId: localId,
            },
        });
        this.startTime = 0;
    };
    StatusPicker.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var element = this.props.target;
        if (prevProps.target !== element) {
            this.setState(this.extractStateFromProps(this.props));
        }
    };
    StatusPicker.prototype.extractStateFromProps = function (props) {
        var state = {};
        var defaultColor = props.defaultColor, defaultText = props.defaultText, defaultLocalId = props.defaultLocalId;
        state.color = defaultColor || __WEBPACK_IMPORTED_MODULE_8__actions__["a" /* DEFAULT_STATUS */].color;
        state.text = defaultText || __WEBPACK_IMPORTED_MODULE_8__actions__["a" /* DEFAULT_STATUS */].text;
        state.localId = defaultLocalId;
        return state;
    };
    StatusPicker.prototype.render = function () {
        var _a = this.props, autoFocus = _a.autoFocus, target = _a.target;
        var _b = this.state, color = _b.color, text = _b.text;
        return (target && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](PopupWithListeners, { target: target, offset: [0, 8], handleClickOutside: this.handleClickOutside, handleEscapeKeydown: this.handleEscapeKeydown, handleEnterKeydown: this.handleEnterKeydown, zIndex: __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["m" /* akEditorFloatingDialogZIndex */], fitHeight: 40 },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](PickerContainer, { onClick: this.handlePopupClick },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__atlaskit_status__["StatusPicker"], { autoFocus: autoFocus, selectedColor: color, text: text, onColorClick: this.onColorClick, onColorHover: this.onColorHover, onTextChanged: this.onTextChanged, onEnter: this.onEnter })))));
    };
    StatusPicker.defaultProps = {
        autoFocus: false,
    };
    return StatusPicker;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__atlaskit_analytics_next__["withAnalyticsEvents"])()(StatusPicker));
var templateObject_1;
//# sourceMappingURL=statusPicker.js.map

/***/ }),
/* 2774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FABRIC_CHANNEL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createStatusAnalyticsAndFire; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__package_json__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__package_json__);


var FABRIC_CHANNEL = 'fabric-elements';
var createStatusAnalyticsAndFire = function (createAnalyticsEvent) { return function (payload) {
    if (createAnalyticsEvent && payload) {
        var statusPayload = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, payload, { eventType: 'ui' });
        if (!statusPayload.attributes) {
            statusPayload.attributes = {};
        }
        statusPayload.attributes.packageName = __WEBPACK_IMPORTED_MODULE_1__package_json__["name"];
        statusPayload.attributes.packageVersion = __WEBPACK_IMPORTED_MODULE_1__package_json__["version"];
        statusPayload.attributes.componentName = 'status';
        createAnalyticsEvent(statusPayload).fire(FABRIC_CHANNEL);
    }
}; };
//# sourceMappingURL=analytics.js.map

/***/ }),
/* 2775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Wrapper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nodeviews__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__width__ = __webpack_require__(114);









var Wrapper = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .ProseMirror > .breakoutView-content-wrap &[data-layout='full-width'],\n  .ProseMirror > .breakoutView-content-wrap &[data-layout='wide'] {\n    margin-left: 50%;\n    transform: translateX(-50%);\n  }\n"], ["\n  .ProseMirror > .breakoutView-content-wrap &[data-layout='full-width'],\n  .ProseMirror > .breakoutView-content-wrap &[data-layout='wide'] {\n    margin-left: 50%;\n    transform: translateX(-50%);\n  }\n"])));
var BreakoutView = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](BreakoutView, _super);
    function BreakoutView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BreakoutView.prototype.getContentDOM = function () {
        return { dom: document.createElement('div') };
    };
    BreakoutView.prototype.render = function (props, forwardRef) {
        var mode = this.node.attrs.mode;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ui_WithPluginState__["a" /* default */], { editorView: this.view, plugins: { widthState: __WEBPACK_IMPORTED_MODULE_8__width__["b" /* pluginKey */] }, render: function (_a) {
                var _b = _a.widthState, widthState = _b === void 0 ? { width: 0 } : _b;
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Wrapper, { className: "fabric-editor-breakout-mark", "data-layout": mode, style: { width: Object(__WEBPACK_IMPORTED_MODULE_5__atlaskit_editor_common__["F" /* calcBreakoutWidth */])(mode, widthState.width) } },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: forwardRef })));
            } }));
    };
    return BreakoutView;
}(__WEBPACK_IMPORTED_MODULE_6__nodeviews__["a" /* ReactNodeView */]));
function createPlugin(_a) {
    var portalProviderAPI = _a.portalProviderAPI, providerFactory = _a.providerFactory;
    return new __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["Plugin"]({
        props: {
            nodeViews: {
                breakout: function (node, view, getPos) {
                    return new BreakoutView(node, view, getPos, portalProviderAPI, {
                        providerFactory: providerFactory,
                    }).init();
                },
            },
        },
    });
}
var breakoutPlugin = {
    pmPlugins: function () {
        return [{ name: 'breakout', plugin: createPlugin }];
    },
    marks: function () {
        return [{ name: 'breakout', mark: __WEBPACK_IMPORTED_MODULE_4__atlaskit_adf_schema__["i" /* breakout */] }];
    },
};
/* harmony default export */ __webpack_exports__["a"] = (breakoutPlugin);
var templateObject_1;
//# sourceMappingURL=index.js.map

/***/ }),
/* 2776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultConfig */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pm_plugins_main__ = __webpack_require__(2777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commands__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_ToolbarAlignment__ = __webpack_require__(879);






var defaultConfig = {
    align: 'left',
};
var alignmentPlugin = {
    name: 'alignmentPlugin',
    marks: function () {
        return [{ name: 'alignment', mark: __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["c" /* alignment */] }];
    },
    pmPlugins: function () {
        return [
            {
                name: 'alignmentPlugin',
                plugin: function (_a) {
                    var props = _a.props, dispatch = _a.dispatch;
                    return Object(__WEBPACK_IMPORTED_MODULE_3__pm_plugins_main__["a" /* createPlugin */])(dispatch, defaultConfig);
                },
            },
        ];
    },
    primaryToolbarComponent: function (_a) {
        var editorView = _a.editorView, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, popupsScrollableElement = _a.popupsScrollableElement, disabled = _a.disabled, isToolbarReducedSpacing = _a.isToolbarReducedSpacing;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__ui_WithPluginState__["a" /* default */], { plugins: {
                align: __WEBPACK_IMPORTED_MODULE_3__pm_plugins_main__["b" /* pluginKey */],
            }, render: function (_a) {
                var align = _a.align;
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ui_ToolbarAlignment__["a" /* default */], { pluginState: align, isReducedSpacing: isToolbarReducedSpacing, changeAlignment: function (align) {
                        return Object(__WEBPACK_IMPORTED_MODULE_4__commands__["a" /* changeAlignment */])(align)(editorView.state, editorView.dispatch);
                    }, disabled: disabled || !align.isEnabled, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }));
            } }));
    },
};
/* harmony default export */ __webpack_exports__["a"] = (alignmentPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createInitialPluginState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluginKey; });
/* harmony export (immutable) */ __webpack_exports__["a"] = createPlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commands__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(2778);




function createInitialPluginState(editorState, pluginConfig) {
    return {
        align: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* getActiveAlignment */])(editorState) || pluginConfig.align,
        isEnabled: true,
    };
}
var pluginKey = new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["PluginKey"]('alignmentPlugin');
function createPlugin(dispatch, pluginConfig) {
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["Plugin"]({
        key: pluginKey,
        state: {
            init: function (config, editorState) {
                return createInitialPluginState(editorState, pluginConfig);
            },
            apply: function (tr, state, prevState, nextState) {
                var nextPluginState = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* getActiveAlignment */])(nextState);
                var isEnabled = Object(__WEBPACK_IMPORTED_MODULE_2__commands__["b" /* isAlignable */])(nextPluginState)(nextState, 
                /**
                 * NOTE: Stan is already making dispatch optional in another PR.
                 * We can remove this once it's merged.
                 */
                undefined);
                var newState = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, state, { align: nextPluginState, isEnabled: isEnabled });
                if (nextPluginState !== state.align || isEnabled !== state.isEnabled) {
                    dispatch(pluginKey, newState);
                }
                return newState;
            },
        },
    });
}
//# sourceMappingURL=main.js.map

/***/ }),
/* 2778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getActiveAlignment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__);

var getActiveAlignment = function (state) {
    var node = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_utils__["findParentNodeOfType"])([
        state.schema.nodes.paragraph,
        state.schema.nodes.heading,
    ])(state.selection);
    var getMark = node &&
        node.node.marks.filter(function (mark) { return mark.type === state.schema.marks.alignment; })[0];
    return (getMark && getMark.attrs.align) || 'start';
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 2779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorAlignLeftIcon = function EditorAlignLeftIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M7 7h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2zm0 4h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zm0 4h5a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorAlignLeftIcon.displayName = 'EditorAlignLeftIcon';
var _default = EditorAlignLeftIcon;
exports.default = _default;

/***/ }),
/* 2780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorAlignCenterIcon = function EditorAlignCenterIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M7 11h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zm2.5 4h5a1 1 0 0 1 0 2h-5a1 1 0 0 1 0-2zm0-8h5a1 1 0 0 1 0 2h-5a1 1 0 1 1 0-2z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorAlignCenterIcon.displayName = 'EditorAlignCenterIcon';
var _default = EditorAlignCenterIcon;
exports.default = _default;

/***/ }),
/* 2781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorAlignRightIcon = function EditorAlignRightIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M7 11h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zm5 4h5a1 1 0 0 1 0 2h-5a1 1 0 0 1 0-2zM7 7h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorAlignRightIcon.displayName = 'EditorAlignRightIcon';
var _default = EditorAlignRightIcon;
exports.default = _default;

/***/ }),
/* 2782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TriggerWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Separator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExpandIconWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



var TriggerWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var Separator = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  background: ", ";\n  width: 1px;\n  height: 24px;\n  display: inline-block;\n  margin: 0 8px;\n"], ["\n  background: ", ";\n  width: 1px;\n  height: 24px;\n  display: inline-block;\n  margin: 0 8px;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30);
var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  align-items: center;\n  div {\n    display: flex;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  div {\n    display: flex;\n  }\n"])));
var ExpandIconWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin-left: -8px;\n"], ["\n  margin-left: -8px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AlignmentButton__ = __webpack_require__(2784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(2785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_alignment_ui_ToolbarAlignment__ = __webpack_require__(879);






var alignmentOptions = [
    { title: 'Align left', value: 'start' },
    { title: 'Align center', value: 'center' },
    { title: 'Align right', value: 'end' },
];
var Alignment = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Alignment, _super);
    function Alignment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Alignment.prototype.render = function () {
        var _a = this.props, onClick = _a.onClick, selectedAlignment = _a.selectedAlignment, className = _a.className;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* AlignmentWrapper */], { className: className, style: { maxWidth: 3 * 32 } }, alignmentOptions.map(function (alignment) {
            var value = alignment.value, title = alignment.title;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__AlignmentButton__["a" /* default */], { content: __WEBPACK_IMPORTED_MODULE_4__plugins_alignment_ui_ToolbarAlignment__["b" /* iconMap */][value], key: value, value: value, label: title, onClick: onClick, isSelected: value === selectedAlignment }));
        })));
    };
    return Alignment;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Alignment);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ToolbarButton__ = __webpack_require__(40);




var AlignmentButton = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AlignmentButton, _super);
    function AlignmentButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function (e) {
            var _a = _this.props, onClick = _a.onClick, value = _a.value;
            e.preventDefault();
            onClick(value);
        };
        return _this;
    }
    AlignmentButton.prototype.render = function () {
        var _a = this.props, label = _a.label, isSelected = _a.isSelected, content = _a.content;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__ToolbarButton__["a" /* default */], { disabled: false, selected: isSelected, title: label, onClick: this.onClick, iconBefore: content }));
    };
    return AlignmentButton;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (AlignmentButton);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlignmentWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



var AlignmentWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  padding: 0 ", "px;\n  display: flex;\n  flex-wrap: wrap;\n"], ["\n  padding: 0 ", "px;\n  display: flex;\n  flex-wrap: wrap;\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])());
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pm_plugins_keymap__ = __webpack_require__(2787);


var indentationPlugin = {
    name: 'indentationPlugin',
    marks: function () {
        return [{ name: 'indentation', mark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["H" /* indentation */] }];
    },
    pmPlugins: function () {
        return [
            {
                name: 'indentationKeymap',
                plugin: function () { return Object(__WEBPACK_IMPORTED_MODULE_1__pm_plugins_keymap__["a" /* keymapPlugin */])(); },
            },
        ];
    },
};
/* harmony default export */ __webpack_exports__["a"] = (indentationPlugin);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keymapPlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keymaps__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commands__ = __webpack_require__(2788);





function keymapPlugin() {
    var list = {};
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["p" /* findShortcutByKeymap */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["q" /* indent */]), Object(__WEBPACK_IMPORTED_MODULE_2__analytics__["b" /* trackAndInvoke */])('atlassian.editor.format.block.indent.keyboard', __WEBPACK_IMPORTED_MODULE_4__commands__["a" /* indent */]), list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["p" /* findShortcutByKeymap */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["A" /* outdent */]), Object(__WEBPACK_IMPORTED_MODULE_2__analytics__["b" /* trackAndInvoke */])('atlassian.editor.format.block.outdent.keyboard', __WEBPACK_IMPORTED_MODULE_4__commands__["b" /* outdent */]), list);
    __WEBPACK_IMPORTED_MODULE_1__keymaps__["h" /* bindKeymapWithCommand */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["p" /* findShortcutByKeymap */](__WEBPACK_IMPORTED_MODULE_1__keymaps__["g" /* backspace */]), Object(__WEBPACK_IMPORTED_MODULE_2__analytics__["b" /* trackAndInvoke */])('atlassian.editor.format.block.outdent.keyboard.alt', function (state, dispatch) {
        var selection = state.selection;
        if (Object(__WEBPACK_IMPORTED_MODULE_3__utils__["C" /* isTextSelection */])(selection) &&
            selection.$cursor &&
            selection.$cursor.parentOffset === 0) {
            return dispatch ? Object(__WEBPACK_IMPORTED_MODULE_4__commands__["b" /* outdent */])(state, dispatch) : false;
        }
        return false;
    }), list);
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__["keymap"])(list);
}
/* unused harmony default export */ var _unused_webpack_default_export = (keymapPlugin);
//# sourceMappingURL=keymap.js.map

/***/ }),
/* 2788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return indent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return outdent; });
/* unused harmony export removeIndentation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commands__ = __webpack_require__(113);

var isIndentationAllowed = function (schema, node, parent) {
    var _a = schema.nodes, paragraph = _a.paragraph, heading = _a.heading, alignment = schema.marks.alignment;
    if ([paragraph, heading].indexOf(node.type) > -1) {
        if (alignment) {
            var hasAlignment = node.marks.filter(function (mark) { return mark.type === alignment; })[0];
            return !hasAlignment;
        }
        return true;
    }
    return false;
};
var indent = function (state, dispatch) {
    var indentation = state.schema.marks.indentation;
    return Object(__WEBPACK_IMPORTED_MODULE_0__commands__["k" /* toggleBlockMark */])(indentation, function (oldMark) {
        // No mark - add a mark with level 1
        return !oldMark
            ? { level: 1 }
            : // Level is at 6 or higher - do nothing
                oldMark.level >= 6
                    ? undefined
                    : // For other cases - increase level by 1
                        { level: oldMark.level + 1 };
    }, isIndentationAllowed)(state, dispatch);
};
var outdent = function (state, dispatch) {
    var indentation = state.schema.marks.indentation;
    return Object(__WEBPACK_IMPORTED_MODULE_0__commands__["k" /* toggleBlockMark */])(indentation, function (oldMark) {
        // No mark - do nothing
        return !oldMark
            ? undefined
            : // Level is at 1 or lower - remove the mark
                oldMark.level <= 1
                    ? false
                    : // For other cases - decrease level by 1
                        { level: oldMark.level - 1 };
    }, isIndentationAllowed)(state, dispatch);
};
var removeIndentation = function (state, dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__commands__["k" /* toggleBlockMark */])(state.schema.marks.indentation, function () { return false; })(state, dispatch);
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 2789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sortByRank */
/* unused harmony export fixExcludes */
/* harmony export (immutable) */ __webpack_exports__["e"] = processPluginsList;
/* harmony export (immutable) */ __webpack_exports__["c"] = createSchema;
/* harmony export (immutable) */ __webpack_exports__["b"] = createPMPlugins;
/* harmony export (immutable) */ __webpack_exports__["a"] = createErrorReporter;
/* harmony export (immutable) */ __webpack_exports__["d"] = initAnalytics;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__version__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_rank__ = __webpack_require__(2790);







function sortByRank(a, b) {
    return a.rank - b.rank;
}
function sortByOrder(item) {
    return function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_6__plugins_rank__["a" /* default */][item].indexOf(a.name) - __WEBPACK_IMPORTED_MODULE_6__plugins_rank__["a" /* default */][item].indexOf(b.name);
    };
}
function fixExcludes(marks) {
    var markKeys = Object.keys(marks);
    var markGroups = new Set(markKeys.map(function (mark) { return marks[mark].group; }));
    markKeys.map(function (markKey) {
        var mark = marks[markKey];
        if (mark.excludes) {
            mark.excludes = mark.excludes
                .split(' ')
                .filter(function (group) { return markGroups.has(group); })
                .join(' ');
        }
    });
    return marks;
}
function processPluginsList(plugins, editorProps) {
    /**
     * First pass to collect pluginsOptions
     */
    var pluginsOptions = plugins.reduce(function (acc, plugin) {
        if (plugin.pluginsOptions) {
            Object.keys(plugin.pluginsOptions).forEach(function (pluginName) {
                if (!acc[pluginName]) {
                    acc[pluginName] = [];
                }
                acc[pluginName].push(plugin.pluginsOptions[pluginName]);
            });
        }
        return acc;
    }, {});
    /**
     * Process plugins
     */
    return plugins.reduce(function (acc, plugin) {
        var _a, _b, _c;
        if (plugin.pmPlugins) {
            (_a = acc.pmPlugins).push.apply(_a, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](plugin.pmPlugins(plugin.name ? pluginsOptions[plugin.name] : undefined)));
        }
        if (plugin.nodes) {
            (_b = acc.nodes).push.apply(_b, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](plugin.nodes(editorProps)));
        }
        if (plugin.marks) {
            (_c = acc.marks).push.apply(_c, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](plugin.marks(editorProps)));
        }
        if (plugin.contentComponent) {
            acc.contentComponents.push(plugin.contentComponent);
        }
        if (plugin.primaryToolbarComponent) {
            acc.primaryToolbarComponents.push(plugin.primaryToolbarComponent);
        }
        if (plugin.secondaryToolbarComponent) {
            acc.secondaryToolbarComponents.push(plugin.secondaryToolbarComponent);
        }
        return acc;
    }, {
        nodes: [],
        marks: [],
        pmPlugins: [],
        contentComponents: [],
        primaryToolbarComponents: [],
        secondaryToolbarComponents: [],
    });
}
function createSchema(editorConfig) {
    var marks = fixExcludes(editorConfig.marks.sort(sortByOrder('marks')).reduce(function (acc, mark) {
        acc[mark.name] = mark.mark;
        return acc;
    }, {}));
    var nodes = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__["_3" /* sanitizeNodes */])(editorConfig.nodes.sort(sortByOrder('nodes')).reduce(function (acc, node) {
        acc[node.name] = node.node;
        return acc;
    }, {}), marks);
    return new __WEBPACK_IMPORTED_MODULE_1_prosemirror_model__["Schema"]({ nodes: nodes, marks: marks });
}
function createPMPlugins(_a) {
    var editorConfig = _a.editorConfig, schema = _a.schema, props = _a.props, dispatch = _a.dispatch, eventDispatcher = _a.eventDispatcher, providerFactory = _a.providerFactory, errorReporter = _a.errorReporter, portalProviderAPI = _a.portalProviderAPI, reactContext = _a.reactContext;
    return editorConfig.pmPlugins
        .sort(sortByOrder('plugins'))
        .map(function (_a) {
        var plugin = _a.plugin;
        return plugin({
            schema: schema,
            props: props,
            dispatch: dispatch,
            providerFactory: providerFactory,
            errorReporter: errorReporter,
            eventDispatcher: eventDispatcher,
            portalProviderAPI: portalProviderAPI,
            reactContext: reactContext,
        });
    })
        .filter(function (plugin) { return !!plugin; });
}
function createErrorReporter(errorReporterHandler) {
    var errorReporter = new __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["b" /* ErrorReporter */]();
    if (errorReporterHandler) {
        errorReporter.handler = errorReporterHandler;
    }
    return errorReporter;
}
function initAnalytics(analyticsHandler) {
    __WEBPACK_IMPORTED_MODULE_4__analytics__["a" /* analyticsService */].handler = analyticsHandler || (function () { });
    __WEBPACK_IMPORTED_MODULE_4__analytics__["a" /* analyticsService */].trackEvent('atlassian.editor.start', {
        name: __WEBPACK_IMPORTED_MODULE_5__version__["a" /* name */],
        version: __WEBPACK_IMPORTED_MODULE_5__version__["c" /* version */],
    });
}
//# sourceMappingURL=create-editor.js.map

/***/ }),
/* 2790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    plugins: [
        'inlineCursorTargetPlugin',
        'focusHandlerPlugin',
        'submitEditor',
        'imageUpload',
        'imageUploadInputRule',
        'paste',
        'pasteKeymap',
        'mention',
        'mentionInputRule',
        'mentionKeymap',
        'emoji',
        'placeholderText',
        'emojiInputRule',
        'emojiKeymap',
        'emojiAsciiInputRule',
        'blockType',
        'quickInsert',
        'tasksAndDecisions',
        'blockTypeInputRule',
        'tasksAndDecisionsInputRule',
        'typeAhead',
        'typeAheadKeymap',
        'typeAheadInputRule',
        // This should be always after `typeAheadKeymap` & `emojiKeymap`
        'indentationKeymap',
        'lists',
        'textColor',
        'alignmentPlugin',
        'listsInputRule',
        'listsKeymap',
        'codeBlock',
        'codeBlockIDEKeyBindings',
        'codeBlockKeyMap',
        'textFormatting',
        'textFormattingCursor',
        'textFormattingInputRule',
        'textFormattingSmartRule',
        'textFormattingClear',
        'textFormattingKeymap',
        'gapCursorKeymap',
        'gapCursor',
        'syncUrlText',
        'fakeCursorToolbarPlugin',
        'hyperLink',
        'table',
        'tableKeymap',
        'hyperlinkInputRule',
        'tablePMColResizing',
        'hyperlinkKeymap',
        'tableColResizing',
        'blockTypeKeyMap',
        'tableEditing',
        'pmCollab',
        'collab',
        'ruleInputRule',
        'ruleKeymap',
        'panel',
        'media',
        'mediaKeymap',
        'mediaSingleKeymap',
        'unsupportedContent',
        'jiraIssue',
        'fakeTextCursor',
        'helpDialog',
        'helpDialogKeymap',
        'macro',
        'extension',
        'layout',
        'date',
        'dateKeymap',
        'floatingToolbar',
        'clearMarksOnChange',
        'saveOnEnter',
        'reactNodeView',
        'tasksAndDecisionsKeyMap',
        'history',
        'codeBlockIndent',
        'placeholder',
        'width',
        'maxContentSize',
        'multilineContent',
        'grid',
    ],
    nodes: [
        'doc',
        'paragraph',
        'text',
        'bulletList',
        'orderedList',
        'listItem',
        'heading',
        'blockquote',
        'codeBlock',
        'rule',
        'panel',
        'mention',
        'confluenceUnsupportedBlock',
        'confluenceUnsupportedInline',
        'unsupportedBlock',
        'unsupportedInline',
        'confluenceJiraIssue',
        'hardBreak',
        'emoji',
        'placeholder',
        'mediaGroup',
        'table',
        'mediaSingle',
        'media',
        'tableHeader',
        'decisionList',
        'tableRow',
        'decisionItem',
        'tableCell',
        'taskList',
        'taskItem',
        'extension',
        'bodiedExtension',
        'inlineExtension',
        'date',
        'layoutSection',
        'layoutColumn',
        'inlineCard',
        'blockCard',
    ],
    marks: [
        // Inline marks
        'link',
        'confluenceInlineComment',
        'em',
        'strong',
        'strike',
        'action',
        'subsup',
        'underline',
        'code',
        'typeAheadQuery',
        'emojiQuery',
        'textColor',
        // Block marks
        'alignment',
        'breakout',
        'indentation',
    ],
});
//# sourceMappingURL=rank.js.map

/***/ }),
/* 2791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUiComponent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_Appearance_Message__ = __webpack_require__(2792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_Appearance_FullPage__ = __webpack_require__(2816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_Appearance_Chromeless__ = __webpack_require__(2818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_Appearance_Comment__ = __webpack_require__(2819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Appearance_Mobile__ = __webpack_require__(2820);





function getUiComponent(appearance) {
    appearance = appearance || 'message';
    switch (appearance) {
        case 'message':
            return __WEBPACK_IMPORTED_MODULE_0__ui_Appearance_Message__["a" /* default */];
        case 'full-page':
            return __WEBPACK_IMPORTED_MODULE_1__ui_Appearance_FullPage__["a" /* default */];
        case 'chromeless':
            return __WEBPACK_IMPORTED_MODULE_2__ui_Appearance_Chromeless__["a" /* default */];
        case 'comment':
            return __WEBPACK_IMPORTED_MODULE_3__ui_Appearance_Comment__["a" /* default */];
        case 'mobile':
            return __WEBPACK_IMPORTED_MODULE_4__ui_Appearance_Mobile__["a" /* default */];
        default:
            throw new Error("Appearance '" + appearance + "' is not supported by the editor.");
    }
}
//# sourceMappingURL=get-ui-component.js.map

/***/ }),
/* 2792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PluginSlot__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContentStyles__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_max_content_size__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_is_multiline_content__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Addon__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__WithFlash__ = __webpack_require__(301);












var MessageEditor = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  border: 1px solid\n    ", ";\n  border-radius: 3px;\n  height: auto;\n  min-height: 34px;\n  box-sizing: border-box;\n  word-wrap: break-word;\n\n  div > .ProseMirror {\n    outline: none;\n    white-space: pre-wrap;\n    padding: 0;\n    margin: 0;\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  border: 1px solid\n    ",
    ";\n  border-radius: 3px;\n  height: auto;\n  min-height: 34px;\n  box-sizing: border-box;\n  word-wrap: break-word;\n\n  div > .ProseMirror {\n    outline: none;\n    white-space: pre-wrap;\n    padding: 0;\n    margin: 0;\n  }\n"])), function (props) {
    return props.isMaxContentSizeReached ? '#FF8F73' : '#C1C7D0';
});
var ContentArea = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_5__ContentStyles__["a" /* default */])(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  line-height: 20px;\n  padding: 4px 16px 4px 8px;\n  flex-grow: 1;\n  overflow-x: hidden;\n  overflow-y: auto;\n  max-width: inherit;\n  width: ", ";\n  max-height: ", ";\n\n  ", ";\n"], ["\n  line-height: 20px;\n  padding: 4px 16px 4px 8px;\n  flex-grow: 1;\n  overflow-x: hidden;\n  overflow-y: auto;\n  max-width: inherit;\n  width: ", ";\n  max-height: ",
    ";\n\n  ", ";\n"])), function (props) { return (props.isMultiline ? '100%' : 'auto'); }, function (props) {
    return props.maxHeight ? props.maxHeight + 'px' : 'none';
}, __WEBPACK_IMPORTED_MODULE_10__styles__["j" /* scrollbarStyles */]);
var ToolbarArea = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_5__ContentStyles__["a" /* default */])(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  width: ", ";\n"], ["\n  display: flex;\n  width: ", ";\n"])), function (props) { return (props.isMultiline ? '100%' : 'auto'); });
var SecondaryToolbarContainer = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  padding: 2px 4px 0 0;\n  margin-bottom: -1px;\n  box-sizing: border-box;\n  justify-content: flex-end;\n  align-items: flex-end;\n  flex-shrink: 0;\n  display: flex;\n"], ["\n  padding: 2px 4px 0 0;\n  margin-bottom: -1px;\n  box-sizing: border-box;\n  justify-content: flex-end;\n  align-items: flex-end;\n  flex-shrink: 0;\n  display: flex;\n"])));
var Editor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Editor, _super);
    function Editor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.appearance = 'message';
        _this.focusEditor = function (e) {
            // Only focus for unhandled click events (e.g. so we don't focus on click events in pop ups)
            var target = e.target;
            var clickIsFromPopup = !!Object(__WEBPACK_IMPORTED_MODULE_6__utils__["i" /* closestElement */])(target, '[data-editor-popup]');
            if (_this.props.editorActions && !clickIsFromPopup) {
                _this.props.editorActions.focus();
            }
        };
        _this.renderChrome = function (_a) {
            var maxContentSize = _a.maxContentSize, isMultilineContent = _a.isMultilineContent;
            var _b = _this.props, disabled = _b.disabled, editorDOMElement = _b.editorDOMElement, editorView = _b.editorView, editorActions = _b.editorActions, eventDispatcher = _b.eventDispatcher, providerFactory = _b.providerFactory, contentComponents = _b.contentComponents, secondaryToolbarComponents = _b.secondaryToolbarComponents, customContentComponents = _b.customContentComponents, customSecondaryToolbarComponents = _b.customSecondaryToolbarComponents, addonToolbarComponents = _b.addonToolbarComponents, maxHeight = _b.maxHeight, popupsMountPoint = _b.popupsMountPoint, popupsBoundariesElement = _b.popupsBoundariesElement, popupsScrollableElement = _b.popupsScrollableElement;
            var maxContentSizeReached = maxContentSize && maxContentSize.maxContentSizeReached;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__WithFlash__["a" /* default */], { animate: maxContentSizeReached },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MessageEditor, { onClick: _this.focusEditor, isMaxContentSizeReached: maxContentSizeReached, className: "akEditor" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ContentArea, { maxHeight: maxHeight, isMultiline: isMultilineContent, innerRef: function (ref) { return (_this.containerElement = ref); } },
                        customContentComponents,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__PluginSlot__["a" /* default */], { disabled: !!disabled, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: _this.appearance, items: contentComponents, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, containerElement: _this.containerElement }),
                        editorDOMElement),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ToolbarArea, { isMultiline: isMultilineContent },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Addon__["c" /* ClickAreaInline */], { editorView: editorView }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](SecondaryToolbarContainer, null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__PluginSlot__["a" /* default */], { disabled: disabled || maxContentSizeReached, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: _this.appearance, items: secondaryToolbarComponents, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, containerElement: _this.containerElement }),
                            customSecondaryToolbarComponents,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Addon__["a" /* AddonToolbar */], { dropdownItems: addonToolbarComponents, isReducedSpacing: true }))))));
        };
        return _this;
    }
    Editor.prototype.render = function () {
        var _a = this.props, eventDispatcher = _a.eventDispatcher, editorView = _a.editorView;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__WithPluginState__["a" /* default */], { editorView: editorView, eventDispatcher: eventDispatcher, plugins: {
                maxContentSize: __WEBPACK_IMPORTED_MODULE_7__plugins_max_content_size__["b" /* pluginKey */],
                isMultilineContent: __WEBPACK_IMPORTED_MODULE_8__plugins_is_multiline_content__["b" /* pluginKey */],
            }, render: this.renderChrome }));
    };
    Editor.displayName = 'MessageEditor';
    return Editor;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Editor);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Message.js.map

/***/ }),
/* 2793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return telepointerStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(284);

// @ts-ignore: unused variable
// prettier-ignore


var telepointerColorStyle = function (color, index) { return "\n  &.color-" + index + " {\n    background-color: " + color.selection + ";\n    &::after {\n      background-color: " + color.solid + ";\n      color: #fff;\n      border-color: " + color.solid + ";\n    }\n  }\n"; };
var telepointerStyle = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .ProseMirror .telepointer {\n    position: relative;\n\n    &.telepointer-selection {\n      line-height: 1.2;\n      pointer-events: none;\n      user-select: none;\n    }\n\n    &.telepointer-selection-badge::after {\n      content: attr(data-initial);\n      position: absolute;\n      display: block;\n      top: -14px;\n      font-size: 9px;\n      padding: 2px;\n      color: white;\n      left: -1px;\n      border-radius: 2px 2px 2px 0;\n      line-height: initial;\n    }\n\n    ", ";\n  }\n"], ["\n  .ProseMirror .telepointer {\n    position: relative;\n\n    &.telepointer-selection {\n      line-height: 1.2;\n      pointer-events: none;\n      user-select: none;\n    }\n\n    &.telepointer-selection-badge::after {\n      content: attr(data-initial);\n      position: absolute;\n      display: block;\n      top: -14px;\n      font-size: 9px;\n      padding: 2px;\n      color: white;\n      left: -1px;\n      border-radius: 2px 2px 2px 0;\n      line-height: initial;\n    }\n\n    ", ";\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* colors */].map(function (color, index) { return telepointerColorStyle(color, index); }));
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gapCursorStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var gapCursorBlink = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\nto {\n  visibility: hidden;\n}\n"], ["\nto {\n  visibility: hidden;\n}\n"])));
var gapCursor = '.ProseMirror-gapcursor';
var wrapLeft = '[layout="wrap-left"]';
var wrapRight = '[layout="wrap-right"]';
var gapCursorStyles = "\n  /* =============== GAP CURSOR ================== */\n  .ProseMirror {\n    " + gapCursor + " {\n      display: none;\n      pointer-events: none;\n      position: relative;\n\n      & span {\n        caret-color: transparent;\n        position: absolute;\n        height: 100%;\n        width: 100%;\n        display: block;\n      }\n\n      & span::after {\n        animation: 1.1s " + gapCursorBlink + " steps(2, start) infinite;\n        border-left: 1px solid;\n        content: '';\n        display: block;\n        position: absolute;\n        top: 0;\n        height: 100%;\n      }\n      &.-left span::after {\n        left: -3px;\n      }\n      &.-right span::after {\n        right: -3px;\n      }\n      & span[layout='full-width'],\n      & span[layout='wide'] {\n        margin-left: 50%;\n        transform: translateX(-50%);\n      }\n      &" + wrapRight + " {\n        float: right;\n      }\n\n      /* fix vertical alighment of gap cursor */\n      &:first-child + ul,\n      &:first-child + span + ul,\n      &:first-child + ol,\n      &:first-child + span + ol,\n      &:first-child + pre,\n      &:first-child + span + pre,\n      &:first-child + blockquote,\n      &:first-child + span + blockquote {\n        margin-top: 0;\n      }\n    }\n    &.ProseMirror-focused " + gapCursor + " {\n      display: block;\n    }\n  }\n\n  /* This hack below is for two images aligned side by side */\n  " + gapCursor + wrapLeft + " + span + " + wrapLeft + ",\n  " + gapCursor + wrapRight + " + span + " + wrapRight + ",\n  " + gapCursor + " + " + wrapLeft + " + " + wrapRight + ",\n  " + gapCursor + " + " + wrapLeft + " + span + " + wrapRight + ",\n  " + gapCursor + " + " + wrapRight + " + " + wrapLeft + ",\n  " + gapCursor + " + " + wrapRight + " + span + " + wrapLeft + ",\n  " + wrapLeft + " + " + gapCursor + " + " + wrapRight + ",\n  " + wrapLeft + " + " + gapCursor + " + span " + wrapRight + ",\n  " + wrapRight + " + " + gapCursor + " + " + wrapLeft + ",\n  " + wrapRight + " + " + gapCursor + " + span + " + wrapLeft + " {\n    clear: none;\n  }\n\n  " + wrapLeft + " + " + gapCursor + " + " + wrapRight + " > div,\n  " + wrapLeft + " + " + gapCursor + " + span + " + wrapRight + " > div,\n  " + wrapRight + " + " + gapCursor + " + " + wrapLeft + " > div,\n  " + wrapRight + " + " + gapCursor + " + span + " + wrapLeft + " > div,\n  " + gapCursor + " + " + wrapRight + " + " + wrapLeft + " > div,\n  " + gapCursor + " + " + wrapRight + " + span + " + wrapLeft + " > div,\n  " + gapCursor + " + " + wrapLeft + " + " + wrapRight + " > div,\n  " + gapCursor + " + " + wrapLeft + " + span + " + wrapRight + " > div {\n    margin-right: 0;\n    margin-left: 0;\n    margin-bottom: 0;\n  }\n\n  " + wrapLeft + " + " + gapCursor + ",\n  " + wrapRight + " + " + gapCursor + " {\n    float: left;\n  }\n\n  " + gapCursor + " + " + wrapLeft + " + span + " + wrapRight + "::after,\n  " + gapCursor + " + " + wrapRight + " + span + " + wrapLeft + "::after,\n  " + wrapLeft + " + " + gapCursor + " + " + wrapRight + "::after,\n  " + wrapLeft + " + " + gapCursor + " + span + " + wrapRight + "::after,\n  " + wrapRight + " + " + gapCursor + " + " + wrapLeft + "::after,\n  " + wrapRight + " + " + gapCursor + " + span + " + wrapLeft + "::after {\n    visibility: hidden;\n    display: block;\n    font-size: 0;\n    content: ' ';\n    clear: both;\n    height: 0;\n  }\n\n  " + wrapLeft + " + " + gapCursor + " + " + wrapRight + " + *,\n  " + wrapLeft + " + " + gapCursor + " + " + wrapRight + " + span + *,\n  " + wrapRight + " + " + gapCursor + " + " + wrapLeft + " + *,\n  " + wrapRight + " + " + gapCursor + " + " + wrapLeft + " + span + *,\n  " + wrapLeft + " + " + gapCursor + " + span + " + wrapRight + " + *,\n  " + wrapRight + " + " + gapCursor + " + span + " + wrapLeft + " + *,\n  " + gapCursor + " + " + wrapLeft + " + span + " + wrapRight + " + *,\n  " + gapCursor + " + " + wrapRight + " + span + " + wrapLeft + " + *,\n  " + wrapLeft + " + " + gapCursor + " + " + wrapRight + " + * > *,\n  " + wrapLeft + " + " + gapCursor + " + " + wrapRight + " + span + * > *,\n  " + wrapRight + " + " + gapCursor + " + " + wrapLeft + " + * > *,\n  " + wrapRight + " + " + gapCursor + " + " + wrapLeft + " + span + * > *,\n  " + wrapLeft + " + " + gapCursor + " + span + " + wrapRight + " + * > *,\n  " + wrapRight + " + " + gapCursor + " + span + " + wrapLeft + " + * > *,\n  " + gapCursor + " + " + wrapLeft + " + span + " + wrapRight + " + * > *,\n  " + gapCursor + " + " + wrapRight + " + span + " + wrapLeft + " + * > * {\n    margin-top: 0;\n  }\n";
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placeholderStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);

// @ts-ignore: unused variable
// prettier-ignore


var placeholderStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .ProseMirror .placeholder-decoration {\n    position: absolute;\n    pointer-events: none;\n    user-select: none;\n\n    &::before {\n      content: attr(data-text);\n      color: ", ";\n      pointer-events: none;\n    }\n  }\n"], ["\n  .ProseMirror .placeholder-decoration {\n    position: absolute;\n    pointer-events: none;\n    user-select: none;\n\n    &::before {\n      content: attr(data-text);\n      color: ", ";\n      pointer-events: none;\n    }\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N90);
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return blocktypeStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__ = __webpack_require__(13);

// @ts-ignore: unused variable


var blocktypeStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .ProseMirror {\n    ", ";\n    ", ";\n  }\n"], ["\n  .ProseMirror {\n    ", ";\n    ", ";\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["C" /* blockquoteSharedStyles */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["Q" /* headingsSharedStyles */]);
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return codeBlockStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(224);





var codeBlockStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .ProseMirror .code-block {\n    font-family: ", ";\n    background: ", ";\n    border-radius: ", "px;\n    font-size: 14px;\n    line-height: 24px;\n    margin: ", " 0 0 0;\n    counter-reset: line;\n    display: flex;\n    min-width: ", "px;\n\n    .line-number-gutter {\n      color: ", ";\n      background-color: rgba(9, 30, 66, 0.04);\n      text-align: right;\n      user-select: none;\n      padding: ", " 8px;\n      border-radius: ", "px;\n      font-size: 12px;\n      line-height: 24px;\n\n      span {\n        display: block;\n\n        &::before {\n          counter-increment: line;\n          content: counter(line);\n          display: inline-block;\n        }\n      }\n    }\n\n    .code-content {\n      padding: ", " 16px;\n      color: ", ";\n      overflow: auto;\n      display: flex;\n      flex: 1;\n\n      pre {\n        width: 100%;\n      }\n      code {\n        display: inline-block;\n        min-width: 100%;\n        tab-size: 4;\n      }\n    }\n\n    /* We render this as a basic box in IE11 because it can't handle scrolling */\n    &.ie11 {\n      display: block;\n      .line-number-gutter {\n        display: none;\n      }\n      .code-content {\n        display: block;\n        overflow: visible;\n\n        pre {\n          width: auto;\n        }\n        code {\n          display: inline;\n        }\n      }\n    }\n  }\n  .ProseMirror li > .code-block {\n    margin: 0;\n  }\n"], ["\n  .ProseMirror .code-block {\n    font-family: ", ";\n    background: ", ";\n    border-radius: ", "px;\n    font-size: 14px;\n    line-height: 24px;\n    margin: ", " 0 0 0;\n    counter-reset: line;\n    display: flex;\n    min-width: ", "px;\n\n    .line-number-gutter {\n      color: ", ";\n      background-color: rgba(9, 30, 66, 0.04);\n      text-align: right;\n      user-select: none;\n      padding: ", " 8px;\n      border-radius: ", "px;\n      font-size: 12px;\n      line-height: 24px;\n\n      span {\n        display: block;\n\n        &::before {\n          counter-increment: line;\n          content: counter(line);\n          display: inline-block;\n        }\n      }\n    }\n\n    .code-content {\n      padding: ", " 16px;\n      color: ", ";\n      overflow: auto;\n      display: flex;\n      flex: 1;\n\n      pre {\n        width: 100%;\n      }\n      code {\n        display: inline-block;\n        min-width: 100%;\n        tab-size: 4;\n      }\n    }\n\n    /* We render this as a basic box in IE11 because it can't handle scrolling */\n    &.ie11 {\n      display: block;\n      .line-number-gutter {\n        display: none;\n      }\n      .code-content {\n        display: block;\n        overflow: visible;\n\n        pre {\n          width: auto;\n        }\n        code {\n          display: inline;\n        }\n      }\n    }\n  }\n  .ProseMirror li > .code-block {\n    margin: 0;\n  }\n"])), __WEBPACK_IMPORTED_MODULE_4__styles__["b" /* akEditorCodeFontFamily */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N20, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])(), __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["B" /* blockNodesVerticalMargin */], __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["v" /* akEditorTableCellMinWidth */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N300, __WEBPACK_IMPORTED_MODULE_4__styles__["a" /* akEditorCodeBlockPadding */], Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])(), __WEBPACK_IMPORTED_MODULE_4__styles__["a" /* akEditorCodeBlockPadding */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N800);
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return listsStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);

// @ts-ignore: unused variable
// prettier-ignore

var listsStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .ProseMirror ul,\n  .ProseMirror ol {\n    padding-left: 30px;\n    box-sizing: border-box;\n  }\n\n  .ProseMirror ul ul,\n  .ProseMirror ul ol,\n  .ProseMirror ol ul,\n  .ProseMirror ol ol {\n    padding-left: 21px;\n  }\n\n  .ProseMirror li {\n    position: relative;\n    /* Dont do weird stuff with marker clicks */\n    pointer-events: none;\n\n    > p:not(:first-child) {\n      margin: 4px 0 0 0;\n    }\n  }\n\n  .ProseMirror li > * {\n    pointer-events: auto;\n  }\n  /* Make sure li selections wrap around markers */\n  li.ProseMirror-selectednode {\n    outline: none;\n  }\n\n  li.ProseMirror-selectednode::after {\n    content: '';\n    position: absolute;\n    left: -32px;\n    right: -2px;\n    top: -2px;\n    bottom: -2px;\n    border: 2px solid #8cf;\n    pointer-events: none;\n  }\n\n  /** =============== LIST INDENT STYLES ========= */\n  .ProseMirror {\n    ul,\n    ul ul ul ul,\n    ul ul ul ul ul ul ul {\n      list-style-type: disc;\n    }\n\n    ul ul,\n    ul ul ul ul ul,\n    ul ul ul ul ul ul ul ul {\n      list-style-type: circle;\n    }\n\n    ul ul ul,\n    ul ul ul ul ul ul,\n    ul ul ul ul ul ul ul ul ul {\n      list-style-type: square;\n    }\n\n    ol,\n    ol ol ol ol,\n    ol ol ol ol ol ol ol {\n      list-style-type: decimal;\n    }\n    ol ol,\n    ol ol ol ol ol,\n    ol ol ol ol ol ol ol ol {\n      list-style-type: lower-alpha;\n    }\n    ol ol ol,\n    ol ol ol ol ol ol,\n    ol ol ol ol ol ol ol ol ol {\n      list-style-type: lower-roman;\n    }\n  }\n"], ["\n  .ProseMirror ul,\n  .ProseMirror ol {\n    padding-left: 30px;\n    box-sizing: border-box;\n  }\n\n  .ProseMirror ul ul,\n  .ProseMirror ul ol,\n  .ProseMirror ol ul,\n  .ProseMirror ol ol {\n    padding-left: 21px;\n  }\n\n  .ProseMirror li {\n    position: relative;\n    /* Dont do weird stuff with marker clicks */\n    pointer-events: none;\n\n    > p:not(:first-child) {\n      margin: 4px 0 0 0;\n    }\n  }\n\n  .ProseMirror li > * {\n    pointer-events: auto;\n  }\n  /* Make sure li selections wrap around markers */\n  li.ProseMirror-selectednode {\n    outline: none;\n  }\n\n  li.ProseMirror-selectednode::after {\n    content: '';\n    position: absolute;\n    left: -32px;\n    right: -2px;\n    top: -2px;\n    bottom: -2px;\n    border: 2px solid #8cf;\n    pointer-events: none;\n  }\n\n  /** =============== LIST INDENT STYLES ========= */\n  .ProseMirror {\n    ul,\n    ul ul ul ul,\n    ul ul ul ul ul ul ul {\n      list-style-type: disc;\n    }\n\n    ul ul,\n    ul ul ul ul ul,\n    ul ul ul ul ul ul ul ul {\n      list-style-type: circle;\n    }\n\n    ul ul ul,\n    ul ul ul ul ul ul,\n    ul ul ul ul ul ul ul ul ul {\n      list-style-type: square;\n    }\n\n    ol,\n    ol ol ol ol,\n    ol ol ol ol ol ol ol {\n      list-style-type: decimal;\n    }\n    ol ol,\n    ol ol ol ol ol,\n    ol ol ol ol ol ol ol ol {\n      list-style-type: lower-alpha;\n    }\n    ol ol ol,\n    ol ol ol ol ol ol,\n    ol ol ol ol ol ol ol ol ol {\n      list-style-type: lower-roman;\n    }\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ruleStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__ = __webpack_require__(13);

// @ts-ignore: unused variable
// prettier-ignore


var ruleStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .ProseMirror {\n    ", ";\n  }\n"], ["\n  .ProseMirror {\n    ", ";\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["Z" /* ruleSharedStyles */]);
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mediaStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__ = __webpack_require__(3);

// @ts-ignore: unused variable
// prettier-ignore



var mediaStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .ProseMirror {\n    ", " & [layout='full-width'] .media-single,\n    & [layout='wide'] .media-single {\n      margin-left: 50%;\n      transform: translateX(-50%);\n    }\n\n    .media-single.is-loading {\n      min-height: 20px;\n    }\n\n    & [layout^='wrap-'] + [layout^='wrap-'] {\n      clear: none;\n      & + p,\n      & + div[class^='fabric-editor-align'],\n      & + ul,\n      & + ol,\n      & + h1,\n      & + h2,\n      & + h3,\n      & + h4,\n      & + h5,\n      & + h6 {\n        clear: both !important;\n      }\n      & .media-single {\n        margin-left: 0;\n        margin-right: 0;\n      }\n    }\n  }\n\n  .mediaSingle-resize-handle-right,\n  .mediaSingle-resize-handle-left {\n    display: flex;\n    flex-direction: column;\n\n    /* vertical align */\n    justify-content: center;\n  }\n\n  .mediaSingle-resize-handle-right {\n    align-items: flex-end;\n    padding-right: 12px;\n    margin-right: -12px;\n  }\n\n  .mediaSingle-resize-handle-left {\n    align-items: flex-start;\n    padding-left: 12px;\n    margin-left: -12px;\n  }\n\n  .mediaSingle-resize-handle-right::after,\n  .mediaSingle-resize-handle-left::after {\n    content: ' ';\n    display: flex;\n    width: 3px;\n    height: 64px;\n\n    border-radius: 6px;\n  }\n\n  .media-single:hover .mediaSingle-resize-handle-left::after,\n  .media-single:hover .mediaSingle-resize-handle-right::after {\n    background: ", ";\n  }\n\n  .mediaSingle-selected .mediaSingle-resize-handle-right::after,\n  .mediaSingle-selected .mediaSingle-resize-handle-left::after,\n  .media-single .mediaSingle-resize-handle-right:hover::after,\n  .media-single .mediaSingle-resize-handle-left:hover::after,\n  .media-single.is-resizing .mediaSingle-resize-handle-right::after,\n  .media-single.is-resizing .mediaSingle-resize-handle-left::after {\n    background: ", ";\n  }\n\n  .__resizable_base__ {\n    left: unset !important;\n    width: auto !important;\n    height: auto !important;\n  }\n"], ["\n  .ProseMirror {\n    ", " & [layout='full-width'] .media-single,\n    & [layout='wide'] .media-single {\n      margin-left: 50%;\n      transform: translateX(-50%);\n    }\n\n    .media-single.is-loading {\n      min-height: 20px;\n    }\n\n    & [layout^='wrap-'] + [layout^='wrap-'] {\n      clear: none;\n      & + p,\n      & + div[class^='fabric-editor-align'],\n      & + ul,\n      & + ol,\n      & + h1,\n      & + h2,\n      & + h3,\n      & + h4,\n      & + h5,\n      & + h6 {\n        clear: both !important;\n      }\n      & .media-single {\n        margin-left: 0;\n        margin-right: 0;\n      }\n    }\n  }\n\n  .mediaSingle-resize-handle-right,\n  .mediaSingle-resize-handle-left {\n    display: flex;\n    flex-direction: column;\n\n    /* vertical align */\n    justify-content: center;\n  }\n\n  .mediaSingle-resize-handle-right {\n    align-items: flex-end;\n    padding-right: 12px;\n    margin-right: -12px;\n  }\n\n  .mediaSingle-resize-handle-left {\n    align-items: flex-start;\n    padding-left: 12px;\n    margin-left: -12px;\n  }\n\n  .mediaSingle-resize-handle-right::after,\n  .mediaSingle-resize-handle-left::after {\n    content: ' ';\n    display: flex;\n    width: 3px;\n    height: 64px;\n\n    border-radius: 6px;\n  }\n\n  .media-single:hover .mediaSingle-resize-handle-left::after,\n  .media-single:hover .mediaSingle-resize-handle-right::after {\n    background: ", ";\n  }\n\n  .mediaSingle-selected .mediaSingle-resize-handle-right::after,\n  .mediaSingle-selected .mediaSingle-resize-handle-left::after,\n  .media-single .mediaSingle-resize-handle-right:hover::after,\n  .media-single .mediaSingle-resize-handle-left:hover::after,\n  .media-single.is-resizing .mediaSingle-resize-handle-right::after,\n  .media-single.is-resizing .mediaSingle-resize-handle-left::after {\n    background: ", ";\n  }\n\n  .__resizable_base__ {\n    left: unset !important;\n    width: auto !important;\n    height: auto !important;\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["V" /* mediaSingleSharedStyle */], __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N60, __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].B200);
var templateObject_1;
/* `left: unset` above is to work around Chrome bug where rendering a div with
 * that style applied inside a container that has a scroll, causes any svgs on
 * the page, without a border, that are inside a flexbox, to no longer align to
 * the center of their viewbox.
 *
 * for us, this means that all the toolbar icons start jumping around if
 * you make the viewport small
 */
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return layoutStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);

// @ts-ignore: unused variable
// prettier-ignore



var layoutStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .ProseMirror {\n    ", " [data-layout-section] {\n      position: relative;\n      width: calc(100% + 26px);\n      /* left-padding (12px) + layout-column-border (1px) */\n      left: -13px;\n\n      /* Inner cursor located 26px from left */\n      & > * {\n        padding: ", "px;\n        margin-top: ", "px;\n        flex: 1;\n        min-width: 0;\n        border: 1px solid transparent;\n        border-radius: 5px;\n      }\n\n      & > * + * {\n        margin-left: ", "px;\n      }\n\n      @media screen and (max-width: ", "px) {\n        & > * + * {\n          margin-left: 0;\n        }\n      }\n\n      /**\n        * Border to show when node is selected\n        * Helps visualise when 'selectNodeBackwards' selects the node for deletion\n        */\n      &.ProseMirror-selectednode > * {\n        border-color: ", ";\n      }\n      /* Shows the border when cursor is inside a layout */\n      &.selected > * {\n        border-color: ", ";\n      }\n    }\n  }\n"], ["\n  .ProseMirror {\n    ", " [data-layout-section] {\n      position: relative;\n      width: calc(100% + 26px);\n      /* left-padding (12px) + layout-column-border (1px) */\n      left: -13px;\n\n      /* Inner cursor located 26px from left */\n      & > * {\n        padding: ", "px;\n        margin-top: ", "px;\n        flex: 1;\n        min-width: 0;\n        border: 1px solid transparent;\n        border-radius: 5px;\n      }\n\n      & > * + * {\n        margin-left: ", "px;\n      }\n\n      @media screen and (max-width: ", "px) {\n        & > * + * {\n          margin-left: 0;\n        }\n      }\n\n      /**\n        * Border to show when node is selected\n        * Helps visualise when 'selectNodeBackwards' selects the node for deletion\n        */\n      &.ProseMirror-selectednode > * {\n        border-color: ", ";\n      }\n      /* Shows the border when cursor is inside a layout */\n      &.selected > * {\n        border-color: ", ";\n      }\n    }\n  }\n"])), __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["L" /* columnLayoutSharedStyle */], Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() * 1.5, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() - 1, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() - 2, __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["P" /* gridMediumMaxWidth */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B200, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N40);
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return panelStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__ = __webpack_require__(13);

// @ts-ignore: unused variable
// prettier-ignore


var panelStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .ProseMirror {\n    ", ";\n  }\n"], ["\n  .ProseMirror {\n    ", ";\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["W" /* panelSharedStyles */]);
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fakeCursorStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);

// @ts-ignore: unused variable
// prettier-ignore


var fakeCursorStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .ProseMirror {\n    .ProseMirror-fake-text-cursor {\n      display: inline;\n      pointer-events: none;\n      position: relative;\n      height: 15px;\n    }\n\n    .ProseMirror-fake-text-cursor::after {\n      content: '';\n      display: inline;\n      top: 0;\n      position: absolute;\n      height: 100%;\n      border-right: 1px solid rgba(0, 0, 0, 0.4);\n    }\n\n    .ProseMirror-fake-text-selection {\n      display: inline;\n      pointer-events: none;\n      position: relative;\n      background-color: ", ";\n    }\n  }\n"], ["\n  .ProseMirror {\n    .ProseMirror-fake-text-cursor {\n      display: inline;\n      pointer-events: none;\n      position: relative;\n      height: 15px;\n    }\n\n    .ProseMirror-fake-text-cursor::after {\n      content: '';\n      display: inline;\n      top: 0;\n      position: absolute;\n      height: 100%;\n      border-right: 1px solid rgba(0, 0, 0, 0.4);\n    }\n\n    .ProseMirror-fake-text-selection {\n      display: inline;\n      pointer-events: none;\n      position: relative;\n      background-color: ", ";\n    }\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B75);
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mentionsStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(224);



var mentionsStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .ProseMirror-selectednode .ak-mention {\n    background: ", ";\n  }\n"], ["\n  .ProseMirror-selectednode .ak-mention {\n    background: ", ";\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__styles__["c" /* akEditorMentionSelected */]);
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return textFormattingStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__ = __webpack_require__(13);

// @ts-ignore: unused variable
// prettier-ignore




var textFormattingStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .ProseMirror span.code {\n    font-size: ", "px;\n    font-weight: normal;\n    padding: 2px 0px 2px 0px;\n    background-color: ", ";\n    box-decoration-break: clone;\n    border-radius: 3px;\n    font-family: ", ";\n    white-space: pre-wrap;\n    margin: 0 4px 0 4px;\n    box-shadow: -4px 0 0 0 ", ", 4px 0 0 0 ", ";\n\n    &::before,\n    &::after {\n      vertical-align: text-top;\n      display: inline-block;\n      content: '';\n    }\n  }\n"], ["\n  .ProseMirror span.code {\n    font-size: ", "px;\n    font-weight: normal;\n    padding: 2px 0px 2px 0px;\n    background-color: ", ";\n    box-decoration-break: clone;\n    border-radius: 3px;\n    font-family: ", ";\n    white-space: pre-wrap;\n    margin: 0 4px 0 4px;\n    box-shadow: -4px 0 0 0 ", ", 4px 0 0 0 ", ";\n\n    &::before,\n    &::after {\n      vertical-align: text-top;\n      display: inline-block;\n      content: '';\n    }\n  }\n"])), Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__["Y" /* relativeSize */])(0.857), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30A, __WEBPACK_IMPORTED_MODULE_3__styles__["b" /* akEditorCodeFontFamily */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30A, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30A);
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placeholderTextStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);

// @ts-ignore: unused variable
// prettier-ignore


var placeholderTextStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .ProseMirror span[data-placeholder] {\n    color: ", ";\n  }\n"], ["\n  .ProseMirror span[data-placeholder] {\n    color: ", ";\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N300);
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tasksAndDecisionsStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);

// @ts-ignore: unused variable
// prettier-ignore



var tasksAndDecisionsStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .ProseMirror .taskItemView-content-wrap,\n  .ProseMirror .decisionItemView-content-wrap {\n    font-size: ", "px;\n    min-width: ", "px;\n  }\n"], ["\n  .ProseMirror .taskItemView-content-wrap,\n  .ProseMirror .decisionItemView-content-wrap {\n    font-size: ", "px;\n    min-width: ", "px;\n  }\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["fontSize"])(), __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["v" /* akEditorTableCellMinWidth */]);
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return linkStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__ = __webpack_require__(13);



var linkStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .ProseMirror {\n    ", "\n  }\n"], ["\n  .ProseMirror {\n    ", "\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["U" /* linkSharedStyle */]);
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2810);


var DropdownItemWrapper = function (props) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* DropdownItem */], { onClick: function () {
        return props.onClick &&
            props.onClick({
                actionOnClick: props.actionOnClick,
                renderOnClick: props.renderOnClick,
            });
    } },
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, props.icon),
    props.children)); };
/* unused harmony default export */ var _unused_webpack_default_export = (DropdownItemWrapper);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropdownItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



var DropdownItem = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  text-decoration: none;\n  padding: 8px 32px 8px 12px;\n  color: ", ";\n  > span {\n    display: flex;\n    margin-right: 8px;\n  }\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  text-decoration: none;\n  padding: 8px 32px 8px 12px;\n  color: ", ";\n  > span {\n    display: flex;\n    margin-right: 8px;\n  }\n  &:hover {\n    background-color: ", ";\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N800, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N20);
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2812);



var DropdownWrapper = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](DropdownWrapper, _super);
    function DropdownWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (actions) {
            var actionOnClick = actions.actionOnClick, renderOnClick = actions.renderOnClick;
            var editorActions = _this.props.editorActions;
            if (actionOnClick) {
                actionOnClick(editorActions);
                _this.props.togglePopup();
            }
            else if (renderOnClick) {
                _this.props.onClick(editorActions, renderOnClick);
            }
        };
        return _this;
    }
    DropdownWrapper.prototype.render = function () {
        var _this = this;
        // adding onClick handler to each DropdownItem component
        var children = __WEBPACK_IMPORTED_MODULE_1_react__["Children"].map(this.props.children, function (child) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"](child, {
                onClick: _this.handleClick,
            });
        });
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Dropdown */], null, children);
    };
    return DropdownWrapper;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (DropdownWrapper);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dropdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



// tslint:disable-next-line:variable-name
var Dropdown = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  flex-direction: column;\n  background: white;\n  border-radius: ", "px;\n  box-shadow: 0 4px 8px -2px ", ", 0 0 1px ", ";\n  box-sizing: border-box;\n  padding: 4px 0;\n"], ["\n  display: flex;\n  flex-direction: column;\n  background: white;\n  border-radius: ", "px;\n  box-shadow: 0 4px 8px -2px ", ", 0 0 1px ", ";\n  box-sizing: border-box;\n  padding: 4px 0;\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])(), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N60A, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N60A);
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands__ = __webpack_require__(113);




var ClickArea = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  flex-grow: 1;\n"], ["\n  flex-grow: 1;\n"])));
ClickArea.displayName = 'ClickArea';
var ClickAreaInline = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ClickAreaInline, _super);
    function ClickAreaInline() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (event) {
            var editorView = _this.props.editorView;
            if (editorView) {
                if (Object(__WEBPACK_IMPORTED_MODULE_3__commands__["d" /* createParagraphAtEnd */])()(editorView.state, editorView.dispatch)) {
                    editorView.focus();
                    event.stopPropagation();
                }
            }
        };
        return _this;
    }
    ClickAreaInline.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ClickArea, { onClick: this.handleClick });
    };
    return ClickAreaInline;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ClickAreaInline);
var templateObject_1;
//# sourceMappingURL=index.js.map

/***/ }),
/* 2814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_gap_cursor__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(21);






var ClickWrapper = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  flex-grow: 1;\n  height: 100%;\n"], ["\n  flex-grow: 1;\n  height: 100%;\n"])));
ClickWrapper.displayName = 'ClickWrapper';
// we ignore all of the clicks made inside <div class="ak-editor-content-area" /> (but not clicks on the node itself)
var insideContentArea = function (ref) {
    while (ref) {
        if (ref.classList && ref.classList.contains('ak-editor-content-area')) {
            return true;
        }
        ref = ref.parentNode;
    }
    return false;
};
var ClickAreaBlock = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ClickAreaBlock, _super);
    function ClickAreaBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (event) {
            var view = _this.props.editorView;
            var contentArea = event.currentTarget.querySelector('.ak-editor-content-area');
            // @see https://product-fabric.atlassian.net/browse/ED-4287
            // click event gets triggered twice on a checkbox (on <label> first and then on <input>)
            // by the time it gets triggered on input, PM already re-renders nodeView and detaches it from DOM
            // which doesn't pass the check !contentArea.contains(event.target)
            var isInputClicked = event.target.nodeName === 'INPUT';
            // @see ED-5126
            var isPopupClicked = !!Object(__WEBPACK_IMPORTED_MODULE_5__utils__["i" /* closestElement */])(event.target, '[data-editor-popup]');
            if ((!contentArea || !insideContentArea(event.target.parentNode)) &&
                !isInputClicked &&
                !isPopupClicked &&
                view) {
                var dispatch = view.dispatch, dom = view.dom;
                var bottomAreaClicked = event.clientY > dom.getBoundingClientRect().bottom;
                var isParagrpahAppended = bottomAreaClicked
                    ? Object(__WEBPACK_IMPORTED_MODULE_3__commands__["d" /* createParagraphAtEnd */])()(view.state, dispatch)
                    : false;
                var isGapCursorSet = Object(__WEBPACK_IMPORTED_MODULE_4__plugins_gap_cursor__["c" /* setCursorForTopLevelBlocks */])(event, dom, view.posAtCoords.bind(view))(view.state, dispatch);
                if (isParagrpahAppended || isGapCursorSet) {
                    view.focus();
                    event.stopPropagation();
                }
            }
        };
        return _this;
    }
    ClickAreaBlock.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ClickWrapper, { onClick: this.handleClick }, this.props.children));
    };
    return ClickAreaBlock;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ClickAreaBlock);
var templateObject_1;
//# sourceMappingURL=index.js.map

/***/ }),
/* 2815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_more__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_more___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_more__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ToolbarButton__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WithEditorActions__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__with_outer_listeners__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7____ = __webpack_require__(300);








// tslint:disable-next-line:variable-name
var AddonPopup = Object(__WEBPACK_IMPORTED_MODULE_6__with_outer_listeners__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["e" /* Popup */]);
var POPUP_HEIGHT = 188;
var POPUP_WIDTH = 136;
var AddonToolbar = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AddonToolbar, _super);
    function AddonToolbar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false,
            addonDropdownContent: null,
        };
        _this.togglePopup = function () {
            _this.setState({
                isOpen: !_this.state.isOpen,
                addonDropdownContent: null,
            });
        };
        _this.handleDropdownClick = function (editorActions, renderOnClick) {
            if (renderOnClick) {
                // popup stays open, we just change its content to the component that is returned from renderOnClick()
                _this.setState({
                    addonDropdownContent: renderOnClick(editorActions, _this.togglePopup),
                });
            }
            else {
                // close popup
                _this.togglePopup();
            }
        };
        _this.handleRef = function (target) {
            _this.setState({ target: target });
        };
        // cancel bubbling to fix clickOutside logic:
        // popup re-renders its content before the click event bubbles up to the document
        // therefore click target element would be different from the popup content
        _this.handlePopupClick = function (event) {
            return event.nativeEvent.stopImmediatePropagation();
        };
        return _this;
    }
    AddonToolbar.prototype.render = function () {
        var _this = this;
        var _a = this.props, dropdownItems = _a.dropdownItems, isReducedSpacing = _a.isReducedSpacing;
        var _b = this.state, addonDropdownContent = _b.addonDropdownContent, isOpen = _b.isOpen;
        if (!dropdownItems ||
            (Array.isArray(dropdownItems) && !dropdownItems.length)) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this.handleRef },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ToolbarButton__["a" /* default */], { selected: isOpen, spacing: isReducedSpacing ? 'none' : 'default', onClick: this.togglePopup, title: "Insert addon", iconBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_editor_more___default.a, { label: "Insert addon" }) }),
            isOpen && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](AddonPopup, { handleClickOutside: this.togglePopup, handleEscapeKeydown: this.togglePopup, target: this.state.target, fitHeight: POPUP_HEIGHT, fitWidth: POPUP_WIDTH, alignY: "top" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { onClick: this.handlePopupClick }, addonDropdownContent ? (addonDropdownContent) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__WithEditorActions__["a" /* default */]
                // tslint:disable-next-line:jsx-no-lambda
                , { 
                    // tslint:disable-next-line:jsx-no-lambda
                    render: function (editorActions) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7____["d" /* Dropdown */], { onClick: _this.handleDropdownClick, togglePopup: _this.togglePopup, editorActions: editorActions }, dropdownItems)); } })))))));
    };
    return AddonToolbar;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (AddonToolbar);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_collab_edit_ui_avatars__ = __webpack_require__(2817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PluginSlot__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Toolbar__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ContentStyles__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Addon__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plugins_table_ui_styles__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_raf_schd__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__WidthEmitter__ = __webpack_require__(880);















var GUTTER_PADDING = 32;
var FullPageEditorWrapper = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  min-width: 340px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n"], ["\n  min-width: 340px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n"])));
FullPageEditorWrapper.displayName = 'FullPageEditorWrapper';
var ScrollContainer = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8__ContentStyles__["a" /* default */])(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  flex-grow: 1;\n  overflow-y: scroll;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  scroll-behavior: smooth;\n  ", ";\n"], ["\n  flex-grow: 1;\n  overflow-y: scroll;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  scroll-behavior: smooth;\n  ", ";\n"])), __WEBPACK_IMPORTED_MODULE_13__styles__["j" /* scrollbarStyles */]);
ScrollContainer.displayName = 'ScrollContainer';
var ContentArea = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  line-height: 24px;\n  height: 100%;\n  width: 100%;\n  max-width: ", "px;\n  padding-top: 50px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  padding-bottom: 55px;\n\n  & .ProseMirror {\n    flex-grow: 1;\n    box-sizing: border-box;\n  }\n\n  && .ProseMirror {\n    & > * {\n      clear: both;\n    }\n    > p,\n    > ul,\n    > ol,\n    > h1,\n    > h2,\n    > h3,\n    > h4,\n    > h5,\n    > h6 {\n      clear: none;\n    }\n  }\n  ", ";\n"], ["\n  line-height: 24px;\n  height: 100%;\n  width: 100%;\n  max-width: ", "px;\n  padding-top: 50px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  padding-bottom: 55px;\n\n  & .ProseMirror {\n    flex-grow: 1;\n    box-sizing: border-box;\n  }\n\n  && .ProseMirror {\n    & > * {\n      clear: both;\n    }\n    > p,\n    > ul,\n    > ol,\n    > h1,\n    > h2,\n    > h3,\n    > h4,\n    > h5,\n    > h6 {\n      clear: none;\n    }\n  }\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.layoutMaxWidth + GUTTER_PADDING * 2;
}, __WEBPACK_IMPORTED_MODULE_10__plugins_table_ui_styles__["f" /* tableFullPageEditorStyles */]);
ContentArea.displayName = 'ContentArea';
var MainToolbar = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  position: relative;\n  align-items: center;\n  box-shadow: ", ";\n  transition: box-shadow 200ms;\n  z-index: ", ";\n  display: flex;\n  height: 80px;\n  flex-shrink: 0;\n\n  & object {\n    height: 0 !important;\n  }\n"], ["\n  position: relative;\n  align-items: center;\n  box-shadow: ",
    ";\n  transition: box-shadow 200ms;\n  z-index: ", ";\n  display: flex;\n  height: 80px;\n  flex-shrink: 0;\n\n  & object {\n    height: 0 !important;\n  }\n"])), function (props) {
    return props.showKeyline
        ? "0 " + __WEBPACK_IMPORTED_MODULE_11__styles__["e" /* akEditorToolbarKeylineHeight */] + "px 0 0 " + __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N30
        : 'none';
}, __WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__["r" /* akEditorMenuZIndex */]);
MainToolbar.displayName = 'MainToolbar';
var MainToolbarCustomComponentsSlot = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_5 || (templateObject_5 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  justify-content: flex-end;\n  flex-grow: 1;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  flex-grow: 1;\n"])));
MainToolbarCustomComponentsSlot.displayName = 'MainToolbar';
var SecondaryToolbar = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_6 || (templateObject_6 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  box-sizing: border-box;\n  justify-content: flex-end;\n  align-items: center;\n  flex-shrink: 0;\n  display: flex;\n  padding: 24px 0;\n"], ["\n  box-sizing: border-box;\n  justify-content: flex-end;\n  align-items: center;\n  flex-shrink: 0;\n  display: flex;\n  padding: 24px 0;\n"])));
SecondaryToolbar.displayName = 'SecondaryToolbar';
var Editor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Editor, _super);
    function Editor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { showKeyline: false };
        _this.appearance = 'full-page';
        _this.stopPropagation = function (event) {
            return event.stopPropagation();
        };
        _this.scrollContainerRef = function (ref) {
            var previousScrollContainer = _this.scrollContainer;
            // remove existing handler
            if (previousScrollContainer) {
                previousScrollContainer.removeEventListener('scroll', _this.scheduleUpdateToolbarKeyline);
            }
            _this.scrollContainer = ref ? ref : undefined;
            if (_this.scrollContainer) {
                _this.scrollContainer.addEventListener('scroll', _this.scheduleUpdateToolbarKeyline, false);
                _this.updateToolbarKeyline();
            }
        };
        _this.updateToolbarKeyline = function () {
            if (!_this.scrollContainer) {
                return false;
            }
            var scrollTop = _this.scrollContainer.scrollTop;
            _this.setState({ showKeyline: scrollTop > __WEBPACK_IMPORTED_MODULE_11__styles__["e" /* akEditorToolbarKeylineHeight */] });
            return false;
        };
        _this.scheduleUpdateToolbarKeyline = Object(__WEBPACK_IMPORTED_MODULE_12_raf_schd__["a" /* default */])(_this.updateToolbarKeyline);
        return _this;
    }
    Editor.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.scheduleUpdateToolbarKeyline, false);
    };
    Editor.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.scheduleUpdateToolbarKeyline);
        if (this.scheduledKeylineUpdate) {
            cancelAnimationFrame(this.scheduledKeylineUpdate);
        }
    };
    Editor.prototype.render = function () {
        var _a = this.props, editorDOMElement = _a.editorDOMElement, editorView = _a.editorView, editorActions = _a.editorActions, eventDispatcher = _a.eventDispatcher, providerFactory = _a.providerFactory, primaryToolbarComponents = _a.primaryToolbarComponents, contentComponents = _a.contentComponents, customPrimaryToolbarComponents = _a.customPrimaryToolbarComponents, customContentComponents = _a.customContentComponents, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, popupsScrollableElement = _a.popupsScrollableElement, disabled = _a.disabled, collabEdit = _a.collabEdit;
        var showKeyline = this.state.showKeyline;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](FullPageEditorWrapper, { className: "akEditor" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MainToolbar, { showKeyline: showKeyline },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Toolbar__["b" /* default */], { editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: this.appearance, items: primaryToolbarComponents, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: !!disabled }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MainToolbarCustomComponentsSlot, null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__plugins_collab_edit_ui_avatars__["a" /* default */], { editorView: editorView, eventDispatcher: eventDispatcher, inviteToEditHandler: collabEdit && collabEdit.inviteToEditHandler, isInviteToEditButtonSelected: collabEdit && collabEdit.isInviteToEditButtonSelected }),
                    customPrimaryToolbarComponents)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ScrollContainer, { innerRef: this.scrollContainerRef, className: "fabric-editor-popup-scroll-parent" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Addon__["b" /* ClickAreaBlock */], { editorView: editorView },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ContentArea, null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: { padding: "0 " + GUTTER_PADDING + "px" }, className: "ak-editor-content-area" },
                            customContentComponents,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__PluginSlot__["a" /* default */], { editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: this.appearance, items: contentComponents, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: !!disabled, containerElement: this.scrollContainer }),
                            editorDOMElement)))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__WidthEmitter__["a" /* default */], { editorView: editorView, contentArea: this.scrollContainer })));
    };
    Editor.displayName = 'FullPageEditor';
    return Editor;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Editor);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=FullPage.js.map

/***/ }),
/* 2817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_avatar__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_avatar_group__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_add__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugin__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_ToolbarButton__ = __webpack_require__(40);












var AvatarContainer = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin-right: ", "px;\n  display: flex;\n  align-items: center;\n  div:last-child > button {\n    border-radius: 50%;\n    height: 32px;\n    width: 32px;\n    padding: 2px;\n  }\n"], ["\n  margin-right: ", "px;\n  display: flex;\n  align-items: center;\n  div:last-child > button {\n    border-radius: 50%;\n    height: 32px;\n    width: 32px;\n    padding: 2px;\n  }\n"])), Object(__WEBPACK_IMPORTED_MODULE_5__atlaskit_theme__["gridSize"])());
var InviteTeamWrapper = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  background: ", ";\n  border-radius: 50%;\n  min-width: ", "px;\n  margin-left: -", "px;\n"], ["\n  background: ", ";\n  border-radius: 50%;\n  min-width: ", "px;\n  margin-left: -", "px;\n"])), __WEBPACK_IMPORTED_MODULE_5__atlaskit_theme__["colors"].N20, Object(__WEBPACK_IMPORTED_MODULE_5__atlaskit_theme__["gridSize"])() * 4, Object(__WEBPACK_IMPORTED_MODULE_5__atlaskit_theme__["gridSize"])() / 2);
var itemAppear = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["keyframes"])(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n0% {\n  transform: scale(0);\n}\n\n50% {\n  transform: scale(1.1);\n}\n\n100% {\n  transform: scale(1);\n}\n"], ["\n0% {\n  transform: scale(0);\n}\n\n50% {\n  transform: scale(1.1);\n}\n\n100% {\n  transform: scale(1);\n}\n"])));
var animateAvatar = function (_a) {
    var shouldAnimate = _a.shouldAnimate;
    if (!shouldAnimate) {
        return;
    }
    return "\n    & > div {\n      animation: " + itemAppear + " 500ms 1;\n      animation-fill-mode: both;\n    }\n  ";
};
var animateBadge = function (_a) {
    var shouldAnimate = _a.shouldAnimate;
    if (!shouldAnimate) {
        return;
    }
    return "\n    animation: " + itemAppear + " 250ms 1;\n    animation-fill-mode: both;\n    animation-delay: 400ms;\n  ";
};
var AvatarItem = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  position: relative;\n  align-self: center;\n\n  ", "\n\n  &::before {\n    content: '", "';\n    display: block;\n    position: absolute;\n    right: -1px;\n    bottom: -1px;\n    width: 13px;\n    height: 13px;\n    z-index: ", ";\n    border-radius: 3px;\n    background: ", ";\n    color: #fff;\n    font-size: 9px;\n    line-height: 0;\n    padding-top: 7px;\n    text-align: center;\n    box-shadow: 0 0 1px #fff;\n    box-sizing: border-box;\n\n    ", "\n  }\n"], ["\n  position: relative;\n  align-self: center;\n\n  ", "\n\n  &::before {\n    content: '", "';\n    display: block;\n    position: absolute;\n    right: -1px;\n    bottom: -1px;\n    width: 13px;\n    height: 13px;\n    z-index: ", ";\n    border-radius: 3px;\n    background: ", ";\n    color: #fff;\n    font-size: 9px;\n    line-height: 0;\n    padding-top: 7px;\n    text-align: center;\n    box-shadow: 0 0 1px #fff;\n    box-sizing: border-box;\n\n    ", "\n  }\n"])), animateAvatar, function (props) { return props.avatar; }, __WEBPACK_IMPORTED_MODULE_7__atlaskit_editor_common__["t" /* akEditorSmallZIndex */], function (props) { return props.badgeColor; }, animateBadge);
function Item(props) {
    var color = Object(__WEBPACK_IMPORTED_MODULE_10__utils__["d" /* getAvatarColor */])(props.sessionId).color.solid;
    var avatar = props.name.substr(0, 1).toUpperCase();
    var children = props.children, theme = props.theme, other = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](props, ["children", "theme"]);
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](AvatarItem, { badgeColor: color, avatar: avatar, shouldAnimate: props.isInteractive },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_avatar__["d" /* default */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, other))));
}
var Avatars = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Avatars, _super);
    function Avatars() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onAvatarClick = function (event) { };
        _this.renderAvatars = function (state) {
            if (!state.data) {
                return null;
            }
            var _a = state.data, sessionId = _a.sessionId, activeParticipants = _a.activeParticipants;
            var avatars = activeParticipants
                .toArray()
                .map(function (p) { return ({
                email: p.email,
                key: p.sessionId,
                name: p.name,
                src: p.avatar,
                sessionId: p.sessionId,
                size: 'medium',
                component: Item,
            }); })
                .sort(function (p) { return (p.sessionId === sessionId ? -1 : 1); });
            if (!avatars.length) {
                return null;
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](AvatarContainer, null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_avatar_group__["default"], { appearance: "stack", size: "medium", data: avatars, onAvatarClick: _this.onAvatarClick }),
                _this.props.inviteToEditHandler && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](InviteTeamWrapper, null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__ui_ToolbarButton__["a" /* default */], { onClick: _this.props.inviteToEditHandler, selected: _this.props.isInviteToEditButtonSelected, title: "Invite to edit", titlePosition: "bottom", iconBefore: __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_add___default.a, { label: "Invite to edit" }) })))));
        };
        return _this;
    }
    Avatars.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ui_WithPluginState__["a" /* default */], { plugins: { data: __WEBPACK_IMPORTED_MODULE_9__plugin__["b" /* pluginKey */] }, render: this.renderAvatars, editorView: this.props.editorView }));
    };
    return Avatars;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Avatars);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=avatars.js.map

/***/ }),
/* 2818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PluginSlot__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContentStyles__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_max_content_size__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WithFlash__ = __webpack_require__(301);









// tslint:disable-next-line:variable-name
var ChromelessEditor = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  line-height: 20px;\n  height: auto;\n  min-height: 30px;\n  ", " overflow-x: hidden;\n  overflow-y: auto;\n  ", " max-width: inherit;\n  box-sizing: border-box;\n  word-wrap: break-word;\n\n  div > .ProseMirror {\n    outline: none;\n    white-space: pre-wrap;\n    padding: 0;\n    margin: 0;\n  }\n"], ["\n  line-height: 20px;\n  height: auto;\n  min-height: 30px;\n  ",
    " overflow-x: hidden;\n  overflow-y: auto;\n  ", " max-width: inherit;\n  box-sizing: border-box;\n  word-wrap: break-word;\n\n  div > .ProseMirror {\n    outline: none;\n    white-space: pre-wrap;\n    padding: 0;\n    margin: 0;\n  }\n"])), function (props) {
    return props.maxHeight
        ? 'max-height: ' + props.maxHeight + 'px;'
        : '';
}, __WEBPACK_IMPORTED_MODULE_7__styles__["j" /* scrollbarStyles */]);
ChromelessEditor.displayName = 'ChromelessEditor';
// tslint:disable-next-line:variable-name
var ContentArea = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_5__ContentStyles__["a" /* default */])(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"]([""], [""])));
ContentArea.displayName = 'ContentArea';
var Editor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Editor, _super);
    function Editor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.appearance = 'chromeless';
        _this.renderChrome = function (_a) {
            var maxContentSize = _a.maxContentSize;
            var _b = _this.props, editorDOMElement = _b.editorDOMElement, editorView = _b.editorView, editorActions = _b.editorActions, eventDispatcher = _b.eventDispatcher, providerFactory = _b.providerFactory, contentComponents = _b.contentComponents, customContentComponents = _b.customContentComponents, maxHeight = _b.maxHeight, popupsMountPoint = _b.popupsMountPoint, popupsBoundariesElement = _b.popupsBoundariesElement, popupsScrollableElement = _b.popupsScrollableElement, disabled = _b.disabled;
            var maxContentSizeReached = maxContentSize && maxContentSize.maxContentSizeReached;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__WithFlash__["a" /* default */], { animate: maxContentSizeReached },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ChromelessEditor, { maxHeight: maxHeight, innerRef: function (ref) { return (_this.containerElement = ref); } },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ContentArea, null,
                        customContentComponents,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__PluginSlot__["a" /* default */], { editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: _this.appearance, items: contentComponents, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, containerElement: _this.containerElement, disabled: !!disabled }),
                        editorDOMElement))));
        };
        return _this;
    }
    Editor.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__WithPluginState__["a" /* default */], { plugins: { maxContentSize: __WEBPACK_IMPORTED_MODULE_6__plugins_max_content_size__["b" /* pluginKey */] }, render: this.renderChrome }));
    };
    Editor.displayName = 'ChromelessEditorAppearance';
    return Editor;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Editor);
var templateObject_1, templateObject_2;
//# sourceMappingURL=Chromeless.js.map

/***/ }),
/* 2819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Toolbar__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PluginSlot__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ContentStyles__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_max_content_size__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plugins_media_pm_plugins_main__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Addon__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__plugins_table_ui_styles__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__WithFlash__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__WidthEmitter__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__plugins_grid__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_classnames__);


















var CommentEditorMargin = 14;
var CommentEditorSmallerMargin = 8;
// tslint:disable-next-line:variable-name
var CommentEditor = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  flex-direction: column;\n\n  .less-margin .ProseMirror {\n    margin: 12px ", "px ", "px;\n  }\n\n  min-width: 272px;\n  /* Border + Toolbar + Footer + (Paragraph + ((Parahraph + Margin) * (DefaultLines - 1)) */\n  /* calc(2px + 40px + 24px + ( 20px + (32px * 2))) */\n  min-height: 150px;\n  height: auto;\n  ", " background-color: white;\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  border-radius: ", "px;\n\n  max-width: inherit;\n  word-wrap: break-word;\n"], ["\n  display: flex;\n  flex-direction: column;\n\n  .less-margin .ProseMirror {\n    margin: 12px ", "px ", "px;\n  }\n\n  min-width: 272px;\n  /* Border + Toolbar + Footer + (Paragraph + ((Parahraph + Margin) * (DefaultLines - 1)) */\n  /* calc(2px + 40px + 24px + ( 20px + (32px * 2))) */\n  min-height: 150px;\n  height: auto;\n  ",
    " background-color: white;\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  border-radius: ", "px;\n\n  max-width: inherit;\n  word-wrap: break-word;\n"])), CommentEditorSmallerMargin, CommentEditorSmallerMargin, function (props) {
    return props.maxHeight
        ? 'max-height: ' + props.maxHeight + 'px;'
        : '';
}, __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["colors"].N40, Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["borderRadius"])());
CommentEditor.displayName = 'CommentEditor';
var TableControlsPadding = 16;
// tslint:disable-next-line:variable-name
var MainToolbar = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  position: relative;\n  align-items: center;\n  padding: ", "px ", "px 0;\n  display: flex;\n  height: auto;\n\n  padding-left: ", "px;\n\n  & > div > *:first-child {\n    margin-left: 0;\n  }\n\n  .block-type-btn {\n    padding-left: 0;\n  }\n"], ["\n  position: relative;\n  align-items: center;\n  padding: ", "px ", "px 0;\n  display: flex;\n  height: auto;\n\n  padding-left: ", "px;\n\n  & > div > *:first-child {\n    margin-left: 0;\n  }\n\n  .block-type-btn {\n    padding-left: 0;\n  }\n"])), Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["gridSize"])(), Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["gridSize"])(), TableControlsPadding);
MainToolbar.displayName = 'MainToolbar';
// tslint:disable-next-line:variable-name
var MainToolbarCustomComponentsSlot = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex-grow: 1;\n  padding-right: ", "px;\n  > div {\n    display: flex;\n    flex-shrink: 0;\n  }\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex-grow: 1;\n  padding-right: ", "px;\n  > div {\n    display: flex;\n    flex-shrink: 0;\n  }\n"])), TableControlsPadding);
MainToolbarCustomComponentsSlot.displayName = 'MainToolbar';
// tslint:disable-next-line:variable-name
var ContentArea = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_8__ContentStyles__["a" /* default */])(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  flex-grow: 1;\n  overflow-x: hidden;\n  overflow-y: auto;\n  line-height: 24px;\n\n  /** Hack for Bitbucket to ensure entire editorView gets drop event; see ED-3294 **/\n  /** Hack for tables controlls. Otherwise marging collapse and controlls are misplaced. **/\n  .ProseMirror {\n    margin: 12px ", "px ", "px;\n  }\n\n  .gridParent {\n    margin-left: ", "px;\n    margin-right: ", "px;\n    width: calc(100% + ", "px);\n  }\n\n  padding: ", "px;\n\n  ", ";\n"], ["\n  flex-grow: 1;\n  overflow-x: hidden;\n  overflow-y: auto;\n  line-height: 24px;\n\n  /** Hack for Bitbucket to ensure entire editorView gets drop event; see ED-3294 **/\n  /** Hack for tables controlls. Otherwise marging collapse and controlls are misplaced. **/\n  .ProseMirror {\n    margin: 12px ", "px ", "px;\n  }\n\n  .gridParent {\n    margin-left: ", "px;\n    margin-right: ", "px;\n    width: calc(100% + ", "px);\n  }\n\n  padding: ", "px;\n\n  ", ";\n"])), CommentEditorMargin, CommentEditorMargin, CommentEditorMargin - __WEBPACK_IMPORTED_MODULE_16__plugins_grid__["a" /* GRID_GUTTER */], CommentEditorMargin - __WEBPACK_IMPORTED_MODULE_16__plugins_grid__["a" /* GRID_GUTTER */], CommentEditorMargin - __WEBPACK_IMPORTED_MODULE_16__plugins_grid__["a" /* GRID_GUTTER */], TableControlsPadding, __WEBPACK_IMPORTED_MODULE_12__plugins_table_ui_styles__["d" /* tableCommentEditorStyles */]);
ContentArea.displayName = 'ContentArea';
// tslint:disable-next-line:variable-name
var SecondaryToolbar = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_5 || (templateObject_5 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  box-sizing: border-box;\n  justify-content: flex-end;\n  align-items: center;\n  display: flex;\n  padding: 12px 1px;\n"], ["\n  box-sizing: border-box;\n  justify-content: flex-end;\n  align-items: center;\n  display: flex;\n  padding: 12px 1px;\n"])));
SecondaryToolbar.displayName = 'SecondaryToolbar';
var Editor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Editor, _super);
    function Editor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.appearance = 'comment';
        _this.handleSave = function () {
            if (_this.props.editorView && _this.props.onSave) {
                _this.props.onSave(_this.props.editorView);
            }
        };
        _this.handleCancel = function () {
            if (_this.props.editorView && _this.props.onCancel) {
                _this.props.onCancel(_this.props.editorView);
            }
        };
        _this.renderChrome = function (_a) {
            var maxContentSize = _a.maxContentSize, mediaState = _a.mediaState;
            var _b = _this.props, editorDOMElement = _b.editorDOMElement, editorView = _b.editorView, editorActions = _b.editorActions, eventDispatcher = _b.eventDispatcher, providerFactory = _b.providerFactory, contentComponents = _b.contentComponents, customContentComponents = _b.customContentComponents, customPrimaryToolbarComponents = _b.customPrimaryToolbarComponents, primaryToolbarComponents = _b.primaryToolbarComponents, customSecondaryToolbarComponents = _b.customSecondaryToolbarComponents, popupsMountPoint = _b.popupsMountPoint, popupsBoundariesElement = _b.popupsBoundariesElement, popupsScrollableElement = _b.popupsScrollableElement, maxHeight = _b.maxHeight, onSave = _b.onSave, onCancel = _b.onCancel, disabled = _b.disabled;
            var maxContentSizeReached = maxContentSize && maxContentSize.maxContentSizeReached;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__WithFlash__["a" /* default */], { animate: maxContentSizeReached },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CommentEditor, { maxHeight: maxHeight, className: "akEditor" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MainToolbar, null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Toolbar__["b" /* default */], { editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: _this.appearance, items: primaryToolbarComponents, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: !!disabled }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MainToolbarCustomComponentsSlot, null, customPrimaryToolbarComponents)),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Addon__["b" /* ClickAreaBlock */], { editorView: editorView },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__atlaskit_editor_common__["h" /* WidthConsumer */], null, function (_a) {
                            var width = _a.width;
                            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ContentArea, { innerRef: function (ref) { return (_this.containerElement = ref); }, className: __WEBPACK_IMPORTED_MODULE_17_classnames__('ak-editor-content-area', {
                                    'less-margin': width < __WEBPACK_IMPORTED_MODULE_14__atlaskit_editor_common__["s" /* akEditorMobileBreakoutPoint */],
                                }) },
                                customContentComponents,
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__PluginSlot__["a" /* default */], { editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: _this.appearance, items: contentComponents, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, containerElement: _this.containerElement, disabled: !!disabled }),
                                editorDOMElement));
                        })),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__WidthEmitter__["a" /* default */], { editorView: editorView, contentArea: _this.containerElement })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](SecondaryToolbar, null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_button__["ButtonGroup"], null,
                        !!onSave && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_button__["default"], { appearance: "primary", onClick: _this.handleSave, isDisabled: disabled || (mediaState && !mediaState.allUploadsFinished) }, "Save")),
                        !!onCancel && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_button__["default"], { appearance: "subtle", onClick: _this.handleCancel, isDisabled: disabled }, "Cancel"))),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { style: { flexGrow: 1 } }),
                    customSecondaryToolbarComponents)));
        };
        return _this;
    }
    Editor.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__WithPluginState__["a" /* default */], { plugins: {
                maxContentSize: __WEBPACK_IMPORTED_MODULE_9__plugins_max_content_size__["b" /* pluginKey */],
                mediaState: __WEBPACK_IMPORTED_MODULE_10__plugins_media_pm_plugins_main__["b" /* stateKey */],
            }, render: this.renderChrome }));
    };
    Editor.displayName = 'CommentEditorAppearance';
    return Editor;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Editor);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Comment.js.map

/***/ }),
/* 2820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PluginSlot__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WithPluginState__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContentStyles__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_max_content_size__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_mentions__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WithFlash__ = __webpack_require__(301);









// tslint:disable-next-line:variable-name
var MobileEditor = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  height: 100%;\n  min-height: 30px;\n  width: 100%;\n  max-width: inherit;\n  box-sizing: border-box;\n  word-wrap: break-word;\n\n  div > .ProseMirror {\n    outline: none;\n    white-space: pre-wrap;\n    padding: 0;\n    margin: 0;\n  }\n"], ["\n  height: 100%;\n  min-height: 30px;\n  width: 100%;\n  max-width: inherit;\n  box-sizing: border-box;\n  word-wrap: break-word;\n\n  div > .ProseMirror {\n    outline: none;\n    white-space: pre-wrap;\n    padding: 0;\n    margin: 0;\n  }\n"])));
MobileEditor.displayName = 'MobileEditor';
// tslint:disable-next-line:variable-name
var ContentArea = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_5__ContentStyles__["a" /* default */])(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  height: 100%;\n\n  .ProseMirror {\n    /** Make it full page minus the padding */\n    min-height: calc(100vh - 40px);\n  }\n"], ["\n  height: 100%;\n\n  .ProseMirror {\n    /** Make it full page minus the padding */\n    min-height: calc(100vh - 40px);\n  }\n"])));
ContentArea.displayName = 'ContentArea';
var Editor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Editor, _super);
    function Editor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.appearance = 'mobile';
        _this.handleRef = function (ref) {
            _this.containerElement = ref;
            if (_this.props.onUiReady) {
                _this.props.onUiReady(ref);
            }
        };
        _this.renderMobile = function (_a) {
            var maxContentSize = _a.maxContentSize, mentions = _a.mentions;
            var _b = _this.props, editorView = _b.editorView, eventDispatcher = _b.eventDispatcher, providerFactory = _b.providerFactory, customContentComponents = _b.customContentComponents, maxHeight = _b.maxHeight, disabled = _b.disabled, editorDOMElement = _b.editorDOMElement;
            var maxContentSizeReached = maxContentSize && maxContentSize.maxContentSizeReached;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__WithFlash__["a" /* default */], { animate: maxContentSizeReached },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MobileEditor, { isMaxContentSizeReached: maxContentSizeReached, maxHeight: maxHeight },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ContentArea, { innerRef: _this.handleRef },
                        customContentComponents,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__PluginSlot__["a" /* default */], { editorView: editorView, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: _this.appearance, containerElement: _this.containerElement, disabled: !!disabled }),
                        editorDOMElement))));
        };
        return _this;
    }
    Editor.prototype.render = function () {
        var _a = this.props, eventDispatcher = _a.eventDispatcher, editorView = _a.editorView;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__WithPluginState__["a" /* default */], { editorView: editorView, eventDispatcher: eventDispatcher, plugins: {
                maxContentSize: __WEBPACK_IMPORTED_MODULE_6__plugins_max_content_size__["b" /* pluginKey */],
                mentions: __WEBPACK_IMPORTED_MODULE_7__plugins_mentions__["b" /* mentionPluginKey */],
            }, render: this.renderMobile }));
    };
    Editor.displayName = 'MobileEditor';
    return Editor;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Editor);
var templateObject_1, templateObject_2;
//# sourceMappingURL=Mobile.js.map

/***/ }),
/* 2821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WithCreateAnalyticsEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_analytics_next__ = __webpack_require__(29);



var WithCreateAnalyticsEvent = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_analytics_next__["withAnalyticsEvents"])()(/** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WithCreateAnalyticsEvent, _super);
    function WithCreateAnalyticsEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WithCreateAnalyticsEvent.prototype.render = function () {
        var _a = this.props, render = _a.render, createAnalyticsEvent = _a.createAnalyticsEvent;
        return render(createAnalyticsEvent);
    };
    return WithCreateAnalyticsEvent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"])));
//# sourceMappingURL=index.js.map

/***/ }),
/* 2822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editor__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__labs_EditorWithActions__ = __webpack_require__(2823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ChromeCollapsed__ = __webpack_require__(2824);





var CollapsedEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CollapsedEditor, _super);
    function CollapsedEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleEditorRef = function (editorRef, editorRefCallback) {
            if (editorRefCallback && typeof editorRefCallback === 'function') {
                editorRefCallback(editorRef);
            }
            _this.editorComponent = editorRef;
        };
        return _this;
    }
    CollapsedEditor.prototype.componentWillReceiveProps = function (nextProps, nextState) {
        if (!this.props.isExpanded && nextProps.isExpanded) {
            this.shouldTriggerExpandEvent = true;
        }
    };
    CollapsedEditor.prototype.componentDidUpdate = function () {
        if (this.shouldTriggerExpandEvent && this.editorComponent) {
            this.shouldTriggerExpandEvent = false;
            if (this.props.onExpand) {
                this.props.onExpand();
            }
        }
    };
    CollapsedEditor.prototype.render = function () {
        var _this = this;
        var child = __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
        if (child.type !== __WEBPACK_IMPORTED_MODULE_2__editor__["a" /* default */] && child.type !== __WEBPACK_IMPORTED_MODULE_3__labs_EditorWithActions__["a" /* default */]) {
            throw new Error('Expected child to be of type `Editor`');
        }
        if (!this.props.isExpanded) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ChromeCollapsed__["a" /* default */], { onFocus: this.props.onFocus, text: this.props.placeholder }));
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"](child, {
            ref: function (editorComponent) {
                return _this.handleEditorRef(editorComponent, child.ref);
            },
        });
    };
    return CollapsedEditor;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* unused harmony default export */ var _unused_webpack_default_export = (CollapsedEditor);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editor__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_EditorContext__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_WithEditorActions__ = __webpack_require__(468);






var EditorWithActions = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EditorWithActions, _super);
    function EditorWithActions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSave = function (actions) { return function () {
            _this.props.onSave(actions);
        }; };
        _this.handleCancel = function (actions) { return function () {
            _this.props.onCancel(actions);
        }; };
        _this.handleChange = function (actions) { return function () {
            _this.props.onChange(actions);
        }; };
        return _this;
    }
    EditorWithActions.prototype.render = function () {
        var _this = this;
        if (this.context.editorActions) {
            var actions = this.context.editorActions;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, this.props, { onSave: this.props.onSave ? this.handleSave(actions) : undefined, onChange: this.props.onChange ? this.handleChange(actions) : undefined, onCancel: this.props.onCancel ? this.handleCancel(actions) : undefined })));
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ui_EditorContext__["a" /* default */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ui_WithEditorActions__["a" /* default */], { render: function (actions) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, _this.props, { onSave: _this.props.onSave ? _this.handleSave(actions) : undefined, onChange: _this.props.onChange ? _this.handleChange(actions) : undefined, onCancel: _this.props.onCancel ? _this.handleCancel(actions) : undefined }))); } })));
    };
    EditorWithActions.contextTypes = {
        editorActions: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"].isRequired,
    };
    return EditorWithActions;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (EditorWithActions);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2825);




var ChromeCollapsed = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ChromeCollapsed, _super);
    function ChromeCollapsed() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.focusHandler = function (e) {
            /**
             * We need this magic for FireFox.
             * The reason we need it is, when, in FireFox, we have focus inside input,
             * and then we remove that input and move focus to another place programmatically,
             * for whatever reason UP/DOWN arrows don't work until you blur and focus editor manually.
             */
            if (_this.input) {
                _this.input.blur();
            }
            if (_this.props.onFocus) {
                _this.props.onFocus(e);
            }
        };
        _this.handleInputRef = function (ref) {
            _this.input = ref;
        };
        return _this;
    }
    ChromeCollapsed.prototype.render = function () {
        var placeholder = this.props.text || 'Type something…';
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Input */], { innerRef: this.handleInputRef, onFocus: this.focusHandler, placeholder: placeholder }));
    };
    return ChromeCollapsed;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (ChromeCollapsed);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Input; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__ = __webpack_require__(3);




var Input = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].input(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  /* Normal .className gets overridden by input[type=text] hence this hack to produce input.className */\n  input& {\n    background-color: white;\n    border: 1px solid ", ";\n    border-radius: ", "px;\n    box-sizing: border-box;\n    height: 40px;\n    padding-left: 20px;\n    padding-top: 12px;\n    padding-bottom: 12px;\n    font-size: 14px;\n    width: 100%;\n    font-weight: 400;\n    line-height: 1.42857142857143;\n    letter-spacing: -0.005em;\n    color: ", ";\n\n    &:hover {\n      border-color: ", ";\n      cursor: text;\n    }\n  }\n"], ["\n  /* Normal .className gets overridden by input[type=text] hence this hack to produce input.className */\n  input& {\n    background-color: white;\n    border: 1px solid ", ";\n    border-radius: ", "px;\n    box-sizing: border-box;\n    height: 40px;\n    padding-left: 20px;\n    padding-top: 12px;\n    padding-bottom: 12px;\n    font-size: 14px;\n    width: 100%;\n    font-weight: 400;\n    line-height: 1.42857142857143;\n    letter-spacing: -0.005em;\n    color: ", ";\n\n    &:hover {\n      border-color: ", ";\n      cursor: text;\n    }\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__styles__["d" /* akEditorSubtleAccent */], Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["borderRadius"])(), __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N300, __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N50);
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_question__ = __webpack_require__(2827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ToolbarButton__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WithHelpTrigger__ = __webpack_require__(883);




var ToolbarHelp = function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__WithHelpTrigger__["a" /* default */], { render: function (showHelp) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__ToolbarButton__["a" /* default */], { onClick: showHelp, title: "Open help dialog", titlePosition: "left", iconBefore: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_question___default.a, { label: "Open help dialog" }) })); } })); };
/* unused harmony default export */ var _unused_webpack_default_export = (ToolbarHelp);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(15));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var QuestionIcon = function QuestionIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M12 18a1 1 0 0 1 0-2 1 1 0 0 1 0 2m-2-9a1 1 0 1 1-2 0 1 1 0 0 1 2 0\"/><path d=\"M15.89 8.048a3.971 3.971 0 0 0-2.951-2.94A4.005 4.005 0 0 0 8 9.087a.073.073 0 0 0 .009.008l1.878.022.112-.116A2.002 2.002 0 0 1 12 7c1.103 0 2 .897 2 2 0 1.102-.897 2-2 2h.008a1 1 0 0 0-.998.987v2.014a1 1 0 1 0 2 0v-.782c0-.217.145-.399.349-.472a3.991 3.991 0 0 0 2.53-4.699\"/></g></svg>"
  }, props));
};

QuestionIcon.displayName = 'QuestionIcon';
var _default = QuestionIcon;
exports.default = _default;

/***/ }),
/* 2828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getBrowserInfo */
/* unused harmony export getDeviceInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_spinner__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__analytics__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ToolbarButton__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__package_json__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__with_outer_listeners__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles__ = __webpack_require__(2829);












var PopupWithOutsideListeners = Object(__WEBPACK_IMPORTED_MODULE_9__with_outer_listeners__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__atlaskit_editor_common__["e" /* Popup */]);
var POPUP_HEIGHT = 388;
var POPUP_WIDTH = 280;
var JIRA_ISSUE_COLLECTOR_URL = 'https://product-fabric.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/-w0bwo4/b/14/e73395c53c3b10fde2303f4bf74ffbf6/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs.js?locale=en-US&collectorId=98644b9c';
var EDITOR_IMAGE_URL = 'https://confluence.atlassian.com/download/attachments/945114421/editorillustration@2x.png?api=v2';
/**
 * Inspired from:
 * https://stackoverflow.com/questions/11219582/how-to-detect-my-browser-version-and-operating-system-using-javascript
 */
var getBrowserInfo = function (nAgt) {
    var browserName;
    var browserVersion;
    var nameOffset;
    var verOffset;
    var index;
    // In Opera 15+, version is after "OPR/"
    if ((verOffset = nAgt.indexOf('OPR/')) !== -1) {
        browserName = 'Opera';
        browserVersion = nAgt.substring(verOffset + 4);
    }
    else if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
        // In older Opera, version is after "Opera" or after "Version"
        browserName = 'Opera';
        if ((verOffset = nAgt.indexOf('Version')) !== -1) {
            browserVersion = nAgt.substring(verOffset + 8);
        }
        else {
            browserVersion = nAgt.substring(verOffset + 6);
        }
    }
    else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
        // In MSIE, version is after "MSIE" in userAgent
        browserName = 'Microsoft Internet Explorer';
        browserVersion = nAgt.substring(verOffset + 5);
    }
    else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
        // In Chrome, version is after "Chrome"
        browserName = 'Chrome';
        browserVersion = nAgt.substring(verOffset + 7);
    }
    else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
        // In Safari, version is after "Safari" or after "Version"
        browserName = 'Safari';
        if ((verOffset = nAgt.indexOf('Version')) !== -1) {
            browserVersion = nAgt.substring(verOffset + 8);
        }
        else {
            browserVersion = nAgt.substring(verOffset + 7);
        }
    }
    else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
        // In Firefox, version is after "Firefox"
        browserName = 'Firefox';
        browserVersion = nAgt.substring(verOffset + 8);
    }
    else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) <
        (verOffset = nAgt.lastIndexOf('/'))) {
        // In most other browsers, "name/version" is at the end of userAgent
        browserName = nAgt.substring(nameOffset, verOffset);
        browserVersion = nAgt.substring(verOffset + 1);
        if (browserName.toLowerCase() === browserName.toUpperCase()) {
            browserName = navigator.appName;
        }
    }
    else {
        browserName = navigator.appName;
        browserVersion = '' + parseFloat(navigator.appVersion);
    }
    // trim the versionStr string at semicolon/space if present
    if ((index = browserVersion.indexOf(';')) !== -1) {
        browserVersion = browserVersion.substring(0, index);
    }
    if ((index = browserVersion.indexOf(' ')) !== -1) {
        browserVersion = browserVersion.substring(0, index);
    }
    return browserName + " " + browserVersion;
};
/**
 * Inspired from:
 * https://stackoverflow.com/questions/9514179/how-to-find-the-operating-system-version-using-javascript
 */
var getDeviceInfo = function (nAgt, nVersion) {
    var os = '';
    var osVersion = '';
    var clientStrings = [
        { s: 'Windows 3.11', r: /Win16/ },
        { s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/ },
        { s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/ },
        { s: 'Windows 98', r: /(Windows 98|Win98)/ },
        { s: 'Windows CE', r: /Windows CE/ },
        { s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/ },
        { s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/ },
        { s: 'Windows Server 2003', r: /Windows NT 5.2/ },
        { s: 'Windows Vista', r: /Windows NT 6.0/ },
        { s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/ },
        { s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/ },
        { s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/ },
        { s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
        { s: 'Android', r: /Android/ },
        { s: 'Open BSD', r: /OpenBSD/ },
        { s: 'Sun OS', r: /SunOS/ },
        { s: 'Linux', r: /(Linux|X11)/ },
        { s: 'iOS', r: /(iPhone|iPad|iPod)/ },
        { s: 'Mac OS X', r: /Mac OS X/ },
        { s: 'Mac OS', r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
        { s: 'QNX', r: /QNX/ },
        { s: 'UNIX', r: /UNIX/ },
        { s: 'BeOS', r: /BeOS/ },
        { s: 'OS/2', r: /OS\/2/ },
        {
            s: 'Search Bot',
            r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/,
        },
    ];
    for (var client in clientStrings) {
        var clientObj = clientStrings[client];
        if (clientObj.r.test(nAgt)) {
            os = clientObj.s;
            break;
        }
    }
    var match;
    if (/Windows/.test(os)) {
        match = /Windows (.*)/.exec(os);
        osVersion = match && match[1];
        os = 'Windows';
    }
    switch (os) {
        case 'Mac OS X':
            match = /Mac OS X (10[\.\_\d]+)/.exec(nAgt);
            osVersion = match && match[1];
            break;
        case 'Android':
            match = /Android ([\.\_\d]+)/.exec(nAgt);
            osVersion = match && match[1];
            break;
        case 'iOS':
            match = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVersion);
            osVersion = match && match[1] + '.' + match[2] + '.' + (match[3] | 0);
    }
    return os + " " + osVersion;
};
var ToolbarFeedback = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ToolbarFeedback, _super);
    function ToolbarFeedback() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            jiraIssueCollectorScriptLoading: false,
            showOptOutOption: false,
        };
        _this.handleRef = function (ref) {
            if (ref) {
                _this.setState({
                    target: __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](ref || null),
                });
            }
        };
        _this.collectFeedback = function () {
            if (_this.props.product === 'bitbucket') {
                _this.setState({ showOptOutOption: true });
            }
            else {
                _this.openFeedbackPopup();
            }
        };
        _this.toggleShowOptOutOption = function () {
            _this.setState({ showOptOutOption: !_this.state.showOptOutOption });
        };
        _this.openFeedbackPopup = Object(__WEBPACK_IMPORTED_MODULE_6__analytics__["c" /* withAnalytics */])('atlassian.editor.feedback.button', function () {
            if (typeof _this.showJiraCollectorDialogCallback === 'function') {
                _this.showJiraCollectorDialogCallback();
                return false;
            }
            _this.setState({
                jiraIssueCollectorScriptLoading: true,
                showOptOutOption: false,
            });
            var product = _this.props.product || 'n/a';
            // triggerFunction is executed as soon as JIRA issue collector script is loaded
            window.ATL_JQ_PAGE_PROPS = {
                triggerFunction: function (showCollectorDialog) {
                    _this.setState({ jiraIssueCollectorScriptLoading: false });
                    if (typeof showCollectorDialog === 'function') {
                        // save reference to `showCollectorDialog` for future calls
                        _this.showJiraCollectorDialogCallback = showCollectorDialog;
                        // and run it now
                        // next tick is essential due to JIRA issue collector behaviour
                        window.setTimeout(showCollectorDialog, 0);
                    }
                },
                fieldValues: {
                    description: "Please describe the problem you're having or feature you'd like to see:\n\n\n",
                    // 11711 is the field ID for the Feedback Labels field on Product Fabric.
                    // this is found by clicking "configure" on the field and inspecting the URL
                    customfield_11711: __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"]([product], (_this.props.labels || [])),
                    customfield_11712: "version: " + _this.props.packageName + "@" + _this.props.packageVersion + " (" + __WEBPACK_IMPORTED_MODULE_8__package_json__["version"] + ")\n          Browser: " + getBrowserInfo(navigator.userAgent) + "\n          OS: " + getDeviceInfo(navigator.userAgent, navigator.appVersion),
                },
                environment: {
                    'Editor Package': _this.props.packageName,
                    'Editor Version': _this.props.packageVersion,
                    'Editor Core Version': __WEBPACK_IMPORTED_MODULE_8__package_json__["version"],
                },
                priority: '1',
                components: '15306',
            };
            _this.loadJiraIssueCollectorScript();
            return true;
        });
        _this.loadJiraIssueCollectorScript = function () {
            if (_this.hasJquery()) {
                window.jQuery.ajax({
                    url: JIRA_ISSUE_COLLECTOR_URL,
                    type: 'get',
                    cache: true,
                    dataType: 'script',
                });
            }
        };
        _this.openLearnMorePage = function () {
            window.open('https://confluence.atlassian.com/x/NU1VO', '_blank');
            _this.toggleShowOptOutOption();
        };
        _this.hasJquery = function () {
            return typeof window.jQuery !== 'undefined';
        };
        return _this;
    }
    ToolbarFeedback.prototype.handleSpinnerComplete = function () { };
    ToolbarFeedback.prototype.render = function () {
        var _a = this.props, popupsMountPoint = _a.popupsMountPoint, popupsBoundariesElement = _a.popupsBoundariesElement, popupsScrollableElement = _a.popupsScrollableElement;
        var iconBefore = this.state.jiraIssueCollectorScriptLoading ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_spinner__["a" /* default */], { isCompleting: false, onComplete: this.handleSpinnerComplete })) : (undefined);
        // JIRA issue collector script is using jQuery internally
        return this.hasJquery() ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styles__["f" /* Wrapper */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ToolbarButton__["a" /* default */], { ref: this.handleRef, iconBefore: iconBefore, onClick: this.collectFeedback, selected: false, spacing: "compact" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styles__["a" /* ButtonContent */], null, "Feedback")),
            this.state.showOptOutOption && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](PopupWithOutsideListeners, { target: this.state.target, mountTo: popupsMountPoint, boundariesElement: popupsBoundariesElement, scrollableElement: popupsScrollableElement, fitHeight: POPUP_HEIGHT, fitWidth: POPUP_WIDTH, handleClickOutside: this.toggleShowOptOutOption, handleEscapeKeydown: this.toggleShowOptOutOption },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styles__["d" /* ConfirmationPopup */], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styles__["b" /* ConfirmationHeader */], null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styles__["c" /* ConfirmationImg */], { src: EDITOR_IMAGE_URL })),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__styles__["e" /* ConfirmationText */], null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, "We are rolling out a new editing experience across Atlassian products. Help us improve by providing feedback."),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, "You can opt-out for now by turning off the \"Atlassian Editor\" feature on the Labs page in Bitbucket settings."),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__atlaskit_button__["ButtonGroup"], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__atlaskit_button__["default"], { appearance: "primary", onClick: this.openFeedbackPopup }, "Give feedback"),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__atlaskit_button__["default"], { appearance: "default", onClick: this.openLearnMorePage }, "Learn more")))))))) : null;
    };
    return ToolbarFeedback;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* unused harmony default export */ var _unused_webpack_default_export = (ToolbarFeedback);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ConfirmationPopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ConfirmationText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ConfirmationHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ConfirmationImg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



var ButtonContent = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  height: 24px;\n  line-height: 24px;\n  min-width: 70px;\n"], ["\n  display: flex;\n  height: 24px;\n  line-height: 24px;\n  min-width: 70px;\n"])));
var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  margin-right: ", "px;\n"], ["\n  display: flex;\n  margin-right: ",
    "px;\n"])), function (_a) {
    var width = _a.width;
    return !width || width === 'large' ? 0 : Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])();
});
var ConfirmationPopup = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  background: #fff;\n  border-radius: ", "px;\n  box-shadow: 0 4px 8px -2px ", ", 0 0 1px ", ";\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  overflow: auto;\n  max-height: none;\n  height: 410px;\n  width: 280px;\n"], ["\n  background: #fff;\n  border-radius: ", "px;\n  box-shadow: 0 4px 8px -2px ", ", 0 0 1px ", ";\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  overflow: auto;\n  max-height: none;\n  height: 410px;\n  width: 280px;\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])(), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N60A, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N60A);
var ConfirmationText = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  font-size: 14px;\n  word-spacing: 4px;\n  line-height: 22px;\n  color: ", ";\n  margin-top: 30px;\n  padding: 20px;\n  & > div {\n    width: 240px;\n  }\n  & > div:first-of-type {\n    margin-bottom: 12px;\n  }\n  & > div:nth-of-type(2) {\n    margin-bottom: 20px;\n  }\n"], ["\n  font-size: 14px;\n  word-spacing: 4px;\n  line-height: 22px;\n  color: ", ";\n  margin-top: 30px;\n  padding: 20px;\n  & > div {\n    width: 240px;\n  }\n  & > div:first-of-type {\n    margin-bottom: 12px;\n  }\n  & > div:nth-of-type(2) {\n    margin-bottom: 20px;\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N400);
var ConfirmationHeader = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_5 || (templateObject_5 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  background-color: ", ";\n  height: 100px;\n  width: 100%;\n  display: inline-block;\n"], ["\n  background-color: ", ";\n  height: 100px;\n  width: 100%;\n  display: inline-block;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].P400);
var ConfirmationImg = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].img(templateObject_6 || (templateObject_6 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  width: 100px;\n  display: block;\n  margin: 25px auto 0 auto;\n"], ["\n  width: 100px;\n  display: block;\n  margin: 25px auto 0 auto;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tooltip__ = __webpack_require__(256);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var status=_ref.status,children=_ref.children,className=_ref.className,useBareClass=_ref.useBareClass,props=_objectWithoutProperties(_ref,['status','children','className','useBareClass']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:(useBareClass||'fs18-sm d-sm-ib')+' '+(className||'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Tooltip__["a" /* default */],Object.assign({},props,{content:children,placement:'right'}),status=='ineligible'||status=='inactive'||status=='unavailable'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-access-status-warning status-'+status}):status=='active'||status=='inprogress'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-access-status-good status-'+status}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-access-status-warning inactive'})));});

/***/ }),
/* 2831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tooltip__ = __webpack_require__(256);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var status=_ref.status,children=_ref.children,className=_ref.className,useBareClass=_ref.useBareClass,props=_objectWithoutProperties(_ref,['status','children','className','useBareClass']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:(useBareClass||'fs18-sm d-sm-ib')+' '+(className||'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Tooltip__["a" /* default */],Object.assign({},props,{content:children,placement:'right'}),status?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-access-status-good status-active'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-access-status-warning status-inactive'})));});

/***/ }),
/* 2832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_modal_dialog__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_wikimarkup_transformer__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_renderer__ = __webpack_require__(109);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalDialog=function(_Component){_inherits(ModalDialog,_Component);function ModalDialog(props){var _ref;_classCallCheck(this,ModalDialog);for(var _len=arguments.length,args=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}var _this=_possibleConstructorReturn(this,(_ref=ModalDialog.__proto__||Object.getPrototypeOf(ModalDialog)).call.apply(_ref,[this,props].concat(args)));_this.close=function(){var handleClose=_this.props.handleClose;_this.setState({show:false});handleClose();};var display=props.display;_this.state={show:display?display:false};return _this;}_createClass(ModalDialog,[{key:'render',value:function render(){var children=this.props.children;var actions=[{text:'Close',onClick:this.close}];var adfEncoder=new __WEBPACK_IMPORTED_MODULE_3__atlaskit_renderer__["a" /* ADFEncoder */](function(){return new __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_wikimarkup_transformer__["a" /* WikiMarkupTransformer */]();});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__atlaskit_modal_dialog__["a" /* ModalTransition */],null,this.state.show&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__atlaskit_modal_dialog__["b" /* default */],{actions:actions,onClose:this.close,heading:children.HEADER?children.HEADER:"Error"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__atlaskit_renderer__["b" /* ReactRenderer */],{document:adfEncoder.encode(children.MESSAGE?children.MESSAGE:children)}))));}}]);return ModalDialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ModalDialog);

/***/ }),
/* 2833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return blockquote; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(167);

var blockquote = function (node) {
    var result = [];
    node.forEach(function (n) {
        result.push(Object(__WEBPACK_IMPORTED_MODULE_0____["a" /* encode */])(n));
    });
    return "{quote}" + result.join('\n\n') + "{quote}";
};
//# sourceMappingURL=blockquote.js.map

/***/ }),
/* 2834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bulletList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listItem__ = __webpack_require__(884);

var bulletList = function (node) {
    var result = [];
    node.forEach(function (item) {
        result.push(Object(__WEBPACK_IMPORTED_MODULE_0__listItem__["a" /* listItem */])(item, '*'));
    });
    return result.join('\n');
};
//# sourceMappingURL=bullet-list.js.map

/***/ }),
/* 2835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return emoji; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emoji_unicode_mapping__ = __webpack_require__(2836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unknown__ = __webpack_require__(886);


var emoji = function (node) {
    var value = __WEBPACK_IMPORTED_MODULE_0__emoji_unicode_mapping__["a" /* mapping */][node.attrs.id];
    if (value) {
        return value;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_1__unknown__["a" /* unknown */])(node);
};
//# sourceMappingURL=emoji.js.map

/***/ }),
/* 2836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mapping; });
var mapping = {
    '1f600': '😀',
    '1f603': '😃',
    '1f604': '😄',
    '1f601': '😁',
    '1f606': '😆',
    '1f605': '😅',
    '1f602': '😂',
    '1f923': '🤣',
    '263a': '☺️',
    '1f60a': '😊',
    '1f607': '😇',
    '1f642': '🙂',
    '1f643': '🙃',
    '1f609': '😉',
    '1f60c': '😌',
    '1f60d': '😍',
    '1f618': '😘',
    '1f617': '😗',
    '1f619': '😙',
    '1f61a': '😚',
    '1f60b': '😋',
    '1f61c': '😜',
    '1f61d': '😝',
    '1f61b': '😛',
    '1f911': '🤑',
    '1f917': '🤗',
    '1f913': '🤓',
    '1f60e': '😎',
    '1f921': '🤡',
    '1f920': '🤠',
    '1f60f': '😏',
    '1f612': '😒',
    '1f61e': '😞',
    '1f614': '😔',
    '1f61f': '😟',
    '1f615': '😕',
    '1f641': '🙁',
    '2639': '☹️',
    '1f623': '😣',
    '1f616': '😖',
    '1f62b': '😫',
    '1f629': '😩',
    '1f624': '😤',
    '1f620': '😠',
    '1f621': '😡',
    '1f636': '😶',
    '1f610': '😐',
    '1f611': '😑',
    '1f62f': '😯',
    '1f626': '😦',
    '1f627': '😧',
    '1f62e': '😮',
    '1f632': '😲',
    '1f635': '😵',
    '1f633': '😳',
    '1f631': '😱',
    '1f628': '😨',
    '1f630': '😰',
    '1f622': '😢',
    '1f625': '😥',
    '1f924': '🤤',
    '1f62d': '😭',
    '1f613': '😓',
    '1f62a': '😪',
    '1f634': '😴',
    '1f644': '🙄',
    '1f914': '🤔',
    '1f925': '🤥',
    '1f62c': '😬',
    '1f910': '🤐',
    '1f922': '🤢',
    '1f927': '🤧',
    '1f637': '😷',
    '1f912': '🤒',
    '1f915': '🤕',
    '1f608': '😈',
    '1f47f': '👿',
    '1f479': '👹',
    '1f47a': '👺',
    '1f4a9': '💩',
    '1f47b': '👻',
    '1f480': '💀',
    '2620': '☠️',
    '1f47d': '👽',
    '1f47e': '👾',
    '1f916': '🤖',
    '1f383': '🎃',
    '1f63a': '😺',
    '1f638': '😸',
    '1f639': '😹',
    '1f63b': '😻',
    '1f63c': '😼',
    '1f63d': '😽',
    '1f640': '🙀',
    '1f63f': '😿',
    '1f63e': '😾',
    '1f450': '👐',
    '1f64c': '🙌',
    '1f44f': '👏',
    '1f64f': '🙏',
    '1f91d': '🤝',
    '1f44d': '👍',
    '1f44e': '👎',
    '1f44a': '👊',
    '270a': '✊',
    '1f91b': '🤛',
    '1f91c': '🤜',
    '1f91e': '🤞',
    '270c': '✌️',
    '1f918': '🤘',
    '1f44c': '👌',
    '1f448': '👈',
    '1f449': '👉',
    '1f446': '👆',
    '1f447': '👇',
    '261d': '☝️',
    '270b': '✋',
    '1f91a': '🤚',
    '1f590': '🖐️',
    '1f596': '🖖',
    '1f44b': '👋',
    '1f919': '🤙',
    '1f4aa': '💪',
    '1f595': '🖕',
    '270d': '✍️',
    '1f933': '🤳',
    '1f485': '💅',
    '1f48d': '💍',
    '1f484': '💄',
    '1f48b': '💋',
    '1f444': '👄',
    '1f445': '👅',
    '1f442': '👂',
    '1f443': '👃',
    '1f463': '👣',
    '1f441': '👁️',
    '1f440': '👀',
    '1f5e3': '🗣️',
    '1f464': '👤',
    '1f465': '👥',
    '1f476': '👶',
    '1f466': '👦',
    '1f467': '👧',
    '1f468': '👨',
    '1f469': '👩',
    '1f471-200d-2640-fe0f': '👱‍♀️',
    '1f471': '👱',
    '1f471-200d-2642-fe0f': '👱‍♂️',
    '1f474': '👴',
    '1f475': '👵',
    '1f472': '👲',
    '1f473-200d-2640-fe0f': '👳‍♀️',
    '1f473': '👳',
    '1f473-200d-2642-fe0f': '👳‍♂️',
    '1f46e-200d-2640-fe0f': '👮‍♀️',
    '1f46e': '👮',
    '1f46e-200d-2642-fe0f': '👮‍♂️',
    '1f477-200d-2640-fe0f': '👷‍♀️',
    '1f477': '👷',
    '1f477-200d-2642-fe0f': '👷‍♂️',
    '1f482-200d-2640-fe0f': '💂‍♀️',
    '1f482': '💂',
    '1f482-200d-2642-fe0f': '💂‍♂️',
    '1f575-fe0f-200d-2640-fe0f': '🕵️‍♀️',
    '1f575': '🕵️',
    '1f575-fe0f-200d-2642-fe0f': '🕵️‍♂️',
    '1f469-200d-2695-fe0f': '👩‍⚕️',
    '1f468-200d-2695-fe0f': '👨‍⚕️',
    '1f469-200d-1f33e': '👩‍🌾',
    '1f468-200d-1f33e': '👨‍🌾',
    '1f469-200d-1f373': '👩‍🍳',
    '1f468-200d-1f373': '👨‍🍳',
    '1f469-200d-1f393': '👩‍🎓',
    '1f468-200d-1f393': '👨‍🎓',
    '1f469-200d-1f3a4': '👩‍🎤',
    '1f468-200d-1f3a4': '👨‍🎤',
    '1f469-200d-1f3eb': '👩‍🏫',
    '1f468-200d-1f3eb': '👨‍🏫',
    '1f469-200d-1f3ed': '👩‍🏭',
    '1f468-200d-1f3ed': '👨‍🏭',
    '1f469-200d-1f4bb': '👩‍💻',
    '1f468-200d-1f4bb': '👨‍💻',
    '1f469-200d-1f4bc': '👩‍💼',
    '1f468-200d-1f4bc': '👨‍💼',
    '1f469-200d-1f527': '👩‍🔧',
    '1f468-200d-1f527': '👨‍🔧',
    '1f469-200d-1f52c': '👩‍🔬',
    '1f468-200d-1f52c': '👨‍🔬',
    '1f469-200d-1f3a8': '👩‍🎨',
    '1f468-200d-1f3a8': '👨‍🎨',
    '1f469-200d-1f692': '👩‍🚒',
    '1f468-200d-1f692': '👨‍🚒',
    '1f469-200d-2708-fe0f': '👩‍✈️',
    '1f468-200d-2708-fe0f': '👨‍✈️',
    '1f469-200d-1f680': '👩‍🚀',
    '1f468-200d-1f680': '👨‍🚀',
    '1f469-200d-2696-fe0f': '👩‍⚖️',
    '1f468-200d-2696-fe0f': '👨‍⚖️',
    '1f936': '🤶',
    '1f385': '🎅',
    '1f478': '👸',
    '1f934': '🤴',
    '1f470': '👰',
    '1f935': '🤵',
    '1f47c': '👼',
    '1f930': '🤰',
    '1f647-200d-2640-fe0f': '🙇‍♀️',
    '1f647': '🙇',
    '1f647-200d-2642-fe0f': '🙇‍♂️',
    '1f481': '💁',
    '1f481-200d-2642-fe0f': '💁‍♂️',
    '1f481-200d-2640-fe0f': '💁‍♀️',
    '1f645': '🙅',
    '1f645-200d-2642-fe0f': '🙅‍♂️',
    '1f645-200d-2640-fe0f': '🙅‍♀️',
    '1f646': '🙆',
    '1f646-200d-2642-fe0f': '🙆‍♂️',
    '1f646-200d-2640-fe0f': '🙆‍♀️',
    '1f64b': '🙋',
    '1f64b-200d-2642-fe0f': '🙋‍♂️',
    '1f64b-200d-2640-fe0f': '🙋‍♀️',
    '1f926-200d-2640-fe0f': '🤦‍♀️',
    '1f926-200d-2642-fe0f': '🤦‍♂️',
    '1f926': '🤦',
    '1f937-200d-2640-fe0f': '🤷‍♀️',
    '1f937-200d-2642-fe0f': '🤷‍♂️',
    '1f937': '🤷',
    '1f64e': '🙎',
    '1f64e-200d-2642-fe0f': '🙎‍♂️',
    '1f64e-200d-2640-fe0f': '🙎‍♀️',
    '1f64d': '🙍',
    '1f64d-200d-2642-fe0f': '🙍‍♂️',
    '1f64d-200d-2640-fe0f': '🙍‍♀️',
    '1f487': '💇',
    '1f487-200d-2642-fe0f': '💇‍♂️',
    '1f487-200d-2640-fe0f': '💇‍♀️',
    '1f486': '💆',
    '1f486-200d-2642-fe0f': '💆‍♂️',
    '1f486-200d-2640-fe0f': '💆‍♀️',
    '1f574': '🕴️',
    '1f483': '💃',
    '1f57a': '🕺',
    '1f46f': '👯',
    '1f46f-200d-2642-fe0f': '👯‍♂️',
    '1f46f-200d-2640-fe0f': '👯‍♀️',
    '1f6b6-200d-2640-fe0f': '🚶‍♀️',
    '1f6b6': '🚶',
    '1f6b6-200d-2642-fe0f': '🚶‍♂️',
    '1f3c3-200d-2640-fe0f': '🏃‍♀️',
    '1f3c3': '🏃',
    '1f3c3-200d-2642-fe0f': '🏃‍♂️',
    '1f46b': '👫',
    '1f46d': '👭',
    '1f46c': '👬',
    '1f491': '💑',
    '1f469-200d-2764-fe0f-200d-1f469': '👩‍❤️‍👩',
    '1f468-200d-2764-fe0f-200d-1f468': '👨‍❤️‍👨',
    '1f48f': '💏',
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469': '👩‍❤️‍💋‍👩',
    '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468': '👨‍❤️‍💋‍👨',
    '1f46a': '👪',
    '1f468-200d-1f469-200d-1f467': '👨‍👩‍👧',
    '1f468-200d-1f469-200d-1f467-200d-1f466': '👨‍👩‍👧‍👦',
    '1f468-200d-1f469-200d-1f466-200d-1f466': '👨‍👩‍👦‍👦',
    '1f468-200d-1f469-200d-1f467-200d-1f467': '👨‍👩‍👧‍👧',
    '1f469-200d-1f469-200d-1f466': '👩‍👩‍👦',
    '1f469-200d-1f469-200d-1f467': '👩‍👩‍👧',
    '1f469-200d-1f469-200d-1f467-200d-1f466': '👩‍👩‍👧‍👦',
    '1f469-200d-1f469-200d-1f466-200d-1f466': '👩‍👩‍👦‍👦',
    '1f469-200d-1f469-200d-1f467-200d-1f467': '👩‍👩‍👧‍👧',
    '1f468-200d-1f468-200d-1f466': '👨‍👨‍👦',
    '1f468-200d-1f468-200d-1f467': '👨‍👨‍👧',
    '1f468-200d-1f468-200d-1f467-200d-1f466': '👨‍👨‍👧‍👦',
    '1f468-200d-1f468-200d-1f466-200d-1f466': '👨‍👨‍👦‍👦',
    '1f468-200d-1f468-200d-1f467-200d-1f467': '👨‍👨‍👧‍👧',
    '1f469-200d-1f466': '👩‍👦',
    '1f469-200d-1f467': '👩‍👧',
    '1f469-200d-1f467-200d-1f466': '👩‍👧‍👦',
    '1f469-200d-1f466-200d-1f466': '👩‍👦‍👦',
    '1f469-200d-1f467-200d-1f467': '👩‍👧‍👧',
    '1f468-200d-1f466': '👨‍👦',
    '1f468-200d-1f467': '👨‍👧',
    '1f468-200d-1f467-200d-1f466': '👨‍👧‍👦',
    '1f468-200d-1f466-200d-1f466': '👨‍👦‍👦',
    '1f468-200d-1f467-200d-1f467': '👨‍👧‍👧',
    '1f45a': '👚',
    '1f455': '👕',
    '1f456': '👖',
    '1f454': '👔',
    '1f457': '👗',
    '1f459': '👙',
    '1f458': '👘',
    '1f460': '👠',
    '1f461': '👡',
    '1f462': '👢',
    '1f45e': '👞',
    '1f45f': '👟',
    '1f452': '👒',
    '1f3a9': '🎩',
    '1f393': '🎓',
    '1f451': '👑',
    '26d1': '⛑️',
    '1f392': '🎒',
    '1f45d': '👝',
    '1f45b': '👛',
    '1f45c': '👜',
    '1f4bc': '💼',
    '1f453': '👓',
    '1f576': '🕶️',
    '1f302': '🌂',
    '2602': '☂️',
    '1f436': '🐶',
    '1f431': '🐱',
    '1f42d': '🐭',
    '1f439': '🐹',
    '1f430': '🐰',
    '1f98a': '🦊',
    '1f43b': '🐻',
    '1f43c': '🐼',
    '1f428': '🐨',
    '1f42f': '🐯',
    '1f981': '🦁',
    '1f42e': '🐮',
    '1f437': '🐷',
    '1f43d': '🐽',
    '1f438': '🐸',
    '1f435': '🐵',
    '1f648': '🙈',
    '1f649': '🙉',
    '1f64a': '🙊',
    '1f412': '🐒',
    '1f414': '🐔',
    '1f427': '🐧',
    '1f426': '🐦',
    '1f424': '🐤',
    '1f423': '🐣',
    '1f425': '🐥',
    '1f986': '🦆',
    '1f985': '🦅',
    '1f989': '🦉',
    '1f987': '🦇',
    '1f43a': '🐺',
    '1f417': '🐗',
    '1f434': '🐴',
    '1f984': '🦄',
    '1f41d': '🐝',
    '1f41b': '🐛',
    '1f98b': '🦋',
    '1f40c': '🐌',
    '1f41a': '🐚',
    '1f41e': '🐞',
    '1f41c': '🐜',
    '1f577': '🕷️',
    '1f578': '🕸️',
    '1f422': '🐢',
    '1f40d': '🐍',
    '1f98e': '🦎',
    '1f982': '🦂',
    '1f980': '🦀',
    '1f991': '🦑',
    '1f419': '🐙',
    '1f990': '🦐',
    '1f420': '🐠',
    '1f41f': '🐟',
    '1f421': '🐡',
    '1f42c': '🐬',
    '1f988': '🦈',
    '1f433': '🐳',
    '1f40b': '🐋',
    '1f40a': '🐊',
    '1f406': '🐆',
    '1f405': '🐅',
    '1f403': '🐃',
    '1f402': '🐂',
    '1f404': '🐄',
    '1f98c': '🦌',
    '1f42a': '🐪',
    '1f42b': '🐫',
    '1f418': '🐘',
    '1f98f': '🦏',
    '1f98d': '🦍',
    '1f40e': '🐎',
    '1f416': '🐖',
    '1f410': '🐐',
    '1f40f': '🐏',
    '1f411': '🐑',
    '1f415': '🐕',
    '1f429': '🐩',
    '1f408': '🐈',
    '1f413': '🐓',
    '1f983': '🦃',
    '1f54a': '🕊️',
    '1f407': '🐇',
    '1f401': '🐁',
    '1f400': '🐀',
    '1f43f': '🐿️',
    '1f43e': '🐾',
    '1f409': '🐉',
    '1f432': '🐲',
    '1f335': '🌵',
    '1f384': '🎄',
    '1f332': '🌲',
    '1f333': '🌳',
    '1f334': '🌴',
    '1f331': '🌱',
    '1f33f': '🌿',
    '2618': '☘️',
    '1f340': '🍀',
    '1f38d': '🎍',
    '1f38b': '🎋',
    '1f343': '🍃',
    '1f342': '🍂',
    '1f341': '🍁',
    '1f344': '🍄',
    '1f33e': '🌾',
    '1f490': '💐',
    '1f337': '🌷',
    '1f339': '🌹',
    '1f940': '🥀',
    '1f33b': '🌻',
    '1f33c': '🌼',
    '1f338': '🌸',
    '1f33a': '🌺',
    '1f30e': '🌎',
    '1f30d': '🌍',
    '1f30f': '🌏',
    '1f315': '🌕',
    '1f316': '🌖',
    '1f317': '🌗',
    '1f318': '🌘',
    '1f311': '🌑',
    '1f312': '🌒',
    '1f313': '🌓',
    '1f314': '🌔',
    '1f31a': '🌚',
    '1f31d': '🌝',
    '1f31e': '🌞',
    '1f31b': '🌛',
    '1f31c': '🌜',
    '1f319': '🌙',
    '1f4ab': '💫',
    '2b50': '⭐',
    '1f31f': '🌟',
    '2728': '✨',
    '26a1': '⚡',
    '1f525': '🔥',
    '1f4a5': '💥',
    '2604': '☄️',
    '2600': '☀️',
    '1f324': '🌤️',
    '26c5': '⛅',
    '1f325': '🌥️',
    '1f326': '🌦️',
    '1f308': '🌈',
    '2601': '☁️',
    '1f327': '🌧️',
    '26c8': '⛈️',
    '1f329': '🌩️',
    '1f328': '🌨️',
    '2603': '☃️',
    '26c4': '⛄',
    '2744': '❄️',
    '1f32c': '🌬️',
    '1f4a8': '💨',
    '1f32a': '🌪️',
    '1f32b': '🌫️',
    '1f30a': '🌊',
    '1f4a7': '💧',
    '1f4a6': '💦',
    '2614': '☔',
    '1f992': '🦒',
    '1f993': '🦓',
    '1f994': '🦔',
    '1f995': '🦕',
    '1f996': '🦖',
    '1f997': '🦗',
    '1f34f': '🍏',
    '1f34e': '🍎',
    '1f350': '🍐',
    '1f34a': '🍊',
    '1f34b': '🍋',
    '1f34c': '🍌',
    '1f349': '🍉',
    '1f347': '🍇',
    '1f353': '🍓',
    '1f348': '🍈',
    '1f352': '🍒',
    '1f351': '🍑',
    '1f34d': '🍍',
    '1f95d': '🥝',
    '1f951': '🥑',
    '1f345': '🍅',
    '1f346': '🍆',
    '1f952': '🥒',
    '1f955': '🥕',
    '1f33d': '🌽',
    '1f336': '🌶️',
    '1f954': '🥔',
    '1f360': '🍠',
    '1f330': '🌰',
    '1f95c': '🥜',
    '1f36f': '🍯',
    '1f950': '🥐',
    '1f35e': '🍞',
    '1f956': '🥖',
    '1f9c0': '🧀',
    '1f95a': '🥚',
    '1f373': '🍳',
    '1f953': '🥓',
    '1f95e': '🥞',
    '1f364': '🍤',
    '1f357': '🍗',
    '1f356': '🍖',
    '1f355': '🍕',
    '1f32d': '🌭',
    '1f354': '🍔',
    '1f35f': '🍟',
    '1f959': '🥙',
    '1f32e': '🌮',
    '1f32f': '🌯',
    '1f957': '🥗',
    '1f958': '🥘',
    '1f35d': '🍝',
    '1f35c': '🍜',
    '1f372': '🍲',
    '1f365': '🍥',
    '1f363': '🍣',
    '1f371': '🍱',
    '1f35b': '🍛',
    '1f359': '🍙',
    '1f35a': '🍚',
    '1f358': '🍘',
    '1f362': '🍢',
    '1f361': '🍡',
    '1f367': '🍧',
    '1f368': '🍨',
    '1f366': '🍦',
    '1f370': '🍰',
    '1f382': '🎂',
    '1f36e': '🍮',
    '1f36d': '🍭',
    '1f36c': '🍬',
    '1f36b': '🍫',
    '1f37f': '🍿',
    '1f369': '🍩',
    '1f36a': '🍪',
    '1f95b': '🥛',
    '1f37c': '🍼',
    '2615': '☕',
    '1f375': '🍵',
    '1f376': '🍶',
    '1f37a': '🍺',
    '1f37b': '🍻',
    '1f942': '🥂',
    '1f377': '🍷',
    '1f943': '🥃',
    '1f378': '🍸',
    '1f379': '🍹',
    '1f37e': '🍾',
    '1f944': '🥄',
    '1f374': '🍴',
    '1f37d': '🍽️',
    '1f95f': '🥟',
    '1f960': '🥠',
    '1f961': '🥡',
    '1f962': '🥢',
    '1f963': '🥣',
    '1f964': '🥤',
    '1f965': '🥥',
    '1f966': '🥦',
    '1f967': '🥧',
    '1f968': '🥨',
    '1f969': '🥩',
    '1f96a': '🥪',
    '1f96b': '🥫',
    '26bd': '⚽',
    '1f3c0': '🏀',
    '1f3c8': '🏈',
    '26be': '⚾',
    '1f3be': '🎾',
    '1f3d0': '🏐',
    '1f3c9': '🏉',
    '1f3b1': '🎱',
    '1f3d3': '🏓',
    '1f3f8': '🏸',
    '1f945': '🥅',
    '1f3d2': '🏒',
    '1f3d1': '🏑',
    '1f3cf': '🏏',
    '26f3': '⛳',
    '1f3f9': '🏹',
    '1f3a3': '🎣',
    '1f94a': '🥊',
    '1f94b': '🥋',
    '26f8': '⛸️',
    '1f3bf': '🎿',
    '26f7': '⛷️',
    '1f3c2': '🏂',
    '1f3cb-fe0f-200d-2640-fe0f': '🏋️‍♀️',
    '1f3cb': '🏋️',
    '1f3cb-fe0f-200d-2642-fe0f': '🏋️‍♂️',
    '1f93a': '🤺',
    '1f93c-200d-2640-fe0f': '🤼‍♀️',
    '1f93c-200d-2642-fe0f': '🤼‍♂️',
    '1f93c': '🤼',
    '1f938-200d-2640-fe0f': '🤸‍♀️',
    '1f938-200d-2642-fe0f': '🤸‍♂️',
    '1f938': '🤸',
    '26f9-fe0f-200d-2640-fe0f': '⛹️‍♀️',
    '26f9': '⛹️',
    '26f9-fe0f-200d-2642-fe0f': '⛹️‍♂️',
    '1f93e-200d-2640-fe0f': '🤾‍♀️',
    '1f93e-200d-2642-fe0f': '🤾‍♂️',
    '1f93e': '🤾',
    '1f3cc-fe0f-200d-2640-fe0f': '🏌️‍♀️',
    '1f3cc': '🏌️',
    '1f3cc-fe0f-200d-2642-fe0f': '🏌️‍♂️',
    '1f3c4-200d-2640-fe0f': '🏄‍♀️',
    '1f3c4': '🏄',
    '1f3c4-200d-2642-fe0f': '🏄‍♂️',
    '1f3ca-200d-2640-fe0f': '🏊‍♀️',
    '1f3ca': '🏊',
    '1f3ca-200d-2642-fe0f': '🏊‍♂️',
    '1f93d-200d-2640-fe0f': '🤽‍♀️',
    '1f93d-200d-2642-fe0f': '🤽‍♂️',
    '1f93d': '🤽',
    '1f6a3-200d-2640-fe0f': '🚣‍♀️',
    '1f6a3': '🚣',
    '1f6a3-200d-2642-fe0f': '🚣‍♂️',
    '1f3c7': '🏇',
    '1f6b4-200d-2640-fe0f': '🚴‍♀️',
    '1f6b4': '🚴',
    '1f6b4-200d-2642-fe0f': '🚴‍♂️',
    '1f6b5-200d-2640-fe0f': '🚵‍♀️',
    '1f6b5': '🚵',
    '1f6b5-200d-2642-fe0f': '🚵‍♂️',
    '1f3bd': '🎽',
    '1f3c5': '🏅',
    '1f396': '🎖️',
    '1f947': '🥇',
    '1f948': '🥈',
    '1f949': '🥉',
    '1f3c6': '🏆',
    '1f3f5': '🏵️',
    '1f397': '🎗️',
    '1f3ab': '🎫',
    '1f39f': '🎟️',
    '1f3aa': '🎪',
    '1f939-200d-2640-fe0f': '🤹‍♀️',
    '1f939-200d-2642-fe0f': '🤹‍♂️',
    '1f939': '🤹',
    '1f3ad': '🎭',
    '1f3a8': '🎨',
    '1f3ac': '🎬',
    '1f3a4': '🎤',
    '1f3a7': '🎧',
    '1f3bc': '🎼',
    '1f3b9': '🎹',
    '1f941': '🥁',
    '1f3b7': '🎷',
    '1f3ba': '🎺',
    '1f3b8': '🎸',
    '1f3bb': '🎻',
    '1f3b2': '🎲',
    '1f3af': '🎯',
    '1f3b3': '🎳',
    '1f3ae': '🎮',
    '1f3b0': '🎰',
    '1f6f7': '🛷',
    '1f931': '🤱',
    '1f94c': '🥌',
    '1f9d6': '🧖',
    '1f9d7': '🧗',
    '1f9d8': '🧘',
    '1f9d6-200d-2640-fe0f': '🧖‍♀️',
    '1f9d6-200d-2642-fe0f': '🧖‍♂️',
    '1f9d7-200d-2640-fe0f': '🧗‍♀️',
    '1f9d7-200d-2642-fe0f': '🧗‍♂️',
    '1f9d8-200d-2640-fe0f': '🧘‍♀️',
    '1f9d8-200d-2642-fe0f': '🧘‍♂️',
    '1f697': '🚗',
    '1f695': '🚕',
    '1f699': '🚙',
    '1f68c': '🚌',
    '1f68e': '🚎',
    '1f3ce': '🏎️',
    '1f693': '🚓',
    '1f691': '🚑',
    '1f692': '🚒',
    '1f690': '🚐',
    '1f69a': '🚚',
    '1f69b': '🚛',
    '1f69c': '🚜',
    '1f6f4': '🛴',
    '1f6b2': '🚲',
    '1f6f5': '🛵',
    '1f3cd': '🏍️',
    '1f6a8': '🚨',
    '1f694': '🚔',
    '1f68d': '🚍',
    '1f698': '🚘',
    '1f696': '🚖',
    '1f6a1': '🚡',
    '1f6a0': '🚠',
    '1f69f': '🚟',
    '1f683': '🚃',
    '1f68b': '🚋',
    '1f69e': '🚞',
    '1f69d': '🚝',
    '1f684': '🚄',
    '1f685': '🚅',
    '1f688': '🚈',
    '1f682': '🚂',
    '1f686': '🚆',
    '1f687': '🚇',
    '1f68a': '🚊',
    '1f689': '🚉',
    '1f681': '🚁',
    '1f6e9': '🛩️',
    '2708': '✈️',
    '1f6eb': '🛫',
    '1f6ec': '🛬',
    '1f680': '🚀',
    '1f6f0': '🛰️',
    '1f4ba': '💺',
    '1f6f6': '🛶',
    '26f5': '⛵',
    '1f6e5': '🛥️',
    '1f6a4': '🚤',
    '1f6f3': '🛳️',
    '26f4': '⛴️',
    '1f6a2': '🚢',
    '2693': '⚓',
    '1f6a7': '🚧',
    '26fd': '⛽',
    '1f68f': '🚏',
    '1f6a6': '🚦',
    '1f6a5': '🚥',
    '1f5fa': '🗺️',
    '1f5ff': '🗿',
    '1f5fd': '🗽',
    '26f2': '⛲',
    '1f5fc': '🗼',
    '1f3f0': '🏰',
    '1f3ef': '🏯',
    '1f3df': '🏟️',
    '1f3a1': '🎡',
    '1f3a2': '🎢',
    '1f3a0': '🎠',
    '26f1': '⛱️',
    '1f3d6': '🏖️',
    '1f3dd': '🏝️',
    '26f0': '⛰️',
    '1f3d4': '🏔️',
    '1f5fb': '🗻',
    '1f30b': '🌋',
    '1f3dc': '🏜️',
    '1f3d5': '🏕️',
    '26fa': '⛺',
    '1f6e4': '🛤️',
    '1f6e3': '🛣️',
    '1f3d7': '🏗️',
    '1f3ed': '🏭',
    '1f3e0': '🏠',
    '1f3e1': '🏡',
    '1f3d8': '🏘️',
    '1f3da': '🏚️',
    '1f3e2': '🏢',
    '1f3ec': '🏬',
    '1f3e3': '🏣',
    '1f3e4': '🏤',
    '1f3e5': '🏥',
    '1f3e6': '🏦',
    '1f3e8': '🏨',
    '1f3ea': '🏪',
    '1f3eb': '🏫',
    '1f3e9': '🏩',
    '1f492': '💒',
    '1f3db': '🏛️',
    '26ea': '⛪',
    '1f54c': '🕌',
    '1f54d': '🕍',
    '1f54b': '🕋',
    '26e9': '⛩️',
    '1f5fe': '🗾',
    '1f391': '🎑',
    '1f3de': '🏞️',
    '1f305': '🌅',
    '1f304': '🌄',
    '1f320': '🌠',
    '1f387': '🎇',
    '1f386': '🎆',
    '1f307': '🌇',
    '1f306': '🌆',
    '1f3d9': '🏙️',
    '1f303': '🌃',
    '1f30c': '🌌',
    '1f309': '🌉',
    '1f301': '🌁',
    '1f6f8': '🛸',
    '231a': '⌚',
    '1f4f1': '📱',
    '1f4f2': '📲',
    '1f4bb': '💻',
    '2328': '⌨️',
    '1f5a5': '🖥️',
    '1f5a8': '🖨️',
    '1f5b1': '🖱️',
    '1f5b2': '🖲️',
    '1f579': '🕹️',
    '1f5dc': '🗜️',
    '1f4bd': '💽',
    '1f4be': '💾',
    '1f4bf': '💿',
    '1f4c0': '📀',
    '1f4fc': '📼',
    '1f4f7': '📷',
    '1f4f8': '📸',
    '1f4f9': '📹',
    '1f3a5': '🎥',
    '1f4fd': '📽️',
    '1f39e': '🎞️',
    '1f4de': '📞',
    '260e': '☎️',
    '1f4df': '📟',
    '1f4e0': '📠',
    '1f4fa': '📺',
    '1f4fb': '📻',
    '1f399': '🎙️',
    '1f39a': '🎚️',
    '1f39b': '🎛️',
    '23f1': '⏱️',
    '23f2': '⏲️',
    '23f0': '⏰',
    '1f570': '🕰️',
    '231b': '⌛',
    '23f3': '⏳',
    '1f4e1': '📡',
    '1f50b': '🔋',
    '1f50c': '🔌',
    '1f4a1': '💡',
    '1f526': '🔦',
    '1f56f': '🕯️',
    '1f5d1': '🗑️',
    '1f6e2': '🛢️',
    '1f4b8': '💸',
    '1f4b5': '💵',
    '1f4b4': '💴',
    '1f4b6': '💶',
    '1f4b7': '💷',
    '1f4b0': '💰',
    '1f4b3': '💳',
    '1f48e': '💎',
    '2696': '⚖️',
    '1f527': '🔧',
    '1f528': '🔨',
    '2692': '⚒️',
    '1f6e0': '🛠️',
    '26cf': '⛏️',
    '1f529': '🔩',
    '2699': '⚙️',
    '26d3': '⛓️',
    '1f52b': '🔫',
    '1f4a3': '💣',
    '1f52a': '🔪',
    '1f5e1': '🗡️',
    '2694': '⚔️',
    '1f6e1': '🛡️',
    '1f6ac': '🚬',
    '26b0': '⚰️',
    '26b1': '⚱️',
    '1f3fa': '🏺',
    '1f52e': '🔮',
    '1f4ff': '📿',
    '1f488': '💈',
    '2697': '⚗️',
    '1f52d': '🔭',
    '1f52c': '🔬',
    '1f573': '🕳️',
    '1f48a': '💊',
    '1f489': '💉',
    '1f321': '🌡️',
    '1f6bd': '🚽',
    '1f6b0': '🚰',
    '1f6bf': '🚿',
    '1f6c1': '🛁',
    '1f6c0': '🛀',
    '1f6ce': '🛎️',
    '1f511': '🔑',
    '1f5dd': '🗝️',
    '1f6aa': '🚪',
    '1f6cb': '🛋️',
    '1f6cf': '🛏️',
    '1f6cc': '🛌',
    '1f5bc': '🖼️',
    '1f6cd': '🛍️',
    '1f6d2': '🛒',
    '1f381': '🎁',
    '1f388': '🎈',
    '1f38f': '🎏',
    '1f380': '🎀',
    '1f38a': '🎊',
    '1f389': '🎉',
    '1f38e': '🎎',
    '1f3ee': '🏮',
    '1f390': '🎐',
    '2709': '✉️',
    '1f4e9': '📩',
    '1f4e8': '📨',
    '1f4e7': '📧',
    '1f48c': '💌',
    '1f4e5': '📥',
    '1f4e4': '📤',
    '1f4e6': '📦',
    '1f3f7': '🏷️',
    '1f4ea': '📪',
    '1f4eb': '📫',
    '1f4ec': '📬',
    '1f4ed': '📭',
    '1f4ee': '📮',
    '1f4ef': '📯',
    '1f4dc': '📜',
    '1f4c3': '📃',
    '1f4c4': '📄',
    '1f4d1': '📑',
    '1f4ca': '📊',
    '1f4c8': '📈',
    '1f4c9': '📉',
    '1f5d2': '🗒️',
    '1f5d3': '🗓️',
    '1f4c6': '📆',
    '1f4c5': '📅',
    '1f4c7': '📇',
    '1f5c3': '🗃️',
    '1f5f3': '🗳️',
    '1f5c4': '🗄️',
    '1f4cb': '📋',
    '1f4c1': '📁',
    '1f4c2': '📂',
    '1f5c2': '🗂️',
    '1f5de': '🗞️',
    '1f4f0': '📰',
    '1f4d3': '📓',
    '1f4d4': '📔',
    '1f4d2': '📒',
    '1f4d5': '📕',
    '1f4d7': '📗',
    '1f4d8': '📘',
    '1f4d9': '📙',
    '1f4da': '📚',
    '1f4d6': '📖',
    '1f516': '🔖',
    '1f517': '🔗',
    '1f4ce': '📎',
    '1f587': '🖇️',
    '1f4d0': '📐',
    '1f4cf': '📏',
    '1f4cc': '📌',
    '1f4cd': '📍',
    '2702': '✂️',
    '1f58a': '🖊️',
    '1f58b': '🖋️',
    '2712': '✒️',
    '1f58c': '🖌️',
    '1f58d': '🖍️',
    '1f4dd': '📝',
    '270f': '✏️',
    '1f50d': '🔍',
    '1f50e': '🔎',
    '1f50f': '🔏',
    '1f510': '🔐',
    '1f512': '🔒',
    '1f513': '🔓',
    '1f9e1': '🧡',
    '2764': '❤️',
    '1f49b': '💛',
    '1f49a': '💚',
    '1f499': '💙',
    '1f49c': '💜',
    '1f5a4': '🖤',
    '1f494': '💔',
    '2763': '❣️',
    '1f495': '💕',
    '1f49e': '💞',
    '1f493': '💓',
    '1f497': '💗',
    '1f496': '💖',
    '1f498': '💘',
    '1f49d': '💝',
    '1f49f': '💟',
    '262e': '☮️',
    '271d': '✝️',
    '262a': '☪️',
    '1f549': '🕉️',
    '2638': '☸️',
    '2721': '✡️',
    '1f52f': '🔯',
    '1f54e': '🕎',
    '262f': '☯️',
    '2626': '☦️',
    '1f6d0': '🛐',
    '26ce': '⛎',
    '2648': '♈',
    '2649': '♉',
    '264a': '♊',
    '264b': '♋',
    '264c': '♌',
    '264d': '♍',
    '264e': '♎',
    '264f': '♏',
    '2650': '♐',
    '2651': '♑',
    '2652': '♒',
    '2653': '♓',
    '1f194': '🆔',
    '269b': '⚛️',
    '1f251': '🉑',
    '2622': '☢️',
    '2623': '☣️',
    '1f4f4': '📴',
    '1f4f3': '📳',
    '1f236': '🈶',
    '1f21a': '🈚',
    '1f238': '🈸',
    '1f23a': '🈺',
    '1f237': '🈷️',
    '2734': '✴️',
    '1f19a': '🆚',
    '1f4ae': '💮',
    '1f250': '🉐',
    '3299': '㊙️',
    '3297': '㊗️',
    '1f234': '🈴',
    '1f235': '🈵',
    '1f239': '🈹',
    '1f232': '🈲',
    '1f170': '🅰️',
    '1f171': '🅱️',
    '1f18e': '🆎',
    '1f191': '🆑',
    '1f17e': '🅾️',
    '1f198': '🆘',
    '274c': '❌',
    '2b55': '⭕',
    '1f6d1': '🛑',
    '26d4': '⛔',
    '1f4db': '📛',
    '1f6ab': '🚫',
    '1f4af': '💯',
    '1f4a2': '💢',
    '2668': '♨️',
    '1f6b7': '🚷',
    '1f6af': '🚯',
    '1f6b3': '🚳',
    '1f6b1': '🚱',
    '1f51e': '🔞',
    '1f4f5': '📵',
    '1f6ad': '🚭',
    '2757': '❗',
    '2755': '❕',
    '2753': '❓',
    '2754': '❔',
    '203c': '‼️',
    '2049': '⁉️',
    '1f505': '🔅',
    '1f506': '🔆',
    '303d': '〽️',
    '26a0': '⚠️',
    '1f6b8': '🚸',
    '1f531': '🔱',
    '269c': '⚜️',
    '1f530': '🔰',
    '267b': '♻️',
    '2705': '✅',
    '1f22f': '🈯',
    '1f4b9': '💹',
    '2747': '❇️',
    '2733': '✳️',
    '274e': '❎',
    '1f310': '🌐',
    '1f4a0': '💠',
    '24c2': 'Ⓜ️',
    '1f300': '🌀',
    '1f4a4': '💤',
    '1f3e7': '🏧',
    '1f6be': '🚾',
    '267f': '♿',
    '1f17f': '🅿️',
    '1f233': '🈳',
    '1f202': '🈂️',
    '1f6c2': '🛂',
    '1f6c3': '🛃',
    '1f6c4': '🛄',
    '1f6c5': '🛅',
    '1f6b9': '🚹',
    '1f6ba': '🚺',
    '1f6bc': '🚼',
    '1f6bb': '🚻',
    '1f6ae': '🚮',
    '1f3a6': '🎦',
    '1f4f6': '📶',
    '1f201': '🈁',
    '1f523': '🔣',
    '2139': 'ℹ️',
    '1f524': '🔤',
    '1f521': '🔡',
    '1f520': '🔠',
    '1f196': '🆖',
    '1f197': '🆗',
    '1f199': '🆙',
    '1f192': '🆒',
    '1f195': '🆕',
    '1f193': '🆓',
    '30-20e3': '0️⃣',
    '31-20e3': '1️⃣',
    '32-20e3': '2️⃣',
    '33-20e3': '3️⃣',
    '34-20e3': '4️⃣',
    '35-20e3': '5️⃣',
    '36-20e3': '6️⃣',
    '37-20e3': '7️⃣',
    '38-20e3': '8️⃣',
    '39-20e3': '9️⃣',
    '1f51f': '🔟',
    '1f522': '🔢',
    '23-20e3': '#️⃣',
    '2a-20e3': '*️⃣',
    '25b6': '▶️',
    '23f8': '⏸️',
    '23ef': '⏯️',
    '23f9': '⏹️',
    '23fa': '⏺️',
    '23cf': '⏏️',
    '23ed': '⏭️',
    '23ee': '⏮️',
    '23e9': '⏩',
    '23ea': '⏪',
    '23eb': '⏫',
    '23ec': '⏬',
    '25c0': '◀️',
    '1f53c': '🔼',
    '1f53d': '🔽',
    '27a1': '➡️',
    '2b05': '⬅️',
    '2b06': '⬆️',
    '2b07': '⬇️',
    '2197': '↗️',
    '2198': '↘️',
    '2199': '↙️',
    '2196': '↖️',
    '2195': '↕️',
    '2194': '↔️',
    '21aa': '↪️',
    '21a9': '↩️',
    '2934': '⤴️',
    '2935': '⤵️',
    '1f500': '🔀',
    '1f501': '🔁',
    '1f502': '🔂',
    '1f504': '🔄',
    '1f503': '🔃',
    '1f3b5': '🎵',
    '1f3b6': '🎶',
    '2795': '➕',
    '2796': '➖',
    '2797': '➗',
    '2716': '✖️',
    '1f4b2': '💲',
    '1f4b1': '💱',
    '2122': '™️',
    a9: '©️',
    ae: '®️',
    '3030': '〰️',
    '27b0': '➰',
    '27bf': '➿',
    '1f51a': '🔚',
    '1f519': '🔙',
    '1f51b': '🔛',
    '1f51d': '🔝',
    '1f51c': '🔜',
    '2714': '✔️',
    '2611': '☑️',
    '1f518': '🔘',
    '26aa': '⚪',
    '26ab': '⚫',
    '1f534': '🔴',
    '1f535': '🔵',
    '1f53a': '🔺',
    '1f53b': '🔻',
    '1f538': '🔸',
    '1f539': '🔹',
    '1f536': '🔶',
    '1f537': '🔷',
    '1f533': '🔳',
    '1f532': '🔲',
    '25aa': '▪️',
    '25ab': '▫️',
    '25fe': '◾',
    '25fd': '◽',
    '25fc': '◼️',
    '25fb': '◻️',
    '2b1b': '⬛',
    '2b1c': '⬜',
    '1f508': '🔈',
    '1f507': '🔇',
    '1f509': '🔉',
    '1f50a': '🔊',
    '1f514': '🔔',
    '1f515': '🔕',
    '1f4e3': '📣',
    '1f4e2': '📢',
    '1f5e8': '🗨️',
    '1f441-fe0f-200d-1f5e8-fe0f': '👁️‍🗨️',
    '1f4ac': '💬',
    '1f4ad': '💭',
    '1f5ef': '🗯️',
    '2660': '♠️',
    '2663': '♣️',
    '2665': '♥️',
    '2666': '♦️',
    '1f0cf': '🃏',
    '1f3b4': '🎴',
    '1f004': '🀄',
    '1f550': '🕐',
    '1f551': '🕑',
    '1f552': '🕒',
    '1f553': '🕓',
    '1f554': '🕔',
    '1f555': '🕕',
    '1f556': '🕖',
    '1f557': '🕗',
    '1f558': '🕘',
    '1f559': '🕙',
    '1f55a': '🕚',
    '1f55b': '🕛',
    '1f55c': '🕜',
    '1f55d': '🕝',
    '1f55e': '🕞',
    '1f55f': '🕟',
    '1f560': '🕠',
    '1f561': '🕡',
    '1f562': '🕢',
    '1f563': '🕣',
    '1f564': '🕤',
    '1f565': '🕥',
    '1f566': '🕦',
    '1f567': '🕧',
    '1f3f3': '🏳️',
    '1f3f4': '🏴',
    '1f3c1': '🏁',
    '1f6a9': '🚩',
    '1f3f3-fe0f-200d-1f308': '🏳️‍🌈',
    '1f1e6-1f1eb': '🇦🇫',
    '1f1e6-1f1fd': '🇦🇽',
    '1f1e6-1f1f1': '🇦🇱',
    '1f1e9-1f1ff': '🇩🇿',
    '1f1e6-1f1f8': '🇦🇸',
    '1f1e6-1f1e9': '🇦🇩',
    '1f1e6-1f1f4': '🇦🇴',
    '1f1e6-1f1ee': '🇦🇮',
    '1f1e6-1f1f6': '🇦🇶',
    '1f1e6-1f1ec': '🇦🇬',
    '1f1e6-1f1f7': '🇦🇷',
    '1f1e6-1f1f2': '🇦🇲',
    '1f1e6-1f1fc': '🇦🇼',
    '1f1e6-1f1fa': '🇦🇺',
    '1f1e6-1f1f9': '🇦🇹',
    '1f1e6-1f1ff': '🇦🇿',
    '1f1e7-1f1f8': '🇧🇸',
    '1f1e7-1f1ed': '🇧🇭',
    '1f1e7-1f1e9': '🇧🇩',
    '1f1e7-1f1e7': '🇧🇧',
    '1f1e7-1f1fe': '🇧🇾',
    '1f1e7-1f1ea': '🇧🇪',
    '1f1e7-1f1ff': '🇧🇿',
    '1f1e7-1f1ef': '🇧🇯',
    '1f1e7-1f1f2': '🇧🇲',
    '1f1e7-1f1f9': '🇧🇹',
    '1f1e7-1f1f4': '🇧🇴',
    '1f1e7-1f1e6': '🇧🇦',
    '1f1e7-1f1fc': '🇧🇼',
    '1f1e7-1f1f7': '🇧🇷',
    '1f1ee-1f1f4': '🇮🇴',
    '1f1fb-1f1ec': '🇻🇬',
    '1f1e7-1f1f3': '🇧🇳',
    '1f1e7-1f1ec': '🇧🇬',
    '1f1e7-1f1eb': '🇧🇫',
    '1f1e7-1f1ee': '🇧🇮',
    '1f1f0-1f1ed': '🇰🇭',
    '1f1e8-1f1f2': '🇨🇲',
    '1f1e8-1f1e6': '🇨🇦',
    '1f1ee-1f1e8': '🇮🇨',
    '1f1e8-1f1fb': '🇨🇻',
    '1f1e7-1f1f6': '🇧🇶',
    '1f1f0-1f1fe': '🇰🇾',
    '1f1e8-1f1eb': '🇨🇫',
    '1f1f9-1f1e9': '🇹🇩',
    '1f1e8-1f1f1': '🇨🇱',
    '1f1e8-1f1f3': '🇨🇳',
    '1f1e8-1f1fd': '🇨🇽',
    '1f1e8-1f1e8': '🇨🇨',
    '1f1e8-1f1f4': '🇨🇴',
    '1f1f0-1f1f2': '🇰🇲',
    '1f1e8-1f1ec': '🇨🇬',
    '1f1e8-1f1e9': '🇨🇩',
    '1f1e8-1f1f0': '🇨🇰',
    '1f1e8-1f1f7': '🇨🇷',
    '1f1e8-1f1ee': '🇨🇮',
    '1f1ed-1f1f7': '🇭🇷',
    '1f1e8-1f1fa': '🇨🇺',
    '1f1e8-1f1fc': '🇨🇼',
    '1f1e8-1f1fe': '🇨🇾',
    '1f1e8-1f1ff': '🇨🇿',
    '1f1e9-1f1f0': '🇩🇰',
    '1f1e9-1f1ef': '🇩🇯',
    '1f1e9-1f1f2': '🇩🇲',
    '1f1e9-1f1f4': '🇩🇴',
    '1f1ea-1f1e8': '🇪🇨',
    '1f1ea-1f1ec': '🇪🇬',
    '1f1f8-1f1fb': '🇸🇻',
    '1f1ec-1f1f6': '🇬🇶',
    '1f1ea-1f1f7': '🇪🇷',
    '1f1ea-1f1ea': '🇪🇪',
    '1f1ea-1f1f9': '🇪🇹',
    '1f1ea-1f1fa': '🇪🇺',
    '1f1eb-1f1f0': '🇫🇰',
    '1f1eb-1f1f4': '🇫🇴',
    '1f1eb-1f1ef': '🇫🇯',
    '1f1eb-1f1ee': '🇫🇮',
    '1f1eb-1f1f7': '🇫🇷',
    '1f1ec-1f1eb': '🇬🇫',
    '1f1f5-1f1eb': '🇵🇫',
    '1f1f9-1f1eb': '🇹🇫',
    '1f1ec-1f1e6': '🇬🇦',
    '1f1ec-1f1f2': '🇬🇲',
    '1f1ec-1f1ea': '🇬🇪',
    '1f1e9-1f1ea': '🇩🇪',
    '1f1ec-1f1ed': '🇬🇭',
    '1f1ec-1f1ee': '🇬🇮',
    '1f1ec-1f1f7': '🇬🇷',
    '1f1ec-1f1f1': '🇬🇱',
    '1f1ec-1f1e9': '🇬🇩',
    '1f1ec-1f1f5': '🇬🇵',
    '1f1ec-1f1fa': '🇬🇺',
    '1f1ec-1f1f9': '🇬🇹',
    '1f1ec-1f1ec': '🇬🇬',
    '1f1ec-1f1f3': '🇬🇳',
    '1f1ec-1f1fc': '🇬🇼',
    '1f1ec-1f1fe': '🇬🇾',
    '1f1ed-1f1f9': '🇭🇹',
    '1f1ed-1f1f3': '🇭🇳',
    '1f1ed-1f1f0': '🇭🇰',
    '1f1ed-1f1fa': '🇭🇺',
    '1f1ee-1f1f8': '🇮🇸',
    '1f1ee-1f1f3': '🇮🇳',
    '1f1ee-1f1e9': '🇮🇩',
    '1f1ee-1f1f7': '🇮🇷',
    '1f1ee-1f1f6': '🇮🇶',
    '1f1ee-1f1ea': '🇮🇪',
    '1f1ee-1f1f2': '🇮🇲',
    '1f1ee-1f1f1': '🇮🇱',
    '1f1ee-1f1f9': '🇮🇹',
    '1f1ef-1f1f2': '🇯🇲',
    '1f1ef-1f1f5': '🇯🇵',
    '1f38c': '🎌',
    '1f1ef-1f1ea': '🇯🇪',
    '1f1ef-1f1f4': '🇯🇴',
    '1f1f0-1f1ff': '🇰🇿',
    '1f1f0-1f1ea': '🇰🇪',
    '1f1f0-1f1ee': '🇰🇮',
    '1f1fd-1f1f0': '🇽🇰',
    '1f1f0-1f1fc': '🇰🇼',
    '1f1f0-1f1ec': '🇰🇬',
    '1f1f1-1f1e6': '🇱🇦',
    '1f1f1-1f1fb': '🇱🇻',
    '1f1f1-1f1e7': '🇱🇧',
    '1f1f1-1f1f8': '🇱🇸',
    '1f1f1-1f1f7': '🇱🇷',
    '1f1f1-1f1fe': '🇱🇾',
    '1f1f1-1f1ee': '🇱🇮',
    '1f1f1-1f1f9': '🇱🇹',
    '1f1f1-1f1fa': '🇱🇺',
    '1f1f2-1f1f4': '🇲🇴',
    '1f1f2-1f1f0': '🇲🇰',
    '1f1f2-1f1ec': '🇲🇬',
    '1f1f2-1f1fc': '🇲🇼',
    '1f1f2-1f1fe': '🇲🇾',
    '1f1f2-1f1fb': '🇲🇻',
    '1f1f2-1f1f1': '🇲🇱',
    '1f1f2-1f1f9': '🇲🇹',
    '1f1f2-1f1ed': '🇲🇭',
    '1f1f2-1f1f6': '🇲🇶',
    '1f1f2-1f1f7': '🇲🇷',
    '1f1f2-1f1fa': '🇲🇺',
    '1f1fe-1f1f9': '🇾🇹',
    '1f1f2-1f1fd': '🇲🇽',
    '1f1eb-1f1f2': '🇫🇲',
    '1f1f2-1f1e9': '🇲🇩',
    '1f1f2-1f1e8': '🇲🇨',
    '1f1f2-1f1f3': '🇲🇳',
    '1f1f2-1f1ea': '🇲🇪',
    '1f1f2-1f1f8': '🇲🇸',
    '1f1f2-1f1e6': '🇲🇦',
    '1f1f2-1f1ff': '🇲🇿',
    '1f1f2-1f1f2': '🇲🇲',
    '1f1f3-1f1e6': '🇳🇦',
    '1f1f3-1f1f7': '🇳🇷',
    '1f1f3-1f1f5': '🇳🇵',
    '1f1f3-1f1f1': '🇳🇱',
    '1f1f3-1f1e8': '🇳🇨',
    '1f1f3-1f1ff': '🇳🇿',
    '1f1f3-1f1ee': '🇳🇮',
    '1f1f3-1f1ea': '🇳🇪',
    '1f1f3-1f1ec': '🇳🇬',
    '1f1f3-1f1fa': '🇳🇺',
    '1f1f3-1f1eb': '🇳🇫',
    '1f1f0-1f1f5': '🇰🇵',
    '1f1f2-1f1f5': '🇲🇵',
    '1f1f3-1f1f4': '🇳🇴',
    '1f1f4-1f1f2': '🇴🇲',
    '1f1f5-1f1f0': '🇵🇰',
    '1f1f5-1f1fc': '🇵🇼',
    '1f1f5-1f1f8': '🇵🇸',
    '1f1f5-1f1e6': '🇵🇦',
    '1f1f5-1f1ec': '🇵🇬',
    '1f1f5-1f1fe': '🇵🇾',
    '1f1f5-1f1ea': '🇵🇪',
    '1f1f5-1f1ed': '🇵🇭',
    '1f1f5-1f1f3': '🇵🇳',
    '1f1f5-1f1f1': '🇵🇱',
    '1f1f5-1f1f9': '🇵🇹',
    '1f1f5-1f1f7': '🇵🇷',
    '1f1f6-1f1e6': '🇶🇦',
    '1f1f7-1f1ea': '🇷🇪',
    '1f1f7-1f1f4': '🇷🇴',
    '1f1f7-1f1fa': '🇷🇺',
    '1f1f7-1f1fc': '🇷🇼',
    '1f1fc-1f1f8': '🇼🇸',
    '1f1f8-1f1f2': '🇸🇲',
    '1f1f8-1f1f9': '🇸🇹',
    '1f1f8-1f1e6': '🇸🇦',
    '1f1f8-1f1f3': '🇸🇳',
    '1f1f7-1f1f8': '🇷🇸',
    '1f1f8-1f1e8': '🇸🇨',
    '1f1f8-1f1f1': '🇸🇱',
    '1f1f8-1f1ec': '🇸🇬',
    '1f1f8-1f1fd': '🇸🇽',
    '1f1f8-1f1f0': '🇸🇰',
    '1f1f8-1f1ee': '🇸🇮',
    '1f1ec-1f1f8': '🇬🇸',
    '1f1f8-1f1e7': '🇸🇧',
    '1f1f8-1f1f4': '🇸🇴',
    '1f1ff-1f1e6': '🇿🇦',
    '1f1f0-1f1f7': '🇰🇷',
    '1f1f8-1f1f8': '🇸🇸',
    '1f1ea-1f1f8': '🇪🇸',
    '1f1f1-1f1f0': '🇱🇰',
    '1f1e7-1f1f1': '🇧🇱',
    '1f1f8-1f1ed': '🇸🇭',
    '1f1f0-1f1f3': '🇰🇳',
    '1f1f1-1f1e8': '🇱🇨',
    '1f1f5-1f1f2': '🇵🇲',
    '1f1fb-1f1e8': '🇻🇨',
    '1f1f8-1f1e9': '🇸🇩',
    '1f1f8-1f1f7': '🇸🇷',
    '1f1f8-1f1ff': '🇸🇿',
    '1f1f8-1f1ea': '🇸🇪',
    '1f1e8-1f1ed': '🇨🇭',
    '1f1f8-1f1fe': '🇸🇾',
    '1f1f9-1f1fc': '🇹🇼',
    '1f1f9-1f1ef': '🇹🇯',
    '1f1f9-1f1ff': '🇹🇿',
    '1f1f9-1f1ed': '🇹🇭',
    '1f1f9-1f1f1': '🇹🇱',
    '1f1f9-1f1ec': '🇹🇬',
    '1f1f9-1f1f0': '🇹🇰',
    '1f1f9-1f1f4': '🇹🇴',
    '1f1f9-1f1f9': '🇹🇹',
    '1f1f9-1f1f3': '🇹🇳',
    '1f1f9-1f1f7': '🇹🇷',
    '1f1f9-1f1f2': '🇹🇲',
    '1f1f9-1f1e8': '🇹🇨',
    '1f1f9-1f1fb': '🇹🇻',
    '1f1fb-1f1ee': '🇻🇮',
    '1f1fa-1f1ec': '🇺🇬',
    '1f1fa-1f1e6': '🇺🇦',
    '1f1e6-1f1ea': '🇦🇪',
    '1f1ec-1f1e7': '🇬🇧',
    '1f1fa-1f1f8': '🇺🇸',
    '1f1fa-1f1fe': '🇺🇾',
    '1f1fa-1f1ff': '🇺🇿',
    '1f1fb-1f1fa': '🇻🇺',
    '1f1fb-1f1e6': '🇻🇦',
    '1f1fb-1f1ea': '🇻🇪',
    '1f1fb-1f1f3': '🇻🇳',
    '1f1fc-1f1eb': '🇼🇫',
    '1f1ea-1f1ed': '🇪🇭',
    '1f1fe-1f1ea': '🇾🇪',
    '1f1ff-1f1f2': '🇿🇲',
    '1f1ff-1f1fc': '🇿🇼',
    '1f1e6-1f1e8': '🇦🇨',
    '1f1f9-1f1e6': '🇹🇦',
    '1f1e7-1f1fb': '🇧🇻',
    '1f1ed-1f1f2': '🇭🇲',
    '1f1f8-1f1ef': '🇸🇯',
    '1f1fa-1f1f2': '🇺🇲',
    '1f1ea-1f1e6': '🇪🇦',
    '1f1e8-1f1f5': '🇨🇵',
    '1f1e9-1f1ec': '🇩🇬',
    '1f1f2-1f1eb': '🇲🇫',
    '1f1fa-1f1f3': '🇺🇳',
    '1f3f4-e0067-e0062-e0065-e006e-e0067-e007f': '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
    '1f3f4-e0067-e0062-e0073-e0063-e0074-e007f': '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
    '1f3f4-e0067-e0062-e0077-e006c-e0073-e007f': '🏴󠁧󠁢󠁷󠁬󠁳󠁿',
    '1f1ff': '🇿',
    '1f1fe': '🇾',
    '1f1fd': '🇽',
    '1f3fb': '🏻',
    '1f3fc': '🏼',
    '1f3fd': '🏽',
    '1f3fe': '🏾',
    '1f3ff': '🏿',
    '1f1fc': '🇼',
    '1f1fb': '🇻',
    '1f1fa': '🇺',
    '1f1f9': '🇹',
    '1f1f8': '🇸',
    '1f1f7': '🇷',
    '1f1f6': '🇶',
    '1f1f5': '🇵',
    '1f1f4': '🇴',
    '1f1f3': '🇳',
    '1f1f2': '🇲',
    '1f1f1': '🇱',
    '1f1f0': '🇰',
    '1f1ef': '🇯',
    '1f1ee': '🇮',
    '1f1ed': '🇭',
    '1f1ec': '🇬',
    '1f1eb': '🇫',
    '1f1ea': '🇪',
    '1f1e9': '🇩',
    '1f1e8': '🇨',
    '1f1e7': '🇧',
    '1f1e6': '🇦',
    '2640': '♀️',
    '2642': '♂️',
    '2695': '⚕️',
    '1f468-200d-1f469-200d-1f466': '👨‍👩‍👦',
    '1f469-200d-2764-fe0f-200d-1f468': '👩‍❤️‍👨',
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f468': '👩‍❤️‍💋‍👨',
    '1f928': '🤨',
    '1f929': '🤩',
    '1f92a': '🤪',
    '1f92b': '🤫',
    '1f92c': '🤬',
    '1f92d': '🤭',
    '1f92e': '🤮',
    '1f92f': '🤯',
    '1f9d0': '🧐',
    '1f9d1': '🧑',
    '1f9d2': '🧒',
    '1f9d3': '🧓',
    '1f9d4': '🧔',
    '1f9d5': '🧕',
    '1f9e0': '🧠',
    '1f9e2': '🧢',
    '1f9d9': '🧙',
    '1f9da': '🧚',
    '1f9db': '🧛',
    '1f9dc': '🧜',
    '1f9dd': '🧝',
    '1f9de': '🧞',
    '1f9df': '🧟',
    '1f9e3': '🧣',
    '1f9e4': '🧤',
    '1f9e5': '🧥',
    '1f9e6': '🧦',
    '1f91f': '🤟',
    '1f932': '🤲',
    '1f9d9-200d-2640-fe0f': '🧙‍♀️',
    '1f9d9-200d-2642-fe0f': '🧙‍♂️',
    '1f9da-200d-2640-fe0f': '🧚‍♀️',
    '1f9da-200d-2642-fe0f': '🧚‍♂️',
    '1f9db-200d-2640-fe0f': '🧛‍♀️',
    '1f9db-200d-2642-fe0f': '🧛‍♂️',
    '1f9dc-200d-2640-fe0f': '🧜‍♀️',
    '1f9dc-200d-2642-fe0f': '🧜‍♂️',
    '1f9dd-200d-2640-fe0f': '🧝‍♀️',
    '1f9dd-200d-2642-fe0f': '🧝‍♂️',
    '1f9de-200d-2640-fe0f': '🧞‍♀️',
    '1f9de-200d-2642-fe0f': '🧞‍♂️',
    '1f9df-200d-2640-fe0f': '🧟‍♀️',
    '1f9df-200d-2642-fe0f': '🧟‍♂️',
    'atlassian-check_mark': '(/)',
    'atlassian-cross_mark': '(x)',
    'atlassian-plus': '(+)',
    'atlassian-minus': '(-)',
    'atlassian-light_bulb_on': '(on)',
    'atlassian-light_bulb_off': '(off)',
    'atlassian-flag_on': '(flag)',
    'atlassian-flag_off': '(flagoff)',
    'atlassian-warning': '(!)',
    'atlassian-question_mark': '(?)',
    'atlassian-info': '(i)',
    'atlassian-yellow_star': '(*y)',
    'atlassian-blue_star': '(*b)',
    'atlassian-green_star': '(*g)',
    'atlassian-red_star': '(*r)',
};
//# sourceMappingURL=emoji-unicode-mapping.js.map

/***/ }),
/* 2837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hardBreak; });
var hardBreak = function (node) {
    return '\n';
};
//# sourceMappingURL=hard-break.js.map

/***/ }),
/* 2838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mention; });
var mention = function (node) {
    return "[~" + node.attrs.id + "]";
};
//# sourceMappingURL=mention.js.map

/***/ }),
/* 2839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return text; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__marks_code__ = __webpack_require__(2840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__marks_color__ = __webpack_require__(2841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__marks_em__ = __webpack_require__(2842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__marks_link__ = __webpack_require__(2843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__marks_strike__ = __webpack_require__(2844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__marks_strong__ = __webpack_require__(2845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__marks_subsup__ = __webpack_require__(2846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__marks_underline__ = __webpack_require__(2847);








/**
 * The order of the mapping matters.
 * For example, textColor will be a macro {color} so
 * we want to process other marks before it.
 */
var markEncoderMapping = new Map([
    ['em', __WEBPACK_IMPORTED_MODULE_2__marks_em__["a" /* em */]],
    ['strike', __WEBPACK_IMPORTED_MODULE_4__marks_strike__["a" /* strike */]],
    ['strong', __WEBPACK_IMPORTED_MODULE_5__marks_strong__["a" /* strong */]],
    ['subsup', __WEBPACK_IMPORTED_MODULE_6__marks_subsup__["a" /* subsup */]],
    ['underline', __WEBPACK_IMPORTED_MODULE_7__marks_underline__["a" /* underline */]],
    ['textColor', __WEBPACK_IMPORTED_MODULE_1__marks_color__["a" /* textColor */]],
    ['link', __WEBPACK_IMPORTED_MODULE_3__marks_link__["a" /* link */]],
    ['code', __WEBPACK_IMPORTED_MODULE_0__marks_code__["a" /* code */]],
]);
var text = function (node, parent) {
    var result = parent && parent.type.name === 'codeBlock'
        ? node.text
        : escapingWikiFormatter(node.text);
    markEncoderMapping.forEach(function (encoder, markName) {
        var mark = node.marks.find(function (m) { return m.type.name === markName; });
        if (mark) {
            result = encoder(result, mark.attrs);
        }
    });
    return result;
};
function escapingWikiFormatter(text) {
    return text.replace(/[{\\![]/g, '\\$&');
}
//# sourceMappingURL=text.js.map

/***/ }),
/* 2840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return code; });
var code = function (text) {
    return "{{" + text + "}}";
};
//# sourceMappingURL=code.js.map

/***/ }),
/* 2841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return textColor; });
var textColor = function (text, attrs) {
    return "{color:" + attrs.color + "}" + text + "{color}";
};
//# sourceMappingURL=color.js.map

/***/ }),
/* 2842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return em; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(225);

var em = function (text) {
    if (text.startsWith('— ')) {
        // This is a citation
        return Object(__WEBPACK_IMPORTED_MODULE_0__base__["a" /* baseMarkPattern */])(text.substring(2), '??');
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__base__["a" /* baseMarkPattern */])(text, '_');
};
//# sourceMappingURL=em.js.map

/***/ }),
/* 2843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return link; });
var link = function (text, attrs) {
    return "[" + text + "|" + attrs.href + "]";
};
//# sourceMappingURL=link.js.map

/***/ }),
/* 2844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return strike; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(225);

var strike = function (text) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__base__["a" /* baseMarkPattern */])(text, '-');
};
//# sourceMappingURL=strike.js.map

/***/ }),
/* 2845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return strong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(225);

/**
 * For text that has leading and ending space. We don't want to
 * convert it to `*strong *. Instead, we need it to be `*strong* `
 */
var strong = function (text) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__base__["a" /* baseMarkPattern */])(text, '*');
};
//# sourceMappingURL=strong.js.map

/***/ }),
/* 2846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subsup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(225);

var subsup = function (text, attrs) {
    if (attrs.type === 'sub') {
        return Object(__WEBPACK_IMPORTED_MODULE_0__base__["a" /* baseMarkPattern */])(text, '~');
    }
    else {
        return Object(__WEBPACK_IMPORTED_MODULE_0__base__["a" /* baseMarkPattern */])(text, '^');
    }
};
//# sourceMappingURL=subsup.js.map

/***/ }),
/* 2847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return underline; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(225);

var underline = function (text) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__base__["a" /* baseMarkPattern */])(text, '+');
};
//# sourceMappingURL=underline.js.map

/***/ }),
/* 2848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return codeBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inlines__ = __webpack_require__(471);

var supportedLanguageInWiki = [
    'actionscript',
    'ada',
    'applescript',
    'bash',
    'c',
    'c#',
    'c++',
    'cpp',
    'css',
    'erlang',
    'go',
    'groovy',
    'haskell',
    'html',
    'java',
    'javascript',
    'js',
    'json',
    'lua',
    'none',
    'nyan',
    'objc',
    'perl',
    'php',
    'python',
    'r',
    'rainbow',
    'ruby',
    'scala',
    'sh',
    'sql',
    'swift',
    'visualbasic',
    'xml',
    'yaml',
];
var codeBlock = function (node) {
    var result = '';
    node.forEach(function (n) {
        result += Object(__WEBPACK_IMPORTED_MODULE_0__inlines__["a" /* inlines */])(n, node);
    });
    if (supportedLanguageInWiki.indexOf(node.attrs.language) !== -1) {
        return "{code:" + node.attrs.language + "}" + result + "{code}";
    }
    else {
        return "{code}" + result + "{code}";
    }
};
//# sourceMappingURL=code-block.js.map

/***/ }),
/* 2849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return doc; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(167);

var doc = function (node) {
    var result = [];
    node.forEach(function (n) {
        result.push(Object(__WEBPACK_IMPORTED_MODULE_0____["a" /* encode */])(n));
    });
    return result.join('\n\n');
};
//# sourceMappingURL=doc.js.map

/***/ }),
/* 2850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return heading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inlines__ = __webpack_require__(471);

var heading = function (node) {
    var result = '';
    node.forEach(function (n) {
        result += Object(__WEBPACK_IMPORTED_MODULE_0__inlines__["a" /* inlines */])(n);
    });
    return "h" + node.attrs.level + ". " + result;
};
//# sourceMappingURL=heading.js.map

/***/ }),
/* 2851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mediaGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media__ = __webpack_require__(2852);

var mediaGroup = function (node) {
    var result = [];
    node.forEach(function (n) {
        result.push(Object(__WEBPACK_IMPORTED_MODULE_0__media__["a" /* media */])(n));
    });
    return result.join('\n');
};
//# sourceMappingURL=media-group.js.map

/***/ }),
/* 2852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return media; });
var media = function (node) {
    var wikiAttrs = [];
    if (node.attrs.width) {
        wikiAttrs.push("width=" + node.attrs.width);
    }
    if (node.attrs.height) {
        wikiAttrs.push("height=" + node.attrs.height);
    }
    var fileName = node.attrs.type === 'external' ? node.attrs.url : node.attrs.id;
    if (wikiAttrs.length) {
        return "!" + fileName + "|" + wikiAttrs.join(',') + "!";
    }
    // default to thumbnail if no width or height is set
    return "!" + fileName + "|thumbnail!";
};
//# sourceMappingURL=media.js.map

/***/ }),
/* 2853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return orderedList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listItem__ = __webpack_require__(884);

var orderedList = function (node) {
    var result = [];
    node.forEach(function (item) {
        result.push(Object(__WEBPACK_IMPORTED_MODULE_0__listItem__["a" /* listItem */])(item, '#'));
    });
    return result.join('\n');
};
//# sourceMappingURL=ordered-list.js.map

/***/ }),
/* 2854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return panel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(167);

var panelTypeColorMapping = {
    info: '#deebff',
    note: '#eae6ff',
    success: '#e3fcef',
    warning: '#fffae6',
    error: '#ffebe6',
};
var panel = function (node) {
    var result = [];
    node.forEach(function (n) {
        result.push(Object(__WEBPACK_IMPORTED_MODULE_0____["a" /* encode */])(n));
    });
    return "{panel:bgColor=" + (panelTypeColorMapping[node.attrs.panelType] || '') + "}\n" + result.join('\n\n') + "\n{panel}";
};
//# sourceMappingURL=panel.js.map

/***/ }),
/* 2855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rule; });
var rule = function (node) {
    return '----';
};
//# sourceMappingURL=rule.js.map

/***/ }),
/* 2856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return table; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(167);

var table = function (node) {
    var result = [];
    node.forEach(function (n) {
        result.push(tableRow(n));
    });
    return result.join('\n');
};
var tableRow = function (node) {
    var result = [];
    var separator = '|';
    node.forEach(function (n) {
        if (n.type.name === 'tableHeader') {
            separator = '||';
        }
        result.push(tableCell(n));
    });
    return "" + separator + result.join("" + separator) + separator;
};
var tableCell = function (node) {
    var result = [];
    node.forEach(function (n) {
        result.push(Object(__WEBPACK_IMPORTED_MODULE_0____["a" /* encode */])(n));
    });
    return result.join('\n');
};
//# sourceMappingURL=table.js.map

/***/ }),
/* 2857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__text__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_normalize__ = __webpack_require__(228);


var AbstractTree = /** @class */ (function () {
    function AbstractTree(schema, wikiMarkup) {
        this.schema = schema;
        this.wikiMarkup = wikiMarkup;
    }
    /**
     * Convert reduced macros tree into prosemirror model tree
     */
    AbstractTree.prototype.getProseMirrorModel = function (tokenErrCallback) {
        var content = Object(__WEBPACK_IMPORTED_MODULE_0__text__["a" /* parseString */])(this.wikiMarkup, this.schema, [], tokenErrCallback);
        return this.schema.nodes.doc.createChecked({}, Object(__WEBPACK_IMPORTED_MODULE_1__utils_normalize__["a" /* normalizePMNodes */])(content, this.schema));
    };
    return AbstractTree;
}());
/* harmony default export */ __webpack_exports__["a"] = (AbstractTree);
//# sourceMappingURL=abstract-tree.js.map

/***/ }),
/* 2858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTextNode;
function createTextNode(input, schema, marks) {
    if (input === '') {
        return [];
    }
    var node = schema.text(input, marks || []);
    return [node];
}
//# sourceMappingURL=text.js.map

/***/ }),
/* 2859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMediaSingleNodeView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tokenize_link_text__ = __webpack_require__(888);

var defaultWidth = 200;
var defaultHeight = 183;
function getMediaSingleNodeView(schema, filename, attrs) {
    var _a = schema.nodes, media = _a.media, mediaSingle = _a.mediaSingle;
    var width = defaultWidth;
    var height = defaultHeight;
    if (attrs.width) {
        var parsed = parseInt(attrs.width, 10);
        if (!isNaN(parsed)) {
            width = parsed;
        }
    }
    if (attrs.height) {
        var parsed = parseInt(attrs.height, 10);
        if (!isNaN(parsed)) {
            height = parsed;
        }
    }
    if (filename.match(__WEBPACK_IMPORTED_MODULE_0__tokenize_link_text__["a" /* LINK_TEXT_REGEXP */])) {
        var externalMediaNode = media.createChecked({
            type: 'external',
            url: filename,
            width: width,
            height: height,
        });
        return mediaSingle.createChecked({}, externalMediaNode);
    }
    else {
        var mediaNode = media.createChecked({
            id: filename,
            type: 'file',
            collection: '',
            width: width,
            height: height,
        });
        return mediaSingle.createChecked({}, mediaNode);
    }
}
//# sourceMappingURL=mediaSingle.js.map

/***/ }),
/* 2860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = resolveLink;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mention_link__ = __webpack_require__(2861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__attachment_link__ = __webpack_require__(2862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__url_link__ = __webpack_require__(2864);




// jira-components/jira-core/src/main/resources/system-contentlinkresolvers-plugin.xml
// attachment resolver: 10
// anchor resolver: 20 - unsupported
// jiraissue resolver: 30 - unsupported
// user profile: 40
//
// Fall back to url link resolver
var linkResolverStrategies = [
    __WEBPACK_IMPORTED_MODULE_2__attachment_link__["a" /* attachmentLinkResolver */],
    __WEBPACK_IMPORTED_MODULE_1__mention_link__["a" /* mentionLinkResolver */],
    __WEBPACK_IMPORTED_MODULE_3__url_link__["a" /* urlLinkResolver */],
];
function resolveLink(link, schema, tokenErrCallback) {
    var e_1, _a;
    var length = link.originalLinkText.length + 2;
    try {
        for (var linkResolverStrategies_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](linkResolverStrategies), linkResolverStrategies_1_1 = linkResolverStrategies_1.next(); !linkResolverStrategies_1_1.done; linkResolverStrategies_1_1 = linkResolverStrategies_1.next()) {
            var resolver = linkResolverStrategies_1_1.value;
            var resolvedLink = resolver(link, schema, tokenErrCallback);
            if (resolvedLink) {
                return {
                    length: length,
                    nodes: resolvedLink,
                    type: 'pmnode',
                };
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (linkResolverStrategies_1_1 && !linkResolverStrategies_1_1.done && (_a = linkResolverStrategies_1.return)) _a.call(linkResolverStrategies_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return {
        length: 1,
        type: 'text',
        text: "[",
    };
}
//# sourceMappingURL=link-resolver.js.map

/***/ }),
/* 2861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mentionLinkResolver;
function mentionLinkResolver(link, schema) {
    if (link.notLinkBody.startsWith('~')) {
        var mentionText = link.notLinkBody.substring(1);
        return [
            schema.nodes.mention.createChecked({
                id: mentionText,
            }),
        ];
    }
}
//# sourceMappingURL=mention-link.js.map

/***/ }),
/* 2862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = attachmentLinkResolver;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nodes_mediaGroup__ = __webpack_require__(2863);

function attachmentLinkResolver(link, schema) {
    if (link.attachmentName) {
        return [Object(__WEBPACK_IMPORTED_MODULE_0__nodes_mediaGroup__["a" /* default */])(schema, link.attachmentName)];
    }
}
//# sourceMappingURL=attachment-link.js.map

/***/ }),
/* 2863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMediaGroupNodeView;
function getMediaGroupNodeView(schema, filename) {
    var _a = schema.nodes, media = _a.media, mediaGroup = _a.mediaGroup;
    var mediaNode = media.createChecked({
        id: filename,
        type: 'file',
        collection: '',
    });
    return mediaGroup.createChecked({}, mediaNode);
}
//# sourceMappingURL=mediaGroup.js.map

/***/ }),
/* 2864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = urlLinkResolver;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__text__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_text__ = __webpack_require__(93);





function urlLinkResolver(link, schema, tokenErrCallback) {
    var output = [];
    var url = link.notLinkBody;
    var textRepresentation = link.linkBody || link.notLinkBody;
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__["L" /* isSafeUrl */])(url)) {
        return;
    }
    var ignoreTokenTypes = [
        __WEBPACK_IMPORTED_MODULE_1__index__["a" /* TokenType */].DOUBLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_1__index__["a" /* TokenType */].TRIPLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_1__index__["a" /* TokenType */].QUADRUPLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_1__index__["a" /* TokenType */].LINK_TEXT,
    ];
    var rawContent = Object(__WEBPACK_IMPORTED_MODULE_3__text__["a" /* parseString */])(textRepresentation.replace(/^mailto:/, ''), schema, ignoreTokenTypes, tokenErrCallback);
    var decoratedContent = rawContent.map(function (n) {
        var mark = schema.marks.link.create({
            href: url,
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !Object(__WEBPACK_IMPORTED_MODULE_4__utils_text__["b" /* hasAnyOfMarks */])(n, ['link', 'code'])) {
            return n.mark(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](n.marks, [mark]));
        }
        return n;
    });
    output.push.apply(output, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](decoratedContent));
    if (!hasTextNode(rawContent)) {
        var mark = schema.marks.link.create({
            href: url,
        });
        var linkTextNode = schema.text(textRepresentation, [mark]);
        output.push(linkTextNode);
    }
    return output;
}
function hasTextNode(nodes) {
    return nodes.find(function (n) {
        return n.type.name === 'text';
    });
}
//# sourceMappingURL=url-link.js.map

/***/ }),
/* 2865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export parseLink */
/* harmony export (immutable) */ __webpack_exports__["a"] = parseContentLink;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_text__ = __webpack_require__(93);


/*
 * This implementation is ported from JIRA with minimal modifications
 * It uses a mutable "StringBuffer" to parse links. It would be ideal to
 *  move this to operating on immutable strings instead if possible
 *
 * TODO: CS-596 Replace string buffer usage with strings
 */
function trimIfPossible(s) {
    if (s === null) {
        return null;
    }
    return s.trim();
}
function extractLinkBody(buffer) {
    var indexOfBang = buffer.indexOf('!');
    var indexOfPipe = buffer.indexOf('|');
    var lastIndexOfBang = buffer.lastIndexOf('!');
    var notEscaped = indexOfBang === -1 ||
        indexOfBang > indexOfPipe ||
        indexOfBang === lastIndexOfBang;
    if (notEscaped) {
        return divideOn(buffer, '|');
    }
    var body = new __WEBPACK_IMPORTED_MODULE_1__utils_text__["a" /* StringBuffer */]();
    var inEscape = false;
    for (var i = 0; i < buffer.length(); i++) {
        var c = buffer.charAt(i);
        if (c === '!') {
            inEscape = !inEscape;
        }
        if (c === '|' && !inEscape) {
            buffer.delete(0, i + 1);
            return body.toString();
        }
        body.append(c);
    }
    return null;
}
function divideAfterLast(buffer, divider) {
    if (buffer.length() === 0) {
        return null;
    }
    return divideAfter(buffer, buffer.lastIndexOf(divider));
}
function divideAfter(buffer, index) {
    if (typeof index === 'string') {
        index = buffer.indexOf(index);
    }
    if (index < 0) {
        return null;
    }
    else if (index === buffer.length() - 1) {
        buffer.deleteCharAt(buffer.length() - 1);
        return null;
    }
    else {
        var body = buffer.substring(index + 1);
        buffer.delete(index, buffer.length());
        return body;
    }
}
/**
 * Split a StringBuffer on some dividing character. Return everything before the divider,
 * and remove that prefix _and_ the divider from the StringBuffer. If there is no divider,
 * return null.
 * <p/>
 * If the buffer begins with the divider, then the divider will be removed _and_ null returned.
 * If the buffer ends with the divider, everything before the divider is returned and the buffer
 * will remain empty.
 *
 * @param buffer  the text we want to divide. Will be modified during the operation
 * @param divider the character to divide the buffer on
 * @return the characters before the divider, or the default if there are none
 */
function divideOn(buffer, divider) {
    if (buffer.length() === 0) {
        return null;
    }
    var i = buffer.indexOf(divider);
    if (i < 0) {
        return null;
    }
    else if (i === 0) {
        buffer.deleteCharAt(0);
        return null;
    }
    else {
        var body = buffer.substring(0, i);
        buffer.delete(0, i + 1);
        return body;
    }
}
function extractNumber(buf) {
    var digits = new __WEBPACK_IMPORTED_MODULE_1__utils_text__["a" /* StringBuffer */]();
    var i = 0;
    for (; i < buf.length() && Object(__WEBPACK_IMPORTED_MODULE_1__utils_text__["d" /* isDigit */])(buf.charAt(i)); i++) {
        digits.append(buf.charAt(i));
    }
    if (i > 0) {
        buf.delete(0, i);
    }
    try {
        return parseInt(digits.toString(), 10);
    }
    catch (e) {
        return 0;
    }
}
function parseLink(linkText) {
    var originalLinkText = linkText;
    // we want to decode single quotes (represented by &#039;) back before parsing the link test
    if (linkText.indexOf('&#039;') !== -1) {
        linkText = linkText.replace('&#039;', "'");
    }
    var buf = new __WEBPACK_IMPORTED_MODULE_1__utils_text__["a" /* StringBuffer */](linkText);
    var linkBody = extractLinkBody(buf);
    var linkTitle = trimIfPossible(divideAfter(buf, '|'));
    var notLinkBody = buf.toString().trim();
    return {
        originalLinkText: originalLinkText,
        linkBody: linkBody,
        linkTitle: linkTitle,
        notLinkBody: notLinkBody,
    };
}
function parseContentLink(link) {
    if (typeof link === 'string') {
        link = parseLink(link);
    }
    var notLinkBody = link.notLinkBody;
    var shortcutName = null;
    var shortcutValue = null;
    var spaceKey = null;
    var attachmentName = null;
    var anchor = null;
    var destinationTitle = '';
    var contentId = 0;
    // Don't treat it as a short link when it starts with "~"
    if (!notLinkBody.startsWith('~')) {
        var shortcutBuf = new __WEBPACK_IMPORTED_MODULE_1__utils_text__["a" /* StringBuffer */](notLinkBody);
        shortcutName = trimIfPossible(divideAfterLast(shortcutBuf, '@'));
        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_text__["e" /* isNotBlank */])(shortcutName)) {
            shortcutValue = shortcutBuf.toString();
        }
    }
    var buf = new __WEBPACK_IMPORTED_MODULE_1__utils_text__["a" /* StringBuffer */](notLinkBody);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_text__["c" /* isBlank */])(shortcutName)) {
        spaceKey = trimIfPossible(divideOn(buf, ':'));
        if (buf.indexOf('$') === 0) {
            buf.deleteCharAt(0);
            contentId = extractNumber(buf);
            if (contentId === 0) {
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, link, { shortcutName: shortcutName,
                    shortcutValue: shortcutValue,
                    spaceKey: spaceKey,
                    contentId: contentId,
                    attachmentName: attachmentName,
                    anchor: anchor,
                    destinationTitle: destinationTitle });
            }
        }
        attachmentName = trimIfPossible(divideAfter(buf, '^'));
        anchor = trimIfPossible(divideAfter(buf, '#'));
    }
    if (contentId === 0) {
        destinationTitle = buf.toString().trim();
    }
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, link, { shortcutName: shortcutName,
        shortcutValue: shortcutValue,
        spaceKey: spaceKey,
        contentId: contentId,
        attachmentName: attachmentName,
        anchor: anchor,
        destinationTitle: destinationTitle });
}
//# sourceMappingURL=link-parser.js.map

/***/ }),
/* 2866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = blockquote;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__quote_macro__ = __webpack_require__(890);


// bq. sadfsdf
var BLOCKQUOTE_REGEXP = /^bq\.(.*)/;
function blockquote(input, position, schema, tokenErrCallback) {
    var match = input.substring(position).match(BLOCKQUOTE_REGEXP);
    if (!match) {
        return fallback(input, position);
    }
    var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](match, 2), rawContent = _a[1];
    return Object(__WEBPACK_IMPORTED_MODULE_1__quote_macro__["b" /* rawContentProcessor */])('', rawContent, match[0].length, schema, tokenErrCallback);
}
function fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1,
    };
}
//# sourceMappingURL=blockquote.js.map

/***/ }),
/* 2867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createEmptyParagraphNode;
/* harmony export (immutable) */ __webpack_exports__["b"] = createParagraphNodeFromInlineNodes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

function createEmptyParagraphNode(schema) {
    var paragraph = schema.nodes.paragraph;
    return paragraph.createChecked({}, []);
}
/**
 * Create paragraphs from inline nodes. Two and more
 * hardbreaks will start a new paragraph
 */
function createParagraphNodeFromInlineNodes(inlineNodes, schema) {
    var e_1, _a;
    var paragraph = schema.nodes.paragraph;
    var result = [];
    var buffer = [];
    var hardbreakBuffer = [];
    try {
        for (var inlineNodes_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](inlineNodes), inlineNodes_1_1 = inlineNodes_1.next(); !inlineNodes_1_1.done; inlineNodes_1_1 = inlineNodes_1.next()) {
            var node = inlineNodes_1_1.value;
            if (node.type.name === 'hardBreak') {
                hardbreakBuffer.push(node);
                continue;
            }
            // There are more than one hardBreaks, we should make
            // a new paragraph
            if (hardbreakBuffer.length > 1 && buffer.length > 0) {
                result.push(paragraph.createChecked({}, buffer));
                buffer = [];
                hardbreakBuffer = [];
            }
            buffer.push.apply(buffer, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](hardbreakBuffer, [node]));
            hardbreakBuffer = [];
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (inlineNodes_1_1 && !inlineNodes_1_1.done && (_a = inlineNodes_1.return)) _a.call(inlineNodes_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (buffer.length > 0) {
        result.push(paragraph.createChecked({}, buffer));
    }
    return result;
}
//# sourceMappingURL=paragraph.js.map

/***/ }),
/* 2868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = citation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_text__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_formatter__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__text__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__char__ = __webpack_require__(2869);






function citation(input, position, schema, tokenErrCallback) {
    /**
     * The following token types will be ignored in parsing
     * the content
     */
    var ignoreTokenTypes = [
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].DOUBLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].TRIPLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].QUADRUPLE_DASH_SYMBOL,
    ];
    /** Add code mark to each text */
    var contentDecorator = function (n, index) {
        var mark = schema.marks.em.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !Object(__WEBPACK_IMPORTED_MODULE_2__utils_text__["b" /* hasAnyOfMarks */])(n, ['em', 'code'])) {
            if (index === 0) {
                n.text = __WEBPACK_IMPORTED_MODULE_5__char__["a" /* EM_DASH */] + " " + n.text;
            }
            return n.mark(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](n.marks, [mark]));
        }
        return n;
    };
    var rawContentProcessor = function (raw, length) {
        var content = Object(__WEBPACK_IMPORTED_MODULE_4__text__["a" /* parseString */])(raw, schema, ignoreTokenTypes, tokenErrCallback);
        var decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length,
        };
    };
    return Object(__WEBPACK_IMPORTED_MODULE_3__common_formatter__["a" /* commonFormatter */])(input, position, schema, {
        opening: '??',
        closing: '??',
        rawContentProcessor: rawContentProcessor,
    });
}
//# sourceMappingURL=citation.js.map

/***/ }),
/* 2869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EM_DASH; });
var EM_DASH = '—';
//# sourceMappingURL=char.js.map

/***/ }),
/* 2870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = deleted;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_text__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_formatter__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__text__ = __webpack_require__(50);





function deleted(input, position, schema, tokenErrCallback) {
    /**
     * The following token types will be ignored in parsing
     * the content
     */
    var ignoreTokenTypes = [
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].DOUBLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].TRIPLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].QUADRUPLE_DASH_SYMBOL,
    ];
    /** Add strike mark to each text */
    var contentDecorator = function (n) {
        var mark = schema.marks.strike.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !Object(__WEBPACK_IMPORTED_MODULE_2__utils_text__["b" /* hasAnyOfMarks */])(n, ['strike', 'code'])) {
            return n.mark(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](n.marks, [mark]));
        }
        return n;
    };
    var rawContentProcessor = function (raw, length) {
        var content = Object(__WEBPACK_IMPORTED_MODULE_4__text__["a" /* parseString */])(raw, schema, ignoreTokenTypes, tokenErrCallback);
        var decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length,
        };
    };
    return Object(__WEBPACK_IMPORTED_MODULE_3__common_formatter__["a" /* commonFormatter */])(input, position, schema, {
        opening: '-',
        closing: '-',
        rawContentProcessor: rawContentProcessor,
    });
}
//# sourceMappingURL=deleted.js.map

/***/ }),
/* 2871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return doubleDashSymbol; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dash_token_creator__ = __webpack_require__(891);


var token = {
    type: 'text',
    text: '\u2013',
    length: 2,
};
var fallback = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, token, { text: '--' });
var doubleDashSymbol = Object(__WEBPACK_IMPORTED_MODULE_1__dash_token_creator__["a" /* createDashTokenParser */])(token, fallback);
//# sourceMappingURL=double-dash-symbol.js.map

/***/ }),
/* 2872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = emphasis;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_text__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_formatter__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__text__ = __webpack_require__(50);





function emphasis(input, position, schema, tokenErrCallback) {
    /**
     * The following token types will be ignored in parsing
     * the content of a  mark
     */
    var ignoreTokenTypes = [
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].DOUBLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].TRIPLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].QUADRUPLE_DASH_SYMBOL,
    ];
    /** Add underline mark to each text */
    var contentDecorator = function (n) {
        var mark = schema.marks.em.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !Object(__WEBPACK_IMPORTED_MODULE_2__utils_text__["b" /* hasAnyOfMarks */])(n, ['em', 'code'])) {
            return n.mark(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](n.marks, [mark]));
        }
        return n;
    };
    var rawContentProcessor = function (raw, length) {
        var content = Object(__WEBPACK_IMPORTED_MODULE_4__text__["a" /* parseString */])(raw, schema, ignoreTokenTypes, tokenErrCallback);
        var decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length,
        };
    };
    return Object(__WEBPACK_IMPORTED_MODULE_3__common_formatter__["a" /* commonFormatter */])(input, position, schema, {
        opening: '_',
        closing: '_',
        rawContentProcessor: rawContentProcessor,
    });
}
//# sourceMappingURL=emphasis.js.map

/***/ }),
/* 2873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hardbreak;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__whitespace__ = __webpack_require__(227);

function hardbreak(input, position, schema) {
    // Look for normal hardbreak \r, \n, \r\n
    var length = Object(__WEBPACK_IMPORTED_MODULE_0__whitespace__["a" /* parseNewlineOnly */])(input.substring(position));
    if (length === 0) {
        // not a valid hardbreak
        return {
            type: 'text',
            text: input.substr(position, 1),
            length: 1,
        };
    }
    return {
        type: 'pmnode',
        nodes: [schema.nodes.hardBreak.createChecked()],
        length: length,
    };
}
//# sourceMappingURL=hardbreak.js.map

/***/ }),
/* 2874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = heading;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__text__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(45);


// h1. HEADING
var HEADING_REGEXP = /^h([1-6])\.(.*)/;
function heading(input, position, schema, tokenErrCallback) {
    /**
     * The following token types will be ignored in parsing
     * the content of a strong mark
     */
    var ignoreTokenTypes = [
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].DOUBLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].TRIPLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].QUADRUPLE_DASH_SYMBOL,
    ];
    var match = input.substring(position).match(HEADING_REGEXP);
    if (!match) {
        return fallback(input, position);
    }
    var level = parseInt(match[1], 10);
    var content = Object(__WEBPACK_IMPORTED_MODULE_0__text__["a" /* parseString */])(match[2], schema, ignoreTokenTypes, tokenErrCallback);
    try {
        var headingNode = schema.nodes.heading.createChecked({
            level: level,
        }, content);
        return {
            type: 'pmnode',
            nodes: [headingNode],
            length: match[0].length,
        };
    }
    catch (err) {
        /**
         * If the heading fails to rendering, we want to skip the text
         * "h1."
         */
        return {
            type: 'text',
            text: '',
            length: 4,
        };
    }
}
function fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1,
    };
}
//# sourceMappingURL=heading.js.map

/***/ }),
/* 2875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = inserted;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_text__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_formatter__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__text__ = __webpack_require__(50);





function inserted(input, position, schema, tokenErrCallback) {
    /**
     * The following token types will be ignored in parsing
     * the content
     */
    var ignoreTokenTypes = [
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].DOUBLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].TRIPLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].QUADRUPLE_DASH_SYMBOL,
    ];
    /** Add underline mark to each text */
    var contentDecorator = function (n) {
        var mark = schema.marks.underline.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !Object(__WEBPACK_IMPORTED_MODULE_2__utils_text__["b" /* hasAnyOfMarks */])(n, ['underline', 'code'])) {
            return n.mark(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](n.marks, [mark]));
        }
        return n;
    };
    var rawContentProcessor = function (raw, length) {
        var content = Object(__WEBPACK_IMPORTED_MODULE_4__text__["a" /* parseString */])(raw, schema, ignoreTokenTypes, tokenErrCallback);
        var decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length,
        };
    };
    return Object(__WEBPACK_IMPORTED_MODULE_3__common_formatter__["a" /* commonFormatter */])(input, position, schema, {
        opening: '+',
        closing: '+',
        rawContentProcessor: rawContentProcessor,
    });
}
//# sourceMappingURL=inserted.js.map

/***/ }),
/* 2876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = list;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__builder_list_builder__ = __webpack_require__(2877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__text__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_normalize__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keyword__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5____ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__whitespace__ = __webpack_require__(227);







var LIST_ITEM_REGEXP = /^ *([*\-#]+) /;
var EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
var RULER_SYMBOL_REGEXP = /^-{4,5}/;
var processState = {
    NEW_LINE: 0,
    BUFFER: 1,
    END: 2,
    MACRO: 3,
};
function list(input, position, schema, tokenErrCallback) {
    /**
     * The following token types will be ignored in parsing
     * the content of a listItem
     */
    var ignoreTokenTypes = [__WEBPACK_IMPORTED_MODULE_5____["a" /* TokenType */].QUADRUPLE_DASH_SYMBOL, __WEBPACK_IMPORTED_MODULE_5____["a" /* TokenType */].LIST];
    var index = position;
    var state = processState.NEW_LINE;
    var buffer = '';
    var lastListSymbols = null;
    var builder = null;
    var contentBuffer = [];
    var output = [];
    while (index < input.length) {
        var char = input.charAt(index);
        switch (state) {
            case processState.NEW_LINE: {
                var substring = input.substring(index);
                var listMatch = substring.match(LIST_ITEM_REGEXP);
                if (listMatch) {
                    var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](listMatch, 2), symbols = _a[1];
                    // Handle ruler in list
                    var rulerMatch = symbols.match(RULER_SYMBOL_REGEXP);
                    if (rulerMatch) {
                        var remainingAfterSymbol = input.substring(index + rulerMatch[0].length);
                        var emptyLineMatch_1 = remainingAfterSymbol.match(EMPTY_LINE_REGEXP);
                        // If this is an empty line skip to the buffering step rather than match as a list element
                        if (emptyLineMatch_1) {
                            state = processState.BUFFER;
                            continue;
                        }
                    }
                    if (!builder) {
                        /**
                         * It happens because this is the first item of the list
                         */
                        builder = new __WEBPACK_IMPORTED_MODULE_1__builder_list_builder__["a" /* ListBuilder */](schema, symbols);
                        lastListSymbols = symbols;
                    }
                    else {
                        /**
                         * There is a builder, so we are in the middle of building a list
                         * and now there is a new list item
                         */
                        if (buffer.length > 0) {
                            /** Wrap up previous list item and clear buffer */
                            var content = Object(__WEBPACK_IMPORTED_MODULE_2__text__["a" /* parseString */])(buffer, schema, ignoreTokenTypes, tokenErrCallback);
                            var normalizedContent = Object(__WEBPACK_IMPORTED_MODULE_3__utils_normalize__["a" /* normalizePMNodes */])(content, schema);
                            contentBuffer.push.apply(contentBuffer, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](normalizedContent));
                            builder.add([
                                {
                                    style: lastListSymbols,
                                    content: sanitize(contentBuffer, schema),
                                },
                            ]);
                            buffer = '';
                            contentBuffer = [];
                        }
                        /** We finished last list item here, going to the new one */
                        lastListSymbols = symbols;
                        var type = Object(__WEBPACK_IMPORTED_MODULE_1__builder_list_builder__["b" /* getType */])(symbols);
                        /** If it's top level and doesn't match, create a new list */
                        if (type !== builder.type && symbols.length === 1) {
                            output.push.apply(output, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](builder.buildPMNode()));
                            builder = new __WEBPACK_IMPORTED_MODULE_1__builder_list_builder__["a" /* ListBuilder */](schema, symbols);
                        }
                    }
                    index += listMatch[0].length;
                }
                /**
                 * If we encounter an empty line, we should end the list
                 */
                var emptyLineMatch = substring.match(EMPTY_LINE_REGEXP);
                if (emptyLineMatch) {
                    state = processState.END;
                    continue;
                }
                state = processState.BUFFER;
                continue;
            }
            case processState.BUFFER: {
                var length_1 = Object(__WEBPACK_IMPORTED_MODULE_6__whitespace__["a" /* parseNewlineOnly */])(input.substring(index));
                if (length_1) {
                    buffer += input.substr(index, length_1);
                    state = processState.NEW_LINE;
                    index += length_1;
                    continue;
                }
                if (char === '{') {
                    state = processState.MACRO;
                    continue;
                }
                else {
                    buffer += char;
                }
                break;
            }
            case processState.MACRO: {
                var match = Object(__WEBPACK_IMPORTED_MODULE_4__keyword__["b" /* parseMacroKeyword */])(input.substring(index));
                if (!match) {
                    buffer += char;
                    state = processState.BUFFER;
                    break;
                }
                var token = Object(__WEBPACK_IMPORTED_MODULE_5____["b" /* parseToken */])(input, match.type, index, schema);
                if (token.type === 'text') {
                    buffer += token.text;
                }
                else {
                    /**
                     * We found a macro in the list...
                     */
                    if (!builder) {
                        /** Something is really wrong here */
                        return fallback(input, position);
                    }
                    if (buffer.length > 0) {
                        /**
                         * Wrapup what is already in the string buffer and save it to
                         * contentBuffer
                         */
                        var content = Object(__WEBPACK_IMPORTED_MODULE_2__text__["a" /* parseString */])(buffer, schema, ignoreTokenTypes, tokenErrCallback);
                        var normalizedContent_1 = Object(__WEBPACK_IMPORTED_MODULE_3__utils_normalize__["a" /* normalizePMNodes */])(content, schema);
                        contentBuffer.push.apply(contentBuffer, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](sanitize(normalizedContent_1, schema)));
                        buffer = '';
                    }
                    var normalizedContent = Object(__WEBPACK_IMPORTED_MODULE_3__utils_normalize__["a" /* normalizePMNodes */])(token.nodes, schema);
                    contentBuffer.push.apply(contentBuffer, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](sanitize(normalizedContent, schema)));
                }
                index += token.length;
                state = processState.BUFFER;
                continue;
            }
            case processState.END: {
                if (!builder) {
                    /** Something is really wrong here */
                    return fallback(input, position);
                }
                if (buffer.length > 0) {
                    /** Wrap up previous list item and clear buffer */
                    var content = Object(__WEBPACK_IMPORTED_MODULE_2__text__["a" /* parseString */])(buffer, schema, ignoreTokenTypes, tokenErrCallback);
                    var normalizedContent = Object(__WEBPACK_IMPORTED_MODULE_3__utils_normalize__["a" /* normalizePMNodes */])(content, schema);
                    contentBuffer.push.apply(contentBuffer, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](normalizedContent));
                }
                builder.add([
                    { style: lastListSymbols, content: sanitize(contentBuffer, schema) },
                ]);
                output.push.apply(output, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](builder.buildPMNode()));
                return {
                    type: 'pmnode',
                    nodes: output,
                    length: index - position,
                };
            }
        }
        index++;
    }
    if (buffer.length > 0) {
        /** Wrap up what's left in the buffer */
        var content = Object(__WEBPACK_IMPORTED_MODULE_2__text__["a" /* parseString */])(buffer, schema, ignoreTokenTypes, tokenErrCallback);
        var normalizedContent = Object(__WEBPACK_IMPORTED_MODULE_3__utils_normalize__["a" /* normalizePMNodes */])(content, schema);
        contentBuffer.push.apply(contentBuffer, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](normalizedContent));
    }
    if (builder) {
        builder.add([
            { style: lastListSymbols, content: sanitize(contentBuffer, schema) },
        ]);
        output.push.apply(output, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](builder.buildPMNode()));
    }
    return {
        type: 'pmnode',
        nodes: output,
        length: index - position,
    };
}
function sanitize(nodes, schema) {
    return nodes.reduce(function (result, curr) {
        switch (curr.type.name) {
            case 'blockquote': {
                /**
                 * If a blockquote is inside a list item
                 * - Convert it to paragraph
                 */
                curr.content.forEach(function (n) {
                    result.push(n);
                });
                break;
            }
            case 'heading': {
                /**
                 * If a heading is inside a list item
                 * - Convert the heading to paragraph
                 * - Convert text to upper case
                 * - Mark text with strong.
                 */
                var contentBuffer_1 = [];
                curr.content.forEach(function (n) {
                    var mark = schema.marks.strong.create();
                    if (n.type.name === 'text') {
                        if (n.text) {
                            n.text = n.text.toUpperCase();
                        }
                        contentBuffer_1.push(n.mark(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](n.marks, [mark])));
                    }
                    else {
                        contentBuffer_1.push(n);
                    }
                });
                var p = schema.nodes.paragraph.createChecked({}, contentBuffer_1);
                result.push(p);
                break;
            }
            default:
                result.push(curr);
        }
        return result;
    }, []);
}
function fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1,
    };
}
//# sourceMappingURL=list.js.map

/***/ }),
/* 2877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getType;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListBuilder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

var supportedContentType = [
    'paragraph',
    'orderedList',
    'bulletList',
    'mediaSingle',
];
/**
 * Return the type of a list from the bullets
 */
function getType(bullets) {
    return /#$/.test(bullets) ? 'orderedList' : 'bulletList';
}
var ListBuilder = /** @class */ (function () {
    function ListBuilder(schema, bullets) {
        var _this = this;
        /**
         * Build prosemirror bulletList or orderedList node
         * @param {List} list
         * @returns {PMNode}
         */
        this.parseList = function (list) {
            var listNode = _this.schema.nodes[list.type];
            var output = [];
            var listItemsBuffer = [];
            for (var i = 0; i < list.children.length; i++) {
                var parsedContent = _this.parseListItem(list.children[i]);
                for (var j = 0; j < parsedContent.length; j++) {
                    var parsedNode = parsedContent[j];
                    if (parsedNode.type.name === 'listItem') {
                        listItemsBuffer.push(parsedNode);
                        continue;
                    }
                    /**
                     * If the node is not a listItem, then we need to
                     * wrap exisintg list and break out
                     */
                    if (listItemsBuffer.length) {
                        var list_1 = listNode.createChecked({}, listItemsBuffer);
                        output.push(list_1);
                    }
                    output.push(parsedNode); // This is the break out node
                    listItemsBuffer = [];
                }
            }
            if (listItemsBuffer.length) {
                var list_2 = listNode.createChecked({}, listItemsBuffer);
                output.push(list_2);
            }
            return output;
        };
        /**
         * Build prosemirror listItem node
         * This function would possibly return non listItem nodes
         * which we need to break out later
         * @param {ListItem} item
         */
        this.parseListItem = function (item) {
            var _a;
            var output = [];
            if (!item.content) {
                item.content = [];
            }
            // Parse nested list
            var parsedChildren = item.children.reduce(function (result, list) {
                var parsedList = _this.parseList(list);
                result.push.apply(result, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](parsedList));
                return result;
            }, []);
            // Append children to the content
            (_a = item.content).push.apply(_a, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](parsedChildren));
            var contentBuffer = [];
            for (var i = 0; i < item.content.length; i++) {
                var pmNode = item.content[i];
                /**
                 * Skip empty paragraph
                 */
                if (pmNode.type.name === 'paragraph' && pmNode.childCount === 0) {
                    continue;
                }
                /* Skip Empty spaces after rule */
                if (_this.isParagraphEmptyTextNode(pmNode)) {
                    continue;
                }
                if (supportedContentType.indexOf(pmNode.type.name) === -1) {
                    var listItem = _this.createListItem(contentBuffer, _this.schema);
                    output.push(listItem);
                    output.push(pmNode);
                    contentBuffer = [];
                    continue;
                }
                contentBuffer.push(pmNode);
            }
            if (contentBuffer.length) {
                var listItem = _this.createListItem(contentBuffer, _this.schema);
                output.push(listItem);
            }
            return output;
        };
        this.schema = schema;
        this.root = { children: [], type: getType(bullets) };
        this.lastDepth = 1;
        this.lastList = this.root;
    }
    Object.defineProperty(ListBuilder.prototype, "type", {
        /**
         * Return the type of the base list
         * @returns {ListType}
         */
        get: function () {
            return this.root.type;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Add a list item to the builder
     * @param {AddArgs[]} items
     */
    ListBuilder.prototype.add = function (items) {
        var e_1, _a;
        try {
            for (var items_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
                var item = items_1_1.value;
                var style = item.style, content = item.content;
                // If there's no style, add to previous list item as multiline
                if (style === null) {
                    this.appendToLastItem(content);
                    continue;
                }
                var depth = style.length;
                var type = getType(style);
                if (depth > this.lastDepth) {
                    // Add children starting from last node
                    this.createNest(depth - this.lastDepth, type);
                    this.lastDepth = depth;
                    this.lastList = this.addListItem(type, content);
                }
                else if (depth === this.lastDepth) {
                    // Add list item to current node
                    this.lastList = this.addListItem(type, content);
                }
                else {
                    // Find node at depth and add list item
                    this.lastList = this.findAncestor(this.lastDepth - depth);
                    this.lastDepth = depth;
                    this.lastList = this.addListItem(type, content);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /**
     * Compile a prosemirror node from the root list
     * @returns {PMNode[]}
     */
    ListBuilder.prototype.buildPMNode = function () {
        return this.parseList(this.root);
    };
    /* Check if all paragraph's children nodes are text and empty */
    ListBuilder.prototype.isParagraphEmptyTextNode = function (node) {
        if (node.type.name !== 'paragraph' || !node.childCount) {
            return false;
        }
        for (var i = 0; i < node.childCount; i++) {
            var n = node.content.child(i);
            if (n.type.name !== 'text') {
                // Paragraph contains non-text node, so not empty
                return false;
            }
            else if (n.textContent.trim() !== '') {
                return false;
            }
        }
        return true;
    };
    ListBuilder.prototype.createListItem = function (content, schema) {
        if (content.length === 0 ||
            ['paragraph', 'mediaSingle'].indexOf(content[0].type.name) === -1) {
            // If the content is empty or the first element is not paragraph or mediaSingle.
            // this likely to be a nested list where the toplevel list is empty
            // For example: *# item 1
            // In this case we create an empty paragraph for the top level listNode
            content.unshift(this.schema.nodes.paragraph.createChecked());
        }
        return schema.nodes.listItem.createChecked({}, content);
    };
    /**
     * Add an item at the same level as the current list item
     * @param {ListType} type
     * @param {PMNode} content
     * @returns {PMNode}
     */
    ListBuilder.prototype.addListItem = function (type, content) {
        var list = this.lastList;
        // If the list is a different type, create a new list and add it to the parent node
        if (list.type !== type) {
            var parent_1 = list.parent;
            var newList = {
                children: [],
                type: type,
                parent: parent_1,
            };
            parent_1.children.push(newList);
            this.lastList = list = newList;
        }
        var listItem = { content: content, parent: list, children: [] };
        list.children = __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](list.children, [listItem]);
        return list;
    };
    /**
     * Append the past content to the last accessed list node (multiline entries)
     * @param {PMNode[]} content
     */
    ListBuilder.prototype.appendToLastItem = function (content) {
        var _a;
        var children = this.lastList.children;
        var lastItem = children[children.length - 1];
        (_a = lastItem.content).push.apply(_a, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](content));
    };
    /**
     * Created a nested list structure of N depth under the current node
     * @param {number} depth
     * @param {ListType} type
     */
    ListBuilder.prototype.createNest = function (depth, type) {
        while (depth-- > 0) {
            if (this.lastList.children.length === 0) {
                var listItem = { parent: this.lastList, children: [] };
                this.lastList.children = [listItem];
            }
            var nextItem = this.lastList.children[this.lastList.children.length - 1];
            nextItem.children = [
                {
                    children: [],
                    parent: nextItem,
                    type: type,
                },
            ];
            this.lastList = nextItem.children[0];
        }
    };
    /**
     * Find the Nth list ancestor of the current list
     * @param {number} depth
     */
    ListBuilder.prototype.findAncestor = function (depth) {
        var list = this.lastList;
        while (depth-- > 0 && list.parent) {
            var listItem = list.parent;
            if (listItem && listItem.parent) {
                list = listItem.parent;
            }
        }
        return list;
    };
    return ListBuilder;
}());

//# sourceMappingURL=list-builder.js.map

/***/ }),
/* 2878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = monospace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_formatter__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__text__ = __webpack_require__(50);



function monospace(input, position, schema, tokenErrCallback) {
    /**
     * The following token types will be ignored in parsing
     * the content
     */
    var ignoreTokenTypes = [
        __WEBPACK_IMPORTED_MODULE_0____["a" /* TokenType */].DOUBLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_0____["a" /* TokenType */].TRIPLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_0____["a" /* TokenType */].QUADRUPLE_DASH_SYMBOL,
    ];
    /** Add code mark to each text */
    var contentDecorator = function (n) {
        var mark = schema.marks.code.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && n.marks.length) {
            return n;
        }
        return n.mark([mark]);
    };
    var rawContentProcessor = function (raw, length) {
        var content = Object(__WEBPACK_IMPORTED_MODULE_2__text__["a" /* parseString */])(raw, schema, ignoreTokenTypes, tokenErrCallback);
        var decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length,
        };
    };
    return Object(__WEBPACK_IMPORTED_MODULE_1__common_formatter__["a" /* commonFormatter */])(input, position, schema, {
        opening: '{{',
        closing: '}}',
        rawContentProcessor: rawContentProcessor,
    });
}
//# sourceMappingURL=monospace.js.map

/***/ }),
/* 2879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quadrupleDashSymbol;
var MULTI_DASH_REGEX = /^-{4,}(\s|$)/;
function quadrupleDashSymbol(input, position) {
    /**
     * This won't be a ruler because ruler has been checked at leadingKeywordMapping
     */
    var match = input.substring(position).match(MULTI_DASH_REGEX);
    if (!match) {
        return {
            type: 'text',
            text: '----',
            length: 4,
        };
    }
    return {
        type: 'text',
        text: input.substr(position, match[0].length),
        length: match[0].length,
    };
}
//# sourceMappingURL=quadruple-dash-symbol.js.map

/***/ }),
/* 2880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ruler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nodes_rule__ = __webpack_require__(2881);

var RULER_REGEX = /^-{4,5}(\s|$)/;
function ruler(input, position, schema) {
    var match = input.substring(position).match(RULER_REGEX);
    if (match) {
        return {
            type: 'pmnode',
            nodes: Object(__WEBPACK_IMPORTED_MODULE_0__nodes_rule__["a" /* createRuleNode */])(schema),
            length: match[0].length,
        };
    }
    return {
        type: 'text',
        text: input.substring(position, 1),
        length: 1,
    };
}
//# sourceMappingURL=ruler.js.map

/***/ }),
/* 2881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["a"] = createRuleNode;
var HORIZONTAL_LINE_INSIDE_MACRO = '---';
function getRuleNodeView(schema, containerNodeType) {
    var _a = schema.nodes, paragraph = _a.paragraph, rule = _a.rule;
    if (containerNodeType) {
        var textNode = schema.text(HORIZONTAL_LINE_INSIDE_MACRO);
        return paragraph.createChecked({}, textNode);
    }
    else {
        return rule.createChecked();
    }
}
function createRuleNode(schema) {
    var rule = schema.nodes.rule;
    var ruleNode = rule.createChecked();
    return [ruleNode];
}
//# sourceMappingURL=rule.js.map

/***/ }),
/* 2882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = strong;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_text__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_formatter__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__text__ = __webpack_require__(50);





function strong(input, position, schema, tokenErrCallback) {
    /**
     * The following token types will be ignored in parsing
     * the content of a strong mark
     */
    var ignoreTokenTypes = [
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].DOUBLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].TRIPLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].QUADRUPLE_DASH_SYMBOL,
    ];
    /** Adding strong mark to all text */
    var contentDecorator = function (pmNode) {
        var mark = schema.marks.strong.create();
        // We don't want to mix `code` mark with others
        if (pmNode.type.name === 'text' &&
            !Object(__WEBPACK_IMPORTED_MODULE_2__utils_text__["b" /* hasAnyOfMarks */])(pmNode, ['strong', 'code'])) {
            return pmNode.mark(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](pmNode.marks, [mark]));
        }
        return pmNode;
    };
    var rawContentProcessor = function (raw, length) {
        var content = Object(__WEBPACK_IMPORTED_MODULE_4__text__["a" /* parseString */])(raw, schema, ignoreTokenTypes, tokenErrCallback);
        var decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length,
        };
    };
    return Object(__WEBPACK_IMPORTED_MODULE_3__common_formatter__["a" /* commonFormatter */])(input, position, schema, {
        opening: '*',
        closing: '*',
        rawContentProcessor: rawContentProcessor,
    });
}
//# sourceMappingURL=strong.js.map

/***/ }),
/* 2883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subscript;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_text__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_formatter__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__text__ = __webpack_require__(50);





function subscript(input, position, schema, tokenErrCallback) {
    /**
     * The following token types will be ignored in parsing
     * the content of a  mark
     */
    var ignoreTokenTypes = [
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].DOUBLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].TRIPLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].QUADRUPLE_DASH_SYMBOL,
    ];
    /** Adding subsup mark to all text */
    var contentDecorator = function (n) {
        var mark = schema.marks.subsup.create({ type: 'sub' });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !Object(__WEBPACK_IMPORTED_MODULE_2__utils_text__["b" /* hasAnyOfMarks */])(n, ['subsup', 'code'])) {
            return n.mark(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](n.marks, [mark]));
        }
        return n;
    };
    var rawContentProcessor = function (raw, length) {
        var content = Object(__WEBPACK_IMPORTED_MODULE_4__text__["a" /* parseString */])(raw, schema, ignoreTokenTypes, tokenErrCallback);
        var decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length,
        };
    };
    return Object(__WEBPACK_IMPORTED_MODULE_3__common_formatter__["a" /* commonFormatter */])(input, position, schema, {
        opening: '~',
        closing: '~',
        rawContentProcessor: rawContentProcessor,
    });
}
//# sourceMappingURL=subscript.js.map

/***/ }),
/* 2884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = superscript;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_text__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_formatter__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__text__ = __webpack_require__(50);





function superscript(input, position, schema, tokenErrCallback) {
    /**
     * The following token types will be ignored in parsing
     * the content of a  mark
     */
    var ignoreTokenTypes = [
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].DOUBLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].TRIPLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].QUADRUPLE_DASH_SYMBOL,
    ];
    /** Adding subsup mark to all text */
    var contentDecorator = function (n) {
        var mark = schema.marks.subsup.create({ type: 'sup' });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !Object(__WEBPACK_IMPORTED_MODULE_2__utils_text__["b" /* hasAnyOfMarks */])(n, ['subsup', 'code'])) {
            return n.mark(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](n.marks, [mark]));
        }
        return n;
    };
    var rawContentProcessor = function (raw, length) {
        var content = Object(__WEBPACK_IMPORTED_MODULE_4__text__["a" /* parseString */])(raw, schema, ignoreTokenTypes, tokenErrCallback);
        var decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length,
        };
    };
    return Object(__WEBPACK_IMPORTED_MODULE_3__common_formatter__["a" /* commonFormatter */])(input, position, schema, {
        opening: '^',
        closing: '^',
        rawContentProcessor: rawContentProcessor,
    });
}
//# sourceMappingURL=superscript.js.map

/***/ }),
/* 2885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = table;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__builder_table_builder__ = __webpack_require__(2886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__text__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_normalize__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__links_link_format__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__media__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5____ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__whitespace__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__keyword__ = __webpack_require__(303);









/*
  The following are currently NOT supported
  1. Macros
  2. Escape |
  3. Table of table
*/
var CELL_REGEXP = /^([ \t]*)([|]+)([ \t]*)/;
var EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
var EMPTY_CELL_REGEXP = /^([ \t]+)/;
var processState = {
    END_TABLE: 2,
    BUFFER: 4,
    CLOSE_ROW: 5,
    NEW_ROW: 6,
    LINE_BREAK: 7,
    LINK: 8,
    MEDIA: 9,
    MACRO: 10,
};
function table(input, position, schema, tokenErrCallback) {
    /**
     * The following token types will be ignored in parsing
     * the content of a table cell
     */
    var ignoreTokenTypes = [
        __WEBPACK_IMPORTED_MODULE_5____["a" /* TokenType */].DOUBLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_5____["a" /* TokenType */].TRIPLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_5____["a" /* TokenType */].QUADRUPLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_5____["a" /* TokenType */].TABLE,
        __WEBPACK_IMPORTED_MODULE_5____["a" /* TokenType */].RULER,
    ];
    var output = [];
    var index = position;
    var currentState = processState.NEW_ROW;
    var buffer = '';
    var cellsBuffer = [];
    var cellStyle = '';
    var builder = null;
    while (index < input.length) {
        var char = input.charAt(index);
        var substring = input.substring(index);
        switch (currentState) {
            case processState.NEW_ROW: {
                var tableMatch = substring.match(CELL_REGEXP);
                if (tableMatch) {
                    if (!builder) {
                        builder = new __WEBPACK_IMPORTED_MODULE_0__builder_table_builder__["a" /* TableBuilder */](schema);
                    }
                    /* Capture empty spaces */
                    index += tableMatch[1].length;
                    cellStyle = tableMatch[2];
                    index += tableMatch[2].length;
                    currentState = processState.BUFFER;
                    continue;
                }
                currentState = processState.END_TABLE;
                continue;
            }
            case processState.LINE_BREAK: {
                /**
                 * If we encounter an empty line, we should end the table
                 */
                var emptyLineMatch = substring.match(EMPTY_LINE_REGEXP);
                if (emptyLineMatch) {
                    bufferToCells(cellStyle, buffer, cellsBuffer, schema, ignoreTokenTypes, tokenErrCallback);
                    currentState = processState.END_TABLE;
                    continue;
                }
                /**
                 * If we enconter a new row
                 */
                var cellMatch = substring.match(CELL_REGEXP);
                if (cellMatch) {
                    currentState = processState.CLOSE_ROW;
                }
                else {
                    currentState = processState.BUFFER;
                }
                continue;
            }
            case processState.BUFFER: {
                var length_1 = Object(__WEBPACK_IMPORTED_MODULE_6__whitespace__["a" /* parseNewlineOnly */])(substring);
                if (length_1) {
                    var charBefore = input.charAt(index - 1);
                    if (charBefore === '|' || charBefore.match(EMPTY_CELL_REGEXP)) {
                        currentState = processState.CLOSE_ROW;
                    }
                    else {
                        currentState = processState.LINE_BREAK;
                        buffer += input.substr(index, length_1);
                    }
                    index += length_1;
                    continue;
                }
                switch (char) {
                    case '|': {
                        /**
                         * This is now end of a cell, we should wrap the buffer into a cell
                         */
                        bufferToCells(cellStyle, buffer, cellsBuffer, schema, ignoreTokenTypes, tokenErrCallback);
                        buffer = '';
                        /**
                         * Update cells tyle
                         */
                        var cellMatch = substring.match(CELL_REGEXP);
                        /* The below if statement should aways be true, we leave it here to prevent any future code changes fall into infinite loop */
                        if (cellMatch) {
                            cellStyle = cellMatch[2];
                            /* Move into the cell content */
                            index += cellMatch[2].length;
                            /* Remove empty spaces after new cell */
                            index += cellMatch[3].length;
                            continue;
                        }
                        break;
                    }
                    case '[': {
                        currentState = processState.LINK;
                        continue;
                    }
                    case '!': {
                        currentState = processState.MEDIA;
                        continue;
                    }
                    case '{': {
                        currentState = processState.MACRO;
                        continue;
                    }
                    default: {
                        buffer += char;
                        index++;
                        continue;
                    }
                }
                break;
            }
            case processState.CLOSE_ROW: {
                bufferToCells(cellStyle, buffer, cellsBuffer, schema, ignoreTokenTypes, tokenErrCallback);
                buffer = '';
                if (builder) {
                    builder.add(cellsBuffer);
                    cellsBuffer = [];
                }
                currentState = processState.NEW_ROW;
                continue;
            }
            case processState.END_TABLE: {
                if (builder) {
                    if (cellsBuffer.length) {
                        builder.add(cellsBuffer);
                    }
                    output.push(builder.buildPMNode());
                }
                return {
                    type: 'pmnode',
                    nodes: output,
                    length: index - position,
                };
            }
            case processState.MEDIA: {
                var token = Object(__WEBPACK_IMPORTED_MODULE_4__media__["a" /* media */])(input, index, schema);
                buffer += input.substr(index, token.length);
                index += token.length;
                currentState = processState.BUFFER;
                continue;
            }
            case processState.LINK: {
                /**
                 * We should "fly over" the link format and we dont want
                 * -awesome [link|https://www.atlass-ian.com] nice
                 * to be a strike through because of the '-' in link
                 */
                var token = Object(__WEBPACK_IMPORTED_MODULE_3__links_link_format__["a" /* linkFormat */])(input, index, schema);
                if (token.type === 'text') {
                    buffer += token.text;
                    index += token.length;
                    currentState = processState.BUFFER;
                    continue;
                }
                else if (token.type === 'pmnode') {
                    buffer += input.substr(index, token.length);
                    index += token.length;
                    currentState = processState.BUFFER;
                    continue;
                }
                break;
            }
            case processState.MACRO: {
                var match = Object(__WEBPACK_IMPORTED_MODULE_7__keyword__["b" /* parseMacroKeyword */])(input.substring(index));
                if (!match) {
                    buffer += char;
                    currentState = processState.BUFFER;
                    break;
                }
                var token = Object(__WEBPACK_IMPORTED_MODULE_5____["b" /* parseToken */])(input, match.type, index, schema);
                buffer += input.substr(index, token.length);
                index += token.length;
                currentState = processState.BUFFER;
                continue;
            }
        }
        index++;
    }
    bufferToCells(cellStyle, buffer, cellsBuffer, schema, ignoreTokenTypes, tokenErrCallback);
    if (builder) {
        if (cellsBuffer.length) {
            builder.add(cellsBuffer);
        }
        output.push(builder.buildPMNode());
    }
    return {
        type: 'pmnode',
        nodes: output,
        length: index - position,
    };
}
function bufferToCells(style, buffer, cellsBuffer, schema, ignoreTokenTypes, tokenErrCallback) {
    if (buffer.length) {
        var contentNode = Object(__WEBPACK_IMPORTED_MODULE_1__text__["a" /* parseString */])(buffer, schema, ignoreTokenTypes, tokenErrCallback);
        cellsBuffer.push({
            style: style,
            content: Object(__WEBPACK_IMPORTED_MODULE_2__utils_normalize__["a" /* normalizePMNodes */])(contentNode, schema),
        });
    }
}
//# sourceMappingURL=table.js.map

/***/ }),
/* 2886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TableBuilder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

/**
 * Return the cell type based on the delimeter
 */
function getType(style) {
    return /\|\|/.test(style) ? 'tableHeader' : 'tableCell';
}
var TableBuilder = /** @class */ (function () {
    function TableBuilder(schema) {
        var _this = this;
        this.emptyTableCell = function () {
            var _a = _this.schema.nodes, tableCell = _a.tableCell, paragraph = _a.paragraph;
            return tableCell.createChecked({}, paragraph.createChecked());
        };
        this.emptyTableRow = function () {
            var tableRow = _this.schema.nodes.tableRow;
            return tableRow.createChecked({}, _this.emptyTableCell());
        };
        /**
         * Build prosemirror table node
         * @returns {PMNode}
         */
        this.buildTableNode = function () {
            var root = _this.root;
            var table = _this.schema.nodes.table;
            var content = root.rows.map(_this.buildTableRowNode);
            if (content.length === 0) {
                content.push(_this.emptyTableRow());
            }
            return table.createChecked({}, content);
        };
        /**
         * Build prosemirror tr node
         * @returns {PMNode}
         */
        this.buildTableRowNode = function (row) {
            var tableRow = _this.schema.nodes.tableRow;
            return tableRow.createChecked({}, row.cells.map(_this.buildTableCellNode));
        };
        /**
         * Build prosemirror td/th node
         * @param {TableCell} cell
         * @returns {PMNode}
         */
        this.buildTableCellNode = function (cell) {
            var type = cell.type, content = cell.content;
            if (content.length === 0) {
                content.push(_this.schema.nodes.paragraph.createChecked());
            }
            var cellNode = _this.schema.nodes[type];
            return cellNode.createChecked({}, content);
        };
        this.schema = schema;
        this.root = {
            rows: [],
        };
    }
    Object.defineProperty(TableBuilder.prototype, "type", {
        /**
         * Return the type of the base element
         * @returns {string}
         */
        get: function () {
            return 'table';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Add new cells to the table
     * @param {AddCellArgs[]} cells
     */
    TableBuilder.prototype.add = function (cells) {
        var e_1, _a;
        if (!cells.length) {
            return;
        }
        // Iterate the cells and create TH/TD based on the delimeter
        var index = 0;
        var cellType = getType(cells[0].style);
        try {
            for (var cells_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](cells), cells_1_1 = cells_1.next(); !cells_1_1.done; cells_1_1 = cells_1.next()) {
                var cell = cells_1_1.value;
                var content = cell.content;
                // For the first item, determine if it's a new row or not
                if (index === 0) {
                    this.addRow();
                }
                var newCell = { type: cellType, content: content };
                this.lastRow.cells.push(newCell);
                index += 1;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (cells_1_1 && !cells_1_1.done && (_a = cells_1.return)) _a.call(cells_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /**
     * Build a prosemirror table from the data
     * @returns {PMNode}
     */
    TableBuilder.prototype.buildPMNode = function () {
        return this.buildTableNode();
    };
    /**
     * Add a new row to the table
     */
    TableBuilder.prototype.addRow = function () {
        var rows = this.root.rows;
        var row = {
            cells: [],
        };
        rows.push(row);
        this.lastRow = row;
    };
    return TableBuilder;
}());

//# sourceMappingURL=table-builder.js.map

/***/ }),
/* 2887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tripleDashSymbol; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dash_token_creator__ = __webpack_require__(891);


var token = {
    type: 'text',
    text: '\u2014',
    length: 3,
};
var fallback = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, token, { text: '---' });
var tripleDashSymbol = Object(__WEBPACK_IMPORTED_MODULE_1__dash_token_creator__["a" /* createDashTokenParser */])(token, fallback);
//# sourceMappingURL=triple-dash-symbol.js.map

/***/ }),
/* 2888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = panelMacro;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_macro__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__text__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_attrs__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_normalize__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_panel_type__ = __webpack_require__(2889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_title__ = __webpack_require__(473);







var allowedNodeType = ['paragraph', 'heading', 'orderedList', 'bulletList'];
function panelMacro(input, position, schema, tokenErrCallback) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__common_macro__["a" /* commonMacro */])(input.substring(position), schema, {
        keyword: 'panel',
        paired: true,
        rawContentProcessor: rawContentProcessor,
        tokenErrCallback: tokenErrCallback,
    });
}
var rawContentProcessor = function (rawAttrs, rawContent, length, schema, tokenErrCallback) {
    var e_1, _a;
    var output = [];
    var parsedAttrs = Object(__WEBPACK_IMPORTED_MODULE_3__utils_attrs__["a" /* parseAttrs */])(rawAttrs);
    var nodeAttrs = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, parsedAttrs, { panelType: Object(__WEBPACK_IMPORTED_MODULE_5__utils_panel_type__["a" /* getPanelType */])(parsedAttrs) });
    var parsedContent = Object(__WEBPACK_IMPORTED_MODULE_2__text__["a" /* parseString */])(rawContent, schema, [], tokenErrCallback);
    var normalizedContent = Object(__WEBPACK_IMPORTED_MODULE_4__utils_normalize__["a" /* normalizePMNodes */])(parsedContent, schema);
    var contentBuffer = parsedAttrs.title
        ? [Object(__WEBPACK_IMPORTED_MODULE_6__utils_title__["a" /* title */])(parsedAttrs.title, schema)]
        : [];
    try {
        for (var normalizedContent_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](normalizedContent), normalizedContent_1_1 = normalizedContent_1.next(); !normalizedContent_1_1.done; normalizedContent_1_1 = normalizedContent_1.next()) {
            var n = normalizedContent_1_1.value;
            if (allowedNodeType.indexOf(n.type.name) !== -1) {
                contentBuffer.push(n);
            }
            else {
                var panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer.length
                    ? contentBuffer
                    : schema.nodes.paragraph.createChecked());
                contentBuffer = [];
                output.push(panelNode);
                output.push(n);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (normalizedContent_1_1 && !normalizedContent_1_1.done && (_a = normalizedContent_1.return)) _a.call(normalizedContent_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (contentBuffer.length > 0) {
        var panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer);
        output.push(panelNode);
    }
    return {
        type: 'pmnode',
        nodes: output.length ? output : [emptyPanel(schema)],
        length: length,
    };
};
function emptyPanel(schema) {
    var p = schema.nodes.paragraph.createChecked();
    return schema.nodes.panel.createChecked({}, p);
}
//# sourceMappingURL=panel-macro.js.map

/***/ }),
/* 2889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPanelType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color_name_mapping__ = __webpack_require__(2890);

var COLOR_TYPE_REGEX = {
    hexShort: /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
    hexLong: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
    rgb: /^#?rgb\((\d+),\s*(\d+),\s*(\d+)\)$/,
    prgb: /^#?rgb\((\d+)%,\s*(\d+)%,\s*(\d+)%\)$/,
};
var PANEL_TYPE_TO_RGB = {
    info: { r: 222, g: 235, b: 255 },
    note: { r: 234, g: 230, b: 255 },
    success: { r: 227, g: 252, b: 239 },
    warning: { r: 255, g: 250, b: 230 },
    error: { r: 255, g: 235, b: 230 },
};
function getPanelType(attrs) {
    var rgb = generateRgb(attrs.bgColor);
    if (!rgb) {
        return 'info';
    }
    var mapTo = 'info';
    var smallestDistance = Infinity;
    Object.keys(PANEL_TYPE_TO_RGB).forEach(function (panelType) {
        var distance = distanceOfRgb(PANEL_TYPE_TO_RGB[panelType], rgb);
        if (distance < smallestDistance) {
            smallestDistance = distance;
            mapTo = panelType;
        }
    });
    return mapTo;
}
function distanceOfRgb(a, b) {
    // https://en.wikipedia.org/wiki/Color_difference
    return (Math.pow(a.r - b.r, 2) + Math.pow(a.g - b.g, 2) + Math.pow(a.b - b.b, 2));
}
function generateRgb(color) {
    switch (true) {
        case COLOR_TYPE_REGEX.hexShort.test(color) ||
            COLOR_TYPE_REGEX.hexLong.test(color):
            return parseHex(color);
        case COLOR_TYPE_REGEX.rgb.test(color):
            return parseRgb(color);
        case COLOR_TYPE_REGEX.prgb.test(color):
            return parsePrgb(color);
        default:
            return parseColorName(color);
    }
}
function parseHex(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    hex = hex.replace(COLOR_TYPE_REGEX.hexShort, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var result = COLOR_TYPE_REGEX.hexLong.exec(hex);
    return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
        }
        : null;
}
function parseRgb(rgb) {
    var result = rgb.match(COLOR_TYPE_REGEX.rgb);
    return result
        ? {
            r: parseInt(result[1], 10),
            g: parseInt(result[2], 10),
            b: parseInt(result[3], 10),
        }
        : null;
}
function parsePrgb(prgb) {
    var result = prgb.match(COLOR_TYPE_REGEX.prgb);
    return result
        ? {
            r: Math.floor((255 * parseInt(result[1], 10)) / 100),
            g: Math.floor((255 * parseInt(result[2], 10)) / 100),
            b: Math.floor((255 * parseInt(result[4], 10)) / 100),
        }
        : null;
}
function parseColorName(color) {
    return __WEBPACK_IMPORTED_MODULE_0__color_name_mapping__["a" /* default */][color];
}
//# sourceMappingURL=panel-type.js.map

/***/ }),
/* 2890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mapping = {
    crimson: {
        r: 220,
        g: 20,
        b: 60,
    },
    lightpink: {
        r: 255,
        g: 182,
        b: 193,
    },
    pink: {
        r: 255,
        g: 192,
        b: 203,
    },
    palevioletred: {
        r: 219,
        g: 112,
        b: 147,
    },
    lavenderblush: {
        r: 255,
        g: 240,
        b: 245,
    },
    hotpink: {
        r: 255,
        g: 105,
        b: 180,
    },
    deeppink: {
        r: 255,
        g: 20,
        b: 147,
    },
    mediumvioletred: {
        r: 199,
        g: 21,
        b: 133,
    },
    orchid: {
        r: 218,
        g: 112,
        b: 214,
    },
    thistle: {
        r: 216,
        g: 191,
        b: 216,
    },
    plum: {
        r: 221,
        g: 160,
        b: 221,
    },
    violet: {
        r: 238,
        g: 130,
        b: 238,
    },
    fuchsia: {
        r: 255,
        g: 0,
        b: 255,
    },
    darkmagenta: {
        r: 139,
        g: 0,
        b: 139,
    },
    purple: {
        r: 128,
        g: 0,
        b: 128,
    },
    mediumorchid: {
        r: 186,
        g: 85,
        b: 211,
    },
    darkviolet: {
        r: 148,
        g: 0,
        b: 211,
    },
    darkorchid: {
        r: 153,
        g: 50,
        b: 204,
    },
    indigo: {
        r: 75,
        g: 0,
        b: 130,
    },
    blueviolet: {
        r: 138,
        g: 43,
        b: 226,
    },
    mediumpurple: {
        r: 147,
        g: 112,
        b: 219,
    },
    darkslateblue: {
        r: 72,
        g: 61,
        b: 139,
    },
    mediumslateblue: {
        r: 123,
        g: 104,
        b: 238,
    },
    slateblue: {
        r: 106,
        g: 90,
        b: 205,
    },
    ghostwhite: {
        r: 248,
        g: 248,
        b: 255,
    },
    lavender: {
        r: 230,
        g: 230,
        b: 250,
    },
    blue: {
        r: 0,
        g: 0,
        b: 255,
    },
    mediumblue: {
        r: 0,
        g: 0,
        b: 205,
    },
    darkblue: {
        r: 0,
        g: 0,
        b: 139,
    },
    navy: {
        r: 0,
        g: 0,
        b: 128,
    },
    midnightblue: {
        r: 25,
        g: 25,
        b: 112,
    },
    royalblue: {
        r: 65,
        g: 105,
        b: 225,
    },
    cornflowerblue: {
        r: 100,
        g: 149,
        b: 237,
    },
    lightsteelblue: {
        r: 176,
        g: 196,
        b: 222,
    },
    lightslategray: {
        r: 119,
        g: 136,
        b: 153,
    },
    slategray: {
        r: 112,
        g: 128,
        b: 144,
    },
    dodgerblue: {
        r: 30,
        g: 144,
        b: 255,
    },
    aliceblue: {
        r: 240,
        g: 248,
        b: 255,
    },
    steelblue: {
        r: 70,
        g: 130,
        b: 180,
    },
    lightskyblue: {
        r: 135,
        g: 206,
        b: 250,
    },
    skyblue: {
        r: 135,
        g: 206,
        b: 235,
    },
    deepskyblue: {
        r: 0,
        g: 191,
        b: 255,
    },
    lightblue: {
        r: 173,
        g: 216,
        b: 230,
    },
    powderblue: {
        r: 176,
        g: 224,
        b: 230,
    },
    cadetblue: {
        r: 95,
        g: 158,
        b: 160,
    },
    darkturquoise: {
        r: 0,
        g: 206,
        b: 209,
    },
    azure: {
        r: 240,
        g: 255,
        b: 255,
    },
    lightcyan: {
        r: 224,
        g: 255,
        b: 255,
    },
    paleturquoise: {
        r: 174,
        g: 238,
        b: 238,
    },
    darkslategray: {
        r: 47,
        g: 79,
        b: 79,
    },
    aqua: {
        r: 0,
        g: 255,
        b: 255,
    },
    darkcyan: {
        r: 0,
        g: 139,
        b: 139,
    },
    teal: {
        r: 0,
        g: 128,
        b: 128,
    },
    mediumturquoise: {
        r: 72,
        g: 209,
        b: 204,
    },
    lightseagreen: {
        r: 32,
        g: 178,
        b: 170,
    },
    turquoise: {
        r: 64,
        g: 224,
        b: 208,
    },
    aquamarine: {
        r: 127,
        g: 255,
        b: 212,
    },
    mediumaquamarine: {
        r: 102,
        g: 205,
        b: 170,
    },
    mediumspringgreen: {
        r: 0,
        g: 250,
        b: 154,
    },
    mintcream: {
        r: 245,
        g: 255,
        b: 250,
    },
    springgreen: {
        r: 0,
        g: 255,
        b: 127,
    },
    mediumseagreen: {
        r: 60,
        g: 179,
        b: 113,
    },
    seagreen: {
        r: 46,
        g: 139,
        b: 87,
    },
    honeydew: {
        r: 240,
        g: 255,
        b: 240,
    },
    darkseagreen: {
        r: 143,
        g: 188,
        b: 143,
    },
    palegreen: {
        r: 152,
        g: 251,
        b: 152,
    },
    lightgreen: {
        r: 144,
        g: 238,
        b: 144,
    },
    limegreen: {
        r: 50,
        g: 205,
        b: 50,
    },
    forestgreen: {
        r: 34,
        g: 139,
        b: 34,
    },
    lime: {
        r: 0,
        g: 255,
        b: 0,
    },
    green: {
        r: 0,
        g: 128,
        b: 0,
    },
    darkgreen: {
        r: 0,
        g: 100,
        b: 0,
    },
    lawngreen: {
        r: 124,
        g: 252,
        b: 0,
    },
    chartreuse: {
        r: 127,
        g: 255,
        b: 0,
    },
    greenyellow: {
        r: 173,
        g: 255,
        b: 47,
    },
    darkolivegreen: {
        r: 85,
        g: 107,
        b: 47,
    },
    olivedrab: {
        r: 107,
        g: 142,
        b: 35,
    },
    yellowgreen: {
        r: 154,
        g: 205,
        b: 50,
    },
    ivory: {
        r: 255,
        g: 255,
        b: 240,
    },
    beige: {
        r: 245,
        g: 245,
        b: 220,
    },
    lightyellow: {
        r: 255,
        g: 255,
        b: 224,
    },
    lightgoldenrodyellow: {
        r: 250,
        g: 250,
        b: 210,
    },
    yellow: {
        r: 255,
        g: 255,
        b: 0,
    },
    olive: {
        r: 128,
        g: 128,
        b: 0,
    },
    darkkhaki: {
        r: 189,
        g: 183,
        b: 107,
    },
    khaki: {
        r: 240,
        g: 230,
        b: 140,
    },
    palegoldenrod: {
        r: 238,
        g: 232,
        b: 170,
    },
    lemonchiffon: {
        r: 255,
        g: 250,
        b: 205,
    },
    gold: {
        r: 255,
        g: 215,
        b: 0,
    },
    cornsilk: {
        r: 255,
        g: 248,
        b: 220,
    },
    goldenrod: {
        r: 218,
        g: 165,
        b: 32,
    },
    darkgoldenrod: {
        r: 184,
        g: 134,
        b: 11,
    },
    orange: {
        r: 255,
        g: 128,
        b: 0,
    },
    floralwhite: {
        r: 255,
        g: 250,
        b: 240,
    },
    oldlace: {
        r: 253,
        g: 245,
        b: 230,
    },
    wheat: {
        r: 245,
        g: 222,
        b: 179,
    },
    moccasin: {
        r: 255,
        g: 228,
        b: 181,
    },
    papayawhip: {
        r: 255,
        g: 239,
        b: 213,
    },
    blanchedalmond: {
        r: 255,
        g: 235,
        b: 205,
    },
    navajowhite: {
        r: 255,
        g: 222,
        b: 173,
    },
    tan: {
        r: 210,
        g: 180,
        b: 140,
    },
    antiquewhite: {
        r: 250,
        g: 235,
        b: 215,
    },
    burlywood: {
        r: 222,
        g: 184,
        b: 135,
    },
    bisque: {
        r: 255,
        g: 228,
        b: 196,
    },
    darkorange: {
        r: 255,
        g: 140,
        b: 0,
    },
    peru: {
        r: 205,
        g: 133,
        b: 63,
    },
    linen: {
        r: 250,
        g: 240,
        b: 230,
    },
    peachpuff: {
        r: 255,
        g: 218,
        b: 185,
    },
    seashell: {
        r: 255,
        g: 245,
        b: 238,
    },
    sandybrown: {
        r: 244,
        g: 164,
        b: 96,
    },
    chocolate: {
        r: 210,
        g: 105,
        b: 30,
    },
    saddlebrown: {
        r: 139,
        g: 69,
        b: 19,
    },
    sienna: {
        r: 160,
        g: 82,
        b: 45,
    },
    lightsalmon: {
        r: 255,
        g: 160,
        b: 122,
    },
    coral: {
        r: 255,
        g: 127,
        b: 80,
    },
    orangered: {
        r: 255,
        g: 69,
        b: 0,
    },
    darksalmon: {
        r: 233,
        g: 150,
        b: 122,
    },
    tomato: {
        r: 255,
        g: 99,
        b: 71,
    },
    salmon: {
        r: 250,
        g: 128,
        b: 114,
    },
    mistyrose: {
        r: 255,
        g: 228,
        b: 225,
    },
    snow: {
        r: 255,
        g: 250,
        b: 250,
    },
    rosybrown: {
        r: 188,
        g: 143,
        b: 143,
    },
    lightcoral: {
        r: 240,
        g: 128,
        b: 128,
    },
    indianred: {
        r: 205,
        g: 92,
        b: 92,
    },
    brown: {
        r: 165,
        g: 42,
        b: 42,
    },
    firebrick: {
        r: 178,
        g: 34,
        b: 34,
    },
    red: {
        r: 255,
        g: 0,
        b: 0,
    },
    darkred: {
        r: 139,
        g: 0,
        b: 0,
    },
    maroon: {
        r: 128,
        g: 0,
        b: 0,
    },
    white: {
        r: 255,
        g: 255,
        b: 255,
    },
    gainsboro: {
        r: 220,
        g: 220,
        b: 220,
    },
    lightgray: {
        r: 211,
        g: 211,
        b: 211,
    },
    silver: {
        r: 192,
        g: 192,
        b: 192,
    },
    darkgray: {
        r: 169,
        g: 169,
        b: 169,
    },
    gray: {
        r: 128,
        g: 128,
        b: 128,
    },
    dimgray: {
        r: 105,
        g: 105,
        b: 105,
    },
    black: {
        r: 0,
        g: 0,
        b: 0,
    },
    whitesmoke: {
        r: 245,
        g: 245,
        b: 245,
    },
};
/* harmony default export */ __webpack_exports__["a"] = (mapping);
//# sourceMappingURL=color-name-mapping.js.map

/***/ }),
/* 2891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = adfMacro;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_macro__ = __webpack_require__(135);

function adfMacro(input, position, schema, tokenErrCallback) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__common_macro__["a" /* commonMacro */])(input.substring(position), schema, {
        keyword: 'adf',
        paired: true,
        rawContentProcessor: rawContentProcessor,
        tokenErrCallback: tokenErrCallback,
    });
}
var rawContentProcessor = function (rawAttrs, rawContent, length, schema, tokenErrCallback) {
    var json = JSON.parse(rawContent);
    var node = schema.nodeFromJSON(json);
    return {
        type: 'pmnode',
        nodes: [node],
        length: length,
    };
};
//# sourceMappingURL=adf-macro.js.map

/***/ }),
/* 2892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = anchorMacro;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_macro__ = __webpack_require__(135);

function anchorMacro(input, position, schema, tokenErrCallback) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__common_macro__["a" /* commonMacro */])(input.substring(position), schema, {
        keyword: 'anchor',
        paired: false,
        rawContentProcessor: rawContentProcessor,
        tokenErrCallback: tokenErrCallback,
    });
}
var rawContentProcessor = function (rawAttrs, rawContent, length, schema, tokenErrCallback) {
    return {
        type: 'text',
        text: '',
        length: length,
    };
};
//# sourceMappingURL=anchor-macro.js.map

/***/ }),
/* 2893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = codeMacro;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_macro__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_attrs__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_title__ = __webpack_require__(473);




var SUPPORTED_CODEBOCK_LANGUAGES = [
    'abap',
    'actionscript',
    'ada',
    'arduino',
    'autoit',
    'c',
    'c++',
    'clojure',
    'coffeescript',
    'csharp',
    'css',
    'cuda',
    'd',
    'dart',
    'delphi',
    'elixir',
    'erlang',
    'fortran',
    'foxpro',
    'go',
    'groovy',
    'haskell',
    'haxe',
    'html',
    'java',
    'javascript',
    'json',
    'julia',
    'kotlin',
    'latex',
    'livescript',
    'lua',
    'mathematica',
    'matlab',
    'objective-c',
    'objective-j',
    'objectpascal',
    'ocaml',
    'octave',
    'perl',
    'php',
    'powershell',
    'prolog',
    'puppet',
    'python',
    'qml',
    'r',
    'racket',
    'restructuredtext',
    'ruby',
    'rust',
    'sass',
    'scala',
    'scheme',
    'shell',
    'smalltalk',
    'sql',
    'standardml',
    'swift',
    'tcl',
    'tex',
    'typescript',
    'vala',
    'vbnet',
    'verilog',
    'vhdl',
    'xml',
    'xquery',
];
function codeMacro(input, position, schema, tokenErrCallback) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__common_macro__["a" /* commonMacro */])(input.substring(position), schema, {
        keyword: 'code',
        paired: true,
        rawContentProcessor: rawContentProcessor,
        tokenErrCallback: tokenErrCallback,
    });
}
var rawContentProcessor = function (rawAttrs, rawContent, length, schema, tokenErrCallback) {
    var output = [];
    var codeBlock = schema.nodes.codeBlock;
    var parsedAttrs = Object(__WEBPACK_IMPORTED_MODULE_2__utils_attrs__["a" /* parseAttrs */])(rawAttrs);
    var trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
    var textNode = trimedContent.length
        ? schema.text(trimedContent)
        : undefined;
    if (parsedAttrs.title) {
        output.push(Object(__WEBPACK_IMPORTED_MODULE_3__utils_title__["a" /* title */])(parsedAttrs.title, schema));
    }
    var nodeAttrs = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, parsedAttrs, { language: getCodeLanguage(parsedAttrs) });
    output.push(codeBlock.createChecked(nodeAttrs, textNode));
    return {
        type: 'pmnode',
        nodes: output,
        length: length,
    };
};
function getCodeLanguage(attrs) {
    var e_1, _a;
    var keys = Object.keys(attrs).map(function (key) { return key.toLowerCase(); });
    try {
        for (var SUPPORTED_CODEBOCK_LANGUAGES_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](SUPPORTED_CODEBOCK_LANGUAGES), SUPPORTED_CODEBOCK_LANGUAGES_1_1 = SUPPORTED_CODEBOCK_LANGUAGES_1.next(); !SUPPORTED_CODEBOCK_LANGUAGES_1_1.done; SUPPORTED_CODEBOCK_LANGUAGES_1_1 = SUPPORTED_CODEBOCK_LANGUAGES_1.next()) {
            var language = SUPPORTED_CODEBOCK_LANGUAGES_1_1.value;
            if (keys.indexOf(language) !== -1) {
                return language;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (SUPPORTED_CODEBOCK_LANGUAGES_1_1 && !SUPPORTED_CODEBOCK_LANGUAGES_1_1.done && (_a = SUPPORTED_CODEBOCK_LANGUAGES_1.return)) _a.call(SUPPORTED_CODEBOCK_LANGUAGES_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (keys.indexOf('objc') !== -1) {
        return 'objective-c';
    }
    return 'java';
}
//# sourceMappingURL=code-macro.js.map

/***/ }),
/* 2894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = colorMacro;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_macro__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_attrs__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__text__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__color__ = __webpack_require__(2895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_text__ = __webpack_require__(93);







function colorMacro(input, position, schema, tokenErrCallback) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__common_macro__["a" /* commonMacro */])(input.substring(position), schema, {
        keyword: 'color',
        paired: true,
        rawContentProcessor: rawContentProcessor,
        tokenErrCallback: tokenErrCallback,
    });
}
var rawContentProcessor = function (rawAttrs, rawContent, length, schema, tokenErrCallback) {
    var ignoreTokenTypes = [
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].DOUBLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].TRIPLE_DASH_SYMBOL,
        __WEBPACK_IMPORTED_MODULE_1____["a" /* TokenType */].QUADRUPLE_DASH_SYMBOL,
    ];
    var parsedAttrs = Object(__WEBPACK_IMPORTED_MODULE_3__utils_attrs__["a" /* parseAttrs */])(rawAttrs);
    var content = Object(__WEBPACK_IMPORTED_MODULE_4__text__["a" /* parseString */])(rawContent, schema, ignoreTokenTypes, tokenErrCallback);
    var decoratedContent = content.map(function (n) {
        var mark = schema.marks.textColor.create({
            color: Object(__WEBPACK_IMPORTED_MODULE_5__color__["a" /* getEditorColor */])(parsedAttrs) || '#000000',
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !Object(__WEBPACK_IMPORTED_MODULE_6__utils_text__["b" /* hasAnyOfMarks */])(n, ['textColor', 'code'])) {
            return n.mark(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](n.marks, [mark]));
        }
        return n;
    });
    return {
        type: 'pmnode',
        nodes: decoratedContent,
        length: length,
    };
};
//# sourceMappingURL=color-macro.js.map

/***/ }),
/* 2895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getEditorColor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_editor_common__ = __webpack_require__(893);

function getEditorColor(attrs) {
    var keys = Object.keys(attrs);
    return Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_editor_common__["a" /* normalizeHexColor */])(keys[0]);
}
//# sourceMappingURL=color.js.map

/***/ }),
/* 2896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeHexColor;
/* unused harmony export hexToRgb */
/* unused harmony export hexToRgba */
/* unused harmony export rgbToHex */
/* unused harmony export isRgb */
/* unused harmony export isHex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_css_color_names__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_css_color_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_css_color_names__);


/**
 * @return String with HEX-coded color
 */
function normalizeHexColor(color, defaultColor) {
    if (!color) {
        return null;
    }
    // Normalize to hex
    color = color.trim().toLowerCase();
    if (isHex(color)) {
        // Normalize 3-hex to 6-hex colours
        if (color.length === 4) {
            color = color
                .split('')
                .map(function (c) { return (c === '#' ? '#' : "" + c + c); })
                .join('');
        }
    }
    else if (isRgb(color)) {
        return rgbToHex(color);
    }
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (__WEBPACK_IMPORTED_MODULE_1_css_color_names__["default"] && __WEBPACK_IMPORTED_MODULE_1_css_color_names__["default"][color]) {
            color = __WEBPACK_IMPORTED_MODULE_1_css_color_names__["default"][color];
        }
        else if (__WEBPACK_IMPORTED_MODULE_1_css_color_names__ && __WEBPACK_IMPORTED_MODULE_1_css_color_names__[color]) {
            color = __WEBPACK_IMPORTED_MODULE_1_css_color_names__[color];
        }
        else {
            return null;
        }
    }
    if (color === defaultColor) {
        return null;
    }
    return color;
}
/**
 * Converts hex color format to rgb.
 * Works well with full hex color format and shortcut as well.
 *
 * @param hex - hex color string (#xxx, or #xxxxxx)
 */
function hexToRgb(color) {
    if (!isHex(color)) {
        return null;
    }
    var colorBits = color.substring(1).split('');
    if (colorBits.length === 3) {
        colorBits = [
            colorBits[0],
            colorBits[0],
            colorBits[1],
            colorBits[1],
            colorBits[2],
            colorBits[2],
        ];
    }
    var rgb = Number("0x" + colorBits.join(''));
    // tslint:disable-next-line:no-bitwise
    return "rgb(" + ((rgb >> 16) & 255) + "," + ((rgb >> 8) & 255) + "," + (rgb & 255) + ")";
}
/**
 * Converts hex color format to rgba.
 *
 * @param hex - hex color string (#xxx, or #xxxxxx)
 */
function hexToRgba(rawColor, alpha) {
    var color = normalizeHexColor(rawColor);
    if (!color) {
        return null;
    }
    var hex2rgb = function (color) {
        return color.match(/[a-z0-9]{2}/gi).map(function (hex) { return parseInt(hex, 16); });
    };
    return "rgba(" + hex2rgb(color)
        .concat(alpha)
        .join(',') + ")";
}
function rgbToHex(value) {
    var matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](matches.map(Number), 3), red = _a[0], green = _a[1], blue = _a[2];
        return ('#' +
            (blue | (green << 8) | (red << 16) | (1 << 24)).toString(16).slice(1) // tslint:disable-line:no-bitwise
        );
    }
    return null;
}
function isRgb(color) {
    return /rgba?\(/.test(color);
}
function isHex(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}
//# sourceMappingURL=color.js.map

/***/ }),
/* 2897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getExtensionLozengeData */
var getExtensionLozengeData = function (_a) {
    var node = _a.node, type = _a.type;
    if (!node.attrs.parameters) {
        return;
    }
    var macroMetadata = node.attrs.parameters.macroMetadata;
    if (macroMetadata && macroMetadata.placeholder) {
        var placeholderData_1;
        macroMetadata.placeholder.forEach(function (placeholder) {
            if (placeholder.type === type &&
                placeholder.data &&
                placeholder.data.url) {
                placeholderData_1 = placeholder.data;
            }
        });
        return placeholderData_1;
    }
};
//# sourceMappingURL=macro.js.map

/***/ }),
/* 2898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export markOrder */
/* unused harmony export isSubSupType */
/* unused harmony export getMarksByOrder */
/* unused harmony export isSameMark */
/* unused harmony export getValidDocument */
/* unused harmony export getValidContent */
/* unused harmony export getValidUnknownNode */
/* unused harmony export getValidNode */
/* unused harmony export getValidMark */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__ = __webpack_require__(19);


/*
 * It's important that this order follows the marks rank defined here:
 * https://product-fabric.atlassian.net/wiki/spaces/E/pages/11174043/Document+structure#Documentstructure-Rank
 */
var markOrder = [
    'link',
    'em',
    'strong',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'textColor',
];
var isSubSupType = function (type) {
    return type === 'sub' || type === 'sup';
};
/*
 * Sorts mark by the predefined order above
 */
var getMarksByOrder = function (marks) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](marks).sort(function (a, b) { return markOrder.indexOf(a.type.name) - markOrder.indexOf(b.type.name); });
};
/*
 * Check if two marks are the same by comparing type and attrs
 */
var isSameMark = function (mark, otherMark) {
    if (!mark || !otherMark) {
        return false;
    }
    return mark.eq(otherMark);
};
var getValidDocument = function (doc, schema, adfStage) {
    if (schema === void 0) { schema = __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["x" /* defaultSchema */]; }
    if (adfStage === void 0) { adfStage = 'final'; }
    var node = getValidNode(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
var wrapInlineNodes = function (nodes) {
    if (nodes === void 0) { nodes = []; }
    return nodes.map(function (node) {
        return __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["K" /* inlineNodes */].has(node.type) ? { type: 'paragraph', content: [node] } : node;
    });
};
var getValidContent = function (content, schema, adfStage) {
    if (schema === void 0) { schema = __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["x" /* defaultSchema */]; }
    if (adfStage === void 0) { adfStage = 'final'; }
    return content.map(function (node) { return getValidNode(node, schema, adfStage); });
};
var TEXT_COLOR_PATTERN = /^#[0-9a-f]{6}$/i;
var RELATIVE_LINK = /^\//;
var flattenUnknownBlockTree = function (node, schema, adfStage) {
    if (schema === void 0) { schema = __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["x" /* defaultSchema */]; }
    if (adfStage === void 0) { adfStage = 'final'; }
    var output = [];
    var isPrevLeafNode = false;
    for (var i = 0; i < node.content.length; i++) {
        var childNode = node.content[i];
        var isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) {
                output.push({ type: 'text', text: ' ' });
            }
            else {
                output.push({ type: 'hardBreak' });
            }
        }
        if (isLeafNode) {
            output.push(getValidNode(childNode, schema, adfStage));
        }
        else {
            output.push.apply(output, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](flattenUnknownBlockTree(childNode, schema, adfStage)));
        }
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
// null is Object, also maybe check obj.constructor == Object if we want to skip Class
var isValidObject = function (obj) { return obj !== null && typeof obj === 'object'; };
var isValidString = function (str) { return typeof str === 'string'; };
var keysLen = function (obj) { return Object.keys(obj).length; };
var isValidIcon = function (icon) {
    return isValidObject(icon) &&
        keysLen(icon) === 2 &&
        isValidString(icon.url) &&
        isValidString(icon.label);
};
var isValidUser = function (user) {
    var len = keysLen(user);
    return (isValidObject(user) &&
        len <= 2 &&
        isValidIcon(user.icon) &&
        (len === 1 || isValidString(user.id)));
};
/**
 * Sanitize unknown node tree
 *
 * @see https://product-fabric.atlassian.net/wiki/spaces/E/pages/11174043/Document+structure#Documentstructure-ImplementationdetailsforHCNGwebrenderer
 */
var getValidUnknownNode = function (node) {
    var _a = node.attrs, attrs = _a === void 0 ? {} : _a, content = node.content, text = node.text, type = node.type;
    if (!content || !content.length) {
        var unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || "[" + type + "]",
        };
        var textUrl = attrs.textUrl;
        if (textUrl && Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["L" /* isSafeUrl */])(textUrl)) {
            unknownInlineNode.marks = [
                {
                    type: 'link',
                    attrs: {
                        href: textUrl,
                    },
                },
            ];
        }
        return unknownInlineNode;
    }
    /*
     * Find leaf nodes and join them. If leaf nodes' parent node is the same node
     * join with a blank space, otherwise they are children of different branches, i.e.
     * we need to join them with a hardBreak node
     */
    return {
        type: 'unknownBlock',
        content: flattenUnknownBlockTree(node),
    };
};
/*
 * This method will validate a Node according to the spec defined here
 * https://product-fabric.atlassian.net/wiki/spaces/E/pages/11174043/Document+structure#Documentstructure-Nodes
 *
 * This is also the place to handle backwards compatibility.
 *
 * If a node is not recognized or is missing required attributes, we should return 'unknown'
 *
 */
var getValidNode = function (originalNode, schema, adfStage) {
    if (schema === void 0) { schema = __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["x" /* defaultSchema */]; }
    if (adfStage === void 0) { adfStage = 'final'; }
    var attrs = originalNode.attrs, marks = originalNode.marks, text = originalNode.text, type = originalNode.type;
    var content = originalNode.content;
    var node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type,
    };
    if (content) {
        node.content = content = getValidContent(content, schema, adfStage);
    }
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) {
        return getValidUnknownNode(node);
    }
    if (type) {
        switch (type) {
            case 'applicationCard': {
                if (!attrs) {
                    break;
                }
                var text_1 = attrs.text, link = attrs.link, background = attrs.background, preview = attrs.preview, title = attrs.title, description = attrs.description, details = attrs.details, actions = attrs.actions, context = attrs.context;
                if (!isValidString(text_1) || !isValidObject(title) || !title.text) {
                    break;
                }
                // title can contain at most two keys (text, user)
                var titleKeys = Object.keys(title);
                if (titleKeys.length > 2) {
                    break;
                }
                if (titleKeys.length === 2 && !title.user) {
                    break;
                }
                if (title.user && !isValidUser(title.user)) {
                    break;
                }
                if ((link && !link.url) ||
                    (background && !background.url) ||
                    (preview && !preview.url) ||
                    (description && !description.text)) {
                    break;
                }
                if (context && !isValidString(context.text)) {
                    break;
                }
                if (context && (context.icon && !isValidIcon(context.icon))) {
                    break;
                }
                if (actions && !Array.isArray(actions)) {
                    break;
                }
                if (actions && !actions.length) {
                    break;
                }
                if (actions &&
                    actions.some(function (meta) {
                        var key = meta.key, title = meta.title, target = meta.target, parameters = meta.parameters;
                        if (key && !isValidString(key)) {
                            return true;
                        }
                        if (!isValidString(title)) {
                            return true;
                        }
                        if (!target) {
                            return true;
                        }
                        if (!isValidString(target.key)) {
                            return true;
                        }
                        if (target.receiver && !isValidString(target.receiver)) {
                            return true;
                        }
                        if (parameters && !isValidObject(parameters)) {
                            return true;
                        }
                    })) {
                    break;
                }
                if (details && !Array.isArray(details)) {
                    break;
                }
                if (details &&
                    details.some(function (meta) {
                        var badge = meta.badge, lozenge = meta.lozenge, users = meta.users;
                        if (badge && typeof badge.value !== 'number') {
                            return true;
                        }
                        if (lozenge && !lozenge.text) {
                            return true;
                        }
                        if (users && !Array.isArray(users)) {
                            return true;
                        }
                        if (users && !users.every(isValidUser)) {
                            return true;
                        }
                    })) {
                    break;
                }
                return {
                    type: type,
                    text: text_1,
                    attrs: attrs,
                };
            }
            case 'doc': {
                var version = originalNode.version;
                if (version && content && content.length) {
                    return {
                        type: type,
                        content: content,
                    };
                }
                break;
            }
            case 'codeBlock': {
                if (content) {
                    content = content.reduce(function (acc, val) {
                        if (val.type === 'text') {
                            acc.push({ type: val.type, text: val.text });
                        }
                        return acc;
                    }, []);
                }
                if (attrs && attrs.language) {
                    return {
                        type: type,
                        attrs: attrs,
                        content: content,
                        marks: marks,
                    };
                }
                return {
                    type: type,
                    content: content,
                    marks: marks,
                };
            }
            case 'date': {
                if (attrs && attrs.timestamp) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'status': {
                if (attrs && attrs.text && attrs.color) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'emoji': {
                if (attrs && attrs.shortName) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'inlineExtension':
            case 'extension': {
                if (attrs && attrs.extensionType && attrs.extensionKey) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'inlineCard':
            case 'blockCard': {
                if (attrs && (attrs.url || attrs.data)) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'bodiedExtension': {
                if (attrs && attrs.extensionType && attrs.extensionKey && content) {
                    return {
                        type: type,
                        attrs: attrs,
                        content: content,
                    };
                }
                break;
            }
            case 'hardBreak': {
                return {
                    type: type,
                };
            }
            case 'media': {
                var mediaId = '';
                var mediaType = '';
                var mediaCollection = [];
                var mediaUrl = '';
                if (attrs) {
                    var id = attrs.id, collection = attrs.collection, type_1 = attrs.type, url = attrs.url;
                    mediaId = id;
                    mediaType = type_1;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    return {
                        type: type,
                        attrs: {
                            type: mediaType,
                            url: mediaUrl,
                            width: attrs.width,
                            height: attrs.height,
                        },
                    };
                }
                else if (mediaId && mediaType) {
                    var mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection,
                    };
                    if (attrs.width) {
                        mediaAttrs.width = attrs.width;
                    }
                    if (attrs.height) {
                        mediaAttrs.height = attrs.height;
                    }
                    return {
                        type: type,
                        attrs: mediaAttrs,
                    };
                }
                break;
            }
            case 'mediaGroup': {
                if (Array.isArray(content) && !content.some(function (e) { return e.type !== 'media'; })) {
                    return {
                        type: type,
                        content: content,
                    };
                }
                break;
            }
            case 'mediaSingle': {
                if (Array.isArray(content) &&
                    content.length === 1 &&
                    content[0].type === 'media') {
                    return {
                        type: type,
                        attrs: attrs,
                        content: content,
                        marks: marks,
                    };
                }
                break;
            }
            case 'mention': {
                var mentionText = '';
                var mentionId = void 0;
                var mentionAccess = void 0;
                if (attrs) {
                    var text_2 = attrs.text, displayName = attrs.displayName, id = attrs.id, accessLevel = attrs.accessLevel;
                    mentionText = text_2 || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                }
                if (!mentionText) {
                    mentionText = text || '@unknown';
                }
                if (mentionText && mentionId) {
                    var mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                        },
                    };
                    if (mentionAccess) {
                        mentionNode.attrs['accessLevel'] = mentionAccess;
                    }
                    return mentionNode;
                }
                break;
            }
            case 'paragraph': {
                return marks
                    ? {
                        type: type,
                        content: content || [],
                        marks: marks,
                    }
                    : { type: type, content: content || [] };
            }
            case 'rule': {
                return {
                    type: type,
                };
            }
            case 'text': {
                var marks_1 = node.marks;
                if (text) {
                    if (marks_1) {
                        marks_1 = marks_1.reduce(function (acc, mark) {
                            var validMark = getValidMark(mark, adfStage);
                            if (validMark) {
                                acc.push(validMark);
                            }
                            return acc;
                        }, []);
                    }
                    return marks_1 ? { type: type, text: text, marks: marks_1 } : { type: type, text: text };
                }
                break;
            }
            case 'heading': {
                if (attrs) {
                    var level = attrs.level;
                    var between = function (x, a, b) { return x >= a && x <= b; };
                    if (level && between(level, 1, 6)) {
                        return marks
                            ? {
                                type: type,
                                content: content,
                                marks: marks,
                                attrs: {
                                    level: level,
                                },
                            }
                            : {
                                type: type,
                                content: content,
                                attrs: {
                                    level: level,
                                },
                            };
                    }
                }
                break;
            }
            case 'bulletList': {
                if (content) {
                    return {
                        type: type,
                        content: content,
                    };
                }
                break;
            }
            case 'orderedList': {
                if (content) {
                    return {
                        type: type,
                        content: content,
                        attrs: {
                            order: attrs && attrs.order,
                        },
                    };
                }
                break;
            }
            case 'listItem': {
                if (content) {
                    return {
                        type: type,
                        content: wrapInlineNodes(content),
                    };
                }
                break;
            }
            case 'blockquote': {
                if (content) {
                    return {
                        type: type,
                        content: content,
                    };
                }
                break;
            }
            case 'panel': {
                var types = ['info', 'note', 'tip', 'success', 'warning', 'error'];
                if (attrs && content) {
                    var panelType = attrs.panelType;
                    if (types.indexOf(panelType) > -1) {
                        return {
                            type: type,
                            attrs: { panelType: panelType },
                            content: content,
                        };
                    }
                }
                break;
            }
            case 'layoutSection': {
                if (content) {
                    return {
                        type: type,
                        marks: marks,
                        content: content,
                    };
                }
                break;
            }
            case 'layoutColumn': {
                if (attrs && content) {
                    if (attrs.width > 0 && attrs.width <= 100) {
                        return {
                            type: type,
                            content: content,
                            attrs: attrs,
                        };
                    }
                }
                break;
            }
            case 'decisionList': {
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: (attrs && attrs.localId) || Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["D" /* generateUuid */])(),
                    },
                };
            }
            case 'decisionItem': {
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: (attrs && attrs.localId) || Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["D" /* generateUuid */])(),
                        state: (attrs && attrs.state) || 'DECIDED',
                    },
                };
            }
            case 'taskList': {
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: (attrs && attrs.localId) || Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["D" /* generateUuid */])(),
                    },
                };
            }
            case 'taskItem': {
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: (attrs && attrs.localId) || Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["D" /* generateUuid */])(),
                        state: (attrs && attrs.state) || 'TODO',
                    },
                };
            }
            case 'table': {
                if (Array.isArray(content) &&
                    content.length > 0 &&
                    !content.some(function (e) { return e.type !== 'tableRow'; })) {
                    return {
                        type: type,
                        content: content,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'tableRow': {
                if (Array.isArray(content) &&
                    content.length > 0 &&
                    !content.some(function (e) { return e.type !== 'tableCell' && e.type !== 'tableHeader'; })) {
                    return {
                        type: type,
                        content: content,
                    };
                }
                break;
            }
            case 'tableCell':
            case 'tableHeader': {
                if (content) {
                    var cellAttrs = {};
                    if (attrs) {
                        if (attrs.colspan && attrs.colspan > 1) {
                            cellAttrs.colspan = attrs.colspan;
                        }
                        if (attrs.rowspan && attrs.rowspan > 1) {
                            cellAttrs.rowspan = attrs.rowspan;
                        }
                        if (attrs.background) {
                            cellAttrs.background = attrs.background;
                        }
                        if (attrs.colwidth && Array.isArray(attrs.colwidth)) {
                            cellAttrs.colwidth = attrs.colwidth;
                        }
                    }
                    return {
                        type: type,
                        content: wrapInlineNodes(content),
                        attrs: attrs ? cellAttrs : undefined,
                    };
                }
                break;
            }
            case 'image': {
                if (attrs && attrs.src) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'placeholder': {
                if (attrs && typeof attrs.text !== 'undefined') {
                    return { type: type, attrs: attrs };
                }
                break;
            }
        }
    }
    return getValidUnknownNode(node);
};
/*
 * This method will validate a Mark according to the spec defined here
 * https://product-fabric.atlassian.net/wiki/spaces/E/pages/11174043/Document+structure#Documentstructure-Marks
 *
 * This is also the place to handle backwards compatibility.
 *
 * If a node is not recognized or is missing required attributes, we should return null
 *
 */
var getValidMark = function (mark, adfStage) {
    if (adfStage === void 0) { adfStage = 'final'; }
    var attrs = mark.attrs, type = mark.type;
    if (type) {
        switch (type) {
            case 'action': {
                if (attrs && attrs.target && attrs.target.key) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'code': {
                return {
                    type: type,
                };
            }
            case 'em': {
                return {
                    type: type,
                };
            }
            case 'link': {
                if (attrs) {
                    var href = attrs.href, url = attrs.url, __confluenceMetadata = attrs.__confluenceMetadata;
                    var linkHref = href || url;
                    if (linkHref &&
                        linkHref.indexOf(':') === -1 &&
                        !RELATIVE_LINK.test(linkHref)) {
                        linkHref = "http://" + linkHref;
                    }
                    var linkAttrs = {
                        href: linkHref,
                    };
                    if (__confluenceMetadata) {
                        linkAttrs.__confluenceMetadata = __confluenceMetadata;
                    }
                    if (linkHref && Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["L" /* isSafeUrl */])(linkHref)) {
                        return {
                            type: type,
                            attrs: linkAttrs,
                        };
                    }
                }
                break;
            }
            case 'strike': {
                return {
                    type: type,
                };
            }
            case 'strong': {
                return {
                    type: type,
                };
            }
            case 'subsup': {
                if (attrs && attrs['type']) {
                    var subSupType = attrs['type'];
                    if (isSubSupType(subSupType)) {
                        return {
                            type: type,
                            attrs: {
                                type: subSupType,
                            },
                        };
                    }
                }
                break;
            }
            case 'textColor': {
                if (attrs && TEXT_COLOR_PATTERN.test(attrs.color)) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'underline': {
                return {
                    type: type,
                };
            }
        }
    }
    if (adfStage === 'stage0') {
        switch (type) {
            case 'confluenceInlineComment': {
                return {
                    type: type,
                    attrs: attrs,
                };
            }
        }
    }
    return null;
};
//# sourceMappingURL=validator.js.map

/***/ }),
/* 2899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    ios: false,
    webkit: false,
};
if (typeof navigator !== 'undefined') {
    var ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    var ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    var ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    result.mac = /Mac/.test(navigator.platform);
    var ie = (result.ie = !!(ieUpTo10 || ie11up || ieEdge));
    result.ie_version = ieUpTo10
        ? document.documentMode || 6
        : ie11up
            ? +ie11up[1]
            : ieEdge
                ? +ieEdge[1]
                : null;
    result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    result.ios =
        !ie &&
            /AppleWebKit/.test(navigator.userAgent) &&
            /Mobile\/\w+/.test(navigator.userAgent);
    result.webkit =
        !ie &&
            !!document.documentElement &&
            'WebkitAppearance' in document.documentElement.style;
}
/* unused harmony default export */ var _unused_webpack_default_export = (result);
//# sourceMappingURL=browser.js.map

/***/ }),
/* 2900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ErrorReporter = /** @class */ (function () {
    function ErrorReporter() {
        this.handlerStorage = null;
    }
    ErrorReporter.prototype.captureMessage = function (msg, tags) {
        if (this.handlerStorage) {
            this.handlerStorage.captureMessage(msg, tags);
        }
    };
    ErrorReporter.prototype.captureException = function (err, tags) {
        if (this.handlerStorage) {
            this.handlerStorage.captureException(err, tags);
        }
    };
    Object.defineProperty(ErrorReporter.prototype, "handler", {
        set: function (handler) {
            this.handlerStorage = handler;
        },
        enumerable: true,
        configurable: true
    });
    return ErrorReporter;
}());
/* unused harmony default export */ var _unused_webpack_default_export = (ErrorReporter);
//# sourceMappingURL=error-reporter.js.map

/***/ }),
/* 2901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export timestampToUTCDate */
/* unused harmony export timestampToString */
/* unused harmony export timestampToIsoFormat */
/* unused harmony export isPastDate */
/* unused harmony export timestampToTaskContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_is_before__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_is_before___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_is_before__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_difference_in_calendar_days__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_difference_in_calendar_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_difference_in_calendar_days__);


var ISO_FORMAT = 'YYYY-MM-DD';
var DEFAULT_FORMAT = 'DD MMM YYYY';
var timestampToUTCDate = function (timestamp) {
    var date = new Date(Number(timestamp));
    var day = date.getUTCDate();
    var month = date.getUTCMonth() + 1;
    var year = date.getUTCFullYear();
    return { day: day, month: month, year: year };
};
var addLeadingZero = function (val) {
    if (val < 10) {
        return "0" + val;
    }
    return val;
};
var months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];
var week_days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
// example: "23 Jan 2018"
var timestampToString = function (timestamp, pattern) {
    var date = new Date(Number(timestamp));
    switch (pattern) {
        case 'ddd, DD MMM':
            return week_days[date.getUTCDay()] + ", " + addLeadingZero(date.getUTCDate()) + " " + months[date.getUTCMonth()];
        case ISO_FORMAT:
            return date.getUTCFullYear() + "-" + addLeadingZero(date.getUTCMonth() + 1) + "-" + date.getUTCDate();
        default:
            return addLeadingZero(date.getUTCDate()) + " " + months[date.getUTCMonth()] + " " + date.getUTCFullYear();
    }
};
// example: "2018-01-23"
var timestampToIsoFormat = function (timestamp) {
    return timestampToString(timestamp, ISO_FORMAT);
};
var isPastDate = function (timestamp) {
    return __WEBPACK_IMPORTED_MODULE_0_date_fns_is_before__(timestampToIsoFormat(Number(timestamp)), timestampToIsoFormat(new Date().valueOf()));
};
var timestampToTaskContext = function (timestamp) {
    var curDate = new Date();
    var givenDate = new Date(Number(timestamp));
    var distance = __WEBPACK_IMPORTED_MODULE_1_date_fns_difference_in_calendar_days__(givenDate, curDate);
    var sameYear = givenDate.getUTCFullYear() === curDate.getUTCFullYear();
    var pattern = '';
    if (distance === 0) {
        return 'Today';
    }
    else if (distance === 1) {
        return 'Tomorrow';
    }
    else if (distance === -1) {
        pattern = 'Yesterday';
    }
    else if (sameYear) {
        pattern = 'ddd, DD MMM';
    }
    else {
        pattern = DEFAULT_FORMAT;
    }
    return timestampToString(timestamp, pattern);
};
//# sourceMappingURL=date.js.map

/***/ }),
/* 2902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export withImageLoader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



var withImageLoader = function (Wrapped) {
    return /** @class */ (function (_super) {
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WithImageLoader, _super);
        function WithImageLoader() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = {
                imageStatus: 'loading',
            };
            _this.onLoad = function () {
                _this.setState({
                    imageStatus: 'complete',
                });
                var onExternalImageLoaded = _this.props.onExternalImageLoaded;
                if (onExternalImageLoaded && _this.img) {
                    onExternalImageLoaded({
                        width: _this.img.naturalWidth,
                        height: _this.img.naturalHeight,
                    });
                }
            };
            _this.onError = function () {
                _this.setState({
                    imageStatus: 'error',
                });
            };
            return _this;
        }
        WithImageLoader.prototype.componentDidMount = function () {
            this.fetchImage(this.props);
        };
        WithImageLoader.prototype.componentWillReceiveProps = function (nextProps) {
            if (nextProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading',
                });
                this.fetchImage(nextProps);
            }
        };
        WithImageLoader.prototype.componentWillUnmount = function () {
            if (this.img) {
                this.img.removeEventListener('load', this.onLoad);
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        };
        WithImageLoader.prototype.fetchImage = function (_a) {
            var url = _a.url;
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    this.img.addEventListener('load', this.onLoad);
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        };
        WithImageLoader.prototype.render = function () {
            var imageStatus = this.state.imageStatus;
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Wrapped, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, this.props, { imageStatus: imageStatus }));
        };
        return WithImageLoader;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
};
//# sourceMappingURL=imageLoader.js.map

/***/ }),
/* 2903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calcBreakoutWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calcWideWidth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui__ = __webpack_require__(895);


var calcBreakoutWidth = function (layout, containerWidth) {
    var effectiveFullWidth = containerWidth - __WEBPACK_IMPORTED_MODULE_0__styles__["a" /* akEditorBreakoutPadding */];
    switch (layout) {
        case 'full-width':
            return effectiveFullWidth <= __WEBPACK_IMPORTED_MODULE_0__styles__["d" /* akEditorFullPageMaxWidth */]
                ? '100%'
                : effectiveFullWidth + "px";
        case 'wide':
            return calcWideWidth(containerWidth);
        default:
            return 'inherit';
    }
};
var calcWideWidth = function (containerWidth, maxWidth, fallback) {
    if (containerWidth === void 0) { containerWidth = __WEBPACK_IMPORTED_MODULE_0__styles__["b" /* akEditorDefaultLayoutWidth */]; }
    if (maxWidth === void 0) { maxWidth = Infinity; }
    if (fallback === void 0) { fallback = '100%'; }
    var effectiveFullWidth = containerWidth - __WEBPACK_IMPORTED_MODULE_0__styles__["a" /* akEditorBreakoutPadding */];
    var layoutMaxWidth = Object(__WEBPACK_IMPORTED_MODULE_1__ui__["b" /* mapBreakpointToLayoutMaxWidth */])(Object(__WEBPACK_IMPORTED_MODULE_1__ui__["a" /* getBreakpoint */])(containerWidth));
    var wideWidth = Math.min(Math.ceil(layoutMaxWidth * __WEBPACK_IMPORTED_MODULE_0__styles__["e" /* breakoutWideScaleRatio */]), effectiveFullWidth);
    return layoutMaxWidth > wideWidth
        ? fallback
        : Math.min(maxWidth, wideWidth) + "px";
};
//# sourceMappingURL=calc-breakout-width.js.map

/***/ }),
/* 2904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export tableMarginTop */
/* unused harmony export tableMarginBottom */
/* unused harmony export tableMarginSides */
/* unused harmony export tableCellMinWidth */
/* unused harmony export TableSharedCssClassName */
/* unused harmony export calcTableWidth */
/* unused harmony export tableSharedStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__panel__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(474);






var tableMarginTop = 24;
var tableMarginBottom = 16;
var tableMarginSides = 8;
var tableCellMinWidth = 48;
var clPrefix = 'pm-table-';
var TableSharedCssClassName = {
    TABLE_CONTAINER: clPrefix + "container",
    TABLE_NODE_WRAPPER: clPrefix + "wrapper",
    TABLE_LEFT_SHADOW: clPrefix + "with-left-shadow",
    TABLE_RIGHT_SHADOW: clPrefix + "with-right-shadow",
    TABLE_CELL_NODEVIEW_CONTENT_DOM: clPrefix + "cell-nodeview-content-dom",
};
var tableSharedStyle = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .", " {\n    position: relative;\n    margin: 0 auto ", "px;\n    box-sizing: border-box;\n\n    /**\n     * Fix block top alignment inside table cells.\n     */\n    .code-block,\n    .", ",\n    .taskItemView-content-wrap > div,\n    .decisionItemView-content-wrap > div {\n      margin-top: 0;\n    }\n  }\n  .", "[data-number-column='true'] {\n    padding-left: ", "px;\n  }\n  /* avoid applying styles to nested tables (possible via extensions) */\n  .", " > table,\n  .", " > table {\n    border-collapse: collapse;\n    margin: ", "px ", "px 0;\n    border: 1px solid ", ";\n    table-layout: fixed;\n    font-size: ", "px;\n    width: 100%;\n\n    &[data-autosize='true'] {\n      table-layout: auto;\n    }\n\n    & {\n      * {\n        box-sizing: border-box;\n      }\n\n      tbody {\n        border-bottom: none;\n      }\n      th td {\n        background-color: white;\n        font-weight: normal;\n      }\n      th,\n      td {\n        min-width: ", "px;\n        height: 3em;\n        vertical-align: top;\n        border: 1px solid ", ";\n        border-right-width: 0;\n        border-bottom-width: 0;\n        padding: 10px;\n        /* https://stackoverflow.com/questions/7517127/borders-not-shown-in-firefox-with-border-collapse-on-table-position-relative-o */\n        background-clip: padding-box;\n\n        th p:not(:first-of-type),\n        td p:not(:first-of-type) {\n          margin-top: 12px;\n        }\n      }\n      th {\n        background-color: ", ";\n        text-align: left;\n        & *:not(strong) {\n          font-weight: normal;\n        }\n        & .", " > p {\n          font-weight: bold;\n        }\n      }\n    }\n  }\n"], ["\n  .", " {\n    position: relative;\n    margin: 0 auto ", "px;\n    box-sizing: border-box;\n\n    /**\n     * Fix block top alignment inside table cells.\n     */\n    .code-block,\n    .", ",\n    .taskItemView-content-wrap > div,\n    .decisionItemView-content-wrap > div {\n      margin-top: 0;\n    }\n  }\n  .", "[data-number-column='true'] {\n    padding-left: ", "px;\n  }\n  /* avoid applying styles to nested tables (possible via extensions) */\n  .", " > table,\n  .", " > table {\n    border-collapse: collapse;\n    margin: ", "px ", "px 0;\n    border: 1px solid ", ";\n    table-layout: fixed;\n    font-size: ", "px;\n    width: 100%;\n\n    &[data-autosize='true'] {\n      table-layout: auto;\n    }\n\n    & {\n      * {\n        box-sizing: border-box;\n      }\n\n      tbody {\n        border-bottom: none;\n      }\n      th td {\n        background-color: white;\n        font-weight: normal;\n      }\n      th,\n      td {\n        min-width: ", "px;\n        height: 3em;\n        vertical-align: top;\n        border: 1px solid ", ";\n        border-right-width: 0;\n        border-bottom-width: 0;\n        padding: 10px;\n        /* https://stackoverflow.com/questions/7517127/borders-not-shown-in-firefox-with-border-collapse-on-table-position-relative-o */\n        background-clip: padding-box;\n\n        th p:not(:first-of-type),\n        td p:not(:first-of-type) {\n          margin-top: 12px;\n        }\n      }\n      th {\n        background-color: ", ";\n        text-align: left;\n        & *:not(strong) {\n          font-weight: normal;\n        }\n        & .", " > p {\n          font-weight: bold;\n        }\n      }\n    }\n  }\n"])), TableSharedCssClassName.TABLE_CONTAINER, tableMarginBottom, __WEBPACK_IMPORTED_MODULE_4__panel__["a" /* PanelSharedCssClassName */].PANEL_CONTAINER, TableSharedCssClassName.TABLE_CONTAINER, __WEBPACK_IMPORTED_MODULE_3__consts__["h" /* akEditorTableNumberColumnWidth */] - 1, TableSharedCssClassName.TABLE_CONTAINER, TableSharedCssClassName.TABLE_NODE_WRAPPER, tableMarginTop, tableMarginSides, __WEBPACK_IMPORTED_MODULE_3__consts__["f" /* akEditorTableBorder */], Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["fontSize"])(), tableCellMinWidth, __WEBPACK_IMPORTED_MODULE_3__consts__["f" /* akEditorTableBorder */], __WEBPACK_IMPORTED_MODULE_3__consts__["i" /* akEditorTableToolbar */], TableSharedCssClassName.TABLE_CELL_NODEVIEW_CONTENT_DOM);
var calcTableWidth = function (layout, containerWidth, addControllerPadding) {
    if (addControllerPadding === void 0) { addControllerPadding = true; }
    switch (layout) {
        case 'full-width':
            return containerWidth
                ? containerWidth -
                    (addControllerPadding ? __WEBPACK_IMPORTED_MODULE_3__consts__["b" /* akEditorBreakoutPadding */] : 0) + "px"
                : '100%';
        case 'wide':
            if (containerWidth) {
                var targetWidth = containerWidth - (addControllerPadding ? __WEBPACK_IMPORTED_MODULE_3__consts__["b" /* akEditorBreakoutPadding */] : 0);
                return Object(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* calcWideWidth */])(containerWidth, targetWidth, targetWidth + "px");
            }
            else {
                return __WEBPACK_IMPORTED_MODULE_3__consts__["j" /* akEditorWideLayoutWidth */] + "px";
            }
        default:
            return 'inherit';
    }
};

var templateObject_1;
//# sourceMappingURL=table.js.map

/***/ }),
/* 2905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export columnLayoutSharedStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(168);



var columnLayoutSharedStyle = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  [data-layout-section] {\n    display: flex;\n    flex-direction: row;\n    & > * {\n      flex: 1;\n    }\n\n    @media screen and (max-width: ", "px) {\n      flex-direction: column;\n    }\n  }\n"], ["\n  [data-layout-section] {\n    display: flex;\n    flex-direction: row;\n    & > * {\n      flex: 1;\n    }\n\n    @media screen and (max-width: ", "px) {\n      flex-direction: column;\n    }\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__consts__["m" /* gridMediumMaxWidth */]);

var templateObject_1;
//# sourceMappingURL=column-layout.js.map

/***/ }),
/* 2906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mediaSingleSharedStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);

// @ts-ignore: unused variable
// prettier-ignore

var mediaSingleSharedStyle = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  li .media-single {\n    margin: 0;\n  }\n\n  table .media-single {\n    margin: 0;\n  }\n\n  .media-single.image-wrap-left + .media-single.image-wrap-right,\n  .media-single.image-wrap-right + .media-single.image-wrap-left,\n  .media-single.image-wrap-left + .media-single.image-wrap-left,\n  .media-single.image-wrap-right + .media-single.image-wrap-right {\n    margin-right: 0;\n    margin-left: 0;\n  }\n"], ["\n  li .media-single {\n    margin: 0;\n  }\n\n  table .media-single {\n    margin: 0;\n  }\n\n  .media-single.image-wrap-left + .media-single.image-wrap-right,\n  .media-single.image-wrap-right + .media-single.image-wrap-left,\n  .media-single.image-wrap-left + .media-single.image-wrap-left,\n  .media-single.image-wrap-right + .media-single.image-wrap-right {\n    margin-right: 0;\n    margin-left: 0;\n  }\n"])));

var templateObject_1;
//# sourceMappingURL=media-single.js.map

/***/ }),
/* 2907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export blockquoteSharedStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(168);

// @ts-ignore: unused variable



var blockquoteSharedStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  & blockquote {\n    box-sizing: border-box;\n    padding-left: ", "px;\n    border-left: 2px solid ", ";\n    margin: ", " 0 0 0;\n    margin-right: 0;\n\n    [dir='rtl'] & {\n      padding-left: 0;\n      padding-right: ", "px;\n    }\n\n    &:first-child {\n      margin-top: 0;\n    }\n\n    &::before {\n      content: '';\n    }\n\n    &::after {\n      content: none;\n    }\n\n    & p {\n      display: block;\n    }\n\n    & table,\n    & table:last-child {\n      display: inline-table;\n    }\n  }\n"], ["\n  & blockquote {\n    box-sizing: border-box;\n    padding-left: ", "px;\n    border-left: 2px solid ", ";\n    margin: ", " 0 0 0;\n    margin-right: 0;\n\n    [dir='rtl'] & {\n      padding-left: 0;\n      padding-right: ", "px;\n    }\n\n    &:first-child {\n      margin-top: 0;\n    }\n\n    &::before {\n      content: '';\n    }\n\n    &::after {\n      content: none;\n    }\n\n    & p {\n      display: block;\n    }\n\n    & table,\n    & table:last-child {\n      display: inline-table;\n    }\n  }\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() * 2, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* akEditorBlockquoteBorderColor */], __WEBPACK_IMPORTED_MODULE_3__consts__["k" /* blockNodesVerticalMargin */], Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() * 2);
var templateObject_1;
//# sourceMappingURL=blockquote.js.map

/***/ }),
/* 2908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export headingsSharedStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);

// @ts-ignore: unused variable
// prettier-ignore

// @see typography spreadsheet: https://docs.google.com/spreadsheets/d/1iYusRGCT4PoPfvxbJ8NrgjtfFgXLm5lpDWXzjua1W2E/edit#gid=93913128
// text sizing prototype: http://proto/fabricrender/
var headingsSharedStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  & h1 {\n    line-height: 1.166;\n    font-size: 1.714em;\n    margin-top: 2.857em;\n    margin-bottom: 0;\n  }\n\n  & h2 {\n    line-height: 1.2;\n    font-size: 1.43em;\n    margin-top: 2.571em;\n    margin-bottom: 0;\n  }\n\n  & h3 {\n    line-height: 1.5;\n    font-size: 1.142em;\n    margin-top: 2.585em;\n    margin-bottom: 0;\n  }\n\n  & h4 {\n    line-height: 1.428;\n    font-size: 1em;\n    margin-top: 1.714em;\n  }\n\n  & h5 {\n    line-height: 1.333;\n    font-size: 0.857em;\n    margin-top: 1.43em;\n  }\n\n  & h6 {\n    line-height: 1.454;\n    font-size: 0.785em;\n    margin-top: 1.42em;\n  }\n"], ["\n  & h1 {\n    line-height: 1.166;\n    font-size: 1.714em;\n    margin-top: 2.857em;\n    margin-bottom: 0;\n  }\n\n  & h2 {\n    line-height: 1.2;\n    font-size: 1.43em;\n    margin-top: 2.571em;\n    margin-bottom: 0;\n  }\n\n  & h3 {\n    line-height: 1.5;\n    font-size: 1.142em;\n    margin-top: 2.585em;\n    margin-bottom: 0;\n  }\n\n  & h4 {\n    line-height: 1.428;\n    font-size: 1em;\n    margin-top: 1.714em;\n  }\n\n  & h5 {\n    line-height: 1.333;\n    font-size: 0.857em;\n    margin-top: 1.43em;\n  }\n\n  & h6 {\n    line-height: 1.454;\n    font-size: 0.785em;\n    margin-top: 1.42em;\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=headings.js.map

/***/ }),
/* 2909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ruleSharedStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);

// @ts-ignore: unused variable


// @see typography spreadsheet: https://docs.google.com/spreadsheets/d/1iYusRGCT4PoPfvxbJ8NrgjtfFgXLm5lpDWXzjua1W2E/edit#gid=93913128
var ruleSharedStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  & hr {\n    border: none;\n    background-color: ", ";\n    margin: 1.714em 0;\n    height: 2px;\n    border-radius: 1px;\n\n    &.ProseMirror-selectednode {\n      outline: none;\n      background-color: ", ";\n    }\n  }\n"], ["\n  & hr {\n    border: none;\n    background-color: ", ";\n    margin: 1.714em 0;\n    height: 2px;\n    border-radius: 1px;\n\n    &.ProseMirror-selectednode {\n      outline: none;\n      background-color: ", ";\n    }\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30A, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B300);
var templateObject_1;
//# sourceMappingURL=rule.js.map

/***/ }),
/* 2910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export paragraphSharedStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(168);

// @ts-ignore: unused variable


// @see typography spreadsheet: https://docs.google.com/spreadsheets/d/1iYusRGCT4PoPfvxbJ8NrgjtfFgXLm5lpDWXzjua1W2E/edit#gid=93913128
var paragraphSharedStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  & p {\n    font-size: 1em;\n    line-height: 1.714;\n    font-weight: normal;\n    margin-top: ", ";\n    margin-bottom: 0;\n    letter-spacing: -0.005em;\n  }\n"], ["\n  & p {\n    font-size: 1em;\n    line-height: 1.714;\n    font-weight: normal;\n    margin-top: ", ";\n    margin-bottom: 0;\n    letter-spacing: -0.005em;\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__consts__["k" /* blockNodesVerticalMargin */]);
var templateObject_1;
//# sourceMappingURL=paragraph.js.map

/***/ }),
/* 2911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export linkSharedStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var linkSharedStyle = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  a.blockLink {\n    display: block;\n  }\n"], ["\n  a.blockLink {\n    display: block;\n  }\n"])));

var templateObject_1;
//# sourceMappingURL=link.js.map

/***/ }),
/* 2912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export indentationSharedStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var indentationSharedStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .fabric-editor-indentation-mark {\n    &[data-level='1'] {\n      margin-left: 30px;\n    }\n    &[data-level='2'] {\n      margin-left: 60px;\n    }\n    &[data-level='3'] {\n      margin-left: 90px;\n    }\n    &[data-level='4'] {\n      margin-left: 120px;\n    }\n    &[data-level='5'] {\n      margin-left: 150px;\n    }\n    &[data-level='6'] {\n      margin-left: 180px;\n    }\n  }\n"], ["\n  .fabric-editor-indentation-mark {\n    &[data-level='1'] {\n      margin-left: 30px;\n    }\n    &[data-level='2'] {\n      margin-left: 60px;\n    }\n    &[data-level='3'] {\n      margin-left: 90px;\n    }\n    &[data-level='4'] {\n      margin-left: 120px;\n    }\n    &[data-level='5'] {\n      margin-left: 150px;\n    }\n    &[data-level='6'] {\n      margin-left: 180px;\n    }\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=indentation.js.map

/***/ }),
/* 2913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export blockMarksSharedStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var blockMarksSharedStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  /**\n   * We need to remove margin-top from first item\n   * inside doc, tableCell, tableHeader, blockquote, etc.\n   */\n  *:not(.fabric-editor-block-mark) >,\n  /* For nested block marks */\n  *:not(.fabric-editor-block-mark) > div.fabric-editor-block-mark:first-child {\n    p,\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      &:first-child {\n        margin-top: 0;\n      }\n    }\n  }\n"], ["\n  /**\n   * We need to remove margin-top from first item\n   * inside doc, tableCell, tableHeader, blockquote, etc.\n   */\n  *:not(.fabric-editor-block-mark) >,\n  /* For nested block marks */\n  *:not(.fabric-editor-block-mark) > div.fabric-editor-block-mark:first-child {\n    p,\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      &:first-child {\n        margin-top: 0;\n      }\n    }\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=block-marks.js.map

/***/ }),
/* 2914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_emoji__ = __webpack_require__(2915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__providerFactory__ = __webpack_require__(476);





var EmojiNode = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiNode, _super);
    function EmojiNode(props) {
        var _this = _super.call(this, props) || this;
        _this.renderWithProvider = function (providers) {
            var _a = _this.props, allowTextFallback = _a.allowTextFallback, shortName = _a.shortName, id = _a.id, fallback = _a.fallback, fitToHeight = _a.fitToHeight;
            if (allowTextFallback && !providers.emojiProvider) {
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, fallback || shortName);
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_emoji__["a" /* ResourcedEmoji */], { emojiId: { id: id, fallback: fallback, shortName: shortName }, emojiProvider: providers.emojiProvider, showTooltip: true, fitToHeight: fitToHeight }));
        };
        _this.providerFactory = props.providers || new __WEBPACK_IMPORTED_MODULE_3__providerFactory__["b" /* default */]();
        return _this;
    }
    EmojiNode.prototype.componentWillUnmount = function () {
        if (!this.props.providers) {
            // new ProviderFactory is created if no `providers` has been set
            // in this case when component is unmounted it's safe to destroy this providerFactory
            this.providerFactory.destroy();
        }
    };
    EmojiNode.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__providerFactory__["a" /* WithProviders */], { providers: ['emojiProvider'], providerFactory: this.providerFactory, renderNode: this.renderWithProvider }));
    };
    return EmojiNode;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* unused harmony default export */ var _unused_webpack_default_export = (EmojiNode);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_util_service_support__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Emoji__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_EmojiPlaceholder__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_ResourcedEmoji__ = __webpack_require__(2918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_picker_EmojiPicker__ = __webpack_require__(2919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_typeahead_EmojiTypeAhead__ = __webpack_require__(2931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_EmojiResource__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_EmojiRepository__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_EmojiLoader__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_EmojiUtils__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__type_helpers__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_internal_UsageFrequencyTracker__ = __webpack_require__(896);
/* unused harmony reexport AbstractResource */
/* unused harmony reexport Emoji */
/* unused harmony reexport EmojiPlaceholder */
/* unused harmony reexport EmojiLoader */
/* unused harmony reexport EmojiPicker */
/* unused harmony reexport EmojiResource */
/* unused harmony reexport EmojiRepository */
/* unused harmony reexport EmojiTypeAhead */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__components_common_ResourcedEmoji__["a"]; });
/* unused harmony reexport denormaliseEmojiServiceResponse */
/* unused harmony reexport toEmojiId */
/* unused harmony reexport toOptionalEmojiId */
/* unused harmony reexport emojiPickerWidth */
/* unused harmony reexport emojiPickerHeight */
/* unused harmony reexport defaultEmojiHeight */
/* unused harmony reexport customCategory */
/* unused harmony reexport UsageFrequencyTracker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types__ = __webpack_require__(540);
/* unused harmony namespace reexport */















/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_4__components_picker_EmojiPicker__["a" /* default */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(524));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CrossCircleIcon = function CrossCircleIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill-rule=\"evenodd\"><circle fill=\"currentColor\" cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M13.477 9.113l-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41z\" fill=\"inherit\"/><path d=\"M9.084 10.501l4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411z\" fill=\"inherit\"/></g></svg>"
  }, props));
};

CrossCircleIcon.displayName = 'CrossCircleIcon';
var _default = CrossCircleIcon;
exports.default = _default;

/***/ }),
/* 2917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = void 0;
var sizes = {
  small: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '48px'
};
exports.sizes = sizes;

/***/ }),
/* 2918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EmojiPlaceholder__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LoadingEmojiComponent__ = __webpack_require__(475);





var resourcedEmojiModuleLoader = function () {
    return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 3473));
};
var resourcedEmojiComponentLoader = function () { return resourcedEmojiModuleLoader().then(function (module) { return module.default; }); };
var ResourcedEmoji = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ResourcedEmoji, _super);
    function ResourcedEmoji() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            asyncLoadedComponent: ResourcedEmoji.AsyncLoadedComponent,
        };
        return _this;
    }
    ResourcedEmoji.prototype.asyncLoadComponent = function () {
        var _this = this;
        resourcedEmojiComponentLoader().then(function (component) {
            ResourcedEmoji.AsyncLoadedComponent = component;
            _this.setAsyncState(component);
        });
    };
    ResourcedEmoji.prototype.renderLoading = function () {
        var _a = this.props, fitToHeight = _a.fitToHeight, emojiId = _a.emojiId, showTooltip = _a.showTooltip;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__EmojiPlaceholder__["a" /* default */], { shortName: emojiId.shortName, showTooltip: showTooltip, size: fitToHeight || __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* defaultEmojiHeight */] }));
    };
    ResourcedEmoji.prototype.renderLoaded = function (loadedEmojiProvider, ResourcedEmojiComponent) {
        var _a = this.props, emojiProvider = _a.emojiProvider, otherProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["emojiProvider"]);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ResourcedEmojiComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, otherProps, { emojiProvider: loadedEmojiProvider })));
    };
    return ResourcedEmoji;
}(__WEBPACK_IMPORTED_MODULE_4__LoadingEmojiComponent__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (ResourcedEmoji);
//# sourceMappingURL=ResourcedEmoji.js.map

/***/ }),
/* 2919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EmojiPickerInternal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_analytics__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_LoadingEmojiComponent__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EmojiPickerVirtualItems__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(180);






var emojiPickerModuleLoader = function () {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 3474));
};
var emojiPickerLoader = function () {
    return emojiPickerModuleLoader().then(function (module) { return module.default; });
};
var EmojiPickerInternal = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiPickerInternal, _super);
    function EmojiPickerInternal(props) {
        var _this = _super.call(this, props, {}) || this;
        _this.state = {
            asyncLoadedComponent: EmojiPickerInternal.AsyncLoadedComponent,
        };
        return _this;
    }
    EmojiPickerInternal.prototype.asyncLoadComponent = function () {
        var _this = this;
        emojiPickerLoader().then(function (component) {
            EmojiPickerInternal.AsyncLoadedComponent = component;
            _this.setAsyncState(component);
        });
    };
    EmojiPickerInternal.prototype.renderLoading = function () {
        var _this = this;
        var item = new __WEBPACK_IMPORTED_MODULE_4__EmojiPickerVirtualItems__["c" /* LoadingItem */]();
        var handlePickerRef = function (ref) {
            if (_this.props.onPickerRef) {
                _this.props.onPickerRef(ref);
            }
        };
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_5__styles__["g" /* emojiPicker */], ref: handlePickerRef }, item.renderItem()));
    };
    EmojiPickerInternal.prototype.renderLoaded = function (loadedEmojiProvider, EmojiPickerComponent) {
        var _a = this.props, emojiProvider = _a.emojiProvider, otherProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["emojiProvider"]);
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](EmojiPickerComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ emojiProvider: loadedEmojiProvider }, otherProps)));
    };
    return EmojiPickerInternal;
}(__WEBPACK_IMPORTED_MODULE_3__common_LoadingEmojiComponent__["a" /* default */]));

// tslint:disable-next-line:variable-name
var EmojiPicker = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_analytics__["a" /* withAnalytics */])(EmojiPickerInternal, {}, {});
/* harmony default export */ __webpack_exports__["a"] = (EmojiPicker);
//# sourceMappingURL=EmojiPicker.js.map

/***/ }),
/* 2920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_field_base__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_search__ = __webpack_require__(2921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(180);








var EmojiPickerListSearch = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiPickerListSearch, _super);
    function EmojiPickerListSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onBlur = function (e) {
            var activeElement = document.activeElement;
            // Input lost focus to emoji picker container (happens in IE11 when updating search results)
            // See FS-2111
            if (activeElement instanceof HTMLElement &&
                activeElement.getAttribute('data-emoji-picker-container')) {
                _this.restoreInputFocus();
            }
        };
        _this.onChange = function (e) {
            _this.saveInputSelection();
            _this.props.onChange(e);
        };
        _this.focusInput = function () {
            if (_this.inputRef) {
                _this.inputRef.focus();
            }
        };
        _this.handleInputRef = function (input) {
            if (input) {
                // Defer focus so it give some time to position the popup before
                // setting the focus to search input.
                // see FS-2056
                _this.inputRef = input;
                window.setTimeout(_this.focusInput);
            }
        };
        return _this;
    }
    EmojiPickerListSearch.prototype.saveInputSelection = function () {
        this.inputSelection = undefined;
        if (this.inputRef) {
            var _a = this.inputRef, selectionStart = _a.selectionStart, selectionEnd = _a.selectionEnd, selectionDirection = _a.selectionDirection;
            if (selectionStart !== undefined) {
                this.inputSelection = {
                    selectionStart: selectionStart,
                    selectionEnd: selectionEnd,
                    selectionDirection: selectionDirection,
                };
            }
        }
    };
    EmojiPickerListSearch.prototype.restoreInputFocus = function () {
        this.focusInput();
        if (this.inputSelection &&
            this.inputRef &&
            this.inputRef.setSelectionRange) {
            var _a = this.inputSelection, selectionStart = _a.selectionStart, selectionEnd = _a.selectionEnd, selectionDirection = _a.selectionDirection;
            this.inputRef.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
        }
    };
    EmojiPickerListSearch.prototype.render = function () {
        var _this = this;
        var _a = this.props, style = _a.style, query = _a.query;
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_6__styles__["n" /* pickerSearch */], style: style },
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_intl__["FormattedMessage"], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, __WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* messages */].searchLabel), function (searchLabel) { return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__atlaskit_field_base__["b" /* default */], { appearance: "standard", isCompact: true, isLabelHidden: true, isFitContainerWidthEnabled: true },
                __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_6__styles__["o" /* searchIcon */] },
                    __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_search___default.a, { label: searchLabel })),
                __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("input", { className: __WEBPACK_IMPORTED_MODULE_6__styles__["m" /* input */], autoComplete: "off", disabled: false, name: "search", placeholder: searchLabel + "...", required: false, onChange: _this.onChange, value: query || '', ref: _this.handleInputRef, onBlur: _this.onBlur }))); })));
    };
    EmojiPickerListSearch.defaultProps = {
        style: {},
    };
    return EmojiPickerListSearch;
}(__WEBPACK_IMPORTED_MODULE_3_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (EmojiPickerListSearch);
//# sourceMappingURL=EmojiPickerListSearch.js.map

/***/ }),
/* 2921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(524));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SearchIcon = function SearchIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

SearchIcon.displayName = 'SearchIcon';
var _default = SearchIcon;
exports.default = _default;

/***/ }),
/* 2922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_CachingEmoji__ = __webpack_require__(1358);





var EmojiPickerEmojiRow = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiPickerEmojiRow, _super);
    function EmojiPickerEmojiRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmojiPickerEmojiRow.prototype.render = function () {
        var _a = this.props, emojis = _a.emojis, onSelected = _a.onSelected, onMouseMove = _a.onMouseMove, title = _a.title, showDelete = _a.showDelete, onDelete = _a.onDelete;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2__styles__["k" /* emojiPickerRow */] }, emojis.map(function (emoji) {
            var shortName = emoji.shortName, id = emoji.id;
            var key = id ? id + "-" + title : shortName + "-" + title;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_2__styles__["f" /* emojiItem */], key: key },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_CachingEmoji__["a" /* default */], { emoji: emoji, selectOnHover: true, onSelected: onSelected, onMouseMove: onMouseMove, showDelete: showDelete, onDelete: onDelete, placeholderSize: 24 })));
        })));
    };
    return EmojiPickerEmojiRow;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (EmojiPickerEmojiRow);
//# sourceMappingURL=EmojiPickerEmojiRow.js.map

/***/ }),
/* 2923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(180);







var EmojiPickerCategoryHeading = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiPickerCategoryHeading, _super);
    function EmojiPickerCategoryHeading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmojiPickerCategoryHeading.prototype.render = function () {
        var _a = this.props, id = _a.id, title = _a.title, className = _a.className;
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { id: id, "data-category-id": id, className: __WEBPACK_IMPORTED_MODULE_1_classnames__(className) },
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_5__styles__["e" /* emojiCategoryTitle */] },
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["FormattedMessage"], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* messages */][title])))));
    };
    return EmojiPickerCategoryHeading;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (EmojiPickerCategoryHeading);
//# sourceMappingURL=EmojiPickerCategoryHeading.js.map

/***/ }),
/* 2924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSearchEmojiComparator;
/* harmony export (immutable) */ __webpack_exports__["b"] = createUsageOnlyEmojiComparator;
/* unused harmony export ChainedEmojiComparator */
/* unused harmony export AsciiMatchComparator */
/* unused harmony export ExactShortNameMatchComparator */
/* unused harmony export EmojiTypeComparator */
/* unused harmony export UsageFrequencyComparator */
/* unused harmony export QueryStringPositionMatchComparator */
/* unused harmony export OrderComparator */
/* unused harmony export AlphabeticalShortnameComparator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type_helpers__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(70);



/**
 * Create the default sort comparator to be used for the user queries against emoji
 *
 * @param query the query used in the search to be sorted. Any colons will be stripped from the query and it will be
 * converted to lowercase.
 * @param orderedIds the id of emoji ordered by how frequently they are used
 */
function createSearchEmojiComparator(query, orderedIds) {
    var textQuery = query
        ? query
            .replace(/:/g, '')
            .toLowerCase()
            .trim()
        : undefined;
    var comparators = [];
    if (query) {
        comparators.push(new AsciiMatchComparator(query));
    }
    // Add the comparators to the 'chain'. The order of adding each comparator is important to the sort that is applied by the
    // ChainedEmojiComparator. (Which is why you may see the same 'if' a few times.)
    if (textQuery) {
        comparators.push(new ExactShortNameMatchComparator(textQuery));
    }
    if (orderedIds && orderedIds.length) {
        comparators.push(new UsageFrequencyComparator(orderedIds));
    }
    if (textQuery) {
        comparators.push(new QueryStringPositionMatchComparator(textQuery, 'shortName'), new QueryStringPositionMatchComparator(textQuery, 'name'));
    }
    comparators.push(OrderComparator.Instance, AlphabeticalShortnameComparator.Instance);
    var comparator = new (ChainedEmojiComparator.bind.apply(ChainedEmojiComparator, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"]([void 0], comparators)))();
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
function createUsageOnlyEmojiComparator(orderedIds) {
    var comparator = new ChainedEmojiComparator(new UsageFrequencyComparator(orderedIds), new EmojiTypeComparator(), OrderComparator.Instance);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
/**
 * A combinator comparator that applies an ordered chained of sub-comparators. The first comparator that
 * returns a non-zero value stops the chain and causes that value to be returned. If a comparator returns a
 * zero then the next one in the chain is tried.
 *
 * If no comparators in the chain return a non-zero value then zero will be returned.
 */
var ChainedEmojiComparator = /** @class */ (function () {
    function ChainedEmojiComparator() {
        var comparators = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            comparators[_i] = arguments[_i];
        }
        this.chain = comparators;
    }
    ChainedEmojiComparator.prototype.compare = function (e1, e2) {
        for (var i = 0; i < this.chain.length; i++) {
            var result = this.chain[i].compare(e1, e2);
            if (result !== 0) {
                return result;
            }
        }
        return 0;
    };
    return ChainedEmojiComparator;
}());

/**
 * Orders two emoji such that if one of them has an ascii representation that exactly matches the query then it will
 * be ordered first.
 */
var AsciiMatchComparator = /** @class */ (function () {
    function AsciiMatchComparator(query) {
        this.query = query;
    }
    AsciiMatchComparator.prototype.compare = function (e1, e2) {
        var e1HasAscii = e1.ascii && e1.ascii.indexOf(this.query) !== -1;
        var e2HasAscii = e2.ascii && e2.ascii.indexOf(this.query) !== -1;
        if (e1HasAscii && !e2HasAscii) {
            return -1;
        }
        else if (!e1HasAscii && e2HasAscii) {
            return 1;
        }
        return 0;
    };
    return AsciiMatchComparator;
}());

/**
 * Orders two emoji such that the one who's shortname matches the query exactly comes first. If there are matching
 * shortnames then the type of emoji is taken into account with SITE emoji coming first.
 */
var ExactShortNameMatchComparator = /** @class */ (function () {
    function ExactShortNameMatchComparator(query) {
        this.colonQuery = ":" + query + ":";
        this.typeComparator = new EmojiTypeComparator(true);
    }
    ExactShortNameMatchComparator.prototype.compare = function (e1, e2) {
        if (e1.shortName === this.colonQuery && e2.shortName === this.colonQuery) {
            return this.typeComparator.compare(e1, e2);
        }
        else if (e1.shortName === this.colonQuery) {
            return -1;
        }
        else if (e2.shortName === this.colonQuery) {
            return 1;
        }
        return 0;
    };
    return ExactShortNameMatchComparator;
}());

/**
 * Orders two emoji based on their type, with the types being STANDARD, ATLASSIAN and SITE (in that order).
 * If the comparator is configured to 'reverse' then the order will be SITE, ATLASSIAN, STANDARD.
 *
 * Regardless of the reverse setting, an unknown type will always come last.
 */
var EmojiTypeComparator = /** @class */ (function () {
    function EmojiTypeComparator(reverse) {
        if (reverse) {
            this.typeToNumber = new Map([
                ['SITE', 0],
                ['ATLASSIAN', 1],
                ['STANDARD', 2],
            ]);
        }
        else {
            this.typeToNumber = new Map([
                ['STANDARD', 0],
                ['ATLASSIAN', 1],
                ['SITE', 2],
            ]);
        }
    }
    EmojiTypeComparator.prototype.compare = function (e1, e2) {
        return this.emojiTypeToOrdinal(e1) - this.emojiTypeToOrdinal(e2);
    };
    EmojiTypeComparator.prototype.emojiTypeToOrdinal = function (emoji) {
        var ordinal = this.typeToNumber.get(emoji.type);
        if (ordinal === undefined) {
            ordinal = 10;
        }
        return ordinal;
    };
    return EmojiTypeComparator;
}());

/**
 * Order two emoji such as the one which is more frequently used comes first. If neither have any usage
 * information then leave their order unchanged.
 */
var UsageFrequencyComparator = /** @class */ (function () {
    function UsageFrequencyComparator(orderedIds) {
        var _this = this;
        this.positionLookup = new Map();
        // Make ordering start from 1 to avoid having zero in the map (which is falsey)
        orderedIds.map(function (id, index) { return _this.positionLookup.set(id, index + 1); });
    }
    UsageFrequencyComparator.prototype.compare = function (e1, e2) {
        if (!e1.id || !e2.id) {
            return 0; // this shouldn't occur. Leave position unchanged if there is any missing id.
        }
        var i1 = this.getPositionInOrder(e1);
        var i2 = this.getPositionInOrder(e2);
        return i1 - i2;
    };
    /**
     * Get the ordinal representing the position of this emoji.
     *
     * @param id the id of the emoji
     */
    UsageFrequencyComparator.prototype.getPositionInOrder = function (emoji) {
        var id = emoji.id ? emoji.id : '0';
        if (Object(__WEBPACK_IMPORTED_MODULE_1__type_helpers__["g" /* isEmojiVariationDescription */])(emoji)) {
            id = emoji.baseId;
        }
        var position = this.positionLookup.get(id);
        if (position) {
            return position;
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* MAX_ORDINAL */];
        }
    };
    return UsageFrequencyComparator;
}());

/**
 * A comparator that will sort higher an emoji which matches the query string earliest in the indicated
 * property.
 */
var QueryStringPositionMatchComparator = /** @class */ (function () {
    /**
     * @param query the query to match
     * @param propertyToCompare the property of EmojiDescription to check for query within
     */
    function QueryStringPositionMatchComparator(query, propertyToCompare) {
        this.query = query;
        this.propertyName = propertyToCompare;
    }
    QueryStringPositionMatchComparator.prototype.compare = function (e1, e2) {
        var i1 = e1[this.propertyName]
            ? e1[this.propertyName].indexOf(this.query)
            : __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* MAX_ORDINAL */];
        var i2 = e2[this.propertyName]
            ? e2[this.propertyName].indexOf(this.query)
            : __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* MAX_ORDINAL */];
        i1 = i1 === -1 ? __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* MAX_ORDINAL */] : i1;
        i2 = i2 === -1 ? __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* MAX_ORDINAL */] : i2;
        return i1 - i2;
    };
    return QueryStringPositionMatchComparator;
}());

var OrderComparator = /** @class */ (function () {
    function OrderComparator() {
    }
    Object.defineProperty(OrderComparator, "Instance", {
        get: function () {
            return this.INSTANCE || (this.INSTANCE = new this());
        },
        enumerable: true,
        configurable: true
    });
    OrderComparator.prototype.compare = function (e1, e2) {
        var o1 = e1.order ? e1.order : __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* MAX_ORDINAL */];
        var o2 = e2.order ? e2.order : __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* MAX_ORDINAL */];
        return o1 - o2;
    };
    return OrderComparator;
}());

var AlphabeticalShortnameComparator = /** @class */ (function () {
    function AlphabeticalShortnameComparator() {
    }
    Object.defineProperty(AlphabeticalShortnameComparator, "Instance", {
        get: function () {
            return this.INSTANCE || (this.INSTANCE = new this());
        },
        enumerable: true,
        configurable: true
    });
    AlphabeticalShortnameComparator.prototype.compare = function (e1, e2) {
        return e1.shortName.localeCompare(e2.shortName);
    };
    return AlphabeticalShortnameComparator;
}());

//# sourceMappingURL=Comparators.js.map

/***/ }),
/* 2925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DuplicateLimitedQueue__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_logger__ = __webpack_require__(120);



/**
 * An extension to the DuplicateLimitedQueue that will initialise its contents from the
 * supplied Storage and will also update the storage for every new item enqueued.
 */
var StoredDuplicateLimitedQueue = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](StoredDuplicateLimitedQueue, _super);
    function StoredDuplicateLimitedQueue(options) {
        var _this = _super.call(this, options) || this;
        _this.storage = options.storage;
        _this.prefixedStorageKey = options.storagePrefix + "." + StoredDuplicateLimitedQueue.storageKey;
        _this.load();
        return _this;
    }
    /**
     * Enqueue the supplied item and also persist the new contents of the queue to storage.
     *
     * @param item the item to be enqueued
     */
    StoredDuplicateLimitedQueue.prototype.enqueue = function (item) {
        _super.prototype.enqueue.call(this, item);
        this.save();
    };
    /**
     * Exposed for storybook/testing purposes only. Clear the contents of the queue, and localStorage.
     */
    StoredDuplicateLimitedQueue.prototype.clear = function () {
        _super.prototype.clear.call(this);
        this.storage.removeItem(this.prefixedStorageKey);
    };
    /**
     * Initialise the queue contents from the configured Storage. If there is no data found in
     * storage then the queue will have no items added. Likewise, a failure to read or parse stored
     * data will be swallowed and no items are added to the queue.
     */
    StoredDuplicateLimitedQueue.prototype.load = function () {
        var itemsJson = this.storage.getItem(this.prefixedStorageKey);
        if (itemsJson !== null) {
            try {
                var items = JSON.parse(itemsJson);
                this.bulkEnqueue(items);
            }
            catch (e) {
                Object(__WEBPACK_IMPORTED_MODULE_2__util_logger__["a" /* default */])("Error parsing the queue stored as " + this.prefixedStorageKey + " key from storage", e);
            }
        }
    };
    /**
     * Save the current items in the queue, overwriting any previously stored queue.
     * Any failure in saving will be silently ignored with the likely outcome that any previous
     * saved items will remain unchanged in storage.
     */
    StoredDuplicateLimitedQueue.prototype.save = function () {
        var itemsJson = JSON.stringify(this.getItems());
        try {
            this.storage.setItem(this.prefixedStorageKey, itemsJson);
        }
        catch (e) {
            Object(__WEBPACK_IMPORTED_MODULE_2__util_logger__["a" /* default */])("Error saving the queued items as " + this.prefixedStorageKey, e);
        }
    };
    StoredDuplicateLimitedQueue.storageKey = 'lastUsed';
    return StoredDuplicateLimitedQueue;
}(__WEBPACK_IMPORTED_MODULE_1__DuplicateLimitedQueue__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (StoredDuplicateLimitedQueue);
//# sourceMappingURL=StoredDuplicateLimitedQueue.js.map

/***/ }),
/* 2926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tokenizerRegex; });
// \p{Han} => each chinese character is a separate token
// \p{L}+[\p{Mn}|']*\p{L} => consecutive letters, including non spacing mark and apostrophe are a single token
// const tokenizerRegex = new XRegExp("\\p{Han}|[\\p{L}|\\p{N}]+[\\p{Mn}|']*\\p{L}*", 'gi');
// Note: regex compiled to unicode charsets using @atlaskit/xregexp-transformer (packages/elements/xregexp-transformer). Refer to it if you need to compile it again.
var tokenizerRegex = new RegExp("[\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FEF\uF900-\uFA6D\uFA70-\uFAD9]|[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC|0-9\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F|']*[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*", 'gi');
//# sourceMappingURL=EmojiRepositoryRegex.js.map

/***/ }),
/* 2927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mediaProportionOfProgress */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type_helpers__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MediaEmojiCache__ = __webpack_require__(2928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EmojiUtils__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TokenManager__ = __webpack_require__(2930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_logger__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_media_core__ = __webpack_require__(325);








// Assume media is 95% of total upload time.
var mediaProportionOfProgress = 95 / 100;
var SiteEmojiResource = /** @class */ (function () {
    function SiteEmojiResource(siteServiceConfig, mediaApiToken) {
        var _this = this;
        this.postToEmojiService = function (upload, fileId) {
            var shortName = upload.shortName, name = upload.name;
            var width = upload.width, height = upload.height;
            var requestInit = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    shortName: shortName,
                    name: name,
                    width: width,
                    height: height,
                    fileId: fileId,
                }),
            };
            return __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */]
                .requestService(_this.siteServiceConfig, {
                requestInit: requestInit,
            })
                .then(function (response) {
                var emojis = response.emojis;
                if (emojis.length) {
                    var _a = emojis[0], altRepresentations = _a.altRepresentations, emoji = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["altRepresentations"]);
                    var response_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, emoji, { representation: Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["c" /* convertImageToMediaRepresentation */])(emoji.representation) });
                    var altRepresentation = Object(__WEBPACK_IMPORTED_MODULE_4__EmojiUtils__["c" /* getAltRepresentation */])(altRepresentations || {});
                    var imgAltRepresentation = altRepresentation
                        ? Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["c" /* convertImageToMediaRepresentation */])(altRepresentation)
                        : undefined;
                    return Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["a" /* buildEmojiDescriptionWithAltRepresentation */])(response_1, imgAltRepresentation);
                }
                throw new Error('No emoji returns from upload. Upload failed.');
            });
        };
        this.siteServiceConfig = siteServiceConfig;
        this.mediaApiToken = mediaApiToken;
        this.tokenManager = new __WEBPACK_IMPORTED_MODULE_5__TokenManager__["a" /* default */](siteServiceConfig);
        this.tokenManager.addToken('read', mediaApiToken);
        this.mediaEmojiCache = new __WEBPACK_IMPORTED_MODULE_3__MediaEmojiCache__["a" /* default */](this.tokenManager);
    }
    /**
     * Will load media emoji, returning a new EmojiDescription if, for example,
     * the URL has changed.
     */
    SiteEmojiResource.prototype.loadMediaEmoji = function (emoji, useAlt) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["j" /* isMediaEmoji */])(emoji)) {
            throw new Error('Only supported for media emoji');
        }
        return this.mediaEmojiCache.loadEmoji(emoji, useAlt);
    };
    SiteEmojiResource.prototype.optimisticRendering = function (emoji, useAlt) {
        var representation = useAlt
            ? emoji.altRepresentation
            : emoji.representation;
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["k" /* isMediaRepresentation */])(representation)) {
            throw new Error('Only supported for media emoji');
        }
        var mediaPath = representation.mediaPath;
        return this.mediaEmojiCache.optimisticRendering(mediaPath);
    };
    SiteEmojiResource.prototype.uploadEmoji = function (upload, progressCallback) {
        var _this = this;
        var startTime = Date.now();
        return this.tokenManager.getToken('upload').then(function (uploadToken) {
            var tokenLoadTime = Date.now() - startTime;
            Object(__WEBPACK_IMPORTED_MODULE_6__util_logger__["a" /* default */])('upload token load time', tokenLoadTime);
            return new Promise(function (resolve, reject) {
                var url = uploadToken.url, clientId = uploadToken.clientId, collectionName = uploadToken.collectionName;
                var context = __WEBPACK_IMPORTED_MODULE_7__atlaskit_media_core__["a" /* ContextFactory */].create({
                    authProvider: function () {
                        return Promise.resolve({
                            clientId: clientId,
                            token: uploadToken.jwt,
                            baseUrl: url,
                        });
                    },
                });
                var subscription = context.file
                    .upload({
                    content: upload.dataURL,
                    name: upload.filename,
                    collection: collectionName,
                })
                    .subscribe({
                    next: function (state) {
                        if (state.status === 'uploading' && progressCallback) {
                            progressCallback({
                                percent: state.progress * mediaProportionOfProgress,
                            });
                        }
                        else if (state.status === 'processing') {
                            subscription.unsubscribe();
                            var totalUploadTime = Date.now() - startTime;
                            var mediaUploadTime = totalUploadTime - tokenLoadTime;
                            Object(__WEBPACK_IMPORTED_MODULE_6__util_logger__["a" /* default */])('total upload / media upload times', totalUploadTime, mediaUploadTime);
                            _this.postToEmojiService(upload, state.id)
                                .then(function (emoji) {
                                resolve(emoji);
                            })
                                .catch(function (httpError) {
                                reject(httpError.reason || httpError);
                            });
                        }
                    },
                    error: function (error) {
                        reject(error);
                    },
                });
            });
        });
    };
    /**
     * Check if the MediaEmojiResource has been able to initialise an uploadToken. Retrieving an upload token
     * is asynchronous so the Promise will need to resolve before the state is known. If the token retrieval
     * completes with failure then the Promise will resolve to false.
     */
    SiteEmojiResource.prototype.hasUploadToken = function () {
        var tokenPromise = this.tokenManager.getToken('upload');
        return tokenPromise.then(function (token) {
            return token !== undefined;
        }, function () {
            return false;
        });
    };
    SiteEmojiResource.prototype.prepareForUpload = function () {
        // make sure a token is loaded from the emoji service if we don't have one
        // as future request to uploadEmoji will use this, this to preload it, as it
        // usually takes 1-2 seconds to generate
        this.tokenManager.getToken('upload');
    };
    SiteEmojiResource.prototype.findEmoji = function (emojiId) {
        var path = "../" + emojiId.id;
        return Object(__WEBPACK_IMPORTED_MODULE_4__EmojiUtils__["b" /* emojiRequest */])(this.siteServiceConfig, { path: path })
            .then(function (serviceResponse) {
            var response = Object(__WEBPACK_IMPORTED_MODULE_4__EmojiUtils__["a" /* denormaliseEmojiServiceResponse */])(serviceResponse);
            return response.emojis[0];
        })
            .catch(function (error) {
            Object(__WEBPACK_IMPORTED_MODULE_6__util_logger__["a" /* default */])('failed to load emoji', emojiId, error);
            return undefined;
        });
    };
    /**
     * Calls to site-scoped EmojiResource to delete emoji
     * @param emoji media emoji to delete
     * @returns Promise.resolve() if success and Promise.reject() for failure
     */
    SiteEmojiResource.prototype.deleteEmoji = function (emoji) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["j" /* isMediaEmoji */])(emoji) && !Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["i" /* isLoadedMediaEmoji */])(emoji)) {
            return Promise.reject(false);
        }
        var path = "" + emoji.id;
        var requestInit = {
            method: 'DELETE',
        };
        return (__WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */]
            .requestService(this.siteServiceConfig, { path: path, requestInit: requestInit })
            // Successful delete on Promise.resolve
            .then(function () { return true; })
            // Unsuccessful delete on Promise.reject
            .catch(function () { return false; }));
    };
    return SiteEmojiResource;
}());
/* harmony default export */ __webpack_exports__["a"] = (SiteEmojiResource);
//# sourceMappingURL=SiteEmojiResource.js.map

/***/ }),
/* 2928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BrowserCacheStrategy */
/* unused harmony export MemoryCacheStrategy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type_helpers__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MediaImageLoader__ = __webpack_require__(2929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_logger__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lru_fast__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lru_fast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lru_fast__);




var getRequiredRepresentation = function (emoji, useAlt) {
    return useAlt ? emoji.altRepresentation : emoji.representation;
};
var isUnsupportedBrowser = function () {
    var isIE = /*@cc_on!@*/ false || !!document.documentMode; // Internet Explorer 6-11
    var isEdge = !isIE && !!window.StyleMedia; // Edge 20+
    return isIE || isEdge;
};
/**
 * For browsers that support caching for resources
 * regardless of originally supplied headers (basically everything but Firefox).
 */
var BrowserCacheStrategy = /** @class */ (function () {
    function BrowserCacheStrategy(mediaImageLoader) {
        this.cachedImageUrls = new Set();
        Object(__WEBPACK_IMPORTED_MODULE_2__util_logger__["a" /* default */])('BrowserCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
    }
    BrowserCacheStrategy.prototype.loadEmoji = function (emoji, useAlt) {
        var _this = this;
        var representation = getRequiredRepresentation(emoji, useAlt);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__type_helpers__["k" /* isMediaRepresentation */])(representation)) {
            return emoji;
        }
        var mediaPath = representation.mediaPath;
        if (this.cachedImageUrls.has(mediaPath)) {
            // Already cached
            return emoji;
        }
        return this.mediaImageLoader
            .loadMediaImage(mediaPath)
            .then(function () {
            // Media is loaded, can use original URL now, so just return original emoji
            _this.cachedImageUrls.add(mediaPath);
            return emoji;
        })
            .catch(function () {
            return undefined;
        });
    };
    BrowserCacheStrategy.prototype.optimisticRendering = function () {
        return true;
    };
    BrowserCacheStrategy.supported = function (mediaPath, mediaImageLoader) {
        // IE/Edge uses memory cache strategy else images can fail to load
        // from a clean cache/if they are downloaded from the service
        // TODO: fix as a part of FS-1592
        if (isUnsupportedBrowser()) {
            return Promise.resolve(false);
        }
        return mediaImageLoader
            .loadMediaImage(mediaPath)
            .then(function () {
            // Image should be cached in browser, if supported it should be accessible from the cache by an <img/>
            // Try to load without via image to confirm this support (this fails in Firefox)
            return new Promise(function (resolve) {
                var img = new Image();
                img.addEventListener('load', function () {
                    resolve(true);
                });
                img.addEventListener('error', function () {
                    resolve(false);
                });
                img.src = mediaPath;
            });
        })
            .catch(function () { return false; });
    };
    return BrowserCacheStrategy;
}());

var maxImageCached = 1000;
// Don't cache images large than this - dataUrl size in characters
var maxImageSize = 10000;
/**
 * For browsers that do no cache images without equivalent headers (e.g. Firefox).
 *
 * Images are cached in memory in a LRU cache. Images considered too large,
 * are not cached, but retrieved each time.
 *
 * Images are still cached by the browser, but loading in asynchronous with
 * small delay noticable to the end user.
 */
var MemoryCacheStrategy = /** @class */ (function () {
    function MemoryCacheStrategy(mediaImageLoader) {
        Object(__WEBPACK_IMPORTED_MODULE_2__util_logger__["a" /* default */])('MemoryCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
        this.dataURLCache = new __WEBPACK_IMPORTED_MODULE_3_lru_fast__["LRUCache"](maxImageCached);
    }
    MemoryCacheStrategy.prototype.loadEmoji = function (emoji, useAlt) {
        var _this = this;
        var representation = getRequiredRepresentation(emoji, useAlt);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__type_helpers__["k" /* isMediaRepresentation */])(representation)) {
            return emoji;
        }
        var mediaPath = representation.mediaPath;
        var dataURL = this.dataURLCache.get(mediaPath);
        if (dataURL) {
            // Already cached
            return Object(__WEBPACK_IMPORTED_MODULE_0__type_helpers__["d" /* convertMediaToImageEmoji */])(emoji, dataURL, useAlt);
        }
        // Not cached, load
        return this.mediaImageLoader
            .loadMediaImage(mediaPath)
            .then(function (dataURL) {
            var loadedEmoji = Object(__WEBPACK_IMPORTED_MODULE_0__type_helpers__["d" /* convertMediaToImageEmoji */])(emoji, dataURL, useAlt);
            if (dataURL.length <= maxImageSize) {
                // Only cache if not large than max size
                _this.dataURLCache.put(mediaPath, dataURL);
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_2__util_logger__["a" /* default */])('No caching as image is too large', dataURL.length, dataURL.slice(0, 15), emoji.shortName);
            }
            return loadedEmoji;
        })
            .catch(function () {
            return undefined;
        });
    };
    MemoryCacheStrategy.prototype.optimisticRendering = function () {
        return false;
    };
    return MemoryCacheStrategy;
}());

/**
 * Provides a cache for Media Emoji.
 *
 * Emoji are returned immediately if cached and ready to use by the browser.
 *
 * Otherwise, they are loaded and returned via a promise.
 */
var MediaEmojiCache = /** @class */ (function () {
    function MediaEmojiCache(tokenManager) {
        this.waitingInitUrls = [];
        Object(__WEBPACK_IMPORTED_MODULE_2__util_logger__["a" /* default */])('MediaEmojiCache');
        this.mediaImageLoader = new __WEBPACK_IMPORTED_MODULE_1__MediaImageLoader__["a" /* default */](tokenManager);
    }
    MediaEmojiCache.prototype.loadEmoji = function (emoji, useAlt) {
        var representation = getRequiredRepresentation(emoji, useAlt);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__type_helpers__["k" /* isMediaRepresentation */])(representation)) {
            return emoji;
        }
        var mediaPath = representation.mediaPath;
        var emojiCache = this.getCache(mediaPath);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__type_helpers__["l" /* isPromise */])(emojiCache)) {
            // Promise based
            return emojiCache
                .then(function (cache) { return cache.loadEmoji(emoji, useAlt); })
                .catch(function () { return undefined; });
        }
        return emojiCache.loadEmoji(emoji, useAlt);
    };
    MediaEmojiCache.prototype.optimisticRendering = function (url) {
        var emojiCache = this.getCache(url);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__type_helpers__["l" /* isPromise */])(emojiCache)) {
            // Promise based
            return emojiCache
                .then(function (cache) { return cache.optimisticRendering(); })
                .catch(function () { return false; });
        }
        return emojiCache.optimisticRendering();
    };
    MediaEmojiCache.prototype.getCache = function (url) {
        var _this = this;
        if (this.cache) {
            return this.cache;
        }
        this.waitingInitUrls.push(url);
        if (!this.cacheLoading) {
            this.cacheLoading = this.initCache()
                .then(function (cache) {
                _this.cache = cache;
                _this.cacheLoading = undefined;
                return cache;
            })
                .catch(function (err) {
                _this.cacheLoading = undefined;
                throw err;
            });
        }
        return this.cacheLoading;
    };
    MediaEmojiCache.prototype.initCache = function () {
        var _this = this;
        var url = this.waitingInitUrls.pop();
        if (!url) {
            return Promise.reject('Unable to initialise cache based on provided url(s)');
        }
        return BrowserCacheStrategy.supported(url, this.mediaImageLoader)
            .then(function (supported) {
            _this.waitingInitUrls = []; // clear
            _this.cacheLoading = undefined;
            if (supported) {
                return new BrowserCacheStrategy(_this.mediaImageLoader);
            }
            return new MemoryCacheStrategy(_this.mediaImageLoader);
        })
            .catch(function () {
            return _this.initCache();
        });
    };
    return MediaEmojiCache;
}());
/* harmony default export */ __webpack_exports__["a"] = (MediaEmojiCache);
//# sourceMappingURL=MediaEmojiCache.js.map

/***/ }),
/* 2929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_image__ = __webpack_require__(1404);

var defaultConcurrentDownloadLimit = 16;
var MediaImageLoader = /** @class */ (function () {
    function MediaImageLoader(tokenManager, options) {
        this.mediaImageQueue = [];
        this.activeProcessing = 0;
        this.pendingRequests = new Map();
        this.concurrentDownloadLimit =
            (options && options.concurrentDownloadLimit) ||
                defaultConcurrentDownloadLimit;
        this.tokenManager = tokenManager;
    }
    MediaImageLoader.prototype.loadMediaImage = function (url) {
        var _this = this;
        var maybePending = this.pendingRequests.get(url);
        if (maybePending !== undefined) {
            return maybePending;
        }
        var pending = new Promise(function (resolve, reject) {
            _this.mediaImageQueue.push({
                url: url,
                resolve: resolve,
                reject: reject,
            });
            _this.processFromQueue();
        })
            .then(function (result) {
            _this.pendingRequests.delete(url);
            return result;
        })
            .catch(function (error) {
            _this.pendingRequests.delete(url);
            throw error;
        });
        this.pendingRequests.set(url, pending);
        return pending;
    };
    MediaImageLoader.prototype.getQueueSize = function () {
        return this.mediaImageQueue.length;
    };
    MediaImageLoader.prototype.getActiveDownloads = function () {
        return this.activeProcessing;
    };
    MediaImageLoader.prototype.processFromQueue = function () {
        var _this = this;
        var _loop_1 = function () {
            this_1.activeProcessing++;
            var item = this_1.mediaImageQueue.shift();
            var url = item.url, resolve = item.resolve, reject = item.reject;
            this_1.tokenManager
                .getToken('read', false)
                .then(function (token) {
                _this.requestMediaEmoji(url, token, true)
                    .then(function (dataURL) {
                    resolve(dataURL);
                    _this.completedItem();
                })
                    .catch(function (error) {
                    reject(error);
                    _this.completedItem();
                });
            })
                .catch(function (error) {
                // Failed to load, just resolve to original emoji
                reject(error);
                _this.completedItem();
            });
        };
        var this_1 = this;
        while (this.activeProcessing < this.concurrentDownloadLimit &&
            this.mediaImageQueue.length > 0) {
            _loop_1();
        }
    };
    MediaImageLoader.prototype.completedItem = function () {
        this.activeProcessing--;
        this.processFromQueue();
    };
    MediaImageLoader.prototype.requestMediaEmoji = function (url, token, retryOnAuthError) {
        var _this = this;
        return Object(__WEBPACK_IMPORTED_MODULE_0__util_image__["c" /* imageAcceptHeader */])().then(function (acceptHeader) {
            // Media REST API: https://media-api-internal.atlassian.io/api.html#file__fileId__image_get
            var options = {
                headers: {
                    Authorization: "Bearer " + token.jwt,
                    'X-Client-Id': token.clientId,
                    Accept: acceptHeader,
                },
            };
            return fetch(url, options).then(function (response) {
                if (response.status === 403 && retryOnAuthError) {
                    // retry once if 403
                    return _this.tokenManager
                        .getToken('read', true)
                        .then(function (newToken) { return _this.requestMediaEmoji(url, newToken, false); });
                }
                else if (response.ok) {
                    return response.blob().then(function (blob) { return _this.readBlob(blob); });
                }
                throw new Error("Unable to load media image. Status=" + response.status + " " + response.statusText);
            });
        });
    };
    MediaImageLoader.prototype.readBlob = function (blob) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            // TODO: [ts30] Add proper handling for null and ArrayBuffer
            reader.addEventListener('load', function () { return resolve(reader.result); });
            reader.addEventListener('error', function () { return reject(reader.error); });
            reader.readAsDataURL(blob);
        });
    };
    return MediaImageLoader;
}());
/* harmony default export */ __webpack_exports__["a"] = (MediaImageLoader);
//# sourceMappingURL=MediaImageLoader.js.map

/***/ }),
/* 2930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export expireAdjustment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_util_service_support__ = __webpack_require__(41);

// expire 30 seconds early to factor in latency, slow services, etc
var expireAdjustment = 30;
var TokenManager = /** @class */ (function () {
    function TokenManager(siteServiceConfig) {
        this.siteServiceConfig = siteServiceConfig;
        this.tokens = new Map();
    }
    TokenManager.prototype.addToken = function (type, mediaApiToken) {
        this.tokens.set(type, {
            mediaApiToken: mediaApiToken,
        });
    };
    TokenManager.prototype.getToken = function (type, forceRefresh) {
        var tokenDetail = this.tokens.get(type);
        if (!tokenDetail) {
            tokenDetail = {};
            this.tokens.set(type, tokenDetail);
        }
        var mediaApiToken = tokenDetail.mediaApiToken, activeTokenRefresh = tokenDetail.activeTokenRefresh;
        if (mediaApiToken) {
            var nowInSeconds = Date.now() / 1000;
            var expiresAt = mediaApiToken.expiresAt - expireAdjustment;
            if (nowInSeconds < expiresAt && !forceRefresh) {
                // still valid
                return Promise.resolve(mediaApiToken);
            }
            if (activeTokenRefresh) {
                // refresh already active, return that
                return activeTokenRefresh;
            }
            // clear expired token
            tokenDetail.mediaApiToken = undefined;
        }
        var path = "token/" + type;
        // request a new token and track the promise for future requests until completed
        tokenDetail.activeTokenRefresh = __WEBPACK_IMPORTED_MODULE_0__atlaskit_util_service_support__["b" /* utils */]
            .requestService(this.siteServiceConfig, { path: path })
            .then(function (mediaApiToken) {
            tokenDetail.activeTokenRefresh = undefined;
            tokenDetail.mediaApiToken = mediaApiToken;
            return mediaApiToken;
        });
        return tokenDetail.activeTokenRefresh;
    };
    return TokenManager;
}());
/* harmony default export */ __webpack_exports__["a"] = (TokenManager);
//# sourceMappingURL=TokenManager.js.map

/***/ }),
/* 2931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_LoadingEmojiComponent__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Popup__ = __webpack_require__(2932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_logger__ = __webpack_require__(120);





var emojiTypeAheadModuleLoader = function () {
    return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 3475));
};
var emojiTypeAheadComponentLoader = function () { return emojiTypeAheadModuleLoader().then(function (module) { return module.default; }); };
var EmojiTypeahead = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiTypeahead, _super);
    function EmojiTypeahead(props) {
        var _this = _super.call(this, props, {}) || this;
        _this.state = {
            asyncLoadedComponent: EmojiTypeahead.AsyncLoadedComponent,
        };
        _this.selectNext = function () {
            if (_this.refs.typeAhead) {
                _this.refs.typeAhead.selectNext();
            }
        };
        _this.selectPrevious = function () {
            if (_this.refs.typeAhead) {
                _this.refs.typeAhead.selectPrevious();
            }
        };
        _this.chooseCurrentSelection = function () {
            if (_this.refs.typeAhead) {
                _this.refs.typeAhead.chooseCurrentSelection();
            }
        };
        _this.count = function () {
            if (_this.refs.typeAhead) {
                return _this.refs.typeAhead.count();
            }
            return 0;
        };
        return _this;
    }
    EmojiTypeahead.prototype.asyncLoadComponent = function () {
        var _this = this;
        emojiTypeAheadComponentLoader().then(function (component) {
            EmojiTypeahead.AsyncLoadedComponent = component;
            _this.setAsyncState(component);
        });
    };
    EmojiTypeahead.prototype.renderLoaded = function (loadedEmojiProvider, EmojiTypeAheadComponent) {
        var _a = this.props, emojiProvider = _a.emojiProvider, target = _a.target, position = _a.position, zIndex = _a.zIndex, offsetX = _a.offsetX, offsetY = _a.offsetY, otherProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["emojiProvider", "target", "position", "zIndex", "offsetX", "offsetY"]);
        var typeAhead = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](EmojiTypeAheadComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, otherProps, { emojiProvider: loadedEmojiProvider, ref: "typeAhead" })));
        if (position) {
            Object(__WEBPACK_IMPORTED_MODULE_4__util_logger__["a" /* default */])('target, position', target, position);
            if (target) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Popup__["a" /* default */], { target: target, relativePosition: position, zIndex: zIndex, offsetX: offsetX, offsetY: offsetY, children: typeAhead }));
            }
            // don't show if we have a position, but no target yet
            return null;
        }
        return typeAhead;
    };
    return EmojiTypeahead;
}(__WEBPACK_IMPORTED_MODULE_2__common_LoadingEmojiComponent__["a" /* default */]));
/* unused harmony default export */ var _unused_webpack_default_export = (EmojiTypeahead);
//# sourceMappingURL=EmojiTypeAhead.js.map

/***/ }),
/* 2932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);




var getTargetNode = function (target) {
    if (typeof target === 'string') {
        return document.querySelector(target);
    }
    // Expect to be an element
    return target;
};
/*
 * Simple implementation of popup while waiting for ak-inline-dialog
 */
var Popup = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Popup, _super);
    function Popup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.debounced = null;
        _this.handleResize = function () {
            if (_this.debounced) {
                clearTimeout(_this.debounced);
                _this.debounced = null;
            }
            // Timeout set to 30ms as to not throttle IE11
            _this.debounced = window.setTimeout(function () {
                _this.applyAbsolutePosition();
                _this.debounced = null;
            }, 30);
        };
        return _this;
    }
    Popup.prototype.componentDidMount = function () {
        this.popup = document.createElement('div');
        document.body.appendChild(this.popup);
        this.popup.style.position = 'absolute';
        window.addEventListener('resize', this.handleResize);
        this.applyAbsolutePosition();
        this.renderContent();
    };
    Popup.prototype.componentDidUpdate = function () {
        this.applyAbsolutePosition();
        this.renderContent();
    };
    Popup.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleResize);
        __WEBPACK_IMPORTED_MODULE_2_react_dom__["unmountComponentAtNode"](this.popup);
        document.body.removeChild(this.popup);
    };
    // Internal
    Popup.prototype.applyBelowPosition = function () {
        var targetNode = getTargetNode(this.props.target);
        if (targetNode) {
            var box = targetNode.getBoundingClientRect();
            var top_1 = box.bottom + (this.props.offsetY || 0);
            var left = box.left + (this.props.offsetX || 0);
            this.popup.style.top = top_1 + "px";
            this.popup.style.bottom = '';
            this.popup.style.left = left + "px";
        }
    };
    Popup.prototype.applyAbovePosition = function () {
        var targetNode = getTargetNode(this.props.target);
        if (targetNode) {
            var box = targetNode.getBoundingClientRect();
            var bottom = window.innerHeight - box.top + (this.props.offsetY || 0);
            var left = box.left + (this.props.offsetX || 0);
            this.popup.style.top = '';
            this.popup.style.bottom = bottom + "px";
            this.popup.style.left = left + "px";
        }
    };
    Popup.prototype.applyAbsolutePosition = function () {
        if (this.props.relativePosition === 'above') {
            this.applyAbovePosition();
        }
        else if (this.props.relativePosition === 'below') {
            this.applyBelowPosition();
        }
        else {
            var targetNode = getTargetNode(this.props.target);
            if (targetNode) {
                var box = targetNode.getBoundingClientRect();
                var viewPortHeight = window.innerHeight;
                if (box.top < viewPortHeight / 2) {
                    this.applyBelowPosition();
                }
                else {
                    this.applyAbovePosition();
                }
            }
        }
        if (this.props.zIndex) {
            this.popup.style.zIndex = "" + this.props.zIndex;
        }
    };
    Popup.prototype.renderContent = function () {
        __WEBPACK_IMPORTED_MODULE_2_react_dom__["render"](this.props.children, this.popup);
    };
    Popup.prototype.render = function () {
        // inline placeholder element for react to render inplace
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null);
    };
    Popup.defaultProps = {
        relativePosition: 'auto',
        offsetX: 0,
        offsetY: 0,
        zIndex: 0,
    };
    return Popup;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Popup);
//# sourceMappingURL=Popup.js.map

/***/ }),
/* 2933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WithProviders; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var WithProviders = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WithProviders, _super);
    function WithProviders(props) {
        var _this = _super.call(this, props) || this;
        _this.handleProvider = function (name, provider) {
            _this.setState(function (_a) {
                var providers = _a.providers;
                var _b;
                return {
                    providers: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, providers, (_b = {}, _b[name] = provider, _b)),
                };
            });
        };
        var providers = {};
        _this.props.providers.forEach(function (name) {
            providers[name] = undefined;
        });
        _this.state = {
            providers: providers,
        };
        return _this;
    }
    WithProviders.prototype.componentWillMount = function () {
        var _this = this;
        var _a = this.props, providers = _a.providers, providerFactory = _a.providerFactory;
        providers.forEach(function (name) {
            providerFactory.subscribe(name, _this.handleProvider);
        });
    };
    WithProviders.prototype.componentWillUnmount = function () {
        var _this = this;
        var _a = this.props, providers = _a.providers, providerFactory = _a.providerFactory;
        providers.forEach(function (name) {
            providerFactory.unsubscribe(name, _this.handleProvider);
        });
    };
    WithProviders.prototype.render = function () {
        var _a = this, state = _a.state, props = _a.props;
        var renderNode = props.renderNode;
        return renderNode(state.providers);
    };
    return WithProviders;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

//# sourceMappingURL=withProviders.js.map

/***/ }),
/* 2934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styled__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__grid__ = __webpack_require__(900);




function MediaSingle(_a) {
    var children = _a.children, layout = _a.layout, width = _a.width, height = _a.height, _b = _a.containerWidth, containerWidth = _b === void 0 ? width : _b, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c, pctWidth = _a.pctWidth, lineLength = _a.lineLength, className = _a.className;
    var usePctWidth = pctWidth && Object(__WEBPACK_IMPORTED_MODULE_3__grid__["b" /* layoutSupportsWidth */])(layout);
    if (pctWidth && usePctWidth) {
        var pxWidth = Math.ceil(Object(__WEBPACK_IMPORTED_MODULE_3__grid__["a" /* calcPxFromPct */])(pctWidth / 100, lineLength || containerWidth));
        // scale, keeping aspect ratio
        height = (height / width) * pxWidth;
        width = pxWidth;
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styled__["a" /* default */], { layout: layout, width: width, height: height, containerWidth: containerWidth, pctWidth: pctWidth, className: __WEBPACK_IMPORTED_MODULE_2_classnames__('media-single', "image-" + layout, className, {
            'is-loading': isLoading,
            'media-wrapped': layout === 'wrap-left' || layout === 'wrap-right',
        }) }, __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children)));
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 2935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mention_with_providers__ = __webpack_require__(2936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__providerFactory__ = __webpack_require__(476);





var Mention = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Mention, _super);
    function Mention(props) {
        var _this = _super.call(this, props) || this;
        _this.renderWithProvider = function (providers) {
            var _a = _this.props, accessLevel = _a.accessLevel, eventHandlers = _a.eventHandlers, id = _a.id, portal = _a.portal, text = _a.text;
            var mentionProvider = providers.mentionProvider, profilecardProvider = providers.profilecardProvider;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__mention_with_providers__["a" /* default */], { id: id, text: text, accessLevel: accessLevel, eventHandlers: eventHandlers, mentionProvider: mentionProvider, profilecardProvider: profilecardProvider, portal: portal }));
        };
        _this.providerFactory = props.providers || new __WEBPACK_IMPORTED_MODULE_3__providerFactory__["b" /* default */]();
        return _this;
    }
    Mention.prototype.componentWillUnmount = function () {
        if (!this.props.providers) {
            // new ProviderFactory is created if no `providers` has been set
            // in this case when component is unmounted it's safe to destroy this providerFactory
            this.providerFactory.destroy();
        }
    };
    Mention.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__providerFactory__["a" /* WithProviders */], { providers: ['mentionProvider', 'profilecardProvider'], providerFactory: this.providerFactory, renderNode: this.renderWithProvider }));
    };
    return Mention;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* unused harmony default export */ var _unused_webpack_default_export = (Mention);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_mention__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mention_with_profilecard__ = __webpack_require__(2957);





var GENERIC_USER_IDS = ['HipChat', 'all', 'here'];
var noop = function () { };
var MentionWithProviders = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionWithProviders, _super);
    function MentionWithProviders() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { profilecardProvider: null };
        return _this;
    }
    MentionWithProviders.prototype.componentWillMount = function () {
        this.updateProfilecardProvider(this.props);
    };
    MentionWithProviders.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.profilecardProvider !== this.props.profilecardProvider) {
            this.updateProfilecardProvider(nextProps);
        }
    };
    MentionWithProviders.prototype.updateProfilecardProvider = function (props) {
        var _this = this;
        // We are not using async/await here to avoid having an intermediate Promise
        // introduced by the transpiler.
        // This will allow consumer to use a SynchronousPromise.resolve and avoid useless
        // rerendering
        if (props.profilecardProvider) {
            props.profilecardProvider
                .then(function (profilecardProvider) {
                _this.setState({ profilecardProvider: profilecardProvider });
            })
                .catch(function (err) {
                _this.setState({ profilecardProvider: null });
            });
        }
        else {
            this.setState({ profilecardProvider: null });
        }
    };
    MentionWithProviders.prototype.render = function () {
        var _a = this.props, accessLevel = _a.accessLevel, userType = _a.userType, eventHandlers = _a.eventHandlers, id = _a.id, mentionProvider = _a.mentionProvider, portal = _a.portal, text = _a.text;
        var profilecardProvider = this.state.profilecardProvider;
        var actionHandlers = {};
        ['onClick', 'onMouseEnter', 'onMouseLeave'].forEach(function (handler) {
            actionHandlers[handler] =
                (eventHandlers && eventHandlers[handler]) || noop;
        });
        // tslint:disable-next-line:variable-name
        var MentionComponent = profilecardProvider && GENERIC_USER_IDS.indexOf(id) === -1
            ? __WEBPACK_IMPORTED_MODULE_3__mention_with_profilecard__["a" /* default */]
            : __WEBPACK_IMPORTED_MODULE_2__atlaskit_mention__["a" /* ResourcedMention */];
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MentionComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ id: id, text: text, accessLevel: accessLevel, userType: userType, mentionProvider: mentionProvider, profilecardProvider: profilecardProvider, portal: portal }, actionHandlers)));
    };
    return MentionWithProviders;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (MentionWithProviders);
//# sourceMappingURL=mention-with-providers.js.map

/***/ }),
/* 2937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tokenizerRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return nonSpacingMarkRegex; });
// \p{Han} => each chinese character is a separate token
// \p{L}+[\p{Mn}|']*\p{L} => consecutive letters, including non spacing mark and apostrophe are a single token
// const tokenizerRegex = new XRegExp("\\p{Han}|\\p{L}+[\\p{Mn}|']*\\p{L}*", 'gi');
// const nonSpacingMarkRegex = new XRegExp('\\p{Mn}', 'gi');
// Note: regex compiled to unicode charsets using @atlaskit/xregexp-transformer (packages/elements/xregexp-transformer). Refer to it if you need to compile it again.
var tokenizerRegex = new RegExp("[\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FEF\uF900-\uFA6D\uFA70-\uFAD9]|[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]+[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F|']*[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*", 'gi');
var nonSpacingMarkRegex = new RegExp('[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]', 'gi');
//# sourceMappingURL=searchIndexRegex.js.map

/***/ }),
/* 2938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DefaultPresenceCache */
/* unused harmony export DefaultPresenceParser */
/* unused harmony export AbstractPresenceResource */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_logger__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MentionResource__ = __webpack_require__(902);



var CacheEntry = /** @class */ (function () {
    function CacheEntry(pres, timeout) {
        this.presence = pres;
        this.expiry = Date.now() + timeout;
    }
    CacheEntry.prototype.expired = function () {
        return Date.now() > this.expiry;
    };
    return CacheEntry;
}());
var AbstractPresenceResource = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AbstractPresenceResource, _super);
    function AbstractPresenceResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AbstractPresenceResource.prototype.refreshPresence = function (userIds) {
        throw new Error("not yet implemented.\nParams: userIds=" + userIds);
    };
    AbstractPresenceResource.prototype.notifyListeners = function (presences) {
        this.changeListeners.forEach(function (listener, key) {
            try {
                listener(presences);
            }
            catch (e) {
                // ignore error from listener
                Object(__WEBPACK_IMPORTED_MODULE_1__util_logger__["a" /* default */])("error from listener '" + key + "', ignoring", e);
            }
        });
    };
    return AbstractPresenceResource;
}(__WEBPACK_IMPORTED_MODULE_2__MentionResource__["a" /* AbstractResource */]));
var PresenceResource = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](PresenceResource, _super);
    function PresenceResource(config) {
        var _this = _super.call(this) || this;
        if (!config.url) {
            throw new Error('config.url is a required parameter');
        }
        if (!config.cloudId) {
            throw new Error('config.cloudId is a required parameter');
        }
        _this.config = config;
        _this.config.url = PresenceResource.cleanUrl(config.url);
        _this.presenceCache =
            config.cache || new DefaultPresenceCache(config.cacheExpiry);
        _this.presenceParser = config.parser || new DefaultPresenceParser();
        return _this;
    }
    PresenceResource.prototype.refreshPresence = function (userIds) {
        var cacheHits = this.presenceCache.getBulk(userIds);
        this.notifyListeners(cacheHits);
        var cacheMisses = this.presenceCache.getMissingUserIds(userIds);
        if (cacheMisses.length) {
            this.retrievePresence(cacheMisses);
        }
    };
    PresenceResource.prototype.retrievePresence = function (userIds) {
        var _this = this;
        this.queryDirectoryForPresences(userIds)
            .then(function (res) { return _this.presenceParser.parse(res); })
            .then(function (presences) {
            _this.notifyListeners(presences);
            _this.presenceCache.update(presences);
        });
    };
    PresenceResource.prototype.queryDirectoryForPresences = function (userIds) {
        var data = {
            query: "query getPresenceForMentions($organizationId: String!, $userIds: [String!], $productId: String) {\n                PresenceBulk(organizationId: $organizationId, product: $productId, userIds: $userIds) {\n                  userId\n                  state\n                  stateMetadata\n                }\n              }",
            variables: {
                organizationId: this.config.cloudId,
                userIds: userIds,
            },
        };
        if (this.config.productId) {
            data.variables['productId'] = this.config.productId;
        }
        var options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(data),
        };
        return fetch(this.config.url, options).then(function (response) { return response.json(); });
    };
    PresenceResource.cleanUrl = function (url) {
        if (url.substr(-1) !== '/') {
            url += '/';
        }
        return url;
    };
    return PresenceResource;
}(AbstractPresenceResource));
var DefaultPresenceCache = /** @class */ (function () {
    function DefaultPresenceCache(cacheTimeout, cacheTrigger) {
        this.expiryInMillis = cacheTimeout
            ? cacheTimeout
            : DefaultPresenceCache.defaultTimeout;
        this.flushTrigger = cacheTrigger
            ? cacheTrigger
            : DefaultPresenceCache.defaultFlushTrigger;
        this.cache = {};
        this.size = 0;
    }
    /**
     * Precondition: _delete is only called internally if userId exists in cache
     * Removes cache entry
     * @param userId
     */
    DefaultPresenceCache.prototype._delete = function (userId) {
        delete this.cache[userId];
        this.size--;
    };
    /**
     * Checks a cache entry and calls delete if the info has expired
     * @param userId
     */
    DefaultPresenceCache.prototype._deleteIfExpired = function (userId) {
        if (this.contains(userId) && this.cache[userId].expired()) {
            this._delete(userId);
        }
    };
    /**
     * Cleans expired entries from cache
     */
    DefaultPresenceCache.prototype._removeExpired = function () {
        var _this = this;
        Object.keys(this.cache).forEach(function (id) {
            _this._deleteIfExpired(id);
        });
    };
    /**
     * Checks if a user exists in the cache
     * @param userId
     */
    DefaultPresenceCache.prototype.contains = function (userId) {
        return this.cache.hasOwnProperty(userId);
    };
    /**
     * Retrieves a presence from the cache after checking for expired entries
     * @param userId - to index the cache
     * @returns Presence - the presence that matches the userId
     */
    DefaultPresenceCache.prototype.get = function (userId) {
        this._deleteIfExpired(userId);
        if (!this.contains(userId)) {
            return {};
        }
        return this.cache[userId].presence;
    };
    /**
     * Retrieve multiple presences at once from the cache
     * @param userIds - to index the cache
     * @returns PresenceMap - A map of userIds to cached Presences
     */
    DefaultPresenceCache.prototype.getBulk = function (userIds) {
        var e_1, _a;
        var presences = {};
        try {
            for (var userIds_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](userIds), userIds_1_1 = userIds_1.next(); !userIds_1_1.done; userIds_1_1 = userIds_1.next()) {
                var userId = userIds_1_1.value;
                if (this.contains(userId)) {
                    presences[userId] = this.get(userId);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (userIds_1_1 && !userIds_1_1.done && (_a = userIds_1.return)) _a.call(userIds_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return presences;
    };
    /**
     * For a given list of ids, returns a subset
     * of all the ids with missing cache entries.
     * @param userIds - to index the cache
     * @returns string[] - ids missing from the cache
     */
    DefaultPresenceCache.prototype.getMissingUserIds = function (userIds) {
        var _this = this;
        return userIds.filter(function (id) { return !_this.contains(id); });
    };
    /**
     * Precondition: presMap only contains ids of users not in cache
     *               expired users must first be removed then reinserted with updated presence
     * Updates the cache by adding the new Presence entries and setting the expiry time
     * @param presMap
     */
    DefaultPresenceCache.prototype.update = function (presMap) {
        var _this = this;
        if (this.size >= this.flushTrigger) {
            this._removeExpired();
        }
        Object.keys(presMap).forEach(function (userId) {
            _this.cache[userId] = new CacheEntry(presMap[userId], _this.expiryInMillis);
            _this.size++;
        });
    };
    DefaultPresenceCache.defaultTimeout = 20000;
    DefaultPresenceCache.defaultFlushTrigger = 50;
    return DefaultPresenceCache;
}());

var DefaultPresenceParser = /** @class */ (function () {
    function DefaultPresenceParser() {
    }
    DefaultPresenceParser.prototype.mapState = function (state) {
        if (state === 'unavailable') {
            return 'offline';
        }
        else if (state === 'available') {
            return 'online';
        }
        else {
            return state;
        }
    };
    DefaultPresenceParser.prototype.parse = function (response) {
        var e_2, _a;
        var presences = {};
        if (response.hasOwnProperty('data') &&
            response['data'].hasOwnProperty('PresenceBulk')) {
            var results = response['data'].PresenceBulk;
            try {
                // Store map of state and time indexed by userId.  Ignore null results.
                for (var results_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](results), results_1_1 = results_1.next(); !results_1_1.done; results_1_1 = results_1.next()) {
                    var user = results_1_1.value;
                    if (user.userId && user.state) {
                        var state = DefaultPresenceParser.extractState(user);
                        presences[user.userId] = {
                            status: this.mapState(state),
                        };
                    }
                    else if (!user.hasOwnProperty('userId') ||
                        !user.hasOwnProperty('state')) {
                        // tslint:disable-next-line:no-console
                        console.error('Unexpected response from presence service contains keys: ' +
                            Object.keys(user));
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (results_1_1 && !results_1_1.done && (_a = results_1.return)) _a.call(results_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        return presences;
    };
    DefaultPresenceParser.extractState = function (presence) {
        if (DefaultPresenceParser.isFocusState(presence)) {
            return DefaultPresenceParser.FOCUS_STATE;
        }
        return presence.state;
    };
    /*
      This is a bit of an odd exception. In the case where a user is in "Focus Mode", their presence state
      is returned as 'busy' along with a `stateMetadata` object containing a `focus` field.
      In this case we ignore the value of the `state` field and treat the presence as a 'focus' state.
     */
    DefaultPresenceParser.isFocusState = function (presence) {
        if (presence.stateMetadata) {
            try {
                var metadata = JSON.parse(presence.stateMetadata);
                return metadata && !!metadata.focus;
            }
            catch (e) {
                // tslint:disable-next-line:no-console
                console.error("Failed to parse presence's stateMetadata for user with id " + presence.userId + ": " + presence.stateMetadata);
                // tslint:disable-next-line:no-console
                console.error(e);
            }
        }
        return false;
    };
    DefaultPresenceParser.FOCUS_STATE = 'focus';
    return DefaultPresenceParser;
}());


/* unused harmony default export */ var _unused_webpack_default_export = (PresenceResource);
//# sourceMappingURL=PresenceResource.js.map

/***/ }),
/* 2939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(2940));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var LockCircleIcon = function LockCircleIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill-rule=\"evenodd\"><circle fill=\"currentColor\" cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M12.02 8h-.04A1.98 1.98 0 0 0 10 9.98V11h1V9.99a.99.99 0 0 1 .99-.99h.02a.99.99 0 0 1 .99.99V11h1V9.98A1.98 1.98 0 0 0 12.02 8M10 11h1v1h-1zm3 0h1v1h-1zm0 1h-3a1 1 0 0 0-1 1v2.001a1 1 0 0 0 .991.999h4.018a.992.992 0 0 0 .991-.999V13a1 1 0 0 0-1-1h-1z\" fill=\"inherit\"/></g></svg>"
  }, props));
};

LockCircleIcon.displayName = 'LockCircleIcon';
var _default = LockCircleIcon;
exports.default = _default;

/***/ }),
/* 2940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(54);

var _interopRequireDefault = __webpack_require__(53);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.size = exports.default = exports.IconWrapper = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(4));

var _createClass2 = _interopRequireDefault(__webpack_require__(5));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(7));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(6));

var _inherits2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _styledComponents = _interopRequireDefault(__webpack_require__(2));

var _uuid = _interopRequireDefault(__webpack_require__(22));

var _theme = __webpack_require__(3);

var _constants = __webpack_require__(2941);

var getSize = function getSize(props) {
  if (props.size) {
    return "height: ".concat(_constants.sizes[props.size], "; width: ").concat(_constants.sizes[props.size], ";");
  }

  return null;
};

var IconWrapper = _styledComponents.default.span.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "dyhwwi-0"
})(["\n  ", " color: ", ";\n  display: inline-block;\n  fill: ", ";\n  flex-shrink: 0;\n  line-height: 1;\n\n  > svg {\n    ", " max-height: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    pointer-events: none;\n    vertical-align: bottom;\n  }\n  /* Stop-color doesn't properly apply in chrome when the inherited/current color changes.\n   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS\n   * rule) and then override it with currentColor for the color changes to be picked up.\n   */\n  stop {\n    stop-color: currentColor;\n  }\n"], getSize, function (p) {
  return p.primaryColor || 'currentColor';
}, function (p) {
  return p.secondaryColor || _theme.colors.background;
}, getSize);

exports.IconWrapper = IconWrapper;

var Icon =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Icon, _Component);

  function Icon() {
    (0, _classCallCheck2.default)(this, Icon);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Icon).apply(this, arguments));
  }

  (0, _createClass2.default)(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Glyph = _this$props.glyph,
          dangerouslySetGlyph = _this$props.dangerouslySetGlyph,
          onClick = _this$props.onClick,
          primaryColor = _this$props.primaryColor,
          secondaryColor = _this$props.secondaryColor,
          size = _this$props.size; // handling the glyphs as strings

      if (dangerouslySetGlyph) {
        return _react.default.createElement(IconWrapper, {
          onClick: onClick,
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          size: size,
          "aria-label": this.props.label,
          dangerouslySetInnerHTML: {
            __html: Icon.insertDynamicGradientID(dangerouslySetGlyph)
          }
        });
      } // handling the glyphs when passed through as functions


      return _react.default.createElement(IconWrapper, {
        onClick: onClick,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        "aria-label": this.props.label
      }, Glyph ? _react.default.createElement(Glyph, {
        role: "presentation"
      }) : null);
    }
  }], [{
    key: "insertDynamicGradientID",

    /* Icons need unique gradient IDs across instances for different gradient definitions to work
     * correctly.
     * A step in the icon build process replaces linear gradient IDs and their references in paths
     * to a placeholder string so we can replace them with a dynamic ID here.
     * Replacing the original IDs with placeholders in the build process is more robust than not
     * using placeholders as we do not have to rely on regular expressions to find specific element
     * to replace.
     */
    value: function insertDynamicGradientID(svgStr) {
      var id = (0, _uuid.default)();
      var replacedSvgStr = svgStr.replace(/id="([^"]+)-idPlaceholder"/g, "id=$1-".concat(id)).replace(/fill="url\(#([^"]+)-idPlaceholder\)"/g, "fill=\"url(#$1-".concat(id, ")\""));
      return replacedSvgStr;
    }
  }]);
  return Icon;
}(_react.Component);

exports.default = Icon;
(0, _defineProperty2.default)(Icon, "defaultProps", {
  onClick: function onClick() {}
});
var size = Object.keys(_constants.sizes).reduce(function (p, c) {
  return Object.assign(p, (0, _defineProperty2.default)({}, c, c));
}, {});
exports.size = size;

/***/ }),
/* 2941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = void 0;
var sizes = {
  small: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '48px'
};
exports.sizes = sizes;

/***/ }),
/* 2942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RowStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AvatarStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NameSectionStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FullNameStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NicknameStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return InfoSectionStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TimeStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MentionItemStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccessSectionStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



var RowStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  overflow: hidden;\n  padding: 6px 14px;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  overflow: hidden;\n  padding: 6px 14px;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n"])));
var AvatarStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  position: relative;\n  flex: initial;\n  opacity: ", ";\n"], ["\n  position: relative;\n  flex: initial;\n  opacity: ",
    ";\n"])), function (props) {
    return props.restricted ? '0.5' : 'inherit';
});
var NameSectionStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  flex: 1;\n  min-width: 0;\n  margin-left: 14px;\n  opacity: ", ";\n"], ["\n  flex: 1;\n  min-width: 0;\n  margin-left: 14px;\n  opacity: ",
    ";\n"])), function (props) {
    return props.restricted ? '0.5' : 'inherit';
});
var FullNameStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: ", ";\n"], ["\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N900);
var NicknameStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_5 || (templateObject_5 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  color: ", ";\n  font-size: 12px;\n\n  margin-top: 2px;\n\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  color: ", ";\n  font-size: 12px;\n\n  margin-top: 2px;\n\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N100);
var InfoSectionStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_6 || (templateObject_6 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  flex-direction: column;\n  text-align: right;\n  opacity: ", ";\n\n  & {\n    /* Lozenge */\n    & > span {\n      margin-bottom: 2px;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  text-align: right;\n  opacity: ",
    ";\n\n  & {\n    /* Lozenge */\n    & > span {\n      margin-bottom: 2px;\n    }\n  }\n"])), function (props) {
    return props.restricted ? '0.5' : 'inherit';
});
// tslint:disable:next-line variable-name
var TimeStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_7 || (templateObject_7 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin-left: 20px;\n  flex: none;\n  color: ", ";\n  font-size: 12px;\n"], ["\n  margin-left: 20px;\n  flex: none;\n  color: ", ";\n  font-size: 12px;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N100);
var MentionItemStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_8 || (templateObject_8 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  background-color: ", ";\n  display: block;\n  overflow: hidden;\n  list-style-type: none;\n  height: 48px;\n  line-height: 1.2;\n  cursor: pointer;\n"], ["\n  background-color: ",
    ";\n  display: block;\n  overflow: hidden;\n  list-style-type: none;\n  height: 48px;\n  line-height: 1.2;\n  cursor: pointer;\n"])), function (props) {
    return props.selected ? __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30 : 'transparent';
});
var AccessSectionStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_9 || (templateObject_9 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  padding-left: 5px;\n  color: ", ";\n"], ["\n  padding-left: 5px;\n  color: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N500);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return messages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(17);

var messages = Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["defineMessages"])({
    noAccessWarning: {
        id: 'fabric.mention.noAccess.warning',
        defaultMessage: "{name} won't be notified as they have no access",
        description: "Warning message to show that the mentioned user won't be notified",
    },
    noAccessLabel: {
        id: 'fabric.mention.noAccess.label',
        defaultMessage: 'No access',
        description: 'Label for no access icon',
    },
    defaultHeadline: {
        id: 'fabric.mention.error.defaultHeadline',
        defaultMessage: 'Something went wrong',
        description: 'Error message shown when there is an error communicating with backend',
    },
    defaultAdvisedAction: {
        id: 'fabric.mention.error.defaultAction',
        defaultMessage: 'Try again in a few seconds',
        description: 'Default advised action when an error occurs',
    },
    loginAgain: {
        id: 'fabric.mention.error.loginAgain',
        defaultMessage: 'Try logging out then in again',
        description: 'Login again message when there is an authentication error occurs',
    },
    differentText: {
        id: 'fabric.mention.error.differentText',
        defaultMessage: 'Try entering different text',
        description: 'Enter different text message when a forbidden error occurs',
    },
});
//# sourceMappingURL=i18n.js.map

/***/ }),
/* 2944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MentionListStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_styles__ = __webpack_require__(478);



var MentionListStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: ", ";\n\n  /* list style */\n  width: ", ";\n  color: #333;\n\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n"], ["\n  display: ",
    ";\n\n  /* list style */\n  width: ", ";\n  color: #333;\n\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n"])), function (props) {
    return props.empty ? 'none' : 'block';
}, __WEBPACK_IMPORTED_MODULE_2__shared_styles__["a" /* mentionListWidth */], __WEBPACK_IMPORTED_MODULE_2__shared_styles__["b" /* noDialogContainerBorderColor */], __WEBPACK_IMPORTED_MODULE_2__shared_styles__["c" /* noDialogContainerBorderRadius */], __WEBPACK_IMPORTED_MODULE_2__shared_styles__["d" /* noDialogContainerBoxShadow */]);
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GenericErrorIllustration__ = __webpack_require__(2946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_i18n__ = __webpack_require__(477);





var advisedActionMessages = {
    '401': __WEBPACK_IMPORTED_MODULE_4__util_i18n__["d" /* LoginAgain */],
    '403': __WEBPACK_IMPORTED_MODULE_4__util_i18n__["c" /* DifferentText */],
    default: __WEBPACK_IMPORTED_MODULE_4__util_i18n__["a" /* DefaultAdvisedAction */],
};
var MentionListError = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionListError, _super);
    function MentionListError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Translate the supplied Error into a message suitable for display in the MentionList.
     *
     * @param error the error to be displayed
     */
    MentionListError.getAdvisedActionMessage = function (error) {
        if (error && error.hasOwnProperty('statusCode')) {
            var httpError = error;
            return (advisedActionMessages[httpError.statusCode.toString()] ||
                advisedActionMessages.default);
        }
        return advisedActionMessages.default;
    };
    MentionListError.prototype.render = function () {
        var error = this.props.error;
        var ErrorMessage = MentionListError.getAdvisedActionMessage(error);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* MentionListErrorStyle */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__GenericErrorIllustration__["a" /* GenericErrorIllustration */], null),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* MentionListErrorHeadlineStyle */], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__util_i18n__["b" /* DefaultHeadline */], null)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* MentionListAdviceStyle */], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ErrorMessage, null))));
    };
    return MentionListError;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (MentionListError);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GenericErrorIllustration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(908);



var GenericErrorIllustration = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](GenericErrorIllustration, _super);
    function GenericErrorIllustration() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GenericErrorIllustration.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* GenericErrorVisualStyle */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 163.3 212", "aria-labelledby": "title" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("defs", null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("style", { dangerouslySetInnerHTML: {
                            __html: '.cls-1{fill:url(#linear-gradient);}.cls-2,.cls-5{opacity:0.6;}.cls-3{fill:#c1c7d0;}.cls-4{fill:#b3bac5;}.cls-5{isolation:isolate;}',
                        } }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("linearGradient", { id: "linear-gradient", x1: "25.54", y1: "806.64", x2: "137.75", y2: "694.44", gradientTransform: "translate(0 -578)", gradientUnits: "userSpaceOnUse" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("stop", { offset: 0, stopColor: "#c1c7d0" }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("stop", { offset: "0.24", stopColor: "#c4cad2", stopOpacity: "0.97" }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("stop", { offset: "0.5", stopColor: "#cdd1d9", stopOpacity: "0.89" }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("stop", { offset: "0.78", stopColor: "#dcdee4", stopOpacity: "0.75" }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("stop", { offset: 1, stopColor: "#ebecf0", stopOpacity: "0.6" }))),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("title", null, this.props.title ? this.props.title : 'Generic Error'),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { "data-name": "Layer 2" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { "data-name": "Layer 1-2" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { className: "cls-1", d: "M94.8,74.2l66.4,115.1a15.16,15.16,0,0,1-5.5,20.7,15.4,15.4,0,0,1-7.6,2H15.2A15.19,15.19,0,0,1,0,196.8a15.4,15.4,0,0,1,2-7.6l66.5-115a15.21,15.21,0,0,1,20.7-5.6A15.81,15.81,0,0,1,94.8,74.2Zm-7.6,83.5,2.9-44.3a9.26,9.26,0,0,0-8.6-9.8h-.6a9.18,9.18,0,0,0-9.2,9.2v.6l2.9,44.3a6.33,6.33,0,0,0,6.3,5.9h0A6.26,6.26,0,0,0,87.2,157.7ZM71.4,181.2a9.5,9.5,0,0,0,9.4,9.6h.9a9.79,9.79,0,0,0,8.8-10.5,9.69,9.69,0,0,0-9.7-8.8A9.58,9.58,0,0,0,71.4,181.2Z" }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { className: "cls-2" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { className: "cls-3", d: "M92.7,27.2,85.3.4a.57.57,0,0,0-.7-.4c-.2.1-.4.2-.4.5L79.5,25.6l-5.8-1.1c-.3-.1-.6.2-.7.5v.3L80.3,52a.75.75,0,0,0,.7.5.82.82,0,0,0,.5-.5l4.7-25.1,5.8,1c.3.1.6-.2.7-.5Z" }),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { className: "cls-3", d: "M66.1,41.8,55.2,33.2a.3.3,0,0,0-.4,0,.19.19,0,0,0,0,.3L60.4,45l-2.7,1.3c-.1.1-.2.2-.1.4a.1.1,0,0,0,.1.1l10.9,8.5a.3.3,0,0,0,.4,0,.19.19,0,0,0,0-.3L63.4,43.6l2.7-1.3a.33.33,0,0,0,0-.5Z" })),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { className: "cls-2" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { className: "cls-4", d: "M102.1,56.8a1.42,1.42,0,0,1-.6-.2,1,1,0,0,1-.3-1.2c-.2-.8-2.3-2.8-3.5-4.1-3-3-4.9-5-3.8-6.5s3.6-.2,7.3,1.7a28.41,28.41,0,0,0,4.5,2,21.58,21.58,0,0,0-3.3-3.6c-3-3-4.9-5-3.8-6.5s3.6-.2,7.4,1.7a27.65,27.65,0,0,0,4.4,2,21.58,21.58,0,0,0-3.3-3.6c-3-3-4.9-5-3.8-6.5s3.6-.2,7.3,1.7c1.6.8,4.2,2.1,5,2.1a.91.91,0,0,1,1.2,0,1.08,1.08,0,0,1,.2,1.4c-1.1,1.5-3.6.2-7.3-1.7a27.65,27.65,0,0,0-4.4-2,21.58,21.58,0,0,0,3.3,3.6c3,3,4.9,5,3.8,6.5s-3.6.2-7.3-1.7a28.41,28.41,0,0,0-4.5-2,21.58,21.58,0,0,0,3.3,3.6c3,3,4.9,5,3.8,6.5s-3.6.2-7.3-1.7a28.41,28.41,0,0,0-4.5-2,21.58,21.58,0,0,0,3.3,3.6c3,3,4.9,5,3.8,6.5A1.8,1.8,0,0,1,102.1,56.8Z" })),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { className: "cls-5" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { className: "cls-4", d: "M107.7,71.1a1.05,1.05,0,0,1-.9-.5c-1-1.9-2.2-4-.9-5.2s3.3.2,5.5,1.6a19.31,19.31,0,0,0,2.9,1.7,15.89,15.89,0,0,0-1.4-3.1c-1.3-2.3-2.5-4.4-1.1-5.6s3.3.2,5.5,1.6c1,.6,2.5,1.7,3.1,1.7a1,1,0,0,1,1.3.1,1,1,0,0,1-.1,1.4c-1.3,1.2-3.3-.2-5.5-1.6a19.31,19.31,0,0,0-2.9-1.7,13.64,13.64,0,0,0,1.4,3.1c1.3,2.3,2.4,4.4,1.1,5.6s-3.3-.2-5.5-1.6a19.31,19.31,0,0,0-2.9-1.7,13.07,13.07,0,0,0,1.2,2.7,1,1,0,0,1-.4,1.4A.6.6,0,0,1,107.7,71.1Zm12.5-7.6Z" })),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { className: "cls-5" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { className: "cls-4", d: "M53.4,68.1a2,2,0,0,1-.7-.1c-1.6-.7-1.2-3.1-.8-5.6a10.87,10.87,0,0,0,.3-3.4A15,15,0,0,0,50,61.6c-1.5,2.1-3,4.1-4.6,3.4a1,1,0,0,1-.5-1.3,1,1,0,0,1,1.2-.6,11.23,11.23,0,0,0,2.3-2.7c1.5-2.1,3-4.1,4.7-3.4s1.3,3.1.8,5.7a13.86,13.86,0,0,0-.3,3.3,11.82,11.82,0,0,0,2.1-2.6c1.5-2.1,3-4.1,4.7-3.4s1.2,3.1.9,5.2a1,1,0,1,1-1.9-.3,14.28,14.28,0,0,0,.3-2.9,15,15,0,0,0-2.2,2.6C56,66.4,54.7,68.1,53.4,68.1Z" })))))));
    };
    return GenericErrorIllustration;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

//# sourceMappingURL=GenericErrorIllustration.js.map

/***/ }),
/* 2947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(2948);




var Scrollable = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Scrollable, _super);
    function Scrollable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // API
        _this.reveal = function (child) {
            if (child && _this.scrollableDiv) {
                var childNode = Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(child);
                // Not using Element.scrollIntoView as it scrolls even to top/bottom of view even if
                // already visible
                var scrollableRect = _this.scrollableDiv.getBoundingClientRect();
                var elementRect = childNode.getBoundingClientRect();
                if (elementRect.top < scrollableRect.top) {
                    _this.scrollableDiv.scrollTop += elementRect.top - scrollableRect.top;
                }
                else if (elementRect.bottom > scrollableRect.bottom) {
                    _this.scrollableDiv.scrollTop +=
                        elementRect.bottom - scrollableRect.bottom;
                }
            }
        };
        _this.handleRef = function (ref) {
            _this.scrollableDiv = ref;
        };
        return _this;
    }
    Scrollable.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* ScrollableStyle */], { innerRef: this.handleRef }, this.props.children));
    };
    return Scrollable;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Scrollable);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollableStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_styles__ = __webpack_require__(478);




var ScrollableStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: block;\n  overflow-x: hidden;\n  overflow-y: auto;\n\n  padding: 4px 0;\n  margin: 0;\n\n  background: white;\n  max-height: ", ";\n\n  border-radius: ", "px;\n"], ["\n  display: block;\n  overflow-x: hidden;\n  overflow-y: auto;\n\n  padding: 4px 0;\n  margin: 0;\n\n  background: white;\n  max-height: ", ";\n\n  border-radius: ", "px;\n"])), __WEBPACK_IMPORTED_MODULE_3__shared_styles__["e" /* scrollableMaxHeight */], Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])());
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MentionPicker */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MentionPickerWithAnalytics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResourcedMentionList__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Popup__ = __webpack_require__(2951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_logger__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_id__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_analytics__ = __webpack_require__(911);









/**
 * @class MentionPicker
 */
var MentionPicker = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionPicker, _super);
    function MentionPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.selectNext = function () {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectNext();
            }
        };
        _this.selectPrevious = function () {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectPrevious();
            }
        };
        _this.selectIndex = function (index, callback) {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectIndex(index, callback);
            }
        };
        _this.selectId = function (id, callback) {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectId(id, callback);
            }
        };
        _this.chooseCurrentSelection = function () {
            if (_this.mentionListRef) {
                _this.mentionListRef.chooseCurrentSelection();
            }
        };
        _this.mentionsCount = function () {
            if (_this.mentionListRef) {
                return _this.mentionListRef.mentionsCount();
            }
            return 0;
        };
        /**
         * Called after the 'visible' state is changed to decide whether the onOpen or onClose
         * handlers should be called.
         *
         * It should be noted that the visible state of the component is not considered in
         * this function. Instead the old state and new state should be passed as parameters.
         */
        _this.onFilterVisibilityChange = function (oldVisibility, newVisibility) {
            if (oldVisibility !== newVisibility) {
                if (newVisibility) {
                    if (_this.props.onOpen) {
                        _this.props.onOpen();
                    }
                }
                else {
                    if (_this.props.onClose) {
                        _this.props.onClose();
                    }
                }
            }
        };
        // internal, used for callbacks
        _this.filterChange = function (mentions, query, stats) {
            Object(__WEBPACK_IMPORTED_MODULE_5__util_logger__["a" /* default */])('ak-mention-picker.filterChange', mentions.length);
            var wasVisible = _this.state.visible;
            var visible = mentions.length > 0;
            _this.setState({
                visible: visible,
            });
            _this.onFilterVisibilityChange(wasVisible, visible);
            if (stats && stats.remoteSearch) {
                __WEBPACK_IMPORTED_MODULE_8__util_analytics__["c" /* fireAnalyticsMentionTypeaheadEvent */](_this.props)('rendered', stats.duration, mentions.map(function (mention) { return mention.id; }), query);
            }
        };
        _this.filterError = function (error) {
            Object(__WEBPACK_IMPORTED_MODULE_5__util_logger__["a" /* default */])('ak-mention-picker.filterError', error);
            var wasVisible = _this.state.visible;
            _this.setState({
                visible: true,
                info: undefined,
            });
            _this.onFilterVisibilityChange(wasVisible, true);
        };
        _this.filterInfo = function (info) {
            Object(__WEBPACK_IMPORTED_MODULE_5__util_logger__["a" /* default */])('ak-mention-picker.filterInfo', info);
            _this.setState({
                info: info,
            });
        };
        _this.handleMentionListRef = function (ref) {
            _this.mentionListRef = ref;
        };
        _this.subscriberKey = Object(__WEBPACK_IMPORTED_MODULE_6__util_id__["a" /* default */])('ak-mention-picker');
        _this.state = {
            visible: false,
        };
        _this.applyPropChanges({}, props);
        return _this;
    }
    MentionPicker.prototype.componentDidMount = function () {
        this.subscribeResourceProvider(this.props.resourceProvider);
    };
    MentionPicker.prototype.componentWillReceiveProps = function (nextProps) {
        this.applyPropChanges(this.props, nextProps);
    };
    MentionPicker.prototype.componentWillUnmount = function () {
        this.unsubscribeResourceProvider(this.props.resourceProvider);
    };
    // Internal
    MentionPicker.prototype.applyPropChanges = function (prevProps, nextProps) {
        var oldResourceProvider = prevProps.resourceProvider;
        var newResourceProvider = nextProps.resourceProvider;
        var resourceProviderChanged = oldResourceProvider !== newResourceProvider;
        // resource provider
        if (resourceProviderChanged) {
            this.unsubscribeResourceProvider(oldResourceProvider);
            this.subscribeResourceProvider(newResourceProvider);
        }
    };
    MentionPicker.prototype.subscribeResourceProvider = function (resourceProvider) {
        if (resourceProvider) {
            resourceProvider.subscribe(this.subscriberKey, this.filterChange, this.filterError, this.filterInfo);
        }
    };
    MentionPicker.prototype.unsubscribeResourceProvider = function (resourceProvider) {
        if (resourceProvider) {
            resourceProvider.unsubscribe(this.subscriberKey);
        }
    };
    MentionPicker.prototype.render = function () {
        var _a = this.props, resourceProvider = _a.resourceProvider, presenceProvider = _a.presenceProvider, onSelection = _a.onSelection, query = _a.query, target = _a.target, position = _a.position, zIndex = _a.zIndex, offsetX = _a.offsetX, offsetY = _a.offsetY;
        var _b = this.state, visible = _b.visible, info = _b.info;
        var resourceMentionList = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ResourcedMentionList__["a" /* default */], { resourceProvider: resourceProvider, presenceProvider: presenceProvider, onSelection: onSelection, query: query, ref: this.handleMentionListRef }));
        var infoContent = info && !visible ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* MentionPickerInfoStyle */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", null, info))) : null;
        var content;
        if (position) {
            Object(__WEBPACK_IMPORTED_MODULE_5__util_logger__["a" /* default */])('target, position', target, position);
            if (target) {
                content = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Popup__["a" /* default */], { target: target, relativePosition: position, zIndex: zIndex, offsetX: offsetX, offsetY: offsetY },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                        resourceMentionList,
                        infoContent)));
            }
            else {
                // don't show if we have a position, but no target yet
                content = null;
            }
        }
        else {
            content = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                resourceMentionList,
                infoContent));
        }
        return (
        /* old classnames are essential for Confluence tests */
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* MentionPickerStyle */], { className: "ak-mention-picker", visible: visible || info }, content));
    };
    MentionPicker.defaultProps = {
        onSelection: function () { },
        onOpen: function () { },
        onClose: function () { },
    };
    return MentionPicker;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

var MentionPickerWithAnalytics = Object(__WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__["withAnalyticsEvents"])({})(MentionPicker);
/* unused harmony default export */ var _unused_webpack_default_export = (MentionPickerWithAnalytics);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MentionPickerStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MentionPickerInfoStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_styles__ = __webpack_require__(478);




var MentionPickerStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: ", ";\n"], ["\n  display: ",
    ";\n"])), function (props) {
    return props.visible ? 'block' : 'none';
});
var MentionPickerInfoStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  background: #fff;\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  display: block;\n  width: ", ";\n  white-space: nowrap;\n\n  & {\n    p {\n      margin: 0;\n      overflow: hidden;\n      padding: 9px;\n      text-overflow: ellipsis;\n    }\n  }\n"], ["\n  background: #fff;\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  display: block;\n  width: ", ";\n  white-space: nowrap;\n\n  & {\n    p {\n      margin: 0;\n      overflow: hidden;\n      padding: 9px;\n      text-overflow: ellipsis;\n    }\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N100, __WEBPACK_IMPORTED_MODULE_3__shared_styles__["b" /* noDialogContainerBorderColor */], __WEBPACK_IMPORTED_MODULE_3__shared_styles__["c" /* noDialogContainerBorderRadius */], __WEBPACK_IMPORTED_MODULE_3__shared_styles__["d" /* noDialogContainerBoxShadow */], __WEBPACK_IMPORTED_MODULE_3__shared_styles__["a" /* mentionListWidth */]);
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);



/*
 * Simple implementation of popup while waiting for ak-inline-dialog
 */
var Popup = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Popup, _super);
    function Popup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Popup.prototype.componentDidMount = function () {
        this.popup = document.createElement('div');
        document.body.appendChild(this.popup);
        this.popup.style.position = 'absolute';
        this._applyAbsolutePosition();
        this._renderContent();
    };
    Popup.prototype.componentDidUpdate = function () {
        this._renderContent();
    };
    Popup.prototype.componentWillUnmount = function () {
        __WEBPACK_IMPORTED_MODULE_2_react_dom__["unmountComponentAtNode"](this.popup);
        document.body.removeChild(this.popup);
    };
    Popup.prototype._applyBelowPosition = function () {
        var targetNode = this.props.target && document.getElementById(this.props.target);
        if (targetNode) {
            var box = targetNode.getBoundingClientRect();
            var top_1 = box.bottom + (this.props.offsetY || 0);
            var left = box.left + (this.props.offsetX || 0);
            this.popup.style.top = top_1 + "px";
            this.popup.style.bottom = '';
            this.popup.style.left = left + "px";
        }
    };
    Popup.prototype._applyAbovePosition = function () {
        var targetNode = this.props.target && document.getElementById(this.props.target);
        if (targetNode) {
            var box = targetNode.getBoundingClientRect();
            var bottom = window.innerHeight - box.top + (this.props.offsetY || 0);
            var left = box.left + (this.props.offsetX || 0);
            this.popup.style.top = '';
            this.popup.style.bottom = bottom + "px";
            this.popup.style.left = left + "px";
        }
    };
    Popup.prototype._applyAbsolutePosition = function () {
        if (this.props.relativePosition === 'above') {
            this._applyAbovePosition();
        }
        else if (this.props.relativePosition === 'below') {
            this._applyBelowPosition();
        }
        else {
            var targetNode = this.props.target && document.getElementById(this.props.target);
            if (targetNode) {
                var box = targetNode.getBoundingClientRect();
                var viewPortHeight = window.innerHeight;
                if (box.top < viewPortHeight / 2) {
                    this._applyBelowPosition();
                }
                else {
                    this._applyAbovePosition();
                }
            }
        }
        if (this.props.zIndex) {
            this.popup.style.zIndex = "" + this.props.zIndex;
        }
    };
    Popup.prototype._renderContent = function () {
        __WEBPACK_IMPORTED_MODULE_2_react_dom__["render"](this.props.children, this.popup);
    };
    Popup.prototype.render = function () {
        // Placeholder element for react to render inplace
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null);
    };
    Popup.defaultProps = {
        relativePosition: 'auto',
        offsetX: 0,
        offsetY: 0,
        zIndex: 0,
    };
    return Popup;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Popup);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2952 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/mention","version":"15.3.0","sideEffects":false}

/***/ }),
/* 2953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MentionStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(136);




var mentionStyle = {};
mentionStyle[__WEBPACK_IMPORTED_MODULE_3__types__["a" /* MentionType */].SELF] = {
    background: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B400, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B200 }),
    border: 'transparent',
    text: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN30 }),
};
mentionStyle[__WEBPACK_IMPORTED_MODULE_3__types__["a" /* MentionType */].RESTRICTED] = {
    background: 'transparent',
    border: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N500, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN80 }),
    text: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N500, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN100 }),
};
mentionStyle[__WEBPACK_IMPORTED_MODULE_3__types__["a" /* MentionType */].DEFAULT] = {
    background: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30A, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN80 }),
    border: 'transparent',
    text: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N500, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN800 }),
};
var getStyle = function (props, property) {
    var obj = mentionStyle[props.mentionType][property];
    // themed() returns a function
    return typeof obj === 'string' ? obj : obj(props);
};
var MentionStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) { return "\n  display: inline;\n  background: " + getStyle(props, 'background') + ";\n  border: 1px solid " + getStyle(props, 'border') + ";\n  border-radius: 20px;\n  color: " + getStyle(props, 'text') + ";\n  cursor: pointer;\n  padding: 0 0.3em 2px 0.23em;\n  line-height: 1.714;\n  font-size: 1em;\n  font-weight: normal;\n  word-break: break-word;\n"; });
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 2954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(913);



var ResourcedMention = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ResourcedMention, _super);
    function ResourcedMention(props) {
        var _this = _super.call(this, props) || this;
        _this.handleMentionProvider = function (props) {
            var id = props.id, mentionProvider = props.mentionProvider;
            if (mentionProvider) {
                mentionProvider
                    .then(function (provider) {
                    _this.setState({
                        isHighlighted: provider.shouldHighlightMention({ id: id }),
                    });
                })
                    .catch(function (e) {
                    _this.setState({
                        isHighlighted: false,
                    });
                });
            }
            else {
                _this.setState({
                    isHighlighted: false,
                });
            }
        };
        _this.state = {
            isHighlighted: false,
        };
        return _this;
    }
    ResourcedMention.prototype.componentDidMount = function () {
        this.handleMentionProvider(this.props);
    };
    ResourcedMention.prototype.componentWillReceiveProps = function (nextProps) {
        var props = this.props;
        if (props.id !== nextProps.id ||
            props.mentionProvider !== nextProps.mentionProvider) {
            this.handleMentionProvider(nextProps);
        }
    };
    ResourcedMention.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2____["a" /* default */], { id: props.id, text: props.text, isHighlighted: state.isHighlighted, accessLevel: props.accessLevel, onClick: props.onClick, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave }));
    };
    return ResourcedMention;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (ResourcedMention);
//# sourceMappingURL=ResourcedMention.js.map

/***/ }),
/* 2955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(2956);


/**
 * This component is stateful and should be instantianted per contextIdentifiers.
 */
var ContextMentionResource = /** @class */ (function () {
    function ContextMentionResource(mentionProvider, contextIdentifier) {
        var _this = this;
        this.callWithContextIds = function (f, declaredArgs) { return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _a;
            var argsLength = args ? args.length : 0;
            // cover the scenario where optional parameters are not passed
            // by passing undefined instead to keep the contextIdentifiers parameter in the right position
            var mentionArgs = argsLength !== declaredArgs
                ? Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* padArray */])(args, declaredArgs - argsLength, undefined)
                : args;
            return (_a = _this.mentionProvider)[f].apply(_a, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](mentionArgs, [_this.contextIdentifier]));
        }; };
        this.callDefault = function (f) { return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _a;
            return (_a = _this.mentionProvider)[f].apply(_a, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](args));
        }; };
        this.subscribe = this.callDefault('subscribe');
        this.unsubscribe = this.callDefault('unsubscribe');
        this.filter = this.callWithContextIds('filter', 1);
        this.recordMentionSelection = this.callWithContextIds('recordMentionSelection', 1);
        this.shouldHighlightMention = this.callDefault('shouldHighlightMention');
        this.isFiltering = this.callDefault('isFiltering');
        this.mentionProvider = mentionProvider;
        this.contextIdentifier = contextIdentifier;
    }
    ContextMentionResource.prototype.getContextIdentifier = function () {
        return this.contextIdentifier;
    };
    return ContextMentionResource;
}());
/* unused harmony default export */ var _unused_webpack_default_export = (ContextMentionResource);
//# sourceMappingURL=ContextMentionResource.js.map

/***/ }),
/* 2956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return padArray; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

var padArray = function (arr, size, value) {
    if (size === 0) {
        return arr;
    }
    var gap = new Array(size);
    gap.fill(value);
    return arr.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](arr, gap) : gap;
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 2957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_mention__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_profilecard__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Popup__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__with_outer_listeners__ = __webpack_require__(915);








// tslint:disable-next-line:variable-name
var ProfilecardResourcedWithListeners = Object(__WEBPACK_IMPORTED_MODULE_6__with_outer_listeners__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__atlaskit_profilecard__["a" /* default */]);
var MentionWithProfileCard = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionWithProfileCard, _super);
    function MentionWithProfileCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            target: null,
            visible: false,
            popupAlignX: 'left',
            popupAlignY: 'top',
        };
        _this.handleRef = function (target) {
            _this.setState({ target: target });
        };
        _this.handleMentionNodeRef = function (component) {
            if (!component) {
                _this.domNode = null;
            }
            else {
                _this.domNode = Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(component);
            }
        };
        _this.showProfilecard = function () {
            if (!_this.domNode) {
                return;
            }
            var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](_this.calculateLayerPosition(), 2), popupAlignX = _a[0], popupAlignY = _a[1];
            _this.setState({
                popupAlignX: popupAlignX,
                popupAlignY: popupAlignY,
                visible: true,
            });
        };
        _this.hideProfilecard = function () {
            _this.setState({ visible: false });
        };
        return _this;
    }
    MentionWithProfileCard.prototype.calculateLayerPosition = function () {
        var domNodeCentreCoords = this.getDomNodeCenterCoords();
        var visibleAreaCentreCoords = this.getVisibleAreaCentreCoords();
        var popupAlignY = domNodeCentreCoords.y > visibleAreaCentreCoords.y ? 'top' : 'bottom';
        var popupAlignX = domNodeCentreCoords.x > visibleAreaCentreCoords.x ? 'right' : 'left';
        return [popupAlignX, popupAlignY];
    };
    MentionWithProfileCard.prototype.getDomNodeCenterCoords = function () {
        var rect = this.domNode.getBoundingClientRect();
        return {
            x: rect.left + rect.width / 2,
            y: rect.top + rect.height / 2,
        };
    };
    MentionWithProfileCard.prototype.getVisibleAreaCentreCoords = function () {
        return {
            x: window.innerWidth / 2,
            y: window.innerHeight / 2,
        };
    };
    MentionWithProfileCard.prototype.getActions = function (id, text, accessLevel) {
        var _this = this;
        var profilecardProvider = this.props.profilecardProvider;
        var actions = profilecardProvider.getActions(id, text, accessLevel);
        return actions.map(function (action) {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, action, { callback: function () {
                    _this.setState({ visible: false });
                    action.callback();
                } });
        });
    };
    MentionWithProfileCard.prototype.render = function () {
        var _a = this.props, accessLevel = _a.accessLevel, id = _a.id, mentionProvider = _a.mentionProvider, profilecardProvider = _a.profilecardProvider, text = _a.text, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, portal = _a.portal;
        var _b = this.state, popupAlignX = _b.popupAlignX, popupAlignY = _b.popupAlignY, target = _b.target, visible = _b.visible;
        var cloudId = profilecardProvider.cloudId, resourceClient = profilecardProvider.resourceClient;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { ref: this.handleRef, onClick: this.showProfilecard },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_mention__["a" /* ResourcedMention */], { ref: this.handleMentionNodeRef, id: id, text: text, accessLevel: accessLevel, mentionProvider: mentionProvider, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }),
            target && portal && visible && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Popup__["a" /* default */], { offset: [0, 8], target: target, mountTo: portal, alignX: popupAlignX, alignY: popupAlignY },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ProfilecardResourcedWithListeners, { handleClickOutside: this.hideProfilecard, handleEscapeKeydown: this.hideProfilecard, cloudId: cloudId, userId: id, resourceClient: resourceClient, actions: this.getActions(id, text, accessLevel) })))));
    };
    return MentionWithProfileCard;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (MentionWithProfileCard);
//# sourceMappingURL=mention-with-profilecard.js.map

/***/ }),
/* 2958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isBody */
/* unused harmony export isTextNode */
/* unused harmony export getVerticalPlacement */
/* unused harmony export getHorizontalPlacement */
/* harmony export (immutable) */ __webpack_exports__["a"] = calculatePlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = calculatePosition;
/* harmony export (immutable) */ __webpack_exports__["c"] = findOverflowScrollParent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

function isBody(elem) {
    return elem === document.body;
}
function isTextNode(elem) {
    return elem && elem.nodeType === 3;
}
/**
 * Decides if given fitHeight fits below or above the target taking boundaries into account.
 */
function getVerticalPlacement(target, boundariesElement, fitHeight, alignY) {
    if (alignY) {
        return alignY;
    }
    if (!fitHeight) {
        return 'bottom';
    }
    if (isTextNode(target)) {
        target = target.parentElement;
    }
    var boundariesClientRect = boundariesElement.getBoundingClientRect();
    var boundariesHeight = boundariesClientRect.height;
    var boundariesTop = isBody(boundariesElement)
        ? 0
        : boundariesClientRect.top;
    var _a = target.getBoundingClientRect(), targetTop = _a.top, targetHeight = _a.height;
    var spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
    var spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
    if (spaceBelow >= fitHeight || spaceBelow >= spaceAbove) {
        return 'bottom';
    }
    return 'top';
}
/**
 * Decides if given fitWidth fits to the left or to the right of the target taking boundaries into account.
 */
function getHorizontalPlacement(target, boundariesElement, fitWidth, alignX) {
    if (alignX) {
        return alignX;
    }
    if (!fitWidth) {
        return 'left';
    }
    if (isTextNode(target)) {
        target = target.parentElement;
    }
    var _a = target.getBoundingClientRect(), targetLeft = _a.left, targetWidth = _a.width;
    var _b = boundariesElement.getBoundingClientRect(), boundariesLeft = _b.left, boundariesWidth = _b.width;
    var spaceLeft = targetLeft - boundariesLeft + targetWidth;
    var spaceRight = boundariesLeft + boundariesWidth - targetLeft;
    if (spaceRight >= fitWidth || spaceRight >= spaceLeft) {
        return 'left';
    }
    return 'right';
}
function calculatePlacement(target, boundariesElement, fitWidth, fitHeight, alignX, alignY) {
    return [
        getVerticalPlacement(target, boundariesElement, fitHeight, alignY),
        getHorizontalPlacement(target, boundariesElement, fitWidth, alignX),
    ];
}
var calculateHorizontalPlacement = function (_a) {
    var placement = _a.placement, targetLeft = _a.targetLeft, targetRight = _a.targetRight, targetWidth = _a.targetWidth, isPopupParentBody = _a.isPopupParentBody, popupOffsetParentLeft = _a.popupOffsetParentLeft, popupOffsetParentRight = _a.popupOffsetParentRight, popupOffsetParentScrollLeft = _a.popupOffsetParentScrollLeft, popupClientWidth = _a.popupClientWidth, offset = _a.offset;
    var position = {};
    if (placement === 'left') {
        position.left = Math.ceil(targetLeft -
            popupOffsetParentLeft +
            (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) +
            offset[0]);
    }
    else if (placement === 'center') {
        position.left = Math.ceil(targetLeft -
            popupOffsetParentLeft +
            (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) +
            offset[0] +
            targetWidth / 2 -
            popupClientWidth / 2);
    }
    else {
        position.right = Math.ceil(popupOffsetParentRight -
            targetRight -
            (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) +
            offset[0]);
    }
    return position;
};
var calculateVerticalStickBottom = function (_a) {
    var target = _a.target, targetTop = _a.targetTop, targetHeight = _a.targetHeight, popup = _a.popup, offset = _a.offset, position = _a.position;
    var scrollParent = findOverflowScrollParent(target);
    if (scrollParent) {
        var topOffsetTop = targetTop - scrollParent.getBoundingClientRect().top;
        var targetEnd = targetHeight + topOffsetTop;
        if (scrollParent.clientHeight - targetEnd <=
            popup.clientHeight + offset[1] * 2 &&
            topOffsetTop < scrollParent.clientHeight) {
            var scroll_1 = targetEnd - scrollParent.clientHeight + offset[1] * 2;
            var top_1 = position.top || 0;
            top_1 = top_1 - (scroll_1 + popup.clientHeight);
            position.top = top_1;
        }
    }
    return position;
};
var calculateVerticalPlacement = function (_a) {
    var placement = _a.placement, targetTop = _a.targetTop, targetHeight = _a.targetHeight, isPopupParentBody = _a.isPopupParentBody, popupOffsetParentHeight = _a.popupOffsetParentHeight, popupOffsetParentTop = _a.popupOffsetParentTop, popupOffsetParentScrollTop = _a.popupOffsetParentScrollTop, borderBottomWidth = _a.borderBottomWidth, offset = _a.offset;
    var position = {};
    if (placement === 'top') {
        position.bottom = Math.ceil(popupOffsetParentHeight -
            (targetTop - popupOffsetParentTop) -
            (isPopupParentBody ? 0 : popupOffsetParentScrollTop) -
            borderBottomWidth +
            offset[1]);
    }
    else {
        var top_2 = Math.ceil(targetTop -
            popupOffsetParentTop +
            targetHeight +
            (isPopupParentBody ? 0 : popupOffsetParentScrollTop) -
            borderBottomWidth +
            offset[1]);
        position.top = top_2;
    }
    return position;
};
/**
 * Calculates relative coordinates for placing popup along with the target.
 * Uses placement from calculatePlacement.
 */
function calculatePosition(_a) {
    var placement = _a.placement, target = _a.target, popup = _a.popup, offset = _a.offset, stickToBottom = _a.stickToBottom;
    var position = {};
    if (!target || !popup || !popup.offsetParent) {
        return position;
    }
    if (isTextNode(target)) {
        target = target.parentElement;
    }
    var popupOffsetParent = popup.offsetParent;
    var offsetParentStyle = popupOffsetParent.style;
    var borderBottomWidth = 0;
    if (offsetParentStyle && offsetParentStyle.borderBottomWidth) {
        borderBottomWidth = parseInt(offsetParentStyle.borderBottomWidth, 10);
    }
    var _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](placement, 2), verticalPlacement = _b[0], horizontalPlacement = _b[1];
    var _c = popupOffsetParent.getBoundingClientRect(), popupOffsetParentTop = _c.top, popupOffsetParentLeft = _c.left, popupOffsetParentRight = _c.right, popupOffsetParentHeight = _c.height;
    var _d = target.getBoundingClientRect(), targetTop = _d.top, targetLeft = _d.left, targetRight = _d.right, targetHeight = _d.height, targetWidth = _d.width;
    var isPopupParentBody = isBody(popupOffsetParent);
    var verticalPosition = calculateVerticalPlacement({
        placement: verticalPlacement,
        targetTop: targetTop,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentHeight: popupOffsetParentHeight,
        popupOffsetParentTop: popupOffsetParentTop,
        popupOffsetParentScrollTop: popupOffsetParent.scrollTop || 0,
        targetHeight: targetHeight,
        borderBottomWidth: borderBottomWidth,
        offset: offset,
    });
    position = Object.assign({}, position, verticalPosition);
    if (verticalPlacement !== 'top' && stickToBottom) {
        var verticalStickToBottomPosition = calculateVerticalStickBottom({
            target: target,
            targetTop: targetTop,
            targetHeight: targetHeight,
            popup: popup,
            offset: offset,
            position: position,
        });
        position = Object.assign({}, position, verticalStickToBottomPosition);
    }
    var horizontalPosition = calculateHorizontalPlacement({
        placement: horizontalPlacement,
        targetLeft: targetLeft,
        targetRight: targetRight,
        targetWidth: targetWidth,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentLeft: popupOffsetParentLeft,
        popupOffsetParentRight: popupOffsetParentRight,
        popupOffsetParentScrollLeft: popupOffsetParent.scrollLeft || 0,
        popupClientWidth: popup.clientWidth || 0,
        offset: offset,
    });
    position = Object.assign({}, position, horizontalPosition);
    return position;
}
/**
 * Traverse DOM Tree upwards looking for popup parents with "overflow: scroll".
 */
function findOverflowScrollParent(popup) {
    var parent = popup;
    if (!parent) {
        return false;
    }
    while ((parent = parent.parentElement)) {
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        var style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' ||
            style.overflowX === 'scroll' ||
            style.overflowY === 'scroll' ||
            parent.classList.contains('fabric-editor-popup-scroll-parent')) {
            return parent;
        }
    }
    return false;
}
//# sourceMappingURL=utils.js.map

/***/ }),
/* 2959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__ = __webpack_require__(3);





// tslint:disable-next-line:variable-name
var BlockNode = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  align-items: center;\n  background: ", ";\n  border: 1px dashed ", ";\n  border-radius: ", "px;\n  box-sizing: border-box;\n  cursor: default;\n  display: block;\n  font-size: 13px;\n  margin: 10px 0;\n  min-height: 24px;\n  padding: 10px;\n  text-align: center;\n  user-select: all;\n  vertical-align: text-bottom;\n  white-space: nowrap;\n\n  '&.ProseMirror-selectednode' {\n    background: ", ";\n    outline: none;\n  }\n"], ["\n  align-items: center;\n  background: ", ";\n  border: 1px dashed ", ";\n  border-radius: ", "px;\n  box-sizing: border-box;\n  cursor: default;\n  display: block;\n  font-size: 13px;\n  margin: 10px 0;\n  min-height: 24px;\n  padding: 10px;\n  text-align: center;\n  user-select: all;\n  vertical-align: text-bottom;\n  white-space: nowrap;\n\n  '&.ProseMirror-selectednode' {\n    background: ", ";\n    outline: none;\n  }\n"])), __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N30, __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N50, Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["borderRadius"])(), __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N50);
var UnsupportedBlockNode = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](UnsupportedBlockNode, _super);
    function UnsupportedBlockNode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UnsupportedBlockNode.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](BlockNode, null, "Unsupported content");
    };
    return UnsupportedBlockNode;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* unused harmony default export */ var _unused_webpack_default_export = (UnsupportedBlockNode);
var templateObject_1;
//# sourceMappingURL=index.js.map

/***/ }),
/* 2960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapBreakpointToLayoutMaxWidth;
/* unused harmony export BaseTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WidthProvider__ = __webpack_require__(916);




function mapBreakpointToFontSize(breakpoint) {
    switch (breakpoint) {
        case __WEBPACK_IMPORTED_MODULE_3__WidthProvider__["a" /* Breakpoints */].M:
            return Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["fontSize"])() + 2;
        case __WEBPACK_IMPORTED_MODULE_3__WidthProvider__["a" /* Breakpoints */].L:
            return Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["fontSize"])() + 4;
        default:
            return Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["fontSize"])();
    }
}
function mapBreakpointToLayoutMaxWidth(breakpoint) {
    switch (breakpoint) {
        case __WEBPACK_IMPORTED_MODULE_3__WidthProvider__["a" /* Breakpoints */].M:
            return 760;
        case __WEBPACK_IMPORTED_MODULE_3__WidthProvider__["a" /* Breakpoints */].L:
            return 850;
        default:
            return 680;
    }
}
function BaseTheme(_a) {
    var children = _a.children, dynamicTextSizing = _a.dynamicTextSizing;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__WidthProvider__["b" /* WidthConsumer */], null, function (_a) {
        var breakpoint = _a.breakpoint;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_styled_components__["ThemeProvider"], { theme: {
                baseFontSize: dynamicTextSizing
                    ? mapBreakpointToFontSize(breakpoint)
                    : mapBreakpointToFontSize(__WEBPACK_IMPORTED_MODULE_3__WidthProvider__["a" /* Breakpoints */].S),
                layoutMaxWidth: dynamicTextSizing
                    ? mapBreakpointToLayoutMaxWidth(breakpoint)
                    : mapBreakpointToLayoutMaxWidth(__WEBPACK_IMPORTED_MODULE_3__WidthProvider__["a" /* Breakpoints */].S),
            } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, children)));
    }));
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 2961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ADFTraversor = /** @class */ (function () {
    function ADFTraversor(doc) {
        this.subscribers = new Map();
        this.doc = doc;
    }
    ADFTraversor.prototype.subscribe = function (type, callback) {
        var callbacks = this.subscribers.get(type);
        if (!callbacks) {
            this.subscribers.set(type, [callback]);
        }
        else {
            callbacks.push(callback);
        }
    };
    ADFTraversor.prototype.exec = function () {
        if (!this.doc || !Array.isArray(this.doc.content)) {
            return;
        }
        var candidates = this.doc.content.slice(0);
        while (candidates.length) {
            var node = candidates.shift();
            if (Array.isArray(node.content)) {
                candidates = candidates.concat(node.content);
            }
            var callbacks = this.subscribers.get(node.type);
            if (!callbacks) {
                continue;
            }
            for (var i = 0; i < callbacks.length; i++) {
                callbacks[i](node);
            }
        }
    };
    return ADFTraversor;
}());
/* unused harmony default export */ var _unused_webpack_default_export = (ADFTraversor);
//# sourceMappingURL=traversor.js.map

/***/ }),
/* 2962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noformatMacro;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_macro__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_attrs__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_title__ = __webpack_require__(473);



function noformatMacro(input, position, schema, tokenErrCallback) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__common_macro__["a" /* commonMacro */])(input.substring(position), schema, {
        keyword: 'noformat',
        paired: true,
        rawContentProcessor: rawContentProcessor,
        tokenErrCallback: tokenErrCallback,
    });
}
var rawContentProcessor = function (rawAttrs, rawContent, length, schema, tokenErrCallback) {
    var output = [];
    var codeBlock = schema.nodes.codeBlock;
    var parsedAttrs = Object(__WEBPACK_IMPORTED_MODULE_1__utils_attrs__["a" /* parseAttrs */])(rawAttrs);
    var trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
    var textNode = trimedContent.length
        ? schema.text(trimedContent)
        : undefined;
    if (parsedAttrs.title) {
        output.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils_title__["a" /* title */])(parsedAttrs.title, schema));
    }
    output.push(codeBlock.createChecked({ language: 'java' }, textNode));
    return {
        type: 'pmnode',
        nodes: output,
        length: length,
    };
};
//# sourceMappingURL=noformat-macro.js.map

/***/ }),
/* 2963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = forceLineBreak;
/**
 * Jira is using the following regex to match force line break
 * private static final Pattern FORCE_NEWLINE = Pattern.compile("(?<!\\\\)\\\\{2}(?!\\S*\\\\)");
 */
var FORCE_LINE_BREAK_REGEX = /^\\{2}(?!\S*\\)/;
function forceLineBreak(input, position, schema) {
    if (position > 0) {
        var charBefore = input.charAt(position - 1);
        if (charBefore === '\\') {
            return fallback(input, position);
        }
    }
    var match = input.substring(position).match(FORCE_LINE_BREAK_REGEX);
    if (match) {
        return {
            type: 'pmnode',
            nodes: [schema.nodes.hardBreak.createChecked()],
            length: 2,
        };
    }
    return fallback(input, position);
}
function fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 2),
        length: 2,
    };
}
//# sourceMappingURL=force-line-break.js.map

/***/ }),
/* 2964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nodes__ = __webpack_require__(2966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__marks__ = __webpack_require__(3108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_editor_common__ = __webpack_require__(80);








var mergeMarks = function (marks) {
    return marks.reduce(function (acc, cur) {
        var prev = acc.length && acc[acc.length - 1];
        if (prev && Object(__WEBPACK_IMPORTED_MODULE_6__atlaskit_editor_common__["G" /* isSameMark */])(prev, cur)) {
            prev.content = mergeMarks(prev.content.concat(cur.content));
        }
        else {
            acc.push(cur);
        }
        return acc;
    }, []);
};
var ReactSerializer = /** @class */ (function () {
    function ReactSerializer(_a) {
        var providers = _a.providers, eventHandlers = _a.eventHandlers, extensionHandlers = _a.extensionHandlers, portal = _a.portal, objectContext = _a.objectContext, appearance = _a.appearance, disableHeadingIDs = _a.disableHeadingIDs, allowDynamicTextSizing = _a.allowDynamicTextSizing;
        this.headingIds = [];
        this.providers = providers;
        this.eventHandlers = eventHandlers;
        this.extensionHandlers = extensionHandlers;
        this.portal = portal;
        this.rendererContext = objectContext;
        this.appearance = appearance;
        this.disableHeadingIDs = disableHeadingIDs;
        this.allowDynamicTextSizing = allowDynamicTextSizing;
    }
    ReactSerializer.prototype.resetState = function () {
        this.headingIds = [];
    };
    ReactSerializer.prototype.serializeFragment = function (fragment, props, target, key, parentInfo) {
        var _this = this;
        if (props === void 0) { props = {}; }
        if (target === void 0) { target = __WEBPACK_IMPORTED_MODULE_3__nodes__["a" /* Doc */]; }
        if (key === void 0) { key = 'root-0'; }
        // This makes sure that we reset internal state on re-render.
        if (key === 'root-0') {
            this.resetState();
        }
        var emojiBlock = Object(__WEBPACK_IMPORTED_MODULE_3__nodes__["b" /* isEmojiDoc */])(fragment, props);
        var content = ReactSerializer.getChildNodes(fragment).map(function (node, index) {
            if (Object(__WEBPACK_IMPORTED_MODULE_3__nodes__["c" /* isTextWrapper */])(node)) {
                return _this.serializeTextWrapper(node.content);
            }
            var props;
            if (emojiBlock && _this.appearance === 'message') {
                props = _this.getEmojiBlockProps(node);
            }
            else if (node.type.name === 'table') {
                props = _this.getTableProps(node);
            }
            else if (node.type.name === 'date') {
                props = _this.getDateProps(node, parentInfo);
            }
            else if (node.type.name === 'heading') {
                props = _this.getHeadingProps(node);
            }
            else {
                props = _this.getProps(node);
            }
            var pInfo = parentInfo;
            if (node.type.name === 'taskItem' && node.attrs.state !== 'DONE') {
                pInfo = { parentIsIncompleteTask: true };
            }
            var serializedContent = _this.serializeFragment(node.content, props, Object(__WEBPACK_IMPORTED_MODULE_3__nodes__["e" /* toReact */])(node), node.type.name + "-" + index, pInfo);
            if (node.marks && node.marks.length) {
                return []
                    .concat(node.marks)
                    .reverse()
                    .reduce(function (acc, mark) {
                    return _this.renderMark(Object(__WEBPACK_IMPORTED_MODULE_4__marks__["a" /* toReact */])(mark), _this.getMarkProps(mark), mark.type.name + "-" + index, acc);
                }, serializedContent);
            }
            return serializedContent;
        });
        return this.renderNode(target, props, key, content);
    };
    ReactSerializer.prototype.serializeTextWrapper = function (content) {
        var _this = this;
        return ReactSerializer.buildMarkStructure(content).map(function (mark, index) {
            return _this.serializeMark(mark, index);
        });
    };
    ReactSerializer.prototype.serializeMark = function (mark, index) {
        var _this = this;
        if (index === void 0) { index = 0; }
        if (mark.type.name === 'text') {
            return mark.text;
        }
        var content = (mark.content || []).map(function (child, index) {
            return _this.serializeMark(child, index);
        });
        return this.renderMark(Object(__WEBPACK_IMPORTED_MODULE_4__marks__["a" /* toReact */])(mark), this.getMarkProps(mark), mark.type.name + "-" + index, content);
    };
    ReactSerializer.prototype.renderNode = function (NodeComponent, props, key, content) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](NodeComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ key: key }, props), content));
    };
    ReactSerializer.prototype.renderMark = function (MarkComponent, props, key, content) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MarkComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ key: key }, props), content));
    };
    ReactSerializer.prototype.getEmojiBlockProps = function (node) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, this.getProps(node), { fitToHeight: __WEBPACK_IMPORTED_MODULE_2__utils__["b" /* bigEmojiHeight */] });
    };
    ReactSerializer.prototype.getTableProps = function (node) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, this.getProps(node), { columnWidths: Object(__WEBPACK_IMPORTED_MODULE_5__atlaskit_adf_schema__["k" /* calcTableColumnWidths */])(node) });
    };
    ReactSerializer.prototype.getDateProps = function (node, parentInfo) {
        return {
            timestamp: node.attrs && node.attrs.timestamp,
            parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
        };
    };
    ReactSerializer.prototype.getProps = function (node) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ text: node.text, providers: this.providers, eventHandlers: this.eventHandlers, extensionHandlers: this.extensionHandlers, portal: this.portal, rendererContext: this.rendererContext, serializer: this, content: node.content ? node.content.toJSON() : undefined, allowDynamicTextSizing: this.allowDynamicTextSizing, rendererAppearance: this.appearance }, node.attrs);
    };
    ReactSerializer.prototype.getHeadingProps = function (node) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, node.attrs, { content: node.content ? node.content.toJSON() : undefined, headingId: this.getHeadingId(node) });
    };
    ReactSerializer.prototype.getHeadingId = function (node) {
        if (this.disableHeadingIDs || !node.content.size) {
            return;
        }
        var headingId = node.content
            .toJSON()
            .reduce(function (acc, node) { return acc.concat(Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getText */])(node) || ''); }, '')
            .replace(/ /g, '-');
        return this.getUniqueHeadingId(headingId);
    };
    ReactSerializer.prototype.getUniqueHeadingId = function (baseId, counter) {
        if (counter === void 0) { counter = 0; }
        if (counter === 0 && this.headingIds.indexOf(baseId) === -1) {
            this.headingIds.push(baseId);
            return baseId;
        }
        else if (counter !== 0) {
            var headingId = baseId + "." + counter;
            if (this.headingIds.indexOf(headingId) === -1) {
                this.headingIds.push(headingId);
                return headingId;
            }
        }
        return this.getUniqueHeadingId(baseId, ++counter);
    };
    ReactSerializer.prototype.getMarkProps = function (mark) {
        var _a = mark.attrs, key = _a.key, otherAttrs = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["key"]);
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ eventHandlers: this.eventHandlers, markKey: key }, otherAttrs);
    };
    ReactSerializer.getChildNodes = function (fragment) {
        var children = [];
        fragment.forEach(function (node) {
            children.push(node);
        });
        return Object(__WEBPACK_IMPORTED_MODULE_3__nodes__["d" /* mergeTextNodes */])(children);
    };
    ReactSerializer.getMarks = function (node) {
        if (!node.marks || node.marks.length === 0) {
            return [];
        }
        return Object(__WEBPACK_IMPORTED_MODULE_6__atlaskit_editor_common__["y" /* getMarksByOrder */])(node.marks);
    };
    ReactSerializer.buildMarkStructure = function (content) {
        var _this = this;
        return mergeMarks(content.map(function (node) {
            var nodeMarks = _this.getMarks(node);
            if (nodeMarks.length === 0) {
                return node;
            }
            return nodeMarks.reverse().reduce(function (acc, mark) {
                var eq = mark.eq;
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, mark, { eq: eq, content: [acc] });
            }, node);
        }));
    };
    ReactSerializer.fromSchema = function (schema, _a) {
        var providers = _a.providers, eventHandlers = _a.eventHandlers, extensionHandlers = _a.extensionHandlers, appearance = _a.appearance, disableHeadingIDs = _a.disableHeadingIDs, allowDynamicTextSizing = _a.allowDynamicTextSizing;
        // TODO: Do we actually need the schema here?
        return new ReactSerializer({
            providers: providers,
            eventHandlers: eventHandlers,
            extensionHandlers: extensionHandlers,
            appearance: appearance,
            disableHeadingIDs: disableHeadingIDs,
            allowDynamicTextSizing: allowDynamicTextSizing,
        });
    };
    return ReactSerializer;
}());
/* harmony default export */ __webpack_exports__["a"] = (ReactSerializer);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JSONTransformer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__ = __webpack_require__(19);


var isType = function (type) { return function (node) {
    return node.type.name === type;
}; };
var isCodeBlock = isType('codeBlock');
var isMediaNode = isType('media');
var isMediaSingleNode = isType('mediaSingle');
var isMentionNode = isType('mention');
var isParagraph = isType('paragraph');
var isHeading = isType('heading');
var isTable = isType('table');
var isTableCell = isType('tableCell');
var isTableHeader = isType('tableHeader');
var isLinkMark = isType('link');
var isUnsupportedNode = function (node) {
    return isType('unsupportedBlock')(node) || isType('unsupportedInline')(node);
};
var filterNull = function (subject) {
    return Object.keys(subject).reduce(function (acc, key) {
        var _a;
        var current = subject[key];
        if (current === null) {
            return acc;
        }
        if (typeof current === 'object' && !Array.isArray(current)) {
            current = filterNull(current);
        }
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, acc, (_a = {}, _a[key] = current, _a));
    }, {});
};
var toJSON = function (node) {
    var obj = { type: node.type.name };
    if (isUnsupportedNode(node)) {
        return node.attrs.originalValue;
    }
    else if (isMediaNode(node)) {
        obj.attrs = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["V" /* mediaToJSON */])(node).attrs;
    }
    else if (isMediaSingleNode(node)) {
        obj.attrs = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["U" /* mediaSingleToJSON */])(node).attrs;
    }
    else if (isMentionNode(node)) {
        obj.attrs = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["X" /* mentionToJSON */])(node).attrs;
    }
    else if (isCodeBlock(node)) {
        obj.attrs = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["n" /* codeBlockToJSON */])(node).attrs;
    }
    else if (isTable(node)) {
        obj.attrs = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["_15" /* tableToJSON */])(node).attrs;
    }
    else if (isTableCell(node)) {
        obj.attrs = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["_20" /* toJSONTableCell */])(node).attrs;
    }
    else if (isTableHeader(node)) {
        obj.attrs = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["_21" /* toJSONTableHeader */])(node).attrs;
    }
    else if (Object.keys(node.attrs).length) {
        obj.attrs = node.attrs;
    }
    if (obj.attrs) {
        obj.attrs = filterNull(obj.attrs);
    }
    if (node.isText) {
        obj.text = node.textContent;
    }
    else {
        node.content.forEach(function (child) {
            obj.content = obj.content || [];
            obj.content.push(toJSON(child));
        });
    }
    if (isParagraph(node) || isHeading(node)) {
        obj.content = obj.content || [];
    }
    if (node.marks.length) {
        obj.marks = node.marks.map(function (n) {
            if (isLinkMark(n)) {
                return Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["P" /* linkToJSON */])(n);
            }
            return n.toJSON();
        });
    }
    return obj;
};
var JSONTransformer = /** @class */ (function () {
    function JSONTransformer() {
    }
    JSONTransformer.prototype.encode = function (node) {
        var content = [];
        node.content.forEach(function (child) {
            content.push(toJSON(child));
        });
        return {
            version: 1,
            type: 'doc',
            content: content,
        };
    };
    JSONTransformer.prototype.parse = function (content) {
        if (content.type !== 'doc') {
            throw new Error('Expected content format to be ADF');
        }
        var doc = __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["x" /* defaultSchema */].nodeFromJSON(content);
        doc.check();
        return doc;
    };
    return JSONTransformer;
}());

//# sourceMappingURL=index.js.map

/***/ }),
/* 2966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export nodeToReact */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return toReact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mergeTextNodes; });
/* unused harmony export isText */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isTextWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isEmojiDoc; });
/* unused harmony export BlockCard */
/* unused harmony export Date */
/* unused harmony export DecisionItem */
/* unused harmony export Emoji */
/* unused harmony export InlineCard */
/* unused harmony export Media */
/* unused harmony export MediaGroup */
/* unused harmony export Mention */
/* unused harmony export Status */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__blockquote__ = __webpack_require__(2967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bodiedExtension__ = __webpack_require__(2968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bulletList__ = __webpack_require__(3032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__codeBlock__ = __webpack_require__(3033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__decisionList__ = __webpack_require__(3080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__doc__ = __webpack_require__(3081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__extension__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hardBreak__ = __webpack_require__(3082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__heading__ = __webpack_require__(3083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__image__ = __webpack_require__(3084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__inlineExtension__ = __webpack_require__(3085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__layoutSection__ = __webpack_require__(3086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__layoutColumn__ = __webpack_require__(3087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__listItem__ = __webpack_require__(3088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mediaSingle__ = __webpack_require__(3089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__orderedList__ = __webpack_require__(3090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__panel__ = __webpack_require__(3091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__paragraph__ = __webpack_require__(3098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__placeholder__ = __webpack_require__(3099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__rule__ = __webpack_require__(3100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__taskItem__ = __webpack_require__(3101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__taskList__ = __webpack_require__(3103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__table__ = __webpack_require__(3104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__tableCell__ = __webpack_require__(3105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__tableHeader__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__tableRow__ = __webpack_require__(3106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__unknownBlock__ = __webpack_require__(3107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_loadable__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_react_loadable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils__ = __webpack_require__(144);
/* unused harmony reexport Blockquote */
/* unused harmony reexport BodiedExtension */
/* unused harmony reexport BulletList */
/* unused harmony reexport CodeBlock */
/* unused harmony reexport DecisionList */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__doc__["a"]; });
/* unused harmony reexport Extension */
/* unused harmony reexport HardBreak */
/* unused harmony reexport Heading */
/* unused harmony reexport ListItem */
/* unused harmony reexport Image */
/* unused harmony reexport InlineExtension */
/* unused harmony reexport LayoutSection */
/* unused harmony reexport LayoutColumn */
/* unused harmony reexport MediaSingle */
/* unused harmony reexport OrderedList */
/* unused harmony reexport Panel */
/* unused harmony reexport Paragraph */
/* unused harmony reexport Placeholder */
/* unused harmony reexport Rule */
/* unused harmony reexport TaskItem */
/* unused harmony reexport TaskList */
/* unused harmony reexport Table */
/* unused harmony reexport TableCell */
/* unused harmony reexport TableHeader */
/* unused harmony reexport TableRow */
/* unused harmony reexport UnknownBlock */




























var DecisionItem = __WEBPACK_IMPORTED_MODULE_27_react_loadable__({
    loader: function () {
        return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 3479)).then(function (module) { return module.default; });
    },
    loading: function () { return null; },
});
var Date = __WEBPACK_IMPORTED_MODULE_27_react_loadable__({
    loader: function () {
        return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 3480)).then(function (module) { return module.default; });
    },
    loading: function () { return null; },
});
var Status = __WEBPACK_IMPORTED_MODULE_27_react_loadable__({
    loader: function () {
        return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 3481)).then(function (module) { return module.default; });
    },
    loading: function () { return null; },
});
var Emoji = __WEBPACK_IMPORTED_MODULE_27_react_loadable__({
    loader: function () {
        return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 3482)).then(function (module) { return module.default; });
    },
    loading: function () { return null; },
});
var InlineCard = __WEBPACK_IMPORTED_MODULE_27_react_loadable__({
    loader: function () {
        return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 3483)).then(function (module) { return module.default; });
    },
    loading: function () { return null; },
});
var BlockCard = __WEBPACK_IMPORTED_MODULE_27_react_loadable__({
    loader: function () {
        return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 3484)).then(function (module) { return module.default; });
    },
    loading: function () { return null; },
});
var Media = __WEBPACK_IMPORTED_MODULE_27_react_loadable__({
    loader: function () {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 3485)).then(function (module) { return module.default; });
    },
    loading: function () { return null; },
});
var MediaGroup = __WEBPACK_IMPORTED_MODULE_27_react_loadable__({
    loader: function () {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 3486)).then(function (module) { return module.default; });
    },
    loading: function () { return null; },
});
var Mention = __WEBPACK_IMPORTED_MODULE_27_react_loadable__({
    loader: function () {
        return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 3487)).then(function (module) { return module.default; });
    },
    loading: function () { return null; },
});

var nodeToReact = {
    blockquote: __WEBPACK_IMPORTED_MODULE_0__blockquote__["a" /* default */],
    bulletList: __WEBPACK_IMPORTED_MODULE_2__bulletList__["a" /* default */],
    blockCard: BlockCard,
    codeBlock: __WEBPACK_IMPORTED_MODULE_3__codeBlock__["a" /* default */],
    date: Date,
    decisionItem: DecisionItem,
    decisionList: __WEBPACK_IMPORTED_MODULE_4__decisionList__["a" /* default */],
    doc: __WEBPACK_IMPORTED_MODULE_5__doc__["a" /* default */],
    emoji: Emoji,
    extension: __WEBPACK_IMPORTED_MODULE_6__extension__["a" /* default */],
    bodiedExtension: __WEBPACK_IMPORTED_MODULE_1__bodiedExtension__["a" /* default */],
    hardBreak: __WEBPACK_IMPORTED_MODULE_7__hardBreak__["a" /* default */],
    heading: __WEBPACK_IMPORTED_MODULE_8__heading__["a" /* default */],
    image: __WEBPACK_IMPORTED_MODULE_9__image__["a" /* default */],
    inlineCard: InlineCard,
    inlineExtension: __WEBPACK_IMPORTED_MODULE_10__inlineExtension__["a" /* default */],
    layoutSection: __WEBPACK_IMPORTED_MODULE_11__layoutSection__["a" /* default */],
    layoutColumn: __WEBPACK_IMPORTED_MODULE_12__layoutColumn__["a" /* default */],
    listItem: __WEBPACK_IMPORTED_MODULE_13__listItem__["a" /* default */],
    media: Media,
    mediaGroup: MediaGroup,
    mediaSingle: __WEBPACK_IMPORTED_MODULE_14__mediaSingle__["a" /* default */],
    mention: Mention,
    orderedList: __WEBPACK_IMPORTED_MODULE_15__orderedList__["a" /* default */],
    panel: __WEBPACK_IMPORTED_MODULE_16__panel__["a" /* default */],
    paragraph: __WEBPACK_IMPORTED_MODULE_17__paragraph__["a" /* default */],
    placeholder: __WEBPACK_IMPORTED_MODULE_18__placeholder__["a" /* default */],
    rule: __WEBPACK_IMPORTED_MODULE_19__rule__["a" /* default */],
    status: Status,
    taskItem: __WEBPACK_IMPORTED_MODULE_20__taskItem__["a" /* default */],
    taskList: __WEBPACK_IMPORTED_MODULE_21__taskList__["a" /* default */],
    table: __WEBPACK_IMPORTED_MODULE_22__table__["a" /* default */],
    tableCell: __WEBPACK_IMPORTED_MODULE_23__tableCell__["a" /* default */],
    tableHeader: __WEBPACK_IMPORTED_MODULE_24__tableHeader__["a" /* default */],
    tableRow: __WEBPACK_IMPORTED_MODULE_25__tableRow__["a" /* default */],
    unknownBlock: __WEBPACK_IMPORTED_MODULE_26__unknownBlock__["a" /* default */],
};
var toReact = function (node) {
    return nodeToReact[node.type.name];
};
/*
 *  Wraps adjacent textnodes in a textWrapper
 *
 *  Input:
 *  [
 *    {
 *      type: 'text',
 *      text: 'Hello'
 *    },
 *    {
 *      type: 'text',
 *      text: 'World!',
 *      marks: [
 *        {
 *          type: 'strong'
 *        }
 *      ]
 *    }
 *  ]
 *
 *  Output:
 *  [
 *    {
 *      type: 'textWrapper',
 *      content: [
 *        {
 *          type: 'text',
 *          text: 'Hello'
 *        },
 *        {
 *          type: 'text',
 *          text: 'World!',
 *          marks: [
 *            {
 *              type: 'strong'
 *            }
 *          ]
 *        }
 *      ]
 *    }
 *  ]
 */
var mergeTextNodes = function (nodes) {
    return nodes.reduce(function (acc, current) {
        if (!isText(current.type.name)) {
            acc.push(current);
            return acc;
        }
        // Append node to previous node, if it was a text wrapper
        if (acc.length > 0 && isTextWrapper(acc[acc.length - 1])) {
            acc[acc.length - 1].content.push(current);
        }
        else {
            acc.push({
                type: {
                    name: 'textWrapper',
                },
                content: [current],
            });
        }
        return acc;
    }, []);
};
var isText = function (type) {
    return type === 'text';
};
var isTextWrapper = function (node) {
    return node.type.name === 'textWrapper';
};
var whitespaceRegex = /^\s*$/;
/**
 * Detects whether a fragment contains a single paragraph node
 * whose content satisfies the condition for an emoji block
 */
var isEmojiDoc = function (doc, props) {
    if (props === void 0) { props = {}; }
    // Previously calculated to be true so pass prop down
    // from paragraph node to emoji node
    if (props.fitToHeight === __WEBPACK_IMPORTED_MODULE_28__utils__["b" /* bigEmojiHeight */]) {
        return true;
    }
    if (doc.childCount !== 1) {
        return false;
    }
    var parentNodes = [];
    doc.forEach(function (child) { return parentNodes.push(child); });
    var node = parentNodes[0];
    return node.type.name === 'paragraph' && isEmojiBlock(node.content);
};
var isEmojiBlock = function (pnode) {
    var content = [];
    // Optimisation for long documents - worst case block will be space-emoji-space
    if (pnode.childCount > 7) {
        return false;
    }
    pnode.forEach(function (child) { return content.push(child); });
    var emojiCount = 0;
    for (var i = 0; i < content.length; ++i) {
        var node = content[i];
        switch (node.type.name) {
            case 'text':
                if (node.text && !node.text.match(whitespaceRegex)) {
                    return false;
                }
                continue;
            case 'emoji':
                if (++emojiCount > 3) {
                    return false;
                }
                continue;
            default:
                // Only text and emoji nodes are allowed
                return false;
        }
    }
    return emojiCount > 0;
};

//# sourceMappingURL=index.js.map

/***/ }),
/* 2967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Blockquote;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function Blockquote(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("blockquote", null, props.children);
}
//# sourceMappingURL=blockquote.js.map

/***/ }),
/* 2968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extension__ = __webpack_require__(917);



var BodiedExtension = function (_a) {
    var serializer = _a.serializer, extensionHandlers = _a.extensionHandlers, rendererContext = _a.rendererContext, extensionType = _a.extensionType, extensionKey = _a.extensionKey, content = _a.content, parameters = _a.parameters, children = _a.children, _b = _a.layout, layout = _b === void 0 ? 'default' : _b;
    try {
        if (extensionHandlers && extensionHandlers[extensionType]) {
            var extensionContent = extensionHandlers[extensionType]({
                type: 'bodiedExtension',
                extensionKey: extensionKey,
                extensionType: extensionType,
                parameters: parameters,
                content: content,
            }, rendererContext.adDoc);
            switch (true) {
                case extensionContent && __WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"](extensionContent):
                    // Return the extensionContent directly if it's a valid JSX.Element
                    return Object(__WEBPACK_IMPORTED_MODULE_2__extension__["b" /* renderExtension */])(extensionContent, layout);
                case !!extensionContent:
                    // We expect it to be Atlassian Document here
                    var nodes = Array.isArray(extensionContent)
                        ? extensionContent
                        : [extensionContent];
                    return Object(__WEBPACK_IMPORTED_MODULE_1____["e" /* renderNodes */])(nodes, serializer, rendererContext.schema, 'div');
            }
        }
    }
    catch (e) {
        /** We don't want this error to block renderer */
        /** We keep rendering the default content */
    }
    // Always return default content if anything goes wrong
    return Object(__WEBPACK_IMPORTED_MODULE_2__extension__["b" /* renderExtension */])(children, layout);
};
/* harmony default export */ __webpack_exports__["a"] = (BodiedExtension);
//# sourceMappingURL=bodiedExtension.js.map

/***/ }),
/* 2969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export normalizeHexColor */
/* unused harmony export hexToRgb */
/* harmony export (immutable) */ __webpack_exports__["a"] = hexToRgba;
/* unused harmony export rgbToHex */
/* unused harmony export isRgb */
/* unused harmony export isHex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_css_color_names__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_css_color_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_css_color_names__);


/**
 * @return String with HEX-coded color
 */
function normalizeHexColor(color, defaultColor) {
    if (!color) {
        return null;
    }
    // Normalize to hex
    color = color.trim().toLowerCase();
    if (isHex(color)) {
        // Normalize 3-hex to 6-hex colours
        if (color.length === 4) {
            color = color
                .split('')
                .map(function (c) { return (c === '#' ? '#' : "" + c + c); })
                .join('');
        }
    }
    else if (isRgb(color)) {
        return rgbToHex(color);
    }
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (__WEBPACK_IMPORTED_MODULE_1_css_color_names__["default"] && __WEBPACK_IMPORTED_MODULE_1_css_color_names__["default"][color]) {
            color = __WEBPACK_IMPORTED_MODULE_1_css_color_names__["default"][color];
        }
        else if (__WEBPACK_IMPORTED_MODULE_1_css_color_names__ && __WEBPACK_IMPORTED_MODULE_1_css_color_names__[color]) {
            color = __WEBPACK_IMPORTED_MODULE_1_css_color_names__[color];
        }
        else {
            return null;
        }
    }
    if (color === defaultColor) {
        return null;
    }
    return color;
}
/**
 * Converts hex color format to rgb.
 * Works well with full hex color format and shortcut as well.
 *
 * @param hex - hex color string (#xxx, or #xxxxxx)
 */
function hexToRgb(color) {
    if (!isHex(color)) {
        return null;
    }
    var colorBits = color.substring(1).split('');
    if (colorBits.length === 3) {
        colorBits = [
            colorBits[0],
            colorBits[0],
            colorBits[1],
            colorBits[1],
            colorBits[2],
            colorBits[2],
        ];
    }
    var rgb = Number("0x" + colorBits.join(''));
    // tslint:disable-next-line:no-bitwise
    return "rgb(" + ((rgb >> 16) & 255) + "," + ((rgb >> 8) & 255) + "," + (rgb & 255) + ")";
}
/**
 * Converts hex color format to rgba.
 *
 * @param hex - hex color string (#xxx, or #xxxxxx)
 */
function hexToRgba(rawColor, alpha) {
    var color = normalizeHexColor(rawColor);
    if (!color) {
        return null;
    }
    var hex2rgb = function (color) {
        return color.match(/[a-z0-9]{2}/gi).map(function (hex) { return parseInt(hex, 16); });
    };
    return "rgba(" + hex2rgb(color)
        .concat(alpha)
        .join(',') + ")";
}
function rgbToHex(value) {
    var matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](matches.map(Number), 3), red = _a[0], green = _a[1], blue = _a[2];
        return ('#' +
            (blue | (green << 8) | (red << 16) | (1 << 24)).toString(16).slice(1) // tslint:disable-line:no-bitwise
        );
    }
    return null;
}
function isRgb(color) {
    return /rgba?\(/.test(color);
}
function isHex(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}
//# sourceMappingURL=color.js.map

/***/ }),
/* 2970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getExtensionLozengeData */
var getExtensionLozengeData = function (_a) {
    var node = _a.node, type = _a.type;
    if (!node.attrs.parameters) {
        return;
    }
    var macroMetadata = node.attrs.parameters.macroMetadata;
    if (macroMetadata && macroMetadata.placeholder) {
        var placeholderData_1;
        macroMetadata.placeholder.forEach(function (placeholder) {
            if (placeholder.type === type &&
                placeholder.data &&
                placeholder.data.url) {
                placeholderData_1 = placeholder.data;
            }
        });
        return placeholderData_1;
    }
};
//# sourceMappingURL=macro.js.map

/***/ }),
/* 2971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export markOrder */
/* unused harmony export isSubSupType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMarksByOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isSameMark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getValidDocument; });
/* unused harmony export getValidContent */
/* unused harmony export getValidUnknownNode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getValidNode; });
/* unused harmony export getValidMark */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__ = __webpack_require__(19);


/*
 * It's important that this order follows the marks rank defined here:
 * https://product-fabric.atlassian.net/wiki/spaces/E/pages/11174043/Document+structure#Documentstructure-Rank
 */
var markOrder = [
    'link',
    'em',
    'strong',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'textColor',
];
var isSubSupType = function (type) {
    return type === 'sub' || type === 'sup';
};
/*
 * Sorts mark by the predefined order above
 */
var getMarksByOrder = function (marks) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](marks).sort(function (a, b) { return markOrder.indexOf(a.type.name) - markOrder.indexOf(b.type.name); });
};
/*
 * Check if two marks are the same by comparing type and attrs
 */
var isSameMark = function (mark, otherMark) {
    if (!mark || !otherMark) {
        return false;
    }
    return mark.eq(otherMark);
};
var getValidDocument = function (doc, schema, adfStage) {
    if (schema === void 0) { schema = __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["x" /* defaultSchema */]; }
    if (adfStage === void 0) { adfStage = 'final'; }
    var node = getValidNode(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
var wrapInlineNodes = function (nodes) {
    if (nodes === void 0) { nodes = []; }
    return nodes.map(function (node) {
        return __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["K" /* inlineNodes */].has(node.type) ? { type: 'paragraph', content: [node] } : node;
    });
};
var getValidContent = function (content, schema, adfStage) {
    if (schema === void 0) { schema = __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["x" /* defaultSchema */]; }
    if (adfStage === void 0) { adfStage = 'final'; }
    return content.map(function (node) { return getValidNode(node, schema, adfStage); });
};
var TEXT_COLOR_PATTERN = /^#[0-9a-f]{6}$/i;
var RELATIVE_LINK = /^\//;
var flattenUnknownBlockTree = function (node, schema, adfStage) {
    if (schema === void 0) { schema = __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["x" /* defaultSchema */]; }
    if (adfStage === void 0) { adfStage = 'final'; }
    var output = [];
    var isPrevLeafNode = false;
    for (var i = 0; i < node.content.length; i++) {
        var childNode = node.content[i];
        var isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) {
                output.push({ type: 'text', text: ' ' });
            }
            else {
                output.push({ type: 'hardBreak' });
            }
        }
        if (isLeafNode) {
            output.push(getValidNode(childNode, schema, adfStage));
        }
        else {
            output.push.apply(output, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](flattenUnknownBlockTree(childNode, schema, adfStage)));
        }
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
// null is Object, also maybe check obj.constructor == Object if we want to skip Class
var isValidObject = function (obj) { return obj !== null && typeof obj === 'object'; };
var isValidString = function (str) { return typeof str === 'string'; };
var keysLen = function (obj) { return Object.keys(obj).length; };
var isValidIcon = function (icon) {
    return isValidObject(icon) &&
        keysLen(icon) === 2 &&
        isValidString(icon.url) &&
        isValidString(icon.label);
};
var isValidUser = function (user) {
    var len = keysLen(user);
    return (isValidObject(user) &&
        len <= 2 &&
        isValidIcon(user.icon) &&
        (len === 1 || isValidString(user.id)));
};
/**
 * Sanitize unknown node tree
 *
 * @see https://product-fabric.atlassian.net/wiki/spaces/E/pages/11174043/Document+structure#Documentstructure-ImplementationdetailsforHCNGwebrenderer
 */
var getValidUnknownNode = function (node) {
    var _a = node.attrs, attrs = _a === void 0 ? {} : _a, content = node.content, text = node.text, type = node.type;
    if (!content || !content.length) {
        var unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || "[" + type + "]",
        };
        var textUrl = attrs.textUrl;
        if (textUrl && Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["L" /* isSafeUrl */])(textUrl)) {
            unknownInlineNode.marks = [
                {
                    type: 'link',
                    attrs: {
                        href: textUrl,
                    },
                },
            ];
        }
        return unknownInlineNode;
    }
    /*
     * Find leaf nodes and join them. If leaf nodes' parent node is the same node
     * join with a blank space, otherwise they are children of different branches, i.e.
     * we need to join them with a hardBreak node
     */
    return {
        type: 'unknownBlock',
        content: flattenUnknownBlockTree(node),
    };
};
/*
 * This method will validate a Node according to the spec defined here
 * https://product-fabric.atlassian.net/wiki/spaces/E/pages/11174043/Document+structure#Documentstructure-Nodes
 *
 * This is also the place to handle backwards compatibility.
 *
 * If a node is not recognized or is missing required attributes, we should return 'unknown'
 *
 */
var getValidNode = function (originalNode, schema, adfStage) {
    if (schema === void 0) { schema = __WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["x" /* defaultSchema */]; }
    if (adfStage === void 0) { adfStage = 'final'; }
    var attrs = originalNode.attrs, marks = originalNode.marks, text = originalNode.text, type = originalNode.type;
    var content = originalNode.content;
    var node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type,
    };
    if (content) {
        node.content = content = getValidContent(content, schema, adfStage);
    }
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) {
        return getValidUnknownNode(node);
    }
    if (type) {
        switch (type) {
            case 'applicationCard': {
                if (!attrs) {
                    break;
                }
                var text_1 = attrs.text, link = attrs.link, background = attrs.background, preview = attrs.preview, title = attrs.title, description = attrs.description, details = attrs.details, actions = attrs.actions, context = attrs.context;
                if (!isValidString(text_1) || !isValidObject(title) || !title.text) {
                    break;
                }
                // title can contain at most two keys (text, user)
                var titleKeys = Object.keys(title);
                if (titleKeys.length > 2) {
                    break;
                }
                if (titleKeys.length === 2 && !title.user) {
                    break;
                }
                if (title.user && !isValidUser(title.user)) {
                    break;
                }
                if ((link && !link.url) ||
                    (background && !background.url) ||
                    (preview && !preview.url) ||
                    (description && !description.text)) {
                    break;
                }
                if (context && !isValidString(context.text)) {
                    break;
                }
                if (context && (context.icon && !isValidIcon(context.icon))) {
                    break;
                }
                if (actions && !Array.isArray(actions)) {
                    break;
                }
                if (actions && !actions.length) {
                    break;
                }
                if (actions &&
                    actions.some(function (meta) {
                        var key = meta.key, title = meta.title, target = meta.target, parameters = meta.parameters;
                        if (key && !isValidString(key)) {
                            return true;
                        }
                        if (!isValidString(title)) {
                            return true;
                        }
                        if (!target) {
                            return true;
                        }
                        if (!isValidString(target.key)) {
                            return true;
                        }
                        if (target.receiver && !isValidString(target.receiver)) {
                            return true;
                        }
                        if (parameters && !isValidObject(parameters)) {
                            return true;
                        }
                    })) {
                    break;
                }
                if (details && !Array.isArray(details)) {
                    break;
                }
                if (details &&
                    details.some(function (meta) {
                        var badge = meta.badge, lozenge = meta.lozenge, users = meta.users;
                        if (badge && typeof badge.value !== 'number') {
                            return true;
                        }
                        if (lozenge && !lozenge.text) {
                            return true;
                        }
                        if (users && !Array.isArray(users)) {
                            return true;
                        }
                        if (users && !users.every(isValidUser)) {
                            return true;
                        }
                    })) {
                    break;
                }
                return {
                    type: type,
                    text: text_1,
                    attrs: attrs,
                };
            }
            case 'doc': {
                var version = originalNode.version;
                if (version && content && content.length) {
                    return {
                        type: type,
                        content: content,
                    };
                }
                break;
            }
            case 'codeBlock': {
                if (content) {
                    content = content.reduce(function (acc, val) {
                        if (val.type === 'text') {
                            acc.push({ type: val.type, text: val.text });
                        }
                        return acc;
                    }, []);
                }
                if (attrs && attrs.language) {
                    return {
                        type: type,
                        attrs: attrs,
                        content: content,
                        marks: marks,
                    };
                }
                return {
                    type: type,
                    content: content,
                    marks: marks,
                };
            }
            case 'date': {
                if (attrs && attrs.timestamp) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'status': {
                if (attrs && attrs.text && attrs.color) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'emoji': {
                if (attrs && attrs.shortName) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'inlineExtension':
            case 'extension': {
                if (attrs && attrs.extensionType && attrs.extensionKey) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'inlineCard':
            case 'blockCard': {
                if (attrs && (attrs.url || attrs.data)) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'bodiedExtension': {
                if (attrs && attrs.extensionType && attrs.extensionKey && content) {
                    return {
                        type: type,
                        attrs: attrs,
                        content: content,
                    };
                }
                break;
            }
            case 'hardBreak': {
                return {
                    type: type,
                };
            }
            case 'media': {
                var mediaId = '';
                var mediaType = '';
                var mediaCollection = [];
                var mediaUrl = '';
                if (attrs) {
                    var id = attrs.id, collection = attrs.collection, type_1 = attrs.type, url = attrs.url;
                    mediaId = id;
                    mediaType = type_1;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    return {
                        type: type,
                        attrs: {
                            type: mediaType,
                            url: mediaUrl,
                            width: attrs.width,
                            height: attrs.height,
                        },
                    };
                }
                else if (mediaId && mediaType) {
                    var mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection,
                    };
                    if (attrs.width) {
                        mediaAttrs.width = attrs.width;
                    }
                    if (attrs.height) {
                        mediaAttrs.height = attrs.height;
                    }
                    return {
                        type: type,
                        attrs: mediaAttrs,
                    };
                }
                break;
            }
            case 'mediaGroup': {
                if (Array.isArray(content) && !content.some(function (e) { return e.type !== 'media'; })) {
                    return {
                        type: type,
                        content: content,
                    };
                }
                break;
            }
            case 'mediaSingle': {
                if (Array.isArray(content) &&
                    content.length === 1 &&
                    content[0].type === 'media') {
                    return {
                        type: type,
                        attrs: attrs,
                        content: content,
                        marks: marks,
                    };
                }
                break;
            }
            case 'mention': {
                var mentionText = '';
                var mentionId = void 0;
                var mentionAccess = void 0;
                if (attrs) {
                    var text_2 = attrs.text, displayName = attrs.displayName, id = attrs.id, accessLevel = attrs.accessLevel;
                    mentionText = text_2 || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                }
                if (!mentionText) {
                    mentionText = text || '@unknown';
                }
                if (mentionText && mentionId) {
                    var mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                        },
                    };
                    if (mentionAccess) {
                        mentionNode.attrs['accessLevel'] = mentionAccess;
                    }
                    return mentionNode;
                }
                break;
            }
            case 'paragraph': {
                return marks
                    ? {
                        type: type,
                        content: content || [],
                        marks: marks,
                    }
                    : { type: type, content: content || [] };
            }
            case 'rule': {
                return {
                    type: type,
                };
            }
            case 'text': {
                var marks_1 = node.marks;
                if (text) {
                    if (marks_1) {
                        marks_1 = marks_1.reduce(function (acc, mark) {
                            var validMark = getValidMark(mark, adfStage);
                            if (validMark) {
                                acc.push(validMark);
                            }
                            return acc;
                        }, []);
                    }
                    return marks_1 ? { type: type, text: text, marks: marks_1 } : { type: type, text: text };
                }
                break;
            }
            case 'heading': {
                if (attrs) {
                    var level = attrs.level;
                    var between = function (x, a, b) { return x >= a && x <= b; };
                    if (level && between(level, 1, 6)) {
                        return marks
                            ? {
                                type: type,
                                content: content,
                                marks: marks,
                                attrs: {
                                    level: level,
                                },
                            }
                            : {
                                type: type,
                                content: content,
                                attrs: {
                                    level: level,
                                },
                            };
                    }
                }
                break;
            }
            case 'bulletList': {
                if (content) {
                    return {
                        type: type,
                        content: content,
                    };
                }
                break;
            }
            case 'orderedList': {
                if (content) {
                    return {
                        type: type,
                        content: content,
                        attrs: {
                            order: attrs && attrs.order,
                        },
                    };
                }
                break;
            }
            case 'listItem': {
                if (content) {
                    return {
                        type: type,
                        content: wrapInlineNodes(content),
                    };
                }
                break;
            }
            case 'blockquote': {
                if (content) {
                    return {
                        type: type,
                        content: content,
                    };
                }
                break;
            }
            case 'panel': {
                var types = ['info', 'note', 'tip', 'success', 'warning', 'error'];
                if (attrs && content) {
                    var panelType = attrs.panelType;
                    if (types.indexOf(panelType) > -1) {
                        return {
                            type: type,
                            attrs: { panelType: panelType },
                            content: content,
                        };
                    }
                }
                break;
            }
            case 'layoutSection': {
                if (content) {
                    return {
                        type: type,
                        marks: marks,
                        content: content,
                    };
                }
                break;
            }
            case 'layoutColumn': {
                if (attrs && content) {
                    if (attrs.width > 0 && attrs.width <= 100) {
                        return {
                            type: type,
                            content: content,
                            attrs: attrs,
                        };
                    }
                }
                break;
            }
            case 'decisionList': {
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: (attrs && attrs.localId) || Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["D" /* generateUuid */])(),
                    },
                };
            }
            case 'decisionItem': {
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: (attrs && attrs.localId) || Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["D" /* generateUuid */])(),
                        state: (attrs && attrs.state) || 'DECIDED',
                    },
                };
            }
            case 'taskList': {
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: (attrs && attrs.localId) || Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["D" /* generateUuid */])(),
                    },
                };
            }
            case 'taskItem': {
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: (attrs && attrs.localId) || Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["D" /* generateUuid */])(),
                        state: (attrs && attrs.state) || 'TODO',
                    },
                };
            }
            case 'table': {
                if (Array.isArray(content) &&
                    content.length > 0 &&
                    !content.some(function (e) { return e.type !== 'tableRow'; })) {
                    return {
                        type: type,
                        content: content,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'tableRow': {
                if (Array.isArray(content) &&
                    content.length > 0 &&
                    !content.some(function (e) { return e.type !== 'tableCell' && e.type !== 'tableHeader'; })) {
                    return {
                        type: type,
                        content: content,
                    };
                }
                break;
            }
            case 'tableCell':
            case 'tableHeader': {
                if (content) {
                    var cellAttrs = {};
                    if (attrs) {
                        if (attrs.colspan && attrs.colspan > 1) {
                            cellAttrs.colspan = attrs.colspan;
                        }
                        if (attrs.rowspan && attrs.rowspan > 1) {
                            cellAttrs.rowspan = attrs.rowspan;
                        }
                        if (attrs.background) {
                            cellAttrs.background = attrs.background;
                        }
                        if (attrs.colwidth && Array.isArray(attrs.colwidth)) {
                            cellAttrs.colwidth = attrs.colwidth;
                        }
                    }
                    return {
                        type: type,
                        content: wrapInlineNodes(content),
                        attrs: attrs ? cellAttrs : undefined,
                    };
                }
                break;
            }
            case 'image': {
                if (attrs && attrs.src) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'placeholder': {
                if (attrs && typeof attrs.text !== 'undefined') {
                    return { type: type, attrs: attrs };
                }
                break;
            }
        }
    }
    return getValidUnknownNode(node);
};
/*
 * This method will validate a Mark according to the spec defined here
 * https://product-fabric.atlassian.net/wiki/spaces/E/pages/11174043/Document+structure#Documentstructure-Marks
 *
 * This is also the place to handle backwards compatibility.
 *
 * If a node is not recognized or is missing required attributes, we should return null
 *
 */
var getValidMark = function (mark, adfStage) {
    if (adfStage === void 0) { adfStage = 'final'; }
    var attrs = mark.attrs, type = mark.type;
    if (type) {
        switch (type) {
            case 'action': {
                if (attrs && attrs.target && attrs.target.key) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'code': {
                return {
                    type: type,
                };
            }
            case 'em': {
                return {
                    type: type,
                };
            }
            case 'link': {
                if (attrs) {
                    var href = attrs.href, url = attrs.url, __confluenceMetadata = attrs.__confluenceMetadata;
                    var linkHref = href || url;
                    if (linkHref &&
                        linkHref.indexOf(':') === -1 &&
                        !RELATIVE_LINK.test(linkHref)) {
                        linkHref = "http://" + linkHref;
                    }
                    var linkAttrs = {
                        href: linkHref,
                    };
                    if (__confluenceMetadata) {
                        linkAttrs.__confluenceMetadata = __confluenceMetadata;
                    }
                    if (linkHref && Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_adf_schema__["L" /* isSafeUrl */])(linkHref)) {
                        return {
                            type: type,
                            attrs: linkAttrs,
                        };
                    }
                }
                break;
            }
            case 'strike': {
                return {
                    type: type,
                };
            }
            case 'strong': {
                return {
                    type: type,
                };
            }
            case 'subsup': {
                if (attrs && attrs['type']) {
                    var subSupType = attrs['type'];
                    if (isSubSupType(subSupType)) {
                        return {
                            type: type,
                            attrs: {
                                type: subSupType,
                            },
                        };
                    }
                }
                break;
            }
            case 'textColor': {
                if (attrs && TEXT_COLOR_PATTERN.test(attrs.color)) {
                    return {
                        type: type,
                        attrs: attrs,
                    };
                }
                break;
            }
            case 'underline': {
                return {
                    type: type,
                };
            }
        }
    }
    if (adfStage === 'stage0') {
        switch (type) {
            case 'confluenceInlineComment': {
                return {
                    type: type,
                    attrs: attrs,
                };
            }
        }
    }
    return null;
};
//# sourceMappingURL=validator.js.map

/***/ }),
/* 2972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    ios: false,
    webkit: false,
};
if (typeof navigator !== 'undefined') {
    var ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    var ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    var ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    result.mac = /Mac/.test(navigator.platform);
    var ie = (result.ie = !!(ieUpTo10 || ie11up || ieEdge));
    result.ie_version = ieUpTo10
        ? document.documentMode || 6
        : ie11up
            ? +ie11up[1]
            : ieEdge
                ? +ieEdge[1]
                : null;
    result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    result.ios =
        !ie &&
            /AppleWebKit/.test(navigator.userAgent) &&
            /Mobile\/\w+/.test(navigator.userAgent);
    result.webkit =
        !ie &&
            !!document.documentElement &&
            'WebkitAppearance' in document.documentElement.style;
}
/* harmony default export */ __webpack_exports__["a"] = (result);
//# sourceMappingURL=browser.js.map

/***/ }),
/* 2973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ErrorReporter = /** @class */ (function () {
    function ErrorReporter() {
        this.handlerStorage = null;
    }
    ErrorReporter.prototype.captureMessage = function (msg, tags) {
        if (this.handlerStorage) {
            this.handlerStorage.captureMessage(msg, tags);
        }
    };
    ErrorReporter.prototype.captureException = function (err, tags) {
        if (this.handlerStorage) {
            this.handlerStorage.captureException(err, tags);
        }
    };
    Object.defineProperty(ErrorReporter.prototype, "handler", {
        set: function (handler) {
            this.handlerStorage = handler;
        },
        enumerable: true,
        configurable: true
    });
    return ErrorReporter;
}());
/* unused harmony default export */ var _unused_webpack_default_export = (ErrorReporter);
//# sourceMappingURL=error-reporter.js.map

/***/ }),
/* 2974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export timestampToUTCDate */
/* unused harmony export todayTimestampInUTC */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return timestampToString; });
/* unused harmony export timestampToIsoFormat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isPastDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return timestampToTaskContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_is_before__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_is_before___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_is_before__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_difference_in_calendar_days__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_difference_in_calendar_days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_difference_in_calendar_days__);


var ISO_FORMAT = 'YYYY-MM-DD';
var DEFAULT_FORMAT = 'DD MMM YYYY';
var timestampToUTCDate = function (timestamp) {
    var date = new Date(Number(timestamp));
    var day = date.getUTCDate();
    var month = date.getUTCMonth() + 1;
    var year = date.getUTCFullYear();
    return { day: day, month: month, year: year };
};
var todayTimestampInUTC = function () {
    var today = new Date();
    var todayInUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    return todayInUTC.toString();
};
var addLeadingZero = function (val) {
    if (val < 10) {
        return "0" + val;
    }
    return val;
};
var months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];
var week_days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
// example: "23 Jan 2018"
var timestampToString = function (timestamp, pattern) {
    var date = new Date(Number(timestamp));
    switch (pattern) {
        case 'ddd, DD MMM':
            return week_days[date.getUTCDay()] + ", " + addLeadingZero(date.getUTCDate()) + " " + months[date.getUTCMonth()];
        case ISO_FORMAT:
            return date.getUTCFullYear() + "-" + addLeadingZero(date.getUTCMonth() + 1) + "-" + date.getUTCDate();
        default:
            return addLeadingZero(date.getUTCDate()) + " " + months[date.getUTCMonth()] + " " + date.getUTCFullYear();
    }
};
// example: "2018-01-23"
var timestampToIsoFormat = function (timestamp) {
    return timestampToString(timestamp, ISO_FORMAT);
};
var isPastDate = function (timestamp) {
    return __WEBPACK_IMPORTED_MODULE_0_date_fns_is_before__(timestampToIsoFormat(Number(timestamp)), timestampToIsoFormat(new Date().valueOf()));
};
var timestampToTaskContext = function (timestamp) {
    var curDate = new Date();
    var givenDate = new Date(Number(timestamp));
    var distance = __WEBPACK_IMPORTED_MODULE_1_date_fns_difference_in_calendar_days__(givenDate, curDate);
    var sameYear = givenDate.getUTCFullYear() === curDate.getUTCFullYear();
    var pattern = '';
    if (distance === 0) {
        return 'Today';
    }
    else if (distance === 1) {
        return 'Tomorrow';
    }
    else if (distance === -1) {
        pattern = 'Yesterday';
    }
    else if (sameYear) {
        pattern = 'ddd, DD MMM';
    }
    else {
        pattern = DEFAULT_FORMAT;
    }
    return timestampToString(timestamp, pattern);
};
//# sourceMappingURL=date.js.map

/***/ }),
/* 2975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withImageLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



var withImageLoader = function (Wrapped) {
    return /** @class */ (function (_super) {
        __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WithImageLoader, _super);
        function WithImageLoader() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = {
                imageStatus: 'loading',
            };
            _this.onLoad = function () {
                _this.setState({
                    imageStatus: 'complete',
                });
                var onExternalImageLoaded = _this.props.onExternalImageLoaded;
                if (onExternalImageLoaded && _this.img) {
                    onExternalImageLoaded({
                        width: _this.img.naturalWidth,
                        height: _this.img.naturalHeight,
                    });
                }
            };
            _this.onError = function () {
                _this.setState({
                    imageStatus: 'error',
                });
            };
            return _this;
        }
        WithImageLoader.prototype.componentDidMount = function () {
            this.fetchImage(this.props);
        };
        WithImageLoader.prototype.componentWillReceiveProps = function (nextProps) {
            if (nextProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading',
                });
                this.fetchImage(nextProps);
            }
        };
        WithImageLoader.prototype.componentWillUnmount = function () {
            if (this.img) {
                this.img.removeEventListener('load', this.onLoad);
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        };
        WithImageLoader.prototype.fetchImage = function (_a) {
            var url = _a.url;
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    this.img.addEventListener('load', this.onLoad);
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        };
        WithImageLoader.prototype.render = function () {
            var imageStatus = this.state.imageStatus;
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Wrapped, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, this.props, { imageStatus: imageStatus }));
        };
        return WithImageLoader;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
};
//# sourceMappingURL=imageLoader.js.map

/***/ }),
/* 2976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calcBreakoutWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calcWideWidth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui__ = __webpack_require__(919);


var calcBreakoutWidth = function (layout, containerWidth) {
    var effectiveFullWidth = containerWidth - __WEBPACK_IMPORTED_MODULE_0__styles__["b" /* akEditorBreakoutPadding */];
    switch (layout) {
        case 'full-width':
            return effectiveFullWidth <= __WEBPACK_IMPORTED_MODULE_0__styles__["e" /* akEditorFullPageMaxWidth */]
                ? '100%'
                : effectiveFullWidth + "px";
        case 'wide':
            return calcWideWidth(containerWidth);
        default:
            return 'inherit';
    }
};
var calcWideWidth = function (containerWidth, maxWidth, fallback) {
    if (containerWidth === void 0) { containerWidth = __WEBPACK_IMPORTED_MODULE_0__styles__["c" /* akEditorDefaultLayoutWidth */]; }
    if (maxWidth === void 0) { maxWidth = Infinity; }
    if (fallback === void 0) { fallback = '100%'; }
    var effectiveFullWidth = containerWidth - __WEBPACK_IMPORTED_MODULE_0__styles__["b" /* akEditorBreakoutPadding */];
    var layoutMaxWidth = Object(__WEBPACK_IMPORTED_MODULE_1__ui__["i" /* mapBreakpointToLayoutMaxWidth */])(Object(__WEBPACK_IMPORTED_MODULE_1__ui__["h" /* getBreakpoint */])(containerWidth));
    var wideWidth = Math.min(Math.ceil(layoutMaxWidth * __WEBPACK_IMPORTED_MODULE_0__styles__["n" /* breakoutWideScaleRatio */]), effectiveFullWidth);
    return layoutMaxWidth > wideWidth
        ? fallback
        : Math.min(maxWidth, wideWidth) + "px";
};
//# sourceMappingURL=calc-breakout-width.js.map

/***/ }),
/* 2977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return tableMarginTop; });
/* unused harmony export tableMarginBottom */
/* unused harmony export tableMarginSides */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tableCellMinWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TableSharedCssClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calcTableWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return tableSharedStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__panel__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(479);






var tableMarginTop = 24;
var tableMarginBottom = 16;
var tableMarginSides = 8;
var tableCellMinWidth = 48;
var clPrefix = 'pm-table-';
var TableSharedCssClassName = {
    TABLE_CONTAINER: clPrefix + "container",
    TABLE_NODE_WRAPPER: clPrefix + "wrapper",
    TABLE_LEFT_SHADOW: clPrefix + "with-left-shadow",
    TABLE_RIGHT_SHADOW: clPrefix + "with-right-shadow",
    TABLE_CELL_NODEVIEW_CONTENT_DOM: clPrefix + "cell-nodeview-content-dom",
};
var tableSharedStyle = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .", " {\n    position: relative;\n    margin: 0 auto ", "px;\n    box-sizing: border-box;\n\n    /**\n     * Fix block top alignment inside table cells.\n     */\n    .code-block,\n    .", ",\n    .taskItemView-content-wrap > div,\n    .decisionItemView-content-wrap > div {\n      margin-top: 0;\n    }\n  }\n  .", "[data-number-column='true'] {\n    padding-left: ", "px;\n  }\n  /* avoid applying styles to nested tables (possible via extensions) */\n  .", " > table,\n  .", " > table {\n    border-collapse: collapse;\n    margin: ", "px ", "px 0;\n    border: 1px solid ", ";\n    table-layout: fixed;\n    font-size: ", "px;\n    width: 100%;\n\n    &[data-autosize='true'] {\n      table-layout: auto;\n    }\n\n    & {\n      * {\n        box-sizing: border-box;\n      }\n\n      tbody {\n        border-bottom: none;\n      }\n      th td {\n        background-color: white;\n        font-weight: normal;\n      }\n      th,\n      td {\n        min-width: ", "px;\n        height: 3em;\n        vertical-align: top;\n        border: 1px solid ", ";\n        border-right-width: 0;\n        border-bottom-width: 0;\n        padding: 10px;\n        /* https://stackoverflow.com/questions/7517127/borders-not-shown-in-firefox-with-border-collapse-on-table-position-relative-o */\n        background-clip: padding-box;\n\n        th p:not(:first-of-type),\n        td p:not(:first-of-type) {\n          margin-top: 12px;\n        }\n      }\n      th {\n        background-color: ", ";\n        text-align: left;\n        & *:not(strong) {\n          font-weight: normal;\n        }\n        & .", " > p {\n          font-weight: bold;\n        }\n      }\n    }\n  }\n"], ["\n  .", " {\n    position: relative;\n    margin: 0 auto ", "px;\n    box-sizing: border-box;\n\n    /**\n     * Fix block top alignment inside table cells.\n     */\n    .code-block,\n    .", ",\n    .taskItemView-content-wrap > div,\n    .decisionItemView-content-wrap > div {\n      margin-top: 0;\n    }\n  }\n  .", "[data-number-column='true'] {\n    padding-left: ", "px;\n  }\n  /* avoid applying styles to nested tables (possible via extensions) */\n  .", " > table,\n  .", " > table {\n    border-collapse: collapse;\n    margin: ", "px ", "px 0;\n    border: 1px solid ", ";\n    table-layout: fixed;\n    font-size: ", "px;\n    width: 100%;\n\n    &[data-autosize='true'] {\n      table-layout: auto;\n    }\n\n    & {\n      * {\n        box-sizing: border-box;\n      }\n\n      tbody {\n        border-bottom: none;\n      }\n      th td {\n        background-color: white;\n        font-weight: normal;\n      }\n      th,\n      td {\n        min-width: ", "px;\n        height: 3em;\n        vertical-align: top;\n        border: 1px solid ", ";\n        border-right-width: 0;\n        border-bottom-width: 0;\n        padding: 10px;\n        /* https://stackoverflow.com/questions/7517127/borders-not-shown-in-firefox-with-border-collapse-on-table-position-relative-o */\n        background-clip: padding-box;\n\n        th p:not(:first-of-type),\n        td p:not(:first-of-type) {\n          margin-top: 12px;\n        }\n      }\n      th {\n        background-color: ", ";\n        text-align: left;\n        & *:not(strong) {\n          font-weight: normal;\n        }\n        & .", " > p {\n          font-weight: bold;\n        }\n      }\n    }\n  }\n"])), TableSharedCssClassName.TABLE_CONTAINER, tableMarginBottom, __WEBPACK_IMPORTED_MODULE_4__panel__["a" /* PanelSharedCssClassName */].PANEL_CONTAINER, TableSharedCssClassName.TABLE_CONTAINER, __WEBPACK_IMPORTED_MODULE_3__consts__["j" /* akEditorTableNumberColumnWidth */] - 1, TableSharedCssClassName.TABLE_CONTAINER, TableSharedCssClassName.TABLE_NODE_WRAPPER, tableMarginTop, tableMarginSides, __WEBPACK_IMPORTED_MODULE_3__consts__["g" /* akEditorTableBorder */], Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["fontSize"])(), tableCellMinWidth, __WEBPACK_IMPORTED_MODULE_3__consts__["g" /* akEditorTableBorder */], __WEBPACK_IMPORTED_MODULE_3__consts__["k" /* akEditorTableToolbar */], TableSharedCssClassName.TABLE_CELL_NODEVIEW_CONTENT_DOM);
var calcTableWidth = function (layout, containerWidth, addControllerPadding) {
    if (addControllerPadding === void 0) { addControllerPadding = true; }
    switch (layout) {
        case 'full-width':
            return containerWidth
                ? containerWidth -
                    (addControllerPadding ? __WEBPACK_IMPORTED_MODULE_3__consts__["b" /* akEditorBreakoutPadding */] : 0) + "px"
                : '100%';
        case 'wide':
            if (containerWidth) {
                var targetWidth = containerWidth - (addControllerPadding ? __WEBPACK_IMPORTED_MODULE_3__consts__["b" /* akEditorBreakoutPadding */] : 0);
                return Object(__WEBPACK_IMPORTED_MODULE_5__utils__["c" /* calcWideWidth */])(containerWidth, targetWidth, targetWidth + "px");
            }
            else {
                return __WEBPACK_IMPORTED_MODULE_3__consts__["l" /* akEditorWideLayoutWidth */] + "px";
            }
        default:
            return 'inherit';
    }
};

var templateObject_1;
//# sourceMappingURL=table.js.map

/***/ }),
/* 2978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return columnLayoutSharedStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(169);



var columnLayoutSharedStyle = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  [data-layout-section] {\n    display: flex;\n    flex-direction: row;\n    & > * {\n      flex: 1;\n      min-width: 0;\n    }\n\n    @media screen and (max-width: ", "px) {\n      flex-direction: column;\n    }\n  }\n"], ["\n  [data-layout-section] {\n    display: flex;\n    flex-direction: row;\n    & > * {\n      flex: 1;\n      min-width: 0;\n    }\n\n    @media screen and (max-width: ", "px) {\n      flex-direction: column;\n    }\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__consts__["p" /* gridMediumMaxWidth */]);

var templateObject_1;
//# sourceMappingURL=column-layout.js.map

/***/ }),
/* 2979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mediaSingleSharedStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);

// @ts-ignore: unused variable
// prettier-ignore

var mediaSingleSharedStyle = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  li .media-single {\n    margin: 0;\n  }\n\n  table .media-single {\n    margin: 0;\n  }\n\n  .media-single.image-wrap-left + .media-single.image-wrap-right,\n  .media-single.image-wrap-right + .media-single.image-wrap-left,\n  .media-single.image-wrap-left + .media-single.image-wrap-left,\n  .media-single.image-wrap-right + .media-single.image-wrap-right {\n    margin-right: 0;\n    margin-left: 0;\n  }\n"], ["\n  li .media-single {\n    margin: 0;\n  }\n\n  table .media-single {\n    margin: 0;\n  }\n\n  .media-single.image-wrap-left + .media-single.image-wrap-right,\n  .media-single.image-wrap-right + .media-single.image-wrap-left,\n  .media-single.image-wrap-left + .media-single.image-wrap-left,\n  .media-single.image-wrap-right + .media-single.image-wrap-right {\n    margin-right: 0;\n    margin-left: 0;\n  }\n"])));

var templateObject_1;
//# sourceMappingURL=media-single.js.map

/***/ }),
/* 2980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return blockquoteSharedStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consts__ = __webpack_require__(169);

// @ts-ignore: unused variable



var blockquoteSharedStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  & blockquote {\n    box-sizing: border-box;\n    padding-left: ", "px;\n    border-left: 2px solid ", ";\n    margin: ", " 0 0 0;\n    margin-right: 0;\n\n    [dir='rtl'] & {\n      padding-left: 0;\n      padding-right: ", "px;\n    }\n\n    &:first-child {\n      margin-top: 0;\n    }\n\n    &::before {\n      content: '';\n    }\n\n    &::after {\n      content: none;\n    }\n\n    & p {\n      display: block;\n    }\n\n    & table,\n    & table:last-child {\n      display: inline-table;\n    }\n  }\n"], ["\n  & blockquote {\n    box-sizing: border-box;\n    padding-left: ", "px;\n    border-left: 2px solid ", ";\n    margin: ", " 0 0 0;\n    margin-right: 0;\n\n    [dir='rtl'] & {\n      padding-left: 0;\n      padding-right: ", "px;\n    }\n\n    &:first-child {\n      margin-top: 0;\n    }\n\n    &::before {\n      content: '';\n    }\n\n    &::after {\n      content: none;\n    }\n\n    & p {\n      display: block;\n    }\n\n    & table,\n    & table:last-child {\n      display: inline-table;\n    }\n  }\n"])), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() * 2, __WEBPACK_IMPORTED_MODULE_3__consts__["a" /* akEditorBlockquoteBorderColor */], __WEBPACK_IMPORTED_MODULE_3__consts__["m" /* blockNodesVerticalMargin */], Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["gridSize"])() * 2);
var templateObject_1;
//# sourceMappingURL=blockquote.js.map

/***/ }),
/* 2981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return headingsSharedStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);

// @ts-ignore: unused variable
// prettier-ignore

// @see typography spreadsheet: https://docs.google.com/spreadsheets/d/1iYusRGCT4PoPfvxbJ8NrgjtfFgXLm5lpDWXzjua1W2E/edit#gid=93913128
// text sizing prototype: http://proto/fabricrender/
var headingsSharedStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  & h1 {\n    line-height: 1.167;\n    font-size: 1.714em;\n    margin-top: 1.667em;\n    margin-bottom: 0;\n  }\n\n  & h2 {\n    line-height: 1.2;\n    font-size: 1.429em;\n    margin-top: 1.8em;\n    margin-bottom: 0;\n  }\n\n  & h3 {\n    line-height: 1.25;\n    font-size: 1.143em;\n    margin-top: 2em;\n    margin-bottom: 0;\n  }\n\n  & h4 {\n    line-height: 1.429;\n    font-size: 1em;\n    margin-top: 1.357em;\n  }\n\n  & h5 {\n    line-height: 1.333;\n    font-size: 0.857em;\n    margin-top: 1.667em;\n  }\n\n  & h6 {\n    line-height: 1.455;\n    font-size: 0.786em;\n    margin-top: 1.455em;\n  }\n"], ["\n  & h1 {\n    line-height: 1.167;\n    font-size: 1.714em;\n    margin-top: 1.667em;\n    margin-bottom: 0;\n  }\n\n  & h2 {\n    line-height: 1.2;\n    font-size: 1.429em;\n    margin-top: 1.8em;\n    margin-bottom: 0;\n  }\n\n  & h3 {\n    line-height: 1.25;\n    font-size: 1.143em;\n    margin-top: 2em;\n    margin-bottom: 0;\n  }\n\n  & h4 {\n    line-height: 1.429;\n    font-size: 1em;\n    margin-top: 1.357em;\n  }\n\n  & h5 {\n    line-height: 1.333;\n    font-size: 0.857em;\n    margin-top: 1.667em;\n  }\n\n  & h6 {\n    line-height: 1.455;\n    font-size: 0.786em;\n    margin-top: 1.455em;\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=headings.js.map

/***/ }),
/* 2982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ruleSharedStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);

// @ts-ignore: unused variable


// @see typography spreadsheet: https://docs.google.com/spreadsheets/d/1iYusRGCT4PoPfvxbJ8NrgjtfFgXLm5lpDWXzjua1W2E/edit#gid=93913128
var ruleSharedStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  & hr {\n    border: none;\n    background-color: ", ";\n    margin: 1.714em 0;\n    height: 2px;\n    border-radius: 1px;\n\n    &.ProseMirror-selectednode {\n      outline: none;\n      background-color: ", ";\n    }\n  }\n"], ["\n  & hr {\n    border: none;\n    background-color: ", ";\n    margin: 1.714em 0;\n    height: 2px;\n    border-radius: 1px;\n\n    &.ProseMirror-selectednode {\n      outline: none;\n      background-color: ", ";\n    }\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30A, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B300);
var templateObject_1;
//# sourceMappingURL=rule.js.map

/***/ }),
/* 2983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return paragraphSharedStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(169);

// @ts-ignore: unused variable


// @see typography spreadsheet: https://docs.google.com/spreadsheets/d/1iYusRGCT4PoPfvxbJ8NrgjtfFgXLm5lpDWXzjua1W2E/edit#gid=93913128
var paragraphSharedStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  & p {\n    font-size: 1em;\n    line-height: 1.714;\n    font-weight: normal;\n    margin-top: ", ";\n    margin-bottom: 0;\n    letter-spacing: -0.005em;\n  }\n"], ["\n  & p {\n    font-size: 1em;\n    line-height: 1.714;\n    font-weight: normal;\n    margin-top: ", ";\n    margin-bottom: 0;\n    letter-spacing: -0.005em;\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__consts__["m" /* blockNodesVerticalMargin */]);
var templateObject_1;
//# sourceMappingURL=paragraph.js.map

/***/ }),
/* 2984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export linkSharedStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var linkSharedStyle = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  a.blockLink {\n    display: block;\n  }\n"], ["\n  a.blockLink {\n    display: block;\n  }\n"])));

var templateObject_1;
//# sourceMappingURL=link.js.map

/***/ }),
/* 2985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return indentationSharedStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var indentationSharedStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  .fabric-editor-indentation-mark {\n    &[data-level='1'] {\n      margin-left: 30px;\n    }\n    &[data-level='2'] {\n      margin-left: 60px;\n    }\n    &[data-level='3'] {\n      margin-left: 90px;\n    }\n    &[data-level='4'] {\n      margin-left: 120px;\n    }\n    &[data-level='5'] {\n      margin-left: 150px;\n    }\n    &[data-level='6'] {\n      margin-left: 180px;\n    }\n  }\n"], ["\n  .fabric-editor-indentation-mark {\n    &[data-level='1'] {\n      margin-left: 30px;\n    }\n    &[data-level='2'] {\n      margin-left: 60px;\n    }\n    &[data-level='3'] {\n      margin-left: 90px;\n    }\n    &[data-level='4'] {\n      margin-left: 120px;\n    }\n    &[data-level='5'] {\n      margin-left: 150px;\n    }\n    &[data-level='6'] {\n      margin-left: 180px;\n    }\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=indentation.js.map

/***/ }),
/* 2986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return blockMarksSharedStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);


var blockMarksSharedStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  /**\n   * We need to remove margin-top from first item\n   * inside doc, tableCell, tableHeader, blockquote, etc.\n   */\n  *:not(.fabric-editor-block-mark) >,\n  /* For nested block marks */\n  *:not(.fabric-editor-block-mark) > div.fabric-editor-block-mark:first-child {\n    p,\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      &:first-child {\n        margin-top: 0;\n      }\n    }\n  }\n"], ["\n  /**\n   * We need to remove margin-top from first item\n   * inside doc, tableCell, tableHeader, blockquote, etc.\n   */\n  *:not(.fabric-editor-block-mark) >,\n  /* For nested block marks */\n  *:not(.fabric-editor-block-mark) > div.fabric-editor-block-mark:first-child {\n    p,\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      &:first-child {\n        margin-top: 0;\n      }\n    }\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=block-marks.js.map

/***/ }),
/* 2987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_emoji__ = __webpack_require__(2988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__providerFactory__ = __webpack_require__(481);





var EmojiNode = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiNode, _super);
    function EmojiNode(props) {
        var _this = _super.call(this, props) || this;
        _this.renderWithProvider = function (providers) {
            var _a = _this.props, allowTextFallback = _a.allowTextFallback, shortName = _a.shortName, id = _a.id, fallback = _a.fallback, fitToHeight = _a.fitToHeight;
            if (allowTextFallback && !providers.emojiProvider) {
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, fallback || shortName);
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_emoji__["a" /* ResourcedEmoji */], { emojiId: { id: id, fallback: fallback, shortName: shortName }, emojiProvider: providers.emojiProvider, showTooltip: true, fitToHeight: fitToHeight }));
        };
        _this.providerFactory = props.providers || new __WEBPACK_IMPORTED_MODULE_3__providerFactory__["b" /* default */]();
        return _this;
    }
    EmojiNode.prototype.componentWillUnmount = function () {
        if (!this.props.providers) {
            // new ProviderFactory is created if no `providers` has been set
            // in this case when component is unmounted it's safe to destroy this providerFactory
            this.providerFactory.destroy();
        }
    };
    EmojiNode.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__providerFactory__["a" /* WithProviders */], { providers: ['emojiProvider'], providerFactory: this.providerFactory, renderNode: this.renderWithProvider }));
    };
    return EmojiNode;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (EmojiNode);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_util_service_support__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Emoji__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_EmojiPlaceholder__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_ResourcedEmoji__ = __webpack_require__(2991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_picker_EmojiPicker__ = __webpack_require__(2992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_typeahead_EmojiTypeAhead__ = __webpack_require__(3004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_EmojiResource__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_EmojiRepository__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_EmojiLoader__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_EmojiUtils__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__type_helpers__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_internal_UsageFrequencyTracker__ = __webpack_require__(920);
/* unused harmony reexport AbstractResource */
/* unused harmony reexport Emoji */
/* unused harmony reexport EmojiPlaceholder */
/* unused harmony reexport EmojiLoader */
/* unused harmony reexport EmojiPicker */
/* unused harmony reexport EmojiResource */
/* unused harmony reexport EmojiRepository */
/* unused harmony reexport EmojiTypeAhead */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__components_common_ResourcedEmoji__["a"]; });
/* unused harmony reexport denormaliseEmojiServiceResponse */
/* unused harmony reexport toEmojiId */
/* unused harmony reexport toOptionalEmojiId */
/* unused harmony reexport emojiPickerWidth */
/* unused harmony reexport emojiPickerHeight */
/* unused harmony reexport defaultEmojiHeight */
/* unused harmony reexport customCategory */
/* unused harmony reexport UsageFrequencyTracker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types__ = __webpack_require__(542);
/* unused harmony namespace reexport */















/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_4__components_picker_EmojiPicker__["a" /* default */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 2989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(102));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CrossCircleIcon = function CrossCircleIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill-rule=\"evenodd\"><circle fill=\"currentColor\" cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M13.477 9.113l-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41z\" fill=\"inherit\"/><path d=\"M9.084 10.501l4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411z\" fill=\"inherit\"/></g></svg>"
  }, props));
};

CrossCircleIcon.displayName = 'CrossCircleIcon';
var _default = CrossCircleIcon;
exports.default = _default;

/***/ }),
/* 2990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = void 0;
var sizes = {
  small: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '48px'
};
exports.sizes = sizes;

/***/ }),
/* 2991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EmojiPlaceholder__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LoadingEmojiComponent__ = __webpack_require__(480);





var resourcedEmojiModuleLoader = function () {
    return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 3476));
};
var resourcedEmojiComponentLoader = function () { return resourcedEmojiModuleLoader().then(function (module) { return module.default; }); };
var ResourcedEmoji = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ResourcedEmoji, _super);
    function ResourcedEmoji() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            asyncLoadedComponent: ResourcedEmoji.AsyncLoadedComponent,
        };
        return _this;
    }
    ResourcedEmoji.prototype.asyncLoadComponent = function () {
        var _this = this;
        resourcedEmojiComponentLoader().then(function (component) {
            ResourcedEmoji.AsyncLoadedComponent = component;
            _this.setAsyncState(component);
        });
    };
    ResourcedEmoji.prototype.renderLoading = function () {
        var _a = this.props, fitToHeight = _a.fitToHeight, emojiId = _a.emojiId, showTooltip = _a.showTooltip;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__EmojiPlaceholder__["a" /* default */], { shortName: emojiId.shortName, showTooltip: showTooltip, size: fitToHeight || __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* defaultEmojiHeight */] }));
    };
    ResourcedEmoji.prototype.renderLoaded = function (loadedEmojiProvider, ResourcedEmojiComponent) {
        var _a = this.props, emojiProvider = _a.emojiProvider, otherProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["emojiProvider"]);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ResourcedEmojiComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, otherProps, { emojiProvider: loadedEmojiProvider })));
    };
    return ResourcedEmoji;
}(__WEBPACK_IMPORTED_MODULE_4__LoadingEmojiComponent__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (ResourcedEmoji);
//# sourceMappingURL=ResourcedEmoji.js.map

/***/ }),
/* 2992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EmojiPickerInternal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_analytics__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_LoadingEmojiComponent__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EmojiPickerVirtualItems__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(181);






var emojiPickerModuleLoader = function () {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 3477));
};
var emojiPickerLoader = function () {
    return emojiPickerModuleLoader().then(function (module) { return module.default; });
};
var EmojiPickerInternal = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiPickerInternal, _super);
    function EmojiPickerInternal(props) {
        var _this = _super.call(this, props, {}) || this;
        _this.state = {
            asyncLoadedComponent: EmojiPickerInternal.AsyncLoadedComponent,
        };
        return _this;
    }
    EmojiPickerInternal.prototype.asyncLoadComponent = function () {
        var _this = this;
        emojiPickerLoader().then(function (component) {
            EmojiPickerInternal.AsyncLoadedComponent = component;
            _this.setAsyncState(component);
        });
    };
    EmojiPickerInternal.prototype.renderLoading = function () {
        var _this = this;
        var item = new __WEBPACK_IMPORTED_MODULE_4__EmojiPickerVirtualItems__["c" /* LoadingItem */]();
        var handlePickerRef = function (ref) {
            if (_this.props.onPickerRef) {
                _this.props.onPickerRef(ref);
            }
        };
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_5__styles__["g" /* emojiPicker */], ref: handlePickerRef }, item.renderItem()));
    };
    EmojiPickerInternal.prototype.renderLoaded = function (loadedEmojiProvider, EmojiPickerComponent) {
        var _a = this.props, emojiProvider = _a.emojiProvider, otherProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["emojiProvider"]);
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](EmojiPickerComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ emojiProvider: loadedEmojiProvider }, otherProps)));
    };
    return EmojiPickerInternal;
}(__WEBPACK_IMPORTED_MODULE_3__common_LoadingEmojiComponent__["a" /* default */]));

// tslint:disable-next-line:variable-name
var EmojiPicker = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_analytics__["a" /* withAnalytics */])(EmojiPickerInternal, {}, {});
/* harmony default export */ __webpack_exports__["a"] = (EmojiPicker);
//# sourceMappingURL=EmojiPicker.js.map

/***/ }),
/* 2993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_field_base__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_search__ = __webpack_require__(2994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(181);








var EmojiPickerListSearch = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiPickerListSearch, _super);
    function EmojiPickerListSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onBlur = function (e) {
            var activeElement = document.activeElement;
            // Input lost focus to emoji picker container (happens in IE11 when updating search results)
            // See FS-2111
            if (activeElement instanceof HTMLElement &&
                activeElement.getAttribute('data-emoji-picker-container')) {
                _this.restoreInputFocus();
            }
        };
        _this.onChange = function (e) {
            _this.saveInputSelection();
            _this.props.onChange(e);
        };
        _this.focusInput = function () {
            if (_this.inputRef) {
                _this.inputRef.focus();
            }
        };
        _this.handleInputRef = function (input) {
            if (input) {
                // Defer focus so it give some time to position the popup before
                // setting the focus to search input.
                // see FS-2056
                _this.inputRef = input;
                window.setTimeout(_this.focusInput);
            }
        };
        return _this;
    }
    EmojiPickerListSearch.prototype.saveInputSelection = function () {
        this.inputSelection = undefined;
        if (this.inputRef) {
            var _a = this.inputRef, selectionStart = _a.selectionStart, selectionEnd = _a.selectionEnd, selectionDirection = _a.selectionDirection;
            if (selectionStart !== undefined) {
                this.inputSelection = {
                    selectionStart: selectionStart,
                    selectionEnd: selectionEnd,
                    selectionDirection: selectionDirection,
                };
            }
        }
    };
    EmojiPickerListSearch.prototype.restoreInputFocus = function () {
        this.focusInput();
        if (this.inputSelection &&
            this.inputRef &&
            this.inputRef.setSelectionRange) {
            var _a = this.inputSelection, selectionStart = _a.selectionStart, selectionEnd = _a.selectionEnd, selectionDirection = _a.selectionDirection;
            this.inputRef.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
        }
    };
    EmojiPickerListSearch.prototype.render = function () {
        var _this = this;
        var _a = this.props, style = _a.style, query = _a.query;
        return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_6__styles__["n" /* pickerSearch */], style: style },
            __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_intl__["FormattedMessage"], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, __WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* messages */].searchLabel), function (searchLabel) { return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__atlaskit_field_base__["b" /* default */], { appearance: "standard", isCompact: true, isLabelHidden: true, isFitContainerWidthEnabled: true },
                __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_6__styles__["o" /* searchIcon */] },
                    __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_search___default.a, { label: searchLabel })),
                __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("input", { className: __WEBPACK_IMPORTED_MODULE_6__styles__["m" /* input */], autoComplete: "off", disabled: false, name: "search", placeholder: searchLabel + "...", required: false, onChange: _this.onChange, value: query || '', ref: _this.handleInputRef, onBlur: _this.onBlur }))); })));
    };
    EmojiPickerListSearch.defaultProps = {
        style: {},
    };
    return EmojiPickerListSearch;
}(__WEBPACK_IMPORTED_MODULE_3_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (EmojiPickerListSearch);
//# sourceMappingURL=EmojiPickerListSearch.js.map

/***/ }),
/* 2994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(102));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SearchIcon = function SearchIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

SearchIcon.displayName = 'SearchIcon';
var _default = SearchIcon;
exports.default = _default;

/***/ }),
/* 2995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_CachingEmoji__ = __webpack_require__(1360);





var EmojiPickerEmojiRow = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiPickerEmojiRow, _super);
    function EmojiPickerEmojiRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmojiPickerEmojiRow.prototype.render = function () {
        var _a = this.props, emojis = _a.emojis, onSelected = _a.onSelected, onMouseMove = _a.onMouseMove, title = _a.title, showDelete = _a.showDelete, onDelete = _a.onDelete;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2__styles__["k" /* emojiPickerRow */] }, emojis.map(function (emoji) {
            var shortName = emoji.shortName, id = emoji.id;
            var key = id ? id + "-" + title : shortName + "-" + title;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: __WEBPACK_IMPORTED_MODULE_2__styles__["f" /* emojiItem */], key: key },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_CachingEmoji__["a" /* default */], { emoji: emoji, selectOnHover: true, onSelected: onSelected, onMouseMove: onMouseMove, showDelete: showDelete, onDelete: onDelete, placeholderSize: 24 })));
        })));
    };
    return EmojiPickerEmojiRow;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (EmojiPickerEmojiRow);
//# sourceMappingURL=EmojiPickerEmojiRow.js.map

/***/ }),
/* 2996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(181);







var EmojiPickerCategoryHeading = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiPickerCategoryHeading, _super);
    function EmojiPickerCategoryHeading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmojiPickerCategoryHeading.prototype.render = function () {
        var _a = this.props, id = _a.id, title = _a.title, className = _a.className;
        return (__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { id: id, "data-category-id": id, className: __WEBPACK_IMPORTED_MODULE_1_classnames__(className) },
            __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_5__styles__["e" /* emojiCategoryTitle */] },
                __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["FormattedMessage"], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* messages */][title])))));
    };
    return EmojiPickerCategoryHeading;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (EmojiPickerCategoryHeading);
//# sourceMappingURL=EmojiPickerCategoryHeading.js.map

/***/ }),
/* 2997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSearchEmojiComparator;
/* harmony export (immutable) */ __webpack_exports__["b"] = createUsageOnlyEmojiComparator;
/* unused harmony export ChainedEmojiComparator */
/* unused harmony export AsciiMatchComparator */
/* unused harmony export ExactShortNameMatchComparator */
/* unused harmony export EmojiTypeComparator */
/* unused harmony export UsageFrequencyComparator */
/* unused harmony export QueryStringPositionMatchComparator */
/* unused harmony export OrderComparator */
/* unused harmony export AlphabeticalShortnameComparator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type_helpers__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(71);



/**
 * Create the default sort comparator to be used for the user queries against emoji
 *
 * @param query the query used in the search to be sorted. Any colons will be stripped from the query and it will be
 * converted to lowercase.
 * @param orderedIds the id of emoji ordered by how frequently they are used
 */
function createSearchEmojiComparator(query, orderedIds) {
    var textQuery = query
        ? query
            .replace(/:/g, '')
            .toLowerCase()
            .trim()
        : undefined;
    var comparators = [];
    if (query) {
        comparators.push(new AsciiMatchComparator(query));
    }
    // Add the comparators to the 'chain'. The order of adding each comparator is important to the sort that is applied by the
    // ChainedEmojiComparator. (Which is why you may see the same 'if' a few times.)
    if (textQuery) {
        comparators.push(new ExactShortNameMatchComparator(textQuery));
    }
    if (orderedIds && orderedIds.length) {
        comparators.push(new UsageFrequencyComparator(orderedIds));
    }
    if (textQuery) {
        comparators.push(new QueryStringPositionMatchComparator(textQuery, 'shortName'), new QueryStringPositionMatchComparator(textQuery, 'name'));
    }
    comparators.push(OrderComparator.Instance, AlphabeticalShortnameComparator.Instance);
    var comparator = new (ChainedEmojiComparator.bind.apply(ChainedEmojiComparator, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"]([void 0], comparators)))();
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
function createUsageOnlyEmojiComparator(orderedIds) {
    var comparator = new ChainedEmojiComparator(new UsageFrequencyComparator(orderedIds), new EmojiTypeComparator(), OrderComparator.Instance);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
/**
 * A combinator comparator that applies an ordered chained of sub-comparators. The first comparator that
 * returns a non-zero value stops the chain and causes that value to be returned. If a comparator returns a
 * zero then the next one in the chain is tried.
 *
 * If no comparators in the chain return a non-zero value then zero will be returned.
 */
var ChainedEmojiComparator = /** @class */ (function () {
    function ChainedEmojiComparator() {
        var comparators = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            comparators[_i] = arguments[_i];
        }
        this.chain = comparators;
    }
    ChainedEmojiComparator.prototype.compare = function (e1, e2) {
        for (var i = 0; i < this.chain.length; i++) {
            var result = this.chain[i].compare(e1, e2);
            if (result !== 0) {
                return result;
            }
        }
        return 0;
    };
    return ChainedEmojiComparator;
}());

/**
 * Orders two emoji such that if one of them has an ascii representation that exactly matches the query then it will
 * be ordered first.
 */
var AsciiMatchComparator = /** @class */ (function () {
    function AsciiMatchComparator(query) {
        this.query = query;
    }
    AsciiMatchComparator.prototype.compare = function (e1, e2) {
        var e1HasAscii = e1.ascii && e1.ascii.indexOf(this.query) !== -1;
        var e2HasAscii = e2.ascii && e2.ascii.indexOf(this.query) !== -1;
        if (e1HasAscii && !e2HasAscii) {
            return -1;
        }
        else if (!e1HasAscii && e2HasAscii) {
            return 1;
        }
        return 0;
    };
    return AsciiMatchComparator;
}());

/**
 * Orders two emoji such that the one who's shortname matches the query exactly comes first. If there are matching
 * shortnames then the type of emoji is taken into account with SITE emoji coming first.
 */
var ExactShortNameMatchComparator = /** @class */ (function () {
    function ExactShortNameMatchComparator(query) {
        this.colonQuery = ":" + query + ":";
        this.typeComparator = new EmojiTypeComparator(true);
    }
    ExactShortNameMatchComparator.prototype.compare = function (e1, e2) {
        if (e1.shortName === this.colonQuery && e2.shortName === this.colonQuery) {
            return this.typeComparator.compare(e1, e2);
        }
        else if (e1.shortName === this.colonQuery) {
            return -1;
        }
        else if (e2.shortName === this.colonQuery) {
            return 1;
        }
        return 0;
    };
    return ExactShortNameMatchComparator;
}());

/**
 * Orders two emoji based on their type, with the types being STANDARD, ATLASSIAN and SITE (in that order).
 * If the comparator is configured to 'reverse' then the order will be SITE, ATLASSIAN, STANDARD.
 *
 * Regardless of the reverse setting, an unknown type will always come last.
 */
var EmojiTypeComparator = /** @class */ (function () {
    function EmojiTypeComparator(reverse) {
        if (reverse) {
            this.typeToNumber = new Map([
                ['SITE', 0],
                ['ATLASSIAN', 1],
                ['STANDARD', 2],
            ]);
        }
        else {
            this.typeToNumber = new Map([
                ['STANDARD', 0],
                ['ATLASSIAN', 1],
                ['SITE', 2],
            ]);
        }
    }
    EmojiTypeComparator.prototype.compare = function (e1, e2) {
        return this.emojiTypeToOrdinal(e1) - this.emojiTypeToOrdinal(e2);
    };
    EmojiTypeComparator.prototype.emojiTypeToOrdinal = function (emoji) {
        var ordinal = this.typeToNumber.get(emoji.type);
        if (ordinal === undefined) {
            ordinal = 10;
        }
        return ordinal;
    };
    return EmojiTypeComparator;
}());

/**
 * Order two emoji such as the one which is more frequently used comes first. If neither have any usage
 * information then leave their order unchanged.
 */
var UsageFrequencyComparator = /** @class */ (function () {
    function UsageFrequencyComparator(orderedIds) {
        var _this = this;
        this.positionLookup = new Map();
        // Make ordering start from 1 to avoid having zero in the map (which is falsey)
        orderedIds.map(function (id, index) { return _this.positionLookup.set(id, index + 1); });
    }
    UsageFrequencyComparator.prototype.compare = function (e1, e2) {
        if (!e1.id || !e2.id) {
            return 0; // this shouldn't occur. Leave position unchanged if there is any missing id.
        }
        var i1 = this.getPositionInOrder(e1);
        var i2 = this.getPositionInOrder(e2);
        return i1 - i2;
    };
    /**
     * Get the ordinal representing the position of this emoji.
     *
     * @param id the id of the emoji
     */
    UsageFrequencyComparator.prototype.getPositionInOrder = function (emoji) {
        var id = emoji.id ? emoji.id : '0';
        if (Object(__WEBPACK_IMPORTED_MODULE_1__type_helpers__["g" /* isEmojiVariationDescription */])(emoji)) {
            id = emoji.baseId;
        }
        var position = this.positionLookup.get(id);
        if (position) {
            return position;
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* MAX_ORDINAL */];
        }
    };
    return UsageFrequencyComparator;
}());

/**
 * A comparator that will sort higher an emoji which matches the query string earliest in the indicated
 * property.
 */
var QueryStringPositionMatchComparator = /** @class */ (function () {
    /**
     * @param query the query to match
     * @param propertyToCompare the property of EmojiDescription to check for query within
     */
    function QueryStringPositionMatchComparator(query, propertyToCompare) {
        this.query = query;
        this.propertyName = propertyToCompare;
    }
    QueryStringPositionMatchComparator.prototype.compare = function (e1, e2) {
        var i1 = e1[this.propertyName]
            ? e1[this.propertyName].indexOf(this.query)
            : __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* MAX_ORDINAL */];
        var i2 = e2[this.propertyName]
            ? e2[this.propertyName].indexOf(this.query)
            : __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* MAX_ORDINAL */];
        i1 = i1 === -1 ? __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* MAX_ORDINAL */] : i1;
        i2 = i2 === -1 ? __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* MAX_ORDINAL */] : i2;
        return i1 - i2;
    };
    return QueryStringPositionMatchComparator;
}());

var OrderComparator = /** @class */ (function () {
    function OrderComparator() {
    }
    Object.defineProperty(OrderComparator, "Instance", {
        get: function () {
            return this.INSTANCE || (this.INSTANCE = new this());
        },
        enumerable: true,
        configurable: true
    });
    OrderComparator.prototype.compare = function (e1, e2) {
        var o1 = e1.order ? e1.order : __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* MAX_ORDINAL */];
        var o2 = e2.order ? e2.order : __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* MAX_ORDINAL */];
        return o1 - o2;
    };
    return OrderComparator;
}());

var AlphabeticalShortnameComparator = /** @class */ (function () {
    function AlphabeticalShortnameComparator() {
    }
    Object.defineProperty(AlphabeticalShortnameComparator, "Instance", {
        get: function () {
            return this.INSTANCE || (this.INSTANCE = new this());
        },
        enumerable: true,
        configurable: true
    });
    AlphabeticalShortnameComparator.prototype.compare = function (e1, e2) {
        return e1.shortName.localeCompare(e2.shortName);
    };
    return AlphabeticalShortnameComparator;
}());

//# sourceMappingURL=Comparators.js.map

/***/ }),
/* 2998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DuplicateLimitedQueue__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_logger__ = __webpack_require__(121);



/**
 * An extension to the DuplicateLimitedQueue that will initialise its contents from the
 * supplied Storage and will also update the storage for every new item enqueued.
 */
var StoredDuplicateLimitedQueue = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](StoredDuplicateLimitedQueue, _super);
    function StoredDuplicateLimitedQueue(options) {
        var _this = _super.call(this, options) || this;
        _this.storage = options.storage;
        _this.prefixedStorageKey = options.storagePrefix + "." + StoredDuplicateLimitedQueue.storageKey;
        _this.load();
        return _this;
    }
    /**
     * Enqueue the supplied item and also persist the new contents of the queue to storage.
     *
     * @param item the item to be enqueued
     */
    StoredDuplicateLimitedQueue.prototype.enqueue = function (item) {
        _super.prototype.enqueue.call(this, item);
        this.save();
    };
    /**
     * Exposed for storybook/testing purposes only. Clear the contents of the queue, and localStorage.
     */
    StoredDuplicateLimitedQueue.prototype.clear = function () {
        _super.prototype.clear.call(this);
        this.storage.removeItem(this.prefixedStorageKey);
    };
    /**
     * Initialise the queue contents from the configured Storage. If there is no data found in
     * storage then the queue will have no items added. Likewise, a failure to read or parse stored
     * data will be swallowed and no items are added to the queue.
     */
    StoredDuplicateLimitedQueue.prototype.load = function () {
        var itemsJson = this.storage.getItem(this.prefixedStorageKey);
        if (itemsJson !== null) {
            try {
                var items = JSON.parse(itemsJson);
                this.bulkEnqueue(items);
            }
            catch (e) {
                Object(__WEBPACK_IMPORTED_MODULE_2__util_logger__["a" /* default */])("Error parsing the queue stored as " + this.prefixedStorageKey + " key from storage", e);
            }
        }
    };
    /**
     * Save the current items in the queue, overwriting any previously stored queue.
     * Any failure in saving will be silently ignored with the likely outcome that any previous
     * saved items will remain unchanged in storage.
     */
    StoredDuplicateLimitedQueue.prototype.save = function () {
        var itemsJson = JSON.stringify(this.getItems());
        try {
            this.storage.setItem(this.prefixedStorageKey, itemsJson);
        }
        catch (e) {
            Object(__WEBPACK_IMPORTED_MODULE_2__util_logger__["a" /* default */])("Error saving the queued items as " + this.prefixedStorageKey, e);
        }
    };
    StoredDuplicateLimitedQueue.storageKey = 'lastUsed';
    return StoredDuplicateLimitedQueue;
}(__WEBPACK_IMPORTED_MODULE_1__DuplicateLimitedQueue__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (StoredDuplicateLimitedQueue);
//# sourceMappingURL=StoredDuplicateLimitedQueue.js.map

/***/ }),
/* 2999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tokenizerRegex; });
// \p{Han} => each chinese character is a separate token
// \p{L}+[\p{Mn}|']*\p{L} => consecutive letters, including non spacing mark and apostrophe are a single token
// const tokenizerRegex = new XRegExp("\\p{Han}|[\\p{L}|\\p{N}]+[\\p{Mn}|']*\\p{L}*", 'gi');
// Note: regex compiled to unicode charsets using @atlaskit/xregexp-transformer (packages/elements/xregexp-transformer). Refer to it if you need to compile it again.
var tokenizerRegex = new RegExp("[\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FEF\uF900-\uFA6D\uFA70-\uFAD9]|[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC|0-9\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F|']*[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*", 'gi');
//# sourceMappingURL=EmojiRepositoryRegex.js.map

/***/ }),
/* 3000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mediaProportionOfProgress */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type_helpers__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MediaEmojiCache__ = __webpack_require__(3001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EmojiUtils__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TokenManager__ = __webpack_require__(3003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_logger__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_media_core__ = __webpack_require__(325);








// Assume media is 95% of total upload time.
var mediaProportionOfProgress = 95 / 100;
var SiteEmojiResource = /** @class */ (function () {
    function SiteEmojiResource(siteServiceConfig, mediaApiToken) {
        var _this = this;
        this.postToEmojiService = function (upload, fileId) {
            var shortName = upload.shortName, name = upload.name;
            var width = upload.width, height = upload.height;
            var requestInit = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    shortName: shortName,
                    name: name,
                    width: width,
                    height: height,
                    fileId: fileId,
                }),
            };
            return __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */]
                .requestService(_this.siteServiceConfig, {
                requestInit: requestInit,
            })
                .then(function (response) {
                var emojis = response.emojis;
                if (emojis.length) {
                    var _a = emojis[0], altRepresentations = _a.altRepresentations, emoji = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["altRepresentations"]);
                    var response_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, emoji, { representation: Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["c" /* convertImageToMediaRepresentation */])(emoji.representation) });
                    var altRepresentation = Object(__WEBPACK_IMPORTED_MODULE_4__EmojiUtils__["c" /* getAltRepresentation */])(altRepresentations || {});
                    var imgAltRepresentation = altRepresentation
                        ? Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["c" /* convertImageToMediaRepresentation */])(altRepresentation)
                        : undefined;
                    return Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["a" /* buildEmojiDescriptionWithAltRepresentation */])(response_1, imgAltRepresentation);
                }
                throw new Error('No emoji returns from upload. Upload failed.');
            });
        };
        this.siteServiceConfig = siteServiceConfig;
        this.mediaApiToken = mediaApiToken;
        this.tokenManager = new __WEBPACK_IMPORTED_MODULE_5__TokenManager__["a" /* default */](siteServiceConfig);
        this.tokenManager.addToken('read', mediaApiToken);
        this.mediaEmojiCache = new __WEBPACK_IMPORTED_MODULE_3__MediaEmojiCache__["a" /* default */](this.tokenManager);
    }
    /**
     * Will load media emoji, returning a new EmojiDescription if, for example,
     * the URL has changed.
     */
    SiteEmojiResource.prototype.loadMediaEmoji = function (emoji, useAlt) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["j" /* isMediaEmoji */])(emoji)) {
            throw new Error('Only supported for media emoji');
        }
        return this.mediaEmojiCache.loadEmoji(emoji, useAlt);
    };
    SiteEmojiResource.prototype.optimisticRendering = function (emoji, useAlt) {
        var representation = useAlt
            ? emoji.altRepresentation
            : emoji.representation;
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["k" /* isMediaRepresentation */])(representation)) {
            throw new Error('Only supported for media emoji');
        }
        var mediaPath = representation.mediaPath;
        return this.mediaEmojiCache.optimisticRendering(mediaPath);
    };
    SiteEmojiResource.prototype.uploadEmoji = function (upload, progressCallback) {
        var _this = this;
        var startTime = Date.now();
        return this.tokenManager.getToken('upload').then(function (uploadToken) {
            var tokenLoadTime = Date.now() - startTime;
            Object(__WEBPACK_IMPORTED_MODULE_6__util_logger__["a" /* default */])('upload token load time', tokenLoadTime);
            return new Promise(function (resolve, reject) {
                var url = uploadToken.url, clientId = uploadToken.clientId, collectionName = uploadToken.collectionName;
                var context = __WEBPACK_IMPORTED_MODULE_7__atlaskit_media_core__["a" /* ContextFactory */].create({
                    authProvider: function () {
                        return Promise.resolve({
                            clientId: clientId,
                            token: uploadToken.jwt,
                            baseUrl: url,
                        });
                    },
                });
                var subscription = context.file
                    .upload({
                    content: upload.dataURL,
                    name: upload.filename,
                    collection: collectionName,
                })
                    .subscribe({
                    next: function (state) {
                        if (state.status === 'uploading' && progressCallback) {
                            progressCallback({
                                percent: state.progress * mediaProportionOfProgress,
                            });
                        }
                        else if (state.status === 'processing') {
                            subscription.unsubscribe();
                            var totalUploadTime = Date.now() - startTime;
                            var mediaUploadTime = totalUploadTime - tokenLoadTime;
                            Object(__WEBPACK_IMPORTED_MODULE_6__util_logger__["a" /* default */])('total upload / media upload times', totalUploadTime, mediaUploadTime);
                            _this.postToEmojiService(upload, state.id)
                                .then(function (emoji) {
                                resolve(emoji);
                            })
                                .catch(function (httpError) {
                                reject(httpError.reason || httpError);
                            });
                        }
                    },
                    error: function (error) {
                        reject(error);
                    },
                });
            });
        });
    };
    /**
     * Check if the MediaEmojiResource has been able to initialise an uploadToken. Retrieving an upload token
     * is asynchronous so the Promise will need to resolve before the state is known. If the token retrieval
     * completes with failure then the Promise will resolve to false.
     */
    SiteEmojiResource.prototype.hasUploadToken = function () {
        var tokenPromise = this.tokenManager.getToken('upload');
        return tokenPromise.then(function (token) {
            return token !== undefined;
        }, function () {
            return false;
        });
    };
    SiteEmojiResource.prototype.prepareForUpload = function () {
        // make sure a token is loaded from the emoji service if we don't have one
        // as future request to uploadEmoji will use this, this to preload it, as it
        // usually takes 1-2 seconds to generate
        this.tokenManager.getToken('upload');
    };
    SiteEmojiResource.prototype.findEmoji = function (emojiId) {
        var path = "../" + emojiId.id;
        return Object(__WEBPACK_IMPORTED_MODULE_4__EmojiUtils__["b" /* emojiRequest */])(this.siteServiceConfig, { path: path })
            .then(function (serviceResponse) {
            var response = Object(__WEBPACK_IMPORTED_MODULE_4__EmojiUtils__["a" /* denormaliseEmojiServiceResponse */])(serviceResponse);
            return response.emojis[0];
        })
            .catch(function (error) {
            Object(__WEBPACK_IMPORTED_MODULE_6__util_logger__["a" /* default */])('failed to load emoji', emojiId, error);
            return undefined;
        });
    };
    /**
     * Calls to site-scoped EmojiResource to delete emoji
     * @param emoji media emoji to delete
     * @returns Promise.resolve() if success and Promise.reject() for failure
     */
    SiteEmojiResource.prototype.deleteEmoji = function (emoji) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["j" /* isMediaEmoji */])(emoji) && !Object(__WEBPACK_IMPORTED_MODULE_2__type_helpers__["i" /* isLoadedMediaEmoji */])(emoji)) {
            return Promise.reject(false);
        }
        var path = "" + emoji.id;
        var requestInit = {
            method: 'DELETE',
        };
        return (__WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */]
            .requestService(this.siteServiceConfig, { path: path, requestInit: requestInit })
            // Successful delete on Promise.resolve
            .then(function () { return true; })
            // Unsuccessful delete on Promise.reject
            .catch(function () { return false; }));
    };
    return SiteEmojiResource;
}());
/* harmony default export */ __webpack_exports__["a"] = (SiteEmojiResource);
//# sourceMappingURL=SiteEmojiResource.js.map

/***/ }),
/* 3001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BrowserCacheStrategy */
/* unused harmony export MemoryCacheStrategy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type_helpers__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MediaImageLoader__ = __webpack_require__(3002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_logger__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lru_fast__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lru_fast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lru_fast__);




var getRequiredRepresentation = function (emoji, useAlt) {
    return useAlt ? emoji.altRepresentation : emoji.representation;
};
var isUnsupportedBrowser = function () {
    var isIE = /*@cc_on!@*/ false || !!document.documentMode; // Internet Explorer 6-11
    var isEdge = !isIE && !!window.StyleMedia; // Edge 20+
    return isIE || isEdge;
};
/**
 * For browsers that support caching for resources
 * regardless of originally supplied headers (basically everything but Firefox).
 */
var BrowserCacheStrategy = /** @class */ (function () {
    function BrowserCacheStrategy(mediaImageLoader) {
        this.cachedImageUrls = new Set();
        Object(__WEBPACK_IMPORTED_MODULE_2__util_logger__["a" /* default */])('BrowserCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
    }
    BrowserCacheStrategy.prototype.loadEmoji = function (emoji, useAlt) {
        var _this = this;
        var representation = getRequiredRepresentation(emoji, useAlt);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__type_helpers__["k" /* isMediaRepresentation */])(representation)) {
            return emoji;
        }
        var mediaPath = representation.mediaPath;
        if (this.cachedImageUrls.has(mediaPath)) {
            // Already cached
            return emoji;
        }
        return this.mediaImageLoader
            .loadMediaImage(mediaPath)
            .then(function () {
            // Media is loaded, can use original URL now, so just return original emoji
            _this.cachedImageUrls.add(mediaPath);
            return emoji;
        })
            .catch(function () {
            return undefined;
        });
    };
    BrowserCacheStrategy.prototype.optimisticRendering = function () {
        return true;
    };
    BrowserCacheStrategy.supported = function (mediaPath, mediaImageLoader) {
        // IE/Edge uses memory cache strategy else images can fail to load
        // from a clean cache/if they are downloaded from the service
        // TODO: fix as a part of FS-1592
        if (isUnsupportedBrowser()) {
            return Promise.resolve(false);
        }
        return mediaImageLoader
            .loadMediaImage(mediaPath)
            .then(function () {
            // Image should be cached in browser, if supported it should be accessible from the cache by an <img/>
            // Try to load without via image to confirm this support (this fails in Firefox)
            return new Promise(function (resolve) {
                var img = new Image();
                img.addEventListener('load', function () {
                    resolve(true);
                });
                img.addEventListener('error', function () {
                    resolve(false);
                });
                img.src = mediaPath;
            });
        })
            .catch(function () { return false; });
    };
    return BrowserCacheStrategy;
}());

var maxImageCached = 1000;
// Don't cache images large than this - dataUrl size in characters
var maxImageSize = 10000;
/**
 * For browsers that do no cache images without equivalent headers (e.g. Firefox).
 *
 * Images are cached in memory in a LRU cache. Images considered too large,
 * are not cached, but retrieved each time.
 *
 * Images are still cached by the browser, but loading in asynchronous with
 * small delay noticable to the end user.
 */
var MemoryCacheStrategy = /** @class */ (function () {
    function MemoryCacheStrategy(mediaImageLoader) {
        Object(__WEBPACK_IMPORTED_MODULE_2__util_logger__["a" /* default */])('MemoryCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
        this.dataURLCache = new __WEBPACK_IMPORTED_MODULE_3_lru_fast__["LRUCache"](maxImageCached);
    }
    MemoryCacheStrategy.prototype.loadEmoji = function (emoji, useAlt) {
        var _this = this;
        var representation = getRequiredRepresentation(emoji, useAlt);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__type_helpers__["k" /* isMediaRepresentation */])(representation)) {
            return emoji;
        }
        var mediaPath = representation.mediaPath;
        var dataURL = this.dataURLCache.get(mediaPath);
        if (dataURL) {
            // Already cached
            return Object(__WEBPACK_IMPORTED_MODULE_0__type_helpers__["d" /* convertMediaToImageEmoji */])(emoji, dataURL, useAlt);
        }
        // Not cached, load
        return this.mediaImageLoader
            .loadMediaImage(mediaPath)
            .then(function (dataURL) {
            var loadedEmoji = Object(__WEBPACK_IMPORTED_MODULE_0__type_helpers__["d" /* convertMediaToImageEmoji */])(emoji, dataURL, useAlt);
            if (dataURL.length <= maxImageSize) {
                // Only cache if not large than max size
                _this.dataURLCache.put(mediaPath, dataURL);
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_2__util_logger__["a" /* default */])('No caching as image is too large', dataURL.length, dataURL.slice(0, 15), emoji.shortName);
            }
            return loadedEmoji;
        })
            .catch(function () {
            return undefined;
        });
    };
    MemoryCacheStrategy.prototype.optimisticRendering = function () {
        return false;
    };
    return MemoryCacheStrategy;
}());

/**
 * Provides a cache for Media Emoji.
 *
 * Emoji are returned immediately if cached and ready to use by the browser.
 *
 * Otherwise, they are loaded and returned via a promise.
 */
var MediaEmojiCache = /** @class */ (function () {
    function MediaEmojiCache(tokenManager) {
        this.waitingInitUrls = [];
        Object(__WEBPACK_IMPORTED_MODULE_2__util_logger__["a" /* default */])('MediaEmojiCache');
        this.mediaImageLoader = new __WEBPACK_IMPORTED_MODULE_1__MediaImageLoader__["a" /* default */](tokenManager);
    }
    MediaEmojiCache.prototype.loadEmoji = function (emoji, useAlt) {
        var representation = getRequiredRepresentation(emoji, useAlt);
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__type_helpers__["k" /* isMediaRepresentation */])(representation)) {
            return emoji;
        }
        var mediaPath = representation.mediaPath;
        var emojiCache = this.getCache(mediaPath);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__type_helpers__["l" /* isPromise */])(emojiCache)) {
            // Promise based
            return emojiCache
                .then(function (cache) { return cache.loadEmoji(emoji, useAlt); })
                .catch(function () { return undefined; });
        }
        return emojiCache.loadEmoji(emoji, useAlt);
    };
    MediaEmojiCache.prototype.optimisticRendering = function (url) {
        var emojiCache = this.getCache(url);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__type_helpers__["l" /* isPromise */])(emojiCache)) {
            // Promise based
            return emojiCache
                .then(function (cache) { return cache.optimisticRendering(); })
                .catch(function () { return false; });
        }
        return emojiCache.optimisticRendering();
    };
    MediaEmojiCache.prototype.getCache = function (url) {
        var _this = this;
        if (this.cache) {
            return this.cache;
        }
        this.waitingInitUrls.push(url);
        if (!this.cacheLoading) {
            this.cacheLoading = this.initCache()
                .then(function (cache) {
                _this.cache = cache;
                _this.cacheLoading = undefined;
                return cache;
            })
                .catch(function (err) {
                _this.cacheLoading = undefined;
                throw err;
            });
        }
        return this.cacheLoading;
    };
    MediaEmojiCache.prototype.initCache = function () {
        var _this = this;
        var url = this.waitingInitUrls.pop();
        if (!url) {
            return Promise.reject('Unable to initialise cache based on provided url(s)');
        }
        return BrowserCacheStrategy.supported(url, this.mediaImageLoader)
            .then(function (supported) {
            _this.waitingInitUrls = []; // clear
            _this.cacheLoading = undefined;
            if (supported) {
                return new BrowserCacheStrategy(_this.mediaImageLoader);
            }
            return new MemoryCacheStrategy(_this.mediaImageLoader);
        })
            .catch(function () {
            return _this.initCache();
        });
    };
    return MediaEmojiCache;
}());
/* harmony default export */ __webpack_exports__["a"] = (MediaEmojiCache);
//# sourceMappingURL=MediaEmojiCache.js.map

/***/ }),
/* 3002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_image__ = __webpack_require__(1408);

var defaultConcurrentDownloadLimit = 16;
var MediaImageLoader = /** @class */ (function () {
    function MediaImageLoader(tokenManager, options) {
        this.mediaImageQueue = [];
        this.activeProcessing = 0;
        this.pendingRequests = new Map();
        this.concurrentDownloadLimit =
            (options && options.concurrentDownloadLimit) ||
                defaultConcurrentDownloadLimit;
        this.tokenManager = tokenManager;
    }
    MediaImageLoader.prototype.loadMediaImage = function (url) {
        var _this = this;
        var maybePending = this.pendingRequests.get(url);
        if (maybePending !== undefined) {
            return maybePending;
        }
        var pending = new Promise(function (resolve, reject) {
            _this.mediaImageQueue.push({
                url: url,
                resolve: resolve,
                reject: reject,
            });
            _this.processFromQueue();
        })
            .then(function (result) {
            _this.pendingRequests.delete(url);
            return result;
        })
            .catch(function (error) {
            _this.pendingRequests.delete(url);
            throw error;
        });
        this.pendingRequests.set(url, pending);
        return pending;
    };
    MediaImageLoader.prototype.getQueueSize = function () {
        return this.mediaImageQueue.length;
    };
    MediaImageLoader.prototype.getActiveDownloads = function () {
        return this.activeProcessing;
    };
    MediaImageLoader.prototype.processFromQueue = function () {
        var _this = this;
        var _loop_1 = function () {
            this_1.activeProcessing++;
            var item = this_1.mediaImageQueue.shift();
            var url = item.url, resolve = item.resolve, reject = item.reject;
            this_1.tokenManager
                .getToken('read', false)
                .then(function (token) {
                _this.requestMediaEmoji(url, token, true)
                    .then(function (dataURL) {
                    resolve(dataURL);
                    _this.completedItem();
                })
                    .catch(function (error) {
                    reject(error);
                    _this.completedItem();
                });
            })
                .catch(function (error) {
                // Failed to load, just resolve to original emoji
                reject(error);
                _this.completedItem();
            });
        };
        var this_1 = this;
        while (this.activeProcessing < this.concurrentDownloadLimit &&
            this.mediaImageQueue.length > 0) {
            _loop_1();
        }
    };
    MediaImageLoader.prototype.completedItem = function () {
        this.activeProcessing--;
        this.processFromQueue();
    };
    MediaImageLoader.prototype.requestMediaEmoji = function (url, token, retryOnAuthError) {
        var _this = this;
        return Object(__WEBPACK_IMPORTED_MODULE_0__util_image__["c" /* imageAcceptHeader */])().then(function (acceptHeader) {
            // Media REST API: https://media-api-internal.atlassian.io/api.html#file__fileId__image_get
            var options = {
                headers: {
                    Authorization: "Bearer " + token.jwt,
                    'X-Client-Id': token.clientId,
                    Accept: acceptHeader,
                },
            };
            return fetch(url, options).then(function (response) {
                if (response.status === 403 && retryOnAuthError) {
                    // retry once if 403
                    return _this.tokenManager
                        .getToken('read', true)
                        .then(function (newToken) { return _this.requestMediaEmoji(url, newToken, false); });
                }
                else if (response.ok) {
                    return response.blob().then(function (blob) { return _this.readBlob(blob); });
                }
                throw new Error("Unable to load media image. Status=" + response.status + " " + response.statusText);
            });
        });
    };
    MediaImageLoader.prototype.readBlob = function (blob) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            // TODO: [ts30] Add proper handling for null and ArrayBuffer
            reader.addEventListener('load', function () { return resolve(reader.result); });
            reader.addEventListener('error', function () { return reject(reader.error); });
            reader.readAsDataURL(blob);
        });
    };
    return MediaImageLoader;
}());
/* harmony default export */ __webpack_exports__["a"] = (MediaImageLoader);
//# sourceMappingURL=MediaImageLoader.js.map

/***/ }),
/* 3003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export expireAdjustment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_util_service_support__ = __webpack_require__(41);

// expire 30 seconds early to factor in latency, slow services, etc
var expireAdjustment = 30;
var TokenManager = /** @class */ (function () {
    function TokenManager(siteServiceConfig) {
        this.siteServiceConfig = siteServiceConfig;
        this.tokens = new Map();
    }
    TokenManager.prototype.addToken = function (type, mediaApiToken) {
        this.tokens.set(type, {
            mediaApiToken: mediaApiToken,
        });
    };
    TokenManager.prototype.getToken = function (type, forceRefresh) {
        var tokenDetail = this.tokens.get(type);
        if (!tokenDetail) {
            tokenDetail = {};
            this.tokens.set(type, tokenDetail);
        }
        var mediaApiToken = tokenDetail.mediaApiToken, activeTokenRefresh = tokenDetail.activeTokenRefresh;
        if (mediaApiToken) {
            var nowInSeconds = Date.now() / 1000;
            var expiresAt = mediaApiToken.expiresAt - expireAdjustment;
            if (nowInSeconds < expiresAt && !forceRefresh) {
                // still valid
                return Promise.resolve(mediaApiToken);
            }
            if (activeTokenRefresh) {
                // refresh already active, return that
                return activeTokenRefresh;
            }
            // clear expired token
            tokenDetail.mediaApiToken = undefined;
        }
        var path = "token/" + type;
        // request a new token and track the promise for future requests until completed
        tokenDetail.activeTokenRefresh = __WEBPACK_IMPORTED_MODULE_0__atlaskit_util_service_support__["b" /* utils */]
            .requestService(this.siteServiceConfig, { path: path })
            .then(function (mediaApiToken) {
            tokenDetail.activeTokenRefresh = undefined;
            tokenDetail.mediaApiToken = mediaApiToken;
            return mediaApiToken;
        });
        return tokenDetail.activeTokenRefresh;
    };
    return TokenManager;
}());
/* harmony default export */ __webpack_exports__["a"] = (TokenManager);
//# sourceMappingURL=TokenManager.js.map

/***/ }),
/* 3004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_LoadingEmojiComponent__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Popup__ = __webpack_require__(3005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_logger__ = __webpack_require__(121);





var emojiTypeAheadModuleLoader = function () {
    return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 3478));
};
var emojiTypeAheadComponentLoader = function () { return emojiTypeAheadModuleLoader().then(function (module) { return module.default; }); };
var EmojiTypeahead = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmojiTypeahead, _super);
    function EmojiTypeahead(props) {
        var _this = _super.call(this, props, {}) || this;
        _this.state = {
            asyncLoadedComponent: EmojiTypeahead.AsyncLoadedComponent,
        };
        _this.selectNext = function () {
            if (_this.refs.typeAhead) {
                _this.refs.typeAhead.selectNext();
            }
        };
        _this.selectPrevious = function () {
            if (_this.refs.typeAhead) {
                _this.refs.typeAhead.selectPrevious();
            }
        };
        _this.chooseCurrentSelection = function () {
            if (_this.refs.typeAhead) {
                _this.refs.typeAhead.chooseCurrentSelection();
            }
        };
        _this.count = function () {
            if (_this.refs.typeAhead) {
                return _this.refs.typeAhead.count();
            }
            return 0;
        };
        return _this;
    }
    EmojiTypeahead.prototype.asyncLoadComponent = function () {
        var _this = this;
        emojiTypeAheadComponentLoader().then(function (component) {
            EmojiTypeahead.AsyncLoadedComponent = component;
            _this.setAsyncState(component);
        });
    };
    EmojiTypeahead.prototype.renderLoaded = function (loadedEmojiProvider, EmojiTypeAheadComponent) {
        var _a = this.props, emojiProvider = _a.emojiProvider, target = _a.target, position = _a.position, zIndex = _a.zIndex, offsetX = _a.offsetX, offsetY = _a.offsetY, otherProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["emojiProvider", "target", "position", "zIndex", "offsetX", "offsetY"]);
        var typeAhead = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](EmojiTypeAheadComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, otherProps, { emojiProvider: loadedEmojiProvider, ref: "typeAhead" })));
        if (position) {
            Object(__WEBPACK_IMPORTED_MODULE_4__util_logger__["a" /* default */])('target, position', target, position);
            if (target) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Popup__["a" /* default */], { target: target, relativePosition: position, zIndex: zIndex, offsetX: offsetX, offsetY: offsetY, children: typeAhead }));
            }
            // don't show if we have a position, but no target yet
            return null;
        }
        return typeAhead;
    };
    return EmojiTypeahead;
}(__WEBPACK_IMPORTED_MODULE_2__common_LoadingEmojiComponent__["a" /* default */]));
/* unused harmony default export */ var _unused_webpack_default_export = (EmojiTypeahead);
//# sourceMappingURL=EmojiTypeAhead.js.map

/***/ }),
/* 3005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);




var getTargetNode = function (target) {
    if (typeof target === 'string') {
        return document.querySelector(target);
    }
    // Expect to be an element
    return target;
};
/*
 * Simple implementation of popup while waiting for ak-inline-dialog
 */
var Popup = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Popup, _super);
    function Popup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.debounced = null;
        _this.handleResize = function () {
            if (_this.debounced) {
                clearTimeout(_this.debounced);
                _this.debounced = null;
            }
            // Timeout set to 30ms as to not throttle IE11
            _this.debounced = window.setTimeout(function () {
                _this.applyAbsolutePosition();
                _this.debounced = null;
            }, 30);
        };
        return _this;
    }
    Popup.prototype.componentDidMount = function () {
        this.popup = document.createElement('div');
        document.body.appendChild(this.popup);
        this.popup.style.position = 'absolute';
        window.addEventListener('resize', this.handleResize);
        this.applyAbsolutePosition();
        this.renderContent();
    };
    Popup.prototype.componentDidUpdate = function () {
        this.applyAbsolutePosition();
        this.renderContent();
    };
    Popup.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleResize);
        __WEBPACK_IMPORTED_MODULE_2_react_dom__["unmountComponentAtNode"](this.popup);
        document.body.removeChild(this.popup);
    };
    // Internal
    Popup.prototype.applyBelowPosition = function () {
        var targetNode = getTargetNode(this.props.target);
        if (targetNode) {
            var box = targetNode.getBoundingClientRect();
            var top_1 = box.bottom + (this.props.offsetY || 0);
            var left = box.left + (this.props.offsetX || 0);
            this.popup.style.top = top_1 + "px";
            this.popup.style.bottom = '';
            this.popup.style.left = left + "px";
        }
    };
    Popup.prototype.applyAbovePosition = function () {
        var targetNode = getTargetNode(this.props.target);
        if (targetNode) {
            var box = targetNode.getBoundingClientRect();
            var bottom = window.innerHeight - box.top + (this.props.offsetY || 0);
            var left = box.left + (this.props.offsetX || 0);
            this.popup.style.top = '';
            this.popup.style.bottom = bottom + "px";
            this.popup.style.left = left + "px";
        }
    };
    Popup.prototype.applyAbsolutePosition = function () {
        if (this.props.relativePosition === 'above') {
            this.applyAbovePosition();
        }
        else if (this.props.relativePosition === 'below') {
            this.applyBelowPosition();
        }
        else {
            var targetNode = getTargetNode(this.props.target);
            if (targetNode) {
                var box = targetNode.getBoundingClientRect();
                var viewPortHeight = window.innerHeight;
                if (box.top < viewPortHeight / 2) {
                    this.applyBelowPosition();
                }
                else {
                    this.applyAbovePosition();
                }
            }
        }
        if (this.props.zIndex) {
            this.popup.style.zIndex = "" + this.props.zIndex;
        }
    };
    Popup.prototype.renderContent = function () {
        __WEBPACK_IMPORTED_MODULE_2_react_dom__["render"](this.props.children, this.popup);
    };
    Popup.prototype.render = function () {
        // inline placeholder element for react to render inplace
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null);
    };
    Popup.defaultProps = {
        relativePosition: 'auto',
        offsetX: 0,
        offsetY: 0,
        zIndex: 0,
    };
    return Popup;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Popup);
//# sourceMappingURL=Popup.js.map

/***/ }),
/* 3006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WithProviders; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var WithProviders = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](WithProviders, _super);
    function WithProviders(props) {
        var _this = _super.call(this, props) || this;
        _this.handleProvider = function (name, provider) {
            _this.setState(function (_a) {
                var providers = _a.providers;
                var _b;
                return {
                    providers: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, providers, (_b = {}, _b[name] = provider, _b)),
                };
            });
        };
        var providers = {};
        _this.props.providers.forEach(function (name) {
            providers[name] = undefined;
        });
        _this.state = {
            providers: providers,
        };
        return _this;
    }
    WithProviders.prototype.componentWillMount = function () {
        var _this = this;
        var _a = this.props, providers = _a.providers, providerFactory = _a.providerFactory;
        providers.forEach(function (name) {
            providerFactory.subscribe(name, _this.handleProvider);
        });
    };
    WithProviders.prototype.componentWillUnmount = function () {
        var _this = this;
        var _a = this.props, providers = _a.providers, providerFactory = _a.providerFactory;
        providers.forEach(function (name) {
            providerFactory.unsubscribe(name, _this.handleProvider);
        });
    };
    WithProviders.prototype.render = function () {
        var _a = this, state = _a.state, props = _a.props;
        var renderNode = props.renderNode;
        return renderNode(state.providers);
    };
    return WithProviders;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

//# sourceMappingURL=withProviders.js.map

/***/ }),
/* 3007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MediaSingle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styled__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__grid__ = __webpack_require__(924);




function MediaSingle(_a) {
    var children = _a.children, layout = _a.layout, width = _a.width, height = _a.height, _b = _a.containerWidth, containerWidth = _b === void 0 ? width : _b, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c, pctWidth = _a.pctWidth, lineLength = _a.lineLength, className = _a.className;
    var usePctWidth = pctWidth && Object(__WEBPACK_IMPORTED_MODULE_3__grid__["b" /* layoutSupportsWidth */])(layout);
    if (pctWidth && usePctWidth) {
        var pxWidth = Math.ceil(Object(__WEBPACK_IMPORTED_MODULE_3__grid__["a" /* calcPxFromPct */])(pctWidth / 100, lineLength || containerWidth));
        // scale, keeping aspect ratio
        height = (height / width) * pxWidth;
        width = pxWidth;
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styled__["a" /* default */], { layout: layout, width: width, height: height, containerWidth: containerWidth, pctWidth: pctWidth, className: __WEBPACK_IMPORTED_MODULE_2_classnames__('media-single', "image-" + layout, className, {
            'is-loading': isLoading,
            'media-wrapped': layout === 'wrap-left' || layout === 'wrap-right',
        }) }, __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children)));
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 3008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mention_with_providers__ = __webpack_require__(3009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__providerFactory__ = __webpack_require__(481);





var Mention = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Mention, _super);
    function Mention(props) {
        var _this = _super.call(this, props) || this;
        _this.renderWithProvider = function (providers) {
            var _a = _this.props, accessLevel = _a.accessLevel, eventHandlers = _a.eventHandlers, id = _a.id, portal = _a.portal, text = _a.text;
            var mentionProvider = providers.mentionProvider, profilecardProvider = providers.profilecardProvider;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__mention_with_providers__["a" /* default */], { id: id, text: text, accessLevel: accessLevel, eventHandlers: eventHandlers, mentionProvider: mentionProvider, profilecardProvider: profilecardProvider, portal: portal }));
        };
        _this.providerFactory = props.providers || new __WEBPACK_IMPORTED_MODULE_3__providerFactory__["b" /* default */]();
        return _this;
    }
    Mention.prototype.componentWillUnmount = function () {
        if (!this.props.providers) {
            // new ProviderFactory is created if no `providers` has been set
            // in this case when component is unmounted it's safe to destroy this providerFactory
            this.providerFactory.destroy();
        }
    };
    Mention.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__providerFactory__["a" /* WithProviders */], { providers: ['mentionProvider', 'profilecardProvider'], providerFactory: this.providerFactory, renderNode: this.renderWithProvider }));
    };
    return Mention;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Mention);
//# sourceMappingURL=index.js.map

/***/ }),
/* 3009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_mention__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mention_with_profilecard__ = __webpack_require__(3027);





var GENERIC_USER_IDS = ['HipChat', 'all', 'here'];
var noop = function () { };
var MentionWithProviders = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionWithProviders, _super);
    function MentionWithProviders() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { profilecardProvider: null };
        return _this;
    }
    MentionWithProviders.prototype.componentWillMount = function () {
        this.updateProfilecardProvider(this.props);
    };
    MentionWithProviders.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.profilecardProvider !== this.props.profilecardProvider) {
            this.updateProfilecardProvider(nextProps);
        }
    };
    MentionWithProviders.prototype.updateProfilecardProvider = function (props) {
        var _this = this;
        // We are not using async/await here to avoid having an intermediate Promise
        // introduced by the transpiler.
        // This will allow consumer to use a SynchronousPromise.resolve and avoid useless
        // rerendering
        if (props.profilecardProvider) {
            props.profilecardProvider
                .then(function (profilecardProvider) {
                _this.setState({ profilecardProvider: profilecardProvider });
            })
                .catch(function (err) {
                _this.setState({ profilecardProvider: null });
            });
        }
        else {
            this.setState({ profilecardProvider: null });
        }
    };
    MentionWithProviders.prototype.render = function () {
        var _a = this.props, accessLevel = _a.accessLevel, userType = _a.userType, eventHandlers = _a.eventHandlers, id = _a.id, mentionProvider = _a.mentionProvider, portal = _a.portal, text = _a.text;
        var profilecardProvider = this.state.profilecardProvider;
        var actionHandlers = {};
        ['onClick', 'onMouseEnter', 'onMouseLeave'].forEach(function (handler) {
            actionHandlers[handler] =
                (eventHandlers && eventHandlers[handler]) || noop;
        });
        // tslint:disable-next-line:variable-name
        var MentionComponent = profilecardProvider && GENERIC_USER_IDS.indexOf(id) === -1
            ? __WEBPACK_IMPORTED_MODULE_3__mention_with_profilecard__["a" /* default */]
            : __WEBPACK_IMPORTED_MODULE_2__atlaskit_mention__["a" /* ResourcedMention */];
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MentionComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ id: id, text: text, accessLevel: accessLevel, userType: userType, mentionProvider: mentionProvider, profilecardProvider: profilecardProvider, portal: portal }, actionHandlers)));
    };
    return MentionWithProviders;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (MentionWithProviders);
//# sourceMappingURL=mention-with-providers.js.map

/***/ }),
/* 3010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DefaultPresenceCache */
/* unused harmony export DefaultPresenceParser */
/* unused harmony export AbstractPresenceResource */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_logger__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MentionResource__ = __webpack_require__(926);



var CacheEntry = /** @class */ (function () {
    function CacheEntry(pres, timeout) {
        this.presence = pres;
        this.expiry = Date.now() + timeout;
    }
    CacheEntry.prototype.expired = function () {
        return Date.now() > this.expiry;
    };
    return CacheEntry;
}());
var AbstractPresenceResource = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AbstractPresenceResource, _super);
    function AbstractPresenceResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AbstractPresenceResource.prototype.refreshPresence = function (userIds) {
        throw new Error("not yet implemented.\nParams: userIds=" + userIds);
    };
    AbstractPresenceResource.prototype.notifyListeners = function (presences) {
        this.changeListeners.forEach(function (listener, key) {
            try {
                listener(presences);
            }
            catch (e) {
                // ignore error from listener
                Object(__WEBPACK_IMPORTED_MODULE_1__util_logger__["a" /* default */])("error from listener '" + key + "', ignoring", e);
            }
        });
    };
    return AbstractPresenceResource;
}(__WEBPACK_IMPORTED_MODULE_2__MentionResource__["a" /* AbstractResource */]));
var PresenceResource = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](PresenceResource, _super);
    function PresenceResource(config) {
        var _this = _super.call(this) || this;
        if (!config.url) {
            throw new Error('config.url is a required parameter');
        }
        if (!config.cloudId) {
            throw new Error('config.cloudId is a required parameter');
        }
        _this.config = config;
        _this.config.url = PresenceResource.cleanUrl(config.url);
        _this.presenceCache =
            config.cache || new DefaultPresenceCache(config.cacheExpiry);
        _this.presenceParser = config.parser || new DefaultPresenceParser();
        return _this;
    }
    PresenceResource.prototype.refreshPresence = function (userIds) {
        var cacheHits = this.presenceCache.getBulk(userIds);
        this.notifyListeners(cacheHits);
        var cacheMisses = this.presenceCache.getMissingUserIds(userIds);
        if (cacheMisses.length) {
            this.retrievePresence(cacheMisses);
        }
    };
    PresenceResource.prototype.retrievePresence = function (userIds) {
        var _this = this;
        this.queryDirectoryForPresences(userIds)
            .then(function (res) { return _this.presenceParser.parse(res); })
            .then(function (presences) {
            _this.notifyListeners(presences);
            _this.presenceCache.update(presences);
        });
    };
    PresenceResource.prototype.queryDirectoryForPresences = function (userIds) {
        var data = {
            query: "query getPresenceForMentions($organizationId: String!, $userIds: [String!], $productId: String) {\n                PresenceBulk(organizationId: $organizationId, product: $productId, userIds: $userIds) {\n                  userId\n                  state\n                  stateMetadata\n                }\n              }",
            variables: {
                organizationId: this.config.cloudId,
                userIds: userIds,
            },
        };
        if (this.config.productId) {
            data.variables['productId'] = this.config.productId;
        }
        var options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(data),
        };
        return fetch(this.config.url, options).then(function (response) { return response.json(); });
    };
    PresenceResource.cleanUrl = function (url) {
        if (url.substr(-1) !== '/') {
            url += '/';
        }
        return url;
    };
    return PresenceResource;
}(AbstractPresenceResource));
var DefaultPresenceCache = /** @class */ (function () {
    function DefaultPresenceCache(cacheTimeout, cacheTrigger) {
        this.expiryInMillis = cacheTimeout
            ? cacheTimeout
            : DefaultPresenceCache.defaultTimeout;
        this.flushTrigger = cacheTrigger
            ? cacheTrigger
            : DefaultPresenceCache.defaultFlushTrigger;
        this.cache = {};
        this.size = 0;
    }
    /**
     * Precondition: _delete is only called internally if userId exists in cache
     * Removes cache entry
     * @param userId
     */
    DefaultPresenceCache.prototype._delete = function (userId) {
        delete this.cache[userId];
        this.size--;
    };
    /**
     * Checks a cache entry and calls delete if the info has expired
     * @param userId
     */
    DefaultPresenceCache.prototype._deleteIfExpired = function (userId) {
        if (this.contains(userId) && this.cache[userId].expired()) {
            this._delete(userId);
        }
    };
    /**
     * Cleans expired entries from cache
     */
    DefaultPresenceCache.prototype._removeExpired = function () {
        var _this = this;
        Object.keys(this.cache).forEach(function (id) {
            _this._deleteIfExpired(id);
        });
    };
    /**
     * Checks if a user exists in the cache
     * @param userId
     */
    DefaultPresenceCache.prototype.contains = function (userId) {
        return this.cache.hasOwnProperty(userId);
    };
    /**
     * Retrieves a presence from the cache after checking for expired entries
     * @param userId - to index the cache
     * @returns Presence - the presence that matches the userId
     */
    DefaultPresenceCache.prototype.get = function (userId) {
        this._deleteIfExpired(userId);
        if (!this.contains(userId)) {
            return {};
        }
        return this.cache[userId].presence;
    };
    /**
     * Retrieve multiple presences at once from the cache
     * @param userIds - to index the cache
     * @returns PresenceMap - A map of userIds to cached Presences
     */
    DefaultPresenceCache.prototype.getBulk = function (userIds) {
        var e_1, _a;
        var presences = {};
        try {
            for (var userIds_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](userIds), userIds_1_1 = userIds_1.next(); !userIds_1_1.done; userIds_1_1 = userIds_1.next()) {
                var userId = userIds_1_1.value;
                if (this.contains(userId)) {
                    presences[userId] = this.get(userId);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (userIds_1_1 && !userIds_1_1.done && (_a = userIds_1.return)) _a.call(userIds_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return presences;
    };
    /**
     * For a given list of ids, returns a subset
     * of all the ids with missing cache entries.
     * @param userIds - to index the cache
     * @returns string[] - ids missing from the cache
     */
    DefaultPresenceCache.prototype.getMissingUserIds = function (userIds) {
        var _this = this;
        return userIds.filter(function (id) { return !_this.contains(id); });
    };
    /**
     * Precondition: presMap only contains ids of users not in cache
     *               expired users must first be removed then reinserted with updated presence
     * Updates the cache by adding the new Presence entries and setting the expiry time
     * @param presMap
     */
    DefaultPresenceCache.prototype.update = function (presMap) {
        var _this = this;
        if (this.size >= this.flushTrigger) {
            this._removeExpired();
        }
        Object.keys(presMap).forEach(function (userId) {
            _this.cache[userId] = new CacheEntry(presMap[userId], _this.expiryInMillis);
            _this.size++;
        });
    };
    DefaultPresenceCache.defaultTimeout = 20000;
    DefaultPresenceCache.defaultFlushTrigger = 50;
    return DefaultPresenceCache;
}());

var DefaultPresenceParser = /** @class */ (function () {
    function DefaultPresenceParser() {
    }
    DefaultPresenceParser.prototype.mapState = function (state) {
        if (state === 'unavailable') {
            return 'offline';
        }
        else if (state === 'available') {
            return 'online';
        }
        else {
            return state;
        }
    };
    DefaultPresenceParser.prototype.parse = function (response) {
        var e_2, _a;
        var presences = {};
        if (response.hasOwnProperty('data') &&
            response['data'].hasOwnProperty('PresenceBulk')) {
            var results = response['data'].PresenceBulk;
            try {
                // Store map of state and time indexed by userId.  Ignore null results.
                for (var results_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__values"](results), results_1_1 = results_1.next(); !results_1_1.done; results_1_1 = results_1.next()) {
                    var user = results_1_1.value;
                    if (user.userId && user.state) {
                        var state = DefaultPresenceParser.extractState(user);
                        presences[user.userId] = {
                            status: this.mapState(state),
                        };
                    }
                    else if (!user.hasOwnProperty('userId') ||
                        !user.hasOwnProperty('state')) {
                        // tslint:disable-next-line:no-console
                        console.error('Unexpected response from presence service contains keys: ' +
                            Object.keys(user));
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (results_1_1 && !results_1_1.done && (_a = results_1.return)) _a.call(results_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        return presences;
    };
    DefaultPresenceParser.extractState = function (presence) {
        if (DefaultPresenceParser.isFocusState(presence)) {
            return DefaultPresenceParser.FOCUS_STATE;
        }
        return presence.state;
    };
    /*
      This is a bit of an odd exception. In the case where a user is in "Focus Mode", their presence state
      is returned as 'busy' along with a `stateMetadata` object containing a `focus` field.
      In this case we ignore the value of the `state` field and treat the presence as a 'focus' state.
     */
    DefaultPresenceParser.isFocusState = function (presence) {
        if (presence.stateMetadata) {
            try {
                var metadata = JSON.parse(presence.stateMetadata);
                return metadata && !!metadata.focus;
            }
            catch (e) {
                // tslint:disable-next-line:no-console
                console.error("Failed to parse presence's stateMetadata for user with id " + presence.userId + ": " + presence.stateMetadata);
                // tslint:disable-next-line:no-console
                console.error(e);
            }
        }
        return false;
    };
    DefaultPresenceParser.FOCUS_STATE = 'focus';
    return DefaultPresenceParser;
}());


/* unused harmony default export */ var _unused_webpack_default_export = (PresenceResource);
//# sourceMappingURL=PresenceResource.js.map

/***/ }),
/* 3011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(102));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var LockCircleIcon = function LockCircleIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill-rule=\"evenodd\"><circle fill=\"currentColor\" cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M12.02 8h-.04A1.98 1.98 0 0 0 10 9.98V11h1V9.99a.99.99 0 0 1 .99-.99h.02a.99.99 0 0 1 .99.99V11h1V9.98A1.98 1.98 0 0 0 12.02 8M10 11h1v1h-1zm3 0h1v1h-1zm0 1h-3a1 1 0 0 0-1 1v2.001a1 1 0 0 0 .991.999h4.018a.992.992 0 0 0 .991-.999V13a1 1 0 0 0-1-1h-1z\" fill=\"inherit\"/></g></svg>"
  }, props));
};

LockCircleIcon.displayName = 'LockCircleIcon';
var _default = LockCircleIcon;
exports.default = _default;

/***/ }),
/* 3012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RowStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AvatarStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NameSectionStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FullNameStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NicknameStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return InfoSectionStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TimeStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MentionItemStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccessSectionStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);



var RowStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  overflow: hidden;\n  padding: 6px 14px;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  overflow: hidden;\n  padding: 6px 14px;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n"])));
var AvatarStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  position: relative;\n  flex: initial;\n  opacity: ", ";\n"], ["\n  position: relative;\n  flex: initial;\n  opacity: ",
    ";\n"])), function (props) {
    return props.restricted ? '0.5' : 'inherit';
});
var NameSectionStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_3 || (templateObject_3 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  flex: 1;\n  min-width: 0;\n  margin-left: 14px;\n  opacity: ", ";\n"], ["\n  flex: 1;\n  min-width: 0;\n  margin-left: 14px;\n  opacity: ",
    ";\n"])), function (props) {
    return props.restricted ? '0.5' : 'inherit';
});
var FullNameStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_4 || (templateObject_4 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: ", ";\n"], ["\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N900);
var NicknameStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_5 || (templateObject_5 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  color: ", ";\n  font-size: 12px;\n\n  margin-top: 2px;\n\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  color: ", ";\n  font-size: 12px;\n\n  margin-top: 2px;\n\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N100);
var InfoSectionStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_6 || (templateObject_6 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: flex;\n  flex-direction: column;\n  text-align: right;\n  opacity: ", ";\n\n  & {\n    /* Lozenge */\n    & > span {\n      margin-bottom: 2px;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  text-align: right;\n  opacity: ",
    ";\n\n  & {\n    /* Lozenge */\n    & > span {\n      margin-bottom: 2px;\n    }\n  }\n"])), function (props) {
    return props.restricted ? '0.5' : 'inherit';
});
// tslint:disable:next-line variable-name
var TimeStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_7 || (templateObject_7 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin-left: 20px;\n  flex: none;\n  color: ", ";\n  font-size: 12px;\n"], ["\n  margin-left: 20px;\n  flex: none;\n  color: ", ";\n  font-size: 12px;\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N100);
var MentionItemStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_8 || (templateObject_8 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  background-color: ", ";\n  display: block;\n  overflow: hidden;\n  list-style-type: none;\n  height: 48px;\n  line-height: 1.2;\n  cursor: pointer;\n"], ["\n  background-color: ",
    ";\n  display: block;\n  overflow: hidden;\n  list-style-type: none;\n  height: 48px;\n  line-height: 1.2;\n  cursor: pointer;\n"])), function (props) {
    return props.selected ? __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30 : 'transparent';
});
var AccessSectionStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_9 || (templateObject_9 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  padding-left: 5px;\n  color: ", ";\n"], ["\n  padding-left: 5px;\n  color: ", ";\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N500);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 3013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return messages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(17);

var messages = Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["defineMessages"])({
    noAccessWarning: {
        id: 'fabric.mention.noAccess.warning',
        defaultMessage: "{name} won't be notified as they have no access",
        description: "Warning message to show that the mentioned user won't be notified",
    },
    noAccessLabel: {
        id: 'fabric.mention.noAccess.label',
        defaultMessage: 'No access',
        description: 'Label for no access icon',
    },
    defaultHeadline: {
        id: 'fabric.mention.error.defaultHeadline',
        defaultMessage: 'Something went wrong',
        description: 'Error message shown when there is an error communicating with backend',
    },
    defaultAdvisedAction: {
        id: 'fabric.mention.error.defaultAction',
        defaultMessage: 'Try again in a few seconds',
        description: 'Default advised action when an error occurs',
    },
    loginAgain: {
        id: 'fabric.mention.error.loginAgain',
        defaultMessage: 'Try logging out then in again',
        description: 'Login again message when there is an authentication error occurs',
    },
    differentText: {
        id: 'fabric.mention.error.differentText',
        defaultMessage: 'Try entering different text',
        description: 'Enter different text message when a forbidden error occurs',
    },
});
//# sourceMappingURL=i18n.js.map

/***/ }),
/* 3014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MentionListStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_styles__ = __webpack_require__(483);



var MentionListStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: ", ";\n\n  /* list style */\n  width: ", ";\n  color: #333;\n\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n"], ["\n  display: ",
    ";\n\n  /* list style */\n  width: ", ";\n  color: #333;\n\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n"])), function (props) {
    return props.empty ? 'none' : 'block';
}, __WEBPACK_IMPORTED_MODULE_2__shared_styles__["a" /* mentionListWidth */], __WEBPACK_IMPORTED_MODULE_2__shared_styles__["b" /* noDialogContainerBorderColor */], __WEBPACK_IMPORTED_MODULE_2__shared_styles__["c" /* noDialogContainerBorderRadius */], __WEBPACK_IMPORTED_MODULE_2__shared_styles__["d" /* noDialogContainerBoxShadow */]);
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 3015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GenericErrorIllustration__ = __webpack_require__(3016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_i18n__ = __webpack_require__(482);





var advisedActionMessages = {
    '401': __WEBPACK_IMPORTED_MODULE_4__util_i18n__["d" /* LoginAgain */],
    '403': __WEBPACK_IMPORTED_MODULE_4__util_i18n__["c" /* DifferentText */],
    default: __WEBPACK_IMPORTED_MODULE_4__util_i18n__["a" /* DefaultAdvisedAction */],
};
var MentionListError = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionListError, _super);
    function MentionListError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Translate the supplied Error into a message suitable for display in the MentionList.
     *
     * @param error the error to be displayed
     */
    MentionListError.getAdvisedActionMessage = function (error) {
        if (error && error.hasOwnProperty('statusCode')) {
            var httpError = error;
            return (advisedActionMessages[httpError.statusCode.toString()] ||
                advisedActionMessages.default);
        }
        return advisedActionMessages.default;
    };
    MentionListError.prototype.render = function () {
        var error = this.props.error;
        var ErrorMessage = MentionListError.getAdvisedActionMessage(error);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* MentionListErrorStyle */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__GenericErrorIllustration__["a" /* GenericErrorIllustration */], null),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* MentionListErrorHeadlineStyle */], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__util_i18n__["b" /* DefaultHeadline */], null)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* MentionListAdviceStyle */], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ErrorMessage, null))));
    };
    return MentionListError;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (MentionListError);
//# sourceMappingURL=index.js.map

/***/ }),
/* 3016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GenericErrorIllustration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(931);



var GenericErrorIllustration = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](GenericErrorIllustration, _super);
    function GenericErrorIllustration() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GenericErrorIllustration.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* GenericErrorVisualStyle */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 163.3 212", "aria-labelledby": "title" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("defs", null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("style", { dangerouslySetInnerHTML: {
                            __html: '.cls-1{fill:url(#linear-gradient);}.cls-2,.cls-5{opacity:0.6;}.cls-3{fill:#c1c7d0;}.cls-4{fill:#b3bac5;}.cls-5{isolation:isolate;}',
                        } }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("linearGradient", { id: "linear-gradient", x1: "25.54", y1: "806.64", x2: "137.75", y2: "694.44", gradientTransform: "translate(0 -578)", gradientUnits: "userSpaceOnUse" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("stop", { offset: 0, stopColor: "#c1c7d0" }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("stop", { offset: "0.24", stopColor: "#c4cad2", stopOpacity: "0.97" }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("stop", { offset: "0.5", stopColor: "#cdd1d9", stopOpacity: "0.89" }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("stop", { offset: "0.78", stopColor: "#dcdee4", stopOpacity: "0.75" }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("stop", { offset: 1, stopColor: "#ebecf0", stopOpacity: "0.6" }))),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("title", null, this.props.title ? this.props.title : 'Generic Error'),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { "data-name": "Layer 2" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { "data-name": "Layer 1-2" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { className: "cls-1", d: "M94.8,74.2l66.4,115.1a15.16,15.16,0,0,1-5.5,20.7,15.4,15.4,0,0,1-7.6,2H15.2A15.19,15.19,0,0,1,0,196.8a15.4,15.4,0,0,1,2-7.6l66.5-115a15.21,15.21,0,0,1,20.7-5.6A15.81,15.81,0,0,1,94.8,74.2Zm-7.6,83.5,2.9-44.3a9.26,9.26,0,0,0-8.6-9.8h-.6a9.18,9.18,0,0,0-9.2,9.2v.6l2.9,44.3a6.33,6.33,0,0,0,6.3,5.9h0A6.26,6.26,0,0,0,87.2,157.7ZM71.4,181.2a9.5,9.5,0,0,0,9.4,9.6h.9a9.79,9.79,0,0,0,8.8-10.5,9.69,9.69,0,0,0-9.7-8.8A9.58,9.58,0,0,0,71.4,181.2Z" }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { className: "cls-2" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { className: "cls-3", d: "M92.7,27.2,85.3.4a.57.57,0,0,0-.7-.4c-.2.1-.4.2-.4.5L79.5,25.6l-5.8-1.1c-.3-.1-.6.2-.7.5v.3L80.3,52a.75.75,0,0,0,.7.5.82.82,0,0,0,.5-.5l4.7-25.1,5.8,1c.3.1.6-.2.7-.5Z" }),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { className: "cls-3", d: "M66.1,41.8,55.2,33.2a.3.3,0,0,0-.4,0,.19.19,0,0,0,0,.3L60.4,45l-2.7,1.3c-.1.1-.2.2-.1.4a.1.1,0,0,0,.1.1l10.9,8.5a.3.3,0,0,0,.4,0,.19.19,0,0,0,0-.3L63.4,43.6l2.7-1.3a.33.33,0,0,0,0-.5Z" })),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { className: "cls-2" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { className: "cls-4", d: "M102.1,56.8a1.42,1.42,0,0,1-.6-.2,1,1,0,0,1-.3-1.2c-.2-.8-2.3-2.8-3.5-4.1-3-3-4.9-5-3.8-6.5s3.6-.2,7.3,1.7a28.41,28.41,0,0,0,4.5,2,21.58,21.58,0,0,0-3.3-3.6c-3-3-4.9-5-3.8-6.5s3.6-.2,7.4,1.7a27.65,27.65,0,0,0,4.4,2,21.58,21.58,0,0,0-3.3-3.6c-3-3-4.9-5-3.8-6.5s3.6-.2,7.3,1.7c1.6.8,4.2,2.1,5,2.1a.91.91,0,0,1,1.2,0,1.08,1.08,0,0,1,.2,1.4c-1.1,1.5-3.6.2-7.3-1.7a27.65,27.65,0,0,0-4.4-2,21.58,21.58,0,0,0,3.3,3.6c3,3,4.9,5,3.8,6.5s-3.6.2-7.3-1.7a28.41,28.41,0,0,0-4.5-2,21.58,21.58,0,0,0,3.3,3.6c3,3,4.9,5,3.8,6.5s-3.6.2-7.3-1.7a28.41,28.41,0,0,0-4.5-2,21.58,21.58,0,0,0,3.3,3.6c3,3,4.9,5,3.8,6.5A1.8,1.8,0,0,1,102.1,56.8Z" })),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { className: "cls-5" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { className: "cls-4", d: "M107.7,71.1a1.05,1.05,0,0,1-.9-.5c-1-1.9-2.2-4-.9-5.2s3.3.2,5.5,1.6a19.31,19.31,0,0,0,2.9,1.7,15.89,15.89,0,0,0-1.4-3.1c-1.3-2.3-2.5-4.4-1.1-5.6s3.3.2,5.5,1.6c1,.6,2.5,1.7,3.1,1.7a1,1,0,0,1,1.3.1,1,1,0,0,1-.1,1.4c-1.3,1.2-3.3-.2-5.5-1.6a19.31,19.31,0,0,0-2.9-1.7,13.64,13.64,0,0,0,1.4,3.1c1.3,2.3,2.4,4.4,1.1,5.6s-3.3-.2-5.5-1.6a19.31,19.31,0,0,0-2.9-1.7,13.07,13.07,0,0,0,1.2,2.7,1,1,0,0,1-.4,1.4A.6.6,0,0,1,107.7,71.1Zm12.5-7.6Z" })),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g", { className: "cls-5" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { className: "cls-4", d: "M53.4,68.1a2,2,0,0,1-.7-.1c-1.6-.7-1.2-3.1-.8-5.6a10.87,10.87,0,0,0,.3-3.4A15,15,0,0,0,50,61.6c-1.5,2.1-3,4.1-4.6,3.4a1,1,0,0,1-.5-1.3,1,1,0,0,1,1.2-.6,11.23,11.23,0,0,0,2.3-2.7c1.5-2.1,3-4.1,4.7-3.4s1.3,3.1.8,5.7a13.86,13.86,0,0,0-.3,3.3,11.82,11.82,0,0,0,2.1-2.6c1.5-2.1,3-4.1,4.7-3.4s1.2,3.1.9,5.2a1,1,0,1,1-1.9-.3,14.28,14.28,0,0,0,.3-2.9,15,15,0,0,0-2.2,2.6C56,66.4,54.7,68.1,53.4,68.1Z" })))))));
    };
    return GenericErrorIllustration;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

//# sourceMappingURL=GenericErrorIllustration.js.map

/***/ }),
/* 3017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(3018);




var Scrollable = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Scrollable, _super);
    function Scrollable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // API
        _this.reveal = function (child) {
            if (child && _this.scrollableDiv) {
                var childNode = Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(child);
                // Not using Element.scrollIntoView as it scrolls even to top/bottom of view even if
                // already visible
                var scrollableRect = _this.scrollableDiv.getBoundingClientRect();
                var elementRect = childNode.getBoundingClientRect();
                if (elementRect.top < scrollableRect.top) {
                    _this.scrollableDiv.scrollTop += elementRect.top - scrollableRect.top;
                }
                else if (elementRect.bottom > scrollableRect.bottom) {
                    _this.scrollableDiv.scrollTop +=
                        elementRect.bottom - scrollableRect.bottom;
                }
            }
        };
        _this.handleRef = function (ref) {
            _this.scrollableDiv = ref;
        };
        return _this;
    }
    Scrollable.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* ScrollableStyle */], { innerRef: this.handleRef }, this.props.children));
    };
    return Scrollable;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Scrollable);
//# sourceMappingURL=index.js.map

/***/ }),
/* 3018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollableStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_styles__ = __webpack_require__(483);




var ScrollableStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: block;\n  overflow-x: hidden;\n  overflow-y: auto;\n\n  padding: 4px 0;\n  margin: 0;\n\n  background: white;\n  max-height: ", ";\n\n  border-radius: ", "px;\n"], ["\n  display: block;\n  overflow-x: hidden;\n  overflow-y: auto;\n\n  padding: 4px 0;\n  margin: 0;\n\n  background: white;\n  max-height: ", ";\n\n  border-radius: ", "px;\n"])), __WEBPACK_IMPORTED_MODULE_3__shared_styles__["e" /* scrollableMaxHeight */], Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["borderRadius"])());
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 3019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MentionPicker */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MentionPickerWithAnalytics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(3020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResourcedMentionList__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Popup__ = __webpack_require__(3021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_logger__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_id__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_analytics__ = __webpack_require__(934);









/**
 * @class MentionPicker
 */
var MentionPicker = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionPicker, _super);
    function MentionPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.selectNext = function () {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectNext();
            }
        };
        _this.selectPrevious = function () {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectPrevious();
            }
        };
        _this.selectIndex = function (index, callback) {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectIndex(index, callback);
            }
        };
        _this.selectId = function (id, callback) {
            if (_this.mentionListRef) {
                _this.mentionListRef.selectId(id, callback);
            }
        };
        _this.chooseCurrentSelection = function () {
            if (_this.mentionListRef) {
                _this.mentionListRef.chooseCurrentSelection();
            }
        };
        _this.mentionsCount = function () {
            if (_this.mentionListRef) {
                return _this.mentionListRef.mentionsCount();
            }
            return 0;
        };
        /**
         * Called after the 'visible' state is changed to decide whether the onOpen or onClose
         * handlers should be called.
         *
         * It should be noted that the visible state of the component is not considered in
         * this function. Instead the old state and new state should be passed as parameters.
         */
        _this.onFilterVisibilityChange = function (oldVisibility, newVisibility) {
            if (oldVisibility !== newVisibility) {
                if (newVisibility) {
                    if (_this.props.onOpen) {
                        _this.props.onOpen();
                    }
                }
                else {
                    if (_this.props.onClose) {
                        _this.props.onClose();
                    }
                }
            }
        };
        // internal, used for callbacks
        _this.filterChange = function (mentions, query, stats) {
            Object(__WEBPACK_IMPORTED_MODULE_5__util_logger__["a" /* default */])('ak-mention-picker.filterChange', mentions.length);
            var wasVisible = _this.state.visible;
            var visible = mentions.length > 0;
            _this.setState({
                visible: visible,
            });
            _this.onFilterVisibilityChange(wasVisible, visible);
            __WEBPACK_IMPORTED_MODULE_8__util_analytics__["c" /* fireAnalyticsMentionTypeaheadEvent */](_this.props)('rendered', stats && stats.duration, mentions.map(function (mention) { return mention.id; }), query);
        };
        _this.filterError = function (error) {
            Object(__WEBPACK_IMPORTED_MODULE_5__util_logger__["a" /* default */])('ak-mention-picker.filterError', error);
            var wasVisible = _this.state.visible;
            _this.setState({
                visible: true,
                info: undefined,
            });
            _this.onFilterVisibilityChange(wasVisible, true);
        };
        _this.filterInfo = function (info) {
            Object(__WEBPACK_IMPORTED_MODULE_5__util_logger__["a" /* default */])('ak-mention-picker.filterInfo', info);
            _this.setState({
                info: info,
            });
        };
        _this.handleMentionListRef = function (ref) {
            _this.mentionListRef = ref;
        };
        _this.subscriberKey = Object(__WEBPACK_IMPORTED_MODULE_6__util_id__["a" /* default */])('ak-mention-picker');
        _this.state = {
            visible: false,
        };
        _this.applyPropChanges({}, props);
        return _this;
    }
    MentionPicker.prototype.componentDidMount = function () {
        this.subscribeResourceProvider(this.props.resourceProvider);
    };
    MentionPicker.prototype.componentWillReceiveProps = function (nextProps) {
        this.applyPropChanges(this.props, nextProps);
    };
    MentionPicker.prototype.componentWillUnmount = function () {
        this.unsubscribeResourceProvider(this.props.resourceProvider);
    };
    // Internal
    MentionPicker.prototype.applyPropChanges = function (prevProps, nextProps) {
        var oldResourceProvider = prevProps.resourceProvider;
        var newResourceProvider = nextProps.resourceProvider;
        var resourceProviderChanged = oldResourceProvider !== newResourceProvider;
        // resource provider
        if (resourceProviderChanged) {
            this.unsubscribeResourceProvider(oldResourceProvider);
            this.subscribeResourceProvider(newResourceProvider);
        }
    };
    MentionPicker.prototype.subscribeResourceProvider = function (resourceProvider) {
        if (resourceProvider) {
            resourceProvider.subscribe(this.subscriberKey, this.filterChange, this.filterError, this.filterInfo);
        }
    };
    MentionPicker.prototype.unsubscribeResourceProvider = function (resourceProvider) {
        if (resourceProvider) {
            resourceProvider.unsubscribe(this.subscriberKey);
        }
    };
    MentionPicker.prototype.render = function () {
        var _a = this.props, resourceProvider = _a.resourceProvider, presenceProvider = _a.presenceProvider, onSelection = _a.onSelection, query = _a.query, target = _a.target, position = _a.position, zIndex = _a.zIndex, offsetX = _a.offsetX, offsetY = _a.offsetY;
        var _b = this.state, visible = _b.visible, info = _b.info;
        var resourceMentionList = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ResourcedMentionList__["a" /* default */], { resourceProvider: resourceProvider, presenceProvider: presenceProvider, onSelection: onSelection, query: query, ref: this.handleMentionListRef }));
        var infoContent = info && !visible ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* MentionPickerInfoStyle */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", null, info))) : null;
        var content;
        if (position) {
            Object(__WEBPACK_IMPORTED_MODULE_5__util_logger__["a" /* default */])('target, position', target, position);
            if (target) {
                content = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Popup__["a" /* default */], { target: target, relativePosition: position, zIndex: zIndex, offsetX: offsetX, offsetY: offsetY },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                        resourceMentionList,
                        infoContent)));
            }
            else {
                // don't show if we have a position, but no target yet
                content = null;
            }
        }
        else {
            content = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                resourceMentionList,
                infoContent));
        }
        return (
        /* old classnames are essential for Confluence tests */
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* MentionPickerStyle */], { className: "ak-mention-picker", visible: visible || info }, content));
    };
    MentionPicker.defaultProps = {
        onSelection: function () { },
        onOpen: function () { },
        onClose: function () { },
    };
    return MentionPicker;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

var MentionPickerWithAnalytics = Object(__WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__["withAnalyticsEvents"])({})(MentionPicker);
/* unused harmony default export */ var _unused_webpack_default_export = (MentionPickerWithAnalytics);
//# sourceMappingURL=index.js.map

/***/ }),
/* 3020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MentionPickerStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MentionPickerInfoStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_styles__ = __webpack_require__(483);




var MentionPickerStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  display: ", ";\n"], ["\n  display: ",
    ";\n"])), function (props) {
    return props.visible ? 'block' : 'none';
});
var MentionPickerInfoStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  background: #fff;\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  display: block;\n  width: ", ";\n  white-space: nowrap;\n\n  & {\n    p {\n      margin: 0;\n      overflow: hidden;\n      padding: 9px;\n      text-overflow: ellipsis;\n    }\n  }\n"], ["\n  background: #fff;\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  display: block;\n  width: ", ";\n  white-space: nowrap;\n\n  & {\n    p {\n      margin: 0;\n      overflow: hidden;\n      padding: 9px;\n      text-overflow: ellipsis;\n    }\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N100, __WEBPACK_IMPORTED_MODULE_3__shared_styles__["b" /* noDialogContainerBorderColor */], __WEBPACK_IMPORTED_MODULE_3__shared_styles__["c" /* noDialogContainerBorderRadius */], __WEBPACK_IMPORTED_MODULE_3__shared_styles__["d" /* noDialogContainerBoxShadow */], __WEBPACK_IMPORTED_MODULE_3__shared_styles__["a" /* mentionListWidth */]);
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 3021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);



/*
 * Simple implementation of popup while waiting for ak-inline-dialog
 */
var Popup = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Popup, _super);
    function Popup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Popup.prototype.componentDidMount = function () {
        this.popup = document.createElement('div');
        document.body.appendChild(this.popup);
        this.popup.style.position = 'absolute';
        this._applyAbsolutePosition();
        this._renderContent();
    };
    Popup.prototype.componentDidUpdate = function () {
        this._renderContent();
    };
    Popup.prototype.componentWillUnmount = function () {
        __WEBPACK_IMPORTED_MODULE_2_react_dom__["unmountComponentAtNode"](this.popup);
        document.body.removeChild(this.popup);
    };
    Popup.prototype._applyBelowPosition = function () {
        var targetNode = this.props.target && document.getElementById(this.props.target);
        if (targetNode) {
            var box = targetNode.getBoundingClientRect();
            var top_1 = box.bottom + (this.props.offsetY || 0);
            var left = box.left + (this.props.offsetX || 0);
            this.popup.style.top = top_1 + "px";
            this.popup.style.bottom = '';
            this.popup.style.left = left + "px";
        }
    };
    Popup.prototype._applyAbovePosition = function () {
        var targetNode = this.props.target && document.getElementById(this.props.target);
        if (targetNode) {
            var box = targetNode.getBoundingClientRect();
            var bottom = window.innerHeight - box.top + (this.props.offsetY || 0);
            var left = box.left + (this.props.offsetX || 0);
            this.popup.style.top = '';
            this.popup.style.bottom = bottom + "px";
            this.popup.style.left = left + "px";
        }
    };
    Popup.prototype._applyAbsolutePosition = function () {
        if (this.props.relativePosition === 'above') {
            this._applyAbovePosition();
        }
        else if (this.props.relativePosition === 'below') {
            this._applyBelowPosition();
        }
        else {
            var targetNode = this.props.target && document.getElementById(this.props.target);
            if (targetNode) {
                var box = targetNode.getBoundingClientRect();
                var viewPortHeight = window.innerHeight;
                if (box.top < viewPortHeight / 2) {
                    this._applyBelowPosition();
                }
                else {
                    this._applyAbovePosition();
                }
            }
        }
        if (this.props.zIndex) {
            this.popup.style.zIndex = "" + this.props.zIndex;
        }
    };
    Popup.prototype._renderContent = function () {
        __WEBPACK_IMPORTED_MODULE_2_react_dom__["render"](this.props.children, this.popup);
    };
    Popup.prototype.render = function () {
        // Placeholder element for react to render inplace
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null);
    };
    Popup.defaultProps = {
        relativePosition: 'auto',
        offsetX: 0,
        offsetY: 0,
        zIndex: 0,
    };
    return Popup;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Popup);
//# sourceMappingURL=index.js.map

/***/ }),
/* 3022 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/mention","version":"16.0.0","sideEffects":false}

/***/ }),
/* 3023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MentionStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(170);




var mentionStyle = {};
mentionStyle[__WEBPACK_IMPORTED_MODULE_3__types__["a" /* MentionType */].SELF] = {
    background: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B400, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B200 }),
    border: 'transparent',
    text: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N20, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN30 }),
};
mentionStyle[__WEBPACK_IMPORTED_MODULE_3__types__["a" /* MentionType */].RESTRICTED] = {
    background: 'transparent',
    border: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N500, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN80 }),
    text: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N500, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN100 }),
};
mentionStyle[__WEBPACK_IMPORTED_MODULE_3__types__["a" /* MentionType */].DEFAULT] = {
    background: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N30A, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN80 }),
    border: 'transparent',
    text: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["themed"])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].N500, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].DN800 }),
};
var getStyle = function (props, property) {
    var obj = mentionStyle[props.mentionType][property];
    // themed() returns a function
    return typeof obj === 'string' ? obj : obj(props);
};
var MentionStyle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) { return "\n  display: inline;\n  background: " + getStyle(props, 'background') + ";\n  border: 1px solid " + getStyle(props, 'border') + ";\n  border-radius: 20px;\n  color: " + getStyle(props, 'text') + ";\n  cursor: pointer;\n  padding: 0 0.3em 2px 0.23em;\n  line-height: 1.714;\n  font-size: 1em;\n  font-weight: normal;\n  word-break: break-word;\n"; });
var templateObject_1;
//# sourceMappingURL=styles.js.map

/***/ }),
/* 3024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(936);



var ResourcedMention = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ResourcedMention, _super);
    function ResourcedMention(props) {
        var _this = _super.call(this, props) || this;
        _this.handleMentionProvider = function (props) {
            var id = props.id, mentionProvider = props.mentionProvider;
            if (mentionProvider) {
                mentionProvider
                    .then(function (provider) {
                    _this.setState({
                        isHighlighted: provider.shouldHighlightMention({ id: id }),
                    });
                })
                    .catch(function (e) {
                    _this.setState({
                        isHighlighted: false,
                    });
                });
            }
            else {
                _this.setState({
                    isHighlighted: false,
                });
            }
        };
        _this.state = {
            isHighlighted: false,
        };
        return _this;
    }
    ResourcedMention.prototype.componentDidMount = function () {
        this.handleMentionProvider(this.props);
    };
    ResourcedMention.prototype.componentWillReceiveProps = function (nextProps) {
        var props = this.props;
        if (props.id !== nextProps.id ||
            props.mentionProvider !== nextProps.mentionProvider) {
            this.handleMentionProvider(nextProps);
        }
    };
    ResourcedMention.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2____["a" /* default */], { id: props.id, text: props.text, isHighlighted: state.isHighlighted, accessLevel: props.accessLevel, onClick: props.onClick, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave }));
    };
    return ResourcedMention;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (ResourcedMention);
//# sourceMappingURL=ResourcedMention.js.map

/***/ }),
/* 3025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(3026);


/**
 * This component is stateful and should be instantianted per contextIdentifiers.
 */
var ContextMentionResource = /** @class */ (function () {
    function ContextMentionResource(mentionProvider, contextIdentifier) {
        var _this = this;
        this.callWithContextIds = function (f, declaredArgs) { return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _a;
            var argsLength = args ? args.length : 0;
            // cover the scenario where optional parameters are not passed
            // by passing undefined instead to keep the contextIdentifiers parameter in the right position
            var mentionArgs = argsLength !== declaredArgs
                ? Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* padArray */])(args, declaredArgs - argsLength, undefined)
                : args;
            return (_a = _this.mentionProvider)[f].apply(_a, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](mentionArgs, [_this.contextIdentifier]));
        }; };
        this.callDefault = function (f) { return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _a;
            return (_a = _this.mentionProvider)[f].apply(_a, __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](args));
        }; };
        this.subscribe = this.callDefault('subscribe');
        this.unsubscribe = this.callDefault('unsubscribe');
        this.filter = this.callWithContextIds('filter', 1);
        this.recordMentionSelection = this.callWithContextIds('recordMentionSelection', 1);
        this.shouldHighlightMention = this.callDefault('shouldHighlightMention');
        this.isFiltering = this.callDefault('isFiltering');
        this.mentionProvider = mentionProvider;
        this.contextIdentifier = contextIdentifier;
    }
    ContextMentionResource.prototype.getContextIdentifier = function () {
        return this.contextIdentifier;
    };
    return ContextMentionResource;
}());
/* unused harmony default export */ var _unused_webpack_default_export = (ContextMentionResource);
//# sourceMappingURL=ContextMentionResource.js.map

/***/ }),
/* 3026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return padArray; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

var padArray = function (arr, size, value) {
    if (size === 0) {
        return arr;
    }
    var gap = new Array(size);
    gap.fill(value);
    return arr.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"](arr, gap) : gap;
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 3027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_mention__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_profilecard__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Popup__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__with_outer_listeners__ = __webpack_require__(938);








// tslint:disable-next-line:variable-name
var ProfilecardResourcedWithListeners = Object(__WEBPACK_IMPORTED_MODULE_6__with_outer_listeners__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__atlaskit_profilecard__["a" /* default */]);
var MentionWithProfileCard = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionWithProfileCard, _super);
    function MentionWithProfileCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            target: null,
            visible: false,
            popupAlignX: 'left',
            popupAlignY: 'top',
        };
        _this.handleRef = function (target) {
            _this.setState({ target: target });
        };
        _this.handleMentionNodeRef = function (component) {
            if (!component) {
                _this.domNode = null;
            }
            else {
                _this.domNode = Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(component);
            }
        };
        _this.showProfilecard = function () {
            if (!_this.domNode) {
                return;
            }
            var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](_this.calculateLayerPosition(), 2), popupAlignX = _a[0], popupAlignY = _a[1];
            _this.setState({
                popupAlignX: popupAlignX,
                popupAlignY: popupAlignY,
                visible: true,
            });
        };
        _this.hideProfilecard = function () {
            _this.setState({ visible: false });
        };
        return _this;
    }
    MentionWithProfileCard.prototype.calculateLayerPosition = function () {
        var domNodeCentreCoords = this.getDomNodeCenterCoords();
        var visibleAreaCentreCoords = this.getVisibleAreaCentreCoords();
        var popupAlignY = domNodeCentreCoords.y > visibleAreaCentreCoords.y ? 'top' : 'bottom';
        var popupAlignX = domNodeCentreCoords.x > visibleAreaCentreCoords.x ? 'right' : 'left';
        return [popupAlignX, popupAlignY];
    };
    MentionWithProfileCard.prototype.getDomNodeCenterCoords = function () {
        var rect = this.domNode.getBoundingClientRect();
        return {
            x: rect.left + rect.width / 2,
            y: rect.top + rect.height / 2,
        };
    };
    MentionWithProfileCard.prototype.getVisibleAreaCentreCoords = function () {
        return {
            x: window.innerWidth / 2,
            y: window.innerHeight / 2,
        };
    };
    MentionWithProfileCard.prototype.getActions = function (id, text, accessLevel) {
        var _this = this;
        var profilecardProvider = this.props.profilecardProvider;
        var actions = profilecardProvider.getActions(id, text, accessLevel);
        return actions.map(function (action) {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, action, { callback: function () {
                    _this.setState({ visible: false });
                    action.callback();
                } });
        });
    };
    MentionWithProfileCard.prototype.render = function () {
        var _a = this.props, accessLevel = _a.accessLevel, id = _a.id, mentionProvider = _a.mentionProvider, profilecardProvider = _a.profilecardProvider, text = _a.text, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, portal = _a.portal;
        var _b = this.state, popupAlignX = _b.popupAlignX, popupAlignY = _b.popupAlignY, target = _b.target, visible = _b.visible;
        var cloudId = profilecardProvider.cloudId, resourceClient = profilecardProvider.resourceClient;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { ref: this.handleRef, onClick: this.showProfilecard },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_mention__["a" /* ResourcedMention */], { ref: this.handleMentionNodeRef, id: id, text: text, accessLevel: accessLevel, mentionProvider: mentionProvider, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }),
            target && portal && visible && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Popup__["a" /* default */], { offset: [0, 8], target: target, mountTo: portal, alignX: popupAlignX, alignY: popupAlignY },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ProfilecardResourcedWithListeners, { handleClickOutside: this.hideProfilecard, handleEscapeKeydown: this.hideProfilecard, cloudId: cloudId, userId: id, resourceClient: resourceClient, actions: this.getActions(id, text, accessLevel) })))));
    };
    return MentionWithProfileCard;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (MentionWithProfileCard);
//# sourceMappingURL=mention-with-profilecard.js.map

/***/ }),
/* 3028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isBody */
/* unused harmony export isTextNode */
/* unused harmony export getVerticalPlacement */
/* unused harmony export getHorizontalPlacement */
/* harmony export (immutable) */ __webpack_exports__["a"] = calculatePlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = calculatePosition;
/* harmony export (immutable) */ __webpack_exports__["c"] = findOverflowScrollParent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);

function isBody(elem) {
    return elem === document.body;
}
function isTextNode(elem) {
    return elem && elem.nodeType === 3;
}
/**
 * Decides if given fitHeight fits below or above the target taking boundaries into account.
 */
function getVerticalPlacement(target, boundariesElement, fitHeight, alignY) {
    if (alignY) {
        return alignY;
    }
    if (!fitHeight) {
        return 'bottom';
    }
    if (isTextNode(target)) {
        target = target.parentElement;
    }
    var boundariesClientRect = boundariesElement.getBoundingClientRect();
    var boundariesHeight = boundariesClientRect.height;
    var boundariesTop = isBody(boundariesElement)
        ? 0
        : boundariesClientRect.top;
    var _a = target.getBoundingClientRect(), targetTop = _a.top, targetHeight = _a.height;
    var spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
    var spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
    if (spaceBelow >= fitHeight || spaceBelow >= spaceAbove) {
        return 'bottom';
    }
    return 'top';
}
/**
 * Decides if given fitWidth fits to the left or to the right of the target taking boundaries into account.
 */
function getHorizontalPlacement(target, boundariesElement, fitWidth, alignX) {
    if (alignX) {
        return alignX;
    }
    if (!fitWidth) {
        return 'left';
    }
    if (isTextNode(target)) {
        target = target.parentElement;
    }
    var _a = target.getBoundingClientRect(), targetLeft = _a.left, targetWidth = _a.width;
    var _b = boundariesElement.getBoundingClientRect(), boundariesLeft = _b.left, boundariesWidth = _b.width;
    var spaceLeft = targetLeft - boundariesLeft + targetWidth;
    var spaceRight = boundariesLeft + boundariesWidth - targetLeft;
    if (spaceRight >= fitWidth || spaceRight >= spaceLeft) {
        return 'left';
    }
    return 'right';
}
function calculatePlacement(target, boundariesElement, fitWidth, fitHeight, alignX, alignY) {
    return [
        getVerticalPlacement(target, boundariesElement, fitHeight, alignY),
        getHorizontalPlacement(target, boundariesElement, fitWidth, alignX),
    ];
}
var calculateHorizontalPlacement = function (_a) {
    var placement = _a.placement, targetLeft = _a.targetLeft, targetRight = _a.targetRight, targetWidth = _a.targetWidth, isPopupParentBody = _a.isPopupParentBody, popupOffsetParentLeft = _a.popupOffsetParentLeft, popupOffsetParentRight = _a.popupOffsetParentRight, popupOffsetParentScrollLeft = _a.popupOffsetParentScrollLeft, popupClientWidth = _a.popupClientWidth, offset = _a.offset;
    var position = {};
    if (placement === 'left') {
        position.left = Math.ceil(targetLeft -
            popupOffsetParentLeft +
            (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) +
            offset[0]);
    }
    else if (placement === 'center') {
        position.left = Math.ceil(targetLeft -
            popupOffsetParentLeft +
            (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) +
            offset[0] +
            targetWidth / 2 -
            popupClientWidth / 2);
    }
    else {
        position.right = Math.ceil(popupOffsetParentRight -
            targetRight -
            (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) +
            offset[0]);
    }
    return position;
};
var calculateVerticalStickBottom = function (_a) {
    var target = _a.target, targetTop = _a.targetTop, targetHeight = _a.targetHeight, popup = _a.popup, offset = _a.offset, position = _a.position;
    var scrollParent = findOverflowScrollParent(target);
    var newPos = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, position);
    if (scrollParent) {
        var topOffsetTop = targetTop - scrollParent.getBoundingClientRect().top;
        var targetEnd = targetHeight + topOffsetTop;
        if (scrollParent.clientHeight - targetEnd <=
            popup.clientHeight + offset[1] * 2 &&
            topOffsetTop < scrollParent.clientHeight) {
            var scroll_1 = targetEnd - scrollParent.clientHeight + offset[1] * 2;
            var top_1 = newPos.top || 0;
            top_1 = top_1 - (scroll_1 + popup.clientHeight);
            newPos.top = top_1;
        }
    }
    return newPos;
};
var calculateVerticalStickTop = function (_a) {
    var target = _a.target, targetTop = _a.targetTop, targetHeight = _a.targetHeight, popupOffsetParentHeight = _a.popupOffsetParentHeight, popupOffsetParent = _a.popupOffsetParent, popup = _a.popup, offset = _a.offset, position = _a.position;
    var scrollParent = findOverflowScrollParent(target);
    var newPos = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, position);
    if (scrollParent) {
        var scrollParentTop = scrollParent.getBoundingClientRect().top;
        var topBoundary = targetTop - scrollParentTop;
        var scrollParentScrollTop = scrollParent.scrollTop;
        if (topBoundary < 0) {
            if (targetTop +
                (scrollParentScrollTop - scrollParentTop) +
                targetHeight +
                offset[1] <
                scrollParentScrollTop) {
                newPos.bottom =
                    popupOffsetParentHeight -
                        (topBoundary + popupOffsetParent.scrollTop + targetHeight);
            }
            else {
                newPos.bottom += topBoundary;
            }
        }
    }
    return newPos;
};
var calculateVerticalPlacement = function (_a) {
    var placement = _a.placement, targetTop = _a.targetTop, targetHeight = _a.targetHeight, isPopupParentBody = _a.isPopupParentBody, popupOffsetParentHeight = _a.popupOffsetParentHeight, popupOffsetParentTop = _a.popupOffsetParentTop, popupOffsetParentScrollTop = _a.popupOffsetParentScrollTop, borderBottomWidth = _a.borderBottomWidth, offset = _a.offset;
    var position = {};
    if (placement === 'top') {
        position.bottom = Math.ceil(popupOffsetParentHeight -
            (targetTop - popupOffsetParentTop) -
            (isPopupParentBody ? 0 : popupOffsetParentScrollTop) -
            borderBottomWidth +
            offset[1]);
    }
    else {
        var top_2 = Math.ceil(targetTop -
            popupOffsetParentTop +
            targetHeight +
            (isPopupParentBody ? 0 : popupOffsetParentScrollTop) -
            borderBottomWidth +
            offset[1]);
        position.top = top_2;
    }
    return position;
};
/**
 * Calculates relative coordinates for placing popup along with the target.
 * Uses placement from calculatePlacement.
 */
function calculatePosition(_a) {
    var placement = _a.placement, target = _a.target, popup = _a.popup, offset = _a.offset, stick = _a.stick;
    var position = {};
    if (!target || !popup || !popup.offsetParent) {
        return position;
    }
    if (isTextNode(target)) {
        target = target.parentElement;
    }
    var popupOffsetParent = popup.offsetParent;
    var offsetParentStyle = popupOffsetParent.style;
    var borderBottomWidth = 0;
    if (offsetParentStyle && offsetParentStyle.borderBottomWidth) {
        borderBottomWidth = parseInt(offsetParentStyle.borderBottomWidth, 10);
    }
    var _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["__read"](placement, 2), verticalPlacement = _b[0], horizontalPlacement = _b[1];
    var _c = popupOffsetParent.getBoundingClientRect(), popupOffsetParentTop = _c.top, popupOffsetParentLeft = _c.left, popupOffsetParentRight = _c.right, popupOffsetParentHeight = _c.height;
    var _d = target.getBoundingClientRect(), targetTop = _d.top, targetLeft = _d.left, targetRight = _d.right, targetHeight = _d.height, targetWidth = _d.width;
    var isPopupParentBody = isBody(popupOffsetParent);
    var verticalPosition = calculateVerticalPlacement({
        placement: verticalPlacement,
        targetTop: targetTop,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentHeight: popupOffsetParentHeight,
        popupOffsetParentTop: popupOffsetParentTop,
        popupOffsetParentScrollTop: popupOffsetParent.scrollTop || 0,
        targetHeight: targetHeight,
        borderBottomWidth: borderBottomWidth,
        offset: offset,
    });
    position = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, position, verticalPosition);
    if (verticalPlacement !== 'top' && stick) {
        position = calculateVerticalStickBottom({
            target: target,
            targetTop: targetTop,
            targetHeight: targetHeight,
            popup: popup,
            offset: offset,
            position: position,
        });
    }
    if (verticalPlacement === 'top' && stick) {
        position = calculateVerticalStickTop({
            target: target,
            targetTop: targetTop,
            targetHeight: targetHeight,
            popupOffsetParentHeight: popupOffsetParentHeight,
            popupOffsetParent: popupOffsetParent,
            popup: popup,
            offset: offset,
            position: position,
        });
    }
    var horizontalPosition = calculateHorizontalPlacement({
        placement: horizontalPlacement,
        targetLeft: targetLeft,
        targetRight: targetRight,
        targetWidth: targetWidth,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentLeft: popupOffsetParentLeft,
        popupOffsetParentRight: popupOffsetParentRight,
        popupOffsetParentScrollLeft: popupOffsetParent.scrollLeft || 0,
        popupClientWidth: popup.clientWidth || 0,
        offset: offset,
    });
    position = __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, position, horizontalPosition);
    return position;
}
/**
 * Traverse DOM Tree upwards looking for popup parents with "overflow: scroll".
 */
function findOverflowScrollParent(popup) {
    var parent = popup;
    if (!parent) {
        return false;
    }
    while ((parent = parent.parentElement)) {
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        var style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' ||
            style.overflowX === 'scroll' ||
            style.overflowY === 'scroll' ||
            parent.classList.contains('fabric-editor-popup-scroll-parent')) {
            return parent;
        }
    }
    return false;
}
//# sourceMappingURL=utils.js.map

/***/ }),
/* 3029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__ = __webpack_require__(3);





// tslint:disable-next-line:variable-name
var BlockNode = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  align-items: center;\n  background: ", ";\n  border: 1px dashed ", ";\n  border-radius: ", "px;\n  box-sizing: border-box;\n  cursor: default;\n  display: block;\n  font-size: 13px;\n  margin: 10px 0;\n  min-height: 24px;\n  padding: 10px;\n  text-align: center;\n  user-select: all;\n  vertical-align: text-bottom;\n  white-space: nowrap;\n\n  '&.ProseMirror-selectednode' {\n    background: ", ";\n    outline: none;\n  }\n"], ["\n  align-items: center;\n  background: ", ";\n  border: 1px dashed ", ";\n  border-radius: ", "px;\n  box-sizing: border-box;\n  cursor: default;\n  display: block;\n  font-size: 13px;\n  margin: 10px 0;\n  min-height: 24px;\n  padding: 10px;\n  text-align: center;\n  user-select: all;\n  vertical-align: text-bottom;\n  white-space: nowrap;\n\n  '&.ProseMirror-selectednode' {\n    background: ", ";\n    outline: none;\n  }\n"])), __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N30, __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N50, Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["borderRadius"])(), __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["colors"].N50);
var UnsupportedBlockNode = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](UnsupportedBlockNode, _super);
    function UnsupportedBlockNode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UnsupportedBlockNode.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](BlockNode, null, "Unsupported content");
    };
    return UnsupportedBlockNode;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (UnsupportedBlockNode);
var templateObject_1;
//# sourceMappingURL=index.js.map

/***/ }),
/* 3030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = mapBreakpointToLayoutMaxWidth;
/* harmony export (immutable) */ __webpack_exports__["a"] = BaseTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WidthProvider__ = __webpack_require__(939);




function mapBreakpointToFontSize(breakpoint) {
    switch (breakpoint) {
        case __WEBPACK_IMPORTED_MODULE_3__WidthProvider__["a" /* Breakpoints */].M:
            return Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["fontSize"])() + 2;
        case __WEBPACK_IMPORTED_MODULE_3__WidthProvider__["a" /* Breakpoints */].L:
            return Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["fontSize"])() + 4;
        default:
            return Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["fontSize"])();
    }
}
function mapBreakpointToLayoutMaxWidth(breakpoint) {
    switch (breakpoint) {
        case __WEBPACK_IMPORTED_MODULE_3__WidthProvider__["a" /* Breakpoints */].M:
            return 760;
        case __WEBPACK_IMPORTED_MODULE_3__WidthProvider__["a" /* Breakpoints */].L:
            return 850;
        default:
            return 680;
    }
}
function BaseTheme(_a) {
    var children = _a.children, dynamicTextSizing = _a.dynamicTextSizing;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__WidthProvider__["b" /* WidthConsumer */], null, function (_a) {
        var breakpoint = _a.breakpoint;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_styled_components__["ThemeProvider"], { theme: {
                baseFontSize: dynamicTextSizing
                    ? mapBreakpointToFontSize(breakpoint)
                    : mapBreakpointToFontSize(__WEBPACK_IMPORTED_MODULE_3__WidthProvider__["a" /* Breakpoints */].S),
                layoutMaxWidth: dynamicTextSizing
                    ? mapBreakpointToLayoutMaxWidth(breakpoint)
                    : mapBreakpointToLayoutMaxWidth(__WEBPACK_IMPORTED_MODULE_3__WidthProvider__["a" /* Breakpoints */].S),
            } },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, children)));
    }));
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 3031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ADFTraversor = /** @class */ (function () {
    function ADFTraversor(doc) {
        this.subscribers = new Map();
        this.doc = doc;
    }
    ADFTraversor.prototype.subscribe = function (type, callback) {
        var callbacks = this.subscribers.get(type);
        if (!callbacks) {
            this.subscribers.set(type, [callback]);
        }
        else {
            callbacks.push(callback);
        }
    };
    ADFTraversor.prototype.exec = function () {
        if (!this.doc || !Array.isArray(this.doc.content)) {
            return;
        }
        var candidates = this.doc.content.slice(0);
        while (candidates.length) {
            var node = candidates.shift();
            if (Array.isArray(node.content)) {
                candidates = candidates.concat(node.content);
            }
            var callbacks = this.subscribers.get(node.type);
            if (!callbacks) {
                continue;
            }
            for (var i = 0; i < callbacks.length; i++) {
                callbacks[i](node);
            }
        }
    };
    return ADFTraversor;
}());
/* unused harmony default export */ var _unused_webpack_default_export = (ADFTraversor);
//# sourceMappingURL=traversor.js.map

/***/ }),
/* 3032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = BulletList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function BulletList(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ul", null, props.children);
}
//# sourceMappingURL=bulletList.js.map

/***/ }),
/* 3033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_code__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_overflow_shadow__ = __webpack_require__(1273);





function identity(text) {
    return text;
}
var CodeBlock = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CodeBlock, _super);
    function CodeBlock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CodeBlock.prototype.render = function () {
        var _a = this.props, children = _a.children, language = _a.language, handleRef = _a.handleRef, shadowClassNames = _a.shadowClassNames;
        var codeProps = {
            language: language,
            text: __WEBPACK_IMPORTED_MODULE_1_react__["Children"].map(children, identity).join(''),
        };
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "CodeBlock " + shadowClassNames, ref: handleRef },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_code__["b" /* AkCodeBlock */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, codeProps))));
    };
    return CodeBlock;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__ui_overflow_shadow__["a" /* default */])(CodeBlock, {
    overflowSelector: 'span',
    scrollableSelector: 'code',
}));
//# sourceMappingURL=codeBlock.js.map

/***/ }),
/* 3034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__default_highlight__ = __webpack_require__(3035);
/* unused harmony reexport default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__light_async__ = __webpack_require__(3043);
/* unused harmony reexport LightAsync */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__light__ = __webpack_require__(3047);
/* unused harmony reexport Light */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prism_async_light__ = __webpack_require__(3048);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__prism_async_light__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prism_async__ = __webpack_require__(3074);
/* unused harmony reexport PrismAsync */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prism_light__ = __webpack_require__(3075);
/* unused harmony reexport PrismLight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prism__ = __webpack_require__(3076);
/* unused harmony reexport Prism */








/***/ }),
/* 3035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__highlight__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_hljs_default_style__ = __webpack_require__(3037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lowlight__ = __webpack_require__(3038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lowlight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lowlight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__languages_hljs_supported_languages__ = __webpack_require__(3042);




var highlighter = Object(__WEBPACK_IMPORTED_MODULE_0__highlight__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_lowlight___default.a, __WEBPACK_IMPORTED_MODULE_1__styles_hljs_default_style__["a" /* default */]);
highlighter.supportedLanguages = __WEBPACK_IMPORTED_MODULE_3__languages_hljs_supported_languages__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (highlighter);

/***/ }),
/* 3036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createStyleObject */
/* unused harmony export createClassNameString */
/* unused harmony export createChildren */
/* harmony export (immutable) */ __webpack_exports__["a"] = createElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);



function createStyleObject(classNames) {
  var elementStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var stylesheet = arguments.length > 2 ? arguments[2] : undefined;
  return classNames.reduce(function (styleObject, className) {
    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, styleObject, stylesheet[className]);
  }, elementStyle);
}
function createClassNameString(classNames) {
  return classNames.join(' ');
}
function createChildren(stylesheet, useInlineStyles) {
  var childrenCount = 0;
  return function (children) {
    childrenCount += 1;
    return children.map(function (child, i) {
      return createElement({
        node: child,
        stylesheet: stylesheet,
        useInlineStyles: useInlineStyles,
        key: "code-segment-".concat(childrenCount, "-").concat(i)
      });
    });
  };
}
function createElement(_ref) {
  var node = _ref.node,
      stylesheet = _ref.stylesheet,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      useInlineStyles = _ref.useInlineStyles,
      key = _ref.key;
  var properties = node.properties,
      type = node.type,
      TagName = node.tagName,
      value = node.value;

  if (type === 'text') {
    return value;
  } else if (TagName) {
    var childrenCreator = createChildren(stylesheet, useInlineStyles);
    var nonStylesheetClassNames = useInlineStyles && properties.className && properties.className.filter(function (className) {
      return !stylesheet[className];
    });
    var className = nonStylesheetClassNames && nonStylesheetClassNames.length ? nonStylesheetClassNames : undefined;
    var props = useInlineStyles ? __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, properties, {
      className: className
    }, {
      style: createStyleObject(properties.className, Object.assign({}, properties.style, style), stylesheet)
    }) : __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, properties, {
      className: createClassNameString(properties.className)
    });
    var children = childrenCreator(node.children);
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TagName, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      key: key
    }, props), children);
  }
}

/***/ }),
/* 3037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  "hljs": {
    "display": "block",
    "overflowX": "auto",
    "padding": "0.5em",
    "background": "#F0F0F0",
    "color": "#444"
  },
  "hljs-subst": {
    "color": "#444"
  },
  "hljs-comment": {
    "color": "#888888"
  },
  "hljs-keyword": {
    "fontWeight": "bold"
  },
  "hljs-attribute": {
    "fontWeight": "bold"
  },
  "hljs-selector-tag": {
    "fontWeight": "bold"
  },
  "hljs-meta-keyword": {
    "fontWeight": "bold"
  },
  "hljs-doctag": {
    "fontWeight": "bold"
  },
  "hljs-name": {
    "fontWeight": "bold"
  },
  "hljs-type": {
    "color": "#880000"
  },
  "hljs-string": {
    "color": "#880000"
  },
  "hljs-number": {
    "color": "#880000"
  },
  "hljs-selector-id": {
    "color": "#880000"
  },
  "hljs-selector-class": {
    "color": "#880000"
  },
  "hljs-quote": {
    "color": "#880000"
  },
  "hljs-template-tag": {
    "color": "#880000"
  },
  "hljs-deletion": {
    "color": "#880000"
  },
  "hljs-title": {
    "color": "#880000",
    "fontWeight": "bold"
  },
  "hljs-section": {
    "color": "#880000",
    "fontWeight": "bold"
  },
  "hljs-regexp": {
    "color": "#BC6060"
  },
  "hljs-symbol": {
    "color": "#BC6060"
  },
  "hljs-variable": {
    "color": "#BC6060"
  },
  "hljs-template-variable": {
    "color": "#BC6060"
  },
  "hljs-link": {
    "color": "#BC6060"
  },
  "hljs-selector-attr": {
    "color": "#BC6060"
  },
  "hljs-selector-pseudo": {
    "color": "#BC6060"
  },
  "hljs-literal": {
    "color": "#78A960"
  },
  "hljs-built_in": {
    "color": "#397300"
  },
  "hljs-bullet": {
    "color": "#397300"
  },
  "hljs-code": {
    "color": "#397300"
  },
  "hljs-addition": {
    "color": "#397300"
  },
  "hljs-meta": {
    "color": "#1f7199"
  },
  "hljs-meta-string": {
    "color": "#4d99bf"
  },
  "hljs-emphasis": {
    "fontStyle": "italic"
  },
  "hljs-strong": {
    "fontWeight": "bold"
  }
});

/***/ }),
/* 3038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var low = __webpack_require__(484)

module.exports = low

low.registerLanguage('1c', __webpack_require__(942))
low.registerLanguage('abnf', __webpack_require__(943))
low.registerLanguage(
  'accesslog',
  __webpack_require__(944)
)
low.registerLanguage(
  'actionscript',
  __webpack_require__(945)
)
low.registerLanguage('ada', __webpack_require__(946))
low.registerLanguage('apache', __webpack_require__(947))
low.registerLanguage(
  'applescript',
  __webpack_require__(948)
)
low.registerLanguage('cpp', __webpack_require__(949))
low.registerLanguage('arduino', __webpack_require__(950))
low.registerLanguage('armasm', __webpack_require__(951))
low.registerLanguage('xml', __webpack_require__(952))
low.registerLanguage('asciidoc', __webpack_require__(953))
low.registerLanguage('aspectj', __webpack_require__(954))
low.registerLanguage(
  'autohotkey',
  __webpack_require__(955)
)
low.registerLanguage('autoit', __webpack_require__(956))
low.registerLanguage('avrasm', __webpack_require__(957))
low.registerLanguage('awk', __webpack_require__(958))
low.registerLanguage('axapta', __webpack_require__(959))
low.registerLanguage('bash', __webpack_require__(960))
low.registerLanguage('basic', __webpack_require__(961))
low.registerLanguage('bnf', __webpack_require__(962))
low.registerLanguage(
  'brainfuck',
  __webpack_require__(963)
)
low.registerLanguage('cal', __webpack_require__(964))
low.registerLanguage(
  'capnproto',
  __webpack_require__(965)
)
low.registerLanguage('ceylon', __webpack_require__(966))
low.registerLanguage('clean', __webpack_require__(967))
low.registerLanguage('clojure', __webpack_require__(968))
low.registerLanguage(
  'clojure-repl',
  __webpack_require__(969)
)
low.registerLanguage('cmake', __webpack_require__(970))
low.registerLanguage(
  'coffeescript',
  __webpack_require__(971)
)
low.registerLanguage('coq', __webpack_require__(972))
low.registerLanguage('cos', __webpack_require__(973))
low.registerLanguage('crmsh', __webpack_require__(974))
low.registerLanguage('crystal', __webpack_require__(975))
low.registerLanguage('cs', __webpack_require__(976))
low.registerLanguage('csp', __webpack_require__(977))
low.registerLanguage('css', __webpack_require__(978))
low.registerLanguage('d', __webpack_require__(979))
low.registerLanguage('markdown', __webpack_require__(980))
low.registerLanguage('dart', __webpack_require__(981))
low.registerLanguage('delphi', __webpack_require__(982))
low.registerLanguage('diff', __webpack_require__(983))
low.registerLanguage('django', __webpack_require__(984))
low.registerLanguage('dns', __webpack_require__(985))
low.registerLanguage(
  'dockerfile',
  __webpack_require__(986)
)
low.registerLanguage('dos', __webpack_require__(987))
low.registerLanguage('dsconfig', __webpack_require__(988))
low.registerLanguage('dts', __webpack_require__(989))
low.registerLanguage('dust', __webpack_require__(990))
low.registerLanguage('ebnf', __webpack_require__(991))
low.registerLanguage('elixir', __webpack_require__(992))
low.registerLanguage('elm', __webpack_require__(993))
low.registerLanguage('ruby', __webpack_require__(994))
low.registerLanguage('erb', __webpack_require__(995))
low.registerLanguage(
  'erlang-repl',
  __webpack_require__(996)
)
low.registerLanguage('erlang', __webpack_require__(997))
low.registerLanguage('excel', __webpack_require__(998))
low.registerLanguage('fix', __webpack_require__(999))
low.registerLanguage('flix', __webpack_require__(1000))
low.registerLanguage('fortran', __webpack_require__(1001))
low.registerLanguage('fsharp', __webpack_require__(1002))
low.registerLanguage('gams', __webpack_require__(1003))
low.registerLanguage('gauss', __webpack_require__(1004))
low.registerLanguage('gcode', __webpack_require__(1005))
low.registerLanguage('gherkin', __webpack_require__(1006))
low.registerLanguage('glsl', __webpack_require__(1007))
low.registerLanguage('go', __webpack_require__(1008))
low.registerLanguage('golo', __webpack_require__(1009))
low.registerLanguage('gradle', __webpack_require__(1010))
low.registerLanguage('groovy', __webpack_require__(1011))
low.registerLanguage('haml', __webpack_require__(1012))
low.registerLanguage(
  'handlebars',
  __webpack_require__(1013)
)
low.registerLanguage('haskell', __webpack_require__(1014))
low.registerLanguage('haxe', __webpack_require__(1015))
low.registerLanguage('hsp', __webpack_require__(1016))
low.registerLanguage('htmlbars', __webpack_require__(1017))
low.registerLanguage('http', __webpack_require__(1018))
low.registerLanguage('hy', __webpack_require__(1019))
low.registerLanguage('inform7', __webpack_require__(1020))
low.registerLanguage('ini', __webpack_require__(1021))
low.registerLanguage('irpf90', __webpack_require__(1022))
low.registerLanguage('java', __webpack_require__(1023))
low.registerLanguage(
  'javascript',
  __webpack_require__(1024)
)
low.registerLanguage(
  'jboss-cli',
  __webpack_require__(1025)
)
low.registerLanguage('json', __webpack_require__(1026))
low.registerLanguage('julia', __webpack_require__(1027))
low.registerLanguage(
  'julia-repl',
  __webpack_require__(1028)
)
low.registerLanguage('kotlin', __webpack_require__(1029))
low.registerLanguage('lasso', __webpack_require__(1030))
low.registerLanguage('ldif', __webpack_require__(1031))
low.registerLanguage('leaf', __webpack_require__(1032))
low.registerLanguage('less', __webpack_require__(1033))
low.registerLanguage('lisp', __webpack_require__(1034))
low.registerLanguage(
  'livecodeserver',
  __webpack_require__(1035)
)
low.registerLanguage(
  'livescript',
  __webpack_require__(1036)
)
low.registerLanguage('llvm', __webpack_require__(1037))
low.registerLanguage('lsl', __webpack_require__(1038))
low.registerLanguage('lua', __webpack_require__(1039))
low.registerLanguage('makefile', __webpack_require__(1040))
low.registerLanguage(
  'mathematica',
  __webpack_require__(1041)
)
low.registerLanguage('matlab', __webpack_require__(1042))
low.registerLanguage('maxima', __webpack_require__(1043))
low.registerLanguage('mel', __webpack_require__(1044))
low.registerLanguage('mercury', __webpack_require__(1045))
low.registerLanguage('mipsasm', __webpack_require__(1046))
low.registerLanguage('mizar', __webpack_require__(1047))
low.registerLanguage('perl', __webpack_require__(1048))
low.registerLanguage(
  'mojolicious',
  __webpack_require__(1049)
)
low.registerLanguage('monkey', __webpack_require__(1050))
low.registerLanguage(
  'moonscript',
  __webpack_require__(1051)
)
low.registerLanguage('n1ql', __webpack_require__(1052))
low.registerLanguage('nginx', __webpack_require__(1053))
low.registerLanguage('nimrod', __webpack_require__(1054))
low.registerLanguage('nix', __webpack_require__(1055))
low.registerLanguage('nsis', __webpack_require__(1056))
low.registerLanguage(
  'objectivec',
  __webpack_require__(1057)
)
low.registerLanguage('ocaml', __webpack_require__(1058))
low.registerLanguage('openscad', __webpack_require__(1059))
low.registerLanguage('oxygene', __webpack_require__(1060))
low.registerLanguage('parser3', __webpack_require__(1061))
low.registerLanguage('pf', __webpack_require__(1062))
low.registerLanguage('php', __webpack_require__(1063))
low.registerLanguage('pony', __webpack_require__(1064))
low.registerLanguage(
  'powershell',
  __webpack_require__(1065)
)
low.registerLanguage(
  'processing',
  __webpack_require__(1066)
)
low.registerLanguage('profile', __webpack_require__(1067))
low.registerLanguage('prolog', __webpack_require__(1068))
low.registerLanguage('protobuf', __webpack_require__(1069))
low.registerLanguage('puppet', __webpack_require__(1070))
low.registerLanguage(
  'purebasic',
  __webpack_require__(1071)
)
low.registerLanguage('python', __webpack_require__(1072))
low.registerLanguage('q', __webpack_require__(1073))
low.registerLanguage('qml', __webpack_require__(1074))
low.registerLanguage('r', __webpack_require__(1075))
low.registerLanguage('rib', __webpack_require__(1076))
low.registerLanguage('roboconf', __webpack_require__(1077))
low.registerLanguage('routeros', __webpack_require__(1078))
low.registerLanguage('rsl', __webpack_require__(1079))
low.registerLanguage(
  'ruleslanguage',
  __webpack_require__(1080)
)
low.registerLanguage('rust', __webpack_require__(1081))
low.registerLanguage('scala', __webpack_require__(1082))
low.registerLanguage('scheme', __webpack_require__(1083))
low.registerLanguage('scilab', __webpack_require__(1084))
low.registerLanguage('scss', __webpack_require__(1085))
low.registerLanguage('shell', __webpack_require__(1086))
low.registerLanguage('smali', __webpack_require__(1087))
low.registerLanguage(
  'smalltalk',
  __webpack_require__(1088)
)
low.registerLanguage('sml', __webpack_require__(1089))
low.registerLanguage('sqf', __webpack_require__(1090))
low.registerLanguage('sql', __webpack_require__(1091))
low.registerLanguage('stan', __webpack_require__(1092))
low.registerLanguage('stata', __webpack_require__(1093))
low.registerLanguage('step21', __webpack_require__(1094))
low.registerLanguage('stylus', __webpack_require__(1095))
low.registerLanguage('subunit', __webpack_require__(1096))
low.registerLanguage('swift', __webpack_require__(1097))
low.registerLanguage(
  'taggerscript',
  __webpack_require__(1098)
)
low.registerLanguage('yaml', __webpack_require__(1099))
low.registerLanguage('tap', __webpack_require__(1100))
low.registerLanguage('tcl', __webpack_require__(1101))
low.registerLanguage('tex', __webpack_require__(1102))
low.registerLanguage('thrift', __webpack_require__(1103))
low.registerLanguage('tp', __webpack_require__(1104))
low.registerLanguage('twig', __webpack_require__(1105))
low.registerLanguage(
  'typescript',
  __webpack_require__(1106)
)
low.registerLanguage('vala', __webpack_require__(1107))
low.registerLanguage('vbnet', __webpack_require__(1108))
low.registerLanguage('vbscript', __webpack_require__(1109))
low.registerLanguage(
  'vbscript-html',
  __webpack_require__(1110)
)
low.registerLanguage('verilog', __webpack_require__(1111))
low.registerLanguage('vhdl', __webpack_require__(1112))
low.registerLanguage('vim', __webpack_require__(1113))
low.registerLanguage('x86asm', __webpack_require__(1114))
low.registerLanguage('xl', __webpack_require__(1115))
low.registerLanguage('xquery', __webpack_require__(1116))
low.registerLanguage('zephir', __webpack_require__(1117))


/***/ }),
/* 3039 */
/***/ (function(module, exports, __webpack_require__) {

/*
Syntax highlighting with language autodetection.
https://highlightjs.org/
*/

(function(factory) {

  // Find the global object for export to both the browser and web workers.
  var globalObject = typeof window === 'object' && window ||
                     typeof self === 'object' && self;

  // Setup highlight.js for different environments. First is Node.js or
  // CommonJS.
  if(true) {
    factory(exports);
  } else if(globalObject) {
    // Export hljs globally even when using AMD for cases when this script
    // is loaded with others that may still expect a global hljs.
    globalObject.hljs = factory({});

    // Finally register the global hljs with AMD.
    if(typeof define === 'function' && define.amd) {
      define([], function() {
        return globalObject.hljs;
      });
    }
  }

}(function(hljs) {
  // Convenience variables for build-in objects
  var ArrayProto = [],
      objectKeys = Object.keys;

  // Global internal variables used within the highlight.js library.
  var languages = {},
      aliases   = {};

  // Regular expressions used throughout the highlight.js library.
  var noHighlightRe    = /^(no-?highlight|plain|text)$/i,
      languagePrefixRe = /\blang(?:uage)?-([\w-]+)\b/i,
      fixMarkupRe      = /((^(<[^>]+>|\t|)+|(?:\n)))/gm;

  var spanEndTag = '</span>';

  // Global options used when within external APIs. This is modified when
  // calling the `hljs.configure` function.
  var options = {
    classPrefix: 'hljs-',
    tabReplace: null,
    useBR: false,
    languages: undefined
  };


  /* Utility functions */

  function escape(value) {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function tag(node) {
    return node.nodeName.toLowerCase();
  }

  function testRe(re, lexeme) {
    var match = re && re.exec(lexeme);
    return match && match.index === 0;
  }

  function isNotHighlighted(language) {
    return noHighlightRe.test(language);
  }

  function blockLanguage(block) {
    var i, match, length, _class;
    var classes = block.className + ' ';

    classes += block.parentNode ? block.parentNode.className : '';

    // language-* takes precedence over non-prefixed class names.
    match = languagePrefixRe.exec(classes);
    if (match) {
      return getLanguage(match[1]) ? match[1] : 'no-highlight';
    }

    classes = classes.split(/\s+/);

    for (i = 0, length = classes.length; i < length; i++) {
      _class = classes[i]

      if (isNotHighlighted(_class) || getLanguage(_class)) {
        return _class;
      }
    }
  }

  function inherit(parent) {  // inherit(parent, override_obj, override_obj, ...)
    var key;
    var result = {};
    var objects = Array.prototype.slice.call(arguments, 1);

    for (key in parent)
      result[key] = parent[key];
    objects.forEach(function(obj) {
      for (key in obj)
        result[key] = obj[key];
    });
    return result;
  }

  /* Stream merging */

  function nodeStream(node) {
    var result = [];
    (function _nodeStream(node, offset) {
      for (var child = node.firstChild; child; child = child.nextSibling) {
        if (child.nodeType === 3)
          offset += child.nodeValue.length;
        else if (child.nodeType === 1) {
          result.push({
            event: 'start',
            offset: offset,
            node: child
          });
          offset = _nodeStream(child, offset);
          // Prevent void elements from having an end tag that would actually
          // double them in the output. There are more void elements in HTML
          // but we list only those realistically expected in code display.
          if (!tag(child).match(/br|hr|img|input/)) {
            result.push({
              event: 'stop',
              offset: offset,
              node: child
            });
          }
        }
      }
      return offset;
    })(node, 0);
    return result;
  }

  function mergeStreams(original, highlighted, value) {
    var processed = 0;
    var result = '';
    var nodeStack = [];

    function selectStream() {
      if (!original.length || !highlighted.length) {
        return original.length ? original : highlighted;
      }
      if (original[0].offset !== highlighted[0].offset) {
        return (original[0].offset < highlighted[0].offset) ? original : highlighted;
      }

      /*
      To avoid starting the stream just before it should stop the order is
      ensured that original always starts first and closes last:

      if (event1 == 'start' && event2 == 'start')
        return original;
      if (event1 == 'start' && event2 == 'stop')
        return highlighted;
      if (event1 == 'stop' && event2 == 'start')
        return original;
      if (event1 == 'stop' && event2 == 'stop')
        return highlighted;

      ... which is collapsed to:
      */
      return highlighted[0].event === 'start' ? original : highlighted;
    }

    function open(node) {
      function attr_str(a) {return ' ' + a.nodeName + '="' + escape(a.value).replace('"', '&quot;') + '"';}
      result += '<' + tag(node) + ArrayProto.map.call(node.attributes, attr_str).join('') + '>';
    }

    function close(node) {
      result += '</' + tag(node) + '>';
    }

    function render(event) {
      (event.event === 'start' ? open : close)(event.node);
    }

    while (original.length || highlighted.length) {
      var stream = selectStream();
      result += escape(value.substring(processed, stream[0].offset));
      processed = stream[0].offset;
      if (stream === original) {
        /*
        On any opening or closing tag of the original markup we first close
        the entire highlighted node stack, then render the original tag along
        with all the following original tags at the same offset and then
        reopen all the tags on the highlighted stack.
        */
        nodeStack.reverse().forEach(close);
        do {
          render(stream.splice(0, 1)[0]);
          stream = selectStream();
        } while (stream === original && stream.length && stream[0].offset === processed);
        nodeStack.reverse().forEach(open);
      } else {
        if (stream[0].event === 'start') {
          nodeStack.push(stream[0].node);
        } else {
          nodeStack.pop();
        }
        render(stream.splice(0, 1)[0]);
      }
    }
    return result + escape(value.substr(processed));
  }

  /* Initialization */

  function expand_mode(mode) {
    if (mode.variants && !mode.cached_variants) {
      mode.cached_variants = mode.variants.map(function(variant) {
        return inherit(mode, {variants: null}, variant);
      });
    }
    return mode.cached_variants || (mode.endsWithParent && [inherit(mode)]) || [mode];
  }

  function compileLanguage(language) {

    function reStr(re) {
        return (re && re.source) || re;
    }

    function langRe(value, global) {
      return new RegExp(
        reStr(value),
        'm' + (language.case_insensitive ? 'i' : '') + (global ? 'g' : '')
      );
    }

    function compileMode(mode, parent) {
      if (mode.compiled)
        return;
      mode.compiled = true;

      mode.keywords = mode.keywords || mode.beginKeywords;
      if (mode.keywords) {
        var compiled_keywords = {};

        var flatten = function(className, str) {
          if (language.case_insensitive) {
            str = str.toLowerCase();
          }
          str.split(' ').forEach(function(kw) {
            var pair = kw.split('|');
            compiled_keywords[pair[0]] = [className, pair[1] ? Number(pair[1]) : 1];
          });
        };

        if (typeof mode.keywords === 'string') { // string
          flatten('keyword', mode.keywords);
        } else {
          objectKeys(mode.keywords).forEach(function (className) {
            flatten(className, mode.keywords[className]);
          });
        }
        mode.keywords = compiled_keywords;
      }
      mode.lexemesRe = langRe(mode.lexemes || /\w+/, true);

      if (parent) {
        if (mode.beginKeywords) {
          mode.begin = '\\b(' + mode.beginKeywords.split(' ').join('|') + ')\\b';
        }
        if (!mode.begin)
          mode.begin = /\B|\b/;
        mode.beginRe = langRe(mode.begin);
        if (!mode.end && !mode.endsWithParent)
          mode.end = /\B|\b/;
        if (mode.end)
          mode.endRe = langRe(mode.end);
        mode.terminator_end = reStr(mode.end) || '';
        if (mode.endsWithParent && parent.terminator_end)
          mode.terminator_end += (mode.end ? '|' : '') + parent.terminator_end;
      }
      if (mode.illegal)
        mode.illegalRe = langRe(mode.illegal);
      if (mode.relevance == null)
        mode.relevance = 1;
      if (!mode.contains) {
        mode.contains = [];
      }
      mode.contains = Array.prototype.concat.apply([], mode.contains.map(function(c) {
        return expand_mode(c === 'self' ? mode : c)
      }));
      mode.contains.forEach(function(c) {compileMode(c, mode);});

      if (mode.starts) {
        compileMode(mode.starts, parent);
      }

      var terminators =
        mode.contains.map(function(c) {
          return c.beginKeywords ? '\\.?(' + c.begin + ')\\.?' : c.begin;
        })
        .concat([mode.terminator_end, mode.illegal])
        .map(reStr)
        .filter(Boolean);
      mode.terminators = terminators.length ? langRe(terminators.join('|'), true) : {exec: function(/*s*/) {return null;}};
    }

    compileMode(language);
  }

  /*
  Core highlighting function. Accepts a language name, or an alias, and a
  string with the code to highlight. Returns an object with the following
  properties:

  - relevance (int)
  - value (an HTML string with highlighting markup)

  */
  function highlight(name, value, ignore_illegals, continuation) {

    function subMode(lexeme, mode) {
      var i, length;

      for (i = 0, length = mode.contains.length; i < length; i++) {
        if (testRe(mode.contains[i].beginRe, lexeme)) {
          return mode.contains[i];
        }
      }
    }

    function endOfMode(mode, lexeme) {
      if (testRe(mode.endRe, lexeme)) {
        while (mode.endsParent && mode.parent) {
          mode = mode.parent;
        }
        return mode;
      }
      if (mode.endsWithParent) {
        return endOfMode(mode.parent, lexeme);
      }
    }

    function isIllegal(lexeme, mode) {
      return !ignore_illegals && testRe(mode.illegalRe, lexeme);
    }

    function keywordMatch(mode, match) {
      var match_str = language.case_insensitive ? match[0].toLowerCase() : match[0];
      return mode.keywords.hasOwnProperty(match_str) && mode.keywords[match_str];
    }

    function buildSpan(classname, insideSpan, leaveOpen, noPrefix) {
      var classPrefix = noPrefix ? '' : options.classPrefix,
          openSpan    = '<span class="' + classPrefix,
          closeSpan   = leaveOpen ? '' : spanEndTag

      openSpan += classname + '">';

      return openSpan + insideSpan + closeSpan;
    }

    function processKeywords() {
      var keyword_match, last_index, match, result;

      if (!top.keywords)
        return escape(mode_buffer);

      result = '';
      last_index = 0;
      top.lexemesRe.lastIndex = 0;
      match = top.lexemesRe.exec(mode_buffer);

      while (match) {
        result += escape(mode_buffer.substring(last_index, match.index));
        keyword_match = keywordMatch(top, match);
        if (keyword_match) {
          relevance += keyword_match[1];
          result += buildSpan(keyword_match[0], escape(match[0]));
        } else {
          result += escape(match[0]);
        }
        last_index = top.lexemesRe.lastIndex;
        match = top.lexemesRe.exec(mode_buffer);
      }
      return result + escape(mode_buffer.substr(last_index));
    }

    function processSubLanguage() {
      var explicit = typeof top.subLanguage === 'string';
      if (explicit && !languages[top.subLanguage]) {
        return escape(mode_buffer);
      }

      var result = explicit ?
                   highlight(top.subLanguage, mode_buffer, true, continuations[top.subLanguage]) :
                   highlightAuto(mode_buffer, top.subLanguage.length ? top.subLanguage : undefined);

      // Counting embedded language score towards the host language may be disabled
      // with zeroing the containing mode relevance. Usecase in point is Markdown that
      // allows XML everywhere and makes every XML snippet to have a much larger Markdown
      // score.
      if (top.relevance > 0) {
        relevance += result.relevance;
      }
      if (explicit) {
        continuations[top.subLanguage] = result.top;
      }
      return buildSpan(result.language, result.value, false, true);
    }

    function processBuffer() {
      result += (top.subLanguage != null ? processSubLanguage() : processKeywords());
      mode_buffer = '';
    }

    function startNewMode(mode) {
      result += mode.className? buildSpan(mode.className, '', true): '';
      top = Object.create(mode, {parent: {value: top}});
    }

    function processLexeme(buffer, lexeme) {

      mode_buffer += buffer;

      if (lexeme == null) {
        processBuffer();
        return 0;
      }

      var new_mode = subMode(lexeme, top);
      if (new_mode) {
        if (new_mode.skip) {
          mode_buffer += lexeme;
        } else {
          if (new_mode.excludeBegin) {
            mode_buffer += lexeme;
          }
          processBuffer();
          if (!new_mode.returnBegin && !new_mode.excludeBegin) {
            mode_buffer = lexeme;
          }
        }
        startNewMode(new_mode, lexeme);
        return new_mode.returnBegin ? 0 : lexeme.length;
      }

      var end_mode = endOfMode(top, lexeme);
      if (end_mode) {
        var origin = top;
        if (origin.skip) {
          mode_buffer += lexeme;
        } else {
          if (!(origin.returnEnd || origin.excludeEnd)) {
            mode_buffer += lexeme;
          }
          processBuffer();
          if (origin.excludeEnd) {
            mode_buffer = lexeme;
          }
        }
        do {
          if (top.className) {
            result += spanEndTag;
          }
          if (!top.skip) {
            relevance += top.relevance;
          }
          top = top.parent;
        } while (top !== end_mode.parent);
        if (end_mode.starts) {
          startNewMode(end_mode.starts, '');
        }
        return origin.returnEnd ? 0 : lexeme.length;
      }

      if (isIllegal(lexeme, top))
        throw new Error('Illegal lexeme "' + lexeme + '" for mode "' + (top.className || '<unnamed>') + '"');

      /*
      Parser should not reach this point as all types of lexemes should be caught
      earlier, but if it does due to some bug make sure it advances at least one
      character forward to prevent infinite looping.
      */
      mode_buffer += lexeme;
      return lexeme.length || 1;
    }

    var language = getLanguage(name);
    if (!language) {
      throw new Error('Unknown language: "' + name + '"');
    }

    compileLanguage(language);
    var top = continuation || language;
    var continuations = {}; // keep continuations for sub-languages
    var result = '', current;
    for(current = top; current !== language; current = current.parent) {
      if (current.className) {
        result = buildSpan(current.className, '', true) + result;
      }
    }
    var mode_buffer = '';
    var relevance = 0;
    try {
      var match, count, index = 0;
      while (true) {
        top.terminators.lastIndex = index;
        match = top.terminators.exec(value);
        if (!match)
          break;
        count = processLexeme(value.substring(index, match.index), match[0]);
        index = match.index + count;
      }
      processLexeme(value.substr(index));
      for(current = top; current.parent; current = current.parent) { // close dangling modes
        if (current.className) {
          result += spanEndTag;
        }
      }
      return {
        relevance: relevance,
        value: result,
        language: name,
        top: top
      };
    } catch (e) {
      if (e.message && e.message.indexOf('Illegal') !== -1) {
        return {
          relevance: 0,
          value: escape(value)
        };
      } else {
        throw e;
      }
    }
  }

  /*
  Highlighting with language detection. Accepts a string with the code to
  highlight. Returns an object with the following properties:

  - language (detected language)
  - relevance (int)
  - value (an HTML string with highlighting markup)
  - second_best (object with the same structure for second-best heuristically
    detected language, may be absent)

  */
  function highlightAuto(text, languageSubset) {
    languageSubset = languageSubset || options.languages || objectKeys(languages);
    var result = {
      relevance: 0,
      value: escape(text)
    };
    var second_best = result;
    languageSubset.filter(getLanguage).forEach(function(name) {
      var current = highlight(name, text, false);
      current.language = name;
      if (current.relevance > second_best.relevance) {
        second_best = current;
      }
      if (current.relevance > result.relevance) {
        second_best = result;
        result = current;
      }
    });
    if (second_best.language) {
      result.second_best = second_best;
    }
    return result;
  }

  /*
  Post-processing of the highlighted markup:

  - replace TABs with something more useful
  - replace real line-breaks with '<br>' for non-pre containers

  */
  function fixMarkup(value) {
    return !(options.tabReplace || options.useBR)
      ? value
      : value.replace(fixMarkupRe, function(match, p1) {
          if (options.useBR && match === '\n') {
            return '<br>';
          } else if (options.tabReplace) {
            return p1.replace(/\t/g, options.tabReplace);
          }
          return '';
      });
  }

  function buildClassName(prevClassName, currentLang, resultLang) {
    var language = currentLang ? aliases[currentLang] : resultLang,
        result   = [prevClassName.trim()];

    if (!prevClassName.match(/\bhljs\b/)) {
      result.push('hljs');
    }

    if (prevClassName.indexOf(language) === -1) {
      result.push(language);
    }

    return result.join(' ').trim();
  }

  /*
  Applies highlighting to a DOM node containing code. Accepts a DOM node and
  two optional parameters for fixMarkup.
  */
  function highlightBlock(block) {
    var node, originalStream, result, resultNode, text;
    var language = blockLanguage(block);

    if (isNotHighlighted(language))
        return;

    if (options.useBR) {
      node = document.createElementNS('http://www.w3.org/1999/xhtml', 'div');
      node.innerHTML = block.innerHTML.replace(/\n/g, '').replace(/<br[ \/]*>/g, '\n');
    } else {
      node = block;
    }
    text = node.textContent;
    result = language ? highlight(language, text, true) : highlightAuto(text);

    originalStream = nodeStream(node);
    if (originalStream.length) {
      resultNode = document.createElementNS('http://www.w3.org/1999/xhtml', 'div');
      resultNode.innerHTML = result.value;
      result.value = mergeStreams(originalStream, nodeStream(resultNode), text);
    }
    result.value = fixMarkup(result.value);

    block.innerHTML = result.value;
    block.className = buildClassName(block.className, language, result.language);
    block.result = {
      language: result.language,
      re: result.relevance
    };
    if (result.second_best) {
      block.second_best = {
        language: result.second_best.language,
        re: result.second_best.relevance
      };
    }
  }

  /*
  Updates highlight.js global options with values passed in the form of an object.
  */
  function configure(user_options) {
    options = inherit(options, user_options);
  }

  /*
  Applies highlighting to all <pre><code>..</code></pre> blocks on a page.
  */
  function initHighlighting() {
    if (initHighlighting.called)
      return;
    initHighlighting.called = true;

    var blocks = document.querySelectorAll('pre code');
    ArrayProto.forEach.call(blocks, highlightBlock);
  }

  /*
  Attaches highlighting to the page load event.
  */
  function initHighlightingOnLoad() {
    addEventListener('DOMContentLoaded', initHighlighting, false);
    addEventListener('load', initHighlighting, false);
  }

  function registerLanguage(name, language) {
    var lang = languages[name] = language(hljs);
    if (lang.aliases) {
      lang.aliases.forEach(function(alias) {aliases[alias] = name;});
    }
  }

  function listLanguages() {
    return objectKeys(languages);
  }

  function getLanguage(name) {
    name = (name || '').toLowerCase();
    return languages[name] || languages[aliases[name]];
  }

  /* Interface definition */

  hljs.highlight = highlight;
  hljs.highlightAuto = highlightAuto;
  hljs.fixMarkup = fixMarkup;
  hljs.highlightBlock = highlightBlock;
  hljs.configure = configure;
  hljs.initHighlighting = initHighlighting;
  hljs.initHighlightingOnLoad = initHighlightingOnLoad;
  hljs.registerLanguage = registerLanguage;
  hljs.listLanguages = listLanguages;
  hljs.getLanguage = getLanguage;
  hljs.inherit = inherit;

  // Common regexps
  hljs.IDENT_RE = '[a-zA-Z]\\w*';
  hljs.UNDERSCORE_IDENT_RE = '[a-zA-Z_]\\w*';
  hljs.NUMBER_RE = '\\b\\d+(\\.\\d+)?';
  hljs.C_NUMBER_RE = '(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)'; // 0x..., 0..., decimal, float
  hljs.BINARY_NUMBER_RE = '\\b(0b[01]+)'; // 0b...
  hljs.RE_STARTERS_RE = '!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~';

  // Common modes
  hljs.BACKSLASH_ESCAPE = {
    begin: '\\\\[\\s\\S]', relevance: 0
  };
  hljs.APOS_STRING_MODE = {
    className: 'string',
    begin: '\'', end: '\'',
    illegal: '\\n',
    contains: [hljs.BACKSLASH_ESCAPE]
  };
  hljs.QUOTE_STRING_MODE = {
    className: 'string',
    begin: '"', end: '"',
    illegal: '\\n',
    contains: [hljs.BACKSLASH_ESCAPE]
  };
  hljs.PHRASAL_WORDS_MODE = {
    begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
  };
  hljs.COMMENT = function (begin, end, inherits) {
    var mode = hljs.inherit(
      {
        className: 'comment',
        begin: begin, end: end,
        contains: []
      },
      inherits || {}
    );
    mode.contains.push(hljs.PHRASAL_WORDS_MODE);
    mode.contains.push({
      className: 'doctag',
      begin: '(?:TODO|FIXME|NOTE|BUG|XXX):',
      relevance: 0
    });
    return mode;
  };
  hljs.C_LINE_COMMENT_MODE = hljs.COMMENT('//', '$');
  hljs.C_BLOCK_COMMENT_MODE = hljs.COMMENT('/\\*', '\\*/');
  hljs.HASH_COMMENT_MODE = hljs.COMMENT('#', '$');
  hljs.NUMBER_MODE = {
    className: 'number',
    begin: hljs.NUMBER_RE,
    relevance: 0
  };
  hljs.C_NUMBER_MODE = {
    className: 'number',
    begin: hljs.C_NUMBER_RE,
    relevance: 0
  };
  hljs.BINARY_NUMBER_MODE = {
    className: 'number',
    begin: hljs.BINARY_NUMBER_RE,
    relevance: 0
  };
  hljs.CSS_NUMBER_MODE = {
    className: 'number',
    begin: hljs.NUMBER_RE + '(' +
      '%|em|ex|ch|rem'  +
      '|vw|vh|vmin|vmax' +
      '|cm|mm|in|pt|pc|px' +
      '|deg|grad|rad|turn' +
      '|s|ms' +
      '|Hz|kHz' +
      '|dpi|dpcm|dppx' +
      ')?',
    relevance: 0
  };
  hljs.REGEXP_MODE = {
    className: 'regexp',
    begin: /\//, end: /\/[gimuy]*/,
    illegal: /\n/,
    contains: [
      hljs.BACKSLASH_ESCAPE,
      {
        begin: /\[/, end: /\]/,
        relevance: 0,
        contains: [hljs.BACKSLASH_ESCAPE]
      }
    ]
  };
  hljs.TITLE_MODE = {
    className: 'title',
    begin: hljs.IDENT_RE,
    relevance: 0
  };
  hljs.UNDERSCORE_TITLE_MODE = {
    className: 'title',
    begin: hljs.UNDERSCORE_IDENT_RE,
    relevance: 0
  };
  hljs.METHOD_GUARD = {
    // excludes method names from keyword processing
    begin: '\\.\\s*' + hljs.UNDERSCORE_IDENT_RE,
    relevance: 0
  };

  return hljs;
}));


/***/ }),
/* 3040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var formatter = __webpack_require__(3041)

var fault = create(Error)

module.exports = fault

fault.eval = create(EvalError)
fault.range = create(RangeError)
fault.reference = create(ReferenceError)
fault.syntax = create(SyntaxError)
fault.type = create(TypeError)
fault.uri = create(URIError)

fault.create = create

/* Create a new `EConstructor`, with the formatted
 * `format` as a first argument. */
function create(EConstructor) {
  FormattedError.displayName = EConstructor.displayName || EConstructor.name

  return FormattedError

  function FormattedError(format) {
    if (format) {
      format = formatter.apply(null, arguments)
    }

    return new EConstructor(format)
  }
}


/***/ }),
/* 3041 */
/***/ (function(module, exports, __webpack_require__) {

//
// format - printf-like string formatting for JavaScript
// github.com/samsonjs/format
// @_sjs
//
// Copyright 2010 - 2013 Sami Samhuri <sami@samhuri.net>
//
// MIT License
// http://sjs.mit-license.org
//

;(function() {

  //// Export the API
  var namespace;

  // CommonJS / Node module
  if (true) {
    namespace = module.exports = format;
  }

  // Browsers and other environments
  else {
    // Get the global object. Works in ES3, ES5, and ES5 strict mode.
    namespace = (function(){ return this || (1,eval)('this') }());
  }

  namespace.format = format;
  namespace.vsprintf = vsprintf;

  if (typeof console !== 'undefined' && typeof console.log === 'function') {
    namespace.printf = printf;
  }

  function printf(/* ... */) {
    console.log(format.apply(null, arguments));
  }

  function vsprintf(fmt, replacements) {
    return format.apply(null, [fmt].concat(replacements));
  }

  function format(fmt) {
    var argIndex = 1 // skip initial format argument
      , args = [].slice.call(arguments)
      , i = 0
      , n = fmt.length
      , result = ''
      , c
      , escaped = false
      , arg
      , tmp
      , leadingZero = false
      , precision
      , nextArg = function() { return args[argIndex++]; }
      , slurpNumber = function() {
          var digits = '';
          while (/\d/.test(fmt[i])) {
            digits += fmt[i++];
            c = fmt[i];
          }
          return digits.length > 0 ? parseInt(digits) : null;
        }
      ;
    for (; i < n; ++i) {
      c = fmt[i];
      if (escaped) {
        escaped = false;
        if (c == '.') {
          leadingZero = false;
          c = fmt[++i];
        }
        else if (c == '0' && fmt[i + 1] == '.') {
          leadingZero = true;
          i += 2;
          c = fmt[i];
        }
        else {
          leadingZero = true;
        }
        precision = slurpNumber();
        switch (c) {
        case 'b': // number in binary
          result += parseInt(nextArg(), 10).toString(2);
          break;
        case 'c': // character
          arg = nextArg();
          if (typeof arg === 'string' || arg instanceof String)
            result += arg;
          else
            result += String.fromCharCode(parseInt(arg, 10));
          break;
        case 'd': // number in decimal
          result += parseInt(nextArg(), 10);
          break;
        case 'f': // floating point number
          tmp = String(parseFloat(nextArg()).toFixed(precision || 6));
          result += leadingZero ? tmp : tmp.replace(/^0/, '');
          break;
        case 'j': // JSON
          result += JSON.stringify(nextArg());
          break;
        case 'o': // number in octal
          result += '0' + parseInt(nextArg(), 10).toString(8);
          break;
        case 's': // string
          result += nextArg();
          break;
        case 'x': // lowercase hexadecimal
          result += '0x' + parseInt(nextArg(), 10).toString(16);
          break;
        case 'X': // uppercase hexadecimal
          result += '0x' + parseInt(nextArg(), 10).toString(16).toUpperCase();
          break;
        default:
          result += c;
          break;
        }
      } else if (c === '%') {
        escaped = true;
      } else {
        result += c;
      }
    }
    return result;
  }

}());


/***/ }),
/* 3042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (['1c', 'abnf', 'accesslog', 'actionscript', 'ada', 'apache', 'applescript', 'arduino', 'armasm', 'asciidoc', 'aspectj', 'autohotkey', 'autoit', 'avrasm', 'awk', 'axapta', 'bash', 'basic', 'bnf', 'brainfuck', 'cal', 'capnproto', 'ceylon', 'clean', 'clojure-repl', 'clojure', 'cmake', 'coffeescript', 'coq', 'cos', 'cpp', 'crmsh', 'crystal', 'cs', 'csp', 'css', 'd', 'dart', 'delphi', 'diff', 'django', 'dns', 'dockerfile', 'dos', 'dsconfig', 'dts', 'dust', 'ebnf', 'elixir', 'elm', 'erb', 'erlang-repl', 'erlang', 'excel', 'fix', 'flix', 'fortran', 'fsharp', 'gams', 'gauss', 'gcode', 'gherkin', 'glsl', 'go', 'golo', 'gradle', 'groovy', 'haml', 'handlebars', 'haskell', 'haxe', 'hsp', 'htmlbars', 'http', 'hy', 'inform7', 'ini', 'irpf90', 'java', 'javascript', 'jboss-cli', 'json', 'julia-repl', 'julia', 'kotlin', 'lasso', 'ldif', 'leaf', 'less', 'lisp', 'livecodeserver', 'livescript', 'llvm', 'lsl', 'lua', 'makefile', 'markdown', 'mathematica', 'matlab', 'maxima', 'mel', 'mercury', 'mipsasm', 'mizar', 'mojolicious', 'monkey', 'moonscript', 'n1ql', 'nginx', 'nimrod', 'nix', 'nsis', 'objectivec', 'ocaml', 'openscad', 'oxygene', 'parser3', 'perl', 'pf', 'php', 'pony', 'powershell', 'processing', 'profile', 'prolog', 'protobuf', 'puppet', 'purebasic', 'python', 'q', 'qml', 'r', 'rib', 'roboconf', 'routeros', 'rsl', 'ruby', 'ruleslanguage', 'rust', 'scala', 'scheme', 'scilab', 'scss', 'shell', 'smali', 'smalltalk', 'sml', 'sqf', 'sql', 'stan', 'stata', 'step21', 'stylus', 'subunit', 'swift', 'taggerscript', 'tap', 'tcl', 'tex', 'thrift', 'tp', 'twig', 'typescript', 'vala', 'vbnet', 'vbscript-html', 'vbscript', 'verilog', 'vhdl', 'vim', 'x86asm', 'xl', 'xml', 'xquery', 'yaml', 'zephir']);

/***/ }),
/* 3043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__async_syntax_highlighter__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__async_languages_hljs__ = __webpack_require__(3046);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__async_syntax_highlighter__["a" /* default */])({
  loader: function loader() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 484)).then(function (module) {
      // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
      return module.default || module;
    });
  },
  isLanguageRegistered: function isLanguageRegistered(instance, language) {
    return !!instance.getLanguage(language);
  },
  languageLoaders: __WEBPACK_IMPORTED_MODULE_1__async_languages_hljs__["a" /* default */],
  registerLanguage: function registerLanguage(instance, name, language) {
    return instance.registerLanguage(name, language);
  }
}));

/***/ }),
/* 3044 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() {
  return this || (typeof self === "object" && self);
})() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(3045);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 3045 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() {
    return this || (typeof self === "object" && self);
  })() || Function("return this")()
);


/***/ }),
/* 3046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__ = __webpack_require__(1120);

/* harmony default export */ __webpack_exports__["a"] = ({
  oneC: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("oneC", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 942));
  }),
  abnf: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("abnf", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 943));
  }),
  accesslog: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("accesslog", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 944));
  }),
  actionscript: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("actionscript", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 945));
  }),
  ada: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("ada", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 946));
  }),
  apache: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("apache", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 947));
  }),
  applescript: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("applescript", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 948));
  }),
  arduino: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("arduino", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 950));
  }),
  armasm: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("armasm", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 951));
  }),
  asciidoc: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("asciidoc", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 953));
  }),
  aspectj: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("aspectj", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 954));
  }),
  autohotkey: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("autohotkey", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 955));
  }),
  autoit: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("autoit", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 956));
  }),
  avrasm: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("avrasm", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 957));
  }),
  awk: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("awk", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 958));
  }),
  axapta: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("axapta", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 959));
  }),
  bash: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("bash", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 960));
  }),
  basic: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("basic", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 961));
  }),
  bnf: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("bnf", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 962));
  }),
  brainfuck: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("brainfuck", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 963));
  }),
  cal: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("cal", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 964));
  }),
  capnproto: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("capnproto", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 965));
  }),
  ceylon: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("ceylon", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 966));
  }),
  clean: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("clean", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 967));
  }),
  clojureRepl: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("clojureRepl", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 969));
  }),
  clojure: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("clojure", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 968));
  }),
  cmake: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("cmake", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 970));
  }),
  coffeescript: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("coffeescript", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 971));
  }),
  coq: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("coq", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 972));
  }),
  cos: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("cos", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 973));
  }),
  cpp: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("cpp", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 949));
  }),
  crmsh: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("crmsh", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 974));
  }),
  crystal: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("crystal", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 975));
  }),
  cs: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("cs", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 976));
  }),
  csp: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("csp", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 977));
  }),
  css: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("css", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 978));
  }),
  d: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("d", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 979));
  }),
  dart: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("dart", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 981));
  }),
  delphi: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("delphi", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 982));
  }),
  diff: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("diff", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 983));
  }),
  django: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("django", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 984));
  }),
  dns: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("dns", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 985));
  }),
  dockerfile: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("dockerfile", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 986));
  }),
  dos: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("dos", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 987));
  }),
  dsconfig: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("dsconfig", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 988));
  }),
  dts: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("dts", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 989));
  }),
  dust: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("dust", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 990));
  }),
  ebnf: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("ebnf", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 991));
  }),
  elixir: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("elixir", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 992));
  }),
  elm: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("elm", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 993));
  }),
  erb: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("erb", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 995));
  }),
  erlangRepl: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("erlangRepl", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 996));
  }),
  erlang: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("erlang", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 997));
  }),
  excel: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("excel", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 998));
  }),
  fix: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("fix", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 999));
  }),
  flix: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("flix", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1000));
  }),
  fortran: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("fortran", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1001));
  }),
  fsharp: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("fsharp", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1002));
  }),
  gams: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("gams", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1003));
  }),
  gauss: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("gauss", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1004));
  }),
  gcode: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("gcode", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1005));
  }),
  gherkin: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("gherkin", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1006));
  }),
  glsl: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("glsl", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1007));
  }),
  go: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("go", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1008));
  }),
  golo: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("golo", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1009));
  }),
  gradle: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("gradle", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1010));
  }),
  groovy: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("groovy", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1011));
  }),
  haml: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("haml", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1012));
  }),
  handlebars: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("handlebars", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1013));
  }),
  haskell: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("haskell", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1014));
  }),
  haxe: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("haxe", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1015));
  }),
  hsp: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("hsp", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1016));
  }),
  htmlbars: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("htmlbars", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1017));
  }),
  http: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("http", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1018));
  }),
  hy: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("hy", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1019));
  }),
  inform7: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("inform7", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1020));
  }),
  ini: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("ini", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1021));
  }),
  irpf90: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("irpf90", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1022));
  }),
  java: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("java", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1023));
  }),
  javascript: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("javascript", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1024));
  }),
  jbossCli: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("jbossCli", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1025));
  }),
  json: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("json", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1026));
  }),
  juliaRepl: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("juliaRepl", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1028));
  }),
  julia: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("julia", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1027));
  }),
  kotlin: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("kotlin", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1029));
  }),
  lasso: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("lasso", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1030));
  }),
  ldif: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("ldif", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1031));
  }),
  leaf: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("leaf", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1032));
  }),
  less: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("less", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1033));
  }),
  lisp: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("lisp", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1034));
  }),
  livecodeserver: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("livecodeserver", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1035));
  }),
  livescript: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("livescript", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1036));
  }),
  llvm: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("llvm", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1037));
  }),
  lsl: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("lsl", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1038));
  }),
  lua: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("lua", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1039));
  }),
  makefile: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("makefile", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1040));
  }),
  markdown: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("markdown", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 980));
  }),
  mathematica: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("mathematica", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1041));
  }),
  matlab: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("matlab", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1042));
  }),
  maxima: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("maxima", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1043));
  }),
  mel: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("mel", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1044));
  }),
  mercury: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("mercury", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1045));
  }),
  mipsasm: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("mipsasm", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1046));
  }),
  mizar: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("mizar", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1047));
  }),
  mojolicious: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("mojolicious", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1049));
  }),
  monkey: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("monkey", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1050));
  }),
  moonscript: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("moonscript", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1051));
  }),
  n1ql: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("n1ql", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1052));
  }),
  nginx: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("nginx", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1053));
  }),
  nimrod: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("nimrod", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1054));
  }),
  nix: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("nix", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1055));
  }),
  nsis: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("nsis", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1056));
  }),
  objectivec: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("objectivec", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1057));
  }),
  ocaml: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("ocaml", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1058));
  }),
  openscad: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("openscad", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1059));
  }),
  oxygene: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("oxygene", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1060));
  }),
  parser3: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("parser3", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1061));
  }),
  perl: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("perl", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1048));
  }),
  pf: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("pf", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1062));
  }),
  php: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("php", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1063));
  }),
  pony: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("pony", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1064));
  }),
  powershell: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("powershell", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1065));
  }),
  processing: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("processing", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1066));
  }),
  profile: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("profile", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1067));
  }),
  prolog: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("prolog", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1068));
  }),
  protobuf: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("protobuf", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1069));
  }),
  puppet: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("puppet", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1070));
  }),
  purebasic: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("purebasic", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1071));
  }),
  python: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("python", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1072));
  }),
  q: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("q", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1073));
  }),
  qml: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("qml", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1074));
  }),
  r: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("r", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1075));
  }),
  rib: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("rib", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1076));
  }),
  roboconf: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("roboconf", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1077));
  }),
  routeros: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("routeros", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1078));
  }),
  rsl: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("rsl", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1079));
  }),
  ruby: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("ruby", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 994));
  }),
  ruleslanguage: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("ruleslanguage", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1080));
  }),
  rust: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("rust", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1081));
  }),
  scala: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("scala", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1082));
  }),
  scheme: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("scheme", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1083));
  }),
  scilab: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("scilab", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1084));
  }),
  scss: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("scss", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1085));
  }),
  shell: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("shell", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1086));
  }),
  smali: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("smali", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1087));
  }),
  smalltalk: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("smalltalk", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1088));
  }),
  sml: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("sml", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1089));
  }),
  sqf: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("sqf", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1090));
  }),
  sql: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("sql", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1091));
  }),
  stan: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("stan", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1092));
  }),
  stata: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("stata", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1093));
  }),
  step21: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("step21", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1094));
  }),
  stylus: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("stylus", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1095));
  }),
  subunit: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("subunit", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1096));
  }),
  swift: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("swift", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1097));
  }),
  taggerscript: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("taggerscript", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1098));
  }),
  tap: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("tap", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1100));
  }),
  tcl: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("tcl", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1101));
  }),
  tex: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("tex", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1102));
  }),
  thrift: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("thrift", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1103));
  }),
  tp: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("tp", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1104));
  }),
  twig: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("twig", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1105));
  }),
  typescript: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("typescript", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1106));
  }),
  vala: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("vala", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1107));
  }),
  vbnet: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("vbnet", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1108));
  }),
  vbscriptHtml: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("vbscriptHtml", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1110));
  }),
  vbscript: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("vbscript", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1109));
  }),
  verilog: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("verilog", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1111));
  }),
  vhdl: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("vhdl", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1112));
  }),
  vim: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("vim", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1113));
  }),
  x86asm: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("x86asm", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1114));
  }),
  xl: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("xl", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1115));
  }),
  xml: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("xml", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 952));
  }),
  xquery: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("xquery", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1116));
  }),
  yaml: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("yaml", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1099));
  }),
  zephir: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("zephir", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1117));
  })
});

/***/ }),
/* 3047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__highlight__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lowlight_lib_core__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lowlight_lib_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lowlight_lib_core__);


var SyntaxHighlighter = Object(__WEBPACK_IMPORTED_MODULE_0__highlight__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_lowlight_lib_core___default.a, {});
SyntaxHighlighter.registerLanguage = __WEBPACK_IMPORTED_MODULE_1_lowlight_lib_core___default.a.registerLanguage;
/* unused harmony default export */ var _unused_webpack_default_export = (SyntaxHighlighter);

/***/ }),
/* 3048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__async_syntax_highlighter__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__async_languages_prism__ = __webpack_require__(3049);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__async_syntax_highlighter__["a" /* default */])({
  loader: function loader() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 492)).then(function (module) {
      // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
      return module.default || module;
    });
  },
  isLanguageRegistered: function isLanguageRegistered(instance, language) {
    return instance.registered(language);
  },
  languageLoaders: __WEBPACK_IMPORTED_MODULE_1__async_languages_prism__["a" /* default */],
  registerLanguage: function registerLanguage(instance, name, language) {
    return instance.register(language);
  }
}));

/***/ }),
/* 3049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__ = __webpack_require__(1120);

/* harmony default export */ __webpack_exports__["a"] = ({
  abap: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("abap", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1121));
  }),
  actionscript: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("actionscript", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1122));
  }),
  ada: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("ada", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1123));
  }),
  apacheconf: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("apacheconf", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1124));
  }),
  apl: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("apl", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1125));
  }),
  applescript: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("applescript", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1126));
  }),
  arduino: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("arduino", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1127));
  }),
  arff: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("arff", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1128));
  }),
  asciidoc: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("asciidoc", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1129));
  }),
  asm6502: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("asm6502", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1130));
  }),
  aspnet: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("aspnet", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1131));
  }),
  autohotkey: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("autohotkey", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1132));
  }),
  autoit: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("autoit", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1133));
  }),
  bash: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("bash", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1134));
  }),
  basic: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("basic", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 486));
  }),
  batch: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("batch", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1135));
  }),
  bison: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("bison", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1136));
  }),
  brainfuck: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("brainfuck", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1137));
  }),
  bro: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("bro", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1138));
  }),
  c: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("c", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 137));
  }),
  clike: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("clike", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1139));
  }),
  clojure: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("clojure", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1140));
  }),
  coffeescript: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("coffeescript", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1141));
  }),
  cpp: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("cpp", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 307));
  }),
  crystal: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("crystal", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1142));
  }),
  csharp: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("csharp", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1143));
  }),
  csp: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("csp", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1144));
  }),
  cssExtras: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("cssExtras", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1145));
  }),
  css: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("css", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1146));
  }),
  d: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("d", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1147));
  }),
  dart: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("dart", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1148));
  }),
  diff: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("diff", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1149));
  }),
  django: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("django", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1150));
  }),
  docker: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("docker", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1151));
  }),
  eiffel: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("eiffel", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1152));
  }),
  elixir: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("elixir", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1153));
  }),
  elm: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("elm", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1154));
  }),
  erb: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("erb", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1155));
  }),
  erlang: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("erlang", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1156));
  }),
  flow: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("flow", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1157));
  }),
  fortran: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("fortran", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1158));
  }),
  fsharp: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("fsharp", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1159));
  }),
  gedcom: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("gedcom", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1160));
  }),
  gherkin: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("gherkin", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1161));
  }),
  git: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("git", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1162));
  }),
  glsl: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("glsl", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1163));
  }),
  go: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("go", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1164));
  }),
  graphql: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("graphql", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1165));
  }),
  groovy: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("groovy", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1166));
  }),
  haml: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("haml", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1167));
  }),
  handlebars: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("handlebars", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1168));
  }),
  haskell: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("haskell", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1169));
  }),
  haxe: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("haxe", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1170));
  }),
  hpkp: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("hpkp", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1171));
  }),
  hsts: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("hsts", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1172));
  }),
  http: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("http", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1173));
  }),
  ichigojam: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("ichigojam", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1174));
  }),
  icon: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("icon", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1175));
  }),
  inform7: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("inform7", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1176));
  }),
  ini: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("ini", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1177));
  }),
  io: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("io", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1178));
  }),
  j: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("j", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1179));
  }),
  java: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("java", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 487));
  }),
  javascript: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("javascript", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1180));
  }),
  jolie: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("jolie", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1181));
  }),
  json: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("json", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1182));
  }),
  jsx: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("jsx", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 488));
  }),
  julia: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("julia", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1183));
  }),
  keyman: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("keyman", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1184));
  }),
  kotlin: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("kotlin", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1185));
  }),
  latex: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("latex", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1186));
  }),
  less: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("less", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1187));
  }),
  liquid: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("liquid", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1188));
  }),
  lisp: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("lisp", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1189));
  }),
  livescript: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("livescript", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1190));
  }),
  lolcode: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("lolcode", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1191));
  }),
  lua: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("lua", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1192));
  }),
  makefile: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("makefile", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1193));
  }),
  markdown: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("markdown", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1194));
  }),
  markupTemplating: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("markupTemplating", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1195));
  }),
  markup: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("markup", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1196));
  }),
  matlab: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("matlab", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1197));
  }),
  mel: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("mel", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1198));
  }),
  mizar: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("mizar", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1199));
  }),
  monkey: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("monkey", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1200));
  }),
  n4js: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("n4js", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1201));
  }),
  nasm: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("nasm", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1202));
  }),
  nginx: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("nginx", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1203));
  }),
  nim: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("nim", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1204));
  }),
  nix: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("nix", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1205));
  }),
  nsis: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("nsis", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1206));
  }),
  objectivec: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("objectivec", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1207));
  }),
  ocaml: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("ocaml", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1208));
  }),
  opencl: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("opencl", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1209));
  }),
  oz: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("oz", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1210));
  }),
  parigp: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("parigp", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1211));
  }),
  parser: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("parser", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1212));
  }),
  pascal: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("pascal", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1213));
  }),
  perl: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("perl", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1214));
  }),
  phpExtras: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("phpExtras", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1215));
  }),
  php: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("php", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 489));
  }),
  plsql: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("plsql", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1216));
  }),
  powershell: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("powershell", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1217));
  }),
  processing: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("processing", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1218));
  }),
  prolog: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("prolog", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1219));
  }),
  properties: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("properties", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1220));
  }),
  protobuf: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("protobuf", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1221));
  }),
  pug: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("pug", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1222));
  }),
  puppet: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("puppet", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1223));
  }),
  pure: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("pure", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1224));
  }),
  python: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("python", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1225));
  }),
  q: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("q", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1226));
  }),
  qore: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("qore", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1227));
  }),
  r: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("r", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1228));
  }),
  reason: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("reason", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1229));
  }),
  renpy: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("renpy", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1230));
  }),
  rest: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("rest", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1231));
  }),
  rip: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("rip", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1232));
  }),
  roboconf: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("roboconf", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1233));
  }),
  ruby: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("ruby", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 308));
  }),
  rust: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("rust", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1234));
  }),
  sas: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("sas", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1235));
  }),
  sass: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("sass", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1236));
  }),
  scala: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("scala", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1237));
  }),
  scheme: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("scheme", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1238));
  }),
  scss: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("scss", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1239));
  }),
  smalltalk: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("smalltalk", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1240));
  }),
  smarty: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("smarty", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1241));
  }),
  soy: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("soy", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1242));
  }),
  sql: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("sql", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 490));
  }),
  stylus: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("stylus", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1243));
  }),
  swift: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("swift", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1244));
  }),
  tap: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("tap", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1245));
  }),
  tcl: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("tcl", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1246));
  }),
  textile: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("textile", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1247));
  }),
  tsx: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("tsx", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1248));
  }),
  tt2: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("tt2", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1249));
  }),
  twig: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("twig", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1250));
  }),
  typescript: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("typescript", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 491));
  }),
  vbnet: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("vbnet", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1251));
  }),
  velocity: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("velocity", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1252));
  }),
  verilog: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("verilog", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1253));
  }),
  vhdl: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("vhdl", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1254));
  }),
  vim: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("vim", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1255));
  }),
  visualBasic: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("visualBasic", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1256));
  }),
  wasm: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("wasm", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1257));
  }),
  wiki: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("wiki", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1258));
  }),
  xeora: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("xeora", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1259));
  }),
  xojo: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("xojo", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1260));
  }),
  xquery: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("xquery", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1261));
  }),
  yaml: Object(__WEBPACK_IMPORTED_MODULE_0__create_language_async_loader__["a" /* default */])("yaml", function () {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1262));
  })
});

/***/ }),
/* 3050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(3051)


/***/ }),
/* 3051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var schema = __webpack_require__(3052)
var factory = __webpack_require__(3061)

var html = factory(schema, 'div')
html.displayName = 'html'

module.exports = html


/***/ }),
/* 3052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var merge = __webpack_require__(3053)
var xlink = __webpack_require__(3055)
var xml = __webpack_require__(3056)
var xmlns = __webpack_require__(3057)
var aria = __webpack_require__(3059)
var html = __webpack_require__(3060)

module.exports = merge([xml, xlink, xmlns, aria, html])


/***/ }),
/* 3053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var xtend = __webpack_require__(3054)
var Schema = __webpack_require__(1263)

module.exports = merge

function merge(definitions) {
  var length = definitions.length
  var property = []
  var normal = []
  var index = -1
  var info
  var space

  while (++index < length) {
    info = definitions[index]
    property.push(info.property)
    normal.push(info.normal)
    space = info.space
  }

  return new Schema(
    xtend.apply(null, property),
    xtend.apply(null, normal),
    space
  )
}


/***/ }),
/* 3054 */
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),
/* 3055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var create = __webpack_require__(234)

module.exports = create({
  space: 'xlink',
  transform: xlinkTransform,
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
})

function xlinkTransform(_, prop) {
  return 'xlink:' + prop.slice(5).toLowerCase()
}


/***/ }),
/* 3056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var create = __webpack_require__(234)

module.exports = create({
  space: 'xml',
  transform: xmlTransform,
  properties: {
    xmlLang: null,
    xmlBase: null,
    xmlSpace: null
  }
})

function xmlTransform(_, prop) {
  return 'xml:' + prop.slice(3).toLowerCase()
}


/***/ }),
/* 3057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var create = __webpack_require__(234)
var caseInsensitiveTransform = __webpack_require__(1266)

module.exports = create({
  space: 'xmlns',
  attributes: {
    xmlnsxlink: 'xmlns:xlink'
  },
  transform: caseInsensitiveTransform,
  properties: {
    xmlns: null,
    xmlnsXLink: null
  }
})


/***/ }),
/* 3058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = caseSensitiveTransform

function caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute
}


/***/ }),
/* 3059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var types = __webpack_require__(494)
var create = __webpack_require__(234)

var booleanish = types.booleanish
var number = types.number
var spaceSeparated = types.spaceSeparated

module.exports = create({
  transform: ariaTransform,
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish,
    ariaAutoComplete: null,
    ariaBusy: booleanish,
    ariaChecked: booleanish,
    ariaColCount: number,
    ariaColIndex: number,
    ariaColSpan: number,
    ariaControls: spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated,
    ariaDetails: null,
    ariaDisabled: booleanish,
    ariaDropEffect: spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: booleanish,
    ariaFlowTo: spaceSeparated,
    ariaGrabbed: booleanish,
    ariaHasPopup: null,
    ariaHidden: booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated,
    ariaLevel: number,
    ariaLive: null,
    ariaModal: booleanish,
    ariaMultiLine: booleanish,
    ariaMultiSelectable: booleanish,
    ariaOrientation: null,
    ariaOwns: spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: number,
    ariaPressed: booleanish,
    ariaReadOnly: booleanish,
    ariaRelevant: null,
    ariaRequired: booleanish,
    ariaRoleDescription: spaceSeparated,
    ariaRowCount: number,
    ariaRowIndex: number,
    ariaRowSpan: number,
    ariaSelected: booleanish,
    ariaSetSize: number,
    ariaSort: null,
    ariaValueMax: number,
    ariaValueMin: number,
    ariaValueNow: number,
    ariaValueText: null,
    role: null
  }
})

function ariaTransform(_, prop) {
  return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase()
}


/***/ }),
/* 3060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var types = __webpack_require__(494)
var create = __webpack_require__(234)
var caseInsensitiveTransform = __webpack_require__(1266)

var boolean = types.boolean
var overloadedBoolean = types.overloadedBoolean
var booleanish = types.booleanish
var number = types.number
var spaceSeparated = types.spaceSeparated
var commaSeparated = types.commaSeparated

module.exports = create({
  space: 'html',
  attributes: {
    acceptcharset: 'accept-charset',
    classname: 'class',
    htmlfor: 'for',
    httpequiv: 'http-equiv'
  },
  transform: caseInsensitiveTransform,
  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated,
    acceptCharset: spaceSeparated,
    accessKey: spaceSeparated,
    action: null,
    allowFullScreen: boolean,
    allowPaymentRequest: boolean,
    allowUserMedia: boolean,
    alt: null,
    as: null,
    async: boolean,
    autoCapitalize: null,
    autoComplete: spaceSeparated,
    autoFocus: boolean,
    autoPlay: boolean,
    capture: boolean,
    charSet: null,
    checked: boolean,
    cite: null,
    className: spaceSeparated,
    cols: number,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: boolean,
    controlsList: spaceSeparated,
    coords: number | commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: boolean,
    defer: boolean,
    dir: null,
    dirName: null,
    disabled: boolean,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: boolean,
    formTarget: null,
    headers: spaceSeparated,
    height: number,
    hidden: boolean,
    high: number,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated,
    httpEquiv: spaceSeparated,
    id: null,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: boolean,
    itemId: null,
    itemProp: spaceSeparated,
    itemRef: spaceSeparated,
    itemScope: boolean,
    itemType: spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loop: boolean,
    low: number,
    manifest: null,
    max: null,
    maxLength: number,
    media: null,
    method: null,
    min: null,
    minLength: number,
    multiple: boolean,
    muted: boolean,
    name: null,
    nonce: null,
    noModule: boolean,
    noValidate: boolean,
    open: boolean,
    optimum: number,
    pattern: null,
    ping: spaceSeparated,
    placeholder: null,
    playsInline: boolean,
    poster: null,
    preload: null,
    readOnly: boolean,
    referrerPolicy: null,
    rel: spaceSeparated,
    required: boolean,
    reversed: boolean,
    rows: number,
    rowSpan: number,
    sandbox: spaceSeparated,
    scope: null,
    scoped: boolean,
    seamless: boolean,
    selected: boolean,
    shape: null,
    size: number,
    sizes: null,
    slot: null,
    span: number,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: commaSeparated,
    start: number,
    step: null,
    style: null,
    tabIndex: number,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: boolean,
    useMap: null,
    value: booleanish,
    width: number,
    wrap: null,

    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null, // Several. Use CSS `text-align` instead,
    aLink: null, // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated, // `<object>`. List of URIs to archives
    axis: null, // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null, // `<body>`. Use CSS `background-image` instead
    bgColor: null, // `<body>` and table elements. Use CSS `background-color` instead
    border: number, // `<table>`. Use CSS `border-width` instead,
    borderColor: null, // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number, // `<body>`
    cellPadding: null, // `<table>`
    cellSpacing: null, // `<table>`
    char: null, // Several table elements. When `align=char`, sets the character to align on
    charOff: null, // Several table elements. When `char`, offsets the alignment
    classId: null, // `<object>`
    clear: null, // `<br>`. Use CSS `clear` instead
    code: null, // `<object>`
    codeBase: null, // `<object>`
    codeType: null, // `<object>`
    color: null, // `<font>` and `<hr>`. Use CSS instead
    compact: boolean, // Lists. Use CSS to reduce space between items instead
    declare: boolean, // `<object>`
    event: null, // `<script>`
    face: null, // `<font>`. Use CSS instead
    frame: null, // `<table>`
    frameBorder: null, // `<iframe>`. Use CSS `border` instead
    hSpace: number, // `<img>` and `<object>`
    leftMargin: number, // `<body>`
    link: null, // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null, // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null, // `<img>`. Use a `<picture>`
    marginHeight: number, // `<body>`
    marginWidth: number, // `<body>`
    noResize: boolean, // `<frame>`
    noHref: boolean, // `<area>`. Use no href instead of an explicit `nohref`
    noShade: boolean, // `<hr>`. Use background-color and height instead of borders
    noWrap: boolean, // `<td>` and `<th>`
    object: null, // `<applet>`
    profile: null, // `<head>`
    prompt: null, // `<isindex>`
    rev: null, // `<link>`
    rightMargin: number, // `<body>`
    rules: null, // `<table>`
    scheme: null, // `<meta>`
    scrolling: booleanish, // `<frame>`. Use overflow in the child context
    standby: null, // `<object>`
    summary: null, // `<table>`
    text: null, // `<body>`. Use CSS `color` instead
    topMargin: number, // `<body>`
    valueType: null, // `<param>`
    version: null, // `<html>`. Use a doctype.
    vAlign: null, // Several. Use CSS `vertical-align` instead
    vLink: null, // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number, // `<img>` and `<object>`

    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    prefix: null,
    property: null,
    results: number,
    security: null,
    unselectable: null
  }
})


/***/ }),
/* 3061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var find = __webpack_require__(3062)
var normalize = __webpack_require__(493)
var parseSelector = __webpack_require__(3063)
var spaces = __webpack_require__(3064).parse
var commas = __webpack_require__(3065).parse

module.exports = factory

function factory(schema, defaultTagName) {
  return h

  /* Hyperscript compatible DSL for creating virtual HAST trees. */
  function h(selector, properties) {
    var node = parseSelector(selector, defaultTagName)
    var children = Array.prototype.slice.call(arguments, 2)
    var property

    if (properties && isChildren(properties, node)) {
      children.unshift(properties)
      properties = null
    }

    if (properties) {
      for (property in properties) {
        addProperty(node.properties, property, properties[property])
      }
    }

    addChild(node.children, children)

    if (node.tagName === 'template') {
      node.content = {type: 'root', children: node.children}
      node.children = []
    }

    return node
  }

  function addProperty(properties, key, value) {
    var info
    var property
    var result

    /* Ignore nully and NaN values. */
    if (value === null || value === undefined || value !== value) {
      return
    }

    info = find(schema, key)
    property = info.property
    result = value

    /* Handle list values. */
    if (typeof result === 'string') {
      if (info.spaceSeparated) {
        result = spaces(result)
      } else if (info.commaSeparated) {
        result = commas(result)
      } else if (info.commaOrSpaceSeparated) {
        result = spaces(commas(result).join(' '))
      }
    }

    /* Accept `object` on style. */
    if (property === 'style' && typeof value !== 'string') {
      result = style(result)
    }

    /* Class-names (which can be added both on the `selector` and here). */
    if (property === 'className' && properties.className) {
      result = properties.className.concat(result)
    }

    properties[property] = parsePrimitives(info, property, result)
  }
}

function isChildren(value, node) {
  return (
    typeof value === 'string' ||
    'length' in value ||
    isNode(node.tagName, value)
  )
}

function isNode(tagName, value) {
  var type = value.type

  if (tagName === 'input' || !type || typeof type !== 'string') {
    return false
  }

  if (typeof value.children === 'object' && 'length' in value.children) {
    return true
  }

  type = type.toLowerCase()

  if (tagName === 'button') {
    return (
      type !== 'menu' &&
      type !== 'submit' &&
      type !== 'reset' &&
      type !== 'button'
    )
  }

  return 'value' in value
}

function addChild(nodes, value) {
  var index
  var length

  if (typeof value === 'string' || typeof value === 'number') {
    nodes.push({type: 'text', value: String(value)})
    return
  }

  if (typeof value === 'object' && 'length' in value) {
    index = -1
    length = value.length

    while (++index < length) {
      addChild(nodes, value[index])
    }

    return
  }

  if (typeof value !== 'object' || !('type' in value)) {
    throw new Error('Expected node, nodes, or string, got `' + value + '`')
  }

  nodes.push(value)
}

/* Parse a (list of) primitives. */
function parsePrimitives(info, name, value) {
  var index
  var length
  var result

  if (typeof value !== 'object' || !('length' in value)) {
    return parsePrimitive(info, name, value)
  }

  length = value.length
  index = -1
  result = []

  while (++index < length) {
    result[index] = parsePrimitive(info, name, value[index])
  }

  return result
}

/* Parse a single primitives. */
function parsePrimitive(info, name, value) {
  var result = value

  if (info.number || info.positiveNumber) {
    if (!isNaN(result) && result !== '') {
      result = Number(result)
    }
  } else if (info.boolean || info.overloadedBoolean) {
    /* Accept `boolean` and `string`. */
    if (
      typeof result === 'string' &&
      (result === '' || normalize(value) === normalize(name))
    ) {
      result = true
    }
  }

  return result
}

function style(value) {
  var result = []
  var key

  for (key in value) {
    result.push([key, value[key]].join(': '))
  }

  return result.join('; ')
}


/***/ }),
/* 3062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var normalize = __webpack_require__(493)
var DefinedInfo = __webpack_require__(1264)
var Info = __webpack_require__(1265)

var data = 'data'

module.exports = find

var valid = /^data[-a-z0-9.:_]+$/i
var dash = /-[a-z]/g
var cap = /[A-Z]/g

function find(schema, value) {
  var normal = normalize(value)
  var prop = value
  var Type = Info

  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]]
  }

  if (normal.length > 4 && normal.slice(0, 4) === data && valid.test(value)) {
    // Attribute or property.
    if (value.charAt(4) === '-') {
      prop = datasetToProperty(value)
    } else {
      value = datasetToAttribute(value)
    }

    Type = DefinedInfo
  }

  return new Type(prop, value)
}

function datasetToProperty(attribute) {
  var value = attribute.slice(5).replace(dash, camelcase)
  return data + value.charAt(0).toUpperCase() + value.slice(1)
}

function datasetToAttribute(property) {
  var value = property.slice(4)

  if (dash.test(value)) {
    return property
  }

  value = value.replace(cap, kebab)

  if (value.charAt(0) !== '-') {
    value = '-' + value
  }

  return data + value
}

function kebab($0) {
  return '-' + $0.toLowerCase()
}

function camelcase($0) {
  return $0.charAt(1).toUpperCase()
}


/***/ }),
/* 3063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = parse

var dot = '.'.charCodeAt(0)
var hash = '#'.charCodeAt(0)

/* Parse a simple CSS selector into a HAST node. */
function parse(selector, defaultTagName) {
  var value = selector || ''
  var name = defaultTagName || 'div'
  var props = {}
  var index = -1
  var length = value.length
  var className
  var type
  var code
  var subvalue
  var lastIndex

  while (++index <= length) {
    code = value.charCodeAt(index)

    if (!code || code === dot || code === hash) {
      subvalue = value.slice(lastIndex, index)

      if (subvalue) {
        if (type === dot) {
          if (className) {
            className.push(subvalue)
          } else {
            className = [subvalue]
            props.className = className
          }
        } else if (type === hash) {
          props.id = subvalue
        } else {
          name = subvalue
        }
      }

      lastIndex = index + 1
      type = code
    }
  }

  return {
    type: 'element',
    tagName: name,
    properties: props,
    children: []
  }
}


/***/ }),
/* 3064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var trim = __webpack_require__(1267)

exports.parse = parse
exports.stringify = stringify

var empty = ''
var space = ' '
var whiteSpace = /[ \t\n\r\f]+/g

function parse(value) {
  var input = trim(String(value || empty))
  return input === empty ? [] : input.split(whiteSpace)
}

function stringify(values) {
  return trim(values.join(space))
}


/***/ }),
/* 3065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.parse = parse
exports.stringify = stringify

var trim = __webpack_require__(1267)

var comma = ','
var space = ' '
var empty = ''

/* Parse comma-separated tokens to an array. */
function parse(value) {
  var values = []
  var input = String(value || empty)
  var index = input.indexOf(comma)
  var lastIndex = 0
  var end = false
  var val

  while (!end) {
    if (index === -1) {
      index = input.length
      end = true
    }

    val = trim(input.slice(lastIndex, index))

    if (val || !end) {
      values.push(val)
    }

    lastIndex = index + 1
    index = input.indexOf(comma, lastIndex)
  }

  return values
}

/* Compile an array to comma-separated tokens.
 * `options.padLeft` (default: `true`) pads a space left of each
 * token, and `options.padRight` (default: `false`) pads a space
 * to the right of each token. */
function stringify(values, options) {
  var settings = options || {}
  var left = settings.padLeft === false ? empty : space
  var right = settings.padRight ? space : empty

  /* Ensure the last empty entry is seen. */
  if (values[values.length - 1] === empty) {
    values = values.concat(empty)
  }

  return trim(values.join(right + comma + left))
}


/***/ }),
/* 3066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var legacy = __webpack_require__(3067)
var invalid = __webpack_require__(3068)
var decimal = __webpack_require__(1268)
var hexadecimal = __webpack_require__(3069)
var alphanumerical = __webpack_require__(3070)
var decodeEntity = __webpack_require__(3072)

module.exports = parseEntities

var own = {}.hasOwnProperty
var fromCharCode = String.fromCharCode
var noop = Function.prototype

/* Default settings. */
var defaults = {
  warning: null,
  reference: null,
  text: null,
  warningContext: null,
  referenceContext: null,
  textContext: null,
  position: {},
  additional: null,
  attribute: false,
  nonTerminated: true
}

/* Reference types. */
var NAMED = 'named'
var HEXADECIMAL = 'hexadecimal'
var DECIMAL = 'decimal'

/* Map of bases. */
var BASE = {}

BASE[HEXADECIMAL] = 16
BASE[DECIMAL] = 10

/* Map of types to tests. Each type of character reference
 * accepts different characters. This test is used to
 * detect whether a reference has ended (as the semicolon
 * is not strictly needed). */
var TESTS = {}

TESTS[NAMED] = alphanumerical
TESTS[DECIMAL] = decimal
TESTS[HEXADECIMAL] = hexadecimal

/* Warning messages. */
var NAMED_NOT_TERMINATED = 1
var NUMERIC_NOT_TERMINATED = 2
var NAMED_EMPTY = 3
var NUMERIC_EMPTY = 4
var NAMED_UNKNOWN = 5
var NUMERIC_DISALLOWED = 6
var NUMERIC_PROHIBITED = 7

var MESSAGES = {}

MESSAGES[NAMED_NOT_TERMINATED] =
  'Named character references must be terminated by a semicolon'
MESSAGES[NUMERIC_NOT_TERMINATED] =
  'Numeric character references must be terminated by a semicolon'
MESSAGES[NAMED_EMPTY] = 'Named character references cannot be empty'
MESSAGES[NUMERIC_EMPTY] = 'Numeric character references cannot be empty'
MESSAGES[NAMED_UNKNOWN] = 'Named character references must be known'
MESSAGES[NUMERIC_DISALLOWED] =
  'Numeric character references cannot be disallowed'
MESSAGES[NUMERIC_PROHIBITED] =
  'Numeric character references cannot be outside the permissible Unicode range'

/* Wrap to ensure clean parameters are given to `parse`. */
function parseEntities(value, options) {
  var settings = {}
  var option
  var key

  if (!options) {
    options = {}
  }

  for (key in defaults) {
    option = options[key]
    settings[key] =
      option === null || option === undefined ? defaults[key] : option
  }

  if (settings.position.indent || settings.position.start) {
    settings.indent = settings.position.indent || []
    settings.position = settings.position.start
  }

  return parse(value, settings)
}

/* Parse entities. */
function parse(value, settings) {
  var additional = settings.additional
  var nonTerminated = settings.nonTerminated
  var handleText = settings.text
  var handleReference = settings.reference
  var handleWarning = settings.warning
  var textContext = settings.textContext
  var referenceContext = settings.referenceContext
  var warningContext = settings.warningContext
  var pos = settings.position
  var indent = settings.indent || []
  var length = value.length
  var index = 0
  var lines = -1
  var column = pos.column || 1
  var line = pos.line || 1
  var queue = ''
  var result = []
  var entityCharacters
  var namedEntity
  var terminated
  var characters
  var character
  var reference
  var following
  var warning
  var reason
  var output
  var entity
  var begin
  var start
  var type
  var test
  var prev
  var next
  var diff
  var end

  /* Cache the current point. */
  prev = now()

  /* Wrap `handleWarning`. */
  warning = handleWarning ? parseError : noop

  /* Ensure the algorithm walks over the first character
   * and the end (inclusive). */
  index--
  length++

  while (++index < length) {
    /* If the previous character was a newline. */
    if (character === '\n') {
      column = indent[lines] || 1
    }

    character = at(index)

    /* Handle anything other than an ampersand,
     * including newlines and EOF. */
    if (character !== '&') {
      if (character === '\n') {
        line++
        lines++
        column = 0
      }

      if (character) {
        queue += character
        column++
      } else {
        flush()
      }
    } else {
      following = at(index + 1)

      /* The behaviour depends on the identity of the next
       * character. */
      if (
        following === '\t' /* Tab */ ||
        following === '\n' /* Newline */ ||
        following === '\f' /* Form feed */ ||
        following === ' ' /* Space */ ||
        following === '<' /* Less-than */ ||
        following === '&' /* Ampersand */ ||
        following === '' ||
        (additional && following === additional)
      ) {
        /* Not a character reference. No characters
         * are consumed, and nothing is returned.
         * This is not an error, either. */
        queue += character
        column++

        continue
      }

      start = index + 1
      begin = start
      end = start

      /* Numerical entity. */
      if (following !== '#') {
        type = NAMED
      } else {
        end = ++begin

        /* The behaviour further depends on the
         * character after the U+0023 NUMBER SIGN. */
        following = at(end)

        if (following === 'x' || following === 'X') {
          /* ASCII hex digits. */
          type = HEXADECIMAL
          end = ++begin
        } else {
          /* ASCII digits. */
          type = DECIMAL
        }
      }

      entityCharacters = ''
      entity = ''
      characters = ''
      test = TESTS[type]
      end--

      while (++end < length) {
        following = at(end)

        if (!test(following)) {
          break
        }

        characters += following

        /* Check if we can match a legacy named
         * reference.  If so, we cache that as the
         * last viable named reference.  This
         * ensures we do not need to walk backwards
         * later. */
        if (type === NAMED && own.call(legacy, characters)) {
          entityCharacters = characters
          entity = legacy[characters]
        }
      }

      terminated = at(end) === ';'

      if (terminated) {
        end++

        namedEntity = type === NAMED ? decodeEntity(characters) : false

        if (namedEntity) {
          entityCharacters = characters
          entity = namedEntity
        }
      }

      diff = 1 + end - start

      if (!terminated && !nonTerminated) {
        /* Empty. */
      } else if (!characters) {
        /* An empty (possible) entity is valid, unless
         * its numeric (thus an ampersand followed by
         * an octothorp). */
        if (type !== NAMED) {
          warning(NUMERIC_EMPTY, diff)
        }
      } else if (type === NAMED) {
        /* An ampersand followed by anything
         * unknown, and not terminated, is invalid. */
        if (terminated && !entity) {
          warning(NAMED_UNKNOWN, 1)
        } else {
          /* If theres something after an entity
           * name which is not known, cap the
           * reference. */
          if (entityCharacters !== characters) {
            end = begin + entityCharacters.length
            diff = 1 + end - begin
            terminated = false
          }

          /* If the reference is not terminated,
           * warn. */
          if (!terminated) {
            reason = entityCharacters ? NAMED_NOT_TERMINATED : NAMED_EMPTY

            if (!settings.attribute) {
              warning(reason, diff)
            } else {
              following = at(end)

              if (following === '=') {
                warning(reason, diff)
                entity = null
              } else if (alphanumerical(following)) {
                entity = null
              } else {
                warning(reason, diff)
              }
            }
          }
        }

        reference = entity
      } else {
        if (!terminated) {
          /* All non-terminated numeric entities are
           * not rendered, and trigger a warning. */
          warning(NUMERIC_NOT_TERMINATED, diff)
        }

        /* When terminated and number, parse as
         * either hexadecimal or decimal. */
        reference = parseInt(characters, BASE[type])

        /* Trigger a warning when the parsed number
         * is prohibited, and replace with
         * replacement character. */
        if (prohibited(reference)) {
          warning(NUMERIC_PROHIBITED, diff)
          reference = '\uFFFD'
        } else if (reference in invalid) {
          /* Trigger a warning when the parsed number
           * is disallowed, and replace by an
           * alternative. */
          warning(NUMERIC_DISALLOWED, diff)
          reference = invalid[reference]
        } else {
          /* Parse the number. */
          output = ''

          /* Trigger a warning when the parsed
           * number should not be used. */
          if (disallowed(reference)) {
            warning(NUMERIC_DISALLOWED, diff)
          }

          /* Stringify the number. */
          if (reference > 0xffff) {
            reference -= 0x10000
            output += fromCharCode((reference >>> (10 & 0x3ff)) | 0xd800)
            reference = 0xdc00 | (reference & 0x3ff)
          }

          reference = output + fromCharCode(reference)
        }
      }

      /* If we could not find a reference, queue the
       * checked characters (as normal characters),
       * and move the pointer to their end. This is
       * possible because we can be certain neither
       * newlines nor ampersands are included. */
      if (!reference) {
        characters = value.slice(start - 1, end)
        queue += characters
        column += characters.length
        index = end - 1
      } else {
        /* Found it! First eat the queued
         * characters as normal text, then eat
         * an entity. */
        flush()

        prev = now()
        index = end - 1
        column += end - start + 1
        result.push(reference)
        next = now()
        next.offset++

        if (handleReference) {
          handleReference.call(
            referenceContext,
            reference,
            {start: prev, end: next},
            value.slice(start - 1, end)
          )
        }

        prev = next
      }
    }
  }

  /* Return the reduced nodes, and any possible warnings. */
  return result.join('')

  /* Get current position. */
  function now() {
    return {
      line: line,
      column: column,
      offset: index + (pos.offset || 0)
    }
  }

  /* “Throw” a parse-error: a warning. */
  function parseError(code, offset) {
    var position = now()

    position.column += offset
    position.offset += offset

    handleWarning.call(warningContext, MESSAGES[code], position, code)
  }

  /* Get character at position. */
  function at(position) {
    return value.charAt(position)
  }

  /* Flush `queue` (normal text). Macro invoked before
   * each entity and at the end of `value`.
   * Does nothing when `queue` is empty. */
  function flush() {
    if (queue) {
      result.push(queue)

      if (handleText) {
        handleText.call(textContext, queue, {start: prev, end: now()})
      }

      queue = ''
    }
  }
}

/* Check if `character` is outside the permissible unicode range. */
function prohibited(code) {
  return (code >= 0xd800 && code <= 0xdfff) || code > 0x10ffff
}

/* Check if `character` is disallowed. */
function disallowed(code) {
  return (
    (code >= 0x0001 && code <= 0x0008) ||
    code === 0x000b ||
    (code >= 0x000d && code <= 0x001f) ||
    (code >= 0x007f && code <= 0x009f) ||
    (code >= 0xfdd0 && code <= 0xfdef) ||
    (code & 0xffff) === 0xffff ||
    (code & 0xffff) === 0xfffe
  )
}


/***/ }),
/* 3067 */
/***/ (function(module, exports) {

module.exports = {"AElig":"Æ","AMP":"&","Aacute":"Á","Acirc":"Â","Agrave":"À","Aring":"Å","Atilde":"Ã","Auml":"Ä","COPY":"©","Ccedil":"Ç","ETH":"Ð","Eacute":"É","Ecirc":"Ê","Egrave":"È","Euml":"Ë","GT":">","Iacute":"Í","Icirc":"Î","Igrave":"Ì","Iuml":"Ï","LT":"<","Ntilde":"Ñ","Oacute":"Ó","Ocirc":"Ô","Ograve":"Ò","Oslash":"Ø","Otilde":"Õ","Ouml":"Ö","QUOT":"\"","REG":"®","THORN":"Þ","Uacute":"Ú","Ucirc":"Û","Ugrave":"Ù","Uuml":"Ü","Yacute":"Ý","aacute":"á","acirc":"â","acute":"´","aelig":"æ","agrave":"à","amp":"&","aring":"å","atilde":"ã","auml":"ä","brvbar":"¦","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","curren":"¤","deg":"°","divide":"÷","eacute":"é","ecirc":"ê","egrave":"è","eth":"ð","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","iacute":"í","icirc":"î","iexcl":"¡","igrave":"ì","iquest":"¿","iuml":"ï","laquo":"«","lt":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","ntilde":"ñ","oacute":"ó","ocirc":"ô","ograve":"ò","ordf":"ª","ordm":"º","oslash":"ø","otilde":"õ","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","raquo":"»","reg":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","thorn":"þ","times":"×","uacute":"ú","ucirc":"û","ugrave":"ù","uml":"¨","uuml":"ü","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 3068 */
/***/ (function(module, exports) {

module.exports = {"0":"�","128":"€","130":"‚","131":"ƒ","132":"„","133":"…","134":"†","135":"‡","136":"ˆ","137":"‰","138":"Š","139":"‹","140":"Œ","142":"Ž","145":"‘","146":"’","147":"“","148":"”","149":"•","150":"–","151":"—","152":"˜","153":"™","154":"š","155":"›","156":"œ","158":"ž","159":"Ÿ"}

/***/ }),
/* 3069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = hexadecimal

/* Check if the given character code, or the character
 * code at the first character, is hexadecimal. */
function hexadecimal(character) {
  var code = typeof character === 'string' ? character.charCodeAt(0) : character

  return (
    (code >= 97 /* a */ && code <= 102) /* z */ ||
    (code >= 65 /* A */ && code <= 70) /* Z */ ||
    (code >= 48 /* A */ && code <= 57) /* Z */
  )
}


/***/ }),
/* 3070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabetical = __webpack_require__(3071)
var decimal = __webpack_require__(1268)

module.exports = alphanumerical

/* Check if the given character code, or the character
 * code at the first character, is alphanumerical. */
function alphanumerical(character) {
  return alphabetical(character) || decimal(character)
}


/***/ }),
/* 3071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = alphabetical

/* Check if the given character code, or the character
 * code at the first character, is alphabetical. */
function alphabetical(character) {
  var code = typeof character === 'string' ? character.charCodeAt(0) : character

  return (
    (code >= 97 && code <= 122) /* a-z */ ||
    (code >= 65 && code <= 90) /* A-Z */
  )
}


/***/ }),
/* 3072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-env browser */

var el

module.exports = decodeEntity

function decodeEntity(characters) {
  var entity = '&' + characters + ';'
  var char

  el = el || document.createElement('i')
  el.innerHTML = entity
  char = el.textContent

  // Some entities do not require the closing semicolon (&not - for instance),
  // which leads to situations where parsing the assumed entity of &notit; will
  // result in the string `¬it;`.  When we encounter a trailing semicolon after
  // parsing and the entity to decode was not a semicolon (&semi;), we can
  // assume that the matching was incomplete
  if (char.slice(-1) === ';' && characters !== 'semi') {
    return false
  }

  // If the decoded string is equal to the input, the entity was not valid
  return char === entity ? false : char
}


/***/ }),
/* 3073 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/// <reference lib="WebWorker"/>

var _self = (typeof window !== 'undefined')
	? window   // if in browser
	: (
		(typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope)
			? self // if in worker
			: {}   // if in node js
	);

/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */
var Prism = (function (_self) {

	// Private helper vars
	var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
	var uniqueId = 0;

	// The grammar object for plaintext
	var plainTextGrammar = {};


	var _ = {
		/**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */
		manual: _self.Prism && _self.Prism.manual,
		/**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */
		disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,

		/**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */
		util: {
			encode: function encode(tokens) {
				if (tokens instanceof Token) {
					return new Token(tokens.type, encode(tokens.content), tokens.alias);
				} else if (Array.isArray(tokens)) {
					return tokens.map(encode);
				} else {
					return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
				}
			},

			/**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */
			type: function (o) {
				return Object.prototype.toString.call(o).slice(8, -1);
			},

			/**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */
			objId: function (obj) {
				if (!obj['__id']) {
					Object.defineProperty(obj, '__id', { value: ++uniqueId });
				}
				return obj['__id'];
			},

			/**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */
			clone: function deepClone(o, visited) {
				visited = visited || {};

				var clone; var id;
				switch (_.util.type(o)) {
					case 'Object':
						id = _.util.objId(o);
						if (visited[id]) {
							return visited[id];
						}
						clone = /** @type {Record<string, any>} */ ({});
						visited[id] = clone;

						for (var key in o) {
							if (o.hasOwnProperty(key)) {
								clone[key] = deepClone(o[key], visited);
							}
						}

						return /** @type {any} */ (clone);

					case 'Array':
						id = _.util.objId(o);
						if (visited[id]) {
							return visited[id];
						}
						clone = [];
						visited[id] = clone;

						(/** @type {Array} */(/** @type {any} */(o))).forEach(function (v, i) {
							clone[i] = deepClone(v, visited);
						});

						return /** @type {any} */ (clone);

					default:
						return o;
				}
			},

			/**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */
			getLanguage: function (element) {
				while (element) {
					var m = lang.exec(element.className);
					if (m) {
						return m[1].toLowerCase();
					}
					element = element.parentElement;
				}
				return 'none';
			},

			/**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */
			setLanguage: function (element, language) {
				// remove all `language-xxxx` classes
				// (this might leave behind a leading space)
				element.className = element.className.replace(RegExp(lang, 'gi'), '');

				// add the new `language-xxxx` class
				// (using `classList` will automatically clean up spaces for us)
				element.classList.add('language-' + language);
			},

			/**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */
			currentScript: function () {
				if (typeof document === 'undefined') {
					return null;
				}
				if (document.currentScript && document.currentScript.tagName === 'SCRIPT' && 1 < 2 /* hack to trip TS' flow analysis */) {
					return /** @type {any} */ (document.currentScript);
				}

				// IE11 workaround
				// we'll get the src of the current script by parsing IE11's error stack trace
				// this will not work for inline scripts

				try {
					throw new Error();
				} catch (err) {
					// Get file src url from stack. Specifically works with the format of stack traces in IE.
					// A stack will look like this:
					//
					// Error
					//    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
					//    at Global code (http://localhost/components/prism-core.js:606:1)

					var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
					if (src) {
						var scripts = document.getElementsByTagName('script');
						for (var i in scripts) {
							if (scripts[i].src == src) {
								return scripts[i];
							}
						}
					}
					return null;
				}
			},

			/**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */
			isActive: function (element, className, defaultActivation) {
				var no = 'no-' + className;

				while (element) {
					var classList = element.classList;
					if (classList.contains(className)) {
						return true;
					}
					if (classList.contains(no)) {
						return false;
					}
					element = element.parentElement;
				}
				return !!defaultActivation;
			}
		},

		/**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */
		languages: {
			/**
			 * The grammar for plain, unformatted text.
			 */
			plain: plainTextGrammar,
			plaintext: plainTextGrammar,
			text: plainTextGrammar,
			txt: plainTextGrammar,

			/**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */
			extend: function (id, redef) {
				var lang = _.util.clone(_.languages[id]);

				for (var key in redef) {
					lang[key] = redef[key];
				}

				return lang;
			},

			/**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */
			insertBefore: function (inside, before, insert, root) {
				root = root || /** @type {any} */ (_.languages);
				var grammar = root[inside];
				/** @type {Grammar} */
				var ret = {};

				for (var token in grammar) {
					if (grammar.hasOwnProperty(token)) {

						if (token == before) {
							for (var newToken in insert) {
								if (insert.hasOwnProperty(newToken)) {
									ret[newToken] = insert[newToken];
								}
							}
						}

						// Do not insert token which also occur in insert. See #1525
						if (!insert.hasOwnProperty(token)) {
							ret[token] = grammar[token];
						}
					}
				}

				var old = root[inside];
				root[inside] = ret;

				// Update references in other language definitions
				_.languages.DFS(_.languages, function (key, value) {
					if (value === old && key != inside) {
						this[key] = ret;
					}
				});

				return ret;
			},

			// Traverse a language definition with Depth First Search
			DFS: function DFS(o, callback, type, visited) {
				visited = visited || {};

				var objId = _.util.objId;

				for (var i in o) {
					if (o.hasOwnProperty(i)) {
						callback.call(o, i, o[i], type || i);

						var property = o[i];
						var propertyType = _.util.type(property);

						if (propertyType === 'Object' && !visited[objId(property)]) {
							visited[objId(property)] = true;
							DFS(property, callback, null, visited);
						} else if (propertyType === 'Array' && !visited[objId(property)]) {
							visited[objId(property)] = true;
							DFS(property, callback, i, visited);
						}
					}
				}
			}
		},

		plugins: {},

		/**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */
		highlightAll: function (async, callback) {
			_.highlightAllUnder(document, async, callback);
		},

		/**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */
		highlightAllUnder: function (container, async, callback) {
			var env = {
				callback: callback,
				container: container,
				selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
			};

			_.hooks.run('before-highlightall', env);

			env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));

			_.hooks.run('before-all-elements-highlight', env);

			for (var i = 0, element; (element = env.elements[i++]);) {
				_.highlightElement(element, async === true, env.callback);
			}
		},

		/**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */
		highlightElement: function (element, async, callback) {
			// Find language
			var language = _.util.getLanguage(element);
			var grammar = _.languages[language];

			// Set language on the element, if not present
			_.util.setLanguage(element, language);

			// Set language on the parent, for styling
			var parent = element.parentElement;
			if (parent && parent.nodeName.toLowerCase() === 'pre') {
				_.util.setLanguage(parent, language);
			}

			var code = element.textContent;

			var env = {
				element: element,
				language: language,
				grammar: grammar,
				code: code
			};

			function insertHighlightedCode(highlightedCode) {
				env.highlightedCode = highlightedCode;

				_.hooks.run('before-insert', env);

				env.element.innerHTML = env.highlightedCode;

				_.hooks.run('after-highlight', env);
				_.hooks.run('complete', env);
				callback && callback.call(env.element);
			}

			_.hooks.run('before-sanity-check', env);

			// plugins may change/add the parent/element
			parent = env.element.parentElement;
			if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) {
				parent.setAttribute('tabindex', '0');
			}

			if (!env.code) {
				_.hooks.run('complete', env);
				callback && callback.call(env.element);
				return;
			}

			_.hooks.run('before-highlight', env);

			if (!env.grammar) {
				insertHighlightedCode(_.util.encode(env.code));
				return;
			}

			if (async && _self.Worker) {
				var worker = new Worker(_.filename);

				worker.onmessage = function (evt) {
					insertHighlightedCode(evt.data);
				};

				worker.postMessage(JSON.stringify({
					language: env.language,
					code: env.code,
					immediateClose: true
				}));
			} else {
				insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
			}
		},

		/**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */
		highlight: function (text, grammar, language) {
			var env = {
				code: text,
				grammar: grammar,
				language: language
			};
			_.hooks.run('before-tokenize', env);
			if (!env.grammar) {
				throw new Error('The language "' + env.language + '" has no grammar.');
			}
			env.tokens = _.tokenize(env.code, env.grammar);
			_.hooks.run('after-tokenize', env);
			return Token.stringify(_.util.encode(env.tokens), env.language);
		},

		/**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */
		tokenize: function (text, grammar) {
			var rest = grammar.rest;
			if (rest) {
				for (var token in rest) {
					grammar[token] = rest[token];
				}

				delete grammar.rest;
			}

			var tokenList = new LinkedList();
			addAfter(tokenList, tokenList.head, text);

			matchGrammar(text, tokenList, grammar, tokenList.head, 0);

			return toArray(tokenList);
		},

		/**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */
		hooks: {
			all: {},

			/**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */
			add: function (name, callback) {
				var hooks = _.hooks.all;

				hooks[name] = hooks[name] || [];

				hooks[name].push(callback);
			},

			/**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */
			run: function (name, env) {
				var callbacks = _.hooks.all[name];

				if (!callbacks || !callbacks.length) {
					return;
				}

				for (var i = 0, callback; (callback = callbacks[i++]);) {
					callback(env);
				}
			}
		},

		Token: Token
	};
	_self.Prism = _;


	// Typescript note:
	// The following can be used to import the Token type in JSDoc:
	//
	//   @typedef {InstanceType<import("./prism-core")["Token"]>} Token

	/**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */
	function Token(type, content, alias, matchedStr) {
		/**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */
		this.type = type;
		/**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */
		this.content = content;
		/**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */
		this.alias = alias;
		// Copy of the full string this token was created from
		this.length = (matchedStr || '').length | 0;
	}

	/**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */

	/**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */
	Token.stringify = function stringify(o, language) {
		if (typeof o == 'string') {
			return o;
		}
		if (Array.isArray(o)) {
			var s = '';
			o.forEach(function (e) {
				s += stringify(e, language);
			});
			return s;
		}

		var env = {
			type: o.type,
			content: stringify(o.content, language),
			tag: 'span',
			classes: ['token', o.type],
			attributes: {},
			language: language
		};

		var aliases = o.alias;
		if (aliases) {
			if (Array.isArray(aliases)) {
				Array.prototype.push.apply(env.classes, aliases);
			} else {
				env.classes.push(aliases);
			}
		}

		_.hooks.run('wrap', env);

		var attributes = '';
		for (var name in env.attributes) {
			attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
		}

		return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
	};

	/**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */
	function matchPattern(pattern, pos, text, lookbehind) {
		pattern.lastIndex = pos;
		var match = pattern.exec(text);
		if (match && lookbehind && match[1]) {
			// change the match to remove the text matched by the Prism lookbehind group
			var lookbehindLength = match[1].length;
			match.index += lookbehindLength;
			match[0] = match[0].slice(lookbehindLength);
		}
		return match;
	}

	/**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */
	function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
		for (var token in grammar) {
			if (!grammar.hasOwnProperty(token) || !grammar[token]) {
				continue;
			}

			var patterns = grammar[token];
			patterns = Array.isArray(patterns) ? patterns : [patterns];

			for (var j = 0; j < patterns.length; ++j) {
				if (rematch && rematch.cause == token + ',' + j) {
					return;
				}

				var patternObj = patterns[j];
				var inside = patternObj.inside;
				var lookbehind = !!patternObj.lookbehind;
				var greedy = !!patternObj.greedy;
				var alias = patternObj.alias;

				if (greedy && !patternObj.pattern.global) {
					// Without the global flag, lastIndex won't work
					var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
					patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
				}

				/** @type {RegExp} */
				var pattern = patternObj.pattern || patternObj;

				for ( // iterate the token list and keep track of the current token/string position
					var currentNode = startNode.next, pos = startPos;
					currentNode !== tokenList.tail;
					pos += currentNode.value.length, currentNode = currentNode.next
				) {

					if (rematch && pos >= rematch.reach) {
						break;
					}

					var str = currentNode.value;

					if (tokenList.length > text.length) {
						// Something went terribly wrong, ABORT, ABORT!
						return;
					}

					if (str instanceof Token) {
						continue;
					}

					var removeCount = 1; // this is the to parameter of removeBetween
					var match;

					if (greedy) {
						match = matchPattern(pattern, pos, text, lookbehind);
						if (!match || match.index >= text.length) {
							break;
						}

						var from = match.index;
						var to = match.index + match[0].length;
						var p = pos;

						// find the node that contains the match
						p += currentNode.value.length;
						while (from >= p) {
							currentNode = currentNode.next;
							p += currentNode.value.length;
						}
						// adjust pos (and p)
						p -= currentNode.value.length;
						pos = p;

						// the current node is a Token, then the match starts inside another Token, which is invalid
						if (currentNode.value instanceof Token) {
							continue;
						}

						// find the last node which is affected by this match
						for (
							var k = currentNode;
							k !== tokenList.tail && (p < to || typeof k.value === 'string');
							k = k.next
						) {
							removeCount++;
							p += k.value.length;
						}
						removeCount--;

						// replace with the new match
						str = text.slice(pos, p);
						match.index -= pos;
					} else {
						match = matchPattern(pattern, 0, str, lookbehind);
						if (!match) {
							continue;
						}
					}

					// eslint-disable-next-line no-redeclare
					var from = match.index;
					var matchStr = match[0];
					var before = str.slice(0, from);
					var after = str.slice(from + matchStr.length);

					var reach = pos + str.length;
					if (rematch && reach > rematch.reach) {
						rematch.reach = reach;
					}

					var removeFrom = currentNode.prev;

					if (before) {
						removeFrom = addAfter(tokenList, removeFrom, before);
						pos += before.length;
					}

					removeRange(tokenList, removeFrom, removeCount);

					var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
					currentNode = addAfter(tokenList, removeFrom, wrapped);

					if (after) {
						addAfter(tokenList, currentNode, after);
					}

					if (removeCount > 1) {
						// at least one Token object was removed, so we have to do some rematching
						// this can only happen if the current pattern is greedy

						/** @type {RematchOptions} */
						var nestedRematch = {
							cause: token + ',' + j,
							reach: reach
						};
						matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);

						// the reach might have been extended because of the rematching
						if (rematch && nestedRematch.reach > rematch.reach) {
							rematch.reach = nestedRematch.reach;
						}
					}
				}
			}
		}
	}

	/**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */

	/**
	 * @template T
	 * @private
	 */
	function LinkedList() {
		/** @type {LinkedListNode<T>} */
		var head = { value: null, prev: null, next: null };
		/** @type {LinkedListNode<T>} */
		var tail = { value: null, prev: head, next: null };
		head.next = tail;

		/** @type {LinkedListNode<T>} */
		this.head = head;
		/** @type {LinkedListNode<T>} */
		this.tail = tail;
		this.length = 0;
	}

	/**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */
	function addAfter(list, node, value) {
		// assumes that node != list.tail && values.length >= 0
		var next = node.next;

		var newNode = { value: value, prev: node, next: next };
		node.next = newNode;
		next.prev = newNode;
		list.length++;

		return newNode;
	}
	/**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */
	function removeRange(list, node, count) {
		var next = node.next;
		for (var i = 0; i < count && next !== list.tail; i++) {
			next = next.next;
		}
		node.next = next;
		next.prev = node;
		list.length -= i;
	}
	/**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */
	function toArray(list) {
		var array = [];
		var node = list.head.next;
		while (node !== list.tail) {
			array.push(node.value);
			node = node.next;
		}
		return array;
	}


	if (!_self.document) {
		if (!_self.addEventListener) {
			// in Node.js
			return _;
		}

		if (!_.disableWorkerMessageHandler) {
			// In worker
			_self.addEventListener('message', function (evt) {
				var message = JSON.parse(evt.data);
				var lang = message.language;
				var code = message.code;
				var immediateClose = message.immediateClose;

				_self.postMessage(_.highlight(code, _.languages[lang], lang));
				if (immediateClose) {
					_self.close();
				}
			}, false);
		}

		return _;
	}

	// Get current script and highlight
	var script = _.util.currentScript();

	if (script) {
		_.filename = script.src;

		if (script.hasAttribute('data-manual')) {
			_.manual = true;
		}
	}

	function highlightAutomaticallyCallback() {
		if (!_.manual) {
			_.highlightAll();
		}
	}

	if (!_.manual) {
		// If the document state is "loading", then we'll use DOMContentLoaded.
		// If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
		// DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
		// might take longer one animation frame to execute which can create a race condition where only some plugins have
		// been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
		// See https://github.com/PrismJS/prism/issues/2102
		var readyState = document.readyState;
		if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) {
			document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
		} else {
			if (window.requestAnimationFrame) {
				window.requestAnimationFrame(highlightAutomaticallyCallback);
			} else {
				window.setTimeout(highlightAutomaticallyCallback, 16);
			}
		}
	}

	return _;

}(_self));

if (typeof module !== 'undefined' && module.exports) {
	module.exports = Prism;
}

// hack for components to work correctly in node.js
if (typeof global !== 'undefined') {
	global.Prism = Prism;
}

// some additional documentation/types

/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */

/**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */

/**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */

/**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 3074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__async_syntax_highlighter__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__languages_prism_supported_languages__ = __webpack_require__(1269);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__async_syntax_highlighter__["a" /* default */])({
  loader: function loader() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1270)).then(function (module) {
      // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
      return module.default || module;
    });
  },
  noAsyncLoadingLanguages: true,
  supportedLanguages: __WEBPACK_IMPORTED_MODULE_1__languages_prism_supported_languages__["a" /* default */]
}));

/***/ }),
/* 3075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__highlight__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_refractor_core__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_refractor_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_refractor_core__);


var SyntaxHighlighter = Object(__WEBPACK_IMPORTED_MODULE_0__highlight__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_refractor_core___default.a, {});

SyntaxHighlighter.registerLanguage = function (_, language) {
  return __WEBPACK_IMPORTED_MODULE_1_refractor_core___default.a.register(language);
};

/* unused harmony default export */ var _unused_webpack_default_export = (SyntaxHighlighter);

/***/ }),
/* 3076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__highlight__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_prism_prism__ = __webpack_require__(3077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_refractor__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_refractor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_refractor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__languages_prism_supported_languages__ = __webpack_require__(1269);




var highlighter = Object(__WEBPACK_IMPORTED_MODULE_0__highlight__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_refractor___default.a, __WEBPACK_IMPORTED_MODULE_1__styles_prism_prism__["a" /* default */]);
highlighter.supportedLanguages = __WEBPACK_IMPORTED_MODULE_3__languages_prism_supported_languages__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (highlighter);

/***/ }),
/* 3077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  "code[class*=\"language-\"]": {
    "color": "black",
    "background": "none",
    "textShadow": "0 1px white",
    "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
    "textAlign": "left",
    "whiteSpace": "pre",
    "wordSpacing": "normal",
    "wordBreak": "normal",
    "wordWrap": "normal",
    "lineHeight": "1.5",
    "MozTabSize": "4",
    "OTabSize": "4",
    "tabSize": "4",
    "WebkitHyphens": "none",
    "MozHyphens": "none",
    "msHyphens": "none",
    "hyphens": "none"
  },
  "pre[class*=\"language-\"]": {
    "color": "black",
    "background": "#f5f2f0",
    "textShadow": "0 1px white",
    "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
    "textAlign": "left",
    "whiteSpace": "pre",
    "wordSpacing": "normal",
    "wordBreak": "normal",
    "wordWrap": "normal",
    "lineHeight": "1.5",
    "MozTabSize": "4",
    "OTabSize": "4",
    "tabSize": "4",
    "WebkitHyphens": "none",
    "MozHyphens": "none",
    "msHyphens": "none",
    "hyphens": "none",
    "padding": "1em",
    "margin": ".5em 0",
    "overflow": "auto"
  },
  "pre[class*=\"language-\"]::-moz-selection": {
    "textShadow": "none",
    "background": "#b3d4fc"
  },
  "pre[class*=\"language-\"] ::-moz-selection": {
    "textShadow": "none",
    "background": "#b3d4fc"
  },
  "code[class*=\"language-\"]::-moz-selection": {
    "textShadow": "none",
    "background": "#b3d4fc"
  },
  "code[class*=\"language-\"] ::-moz-selection": {
    "textShadow": "none",
    "background": "#b3d4fc"
  },
  "pre[class*=\"language-\"]::selection": {
    "textShadow": "none",
    "background": "#b3d4fc"
  },
  "pre[class*=\"language-\"] ::selection": {
    "textShadow": "none",
    "background": "#b3d4fc"
  },
  "code[class*=\"language-\"]::selection": {
    "textShadow": "none",
    "background": "#b3d4fc"
  },
  "code[class*=\"language-\"] ::selection": {
    "textShadow": "none",
    "background": "#b3d4fc"
  },
  ":not(pre) > code[class*=\"language-\"]": {
    "background": "#f5f2f0",
    "padding": ".1em",
    "borderRadius": ".3em",
    "whiteSpace": "normal"
  },
  "comment": {
    "color": "slategray"
  },
  "prolog": {
    "color": "slategray"
  },
  "doctype": {
    "color": "slategray"
  },
  "cdata": {
    "color": "slategray"
  },
  "punctuation": {
    "color": "#999"
  },
  ".namespace": {
    "Opacity": ".7"
  },
  "property": {
    "color": "#905"
  },
  "tag": {
    "color": "#905"
  },
  "boolean": {
    "color": "#905"
  },
  "number": {
    "color": "#905"
  },
  "constant": {
    "color": "#905"
  },
  "symbol": {
    "color": "#905"
  },
  "deleted": {
    "color": "#905"
  },
  "selector": {
    "color": "#690"
  },
  "attr-name": {
    "color": "#690"
  },
  "string": {
    "color": "#690"
  },
  "char": {
    "color": "#690"
  },
  "builtin": {
    "color": "#690"
  },
  "inserted": {
    "color": "#690"
  },
  "operator": {
    "color": "#9a6e3a",
    "background": "hsla(0, 0%, 100%, .5)"
  },
  "entity": {
    "color": "#9a6e3a",
    "background": "hsla(0, 0%, 100%, .5)",
    "cursor": "help"
  },
  "url": {
    "color": "#9a6e3a",
    "background": "hsla(0, 0%, 100%, .5)"
  },
  ".language-css .token.string": {
    "color": "#9a6e3a",
    "background": "hsla(0, 0%, 100%, .5)"
  },
  ".style .token.string": {
    "color": "#9a6e3a",
    "background": "hsla(0, 0%, 100%, .5)"
  },
  "atrule": {
    "color": "#07a"
  },
  "attr-value": {
    "color": "#07a"
  },
  "keyword": {
    "color": "#07a"
  },
  "function": {
    "color": "#DD4A68"
  },
  "class-name": {
    "color": "#DD4A68"
  },
  "regex": {
    "color": "#e90"
  },
  "important": {
    "color": "#e90",
    "fontWeight": "bold"
  },
  "variable": {
    "color": "#e90"
  },
  "bold": {
    "fontWeight": "bold"
  },
  "italic": {
    "fontStyle": "italic"
  }
});

/***/ }),
/* 3078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultColors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_memoize_one__ = __webpack_require__(339);


var defaultColors = Object(__WEBPACK_IMPORTED_MODULE_1_memoize_one__["a" /* default */])(function (theme) {
  var akTheme = {
    theme: theme
  };
  return {
    lineNumberColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N90,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN90
    })(akTheme),
    lineNumberBgColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N30,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN20
    })(akTheme),
    backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN50
    })(akTheme),
    textColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N800,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN800
    })(akTheme),
    substringColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N400,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400
    })(akTheme),
    keywordColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100
    })(akTheme),
    attributeColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T300,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T200
    })(akTheme),
    selectorTagColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100
    })(akTheme),
    docTagColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y300,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y300
    })(akTheme),
    nameColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100
    })(akTheme),
    builtInColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100
    })(akTheme),
    literalColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100
    })(akTheme),
    bulletColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100
    })(akTheme),
    codeColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100
    })(akTheme),
    additionColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100
    })(akTheme),
    regexpColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T300,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T200
    })(akTheme),
    symbolColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T300,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T200
    })(akTheme),
    variableColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T300,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T200
    })(akTheme),
    templateVariableColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T300,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T200
    })(akTheme),
    linkColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P300,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P100
    })(akTheme),
    selectorAttributeColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T300,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T200
    })(akTheme),
    selectorPseudoColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T300,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T200
    })(akTheme),
    typeColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T500,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T300
    })(akTheme),
    stringColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].G300,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].G300
    })(akTheme),
    selectorIdColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T500,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T300
    })(akTheme),
    selectorClassColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T500,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T300
    })(akTheme),
    quoteColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T500,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T300
    })(akTheme),
    templateTagColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T500,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T300
    })(akTheme),
    deletionColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T500,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].T300
    })(akTheme),
    titleColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P300,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P100
    })(akTheme),
    sectionColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P300,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P100
    })(akTheme),
    commentColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N400,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400
    })(akTheme),
    metaKeywordColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].G300,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].G300
    })(akTheme),
    metaColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N400,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN400
    })(akTheme),
    functionColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N800,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].DN800
    })(akTheme),
    numberColor: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["themed"])({
      light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400,
      dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B100
    })(akTheme)
  };
});

/***/ }),
/* 3079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CodeBlock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__supportedLanguages__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__themes_themeBuilder__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Code__ = __webpack_require__(941);












var LANGUAGE_FALLBACK = 'text';
var CodeBlock =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(CodeBlock, _PureComponent);

  function CodeBlock() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, CodeBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(CodeBlock)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)), "handleCopy", function (event) {
      /**
       * We don't want to copy the markup after highlighting, but rather the preformatted text in the selection
       */
      var data = event.nativeEvent.clipboardData;

      if (data) {
        event.preventDefault();
        var selectedText = window.getSelection().toString();
        var document = "<!doctype html><html><head></head><body><pre>".concat(selectedText, "</pre></body></html>");
        data.clearData();
        data.setData('text/html', document);
        data.setData('text/plain', selectedText);
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(CodeBlock, [{
    key: "render",
    value: function render() {
      var _applyTheme = Object(__WEBPACK_IMPORTED_MODULE_10__themes_themeBuilder__["a" /* applyTheme */])(this.props.theme),
          lineNumberContainerStyle = _applyTheme.lineNumberContainerStyle,
          codeBlockStyle = _applyTheme.codeBlockStyle,
          codeContainerStyle = _applyTheme.codeContainerStyle;

      var props = {
        language: Object(__WEBPACK_IMPORTED_MODULE_9__supportedLanguages__["a" /* normalizeLanguage */])(this.props.language || LANGUAGE_FALLBACK),
        codeStyle: codeBlockStyle,
        showLineNumbers: this.props.showLineNumbers,
        codeTagProps: {
          style: codeContainerStyle
        },
        lineNumberContainerStyle: lineNumberContainerStyle,
        text: this.props.text.toString()
      };
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Code__["a" /* Code */], props);
    }
  }]);

  return CodeBlock;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(CodeBlock, "displayName", 'CodeBlock');

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(CodeBlock, "defaultProps", {
  showLineNumbers: true,
  language: LANGUAGE_FALLBACK,
  theme: {}
});

var CodeBlockWithTheme = Object(__WEBPACK_IMPORTED_MODULE_8_styled_components__["withTheme"])(CodeBlock);
var emptyTheme = {};
/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_styled_components__["ThemeProvider"], {
    theme: emptyTheme
  }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(CodeBlockWithTheme, props));
});

/***/ }),
/* 3080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_task_decision__ = __webpack_require__(183);




var DecisionList = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](DecisionList, _super);
    function DecisionList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DecisionList.prototype.render = function () {
        var children = this.props.children;
        if (__WEBPACK_IMPORTED_MODULE_1_react__["Children"].count(children) === 0) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "akDecisionList" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_task_decision__["b" /* DecisionList */], null, children)));
    };
    return DecisionList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (DecisionList);
//# sourceMappingURL=decisionList.js.map

/***/ }),
/* 3081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Doc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts__ = __webpack_require__(306);


function Doc(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* RendererCssClassName */].DOCUMENT }, props.children);
}
//# sourceMappingURL=doc.js.map

/***/ }),
/* 3082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = HardBreak;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function HardBreak(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null);
}
//# sourceMappingURL=hardBreak.js.map

/***/ }),
/* 3083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Heading;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inline__ = __webpack_require__(1274);


function Heading(props) {
    var level = props.level, children = props.children, headingId = props.headingId;
    var HX = "h" + level;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HX, { id: headingId },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__inline__["a" /* default */], null, children)));
}
//# sourceMappingURL=heading.js.map

/***/ }),
/* 3084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Image;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function Image(props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "renderer-image", src: props.src, alt: props.alt, title: props.title }));
}
//# sourceMappingURL=image.js.map

/***/ }),
/* 3085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(109);


var InlineExtension = function (_a) {
    var serializer = _a.serializer, extensionHandlers = _a.extensionHandlers, rendererContext = _a.rendererContext, extensionType = _a.extensionType, extensionKey = _a.extensionKey, parameters = _a.parameters, text = _a.text, children = _a.children;
    try {
        if (extensionHandlers && extensionHandlers[extensionType]) {
            var content = extensionHandlers[extensionType]({
                type: 'inlineExtension',
                extensionKey: extensionKey,
                extensionType: extensionType,
                parameters: parameters,
                content: text,
            }, rendererContext.adDoc);
            switch (true) {
                case content && __WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"](content):
                    // Return the content directly if it's a valid JSX.Element
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, content);
                case !!content:
                    // We expect it to be Atlassian Document here
                    var nodes = Array.isArray(content) ? content : [content];
                    return Object(__WEBPACK_IMPORTED_MODULE_1____["e" /* renderNodes */])(nodes, serializer, rendererContext.schema, 'span');
            }
        }
    }
    catch (e) {
        /** We don't want this error to block renderer */
        /** We keep rendering the default content */
    }
    // Always return default content if anything goes wrong
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, text || 'inlineExtension');
};
/* harmony default export */ __webpack_exports__["a"] = (InlineExtension);
//# sourceMappingURL=inlineExtension.js.map

/***/ }),
/* 3086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = LayoutSection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function LayoutSection(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { "data-layout-section": true }, props.children);
}
//# sourceMappingURL=layoutSection.js.map

/***/ }),
/* 3087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = LayoutSection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function LayoutSection(props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { "data-layout-column": true, "data-column-width": props.width, style: { flexBasis: props.width + "%" } }, props.children));
}
//# sourceMappingURL=layoutColumn.js.map

/***/ }),
/* 3088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ListItem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function ListItem(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("li", null, props.children);
}
//# sourceMappingURL=listItem.js.map

/***/ }),
/* 3089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Renderer_style__ = __webpack_require__(495);






var DEFAULT_WIDTH = 250;
var DEFAULT_HEIGHT = 200;
var ExtendedUIMediaSingle = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["c" /* MediaSingle */])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", " transition: all 0.1s linear;\n"], ["\n  ",
    " transition: all 0.1s linear;\n"])), function (_a) {
    var layout = _a.layout;
    return layout === 'full-width' || layout === 'wide'
        ? "\n  margin-left: 50%;\n  transform: translateX(-50%);\n  "
        : "";
});
var MediaSingle = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MediaSingle, _super);
    function MediaSingle(props) {
        var _this = _super.call(this, props) || this;
        _this.onExternalImageLoaded = function (_a) {
            var width = _a.width, height = _a.height;
            _this.setState({
                width: width,
                height: height,
            });
        };
        _this.state = {}; // Need to initialize with empty state.
        return _this;
    }
    MediaSingle.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var child = __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(__WEBPACK_IMPORTED_MODULE_1_react__["Children"].toArray(props.children)[0]);
        var _a = child.props, width = _a.width, height = _a.height, type = _a.type;
        if (type === 'external') {
            var _b = this.state, stateWidth = _b.width, stateHeight = _b.height;
            if (width === null) {
                width = stateWidth || DEFAULT_WIDTH;
            }
            if (height === null) {
                height = stateHeight || DEFAULT_HEIGHT;
            }
        }
        if (width === null) {
            width = DEFAULT_WIDTH;
            height = DEFAULT_HEIGHT;
        }
        // TODO: put appearance-based padding into theme instead
        var padding = this.props.rendererAppearance === 'full-page' ? __WEBPACK_IMPORTED_MODULE_4__ui_Renderer_style__["a" /* FullPagePadding */] * 2 : 0;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["h" /* WidthConsumer */], null, function (_a) {
            var containerWidth = _a.width, breakpoint = _a.breakpoint;
            var cardWidth = containerWidth;
            var cardHeight = (height / width) * cardWidth;
            var cardDimensions = {
                width: cardWidth + "px",
                height: cardHeight + "px",
            };
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ExtendedUIMediaSingle, { layout: props.layout, width: width, height: height, containerWidth: containerWidth, lineLength: containerWidth - padding >= __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["k" /* akEditorFullPageMaxWidth */]
                    ? _this.props.allowDynamicTextSizing
                        ? Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["H" /* mapBreakpointToLayoutMaxWidth */])(breakpoint)
                        : __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["k" /* akEditorFullPageMaxWidth */]
                    : containerWidth - padding, pctWidth: props.width }, __WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"](child, {
                resizeMode: 'stretchy-fit',
                cardDimensions: cardDimensions,
                onExternalImageLoaded: _this.onExternalImageLoaded,
                disableOverlay: true,
            })));
        }));
    };
    return MediaSingle;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (MediaSingle);
var templateObject_1;
//# sourceMappingURL=mediaSingle.js.map

/***/ }),
/* 3090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = OrderedList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function OrderedList(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("ol", { start: props.start }, props.children);
}
//# sourceMappingURL=orderedList.js.map

/***/ }),
/* 3091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_info__ = __webpack_require__(3092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_hint__ = __webpack_require__(3093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_hint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_hint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_success__ = __webpack_require__(3094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_success___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_success__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_error__ = __webpack_require__(3095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_note__ = __webpack_require__(3096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_note__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_warning__ = __webpack_require__(3097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_warning__);










var G50 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].G50, G400 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].G400, P50 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].P50, P400 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].P400, B400 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B400, Y50 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].Y50, B50 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B50, Y400 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].Y400, R50 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R50, R400 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].R400;
var config = {
    info: {
        icon: __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_editor_info___default.a,
        background: B50,
        iconColor: B400,
    },
    note: {
        icon: __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_editor_note___default.a,
        background: P50,
        iconColor: P400,
    },
    tip: {
        icon: __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_editor_hint___default.a,
        background: G50,
        iconColor: G400,
    },
    success: {
        icon: __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_editor_success___default.a,
        background: G50,
        iconColor: G400,
    },
    warning: {
        icon: __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_warning___default.a,
        background: Y50,
        iconColor: Y400,
    },
    error: {
        icon: __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_editor_error___default.a,
        background: R50,
        iconColor: R400,
    },
};
var Panel = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Panel, _super);
    function Panel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Panel.prototype.render = function () {
        var _a = this.props, panelType = _a.panelType, children = _a.children;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: { background: config[panelType].background }, className: "ak-editor-panel", "data-panel-type": panelType },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { style: { color: config[panelType].iconColor }, className: "ak-editor-panel__icon" }, this.getIcon()),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "ak-editor-panel__content" }, children)));
    };
    Panel.prototype.getIcon = function () {
        var panelType = this.props.panelType;
        // tslint:disable-next-line:variable-name
        var Icon = config[panelType].icon;
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Icon, { label: "Panel " + panelType });
    };
    return Panel;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Panel);
//# sourceMappingURL=panel.js.map

/***/ }),
/* 3092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(102));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorInfoIcon = function EditorInfoIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-8.5a1 1 0 0 0-1 1V15a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1zm0-1.125a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorInfoIcon.displayName = 'EditorInfoIcon';
var _default = EditorInfoIcon;
exports.default = _default;

/***/ }),
/* 3093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(102));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorHintIcon = function EditorHintIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M14 16h-4s0-.5-1-2-2.5-3-2.5-5S7 4 12 4s5.5 3 5.5 5-1.5 3.5-2.5 5-1 2-1 2zm-4 1h4v1l-1.5 2h-1L10 18v-1z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorHintIcon.displayName = 'EditorHintIcon';
var _default = EditorHintIcon;
exports.default = _default;

/***/ }),
/* 3094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(102));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorSuccessIcon = function EditorSuccessIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm1.364-10.964l-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var _default = EditorSuccessIcon;
exports.default = _default;

/***/ }),
/* 3095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(102));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorErrorIcon = function EditorErrorIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M13.485 11.929l2.122-2.121a1 1 0 0 0-1.415-1.415l-2.12 2.122L9.95 8.393a1 1 0 0 0-1.414 1.415l2.12 2.12-2.12 2.122a1 1 0 0 0 1.414 1.414l2.121-2.12 2.121 2.12a1 1 0 1 0 1.415-1.414l-2.122-2.121zM12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorErrorIcon.displayName = 'EditorErrorIcon';
var _default = EditorErrorIcon;
exports.default = _default;

/***/ }),
/* 3096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(102));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EditorNoteIcon = function EditorNoteIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path d=\"M8 4h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm1.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-5zm0 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-3z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
  }, props));
};

EditorNoteIcon.displayName = 'EditorNoteIcon';
var _default = EditorNoteIcon;
exports.default = _default;

/***/ }),
/* 3097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(102));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var WarningIcon = function WarningIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill-rule=\"evenodd\"><path d=\"M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771L12.938 4.967z\" fill=\"currentColor\"/><path d=\"M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2\" fill=\"inherit\"/></g></svg>"
  }, props));
};

WarningIcon.displayName = 'WarningIcon';
var _default = WarningIcon;
exports.default = _default;

/***/ }),
/* 3098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Paragraph;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inline__ = __webpack_require__(1274);


function Paragraph(_a) {
    var children = _a.children;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__inline__["a" /* default */], null, children)));
}
//# sourceMappingURL=paragraph.js.map

/***/ }),
/* 3099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Placeholder;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function Placeholder(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null);
}
//# sourceMappingURL=placeholder.js.map

/***/ }),
/* 3100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Rule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function Rule(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("hr", null);
}
//# sourceMappingURL=rule.js.map

/***/ }),
/* 3101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__task_item_with_providers__ = __webpack_require__(3102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_analytics_namespaced_context__ = __webpack_require__(248);






var TaskItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](TaskItem, _super);
    function TaskItem(props) {
        var _this = _super.call(this, props) || this;
        _this.renderWithProvider = function (providers) {
            var taskDecisionProvider = providers.taskDecisionProvider, contextIdentifierProvider = providers.contextIdentifierProvider;
            var _a = _this.props, children = _a.children, localId = _a.localId, state = _a.state, rendererContext = _a.rendererContext;
            var objectAri = '';
            var containerAri = '';
            if (rendererContext) {
                objectAri = rendererContext.objectAri || '';
                containerAri = rendererContext.containerAri || '';
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__atlaskit_analytics_namespaced_context__["a" /* FabricElementsAnalyticsContext */], { data: {
                    userContext: 'document',
                } },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__task_item_with_providers__["a" /* default */], { objectAri: objectAri, containerAri: containerAri, taskId: localId, isDone: state === 'DONE', taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider }, children)));
        };
        _this.providerFactory = props.providers || new __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["e" /* ProviderFactory */]();
        return _this;
    }
    TaskItem.prototype.componentWillUnmount = function () {
        if (!this.props.providers) {
            // new ProviderFactory is created if no `providers` has been set
            // in this case when component is unmounted it's safe to destroy this providerFactory
            this.providerFactory.destroy();
        }
    };
    TaskItem.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["j" /* WithProviders */], { providers: ['taskDecisionProvider', 'contextIdentifierProvider'], providerFactory: this.providerFactory, renderNode: this.renderWithProvider }));
    };
    return TaskItem;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (TaskItem);
//# sourceMappingURL=taskItem.js.map

/***/ }),
/* 3102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_task_decision__ = __webpack_require__(183);




var TaskItemWithProviders = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](TaskItemWithProviders, _super);
    function TaskItemWithProviders() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { resolvedContextProvider: undefined };
        return _this;
    }
    TaskItemWithProviders.prototype.componentWillMount = function () {
        this.updateContextIdentifierProvider(this.props);
    };
    TaskItemWithProviders.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.contextIdentifierProvider !==
            this.props.contextIdentifierProvider) {
            this.updateContextIdentifierProvider(nextProps);
        }
    };
    TaskItemWithProviders.prototype.updateContextIdentifierProvider = function (props) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"](this, void 0, void 0, function () {
            var resolvedContextProvider, err_1;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!props.contextIdentifierProvider) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, props.contextIdentifierProvider];
                    case 2:
                        resolvedContextProvider = _a.sent();
                        this.setState({ resolvedContextProvider: resolvedContextProvider });
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        this.setState({ resolvedContextProvider: undefined });
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        this.setState({ resolvedContextProvider: undefined });
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    TaskItemWithProviders.prototype.render = function () {
        var _a = this.props, contextIdentifierProvider = _a.contextIdentifierProvider, objectAri = _a.objectAri, containerAri = _a.containerAri, otherProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"](_a, ["contextIdentifierProvider", "objectAri", "containerAri"]);
        var _b = this.state.resolvedContextProvider ||
            {
                objectId: objectAri,
                containerId: containerAri,
            }, objectId = _b.objectId, containerId = _b.containerId;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_task_decision__["c" /* ResourcedTaskItem */], __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, otherProps, { objectAri: objectId, containerAri: containerId })));
    };
    return TaskItemWithProviders;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (TaskItemWithProviders);
//# sourceMappingURL=task-item-with-providers.js.map

/***/ }),
/* 3103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_task_decision__ = __webpack_require__(183);




var TaskList = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](TaskList, _super);
    function TaskList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TaskList.prototype.render = function () {
        var _a = this.props, children = _a.children, localId = _a.localId;
        if (__WEBPACK_IMPORTED_MODULE_1_react__["Children"].count(children) === 0) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "akTaskList" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_task_decision__["d" /* TaskList */], { listId: localId }, children)));
    };
    return TaskList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (TaskList);
//# sourceMappingURL=taskList.js.map

/***/ }),
/* 3104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_overflow_shadow__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tableHeader__ = __webpack_require__(1275);





var isHeaderRowEnabled = function (rows) {
    if (!rows.length) {
        return false;
    }
    var children = rows[0].props.children;
    if (!children.length) {
        return false;
    }
    return children[0].type === __WEBPACK_IMPORTED_MODULE_4__tableHeader__["a" /* default */];
};
var addNumberColumnIndexes = function (rows) {
    var headerRowEnabled = isHeaderRowEnabled(rows);
    return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].map(rows, function (row, index) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(row), {
            isNumberColumnEnabled: true,
            index: headerRowEnabled ? (index === 0 ? '' : index) : index + 1,
        });
    });
};
var Table = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Table, _super);
    function Table() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderColgroup = function () {
            var _a = _this.props, columnWidths = _a.columnWidths, isNumberColumnEnabled = _a.isNumberColumnEnabled;
            if (!columnWidths) {
                return null;
            }
            var actualWidth = 0;
            if (_this.wrapper) {
                actualWidth = _this.wrapper.offsetWidth;
            }
            else {
                _this.forceUpdate();
                return;
            }
            var minTableWidth = columnWidths.reduce(function (acc, width) {
                return (acc += Math.ceil(width) || __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["M" /* tableCellMinWidth */]);
            }, 0);
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("colgroup", null,
                isNumberColumnEnabled && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("col", { style: { width: __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["o" /* akEditorTableNumberColumnWidth */] } })),
                columnWidths.map(function (colWidth, idx) {
                    var width;
                    // @see ED-5775:
                    // we can't rely on css min-width as long as we use "table-layout: fixed"
                    // therefore if a column is not resized, we enforce min-width when table is smaller than minimum table width
                    if (colWidth) {
                        width = colWidth < __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["M" /* tableCellMinWidth */] ? __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["M" /* tableCellMinWidth */] : colWidth;
                    }
                    else {
                        width = actualWidth <= minTableWidth ? __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["M" /* tableCellMinWidth */] : 0;
                    }
                    var style = width ? { width: width + "px" } : {};
                    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("col", { key: idx, style: style });
                })));
        };
        return _this;
    }
    Table.prototype.render = function () {
        var _this = this;
        var _a = this.props, isNumberColumnEnabled = _a.isNumberColumnEnabled, layout = _a.layout, children = _a.children;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["h" /* WidthConsumer */], null, function (_a) {
            var width = _a.width;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["f" /* TableSharedCssClassName */].TABLE_CONTAINER + " " + _this.props.shadowClassNames, "data-layout": layout, ref: function (ref) {
                    _this.wrapper = ref;
                    _this.props.handleRef(ref);
                }, style: { width: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["v" /* calcTableWidth */])(layout, width, false) } },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["f" /* TableSharedCssClassName */].TABLE_NODE_WRAPPER },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("table", { "data-number-column": isNumberColumnEnabled },
                        _this.renderColgroup(),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tbody", null, isNumberColumnEnabled
                            ? addNumberColumnIndexes(children)
                            : children)))));
        }));
    };
    return Table;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__ui_overflow_shadow__["a" /* default */])(Table, {
    overflowSelector: "." + __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_common__["f" /* TableSharedCssClassName */].TABLE_NODE_WRAPPER,
    scrollableSelector: 'table',
}));
//# sourceMappingURL=table.js.map

/***/ }),
/* 3105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_editor_common__ = __webpack_require__(80);


// tslint:disable-next-line:variable-name
var TableCell = function (props) {
    var style = {};
    if (props.background) {
        // we do this when doing toDOM, so do here as well
        var color = Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_editor_common__["D" /* hexToRgba */])(props.background, __WEBPACK_IMPORTED_MODULE_1__atlaskit_editor_common__["n" /* akEditorTableCellBackgroundOpacity */]);
        style['background-color'] = color;
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { style: style, rowSpan: props.rowspan, colSpan: props.colspan }, props.children));
};
/* harmony default export */ __webpack_exports__["a"] = (TableCell);
//# sourceMappingURL=tableCell.js.map

/***/ }),
/* 3106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts__ = __webpack_require__(306);


// tslint:disable-next-line:variable-name
var TableRow = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr", null,
        props.isNumberColumnEnabled && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td", { className: __WEBPACK_IMPORTED_MODULE_1__consts__["a" /* RendererCssClassName */].NUMBER_COLUMN }, props.index)),
        props.children));
};
/* harmony default export */ __webpack_exports__["a"] = (TableRow);
//# sourceMappingURL=tableRow.js.map

/***/ }),
/* 3107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UnknownBlock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function UnknownBlock(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "UnknownBlock" }, props.children);
}
//# sourceMappingURL=unknownBlock.js.map

/***/ }),
/* 3108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export markToReact */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toReact; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__code__ = __webpack_require__(3109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__em__ = __webpack_require__(3110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__link__ = __webpack_require__(3111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__strike__ = __webpack_require__(3112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__strong__ = __webpack_require__(3113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__subsup__ = __webpack_require__(3114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__textColor__ = __webpack_require__(3115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__underline__ = __webpack_require__(3116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__action__ = __webpack_require__(3117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__breakout__ = __webpack_require__(3118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__alignment__ = __webpack_require__(3119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__indentation__ = __webpack_require__(3120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__confluence_inline_comment__ = __webpack_require__(3121);
/* unused harmony reexport Code */
/* unused harmony reexport Em */
/* unused harmony reexport Link */
/* unused harmony reexport Strike */
/* unused harmony reexport Strong */
/* unused harmony reexport Subsup */
/* unused harmony reexport TextColor */
/* unused harmony reexport Underline */
/* unused harmony reexport Action */
/* unused harmony reexport Breakout */












// Stage0

var markToReact = {
    code: __WEBPACK_IMPORTED_MODULE_0__code__["a" /* default */],
    em: __WEBPACK_IMPORTED_MODULE_1__em__["a" /* default */],
    link: __WEBPACK_IMPORTED_MODULE_2__link__["a" /* default */],
    strike: __WEBPACK_IMPORTED_MODULE_3__strike__["a" /* default */],
    strong: __WEBPACK_IMPORTED_MODULE_4__strong__["a" /* default */],
    subsup: __WEBPACK_IMPORTED_MODULE_5__subsup__["a" /* default */],
    textColor: __WEBPACK_IMPORTED_MODULE_6__textColor__["a" /* default */],
    underline: __WEBPACK_IMPORTED_MODULE_7__underline__["a" /* default */],
    action: __WEBPACK_IMPORTED_MODULE_8__action__["a" /* default */],
    // Stage0
    confluenceInlineComment: __WEBPACK_IMPORTED_MODULE_12__confluence_inline_comment__["a" /* default */],
    breakout: __WEBPACK_IMPORTED_MODULE_9__breakout__["a" /* default */],
    alignment: __WEBPACK_IMPORTED_MODULE_10__alignment__["a" /* default */],
    indentation: __WEBPACK_IMPORTED_MODULE_11__indentation__["a" /* default */],
};
var toReact = function (mark) {
    return markToReact[mark.type.name];
};

//# sourceMappingURL=index.js.map

/***/ }),
/* 3109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_code__ = __webpack_require__(940);




var Code = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Code, _super);
    function Code() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Code.prototype.render = function () {
        var children = this.props.children;
        if (typeof children === 'string') {
            /**
             * It could be used like
             * <Code>This is the text</Code>
             */
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_code__["a" /* AkCode */], { language: "text", text: children });
        }
        if (Array.isArray(children) && typeof children[0] === 'string') {
            /**
             * The React Serializer would generically wrap all content in an array,
             * so it would actually looks like
             * <Code>{['This is the text']}</Code>
             */
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_code__["a" /* AkCode */], { language: "text", text: children.join('') });
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__atlaskit_code__["a" /* AkCode */], { language: "text", text: '' });
    };
    return Code;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Code);
//# sourceMappingURL=code.js.map

/***/ }),
/* 3110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Em;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function Em(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", null, props.children);
}
//# sourceMappingURL=em.js.map

/***/ }),
/* 3111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Link;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(144);





// tslint:disable-next-line:variable-name
var StyledAnchor = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].a(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n    text-decoration: underline;\n  }\n"], ["\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n    text-decoration: underline;\n  }\n"])), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B400, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["colors"].B300);
function Link(props) {
    var href = props.href, target = props.target, eventHandlers = props.eventHandlers;
    var anchorProps = {
        href: href,
        target: target,
        title: href,
    };
    if (target === '_blank') {
        anchorProps.rel = 'noreferrer noopener';
    }
    var handler = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* getEventHandler */])(eventHandlers, 'link');
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](StyledAnchor, __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ onClick: function (e) {
            if (handler) {
                handler(e, href);
            }
        } }, anchorProps), props.children));
}
var templateObject_1;
//# sourceMappingURL=link.js.map

/***/ }),
/* 3112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Strike;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function Strike(props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { style: { textDecoration: 'line-through' } }, props.children));
}
//# sourceMappingURL=strike.js.map

/***/ }),
/* 3113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Strong;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function Strong(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("strong", null, props.children);
}
//# sourceMappingURL=strong.js.map

/***/ }),
/* 3114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SubSup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var isSub = function (type) {
    return type === 'sub';
};
function SubSup(props) {
    if (isSub(props.type)) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("sub", null, props.children);
    }
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("sup", null, props.children);
}
//# sourceMappingURL=subsup.js.map

/***/ }),
/* 3115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TextColor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function TextColor(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { style: { color: props.color } }, props.children);
}
//# sourceMappingURL=textColor.js.map

/***/ }),
/* 3116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Underline;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function Underline(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("u", null, props.children);
}
//# sourceMappingURL=underline.js.map

/***/ }),
/* 3117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



var Action = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Action, _super);
    function Action() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function () {
            if (_this.props.eventHandlers &&
                _this.props.eventHandlers.action &&
                _this.props.eventHandlers.action.onClick) {
                _this.props.eventHandlers.action.onClick({
                    key: _this.props.markKey,
                    target: _this.props.target,
                    parameters: _this.props.parameters,
                });
            }
        };
        return _this;
    }
    Action.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "akActionMark", onClick: this.onClick }, this.props.children));
    };
    return Action;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Action);
//# sourceMappingURL=action.js.map

/***/ }),
/* 3118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Wrapper */
/* harmony export (immutable) */ __webpack_exports__["a"] = Breakout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(80);




var Wrapper = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  margin: ", " 0;\n  margin-left: 50%;\n  transform: translateX(-50%);\n"], ["\n  margin: ", " 0;\n  margin-left: 50%;\n  transform: translateX(-50%);\n"])), __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["r" /* blockNodesVerticalMargin */]);
function Breakout(props) {
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["h" /* WidthConsumer */], null, function (_a) {
        var width = _a.width, breakpoint = _a.breakpoint;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Wrapper, { "data-mode": props.mode, style: { width: Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["u" /* calcBreakoutWidth */])(props.mode, width) }, className: "fabric-editor-breakout-mark" }, props.children));
    }));
}
var templateObject_1;
//# sourceMappingURL=breakout.js.map

/***/ }),
/* 3119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Alignment;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_adf_schema__ = __webpack_require__(19);




var MarkWrapper = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_2 || (templateObject_2 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    return props['data-align'] && Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n      text-align: ", ";\n    "], ["\n      text-align: ", ";\n    "])), __WEBPACK_IMPORTED_MODULE_3__atlaskit_adf_schema__["d" /* alignmentPositionMap */][props['data-align']]);
});
function Alignment(props) {
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MarkWrapper, { className: "fabric-editor-block-mark", "data-align": props.align }, props.children));
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=alignment.js.map

/***/ }),
/* 3120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Indentation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function Indentation(props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "fabric-editor-block-mark fabric-editor-indentation-mark", "data-level": props.level }, props.children));
}
//# sourceMappingURL=indentation.js.map

/***/ }),
/* 3121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



var ConfluenceInlineComment = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ConfluenceInlineComment, _super);
    function ConfluenceInlineComment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConfluenceInlineComment.prototype.render = function () {
        var _a = this.props, reference = _a.reference, children = _a.children;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { "data-mark-type": "confluenceInlineComment", "data-reference": reference }, children));
    };
    return ConfluenceInlineComment;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (ConfluenceInlineComment);
//# sourceMappingURL=confluence-inline-comment.js.map

/***/ }),
/* 3122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nodes__ = __webpack_require__(85);


var TextSerializer = /** @class */ (function () {
    function TextSerializer(schema) {
        this.schema = schema;
        this.schema = schema;
    }
    TextSerializer.prototype.serializeFragment = function (fragment) {
        var _this = this;
        var result = [];
        fragment.forEach(function (n) {
            result.push(Object(__WEBPACK_IMPORTED_MODULE_1__nodes__["a" /* reduce */])(n, _this.schema));
        });
        return result.join('\n').replace(/\n+/g, '\n');
    };
    TextSerializer.fromSchema = function (schema) {
        if (schema === void 0) { schema = __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["x" /* defaultSchema */]; }
        return new TextSerializer(schema);
    };
    return TextSerializer;
}());
/* unused harmony default export */ var _unused_webpack_default_export = (TextSerializer);
//# sourceMappingURL=index.js.map

/***/ }),
/* 3123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(85);

var blockquote = function (node, schema) {
    var result = [];
    node.content.forEach(function (n) {
        result.push(Object(__WEBPACK_IMPORTED_MODULE_0____["a" /* reduce */])(n, schema));
    });
    return "> " + result.join('');
};
/* harmony default export */ __webpack_exports__["a"] = (blockquote);
//# sourceMappingURL=blockquote.js.map

/***/ }),
/* 3124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(85);

var bulletList = function (node, schema) {
    var result = [];
    node.forEach(function (n) {
        result.push("* " + Object(__WEBPACK_IMPORTED_MODULE_0____["a" /* reduce */])(n, schema));
    });
    return result.join('\n');
};
/* harmony default export */ __webpack_exports__["a"] = (bulletList);
//# sourceMappingURL=bulletList.js.map

/***/ }),
/* 3125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(85);

var decisionItem = function (node, schema) {
    var result = [];
    var previousNodeType = '';
    node.forEach(function (n) {
        var text = Object(__WEBPACK_IMPORTED_MODULE_0____["a" /* reduce */])(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) {
            result.push(" " + text);
        }
        else {
            result.push(text);
        }
        previousNodeType = n.type.name;
    });
    return "<> " + result.join('').trim();
};
/* harmony default export */ __webpack_exports__["a"] = (decisionItem);
//# sourceMappingURL=decisionItem.js.map

/***/ }),
/* 3126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var hardBreak = function (node) {
    return '\n';
};
/* harmony default export */ __webpack_exports__["a"] = (hardBreak);
//# sourceMappingURL=hardBreak.js.map

/***/ }),
/* 3127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(85);

var heading = function (node, schema) {
    var result = [];
    node.forEach(function (n) {
        result.push(Object(__WEBPACK_IMPORTED_MODULE_0____["a" /* reduce */])(n, schema));
    });
    return result.join('');
};
/* harmony default export */ __webpack_exports__["a"] = (heading);
//# sourceMappingURL=heading.js.map

/***/ }),
/* 3128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(85);

var listItem = function (node, schema) {
    var result = [];
    node.forEach(function (n) {
        result.push(Object(__WEBPACK_IMPORTED_MODULE_0____["a" /* reduce */])(n, schema));
    });
    return result.join('\n');
};
/* harmony default export */ __webpack_exports__["a"] = (listItem);
//# sourceMappingURL=listItem.js.map

/***/ }),
/* 3129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mediaGroup = function (node) {
    // count children which are media files
    // ignore card links
    var childMediaFilesCount = 0;
    node.content.forEach(function (childNode) {
        if (childNode.attrs.type === 'file') {
            childMediaFilesCount += 1;
        }
    });
    if (childMediaFilesCount) {
        var postfix = childMediaFilesCount > 1 ? 'Files' : 'File';
        return "\uD83D\uDCCE " + childMediaFilesCount + " " + postfix;
    }
    return '';
};
/* harmony default export */ __webpack_exports__["a"] = (mediaGroup);
//# sourceMappingURL=mediaGroup.js.map

/***/ }),
/* 3130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(85);

var orderedList = function (node, schema) {
    var result = [];
    node.forEach(function (n, offset, index) {
        result.push(index + 1 + ". " + Object(__WEBPACK_IMPORTED_MODULE_0____["a" /* reduce */])(n, schema));
    });
    return result.join('\n');
};
/* harmony default export */ __webpack_exports__["a"] = (orderedList);
//# sourceMappingURL=orderedList.js.map

/***/ }),
/* 3131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(85);

var panel = function (node, schema) {
    var result = [];
    node.forEach(function (n) {
        result.push(Object(__WEBPACK_IMPORTED_MODULE_0____["a" /* reduce */])(n, schema));
    });
    return result.join('\n');
};
/* harmony default export */ __webpack_exports__["a"] = (panel);
//# sourceMappingURL=panel.js.map

/***/ }),
/* 3132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(85);

var paragraph = function (node, schema) {
    var result = [];
    var previousNodeType = '';
    node.forEach(function (n) {
        var text = Object(__WEBPACK_IMPORTED_MODULE_0____["a" /* reduce */])(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) {
            result.push(" " + text);
        }
        else {
            result.push(text);
        }
        previousNodeType = n.type.name;
    });
    return result.join('').trim();
};
/* harmony default export */ __webpack_exports__["a"] = (paragraph);
//# sourceMappingURL=paragraph.js.map

/***/ }),
/* 3133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rule = function (node) {
    return '';
};
/* harmony default export */ __webpack_exports__["a"] = (rule);
//# sourceMappingURL=rule.js.map

/***/ }),
/* 3134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(85);

var table = function (node, schema) {
    var result = [];
    node.forEach(function (n) {
        result.push(tableRow(n, schema));
    });
    return result.join('\n');
};
var tableRow = function (node, schema) {
    var result = [];
    var separator = '|';
    node.forEach(function (n) {
        result.push(tableCell(n, schema));
    });
    return "" + separator + result.join("" + separator) + separator;
};
var tableCell = function (node, schema) {
    var result = [];
    node.forEach(function (n) {
        result.push(Object(__WEBPACK_IMPORTED_MODULE_0____["a" /* reduce */])(n, schema));
    });
    return result.join('\n');
};
/* harmony default export */ __webpack_exports__["a"] = (table);
//# sourceMappingURL=table.js.map

/***/ }),
/* 3135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(85);

var taskItem = function (node, schema) {
    var result = [];
    var previousNodeType = '';
    var state = node.attrs.state === 'DONE' ? '[x]' : '[]';
    node.forEach(function (n) {
        var text = Object(__WEBPACK_IMPORTED_MODULE_0____["a" /* reduce */])(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) {
            result.push(" " + text);
        }
        else {
            result.push(text);
        }
        previousNodeType = n.type.name;
    });
    return state + " " + result.join('').trim();
};
/* harmony default export */ __webpack_exports__["a"] = (taskItem);
//# sourceMappingURL=taskItem.js.map

/***/ }),
/* 3136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(85);


var unknown = function (node, schema) {
    var result = [];
    node.forEach(function (n) {
        result.push(Object(__WEBPACK_IMPORTED_MODULE_1____["a" /* reduce */])(n, schema));
    });
    if (result.length > 0) {
        return result.join('');
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* getText */])(node);
};
/* harmony default export */ __webpack_exports__["a"] = (unknown);
//# sourceMappingURL=unknown.js.map

/***/ }),
/* 3137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__serializers__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_adf_schema__ = __webpack_require__(19);





var serializeNode = function (node, serializedHTML) {
    // ignore nodes with unknown type
    if (!__WEBPACK_IMPORTED_MODULE_2__serializers__["b" /* nodeSerializers */][node.type.name]) {
        return "[UNKNOWN_NODE_TYPE: " + node.type.name + "]";
    }
    var attrs = node.type.name === 'table' ? getTableAttrs(node) : node.attrs;
    return __WEBPACK_IMPORTED_MODULE_2__serializers__["b" /* nodeSerializers */][node.type.name]({
        attrs: attrs,
        marks: node.marks,
        text: serializedHTML || node.attrs.text || node.attrs.shortName || node.text,
    });
};
var getTableAttrs = function (node) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, node.attrs, { columnWidths: Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_adf_schema__["k" /* calcTableColumnWidths */])(node) });
};
var traverseTree = function (fragment) {
    var output = '';
    fragment.forEach(function (childNode) {
        if (childNode.isLeaf) {
            output += serializeNode(childNode);
        }
        else {
            var innerHTML = traverseTree(childNode.content);
            output += serializeNode(childNode, innerHTML);
        }
    });
    return output;
};
var wrapperCSS = Object(__WEBPACK_IMPORTED_MODULE_3__util__["c" /* serializeStyle */])({
    'font-family': Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["fontFamily"])(),
    'font-size': Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["fontSize"])(),
    'font-weight': 400,
    'line-height': '24px',
});
var EmailSerializer = /** @class */ (function () {
    function EmailSerializer() {
    }
    EmailSerializer.prototype.serializeFragment = function (fragment) {
        var innerHTML = traverseTree(fragment);
        return "<div style=\"" + wrapperCSS + "\">" + innerHTML + "</div>";
    };
    EmailSerializer.fromSchema = function (schema) {
        return new EmailSerializer();
    };
    return EmailSerializer;
}());
/* unused harmony default export */ var _unused_webpack_default_export = (EmailSerializer);
//# sourceMappingURL=index.js.map

/***/ }),
/* 3138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = blockquote;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(33);


var css = Object(__WEBPACK_IMPORTED_MODULE_1__util__["c" /* serializeStyle */])({
    'border-left': "2px solid " + __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N40,
    color: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N300,
    margin: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["gridSize"])() * 1.5 + "px 0 0 0",
    'padding-left': Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["gridSize"])() * 2 + "px",
});
function blockquote(_a) {
    var text = _a.text;
    return Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* createTag */])('blockquote', { style: css }, text);
}
//# sourceMappingURL=blockquote.js.map

/***/ }),
/* 3139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bulletList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(33);

var css = Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* serializeStyle */])({
    'list-style-type': 'disc',
});
function bulletList(_a) {
    var text = _a.text;
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* createTag */])('ul', { style: css }, text);
}
//# sourceMappingURL=bullet-list.js.map

/***/ }),
/* 3140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = codeBlock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(33);

var css = Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* serializeStyle */])({
    background: 'rgb(244, 245, 247)',
    'border-radius': '3px',
    color: 'rgb(23, 43, 77)',
    display: 'block',
    'font-size': '12px',
    'line-height': '20px',
    padding: '8px 16px',
    'white-space': 'pre',
});
function codeBlock(_a) {
    var attrs = _a.attrs, text = _a.text;
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* createTag */])('code', { style: css }, text);
}
//# sourceMappingURL=code-block.js.map

/***/ }),
/* 3141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = decisionItem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(33);


var akGridSize = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["gridSize"])();
var css = Object(__WEBPACK_IMPORTED_MODULE_1__util__["c" /* serializeStyle */])({
    'background-color': __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N20,
    'border-radius': Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["borderRadius"])() + "px",
    margin: akGridSize + "px 0",
    padding: akGridSize + "px " + akGridSize + "px",
    'box-sizing': 'border-box',
});
function decisionItem(_a) {
    var text = _a.text;
    if (!text) {
        return '';
    }
    return Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* createTag */])('div', { style: css }, text);
}
//# sourceMappingURL=decision-item.js.map

/***/ }),
/* 3142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = decisionList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(33);

function decisionList(_a) {
    var text = _a.text;
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* createTag */])('div', {}, text);
}
//# sourceMappingURL=decision-list.js.map

/***/ }),
/* 3143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = emoji;
function emoji(_a) {
    var attrs = _a.attrs;
    return attrs.text || attrs.shortName;
}
//# sourceMappingURL=emoji.js.map

/***/ }),
/* 3144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hardBreak;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(33);

function hardBreak() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* createTag */])('br');
}
//# sourceMappingURL=hard-break.js.map

/***/ }),
/* 3145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = heading;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(33);


var getTypoMixin = function (tagName) {
    switch (tagName) {
        case 'h1':
            return __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["typography"].h800();
        case 'h2':
            return __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["typography"].h700();
        case 'h3':
            return __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["typography"].h600();
        case 'h4':
            return __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["typography"].h500();
        case 'h5':
            return __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["typography"].h400();
        case 'h6':
            return __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["typography"].h300();
        default:
            throw new Error("Unknown tagName: " + tagName);
    }
};
function heading(_a) {
    var attrs = _a.attrs, text = _a.text;
    var tagName = "h" + attrs.level;
    var css = getTypoMixin(tagName).join().trim();
    return Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* createTag */])(tagName, { style: css }, text);
}
//# sourceMappingURL=heading.js.map

/***/ }),
/* 3146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = listItem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(33);

function listItem(_a) {
    var text = _a.text;
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* createTag */])('li', {}, text);
}
//# sourceMappingURL=list-item.js.map

/***/ }),
/* 3147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mention;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(33);

var css = Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* serializeStyle */])({
    background: 'rgba(9, 30, 66, 0.08)',
    border: '1px solid transparent',
    'border-radius': '20px',
    color: '#42526E',
    padding: '0 4px 2px 3px',
    'white-space': 'nowrap',
});
function mention(_a) {
    var text = _a.text;
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* createTag */])('span', { style: css }, text);
}
//# sourceMappingURL=mention.js.map

/***/ }),
/* 3148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = orderedList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(33);

var css = Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* serializeStyle */])({
    'list-style-type': 'decimal',
});
function orderedList(_a) {
    var text = _a.text;
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* createTag */])('ol', { style: css }, text);
}
//# sourceMappingURL=ordered-list.js.map

/***/ }),
/* 3149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = panel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(33);


var config = {
    info: {
        background: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B50,
        iconColor: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].B400,
    },
    note: {
        background: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P50,
        iconColor: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].P400,
    },
    tip: {
        background: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].G50,
        iconColor: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].G400,
    },
    success: {
        background: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].G50,
        iconColor: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].G400,
    },
    warning: {
        background: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y50,
        iconColor: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].Y400,
    },
    error: {
        background: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R50,
        iconColor: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].R400,
    },
};
function panel(_a) {
    var attrs = _a.attrs, text = _a.text;
    var css = Object(__WEBPACK_IMPORTED_MODULE_1__util__["c" /* serializeStyle */])({
        'border-radius': Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["borderRadius"])() + "px",
        margin: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["gridSize"])() / 2 + "px 0",
        padding: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["gridSize"])() + "px",
        background: config[attrs.panelType] && config[attrs.panelType].background,
    });
    return Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* createTag */])('div', { style: css }, text);
}
//# sourceMappingURL=panel.js.map

/***/ }),
/* 3150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = paragraph;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(33);

var css = Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* serializeStyle */])({
    'white-space': 'pre-wrap',
    'word-wrap': 'break-word',
});
function paragraph(_a) {
    var text = _a.text;
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* createTag */])('p', { style: css }, text);
}
//# sourceMappingURL=paragraph.js.map

/***/ }),
/* 3151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(33);


var css = Object(__WEBPACK_IMPORTED_MODULE_1__util__["c" /* serializeStyle */])({
    border: 'none',
    'border-bottom': "1px solid " + __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N30A,
});
function rule() {
    return Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* createTag */])('hr', { style: css });
}
//# sourceMappingURL=rule.js.map

/***/ }),
/* 3152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = table;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(33);


var css = Object(__WEBPACK_IMPORTED_MODULE_1__util__["c" /* serializeStyle */])({
    border: "1px solid " + __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["colors"].N50,
    'border-collapse': 'collapse',
    margin: '20px 8px',
    width: 'auto',
});
function table(_a) {
    var attrs = _a.attrs, text = _a.text;
    var colgroup = '';
    if (attrs.columnWidths) {
        var colTags = attrs.columnWidths.map(function (colwidth) {
            var style = colwidth ? "width: " + colwidth + "px" : undefined;
            return Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* createTag */])('col', { style: style });
        });
        colgroup = Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* createTag */])('colgroup', undefined, colTags.join(''));
    }
    return Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* createTag */])('table', { style: css }, colgroup + text);
}
//# sourceMappingURL=table.js.map

/***/ }),
/* 3153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = tableCell;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(33);



var baseStyle = {
    'background-clip': 'padding-box',
    height: '2.5em',
    'min-width': '3em',
    'vertical-align': 'top',
    border: "1px solid " + __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N50,
    'border-right-width': 0,
    'border-bottom-width': 0,
    padding: '6px 10px',
};
function tableCell(_a) {
    var attrs = _a.attrs, text = _a.text;
    var colspan = attrs.colspan, rowspan = attrs.rowspan, background = attrs.background;
    var style = Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* serializeStyle */])(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, baseStyle, { 'background-color': background }));
    return Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* createTag */])('td', {
        colspan: colspan,
        rowspan: rowspan,
        style: style,
    }, text);
}
//# sourceMappingURL=table-cell.js.map

/***/ }),
/* 3154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = tableHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(33);



var baseStyle = {
    'background-color': __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N20,
    'background-clip': 'padding-box',
    border: "1px solid " + __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N50,
    'border-right-width': 0,
    'border-bottom-width': 0,
    'font-weight': 'bold',
    height: '2.5em',
    'min-width': '3em',
    padding: '6px 10px',
    'text-align': 'left',
    'vertical-align': 'top',
};
function tableHeader(_a) {
    var attrs = _a.attrs, text = _a.text;
    var colspan = attrs.colspan, rowspan = attrs.rowspan, background = attrs.background;
    var style = Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* serializeStyle */])(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({}, baseStyle, { 'background-color': background ? background : baseStyle['background-color'] }));
    return Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* createTag */])('th', {
        colspan: colspan,
        rowspan: rowspan,
        style: style,
    }, text);
}
//# sourceMappingURL=table-header.js.map

/***/ }),
/* 3155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = tableRow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(33);

function tableRow(_a) {
    var text = _a.text;
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* createTag */])('tr', {}, text);
}
//# sourceMappingURL=table-row.js.map

/***/ }),
/* 3156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = text;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(33);

function text(_a) {
    var marks = _a.marks, text = _a.text;
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* applyMarks */])(marks, text);
}
//# sourceMappingURL=text.js.map

/***/ }),
/* 3157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = unknownBlock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(33);

function unknownBlock(_a) {
    var marks = _a.marks, text = _a.text;
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* applyMarks */])(marks, text);
}
//# sourceMappingURL=unknown-block.js.map

/***/ }),
/* 3158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = code;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(33);

var css = Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* serializeStyle */])({
    background: 'rgb(244, 245, 247)',
    color: 'rgb(23, 43, 77)',
    'border-radius': '3px',
    padding: '2px 4px',
});
function code(_a) {
    var mark = _a.mark, text = _a.text;
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* createTag */])('code', { style: css }, text);
}
//# sourceMappingURL=code.js.map

/***/ }),
/* 3159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = link;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(33);

var css = Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* serializeStyle */])({
    border: 'none',
    background: 'transparent',
    color: '#0052cc',
});
function link(_a) {
    var mark = _a.mark, text = _a.text;
    var _b = mark.attrs, href = _b.href, title = _b.title;
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* createTag */])('a', {
        href: href,
        title: title,
        style: css,
    }, text);
}
//# sourceMappingURL=link.js.map

/***/ }),
/* 3160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = strike;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(33);

var css = Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* serializeStyle */])({
    'text-decoration': 'line-through',
});
function strike(_a) {
    var mark = _a.mark, text = _a.text;
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* createTag */])('span', { style: css }, text);
}
//# sourceMappingURL=strike.js.map

/***/ }),
/* 3161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subsup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(33);

function subsup(_a) {
    var mark = _a.mark, text = _a.text;
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* createTag */])(mark.attrs.type, {}, text);
}
//# sourceMappingURL=subsup.js.map

/***/ }),
/* 3162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = textColor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(33);

function textColor(_a) {
    var mark = _a.mark, text = _a.text;
    var css = Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* serializeStyle */])({ color: mark.attrs.color });
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* createTag */])('span', { style: css }, text);
}
//# sourceMappingURL=text-color.js.map

/***/ }),
/* 3163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = strong;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(33);

var css = Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* serializeStyle */])({
    'text-decoration': 'underline',
});
function strong(_a) {
    var mark = _a.mark, text = _a.text;
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* createTag */])('span', { style: css }, text);
}
//# sourceMappingURL=underline.js.map

/***/ }),
/* 3164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RendererWrapper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__truncated_wrapper__ = __webpack_require__(3165);








var Renderer = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Renderer, _super);
    function Renderer(props) {
        var _this = _super.call(this, props) || this;
        _this.providerFactory = props.dataProviders || new __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["e" /* ProviderFactory */]();
        _this.updateSerializer(props);
        return _this;
    }
    Renderer.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.portal !== this.props.portal) {
            this.updateSerializer(nextProps);
        }
    };
    Renderer.prototype.updateSerializer = function (props) {
        var eventHandlers = props.eventHandlers, portal = props.portal, rendererContext = props.rendererContext, document = props.document, extensionHandlers = props.extensionHandlers, schema = props.schema, appearance = props.appearance, disableHeadingIDs = props.disableHeadingIDs, allowDynamicTextSizing = props.allowDynamicTextSizing;
        this.serializer = new __WEBPACK_IMPORTED_MODULE_4____["c" /* ReactSerializer */]({
            providers: this.providerFactory,
            eventHandlers: eventHandlers,
            extensionHandlers: extensionHandlers,
            portal: portal,
            objectContext: __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({ adDoc: document, schema: schema }, rendererContext),
            appearance: appearance,
            disableHeadingIDs: disableHeadingIDs,
            allowDynamicTextSizing: allowDynamicTextSizing,
        });
    };
    Renderer.prototype.render = function () {
        var _a = this.props, document = _a.document, onComplete = _a.onComplete, schema = _a.schema, appearance = _a.appearance, adfStage = _a.adfStage, allowDynamicTextSizing = _a.allowDynamicTextSizing, maxHeight = _a.maxHeight, truncated = _a.truncated;
        try {
            var _b = Object(__WEBPACK_IMPORTED_MODULE_4____["d" /* renderDocument */])(document, this.serializer, schema || __WEBPACK_IMPORTED_MODULE_2__atlaskit_adf_schema__["x" /* defaultSchema */], adfStage), result = _b.result, stat = _b.stat;
            if (onComplete) {
                onComplete(stat);
            }
            var rendererOutput = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](RendererWrapper, { appearance: appearance, dynamicTextSizing: allowDynamicTextSizing }, result));
            return truncated ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__truncated_wrapper__["a" /* TruncatedWrapper */], { height: maxHeight }, rendererOutput)) : (rendererOutput);
        }
        catch (ex) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](RendererWrapper, { appearance: appearance, dynamicTextSizing: allowDynamicTextSizing },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["g" /* UnsupportedBlock */], null)));
        }
    };
    Renderer.prototype.componentWillUnmount = function () {
        var dataProviders = this.props.dataProviders;
        // if this is the ProviderFactory which was created in constructor
        // it's safe to destroy it on Renderer unmount
        if (!dataProviders) {
            this.providerFactory.destroy();
        }
    };
    return Renderer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));
/* harmony default export */ __webpack_exports__["a"] = (Renderer);
function RendererWrapper(_a) {
    var appearance = _a.appearance, children = _a.children, dynamicTextSizing = _a.dynamicTextSizing;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["i" /* WidthProvider */], null,
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__["a" /* BaseTheme */], { dynamicTextSizing: dynamicTextSizing },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__style__["b" /* Wrapper */], { appearance: appearance }, children))));
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 3165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TruncatedWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);




var FadeOut = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(templateObject_1 || (templateObject_1 = __WEBPACK_IMPORTED_MODULE_0_tslib__["__makeTemplateObject"](["\n  position: relative;\n  overflow-y: hidden;\n  max-height: ", "px;\n  &::after {\n    content: '';\n    position: absolute;\n    top: ", "px;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    /* Using 'rgba(255, 255, 255, 0)' because 'transparent' breaks the gradient in Safari 11 */\n    background-image: ", ";\n  }\n"], ["\n  position: relative;\n  overflow-y: hidden;\n  max-height: ", "px;\n  &::after {\n    content: '';\n    position: absolute;\n    top: ", "px;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    /* Using 'rgba(255, 255, 255, 0)' because 'transparent' breaks the gradient in Safari 11 */\n    background-image: ",
    ";\n  }\n"])), function (_a) {
    var height = _a.height;
    return height;
}, function (_a) {
    var height = _a.height, fadeHeight = _a.fadeHeight;
    return height - fadeHeight;
}, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return "linear-gradient(rgba(255, 255, 255, 0),  " + backgroundColor + ")";
});
var TruncatedWrapper = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](TruncatedWrapper, _super);
    function TruncatedWrapper(props) {
        return _super.call(this, props) || this;
    }
    TruncatedWrapper.prototype.render = function () {
        var _a = this.props, _b = _a.height, height = _b === void 0 ? 95 : _b, _c = _a.backgroundColor, backgroundColor = _c === void 0 ? 'white' : _c, children = _a.children;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](FadeOut, { height: height, fadeHeight: 24, backgroundColor: backgroundColor }, children));
    };
    return TruncatedWrapper;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

var templateObject_1;
//# sourceMappingURL=truncated-wrapper.js.map

/***/ }),
/* 3166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return renderDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return renderNodes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_editor_common__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_model__);



var SUPPORTS_HIRES_TIMER_API = window.performance && performance.now;
var withStopwatch = function (cb) {
    var startTime = SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    var output = cb();
    var endTime = SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    var time = endTime - startTime;
    return { output: output, time: time };
};
var renderDocument = function (doc, serializer, schema, adfStage) {
    if (schema === void 0) { schema = __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["x" /* defaultSchema */]; }
    if (adfStage === void 0) { adfStage = 'final'; }
    var stat = { sanitizeTime: 0 };
    var _a = withStopwatch(function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_editor_common__["z" /* getValidDocument */])(doc, schema, adfStage);
    }), validDoc = _a.output, sanitizeTime = _a.time;
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) {
        return { stat: stat, result: null };
    }
    var _b = withStopwatch(function () {
        var pmNode = schema.nodeFromJSON(validDoc);
        pmNode.check();
        return pmNode;
    }), node = _b.output, buildTreeTime = _b.time;
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    var _c = withStopwatch(function () {
        return serializer.serializeFragment(node.content);
    }), result = _c.output, serializeTime = _c.time;
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    return { result: result, stat: stat };
};
var renderNodes = function (nodes, serializer, schema, target, adfStage) {
    if (schema === void 0) { schema = __WEBPACK_IMPORTED_MODULE_0__atlaskit_adf_schema__["x" /* defaultSchema */]; }
    if (adfStage === void 0) { adfStage = 'final'; }
    var validNodes = nodes.map(function (n) { return Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_editor_common__["A" /* getValidNode */])(n, schema, adfStage); });
    var pmFragment = __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__["Fragment"].fromJSON(schema, validNodes);
    return serializer.serializeFragment(pmFragment, {}, target, 'node-0');
};
//# sourceMappingURL=render-document.js.map

/***/ }),
/* 3167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url_join__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_url_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_MentionResource__ = __webpack_require__(3168);
var api=__WEBPACK_IMPORTED_MODULE_0_url_join___default.a.bind(null,__WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].apiUrl);var Provider=function Provider(issueKey){return new __WEBPACK_IMPORTED_MODULE_2__util_MentionResource__["a" /* MentionResource */]({url:api('/ssp/mention'),issueKey:issueKey// securityProvider: () => {
//     return {
//         headers: {
//             ...getGlobalHeader(),
//             'Access-Control-Allow-Credentials': true
//         }
//     };
//   },
});};var mentionProvider=function mentionProvider(issueKey){return Promise.resolve(Provider(issueKey));};/* harmony default export */ __webpack_exports__["a"] = (mentionProvider);

/***/ }),
/* 3168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MentionResource; });
/* unused harmony export HttpError */
/* unused harmony export AbstractResource */
/* unused harmony export AbstractMentionResource */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(36);
var MAX_QUERY_ITEMS=100;var MAX_NOTIFIED_ITEMS=20;// var emptySecurityProvider = function () {
//     return {
//         params: {},
//         headers: {},
//     };
// };
var AbstractResource=/** @class */function(){function AbstractResource(){this.changeListeners=new Map();this.allResultsListeners=new Map();this.errListeners=new Map();this.infoListeners=new Map();}AbstractResource.prototype.subscribe=function(key,callback,errCallback,infoCallback,allResultsCallback){if(callback){this.changeListeners.set(key,callback);}if(errCallback){this.errListeners.set(key,errCallback);}if(infoCallback){this.infoListeners.set(key,infoCallback);}if(allResultsCallback){this.allResultsListeners.set(key,allResultsCallback);}};AbstractResource.prototype.unsubscribe=function(key){this.changeListeners.delete(key);this.errListeners.delete(key);this.infoListeners.delete(key);this.allResultsListeners.delete(key);};return AbstractResource;}();var AbstractMentionResource=/** @class */function(_super){__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AbstractMentionResource,_super);function AbstractMentionResource(){return _super!==null&&_super.apply(this,arguments)||this;}AbstractMentionResource.prototype.shouldHighlightMention=function(_mention){return false;};// eslint-disable-next-line class-methods-use-this
AbstractMentionResource.prototype.filter=function(query){throw new Error("not yet implemented.\nParams: query="+query);};// eslint-disable-next-line class-methods-use-this, no-unused-vars
AbstractMentionResource.prototype.recordMentionSelection=function(_mention){// Do nothing
};AbstractMentionResource.prototype.isFiltering=function(_query){return false;};AbstractMentionResource.prototype._notifyListeners=function(mentionsResult,stats){// console.info('ak-mention-resource._notifyListeners', mentionsResult &&
//     mentionsResult.mentions &&
//     mentionsResult.mentions.length, this.changeListeners);
this.changeListeners.forEach(function(listener,key){try{listener(mentionsResult.mentions.slice(0,MAX_NOTIFIED_ITEMS),mentionsResult.query,stats);}catch(e){// ignore error from listener
console.error("error from listener '"+key+"', ignoring",e);}});};AbstractMentionResource.prototype._notifyAllResultsListeners=function(mentionsResult){// console.info('ak-mention-resource._notifyAllResultsListeners', mentionsResult &&
//     mentionsResult.mentions &&
//     mentionsResult.mentions.length, this.changeListeners);
this.allResultsListeners.forEach(function(listener,key){try{listener(mentionsResult.mentions.slice(0,MAX_NOTIFIED_ITEMS),mentionsResult.query);}catch(e){// ignore error from listener
console.error("error from listener '"+key+"', ignoring",e);}});};AbstractMentionResource.prototype._notifyErrorListeners=function(error,query){this.errListeners.forEach(function(listener,key){try{listener(error,query);}catch(e){// ignore error from listener
console.error("error from listener '"+key+"', ignoring",e);}});};AbstractMentionResource.prototype._notifyInfoListeners=function(info){this.infoListeners.forEach(function(listener,key){try{listener(info);}catch(e){// ignore error fromr listener
console.error("error from listener '"+key+"', ignoring",e);}});};return AbstractMentionResource;}(AbstractResource);/**
 * Provides a Javascript API
 */var MentionResource=/** @class */function(_super){__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MentionResource,_super);function MentionResource(config){var _this=_super.call(this)||this;_this.verifyMentionConfig(config);_this.config=config;_this.lastReturnedSearch=0;_this.activeSearches=new Set();return _this;}MentionResource.prototype.shouldHighlightMention=function(mention){if(this.config.shouldHighlightMention){return this.config.shouldHighlightMention(mention);}return false;};MentionResource.prototype.notify=function(searchTime,mentionResult,query){if(searchTime>this.lastReturnedSearch){this.lastReturnedSearch=searchTime;this._notifyListeners(mentionResult,{duration:Date.now()-searchTime});}else{var date=new Date(searchTime).toISOString().substr(17,6);console.debug('Stale search result, skipping',date,query);// eslint-disable-line no-console, max-len
}this._notifyAllResultsListeners(mentionResult);};MentionResource.prototype.notifyError=function(error,query){this._notifyErrorListeners(error,query);if(query){this.activeSearches.delete(query);}};MentionResource.prototype.filter=function(query,contextIdentifier){var _this=this;var searchTime=Date.now();if(!query){this.initialState(contextIdentifier).then(function(results){return _this.notify(searchTime,results,query);},function(error){return _this.notifyError(error,query);});}else{this.activeSearches.add(query);var searchResponse=this.search(query,contextIdentifier);searchResponse.mentions.then(function(results){_this.notify(searchTime,results,query);},function(error){return _this.notifyError(error,query);});}};MentionResource.prototype.recordMentionSelection=function(mention,contextIdentifier){return this.recordSelection(mention,contextIdentifier).then(function(){},function(error){return console.error("error recording mention selection: "+error,error);});};MentionResource.prototype.isFiltering=function(query){return this.activeSearches.has(query);};MentionResource.prototype.updateActiveSearches=function(query){this.activeSearches.add(query);};MentionResource.prototype.verifyMentionConfig=function(config){if(!config.url){throw new Error('config.url is a required parameter');}if(!config.issueKey){throw new Error('config.issueKey is a required parameter');}// if (!config.securityProvider) {
//     config.securityProvider = emptySecurityProvider;
// }
};MentionResource.prototype.initialState=function(contextIdentifier){return this.remoteInitialState(contextIdentifier);};MentionResource.prototype.getQueryParams=function(contextIdentifier){var configParams={};if(this.config.containerId){configParams['containerId']=this.config.containerId;}if(this.config.productId){configParams['productIdentifier']=this.config.productId;}if(this.config.issueKey){configParams['issueKey']=this.config.issueKey;}// if contextParams exist then it will override configParams for containerId
return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({},configParams,contextIdentifier);};/**
     * Returns the initial mention display list before a search is performed for the specified
     * container.
     *
     * @param contextIdentifier
     * @returns Promise
     */MentionResource.prototype.remoteInitialState=function(contextIdentifier){var _this=this;var queryParams=this.getQueryParams(contextIdentifier);var options={queryParams:queryParams,headers:Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__http__["b" /* getGlobalHeader */])())};return __WEBPACK_IMPORTED_MODULE_3____["d" /* http */].requestService(this.config,options).then(function(result){return _this.transformServiceResponse(result,"");});// return serviceUtils
//     .requestService(this.config, options)
//     .then(function (result) { return _this.transformServiceResponse(result, ''); });
};MentionResource.prototype.search=function(query,contextIdentifier){return{mentions:this.remoteSearch(query,contextIdentifier)};};MentionResource.prototype.remoteSearch=function(query,contextIdentifier){var _this=this;var options={queryParams:__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({query:query,limit:MAX_QUERY_ITEMS},this.getQueryParams(contextIdentifier)),headers:Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__http__["b" /* getGlobalHeader */])())};return __WEBPACK_IMPORTED_MODULE_3____["d" /* http */].requestService(this.config,options).then(function(result){return _this.transformServiceResponse(result,query);});// return serviceUtils
//     .requestService(this.config, options)
//     .then(function (result) { return _this.transformServiceResponse(result, query); });
};MentionResource.prototype.transformServiceResponse=function(result,query){var mentions=result.map(function(mention){var lozenge;// if (isAppMention(mention)) {
//     lozenge = mention.userType;
// }
// else if (isTeamMention(mention)) {
//     lozenge = mention.userType;
// }
return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({},mention,{lozenge:lozenge,query:query});});return __WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({},result,{mentions:mentions,query:result.query||query});};MentionResource.prototype.recordSelection=function(mention,contextIdentifier){var options={path:'record',queryParams:__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"]({selectedUserId:mention.id},this.getQueryParams(contextIdentifier)),requestInit:{method:'POST',headers:Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_2__http__["b" /* getGlobalHeader */])())}};return __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_service_support__["b" /* utils */].requestService(this.config,options);};return MentionResource;}(AbstractMentionResource);var HttpError=/** @class */function(){function HttpError(statusCode,statusMessage){this.statusCode=statusCode;this.message=statusMessage;this.name='HttpError';this.stack=new Error().stack;}return HttpError;}();/* unused harmony default export */ var _unused_webpack_default_export = (MentionResource);

/***/ }),
/* 3169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
Copyright (C) 2015-2017 Andrea Giammarchi - @WebReflection

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/


function URLSearchParams(query) {
  var
    index, key, value,
    pairs, i, length,
    dict = Object.create(null)
  ;
  this[secret] = dict;
  if (!query) return;
  if (typeof query === 'string') {
    if (query.charAt(0) === '?') {
      query = query.slice(1);
    }
    for (
      pairs = query.split('&'),
      i = 0,
      length = pairs.length; i < length; i++
    ) {
      value = pairs[i];
      index = value.indexOf('=');
      if (-1 < index) {
        appendTo(
          dict,
          decode(value.slice(0, index)),
          decode(value.slice(index + 1))
        );
      } else if (value.length){
        appendTo(
          dict,
          decode(value),
          ''
        );
      }
    }
  } else {
    if (isArray(query)) {
      for (
        i = 0,
        length = query.length; i < length; i++
      ) {
        value = query[i];
        appendTo(dict, value[0], value[1]);
      }
    } else if (query.forEach) {
      query.forEach(addEach, dict);
    } else {
      for (key in query) {
         appendTo(dict, key, query[key]);
      }
    }
  }
}

var
  isArray = Array.isArray,
  URLSearchParamsProto = URLSearchParams.prototype,
  find = /[!'\(\)~]|%20|%00/g,
  plus = /\+/g,
  replace = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  },
  replacer = function (match) {
    return replace[match];
  },
  secret = '__URLSearchParams__:' + Math.random()
;

function addEach(value, key) {
  /* jshint validthis:true */
  appendTo(this, key, value);
}

function appendTo(dict, name, value) {
  var res = isArray(value) ? value.join(',') : value;
  if (name in dict)
    dict[name].push(res);
  else
    dict[name] = [res];
}

function decode(str) {
  return decodeURIComponent(str.replace(plus, ' '));
}

function encode(str) {
  return encodeURIComponent(str).replace(find, replacer);
}

URLSearchParamsProto.append = function append(name, value) {
  appendTo(this[secret], name, value);
};

URLSearchParamsProto.delete = function del(name) {
  delete this[secret][name];
};

URLSearchParamsProto.get = function get(name) {
  var dict = this[secret];
  return name in dict ? dict[name][0] : null;
};

URLSearchParamsProto.getAll = function getAll(name) {
  var dict = this[secret];
  return name in dict ? dict[name].slice(0) : [];
};

URLSearchParamsProto.has = function has(name) {
  return name in this[secret];
};

URLSearchParamsProto.set = function set(name, value) {
  this[secret][name] = ['' + value];
};

URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
  var dict = this[secret];
  Object.getOwnPropertyNames(dict).forEach(function(name) {
    dict[name].forEach(function(value) {
      callback.call(thisArg, value, name, this);
    }, this);
  }, this);
};

/*
URLSearchParamsProto.toBody = function() {
  return new Blob(
    [this.toString()],
    {type: 'application/x-www-form-urlencoded'}
  );
};
*/

URLSearchParamsProto.toJSON = function toJSON() {
  return {};
};

URLSearchParamsProto.toString = function toString() {
  var dict = this[secret], query = [], i, key, name, value;
  for (key in dict) {
    name = encode(key);
    for (
      i = 0,
      value = dict[key];
      i < value.length; i++
    ) {
      query.push(name + '=' + encode(value[i]));
    }
  }
  return query.join('&');
};

URLSearchParams = (module.exports = global.URLSearchParams || URLSearchParams);

(function (URLSearchParamsProto) {

  var iterable = (function () {
    try {
      return !!Symbol.iterator;
    } catch(error) {
      return false;
    }
  }());

  // mostly related to issue #24
  if (!('forEach' in URLSearchParamsProto)) {
    URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
      var names = Object.create(null);
      this.toString()
          .replace(/=[\s\S]*?(?:&|$)/g, '=')
          .split('=')
          .forEach(function (name) {
            if (!name.length || name in names) return;
            (names[name] = this.getAll(name)).forEach(function(value) {
              callback.call(thisArg, value, name, this);
            }, this);
          }, this);
    };
  }

  if (!('keys' in URLSearchParamsProto)) {
    URLSearchParamsProto.keys = function keys() {
      var items = [];
      this.forEach(function(value, name) { items.push(name); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (!('values' in URLSearchParamsProto)) {
    URLSearchParamsProto.values = function values() {
      var items = [];
      this.forEach(function(value) { items.push(value); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (!('entries' in URLSearchParamsProto)) {
    URLSearchParamsProto.entries = function entries() {
      var items = [];
      this.forEach(function(value, name) { items.push([name, value]); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (iterable && !(Symbol.iterator in URLSearchParamsProto)) {
    URLSearchParamsProto[Symbol.iterator] = URLSearchParamsProto.entries;
  }

  if (!('sort' in URLSearchParamsProto)) {
    URLSearchParamsProto.sort = function sort() {
      var
        entries = this.entries(),
        entry = entries.next(),
        done = entry.done,
        keys = [],
        values = Object.create(null),
        i, key, value
      ;
      while (!done) {
        value = entry.value;
        key = value[0];
        keys.push(key);
        if (!(key in values)) {
          values[key] = [];
        }
        values[key].push(value[1]);
        entry = entries.next();
        done = entry.done;
      }
      // not the champion in efficiency
      // but these two bits just do the job
      keys.sort();
      for (i = 0; i < keys.length; i++) {
        this.delete(keys[i]);
      }
      for (i = 0; i < keys.length; i++) {
        key = keys[i];
        this.append(key, values[key].shift());
      }
    };
  }

}(URLSearchParams.prototype));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 3170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__);
/* harmony default export */ __webpack_exports__["a"] = (fetch);// eslint-disable-line no-undef

/***/ }),
/* 3171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_renderer__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_wikimarkup_transformer__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_editor_common__ = __webpack_require__(893);
var wikiRenderer=function wikiRenderer(props){var adfEncoder=new __WEBPACK_IMPORTED_MODULE_1__atlaskit_renderer__["a" /* ADFEncoder */](function(){return new __WEBPACK_IMPORTED_MODULE_2__atlaskit_editor_wikimarkup_transformer__["a" /* WikiMarkupTransformer */]();});// const providerFactory = (mentionProvider) => ProviderFactory.create({
//     mentionProvider
// })
var value=props.value;//let provFact = providerFactory(mentionProvider)
//let doc = value ? adfEncoder.encode(value) : null
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__atlaskit_renderer__["b" /* ReactRenderer */],{document:value/*dataProviders={provFact}*/});};/* unused harmony default export */ var _unused_webpack_default_export = (wikiRenderer);

/***/ }),
/* 3172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_tabs__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RoutedTabs=function(_Component){_inherits(RoutedTabs,_Component);function RoutedTabs(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RoutedTabs);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RoutedTabs.__proto__||Object.getPrototypeOf(RoutedTabs)).call.apply(_ref,[this].concat(args))),_this),_this.onSelect=function(tabIndex){__WEBPACK_IMPORTED_MODULE_4__util__["c" /* history */].mergeQueryString({tab:_this.props.tabs[tabIndex]});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RoutedTabs,[{key:'render',value:function render(){var _props=this.props,tabs=_props.tabs,children=_props.children,location=_props.location;var tab=location.query?location.query.tab:null;var selectedIndex=tabs.indexOf(tab);selectedIndex=selectedIndex<0?0:selectedIndex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tabs__["d" /* Tabs */],{forceRenderTabPanel:true,selectedIndex:selectedIndex,onSelect:this.onSelect},children);}}]);return RoutedTabs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RoutedTabs.propTypes={tabs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};RoutedTabs.defaultProps={tabs:[]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(RoutedTabs));

/***/ }),
/* 3173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tabs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_propTypes__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UncontrolledTabs__ = __webpack_require__(3174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_count__ = __webpack_require__(1281);
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }






var MODE_CONTROLLED = 0;
var MODE_UNCONTROLLED = 1;

var Tabs =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Tabs, _Component);

  function Tabs(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleSelected = function (index, last, event) {
      var onSelect = _this.props.onSelect;
      var mode = _this.state.mode; // Call change event handler

      if (typeof onSelect === 'function') {
        // Check if the change event handler cancels the tab change
        if (onSelect(index, last, event) === false) return;
      }

      var state = {
        // Set focus if the change was triggered from the keyboard
        focus: event.type === 'keydown'
      };

      if (mode === MODE_UNCONTROLLED) {
        // Update selected index
        state.selectedIndex = index;
      }

      _this.setState(state);
    };

    _this.state = Tabs.copyPropsToState(_this.props, {}, props.defaultFocus);
    return _this;
  }

  Tabs.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    return Tabs.copyPropsToState(props, state);
  };

  Tabs.getModeFromProps = function getModeFromProps(props) {
    return props.selectedIndex === null ? MODE_UNCONTROLLED : MODE_CONTROLLED;
  };

  // preserve the existing selectedIndex from state.
  // If the state has not selectedIndex, default to the defaultIndex or 0
  Tabs.copyPropsToState = function copyPropsToState(props, state, focus) {
    if (focus === void 0) {
      focus = false;
    }

    if (false) {
      throw new Error("Switching between controlled mode (by using `selectedIndex`) and uncontrolled mode is not supported in `Tabs`.\nFor more information about controlled and uncontrolled mode of react-tabs see the README.");
    }

    var newState = {
      focus: focus,
      mode: Tabs.getModeFromProps(props)
    };

    if (newState.mode === MODE_UNCONTROLLED) {
      var maxTabIndex = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_count__["b" /* getTabsCount */])(props.children) - 1;
      var selectedIndex = null;

      if (state.selectedIndex != null) {
        selectedIndex = Math.min(state.selectedIndex, maxTabIndex);
      } else {
        selectedIndex = props.defaultIndex || 0;
      }

      newState.selectedIndex = selectedIndex;
    }

    return newState;
  };

  var _proto = Tabs.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        defaultIndex = _this$props.defaultIndex,
        defaultFocus = _this$props.defaultFocus,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "defaultIndex", "defaultFocus"]);

    var _this$state = this.state,
        focus = _this$state.focus,
        selectedIndex = _this$state.selectedIndex;
    props.focus = focus;
    props.onSelect = this.handleSelected;

    if (selectedIndex != null) {
      props.selectedIndex = selectedIndex;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__UncontrolledTabs__["a" /* default */], props, children);
  };

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Tabs.defaultProps = {
  defaultFocus: false,
  forceRenderTabPanel: false,
  selectedIndex: null,
  defaultIndex: null
};

Tabs.propTypes =  false ? {
  children: childrenPropType,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  defaultFocus: PropTypes.bool,
  defaultIndex: PropTypes.number,
  disabledTabClassName: PropTypes.string,
  domRef: PropTypes.func,
  forceRenderTabPanel: PropTypes.bool,
  onSelect: onSelectPropType,
  selectedIndex: selectedIndexPropType,
  selectedTabClassName: PropTypes.string,
  selectedTabPanelClassName: PropTypes.string
} : {};
Tabs.tabsRole = 'Tabs';

/***/ }),
/* 3174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UncontrolledTabs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_uuid__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_propTypes__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_count__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_childrenDeepMap__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__ = __webpack_require__(309);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }










function isNode(node) {
  return node && 'getAttribute' in node;
} // Determine if a node from event.target is a Tab element


function isTabNode(node) {
  return isNode(node) && node.getAttribute('role') === 'tab';
} // Determine if a tab node is disabled


function isTabDisabled(node) {
  return isNode(node) && node.getAttribute('aria-disabled') === 'true';
}

var canUseActiveElement;

try {
  canUseActiveElement = !!(typeof window !== 'undefined' && window.document && window.document.activeElement);
} catch (e) {
  // Work around for IE bug when accessing document.activeElement in an iframe
  // Refer to the following resources:
  // http://stackoverflow.com/a/10982960/369687
  // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12733599
  canUseActiveElement = false;
}

var UncontrolledTabs =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(UncontrolledTabs, _Component);

  function UncontrolledTabs() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.tabNodes = [];

    _this.handleKeyDown = function (e) {
      if (_this.isTabFromContainer(e.target)) {
        var index = _this.props.selectedIndex;
        var preventDefault = false;
        var useSelectedIndex = false;

        if (e.keyCode === 32 || e.keyCode === 13) {
          preventDefault = true;
          useSelectedIndex = false;

          _this.handleClick(e);
        }

        if (e.keyCode === 37 || e.keyCode === 38) {
          // Select next tab to the left
          index = _this.getPrevTab(index);
          preventDefault = true;
          useSelectedIndex = true;
        } else if (e.keyCode === 39 || e.keyCode === 40) {
          // Select next tab to the right
          index = _this.getNextTab(index);
          preventDefault = true;
          useSelectedIndex = true;
        } else if (e.keyCode === 35) {
          // Select last tab (End key)
          index = _this.getLastTab();
          preventDefault = true;
          useSelectedIndex = true;
        } else if (e.keyCode === 36) {
          // Select first tab (Home key)
          index = _this.getFirstTab();
          preventDefault = true;
          useSelectedIndex = true;
        } // This prevents scrollbars from moving around


        if (preventDefault) {
          e.preventDefault();
        } // Only use the selected index in the state if we're not using the tabbed index


        if (useSelectedIndex) {
          _this.setSelected(index, e);
        }
      }
    };

    _this.handleClick = function (e) {
      var node = e.target; // eslint-disable-next-line no-cond-assign

      do {
        if (_this.isTabFromContainer(node)) {
          if (isTabDisabled(node)) {
            return;
          }

          var index = [].slice.call(node.parentNode.children).filter(isTabNode).indexOf(node);

          _this.setSelected(index, e);

          return;
        }
      } while ((node = node.parentNode) != null);
    };

    return _this;
  }

  var _proto = UncontrolledTabs.prototype;

  _proto.setSelected = function setSelected(index, event) {
    // Check index boundary
    if (index < 0 || index >= this.getTabsCount()) return;
    var _this$props = this.props,
        onSelect = _this$props.onSelect,
        selectedIndex = _this$props.selectedIndex; // Call change event handler

    onSelect(index, selectedIndex, event);
  };

  _proto.getNextTab = function getNextTab(index) {
    var count = this.getTabsCount(); // Look for non-disabled tab from index to the last tab on the right

    for (var i = index + 1; i < count; i++) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    } // If no tab found, continue searching from first on left to index


    for (var _i = 0; _i < index; _i++) {
      if (!isTabDisabled(this.getTab(_i))) {
        return _i;
      }
    } // No tabs are disabled, return index


    return index;
  };

  _proto.getPrevTab = function getPrevTab(index) {
    var i = index; // Look for non-disabled tab from index to first tab on the left

    while (i--) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    } // If no tab found, continue searching from last tab on right to index


    i = this.getTabsCount();

    while (i-- > index) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    } // No tabs are disabled, return index


    return index;
  };

  _proto.getFirstTab = function getFirstTab() {
    var count = this.getTabsCount(); // Look for non disabled tab from the first tab

    for (var i = 0; i < count; i++) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    }

    return null;
  };

  _proto.getLastTab = function getLastTab() {
    var i = this.getTabsCount(); // Look for non disabled tab from the last tab

    while (i--) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    }

    return null;
  };

  _proto.getTabsCount = function getTabsCount() {
    var children = this.props.children;
    return Object(__WEBPACK_IMPORTED_MODULE_5__helpers_count__["b" /* getTabsCount */])(children);
  };

  _proto.getPanelsCount = function getPanelsCount() {
    var children = this.props.children;
    return Object(__WEBPACK_IMPORTED_MODULE_5__helpers_count__["a" /* getPanelsCount */])(children);
  };

  _proto.getTab = function getTab(index) {
    return this.tabNodes["tabs-" + index];
  };

  _proto.getChildren = function getChildren() {
    var _this2 = this;

    var index = 0;
    var _this$props2 = this.props,
        children = _this$props2.children,
        disabledTabClassName = _this$props2.disabledTabClassName,
        focus = _this$props2.focus,
        forceRenderTabPanel = _this$props2.forceRenderTabPanel,
        selectedIndex = _this$props2.selectedIndex,
        selectedTabClassName = _this$props2.selectedTabClassName,
        selectedTabPanelClassName = _this$props2.selectedTabPanelClassName;
    this.tabIds = this.tabIds || [];
    this.panelIds = this.panelIds || [];
    var diff = this.tabIds.length - this.getTabsCount(); // Add ids if new tabs have been added
    // Don't bother removing ids, just keep them in case they are added again
    // This is more efficient, and keeps the uuid counter under control

    while (diff++ < 0) {
      this.tabIds.push(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_uuid__["a" /* default */])());
      this.panelIds.push(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_uuid__["a" /* default */])());
    } // Map children to dynamically setup refs


    return Object(__WEBPACK_IMPORTED_MODULE_6__helpers_childrenDeepMap__["b" /* deepMap */])(children, function (child) {
      var result = child; // Clone TabList and Tab components to have refs

      if (Object(__WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__["b" /* isTabList */])(child)) {
        var listIndex = 0; // Figure out if the current focus in the DOM is set on a Tab
        // If it is we should keep the focus on the next selected tab

        var wasTabFocused = false;

        if (canUseActiveElement) {
          wasTabFocused = __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.toArray(child.props.children).filter(__WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__["a" /* isTab */]).some(function (tab, i) {
            return document.activeElement === _this2.getTab(i);
          });
        }

        result = Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(child, {
          children: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_childrenDeepMap__["b" /* deepMap */])(child.props.children, function (tab) {
            var key = "tabs-" + listIndex;
            var selected = selectedIndex === listIndex;
            var props = {
              tabRef: function tabRef(node) {
                _this2.tabNodes[key] = node;
              },
              id: _this2.tabIds[listIndex],
              panelId: _this2.panelIds[listIndex],
              selected: selected,
              focus: selected && (focus || wasTabFocused)
            };
            if (selectedTabClassName) props.selectedClassName = selectedTabClassName;
            if (disabledTabClassName) props.disabledClassName = disabledTabClassName;
            listIndex++;
            return Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(tab, props);
          })
        });
      } else if (Object(__WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__["c" /* isTabPanel */])(child)) {
        var props = {
          id: _this2.panelIds[index],
          tabId: _this2.tabIds[index],
          selected: selectedIndex === index
        };
        if (forceRenderTabPanel) props.forceRender = forceRenderTabPanel;
        if (selectedTabPanelClassName) props.selectedClassName = selectedTabPanelClassName;
        index++;
        result = Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(child, props);
      }

      return result;
    });
  };

  /**
   * Determine if a node from event.target is a Tab element for the current Tabs container.
   * If the clicked element is not a Tab, it returns false.
   * If it finds another Tabs container between the Tab and `this`, it returns false.
   */
  _proto.isTabFromContainer = function isTabFromContainer(node) {
    // return immediately if the clicked element is not a Tab.
    if (!isTabNode(node)) {
      return false;
    } // Check if the first occurrence of a Tabs container is `this` one.


    var nodeAncestor = node.parentElement;

    do {
      if (nodeAncestor === this.node) return true;
      if (nodeAncestor.getAttribute('data-tabs')) break;
      nodeAncestor = nodeAncestor.parentElement;
    } while (nodeAncestor);

    return false;
  };

  _proto.render = function render() {
    var _this3 = this;

    // Delete all known props, so they don't get added to DOM
    var _this$props3 = this.props,
        children = _this$props3.children,
        className = _this$props3.className,
        disabledTabClassName = _this$props3.disabledTabClassName,
        domRef = _this$props3.domRef,
        focus = _this$props3.focus,
        forceRenderTabPanel = _this$props3.forceRenderTabPanel,
        onSelect = _this$props3.onSelect,
        selectedIndex = _this$props3.selectedIndex,
        selectedTabClassName = _this$props3.selectedTabClassName,
        selectedTabPanelClassName = _this$props3.selectedTabPanelClassName,
        attributes = _objectWithoutPropertiesLoose(_this$props3, ["children", "className", "disabledTabClassName", "domRef", "focus", "forceRenderTabPanel", "onSelect", "selectedIndex", "selectedTabClassName", "selectedTabPanelClassName"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className),
      onClick: this.handleClick,
      onKeyDown: this.handleKeyDown,
      ref: function ref(node) {
        _this3.node = node;
        if (domRef) domRef(node);
      },
      "data-tabs": true
    }), this.getChildren());
  };

  return UncontrolledTabs;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

UncontrolledTabs.defaultProps = {
  className: 'react-tabs',
  focus: false
};

UncontrolledTabs.propTypes =  false ? {
  children: childrenPropType,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  disabledTabClassName: PropTypes.string,
  domRef: PropTypes.func,
  focus: PropTypes.bool,
  forceRenderTabPanel: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  selectedTabClassName: PropTypes.string,
  selectedTabPanelClassName: PropTypes.string
} : {};

/***/ }),
/* 3175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }





var TabList =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(TabList, _Component);

  function TabList() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = TabList.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["children", "className"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className),
      role: "tablist"
    }), children);
  };

  return TabList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

TabList.defaultProps = {
  className: 'react-tabs__tab-list'
};

TabList.propTypes =  false ? {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
} : {};
TabList.tabsRole = 'TabList';

/***/ }),
/* 3176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var DEFAULT_CLASS = 'react-tabs__tab';

var Tab =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Tab, _Component);

  function Tab() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Tab.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.checkFocus();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.checkFocus();
  };

  _proto.checkFocus = function checkFocus() {
    var _this$props = this.props,
        selected = _this$props.selected,
        focus = _this$props.focus;

    if (selected && focus) {
      this.node.focus();
    }
  };

  _proto.render = function render() {
    var _cx,
        _this = this;

    var _this$props2 = this.props,
        children = _this$props2.children,
        className = _this$props2.className,
        disabled = _this$props2.disabled,
        disabledClassName = _this$props2.disabledClassName,
        focus = _this$props2.focus,
        id = _this$props2.id,
        panelId = _this$props2.panelId,
        selected = _this$props2.selected,
        selectedClassName = _this$props2.selectedClassName,
        tabIndex = _this$props2.tabIndex,
        tabRef = _this$props2.tabRef,
        attributes = _objectWithoutPropertiesLoose(_this$props2, ["children", "className", "disabled", "disabledClassName", "focus", "id", "panelId", "selected", "selectedClassName", "tabIndex", "tabRef"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, (_cx = {}, _cx[selectedClassName] = selected, _cx[disabledClassName] = disabled, _cx)),
      ref: function ref(node) {
        _this.node = node;
        if (tabRef) tabRef(node);
      },
      role: "tab",
      id: id,
      "aria-selected": selected ? 'true' : 'false',
      "aria-disabled": disabled ? 'true' : 'false',
      "aria-controls": panelId,
      tabIndex: tabIndex || (selected ? '0' : null)
    }), children);
  };

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Tab.defaultProps = {
  className: DEFAULT_CLASS,
  disabledClassName: DEFAULT_CLASS + "--disabled",
  focus: false,
  id: null,
  panelId: null,
  selected: false,
  selectedClassName: DEFAULT_CLASS + "--selected"
};

Tab.propTypes =  false ? {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  disabled: PropTypes.bool,
  tabIndex: PropTypes.string,
  disabledClassName: PropTypes.string,
  focus: PropTypes.bool,
  // private
  id: PropTypes.string,
  // private
  panelId: PropTypes.string,
  // private
  selected: PropTypes.bool,
  // private
  selectedClassName: PropTypes.string,
  tabRef: PropTypes.func // private

} : {};
Tab.tabsRole = 'Tab';

/***/ }),
/* 3177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var DEFAULT_CLASS = 'react-tabs__tab-panel';

var TabPanel =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(TabPanel, _Component);

  function TabPanel() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = TabPanel.prototype;

  _proto.render = function render() {
    var _cx;

    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        forceRender = _this$props.forceRender,
        id = _this$props.id,
        selected = _this$props.selected,
        selectedClassName = _this$props.selectedClassName,
        tabId = _this$props.tabId,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "forceRender", "id", "selected", "selectedClassName", "tabId"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, (_cx = {}, _cx[selectedClassName] = selected, _cx)),
      role: "tabpanel",
      id: id,
      "aria-labelledby": tabId
    }), forceRender || selected ? children : null);
  };

  return TabPanel;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

TabPanel.defaultProps = {
  className: DEFAULT_CLASS,
  forceRender: false,
  selectedClassName: DEFAULT_CLASS + "--selected"
};

TabPanel.propTypes =  false ? {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  forceRender: PropTypes.bool,
  id: PropTypes.string,
  // private
  selected: PropTypes.bool,
  // private
  selectedClassName: PropTypes.string,
  tabId: PropTypes.string // private

} : {};
TabPanel.tabsRole = 'TabPanel';

/***/ }),
/* 3178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export contains */
/* unused harmony export pluralize */
/* unused harmony export endsWith */
function contains(str,val){return str&&typeof str==='string'&&str.indexOf(val)!==-1;}function pluralize(term,value){var plurality=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'s';value=parseFloat(value);return Number.isNaN(value)||value>1?term+plurality:term;}function endsWith(subjectString,searchString,position){if(typeof position!=='number'||!isFinite(position)||Math.floor(position)!==position||position>subjectString.length){position=subjectString.length;}position-=searchString.length;var lastIndex=subjectString.lastIndexOf(searchString,position);return lastIndex!==-1&&lastIndex===position;}

/***/ }),
/* 3179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export logError */
/* unused harmony export getHttpErrorMessage */
function logError(error){console.error(error);if(window.newrelic)window.newrelic.noticeError(error);// eslint-disable-line no-undef
}function getHttpErrorMessage(error){if(!error)return'';if(error.response&&error.response.data)error.data=error.response.data;if(error.data)error=error.data;if(error.message)return formatErrorMessage(error.message);return JSON.stringify(error);}function formatErrorMessage(message){if(message.indexOf('Error: ')===0)message=message.replace('Error: ','');return message;}

/***/ }),
/* 3180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export normalizeArray */
/* unused harmony export normalizeVersionName */
function normalizeArray(keyProperty,array){return array.reduce(function(result,element){result[element[keyProperty]]=element;return result;},{});}function normalizeVersionName(name){return name&&name[0]==='v'?name:'v'+name;}

/***/ }),
/* 3181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export syncValidate */
/* unused harmony export hasErrors */
/* unused harmony export submitIfValid */
/* unused harmony export isUrl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validate_js__ = __webpack_require__(3182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_validate_js__);
// We have to return an object for redux-form
// but validate.js returns null when everything passes
var syncValidate=function syncValidate(values,constraints){for(var _len=arguments.length,arrayFields=Array(_len>2?_len-2:0),_key=2;_key<_len;_key++){arrayFields[_key-2]=arguments[_key];}var result=__WEBPACK_IMPORTED_MODULE_0_validate_js___default()(values,constraints)||{};result=Object.keys(result).reduce(function(obj,prop){obj[prop]=result[prop].join(', ');return obj;},{});arrayFields.forEach(function(field){if(result[field]){result[field]={_error:result[field]};}});return result;};__WEBPACK_IMPORTED_MODULE_0_validate_js___default.a.validators.uniqueItems=function(value,options,key,attributes){if(!value)return;if(!Array.isArray(value))throw new Error('uniqueItems validator requires an array value');if(!value.every(function(val,index){return index===value.indexOf(val);}))return'cannot contain duplicates';};__WEBPACK_IMPORTED_MODULE_0_validate_js___default.a.validators.arrayItems=function(value,options,key,attributes){if(!value||!value.length)return null;var result=options.predicate(value);if(!result)return null;if(typeof result==='string')return result;return options.message||'invalid item';};var hasErrors=function hasErrors(obj){return Object.keys(obj).length;};// TODO: REMOVE THIS ONCE REDUX-FORM FIXES THEIR SUBMIT VALIDATION
var submitIfValid=function submitIfValid(props,transformer){return props.handleSubmit(function(result){if(!hasErrors(props.validate(result)))return props.onSubmit(transformer?transformer(result):result);});};// TODO: Make async wrapper when you have a use case for validate.async
// eslint-disable-next-line
var isUrl=function isUrl(value){return value&&value.match(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/)!==null;};

/***/ }),
/* 3182 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {/*!
 * validate.js 0.11.1
 *
 * (c) 2013-2016 Nicklas Ansman, 2013 Wrapp
 * Validate.js may be freely distributed under the MIT license.
 * For all details and documentation:
 * http://validatejs.org/
 */

(function(exports, module, define) {
  "use strict";

  // The main function that calls the validators specified by the constraints.
  // The options are the following:
  //   - format (string) - An option that controls how the returned value is formatted
  //     * flat - Returns a flat array of just the error messages
  //     * grouped - Returns the messages grouped by attribute (default)
  //     * detailed - Returns an array of the raw validation data
  //   - fullMessages (boolean) - If `true` (default) the attribute name is prepended to the error.
  //
  // Please note that the options are also passed to each validator.
  var validate = function(attributes, constraints, options) {
    options = v.extend({}, v.options, options);

    var results = v.runValidations(attributes, constraints, options)
      , attr
      , validator;

    for (attr in results) {
      for (validator in results[attr]) {
        if (v.isPromise(results[attr][validator])) {
          throw new Error("Use validate.async if you want support for promises");
        }
      }
    }
    return validate.processValidationResults(results, options);
  };

  var v = validate;

  // Copies over attributes from one or more sources to a single destination.
  // Very much similar to underscore's extend.
  // The first argument is the target object and the remaining arguments will be
  // used as sources.
  v.extend = function(obj) {
    [].slice.call(arguments, 1).forEach(function(source) {
      for (var attr in source) {
        obj[attr] = source[attr];
      }
    });
    return obj;
  };

  v.extend(validate, {
    // This is the version of the library as a semver.
    // The toString function will allow it to be coerced into a string
    version: {
      major: 0,
      minor: 11,
      patch: 1,
      metadata: null,
      toString: function() {
        var version = v.format("%{major}.%{minor}.%{patch}", v.version);
        if (!v.isEmpty(v.version.metadata)) {
          version += "+" + v.version.metadata;
        }
        return version;
      }
    },

    // Below is the dependencies that are used in validate.js

    // The constructor of the Promise implementation.
    // If you are using Q.js, RSVP or any other A+ compatible implementation
    // override this attribute to be the constructor of that promise.
    // Since jQuery promises aren't A+ compatible they won't work.
    Promise: typeof Promise !== "undefined" ? Promise : /* istanbul ignore next */ null,

    EMPTY_STRING_REGEXP: /^\s*$/,

    // Runs the validators specified by the constraints object.
    // Will return an array of the format:
    //     [{attribute: "<attribute name>", error: "<validation result>"}, ...]
    runValidations: function(attributes, constraints, options) {
      var results = []
        , attr
        , validatorName
        , value
        , validators
        , validator
        , validatorOptions
        , error;

      if (v.isDomElement(attributes) || v.isJqueryElement(attributes)) {
        attributes = v.collectFormValues(attributes);
      }

      // Loops through each constraints, finds the correct validator and run it.
      for (attr in constraints) {
        value = v.getDeepObjectValue(attributes, attr);
        // This allows the constraints for an attribute to be a function.
        // The function will be called with the value, attribute name, the complete dict of
        // attributes as well as the options and constraints passed in.
        // This is useful when you want to have different
        // validations depending on the attribute value.
        validators = v.result(constraints[attr], value, attributes, attr, options, constraints);

        for (validatorName in validators) {
          validator = v.validators[validatorName];

          if (!validator) {
            error = v.format("Unknown validator %{name}", {name: validatorName});
            throw new Error(error);
          }

          validatorOptions = validators[validatorName];
          // This allows the options to be a function. The function will be
          // called with the value, attribute name, the complete dict of
          // attributes as well as the options and constraints passed in.
          // This is useful when you want to have different
          // validations depending on the attribute value.
          validatorOptions = v.result(validatorOptions, value, attributes, attr, options, constraints);
          if (!validatorOptions) {
            continue;
          }
          results.push({
            attribute: attr,
            value: value,
            validator: validatorName,
            globalOptions: options,
            attributes: attributes,
            options: validatorOptions,
            error: validator.call(validator,
                value,
                validatorOptions,
                attr,
                attributes,
                options)
          });
        }
      }

      return results;
    },

    // Takes the output from runValidations and converts it to the correct
    // output format.
    processValidationResults: function(errors, options) {
      errors = v.pruneEmptyErrors(errors, options);
      errors = v.expandMultipleErrors(errors, options);
      errors = v.convertErrorMessages(errors, options);

      var format = options.format || "grouped";

      if (typeof v.formatters[format] === 'function') {
        errors = v.formatters[format](errors);
      } else {
        throw new Error(v.format("Unknown format %{format}", options));
      }

      return v.isEmpty(errors) ? undefined : errors;
    },

    // Runs the validations with support for promises.
    // This function will return a promise that is settled when all the
    // validation promises have been completed.
    // It can be called even if no validations returned a promise.
    async: function(attributes, constraints, options) {
      options = v.extend({}, v.async.options, options);

      var WrapErrors = options.wrapErrors || function(errors) {
        return errors;
      };

      // Removes unknown attributes
      if (options.cleanAttributes !== false) {
        attributes = v.cleanAttributes(attributes, constraints);
      }

      var results = v.runValidations(attributes, constraints, options);

      return new v.Promise(function(resolve, reject) {
        v.waitForResults(results).then(function() {
          var errors = v.processValidationResults(results, options);
          if (errors) {
            reject(new WrapErrors(errors, options, attributes, constraints));
          } else {
            resolve(attributes);
          }
        }, function(err) {
          reject(err);
        });
      });
    },

    single: function(value, constraints, options) {
      options = v.extend({}, v.single.options, options, {
        format: "flat",
        fullMessages: false
      });
      return v({single: value}, {single: constraints}, options);
    },

    // Returns a promise that is resolved when all promises in the results array
    // are settled. The promise returned from this function is always resolved,
    // never rejected.
    // This function modifies the input argument, it replaces the promises
    // with the value returned from the promise.
    waitForResults: function(results) {
      // Create a sequence of all the results starting with a resolved promise.
      return results.reduce(function(memo, result) {
        // If this result isn't a promise skip it in the sequence.
        if (!v.isPromise(result.error)) {
          return memo;
        }

        return memo.then(function() {
          return result.error.then(function(error) {
            result.error = error || null;
          });
        });
      }, new v.Promise(function(r) { r(); })); // A resolved promise
    },

    // If the given argument is a call: function the and: function return the value
    // otherwise just return the value. Additional arguments will be passed as
    // arguments to the function.
    // Example:
    // ```
    // result('foo') // 'foo'
    // result(Math.max, 1, 2) // 2
    // ```
    result: function(value) {
      var args = [].slice.call(arguments, 1);
      if (typeof value === 'function') {
        value = value.apply(null, args);
      }
      return value;
    },

    // Checks if the value is a number. This function does not consider NaN a
    // number like many other `isNumber` functions do.
    isNumber: function(value) {
      return typeof value === 'number' && !isNaN(value);
    },

    // Returns false if the object is not a function
    isFunction: function(value) {
      return typeof value === 'function';
    },

    // A simple check to verify that the value is an integer. Uses `isNumber`
    // and a simple modulo check.
    isInteger: function(value) {
      return v.isNumber(value) && value % 1 === 0;
    },

    // Checks if the value is a boolean
    isBoolean: function(value) {
      return typeof value === 'boolean';
    },

    // Uses the `Object` function to check if the given argument is an object.
    isObject: function(obj) {
      return obj === Object(obj);
    },

    // Simply checks if the object is an instance of a date
    isDate: function(obj) {
      return obj instanceof Date;
    },

    // Returns false if the object is `null` of `undefined`
    isDefined: function(obj) {
      return obj !== null && obj !== undefined;
    },

    // Checks if the given argument is a promise. Anything with a `then`
    // function is considered a promise.
    isPromise: function(p) {
      return !!p && v.isFunction(p.then);
    },

    isJqueryElement: function(o) {
      return o && v.isString(o.jquery);
    },

    isDomElement: function(o) {
      if (!o) {
        return false;
      }

      if (!o.querySelectorAll || !o.querySelector) {
        return false;
      }

      if (v.isObject(document) && o === document) {
        return true;
      }

      // http://stackoverflow.com/a/384380/699304
      /* istanbul ignore else */
      if (typeof HTMLElement === "object") {
        return o instanceof HTMLElement;
      } else {
        return o &&
          typeof o === "object" &&
          o !== null &&
          o.nodeType === 1 &&
          typeof o.nodeName === "string";
      }
    },

    isEmpty: function(value) {
      var attr;

      // Null and undefined are empty
      if (!v.isDefined(value)) {
        return true;
      }

      // functions are non empty
      if (v.isFunction(value)) {
        return false;
      }

      // Whitespace only strings are empty
      if (v.isString(value)) {
        return v.EMPTY_STRING_REGEXP.test(value);
      }

      // For arrays we use the length property
      if (v.isArray(value)) {
        return value.length === 0;
      }

      // Dates have no attributes but aren't empty
      if (v.isDate(value)) {
        return false;
      }

      // If we find at least one property we consider it non empty
      if (v.isObject(value)) {
        for (attr in value) {
          return false;
        }
        return true;
      }

      return false;
    },

    // Formats the specified strings with the given values like so:
    // ```
    // format("Foo: %{foo}", {foo: "bar"}) // "Foo bar"
    // ```
    // If you want to write %{...} without having it replaced simply
    // prefix it with % like this `Foo: %%{foo}` and it will be returned
    // as `"Foo: %{foo}"`
    format: v.extend(function(str, vals) {
      if (!v.isString(str)) {
        return str;
      }
      return str.replace(v.format.FORMAT_REGEXP, function(m0, m1, m2) {
        if (m1 === '%') {
          return "%{" + m2 + "}";
        } else {
          return String(vals[m2]);
        }
      });
    }, {
      // Finds %{key} style patterns in the given string
      FORMAT_REGEXP: /(%?)%\{([^\}]+)\}/g
    }),

    // "Prettifies" the given string.
    // Prettifying means replacing [.\_-] with spaces as well as splitting
    // camel case words.
    prettify: function(str) {
      if (v.isNumber(str)) {
        // If there are more than 2 decimals round it to two
        if ((str * 100) % 1 === 0) {
          return "" + str;
        } else {
          return parseFloat(Math.round(str * 100) / 100).toFixed(2);
        }
      }

      if (v.isArray(str)) {
        return str.map(function(s) { return v.prettify(s); }).join(", ");
      }

      if (v.isObject(str)) {
        return str.toString();
      }

      // Ensure the string is actually a string
      str = "" + str;

      return str
        // Splits keys separated by periods
        .replace(/([^\s])\.([^\s])/g, '$1 $2')
        // Removes backslashes
        .replace(/\\+/g, '')
        // Replaces - and - with space
        .replace(/[_-]/g, ' ')
        // Splits camel cased words
        .replace(/([a-z])([A-Z])/g, function(m0, m1, m2) {
          return "" + m1 + " " + m2.toLowerCase();
        })
        .toLowerCase();
    },

    stringifyValue: function(value) {
      return v.prettify(value);
    },

    isString: function(value) {
      return typeof value === 'string';
    },

    isArray: function(value) {
      return {}.toString.call(value) === '[object Array]';
    },

    // Checks if the object is a hash, which is equivalent to an object that
    // is neither an array nor a function.
    isHash: function(value) {
      return v.isObject(value) && !v.isArray(value) && !v.isFunction(value);
    },

    contains: function(obj, value) {
      if (!v.isDefined(obj)) {
        return false;
      }
      if (v.isArray(obj)) {
        return obj.indexOf(value) !== -1;
      }
      return value in obj;
    },

    unique: function(array) {
      if (!v.isArray(array)) {
        return array;
      }
      return array.filter(function(el, index, array) {
        return array.indexOf(el) == index;
      });
    },

    forEachKeyInKeypath: function(object, keypath, callback) {
      if (!v.isString(keypath)) {
        return undefined;
      }

      var key = ""
        , i
        , escape = false;

      for (i = 0; i < keypath.length; ++i) {
        switch (keypath[i]) {
          case '.':
            if (escape) {
              escape = false;
              key += '.';
            } else {
              object = callback(object, key, false);
              key = "";
            }
            break;

          case '\\':
            if (escape) {
              escape = false;
              key += '\\';
            } else {
              escape = true;
            }
            break;

          default:
            escape = false;
            key += keypath[i];
            break;
        }
      }

      return callback(object, key, true);
    },

    getDeepObjectValue: function(obj, keypath) {
      if (!v.isObject(obj)) {
        return undefined;
      }

      return v.forEachKeyInKeypath(obj, keypath, function(obj, key) {
        if (v.isObject(obj)) {
          return obj[key];
        }
      });
    },

    // This returns an object with all the values of the form.
    // It uses the input name as key and the value as value
    // So for example this:
    // <input type="text" name="email" value="foo@bar.com" />
    // would return:
    // {email: "foo@bar.com"}
    collectFormValues: function(form, options) {
      var values = {}
        , i
        , j
        , input
        , inputs
        , option
        , value;

      if (v.isJqueryElement(form)) {
        form = form[0];
      }

      if (!form) {
        return values;
      }

      options = options || {};

      inputs = form.querySelectorAll("input[name], textarea[name]");
      for (i = 0; i < inputs.length; ++i) {
        input = inputs.item(i);

        if (v.isDefined(input.getAttribute("data-ignored"))) {
          continue;
        }

        value = v.sanitizeFormValue(input.value, options);
        if (input.type === "number") {
          value = value ? +value : null;
        } else if (input.type === "checkbox") {
          if (input.attributes.value) {
            if (!input.checked) {
              value = values[input.name] || null;
            }
          } else {
            value = input.checked;
          }
        } else if (input.type === "radio") {
          if (!input.checked) {
            value = values[input.name] || null;
          }
        }
        values[input.name] = value;
      }

      inputs = form.querySelectorAll("select[name]");
      for (i = 0; i < inputs.length; ++i) {
        input = inputs.item(i);
        if (input.multiple) {
          value = [];
          for (j in input.options) {
            option = input.options[j];
            if (option.selected) {
              value.push(v.sanitizeFormValue(option.value, options));
            }
          }
        } else {
          value = v.sanitizeFormValue(input.options[input.selectedIndex].value, options);
        }
        values[input.name] = value;
      }

      return values;
    },

    sanitizeFormValue: function(value, options) {
      if (options.trim && v.isString(value)) {
        value = value.trim();
      }

      if (options.nullify !== false && value === "") {
        return null;
      }
      return value;
    },

    capitalize: function(str) {
      if (!v.isString(str)) {
        return str;
      }
      return str[0].toUpperCase() + str.slice(1);
    },

    // Remove all errors who's error attribute is empty (null or undefined)
    pruneEmptyErrors: function(errors) {
      return errors.filter(function(error) {
        return !v.isEmpty(error.error);
      });
    },

    // In
    // [{error: ["err1", "err2"], ...}]
    // Out
    // [{error: "err1", ...}, {error: "err2", ...}]
    //
    // All attributes in an error with multiple messages are duplicated
    // when expanding the errors.
    expandMultipleErrors: function(errors) {
      var ret = [];
      errors.forEach(function(error) {
        // Removes errors without a message
        if (v.isArray(error.error)) {
          error.error.forEach(function(msg) {
            ret.push(v.extend({}, error, {error: msg}));
          });
        } else {
          ret.push(error);
        }
      });
      return ret;
    },

    // Converts the error mesages by prepending the attribute name unless the
    // message is prefixed by ^
    convertErrorMessages: function(errors, options) {
      options = options || {};

      var ret = [];
      errors.forEach(function(errorInfo) {
        var error = v.result(errorInfo.error,
            errorInfo.value,
            errorInfo.attribute,
            errorInfo.options,
            errorInfo.attributes,
            errorInfo.globalOptions);

        if (!v.isString(error)) {
          ret.push(errorInfo);
          return;
        }

        if (error[0] === '^') {
          error = error.slice(1);
        } else if (options.fullMessages !== false) {
          error = v.capitalize(v.prettify(errorInfo.attribute)) + " " + error;
        }
        error = error.replace(/\\\^/g, "^");
        error = v.format(error, {value: v.stringifyValue(errorInfo.value)});
        ret.push(v.extend({}, errorInfo, {error: error}));
      });
      return ret;
    },

    // In:
    // [{attribute: "<attributeName>", ...}]
    // Out:
    // {"<attributeName>": [{attribute: "<attributeName>", ...}]}
    groupErrorsByAttribute: function(errors) {
      var ret = {};
      errors.forEach(function(error) {
        var list = ret[error.attribute];
        if (list) {
          list.push(error);
        } else {
          ret[error.attribute] = [error];
        }
      });
      return ret;
    },

    // In:
    // [{error: "<message 1>", ...}, {error: "<message 2>", ...}]
    // Out:
    // ["<message 1>", "<message 2>"]
    flattenErrorsToArray: function(errors) {
      return errors
        .map(function(error) { return error.error; })
        .filter(function(value, index, self) {
          return self.indexOf(value) === index;
        });
    },

    cleanAttributes: function(attributes, whitelist) {
      function whitelistCreator(obj, key, last) {
        if (v.isObject(obj[key])) {
          return obj[key];
        }
        return (obj[key] = last ? true : {});
      }

      function buildObjectWhitelist(whitelist) {
        var ow = {}
          , lastObject
          , attr;
        for (attr in whitelist) {
          if (!whitelist[attr]) {
            continue;
          }
          v.forEachKeyInKeypath(ow, attr, whitelistCreator);
        }
        return ow;
      }

      function cleanRecursive(attributes, whitelist) {
        if (!v.isObject(attributes)) {
          return attributes;
        }

        var ret = v.extend({}, attributes)
          , w
          , attribute;

        for (attribute in attributes) {
          w = whitelist[attribute];

          if (v.isObject(w)) {
            ret[attribute] = cleanRecursive(ret[attribute], w);
          } else if (!w) {
            delete ret[attribute];
          }
        }
        return ret;
      }

      if (!v.isObject(whitelist) || !v.isObject(attributes)) {
        return {};
      }

      whitelist = buildObjectWhitelist(whitelist);
      return cleanRecursive(attributes, whitelist);
    },

    exposeModule: function(validate, root, exports, module, define) {
      if (exports) {
        if (module && module.exports) {
          exports = module.exports = validate;
        }
        exports.validate = validate;
      } else {
        root.validate = validate;
        if (validate.isFunction(define) && define.amd) {
          define([], function () { return validate; });
        }
      }
    },

    warn: function(msg) {
      if (typeof console !== "undefined" && console.warn) {
        console.warn("[validate.js] " + msg);
      }
    },

    error: function(msg) {
      if (typeof console !== "undefined" && console.error) {
        console.error("[validate.js] " + msg);
      }
    }
  });

  validate.validators = {
    // Presence validates that the value isn't empty
    presence: function(value, options) {
      options = v.extend({}, this.options, options);
      if (options.allowEmpty ? !v.isDefined(value) : v.isEmpty(value)) {
        return options.message || this.message || "can't be blank";
      }
    },
    length: function(value, options, attribute) {
      // Empty values are allowed
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var is = options.is
        , maximum = options.maximum
        , minimum = options.minimum
        , tokenizer = options.tokenizer || function(val) { return val; }
        , err
        , errors = [];

      value = tokenizer(value);
      var length = value.length;
      if(!v.isNumber(length)) {
        v.error(v.format("Attribute %{attr} has a non numeric value for `length`", {attr: attribute}));
        return options.message || this.notValid || "has an incorrect length";
      }

      // Is checks
      if (v.isNumber(is) && length !== is) {
        err = options.wrongLength ||
          this.wrongLength ||
          "is the wrong length (should be %{count} characters)";
        errors.push(v.format(err, {count: is}));
      }

      if (v.isNumber(minimum) && length < minimum) {
        err = options.tooShort ||
          this.tooShort ||
          "is too short (minimum is %{count} characters)";
        errors.push(v.format(err, {count: minimum}));
      }

      if (v.isNumber(maximum) && length > maximum) {
        err = options.tooLong ||
          this.tooLong ||
          "is too long (maximum is %{count} characters)";
        errors.push(v.format(err, {count: maximum}));
      }

      if (errors.length > 0) {
        return options.message || errors;
      }
    },
    numericality: function(value, options) {
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var errors = []
        , name
        , count
        , checks = {
            greaterThan:          function(v, c) { return v > c; },
            greaterThanOrEqualTo: function(v, c) { return v >= c; },
            equalTo:              function(v, c) { return v === c; },
            lessThan:             function(v, c) { return v < c; },
            lessThanOrEqualTo:    function(v, c) { return v <= c; },
            divisibleBy:          function(v, c) { return v % c === 0; }
          };

      // Strict will check that it is a valid looking number
      if (v.isString(value) && options.strict) {
        var pattern = "^(0|[1-9]\\d*)";
        if (!options.onlyInteger) {
          pattern += "(\\.\\d+)?";
        }
        pattern += "$";

        if (!(new RegExp(pattern).test(value))) {
          return options.message ||
            options.notValid ||
            this.notValid ||
            this.message ||
            "must be a valid number";
        }
      }

      // Coerce the value to a number unless we're being strict.
      if (options.noStrings !== true && v.isString(value) && !v.isEmpty(value)) {
        value = +value;
      }

      // If it's not a number we shouldn't continue since it will compare it.
      if (!v.isNumber(value)) {
        return options.message ||
          options.notValid ||
          this.notValid ||
          this.message ||
          "is not a number";
      }

      // Same logic as above, sort of. Don't bother with comparisons if this
      // doesn't pass.
      if (options.onlyInteger && !v.isInteger(value)) {
        return options.message ||
          options.notInteger ||
          this.notInteger ||
          this.message ||
          "must be an integer";
      }

      for (name in checks) {
        count = options[name];
        if (v.isNumber(count) && !checks[name](value, count)) {
          // This picks the default message if specified
          // For example the greaterThan check uses the message from
          // this.notGreaterThan so we capitalize the name and prepend "not"
          var key = "not" + v.capitalize(name);
          var msg = options[key] ||
            this[key] ||
            this.message ||
            "must be %{type} %{count}";

          errors.push(v.format(msg, {
            count: count,
            type: v.prettify(name)
          }));
        }
      }

      if (options.odd && value % 2 !== 1) {
        errors.push(options.notOdd ||
            this.notOdd ||
            this.message ||
            "must be odd");
      }
      if (options.even && value % 2 !== 0) {
        errors.push(options.notEven ||
            this.notEven ||
            this.message ||
            "must be even");
      }

      if (errors.length) {
        return options.message || errors;
      }
    },
    datetime: v.extend(function(value, options) {
      if (!v.isFunction(this.parse) || !v.isFunction(this.format)) {
        throw new Error("Both the parse and format functions needs to be set to use the datetime/date validator");
      }

      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var err
        , errors = []
        , earliest = options.earliest ? this.parse(options.earliest, options) : NaN
        , latest = options.latest ? this.parse(options.latest, options) : NaN;

      value = this.parse(value, options);

      // 86400000 is the number of seconds in a day, this is used to remove
      // the time from the date
      if (isNaN(value) || options.dateOnly && value % 86400000 !== 0) {
        err = options.notValid ||
          options.message ||
          this.notValid ||
          "must be a valid date";
        return v.format(err, {value: arguments[0]});
      }

      if (!isNaN(earliest) && value < earliest) {
        err = options.tooEarly ||
          options.message ||
          this.tooEarly ||
          "must be no earlier than %{date}";
        err = v.format(err, {
          value: this.format(value, options),
          date: this.format(earliest, options)
        });
        errors.push(err);
      }

      if (!isNaN(latest) && value > latest) {
        err = options.tooLate ||
          options.message ||
          this.tooLate ||
          "must be no later than %{date}";
        err = v.format(err, {
          date: this.format(latest, options),
          value: this.format(value, options)
        });
        errors.push(err);
      }

      if (errors.length) {
        return v.unique(errors);
      }
    }, {
      parse: null,
      format: null
    }),
    date: function(value, options) {
      options = v.extend({}, options, {dateOnly: true});
      return v.validators.datetime.call(v.validators.datetime, value, options);
    },
    format: function(value, options) {
      if (v.isString(options) || (options instanceof RegExp)) {
        options = {pattern: options};
      }

      options = v.extend({}, this.options, options);

      var message = options.message || this.message || "is invalid"
        , pattern = options.pattern
        , match;

      // Empty values are allowed
      if (!v.isDefined(value)) {
        return;
      }
      if (!v.isString(value)) {
        return message;
      }

      if (v.isString(pattern)) {
        pattern = new RegExp(options.pattern, options.flags);
      }
      match = pattern.exec(value);
      if (!match || match[0].length != value.length) {
        return message;
      }
    },
    inclusion: function(value, options) {
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }
      if (v.isArray(options)) {
        options = {within: options};
      }
      options = v.extend({}, this.options, options);
      if (v.contains(options.within, value)) {
        return;
      }
      var message = options.message ||
        this.message ||
        "^%{value} is not included in the list";
      return v.format(message, {value: value});
    },
    exclusion: function(value, options) {
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }
      if (v.isArray(options)) {
        options = {within: options};
      }
      options = v.extend({}, this.options, options);
      if (!v.contains(options.within, value)) {
        return;
      }
      var message = options.message || this.message || "^%{value} is restricted";
      return v.format(message, {value: value});
    },
    email: v.extend(function(value, options) {
      options = v.extend({}, this.options, options);
      var message = options.message || this.message || "is not a valid email";
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }
      if (!v.isString(value)) {
        return message;
      }
      if (!this.PATTERN.exec(value)) {
        return message;
      }
    }, {
      PATTERN: /^[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i
    }),
    equality: function(value, options, attribute, attributes) {
      if (!v.isDefined(value)) {
        return;
      }

      if (v.isString(options)) {
        options = {attribute: options};
      }
      options = v.extend({}, this.options, options);
      var message = options.message ||
        this.message ||
        "is not equal to %{attribute}";

      if (v.isEmpty(options.attribute) || !v.isString(options.attribute)) {
        throw new Error("The attribute must be a non empty string");
      }

      var otherValue = v.getDeepObjectValue(attributes, options.attribute)
        , comparator = options.comparator || function(v1, v2) {
          return v1 === v2;
        };

      if (!comparator(value, otherValue, options, attribute, attributes)) {
        return v.format(message, {attribute: v.prettify(options.attribute)});
      }
    },

    // A URL validator that is used to validate URLs with the ability to
    // restrict schemes and some domains.
    url: function(value, options) {
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var message = options.message || this.message || "is not a valid url"
        , schemes = options.schemes || this.schemes || ['http', 'https']
        , allowLocal = options.allowLocal || this.allowLocal || false;

      if (!v.isString(value)) {
        return message;
      }

      // https://gist.github.com/dperini/729294
      var regex =
        "^" +
        // protocol identifier
        "(?:(?:" + schemes.join("|") + ")://)" +
        // user:pass authentication
        "(?:\\S+(?::\\S*)?@)?" +
        "(?:";

      var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";

      if (allowLocal) {
        tld += "?";
      } else {
        regex +=
          // IP address exclusion
          // private & local networks
          "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
          "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
          "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})";
      }

      regex +=
          // IP address dotted notation octets
          // excludes loopback network 0.0.0.0
          // excludes reserved space >= 224.0.0.0
          // excludes network & broacast addresses
          // (first & last IP address of each class)
          "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
          "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
          "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
        "|" +
          // host name
          "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
          // domain name
          "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
          tld +
        ")" +
        // port number
        "(?::\\d{2,5})?" +
        // resource path
        "(?:[/?#]\\S*)?" +
      "$";

      var PATTERN = new RegExp(regex, 'i');
      if (!PATTERN.exec(value)) {
        return message;
      }
    }
  };

  validate.formatters = {
    detailed: function(errors) {return errors;},
    flat: v.flattenErrorsToArray,
    grouped: function(errors) {
      var attr;

      errors = v.groupErrorsByAttribute(errors);
      for (attr in errors) {
        errors[attr] = v.flattenErrorsToArray(errors[attr]);
      }
      return errors;
    },
    constraint: function(errors) {
      var attr;
      errors = v.groupErrorsByAttribute(errors);
      for (attr in errors) {
        errors[attr] = errors[attr].map(function(result) {
          return result.validator;
        }).sort();
      }
      return errors;
    }
  };

  validate.exposeModule(validate, this, exports, module, __webpack_require__(1282));
}).call(this,
         true ? /* istanbul ignore next */ exports : null,
         true ? /* istanbul ignore next */ module : null,
        __webpack_require__(1282));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(646)(module)))

/***/ }),
/* 3183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export tryJsonParse */
function tryJsonParse(value){var parsed=void 0;try{parsed=JSON.parse(value);}catch(e){return undefined;}return parsed;}

/***/ }),
/* 3184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HYDRATE_STATE */
/* unused harmony export hydrateState */
/* unused harmony export makeHydratable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(357);
var HYDRATE_STATE='HYDRATE_STATE';var hydrateState=Object(__WEBPACK_IMPORTED_MODULE_0__actions_js__["b" /* createAction */])(HYDRATE_STATE);function makeHydratable(reducer,hydrateActionType){return function(state,action){switch(action.type){case hydrateActionType:return reducer(action.payload,action);default:return reducer(state,action);}};}

/***/ }),
/* 3185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = login;
/* harmony export (immutable) */ __webpack_exports__["c"] = logout;
/* harmony export (immutable) */ __webpack_exports__["a"] = checkForToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_localforage__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url_join__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_url_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_js__ = __webpack_require__(73);
var tokenKey='token';var tokenStore=__WEBPACK_IMPORTED_MODULE_0_localforage___default.a.createInstance({name:'tokens'});var tokenBase={get isExpired(){return this.expiresAt*1000<Date.now();}};var makeToken=function makeToken(token){return Object.assign(Object.create(tokenBase),token);};var exists=function exists(obj){return obj!==undefined&&obj!==null;};function login(){var href=__WEBPACK_IMPORTED_MODULE_1_url_join___default()(__WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].oAuth.authorization,'?'+__WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(Object.assign({},__WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].oAuth,{nonce:'1',state:'1'})));window.location.href=href;}function logout(){return tokenStore.removeItem(tokenKey);}function checkForToken(){// Parse the token
return tokenStore.getItem(tokenKey).then(function(result){if(exists(result))return result;//if (exists(result)) logout()
var token=parseRedirectToken(window.location.hash);if(token){window.location.hash='';token=unpackEncodedToken(token);return exists(token)?tokenStore.setItem(tokenKey,token):null;}return null;}).then(function(result){if(!result)return;var token=makeToken(result);return token.isExpired?logout().then(function(){return undefined;}):token;});}function parseRedirectToken(value){if(!value||!value.length)return null;if(value[0]==='#')value=value.substring(1);var token=__WEBPACK_IMPORTED_MODULE_2_qs___default.a.parse(value);if(token.error){var message='Error logging in: '+(token.error_description||'Unknown Error');console.log(message);throw new Error(message);}// Check that this is an oauth redirection, not a normal app route
return token.access_token?token:null;}function parseJwtPayload(payload){return JSON.parse(window.atob(payload));}function unpackEncodedToken(token){if(!token||!token.access_token)return null;var accessValues=token.access_token.split('.');var openIdValues=token.id_token.split('.');var accessClaims=parseJwtPayload(accessValues[1]);var openIdClaims=parseJwtPayload(openIdValues[1]);// The name of these values will depend on the token issuer
// Ping and Okta have different values for scope and username
return{accessToken:token.access_token,openIdToken:token.id_token,expiresIn:token.expires_in,expiresAt:accessClaims.exp,username:accessClaims.sub,email:openIdClaims.email,firstName:openIdClaims.given_name,lastName:openIdClaims.family_name,scope:accessClaims.scope,encoded:token};}

/***/ }),
/* 3186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(54);

var _interopRequireDefault = __webpack_require__(53);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.size = exports.default = exports.IconWrapper = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(9));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(4));

var _createClass2 = _interopRequireDefault(__webpack_require__(5));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(7));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(6));

var _inherits2 = _interopRequireDefault(__webpack_require__(8));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _styledComponents = _interopRequireDefault(__webpack_require__(2));

var _uuid = _interopRequireDefault(__webpack_require__(22));

var _theme = __webpack_require__(3187);

var _constants = __webpack_require__(3195);

var getSize = function getSize(props) {
  if (props.size) {
    return "height: ".concat(_constants.sizes[props.size], "; width: ").concat(_constants.sizes[props.size], ";");
  }

  return null;
};

var IconWrapper = _styledComponents.default.span.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "dyhwwi-0"
})(["\n  ", " color: ", ";\n  display: inline-block;\n  fill: ", ";\n  flex-shrink: 0;\n  line-height: 1;\n\n  > svg {\n    ", " max-height: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    pointer-events: none;\n    vertical-align: bottom;\n  }\n  /* Stop-color doesn't properly apply in chrome when the inherited/current color changes.\n   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS\n   * rule) and then override it with currentColor for the color changes to be picked up.\n   */\n  stop {\n    stop-color: currentColor;\n  }\n"], getSize, function (p) {
  return p.primaryColor || 'currentColor';
}, function (p) {
  return p.secondaryColor || _theme.colors.background;
}, getSize);

exports.IconWrapper = IconWrapper;

var Icon =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Icon, _Component);

  function Icon() {
    (0, _classCallCheck2.default)(this, Icon);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Icon).apply(this, arguments));
  }

  (0, _createClass2.default)(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Glyph = _this$props.glyph,
          dangerouslySetGlyph = _this$props.dangerouslySetGlyph,
          primaryColor = _this$props.primaryColor,
          secondaryColor = _this$props.secondaryColor,
          size = _this$props.size; // handling the glyphs as strings

      if (dangerouslySetGlyph) {
        return _react.default.createElement(IconWrapper, {
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          size: size,
          "aria-label": this.props.label,
          dangerouslySetInnerHTML: {
            __html: Icon.insertDynamicGradientID(dangerouslySetGlyph)
          }
        });
      } // handling the glyphs when passed through as functions


      return _react.default.createElement(IconWrapper, {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        "aria-label": this.props.label
      }, Glyph ? _react.default.createElement(Glyph, {
        role: "presentation"
      }) : null);
    }
  }], [{
    key: "insertDynamicGradientID",

    /* Icons need unique gradient IDs across instances for different gradient definitions to work
     * correctly.
     * A step in the icon build process replaces linear gradient IDs and their references in paths
     * to a placeholder string so we can replace them with a dynamic ID here.
     * Replacing the original IDs with placeholders in the build process is more robust than not
     * using placeholders as we do not have to rely on regular expressions to find specific element
     * to replace.
     */
    value: function insertDynamicGradientID(svgStr) {
      var id = (0, _uuid.default)();
      var replacedSvgStr = svgStr.replace(/id="([^"]+)-idPlaceholder"/g, "id=$1-".concat(id)).replace(/fill="url\(#([^"]+)-idPlaceholder\)"/g, "fill=\"url(#$1-".concat(id, ")\""));
      return replacedSvgStr;
    }
  }]);
  return Icon;
}(_react.Component);

exports.default = Icon;
var size = Object.keys(_constants.sizes).reduce(function (p, c) {
  return Object.assign(p, (0, _defineProperty2.default)({}, c, c));
}, {});
exports.size = size;

/***/ }),
/* 3187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AtlasKitThemeProvider", function() { return AtlasKitThemeProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elevation__ = __webpack_require__(3188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typography__ = __webpack_require__(3189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_math__ = __webpack_require__(3190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getTheme__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_themed__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__ = __webpack_require__(3191);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "colors", function() { return __WEBPACK_IMPORTED_MODULE_0__colors__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "elevation", function() { return __WEBPACK_IMPORTED_MODULE_1__elevation__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "typography", function() { return __WEBPACK_IMPORTED_MODULE_2__typography__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "math", function() { return __WEBPACK_IMPORTED_MODULE_3__utils_math__; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getTheme", function() { return __WEBPACK_IMPORTED_MODULE_4__utils_getTheme__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "themed", function() { return __WEBPACK_IMPORTED_MODULE_5__utils_themed__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AtlaskitThemeProvider", function() { return __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Appearance__ = __webpack_require__(3192);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Appearance", function() { return __WEBPACK_IMPORTED_MODULE_7__components_Appearance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(310);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FLATTENED", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "CHANNEL", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_THEME_MODE", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "THEME_MODES", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "borderRadius", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "gridSize", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "fontSize", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "fontSizeSmall", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "fontFamily", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "codeFontFamily", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "focusRing", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "noFocusRing", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "layers", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "assistive", function() { return __WEBPACK_IMPORTED_MODULE_8__constants__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Reset__ = __webpack_require__(3193);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ResetTheme", function() { return __WEBPACK_IMPORTED_MODULE_9__components_Reset__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Reset", function() { return __WEBPACK_IMPORTED_MODULE_9__components_Reset__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Theme__ = __webpack_require__(502);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_10__components_Theme__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hoc__ = __webpack_require__(3194);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "withTheme", function() { return __WEBPACK_IMPORTED_MODULE_11__hoc__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_createTheme__ = __webpack_require__(503);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "createTheme", function() { return __WEBPACK_IMPORTED_MODULE_12__utils_createTheme__["a"]; });








 // backwards-compatible export with old Atlaskit case

var AtlasKitThemeProvider = __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__["a" /* default */];
 // New API






/***/ }),
/* 3188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e100", function() { return e100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e200", function() { return e200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e300", function() { return e300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e400", function() { return e400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e500", function() { return e500; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(501);

 // Cards on a board

var e100 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 1px 1px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px 0 ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 1px 1px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
}); // Inline dialogs

var e200 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 4px 8px -2px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 4px 8px -2px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
}); // Modals

var e300 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 8px 16px -4px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 8px 16px -4px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
}); // Panels

var e400 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 12px 24px -6px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 12px 24px -6px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
}); // Flag messages (notifications)

var e500 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 20px 32px -8px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["N60A"], ";"),
  dark: "box-shadow: 0 20px 32px -8px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"], ";")
});

/***/ }),
/* 3189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h900", function() { return h900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h800", function() { return h800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h700", function() { return h700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h600", function() { return h600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h500", function() { return h500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h400", function() { return h400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h300", function() { return h300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h200", function() { return h200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h100", function() { return h100; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colors__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(310);




var baseHeading = function baseHeading(size, lineHeight) {
  return "\n  font-size: ".concat(size / Object(__WEBPACK_IMPORTED_MODULE_2__constants__["j" /* fontSize */])(), "em;\n  font-style: inherit;\n  line-height: ").concat(lineHeight / size, ";\n");
};

var h900 = function h900() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ", "px;\n"], baseHeading(35, 40), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* gridSize */])() * 6.5);
};
var h800 = function h800() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ", "px;\n"], baseHeading(29, 32), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* gridSize */])() * 5);
};
var h700 = function h700() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ", "px;\n"], baseHeading(24, 28), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* gridSize */])() * 5);
};
var h600 = function h600() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ", "px;\n"], baseHeading(20, 24), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* gridSize */])() * 3.5);
};
var h500 = function h500() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ", "px;\n"], baseHeading(16, 20), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* gridSize */])() * 3);
};
var h400 = function h400() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ", "px;\n"], baseHeading(14, 16), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* gridSize */])() * 2);
};
var h300 = function h300() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  margin-top: ", "px;\n  text-transform: uppercase;\n"], baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_1__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* gridSize */])() * 2.5);
};
var h200 = function h200() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 600;\n  margin-top: ", "px;\n"], baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_1__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* gridSize */])() * 2);
};
var h100 = function h100() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  ", " color: ", ";\n  font-weight: 700;\n  margin-top: ", "px;\n"], baseHeading(11, 16), __WEBPACK_IMPORTED_MODULE_1__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* gridSize */])() * 2);
};

/***/ }),
/* 3190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["add"] = add;
/* harmony export (immutable) */ __webpack_exports__["subtract"] = subtract;
/* harmony export (immutable) */ __webpack_exports__["multiply"] = multiply;
/* harmony export (immutable) */ __webpack_exports__["divide"] = divide;
function add(fn, addend) {
  return function (props) {
    return fn(props) + addend;
  };
}
function subtract(fn, subtrahend) {
  return function (props) {
    return fn(props) - subtrahend;
  };
}
function multiply(fn, factor) {
  return function (props) {
    return fn(props) * factor;
  };
}
function divide(fn, divisor) {
  return function (props) {
    return fn(props) / divisor;
  };
}

/***/ }),
/* 3191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AtlaskitThemeProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_exenv__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_exenv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_exenv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__colors__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Theme__ = __webpack_require__(502);












 // For forward-compat until everything is upgraded.



function getStylesheetResetCSS(state) {
  var backgroundColor = __WEBPACK_IMPORTED_MODULE_11__colors__["background"](state);
  return "\n    body { background: ".concat(backgroundColor, "; }\n  ");
}

function buildThemeState(mode) {
  return {
    theme: __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_12__constants__["a" /* CHANNEL */], {
      mode: mode
    })
  };
}

var LegacyReset = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div.withConfig({
  displayName: "AtlaskitThemeProvider__LegacyReset",
  componentId: "sc-431dkp-0"
})(["\n  background-color: ", ";\n  color: ", ";\n\n  a {\n    color: ", ";\n  }\n  a:hover {\n    color: ", ";\n  }\n  a:active {\n    color: ", ";\n  }\n  a:focus {\n    outline-color: ", ";\n  }\n  h1 {\n    color: ", ";\n  }\n  h2 {\n    color: ", ";\n  }\n  h3 {\n    color: ", ";\n  }\n  h4 {\n    color: ", ";\n  }\n  h5 {\n    color: ", ";\n  }\n  h6 {\n    color: ", ";\n  }\n  small {\n    color: ", ";\n  }\n"], __WEBPACK_IMPORTED_MODULE_11__colors__["background"], __WEBPACK_IMPORTED_MODULE_11__colors__["text"], __WEBPACK_IMPORTED_MODULE_11__colors__["link"], __WEBPACK_IMPORTED_MODULE_11__colors__["linkHover"], __WEBPACK_IMPORTED_MODULE_11__colors__["linkActive"], __WEBPACK_IMPORTED_MODULE_11__colors__["linkOutline"], __WEBPACK_IMPORTED_MODULE_11__colors__["heading"], __WEBPACK_IMPORTED_MODULE_11__colors__["heading"], __WEBPACK_IMPORTED_MODULE_11__colors__["heading"], __WEBPACK_IMPORTED_MODULE_11__colors__["heading"], __WEBPACK_IMPORTED_MODULE_11__colors__["heading"], __WEBPACK_IMPORTED_MODULE_11__colors__["subtleHeading"], __WEBPACK_IMPORTED_MODULE_11__colors__["subtleText"]);

var AtlaskitThemeProvider =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(AtlaskitThemeProvider, _Component);

  function AtlaskitThemeProvider(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, AtlaskitThemeProvider);

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(AtlaskitThemeProvider).call(this, props));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "stylesheet", void 0);

    _this.state = buildThemeState(props.mode);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(AtlaskitThemeProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        hasAtlaskitThemeProvider: true
      };
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      if (!this.context.hasAtlaskitThemeProvider && __WEBPACK_IMPORTED_MODULE_10_exenv___default.a.canUseDOM) {
        var css = getStylesheetResetCSS(this.state);
        this.stylesheet = document.createElement('style');
        this.stylesheet.type = 'text/css';
        this.stylesheet.innerHTML = css;

        if (document && document.head) {
          document.head.appendChild(this.stylesheet);
        }
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (newProps.mode !== this.props.mode) {
        var newThemeState = buildThemeState(newProps.mode);

        if (this.stylesheet) {
          var css = getStylesheetResetCSS(newThemeState);
          this.stylesheet.innerHTML = css;
        }

        this.setState(newThemeState);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.stylesheet && document && document.head) {
        document.head.removeChild(this.stylesheet);
        delete this.stylesheet;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var theme = this.state.theme;
      return (
        /* Wrapping the new provider around the old one provides forward
        compatibility when using the old provider for styled components. This
        allows us to use components converted to use the new API with consumers
        using the old provider along side components that may still be using the
        old theming API. */
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Theme__["a" /* default */].Provider, {
          value: function value() {
            return {
              mode: theme[__WEBPACK_IMPORTED_MODULE_12__constants__["a" /* CHANNEL */]].mode
            };
          }
        }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_styled_components__["ThemeProvider"], {
          theme: theme
        }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(LegacyReset, null, children)))
      );
    }
  }]);

  return AtlaskitThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AtlaskitThemeProvider, "defaultProps", {
  mode: __WEBPACK_IMPORTED_MODULE_12__constants__["b" /* DEFAULT_THEME_MODE */]
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AtlaskitThemeProvider, "childContextTypes", {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AtlaskitThemeProvider, "contextTypes", {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
});



/***/ }),
/* 3192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);


/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var children = _ref.children,
      props = _ref.props,
      theme = _ref.theme;
  var appearance = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(props) === 'object' ? 'default' : props;
  var merged = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(props) === 'object' ? __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({}, props) : {};
  Object.keys(theme).forEach(function (key) {
    if (!(key in merged)) {
      merged[key] = theme[key]({
        appearance: appearance
      });
    }
  });
  return children(merged);
});

/***/ }),
/* 3193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ResetTheme; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Reset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__colors__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_createTheme__ = __webpack_require__(503);







var orTextColor = function orTextColor(preferred) {
  return function (p) {
    return p[preferred] || p.textColor;
  };
};

var Div = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div.withConfig({
  displayName: "Reset__Div",
  componentId: "sc-15i6ali-0"
})(["\n  ", ";\n"], function (p) {
  return Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["css"])(["\n    background-color: ", ";\n    color: ", ";\n\n    a {\n      color: ", ";\n    }\n    a:hover {\n      color: ", ";\n    }\n    a:active {\n      color: ", ";\n    }\n    a:focus {\n      outline-color: ", ";\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ", ";\n    }\n    h6 {\n      color: ", ";\n    }\n    small {\n      color: ", ";\n    }\n  "], p.backgroundColor, p.textColor, orTextColor('linkColor'), orTextColor('linkColorHover'), orTextColor('linkColorActive'), orTextColor('linkColorOutline'), orTextColor('headingColor'), orTextColor('subtleHeadingColor'), orTextColor('subtleTextColor'));
});
var ResetTheme = Object(__WEBPACK_IMPORTED_MODULE_5__utils_createTheme__["a" /* createTheme */])(function () {
  return {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N0"],
    linkColor: __WEBPACK_IMPORTED_MODULE_4__colors__["B400"],
    linkColorHover: __WEBPACK_IMPORTED_MODULE_4__colors__["B300"],
    linkColorActive: __WEBPACK_IMPORTED_MODULE_4__colors__["B500"],
    linkColorOutline: __WEBPACK_IMPORTED_MODULE_4__colors__["B100"],
    headingColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N800"],
    subtleHeadingColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N200"],
    subtleTextColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N200"],
    textColor: __WEBPACK_IMPORTED_MODULE_4__colors__["N900"]
  };
});
function Reset(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ResetTheme.Provider, {
    value: props.theme
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ResetTheme.Consumer, null, function (tokens) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Div, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, tokens, {
      mode: undefined
    }), props), props.children);
  }));
}

/***/ }),
/* 3194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Theme__ = __webpack_require__(502);


 // Pre-executes the theme and passes it as a prop to the supplied component.
// This is useful for ensuring that the current theme is accessible as props
// in styled-components.

function withTheme(InnerComponent) {
  return function ComponentWithTheme(props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Theme__["a" /* default */].Consumer, null, function (tokens) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InnerComponent, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, props, {
        theme: tokens
      }));
    });
  };
}

/***/ }),
/* 3195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = void 0;
var sizes = {
  small: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '48px'
};
exports.sizes = sizes;

/***/ }),
/* 3196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HomePage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__serviceDesk_IssueList__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__serviceDesk_request_RequestTypeList__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth_reducer__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appStatus_reducer__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_index__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_refresh__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_refresh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_refresh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__accessSelfService_AccessStatus__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appStatus_AppStatus__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__accessSelfService_actions__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_index__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HomePage=function(_Component){_inherits(HomePage,_Component);function HomePage(){_classCallCheck(this,HomePage);return _possibleConstructorReturn(this,(HomePage.__proto__||Object.getPrototypeOf(HomePage)).apply(this,arguments));}_createClass(HomePage,[{key:'render',value:function render(){var _props=this.props,appList=_props.appList,adUserInfo=_props.adUserInfo,getAccessPending=_props.getAccessPending;var jiraStatus=void 0;if(appList){jiraStatus=appList.find(function(app){return app.name.toLowerCase()==='jira';});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_index__["s" /* PageTitle */],{title:'Home'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_index__["q" /* PageHeader */],{title:'Build And Agile Tools Self-Service Portal'}),!appList||!jiraStatus.available?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_index__["f" /* Container */],{section:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__serviceDesk_IssueList__["a" /* default */],null)));}}]);return HomePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{getAccessPending:Object(__WEBPACK_IMPORTED_MODULE_12__util_index__["f" /* selectIsRequestPending */])(state,__WEBPACK_IMPORTED_MODULE_11__accessSelfService_actions__["e" /* getUserAccessStatus */]),adUserInfo:Object(__WEBPACK_IMPORTED_MODULE_5__auth_reducer__["f" /* selectADUserInfo */])(state),appList:Object(__WEBPACK_IMPORTED_MODULE_6__appStatus_reducer__["b" /* selectAppList */])(state)};},{getUserAccessStatus:__WEBPACK_IMPORTED_MODULE_11__accessSelfService_actions__["e" /* getUserAccessStatus */]})(HomePage)));

/***/ }),
/* 3197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HomePage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__serviceDesk_IssueList__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__serviceDesk_request_RequestTypeList__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth_reducer__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appStatus_reducer__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_index__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_refresh__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_refresh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_refresh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__accessSelfService_AccessStatus__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__accessSelfService_CheckAccessStatus2__ = __webpack_require__(3198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__appStatus_AppStatus__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__accessSelfService_actions__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_index__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HomePage=function(_Component){_inherits(HomePage,_Component);function HomePage(){_classCallCheck(this,HomePage);return _possibleConstructorReturn(this,(HomePage.__proto__||Object.getPrototypeOf(HomePage)).apply(this,arguments));}_createClass(HomePage,[{key:'render',value:function render(){var _props=this.props,appList=_props.appList,adUserInfo=_props.adUserInfo,getAccessPending=_props.getAccessPending;var jiraStatus=void 0;if(appList){jiraStatus=appList.find(function(app){return app.name.toLowerCase()==='jira';});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_index__["s" /* PageTitle */],{title:'Home'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_index__["q" /* PageHeader */],{title:'Build And Agile Tools Self-Service Portal'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_index__["f" /* Container */],{section:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_index__["j" /* H3 */],{className:'pb5-sm'},'App Access'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__accessSelfService_CheckAccessStatus2__["a" /* default */],null)),!appList||!jiraStatus.available?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_index__["f" /* Container */],{section:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Average Wait Time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Application access is generally available within two (2) hours of the initial request. Please ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://baat.niketech.com/create',target:'_blank'},'create a request'),' if you\'re still unable to access the application(s) after that time.')));}}]);return HomePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{getAccessPending:Object(__WEBPACK_IMPORTED_MODULE_13__util_index__["f" /* selectIsRequestPending */])(state,__WEBPACK_IMPORTED_MODULE_12__accessSelfService_actions__["e" /* getUserAccessStatus */]),adUserInfo:Object(__WEBPACK_IMPORTED_MODULE_5__auth_reducer__["f" /* selectADUserInfo */])(state),appList:Object(__WEBPACK_IMPORTED_MODULE_6__appStatus_reducer__["b" /* selectAppList */])(state)};},{getUserAccessStatus:__WEBPACK_IMPORTED_MODULE_12__accessSelfService_actions__["e" /* getUserAccessStatus */]})(HomePage)));

/***/ }),
/* 3198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_requireLogin_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducer__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__accessSelfService_AccessStatus__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AccessGuide__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__userCheckForm__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_index__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__auth_reducer_js__ = __webpack_require__(59);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CheckAccessStatus=function(_Component){_inherits(CheckAccessStatus,_Component);function CheckAccessStatus(props){var _ref;var _temp,_this;_classCallCheck(this,CheckAccessStatus);for(var _len=arguments.length,args=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}(_temp=(_this=_possibleConstructorReturn(this,(_ref=CheckAccessStatus.__proto__||Object.getPrototypeOf(CheckAccessStatus)).call.apply(_ref,[this,props].concat(args))),_this),_this.handleSubmit=function(fieldValue){var _this$props=_this.props,checkUserExists=_this$props.checkUserExists,setUserCheckResults=_this$props.setUserCheckResults;Object(__WEBPACK_IMPORTED_MODULE_5__actions__["d" /* clearUserStatus */])();setUserCheckResults(null);if(!fieldValue.UserId){setUserCheckResults('You need to enter an AD or Email address to check');}else{checkUserExists(fieldValue.UserId);_this.setState({userId:fieldValue.UserId});}},_temp),_this.state={userId:null};return _this;}_createClass(CheckAccessStatus,[{key:'render',value:function render(){var _props=this.props,userCheckResults=_props.userCheckResults,userCheckPending=_props.userCheckPending,loggedInUser=_props.loggedInUser;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index_js__["f" /* Container */],{section:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__userCheckForm__["a" /* default */],{onSubmit:this.handleSubmit,actionInProgress:userCheckPending}),userCheckResults==true?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__accessSelfService_AccessStatus__["a" /* default */],{username:this.state.userId,title:'Application Access Status'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'access-self-service-error'},userCheckResults));}}]);return CheckAccessStatus;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_3__auth_requireLogin_js__["b" /* default */])('AccessSelfService'),Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{userCheckPending:Object(__WEBPACK_IMPORTED_MODULE_10__util_index__["f" /* selectIsRequestPending */])(state,__WEBPACK_IMPORTED_MODULE_5__actions__["a" /* checkUserExists */]),userCheckResults:Object(__WEBPACK_IMPORTED_MODULE_4__reducer__["d" /* selectUserCheckResults */])(state),loggedInUser:Object(__WEBPACK_IMPORTED_MODULE_11__auth_reducer_js__["f" /* selectADUserInfo */])(state)};},{checkUserExists:__WEBPACK_IMPORTED_MODULE_5__actions__["a" /* checkUserExists */],clearUserCheck:__WEBPACK_IMPORTED_MODULE_5__actions__["c" /* clearUserCheck */],setUserCheckResults:__WEBPACK_IMPORTED_MODULE_5__actions__["f" /* setUserCheckResults */],clearUserStatus:__WEBPACK_IMPORTED_MODULE_5__actions__["d" /* clearUserStatus */]}))(CheckAccessStatus));

/***/ }),
/* 3199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form(props, context) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('Form must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  _createClass(Form, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.context._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form', this.props);
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  onSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
Form.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};

Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(Form);
/* unused harmony default export */ var _unused_webpack_default_export = (Form);

/***/ }),
/* 3200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);




var FormName = function FormName(_ref, _ref2) {
  var children = _ref.children;
  var _reduxForm = _ref2._reduxForm;
  return children({ form: _reduxForm && _reduxForm.form });
};
FormName.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    form: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired
};

/* unused harmony default export */ var _unused_webpack_default_export = (FormName);

/***/ }),
/* 3201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_prefixName__ = __webpack_require__(238);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var FormSection = function (_Component) {
  _inherits(FormSection, _Component);

  function FormSection(props, context) {
    _classCallCheck(this, FormSection);

    var _this = _possibleConstructorReturn(this, (FormSection.__proto__ || Object.getPrototypeOf(FormSection)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('FormSection must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  _createClass(FormSection, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var context = this.context,
          name = this.props.name;

      return {
        _reduxForm: _extends({}, context._reduxForm, {
          sectionPrefix: Object(__WEBPACK_IMPORTED_MODULE_2__util_prefixName__["a" /* default */])(context, name)
        })
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          name = _props.name,
          component = _props.component,
          rest = _objectWithoutProperties(_props, ['children', 'name', 'component']);

      if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(children)) {
        return children;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, rest, {
        children: children
      }));
    }
  }]);

  return FormSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FormSection.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])
};

FormSection.defaultProps = {
  component: 'div'
};

FormSection.childContextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

FormSection.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (FormSection);

/***/ }),
/* 3202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    cls.apply(this, arguments);
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var ExtendableError = function (_extendableBuiltin2) {
  _inherits(ExtendableError, _extendableBuiltin2);

  function ExtendableError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, ExtendableError);

    // extending Error is weird and does not propagate `message`
    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));

    Object.defineProperty(_this, 'message', {
      configurable: true,
      enumerable: false,
      value: message,
      writable: true
    });

    Object.defineProperty(_this, 'name', {
      configurable: true,
      enumerable: false,
      value: _this.constructor.name,
      writable: true
    });

    if (Error.hasOwnProperty('captureStackTrace')) {
      Error.captureStackTrace(_this, _this.constructor);
      return _possibleConstructorReturn(_this);
    }

    Object.defineProperty(_this, 'stack', {
      configurable: true,
      enumerable: false,
      value: new Error(message).stack,
      writable: true
    });
    return _this;
  }

  return ExtendableError;
}(_extendableBuiltin(Error));

/* harmony default export */ __webpack_exports__["a"] = (ExtendableError);


/***/ }),
/* 3203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export formPropTypes */
/* unused harmony export fieldInputPropTypes */
/* unused harmony export fieldMetaPropTypes */
/* unused harmony export fieldArrayMetaPropTypes */
/* unused harmony export fieldArrayFieldsPropTypes */
/* unused harmony export fieldPropTypes */
/* unused harmony export fieldArrayPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var any = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
    bool = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    func = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    shape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape,
    string = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    oneOfType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType,
    object = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    number = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number;


var formPropTypes = {
  // State:
  anyTouched: bool.isRequired, // true if any of the fields have been marked as touched
  asyncValidating: oneOfType([bool, string]).isRequired, // true if async validation is running, a string if a field triggered async validation
  dirty: bool.isRequired, // true if any values are different from initialValues
  error: any, // form-wide error from '_error' key in validation result
  form: string.isRequired, // the name of the form
  invalid: bool.isRequired, // true if there are any validation errors
  initialized: bool.isRequired, // true if the form has been initialized
  initialValues: object, // the initialValues object passed to reduxForm
  pristine: bool.isRequired, // true if the values are the same as initialValues
  pure: bool.isRequired, // if true, implements shouldComponentUpdate
  submitting: bool.isRequired, // true if the form is in the process of being submitted
  submitFailed: bool.isRequired, // true if the form was submitted and failed for any reason
  submitSucceeded: bool.isRequired, // true if the form was successfully submitted
  valid: bool.isRequired, // true if there are no validation errors
  warning: any, // form-wide warning from '_warning' key in validation result
  // Actions:
  array: shape({
    insert: func.isRequired, // function to insert a value into an array field
    move: func.isRequired, // function to move a value within an array field
    pop: func.isRequired, // function to pop a value off of an array field
    push: func.isRequired, // function to push a value onto an array field
    remove: func.isRequired, // function to remove a value from an array field
    removeAll: func.isRequired, // function to remove all the values from an array field
    shift: func.isRequired, // function to shift a value out of an array field
    splice: func.isRequired, // function to splice a value into an array field
    swap: func.isRequired, // function to swap values in an array field
    unshift: func.isRequired // function to unshift a value into an array field
  }),
  asyncValidate: func.isRequired, // function to trigger async validation
  autofill: func.isRequired, // action to set a value of a field and mark it as autofilled
  blur: func.isRequired, // action to mark a field as blurred
  change: func.isRequired, // action to change the value of a field
  clearAsyncError: func.isRequired, // action to clear the async error of a field
  clearFields: func.isRequired, // action to clean fields values for all fields
  clearSubmitErrors: func.isRequired, // action to remove submitErrors and error
  destroy: func.isRequired, // action to destroy the form's data in Redux
  dispatch: func.isRequired, // the Redux dispatch action
  handleSubmit: func.isRequired, // function to submit the form
  initialize: func.isRequired, // action to initialize form data
  reset: func.isRequired, // action to reset the form data to previously initialized values
  resetSection: func.isRequired, // action to reset the form sections data to previously initialized values
  touch: func.isRequired, // action to mark fields as touched
  submit: func.isRequired, // action to trigger a submission of the specified form
  untouch: func.isRequired, // action to mark fields as untouched

  // triggerSubmit
  triggerSubmit: bool, // if true, submits the form on componentWillReceiveProps
  clearSubmit: func.isRequired // called before a triggered submit, by default clears triggerSubmit
};

var fieldInputPropTypes = {
  checked: bool,
  name: string.isRequired,
  onBlur: func.isRequired,
  onChange: func.isRequired,
  onDragStart: func.isRequired,
  onDrop: func.isRequired,
  onFocus: func.isRequired,
  value: any
};

var fieldMetaPropTypes = {
  active: bool.isRequired,
  asyncValidating: bool.isRequired,
  autofilled: bool.isRequired,
  dirty: bool.isRequired,
  dispatch: func.isRequired,
  error: any,
  form: string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitting: bool.isRequired,
  submitFailed: bool.isRequired,
  touched: bool.isRequired,
  valid: bool.isRequired,
  visited: bool.isRequired,
  warning: string
};

var fieldArrayMetaPropTypes = {
  dirty: bool.isRequired,
  error: any,
  form: string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitFailed: bool,
  submitting: bool,
  valid: bool.isRequired,
  warning: string
};

var fieldArrayFieldsPropTypes = {
  name: string.isRequired,
  forEach: func.isRequired,
  get: func.isRequired,
  getAll: func.isRequired,
  insert: func.isRequired,
  length: number.isRequired,
  map: func.isRequired,
  move: func.isRequired,
  pop: func.isRequired,
  push: func.isRequired,
  reduce: func.isRequired,
  remove: func.isRequired,
  removeAll: func.isRequired,
  shift: func.isRequired,
  swap: func.isRequired,
  unshift: func.isRequired
};

var fieldPropTypes = {
  input: shape(fieldInputPropTypes).isRequired,
  meta: shape(fieldMetaPropTypes).isRequired
};

var fieldArrayPropTypes = {
  fields: shape(fieldArrayFieldsPropTypes).isRequired,
  meta: shape(fieldArrayMetaPropTypes).isRequired
};

/* unused harmony default export */ var _unused_webpack_default_export = (formPropTypes);

/***/ }),
/* 3204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createField__ = __webpack_require__(3205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createField__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedField__ = __webpack_require__(3206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_prefixName__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__structure_plain__ = __webpack_require__(26);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var createField = function createField(structure) {
  var ConnectedField = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedField__["a" /* default */])(structure);

  var setIn = structure.setIn;

  var Field = function (_Component) {
    _inherits(Field, _Component);

    function Field(props, context) {
      _classCallCheck(this, Field);

      var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props, context));

      _this.saveRef = function (ref) {
        return _this.ref = ref;
      };

      _this.normalize = function (name, value) {
        var normalize = _this.props.normalize;

        if (!normalize) {
          return value;
        }
        var previousValues = _this.context._reduxForm.getValues();
        var previousValue = _this.value;
        var nextValues = setIn(previousValues, name, value);
        return normalize(value, previousValue, nextValues, previousValues);
      };

      if (!context._reduxForm) {
        throw new Error('Field must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(Field, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'Field', function () {
          return _this2.props.validate;
        }, function () {
          return _this2.props.warn;
        });
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps, nextState) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__["a" /* default */])(this, nextProps, nextState);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var oldName = Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(this.context, this.props.name);
        var newName = Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(nextContext, nextProps.name);

        if (oldName !== newName ||
        // use deepEqual here because they could be a function or an array of functions
        !__WEBPACK_IMPORTED_MODULE_7__structure_plain__["a" /* default */].deepEqual(this.props.validate, nextProps.validate) || !__WEBPACK_IMPORTED_MODULE_7__structure_plain__["a" /* default */].deepEqual(this.props.warn, nextProps.warn)) {
          // unregister old name
          this.context._reduxForm.unregister(oldName);
          // register new name
          this.context._reduxForm.register(newName, 'Field', function () {
            return nextProps.validate;
          }, function () {
            return nextProps.warn;
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Field');
        return this.ref ? this.ref.getWrappedInstance().getRenderedComponent() : undefined;
      }
    }, {
      key: 'render',
      value: function render() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedField, _extends({}, this.props, {
          name: this.name,
          normalize: this.normalize,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return !this.pristine;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !!(this.ref && this.ref.getWrappedInstance().isPristine());
      }
    }, {
      key: 'value',
      get: function get() {
        return this.ref && this.ref.getWrappedInstance().getValue();
      }
    }]);

    return Field;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Field.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    format: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    normalize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onDragStart: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onDrop: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    parse: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    validate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    warn: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    immutableProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string)
  };
  Field.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(Field);
  return Field;
};

/* harmony default export */ __webpack_exports__["a"] = (createField);

/***/ }),
/* 3206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createFieldProps__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__ = __webpack_require__(3208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isReactNative__ = __webpack_require__(1296);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var propsToNotUpdateFor = ['_reduxForm'];

var isObject = function isObject(entity) {
  return entity && (typeof entity === 'undefined' ? 'undefined' : _typeof(entity)) === 'object';
};

var isFunction = function isFunction(entity) {
  return entity && typeof entity === 'function';
};

var eventPreventDefault = function eventPreventDefault(event) {
  if (isObject(event) && isFunction(event.preventDefault)) {
    event.preventDefault();
  }
};

var eventDataTransferGetData = function eventDataTransferGetData(event, key) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.getData)) {
    return event.dataTransfer.getData(key);
  }
};

var eventDataTransferSetData = function eventDataTransferSetData(event, key, value) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.setData)) {
    event.dataTransfer.setData(key, value);
  }
};

var createConnectedField = function createConnectedField(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn;

  var getSyncError = function getSyncError(syncErrors, name) {
    var error = __WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].getIn(syncErrors, name);
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    return error && error._error ? error._error : error;
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name);
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedField = function (_Component) {
    _inherits(ConnectedField, _Component);

    function ConnectedField() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ConnectedField);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedField.__proto__ || Object.getPrototypeOf(ConnectedField)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
        return _this.ref = ref;
      }, _this.isPristine = function () {
        return _this.props.pristine;
      }, _this.getValue = function () {
        return _this.props.value;
      }, _this.handleChange = function (event) {
        var _this$props = _this.props,
            name = _this$props.name,
            dispatch = _this$props.dispatch,
            parse = _this$props.parse,
            normalize = _this$props.normalize,
            onChange = _this$props.onChange,
            _reduxForm = _this$props._reduxForm,
            previousValue = _this$props.value;

        var newValue = Object(__WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse, normalize: normalize });

        var defaultPrevented = false;
        if (onChange) {
          // Can't seem to find a way to extend Event in React Native,
          // thus I simply avoid adding preventDefault() in a RN environment
          // to prevent the following error:
          // `One of the sources for assign has an enumerable key on the prototype chain`
          // Reference: https://github.com/facebook/react-native/issues/5507
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onChange(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue, name);
          } else {
            onChange(event, newValue, previousValue, name);
          }
        }
        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));

          // call post-change callback
          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue, 'change');
          }
        }
      }, _this.handleFocus = function (event) {
        var _this$props2 = _this.props,
            name = _this$props2.name,
            dispatch = _this$props2.dispatch,
            onFocus = _this$props2.onFocus,
            _reduxForm = _this$props2._reduxForm;


        var defaultPrevented = false;
        if (onFocus) {
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onFocus(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), name);
          } else {
            onFocus(event, name);
          }
        }

        if (!defaultPrevented) {
          dispatch(_reduxForm.focus(name));
        }
      }, _this.handleBlur = function (event) {
        var _this$props3 = _this.props,
            name = _this$props3.name,
            dispatch = _this$props3.dispatch,
            parse = _this$props3.parse,
            normalize = _this$props3.normalize,
            onBlur = _this$props3.onBlur,
            _reduxForm = _this$props3._reduxForm,
            _value = _this$props3._value,
            previousValue = _this$props3.value;

        var newValue = Object(__WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse, normalize: normalize });

        // for checkbox and radio, if the value property of checkbox or radio equals
        // the value passed by blur event, then fire blur action with previousValue.
        if (newValue === _value && _value !== undefined) {
          newValue = previousValue;
        }

        var defaultPrevented = false;
        if (onBlur) {
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onBlur(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue, name);
          } else {
            onBlur(event, newValue, previousValue, name);
          }
        }

        if (!defaultPrevented) {
          // dispatch blur action
          dispatch(_reduxForm.blur(name, newValue));

          // call post-blur callback
          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue, 'blur');
          }
        }
      }, _this.handleDragStart = function (event) {
        var _this$props4 = _this.props,
            name = _this$props4.name,
            onDragStart = _this$props4.onDragStart,
            value = _this$props4.value;

        eventDataTransferSetData(event, __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__["a" /* dataKey */], value == null ? '' : value);

        if (onDragStart) {
          onDragStart(event, name);
        }
      }, _this.handleDrop = function (event) {
        var _this$props5 = _this.props,
            name = _this$props5.name,
            dispatch = _this$props5.dispatch,
            onDrop = _this$props5.onDrop,
            _reduxForm = _this$props5._reduxForm,
            previousValue = _this$props5.value;

        var newValue = eventDataTransferGetData(event, __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__["a" /* dataKey */]);

        var defaultPrevented = false;
        if (onDrop) {
          onDrop(_extends({}, event, {
            preventDefault: function preventDefault() {
              defaultPrevented = true;
              return eventPreventDefault(event);
            }
          }), newValue, previousValue, name);
        }

        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));
          eventPreventDefault(event);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ConnectedField, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          if (~(nextProps.immutableProps || []).indexOf(prop)) {
            return _this2.props[prop] !== nextProps[prop];
          }
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            name = _props.name,
            _reduxForm = _props._reduxForm,
            normalize = _props.normalize,
            onBlur = _props.onBlur,
            onChange = _props.onChange,
            onFocus = _props.onFocus,
            onDragStart = _props.onDragStart,
            onDrop = _props.onDrop,
            immutableProps = _props.immutableProps,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'normalize', 'onBlur', 'onChange', 'onFocus', 'onDragStart', 'onDrop', 'immutableProps']);

        var _createFieldProps = Object(__WEBPACK_IMPORTED_MODULE_3__createFieldProps__["a" /* default */])(structure, name, _extends({}, rest, {
          form: _reduxForm.form,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onDrop: this.handleDrop,
          onDragStart: this.handleDragStart,
          onFocus: this.handleFocus
        })),
            custom = _createFieldProps.custom,
            props = _objectWithoutProperties(_createFieldProps, ['custom']);

        if (withRef) {
          custom.ref = this.saveRef;
        }
        if (typeof component === 'string') {
          var input = props.input,
              meta = props.meta; // eslint-disable-line no-unused-vars
          // flatten input into other props

          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, input, custom));
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, props, custom));
        }
      }
    }]);

    return ConnectedField;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ConnectedField.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initialState = getIn(formState, 'initial.' + name);
    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name),
      asyncValidating: getIn(formState, 'asyncValidating') === name,
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      initial: initial,
      value: value,
      _value: ownProps.value // save value passed in (for checkboxes)
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedField);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedField);

/***/ }),
/* 3207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isEvent__ = __webpack_require__(1295);



var getSelectedValues = function getSelectedValues(options) {
  var result = [];
  if (options) {
    for (var index = 0; index < options.length; index++) {
      var option = options[index];
      if (option.selected) {
        result.push(option.value);
      }
    }
  }
  return result;
};

var getValue = function getValue(event, isReactNative) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isEvent__["a" /* default */])(event)) {
    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
      return event.nativeEvent.text;
    }
    if (isReactNative && event.nativeEvent !== undefined) {
      return event.nativeEvent.text;
    }
    var detypedEvent = event;
    var _detypedEvent$target = detypedEvent.target,
        type = _detypedEvent$target.type,
        value = _detypedEvent$target.value,
        checked = _detypedEvent$target.checked,
        files = _detypedEvent$target.files,
        dataTransfer = detypedEvent.dataTransfer;

    if (type === 'checkbox') {
      return !!checked;
    }
    if (type === 'file') {
      return files || dataTransfer && dataTransfer.files;
    }
    if (type === 'select-multiple') {
      return getSelectedValues(event.target.options);
    }
    return value;
  }
  return event;
};

/* harmony default export */ __webpack_exports__["a"] = (getValue);

/***/ }),
/* 3208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataKey; });
var dataKey = 'text';

/***/ }),
/* 3209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var splice = function splice(array, index, removeNum, value) {
  array = array || [];

  if (index < array.length) {
    if (value === undefined && !removeNum) {
      // inserting undefined
      var _copy2 = [].concat(_toConsumableArray(array));
      _copy2.splice(index, 0, true); // temporary placeholder
      _copy2[index] = undefined; // set to undefined
      return _copy2;
    }
    if (value != null) {
      var _copy3 = [].concat(_toConsumableArray(array));
      _copy3.splice(index, removeNum, value); // removing and adding
      return _copy3;
    }
    var _copy = [].concat(_toConsumableArray(array));
    _copy.splice(index, removeNum); // removing
    return _copy;
  }
  if (removeNum) {
    // trying to remove non-existant item: return original array
    return array;
  }
  // trying to add outside of range: just set value
  var copy = [].concat(_toConsumableArray(array));
  copy[index] = value;
  return copy;
};

/* harmony default export */ __webpack_exports__["a"] = (splice);

/***/ }),
/* 3210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(311);



var getIn = function getIn(state, field) {
  if (!state) {
    return state;
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field);
  var length = path.length;
  if (!length) {
    return undefined;
  }

  var result = state;
  for (var i = 0; i < length && result; ++i) {
    result = result[path[i]];
  }

  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (getIn);

/***/ }),
/* 3211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoize_js__ = __webpack_require__(3212);


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__memoize_js__["a" /* default */])(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeCapped);


/***/ }),
/* 3212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(508);


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */]);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 3213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hash_js__ = __webpack_require__(3214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListCache_js__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Map_js__ = __webpack_require__(510);




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */],
    'map': new (__WEBPACK_IMPORTED_MODULE_2__Map_js__["a" /* default */] || __WEBPACK_IMPORTED_MODULE_1__ListCache_js__["a" /* default */]),
    'string': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheClear);


/***/ }),
/* 3214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hashClear_js__ = __webpack_require__(3215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__ = __webpack_require__(3220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hashGet_js__ = __webpack_require__(3221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hashHas_js__ = __webpack_require__(3222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hashSet_js__ = __webpack_require__(3223);






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__hashClear_js__["a" /* default */];
Hash.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__["a" /* default */];
Hash.prototype.get = __WEBPACK_IMPORTED_MODULE_2__hashGet_js__["a" /* default */];
Hash.prototype.has = __WEBPACK_IMPORTED_MODULE_3__hashHas_js__["a" /* default */];
Hash.prototype.set = __WEBPACK_IMPORTED_MODULE_4__hashSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Hash);


/***/ }),
/* 3215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(313);


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? Object(__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */])(null) : {};
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (hashClear);


/***/ }),
/* 3216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMasked_js__ = __webpack_require__(3217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toSource_js__ = __webpack_require__(1300);





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_1__isMasked_js__["a" /* default */])(value)) {
    return false;
  }
  var pattern = Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value) ? reIsNative : reIsHostCtor;
  return pattern.test(Object(__WEBPACK_IMPORTED_MODULE_3__toSource_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNative);


/***/ }),
/* 3217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__ = __webpack_require__(3218);


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(__WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ __webpack_exports__["a"] = (isMasked);


/***/ }),
/* 3218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(96);


/** Used to detect overreaching core-js shims. */
var coreJsData = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */]['__core-js_shared__'];

/* harmony default export */ __webpack_exports__["a"] = (coreJsData);


/***/ }),
/* 3219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (getValue);


/***/ }),
/* 3220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (hashDelete);


/***/ }),
/* 3221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(313);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */]) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (hashGet);


/***/ }),
/* 3222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(313);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/* harmony default export */ __webpack_exports__["a"] = (hashHas);


/***/ }),
/* 3223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(313);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (hashSet);


/***/ }),
/* 3224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheClear);


/***/ }),
/* 3225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(315);


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheDelete);


/***/ }),
/* 3226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(315);


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheGet);


/***/ }),
/* 3227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(315);


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(this.__data__, key) > -1;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheHas);


/***/ }),
/* 3228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(315);


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheSet);


/***/ }),
/* 3229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(316);


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheDelete);


/***/ }),
/* 3230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ __webpack_exports__["a"] = (isKeyable);


/***/ }),
/* 3231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(316);


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheGet);


/***/ }),
/* 3232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(316);


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheHas);


/***/ }),
/* 3233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(316);


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheSet);


/***/ }),
/* 3234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(312);





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return Object(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(value, baseToString) + '';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseToString);


/***/ }),
/* 3235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(311);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
  if (pathIndex >= path.length) {
    return value;
  }

  var first = path[pathIndex];
  var firstState = state && (Array.isArray(state) ? state[Number(first)] : state[first]);
  var next = setInWithPath(firstState, value, path, pathIndex + 1);

  if (!state) {
    if (isNaN(first)) {
      return _defineProperty({}, first, next);
    }
    var initialized = [];
    initialized[parseInt(first, 10)] = next;
    return initialized;
  }

  if (Array.isArray(state)) {
    var copy = [].concat(state);
    copy[parseInt(first, 10)] = next;
    return copy;
  }

  return _extends({}, state, _defineProperty({}, first, next));
};

var setIn = function setIn(state, field, value) {
  return setInWithPath(state, value, Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field), 0);
};

/* harmony default export */ __webpack_exports__["a"] = (setIn);

/***/ }),
/* 3236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);




var customizer = function customizer(obj, other) {
  if (obj === other) return true;

  if (!obj && !other) {
    var objIsEmpty = obj === null || obj === undefined || obj === '';
    var otherIsEmpty = other === null || other === undefined || other === '';
    return objIsEmpty === otherIsEmpty;
  }

  if (obj && other && obj._error !== other._error) return false;
  if (obj && other && obj._warning !== other._warning) return false;
  if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(obj) || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(other)) return false;
};

var deepEqual = function deepEqual(a, b) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(a, b, customizer);
};

/* harmony default export */ __webpack_exports__["a"] = (deepEqual);

/***/ }),
/* 3237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equalArrays_js__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equalByTag_js__ = __webpack_require__(3248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalObjects_js__ = __webpack_require__(3251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getTag_js__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArray_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isBuffer_js__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(320);









/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(object),
      othIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(other),
      objTag = objIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(object),
      othTag = othIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(object)) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
    return (objIsArr || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(object))
      ? Object(__WEBPACK_IMPORTED_MODULE_1__equalArrays_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack)
      : Object(__WEBPACK_IMPORTED_MODULE_2__equalByTag_js__["a" /* default */])(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
  return Object(__WEBPACK_IMPORTED_MODULE_3__equalObjects_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqualDeep);


/***/ }),
/* 3238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(314);


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (stackClear);


/***/ }),
/* 3239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (stackDelete);


/***/ }),
/* 3240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackGet);


/***/ }),
/* 3241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackHas);


/***/ }),
/* 3242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MapCache_js__ = __webpack_require__(508);




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */]) {
    var pairs = data.__data__;
    if (!__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_2__MapCache_js__["a" /* default */](pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (stackSet);


/***/ }),
/* 3243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__ = __webpack_require__(3244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__ = __webpack_require__(3245);




/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__["a" /* default */];
SetCache.prototype.has = __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (SetCache);


/***/ }),
/* 3244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheAdd);


/***/ }),
/* 3245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheHas);


/***/ }),
/* 3246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (arraySome);


/***/ }),
/* 3247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (cacheHas);


/***/ }),
/* 3248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eq_js__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalArrays_js__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__ = __webpack_require__(3249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__setToArray_js__ = __webpack_require__(3250);







/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](object), new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return Object(__WEBPACK_IMPORTED_MODULE_2__eq_js__["a" /* default */])(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__["a" /* default */];

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = __WEBPACK_IMPORTED_MODULE_5__setToArray_js__["a" /* default */]);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = Object(__WEBPACK_IMPORTED_MODULE_3__equalArrays_js__["a" /* default */])(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (equalByTag);


/***/ }),
/* 3249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapToArray);


/***/ }),
/* 3250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (setToArray);


/***/ }),
/* 3251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__ = __webpack_require__(3252);


/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(object),
      objLength = objProps.length,
      othProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalObjects);


/***/ }),
/* 3252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__(3253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__ = __webpack_require__(3255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(512);




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeys);


/***/ }),
/* 3253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(3254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(94);



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(object) ? result : Object(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, symbolsFunc(object));
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetAllKeys);


/***/ }),
/* 3254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayPush);


/***/ }),
/* 3255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__(3256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubArray_js__ = __webpack_require__(3257);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? __WEBPACK_IMPORTED_MODULE_1__stubArray_js__["a" /* default */] : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */])(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (getSymbols);


/***/ }),
/* 3256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayFilter);


/***/ }),
/* 3257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (stubArray);


/***/ }),
/* 3258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseTimes);


/***/ }),
/* 3259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(126);



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == argsTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsArguments);


/***/ }),
/* 3260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),
/* 3261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(126);




/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) &&
    Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !!typedArrayTags[Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value)];
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsTypedArray);


/***/ }),
/* 3262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnary);


/***/ }),
/* 3263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(566);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(149)(module)))

/***/ }),
/* 3264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(568);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.keys, Object);

/* harmony default export */ __webpack_exports__["a"] = (nativeKeys);


/***/ }),
/* 3265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(96);



/* Built-in method references that are verified to be native. */
var DataView = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'DataView');

/* harmony default export */ __webpack_exports__["a"] = (DataView);


/***/ }),
/* 3266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(96);



/* Built-in method references that are verified to be native. */
var Promise = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Promise');

/* harmony default export */ __webpack_exports__["a"] = (Promise);


/***/ }),
/* 3267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(96);



/* Built-in method references that are verified to be native. */
var Set = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Set');

/* harmony default export */ __webpack_exports__["a"] = (Set);


/***/ }),
/* 3268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(96);



/* Built-in method references that are verified to be native. */
var WeakMap = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'WeakMap');

/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),
/* 3269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(311);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function deleteInWithPath(state, first) {
  if (state === undefined || state === null || first === undefined || first === null) {
    return state;
  }

  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  if (rest.length) {
    if (Array.isArray(state)) {
      if (isNaN(first)) {
        throw new Error('Must access array elements with a number, not "' + String(first) + '".');
      }
      var firstIndex = Number(first);
      if (firstIndex < state.length) {
        var result = deleteInWithPath.apply(undefined, [state && state[firstIndex]].concat(_toConsumableArray(rest)));
        if (result !== state[firstIndex]) {
          var copy = [].concat(_toConsumableArray(state));
          copy[firstIndex] = result;
          return copy;
        }
      }
      return state;
    }
    if (first in state) {
      var _result = deleteInWithPath.apply(undefined, [state && state[first]].concat(_toConsumableArray(rest)));
      return state[first] === _result ? state : _extends({}, state, _defineProperty({}, first, _result));
    }
    return state;
  }
  if (Array.isArray(state)) {
    if (isNaN(first)) {
      throw new Error('Cannot delete non-numerical index from an array. Given: "' + String(first));
    }
    var _firstIndex = Number(first);
    if (_firstIndex < state.length) {
      var _copy = [].concat(_toConsumableArray(state));
      _copy.splice(_firstIndex, 1);
      return _copy;
    }
    return state;
  }
  if (first in state) {
    var _copy2 = _extends({}, state);
    delete _copy2[first];
    return _copy2;
  }
  return state;
}

var deleteIn = function deleteIn(state, field) {
  return deleteInWithPath.apply(undefined, [state].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field))));
};

/* harmony default export */ __webpack_exports__["a"] = (deleteIn);

/***/ }),
/* 3270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


function keys(value) {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.map(function (i) {
      return i.name;
    });
  }

  return Object.keys(value);
}


/* harmony default export */ __webpack_exports__["a"] = (keys);

/***/ }),
/* 3271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFields__ = __webpack_require__(3272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createFields__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedFields__ = __webpack_require__(3273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_prefixName__ = __webpack_require__(238);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var validateNameProp = function validateNameProp(prop) {
  if (!prop) {
    return new Error('No "names" prop was specified <Fields/>');
  }
  if (!Array.isArray(prop) && !prop._isFieldArray) {
    return new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.');
  }
};

var createFields = function createFields(structure) {
  var ConnectedFields = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedFields__["a" /* default */])(structure);

  var Fields = function (_Component) {
    _inherits(Fields, _Component);

    function Fields(props, context) {
      _classCallCheck(this, Fields);

      var _this = _possibleConstructorReturn(this, (Fields.__proto__ || Object.getPrototypeOf(Fields)).call(this, props, context));

      if (!context._reduxForm) {
        throw new Error('Fields must be inside a component decorated with reduxForm()');
      }
      var error = validateNameProp(props.names);
      if (error) {
        throw error;
      }
      return _this;
    }

    _createClass(Fields, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__["a" /* default */])(this, nextProps);
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var context = this.context;
        var register = context._reduxForm.register;

        this.names.forEach(function (name) {
          return register(name, 'Field');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (!__WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].deepEqual(this.props.names, nextProps.names)) {
          var context = this.context;
          var _context$_reduxForm = context._reduxForm,
              register = _context$_reduxForm.register,
              unregister = _context$_reduxForm.unregister;
          // unregister old name

          this.props.names.forEach(function (name) {
            return unregister(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name));
          });
          // register new name
          nextProps.names.forEach(function (name) {
            return register(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name), 'Field');
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var context = this.context;
        var unregister = context._reduxForm.unregister;

        this.props.names.forEach(function (name) {
          return unregister(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name));
        });
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Fields');
        return this.refs.connected.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        var context = this.context;

        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedFields, _extends({}, this.props, {
          names: this.props.names.map(function (name) {
            return Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name);
          }),
          _reduxForm: this.context._reduxForm,
          ref: 'connected'
        }));
      }
    }, {
      key: 'names',
      get: function get() {
        var context = this.context;

        return this.props.names.map(function (name) {
          return Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name);
        });
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.refs.connected.getWrappedInstance().isDirty();
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !this.dirty;
      }
    }, {
      key: 'values',
      get: function get() {
        return this.refs.connected && this.refs.connected.getWrappedInstance().getValues();
      }
    }]);

    return Fields;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Fields.propTypes = {
    names: function names(props, propName) {
      return validateNameProp(props[propName]);
    },
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    format: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    parse: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };
  Fields.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(Fields);
  return Fields;
};

/* harmony default export */ __webpack_exports__["a"] = (createFields);

/***/ }),
/* 3273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createFieldProps__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__structure_plain__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__ = __webpack_require__(1294);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var propsToNotUpdateFor = ['_reduxForm'];

var createConnectedFields = function createConnectedFields(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn,
      size = structure.size;


  var getSyncError = function getSyncError(syncErrors, name) {
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].getIn(syncErrors, name + '._error') || __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].getIn(syncErrors, name);
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name);
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedFields = function (_React$Component) {
    _inherits(ConnectedFields, _React$Component);

    function ConnectedFields(props) {
      _classCallCheck(this, ConnectedFields);

      var _this = _possibleConstructorReturn(this, (ConnectedFields.__proto__ || Object.getPrototypeOf(ConnectedFields)).call(this, props));

      _this.onChangeFns = {};
      _this.onFocusFns = {};
      _this.onBlurFns = {};

      _this.prepareEventHandlers = function (_ref) {
        var names = _ref.names;
        return names.forEach(function (name) {
          _this.onChangeFns[name] = function (event) {
            return _this.handleChange(name, event);
          };
          _this.onFocusFns[name] = function () {
            return _this.handleFocus(name);
          };
          _this.onBlurFns[name] = function (event) {
            return _this.handleBlur(name, event);
          };
        });
      };

      _this.handleChange = function (name, event) {
        var _this$props = _this.props,
            dispatch = _this$props.dispatch,
            parse = _this$props.parse,
            _reduxForm = _this$props._reduxForm;

        var value = Object(__WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse });

        dispatch(_reduxForm.change(name, value));

        // call post-change callback
        if (_reduxForm.asyncValidate) {
          _reduxForm.asyncValidate(name, value, 'change');
        }
      };

      _this.handleFocus = function (name) {
        var _this$props2 = _this.props,
            dispatch = _this$props2.dispatch,
            _reduxForm = _this$props2._reduxForm;

        dispatch(_reduxForm.focus(name));
      };

      _this.handleBlur = function (name, event) {
        var _this$props3 = _this.props,
            dispatch = _this$props3.dispatch,
            parse = _this$props3.parse,
            _reduxForm = _this$props3._reduxForm;

        var value = Object(__WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse });

        // dispatch blur action
        dispatch(_reduxForm.blur(name, value));

        // call post-blur callback
        if (_reduxForm.asyncValidate) {
          _reduxForm.asyncValidate(name, value, 'blur');
        }
      };

      _this.saveRef = function (ref) {
        _this.ref = ref;
      };

      _this.prepareEventHandlers(props);
      return _this;
    }

    _createClass(ConnectedFields, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        if (this.props.names !== nextProps.names && (size(this.props.names) !== size(nextProps.names) || nextProps.names.some(function (nextName) {
          return !_this2.props._fields[nextName];
        }))) {
          // names has changed. The cached event handlers need to be updated
          this.prepareEventHandlers(nextProps);
        }
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this3 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'isDirty',
      value: function isDirty() {
        var _fields = this.props._fields;

        return Object.keys(_fields).some(function (name) {
          return _fields[name].dirty;
        });
      }
    }, {
      key: 'getValues',
      value: function getValues() {
        var _fields = this.props._fields;

        return Object.keys(_fields).reduce(function (accumulator, name) {
          return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].setIn(accumulator, name, _fields[name].value);
        }, {});
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;

        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            _fields = _props._fields,
            _reduxForm = _props._reduxForm,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', '_fields', '_reduxForm']);

        var sectionPrefix = _reduxForm.sectionPrefix,
            form = _reduxForm.form;

        var _Object$keys$reduce = Object.keys(_fields).reduce(function (accumulator, name) {
          var connectedProps = _fields[name];

          var _createFieldProps = Object(__WEBPACK_IMPORTED_MODULE_3__createFieldProps__["a" /* default */])(structure, name, _extends({}, connectedProps, rest, {
            form: form,
            onBlur: _this4.onBlurFns[name],
            onChange: _this4.onChangeFns[name],
            onFocus: _this4.onFocusFns[name]
          })),
              custom = _createFieldProps.custom,
              fieldProps = _objectWithoutProperties(_createFieldProps, ['custom']);

          accumulator.custom = custom;
          var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
          return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].setIn(accumulator, fieldName, fieldProps);
        }, {}),
            custom = _Object$keys$reduce.custom,
            props = _objectWithoutProperties(_Object$keys$reduce, ['custom']);

        if (withRef) {
          props.ref = this.saveRef;
        }

        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](component, _extends({}, props, custom));
      }
    }]);

    return ConnectedFields;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ConnectedFields.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired,
    _fields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    var names = ownProps.names,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    return {
      _fields: names.reduce(function (accumulator, name) {
        var initialState = getIn(formState, 'initial.' + name);
        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
        var value = getIn(formState, 'values.' + name);
        var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
        var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
        var submitting = getIn(formState, 'submitting');
        var pristine = value === initial;
        accumulator[name] = {
          asyncError: getIn(formState, 'asyncErrors.' + name),
          asyncValidating: getIn(formState, 'asyncValidating') === name,
          dirty: !pristine,
          initial: initial,
          pristine: pristine,
          state: getIn(formState, 'fields.' + name),
          submitError: getIn(formState, 'submitErrors.' + name),
          submitFailed: getIn(formState, 'submitFailed'),
          submitting: submitting,
          syncError: syncError,
          syncWarning: syncWarning,
          value: value,
          _value: ownProps.value // save value passed in (for checkboxes)
        };
        return accumulator;
      }, {})
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedFields);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedFields);

/***/ }),
/* 3274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFieldArray__ = __webpack_require__(3275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createFieldArray__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedFieldArray__ = __webpack_require__(3276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_prefixName__ = __webpack_require__(238);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var wrapError = function wrapError(fn, key) {
  return fn && function () {
    var validators = toArray(fn);
    for (var i = 0; i < validators.length; i++) {
      var result = validators[i].apply(validators, arguments);
      if (result) {
        return _defineProperty({}, key, result);
      }
    }
  };
};

var createFieldArray = function createFieldArray(structure) {
  var ConnectedFieldArray = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedFieldArray__["a" /* default */])(structure);

  var FieldArray = function (_Component) {
    _inherits(FieldArray, _Component);

    function FieldArray(props, context) {
      _classCallCheck(this, FieldArray);

      var _this = _possibleConstructorReturn(this, (FieldArray.__proto__ || Object.getPrototypeOf(FieldArray)).call(this, props, context));

      _this.saveRef = function (ref) {
        _this.ref = ref;
      };

      if (!context._reduxForm) {
        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(FieldArray, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'FieldArray', function () {
          return wrapError(_this2.props.validate, '_error');
        }, function () {
          return wrapError(_this2.props.warn, '_warning');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var oldName = Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(this.context, this.props.name);
        var newName = Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(nextContext, nextProps.name);

        if (oldName !== newName) {
          // unregister old name
          this.context._reduxForm.unregister(oldName);
          // register new name
          this.context._reduxForm.register(newName, 'FieldArray');
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to FieldArray');
        return this.ref && this.ref.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedFieldArray, _extends({}, this.props, {
          name: this.name,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return !this.ref || this.ref.getWrappedInstance().dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !!(this.ref && this.ref.getWrappedInstance().pristine);
      }
    }, {
      key: 'value',
      get: function get() {
        return this.ref ? this.ref.getWrappedInstance().value : undefined;
      }
    }]);

    return FieldArray;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  FieldArray.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    validate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    warn: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };
  FieldArray.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(FieldArray);
  return FieldArray;
};

/* harmony default export */ __webpack_exports__["a"] = (createFieldArray);

/***/ }),
/* 3276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__createFieldArrayProps__ = __webpack_require__(3291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(26);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var propsToNotUpdateFor = ['_reduxForm', 'value'];

var createConnectedFieldArray = function createConnectedFieldArray(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn,
      size = structure.size;

  var getSyncError = function getSyncError(syncErrors, name) {
    // For an array, the error can _ONLY_ be under _error.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return __WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].getIn(syncErrors, name + '._error');
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    // For an array, the warning can _ONLY_ be under _warning.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return getIn(syncWarnings, name + '._warning');
  };

  var ConnectedFieldArray = function (_React$Component) {
    _inherits(ConnectedFieldArray, _React$Component);

    function ConnectedFieldArray() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ConnectedFieldArray);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedFieldArray.__proto__ || Object.getPrototypeOf(ConnectedFieldArray)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
        _this.ref = ref;
      }, _this.getValue = function (index) {
        return _this.props.value && getIn(_this.props.value, String(index));
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ConnectedFieldArray, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        // Update if the elements of the value array was updated.
        var thisValue = this.props.value;
        var nextValue = nextProps.value;

        if (thisValue && nextValue) {
          var nextValueItemsSame = nextValue.every(function (val) {
            return ~thisValue.indexOf(val);
          });
          var nextValueItemsOrderChanged = nextValue.some(function (val, index) {
            return val !== thisValue[index];
          });
          if (thisValue.length !== nextValue.length || nextValueItemsSame && nextValueItemsOrderChanged || nextProps.rerenderOnEveryChange && thisValue.some(function (val, index) {
            return !deepEqual(val, nextValue[index]);
          })) {
            return true;
          }
        }

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          // useful to debug rerenders
          // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
          //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
          // }
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            name = _props.name,
            _reduxForm = _props._reduxForm,
            validate = _props.validate,
            warn = _props.warn,
            rerenderOnEveryChange = _props.rerenderOnEveryChange,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'validate', 'warn', 'rerenderOnEveryChange']);

        var props = Object(__WEBPACK_IMPORTED_MODULE_5__createFieldArrayProps__["a" /* default */])(structure, name, _reduxForm.form, _reduxForm.sectionPrefix, this.getValue, rest);
        if (withRef) {
          props.ref = this.saveRef;
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](component, props);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.props.dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return this.props.pristine;
      }
    }, {
      key: 'value',
      get: function get() {
        return this.props.value;
      }
    }]);

    return ConnectedFieldArray;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  ConnectedFieldArray.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    rerenderOnEveryChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };

  ConnectedFieldArray.defaultProps = {
    rerenderOnEveryChange: false
  };

  ConnectedFieldArray.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initial = getIn(formState, 'initial.' + name) || initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name + '._error'),
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name + '._error'),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      value: value,
      length: size(value)
    };
  }, function (dispatch, ownProps) {
    var name = ownProps.name,
        _reduxForm = ownProps._reduxForm;
    var arrayInsert = _reduxForm.arrayInsert,
        arrayMove = _reduxForm.arrayMove,
        arrayPop = _reduxForm.arrayPop,
        arrayPush = _reduxForm.arrayPush,
        arrayRemove = _reduxForm.arrayRemove,
        arrayRemoveAll = _reduxForm.arrayRemoveAll,
        arrayShift = _reduxForm.arrayShift,
        arraySplice = _reduxForm.arraySplice,
        arraySwap = _reduxForm.arraySwap,
        arrayUnshift = _reduxForm.arrayUnshift;

    return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__["a" /* default */])({
      arrayInsert: arrayInsert,
      arrayMove: arrayMove,
      arrayPop: arrayPop,
      arrayPush: arrayPush,
      arrayRemove: arrayRemove,
      arrayRemoveAll: arrayRemoveAll,
      arrayShift: arrayShift,
      arraySplice: arraySplice,
      arraySwap: arraySwap,
      arrayUnshift: arrayUnshift
    }, function (actionCreator) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["bindActionCreators"])(actionCreator.bind(null, name), dispatch);
    });
  }, undefined, { withRef: true });
  return connector(ConnectedFieldArray);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedFieldArray);

/***/ }),
/* 3277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFor_js__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(512);



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && Object(__WEBPACK_IMPORTED_MODULE_0__baseFor_js__["a" /* default */])(object, iteratee, __WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseForOwn);


/***/ }),
/* 3278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createBaseFor);


/***/ }),
/* 3279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMatches_js__ = __webpack_require__(3280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__ = __webpack_require__(3283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__property_js__ = __webpack_require__(3288);






/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */];
  }
  if (typeof value == 'object') {
    return Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value)
      ? Object(__WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__["a" /* default */])(value[0], value[1])
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseMatches_js__["a" /* default */])(value);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_4__property_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIteratee);


/***/ }),
/* 3280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__ = __webpack_require__(3281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getMatchData_js__ = __webpack_require__(3282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__ = __webpack_require__(1312);




/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = Object(__WEBPACK_IMPORTED_MODULE_1__getMatchData_js__["a" /* default */])(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__["a" /* default */])(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || Object(__WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__["a" /* default */])(object, source, matchData);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatches);


/***/ }),
/* 3281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__ = __webpack_require__(317);



/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */];
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? Object(__WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsMatch);


/***/ }),
/* 3282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(512);



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, Object(__WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__["a" /* default */])(value)];
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getMatchData);


/***/ }),
/* 3283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_js__ = __webpack_require__(3284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hasIn_js__ = __webpack_require__(3285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isKey_js__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toKey_js__ = __webpack_require__(240);








/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isKey_js__["a" /* default */])(path) && Object(__WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__["a" /* default */])(srcValue)) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toKey_js__["a" /* default */])(path), srcValue);
  }
  return function(object) {
    var objValue = Object(__WEBPACK_IMPORTED_MODULE_1__get_js__["a" /* default */])(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? Object(__WEBPACK_IMPORTED_MODULE_2__hasIn_js__["a" /* default */])(object, path)
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatchesProperty);


/***/ }),
/* 3284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(1313);


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  return result === undefined ? defaultValue : result;
}

/* harmony default export */ __webpack_exports__["a"] = (get);


/***/ }),
/* 3285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__ = __webpack_require__(3286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasPath_js__ = __webpack_require__(3287);



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && Object(__WEBPACK_IMPORTED_MODULE_1__hasPath_js__["a" /* default */])(object, path, __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (hasIn);


/***/ }),
/* 3286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseHasIn);


/***/ }),
/* 3287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isIndex_js__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isLength_js__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(240);







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = Object(__WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */])(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && Object(__WEBPACK_IMPORTED_MODULE_4__isLength_js__["a" /* default */])(length) && Object(__WEBPACK_IMPORTED_MODULE_3__isIndex_js__["a" /* default */])(key, length) &&
    (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(object) || Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (hasPath);


/***/ }),
/* 3288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseProperty_js__ = __webpack_require__(3289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__ = __webpack_require__(3290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isKey_js__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toKey_js__ = __webpack_require__(240);





/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isKey_js__["a" /* default */])(path) ? Object(__WEBPACK_IMPORTED_MODULE_0__baseProperty_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toKey_js__["a" /* default */])(path)) : Object(__WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__["a" /* default */])(path);
}

/* harmony default export */ __webpack_exports__["a"] = (property);


/***/ }),
/* 3289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseProperty);


/***/ }),
/* 3290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(1313);


/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (basePropertyDeep);


/***/ }),
/* 3291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var createFieldArrayProps = function createFieldArrayProps(_ref2, name, form, sectionPrefix, getValue, _ref) {
  var getIn = _ref2.getIn;

  var arrayInsert = _ref.arrayInsert,
      arrayMove = _ref.arrayMove,
      arrayPop = _ref.arrayPop,
      arrayPush = _ref.arrayPush,
      arrayRemove = _ref.arrayRemove,
      arrayRemoveAll = _ref.arrayRemoveAll,
      arrayShift = _ref.arrayShift,
      arraySplice = _ref.arraySplice,
      arraySwap = _ref.arraySwap,
      arrayUnshift = _ref.arrayUnshift,
      asyncError = _ref.asyncError,
      dirty = _ref.dirty,
      length = _ref.length,
      pristine = _ref.pristine,
      submitError = _ref.submitError,
      state = _ref.state,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      value = _ref.value,
      props = _ref.props,
      rest = _objectWithoutProperties(_ref, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncError', 'dirty', 'length', 'pristine', 'submitError', 'state', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'value', 'props']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;
  var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
  var finalProps = _extends({
    fields: {
      _isFieldArray: true,
      forEach: function forEach(callback) {
        return (value || []).forEach(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      get: getValue,
      getAll: function getAll() {
        return value;
      },
      insert: arrayInsert,
      length: length,
      map: function map(callback) {
        return (value || []).map(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      move: arrayMove,
      name: name,
      pop: function pop() {
        arrayPop();
        return getIn(value, String(length - 1));
      },
      push: arrayPush,
      reduce: function reduce(callback, initial) {
        return (value || []).reduce(function (accumulator, item, index) {
          return callback(accumulator, fieldName + '[' + index + ']', index, finalProps.fields);
        }, initial);
      },
      remove: arrayRemove,
      removeAll: arrayRemoveAll,
      shift: function shift() {
        arrayShift();
        return getIn(value, '0');
      },
      splice: arraySplice,
      swap: arraySwap,
      unshift: arrayUnshift
    },
    meta: {
      dirty: dirty,
      error: error,
      form: form,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: submitting,
      submitFailed: submitFailed,
      valid: !error
    }
  }, props, rest);
  return finalProps;
};


/* harmony default export */ __webpack_exports__["a"] = (createFieldArrayProps);

/***/ }),
/* 3292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFormValueSelector__ = __webpack_require__(3293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createFormValueSelector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);




var createFormValueSelector = function createFormValueSelector(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    __WEBPACK_IMPORTED_MODULE_0_invariant___default()(form, 'Form value must be specified');
    var nonNullGetFormState = getFormState || function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      __WEBPACK_IMPORTED_MODULE_0_invariant___default()(fields.length, 'No fields specified');
      return fields.length === 1 ? // only selecting one field, so return its value
      getIn(nonNullGetFormState(state), form + '.values.' + fields[0]) : // selecting many fields, so return an object of field values
      fields.reduce(function (accumulator, field) {
        var value = getIn(nonNullGetFormState(state), form + '.values.' + field);
        return value === undefined ? accumulator : __WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */].setIn(accumulator, field, value);
      }, {});
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createFormValueSelector);

/***/ }),
/* 3294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFormValues__ = __webpack_require__(3295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createFormValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isEqual__ = __webpack_require__(3296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__ = __webpack_require__(3297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_prefixName__ = __webpack_require__(238);




var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function (firstArg) {
    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    // create a class that reads current form name and creates a selector
    // return
    return function (Component) {
      var FormValues = function (_React$Component) {
        _inherits(FormValues, _React$Component);

        function FormValues(props, context) {
          _classCallCheck(this, FormValues);

          var _this = _possibleConstructorReturn(this, (FormValues.__proto__ || Object.getPrototypeOf(FormValues)).call(this, props, context));

          if (!context._reduxForm) {
            throw new Error('formValues() must be used inside a React tree decorated with reduxForm()');
          }
          _this.updateComponent(props);
          return _this;
        }

        _createClass(FormValues, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(props) {
            if (typeof firstArg === 'function') {
              this.updateComponent(props);
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var Component = this.Component;

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component
            // so that the connected component updates props when sectionPrefix has changed
            , _extends({ sectionPrefix: this.context._reduxForm.sectionPrefix
            }, this.props));
          }
        }, {
          key: 'updateComponent',
          value: function updateComponent(props) {
            var valuesMap = void 0;
            var resolvedFirstArg = typeof firstArg === 'function' ? firstArg(props) : firstArg;
            if (typeof resolvedFirstArg === 'string') {
              valuesMap = rest.reduce(function (result, k) {
                result[k] = k;
                return result;
              }, _defineProperty({}, resolvedFirstArg, resolvedFirstArg));
            } else {
              valuesMap = resolvedFirstArg;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__["a" /* default */])(valuesMap)) {
              // maybe that empty valuesMap is ok if firstArg is a function?
              // if this is the case, we probably should set this.Component = Component
              throw new Error('formValues(): You must specify values to get as formValues(name1, name2, ...) or formValues({propName1: propPath1, ...}) or formValues((props) => name) or formValues((props) => ({propName1: propPath1, ...}))');
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isEqual__["a" /* default */])(valuesMap, this._valuesMap)) {
              // no change in valuesMap
              return;
            }
            this._valuesMap = valuesMap;
            this.setComponent();
          }
        }, {
          key: 'setComponent',
          value: function setComponent() {
            var _this2 = this;

            var formValuesSelector = function formValuesSelector(_, _ref2) {
              var sectionPrefix = _ref2.sectionPrefix;

              // Yes, we're only using connect() for listening to updates.
              // The second argument needs to be there so that connect calls
              // the selector when props change
              var getValues = _this2.context._reduxForm.getValues;

              var values = getValues();
              return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__["a" /* default */])(_this2._valuesMap, function (path) {
                return getIn(values, Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(_this2.context, path));
              });
            };
            this.Component = Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(formValuesSelector, function () {
              return {};
            } // ignore dispatch
            )(function (_ref3) {
              var sectionPrefix = _ref3.sectionPrefix,
                  otherProps = _objectWithoutProperties(_ref3, ['sectionPrefix']);

              return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, otherProps);
            });
          }
        }]);

        return FormValues;
      }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

      FormValues.contextTypes = {
        _reduxForm: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
      };
      return FormValues;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createValues);

/***/ }),
/* 3296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(317);


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(value, other);
}

/* harmony default export */ __webpack_exports__["a"] = (isEqual);


/***/ }),
/* 3297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseKeys_js__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getTag_js__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArguments_js__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isBuffer_js__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isPrototype_js__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(320);









/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__["a" /* default */])(value) &&
      (Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        Object(__WEBPACK_IMPORTED_MODULE_5__isBuffer_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_2__isArguments_js__["a" /* default */])(value))) {
    return !value.length;
  }
  var tag = Object(__WEBPACK_IMPORTED_MODULE_1__getTag_js__["a" /* default */])(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_6__isPrototype_js__["a" /* default */])(value)) {
    return !Object(__WEBPACK_IMPORTED_MODULE_0__baseKeys_js__["a" /* default */])(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (isEmpty);


/***/ }),
/* 3298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormError__ = __webpack_require__(3299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormError__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormError = function createGetFormError(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.error');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormError);

/***/ }),
/* 3300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormNames__ = __webpack_require__(3301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormNames__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createGetFormNames(_ref) {
  var getIn = _ref.getIn,
      keys = _ref.keys;

  return function (getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return keys(nonNullGetFormState(state));
    };
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createGetFormNames);

/***/ }),
/* 3302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormValues__ = __webpack_require__(3303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormValues = function createGetFormValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.values');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormValues);

/***/ }),
/* 3304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormInitialValues__ = __webpack_require__(3305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormInitialValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormInitialValues = function createGetFormInitialValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.initial');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormInitialValues);

/***/ }),
/* 3306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncErrors__ = __webpack_require__(3307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSyncErrors = function createGetFormSyncErrors(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.syncErrors') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSyncErrors);

/***/ }),
/* 3308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormMeta__ = __webpack_require__(3309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormMeta__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormMeta = function createGetFormMeta(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.fields') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormMeta);

/***/ }),
/* 3310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormAsyncErrors__ = __webpack_require__(3311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormAsyncErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormAsyncErrors = function createGetFormAsyncErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.asyncErrors');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormAsyncErrors);

/***/ }),
/* 3312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncWarnings__ = __webpack_require__(3313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncWarnings__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSyncWarnings = function createGetFormSyncWarnings(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.syncWarnings') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSyncWarnings);

/***/ }),
/* 3314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSubmitErrors__ = __webpack_require__(3315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSubmitErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSubmitErrors = function createGetFormSubmitErrors(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.submitErrors') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSubmitErrors);

/***/ }),
/* 3316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isAsyncValidating__ = __webpack_require__(3317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isAsyncValidating__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsAsyncValidating = function createIsAsyncValidating(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.asyncValidating');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsAsyncValidating);

/***/ }),
/* 3318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isDirty__ = __webpack_require__(3319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isDirty__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPristine__ = __webpack_require__(1315);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var createIsDirty = function createIsDirty(structure) {
  return function (form, getFormState) {
    var isPristine = Object(__WEBPACK_IMPORTED_MODULE_0__isPristine__["a" /* default */])(structure)(form, getFormState);
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      return !isPristine.apply(undefined, [state].concat(_toConsumableArray(fields)));
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsDirty);

/***/ }),
/* 3320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isInvalid__ = __webpack_require__(3321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isInvalid__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isValid__ = __webpack_require__(518);



var createIsInvalid = function createIsInvalid(structure) {
  return function (form, getFormState) {
    var isValid = Object(__WEBPACK_IMPORTED_MODULE_0__isValid__["a" /* default */])(structure)(form, getFormState);
    return function (state) {
      return !isValid(state);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsInvalid);

/***/ }),
/* 3322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var getErrorKeys = function getErrorKeys(name, type) {
  switch (type) {
    case 'Field':
      return [name, name + '._error'];
    case 'FieldArray':
      return [name + '._error'];
    default:
      throw new Error('Unknown field type');
  }
};


var createHasError = function createHasError(_ref) {
  var getIn = _ref.getIn;

  var hasError = function hasError(field, syncErrors, asyncErrors, submitErrors) {
    if (!syncErrors && !asyncErrors && !submitErrors) {
      return false;
    }

    var name = getIn(field, 'name');
    var type = getIn(field, 'type');
    return getErrorKeys(name, type).some(function (key) {
      return getIn(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
    });
  };
  return hasError;
};

/* harmony default export */ __webpack_exports__["a"] = (createHasError);

/***/ }),
/* 3323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isPristine__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isPristine__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isValid__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isValid__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isSubmitting__ = __webpack_require__(3326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isSubmitting__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsSubmitting = function createIsSubmitting(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitting');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsSubmitting);

/***/ }),
/* 3327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitSucceeded__ = __webpack_require__(3328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitSucceeded__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createHasSubmitSucceeded = function createHasSubmitSucceeded(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitSucceeded');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createHasSubmitSucceeded);

/***/ }),
/* 3329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitFailed__ = __webpack_require__(3330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitFailed__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createHasSubmitFailed = function createHasSubmitFailed(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitFailed');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createHasSubmitFailed);

/***/ }),
/* 3331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReduxForm__ = __webpack_require__(3332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReduxForm__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__ = __webpack_require__(3333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_is_promise__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_is_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__asyncValidation__ = __webpack_require__(3356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaultShouldAsyncValidate__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__events_silenceEvent__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__events_silenceEvents__ = __webpack_require__(3357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__generateValidator__ = __webpack_require__(3358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__handleSubmit__ = __webpack_require__(3359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__selectors_isValid__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__structure_plain__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_getDisplayName__ = __webpack_require__(3360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__ = __webpack_require__(3361);



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



























var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object');
};

// extract field-specific actions

var arrayInsert = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayInsert,
    arrayMove = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayMove,
    arrayPop = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayPop,
    arrayPush = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayPush,
    arrayRemove = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayRemove,
    arrayRemoveAll = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayRemoveAll,
    arrayShift = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayShift,
    arraySplice = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arraySplice,
    arraySwap = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arraySwap,
    arrayUnshift = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayUnshift,
    blur = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].blur,
    change = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].change,
    focus = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].focus,
    formActions = _objectWithoutProperties(__WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */], ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'blur', 'change', 'focus']);

var arrayActions = {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift
};

var propsToNotUpdateFor = [].concat(_toConsumableArray(Object.keys(__WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */])), ['array', 'asyncErrors', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);

var checkSubmit = function checkSubmit(submit) {
  if (!submit || typeof submit !== 'function') {
    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
  }
  return submit;
};

/**
 * The decorator that is the main API to redux-form
 */
var createReduxForm = function createReduxForm(structure) {
  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      getIn = structure.getIn,
      setIn = structure.setIn,
      keys = structure.keys,
      fromJS = structure.fromJS;

  var isValid = Object(__WEBPACK_IMPORTED_MODULE_20__selectors_isValid__["a" /* default */])(structure);
  return function (initialConfig) {
    var config = _extends({
      touchOnBlur: true,
      touchOnChange: false,
      persistentSubmitErrors: false,
      destroyOnUnmount: true,
      shouldAsyncValidate: __WEBPACK_IMPORTED_MODULE_12__defaultShouldAsyncValidate__["a" /* default */],
      shouldValidate: __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */],
      shouldError: __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__["a" /* default */],
      shouldWarn: __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__["a" /* default */],
      enableReinitialize: false,
      keepDirtyOnReinitialize: false,
      updateUnregisteredFields: false,
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      },
      pure: true,
      forceUnregisterOnUnmount: false
    }, initialConfig);

    return function (WrappedComponent) {
      var Form = function (_Component) {
        _inherits(Form, _Component);

        function Form() {
          var _ref;

          var _temp, _this, _ret;

          _classCallCheck(this, Form);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.destroyed = false, _this.fieldCounts = {}, _this.fieldValidators = {}, _this.lastFieldValidatorKeys = [], _this.fieldWarners = {}, _this.lastFieldWarnerKeys = [], _this.innerOnSubmit = undefined, _this.submitPromise = undefined, _this.getValues = function () {
            return _this.props.values;
          }, _this.isValid = function () {
            return _this.props.valid;
          }, _this.isPristine = function () {
            return _this.props.pristine;
          }, _this.register = function (name, type, getValidator, getWarner) {
            var lastCount = _this.fieldCounts[name];
            var nextCount = (lastCount || 0) + 1;
            _this.fieldCounts[name] = nextCount;
            _this.props.registerField(name, type);
            if (getValidator) {
              _this.fieldValidators[name] = getValidator;
            }
            if (getWarner) {
              _this.fieldWarners[name] = getWarner;
            }
          }, _this.unregister = function (name) {
            var lastCount = _this.fieldCounts[name];
            if (lastCount === 1) delete _this.fieldCounts[name];else if (lastCount != null) _this.fieldCounts[name] = lastCount - 1;

            if (!_this.destroyed) {
              var _this$props = _this.props,
                  _destroyOnUnmount = _this$props.destroyOnUnmount,
                  _forceUnregisterOnUnmount = _this$props.forceUnregisterOnUnmount,
                  _unregisterField = _this$props.unregisterField;

              if (_destroyOnUnmount || _forceUnregisterOnUnmount) {
                _unregisterField(name, _destroyOnUnmount);
                if (!_this.fieldCounts[name]) {
                  delete _this.fieldValidators[name];
                  delete _this.fieldWarners[name];
                  _this.lastFieldValidatorKeys = _this.lastFieldValidatorKeys.filter(function (key) {
                    return key !== name;
                  });
                }
              } else {
                _unregisterField(name, false);
              }
            }
          }, _this.getFieldList = function (options) {
            var registeredFields = _this.props.registeredFields;
            var list = [];
            if (!registeredFields) {
              return list;
            }
            var keySeq = keys(registeredFields);
            if (options && options.excludeFieldArray) {
              keySeq = keySeq.filter(function (name) {
                return getIn(registeredFields, '[\'' + name + '\'].type') !== 'FieldArray';
              });
            }
            return fromJS(keySeq.reduce(function (acc, key) {
              acc.push(key);
              return acc;
            }, list));
          }, _this.getValidators = function () {
            var validators = {};
            Object.keys(_this.fieldValidators).forEach(function (name) {
              var validator = _this.fieldValidators[name]();
              if (validator) {
                validators[name] = validator;
              }
            });
            return validators;
          }, _this.generateValidator = function () {
            var validators = _this.getValidators();
            return Object.keys(validators).length ? Object(__WEBPACK_IMPORTED_MODULE_18__generateValidator__["a" /* default */])(validators, structure) : undefined;
          }, _this.getWarners = function () {
            var warners = {};
            Object.keys(_this.fieldWarners).forEach(function (name) {
              var warner = _this.fieldWarners[name]();
              if (warner) {
                warners[name] = warner;
              }
            });
            return warners;
          }, _this.generateWarner = function () {
            var warners = _this.getWarners();
            return Object.keys(warners).length ? Object(__WEBPACK_IMPORTED_MODULE_18__generateValidator__["a" /* default */])(warners, structure) : undefined;
          }, _this.asyncValidate = function (name, value, trigger) {
            var _this$props2 = _this.props,
                asyncBlurFields = _this$props2.asyncBlurFields,
                asyncChangeFields = _this$props2.asyncChangeFields,
                asyncErrors = _this$props2.asyncErrors,
                asyncValidate = _this$props2.asyncValidate,
                dispatch = _this$props2.dispatch,
                initialized = _this$props2.initialized,
                pristine = _this$props2.pristine,
                shouldAsyncValidate = _this$props2.shouldAsyncValidate,
                startAsyncValidation = _this$props2.startAsyncValidation,
                stopAsyncValidation = _this$props2.stopAsyncValidation,
                syncErrors = _this$props2.syncErrors,
                values = _this$props2.values;

            var submitting = !name;

            var fieldNeedsValidation = function fieldNeedsValidation() {
              var fieldNeedsValidationForBlur = asyncBlurFields && name && ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'));
              var fieldNeedsValidationForChange = asyncChangeFields && name && ~asyncChangeFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'));
              var asyncValidateByDefault = !(asyncBlurFields || asyncChangeFields);

              return submitting || asyncValidateByDefault || (trigger === 'blur' ? fieldNeedsValidationForBlur : fieldNeedsValidationForChange);
            };

            if (asyncValidate) {
              var valuesToValidate = submitting ? values : setIn(values, name, value);
              var syncValidationPasses = submitting || !getIn(syncErrors, name);
              if (fieldNeedsValidation() && shouldAsyncValidate({
                asyncErrors: asyncErrors,
                initialized: initialized,
                trigger: submitting ? 'submit' : trigger,
                blurredField: name,
                pristine: pristine,
                syncValidationPasses: syncValidationPasses
              })) {
                return Object(__WEBPACK_IMPORTED_MODULE_11__asyncValidation__["a" /* default */])(function () {
                  return asyncValidate(valuesToValidate, dispatch, _this.props, name);
                }, startAsyncValidation, stopAsyncValidation, name);
              }
            }
          }, _this.submitCompleted = function (result) {
            delete _this.submitPromise;
            return result;
          }, _this.submitFailed = function (error) {
            delete _this.submitPromise;
            throw error;
          }, _this.listenToSubmit = function (promise) {
            if (!__WEBPACK_IMPORTED_MODULE_6_is_promise___default()(promise)) {
              return promise;
            }
            _this.submitPromise = promise;
            return promise.then(_this.submitCompleted, _this.submitFailed);
          }, _this.submit = function (submitOrEvent) {
            var _this$props3 = _this.props,
                onSubmit = _this$props3.onSubmit,
                blur = _this$props3.blur,
                change = _this$props3.change,
                dispatch = _this$props3.dispatch;


            if (!submitOrEvent || Object(__WEBPACK_IMPORTED_MODULE_16__events_silenceEvent__["a" /* default */])(submitOrEvent)) {
              // submitOrEvent is an event: fire submit if not already submitting
              if (!_this.submitPromise) {
                // avoid recursive stack trace if use Form with onSubmit as handleSubmit
                if (_this.innerOnSubmit && _this.innerOnSubmit !== _this.submit) {
                  // will call "submitOrEvent is the submit function" block below
                  return _this.innerOnSubmit();
                } else {
                  return _this.listenToSubmit(Object(__WEBPACK_IMPORTED_MODULE_19__handleSubmit__["a" /* default */])(checkSubmit(onSubmit), _extends({}, _this.props, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
                }
              }
            } else {
              // submitOrEvent is the submit function: return deferred submit thunk
              return Object(__WEBPACK_IMPORTED_MODULE_17__events_silenceEvents__["a" /* default */])(function () {
                return !_this.submitPromise && _this.listenToSubmit(Object(__WEBPACK_IMPORTED_MODULE_19__handleSubmit__["a" /* default */])(checkSubmit(submitOrEvent), _extends({}, _this.props, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
              });
            }
          }, _this.reset = function () {
            return _this.props.reset();
          }, _this.saveRef = function (ref) {
            _this.wrapped = ref;
          }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(Form, [{
          key: 'getChildContext',
          value: function getChildContext() {
            var _this2 = this;

            return {
              _reduxForm: _extends({}, this.props, {
                getFormState: function getFormState(state) {
                  return getIn(_this2.props.getFormState(state), _this2.props.form);
                },
                asyncValidate: this.asyncValidate,
                getValues: this.getValues,
                sectionPrefix: undefined,
                register: this.register,
                unregister: this.unregister,
                registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
                  return _this2.innerOnSubmit = innerOnSubmit;
                }
              })
            };
          }
        }, {
          key: 'initIfNeeded',
          value: function initIfNeeded(nextProps) {
            var enableReinitialize = this.props.enableReinitialize;

            if (nextProps) {
              if ((enableReinitialize || !nextProps.initialized) && !deepEqual(this.props.initialValues, nextProps.initialValues)) {
                var _keepDirty = nextProps.initialized && this.props.keepDirtyOnReinitialize;
                this.props.initialize(nextProps.initialValues, _keepDirty, {
                  keepValues: nextProps.keepValues,
                  lastInitialValues: this.props.initialValues,
                  updateUnregisteredFields: nextProps.updateUnregisteredFields
                });
              }
            } else if (this.props.initialValues && (!this.props.initialized || enableReinitialize)) {
              this.props.initialize(this.props.initialValues, this.props.keepDirtyOnReinitialize, {
                keepValues: this.props.keepValues,
                updateUnregisteredFields: this.props.updateUnregisteredFields
              });
            }
          }
        }, {
          key: 'updateSyncErrorsIfNeeded',
          value: function updateSyncErrorsIfNeeded(nextSyncErrors, nextError, lastSyncErrors) {
            var _props = this.props,
                error = _props.error,
                updateSyncErrors = _props.updateSyncErrors;

            var noErrors = (!lastSyncErrors || !Object.keys(lastSyncErrors).length) && !error;
            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
            if (!(noErrors && nextNoErrors) && (!__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(lastSyncErrors, nextSyncErrors) || !__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(error, nextError))) {
              updateSyncErrors(nextSyncErrors, nextError);
            }
          }
        }, {
          key: 'clearSubmitPromiseIfNeeded',
          value: function clearSubmitPromiseIfNeeded(nextProps) {
            var submitting = this.props.submitting;

            if (this.submitPromise && submitting && !nextProps.submitting) {
              delete this.submitPromise;
            }
          }
        }, {
          key: 'submitIfNeeded',
          value: function submitIfNeeded(nextProps) {
            var _props2 = this.props,
                clearSubmit = _props2.clearSubmit,
                triggerSubmit = _props2.triggerSubmit;

            if (!triggerSubmit && nextProps.triggerSubmit) {
              clearSubmit();
              this.submit();
            }
          }
        }, {
          key: 'shouldErrorFunction',
          value: function shouldErrorFunction() {
            var _props3 = this.props,
                shouldValidate = _props3.shouldValidate,
                shouldError = _props3.shouldError;

            var shouldValidateOverridden = shouldValidate !== __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */];
            var shouldErrorOverridden = shouldError !== __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__["a" /* default */];

            return shouldValidateOverridden && !shouldErrorOverridden ? shouldValidate : shouldError;
          }
        }, {
          key: 'validateIfNeeded',
          value: function validateIfNeeded(nextProps) {
            var _props4 = this.props,
                validate = _props4.validate,
                values = _props4.values;

            var shouldError = this.shouldErrorFunction();
            var fieldLevelValidate = this.generateValidator();
            if (validate || fieldLevelValidate) {
              var initialRender = nextProps === undefined;
              var fieldValidatorKeys = Object.keys(this.getValidators());
              var validateParams = {
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldValidatorKeys,
                fieldValidatorKeys: fieldValidatorKeys,
                structure: structure
              };

              if (shouldError(validateParams)) {
                var propsToValidate = initialRender || !nextProps ? this.props : nextProps;

                var _merge2 = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__["a" /* default */])(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}),
                    _error = _merge2._error,
                    nextSyncErrors = _objectWithoutProperties(_merge2, ['_error']);

                this.lastFieldValidatorKeys = fieldValidatorKeys;
                this.updateSyncErrorsIfNeeded(nextSyncErrors, _error, propsToValidate.syncErrors);
              }
            } else {
              this.lastFieldValidatorKeys = [];
            }
          }
        }, {
          key: 'updateSyncWarningsIfNeeded',
          value: function updateSyncWarningsIfNeeded(nextSyncWarnings, nextWarning, lastSyncWarnings) {
            var _props5 = this.props,
                warning = _props5.warning,
                syncWarnings = _props5.syncWarnings,
                updateSyncWarnings = _props5.updateSyncWarnings;

            var noWarnings = (!syncWarnings || !Object.keys(syncWarnings).length) && !warning;
            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
            if (!(noWarnings && nextNoWarnings) && (!__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(lastSyncWarnings, nextSyncWarnings) || !__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(warning, nextWarning))) {
              updateSyncWarnings(nextSyncWarnings, nextWarning);
            }
          }
        }, {
          key: 'shouldWarnFunction',
          value: function shouldWarnFunction() {
            var _props6 = this.props,
                shouldValidate = _props6.shouldValidate,
                shouldWarn = _props6.shouldWarn;

            var shouldValidateOverridden = shouldValidate !== __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */];
            var shouldWarnOverridden = shouldWarn !== __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__["a" /* default */];

            return shouldValidateOverridden && !shouldWarnOverridden ? shouldValidate : shouldWarn;
          }
        }, {
          key: 'warnIfNeeded',
          value: function warnIfNeeded(nextProps) {
            var _props7 = this.props,
                warn = _props7.warn,
                values = _props7.values;

            var shouldWarn = this.shouldWarnFunction();
            var fieldLevelWarn = this.generateWarner();
            if (warn || fieldLevelWarn) {
              var initialRender = nextProps === undefined;
              var fieldWarnerKeys = Object.keys(this.getWarners());
              var validateParams = {
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldWarnerKeys,
                fieldValidatorKeys: fieldWarnerKeys,
                structure: structure
              };

              if (shouldWarn(validateParams)) {
                var propsToWarn = initialRender || !nextProps ? this.props : nextProps;

                var _merge3 = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__["a" /* default */])(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}),
                    _warning = _merge3._warning,
                    nextSyncWarnings = _objectWithoutProperties(_merge3, ['_warning']);

                this.lastFieldWarnerKeys = fieldWarnerKeys;
                this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning, propsToWarn.syncWarnings);
              }
            }
          }
        }, {
          key: 'componentWillMount',
          value: function componentWillMount() {
            if (!Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.initIfNeeded();
              this.validateIfNeeded();
              this.warnIfNeeded();
            }
            __WEBPACK_IMPORTED_MODULE_5_invariant___default()(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.');
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            this.initIfNeeded(nextProps);
            this.validateIfNeeded(nextProps);
            this.warnIfNeeded(nextProps);
            this.clearSubmitPromiseIfNeeded(nextProps);
            this.submitIfNeeded(nextProps);
            var onChange = nextProps.onChange,
                values = nextProps.values,
                dispatch = nextProps.dispatch;

            if (onChange && !deepEqual(values, this.props.values)) {
              onChange(values, dispatch, nextProps, this.props.values);
            }
          }
        }, {
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate(nextProps) {
            var _this3 = this;

            if (!this.props.pure) return true;
            var _config$immutableProp = config.immutableProps,
                immutableProps = _config$immutableProp === undefined ? [] : _config$immutableProp;
            // if we have children, we MUST update in React 16
            // https://twitter.com/erikras/status/915866544558788608

            return !!(this.props.children || nextProps.children || Object.keys(nextProps).some(function (prop) {
              // useful to debug rerenders
              // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
              //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
              // }
              if (~immutableProps.indexOf(prop)) {
                return _this3.props[prop] !== nextProps[prop];
              }
              return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
            }));
          }
        }, {
          key: 'componentDidMount',
          value: function componentDidMount() {
            if (!Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.initIfNeeded(this.props);
              this.validateIfNeeded();
              this.warnIfNeeded();
            }
            __WEBPACK_IMPORTED_MODULE_5_invariant___default()(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.');
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            var _props8 = this.props,
                destroyOnUnmount = _props8.destroyOnUnmount,
                destroy = _props8.destroy;

            if (destroyOnUnmount && !Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.destroyed = true;
              destroy();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            // remove some redux-form config-only props
            /* eslint-disable no-unused-vars */
            var _props9 = this.props,
                anyTouched = _props9.anyTouched,
                array = _props9.array,
                arrayInsert = _props9.arrayInsert,
                arrayMove = _props9.arrayMove,
                arrayPop = _props9.arrayPop,
                arrayPush = _props9.arrayPush,
                arrayRemove = _props9.arrayRemove,
                arrayRemoveAll = _props9.arrayRemoveAll,
                arrayShift = _props9.arrayShift,
                arraySplice = _props9.arraySplice,
                arraySwap = _props9.arraySwap,
                arrayUnshift = _props9.arrayUnshift,
                asyncErrors = _props9.asyncErrors,
                asyncValidate = _props9.asyncValidate,
                asyncValidating = _props9.asyncValidating,
                blur = _props9.blur,
                change = _props9.change,
                clearSubmit = _props9.clearSubmit,
                destroy = _props9.destroy,
                destroyOnUnmount = _props9.destroyOnUnmount,
                forceUnregisterOnUnmount = _props9.forceUnregisterOnUnmount,
                dirty = _props9.dirty,
                dispatch = _props9.dispatch,
                enableReinitialize = _props9.enableReinitialize,
                error = _props9.error,
                focus = _props9.focus,
                form = _props9.form,
                getFormState = _props9.getFormState,
                immutableProps = _props9.immutableProps,
                initialize = _props9.initialize,
                initialized = _props9.initialized,
                initialValues = _props9.initialValues,
                invalid = _props9.invalid,
                keepDirtyOnReinitialize = _props9.keepDirtyOnReinitialize,
                keepValues = _props9.keepValues,
                updateUnregisteredFields = _props9.updateUnregisteredFields,
                pristine = _props9.pristine,
                propNamespace = _props9.propNamespace,
                registeredFields = _props9.registeredFields,
                registerField = _props9.registerField,
                reset = _props9.reset,
                resetSection = _props9.resetSection,
                setSubmitFailed = _props9.setSubmitFailed,
                setSubmitSucceeded = _props9.setSubmitSucceeded,
                shouldAsyncValidate = _props9.shouldAsyncValidate,
                shouldValidate = _props9.shouldValidate,
                shouldError = _props9.shouldError,
                shouldWarn = _props9.shouldWarn,
                startAsyncValidation = _props9.startAsyncValidation,
                startSubmit = _props9.startSubmit,
                stopAsyncValidation = _props9.stopAsyncValidation,
                stopSubmit = _props9.stopSubmit,
                submitting = _props9.submitting,
                submitFailed = _props9.submitFailed,
                submitSucceeded = _props9.submitSucceeded,
                touch = _props9.touch,
                touchOnBlur = _props9.touchOnBlur,
                touchOnChange = _props9.touchOnChange,
                persistentSubmitErrors = _props9.persistentSubmitErrors,
                syncErrors = _props9.syncErrors,
                syncWarnings = _props9.syncWarnings,
                unregisterField = _props9.unregisterField,
                untouch = _props9.untouch,
                updateSyncErrors = _props9.updateSyncErrors,
                updateSyncWarnings = _props9.updateSyncWarnings,
                valid = _props9.valid,
                validExceptSubmit = _props9.validExceptSubmit,
                values = _props9.values,
                warning = _props9.warning,
                rest = _objectWithoutProperties(_props9, ['anyTouched', 'array', 'arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncErrors', 'asyncValidate', 'asyncValidating', 'blur', 'change', 'clearSubmit', 'destroy', 'destroyOnUnmount', 'forceUnregisterOnUnmount', 'dirty', 'dispatch', 'enableReinitialize', 'error', 'focus', 'form', 'getFormState', 'immutableProps', 'initialize', 'initialized', 'initialValues', 'invalid', 'keepDirtyOnReinitialize', 'keepValues', 'updateUnregisteredFields', 'pristine', 'propNamespace', 'registeredFields', 'registerField', 'reset', 'resetSection', 'setSubmitFailed', 'setSubmitSucceeded', 'shouldAsyncValidate', 'shouldValidate', 'shouldError', 'shouldWarn', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitting', 'submitFailed', 'submitSucceeded', 'touch', 'touchOnBlur', 'touchOnChange', 'persistentSubmitErrors', 'syncErrors', 'syncWarnings', 'unregisterField', 'untouch', 'updateSyncErrors', 'updateSyncWarnings', 'valid', 'validExceptSubmit', 'values', 'warning']);
            /* eslint-enable no-unused-vars */


            var reduxFormProps = _extends({
              array: array,
              anyTouched: anyTouched,
              asyncValidate: this.asyncValidate,
              asyncValidating: asyncValidating
            }, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])({ blur: blur, change: change }, dispatch), {
              clearSubmit: clearSubmit,
              destroy: destroy,
              dirty: dirty,
              dispatch: dispatch,
              error: error,
              form: form,
              handleSubmit: this.submit,
              initialize: initialize,
              initialized: initialized,
              initialValues: initialValues,
              invalid: invalid,
              pristine: pristine,
              reset: reset,
              resetSection: resetSection,
              submitting: submitting,
              submitFailed: submitFailed,
              submitSucceeded: submitSucceeded,
              touch: touch,
              untouch: untouch,
              valid: valid,
              warning: warning
            });
            var propsToPass = _extends({}, propNamespace ? _defineProperty({}, propNamespace, reduxFormProps) : reduxFormProps, rest);
            if (isClassComponent(WrappedComponent)) {
              ;propsToPass.ref = this.saveRef;
            }
            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, propsToPass);
          }
        }]);

        return Form;
      }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

      Form.displayName = 'Form(' + Object(__WEBPACK_IMPORTED_MODULE_22__util_getDisplayName__["a" /* default */])(WrappedComponent) + ')';
      Form.WrappedComponent = WrappedComponent;
      Form.childContextTypes = {
        _reduxForm: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired
      };
      Form.propTypes = {
        destroyOnUnmount: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        forceUnregisterOnUnmount: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        form: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
        immutableProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string),
        initialValues: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
        getFormState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        onSubmitFail: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        onSubmitSuccess: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        propNamespace: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
        validate: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        warn: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        touchOnBlur: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        touchOnChange: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        triggerSubmit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        persistentSubmitErrors: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        registeredFields: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
      };

      var connector = Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(function (state, props) {
        var form = props.form,
            getFormState = props.getFormState,
            initialValues = props.initialValues,
            enableReinitialize = props.enableReinitialize,
            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;

        var formState = getIn(getFormState(state) || empty, form) || empty;
        var stateInitial = getIn(formState, 'initial');
        var initialized = !!stateInitial;

        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;

        var initial = initialValues || stateInitial || empty;

        if (shouldUpdateInitialValues) {
          initial = stateInitial || empty;
        }

        var values = getIn(formState, 'values') || initial;

        if (shouldResetValues) {
          values = initial;
        }

        var pristine = shouldResetValues || deepEqual(initial, values);
        var asyncErrors = getIn(formState, 'asyncErrors');
        var syncErrors = getIn(formState, 'syncErrors') || __WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].empty;
        var syncWarnings = getIn(formState, 'syncWarnings') || __WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].empty;
        var registeredFields = getIn(formState, 'registeredFields');
        var valid = isValid(form, getFormState, false)(state);
        var validExceptSubmit = isValid(form, getFormState, true)(state);
        var anyTouched = !!getIn(formState, 'anyTouched');
        var submitting = !!getIn(formState, 'submitting');
        var submitFailed = !!getIn(formState, 'submitFailed');
        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
        var error = getIn(formState, 'error');
        var warning = getIn(formState, 'warning');
        var triggerSubmit = getIn(formState, 'triggerSubmit');
        return {
          anyTouched: anyTouched,
          asyncErrors: asyncErrors,
          asyncValidating: getIn(formState, 'asyncValidating') || false,
          dirty: !pristine,
          error: error,
          initialized: initialized,
          invalid: !valid,
          pristine: pristine,
          registeredFields: registeredFields,
          submitting: submitting,
          submitFailed: submitFailed,
          submitSucceeded: submitSucceeded,
          syncErrors: syncErrors,
          syncWarnings: syncWarnings,
          triggerSubmit: triggerSubmit,
          values: values,
          valid: valid,
          validExceptSubmit: validExceptSubmit,
          warning: warning
        };
      }, function (dispatch, initialProps) {
        var bindForm = function bindForm(actionCreator) {
          return actionCreator.bind(null, initialProps.form);
        };

        // Bind the first parameter on `props.form`
        var boundFormACs = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__["a" /* default */])(formActions, bindForm);
        var boundArrayACs = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__["a" /* default */])(arrayActions, bindForm);
        var boundBlur = function boundBlur(field, value) {
          return blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
        };
        var boundChange = function boundChange(field, value) {
          return change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
        };
        var boundFocus = bindForm(focus);

        // Wrap action creators with `dispatch`
        var connectedFormACs = Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundFormACs, dispatch);
        var connectedArrayACs = {
          insert: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayInsert, dispatch),
          move: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayMove, dispatch),
          pop: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayPop, dispatch),
          push: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayPush, dispatch),
          remove: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayRemove, dispatch),
          removeAll: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayRemoveAll, dispatch),
          shift: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayShift, dispatch),
          splice: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arraySplice, dispatch),
          swap: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arraySwap, dispatch),
          unshift: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayUnshift, dispatch)
        };

        var computedActions = _extends({}, connectedFormACs, boundArrayACs, {
          blur: boundBlur,
          change: boundChange,
          array: connectedArrayACs,
          focus: boundFocus,
          dispatch: dispatch
        });

        return function () {
          return computedActions;
        };
      }, undefined, { withRef: true });
      var ConnectedForm = __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(connector(Form), WrappedComponent);
      ConnectedForm.defaultProps = config;

      // build outer component to expose instance api

      var ReduxForm = function (_Component2) {
        _inherits(ReduxForm, _Component2);

        function ReduxForm() {
          _classCallCheck(this, ReduxForm);

          return _possibleConstructorReturn(this, (ReduxForm.__proto__ || Object.getPrototypeOf(ReduxForm)).apply(this, arguments));
        }

        _createClass(ReduxForm, [{
          key: 'submit',
          value: function submit() {
            return this.ref && this.ref.getWrappedInstance().submit();
          }
        }, {
          key: 'reset',
          value: function reset() {
            if (this.ref) {
              this.ref.getWrappedInstance().reset();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _this5 = this;

            var _props10 = this.props,
                initialValues = _props10.initialValues,
                rest = _objectWithoutProperties(_props10, ['initialValues']);

            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ConnectedForm, _extends({}, rest, {
              ref: function ref(_ref3) {
                _this5.ref = _ref3;
              },
              // convert initialValues if need to
              initialValues: fromJS(initialValues)
            }));
          }
        }, {
          key: 'valid',
          get: function get() {
            return !!(this.ref && this.ref.getWrappedInstance().isValid());
          }
        }, {
          key: 'invalid',
          get: function get() {
            return !this.valid;
          }
        }, {
          key: 'pristine',
          get: function get() {
            return !!(this.ref && this.ref.getWrappedInstance().isPristine());
          }
        }, {
          key: 'dirty',
          get: function get() {
            return !this.pristine;
          }
        }, {
          key: 'values',
          get: function get() {
            return this.ref ? this.ref.getWrappedInstance().getValues() : empty;
          }
        }, {
          key: 'fieldList',
          get: function get() {
            // mainly provided for testing
            return this.ref ? this.ref.getWrappedInstance().getFieldList() : [];
          }
        }, {
          key: 'wrappedInstance',
          get: function get() {
            // for testing
            return this.ref && this.ref.getWrappedInstance().wrapped;
          }
        }]);

        return ReduxForm;
      }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

      Object(__WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__["polyfill"])(ReduxForm);
      return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(ReduxForm, WrappedComponent);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createReduxForm);

/***/ }),
/* 3333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMerge_js__ = __webpack_require__(3334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAssigner_js__ = __webpack_require__(3347);



/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = Object(__WEBPACK_IMPORTED_MODULE_1__createAssigner_js__["a" /* default */])(function(object, source, srcIndex) {
  Object(__WEBPACK_IMPORTED_MODULE_0__baseMerge_js__["a" /* default */])(object, source, srcIndex);
});

/* harmony default export */ __webpack_exports__["a"] = (merge);


/***/ }),
/* 3334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseFor_js__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__ = __webpack_require__(3335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isObject_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keysIn_js__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__safeGet_js__ = __webpack_require__(1317);








/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  Object(__WEBPACK_IMPORTED_MODULE_2__baseFor_js__["a" /* default */])(source, function(srcValue, key) {
    stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
    if (Object(__WEBPACK_IMPORTED_MODULE_4__isObject_js__["a" /* default */])(srcValue)) {
      Object(__WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__["a" /* default */])(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(Object(__WEBPACK_IMPORTED_MODULE_6__safeGet_js__["a" /* default */])(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__["a" /* default */])(object, key, newValue);
    }
  }, __WEBPACK_IMPORTED_MODULE_5__keysIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMerge);


/***/ }),
/* 3335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__ = __webpack_require__(3336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__ = __webpack_require__(3337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__copyArray_js__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__ = __webpack_require__(3339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArguments_js__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isArray_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__ = __webpack_require__(3341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__isBuffer_js__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isFunction_js__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__isObject_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__safeGet_js__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__toPlainObject_js__ = __webpack_require__(3342);
















/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = Object(__WEBPACK_IMPORTED_MODULE_13__safeGet_js__["a" /* default */])(object, key),
      srcValue = Object(__WEBPACK_IMPORTED_MODULE_13__safeGet_js__["a" /* default */])(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    Object(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = Object(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(srcValue),
        isBuff = !isArr && Object(__WEBPACK_IMPORTED_MODULE_8__isBuffer_js__["a" /* default */])(srcValue),
        isTyped = !isArr && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__["a" /* default */])(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (Object(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(objValue)) {
        newValue = objValue;
      }
      else if (Object(__WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_3__copyArray_js__["a" /* default */])(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = Object(__WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__["a" /* default */])(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = Object(__WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__["a" /* default */])(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__["a" /* default */])(srcValue) || Object(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(srcValue)) {
      newValue = objValue;
      if (Object(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_14__toPlainObject_js__["a" /* default */])(objValue);
      }
      else if (!Object(__WEBPACK_IMPORTED_MODULE_10__isObject_js__["a" /* default */])(objValue) || Object(__WEBPACK_IMPORTED_MODULE_9__isFunction_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__["a" /* default */])(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, newValue);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMergeDeep);


/***/ }),
/* 3336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(96);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(149)(module)))

/***/ }),
/* 3337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(3338);


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? Object(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneTypedArray);


/***/ }),
/* 3338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__ = __webpack_require__(1304);


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](result).set(new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](arrayBuffer));
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneArrayBuffer);


/***/ }),
/* 3339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(3340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isPrototype_js__ = __webpack_require__(321);




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !Object(__WEBPACK_IMPORTED_MODULE_2__isPrototype_js__["a" /* default */])(object))
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(object))
    : {};
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneObject);


/***/ }),
/* 3340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(117);


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (baseCreate);


/***/ }),
/* 3341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(126);



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLikeObject);


/***/ }),
/* 3342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(3343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keysIn_js__ = __webpack_require__(1318);



/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(value, Object(__WEBPACK_IMPORTED_MODULE_1__keysIn_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (toPlainObject);


/***/ }),
/* 3343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignValue_js__ = __webpack_require__(3344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__ = __webpack_require__(322);



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      Object(__WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__["a" /* default */])(object, key, newValue);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_0__assignValue_js__["a" /* default */])(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ __webpack_exports__["a"] = (copyObject);


/***/ }),
/* 3344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(239);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(objValue, value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignValue);


/***/ }),
/* 3345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPrototype_js__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__ = __webpack_require__(3346);




/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__["a" /* default */])(object);
  }
  var isProto = Object(__WEBPACK_IMPORTED_MODULE_1__isPrototype_js__["a" /* default */])(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeysIn);


/***/ }),
/* 3346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (nativeKeysIn);


/***/ }),
/* 3347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(3348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__ = __webpack_require__(3355);



/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */])(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && Object(__WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__["a" /* default */])(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/* harmony default export */ __webpack_exports__["a"] = (createAssigner);


/***/ }),
/* 3348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__overRest_js__ = __webpack_require__(3349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setToString_js__ = __webpack_require__(3351);




/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__setToString_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__overRest_js__["a" /* default */])(func, start, __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */]), func + '');
}

/* harmony default export */ __webpack_exports__["a"] = (baseRest);


/***/ }),
/* 3349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(3350);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(func, this, otherArgs);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overRest);


/***/ }),
/* 3350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* harmony default export */ __webpack_exports__["a"] = (apply);


/***/ }),
/* 3351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__ = __webpack_require__(3352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortOut_js__ = __webpack_require__(3354);



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = Object(__WEBPACK_IMPORTED_MODULE_1__shortOut_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (setToString);


/***/ }),
/* 3352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(3353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defineProperty_js__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(517);




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */] : function(func, string) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */])(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(string),
    'writable': true
  });
};

/* harmony default export */ __webpack_exports__["a"] = (baseSetToString);


/***/ }),
/* 3353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (constant);


/***/ }),
/* 3354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (shortOut);


/***/ }),
/* 3355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isIndex_js__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isObject_js__ = __webpack_require__(117);





/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_3__isObject_js__["a" /* default */])(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(object) && Object(__WEBPACK_IMPORTED_MODULE_2__isIndex_js__["a" /* default */])(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(object[index], value);
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (isIterateeCall);


/***/ }),
/* 3356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_promise__);


var asyncValidation = function asyncValidation(fn, start, stop, field) {
  start(field);
  var promise = fn();
  if (!__WEBPACK_IMPORTED_MODULE_0_is_promise___default()(promise)) {
    throw new Error('asyncValidate function passed to reduxForm must return a promise');
  }
  var handleErrors = function handleErrors(rejected) {
    return function (errors) {
      if (rejected) {
        if (errors && Object.keys(errors).length) {
          stop(errors);
          return errors;
        } else {
          stop();
          throw new Error('Asynchronous validation promise was rejected without errors.');
        }
      }
      stop();
      return Promise.resolve();
    };
  };
  return promise.then(handleErrors(false), handleErrors(true));
};

/* harmony default export */ __webpack_exports__["a"] = (asyncValidation);

/***/ }),
/* 3357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__silenceEvent__ = __webpack_require__(1319);


var silenceEvents = function silenceEvents(fn) {
  return function (event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__silenceEvent__["a" /* default */])(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
  };
};

/* harmony default export */ __webpack_exports__["a"] = (silenceEvents);

/***/ }),
/* 3358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__structure_plain__ = __webpack_require__(26);



var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var getError = function getError(value, values, props, validators, name) {
  var array = toArray(validators);
  for (var i = 0; i < array.length; i++) {
    var error = array[i](value, values, props, name);
    if (error) {
      return error;
    }
  }
};

var generateValidator = function generateValidator(validators, _ref) {
  var getIn = _ref.getIn;
  return function (values, props) {
    var errors = {};
    Object.keys(validators).forEach(function (name) {
      var value = getIn(values, name);
      var error = getError(value, values, props, validators[name], name);
      if (error) {
        errors = __WEBPACK_IMPORTED_MODULE_0__structure_plain__["a" /* default */].setIn(errors, name, error);
      }
    });
    return errors;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (generateValidator);

/***/ }),
/* 3359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubmissionError__ = __webpack_require__(1292);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
  var dispatch = props.dispatch,
      onSubmitFail = props.onSubmitFail,
      onSubmitSuccess = props.onSubmitSuccess,
      startSubmit = props.startSubmit,
      stopSubmit = props.stopSubmit,
      setSubmitFailed = props.setSubmitFailed,
      setSubmitSucceeded = props.setSubmitSucceeded,
      syncErrors = props.syncErrors,
      asyncErrors = props.asyncErrors,
      touch = props.touch,
      values = props.values,
      persistentSubmitErrors = props.persistentSubmitErrors;


  touch.apply(undefined, _toConsumableArray(fields)); // mark all fields as touched

  if (valid || persistentSubmitErrors) {
    var doSubmit = function doSubmit() {
      var result = void 0;
      try {
        result = submit(values, dispatch, props);
      } catch (submitError) {
        var error = submitError instanceof __WEBPACK_IMPORTED_MODULE_1__SubmissionError__["a" /* default */] ? submitError.errors : undefined;
        stopSubmit(error);
        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(error, dispatch, submitError, props);
        }
        if (error || onSubmitFail) {
          // if you've provided an onSubmitFail callback, don't re-throw the error
          return error;
        } else {
          throw submitError;
        }
      }
      if (__WEBPACK_IMPORTED_MODULE_0_is_promise___default()(result)) {
        startSubmit();
        return result.then(function (submitResult) {
          stopSubmit();
          setSubmitSucceeded();
          if (onSubmitSuccess) {
            onSubmitSuccess(submitResult, dispatch, props);
          }
          return submitResult;
        }, function (submitError) {
          var error = submitError instanceof __WEBPACK_IMPORTED_MODULE_1__SubmissionError__["a" /* default */] ? submitError.errors : undefined;
          stopSubmit(error);
          setSubmitFailed.apply(undefined, _toConsumableArray(fields));
          if (onSubmitFail) {
            onSubmitFail(error, dispatch, submitError, props);
          }
          if (error || onSubmitFail) {
            // if you've provided an onSubmitFail callback, don't re-throw the error
            return error;
          } else {
            throw submitError;
          }
        });
      } else {
        setSubmitSucceeded();
        if (onSubmitSuccess) {
          onSubmitSuccess(result, dispatch, props);
        }
      }
      return result;
    };

    var asyncValidateResult = asyncValidate && asyncValidate();
    if (asyncValidateResult) {
      return asyncValidateResult.then(function (asyncErrors) {
        if (asyncErrors) {
          throw asyncErrors;
        }
        return doSubmit();
      }).catch(function (asyncErrors) {
        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(asyncErrors, dispatch, null, props);
        }
        return Promise.reject(asyncErrors);
      });
    } else {
      return doSubmit();
    }
  } else {
    setSubmitFailed.apply(undefined, _toConsumableArray(fields));
    var errors = _extends({}, asyncErrors, syncErrors);
    if (onSubmitFail) {
      onSubmitFail(errors, dispatch, null, props);
    }
    return errors;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (handleSubmit);

/***/ }),
/* 3360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var getDisplayName = function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
};


/* harmony default export */ __webpack_exports__["a"] = (getDisplayName);

/***/ }),
/* 3361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var isHotReloading = function isHotReloading() {
  return !!(typeof module !== 'undefined' && module.hot && typeof module.hot.status === 'function' && module.hot.status() === 'apply');
};

/* harmony default export */ __webpack_exports__["a"] = (isHotReloading);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(149)(module)))

/***/ }),
/* 3362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReducer__ = __webpack_require__(3363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__ = __webpack_require__(3364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__structure_plain__ = __webpack_require__(26);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var shouldDelete = function shouldDelete(_ref) {
  var getIn = _ref.getIn;
  return function (state, path) {
    var initialValuesPath = null;

    if (path.startsWith('values')) {
      initialValuesPath = path.replace('values', 'initial');
    }

    var initialValueComparison = initialValuesPath ? getIn(state, initialValuesPath) === undefined : true;

    return getIn(state, path) !== undefined && initialValueComparison;
  };
};

var isReduxFormAction = function isReduxFormAction(action) {
  return action && action.type && action.type.length > __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"].length && action.type.substring(0, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"].length) === __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"];
};

function createReducer(structure) {
  var _behaviors;

  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      forEach = structure.forEach,
      getIn = structure.getIn,
      setIn = structure.setIn,
      deleteIn = structure.deleteIn,
      fromJS = structure.fromJS,
      keys = structure.keys,
      size = structure.size,
      some = structure.some,
      splice = structure.splice;

  var deleteInWithCleanUp = Object(__WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__["a" /* default */])(structure)(shouldDelete);
  var plainDeleteInWithCleanUp = Object(__WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */])(shouldDelete);
  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
    var existing = getIn(state, key + '.' + field);
    return existing || force ? setIn(state, key + '.' + field, splice(existing, index, removeNum, value)) : state;
  };
  var doPlainSplice = function doPlainSplice(state, key, field, index, removeNum, value, force) {
    var slice = getIn(state, key);
    var existing = __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].getIn(slice, field);
    return existing || force ? setIn(state, key, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].setIn(slice, field, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].splice(existing, index, removeNum, value))) : state;
  };
  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
    var result = state;
    var nonValuesValue = value != null ? empty : undefined;
    result = doSplice(result, 'values', field, index, removeNum, value, true);
    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
    result = doPlainSplice(result, 'syncErrors', field, index, removeNum, undefined);
    result = doPlainSplice(result, 'syncWarnings', field, index, removeNum, undefined);
    result = doSplice(result, 'submitErrors', field, index, removeNum, undefined);
    result = doSplice(result, 'asyncErrors', field, index, removeNum, undefined);
    return result;
  };

  var behaviors = (_behaviors = {}, _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_INSERT"], function (state, _ref2) {
    var _ref2$meta = _ref2.meta,
        field = _ref2$meta.field,
        index = _ref2$meta.index,
        payload = _ref2.payload;

    return arraySplice(state, field, index, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_MOVE"], function (state, _ref3) {
    var _ref3$meta = _ref3.meta,
        field = _ref3$meta.field,
        from = _ref3$meta.from,
        to = _ref3$meta.to;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    var result = state;
    if (length) {
      rootKeys.forEach(function (key) {
        var path = key + '.' + field;
        if (getIn(result, path)) {
          var value = getIn(result, path + '[' + from + ']');
          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove
          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
        }
      });
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_POP"], function (state, _ref4) {
    var field = _ref4.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, length - 1, 1) : state;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_PUSH"], function (state, _ref5) {
    var field = _ref5.meta.field,
        payload = _ref5.payload;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return arraySplice(state, field, length, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE"], function (state, _ref6) {
    var _ref6$meta = _ref6.meta,
        field = _ref6$meta.field,
        index = _ref6$meta.index;

    return arraySplice(state, field, index, 1);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE_ALL"], function (state, _ref7) {
    var field = _ref7.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, 0, length) : state;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SHIFT"], function (state, _ref8) {
    var field = _ref8.meta.field;

    return arraySplice(state, field, 0, 1);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SPLICE"], function (state, _ref9) {
    var _ref9$meta = _ref9.meta,
        field = _ref9$meta.field,
        index = _ref9$meta.index,
        removeNum = _ref9$meta.removeNum,
        payload = _ref9.payload;

    return arraySplice(state, field, index, removeNum, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SWAP"], function (state, _ref10) {
    var _ref10$meta = _ref10.meta,
        field = _ref10$meta.field,
        indexA = _ref10$meta.indexA,
        indexB = _ref10$meta.indexB;

    var result = state;
    rootKeys.forEach(function (key) {
      var valueA = getIn(result, key + '.' + field + '[' + indexA + ']');
      var valueB = getIn(result, key + '.' + field + '[' + indexB + ']');
      if (valueA !== undefined || valueB !== undefined) {
        result = setIn(result, key + '.' + field + '[' + indexA + ']', valueB);
        result = setIn(result, key + '.' + field + '[' + indexB + ']', valueA);
      }
    });
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_UNSHIFT"], function (state, _ref11) {
    var field = _ref11.meta.field,
        payload = _ref11.payload;

    return arraySplice(state, field, 0, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["AUTOFILL"], function (state, _ref12) {
    var field = _ref12.meta.field,
        payload = _ref12.payload;

    var result = state;
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    result = setIn(result, 'fields.' + field + '.autofilled', true);
    result = setIn(result, 'values.' + field, payload);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["BLUR"], function (state, _ref13) {
    var _ref13$meta = _ref13.meta,
        field = _ref13$meta.field,
        touch = _ref13$meta.touch,
        payload = _ref13.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    if (field === getIn(result, 'active')) {
      result = deleteIn(result, 'active');
    }
    result = deleteIn(result, 'fields.' + field + '.active');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CHANGE"], function (state, _ref14) {
    var _ref14$meta = _ref14.meta,
        field = _ref14$meta.field,
        touch = _ref14$meta.touch,
        persistentSubmitErrors = _ref14$meta.persistentSubmitErrors,
        payload = _ref14.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    if (!persistentSubmitErrors) {
      result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    }
    result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT"], function (state) {
    return deleteIn(state, 'triggerSubmit');
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT_ERRORS"], function (state) {
    var result = state;
    result = deleteInWithCleanUp(result, 'submitErrors');
    result = deleteIn(result, 'error');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_ASYNC_ERROR"], function (state, _ref15) {
    var field = _ref15.meta.field;

    return deleteIn(state, 'asyncErrors.' + field);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_FIELDS"], function (state, _ref16) {
    var _ref16$meta = _ref16.meta,
        keepTouched = _ref16$meta.keepTouched,
        persistentSubmitErrors = _ref16$meta.persistentSubmitErrors,
        fields = _ref16$meta.fields;

    var result = state;
    fields.forEach(function (field) {
      result = deleteInWithCleanUp(result, 'values.' + field);
      result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
      if (!persistentSubmitErrors) {
        result = deleteInWithCleanUp(result, 'submitErrors.' + field);
      }
      result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
      if (!keepTouched) {
        result = deleteIn(result, 'fields.' + field + '.touched');
      }
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["FOCUS"], function (state, _ref17) {
    var field = _ref17.meta.field;

    var result = state;
    var previouslyActive = getIn(state, 'active');
    result = deleteIn(result, 'fields.' + previouslyActive + '.active');
    result = setIn(result, 'fields.' + field + '.visited', true);
    result = setIn(result, 'fields.' + field + '.active', true);
    result = setIn(result, 'active', field);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["INITIALIZE"], function (state, _ref18) {
    var payload = _ref18.payload,
        _ref18$meta = _ref18.meta,
        keepDirty = _ref18$meta.keepDirty,
        keepSubmitSucceeded = _ref18$meta.keepSubmitSucceeded,
        updateUnregisteredFields = _ref18$meta.updateUnregisteredFields,
        keepValues = _ref18$meta.keepValues;

    var mapData = fromJS(payload);
    var result = empty; // clean all field state

    // persist old warnings, they will get recalculated if the new form values are different from the old values
    var warning = getIn(state, 'warning');
    if (warning) {
      result = setIn(result, 'warning', warning);
    }
    var syncWarnings = getIn(state, 'syncWarnings');
    if (syncWarnings) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    }

    // persist old errors, they will get recalculated if the new form values are different from the old values
    var error = getIn(state, 'error');
    if (error) {
      result = setIn(result, 'error', error);
    }
    var syncErrors = getIn(state, 'syncErrors');
    if (syncErrors) {
      result = setIn(result, 'syncErrors', syncErrors);
    }

    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }

    var previousValues = getIn(state, 'values');
    var previousInitialValues = getIn(state, 'initial');

    var newInitialValues = mapData;
    var newValues = previousValues;

    if (keepDirty && registeredFields) {
      if (!deepEqual(newInitialValues, previousInitialValues)) {
        //
        // Keep the value of dirty fields while updating the value of
        // pristine fields. This way, apps can reinitialize forms while
        // avoiding stomping on user edits.
        //
        // Note 1: The initialize action replaces all initial values
        // regardless of keepDirty.
        //
        // Note 2: When a field is dirty, keepDirty is enabled, and the field
        // value is the same as the new initial value for the field, the
        // initialize action causes the field to become pristine. That effect
        // is what we want.
        //
        var overwritePristineValue = function overwritePristineValue(name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          var previousValue = getIn(previousValues, name);

          if (deepEqual(previousValue, previousInitialValue)) {
            // Overwrite the old pristine value with the new pristine value
            var newInitialValue = getIn(newInitialValues, name);

            // This check prevents any 'setIn' call that would create useless
            // nested objects, since the path to the new field value would
            // evaluate to the same (especially for undefined values)
            if (getIn(newValues, name) !== newInitialValue) {
              newValues = setIn(newValues, name, newInitialValue);
            }
          }
        };

        if (!updateUnregisteredFields) {
          forEach(keys(registeredFields), function (name) {
            return overwritePristineValue(name);
          });
        }

        forEach(keys(newInitialValues), function (name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          if (typeof previousInitialValue === 'undefined') {
            // Add new values at the root level.
            var newInitialValue = getIn(newInitialValues, name);
            newValues = setIn(newValues, name, newInitialValue);
          }

          if (updateUnregisteredFields) {
            overwritePristineValue(name);
          }
        });
      }
    } else {
      newValues = newInitialValues;
    }

    if (keepValues) {
      forEach(keys(previousValues), function (name) {
        var previousValue = getIn(previousValues, name);

        newValues = setIn(newValues, name, previousValue);
      });

      forEach(keys(previousInitialValues), function (name) {
        var previousInitialValue = getIn(previousInitialValues, name);

        newInitialValues = setIn(newInitialValues, name, previousInitialValue);
      });
    }

    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
      result = setIn(result, 'submitSucceeded', true);
    }
    result = setIn(result, 'values', newValues);
    result = setIn(result, 'initial', newInitialValues);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["REGISTER_FIELD"], function (state, _ref19) {
    var _ref19$payload = _ref19.payload,
        name = _ref19$payload.name,
        type = _ref19$payload.type;

    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(state, key);
    if (field) {
      var count = getIn(field, 'count') + 1;
      field = setIn(field, 'count', count);
    } else {
      field = fromJS({ name: name, type: type, count: 1 });
    }
    return setIn(state, key, field);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET"], function (state) {
    var result = empty;
    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }
    var values = getIn(state, 'initial');
    if (values) {
      result = setIn(result, 'values', values);
      result = setIn(result, 'initial', values);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET_SECTION"], function (state, _ref20) {
    var sections = _ref20.meta.sections;

    var result = state;

    sections.forEach(function (section) {
      result = deleteInWithCleanUp(result, 'asyncErrors.' + section);
      result = deleteInWithCleanUp(result, 'submitErrors.' + section);
      result = deleteInWithCleanUp(result, 'fields.' + section);

      var values = getIn(state, 'initial.' + section);
      result = values ? setIn(result, 'values.' + section, values) : deleteInWithCleanUp(result, 'values.' + section);
    });

    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');

    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SUBMIT"], function (state) {
    return setIn(state, 'triggerSubmit', true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_ASYNC_VALIDATION"], function (state, _ref21) {
    var field = _ref21.meta.field;

    return setIn(state, 'asyncValidating', field || true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_SUBMIT"], function (state) {
    return setIn(state, 'submitting', true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_ASYNC_VALIDATION"], function (state, _ref22) {
    var payload = _ref22.payload;

    var result = state;
    result = deleteIn(result, 'asyncValidating');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = _objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
      }
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'asyncErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_SUBMIT"], function (state, _ref23) {
    var payload = _ref23.payload;

    var result = state;
    result = deleteIn(result, 'submitting');
    result = deleteIn(result, 'submitFailed');
    result = deleteIn(result, 'submitSucceeded');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = _objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      } else {
        result = deleteIn(result, 'error');
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
      } else {
        result = deleteIn(result, 'submitErrors');
      }
      result = setIn(result, 'submitFailed', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'submitErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_FAILED"], function (state, _ref24) {
    var fields = _ref24.meta.fields;

    var result = state;
    result = setIn(result, 'submitFailed', true);
    result = deleteIn(result, 'submitSucceeded');
    result = deleteIn(result, 'submitting');
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    if (fields.length) {
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_SUCCEEDED"], function (state) {
    var result = state;
    result = deleteIn(result, 'submitFailed');
    result = setIn(result, 'submitSucceeded', true);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["TOUCH"], function (state, _ref25) {
    var fields = _ref25.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    result = setIn(result, 'anyTouched', true);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNREGISTER_FIELD"], function (state, _ref26) {
    var _ref26$payload = _ref26.payload,
        name = _ref26$payload.name,
        destroyOnUnmount = _ref26$payload.destroyOnUnmount;

    var result = state;
    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(result, key);
    if (!field) {
      return result;
    }

    var count = getIn(field, 'count') - 1;
    if (count <= 0 && destroyOnUnmount) {
      // Note: Cannot use deleteWithCleanUp here because of the flat nature of registeredFields
      result = deleteIn(result, key);
      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
        result = deleteIn(result, 'registeredFields');
      }
      var syncErrors = getIn(result, 'syncErrors');
      if (syncErrors) {
        syncErrors = plainDeleteInWithCleanUp(syncErrors, name);
        if (__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].deepEqual(syncErrors, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].empty)) {
          result = deleteIn(result, 'syncErrors');
        } else {
          result = setIn(result, 'syncErrors', syncErrors);
        }
      }
      var syncWarnings = getIn(result, 'syncWarnings');
      if (syncWarnings) {
        syncWarnings = plainDeleteInWithCleanUp(syncWarnings, name);
        if (__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].deepEqual(syncWarnings, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].empty)) {
          result = deleteIn(result, 'syncWarnings');
        } else {
          result = setIn(result, 'syncWarnings', syncWarnings);
        }
      }
      result = deleteInWithCleanUp(result, 'submitErrors.' + name);
      result = deleteInWithCleanUp(result, 'asyncErrors.' + name);
    } else {
      field = setIn(field, 'count', count);
      result = setIn(result, key, field);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNTOUCH"], function (state, _ref27) {
    var fields = _ref27.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = deleteIn(result, 'fields.' + field + '.touched');
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_ERRORS"], function (state, _ref28) {
    var _ref28$payload = _ref28.payload,
        syncErrors = _ref28$payload.syncErrors,
        error = _ref28$payload.error;

    var result = state;
    if (error) {
      result = setIn(result, 'error', error);
      result = setIn(result, 'syncError', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'syncError');
    }
    if (Object.keys(syncErrors).length) {
      result = setIn(result, 'syncErrors', syncErrors);
    } else {
      result = deleteIn(result, 'syncErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_WARNINGS"], function (state, _ref29) {
    var _ref29$payload = _ref29.payload,
        syncWarnings = _ref29$payload.syncWarnings,
        warning = _ref29$payload.warning;

    var result = state;
    if (warning) {
      result = setIn(result, 'warning', warning);
    } else {
      result = deleteIn(result, 'warning');
    }
    if (Object.keys(syncWarnings).length) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    } else {
      result = deleteIn(result, 'syncWarnings');
    }
    return result;
  }), _behaviors);

  var reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
    var action = arguments[1];

    var behavior = behaviors[action.type];
    return behavior ? behavior(state, action) : state;
  };

  var byForm = function byForm(reducer) {
    return function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };

      var form = action && action.meta && action.meta.form;
      if (!form || !isReduxFormAction(action)) {
        return state;
      }
      if (action.type === __WEBPACK_IMPORTED_MODULE_0__actionTypes__["DESTROY"] && action.meta && action.meta.form) {
        return action.meta.form.reduce(function (result, form) {
          return deleteInWithCleanUp(result, form);
        }, state);
      }
      var formState = getIn(state, form);
      var result = reducer(formState, action);
      return result === formState ? state : setIn(state, form, result);
    };
  };

  /**
   * Adds additional functionality to the reducer
   */
  function decorate(target) {
    target.plugin = function (reducers) {
      var _this = this;

      // use 'function' keyword to enable 'this'
      return decorate(function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };

        var callPlugin = function callPlugin(processed, key) {
          var previousState = getIn(processed, key);
          var nextState = reducers[key](previousState, action, getIn(state, key));
          return nextState !== previousState ? setIn(processed, key, nextState) : processed;
        };

        var processed = _this(state, action); // run through redux-form reducer
        var form = action && action.meta && action.meta.form;

        if (form) {
          // this is an action aimed at forms, so only give it to the specified form's plugin
          return reducers[form] ? callPlugin(processed, form) : processed;
        } else {
          // this is not a form-specific action, so send it to all the plugins
          return Object.keys(reducers).reduce(callPlugin, processed);
        }
      });
    };

    return target;
  }

  return decorate(byForm(reducer));
}

/* harmony default export */ __webpack_exports__["a"] = (createReducer);

/***/ }),
/* 3364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(311);



function createDeleteInWithCleanUp(structure) {
  var shouldDeleteDefault = function shouldDeleteDefault(structure) {
    return function (state, path) {
      return structure.getIn(state, path) !== undefined;
    };
  };

  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      getIn = structure.getIn,
      deleteIn = structure.deleteIn,
      setIn = structure.setIn;


  return function () {
    var shouldDelete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : shouldDeleteDefault;

    var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
      if (path[path.length - 1] === ']') {
        // array path
        var pathTokens = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(path);
        pathTokens.pop();
        var parent = getIn(state, pathTokens.join('.'));
        return parent ? setIn(state, path) : state;
      }

      var result = state;

      if (shouldDelete(structure)(state, path)) {
        result = deleteIn(state, path);
      }

      var dotIndex = path.lastIndexOf('.');
      if (dotIndex > 0) {
        var parentPath = path.substring(0, dotIndex);
        if (parentPath[parentPath.length - 1] !== ']') {
          var _parent = getIn(result, parentPath);
          if (deepEqual(_parent, empty)) {
            return deleteInWithCleanUp(result, parentPath);
          }
        }
      }
      return result;
    };

    return deleteInWithCleanUp;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createDeleteInWithCleanUp);

/***/ }),
/* 3365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createValues__ = __webpack_require__(3366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(26);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 3366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(31);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function (config) {
    var _prop$getFormState$co = _extends({
      prop: 'values',
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      }
    }, config),
        form = _prop$getFormState$co.form,
        prop = _prop$getFormState$co.prop,
        getFormState = _prop$getFormState$co.getFormState;

    return Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
      return _defineProperty({}, prop, getIn(getFormState(state), form + '.values'));
    }
    // ignore dispatch
    );
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createValues);

/***/ }),
/* 3367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InputContainer_js__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ncss_TextInput_js__ = __webpack_require__(626);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var label=_ref.label,input=_ref.input,title=_ref.title,meta=_ref.meta,props=_objectWithoutProperties(_ref,['label','input','title','meta']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__InputContainer_js__["a" /* default */],{label:label,meta:meta,title:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ncss_TextInput_js__["a" /* default */],Object.assign({},input,props)));});

/***/ }),
/* 3368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InputContainer__ = __webpack_require__(175);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var defaultInputClass='ncss-input pt2-sm pr4-sm pb2-sm pl4-sm';/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var label=_ref.label,input=_ref.input,title=_ref.title,meta=_ref.meta,props=_objectWithoutProperties(_ref,['label','input','title','meta']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__InputContainer__["a" /* default */],{label:label,meta:meta,title:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',Object.assign({type:'number',className:props.className||defaultInputClass},props,{onChange:wrap(input.onChange),onBlur:wrap(input.onBlur)})));});var wrap=function wrap(fn){if(!fn)return undefined;return function(e){return fn(e.target.value?parseFloat(e.target.value):null);};};

/***/ }),
/* 3369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InputContainer_js__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ncss_Checkbox_js__ = __webpack_require__(370);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var label=_ref.label,input=_ref.input,meta=_ref.meta,props=_objectWithoutProperties(_ref,['label','input','meta']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__InputContainer_js__["a" /* default */],{meta:meta,type:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ncss_Checkbox_js__["a" /* default */],Object.assign({},input,props,{checked:input.checked||input.value,label:label})));});

/***/ }),
/* 3370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InputContainer_js__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Select_js__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ncss_Toggle_js__ = __webpack_require__(627);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// React select passes in bad values onBlur, and redux-form expects the value
var valueOnBlur=function valueOnBlur(props){return function(){props.onBlur(props.value);};};/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var label=_ref.label,input=_ref.input,options=_ref.options,title=_ref.title,meta=_ref.meta,props=_objectWithoutProperties(_ref,['label','input','options','title','meta']);return options.length>3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__InputContainer_js__["a" /* default */],{label:label,meta:meta,title:title,type:'select'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Select_js__["a" /* default */],Object.assign({},input,{options:options,onChange:function onChange(option){return input.onChange(option&&option.value);},autoBlur:true,openOnFocus:true,onBlur:valueOnBlur(input),onBlurResetsInput:false},props))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ncss_Toggle_js__["a" /* default */],Object.assign({},input,{title:title,options:options,label:label}));});

/***/ }),
/* 3371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ncss_Button_js__ = __webpack_require__(601);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/* unused harmony default export */ var _unused_webpack_default_export = (function(_ref){var label=_ref.label,props=_objectWithoutProperties(_ref,['label']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ncss_Button_js__["a" /* default */],{type:'submit',color:props.invalid&&props.submitFailed?'error':'',disabled:props.submitting||props.asyncValidating||props.disabled},label,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa '+(props.submitting?'fa-circle-o-notch fa-spin':'fa-save')}));});

/***/ }),
/* 3372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InputContainer_js__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ncss_Label__ = __webpack_require__(189);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/* unused harmony default export */ var _unused_webpack_default_export = (function(_ref){var input=_ref.input,meta=_ref.meta,props=_objectWithoutProperties(_ref,['input','meta']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__InputContainer_js__["a" /* default */],{meta:meta,type:'label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ncss_Label__["a" /* default */],Object.assign({},input,props)));});

/***/ }),
/* 3373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InputContainer_js__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JiraWikiEditor__ = __webpack_require__(630);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var label=_ref.label,input=_ref.input,title=_ref.title,meta=_ref.meta,props=_objectWithoutProperties(_ref,['label','input','title','meta']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__InputContainer_js__["a" /* default */],{label:label,meta:meta,title:title,type:'wiki'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__JiraWikiEditor__["a" /* default */],Object.assign({},input,props)));});

/***/ }),
/* 3374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CreateRequestPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_history__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_index__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_index__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__request_forms_DynamicForm__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__auth_reducer__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducer__ = __webpack_require__(173);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// TODO update create action to also trigger the issueList on home page to re-fetch its data. 
var CreateRequestPage=function(_Component){_inherits(CreateRequestPage,_Component);function CreateRequestPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CreateRequestPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CreateRequestPage.__proto__||Object.getPrototypeOf(CreateRequestPage)).call.apply(_ref,[this].concat(args))),_this),_this.getSystemFieldValues=function(){var _this$props=_this.props,requestType=_this$props.requestType,user=_this$props.user;return requestType.systemFields.properties.reduce(function(result,field){result[field.id]=field.title==='Requestor Email'?user.email:field.title==='Requestor'?user.firstName+' '+user.lastName:field.value;return result;},{'issuetype':''+requestType.issuetype,'project':''+requestType.project});},_this.submit=function(values){var _this$props2=_this.props,createIssue=_this$props2.createIssue,requestType=_this$props2.requestType;var issueData=Object.assign({},_this.getSystemFieldValues(),values);//console.log(issueData)
return createIssue(issueData,requestType).catch(function(err){return console.error(err);});},_this.cancel=function(){__WEBPACK_IMPORTED_MODULE_4__util_history__["a" /* default */].push('/');},_temp),_possibleConstructorReturn(_this,_ret);}/*
  componentWillMount () {                
    let { getRequestType, requestName } = this.props
    if (requestName) {
      getRequestType(requestName).catch(err => console.error(err))
    }
  } */_createClass(CreateRequestPage,[{key:'render',value:function render(){var _props=this.props,requestType=_props.requestType,isCreateNewIssuePending=_props.isCreateNewIssuePending,newIssueKey=_props.newIssueKey;if(!requestType)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Redirect */],{to:{pathname:'/',state:{from:this.props.location}}});if(newIssueKey)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Redirect */],{to:{pathname:'/requests/'+newIssueKey,state:{from:this.props.location}}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["s" /* PageTitle */],{title:'Create'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["q" /* PageHeader */],{title:'Create New '+requestType.title,back:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["m" /* Link */],{to:'/',className:'page-title-back'},'< Home')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index__["f" /* Container */],{section:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__request_forms_DynamicForm__["a" /* default */],{RequestType:requestType,isNew:true,onSubmit:this.submit,actionInProgress:isCreateNewIssuePending,cancel:this.cancel})));}}]);return CreateRequestPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_6__util_index__["e" /* requireLogin */])('Create'),Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{isCreateNewIssuePending:Object(__WEBPACK_IMPORTED_MODULE_6__util_index__["f" /* selectIsRequestPending */])(state,__WEBPACK_IMPORTED_MODULE_9__actions__["d" /* createIssue */]),requestType:Object(__WEBPACK_IMPORTED_MODULE_10__reducer__["h" /* selectRequestType */])(state),user:Object(__WEBPACK_IMPORTED_MODULE_8__auth_reducer__["f" /* selectADUserInfo */])(state),newIssueKey:Object(__WEBPACK_IMPORTED_MODULE_10__reducer__["g" /* selectNewIssueKey */])(state)};},{getRequestType:__WEBPACK_IMPORTED_MODULE_9__actions__["i" /* getRequestType */],createIssue:__WEBPACK_IMPORTED_MODULE_9__actions__["d" /* createIssue */],selectNewIssueKey:__WEBPACK_IMPORTED_MODULE_10__reducer__["g" /* selectNewIssueKey */]}))(CreateRequestPage));

/***/ }),
/* 3375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export validateSchema */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeDefaultItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ajv__ = __webpack_require__(3376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ajv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ajv__);
var ajv=new __WEBPACK_IMPORTED_MODULE_0_ajv___default.a({allErrors:true});var validateSchema=function validateSchema(schema,value){var validate=ajv.compile(schema);var valid=validate(value);return{isValid:valid,errors:validate.errors};};var makeDefaultItem=function makeDefaultItem(){var schema=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var isNestedRequire=arguments[1];var properties=schema.properties,required=schema.required;if(!properties)return{};return Object.keys(properties).reduce(function(result,key){result[key]=properties[key].properties?makeDefaultItem(properties[key],required&&required.includes(key))// May be undefined, but we need to set the value to undefined in that case ;)
:properties[key].default;return result;},{'_include':isNestedRequire||undefined});};

/***/ }),
/* 3376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compileSchema = __webpack_require__(3377)
  , resolve = __webpack_require__(520)
  , Cache = __webpack_require__(3381)
  , SchemaObject = __webpack_require__(1322)
  , stableStringify = __webpack_require__(1323)
  , formats = __webpack_require__(3382)
  , rules = __webpack_require__(3383)
  , $dataMetaSchema = __webpack_require__(3404)
  , util = __webpack_require__(176);

module.exports = Ajv;

Ajv.prototype.validate = validate;
Ajv.prototype.compile = compile;
Ajv.prototype.addSchema = addSchema;
Ajv.prototype.addMetaSchema = addMetaSchema;
Ajv.prototype.validateSchema = validateSchema;
Ajv.prototype.getSchema = getSchema;
Ajv.prototype.removeSchema = removeSchema;
Ajv.prototype.addFormat = addFormat;
Ajv.prototype.errorsText = errorsText;

Ajv.prototype._addSchema = _addSchema;
Ajv.prototype._compile = _compile;

Ajv.prototype.compileAsync = __webpack_require__(3405);
var customKeyword = __webpack_require__(3406);
Ajv.prototype.addKeyword = customKeyword.add;
Ajv.prototype.getKeyword = customKeyword.get;
Ajv.prototype.removeKeyword = customKeyword.remove;
Ajv.prototype.validateKeyword = customKeyword.validate;

var errorClasses = __webpack_require__(522);
Ajv.ValidationError = errorClasses.Validation;
Ajv.MissingRefError = errorClasses.MissingRef;
Ajv.$dataMetaSchema = $dataMetaSchema;

var META_SCHEMA_ID = 'http://json-schema.org/draft-07/schema';

var META_IGNORE_OPTIONS = [ 'removeAdditional', 'useDefaults', 'coerceTypes', 'strictDefaults' ];
var META_SUPPORT_DATA = ['/properties'];

/**
 * Creates validator instance.
 * Usage: `Ajv(opts)`
 * @param {Object} opts optional options
 * @return {Object} ajv instance
 */
function Ajv(opts) {
  if (!(this instanceof Ajv)) return new Ajv(opts);
  opts = this._opts = util.copy(opts) || {};
  setLogger(this);
  this._schemas = {};
  this._refs = {};
  this._fragments = {};
  this._formats = formats(opts.format);

  this._cache = opts.cache || new Cache;
  this._loadingSchemas = {};
  this._compilations = [];
  this.RULES = rules();
  this._getId = chooseGetId(opts);

  opts.loopRequired = opts.loopRequired || Infinity;
  if (opts.errorDataPath == 'property') opts._errorDataPathProperty = true;
  if (opts.serialize === undefined) opts.serialize = stableStringify;
  this._metaOpts = getMetaSchemaOptions(this);

  if (opts.formats) addInitialFormats(this);
  if (opts.keywords) addInitialKeywords(this);
  addDefaultMetaSchema(this);
  if (typeof opts.meta == 'object') this.addMetaSchema(opts.meta);
  if (opts.nullable) this.addKeyword('nullable', {metaSchema: {type: 'boolean'}});
  addInitialSchemas(this);
}



/**
 * Validate data using schema
 * Schema will be compiled and cached (using serialized JSON as key. [fast-json-stable-stringify](https://github.com/epoberezkin/fast-json-stable-stringify) is used to serialize.
 * @this   Ajv
 * @param  {String|Object} schemaKeyRef key, ref or schema object
 * @param  {Any} data to be validated
 * @return {Boolean} validation result. Errors from the last validation will be available in `ajv.errors` (and also in compiled schema: `schema.errors`).
 */
function validate(schemaKeyRef, data) {
  var v;
  if (typeof schemaKeyRef == 'string') {
    v = this.getSchema(schemaKeyRef);
    if (!v) throw new Error('no schema with key or ref "' + schemaKeyRef + '"');
  } else {
    var schemaObj = this._addSchema(schemaKeyRef);
    v = schemaObj.validate || this._compile(schemaObj);
  }

  var valid = v(data);
  if (v.$async !== true) this.errors = v.errors;
  return valid;
}


/**
 * Create validating function for passed schema.
 * @this   Ajv
 * @param  {Object} schema schema object
 * @param  {Boolean} _meta true if schema is a meta-schema. Used internally to compile meta schemas of custom keywords.
 * @return {Function} validating function
 */
function compile(schema, _meta) {
  var schemaObj = this._addSchema(schema, undefined, _meta);
  return schemaObj.validate || this._compile(schemaObj);
}


/**
 * Adds schema to the instance.
 * @this   Ajv
 * @param {Object|Array} schema schema or array of schemas. If array is passed, `key` and other parameters will be ignored.
 * @param {String} key Optional schema key. Can be passed to `validate` method instead of schema object or id/ref. One schema per instance can have empty `id` and `key`.
 * @param {Boolean} _skipValidation true to skip schema validation. Used internally, option validateSchema should be used instead.
 * @param {Boolean} _meta true if schema is a meta-schema. Used internally, addMetaSchema should be used instead.
 * @return {Ajv} this for method chaining
 */
function addSchema(schema, key, _skipValidation, _meta) {
  if (Array.isArray(schema)){
    for (var i=0; i<schema.length; i++) this.addSchema(schema[i], undefined, _skipValidation, _meta);
    return this;
  }
  var id = this._getId(schema);
  if (id !== undefined && typeof id != 'string')
    throw new Error('schema id must be string');
  key = resolve.normalizeId(key || id);
  checkUnique(this, key);
  this._schemas[key] = this._addSchema(schema, _skipValidation, _meta, true);
  return this;
}


/**
 * Add schema that will be used to validate other schemas
 * options in META_IGNORE_OPTIONS are alway set to false
 * @this   Ajv
 * @param {Object} schema schema object
 * @param {String} key optional schema key
 * @param {Boolean} skipValidation true to skip schema validation, can be used to override validateSchema option for meta-schema
 * @return {Ajv} this for method chaining
 */
function addMetaSchema(schema, key, skipValidation) {
  this.addSchema(schema, key, skipValidation, true);
  return this;
}


/**
 * Validate schema
 * @this   Ajv
 * @param {Object} schema schema to validate
 * @param {Boolean} throwOrLogError pass true to throw (or log) an error if invalid
 * @return {Boolean} true if schema is valid
 */
function validateSchema(schema, throwOrLogError) {
  var $schema = schema.$schema;
  if ($schema !== undefined && typeof $schema != 'string')
    throw new Error('$schema must be a string');
  $schema = $schema || this._opts.defaultMeta || defaultMeta(this);
  if (!$schema) {
    this.logger.warn('meta-schema not available');
    this.errors = null;
    return true;
  }
  var valid = this.validate($schema, schema);
  if (!valid && throwOrLogError) {
    var message = 'schema is invalid: ' + this.errorsText();
    if (this._opts.validateSchema == 'log') this.logger.error(message);
    else throw new Error(message);
  }
  return valid;
}


function defaultMeta(self) {
  var meta = self._opts.meta;
  self._opts.defaultMeta = typeof meta == 'object'
                            ? self._getId(meta) || meta
                            : self.getSchema(META_SCHEMA_ID)
                              ? META_SCHEMA_ID
                              : undefined;
  return self._opts.defaultMeta;
}


/**
 * Get compiled schema from the instance by `key` or `ref`.
 * @this   Ajv
 * @param  {String} keyRef `key` that was passed to `addSchema` or full schema reference (`schema.id` or resolved id).
 * @return {Function} schema validating function (with property `schema`).
 */
function getSchema(keyRef) {
  var schemaObj = _getSchemaObj(this, keyRef);
  switch (typeof schemaObj) {
    case 'object': return schemaObj.validate || this._compile(schemaObj);
    case 'string': return this.getSchema(schemaObj);
    case 'undefined': return _getSchemaFragment(this, keyRef);
  }
}


function _getSchemaFragment(self, ref) {
  var res = resolve.schema.call(self, { schema: {} }, ref);
  if (res) {
    var schema = res.schema
      , root = res.root
      , baseId = res.baseId;
    var v = compileSchema.call(self, schema, root, undefined, baseId);
    self._fragments[ref] = new SchemaObject({
      ref: ref,
      fragment: true,
      schema: schema,
      root: root,
      baseId: baseId,
      validate: v
    });
    return v;
  }
}


function _getSchemaObj(self, keyRef) {
  keyRef = resolve.normalizeId(keyRef);
  return self._schemas[keyRef] || self._refs[keyRef] || self._fragments[keyRef];
}


/**
 * Remove cached schema(s).
 * If no parameter is passed all schemas but meta-schemas are removed.
 * If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
 * Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
 * @this   Ajv
 * @param  {String|Object|RegExp} schemaKeyRef key, ref, pattern to match key/ref or schema object
 * @return {Ajv} this for method chaining
 */
function removeSchema(schemaKeyRef) {
  if (schemaKeyRef instanceof RegExp) {
    _removeAllSchemas(this, this._schemas, schemaKeyRef);
    _removeAllSchemas(this, this._refs, schemaKeyRef);
    return this;
  }
  switch (typeof schemaKeyRef) {
    case 'undefined':
      _removeAllSchemas(this, this._schemas);
      _removeAllSchemas(this, this._refs);
      this._cache.clear();
      return this;
    case 'string':
      var schemaObj = _getSchemaObj(this, schemaKeyRef);
      if (schemaObj) this._cache.del(schemaObj.cacheKey);
      delete this._schemas[schemaKeyRef];
      delete this._refs[schemaKeyRef];
      return this;
    case 'object':
      var serialize = this._opts.serialize;
      var cacheKey = serialize ? serialize(schemaKeyRef) : schemaKeyRef;
      this._cache.del(cacheKey);
      var id = this._getId(schemaKeyRef);
      if (id) {
        id = resolve.normalizeId(id);
        delete this._schemas[id];
        delete this._refs[id];
      }
  }
  return this;
}


function _removeAllSchemas(self, schemas, regex) {
  for (var keyRef in schemas) {
    var schemaObj = schemas[keyRef];
    if (!schemaObj.meta && (!regex || regex.test(keyRef))) {
      self._cache.del(schemaObj.cacheKey);
      delete schemas[keyRef];
    }
  }
}


/* @this   Ajv */
function _addSchema(schema, skipValidation, meta, shouldAddSchema) {
  if (typeof schema != 'object' && typeof schema != 'boolean')
    throw new Error('schema should be object or boolean');
  var serialize = this._opts.serialize;
  var cacheKey = serialize ? serialize(schema) : schema;
  var cached = this._cache.get(cacheKey);
  if (cached) return cached;

  shouldAddSchema = shouldAddSchema || this._opts.addUsedSchema !== false;

  var id = resolve.normalizeId(this._getId(schema));
  if (id && shouldAddSchema) checkUnique(this, id);

  var willValidate = this._opts.validateSchema !== false && !skipValidation;
  var recursiveMeta;
  if (willValidate && !(recursiveMeta = id && id == resolve.normalizeId(schema.$schema)))
    this.validateSchema(schema, true);

  var localRefs = resolve.ids.call(this, schema);

  var schemaObj = new SchemaObject({
    id: id,
    schema: schema,
    localRefs: localRefs,
    cacheKey: cacheKey,
    meta: meta
  });

  if (id[0] != '#' && shouldAddSchema) this._refs[id] = schemaObj;
  this._cache.put(cacheKey, schemaObj);

  if (willValidate && recursiveMeta) this.validateSchema(schema, true);

  return schemaObj;
}


/* @this   Ajv */
function _compile(schemaObj, root) {
  if (schemaObj.compiling) {
    schemaObj.validate = callValidate;
    callValidate.schema = schemaObj.schema;
    callValidate.errors = null;
    callValidate.root = root ? root : callValidate;
    if (schemaObj.schema.$async === true)
      callValidate.$async = true;
    return callValidate;
  }
  schemaObj.compiling = true;

  var currentOpts;
  if (schemaObj.meta) {
    currentOpts = this._opts;
    this._opts = this._metaOpts;
  }

  var v;
  try { v = compileSchema.call(this, schemaObj.schema, root, schemaObj.localRefs); }
  catch(e) {
    delete schemaObj.validate;
    throw e;
  }
  finally {
    schemaObj.compiling = false;
    if (schemaObj.meta) this._opts = currentOpts;
  }

  schemaObj.validate = v;
  schemaObj.refs = v.refs;
  schemaObj.refVal = v.refVal;
  schemaObj.root = v.root;
  return v;


  /* @this   {*} - custom context, see passContext option */
  function callValidate() {
    /* jshint validthis: true */
    var _validate = schemaObj.validate;
    var result = _validate.apply(this, arguments);
    callValidate.errors = _validate.errors;
    return result;
  }
}


function chooseGetId(opts) {
  switch (opts.schemaId) {
    case 'auto': return _get$IdOrId;
    case 'id': return _getId;
    default: return _get$Id;
  }
}

/* @this   Ajv */
function _getId(schema) {
  if (schema.$id) this.logger.warn('schema $id ignored', schema.$id);
  return schema.id;
}

/* @this   Ajv */
function _get$Id(schema) {
  if (schema.id) this.logger.warn('schema id ignored', schema.id);
  return schema.$id;
}


function _get$IdOrId(schema) {
  if (schema.$id && schema.id && schema.$id != schema.id)
    throw new Error('schema $id is different from id');
  return schema.$id || schema.id;
}


/**
 * Convert array of error message objects to string
 * @this   Ajv
 * @param  {Array<Object>} errors optional array of validation errors, if not passed errors from the instance are used.
 * @param  {Object} options optional options with properties `separator` and `dataVar`.
 * @return {String} human readable string with all errors descriptions
 */
function errorsText(errors, options) {
  errors = errors || this.errors;
  if (!errors) return 'No errors';
  options = options || {};
  var separator = options.separator === undefined ? ', ' : options.separator;
  var dataVar = options.dataVar === undefined ? 'data' : options.dataVar;

  var text = '';
  for (var i=0; i<errors.length; i++) {
    var e = errors[i];
    if (e) text += dataVar + e.dataPath + ' ' + e.message + separator;
  }
  return text.slice(0, -separator.length);
}


/**
 * Add custom format
 * @this   Ajv
 * @param {String} name format name
 * @param {String|RegExp|Function} format string is converted to RegExp; function should return boolean (true when valid)
 * @return {Ajv} this for method chaining
 */
function addFormat(name, format) {
  if (typeof format == 'string') format = new RegExp(format);
  this._formats[name] = format;
  return this;
}


function addDefaultMetaSchema(self) {
  var $dataSchema;
  if (self._opts.$data) {
    $dataSchema = __webpack_require__(3409);
    self.addMetaSchema($dataSchema, $dataSchema.$id, true);
  }
  if (self._opts.meta === false) return;
  var metaSchema = __webpack_require__(1329);
  if (self._opts.$data) metaSchema = $dataMetaSchema(metaSchema, META_SUPPORT_DATA);
  self.addMetaSchema(metaSchema, META_SCHEMA_ID, true);
  self._refs['http://json-schema.org/schema'] = META_SCHEMA_ID;
}


function addInitialSchemas(self) {
  var optsSchemas = self._opts.schemas;
  if (!optsSchemas) return;
  if (Array.isArray(optsSchemas)) self.addSchema(optsSchemas);
  else for (var key in optsSchemas) self.addSchema(optsSchemas[key], key);
}


function addInitialFormats(self) {
  for (var name in self._opts.formats) {
    var format = self._opts.formats[name];
    self.addFormat(name, format);
  }
}


function addInitialKeywords(self) {
  for (var name in self._opts.keywords) {
    var keyword = self._opts.keywords[name];
    self.addKeyword(name, keyword);
  }
}


function checkUnique(self, id) {
  if (self._schemas[id] || self._refs[id])
    throw new Error('schema with key or id "' + id + '" already exists');
}


function getMetaSchemaOptions(self) {
  var metaOpts = util.copy(self._opts);
  for (var i=0; i<META_IGNORE_OPTIONS.length; i++)
    delete metaOpts[META_IGNORE_OPTIONS[i]];
  return metaOpts;
}


function setLogger(self) {
  var logger = self._opts.logger;
  if (logger === false) {
    self.logger = {log: noop, warn: noop, error: noop};
  } else {
    if (logger === undefined) logger = console;
    if (!(typeof logger == 'object' && logger.log && logger.warn && logger.error))
      throw new Error('logger must implement log, warn and error methods');
    self.logger = logger;
  }
}


function noop() {}


/***/ }),
/* 3377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var resolve = __webpack_require__(520)
  , util = __webpack_require__(176)
  , errorClasses = __webpack_require__(522)
  , stableStringify = __webpack_require__(1323);

var validateGenerator = __webpack_require__(1324);

/**
 * Functions below are used inside compiled validations function
 */

var ucs2length = util.ucs2length;
var equal = __webpack_require__(521);

// this error is thrown by async schemas to return validation errors via exception
var ValidationError = errorClasses.Validation;

module.exports = compile;


/**
 * Compiles schema to validation function
 * @this   Ajv
 * @param  {Object} schema schema object
 * @param  {Object} root object with information about the root schema for this schema
 * @param  {Object} localRefs the hash of local references inside the schema (created by resolve.id), used for inline resolution
 * @param  {String} baseId base ID for IDs in the schema
 * @return {Function} validation function
 */
function compile(schema, root, localRefs, baseId) {
  /* jshint validthis: true, evil: true */
  /* eslint no-shadow: 0 */
  var self = this
    , opts = this._opts
    , refVal = [ undefined ]
    , refs = {}
    , patterns = []
    , patternsHash = {}
    , defaults = []
    , defaultsHash = {}
    , customRules = [];

  function patternCode(i, patterns) {
    var regExpCode = opts.regExp ? 'regExp' : 'new RegExp';
    return 'var pattern' + i + ' = ' + regExpCode + '(' + util.toQuotedString(patterns[i]) + ');';
  }

  root = root || { schema: schema, refVal: refVal, refs: refs };

  var c = checkCompiling.call(this, schema, root, baseId);
  var compilation = this._compilations[c.index];
  if (c.compiling) return (compilation.callValidate = callValidate);

  var formats = this._formats;
  var RULES = this.RULES;

  try {
    var v = localCompile(schema, root, localRefs, baseId);
    compilation.validate = v;
    var cv = compilation.callValidate;
    if (cv) {
      cv.schema = v.schema;
      cv.errors = null;
      cv.refs = v.refs;
      cv.refVal = v.refVal;
      cv.root = v.root;
      cv.$async = v.$async;
      if (opts.sourceCode) cv.source = v.source;
    }
    return v;
  } finally {
    endCompiling.call(this, schema, root, baseId);
  }

  /* @this   {*} - custom context, see passContext option */
  function callValidate() {
    /* jshint validthis: true */
    var validate = compilation.validate;
    var result = validate.apply(this, arguments);
    callValidate.errors = validate.errors;
    return result;
  }

  function localCompile(_schema, _root, localRefs, baseId) {
    var isRoot = !_root || (_root && _root.schema == _schema);
    if (_root.schema != root.schema)
      return compile.call(self, _schema, _root, localRefs, baseId);

    var $async = _schema.$async === true;

    var sourceCode = validateGenerator({
      isTop: true,
      schema: _schema,
      isRoot: isRoot,
      baseId: baseId,
      root: _root,
      schemaPath: '',
      errSchemaPath: '#',
      errorPath: '""',
      MissingRefError: errorClasses.MissingRef,
      RULES: RULES,
      validate: validateGenerator,
      util: util,
      resolve: resolve,
      resolveRef: resolveRef,
      usePattern: usePattern,
      useDefault: useDefault,
      useCustomRule: useCustomRule,
      opts: opts,
      formats: formats,
      logger: self.logger,
      self: self
    });

    sourceCode = vars(refVal, refValCode) + vars(patterns, patternCode)
                   + vars(defaults, defaultCode) + vars(customRules, customRuleCode)
                   + sourceCode;

    if (opts.processCode) sourceCode = opts.processCode(sourceCode, _schema);
    // console.log('\n\n\n *** \n', JSON.stringify(sourceCode));
    var validate;
    try {
      var makeValidate = new Function(
        'self',
        'RULES',
        'formats',
        'root',
        'refVal',
        'defaults',
        'customRules',
        'equal',
        'ucs2length',
        'ValidationError',
        'regExp',
        sourceCode
      );

      validate = makeValidate(
        self,
        RULES,
        formats,
        root,
        refVal,
        defaults,
        customRules,
        equal,
        ucs2length,
        ValidationError,
        opts.regExp
      );

      refVal[0] = validate;
    } catch(e) {
      self.logger.error('Error compiling schema, function code:', sourceCode);
      throw e;
    }

    validate.schema = _schema;
    validate.errors = null;
    validate.refs = refs;
    validate.refVal = refVal;
    validate.root = isRoot ? validate : _root;
    if ($async) validate.$async = true;
    if (opts.sourceCode === true) {
      validate.source = {
        code: sourceCode,
        patterns: patterns,
        defaults: defaults
      };
    }

    return validate;
  }

  function resolveRef(baseId, ref, isRoot) {
    ref = resolve.url(baseId, ref);
    var refIndex = refs[ref];
    var _refVal, refCode;
    if (refIndex !== undefined) {
      _refVal = refVal[refIndex];
      refCode = 'refVal[' + refIndex + ']';
      return resolvedRef(_refVal, refCode);
    }
    if (!isRoot && root.refs) {
      var rootRefId = root.refs[ref];
      if (rootRefId !== undefined) {
        _refVal = root.refVal[rootRefId];
        refCode = addLocalRef(ref, _refVal);
        return resolvedRef(_refVal, refCode);
      }
    }

    refCode = addLocalRef(ref);
    var v = resolve.call(self, localCompile, root, ref);
    if (v === undefined) {
      var localSchema = localRefs && localRefs[ref];
      if (localSchema) {
        v = resolve.inlineRef(localSchema, opts.inlineRefs)
            ? localSchema
            : compile.call(self, localSchema, root, localRefs, baseId);
      }
    }

    if (v === undefined) {
      removeLocalRef(ref);
    } else {
      replaceLocalRef(ref, v);
      return resolvedRef(v, refCode);
    }
  }

  function addLocalRef(ref, v) {
    var refId = refVal.length;
    refVal[refId] = v;
    refs[ref] = refId;
    return 'refVal' + refId;
  }

  function removeLocalRef(ref) {
    delete refs[ref];
  }

  function replaceLocalRef(ref, v) {
    var refId = refs[ref];
    refVal[refId] = v;
  }

  function resolvedRef(refVal, code) {
    return typeof refVal == 'object' || typeof refVal == 'boolean'
            ? { code: code, schema: refVal, inline: true }
            : { code: code, $async: refVal && !!refVal.$async };
  }

  function usePattern(regexStr) {
    var index = patternsHash[regexStr];
    if (index === undefined) {
      index = patternsHash[regexStr] = patterns.length;
      patterns[index] = regexStr;
    }
    return 'pattern' + index;
  }

  function useDefault(value) {
    switch (typeof value) {
      case 'boolean':
      case 'number':
        return '' + value;
      case 'string':
        return util.toQuotedString(value);
      case 'object':
        if (value === null) return 'null';
        var valueStr = stableStringify(value);
        var index = defaultsHash[valueStr];
        if (index === undefined) {
          index = defaultsHash[valueStr] = defaults.length;
          defaults[index] = value;
        }
        return 'default' + index;
    }
  }

  function useCustomRule(rule, schema, parentSchema, it) {
    if (self._opts.validateSchema !== false) {
      var deps = rule.definition.dependencies;
      if (deps && !deps.every(function(keyword) {
        return Object.prototype.hasOwnProperty.call(parentSchema, keyword);
      }))
        throw new Error('parent schema must have all required keywords: ' + deps.join(','));

      var validateSchema = rule.definition.validateSchema;
      if (validateSchema) {
        var valid = validateSchema(schema);
        if (!valid) {
          var message = 'keyword schema is invalid: ' + self.errorsText(validateSchema.errors);
          if (self._opts.validateSchema == 'log') self.logger.error(message);
          else throw new Error(message);
        }
      }
    }

    var compile = rule.definition.compile
      , inline = rule.definition.inline
      , macro = rule.definition.macro;

    var validate;
    if (compile) {
      validate = compile.call(self, schema, parentSchema, it);
    } else if (macro) {
      validate = macro.call(self, schema, parentSchema, it);
      if (opts.validateSchema !== false) self.validateSchema(validate, true);
    } else if (inline) {
      validate = inline.call(self, it, rule.keyword, schema, parentSchema);
    } else {
      validate = rule.definition.validate;
      if (!validate) return;
    }

    if (validate === undefined)
      throw new Error('custom keyword "' + rule.keyword + '"failed to compile');

    var index = customRules.length;
    customRules[index] = validate;

    return {
      code: 'customRule' + index,
      validate: validate
    };
  }
}


/**
 * Checks if the schema is currently compiled
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 * @return {Object} object with properties "index" (compilation index) and "compiling" (boolean)
 */
function checkCompiling(schema, root, baseId) {
  /* jshint validthis: true */
  var index = compIndex.call(this, schema, root, baseId);
  if (index >= 0) return { index: index, compiling: true };
  index = this._compilations.length;
  this._compilations[index] = {
    schema: schema,
    root: root,
    baseId: baseId
  };
  return { index: index, compiling: false };
}


/**
 * Removes the schema from the currently compiled list
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 */
function endCompiling(schema, root, baseId) {
  /* jshint validthis: true */
  var i = compIndex.call(this, schema, root, baseId);
  if (i >= 0) this._compilations.splice(i, 1);
}


/**
 * Index of schema compilation in the currently compiled list
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 * @return {Integer} compilation index
 */
function compIndex(schema, root, baseId) {
  /* jshint validthis: true */
  for (var i=0; i<this._compilations.length; i++) {
    var c = this._compilations[i];
    if (c.schema == schema && c.root == root && c.baseId == baseId) return i;
  }
  return -1;
}


function defaultCode(i) {
  return 'var default' + i + ' = defaults[' + i + '];';
}


function refValCode(i, refVal) {
  return refVal[i] === undefined ? '' : 'var refVal' + i + ' = refVal[' + i + '];';
}


function customRuleCode(i) {
  return 'var customRule' + i + ' = customRules[' + i + '];';
}


function vars(arr, statement) {
  if (!arr.length) return '';
  var code = '';
  for (var i=0; i<arr.length; i++)
    code += statement(i, arr);
  return code;
}


/***/ }),
/* 3378 */
/***/ (function(module, exports, __webpack_require__) {

/** @license URI.js v4.2.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */
(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.URI = global.URI || {})));
}(this, (function (exports) { 'use strict';

function merge() {
    for (var _len = arguments.length, sets = Array(_len), _key = 0; _key < _len; _key++) {
        sets[_key] = arguments[_key];
    }

    if (sets.length > 1) {
        sets[0] = sets[0].slice(0, -1);
        var xl = sets.length - 1;
        for (var x = 1; x < xl; ++x) {
            sets[x] = sets[x].slice(1, -1);
        }
        sets[xl] = sets[xl].slice(1);
        return sets.join('');
    } else {
        return sets[0];
    }
}
function subexp(str) {
    return "(?:" + str + ")";
}
function typeOf(o) {
    return o === undefined ? "undefined" : o === null ? "null" : Object.prototype.toString.call(o).split(" ").pop().split("]").shift().toLowerCase();
}
function toUpperCase(str) {
    return str.toUpperCase();
}
function toArray(obj) {
    return obj !== undefined && obj !== null ? obj instanceof Array ? obj : typeof obj.length !== "number" || obj.split || obj.setInterval || obj.call ? [obj] : Array.prototype.slice.call(obj) : [];
}
function assign(target, source) {
    var obj = target;
    if (source) {
        for (var key in source) {
            obj[key] = source[key];
        }
    }
    return obj;
}

function buildExps(isIRI) {
    var ALPHA$$ = "[A-Za-z]",
        CR$ = "[\\x0D]",
        DIGIT$$ = "[0-9]",
        DQUOTE$$ = "[\\x22]",
        HEXDIG$$ = merge(DIGIT$$, "[A-Fa-f]"),
        //case-insensitive
    LF$$ = "[\\x0A]",
        SP$$ = "[\\x20]",
        PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)),
        //expanded
    GEN_DELIMS$$ = "[\\:\\/\\?\\#\\[\\]\\@]",
        SUB_DELIMS$$ = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]",
        RESERVED$$ = merge(GEN_DELIMS$$, SUB_DELIMS$$),
        UCSCHAR$$ = isIRI ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]",
        //subset, excludes bidi control characters
    IPRIVATE$$ = isIRI ? "[\\uE000-\\uF8FF]" : "[]",
        //subset
    UNRESERVED$$ = merge(ALPHA$$, DIGIT$$, "[\\-\\.\\_\\~]", UCSCHAR$$),
        SCHEME$ = subexp(ALPHA$$ + merge(ALPHA$$, DIGIT$$, "[\\+\\-\\.]") + "*"),
        USERINFO$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]")) + "*"),
        DEC_OCTET$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("[1-9]" + DIGIT$$) + "|" + DIGIT$$),
        DEC_OCTET_RELAXED$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("0?[1-9]" + DIGIT$$) + "|0?0?" + DIGIT$$),
        //relaxed parsing rules
    IPV4ADDRESS$ = subexp(DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$),
        H16$ = subexp(HEXDIG$$ + "{1,4}"),
        LS32$ = subexp(subexp(H16$ + "\\:" + H16$) + "|" + IPV4ADDRESS$),
        IPV6ADDRESS1$ = subexp(subexp(H16$ + "\\:") + "{6}" + LS32$),
        //                           6( h16 ":" ) ls32
    IPV6ADDRESS2$ = subexp("\\:\\:" + subexp(H16$ + "\\:") + "{5}" + LS32$),
        //                      "::" 5( h16 ":" ) ls32
    IPV6ADDRESS3$ = subexp(subexp(H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{4}" + LS32$),
        //[               h16 ] "::" 4( h16 ":" ) ls32
    IPV6ADDRESS4$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,1}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{3}" + LS32$),
        //[ *1( h16 ":" ) h16 ] "::" 3( h16 ":" ) ls32
    IPV6ADDRESS5$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,2}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{2}" + LS32$),
        //[ *2( h16 ":" ) h16 ] "::" 2( h16 ":" ) ls32
    IPV6ADDRESS6$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,3}" + H16$) + "?\\:\\:" + H16$ + "\\:" + LS32$),
        //[ *3( h16 ":" ) h16 ] "::"    h16 ":"   ls32
    IPV6ADDRESS7$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,4}" + H16$) + "?\\:\\:" + LS32$),
        //[ *4( h16 ":" ) h16 ] "::"              ls32
    IPV6ADDRESS8$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,5}" + H16$) + "?\\:\\:" + H16$),
        //[ *5( h16 ":" ) h16 ] "::"              h16
    IPV6ADDRESS9$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,6}" + H16$) + "?\\:\\:"),
        //[ *6( h16 ":" ) h16 ] "::"
    IPV6ADDRESS$ = subexp([IPV6ADDRESS1$, IPV6ADDRESS2$, IPV6ADDRESS3$, IPV6ADDRESS4$, IPV6ADDRESS5$, IPV6ADDRESS6$, IPV6ADDRESS7$, IPV6ADDRESS8$, IPV6ADDRESS9$].join("|")),
        ZONEID$ = subexp(subexp(UNRESERVED$$ + "|" + PCT_ENCODED$) + "+"),
        //RFC 6874
    IPV6ADDRZ$ = subexp(IPV6ADDRESS$ + "\\%25" + ZONEID$),
        //RFC 6874
    IPV6ADDRZ_RELAXED$ = subexp(IPV6ADDRESS$ + subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + ZONEID$),
        //RFC 6874, with relaxed parsing rules
    IPVFUTURE$ = subexp("[vV]" + HEXDIG$$ + "+\\." + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]") + "+"),
        IP_LITERAL$ = subexp("\\[" + subexp(IPV6ADDRZ_RELAXED$ + "|" + IPV6ADDRESS$ + "|" + IPVFUTURE$) + "\\]"),
        //RFC 6874
    REG_NAME$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$)) + "*"),
        HOST$ = subexp(IP_LITERAL$ + "|" + IPV4ADDRESS$ + "(?!" + REG_NAME$ + ")" + "|" + REG_NAME$),
        PORT$ = subexp(DIGIT$$ + "*"),
        AUTHORITY$ = subexp(subexp(USERINFO$ + "@") + "?" + HOST$ + subexp("\\:" + PORT$) + "?"),
        PCHAR$ = subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@]")),
        SEGMENT$ = subexp(PCHAR$ + "*"),
        SEGMENT_NZ$ = subexp(PCHAR$ + "+"),
        SEGMENT_NZ_NC$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\@]")) + "+"),
        PATH_ABEMPTY$ = subexp(subexp("\\/" + SEGMENT$) + "*"),
        PATH_ABSOLUTE$ = subexp("\\/" + subexp(SEGMENT_NZ$ + PATH_ABEMPTY$) + "?"),
        //simplified
    PATH_NOSCHEME$ = subexp(SEGMENT_NZ_NC$ + PATH_ABEMPTY$),
        //simplified
    PATH_ROOTLESS$ = subexp(SEGMENT_NZ$ + PATH_ABEMPTY$),
        //simplified
    PATH_EMPTY$ = "(?!" + PCHAR$ + ")",
        PATH$ = subexp(PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$),
        QUERY$ = subexp(subexp(PCHAR$ + "|" + merge("[\\/\\?]", IPRIVATE$$)) + "*"),
        FRAGMENT$ = subexp(subexp(PCHAR$ + "|[\\/\\?]") + "*"),
        HIER_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$),
        URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"),
        RELATIVE_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$),
        RELATIVE$ = subexp(RELATIVE_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"),
        URI_REFERENCE$ = subexp(URI$ + "|" + RELATIVE$),
        ABSOLUTE_URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?"),
        GENERIC_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$",
        RELATIVE_REF$ = "^(){0}" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$",
        ABSOLUTE_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?$",
        SAMEDOC_REF$ = "^" + subexp("\\#(" + FRAGMENT$ + ")") + "?$",
        AUTHORITY_REF$ = "^" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?$";
    return {
        NOT_SCHEME: new RegExp(merge("[^]", ALPHA$$, DIGIT$$, "[\\+\\-\\.]"), "g"),
        NOT_USERINFO: new RegExp(merge("[^\\%\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
        NOT_HOST: new RegExp(merge("[^\\%\\[\\]\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
        NOT_PATH: new RegExp(merge("[^\\%\\/\\:\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
        NOT_PATH_NOSCHEME: new RegExp(merge("[^\\%\\/\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
        NOT_QUERY: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]", IPRIVATE$$), "g"),
        NOT_FRAGMENT: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]"), "g"),
        ESCAPE: new RegExp(merge("[^]", UNRESERVED$$, SUB_DELIMS$$), "g"),
        UNRESERVED: new RegExp(UNRESERVED$$, "g"),
        OTHER_CHARS: new RegExp(merge("[^\\%]", UNRESERVED$$, RESERVED$$), "g"),
        PCT_ENCODED: new RegExp(PCT_ENCODED$, "g"),
        IPV4ADDRESS: new RegExp("^(" + IPV4ADDRESS$ + ")$"),
        IPV6ADDRESS: new RegExp("^\\[?(" + IPV6ADDRESS$ + ")" + subexp(subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + "(" + ZONEID$ + ")") + "?\\]?$") //RFC 6874, with relaxed parsing rules
    };
}
var URI_PROTOCOL = buildExps(false);

var IRI_PROTOCOL = buildExps(true);

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();













var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/** Highest positive signed 32-bit float value */

var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1

/** Bootstring parameters */
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'

/** Regular expressions */
var regexPunycode = /^xn--/;
var regexNonASCII = /[^\0-\x7E]/; // non-ASCII chars
var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators

/** Error messages */
var errors = {
	'overflow': 'Overflow: input needs wider integers to process',
	'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
	'invalid-input': 'Invalid input'
};

/** Convenience shortcuts */
var baseMinusTMin = base - tMin;
var floor = Math.floor;
var stringFromCharCode = String.fromCharCode;

/*--------------------------------------------------------------------------*/

/**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */
function error$1(type) {
	throw new RangeError(errors[type]);
}

/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */
function map(array, fn) {
	var result = [];
	var length = array.length;
	while (length--) {
		result[length] = fn(array[length]);
	}
	return result;
}

/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {Array} A new string of characters returned by the callback
 * function.
 */
function mapDomain(string, fn) {
	var parts = string.split('@');
	var result = '';
	if (parts.length > 1) {
		// In email addresses, only the domain name should be punycoded. Leave
		// the local part (i.e. everything up to `@`) intact.
		result = parts[0] + '@';
		string = parts[1];
	}
	// Avoid `split(regex)` for IE8 compatibility. See #17.
	string = string.replace(regexSeparators, '\x2E');
	var labels = string.split('.');
	var encoded = map(labels, fn).join('.');
	return result + encoded;
}

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */
function ucs2decode(string) {
	var output = [];
	var counter = 0;
	var length = string.length;
	while (counter < length) {
		var value = string.charCodeAt(counter++);
		if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
			// It's a high surrogate, and there is a next character.
			var extra = string.charCodeAt(counter++);
			if ((extra & 0xFC00) == 0xDC00) {
				// Low surrogate.
				output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
			} else {
				// It's an unmatched surrogate; only append this code unit, in case the
				// next code unit is the high surrogate of a surrogate pair.
				output.push(value);
				counter--;
			}
		} else {
			output.push(value);
		}
	}
	return output;
}

/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */
var ucs2encode = function ucs2encode(array) {
	return String.fromCodePoint.apply(String, toConsumableArray(array));
};

/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */
var basicToDigit = function basicToDigit(codePoint) {
	if (codePoint - 0x30 < 0x0A) {
		return codePoint - 0x16;
	}
	if (codePoint - 0x41 < 0x1A) {
		return codePoint - 0x41;
	}
	if (codePoint - 0x61 < 0x1A) {
		return codePoint - 0x61;
	}
	return base;
};

/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */
var digitToBasic = function digitToBasic(digit, flag) {
	//  0..25 map to ASCII a..z or A..Z
	// 26..35 map to ASCII 0..9
	return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */
var adapt = function adapt(delta, numPoints, firstTime) {
	var k = 0;
	delta = firstTime ? floor(delta / damp) : delta >> 1;
	delta += floor(delta / numPoints);
	for (; /* no initialization */delta > baseMinusTMin * tMax >> 1; k += base) {
		delta = floor(delta / baseMinusTMin);
	}
	return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */
var decode = function decode(input) {
	// Don't use UCS-2.
	var output = [];
	var inputLength = input.length;
	var i = 0;
	var n = initialN;
	var bias = initialBias;

	// Handle the basic code points: let `basic` be the number of input code
	// points before the last delimiter, or `0` if there is none, then copy
	// the first basic code points to the output.

	var basic = input.lastIndexOf(delimiter);
	if (basic < 0) {
		basic = 0;
	}

	for (var j = 0; j < basic; ++j) {
		// if it's not a basic code point
		if (input.charCodeAt(j) >= 0x80) {
			error$1('not-basic');
		}
		output.push(input.charCodeAt(j));
	}

	// Main decoding loop: start just after the last delimiter if any basic code
	// points were copied; start at the beginning otherwise.

	for (var index = basic > 0 ? basic + 1 : 0; index < inputLength;) /* no final expression */{

		// `index` is the index of the next character to be consumed.
		// Decode a generalized variable-length integer into `delta`,
		// which gets added to `i`. The overflow checking is easier
		// if we increase `i` as we go, then subtract off its starting
		// value at the end to obtain `delta`.
		var oldi = i;
		for (var w = 1, k = base;; /* no condition */k += base) {

			if (index >= inputLength) {
				error$1('invalid-input');
			}

			var digit = basicToDigit(input.charCodeAt(index++));

			if (digit >= base || digit > floor((maxInt - i) / w)) {
				error$1('overflow');
			}

			i += digit * w;
			var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;

			if (digit < t) {
				break;
			}

			var baseMinusT = base - t;
			if (w > floor(maxInt / baseMinusT)) {
				error$1('overflow');
			}

			w *= baseMinusT;
		}

		var out = output.length + 1;
		bias = adapt(i - oldi, out, oldi == 0);

		// `i` was supposed to wrap around from `out` to `0`,
		// incrementing `n` each time, so we'll fix that now:
		if (floor(i / out) > maxInt - n) {
			error$1('overflow');
		}

		n += floor(i / out);
		i %= out;

		// Insert `n` at position `i` of the output.
		output.splice(i++, 0, n);
	}

	return String.fromCodePoint.apply(String, output);
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */
var encode = function encode(input) {
	var output = [];

	// Convert the input in UCS-2 to an array of Unicode code points.
	input = ucs2decode(input);

	// Cache the length.
	var inputLength = input.length;

	// Initialize the state.
	var n = initialN;
	var delta = 0;
	var bias = initialBias;

	// Handle the basic code points.
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var _currentValue2 = _step.value;

			if (_currentValue2 < 0x80) {
				output.push(stringFromCharCode(_currentValue2));
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	var basicLength = output.length;
	var handledCPCount = basicLength;

	// `handledCPCount` is the number of code points that have been handled;
	// `basicLength` is the number of basic code points.

	// Finish the basic string with a delimiter unless it's empty.
	if (basicLength) {
		output.push(delimiter);
	}

	// Main encoding loop:
	while (handledCPCount < inputLength) {

		// All non-basic code points < n have been handled already. Find the next
		// larger one:
		var m = maxInt;
		var _iteratorNormalCompletion2 = true;
		var _didIteratorError2 = false;
		var _iteratorError2 = undefined;

		try {
			for (var _iterator2 = input[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
				var currentValue = _step2.value;

				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow.
		} catch (err) {
			_didIteratorError2 = true;
			_iteratorError2 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion2 && _iterator2.return) {
					_iterator2.return();
				}
			} finally {
				if (_didIteratorError2) {
					throw _iteratorError2;
				}
			}
		}

		var handledCPCountPlusOne = handledCPCount + 1;
		if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
			error$1('overflow');
		}

		delta += (m - n) * handledCPCountPlusOne;
		n = m;

		var _iteratorNormalCompletion3 = true;
		var _didIteratorError3 = false;
		var _iteratorError3 = undefined;

		try {
			for (var _iterator3 = input[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
				var _currentValue = _step3.value;

				if (_currentValue < n && ++delta > maxInt) {
					error$1('overflow');
				}
				if (_currentValue == n) {
					// Represent delta as a generalized variable-length integer.
					var q = delta;
					for (var k = base;; /* no condition */k += base) {
						var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
						if (q < t) {
							break;
						}
						var qMinusT = q - t;
						var baseMinusT = base - t;
						output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}
		} catch (err) {
			_didIteratorError3 = true;
			_iteratorError3 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion3 && _iterator3.return) {
					_iterator3.return();
				}
			} finally {
				if (_didIteratorError3) {
					throw _iteratorError3;
				}
			}
		}

		++delta;
		++n;
	}
	return output.join('');
};

/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */
var toUnicode = function toUnicode(input) {
	return mapDomain(input, function (string) {
		return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
	});
};

/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */
var toASCII = function toASCII(input) {
	return mapDomain(input, function (string) {
		return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
	});
};

/*--------------------------------------------------------------------------*/

/** Define the public API */
var punycode = {
	/**
  * A string representing the current Punycode.js version number.
  * @memberOf punycode
  * @type String
  */
	'version': '2.1.0',
	/**
  * An object of methods to convert from JavaScript's internal character
  * representation (UCS-2) to Unicode code points, and back.
  * @see <https://mathiasbynens.be/notes/javascript-encoding>
  * @memberOf punycode
  * @type Object
  */
	'ucs2': {
		'decode': ucs2decode,
		'encode': ucs2encode
	},
	'decode': decode,
	'encode': encode,
	'toASCII': toASCII,
	'toUnicode': toUnicode
};

/**
 * URI.js
 *
 * @fileoverview An RFC 3986 compliant, scheme extendable URI parsing/validating/resolving library for JavaScript.
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/uri-js
 */
/**
 * Copyright 2011 Gary Court. All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are
 * permitted provided that the following conditions are met:
 *
 *    1. Redistributions of source code must retain the above copyright notice, this list of
 *       conditions and the following disclaimer.
 *
 *    2. Redistributions in binary form must reproduce the above copyright notice, this list
 *       of conditions and the following disclaimer in the documentation and/or other materials
 *       provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY GARY COURT ``AS IS'' AND ANY EXPRESS OR IMPLIED
 * WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL GARY COURT OR
 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
 * ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
 * ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * The views and conclusions contained in the software and documentation are those of the
 * authors and should not be interpreted as representing official policies, either expressed
 * or implied, of Gary Court.
 */
var SCHEMES = {};
function pctEncChar(chr) {
    var c = chr.charCodeAt(0);
    var e = void 0;
    if (c < 16) e = "%0" + c.toString(16).toUpperCase();else if (c < 128) e = "%" + c.toString(16).toUpperCase();else if (c < 2048) e = "%" + (c >> 6 | 192).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();else e = "%" + (c >> 12 | 224).toString(16).toUpperCase() + "%" + (c >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
    return e;
}
function pctDecChars(str) {
    var newStr = "";
    var i = 0;
    var il = str.length;
    while (i < il) {
        var c = parseInt(str.substr(i + 1, 2), 16);
        if (c < 128) {
            newStr += String.fromCharCode(c);
            i += 3;
        } else if (c >= 194 && c < 224) {
            if (il - i >= 6) {
                var c2 = parseInt(str.substr(i + 4, 2), 16);
                newStr += String.fromCharCode((c & 31) << 6 | c2 & 63);
            } else {
                newStr += str.substr(i, 6);
            }
            i += 6;
        } else if (c >= 224) {
            if (il - i >= 9) {
                var _c = parseInt(str.substr(i + 4, 2), 16);
                var c3 = parseInt(str.substr(i + 7, 2), 16);
                newStr += String.fromCharCode((c & 15) << 12 | (_c & 63) << 6 | c3 & 63);
            } else {
                newStr += str.substr(i, 9);
            }
            i += 9;
        } else {
            newStr += str.substr(i, 3);
            i += 3;
        }
    }
    return newStr;
}
function _normalizeComponentEncoding(components, protocol) {
    function decodeUnreserved(str) {
        var decStr = pctDecChars(str);
        return !decStr.match(protocol.UNRESERVED) ? str : decStr;
    }
    if (components.scheme) components.scheme = String(components.scheme).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_SCHEME, "");
    if (components.userinfo !== undefined) components.userinfo = String(components.userinfo).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_USERINFO, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
    if (components.host !== undefined) components.host = String(components.host).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_HOST, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
    if (components.path !== undefined) components.path = String(components.path).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(components.scheme ? protocol.NOT_PATH : protocol.NOT_PATH_NOSCHEME, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
    if (components.query !== undefined) components.query = String(components.query).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_QUERY, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
    if (components.fragment !== undefined) components.fragment = String(components.fragment).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_FRAGMENT, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
    return components;
}

function _stripLeadingZeros(str) {
    return str.replace(/^0*(.*)/, "$1") || "0";
}
function _normalizeIPv4(host, protocol) {
    var matches = host.match(protocol.IPV4ADDRESS) || [];

    var _matches = slicedToArray(matches, 2),
        address = _matches[1];

    if (address) {
        return address.split(".").map(_stripLeadingZeros).join(".");
    } else {
        return host;
    }
}
function _normalizeIPv6(host, protocol) {
    var matches = host.match(protocol.IPV6ADDRESS) || [];

    var _matches2 = slicedToArray(matches, 3),
        address = _matches2[1],
        zone = _matches2[2];

    if (address) {
        var _address$toLowerCase$ = address.toLowerCase().split('::').reverse(),
            _address$toLowerCase$2 = slicedToArray(_address$toLowerCase$, 2),
            last = _address$toLowerCase$2[0],
            first = _address$toLowerCase$2[1];

        var firstFields = first ? first.split(":").map(_stripLeadingZeros) : [];
        var lastFields = last.split(":").map(_stripLeadingZeros);
        var isLastFieldIPv4Address = protocol.IPV4ADDRESS.test(lastFields[lastFields.length - 1]);
        var fieldCount = isLastFieldIPv4Address ? 7 : 8;
        var lastFieldsStart = lastFields.length - fieldCount;
        var fields = Array(fieldCount);
        for (var x = 0; x < fieldCount; ++x) {
            fields[x] = firstFields[x] || lastFields[lastFieldsStart + x] || '';
        }
        if (isLastFieldIPv4Address) {
            fields[fieldCount - 1] = _normalizeIPv4(fields[fieldCount - 1], protocol);
        }
        var allZeroFields = fields.reduce(function (acc, field, index) {
            if (!field || field === "0") {
                var lastLongest = acc[acc.length - 1];
                if (lastLongest && lastLongest.index + lastLongest.length === index) {
                    lastLongest.length++;
                } else {
                    acc.push({ index: index, length: 1 });
                }
            }
            return acc;
        }, []);
        var longestZeroFields = allZeroFields.sort(function (a, b) {
            return b.length - a.length;
        })[0];
        var newHost = void 0;
        if (longestZeroFields && longestZeroFields.length > 1) {
            var newFirst = fields.slice(0, longestZeroFields.index);
            var newLast = fields.slice(longestZeroFields.index + longestZeroFields.length);
            newHost = newFirst.join(":") + "::" + newLast.join(":");
        } else {
            newHost = fields.join(":");
        }
        if (zone) {
            newHost += "%" + zone;
        }
        return newHost;
    } else {
        return host;
    }
}
var URI_PARSE = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i;
var NO_MATCH_IS_UNDEFINED = "".match(/(){0}/)[1] === undefined;
function parse(uriString) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var components = {};
    var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
    if (options.reference === "suffix") uriString = (options.scheme ? options.scheme + ":" : "") + "//" + uriString;
    var matches = uriString.match(URI_PARSE);
    if (matches) {
        if (NO_MATCH_IS_UNDEFINED) {
            //store each component
            components.scheme = matches[1];
            components.userinfo = matches[3];
            components.host = matches[4];
            components.port = parseInt(matches[5], 10);
            components.path = matches[6] || "";
            components.query = matches[7];
            components.fragment = matches[8];
            //fix port number
            if (isNaN(components.port)) {
                components.port = matches[5];
            }
        } else {
            //IE FIX for improper RegExp matching
            //store each component
            components.scheme = matches[1] || undefined;
            components.userinfo = uriString.indexOf("@") !== -1 ? matches[3] : undefined;
            components.host = uriString.indexOf("//") !== -1 ? matches[4] : undefined;
            components.port = parseInt(matches[5], 10);
            components.path = matches[6] || "";
            components.query = uriString.indexOf("?") !== -1 ? matches[7] : undefined;
            components.fragment = uriString.indexOf("#") !== -1 ? matches[8] : undefined;
            //fix port number
            if (isNaN(components.port)) {
                components.port = uriString.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? matches[4] : undefined;
            }
        }
        if (components.host) {
            //normalize IP hosts
            components.host = _normalizeIPv6(_normalizeIPv4(components.host, protocol), protocol);
        }
        //determine reference type
        if (components.scheme === undefined && components.userinfo === undefined && components.host === undefined && components.port === undefined && !components.path && components.query === undefined) {
            components.reference = "same-document";
        } else if (components.scheme === undefined) {
            components.reference = "relative";
        } else if (components.fragment === undefined) {
            components.reference = "absolute";
        } else {
            components.reference = "uri";
        }
        //check for reference errors
        if (options.reference && options.reference !== "suffix" && options.reference !== components.reference) {
            components.error = components.error || "URI is not a " + options.reference + " reference.";
        }
        //find scheme handler
        var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
        //check if scheme can't handle IRIs
        if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
            //if host component is a domain name
            if (components.host && (options.domainHost || schemeHandler && schemeHandler.domainHost)) {
                //convert Unicode IDN -> ASCII IDN
                try {
                    components.host = punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase());
                } catch (e) {
                    components.error = components.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
                }
            }
            //convert IRI -> URI
            _normalizeComponentEncoding(components, URI_PROTOCOL);
        } else {
            //normalize encodings
            _normalizeComponentEncoding(components, protocol);
        }
        //perform scheme specific parsing
        if (schemeHandler && schemeHandler.parse) {
            schemeHandler.parse(components, options);
        }
    } else {
        components.error = components.error || "URI can not be parsed.";
    }
    return components;
}

function _recomposeAuthority(components, options) {
    var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
    var uriTokens = [];
    if (components.userinfo !== undefined) {
        uriTokens.push(components.userinfo);
        uriTokens.push("@");
    }
    if (components.host !== undefined) {
        //normalize IP hosts, add brackets and escape zone separator for IPv6
        uriTokens.push(_normalizeIPv6(_normalizeIPv4(String(components.host), protocol), protocol).replace(protocol.IPV6ADDRESS, function (_, $1, $2) {
            return "[" + $1 + ($2 ? "%25" + $2 : "") + "]";
        }));
    }
    if (typeof components.port === "number") {
        uriTokens.push(":");
        uriTokens.push(components.port.toString(10));
    }
    return uriTokens.length ? uriTokens.join("") : undefined;
}

var RDS1 = /^\.\.?\//;
var RDS2 = /^\/\.(\/|$)/;
var RDS3 = /^\/\.\.(\/|$)/;
var RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/;
function removeDotSegments(input) {
    var output = [];
    while (input.length) {
        if (input.match(RDS1)) {
            input = input.replace(RDS1, "");
        } else if (input.match(RDS2)) {
            input = input.replace(RDS2, "/");
        } else if (input.match(RDS3)) {
            input = input.replace(RDS3, "/");
            output.pop();
        } else if (input === "." || input === "..") {
            input = "";
        } else {
            var im = input.match(RDS5);
            if (im) {
                var s = im[0];
                input = input.slice(s.length);
                output.push(s);
            } else {
                throw new Error("Unexpected dot segment condition");
            }
        }
    }
    return output.join("");
}

function serialize(components) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var protocol = options.iri ? IRI_PROTOCOL : URI_PROTOCOL;
    var uriTokens = [];
    //find scheme handler
    var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
    //perform scheme specific serialization
    if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(components, options);
    if (components.host) {
        //if host component is an IPv6 address
        if (protocol.IPV6ADDRESS.test(components.host)) {}
        //TODO: normalize IPv6 address as per RFC 5952

        //if host component is a domain name
        else if (options.domainHost || schemeHandler && schemeHandler.domainHost) {
                //convert IDN via punycode
                try {
                    components.host = !options.iri ? punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase()) : punycode.toUnicode(components.host);
                } catch (e) {
                    components.error = components.error || "Host's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                }
            }
    }
    //normalize encoding
    _normalizeComponentEncoding(components, protocol);
    if (options.reference !== "suffix" && components.scheme) {
        uriTokens.push(components.scheme);
        uriTokens.push(":");
    }
    var authority = _recomposeAuthority(components, options);
    if (authority !== undefined) {
        if (options.reference !== "suffix") {
            uriTokens.push("//");
        }
        uriTokens.push(authority);
        if (components.path && components.path.charAt(0) !== "/") {
            uriTokens.push("/");
        }
    }
    if (components.path !== undefined) {
        var s = components.path;
        if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) {
            s = removeDotSegments(s);
        }
        if (authority === undefined) {
            s = s.replace(/^\/\//, "/%2F"); //don't allow the path to start with "//"
        }
        uriTokens.push(s);
    }
    if (components.query !== undefined) {
        uriTokens.push("?");
        uriTokens.push(components.query);
    }
    if (components.fragment !== undefined) {
        uriTokens.push("#");
        uriTokens.push(components.fragment);
    }
    return uriTokens.join(""); //merge tokens into a string
}

function resolveComponents(base, relative) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var skipNormalization = arguments[3];

    var target = {};
    if (!skipNormalization) {
        base = parse(serialize(base, options), options); //normalize base components
        relative = parse(serialize(relative, options), options); //normalize relative components
    }
    options = options || {};
    if (!options.tolerant && relative.scheme) {
        target.scheme = relative.scheme;
        //target.authority = relative.authority;
        target.userinfo = relative.userinfo;
        target.host = relative.host;
        target.port = relative.port;
        target.path = removeDotSegments(relative.path || "");
        target.query = relative.query;
    } else {
        if (relative.userinfo !== undefined || relative.host !== undefined || relative.port !== undefined) {
            //target.authority = relative.authority;
            target.userinfo = relative.userinfo;
            target.host = relative.host;
            target.port = relative.port;
            target.path = removeDotSegments(relative.path || "");
            target.query = relative.query;
        } else {
            if (!relative.path) {
                target.path = base.path;
                if (relative.query !== undefined) {
                    target.query = relative.query;
                } else {
                    target.query = base.query;
                }
            } else {
                if (relative.path.charAt(0) === "/") {
                    target.path = removeDotSegments(relative.path);
                } else {
                    if ((base.userinfo !== undefined || base.host !== undefined || base.port !== undefined) && !base.path) {
                        target.path = "/" + relative.path;
                    } else if (!base.path) {
                        target.path = relative.path;
                    } else {
                        target.path = base.path.slice(0, base.path.lastIndexOf("/") + 1) + relative.path;
                    }
                    target.path = removeDotSegments(target.path);
                }
                target.query = relative.query;
            }
            //target.authority = base.authority;
            target.userinfo = base.userinfo;
            target.host = base.host;
            target.port = base.port;
        }
        target.scheme = base.scheme;
    }
    target.fragment = relative.fragment;
    return target;
}

function resolve(baseURI, relativeURI, options) {
    var schemelessOptions = assign({ scheme: 'null' }, options);
    return serialize(resolveComponents(parse(baseURI, schemelessOptions), parse(relativeURI, schemelessOptions), schemelessOptions, true), schemelessOptions);
}

function normalize(uri, options) {
    if (typeof uri === "string") {
        uri = serialize(parse(uri, options), options);
    } else if (typeOf(uri) === "object") {
        uri = parse(serialize(uri, options), options);
    }
    return uri;
}

function equal(uriA, uriB, options) {
    if (typeof uriA === "string") {
        uriA = serialize(parse(uriA, options), options);
    } else if (typeOf(uriA) === "object") {
        uriA = serialize(uriA, options);
    }
    if (typeof uriB === "string") {
        uriB = serialize(parse(uriB, options), options);
    } else if (typeOf(uriB) === "object") {
        uriB = serialize(uriB, options);
    }
    return uriA === uriB;
}

function escapeComponent(str, options) {
    return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.ESCAPE : IRI_PROTOCOL.ESCAPE, pctEncChar);
}

function unescapeComponent(str, options) {
    return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.PCT_ENCODED : IRI_PROTOCOL.PCT_ENCODED, pctDecChars);
}

var handler = {
    scheme: "http",
    domainHost: true,
    parse: function parse(components, options) {
        //report missing host
        if (!components.host) {
            components.error = components.error || "HTTP URIs must have a host.";
        }
        return components;
    },
    serialize: function serialize(components, options) {
        //normalize the default port
        if (components.port === (String(components.scheme).toLowerCase() !== "https" ? 80 : 443) || components.port === "") {
            components.port = undefined;
        }
        //normalize the empty path
        if (!components.path) {
            components.path = "/";
        }
        //NOTE: We do not parse query strings for HTTP URIs
        //as WWW Form Url Encoded query strings are part of the HTML4+ spec,
        //and not the HTTP spec.
        return components;
    }
};

var handler$1 = {
    scheme: "https",
    domainHost: handler.domainHost,
    parse: handler.parse,
    serialize: handler.serialize
};

var O = {};
var isIRI = true;
//RFC 3986
var UNRESERVED$$ = "[A-Za-z0-9\\-\\.\\_\\~" + (isIRI ? "\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF" : "") + "]";
var HEXDIG$$ = "[0-9A-Fa-f]"; //case-insensitive
var PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)); //expanded
//RFC 5322, except these symbols as per RFC 6068: @ : / ? # [ ] & ; =
//const ATEXT$$ = "[A-Za-z0-9\\!\\#\\$\\%\\&\\'\\*\\+\\-\\/\\=\\?\\^\\_\\`\\{\\|\\}\\~]";
//const WSP$$ = "[\\x20\\x09]";
//const OBS_QTEXT$$ = "[\\x01-\\x08\\x0B\\x0C\\x0E-\\x1F\\x7F]";  //(%d1-8 / %d11-12 / %d14-31 / %d127)
//const QTEXT$$ = merge("[\\x21\\x23-\\x5B\\x5D-\\x7E]", OBS_QTEXT$$);  //%d33 / %d35-91 / %d93-126 / obs-qtext
//const VCHAR$$ = "[\\x21-\\x7E]";
//const WSP$$ = "[\\x20\\x09]";
//const OBS_QP$ = subexp("\\\\" + merge("[\\x00\\x0D\\x0A]", OBS_QTEXT$$));  //%d0 / CR / LF / obs-qtext
//const FWS$ = subexp(subexp(WSP$$ + "*" + "\\x0D\\x0A") + "?" + WSP$$ + "+");
//const QUOTED_PAIR$ = subexp(subexp("\\\\" + subexp(VCHAR$$ + "|" + WSP$$)) + "|" + OBS_QP$);
//const QUOTED_STRING$ = subexp('\\"' + subexp(FWS$ + "?" + QCONTENT$) + "*" + FWS$ + "?" + '\\"');
var ATEXT$$ = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]";
var QTEXT$$ = "[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]";
var VCHAR$$ = merge(QTEXT$$, "[\\\"\\\\]");
var SOME_DELIMS$$ = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]";
var UNRESERVED = new RegExp(UNRESERVED$$, "g");
var PCT_ENCODED = new RegExp(PCT_ENCODED$, "g");
var NOT_LOCAL_PART = new RegExp(merge("[^]", ATEXT$$, "[\\.]", '[\\"]', VCHAR$$), "g");
var NOT_HFNAME = new RegExp(merge("[^]", UNRESERVED$$, SOME_DELIMS$$), "g");
var NOT_HFVALUE = NOT_HFNAME;
function decodeUnreserved(str) {
    var decStr = pctDecChars(str);
    return !decStr.match(UNRESERVED) ? str : decStr;
}
var handler$2 = {
    scheme: "mailto",
    parse: function parse$$1(components, options) {
        var mailtoComponents = components;
        var to = mailtoComponents.to = mailtoComponents.path ? mailtoComponents.path.split(",") : [];
        mailtoComponents.path = undefined;
        if (mailtoComponents.query) {
            var unknownHeaders = false;
            var headers = {};
            var hfields = mailtoComponents.query.split("&");
            for (var x = 0, xl = hfields.length; x < xl; ++x) {
                var hfield = hfields[x].split("=");
                switch (hfield[0]) {
                    case "to":
                        var toAddrs = hfield[1].split(",");
                        for (var _x = 0, _xl = toAddrs.length; _x < _xl; ++_x) {
                            to.push(toAddrs[_x]);
                        }
                        break;
                    case "subject":
                        mailtoComponents.subject = unescapeComponent(hfield[1], options);
                        break;
                    case "body":
                        mailtoComponents.body = unescapeComponent(hfield[1], options);
                        break;
                    default:
                        unknownHeaders = true;
                        headers[unescapeComponent(hfield[0], options)] = unescapeComponent(hfield[1], options);
                        break;
                }
            }
            if (unknownHeaders) mailtoComponents.headers = headers;
        }
        mailtoComponents.query = undefined;
        for (var _x2 = 0, _xl2 = to.length; _x2 < _xl2; ++_x2) {
            var addr = to[_x2].split("@");
            addr[0] = unescapeComponent(addr[0]);
            if (!options.unicodeSupport) {
                //convert Unicode IDN -> ASCII IDN
                try {
                    addr[1] = punycode.toASCII(unescapeComponent(addr[1], options).toLowerCase());
                } catch (e) {
                    mailtoComponents.error = mailtoComponents.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
                }
            } else {
                addr[1] = unescapeComponent(addr[1], options).toLowerCase();
            }
            to[_x2] = addr.join("@");
        }
        return mailtoComponents;
    },
    serialize: function serialize$$1(mailtoComponents, options) {
        var components = mailtoComponents;
        var to = toArray(mailtoComponents.to);
        if (to) {
            for (var x = 0, xl = to.length; x < xl; ++x) {
                var toAddr = String(to[x]);
                var atIdx = toAddr.lastIndexOf("@");
                var localPart = toAddr.slice(0, atIdx).replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_LOCAL_PART, pctEncChar);
                var domain = toAddr.slice(atIdx + 1);
                //convert IDN via punycode
                try {
                    domain = !options.iri ? punycode.toASCII(unescapeComponent(domain, options).toLowerCase()) : punycode.toUnicode(domain);
                } catch (e) {
                    components.error = components.error || "Email address's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                }
                to[x] = localPart + "@" + domain;
            }
            components.path = to.join(",");
        }
        var headers = mailtoComponents.headers = mailtoComponents.headers || {};
        if (mailtoComponents.subject) headers["subject"] = mailtoComponents.subject;
        if (mailtoComponents.body) headers["body"] = mailtoComponents.body;
        var fields = [];
        for (var name in headers) {
            if (headers[name] !== O[name]) {
                fields.push(name.replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFNAME, pctEncChar) + "=" + headers[name].replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFVALUE, pctEncChar));
            }
        }
        if (fields.length) {
            components.query = fields.join("&");
        }
        return components;
    }
};

var URN_PARSE = /^([^\:]+)\:(.*)/;
//RFC 2141
var handler$3 = {
    scheme: "urn",
    parse: function parse$$1(components, options) {
        var matches = components.path && components.path.match(URN_PARSE);
        var urnComponents = components;
        if (matches) {
            var scheme = options.scheme || urnComponents.scheme || "urn";
            var nid = matches[1].toLowerCase();
            var nss = matches[2];
            var urnScheme = scheme + ":" + (options.nid || nid);
            var schemeHandler = SCHEMES[urnScheme];
            urnComponents.nid = nid;
            urnComponents.nss = nss;
            urnComponents.path = undefined;
            if (schemeHandler) {
                urnComponents = schemeHandler.parse(urnComponents, options);
            }
        } else {
            urnComponents.error = urnComponents.error || "URN can not be parsed.";
        }
        return urnComponents;
    },
    serialize: function serialize$$1(urnComponents, options) {
        var scheme = options.scheme || urnComponents.scheme || "urn";
        var nid = urnComponents.nid;
        var urnScheme = scheme + ":" + (options.nid || nid);
        var schemeHandler = SCHEMES[urnScheme];
        if (schemeHandler) {
            urnComponents = schemeHandler.serialize(urnComponents, options);
        }
        var uriComponents = urnComponents;
        var nss = urnComponents.nss;
        uriComponents.path = (nid || options.nid) + ":" + nss;
        return uriComponents;
    }
};

var UUID = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/;
//RFC 4122
var handler$4 = {
    scheme: "urn:uuid",
    parse: function parse(urnComponents, options) {
        var uuidComponents = urnComponents;
        uuidComponents.uuid = uuidComponents.nss;
        uuidComponents.nss = undefined;
        if (!options.tolerant && (!uuidComponents.uuid || !uuidComponents.uuid.match(UUID))) {
            uuidComponents.error = uuidComponents.error || "UUID is not valid.";
        }
        return uuidComponents;
    },
    serialize: function serialize(uuidComponents, options) {
        var urnComponents = uuidComponents;
        //normalize UUID
        urnComponents.nss = (uuidComponents.uuid || "").toLowerCase();
        return urnComponents;
    }
};

SCHEMES[handler.scheme] = handler;
SCHEMES[handler$1.scheme] = handler$1;
SCHEMES[handler$2.scheme] = handler$2;
SCHEMES[handler$3.scheme] = handler$3;
SCHEMES[handler$4.scheme] = handler$4;

exports.SCHEMES = SCHEMES;
exports.pctEncChar = pctEncChar;
exports.pctDecChars = pctDecChars;
exports.parse = parse;
exports.removeDotSegments = removeDotSegments;
exports.serialize = serialize;
exports.resolveComponents = resolveComponents;
exports.resolve = resolve;
exports.normalize = normalize;
exports.equal = equal;
exports.escapeComponent = escapeComponent;
exports.unescapeComponent = unescapeComponent;

Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=uri.all.js.map


/***/ }),
/* 3379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://mathiasbynens.be/notes/javascript-encoding
// https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
module.exports = function ucs2length(str) {
  var length = 0
    , len = str.length
    , pos = 0
    , value;
  while (pos < len) {
    length++;
    value = str.charCodeAt(pos++);
    if (value >= 0xD800 && value <= 0xDBFF && pos < len) {
      // high surrogate, and there is a next character
      value = str.charCodeAt(pos);
      if ((value & 0xFC00) == 0xDC00) pos++; // low surrogate
    }
  }
  return length;
};


/***/ }),
/* 3380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var traverse = module.exports = function (schema, opts, cb) {
  // Legacy support for v0.3.1 and earlier.
  if (typeof opts == 'function') {
    cb = opts;
    opts = {};
  }

  cb = opts.cb || cb;
  var pre = (typeof cb == 'function') ? cb : cb.pre || function() {};
  var post = cb.post || function() {};

  _traverse(opts, pre, post, schema, '', schema);
};


traverse.keywords = {
  additionalItems: true,
  items: true,
  contains: true,
  additionalProperties: true,
  propertyNames: true,
  not: true
};

traverse.arrayKeywords = {
  items: true,
  allOf: true,
  anyOf: true,
  oneOf: true
};

traverse.propsKeywords = {
  definitions: true,
  properties: true,
  patternProperties: true,
  dependencies: true
};

traverse.skipKeywords = {
  default: true,
  enum: true,
  const: true,
  required: true,
  maximum: true,
  minimum: true,
  exclusiveMaximum: true,
  exclusiveMinimum: true,
  multipleOf: true,
  maxLength: true,
  minLength: true,
  pattern: true,
  format: true,
  maxItems: true,
  minItems: true,
  uniqueItems: true,
  maxProperties: true,
  minProperties: true
};


function _traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
  if (schema && typeof schema == 'object' && !Array.isArray(schema)) {
    pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    for (var key in schema) {
      var sch = schema[key];
      if (Array.isArray(sch)) {
        if (key in traverse.arrayKeywords) {
          for (var i=0; i<sch.length; i++)
            _traverse(opts, pre, post, sch[i], jsonPtr + '/' + key + '/' + i, rootSchema, jsonPtr, key, schema, i);
        }
      } else if (key in traverse.propsKeywords) {
        if (sch && typeof sch == 'object') {
          for (var prop in sch)
            _traverse(opts, pre, post, sch[prop], jsonPtr + '/' + key + '/' + escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
        }
      } else if (key in traverse.keywords || (opts.allKeys && !(key in traverse.skipKeywords))) {
        _traverse(opts, pre, post, sch, jsonPtr + '/' + key, rootSchema, jsonPtr, key, schema);
      }
    }
    post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
  }
}


function escapeJsonPtr(str) {
  return str.replace(/~/g, '~0').replace(/\//g, '~1');
}


/***/ }),
/* 3381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var Cache = module.exports = function Cache() {
  this._cache = {};
};


Cache.prototype.put = function Cache_put(key, value) {
  this._cache[key] = value;
};


Cache.prototype.get = function Cache_get(key) {
  return this._cache[key];
};


Cache.prototype.del = function Cache_del(key) {
  delete this._cache[key];
};


Cache.prototype.clear = function Cache_clear() {
  this._cache = {};
};


/***/ }),
/* 3382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(176);

var DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
var DAYS = [0,31,28,31,30,31,30,31,31,30,31,30,31];
var TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
var HOSTNAME = /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i;
var URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
var URIREF = /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
// uri-template: https://tools.ietf.org/html/rfc6570
var URITEMPLATE = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i;
// For the source: https://gist.github.com/dperini/729294
// For test cases: https://mathiasbynens.be/demo/url-regex
// @todo Delete current URL in favour of the commented out URL rule when this issue is fixed https://github.com/eslint/eslint/issues/7983.
// var URL = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u{00a1}-\u{ffff}0-9]+-)*[a-z\u{00a1}-\u{ffff}0-9]+)(?:\.(?:[a-z\u{00a1}-\u{ffff}0-9]+-)*[a-z\u{00a1}-\u{ffff}0-9]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu;
var URL = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i;
var UUID = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
var JSON_POINTER = /^(?:\/(?:[^~/]|~0|~1)*)*$/;
var JSON_POINTER_URI_FRAGMENT = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i;
var RELATIVE_JSON_POINTER = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;


module.exports = formats;

function formats(mode) {
  mode = mode == 'full' ? 'full' : 'fast';
  return util.copy(formats[mode]);
}


formats.fast = {
  // date: http://tools.ietf.org/html/rfc3339#section-5.6
  date: /^\d\d\d\d-[0-1]\d-[0-3]\d$/,
  // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
  time: /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i,
  'date-time': /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i,
  // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
  uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
  'uri-reference': /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
  'uri-template': URITEMPLATE,
  url: URL,
  // email (sources from jsen validator):
  // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
  // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'willful violation')
  email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
  hostname: HOSTNAME,
  // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
  ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
  // optimized http://stackoverflow.com/questions/53497/regular-expression-that-matches-valid-ipv6-addresses
  ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
  regex: regex,
  // uuid: http://tools.ietf.org/html/rfc4122
  uuid: UUID,
  // JSON-pointer: https://tools.ietf.org/html/rfc6901
  // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
  'json-pointer': JSON_POINTER,
  'json-pointer-uri-fragment': JSON_POINTER_URI_FRAGMENT,
  // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
  'relative-json-pointer': RELATIVE_JSON_POINTER
};


formats.full = {
  date: date,
  time: time,
  'date-time': date_time,
  uri: uri,
  'uri-reference': URIREF,
  'uri-template': URITEMPLATE,
  url: URL,
  email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
  hostname: HOSTNAME,
  ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
  ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
  regex: regex,
  uuid: UUID,
  'json-pointer': JSON_POINTER,
  'json-pointer-uri-fragment': JSON_POINTER_URI_FRAGMENT,
  'relative-json-pointer': RELATIVE_JSON_POINTER
};


function isLeapYear(year) {
  // https://tools.ietf.org/html/rfc3339#appendix-C
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}


function date(str) {
  // full-date from http://tools.ietf.org/html/rfc3339#section-5.6
  var matches = str.match(DATE);
  if (!matches) return false;

  var year = +matches[1];
  var month = +matches[2];
  var day = +matches[3];

  return month >= 1 && month <= 12 && day >= 1 &&
          day <= (month == 2 && isLeapYear(year) ? 29 : DAYS[month]);
}


function time(str, full) {
  var matches = str.match(TIME);
  if (!matches) return false;

  var hour = matches[1];
  var minute = matches[2];
  var second = matches[3];
  var timeZone = matches[5];
  return ((hour <= 23 && minute <= 59 && second <= 59) ||
          (hour == 23 && minute == 59 && second == 60)) &&
         (!full || timeZone);
}


var DATE_TIME_SEPARATOR = /t|\s/i;
function date_time(str) {
  // http://tools.ietf.org/html/rfc3339#section-5.6
  var dateTime = str.split(DATE_TIME_SEPARATOR);
  return dateTime.length == 2 && date(dateTime[0]) && time(dateTime[1], true);
}


var NOT_URI_FRAGMENT = /\/|:/;
function uri(str) {
  // http://jmrware.com/articles/2009/uri_regexp/URI_regex.html + optional protocol + required "."
  return NOT_URI_FRAGMENT.test(str) && URI.test(str);
}


var Z_ANCHOR = /[^\\]\\Z/;
function regex(str) {
  if (Z_ANCHOR.test(str)) return false;
  try {
    new RegExp(str);
    return true;
  } catch(e) {
    return false;
  }
}


/***/ }),
/* 3383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ruleModules = __webpack_require__(3384)
  , toHash = __webpack_require__(176).toHash;

module.exports = function rules() {
  var RULES = [
    { type: 'number',
      rules: [ { 'maximum': ['exclusiveMaximum'] },
               { 'minimum': ['exclusiveMinimum'] }, 'multipleOf', 'format'] },
    { type: 'string',
      rules: [ 'maxLength', 'minLength', 'pattern', 'format' ] },
    { type: 'array',
      rules: [ 'maxItems', 'minItems', 'items', 'contains', 'uniqueItems' ] },
    { type: 'object',
      rules: [ 'maxProperties', 'minProperties', 'required', 'dependencies', 'propertyNames',
               { 'properties': ['additionalProperties', 'patternProperties'] } ] },
    { rules: [ '$ref', 'const', 'enum', 'not', 'anyOf', 'oneOf', 'allOf', 'if' ] }
  ];

  var ALL = [ 'type', '$comment' ];
  var KEYWORDS = [
    '$schema', '$id', 'id', '$data', '$async', 'title',
    'description', 'default', 'definitions',
    'examples', 'readOnly', 'writeOnly',
    'contentMediaType', 'contentEncoding',
    'additionalItems', 'then', 'else'
  ];
  var TYPES = [ 'number', 'integer', 'string', 'array', 'object', 'boolean', 'null' ];
  RULES.all = toHash(ALL);
  RULES.types = toHash(TYPES);

  RULES.forEach(function (group) {
    group.rules = group.rules.map(function (keyword) {
      var implKeywords;
      if (typeof keyword == 'object') {
        var key = Object.keys(keyword)[0];
        implKeywords = keyword[key];
        keyword = key;
        implKeywords.forEach(function (k) {
          ALL.push(k);
          RULES.all[k] = true;
        });
      }
      ALL.push(keyword);
      var rule = RULES.all[keyword] = {
        keyword: keyword,
        code: ruleModules[keyword],
        implements: implKeywords
      };
      return rule;
    });

    RULES.all.$comment = {
      keyword: '$comment',
      code: ruleModules.$comment
    };

    if (group.type) RULES.types[group.type] = group;
  });

  RULES.keywords = toHash(ALL.concat(KEYWORDS));
  RULES.custom = {};

  return RULES;
};


/***/ }),
/* 3384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//all requires must be explicit because browserify won't work with dynamic requires
module.exports = {
  '$ref': __webpack_require__(3385),
  allOf: __webpack_require__(3386),
  anyOf: __webpack_require__(3387),
  '$comment': __webpack_require__(3388),
  const: __webpack_require__(3389),
  contains: __webpack_require__(3390),
  dependencies: __webpack_require__(3391),
  'enum': __webpack_require__(3392),
  format: __webpack_require__(3393),
  'if': __webpack_require__(3394),
  items: __webpack_require__(3395),
  maximum: __webpack_require__(1325),
  minimum: __webpack_require__(1325),
  maxItems: __webpack_require__(1326),
  minItems: __webpack_require__(1326),
  maxLength: __webpack_require__(1327),
  minLength: __webpack_require__(1327),
  maxProperties: __webpack_require__(1328),
  minProperties: __webpack_require__(1328),
  multipleOf: __webpack_require__(3396),
  not: __webpack_require__(3397),
  oneOf: __webpack_require__(3398),
  pattern: __webpack_require__(3399),
  properties: __webpack_require__(3400),
  propertyNames: __webpack_require__(3401),
  required: __webpack_require__(3402),
  uniqueItems: __webpack_require__(3403),
  validate: __webpack_require__(1324)
};


/***/ }),
/* 3385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_ref(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $async, $refCode;
  if ($schema == '#' || $schema == '#/') {
    if (it.isRoot) {
      $async = it.async;
      $refCode = 'validate';
    } else {
      $async = it.root.schema.$async === true;
      $refCode = 'root.refVal[0]';
    }
  } else {
    var $refVal = it.resolveRef(it.baseId, $schema, it.isRoot);
    if ($refVal === undefined) {
      var $message = it.MissingRefError.message(it.baseId, $schema);
      if (it.opts.missingRefs == 'fail') {
        it.logger.error($message);
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ('$ref') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { ref: \'' + (it.util.escapeQuotes($schema)) + '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'can\\\'t resolve reference ' + (it.util.escapeQuotes($schema)) + '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: ' + (it.util.toQuotedString($schema)) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
        if ($breakOnError) {
          out += ' if (false) { ';
        }
      } else if (it.opts.missingRefs == 'ignore') {
        it.logger.warn($message);
        if ($breakOnError) {
          out += ' if (true) { ';
        }
      } else {
        throw new it.MissingRefError(it.baseId, $schema, $message);
      }
    } else if ($refVal.inline) {
      var $it = it.util.copy(it);
      $it.level++;
      var $nextValid = 'valid' + $it.level;
      $it.schema = $refVal.schema;
      $it.schemaPath = '';
      $it.errSchemaPath = $schema;
      var $code = it.validate($it).replace(/validate\.schema/g, $refVal.code);
      out += ' ' + ($code) + ' ';
      if ($breakOnError) {
        out += ' if (' + ($nextValid) + ') { ';
      }
    } else {
      $async = $refVal.$async === true || (it.async && $refVal.$async !== false);
      $refCode = $refVal.code;
    }
  }
  if ($refCode) {
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = '';
    if (it.opts.passContext) {
      out += ' ' + ($refCode) + '.call(this, ';
    } else {
      out += ' ' + ($refCode) + '( ';
    }
    out += ' ' + ($data) + ', (dataPath || \'\')';
    if (it.errorPath != '""') {
      out += ' + ' + (it.errorPath);
    }
    var $parentData = $dataLvl ? 'data' + (($dataLvl - 1) || '') : 'parentData',
      $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : 'parentDataProperty';
    out += ' , ' + ($parentData) + ' , ' + ($parentDataProperty) + ', rootData)  ';
    var __callValidate = out;
    out = $$outStack.pop();
    if ($async) {
      if (!it.async) throw new Error('async schema referenced by sync schema');
      if ($breakOnError) {
        out += ' var ' + ($valid) + '; ';
      }
      out += ' try { await ' + (__callValidate) + '; ';
      if ($breakOnError) {
        out += ' ' + ($valid) + ' = true; ';
      }
      out += ' } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ';
      if ($breakOnError) {
        out += ' ' + ($valid) + ' = false; ';
      }
      out += ' } ';
      if ($breakOnError) {
        out += ' if (' + ($valid) + ') { ';
      }
    } else {
      out += ' if (!' + (__callValidate) + ') { if (vErrors === null) vErrors = ' + ($refCode) + '.errors; else vErrors = vErrors.concat(' + ($refCode) + '.errors); errors = vErrors.length; } ';
      if ($breakOnError) {
        out += ' else { ';
      }
    }
  }
  return out;
}


/***/ }),
/* 3386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_allOf(it, $keyword, $ruleType) {
  var out = ' ';
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $currentBaseId = $it.baseId,
    $allSchemasEmpty = true;
  var arr1 = $schema;
  if (arr1) {
    var $sch, $i = -1,
      l1 = arr1.length - 1;
    while ($i < l1) {
      $sch = arr1[$i += 1];
      if ((it.opts.strictKeywords ? (typeof $sch == 'object' && Object.keys($sch).length > 0) || $sch === false : it.util.schemaHasRules($sch, it.RULES.all))) {
        $allSchemasEmpty = false;
        $it.schema = $sch;
        $it.schemaPath = $schemaPath + '[' + $i + ']';
        $it.errSchemaPath = $errSchemaPath + '/' + $i;
        out += '  ' + (it.validate($it)) + ' ';
        $it.baseId = $currentBaseId;
        if ($breakOnError) {
          out += ' if (' + ($nextValid) + ') { ';
          $closingBraces += '}';
        }
      }
    }
  }
  if ($breakOnError) {
    if ($allSchemasEmpty) {
      out += ' if (true) { ';
    } else {
      out += ' ' + ($closingBraces.slice(0, -1)) + ' ';
    }
  }
  return out;
}


/***/ }),
/* 3387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_anyOf(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $noEmptySchema = $schema.every(function($sch) {
    return (it.opts.strictKeywords ? (typeof $sch == 'object' && Object.keys($sch).length > 0) || $sch === false : it.util.schemaHasRules($sch, it.RULES.all));
  });
  if ($noEmptySchema) {
    var $currentBaseId = $it.baseId;
    out += ' var ' + ($errs) + ' = errors; var ' + ($valid) + ' = false;  ';
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    var arr1 = $schema;
    if (arr1) {
      var $sch, $i = -1,
        l1 = arr1.length - 1;
      while ($i < l1) {
        $sch = arr1[$i += 1];
        $it.schema = $sch;
        $it.schemaPath = $schemaPath + '[' + $i + ']';
        $it.errSchemaPath = $errSchemaPath + '/' + $i;
        out += '  ' + (it.validate($it)) + ' ';
        $it.baseId = $currentBaseId;
        out += ' ' + ($valid) + ' = ' + ($valid) + ' || ' + ($nextValid) + '; if (!' + ($valid) + ') { ';
        $closingBraces += '}';
      }
    }
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += ' ' + ($closingBraces) + ' if (!' + ($valid) + ') {   var err =   '; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ('anyOf') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
      if (it.opts.messages !== false) {
        out += ' , message: \'should match some schema in anyOf\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    if (!it.compositeRule && $breakOnError) {
      /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError(vErrors); ';
      } else {
        out += ' validate.errors = vErrors; return false; ';
      }
    }
    out += ' } else {  errors = ' + ($errs) + '; if (vErrors !== null) { if (' + ($errs) + ') vErrors.length = ' + ($errs) + '; else vErrors = null; } ';
    if (it.opts.allErrors) {
      out += ' } ';
    }
  } else {
    if ($breakOnError) {
      out += ' if (true) { ';
    }
  }
  return out;
}


/***/ }),
/* 3388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_comment(it, $keyword, $ruleType) {
  var out = ' ';
  var $schema = it.schema[$keyword];
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $comment = it.util.toQuotedString($schema);
  if (it.opts.$comment === true) {
    out += ' console.log(' + ($comment) + ');';
  } else if (typeof it.opts.$comment == 'function') {
    out += ' self._opts.$comment(' + ($comment) + ', ' + (it.util.toQuotedString($errSchemaPath)) + ', validate.root.schema);';
  }
  return out;
}


/***/ }),
/* 3389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_const(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  if (!$isData) {
    out += ' var schema' + ($lvl) + ' = validate.schema' + ($schemaPath) + ';';
  }
  out += 'var ' + ($valid) + ' = equal(' + ($data) + ', schema' + ($lvl) + '); if (!' + ($valid) + ') {   ';
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('const') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { allowedValue: schema' + ($lvl) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should be equal to constant\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += ' }';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),
/* 3390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_contains(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $idx = 'i' + $lvl,
    $dataNxt = $it.dataLevel = it.dataLevel + 1,
    $nextData = 'data' + $dataNxt,
    $currentBaseId = it.baseId,
    $nonEmptySchema = (it.opts.strictKeywords ? (typeof $schema == 'object' && Object.keys($schema).length > 0) || $schema === false : it.util.schemaHasRules($schema, it.RULES.all));
  out += 'var ' + ($errs) + ' = errors;var ' + ($valid) + ';';
  if ($nonEmptySchema) {
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    $it.schema = $schema;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    out += ' var ' + ($nextValid) + ' = false; for (var ' + ($idx) + ' = 0; ' + ($idx) + ' < ' + ($data) + '.length; ' + ($idx) + '++) { ';
    $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
    var $passData = $data + '[' + $idx + ']';
    $it.dataPathArr[$dataNxt] = $idx;
    var $code = it.validate($it);
    $it.baseId = $currentBaseId;
    if (it.util.varOccurences($code, $nextData) < 2) {
      out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
    } else {
      out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
    }
    out += ' if (' + ($nextValid) + ') break; }  ';
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += ' ' + ($closingBraces) + ' if (!' + ($nextValid) + ') {';
  } else {
    out += ' if (' + ($data) + '.length == 0) {';
  }
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('contains') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should contain a valid item\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += ' } else { ';
  if ($nonEmptySchema) {
    out += '  errors = ' + ($errs) + '; if (vErrors !== null) { if (' + ($errs) + ') vErrors.length = ' + ($errs) + '; else vErrors = null; } ';
  }
  if (it.opts.allErrors) {
    out += ' } ';
  }
  return out;
}


/***/ }),
/* 3391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_dependencies(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $schemaDeps = {},
    $propertyDeps = {},
    $ownProperties = it.opts.ownProperties;
  for ($property in $schema) {
    if ($property == '__proto__') continue;
    var $sch = $schema[$property];
    var $deps = Array.isArray($sch) ? $propertyDeps : $schemaDeps;
    $deps[$property] = $sch;
  }
  out += 'var ' + ($errs) + ' = errors;';
  var $currentErrorPath = it.errorPath;
  out += 'var missing' + ($lvl) + ';';
  for (var $property in $propertyDeps) {
    $deps = $propertyDeps[$property];
    if ($deps.length) {
      out += ' if ( ' + ($data) + (it.util.getProperty($property)) + ' !== undefined ';
      if ($ownProperties) {
        out += ' && Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($property)) + '\') ';
      }
      if ($breakOnError) {
        out += ' && ( ';
        var arr1 = $deps;
        if (arr1) {
          var $propertyKey, $i = -1,
            l1 = arr1.length - 1;
          while ($i < l1) {
            $propertyKey = arr1[$i += 1];
            if ($i) {
              out += ' || ';
            }
            var $prop = it.util.getProperty($propertyKey),
              $useData = $data + $prop;
            out += ' ( ( ' + ($useData) + ' === undefined ';
            if ($ownProperties) {
              out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
            }
            out += ') && (missing' + ($lvl) + ' = ' + (it.util.toQuotedString(it.opts.jsonPointers ? $propertyKey : $prop)) + ') ) ';
          }
        }
        out += ')) {  ';
        var $propertyPath = 'missing' + $lvl,
          $missingProperty = '\' + ' + $propertyPath + ' + \'';
        if (it.opts._errorDataPathProperty) {
          it.errorPath = it.opts.jsonPointers ? it.util.getPathExpr($currentErrorPath, $propertyPath, true) : $currentErrorPath + ' + ' + $propertyPath;
        }
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ('dependencies') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { property: \'' + (it.util.escapeQuotes($property)) + '\', missingProperty: \'' + ($missingProperty) + '\', depsCount: ' + ($deps.length) + ', deps: \'' + (it.util.escapeQuotes($deps.length == 1 ? $deps[0] : $deps.join(", "))) + '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'should have ';
            if ($deps.length == 1) {
              out += 'property ' + (it.util.escapeQuotes($deps[0]));
            } else {
              out += 'properties ' + (it.util.escapeQuotes($deps.join(", ")));
            }
            out += ' when property ' + (it.util.escapeQuotes($property)) + ' is present\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
      } else {
        out += ' ) { ';
        var arr2 = $deps;
        if (arr2) {
          var $propertyKey, i2 = -1,
            l2 = arr2.length - 1;
          while (i2 < l2) {
            $propertyKey = arr2[i2 += 1];
            var $prop = it.util.getProperty($propertyKey),
              $missingProperty = it.util.escapeQuotes($propertyKey),
              $useData = $data + $prop;
            if (it.opts._errorDataPathProperty) {
              it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
            }
            out += ' if ( ' + ($useData) + ' === undefined ';
            if ($ownProperties) {
              out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
            }
            out += ') {  var err =   '; /* istanbul ignore else */
            if (it.createErrors !== false) {
              out += ' { keyword: \'' + ('dependencies') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { property: \'' + (it.util.escapeQuotes($property)) + '\', missingProperty: \'' + ($missingProperty) + '\', depsCount: ' + ($deps.length) + ', deps: \'' + (it.util.escapeQuotes($deps.length == 1 ? $deps[0] : $deps.join(", "))) + '\' } ';
              if (it.opts.messages !== false) {
                out += ' , message: \'should have ';
                if ($deps.length == 1) {
                  out += 'property ' + (it.util.escapeQuotes($deps[0]));
                } else {
                  out += 'properties ' + (it.util.escapeQuotes($deps.join(", ")));
                }
                out += ' when property ' + (it.util.escapeQuotes($property)) + ' is present\' ';
              }
              if (it.opts.verbose) {
                out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
              }
              out += ' } ';
            } else {
              out += ' {} ';
            }
            out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ';
          }
        }
      }
      out += ' }   ';
      if ($breakOnError) {
        $closingBraces += '}';
        out += ' else { ';
      }
    }
  }
  it.errorPath = $currentErrorPath;
  var $currentBaseId = $it.baseId;
  for (var $property in $schemaDeps) {
    var $sch = $schemaDeps[$property];
    if ((it.opts.strictKeywords ? (typeof $sch == 'object' && Object.keys($sch).length > 0) || $sch === false : it.util.schemaHasRules($sch, it.RULES.all))) {
      out += ' ' + ($nextValid) + ' = true; if ( ' + ($data) + (it.util.getProperty($property)) + ' !== undefined ';
      if ($ownProperties) {
        out += ' && Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($property)) + '\') ';
      }
      out += ') { ';
      $it.schema = $sch;
      $it.schemaPath = $schemaPath + it.util.getProperty($property);
      $it.errSchemaPath = $errSchemaPath + '/' + it.util.escapeFragment($property);
      out += '  ' + (it.validate($it)) + ' ';
      $it.baseId = $currentBaseId;
      out += ' }  ';
      if ($breakOnError) {
        out += ' if (' + ($nextValid) + ') { ';
        $closingBraces += '}';
      }
    }
  }
  if ($breakOnError) {
    out += '   ' + ($closingBraces) + ' if (' + ($errs) + ' == errors) {';
  }
  return out;
}


/***/ }),
/* 3392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_enum(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $i = 'i' + $lvl,
    $vSchema = 'schema' + $lvl;
  if (!$isData) {
    out += ' var ' + ($vSchema) + ' = validate.schema' + ($schemaPath) + ';';
  }
  out += 'var ' + ($valid) + ';';
  if ($isData) {
    out += ' if (schema' + ($lvl) + ' === undefined) ' + ($valid) + ' = true; else if (!Array.isArray(schema' + ($lvl) + ')) ' + ($valid) + ' = false; else {';
  }
  out += '' + ($valid) + ' = false;for (var ' + ($i) + '=0; ' + ($i) + '<' + ($vSchema) + '.length; ' + ($i) + '++) if (equal(' + ($data) + ', ' + ($vSchema) + '[' + ($i) + '])) { ' + ($valid) + ' = true; break; }';
  if ($isData) {
    out += '  }  ';
  }
  out += ' if (!' + ($valid) + ') {   ';
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('enum') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { allowedValues: schema' + ($lvl) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should be equal to one of the allowed values\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += ' }';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),
/* 3393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_format(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  if (it.opts.format === false) {
    if ($breakOnError) {
      out += ' if (true) { ';
    }
    return out;
  }
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $unknownFormats = it.opts.unknownFormats,
    $allowUnknown = Array.isArray($unknownFormats);
  if ($isData) {
    var $format = 'format' + $lvl,
      $isObject = 'isObject' + $lvl,
      $formatType = 'formatType' + $lvl;
    out += ' var ' + ($format) + ' = formats[' + ($schemaValue) + ']; var ' + ($isObject) + ' = typeof ' + ($format) + ' == \'object\' && !(' + ($format) + ' instanceof RegExp) && ' + ($format) + '.validate; var ' + ($formatType) + ' = ' + ($isObject) + ' && ' + ($format) + '.type || \'string\'; if (' + ($isObject) + ') { ';
    if (it.async) {
      out += ' var async' + ($lvl) + ' = ' + ($format) + '.async; ';
    }
    out += ' ' + ($format) + ' = ' + ($format) + '.validate; } if (  ';
    if ($isData) {
      out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'string\') || ';
    }
    out += ' (';
    if ($unknownFormats != 'ignore') {
      out += ' (' + ($schemaValue) + ' && !' + ($format) + ' ';
      if ($allowUnknown) {
        out += ' && self._opts.unknownFormats.indexOf(' + ($schemaValue) + ') == -1 ';
      }
      out += ') || ';
    }
    out += ' (' + ($format) + ' && ' + ($formatType) + ' == \'' + ($ruleType) + '\' && !(typeof ' + ($format) + ' == \'function\' ? ';
    if (it.async) {
      out += ' (async' + ($lvl) + ' ? await ' + ($format) + '(' + ($data) + ') : ' + ($format) + '(' + ($data) + ')) ';
    } else {
      out += ' ' + ($format) + '(' + ($data) + ') ';
    }
    out += ' : ' + ($format) + '.test(' + ($data) + '))))) {';
  } else {
    var $format = it.formats[$schema];
    if (!$format) {
      if ($unknownFormats == 'ignore') {
        it.logger.warn('unknown format "' + $schema + '" ignored in schema at path "' + it.errSchemaPath + '"');
        if ($breakOnError) {
          out += ' if (true) { ';
        }
        return out;
      } else if ($allowUnknown && $unknownFormats.indexOf($schema) >= 0) {
        if ($breakOnError) {
          out += ' if (true) { ';
        }
        return out;
      } else {
        throw new Error('unknown format "' + $schema + '" is used in schema at path "' + it.errSchemaPath + '"');
      }
    }
    var $isObject = typeof $format == 'object' && !($format instanceof RegExp) && $format.validate;
    var $formatType = $isObject && $format.type || 'string';
    if ($isObject) {
      var $async = $format.async === true;
      $format = $format.validate;
    }
    if ($formatType != $ruleType) {
      if ($breakOnError) {
        out += ' if (true) { ';
      }
      return out;
    }
    if ($async) {
      if (!it.async) throw new Error('async format in sync schema');
      var $formatRef = 'formats' + it.util.getProperty($schema) + '.validate';
      out += ' if (!(await ' + ($formatRef) + '(' + ($data) + '))) { ';
    } else {
      out += ' if (! ';
      var $formatRef = 'formats' + it.util.getProperty($schema);
      if ($isObject) $formatRef += '.validate';
      if (typeof $format == 'function') {
        out += ' ' + ($formatRef) + '(' + ($data) + ') ';
      } else {
        out += ' ' + ($formatRef) + '.test(' + ($data) + ') ';
      }
      out += ') { ';
    }
  }
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('format') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { format:  ';
    if ($isData) {
      out += '' + ($schemaValue);
    } else {
      out += '' + (it.util.toQuotedString($schema));
    }
    out += '  } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should match format "';
      if ($isData) {
        out += '\' + ' + ($schemaValue) + ' + \'';
      } else {
        out += '' + (it.util.escapeQuotes($schema));
      }
      out += '"\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + (it.util.toQuotedString($schema));
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += ' } ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),
/* 3394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_if(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $thenSch = it.schema['then'],
    $elseSch = it.schema['else'],
    $thenPresent = $thenSch !== undefined && (it.opts.strictKeywords ? (typeof $thenSch == 'object' && Object.keys($thenSch).length > 0) || $thenSch === false : it.util.schemaHasRules($thenSch, it.RULES.all)),
    $elsePresent = $elseSch !== undefined && (it.opts.strictKeywords ? (typeof $elseSch == 'object' && Object.keys($elseSch).length > 0) || $elseSch === false : it.util.schemaHasRules($elseSch, it.RULES.all)),
    $currentBaseId = $it.baseId;
  if ($thenPresent || $elsePresent) {
    var $ifClause;
    $it.createErrors = false;
    $it.schema = $schema;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    out += ' var ' + ($errs) + ' = errors; var ' + ($valid) + ' = true;  ';
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    out += '  ' + (it.validate($it)) + ' ';
    $it.baseId = $currentBaseId;
    $it.createErrors = true;
    out += '  errors = ' + ($errs) + '; if (vErrors !== null) { if (' + ($errs) + ') vErrors.length = ' + ($errs) + '; else vErrors = null; }  ';
    it.compositeRule = $it.compositeRule = $wasComposite;
    if ($thenPresent) {
      out += ' if (' + ($nextValid) + ') {  ';
      $it.schema = it.schema['then'];
      $it.schemaPath = it.schemaPath + '.then';
      $it.errSchemaPath = it.errSchemaPath + '/then';
      out += '  ' + (it.validate($it)) + ' ';
      $it.baseId = $currentBaseId;
      out += ' ' + ($valid) + ' = ' + ($nextValid) + '; ';
      if ($thenPresent && $elsePresent) {
        $ifClause = 'ifClause' + $lvl;
        out += ' var ' + ($ifClause) + ' = \'then\'; ';
      } else {
        $ifClause = '\'then\'';
      }
      out += ' } ';
      if ($elsePresent) {
        out += ' else { ';
      }
    } else {
      out += ' if (!' + ($nextValid) + ') { ';
    }
    if ($elsePresent) {
      $it.schema = it.schema['else'];
      $it.schemaPath = it.schemaPath + '.else';
      $it.errSchemaPath = it.errSchemaPath + '/else';
      out += '  ' + (it.validate($it)) + ' ';
      $it.baseId = $currentBaseId;
      out += ' ' + ($valid) + ' = ' + ($nextValid) + '; ';
      if ($thenPresent && $elsePresent) {
        $ifClause = 'ifClause' + $lvl;
        out += ' var ' + ($ifClause) + ' = \'else\'; ';
      } else {
        $ifClause = '\'else\'';
      }
      out += ' } ';
    }
    out += ' if (!' + ($valid) + ') {   var err =   '; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ('if') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { failingKeyword: ' + ($ifClause) + ' } ';
      if (it.opts.messages !== false) {
        out += ' , message: \'should match "\' + ' + ($ifClause) + ' + \'" schema\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    if (!it.compositeRule && $breakOnError) {
      /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError(vErrors); ';
      } else {
        out += ' validate.errors = vErrors; return false; ';
      }
    }
    out += ' }   ';
    if ($breakOnError) {
      out += ' else { ';
    }
  } else {
    if ($breakOnError) {
      out += ' if (true) { ';
    }
  }
  return out;
}


/***/ }),
/* 3395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_items(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $idx = 'i' + $lvl,
    $dataNxt = $it.dataLevel = it.dataLevel + 1,
    $nextData = 'data' + $dataNxt,
    $currentBaseId = it.baseId;
  out += 'var ' + ($errs) + ' = errors;var ' + ($valid) + ';';
  if (Array.isArray($schema)) {
    var $additionalItems = it.schema.additionalItems;
    if ($additionalItems === false) {
      out += ' ' + ($valid) + ' = ' + ($data) + '.length <= ' + ($schema.length) + '; ';
      var $currErrSchemaPath = $errSchemaPath;
      $errSchemaPath = it.errSchemaPath + '/additionalItems';
      out += '  if (!' + ($valid) + ') {   ';
      var $$outStack = $$outStack || [];
      $$outStack.push(out);
      out = ''; /* istanbul ignore else */
      if (it.createErrors !== false) {
        out += ' { keyword: \'' + ('additionalItems') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { limit: ' + ($schema.length) + ' } ';
        if (it.opts.messages !== false) {
          out += ' , message: \'should NOT have more than ' + ($schema.length) + ' items\' ';
        }
        if (it.opts.verbose) {
          out += ' , schema: false , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
        }
        out += ' } ';
      } else {
        out += ' {} ';
      }
      var __err = out;
      out = $$outStack.pop();
      if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */
        if (it.async) {
          out += ' throw new ValidationError([' + (__err) + ']); ';
        } else {
          out += ' validate.errors = [' + (__err) + ']; return false; ';
        }
      } else {
        out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
      }
      out += ' } ';
      $errSchemaPath = $currErrSchemaPath;
      if ($breakOnError) {
        $closingBraces += '}';
        out += ' else { ';
      }
    }
    var arr1 = $schema;
    if (arr1) {
      var $sch, $i = -1,
        l1 = arr1.length - 1;
      while ($i < l1) {
        $sch = arr1[$i += 1];
        if ((it.opts.strictKeywords ? (typeof $sch == 'object' && Object.keys($sch).length > 0) || $sch === false : it.util.schemaHasRules($sch, it.RULES.all))) {
          out += ' ' + ($nextValid) + ' = true; if (' + ($data) + '.length > ' + ($i) + ') { ';
          var $passData = $data + '[' + $i + ']';
          $it.schema = $sch;
          $it.schemaPath = $schemaPath + '[' + $i + ']';
          $it.errSchemaPath = $errSchemaPath + '/' + $i;
          $it.errorPath = it.util.getPathExpr(it.errorPath, $i, it.opts.jsonPointers, true);
          $it.dataPathArr[$dataNxt] = $i;
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
          } else {
            out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
          }
          out += ' }  ';
          if ($breakOnError) {
            out += ' if (' + ($nextValid) + ') { ';
            $closingBraces += '}';
          }
        }
      }
    }
    if (typeof $additionalItems == 'object' && (it.opts.strictKeywords ? (typeof $additionalItems == 'object' && Object.keys($additionalItems).length > 0) || $additionalItems === false : it.util.schemaHasRules($additionalItems, it.RULES.all))) {
      $it.schema = $additionalItems;
      $it.schemaPath = it.schemaPath + '.additionalItems';
      $it.errSchemaPath = it.errSchemaPath + '/additionalItems';
      out += ' ' + ($nextValid) + ' = true; if (' + ($data) + '.length > ' + ($schema.length) + ') {  for (var ' + ($idx) + ' = ' + ($schema.length) + '; ' + ($idx) + ' < ' + ($data) + '.length; ' + ($idx) + '++) { ';
      $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
      var $passData = $data + '[' + $idx + ']';
      $it.dataPathArr[$dataNxt] = $idx;
      var $code = it.validate($it);
      $it.baseId = $currentBaseId;
      if (it.util.varOccurences($code, $nextData) < 2) {
        out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
      } else {
        out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
      }
      if ($breakOnError) {
        out += ' if (!' + ($nextValid) + ') break; ';
      }
      out += ' } }  ';
      if ($breakOnError) {
        out += ' if (' + ($nextValid) + ') { ';
        $closingBraces += '}';
      }
    }
  } else if ((it.opts.strictKeywords ? (typeof $schema == 'object' && Object.keys($schema).length > 0) || $schema === false : it.util.schemaHasRules($schema, it.RULES.all))) {
    $it.schema = $schema;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    out += '  for (var ' + ($idx) + ' = ' + (0) + '; ' + ($idx) + ' < ' + ($data) + '.length; ' + ($idx) + '++) { ';
    $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
    var $passData = $data + '[' + $idx + ']';
    $it.dataPathArr[$dataNxt] = $idx;
    var $code = it.validate($it);
    $it.baseId = $currentBaseId;
    if (it.util.varOccurences($code, $nextData) < 2) {
      out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
    } else {
      out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
    }
    if ($breakOnError) {
      out += ' if (!' + ($nextValid) + ') break; ';
    }
    out += ' }';
  }
  if ($breakOnError) {
    out += ' ' + ($closingBraces) + ' if (' + ($errs) + ' == errors) {';
  }
  return out;
}


/***/ }),
/* 3396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_multipleOf(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  if (!($isData || typeof $schema == 'number')) {
    throw new Error($keyword + ' must be number');
  }
  out += 'var division' + ($lvl) + ';if (';
  if ($isData) {
    out += ' ' + ($schemaValue) + ' !== undefined && ( typeof ' + ($schemaValue) + ' != \'number\' || ';
  }
  out += ' (division' + ($lvl) + ' = ' + ($data) + ' / ' + ($schemaValue) + ', ';
  if (it.opts.multipleOfPrecision) {
    out += ' Math.abs(Math.round(division' + ($lvl) + ') - division' + ($lvl) + ') > 1e-' + (it.opts.multipleOfPrecision) + ' ';
  } else {
    out += ' division' + ($lvl) + ' !== parseInt(division' + ($lvl) + ') ';
  }
  out += ' ) ';
  if ($isData) {
    out += '  )  ';
  }
  out += ' ) {   ';
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('multipleOf') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { multipleOf: ' + ($schemaValue) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should be multiple of ';
      if ($isData) {
        out += '\' + ' + ($schemaValue);
      } else {
        out += '' + ($schemaValue) + '\'';
      }
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + ($schema);
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += '} ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),
/* 3397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_not(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  if ((it.opts.strictKeywords ? (typeof $schema == 'object' && Object.keys($schema).length > 0) || $schema === false : it.util.schemaHasRules($schema, it.RULES.all))) {
    $it.schema = $schema;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    out += ' var ' + ($errs) + ' = errors;  ';
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    $it.createErrors = false;
    var $allErrorsOption;
    if ($it.opts.allErrors) {
      $allErrorsOption = $it.opts.allErrors;
      $it.opts.allErrors = false;
    }
    out += ' ' + (it.validate($it)) + ' ';
    $it.createErrors = true;
    if ($allErrorsOption) $it.opts.allErrors = $allErrorsOption;
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += ' if (' + ($nextValid) + ') {   ';
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ('not') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
      if (it.opts.messages !== false) {
        out += ' , message: \'should NOT be valid\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
      /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError([' + (__err) + ']); ';
      } else {
        out += ' validate.errors = [' + (__err) + ']; return false; ';
      }
    } else {
      out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    }
    out += ' } else {  errors = ' + ($errs) + '; if (vErrors !== null) { if (' + ($errs) + ') vErrors.length = ' + ($errs) + '; else vErrors = null; } ';
    if (it.opts.allErrors) {
      out += ' } ';
    }
  } else {
    out += '  var err =   '; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ('not') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
      if (it.opts.messages !== false) {
        out += ' , message: \'should NOT be valid\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    if ($breakOnError) {
      out += ' if (false) { ';
    }
  }
  return out;
}


/***/ }),
/* 3398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_oneOf(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $currentBaseId = $it.baseId,
    $prevValid = 'prevValid' + $lvl,
    $passingSchemas = 'passingSchemas' + $lvl;
  out += 'var ' + ($errs) + ' = errors , ' + ($prevValid) + ' = false , ' + ($valid) + ' = false , ' + ($passingSchemas) + ' = null; ';
  var $wasComposite = it.compositeRule;
  it.compositeRule = $it.compositeRule = true;
  var arr1 = $schema;
  if (arr1) {
    var $sch, $i = -1,
      l1 = arr1.length - 1;
    while ($i < l1) {
      $sch = arr1[$i += 1];
      if ((it.opts.strictKeywords ? (typeof $sch == 'object' && Object.keys($sch).length > 0) || $sch === false : it.util.schemaHasRules($sch, it.RULES.all))) {
        $it.schema = $sch;
        $it.schemaPath = $schemaPath + '[' + $i + ']';
        $it.errSchemaPath = $errSchemaPath + '/' + $i;
        out += '  ' + (it.validate($it)) + ' ';
        $it.baseId = $currentBaseId;
      } else {
        out += ' var ' + ($nextValid) + ' = true; ';
      }
      if ($i) {
        out += ' if (' + ($nextValid) + ' && ' + ($prevValid) + ') { ' + ($valid) + ' = false; ' + ($passingSchemas) + ' = [' + ($passingSchemas) + ', ' + ($i) + ']; } else { ';
        $closingBraces += '}';
      }
      out += ' if (' + ($nextValid) + ') { ' + ($valid) + ' = ' + ($prevValid) + ' = true; ' + ($passingSchemas) + ' = ' + ($i) + '; }';
    }
  }
  it.compositeRule = $it.compositeRule = $wasComposite;
  out += '' + ($closingBraces) + 'if (!' + ($valid) + ') {   var err =   '; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('oneOf') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { passingSchemas: ' + ($passingSchemas) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should match exactly one schema in oneOf\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError(vErrors); ';
    } else {
      out += ' validate.errors = vErrors; return false; ';
    }
  }
  out += '} else {  errors = ' + ($errs) + '; if (vErrors !== null) { if (' + ($errs) + ') vErrors.length = ' + ($errs) + '; else vErrors = null; }';
  if (it.opts.allErrors) {
    out += ' } ';
  }
  return out;
}


/***/ }),
/* 3399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_pattern(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $regExpCode = it.opts.regExp ? 'regExp' : 'new RegExp';
  if ($isData) {
    out += ' var ' + ($valid) + ' = true; try { ' + ($valid) + ' = ' + ($regExpCode) + '(' + ($schemaValue) + ').test(' + ($data) + '); } catch(e) { ' + ($valid) + ' = false; } if ( ';
    if ($isData) {
      out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'string\') || ';
    }
    out += ' !' + ($valid) + ') {';
  } else {
    var $regexp = it.usePattern($schema);
    out += ' if ( ';
    if ($isData) {
      out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'string\') || ';
    }
    out += ' !' + ($regexp) + '.test(' + ($data) + ') ) {';
  }
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('pattern') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { pattern:  ';
    if ($isData) {
      out += '' + ($schemaValue);
    } else {
      out += '' + (it.util.toQuotedString($schema));
    }
    out += '  } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should match pattern "';
      if ($isData) {
        out += '\' + ' + ($schemaValue) + ' + \'';
      } else {
        out += '' + (it.util.escapeQuotes($schema));
      }
      out += '"\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + (it.util.toQuotedString($schema));
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += '} ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),
/* 3400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_properties(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $key = 'key' + $lvl,
    $idx = 'idx' + $lvl,
    $dataNxt = $it.dataLevel = it.dataLevel + 1,
    $nextData = 'data' + $dataNxt,
    $dataProperties = 'dataProperties' + $lvl;
  var $schemaKeys = Object.keys($schema || {}).filter(notProto),
    $pProperties = it.schema.patternProperties || {},
    $pPropertyKeys = Object.keys($pProperties).filter(notProto),
    $aProperties = it.schema.additionalProperties,
    $someProperties = $schemaKeys.length || $pPropertyKeys.length,
    $noAdditional = $aProperties === false,
    $additionalIsSchema = typeof $aProperties == 'object' && Object.keys($aProperties).length,
    $removeAdditional = it.opts.removeAdditional,
    $checkAdditional = $noAdditional || $additionalIsSchema || $removeAdditional,
    $ownProperties = it.opts.ownProperties,
    $currentBaseId = it.baseId;
  var $required = it.schema.required;
  if ($required && !(it.opts.$data && $required.$data) && $required.length < it.opts.loopRequired) {
    var $requiredHash = it.util.toHash($required);
  }

  function notProto(p) {
    return p !== '__proto__';
  }
  out += 'var ' + ($errs) + ' = errors;var ' + ($nextValid) + ' = true;';
  if ($ownProperties) {
    out += ' var ' + ($dataProperties) + ' = undefined;';
  }
  if ($checkAdditional) {
    if ($ownProperties) {
      out += ' ' + ($dataProperties) + ' = ' + ($dataProperties) + ' || Object.keys(' + ($data) + '); for (var ' + ($idx) + '=0; ' + ($idx) + '<' + ($dataProperties) + '.length; ' + ($idx) + '++) { var ' + ($key) + ' = ' + ($dataProperties) + '[' + ($idx) + ']; ';
    } else {
      out += ' for (var ' + ($key) + ' in ' + ($data) + ') { ';
    }
    if ($someProperties) {
      out += ' var isAdditional' + ($lvl) + ' = !(false ';
      if ($schemaKeys.length) {
        if ($schemaKeys.length > 8) {
          out += ' || validate.schema' + ($schemaPath) + '.hasOwnProperty(' + ($key) + ') ';
        } else {
          var arr1 = $schemaKeys;
          if (arr1) {
            var $propertyKey, i1 = -1,
              l1 = arr1.length - 1;
            while (i1 < l1) {
              $propertyKey = arr1[i1 += 1];
              out += ' || ' + ($key) + ' == ' + (it.util.toQuotedString($propertyKey)) + ' ';
            }
          }
        }
      }
      if ($pPropertyKeys.length) {
        var arr2 = $pPropertyKeys;
        if (arr2) {
          var $pProperty, $i = -1,
            l2 = arr2.length - 1;
          while ($i < l2) {
            $pProperty = arr2[$i += 1];
            out += ' || ' + (it.usePattern($pProperty)) + '.test(' + ($key) + ') ';
          }
        }
      }
      out += ' ); if (isAdditional' + ($lvl) + ') { ';
    }
    if ($removeAdditional == 'all') {
      out += ' delete ' + ($data) + '[' + ($key) + ']; ';
    } else {
      var $currentErrorPath = it.errorPath;
      var $additionalProperty = '\' + ' + $key + ' + \'';
      if (it.opts._errorDataPathProperty) {
        it.errorPath = it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
      }
      if ($noAdditional) {
        if ($removeAdditional) {
          out += ' delete ' + ($data) + '[' + ($key) + ']; ';
        } else {
          out += ' ' + ($nextValid) + ' = false; ';
          var $currErrSchemaPath = $errSchemaPath;
          $errSchemaPath = it.errSchemaPath + '/additionalProperties';
          var $$outStack = $$outStack || [];
          $$outStack.push(out);
          out = ''; /* istanbul ignore else */
          if (it.createErrors !== false) {
            out += ' { keyword: \'' + ('additionalProperties') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { additionalProperty: \'' + ($additionalProperty) + '\' } ';
            if (it.opts.messages !== false) {
              out += ' , message: \'';
              if (it.opts._errorDataPathProperty) {
                out += 'is an invalid additional property';
              } else {
                out += 'should NOT have additional properties';
              }
              out += '\' ';
            }
            if (it.opts.verbose) {
              out += ' , schema: false , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
            }
            out += ' } ';
          } else {
            out += ' {} ';
          }
          var __err = out;
          out = $$outStack.pop();
          if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */
            if (it.async) {
              out += ' throw new ValidationError([' + (__err) + ']); ';
            } else {
              out += ' validate.errors = [' + (__err) + ']; return false; ';
            }
          } else {
            out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
          }
          $errSchemaPath = $currErrSchemaPath;
          if ($breakOnError) {
            out += ' break; ';
          }
        }
      } else if ($additionalIsSchema) {
        if ($removeAdditional == 'failing') {
          out += ' var ' + ($errs) + ' = errors;  ';
          var $wasComposite = it.compositeRule;
          it.compositeRule = $it.compositeRule = true;
          $it.schema = $aProperties;
          $it.schemaPath = it.schemaPath + '.additionalProperties';
          $it.errSchemaPath = it.errSchemaPath + '/additionalProperties';
          $it.errorPath = it.opts._errorDataPathProperty ? it.errorPath : it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
          var $passData = $data + '[' + $key + ']';
          $it.dataPathArr[$dataNxt] = $key;
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
          } else {
            out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
          }
          out += ' if (!' + ($nextValid) + ') { errors = ' + ($errs) + '; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete ' + ($data) + '[' + ($key) + ']; }  ';
          it.compositeRule = $it.compositeRule = $wasComposite;
        } else {
          $it.schema = $aProperties;
          $it.schemaPath = it.schemaPath + '.additionalProperties';
          $it.errSchemaPath = it.errSchemaPath + '/additionalProperties';
          $it.errorPath = it.opts._errorDataPathProperty ? it.errorPath : it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
          var $passData = $data + '[' + $key + ']';
          $it.dataPathArr[$dataNxt] = $key;
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
          } else {
            out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
          }
          if ($breakOnError) {
            out += ' if (!' + ($nextValid) + ') break; ';
          }
        }
      }
      it.errorPath = $currentErrorPath;
    }
    if ($someProperties) {
      out += ' } ';
    }
    out += ' }  ';
    if ($breakOnError) {
      out += ' if (' + ($nextValid) + ') { ';
      $closingBraces += '}';
    }
  }
  var $useDefaults = it.opts.useDefaults && !it.compositeRule;
  if ($schemaKeys.length) {
    var arr3 = $schemaKeys;
    if (arr3) {
      var $propertyKey, i3 = -1,
        l3 = arr3.length - 1;
      while (i3 < l3) {
        $propertyKey = arr3[i3 += 1];
        var $sch = $schema[$propertyKey];
        if ((it.opts.strictKeywords ? (typeof $sch == 'object' && Object.keys($sch).length > 0) || $sch === false : it.util.schemaHasRules($sch, it.RULES.all))) {
          var $prop = it.util.getProperty($propertyKey),
            $passData = $data + $prop,
            $hasDefault = $useDefaults && $sch.default !== undefined;
          $it.schema = $sch;
          $it.schemaPath = $schemaPath + $prop;
          $it.errSchemaPath = $errSchemaPath + '/' + it.util.escapeFragment($propertyKey);
          $it.errorPath = it.util.getPath(it.errorPath, $propertyKey, it.opts.jsonPointers);
          $it.dataPathArr[$dataNxt] = it.util.toQuotedString($propertyKey);
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            $code = it.util.varReplace($code, $nextData, $passData);
            var $useData = $passData;
          } else {
            var $useData = $nextData;
            out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ';
          }
          if ($hasDefault) {
            out += ' ' + ($code) + ' ';
          } else {
            if ($requiredHash && $requiredHash[$propertyKey]) {
              out += ' if ( ' + ($useData) + ' === undefined ';
              if ($ownProperties) {
                out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
              }
              out += ') { ' + ($nextValid) + ' = false; ';
              var $currentErrorPath = it.errorPath,
                $currErrSchemaPath = $errSchemaPath,
                $missingProperty = it.util.escapeQuotes($propertyKey);
              if (it.opts._errorDataPathProperty) {
                it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
              }
              $errSchemaPath = it.errSchemaPath + '/required';
              var $$outStack = $$outStack || [];
              $$outStack.push(out);
              out = ''; /* istanbul ignore else */
              if (it.createErrors !== false) {
                out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
                if (it.opts.messages !== false) {
                  out += ' , message: \'';
                  if (it.opts._errorDataPathProperty) {
                    out += 'is a required property';
                  } else {
                    out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
                  }
                  out += '\' ';
                }
                if (it.opts.verbose) {
                  out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
                }
                out += ' } ';
              } else {
                out += ' {} ';
              }
              var __err = out;
              out = $$outStack.pop();
              if (!it.compositeRule && $breakOnError) {
                /* istanbul ignore if */
                if (it.async) {
                  out += ' throw new ValidationError([' + (__err) + ']); ';
                } else {
                  out += ' validate.errors = [' + (__err) + ']; return false; ';
                }
              } else {
                out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
              }
              $errSchemaPath = $currErrSchemaPath;
              it.errorPath = $currentErrorPath;
              out += ' } else { ';
            } else {
              if ($breakOnError) {
                out += ' if ( ' + ($useData) + ' === undefined ';
                if ($ownProperties) {
                  out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
                }
                out += ') { ' + ($nextValid) + ' = true; } else { ';
              } else {
                out += ' if (' + ($useData) + ' !== undefined ';
                if ($ownProperties) {
                  out += ' &&   Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
                }
                out += ' ) { ';
              }
            }
            out += ' ' + ($code) + ' } ';
          }
        }
        if ($breakOnError) {
          out += ' if (' + ($nextValid) + ') { ';
          $closingBraces += '}';
        }
      }
    }
  }
  if ($pPropertyKeys.length) {
    var arr4 = $pPropertyKeys;
    if (arr4) {
      var $pProperty, i4 = -1,
        l4 = arr4.length - 1;
      while (i4 < l4) {
        $pProperty = arr4[i4 += 1];
        var $sch = $pProperties[$pProperty];
        if ((it.opts.strictKeywords ? (typeof $sch == 'object' && Object.keys($sch).length > 0) || $sch === false : it.util.schemaHasRules($sch, it.RULES.all))) {
          $it.schema = $sch;
          $it.schemaPath = it.schemaPath + '.patternProperties' + it.util.getProperty($pProperty);
          $it.errSchemaPath = it.errSchemaPath + '/patternProperties/' + it.util.escapeFragment($pProperty);
          if ($ownProperties) {
            out += ' ' + ($dataProperties) + ' = ' + ($dataProperties) + ' || Object.keys(' + ($data) + '); for (var ' + ($idx) + '=0; ' + ($idx) + '<' + ($dataProperties) + '.length; ' + ($idx) + '++) { var ' + ($key) + ' = ' + ($dataProperties) + '[' + ($idx) + ']; ';
          } else {
            out += ' for (var ' + ($key) + ' in ' + ($data) + ') { ';
          }
          out += ' if (' + (it.usePattern($pProperty)) + '.test(' + ($key) + ')) { ';
          $it.errorPath = it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
          var $passData = $data + '[' + $key + ']';
          $it.dataPathArr[$dataNxt] = $key;
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
          } else {
            out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
          }
          if ($breakOnError) {
            out += ' if (!' + ($nextValid) + ') break; ';
          }
          out += ' } ';
          if ($breakOnError) {
            out += ' else ' + ($nextValid) + ' = true; ';
          }
          out += ' }  ';
          if ($breakOnError) {
            out += ' if (' + ($nextValid) + ') { ';
            $closingBraces += '}';
          }
        }
      }
    }
  }
  if ($breakOnError) {
    out += ' ' + ($closingBraces) + ' if (' + ($errs) + ' == errors) {';
  }
  return out;
}


/***/ }),
/* 3401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_propertyNames(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  out += 'var ' + ($errs) + ' = errors;';
  if ((it.opts.strictKeywords ? (typeof $schema == 'object' && Object.keys($schema).length > 0) || $schema === false : it.util.schemaHasRules($schema, it.RULES.all))) {
    $it.schema = $schema;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    var $key = 'key' + $lvl,
      $idx = 'idx' + $lvl,
      $i = 'i' + $lvl,
      $invalidName = '\' + ' + $key + ' + \'',
      $dataNxt = $it.dataLevel = it.dataLevel + 1,
      $nextData = 'data' + $dataNxt,
      $dataProperties = 'dataProperties' + $lvl,
      $ownProperties = it.opts.ownProperties,
      $currentBaseId = it.baseId;
    if ($ownProperties) {
      out += ' var ' + ($dataProperties) + ' = undefined; ';
    }
    if ($ownProperties) {
      out += ' ' + ($dataProperties) + ' = ' + ($dataProperties) + ' || Object.keys(' + ($data) + '); for (var ' + ($idx) + '=0; ' + ($idx) + '<' + ($dataProperties) + '.length; ' + ($idx) + '++) { var ' + ($key) + ' = ' + ($dataProperties) + '[' + ($idx) + ']; ';
    } else {
      out += ' for (var ' + ($key) + ' in ' + ($data) + ') { ';
    }
    out += ' var startErrs' + ($lvl) + ' = errors; ';
    var $passData = $key;
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    var $code = it.validate($it);
    $it.baseId = $currentBaseId;
    if (it.util.varOccurences($code, $nextData) < 2) {
      out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
    } else {
      out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
    }
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += ' if (!' + ($nextValid) + ') { for (var ' + ($i) + '=startErrs' + ($lvl) + '; ' + ($i) + '<errors; ' + ($i) + '++) { vErrors[' + ($i) + '].propertyName = ' + ($key) + '; }   var err =   '; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ('propertyNames') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { propertyName: \'' + ($invalidName) + '\' } ';
      if (it.opts.messages !== false) {
        out += ' , message: \'property name \\\'' + ($invalidName) + '\\\' is invalid\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    if (!it.compositeRule && $breakOnError) {
      /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError(vErrors); ';
      } else {
        out += ' validate.errors = vErrors; return false; ';
      }
    }
    if ($breakOnError) {
      out += ' break; ';
    }
    out += ' } }';
  }
  if ($breakOnError) {
    out += ' ' + ($closingBraces) + ' if (' + ($errs) + ' == errors) {';
  }
  return out;
}


/***/ }),
/* 3402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_required(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $vSchema = 'schema' + $lvl;
  if (!$isData) {
    if ($schema.length < it.opts.loopRequired && it.schema.properties && Object.keys(it.schema.properties).length) {
      var $required = [];
      var arr1 = $schema;
      if (arr1) {
        var $property, i1 = -1,
          l1 = arr1.length - 1;
        while (i1 < l1) {
          $property = arr1[i1 += 1];
          var $propertySch = it.schema.properties[$property];
          if (!($propertySch && (it.opts.strictKeywords ? (typeof $propertySch == 'object' && Object.keys($propertySch).length > 0) || $propertySch === false : it.util.schemaHasRules($propertySch, it.RULES.all)))) {
            $required[$required.length] = $property;
          }
        }
      }
    } else {
      var $required = $schema;
    }
  }
  if ($isData || $required.length) {
    var $currentErrorPath = it.errorPath,
      $loopRequired = $isData || $required.length >= it.opts.loopRequired,
      $ownProperties = it.opts.ownProperties;
    if ($breakOnError) {
      out += ' var missing' + ($lvl) + '; ';
      if ($loopRequired) {
        if (!$isData) {
          out += ' var ' + ($vSchema) + ' = validate.schema' + ($schemaPath) + '; ';
        }
        var $i = 'i' + $lvl,
          $propertyPath = 'schema' + $lvl + '[' + $i + ']',
          $missingProperty = '\' + ' + $propertyPath + ' + \'';
        if (it.opts._errorDataPathProperty) {
          it.errorPath = it.util.getPathExpr($currentErrorPath, $propertyPath, it.opts.jsonPointers);
        }
        out += ' var ' + ($valid) + ' = true; ';
        if ($isData) {
          out += ' if (schema' + ($lvl) + ' === undefined) ' + ($valid) + ' = true; else if (!Array.isArray(schema' + ($lvl) + ')) ' + ($valid) + ' = false; else {';
        }
        out += ' for (var ' + ($i) + ' = 0; ' + ($i) + ' < ' + ($vSchema) + '.length; ' + ($i) + '++) { ' + ($valid) + ' = ' + ($data) + '[' + ($vSchema) + '[' + ($i) + ']] !== undefined ';
        if ($ownProperties) {
          out += ' &&   Object.prototype.hasOwnProperty.call(' + ($data) + ', ' + ($vSchema) + '[' + ($i) + ']) ';
        }
        out += '; if (!' + ($valid) + ') break; } ';
        if ($isData) {
          out += '  }  ';
        }
        out += '  if (!' + ($valid) + ') {   ';
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'';
            if (it.opts._errorDataPathProperty) {
              out += 'is a required property';
            } else {
              out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
            }
            out += '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
        out += ' } else { ';
      } else {
        out += ' if ( ';
        var arr2 = $required;
        if (arr2) {
          var $propertyKey, $i = -1,
            l2 = arr2.length - 1;
          while ($i < l2) {
            $propertyKey = arr2[$i += 1];
            if ($i) {
              out += ' || ';
            }
            var $prop = it.util.getProperty($propertyKey),
              $useData = $data + $prop;
            out += ' ( ( ' + ($useData) + ' === undefined ';
            if ($ownProperties) {
              out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
            }
            out += ') && (missing' + ($lvl) + ' = ' + (it.util.toQuotedString(it.opts.jsonPointers ? $propertyKey : $prop)) + ') ) ';
          }
        }
        out += ') {  ';
        var $propertyPath = 'missing' + $lvl,
          $missingProperty = '\' + ' + $propertyPath + ' + \'';
        if (it.opts._errorDataPathProperty) {
          it.errorPath = it.opts.jsonPointers ? it.util.getPathExpr($currentErrorPath, $propertyPath, true) : $currentErrorPath + ' + ' + $propertyPath;
        }
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'';
            if (it.opts._errorDataPathProperty) {
              out += 'is a required property';
            } else {
              out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
            }
            out += '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
        out += ' } else { ';
      }
    } else {
      if ($loopRequired) {
        if (!$isData) {
          out += ' var ' + ($vSchema) + ' = validate.schema' + ($schemaPath) + '; ';
        }
        var $i = 'i' + $lvl,
          $propertyPath = 'schema' + $lvl + '[' + $i + ']',
          $missingProperty = '\' + ' + $propertyPath + ' + \'';
        if (it.opts._errorDataPathProperty) {
          it.errorPath = it.util.getPathExpr($currentErrorPath, $propertyPath, it.opts.jsonPointers);
        }
        if ($isData) {
          out += ' if (' + ($vSchema) + ' && !Array.isArray(' + ($vSchema) + ')) {  var err =   '; /* istanbul ignore else */
          if (it.createErrors !== false) {
            out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
            if (it.opts.messages !== false) {
              out += ' , message: \'';
              if (it.opts._errorDataPathProperty) {
                out += 'is a required property';
              } else {
                out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
              }
              out += '\' ';
            }
            if (it.opts.verbose) {
              out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
            }
            out += ' } ';
          } else {
            out += ' {} ';
          }
          out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (' + ($vSchema) + ' !== undefined) { ';
        }
        out += ' for (var ' + ($i) + ' = 0; ' + ($i) + ' < ' + ($vSchema) + '.length; ' + ($i) + '++) { if (' + ($data) + '[' + ($vSchema) + '[' + ($i) + ']] === undefined ';
        if ($ownProperties) {
          out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', ' + ($vSchema) + '[' + ($i) + ']) ';
        }
        out += ') {  var err =   '; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'';
            if (it.opts._errorDataPathProperty) {
              out += 'is a required property';
            } else {
              out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
            }
            out += '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ';
        if ($isData) {
          out += '  }  ';
        }
      } else {
        var arr3 = $required;
        if (arr3) {
          var $propertyKey, i3 = -1,
            l3 = arr3.length - 1;
          while (i3 < l3) {
            $propertyKey = arr3[i3 += 1];
            var $prop = it.util.getProperty($propertyKey),
              $missingProperty = it.util.escapeQuotes($propertyKey),
              $useData = $data + $prop;
            if (it.opts._errorDataPathProperty) {
              it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
            }
            out += ' if ( ' + ($useData) + ' === undefined ';
            if ($ownProperties) {
              out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
            }
            out += ') {  var err =   '; /* istanbul ignore else */
            if (it.createErrors !== false) {
              out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
              if (it.opts.messages !== false) {
                out += ' , message: \'';
                if (it.opts._errorDataPathProperty) {
                  out += 'is a required property';
                } else {
                  out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
                }
                out += '\' ';
              }
              if (it.opts.verbose) {
                out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
              }
              out += ' } ';
            } else {
              out += ' {} ';
            }
            out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ';
          }
        }
      }
    }
    it.errorPath = $currentErrorPath;
  } else if ($breakOnError) {
    out += ' if (true) {';
  }
  return out;
}


/***/ }),
/* 3403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_uniqueItems(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  if (($schema || $isData) && it.opts.uniqueItems !== false) {
    if ($isData) {
      out += ' var ' + ($valid) + '; if (' + ($schemaValue) + ' === false || ' + ($schemaValue) + ' === undefined) ' + ($valid) + ' = true; else if (typeof ' + ($schemaValue) + ' != \'boolean\') ' + ($valid) + ' = false; else { ';
    }
    out += ' var i = ' + ($data) + '.length , ' + ($valid) + ' = true , j; if (i > 1) { ';
    var $itemType = it.schema.items && it.schema.items.type,
      $typeIsArray = Array.isArray($itemType);
    if (!$itemType || $itemType == 'object' || $itemType == 'array' || ($typeIsArray && ($itemType.indexOf('object') >= 0 || $itemType.indexOf('array') >= 0))) {
      out += ' outer: for (;i--;) { for (j = i; j--;) { if (equal(' + ($data) + '[i], ' + ($data) + '[j])) { ' + ($valid) + ' = false; break outer; } } } ';
    } else {
      out += ' var itemIndices = {}, item; for (;i--;) { var item = ' + ($data) + '[i]; ';
      var $method = 'checkDataType' + ($typeIsArray ? 's' : '');
      out += ' if (' + (it.util[$method]($itemType, 'item', it.opts.strictNumbers, true)) + ') continue; ';
      if ($typeIsArray) {
        out += ' if (typeof item == \'string\') item = \'"\' + item; ';
      }
      out += ' if (typeof itemIndices[item] == \'number\') { ' + ($valid) + ' = false; j = itemIndices[item]; break; } itemIndices[item] = i; } ';
    }
    out += ' } ';
    if ($isData) {
      out += '  }  ';
    }
    out += ' if (!' + ($valid) + ') {   ';
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ('uniqueItems') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { i: i, j: j } ';
      if (it.opts.messages !== false) {
        out += ' , message: \'should NOT have duplicate items (items ## \' + j + \' and \' + i + \' are identical)\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema:  ';
        if ($isData) {
          out += 'validate.schema' + ($schemaPath);
        } else {
          out += '' + ($schema);
        }
        out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
      /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError([' + (__err) + ']); ';
      } else {
        out += ' validate.errors = [' + (__err) + ']; return false; ';
      }
    } else {
      out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    }
    out += ' } ';
    if ($breakOnError) {
      out += ' else { ';
    }
  } else {
    if ($breakOnError) {
      out += ' if (true) { ';
    }
  }
  return out;
}


/***/ }),
/* 3404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var KEYWORDS = [
  'multipleOf',
  'maximum',
  'exclusiveMaximum',
  'minimum',
  'exclusiveMinimum',
  'maxLength',
  'minLength',
  'pattern',
  'additionalItems',
  'maxItems',
  'minItems',
  'uniqueItems',
  'maxProperties',
  'minProperties',
  'required',
  'additionalProperties',
  'enum',
  'format',
  'const'
];

module.exports = function (metaSchema, keywordsJsonPointers) {
  for (var i=0; i<keywordsJsonPointers.length; i++) {
    metaSchema = JSON.parse(JSON.stringify(metaSchema));
    var segments = keywordsJsonPointers[i].split('/');
    var keywords = metaSchema;
    var j;
    for (j=1; j<segments.length; j++)
      keywords = keywords[segments[j]];

    for (j=0; j<KEYWORDS.length; j++) {
      var key = KEYWORDS[j];
      var schema = keywords[key];
      if (schema) {
        keywords[key] = {
          anyOf: [
            schema,
            { $ref: 'https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#' }
          ]
        };
      }
    }
  }

  return metaSchema;
};


/***/ }),
/* 3405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MissingRefError = __webpack_require__(522).MissingRef;

module.exports = compileAsync;


/**
 * Creates validating function for passed schema with asynchronous loading of missing schemas.
 * `loadSchema` option should be a function that accepts schema uri and returns promise that resolves with the schema.
 * @this  Ajv
 * @param {Object}   schema schema object
 * @param {Boolean}  meta optional true to compile meta-schema; this parameter can be skipped
 * @param {Function} callback an optional node-style callback, it is called with 2 parameters: error (or null) and validating function.
 * @return {Promise} promise that resolves with a validating function.
 */
function compileAsync(schema, meta, callback) {
  /* eslint no-shadow: 0 */
  /* global Promise */
  /* jshint validthis: true */
  var self = this;
  if (typeof this._opts.loadSchema != 'function')
    throw new Error('options.loadSchema should be a function');

  if (typeof meta == 'function') {
    callback = meta;
    meta = undefined;
  }

  var p = loadMetaSchemaOf(schema).then(function () {
    var schemaObj = self._addSchema(schema, undefined, meta);
    return schemaObj.validate || _compileAsync(schemaObj);
  });

  if (callback) {
    p.then(
      function(v) { callback(null, v); },
      callback
    );
  }

  return p;


  function loadMetaSchemaOf(sch) {
    var $schema = sch.$schema;
    return $schema && !self.getSchema($schema)
            ? compileAsync.call(self, { $ref: $schema }, true)
            : Promise.resolve();
  }


  function _compileAsync(schemaObj) {
    try { return self._compile(schemaObj); }
    catch(e) {
      if (e instanceof MissingRefError) return loadMissingSchema(e);
      throw e;
    }


    function loadMissingSchema(e) {
      var ref = e.missingSchema;
      if (added(ref)) throw new Error('Schema ' + ref + ' is loaded but ' + e.missingRef + ' cannot be resolved');

      var schemaPromise = self._loadingSchemas[ref];
      if (!schemaPromise) {
        schemaPromise = self._loadingSchemas[ref] = self._opts.loadSchema(ref);
        schemaPromise.then(removePromise, removePromise);
      }

      return schemaPromise.then(function (sch) {
        if (!added(ref)) {
          return loadMetaSchemaOf(sch).then(function () {
            if (!added(ref)) self.addSchema(sch, ref, undefined, meta);
          });
        }
      }).then(function() {
        return _compileAsync(schemaObj);
      });

      function removePromise() {
        delete self._loadingSchemas[ref];
      }

      function added(ref) {
        return self._refs[ref] || self._schemas[ref];
      }
    }
  }
}


/***/ }),
/* 3406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var IDENTIFIER = /^[a-z_$][a-z0-9_$-]*$/i;
var customRuleCode = __webpack_require__(3407);
var definitionSchema = __webpack_require__(3408);

module.exports = {
  add: addKeyword,
  get: getKeyword,
  remove: removeKeyword,
  validate: validateKeyword
};


/**
 * Define custom keyword
 * @this  Ajv
 * @param {String} keyword custom keyword, should be unique (including different from all standard, custom and macro keywords).
 * @param {Object} definition keyword definition object with properties `type` (type(s) which the keyword applies to), `validate` or `compile`.
 * @return {Ajv} this for method chaining
 */
function addKeyword(keyword, definition) {
  /* jshint validthis: true */
  /* eslint no-shadow: 0 */
  var RULES = this.RULES;
  if (RULES.keywords[keyword])
    throw new Error('Keyword ' + keyword + ' is already defined');

  if (!IDENTIFIER.test(keyword))
    throw new Error('Keyword ' + keyword + ' is not a valid identifier');

  if (definition) {
    this.validateKeyword(definition, true);

    var dataType = definition.type;
    if (Array.isArray(dataType)) {
      for (var i=0; i<dataType.length; i++)
        _addRule(keyword, dataType[i], definition);
    } else {
      _addRule(keyword, dataType, definition);
    }

    var metaSchema = definition.metaSchema;
    if (metaSchema) {
      if (definition.$data && this._opts.$data) {
        metaSchema = {
          anyOf: [
            metaSchema,
            { '$ref': 'https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#' }
          ]
        };
      }
      definition.validateSchema = this.compile(metaSchema, true);
    }
  }

  RULES.keywords[keyword] = RULES.all[keyword] = true;


  function _addRule(keyword, dataType, definition) {
    var ruleGroup;
    for (var i=0; i<RULES.length; i++) {
      var rg = RULES[i];
      if (rg.type == dataType) {
        ruleGroup = rg;
        break;
      }
    }

    if (!ruleGroup) {
      ruleGroup = { type: dataType, rules: [] };
      RULES.push(ruleGroup);
    }

    var rule = {
      keyword: keyword,
      definition: definition,
      custom: true,
      code: customRuleCode,
      implements: definition.implements
    };
    ruleGroup.rules.push(rule);
    RULES.custom[keyword] = rule;
  }

  return this;
}


/**
 * Get keyword
 * @this  Ajv
 * @param {String} keyword pre-defined or custom keyword.
 * @return {Object|Boolean} custom keyword definition, `true` if it is a predefined keyword, `false` otherwise.
 */
function getKeyword(keyword) {
  /* jshint validthis: true */
  var rule = this.RULES.custom[keyword];
  return rule ? rule.definition : this.RULES.keywords[keyword] || false;
}


/**
 * Remove keyword
 * @this  Ajv
 * @param {String} keyword pre-defined or custom keyword.
 * @return {Ajv} this for method chaining
 */
function removeKeyword(keyword) {
  /* jshint validthis: true */
  var RULES = this.RULES;
  delete RULES.keywords[keyword];
  delete RULES.all[keyword];
  delete RULES.custom[keyword];
  for (var i=0; i<RULES.length; i++) {
    var rules = RULES[i].rules;
    for (var j=0; j<rules.length; j++) {
      if (rules[j].keyword == keyword) {
        rules.splice(j, 1);
        break;
      }
    }
  }
  return this;
}


/**
 * Validate keyword definition
 * @this  Ajv
 * @param {Object} definition keyword definition object.
 * @param {Boolean} throwError true to throw exception if definition is invalid
 * @return {boolean} validation result
 */
function validateKeyword(definition, throwError) {
  validateKeyword.errors = null;
  var v = this._validateKeyword = this._validateKeyword
                                  || this.compile(definitionSchema, true);

  if (v(definition)) return true;
  validateKeyword.errors = v.errors;
  if (throwError)
    throw new Error('custom keyword definition is invalid: '  + this.errorsText(v.errors));
  else
    return false;
}


/***/ }),
/* 3407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_custom(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $rule = this,
    $definition = 'definition' + $lvl,
    $rDef = $rule.definition,
    $closingBraces = '';
  var $compile, $inline, $macro, $ruleValidate, $validateCode;
  if ($isData && $rDef.$data) {
    $validateCode = 'keywordValidate' + $lvl;
    var $validateSchema = $rDef.validateSchema;
    out += ' var ' + ($definition) + ' = RULES.custom[\'' + ($keyword) + '\'].definition; var ' + ($validateCode) + ' = ' + ($definition) + '.validate;';
  } else {
    $ruleValidate = it.useCustomRule($rule, $schema, it.schema, it);
    if (!$ruleValidate) return;
    $schemaValue = 'validate.schema' + $schemaPath;
    $validateCode = $ruleValidate.code;
    $compile = $rDef.compile;
    $inline = $rDef.inline;
    $macro = $rDef.macro;
  }
  var $ruleErrs = $validateCode + '.errors',
    $i = 'i' + $lvl,
    $ruleErr = 'ruleErr' + $lvl,
    $asyncKeyword = $rDef.async;
  if ($asyncKeyword && !it.async) throw new Error('async keyword in sync schema');
  if (!($inline || $macro)) {
    out += '' + ($ruleErrs) + ' = null;';
  }
  out += 'var ' + ($errs) + ' = errors;var ' + ($valid) + ';';
  if ($isData && $rDef.$data) {
    $closingBraces += '}';
    out += ' if (' + ($schemaValue) + ' === undefined) { ' + ($valid) + ' = true; } else { ';
    if ($validateSchema) {
      $closingBraces += '}';
      out += ' ' + ($valid) + ' = ' + ($definition) + '.validateSchema(' + ($schemaValue) + '); if (' + ($valid) + ') { ';
    }
  }
  if ($inline) {
    if ($rDef.statements) {
      out += ' ' + ($ruleValidate.validate) + ' ';
    } else {
      out += ' ' + ($valid) + ' = ' + ($ruleValidate.validate) + '; ';
    }
  } else if ($macro) {
    var $it = it.util.copy(it);
    var $closingBraces = '';
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    $it.schema = $ruleValidate.validate;
    $it.schemaPath = '';
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    var $code = it.validate($it).replace(/validate\.schema/g, $validateCode);
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += ' ' + ($code);
  } else {
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = '';
    out += '  ' + ($validateCode) + '.call( ';
    if (it.opts.passContext) {
      out += 'this';
    } else {
      out += 'self';
    }
    if ($compile || $rDef.schema === false) {
      out += ' , ' + ($data) + ' ';
    } else {
      out += ' , ' + ($schemaValue) + ' , ' + ($data) + ' , validate.schema' + (it.schemaPath) + ' ';
    }
    out += ' , (dataPath || \'\')';
    if (it.errorPath != '""') {
      out += ' + ' + (it.errorPath);
    }
    var $parentData = $dataLvl ? 'data' + (($dataLvl - 1) || '') : 'parentData',
      $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : 'parentDataProperty';
    out += ' , ' + ($parentData) + ' , ' + ($parentDataProperty) + ' , rootData )  ';
    var def_callRuleValidate = out;
    out = $$outStack.pop();
    if ($rDef.errors === false) {
      out += ' ' + ($valid) + ' = ';
      if ($asyncKeyword) {
        out += 'await ';
      }
      out += '' + (def_callRuleValidate) + '; ';
    } else {
      if ($asyncKeyword) {
        $ruleErrs = 'customErrors' + $lvl;
        out += ' var ' + ($ruleErrs) + ' = null; try { ' + ($valid) + ' = await ' + (def_callRuleValidate) + '; } catch (e) { ' + ($valid) + ' = false; if (e instanceof ValidationError) ' + ($ruleErrs) + ' = e.errors; else throw e; } ';
      } else {
        out += ' ' + ($ruleErrs) + ' = null; ' + ($valid) + ' = ' + (def_callRuleValidate) + '; ';
      }
    }
  }
  if ($rDef.modifying) {
    out += ' if (' + ($parentData) + ') ' + ($data) + ' = ' + ($parentData) + '[' + ($parentDataProperty) + '];';
  }
  out += '' + ($closingBraces);
  if ($rDef.valid) {
    if ($breakOnError) {
      out += ' if (true) { ';
    }
  } else {
    out += ' if ( ';
    if ($rDef.valid === undefined) {
      out += ' !';
      if ($macro) {
        out += '' + ($nextValid);
      } else {
        out += '' + ($valid);
      }
    } else {
      out += ' ' + (!$rDef.valid) + ' ';
    }
    out += ') { ';
    $errorKeyword = $rule.keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = '';
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ($errorKeyword || 'custom') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { keyword: \'' + ($rule.keyword) + '\' } ';
      if (it.opts.messages !== false) {
        out += ' , message: \'should pass "' + ($rule.keyword) + '" keyword validation\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
      /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError([' + (__err) + ']); ';
      } else {
        out += ' validate.errors = [' + (__err) + ']; return false; ';
      }
    } else {
      out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    }
    var def_customError = out;
    out = $$outStack.pop();
    if ($inline) {
      if ($rDef.errors) {
        if ($rDef.errors != 'full') {
          out += '  for (var ' + ($i) + '=' + ($errs) + '; ' + ($i) + '<errors; ' + ($i) + '++) { var ' + ($ruleErr) + ' = vErrors[' + ($i) + ']; if (' + ($ruleErr) + '.dataPath === undefined) ' + ($ruleErr) + '.dataPath = (dataPath || \'\') + ' + (it.errorPath) + '; if (' + ($ruleErr) + '.schemaPath === undefined) { ' + ($ruleErr) + '.schemaPath = "' + ($errSchemaPath) + '"; } ';
          if (it.opts.verbose) {
            out += ' ' + ($ruleErr) + '.schema = ' + ($schemaValue) + '; ' + ($ruleErr) + '.data = ' + ($data) + '; ';
          }
          out += ' } ';
        }
      } else {
        if ($rDef.errors === false) {
          out += ' ' + (def_customError) + ' ';
        } else {
          out += ' if (' + ($errs) + ' == errors) { ' + (def_customError) + ' } else {  for (var ' + ($i) + '=' + ($errs) + '; ' + ($i) + '<errors; ' + ($i) + '++) { var ' + ($ruleErr) + ' = vErrors[' + ($i) + ']; if (' + ($ruleErr) + '.dataPath === undefined) ' + ($ruleErr) + '.dataPath = (dataPath || \'\') + ' + (it.errorPath) + '; if (' + ($ruleErr) + '.schemaPath === undefined) { ' + ($ruleErr) + '.schemaPath = "' + ($errSchemaPath) + '"; } ';
          if (it.opts.verbose) {
            out += ' ' + ($ruleErr) + '.schema = ' + ($schemaValue) + '; ' + ($ruleErr) + '.data = ' + ($data) + '; ';
          }
          out += ' } } ';
        }
      }
    } else if ($macro) {
      out += '   var err =   '; /* istanbul ignore else */
      if (it.createErrors !== false) {
        out += ' { keyword: \'' + ($errorKeyword || 'custom') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { keyword: \'' + ($rule.keyword) + '\' } ';
        if (it.opts.messages !== false) {
          out += ' , message: \'should pass "' + ($rule.keyword) + '" keyword validation\' ';
        }
        if (it.opts.verbose) {
          out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
        }
        out += ' } ';
      } else {
        out += ' {} ';
      }
      out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
      if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */
        if (it.async) {
          out += ' throw new ValidationError(vErrors); ';
        } else {
          out += ' validate.errors = vErrors; return false; ';
        }
      }
    } else {
      if ($rDef.errors === false) {
        out += ' ' + (def_customError) + ' ';
      } else {
        out += ' if (Array.isArray(' + ($ruleErrs) + ')) { if (vErrors === null) vErrors = ' + ($ruleErrs) + '; else vErrors = vErrors.concat(' + ($ruleErrs) + '); errors = vErrors.length;  for (var ' + ($i) + '=' + ($errs) + '; ' + ($i) + '<errors; ' + ($i) + '++) { var ' + ($ruleErr) + ' = vErrors[' + ($i) + ']; if (' + ($ruleErr) + '.dataPath === undefined) ' + ($ruleErr) + '.dataPath = (dataPath || \'\') + ' + (it.errorPath) + ';  ' + ($ruleErr) + '.schemaPath = "' + ($errSchemaPath) + '";  ';
        if (it.opts.verbose) {
          out += ' ' + ($ruleErr) + '.schema = ' + ($schemaValue) + '; ' + ($ruleErr) + '.data = ' + ($data) + '; ';
        }
        out += ' } } else { ' + (def_customError) + ' } ';
      }
    }
    out += ' } ';
    if ($breakOnError) {
      out += ' else { ';
    }
  }
  return out;
}


/***/ }),
/* 3408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var metaSchema = __webpack_require__(1329);

module.exports = {
  $id: 'https://github.com/ajv-validator/ajv/blob/master/lib/definition_schema.js',
  definitions: {
    simpleTypes: metaSchema.definitions.simpleTypes
  },
  type: 'object',
  dependencies: {
    schema: ['validate'],
    $data: ['validate'],
    statements: ['inline'],
    valid: {not: {required: ['macro']}}
  },
  properties: {
    type: metaSchema.properties.type,
    schema: {type: 'boolean'},
    statements: {type: 'boolean'},
    dependencies: {
      type: 'array',
      items: {type: 'string'}
    },
    metaSchema: {type: 'object'},
    modifying: {type: 'boolean'},
    valid: {type: 'boolean'},
    $data: {type: 'boolean'},
    async: {type: 'boolean'},
    errors: {
      anyOf: [
        {type: 'boolean'},
        {const: 'full'}
      ]
    }
  }
};


/***/ }),
/* 3409 */
/***/ (function(module, exports) {

module.exports = {"$schema":"http://json-schema.org/draft-07/schema#","$id":"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#","description":"Meta-schema for $data reference (JSON Schema extension proposal)","type":"object","required":["$data"],"properties":{"$data":{"type":"string","anyOf":[{"format":"relative-json-pointer"},{"format":"json-pointer"}]}},"additionalProperties":false}

/***/ }),
/* 3410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SchemaArray__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_index__ = __webpack_require__(323);
var SchemaObject=function SchemaObject(_ref){var title=_ref.title,_ref$schema=_ref.schema,schema=_ref$schema===undefined?{}:_ref$schema;var properties=schema.properties,required=schema.required;var props=Object.keys(properties);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'schema-form-block'},props.map(function(key){var prop=properties[key];switch(prop.type){case'object':var isNestedRequire=required&&required.includes(prop.name);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["c" /* FormSection */],{key:prop.id,name:prop.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{name:'_include',className:'ncss-label',label:prop.title,disabled:isNestedRequire,component:__WEBPACK_IMPORTED_MODULE_3__components_forms_index__["a" /* Checkbox */],title:prop.description}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SchemaObject,{title:prop.title,schema:prop}));case'string':return prop.enum?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{key:prop.id,name:prop.id,component:__WEBPACK_IMPORTED_MODULE_3__components_forms_index__["c" /* Select */],label:prop.title,options:prop.enum.map(function(e){return{label:e,value:e};}),title:prop.description}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{key:prop.id,name:prop.id,component:__WEBPACK_IMPORTED_MODULE_3__components_forms_index__["d" /* TextInput */],label:prop.title,title:prop.description,placeholder:prop['x-placeholder']});case'text':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{key:prop.id,name:prop.id,component:__WEBPACK_IMPORTED_MODULE_3__components_forms_index__["d" /* TextInput */],textArea:true,label:prop.title,title:prop.description,placeholder:prop['x-placeholder']});case'boolean':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{key:prop.id,name:prop.id,component:__WEBPACK_IMPORTED_MODULE_3__components_forms_index__["a" /* Checkbox */],label:prop.title,title:prop.description});case'array':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["b" /* FieldArray */],{key:prop.id,name:prop.id,prop:prop,component:__WEBPACK_IMPORTED_MODULE_1__SchemaArray__["a" /* default */]});case'number':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */],{key:prop.id,name:prop.id,component:__WEBPACK_IMPORTED_MODULE_3__components_forms_index__["b" /* NumericInput */],label:prop.title,title:prop.description});default:throw new Error('unknown prop type '+prop.type+' in '+title);}}));};/* harmony default export */ __webpack_exports__["a"] = (SchemaObject);// TODO: make updates so that when viewing an existing issues the fields are by defualt read only and have an Edit button next to them, may require a new component

/***/ }),
/* 3411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CreateRequestPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__serviceDesk_IssueList__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__serviceDesk_request_RequestTypeList__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth_reducer__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appStatus_reducer__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_index__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_refresh__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_refresh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_refresh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__accessSelfService_AccessStatus__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appStatus_AppStatus__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__accessSelfService_actions__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_index__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateRequestPage=function(_Component){_inherits(CreateRequestPage,_Component);function CreateRequestPage(){_classCallCheck(this,CreateRequestPage);return _possibleConstructorReturn(this,(CreateRequestPage.__proto__||Object.getPrototypeOf(CreateRequestPage)).apply(this,arguments));}_createClass(CreateRequestPage,[{key:'render',value:function render(){var _props=this.props,appList=_props.appList,adUserInfo=_props.adUserInfo,getAccessPending=_props.getAccessPending;var jiraStatus=void 0;if(appList){jiraStatus=appList.find(function(app){return app.name.toLowerCase()==='jira';});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_index__["s" /* PageTitle */],{title:'Home'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_index__["q" /* PageHeader */],{title:'Build And Agile Tools Self-Service Portal'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_index__["f" /* Container */],{section:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'split-container left-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'split-container-right right-padding split-container-border-left border-left'},!appList||!jiraStatus.available?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__serviceDesk_request_RequestTypeList__["a" /* default */],null)))));}}]);return CreateRequestPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{getAccessPending:Object(__WEBPACK_IMPORTED_MODULE_12__util_index__["f" /* selectIsRequestPending */])(state,__WEBPACK_IMPORTED_MODULE_11__accessSelfService_actions__["e" /* getUserAccessStatus */]),adUserInfo:Object(__WEBPACK_IMPORTED_MODULE_5__auth_reducer__["f" /* selectADUserInfo */])(state),appList:Object(__WEBPACK_IMPORTED_MODULE_6__appStatus_reducer__["b" /* selectAppList */])(state)};},{getUserAccessStatus:__WEBPACK_IMPORTED_MODULE_11__accessSelfService_actions__["e" /* getUserAccessStatus */]})(CreateRequestPage)));

/***/ }),
/* 3412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_index__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth_reducer__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_avatar__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_lozenge__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__request_forms_DynamicForm__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__request_forms_DynamicView__ = __webpack_require__(3413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_CommentSection__ = __webpack_require__(3414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__reducer__ = __webpack_require__(173);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var dateOptions={year:'numeric',month:'long',day:'numeric','hour':'2-digit','minute':'2-digit','hour12':false};var ViewRequestPage=function(_Component){_inherits(ViewRequestPage,_Component);function ViewRequestPage(props){var _ref;var _temp,_this;_classCallCheck(this,ViewRequestPage);for(var _len=arguments.length,args=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}(_temp=(_this=_possibleConstructorReturn(this,(_ref=ViewRequestPage.__proto__||Object.getPrototypeOf(ViewRequestPage)).call.apply(_ref,[this,props].concat(args))),_this),_this.handleUpdate=function(values){var _this$props=_this.props,updateIssue=_this$props.updateIssue,issueKey=_this$props.issueKey;updateIssue(values,issueKey).catch(function(err){return console.error(err);});_this.setState({editing:!_this.state.editing});},_this.handleEditing=function(){_this.setState({editing:!_this.state.editing});},_this.handleCancel=function(){_this.setState({editing:!_this.state.editing});},_temp),_this.state={editing:false};return _this;}_createClass(ViewRequestPage,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,getIssue=_props.getIssue,issueKey=_props.issueKey,issue=_props.issue;// if url has issue key then
if(issueKey&&!issue){// then get the specific Issue identified by that ID if that issue isn't already loaded to state
getIssue(issueKey);}}},{key:'render',value:function render(){var _props2=this.props,issue=_props2.issue,issueKey=_props2.issueKey,isIssuePending=_props2.isIssuePending,isUpdatePending=_props2.isUpdatePending,issueError=_props2.issueError,JiraUser=_props2.JiraUser;if(issueError)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["s" /* PageTitle */],{title:'Issue not Found'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["q" /* PageHeader */],{title:'Issue Lookup Error',back:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["m" /* Link */],{to:'/',className:'page-title-back'},'< Home')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["f" /* Container */],{section:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status-inactive fs20-sm lh20-sm fs24-md lh24-md'},issueError)));if(issueKey&&isIssuePending||!issue)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["r" /* PageSpinner */],{title:'Looking Up Issue...'});var assignee=issue.assignee?issue.assignee:null;var status=issue.status?issue.status:{};var resolution=issue.resolution?issue.resolution:'Unresolved';var created=issue.created?new Date(issue.created):null;var updated=issue.updated?new Date(issue.updated):null;var issueLink=issue.issue_link?issue.issue_link:null;var issueKeyLink=JiraUser&&issueLink?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:issueLink,target:'_blank',className:'link'},issueKey):issueKey;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["s" /* PageTitle */],{title:issueKey}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["q" /* PageHeader */],{title:issueKeyLink,back:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["m" /* Link */],{to:'/',className:'page-title-back'},'< Home')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["f" /* Container */],{section:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["j" /* H3 */],{className:'pb5-sm'},'Issue Details'),isUpdatePending?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["v" /* Spinner */],{large:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'split-container fit-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'split-container-right split-container-border-left border-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["g" /* DescriptionList */],{hideEmpty:true,items:{'Status':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__atlaskit_lozenge__["default"],{appearance:status.appearance,isBold:true},status.name),'Assignee':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__atlaskit_avatar__["a" /* AvatarItem */],{avatar:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__atlaskit_avatar__["d" /* default */],{src:assignee?assignee.avatarUrls['32x32']:null,size:'large'}),key:assignee?assignee.emailAddress:null,primaryText:assignee?assignee.displayName:'Unassigned',secondaryText:assignee?assignee.emailAddress:null,enableTextTruncate:true,isActive:false}),'Resolution':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,resolution),'Created':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,created.toLocaleDateString('en-US',dateOptions)),'Updated':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,updated.toLocaleDateString('en-US',dateOptions))}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'split-container-left'},this.state.editing?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__request_forms_DynamicForm__["a" /* default */],{RequestType:issue.requestType,isNew:false,Issue:issue,onSubmit:this.handleUpdate,actionInProgress:isUpdatePending,cancel:this.handleCancel}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__request_forms_DynamicView__["a" /* default */],{Issue:issue,editIssue:this.handleEditing})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["f" /* Container */],{section:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index__["j" /* H3 */],{className:'pb5-sm'},'Comments'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_CommentSection__["a" /* default */],{Issue:issue})));}}]);return ViewRequestPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_4__util_index__["e" /* requireLogin */])('Request'),Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,ownProps){return{isUpdatePending:Object(__WEBPACK_IMPORTED_MODULE_4__util_index__["f" /* selectIsRequestPending */])(state,__WEBPACK_IMPORTED_MODULE_11__actions__["m" /* updateIssue */]),isIssuePending:Object(__WEBPACK_IMPORTED_MODULE_4__util_index__["f" /* selectIsRequestPending */])(state,__WEBPACK_IMPORTED_MODULE_11__actions__["g" /* getIssue */]),requestType:Object(__WEBPACK_IMPORTED_MODULE_12__reducer__["h" /* selectRequestType */])(state),isRequestTypePending:Object(__WEBPACK_IMPORTED_MODULE_4__util_index__["f" /* selectIsRequestPending */])(state,__WEBPACK_IMPORTED_MODULE_11__actions__["i" /* getRequestType */]),issueKey:ownProps.match.params.issueKey,issue:Object(__WEBPACK_IMPORTED_MODULE_12__reducer__["b" /* selectIssue */])(state),user:Object(__WEBPACK_IMPORTED_MODULE_5__auth_reducer__["f" /* selectADUserInfo */])(state),JiraUser:Object(__WEBPACK_IMPORTED_MODULE_5__auth_reducer__["h" /* selectJiraUser */])(state),issueError:Object(__WEBPACK_IMPORTED_MODULE_12__reducer__["d" /* selectIssueError */])(state)};},{getIssue:__WEBPACK_IMPORTED_MODULE_11__actions__["g" /* getIssue */],getRequestType:__WEBPACK_IMPORTED_MODULE_11__actions__["i" /* getRequestType */],updateIssue:__WEBPACK_IMPORTED_MODULE_11__actions__["m" /* updateIssue */],updateIssueData:__WEBPACK_IMPORTED_MODULE_11__actions__["o" /* updateIssueData */]}))(ViewRequestPage));

/***/ }),
/* 3413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_renderer__ = __webpack_require__(109);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DynamicView=function(_Component){_inherits(DynamicView,_Component);function DynamicView(){_classCallCheck(this,DynamicView);return _possibleConstructorReturn(this,(DynamicView.__proto__||Object.getPrototypeOf(DynamicView)).apply(this,arguments));}_createClass(DynamicView,[{key:'render',value:function render(){var _props=this.props,Issue=_props.Issue,editIssue=_props.editIssue;var properties=Issue.requestType.inputs.properties;var issueItems=properties.reduce(function(result,field){result[''+field.title]=field.type=='wiki'||field.jiraFieldName=='description'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__atlaskit_renderer__["b" /* ReactRenderer */],{document:Issue[field.id]}):Issue[field.id];return result;},{});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["g" /* DescriptionList */],{hideEmpty:true,items:issueItems}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__atlaskit_button__["default"],{type:'button',appearance:'primary',onClick:editIssue},'Edit'));}}]);return DynamicView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DynamicView);

/***/ }),
/* 3414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CollapsibleComment__ = __webpack_require__(3415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_index__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth_reducer__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reducer__ = __webpack_require__(173);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CommentSection=function(_Component){_inherits(CommentSection,_Component);function CommentSection(props){var _ref;var _temp,_this;_classCallCheck(this,CommentSection);for(var _len=arguments.length,args=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}(_temp=(_this=_possibleConstructorReturn(this,(_ref=CommentSection.__proto__||Object.getPrototypeOf(CommentSection)).call.apply(_ref,[this,props].concat(args))),_this),_this.handleUpdate=function(value){var _this$props=_this.props,Issue=_this$props.Issue,updateIssueComment=_this$props.updateIssueComment;updateIssueComment(Issue.key,value);},_this.handleEditing=function(){_this.setState({editing:!_this.state.editing});},_this.handleCreateSubmit=function(values){var _this$props2=_this.props,Issue=_this$props2.Issue,addIssueComment=_this$props2.addIssueComment;addIssueComment(Issue.key,values);_this.setState({createNew:false});},_this.handleCreate=function(){_this.setState({createNew:true});},_this.handleCreateCancel=function(){_this.setState({createNew:false});},_this.handleShowHidden=function(){_this.setState({hideOld:false});},_this.collapsedOlderComments=function(comments){var shownComments=comments.slice(comments.length-4);var countHidden=comments.length-4;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'older-comments fancy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:_this.handleShowHidden},countHidden+' older comments')),shownComments);},_temp),_this.state={createNew:false,editing:false,hideOld:true};return _this;}_createClass(CommentSection,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,Issue=_props.Issue,getIssueComments=_props.getIssueComments;getIssueComments(Issue.key).catch(function(err){return console.error(err);});}// TODO: CSS to get this section looking right still needs to be setup, and onClick isn't working span isn't actually clickable.
},{key:'render',value:function render(){var _this2=this;var _props2=this.props,Issue=_props2.Issue,issueComments=_props2.issueComments,isCommentsPending=_props2.isCommentsPending,user=_props2.user,isAddCommentPending=_props2.isAddCommentPending,isUpdateCommentPending=_props2.isUpdateCommentPending;if(isCommentsPending)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["v" /* Spinner */],{medium:true});var comments=issueComments.map(function(comment){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CollapsibleComment__["a" /* default */],{key:comment.id,comment:comment,onUpdate:_this2.handleUpdate,user:user,editingComment:_this2.state.editing,onEditing:_this2.handleEditing,updatePending:isUpdateCommentPending});});//let commentsSection = comments.length < 5 ? comments : this.collapsedOlderComments(comments)
var commentsSection=comments;return isUpdateCommentPending||isAddCommentPending?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["v" /* Spinner */],{large:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comment-section-container'},commentsSection,this.state.createNew?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_index__["w" /* WikiEditor */],{key:'newComment',onSave:this.handleCreateSubmit,onCancel:this.handleCreateCancel}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__atlaskit_button__["default"],{type:'button',appearance:'primary',onClick:this.handleCreate},'Add Comment'));}}]);return CommentSection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{issueComments:Object(__WEBPACK_IMPORTED_MODULE_8__reducer__["c" /* selectIssueComments */])(state),isCommentsPending:Object(__WEBPACK_IMPORTED_MODULE_4__util_index__["f" /* selectIsRequestPending */])(state,__WEBPACK_IMPORTED_MODULE_7__actions__["h" /* getIssueComments */]),isUpdateCommentPending:Object(__WEBPACK_IMPORTED_MODULE_4__util_index__["f" /* selectIsRequestPending */])(state,__WEBPACK_IMPORTED_MODULE_7__actions__["n" /* updateIssueComment */]),isAddCommentPending:Object(__WEBPACK_IMPORTED_MODULE_4__util_index__["f" /* selectIsRequestPending */])(state,__WEBPACK_IMPORTED_MODULE_7__actions__["a" /* addIssueComment */]),user:Object(__WEBPACK_IMPORTED_MODULE_6__auth_reducer__["f" /* selectADUserInfo */])(state)};},{getIssueComments:__WEBPACK_IMPORTED_MODULE_7__actions__["h" /* getIssueComments */],addIssueComment:__WEBPACK_IMPORTED_MODULE_7__actions__["a" /* addIssueComment */],updateIssueComment:__WEBPACK_IMPORTED_MODULE_7__actions__["n" /* updateIssueComment */]})(CommentSection));

/***/ }),
/* 3415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_avatar__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_comment__ = __webpack_require__(3416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_renderer__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(73);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var dateOptions={year:'numeric',month:'long',day:'2-digit',hour:'2-digit',minute:'2-digit'};var CollapsibleComment=function(_Component){_inherits(CollapsibleComment,_Component);function CollapsibleComment(props){var _ref;_classCallCheck(this,CollapsibleComment);for(var _len=arguments.length,args=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}var _this=_possibleConstructorReturn(this,(_ref=CollapsibleComment.__proto__||Object.getPrototypeOf(CollapsibleComment)).call.apply(_ref,[this,props].concat(args)));_this.handleTrigger=function(edit){_this.setState(edit?{isOpen:true}:{isOpen:!_this.state.isOpen});};_this.handleEdit=function(e){var onEditing=_this.props.onEditing;onEditing();_this.state.edit===false?e.stopPropagation():null;_this.setState({edit:!_this.state.edit});};_this.handleUpdate=function(values){var _this$props=_this.props,onUpdate=_this$props.onUpdate,comment=_this$props.comment;comment.body=values;onUpdate(comment);_this.handleEdit();};_this.state={isOpen:true,edit:false,editingComment:false};return _this;}_createClass(CollapsibleComment,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.editingComment!=this.props.editingComment)return;this.setState({editingComment:nextProps.editingComment});}},{key:'render',value:function render(){var _this2=this;var _props=this.props,comment=_props.comment,user=_props.user,editingComment=_props.editingComment;var created=new Date(comment.created);var mentionProvider=Object(__WEBPACK_IMPORTED_MODULE_4__components_index__["n" /* MentionProvider */])(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].mentionsIssue);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["f" /* Container */],{className:'comment-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comment-outer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["e" /* Collapsible */],{open:this.state.isOpen,handleTriggerClick:function handleTriggerClick(){return _this2.handleTrigger(_this2.state.edit);},trigger:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comment-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comment-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comment-header-main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comment-avatar-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__atlaskit_avatar__["d" /* default */],{className:'comment-avatar',appearance:'square',size:'small',src:comment.author.avatarUrls?comment.author.avatarUrls['48x48']:null})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comment-header-main-contents'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__atlaskit_comment__["b" /* CommentAuthor */],null,comment.author.displayName)),comment.updated!=comment.created?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comment-header-main-contents'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__atlaskit_comment__["c" /* CommentEdited */],null,'Edited')):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comment-header-main-contents'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__atlaskit_comment__["d" /* CommentTime */],null,created.toLocaleDateString('en-US',dateOptions)))),user.email==comment.author.emailAddress?editingComment||this.state.edit?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__atlaskit_comment__["a" /* CommentAction */],{className:'btn icon-solo comment-header-right',onClick:this.handleEdit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-pencil'})):null))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comment-content'},this.state.edit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["w" /* WikiEditor */],{key:comment.id,onSave:this.handleUpdate,onCancel:this.handleEdit,value:comment.body,mentionProvider:mentionProvider}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__atlaskit_renderer__["b" /* ReactRenderer */],{document:comment.body})))));}}]);return CollapsibleComment;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CollapsibleComment);

/***/ }),
/* 3416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Comment__ = __webpack_require__(3417);
/* unused harmony reexport default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ActionItem__ = __webpack_require__(3427);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__components_ActionItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Author__ = __webpack_require__(3428);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__components_Author__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Edited__ = __webpack_require__(3430);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__components_Edited__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Layout__ = __webpack_require__(1330);
/* unused harmony reexport CommentLayout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Time__ = __webpack_require__(3432);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__components_Time__["a"]; });







/***/ }),
/* 3417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Header__ = __webpack_require__(3419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Footer__ = __webpack_require__(3423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styled_CommentStyles__ = __webpack_require__(3426);












var Comment =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Comment, _Component);

  function Comment() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Comment);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Comment).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Comment, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          actions = _this$props.actions,
          author = _this$props.author,
          avatar = _this$props.avatar,
          children = _this$props.children,
          content = _this$props.content,
          edited = _this$props.edited,
          errorActions = _this$props.errorActions,
          errorIconLabel = _this$props.errorIconLabel,
          highlighted = _this$props.highlighted,
          isError = _this$props.isError,
          isSaving = _this$props.isSaving,
          restrictedTo = _this$props.restrictedTo,
          savingText = _this$props.savingText,
          time = _this$props.time,
          type = _this$props.type,
          id = _this$props.id;
      var headerProps = {
        author: author,
        edited: edited,
        isError: isError,
        isSaving: isSaving,
        restrictedTo: restrictedTo,
        savingText: savingText,
        time: time,
        type: type
      };
      var footerProps = {
        actions: actions,
        errorActions: errorActions,
        errorIconLabel: errorIconLabel,
        isError: isError,
        isSaving: isSaving
      };
      var layoutContent = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Header__["a" /* default */], headerProps), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styled_CommentStyles__["a" /* Content */], {
        isDisabled: isSaving || isError
      }, content), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Footer__["a" /* default */], footerProps));
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Layout__["a" /* default */], {
        id: id,
        avatar: avatar,
        content: layoutContent,
        highlighted: highlighted
      }, children);
    }
  }]);

  return Comment;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(Comment, "defaultProps", {
  actions: [],
  restrictedTo: '',
  highlighted: false,
  isSaving: false,
  savingText: 'Sending...',
  isError: false,
  errorActions: [],
  errorIconLabel: ''
});



/***/ }),
/* 3418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AvatarSectionDiv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ContentSectionDiv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Highlight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NestedCommentsDiv; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled_constants__ = __webpack_require__(1331);



var ThemeColor = {
  Highlight: {
    background: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N20A
  }
};
var AvatarSectionDiv = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "LayoutStyles__AvatarSectionDiv",
  componentId: "sc-14140bv-0"
})(["\n  /* -ms- properties are necessary until MS supports the latest version of the grid spec */\n  /* stylelint-disable value-no-vendor-prefix */\n  -ms-grid-row: 1;\n  -ms-grid-column: 1;\n  /* stylelint-enable */\n  grid-area: avatar-area;\n  /* Unfortunately it's still easier to use a margin here until MS supports grid-gap */\n  margin-right: ", "px;\n\n  [dir='rtl'] & {\n    margin-left: ", "px;\n    margin-right: 0;\n  }\n"], Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])(), Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])());
var Container = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "LayoutStyles__Container",
  componentId: "sc-14140bv-1"
})(["\n  /* stylelint-disable value-no-vendor-prefix, declaration-block-no-duplicate-properties */\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: auto 1fr;\n  /* stylelint-enable */\n  grid-template:\n    'avatar-area comment-area'\n    '. nested-comments-area'\n    / auto 1fr;\n  padding-top: ", "px;\n  position: relative;\n\n  /* We need both selectors as there is not a common wrapper component around\n  comments. We also provide isFirst as an escape hatch. */\n  &:first-child,\n  &:first-of-type {\n    padding-top: 0;\n  }\n"], __WEBPACK_IMPORTED_MODULE_2__styled_constants__["b" /* verticalPadding */]);
var ContentSectionDiv = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "LayoutStyles__ContentSectionDiv",
  componentId: "sc-14140bv-2"
})(["\n  -ms-grid-row: 1;\n  -ms-grid-column: 2;\n  grid-area: comment-area;\n  margin-top: ", "px;\n  /* Required for word-wrap: break-word to work in a grid */\n  min-width: 0;\n  word-wrap: break-word;\n"], Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])() * 0.25);
var Highlight = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "LayoutStyles__Highlight",
  componentId: "sc-14140bv-3"
})(["\n  background: ", ";\n  -ms-grid-row: 1;\n  -ms-grid-column: 1;\n  -ms-grid-column-span: 2;\n  grid-area: 1 / 1 / 2 / 3;\n  height: 100%;\n  padding: ", "px ", "px ", "px;\n  transform: translate(-", "px, -", "px);\n  width: 100%;\n\n  [dir='rtl'] & {\n    transform: translate(", "px, -", "px);\n  }\n  pointer-events: none;\n"], ThemeColor.Highlight.background, Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])(), Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])(), Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])() / 2, Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])(), Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])(), Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])(), Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])());
var NestedCommentsDiv = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "LayoutStyles__NestedCommentsDiv",
  componentId: "sc-14140bv-4"
})(["\n  -ms-grid-row: 2;\n  -ms-grid-column: 2;\n  grid-area: nested-comments-area;\n  margin-top: ", "px;\n"], __WEBPACK_IMPORTED_MODULE_2__styled_constants__["b" /* verticalPadding */]);

/***/ }),
/* 3419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_lozenge__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_lock_filled__ = __webpack_require__(3420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_lock_filled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_lock_filled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled_HeaderStyles__ = __webpack_require__(3422);





var HeaderItems = function HeaderItems(_ref) {
  var author = _ref.author,
      edited = _ref.edited,
      isError = _ref.isError,
      isSaving = _ref.isSaving,
      restrictedTo = _ref.restrictedTo,
      savingText = _ref.savingText,
      time = _ref.time,
      type = _ref.type;
  var restrictedElement = restrictedTo ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled_HeaderStyles__["b" /* Restricted */], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled_HeaderStyles__["a" /* BulletSpacer */], null, "\u2022"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled_HeaderStyles__["c" /* RestrictedIconWrapper */], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__atlaskit_icon_glyph_lock_filled___default.a, {
    size: "small"
  })), ' ', restrictedTo) : null;
  var items = [author || null, type ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__atlaskit_lozenge__["default"], null, type) : null, time && !isSaving && !isError ? time : null, edited || null, isSaving ? savingText : null, restrictedElement].filter(function (item) {
    return !!item;
  }).map(function (item, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled_HeaderStyles__["d" /* TopItem */], {
      key: index
    }, item);
  }); // eslint-disable-line react/no-array-index-key

  return items.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled_HeaderStyles__["e" /* TopItemsContainer */], null, items) : null;
};

/* harmony default export */ __webpack_exports__["a"] = (HeaderItems);

/***/ }),
/* 3420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(1332));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var LockFilledIcon = function LockFilledIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2zm2 0h4V8.002A2.001 2.001 0 0 0 12 6c-1.102 0-2 .898-2 2.002V10zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4z\"/></svg>"
  }, props));
};

LockFilledIcon.displayName = 'LockFilledIcon';
var _default = LockFilledIcon;
exports.default = _default;

/***/ }),
/* 3421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = void 0;
var sizes = {
  small: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '48px'
};
exports.sizes = sizes;

/***/ }),
/* 3422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BulletSpacer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Restricted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RestrictedIconWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TopItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TopItemsContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);


var ThemeColor = {
  Restricted: {
    text: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N100A
  }
};
var BulletSpacer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "HeaderStyles__BulletSpacer",
  componentId: "sc-1x5yo10-0"
})(["\n  padding-right: ", "px;\n"], Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])() / 2);
var Restricted = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "HeaderStyles__Restricted",
  componentId: "sc-1x5yo10-1"
})(["\n  color: ", ";\n  display: flex;\n"], ThemeColor.Restricted.text);
var RestrictedIconWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "HeaderStyles__RestrictedIconWrapper",
  componentId: "sc-1x5yo10-2"
})(["\n  margin-right: ", "px;\n"], Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])() / 2);
RestrictedIconWrapper.displayName = 'RestrictedIconWrapper';
var TopItem = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "HeaderStyles__TopItem",
  componentId: "sc-1x5yo10-3"
})(["\n  display: inline-block;\n  margin-left: ", "px;\n\n  [dir='rtl'] & {\n    margin-left: 0;\n    margin-right: ", "px;\n  }\n\n  &:first-child {\n    margin-left: 0;\n\n    [dir='rtl'] & {\n      margin-right: 0;\n    }\n  }\n"], Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])(), Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])());
var TopItemsContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "HeaderStyles__TopItemsContainer",
  componentId: "sc-1x5yo10-4"
})(["\n  display: flex;\n"]);

/***/ }),
/* 3423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_warning__ = __webpack_require__(3424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled_FooterStyles__ = __webpack_require__(3425);




var mapActions = function mapActions(items) {
  return items.map(function (item, index) {
    return (// eslint-disable-next-line react/no-array-index-key
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled_FooterStyles__["b" /* ActionsItem */], {
        key: index
      }, item)
    );
  });
};

var FooterItems = function FooterItems(_ref) {
  var actions = _ref.actions,
      errorActions = _ref.errorActions,
      errorIconLabel = _ref.errorIconLabel,
      isError = _ref.isError,
      isSaving = _ref.isSaving;
  if (isSaving || !actions && !errorActions) return null;
  var items = isError ? errorActions && mapActions(errorActions) : actions && mapActions(actions);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled_FooterStyles__["a" /* ActionsContainer */], null, isError ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled_FooterStyles__["c" /* ErrorIcon */], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon_glyph_warning___default.a, {
    label: errorIconLabel
  })) : null, items);
};

/* harmony default export */ __webpack_exports__["a"] = (FooterItems);

/***/ }),
/* 3424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Icon = _interopRequireDefault(__webpack_require__(1332));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var WarningIcon = function WarningIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" focusable=\"false\" role=\"presentation\"><g fill-rule=\"evenodd\"><path d=\"M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771L12.938 4.967z\" fill=\"currentColor\"/><path d=\"M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2\" fill=\"inherit\"/></g></svg>"
  }, props));
};

WarningIcon.displayName = 'WarningIcon';
var _default = WarningIcon;
exports.default = _default;

/***/ }),
/* 3425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ErrorIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionsContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(1331);



var ThemeColor = {
  text: {
    default: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N500,
    error: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].Y500
  }
};
var ActionsItem = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "FooterStyles__ActionsItem",
  componentId: "sc-7f01gi-0"
})(["\n  display: flex;\n\n  & + &::before {\n    color: ", ";\n    content: '\xB7';\n    display: inline-block;\n    text-align: center;\n    vertical-align: middle;\n    width: ", "px;\n  }\n"], ThemeColor.text.default, __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* actionsPadding */]);
var ErrorIcon = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "FooterStyles__ErrorIcon",
  componentId: "sc-7f01gi-1"
})(["\n  color: ", ";\n  padding-right: ", "px;\n"], ThemeColor.text.error, Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])());
var ActionsContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "FooterStyles__ActionsContainer",
  componentId: "sc-7f01gi-2"
})(["\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: ", "px;\n"], Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])() * 0.75);

/***/ }),
/* 3426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Content; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);


var ThemeColor = {
  text: {
    default: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N800,
    //akColorN800,
    disabled: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N100A
  }
};
var Content = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div.withConfig({
  displayName: "CommentStyles__Content",
  componentId: "lr96k6-0"
})(["\n  color: ", ";\n  margin-top: ", "px;\n"], function (p) {
  return p.isDisabled ? ThemeColor.text.disabled : ThemeColor.text.default;
}, Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["gridSize"])() / 2);

/***/ }),
/* 3427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CommentActionWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics_next__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__package_json__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__package_json__);










var ActionItem =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(ActionItem, _Component);

  function ActionItem() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ActionItem);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ActionItem).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ActionItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onClick = _this$props.onClick,
          onFocus = _this$props.onFocus,
          onMouseOver = _this$props.onMouseOver;
      /* eslint-disable jsx-a11y/no-static-element-interactions */

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", {
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver
      }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__atlaskit_button__["default"], {
        appearance: "subtle-link",
        spacing: "none",
        type: "button"
      }, children));
      /* eslint-enable jsx-a11y/no-static-element-interactions */
    }
  }]);

  return ActionItem;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);


var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics_next__["createAndFireEvent"])('atlaskit');
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics_next__["withAnalyticsContext"])({
  componentName: 'commentAction',
  packageName: __WEBPACK_IMPORTED_MODULE_8__package_json__["name"],
  packageVersion: __WEBPACK_IMPORTED_MODULE_8__package_json__["version"]
})(Object(__WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics_next__["withAnalyticsEvents"])({
  onClick: createAndFireEventOnAtlaskit({
    action: 'clicked',
    actionSubject: 'commentAction',
    attributes: {
      componentName: 'commentAction',
      packageName: __WEBPACK_IMPORTED_MODULE_8__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_8__package_json__["version"]
    }
  })
})(ActionItem)));

/***/ }),
/* 3428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CommentAuthorWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics_next__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__package_json__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Field__ = __webpack_require__(1333);










var Author =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Author, _Component);

  function Author() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Author);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Author).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Author, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          href = _this$props.href,
          onClick = _this$props.onClick,
          onFocus = _this$props.onFocus,
          onMouseOver = _this$props.onMouseOver;
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Field__["a" /* default */], {
        hasAuthor: true,
        href: href,
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver
      }, children);
    }
  }]);

  return Author;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);


var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics_next__["createAndFireEvent"])('atlaskit');
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics_next__["withAnalyticsContext"])({
  componentName: 'commentAuthor',
  packageName: __WEBPACK_IMPORTED_MODULE_7__package_json__["name"],
  packageVersion: __WEBPACK_IMPORTED_MODULE_7__package_json__["version"]
})(Object(__WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics_next__["withAnalyticsEvents"])({
  onClick: createAndFireEventOnAtlaskit({
    action: 'clicked',
    actionSubject: 'commentAuthor',
    attributes: {
      componentName: 'commentAuthor',
      packageName: __WEBPACK_IMPORTED_MODULE_7__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_7__package_json__["version"]
    }
  })
})(Author)));

/***/ }),
/* 3429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Anchor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Span; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);


var ThemeColor = {
  text: __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N500
};

var common = function common(_ref) {
  var hasAuthor = _ref.hasAuthor;
  return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(["\n  &:not(:hover):not(:active) {\n    color: ", ";\n  }\n  font-weight: ", ";\n"], ThemeColor.text, hasAuthor ? 500 : 'inherit');
};

var Anchor = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].a.withConfig({
  displayName: "FieldStyles__Anchor",
  componentId: "sc-173n8o8-0"
})(["\n  ", ";\n"], function (p) {
  return common(p);
});
var Span = __WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "FieldStyles__Span",
  componentId: "sc-173n8o8-1"
})(["\n  ", ";\n"], function (p) {
  return common(p);
});

/***/ }),
/* 3430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CommentEditedWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics_next__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__package_json__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled_EditedStyles__ = __webpack_require__(3431);










var Edited =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Edited, _Component);

  function Edited() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Edited);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Edited).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Edited, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onFocus = _this$props.onFocus,
          onMouseOver = _this$props.onMouseOver;
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styled_EditedStyles__["a" /* default */], {
        onFocus: onFocus,
        onMouseOver: onMouseOver
      }, children);
    }
  }]);

  return Edited;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);


var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics_next__["createAndFireEvent"])('atlaskit');
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics_next__["withAnalyticsContext"])({
  componentName: 'commentEdited',
  packageName: __WEBPACK_IMPORTED_MODULE_7__package_json__["name"],
  packageVersion: __WEBPACK_IMPORTED_MODULE_7__package_json__["version"]
})(Object(__WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics_next__["withAnalyticsEvents"])({
  onClick: createAndFireEventOnAtlaskit({
    action: 'clicked',
    actionSubject: 'commentEdited',
    attributes: {
      componentName: 'commentEdited',
      packageName: __WEBPACK_IMPORTED_MODULE_7__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_7__package_json__["version"]
    }
  })
})(Edited)));

/***/ }),
/* 3431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span.withConfig({
  displayName: "EditedStyles",
  componentId: "gabpnk-0"
})(["\n  color: ", ";\n"], __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["colors"].N200));

/***/ }),
/* 3432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CommentTimeWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics_next__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__package_json__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Field__ = __webpack_require__(1333);










var Time =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Time, _Component);

  function Time() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Time);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Time).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Time, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          href = _this$props.href,
          onClick = _this$props.onClick,
          onFocus = _this$props.onFocus,
          onMouseOver = _this$props.onMouseOver;
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Field__["a" /* default */], {
        href: href,
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver
      }, children);
    }
  }]);

  return Time;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);


var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics_next__["createAndFireEvent"])('atlaskit');
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics_next__["withAnalyticsContext"])({
  componentName: 'commentTime',
  packageName: __WEBPACK_IMPORTED_MODULE_7__package_json__["name"],
  packageVersion: __WEBPACK_IMPORTED_MODULE_7__package_json__["version"]
})(Object(__WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics_next__["withAnalyticsEvents"])({
  onClick: createAndFireEventOnAtlaskit({
    action: 'clicked',
    actionSubject: 'commentTime',
    attributes: {
      componentName: 'commentTime',
      packageName: __WEBPACK_IMPORTED_MODULE_7__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_7__package_json__["version"]
    }
  })
})(Time)));

/***/ }),
/* 3433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_requireLogin_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducer__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__accessSelfService_AccessStatus__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AccessGuide__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__userCheckForm__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_index__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__auth_reducer_js__ = __webpack_require__(59);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CheckAccessStatus=function(_Component){_inherits(CheckAccessStatus,_Component);function CheckAccessStatus(props){var _ref;var _temp,_this;_classCallCheck(this,CheckAccessStatus);for(var _len=arguments.length,args=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}(_temp=(_this=_possibleConstructorReturn(this,(_ref=CheckAccessStatus.__proto__||Object.getPrototypeOf(CheckAccessStatus)).call.apply(_ref,[this,props].concat(args))),_this),_this.handleSubmit=function(fieldValue){var _this$props=_this.props,checkUserExists=_this$props.checkUserExists,setUserCheckResults=_this$props.setUserCheckResults;Object(__WEBPACK_IMPORTED_MODULE_5__actions__["d" /* clearUserStatus */])();setUserCheckResults(null);if(!fieldValue.UserId){setUserCheckResults('You need to enter an AD or Email address to check');}else{checkUserExists(fieldValue.UserId);_this.setState({userId:fieldValue.UserId});}},_temp),_this.state={userId:null};return _this;}_createClass(CheckAccessStatus,[{key:'render',value:function render(){var _props=this.props,userCheckResults=_props.userCheckResults,userCheckPending=_props.userCheckPending,loggedInUser=_props.loggedInUser;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index_js__["s" /* PageTitle */],{title:'Application Access'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index_js__["q" /* PageHeader */],{title:'Application Access'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_index_js__["f" /* Container */],{section:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__AccessGuide__["a" /* default */],null)));}}]);return CheckAccessStatus;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_3__auth_requireLogin_js__["b" /* default */])('AccessSelfService'),Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{userCheckPending:Object(__WEBPACK_IMPORTED_MODULE_10__util_index__["f" /* selectIsRequestPending */])(state,__WEBPACK_IMPORTED_MODULE_5__actions__["a" /* checkUserExists */]),userCheckResults:Object(__WEBPACK_IMPORTED_MODULE_4__reducer__["d" /* selectUserCheckResults */])(state),loggedInUser:Object(__WEBPACK_IMPORTED_MODULE_11__auth_reducer_js__["f" /* selectADUserInfo */])(state)};},{checkUserExists:__WEBPACK_IMPORTED_MODULE_5__actions__["a" /* checkUserExists */],clearUserCheck:__WEBPACK_IMPORTED_MODULE_5__actions__["c" /* clearUserCheck */],setUserCheckResults:__WEBPACK_IMPORTED_MODULE_5__actions__["f" /* setUserCheckResults */],clearUserStatus:__WEBPACK_IMPORTED_MODULE_5__actions__["d" /* clearUserStatus */]}))(CheckAccessStatus));

/***/ }),
/* 3434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_tabs__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_index__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tools_userEmulator_UserEmulator__ = __webpack_require__(3435);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectDestructuringEmpty(obj){if(obj==null)throw new TypeError("Cannot destructure undefined");}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AdminTools=function(_Component){_inherits(AdminTools,_Component);function AdminTools(){_classCallCheck(this,AdminTools);return _possibleConstructorReturn(this,(AdminTools.__proto__||Object.getPrototypeOf(AdminTools)).apply(this,arguments));}_createClass(AdminTools,[{key:'render',// handleTabSwitch = (newTabIndex, oldTabIndex) => {
//     if (newTabIndex !== oldTabIndex) {
//       history.push(history.location.pathname + (newTabIndex === 1 ? '?tab=tool3' : ''))
//     }
// }
value:function render(){_objectDestructuringEmpty(this.props);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index_js__["s" /* PageTitle */],{title:'Admin Tools'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index_js__["q" /* PageHeader */],{title:'Admin Tools',back:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index_js__["m" /* Link */],{to:'/',className:'page-title-back'},'< Home')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index_js__["f" /* Container */],{section:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index_js__["u" /* RoutedTabs */],{tabs:['UserEmulator','futureTool2']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_tabs__["b" /* TabList */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_tabs__["a" /* Tab */],null,'User Emulator'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_tabs__["a" /* Tab */],null,'Future Tool 2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_tabs__["c" /* TabPanel */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__tools_userEmulator_UserEmulator__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_tabs__["c" /* TabPanel */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Place Holder for Future Tool 2 component')))));}}]);return AdminTools;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_4__util_index__["e" /* requireLogin */])('Admin'),Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state,ownProps){return{};},{}))(AdminTools));

/***/ }),
/* 3435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_index__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserEmulatorForm__ = __webpack_require__(3436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__serviceDesk_actions__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__accessSelfService_actions__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__accessSelfService_reducer__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__auth_actions__ = __webpack_require__(188);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var description='This tool allows you to access the Portal as a different user.\nUsage: \n    1) check that the Email or ID of the user you want to emulate is valid.\n    2) Emulate the user.\n\nNotes: \n    The requests list is cleared when emulating, hit the refresh button next to the requests to get tickets.\n    Refresh the page to return to accessing the portal as yourself.';var UserEmulator=function(_Component){_inherits(UserEmulator,_Component);function UserEmulator(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserEmulator);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserEmulator.__proto__||Object.getPrototypeOf(UserEmulator)).call.apply(_ref,[this].concat(args))),_this),_this.handleSubmit=function(fieldValue){var _this$props=_this.props,checkUserExists=_this$props.checkUserExists,setUserCheckResults=_this$props.setUserCheckResults;setUserCheckResults(null);if(!fieldValue.UserId){setUserCheckResults('You need to enter an AD or Email address to check');}else{checkUserExists(fieldValue.UserId);}},_this.handleEmulate=function(fieldValue){var _this$props2=_this.props,EmulateUser=_this$props2.EmulateUser,setUserCheckResults=_this$props2.setUserCheckResults,setADandJiraUser=_this$props2.setADandJiraUser,clearIssues=_this$props2.clearIssues;EmulateUser(fieldValue.UserId,setADandJiraUser,clearIssues);setUserCheckResults(null);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserEmulator,[{key:'render',value:function render(){var _props=this.props,userCheckResults=_props.userCheckResults,userEmulationPending=_props.userEmulationPending,userCheckPending=_props.userCheckPending;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index__["f" /* Container */],{section:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre',{className:''},description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__UserEmulatorForm__["a" /* default */],{onSubmit:userCheckResults===true?this.handleEmulate:this.handleSubmit,actionInProgress:userCheckResults===true||userEmulationPending?userEmulationPending:userCheckPending,userCheckResults:userCheckResults})));}}]);return UserEmulator;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_3__util_index__["e" /* requireLogin */])('UserEmulator'),Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{userEmulationPending:Object(__WEBPACK_IMPORTED_MODULE_3__util_index__["f" /* selectIsRequestPending */])(state,__WEBPACK_IMPORTED_MODULE_9__actions__["a" /* EmulateUser */]),userCheckPending:Object(__WEBPACK_IMPORTED_MODULE_3__util_index__["f" /* selectIsRequestPending */])(state,__WEBPACK_IMPORTED_MODULE_7__accessSelfService_actions__["a" /* checkUserExists */]),userCheckResults:Object(__WEBPACK_IMPORTED_MODULE_8__accessSelfService_reducer__["d" /* selectUserCheckResults */])(state)};},{checkUserExists:__WEBPACK_IMPORTED_MODULE_7__accessSelfService_actions__["a" /* checkUserExists */],EmulateUser:__WEBPACK_IMPORTED_MODULE_9__actions__["a" /* EmulateUser */],setADandJiraUser:__WEBPACK_IMPORTED_MODULE_10__auth_actions__["f" /* setADandJiraUser */],setUserCheckResults:__WEBPACK_IMPORTED_MODULE_7__accessSelfService_actions__["f" /* setUserCheckResults */],clearIssues:__WEBPACK_IMPORTED_MODULE_6__serviceDesk_actions__["b" /* clearIssues */]}))(UserEmulator));

/***/ }),
/* 3436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_index__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_button__ = __webpack_require__(35);
var UserEmulatorForm=function UserEmulatorForm(props){var handleSubmit=props.handleSubmit,actionInProgress=props.actionInProgress,userCheckResults=props.userCheckResults;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'access-user-check-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */],{key:'UserId',name:'UserId',component:__WEBPACK_IMPORTED_MODULE_2__components_forms_index__["d" /* TextInput */],label:'Nike Username or Email address',title:'Enter the Nike username or email address of the user you want to emulate.',placeholder:'\u02DCNike Username or Email',disabled:actionInProgress||userCheckResults===true,className:'pt4-sm ncss-input pr4-sm pb2-sm pl4-sm'}),userCheckResults!=true?userCheckResults:null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__atlaskit_button__["default"],{type:'submit',appearance:'primary',isLoading:actionInProgress,className:'search-form-btn'},userCheckResults===true?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'g72 g72-search'}),userCheckResults===true?'Emulate':' Check')));};var validate=function validate(values){return!values.UserId?'You need to enter a Nike username or Email address':undefined;};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_form__["e" /* reduxForm */])({form:'UserEmulatorForm',validate:validate})(UserEmulatorForm));

/***/ }),
/* 3437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export App */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_document_title__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stylus_app_styl__ = __webpack_require__(3438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stylus_app_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__stylus_app_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routes_js__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__navigation_SlideMenuContainer_js__ = __webpack_require__(3439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__navigation_actions_js__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__offline_offline_js__ = __webpack_require__(3440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__auth_actions_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__auth_requireLogin_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__auth_reducer_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__notifications_Toasts__ = __webpack_require__(3441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_index__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__appStatus_actions__ = __webpack_require__(498);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var navLinks=__WEBPACK_IMPORTED_MODULE_6__routes_js__["b" /* navRoutes */].map(function(r){return{to:r.path,label:r.title};});var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'componentDidMount',value:function componentDidMount(){this.props.initializeUserAuth();}},{key:'render',value:function render(){var _props=this.props,closeNavMenu=_props.closeNavMenu,children=_props.children,loginFinished=_props.loginFinished,loginError=_props.loginError,extraInfoPending=_props.extraInfoPending,appStatusPending=_props.appStatusPending;if(loginError)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_index_js__["h" /* GenericError */],{error:loginError});if(!loginFinished)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_index_js__["r" /* PageSpinner */],{title:'Authenticating...'});if(extraInfoPending)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_index_js__["r" /* PageSpinner */],{title:'Requesting additional user data, this may take a minute...'});if(appStatusPending)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_index_js__["r" /* PageSpinner */],{title:'Checking Status of connected apps...'});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_document_title___default.a,{title:__WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].appName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'u-full-height'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__offline_offline_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__navigation_SlideMenuContainer_js__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].appName,description:__WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].appFullName,navLinks:navLinks,onClose:closeNavMenu,env:__WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].env},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app-container m12-sm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__auth_requireLogin_js__["a" /* LoginRequired */],null,children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__notifications_Toasts__["a" /* default */],null)))));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{appStatusPending:Object(__WEBPACK_IMPORTED_MODULE_15__util_index__["f" /* selectIsRequestPending */])(state,__WEBPACK_IMPORTED_MODULE_16__appStatus_actions__["a" /* getAppStatus */]),extraInfoPending:Object(__WEBPACK_IMPORTED_MODULE_15__util_index__["f" /* selectIsRequestPending */])(state,__WEBPACK_IMPORTED_MODULE_11__auth_actions_js__["b" /* getExtraUserInfo */]),loginError:Object(__WEBPACK_IMPORTED_MODULE_13__auth_reducer_js__["i" /* selectLoginError */])(state),loginFinished:Object(__WEBPACK_IMPORTED_MODULE_13__auth_reducer_js__["b" /* hasAuthCheckFinished */])(state),isLoggedIn:Object(__WEBPACK_IMPORTED_MODULE_13__auth_reducer_js__["e" /* isLoggedIn */])(state)};},{closeNavMenu:__WEBPACK_IMPORTED_MODULE_8__navigation_actions_js__["a" /* closeNavMenu */],initializeUserAuth:__WEBPACK_IMPORTED_MODULE_11__auth_actions_js__["c" /* initializeUserAuth */],getExtraUserInfo:__WEBPACK_IMPORTED_MODULE_11__auth_actions_js__["b" /* getExtraUserInfo */],getAppStatus:__WEBPACK_IMPORTED_MODULE_16__appStatus_actions__["a" /* getAppStatus */]})(App)));

/***/ }),
/* 3438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_index_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__navigation_actions_js__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__navigation_reducer_js__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_avatar__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__auth_reducer__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__auth_actions_js__ = __webpack_require__(188);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var navStyle='nav pt4-sm pb4-sm prl6-sm u-no-ws';var nikeTechSlack='https://nikedigital.slack.com/archives/C0JSX3QSZ';var nikeDigitalSlack='https://nikedigital.slack.com/messages/'+__WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].slack.channelId;var NavLinkItem=function NavLinkItem(_ref){var to=_ref.to,label=_ref.label;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'text-color-secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */],{to:to,activeClassName:'text-color-accent',exact:true},label));};var SlideMenuContainer=function SlideMenuContainer(_ref2){var isOpen=_ref2.isOpen,closeNavMenu=_ref2.closeNavMenu,isLoggedIn=_ref2.isLoggedIn,isReady=_ref2.isReady,jiraUser=_ref2.jiraUser,adUser=_ref2.adUser,isAdmin=_ref2.isAdmin,title=_ref2.title,description=_ref2.description,toggleNavMenu=_ref2.toggleNavMenu,notifications=_ref2.notifications,children=_ref2.children,navLinks=_ref2.navLinks,env=_ref2.env,email=_ref2.email,props=_objectWithoutProperties(_ref2,['isOpen','closeNavMenu','isLoggedIn','isReady','jiraUser','adUser','isAdmin','title','description','toggleNavMenu','notifications','children','navLinks','env','email']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-container '+(isOpen?'show-menu':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-aside border-right bg-white',onClick:closeNavMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index_js__["m" /* Link */],{to:'/',className:'pt1-sm prl6-sm pb1-sm u-sm-b border-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index_js__["i" /* H1 */],{className:'u-uppercase ncss-brand',useBareClass:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'g72-swoosh nav-brand fs22-sm menu-logo'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fs30-sm ncss-brand u-italic'},title))),renderProfileNav({jiraUser:jiraUser,adUser:adUser,isLoggedIn:isLoggedIn,isReady:isReady,email:email}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:navStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,navLinks.map(function(_ref3){var to=_ref3.to,label=_ref3.label;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavLinkItem,{key:to,to:to,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fs18-sm pt2-sm pb2-sm'},label)});}),isAdmin?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavLinkItem,{key:'/Admin',to:'/Admin',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fs18-sm pt2-sm pb2-sm'},'Admin Tools')}):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer pb4-md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-spacer border-bottom mb2-sm'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:navStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fs14-sm lh14-sm u-align-center pb2-sm',style:{whiteSpace:'normal'}},'Have a bug report or feature request? Find us in Slack.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:nikeTechSlack,target:'_blank',className:'u-sm-b'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index_js__["d" /* Button */],{extraClassName:'mb4-md u-full-width',small:true,color:'border-grey'},'#inf-buildtools'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-color-secondary prl2-sm fs12-sm lh12-sm'},description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-color-secondary prl2-sm fs12-sm lh12-sm'},'© 2020-2026 Nike, Inc. All Rights Reserved'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-color-secondary prl2-sm fs12-sm lh12-sm'},'Environment: ',env))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'menu-btn ncss-btn fs16-sm',onClick:toggleNavMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index_js__["c" /* Badge */],{count:notifications}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'g72-menu'})),children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-lightbox',onClick:closeNavMenu}));};var renderProfileNav=function renderProfileNav(_ref4){var jiraUser=_ref4.jiraUser,adUser=_ref4.adUser,isLoggedIn=_ref4.isLoggedIn,isReady=_ref4.isReady,loginUser=_ref4.loginUser,logoutUser=_ref4.logoutUser,email=_ref4.email;return isLoggedIn&&isReady?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:navStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profile-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_index_js__["m" /* Link */],{to:'/user'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__atlaskit_avatar__["a" /* AvatarItem */],{avatar:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__atlaskit_avatar__["d" /* default */],{src:jiraUser&&jiraUser.avatarUrls?jiraUser.avatarUrls['48x48']:null,size:'large'}),key:jiraUser?jiraUser.emailAddress:adUser?adUser.email:email,primaryText:jiraUser?jiraUser.displayName:adUser?adUser.firstName+' '+adUser.lastName:null,secondaryText:jiraUser?jiraUser.emailAddress:adUser?adUser.email:email,enableTextTruncate:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profile-nav-item fs22-sm'}))):null;};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,ownProps){return{isReady:Object(__WEBPACK_IMPORTED_MODULE_8__auth_reducer__["b" /* hasAuthCheckFinished */])(state),isOpen:Object(__WEBPACK_IMPORTED_MODULE_6__navigation_reducer_js__["b" /* selectIsMenuOpen */])(state),isLoggedIn:Object(__WEBPACK_IMPORTED_MODULE_8__auth_reducer__["e" /* isLoggedIn */])(state),navLinks:ownProps.navLinks||[],jiraUser:Object(__WEBPACK_IMPORTED_MODULE_8__auth_reducer__["h" /* selectJiraUser */])(state),adUser:Object(__WEBPACK_IMPORTED_MODULE_8__auth_reducer__["f" /* selectADUserInfo */])(state),isAdmin:Object(__WEBPACK_IMPORTED_MODULE_8__auth_reducer__["d" /* isAdmin */])(state),email:Object(__WEBPACK_IMPORTED_MODULE_8__auth_reducer__["g" /* selectEmail */])(state)};},{toggleNavMenu:__WEBPACK_IMPORTED_MODULE_5__navigation_actions_js__["c" /* toggleNavMenu */],closeNavMenu:__WEBPACK_IMPORTED_MODULE_5__navigation_actions_js__["a" /* closeNavMenu */],loginUser:__WEBPACK_IMPORTED_MODULE_9__auth_actions_js__["d" /* loginUser */],logoutUser:__WEBPACK_IMPORTED_MODULE_9__auth_actions_js__["e" /* logoutUser */]})(SlideMenuContainer)));

/***/ }),
/* 3440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__offline_actions_js__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__offline_reducer_js__ = __webpack_require__(499);
var OfflineBanner=function OfflineBanner(_ref){var offline=_ref.offline;return offline?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ncss-container bg-accent mb2-sm offline-section text-color-primary-light u-align-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'fs20-sm u-sm-ib pr4-sm pl4-sm'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'g72-alert'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'ncss-brand'},'OFFLINE MODE'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'pl2-sm'},'functionality may be limited')):null;};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function(state){return{offline:Object(__WEBPACK_IMPORTED_MODULE_3__offline_reducer_js__["b" /* isOffline */])(state)};},{notifyOffline:__WEBPACK_IMPORTED_MODULE_2__offline_actions_js__["a" /* notifyOffline */]})(OfflineBanner));

/***/ }),
/* 3441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group_CSSTransitionGroup__ = __webpack_require__(3442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group_CSSTransitionGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_transition_group_CSSTransitionGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_js__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducer_js__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_index_js__ = __webpack_require__(25);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var formatNotifcation=function formatNotifcation(message){if(message instanceof Error){return message.message;}if((typeof message==='undefined'?'undefined':_typeof(message))==='object'){throw new Error('unable to format object as notification');}return message;};var Toasts=function Toasts(_ref){var toasts=_ref.toasts,removeNotification=_ref.removeNotification,notify=_ref.notify,notifyError=_ref.notifyError;toasts=toasts.toArray();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_index_js__["t" /* RenderInBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alertify-logs bottom right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_transition_group_CSSTransitionGroup___default.a,{transitionName:'alertify-log',transitionEnterTimeout:400,transitionLeaveTimeout:400},toasts.map(function(toast){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:toast.id,className:toast.type+' alertify-log',onClick:toast.closeOnClick?function(){return removeNotification(toast.id);}:undefined},formatNotifcation(toast.message));}))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{toasts:Object(__WEBPACK_IMPORTED_MODULE_4__reducer_js__["b" /* selectNotifications */])(state)};},{removeNotification:__WEBPACK_IMPORTED_MODULE_3__actions_js__["e" /* removeNotification */],notify:__WEBPACK_IMPORTED_MODULE_3__actions_js__["c" /* notify */],notifyError:__WEBPACK_IMPORTED_MODULE_3__actions_js__["d" /* notifyError */]})(Toasts));

/***/ }),
/* 3442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(3443);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(3446);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(1336);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 3443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(3444);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(150);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(3445);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 3444 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 3445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 3446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__(244);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(245);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(3447);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(3448);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(18);

var _PropTypes = __webpack_require__(1336);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 3447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(552);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf = void 0;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM2.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}

/* https://github.com/component/raf */
var prev = new Date().getTime();
function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);

  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};
compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};
exports.default = compatRaf;
module.exports = exports['default'];

/***/ }),
/* 3448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;

var _inDOM = __webpack_require__(552);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;


  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};


function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),
/* 3449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HYDRATE_STATE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(3450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_devtools_extension__ = __webpack_require__(3451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_devtools_extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_devtools_extension__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer_js__ = __webpack_require__(3452);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var HYDRATE_STATE='HYDRATE_STATE';// If we ever do server-side rendering, the initial state needs to check
// for pre-hydrated data, probably in window.__initialState
var initialState={};var configureStore=function configureStore(){var store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(makeHydratable(__WEBPACK_IMPORTED_MODULE_3__reducer_js__["a" /* default */],HYDRATE_STATE),initialState,Object(__WEBPACK_IMPORTED_MODULE_0_redux__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"])(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__["a" /* default */]),(typeof window==='undefined'?'undefined':_typeof(window))==='object'&&typeof window.devToolsExtension!=='undefined'?window.devToolsExtension():function(f){return f;}));if(false){if(module.hot){module.hot.accept('./reducer',function(){store.replaceReducer(rootReducer);});}}return store;};/* harmony default export */ __webpack_exports__["a"] = (configureStore);function makeHydratable(reducer,hydrateActionType){return function(state,action){switch(action.type){case hydrateActionType:return reducer(action.state,action);default:return reducer(state,action);}};}

/***/ }),
/* 3450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 3451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(64).compose;

exports.__esModule = true;
exports.composeWithDevTools = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

exports.devToolsEnhancer = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),
/* 3452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_reducer_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_reducer__ = __webpack_require__(3453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__navigation_reducer_js__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__offline_reducer_js__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_requestReducer_js__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__notifications_reducer__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__serviceDesk_reducer__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__accessSelfService_reducer__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__admin_tools_userEmulator_reducer__ = __webpack_require__(3454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__appStatus_reducer__ = __webpack_require__(237);
var rootReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({routing:__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["b" /* routerReducer */],form:__WEBPACK_IMPORTED_MODULE_2_redux_form__["d" /* reducer */],request:__WEBPACK_IMPORTED_MODULE_7__util_requestReducer_js__["a" /* default */],auth:__WEBPACK_IMPORTED_MODULE_3__auth_reducer_js__["a" /* default */],user:__WEBPACK_IMPORTED_MODULE_4__user_reducer__["a" /* default */],navigation:__WEBPACK_IMPORTED_MODULE_5__navigation_reducer_js__["a" /* default */],offline:__WEBPACK_IMPORTED_MODULE_6__offline_reducer_js__["a" /* default */],notifications:__WEBPACK_IMPORTED_MODULE_8__notifications_reducer__["a" /* default */],serviceDesk:__WEBPACK_IMPORTED_MODULE_9__serviceDesk_reducer__["a" /* default */],AccessSelfService:__WEBPACK_IMPORTED_MODULE_10__accessSelfService_reducer__["a" /* default */],userEmulator:__WEBPACK_IMPORTED_MODULE_11__admin_tools_userEmulator_reducer__["a" /* default */],appStatus:__WEBPACK_IMPORTED_MODULE_12__appStatus_reducer__["a" /* default */]});/* harmony default export */ __webpack_exports__["a"] = (rootReducer);

/***/ }),
/* 3453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(97);
var defaultState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["c" /* fromJS */])({});function compose(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];state=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["c" /* fromJS */])(state);// Force immutable in case of rehydration
switch(action.type){default:return state;}}

/***/ }),
/* 3454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = userEmulator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(1334);
var defaultState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["c" /* fromJS */])({});function userEmulator(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];state=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["c" /* fromJS */])(state);// Force immutable in case of rehydration
switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* EmulateUser */].event.success:return state;default:return state;}}

/***/ }),
/* 3455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
/* eslint-disable */// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(!isLocalhost){// Is not local host. Just register service worker
registerValidSW(swUrl);}else{// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.e1d649b9.js